
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}
var parcelRequire = $parcel$global["parcelRequirefc28"];
var parcelRegister = parcelRequire.register;
parcelRegister("3PYUJ", function(module, exports) {
$parcel$export(module.exports, "isConfluenceSlideUrl", () => $7e71ecd5d09db157$export$4091d55e0211d2e1);
/**
 * URL checker utilities for Confluence content types.
 *
 * Exported via the `@atlaskit/editor-card-provider/url-checkers` subpath
 * so consumers don't have to depend on the barrel file.
 */ /**
 * Matches Confluence Slides URLs.
 *
 * Examples:
 *   - /wiki/spaces/TEAM/slide/12345
 *   - /wiki/spaces/~uid/slide/8fb8c642-803d-59fe-8d1c-066610e860c6
 */ // eslint-disable-next-line require-unicode-regexp -- consistent with isConfluenceDatabase in provider.ts
const $7e71ecd5d09db157$var$CONFLUENCE_SLIDE_URL_PATTERN = /\/wiki\/spaces\/~?[\d\w]+\/slide\/[\d\w-]+(\?.*)?$/;
const $7e71ecd5d09db157$export$4091d55e0211d2e1 = (url)=>$7e71ecd5d09db157$var$CONFLUENCE_SLIDE_URL_PATTERN.test(url);

});

parcelRegister("d8zoL", function(module, exports) {
$parcel$export(module.exports, "IntlProviderIfMissingWrapper", () => $3b5bd328c3b0556d$export$742fe272b8921eea);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $fK3tS = parcelRequire("fK3tS");
var $dTM5i = parcelRequire("dTM5i");
const $3b5bd328c3b0556d$var$useCheckIntlContext = ()=>(0, $bSJIT.useContext)((0, $fK3tS.Context)) === null;
function $3b5bd328c3b0556d$export$742fe272b8921eea({ children: children }) {
    const missingIntlContext = $3b5bd328c3b0556d$var$useCheckIntlContext();
    if (missingIntlContext) return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dTM5i.default), {
        locale: "en",
        children: children
    });
    return children;
}

});

parcelRegister("2iptY", function(module, exports) {
$parcel$export(module.exports, "ComposableEditor", () => $c7527a957c529dd5$export$36a7c46ebbddbc5d);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $i0SXl = parcelRequire("i0SXl");

var $jEuGx = parcelRequire("jEuGx");
function $c7527a957c529dd5$export$36a7c46ebbddbc5d(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const AppearanceComponent = (0, $bSJIT.useMemo)(()=>(0, $i0SXl.default)(props.appearance), [
        props.appearance
    ]);
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $jEuGx.CoreEditor), {
        ...props,
        AppearanceComponent: AppearanceComponent
    });
}

});
parcelRegister("i0SXl", function(module, exports) {
$parcel$export(module.exports, "default", () => $d279b49678692e38$export$2e2bcd8739ae039);

var $kuZUE = parcelRequire("kuZUE");

var $fM3fo = parcelRequire("fM3fo");

var $bGW2u = parcelRequire("bGW2u");
function $d279b49678692e38$export$2e2bcd8739ae039(appearance) {
    appearance = appearance || 'comment';
    switch(appearance){
        case 'full-page':
        case 'full-width':
        case 'max':
            return 0, $bGW2u.FullPageEditor;
        case 'chromeless':
            return 0, $kuZUE.default;
        case 'comment':
            return 0, $fM3fo.CommentEditorWithIntl;
        default:
            throw new Error(`Appearance '${appearance}' is not supported by the editor.`);
    }
}

});
parcelRegister("kuZUE", function(module, exports) {
$parcel$export(module.exports, "default", () => $e7570c068d6bb11a$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $5beht = parcelRequire("5beht");

var $3y2s4 = parcelRequire("3y2s4");

var $bKltE = parcelRequire("bKltE");

var $fdwmh = parcelRequire("fdwmh");

var $lcrZe = parcelRequire("lcrZe");

var $2zd8q = parcelRequire("2zd8q");
class $e7570c068d6bb11a$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Component {
    static #_ = this.displayName = 'ChromelessEditorAppearance';
    render() {
        return /*#__PURE__*/ (0, $dc70d.jsx)($e7570c068d6bb11a$var$RenderWithPluginState, {
            editorAPI: this.props.editorAPI,
            renderChrome: this.renderChrome
        });
    }
    constructor(...args){
        super(...args), this.appearance = 'chromeless', this.containerElement = null, this.setContainerElement = (ref)=>{
            this.containerElement = ref;
        }, this.renderChrome = ({ maxContentSize: maxContentSize })=>{
            const { editorDOMElement: editorDOMElement, editorView: editorView, editorActions: editorActions, eventDispatcher: eventDispatcher, providerFactory: providerFactory, contentComponents: contentComponents, customContentComponents: customContentComponents, maxHeight: maxHeight, minHeight: minHeight = 30, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, disabled: disabled, dispatchAnalyticsEvent: dispatchAnalyticsEvent, pluginHooks: pluginHooks, featureFlags: featureFlags } = this.props;
            const maxContentSizeReached = Boolean(maxContentSize === null || maxContentSize === void 0 ? void 0 : maxContentSize.maxContentSizeReached);
            const editorViewMode = (0, $5beht.useSharedPluginStateWithSelector)(this.props.editorAPI, [
                'editorViewMode'
            ], (states)=>{
                var _states$editorViewMod;
                return states === null || states === void 0 || (_states$editorViewMod = states.editorViewModeState) === null || _states$editorViewMod === void 0 ? void 0 : _states$editorViewMod.mode;
            });
            const containerRef = (0, $3y2s4.isExperimentEnabled)('platform_editor_perf_lint_cleanup') ? this.setContainerElement : (ref)=>this.containerElement = ref;
            return /*#__PURE__*/ (0, $dc70d.jsx)((0, $lcrZe.default), {
                animate: maxContentSizeReached,
                children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $2zd8q.ChromelessEditorContainer), {
                    maxHeight: maxHeight,
                    minHeight: minHeight,
                    containerRef: containerRef,
                    children: /*#__PURE__*/ (0, $dc70d.jsxs)((0, $bKltE.default), {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                        className: "ak-editor-content-area",
                        featureFlags: featureFlags,
                        viewMode: editorViewMode,
                        appearance: this.appearance,
                        children: [
                            customContentComponents && 'before' in customContentComponents ? customContentComponents.before : customContentComponents,
                            /*#__PURE__*/ (0, $dc70d.jsx)((0, $fdwmh.default), {
                                editorView: editorView,
                                editorActions: editorActions,
                                eventDispatcher: eventDispatcher,
                                providerFactory: providerFactory,
                                appearance: this.appearance,
                                items: contentComponents,
                                popupsMountPoint: popupsMountPoint,
                                popupsBoundariesElement: popupsBoundariesElement,
                                popupsScrollableElement: popupsScrollableElement,
                                containerElement: this.containerElement,
                                disabled: !!disabled,
                                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                                wrapperElement: this.containerElement,
                                pluginHooks: pluginHooks
                            }),
                            editorDOMElement,
                            customContentComponents && 'after' in customContentComponents ? customContentComponents.after : null
                        ]
                    })
                })
            });
        };
    }
}
function $e7570c068d6bb11a$var$RenderWithPluginState({ renderChrome: renderChrome, editorAPI: editorAPI }) {
    'use no memo';
    // renderChrome should be changed to called as a component not a function
    const maxContentSizeReached = (0, $5beht.useSharedPluginStateWithSelector)(editorAPI, [
        'maxContentSize'
    ], (states)=>{
        var _states$maxContentSiz;
        return states === null || states === void 0 || (_states$maxContentSiz = states.maxContentSizeState) === null || _states$maxContentSiz === void 0 ? void 0 : _states$maxContentSiz.maxContentSizeReached;
    });
    const maxContentSize = maxContentSizeReached === undefined ? undefined : {
        maxContentSizeReached: maxContentSizeReached
    };
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $bSJIT.Fragment), {
        children: renderChrome({
            maxContentSize: maxContentSize
        })
    });
}

});
parcelRegister("5beht", function(module, exports) {
$parcel$export(module.exports, "useSharedPluginStateWithSelector", () => $430abdfe7b868193$export$e5d623015ec283cc);

var $bSJIT = parcelRequire("bSJIT");

var $inh7J = parcelRequire("inh7J");
/**
 *
 * Directly map object values
 *
 * @private
 * @param object The object to transform
 * @param mapFunction The function to map an old value to new one
 * @returns Object with the same key but transformed values
 *
 */ function $430abdfe7b868193$var$mapValues(object, mapFunction) {
    return Object.entries(object).reduce((acc, [key, value])=>({
            ...acc,
            [key]: mapFunction(value)
        }), {});
}
// When we use the `useSharedPluginStateWithSelector` example: `useSharedPluginStateWithSelector(api, ['width'], selector)`
// it will re-render every time the component re-renders as the array "['width']" is seen as an update.
// This hook is used to prevent re-renders due to this.
function $430abdfe7b868193$var$useStaticPlugins(plugins) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $bSJIT.useMemo)(()=>plugins, []);
}
function $430abdfe7b868193$export$e5d623015ec283cc(injectionApi, plugins, selector) {
    const pluginNames = $430abdfe7b868193$var$useStaticPlugins(plugins);
    const selectorRef = (0, $bSJIT.useRef)(selector);
    // Create a memoized object containing the named plugins
    const namedExternalPlugins = (0, $bSJIT.useMemo)(()=>pluginNames.reduce((acc, pluginName)=>({
                ...acc,
                [`${String(pluginName)}State`]: injectionApi === null || injectionApi === void 0 ? void 0 : injectionApi[pluginName]
            }), {}), [
        injectionApi,
        pluginNames
    ]);
    return $430abdfe7b868193$var$useSharedPluginStateInternal(namedExternalPlugins, selectorRef);
}
function $430abdfe7b868193$var$useSharedPluginStateInternal(externalPlugins, selector) {
    const refStates = (0, $bSJIT.useRef)($430abdfe7b868193$var$mapValues(externalPlugins, (value)=>value === null || value === void 0 ? void 0 : value.sharedState.currentState()));
    const [pluginStates, setPluginState] = (0, $bSJIT.useState)(()=>selector.current(refStates.current));
    const mounted = (0, $bSJIT.useRef)(false);
    (0, $bSJIT.useLayoutEffect)(()=>{
        const debouncedPluginStateUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($inh7J)))(()=>{
            setPluginState((currentPluginStates)=>{
                const nextStates = selector.current({
                    ...refStates.current
                });
                if ($430abdfe7b868193$var$shallowEqual(nextStates, currentPluginStates)) return currentPluginStates;
                return nextStates;
            });
        });
        // If we re-render this hook due to a change in the external
        // plugins we need to push a state update to ensure we have
        // the most current state.
        if (mounted.current) {
            refStates.current = $430abdfe7b868193$var$mapValues(externalPlugins, (value)=>value === null || value === void 0 ? void 0 : value.sharedState.currentState());
            debouncedPluginStateUpdate();
        }
        const unsubs = Object.entries(externalPlugins).map(([pluginKey, externalPlugin])=>{
            return externalPlugin === null || externalPlugin === void 0 ? void 0 : externalPlugin.sharedState.onChange(({ nextSharedState: nextSharedState, prevSharedState: prevSharedState })=>{
                if (prevSharedState === nextSharedState) return;
                refStates.current[pluginKey] = nextSharedState;
                debouncedPluginStateUpdate();
            });
        });
        mounted.current = true;
        return ()=>{
            refStates.current = {};
            unsubs.forEach((cb)=>cb === null || cb === void 0 ? void 0 : cb());
        };
    }, [
        externalPlugins,
        selector
    ]);
    return pluginStates;
}
function $430abdfe7b868193$var$shallowEqual(objA, objB) {
    if (objA === objB) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for (const key of keysA){
        if (objA[key] !== objB[key]) return false;
    }
    return true;
}

});

parcelRegister("bKltE", function(module, exports) {
$parcel$export(module.exports, "default", () => $63b272824152dd16$export$2e2bcd8739ae039);

var $03Ze8 = parcelRequire("03Ze8");
/**
 * This module exposes the Compiled implementation as the entry point so consumers keep
 * importing from `./EditorContentContainer`.
 */ const $63b272824152dd16$var$EditorContentContainer = (0, $03Ze8.EditorContentContainerCompiled);
var $63b272824152dd16$export$2e2bcd8739ae039 = $63b272824152dd16$var$EditorContentContainer;

});
parcelRegister("03Ze8", function(module, exports) {
$parcel$export(module.exports, "EditorContentContainerCompiled", () => $863ab7558870d100$export$b9e04e68e256861a);
/* EditorContentContainer-compiled.tsx generated by @compiled/babel-plugin v3.0.2 */ // oxlint-disable-next-line typescript-eslint/triple-slash-reference
/// <reference path="../../types/compiled-shims.d.ts" />
// Because we migrated with using cssMapScope API for non atomic css, so these atomic css related eslint suppression no longer needs to be fixed.
/* eslint-disable @atlaskit/platform/use-motion-token-values, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/design-system/no-invalid-css-map, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-selectors, @atlaskit/platform/expand-spacing-shorthand, @atlaskit/platform/expand-border-shorthand, @atlaskit/platform/expand-background-shorthand */ 
var $dc70d = parcelRequire("dc70d");

var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $jxkn6 = parcelRequire("jxkn6");

var $jg7cu = parcelRequire("jg7cu");

var $5bbjm = parcelRequire("5bbjm");

var $iZZBs = parcelRequire("iZZBs");

var $3y2s4 = parcelRequire("3y2s4");

var $3zzvD = parcelRequire("3zzvD");

var $gdUUy = parcelRequire("gdUUy");

var $797yE = parcelRequire("797yE");

var $5N1Y4 = parcelRequire("5N1Y4");

var $4zjoa = parcelRequire("4zjoa");

var $ceb9s = parcelRequire("ceb9s");

var $dj7La = parcelRequire("dj7La");
// = akEditorDefaultLayoutWidth * breakoutWideScaleRatio = 1010.8 ~ 1011 This is a resulting width value that is applied to nodes that currently use breakouts (except table) and are set to `wide` when the viewport's width is > 1329px.
const $863ab7558870d100$var$akEditorCalculatedWideLayoutWidth = 1011;
// from breakoutConsts.calcWideWidth, layoutMaxWidth * breakoutConsts.wideScaleRatio = 904.8 ~ 905 This is a resulting width value that is applied to nodes that currently use breakouts (except table) and are set to `wide` when the viewport's width is <= 1266px.
const $863ab7558870d100$var$akEditorCalculatedWideLayoutWidthSmallViewport = 905;
const $863ab7558870d100$var$akEditorGutterPadding = 32;
const $863ab7558870d100$var$akEditorDefaultLayoutWidth = 760;
const $863ab7558870d100$var$akEditorFullWidthLayoutWidth = 1800;
const $863ab7558870d100$var$tableOverflowShadowWidthWide = 32;
// The breakpoint for small devices is 1266px, copied from getBreakpoint in platform/packages/editor/editor-common/src/ui/WidthProvider/index.tsx
const $863ab7558870d100$var$akEditorBreakpointForSmallDevice = `1266px`;
const $863ab7558870d100$var$akEditorGutterPaddingReduced = 24;
const $863ab7558870d100$var$akEditorFullPageNarrowBreakout = 600;
const $863ab7558870d100$var$akEditorUltraWideLayoutWidth = 4000;
// Layout responsiveness breakpoints — chosen to align editor layout responsiveness with the renderer.
// Applied to the editor-area container query (max-width) for layout sections.
const $863ab7558870d100$var$akEditorLayoutFullWidthBreakpoint = 724;
const $863ab7558870d100$var$akEditorLayoutFixedWidthBreakpoint = 788;
const $863ab7558870d100$var$akEditorLayoutResizedBreakpoint = 820;
// Originally copied from packages/editor/editor-core/src/ui/Appearance/Comment/Comment.tsx
const $863ab7558870d100$var$CommentEditorMargin = 14;
const $863ab7558870d100$var$GRID_GUTTER = 12;
const $863ab7558870d100$var$blockNodesVerticalMargin = '0.75rem';
const $863ab7558870d100$var$fontSize14px = `${0.875}rem`;
const $863ab7558870d100$var$scaledBlockNodesVerticalMargin = '0.75em';
// emoji constants — values inlined from packages/elements/emoji/src/util/constants.ts
// If you need to update these values, please also update packages/elements/emoji/src/util/constants.ts
const $863ab7558870d100$var$defaultEmojiHeight = 20;
const $863ab7558870d100$var$defaultDenseEmojiHeight = 16.25;
const $863ab7558870d100$var$scaledEmojiHeightH1 = 28;
const $863ab7558870d100$var$scaledEmojiHeightH2 = 26;
const $863ab7558870d100$var$scaledEmojiHeightH3 = 24;
const $863ab7558870d100$var$scaledEmojiHeightH4 = 22;
const $863ab7558870d100$var$denseEmojiHeightH1 = 24.25;
const $863ab7558870d100$var$denseEmojiHeightH2 = 22.25;
const $863ab7558870d100$var$denseEmojiHeightH3 = 20.25;
const $863ab7558870d100$var$denseEmojiHeightH4 = 18.25;
const $863ab7558870d100$var$emojiSelectionStyles = null;
const $863ab7558870d100$var$gutterDangerOverlay = null;
const $863ab7558870d100$var$blanketSelectionStyles = null;
// copied from packages/editor/editor-shared-styles/src/consts/consts.ts
const $863ab7558870d100$var$akEditorLineHeight = 1.714;
const $863ab7558870d100$var$listsStylesSafariFixMultiSelector = `
	.ProseMirror:not(.blockCardView-content-wrap) > li > p:first-child,
	.ProseMirror:not(.blockCardView-content-wrap) > li > .code-block:first-child,
	.ProseMirror:not(.blockCardView-content-wrap) > li > .ProseMirror-gapcursor:first-child + .code-block`;
const $863ab7558870d100$var$editorAreaNonSmallDeviceContainerQuery = `@container editor-area (width >= ${$863ab7558870d100$var$akEditorBreakpointForSmallDevice})`;
const $863ab7558870d100$var$editorAreaNarrowPageContainerQuery = `@container editor-area (max-width: ${$863ab7558870d100$var$akEditorFullPageNarrowBreakout}px)`;
const $863ab7558870d100$var$editorAreaLayoutFullWidthMaxWidthContainerQuery = `@container editor-area (max-width: ${$863ab7558870d100$var$akEditorLayoutFullWidthBreakpoint}px)`;
const $863ab7558870d100$var$editorAreaLayoutFixedWidthMaxWidthContainerQuery = `@container editor-area (max-width: ${$863ab7558870d100$var$akEditorLayoutFixedWidthBreakpoint}px)`;
const $863ab7558870d100$var$editorAreaLayoutResizedMaxWidthContainerQuery = `@container editor-area (max-width: ${$863ab7558870d100$var$akEditorLayoutResizedBreakpoint}px)`;
const $863ab7558870d100$var$placeholderFadeInKeyframes = null;
const $863ab7558870d100$var$fadeIn = null;
const $863ab7558870d100$var$inlineStartShadow = null;
const $863ab7558870d100$var$inlineEndShadow = null;
const $863ab7558870d100$var$hideNativeBrowserTextSelectionStyles = null;
const $863ab7558870d100$var$boxShadowSelectionStyles = null;
const $863ab7558870d100$var$dangerBorderStyles = null;
const $863ab7558870d100$var$backgroundSelectionStyles = null;
const $863ab7558870d100$var$dangerBackgroundStyles = null;
const $863ab7558870d100$var$mentionsSelectedColor = null;
const $863ab7558870d100$var$fixVerticalAlignmentSelector = `
	&:first-of-type + ul,
	&:first-of-type + span + ul,
	&:first-of-type + ol,
	&:first-of-type + span + ol,
	&:first-of-type + pre,
	&:first-of-type + span + pre,
	&:first-of-type + blockquote,
	&:first-of-type + span + blockquote
`;
const $863ab7558870d100$var$gapCursorTwoImagesSideBySideFixSelector = `
  .ProseMirror-gapcursor[layout="wrap-left"] + span + [layout="wrap-left"],
  .ProseMirror-gapcursor[layout="wrap-right"] + span + [layout="wrap-right"],
  .ProseMirror-gapcursor + [layout="wrap-left"] + [layout="wrap-right"],
  .ProseMirror-gapcursor + [layout="wrap-left"] + span + [layout="wrap-right"],
  .ProseMirror-gapcursor + [layout="wrap-right"] + [layout="wrap-left"],
  .ProseMirror-gapcursor + [layout="wrap-right"] + span + [layout="wrap-left"],
  [layout="wrap-left"] + .ProseMirror-gapcursor + [layout="wrap-right"],
  [layout="wrap-left"] + .ProseMirror-gapcursor + span [layout="wrap-right"],
  [layout="wrap-right"] + .ProseMirror-gapcursor + [layout="wrap-left"],
  [layout="wrap-right"] + .ProseMirror-gapcursor + span + [layout="wrap-left"],
  [layout="wrap-left"] + .ProseMirror-gapcursor`;
const $863ab7558870d100$var$gapCursorMarginFixSelector = `
  [layout="wrap-left"] + .ProseMirror-gapcursor + [layout="wrap-right"] > div,
  [layout="wrap-left"] + .ProseMirror-gapcursor + span + [layout="wrap-right"] > div,
  [layout="wrap-right"] + .ProseMirror-gapcursor + [layout="wrap-left"] > div,
  [layout="wrap-right"] + .ProseMirror-gapcursor + span + [layout="wrap-left"] > div,
  .ProseMirror-gapcursor + [layout="wrap-right"] + [layout="wrap-left"] > div,
  .ProseMirror-gapcursor + [layout="wrap-right"] + span + [layout="wrap-left"] > div,
  .ProseMirror-gapcursor + [layout="wrap-left"] + [layout="wrap-right"] > div,
  .ProseMirror-gapcursor + [layout="wrap-left"] + span + [layout="wrap-right"] > div`;
const $863ab7558870d100$var$gapCursorFloatLeftFixSelector = `
  [layout="wrap-left"] + .ProseMirror-gapcursor,
  [layout="wrap-right"] + .ProseMirror-gapcursor`;
const $863ab7558870d100$var$gapCursorAfterPseudoSelector = `
  .ProseMirror-gapcursor + [layout="wrap-left"] + span + [layout="wrap-right"]::after,
  .ProseMirror-gapcursor + [layout="wrap-right"] + span + [layout="wrap-left"]::after,
  [layout="wrap-left"] + .ProseMirror-gapcursor + [layout="wrap-right"]::after,
  [layout="wrap-left"] + .ProseMirror-gapcursor + span + [layout="wrap-right"]::after,
  [layout="wrap-right"] + .ProseMirror-gapcursor + [layout="wrap-left"]::after,
  [layout="wrap-right"] + .ProseMirror-gapcursor + span + [layout="wrap-left"]::after`;
const $863ab7558870d100$var$gapCursorMarginDeepChildrenFixSelector = `
  [layout="wrap-left"] + .ProseMirror-gapcursor + [layout="wrap-right"] + *,
  [layout="wrap-left"] + .ProseMirror-gapcursor + [layout="wrap-right"] + span + *,
  [layout="wrap-right"] + .ProseMirror-gapcursor + [layout="wrap-left"] + *,
  [layout="wrap-right"] + .ProseMirror-gapcursor + [layout="wrap-left"] + span + *,
  [layout="wrap-left"] + .ProseMirror-gapcursor + span + [layout="wrap-right"] + *,
  [layout="wrap-right"] + .ProseMirror-gapcursor + span + [layout="wrap-left"] + *,
  .ProseMirror-gapcursor + [layout="wrap-left"] + span + [layout="wrap-right"] + *,
  .ProseMirror-gapcursor + [layout="wrap-right"] + span + [layout="wrap-left"] + *,
  [layout="wrap-left"] + .ProseMirror-gapcursor + [layout="wrap-right"] + * > *,
  [layout="wrap-left"] + .ProseMirror-gapcursor + [layout="wrap-right"] + span + * > *,
  [layout="wrap-right"] + .ProseMirror-gapcursor + [layout="wrap-left"] + * > *,
  [layout="wrap-right"] + .ProseMirror-gapcursor + [layout="wrap-left"] + span + * > *,
  [layout="wrap-left"] + .ProseMirror-gapcursor + span + [layout="wrap-right"] + * > *,
  [layout="wrap-right"] + .ProseMirror-gapcursor + span + [layout="wrap-left"] + * > *,
  .ProseMirror-gapcursor + [layout="wrap-left"] + span + [layout="wrap-right"] + * > *,
  .ProseMirror-gapcursor + [layout="wrap-right"] + span + [layout="wrap-left"] + * > *,
  .ProseMirror-widget:not([data-blocks-decoration-container="true"]):not([data-blocks-drag-handle-container="true"]):not([data-blocks-quick-insert-container="true"]) + .ProseMirror-gapcursor + *,
  .ProseMirror-widget:not([data-blocks-decoration-container="true"]):not([data-blocks-drag-handle-container="true"]):not([data-blocks-quick-insert-container="true"]) + .ProseMirror-gapcursor + span + *`;
const $863ab7558870d100$var$gapCursorBlink = null;
const $863ab7558870d100$var$pulseIn = null;
const $863ab7558870d100$var$pulseOut = null;
const $863ab7558870d100$var$pulseInDuringTr = null;
const $863ab7558870d100$var$pulseOutDuringTr = null;
// Agent edit shimmer: skeleton-loader sweep across the agent-authored range.
const $863ab7558870d100$var$agentShimmer = null;
// Agent edit purple "just edited" highlight: eases the background and underline in, holds, then eases
// them back out over the highlight's lifetime (duration set inline per-decoration to match removal).
const $863ab7558870d100$var$agentEditHighlight = null;
const $863ab7558870d100$var$syncBlockCreationLoadingKeyframes = null;
const $863ab7558870d100$var$mentionRunShimmer = null;
/**
 * aiPanelStyles
 * was imported from packages/editor/editor-core/src/ui/ContentStyles/ai-panels.ts
 */ const $863ab7558870d100$var$rotationAnimation = null;
const $863ab7558870d100$var$rotationAnimationFirefox = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
const $863ab7558870d100$var$prismBorderBaseBackgroundFirefox = `linear-gradient(90deg, #0065FF 0%, #0469FF 12%, #BF63F3 24%, #FFA900 48%, #BF63F3 64%, #0469FF 80%, #0065FF 100%)`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
const $863ab7558870d100$var$prismBorderBaseBackground = `conic-gradient(from var(--panel-gradient-angle, 270deg), #0065FF 0%, #0469FF 20%, #BF63F3 50%, #FFA900 56%, #0065FF 100%)`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
const $863ab7558870d100$var$prismBorderDarkBackgroundFirefox = `linear-gradient(90deg, #0065FF80 0%, #0469FF80 12%, #BF63F380 24%, #FFA90080 48%, #BF63F380 64%, #0469FF80 80%, #0065FF80 100%)`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
const $863ab7558870d100$var$prismBorderDarkBackground = `conic-gradient(from var(--panel-gradient-angle, 270deg), #0065FF80 0%, #0469FF80 20%, #BF63F380 50%, #FFA90080 56%, #0065FF80 100%)`;
const $863ab7558870d100$var$borderSelectionStyles = null;
const $863ab7558870d100$var$overflowShadowStyles = null;
/**
 * editorContentStyles contains the Compiled CSS styles migrated from EditorContentContainer/styles.
 * Validate style changes with local VR and integration tests.
 *
 * If you are not sure, please contact #proj-cc-editor-full-compiled-css-migration
 */ // eslint-disable-next-line @atlaskit/design-system/no-css-map-scoped
const $863ab7558870d100$var$editorContentStyles = {
    aiPanelBaseFirefoxStyles: "cc-nxozza",
    aiPanelBaseStyles: "cc-fq3ixy",
    aiPanelDarkFirefoxStyles: "cc-10cptea",
    aiPanelDarkStyles: "cc-5cpl9e",
    alignMultipleWrappedImageInLayoutStyles: "cc-dkvgen",
    annotationStyles: "cc-1flkwh",
    backgroundColorStyles: "cc-vbhsc3",
    highlightLinksUnsetStyles: "cc-kix5ii",
    baseStyles: "cc-8rtctp",
    baseStylesMaxContainerWidthFixes: "cc-9ri12x",
    blockMarksStyles: "cc-8cs5ej",
    extensionWithBreakoutStyles: "cc-j1c8r0",
    blockquoteDangerStyles: "cc-1sniys0",
    blockquoteSelectedNodeStyles: "cc-zchq1h",
    blocktypeStyles: "cc-fbqkq9",
    headingScrollMarginStyles: "cc-7k6n9k",
    blocktypeStylesRtlBlockquote: "cc-jo4vj",
    blocktypeStylesNestedDnd: "cc-1r1wtfx",
    blocktypeStyles_fg_platform_editor_typography_ugc: "cc-1tvgvcm",
    codeBlockStyles: "cc-1aew448",
    codeBlockStylesWithEmUnits: "cc-hl0mak",
    codeMarkStyles: "cc-1j1rcxi",
    commentEditorStyles: "cc-ht6m66",
    nonFullPageContainerTypeStyles: "cc-vvroiu",
    cursorStyles: "cc-bp4onv",
    dangerDateStyles: "cc-4fidym",
    dangerRuleStyles: "cc-12bry89",
    numberedHeadingsStyles: "cc-1sdftyi",
    ruleWithAttrsStyles: "cc-jgboh",
    dateStyles: "cc-4a2sda",
    dateVanillaStyles: "cc-uwx56g",
    decisionDangerStyles: "cc-1if9r82",
    decisionIconWithVisualRefresh: "cc-11vrzqk",
    decisionStyles: "cc-8lm5yp",
    diffListStyles: "cc-5jmzeb",
    editorControlsSmartCardStyles: "cc-1ej3po4",
    editorGutterPaddingBaseStyles: "cc-1u75jr",
    editorLargeGutterPuddingReducedBaseStyles: "cc-16djhdn",
    editorUGCTokensRefreshed: "cc-axldfu",
    editorUGCSmallText: "cc-gi137o",
    embedCardStyles: "cc-rvrlre",
    emojiDangerStyles: "cc-zm2uv",
    emojiStyles: "cc-hhv5aj",
    emojiSelectionStyles: "cc-93v8xz",
    directEmojiSelectionStyles: "cc-1shdmq7",
    emojiDenseStyles: "cc-1c1i7rv",
    expandStyles: "cc-halxj4",
    expandStylesBase: "cc-17cvvyz",
    expandStylesMixin_chromeless_expand_fix: "cc-1vh2e0l",
    expandStylesMixinNestedDnd: "cc-oizn4q",
    expandStylesMixin_fg_platform_visual_refresh_icons: "cc-1wwn39y",
    expandDenseStyles: "cc-1roxt8n",
    extensionStyles: "cc-1smh8rj",
    extensionStylesDense: "cc-co74ny",
    extensionDiffStyles: "cc-17qh1x7",
    bodiedExtensionLayoutShiftFix: "cc-1iiqc8d",
    findReplaceStyles: "cc-rltwid",
    findReplaceStylesWithCodeblockColorContrastFix: "cc-fvp5l3",
    findReplaceStylesWithRefSyncBlock: "cc-1lqllhn",
    firstBlockNodeStyles: "cc-c7wvy",
    firstNodeWidgetFixStyles: "cc-2ub6w9",
    firstCodeBlockWithNoMargin: "cc-101wakz",
    firstFloatingToolbarButtonStyles: "cc-qzsa0i",
    firstWrappedMediaStyles: "cc-1932pj3",
    fontSizeStyles: "cc-1bl2asj",
    fullPageEditorStyles: "cc-u6bitr",
    gapCursorStyles: "cc-6snxi6",
    gapCursorStylesVisibilityFix: "cc-1jrnrsn",
    gridStyles: "cc-1mk7qyx",
    hideCursorWhenHideSelectionStyles: "cc-1o2iha0",
    hideSelectionStyles: "cc-1062cpx",
    hyperLinkFloatingToolbarStyles: "cc-mcw54q",
    indentationStyles: "cc-178lsg",
    InlineNodeViewSharedStyles: "cc-qmeuk0",
    layoutBaseStyles: "cc-x33nmu",
    layoutBaseStylesAdvanced: "cc-5tnpr3",
    layoutBaseStylesNestedDndExcludingBodiedSync: "cc-1aah7yo",
    layoutColumnDividerStyles: "cc-1kmb1d7",
    layoutColumnDividerStylesNestedDnD: "cc-1wu6eoc",
    layoutColumnMartinTopFixes: "cc-1ui88lk",
    layoutColumnResizeStyles: "cc-13pm7r7",
    layoutColumnResponsiveStyles: "cc-ltzpov",
    layoutColumnStylesAdvanced: "cc-b8v72t",
    layoutColumnStylesNotAdvanced: "cc-ji5n4z",
    layoutResponsiveBaseStyles: "cc-5tnn3i",
    layoutResponsiveStylesForView: "cc-19hy1zt",
    layoutDragHandleWrapperStylesLegacy: "cc-1334uzr",
    layoutDragHandleWrapperStylesTopLayer: "cc-y1hjm0",
    layoutSectionStylesAdvanced: "cc-jymp42",
    layoutSectionStylesNotAdvanced: "cc-bl1kpu",
    layoutSelectedStylesAdvanced: "cc-1awd7rg",
    layoutSelectedStylesAdvancedFix: "cc-dvqk9n",
    layoutSelectedStylesForViewAdvanced: "cc-1ubdzzh",
    layoutSelectedStylesForViewNotAdvanced: "cc-1s8bqns",
    layoutSelectedStylesNotAdvanced: "cc-a2byjx",
    layoutStylesForView: "cc-jybn5i",
    linkingVisualRefreshV1Styles: "cc-18lhlkw",
    linkStyles: "cc-4q7djy",
    listDangerStyles: "cc-175suwm",
    listItemHiddenMarkerStyles: "cc-5drztr",
    listSelectedNodeStyles: "cc-kjdsov",
    listsStyles: "cc-d30lm9",
    listsStylesMarginLayoutShiftFix: "cc-19q8bsv",
    listsStylesSafariFix: "cc-7zb3g7",
    listsDenseStyles: "cc-1f5b2a8",
    maxModeReizeFixStyles: "cc-yaauc5",
    mediaAlignmentStyles: "cc-1u4mef2",
    vanillaCaptionStyles: "cc-ylks8u",
    mediaCaptionStyles: "cc-jou28z",
    mediaDangerStyles: "cc-1j1fgm4",
    mediaGroupStyles: "cc-1181xy3",
    mediaStyles: "cc-1tsurnq",
    mentionDangerStyles: "cc-shgg21",
    mentionAvatarNoWrapStyles: "cc-omm00e",
    mentionNodeStyles: "cc-3mptdv",
    agentMentionShimmerDarkMode: "cc-kpc7tm",
    mentionsSelectionStyles: "cc-pasq3f",
    mentionsStyles: "cc-1ch2mav",
    nestedPanelBorderStylesMixin: "cc-4gjktj",
    nestedPanelDangerStyles: "cc-6qmb10",
    panelStyles: "cc-1q1rsvs",
    panelStylesMixin: "cc-y1fvdb",
    panelStylesMixinNestedDnd: "cc-1l2ajh9",
    panelViewStyles: "cc-14f1i19",
    paragraphStylesUGCRefreshed: "cc-xd6k28",
    paragraphStylesWithScaledMargin: "cc-dafs11",
    placeholderOverflowStyles: "cc-1ratie0",
    placeholderStyles: "cc-1fe75wr",
    placeholderTextStyles: "cc-p2vnxp",
    pragmaticResizerStyles: "cc-xz3998",
    pragmaticResizerStylesCodeBlockSyncedBlockPatch: "cc-1ou5hn3",
    pragmaticResizerStylesForTooltip: "cc-ol8ybb",
    pragmaticResizerStylesSyncedBlock: "cc-1qubxhz",
    pragmaticResizerStylesWithReducedEditorGutter: "cc-pjep6d",
    pragmaticResizerStylesPanelAndRule: "cc-1yd6cax",
    pragmaticResizerStylesPanelAndRuleJsdomFix: "cc-1qxd9zj",
    pragmaticResizerStylesExtensions: "cc-1vlq9bw",
    pragmaticResizerStylesHiddenForPanelAndRule: "cc-10jz9l8",
    pragmaticResizerStylesHiddenForExtensions: "cc-wut5ct",
    pragmaticStylesLayoutFirstNodeResizeHandleFix: "cc-gvmcb8",
    resizerStyles: "cc-12vtbrw",
    resizerBottomHandleStyles: "cc-1uqurck",
    ruleStyles: "cc-1udc5a2",
    scaledEmojiStyles: "cc-33h5rh",
    scaledEmojiDenseStyles: "cc-1xoth0f",
    scrollbarStyles: "cc-19g7rsz",
    selectedNodeStyles: "cc-1rdosaw",
    selectionToolbarAnimationStyles: "cc-pwe4jy",
    shadowStyles: "cc-17lsfth",
    extensionScrollInlineShadowStyles: "cc-1mzk0q1",
    showDiffDeletedNodeStyles: "cc-yq0u2c",
    smartCardDiffStyles: "cc-q67isw",
    smartCardStylesWithSearchMatch: "cc-en2ljt",
    smartCardStylesWithSearchMatchAndBlockMenuDangerStyles: "cc-1xb8dtq",
    smartCardStylesWithSearchMatchAndPreviewPanelResponsiveness: "cc-1lq0ftg",
    smartLinksInLivePagesStyles: "cc-1vvkzqc",
    syncBlockFirstNodeStyles: "cc-w012lq",
    syncBlockTextSelectionStyles: "cc-1y0yw2m",
    syncBlockInteractiveCursorStyles: "cc-13vvsdg",
    syncBlockOverflowStyles: "cc-pcoc0f",
    syncBlockStyles: "cc-hcyd0h",
    syncBlockSelectedStyles: "cc-u54o3z",
    syncBlockStylesBase: "cc-15d9ojr",
    tableCellBackgroundColorOverrides: "cc-1d4nwlw",
    tableCommentEditorStyles: "cc-1rmp8zp",
    tableContainerStyles: "cc-cdl04x",
    tableScrollInlineShadowStyles: "cc-1ff9jzy",
    tableContentModeStyles: "cc-jaald7",
    tableContentModeExtensionContainmentStyles: "cc-n94ot4",
    tableContentModeNestedTableStyles: "cc-7bbx0c",
    tableEmptyRowStyles: "cc-2hcb5b",
    tableRoundedCornerStyles: "cc-40thxh",
    tableLayoutFixes: "cc-1olrv5m",
    tableLayoutFixesWithFontSize: "cc-12k1wjt",
    tableSharedStyle: "cc-191p3m",
    tableSharedStyleBackgroundClipFix: "cc-8zaofg",
    tableSharedStyle_with_platform_editor_table_q4_loveability: "cc-1yp891w",
    tableSharedStyle_without_platform_editor_table_q4_loveability: "cc-1oggp9a",
    tableSharedStyle_with_platform_editor_table_menu_updates: "cc-1umqnky",
    tableSharedStyle_with_platform_editor_bordered_panel_nested_in_table: "cc-19kg595",
    taskItemCheckboxStyles: "cc-ri327w",
    taskItemStylesWithBlockTaskItem: "cc-1lrzai2",
    tasksAndDecisionsStyles: "cc-111dazk",
    tasksAndDecisionsDenseStyles: "cc-r80zg4",
    statusDangerStyles: "cc-16eit37",
    statusStyles: "cc-1n7epx6",
    statusStylesMixin_fg_platform_component_visual_refresh_with_search_match: "cc-1rkvfkn",
    statusStylesMixin_without_fg_platform_component_visual_refresh_with_search_match: "cc-asniun",
    deletedStatusStrikeStyles: "cc-l4fro4",
    atomicInlineChangedBoxShadowStyles: "cc-6vlsb9",
    statusStylesTeam26: "cc-18pwq72",
    statusStylesNamedSemantic: "cc-nxc4cw",
    statusStylesNamedAccent: "cc-1ajfo9u",
    statusStylesHexAccent: "cc-13q87kd",
    telepointerColorAndCommonStyle: "cc-18bfncu",
    telepointerColorAndCommonStyleDarkMode: "cc-vh4h1e",
    agentShimmerStyles: "cc-oxiemz",
    telepointerStyle: "cc-yly1tq",
    textColorStyles: "cc-zrepy0",
    textDangerStyles: "cc-dqcceg",
    textHighlightPaddingStyles: "cc-w1naod",
    textHighlightStyle: "cc-5bys90",
    textSelectedNodeStyles: "cc-zehtfr",
    unsupportedStyles: "cc-148bb4h",
    vanillaTooltipDefaultStyles: "cc-1nel5m",
    contributorTagStyles: "cc-1nedeqb",
    vanillaUnsupportedStyles: "cc-14ih7us",
    whitespaceStyles: "cc-3tuu0m"
};
const $863ab7558870d100$var$isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
const $863ab7558870d100$export$b9e04e68e256861a = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).forwardRef((props, ref)=>{
    const { className: className, children: children, viewMode: viewMode, isScrollable: isScrollable, appearance: appearance, contentMode: contentMode, useStandardNodeWidth: useStandardNodeWidth } = props;
    const { colorMode: colorMode } = (0, $ceb9s.useThemeObserver)();
    const isFullPage = appearance === 'full-page' || appearance === 'full-width' || appearance === 'max';
    const isComment = appearance === 'comment';
    const isChromeless = appearance === 'chromeless';
    const baseFontSize = (0, $dj7La.getBaseFontSize)(appearance, contentMode);
    const isDense = !!baseFontSize && baseFontSize !== (0, $5bbjm.akEditorFullPageDefaultFontSize);
    const tableOverflowShadow = (0, $iZZBs.overflowShadowForCompiled)({
        leftCoverWidth: "var(--ds-space-300, 24px)"
    });
    // Under the static-CSS experiment, --ak-editor-base-font-size is set earlier on the
    // root div in editor-internal.tsx and inherited via the CSS cascade — do not set it here.
    // For the legacy path, compute it from the Emotion theme as before.
    const style = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useMemo(()=>({
            '--ak-editor--table-overflow-shadow': tableOverflowShadow,
            ...(0, $jg7cu.tableCellBackgroundColorVariablesForCompiled),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            ...!(0, $797yE.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
                exposure: true
            }) && {
                '--ak-editor--large-gutter-padding': `${(0, $5bbjm.akEditorGutterPaddingDynamic)()}px`
            }
        }), [
        tableOverflowShadow
    ]);
    const browser = (0, $jxkn6.getBrowserInfo)();
    const isFloatingTocEnabled = (0, $3y2s4.isExperimentEnabled)('platform_editor_floating_toc');
    const isUpdateStatusColorsEnabled = (0, $3zzvD.UNSAFE_expValNoExposure)('platform_editor_update_status_colors', 'isEnabled', false) || (0, $3zzvD.UNSAFE_expValNoExposure)('platform_editor_update_status_colors_jira', 'isEnabled', false);
    const isStatusStylesTeam26 = (0, $gdUUy.fg)('platform-dst-lozenge-tag-badge-visual-uplifts');
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $9fU1q.default)([
            $863ab7558870d100$var$editorContentStyles.baseStyles,
            $863ab7558870d100$var$editorContentStyles.maxModeReizeFixStyles,
            $863ab7558870d100$var$editorContentStyles.baseStylesMaxContainerWidthFixes,
            $863ab7558870d100$var$editorContentStyles.editorGutterPaddingBaseStyles,
            (0, $797yE.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
                exposure: true
            }) && $863ab7558870d100$var$editorContentStyles.editorLargeGutterPuddingReducedBaseStyles,
            $863ab7558870d100$var$editorContentStyles.whitespaceStyles,
            $863ab7558870d100$var$editorContentStyles.indentationStyles,
            $863ab7558870d100$var$editorContentStyles.fontSizeStyles,
            $863ab7558870d100$var$editorContentStyles.shadowStyles,
            (0, $3y2s4.isExperimentEnabled)('platform_editor_reduce_forced_layout_2') && $863ab7558870d100$var$editorContentStyles.extensionScrollInlineShadowStyles,
            $863ab7558870d100$var$editorContentStyles.InlineNodeViewSharedStyles,
            $863ab7558870d100$var$editorContentStyles.hideSelectionStyles,
            $863ab7558870d100$var$editorContentStyles.hideCursorWhenHideSelectionStyles,
            $863ab7558870d100$var$editorContentStyles.selectedNodeStyles,
            $863ab7558870d100$var$editorContentStyles.cursorStyles,
            $863ab7558870d100$var$editorContentStyles.firstFloatingToolbarButtonStyles,
            $863ab7558870d100$var$editorContentStyles.placeholderTextStyles,
            $863ab7558870d100$var$editorContentStyles.placeholderStyles,
            (0, $797yE.editorExperiment)('platform_editor_controls', 'variant1') && $863ab7558870d100$var$editorContentStyles.placeholderOverflowStyles,
            $863ab7558870d100$var$editorContentStyles.codeBlockStyles,
            contentMode === 'compact' && $863ab7558870d100$var$editorContentStyles.codeBlockStylesWithEmUnits,
            $863ab7558870d100$var$editorContentStyles.editorUGCTokensRefreshed,
            $863ab7558870d100$var$editorContentStyles.editorUGCSmallText,
            $863ab7558870d100$var$editorContentStyles.blocktypeStyles,
            $863ab7558870d100$var$editorContentStyles.blocktypeStylesRtlBlockquote,
            isFloatingTocEnabled && $863ab7558870d100$var$editorContentStyles.headingScrollMarginStyles,
            $863ab7558870d100$var$editorContentStyles.blockquoteSelectedNodeStyles,
            $863ab7558870d100$var$editorContentStyles.listSelectedNodeStyles,
            $863ab7558870d100$var$editorContentStyles.textSelectedNodeStyles,
            $863ab7558870d100$var$editorContentStyles.blocktypeStyles_fg_platform_editor_typography_ugc,
            $863ab7558870d100$var$editorContentStyles.blocktypeStylesNestedDnd,
            $863ab7558870d100$var$editorContentStyles.codeMarkStyles,
            $863ab7558870d100$var$editorContentStyles.textColorStyles,
            $863ab7558870d100$var$editorContentStyles.backgroundColorStyles,
            !(0, $5N1Y4.expValEquals)('platform_editor_lovability_text_bg_color', 'isEnabled', true) && $863ab7558870d100$var$editorContentStyles.highlightLinksUnsetStyles,
            $863ab7558870d100$var$editorContentStyles.textHighlightPaddingStyles,
            $863ab7558870d100$var$editorContentStyles.listsStyles,
            $863ab7558870d100$var$editorContentStyles.listItemHiddenMarkerStyles,
            $863ab7558870d100$var$editorContentStyles.diffListStyles,
            contentMode === 'compact' && isDense && $863ab7558870d100$var$editorContentStyles.listsDenseStyles,
            isFullPage && $863ab7558870d100$var$editorContentStyles.listsStylesMarginLayoutShiftFix,
            $863ab7558870d100$var$editorContentStyles.ruleStyles,
            (0, $3y2s4.isExperimentEnabled)('platform_editor_lovability_dividers_attributes') && $863ab7558870d100$var$editorContentStyles.ruleWithAttrsStyles,
            (0, $3y2s4.isExperimentEnabled)('platform_editor_numbered_headings') && $863ab7558870d100$var$editorContentStyles.numberedHeadingsStyles,
            $863ab7558870d100$var$editorContentStyles.smartCardDiffStyles,
            $863ab7558870d100$var$editorContentStyles.showDiffDeletedNodeStyles,
            $863ab7558870d100$var$editorContentStyles.mediaStyles,
            (0, $3y2s4.isExperimentEnabled)('platform_editor_vanilla_node_views_phase1') && $863ab7558870d100$var$editorContentStyles.vanillaCaptionStyles,
            contentMode === 'compact' && $863ab7558870d100$var$editorContentStyles.mediaCaptionStyles,
            $863ab7558870d100$var$editorContentStyles.firstWrappedMediaStyles,
            $863ab7558870d100$var$editorContentStyles.telepointerStyle,
            /* This needs to be after telepointer styles as some overlapping rules have equal specificity, and so the order is significant */ $863ab7558870d100$var$editorContentStyles.telepointerColorAndCommonStyle,
            colorMode === 'dark' && $863ab7558870d100$var$editorContentStyles.telepointerColorAndCommonStyleDarkMode,
            (0, $4zjoa.expValEqualsNoExposure)('platform_editor_agent_be_streaming', 'isEnabled', true) && $863ab7558870d100$var$editorContentStyles.agentShimmerStyles,
            $863ab7558870d100$var$editorContentStyles.gapCursorStyles,
            $863ab7558870d100$var$editorContentStyles.gapCursorStylesVisibilityFix,
            $863ab7558870d100$var$editorContentStyles.panelStyles,
            $863ab7558870d100$var$editorContentStyles.nestedPanelBorderStylesMixin,
            $863ab7558870d100$var$editorContentStyles.panelStylesMixinNestedDnd,
            $863ab7558870d100$var$editorContentStyles.panelStylesMixin,
            $863ab7558870d100$var$editorContentStyles.mentionsStyles,
            $863ab7558870d100$var$editorContentStyles.tasksAndDecisionsStyles,
            contentMode === 'compact' && isDense && $863ab7558870d100$var$editorContentStyles.tasksAndDecisionsDenseStyles,
            $863ab7558870d100$var$editorContentStyles.gridStyles,
            $863ab7558870d100$var$editorContentStyles.blockMarksStyles,
            $863ab7558870d100$var$editorContentStyles.dateStyles,
            $863ab7558870d100$var$editorContentStyles.extensionStyles,
            (0, $gdUUy.fg)('platform_editor_lovability_resize_exts_gracefully') && $863ab7558870d100$var$editorContentStyles.extensionWithBreakoutStyles,
            contentMode === 'compact' && $863ab7558870d100$var$editorContentStyles.extensionStylesDense,
            $863ab7558870d100$var$editorContentStyles.bodiedExtensionLayoutShiftFix,
            $863ab7558870d100$var$editorContentStyles.extensionDiffStyles,
            $863ab7558870d100$var$editorContentStyles.expandStylesBase,
            !useStandardNodeWidth && $863ab7558870d100$var$editorContentStyles.expandStyles,
            contentMode === 'compact' && isDense && $863ab7558870d100$var$editorContentStyles.expandDenseStyles,
            $863ab7558870d100$var$editorContentStyles.expandStylesMixinNestedDnd,
            $863ab7558870d100$var$editorContentStyles.expandStylesMixin_fg_platform_visual_refresh_icons,
            isChromeless && $863ab7558870d100$var$editorContentStyles.expandStylesMixin_chromeless_expand_fix,
            $863ab7558870d100$var$editorContentStyles.findReplaceStyles,
            $863ab7558870d100$var$editorContentStyles.findReplaceStylesWithCodeblockColorContrastFix,
            $863ab7558870d100$var$editorContentStyles.findReplaceStylesWithRefSyncBlock,
            $863ab7558870d100$var$editorContentStyles.textHighlightStyle,
            $863ab7558870d100$var$editorContentStyles.decisionStyles,
            $863ab7558870d100$var$editorContentStyles.taskItemStylesWithBlockTaskItem,
            $863ab7558870d100$var$editorContentStyles.taskItemCheckboxStyles,
            $863ab7558870d100$var$editorContentStyles.decisionIconWithVisualRefresh,
            $863ab7558870d100$var$editorContentStyles.statusStyles,
            isStatusStylesTeam26 ? $863ab7558870d100$var$editorContentStyles.statusStylesTeam26 : (0, $gdUUy.fg)('platform-component-visual-refresh') ? $863ab7558870d100$var$editorContentStyles.statusStylesMixin_fg_platform_component_visual_refresh_with_search_match : $863ab7558870d100$var$editorContentStyles.statusStylesMixin_without_fg_platform_component_visual_refresh_with_search_match,
            isStatusStylesTeam26 && isUpdateStatusColorsEnabled && $863ab7558870d100$var$editorContentStyles.statusStylesNamedAccent,
            isStatusStylesTeam26 && !isUpdateStatusColorsEnabled && $863ab7558870d100$var$editorContentStyles.statusStylesNamedSemantic,
            $863ab7558870d100$var$editorContentStyles.statusStylesHexAccent,
            (0, $gdUUy.fg)('platform_editor_ai_show_diff_patch_2') && $863ab7558870d100$var$editorContentStyles.deletedStatusStrikeStyles,
            $863ab7558870d100$var$editorContentStyles.annotationStyles,
            $863ab7558870d100$var$editorContentStyles.smartCardStylesWithSearchMatchAndBlockMenuDangerStyles,
            (0, $797yE.editorExperiment)('platform_editor_preview_panel_responsiveness', true) && $863ab7558870d100$var$editorContentStyles.smartCardStylesWithSearchMatchAndPreviewPanelResponsiveness,
            $863ab7558870d100$var$editorContentStyles.editorControlsSmartCardStyles,
            $863ab7558870d100$var$editorContentStyles.embedCardStyles,
            $863ab7558870d100$var$editorContentStyles.unsupportedStyles,
            $863ab7558870d100$var$editorContentStyles.vanillaTooltipDefaultStyles,
            (0, $gdUUy.fg)('confluence_ncs_step_diffing_version_history') && $863ab7558870d100$var$editorContentStyles.contributorTagStyles,
            (0, $3y2s4.isExperimentEnabled)('platform_editor_vanilla_node_views_phase1') && $863ab7558870d100$var$editorContentStyles.vanillaUnsupportedStyles,
            $863ab7558870d100$var$editorContentStyles.resizerStyles,
            (0, $4zjoa.expValEqualsNoExposure)('cc-maui-experiment', 'isEnabled', true) && (0, $5N1Y4.expValEquals)('databases-native-embeds-v2', 'isEnabled', true) && $863ab7558870d100$var$editorContentStyles.resizerBottomHandleStyles,
            $863ab7558870d100$var$editorContentStyles.layoutBaseStyles,
            $863ab7558870d100$var$editorContentStyles.alignMultipleWrappedImageInLayoutStyles,
            $863ab7558870d100$var$editorContentStyles.syncBlockStylesBase,
            (0, $gdUUy.fg)('platform-dst-tokens-finesse') && $863ab7558870d100$var$editorContentStyles.syncBlockSelectedStyles,
            !useStandardNodeWidth && $863ab7558870d100$var$editorContentStyles.syncBlockStyles,
            $863ab7558870d100$var$editorContentStyles.syncBlockOverflowStyles,
            $863ab7558870d100$var$editorContentStyles.syncBlockFirstNodeStyles,
            $863ab7558870d100$var$editorContentStyles.syncBlockTextSelectionStyles,
            $863ab7558870d100$var$editorContentStyles.syncBlockInteractiveCursorStyles,
            (0, $797yE.editorExperiment)('advanced_layouts', true) && $863ab7558870d100$var$editorContentStyles.layoutBaseStylesAdvanced,
            (0, $797yE.editorExperiment)('advanced_layouts', true) ? $863ab7558870d100$var$editorContentStyles.layoutSectionStylesAdvanced : $863ab7558870d100$var$editorContentStyles.layoutSectionStylesNotAdvanced,
            (0, $797yE.editorExperiment)('advanced_layouts', true) && !(0, $gdUUy.fg)('platform-dst-top-layer-tooltip') && $863ab7558870d100$var$editorContentStyles.layoutDragHandleWrapperStylesLegacy,
            (0, $797yE.editorExperiment)('advanced_layouts', true) && (0, $gdUUy.fg)('platform-dst-top-layer-tooltip') && $863ab7558870d100$var$editorContentStyles.layoutDragHandleWrapperStylesTopLayer,
            (0, $797yE.editorExperiment)('advanced_layouts', true) && $863ab7558870d100$var$editorContentStyles.layoutColumnDividerStyles,
            (0, $797yE.editorExperiment)('advanced_layouts', true) && $863ab7558870d100$var$editorContentStyles.layoutColumnDividerStylesNestedDnD,
            (0, $797yE.editorExperiment)('advanced_layouts', true) ? $863ab7558870d100$var$editorContentStyles.layoutColumnStylesAdvanced : $863ab7558870d100$var$editorContentStyles.layoutColumnStylesNotAdvanced,
            (0, $797yE.editorExperiment)('advanced_layouts', true) && $863ab7558870d100$var$editorContentStyles.layoutColumnResizeStyles,
            (0, $797yE.editorExperiment)('advanced_layouts', true) ? $863ab7558870d100$var$editorContentStyles.layoutSelectedStylesAdvanced : $863ab7558870d100$var$editorContentStyles.layoutSelectedStylesNotAdvanced,
            $863ab7558870d100$var$editorContentStyles.layoutSelectedStylesAdvancedFix,
            (0, $797yE.editorExperiment)('advanced_layouts', true) && $863ab7558870d100$var$editorContentStyles.layoutColumnResponsiveStyles,
            (0, $797yE.editorExperiment)('advanced_layouts', true) && $863ab7558870d100$var$editorContentStyles.layoutResponsiveBaseStyles,
            $863ab7558870d100$var$editorContentStyles.layoutBaseStylesNestedDndExcludingBodiedSync,
            $863ab7558870d100$var$editorContentStyles.layoutColumnMartinTopFixes,
            $863ab7558870d100$var$editorContentStyles.smartLinksInLivePagesStyles,
            $863ab7558870d100$var$editorContentStyles.linkingVisualRefreshV1Styles,
            $863ab7558870d100$var$editorContentStyles.dateVanillaStyles,
            contentMode === 'compact' ? $863ab7558870d100$var$editorContentStyles.paragraphStylesWithScaledMargin : $863ab7558870d100$var$editorContentStyles.paragraphStylesUGCRefreshed,
            $863ab7558870d100$var$editorContentStyles.linkStyles,
            browser.safari && $863ab7558870d100$var$editorContentStyles.listsStylesSafariFix,
            $863ab7558870d100$var$editorContentStyles.pragmaticResizerStylesSyncedBlock,
            $863ab7558870d100$var$editorContentStyles.pragmaticResizerStyles,
            (0, $4zjoa.expValEqualsNoExposure)('platform_editor_lovability_resize_dividers_panels', 'isEnabled', true) && (0, $3y2s4.isExperimentEnabled)('platform_editor_resizer_selector_jsdom_fix') && $863ab7558870d100$var$editorContentStyles.pragmaticResizerStylesPanelAndRuleJsdomFix,
            (0, $4zjoa.expValEqualsNoExposure)('platform_editor_lovability_resize_dividers_panels', 'isEnabled', true) && !(0, $3y2s4.isExperimentEnabled)('platform_editor_resizer_selector_jsdom_fix') && $863ab7558870d100$var$editorContentStyles.pragmaticResizerStylesPanelAndRule,
            (0, $3y2s4.isExperimentEnabled)('platform_editor_lovability_resize_extensions') && $863ab7558870d100$var$editorContentStyles.pragmaticResizerStylesExtensions,
            $863ab7558870d100$var$editorContentStyles.pragmaticResizerStylesCodeBlockSyncedBlockPatch,
            (0, $3y2s4.isExperimentEnabled)('platform_editor_reduce_forced_layout') && !(0, $4zjoa.expValEqualsNoExposure)('platform_editor_lovability_resize_dividers_panels', 'isEnabled', true) && $863ab7558870d100$var$editorContentStyles.pragmaticResizerStylesHiddenForPanelAndRule,
            (0, $3y2s4.isExperimentEnabled)('platform_editor_reduce_forced_layout') && !(0, $3y2s4.isExperimentEnabled)('platform_editor_lovability_resize_extensions') && $863ab7558870d100$var$editorContentStyles.pragmaticResizerStylesHiddenForExtensions,
            (0, $797yE.editorExperiment)('advanced_layouts', true) && $863ab7558870d100$var$editorContentStyles.pragmaticStylesLayoutFirstNodeResizeHandleFix,
            $863ab7558870d100$var$editorContentStyles.pragmaticResizerStylesForTooltip,
            (0, $797yE.editorExperiment)('platform_editor_preview_panel_responsiveness', true) && $863ab7558870d100$var$editorContentStyles.pragmaticResizerStylesWithReducedEditorGutter,
            $863ab7558870d100$var$editorContentStyles.aiPanelBaseStyles,
            $863ab7558870d100$var$isFirefox && $863ab7558870d100$var$editorContentStyles.aiPanelBaseFirefoxStyles,
            colorMode === 'dark' && $863ab7558870d100$var$editorContentStyles.aiPanelDarkStyles,
            colorMode === 'dark' && $863ab7558870d100$var$isFirefox && $863ab7558870d100$var$editorContentStyles.aiPanelDarkFirefoxStyles,
            viewMode === 'view' && $863ab7558870d100$var$editorContentStyles.layoutStylesForView,
            viewMode === 'view' && (0, $797yE.editorExperiment)('advanced_layouts', true) && $863ab7558870d100$var$editorContentStyles.layoutSelectedStylesForViewAdvanced,
            viewMode === 'view' && (0, $797yE.editorExperiment)('advanced_layouts', false) && $863ab7558870d100$var$editorContentStyles.layoutSelectedStylesForViewNotAdvanced,
            viewMode === 'view' && (0, $797yE.editorExperiment)('advanced_layouts', true) && $863ab7558870d100$var$editorContentStyles.layoutResponsiveStylesForView,
            isComment && $863ab7558870d100$var$editorContentStyles.commentEditorStyles,
            isComment && $863ab7558870d100$var$editorContentStyles.tableCommentEditorStyles,
            (isComment || isChromeless) && $863ab7558870d100$var$editorContentStyles.nonFullPageContainerTypeStyles,
            isFullPage && $863ab7558870d100$var$editorContentStyles.fullPageEditorStyles,
            isFullPage && $863ab7558870d100$var$editorContentStyles.scrollbarStyles,
            $863ab7558870d100$var$editorContentStyles.firstCodeBlockWithNoMargin,
            $863ab7558870d100$var$editorContentStyles.firstBlockNodeStyles,
            $863ab7558870d100$var$editorContentStyles.firstNodeWidgetFixStyles,
            $863ab7558870d100$var$editorContentStyles.mentionNodeStyles,
            (0, $3y2s4.isExperimentEnabled)('platform_editor_mention_avatar_nowrap') && $863ab7558870d100$var$editorContentStyles.mentionAvatarNoWrapStyles,
            colorMode === 'dark' && $863ab7558870d100$var$editorContentStyles.agentMentionShimmerDarkMode,
            $863ab7558870d100$var$editorContentStyles.mentionsSelectionStyles,
            (0, $5N1Y4.expValEquals)('platform_editor_lovability_emoji_scaling', 'isEnabled', true) ? $863ab7558870d100$var$editorContentStyles.scaledEmojiStyles : $863ab7558870d100$var$editorContentStyles.emojiStyles,
            isFloatingTocEnabled ? $863ab7558870d100$var$editorContentStyles.directEmojiSelectionStyles : $863ab7558870d100$var$editorContentStyles.emojiSelectionStyles,
            contentMode === 'compact' && isDense && (0, $5N1Y4.expValEquals)('platform_editor_lovability_emoji_scaling', 'isEnabled', true) && $863ab7558870d100$var$editorContentStyles.scaledEmojiDenseStyles,
            contentMode === 'compact' && isDense && !(0, $5N1Y4.expValEquals)('platform_editor_lovability_emoji_scaling', 'isEnabled', true) && $863ab7558870d100$var$editorContentStyles.emojiDenseStyles,
            $863ab7558870d100$var$editorContentStyles.panelViewStyles,
            $863ab7558870d100$var$editorContentStyles.mediaGroupStyles,
            $863ab7558870d100$var$editorContentStyles.mediaAlignmentStyles,
            $863ab7558870d100$var$editorContentStyles.tableLayoutFixesWithFontSize,
            $863ab7558870d100$var$editorContentStyles.tableContainerStyles,
            $863ab7558870d100$var$editorContentStyles.tableSharedStyle,
            (0, $3y2s4.isExperimentEnabled)('platform_editor_table_css_overflow_shadow') && $863ab7558870d100$var$editorContentStyles.tableScrollInlineShadowStyles,
            (browser.gecko || browser.ie || browser.mac && browser.chrome) && $863ab7558870d100$var$editorContentStyles.tableSharedStyleBackgroundClipFix,
            (0, $5N1Y4.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) ? $863ab7558870d100$var$editorContentStyles.tableSharedStyle_with_platform_editor_table_q4_loveability : $863ab7558870d100$var$editorContentStyles.tableSharedStyle_without_platform_editor_table_q4_loveability,
            (0, $5N1Y4.expValEquals)('platform_editor_table_menu_updates', 'isEnabled', true) && $863ab7558870d100$var$editorContentStyles.tableSharedStyle_with_platform_editor_table_menu_updates,
            (0, $gdUUy.fg)('platform_editor_bordered_panel_nested_in_table') && $863ab7558870d100$var$editorContentStyles.tableSharedStyle_with_platform_editor_bordered_panel_nested_in_table,
            $863ab7558870d100$var$editorContentStyles.tableEmptyRowStyles,
            (0, $5N1Y4.expValEquals)('platform_editor_table_q4_loveability', 'isEnabled', true) && $863ab7558870d100$var$editorContentStyles.tableRoundedCornerStyles,
            $863ab7558870d100$var$editorContentStyles.tableContentModeStyles,
            $863ab7558870d100$var$editorContentStyles.tableContentModeExtensionContainmentStyles,
            $863ab7558870d100$var$editorContentStyles.tableContentModeNestedTableStyles,
            $863ab7558870d100$var$editorContentStyles.tableCellBackgroundColorOverrides,
            $863ab7558870d100$var$editorContentStyles.hyperLinkFloatingToolbarStyles,
            $863ab7558870d100$var$editorContentStyles.selectionToolbarAnimationStyles,
            $863ab7558870d100$var$editorContentStyles.blockquoteDangerStyles,
            $863ab7558870d100$var$editorContentStyles.textDangerStyles,
            $863ab7558870d100$var$editorContentStyles.listDangerStyles,
            $863ab7558870d100$var$editorContentStyles.dangerDateStyles,
            $863ab7558870d100$var$editorContentStyles.emojiDangerStyles,
            $863ab7558870d100$var$editorContentStyles.mentionDangerStyles,
            $863ab7558870d100$var$editorContentStyles.decisionDangerStyles,
            $863ab7558870d100$var$editorContentStyles.statusDangerStyles,
            (0, $gdUUy.fg)('platform_editor_ai_show_diff_patch_2') && $863ab7558870d100$var$editorContentStyles.atomicInlineChangedBoxShadowStyles,
            $863ab7558870d100$var$editorContentStyles.dangerRuleStyles,
            $863ab7558870d100$var$editorContentStyles.mediaDangerStyles,
            $863ab7558870d100$var$editorContentStyles.nestedPanelDangerStyles,
            className || undefined
        ]),
        ref: ref,
        "data-editor-scroll-container": isScrollable ? 'true' : undefined,
        "data-testid": "editor-content-container",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        tabIndex: isScrollable ? 0 : undefined,
        role: isScrollable ? 'region' : undefined,
        children: children
    });
});

});
parcelRegister("jg7cu", function(module, exports) {
$parcel$export(module.exports, "tableCellBackgroundColorVariablesForCompiled", () => $44c8ecb89777e17b$export$ca835ce2a5bd6107);

var $c8L22 = parcelRequire("c8L22");

var $e4OZJ = parcelRequire("e4OZJ");
const $44c8ecb89777e17b$var$tableCellBackgroundColorVariablePrefix = '--ak-editor-table-cell-background';
const $44c8ecb89777e17b$var$getTableCellBackgroundColorVariableName = (colorName)=>`${$44c8ecb89777e17b$var$tableCellBackgroundColorVariablePrefix}-${colorName.replace(/\s+/gu, '-')}`;
const $44c8ecb89777e17b$export$ca835ce2a5bd6107 = Array.from((0, $c8L22.tableBackgroundColorNames).entries()).reduce((acc, [colorName, hexColor])=>{
    const paletteColorValue = (0, $e4OZJ.hexToEditorBackgroundPaletteColor)(hexColor);
    if (paletteColorValue) acc[$44c8ecb89777e17b$var$getTableCellBackgroundColorVariableName(colorName)] = paletteColorValue;
    return acc;
}, {});

});

parcelRegister("iZZBs", function(module, exports) {
$parcel$export(module.exports, "overflowShadowForCompiled", () => $130638987f8c7e4b$export$bb4a61a93a1e5360);
/**
 * Compiled CSS-compatible variant of {@link overflowShadow}. Returns a plain
 * CSS string (stack of `linear-gradient` layers) suitable for assignment to a
 * `background-image` property in a `cssMap`/`css` declaration.
 *
 * @param options.leftCoverWidth - Width of the left cover layer. Defaults to `token('space.100')`.
 * @param options.rightCoverWidth - Width of the right cover layer. Defaults to `token('space.100')`.
 */ const $130638987f8c7e4b$export$bb4a61a93a1e5360 = ({ leftCoverWidth: leftCoverWidth, rightCoverWidth: rightCoverWidth })=>{
    const width = "var(--ds-space-100, 8px)";
    const leftCoverWidthResolved = leftCoverWidth || width;
    const rightCoverWidthResolved = rightCoverWidth || width;
    return [
        /* shadow cover left */ `linear-gradient(to right, ${"var(--ds-background-neutral, #0515240F)"} ${leftCoverWidthResolved}, transparent ${leftCoverWidthResolved})`,
        /* shadow cover background left */ `linear-gradient(to right, ${"var(--ds-surface-raised, #FFFFFF)"} ${leftCoverWidthResolved}, transparent ${leftCoverWidthResolved})`,
        /* shadow cover right */ `linear-gradient(to left, ${"var(--ds-background-neutral, #0515240F)"} ${rightCoverWidthResolved}, transparent ${rightCoverWidthResolved})`,
        /* shadow cover background right */ `linear-gradient(to left, ${"var(--ds-surface-raised, #FFFFFF)"} ${rightCoverWidthResolved}, transparent ${rightCoverWidthResolved})`,
        /* overflow shadow right spread */ `linear-gradient(to left, ${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 0, ${"var(--ds-UNSAFE-transparent, transparent)"} ${width})`,
        /* overflow shadow right perimeter */ `linear-gradient(to left, ${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0, ${"var(--ds-UNSAFE-transparent, transparent)"} ${width})`,
        /* overflow shadow left spread */ `linear-gradient(to right, ${"var(--ds-shadow-overflow-spread, #1E1F2129)"} 0, ${"var(--ds-UNSAFE-transparent, transparent)"} ${width})`,
        /* overflow shadow left perimeter */ `linear-gradient(to right, ${"var(--ds-shadow-overflow-perimeter, #1E1F211f)"} 0, ${"var(--ds-UNSAFE-transparent, transparent)"} ${width})`
    ].join(', ');
};

});

parcelRegister("dj7La", function(module, exports) {
$parcel$export(module.exports, "getBaseFontSize", () => $f34613992e9c5d8a$export$8e2864079bc476bd);

var $5bbjm = parcelRequire("5bbjm");
function $f34613992e9c5d8a$export$8e2864079bc476bd(appearance, contentMode) {
    if (contentMode === 'compact') return 0, $5bbjm.akEditorFullPageDenseFontSize;
    if (appearance === undefined) return 0, $5bbjm.akEditorFullPageDefaultFontSize;
    return ![
        'comment',
        'chromeless'
    ].includes(appearance) ? (0, $5bbjm.akEditorFullPageDefaultFontSize) : undefined;
}

});



parcelRegister("fdwmh", function(module, exports) {
$parcel$export(module.exports, "default", () => $4e59b63f139a65b9$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $dMMwa = parcelRequire("dMMwa");

var $g6Qq4 = parcelRequire("g6Qq4");

var $5N1Y4 = parcelRequire("5N1Y4");

var $ci39X = parcelRequire("ci39X");

var $8ssDf = parcelRequire("8ssDf");

var $iIViH = parcelRequire("iIViH");
const $4e59b63f139a65b9$var$PluginComponent = ({ component: component, editorView: editorView, editorActions: editorActions, eventDispatcher: eventDispatcher, providerFactory: providerFactory, appearance: appearance, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, containerElement: containerElement, disabled: disabled, dispatchAnalyticsEvent: dispatchAnalyticsEvent, wrapperElement: wrapperElement })=>{
    return component({
        editorView: editorView,
        editorActions: editorActions,
        eventDispatcher: eventDispatcher,
        providerFactory: providerFactory,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        appearance: appearance,
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        containerElement: containerElement,
        disabled: disabled,
        wrapperElement: wrapperElement
    });
};
const $4e59b63f139a65b9$var$PluginSlot = ({ items: items, editorView: editorView, editorActions: editorActions, eventDispatcher: eventDispatcher, providerFactory: providerFactory, appearance: appearance, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, containerElement: containerElement, disabled: disabled, dispatchAnalyticsEvent: dispatchAnalyticsEvent, wrapperElement: wrapperElement, pluginHooks: pluginHooks })=>{
    if (!items && !pluginHooks) return null;
    const isolatePluginSlotFailures = Boolean(items === null || items === void 0 ? void 0 : items.length) && (0, $5N1Y4.expValEquals)('platform_editor_per_plugin_error_boundary', 'isEnabled', true);
    return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $ci39X.ErrorBoundary), {
        component: (0, $g6Qq4.ACTION_SUBJECT).PLUGIN_SLOT,
        fallbackComponent: null,
        children: [
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $8ssDf.MountPluginHooks), {
                editorView: editorView,
                pluginHooks: pluginHooks,
                containerElement: containerElement,
                wrapperElement: wrapperElement
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $iIViH.PluginsComponentsWrapperCompiled), {
                "data-testid": "plugins-components-wrapper",
                children: items === null || items === void 0 ? void 0 : items.map((component, index)=>{
                    if (isolatePluginSlotFailures) return(// The wrapper adds a small amount of overhead, but moves the plugin factory call
                    // inside the per-plugin boundary while still invoking it as a factory.
                    /*#__PURE__*/ (0, $dc70d.jsx)((0, $ci39X.ErrorBoundary), {
                        component: (0, $g6Qq4.ACTION_SUBJECT).PLUGIN_SLOT,
                        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                        fallbackComponent: null,
                        children: /*#__PURE__*/ (0, $dc70d.jsx)($4e59b63f139a65b9$var$PluginComponent, {
                            component: component,
                            editorView: editorView,
                            editorActions: editorActions,
                            eventDispatcher: eventDispatcher,
                            providerFactory: providerFactory,
                            appearance: appearance,
                            popupsMountPoint: popupsMountPoint,
                            popupsBoundariesElement: popupsBoundariesElement,
                            popupsScrollableElement: popupsScrollableElement,
                            containerElement: containerElement,
                            disabled: disabled,
                            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                            wrapperElement: wrapperElement
                        })
                    }, index));
                    const props = {
                        key: index
                    };
                    const element = component({
                        editorView: editorView,
                        editorActions: editorActions,
                        eventDispatcher: eventDispatcher,
                        providerFactory: providerFactory,
                        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        appearance: appearance,
                        popupsMountPoint: popupsMountPoint,
                        popupsBoundariesElement: popupsBoundariesElement,
                        popupsScrollableElement: popupsScrollableElement,
                        containerElement: containerElement,
                        disabled: disabled,
                        wrapperElement: wrapperElement
                    });
                    return element && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).cloneElement(element, props);
                })
            })
        ]
    });
};
const $4e59b63f139a65b9$var$PluginSlotComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).memo($4e59b63f139a65b9$var$PluginSlot, (0, (/*@__PURE__*/$parcel$interopDefault($dMMwa))));
$4e59b63f139a65b9$var$PluginSlotComponent.displayName = 'PluginSlot';
var $4e59b63f139a65b9$export$2e2bcd8739ae039 = $4e59b63f139a65b9$var$PluginSlotComponent;

});
parcelRegister("ci39X", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundary", () => $d7674a44673179d0$export$e926676385687eaf);

var $bSJIT = parcelRequire("bSJIT");

var $g6Qq4 = parcelRequire("g6Qq4");

var $j2Y9J = parcelRequire("j2Y9J");
class $d7674a44673179d0$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Component {
    hasFallback() {
        return typeof this.props.fallbackComponent !== 'undefined';
    }
    shouldRecover() {
        return this.hasFallback() && this.state.errorCaptured;
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.dispatchAnalyticsEvent) this.props.dispatchAnalyticsEvent({
            action: (0, $g6Qq4.ACTION).EDITOR_CRASHED,
            actionSubject: this.props.component,
            actionSubjectId: this.props.componentId,
            eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL,
            attributes: {
                error: error,
                errorInfo: errorInfo,
                errorRethrown: !this.hasFallback()
            }
        });
        (0, $j2Y9J.logException)(error, {
            location: 'editor-core/ui'
        });
        if (this.hasFallback()) this.setState({
            errorCaptured: true
        });
    }
    render() {
        if (this.shouldRecover()) return this.props.fallbackComponent;
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.state = {
            errorCaptured: false
        };
    }
}

});

parcelRegister("8ssDf", function(module, exports) {
$parcel$export(module.exports, "MountPluginHooks", () => $3752820fb79711f5$export$a9224552b63e3fe8);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");
function $3752820fb79711f5$var$MountPluginHook({ usePluginHook: usePluginHook, editorView: editorView, containerElement: containerElement, wrapperElement: wrapperElement }) {
    usePluginHook({
        editorView: editorView,
        containerElement: containerElement,
        wrapperElement: wrapperElement
    });
    return null;
}
function $3752820fb79711f5$export$a9224552b63e3fe8({ pluginHooks: pluginHooks, editorView: editorView, containerElement: containerElement, wrapperElement: wrapperElement }) {
    if (!editorView) return null;
    // Key each fiber by the plugin name carried on the hook function (set by
    // `processPluginsList`). This keeps fibers stable across `reconfigureState`
    // calls that change the plugin set — keying by array index would let React
    // reuse the same fiber for a different `usePluginHook`, which calls a
    // different sequence of hooks (Rules of Hooks violation).
    // Falls back to the array index for any hook that wasn't annotated.
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dc70d.Fragment), {
        children: pluginHooks === null || pluginHooks === void 0 ? void 0 : pluginHooks.map((usePluginHook, index)=>{
            const pluginName = usePluginHook.pluginName;
            return /*#__PURE__*/ (0, $dc70d.jsx)($3752820fb79711f5$var$MountPluginHook, {
                usePluginHook: usePluginHook,
                editorView: editorView,
                containerElement: containerElement,
                wrapperElement: wrapperElement
            }, pluginName ?? index);
        })
    });
}

});

parcelRegister("iIViH", function(module, exports) {
$parcel$export(module.exports, "PluginsComponentsWrapperCompiled", () => $30fd60c84543800c$export$b02ad3407509f83f);
/* PluginSlot-compiled.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
const $30fd60c84543800c$var$pluginsComponentsWrapperCompiledStyles = {
    root: "_1e0c1txw"
};
const $30fd60c84543800c$export$b02ad3407509f83f = ({ children: children, ...rest })=>/*#__PURE__*/ (0, $dc70d.jsx)("div", {
        ...rest,
        className: (0, $9fU1q.default)([
            $30fd60c84543800c$var$pluginsComponentsWrapperCompiledStyles.root
        ]),
        children: children
    });

});


parcelRegister("lcrZe", function(module, exports) {
$parcel$export(module.exports, "default", () => $37f28b2c667b1c88$export$2e2bcd8739ae039);

var $9ttKL = parcelRequire("9ttKL");
const $37f28b2c667b1c88$var$WithFlash = (0, $9ttKL.WithFlashCompiled);
var $37f28b2c667b1c88$export$2e2bcd8739ae039 = $37f28b2c667b1c88$var$WithFlash;

});
parcelRegister("9ttKL", function(module, exports) {
$parcel$export(module.exports, "WithFlashCompiled", () => $56f25b586fb39b98$export$ce622d3514f749db);
/* withFlash-compiled.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");
const $56f25b586fb39b98$var$pulseBackground = null;
const $56f25b586fb39b98$var$pulseBackgroundReverse = null;
const $56f25b586fb39b98$var$compiledStyles = {
    flashWrapper: "_16nrglyw _1q4hp6wo _4eh31doz _l0dz1ytf",
    flashWrapperAnimated: "_1q4h1bej _4eh31doz _l0dz1ytf"
};
class $56f25b586fb39b98$export$ce622d3514f749db extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Component {
    render() {
        const { animate: animate, children: children } = this.props;
        this.toggle = animate && !this.toggle;
        return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $9fU1q.default)([
                animate ? $56f25b586fb39b98$var$compiledStyles.flashWrapperAnimated : $56f25b586fb39b98$var$compiledStyles.flashWrapper,
                this.toggle ? '-flash' : ''
            ]),
            children: children
        });
    }
    constructor(...args){
        super(...args), this.toggle = false;
    }
}

});


parcelRegister("2zd8q", function(module, exports) {
$parcel$export(module.exports, "ChromelessEditorContainer", () => $b12e7fd76df1aac5$export$5ffd32ebea3773c5);
/* ChromelessEditorContainer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $9fU1q = parcelRequire("9fU1q");
parcelRequire("bSJIT");
const $b12e7fd76df1aac5$var$chromelessStyles = {
    scrollbar: "_1fpfolhs _1khk1mok _123b1aqn _jaboglyw _aaynsm61 _1ogl1ibz",
    editor: "_vwz4gktf _4t3i1wug _1reo15vq _18m91wug _p12f1kw7 _vchhusvi _slp31hna _fpqb1r31 _l5dlglyw _tjxn1o36 _1yt4idpf _y826idpf _7fa7idpf _8wn3idpf _1nhbidpf _1q5yidpf _1gfdidpf _1itkidpf _7fkv1jtm _1awku2gc _15gyze3t"
};
const $b12e7fd76df1aac5$export$5ffd32ebea3773c5 = ({ children: children, containerRef: containerRef, maxHeight: maxHeight, minHeight: minHeight })=>/*#__PURE__*/ (0, $dc70d.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $9fU1q.default)([
            $b12e7fd76df1aac5$var$chromelessStyles.editor,
            $b12e7fd76df1aac5$var$chromelessStyles.scrollbar,
            "akEditor"
        ]),
        style: {
            maxHeight: maxHeight ? `${maxHeight}px` : undefined,
            minHeight: `${minHeight}px`
        },
        ref: containerRef,
        "data-testid": "chromeless-editor",
        id: "chromeless-editor",
        children: children
    });

});


parcelRegister("fM3fo", function(module, exports) {
$parcel$export(module.exports, "CommentEditorWithIntl", () => $c09af49552bd129b$export$7b9f3a51cd0c1967);
/* Comment.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $2YfQG = parcelRequire("2YfQG");

var $4vLTk = parcelRequire("4vLTk");

var $f1bHg = parcelRequire("f1bHg");

var $jNJGJ = parcelRequire("jNJGJ");

var $fNLdd = parcelRequire("fNLdd");

var $aHqLs = parcelRequire("aHqLs");

var $9x1C7 = parcelRequire("9x1C7");

var $5beht = parcelRequire("5beht");

var $5oXqC = parcelRequire("5oXqC");

var $5bbjm = parcelRequire("5bbjm");

var $797yE = parcelRequire("797yE");

var $LRGCN = parcelRequire("LRGCN");

var $gLFdE = parcelRequire("gLFdE");

var $bKltE = parcelRequire("bKltE");

var $fdwmh = parcelRequire("fdwmh");

var $dUXT6 = parcelRequire("dUXT6");

var $3BF2Y = parcelRequire("3BF2Y");

var $lcrZe = parcelRequire("lcrZe");

var $eRTBQ = parcelRequire("eRTBQ");

var $cD5dW = parcelRequire("cD5dW");
const $c09af49552bd129b$var$commentEditorCompiledStyles = {
    commentEditor: "_19itno8c _2rko1qi0 _1e0c1txw _2lx21bp4 _1ul9clpc _4t3i1wug _bfhk1j9a _vchhusvi _p12f1kw7 _slp31hna _13dfutpp _gzr8u2gc _ghozu2gc _oafwu2gc",
    modernisedEditor: "_2rkopb1k",
    secondaryToolbar: "_vchhusvi _1bahesu3 _4cvr1h6o _1e0c1txw _ca0qutpp _u5f3v77o _n3tdutpp _19bvv77o",
    mainToolbarCustomComponentsSlotNew: "_1e0c1txw _1bahesu3 _4cvr1h6o _16jlkb7n _u5f3v47k _p7r11txw _t1edidpf",
    mainToolbarCustomComponentsSlotPaddingOverride: "_u5f3idpf",
    mainToolbarCustomComponentsSlotTwoLineToolbar: "_xugcidpf",
    contentAreaMaxHeight: "_c71lmz22 _18m91wug"
};
const $c09af49552bd129b$var$appearance = 'comment';
const $c09af49552bd129b$export$7b9f3a51cd0c1967 = (props)=>{
    var _editorAPI$blockMenu;
    const { editorAPI: editorAPI } = props;
    // Get useStandardNodeWidth from block menu plugin shared state
    // Only access editorAPI when the experiment is enabled to avoid performance impact
    const useStandardNodeWidth = (0, $797yE.editorExperiment)('platform_editor_controls', 'variant1') && ((editorAPI === null || editorAPI === void 0 || (_editorAPI$blockMenu = editorAPI.blockMenu) === null || _editorAPI$blockMenu === void 0 || (_editorAPI$blockMenu = _editorAPI$blockMenu.sharedState) === null || _editorAPI$blockMenu === void 0 || (_editorAPI$blockMenu = _editorAPI$blockMenu.currentState()) === null || _editorAPI$blockMenu === void 0 ? void 0 : _editorAPI$blockMenu.useStandardNodeWidth) ?? false);
    const { editorViewMode: editorViewMode, primaryToolbarComponentsState: primaryToolbarComponentsState, maxContentSizeReached: maxContentSizeReached } = (0, $5beht.useSharedPluginStateWithSelector)(editorAPI, [
        'maxContentSize',
        'primaryToolbar',
        'editorViewMode'
    ], (states)=>{
        var _states$maxContentSiz, _states$primaryToolba, _states$editorViewMod;
        return {
            maxContentSizeReached: !!((_states$maxContentSiz = states.maxContentSizeState) !== null && _states$maxContentSiz !== void 0 && _states$maxContentSiz.maxContentSizeReached),
            primaryToolbarComponentsState: (_states$primaryToolba = states.primaryToolbarState) === null || _states$primaryToolba === void 0 ? void 0 : _states$primaryToolba.components,
            editorViewMode: (_states$editorViewMod = states.editorViewModeState) === null || _states$editorViewMod === void 0 ? void 0 : _states$editorViewMod.mode
        };
    });
    const primaryToolbarState = (0, $dUXT6.getPrimaryToolbarComponents)(editorAPI, primaryToolbarComponentsState);
    const { mediaState: mediaState } = (0, $9x1C7.useSharedPluginState)(editorAPI, [
        'media'
    ]);
    const intl = (0, $4vLTk.default)();
    const { editorDOMElement: editorDOMElement, editorView: editorView, editorActions: editorActions, eventDispatcher: eventDispatcher, providerFactory: providerFactory, contentComponents: contentComponents, customContentComponents: customContentComponents, customPrimaryToolbarComponents: customPrimaryToolbarComponents, primaryToolbarComponents: primaryToolbarComponentsProp, customSecondaryToolbarComponents: customSecondaryToolbarComponents, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, maxHeight: maxHeight, minHeight: minHeight = 150, onSave: onSave, onCancel: onCancel, disabled: disabled, dispatchAnalyticsEvent: dispatchAnalyticsEvent, useStickyToolbar: useStickyToolbar, pluginHooks: pluginHooks, featureFlags: featureFlags, innerRef: innerRef, isEditorModernisationEnabled: isEditorModernisationEnabled } = props;
    const showSecondaryToolbar = !!onSave || !!onCancel || !!customSecondaryToolbarComponents;
    const containerElement = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useRef(null);
    // Wrapper container for toolbar and content area
    const wrapperElementRef = (0, $bSJIT.useMemo)(()=>innerRef || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createRef(), [
        innerRef
    ]);
    const [saveButtonDisabled, setSaveButtonDisabled] = (0, $bSJIT.useState)(false);
    (0, $bSJIT.useEffect)(()=>{
        if (mediaState) mediaState.subscribeToUploadInProgressState(setSaveButtonDisabled);
        return ()=>mediaState === null || mediaState === void 0 ? void 0 : mediaState.unsubscribeFromUploadInProgressState(setSaveButtonDisabled);
    }, [
        mediaState
    ]);
    const handleSave = (0, $bSJIT.useCallback)(()=>{
        if (editorView && onSave) onSave(editorView);
    }, [
        editorView,
        onSave
    ]);
    const handleCancel = (0, $bSJIT.useCallback)(()=>{
        if (editorView && onCancel) onCancel(editorView);
    }, [
        editorView,
        onCancel
    ]);
    const isShortcutToFocusToolbar = (0, $bSJIT.useCallback)((event)=>{
        //Alt + F9 to reach first element in this main toolbar
        return event.altKey && (event.key === 'F9' || event.keyCode === 120);
    }, []);
    // When primary toolbar components is undefined, do not show two line editor toolbar
    const isTwoLineToolbarEnabled = !!customPrimaryToolbarComponents;
    const handleEscape = (0, $bSJIT.useCallback)((event)=>{
        if (!(editorView !== null && editorView !== void 0 && editorView.hasFocus())) editorView === null || editorView === void 0 || editorView.focus();
        event.preventDefault();
        event.stopPropagation();
    }, [
        editorView
    ]);
    let primaryToolbarComponents = primaryToolbarComponentsProp;
    if (Array.isArray(primaryToolbarState === null || primaryToolbarState === void 0 ? void 0 : primaryToolbarState.components) && Array.isArray(primaryToolbarComponents)) primaryToolbarComponents = primaryToolbarState.components.concat(primaryToolbarComponents);
    const isToolbarAIFCEnabled = Boolean(editorAPI === null || editorAPI === void 0 ? void 0 : editorAPI.toolbar);
    const wrapperStyle = (0, $bSJIT.useMemo)(()=>({
            minHeight: `${minHeight}px`,
            ...maxHeight ? {
                '--comment-editor-max-height': `${maxHeight}px`
            } : {}
        }), [
        minHeight,
        maxHeight
    ]);
    const customToolbarSlot = /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        className: (0, $9fU1q.default)([
            $c09af49552bd129b$var$commentEditorCompiledStyles.mainToolbarCustomComponentsSlotNew,
            isTwoLineToolbarEnabled && $c09af49552bd129b$var$commentEditorCompiledStyles.mainToolbarCustomComponentsSlotTwoLineToolbar,
            isToolbarAIFCEnabled && $c09af49552bd129b$var$commentEditorCompiledStyles.mainToolbarCustomComponentsSlotPaddingOverride
        ]),
        children: customPrimaryToolbarComponents
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $lcrZe.default), {
        animate: maxContentSizeReached,
        children: /*#__PURE__*/ (0, $dc70d.jsxs)((0, $5oXqC.WidthProvider), {
            children: [
                /*#__PURE__*/ (0, $dc70d.jsxs)("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- dynamic minHeight/maxHeight from props
                    style: wrapperStyle,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: (0, $9fU1q.default)([
                        $c09af49552bd129b$var$commentEditorCompiledStyles.commentEditor,
                        isEditorModernisationEnabled && $c09af49552bd129b$var$commentEditorCompiledStyles.modernisedEditor,
                        "akEditor"
                    ]),
                    ref: wrapperElementRef,
                    children: [
                        /*#__PURE__*/ (0, $dc70d.jsx)((0, $cD5dW.MainToolbar), {
                            isEditorModernisationEnabled: isEditorModernisationEnabled,
                            useStickyToolbar: useStickyToolbar,
                            twoLineEditorToolbar: isTwoLineToolbarEnabled,
                            isNewToolbarEnabled: isToolbarAIFCEnabled,
                            children: isToolbarAIFCEnabled ? /*#__PURE__*/ (0, $dc70d.jsxs)((0, $aHqLs.ToolbarArrowKeyNavigationProvider), {
                                editorView: editorView,
                                childComponentSelector: "[data-testid='ak-editor-main-toolbar']",
                                isShortcutToFocusToolbar: isShortcutToFocusToolbar,
                                handleEscape: handleEscape,
                                editorAppearance: $c09af49552bd129b$var$appearance,
                                useStickyToolbar: useStickyToolbar,
                                intl: intl,
                                children: [
                                    /*#__PURE__*/ (0, $dc70d.jsx)((0, $eRTBQ.CommentToolbar), {
                                        editorAPI: editorAPI,
                                        editorView: editorView,
                                        editorAppearance: $c09af49552bd129b$var$appearance,
                                        disabled: !!disabled,
                                        popupsBoundariesElement: popupsBoundariesElement,
                                        popupsScrollableElement: popupsScrollableElement,
                                        popupsMountPoint: popupsMountPoint
                                    }),
                                    customPrimaryToolbarComponents ? customToolbarSlot : null
                                ]
                            }) : /*#__PURE__*/ (0, $dc70d.jsxs)((0, $aHqLs.ToolbarArrowKeyNavigationProvider), {
                                editorView: editorView,
                                childComponentSelector: "[data-testid='ak-editor-main-toolbar']",
                                isShortcutToFocusToolbar: isShortcutToFocusToolbar,
                                handleEscape: handleEscape,
                                editorAppearance: $c09af49552bd129b$var$appearance,
                                useStickyToolbar: useStickyToolbar,
                                intl: intl,
                                children: [
                                    /*#__PURE__*/ (0, $dc70d.jsx)((0, $3BF2Y.ToolbarWithSizeDetector), {
                                        // Ignored via go/ees005
                                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                        editorView: editorView,
                                        editorActions: editorActions,
                                        // Ignored via go/ees005
                                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                        eventDispatcher: eventDispatcher,
                                        // Ignored via go/ees005
                                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                        providerFactory: providerFactory,
                                        appearance: $c09af49552bd129b$var$appearance,
                                        items: primaryToolbarComponents,
                                        popupsMountPoint: popupsMountPoint,
                                        popupsBoundariesElement: popupsBoundariesElement,
                                        popupsScrollableElement: popupsScrollableElement,
                                        disabled: !!disabled,
                                        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                                        containerElement: containerElement.current,
                                        twoLineEditorToolbar: isTwoLineToolbarEnabled
                                    }),
                                    customToolbarSlot
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $dc70d.jsx)((0, $LRGCN.default), {
                            editorView: editorView,
                            editorDisabled: disabled,
                            children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $5oXqC.WidthConsumer), {
                                children: ({ width: width })=>{
                                    return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $bKltE.default), {
                                        ref: containerElement,
                                        isScrollable: maxHeight ? true : undefined,
                                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                                        className: (0, $9fU1q.default)([
                                            maxHeight && $c09af49552bd129b$var$commentEditorCompiledStyles.contentAreaMaxHeight,
                                            (0, (/*@__PURE__*/$parcel$interopDefault($2YfQG)))('ak-editor-content-area', {
                                                'less-margin': width < (0, $5bbjm.akEditorMobileBreakoutPoint)
                                            })
                                        ]),
                                        featureFlags: featureFlags,
                                        viewMode: editorViewMode,
                                        appearance: $c09af49552bd129b$var$appearance,
                                        useStandardNodeWidth: useStandardNodeWidth,
                                        children: [
                                            customContentComponents && 'before' in customContentComponents ? (0, $gLFdE.contentComponentClickWrapper)(customContentComponents.before) : (0, $gLFdE.contentComponentClickWrapper)(customContentComponents),
                                            /*#__PURE__*/ (0, $dc70d.jsx)((0, $fdwmh.default), {
                                                editorView: editorView,
                                                editorActions: editorActions,
                                                eventDispatcher: eventDispatcher,
                                                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                                                providerFactory: providerFactory,
                                                appearance: $c09af49552bd129b$var$appearance,
                                                items: contentComponents,
                                                popupsMountPoint: popupsMountPoint,
                                                popupsBoundariesElement: popupsBoundariesElement,
                                                popupsScrollableElement: popupsScrollableElement,
                                                containerElement: containerElement.current,
                                                disabled: !!disabled,
                                                wrapperElement: wrapperElementRef.current,
                                                pluginHooks: pluginHooks
                                            }),
                                            editorDOMElement,
                                            customContentComponents && 'after' in customContentComponents ? (0, $gLFdE.contentComponentClickWrapper)(customContentComponents.after) : null
                                        ]
                                    });
                                }
                            })
                        })
                    ]
                }),
                showSecondaryToolbar && /*#__PURE__*/ (0, $dc70d.jsxs)("div", {
                    "data-testid": "ak-editor-secondary-toolbar",
                    className: (0, $9fU1q.default)([
                        $c09af49552bd129b$var$commentEditorCompiledStyles.secondaryToolbar
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $dc70d.jsxs)((0, $f1bHg.default), {
                            children: [
                                !!onSave && /*#__PURE__*/ (0, $dc70d.jsx)((0, $jNJGJ.default), {
                                    appearance: "primary",
                                    onClick: handleSave,
                                    testId: "comment-save-button",
                                    isDisabled: disabled || saveButtonDisabled,
                                    interactionName: "editor-comment-save-button",
                                    children: intl.formatMessage((0, $fNLdd.default).saveButton)
                                }),
                                !!onCancel && /*#__PURE__*/ (0, $dc70d.jsx)((0, $jNJGJ.default), {
                                    appearance: "subtle",
                                    onClick: handleCancel,
                                    testId: "comment-cancel-button",
                                    isDisabled: disabled,
                                    interactionName: "editor-comment-cancel-button",
                                    children: intl.formatMessage((0, $fNLdd.default).cancelButton)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $dc70d.jsx)("span", {
                            style: {
                                flexGrow: 1
                            }
                        }),
                        customSecondaryToolbarComponents
                    ]
                })
            ]
        })
    });
};
$c09af49552bd129b$export$7b9f3a51cd0c1967.displayName = 'CommentEditorAppearance';

});
parcelRegister("fNLdd", function(module, exports) {
$parcel$export(module.exports, "default", () => $c58da91d70a8b5c6$export$2e2bcd8739ae039);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $f0Pt4 = parcelRequire("f0Pt4");



var $kRPKQ = parcelRequire("kRPKQ");












var $cW1gB = parcelRequire("cW1gB");

var $ahEv1 = parcelRequire("ahEv1");

var $278lv = parcelRequire("278lv");

var $1gu5b = parcelRequire("1gu5b");
































const $c58da91d70a8b5c6$var$_default_1 = (0, $f0Pt4.defineMessages)({
    layoutFixedWidth: {
        id: 'fabric.editor.layoutFixedWidth',
        defaultMessage: 'Back to center',
        description: 'Display your element (image, table, extension, etc) as standard width'
    },
    layoutStateFixedWidth: {
        id: 'fabric.editor.layoutStateFixedWidth',
        defaultMessage: 'Centered',
        description: 'Displaying your element (image, table, extension, etc) as standard width'
    },
    layoutWide: {
        id: 'fabric.editor.layoutWide',
        defaultMessage: 'Go wide',
        description: 'Display your element (image, table, extension, etc) wider than normal'
    },
    layoutStateWide: {
        id: 'fabric.editor.layoutStateWide',
        defaultMessage: 'Wide',
        description: 'Displaying your element (image, table, extension, etc) wider than normal'
    },
    layoutFullWidth: {
        id: 'fabric.editor.layoutFullWidth',
        defaultMessage: 'Go full width',
        description: 'Display your element (image, table, extension, etc) as full width'
    },
    layoutStateFullWidth: {
        id: 'fabric.editor.layoutStateFullWidth',
        defaultMessage: 'Full width',
        description: 'Displaying your element (image, table, extension, etc) as full width'
    },
    alignImageRight: {
        id: 'fabric.editor.alignImageRight',
        defaultMessage: 'Align right',
        description: 'The text is shown as a button in the image toolbar when the user wants to align an image to the right side of the page.'
    },
    alignImageCenter: {
        id: 'fabric.editor.alignImageCenter',
        defaultMessage: 'Align center',
        description: 'The text is shown as a button in the image toolbar when the user wants to align an image to the center of the page.'
    },
    alignImageLeft: {
        id: 'fabric.editor.alignImageLeft',
        defaultMessage: 'Align left',
        description: 'The text is shown as a button in the image toolbar when the user wants to align an image to the left side of the page.'
    },
    delete: {
        id: 'fabric.editor.delete',
        defaultMessage: 'Delete',
        description: 'Delete the element (image, panel, table, etc.) from your document'
    },
    remove: {
        id: 'fabric.editor.remove',
        defaultMessage: 'Remove',
        description: 'Delete the element (image, panel, table, etc.) from your document'
    },
    removeEmoji: {
        id: 'fabric.editor.removeEmoji',
        defaultMessage: 'Remove emoji',
        description: 'Remove the emoji panel icon from custom panel'
    },
    visit: {
        id: 'fabric.editor.visit',
        defaultMessage: 'Open link in a new window',
        description: 'The text is shown as a link or button in the editor when the user wants to open the selected link in a new browser window.'
    },
    inviteToEditButtonTitle: {
        id: 'fabric.editor.editMode.inviteToEditButton.title',
        defaultMessage: 'Invite to edit',
        description: 'Invite another user to edit the current document'
    },
    saveButton: {
        id: 'fabric.editor.saveButton',
        defaultMessage: 'Save',
        description: 'Label for the primary action button that submits and saves the current comment or document in the editor.'
    },
    cancelButton: {
        id: 'fabric.editor.cancelButton',
        defaultMessage: 'Cancel',
        description: 'Label for the button that discards unsaved changes and cancels editing of the current comment or document.'
    },
    taskList: {
        id: 'fabric.editor.tooltip.taskList',
        defaultMessage: 'an action item',
        description: 'The text is shown as a tooltip label in the editor to describe an action item element when the user interacts with it.'
    },
    bulletList: {
        id: 'fabric.editor.tooltip.bulletList',
        defaultMessage: 'a list',
        description: 'The text is shown as a tooltip label in the editor to describe a bullet list element when the user interacts with it.'
    },
    nestedExpand: {
        id: 'fabric.editor.tooltip.nestedExpand',
        defaultMessage: 'a nested expand',
        description: 'The text is shown as a tooltip label in the editor to describe a nested expand element when the user interacts with it.'
    },
    decisionList: {
        id: 'fabric.editor.tooltip.decisionList',
        defaultMessage: 'a decision list',
        description: 'The text is shown as a tooltip label in the editor to describe a decision list element when the user interacts with it.'
    },
    defaultBlockNode: {
        id: 'fabric.editor.tooltip.defaultBlockNode',
        defaultMessage: 'a block node',
        description: 'The text is shown as a tooltip label in the editor to describe a generic block node element when the user interacts with it.'
    },
    panel: {
        id: 'fabric.editor.tooltip.blockPanel',
        defaultMessage: 'a panel',
        description: 'The text is shown as a tooltip label in the editor to describe a panel element when the user interacts with it.'
    },
    blockquote: {
        id: 'fabric.editor.blockquote',
        defaultMessage: 'a quote',
        description: 'The text is shown as a tooltip label in the editor to describe a blockquote element when the user interacts with it.'
    },
    timeUpdated: {
        id: 'fabric.editor.time.updated',
        defaultMessage: 'Updated',
        description: 'The text is shown as a label in the editor to indicate when the content was last updated by a user.'
    },
    timeViewed: {
        id: 'fabric.editor.time.viewed',
        defaultMessage: 'Viewed',
        description: 'The text is shown as a label in the editor to indicate when the content was last viewed by a user.'
    },
    timeAgo: {
        id: 'fabric.editor.time.ago',
        defaultMessage: 'ago',
        description: 'The text is shown as a label suffix after a time value to indicate that the action occurred in the past, for example "5 minutes ago".'
    },
    copyToClipboard: {
        id: 'fabric.editor.copyToClipboard',
        defaultMessage: 'Copy',
        description: 'Copy the whole content of the element to your clipboard'
    },
    copiedToClipboard: {
        id: 'fabric.editor.copiedToClipboard',
        defaultMessage: 'Copied!',
        description: 'Copied the whole content of the element to clipboard'
    },
    viewMore: {
        id: 'fabric.editor.overflowMenuViewMore',
        defaultMessage: 'View more',
        description: 'The text is shown as a button in the editor toolbar overflow menu when additional toolbar options are available for the user to view.'
    },
    imageEdit: {
        id: 'fabric.editor.imageEdit',
        defaultMessage: 'Edit image',
        description: 'Label for the button in the image floating toolbar that opens the image editing panel where users can crop, flip, or rotate the selected image.'
    },
    error: {
        id: 'fabric.editor.error.message.label',
        defaultMessage: 'Error',
        description: 'The text is shown as a label for the error message icon in the editor when an operation fails or an error occurs.'
    },
    success: {
        id: 'fabric.editor.success.message.label',
        defaultMessage: 'Success',
        description: 'Accessible label for the success message icon shown in the editor when an operation completes successfully.'
    }
});
var $c58da91d70a8b5c6$export$2e2bcd8739ae039 = $c58da91d70a8b5c6$var$_default_1;

});
parcelRegister("kRPKQ", function(module, exports) {
$parcel$export(module.exports, "messages", () => $ff099a5d1c2a9bb5$export$defe85febe8b728c);

var $f0Pt4 = parcelRequire("f0Pt4");
const $ff099a5d1c2a9bb5$export$defe85febe8b728c = (0, $f0Pt4.defineMessages)({
    maxWidthLabel: {
        id: 'fabric.editor.breakoutMaxWidthLabel',
        defaultMessage: 'Max-width',
        description: 'Resize current element to max-width mode'
    },
    fullWidthLabel: {
        id: 'fabric.editor.breakoutFullWidthLabel',
        defaultMessage: 'Full-width',
        description: 'Resize current element to full-width mode'
    },
    wideWidthLabel: {
        id: 'fabric.editor.breakoutWideWidthLabel',
        defaultMessage: 'Wide',
        description: 'Label for a toolbar button that resizes the current editor element (e.g. a table, image, or code block) to wide display mode, extending it beyond the default content width.'
    },
    resizeHandle: {
        id: 'fabric.editor.resizeHandle',
        defaultMessage: 'Resize handle',
        description: 'Label for the resize handle element displayed on content blocks in the editor, used to allow users to drag and resize the width of the element.'
    },
    resizeExpand: {
        id: 'fabric.editor.breakout.resizeExpand',
        defaultMessage: 'Resize expand',
        description: 'Tooltip displayed on custom expand width resize handle'
    },
    resizeCodeBlock: {
        id: 'fabric.editor.breakout.resizeCodeBlock',
        defaultMessage: 'Resize code snippet',
        description: 'Tooltip displayed on custom code block width resize handle'
    },
    resizeLayout: {
        id: 'fabric.editor.breakout.resizeLayout',
        defaultMessage: 'Resize layout',
        description: 'Tooltip displayed on custom layout width resize handle'
    },
    resizeElement: {
        id: 'fabric.editor.breakout.resizeElement',
        defaultMessage: 'Resize element',
        description: 'Tooltip displayed on custom element (node) width resize handle'
    },
    resizeRule: {
        id: 'fabric.editor.breakout.resizeRule',
        defaultMessage: 'Resize divider',
        description: 'Tooltip displayed on custom divider width resize handle'
    },
    resizePanel: {
        id: 'fabric.editor.breakout.resizePanel',
        defaultMessage: 'Resize panel',
        description: 'Tooltip displayed on custom panel width resize handle'
    },
    resizeExtension: {
        id: 'fabric.editor.breakout.resizeExtension',
        defaultMessage: 'Resize extension',
        description: 'Tooltip displayed on custom extension width resize handle'
    }
});

});

parcelRegister("cW1gB", function(module, exports) {
$parcel$export(module.exports, "toolbarInsertBlockMessages", () => $075db788c761f761$export$70c8a7203d95247);

var $f0Pt4 = parcelRequire("f0Pt4");
const $075db788c761f761$export$70c8a7203d95247 = (0, $f0Pt4.defineMessages)({
    action: {
        id: 'fabric.editor.action',
        defaultMessage: 'Action item',
        description: "Also known as a \u201Ctask\u201D, \u201Cto do item\u201D, or a checklist"
    },
    actionDescription: {
        id: 'fabric.editor.action.description',
        defaultMessage: 'Create and assign action items',
        description: 'Displayed as a description text for the action item option in the editor insert menu, used to explain the purpose of creating and assigning action items.'
    },
    closeInsertRightRail: {
        id: 'fabric.editor.insertRightRail.close',
        defaultMessage: 'Close',
        description: 'Label for the close button on the insert right rail panel in the editor, used to dismiss the insert elements panel.'
    },
    link: {
        id: 'fabric.editor.link',
        defaultMessage: 'Link',
        description: 'Shown as a menu item label in the editor insert menu, used to insert a hyperlink into the document.'
    },
    linkDescription: {
        id: 'fabric.editor.link.description',
        defaultMessage: 'Insert a link',
        description: 'Displayed as a description text for the link option in the editor insert menu, explaining that it allows users to insert a hyperlink into the document.'
    },
    mediaFiles: {
        id: 'fabric.editor.mediaFiles',
        defaultMessage: 'Image, video, or file',
        description: 'Menu option shown in the quick insert menu. Allows users to insert one or more files, videos, or images into the document.'
    },
    addMediaFiles: {
        id: 'fabric.editor.addMediaFiles',
        defaultMessage: 'Add image, video, or file',
        description: 'Menu option shown in the quick insert menu. Allows users to add images, videos, or files to the document.'
    },
    insertRightRailTitle: {
        id: 'fabric.editor.insertRightRail.title',
        defaultMessage: 'Insert',
        description: 'Heading or title shown in the insert right rail panel. Indicates the purpose of the panel for inserting elements.'
    },
    mediaFilesDescription: {
        id: 'fabric.editor.mediaFiles.description',
        defaultMessage: 'Add images and other files to your page',
        description: 'Menu description shown in the quick insert menu. Explains that users can add images and other files to their page.'
    },
    image: {
        id: 'fabric.editor.image',
        defaultMessage: 'Image',
        description: 'Shown as a menu item label in the editor insert menu, used to insert an image into the document.'
    },
    aiImageGeneration: {
        id: 'fabric.editor.aiImageGeneration',
        defaultMessage: 'Generate image',
        description: 'Shown as a menu item label in the editor insert menu, used to open a popup for generating an image with AI.'
    },
    aiImageGenerationDescription: {
        id: 'fabric.editor.aiImageGeneration.description',
        defaultMessage: 'Generate an image with AI',
        description: 'Displayed as a description text for the AI image generation option in the editor insert menu.'
    },
    aiImageGenerationPopupAriaLabel: {
        id: 'fabric.editor.aiImageGeneration.popupAriaLabel',
        defaultMessage: 'Generate image with AI',
        description: 'Accessible label announced by screen readers when the AI image generation popup opens.'
    },
    mention: {
        id: 'fabric.editor.mention',
        defaultMessage: 'Mention',
        description: 'Reference another person in your document'
    },
    mentionDescription: {
        id: 'fabric.editor.mention.description',
        defaultMessage: 'Notify someone by mentioning them',
        description: 'Reference another person in your document'
    },
    emoji: {
        id: 'fabric.editor.emoji',
        defaultMessage: 'Emoji',
        description: 'Label for the emoji option in the editor insert menu, allowing users to insert an emoji character into the document.'
    },
    emojiDescription: {
        id: 'fabric.editor.emoji.description',
        defaultMessage: "Use emojis to express ideas \uD83C\uDF89 and emotions \uD83D\uDE04",
        description: 'Menu description shown in the quick insert menu. Explains that users can insert emojis to enhance their content.'
    },
    table: {
        id: 'fabric.editor.table',
        defaultMessage: 'Table',
        description: 'Menu option shown in the quick insert menu. Allows users to insert a table into the document.'
    },
    tableDescription: {
        id: 'fabric.editor.table.description',
        defaultMessage: 'Insert a table',
        description: 'Menu description shown in the quick insert menu. Explains that users can insert a table to organize data.'
    },
    tableSelector: {
        id: 'fabric.editor.tableSelector',
        defaultMessage: 'Table size',
        description: 'Opens a table selector that lets you insert a table of custom size'
    },
    tableSelectorDescription: {
        id: 'fabric.editor.tableSelector.description',
        defaultMessage: 'Add a table using popup to select a custom size',
        description: 'Opens a table selector that lets you insert a table of a custom size'
    },
    tableSizeSelectorButton: {
        id: 'fabric.editor.tableSizeSelectorButton',
        defaultMessage: '{numberOfColumns} by {numberOfRows}',
        description: 'Button label showing table dimensions. The placeholders {numberOfColumns} and {numberOfRows} will be substituted with the selected number of columns and rows.'
    },
    tableSizeSelectorPopup: {
        id: 'fabric.editor.tableSizeSelectorPopup',
        defaultMessage: 'Table size selector',
        description: 'Popup menu shown when selecting table size. Allows users to choose custom dimensions for creating a table.'
    },
    expand: {
        id: 'fabric.editor.expand',
        defaultMessage: 'Expand',
        description: 'Menu option shown in the quick insert menu. Allows users to insert an expandable/collapsible section into the document.'
    },
    expandDescription: {
        id: 'fabric.editor.expand.description',
        defaultMessage: 'Insert an expand',
        description: 'Menu description shown in the quick insert menu. Explains that users can insert expandable content sections.'
    },
    decision: {
        id: 'fabric.editor.decision',
        defaultMessage: 'Decision',
        description: 'Menu option shown in the quick insert menu. Allows users to insert a decision element to track and document decisions.'
    },
    decisionDescription: {
        id: 'fabric.editor.decision.description',
        defaultMessage: "Capture decisions so they're easy to track",
        description: 'Menu description shown in the quick insert menu. Explains that users can insert decision elements for tracking.'
    },
    feedbackDialog: {
        id: 'fabric.editor.feedbackDialog',
        defaultMessage: 'Give feedback',
        description: 'Menu option shown in the quick insert menu. Opens a dialog where users can provide feedback about the editor.'
    },
    feedbackDialogDescription: {
        id: 'fabric.editor.feedbackDialog.description',
        defaultMessage: 'Tell us about your experience using the cloud editor',
        description: 'Menu description shown in the quick insert menu. Invites users to share their feedback about the editor experience.'
    },
    horizontalRule: {
        id: 'fabric.editor.horizontalRule',
        defaultMessage: 'Divider',
        description: 'Shown as a menu item label in the editor insert menu, used to insert a horizontal rule or divider to separate content in the document.'
    },
    horizontalRuleDescription: {
        id: 'fabric.editor.horizontalRule.description',
        defaultMessage: 'Separate content with a horizontal line',
        description: 'Displayed as a description text for the divider option in the editor insert menu, explaining that it inserts a horizontal line to separate content sections in the document.'
    },
    date: {
        id: 'fabric.editor.date',
        defaultMessage: 'Date',
        description: 'Menu option shown in the quick insert menu. Allows users to insert a date into the document using a date picker.'
    },
    dateDescription: {
        id: 'fabric.editor.date.description',
        defaultMessage: 'Add a date using a calendar',
        description: 'Menu description shown in the quick insert menu. Explains how to add a date into the document using a calendar picker.'
    },
    placeholderText: {
        id: 'fabric.editor.placeholderText',
        defaultMessage: 'Placeholder text',
        description: 'Menu option shown in the quick insert menu. Allows users to insert a text placeholder into the document.'
    },
    placeholderTextDescription: {
        id: 'fabric.editor.placeholderText.description',
        defaultMessage: 'Insert a text placeholder into the page',
        description: 'Menu description shown in the quick insert menu. Explains how to insert a text placeholder for later content.'
    },
    columns: {
        id: 'fabric.editor.columns',
        defaultMessage: 'Layouts',
        description: 'Menu option shown in the quick insert menu. Allows users to create multi-column layouts and sections.'
    },
    columnsDescription: {
        id: 'fabric.editor.columns.description',
        defaultMessage: 'Structure your page using sections',
        description: 'Menu description shown in the quick insert menu. Explains how to use layouts to structure content.'
    },
    columnsDescriptionAdvancedLayout: {
        id: 'fabric.editor.columns.advanced.layout.description',
        defaultMessage: 'Insert {numberOfColumns} equal {numberOfColumns, plural, one {column} other {columns}}',
        description: 'Menu option for advanced layouts. The placeholder {numberOfColumns} will be substituted with the number of equal columns being inserted.'
    },
    singleColumnsDescriptionAdvancedLayout: {
        id: 'fabric.editor.columns.advanced.layout.single.description',
        defaultMessage: 'Insert a single column layout',
        description: 'Menu option shown in the quick insert menu. Allows users to insert a single column layout section.'
    },
    status: {
        id: 'fabric.editor.status',
        defaultMessage: 'Status',
        description: 'Menu option shown in the quick insert menu. Allows users to insert a status indicator for tasks or activities.'
    },
    statusDescription: {
        id: 'fabric.editor.status.description',
        defaultMessage: 'Add a custom status label',
        description: 'Menu description shown in the quick insert menu. Explains that users can add custom status labels.'
    },
    viewMore: {
        id: 'fabric.editor.viewMore',
        defaultMessage: 'View more',
        description: 'Button label shown in the quick insert menu. Allows users to see additional elements beyond the primary display.'
    },
    viewMoreAriaLabel: {
        id: 'fabric.editor.viewMoreAriaLabel',
        defaultMessage: 'View all elements',
        description: 'ARIA label for accessibility. Provides a more descriptive label to screen readers indicating users can view all insertable elements.'
    },
    insertMenu: {
        id: 'fabric.editor.insertMenu',
        defaultMessage: 'Insert elements',
        description: 'Menu option or button label shown in the editor toolbar. Opens a menu of additional items that can be inserted.'
    },
    help: {
        id: 'fabric.editor.help',
        defaultMessage: 'Help',
        description: 'Shown as a menu item label in the editor insert menu, used to open the help dialog where users can browse keyboard shortcuts and markdown options.'
    },
    helpDescription: {
        id: 'fabric.editor.help.description',
        defaultMessage: 'Browse all the keyboard shortcuts and markdown options',
        description: 'Displayed as a description text for the help option in the editor insert menu, explaining that it opens a dialog where users can view all available keyboard shortcuts and markdown formatting options.'
    },
    recordVideo: {
        id: 'fabric.editor.recordVideo',
        defaultMessage: 'Record a Loom video',
        description: 'Shown as a menu item label in the editor insert menu, used to trigger recording a Loom video to embed in the document.'
    },
    addLoomVideo: {
        id: 'fabric.editor.addLoomVideo',
        defaultMessage: 'Record a Loom video',
        description: 'Shown as a button label in the editor toolbar, used to trigger recording a Loom video to add to the document.'
    },
    addLoomVideoComment: {
        id: 'fabric.editor.addLoomVideoComment',
        defaultMessage: 'Record a Loom video comment',
        description: 'Shown as a button label in the editor comment toolbar, used to trigger recording a Loom video comment to attach to the document.'
    },
    recordVideoDescription: {
        id: 'fabric.editor.recordVideo.description',
        defaultMessage: 'Record and share your screen and thoughts',
        description: 'Displayed as a description text for the Loom video recording option in the editor insert menu, explaining that users can record and share their screen and thoughts.'
    },
    recordLoomShortTitle: {
        id: 'fabric.editor.recordLoomShortTitle',
        defaultMessage: 'Record',
        description: 'Shown as a short button label in the editor toolbar for recording a Loom video when space is limited.'
    },
    turnInto: {
        id: 'fabric.editor.turnInto',
        defaultMessage: 'Turn into',
        description: 'Menu option shown when right-clicking or selecting text. Allows users to convert selected text into different element types.'
    }
});

});

parcelRegister("ahEv1", function(module, exports) {
$parcel$export(module.exports, "toolbarMessages", () => $fca7576da23184be$export$81b075fd34c2f0bb);

var $f0Pt4 = parcelRequire("f0Pt4");
const $fca7576da23184be$export$81b075fd34c2f0bb = (0, $f0Pt4.defineMessages)({
    wrapLeft: {
        id: 'fabric.editor.wrapLeft',
        defaultMessage: 'Wrap left',
        description: 'Aligns your image to the left and wraps text around it.'
    },
    wrapRight: {
        id: 'fabric.editor.wrapRight',
        defaultMessage: 'Wrap right',
        description: 'Aligns your image to the right and wraps text around it.'
    },
    changeToMediaSingle: {
        id: 'fabric.editor.media_change_mediasingle',
        defaultMessage: 'Original size',
        description: 'In the context of a media inline image, it allows the user to convert it to media single'
    },
    changeToMediaInlineImage: {
        id: 'fabric.editor.media_change_mediainline_default',
        defaultMessage: 'Inline',
        description: 'In the context of media single contains media node, it allows the user to convert media single to media inline image'
    },
    changeToMediaInlineImageCaptionWarning: {
        id: 'fabric.editor.media_change_mediainline_caption_warn',
        defaultMessage: 'Inline (caption will be removed)',
        description: 'In the context of media single contains media node, it allows the user to convert media single to media inline image and warn user about caption being removed'
    },
    replaceMedia: {
        id: 'fabric.editor.media.replace.non-final',
        defaultMessage: 'Replace',
        description: 'Replaces the source file of the selected image or media while preserving its size, layout, and caption.'
    }
});

});

parcelRegister("1gu5b", function(module, exports) {
$parcel$export(module.exports, "messages", () => $df3dbfc7d1bd51c1$export$defe85febe8b728c);

var $f0Pt4 = parcelRequire("f0Pt4");
const $df3dbfc7d1bd51c1$export$defe85febe8b728c = (0, $f0Pt4.defineMessages)({
    toolbarLabel: {
        id: 'fabric.editor.toolbarLabel',
        defaultMessage: 'Editor',
        description: 'ARIA region landmark label identifying the editor toolbar area to screen reader users.'
    },
    pageActionsLabel: {
        id: 'fabric.editor.pageActionsLabel',
        defaultMessage: 'Page actions',
        description: 'ARIA region landmark label identifying the page actions area (e.g. publish, share) to screen reader users.'
    },
    editableContentLabel: {
        id: 'fabric.editor.editableContentLabel',
        defaultMessage: 'Editable content',
        description: 'ARIA region landmark label identifying the main editable content area of the editor to screen reader users.'
    }
});

});


parcelRegister("aHqLs", function(module, exports) {
$parcel$export(module.exports, "KeyDownHandlerContext", () => $9435d647d0deff12$export$5455406531e3792c);
$parcel$export(module.exports, "ToolbarArrowKeyNavigationProvider", () => $9435d647d0deff12$export$9837e395eba6f527);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $kfANO = parcelRequire("kfANO");

var $1gu5b = parcelRequire("1gu5b");

var $QZWWt = parcelRequire("QZWWt");

var $k7NV2 = parcelRequire("k7NV2");
function $9435d647d0deff12$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9435d647d0deff12$export$5455406531e3792c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createContext({
    handleArrowLeft: ()=>{},
    handleArrowRight: ()=>{},
    handleTab: ()=>{}
});
const $9435d647d0deff12$var$centeredToolbarContainer = {
    name: "1iikq5b",
    styles: "display:flex;width:100%;align-items:center"
};
const $9435d647d0deff12$export$9837e395eba6f527 = ({ children: children, editorView: editorView, childComponentSelector: childComponentSelector, handleEscape: handleEscape, disableArrowKeyNavigation: disableArrowKeyNavigation, isShortcutToFocusToolbar: isShortcutToFocusToolbar, editorAppearance: editorAppearance, useStickyToolbar: useStickyToolbar, intl: intl })=>{
    const wrapperRef = (0, $bSJIT.useRef)(null);
    const selectedItemIndex = (0, $bSJIT.useRef)(0);
    const incrementIndex = (0, $bSJIT.useCallback)((list)=>{
        let index = 0;
        if (document.activeElement) {
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            index = list.indexOf(document.activeElement);
            index = (index + 1) % list.length;
        }
        selectedItemIndex.current = index;
    }, []);
    const decrementIndex = (0, $bSJIT.useCallback)((list)=>{
        let index = 0;
        if (document.activeElement) {
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            index = list.indexOf(document.activeElement);
            index = (list.length + index - 1) % list.length;
        }
        selectedItemIndex.current = index;
    }, []);
    const handleArrowRightMemoized = (0, $bSJIT.useCallback)(()=>{
        var _filteredFocusableEle;
        const filteredFocusableElements = $9435d647d0deff12$var$getFilteredFocusableElements(wrapperRef === null || wrapperRef === void 0 ? void 0 : wrapperRef.current);
        incrementIndex(filteredFocusableElements);
        (_filteredFocusableEle = filteredFocusableElements[selectedItemIndex.current]) === null || _filteredFocusableEle === void 0 || _filteredFocusableEle.focus();
    }, [
        incrementIndex
    ]);
    const handleArrowLeftMemoized = (0, $bSJIT.useCallback)(()=>{
        var _filteredFocusableEle2;
        const filteredFocusableElements = $9435d647d0deff12$var$getFilteredFocusableElements(wrapperRef === null || wrapperRef === void 0 ? void 0 : wrapperRef.current);
        decrementIndex(filteredFocusableElements);
        (_filteredFocusableEle2 = filteredFocusableElements[selectedItemIndex.current]) === null || _filteredFocusableEle2 === void 0 || _filteredFocusableEle2.focus();
    }, [
        decrementIndex
    ]);
    const handleTabMemoized = (0, $bSJIT.useCallback)(()=>{
        var _filteredFocusableEle3;
        const filteredFocusableElements = $9435d647d0deff12$var$getFilteredFocusableElements(wrapperRef === null || wrapperRef === void 0 ? void 0 : wrapperRef.current);
        (_filteredFocusableEle3 = filteredFocusableElements[selectedItemIndex.current]) === null || _filteredFocusableEle3 === void 0 || _filteredFocusableEle3.focus();
    }, []);
    const handleTabLocal = ()=>{
        const filteredFocusableElements = $9435d647d0deff12$var$getFilteredFocusableElements(wrapperRef === null || wrapperRef === void 0 ? void 0 : wrapperRef.current);
        filteredFocusableElements.forEach((element)=>{
            element.setAttribute('tabindex', '-1');
        });
        filteredFocusableElements[selectedItemIndex.current].setAttribute('tabindex', '0');
    };
    const focusAndScrollToElement = (element, scrollToElement = true)=>{
        if (scrollToElement) element === null || element === void 0 || element.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'nearest'
        });
        element.focus();
    };
    const submenuKeydownHandleContext = (0, $bSJIT.useMemo)(()=>({
            handleArrowLeft: handleArrowLeftMemoized,
            handleArrowRight: handleArrowRightMemoized,
            handleTab: handleTabMemoized
        }), [
        handleArrowLeftMemoized,
        handleArrowRightMemoized,
        handleTabMemoized
    ]);
    (0, $bSJIT.useLayoutEffect)(()=>{
        if (!wrapperRef.current || disableArrowKeyNavigation) return;
        const { current: element } = wrapperRef;
        /**
     * To handle the key events on the list
     * @param event
     */ const handleKeyDown = (event)=>{
            var _document$querySelect, _document$querySelect2, _wrapperRef$current, _wrapperRef$current2;
            // To trap the focus inside the horizontal toolbar for left and right arrow keys
            const targetElement = event.target;
            if (targetElement instanceof HTMLElement && !targetElement.closest(`${childComponentSelector}`)) return;
            if (targetElement instanceof HTMLElement && (_document$querySelect = document.querySelector('[data-role="droplistContent"], [data-test-id="color-picker-menu"], [data-emoji-picker-container="true"]')) !== null && _document$querySelect !== void 0 && _document$querySelect.contains(targetElement) || targetElement instanceof HTMLElement && (_document$querySelect2 = document.querySelector('[data-test-id="color-picker-menu"]')) !== null && _document$querySelect2 !== void 0 && _document$querySelect2.contains(targetElement) || targetElement instanceof HTMLElement && targetElement.closest('[data-keyboard-navigation-independent]') || event.key === 'ArrowUp' || event.key === 'ArrowDown' || disableArrowKeyNavigation) return;
            const menuWrapper = document.querySelector('.menu-key-handler-wrapper');
            if (menuWrapper) // if menu wrapper exists, then a menu is open and arrow keys will be handled by MenuArrowKeyNavigationProvider
            return;
            const elementBrowser = wrapperRef === null || wrapperRef === void 0 || (_wrapperRef$current = wrapperRef.current) === null || _wrapperRef$current === void 0 ? void 0 : _wrapperRef$current.querySelector(`#${(0, $kfANO.ELEMENT_BROWSER_ID)}`);
            if (elementBrowser) // if element browser is open, then arrow keys will be handled by MenuArrowKeyNavigationProvider
            return;
            const filteredFocusableElements = $9435d647d0deff12$var$getFilteredFocusableElements(wrapperRef === null || wrapperRef === void 0 ? void 0 : wrapperRef.current);
            if (!filteredFocusableElements || (filteredFocusableElements === null || filteredFocusableElements === void 0 ? void 0 : filteredFocusableElements.length) === 0) return;
            // If the target element is the media picker then navigation is handled by the media picker
            if (targetElement instanceof HTMLElement && targetElement.closest(`[aria-label="${intl.formatMessage((0, $QZWWt.mediaInsertMessages).mediaPickerPopupAriaLabel)}"]`)) return;
            if (targetElement instanceof HTMLElement && !((_wrapperRef$current2 = wrapperRef.current) !== null && _wrapperRef$current2 !== void 0 && _wrapperRef$current2.contains(targetElement))) selectedItemIndex.current = -1;
            else selectedItemIndex.current = targetElement instanceof HTMLElement && filteredFocusableElements.indexOf(targetElement) > -1 ? filteredFocusableElements.indexOf(targetElement) : selectedItemIndex.current;
            // do not scroll to focused element for sticky toolbar when navigating with arrows to avoid unnesessary scroll jump
            const allowScrollToElement = !(editorAppearance === 'comment' && !!useStickyToolbar);
            switch(event.key){
                case 'ArrowRight':
                    incrementIndex(filteredFocusableElements);
                    focusAndScrollToElement(filteredFocusableElements[selectedItemIndex.current], allowScrollToElement);
                    event.preventDefault();
                    break;
                case 'ArrowLeft':
                    decrementIndex(filteredFocusableElements);
                    focusAndScrollToElement(filteredFocusableElements[selectedItemIndex.current], allowScrollToElement);
                    event.preventDefault();
                    break;
                case 'Tab':
                    handleTabLocal();
                    break;
                case 'Escape':
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    handleEscape(event);
                    break;
                default:
            }
        };
        const globalKeyDownHandler = (event)=>{
            // To focus the first element in the toolbar
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            if (isShortcutToFocusToolbar(event)) {
                var _filteredFocusableEle4, _filteredFocusableEle5, _filteredFocusableEle6;
                const filteredFocusableElements = $9435d647d0deff12$var$getFilteredFocusableElements(wrapperRef === null || wrapperRef === void 0 ? void 0 : wrapperRef.current);
                (_filteredFocusableEle4 = filteredFocusableElements[0]) === null || _filteredFocusableEle4 === void 0 || _filteredFocusableEle4.focus();
                // Button component from DS removes focus ring when :focus:not(:focus-visible) is true
                // Since here we programmatically focus the first button in the toolbar (as suppose to keyboard navigation), browser does not always force focus-visible to true
                // which is why the first button in the toolbar is not shown with focus ring
                // The workaround is add a new classname so we add back focus ring when the button is focused
                if (((_filteredFocusableEle5 = filteredFocusableElements[0]) === null || _filteredFocusableEle5 === void 0 ? void 0 : _filteredFocusableEle5.tagName) === 'BUTTON') filteredFocusableElements[0].classList.add('first-floating-toolbar-button');
                (_filteredFocusableEle6 = filteredFocusableElements[0]) === null || _filteredFocusableEle6 === void 0 || _filteredFocusableEle6.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                    inline: 'nearest'
                });
            }
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element === null || element === void 0 || element.addEventListener('keydown', handleKeyDown);
        const editorViewDom = editorView === null || editorView === void 0 ? void 0 : editorView.dom;
        if (isShortcutToFocusToolbar) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        editorViewDom === null || editorViewDom === void 0 || editorViewDom.addEventListener('keydown', globalKeyDownHandler);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element === null || element === void 0 || element.removeEventListener('keydown', handleKeyDown);
            if (isShortcutToFocusToolbar) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            editorViewDom === null || editorViewDom === void 0 || editorViewDom.removeEventListener('keydown', globalKeyDownHandler);
        };
    }, [
        selectedItemIndex,
        wrapperRef,
        editorView,
        disableArrowKeyNavigation,
        handleEscape,
        childComponentSelector,
        incrementIndex,
        decrementIndex,
        isShortcutToFocusToolbar,
        editorAppearance,
        useStickyToolbar,
        intl
    ]);
    return /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        css: editorAppearance === 'comment' && $9435d647d0deff12$var$centeredToolbarContainer,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "custom-key-handler-wrapper",
        ref: wrapperRef,
        role: "toolbar",
        "aria-label": intl.formatMessage((0, $1gu5b.messages).toolbarLabel),
        "aria-controls": (0, $k7NV2.EDIT_AREA_ID)
    }, /*#__PURE__*/ (0, $9dQre.jsx)($9435d647d0deff12$export$5455406531e3792c.Provider, {
        value: submenuKeydownHandleContext
    }, children));
};
function $9435d647d0deff12$var$getFocusableElements(rootNode) {
    if (!rootNode) return [];
    const focusableModalElements = rootNode.querySelectorAll('a[href], button:not([disabled]), textarea, input, select, div[tabindex="-1"], div[tabindex="0"]') || [];
    return Array.from(focusableModalElements);
}
function $9435d647d0deff12$var$isElementOrAncestorHiddenOrDisabled(element, rootNode) {
    let currentElement = element;
    while(currentElement && currentElement !== rootNode && currentElement !== document.body){
        const style = window.getComputedStyle(currentElement);
        // Check if current element is hidden
        if (style.visibility === 'hidden' || style.display === 'none') return true;
        // Check if current element is disabled
        if (currentElement.hasAttribute('disabled') || currentElement.getAttribute('aria-disabled') === 'true' || currentElement.disabled === true) return true;
        // Move to parent element
        currentElement = currentElement.parentElement;
    }
    return false;
}
function $9435d647d0deff12$var$getFilteredFocusableElements(rootNode) {
    // Independent containers and child popups own their key handling and tab stops.
    return $9435d647d0deff12$var$getFocusableElements(rootNode).filter((elm)=>{
        // Check if element or any ancestor is hidden or disabled
        const isHiddenOrDisabled = $9435d647d0deff12$var$isElementOrAncestorHiddenOrDisabled(elm, rootNode);
        return !elm.closest('[data-role="droplistContent"]') && !elm.closest('[data-emoji-picker-container="true"]') && !elm.closest('[data-test-id="color-picker-menu"]') && !elm.closest('[data-keyboard-navigation-independent]') && !elm.closest('.scroll-buttons') && !isHiddenOrDisabled;
    });
}

});
parcelRegister("kfANO", function(module, exports) {
$parcel$export(module.exports, "GRID_SIZE", () => $dd893b281bb60016$export$bc90872e265d166e);
$parcel$export(module.exports, "DEVICE_BREAKPOINT_NUMBERS", () => $dd893b281bb60016$export$1f1798e92fa75806);
$parcel$export(module.exports, "FLEX_ITEMS_CONTAINER_BREAKPOINT_NUMBERS", () => $dd893b281bb60016$export$69bde1b03e8b5224);
$parcel$export(module.exports, "SIDEBAR_WIDTH", () => $dd893b281bb60016$export$780035d9fe48eb32);
$parcel$export(module.exports, "SIDEBAR_HEADING_WRAPPER_HEIGHT", () => $dd893b281bb60016$export$95b62a1773aa5ebe);
$parcel$export(module.exports, "INLINE_SIDEBAR_HEIGHT", () => $dd893b281bb60016$export$51a2d6b2c009fbfd);
$parcel$export(module.exports, "SEARCH_ITEM_HEIGHT_WIDTH", () => $dd893b281bb60016$export$df8bcac60101d466);
$parcel$export(module.exports, "SCROLLBAR_WIDTH", () => $dd893b281bb60016$export$9a6bb2acef5e644a);
$parcel$export(module.exports, "ELEMENT_LIST_PADDING", () => $dd893b281bb60016$export$3b8e93b2c0f295b0);
$parcel$export(module.exports, "ELEMENT_ITEM_HEIGHT", () => $dd893b281bb60016$export$6d221f35db1b75aa);
$parcel$export(module.exports, "ELEMENT_ITEM_PADDING", () => $dd893b281bb60016$export$ab53450bc5fd5b7d);
$parcel$export(module.exports, "ELEMENT_BROWSER_ID", () => $dd893b281bb60016$export$6ee360fa4b93ee8e);
$parcel$export(module.exports, "ELEMENT_BROWSER_LIST_ID", () => $dd893b281bb60016$export$f5c254b5428bf7c6);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ const $dd893b281bb60016$export$bc90872e265d166e = 8;
const $dd893b281bb60016$export$1f1798e92fa75806 = {
    small: $dd893b281bb60016$export$bc90872e265d166e * 40,
    medium: $dd893b281bb60016$export$bc90872e265d166e * 75,
    large: $dd893b281bb60016$export$bc90872e265d166e * 128
};
const $dd893b281bb60016$export$69bde1b03e8b5224 = {
    small: $dd893b281bb60016$export$bc90872e265d166e * 50,
    medium: $dd893b281bb60016$export$1f1798e92fa75806.medium,
    large: $dd893b281bb60016$export$1f1798e92fa75806.large
};
const $dd893b281bb60016$export$780035d9fe48eb32 = `${$dd893b281bb60016$export$bc90872e265d166e * 25}px`;
const $dd893b281bb60016$export$95b62a1773aa5ebe = `${$dd893b281bb60016$export$bc90872e265d166e * 6}px`;
const $dd893b281bb60016$export$387950d54d372827 = '12px';
const $dd893b281bb60016$export$51a2d6b2c009fbfd = '54px';
const $dd893b281bb60016$export$df8bcac60101d466 = '20px';
const $dd893b281bb60016$export$9a6bb2acef5e644a = 15;
const $dd893b281bb60016$export$3b8e93b2c0f295b0 = 2;
const $dd893b281bb60016$export$6d221f35db1b75aa = 60;
const $dd893b281bb60016$export$ab53450bc5fd5b7d = 10;
const $dd893b281bb60016$export$6ee360fa4b93ee8e = 'editor-element-browser';
const $dd893b281bb60016$export$f5c254b5428bf7c6 = 'editor-element-browser-list';

});

parcelRegister("QZWWt", function(module, exports) {
$parcel$export(module.exports, "mediaInsertMessages", () => $0276aa089c49b216$export$7eb9dc59242bbc45);

var $f0Pt4 = parcelRequire("f0Pt4");
const $0276aa089c49b216$export$7eb9dc59242bbc45 = (0, $f0Pt4.defineMessages)({
    loadPreview: {
        id: 'fabric.editor.media.insert.loadPreview',
        defaultMessage: 'Load preview',
        description: 'Text on a button that loads a preview of a media file that has been linked to from a URL'
    },
    insert: {
        id: 'fabric.editor.media.insert.insert',
        defaultMessage: 'Insert',
        description: 'Text on the modal action button that inserts the linked media file into the editor document'
    },
    pasteLinkToUpload: {
        id: 'fabric.editor.media.insert.pasteLinkToUpload',
        defaultMessage: 'Paste link to upload',
        description: 'Placeholder text for the input field where a user can paste (as in copy-paste) a URL to upload a media file'
    },
    cancel: {
        id: 'fabric.editor.media.insert.cancel',
        defaultMessage: 'Cancel',
        description: 'Text on the modal action button that cancels the media file insertion and closes the modal'
    },
    fromUrlErrorMessage: {
        id: 'fabric.editor.media.insert.fromUrlErrorMessage',
        defaultMessage: "Unfortunately, we can\u2019t add this image link. Download the image, then drag and drop onto the page.",
        description: 'Error message displayed when a user tries to insert an image from a URL that cannot be loaded. This may be because the URL is invalid, there is a network error or any other reason the preview upload does not succeed. When this occurs the suggestion is to attempt downloading the linked file manually and using a local upload instead.'
    },
    fromUrlWarning: {
        id: 'fabric.editor.media.insert.fromUrlWarning',
        defaultMessage: 'This image might not be visible to others due to source restrictions. Consider uploading the file instead.',
        description: 'Warning message displayed when a user tries to insert an image from a URL that may not be visible to others due to source restrictions such as not having permissions/authentication to load the image. The suggestion is to upload the file instead.'
    },
    localFileNetworkErrorMessage: {
        id: 'fabric.editor.media.insert.localFileNetworkErrorMessage',
        defaultMessage: 'File upload error. Check file path or network.',
        description: 'Error message displayed when a network error occurs during file upload'
    },
    localFileErrorMessage: {
        id: 'fabric.editor.media.insert.localFileErrorMessage',
        defaultMessage: "This file couldn\u2019t be uploaded.",
        description: 'Generic catch-all error message displayed when file upload fails'
    },
    mediaAlt: {
        id: 'fabric.editor.media.insert.mediaAlt',
        defaultMessage: 'Preview for uploaded image or video file',
        description: 'Alt text describing a preview of an image uploaded.'
    },
    upload: {
        id: 'fabric.editor.media.insert.upload',
        defaultMessage: 'Upload',
        description: 'Text on a button that opens a file picker dialog to upload a media file'
    },
    linkTabTitle: {
        id: 'fabric.editor.media.insert.linkTabTitle',
        defaultMessage: 'Link',
        description: 'Title of the navigation tab that allows users to insert media from a URL or link'
    },
    fileTabTitle: {
        id: 'fabric.editor.media.insert.fileTabTitle',
        defaultMessage: 'File',
        description: 'Title of the navigation tab that allows users to upload local media files'
    },
    generateTabTitle: {
        id: 'fabric.editor.media.insert.generateTabTitle',
        defaultMessage: 'Create',
        description: 'Title of the navigation tab that allows users to generate an image through AI'
    },
    mediaPickerPopupAriaLabel: {
        id: 'fabric.editor.media.insert.mediaPickerPopupAriaLabel',
        defaultMessage: 'Media picker',
        description: 'Accessibility label for the media picker popup'
    },
    invalidUrlErrorMessage: {
        id: 'fabric.editor.media.insert.invalidUrlErrorMessage',
        defaultMessage: 'Invalid link',
        description: 'Error message displayed when a user tries to insert media from an invalid URL'
    },
    uploadTabTitle: {
        id: 'fabric.editor.media.insert.uploadTabTitle',
        defaultMessage: 'Upload',
        description: 'Title of the navigation tab that allows users to upload local media files'
    },
    chooseFile: {
        id: 'fabric.editor.media.insert.chooseFile',
        defaultMessage: 'Choose a file',
        description: 'Text on a button that opens a file picker dialog to choose a local media file'
    }
});

});

parcelRegister("k7NV2", function(module, exports) {
$parcel$export(module.exports, "EDIT_AREA_ID", () => $a7cebd42603f9401$export$b16ce0826b76e795);
const $a7cebd42603f9401$export$b16ce0826b76e795 = 'ak-editor-textarea';

});


parcelRegister("9x1C7", function(module, exports) {
$parcel$export(module.exports, "useSharedPluginState", () => $c5d941b8593a43df$export$a4c4fd90e2b72baa);

var $bSJIT = parcelRequire("bSJIT");

var $inh7J = parcelRequire("inh7J");
/**
 *
 * Directly map object values
 *
 * @param object The object to transform
 * @param mapFunction The function to map an old value to new one
 * @returns Object with the same key but transformed values
 *
 */ function $c5d941b8593a43df$var$mapValues(object, mapFunction) {
    return Object.entries(object).reduce((acc, [key, value])=>({
            ...acc,
            [key]: mapFunction(value)
        }), {});
}
// When we use the `useSharedPluginState` example: `useSharedPluginState(api, ['width'])`
// it will re-render every time the component re-renders as the array "['width']" is seen as an update.
// This hook is used to prevent re-renders due to this.
function $c5d941b8593a43df$var$useStaticPlugins(plugins) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $bSJIT.useMemo)(()=>plugins, []);
}
function $c5d941b8593a43df$export$a4c4fd90e2b72baa(injectionApi, plugins, options) {
    const pluginNames = $c5d941b8593a43df$var$useStaticPlugins(plugins);
    // Create a memoized object containing the named plugins
    const namedExternalPlugins = (0, $bSJIT.useMemo)(()=>pluginNames.reduce((acc, pluginName)=>({
                ...acc,
                [`${String(pluginName)}State`]: injectionApi === null || injectionApi === void 0 ? void 0 : injectionApi[pluginName]
            }), {}), [
        injectionApi,
        pluginNames
    ]);
    return $c5d941b8593a43df$var$useSharedPluginStateInternal(namedExternalPlugins, options);
}
function $c5d941b8593a43df$var$useSharedPluginStateInternal(externalPlugins, options = {}) {
    const [pluginStates, setPluginState] = (0, $bSJIT.useState)($c5d941b8593a43df$var$mapValues(externalPlugins, (value)=>options.disabled ? undefined : value === null || value === void 0 ? void 0 : value.sharedState.currentState()));
    const refStates = (0, $bSJIT.useRef)({});
    const mounted = (0, $bSJIT.useRef)(false);
    (0, $bSJIT.useLayoutEffect)(()=>{
        if (options.disabled) return;
        const debouncedPluginStateUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($inh7J)))(()=>{
            setPluginState((currentPluginStates)=>({
                    ...currentPluginStates,
                    ...refStates.current
                }));
        });
        // If we re-render this hook due to a change in the external
        // plugins we need to push a state update to ensure we have
        // the most current state.
        if (mounted.current) {
            refStates.current = $c5d941b8593a43df$var$mapValues(externalPlugins, (value)=>value === null || value === void 0 ? void 0 : value.sharedState.currentState());
            debouncedPluginStateUpdate();
        }
        const unsubs = Object.entries(externalPlugins).map(([pluginKey, externalPlugin])=>{
            return externalPlugin === null || externalPlugin === void 0 ? void 0 : externalPlugin.sharedState.onChange(({ nextSharedState: nextSharedState, prevSharedState: prevSharedState })=>{
                if (prevSharedState === nextSharedState) return;
                refStates.current[pluginKey] = nextSharedState;
                debouncedPluginStateUpdate();
            });
        });
        mounted.current = true;
        return ()=>{
            refStates.current = {};
            unsubs.forEach((cb)=>cb === null || cb === void 0 ? void 0 : cb());
        };
    // Do not re-render due to state changes, we only need to check this when
    // setting up the initial subscription.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        externalPlugins,
        options.disabled
    ]);
    return pluginStates;
}

});

parcelRegister("LRGCN", function(module, exports) {
$parcel$export(module.exports, "ClickAreaBlock", () => $a17a0544ee6a03ed$export$68468c5dbde37b99);
$parcel$export(module.exports, "default", () => $a17a0544ee6a03ed$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $kpH7k = parcelRequire("kpH7k");

var $ef6dZ = parcelRequire("ef6dZ");
const $a17a0544ee6a03ed$export$68468c5dbde37b99 = ({ editorView: editorView, editorDisabled: editorDisabled, children: children })=>{
    const handleMouseDown = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useCallback((event)=>{
        if (!editorView) return;
        if (!editorDisabled) (0, $kpH7k.clickAreaClickHandler)(editorView, event);
    }, [
        editorView,
        editorDisabled
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $ef6dZ.ClickAreaBlockContainerCompiled), {
        "data-editor-click-wrapper": true,
        "data-testid": "click-wrapper",
        onMouseDown: handleMouseDown,
        // This div is a presentational container that captures mouse events
        // for programmatic editor focus management, not user interaction.
        role: "presentation",
        children: children
    });
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$a17a0544ee6a03ed$export$2e2bcd8739ae039 = $a17a0544ee6a03ed$export$68468c5dbde37b99;

});
parcelRegister("kpH7k", function(module, exports) {
$parcel$export(module.exports, "clickAreaClickHandler", () => $a052ef349ba161f5$export$28b64e3e5a38e8a2);

var $enEa6 = parcelRequire("enEa6");

var $7XybH = parcelRequire("7XybH");

var $gLFdE = parcelRequire("gLFdE");

var $9RcaS = parcelRequire("9RcaS");
// we ignore all of the clicks made inside <div class="ak-editor-content-area" /> (but not clicks on the node itself)
const $a052ef349ba161f5$var$insideContentArea = (ref)=>{
    while(ref){
        if (ref.classList && ref.classList.contains('ak-editor-content-area')) return true;
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        ref = ref.parentNode;
    }
    return false;
};
const $a052ef349ba161f5$var$insideProseMirrorEditableArea = (ref)=>{
    return Boolean(ref === null || ref === void 0 ? void 0 : ref.closest('.ProseMirror'));
};
const $a052ef349ba161f5$export$28b64e3e5a38e8a2 = (view, event)=>{
    var _view$hasFocus, _target$parentElement, _event$currentTarget, _event$currentTarget2;
    const isEditorFocused = !!(view !== null && view !== void 0 && (_view$hasFocus = view.hasFocus) !== null && _view$hasFocus !== void 0 && _view$hasFocus.call(view));
    if (!(event.target instanceof HTMLElement)) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const target = event.target;
    const isTargetContentArea = target === null || target === void 0 ? void 0 : target.classList.contains('ak-editor-content-area');
    const isTargetChildOfContentArea = $a052ef349ba161f5$var$insideContentArea((target === null || target === void 0 ? void 0 : target.parentNode) instanceof HTMLElement ? target === null || target === void 0 ? void 0 : target.parentNode : null);
    const isTargetInsideEditableArea = $a052ef349ba161f5$var$insideProseMirrorEditableArea(target);
    // Any click inside ProseMirror should be managed by ProseMirror
    if (isTargetInsideEditableArea) return false;
    const isEventComingFromContentArea = Boolean(event.currentTarget.querySelector('.ak-editor-content-area'));
    // @see https://product-fabric.atlassian.net/browse/ED-4287
    // click event gets triggered twice on a checkbox (on <label> first and then on <input>)
    // by the time it gets triggered on input, PM already re-renders nodeView and detaches it from DOM
    // which doesn't pass the check !contentArea.contains(event.target)
    const isInputClicked = (target === null || target === void 0 ? void 0 : target.nodeName) === 'INPUT';
    // @see ED-5126
    const isPopupClicked = !!(0, $enEa6.closestElement)(target, '[data-editor-popup]');
    // Fixes issue when using a textarea for editor title in full page editor doesn't let user focus it.
    const isTextAreaClicked = (target === null || target === void 0 ? void 0 : target.nodeName) === 'TEXTAREA';
    const isBreadcrumbClicked = !!(0, $enEa6.closestElement)(target, 'nav[aria-label="Breadcrumbs"]');
    const selection = window.getSelection();
    const isEditorPopupTextSelected = (selection === null || selection === void 0 ? void 0 : selection.type) === 'Range' && // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    (0, $enEa6.closestElement)(selection === null || selection === void 0 ? void 0 : selection.anchorNode, '[data-editor-popup]');
    // For clicks directly on the content component -- they should not be ignored
    const isContentComponent = target === null || target === void 0 || (_target$parentElement = target.parentElement) === null || _target$parentElement === void 0 ? void 0 : _target$parentElement.closest(`[${(0, $gLFdE.ignoreAttribute)}]`);
    // This is a super workaround to find when events are coming from Confluence InlineComment modal
    // We don't own those components, so we can't change them
    const isEventComingFromInlineCommentPopup = Boolean((0, $enEa6.closestElement)(event.currentTarget, 'div[offset]')) || Boolean((0, $enEa6.closestElement)(target, 'div[offset]'));
    const isAnchorButtonClicked = Boolean((0, $enEa6.closestElement)(event.currentTarget, 'a')) || Boolean((0, $enEa6.closestElement)(target, 'a')) || ((_event$currentTarget = event.currentTarget) === null || _event$currentTarget === void 0 ? void 0 : _event$currentTarget.nodeName) === 'A' || (target === null || target === void 0 ? void 0 : target.nodeName) === 'A';
    const isButtonClicked = Boolean((0, $enEa6.closestElement)(event.currentTarget, 'button')) || Boolean((0, $enEa6.closestElement)(target, 'button')) || ((_event$currentTarget2 = event.currentTarget) === null || _event$currentTarget2 === void 0 ? void 0 : _event$currentTarget2.nodeName) === 'BUTTON' || (target === null || target === void 0 ? void 0 : target.nodeName) === 'BUTTON' || isAnchorButtonClicked;
    const isTargetInsideContentArea = Boolean(isTargetChildOfContentArea);
    const isBetweenContentAreaAndEditableContent = isTargetInsideContentArea && !isTargetInsideEditableArea;
    // Column Picker dropdown in Datasources table
    const isDatasourcePopupClicked = !!(target !== null && target !== void 0 && target.closest('#column-picker-popup'));
    const edgeCaseScenario1 = (isBetweenContentAreaAndEditableContent || !isEventComingFromContentArea) && !isEditorFocused;
    const edgeCaseScenario2 = !isTargetInsideContentArea && isEditorFocused;
    const edgeCaseScenario3 = isTargetContentArea && !isTargetInsideContentArea && !isEditorFocused;
    const edgeCaseScenario4 = isEventComingFromContentArea && !isTargetContentArea && !isTargetInsideContentArea && !isEditorFocused;
    const edgeCases = edgeCaseScenario1 || edgeCaseScenario2 || edgeCaseScenario3 || edgeCaseScenario4;
    const isClickOutsideEditor = edgeCases && !isDatasourcePopupClicked && !isEventComingFromInlineCommentPopup && !isButtonClicked && !isInputClicked && !isTextAreaClicked && !isPopupClicked && !isBreadcrumbClicked && !isEditorPopupTextSelected && !isContentComponent && (0, $7XybH.checkForModal)(target);
    // click was within editor container and focus should be brought to input
    if (isClickOutsideEditor && view) (0, $9RcaS.outsideProsemirrorEditorClickHandler)(view, event);
};

});
parcelRegister("enEa6", function(module, exports) {
$parcel$export(module.exports, "closest", () => $154e405e8dd80413$export$ff7f7c97cdce86e);
$parcel$export(module.exports, "closestElement", () => $154e405e8dd80413$export$d508bcfb7f019487);
$parcel$export(module.exports, "mapElem", () => $154e405e8dd80413$export$b2d5d4f1aeebddf1);
$parcel$export(module.exports, "maphElem", () => $154e405e8dd80413$export$5b6ab01a6efa50e2);





function $154e405e8dd80413$export$ff7f7c97cdce86e(node, s) {
    if (!node) return null;
    let el = node;
    if (!document.documentElement || !document.documentElement.contains(el)) return null;
    if (el.closest) return el.closest(s);
    do {
        const matchfn = el.matches ? el.matches : el.msMatchesSelector;
        if (matchfn && matchfn.call(el, s)) // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        return el;
        el = el.parentElement || el.parentNode;
    }while (el !== null && el.nodeType === 1);
    return null;
}
function $154e405e8dd80413$export$d508bcfb7f019487(node, s) {
    return $154e405e8dd80413$export$ff7f7c97cdce86e(node, s);
}
function $154e405e8dd80413$export$b2d5d4f1aeebddf1(elem, callback) {
    const array = [];
    for(let i = 0; i < elem.childElementCount; i++)array.push(callback(elem.children[i], i, elem));
    return array;
}
function $154e405e8dd80413$export$5b6ab01a6efa50e2(elem, callback) {
    return $154e405e8dd80413$export$b2d5d4f1aeebddf1(elem, callback);
}

});

parcelRegister("7XybH", function(module, exports) {
$parcel$export(module.exports, "checkForModal", () => $46c5b8551ee95155$export$79ba7abfc5f47a65);
/**
 * @see ED-14699 - check if editor is inside a modal to continue to bring cursor to input when
 * any part of the editor container is clicked
 *
 * Handles two cases when a click event is fired:
 *
 * 1. if editor (e.g. comment inside of Jira ticket view) is inside modal then ensure focus and cursor is brought to the input
 * 2. if another modal is open (e.g. delete confirmation modal for confluence table) then ignore clicks as they shouldn't influence editor state
 */ const $46c5b8551ee95155$export$79ba7abfc5f47a65 = (target)=>{
    const modalDialog = target === null || target === void 0 ? void 0 : target.closest('[role=dialog]');
    if (modalDialog) // return false if not an editor inside modal, otherwise return true
    return !!(modalDialog !== null && modalDialog !== void 0 && modalDialog.querySelector('.akEditor'));
    // no modal present so we can return true
    return true;
};

});

parcelRegister("gLFdE", function(module, exports) {
$parcel$export(module.exports, "ignoreAttribute", () => $8477cc1f225b50b9$export$72d101e93c081651);
$parcel$export(module.exports, "contentComponentClickWrapper", () => $8477cc1f225b50b9$export$57a965c23051130d);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");
const $8477cc1f225b50b9$export$72d101e93c081651 = 'data-editor-content-component';
const $8477cc1f225b50b9$export$57a965c23051130d = (reactComponents)=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        "data-editor-content-component": 'true',
        children: reactComponents
    });
};

});

parcelRegister("9RcaS", function(module, exports) {
$parcel$export(module.exports, "outsideProsemirrorEditorClickHandler", () => $5e7862ae2d2d847a$export$c5a7a653c4681bfd);

var $gZj5p = parcelRequire("gZj5p");

var $bq0hv = parcelRequire("bq0hv");

var $8JwHE = parcelRequire("8JwHE");
const $5e7862ae2d2d847a$export$c5a7a653c4681bfd = (view, event)=>{
    var _view$hasFocus;
    const { dispatch: dispatch, dom: dom, state: state } = view;
    const { tr: tr } = state;
    const isEditorFocused = !!(view !== null && view !== void 0 && (_view$hasFocus = view.hasFocus) !== null && _view$hasFocus !== void 0 && _view$hasFocus.call(view));
    const isBottomAreaClicked = event.clientY > dom.getBoundingClientRect().bottom;
    if (isBottomAreaClicked) {
        tr.setMeta('outsideProsemirrorEditorClicked', true);
        (0, $bq0hv.addParagraphAtEnd)(tr);
    }
    (0, $8JwHE.setSelectionTopLevelBlocks)(tr, event, // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    dom, view.posAtCoords.bind(view), isEditorFocused);
    (0, $gZj5p.tintDirtyTransaction)(tr);
    if (!tr.docChanged && !tr.selectionSet) return;
    if (dispatch) dispatch(tr);
    view.focus();
    event.preventDefault();
};

});
parcelRegister("gZj5p", function(module, exports) {
$parcel$export(module.exports, "TELEPOINTER_DIM_CLASS", () => $29d461a1bd1b9e31$export$75f1e2b0ae2c8197);
$parcel$export(module.exports, "TELEPOINTER_PULSE_CLASS", () => $29d461a1bd1b9e31$export$44ee82a2b1106d13);
$parcel$export(module.exports, "TELEPOINTER_PULSE_DURING_TR_CLASS", () => $29d461a1bd1b9e31$export$15875d5e8ce4fd42);
$parcel$export(module.exports, "TELEPOINTER_PULSE_DURING_TR_DURATION_MS", () => $29d461a1bd1b9e31$export$cea3f62f94f5fdf0);
$parcel$export(module.exports, "TELEPOINTER_DATA_SESSION_ID_ATTR", () => $29d461a1bd1b9e31$export$74788e2dc4d9be50);
$parcel$export(module.exports, "isDirtyTransaction", () => $29d461a1bd1b9e31$export$c500b1bc696a0abc);
$parcel$export(module.exports, "tintDirtyTransaction", () => $29d461a1bd1b9e31$export$f25182515d14d793);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ /* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ 
var $9dQre = parcelRequire("9dQre");

var $5bbjm = parcelRequire("5bbjm");

var $bDsJN = parcelRequire("bDsJN");
var $29d461a1bd1b9e31$export$54cb529986e2487b = /*#__PURE__*/ function(PROVIDER_ERROR_CODE) {
    PROVIDER_ERROR_CODE["NO_PERMISSION_ERROR"] = "NO_PERMISSION_ERROR";
    PROVIDER_ERROR_CODE["INVALID_USER_TOKEN"] = "INVALID_USER_TOKEN";
    PROVIDER_ERROR_CODE["DOCUMENT_NOT_FOUND"] = "DOCUMENT_NOT_FOUND";
    PROVIDER_ERROR_CODE["LOCKED"] = "LOCKED";
    PROVIDER_ERROR_CODE["DOCUMENT_BLOCKED"] = "DOCUMENT_BLOCKED";
    PROVIDER_ERROR_CODE["FAIL_TO_SAVE"] = "FAIL_TO_SAVE";
    PROVIDER_ERROR_CODE["DOCUMENT_RESTORE_ERROR"] = "DOCUMENT_RESTORE_ERROR";
    PROVIDER_ERROR_CODE["INITIALISATION_ERROR"] = "INITIALISATION_ERROR";
    PROVIDER_ERROR_CODE["NETWORK_ISSUE"] = "NETWORK_ISSUE";
    PROVIDER_ERROR_CODE["INVALID_PROVIDER_CONFIGURATION"] = "INVALID_PROVIDER_CONFIGURATION";
    PROVIDER_ERROR_CODE["INTERNAL_SERVICE_ERROR"] = "INTERNAL_SERVICE_ERROR";
    PROVIDER_ERROR_CODE["DOCUMENT_UPDATE_ERROR"] = "DOCUMENT_UPDATE_ERROR";
    return PROVIDER_ERROR_CODE;
}({});
var $29d461a1bd1b9e31$export$258d16488300d83f = /*#__PURE__*/ function(DisconnectReason) {
    DisconnectReason["CLIENT_DISCONNECT"] = "CLIENT_DISCONNECT";
    DisconnectReason["SERVER_DISCONNECT"] = "SERVER_DISCONNECT";
    DisconnectReason["SOCKET_CLOSED"] = "SOCKET_CLOSED";
    DisconnectReason["SOCKET_ERROR"] = "SOCKET_ERROR";
    DisconnectReason["SOCKET_TIMEOUT"] = "SOCKET_TIMEOUT";
    DisconnectReason["UNKNOWN_DISCONNECT"] = "UNKNOWN_DISCONNECT";
    return DisconnectReason;
}({});
const $29d461a1bd1b9e31$var$telepointerColorStyle = (backgroundColor, textColor, index)=>{
    const { colorMode: colorMode } = (0, $bDsJN.getGlobalTheme)();
    const backgroundStyle = colorMode === 'dark' ? `linear-gradient(to bottom, ${backgroundColor} -800000%, transparent 200000%)` : `linear-gradient(to bottom, ${backgroundColor} -850000%, transparent 150000%)`;
    return `
    &.color-${index} {
      background: ${backgroundStyle};
      &::after {
        background-color: ${backgroundColor};
        color: ${textColor};
        border-color: ${backgroundColor};
      }
    }
  `;
};
const $29d461a1bd1b9e31$export$75f1e2b0ae2c8197 = 'telepointer-dim';
const $29d461a1bd1b9e31$export$44ee82a2b1106d13 = 'telepointer-pulse-animate';
const $29d461a1bd1b9e31$export$15875d5e8ce4fd42 = 'telepointer-pulse-during-tr';
const $29d461a1bd1b9e31$export$cea3f62f94f5fdf0 = 7500; // Keeping it longer so it'll be easier to spot during transactions
const $29d461a1bd1b9e31$export$74788e2dc4d9be50 = 'data-telepointer-sessionid';
const $29d461a1bd1b9e31$export$c94087d6ea5127ad = /*#__PURE__*/ (0, $9dQre.css)("@keyframes pulseIn{0%,100%{transform:scaleX(0);opacity:0;}10%{transform:scaleX(1.4);opacity:1;}15%,85%{transform:scaleX(1);opacity:1;}}@keyframes pulseOut{0%,90%,100%{transform:scaleX(1);opacity:1;}10%,80%{transform:scaleX(0);opacity:0;}}@keyframes pulseInDuringTr{0%,95%{transform:scaleX(1);opacity:1;}100%{transform:scaleX(0);opacity:0;}}@keyframes pulseOutDuringTr{100%{transform:scaleX(1);opacity:1;}0%,90%{transform:scaleX(0);opacity:0;}}.ProseMirror .telepointer{position:relative;transition:opacity 200ms;", (0, $5bbjm.participantColors).map((participantColor, index)=>$29d461a1bd1b9e31$var$telepointerColorStyle(participantColor.backgroundColor, participantColor.textColor, index)), ";&.telepointer-selection:not(.inlineNodeView){line-height:1.2;pointer-events:none;user-select:none;}&.telepointer-selection-badge{.telepointer-initial,.telepointer-fullname{position:absolute;display:block;user-select:none;white-space:pre;top:-14px;left:0px;font:var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);padding-left:var(--ds-space-050, 4px);padding-right:var(--ds-space-050, 4px);border-radius:0 2px 2px 0;}.telepointer-initial{opacity:1;transition:opacity 0.15s ease-out;}.telepointer-fullname{opacity:0;transform:scaleX(0);transform-origin:top left;transition:transform 0.15s ease-out,opacity 0.15s ease-out;}}&.", $29d461a1bd1b9e31$export$44ee82a2b1106d13, "{.telepointer-initial{animation:pulseOut 2.5s ease-in-out;}.telepointer-fullname{animation:pulseIn 2.5s ease-in-out;}}&.", $29d461a1bd1b9e31$export$15875d5e8ce4fd42, "{.telepointer-initial{animation:pulseOutDuringTr ", $29d461a1bd1b9e31$export$cea3f62f94f5fdf0, "ms ease-in-out;}.telepointer-fullname{animation:pulseInDuringTr ", $29d461a1bd1b9e31$export$cea3f62f94f5fdf0, "ms ease-in-out;}}&:hover{.telepointer-initial{opacity:0;transition-delay:150ms;}.telepointer-fullname{transform:scaleX(1);opacity:1;z-index:1;}}&.", $29d461a1bd1b9e31$export$75f1e2b0ae2c8197, "{opacity:0.2;}}");
const $29d461a1bd1b9e31$var$tintKey = 'collab:isDirtyTransaction';
const $29d461a1bd1b9e31$export$c500b1bc696a0abc = (tr)=>{
    return Boolean(tr.getMeta($29d461a1bd1b9e31$var$tintKey));
};
const $29d461a1bd1b9e31$export$f25182515d14d793 = (tr)=>{
    tr.setMeta($29d461a1bd1b9e31$var$tintKey, true);
};

});

parcelRegister("bq0hv", function(module, exports) {
$parcel$export(module.exports, "addParagraphAtEnd", () => $b59e17215e41f77f$export$fc18809329b5ff08);
$parcel$export(module.exports, "changeImageAlignment", () => $b59e17215e41f77f$export$774cc08dd90b6a6a);
$parcel$export(module.exports, "changeImageAlignmentNext", () => $b59e17215e41f77f$export$b637dda807357427);
$parcel$export(module.exports, "createToggleBlockMarkOnRange", () => $b59e17215e41f77f$export$1115c4cf51ae1924);
$parcel$export(module.exports, "createToggleBlockMarkOnRangeNext", () => $b59e17215e41f77f$export$8614a16deba8906f);
$parcel$export(module.exports, "createToggleInlineMarkOnRange", () => $b59e17215e41f77f$export$a10bb5a1a10022f6);
$parcel$export(module.exports, "toggleBlockMark", () => $b59e17215e41f77f$export$72d6145976985e8c);
$parcel$export(module.exports, "toggleBlockMarkNext", () => $b59e17215e41f77f$export$23f118e134ed2228);
$parcel$export(module.exports, "findCutBefore", () => $b59e17215e41f77f$export$ad1078cb3917e860);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $cw0wu = parcelRequire("cw0wu");

var $2E7OD = parcelRequire("2E7OD");

function $b59e17215e41f77f$export$fc18809329b5ff08(tr) {
    const { doc: { type: { schema: { nodes: { paragraph: paragraph } } } }, doc: doc } = tr;
    if (doc.lastChild && !(doc.lastChild.type === paragraph && doc.lastChild.content.size === 0)) {
        if (paragraph) tr.insert(doc.content.size, paragraph.createAndFill());
    }
    tr.setSelection((0, $cw0wu.TextSelection).create(tr.doc, tr.doc.content.size - 1));
    tr.scrollIntoView();
}
function $b59e17215e41f77f$export$2864da03fd603a92() {
    return function(state, dispatch) {
        const { tr: tr } = state;
        $b59e17215e41f77f$export$fc18809329b5ff08(tr);
        if (dispatch) dispatch(tr);
        return true;
    };
}
const $b59e17215e41f77f$export$774cc08dd90b6a6a = (align)=>(state, dispatch)=>{
        const { from: from, to: to } = state.selection;
        const tr = state.tr;
        state.doc.nodesBetween(from, to, (node, pos)=>{
            if (node.type === state.schema.nodes.mediaSingle) tr.setNodeMarkup(pos, undefined, {
                ...node.attrs,
                layout: align === 'center' ? 'center' : `align-${align}`
            });
        });
        if (tr.docChanged && dispatch) {
            dispatch(tr.scrollIntoView());
            return true;
        }
        return false;
    };
const $b59e17215e41f77f$export$b637dda807357427 = (align)=>(tr)=>{
        const { from: from, to: to } = tr.selection;
        const initialDoc = tr.doc;
        tr.doc.nodesBetween(from, to, (node, pos)=>{
            if (node.type === tr.doc.type.schema.nodes.mediaSingle) tr.setNodeMarkup(pos, undefined, {
                ...node.attrs,
                layout: align === 'center' ? 'center' : `align-${align}`
            });
        });
        // compare tr.doc with initialDoc instead of tr.docChanged
        // because tr passed in might have been modified prior this function
        // e.g. see changeAlignmentTr platform/packages/editor/editor-plugin-alignment/src/editor-commands/index.ts:L197
        if (!tr.doc.eq(initialDoc)) {
            tr.scrollIntoView();
            return true;
        }
        return false;
    };
const $b59e17215e41f77f$export$1115c4cf51ae1924 = (markType, getAttrs, allowedBlocks)=>(from, to, tr, state)=>{
        let markApplied = false;
        state.doc.nodesBetween(from, to, (node, pos, parent)=>{
            var _state$schema, _state$schema2, _state$schema3;
            if (!node.type.isBlock) return false;
            const parentAllowsMark = state !== null && state !== void 0 && (_state$schema = state.schema) !== null && _state$schema !== void 0 && (_state$schema = _state$schema.nodes) !== null && _state$schema !== void 0 && _state$schema.blockTaskItem && (parent === null || parent === void 0 ? void 0 : parent.type) === (state === null || state === void 0 || (_state$schema2 = state.schema) === null || _state$schema2 === void 0 || (_state$schema2 = _state$schema2.nodes) === null || _state$schema2 === void 0 ? void 0 : _state$schema2.blockTaskItem) && markType === (state === null || state === void 0 || (_state$schema3 = state.schema) === null || _state$schema3 === void 0 || (_state$schema3 = _state$schema3.marks) === null || _state$schema3 === void 0 ? void 0 : _state$schema3.indentation) ? false : parent === null || parent === void 0 ? void 0 : parent.type.allowsMarkType(markType);
            if ((!allowedBlocks || (Array.isArray(allowedBlocks) ? allowedBlocks.indexOf(node.type) > -1 : allowedBlocks(state.schema, node, parent))) && parentAllowsMark) {
                const oldMarks = node.marks.filter((mark)=>mark.type === markType);
                const prevAttrs = oldMarks.length ? oldMarks[0].attrs : undefined;
                const newAttrs = getAttrs(prevAttrs, node);
                if (newAttrs !== undefined) {
                    tr.setNodeMarkup(pos, node.type, node.attrs, node.marks.filter((mark)=>!markType.excludes(mark.type)).concat(newAttrs === false ? [] : markType.create(newAttrs)));
                    markApplied = true;
                }
            }
            return;
        });
        return markApplied;
    };
const $b59e17215e41f77f$export$8614a16deba8906f = (markType, getAttrs, allowedBlocks)=>(from, to, tr)=>{
        let markApplied = false;
        tr.doc.nodesBetween(from, to, (node, pos, parent)=>{
            var _schema$nodes, _schema$nodes2, _schema$marks;
            if (!node.type.isBlock) return false;
            const schema = tr.doc.type.schema;
            const parentAllowsMark = schema !== null && schema !== void 0 && (_schema$nodes = schema.nodes) !== null && _schema$nodes !== void 0 && _schema$nodes.blockTaskItem && (parent === null || parent === void 0 ? void 0 : parent.type) === (schema === null || schema === void 0 || (_schema$nodes2 = schema.nodes) === null || _schema$nodes2 === void 0 ? void 0 : _schema$nodes2.blockTaskItem) && markType === (schema === null || schema === void 0 || (_schema$marks = schema.marks) === null || _schema$marks === void 0 ? void 0 : _schema$marks.indentation) ? false : parent === null || parent === void 0 ? void 0 : parent.type.allowsMarkType(markType);
            if ((!allowedBlocks || (Array.isArray(allowedBlocks) ? allowedBlocks.indexOf(node.type) > -1 : allowedBlocks(tr.doc.type.schema, node, parent))) && parentAllowsMark) {
                const oldMarks = node.marks.filter((mark)=>mark.type === markType);
                const prevAttrs = oldMarks.length ? oldMarks[0].attrs : undefined;
                const newAttrs = getAttrs(prevAttrs, node);
                if (newAttrs !== undefined) {
                    tr.setNodeMarkup(pos, node.type, node.attrs, node.marks.filter((mark)=>!markType.excludes(mark.type)).concat(newAttrs === false ? [] : markType.create(newAttrs)));
                    markApplied = true;
                }
            }
            return;
        });
        return markApplied;
    };
const $b59e17215e41f77f$export$a10bb5a1a10022f6 = (markType, getAttrs)=>(from, to, tr, state)=>{
        let markApplied = false;
        state.doc.nodesBetween(from, to, (node, pos, parent)=>{
            if (parent !== null && parent !== void 0 && parent.type.allowsMarkType(markType)) {
                const oldMarks = node.marks.filter((mark)=>mark.type === markType);
                const prevAttrs = oldMarks.length ? oldMarks[0].attrs : undefined;
                const newAttrs = getAttrs(prevAttrs, node);
                if (newAttrs !== undefined) {
                    tr.setNodeMarkup(pos, node.type, node.attrs, node.marks.filter((mark)=>!markType.excludes(mark.type)).concat(newAttrs === false ? [] : markType.create(newAttrs)));
                    tr.setSelection((0, $cw0wu.NodeSelection).create(tr.doc, state.selection.from));
                    markApplied = true;
                }
            }
            return;
        });
        return markApplied;
    };
const $b59e17215e41f77f$export$72d6145976985e8c = (markType, getAttrs, allowedBlocks)=>(state, dispatch)=>{
        let markApplied = false;
        const tr = state.tr;
        const toggleBlockMarkOnRange = $b59e17215e41f77f$export$1115c4cf51ae1924(markType, getAttrs, allowedBlocks);
        if (state.selection instanceof (0, $2E7OD.CellSelection)) state.selection.forEachCell((cell, pos)=>{
            markApplied = toggleBlockMarkOnRange(pos, pos + cell.nodeSize, tr, state);
        });
        else {
            const { from: from, to: to } = state.selection;
            markApplied = toggleBlockMarkOnRange(from, to, tr, state);
        }
        if (markApplied && tr.docChanged) {
            if (dispatch) dispatch(tr.scrollIntoView());
            return true;
        }
        return false;
    };
const $b59e17215e41f77f$export$23f118e134ed2228 = (markType, getAttrs, allowedBlocks)=>(tr)=>{
        let markApplied = false;
        const toggleBlockMarkOnRange = $b59e17215e41f77f$export$8614a16deba8906f(markType, getAttrs, allowedBlocks);
        const initialDoc = tr.doc;
        const { selection: selection } = tr;
        if (selection instanceof (0, $2E7OD.CellSelection)) selection.forEachCell((cell, pos)=>{
            markApplied = toggleBlockMarkOnRange(pos, pos + cell.nodeSize, tr);
        });
        else {
            const { from: from, to: to } = selection;
            markApplied = toggleBlockMarkOnRange(from, to, tr);
        }
        // compare tr.doc with initialDoc instead of tr.docChanged
        // because tr passed in might have been modified prior this function
        // e.g. see changeAlignmentTr platform/packages/editor/editor-plugin-alignment/src/editor-commands/index.ts:L197
        if (markApplied && !initialDoc.eq(tr.doc)) {
            tr.scrollIntoView();
            return true;
        }
        return false;
    };
const $b59e17215e41f77f$export$59c0bf8874edecc7 = (state, dispatch)=>{
    const tr = state.tr;
    tr.replace(0, state.doc.nodeSize - 2);
    tr.setSelection((0, $cw0wu.Selection).atStart(tr.doc));
    if (dispatch) {
        dispatch(tr);
        return true;
    }
    return false;
};
function $b59e17215e41f77f$export$ad1078cb3917e860($pos) {
    // parent is non-isolating, so we can look across this boundary
    if (!$pos.parent.type.spec.isolating) // search up the tree from the pos's *parent*
    for(let i = $pos.depth - 1; i >= 0; i--){
        // starting from the inner most node's parent, find out
        // if we're not its first child
        if ($pos.index(i) > 0) return $pos.doc.resolve($pos.before(i + 1));
        if ($pos.node(i).type.spec.isolating) break;
    }
    return null;
}
function $b59e17215e41f77f$export$c6a04dca1ed03a3c(level) {
    return function(state, dispatch) {
        const { selection: selection, schema: schema, tr: tr } = state;
        const ranges = selection instanceof (0, $2E7OD.CellSelection) ? selection.ranges : [
            selection
        ];
        ranges.forEach(({ $from: $from, $to: $to })=>{
            tr.setBlockType($from.pos, $to.pos, schema.nodes.heading, {
                level: level
            });
        });
        if (dispatch) dispatch(tr);
        return true;
    };
}

});

parcelRegister("8JwHE", function(module, exports) {
$parcel$export(module.exports, "setSelectionTopLevelBlocks", () => $6904f229af68e67a$export$1b305efb24649ca5);
$parcel$export(module.exports, "setGapCursorAtPos", () => $6904f229af68e67a$export$44fdd7840a0a11f2);

var $cw0wu = parcelRequire("cw0wu");

var $j7pt0 = parcelRequire("j7pt0");

var $8t2a4 = parcelRequire("8t2a4");

var $7jXHH = parcelRequire("7jXHH");
// This function captures clicks outside of the ProseMirror contentEditable area
// see also description of "handleClick" in gap-cursor pm-plugin
const $6904f229af68e67a$var$captureCursorCoords = (event, editorRef, posAtCoords, tr)=>{
    const rect = editorRef.getBoundingClientRect();
    // capture clicks before the first block element
    if (event.clientY < rect.top) return {
        position: 0,
        side: (0, $8t2a4.Side).LEFT
    };
    if (rect.left > 0) {
        // calculate start position of a node that is vertically at the same level
        const coords = posAtCoords({
            left: rect.left,
            top: event.clientY
        });
        if (coords && coords.inside > -1) {
            const $from = tr.doc.resolve(coords.inside);
            const start = $from.before(1);
            const side = event.clientX < rect.left ? (0, $8t2a4.Side).LEFT : (0, $8t2a4.Side).RIGHT;
            let position;
            if (side === (0, $8t2a4.Side).LEFT) position = start;
            else {
                const node = tr.doc.nodeAt(start);
                if (node) position = start + node.nodeSize;
            }
            return {
                position: position,
                side: side
            };
        }
    }
    return null;
};
const $6904f229af68e67a$export$1b305efb24649ca5 = (tr, event, editorRef, posAtCoords, editorFocused)=>{
    const cursorCoords = $6904f229af68e67a$var$captureCursorCoords(event, editorRef, posAtCoords, tr);
    if (!cursorCoords) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const $pos = cursorCoords.position !== undefined ? tr.doc.resolve(cursorCoords.position) : null;
    if ($pos === null) return;
    const isGapCursorAllowed = cursorCoords.side === (0, $8t2a4.Side).LEFT ? (0, $7jXHH.isValidTargetNode)($pos.nodeAfter) : (0, $7jXHH.isValidTargetNode)($pos.nodeBefore);
    if (isGapCursorAllowed && (0, $j7pt0.GapCursorSelection).valid($pos)) {
        // this forces PM to re-render the decoration node if we change the side of the gap cursor, it doesn't do it by default
        if (tr.selection instanceof (0, $j7pt0.GapCursorSelection)) tr.setSelection((0, $cw0wu.Selection).near($pos));
        else tr.setSelection(new (0, $j7pt0.GapCursorSelection)($pos, cursorCoords.side));
    } else if (editorFocused === false) {
        const selectionTemp = (0, $cw0wu.Selection).findFrom($pos, cursorCoords.side === (0, $8t2a4.Side).LEFT ? 1 : -1, true);
        if (selectionTemp) tr.setSelection(selectionTemp);
    }
};
const $6904f229af68e67a$export$44fdd7840a0a11f2 = (position, side = (0, $8t2a4.Side).LEFT)=>(state, dispatch)=>{
        // @see ED-6231
        if (position > state.doc.content.size) return false;
        const $pos = state.doc.resolve(position);
        if ((0, $j7pt0.GapCursorSelection).valid($pos)) {
            if (dispatch) dispatch(state.tr.setSelection(new (0, $j7pt0.GapCursorSelection)($pos, side)));
            return true;
        }
        return false;
    };

});
parcelRegister("j7pt0", function(module, exports) {
$parcel$export(module.exports, "JSON_ID", () => $1313b7c28e2d8ecb$export$d9f9f34e18094ffd);
$parcel$export(module.exports, "GapCursorSelection", () => $1313b7c28e2d8ecb$export$7d98c58ca1423246);

var $kW8qW = parcelRequire("kW8qW");

var $cw0wu = parcelRequire("cw0wu");

var $8t2a4 = parcelRequire("8t2a4");

var $7jXHH = parcelRequire("7jXHH");
const $1313b7c28e2d8ecb$export$d9f9f34e18094ffd = 'gapcursor';
class $1313b7c28e2d8ecb$export$7d98c58ca1423246 extends (0, $cw0wu.Selection) {
    /**
   * Construct a GapCursorSelection
   * @param {ResolvedPos} $pos resolved position
   * @param {Side} side side where the gap cursor is drawn
   */ constructor($pos, side = (0, $8t2a4.Side).LEFT){
        super($pos, $pos), this.side = side, this.visible = false;
    }
    static valid($pos) {
        const { parent: parent, nodeBefore: nodeBefore, nodeAfter: nodeAfter } = $pos;
        const targetNode = (0, $7jXHH.isValidTargetNode)(nodeBefore) ? nodeBefore : (0, $7jXHH.isValidTargetNode)(nodeAfter) ? nodeAfter : null;
        if (!targetNode || parent.isTextblock) return false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const deflt = parent.contentMatchAt($pos.index()).defaultType;
        return deflt && deflt.isTextblock;
    }
    static findFrom($pos, dir, mustMove = false) {
        const side = dir === 1 ? (0, $8t2a4.Side).RIGHT : (0, $8t2a4.Side).LEFT;
        if (!mustMove && $1313b7c28e2d8ecb$export$7d98c58ca1423246.valid($pos)) return new $1313b7c28e2d8ecb$export$7d98c58ca1423246($pos, side);
        let pos = $pos.pos;
        // TODO: ED-5048 - Fix any, potential issue.
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let next = null;
        // Scan up from this position
        for(let d = $pos.depth;; d--){
            const parent = $pos.node(d);
            if (side === (0, $8t2a4.Side).RIGHT ? $pos.indexAfter(d) < parent.childCount : $pos.index(d) > 0) {
                next = parent.maybeChild(side === (0, $8t2a4.Side).RIGHT ? $pos.indexAfter(d) : $pos.index(d) - 1);
                break;
            } else if (d === 0) return null;
            pos += dir;
            const $cur = $pos.doc.resolve(pos);
            if ($1313b7c28e2d8ecb$export$7d98c58ca1423246.valid($cur)) return new $1313b7c28e2d8ecb$export$7d98c58ca1423246($cur, side);
        }
        // And then down into the next node
        for(;;){
            next = side === (0, $8t2a4.Side).RIGHT ? next.firstChild : next.lastChild;
            if (next === null) break;
            pos += dir;
            const $cur = $pos.doc.resolve(pos);
            if ($1313b7c28e2d8ecb$export$7d98c58ca1423246.valid($cur)) return new $1313b7c28e2d8ecb$export$7d98c58ca1423246($cur, side);
        }
        return null;
    }
    static fromJSON(doc, json) {
        return new $1313b7c28e2d8ecb$export$7d98c58ca1423246(doc.resolve(json.pos), json.side);
    }
    map(doc, mapping) {
        const $pos = doc.resolve(mapping.map(this.head));
        return $1313b7c28e2d8ecb$export$7d98c58ca1423246.valid($pos) ? new $1313b7c28e2d8ecb$export$7d98c58ca1423246($pos, this.side) : (0, $cw0wu.Selection).near($pos);
    }
    eq(other) {
        return other instanceof $1313b7c28e2d8ecb$export$7d98c58ca1423246 && other.head === this.head;
    }
    content() {
        return (0, $kW8qW.Slice).empty;
    }
    getBookmark() {
        return new $1313b7c28e2d8ecb$export$afd2c0d75bc9ce6c(this.anchor);
    }
    toJSON() {
        return {
            pos: this.head,
            type: $1313b7c28e2d8ecb$export$d9f9f34e18094ffd,
            side: this.side
        };
    }
}
(0, $cw0wu.Selection).jsonID($1313b7c28e2d8ecb$export$d9f9f34e18094ffd, $1313b7c28e2d8ecb$export$7d98c58ca1423246);
class $1313b7c28e2d8ecb$export$afd2c0d75bc9ce6c {
    constructor(pos){
        this.pos = pos;
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    map(mapping) {
        return new $1313b7c28e2d8ecb$export$afd2c0d75bc9ce6c(mapping.map(this.pos));
    }
    resolve(doc) {
        const $pos = doc.resolve(this.pos);
        return $1313b7c28e2d8ecb$export$7d98c58ca1423246.valid($pos) ? new $1313b7c28e2d8ecb$export$7d98c58ca1423246($pos) : (0, $cw0wu.Selection).near($pos);
    }
}

});
parcelRegister("8t2a4", function(module, exports) {
$parcel$export(module.exports, "Side", () => $044c18c5d60bbd75$export$80a00690bda7f17e);
var $044c18c5d60bbd75$export$80a00690bda7f17e = /*#__PURE__*/ function(Side) {
    Side["LEFT"] = "left";
    Side["RIGHT"] = "right";
    return Side;
}({});

});

parcelRegister("7jXHH", function(module, exports) {
$parcel$export(module.exports, "isValidTargetNode", () => $f8f3378fda4c8720$export$b485b49b5e1715ef);

var $ispGV = parcelRequire("ispGV");
const $f8f3378fda4c8720$export$b485b49b5e1715ef = (node)=>{
    return !!node && !(0, $ispGV.isIgnored)(node);
};

});
parcelRegister("ispGV", function(module, exports) {
$parcel$export(module.exports, "isIgnored", () => $c8d85f4e0eb9d335$export$ac3f691269cd6d9b);
// we don't show gap cursor for those nodes
const $c8d85f4e0eb9d335$var$IGNORED_NODES = [
    'paragraph',
    'bulletList',
    'orderedList',
    'listItem',
    'taskItem',
    'decisionItem',
    'heading',
    'blockquote',
    'layoutColumn',
    'caption',
    'media',
    'extensionFrame'
];
const $c8d85f4e0eb9d335$export$ac3f691269cd6d9b = (node)=>{
    return !!node && $c8d85f4e0eb9d335$var$IGNORED_NODES.indexOf(node.type.name) !== -1;
};

});






parcelRegister("ef6dZ", function(module, exports) {
$parcel$export(module.exports, "ClickAreaBlockContainerCompiled", () => $6c73bf879d9dea3f$export$ea84b896e6fff843);
/* clickAreaBlock-compiled.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
const $6c73bf879d9dea3f$var$clickWrapperCompiledStyles = {
    root: "_16jlkb7n _4t3i1osq"
};
const $6c73bf879d9dea3f$export$ea84b896e6fff843 = ({ children: children, ...rest })=>/*#__PURE__*/ (0, $dc70d.jsx)("div", {
        ...rest,
        className: (0, $9fU1q.default)([
            $6c73bf879d9dea3f$var$clickWrapperCompiledStyles.root
        ]),
        children: children
    });

});


parcelRegister("dUXT6", function(module, exports) {
$parcel$export(module.exports, "getPrimaryToolbarComponents", () => $8f390e6cc1c9757f$export$f454e86f6cef71f4);
const $8f390e6cc1c9757f$export$f454e86f6cef71f4 = (editorAPI, components)=>{
    var _editorAPI$primaryToo;
    return {
        components: components ?? (editorAPI === null || editorAPI === void 0 || (_editorAPI$primaryToo = editorAPI.primaryToolbar) === null || _editorAPI$primaryToo === void 0 || (_editorAPI$primaryToo = _editorAPI$primaryToo.sharedState.currentState()) === null || _editorAPI$primaryToo === void 0 ? void 0 : _editorAPI$primaryToo.components)
    };
};

});

parcelRegister("3BF2Y", function(module, exports) {
$parcel$export(module.exports, "ToolbarWithSizeDetector", () => $fcbe56ebbaae57a3$export$6bb21858343ac39d);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $7lseo = parcelRequire("7lseo");

var $d0HRE = parcelRequire("d0HRE");

var $797yE = parcelRequire("797yE");

var $8Mb7N = parcelRequire("8Mb7N");

var $5oN7k = parcelRequire("5oN7k");

var $goVia = parcelRequire("goVia");

var $bmMyd = parcelRequire("bmMyd");

var $gNmU3 = parcelRequire("gNmU3");

var $eP44I = parcelRequire("eP44I");
const $fcbe56ebbaae57a3$export$6bb21858343ac39d = (props)=>{
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useRef(null);
    const [width, setWidth] = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useState(undefined);
    const elementWidth = (0, $goVia.useElementWidth)(ref, {
        skip: typeof width !== 'undefined'
    });
    const defaultToolbarSize = (0, $7lseo.isSSR)() && (0, $5oN7k.isFullPage)(props.appearance) ? (0, $d0HRE.ToolbarSize).XXL : undefined;
    const toolbarSize = typeof width === 'undefined' && typeof elementWidth === 'undefined' ? defaultToolbarSize : // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $gNmU3.widthToToolbarSize)(width || elementWidth, props.appearance);
    const minWidthValue = (0, $bSJIT.useMemo)(()=>{
        if (props.hasMinWidth) {
            const toolbarWidth = (0, $5oN7k.isFullPage)(props.appearance) && props.twoLineEditorToolbar ? (0, $d0HRE.ToolbarSize).S : (0, $d0HRE.ToolbarSize).M;
            return `${(0, $gNmU3.toolbarSizeToWidth)(toolbarWidth, props.appearance)}px`;
        } else {
            const isPreviewPanelResponsivenessEnabled = (0, $797yE.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
                exposure: true
            });
            return isPreviewPanelResponsivenessEnabled ? 'fit-content' : '254px';
        }
    }, [
        props.appearance,
        props.hasMinWidth,
        props.twoLineEditorToolbar
    ]);
    const wrapperStyle = (0, $bSJIT.useMemo)(()=>({
            minWidth: minWidthValue
        }), [
        minWidthValue
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $eP44I.ToolbarSizeDetectorWrapperCompiled), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- minWidth is computed dynamically from props.hasMinWidth, props.appearance, props.twoLineEditorToolbar, and the platform_editor_preview_panel_responsiveness experiment, so it cannot be expressed as a static css value.
        style: wrapperStyle,
        children: [
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $8Mb7N.WidthObserver), {
                setWidth: setWidth
            }),
            props.editorView && toolbarSize ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $bmMyd.Toolbar), {
                toolbarSize: toolbarSize,
                items: props.items,
                editorView: props.editorView,
                editorActions: props.editorActions,
                eventDispatcher: props.eventDispatcher,
                providerFactory: props.providerFactory,
                appearance: props.appearance,
                popupsMountPoint: props.popupsMountPoint,
                popupsBoundariesElement: props.popupsBoundariesElement,
                popupsScrollableElement: props.popupsScrollableElement,
                disabled: props.disabled,
                dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
                containerElement: props.containerElement,
                hasMinWidth: props.hasMinWidth,
                twoLineEditorToolbar: props.twoLineEditorToolbar
            }) : /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                ref: ref
            })
        ]
    });
};

});
parcelRegister("5oN7k", function(module, exports) {
$parcel$export(module.exports, "isFullPage", () => $406fed71a8aa03d0$export$2800a15841f40ad7);
function $406fed71a8aa03d0$export$2800a15841f40ad7(appearance) {
    return appearance === 'full-page' || appearance === 'full-width';
}

});

parcelRegister("goVia", function(module, exports) {
$parcel$export(module.exports, "useElementWidth", () => $579fe9c68cd93385$export$1217913212f99c7);

var $bSJIT = parcelRequire("bSJIT");

var $gdUUy = parcelRequire("gdUUy");
const $579fe9c68cd93385$export$1217913212f99c7 = (ref, { skip: skip })=>{
    const [elementWidth, setWidth] = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useState(undefined);
    (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useEffect(()=>{
        if (!skip && ref.current && !(0, $gdUUy.fg)('platform_editor_prevent_toolbar_width_reflow')) // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- Ignored via go/ees017 (to be fixed)
        setWidth(Math.round(ref.current.getBoundingClientRect().width));
    }, [
        skip,
        setWidth,
        ref
    ]);
    return elementWidth;
};

});

parcelRegister("bmMyd", function(module, exports) {
$parcel$export(module.exports, "Toolbar", () => $f9e3082d5820f315$export$4c260019440d418f);
$parcel$export(module.exports, "ToolbarNext", () => $f9e3082d5820f315$export$1606f8c5fd0ac145);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $28qc1 = parcelRequire("28qc1");

var $43aKr = parcelRequire("43aKr");

var $d0HRE = parcelRequire("d0HRE");

var $5beht = parcelRequire("5beht");

var $hVGJk = parcelRequire("hVGJk");

var $cvshM = parcelRequire("cvshM");

var $5gDEv = parcelRequire("5gDEv");

var $dlk6h = parcelRequire("dlk6h");

var $ap3j9 = parcelRequire("ap3j9");

var $3y2s4 = parcelRequire("3y2s4");

var $kmsvc = parcelRequire("kmsvc");
const $f9e3082d5820f315$var$TOOLBAR_FALLBACKS = {
    group: (0, $5gDEv.ToolbarButtonGroup),
    section: (0, $ap3j9.ToolbarSection),
    menuSection: (0, $dlk6h.ToolbarDropdownItemSection)
};
const $f9e3082d5820f315$export$4c260019440d418f = (props)=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $kmsvc.ToolbarInner), {
        items: props.items,
        editorView: props.editorView,
        editorActions: props.editorActions,
        eventDispatcher: props.eventDispatcher,
        providerFactory: props.providerFactory,
        appearance: props.appearance,
        popupsMountPoint: props.popupsMountPoint,
        popupsBoundariesElement: props.popupsBoundariesElement,
        popupsScrollableElement: props.popupsScrollableElement,
        disabled: props.disabled,
        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
        toolbarSize: props.toolbarSize,
        isToolbarReducedSpacing: props.toolbarSize < (0, $d0HRE.ToolbarSize).XXL,
        containerElement: props.containerElement
    });
};
const $f9e3082d5820f315$var$usePluginState = (api)=>{
    return (0, $5beht.useSharedPluginStateWithSelector)(api, [
        'connectivity',
        'editorViewMode',
        'userPreferences'
    ], (state)=>{
        var _state$connectivitySt, _state$editorViewMode, _state$userPreference;
        return {
            connectivityStateMode: (_state$connectivitySt = state.connectivityState) === null || _state$connectivitySt === void 0 ? void 0 : _state$connectivitySt.mode,
            editorViewMode: (_state$editorViewMode = state.editorViewModeState) === null || _state$editorViewMode === void 0 ? void 0 : _state$editorViewMode.mode,
            editorToolbarDockingPreference: (_state$userPreference = state.userPreferencesState) === null || _state$userPreference === void 0 || (_state$userPreference = _state$userPreference.preferences) === null || _state$userPreference === void 0 ? void 0 : _state$userPreference.toolbarDockingPosition
        };
    });
};
const $f9e3082d5820f315$export$1606f8c5fd0ac145 = ({ toolbar: toolbar, components: components, editorView: editorView, editorAPI: editorAPI, popupsMountPoint: popupsMountPoint, editorAppearance: editorAppearance, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isDisabled: isDisabled, disabledWithoutInteractionLogic: disabledWithoutInteractionLogic })=>{
    const { connectivityStateMode: connectivityStateMode, editorViewMode: editorViewMode, editorToolbarDockingPreference: editorToolbarDockingPreference } = $f9e3082d5820f315$var$usePluginState(editorAPI);
    // remove offline check when patch6Enabled is cleaned up
    const isOffline = (0, $hVGJk.isOfflineMode)(connectivityStateMode);
    const memoizedFireAnalyticsEvent = (0, $bSJIT.useCallback)((payload)=>{
        var _editorAPI$analytics;
        editorAPI === null || editorAPI === void 0 || (_editorAPI$analytics = editorAPI.analytics) === null || _editorAPI$analytics === void 0 || _editorAPI$analytics.actions.fireAnalyticsEvent(payload);
    }, [
        editorAPI
    ]);
    const fireAnalyticsEvent = (0, $3y2s4.isExperimentEnabled)('platform_editor_perf_lint_cleanup') ? memoizedFireAnalyticsEvent : (payload)=>memoizedFireAnalyticsEvent(payload);
    const fallbacks = (0, $3y2s4.isExperimentEnabled)('platform_editor_perf_lint_cleanup') ? $f9e3082d5820f315$var$TOOLBAR_FALLBACKS : {
        group: (0, $5gDEv.ToolbarButtonGroup),
        section: (0, $ap3j9.ToolbarSection),
        menuSection: (0, $dlk6h.ToolbarDropdownItemSection)
    };
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $28qc1.EditorToolbarProvider), {
        editorView: editorView ?? null,
        editorAppearance: editorAppearance,
        editorViewMode: editorViewMode ?? 'edit',
        editorToolbarDockingPreference: editorToolbarDockingPreference,
        isOffline: isOffline,
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $43aKr.EditorToolbarUIProvider), {
            api: editorAPI,
            isDisabled: isDisabled,
            disabledWithoutInteractionLogic: disabledWithoutInteractionLogic,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            fireAnalyticsEvent: fireAnalyticsEvent,
            children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $cvshM.ToolbarModelRenderer), {
                toolbar: toolbar,
                components: components,
                fallbacks: fallbacks
            })
        })
    });
};

});
parcelRegister("28qc1", function(module, exports) {
$parcel$export(module.exports, "useEditorToolbar", () => $c9ebb1e71becaac0$export$d463571cb9040a24);
$parcel$export(module.exports, "EditorToolbarProvider", () => $c9ebb1e71becaac0$export$847624ff5ecdfe6d);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $3y2s4 = parcelRequire("3y2s4");
const $c9ebb1e71becaac0$var$EditorToolbarContext = /*#__PURE__*/ (0, $bSJIT.createContext)({
    editorView: null,
    editorAppearance: undefined,
    editorViewMode: undefined,
    editorToolbarDockingPreference: undefined
});
const $c9ebb1e71becaac0$export$d463571cb9040a24 = ()=>{
    const context = (0, $bSJIT.useContext)($c9ebb1e71becaac0$var$EditorToolbarContext);
    if (!context) throw new Error('useEditorToolbar must be used within EditorToolbarContext');
    return context;
};
const $c9ebb1e71becaac0$export$847624ff5ecdfe6d = ({ children: children, editorView: editorView, editorAppearance: editorAppearance, editorViewMode: editorViewMode, editorToolbarDockingPreference: editorToolbarDockingPreference, isOffline: isOffline })=>{
    const memoizedValue = (0, $bSJIT.useMemo)(()=>({
            editorView: editorView,
            editorAppearance: editorAppearance,
            editorViewMode: editorViewMode,
            editorToolbarDockingPreference: editorToolbarDockingPreference,
            isOffline: isOffline
        }), [
        editorView,
        editorAppearance,
        editorViewMode,
        editorToolbarDockingPreference,
        isOffline
    ]);
    const contextValue = (0, $3y2s4.isExperimentEnabled)('platform_editor_perf_lint_cleanup') ? memoizedValue : {
        editorView: editorView,
        editorAppearance: editorAppearance,
        editorViewMode: editorViewMode,
        editorToolbarDockingPreference: editorToolbarDockingPreference,
        isOffline: isOffline
    };
    return /*#__PURE__*/ (0, $dc70d.jsx)($c9ebb1e71becaac0$var$EditorToolbarContext.Provider, {
        value: contextValue,
        children: children
    });
};

});

parcelRegister("43aKr", function(module, exports) {
$parcel$export(module.exports, "EditorToolbarUIProvider", () => $244c5fed41938625$export$54b6b74e939729c);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $aBdvW = parcelRequire("aBdvW");

var $3y2s4 = parcelRequire("3y2s4");
const $244c5fed41938625$export$54b6b74e939729c = ({ children: children, api: api, isDisabled: isDisabled, disabledWithoutInteractionLogic: disabledWithoutInteractionLogic, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, fireAnalyticsEvent: fireAnalyticsEvent, keyboardNavigation: keyboardNavigation })=>{
    const onDropdownOpenChanged = (0, $bSJIT.useCallback)(({ isOpen: isOpen, event: event })=>{
        if (!isOpen) {
            // Only refocus the editor when the dropdown closes via mouse or programmatic close.
            // When closed via keyboard Escape, keep focus on the trigger for better keyboard UX.
            const isKeyboardEscape = event instanceof KeyboardEvent && event.key === 'Escape';
            const shouldFocusEditor = !isKeyboardEscape;
            if ((0, $3y2s4.isExperimentEnabled)('platform_editor_toolbar_multi_editor_fix') && event instanceof MouseEvent && event.target instanceof Element && !event.target.closest('[role="menu"]')) return;
            if (shouldFocusEditor) // On Dropdown closed, focus is returned to trigger button by default in requestAnimationFrame
            // Hence, `.focus()` should also be called in requestAnimationFrame
            setTimeout(()=>requestAnimationFrame(()=>{
                    api === null || api === void 0 || api.core.actions.focus({
                        scrollIntoView: false
                    });
                }), 1);
        }
    }, [
        api
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $aBdvW.ToolbarUIProvider), {
        onDropdownOpenChanged: onDropdownOpenChanged,
        preventDefaultOnMouseDown: true,
        isDisabled: isDisabled,
        disabledWithoutInteractionLogic: disabledWithoutInteractionLogic,
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        fireAnalyticsEvent: fireAnalyticsEvent,
        keyboardNavigation: keyboardNavigation,
        children: children
    });
};

});
parcelRegister("aBdvW", function(module, exports) {
$parcel$export(module.exports, "useToolbarUI", () => $ec5066973bf1215d$export$e7063f2520f6adf8);
$parcel$export(module.exports, "ToolbarUIProvider", () => $ec5066973bf1215d$export$ae8c3f290017c42a);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");
const $ec5066973bf1215d$var$ToolbarUIContext = /*#__PURE__*/ (0, $bSJIT.createContext)({
    onDropdownOpenChanged: ()=>{},
    preventDefaultOnMouseDown: false,
    isDisabled: false,
    disabledWithoutInteractionLogic: false,
    popupsMountPoint: undefined,
    fireAnalyticsEvent: undefined,
    keyboardNavigation: undefined
});
const $ec5066973bf1215d$export$e7063f2520f6adf8 = ()=>{
    const context = (0, $bSJIT.useContext)($ec5066973bf1215d$var$ToolbarUIContext);
    if (!context) throw new Error('useToolbarUI must be used within ToolbarUIContext');
    return context;
};
const $ec5066973bf1215d$export$ae8c3f290017c42a = ({ children: children, onDropdownOpenChanged: onDropdownOpenChanged, preventDefaultOnMouseDown: preventDefaultOnMouseDown, isDisabled: isDisabled, disabledWithoutInteractionLogic: disabledWithoutInteractionLogic, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, fireAnalyticsEvent: fireAnalyticsEvent, keyboardNavigation: keyboardNavigation })=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)($ec5066973bf1215d$var$ToolbarUIContext.Provider, {
        // eslint-disable-next-line @atlassian/perf-linting/no-inline-context-value, @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        value: {
            onDropdownOpenChanged: onDropdownOpenChanged,
            preventDefaultOnMouseDown: preventDefaultOnMouseDown,
            isDisabled: isDisabled,
            disabledWithoutInteractionLogic: disabledWithoutInteractionLogic,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            fireAnalyticsEvent: fireAnalyticsEvent,
            keyboardNavigation: keyboardNavigation
        },
        children: children
    });
};

});


parcelRegister("hVGJk", function(module, exports) {
$parcel$export(module.exports, "isOfflineMode", () => $fa11d024dd71dc8e$export$a73e10b357da8876);
const $fa11d024dd71dc8e$export$a73e10b357da8876 = (mode)=>{
    return mode === 'offline' || mode === 'collab-offline' || mode === 'internet-offline';
};

});

parcelRegister("cvshM", function(module, exports) {
$parcel$export(module.exports, "ToolbarModelRenderer", () => $87fed404d9e6535c$export$9ceb2742df82af54);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $j7tlB = parcelRequire("j7tlB");
const $87fed404d9e6535c$var$hasParents = (component)=>{
    return component.type !== 'toolbar';
};
const $87fed404d9e6535c$var$getChildTypesForParent = (parentType)=>{
    switch(parentType){
        case 'toolbar':
            return [
                'section'
            ];
        case 'section':
            return [
                'group'
            ];
        case 'group':
            return [
                'button',
                'menu'
            ];
        case 'menu':
        case 'nested-menu':
            return [
                'menu-section'
            ];
        case 'menu-section':
            return [
                'menu-item',
                'nested-menu'
            ];
        default:
            return [];
    }
};
const $87fed404d9e6535c$var$getFallbackComponent = (type, fallbacks)=>{
    switch(type){
        case 'group':
            return fallbacks.group;
        case 'menu-section':
            return fallbacks.menuSection;
        case 'section':
            return fallbacks.section;
        default:
            return 0, $j7tlB.NoOp;
    }
};
const $87fed404d9e6535c$var$hasMenuItems = (menuSections, allComponents)=>{
    return menuSections.some((menuSection)=>{
        return allComponents.some((component)=>{
            var _component$isHidden;
            return component.type === 'menu-item' && component.parents.some((parent)=>parent.key === menuSection.key) && (!('isHidden' in component) || !((_component$isHidden = component.isHidden) !== null && _component$isHidden !== void 0 && _component$isHidden.call(component)));
        });
    });
};
const $87fed404d9e6535c$var$shouldHideEmptyComponent = (component, children, allComponents)=>{
    if (component.type === 'menu') {
        const menuSections = children.filter((child)=>child.type === 'menu-section');
        return menuSections.length === 0 || !$87fed404d9e6535c$var$hasMenuItems(menuSections, allComponents);
    }
    if (component.type === 'group' || component.type === 'nested-menu' || component.type === 'menu-section') return children.length === 0;
    return false;
};
const $87fed404d9e6535c$var$ComponentRenderer = ({ component: component, parents: parents, allComponents: allComponents, fallbacks: fallbacks })=>{
    const childTypes = $87fed404d9e6535c$var$getChildTypesForParent(component.type);
    const children = (0, $j7tlB.getSortedChildren)(// eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- Ignored via go/ees017 (to be fixed)
    allComponents.filter((comp)=>childTypes.includes(comp.type)), component.key);
    if ($87fed404d9e6535c$var$shouldHideEmptyComponent(component, children, allComponents)) return null;
    const Component = component.component || $87fed404d9e6535c$var$getFallbackComponent(component.type, fallbacks);
    const newParents = [
        ...parents,
        {
            key: component.key,
            type: component.type
        }
    ];
    if (children.length === 0) return /*#__PURE__*/ (0, $dc70d.jsx)(Component, {
        parents: parents,
        children: null
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)(Component, {
        parents: parents,
        children: children.map((child)=>/*#__PURE__*/ (0, $dc70d.jsx)($87fed404d9e6535c$var$ComponentRenderer, {
                component: child,
                parents: newParents,
                allComponents: allComponents,
                fallbacks: fallbacks
            }, child.key))
    });
};
const $87fed404d9e6535c$export$9ceb2742df82af54 = ({ toolbar: toolbar, components: components, fallbacks: fallbacks })=>{
    const ToolbarComponent = toolbar.component || (0, $j7tlB.NoOp);
    // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- Ignored via go/ees017 (to be fixed)
    const sections = (0, $j7tlB.getSortedChildren)(components.filter((0, $j7tlB.isSection)), toolbar.key);
    return /*#__PURE__*/ (0, $dc70d.jsx)(ToolbarComponent, {
        children: sections.map((section)=>/*#__PURE__*/ (0, $dc70d.jsx)($87fed404d9e6535c$var$ComponentRenderer, {
                component: section,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                parents: [
                    {
                        key: toolbar.key,
                        type: toolbar.type
                    }
                ],
                // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- Ignored via go/ees017 (to be fixed)
                allComponents: components.filter($87fed404d9e6535c$var$hasParents),
                fallbacks: fallbacks
            }, section.key))
    });
};

});
parcelRegister("j7tlB", function(module, exports) {
$parcel$export(module.exports, "getSortedChildren", () => $b479482673b3a988$export$671f8dfe06a9af10);
$parcel$export(module.exports, "NoOp", () => $b479482673b3a988$export$7fc4381d95dc76c8);
$parcel$export(module.exports, "isSection", () => $b479482673b3a988$export$fc1acc9190910d14);
const $b479482673b3a988$export$671f8dfe06a9af10 = (components, parentKey)=>components.filter((component)=>component.parents.some((parent)=>parent.key === parentKey)).sort((a, b)=>{
        var _a$parents$find, _b$parents$find;
        return (((_a$parents$find = a.parents.find((p)=>p.key === parentKey)) === null || _a$parents$find === void 0 ? void 0 : _a$parents$find.rank) || 0) - (((_b$parents$find = b.parents.find((p)=>p.key === parentKey)) === null || _b$parents$find === void 0 ? void 0 : _b$parents$find.rank) || 0);
    });
const $b479482673b3a988$export$7fc4381d95dc76c8 = (props)=>null;
const $b479482673b3a988$export$fc1acc9190910d14 = (component)=>{
    return component.type === 'section';
};

});


parcelRegister("5gDEv", function(module, exports) {
$parcel$export(module.exports, "ToolbarButtonGroup", () => $cccb1f2f98349015$export$89cfa2b8585c6d03);
/* ToolbarButtonGroup.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $9PwDt = parcelRequire("9PwDt");
const $cccb1f2f98349015$var$styles = {
    container: "_zulpv77o _1e0c1txw _1gt41dpa",
    firstChild: "_19pe12x7 _1qq0idpf _3nesidpf",
    lastChild: "_19pe12x7 _15rdidpf _i84vidpf"
};
const $cccb1f2f98349015$export$89cfa2b8585c6d03 = ({ children: children })=>{
    const items = (0, $bSJIT.Children).toArray(children);
    //  The .at() method is a relatively newer JavaScript API (ES2022) that isn't supported in older browsers
    //  Using items[i] is more compatible with older browsers.
    const firstChild = items[0];
    const lastChild = items[items.length - 1];
    const middleChildren = items.slice(1, -1);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
        xcss: $cccb1f2f98349015$var$styles.container,
        "data-toolbar-component": "button-group",
        children: items.length <= 1 ? children : /*#__PURE__*/ (0, $dc70d.jsxs)((0, $bSJIT.Fragment), {
            children: [
                /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                    className: (0, $9fU1q.default)([
                        $cccb1f2f98349015$var$styles.firstChild
                    ]),
                    children: firstChild
                }),
                middleChildren,
                /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                    className: (0, $9fU1q.default)([
                        $cccb1f2f98349015$var$styles.lastChild
                    ]),
                    children: lastChild
                })
            ]
        })
    });
};

});

parcelRegister("dlk6h", function(module, exports) {
$parcel$export(module.exports, "ToolbarDropdownItemSection", () => $6ba2fa051b9c3d39$export$3e60ddf10b9269e3);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $ljPIj = parcelRequire("ljPIj");
const $6ba2fa051b9c3d39$export$3e60ddf10b9269e3 = ({ children: children, hasSeparator: hasSeparator, title: title, testId: testId })=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $ljPIj.default), {
        hasSeparator: hasSeparator,
        title: title,
        "data-toolbar-component": "menu-section",
        testId: testId,
        children: children
    });
};

});

parcelRegister("ap3j9", function(module, exports) {
$parcel$export(module.exports, "SeparatorPosition", () => $84bd60ec22142f5e$export$90683802e28416b5);
$parcel$export(module.exports, "ToolbarSection", () => $84bd60ec22142f5e$export$b978f6a1bb31af67);
/* ToolbarSection.tsx generated by @compiled/babel-plugin v3.0.2 */ /* ToolbarSection.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $jDsoo = parcelRequire("jDsoo");

var $9PwDt = parcelRequire("9PwDt");
var $84bd60ec22142f5e$export$90683802e28416b5 = /*#__PURE__*/ function(SeparatorPosition) {
    SeparatorPosition["START"] = "start";
    SeparatorPosition["END"] = "end";
    return SeparatorPosition;
}({});
const $84bd60ec22142f5e$var$styles = {
    container: "_zulp1b66 _1e0c1txw _4cvr1h6o"
};
const $84bd60ec22142f5e$var$separator = null;
const $84bd60ec22142f5e$var$marginInlineOverridden = null;
const $84bd60ec22142f5e$var$ToolbarSeparator = ()=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        "data-toolbar-component": "separator",
        role: "separator",
        "aria-orientation": "vertical",
        className: (0, $9fU1q.default)([
            "_195gu2gc _4t3igktf _1bsbt94y _bfhk1l7x",
            "_1p9bv77o"
        ])
    });
};
const $84bd60ec22142f5e$export$b978f6a1bb31af67 = ({ children: children, testId: testId, hasSeparator: hasSeparator })=>{
    return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $9PwDt.Box), {
        xcss: (0, $jDsoo.cx)($84bd60ec22142f5e$var$styles.container),
        testId: testId,
        "data-toolbar-component": "section",
        children: [
            hasSeparator === "start" && /*#__PURE__*/ (0, $dc70d.jsx)($84bd60ec22142f5e$var$ToolbarSeparator, {}),
            children,
            hasSeparator === "end" && /*#__PURE__*/ (0, $dc70d.jsx)($84bd60ec22142f5e$var$ToolbarSeparator, {})
        ]
    });
};

});

parcelRegister("kmsvc", function(module, exports) {
$parcel$export(module.exports, "ToolbarInner", () => $3b1291860f806f47$export$7c77e89663c6a665);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $dMMwa = parcelRequire("dMMwa");

var $7lseo = parcelRequire("7lseo");

var $2tEJk = parcelRequire("2tEJk");
class $3b1291860f806f47$export$7c77e89663c6a665 extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Component {
    shouldComponentUpdate(nextProps) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($dMMwa)))(nextProps, this.props);
    }
    render() {
        const { appearance: appearance, editorView: editorView, editorActions: editorActions, eventDispatcher: eventDispatcher, providerFactory: providerFactory, items: items, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, toolbarSize: toolbarSize, disabled: disabled, isToolbarReducedSpacing: isToolbarReducedSpacing, dispatchAnalyticsEvent: dispatchAnalyticsEvent, containerElement: containerElement } = this.props;
        if (!items || !items.length) return null;
        if ((0, $7lseo.isSSR)()) // Toolbar in SSR environment is showing collapsed state, which caused layout shift after hydrating to SPA.
        // Hiding toolbar in SSR until the dependency of screen width is resolved in SSR environment.
        return null;
        return /*#__PURE__*/ (0, $dc70d.jsx)((0, $2tEJk.ToolbarComponentsWrapperCompiled), {
            "data-vc": "toolbar-inner",
            children: items.map((component, key)=>{
                const element = component({
                    editorView: editorView,
                    editorActions: editorActions,
                    eventDispatcher: eventDispatcher,
                    providerFactory: providerFactory,
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    appearance: appearance,
                    popupsMountPoint: popupsMountPoint,
                    popupsBoundariesElement: popupsBoundariesElement,
                    popupsScrollableElement: popupsScrollableElement,
                    disabled: disabled,
                    toolbarSize: toolbarSize,
                    isToolbarReducedSpacing: isToolbarReducedSpacing,
                    containerElement: containerElement,
                    isLastItem: key === items.length - 1,
                    dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                    wrapperElement: null
                });
                // oxlint-disable-next-line react/no-array-index-key
                return element && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).cloneElement(element, {
                    key: key
                });
            })
        });
    }
}

});
parcelRegister("2tEJk", function(module, exports) {
$parcel$export(module.exports, "ToolbarComponentsWrapperCompiled", () => $2d65eff0d3c9f722$export$526eaae4f7757167);
/* ToolbarComponentsWrapper-compiled.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
const $2d65eff0d3c9f722$var$toolbarComponentsWrapperCompiledStyles = {
    root: "_1e0c1txw _1hm21yb4"
};
const $2d65eff0d3c9f722$export$526eaae4f7757167 = ({ children: children, 'data-vc': dataVc })=>/*#__PURE__*/ (0, $dc70d.jsx)("div", {
        "data-vc": dataVc,
        className: (0, $9fU1q.default)([
            $2d65eff0d3c9f722$var$toolbarComponentsWrapperCompiledStyles.root
        ]),
        children: children
    });

});



parcelRegister("gNmU3", function(module, exports) {
$parcel$export(module.exports, "toolbarSizeToWidth", () => $742c3f4586db2d5b$export$df8e48f984163082);
$parcel$export(module.exports, "widthToToolbarSize", () => $742c3f4586db2d5b$export$886398ab6922a80f);

var $d0HRE = parcelRequire("d0HRE");
var $dOB7E = parcelRequire("dOB7E");
var $dR61S = parcelRequire("dR61S");

var $5oN7k = parcelRequire("5oN7k");
// Toolbar sizes for full page editor a little bit different, because it has more buttons e.g. actions button...
const $742c3f4586db2d5b$var$toolbarSizesFullPageNext = [
    {
        width: (0, $dOB7E.ToolbarWidthsFullPageNext).XXL,
        size: (0, $d0HRE.ToolbarSize).XXL
    },
    {
        width: (0, $dOB7E.ToolbarWidthsFullPageNext).XL,
        size: (0, $d0HRE.ToolbarSize).XL
    },
    {
        width: (0, $dOB7E.ToolbarWidthsFullPageNext).L,
        size: (0, $d0HRE.ToolbarSize).L
    },
    {
        width: (0, $dOB7E.ToolbarWidthsFullPageNext).M,
        size: (0, $d0HRE.ToolbarSize).M
    },
    {
        width: (0, $dOB7E.ToolbarWidthsFullPageNext).S,
        size: (0, $d0HRE.ToolbarSize).S
    }
];
const $742c3f4586db2d5b$var$toolbarSizesNext = [
    {
        width: (0, $dR61S.ToolbarWidthsNext).XXL,
        size: (0, $d0HRE.ToolbarSize).XXL
    },
    {
        width: (0, $dR61S.ToolbarWidthsNext).XL,
        size: (0, $d0HRE.ToolbarSize).XL
    },
    {
        width: (0, $dR61S.ToolbarWidthsNext).L,
        size: (0, $d0HRE.ToolbarSize).L
    },
    {
        width: (0, $dR61S.ToolbarWidthsNext).M,
        size: (0, $d0HRE.ToolbarSize).M
    },
    {
        width: (0, $dR61S.ToolbarWidthsNext).S,
        size: (0, $d0HRE.ToolbarSize).S
    }
];
const $742c3f4586db2d5b$var$toolbarSizesForAppearance = (appearance)=>(0, $5oN7k.isFullPage)(appearance) ? $742c3f4586db2d5b$var$toolbarSizesFullPageNext : $742c3f4586db2d5b$var$toolbarSizesNext;
const $742c3f4586db2d5b$export$df8e48f984163082 = (toolbarSize, appearance)=>{
    return ($742c3f4586db2d5b$var$toolbarSizesForAppearance(appearance).find(({ size: size })=>toolbarSize === size) || {
        width: (0, $dR61S.ToolbarWidthsNext).S
    }).width;
};
const $742c3f4586db2d5b$export$886398ab6922a80f = (toolbarWidth, appearance)=>{
    return ($742c3f4586db2d5b$var$toolbarSizesForAppearance(appearance).find(({ width: width })=>toolbarWidth > width) || {
        size: (0, $d0HRE.ToolbarSize).XXXS
    }).size;
};

});

parcelRegister("eP44I", function(module, exports) {
$parcel$export(module.exports, "ToolbarSizeDetectorWrapperCompiled", () => $30a20ab82eebf665$export$390f44f5b097927e);
/* ToolbarSizeDetectorWrapper-compiled.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
const $30a20ab82eebf665$var$toolbarSizeDetectorWrapperCompiledStyles = {
    root: "_1bsb1osq _kqswh2mm"
};
const $30a20ab82eebf665$export$390f44f5b097927e = ({ children: children, style: style })=>/*#__PURE__*/ (0, $dc70d.jsx)("div", {
        style: style,
        className: (0, $9fU1q.default)([
            $30a20ab82eebf665$var$toolbarSizeDetectorWrapperCompiledStyles.root
        ]),
        children: children
    });

});


parcelRegister("eRTBQ", function(module, exports) {
$parcel$export(module.exports, "CommentToolbar", () => $147ae18f294a1ba1$export$48156340a1673791);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $4rzOL = parcelRequire("4rzOL");

var $kGfTG = parcelRequire("kGfTG");

var $bmMyd = parcelRequire("bmMyd");
const $147ae18f294a1ba1$export$48156340a1673791 = ({ editorAPI: editorAPI, editorView: editorView, editorAppearance: editorAppearance, disabled: disabled, popupsBoundariesElement: popupsBoundariesElement, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement })=>{
    var _editorAPI$toolbar;
    const components = editorAPI === null || editorAPI === void 0 || (_editorAPI$toolbar = editorAPI.toolbar) === null || _editorAPI$toolbar === void 0 ? void 0 : _editorAPI$toolbar.actions.getComponents();
    const toolbar = components === null || components === void 0 ? void 0 : components.find((component)=>component.key === (0, $4rzOL.TOOLBARS).PRIMARY_TOOLBAR);
    if (!components || !(0, $kGfTG.isToolbar)(toolbar)) return null;
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $bmMyd.ToolbarNext), {
        toolbar: toolbar,
        components: components,
        editorView: editorView,
        editorAPI: editorAPI,
        editorAppearance: editorAppearance,
        isDisabled: disabled,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        popupsMountPoint: popupsMountPoint
    });
};

});
parcelRegister("4rzOL", function(module, exports) {
$parcel$export(module.exports, "TOOLBARS", () => $eeb1fde579dcd221$export$cc1c18c6e6b6ecaf);
$parcel$export(module.exports, "AI_SECTION", () => $eeb1fde579dcd221$export$78ec0124ca63fa02);
$parcel$export(module.exports, "AI_VIEW_SECTION", () => $eeb1fde579dcd221$export$124d2ee606ccdfdc);
$parcel$export(module.exports, "ROVO_GROUP", () => $eeb1fde579dcd221$export$ab61657fb37116be);
$parcel$export(module.exports, "ROVO_GROUP_PRIMARY_TOOLBAR", () => $eeb1fde579dcd221$export$67ae7e5d398cd98);
$parcel$export(module.exports, "ROVO_GROUP_DISPLAY_SMALL", () => $eeb1fde579dcd221$export$393a27a1587c4748);
$parcel$export(module.exports, "IMPROVE_WRITING_GROUP", () => $eeb1fde579dcd221$export$164a0130b2b649c6);
$parcel$export(module.exports, "IMPROVE_WRITING_BUTTON", () => $eeb1fde579dcd221$export$e7c291289ee98d9);
$parcel$export(module.exports, "HERO_PROMPT_BUTTON_GROUP", () => $eeb1fde579dcd221$export$50fb6fd780a8da5a);
$parcel$export(module.exports, "HERO_PROMPT_BUTTON", () => $eeb1fde579dcd221$export$6ea8ae73b826b63e);
$parcel$export(module.exports, "ROVO_HERO_BUTTON", () => $eeb1fde579dcd221$export$3d823cd1493e8383);
$parcel$export(module.exports, "ROVO_WRITE_BUTTON_PRIMARY_TOOLBAR", () => $eeb1fde579dcd221$export$bc3c6b8bbdf543d6);
$parcel$export(module.exports, "ROVO_MENU", () => $eeb1fde579dcd221$export$4532eefb6fdb660c);
$parcel$export(module.exports, "ROVO_MENU_DISPLAY_SMALL", () => $eeb1fde579dcd221$export$245b51779748026d);
$parcel$export(module.exports, "ROVO_PROMPT_MENU_SECTION", () => $eeb1fde579dcd221$export$f157764a2d8d74e6);
$parcel$export(module.exports, "ROVO_PROMPT_MENU_SECTION_DISPLAY_SMALL", () => $eeb1fde579dcd221$export$8be015e65f184637);
$parcel$export(module.exports, "IMPROVE_WRITING_MENU_ITEM", () => $eeb1fde579dcd221$export$c9c5b3ece9aa9724);
$parcel$export(module.exports, "HERO_PROMPT_MENU_ITEM", () => $eeb1fde579dcd221$export$1ede5932cecaa59);
$parcel$export(module.exports, "MAKE_SHORTER_MENU_ITEM", () => $eeb1fde579dcd221$export$4799f439258ea378);
$parcel$export(module.exports, "MAKE_LONGER_MENU_ITEM", () => $eeb1fde579dcd221$export$b82c17edba0c6a9e);
$parcel$export(module.exports, "CHANGE_TONE_NESTED_MENU", () => $eeb1fde579dcd221$export$1356bd5d76f7fc4);
$parcel$export(module.exports, "SPELLING_AND_GRAMMAR_MENU_ITEM", () => $eeb1fde579dcd221$export$ba297ac76e077190);
$parcel$export(module.exports, "CHANGE_TONE_MENU_SECTION", () => $eeb1fde579dcd221$export$86a7882cf39bf1df);
$parcel$export(module.exports, "MORE_PROFESSIONAL_MENU_ITEM", () => $eeb1fde579dcd221$export$d868febccc6870c7);
$parcel$export(module.exports, "MORE_CASUAL_MENU_ITEM", () => $eeb1fde579dcd221$export$4a7c57dd33fc4a14);
$parcel$export(module.exports, "MORE_EMPATHETIC_MENU_ITEM", () => $eeb1fde579dcd221$export$3758b89123aa4456);
$parcel$export(module.exports, "TRANSLATE_NESTED_MENU", () => $eeb1fde579dcd221$export$76118e0d25ac1fef);
$parcel$export(module.exports, "TRANSLATE_MENU_SECTION", () => $eeb1fde579dcd221$export$a526b8293dafd11c);
$parcel$export(module.exports, "DEFINE_MENU_ITEM", () => $eeb1fde579dcd221$export$5836877aa3028c9d);
$parcel$export(module.exports, "DEFINE_GROUP", () => $eeb1fde579dcd221$export$92f779590a87713f);
$parcel$export(module.exports, "DEFINE_BUTTON", () => $eeb1fde579dcd221$export$8bfe594eeaed8635);
$parcel$export(module.exports, "ADD_POLISH_MENU_ITEM", () => $eeb1fde579dcd221$export$8d0a77a358b8b557);
$parcel$export(module.exports, "AI_SUGGESTIONS_GROUP", () => $eeb1fde579dcd221$export$b60b22005cb1946b);
$parcel$export(module.exports, "AI_SUGGESTIONS_BUTTON", () => $eeb1fde579dcd221$export$3c6ba64af5b24c36);
$parcel$export(module.exports, "TEXT_SECTION", () => $eeb1fde579dcd221$export$46f6ca06869869c);
$parcel$export(module.exports, "TEXT_SECTION_PRIMARY_TOOLBAR", () => $eeb1fde579dcd221$export$9821adc8accbec40);
$parcel$export(module.exports, "TEXT_SECTION_COLLAPSED", () => $eeb1fde579dcd221$export$65db33ca2d38a784);
$parcel$export(module.exports, "TEXT_COLLAPSED_GROUP", () => $eeb1fde579dcd221$export$dbb8e55d66b9ce7c);
$parcel$export(module.exports, "TEXT_COLLAPSED_MENU", () => $eeb1fde579dcd221$export$50e256f5fa0723b1);
$parcel$export(module.exports, "TEXT_STYLES_GROUP", () => $eeb1fde579dcd221$export$17de14a70389be62);
$parcel$export(module.exports, "TEXT_STYLES_MENU", () => $eeb1fde579dcd221$export$e3c7868e9e7f30f);
$parcel$export(module.exports, "TEXT_STYLES_MENU_SECTION", () => $eeb1fde579dcd221$export$61c471f0e406c6cd);
$parcel$export(module.exports, "NUMBERED_HEADINGS_MENU_SECTION", () => $eeb1fde579dcd221$export$de70e72f2905a257);
$parcel$export(module.exports, "NUMBERED_HEADINGS_MENU_ITEM", () => $eeb1fde579dcd221$export$1808665c7f7430e7);
$parcel$export(module.exports, "NORMAL_TEXT_MENU_ITEM", () => $eeb1fde579dcd221$export$a0d395bab4f77bed);
$parcel$export(module.exports, "SMALL_TEXT_MENU_ITEM", () => $eeb1fde579dcd221$export$e01e7ae5367e3f41);
$parcel$export(module.exports, "HEADING_1_MENU_ITEM", () => $eeb1fde579dcd221$export$2469e8506da598d3);
$parcel$export(module.exports, "HEADING_2_MENU_ITEM", () => $eeb1fde579dcd221$export$a065aede28a4fa60);
$parcel$export(module.exports, "HEADING_3_MENU_ITEM", () => $eeb1fde579dcd221$export$85070b7c6d42e3bb);
$parcel$export(module.exports, "HEADING_4_MENU_ITEM", () => $eeb1fde579dcd221$export$e78c2531f67b545f);
$parcel$export(module.exports, "HEADING_5_MENU_ITEM", () => $eeb1fde579dcd221$export$a92294de346392be);
$parcel$export(module.exports, "HEADING_6_MENU_ITEM", () => $eeb1fde579dcd221$export$9c3cdc8e6d51ce82);
$parcel$export(module.exports, "BLOCK_QUOTE_MENU_ITEM", () => $eeb1fde579dcd221$export$f4b89f87980eb537);
$parcel$export(module.exports, "TEXT_FORMATTING_GROUP", () => $eeb1fde579dcd221$export$acdcd8bfebadff8e);
$parcel$export(module.exports, "TEXT_FORMATTING_GROUP_COLLAPSED", () => $eeb1fde579dcd221$export$3efe78988280adb3);
$parcel$export(module.exports, "TEXT_FORMATTING_GROUP_INLINE", () => $eeb1fde579dcd221$export$d709b777a6a93241);
$parcel$export(module.exports, "BOLD_BUTTON_GROUP", () => $eeb1fde579dcd221$export$e54b89ebe974229a);
$parcel$export(module.exports, "UNDERLINE_BUTTON_GROUP", () => $eeb1fde579dcd221$export$eb8680bccd13ec29);
$parcel$export(module.exports, "TEXT_FORMATTING_HERO_BUTTON", () => $eeb1fde579dcd221$export$b1308631b6ed4b3);
$parcel$export(module.exports, "TEXT_FORMATTING_HERO_BUTTON_COLLAPSED", () => $eeb1fde579dcd221$export$1f2df85e05c78a28);
$parcel$export(module.exports, "BOLD_BUTTON", () => $eeb1fde579dcd221$export$512cce888b603a21);
$parcel$export(module.exports, "UNDERLINE_BUTTON", () => $eeb1fde579dcd221$export$8ba429f81350a9a5);
$parcel$export(module.exports, "TEXT_FORMATTING_MENU", () => $eeb1fde579dcd221$export$6ed8e5719ec9c8ca);
$parcel$export(module.exports, "BOLD_MENU_ITEM", () => $eeb1fde579dcd221$export$8bc14fdbfc88e3d);
$parcel$export(module.exports, "ITALIC_MENU_ITEM", () => $eeb1fde579dcd221$export$55cababf49d70434);
$parcel$export(module.exports, "UNDERLINE_MENU_ITEM", () => $eeb1fde579dcd221$export$74aa4c917d0fb179);
$parcel$export(module.exports, "STRIKE_MENU_ITEM", () => $eeb1fde579dcd221$export$9caef6162846aa5f);
$parcel$export(module.exports, "CODE_MENU_ITEM", () => $eeb1fde579dcd221$export$33821ea6eceb9d13);
$parcel$export(module.exports, "SUBSCRIPT_MENU_ITEM", () => $eeb1fde579dcd221$export$ee8cb7d7ef764bfe);
$parcel$export(module.exports, "SUPERSCRIPT_MENU_ITEM", () => $eeb1fde579dcd221$export$85ead1ec02f87839);
$parcel$export(module.exports, "TEXT_FORMATTING_MENU_SECTION", () => $eeb1fde579dcd221$export$6f16936b77c05f44);
$parcel$export(module.exports, "CLEAR_FORMARTTING_MENU_SECTION", () => $eeb1fde579dcd221$export$2d7a9246359565f);
$parcel$export(module.exports, "CLEAR_FORMATTING_MENU_ITEM", () => $eeb1fde579dcd221$export$2577e452f5468087);
$parcel$export(module.exports, "TEXT_COLOR_HIGHLIGHT_GROUP", () => $eeb1fde579dcd221$export$eb99509879c4d1a6);
$parcel$export(module.exports, "TEXT_COLOR_HIGHLIGHT_MENU", () => $eeb1fde579dcd221$export$126ef012ef4d8c5f);
$parcel$export(module.exports, "TEXT_COLOR_HIGHLIGHT_MENU_SECTION", () => $eeb1fde579dcd221$export$70638f1e77085913);
$parcel$export(module.exports, "TEXT_COLOR_MENU_ITEM", () => $eeb1fde579dcd221$export$ebd1271b08f151b0);
$parcel$export(module.exports, "HIGHLIGHT_MENU_ITEM", () => $eeb1fde579dcd221$export$bae2fe42c2b86102);
$parcel$export(module.exports, "CLEAR_COLOR_MENU_ITEM", () => $eeb1fde579dcd221$export$267f9526bd36c2c);
$parcel$export(module.exports, "COLOR_ACCESSIBILITY_MENU_ITEM", () => $eeb1fde579dcd221$export$97870c389b03ef61);
$parcel$export(module.exports, "ALIGNMENT_GROUP", () => $eeb1fde579dcd221$export$36cf1d476157a47d);
$parcel$export(module.exports, "ALIGNMENT_MENU", () => $eeb1fde579dcd221$export$b9d75d8ec913c411);
$parcel$export(module.exports, "ALIGNMENT_MENU_SECTION", () => $eeb1fde579dcd221$export$a7d30f7c1c00dd6e);
$parcel$export(module.exports, "ALIGN_LEFT_MENU_ITEM", () => $eeb1fde579dcd221$export$fb5e83c02abc1116);
$parcel$export(module.exports, "ALIGN_CENTER_MENU_ITEM", () => $eeb1fde579dcd221$export$920b9c1f02074883);
$parcel$export(module.exports, "ALIGN_RIGHT_MENU_ITEM", () => $eeb1fde579dcd221$export$77c582b2c8fa437c);
$parcel$export(module.exports, "LISTS_INDENTATION_GROUP", () => $eeb1fde579dcd221$export$cfa2bcff371b7719);
$parcel$export(module.exports, "LISTS_INDENTATION_GROUP_COLLAPSED", () => $eeb1fde579dcd221$export$e24e846ad969dbb4);
$parcel$export(module.exports, "LISTS_INDENTATION_GROUP_INLINE", () => $eeb1fde579dcd221$export$18e3c58ea662f7ad);
$parcel$export(module.exports, "BULLETED_LIST_BUTTON_GROUP", () => $eeb1fde579dcd221$export$93963c53c29fc835);
$parcel$export(module.exports, "BULLETED_LIST_BUTTON", () => $eeb1fde579dcd221$export$6c8387a14e0128fe);
$parcel$export(module.exports, "LISTS_INDENTATION_HERO_BUTTON_COLLAPSED", () => $eeb1fde579dcd221$export$f625e29dbd38e447);
$parcel$export(module.exports, "LISTS_INDENTATION_HERO_BUTTON", () => $eeb1fde579dcd221$export$8709d937e93456c5);
$parcel$export(module.exports, "LISTS_INDENTATION_MENU", () => $eeb1fde579dcd221$export$77b7fc28d250a53f);
$parcel$export(module.exports, "LISTS_INDENTATION_MENU_SECTION", () => $eeb1fde579dcd221$export$21a99ac537934e71);
$parcel$export(module.exports, "BULLETED_LIST_MENU_ITEM", () => $eeb1fde579dcd221$export$fc39a5dc74747fed);
$parcel$export(module.exports, "NUMBERED_LIST_MENU_ITEM", () => $eeb1fde579dcd221$export$9d64032e4ea1097c);
$parcel$export(module.exports, "TASK_LIST_MENU_ITEM", () => $eeb1fde579dcd221$export$d6bac99c24b8cdfd);
$parcel$export(module.exports, "INDENT_MENU_ITEM", () => $eeb1fde579dcd221$export$87678574248a0249);
$parcel$export(module.exports, "OUTDENT_MENU_ITEM", () => $eeb1fde579dcd221$export$8fc4080aa2f8adc2);
$parcel$export(module.exports, "INSERT_BLOCK_SECTION", () => $eeb1fde579dcd221$export$8be58f85d6f2b208);
$parcel$export(module.exports, "CODE_BLOCK_GROUP", () => $eeb1fde579dcd221$export$a55d93db15cde50c);
$parcel$export(module.exports, "CODE_BLOCK_BUTTON", () => $eeb1fde579dcd221$export$22d0f50f2ec2f1a8);
$parcel$export(module.exports, "TASK_LIST_GROUP", () => $eeb1fde579dcd221$export$6265c903e79c43eb);
$parcel$export(module.exports, "TASK_LIST_BUTTON", () => $eeb1fde579dcd221$export$9634f504f88ede38);
$parcel$export(module.exports, "MEDIA_GROUP", () => $eeb1fde579dcd221$export$ce4671f9066f5c48);
$parcel$export(module.exports, "MEDIA_BUTTON", () => $eeb1fde579dcd221$export$37025ad4bfe1d2aa);
$parcel$export(module.exports, "MENTION_GROUP", () => $eeb1fde579dcd221$export$f4c921ea7ce3d48a);
$parcel$export(module.exports, "MENTION_BUTTON", () => $eeb1fde579dcd221$export$450b9a588cdf3949);
$parcel$export(module.exports, "EMOJI_GROUP", () => $eeb1fde579dcd221$export$6ca7976638436c6);
$parcel$export(module.exports, "EMOJI_BUTTON", () => $eeb1fde579dcd221$export$a4310034b096a4ad);
$parcel$export(module.exports, "LAYOUT_GROUP", () => $eeb1fde579dcd221$export$f746b10bd135ebe5);
$parcel$export(module.exports, "LAYOUT_BUTTON", () => $eeb1fde579dcd221$export$bc099bce567fd020);
$parcel$export(module.exports, "TABLE_GROUP", () => $eeb1fde579dcd221$export$19b0175d8da45496);
$parcel$export(module.exports, "TABLE_BUTTON", () => $eeb1fde579dcd221$export$c37ae5d099679682);
$parcel$export(module.exports, "TABLE_SIZE_PICKER", () => $eeb1fde579dcd221$export$c796ec87818935d5);
$parcel$export(module.exports, "INSERT_GROUP", () => $eeb1fde579dcd221$export$2db6abe323bf312e);
$parcel$export(module.exports, "INSERT_BUTTON", () => $eeb1fde579dcd221$export$2b79c1387bf4ea1b);
$parcel$export(module.exports, "LINKING_SECTION", () => $eeb1fde579dcd221$export$1fc1401e9e5d8a);
$parcel$export(module.exports, "LINKING_GROUP", () => $eeb1fde579dcd221$export$87f2f2ff3eb62f79);
$parcel$export(module.exports, "LINKING_BUTTON", () => $eeb1fde579dcd221$export$3d214445dcf942f2);
$parcel$export(module.exports, "SYNCED_BLOCK_GROUP", () => $eeb1fde579dcd221$export$8d13eb2ec1e19466);
$parcel$export(module.exports, "SYNCED_BLOCK_BUTTON", () => $eeb1fde579dcd221$export$f7a124e17ae9698f);
$parcel$export(module.exports, "SYNCED_BLOCK_SECTION", () => $eeb1fde579dcd221$export$796e931612f154e7);
$parcel$export(module.exports, "COLLAB_SECTION", () => $eeb1fde579dcd221$export$457818231baddd40);
$parcel$export(module.exports, "COMMENT_GROUP", () => $eeb1fde579dcd221$export$8978fe8e689744cc);
$parcel$export(module.exports, "COMMENT_HERO_BUTTON", () => $eeb1fde579dcd221$export$f97beb46382b3388);
$parcel$export(module.exports, "APPS_SECTION", () => $eeb1fde579dcd221$export$d757fc54a1831d82);
$parcel$export(module.exports, "TRACK_CHANGES_SECTION", () => $eeb1fde579dcd221$export$c3f44bc1025dceb2);
$parcel$export(module.exports, "UNDO_CHANGES_GROUP", () => $eeb1fde579dcd221$export$b3d4f2cdc057cba1);
$parcel$export(module.exports, "UNDO_BUTTON", () => $eeb1fde579dcd221$export$f13c32a4c68c0806);
$parcel$export(module.exports, "REDO_CHANGES_GROUP", () => $eeb1fde579dcd221$export$e149a5154bb9b44);
$parcel$export(module.exports, "REDO_BUTTON", () => $eeb1fde579dcd221$export$1fb249ec6ca34dd0);
$parcel$export(module.exports, "TRACK_CHANGES_GROUP", () => $eeb1fde579dcd221$export$8e3cd3ec14c6efc);
$parcel$export(module.exports, "TRACK_CHANGES_BUTTON", () => $eeb1fde579dcd221$export$9cfd2622f07061e0);
$parcel$export(module.exports, "OVERFLOW_SECTION", () => $eeb1fde579dcd221$export$cb18e5ae740a3f22);
$parcel$export(module.exports, "OVERFLOW_GROUP", () => $eeb1fde579dcd221$export$932f82408ad2af53);
$parcel$export(module.exports, "OVERFLOW_MENU", () => $eeb1fde579dcd221$export$6583eb3a2765795b);
$parcel$export(module.exports, "PIN_MENU_SECTION", () => $eeb1fde579dcd221$export$cefae60670d357d0);
$parcel$export(module.exports, "PIN_MENU_ITEM", () => $eeb1fde579dcd221$export$76d22fa71bc28346);
$parcel$export(module.exports, "OVERFLOW_SECTION_PRIMARY_TOOLBAR", () => $eeb1fde579dcd221$export$1b5ea0d5074f7d18);
$parcel$export(module.exports, "OVERFLOW_GROUP_PRIMARY_TOOLBAR", () => $eeb1fde579dcd221$export$a481b12c04259be8);
$parcel$export(module.exports, "OVERFLOW_MENU_PRIMARY_TOOLBAR", () => $eeb1fde579dcd221$export$b0bb124d5687709e);
$parcel$export(module.exports, "PIN_SECTION", () => $eeb1fde579dcd221$export$6d497f3df1049a22);
$parcel$export(module.exports, "PIN_GROUP", () => $eeb1fde579dcd221$export$762436e7516a2365);
$parcel$export(module.exports, "PIN_BUTTON", () => $eeb1fde579dcd221$export$cfefbb6355b14379);
$parcel$export(module.exports, "VIEW_MODE_TOGGLE_SECTION", () => $eeb1fde579dcd221$export$68f7a2de17e9e39d);
$parcel$export(module.exports, "LOOM_MENU_SECTION", () => $eeb1fde579dcd221$export$dd76f40d6548a654);
$parcel$export(module.exports, "LOOM_MENU_ITEM", () => $eeb1fde579dcd221$export$4ac3fd1884a40118);
$parcel$export(module.exports, "SELECTION_EXTENSION_MENU_SECTION", () => $eeb1fde579dcd221$export$debff7788300c3ff);
$parcel$export(module.exports, "OVERFLOW_EXTENSIONS_MENU_SECTION", () => $eeb1fde579dcd221$export$3752412f1cf2bc0e);
$parcel$export(module.exports, "FIRST_PARTY_EXTENSIONS_MENU_ITEM", () => $eeb1fde579dcd221$export$41bea16b66da911);
$parcel$export(module.exports, "EXTERNAL_EXTENSIONS_MENU_ITEM", () => $eeb1fde579dcd221$export$4b664282d7b95d2c);
$parcel$export(module.exports, "PASTE_MENU", () => $eeb1fde579dcd221$export$b4e8aaf730259f83);
$parcel$export(module.exports, "PASTE_MENU_SECTION", () => $eeb1fde579dcd221$export$76da35b5d1c35bbe);
$parcel$export(module.exports, "PASTE_NESTED_MENU", () => $eeb1fde579dcd221$export$5646e8ff118a2c3f);
$parcel$export(module.exports, "PASTE_MENU_NESTED_SECTION", () => $eeb1fde579dcd221$export$4a6eb83eeeb712a);
$parcel$export(module.exports, "PASTE_RICH_TEXT_MENU_ITEM", () => $eeb1fde579dcd221$export$7528e3cffa17b456);
$parcel$export(module.exports, "PASTE_MARKDOWN_MENU_ITEM", () => $eeb1fde579dcd221$export$d10c0f4ac46a1253);
$parcel$export(module.exports, "PASTE_PLAIN_TEXT_MENU_ITEM", () => $eeb1fde579dcd221$export$ef2727de8c063819);
$parcel$export(module.exports, "AI_PASTE_MENU_SECTION", () => $eeb1fde579dcd221$export$4d6ba29b72804f46);
$parcel$export(module.exports, "SMART_LINK_DISPLAY_AS_PASTE_MENU_SECTION", () => $eeb1fde579dcd221$export$fe45b268a1e660de);
$parcel$export(module.exports, "TOOLBAR_BUTTON_TEST_ID", () => $eeb1fde579dcd221$export$7897566b2299aaf5);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ const $eeb1fde579dcd221$export$cc1c18c6e6b6ecaf = {
    INLINE_TEXT_TOOLBAR: 'inline-text-toolbar',
    PRIMARY_TOOLBAR: 'primary-toolbar'
};
const $eeb1fde579dcd221$export$78ec0124ca63fa02 = {
    key: 'ai-section',
    type: 'section'
};
const $eeb1fde579dcd221$export$124d2ee606ccdfdc = {
    key: 'ai-view-section',
    type: 'section'
};
const $eeb1fde579dcd221$export$6d5407fbb0bc912e = {
    key: 'ai-section-primary-toolbar',
    type: 'section'
};
const $eeb1fde579dcd221$export$ea53d97c37cdede3 = {
    key: 'ai-section-full-page-primary-toolbar',
    type: 'section'
};
const $eeb1fde579dcd221$export$dcbeb7730f347566 = {
    key: 'ai-section-comment-primary-toolbar',
    type: 'section'
};
const $eeb1fde579dcd221$export$ab61657fb37116be = {
    key: 'rovo-group',
    type: 'group'
};
const $eeb1fde579dcd221$export$b0e50b17917e2523 = {
    key: 'rovo-group-view',
    type: 'group'
};
const $eeb1fde579dcd221$export$67ae7e5d398cd98 = {
    key: 'rovo-group-primary-toolbar',
    type: 'group'
};
const $eeb1fde579dcd221$export$393a27a1587c4748 = {
    key: 'rovo-group-display-small',
    type: 'group'
};
const $eeb1fde579dcd221$export$164a0130b2b649c6 = {
    key: 'improve-writing-group',
    type: 'group'
};
const $eeb1fde579dcd221$export$e7c291289ee98d9 = {
    key: 'improve-writing-button',
    type: 'button'
};
const $eeb1fde579dcd221$export$50fb6fd780a8da5a = {
    key: 'hero-prompt-button-group',
    type: 'group'
};
const $eeb1fde579dcd221$export$6ea8ae73b826b63e = {
    key: 'hero-prompt-button',
    type: 'button'
};
const $eeb1fde579dcd221$export$3d823cd1493e8383 = {
    key: 'rovo-hero-button',
    type: 'button'
};
const $eeb1fde579dcd221$export$bc3c6b8bbdf543d6 = {
    key: 'rovo-write-button-primary-toolbar',
    type: 'button'
};
const $eeb1fde579dcd221$export$4532eefb6fdb660c = {
    key: 'rovo-menu',
    type: 'menu'
};
const $eeb1fde579dcd221$export$245b51779748026d = {
    key: 'rovo-menu-display-small',
    type: 'menu'
};
const $eeb1fde579dcd221$export$f157764a2d8d74e6 = {
    key: 'rovo-prompt-menu-section',
    type: 'menu-section'
};
const $eeb1fde579dcd221$export$8be015e65f184637 = {
    key: 'rovo-prompt-menu-section-display-small',
    type: 'menu-section'
};
const $eeb1fde579dcd221$export$c9c5b3ece9aa9724 = {
    key: 'improve-writing-menu-item',
    type: 'menu-item'
};
const $eeb1fde579dcd221$export$1ede5932cecaa59 = {
    key: 'hero-prompt-menu-item',
    type: 'menu-item'
};
const $eeb1fde579dcd221$export$4799f439258ea378 = {
    key: 'make-shorter-menu-item',
    type: 'menu-item'
};
const $eeb1fde579dcd221$export$b82c17edba0c6a9e = {
    key: 'make-longer-menu-item',
    type: 'menu-item'
};
const $eeb1fde579dcd221$export$1356bd5d76f7fc4 = {
    key: 'change-tone-nested-menu',
    type: 'nested-menu'
};
const $eeb1fde579dcd221$export$ba297ac76e077190 = {
    key: 'spelling-and-grammar-menu-item',
    type: 'menu-item'
};
const $eeb1fde579dcd221$export$86a7882cf39bf1df = {
    key: 'change-tone-default-menu-section',
    type: 'menu-section'
};
const $eeb1fde579dcd221$export$d868febccc6870c7 = {
    key: 'more-professional-menu-item',
    type: 'menu-item'
};
const $eeb1fde579dcd221$export$4a7c57dd33fc4a14 = {
    key: 'more-casual-menu-item',
    type: 'menu-item'
};
const $eeb1fde579dcd221$export$3758b89123aa4456 = {
    key: 'more-empathetic-menu-item',
    type: 'menu-item'
};
const $eeb1fde579dcd221$export$76118e0d25ac1fef = {
    key: 'translate-nested-menu',
    type: 'nested-menu'
};
const $eeb1fde579dcd221$export$a526b8293dafd11c = {
    key: 'translate-menu-section',
    type: 'menu-section'
};
const $eeb1fde579dcd221$export$5836877aa3028c9d = {
    key: 'define-menu-item',
    type: 'menu-item'
};
const $eeb1fde579dcd221$export$92f779590a87713f = {
    key: 'define-group',
    type: 'group'
};
const $eeb1fde579dcd221$export$8bfe594eeaed8635 = {
    key: 'define-button',
    type: 'button'
};
const $eeb1fde579dcd221$export$8d0a77a358b8b557 = {
    key: 'add-polish-menu-item',
    type: 'menu-item'
};
const $eeb1fde579dcd221$export$b60b22005cb1946b = {
    key: 'ai-suggestions-group',
    type: 'group'
};
const $eeb1fde579dcd221$export$3c6ba64af5b24c36 = {
    key: 'ai-suggestions-button',
    type: 'button'
};
const $eeb1fde579dcd221$export$46f6ca06869869c = {
    key: 'text-section',
    type: 'section'
};
const $eeb1fde579dcd221$export$9821adc8accbec40 = {
    key: 'text-section-primary-toolbar',
    type: 'section'
};
const $eeb1fde579dcd221$export$65db33ca2d38a784 = {
    key: 'text-section-collapsed',
    type: 'section'
};
const $eeb1fde579dcd221$export$dbb8e55d66b9ce7c = {
    key: 'text-collapsed-group',
    type: 'group'
};
const $eeb1fde579dcd221$export$50e256f5fa0723b1 = {
    key: 'text-collapsed-menu',
    type: 'menu'
};
const $eeb1fde579dcd221$export$17de14a70389be62 = {
    key: 'text-styles-group',
    type: 'group'
};
const $eeb1fde579dcd221$export$e3c7868e9e7f30f = {
    key: 'text-styles-menu',
    type: 'menu'
};
const $eeb1fde579dcd221$export$61c471f0e406c6cd = {
    key: 'text-styles-menu-section',
    type: 'menu-section'
};
const $eeb1fde579dcd221$export$de70e72f2905a257 = {
    key: 'numbered-headings-menu-section',
    type: 'menu-section'
};
const $eeb1fde579dcd221$export$1808665c7f7430e7 = {
    key: 'numbered-headings-menu-item',
    type: 'menu-item'
};
const $eeb1fde579dcd221$export$a0d395bab4f77bed = {
    key: 'normal-text-menu-item',
    type: 'menu-item'
};
const $eeb1fde579dcd221$export$e01e7ae5367e3f41 = {
    key: 'small-text-menu-item',
    type: 'menu-item'
};
const $eeb1fde579dcd221$export$2469e8506da598d3 = {
    key: 'heading-1-menu-item',
    type: 'menu-item'
};
const $eeb1fde579dcd221$export$a065aede28a4fa60 = {
    key: 'heading-2-menu-item',
    type: 'menu-item'
};
const $eeb1fde579dcd221$export$85070b7c6d42e3bb = {
    key: 'heading-3-menu-item',
    type: 'menu-item'
};
const $eeb1fde579dcd221$export$e78c2531f67b545f = {
    key: 'heading-4-menu-item',
    type: 'menu-item'
};
const $eeb1fde579dcd221$export$a92294de346392be = {
    key: 'heading-5-menu-item',
    type: 'menu-item'
};
const $eeb1fde579dcd221$export$9c3cdc8e6d51ce82 = {
    key: 'heading-6-menu-item',
    type: 'menu-item'
};
const $eeb1fde579dcd221$export$f4b89f87980eb537 = {
    key: 'block-quote-menu-item',
    type: 'menu-item'
};
const $eeb1fde579dcd221$export$acdcd8bfebadff8e = {
    key: 'text-formatting-group',
    type: 'group'
};
const $eeb1fde579dcd221$export$3efe78988280adb3 = {
    key: 'text-formatting-group-collapsed',
    type: 'group'
};
const $eeb1fde579dcd221$export$d709b777a6a93241 = {
    key: 'text-formatting-group-inline',
    type: 'group'
};
const $eeb1fde579dcd221$export$e54b89ebe974229a = {
    key: 'bold-button-group',
    type: 'group'
};
const $eeb1fde579dcd221$export$eb8680bccd13ec29 = {
    key: 'underline-button-group',
    type: 'group'
};
const $eeb1fde579dcd221$export$b1308631b6ed4b3 = {
    key: 'text-formatting-hero-button',
    type: 'button'
};
const $eeb1fde579dcd221$export$1f2df85e05c78a28 = {
    key: 'text-formatting-hero-button-collapsed',
    type: 'button'
};
const $eeb1fde579dcd221$export$512cce888b603a21 = {
    key: 'bold-button',
    type: 'button'
};
const $eeb1fde579dcd221$export$8ba429f81350a9a5 = {
    key: 'underline-button',
    type: 'button'
};
const $eeb1fde579dcd221$export$6ed8e5719ec9c8ca = {
    key: 'text-formatting-menu',
    type: 'menu'
};
const $eeb1fde579dcd221$export$8bc14fdbfc88e3d = {
    key: 'bold-menu-item',
    type: 'menu-item'
};
const $eeb1fde579dcd221$export$55cababf49d70434 = {
    key: 'italic-menu-item',
    type: 'menu-item'
};
const $eeb1fde579dcd221$export$74aa4c917d0fb179 = {
    key: 'underline-menu-item',
    type: 'menu-item'
};
const $eeb1fde579dcd221$export$9caef6162846aa5f = {
    key: 'strike-menu-item',
    type: 'menu-item'
};
const $eeb1fde579dcd221$export$33821ea6eceb9d13 = {
    key: 'code-menu-item',
    type: 'menu-item'
};
const $eeb1fde579dcd221$export$ee8cb7d7ef764bfe = {
    key: 'subscript-menu-item',
    type: 'menu-item'
};
const $eeb1fde579dcd221$export$85ead1ec02f87839 = {
    key: 'superscript-menu-item',
    type: 'menu-item'
};
const $eeb1fde579dcd221$export$6f16936b77c05f44 = {
    key: 'text-formatting-menu-section',
    type: 'menu-section'
};
const $eeb1fde579dcd221$export$2d7a9246359565f = {
    key: 'clear-formatting-menu-section',
    type: 'menu-section'
};
const $eeb1fde579dcd221$export$2577e452f5468087 = {
    key: 'clear-formatting-menu-item',
    type: 'menu-item'
};
const $eeb1fde579dcd221$export$eb99509879c4d1a6 = {
    key: 'text-color-highlight-group',
    type: 'group'
};
const $eeb1fde579dcd221$export$126ef012ef4d8c5f = {
    key: 'text-color-highlight-menu',
    type: 'menu'
};
const $eeb1fde579dcd221$export$70638f1e77085913 = {
    key: 'text-color-highlight-menu-section',
    type: 'menu-section'
};
const $eeb1fde579dcd221$export$ebd1271b08f151b0 = {
    key: 'text-color-menu-item',
    type: 'menu-item'
};
const $eeb1fde579dcd221$export$bae2fe42c2b86102 = {
    key: 'highlight-menu-item',
    type: 'menu-item'
};
const $eeb1fde579dcd221$export$267f9526bd36c2c = {
    key: 'clear-color-menu-item',
    type: 'menu-item'
};
const $eeb1fde579dcd221$export$97870c389b03ef61 = {
    key: 'color-accessibility-menu-item',
    type: 'menu-item'
};
const $eeb1fde579dcd221$export$36cf1d476157a47d = {
    key: 'alignment-group',
    type: 'group'
};
const $eeb1fde579dcd221$export$b9d75d8ec913c411 = {
    key: 'alignment-menu',
    type: 'menu'
};
const $eeb1fde579dcd221$export$a7d30f7c1c00dd6e = {
    key: 'alignment-menu-section',
    type: 'menu-section'
};
const $eeb1fde579dcd221$export$fb5e83c02abc1116 = {
    key: 'align-left-menu-item',
    type: 'menu-item'
};
const $eeb1fde579dcd221$export$920b9c1f02074883 = {
    key: 'align-center-menu-item',
    type: 'menu-item'
};
const $eeb1fde579dcd221$export$77c582b2c8fa437c = {
    key: 'align-right-menu-item',
    type: 'menu-item'
};
const $eeb1fde579dcd221$export$cfa2bcff371b7719 = {
    key: 'lists-indentation-group',
    type: 'group'
};
const $eeb1fde579dcd221$export$e24e846ad969dbb4 = {
    key: 'lists-indentation-group-collapsed',
    type: 'group'
};
const $eeb1fde579dcd221$export$18e3c58ea662f7ad = {
    key: 'lists-indentation-group-inline',
    type: 'group'
};
const $eeb1fde579dcd221$export$93963c53c29fc835 = {
    key: 'bullet-list-button-group',
    type: 'group'
};
const $eeb1fde579dcd221$export$6c8387a14e0128fe = {
    key: 'bullet-list-button',
    type: 'button'
};
const $eeb1fde579dcd221$export$f625e29dbd38e447 = {
    key: 'lists-indentation-hero-button-collapsed',
    type: 'button'
};
const $eeb1fde579dcd221$export$8709d937e93456c5 = {
    key: 'lists-indentation-hero-button',
    type: 'button'
};
const $eeb1fde579dcd221$export$77b7fc28d250a53f = {
    key: 'lists-indentation-menu',
    type: 'menu'
};
const $eeb1fde579dcd221$export$21a99ac537934e71 = {
    key: 'lists-indendation-menu-section',
    type: 'menu-section'
};
const $eeb1fde579dcd221$export$fc39a5dc74747fed = {
    key: 'bullet-list-menu-item',
    type: 'menu-item'
};
const $eeb1fde579dcd221$export$9d64032e4ea1097c = {
    key: 'numbered-list-menu-item',
    type: 'menu-item'
};
const $eeb1fde579dcd221$export$d6bac99c24b8cdfd = {
    key: 'task-list-menu-item',
    type: 'menu-item'
};
const $eeb1fde579dcd221$export$87678574248a0249 = {
    key: 'indent-menu-item',
    type: 'menu-item'
};
const $eeb1fde579dcd221$export$8fc4080aa2f8adc2 = {
    key: 'outdent-menu-item',
    type: 'menu-item'
};
const $eeb1fde579dcd221$export$8be58f85d6f2b208 = {
    key: 'insert-block-section',
    type: 'section'
};
const $eeb1fde579dcd221$export$a55d93db15cde50c = {
    key: 'code-block-group',
    type: 'group'
};
const $eeb1fde579dcd221$export$22d0f50f2ec2f1a8 = {
    key: 'code-block-button',
    type: 'button'
};
const $eeb1fde579dcd221$export$6265c903e79c43eb = {
    key: 'task-list-group',
    type: 'group'
};
const $eeb1fde579dcd221$export$9634f504f88ede38 = {
    key: 'task-list-button',
    type: 'button'
};
const $eeb1fde579dcd221$export$ce4671f9066f5c48 = {
    key: 'media-group',
    type: 'group'
};
const $eeb1fde579dcd221$export$37025ad4bfe1d2aa = {
    key: 'media-button',
    type: 'button'
};
const $eeb1fde579dcd221$export$f4c921ea7ce3d48a = {
    key: 'mention-group',
    type: 'group'
};
const $eeb1fde579dcd221$export$450b9a588cdf3949 = {
    key: 'mention-button',
    type: 'button'
};
const $eeb1fde579dcd221$export$6ca7976638436c6 = {
    key: 'emoji-group',
    type: 'group'
};
const $eeb1fde579dcd221$export$a4310034b096a4ad = {
    key: 'emoji-button',
    type: 'button'
};
const $eeb1fde579dcd221$export$f746b10bd135ebe5 = {
    key: 'layout-group',
    type: 'group'
};
const $eeb1fde579dcd221$export$bc099bce567fd020 = {
    key: 'layout-button',
    type: 'button'
};
const $eeb1fde579dcd221$export$19b0175d8da45496 = {
    key: 'table-group',
    type: 'group'
};
const $eeb1fde579dcd221$export$c37ae5d099679682 = {
    key: 'table-button',
    type: 'button'
};
const $eeb1fde579dcd221$export$c796ec87818935d5 = {
    key: 'table-size-picker',
    type: 'button'
};
const $eeb1fde579dcd221$export$2db6abe323bf312e = {
    key: 'insert-group',
    type: 'group'
};
const $eeb1fde579dcd221$export$2b79c1387bf4ea1b = {
    key: 'insert-button',
    type: 'button'
};
const $eeb1fde579dcd221$export$1fc1401e9e5d8a = {
    key: 'linking-section',
    type: 'section'
};
const $eeb1fde579dcd221$export$87f2f2ff3eb62f79 = {
    key: 'linking-group',
    type: 'group'
};
const $eeb1fde579dcd221$export$3d214445dcf942f2 = {
    key: 'linking-button',
    type: 'button'
};
const $eeb1fde579dcd221$export$8d13eb2ec1e19466 = {
    key: 'synced-block-group',
    type: 'group'
};
const $eeb1fde579dcd221$export$f7a124e17ae9698f = {
    key: 'synced-block-button',
    type: 'button'
};
const $eeb1fde579dcd221$export$796e931612f154e7 = {
    key: 'synced-block-section',
    type: 'menu-section'
};
const $eeb1fde579dcd221$export$457818231baddd40 = {
    key: 'collab-section',
    type: 'section'
};
const $eeb1fde579dcd221$export$8978fe8e689744cc = {
    key: 'comment-group',
    type: 'group'
};
const $eeb1fde579dcd221$export$f97beb46382b3388 = {
    key: 'comment-hero-button',
    type: 'button'
};
const $eeb1fde579dcd221$export$d757fc54a1831d82 = {
    key: 'apps-section',
    type: 'section'
};
const $eeb1fde579dcd221$export$c3f44bc1025dceb2 = {
    key: 'track-changes-section',
    type: 'section'
};
const $eeb1fde579dcd221$export$b3d4f2cdc057cba1 = {
    key: 'undo-changes-group',
    type: 'group'
};
const $eeb1fde579dcd221$export$f13c32a4c68c0806 = {
    key: 'undo-button',
    type: 'button'
};
const $eeb1fde579dcd221$export$e149a5154bb9b44 = {
    key: 'redo-changes-group',
    type: 'group'
};
const $eeb1fde579dcd221$export$1fb249ec6ca34dd0 = {
    key: 'redo-button',
    type: 'button'
};
const $eeb1fde579dcd221$export$8e3cd3ec14c6efc = {
    key: 'track-changes-group',
    type: 'group'
};
const $eeb1fde579dcd221$export$9cfd2622f07061e0 = {
    key: 'track-changes-button',
    type: 'button'
};
const $eeb1fde579dcd221$export$cb18e5ae740a3f22 = {
    key: 'overflow-section',
    type: 'section'
};
const $eeb1fde579dcd221$export$932f82408ad2af53 = {
    key: 'overflow-group',
    type: 'group'
};
const $eeb1fde579dcd221$export$6583eb3a2765795b = {
    key: 'overflow-menu',
    type: 'menu'
};
const $eeb1fde579dcd221$export$cefae60670d357d0 = {
    key: 'pin-menu-section',
    type: 'menu-section'
};
const $eeb1fde579dcd221$export$76d22fa71bc28346 = {
    key: 'pin-menu-item',
    type: 'menu-item'
};
const $eeb1fde579dcd221$export$1b5ea0d5074f7d18 = {
    key: 'overflow-section-primary-toolbar',
    type: 'section'
};
const $eeb1fde579dcd221$export$a481b12c04259be8 = {
    key: 'overflow-group-primary-toolbar',
    type: 'group'
};
const $eeb1fde579dcd221$export$b0bb124d5687709e = {
    key: 'overflow-menu-primary-toolbar',
    type: 'menu'
};
const $eeb1fde579dcd221$export$6d497f3df1049a22 = {
    key: 'pin-section',
    type: 'section'
};
const $eeb1fde579dcd221$export$762436e7516a2365 = {
    key: 'pin-group',
    type: 'group'
};
const $eeb1fde579dcd221$export$cfefbb6355b14379 = {
    key: 'pin-button',
    type: 'button'
};
const $eeb1fde579dcd221$export$68f7a2de17e9e39d = {
    key: 'view-mode-toggle-section',
    type: 'section'
};
const $eeb1fde579dcd221$export$dd76f40d6548a654 = {
    key: 'loom-menu-section',
    type: 'menu-section'
};
const $eeb1fde579dcd221$export$4ac3fd1884a40118 = {
    key: 'loom-menu-item',
    type: 'menu-item'
};
const $eeb1fde579dcd221$export$debff7788300c3ff = {
    key: 'selection-extension-menu-section',
    type: 'menu-section'
};
const $eeb1fde579dcd221$export$3752412f1cf2bc0e = {
    key: 'overflow-extensions-menu-section',
    type: 'menu-section'
};
const $eeb1fde579dcd221$export$41bea16b66da911 = {
    key: 'first-party-extensions-menu-item',
    type: 'menu-item'
};
const $eeb1fde579dcd221$export$4b664282d7b95d2c = {
    key: 'external-extensions-menu-item',
    type: 'menu-item'
};
const $eeb1fde579dcd221$export$b4e8aaf730259f83 = {
    key: 'paste-menu',
    type: 'menu'
};
const $eeb1fde579dcd221$export$76da35b5d1c35bbe = {
    key: 'paste-menu-section',
    type: 'menu-section'
};
const $eeb1fde579dcd221$export$5646e8ff118a2c3f = {
    key: 'paste-nested-menu',
    type: 'nested-menu'
};
const $eeb1fde579dcd221$export$4a6eb83eeeb712a = {
    key: 'paste-menu-nested-section',
    type: 'menu-section'
};
const $eeb1fde579dcd221$export$7528e3cffa17b456 = {
    key: 'rich-text-menu-item',
    type: 'menu-item'
};
const $eeb1fde579dcd221$export$d10c0f4ac46a1253 = {
    key: 'markdown-menu-item',
    type: 'menu-item'
};
const $eeb1fde579dcd221$export$ef2727de8c063819 = {
    key: 'plain-text-menu-item',
    type: 'menu-item'
};
const $eeb1fde579dcd221$export$4d6ba29b72804f46 = {
    key: 'ai-paste-menu-section',
    type: 'menu-section'
};
const $eeb1fde579dcd221$export$fe45b268a1e660de = {
    key: 'smart-link-display-as-paste-menu-section',
    type: 'menu-section'
};
const $eeb1fde579dcd221$export$7897566b2299aaf5 = {
    INSERT: 'editor-toolbar-insert-button',
    EMOJI: 'editor-toolbar-emoji-button',
    IMAGE: 'editor-toolbar-image-button',
    MEDIA: 'editor-toolbar-media-button',
    TABLE: 'Table',
    // Keep original value to avoid breaking existing tests
    TABLE_SELECTOR: 'editor-toolbar-table-selector-button',
    MENTION: 'editor-toolbar-mention-button',
    LAYOUT: 'editor-toolbar-layout-button',
    TASK_LIST: 'editor-toolbar-task-list-button'
};

});

parcelRegister("kGfTG", function(module, exports) {
$parcel$export(module.exports, "isToolbar", () => $b3f0f2f3f63e4a1e$export$75279ffd74fef67b);
const $b3f0f2f3f63e4a1e$export$75279ffd74fef67b = (component)=>{
    return (component === null || component === void 0 ? void 0 : component.type) === 'toolbar';
};

});


parcelRegister("cD5dW", function(module, exports) {
$parcel$export(module.exports, "MainToolbar", () => $7a132b67c7a5efd9$export$f7e5e5a2fbd99270);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $eXRB5 = parcelRequire("eXRB5");

var $9wBwi = parcelRequire("9wBwi");
/**
 * ED-15802: Scenarios when a sticky bar is used:
 * 1. useStickyToolbar is true
 * 2. useStickyToolbar is a DOM element
 * 3. useStickyToolbar is an object and has offsetTop key;
 */ const $7a132b67c7a5efd9$var$getStickyParameters = (configuration)=>{
    // const isUsingStickyOffset, isHTMLElement is used so TS can properly infer types.
    const isHTMLElement = typeof configuration === 'object' && !('offsetTop' in configuration);
    const isUsingStickyOffset = typeof configuration === 'object' && 'offsetTop' in configuration;
    if (typeof configuration !== 'object') return {
        externalToolbarRef: undefined,
        offsetTop: undefined
    };
    if (isUsingStickyOffset) return {
        offsetTop: configuration.offsetTop
    };
    if (isHTMLElement) return {
        externalToolbarRef: configuration
    };
};
const $7a132b67c7a5efd9$export$f7e5e5a2fbd99270 = ({ useStickyToolbar: useStickyToolbar, twoLineEditorToolbar: twoLineEditorToolbar, children: children, isEditorModernisationEnabled: isEditorModernisationEnabled, isNewToolbarEnabled: isNewToolbarEnabled })=>{
    if (useStickyToolbar) return /*#__PURE__*/ (0, $dc70d.jsx)((0, $9wBwi.StickyToolbarCompiled), {
        ...$7a132b67c7a5efd9$var$getStickyParameters(useStickyToolbar),
        isEditorModernisationEnabled: isEditorModernisationEnabled,
        twoLineEditorToolbar: twoLineEditorToolbar,
        isNewToolbarEnabled: isNewToolbarEnabled,
        children: children
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $eXRB5.FixedToolbarCompiled), {
        isEditorModernisationEnabled: isEditorModernisationEnabled,
        twoLineEditorToolbar: twoLineEditorToolbar,
        isNewToolbarEnabled: isNewToolbarEnabled,
        children: children
    });
};

});
parcelRegister("eXRB5", function(module, exports) {
$parcel$export(module.exports, "FixedToolbarCompiled", () => $30204c448c9ed5be$export$698f02dc2a985568);
/* FixedToolbar-compiled.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $9fU1q = parcelRequire("9fU1q");
parcelRequire("bSJIT");
const $30204c448c9ed5be$var$MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT = 490;
const $30204c448c9ed5be$var$fixedToolbarCompiledStyles = {
    mainToolbarWrapper: "_kqswh2mm _4cvr1h6o _ca0qu2gc _u5f3u2gc _n3tdidpf _19bvv47k _1e0c1txw _4t3i1wug _bfhkvuon _16qsglyw _1khpidpf _lg5oidpf _1cuzidpf",
    mainToolbarWithoutLeftPadding: "_ca0qu2gc _u5f3u2gc _n3tdidpf _19bvu2gc",
    mainToolbarTwoLine: "_1uq61sxn _cnpmh9n0 _1djy1txw _17mgesu3 _1q27esu3 _16ec1txw",
    mainToolbarWrapperVisualRefresh: "_3pwj1osq",
    mainToolbarRadius: "_2rko12c2",
    editorModernisationToolbar: "_2rko15b0 _10yt1nax"
};
const $30204c448c9ed5be$export$698f02dc2a985568 = (props)=>/*#__PURE__*/ (0, $dc70d.jsx)("div", {
        "data-testid": "ak-editor-main-toolbar",
        className: (0, $9fU1q.default)([
            $30204c448c9ed5be$var$fixedToolbarCompiledStyles.mainToolbarWrapper,
            props.twoLineEditorToolbar && $30204c448c9ed5be$var$fixedToolbarCompiledStyles.mainToolbarTwoLine,
            $30204c448c9ed5be$var$fixedToolbarCompiledStyles.mainToolbarWrapperVisualRefresh,
            props.isNewToolbarEnabled && $30204c448c9ed5be$var$fixedToolbarCompiledStyles.mainToolbarWithoutLeftPadding,
            $30204c448c9ed5be$var$fixedToolbarCompiledStyles.mainToolbarRadius,
            props.isEditorModernisationEnabled && $30204c448c9ed5be$var$fixedToolbarCompiledStyles.editorModernisationToolbar
        ]),
        children: props.children
    });

});

parcelRegister("9wBwi", function(module, exports) {
$parcel$export(module.exports, "StickyToolbarCompiled", () => $68a86f93c67318cc$export$2005bfaa48dbb54b);
/* StickyToolbar-compiled.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");
const $68a86f93c67318cc$var$MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT = 490;
const $68a86f93c67318cc$var$akEditorMenuZIndex = 500;
const $68a86f93c67318cc$var$akEditorToolbarKeylineHeight = 2;
const $68a86f93c67318cc$var$stickyToolbarCompiledStyles = {
    mainToolbarWrapper: "_kqswh2mm _4cvr1h6o _ca0qu2gc _u5f3u2gc _n3tdidpf _19bvv47k _1e0c1txw _4t3i1wug _bfhkvuon _16qsglyw _1khpidpf _lg5oidpf _1cuzidpf",
    mainToolbarWithPadding: "_ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc",
    mainToolbarTwoLine: "_1uq61sxn _cnpmh9n0 _1djy1txw _17mgesu3 _1q27esu3 _16ec1txw",
    mainToolbarWrapperVisualRefresh: "_3pwj1osq",
    mainToolbarRadius: "_2rko12c2",
    editorModernisationToolbar: "_2rko15b0 _10yt1nax",
    stickyToolbarWrapper: "_v56416gf _kqsw1if8 _n3tdu2gc _1pbybfng _10ytl2q5"
};
const $68a86f93c67318cc$export$2005bfaa48dbb54b = (props)=>{
    const [top, setTop] = (0, $bSJIT.useState)(0);
    // ED-15802: if externalToolbarRef is passed in, set top to externalToolbarRef?.current?.clientHeight
    // else if offsetTop is a number set top to offsetTop
    // otherwise top is 0 as initial state
    (0, $bSJIT.useEffect)(()=>{
        var _props$externalToolba;
        if ((_props$externalToolba = props.externalToolbarRef) !== null && _props$externalToolba !== void 0 && (_props$externalToolba = _props$externalToolba.current) !== null && _props$externalToolba !== void 0 && _props$externalToolba.clientHeight) setTop(props.externalToolbarRef.current.clientHeight);
        else setTop(props.offsetTop || 0);
    }, [
        props.externalToolbarRef,
        props.offsetTop
    ]);
    const wrapperStyle = (0, $bSJIT.useMemo)(()=>({
            top: `${top}px`
        }), [
        top
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/enforce-style-prop -- top is computed dynamically from externalToolbarRef height / offsetTop and cannot be a static css value
        style: wrapperStyle,
        "data-testid": "ak-editor-main-toolbar",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $9fU1q.default)([
            $68a86f93c67318cc$var$stickyToolbarCompiledStyles.mainToolbarWrapper,
            props.twoLineEditorToolbar && $68a86f93c67318cc$var$stickyToolbarCompiledStyles.mainToolbarTwoLine,
            $68a86f93c67318cc$var$stickyToolbarCompiledStyles.mainToolbarWrapperVisualRefresh,
            $68a86f93c67318cc$var$stickyToolbarCompiledStyles.stickyToolbarWrapper,
            props.isNewToolbarEnabled && $68a86f93c67318cc$var$stickyToolbarCompiledStyles.mainToolbarWithPadding,
            $68a86f93c67318cc$var$stickyToolbarCompiledStyles.mainToolbarRadius,
            props.isEditorModernisationEnabled && $68a86f93c67318cc$var$stickyToolbarCompiledStyles.editorModernisationToolbar,
            'show-keyline'
        ]),
        children: props.children
    });
};

});



parcelRegister("bGW2u", function(module, exports) {
$parcel$export(module.exports, "FullPageEditor", () => $4f6f599c7dd2c202$export$a15423dd96de66f2);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $jxkn6 = parcelRequire("jxkn6");

var $lLDwe = parcelRequire("lLDwe");

var $6BIjC = parcelRequire("6BIjC");

var $2pWL6 = parcelRequire("2pWL6");

var $5beht = parcelRequire("5beht");

var $5bbjm = parcelRequire("5bbjm");

var $797yE = parcelRequire("797yE");

var $5N1Y4 = parcelRequire("5N1Y4");

var $dUXT6 = parcelRequire("dUXT6");

var $13zME = parcelRequire("13zME");

var $2PqLj = parcelRequire("2PqLj");

var $ipUgj = parcelRequire("ipUgj");

var $lVlMP = parcelRequire("lVlMP");
const $4f6f599c7dd2c202$var$SSR_TRACE_SEGMENT_NAME = 'reactEditorView/fullPageAppearance';
const $4f6f599c7dd2c202$var$useShowKeyline = (contentAreaRef)=>{
    const [showKeyline, setShowKeyline] = (0, $bSJIT.useState)(false);
    (0, $bSJIT.useEffect)(()=>{
        var _contentAreaRef$curre;
        if (!((_contentAreaRef$curre = contentAreaRef.current) !== null && _contentAreaRef$curre !== void 0 && _contentAreaRef$curre.contentArea)) return;
        const browser = (0, $jxkn6.getBrowserInfo)();
        const intersection = new IntersectionObserver(([entry])=>{
            setShowKeyline(!entry.isIntersecting && entry.boundingClientRect.top < entry.intersectionRect.top);
        }, {
            root: undefined,
            // Safari seems to miss events (on fast scroll) sometimes due
            // to differences in IntersectionObserver behaviour between browsers.
            // By lowering the threshold a little it gives Safari more
            // time to catch these events.
            threshold: browser.safari ? 0.98 : 1
        });
        intersection.observe(contentAreaRef.current.contentArea);
        return ()=>{
            intersection.disconnect();
        };
    }, [
        contentAreaRef
    ]);
    return showKeyline;
};
const $4f6f599c7dd2c202$var$hasCustomComponents = (components)=>{
    if (!components) return false;
    if ('before' in components) return Array.isArray(components.before) && components.before.length > 0 || !!components.before || Array.isArray(components.after) && components.after.length > 0 || !!components.after;
    return true;
};
const $4f6f599c7dd2c202$export$a15423dd96de66f2 = (props)=>{
    var _scrollContentContain, _scrollContentContain2;
    // Should be always the first statement in the component
    const firstRenderStartTimestampRef = (0, $bSJIT.useRef)(performance.now());
    const wrapperElementRef = (0, $bSJIT.useMemo)(()=>props.innerRef, [
        props.innerRef
    ]);
    const scrollContentContainerRef = (0, $bSJIT.useRef)(null);
    const showKeyline = $4f6f599c7dd2c202$var$useShowKeyline(scrollContentContainerRef);
    const editorAPI = props.editorAPI;
    const state = (0, $5beht.useSharedPluginStateWithSelector)(editorAPI, [
        'primaryToolbar',
        'interaction',
        'editorViewMode',
        'toolbar'
    ], (states)=>{
        var _states$primaryToolba, _states$interactionSt, _states$editorViewMod, _states$toolbarState;
        return {
            primaryToolbarComponents: (_states$primaryToolba = states.primaryToolbarState) === null || _states$primaryToolba === void 0 ? void 0 : _states$primaryToolba.components,
            interactionState: (_states$interactionSt = states.interactionState) === null || _states$interactionSt === void 0 ? void 0 : _states$interactionSt.interactionState,
            editorViewMode: (_states$editorViewMod = states.editorViewModeState) === null || _states$editorViewMod === void 0 ? void 0 : _states$editorViewMod.mode,
            contextualFormattingModeOverride: (_states$toolbarState = states.toolbarState) === null || _states$toolbarState === void 0 ? void 0 : _states$toolbarState.contextualFormattingModeOverride
        };
    });
    // Markdown Mode forces `'always-pinned'` while in source / preview view
    // (no PM selection to anchor a floating toolbar to). The user's docking
    // pref alone is not enough to decide whether to mount the primary toolbar
    // in that case — the override has to short-circuit the hide gate below.
    const forcePrimaryToolbarPinned = state.contextualFormattingModeOverride === 'always-pinned';
    const interactionState = state.interactionState;
    const primaryToolbarState = (0, $dUXT6.getPrimaryToolbarComponents)(editorAPI, state.primaryToolbarComponents);
    const hasHadInteraction = interactionState !== 'hasNotHadInteraction';
    let { toolbarDockingPosition: toolbarDockingPosition } = (0, $2pWL6.useSharedPluginStateSelector)(editorAPI, 'userPreferences.preferences') || {};
    if (!toolbarDockingPosition) {
        var _editorAPI$userPrefer;
        // This is a workaround for the rendering issue with the selection toolbar
        // when using useSharedPluginStateWithSelector the state is not yet
        // available when the editor is first loaded.
        // This causes the toolbar to blink creating a layout shift.
        const defaultDockingPosition = props.__livePage ? 'none' : 'top';
        toolbarDockingPosition = (editorAPI === null || editorAPI === void 0 || (_editorAPI$userPrefer = editorAPI.userPreferences) === null || _editorAPI$userPrefer === void 0 || (_editorAPI$userPrefer = _editorAPI$userPrefer.actions.getUserPreferences()) === null || _editorAPI$userPrefer === void 0 ? void 0 : _editorAPI$userPrefer.toolbarDockingPosition) ?? defaultDockingPosition;
    }
    let primaryToolbarComponents = props.primaryToolbarComponents;
    if (Array.isArray(primaryToolbarState === null || primaryToolbarState === void 0 ? void 0 : primaryToolbarState.components) && Array.isArray(primaryToolbarComponents)) primaryToolbarComponents = primaryToolbarState.components.concat(primaryToolbarComponents);
    let isEditorToolbarHidden = state.editorViewMode === 'view';
    const { customPrimaryToolbarComponents: customPrimaryToolbarComponents } = props;
    if ((0, $797yE.editorExperiment)('platform_editor_controls', 'variant1', {
        exposure: true
    })) // need to check if the toolbarDockingPosition is set to 'none' or 'top'
    {
        if (toolbarDockingPosition === 'none' && !forcePrimaryToolbarPinned) {
            primaryToolbarComponents = [];
            if (!$4f6f599c7dd2c202$var$hasCustomComponents(customPrimaryToolbarComponents)) isEditorToolbarHidden = true;
        }
    }
    const isToolbarAIFCEnabled = Boolean(editorAPI === null || editorAPI === void 0 ? void 0 : editorAPI.toolbar);
    const popupsBoundariesElement = props.popupsBoundariesElement || (scrollContentContainerRef === null || scrollContentContainerRef === void 0 || (_scrollContentContain = scrollContentContainerRef.current) === null || _scrollContentContain === void 0 ? void 0 : _scrollContentContain.containerArea) || undefined;
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $6BIjC.SSRRenderMeasure), {
        segmentName: $4f6f599c7dd2c202$var$SSR_TRACE_SEGMENT_NAME,
        startTimestampRef: firstRenderStartTimestampRef,
        onSSRMeasure: props.onSSRMeasure,
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $lLDwe.ContextPanelWidthProvider), {
            children: /*#__PURE__*/ (0, $dc70d.jsxs)((0, $13zME.FullPageEditorWrapperCompiled), {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: "akEditor",
                ref: wrapperElementRef,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props
                {
                    '--ak-editor-fullpage-toolbar-height': // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
                    (0, $5bbjm.FULL_PAGE_EDITOR_TOOLBAR_HEIGHT)(isToolbarAIFCEnabled)
                },
                children: [
                    !isEditorToolbarHidden && (isToolbarAIFCEnabled ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $lVlMP.FullPageToolbarNext), {
                        disabled: (0, $5N1Y4.expValEquals)('platform_editor_ssr_toolbar_optimistic', 'isEnabled', true) ? !hasHadInteraction ? false : !!props.disabled : !!props.disabled,
                        disabledWithoutInteractionLogic: !!props.disabled,
                        toolbarDockingPosition: toolbarDockingPosition,
                        beforeIcon: props.primaryToolbarIconBefore,
                        editorAPI: editorAPI,
                        editorView: props.editorView,
                        popupsMountPoint: props.popupsMountPoint,
                        popupsBoundariesElement: props.popupsBoundariesElement,
                        popupsScrollableElement: props.popupsScrollableElement,
                        showKeyline: showKeyline,
                        customPrimaryToolbarComponents: props.customPrimaryToolbarComponents
                    }) : /*#__PURE__*/ (0, $dc70d.jsx)((0, $ipUgj.FullPageToolbar), {
                        appearance: props.appearance,
                        editorAPI: editorAPI,
                        beforeIcon: props.primaryToolbarIconBefore,
                        collabEdit: props.collabEdit,
                        containerElement: ((_scrollContentContain2 = scrollContentContainerRef.current) === null || _scrollContentContain2 === void 0 ? void 0 : _scrollContentContain2.scrollContainer) ?? null,
                        customPrimaryToolbarComponents: props.customPrimaryToolbarComponents,
                        disabled: !!props.disabled,
                        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
                        editorActions: props.editorActions,
                        editorDOMElement: props.editorDOMElement,
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        editorView: props.editorView,
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        eventDispatcher: props.eventDispatcher,
                        hasMinWidth: props.enableToolbarMinWidth,
                        popupsBoundariesElement: props.popupsBoundariesElement,
                        popupsMountPoint: props.popupsMountPoint,
                        popupsScrollableElement: props.popupsScrollableElement,
                        primaryToolbarComponents: primaryToolbarComponents,
                        providerFactory: props.providerFactory,
                        showKeyline: showKeyline,
                        featureFlags: props.featureFlags
                    })),
                    /*#__PURE__*/ (0, $dc70d.jsx)((0, $2PqLj.FullPageContentArea), {
                        editorAPI: editorAPI,
                        ref: scrollContentContainerRef,
                        appearance: props.appearance,
                        contentComponents: props.contentComponents,
                        contextPanel: props.contextPanel,
                        customContentComponents: props.customContentComponents,
                        disabled: props.disabled,
                        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
                        editorActions: props.editorActions,
                        editorDOMElement: props.editorDOMElement,
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        editorView: props.editorView,
                        eventDispatcher: props.eventDispatcher,
                        popupsBoundariesElement: popupsBoundariesElement,
                        popupsMountPoint: props.popupsMountPoint,
                        popupsScrollableElement: props.popupsScrollableElement,
                        providerFactory: props.providerFactory,
                        wrapperElement: (wrapperElementRef === null || wrapperElementRef === void 0 ? void 0 : wrapperElementRef.current) ?? null,
                        pluginHooks: props.pluginHooks,
                        featureFlags: props.featureFlags,
                        isEditorToolbarHidden: isEditorToolbarHidden,
                        viewMode: state.editorViewMode,
                        hasHadInteraction: hasHadInteraction,
                        contentMode: props.contentMode,
                        UNSAFE_containLayout: props.UNSAFE_containLayout
                    })
                ]
            })
        })
    });
};

});
parcelRegister("lLDwe", function(module, exports) {
$parcel$export(module.exports, "ContextPanelWidthProvider", () => $a3368017a03ce971$export$ba19517e2c08f4aa);
$parcel$export(module.exports, "ContextPanelConsumer", () => $a3368017a03ce971$export$24734d8d7782a3fc);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");
const $a3368017a03ce971$export$c174a7dc96b2afb8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createContext({
    width: 0,
    positionedOverEditor: false,
    broadcastWidth: ()=>{},
    broadcastPosition: ()=>{}
});
class $a3368017a03ce971$export$ba19517e2c08f4aa extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Component {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(props){
        super(props), this.state = {
            width: 0,
            positionedOverEditor: false
        }, this.broadcastSidebarWidth = (width)=>{
            if (width !== this.state.width) this.setState({
                width: width
            });
        }, this.broadcastPosition = (positionedOverEditor)=>{
            if (positionedOverEditor !== this.state.positionedOverEditor) this.setState({
                positionedOverEditor: positionedOverEditor
            });
        };
    }
    render() {
        const { width: width, positionedOverEditor: positionedOverEditor } = this.state;
        return /*#__PURE__*/ (0, $dc70d.jsx)($a3368017a03ce971$export$e38af27e662e9783, {
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            value: {
                width: width,
                positionedOverEditor: positionedOverEditor,
                broadcastWidth: this.broadcastSidebarWidth,
                broadcastPosition: this.broadcastPosition
            },
            children: this.props.children
        });
    }
}
const $a3368017a03ce971$export$e38af27e662e9783 = $a3368017a03ce971$export$c174a7dc96b2afb8.Provider;
const $a3368017a03ce971$export$24734d8d7782a3fc = $a3368017a03ce971$export$c174a7dc96b2afb8.Consumer;

});

parcelRegister("6BIjC", function(module, exports) {
$parcel$export(module.exports, "SSRRenderMeasure", () => $5bafe7d780ce6537$export$9f2784dd4053b8a7);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $7lseo = parcelRequire("7lseo");

var $lfqN6 = parcelRequire("lfqN6");
function $5bafe7d780ce6537$var$SSRRenderMeasureImpl({ onSSRMeasure: onSSRMeasure, segmentName: segmentName, startTimestampRef: startTimestampRef, children: children }) {
    const wasMeasured = (0, $bSJIT.useRef)(false);
    const handleOnRender = (0, $bSJIT.useCallback)(()=>{
        if (wasMeasured.current) return;
        onSSRMeasure === null || onSSRMeasure === void 0 || onSSRMeasure({
            segmentName: segmentName,
            startTimestamp: startTimestampRef.current,
            endTimestamp: performance.now()
        });
        wasMeasured.current = true;
    }, [
        onSSRMeasure,
        segmentName,
        startTimestampRef
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $dc70d.Fragment), {
        children: [
            children,
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $lfqN6.RenderMarker), {
                onRender: handleOnRender
            })
        ]
    });
}
const $5bafe7d780ce6537$var$SSRRenderMeasureNoOp = /*#__PURE__*/ (0, $bSJIT.memo)(({ children: children })=>{
    return children;
});
const $5bafe7d780ce6537$export$9f2784dd4053b8a7 = (0, $7lseo.isSSR)() ? $5bafe7d780ce6537$var$SSRRenderMeasureImpl : $5bafe7d780ce6537$var$SSRRenderMeasureNoOp;

});
parcelRegister("lfqN6", function(module, exports) {
$parcel$export(module.exports, "RenderMarker", () => $49e248c080f0c40f$export$8742d3f42739b0ac);

var $bSJIT = parcelRequire("bSJIT");
function $49e248c080f0c40f$export$8742d3f42739b0ac({ onRender: onRender }) {
    (0, $bSJIT.useLayoutEffect)(()=>{
        if (onRender) onRender();
    });
    return null;
}

});


parcelRegister("2pWL6", function(module, exports) {
$parcel$export(module.exports, "useSharedPluginStateSelector", () => $e7659edcc0f66da0$export$feb16861fe41d066);

var $bSJIT = parcelRequire("bSJIT");

var $2BKOF = parcelRequire("2BKOF");

var $dMMwa = parcelRequire("dMMwa");

var $73bnr = parcelRequire("73bnr");
function $e7659edcc0f66da0$export$feb16861fe41d066(api, plugin, options = {}) {
    const transformer = (0, $bSJIT.useCallback)((pluginState)=>{
        const [pluginName, ...properties] = plugin.split('.');
        if (!pluginState || (properties === null || properties === void 0 ? void 0 : properties.length) === 0) return undefined;
        return (0, (/*@__PURE__*/$parcel$interopDefault($2BKOF)))(pluginState === null || pluginState === void 0 ? void 0 : pluginState[`${pluginName}State`], properties);
    }, [
        plugin
    ]);
    const pluginNameArray = (0, $bSJIT.useMemo)(()=>{
        const [pluginName] = plugin.split('.');
        return [
            pluginName
        ];
    }, [
        plugin
    ]);
    const initialState = (0, $bSJIT.useMemo)(()=>{
        var _api$pluginName;
        if (options.disabled) return;
        const [pluginName] = plugin.split('.');
        return transformer({
            [`${pluginName}State`]: api === null || api === void 0 || (_api$pluginName = api[pluginName]) === null || _api$pluginName === void 0 ? void 0 : _api$pluginName.sharedState.currentState()
        });
    }, [
        plugin,
        api,
        options.disabled,
        transformer
    ]);
    return $e7659edcc0f66da0$var$useSharedPluginStateSelectorInternal(api, pluginNameArray, transformer, initialState, options);
}
function $e7659edcc0f66da0$var$useSharedPluginStateSelectorInternal(api, plugins, transformer, initialState, options = {}) {
    const [selectedPluginState, setSelectedPluginState] = (0, $bSJIT.useState)(()=>initialState);
    (0, $73bnr.usePluginStateEffect)(api, plugins, (pluginStates)=>{
        // `pluginStates`: This is the same type through inference - but typescript doesn't recognise them as they are computed slightly differently
        const transformedValue = transformer(pluginStates);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($dMMwa)))(transformedValue, selectedPluginState)) setSelectedPluginState(()=>transformedValue);
    }, options);
    return selectedPluginState;
}

});
parcelRegister("73bnr", function(module, exports) {
$parcel$export(module.exports, "usePluginStateEffect", () => $70c2695ac04adb18$export$85f3fdc261c569b3);

var $bSJIT = parcelRequire("bSJIT");

var $inh7J = parcelRequire("inh7J");
/**
 *
 * Directly map object values
 *
 * @param object The object to transform
 * @param mapFunction The function to map an old value to new one
 * @returns Object with the same key but transformed values
 *
 */ function $70c2695ac04adb18$var$mapValues(object, mapFunction) {
    return Object.entries(object).reduce((acc, [key, value])=>({
            ...acc,
            [key]: mapFunction(value)
        }), {});
}
// When we use the `useSharedPluginState` example: `useSharedPluginState(api, ['width'])`
// it will re-render every time the component re-renders as the array "['width']" is seen as an update.
// This hook is used to prevent re-renders due to this.
function $70c2695ac04adb18$var$useStaticPlugins(plugins) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $bSJIT.useMemo)(()=>plugins, []);
}
function $70c2695ac04adb18$export$85f3fdc261c569b3(injectionApi, plugins, effect, options = {}) {
    const pluginNames = $70c2695ac04adb18$var$useStaticPlugins(plugins);
    // Create a memoized object containing the named plugins
    const namedExternalPlugins = (0, $bSJIT.useMemo)(()=>pluginNames.reduce((acc, pluginName)=>({
                ...acc,
                [`${String(pluginName)}State`]: injectionApi === null || injectionApi === void 0 ? void 0 : injectionApi[pluginName]
            }), {}), [
        injectionApi,
        pluginNames
    ]);
    $70c2695ac04adb18$var$usePluginStateEffectInternal(namedExternalPlugins, effect, options);
}
function $70c2695ac04adb18$var$usePluginStateEffectInternal(externalPlugins, effect, options = {}) {
    const refStates = (0, $bSJIT.useRef)();
    const cleanup = (0, $bSJIT.useRef)();
    const latestEffect = (0, $bSJIT.useRef)(effect);
    // We should store the latest effect in a reference so it is more intuitive to the user
    // and we are not causing a memory leak by having references to old state.
    (0, $bSJIT.useLayoutEffect)(()=>{
        if (options.disabled) return;
        latestEffect.current = (0, (/*@__PURE__*/$parcel$interopDefault($inh7J)))(effect);
        return ()=>{
            latestEffect.current = undefined;
        };
    }, [
        effect,
        options.disabled
    ]);
    (0, $bSJIT.useLayoutEffect)(()=>{
        var _latestEffect$current;
        if (options.disabled) return;
        // Update the reference for this plugin and activate the effect
        refStates.current = $70c2695ac04adb18$var$mapValues(externalPlugins, (value)=>value === null || value === void 0 ? void 0 : value.sharedState.currentState());
        cleanup.current = (_latestEffect$current = latestEffect.current) === null || _latestEffect$current === void 0 ? void 0 : _latestEffect$current.call(latestEffect, refStates.current);
        const unsubs = Object.entries(externalPlugins).map(([pluginKey, externalPlugin])=>externalPlugin === null || externalPlugin === void 0 ? void 0 : externalPlugin.sharedState.onChange(({ nextSharedState: nextSharedState, prevSharedState: prevSharedState })=>{
                if (prevSharedState !== nextSharedState && refStates.current) {
                    var _latestEffect$current2;
                    // Update the reference for this plugin and activate the effect
                    refStates.current[pluginKey] = nextSharedState;
                    cleanup.current = (_latestEffect$current2 = latestEffect.current) === null || _latestEffect$current2 === void 0 ? void 0 : _latestEffect$current2.call(latestEffect, refStates.current);
                }
            }));
        return ()=>{
            var _cleanup$current;
            refStates.current = undefined;
            unsubs.forEach((cb)=>cb === null || cb === void 0 ? void 0 : cb());
            (_cleanup$current = cleanup.current) === null || _cleanup$current === void 0 || _cleanup$current.call(cleanup);
        };
    // Do not re-run if the `effect` changes - this is not expected with `useEffect` or similar hooks
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        externalPlugins,
        options.disabled
    ]);
}

});


parcelRegister("13zME", function(module, exports) {
$parcel$export(module.exports, "FullPageEditorWrapperCompiled", () => $b5ed1f082fb24732$export$2e95191265575e53);
/* FullPage-compiled.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
const $b5ed1f082fb24732$var$styles = {
    root: "_1ul95x59 _4t3i1osq _1e0c1txw _2lx21bp4 _vchhusvi"
};
const $b5ed1f082fb24732$export$2e95191265575e53 = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ children: children, className: className, style: style }, ref)=>/*#__PURE__*/ (0, $dc70d.jsx)("div", {
        ref: ref,
        className: (0, $9fU1q.default)([
            $b5ed1f082fb24732$var$styles.root,
            className
        ]),
        style: style,
        children: children
    }));

});

parcelRegister("2PqLj", function(module, exports) {
$parcel$export(module.exports, "FullPageContentArea", () => $2433bfd3da47d7a9$export$7db1e8e055ebd208);
/* FullPageContentArea.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $2YfQG = parcelRequire("2YfQG");

var $fK3tS = parcelRequire("fK3tS");

var $1gu5b = parcelRequire("1gu5b");

var $5bbjm = parcelRequire("5bbjm");

var $797yE = parcelRequire("797yE");

var $LRGCN = parcelRequire("LRGCN");

var $gLFdE = parcelRequire("gLFdE");

var $jDQsI = parcelRequire("jDQsI");

var $bKltE = parcelRequire("bKltE");

var $fdwmh = parcelRequire("fdwmh");
const $2433bfd3da47d7a9$var$akLayoutGutterOffsetStatic = 12;
const $2433bfd3da47d7a9$var$akEditorGutterPaddingReducedStatic = 24;
const $2433bfd3da47d7a9$var$akEditorFullWidthLayoutWidth = 1800;
const $2433bfd3da47d7a9$var$akEditorUltraWideLayoutWidth = 4000;
const $2433bfd3da47d7a9$var$akEditorSwoopCubicBezier = `cubic-bezier(0.15, 1, 0.3, 1)`;
const $2433bfd3da47d7a9$var$tableMarginFullWidthMode = 2;
const $2433bfd3da47d7a9$var$akLayoutGutterOffset = 12;
const $2433bfd3da47d7a9$var$SWOOP_ANIMATION = `0.5s ${$2433bfd3da47d7a9$var$akEditorSwoopCubicBezier}`;
const $2433bfd3da47d7a9$var$AK_NESTED_DND_GUTTER_OFFSET = 8;
const $2433bfd3da47d7a9$var$getTotalPadding = ()=>(0, $5bbjm.akEditorGutterPaddingDynamic)() * 2;
// Isolates the scroll container's layout and size from the rest of the page.
// Because of contain: size wrapper must take its height from the parent
// rather than from the contained content.
const $2433bfd3da47d7a9$var$containLayoutStyles = {
    wrapper: "_njlp3xnj _4t3i1osq"
};
const $2433bfd3da47d7a9$var$compiledStyles = {
    contentAreaWrapper: "_1bsb1osq _7cca15wb _1f38dez1 _njlp131u",
    sidebarArea: "_4t3i1osq _vchhusvi _1wpzesu3 _1hgw1wug _1t1q1if8 _uj9widpf _13hh1y6m",
    editorContentAreaProsemirrorStyle: "_j9k7kb7n _18q6usvi _l4a11hrf _1nw4glyw _yq1qglyw _1qzyglyw _ongaglyw _1rnyglyw _vtulglyw _13svglyw _t2fzglyw _7uc0glyw _1gl01ejb",
    fullWidthNonChromelessBreakoutBlockTableStyle: "_xpemaq80 _pnffaq80 _zr7faq80 _qkfz261p _i92uagmp",
    editorContentAreaNew: "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _v5641fxv _vwz41tcg _ca0qoahv _n3tdoahv _4t3i1ap5 _1bsb1osq _2lx21bp4 _16jlkb7n _p12f5kin _1uizkqmb",
    tableFullPageEditorStylesNew: "_1tb2idpf _8vye1n1a _1k8i1osq",
    editorContentAreaContainerNestedDndStyle: "_tynl4diq",
    editorContentAreaContainerStyleExcludeCodeBlockNew: "_1wxymslj _9dtbmslj _17q71osq _1b7c1kw7 _tynlfknx",
    editorContentGutterStyleFG: "_ca0qidpf _u5f3t9kd _n3tdidpf _19bvt9kd",
    editorContentGutterStyles: "_ca0qidpf _u5f31ex1 _n3tdidpf _19bv1ex1 _vchhusvi",
    editorContentReducedGutterStyles: "_1d7gidpf _n2nw1tcg _d329idpf _105p1tcg",
    contentAreaNew: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _v5642kub _1e0c1txw _2lx2vrvc _4t3ibhu0 _vchhusvi _8j6w1lxk",
    contentAreaHeightNoToolbar: "_4t3i1osq"
};
const $2433bfd3da47d7a9$export$81adcdb8b9fca1f7 = 'ak-editor-fp-content-area';
const $2433bfd3da47d7a9$var$EDITOR_CONTAINER = 'ak-editor-container';
const $2433bfd3da47d7a9$var$Content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).forwardRef((props, ref)=>{
    var _props$editorAPI, _props$editorAPI2;
    const fullWidthMode = props.appearance === 'full-width';
    const maxWidthMode = props.appearance === 'max';
    const scrollContainerRef = (0, $bSJIT.useRef)(null);
    const contentAreaRef = (0, $bSJIT.useRef)(null);
    const containerRef = (0, $bSJIT.useRef)(null);
    const allowScrollGutter = (_props$editorAPI = props.editorAPI) === null || _props$editorAPI === void 0 || (_props$editorAPI = _props$editorAPI.base) === null || _props$editorAPI === void 0 || (_props$editorAPI = _props$editorAPI.sharedState.currentState()) === null || _props$editorAPI === void 0 ? void 0 : _props$editorAPI.allowScrollGutter;
    const contentAreaMaxWidth = $2433bfd3da47d7a9$var$getTotalPadding() + (!fullWidthMode ? maxWidthMode ? $2433bfd3da47d7a9$var$akEditorUltraWideLayoutWidth : (0, $5bbjm.akEditorDefaultLayoutWidth) : $2433bfd3da47d7a9$var$akEditorFullWidthLayoutWidth);
    // Get useStandardNodeWidth from block menu plugin shared state
    // Only access editorAPI when the experiment is enabled to avoid performance impact
    const useStandardNodeWidth = (0, $797yE.editorExperiment)('platform_editor_controls', 'variant1') && (((_props$editorAPI2 = props.editorAPI) === null || _props$editorAPI2 === void 0 || (_props$editorAPI2 = _props$editorAPI2.blockMenu) === null || _props$editorAPI2 === void 0 || (_props$editorAPI2 = _props$editorAPI2.sharedState) === null || _props$editorAPI2 === void 0 || (_props$editorAPI2 = _props$editorAPI2.currentState()) === null || _props$editorAPI2 === void 0 ? void 0 : _props$editorAPI2.useStandardNodeWidth) ?? false);
    (0, $bSJIT.useImperativeHandle)(ref, ()=>({
            get scrollContainer () {
                return scrollContainerRef.current;
            },
            get contentArea () {
                return contentAreaRef.current;
            },
            get containerArea () {
                return containerRef.current;
            }
        }), []);
    const content = /*#__PURE__*/ (0, $dc70d.jsx)((0, $bKltE.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "fabric-editor-popup-scroll-parent",
        featureFlags: props.featureFlags,
        ref: scrollContainerRef,
        viewMode: props === null || props === void 0 ? void 0 : props.viewMode,
        isScrollable: true,
        appearance: props.appearance,
        contentMode: props.contentMode,
        useStandardNodeWidth: useStandardNodeWidth,
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $LRGCN.ClickAreaBlock), {
            editorView: props.editorView,
            editorDisabled: props.disabled,
            children: /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                style: {
                    '--ak-editor-content-area-max-width': `${contentAreaMaxWidth}px`
                },
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                className: (0, $9fU1q.default)([
                    $2433bfd3da47d7a9$var$compiledStyles.editorContentAreaNew,
                    $2433bfd3da47d7a9$var$compiledStyles.editorContentAreaProsemirrorStyle,
                    $2433bfd3da47d7a9$var$compiledStyles.tableFullPageEditorStylesNew,
                    $2433bfd3da47d7a9$var$compiledStyles.fullWidthNonChromelessBreakoutBlockTableStyle,
                    // for breakout resizing, there's no need to restrict the width of codeblocks as they're always wrapped in a breakout mark
                    $2433bfd3da47d7a9$var$compiledStyles.editorContentAreaContainerStyleExcludeCodeBlockNew,
                    $2433bfd3da47d7a9$var$compiledStyles.editorContentAreaContainerNestedDndStyle,
                    "ak-editor-content-area-region"
                ]),
                "data-editor-editable-content": true,
                role: "region",
                "aria-label": props.intl.formatMessage((0, $1gu5b.messages).editableContentLabel),
                ref: contentAreaRef,
                "data-vc": "editor-content-area-region",
                children: /*#__PURE__*/ (0, $dc70d.jsxs)("div", {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                    className: (0, $9fU1q.default)([
                        $2433bfd3da47d7a9$var$compiledStyles.editorContentGutterStyles,
                        $2433bfd3da47d7a9$var$compiledStyles.editorContentGutterStyleFG,
                        (0, $797yE.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
                            exposure: true
                        }) && $2433bfd3da47d7a9$var$compiledStyles.editorContentReducedGutterStyles,
                        (0, (/*@__PURE__*/$parcel$interopDefault($2YfQG)))('ak-editor-content-area', 'appearance-full-page', {
                            'fabric-editor--full-width-mode': fullWidthMode,
                            'fabric-editor--max-width-mode': Boolean(maxWidthMode)
                        })
                    ]),
                    ref: contentAreaRef,
                    children: [
                        !!props.customContentComponents && 'before' in props.customContentComponents ? (0, $gLFdE.contentComponentClickWrapper)(props.customContentComponents.before) : (0, $gLFdE.contentComponentClickWrapper)(props.customContentComponents),
                        /*#__PURE__*/ (0, $dc70d.jsx)((0, $fdwmh.default), {
                            editorView: props.editorView,
                            editorActions: props.editorActions,
                            eventDispatcher: props.eventDispatcher,
                            providerFactory: props.providerFactory,
                            appearance: props.appearance,
                            items: props.contentComponents,
                            pluginHooks: props.pluginHooks,
                            contentArea: contentAreaRef.current ?? undefined,
                            popupsMountPoint: props.popupsMountPoint,
                            popupsBoundariesElement: props.popupsBoundariesElement,
                            popupsScrollableElement: props.popupsScrollableElement,
                            disabled: !!props.disabled,
                            containerElement: scrollContainerRef.current,
                            dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
                            wrapperElement: props.wrapperElement
                        }),
                        props.editorDOMElement,
                        !!props.customContentComponents && 'after' in props.customContentComponents ? (0, $gLFdE.contentComponentClickWrapper)(props.customContentComponents.after) : null,
                        allowScrollGutter && ((0, $797yE.editorExperiment)('platform_editor_blocks', true) ? /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                            id: "editor-scroll-gutter",
                            style: {
                                paddingBottom: `${allowScrollGutter.gutterSize ?? '120'}px`
                            },
                            "data-vc": "scroll-gutter",
                            "data-editor-scroll-gutter": "true"
                        }) : /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                            id: "editor-scroll-gutter",
                            style: {
                                paddingBottom: `${allowScrollGutter.gutterSize ?? '120'}px`
                            },
                            "data-vc": "scroll-gutter"
                        }))
                    ]
                })
            })
        })
    });
    return /*#__PURE__*/ (0, $dc70d.jsxs)("div", {
        "data-testid": $2433bfd3da47d7a9$export$81adcdb8b9fca1f7,
        ref: containerRef,
        className: (0, $9fU1q.default)([
            $2433bfd3da47d7a9$var$compiledStyles.contentAreaNew,
            props.isEditorToolbarHidden && $2433bfd3da47d7a9$var$compiledStyles.contentAreaHeightNoToolbar
        ]),
        children: [
            /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                "data-testid": $2433bfd3da47d7a9$var$EDITOR_CONTAINER,
                "data-editor-container": 'true',
                className: (0, $9fU1q.default)([
                    $2433bfd3da47d7a9$var$compiledStyles.contentAreaWrapper
                ]),
                children: props.UNSAFE_containLayout ? /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                    "data-testid": "editor-contain-size-and-layout-wrapper",
                    className: (0, $9fU1q.default)([
                        $2433bfd3da47d7a9$var$containLayoutStyles.wrapper
                    ]),
                    children: content
                }) : content
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                className: (0, $9fU1q.default)([
                    $2433bfd3da47d7a9$var$compiledStyles.sidebarArea
                ]),
                children: props.contextPanel || /*#__PURE__*/ (0, $dc70d.jsx)((0, $jDQsI.ContextPanel), {
                    editorAPI: props.editorAPI,
                    visible: false
                })
            })
        ]
    });
});
const $2433bfd3da47d7a9$export$7db1e8e055ebd208 = (0, $fK3tS.default)($2433bfd3da47d7a9$var$Content, {
    forwardRef: true
});

});
parcelRegister("jDQsI", function(module, exports) {
$parcel$export(module.exports, "ContextPanel", () => $570ce6280d2a053a$export$c174a7dc96b2afb8);
/* eslint-disable jsdoc/require-jsdoc -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $fK3tS = parcelRequire("fK3tS");

var $hy4VY = parcelRequire("hy4VY");

var $c9wRy = parcelRequire("c9wRy");

var $lLDwe = parcelRequire("lLDwe");

var $1q2DI = parcelRequire("1q2DI");

var $5beht = parcelRequire("5beht");

var $5bbjm = parcelRequire("5bbjm");

var $3y2s4 = parcelRequire("3y2s4");

var $huAFj = parcelRequire("huAFj");
// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
class $570ce6280d2a053a$var$SwappableContentAreaInner extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).PureComponent {
    static getDerivedStateFromProps(props, state) {
        if (props.pluginContent !== state.currentPluginContent) return {
            ...state,
            currentPluginContent: props.pluginContent
        };
        return null;
    }
    unsetPluginContent() {
        this.setState({
            currentPluginContent: undefined
        });
    }
    render() {
        const width = this.props.customWidth ?? (0, $5bbjm.akEditorContextPanelWidth);
        const userVisible = !!this.props.visible;
        const visible = userVisible || !!this.state.currentPluginContent;
        const hasPadding = this.props.hasPadding === undefined ? true : this.props.hasPadding;
        return /*#__PURE__*/ (0, $dc70d.jsx)((0, $lLDwe.ContextPanelConsumer), {
            children: ({ broadcastWidth: broadcastWidth })=>{
                var _this$props$intl, _this$props$intl2;
                const contextPanelWidth = visible ? width : 0;
                broadcastWidth(contextPanelWidth);
                return /*#__PURE__*/ (0, $dc70d.jsx)((0, $huAFj.ContextPanelWrapperCompiled), {
                    customWidth: this.props.customWidth,
                    visible: visible,
                    "data-testid": "context-panel-panel",
                    // eslint-disable-next-line @atlassian/a11y/no-empty-aria-label -- Pre-existing; intl should always resolve a label here
                    "aria-label": ((_this$props$intl = this.props.intl) === null || _this$props$intl === void 0 ? void 0 : _this$props$intl.formatMessage((0, $1q2DI.contextPanelMessages).panelLabel)) || '',
                    "aria-modal": "false",
                    role: "dialog",
                    children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $huAFj.ContextPanelContentCompiled), {
                        customWidth: this.props.customWidth,
                        visible: visible,
                        hasPadding: hasPadding,
                        "data-testid": "context-panel-content",
                        // Adding tabIndex=0 here to make content focusable as it is a scrollable region
                        tabIndex: 0,
                        role: "region",
                        "aria-label": (_this$props$intl2 = this.props.intl) === null || _this$props$intl2 === void 0 ? void 0 : _this$props$intl2.formatMessage((0, $1q2DI.contextPanelMessages).panelContentLabel),
                        children: this.showPluginContent() || this.showProvidedContent(userVisible)
                    })
                });
            }
        });
    }
    constructor(...args){
        super(...args), this.state = {
            currentPluginContent: undefined
        }, this.handleTransitionExited = ()=>{
            this.unsetPluginContent();
        }, /**
   * Returns focus to the editor when the panel starts closing, so keyboard users
   * are not left with focus on an element that is about to disappear.
   *
   * Skipped when focus is already on a live element *outside* the exiting panel:
   * that means the consumer has restored focus itself (e.g. to the button that
   * opened the panel, per the WAI-ARIA dialog pattern), and overriding it would
   * strand keyboard and screen-reader users in the editor.
   *
   * @param node The exiting panel content, as passed by `Transition`'s `onExiting`.
   */ this.focusEditor = (node)=>{
            var _editorAPI$core;
            const { editorAPI: editorAPI } = this.props;
            // `node` can be null here: consumers often clear the panel's children in the
            // same update that hides it, so `Transition` has no DOM node to hand us. Treat
            // that as "focus is not inside the panel" and rely on the active element alone.
            //
            // `Element` rather than `HTMLElement`: focusable SVG elements (e.g. an
            // SVG-based trigger button) are valid focus targets but are not HTMLElements.
            const activeDocument = (0, $c9wRy.getDocument)();
            const activeElement = activeDocument === null || activeDocument === void 0 ? void 0 : activeDocument.activeElement;
            const focusHeldOutsidePanel = !!activeDocument && activeElement instanceof Element && activeElement !== activeDocument.body && activeElement.isConnected && !((node === null || node === void 0 ? void 0 : node.contains(activeElement)) ?? false);
            if (focusHeldOutsidePanel) return;
            editorAPI === null || editorAPI === void 0 || (_editorAPI$core = editorAPI.core) === null || _editorAPI$core === void 0 || _editorAPI$core.actions.focus({
                scrollIntoView: false
            });
        }, this.showPluginContent = ()=>{
            const { pluginContent: pluginContent } = this.props;
            const { currentPluginContent: currentPluginContent } = this.state;
            if (!currentPluginContent) return;
            const onExited = (0, $3y2s4.isExperimentEnabled)('platform_editor_perf_lint_cleanup') ? this.handleTransitionExited : ()=>this.unsetPluginContent();
            return /*#__PURE__*/ (0, $dc70d.jsx)((0, $hy4VY.default), {
                timeout: 0,
                in: !!pluginContent,
                mountOnEnter: true,
                unmountOnExit: true,
                onExited: onExited,
                children: currentPluginContent
            });
        }, this.showProvidedContent = (isVisible)=>{
            const { children: children } = this.props;
            if (!children) return;
            return /*#__PURE__*/ (0, $dc70d.jsx)((0, $hy4VY.default), {
                timeout: 0,
                in: isVisible,
                mountOnEnter: true,
                unmountOnExit: true,
                onExiting: this.focusEditor,
                children: children
            });
        };
    }
}
const $570ce6280d2a053a$export$2aac880ec6fe2608 = (0, $fK3tS.default)($570ce6280d2a053a$var$SwappableContentAreaInner);
function $570ce6280d2a053a$export$c174a7dc96b2afb8(props) {
    const contextPanelContents = (0, $5beht.useSharedPluginStateWithSelector)(props.editorAPI, [
        'contextPanel'
    ], (states)=>{
        var _states$contextPanelS;
        return states === null || states === void 0 || (_states$contextPanelS = states.contextPanelState) === null || _states$contextPanelS === void 0 ? void 0 : _states$contextPanelS.contents;
    });
    const firstContent = contextPanelContents && contextPanelContents.find(Boolean);
    return /*#__PURE__*/ (0, $dc70d.jsx)($570ce6280d2a053a$export$2aac880ec6fe2608, {
        ...props,
        editorAPI: props.editorAPI,
        pluginContent: firstContent
    });
}

});
parcelRegister("hy4VY", function(module, exports) {
$parcel$export(module.exports, "default", () => $cc69707408f692ae$export$2e2bcd8739ae039);

var $kV77Q = parcelRequire("kV77Q");

var $huZMc = parcelRequire("huZMc");


var $bSJIT = parcelRequire("bSJIT");

var $4Sf72 = parcelRequire("4Sf72");

var $Z33ck = parcelRequire("Z33ck");


var $jF6Mr = parcelRequire("jF6Mr");

var $7brfD = parcelRequire("7brfD");
var $cc69707408f692ae$export$bb38bb9a1161268 = 'unmounted';
var $cc69707408f692ae$export$84cbff306f539230 = 'exited';
var $cc69707408f692ae$export$df38205c966be359 = 'entering';
var $cc69707408f692ae$export$78e9e6e3e014d60a = 'entered';
var $cc69707408f692ae$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $cc69707408f692ae$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $huZMc.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $cc69707408f692ae$export$84cbff306f539230;
                _this.appearStatus = $cc69707408f692ae$export$df38205c966be359;
            } else initialStatus = $cc69707408f692ae$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $cc69707408f692ae$export$bb38bb9a1161268;
        else initialStatus = $cc69707408f692ae$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $cc69707408f692ae$export$bb38bb9a1161268) return {
            status: $cc69707408f692ae$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $cc69707408f692ae$export$df38205c966be359 && status !== $cc69707408f692ae$export$78e9e6e3e014d60a) nextStatus = $cc69707408f692ae$export$df38205c966be359;
            } else if (status === $cc69707408f692ae$export$df38205c966be359 || status === $cc69707408f692ae$export$78e9e6e3e014d60a) nextStatus = $cc69707408f692ae$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $cc69707408f692ae$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($4Sf72))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $7brfD.forceReflow)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $cc69707408f692ae$export$84cbff306f539230) this.setState({
            status: $cc69707408f692ae$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($4Sf72))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $Z33ck.default).disabled) {
            this.safeSetState({
                status: $cc69707408f692ae$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $cc69707408f692ae$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $cc69707408f692ae$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($4Sf72))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $Z33ck.default).disabled) {
            this.safeSetState({
                status: $cc69707408f692ae$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $cc69707408f692ae$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $cc69707408f692ae$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($4Sf72))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $cc69707408f692ae$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $kV77Q.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jF6Mr.default).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Component);
$cc69707408f692ae$var$Transition.contextType = (0, $jF6Mr.default);
$cc69707408f692ae$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $cc69707408f692ae$var$noop() {}
$cc69707408f692ae$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $cc69707408f692ae$var$noop,
    onEntering: $cc69707408f692ae$var$noop,
    onEntered: $cc69707408f692ae$var$noop,
    onExit: $cc69707408f692ae$var$noop,
    onExiting: $cc69707408f692ae$var$noop,
    onExited: $cc69707408f692ae$var$noop
};
$cc69707408f692ae$var$Transition.UNMOUNTED = $cc69707408f692ae$export$bb38bb9a1161268;
$cc69707408f692ae$var$Transition.EXITED = $cc69707408f692ae$export$84cbff306f539230;
$cc69707408f692ae$var$Transition.ENTERING = $cc69707408f692ae$export$df38205c966be359;
$cc69707408f692ae$var$Transition.ENTERED = $cc69707408f692ae$export$78e9e6e3e014d60a;
$cc69707408f692ae$var$Transition.EXITING = $cc69707408f692ae$export$4aacc83d4d59139f;
var $cc69707408f692ae$export$2e2bcd8739ae039 = $cc69707408f692ae$var$Transition;

});
parcelRegister("Z33ck", function(module, exports) {
$parcel$export(module.exports, "default", () => $0b781066a23e35f1$export$2e2bcd8739ae039);
var $0b781066a23e35f1$export$2e2bcd8739ae039 = {
    disabled: false
};

});

parcelRegister("jF6Mr", function(module, exports) {
$parcel$export(module.exports, "default", () => $e5071b1502b0d2a6$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");
var $e5071b1502b0d2a6$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createContext(null);

});

parcelRegister("7brfD", function(module, exports) {
$parcel$export(module.exports, "forceReflow", () => $53aeb302679c732a$export$7d26bbb1236dafd6);
var $53aeb302679c732a$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};

});


parcelRegister("1q2DI", function(module, exports) {
$parcel$export(module.exports, "contextPanelMessages", () => $5ee71e1eef1a21bf$export$8ea7f7e979b71fa5);

var $f0Pt4 = parcelRequire("f0Pt4");
const $5ee71e1eef1a21bf$export$8ea7f7e979b71fa5 = (0, $f0Pt4.defineMessages)({
    panelLabel: {
        id: 'fabric.editor.contextPanel.panelLabel',
        defaultMessage: 'Context panel',
        description: 'Accessibility label for the context panel dialog in the editor. Used as an aria-label to identify the panel for screen reader users.'
    },
    panelContentLabel: {
        id: 'fabric.editor.contextPanel.panelContentLabel',
        defaultMessage: 'Scrollable context panel content',
        description: 'Accessible label for the scrollable content region inside the editor context panel, used by screen readers to identify this scrollable area.'
    }
});

});

parcelRegister("huAFj", function(module, exports) {
$parcel$export(module.exports, "ContextPanelWrapperCompiled", () => $84991ece195803bd$export$1427500076f636b6);
$parcel$export(module.exports, "ContextPanelContentCompiled", () => $84991ece195803bd$export$90b9783dea435d4f);
/* index-compiled.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
const $84991ece195803bd$var$akEditorContextPanelWidthStatic = 320;
const $84991ece195803bd$var$getContextPanelWidthStyle = ({ customWidth: customWidth, visible: visible })=>{
    if (!visible) return {
        width: 0
    };
    if (customWidth) return {
        width: `${customWidth}px`
    };
    return undefined;
};
const $84991ece195803bd$var$panelStyles = {
    panel: "_1reo15vq _18m915vq _1bsbnklw _4t3i1osq _16qshh4h",
    content: "_vchhusvi _1bsbnklw _4t3i1osq _18m91wug",
    padding: "_ca0qpxbi _u5f3pxbi _n3tdze3t _19bvpxbi",
    customWidthOverflow: "_1reo15vq"
};
const $84991ece195803bd$export$1427500076f636b6 = ({ children: children, customWidth: customWidth, visible: visible, ...rest })=>{
    const widthStyle = (0, $bSJIT.useMemo)(()=>$84991ece195803bd$var$getContextPanelWidthStyle({
            customWidth: customWidth,
            visible: visible
        }), [
        customWidth,
        visible
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- dynamic width cannot be expressed as static compiled CSS
        style: widthStyle,
        ...rest,
        className: (0, $9fU1q.default)([
            $84991ece195803bd$var$panelStyles.panel,
            customWidth && ""
        ]),
        children: children
    });
};
const $84991ece195803bd$export$90b9783dea435d4f = ({ children: children, customWidth: customWidth, visible: visible, hasPadding: hasPadding, ...rest })=>{
    const widthStyle = (0, $bSJIT.useMemo)(()=>$84991ece195803bd$var$getContextPanelWidthStyle({
            customWidth: customWidth,
            visible: visible
        }), [
        customWidth,
        visible
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- dynamic width cannot be expressed as static compiled CSS
        style: widthStyle,
        ...rest,
        className: (0, $9fU1q.default)([
            $84991ece195803bd$var$panelStyles.content,
            hasPadding && $84991ece195803bd$var$panelStyles.padding,
            customWidth && ""
        ]),
        children: children
    });
};

});



parcelRegister("ipUgj", function(module, exports) {
$parcel$export(module.exports, "FullPageToolbar", () => $55e7fc80817325e4$export$26f3f0e30f9545b4);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $fK3tS = parcelRequire("fK3tS");

var $lLDwe = parcelRequire("lLDwe");

var $1gu5b = parcelRequire("1gu5b");

var $aHqLs = parcelRequire("aHqLs");

var $797yE = parcelRequire("797yE");

var $5wHxk = parcelRequire("5wHxk");

var $3BF2Y = parcelRequire("3BF2Y");

var $am73x = parcelRequire("am73x");

var $9Mkdx = parcelRequire("9Mkdx");

var $41rEK = parcelRequire("41rEK");

var $a1oju = parcelRequire("a1oju");

var $h2qbv = parcelRequire("h2qbv");
const $55e7fc80817325e4$export$477aaffea178bc4e = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).memo((props)=>{
    var _props$primaryToolbar, _props$customPrimaryT;
    const [shouldSplitToolbar, setShouldSplitToolbar] = (0, $bSJIT.useState)(false);
    const { editorAPI: editorAPI } = props;
    // When primary toolbar components is undefined, do not show two line editor toolbar
    const twoLineEditorToolbar = (0, $797yE.editorExperiment)('platform_editor_controls', 'variant1') ? !!props.customPrimaryToolbarComponents && ((_props$primaryToolbar = props.primaryToolbarComponents) === null || _props$primaryToolbar === void 0 ? void 0 : _props$primaryToolbar.length) !== 0 : !!props.customPrimaryToolbarComponents;
    // When a toolbar portal context is provided, render the  toolbar inside a portal.
    // Otherwise fall back to a fragment just to avoid forking rendering logic.
    const { Portal: ToolbarPortal } = (0, $5wHxk.useToolbarPortal)() ?? {
        Portal: (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment
    };
    const hasToolbarPortal = ToolbarPortal !== (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment;
    const popupsMountPoint = hasToolbarPortal ? undefined : props.popupsMountPoint;
    const nonCustomToolbar = /*#__PURE__*/ (0, $dc70d.jsxs)((0, $a1oju.NonCustomToolbarWrapperCompiled), {
        children: [
            props.beforeIcon && /*#__PURE__*/ (0, $dc70d.jsx)((0, $a1oju.MainToolbarIconBeforeCompiled), {
                children: props.beforeIcon
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $3BF2Y.ToolbarWithSizeDetector), {
                editorView: props.editorView,
                editorActions: props.editorActions,
                eventDispatcher: props.eventDispatcher,
                providerFactory: props.providerFactory,
                appearance: props.appearance,
                items: props.primaryToolbarComponents,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: props.popupsBoundariesElement,
                popupsScrollableElement: props.popupsScrollableElement,
                disabled: props.disabled,
                dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
                containerElement: props.containerElement,
                hasMinWidth: props.hasMinWidth,
                twoLineEditorToolbar: twoLineEditorToolbar
            })
        ]
    });
    const customToolbar = /*#__PURE__*/ (0, $dc70d.jsxs)((0, $a1oju.CustomToolbarWrapperCompiled), {
        children: [
            !!props.customPrimaryToolbarComponents && 'before' in props.customPrimaryToolbarComponents ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $am73x.BeforePrimaryToolbarWrapper), {
                beforePrimaryToolbarComponents: (_props$customPrimaryT = props.customPrimaryToolbarComponents) === null || _props$customPrimaryT === void 0 ? void 0 : _props$customPrimaryT.before
            }) : null,
            !(0, $797yE.editorExperiment)('platform_editor_controls', 'variant1') && editorAPI !== null && editorAPI !== void 0 && editorAPI.findReplace && twoLineEditorToolbar ? editorAPI === null || editorAPI === void 0 ? void 0 : editorAPI.findReplace.actions.registerToolbarButton({
                popupsBoundariesElement: props.popupsBoundariesElement,
                popupsMountPoint: popupsMountPoint,
                popupsScrollableElement: props.popupsScrollableElement,
                editorView: props.editorView,
                containerElement: props.containerElement,
                dispatchAnalyticsEvent: props.dispatchAnalyticsEvent
            }) : null,
            !!props.customPrimaryToolbarComponents && 'after' in props.customPrimaryToolbarComponents ? props.customPrimaryToolbarComponents.after : props.customPrimaryToolbarComponents
        ]
    });
    (0, $bSJIT.useEffect)(()=>{
        if (twoLineEditorToolbar) {
            const updateOnResize = ()=>{
                setShouldSplitToolbar(window.innerWidth <= (0, $41rEK.MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT));
            };
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.addEventListener('resize', updateOnResize);
            updateOnResize();
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            return ()=>window.removeEventListener('resize', updateOnResize);
        }
    });
    const isShortcutToFocusToolbar = (0, $bSJIT.useCallback)((event)=>{
        //Alt + F9 to reach first element in this main toolbar
        return event.altKey && (event.key === 'F9' || event.keyCode === 120);
    }, []);
    const handleEscape = (0, $bSJIT.useCallback)((event)=>{
        var _props$editorView;
        if (!((_props$editorView = props.editorView) !== null && _props$editorView !== void 0 && _props$editorView.hasFocus())) {
            var _props$editorView2;
            (_props$editorView2 = props.editorView) === null || _props$editorView2 === void 0 || _props$editorView2.focus();
        }
        event.preventDefault();
        event.stopPropagation();
    }, [
        props.editorView
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $lLDwe.ContextPanelConsumer), {
        children: ({ width: contextPanelWidth })=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $aHqLs.ToolbarArrowKeyNavigationProvider), {
                editorView: props.editorView,
                childComponentSelector: "[data-testid='ak-editor-main-toolbar']",
                isShortcutToFocusToolbar: isShortcutToFocusToolbar,
                handleEscape: handleEscape,
                intl: props.intl,
                children: /*#__PURE__*/ (0, $dc70d.jsx)(ToolbarPortal, {
                    children: /*#__PURE__*/ (0, $dc70d.jsxs)((0, $h2qbv.MainToolbarWrapper), {
                        showKeyline: props.showKeyline || contextPanelWidth > 0,
                        twoLineEditorToolbar: twoLineEditorToolbar,
                        "data-testid": "ak-editor-main-toolbar",
                        children: [
                            /*#__PURE__*/ (0, $dc70d.jsx)((0, $9Mkdx.MainToolbarForFirstChildWrapper), {
                                twoLineEditorToolbar: twoLineEditorToolbar,
                                role: "toolbar",
                                "aria-label": props.intl.formatMessage((0, $1gu5b.messages).toolbarLabel),
                                children: shouldSplitToolbar ? customToolbar : nonCustomToolbar
                            }),
                            /*#__PURE__*/ (0, $dc70d.jsx)((0, $9Mkdx.MainToolbarForSecondChildWrapper), {
                                twoLineEditorToolbar: twoLineEditorToolbar,
                                "data-testid": "avatar-group-outside-plugin",
                                role: "region",
                                "aria-label": props.intl.formatMessage((0, $1gu5b.messages).pageActionsLabel),
                                children: shouldSplitToolbar ? nonCustomToolbar : customToolbar
                            }),
                            /*#__PURE__*/ (0, $dc70d.jsx)((0, $5wHxk.ToolbarPortalMountPoint), {})
                        ]
                    })
                })
            })
    });
});
const $55e7fc80817325e4$export$26f3f0e30f9545b4 = (0, $fK3tS.default)($55e7fc80817325e4$export$477aaffea178bc4e);

});
parcelRegister("5wHxk", function(module, exports) {
$parcel$export(module.exports, "useToolbarPortal", () => $5e99d28a44c6801d$export$9fa9b541c351558);
$parcel$export(module.exports, "ToolbarPortalMountPoint", () => $5e99d28a44c6801d$export$ed65ed0e830b18c8);
/* ToolbarPortal.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");
const $5e99d28a44c6801d$var$ToolbarPortalContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createContext(undefined);
const $5e99d28a44c6801d$export$89a0c16b81a39772 = ({ children: children, portal: portal, isActive: isActive })=>{
    const value = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useMemo(()=>({
            Portal: portal,
            isActive: isActive
        }), [
        portal,
        isActive
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)($5e99d28a44c6801d$var$ToolbarPortalContext.Provider, {
        value: value,
        children: children
    });
};
const $5e99d28a44c6801d$export$9fa9b541c351558 = ()=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useContext($5e99d28a44c6801d$var$ToolbarPortalContext);
};
const $5e99d28a44c6801d$var$toolbarPortalStyles = {
    portal: "_1r04ze3t _kqswstnw _fiawglyw"
};
const $5e99d28a44c6801d$export$ed65ed0e830b18c8 = ()=>{
    const portal = $5e99d28a44c6801d$export$9fa9b541c351558();
    // Don't render a mountpoint when we're already inside a portal
    if (portal) return null;
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        className: (0, $9fU1q.default)([
            $5e99d28a44c6801d$var$toolbarPortalStyles.portal,
            "ak-editor-toolbar-portal"
        ])
    });
};

});

parcelRegister("am73x", function(module, exports) {
$parcel$export(module.exports, "BeforePrimaryToolbarWrapper", () => $caa9d01741274681$export$b41281e8d2acb8ab);
/* BeforeWrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
const $caa9d01741274681$var$styles = {
    beforePrimaryToolbarPluginWrapper: "_1e0c1txw _16jlkb7n _1bahesu3 _4cvr1h6o"
};
const $caa9d01741274681$export$b41281e8d2acb8ab = (props)=>/*#__PURE__*/ (0, $dc70d.jsx)("div", {
        "data-testid": 'before-primary-toolbar-components-plugin',
        className: (0, $9fU1q.default)([
            $caa9d01741274681$var$styles.beforePrimaryToolbarPluginWrapper
        ]),
        children: props.beforePrimaryToolbarComponents
    });

});

parcelRegister("9Mkdx", function(module, exports) {
$parcel$export(module.exports, "MainToolbarForFirstChildWrapper", () => $7b2b1d0b34caad6e$export$e9a48721664257fd);
$parcel$export(module.exports, "MainToolbarForSecondChildWrapper", () => $7b2b1d0b34caad6e$export$c8150e2de9fece09);
/* CustomToolbarWrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
const $7b2b1d0b34caad6e$var$firstChildStyles = {
    base: "_1e0c1txw _16jlkb7n",
    twoLine: "_u89dkb7n _9gudkb7n _1hoh1osq _8o3817qo _lhl4esu3 _1s2p1ns9"
};
const $7b2b1d0b34caad6e$var$secondChildStyles = {
    base: "_1ul91ns9",
    twoLine: "_u89dkb7n _9gudkb7n _1hoh1osq _1tjb1wug _1rg31wug _1jzq1wug _cn5x1wug _87t41txw _8o3817qo _1s2pidpf"
};
const $7b2b1d0b34caad6e$export$e9a48721664257fd = ({ twoLineEditorToolbar: twoLineEditorToolbar, children: children, role: role, 'aria-label': ariaLabel, 'data-testid': testId })=>/*#__PURE__*/ (0, $dc70d.jsx)("div", {
        role: role,
        "aria-label": ariaLabel,
        "data-testid": testId,
        className: (0, $9fU1q.default)([
            $7b2b1d0b34caad6e$var$firstChildStyles.base,
            twoLineEditorToolbar && $7b2b1d0b34caad6e$var$firstChildStyles.twoLine
        ]),
        children: children
    });
const $7b2b1d0b34caad6e$export$c8150e2de9fece09 = ({ twoLineEditorToolbar: twoLineEditorToolbar, children: children, role: role, 'aria-label': ariaLabel, 'data-testid': testId })=>/*#__PURE__*/ (0, $dc70d.jsx)("div", {
        role: role,
        "aria-label": ariaLabel,
        "data-testid": testId,
        className: (0, $9fU1q.default)([
            $7b2b1d0b34caad6e$var$secondChildStyles.base,
            twoLineEditorToolbar && $7b2b1d0b34caad6e$var$secondChildStyles.twoLine
        ]),
        children: children
    });

});

parcelRegister("41rEK", function(module, exports) {
$parcel$export(module.exports, "MAXIMUM_TWO_LINE_TOOLBAR_BREAKPOINT", () => $b17eb7fee5bc0e28$export$f71dca5c73c8a7);
const $b17eb7fee5bc0e28$export$f71dca5c73c8a7 = 868;

});

parcelRegister("a1oju", function(module, exports) {
$parcel$export(module.exports, "NonCustomToolbarWrapperCompiled", () => $32559270a6fd680b$export$237e1ac09b615dbd);
$parcel$export(module.exports, "CustomToolbarWrapperCompiled", () => $32559270a6fd680b$export$cbddf074130aa75);
$parcel$export(module.exports, "MainToolbarIconBeforeCompiled", () => $32559270a6fd680b$export$fb3cf9f8d75e0584);
/* MainToolbar-compiled.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $9fU1q = parcelRequire("9fU1q");
parcelRequire("bSJIT");
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
const $32559270a6fd680b$var$nonCustomToolbarWrapperCompiledStyles = {
    root: "_4cvr1h6o _1e0c1txw _16jlkb7n"
};
const $32559270a6fd680b$export$237e1ac09b615dbd = ({ children: children })=>/*#__PURE__*/ (0, $dc70d.jsx)("div", {
        className: (0, $9fU1q.default)([
            $32559270a6fd680b$var$nonCustomToolbarWrapperCompiledStyles.root
        ]),
        children: children
    });
const $32559270a6fd680b$var$customToolbarWrapperCompiledStyles = {
    root: "_4cvr1h6o _1e0c1txw"
};
const $32559270a6fd680b$export$cbddf074130aa75 = ({ children: children })=>/*#__PURE__*/ (0, $dc70d.jsx)("div", {
        className: (0, $9fU1q.default)([
            $32559270a6fd680b$var$customToolbarWrapperCompiledStyles.root
        ]),
        children: children
    });
const $32559270a6fd680b$var$mainToolbarIconBeforeCompiledStyles = {
    root: "_19pkpxbi _2hwxpxbi _otyrpxbi _18u0pxbi _4t3ixy5q _1bsbxy5q _mlgzkb7n _tuuhkb7n"
};
const $32559270a6fd680b$export$fb3cf9f8d75e0584 = ({ children: children })=>/*#__PURE__*/ (0, $dc70d.jsx)("div", {
        className: (0, $9fU1q.default)([
            $32559270a6fd680b$var$mainToolbarIconBeforeCompiledStyles.root
        ]),
        children: children
    });

});

parcelRegister("h2qbv", function(module, exports) {
$parcel$export(module.exports, "MainToolbarWrapper", () => $7e1c705a2ff3d786$export$9e3c8dcb351b94fd);
/* MainToolbarWrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $9fU1q = parcelRequire("9fU1q");
parcelRequire("bSJIT");
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
const $7e1c705a2ff3d786$var$styles = {
    base: "_v56419ab _n7zlia51 _kqswh2mm _4cvr1h6o _16qsglyw _1pby16oo _1e0c1txw _4t3i17qo _1o9zidpf _bfhkvuon _1krdgrf3",
    flexibleIconSize: "_3pwj1osq",
    keyline: "_16qs1nax",
    twoLine: "_1s5v1g80 _8o38zpre"
};
const $7e1c705a2ff3d786$export$9e3c8dcb351b94fd = ({ showKeyline: showKeyline, twoLineEditorToolbar: twoLineEditorToolbar, children: children, 'data-testid': testId })=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        "data-testid": testId,
        className: (0, $9fU1q.default)([
            $7e1c705a2ff3d786$var$styles.base,
            $7e1c705a2ff3d786$var$styles.flexibleIconSize,
            showKeyline && $7e1c705a2ff3d786$var$styles.keyline,
            twoLineEditorToolbar && $7e1c705a2ff3d786$var$styles.twoLine
        ]),
        children: children
    });
};

});


parcelRegister("lVlMP", function(module, exports) {
$parcel$export(module.exports, "FullPageToolbarNext", () => $259bccdbe77a78bc$export$9f4aa6ea8358228b);
/* FullPageToolbarNext.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $lLDwe = parcelRequire("lLDwe");

var $7lseo = parcelRequire("7lseo");

var $bj85S = parcelRequire("bj85S");

var $4rzOL = parcelRequire("4rzOL");

var $aHqLs = parcelRequire("aHqLs");

var $5beht = parcelRequire("5beht");

var $5N1Y4 = parcelRequire("5N1Y4");

var $kGfTG = parcelRequire("kGfTG");

var $cS3VF = parcelRequire("cS3VF");

var $bmMyd = parcelRequire("bmMyd");

var $5wHxk = parcelRequire("5wHxk");
const $259bccdbe77a78bc$var$styles = {
    mainToolbarIconBefore: "_19pkpxbi _2hwxpxbi _otyrpxbi",
    mainToolbarIconBeforeNew: "_4cvr1h6o _1e0c1txw",
    mainToolbarWrapper: "_1rjc12x7 _18zrutpp _n7zlia51",
    mainToolbarNew: "_1e0c1txw _4t3izwfg",
    mainToolbarZIndex: "_1pby16oo _kqswh2mm",
    mainToolbarWithKeyline: "_16qs1nax",
    customToolbarWrapperStyle: "_4cvr1h6o _1e0c1txw",
    firstChildWrapperOneLine: "_1e0c1txw _16jlkb7n",
    firstChildWrapperContainerContext: "_7cca15wb _1f38ptqj",
    secondChildWrapperOneLine: "_1e0c1txw _1ul91ns9 _4cvr1h6o",
    beforePrimaryToolbarComponents: "_1e0c1txw _16jlkb7n _1bahesu3 _4cvr1h6o",
    backgroundColor: "_bfhkvuon"
};
const $259bccdbe77a78bc$var$MainToolbarWrapper = ({ children: children, testId: testId, showKeyline: showKeyline })=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        "data-testid": testId,
        className: (0, $9fU1q.default)([
            $259bccdbe77a78bc$var$styles.mainToolbarWrapper,
            showKeyline && $259bccdbe77a78bc$var$styles.mainToolbarWithKeyline,
            $259bccdbe77a78bc$var$styles.mainToolbarZIndex,
            $259bccdbe77a78bc$var$styles.mainToolbarNew,
            (0, $5N1Y4.expValEquals)('platform_editor_table_sticky_header_improvements', 'cohort', 'test_with_overflow') && $259bccdbe77a78bc$var$styles.backgroundColor
        ]),
        children: children
    });
};
const $259bccdbe77a78bc$var$FirstChildWrapper = ({ children: children })=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        "data-testid": "main-toolbar-first-child-wrapper",
        className: (0, $9fU1q.default)([
            $259bccdbe77a78bc$var$styles.firstChildWrapperOneLine,
            $259bccdbe77a78bc$var$styles.firstChildWrapperContainerContext
        ]),
        children: children
    });
};
const $259bccdbe77a78bc$var$SecondChildWrapper = ({ children: children })=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        "data-testid": "main-toolbar-second-child-wrapper",
        className: (0, $9fU1q.default)([
            $259bccdbe77a78bc$var$styles.secondChildWrapperOneLine
        ]),
        children: children
    });
};
const $259bccdbe77a78bc$var$shouldShowToolbarContainer = (toolbar, customPrimaryToolbarComponents)=>{
    return !!toolbar || !!customPrimaryToolbarComponents;
};
const $259bccdbe77a78bc$var$getToolbarComponentsForMarkdownView = (components, markdownModeView, isConvertedMarkdownPreview)=>{
    if (markdownModeView === 'syntax' || markdownModeView === 'preview') {
        // Converted markdown live pages in preview should show full toolbar content
        // so preference-based docking can work consistently.
        if (isConvertedMarkdownPreview) return components;
        return components.filter((component)=>component.key === (0, $4rzOL.TOOLBARS).PRIMARY_TOOLBAR || component.key === (0, $4rzOL.VIEW_MODE_TOGGLE_SECTION).key);
    }
    return components;
};
const $259bccdbe77a78bc$export$9f4aa6ea8358228b = ({ editorAPI: editorAPI, beforeIcon: beforeIcon, toolbarDockingPosition: toolbarDockingPosition, editorView: editorView, popupsMountPoint: popupsMountPoint, showKeyline: showKeyline, customPrimaryToolbarComponents: customPrimaryToolbarComponents, disabled: disabled, disabledWithoutInteractionLogic: disabledWithoutInteractionLogic })=>{
    var _editorAPI$toolbar, _editorAPI$toolbar2;
    const components = editorAPI === null || editorAPI === void 0 || (_editorAPI$toolbar = editorAPI.toolbar) === null || _editorAPI$toolbar === void 0 ? void 0 : _editorAPI$toolbar.actions.getComponents();
    const runtimeOverride = (0, $5beht.useSharedPluginStateWithSelector)(editorAPI, [
        'toolbar'
    ], (states)=>{
        var _states$toolbarState;
        return (_states$toolbarState = states.toolbarState) === null || _states$toolbarState === void 0 ? void 0 : _states$toolbarState.contextualFormattingModeOverride;
    });
    const contextualFormattingEnabled = runtimeOverride ?? (editorAPI === null || editorAPI === void 0 || (_editorAPI$toolbar2 = editorAPI.toolbar) === null || _editorAPI$toolbar2 === void 0 ? void 0 : _editorAPI$toolbar2.actions.contextualFormattingMode());
    const markdownModeState = (0, $5beht.useSharedPluginStateWithSelector)(editorAPI, [
        'markdownMode'
    ], (states)=>states.markdownModeState);
    const isLivePage = markdownModeState === null || markdownModeState === void 0 ? void 0 : markdownModeState.isLivePage;
    const isMarkdownMode = markdownModeState === null || markdownModeState === void 0 ? void 0 : markdownModeState.isMarkdownMode;
    const markdownModeView = markdownModeState === null || markdownModeState === void 0 ? void 0 : markdownModeState.view;
    const isConvertedMarkdownPreview = isMarkdownMode === true && isLivePage === true && markdownModeView === 'preview';
    const intl = (0, $4vLTk.default)();
    const toolbar = components === null || components === void 0 ? void 0 : components.find((component)=>component.key === (0, $4rzOL.TOOLBARS).PRIMARY_TOOLBAR);
    const visibleToolbarComponents = (0, $bSJIT.useMemo)(()=>components ? $259bccdbe77a78bc$var$getToolbarComponentsForMarkdownView(components, markdownModeView, isConvertedMarkdownPreview) : undefined, [
        components,
        markdownModeView,
        isConvertedMarkdownPreview
    ]);
    const effectiveContextualFormattingEnabled = isConvertedMarkdownPreview && contextualFormattingEnabled === 'always-pinned' ? 'controlled' : contextualFormattingEnabled;
    const primaryToolbarDockingConfigEnabled = (0, $bj85S.shouldShowPrimaryToolbar)(effectiveContextualFormattingEnabled, toolbarDockingPosition);
    // When a toolbar portal context is provided, render the  toolbar inside a portal.
    // Otherwise fall back to a fragment just to avoid forking rendering logic.
    const { Portal: ToolbarPortal } = (0, $5wHxk.useToolbarPortal)() ?? {
        Portal: (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment
    };
    const hasToolbarPortal = ToolbarPortal !== (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment;
    const mountPoint = hasToolbarPortal ? undefined : popupsMountPoint;
    const isShortcutToFocusToolbar = (0, $bSJIT.useCallback)((event)=>{
        //Alt + F9 to reach first element in this main toolbar
        return event.altKey && event.key === 'F9';
    }, []);
    const handleEscape = (0, $bSJIT.useCallback)((event)=>{
        if (!(editorView !== null && editorView !== void 0 && editorView.hasFocus())) editorView === null || editorView === void 0 || editorView.focus();
        event.preventDefault();
        event.stopPropagation();
    }, [
        editorView
    ]);
    // Remove entire primary toolbar region if:
    // - primary toolbar isn't registered
    // - no custom primary toolbar components to render
    // note: primary toolbar must render if toolbar docking preference is set to "controlled" to avoid SSR conflicts
    // note(platform_editor_ssr_toolbar_optimistic): On the SSR and CSR, the toolbar plugin may be registered in the
    // injection API but its components not yet populated. Bypass the early-return
    // so the toolbar chrome stays mounted for layout stability; ToolbarNext renders
    // null inside it until components arrive.
    const isAwaitingToolbarComponents = (0, $5N1Y4.expValEquals)('platform_editor_ssr_toolbar_optimistic', 'isEnabled', true) && !Boolean(editorAPI === null || editorAPI === void 0 ? void 0 : editorAPI.toolbar);
    if (!isAwaitingToolbarComponents && !$259bccdbe77a78bc$var$shouldShowToolbarContainer(toolbar, customPrimaryToolbarComponents)) return /*#__PURE__*/ (0, $dc70d.jsx)(ToolbarPortal, {
        children: null
    });
    if (isConvertedMarkdownPreview && !primaryToolbarDockingConfigEnabled && !customPrimaryToolbarComponents) return /*#__PURE__*/ (0, $dc70d.jsx)(ToolbarPortal, {
        children: null
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $lLDwe.ContextPanelConsumer), {
        children: ({ width: ContextPanelWidth })=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $aHqLs.ToolbarArrowKeyNavigationProvider), {
                editorView: editorView,
                childComponentSelector: "[data-testid='ak-editor-main-toolbar']",
                isShortcutToFocusToolbar: isShortcutToFocusToolbar,
                handleEscape: handleEscape,
                intl: intl,
                children: /*#__PURE__*/ (0, $dc70d.jsx)(ToolbarPortal, {
                    children: /*#__PURE__*/ (0, $dc70d.jsxs)($259bccdbe77a78bc$var$MainToolbarWrapper, {
                        testId: "ak-editor-main-toolbar",
                        showKeyline: showKeyline || ContextPanelWidth > 0,
                        children: [
                            beforeIcon && /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                                className: (0, $9fU1q.default)([
                                    $259bccdbe77a78bc$var$styles.mainToolbarIconBefore,
                                    $259bccdbe77a78bc$var$styles.mainToolbarIconBeforeNew
                                ]),
                                children: beforeIcon
                            }),
                            /*#__PURE__*/ (0, $dc70d.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, $dc70d.jsx)($259bccdbe77a78bc$var$FirstChildWrapper, {
                                        children: (0, $5N1Y4.expValEquals)('platform_editor_ssr_toolbar_optimistic', 'isEnabled', true) ? // optimistic toolbar — render immediately on both SSR and CSR with items enabled.
                                        // Clicks are noops until editorView mounts.
                                        primaryToolbarDockingConfigEnabled && (components && visibleToolbarComponents && (0, $kGfTG.isToolbar)(toolbar) ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $bmMyd.ToolbarNext), {
                                            toolbar: toolbar,
                                            components: visibleToolbarComponents,
                                            editorView: editorView,
                                            editorAPI: editorAPI,
                                            popupsMountPoint: mountPoint,
                                            editorAppearance: "full-page",
                                            isDisabled: disabled,
                                            disabledWithoutInteractionLogic: false
                                        }) : // toolbar plugin not yet registered — render nothing inside the chrome for layout stability
                                        null) : /*#__PURE__*/ (0, $dc70d.jsx)((0, $cS3VF.default), {
                                            children: primaryToolbarDockingConfigEnabled && components && visibleToolbarComponents && (0, $kGfTG.isToolbar)(toolbar) && editorView && !(0, $7lseo.isSSR)() && /*#__PURE__*/ (0, $dc70d.jsx)((0, $bmMyd.ToolbarNext), {
                                                toolbar: toolbar,
                                                components: visibleToolbarComponents,
                                                editorView: editorView,
                                                editorAPI: editorAPI,
                                                popupsMountPoint: mountPoint,
                                                editorAppearance: "full-page",
                                                isDisabled: disabled,
                                                disabledWithoutInteractionLogic: disabledWithoutInteractionLogic
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $dc70d.jsx)($259bccdbe77a78bc$var$SecondChildWrapper, {
                                        children: /*#__PURE__*/ (0, $dc70d.jsxs)("div", {
                                            className: (0, $9fU1q.default)([
                                                $259bccdbe77a78bc$var$styles.customToolbarWrapperStyle
                                            ]),
                                            children: [
                                                !!customPrimaryToolbarComponents && 'before' in customPrimaryToolbarComponents && /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                                                    "data-testid": 'before-primary-toolbar-components-plugin',
                                                    className: (0, $9fU1q.default)([
                                                        $259bccdbe77a78bc$var$styles.beforePrimaryToolbarComponents
                                                    ]),
                                                    children: customPrimaryToolbarComponents.before
                                                }),
                                                !!customPrimaryToolbarComponents && 'after' in customPrimaryToolbarComponents ? customPrimaryToolbarComponents.after : customPrimaryToolbarComponents
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $dc70d.jsx)((0, $5wHxk.ToolbarPortalMountPoint), {})
                                ]
                            })
                        ]
                    })
                })
            })
    });
};

});
parcelRegister("bj85S", function(module, exports) {
$parcel$export(module.exports, "shouldShowPrimaryToolbar", () => $6978261962571056$export$2b04a2c5fbfbfe6c);
const $6978261962571056$export$2b04a2c5fbfbfe6c = (contextualFormattingEnabled, toolbarDockingPosition)=>{
    if (contextualFormattingEnabled === 'controlled') return toolbarDockingPosition !== 'none';
    if (contextualFormattingEnabled === 'always-pinned') return true;
    return false;
};

});

parcelRegister("cS3VF", function(module, exports) {
$parcel$export(module.exports, "default", () => $3c648d922d40b914$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $7lseo = parcelRequire("7lseo");
/**
 * ExcludeFromHydration component delays rendering of its children until after the initial
 * hydration phase. It renders the fallback during SSR/hydration and children after.
 * @param children - The content to render after hydration
 * @param fallback - Optional fallback content to render during hydration (e.g., a placeholder to prevent layout shift)
 * @returns
 */ function $3c648d922d40b914$var$ExcludeFromHydration({ children: children, fallback: fallback = null }) {
    const [shouldRender, setShouldRender] = (0, $bSJIT.useState)(false);
    (0, $bSJIT.useEffect)(()=>{
        if ((0, $7lseo.isSSR)()) return;
        setShouldRender(true);
    }, []);
    if (!shouldRender) return fallback ?? null;
    return children;
}
var $3c648d922d40b914$export$2e2bcd8739ae039 = $3c648d922d40b914$var$ExcludeFromHydration;

});




parcelRegister("jEuGx", function(module, exports) {
$parcel$export(module.exports, "CoreEditor", () => $c1378126ee842585$export$be7eaacc86ce4514);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $dMMwa = parcelRequire("dMMwa");

var $7RHfd = parcelRequire("7RHfd");

var $3vqkd = parcelRequire("3vqkd");

var $6WltM = parcelRequire("6WltM");

var $bTWXs = parcelRequire("bTWXs");

var $g6Qq4 = parcelRequire("g6Qq4");

var $951G5 = parcelRequire("951G5");

var $lrWkt = parcelRequire("lrWkt");

var $5kVgQ = parcelRequire("5kVgQ");

var $iM9ST = parcelRequire("iM9ST");

var $8dHy3 = parcelRequire("8dHy3");

var $l9YiQ = parcelRequire("l9YiQ");

var $5CCIk = parcelRequire("5CCIk");

var $6QZ0Y = parcelRequire("6QZ0Y");

var $cUwhT = parcelRequire("cUwhT");

var $kMBaN = parcelRequire("kMBaN");

var $6PsdZ = parcelRequire("6PsdZ");

var $6AIuh = parcelRequire("6AIuh");
/**
 * Editor wrapper that deals with the lifecycle logic of the editor
 * @param passedProps
 * @example
 */ function $c1378126ee842585$var$Editor(passedProps) {
    const propsRef = (0, $bSJIT.useRef)(passedProps);
    const props = (0, $kMBaN.default)(passedProps);
    (0, $bSJIT.useMemo)(()=>{
        propsRef.current = props;
    }, [
        props
    ]);
    const editorContext = (0, $iM9ST.useEditorContext)();
    const editorActionsPlaceholderInstance = (0, $bSJIT.useMemo)(()=>new (0, $5kVgQ.default)(), []);
    const editorActions = editorContext.editorActions || editorActionsPlaceholderInstance;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const handleAnalyticsEvent = (0, $bSJIT.useCallback)((data)=>{
        (0, $bTWXs.fireAnalyticsEvent)(createAnalyticsEvent)(data);
    }, [
        createAnalyticsEvent
    ]);
    const getFeatureFlagsFromRef = (0, $bSJIT.useCallback)(()=>{
        var _propsRef$current$col, _propsRef$current$col2;
        return {
            ...(0, $8dHy3.createFeatureFlagsFromProps)(propsRef.current.featureFlags),
            useNativeCollabPlugin: Boolean(typeof ((_propsRef$current$col = propsRef.current.collabEdit) === null || _propsRef$current$col === void 0 ? void 0 : _propsRef$current$col.useNativePlugin) === 'boolean' ? !!((_propsRef$current$col2 = propsRef.current.collabEdit) !== null && _propsRef$current$col2 !== void 0 && _propsRef$current$col2.useNativePlugin) : false)
        };
    }, []);
    const onEditorCreated = (0, $bSJIT.useCallback)((instance)=>{
        const { contextIdentifierProvider: contextIdentifierProvider, onEditorReady: onEditorReady, featureFlags: featureFlags } = propsRef.current;
        editorActions._privateRegisterEditor(instance.view, instance.eventDispatcher, instance.transformer, getFeatureFlagsFromRef);
        if (onEditorReady) {
            (0, $951G5.startMeasure)((0, $l9YiQ.default).ON_EDITOR_READY_CALLBACK);
            onEditorReady(editorActions);
            (0, $951G5.stopMeasure)((0, $l9YiQ.default).ON_EDITOR_READY_CALLBACK, (0, $6AIuh.default)((0, $g6Qq4.ACTION).ON_EDITOR_READY_CALLBACK, {
                contextIdentifierProvider: contextIdentifierProvider,
                featureFlags: featureFlags
            }, createAnalyticsEvent));
        }
    }, [
        editorActions,
        createAnalyticsEvent,
        getFeatureFlagsFromRef,
        propsRef
    ]);
    const onEditorDestroyed = (0, $bSJIT.useCallback)((_instance)=>{
        const { onDestroy: onDestroy } = propsRef.current;
        editorActions._privateUnregisterEditor();
        if (onDestroy) onDestroy();
    }, [
        editorActions,
        propsRef
    ]);
    (0, $cUwhT.default)(props, createAnalyticsEvent);
    const providerFactory = (0, $6PsdZ.default)(props, editorActions, createAnalyticsEvent);
    const { onSave: onSaveFromProps } = props;
    const handleSave = (0, $bSJIT.useCallback)((view)=>{
        if (onSaveFromProps) onSaveFromProps(view);
    }, [
        onSaveFromProps
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $6QZ0Y.EditorInternal), {
        props: props,
        handleAnalyticsEvent: handleAnalyticsEvent,
        createAnalyticsEvent: createAnalyticsEvent,
        preset: props.preset,
        handleSave: handleSave,
        editorActions: editorActions,
        onEditorCreated: onEditorCreated,
        onEditorDestroyed: onEditorDestroyed,
        providerFactory: providerFactory,
        AppearanceComponent: props.AppearanceComponent
    });
}
const $c1378126ee842585$var$useMemoEditorFeatureFlags = (featureFlags)=>{
    const ffRef = (0, $bSJIT.useRef)(featureFlags);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($dMMwa)))(ffRef.current, featureFlags)) ffRef.current = featureFlags;
    return ffRef.current;
};
function $c1378126ee842585$export$be7eaacc86ce4514(props) {
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const editorSessionId = (0, $bSJIT.useRef)((0, $7RHfd.default)());
    const data = (0, $bSJIT.useMemo)(()=>{
        return {
            packageName: (0, $5CCIk.name),
            packageVersion: (0, $5CCIk.version),
            componentName: 'editorCore',
            appearance: (0, $lrWkt.getAnalyticsAppearance)(props.appearance),
            editorSessionId: editorSessionId.current
        };
    }, [
        props.appearance
    ]);
    const memodEditorFeatureFlags = $c1378126ee842585$var$useMemoEditorFeatureFlags(props.featureFlags);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $3vqkd.FabricEditorAnalyticsContext), {
        // @ts-expect-error Type 'string' is not assignable to type '"editorCore" | "renderer"'.
        data: data,
        children: /*#__PURE__*/ (0, $dc70d.jsx)($c1378126ee842585$var$Editor, {
            ...props,
            featureFlags: memodEditorFeatureFlags
        })
    });
}
$c1378126ee842585$export$be7eaacc86ce4514.propTypes = {
    minHeight: ({ appearance: appearance, minHeight: minHeight })=>{
        if (minHeight && appearance && ![
            'comment',
            'chromeless'
        ].includes(appearance)) return new Error('minHeight only supports editor appearance chromeless and comment for Editor');
        return null;
    }
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$c1378126ee842585$export$2e2bcd8739ae039 = $c1378126ee842585$export$be7eaacc86ce4514;

});
parcelRegister("bTWXs", function(module, exports) {
$parcel$export(module.exports, "fireAnalyticsEvent", () => $6acb2bae064aee33$export$c7d191551feb734);

var $79fQB = parcelRequire("79fQB");

var $cP1y8 = parcelRequire("cP1y8");
const $6acb2bae064aee33$export$c7d191551feb734 = (createAnalyticsEvent, options)=>({ payload: payload, channel: channel = (0, $cP1y8.editorAnalyticsChannel) })=>{
        if (!createAnalyticsEvent) return;
        if (options !== null && options !== void 0 && options.immediate) {
            var _createAnalyticsEvent;
            (_createAnalyticsEvent = createAnalyticsEvent(payload)) === null || _createAnalyticsEvent === void 0 || _createAnalyticsEvent.fire(channel);
            return;
        }
        const queue = (0, $79fQB.AnalyticsQueue).get();
        queue.schedule(()=>{
            var _createAnalyticsEvent2;
            return (_createAnalyticsEvent2 = createAnalyticsEvent(payload)) === null || _createAnalyticsEvent2 === void 0 ? void 0 : _createAnalyticsEvent2.fire(channel);
        });
    };

});
parcelRegister("79fQB", function(module, exports) {
$parcel$export(module.exports, "AnalyticsQueue", () => $7cacc30b3836ac0a$export$b44c4ba8fe19bbc7);

var $57l7A = parcelRequire("57l7A");
class $7cacc30b3836ac0a$export$b44c4ba8fe19bbc7 {
    static #_ = this.get = (0, $57l7A.default)(()=>new $7cacc30b3836ac0a$export$b44c4ba8fe19bbc7());
    constructor(){
        this.tasks = [];
        this.running = false;
    }
    request(fn) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (window.requestIdleCallback) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        window.requestIdleCallback(fn);
        else {
            const start = performance.now();
            setTimeout(()=>{
                fn({
                    didTimeout: false,
                    timeRemaining: ()=>Math.max(0, 50 - (performance.now() - start))
                });
            }, 0);
        }
    }
    pending() {
        var _window$navigator;
        // Defensive coding as navigator.scheduling.isInputPending is an experimental API
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (typeof ((_window$navigator = window.navigator) === null || _window$navigator === void 0 || (_window$navigator = _window$navigator.scheduling) === null || _window$navigator === void 0 ? void 0 : _window$navigator.isInputPending) === 'function') {
            var _window$navigator2;
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return ((_window$navigator2 = window.navigator) === null || _window$navigator2 === void 0 || (_window$navigator2 = _window$navigator2.scheduling) === null || _window$navigator2 === void 0 ? void 0 : _window$navigator2.isInputPending()) === true;
        }
        return false;
    }
    process() {
        if (this.running) return;
        this.running = true;
        this.request((deadline)=>{
            while(deadline.timeRemaining() > 0 && this.tasks.length > 0 && !this.pending()){
                const task = this.tasks.shift();
                if (task) task();
            }
            this.running = false;
            if (this.tasks.length > 0) this.process();
        });
    }
    schedule(task) {
        this.tasks.push(task);
        this.process();
    }
}

});

parcelRegister("cP1y8", function(module, exports) {
$parcel$export(module.exports, "editorAnalyticsChannel", () => $c687d7be475eab88$export$1467dbbb3bb418c6);

var $1l5zG = parcelRequire("1l5zG");
const $c687d7be475eab88$export$1467dbbb3bb418c6 = (0, $1l5zG.FabricChannel).editor;

});


parcelRegister("5kVgQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $05ae7021472948cc$export$2e2bcd8739ae039);

var $g6Qq4 = parcelRequire("g6Qq4");

var $eXGEf = parcelRequire("eXGEf");

var $85mAs = parcelRequire("85mAs");
var $fcrbf = parcelRequire("fcrbf");

var $lrWkt = parcelRequire("lrWkt");

var $kW8qW = parcelRequire("kW8qW");

var $cw0wu = parcelRequire("cw0wu");

var $gab48 = parcelRequire("gab48");

var $4nblR = parcelRequire("4nblR");

var $hDPV9 = parcelRequire("hDPV9");

var $lV7F7 = parcelRequire("lV7F7");

var $8LxSk = parcelRequire("8LxSk");

var $j8JIA = parcelRequire("j8JIA");

var $kMyLY = parcelRequire("kMyLY");
// Please, do not copy or use this kind of code below
// @ts-ignore
const $05ae7021472948cc$var$fakePluginKey = {
    key: 'nativeCollabProviderPlugin$',
    getState: (state)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return state['nativeCollabProviderPlugin$'];
    }
};
class $05ae7021472948cc$export$2e2bcd8739ae039 {
    static from(view, eventDispatcher, transformer) {
        const editorActions = new $05ae7021472948cc$export$2e2bcd8739ae039();
        editorActions._privateRegisterEditor(view, eventDispatcher, transformer);
        return editorActions;
    }
    //#region private
    // This method needs to be public for context based helper components.
    _privateGetEditorView() {
        return this.editorView;
    }
    _privateGetEventDispatcher() {
        return this.eventDispatcher;
    }
    getFeatureFlags() {
        return {};
    }
    // This method needs to be public for EditorContext component.
    _privateRegisterEditor(editorView, eventDispatcher, contentTransformer, getFeatureFlags = ()=>({})) {
        this.contentTransformer = contentTransformer;
        this.eventDispatcher = eventDispatcher;
        this.getFeatureFlags = getFeatureFlags;
        if (!this.editorView && editorView) {
            this.editorView = editorView;
            this.listeners.forEach((cb)=>cb(editorView, eventDispatcher));
        } else if (this.editorView !== editorView) throw new Error("Editor has already been registered! It's not allowed to re-register editor with the new Editor instance.");
        if (this.contentTransformer) this.contentEncode = this.contentTransformer.encode.bind(this.contentTransformer);
    }
    // This method needs to be public for EditorContext component.
    _privateUnregisterEditor() {
        this.editorView = undefined;
        this.contentTransformer = undefined;
        this.contentEncode = undefined;
        this.eventDispatcher = undefined;
        this.getFeatureFlags = ()=>({});
    }
    _privateSubscribe(cb) {
        // If editor is registered and somebody is trying to add a listener,
        // just call it first.
        if (this.editorView && this.eventDispatcher) cb(this.editorView, this.eventDispatcher);
        this.listeners.push(cb);
    }
    _privateUnsubscribe(cb) {
        this.listeners = this.listeners.filter((c)=>c !== cb);
    }
    //#endregion
    focus({ scrollIntoView: scrollIntoView } = {
        scrollIntoView: true
    }) {
        if (!this.editorView || this.editorView.hasFocus()) return false;
        this.editorView.focus();
        if (scrollIntoView ?? true) this.editorView.dispatch(this.editorView.state.tr.scrollIntoView());
        return true;
    }
    blur() {
        if (!this.editorView || !this.editorView.hasFocus()) return false;
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.editorView.dom.blur();
        return true;
    }
    clear() {
        if (!this.editorView) return false;
        const editorView = this.editorView;
        const { state: state } = editorView;
        const tr = editorView.state.tr.setSelection((0, $cw0wu.TextSelection).create(state.doc, 0, state.doc.nodeSize - 2)).deleteSelection();
        editorView.dispatch(tr);
        return true;
    }
    // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
    /**
   * @deprecated This is deprecated and is no longer maintained.
   *
   * Use the `requestDocument` API from `editorAPI` (ie. `editorApi?.core?.actions.requestDocument( ... ))
   * it has inbuilt throttling and is designed for use with `ComposableEditor`.
   *
   * Docs on its usage are available from: https://atlaskit.atlassian.com/packages/editor/editor-core
   *
   * WARNING: this may be called repeatedly, async with care
   */ async getValue() {
        const { editorView: editorView } = this;
        if (!editorView) return;
        const doc = await (0, $4nblR.getEditorValueWithMedia)(editorView);
        const json = (0, $kMyLY.toJSON)(doc);
        if (!this.contentEncode) return json;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const nodeSanitized = (0, $kW8qW.Node).fromJSON(this.editorView.state.schema, json);
        try {
            return this.contentEncode(nodeSanitized);
        } catch (e) {
            this.dispatchAnalyticsEvent({
                action: (0, $g6Qq4.ACTION).DOCUMENT_PROCESSING_ERROR,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).EDITOR,
                eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    errorMessage: `${e instanceof Error && e.name === 'NodeNestingTransformError' ? 'NodeNestingTransformError - Failed to encode one or more nested tables' : undefined}`
                }
            });
            throw e;
        }
    }
    // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
    /**
   * @deprecated - please use `getNodeWithPosByLocalId` found in the core plugin actions instead
   * @example
    	const { editorApi, preset } = usePreset(...);
  	const extensionAPI = editorAPI?.extension?.actions?.api();
  	// Use nodeWithPos as desired
  	const nodeWithPos = extensionAPI.getNodeWithPosByLocalId(localId);
  	const node = nodeWithPos.node;
  	const nodePos = nodeWithPos.pos;
   */ getNodeByLocalId(id) {
        var _this$editorView;
        if ((_this$editorView = this.editorView) !== null && _this$editorView !== void 0 && _this$editorView.state) {
            var _this$editorView2;
            const nodes = (0, $j8JIA.findNodePosByLocalIds)((_this$editorView2 = this.editorView) === null || _this$editorView2 === void 0 ? void 0 : _this$editorView2.state, [
                id
            ]);
            const node = nodes.length >= 1 ? nodes[0] : undefined;
            return node === null || node === void 0 ? void 0 : node.node;
        }
    }
    getNodeByFragmentLocalId(id) {
        var _this$editorView3;
        if ((_this$editorView3 = this.editorView) !== null && _this$editorView3 !== void 0 && _this$editorView3.state) {
            var _this$editorView4;
            const nodes = (0, $lV7F7.findNodePosByFragmentLocalIds)((_this$editorView4 = this.editorView) === null || _this$editorView4 === void 0 ? void 0 : _this$editorView4.state, [
                id
            ]);
            return nodes.length > 0 ? nodes[0].node : undefined;
        }
    }
    /**
   * This method will return the currently selected `Node` if the selection is a `Node`.
   * Otherwise, if the selection is textual or a non-selectable `Node` within another selectable `Node`, the closest selectable parent `Node` will be returned.
   */ getSelectedNode() {
        var _this$editorView5;
        if ((_this$editorView5 = this.editorView) !== null && _this$editorView5 !== void 0 && (_this$editorView5 = _this$editorView5.state) !== null && _this$editorView5 !== void 0 && _this$editorView5.selection) {
            var _findParentNode;
            const { selection: selection } = this.editorView.state;
            if (selection instanceof (0, $cw0wu.NodeSelection)) return selection.node;
            return (_findParentNode = (0, $gab48.findParentNode)((node)=>Boolean(node.type.spec.selectable))(selection)) === null || _findParentNode === void 0 ? void 0 : _findParentNode.node;
        }
    }
    isDocumentEmpty() {
        // Unlikely case when editorView has been destroyed before calling isDocumentEmpty,
        // we treat this case as if document was empty.
        if (!this.editorView) return true;
        return (0, $8LxSk.isEmptyDocument)(this.editorView.state.doc);
    }
    // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
    /**
   * @deprecated - please use `replaceDocument` found in the core plugin actions instead
   * using this will reset your Editor State which could cause some things to break (like emojis)
   * @example - use the `replaceDocument` from the core plugin actions instead
   * ```ts
   * const { editorApi, preset } = usePreset(...);
  	// where you need it
  	editorApi?.core.actions.replaceDocument(value);
  	return <ComposableEditor preset={preset} ... />
   */ replaceDocument(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    rawValue, shouldScrollToBottom = true, // eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
    /** @deprecated [ED-14158] shouldAddToHistory is not being used in this function */ shouldAddToHistory = true) {
        (0, $hDPV9.default)('EditorActions.replaceDocument', {
            shouldAddToHistory: shouldAddToHistory
        }, [
            {
                property: 'shouldAddToHistory',
                description: '[ED-14158] EditorActions.replaceDocument does not use the shouldAddToHistory arg',
                type: 'removed'
            }
        ]);
        if (!this.editorView || rawValue === undefined || rawValue === null) return false;
        if (this.eventDispatcher) this.eventDispatcher.emit('resetEditorState', {
            doc: rawValue,
            shouldScrollToBottom: shouldScrollToBottom
        });
        return true;
    }
    replaceSelection(rawValue, tryToReplace, position) {
        if (!this.editorView) return false;
        const { state: state } = this.editorView;
        if (!rawValue) {
            const tr = state.tr.deleteSelection().scrollIntoView();
            this.editorView.dispatch(tr);
            return true;
        }
        const { schema: schema } = state;
        const content = Array.isArray(rawValue) ? (0, $85mAs.processRawFragmentValue)(schema, rawValue, undefined, undefined, undefined, this.dispatchAnalyticsEvent) : (0, $fcrbf.processRawValue)(schema, rawValue, undefined, undefined, undefined, this.dispatchAnalyticsEvent);
        if (!content) return false;
        // try to find a place in the document where to insert a node if its not allowed at the cursor position by schema
        this.editorView.dispatch((0, $gab48.safeInsert)(content, position, tryToReplace)(state.tr).scrollIntoView());
        return true;
    }
    appendText(text) {
        if (!this.editorView || !text) return false;
        const { state: state } = this.editorView;
        const lastChild = state.doc.lastChild;
        if (lastChild && lastChild.type !== state.schema.nodes.paragraph) return false;
        const tr = state.tr.insertText(text).scrollIntoView();
        this.editorView.dispatch(tr);
        return true;
    }
    constructor(){
        this.listeners = [];
        this.dispatchAnalyticsEvent = (payload)=>{
            if (this.eventDispatcher) {
                const dispatch = (0, $eXGEf.createDispatch)(this.eventDispatcher);
                dispatch((0, $lrWkt.analyticsEventKey), {
                    payload: payload
                });
            }
        };
        /**
   * If editor is using new collab service,
   * we want editor to call the collab provider to
   * retrieve the final acknowledged state of the
   * editor. The final acknowledged editor state
   * refers to the latest state of editor with confirmed
   * steps.
   */ this.getResolvedEditorState = async (reason)=>{
            const { useNativeCollabPlugin: useNativeCollabPlugin } = this.getFeatureFlags();
            if (!this.editorView) throw new Error('Called getResolvedEditorState before editorView is ready');
            if (!useNativeCollabPlugin) {
                const editorValue = await this.getValue();
                if (!editorValue) throw new Error('editorValue is undefined');
                return {
                    content: editorValue,
                    title: null,
                    stepVersion: -1
                };
            }
            const editorView = this.editorView;
            await (0, $4nblR.getEditorValueWithMedia)(editorView);
            const collabEditState = $05ae7021472948cc$var$fakePluginKey.getState(editorView.state);
            return collabEditState === null || collabEditState === void 0 ? void 0 : collabEditState.getFinalAcknowledgedState(reason);
        };
    }
}

});
parcelRegister("eXGEf", function(module, exports) {
$parcel$export(module.exports, "EventDispatcher", () => $654acdd80e5f0e89$export$ec8b666c5fe2c75a);
$parcel$export(module.exports, "createDispatch", () => $654acdd80e5f0e89$export$f57f9cc7ce57b7d0);
class $654acdd80e5f0e89$export$ec8b666c5fe2c75a {
    on(event, cb) {
        if (!this.listeners[event]) this.listeners[event] = new Set();
        this.listeners[event].add(cb);
    }
    has(event, cb) {
        if (!this.listeners[event]) return false;
        return this.listeners[event].has(cb);
    }
    off(event, cb) {
        if (!this.listeners[event]) return;
        if (this.listeners[event].has(cb)) this.listeners[event].delete(cb);
    }
    emit(event, data) {
        if (!this.listeners[event]) return;
        this.listeners[event].forEach((cb)=>cb(data));
    }
    destroy() {
        this.listeners = {};
    }
    constructor(){
        this.listeners = {};
    }
}
function $654acdd80e5f0e89$var$getEventFromEventName(eventName) {
    return typeof eventName === 'string' ? eventName : eventName.key;
}
function $654acdd80e5f0e89$export$f57f9cc7ce57b7d0(eventDispatcher) {
    return (eventName, data)=>{
        if (!eventName) throw new Error('event name is required!');
        eventDispatcher.emit($654acdd80e5f0e89$var$getEventFromEventName(eventName), data);
    };
}

});

parcelRegister("85mAs", function(module, exports) {
$parcel$export(module.exports, "processRawFragmentValue", () => $bbcca4ebf7f5ea6e$export$89b7989c347e6a7b);

var $kW8qW = parcelRequire("kW8qW");

var $fcrbf = parcelRequire("fcrbf");
function $bbcca4ebf7f5ea6e$export$89b7989c347e6a7b(schema, value, providerFactory, sanitizePrivateContent, contentTransformer, dispatchAnalyticsEvent) {
    if (!value) return;
    const adfEntities = value.map((item)=>(0, $fcrbf.processRawValue)(schema, item, providerFactory, sanitizePrivateContent, contentTransformer, dispatchAnalyticsEvent)).filter((item)=>Boolean(item));
    if (adfEntities.length === 0) return;
    return (0, $kW8qW.Fragment).from(adfEntities);
}

});
parcelRegister("fcrbf", function(module, exports) {
$parcel$export(module.exports, "processRawValueWithoutValidation", () => $c1c209372122de19$export$cafe23194e65f591);
$parcel$export(module.exports, "processRawValue", () => $c1c209372122de19$export$f1a0a61081c3ed62);

var $dDhIG = parcelRequire("dDhIG");

var $huQpY = parcelRequire("huQpY");

var $d6ikE = parcelRequire("d6ikE");

var $75GTZ = parcelRequire("75GTZ");

var $2GwqA = parcelRequire("2GwqA");

var $7FYZ0 = parcelRequire("7FYZ0");

var $4T0Fy = parcelRequire("4T0Fy");

var $cXIcJ = parcelRequire("cXIcJ");

var $tj3sM = parcelRequire("tj3sM");

var $hTzs3 = parcelRequire("hTzs3");

var $9WLGT = parcelRequire("9WLGT");

var $3y6N2 = parcelRequire("3y6N2");

var $kW8qW = parcelRequire("kW8qW");

var $5N1Y4 = parcelRequire("5N1Y4");

var $g6Qq4 = parcelRequire("g6Qq4");

var $bnbmo = parcelRequire("bnbmo");

var $eAhRP = parcelRequire("eAhRP");

var $e28Rw = parcelRequire("e28Rw");

var $cyTOy = parcelRequire("cyTOy");

var $awuFt = parcelRequire("awuFt");

var $8gKUV = parcelRequire("8gKUV");

var $eRA48 = parcelRequire("eRA48");

var $fdVRQ = parcelRequire("fdVRQ");

var $85mAs = parcelRequire("85mAs");
// Gate the generalised (table + expand + panel + blockquote + bodiedExtension) panel_c1
// fallback behind the consolidated container-in-panel experiment. The in-production
// table-in-panel path keeps using the deprecated table-only transform until
// platform_editor_nest_container_in_panel is rolled out.
const $c1c209372122de19$var$runPanelC1FallbackTransform = (schema, adf)=>(0, $e28Rw.isPanelNestingContainerExperimentEnabled)() ? (0, $cXIcJ.panelC1FallbackTransformV2)(schema, adf) : (0, $4T0Fy.panelC1FallbackTransform)(schema, adf);
const $c1c209372122de19$var$transformNestedTablesWithAnalytics = (node, dispatchAnalyticsEvent)=>{
    try {
        const { transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $3y6N2.transformNestedTablesIncomingDocument)(node);
        if (isTransformed) {
            if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
                action: (0, $g6Qq4.ACTION).NESTED_TABLE_TRANSFORMED,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).EDITOR,
                eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL
            });
            return {
                transformedAdf: transformedAdf,
                isTransformed: isTransformed
            };
        }
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error('Failed to transform one or more nested tables in the document');
        if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $g6Qq4.ACTION).DOCUMENT_PROCESSING_ERROR,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).EDITOR,
            eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL,
            attributes: {
                errorMessage: `${e instanceof Error && e.name === 'NodeNestingTransformError' ? 'NodeNestingTransformError - Failed to transform one or more nested tables' : undefined}`
            }
        });
    }
    return {
        transformedAdf: node,
        isTransformed: false
    };
};
const $c1c209372122de19$var$transformContainerNodesWithAnalytics = (node, schema, dispatchAnalyticsEvent)=>{
    try {
        const { transformedAdf: transformedAdf, isTransformed: isTransformed, transformedNodeTypes: transformedNodeTypes } = (0, $huQpY.transformContainerNodes)(node, schema);
        if (isTransformed && transformedAdf) {
            if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
                action: (0, $g6Qq4.ACTION).CONTAINER_NODE_TRANSFORMED,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).EDITOR,
                eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    transformedNodeTypes: transformedNodeTypes
                }
            });
            return {
                transformedAdf: transformedAdf,
                isTransformed: isTransformed
            };
        }
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error('Failed to transform one or more panel container nodes');
        if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $g6Qq4.ACTION).DOCUMENT_PROCESSING_ERROR,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).EDITOR,
            eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL,
            attributes: {
                errorMessage: `${e instanceof Error && e.name === 'NodeNestingTransformError' ? 'NodeNestingTransformError - Failed to transform panel container nodes' : undefined}`
            }
        });
    }
    return {
        transformedAdf: node,
        isTransformed: false
    };
};
function $c1c209372122de19$export$cafe23194e65f591(schema, value, dispatchAnalyticsEvent) {
    if (!value) return;
    let node;
    if (typeof value === 'string') try {
        node = JSON.parse(value);
    } catch  {
        // eslint-disable-next-line no-console
        console.error(`Error processing value: ${value} isn't a valid JSON`);
        return;
    }
    else node = value;
    // Convert nested-table extensions into nested tables
    let { transformedAdf: transformedAdf } = $c1c209372122de19$var$transformNestedTablesWithAnalytics(node, dispatchAnalyticsEvent);
    const result = (0, $tj3sM.syncBlockFallbackTransform)(schema, transformedAdf);
    if (result.isTransformed && result.transformedAdf) transformedAdf = result.transformedAdf;
    const panelC1Result = $c1c209372122de19$var$runPanelC1FallbackTransform(schema, transformedAdf);
    if (panelC1Result.isTransformed && panelC1Result.transformedAdf) transformedAdf = panelC1Result.transformedAdf;
    if ((0, $5N1Y4.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true)) ({ transformedAdf: transformedAdf } = $c1c209372122de19$var$transformContainerNodesWithAnalytics(transformedAdf, schema, dispatchAnalyticsEvent));
    return (0, $kW8qW.Node).fromJSON(schema, transformedAdf);
}
function $c1c209372122de19$export$f1a0a61081c3ed62(schema, value, providerFactory, sanitizePrivateContent, contentTransformer, dispatchAnalyticsEvent) {
    if (!value) return;
    let node;
    if (typeof value === 'string') try {
        if (contentTransformer) {
            const doc = contentTransformer.parse(value);
            node = doc.toJSON();
        } else node = JSON.parse(value);
    } catch  {
        // eslint-disable-next-line no-console
        console.error(`Error processing value: ${value} isn't a valid JSON`);
        return;
    }
    else node = value;
    if (Array.isArray(node)) {
        // eslint-disable-next-line no-console
        console.error(`Error processing value: ${node} is an array, but it must be an object.`);
        return;
    }
    try {
        // ProseMirror always require a child under doc
        if (node.type === 'doc') {
            if (Array.isArray(node.content) && node.content.length === 0) node.content.push({
                type: 'paragraph',
                content: []
            });
            // Just making sure doc is always valid
            if (!node.version) node.version = 1;
        }
        if (contentTransformer) return (0, $kW8qW.Node).fromJSON(schema, node);
        // link mark on mediaSingle is deprecated, need to move link mark to child media node
        // https://product-fabric.atlassian.net/browse/ED-14043
        let { transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $2GwqA.transformMediaLinkMarks)(node);
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $g6Qq4.ACTION).MEDIA_LINK_TRANSFORMED,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).EDITOR,
            eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL
        });
        // Fix mediaSingle width issues
        ({ transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $9WLGT.transformMediaSingleWidth)(transformedAdf));
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $g6Qq4.ACTION).MEDIA_SINGLE_WIDTH_TRANSFORMED,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).EDITOR,
            eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL
        });
        // See: HOT-97965 https://product-fabric.atlassian.net/browse/ED-14400
        // We declared in code mark spec that links and marks should not co-exist on
        // text nodes. This util strips code marks from bad text nodes and preserves links.
        // Otherwise, prosemirror will try to repair the invalid document by stripping links
        // and preserving code marks during content changes.
        ({ transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $hTzs3.transformTextLinkCodeMarks)(transformedAdf));
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $g6Qq4.ACTION).TEXT_LINK_MARK_TRANSFORMED,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).EDITOR,
            eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL
        });
        let discardedMarks = [];
        ({ transformedAdf: transformedAdf, isTransformed: isTransformed, discardedMarks: discardedMarks } = (0, $dDhIG.transformDedupeMarks)(transformedAdf));
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $g6Qq4.ACTION).DEDUPE_MARKS_TRANSFORMED_V2,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).EDITOR,
            eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL,
            attributes: {
                /** UGC WARNING
           *
           * DO NOT include the `mark` attributes inside, we map here to only
           * extract the mark type as that is the only non-UGC safe information
           * that we can add to event-attributes
           *
           */ discardedMarkTypes: discardedMarks.map((mark)=>mark.type)
            }
        });
        ({ transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $7FYZ0.transformNodesMissingContent)(transformedAdf));
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $g6Qq4.ACTION).NODES_MISSING_CONTENT_TRANSFORMED,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).EDITOR,
            eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL
        });
        ({ transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $d6ikE.transformIndentationMarks)(transformedAdf));
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $g6Qq4.ACTION).INDENTATION_MARKS_TRANSFORMED,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).EDITOR,
            eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL
        });
        ({ transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $75GTZ.transformInvalidMediaContent)(transformedAdf));
        if (isTransformed && dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $g6Qq4.ACTION).INVALID_MEDIA_CONTENT_TRANSFORMED,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).EDITOR,
            eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL
        });
        if (dispatchAnalyticsEvent) {
            var _transformedAdf$conte;
            const hasSingleColumnLayout = (_transformedAdf$conte = transformedAdf.content) === null || _transformedAdf$conte === void 0 ? void 0 : _transformedAdf$conte.some((node)=>{
                var _node$content;
                return node && node.type === 'layoutSection' && ((_node$content = node.content) === null || _node$content === void 0 ? void 0 : _node$content.length) === 1;
            });
            if (hasSingleColumnLayout) dispatchAnalyticsEvent({
                action: (0, $g6Qq4.ACTION).SINGLE_COL_LAYOUT_DETECTED,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).EDITOR,
                eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL
            });
        }
        const panelC1Result = $c1c209372122de19$var$runPanelC1FallbackTransform(schema, transformedAdf);
        if (panelC1Result.isTransformed && panelC1Result.transformedAdf) transformedAdf = panelC1Result.transformedAdf;
        // Validate ADF first before converting nested-table extensions into nested tables
        // This matches the renderer's behavior in render-document.ts
        const allowNestedTables = (0, $bnbmo.isNestedTablesSupported)(schema);
        const allowTableInPanel = (0, $awuFt.isPanelNestingTableSupported)(schema);
        const allowContainerInPanel = (0, $cyTOy.isPanelNestingContainerSupported)(schema);
        const validateADFEntityOptions = allowNestedTables || allowTableInPanel || allowContainerInPanel ? {
            allowNestedTables: allowNestedTables || undefined,
            allowTableInPanel: allowTableInPanel || undefined,
            allowContainerInPanel: allowContainerInPanel || undefined
        } : undefined;
        let entity = (0, $fdVRQ.validateADFEntity)(schema, transformedAdf || node, dispatchAnalyticsEvent, validateADFEntityOptions);
        // Convert nested-table extensions into nested tables
        ({ transformedAdf: transformedAdf } = $c1c209372122de19$var$transformNestedTablesWithAnalytics(entity, dispatchAnalyticsEvent));
        entity = transformedAdf;
        // The container-node promotion (panel -> panel_c1) is schema-driven and shared across
        // nesting scenarios, so it runs when any panel container-variant experiment is on.
        if ((0, $eAhRP.isPanelC1SchemaEnabled)()) {
            ({ transformedAdf: transformedAdf } = $c1c209372122de19$var$transformContainerNodesWithAnalytics(entity, schema, dispatchAnalyticsEvent));
            entity = transformedAdf;
        }
        const newEntity = $c1c209372122de19$var$maySanitizePrivateContent(entity, providerFactory, sanitizePrivateContent);
        const parsedDoc = (0, $kW8qW.Node).fromJSON(schema, newEntity);
        // throws an error if the document is invalid
        try {
            parsedDoc.check();
        } catch (err) {
            if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
                action: (0, $g6Qq4.ACTION).INVALID_PROSEMIRROR_DOCUMENT,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).EDITOR,
                eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL
            });
            throw err;
        }
        if (dispatchAnalyticsEvent) (0, $eRA48.findAndTrackUnsupportedContentNodes)(parsedDoc, schema, dispatchAnalyticsEvent);
        return parsedDoc;
    } catch (e) {
        if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $g6Qq4.ACTION).DOCUMENT_PROCESSING_ERROR,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).EDITOR,
            eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL
        });
        // eslint-disable-next-line no-console
        console.error(`Error processing document:\n${e instanceof Error ? e.message : String(e)}\n\n`, JSON.stringify(node));
        if ($c1c209372122de19$var$isProseMirrorSchemaCheckError(e)) throw e;
        return;
    }
}
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $c1c209372122de19$var$INVALID_MARKS_REGEX = /^Invalid collection of marks for node/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $c1c209372122de19$var$INVALID_CONTENT_REGEX = /^Invalid content for node/;
function $c1c209372122de19$var$isProseMirrorSchemaCheckError(error) {
    return error instanceof RangeError && (!!error.message.match($c1c209372122de19$var$INVALID_MARKS_REGEX) || !!error.message.match($c1c209372122de19$var$INVALID_CONTENT_REGEX));
}
const $c1c209372122de19$var$maySanitizePrivateContent = (entity, providerFactory, sanitizePrivateContent)=>{
    if (sanitizePrivateContent && providerFactory) return (0, $8gKUV.sanitizeNodeForPrivacy)(entity, providerFactory);
    return entity;
};

});
parcelRegister("dDhIG", function(module, exports) {
$parcel$export(module.exports, "transformDedupeMarks", () => $b0fc6751dea7cb31$export$af4e387303482581);

var $hMBe3 = parcelRequire("hMBe3");
// This is the set of marks that we wont allow in duplicate to
// exist on a given node, regardless of their attributes. We do
// not include annotations here, because we do allow duplicate
// annotations as long as they have unique id attributes (valid scenario)
const $b0fc6751dea7cb31$var$markDuplicatesDisallowed = new Set([
    'strong',
    'underline',
    'textColor',
    'link',
    'em',
    'subsup',
    'strike',
    'backgroundColor'
]);
const $b0fc6751dea7cb31$var$maybeHasDisallowedDuplicateMarks = (node)=>{
    var _node$marks;
    const markTypes = (_node$marks = node.marks) === null || _node$marks === void 0 || (_node$marks = _node$marks.map((mark)=>mark.type)) === null || _node$marks === void 0 ? void 0 : _node$marks.filter((markType)=>// For annotations, we are performing the same cheap check
        // for duplicates by type, without considering IDs, to quickly determine
        // whether there may be potential deduping targets.
        // In the actual deduping logic in maybeRemoveDisallowedDuplicateMarks,
        // we correctly/safely dedupe annotations by their unique IDs.
        $b0fc6751dea7cb31$var$markDuplicatesDisallowed.has(markType) || markType === 'annotation');
    if (!(markTypes !== null && markTypes !== void 0 && markTypes.length)) return false;
    return new Set(markTypes).size !== markTypes.length;
};
const $b0fc6751dea7cb31$var$maybeRemoveDisallowedDuplicateMarks = (node)=>{
    const quota = new Map();
    const annotationsQuota = new Map();
    const discardedMarks = [];
    $b0fc6751dea7cb31$var$markDuplicatesDisallowed.forEach((mark)=>{
        quota.set(mark, false);
    });
    if (!node.marks) return {
        discardedMarks: discardedMarks
    };
    const dedupedMarks = node.marks.filter((mark)=>{
        const markType = mark.type;
        if (markType === 'annotation') {
            var _mark$attrs;
            const id = (_mark$attrs = mark.attrs) === null || _mark$attrs === void 0 ? void 0 : _mark$attrs.id;
            if (annotationsQuota.has(id)) {
                discardedMarks.push(mark);
                return false;
            } else {
                annotationsQuota.set(id, true);
                return true;
            }
        }
        if (quota.has(markType)) {
            if (!quota.get(markType)) {
                quota.set(markType, true);
                return true;
            } else {
                discardedMarks.push(mark);
                return false;
            }
        }
        return true;
    });
    return {
        node: {
            ...node,
            marks: dedupedMarks
        },
        discardedMarks: discardedMarks
    };
};
const $b0fc6751dea7cb31$export$af4e387303482581 = (adf)=>{
    let isTransformed = false;
    const discardedMarks = [];
    const transformedAdf = (0, $hMBe3.traverse)(adf, {
        text: (node)=>{
            if ($b0fc6751dea7cb31$var$maybeHasDisallowedDuplicateMarks(node)) {
                const result = $b0fc6751dea7cb31$var$maybeRemoveDisallowedDuplicateMarks(node);
                const resultDiscardedMarks = result.discardedMarks;
                if (resultDiscardedMarks.length) {
                    discardedMarks.push(...resultDiscardedMarks);
                    isTransformed = true;
                    return result.node;
                }
            }
            return;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed,
        discardedMarks: discardedMarks
    };
};

});

parcelRegister("d6ikE", function(module, exports) {
$parcel$export(module.exports, "transformIndentationMarks", () => $a0d485646523149a$export$c06e4b521519af22);

var $hMBe3 = parcelRequire("hMBe3");
const $a0d485646523149a$var$hasChildHeadingWithIndentation = (node)=>{
    var _node$content;
    return ((_node$content = node.content) === null || _node$content === void 0 ? void 0 : _node$content.some((childNode)=>{
        var _childNode$marks;
        return (childNode === null || childNode === void 0 ? void 0 : childNode.type) === 'heading' && (childNode === null || childNode === void 0 || (_childNode$marks = childNode.marks) === null || _childNode$marks === void 0 ? void 0 : _childNode$marks.some((mark)=>mark.type === 'indentation'));
    })) ?? false;
};
const $a0d485646523149a$var$removeIndentationFromHeadings = (node)=>{
    var _node$content2;
    return {
        ...node,
        content: (_node$content2 = node.content) === null || _node$content2 === void 0 ? void 0 : _node$content2.map((childNode)=>{
            if ((childNode === null || childNode === void 0 ? void 0 : childNode.type) === 'heading') {
                var _childNode$marks2;
                return {
                    ...childNode,
                    marks: (_childNode$marks2 = childNode.marks) === null || _childNode$marks2 === void 0 ? void 0 : _childNode$marks2.filter((mark)=>mark.type !== 'indentation')
                };
            }
            return childNode;
        })
    };
};
const $a0d485646523149a$export$c06e4b521519af22 = (adf)=>{
    let isTransformed = false;
    const transformedAdf = (0, $hMBe3.traverse)(adf, {
        tableCell: (node)=>{
            if ($a0d485646523149a$var$hasChildHeadingWithIndentation(node)) {
                isTransformed = true;
                return $a0d485646523149a$var$removeIndentationFromHeadings(node);
            }
            return;
        },
        tableHeader: (node)=>{
            if ($a0d485646523149a$var$hasChildHeadingWithIndentation(node)) {
                isTransformed = true;
                return $a0d485646523149a$var$removeIndentationFromHeadings(node);
            }
            return;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};

});

parcelRegister("75GTZ", function(module, exports) {
$parcel$export(module.exports, "transformInvalidMediaContent", () => $3ec28c099c0f4db8$export$1c8c16d74c7a63bf);

var $hMBe3 = parcelRequire("hMBe3");

var $3jUou = parcelRequire("3jUou");
const $3ec28c099c0f4db8$var$getChildrenTypeCounts = (nodeContent, allowedTypes)=>{
    const childrenTypes = {};
    nodeContent.forEach((childNode)=>{
        if (!(childNode !== null && childNode !== void 0 && childNode.type) || !allowedTypes.includes(childNode.type)) return;
        if (!childrenTypes[childNode.type]) {
            childrenTypes[childNode.type] = 1;
            return;
        }
        childrenTypes[childNode.type]++;
    });
    return childrenTypes;
};
const $3ec28c099c0f4db8$var$removeDuplicatedNodes = (type, content, predicate)=>{
    let maxIterations = 10;
    let childrenTypeCounts = $3ec28c099c0f4db8$var$getChildrenTypeCounts(content, [
        type
    ])[type];
    let firstPredicateNodeIndex = content.findIndex(predicate);
    while(childrenTypeCounts > 1 && firstPredicateNodeIndex > -1 && maxIterations-- > 0){
        content.splice(firstPredicateNodeIndex, 1);
        firstPredicateNodeIndex = content.findIndex(predicate);
        childrenTypeCounts = $3ec28c099c0f4db8$var$getChildrenTypeCounts(content, [
            type
        ])[type];
    }
};
/**
 * @param  {{[type:string]:number}} allowedTypes - array types allowed to deduplicate
 */ const $3ec28c099c0f4db8$var$deduplicateMediaSingleChildren = (node, allowedTypes)=>{
    if (!node.content) return;
    const content = [
        ...node.content
    ];
    Object.keys(allowedTypes).forEach((type)=>{
        //prioritise removing empty nodes first
        $3ec28c099c0f4db8$var$removeDuplicatedNodes(type, content, (node)=>(node === null || node === void 0 ? void 0 : node.type) === type && (0, $3jUou.isEmpty)(node));
        //remove other remaining dupicates
        $3ec28c099c0f4db8$var$removeDuplicatedNodes(type, content, (node)=>(node === null || node === void 0 ? void 0 : node.type) === type);
    });
    return {
        ...node,
        content: content
    };
};
const $3ec28c099c0f4db8$export$1c8c16d74c7a63bf = (adf)=>{
    let isTransformed = false;
    const transformedAdf = (0, $hMBe3.traverse)(adf, {
        mediaSingle: (node)=>{
            var _node$content;
            if (!(node !== null && node !== void 0 && (_node$content = node.content) !== null && _node$content !== void 0 && _node$content.length)) return;
            const disallowedDuplicateTypes = [
                'media',
                'caption'
            ];
            const childrenTypes = $3ec28c099c0f4db8$var$getChildrenTypeCounts(node.content, disallowedDuplicateTypes);
            if (Object.values(childrenTypes).some((occurences)=>occurences > 1)) {
                isTransformed = true;
                return $3ec28c099c0f4db8$var$deduplicateMediaSingleChildren(node, childrenTypes);
            }
            return;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};

});

parcelRegister("7FYZ0", function(module, exports) {
$parcel$export(module.exports, "transformNodesMissingContent", () => $dba4beb412763be9$export$652814b83c30d251);

var $lIQsf = parcelRequire("lIQsf");
var $aKjrj = parcelRequire("aKjrj");
var $84BAN = parcelRequire("84BAN");
var $k7gOm = parcelRequire("k7gOm");

var $hMBe3 = parcelRequire("hMBe3");

var $3jUou = parcelRequire("3jUou");
const $dba4beb412763be9$var$getMaxColumnsCountForTable = (tableNode)=>{
    var _tableNode$content;
    let colsInRow = 1;
    (_tableNode$content = tableNode.content) === null || _tableNode$content === void 0 || _tableNode$content.forEach((childNode)=>{
        var _childNode$content;
        if ((childNode === null || childNode === void 0 ? void 0 : childNode.type) === 'tableRow' && typeof ((_childNode$content = childNode.content) === null || _childNode$content === void 0 ? void 0 : _childNode$content.length) === 'number' && childNode.content.length > colsInRow) colsInRow = childNode.content.length;
    });
    return colsInRow;
};
const $dba4beb412763be9$var$createValidEmptyContent = (node)=>{
    switch(node.type){
        case 'tableCell':
            return [
                (0, $aKjrj.paragraph)()
            ];
        default:
            return [];
    }
};
const $dba4beb412763be9$var$fixIfTableCellInvalidEmpty = (reportTransform)=>(node)=>{
        if ((0, $3jUou.isEmpty)(node)) {
            reportTransform();
            return {
                ...node,
                content: $dba4beb412763be9$var$createValidEmptyContent(node)
            };
        }
        return;
    };
const $dba4beb412763be9$var$hasNonListItemChildren = (node)=>{
    var _node$content;
    return (_node$content = node.content) === null || _node$content === void 0 ? void 0 : _node$content.some((node)=>(node === null || node === void 0 ? void 0 : node.type) !== 'listItem');
};
const $dba4beb412763be9$var$hasEmptyListItemChildren = (node)=>{
    var _node$content2;
    return (_node$content2 = node.content) === null || _node$content2 === void 0 ? void 0 : _node$content2.some((childNode)=>{
        var _childNode$content2;
        return (childNode === null || childNode === void 0 ? void 0 : childNode.type) === 'listItem' && !((_childNode$content2 = childNode.content) !== null && _childNode$content2 !== void 0 && _childNode$content2.length);
    });
};
const $dba4beb412763be9$var$tryCreateValidListItemWrappedChildren = (parentListNode)=>{
    var _parentListNode$conte;
    return (_parentListNode$conte = parentListNode.content) === null || _parentListNode$conte === void 0 ? void 0 : _parentListNode$conte.map((childNode)=>{
        if (childNode) switch(childNode.type){
            case 'listItem':
                if ((0, $3jUou.isEmpty)(childNode)) {
                    const result = (0, $lIQsf.listItem)([
                        (0, $aKjrj.paragraph)()
                    ]);
                    return result;
                }
                return childNode;
            case 'text':
                return (0, $lIQsf.listItem)([
                    (0, $aKjrj.paragraph)(childNode)
                ]);
            default:
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                return (0, $lIQsf.listItem)([
                    childNode
                ]);
        }
        return childNode;
    });
};
const $dba4beb412763be9$var$fixIfListParentWithInvalidListItemChildren = (reportTransform)=>(node)=>{
        if ($dba4beb412763be9$var$hasNonListItemChildren(node) || $dba4beb412763be9$var$hasEmptyListItemChildren(node)) {
            reportTransform();
            return {
                ...node,
                content: $dba4beb412763be9$var$tryCreateValidListItemWrappedChildren(node)
            };
        }
        return;
    };
const $dba4beb412763be9$var$hasNonTableRowChildren = (node)=>{
    var _node$content3;
    return (_node$content3 = node.content) === null || _node$content3 === void 0 ? void 0 : _node$content3.some((node)=>(node === null || node === void 0 ? void 0 : node.type) !== 'tableRow');
};
const $dba4beb412763be9$var$tryCreateValidTableRowWrappedChildren = (parentTableNode)=>{
    var _parentTableNode$cont;
    const maxColsCount = $dba4beb412763be9$var$getMaxColumnsCountForTable(parentTableNode);
    return (_parentTableNode$cont = parentTableNode.content) === null || _parentTableNode$cont === void 0 ? void 0 : _parentTableNode$cont.map((childNode)=>{
        if (childNode) switch(childNode.type){
            case 'text':
                return (0, $k7gOm.tableRow)([
                    (0, $84BAN.tableCell)({})((0, $aKjrj.paragraph)(childNode)),
                    ...new Array(maxColsCount - 1).fill((0, $84BAN.tableCell)({})((0, $aKjrj.paragraph)()))
                ]);
            case 'tableCell':
                return (0, $k7gOm.tableRow)([
                    childNode
                ]);
            case 'tableRow':
                if ((0, $3jUou.isEmpty)(childNode)) return (0, $k7gOm.tableRow)([
                    ...new Array(maxColsCount).fill((0, $84BAN.tableCell)({})((0, $aKjrj.paragraph)()))
                ]);
                return childNode;
            default:
                return childNode;
        }
        return childNode;
    });
};
const $dba4beb412763be9$var$hasEmptyTableRowChildren = (node)=>{
    var _node$content4;
    return (node === null || node === void 0 || (_node$content4 = node.content) === null || _node$content4 === void 0 ? void 0 : _node$content4.some((node)=>{
        var _node$content5;
        return (node === null || node === void 0 ? void 0 : node.type) === 'tableRow' && (node === null || node === void 0 || (_node$content5 = node.content) === null || _node$content5 === void 0 ? void 0 : _node$content5.length) === 0;
    })) || undefined;
};
const $dba4beb412763be9$var$fixIfTableParentWithInvalidTableRowChildren = (reportTransform)=>(node)=>{
        if ($dba4beb412763be9$var$hasEmptyTableRowChildren(node) || $dba4beb412763be9$var$hasNonTableRowChildren(node)) {
            reportTransform();
            return {
                ...node,
                content: $dba4beb412763be9$var$tryCreateValidTableRowWrappedChildren(node)
            };
        }
        return;
    };
const $dba4beb412763be9$var$removeMediaSingleWithNoContent = (reportTransform)=>(node)=>{
        if ((0, $3jUou.isEmpty)(node)) {
            reportTransform();
            return false;
        }
        return;
    };
const $dba4beb412763be9$export$652814b83c30d251 = (adf)=>{
    let isTransformed = false;
    const reportTransform = ()=>{
        isTransformed = true;
    };
    let transformedAdf = (0, $hMBe3.traverse)(adf, {
        tableCell: $dba4beb412763be9$var$fixIfTableCellInvalidEmpty(reportTransform)
    });
    // Empty mediaSingle nodes get stripped from the document and so this transform
    // will create an empty listItem if the media node is in a list. Empty listItems
    // are invalid adf, so we need to transform the mediaSingle nodes first.
    transformedAdf = (0, $hMBe3.traverse)(transformedAdf || adf, {
        mediaSingle: $dba4beb412763be9$var$removeMediaSingleWithNoContent(reportTransform)
    });
    transformedAdf = (0, $hMBe3.traverse)(transformedAdf || adf, {
        bulletList: $dba4beb412763be9$var$fixIfListParentWithInvalidListItemChildren(reportTransform),
        orderedList: $dba4beb412763be9$var$fixIfListParentWithInvalidListItemChildren(reportTransform),
        table: $dba4beb412763be9$var$fixIfTableParentWithInvalidTableRowChildren(reportTransform)
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};

});
parcelRegister("84BAN", function(module, exports) {
$parcel$export(module.exports, "tableCell", () => $23412ec228cd130c$export$e1e720e5f4603e6a);
const $23412ec228cd130c$export$e1e720e5f4603e6a = (attrs)=>(...content)=>({
            type: 'tableCell',
            attrs: attrs,
            content: content
        });

});

parcelRegister("k7gOm", function(module, exports) {
$parcel$export(module.exports, "tableRow", () => $ba77e7175def670a$export$ce666bf02318c957);
const $ba77e7175def670a$export$ce666bf02318c957 = (content)=>({
        type: 'tableRow',
        content: content
    });

});


parcelRegister("tj3sM", function(module, exports) {
$parcel$export(module.exports, "syncBlockFallbackTransform", () => $2127b1958149ad6c$export$dbdec03917c683f4);

var $hMBe3 = parcelRequire("hMBe3");
const $2127b1958149ad6c$export$dbdec03917c683f4 = (schema, adf)=>{
    let isTransformed = false;
    const { syncBlock: syncBlock, bodiedSyncBlock: bodiedSyncBlock, unsupportedBlock: unsupportedBlock } = schema.nodes;
    if (!unsupportedBlock) return {
        isTransformed: isTransformed,
        transformedAdf: adf
    };
    const transformedAdf = (0, $hMBe3.traverse)(adf, {
        syncBlock: (node)=>{
            if (syncBlock) return node;
            isTransformed = true;
            const unsupportedBlockNode = unsupportedBlock.createChecked({
                originalValue: node
            });
            return unsupportedBlockNode.toJSON();
        },
        bodiedSyncBlock: (node)=>{
            if (bodiedSyncBlock) return node;
            isTransformed = true;
            const unsupportedBlockNode = unsupportedBlock.createChecked({
                originalValue: node
            });
            return unsupportedBlockNode.toJSON();
        },
        unsupportedBlock: (node)=>{
            var _node$attrs;
            if (!((_node$attrs = node.attrs) !== null && _node$attrs !== void 0 && _node$attrs.originalValue)) return node;
            if (node.attrs.originalValue.type === 'syncBlock' && syncBlock) {
                isTransformed = true;
                return node.attrs.originalValue;
            } else if (node.attrs.originalValue.type === 'bodiedSyncBlock' && bodiedSyncBlock) {
                isTransformed = true;
                return node.attrs.originalValue;
            }
            return node;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};

});

parcelRegister("hTzs3", function(module, exports) {
$parcel$export(module.exports, "transformTextLinkCodeMarks", () => $931753bfd323fda2$export$3d531d2daf0e8a14);

var $hMBe3 = parcelRequire("hMBe3");
const $931753bfd323fda2$var$hasLinkAndCodeMarks = (node)=>{
    var _node$marks;
    const marks = (_node$marks = node.marks) === null || _node$marks === void 0 ? void 0 : _node$marks.map((mark)=>mark.type);
    return (marks === null || marks === void 0 ? void 0 : marks.includes('link')) && (marks === null || marks === void 0 ? void 0 : marks.includes('code'));
};
const $931753bfd323fda2$var$removeCodeMarks = (node)=>{
    if (node.marks) return {
        ...node,
        marks: node.marks.filter((mark)=>mark.type !== 'code')
    };
    return node;
};
const $931753bfd323fda2$export$3d531d2daf0e8a14 = (adf)=>{
    let isTransformed = false;
    const transformedAdf = (0, $hMBe3.traverse)(adf, {
        text: (node)=>{
            if ($931753bfd323fda2$var$hasLinkAndCodeMarks(node)) {
                isTransformed = true;
                return $931753bfd323fda2$var$removeCodeMarks(node);
            }
            return;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};

});

parcelRegister("9WLGT", function(module, exports) {
$parcel$export(module.exports, "transformMediaSingleWidth", () => $18c4014b54b14d05$export$abd79dcca4cbaf32);

var $hMBe3 = parcelRequire("hMBe3");
const $18c4014b54b14d05$export$abd79dcca4cbaf32 = (adf)=>{
    let isTransformed = false;
    const transformedAdf = (0, $hMBe3.traverse)(adf, {
        mediaSingle: (node)=>{
            const { width: width, widthType: widthType } = node.attrs || {};
            // if width is not a number or greater than 100, and widthType is not set, we set width to 100
            if (typeof width === 'number' && width > 100 && !widthType) {
                isTransformed = true;
                const newAttrs = {
                    ...node.attrs,
                    width: 100
                };
                return {
                    ...node,
                    attrs: newAttrs
                };
            }
            return node;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};

});

parcelRegister("bnbmo", function(module, exports) {
$parcel$export(module.exports, "isNestedTablesSupported", () => $0fd75d1de5c35ef5$export$103fe177194b9cb8);
const $0fd75d1de5c35ef5$export$103fe177194b9cb8 = (schema)=>{
    var _tableCell$contentMat, _tableHeader$contentM;
    const { table: table, tableCell: tableCell, tableHeader: tableHeader } = schema.nodes;
    if (!table || !tableCell || !tableHeader) return false;
    // Check if table cells can contain table nodes by testing their content match
    const tableCellCanContainTable = ((_tableCell$contentMat = tableCell.contentMatch.matchType(table)) === null || _tableCell$contentMat === void 0 ? void 0 : _tableCell$contentMat.validEnd) === true;
    const tableHeaderCanContainTable = ((_tableHeader$contentM = tableHeader.contentMatch.matchType(table)) === null || _tableHeader$contentM === void 0 ? void 0 : _tableHeader$contentM.validEnd) === true;
    return tableCellCanContainTable || tableHeaderCanContainTable;
};

});

parcelRegister("eAhRP", function(module, exports) {
$parcel$export(module.exports, "isPanelC1SchemaEnabled", () => $ece438cd47151737$export$67a2736d73dace7c);

var $5N1Y4 = parcelRequire("5N1Y4");

var $e28Rw = parcelRequire("e28Rw");
const $ece438cd47151737$export$67a2736d73dace7c = ()=>(0, $5N1Y4.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) || (0, $e28Rw.isPanelNestingContainerExperimentEnabled)();

});
parcelRegister("e28Rw", function(module, exports) {
$parcel$export(module.exports, "isPanelNestingContainerExperimentEnabled", () => $6fac110e51809730$export$17701af918d23092);

var $3y2s4 = parcelRequire("3y2s4");
const $6fac110e51809730$export$17701af918d23092 = ()=>(0, $3y2s4.isExperimentEnabled)('platform_editor_nest_container_in_panel');

});


parcelRegister("cyTOy", function(module, exports) {
$parcel$export(module.exports, "isPanelNestingContainerSupported", () => $b12b55897632f30b$export$adaec6ad4f1f3448);

var $e28Rw = parcelRequire("e28Rw");
// The container children unlocked on panel_c1 by the consolidated
// `platform_editor_nest_container_in_panel` experiment. `table` is intentionally excluded:
// it ships independently under `platform_editor_nest_table_in_panel` and is checked by
// `isPanelNestingTableSupported`.
const $b12b55897632f30b$var$PANEL_C1_CONTAINER_CHILD_TYPES = [
    'expand',
    'panel',
    'blockquote',
    'bodiedExtension'
];
const $b12b55897632f30b$export$adaec6ad4f1f3448 = (schema)=>{
    const { panel_c1: panel_c1 } = schema.nodes;
    if (!panel_c1) return false;
    // Confirm the PM schema actually allows at least one container child inside panel_c1.
    const panelC1CanContainAnyContainer = $b12b55897632f30b$var$PANEL_C1_CONTAINER_CHILD_TYPES.some((type)=>{
        var _panel_c1$contentMatc;
        const childType = schema.nodes[type];
        return !!childType && ((_panel_c1$contentMatc = panel_c1.contentMatch.matchType(childType)) === null || _panel_c1$contentMatc === void 0 ? void 0 : _panel_c1$contentMatc.validEnd) === true;
    });
    return panelC1CanContainAnyContainer && (0, $e28Rw.isPanelNestingContainerExperimentEnabled)();
};

});

parcelRegister("8gKUV", function(module, exports) {
$parcel$export(module.exports, "sanitizeNodeForPrivacy", () => $417eb1872271d8bf$export$8a32f625580e0a06);

var $hMBe3 = parcelRequire("hMBe3");

var $lyKnc = parcelRequire("lyKnc");
function $417eb1872271d8bf$export$8a32f625580e0a06(json, providerFactory) {
    const mentionNames = new Map();
    let hasCacheableMentions = false;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const sanitizedJSON = (0, $hMBe3.traverse)(json, {
        mention: (node)=>{
            if (node.attrs && node.attrs.text) {
                hasCacheableMentions = true;
                // Remove @ prefix
                const text = node.attrs.text;
                const name = text.startsWith('@') ? text.slice(1) : text;
                mentionNames.set(node.attrs.id, name);
            }
            return {
                ...node,
                attrs: {
                    ...node.attrs,
                    text: ''
                }
            };
        }
    });
    if (hasCacheableMentions && providerFactory) {
        const handler = (_name, providerPromise)=>{
            if (providerPromise) providerPromise.then((provider)=>{
                if ((0, $lyKnc.isResolvingMentionProvider)(provider)) {
                    mentionNames.forEach((name, id)=>{
                        provider.cacheMentionName(id, name);
                    });
                    mentionNames.clear();
                    providerFactory.unsubscribe('mentionProvider', handler);
                }
            });
        };
        providerFactory.subscribe('mentionProvider', handler);
    }
    return sanitizedJSON;
}

});



parcelRegister("4nblR", function(module, exports) {
$parcel$export(module.exports, "getEditorValueWithMedia", () => $0b2f4adb18f926f2$export$99c45752ffdaa598);
// Please, do not copy or use this kind of code below
// @ts-ignore
const $0b2f4adb18f926f2$var$mediaPluginKey = {
    key: 'mediaPlugin$',
    getState: (state)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return state['mediaPlugin$'];
    }
};
async function $0b2f4adb18f926f2$export$99c45752ffdaa598(editorView) {
    const mediaPluginState = editorView.state && $0b2f4adb18f926f2$var$mediaPluginKey.getState(editorView.state);
    if (mediaPluginState && mediaPluginState.waitForMediaUpload) await mediaPluginState.waitForPendingTasks();
    return editorView.state.doc;
}

});

parcelRegister("hDPV9", function(module, exports) {
$parcel$export(module.exports, "default", () => $19663de1995aed9e$export$2e2bcd8739ae039);
function $19663de1995aed9e$var$deprecationWarnings(className, props, deprecations) {
    return;
}
var $19663de1995aed9e$export$2e2bcd8739ae039 = $19663de1995aed9e$var$deprecationWarnings;

});

parcelRegister("lV7F7", function(module, exports) {
$parcel$export(module.exports, "findNodePosByFragmentLocalIds", () => $fbd6691c341ed0fd$export$1dc8bea8646ac811);
const $fbd6691c341ed0fd$export$1dc8bea8646ac811 = (state, ids)=>{
    if (ids.length === 0) return [];
    const nodes = [];
    const localIdSet = new Set(ids);
    state.doc.descendants((node, pos)=>{
        var _node$marks;
        const fragmentLocalIdList = (_node$marks = node.marks) === null || _node$marks === void 0 ? void 0 : _node$marks.filter((m)=>m.type.name === 'fragment').map((m)=>{
            var _m$attrs;
            return (_m$attrs = m.attrs) === null || _m$attrs === void 0 ? void 0 : _m$attrs.localId;
        }).filter((id)=>id && localIdSet.has(id));
        if (fragmentLocalIdList.length > 0) nodes.push({
            node: node,
            pos: pos
        });
        // stop traversing once we found all the nodes
        return localIdSet.size !== nodes.length;
    });
    return nodes;
};

});

parcelRegister("8LxSk", function(module, exports) {
$parcel$export(module.exports, "isEmptyDocument", () => $fa00b8927aa2d850$export$2da47a16c0b6bcb);
/**
 * Temporary file which extracts function from `editor-common`.
 *
 * Eventually we will deprecate and delete EditorActions. This is here to
 * help decouple it from editor-common
 */ 
var $lLA0P = parcelRequire("lLA0P");
function $fa00b8927aa2d850$export$2da47a16c0b6bcb(node) {
    const nodeChild = node.content.firstChild;
    if (node.childCount !== 1 || !nodeChild) return false;
    return (0, $lLA0P.isEmptyParagraph)(nodeChild);
}

});
parcelRegister("lLA0P", function(module, exports) {
$parcel$export(module.exports, "isEmptyParagraph", () => $ce2ccd61bc4845ff$export$b648602b09795358);
function $ce2ccd61bc4845ff$export$b648602b09795358(node) {
    return !!node && node.type.name === 'paragraph' && !node.childCount;
}

});


parcelRegister("j8JIA", function(module, exports) {
$parcel$export(module.exports, "findNodePosByLocalIds", () => $878d2fc317875fef$export$947fc26275418e36);
/**
 * Temporary file which extracts function from `editor-common`.
 *
 * Eventually we will deprecate and delete EditorActions. This is here to
 * help decouple it from editor-common
 */ const $878d2fc317875fef$export$947fc26275418e36 = (state, ids, option = {})=>{
    var _state$doc$attrs;
    if (ids.length === 0) return [];
    const nodes = [];
    const localIdSet = new Set(ids);
    if (option.includeDocNode && localIdSet.has((_state$doc$attrs = state.doc.attrs) === null || _state$doc$attrs === void 0 ? void 0 : _state$doc$attrs.localId)) nodes.push({
        node: state.doc,
        pos: 0
    });
    state.doc.descendants((node, pos)=>{
        var _node$attrs;
        if (localIdSet.has((_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId)) nodes.push({
            node: node,
            pos: pos
        });
        // stop traversing once we found all the nodes
        return localIdSet.size !== nodes.length;
    });
    return nodes;
};

});

parcelRegister("kMyLY", function(module, exports) {
$parcel$export(module.exports, "toJSON", () => $7f61be11cf1bcf89$export$54fd2c36b5cc6731);
/**
 * Temporary file which extracts function from `editor-common`.
 *
 * Eventually we will deprecate and delete EditorActions. This is here to
 * help decouple it from editor-common
 */ 
var $c6WhP = parcelRequire("c6WhP");
const $7f61be11cf1bcf89$var$transformer = new (0, $c6WhP.JSONTransformer)();
function $7f61be11cf1bcf89$export$54fd2c36b5cc6731(node) {
    return $7f61be11cf1bcf89$var$transformer.encode(node);
}

});


parcelRegister("iM9ST", function(module, exports) {
$parcel$export(module.exports, "useEditorContext", () => $b3c81915628c0c6a$export$b119c82498f162a5);
$parcel$export(module.exports, "default", () => $b3c81915628c0c6a$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $hclJ1 = parcelRequire("hclJ1");

var $5kVgQ = parcelRequire("5kVgQ");
const $b3c81915628c0c6a$export$b119c82498f162a5 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useContext((0, $hclJ1.EditorContext));
class $b3c81915628c0c6a$export$797df872f5526664 extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Component {
    constructor(props){
        super(props);
        this.editorActions = props.editorActions || new (0, $5kVgQ.default)();
        this.contextValue = {
            editorActions: this.editorActions
        };
    }
    render() {
        return /*#__PURE__*/ (0, $dc70d.jsx)((0, $hclJ1.EditorContext).Provider, {
            value: this.contextValue,
            children: this.props.children
        });
    }
}
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$b3c81915628c0c6a$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, $dc70d.jsx)($b3c81915628c0c6a$export$797df872f5526664, {
        editorActions: props.editorActions,
        children: props.children
    });

});
parcelRegister("hclJ1", function(module, exports) {
$parcel$export(module.exports, "EditorContext", () => $91de7b9d70cf87b9$export$27b8dd149e32f6c7);

var $bSJIT = parcelRequire("bSJIT");
const $91de7b9d70cf87b9$export$27b8dd149e32f6c7 = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createContext({});

});


parcelRegister("8dHy3", function(module, exports) {
$parcel$export(module.exports, "createFeatureFlagsFromProps", () => $fbebdc5be501bb41$export$63102b0cbe181144);

var $2qHl7 = parcelRequire("2qHl7");
function $fbebdc5be501bb41$var$verifyJSON(json) {
    try {
        return JSON.parse(json);
    } catch (e) {
        return undefined;
    }
}
function $fbebdc5be501bb41$var$getSpellCheck(featureFlags) {
    if (!!(featureFlags !== null && featureFlags !== void 0 && featureFlags['disableSpellcheckByBrowser'])) return typeof (featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags['disableSpellcheckByBrowser']) === 'object' ? featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags['disableSpellcheckByBrowser'] : typeof (featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags['disableSpellcheckByBrowser']) === 'string' ? $fbebdc5be501bb41$var$verifyJSON(featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags['disableSpellcheckByBrowser']) : undefined;
    if (!!(featureFlags !== null && featureFlags !== void 0 && featureFlags['disable-spellcheck-by-browser'])) return typeof (featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags['disable-spellcheck-by-browser']) === 'object' ? featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags['disable-spellcheck-by-browser'] : typeof (featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags['disable-spellcheck-by-browser']) === 'string' ? $fbebdc5be501bb41$var$verifyJSON(featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags['disable-spellcheck-by-browser']) : undefined;
    return undefined;
}
function $fbebdc5be501bb41$export$63102b0cbe181144(featureFlags) {
    const normalizedFeatureFlags = (0, $2qHl7.normalizeFeatureFlags)(featureFlags);
    return {
        ...normalizedFeatureFlags,
        catchAllTracking: false,
        showAvatarGroupAsPlugin: Boolean(typeof (featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.showAvatarGroupAsPlugin) === 'boolean' ? !!(featureFlags !== null && featureFlags !== void 0 && featureFlags.showAvatarGroupAsPlugin) : false),
        errorBoundaryDocStructure: Boolean(typeof (featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.useErrorBoundaryDocStructure) === 'boolean' ? !!(featureFlags !== null && featureFlags !== void 0 && featureFlags.useErrorBoundaryDocStructure) : false),
        synchronyErrorDocStructure: Boolean(typeof (featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.synchronyErrorDocStructure) === 'boolean' ? !!(featureFlags !== null && featureFlags !== void 0 && featureFlags.synchronyErrorDocStructure) : false),
        enableViewUpdateSubscription: Boolean(typeof (featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.enableViewUpdateSubscription) === 'boolean' ? !!(featureFlags !== null && featureFlags !== void 0 && featureFlags.enableViewUpdateSubscription) : false),
        collabAvatarScroll: Boolean(typeof (featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.collabAvatarScroll) === 'boolean' ? !!(featureFlags !== null && featureFlags !== void 0 && featureFlags.collabAvatarScroll) : false),
        twoLineEditorToolbar: Boolean(typeof (featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.twoLineEditorToolbar) === 'boolean' ? !!(featureFlags !== null && featureFlags !== void 0 && featureFlags.twoLineEditorToolbar) : false),
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        disableSpellcheckByBrowser: $fbebdc5be501bb41$var$getSpellCheck(featureFlags)
    };
}

});

parcelRegister("l9YiQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $65c3fc488d7d1783$export$2e2bcd8739ae039);
var $65c3fc488d7d1783$export$2e2bcd8739ae039 = {
    EDITOR_MOUNTED: 'Editor Component Mount Time',
    PROSEMIRROR_RENDERED: 'ProseMirror Render Time',
    PROSEMIRROR_CONTENT_RENDERED: 'ProseMirror Content Render Time',
    ON_EDITOR_READY_CALLBACK: 'onEditorReady Callback Duration'
};

});

parcelRegister("5CCIk", function(module, exports) {
$parcel$export(module.exports, "name", () => $8823c2e317ff33f5$export$a8ff84c12d48cfa6);
$parcel$export(module.exports, "version", () => $8823c2e317ff33f5$export$83d89fbfd8236492);
const $8823c2e317ff33f5$export$a8ff84c12d48cfa6 = undefined;
const $8823c2e317ff33f5$export$83d89fbfd8236492 = undefined;

});

parcelRegister("6QZ0Y", function(module, exports) {
$parcel$export(module.exports, "EditorInternal", () => $c37228be7729d87f$export$2617c0dabe49c335);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $g6Qq4 = parcelRequire("g6Qq4");

var $dxcnP = parcelRequire("dxcnP");

var $5bbjm = parcelRequire("5bbjm");

var $3y2s4 = parcelRequire("3y2s4");

var $aa2MR = parcelRequire("aa2MR");

var $23Rvv = parcelRequire("23Rvv");

var $iM9ST = parcelRequire("iM9ST");

var $d8zoL = parcelRequire("d8zoL");

var $8dHy3 = parcelRequire("8dHy3");

var $dh4YA = parcelRequire("dh4YA");

var $bqVsL = parcelRequire("bqVsL");

var $dj7La = parcelRequire("dj7La");
const $c37228be7729d87f$var$DEFAULT_VALUE_PROP_TO_IGNORE = [
    'defaultValue'
];
const $c37228be7729d87f$export$2617c0dabe49c335 = /*#__PURE__*/ (0, $bSJIT.memo)(({ props: props, handleAnalyticsEvent: handleAnalyticsEvent, createAnalyticsEvent: createAnalyticsEvent, handleSave: handleSave, editorActions: editorActions, providerFactory: providerFactory, onEditorCreated: onEditorCreated, onEditorDestroyed: onEditorDestroyed, preset: preset, AppearanceComponent: AppearanceComponent })=>{
    const overriddenEditorProps = {
        ...props,
        onSave: props.onSave ? handleSave : undefined,
        // noop all analytic events, even if a handler is still passed.
        analyticsHandler: undefined
    };
    const featureFlags = (0, $8dHy3.createFeatureFlagsFromProps)(props.featureFlags);
    const renderTrackingEnabled = (0, $3y2s4.isExperimentEnabled)('platform_editor_enable_rerender_tracking') && !featureFlags.lcmPreventRenderTracking;
    const [portalProviderAPI, PortalRenderer] = (0, $dxcnP.usePortalProvider)();
    const [nodeViewPortalProviderAPI, NodeViewPortalRenderer] = (0, $dxcnP.usePortalProvider)();
    const propsToIgnore = (0, $3y2s4.isExperimentEnabled)('platform_editor_perf_lint_cleanup') ? $c37228be7729d87f$var$DEFAULT_VALUE_PROP_TO_IGNORE : [
        'defaultValue'
    ];
    const baseFontSize = (0, $dj7La.getBaseFontSize)(props.appearance, props.contentMode);
    const fontSize = (0, $5bbjm.editorFontSize)({
        theme: {
            baseFontSize: baseFontSize
        }
    });
    return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $bSJIT.Fragment), {
        children: [
            renderTrackingEnabled && /*#__PURE__*/ (0, $dc70d.jsx)((0, $dh4YA.RenderTracking), {
                componentProps: props,
                action: (0, $g6Qq4.ACTION).RE_RENDERED,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).EDITOR,
                handleAnalyticsEvent: handleAnalyticsEvent,
                propsToIgnore: propsToIgnore,
                useShallow: false
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $aa2MR.default), {
                errorTracking: true,
                createAnalyticsEvent: createAnalyticsEvent,
                contextIdentifierProvider: props.contextIdentifierProvider,
                featureFlags: featureFlags,
                children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $bqVsL.EditorInternalContainerCompiled), {
                    fontSize: fontSize,
                    children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $iM9ST.default), {
                        editorActions: editorActions,
                        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $d8zoL.IntlProviderIfMissingWrapper), {
                            children: /*#__PURE__*/ (0, $dc70d.jsxs)((0, $bSJIT.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $dc70d.jsx)((0, $23Rvv.default), {
                                        editorProps: overriddenEditorProps,
                                        createAnalyticsEvent: createAnalyticsEvent,
                                        portalProviderAPI: portalProviderAPI,
                                        nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
                                        providerFactory: providerFactory,
                                        onEditorCreated: onEditorCreated,
                                        onEditorDestroyed: onEditorDestroyed,
                                        disabled: props.disabled,
                                        preset: preset,
                                        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017: this callback closes over the full props object and derived featureFlags; memoization is ineffective because ReactEditorViewNext is not memo()'d and deps (props, featureFlags) change every render
                                        render: ({ editor: editor, view: view, eventDispatcher: eventDispatcher, config: config, dispatchAnalyticsEvent: dispatchAnalyticsEvent, editorRef: editorRef, editorAPI: editorAPI })=>{
                                            var _props$featureFlags, _props$featureFlags2;
                                            return /*#__PURE__*/ (0, $dc70d.jsx)(AppearanceComponent, {
                                                innerRef: editorRef,
                                                editorAPI: editorAPI,
                                                // Ignored via go/ees005
                                                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                                appearance: props.appearance,
                                                disabled: props.disabled,
                                                editorActions: editorActions,
                                                editorDOMElement: editor,
                                                editorView: view,
                                                providerFactory: providerFactory,
                                                eventDispatcher: eventDispatcher,
                                                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                                                maxHeight: props.maxHeight,
                                                minHeight: props.minHeight,
                                                onSave: props.onSave ? handleSave : undefined,
                                                onCancel: props.onCancel,
                                                onSSRMeasure: props.onSSRMeasure,
                                                popupsMountPoint: props.popupsMountPoint,
                                                popupsBoundariesElement: props.popupsBoundariesElement,
                                                popupsScrollableElement: props.popupsScrollableElement,
                                                contentComponents: config.contentComponents,
                                                contentMode: props.contentMode,
                                                primaryToolbarComponents: config.primaryToolbarComponents,
                                                primaryToolbarIconBefore: props.primaryToolbarIconBefore,
                                                secondaryToolbarComponents: config.secondaryToolbarComponents,
                                                customContentComponents: props.contentComponents,
                                                customPrimaryToolbarComponents: props.primaryToolbarComponents,
                                                customSecondaryToolbarComponents: props.secondaryToolbarComponents,
                                                contextPanel: props.contextPanel,
                                                collabEdit: props.collabEdit,
                                                persistScrollGutter: props.persistScrollGutter,
                                                enableToolbarMinWidth: ((_props$featureFlags = props.featureFlags) === null || _props$featureFlags === void 0 ? void 0 : _props$featureFlags.toolbarMinWidthOverflow) != null ? !!((_props$featureFlags2 = props.featureFlags) !== null && _props$featureFlags2 !== void 0 && _props$featureFlags2.toolbarMinWidthOverflow) : props.allowUndoRedoButtons,
                                                isEditorModernisationEnabled: props.isEditorModernisationEnabled,
                                                useStickyToolbar: props.useStickyToolbar,
                                                featureFlags: featureFlags,
                                                pluginHooks: config.pluginHooks,
                                                __livePage: props.__livePage,
                                                preset: preset,
                                                UNSAFE_containLayout: props.UNSAFE_containLayout
                                            });
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $dc70d.jsx)(PortalRenderer, {}),
                                    /*#__PURE__*/ (0, $dc70d.jsx)(NodeViewPortalRenderer, {})
                                ]
                            })
                        })
                    })
                })
            })
        ]
    });
});

});
parcelRegister("dxcnP", function(module, exports) {
$parcel$export(module.exports, "usePortalProvider", () => $646c7a4963375443$export$9b00782c24eb3d6b);

var $bSJIT = parcelRequire("bSJIT");

var $lBGcS = parcelRequire("lBGcS");

var $1cDaf = parcelRequire("1cDaf");

var $7Ktll = parcelRequire("7Ktll");
function $646c7a4963375443$export$9b00782c24eb3d6b() {
    const portalManager = (0, $bSJIT.useMemo)(()=>new (0, $7Ktll.PortalManager)(), []);
    const PortalRenderer = (0, $bSJIT.useMemo)(()=>(0, $1cDaf.createPortalRendererComponent)(portalManager), [
        portalManager
    ]);
    const portalProviderAPI = (0, $bSJIT.useMemo)(()=>(0, $lBGcS.getPortalProviderAPI)(portalManager), [
        portalManager
    ]);
    // Cleanup on unmount
    (0, $bSJIT.useEffect)(()=>{
        return ()=>{
            portalProviderAPI.destroy();
        };
    }, [
        portalManager,
        portalProviderAPI
    ]);
    return [
        portalProviderAPI,
        PortalRenderer
    ];
}

});
parcelRegister("lBGcS", function(module, exports) {
$parcel$export(module.exports, "getPortalProviderAPI", () => $09c011c9bceb6618$export$3a6b5f5c5bba4bde);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $4Sf72 = parcelRequire("4Sf72");

var $7lseo = parcelRequire("7lseo");

var $9PXs3 = parcelRequire("9PXs3");

const $09c011c9bceb6618$var$PortalRenderWrapper = /*#__PURE__*/ (0, $bSJIT.memo)((0, $9PXs3.PortalRenderWrapperInner));
$09c011c9bceb6618$var$PortalRenderWrapper.displayName = 'PortalRenderWrapper';
// Tree-shakable renderToStaticMarkup that should work only in SSR
function $09c011c9bceb6618$var$getRenderToStaticMarkup() {
    return ()=>'';
}
const $09c011c9bceb6618$export$3a6b5f5c5bba4bde = (portalManager)=>{
    const portalsMap = new Map();
    return {
        render: (children, container, key, onBeforeReactDomRender, immediate = false)=>{
            if ((0, $7lseo.isSSR)()) {
                let html = '';
                try {
                    const renderToStaticMarkup = $09c011c9bceb6618$var$getRenderToStaticMarkup();
                    const Children = children;
                    html = renderToStaticMarkup(/*#__PURE__*/ (0, $dc70d.jsx)(Children, {}));
                } catch (error) {
                    var _Array$from$find;
                }
                container.innerHTML = html;
            } else if (typeof onBeforeReactDomRender === 'function') {
                const portal = /*#__PURE__*/ (0, $4Sf72.createPortal)(/*#__PURE__*/ (0, $dc70d.jsx)($09c011c9bceb6618$var$PortalRenderWrapper, {
                    getChildren: children,
                    onBeforeRender: onBeforeReactDomRender
                }), container, key);
                portalsMap.set(key, portalManager.registerPortal(key, portal, immediate));
            } else {
                const portal = /*#__PURE__*/ (0, $4Sf72.createPortal)(children(), container, key);
                portalsMap.set(key, portalManager.registerPortal(key, portal, immediate));
            }
        },
        remove: (key)=>{
            var _portalsMap$get;
            if ((0, $7lseo.isSSR)()) return;
            (_portalsMap$get = portalsMap.get(key)) === null || _portalsMap$get === void 0 || _portalsMap$get();
            portalsMap.delete(key);
        },
        destroy: ()=>{
            portalsMap.clear();
            portalManager.destroy();
        }
    };
};

});
parcelRegister("9PXs3", function(module, exports) {
$parcel$export(module.exports, "PortalRenderWrapperInner", () => $cb5d1b848bfea03d$export$eab0ea19ad3bed77);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");
const $cb5d1b848bfea03d$export$eab0ea19ad3bed77 = ({ getChildren: getChildren, onBeforeRender: onBeforeRender })=>{
    (0, $bSJIT.useLayoutEffect)(()=>{
        if (onBeforeRender) onBeforeRender();
    }, [
        onBeforeRender
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dc70d.Fragment), {
        children: getChildren()
    });
};

});


parcelRegister("1cDaf", function(module, exports) {
$parcel$export(module.exports, "createPortalRendererComponent", () => $fec938f6bc366c17$export$adfaaa25a1ea6e69);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $dnBwT = parcelRequire("dnBwT");
function $fec938f6bc366c17$export$adfaaa25a1ea6e69(portalManager) {
    return function PortalRenderer() {
        const [buckets, setBuckets] = (0, $bSJIT.useState)(portalManager.getBuckets());
        (0, $bSJIT.useLayoutEffect)(()=>{
            portalManager.registerPortalRenderer(setBuckets);
            return ()=>{
                portalManager.unregisterPortalRenderer();
            };
        }, []);
        const portalsElements = (0, $bSJIT.useMemo)(// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        ()=>buckets.map((_, i)=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $dnBwT.PortalBucket), {
                    id: i,
                    portalManager: portalManager
                }, i)), [
            buckets
        ]);
        return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dc70d.Fragment), {
            children: portalsElements
        });
    };
}

});
parcelRegister("dnBwT", function(module, exports) {
$parcel$export(module.exports, "PortalBucket", () => $b51794a24fb3799e$export$828f0f29e8293a07);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $3y2s4 = parcelRequire("3y2s4");
function $b51794a24fb3799e$var$LegacyPortalBucket({ id: id, portalManager: portalManager }) {
    // State to hold the current portals for this bucket
    const [portals, setPortals] = (0, $bSJIT.useState)({});
    // Effect to register/unregister this bucket with the portal manager on mount/unmount
    (0, $bSJIT.useLayoutEffect)(()=>{
        portalManager.registerBucket(id, setPortals);
        return ()=>{
            portalManager.unregisterBucket(id);
        };
    }, [
        id,
        portalManager
    ]);
    // Memoize the portal elements to avoid unnecessary re-renders
    const portalElements = (0, $bSJIT.useMemo)(()=>Object.values(portals), [
        portals
    ]);
    // Render the current portal elements
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dc70d.Fragment), {
        children: portalElements
    });
}
/**
 * Portals stay in the manager; state is only a render tick. React keeps
 * hook state on both the current and alternate fiber, so storing portals
 * in state would retain removed portals until the next render.
 */ function $b51794a24fb3799e$var$TickPortalBucket({ id: id, portalManager: portalManager }) {
    var _portalManager$getBuc;
    const [, forceRender] = (0, $bSJIT.useReducer)((tick)=>tick + 1, 0);
    const updater = (0, $bSJIT.useCallback)(()=>forceRender(), []);
    (0, $bSJIT.useLayoutEffect)(()=>{
        portalManager.registerBucket(id, updater);
        return ()=>{
            portalManager.unregisterBucket(id);
        };
    }, [
        id,
        portalManager,
        updater
    ]);
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dc70d.Fragment), {
        children: Object.values(((_portalManager$getBuc = portalManager.getBuckets()[id]) === null || _portalManager$getBuc === void 0 ? void 0 : _portalManager$getBuc.portals) ?? {})
    });
}
function $b51794a24fb3799e$export$828f0f29e8293a07({ id: id, portalManager: portalManager }) {
    return (0, $3y2s4.isExperimentEnabled)('platform_editor_reduce_memory_leaks') ? /*#__PURE__*/ (0, $dc70d.jsx)($b51794a24fb3799e$var$TickPortalBucket, {
        id: id,
        portalManager: portalManager
    }) : /*#__PURE__*/ (0, $dc70d.jsx)($b51794a24fb3799e$var$LegacyPortalBucket, {
        id: id,
        portalManager: portalManager
    });
}

});


parcelRegister("7Ktll", function(module, exports) {
$parcel$export(module.exports, "PortalManager", () => $28ae7423eb3ff78c$export$52c7ef79917c2f38);

var $cNIkg = parcelRequire("cNIkg");

var $3y2s4 = parcelRequire("3y2s4");

var $5N1Y4 = parcelRequire("5N1Y4");
const $28ae7423eb3ff78c$var$DEFAULT_INITIAL_BUCKETS = 50;
const $28ae7423eb3ff78c$var$DEFAULT_MAX_BUCKET_CAPACITY = 50;
const $28ae7423eb3ff78c$var$DEFAULT_SCALE_RATIO = 0.5;
const $28ae7423eb3ff78c$var$DEFAULT_THROTTLE_DELAY = 16; // ~60fps for smooth updates
/**
 * Creates an empty bucket object with a specified capacity. Each bucket is designed
 * to hold a certain number of React portals and has an associated updater function
 * which can be null initially.
 *
 * @function createEmptyBucket
 * @param {number} capacity - The maximum capacity of the bucket.
 * @returns {PortalBucketType} An object representing an empty bucket with the specified capacity.
 */ function $28ae7423eb3ff78c$var$createEmptyBucket(capacity) {
    return {
        portals: {},
        capacity: capacity,
        updater: null
    };
}
class $28ae7423eb3ff78c$export$52c7ef79917c2f38 {
    constructor(initialBuckets = $28ae7423eb3ff78c$var$DEFAULT_INITIAL_BUCKETS, maxBucketCapacity = $28ae7423eb3ff78c$var$DEFAULT_MAX_BUCKET_CAPACITY, scaleRatio = $28ae7423eb3ff78c$var$DEFAULT_SCALE_RATIO, throttleDelay = $28ae7423eb3ff78c$var$DEFAULT_THROTTLE_DELAY){
        /**
   * Controls whether to use throttled updates or immediate synchronous updates.
   * During initial load, we use synchronous updates to avoid delays and ensure immediate responsiveness.
   * After the initial load period (one RAF cycle), we switch to throttled updates for better performance.
   */ this.shouldUseThrottledUpdates = false;
        this.maxBucketCapacity = maxBucketCapacity;
        this.scaleRatio = scaleRatio;
        this.throttleDelay = throttleDelay;
        // Initialise buckets array by creating an array of length `initialBuckets` containing empty buckets
        this.buckets = Array.from({
            length: initialBuckets
        }, ()=>$28ae7423eb3ff78c$var$createEmptyBucket(maxBucketCapacity));
        this.portalToBucketMap = new Map();
        this.availableBuckets = new Set(Array.from({
            length: initialBuckets
        }, (_, i)=>i));
        this.portalRendererUpdater = null;
        this.scaleCapacityThreshold = maxBucketCapacity / 2;
        this.throttledBucketUpdaters = new Map();
    }
    getCurrentBucket() {
        return this.availableBuckets.values().next().value;
    }
    createBucket() {
        var _this$portalRendererU;
        const currentBucket = this.getCurrentBucket();
        //If the current bucket has capacity, skip this logic
        // @ts-ignore - TS2538 TypeScript 5.9.2 upgrade
        if (this.buckets[currentBucket].capacity > 0) return;
        else // The current bucket is full, delete the bucket from the list of available buckets
        // @ts-ignore - TS2345 TypeScript 5.9.2 upgrade
        this.availableBuckets.delete(currentBucket);
        // Skip creating new bucket if there are buckets still available
        if (this.availableBuckets.size > 0) return;
        // Scale the buckets up only if there are no available buckets left
        // Calculate how many new buckets need to be added
        const numBucketsToAdd = Math.floor(this.buckets.length * this.scaleRatio);
        this.buckets = [
            ...this.buckets
        ];
        for(let i = 0; i < numBucketsToAdd; i++){
            this.buckets.push($28ae7423eb3ff78c$var$createEmptyBucket(this.maxBucketCapacity));
            this.availableBuckets.add(this.buckets.length - 1);
        }
        (_this$portalRendererU = this.portalRendererUpdater) === null || _this$portalRendererU === void 0 || _this$portalRendererU.call(this, this.buckets);
    }
    getOrCreateThrottledUpdater(id) {
        if (!this.throttledBucketUpdaters.has(id)) {
            const throttledUpdater = (0, (/*@__PURE__*/$parcel$interopDefault($cNIkg)))(()=>{
                var _this$buckets$id, _this$buckets$id$upda;
                (_this$buckets$id = this.buckets[id]) === null || _this$buckets$id === void 0 || (_this$buckets$id$upda = _this$buckets$id.updater) === null || _this$buckets$id$upda === void 0 || _this$buckets$id$upda.call(_this$buckets$id, ()=>({
                        ...this.buckets[id].portals
                    }));
            }, this.throttleDelay);
            this.throttledBucketUpdaters.set(id, throttledUpdater);
        }
        return this.throttledBucketUpdaters.get(id);
    }
    getBuckets() {
        return this.buckets;
    }
    registerBucket(id, updater) {
        var _this$buckets$id$upda2, _this$buckets$id2;
        this.buckets[id].updater = updater;
        (_this$buckets$id$upda2 = (_this$buckets$id2 = this.buckets[id]).updater) === null || _this$buckets$id$upda2 === void 0 || _this$buckets$id$upda2.call(_this$buckets$id2, ()=>({
                ...this.buckets[id].portals
            }));
    }
    unregisterBucket(id) {
        this.buckets[id].updater = null;
        // Clean up throttled updater when bucket is unregistered
        if (this.throttledBucketUpdaters.has(id)) {
            var _this$throttledBucket;
            (_this$throttledBucket = this.throttledBucketUpdaters.get(id)) === null || _this$throttledBucket === void 0 || _this$throttledBucket.cancel();
            this.throttledBucketUpdaters.delete(id);
        }
    }
    updateBuckets(id, immediate = false) {
        if (!this.throttleActivationRAFId && (0, $5N1Y4.expValEquals)('platform_editor_debounce_portal_provider', 'isEnabled', true)) this.throttleActivationRAFId = requestAnimationFrame(()=>{
            this.shouldUseThrottledUpdates = true;
        });
        if (immediate || !this.shouldUseThrottledUpdates || !(0, $5N1Y4.expValEquals)('platform_editor_debounce_portal_provider', 'isEnabled', true)) {
            var _this$buckets$id$upda3, _this$buckets$id3;
            // Cancel any pending throttled update and update immediately
            if (this.throttledBucketUpdaters.has(id)) {
                var _this$throttledBucket2;
                (_this$throttledBucket2 = this.throttledBucketUpdaters.get(id)) === null || _this$throttledBucket2 === void 0 || _this$throttledBucket2.cancel();
            }
            (_this$buckets$id$upda3 = (_this$buckets$id3 = this.buckets[id]).updater) === null || _this$buckets$id$upda3 === void 0 || _this$buckets$id$upda3.call(_this$buckets$id3, ()=>({
                    ...this.buckets[id].portals
                }));
        } else {
            var _this$getOrCreateThro;
            // Use throttled update for smooth, regular updates
            (_this$getOrCreateThro = this.getOrCreateThrottledUpdater(id)) === null || _this$getOrCreateThro === void 0 || _this$getOrCreateThro();
        }
    }
    registerPortal(key, portal, immediate = false) {
        if (!(0, $3y2s4.isExperimentEnabled)('platform_editor_reduce_memory_leaks') || !this.portalToBucketMap.has(key)) {
            this.createBucket();
            // @ts-ignore - TS2538 TypeScript 5.9.2 upgrade
            this.buckets[this.getCurrentBucket()].capacity -= 1;
        }
        const id = this.portalToBucketMap.get(key) ?? this.getCurrentBucket();
        // @ts-ignore - TS2345 TypeScript 5.9.2 upgrade
        this.portalToBucketMap.set(key, id);
        // @ts-ignore - TS2538 TypeScript 5.9.2 upgrade
        if (this.buckets[id].portals[key] !== portal) {
            // @ts-ignore - TS2538 TypeScript 5.9.2 upgrade
            this.buckets[id].portals[key] = portal;
            // @ts-ignore - TS2345 TypeScript 5.9.2 upgrade
            this.updateBuckets(id, immediate);
        }
        //returns a function to unregister the portal
        return ()=>{
            // @ts-ignore - TS2538 TypeScript 5.9.2 upgrade
            delete this.buckets[id].portals[key];
            this.portalToBucketMap.delete(key);
            // @ts-ignore - TS2538 TypeScript 5.9.2 upgrade
            this.buckets[id].capacity += 1;
            // @ts-ignore - TS2538 TypeScript 5.9.2 upgrade
            if (this.buckets[id].capacity > this.scaleCapacityThreshold) // @ts-ignore - TS2345 TypeScript 5.9.2 upgrade
            this.availableBuckets.add(id);
            // @ts-ignore - TS2345 TypeScript 5.9.2 upgrade
            this.updateBuckets(id, immediate);
        };
    }
    registerPortalRenderer(updater) {
        if (!this.portalRendererUpdater) updater(()=>this.buckets);
        this.portalRendererUpdater = updater;
    }
    unregisterPortalRenderer() {
        this.portalRendererUpdater = null;
    }
    /**
   * Cleans up resources used by the PortalManager. This includes clearing all portals,
   * unregistering all buckets, and resetting internal state.
   */ destroy() {
        // Cancel all pending throttled updates
        this.throttledBucketUpdaters.forEach((updater)=>{
            updater.cancel();
        });
        this.throttledBucketUpdaters.clear();
        // Iterate through each bucket and clear its portals and unset the updater function
        this.buckets.forEach((bucket, id)=>{
            bucket.portals = {}; // Clearing all portals from the bucket
            bucket.updater = null; // Unsetting the bucket's updater function
            this.availableBuckets.add(id); // Mark all buckets as available
        });
        this.portalToBucketMap.clear();
        this.portalRendererUpdater = null;
        this.availableBuckets = new Set(this.buckets.map((_, index)=>index));
    }
}

});


parcelRegister("aa2MR", function(module, exports) {
$parcel$export(module.exports, "default", () => $9ab439b4cfe767a2$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $7RHfd = parcelRequire("7RHfd");

var $euFUz = parcelRequire("euFUz");

var $cP1y8 = parcelRequire("cP1y8");

var $g6Qq4 = parcelRequire("g6Qq4");

var $ilGNx = parcelRequire("ilGNx");

var $6Vcje = parcelRequire("6Vcje");

var $j2Y9J = parcelRequire("j2Y9J");

var $a30nE = parcelRequire("a30nE");

var $03Qn3 = parcelRequire("03Qn3");
class $9ab439b4cfe767a2$export$d6d3bedcc5fc09c8 extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Component {
    static #_ = this.defaultProps = {
        rethrow: true,
        errorTracking: true
    };
    constructor(props){
        super(props), this.browserExtensions = undefined, this.state = {
            error: undefined
        }, this.sendErrorData = async (analyticsErrorPayload)=>{
            var _window;
            const product = await this.getProductName();
            const { error: error, errorInfo: errorInfo } = analyticsErrorPayload;
            // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
            const sharedId = (0, $7RHfd.default)();
            const browserInfo = ((_window = window) === null || _window === void 0 || (_window = _window.navigator) === null || _window === void 0 ? void 0 : _window.userAgent) || 'unknown';
            const attributes = {
                product: product,
                browserInfo: browserInfo,
                error: error.toString(),
                errorInfo: errorInfo,
                errorId: sharedId,
                browserExtensions: this.browserExtensions,
                docStructure: this.featureFlags.errorBoundaryDocStructure && this.props.editorView ? (0, $ilGNx.getDocStructure)(this.props.editorView.state.doc, {
                    compact: true
                }) : undefined,
                outdatedBrowser: (0, $a30nE.isOutdatedBrowser)(browserInfo)
            };
            this.fireAnalyticsEvent({
                action: (0, $g6Qq4.ACTION).EDITOR_CRASHED,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).EDITOR,
                eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL,
                attributes: attributes
            });
            this.fireAnalyticsEvent({
                action: (0, $g6Qq4.ACTION).EDITOR_CRASHED_ADDITIONAL_INFORMATION,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).EDITOR,
                eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    errorId: sharedId
                }
            });
            this.logException(error, {
                location: 'editor-core/create-editor',
                product: product
            });
        }, this.getProductName = async ()=>{
            const { contextIdentifierProvider: contextIdentifierProvider } = this.props;
            if (contextIdentifierProvider) {
                const context = await contextIdentifierProvider;
                if (context.product) return context.product;
            }
            return 'atlaskit';
        }, this.fireAnalyticsEvent = (event)=>{
            var _this$props$createAna, _this$props;
            (_this$props$createAna = (_this$props = this.props).createAnalyticsEvent) === null || _this$props$createAna === void 0 || _this$props$createAna.call(_this$props, event).fire((0, $cP1y8.editorAnalyticsChannel));
        }, this.logException = (error, tags)=>{
            (0, $j2Y9J.logException)(error, tags);
        };
        this.featureFlags = props.featureFlags;
    }
    componentDidCatch(error, errorInfo) {
        // Only report and re-render once, to avoid over-reporting errors and infinite rerendering
        if (this.state.error) return;
        if (this.props.errorTracking) this.sendErrorData({
            error: error,
            errorInfo: errorInfo,
            errorStack: error.stack
        });
        // Update state to allow a re-render to attempt graceful recovery (in the event that
        // the error was caused by a race condition or is intermittent)
        this.setState({
            error: error
        }, ()=>{
            if (this.props.rethrow) // Now that a re-render has occurred, we re-throw to allow product error boundaries
            // to catch and handle the error too.
            //
            // Note that when rethrowing inside a error boundary, the stack trace
            // from a higher error boundary's componentDidCatch.info param will reset
            // to this component, instead of the original component which threw it.
            throw error;
        });
    }
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // FIXME: This is causing more problems then it's solving. The async check to sniff the browser extensions is block some
    // react unit tests. Essentially jest never completes and just hangs. This was code was added 3yrs ago so that errors
    // would detail if the browser had grammarly extension installed or not. I'm not sure if anyone has every inspecting this
    // as it doesn't look like any dashboards exist for it.
    // You can see the open handles that are block tests if you run unit tests with --detectOpenHandles
    // async componentDidMount() {
    // 	this.browserExtensions = await sniffUserBrowserExtensions({
    // 		extensions: ['grammarly'],
    // 		async: true,
    // 		asyncTimeoutMs: 20000,
    // 	});
    // }
    render() {
        return /*#__PURE__*/ (0, $dc70d.jsx)((0, $6Vcje.IntlErrorBoundary), {
            children: this.props.children
        });
    }
}
class $9ab439b4cfe767a2$export$e34b68cf8622e9fd extends $9ab439b4cfe767a2$export$d6d3bedcc5fc09c8 {
    static #_ = this.contextType = (0, $euFUz.default);
    constructor(props){
        super(props), this.logException = (error, tags)=>{
            var _this$context;
            const extraTags = {};
            extraTags.editorSessionId = (_this$context = this.context) === null || _this$context === void 0 || (_this$context = _this$context.getAtlaskitAnalyticsContext()) === null || _this$context === void 0 || (_this$context = _this$context[0]) === null || _this$context === void 0 || (_this$context = _this$context.fabricEditorCtx) === null || _this$context === void 0 ? void 0 : _this$context.editorSessionId;
            (0, $j2Y9J.logException)(error, {
                ...tags,
                ...extraTags
            });
        };
    }
}
// eslint-disable-next-line @typescript-eslint/no-restricted-types
const $9ab439b4cfe767a2$var$_default_1 = (0, $03Qn3.WithEditorView)($9ab439b4cfe767a2$export$e34b68cf8622e9fd);
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$9ab439b4cfe767a2$export$2e2bcd8739ae039 = $9ab439b4cfe767a2$var$_default_1;

});
parcelRegister("ilGNx", function(module, exports) {
$parcel$export(module.exports, "getDocStructure", () => $70c5483a2e8fe25a$export$6451b72139862cbd);
const $70c5483a2e8fe25a$var$hash = {
    nodes: {
        doc: 'doc',
        paragraph: 'p',
        text: 't',
        bulletList: 'ul',
        orderedList: 'ol',
        listItem: 'li',
        heading: 'h',
        blockquote: 'blockq',
        codeBlock: 'codebl',
        panel: 'pnl',
        rule: 'rl',
        hardBreak: 'br',
        mention: 'ment',
        emoji: 'emj',
        image: 'img',
        caption: 'cap',
        media: 'media',
        mediaGroup: 'mediag',
        mediaSingle: 'medias',
        plain: 'pln',
        table: 'table',
        tableCell: 'td',
        tableHeader: 'th',
        tableRow: 'tr',
        decisionList: 'dl',
        decisionItem: 'di',
        taskList: 'tl',
        taskItem: 'ti',
        extension: 'ext',
        inlineExtension: 'exti',
        bodiedExtension: 'extb',
        multiBodiedExtension: 'extmbe',
        extensionFrame: 'extfrm',
        status: 'sts',
        placeholder: 'plh',
        inlineCard: 'cardi',
        blockCard: 'cardb',
        embedCard: 'carde',
        expand: 'exp',
        nestedExpand: 'expn',
        unsupportedBlock: 'unsupb',
        unsupportedInline: 'unsupi',
        unknownBlock: 'unkb',
        date: 'date'
    },
    marks: {
        em: 'em',
        strong: 'strong',
        code: 'code',
        strike: 'strike',
        underline: 'undline',
        link: 'lnk',
        subsup: 'subsup',
        textColor: 'txtclr',
        unsupportedMark: 'unsupmrk',
        unsupportedNodeAttribute: 'unsupnattr',
        annotation: 'anno'
    }
};
function $70c5483a2e8fe25a$var$shortHash(type, isMark) {
    const code = $70c5483a2e8fe25a$var$hash[isMark ? 'marks' : 'nodes'][type];
    return code ? code : type;
}
function $70c5483a2e8fe25a$var$compactStringifier(node) {
    var _node$marks;
    const isContentEmpty = !node.content;
    const isTextNode = (node === null || node === void 0 ? void 0 : node.type) === 'text';
    const hasMarks = (_node$marks = node.marks) === null || _node$marks === void 0 ? void 0 : _node$marks.length;
    const isContentArray = Array.isArray(node.content);
    const marks = (child)=>{
        if (hasMarks) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return node.marks.reduce((str, mark)=>`${$70c5483a2e8fe25a$var$shortHash(mark, true)}(${str})`, child);
        return child;
    };
    let content;
    if (isTextNode) content = String(node.nodeSize);
    else if (isContentEmpty) content = '';
    else if (isContentArray) // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    content = node.content.map((node)=>$70c5483a2e8fe25a$var$compactStringifier(node)).join(',');
    return marks(`${$70c5483a2e8fe25a$var$shortHash(node.type, false)}(${content})`);
}
const $70c5483a2e8fe25a$export$6451b72139862cbd = (doc, options)=>{
    try {
        const result = $70c5483a2e8fe25a$var$getBlockNode(doc, 0);
        if (options !== null && options !== void 0 && options.compact) return $70c5483a2e8fe25a$var$compactStringifier(result);
        return result;
    } catch (error) {
        return `Error logging document structure: ${error}`;
    }
};
const $70c5483a2e8fe25a$var$getBlockNode = (node, pos)=>{
    const blockNode = {
        type: node.type.name,
        pos: pos,
        nodeSize: node.nodeSize
    };
    const content = $70c5483a2e8fe25a$var$getBlockNodeContent(node.content, pos);
    if (content.length > 0) blockNode.content = content;
    const marks = $70c5483a2e8fe25a$var$getMarks(node);
    if (marks.length > 0) blockNode.marks = marks;
    return blockNode;
};
const $70c5483a2e8fe25a$var$getBlockNodeContent = (node, pos)=>{
    if (!node || !node.content || !node.content.length) return [];
    let blockNodeContent = [];
    const { content: content } = node;
    if (content[0].isBlock) {
        // children are block nodes
        let prevNode;
        blockNodeContent = content.map((node)=>{
            pos += prevNode ? prevNode.nodeSize : 1;
            prevNode = node;
            return $70c5483a2e8fe25a$var$getBlockNode(node, pos);
        });
    } else {
        // children are inline nodes .
        const result = $70c5483a2e8fe25a$var$getInlineNodes(content, pos);
        blockNodeContent = result.inlineNodes;
        pos = result.pos;
    }
    return blockNodeContent;
};
const $70c5483a2e8fe25a$var$getInlineNodes = (nodes, pos)=>{
    const inlineNodes = nodes.map((node)=>{
        const { nodeSize: nodeSize } = node;
        const inlineNode = {
            type: node.type.name,
            pos: pos,
            nodeSize: nodeSize
        };
        const marks = $70c5483a2e8fe25a$var$getMarks(node);
        if (marks.length > 0) inlineNode.marks = marks;
        pos += nodeSize;
        return inlineNode;
    });
    return {
        inlineNodes: inlineNodes,
        pos: pos
    };
};
const $70c5483a2e8fe25a$var$getMarks = (node)=>node.marks.map((mark)=>mark.type.name);

});

parcelRegister("a30nE", function(module, exports) {
$parcel$export(module.exports, "isOutdatedBrowser", () => $1f029c0309da197b$export$12d09524e028927);
/* eslint-disable require-unicode-regexp */ const $1f029c0309da197b$var$CHROME_REGEX = /Chrome\//;
const $1f029c0309da197b$var$OPR_REGEX = /OPR\//;
const $1f029c0309da197b$var$CHROME_VERSION_REGEX = /Chrome\/(\d+)/;
const $1f029c0309da197b$var$GECKO_REGEX = /gecko\/\d/i;
const $1f029c0309da197b$var$FIREFOX_VERSION_REGEX = /Firefox\/(\d+)/;
const $1f029c0309da197b$var$EDGE_REGEX = /Edge\/(\d+)/;
const $1f029c0309da197b$var$SAFARI_REGEX = /Version\/([0-9._]+).*Safari/;
const $1f029c0309da197b$export$12d09524e028927 = (userAgent)=>{
    // Take browsers in both Desktop and Mobile (includes Chrome, Firefox, Edge and Safari) within last 2 years
    const chrome = $1f029c0309da197b$var$CHROME_REGEX.test(userAgent) && !$1f029c0309da197b$var$OPR_REGEX.test(userAgent);
    const chromeVersion = chrome ? parseInt((userAgent.match($1f029c0309da197b$var$CHROME_VERSION_REGEX) || [])[1], 10) : 0;
    if (chromeVersion >= 123) return false;
    const gecko = $1f029c0309da197b$var$GECKO_REGEX.test(userAgent);
    const geckoVersion = gecko ? parseInt((userAgent.match($1f029c0309da197b$var$FIREFOX_VERSION_REGEX) || [])[1], 10) : 0;
    if (geckoVersion >= 124) return false;
    const edge = $1f029c0309da197b$var$EDGE_REGEX.exec(userAgent);
    const edgeVersion = edge ? +edge[1] : 0;
    if (edgeVersion >= 123) return false;
    const safari = !chrome && !gecko && $1f029c0309da197b$var$SAFARI_REGEX.test(userAgent);
    const safariVersion = safari ? parseInt((userAgent.match($1f029c0309da197b$var$SAFARI_REGEX) || [])[1], 10) : 0;
    if (safariVersion >= 17) return false;
    return true;
};

});

parcelRegister("03Qn3", function(module, exports) {
$parcel$export(module.exports, "WithEditorView", () => $c18b1a3f5b27979d$export$cf381084b490bd31);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $iM9ST = parcelRequire("iM9ST");
const $c18b1a3f5b27979d$export$cf381084b490bd31 = (WrappedComponent)=>{
    const _WithFeatureFlags = (props)=>{
        const { editorActions: editorActions } = (0, $iM9ST.useEditorContext)();
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        /*#__PURE__*/ (0, $dc70d.jsx)(WrappedComponent, {
            ...props,
            editorView: editorActions === null || editorActions === void 0 ? void 0 : editorActions._privateGetEditorView()
        }));
    };
    return _WithFeatureFlags;
};

});


parcelRegister("23Rvv", function(module, exports) {
$parcel$export(module.exports, "default", () => $b94c851d152b495d$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $fK3tS = parcelRequire("fK3tS");

var $7RHfd = parcelRequire("7RHfd");

var $bTWXs = parcelRequire("bTWXs");

var $g6Qq4 = parcelRequire("g6Qq4");

var $4S8NW = parcelRequire("4S8NW");

var $eXGEf = parcelRequire("eXGEf");

var $jRBYX = parcelRequire("jRBYX");

var $7lseo = parcelRequire("7lseo");

var $2LeNn = parcelRequire("2LeNn");

var $h16bx = parcelRequire("h16bx");

var $jqEKs = parcelRequire("jqEKs");

var $2a0xe = parcelRequire("2a0xe");
var $g4e18 = parcelRequire("g4e18");

var $cy3my = parcelRequire("cy3my");

var $fcrbf = parcelRequire("fcrbf");

var $3nkOX = parcelRequire("3nkOX");

var $6BIjC = parcelRequire("6BIjC");

var $jC0lZ = parcelRequire("jC0lZ");

var $19de6 = parcelRequire("19de6");

var $b2855 = parcelRequire("b2855");

var $lrWkt = parcelRequire("lrWkt");

var $55o0j = parcelRequire("55o0j");

var $cw0wu = parcelRequire("cw0wu");

var $a3b9P = parcelRequire("a3b9P");

var $iFBOP = parcelRequire("iFBOP");

var $i2dSN = parcelRequire("i2dSN");

var $4xobD = parcelRequire("4xobD");

var $3y2s4 = parcelRequire("3y2s4");

var $8kqXL = parcelRequire("8kqXL");

var $fwg5v = parcelRequire("fwg5v");

var $juFEH = parcelRequire("juFEH");

var $5N1Y4 = parcelRequire("5N1Y4");

var $WJeIw = parcelRequire("WJeIw");

var $8dHy3 = parcelRequire("8dHy3");

var $5NvK0 = parcelRequire("5NvK0");

var $2QkW9 = parcelRequire("2QkW9");

var $XkmhM = parcelRequire("XkmhM");

var $83Zt1 = parcelRequire("83Zt1");

var $5oN7k = parcelRequire("5oN7k");

var $dh4YA = parcelRequire("dh4YA");

var $l9YiQ = parcelRequire("l9YiQ");

var $coiiP = parcelRequire("coiiP");

var $LlHVE = parcelRequire("LlHVE");

var $aKiAv = parcelRequire("aKiAv");

var $j1jEB = parcelRequire("j1jEB");

var $jDv78 = parcelRequire("jDv78");

var $bwlKb = parcelRequire("bwlKb");

var $tEoZh = parcelRequire("tEoZh");

var $bRDwy = parcelRequire("bRDwy");

var $6svky = parcelRequire("6svky");

var $dTpvu = parcelRequire("dTpvu");

var $kd0Iq = parcelRequire("kd0Iq");

var $1oTnu = parcelRequire("1oTnu");
const $b94c851d152b495d$var$EDIT_AREA_ID = 'ak-editor-textarea';
const $b94c851d152b495d$var$SSR_TRACE_SEGMENT_NAME = 'reactEditorView';
const $b94c851d152b495d$var$bootStartTime = (0, $jRBYX.isPerformanceAPIAvailable)() ? performance.now() : undefined;
function $b94c851d152b495d$export$e7d1b1cbca007e16(props) {
    var _pluginInjectionAPI$c, _media, _linking, _document$querySelect, _props$render;
    // Should be always the first statement in the component
    const firstRenderStartTimestampRef = (0, $bSJIT.useRef)(performance.now());
    const { preset: preset, editorProps: { onSSRMeasure: onSSRMeasure, appearance: nextAppearance, disabled: disabled, featureFlags: editorPropFeatureFlags, errorReporterHandler: errorReporterHandler, defaultValue: defaultValue, shouldFocus: shouldFocus }, onEditorCreated: onEditorCreated, onEditorDestroyed: onEditorDestroyed } = props;
    // Holds the best available EditorState before the ProseMirror EditorView has mounted.
    // On SSR: set to the SSR-rendered state so toolbar plugins can read it via getEditorState().
    // On client first render: set to initialEditorState for the same reason.
    // Cleared to undefined once createEditorView runs and viewRef.current becomes available.
    const preMountEditorStateRef = (0, $bSJIT.useRef)(undefined);
    const editorRef = (0, $bSJIT.useRef)(null);
    const viewRef = (0, $bSJIT.useRef)();
    const focusTimeoutId = (0, $bSJIT.useRef)();
    // ProseMirror is instantiated prior to the initial React render cycle,
    // so we allow transactions by default, to avoid discarding the initial one.
    const canDispatchTransactions = (0, $bSJIT.useRef)(true);
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const editorId = (0, $bSJIT.useRef)((0, $7RHfd.default)());
    const eventDispatcher = (0, $bSJIT.useMemo)(()=>new (0, $eXGEf.EventDispatcher)(), []);
    const config = (0, $bSJIT.useRef)({
        nodes: [],
        marks: [],
        pmPlugins: [],
        contentComponents: [],
        pluginHooks: [],
        primaryToolbarComponents: [],
        secondaryToolbarComponents: [],
        onEditorViewStateUpdatedCallbacks: []
    });
    const contentTransformer = (0, $bSJIT.useRef)(undefined);
    const featureFlags = (0, $bSJIT.useMemo)(()=>(0, $8dHy3.createFeatureFlagsFromProps)(editorPropFeatureFlags), [
        editorPropFeatureFlags
    ]);
    const getEditorState = (0, $bSJIT.useCallback)(()=>{
        var _viewRef$current;
        return preMountEditorStateRef.current ?? ((_viewRef$current = viewRef.current) === null || _viewRef$current === void 0 ? void 0 : _viewRef$current.state);
    }, []);
    const getEditorView = (0, $bSJIT.useCallback)(()=>viewRef.current, []);
    const dispatch = (0, $bSJIT.useMemo)(()=>(0, $eXGEf.createDispatch)(eventDispatcher), [
        eventDispatcher
    ]);
    const errorReporter = (0, $bSJIT.useMemo)(()=>(0, $jDv78.createErrorReporter)(errorReporterHandler), [
        errorReporterHandler
    ]);
    const handleAnalyticsEvent = (0, $bSJIT.useCallback)((payload)=>{
        (0, $bTWXs.fireAnalyticsEvent)(props.createAnalyticsEvent)(payload);
    }, [
        props.createAnalyticsEvent
    ]);
    const dispatchAnalyticsEvent = (0, $bSJIT.useCallback)((payload)=>{
        const dispatch = (0, $eXGEf.createDispatch)(eventDispatcher);
        dispatch((0, $lrWkt.analyticsEventKey), {
            payload: payload
        });
    }, [
        eventDispatcher
    ]);
    const pluginInjectionAPI = (0, $bSJIT.useRef)(new (0, $cy3my.EditorPluginInjectionAPI)({
        getEditorState: getEditorState,
        getEditorView: getEditorView,
        fireAnalyticsEvent: handleAnalyticsEvent,
        appearance: nextAppearance
    }));
    const parseDoc = (0, $bSJIT.useCallback)((schema, api, options)=>{
        if (!options.doc) return undefined;
        // if the collabEdit API is set, skip this validation due to potential pm validation errors
        // from docs that end up with invalid marks after processing (See #hot-111702 for more details)
        if ((0, $7lseo.isSSR)() || (api === null || api === void 0 ? void 0 : api.collabEdit) !== undefined || options.props.editorProps.skipValidation) return (0, $fcrbf.processRawValueWithoutValidation)(schema, options.doc, dispatchAnalyticsEvent);
        else return (0, $fcrbf.processRawValue)(schema, options.doc, options.props.providerFactory, options.props.editorProps.sanitizePrivateContent, contentTransformer.current, dispatchAnalyticsEvent);
    }, [
        dispatchAnalyticsEvent
    ]);
    const createEditorState = (0, $bSJIT.useCallback)((options)=>{
        var _api$editorViewMode;
        let schema;
        if (viewRef.current) {
            if (options.resetting) /**
         * ReactEditorView currently does NOT handle dynamic schema,
         * We are reusing the existing schema, and rely on #reconfigureState
         * to update `this.config`
         */ schema = viewRef.current.state.schema;
            else {
                /**
         * There's presently a number of issues with changing the schema of a
         * editor inflight. A significant issue is that we lose the ability
         * to keep track of a user's history as the internal plugin state
         * keeps a list of Steps to undo/redo (which are tied to the schema).
         * Without a good way to do work around this, we prevent this for now.
         */ // eslint-disable-next-line no-console
                console.warn('The editor does not support changing the schema dynamically.');
                return viewRef.current.state;
            }
        } else {
            config.current = (0, $LlHVE.processPluginsList)((0, $aKiAv.default)(options.props.preset, 'allowBlockType' in props.editorProps ? props.editorProps : {}, pluginInjectionAPI.current));
            config.current.pmPlugins.push(...pluginInjectionAPI.current.getInternalPMPlugins());
            schema = (0, $j1jEB.createSchema)(config.current);
        }
        const { contentTransformerProvider: contentTransformerProvider } = options.props.editorProps;
        const plugins = (0, $bwlKb.createPMPlugins)({
            schema: schema,
            dispatch: dispatch,
            errorReporter: errorReporter,
            editorConfig: config.current,
            eventDispatcher: eventDispatcher,
            providerFactory: options.props.providerFactory,
            portalProviderAPI: props.portalProviderAPI,
            nodeViewPortalProviderAPI: props.nodeViewPortalProviderAPI,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            featureFlags: featureFlags,
            getIntl: ()=>props.intl,
            onEditorStateUpdated: pluginInjectionAPI.current.onEditorViewUpdated
        });
        contentTransformer.current = contentTransformerProvider ? contentTransformerProvider(schema) : undefined;
        const api = pluginInjectionAPI.current.api();
        // If we have a doc prop, we need to process it into a PMNode
        const doc = parseDoc(schema, api, options);
        const isViewMode = (api === null || api === void 0 || (_api$editorViewMode = api.editorViewMode) === null || _api$editorViewMode === void 0 ? void 0 : _api$editorViewMode.sharedState.currentState().mode) === 'view';
        let selection;
        if (doc) {
            if (isViewMode) {
                const emptySelection = new (0, $cw0wu.TextSelection)(doc.resolve(0));
                return (0, $cw0wu.EditorState).create({
                    schema: schema,
                    plugins: plugins,
                    doc: doc,
                    selection: emptySelection
                });
            } else selection = options.selectionAtStart ? (0, $cw0wu.Selection).atStart(doc) : (0, $cw0wu.Selection).atEnd(doc);
        }
        // Workaround for ED-3507: When media node is the last element, scrollIntoView throws an error
        const patchedSelection = selection ? (0, $cw0wu.Selection).findFrom(selection.$head, -1, true) || undefined : undefined;
        return (0, $cw0wu.EditorState).create({
            schema: schema,
            plugins: plugins,
            doc: doc,
            selection: patchedSelection
        });
    }, [
        errorReporter,
        featureFlags,
        parseDoc,
        props.intl,
        props.portalProviderAPI,
        props.nodeViewPortalProviderAPI,
        props.editorProps,
        dispatchAnalyticsEvent,
        eventDispatcher,
        dispatch
    ]);
    const initialEditorState = (0, $bSJIT.useMemo)(()=>{
        if ((0, $7lseo.isSSR)()) // We don't need to create initial state in SSR, it would be done by EditorSSRRenderer,
        // so we can save some CPU time here.
        return undefined;
        const state = createEditorState({
            props: props,
            doc: defaultValue,
            // ED-4759: Don't set selection at end for full-page editor - should be at start.
            // Match SSR's start selection so the optimistic toolbar hydrates with the same block type.
            selectionAtStart: (0, $5oN7k.isFullPage)(nextAppearance) || nextAppearance === 'max' && (0, $5N1Y4.expValEquals)('platform_editor_ssr_toolbar_optimistic', 'isEnabled', true)
        });
        if ((0, $5N1Y4.expValEquals)('platform_editor_ssr_toolbar_optimistic', 'isEnabled', true)) // CSR only, synchronously set preMountEditorStateRef so it's ready to be consumed by children including toolbar
        preMountEditorStateRef.current = state;
        return state;
    }, // This is only used for the initial state - afterwards we will have `viewRef` available for use
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    const getCurrentEditorState = (0, $bSJIT.useCallback)(()=>{
        var _viewRef$current2;
        return ((_viewRef$current2 = viewRef.current) === null || _viewRef$current2 === void 0 ? void 0 : _viewRef$current2.state) ?? initialEditorState;
    }, [
        initialEditorState
    ]);
    const blur = (0, $bSJIT.useCallback)(()=>{
        if (!viewRef.current) return;
        if (viewRef.current.dom instanceof HTMLElement && viewRef.current.hasFocus()) viewRef.current.dom.blur();
        // The selectionToDOM method uses the document selection to determine currently selected node
        // We need to mimic blurring this as it seems doing the above is not enough.
        // Guard against clearing selections that belong outside this editor instance.
        // @ts-expect-error
        const sel = viewRef.current.root.getSelection();
        if (sel) {
            if (!(0, $3y2s4.isExperimentEnabled)('fix_editor_blur_issue_exp')) {
                sel.removeAllRanges();
                return;
            }
            if ((!sel.anchorNode || viewRef.current.dom.contains(sel.anchorNode)) && (!sel.focusNode || viewRef.current.dom.contains(sel.focusNode))) sel.removeAllRanges();
        }
    }, []);
    const resetEditorState = (0, $bSJIT.useCallback)(({ doc: doc, shouldScrollToBottom: shouldScrollToBottom })=>{
        var _props$editorProps$on, _props$editorProps;
        if (!viewRef.current) return;
        // We cannot currently guarantee when all the portals will have re-rendered during a reconfigure
        // so we blur here to stop ProseMirror from trying to apply selection to detached nodes or
        // nodes that haven't been re-rendered to the document yet.
        blur();
        const newEditorState = createEditorState({
            props: props,
            doc: doc,
            resetting: true,
            selectionAtStart: !shouldScrollToBottom
        });
        viewRef.current.updateState(newEditorState);
        (_props$editorProps$on = (_props$editorProps = props.editorProps).onChange) === null || _props$editorProps$on === void 0 || _props$editorProps$on.call(_props$editorProps, viewRef.current, {
            source: 'local',
            isDirtyChange: false
        });
    }, [
        blur,
        createEditorState,
        props
    ]);
    // Initialise phase
    // Using constructor hook so we setup and dispatch analytics before anything else
    (0, $19de6.default)(()=>{
        var _props$intl;
        // This needs to be before initialising editorState because
        // we dispatch analytics events in plugin initialisation
        eventDispatcher.on((0, $lrWkt.analyticsEventKey), handleAnalyticsEvent);
        eventDispatcher.on('resetEditorState', resetEditorState);
        dispatchAnalyticsEvent({
            action: (0, $g6Qq4.ACTION).STARTED,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).EDITOR,
            attributes: {
                platform: (0, $4S8NW.PLATFORMS).WEB,
                featureFlags: featureFlags ? (0, $h16bx.getEnabledFeatureFlagKeys)(featureFlags) : [],
                accountLocale: (_props$intl = props.intl) === null || _props$intl === void 0 ? void 0 : _props$intl.locale,
                browserLocale: window.navigator.language
            },
            eventType: (0, $g6Qq4.EVENT_TYPE).UI
        });
    });
    (0, $bSJIT.useLayoutEffect)(()=>{
        if ((0, $7lseo.isSSR)()) return;
        // Transaction dispatching is already enabled by default prior to
        // mounting, but we reset it here, just in case the editor view
        // instance is ever recycled (mounted again after unmounting) with
        // the same key.
        // AND since React 18 effects may run multiple times so we need to ensure
        // this is reset so that transactions are still allowed.
        // Although storing mounted state is an anti-pattern in React,
        // we do so here so that we can intercept and abort asynchronous
        // ProseMirror transactions when a dismount is imminent.
        canDispatchTransactions.current = true;
        return ()=>{
            // We can ignore any transactions from this point onwards.
            // This serves to avoid potential runtime exceptions which could arise
            // from an async dispatched transaction after it's unmounted.
            canDispatchTransactions.current = false;
        };
    }, []);
    // Cleanup
    (0, $bSJIT.useLayoutEffect)(()=>{
        if ((0, $7lseo.isSSR)()) // No cleanup in SSR should happened because SSR doesn't render a real editor.
        return;
        return ()=>{
            const focusTimeoutIdCurrent = focusTimeoutId.current;
            if (focusTimeoutIdCurrent) clearTimeout(focusTimeoutIdCurrent);
            if (viewRef.current) {
                // Destroy the state if the Editor is being unmounted
                const editorState = viewRef.current.state;
                editorState.plugins.forEach((plugin)=>{
                    const state = plugin.getState(editorState);
                    if (state && state.destroy) state.destroy();
                });
            }
            eventDispatcher.destroy();
        // this.view will be destroyed when React unmounts in handleEditorViewRef
        };
    }, [
        eventDispatcher
    ]);
    // Preset reference last processed by reconfigureState. Used to skip the
    // destructive plugin filter when reconfigure is
    // called with the same preset.
    const lastProcessedPresetRef = (0, $bSJIT.useRef)(null);
    const reconfigureState = (0, $bSJIT.useCallback)((props)=>{
        if (!viewRef.current) return;
        // We cannot currently guarantee when all the portals will have re-rendered during a reconfigure
        // so we blur here to stop ProseMirror from trying to apply selection to detached nodes or
        // nodes that haven't been re-rendered to the document yet.
        blur();
        // Snapshot plugin names registered before createPluginsList runs, so
        // we can tell which plugins are newly added by the new preset vs.
        // which ones already coexisted with the current schema.
        const previousPluginNames = new Set(pluginInjectionAPI.current.getRegisteredPluginNames());
        let editorPlugins = (0, $aKiAv.default)(props.preset, 'allowBlockType' in props.editorProps ? props.editorProps : {}, pluginInjectionAPI.current);
        // Capture once, before the downstream block updates the ref — the
        // filter is destructive and only wants to run when the preset has
        // actually changed.
        const presetChanged = lastProcessedPresetRef.current !== props.preset;
        const buildConfig = (plugins)=>{
            const c = (0, $LlHVE.processPluginsList)(plugins);
            c.pmPlugins.push(...pluginInjectionAPI.current.getInternalPMPlugins());
            return c;
        };
        let nextConfig = buildConfig(editorPlugins);
        // `state.reconfigure` keeps the original schema, so switching presets
        // can leave the editor inconsistent in two ways:
        //   1. The new preset may add plugins that reference schema nodes or
        //      marks the original schema doesn't have.
        //   2. Plugins registered by a previous preset can linger in the
        //      injection API even when the new preset doesn't re-register
        //      them, so listeners still fire against a state that no longer
        //      has their pmPlugin.
        if (presetChanged) {
            const { dropped: dropped, kept: kept } = (0, $tEoZh.filterPluginsForReconfigure)(editorPlugins, viewRef.current.state.schema, previousPluginNames);
            if (dropped.length > 0) {
                editorPlugins = kept;
                // Plugin list changed — rebuild candidate config to match.
                nextConfig = buildConfig(editorPlugins);
            }
            const keptPluginNames = new Set(editorPlugins.map((p)=>p === null || p === void 0 ? void 0 : p.name).filter((n)=>Boolean(n)));
            const evictedFromApi = pluginInjectionAPI.current.retainPlugins(keptPluginNames);
            if (dropped.length > 0 || evictedFromApi.length > 0) // eslint-disable-next-line no-console
            console.warn('[reconfigureState] Cleanup summary:', {
                dropped: dropped,
                evictedFromApi: evictedFromApi
            });
        }
        config.current = nextConfig;
        const state = viewRef.current.state;
        const plugins = (0, $bwlKb.createPMPlugins)({
            schema: state.schema,
            dispatch: dispatch,
            errorReporter: errorReporter,
            editorConfig: config.current,
            eventDispatcher: eventDispatcher,
            providerFactory: props.providerFactory,
            portalProviderAPI: props.portalProviderAPI,
            nodeViewPortalProviderAPI: props.nodeViewPortalProviderAPI,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            featureFlags: featureFlags,
            getIntl: ()=>props.intl,
            onEditorStateUpdated: pluginInjectionAPI.current.onEditorViewUpdated
        });
        const newState = state.reconfigure({
            plugins: plugins
        });
        if (presetChanged) lastProcessedPresetRef.current = props.preset;
        // need to update the state first so when the view builds the nodeviews it is
        // using the latest plugins
        viewRef.current.updateState(newState);
        const result = viewRef.current.update({
            ...viewRef.current.props,
            state: newState
        });
        return result;
    }, [
        blur,
        dispatchAnalyticsEvent,
        eventDispatcher,
        dispatch,
        errorReporter,
        featureFlags
    ]);
    const onEditorViewUpdated = (0, $bSJIT.useCallback)(({ originalTransaction: originalTransaction, transactions: transactions, oldEditorState: oldEditorState, newEditorState: newEditorState })=>{
        var _config$current;
        (_config$current = config.current) === null || _config$current === void 0 || _config$current.onEditorViewStateUpdatedCallbacks.forEach((entry)=>{
            entry.callback({
                originalTransaction: originalTransaction,
                transactions: transactions,
                oldEditorState: oldEditorState,
                newEditorState: newEditorState
            });
        });
    }, []);
    const dispatchTransaction = (0, $kd0Iq.useDispatchTransaction)({
        onChange: props.editorProps.onChange,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        onEditorViewUpdated: onEditorViewUpdated,
        isRemoteReplaceDocumentTransaction: (_pluginInjectionAPI$c = pluginInjectionAPI.current.api()) === null || _pluginInjectionAPI$c === void 0 || (_pluginInjectionAPI$c = _pluginInjectionAPI$c.collabEdit) === null || _pluginInjectionAPI$c === void 0 || (_pluginInjectionAPI$c = _pluginInjectionAPI$c.actions) === null || _pluginInjectionAPI$c === void 0 ? void 0 : _pluginInjectionAPI$c.isRemoteReplaceDocumentTransaction
    });
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: Remove these when we deprecate these props from editor-props - smartLinks is unfortunately still used in some places, we can sidestep this problem if we move everyone across to ComposableEditor and deprecate Editor
    const UNSAFE_cards = props.editorProps.UNSAFE_cards;
    const smartLinks = props.editorProps.smartLinks;
    // Temporary to replace provider factory while migration to `ComposableEditor` occurs
    (0, $WJeIw.useProviders)({
        editorApi: pluginInjectionAPI.current.api(),
        contextIdentifierProvider: props.editorProps.contextIdentifierProvider,
        mediaProvider: (_media = props.editorProps.media) === null || _media === void 0 ? void 0 : _media.provider,
        mentionProvider: props.editorProps.mentionProvider,
        cardProvider: ((_linking = props.editorProps.linking) === null || _linking === void 0 || (_linking = _linking.smartLinks) === null || _linking === void 0 ? void 0 : _linking.provider) || smartLinks && smartLinks.provider || UNSAFE_cards && UNSAFE_cards.provider,
        emojiProvider: props.editorProps.emojiProvider,
        autoformattingProvider: props.editorProps.autoformattingProvider,
        taskDecisionProvider: props.editorProps.taskDecisionProvider
    });
    const getDirectEditorProps = (0, $bSJIT.useCallback)((state)=>{
        const stateToUse = state ?? getCurrentEditorState();
        if (!stateToUse) // This should not be happened, because initialState is only inavailable in SSR,
        // but in SSR this function should never be called.
        // In SSR we should use EditorSSRRenderer instead usual ProseMirror editor.
        throw new Error('No editor state found');
        return {
            state: stateToUse,
            dispatchTransaction: (tr)=>{
                // Block stale transactions:
                // Prevent runtime exceptions from async transactions that would attempt to
                // update the DOM after React has unmounted the Editor.
                if (canDispatchTransactions.current) dispatchTransaction(viewRef.current, tr);
            },
            // Disables the contentEditable attribute of the editor if the editor is disabled
            editable: (_state)=>!disabled,
            attributes: {
                'data-gramm': 'false'
            }
        };
    }, [
        dispatchTransaction,
        disabled,
        getCurrentEditorState
    ]);
    const createEditorView = (0, $bSJIT.useCallback)((node)=>{
        // Creates the editor-view from this.editorState. If an editor has been mounted
        // previously, this will contain the previous state of the editor.
        const view = new (0, $a3b9P.EditorView)({
            mount: node
        }, getDirectEditorProps());
        viewRef.current = view;
        if ((0, $5N1Y4.expValEquals)('platform_editor_ssr_toolbar_optimistic', 'isEnabled', true)) // clears pre-mount state as soon as the final view is mounted
        preMountEditorStateRef.current = undefined;
        (0, $jqEKs.measureRender)((0, $l9YiQ.default).PROSEMIRROR_RENDERED, ({ duration: duration, startTime: startTime, distortedDuration: distortedDuration })=>{
            const proseMirrorRenderedSeverity = (0, $lrWkt.getAnalyticsEventSeverity)(duration, (0, $coiiP.PROSEMIRROR_RENDERED_NORMAL_SEVERITY_THRESHOLD), (0, $coiiP.PROSEMIRROR_RENDERED_DEGRADED_SEVERITY_THRESHOLD));
            if (viewRef.current) {
                var _pluginInjectionAPI$c2;
                const { nodes: nodes, extensionKeys: extensionKeys } = (0, $2QkW9.getNodesCountWithExtensionKeys)(viewRef.current.state.doc);
                const ttfb = (0, $g4e18.getResponseEndTime)();
                const requestToResponseTime = (0, $2a0xe.getRequestToResponseTime)();
                const contextIdentifier = (_pluginInjectionAPI$c2 = pluginInjectionAPI.current.api().base) === null || _pluginInjectionAPI$c2 === void 0 ? void 0 : _pluginInjectionAPI$c2.sharedState.currentState();
                const nodesInViewport = (0, $XkmhM.getNodesVisibleInViewport)(viewRef.current.dom);
                const nodeSize = viewRef.current.state.doc.nodeSize;
                const totalNodes = Object.values(nodes).reduce((acc, curr)=>acc + curr, 0);
                // Computed on client for dimension bucketing in Statsig
                const nodeSizeBucket = (()=>{
                    switch(true){
                        case nodeSize < 10000:
                            return '<10000';
                        case nodeSize < 20000:
                            return '<20000';
                        case nodeSize < 30000:
                            return '<30000';
                        case nodeSize < 40000:
                            return '<40000';
                        case nodeSize < 50000:
                            return '<50000';
                        default:
                            return '50000+';
                    }
                })();
                const editorDomSize = (0, $5NvK0.getEditorDomSize)(viewRef.current);
                const interaction = (0, $juFEH.getActiveInteraction)();
                const pageLoadType = interaction === null || interaction === void 0 ? void 0 : interaction.type;
                const pageType = interaction === null || interaction === void 0 ? void 0 : interaction.routeName;
                const timings = (()=>{
                    if (requestToResponseTime === undefined && $b94c851d152b495d$var$bootStartTime === undefined) return undefined;
                    const timingValues = {};
                    if (requestToResponseTime !== undefined) timingValues['requestStart->responseEnd'] = Math.round(requestToResponseTime);
                    if ($b94c851d152b495d$var$bootStartTime !== undefined) timingValues.bootToRender = Math.round(startTime - $b94c851d152b495d$var$bootStartTime);
                    return timingValues;
                })();
                const attributes = {
                    duration: duration,
                    startTime: startTime,
                    nodes: nodes,
                    nodesInViewport: nodesInViewport,
                    nodeSize: nodeSize,
                    nodeSizeBucket: nodeSizeBucket,
                    totalNodes: totalNodes,
                    editorDomSize: editorDomSize,
                    ttfb: ttfb,
                    severity: proseMirrorRenderedSeverity,
                    objectId: contextIdentifier === null || contextIdentifier === void 0 ? void 0 : contextIdentifier.objectId,
                    distortedDuration: distortedDuration,
                    pageLoadType: pageLoadType,
                    pageType: pageType,
                    timings: timings,
                    extensionKeys: extensionKeys,
                    ufoInteractionId: (0, $fwg5v.getInteractionId)().current
                };
                (0, $8kqXL.addUFOCustomData)({
                    editorDomSize: editorDomSize
                });
                dispatchAnalyticsEvent({
                    action: (0, $g6Qq4.ACTION).PROSEMIRROR_RENDERED,
                    actionSubject: (0, $g6Qq4.ACTION_SUBJECT).EDITOR,
                    attributes: attributes,
                    eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL
                });
            }
        });
        pluginInjectionAPI.current.onEditorViewUpdated({
            newEditorState: viewRef.current.state,
            oldEditorState: undefined
        });
        return view;
    }, [
        getDirectEditorProps,
        dispatchAnalyticsEvent
    ]);
    const [editorView, setEditorView] = (0, $bSJIT.useState)(undefined);
    // Detects if the editor is nested inside an extension - ie. it is a Legacy Content Extension (LCE)
    const isNestedEditor = (0, $bSJIT.useRef)(null);
    const isNestedEditorCalculated = (0, $bSJIT.useRef)(false);
    if (editorRef.current !== null && !isNestedEditorCalculated.current) {
        var _editorRef$current;
        isNestedEditor.current = !!((_editorRef$current = editorRef.current) !== null && _editorRef$current !== void 0 && _editorRef$current.closest('.extension-editable-area'));
        isNestedEditorCalculated.current = true;
    }
    // Preconditioned on the affected population - full page, non nested editors - so that experiment
    // exposure is not diluted by editors which never run the scroll restoration code below.
    const scrollRestorePerfEnabled = !isNestedEditor.current && (0, $5oN7k.isFullPage)(props.editorProps.appearance) || (0, $3y2s4.isExperimentEnabled)('platform_editor_reduce_forced_layout');
    const originalScrollToRestore = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useRef(// Reading scrollTop forces a synchronous layout, and this expression is re-evaluated on every
    // render. Products restore scroll themselves after the document has rendered.
    !isNestedEditor.current && (0, $5oN7k.isFullPage)(props.editorProps.appearance) && !scrollRestorePerfEnabled ? (_document$querySelect = document.querySelector('[data-editor-scroll-container]')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.scrollTop : undefined);
    const mitigateScrollJump = // The feature gate here is being used to avoid potential bugs with the scroll restoration code
    // moving it to the end of the expression negates the point of the feature gate
    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
    (0, $5oN7k.isFullPage)(props.editorProps.appearance) && originalScrollToRestore.current && originalScrollToRestore.current !== 0;
    (0, $bSJIT.useLayoutEffect)(()=>{
        var _editorView$props$edi, _editorView$props;
        if ((0, $7lseo.isSSR)()) // We don't need to focus anything in SSR.
        return;
        if (shouldFocus && editorView !== null && editorView !== void 0 && (_editorView$props$edi = (_editorView$props = editorView.props).editable) !== null && _editorView$props$edi !== void 0 && _editorView$props$edi.call(_editorView$props, editorView.state)) {
            if (!mitigateScrollJump) {
                var _pluginInjectionAPI$c3;
                const focusesImmediately = (0, $83Zt1.isChromeless)(props.editorProps.appearance) || (0, $55o0j.isEmptyDocument)(editorView.state.doc) || ((_pluginInjectionAPI$c3 = pluginInjectionAPI.current.api()) === null || _pluginInjectionAPI$c3 === void 0 ? void 0 : _pluginInjectionAPI$c3.interaction) === undefined;
                if (focusesImmediately) focusTimeoutId.current = (0, $dTpvu.handleEditorFocus)(editorView);
            }
        }
    }, [
        editorView,
        shouldFocus,
        mitigateScrollJump,
        disabled,
        props.editorProps.appearance
    ]);
    const scrollElement = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useRef();
    const possibleListeners = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useRef([]);
    (0, $bSJIT.useEffect)(()=>{
        if ((0, $7lseo.isSSR)()) // No event listeners should be attached to scroll element in SSR.
        return;
        return ()=>{
            if (scrollElement.current) // eslint-disable-next-line react-hooks/exhaustive-deps
            for (const possibleListener of possibleListeners.current){
                var _scrollElement$curren;
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                (_scrollElement$curren = scrollElement.current) === null || _scrollElement$curren === void 0 || _scrollElement$curren.removeEventListener(...possibleListener);
            }
            scrollElement.current = null;
        };
    }, []);
    const handleEditorViewRef = (0, $bSJIT.useCallback)((node)=>{
        if (node) {
            // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
            scrollElement.current = document.querySelector('[data-editor-scroll-container]');
            const cleanupListeners = ()=>{
                // eslint-disable-next-line react-hooks/exhaustive-deps
                for (const possibleListener of possibleListeners.current){
                    var _scrollElement$curren2;
                    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                    (_scrollElement$curren2 = scrollElement.current) === null || _scrollElement$curren2 === void 0 || _scrollElement$curren2.removeEventListener(...possibleListener);
                }
            };
            if (scrollElement.current) {
                const wheelAbortHandler = (event)=>{
                    // Programmatic scrolls are not user interactions and must not abort the load metric.
                    if (scrollRestorePerfEnabled && !event.isTrusted) return;
                    const activeInteraction = (0, $juFEH.getActiveInteraction)();
                    if (activeInteraction && [
                        'edit-page',
                        'live-edit'
                    ].includes(activeInteraction.ufoName)) (0, $juFEH.abortAll)('new_interaction', `wheel-on-editor-element`);
                    cleanupListeners();
                };
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                scrollElement.current.addEventListener('wheel', wheelAbortHandler);
                possibleListeners.current.push([
                    'wheel',
                    wheelAbortHandler
                ]);
                const scrollAbortHandler = (event)=>{
                    // Programmatic scrolls are not user interactions and must not abort the load metric.
                    if (scrollRestorePerfEnabled && !event.isTrusted) return;
                    const activeInteraction = (0, $juFEH.getActiveInteraction)();
                    if (activeInteraction && [
                        'edit-page',
                        'live-edit'
                    ].includes(activeInteraction.ufoName)) (0, $juFEH.abortAll)('new_interaction', `scroll-on-editor-element`);
                    cleanupListeners();
                };
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                scrollElement.current.addEventListener('scroll', scrollAbortHandler);
                possibleListeners.current.push([
                    'scroll',
                    scrollAbortHandler
                ]);
            }
        }
        if (!viewRef.current && node) {
            (0, $2LeNn.nodeVisibilityManager)(node).initialiseNodeObserver();
            const view = createEditorView(node);
            if (mitigateScrollJump) {
                const scrollElement = document.querySelector('[data-editor-scroll-container]');
                scrollElement === null || scrollElement === void 0 || scrollElement.scrollTo({
                    top: originalScrollToRestore.current,
                    behavior: 'instant'
                });
            }
            onEditorCreated({
                view: view,
                config: config.current,
                eventDispatcher: eventDispatcher,
                transformer: contentTransformer.current
            });
            (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).startTransition(()=>{
                // Force React to re-render so consumers get a reference to the editor view
                setEditorView(view);
            });
        } else if (viewRef.current && !node) {
            // When the appearance is changed, React will call handleEditorViewRef with node === null
            // to destroy the old EditorView, before calling this method again with node === div to
            // create the new EditorView
            onEditorDestroyed({
                view: viewRef.current,
                config: config.current,
                eventDispatcher: eventDispatcher,
                transformer: contentTransformer.current
            });
            const wasAnalyticsDisconnected = !eventDispatcher.has((0, $lrWkt.analyticsEventKey), handleAnalyticsEvent);
            // If we disabled event listening for some reason we should re-enable it temporarily while we destroy
            // the view for any analytics that occur there.
            if (wasAnalyticsDisconnected) {
                eventDispatcher.on((0, $lrWkt.analyticsEventKey), handleAnalyticsEvent);
                viewRef.current.destroy(); // Destroys the dom node & all node views
                eventDispatcher.off((0, $lrWkt.analyticsEventKey), handleAnalyticsEvent);
            } else viewRef.current.destroy(); // Destroys the dom node & all node views
            (0, $2LeNn.nodeVisibilityManager)(viewRef.current.dom).disconnect();
            viewRef.current = undefined;
        }
    }, [
        createEditorView,
        onEditorCreated,
        eventDispatcher,
        onEditorDestroyed,
        handleAnalyticsEvent,
        mitigateScrollJump,
        scrollRestorePerfEnabled
    ]);
    const isPageAppearance = (0, $5oN7k.isFullPage)(nextAppearance) || nextAppearance === 'max';
    const createEditor = (0, $bSJIT.useCallback)((assistiveLabel, assistiveDescribedBy)=>{
        return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `ProseMirror ${(0, $6svky.getUAPrefix)()}`,
            ref: handleEditorViewRef,
            "aria-label": assistiveLabel || (isPageAppearance ? props.intl.formatMessage((0, $bRDwy.editorMessages).fullPageEditorAssistiveLabel) : props.intl.formatMessage((0, $bRDwy.editorMessages).editorAssistiveLabel)),
            // setting aria-multiline to true when not mobile appearance.
            //  because somehow mobile tests are failing when it set.
            //  don't know why that is happening.
            // Created https://product-fabric.atlassian.net/jira/servicedesk/projects/DTR/queues/issue/DTR-1675
            //  to investigate further.
            "aria-multiline": true,
            role: "textbox",
            id: $b94c851d152b495d$var$EDIT_AREA_ID,
            "aria-describedby": assistiveDescribedBy,
            "data-editor-id": editorId.current,
            "data-vc-ignore-if-no-layout-shift": true,
            "data-ssr-placeholder": "editor-view",
            "data-ssr-placeholder-replace": "editor-view",
            "data-gramm": (0, $3y2s4.isExperimentEnabled)('platform_editor_reduce_forced_layout') ? 'false' : undefined,
            translate: (0, $3y2s4.isExperimentEnabled)('platform_editor_reduce_forced_layout') ? 'no' : undefined,
            // eslint-disable-next-line react/no-danger -- needed for SSR and hydration so react keeps the HTML untouched
            dangerouslySetInnerHTML: {
                __html: ''
            }
        }, "ProseMirror");
    }, [
        handleEditorViewRef,
        isPageAppearance,
        props.intl
    ]);
    const previousPreset = (0, $b2855.default)(preset);
    (0, $bSJIT.useLayoutEffect)(()=>{
        if ((0, $7lseo.isSSR)()) // No state reconfiguration is supported in SSR.
        return;
        if (previousPreset && previousPreset !== preset) reconfigureState(props);
    }, [
        reconfigureState,
        previousPreset,
        preset,
        props
    ]);
    const previousDisabledState = (0, $b2855.default)(disabled);
    (0, $bSJIT.useLayoutEffect)(()=>{
        if ((0, $7lseo.isSSR)()) // We don't need to focus anything in SSR.
        return;
        if (viewRef.current && previousDisabledState !== disabled) {
            var _pluginInjectionAPI$c4;
            // Disables the contentEditable attribute of the editor if the editor is disabled
            viewRef.current.setProps({
                editable: (_state)=>!disabled
            });
            const focusesImmediately = (0, $55o0j.isEmptyDocument)(viewRef.current.state.doc) || ((_pluginInjectionAPI$c4 = pluginInjectionAPI.current.api()) === null || _pluginInjectionAPI$c4 === void 0 ? void 0 : _pluginInjectionAPI$c4.interaction) === undefined;
            if (!disabled && shouldFocus && focusesImmediately) focusTimeoutId.current = (0, $dTpvu.handleEditorFocus)(viewRef.current);
        }
    }, [
        disabled,
        shouldFocus,
        previousDisabledState
    ]);
    (0, $bSJIT.useLayoutEffect)(()=>{
        var _pluginInjectionAPI$c5;
        (_pluginInjectionAPI$c5 = pluginInjectionAPI.current.api()) === null || _pluginInjectionAPI$c5 === void 0 || (_pluginInjectionAPI$c5 = _pluginInjectionAPI$c5.core) === null || _pluginInjectionAPI$c5 === void 0 || (_pluginInjectionAPI$c5 = _pluginInjectionAPI$c5.actions) === null || _pluginInjectionAPI$c5 === void 0 || _pluginInjectionAPI$c5.updateAppearance(nextAppearance);
    }, [
        nextAppearance
    ]);
    (0, $1oTnu.useFireFullWidthEvent)(nextAppearance, dispatchAnalyticsEvent);
    // This function uses as prop as `<EditorSSRRenderer>` so, that should be memoized,
    // to avoid extra rerenders.
    const buildDoc = (0, $bSJIT.useCallback)((schema)=>{
        return parseDoc(schema, undefined, {
            // Don't pass all props here, use only what you need to keep hook dependencies more stable.
            // Check what `parseDoc` consumes and pass only needed data.
            props: {
                providerFactory: props.providerFactory,
                editorProps: {
                    sanitizePrivateContent: props.editorProps.sanitizePrivateContent
                }
            },
            doc: defaultValue
        });
    }, [
        defaultValue,
        parseDoc,
        props.editorProps.sanitizePrivateContent,
        props.providerFactory
    ]);
    // We need to check `allowBlockType` in props, because it is now exist in EditorNextProps type.
    const { allowBlockType: allowBlockType } = 'allowBlockType' in props.editorProps ? props.editorProps : {
        allowBlockType: undefined
    };
    // In separate memo, because some props like `props.intl` that need only for rendering
    // changes many times, but we don't want to process plugins and ADF document for each unnecessary changes.
    const ssrDeps = (0, $bSJIT.useMemo)(()=>{
        var _pluginInjectionAPI$c6;
        if (!(0, $7lseo.isSSR)()) return null;
        const doCreatePluginList = ()=>(0, $aKiAv.default)(props.preset, // Don't pass props.editorProps directly, because editoProps in the dependency will lead to
            // multiple repaints, because props.editorPros is not stable object.
            {
                allowBlockType: allowBlockType
            }, pluginInjectionAPI.current);
        const plugins = (0, $3nkOX.profileSSROperation)(`${$b94c851d152b495d$var$SSR_TRACE_SEGMENT_NAME}/createPluginsList`, doCreatePluginList, onSSRMeasure);
        const doCreateSchema = ()=>(0, $j1jEB.createSchema)((0, $LlHVE.processPluginsList)(plugins));
        const schema = (0, $3nkOX.profileSSROperation)(`${$b94c851d152b495d$var$SSR_TRACE_SEGMENT_NAME}/createSchema`, doCreateSchema, onSSRMeasure);
        const doBuildDoc = ()=>buildDoc(schema);
        const doc = (0, $3nkOX.profileSSROperation)(`${$b94c851d152b495d$var$SSR_TRACE_SEGMENT_NAME}/buildDoc`, doBuildDoc, onSSRMeasure);
        const isViewMode = ((_pluginInjectionAPI$c6 = pluginInjectionAPI.current.api()) === null || _pluginInjectionAPI$c6 === void 0 || (_pluginInjectionAPI$c6 = _pluginInjectionAPI$c6.editorViewMode) === null || _pluginInjectionAPI$c6 === void 0 || (_pluginInjectionAPI$c6 = _pluginInjectionAPI$c6.sharedState.currentState()) === null || _pluginInjectionAPI$c6 === void 0 ? void 0 : _pluginInjectionAPI$c6.mode) === 'view';
        const ariaReadonly = isViewMode && (0, $3y2s4.isExperimentEnabled)('platform_editor_viewmode_aria_readonly_a11y') ? 'true' : undefined;
        // When the platform_editor_ssr_toolbar_optimistic is on, we create SSR-safe PM plugins and EditorState
        // HERE in ssrDeps — before any children render — so that FullPageToolbarNext can read correct
        // plugin state via useSharedPluginStateWithSelector → currentState() → getEditorState().
        //
        // We also pass these pre-built pmPlugins and editorState to EditorSSRRenderer so it can
        // skip redundant creation (avoids double createPluginsList + EditorState.create).
        if ((0, $5N1Y4.expValEquals)('platform_editor_ssr_toolbar_optimistic', 'isEnabled', true)) {
            const ssrPMPlugins = (0, $3nkOX.profileSSROperation)(`${$b94c851d152b495d$var$SSR_TRACE_SEGMENT_NAME}/createSSRPMPlugins`, ()=>(0, $i2dSN.createSSRPMPlugins)({
                    plugins: plugins,
                    schema: schema,
                    portalProviderAPI: props.portalProviderAPI,
                    getIntl: ()=>props.intl
                }), onSSRMeasure);
            const ssrState = (0, $3nkOX.profileSSROperation)(`${$b94c851d152b495d$var$SSR_TRACE_SEGMENT_NAME}/createSSREditorState`, ()=>(0, $iFBOP.createSSREditorState)({
                    doc: doc,
                    schema: schema,
                    pmPlugins: ssrPMPlugins
                }), onSSRMeasure);
            return {
                plugins: plugins,
                schema: schema,
                doc: doc,
                ariaReadonly: ariaReadonly,
                ssrPMPlugins: ssrPMPlugins,
                ssrEditorState: ssrState
            };
        }
        return {
            plugins: plugins,
            schema: schema,
            doc: doc,
            ariaReadonly: ariaReadonly,
            ssrPMPlugins: undefined,
            ssrEditorState: undefined
        };
    }, [
        allowBlockType,
        buildDoc,
        props.preset,
        onSSRMeasure,
        props.portalProviderAPI,
        props.intl
    ]);
    // SSR only, synchronously set preMountEditorStateRef so it's ready to be consumed by children including toolbar
    if (ssrDeps !== null && ssrDeps !== void 0 && ssrDeps.ssrEditorState) preMountEditorStateRef.current = ssrDeps.ssrEditorState;
    const { assistiveLabel: assistiveLabel, assistiveDescribedBy: assistiveDescribedBy } = props.editorProps;
    const handleSsrEditorStateChanged = (0, $bSJIT.useCallback)((state)=>{
        preMountEditorStateRef.current = state;
        // Notify listeners about the initial SSR state
        pluginInjectionAPI.current.onEditorViewUpdated({
            newEditorState: state,
            oldEditorState: undefined
        });
    }, [
        pluginInjectionAPI
    ]);
    const memoizedReactEditorViewContext = (0, $bSJIT.useMemo)(()=>({
            editorRef: editorRef,
            // Use a getter so that consumers always read the live viewRef.current at access
            // time, not a stale snapshot captured when this memo was created.
            get editorView () {
                return viewRef.current;
            },
            popupsMountPoint: props.editorProps.popupsMountPoint
        }), // viewRef is intentionally omitted from the deps array — it's a stable ref object; the getter reads
    // .current lazily so there's no stale-closure risk.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        editorRef,
        props.editorProps.popupsMountPoint
    ]);
    // eslint-disable-next-line @atlassian/perf-linting/no-inline-context-value, @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017
    const reactEditorViewContext = (0, $3y2s4.isExperimentEnabled)('platform_editor_perf_lint_cleanup') ? memoizedReactEditorViewContext : {
        editorRef: editorRef,
        editorView: viewRef.current,
        popupsMountPoint: props.editorProps.popupsMountPoint
    };
    const ssrEditor = (0, $bSJIT.useMemo)(()=>{
        if (!ssrDeps) return null;
        return /*#__PURE__*/ (0, $dc70d.jsx)((0, $4xobD.EditorSSRRenderer), {
            intl: props.intl,
            doc: ssrDeps.doc,
            schema: ssrDeps.schema,
            plugins: ssrDeps.plugins,
            portalProviderAPI: props.portalProviderAPI,
            // IMPORTANT: Keep next props in sync with div that renders a real ProseMirror editor.
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: `ProseMirror ${(0, $6svky.getUAPrefix)()}`,
            "aria-label": assistiveLabel || (isPageAppearance ? props.intl.formatMessage((0, $bRDwy.editorMessages).fullPageEditorAssistiveLabel) : props.intl.formatMessage((0, $bRDwy.editorMessages).editorAssistiveLabel)),
            id: $b94c851d152b495d$var$EDIT_AREA_ID,
            "aria-describedby": assistiveDescribedBy,
            ...ssrDeps.ariaReadonly === 'true' ? {
                'aria-readonly': 'true'
            } : {},
            "data-editor-id": editorId.current,
            onSSRMeasure: onSSRMeasure,
            prebuiltPMPlugins: ssrDeps.ssrPMPlugins,
            prebuiltEditorState: ssrDeps.ssrEditorState,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onEditorStateChanged: (0, $3y2s4.isExperimentEnabled)('platform_editor_perf_lint_cleanup') ? handleSsrEditorStateChanged : (state)=>{
                preMountEditorStateRef.current = state;
                // Notify listeners about the initial SSR state
                pluginInjectionAPI.current.onEditorViewUpdated({
                    newEditorState: state,
                    oldEditorState: undefined
                });
            }
        }, "ProseMirror");
    }, [
        ssrDeps,
        props.intl,
        props.portalProviderAPI,
        assistiveLabel,
        isPageAppearance,
        assistiveDescribedBy,
        onSSRMeasure,
        handleSsrEditorStateChanged
    ]);
    const editor = (0, $bSJIT.useMemo)(()=>{
        // SSR editor will be available only in SSR environment,
        // in a browser `ssrEditor` will be `null`, and we will render a normal one ProseMirror.
        if (ssrEditor) return ssrEditor;
        return createEditor(props.editorProps.assistiveLabel, props.editorProps.assistiveDescribedBy);
    }, // `createEditor` changes a little too frequently - we don't want to recreate the editor view in this case
    // We should follow-up
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        props.editorProps.assistiveLabel,
        props.editorProps.assistiveDescribedBy,
        ssrEditor
    ]);
    const renderTrackingEnabled = (0, $3y2s4.isExperimentEnabled)('platform_editor_enable_rerender_tracking') && !featureFlags.lcmPreventRenderTracking;
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $6BIjC.SSRRenderMeasure), {
        segmentName: $b94c851d152b495d$var$SSR_TRACE_SEGMENT_NAME,
        startTimestampRef: firstRenderStartTimestampRef,
        onSSRMeasure: onSSRMeasure,
        children: /*#__PURE__*/ (0, $dc70d.jsxs)((0, $jC0lZ.default).Provider, {
            value: reactEditorViewContext,
            children: [
                renderTrackingEnabled && /*#__PURE__*/ (0, $dc70d.jsx)((0, $dh4YA.RenderTracking), {
                    componentProps: props,
                    action: (0, $g6Qq4.ACTION).RE_RENDERED,
                    actionSubject: (0, $g6Qq4.ACTION_SUBJECT).REACT_EDITOR_VIEW,
                    handleAnalyticsEvent: handleAnalyticsEvent,
                    useShallow: true
                }),
                props.render ? ((_props$render = props.render) === null || _props$render === void 0 ? void 0 : _props$render.call(props, {
                    editor: editor,
                    view: viewRef.current,
                    config: config.current,
                    eventDispatcher: eventDispatcher,
                    transformer: contentTransformer.current,
                    dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                    editorRef: editorRef,
                    editorAPI: pluginInjectionAPI.current.api()
                })) ?? editor : editor
            ]
        })
    });
}
var // Preserving exact type generated by TypeScript
// eslint-disable-next-line @typescript-eslint/no-restricted-types, @atlaskit/volt-strict-mode/no-multiple-exports
$b94c851d152b495d$export$2e2bcd8739ae039 = (0, $fK3tS.default)($b94c851d152b495d$export$e7d1b1cbca007e16);

});
parcelRegister("2LeNn", function(module, exports) {
$parcel$export(module.exports, "nodeVisibilityManager", () => $8ce367730110ffb7$export$565ab8668cdfbb7c);
// Use this selector to set the intersection observer boundary for editor's inline node views
// If this does not exist, it will use the IntersectionObserver's default root
const $8ce367730110ffb7$var$INTERSECTION_OBSERVER_ROOT_SELECTOR = '[data-editor-scroll-container="true"]';
const $8ce367730110ffb7$var$editorObservers = new WeakMap();
const $8ce367730110ffb7$var$callbackMap = new WeakMap();
const $8ce367730110ffb7$export$565ab8668cdfbb7c = (editorElement)=>{
    // Warning! do not reference editorElement outside of internal functions.
    // editorElement is passed to allow support for multiple editors,
    const unObserveInternal = (nodeElement)=>{
        var _editorObservers$get;
        (_editorObservers$get = $8ce367730110ffb7$var$editorObservers.get(editorElement)) === null || _editorObservers$get === void 0 || _editorObservers$get.unobserve(nodeElement);
        $8ce367730110ffb7$var$callbackMap.delete(nodeElement);
    };
    const observe = (observerConfig)=>{
        var _editorObservers$get2;
        $8ce367730110ffb7$var$callbackMap.set(observerConfig.element, observerConfig);
        (_editorObservers$get2 = $8ce367730110ffb7$var$editorObservers.get(editorElement)) === null || _editorObservers$get2 === void 0 || _editorObservers$get2.observe(observerConfig.element);
        // return clean up
        return ()=>{
            // consumer needs to unobserve on destroy if their element
            // was observed but never scrolled into view
            unObserveInternal(observerConfig.element);
        };
    };
    const initialiseNodeObserver = ()=>{
        if ($8ce367730110ffb7$var$editorObservers.has(editorElement)) return;
        const intersectionObserverOptions = {
            root: editorElement.closest($8ce367730110ffb7$var$INTERSECTION_OBSERVER_ROOT_SELECTOR),
            rootMargin: '0px 0px 100px 0px',
            threshold: 0
        };
        const editorObserver = new IntersectionObserver((entries)=>entries.map((entry)=>({
                    entry: entry,
                    callback: $8ce367730110ffb7$var$callbackMap.get(entry.target)
                }))// Invoke callbacks together to group browser rendering
            // Avoiding requestAnimationFrame to reduce visual flickering
            .forEach(({ entry: entry, callback: callback })=>{
                if (entry.isIntersecting) {
                    callback === null || callback === void 0 || callback.onFirstVisible();
                    if (entry.target instanceof HTMLElement) // immediately unobserve the element after it is visible
                    unObserveInternal(entry.target);
                }
            }), intersectionObserverOptions);
        $8ce367730110ffb7$var$editorObservers.set(editorElement, editorObserver);
    };
    const disconnect = ()=>{
        var _editorObservers$get3;
        (_editorObservers$get3 = $8ce367730110ffb7$var$editorObservers.get(editorElement)) === null || _editorObservers$get3 === void 0 || _editorObservers$get3.disconnect();
        $8ce367730110ffb7$var$editorObservers.delete(editorElement);
    };
    return {
        initialiseNodeObserver: initialiseNodeObserver,
        observe: observe,
        disconnect: disconnect
    };
};

});

parcelRegister("2a0xe", function(module, exports) {
$parcel$export(module.exports, "getRequestToResponseTime", () => $b3347a6f4e78a0eb$export$c982229f6c12dcf);

var $jRBYX = parcelRequire("jRBYX");
function $b3347a6f4e78a0eb$export$c982229f6c12dcf() {
    if (!(0, $jRBYX.isPerformanceAPIAvailable)()) return;
    const nav = performance.getEntriesByType('navigation')[0];
    if (nav) return nav.responseEnd - nav.requestStart;
    return;
}

});

parcelRegister("cy3my", function(module, exports) {
$parcel$export(module.exports, "EditorPluginInjectionAPI", () => $c05d9ec136e8019a$export$50ccbedb1c6559a0);

var $dMMwa = parcelRequire("dMMwa");

var $cNIkg = parcelRequire("cNIkg");

var $4Fnx3 = parcelRequire("4Fnx3");

function $c05d9ec136e8019a$var$hasGetSharedState(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
plugin) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return typeof plugin.getSharedState === 'function';
}
function $c05d9ec136e8019a$var$hasActions(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
plugin) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return typeof plugin.actions === 'object';
}
function $c05d9ec136e8019a$var$hasCommands(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
plugin) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return typeof plugin.commands === 'object';
}
const $c05d9ec136e8019a$var$filterPluginsWithListeners = ({ listeners: listeners, plugins: plugins })=>Array.from(listeners.keys()).map((pluginName)=>plugins.get(pluginName)).filter((plugin)=>plugin !== undefined && $c05d9ec136e8019a$var$hasGetSharedState(plugin));
const $c05d9ec136e8019a$var$extractSharedStateFromPlugins = ({ oldEditorState: oldEditorState, newEditorState: newEditorState, plugins: plugins })=>{
    const isInitialization = !oldEditorState && newEditorState;
    const result = new Map();
    for (const plugin of plugins){
        if (!plugin || !$c05d9ec136e8019a$var$hasGetSharedState(plugin)) continue;
        const nextSharedState = plugin.getSharedState(newEditorState);
        const prevSharedState = !isInitialization && oldEditorState ? plugin.getSharedState(oldEditorState) : undefined;
        const isSamePluginState = (0, (/*@__PURE__*/$parcel$interopDefault($dMMwa)))(prevSharedState, nextSharedState);
        if (isInitialization || !isSamePluginState) result.set(plugin.name, {
            nextSharedState: nextSharedState,
            prevSharedState: prevSharedState
        });
    }
    return result;
};
const $c05d9ec136e8019a$var$THROTTLE_CALLS_FOR_MILLISECONDS = 0;
const $c05d9ec136e8019a$var$notifyListenersThrottled = (0, (/*@__PURE__*/$parcel$interopDefault($cNIkg)))(({ listeners: listeners, updatesToNotifyQueue: updatesToNotifyQueue })=>{
    const callbacks = [];
    for (const [pluginName, diffs] of updatesToNotifyQueue.entries()){
        const pluginListeners = listeners.get(pluginName) || [];
        pluginListeners.forEach((callback)=>{
            diffs.forEach((diff)=>{
                callbacks.push(callback.bind(callback, diff));
            });
        });
    }
    updatesToNotifyQueue.clear();
    if (callbacks.length === 0) return;
    callbacks.reverse().forEach((cb)=>{
        cb();
    });
}, $c05d9ec136e8019a$var$THROTTLE_CALLS_FOR_MILLISECONDS);
class $c05d9ec136e8019a$var$ActionsAPI {
    createAPI(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    plugin) {
        if (!plugin || !$c05d9ec136e8019a$var$hasActions(plugin)) return {};
        return new Proxy(plugin.actions || {}, {
            get: function(target, prop, _receiver) {
                // We will be able to track perfomance here
                return Reflect.get(target, prop);
            }
        });
    }
}
class $c05d9ec136e8019a$var$EditorCommandsAPI {
    createAPI(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    plugin) {
        if (!plugin || !$c05d9ec136e8019a$var$hasCommands(plugin)) return {};
        return new Proxy(plugin.commands || {}, {
            get: function(target, prop, _receiver) {
                // We will be able to track perfomance here
                return Reflect.get(target, prop);
            }
        });
    }
}
class $c05d9ec136e8019a$export$da7528f3fb233b4a {
    constructor({ getEditorState: getEditorState }){
        this.updatesToNotifyQueue = new Map();
        this.getEditorState = getEditorState;
        this.listeners = new Map();
    }
    createAPI(plugin) {
        if (!plugin) return {
            currentState: ()=>undefined,
            onChange: (_sub)=>{
                return ()=>{};
            }
        };
        const pluginName = plugin.name;
        return {
            currentState: ()=>{
                if (!$c05d9ec136e8019a$var$hasGetSharedState(plugin)) return undefined;
                const state = this.getEditorState();
                return plugin.getSharedState(state);
            },
            onChange: (sub)=>{
                const pluginListeners = this.listeners.get(pluginName) || new Set();
                pluginListeners.add(sub);
                this.listeners.set(pluginName, pluginListeners);
                return ()=>this.cleanupSubscription(pluginName, sub);
            }
        };
    }
    cleanupSubscription(pluginName, sub) {
        (this.listeners.get(pluginName) || new Set()).delete(sub);
    }
    // Drop every listener and pending update for a plugin that is no longer
    // registered. Without this, callbacks (and their captured closures) for
    // evicted plugins would linger in `listeners` until destroy(), and every
    // transaction would still walk their keys via filterPluginsWithListeners.
    removePluginListeners(pluginName) {
        this.listeners.delete(pluginName);
        this.updatesToNotifyQueue.delete(pluginName);
    }
    notifyListeners({ newEditorState: newEditorState, oldEditorState: oldEditorState, plugins: plugins }) {
        const { listeners: listeners, updatesToNotifyQueue: updatesToNotifyQueue } = this;
        const pluginsFiltered = $c05d9ec136e8019a$var$filterPluginsWithListeners({
            plugins: plugins,
            listeners: listeners
        });
        const sharedStateDiffs = $c05d9ec136e8019a$var$extractSharedStateFromPlugins({
            oldEditorState: oldEditorState,
            newEditorState: newEditorState,
            plugins: pluginsFiltered
        });
        if (sharedStateDiffs.size === 0) return;
        for (const [pluginName, nextDiff] of sharedStateDiffs){
            const currentDiffQueue = updatesToNotifyQueue.get(pluginName) || [];
            updatesToNotifyQueue.set(pluginName, [
                ...currentDiffQueue,
                nextDiff
            ]);
        }
        $c05d9ec136e8019a$var$notifyListenersThrottled({
            updatesToNotifyQueue: updatesToNotifyQueue,
            listeners: listeners
        });
    }
    destroy() {
        this.listeners.clear();
        this.updatesToNotifyQueue.clear();
    }
}
const $c05d9ec136e8019a$var$editorAPICache = new WeakMap();
class $c05d9ec136e8019a$export$50ccbedb1c6559a0 {
    constructor({ getEditorState: getEditorState, getEditorView: getEditorView, fireAnalyticsEvent: fireAnalyticsEvent, appearance: appearance }){
        this.onEditorViewUpdated = ({ newEditorState: newEditorState, oldEditorState: oldEditorState })=>{
            this.sharedStateAPI.notifyListeners({
                newEditorState: newEditorState,
                oldEditorState: oldEditorState,
                plugins: this.plugins
            });
        };
        this.onEditorPluginInitialized = (plugin)=>{
            this.addPlugin(plugin);
        };
        // Internal cleanup helper used by ReactEditorView's reconfigureState to
        // reconcile the registered plugin set with the current preset. Removes
        // every registered plugin not in `keptPluginNames`; `core` is always
        // preserved. Returns the names that were removed. Intentionally not on
        // PluginInjectionAPIDefinition: this is an editor-internal control, not
        // part of the injection-API contract that plugins or external consumers
        // depend on.
        this.retainPlugins = (keptPluginNames)=>{
            const evicted = [];
            for (const name of this.plugins.keys())if (name !== 'core' && !keptPluginNames.has(name)) evicted.push(name);
            for (const name of evicted){
                this.plugins.delete(name);
                this.sharedStateAPI.removePluginListeners(name);
            }
            return evicted;
        };
        // Internal: snapshot the names of currently-registered plugins. Used by
        // reconfigureState to capture the previous plugin set before the new
        // preset registers its own plugins via onEditorPluginInitialized.
        this.getRegisteredPluginNames = ()=>Array.from(this.plugins.keys());
        this.addPlugin = (plugin)=>{
            // Plugins other than `core` are checked by the preset itself
            // For some reason in some tests we have duplicates that are missed.
            // To follow-up in ED-19611
            if (plugin.name === 'core' && this.plugins.has(plugin.name)) throw new Error(`Plugin ${plugin.name} has already been initialised in the Editor API!
        There cannot be duplicate plugins or you will have unexpected behaviour`);
            this.plugins.set(plugin.name, plugin);
        };
        this.getPluginByName = (pluginName)=>{
            const plugin = this.plugins.get(pluginName);
            return plugin;
        };
        this.sharedStateAPI = new $c05d9ec136e8019a$export$da7528f3fb233b4a({
            getEditorState: getEditorState
        });
        this.plugins = new Map();
        this.actionsAPI = new $c05d9ec136e8019a$var$ActionsAPI();
        this.commandsAPI = new $c05d9ec136e8019a$var$EditorCommandsAPI();
        // Special core plugin that is always added
        this.addPlugin((0, $4Fnx3.corePlugin)({
            config: {
                getEditorView: getEditorView,
                fireAnalyticsEvent: fireAnalyticsEvent,
                appearance: appearance
            }
        }));
    }
    /**
   * Returns PM plugins from internally-registered plugins (e.g. the core plugin)
   * that are not processed through the normal preset builder flow.
   */ // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getInternalPMPlugins() {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const result = [];
        const corePlugin = this.plugins.get('core');
        if (corePlugin && typeof corePlugin.pmPlugins === 'function') {
            const pmPlugins = corePlugin.pmPlugins();
            if (pmPlugins) result.push(...pmPlugins);
        }
        return result;
    }
    createAPI() {
        const { sharedStateAPI: sharedStateAPI, actionsAPI: actionsAPI, commandsAPI: commandsAPI, getPluginByName: getPluginByName } = this;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return new Proxy({}, {
            get: function(target, prop, _receiver) {
                // If we pass this as a prop React hates us
                // Let's just reflect the result and ignore these
                if (prop === 'toJSON') return Reflect.get(target, prop);
                const plugin = getPluginByName(prop);
                if (!plugin) return undefined;
                const sharedState = sharedStateAPI.createAPI(plugin);
                const actions = actionsAPI.createAPI(plugin);
                const commands = commandsAPI.createAPI(plugin);
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const proxyCoreAPI = {
                    sharedState: sharedState,
                    actions: actions,
                    commands: commands
                };
                return proxyCoreAPI;
            }
        });
    }
    api() {
        if (!$c05d9ec136e8019a$var$editorAPICache.get(this)) $c05d9ec136e8019a$var$editorAPICache.set(this, this.createAPI());
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return $c05d9ec136e8019a$var$editorAPICache.get(this);
    }
}

});
parcelRegister("4Fnx3", function(module, exports) {
$parcel$export(module.exports, "corePlugin", () => $ce99aabf312ea79a$export$71ab138dd170c35);

var $kW8qW = parcelRequire("kW8qW");

var $l6DJ7 = parcelRequire("l6DJ7");

var $85mAs = parcelRequire("85mAs");

var $fcrbf = parcelRequire("fcrbf");

var $iPR6g = parcelRequire("iPR6g");

var $dpCmG = parcelRequire("dpCmG");

var $jPcm5 = parcelRequire("jPcm5");
const $ce99aabf312ea79a$export$71ab138dd170c35 = ({ config: config })=>{
    // Create the document request throttler per editor (rather than at a module level)
    const scheduleDocumentRequest = (0, $jPcm5.createThrottleSchedule)((0, $jPcm5.returnDocumentRequest));
    const scheduleDocumentRequestNoThrowError = (0, $jPcm5.createThrottleSchedule)((0, $jPcm5.returnDocumentRequestNoThrowError));
    return {
        name: 'core',
        getSharedState (state) {
            const pluginState = state && (0, $dpCmG.appearancePluginKey).getState(state);
            return {
                schema: state === null || state === void 0 ? void 0 : state.schema,
                appearance: pluginState === null || pluginState === void 0 ? void 0 : pluginState.appearance
            };
        },
        pmPlugins () {
            return [
                {
                    name: 'appearancePlugin',
                    plugin: ()=>(0, $dpCmG.createAppearancePlugin)(config === null || config === void 0 ? void 0 : config.appearance)
                }
            ];
        },
        actions: {
            execute: (command)=>{
                const editorView = config === null || config === void 0 ? void 0 : config.getEditorView();
                if (!editorView || !command) return false;
                const { state: state, dispatch: dispatch } = editorView;
                return (0, $iPR6g.editorCommandToPMCommand)(command)(state, dispatch);
            },
            // Code copied from `EditorActions.focus()`
            focus: (options)=>{
                const editorView = config === null || config === void 0 ? void 0 : config.getEditorView();
                if (!editorView || editorView.hasFocus()) return false;
                editorView.focus();
                if ((options === null || options === void 0 ? void 0 : options.scrollIntoView) ?? true) editorView.dispatch(editorView.state.tr.scrollIntoView());
                return true;
            },
            // Code copied from `EditorActions.blur()`
            blur: ()=>{
                const editorView = config === null || config === void 0 ? void 0 : config.getEditorView();
                if (!editorView || !editorView.hasFocus()) return false;
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                editorView.dom.blur();
                return true;
            },
            scrollToPos (pos, scrollOptions) {
                var _editorView$domAtPos;
                const editorView = config === null || config === void 0 ? void 0 : config.getEditorView();
                if (!editorView) return false;
                const tr = editorView.state.tr;
                const isValidPos = typeof pos === 'number' && pos >= 0 && pos <= tr.doc.content.size;
                if (!isValidPos) return false;
                // nodeDOM can return a Text node for inline positions
                const nodeDom = editorView.nodeDOM(pos);
                const dom = (nodeDom instanceof Element ? nodeDom : null) ?? ((_editorView$domAtPos = editorView.domAtPos(pos)) === null || _editorView$domAtPos === void 0 ? void 0 : _editorView$domAtPos.node);
                if (!(dom instanceof Element)) return false;
                dom.scrollIntoView(scrollOptions);
                return true;
            },
            updateAppearance: (newAppearance)=>{
                var _appearancePluginKey$;
                const editorView = config === null || config === void 0 ? void 0 : config.getEditorView();
                if (!editorView) return false;
                // Avoid dispatching a redundant transaction if appearance hasn't changed
                const currentAppearance = (_appearancePluginKey$ = (0, $dpCmG.appearancePluginKey).getState(editorView.state)) === null || _appearancePluginKey$ === void 0 ? void 0 : _appearancePluginKey$.appearance;
                if (currentAppearance === newAppearance) return false;
                const tr = editorView.state.tr.setMeta((0, $dpCmG.appearancePluginKey), {
                    appearance: newAppearance
                });
                tr.setMeta('addToHistory', false);
                editorView.dispatch(tr);
                return true;
            },
            replaceDocument: (replaceValue, options)=>{
                const editorView = config === null || config === void 0 ? void 0 : config.getEditorView();
                if (!editorView || replaceValue === undefined || replaceValue === null) return false;
                const { state: state } = editorView;
                const { schema: schema } = state;
                const content = options !== null && options !== void 0 && options.skipValidation ? (0, $fcrbf.processRawValueWithoutValidation)(schema, replaceValue) : Array.isArray(replaceValue) ? (0, $85mAs.processRawFragmentValue)(schema, replaceValue, undefined, undefined, options === null || options === void 0 ? void 0 : options.transformer) : (0, $fcrbf.processRawValue)(schema, replaceValue, undefined, undefined, options === null || options === void 0 ? void 0 : options.transformer);
                // Don't replace the document if it's the same document, as full size
                // replace transactions cause issues for collaborative editing and
                // content reconciliation (eg. inline comments getting dropped)
                if (content instanceof (0, $kW8qW.Node) && state.doc.eq(content)) return false;
                if (content) {
                    const tr = state.tr.replaceWith(0, state.doc.nodeSize - 2, content);
                    tr.setMeta('replaceDocument', true);
                    if ((options === null || options === void 0 ? void 0 : options.addToHistory) === false) tr.setMeta('addToHistory', false);
                    if ((options === null || options === void 0 ? void 0 : options.scrollIntoView) ?? true) editorView.dispatch(tr.scrollIntoView());
                    else editorView.dispatch(tr.setMeta('scrollIntoView', false));
                    return true;
                }
                return false;
            },
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            requestDocument (onReceive, options) {
                const view = (config === null || config === void 0 ? void 0 : config.getEditorView()) ?? null;
                scheduleDocumentRequest(view, onReceive, options === null || options === void 0 ? void 0 : options.transformer, config === null || config === void 0 ? void 0 : config.fireAnalyticsEvent, options === null || options === void 0 ? void 0 : options.alwaysFire);
            },
            requestDocumentAsync: (options)=>{
                return new Promise((resolve)=>{
                    const view = (config === null || config === void 0 ? void 0 : config.getEditorView()) ?? null;
                    scheduleDocumentRequestNoThrowError(view, (doc)=>{
                        resolve(doc);
                    }, options === null || options === void 0 ? void 0 : options.transformer, config === null || config === void 0 ? void 0 : config.fireAnalyticsEvent, true);
                });
            },
            createTransformer (cb) {
                const view = (config === null || config === void 0 ? void 0 : config.getEditorView()) ?? null;
                if (!(view !== null && view !== void 0 && view.state.schema)) return undefined;
                return cb(view === null || view === void 0 ? void 0 : view.state.schema);
            },
            getAnchorIdForNode (node, pos) {
                const view = (config === null || config === void 0 ? void 0 : config.getEditorView()) ?? null;
                if (!view) return undefined;
                const nodeIdProvider = (0, $l6DJ7.getNodeIdProvider)(view);
                const cachedId = nodeIdProvider.getIdForNode(node);
                if (cachedId) return cachedId;
                if (pos < 0) return undefined;
                // Check DOM first to avoid generating a new ID with a collision suffix
                // when the DOM already has a valid anchor. This prevents misalignment
                // of drag handles on first focus after clicking from the title.
                const nodeDOM = view.nodeDOM(pos);
                if (nodeDOM instanceof HTMLElement) {
                    const domAnchor = nodeDOM.getAttribute('data-node-anchor');
                    if (domAnchor) {
                        // Cache the DOM anchor for this node to maintain consistency
                        // This ensures subsequent calls return the same anchor
                        nodeIdProvider.setIdForNode(node, domAnchor);
                        return domAnchor;
                    }
                }
                // Only generate a new ID if DOM doesn't have one
                const generatedId = nodeIdProvider.getOrGenerateId(node, pos);
                if (generatedId) return generatedId;
                return undefined;
            }
        }
    };
};

});
parcelRegister("l6DJ7", function(module, exports) {
$parcel$export(module.exports, "getNodeIdProvider", () => $9a0a68bcf391e73c$export$753ee9749f6df320);

var $55o0j = parcelRequire("55o0j");

var $5NsjA = parcelRequire("5NsjA");
// The real key stays in `@atlaskit/editor-plugin-limited-mode`; importing it would make
// `editor-common` depend on a plugin package, so match the state property by name.
// `'limitedModePlugin$'` is what ProseMirror derives for `new PluginKey('limitedModePlugin')`,
// and editor-plugin-limited-mode-tests asserts that literal to catch it shifting to `$1`.
// Please, do not copy or use this kind of code below
// @ts-ignore
const $9a0a68bcf391e73c$var$limitedModePluginKey = {
    key: 'limitedModePlugin$',
    getState: (state)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return state['limitedModePlugin$'];
    }
};
class $9a0a68bcf391e73c$export$d6cb5c66663ecf49 {
    constructor(limitedMode = false, emptyDoc = false){
        this.cache = new WeakMap();
        this.count = BigInt(0);
        this.existingPos = new (0, $5NsjA.DynamicBitArray)();
        this.limitedMode = false;
        this.emptyDoc = false;
        this.limitedMode = limitedMode;
        this.emptyDoc = emptyDoc;
    }
    isEmptyDoc() {
        return this.emptyDoc;
    }
    setEmptyDoc(isEmpty) {
        this.emptyDoc = isEmpty;
    }
    isLimitedMode() {
        return this.limitedMode;
    }
    // We use pos to generate unique ids for each node at a specific position
    // This is to ensure the same ADF will always generate the same DOM initially
    getOrGenerateId(node, pos) {
        if (this.limitedMode) return undefined;
        if (this.cache.has(node)) return this.cache.get(node);
        let idSuffix = '';
        if (this.existingPos.get(pos)) idSuffix = `-${(this.count++).toString(36)}`;
        else this.existingPos.set(pos, true);
        const anchorName = `--anchor-${node.type.name}-${pos}${idSuffix}`;
        this.cache.set(node, anchorName);
        return anchorName;
    }
    getIdForNode(node) {
        if (this.limitedMode) return undefined;
        return this.cache.get(node);
    }
    setIdForNode(node, id) {
        if (this.limitedMode) return;
        this.cache.set(node, id);
    }
    // After set to limited mode, we clear the cache to free up memory
    // and prevent further ids from being generated
    // Once in limited mode, we won't exit it
    //
    // One-way by design, so this can stay latched on after the plugin flips back to
    // off: recovering would mean re-rendering every nodeview to restore its anchor.
    setLimitedMode() {
        this.limitedMode = true;
        this.cache = new WeakMap();
        this.existingPos = new (0, $5NsjA.DynamicBitArray)();
        this.count = BigInt(0);
    }
}
const $9a0a68bcf391e73c$var$nodeIdProviderMap = new WeakMap();
/**
 * Reads the limited-mode plugin's state and nothing else, so a preset without the plugin no longer
 * gets anchor suppression (and with it, no drag handles). No plugin means limited mode is off.
 *
 * Read off the state rather than the plugin injection API because plugin `state.init` is the only
 * thing that has run by the time the `EditorView` constructor builds its first nodeview and calls
 * `getNodeIdProvider`. Plugin views and `usePluginHook` both run later.
 */ const $9a0a68bcf391e73c$var$isLimitedModeEnabled = (editorView)=>{
    var _limitedModePluginKey;
    return ((_limitedModePluginKey = $9a0a68bcf391e73c$var$limitedModePluginKey.getState(editorView.state)) === null || _limitedModePluginKey === void 0 ? void 0 : _limitedModePluginKey.documentSizeBreachesThreshold) ?? false;
};
const $9a0a68bcf391e73c$export$753ee9749f6df320 = (editorView)=>{
    if (!$9a0a68bcf391e73c$var$nodeIdProviderMap.has(editorView)) {
        const limitedMode = $9a0a68bcf391e73c$var$isLimitedModeEnabled(editorView);
        const isEmptyDoc = (0, $55o0j.isEmptyDocument)(editorView.state.doc);
        const provider = new $9a0a68bcf391e73c$export$d6cb5c66663ecf49(limitedMode, isEmptyDoc);
        $9a0a68bcf391e73c$var$nodeIdProviderMap.set(editorView, provider);
        return provider;
    }
    const nodeIdProvider = $9a0a68bcf391e73c$var$nodeIdProviderMap.get(editorView);
    // in some cases we need to re-check limited mode state
    // Confluence editor can start with an empty doc and then load content later
    // so we need to check first time from an empty doc to a non-empty doc
    if (nodeIdProvider.isEmptyDoc() && !(0, $55o0j.isEmptyDocument)(editorView.state.doc)) {
        // set empty doc to false regardless of limited mode state
        nodeIdProvider.setEmptyDoc(false);
        if (!nodeIdProvider.isLimitedMode() && $9a0a68bcf391e73c$var$isLimitedModeEnabled(editorView)) nodeIdProvider.setLimitedMode();
    }
    // This is based on the fact that editorView is a singleton.
    return $9a0a68bcf391e73c$var$nodeIdProviderMap.get(editorView);
};

});
parcelRegister("55o0j", function(module, exports) {
$parcel$export(module.exports, "isEmptyDocument", () => $90bf826e8e22f67e$export$2da47a16c0b6bcb);

var $24xJB = parcelRequire("24xJB");
function $90bf826e8e22f67e$export$2da47a16c0b6bcb(node) {
    const nodeChild = node.content.firstChild;
    if (node.childCount !== 1 || !nodeChild) return false;
    return (0, $24xJB.isEmptyParagraph)(nodeChild);
}

});
parcelRegister("24xJB", function(module, exports) {
$parcel$export(module.exports, "isEmptyParagraph", () => $da47bcd190ef8c6c$export$b648602b09795358);
function $da47bcd190ef8c6c$export$b648602b09795358(node) {
    return !!node && node.type.name === 'paragraph' && !node.childCount;
}

});


parcelRegister("5NsjA", function(module, exports) {
$parcel$export(module.exports, "DynamicBitArray", () => $ad619d9d46654029$export$fdc385e5a167108c);
const $ad619d9d46654029$var$DEFAULT_CHUNK_SIZE = 4096; // Default chunk size in bits
class $ad619d9d46654029$export$fdc385e5a167108c {
    constructor(chunkSize = $ad619d9d46654029$var$DEFAULT_CHUNK_SIZE){
        this.chunkSize = chunkSize;
        this.chunkTotalBitSize = this.chunkSize * 8;
        this.bitArrays = [];
    }
    set(index, value) {
        const bitArray = this.getChunk(index);
        const byteOffset = index % this.chunkTotalBitSize;
        const byteIndex = Math.floor(byteOffset / 8); // Get the byte index
        const bitOffset = byteOffset % 8; // Get the bit offset within the byte
        if (value) bitArray[byteIndex] |= 1 << bitOffset; // set the bit
        else bitArray[byteIndex] &= ~(1 << bitOffset); // clear the bit
    }
    get(index) {
        const bitArray = this.getChunk(index);
        const byteOffset = index % this.chunkTotalBitSize;
        const byteIndex = Math.floor(byteOffset / 8); // Get the byte index
        const bitOffset = byteOffset % 8; // Get the bit offset within the byte
        return (bitArray[byteIndex] & 1 << bitOffset) !== 0; // Check if the bit is set
    }
    getChunk(index) {
        const chunkIndex = Math.floor(index / this.chunkTotalBitSize);
        if (!this.bitArrays[chunkIndex]) this.bitArrays[chunkIndex] = new Uint8Array(this.chunkSize);
        return this.bitArrays[chunkIndex];
    }
}

});


parcelRegister("iPR6g", function(module, exports) {
$parcel$export(module.exports, "editorCommandToPMCommand", () => $6619fdb6ae051335$export$bd352a83a17b2af8);

var $8O4hA = parcelRequire("8O4hA");
function $6619fdb6ae051335$export$bd352a83a17b2af8(command) {
    return ({ tr: tr }, dispatch)=>{
        const newTr = command === null || command === void 0 ? void 0 : command({
            tr: tr
        });
        if (!newTr) return false;
        if (newTr instanceof (0, $8O4hA.PassiveTransaction)) return true;
        dispatch === null || dispatch === void 0 || dispatch(newTr);
        return true;
    };
}

});
parcelRegister("8O4hA", function(module, exports) {
$parcel$export(module.exports, "PassiveTransaction", () => $08b1be1f1fd7d375$export$95069e054e554fa9);

var $cw0wu = parcelRequire("cw0wu");
class $08b1be1f1fd7d375$export$95069e054e554fa9 extends (0, $cw0wu.Transaction) {
    // This is very cheeky but this should never be used outside its intended
    // purpose - it will likely crash the editor so we should get an early warning
    // signal
    constructor(){
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        super({});
    }
}

});


parcelRegister("dpCmG", function(module, exports) {
$parcel$export(module.exports, "appearancePluginKey", () => $6167e0649e359f37$export$c701b355a31b2a13);
$parcel$export(module.exports, "createAppearancePlugin", () => $6167e0649e359f37$export$8eb39c7592eeb788);

var $cw0wu = parcelRequire("cw0wu");

var $f7Kk4 = parcelRequire("f7Kk4");
const $6167e0649e359f37$export$c701b355a31b2a13 = new (0, $cw0wu.PluginKey)('appearancePlugin');
const $6167e0649e359f37$var$DEFAULT_APPEARANCE = 'comment';
function $6167e0649e359f37$export$8eb39c7592eeb788(initialAppearance) {
    return new (0, $f7Kk4.SafePlugin)({
        key: $6167e0649e359f37$export$c701b355a31b2a13,
        state: {
            init: ()=>({
                    appearance: initialAppearance ?? $6167e0649e359f37$var$DEFAULT_APPEARANCE
                }),
            apply: (tr, pluginState)=>{
                const meta = tr.getMeta($6167e0649e359f37$export$c701b355a31b2a13);
                if ((meta === null || meta === void 0 ? void 0 : meta.appearance) !== undefined) return {
                    ...pluginState,
                    appearance: meta.appearance
                };
                return pluginState;
            }
        }
    });
}

});
parcelRegister("f7Kk4", function(module, exports) {
$parcel$export(module.exports, "SafePlugin", () => $31ed762e40825269$export$1d44e2741b8f180d);
// oxlint-disable-next-line import/no-duplicates

var $cw0wu = parcelRequire("cw0wu");

var $3y2s4 = parcelRequire("3y2s4");

var $5N1Y4 = parcelRequire("5N1Y4");

var $7lseo = parcelRequire("7lseo");

var $l6DJ7 = parcelRequire("l6DJ7");

var $4G6Rb = parcelRequire("4G6Rb");

var $coj29 = parcelRequire("coj29");
const $31ed762e40825269$export$286bb6e3f51916b5 = ({ nodeOrMark: nodeOrMark, dom: dom, options: options })=>{
    const metadata = (0, $4G6Rb.createProseMirrorMetadata)(nodeOrMark, options);
    Object.entries(metadata).forEach(([name, value])=>{
        dom.setAttribute(name, value);
        if (name === 'data-node-anchor' && ((0, $5N1Y4.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) || (0, $3y2s4.isExperimentEnabled)('platform_editor_block_control_migration'))) {
            // if browser doesn't support CSS anchor, won't need the style
            // Or if it supports CSS attr() function as the value of anchor-name,
            // We won't need set the style
            if (!(0, $coj29.isCSSAnchorSupported)() || (0, $coj29.isCSSAttrAnchorSupported)()) return;
            // otherwise, we set the CSS variable for anchor-name
            dom.style.setProperty((0, $coj29.ANCHOR_VARIABLE_NAME), `${value}`);
            return;
        }
    });
};
/** Type guard to check if a Node is an HTMLElement in a safe way. */ const $31ed762e40825269$var$isHTMLElement = (element)=>{
    if (element === null || element === undefined) return false;
    // In SSR `HTMLElement` is not defined, so we need to use duck typing here
    return 'innerHTML' in element && 'style' in element && 'classList' in element;
};
// Wraper to avoid any exception during the get pos operation
// See this https://hello.atlassian.net/wiki/spaces/EDITOR/pages/2849713193/ED-19672+Extensions+Regression
// And this https://discuss.prosemirror.net/t/possible-bug-on-viewdesc-posbeforechild/5783
const $31ed762e40825269$var$wrapGetPosExceptions = (spec)=>{
    var _spec$props;
    if (!(spec !== null && spec !== void 0 && (_spec$props = spec.props) !== null && _spec$props !== void 0 && _spec$props.nodeViews)) return spec;
    const unsafeNodeViews = spec.props.nodeViews;
    let nodeIdProvider;
    const safeNodeViews = new Proxy(unsafeNodeViews, {
        get (target, prop, receiver) {
            const safeNodeView = new Proxy(Reflect.get(target, prop, receiver), {
                apply (target, thisArg, argumentsList) {
                    const [node, view, unsafeGetPos, ...more] = argumentsList;
                    if (!nodeIdProvider && ((0, $5N1Y4.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) || (0, $3y2s4.isExperimentEnabled)('platform_editor_block_control_migration'))) nodeIdProvider = (0, $l6DJ7.getNodeIdProvider)(view);
                    const safeGetPos = (()=>{
                        try {
                            return unsafeGetPos();
                        } catch (e) {
                            return;
                        }
                    // eslint-disable-next-line no-extra-bind
                    }).bind(thisArg);
                    const result = Reflect.apply(target, thisArg, [
                        node,
                        view,
                        safeGetPos,
                        ...more
                    ]);
                    if ((result === null || result === void 0 ? void 0 : result.dom) instanceof HTMLElement || // SSR result?.dom is not an instance of HTMLElement, but we still want to attach metadata to it
                    (0, $7lseo.isSSR)() && $31ed762e40825269$var$isHTMLElement(result === null || result === void 0 ? void 0 : result.dom)) {
                        var _nodeIdProvider;
                        // we only attach metadata to the dom if its position is known
                        const pos = safeGetPos();
                        const options = pos !== undefined && ((0, $5N1Y4.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) || (0, $3y2s4.isExperimentEnabled)('platform_editor_block_control_migration')) ? {
                            anchrorId: (_nodeIdProvider = nodeIdProvider) === null || _nodeIdProvider === void 0 ? void 0 : _nodeIdProvider.getOrGenerateId(node, pos)
                        } : undefined;
                        $31ed762e40825269$export$286bb6e3f51916b5({
                            nodeOrMark: node,
                            dom: result.dom,
                            options: options
                        });
                    }
                    return result;
                }
            });
            return safeNodeView;
        }
    });
    spec.props.nodeViews = safeNodeViews;
    return spec;
};
class $31ed762e40825269$export$1d44e2741b8f180d extends (0, $cw0wu.Plugin) {
    constructor(spec){
        super($31ed762e40825269$var$wrapGetPosExceptions(spec));
    }
}

});
parcelRegister("4G6Rb", function(module, exports) {
$parcel$export(module.exports, "createProseMirrorMetadata", () => $0cd1ba6acc1fd563$export$3d8be158d19aadd1);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $kW8qW = parcelRequire("kW8qW");

var $3y2s4 = parcelRequire("3y2s4");

var $5N1Y4 = parcelRequire("5N1Y4");
const $0cd1ba6acc1fd563$var$isPMNode = (nodeOrMark)=>{
    return nodeOrMark instanceof (0, $kW8qW.Node) || Array.isArray(nodeOrMark.marks);
};
const $0cd1ba6acc1fd563$export$3d8be158d19aadd1 = (nodeOrMark, options)=>{
    const name = nodeOrMark.type.name;
    const isNode = $0cd1ba6acc1fd563$var$isPMNode(nodeOrMark);
    const commonAttributes = {
        'data-prosemirror-content-type': isNode ? 'node' : 'mark'
    };
    if (!isNode) return {
        ...commonAttributes,
        ['data-prosemirror-mark-name']: name
    };
    commonAttributes['data-prosemirror-node-name'] = name;
    if (nodeOrMark.type.isBlock) commonAttributes['data-prosemirror-node-block'] = 'true';
    if (nodeOrMark.type.isInline) commonAttributes['data-prosemirror-node-inline'] = 'true';
    if ((options === null || options === void 0 ? void 0 : options.anchrorId) !== undefined && ((0, $5N1Y4.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) || (0, $3y2s4.isExperimentEnabled)('platform_editor_block_control_migration'))) commonAttributes['data-node-anchor'] = options.anchrorId;
    return commonAttributes;
};

});

parcelRegister("coj29", function(module, exports) {
$parcel$export(module.exports, "ANCHOR_VARIABLE_NAME", () => $b36e6bc5d5e05d08$export$ef134ee0b603ec88);
$parcel$export(module.exports, "isCSSAttrAnchorSupported", () => $b36e6bc5d5e05d08$export$98ea10c5c22b6d19);
$parcel$export(module.exports, "isCSSAnchorSupported", () => $b36e6bc5d5e05d08$export$e43af301b4191f);
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9dQre = parcelRequire("9dQre");

var $57l7A = parcelRequire("57l7A");
const $b36e6bc5d5e05d08$export$ef134ee0b603ec88 = '--ed-pm-node-anchor';
const $b36e6bc5d5e05d08$var$hasCssSupport = (0, $57l7A.default)(()=>{
    if (typeof window !== 'undefined' && window.CSS && typeof window.CSS.supports === 'function') return true;
    return false;
});
const $b36e6bc5d5e05d08$export$98ea10c5c22b6d19 = (0, $57l7A.default)(()=>{
    if ($b36e6bc5d5e05d08$var$hasCssSupport()) return CSS.supports('anchor-name', 'attr(data-anchor-name type(<custom-ident>))');
    return false;
});
const $b36e6bc5d5e05d08$export$e43af301b4191f = (0, $57l7A.default)(()=>{
    if ($b36e6bc5d5e05d08$var$hasCssSupport()) return CSS.supports('anchor-name', '--anchor');
});
const $b36e6bc5d5e05d08$export$abca45c45e682c01 = /*#__PURE__*/ (0, $9dQre.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.ProseMirror': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '[data-node-anchor]': {
            anchorName: `var(${$b36e6bc5d5e05d08$export$ef134ee0b603ec88}, attr(data-node-anchor type(<custom-ident>)))`
        }
    }
});

});



parcelRegister("jPcm5", function(module, exports) {
$parcel$export(module.exports, "createThrottleSchedule", () => $972ec28b9a7d4714$export$6a1dd68d75badcc7);
$parcel$export(module.exports, "returnDocumentRequest", () => $972ec28b9a7d4714$export$dce79649e5264171);
$parcel$export(module.exports, "returnDocumentRequestNoThrowError", () => $972ec28b9a7d4714$export$840661c1d4051b37);

var $c6WhP = parcelRequire("c6WhP");

var $kW8qW = parcelRequire("kW8qW");

var $gdUUy = parcelRequire("gdUUy");

var $g6Qq4 = parcelRequire("g6Qq4");
const $972ec28b9a7d4714$var$transformer = new (0, $c6WhP.JSONTransformer)();
function $972ec28b9a7d4714$export$54fd2c36b5cc6731(node) {
    return $972ec28b9a7d4714$var$transformer.encode(node);
}
function $972ec28b9a7d4714$export$6a1dd68d75badcc7(callback) {
    let frameId;
    let lastArgs;
    const delayedCallbacks = [];
    const wrapperFn = (...args)=>{
        const lastArgsBefore = lastArgs;
        lastArgs = args;
        if (frameId) {
            if (lastArgsBefore) {
                const [_v, _c, _t, _f, alwaysFire] = lastArgsBefore;
                if (alwaysFire) delayedCallbacks.push(lastArgsBefore);
            }
            return;
        }
        // If `requestIdleCallback` doesn't exist - fallback to `requestAnimationFrame`
        const delayFunction = globalThis.requestIdleCallback ?? globalThis.requestAnimationFrame;
        frameId = delayFunction(()=>{
            frameId = undefined;
            if (lastArgs) {
                delayedCallbacks.forEach((savedArgs)=>{
                    callback(...savedArgs);
                });
                callback(...lastArgs);
            }
        }, {
            timeout: 100
        });
    };
    return wrapperFn;
}
function $972ec28b9a7d4714$export$dce79649e5264171(editorView, callback, transformer, fireAnalyticsEvent, _alwaysFire) {
    const { doc: doc, schema: schema } = (editorView === null || editorView === void 0 ? void 0 : editorView.state) ?? {};
    if (!doc || !schema) {
        if ((0, $gdUUy.fg)('platform_editor_resolve_missing_document_request')) // Notify callers that no document is available.
        // Async requests rely on this callback to settle their promise.
        callback(undefined);
        return undefined;
    }
    try {
        const json = $972ec28b9a7d4714$export$54fd2c36b5cc6731(doc);
        if (typeof transformer === 'undefined') callback(json);
        else {
            const nodeSanitized = (0, $kW8qW.Node).fromJSON(schema, json);
            callback(transformer.encode(nodeSanitized));
        }
    } catch (e) {
        fireAnalyticsEvent === null || fireAnalyticsEvent === void 0 || fireAnalyticsEvent({
            payload: {
                action: (0, $g6Qq4.ACTION).DOCUMENT_PROCESSING_ERROR,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).EDITOR,
                eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    errorMessage: `${e instanceof Error && e.name === 'NodeNestingTransformError' ? 'NodeNestingTransformError - Failed to transform one or more nested tables' : undefined}`
                }
            }
        });
        throw e;
    }
}
function $972ec28b9a7d4714$export$840661c1d4051b37(editorView, callback, transformer, fireAnalyticsEvent, _alwaysFire) {
    try {
        return $972ec28b9a7d4714$export$dce79649e5264171(editorView, callback, transformer, fireAnalyticsEvent, _alwaysFire);
    } catch  {
        callback(undefined);
    }
}

});



parcelRegister("3nkOX", function(module, exports) {
$parcel$export(module.exports, "profileSSROperation", () => $a30d9d0a5bcd124c$export$69bfe89b2a668d26);

var $7lseo = parcelRequire("7lseo");
const $a30d9d0a5bcd124c$var$profileSSROperationImpl = (segmentName, fn, onSSRMeasure)=>{
    if (!onSSRMeasure) return fn();
    const startTimestamp = performance.now();
    try {
        return fn();
    } finally{
        onSSRMeasure({
            segmentName: segmentName,
            startTimestamp: startTimestamp,
            endTimestamp: performance.now()
        });
    }
};
const $a30d9d0a5bcd124c$var$profileSSROperationNoOp = (_segmentName, fn, _onSSRMeasure)=>{
    return fn();
};
const $a30d9d0a5bcd124c$export$69bfe89b2a668d26 = (0, $7lseo.isSSR)() ? $a30d9d0a5bcd124c$var$profileSSROperationImpl : $a30d9d0a5bcd124c$var$profileSSROperationNoOp;

});

parcelRegister("jC0lZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $7c25b3e4c5feac43$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");
const $7c25b3e4c5feac43$var$ReactEditorViewContext = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createContext({});
var $7c25b3e4c5feac43$export$2e2bcd8739ae039 = $7c25b3e4c5feac43$var$ReactEditorViewContext;

});

parcelRegister("19de6", function(module, exports) {
$parcel$export(module.exports, "default", () => $678e18c89e9c5572$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");
function $678e18c89e9c5572$export$2e2bcd8739ae039(callback) {
    const hasRun = (0, $bSJIT.useRef)(false);
    if (!hasRun.current) {
        callback();
        hasRun.current = true;
    }
}

});

parcelRegister("b2855", function(module, exports) {
$parcel$export(module.exports, "default", () => $9698d372534251d6$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");
function $9698d372534251d6$export$2e2bcd8739ae039(value, initialValue) {
    const ref = (0, $bSJIT.useRef)(initialValue);
    (0, $bSJIT.useEffect)(()=>{
        // Setting the value to ref.current inside an effect, or otherwise the behaviour in staging/prod doesn't match with local
        // In local, the double rendering in react dev mode causes the previous value to be the same as next value immediately after
        // In prod and staging, double rendering is not done since that is a react prod build
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}

});

parcelRegister("iFBOP", function(module, exports) {
$parcel$export(module.exports, "createSSREditorState", () => $29dc87523092b3fd$export$d5371f6840b6acde);

var $cw0wu = parcelRequire("cw0wu");
function $29dc87523092b3fd$export$d5371f6840b6acde({ pmPlugins: pmPlugins, schema: schema, doc: doc }) {
    return (0, $cw0wu.EditorState).create({
        doc: doc,
        schema: schema,
        plugins: pmPlugins
    });
}

});

parcelRegister("i2dSN", function(module, exports) {
$parcel$export(module.exports, "createSSRPMPlugins", () => $f64d949781b0be87$export$5dd8b2dbd9647c38);

var $eXGEf = parcelRequire("eXGEf");

var $5zxDU = parcelRequire("5zxDU");
class $f64d949781b0be87$var$SSREventDispatcher extends (0, $eXGEf.EventDispatcher) {
    emit() {
    // Don't notify about events in SSR
    }
}
function $f64d949781b0be87$export$5dd8b2dbd9647c38({ plugins: plugins, schema: schema, portalProviderAPI: portalProviderAPI, getIntl: getIntl }) {
    const eventDispatcher = new $f64d949781b0be87$var$SSREventDispatcher();
    const providerFactory = new (0, $5zxDU.default)();
    const pmPluginFactoryParams = {
        dispatch: (0, $eXGEf.createDispatch)(eventDispatcher),
        dispatchAnalyticsEvent: ()=>{},
        eventDispatcher: eventDispatcher,
        featureFlags: {},
        getIntl: getIntl,
        portalProviderAPI: portalProviderAPI,
        nodeViewPortalProviderAPI: portalProviderAPI,
        providerFactory: providerFactory,
        schema: schema
    };
    return plugins.reduce((acc, editorPlugin)=>{
        var _editorPlugin$pmPlugi;
        (_editorPlugin$pmPlugi = editorPlugin.pmPlugins) === null || _editorPlugin$pmPlugi === void 0 || _editorPlugin$pmPlugi.call(editorPlugin).forEach(({ plugin: plugin })=>{
            try {
                const pmPlugin = plugin(pmPluginFactoryParams);
                if (pmPlugin) acc.push(pmPlugin);
            } catch (error) {}
        });
        return acc;
    }, []);
}

});

parcelRegister("4xobD", function(module, exports) {
$parcel$export(module.exports, "EditorSSRRenderer", () => $50361baa497f56d3$export$8d417ec112d5c31c);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $3nkOX = parcelRequire("3nkOX");

var $6BIjC = parcelRequire("6BIjC");

var $kW8qW = parcelRequire("kW8qW");

var $a3b9P = parcelRequire("a3b9P");

var $iFBOP = parcelRequire("iFBOP");

var $i2dSN = parcelRequire("i2dSN");
const $50361baa497f56d3$var$SSR_TRACE_SEGMENT_NAME = 'reactEditorView/editorSSRRenderer';
/**
 * A lightweight EditorView implementation for SSR environments.
 *
 * It's kind of aggressive right now, we need to test and see how it works.
 * Probably, we will need to implement more methods/properties in the future.
 *
 * If it doesn't work, we can extend `EditorView` directly instead of implementing `Partial<EditorView>`,
 * but it will perform some DOM operation during the construction.
 */ class $50361baa497f56d3$var$SSREditorView {
    update() {
    // No-op in SSR
    }
    setProps() {
    // No-op in SSR
    }
    dispatchEvent() {
    // No-op in SSR
    }
    dispatch() {
    // No-op in SSR
    }
    hasFocus() {
        return false;
    }
    focus() {
    // No-op in SSR
    }
    updateRoot() {
    // No-op in SSR
    }
    posAtCoords() {
        return null;
    }
    coordsAtPos() {
        return {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
        };
    }
    domAtPos() {
        return {
            node: this.root,
            offset: 0
        };
    }
    nodeDOM() {
        return null;
    }
    posAtDOM() {
        return 0;
    }
    endOfTextblock() {
        return false;
    }
    pasteHTML() {
        return false;
    }
    pasteText() {
        return false;
    }
    destroy() {
    // No-op in SSR
    }
    updateState() {
    // No-op in SSR
    }
    someProp() {
        return undefined;
    }
    serializeForClipboard(slice) {
        // No-op in SSR - clipboard operations are not supported
        return {
            dom: document.createElement('div'),
            text: '',
            slice: slice
        };
    }
    constructor(place, props){
        this.state = props.state;
        this.dom = document.createElement('div');
        this.editable = true;
        this.dragging = null;
        this.composing = false;
        this.props = props;
        this.root = document;
        this.isDestroyed = false;
    }
}
function $50361baa497f56d3$export$8d417ec112d5c31c({ plugins: plugins, schema: schema, doc: doc, portalProviderAPI: portalProviderAPI, intl: intl, onSSRMeasure: onSSRMeasure, onEditorStateChanged: onEditorStateChanged, prebuiltPMPlugins: prebuiltPMPlugins, prebuiltEditorState: prebuiltEditorState, ...divProps }) {
    // Should be always the first statement in the component
    const firstRenderStartTimestampRef = (0, $bSJIT.useRef)(performance.now());
    // PMPluginFactoryParams use `getIntl` function to get current intl instance,
    // so we don't need to add `intl` as a dependency to `useMemo`.
    // We will store intl in ref and access to it dynamically in `getIntl` function call.
    const intlRef = (0, $bSJIT.useRef)(intl);
    intlRef.current = intl;
    const pmPlugins = (0, $bSJIT.useMemo)(()=>{
        if (prebuiltPMPlugins) return prebuiltPMPlugins;
        return (0, $3nkOX.profileSSROperation)(`${$50361baa497f56d3$var$SSR_TRACE_SEGMENT_NAME}/createPMPlugins`, ()=>(0, $i2dSN.createSSRPMPlugins)({
                plugins: plugins,
                schema: schema,
                portalProviderAPI: portalProviderAPI,
                getIntl: ()=>intlRef.current
            }), onSSRMeasure);
    }, [
        plugins,
        portalProviderAPI,
        schema,
        onSSRMeasure,
        prebuiltPMPlugins
    ]);
    const nodeViews = (0, $bSJIT.useMemo)(()=>{
        return pmPlugins.reduce((acc, plugin)=>{
            return Object.assign(acc, plugin.props.nodeViews);
        }, {});
    }, [
        pmPlugins
    ]);
    const markViews = (0, $bSJIT.useMemo)(()=>{
        return pmPlugins.reduce((acc, plugin)=>{
            return Object.assign(acc, plugin.props.markViews);
        }, {});
    }, [
        pmPlugins
    ]);
    const editorState = (0, $bSJIT.useMemo)(()=>{
        if (prebuiltEditorState) return prebuiltEditorState;
        return (0, $3nkOX.profileSSROperation)(`${$50361baa497f56d3$var$SSR_TRACE_SEGMENT_NAME}/createSSREditorState`, ()=>(0, $iFBOP.createSSREditorState)({
                doc: doc,
                schema: schema,
                pmPlugins: pmPlugins
            }), onSSRMeasure);
    }, [
        doc,
        pmPlugins,
        schema,
        onSSRMeasure,
        prebuiltEditorState
    ]);
    // In React 19 could be replaced by `useEffectEvent` hook.
    const onEditorStateChangedRef = (0, $bSJIT.useRef)(onEditorStateChanged);
    onEditorStateChangedRef.current = onEditorStateChanged;
    (0, $bSJIT.useLayoutEffect)(()=>{
        var _onEditorStateChanged;
        (_onEditorStateChanged = onEditorStateChangedRef.current) === null || _onEditorStateChanged === void 0 || _onEditorStateChanged.call(onEditorStateChangedRef, editorState);
    }, [
        editorState
    ]);
    const editorView = (0, $bSJIT.useMemo)(()=>{
        return new $50361baa497f56d3$var$SSREditorView(null, {
            state: editorState
        });
    }, [
        editorState
    ]);
    const { serializer: serializer, nodePositions: nodePositions } = (0, $bSJIT.useMemo)(()=>{
        const createSerializerAndNodePositions = ()=>{
            const nodePositions = new WeakMap();
            // ProseMirror View adds <br class="ProseMirror-trailingBreak" /> to empty nodes. Because we are using
            // DOMSerializer, we should simulate the same behaviour to get the same HTML document.
            //
            // There are a lot of conditions that check for adding `<br />` but we could implement only the case when we
            // are adding `<br />` to empty texblock, because if we add `<br />` in other cases it will change order of DOM nodes inside
            // this node (`<br />`) will be the first, after will be other nodes. It's because we are adding `<br />` to root node before
            // we are rendering child node.
            //
            // See: https://discuss.prosemirror.net/t/where-can-i-read-about-prosemirror-trailingbreak/6665
            // See: https://github.com/ProseMirror/prosemirror-view/blob/76c7c47f03730b18397b94bd269ece8a9cb7f486/src/viewdesc.ts#L803
            // See: https://github.com/ProseMirror/prosemirror-view/blob/76c7c47f03730b18397b94bd269ece8a9cb7f486/src/viewdesc.ts#L1365
            const addTrailingBreakIfNeeded = (node, contentDOM)=>{
                if (contentDOM && node.isTextblock && !node.lastChild) {
                    const br = document.createElement('br');
                    br.classList.add('ProseMirror-trailingBreak');
                    contentDOM.appendChild(br);
                }
            };
            const toDomNodeRenderers = Object.fromEntries(Object.entries(schema.nodes).map(([nodeName, nodeType])=>{
                return [
                    nodeName,
                    nodeType.spec.toDOM
                ];
            }).filter(([, toDOM])=>!!toDOM));
            const toDomMarkRenderers = Object.fromEntries(Object.entries(schema.marks).map(([markName, markType])=>{
                return [
                    markName,
                    markType.spec.toDOM
                ];
            }).filter(([, toDOM])=>!!toDOM));
            const nodeViewRenderers = Object.fromEntries(Object.entries(nodeViews).map(([nodeName, nodeViewFactory])=>{
                return [
                    nodeName,
                    (node)=>{
                        try {
                            const nodeViewInstance = nodeViewFactory(node, editorView, ()=>nodePositions.get(node) ?? 0, [], (0, $a3b9P.DecorationSet).create(node, []));
                            addTrailingBreakIfNeeded(node, nodeViewInstance.contentDOM);
                            return {
                                dom: nodeViewInstance.dom,
                                // Leaf nodes have no content, ProseMirror will throw an error if we pass contentDOM
                                contentDOM: node.isLeaf ? undefined : nodeViewInstance.contentDOM
                            };
                        } catch (error) {
                            var _schema$nodes$nodeNam;
                            // Fall back to schema-level toDOM for this node
                            const toDOM = (_schema$nodes$nodeNam = schema.nodes[nodeName]) === null || _schema$nodes$nodeNam === void 0 ? void 0 : _schema$nodes$nodeNam.spec.toDOM;
                            if (toDOM) return (0, $kW8qW.DOMSerializer).renderSpec(document, toDOM(node));
                            // Last resort: empty div
                            return {
                                dom: document.createElement('div')
                            };
                        }
                    }
                ];
            }));
            // Create renderers for textblock nodes that don't have custom NodeViews (e.g. paragraph, heading)
            const textblockRenderers = Object.fromEntries(Object.entries(schema.nodes).filter(([nodeName, nodeType])=>{
                // Only handle textblock nodes
                return nodeType.spec.toDOM && nodeType.isTextblock && !nodeViews[nodeName];
            }).map(([nodeName, nodeType])=>{
                const toDOM = nodeType.spec.toDOM;
                if (!toDOM) return [
                    nodeName,
                    undefined
                ];
                return [
                    nodeName,
                    (node)=>{
                        if (!node.lastChild) {
                            const result = (0, $kW8qW.DOMSerializer).renderSpec(document, toDOM(node));
                            addTrailingBreakIfNeeded(node, result.contentDOM);
                            return result;
                        }
                        return toDOM(node);
                    }
                ];
            }).filter(([, renderer])=>!!renderer));
            const markViewRenderers = Object.fromEntries(Object.entries(markViews).map(([markName, markViewFactory])=>{
                return [
                    markName,
                    (mark)=>{
                        const markViewInstance = markViewFactory(mark, editorView, false);
                        return {
                            dom: markViewInstance.dom,
                            contentDOM: markViewInstance.contentDOM
                        };
                    }
                ];
            }));
            const serializer = new (0, $kW8qW.DOMSerializer)({
                ...toDomNodeRenderers,
                ...textblockRenderers,
                ...nodeViewRenderers,
                text: $50361baa497f56d3$var$renderText
            }, {
                ...toDomMarkRenderers,
                ...markViewRenderers
            });
            return {
                serializer: serializer,
                nodePositions: nodePositions
            };
        };
        return (0, $3nkOX.profileSSROperation)(`${$50361baa497f56d3$var$SSR_TRACE_SEGMENT_NAME}/createSerializerAndNodePositions`, createSerializerAndNodePositions, onSSRMeasure);
    }, [
        editorView,
        markViews,
        nodeViews,
        schema.marks,
        schema.nodes,
        onSSRMeasure
    ]);
    const editorHTML = (0, $bSJIT.useMemo)(()=>{
        const serializeFragment = ()=>{
            if (!doc) return undefined;
            doc.descendants((node, pos)=>{
                nodePositions.set(node, pos);
            });
            const fragment = serializer.serializeFragment(doc.content);
            const wrapper = document.createElement('div');
            wrapper.appendChild(fragment);
            return wrapper.innerHTML;
        };
        try {
            return (0, $3nkOX.profileSSROperation)(`${$50361baa497f56d3$var$SSR_TRACE_SEGMENT_NAME}/serializeFragment`, serializeFragment, onSSRMeasure);
        } catch (error) {
            return undefined;
        }
    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-usememo-deps -- Ignored via go/ees017 (to be fixed)
    }, [
        doc,
        serializer,
        nodePositions,
        onSSRMeasure
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $6BIjC.SSRRenderMeasure), {
        segmentName: $50361baa497f56d3$var$SSR_TRACE_SEGMENT_NAME,
        startTimestampRef: firstRenderStartTimestampRef,
        onSSRMeasure: onSSRMeasure,
        children: /*#__PURE__*/ (0, $dc70d.jsx)("div", {
            id: divProps.id,
            // eslint-disable-next-line react/no-danger -- It's intentional by design
            dangerouslySetInnerHTML: typeof editorHTML === 'string' ? {
                __html: editorHTML
            } : undefined,
            // For some reason on SSR, the result `class` has a trailing space, that broke UFO,
            // because ReactEditorView produces a div with `class` without space.
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: divProps.className.trim(),
            "aria-label": divProps['aria-label'],
            "aria-describedby": divProps['aria-describedby'],
            ...divProps['aria-readonly'] === 'true' ? {
                'aria-readonly': 'true'
            } : {},
            "data-editor-id": divProps['data-editor-id'],
            "data-vc-ignore-if-no-layout-shift": true,
            "data-ssr-placeholder": "editor-view",
            "data-ssr-placeholder-replace": "editor-view",
            "aria-multiline": true,
            role: "textbox",
            // @ts-expect-error - contenteditable is not exist in div attributes
            contenteditable: "true",
            "data-gramm": "false",
            translate: "no"
        })
    });
}
function $50361baa497f56d3$var$renderText(node) {
    return node.text || '';
}

});

parcelRegister("WJeIw", function(module, exports) {
$parcel$export(module.exports, "useProviders", () => $ef3d7cd9f55a264f$export$e4c19534640d7866);

var $bSJIT = parcelRequire("bSJIT");
const $ef3d7cd9f55a264f$export$e4c19534640d7866 = ({ editorApi: editorApi, contextIdentifierProvider: contextIdentifierProvider, mediaProvider: mediaProvider, mentionProvider: mentionProvider, cardProvider: cardProvider, emojiProvider: emojiProvider, autoformattingProvider: autoformattingProvider, taskDecisionProvider: taskDecisionProvider })=>{
    (0, $bSJIT.useEffect)(()=>{
        async function setProvider() {
            var _editorApi$core, _editorApi$contextIde;
            if (!contextIdentifierProvider) return;
            const provider = await contextIdentifierProvider;
            editorApi === null || editorApi === void 0 || (_editorApi$core = editorApi.core) === null || _editorApi$core === void 0 || _editorApi$core.actions.execute(editorApi === null || editorApi === void 0 || (_editorApi$contextIde = editorApi.contextIdentifier) === null || _editorApi$contextIde === void 0 ? void 0 : _editorApi$contextIde.commands.setProvider({
                contextIdentifierProvider: provider
            }));
        }
        setProvider();
    }, [
        contextIdentifierProvider,
        editorApi
    ]);
    (0, $bSJIT.useEffect)(()=>{
        if (mediaProvider) {
            var _editorApi$media;
            editorApi === null || editorApi === void 0 || (_editorApi$media = editorApi.media) === null || _editorApi$media === void 0 || _editorApi$media.actions.setProvider(mediaProvider);
        }
    }, [
        mediaProvider,
        editorApi
    ]);
    (0, $bSJIT.useEffect)(()=>{
        if (mentionProvider) {
            var _editorApi$mention;
            editorApi === null || editorApi === void 0 || (_editorApi$mention = editorApi.mention) === null || _editorApi$mention === void 0 || _editorApi$mention.actions.setProvider(mentionProvider);
        }
    }, [
        mentionProvider,
        editorApi
    ]);
    (0, $bSJIT.useEffect)(()=>{
        if (cardProvider) {
            var _editorApi$card;
            editorApi === null || editorApi === void 0 || (_editorApi$card = editorApi.card) === null || _editorApi$card === void 0 || _editorApi$card.actions.setProvider(cardProvider);
        }
    }, [
        cardProvider,
        editorApi
    ]);
    (0, $bSJIT.useEffect)(()=>{
        if (emojiProvider) {
            var _editorApi$emoji;
            editorApi === null || editorApi === void 0 || (_editorApi$emoji = editorApi.emoji) === null || _editorApi$emoji === void 0 || _editorApi$emoji.actions.setProvider(emojiProvider);
        }
    }, [
        emojiProvider,
        editorApi
    ]);
    (0, $bSJIT.useEffect)(()=>{
        if (autoformattingProvider) {
            var _editorApi$customAuto;
            editorApi === null || editorApi === void 0 || (_editorApi$customAuto = editorApi.customAutoformat) === null || _editorApi$customAuto === void 0 || _editorApi$customAuto.actions.setProvider(autoformattingProvider);
        }
    }, [
        autoformattingProvider,
        editorApi
    ]);
    (0, $bSJIT.useEffect)(()=>{
        if (taskDecisionProvider) {
            var _editorApi$taskDecisi;
            editorApi === null || editorApi === void 0 || (_editorApi$taskDecisi = editorApi.taskDecision) === null || _editorApi$taskDecisi === void 0 || _editorApi$taskDecisi.actions.setProvider(taskDecisionProvider);
        }
    }, [
        taskDecisionProvider,
        editorApi
    ]);
};

});

parcelRegister("5NvK0", function(module, exports) {
$parcel$export(module.exports, "getEditorDomSize", () => $a38cad4e6d28d3d9$export$2b8873b73f502810);
function $a38cad4e6d28d3d9$export$2b8873b73f502810(view) {
    return view.dom.getElementsByTagName('*').length;
}

});

parcelRegister("2QkW9", function(module, exports) {
$parcel$export(module.exports, "getNodesCountWithExtensionKeys", () => $9a4ce7550e2ff09a$export$af7be2186992199);
function $9a4ce7550e2ff09a$export$af7be2186992199(node) {
    const nodes = {};
    const extensionKeys = {};
    const extensionNodeNames = [
        'extension',
        'bodiedExtension',
        'inlineExtension',
        'multiBodiedExtension'
    ];
    node.nodesBetween(0, node.nodeSize - 2, (currentNode)=>{
        var _currentNode$attrs;
        nodes[currentNode.type.name] = (nodes[currentNode.type.name] || 0) + 1;
        if (!extensionNodeNames.includes(currentNode.type.name)) return;
        const extensionKey = (_currentNode$attrs = currentNode.attrs) === null || _currentNode$attrs === void 0 ? void 0 : _currentNode$attrs.extensionKey;
        if (!extensionKey) return;
        extensionKeys[extensionKey] = (extensionKeys[extensionKey] || 0) + 1;
    });
    return {
        nodes: nodes,
        extensionKeys: extensionKeys
    };
}

});

parcelRegister("XkmhM", function(module, exports) {
$parcel$export(module.exports, "getNodesVisibleInViewport", () => $5d4e65765aa22ab9$export$f20e3cf045904cb);

var $iCovX = parcelRequire("iCovX");
const $5d4e65765aa22ab9$export$f20e3cf045904cb = (editorDom)=>{
    const MAX_NODES_TO_COUNT = 200;
    const pmNodesList = editorDom.querySelectorAll('[data-prosemirror-node-name]');
    const nodesTypeCounter = {};
    for(let i = 0; i < Math.min(MAX_NODES_TO_COUNT, pmNodesList.length); i++){
        const node = pmNodesList[i];
        const type = node.getAttribute('data-prosemirror-node-name');
        // No valid prosemirrornode type, skip.
        if (!type) continue;
        const isVisible = (0, $iCovX.isNodeVisible)(node);
        // Not a visible node, end counting.
        if (!isVisible) break;
        nodesTypeCounter[type] = (nodesTypeCounter[type] || 0) + 1;
    }
    return nodesTypeCounter;
};

});
parcelRegister("iCovX", function(module, exports) {
$parcel$export(module.exports, "isNodeVisible", () => $acc26cbbaed34a10$export$9c8a351faafa8fbb);
/**
 * Check if a DOM element is visible within the viewport. We deem a node visible if the top left corner coordinate is within the viewport.
 * This may not look visible, and may include a node that looks below the fold – but it's more than 0 pixels within the viewport.
 */ const $acc26cbbaed34a10$export$9c8a351faafa8fbb = (node)=>{
    const rect = node.getBoundingClientRect();
    const isVisible = rect.x >= 0 && rect.x < window.innerWidth && rect.y >= 0 && rect.y < window.innerHeight;
    return isVisible;
};

});


parcelRegister("83Zt1", function(module, exports) {
$parcel$export(module.exports, "isChromeless", () => $d94c861b5ad9dbd2$export$73ae01d857526945);
function $d94c861b5ad9dbd2$export$73ae01d857526945(appearance) {
    return appearance === 'chromeless';
}

});

parcelRegister("dh4YA", function(module, exports) {
$parcel$export(module.exports, "RenderTracking", () => $cb2fa4fd953f51fd$export$fe16de086fea1f5f);

var $bSJIT = parcelRequire("bSJIT");

var $inh7J = parcelRequire("inh7J");

var $g6Qq4 = parcelRequire("g6Qq4");

var $fjuP7 = parcelRequire("fjuP7");
function $cb2fa4fd953f51fd$export$fe16de086fea1f5f(props) {
    const debouncedHandleAnalyticsEvent = (0, $bSJIT.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($inh7J)))(props.handleAnalyticsEvent, 500), [
        props.handleAnalyticsEvent
    ]);
    (0, $fjuP7.useComponentRenderTracking)({
        onRender: ({ renderCount: renderCount, propsDifference: propsDifference })=>{
            if (!renderCount) return;
            debouncedHandleAnalyticsEvent({
                payload: {
                    action: props.action,
                    actionSubject: props.actionSubject,
                    attributes: {
                        count: renderCount,
                        propsDifference: propsDifference
                    },
                    eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL
                }
            });
        },
        propsDiffingOptions: {
            enabled: true,
            props: props.componentProps,
            propsToIgnore: props.propsToIgnore,
            useShallow: props.useShallow
        },
        zeroBasedCount: true
    });
    return null;
}

});
parcelRegister("fjuP7", function(module, exports) {
$parcel$export(module.exports, "useComponentRenderTracking", () => $d9279cdd7bbda274$export$ebce6d7d8ca67353);

var $bSJIT = parcelRequire("bSJIT");

var $7RHfd = parcelRequire("7RHfd");

var $7RKgO = parcelRequire("7RKgO");
function $d9279cdd7bbda274$export$ebce6d7d8ca67353({ onRender: onRender, propsDiffingOptions: propsDiffingOptions, zeroBasedCount: zeroBasedCount = true }) {
    const propsRef = (0, $bSJIT.useRef)();
    const renderCountRef = (0, $bSJIT.useRef)(zeroBasedCount ? 0 : 1);
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const { current: componentId } = (0, $bSJIT.useRef)((0, $7RHfd.default)());
    (0, $bSJIT.useEffect)(()=>{
        const lastProps = propsRef.current;
        const renderCount = renderCountRef.current;
        let propsDifference;
        if (propsDiffingOptions !== null && propsDiffingOptions !== void 0 && propsDiffingOptions.enabled && lastProps) propsDifference = propsDiffingOptions !== null && propsDiffingOptions !== void 0 && propsDiffingOptions.useShallow ? (0, $7RKgO.getShallowPropsDifference)(lastProps, propsDiffingOptions.props) : (0, $7RKgO.getPropsDifference)(lastProps, propsDiffingOptions.props, 0, 2, propsDiffingOptions === null || propsDiffingOptions === void 0 ? void 0 : propsDiffingOptions.propsToIgnore);
        const result = {
            renderCount: renderCount,
            propsDifference: propsDifference,
            componentId: componentId
        };
        onRender(result);
        if (propsDiffingOptions !== null && propsDiffingOptions !== void 0 && propsDiffingOptions.enabled) propsRef.current = propsDiffingOptions.props;
        renderCountRef.current = renderCountRef.current + 1;
    }); // No dependencies run on each render
}

});
parcelRegister("7RKgO", function(module, exports) {
$parcel$export(module.exports, "getPropsDifference", () => $087692cba489a55d$export$d438af18e3a25d10);
$parcel$export(module.exports, "getShallowPropsDifference", () => $087692cba489a55d$export$418b0a935c0a0030);

var $bSJIT = parcelRequire("bSJIT");

var $84zAO = parcelRequire("84zAO");

var $btdka = parcelRequire("btdka");
const $087692cba489a55d$export$aedd1a2d18cbf42b = (object1, object2)=>{
    const oldKeys = object1 !== null ? (0, $84zAO.getKeys)(object1) : [];
    const newKeys = object2 !== null ? (0, $84zAO.getKeys)(object2) : [];
    const removed = oldKeys.filter((key)=>!newKeys.includes(key));
    const added = newKeys.filter((key)=>!oldKeys.includes(key));
    const common = oldKeys.filter((key)=>newKeys.includes(key));
    return {
        added: added,
        common: common,
        removed: removed
    };
};
const $087692cba489a55d$export$d438af18e3a25d10 = (object1, object2, curDepth = 0, maxDepth = 2, keysToIgnore = [])=>{
    const { added: added, common: common, removed: removed } = $087692cba489a55d$export$aedd1a2d18cbf42b(object1, object2);
    const changed = [];
    common.forEach((key)=>{
        const value1 = object1[key];
        const value2 = object2[key];
        const value1Type = typeof value1;
        const value2Type = typeof value2;
        // Do comparision only if values doesn't match (or reference to same object in memory).
        // Or if key does not exist in keys to ignore.
        if (value1 !== value2 && keysToIgnore.indexOf(key) === -1) {
            // if both key value are objects and not referencing same object in memory.
            //  then get recursive difference.
            if ((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).isValidElement(value1) || (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).isValidElement(value2)) changed.push({
                key: key,
                reactElementChanged: true
            });
            else if (value1Type === 'object' && value2Type === 'object') {
                if (curDepth <= maxDepth) {
                    const difference = $087692cba489a55d$export$d438af18e3a25d10(value1, value2, curDepth + 1, maxDepth);
                    changed.push({
                        key: key,
                        difference: difference
                    });
                } else changed.push({
                    key: key,
                    maxDepthReached: true
                });
            } else changed.push({
                key: key,
                oldValue: (0, $btdka.serializeValue)(value1),
                newValue: (0, $btdka.serializeValue)(value2)
            });
        }
    });
    return {
        added: added,
        changed: changed,
        removed: removed
    };
};
const $087692cba489a55d$export$418b0a935c0a0030 = (object1, object2)=>{
    const { added: added, common: common, removed: removed } = $087692cba489a55d$export$aedd1a2d18cbf42b(object1, object2);
    const changed = common.filter((key)=>object1[key] !== object2[key]);
    return {
        added: added,
        changed: changed,
        removed: removed
    };
};

});
parcelRegister("84zAO", function(module, exports) {
$parcel$export(module.exports, "getKeys", () => $a0b15b3bd6345dd9$export$74743eda5dda3ccf);
const $a0b15b3bd6345dd9$export$74743eda5dda3ccf = Object.keys;

});

parcelRegister("btdka", function(module, exports) {
$parcel$export(module.exports, "serializeValue", () => $1fb6ffacd845f547$export$f4c1dafc9df1f03);
const $1fb6ffacd845f547$export$f4c1dafc9df1f03 = (value)=>{
    const valueType = typeof value;
    if (value === null) return 'null';
    else if (value === undefined) return 'undefined';
    else if (valueType === 'string' || valueType === 'number') return value;
    else if (valueType === 'symbol') return value.toString();
    else if (valueType === 'function') return `function:${value.name}`;
    else if (valueType === 'object') return {
        type: 'object',
        keys: Object.keys(value)
    };
};

});




parcelRegister("coiiP", function(module, exports) {
$parcel$export(module.exports, "PROSEMIRROR_RENDERED_NORMAL_SEVERITY_THRESHOLD", () => $1c7756ea88dd74fa$export$646a6982857f2cd5);
$parcel$export(module.exports, "PROSEMIRROR_RENDERED_DEGRADED_SEVERITY_THRESHOLD", () => $1c7756ea88dd74fa$export$79d7eac6cbb6352d);
const $1c7756ea88dd74fa$export$646a6982857f2cd5 = 2000;
const $1c7756ea88dd74fa$export$79d7eac6cbb6352d = 3000;
const $1c7756ea88dd74fa$export$7d7bd496a5206996 = 100;

});

parcelRegister("LlHVE", function(module, exports) {
$parcel$export(module.exports, "processPluginsList", () => $b5fa0f8c235a971d$export$7265233e78178a4);
function $b5fa0f8c235a971d$export$7265233e78178a4(plugins) {
    /**
   * First pass to collect pluginsOptions
   */ const pluginsOptions = plugins.reduce((acc, plugin)=>{
        if (plugin.pluginsOptions) Object.keys(plugin.pluginsOptions).forEach((pluginName)=>{
            if (!acc[pluginName]) acc[pluginName] = [];
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            acc[pluginName].push(plugin.pluginsOptions[pluginName]);
        });
        return acc;
    }, {});
    /**
   * Process plugins
   */ return plugins.reduce((acc, plugin)=>{
        if (plugin.pmPlugins) acc.pmPlugins.push(...plugin.pmPlugins(plugin.name ? pluginsOptions[plugin.name] : undefined));
        if (plugin.nodes) acc.nodes.push(...plugin.nodes());
        if (plugin.marks) acc.marks.push(...plugin.marks());
        if (plugin.contentComponent) acc.contentComponents.push(plugin.contentComponent);
        if (plugin.usePluginHook) {
            // Wrap with .bind(null) so we can annotate the function with the
            // plugin name without mutating the plugin's original hook reference.
            // MountPluginHooks reads `pluginName` to derive a stable React key.
            const named = plugin.usePluginHook.bind(null);
            named.pluginName = plugin.name;
            acc.pluginHooks.push(named);
        }
        if (plugin.primaryToolbarComponent) acc.primaryToolbarComponents.push(plugin.primaryToolbarComponent);
        if (plugin.secondaryToolbarComponent) acc.secondaryToolbarComponents.push(plugin.secondaryToolbarComponent);
        if (plugin.onEditorViewStateUpdated) acc.onEditorViewStateUpdatedCallbacks.push({
            pluginName: plugin.name,
            callback: plugin.onEditorViewStateUpdated
        });
        return acc;
    }, {
        nodes: [],
        marks: [],
        pmPlugins: [],
        contentComponents: [],
        pluginHooks: [],
        primaryToolbarComponents: [],
        secondaryToolbarComponents: [],
        onEditorViewStateUpdatedCallbacks: []
    });
}

});

parcelRegister("aKiAv", function(module, exports) {
$parcel$export(module.exports, "getDefaultPresetOptionsFromEditorProps", () => $4ab2538e1c78d346$export$fdea1e40b8747a5b);
$parcel$export(module.exports, "default", () => $4ab2538e1c78d346$export$2e2bcd8739ae039);

var $8dHy3 = parcelRequire("8dHy3");

var $4PWXE = parcelRequire("4PWXE");
const $4ab2538e1c78d346$var$isCodeBlockAllowed = (options)=>{
    const exclude = options && options.allowBlockType && options.allowBlockType.exclude ? options.allowBlockType.exclude : [];
    return exclude.indexOf('codeBlock') === -1;
};
function $4ab2538e1c78d346$export$fdea1e40b8747a5b(props, createAnalyticsEvent) {
    var _props$linking, _props$textFormatting, _props$linking2, _props$linking3;
    const appearance = props.appearance;
    const cardOptions = ((_props$linking = props.linking) === null || _props$linking === void 0 ? void 0 : _props$linking.smartLinks) || props.smartLinks || props.UNSAFE_cards;
    return {
        ...props,
        createAnalyticsEvent: createAnalyticsEvent,
        typeAhead: {
            isMobile: false
        },
        featureFlags: (0, $8dHy3.createFeatureFlagsFromProps)(props.featureFlags),
        paste: {
            cardOptions: cardOptions,
            sanitizePrivateContent: props.sanitizePrivateContent,
            pasteWarningOptions: props.pasteWarningOptions
        },
        base: {
            allowInlineCursorTarget: true,
            allowScrollGutter: (0, $4PWXE.getScrollGutterOptions)(props)
        },
        blockType: {
            lastNodeMustBeParagraph: appearance === 'comment' || appearance === 'chromeless',
            allowBlockType: props.allowBlockType
        },
        placeholder: {
            placeholder: props.placeholder,
            placeholderBracketHint: props.placeholderBracketHint
        },
        textFormatting: {
            ...props.textFormatting || {},
            responsiveToolbarMenu: ((_props$textFormatting = props.textFormatting) === null || _props$textFormatting === void 0 ? void 0 : _props$textFormatting.responsiveToolbarMenu) != null ? props.textFormatting.responsiveToolbarMenu : props.allowUndoRedoButtons
        },
        submitEditor: props.onSave,
        quickInsert: {
            enableElementBrowser: props.elementBrowser && props.elementBrowser.showModal,
            elementBrowserHelpUrl: props.elementBrowser && props.elementBrowser.helpUrl,
            disableDefaultItems: props.quickInsert && typeof props.quickInsert !== 'boolean' && props.quickInsert.disableDefaultItems || false,
            headless: false,
            emptyStateHandler: props.elementBrowser && props.elementBrowser.emptyStateHandler,
            prioritySortingFn: props.quickInsert && typeof props.quickInsert !== 'boolean' && props.quickInsert.prioritySortingFn || undefined,
            onInsert: props.quickInsert && typeof props.quickInsert !== 'boolean' && props.quickInsert.onInsert || undefined
        },
        selection: {
            useLongPressSelection: false
        },
        hyperlinkOptions: {
            editorAppearance: props.appearance,
            linkPicker: (_props$linking2 = props.linking) === null || _props$linking2 === void 0 ? void 0 : _props$linking2.linkPicker,
            onClickCallback: cardOptions === null || cardOptions === void 0 ? void 0 : cardOptions.onClickCallback,
            platform: 'web',
            autoLinkOnBlur: (_props$linking3 = props.linking) === null || _props$linking3 === void 0 ? void 0 : _props$linking3.autoLinkOnBlur
        },
        codeBlock: {
            ...props.codeBlock,
            useLongPressSelection: false,
            allowCompositionInputOverride: false
        }
    };
}
function $4ab2538e1c78d346$export$2e2bcd8739ae039(// eslint-disable-next-line @typescript-eslint/no-explicit-any
preset, props, pluginInjectionAPI) {
    const excludes = new Set();
    if (!$4ab2538e1c78d346$var$isCodeBlockAllowed({
        allowBlockType: props.allowBlockType
    })) excludes.add('codeBlock');
    return preset.build({
        pluginInjectionAPI: pluginInjectionAPI,
        excludePlugins: excludes
    });
}

});
parcelRegister("4PWXE", function(module, exports) {
$parcel$export(module.exports, "getScrollGutterOptions", () => $42e3497461f88a80$export$f94443780f769f8);

var $5oN7k = parcelRequire("5oN7k");
function $42e3497461f88a80$export$f94443780f769f8(props) {
    const { appearance: appearance } = props;
    if ((0, $5oN7k.isFullPage)(appearance)) // Full Page appearance uses a scrollable div wrapper.
    return {
        getScrollElement: ()=>document.querySelector('.fabric-editor-popup-scroll-parent')
    };
    return undefined;
}

});


parcelRegister("j1jEB", function(module, exports) {
$parcel$export(module.exports, "createSchema", () => $67bd498cdeb94b9e$export$5f4ce795563f4211);

var $jiH53 = parcelRequire("jiH53");

var $3BkBo = parcelRequire("3BkBo");

var $kW8qW = parcelRequire("kW8qW");

var $d7ZMr = parcelRequire("d7ZMr");

var $1rPP3 = parcelRequire("1rPP3");
const $67bd498cdeb94b9e$export$48404bb361c0cbc1 = (toDOM)=>{
    return new Proxy(toDOM, {
        apply (target, thisArg, argumentsList) {
            const domSpec = Reflect.apply(target, thisArg, argumentsList);
            if (!Array.isArray(domSpec)) return domSpec;
            const nodeOrMark = argumentsList[0];
            return (0, $d7ZMr.addMetadataAttributes)({
                nodeOrMark: nodeOrMark,
                domSpec: domSpec
            });
        }
    });
};
const $67bd498cdeb94b9e$export$83e999ea28e263f4 = (spec)=>{
    return new Proxy(spec, {
        get (target, prop, receiver) {
            const result = Reflect.get(target, prop, receiver);
            if (prop === 'toDOM' && typeof result === 'function') return $67bd498cdeb94b9e$export$48404bb361c0cbc1(result);
            return result;
        }
    });
};
function $67bd498cdeb94b9e$export$5f4ce795563f4211(editorConfig) {
    const marks = (0, $1rPP3.fixExcludes)(editorConfig.marks.sort((0, $3BkBo.sortByOrder)('marks')).reduce((acc, mark)=>{
        acc[mark.name] = $67bd498cdeb94b9e$export$83e999ea28e263f4(mark.mark);
        return acc;
    }, {}));
    const nodes = (0, $jiH53.sanitizeNodes)(editorConfig.nodes.sort((0, $3BkBo.sortByOrder)('nodes')).reduce((acc, node)=>{
        acc[node.name] = $67bd498cdeb94b9e$export$83e999ea28e263f4(node.node);
        return acc;
    }, {}), marks);
    return new (0, $kW8qW.Schema)({
        nodes: nodes,
        marks: marks
    });
}

});
parcelRegister("3BkBo", function(module, exports) {
$parcel$export(module.exports, "sortByOrder", () => $43149ac3902d6d42$export$49afdc3354d5c84e);
$parcel$export(module.exports, "sortByOrderWithTypeName", () => $43149ac3902d6d42$export$b4ae7ad1c009d0a1);

var $cjsBX = parcelRequire("cjsBX");
function $43149ac3902d6d42$export$49afdc3354d5c84e(item) {
    return function(a, b) {
        return (0, $cjsBX.rankEditorPlugins)[item].indexOf(a.name) - (0, $cjsBX.rankEditorPlugins)[item].indexOf(b.name);
    };
}
function $43149ac3902d6d42$export$b4ae7ad1c009d0a1(item) {
    return function(a, b) {
        return (0, $cjsBX.rankEditorPlugins)[item].indexOf(a.type.name) - (0, $cjsBX.rankEditorPlugins)[item].indexOf(b.type.name);
    };
}

});
parcelRegister("cjsBX", function(module, exports) {
$parcel$export(module.exports, "rankEditorPlugins", () => $51794ee199aa3ee7$export$d4a08ec0aa6e0cef);
// eslint-disable-next-line @repo/internal/deprecations/deprecation-ticket-required -- Ignored via go/ED-25883
// @deprecated
// @private This rank is not stable and should not be trusted. If you need to change this file, please let the Editor lego team know about it
const $51794ee199aa3ee7$export$d4a08ec0aa6e0cef = {
    plugins: [
        'featureFlagsContextPlugin',
        'compositionPlugin',
        'inlineCursorTargetPlugin',
        'typeAhead',
        'typeAheadInsertItem',
        'focusHandlerPlugin',
        'frozenEditor',
        'submitEditor',
        'saveOnEnter',
        'customAutoformatting',
        'newlinePreserveMarksPlugin',
        'imageUpload',
        'imageUploadInputRule',
        'clipboard',
        'paste',
        'pasteKeymap',
        'mention',
        'mentionInputRule',
        'mentionKeymap',
        'emoji',
        'placeholderText',
        'emojiInputRule',
        'emojiKeymap',
        'emojiAsciiInputRule',
        'blockType',
        'quickInsert',
        'tasksAndDecisions',
        'blockTypeInputRule',
        'tasksAndDecisionsInputRule',
        'list',
        'typeAheadKeymap',
        'typeAheadInputRule',
        'date',
        // Needs to be before indentation to handle tab into input field
        'dateKeymap',
        // This should be always after `typeAheadKeymap` & `emojiKeymap`
        'indentationKeymap',
        'textColor',
        'highlight',
        'highlightKeymap',
        'alignmentPlugin',
        'listInputRule',
        'listKeymap',
        'codeBlock',
        'codeBlockIDEKeyBindings',
        'codeBlockKeyMap',
        'textFormatting',
        'textFormattingCursor',
        'textFormattingInputRule',
        'textFormattingSmartRule',
        'textFormattingClear',
        'textFormattingKeymap',
        // task/decisions keymap needs to be above table keymap so can indent actions in a table
        'tasksAndDecisionsKeyMap',
        // expand and table keymaps need to be above selection keymap to add their custom selection behaviour:
        // https://product-fabric.atlassian.net/wiki/spaces/E/pages/1113098008/Selection+Guide#Special-Cases
        'expandKeymap',
        'tableSelectionKeymap',
        'tableKeymap',
        'captionKeymap',
        // media keymap above selection keymap to allow navigating past the mediaSingle node
        'mediaKeymap',
        // selection keymap needs to be above gap cursor keymap so it can set node selections from
        // left/right arrows
        'selectionKeymap',
        'gapCursorKeymap',
        'gapCursor',
        'syncUrlText',
        'fakeCursorToolbarPlugin',
        'hyperLink',
        'table',
        'tableDecorations',
        'hyperlinkInputRule',
        'tablePMColResizing',
        'hyperlinkKeymap',
        'tableColResizing',
        'undoRedoKeyMap',
        'blockTypeKeyMap',
        'tableEditing',
        'filterStepsPlugin',
        'pmCollab',
        'collab',
        'ruleInputRule',
        'ruleKeymap',
        'panel',
        'media',
        'mediaSingleKeymap',
        'mediaEditor',
        'unsupportedContent',
        'jiraIssue',
        'helpDialog',
        'helpDialogKeymap',
        'macro',
        'expand',
        'extension',
        'layout',
        'contextPanel',
        'selectionToolbar',
        'floatingToolbar',
        'clearMarksOnChange',
        'reactNodeView',
        'history',
        'undoRedoPlugin',
        'codeBlockIndent',
        'placeholder',
        'width',
        'maxContentSize',
        'multilineContent',
        'grid',
        'mobileDimensions',
        'scrollGutterPlugin',
        'analytics',
        'findReplace',
        'selection',
        'avatarGroup',
        'viewUpdateSubscription',
        'beforePrimaryToolbar',
        'inlineCode'
    ],
    nodes: [
        'doc',
        'paragraph',
        'text',
        'bulletList',
        'orderedList',
        'listItem',
        'heading',
        'blockquote',
        'codeBlock',
        'rule',
        'panel',
        'panel_c1',
        'mention',
        'confluenceUnsupportedBlock',
        'confluenceUnsupportedInline',
        'unsupportedBlock',
        'unsupportedInline',
        'confluenceJiraIssue',
        'hardBreak',
        'emoji',
        'placeholder',
        'mediaSingle',
        'mediaGroup',
        'table',
        'expand',
        'nestedExpand',
        'media',
        'tableHeader',
        'decisionList',
        'tableRow',
        'decisionItem',
        'tableCell',
        'taskList',
        'taskItem',
        'extension',
        'bodiedExtension',
        'multiBodiedExtension',
        'inlineExtension',
        'layoutSection',
        'layoutColumn',
        'inlineCard',
        'blockCard',
        'embedCard'
    ],
    marks: [
        // Fragment mark is both for inline and block elements
        'fragment',
        // Inline marks
        'link',
        'em',
        'strong',
        'textColor',
        'backgroundColor',
        'strike',
        'subsup',
        'underline',
        'code',
        'typeAheadQuery',
        // Block marks
        'alignment',
        'breakout',
        'indentation',
        'annotation',
        'dataConsumer',
        'border',
        // Unsupported mark
        'unsupportedMark',
        'unsupportedNodeAttribute'
    ]
};

});


parcelRegister("d7ZMr", function(module, exports) {
$parcel$export(module.exports, "addMetadataAttributes", () => $994afcbf95a45856$export$29c1e593063b23a7);

var $4G6Rb = parcelRequire("4G6Rb");
const $994afcbf95a45856$export$29c1e593063b23a7 = ({ nodeOrMark: nodeOrMark, domSpec: domSpec })=>{
    if (!Array.isArray(domSpec)) return domSpec;
    const maybeDefinedAttributes = domSpec[1];
    const metadata = (0, $4G6Rb.createProseMirrorMetadata)(nodeOrMark);
    const hasDefinedAttributes = typeof maybeDefinedAttributes === 'object' && !Array.isArray(maybeDefinedAttributes);
    if (hasDefinedAttributes) domSpec[1] = Object.assign(maybeDefinedAttributes, metadata);
    else domSpec.splice(1, 0, metadata);
    return domSpec;
};

});

parcelRegister("1rPP3", function(module, exports) {
$parcel$export(module.exports, "fixExcludes", () => $a78eaa13ba691545$export$ef6c09ff452189fa);
function $a78eaa13ba691545$export$ef6c09ff452189fa(marks) {
    const markKeys = Object.keys(marks);
    const markGroups = new Set(markKeys.map((mark)=>marks[mark].group));
    markKeys.forEach((markKey)=>{
        const mark = marks[markKey];
        if (mark.excludes) // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
        mark.excludes = mark.excludes.split(' ').filter((group)=>markGroups.has(group)).join(' ');
    });
    return marks;
}

});


parcelRegister("jDv78", function(module, exports) {
$parcel$export(module.exports, "createErrorReporter", () => $7c3301d424a0a2ca$export$e98521bb0cea2db1);

var $ehhh6 = parcelRequire("ehhh6");
function $7c3301d424a0a2ca$export$e98521bb0cea2db1(errorReporterHandler) {
    const errorReporter = new (0, $ehhh6.ErrorReporter)();
    if (errorReporterHandler) errorReporter.handler = errorReporterHandler;
    return errorReporter;
}

});
parcelRegister("ehhh6", function(module, exports) {
$parcel$export(module.exports, "ErrorReporter", () => $e2b9f80a80cf9ecd$export$88da0ac32d9c271e);
class $e2b9f80a80cf9ecd$export$88da0ac32d9c271e {
    captureMessage(msg, tags) {
        if (this.handlerStorage) this.handlerStorage.captureMessage(msg, tags);
    }
    captureException(err, tags) {
        if (this.handlerStorage) this.handlerStorage.captureException(err, tags);
    }
    set handler(handler) {
        this.handlerStorage = handler;
    }
    constructor(){
        this.handlerStorage = null;
    }
}

});


parcelRegister("bwlKb", function(module, exports) {
$parcel$export(module.exports, "createPMPlugins", () => $d5023fa633cb9c82$export$169329cb2979ef81);

var $3BkBo = parcelRequire("3BkBo");

var $3y2s4 = parcelRequire("3y2s4");

var $5N1Y4 = parcelRequire("5N1Y4");

var $bxwW6 = parcelRequire("bxwW6");

var $ivjxX = parcelRequire("ivjxX");
function $d5023fa633cb9c82$export$169329cb2979ef81(config) {
    const { editorConfig: editorConfig } = config;
    const pmPlugins = editorConfig.pmPlugins.sort((0, $3BkBo.sortByOrder)('plugins')).map(({ plugin: plugin })=>plugin({
            schema: config.schema,
            dispatch: config.dispatch,
            eventDispatcher: config.eventDispatcher,
            providerFactory: config.providerFactory,
            errorReporter: config.errorReporter,
            portalProviderAPI: config.portalProviderAPI,
            nodeViewPortalProviderAPI: config.nodeViewPortalProviderAPI,
            dispatchAnalyticsEvent: config.dispatchAnalyticsEvent,
            featureFlags: config.featureFlags || {},
            getIntl: config.getIntl
        })).filter((plugin)=>typeof plugin !== 'undefined');
    if ((0, $5N1Y4.expValEquals)('platform_editor_native_anchor_with_dnd', 'isEnabled', true) || (0, $3y2s4.isExperimentEnabled)('platform_editor_block_control_migration')) pmPlugins.push((0, $bxwW6.createEditorNativeAnchorSupportPlugin)(config.schema));
    if (config.onEditorStateUpdated !== undefined) return [
        (0, $ivjxX.createEditorStateNotificationPlugin)(config.onEditorStateUpdated, config.editorConfig.onEditorViewStateUpdatedCallbacks),
        ...pmPlugins
    ];
    return pmPlugins;
}

});
parcelRegister("bxwW6", function(module, exports) {
$parcel$export(module.exports, "createEditorNativeAnchorSupportPlugin", () => $70957405ac0911a2$export$dc8df63091e87b7a);

var $f7Kk4 = parcelRequire("f7Kk4");

var $kW8qW = parcelRequire("kW8qW");

var $cw0wu = parcelRequire("cw0wu");
const $70957405ac0911a2$var$injectNodeViewNodeTypeList = [
    'paragraph',
    'heading',
    'bulletList',
    'orderedList',
    'blockquote',
    'rule',
    'decisionList',
    'taskList',
    'layoutColumn',
    'hardBreak',
    'layoutSection'
];
const $70957405ac0911a2$var$key = new (0, $cw0wu.PluginKey)('editorNativeAnchorSupportPlugin');
const $70957405ac0911a2$export$dc8df63091e87b7a = (schema)=>{
    const nodeViewEntries = [];
    schema.spec.nodes.forEach((nodeName, nodeSpec)=>{
        if ($70957405ac0911a2$var$injectNodeViewNodeTypeList.includes(nodeName)) {
            if (nodeSpec.toDOM && typeof nodeSpec.toDOM === 'function') {
                const toDOM = nodeSpec.toDOM.bind(nodeSpec);
                nodeViewEntries.push([
                    nodeName,
                    (node)=>(0, $kW8qW.DOMSerializer).renderSpec(document, toDOM(node))
                ]);
            }
        }
    });
    return new (0, $f7Kk4.SafePlugin)({
        key: $70957405ac0911a2$var$key,
        props: {
            nodeViews: Object.fromEntries(nodeViewEntries)
        }
    });
};

});

parcelRegister("ivjxX", function(module, exports) {
$parcel$export(module.exports, "createEditorStateNotificationPlugin", () => $4172fc9dc4e9238c$export$e0355cecc74597d);

var $f7Kk4 = parcelRequire("f7Kk4");

var $cw0wu = parcelRequire("cw0wu");

var $3y2s4 = parcelRequire("3y2s4");
const $4172fc9dc4e9238c$var$key = new (0, $cw0wu.PluginKey)('editorStateNotificationPlugin');
const $4172fc9dc4e9238c$export$e0355cecc74597d = (onEditorStateUpdated, onEditorViewStateUpdatedCallbacks)=>{
    const transactions = [];
    return new (0, $f7Kk4.SafePlugin)({
        key: $4172fc9dc4e9238c$var$key,
        state: {
            init () {
                return {
                    latestTransaction: undefined
                };
            },
            apply (tr) {
                if (!(0, $3y2s4.isExperimentEnabled)('platform_editor_reduce_memory_leaks')) // Dead accumulator: nothing reads it, so it pins every transaction for the
                // editor's lifetime. Delete it when the experiment ships.
                transactions.push(tr);
                return {
                    latestTransaction: tr
                };
            }
        },
        view: ()=>{
            return {
                update: (view, oldEditorState)=>{
                    onEditorStateUpdated({
                        oldEditorState: oldEditorState,
                        newEditorState: view.state
                    });
                }
            };
        }
    });
};

});


parcelRegister("tEoZh", function(module, exports) {
$parcel$export(module.exports, "filterPluginsForReconfigure", () => $8d4b5f2851078d71$export$1a7fe7567929e9de);
function $8d4b5f2851078d71$export$1a7fe7567929e9de(editorPlugins, schema, previousPluginNames) {
    const availableNodeNames = new Set(Object.keys(schema.nodes));
    const availableMarkNames = new Set(Object.keys(schema.marks));
    const dropped = [];
    const kept = editorPlugins.filter((plugin)=>{
        if (!plugin) return false;
        if (previousPluginNames.has(plugin.name)) return true;
        const missingNodes = plugin.nodes ? plugin.nodes().map((n)=>n.name).filter((n)=>!availableNodeNames.has(n)) : [];
        const missingMarks = plugin.marks ? plugin.marks().map((m)=>m.name).filter((m)=>!availableMarkNames.has(m)) : [];
        if (missingNodes.length > 0 || missingMarks.length > 0) {
            dropped.push({
                name: plugin.name,
                missingNodes: missingNodes,
                missingMarks: missingMarks
            });
            return false;
        }
        return true;
    });
    return {
        kept: kept,
        dropped: dropped
    };
}

});

parcelRegister("bRDwy", function(module, exports) {
$parcel$export(module.exports, "editorMessages", () => $898b2874253a1cb5$export$3b488057bfc1868f);

var $f0Pt4 = parcelRequire("f0Pt4");
const $898b2874253a1cb5$export$3b488057bfc1868f = (0, $f0Pt4.defineMessages)({
    editorAssistiveLabel: {
        id: 'fabric.editor.editorAssistiveLabel',
        defaultMessage: 'Main content area, start typing to enter text.',
        description: 'Text that is read out by screen reader when the main editor is in focus'
    },
    fullPageEditorAssistiveLabel: {
        id: 'fabric.editor.fullPageEditorAssistiveLabel',
        defaultMessage: 'Page editing area, start typing to enter text.',
        description: 'The aria-label assigned to the full page editor content area, read by screen readers when a user focuses the editing region.'
    }
});

});

parcelRegister("6svky", function(module, exports) {
$parcel$export(module.exports, "getUAPrefix", () => $a92fc6205d7283b2$export$11a24c7b1b4aab81);

var $jxkn6 = parcelRequire("jxkn6");
function $a92fc6205d7283b2$export$11a24c7b1b4aab81() {
    const browser = (0, $jxkn6.getBrowserInfo)();
    if (browser.chrome) return 'ua-chrome';
    else if (browser.ie) return 'ua-ie';
    else if (browser.gecko) return 'ua-firefox';
    else if (browser.safari) return 'ua-safari';
    return '';
}

});

parcelRegister("dTpvu", function(module, exports) {
$parcel$export(module.exports, "handleEditorFocus", () => $ae0ad419df5e5cbd$export$ebebb7f5b9271fd7);

var $cw0wu = parcelRequire("cw0wu");

var $5N1Y4 = parcelRequire("5N1Y4");
function $ae0ad419df5e5cbd$export$ebebb7f5b9271fd7(view) {
    var _domSelection$getRang;
    if (view !== null && view !== void 0 && view.hasFocus()) return;
    // Due to race conditions during editor lifecycle transitions (e.g. SPA route changes during opening or closing)
    // where the view (and its internal docView) may have been destroyed, the timeout callback may fire on a stale view.
    // Bail out in that scenario to prevent operating on an unmounted view.
    if (view !== null && view !== void 0 && view.isDestroyed) return;
    if (!window.getSelection) {
        view === null || view === void 0 || view.focus();
        return;
    }
    const domSelection = window.getSelection();
    if (!domSelection || domSelection.rangeCount === 0) {
        view === null || view === void 0 || view.focus();
        return;
    }
    // If not mocked properly in tests, getRangeAt may not exist.
    const range = (_domSelection$getRang = domSelection.getRangeAt) === null || _domSelection$getRang === void 0 ? void 0 : _domSelection$getRang.call(domSelection, 0);
    if (!range) return;
    // if selection is outside editor focus and exit
    try {
        if (view && range !== null && range !== void 0 && range.startContainer.contains(view.dom)) {
            view.focus();
            return;
        }
    } catch (error) {
        // If we get a SecurityError-type DOMException here, then we probably just tried to
        // access a cross-origin iframe's contents. In that case, we can ignore the error and
        // just reasonably assume the selection is outside the editor, since we can't access it.
        if (error instanceof DOMException && error.name === 'SecurityError' && (0, $5N1Y4.expValEquals)('platform_editor_fix_cross_origin_editor_focus', 'isEnabled', true)) {
            if (view) {
                view.focus();
                return;
            }
        } else // re-throw other unexpected errors
        throw error;
    }
    // set cursor/selection and focus
    const anchor = view === null || view === void 0 ? void 0 : view.posAtDOM(range.startContainer, range.startOffset);
    const head = view === null || view === void 0 ? void 0 : view.posAtDOM(range.endContainer, range.endOffset);
    // if anchor or head < 0 focus and exit
    if (anchor && anchor < 0 || head && head < 0) {
        view === null || view === void 0 || view.focus();
        return;
    }
    if (view && anchor) {
        const selection = (0, $cw0wu.TextSelection).create(view.state.doc, anchor, head);
        const tr = view.state.tr.setSelection(selection);
        view.dispatch(tr);
        view.focus();
    }
}

});

parcelRegister("kd0Iq", function(module, exports) {
$parcel$export(module.exports, "useDispatchTransaction", () => $ff85fbf0b53e9e5a$export$b582387940572fe7);

var $bSJIT = parcelRequire("bSJIT");

var $g6Qq4 = parcelRequire("g6Qq4");

var $gK4Lk = parcelRequire("gK4Lk");

var $gZj5p = parcelRequire("gZj5p");

var $ilGNx = parcelRequire("ilGNx");

var $951G5 = parcelRequire("951G5");

var $hVX65 = parcelRequire("hVX65");

var $l6P57 = parcelRequire("l6P57");

var $lqmpu = parcelRequire("lqmpu");

var $fHCTK = parcelRequire("fHCTK");

var $aqEaP = parcelRequire("aqEaP");
const $ff85fbf0b53e9e5a$export$b582387940572fe7 = ({ onChange: onChange, dispatchAnalyticsEvent: dispatchAnalyticsEvent, onEditorViewUpdated: onEditorViewUpdated, isRemoteReplaceDocumentTransaction: isRemoteReplaceDocumentTransaction })=>{
    // We need to have a ref to the latest `onChange` since the `dispatchTransaction` gets captured
    const onChangeRef = (0, $bSJIT.useRef)(onChange);
    (0, $bSJIT.useEffect)(()=>{
        onChangeRef.current = onChange;
    }, [
        onChange
    ]);
    const dispatchTransaction = (0, $bSJIT.useCallback)((view, unsafeTransaction)=>{
        if (!view) return;
        const nodes = (0, $hVX65.findChangedNodesFromTransaction)(unsafeTransaction);
        const changedNodesValid = (0, $fHCTK.validateNodes)(nodes);
        const transaction = new Proxy(unsafeTransaction, (0, $l6P57.freezeUnsafeTransactionProperties)({
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            pluginKey: 'unknown-reacteditorview'
        }));
        // If the transaction is a remote replaceDocument transaction, we should skip validation.
        // Remote replaceDocument transactions are fired when the document is replaced by initialization of editor-plugin-collab-edit
        // If there is a discrepancy in the ProseMirror schema at initialization, it results in the editor being loaded with no content,
        // giving the user the impression that content has been lost
        const isRemoteReplace = isRemoteReplaceDocumentTransaction ? isRemoteReplaceDocumentTransaction(transaction) : false;
        if (changedNodesValid || isRemoteReplace) {
            const oldEditorState = view.state;
            // go ahead and update the state now we know the transaction is good
            const { state: newEditorState, transactions: transactions } = view.state.applyTransaction(transaction);
            if (newEditorState === oldEditorState) return;
            view.updateState(newEditorState);
            onEditorViewUpdated({
                originalTransaction: transaction,
                transactions: transactions,
                oldEditorState: oldEditorState,
                newEditorState: newEditorState
            });
            if (onChangeRef.current && transaction.docChanged) {
                const source = transaction.getMeta('isRemote') ? 'remote' : 'local';
                const isDirtyChange = (0, $gZj5p.isDirtyTransaction)(transaction);
                (0, $951G5.startMeasure)((0, $lqmpu.EVENT_NAME_ON_CHANGE));
                onChangeRef.current(view, {
                    source: source,
                    isDirtyChange: isDirtyChange
                });
                (0, $951G5.stopMeasure)((0, $lqmpu.EVENT_NAME_ON_CHANGE));
            }
        }
        if (!changedNodesValid) {
            const invalidNodes = nodes.filter((node)=>!(0, $aqEaP.validNode)(node)).map((node)=>(0, $ilGNx.getDocStructure)(node, {
                    compact: true
                }));
            dispatchAnalyticsEvent({
                action: (0, $g6Qq4.ACTION).DISPATCHED_INVALID_TRANSACTION,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).EDITOR,
                eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    analyticsEventPayloads: (0, $gK4Lk.getAnalyticsEventsFromTransaction)(transaction),
                    invalidNodes: invalidNodes,
                    isRemoteReplaceDocumentTransaction: isRemoteReplace
                }
            });
        }
    }, [
        dispatchAnalyticsEvent,
        onEditorViewUpdated,
        isRemoteReplaceDocumentTransaction
    ]);
    return dispatchTransaction;
};

});
parcelRegister("gK4Lk", function(module, exports) {
$parcel$export(module.exports, "getAnalyticsEventsFromTransaction", () => $ce6263ae36bc56a8$export$d9985be1ece4b7ee);

var $7ozbX = parcelRequire("7ozbX");
function $ce6263ae36bc56a8$export$d9985be1ece4b7ee(tr) {
    return tr.steps.filter((step)=>step instanceof (0, $7ozbX.AnalyticsStep)).reduce((acc, step)=>[
            ...acc,
            ...step.analyticsEvents
        ], []);
}

});
parcelRegister("7ozbX", function(module, exports) {
$parcel$export(module.exports, "AnalyticsStep", () => $277ee8c154c74927$export$cc33374693c7fb23);

var $kW8qW = parcelRequire("kW8qW");

var $3DNV7 = parcelRequire("3DNV7");
parcelRequire("bUbIU");
var $3DNV7 = parcelRequire("3DNV7");
const $277ee8c154c74927$export$9126078e8b0f76e4 = 'atlaskit-analytics';
const $277ee8c154c74927$export$89a6d622be04d823 = 'atlaskit-analytics-invert';
var $277ee8c154c74927$var$HISTORY_ACTIONS = /*#__PURE__*/ function(HISTORY_ACTIONS) {
    HISTORY_ACTIONS["UNDID"] = "undid";
    HISTORY_ACTIONS["REDID"] = "redid";
    return HISTORY_ACTIONS;
}($277ee8c154c74927$var$HISTORY_ACTIONS || {});
/** Creates undo event from a normal analytics event */ function $277ee8c154c74927$var$createUndoEvent(analyticsEvent) {
    var _analyticsEvent$paylo;
    return {
        ...analyticsEvent,
        payload: {
            action: "undid",
            actionSubject: analyticsEvent.payload.actionSubject,
            actionSubjectId: analyticsEvent.payload.action,
            attributes: {
                ...analyticsEvent.payload.attributes,
                actionSubjectId: analyticsEvent.payload.actionSubjectId,
                inputMethod: ((_analyticsEvent$paylo = analyticsEvent.payload.attributes) === null || _analyticsEvent$paylo === void 0 ? void 0 : _analyticsEvent$paylo.inputMethod) || ''
            },
            eventType: 'track'
        }
    };
}
/** Toggles event action between undo & redo */ const $277ee8c154c74927$var$toggleEventAction = (analyticsEvent)=>({
        ...analyticsEvent,
        payload: {
            ...analyticsEvent.payload,
            action: analyticsEvent.payload.action === "undid" ? "redid" : "undid"
        }
    });
function $277ee8c154c74927$var$isHistoryAnalyticsEvent(event) {
    return event.payload.action === "undid" || event.payload.action === "redid";
}
class $277ee8c154c74927$export$cc33374693c7fb23 extends (0, $3DNV7.Step) {
    constructor(analyticsEvents, actionsToIgnore = [], pos // Used to create the map, prevent splitting history.
    ){
        super(), this.analyticsEvents = [], this.actionsToIgnore = [];
        this.analyticsEvents = analyticsEvents;
        this.actionsToIgnore = actionsToIgnore;
        this.pos = pos;
    }
    /**
   * Generate new undo/redo analytics event when step is inverted
   */ invert() {
        const analyticsEvents = this.analyticsEvents.filter((analyticsEvent)=>this.actionsToIgnore.indexOf(analyticsEvent.payload.action) === -1).map((analyticsEvent)=>{
            if ($277ee8c154c74927$var$isHistoryAnalyticsEvent(analyticsEvent)) return $277ee8c154c74927$var$toggleEventAction(analyticsEvent);
            else return $277ee8c154c74927$var$createUndoEvent(analyticsEvent);
        });
        return new $277ee8c154c74927$export$cc33374693c7fb23(analyticsEvents, []);
    }
    apply(doc) {
        return (0, $3DNV7.StepResult).ok(doc);
    }
    map(mapping) {
        let newPos = this.pos;
        if (typeof newPos === 'number') newPos = mapping.map(newPos);
        // Return the same events, this step will never be removed
        return new $277ee8c154c74927$export$cc33374693c7fb23(this.analyticsEvents, this.actionsToIgnore, newPos);
    }
    getMap() {
        if (typeof this.pos === 'number') return new (0, $3DNV7.StepMap)([
            this.pos,
            0,
            0
        ]);
        return new (0, $3DNV7.StepMap)([]);
    }
    merge(other) {
        if (other instanceof $277ee8c154c74927$export$cc33374693c7fb23) {
            const otherAnalyticsEvents = other.analyticsEvents;
            return new $277ee8c154c74927$export$cc33374693c7fb23([
                ...otherAnalyticsEvents,
                ...this.analyticsEvents
            ]);
        }
        return null;
    }
    toJSON() {
        return {
            stepType: $277ee8c154c74927$export$9126078e8b0f76e4
        };
    }
    static fromJSON() {
        return new (0, $3DNV7.ReplaceStep)(0, 0, (0, $kW8qW.Slice).empty);
    }
}
/** Register this step with Prosemirror */ (0, $3DNV7.Step).jsonID($277ee8c154c74927$export$9126078e8b0f76e4, $277ee8c154c74927$export$cc33374693c7fb23);

});
parcelRegister("bUbIU", function(module, exports) {
$parcel$export(module.exports, "Step", () => (parcelRequire("3DNV7")).Step);

var $3DNV7 = parcelRequire("3DNV7");
// Using this avoids infinite recursion, as referencing Step.fromJSON inside Step.fromJSON
// will refer to the reassigned version, not the original version
const $837a7fd6f06d33c0$var$originalFromJSON = (0, $3DNV7.Step).fromJSON;
(0, $3DNV7.Step).fromJSON = (schema, jsonStep)=>{
    const stepImplementation = $837a7fd6f06d33c0$var$originalFromJSON(schema, jsonStep);
    return new Proxy(stepImplementation, {
        get (target, prop, receiver) {
            if (prop === 'toJSON') {
                const toJSONfunc = Reflect.get(target, prop, receiver);
                // @ts-expect-error Metadata may or may not exist at this stage, depending on step type,
                // but also additions outside of the type system that others may have done.
                const classMetadata = target.metadata;
                return new Proxy(toJSONfunc, {
                    apply (target, thisArg, argArray) {
                        const originalResult = Reflect.apply(target, thisArg, argArray);
                        const metadata = {
                            ...jsonStep.metadata,
                            ...classMetadata,
                            ...originalResult.metadata
                        };
                        return {
                            ...originalResult,
                            ...Object.keys(metadata).length === 0 ? {} : {
                                metadata: metadata
                            }
                        };
                    }
                });
            }
            return Reflect.get(target, prop, receiver);
        }
    });
};

});



parcelRegister("hVX65", function(module, exports) {
$parcel$export(module.exports, "findChangedNodesFromTransaction", () => $f1cf3bc52e3c922b$export$cdc577fd3f583194);
const $f1cf3bc52e3c922b$export$cdc577fd3f583194 = (tr)=>{
    const nodes = [];
    const steps = tr.steps || [];
    steps.forEach((step)=>{
        step.getMap().forEach((_oldStart, _oldEnd, newStart, newEnd)=>{
            tr.doc.nodesBetween(newStart, Math.min(newEnd, tr.doc.content.size), (node)=>{
                if (!nodes.find((n)=>n === node)) nodes.push(node);
                return false;
            });
        });
    });
    return nodes;
};

});

parcelRegister("l6P57", function(module, exports) {
$parcel$export(module.exports, "freezeUnsafeTransactionProperties", () => $07ae0050245f0916$export$668aa008bdae439f);

var $g6Qq4 = parcelRequire("g6Qq4");
const $07ae0050245f0916$export$9f24e92219b6e945 = 'Setting an unsafe property on transaction after dispatch!';
// since selection uses curSelection under the hood, we guard setSelection instead
const $07ae0050245f0916$var$isUnsafeMethod = (prop)=>[
        'setSelection'
    ].includes(prop.toString());
const $07ae0050245f0916$var$isReadOnlyProperty = (prop)=>[
        'doc',
        'docs',
        'steps',
        'selection'
    ].includes(prop.toString());
const $07ae0050245f0916$export$668aa008bdae439f = ({ dispatchAnalyticsEvent: dispatchAnalyticsEvent, pluginKey: pluginKey })=>{
    const isUnsafe = ()=>{
        if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
            action: (0, $g6Qq4.ACTION).TRANSACTION_MUTATED_AFTER_DISPATCH,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).EDITOR,
            eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL,
            attributes: {
                pluginKey: pluginKey || 'unknown'
            }
        });
        throw new Error($07ae0050245f0916$export$9f24e92219b6e945);
    };
    return {
        get: function(target, prop, receiver) {
            if ($07ae0050245f0916$var$isUnsafeMethod(prop)) isUnsafe();
            return Reflect.get(target, prop, receiver);
        },
        set: function(target, prop, receiver) {
            if ($07ae0050245f0916$var$isReadOnlyProperty(prop)) isUnsafe();
            return Reflect.set(target, prop, receiver);
        }
    };
};

});

parcelRegister("lqmpu", function(module, exports) {
$parcel$export(module.exports, "EVENT_NAME_ON_CHANGE", () => $98050a30f95ecdc2$export$bb82e7cfb8987f35);

var $jRBYX = parcelRequire("jRBYX");

var $951G5 = parcelRequire("951G5");

var $kQi0V = parcelRequire("kQi0V");
const $98050a30f95ecdc2$export$5e38f3b295505ec8 = `\u{1F989} EditorView::state::apply`;
const $98050a30f95ecdc2$export$646ca0d076c98ad5 = `\u{1F989} EditorView::updateState`;
const $98050a30f95ecdc2$export$2f488cec9729a7d6 = `\u{1F989} EditorView::onEditorViewStateUpdated`;
const $98050a30f95ecdc2$export$bb82e7cfb8987f35 = `\u{1F989} ReactEditorView::onChange`;
const $98050a30f95ecdc2$export$373baa16b824d295 = `\u{1F989} ReactEditorView::dispatchTransaction`;
const $98050a30f95ecdc2$export$735da5ee20c885d5 = false;
const $98050a30f95ecdc2$var$DEFAULT_SAMPLING_RATE = 100;
const $98050a30f95ecdc2$var$noop = ()=>{};
class $98050a30f95ecdc2$export$7a054319813aafa {
    addMeasureListener(listener) {
        this.measureListeners.push(listener);
    }
    removeMeasureListener(listener) {
        const index = this.measureListeners.indexOf(listener);
        if (index > -1) this.measureListeners.splice(index, 1);
    }
    shouldTrackTransaction(options) {
        const { enabled: trackingEnabled, samplingRate: samplingRate = $98050a30f95ecdc2$var$DEFAULT_SAMPLING_RATE } = options;
        return trackingEnabled && this.dispatchCallCounter === samplingRate;
    }
    constructor(){
        // Counter so we can rate limit the transaction performance tracking
        this.dispatchCallCounter = 0;
        // A map containing the time which measurement starts
        this.measureMap = new Map();
        this.measureListeners = [];
        this.bumpDispatchCounter = (options)=>{
            const { enabled: trackingEnabled, samplingRate: samplingRate = $98050a30f95ecdc2$var$DEFAULT_SAMPLING_RATE } = options;
            if (trackingEnabled) {
                if (this.dispatchCallCounter >= samplingRate) this.dispatchCallCounter = 0;
                this.dispatchCallCounter++;
            }
            return this.dispatchCallCounter;
        };
        this.getMeasureHelpers = (options)=>{
            const { usePerformanceMarks: usePerformanceMarks = $98050a30f95ecdc2$export$735da5ee20c885d5 } = options;
            if (!this.shouldTrackTransaction(options)) return {
                startMeasure: $98050a30f95ecdc2$var$noop,
                stopMeasure: $98050a30f95ecdc2$var$noop
            };
            return {
                startMeasure: usePerformanceMarks ? (0, $951G5.startMeasure) : this.startMeasureSimple,
                stopMeasure: usePerformanceMarks ? (0, $951G5.stopMeasure) : this.stopMeasureSimple
            };
        };
        this.startMeasureSimple = (measureName)=>{
            if (!(0, $jRBYX.isPerformanceAPIAvailable)()) return;
            this.measureMap.set(measureName, performance.now());
        };
        this.stopMeasureSimple = (measureName, onMeasureComplete)=>{
            if (!(0, $jRBYX.isPerformanceAPIAvailable)()) return;
            const startTime = this.measureMap.get(measureName);
            if (startTime) {
                const duration = (0, $kQi0V.getTimeSince)(startTime);
                this.measureMap.delete(measureName);
                if (onMeasureComplete) onMeasureComplete(duration, startTime);
                // Call each subscribed listener
                this.measureListeners.forEach((listener)=>listener({
                        name: measureName,
                        duration: duration,
                        startTime: startTime
                    }));
            }
        };
    }
}

});
parcelRegister("kQi0V", function(module, exports) {
$parcel$export(module.exports, "getTimeSince", () => $0cb387f019fe8b24$export$a26b90db2c8f1b97);
/**
 * Calculate the difference between performance.now() and the given startTime.
 * This allows for the timing to be overridable during tests.
 *
 * @param startTime DOMHighResTimeStamp
 * @returns DOMHighResTimeStamp
 */ const $0cb387f019fe8b24$export$a26b90db2c8f1b97 = (startTime)=>performance.now() - startTime;

});


parcelRegister("fHCTK", function(module, exports) {
$parcel$export(module.exports, "validateNodes", () => $3dfbf96beafba663$export$996213f7c272fc6f);

var $aqEaP = parcelRequire("aqEaP");
const $3dfbf96beafba663$export$996213f7c272fc6f = (nodes)=>nodes.every((0, $aqEaP.validNode));

});
parcelRegister("aqEaP", function(module, exports) {
$parcel$export(module.exports, "validNode", () => $bfa32bdb99a62cb6$export$4c39e41e39b3c449);
const $bfa32bdb99a62cb6$export$4c39e41e39b3c449 = (node)=>{
    try {
        node.check();
    } catch (error) {
        return false;
    }
    return true;
};

});



parcelRegister("1oTnu", function(module, exports) {
$parcel$export(module.exports, "useFireFullWidthEvent", () => $f55384a21a8067e6$export$4998b7b36606f9c3);

var $bSJIT = parcelRequire("bSJIT");

var $g6Qq4 = parcelRequire("g6Qq4");

var $b2855 = parcelRequire("b2855");

var $64SSy = parcelRequire("64SSy");
const $f55384a21a8067e6$export$4998b7b36606f9c3 = (appearance, dispatchAnalyticsEvent)=>{
    const previousAppearance = (0, $b2855.default)(appearance);
    (0, $bSJIT.useEffect)(()=>{
        if (appearance !== previousAppearance) {
            if (appearance === 'full-width' || previousAppearance === 'full-width') dispatchAnalyticsEvent({
                action: (0, $g6Qq4.ACTION).CHANGED_FULL_WIDTH_MODE,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).EDITOR,
                eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
                attributes: {
                    previousMode: (0, $64SSy.formatFullWidthAppearance)(previousAppearance),
                    newMode: (0, $64SSy.formatFullWidthAppearance)(appearance)
                }
            });
        }
    }, [
        appearance,
        previousAppearance,
        dispatchAnalyticsEvent
    ]);
};

});
parcelRegister("64SSy", function(module, exports) {
$parcel$export(module.exports, "formatFullWidthAppearance", () => $a207f1a86ad497aa$export$47d5b79f3ddf0b92);

var $4S8NW = parcelRequire("4S8NW");
const $a207f1a86ad497aa$export$47d5b79f3ddf0b92 = (appearance)=>{
    if (appearance === 'full-width') return (0, $4S8NW.FULL_WIDTH_MODE).FULL_WIDTH;
    return (0, $4S8NW.FULL_WIDTH_MODE).FIXED_WIDTH;
};

});



parcelRegister("bqVsL", function(module, exports) {
$parcel$export(module.exports, "EditorInternalContainerCompiled", () => $4223eb9f679ce46f$export$f01d938f9288b4e1);
/* editor-internal-compiled.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
const $4223eb9f679ce46f$var$editorContainerCompiledStyles = {
    root: "_kqswh2mm _1bsb1osq _4t3i1osq"
};
const $4223eb9f679ce46f$export$f01d938f9288b4e1 = ({ children: children, fontSize: fontSize })=>/*#__PURE__*/ (0, $dc70d.jsx)("div", {
        style: {
            '--ak-editor-base-font-size': `${fontSize}px`
        },
        className: (0, $9fU1q.default)([
            $4223eb9f679ce46f$var$editorContainerCompiledStyles.root
        ]),
        children: children
    });

});


parcelRegister("cUwhT", function(module, exports) {
$parcel$export(module.exports, "default", () => $238e9270bb2b715d$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $g6Qq4 = parcelRequire("g6Qq4");

var $951G5 = parcelRequire("951G5");

var $l9YiQ = parcelRequire("l9YiQ");

var $6AIuh = parcelRequire("6AIuh");

var $lC766 = parcelRequire("lC766");
function $238e9270bb2b715d$export$2e2bcd8739ae039(props, createAnalyticsEvent) {
    (0, $lC766.default)();
    (0, $bSJIT.useEffect)(()=>{
        (0, $951G5.stopMeasure)((0, $l9YiQ.default).EDITOR_MOUNTED, (0, $6AIuh.default)((0, $g6Qq4.ACTION).EDITOR_MOUNTED, props, createAnalyticsEvent));
        return ()=>{
            (0, $951G5.clearMeasure)((0, $l9YiQ.default).EDITOR_MOUNTED);
            (0, $951G5.clearMeasure)((0, $l9YiQ.default).ON_EDITOR_READY_CALLBACK);
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
// Disable Exhaustive Deps here since we only want to stop the measure on mount.
}

});
parcelRegister("6AIuh", function(module, exports) {
$parcel$export(module.exports, "default", () => $7c07b9ec1932ebfd$export$2e2bcd8739ae039);

var $bTWXs = parcelRequire("bTWXs");

var $g6Qq4 = parcelRequire("g6Qq4");
function $7c07b9ec1932ebfd$export$2e2bcd8739ae039(action, props, createAnalyticsEvent) {
    return async (duration, startTime)=>{
        const contextIdentifier = await props.contextIdentifierProvider;
        const objectId = contextIdentifier === null || contextIdentifier === void 0 ? void 0 : contextIdentifier.objectId;
        if (createAnalyticsEvent) (0, $bTWXs.fireAnalyticsEvent)(createAnalyticsEvent)({
            payload: {
                action: action,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).EDITOR,
                attributes: {
                    duration: duration,
                    startTime: startTime,
                    objectId: objectId
                },
                eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL
            }
        });
    };
}

});

parcelRegister("lC766", function(module, exports) {
$parcel$export(module.exports, "default", () => $67c776138b54fdca$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $951G5 = parcelRequire("951G5");

var $19de6 = parcelRequire("19de6");

var $l9YiQ = parcelRequire("l9YiQ");
function $67c776138b54fdca$export$2e2bcd8739ae039() {
    (0, $19de6.default)(()=>{
        (0, $951G5.startMeasure)((0, $l9YiQ.default).EDITOR_MOUNTED);
    });
}

});


parcelRegister("kMBaN", function(module, exports) {
$parcel$export(module.exports, "default", () => $59027617dd172e2d$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");
const $59027617dd172e2d$export$d9d7e48a5f16fb4d = (passedProps)=>{
    const memodProps = (0, $bSJIT.useMemo)(()=>{
        // That sounds awful but this is the only way to make sure we didn't missed any EditorProps
        const allProps = {
            preset: passedProps.preset,
            appearance: passedProps.appearance,
            contentMode: passedProps.contentMode,
            contentComponents: passedProps.contentComponents,
            primaryToolbarIconBefore: passedProps.primaryToolbarIconBefore,
            secondaryToolbarComponents: passedProps.secondaryToolbarComponents,
            persistScrollGutter: passedProps.persistScrollGutter,
            quickInsert: passedProps.quickInsert,
            shouldFocus: passedProps.shouldFocus,
            disabled: passedProps.disabled,
            contextPanel: passedProps.contextPanel,
            errorReporterHandler: passedProps.errorReporterHandler,
            contentTransformerProvider: passedProps.contentTransformerProvider,
            maxHeight: passedProps.maxHeight,
            minHeight: passedProps.minHeight,
            placeholder: passedProps.placeholder,
            placeholderBracketHint: passedProps.placeholderBracketHint,
            defaultValue: passedProps.defaultValue,
            assistiveLabel: passedProps.assistiveLabel,
            assistiveDescribedBy: passedProps.assistiveDescribedBy,
            popupsMountPoint: passedProps.popupsMountPoint,
            popupsBoundariesElement: passedProps.popupsBoundariesElement,
            popupsScrollableElement: passedProps.popupsScrollableElement,
            editorActions: passedProps.editorActions,
            onEditorReady: passedProps.onEditorReady,
            onDestroy: passedProps.onDestroy,
            onChange: passedProps.onChange,
            onCancel: passedProps.onCancel,
            extensionProviders: passedProps.extensionProviders,
            UNSAFE_useAnalyticsContext: passedProps.UNSAFE_useAnalyticsContext,
            useStickyToolbar: passedProps.useStickyToolbar,
            isEditorModernisationEnabled: passedProps.isEditorModernisationEnabled,
            featureFlags: passedProps.featureFlags,
            onSave: passedProps.onSave,
            sanitizePrivateContent: passedProps.sanitizePrivateContent,
            media: passedProps.media,
            collabEdit: passedProps.collabEdit,
            primaryToolbarComponents: passedProps.primaryToolbarComponents,
            performanceTracking: passedProps.performanceTracking,
            inputSamplingLimit: passedProps.inputSamplingLimit,
            allowUndoRedoButtons: passedProps.allowUndoRedoButtons,
            linking: passedProps.linking,
            activityProvider: passedProps.activityProvider,
            searchProvider: passedProps.searchProvider,
            annotationProviders: passedProps.annotationProviders,
            collabEditProvider: passedProps.collabEditProvider,
            presenceProvider: passedProps.presenceProvider,
            emojiProvider: passedProps.emojiProvider,
            taskDecisionProvider: passedProps.taskDecisionProvider,
            legacyImageUploadProvider: passedProps.legacyImageUploadProvider,
            mentionProvider: passedProps.mentionProvider,
            autoformattingProvider: passedProps.autoformattingProvider,
            macroProvider: passedProps.macroProvider,
            contextIdentifierProvider: passedProps.contextIdentifierProvider,
            allowExpand: passedProps.allowExpand,
            allowNestedTasks: passedProps.allowNestedTasks,
            allowBlockType: passedProps.allowBlockType,
            allowTasksAndDecisions: passedProps.allowTasksAndDecisions,
            allowBreakout: passedProps.allowBreakout,
            allowRule: passedProps.allowRule,
            allowHelpDialog: passedProps.allowHelpDialog,
            allowPanel: passedProps.allowPanel,
            allowExtension: passedProps.allowExtension,
            allowConfluenceInlineComment: passedProps.allowConfluenceInlineComment,
            allowTemplatePlaceholders: passedProps.allowTemplatePlaceholders,
            allowDate: passedProps.allowDate,
            allowLayouts: passedProps.allowLayouts,
            allowStatus: passedProps.allowStatus,
            allowTextAlignment: passedProps.allowTextAlignment,
            allowIndentation: passedProps.allowIndentation,
            showIndentationButtons: passedProps.showIndentationButtons,
            allowFindReplace: passedProps.allowFindReplace,
            allowBorderMark: passedProps.allowBorderMark,
            allowFragmentMark: passedProps.allowFragmentMark,
            autoScrollIntoView: passedProps.autoScrollIntoView,
            elementBrowser: passedProps.elementBrowser,
            maxContentSize: passedProps.maxContentSize,
            saveOnEnter: passedProps.saveOnEnter,
            feedbackInfo: passedProps.feedbackInfo,
            mention: passedProps.mention,
            mentionInsertDisplayName: passedProps.mentionInsertDisplayName,
            uploadErrorHandler: passedProps.uploadErrorHandler,
            onSSRMeasure: passedProps.onSSRMeasure,
            waitForMediaUpload: passedProps.waitForMediaUpload,
            extensionHandlers: passedProps.extensionHandlers,
            allowTextColor: passedProps.allowTextColor,
            allowTables: passedProps.allowTables,
            insertMenuItems: passedProps.insertMenuItems,
            UNSAFE_cards: passedProps.UNSAFE_cards,
            smartLinks: passedProps.smartLinks,
            allowAnalyticsGASV3: passedProps.allowAnalyticsGASV3,
            codeBlock: passedProps.codeBlock,
            textFormatting: passedProps.textFormatting,
            __livePage: passedProps.__livePage,
            AppearanceComponent: passedProps.AppearanceComponent,
            skipValidation: passedProps.skipValidation,
            syncBlock: passedProps.syncBlock,
            syncedBlockProvider: passedProps.syncedBlockProvider,
            pasteWarningOptions: passedProps.pasteWarningOptions,
            UNSAFE_containLayout: passedProps.UNSAFE_containLayout
        };
        const defaultProps = {
            appearance: 'comment',
            disabled: false,
            quickInsert: true
        };
        const nextProps = {
            ...defaultProps,
            ...allProps
        };
        return nextProps;
    }, [
        passedProps.preset,
        passedProps.appearance,
        passedProps.contentMode,
        passedProps.contentComponents,
        passedProps.primaryToolbarIconBefore,
        passedProps.secondaryToolbarComponents,
        passedProps.persistScrollGutter,
        passedProps.quickInsert,
        passedProps.shouldFocus,
        passedProps.disabled,
        passedProps.contextPanel,
        passedProps.errorReporterHandler,
        passedProps.contentTransformerProvider,
        passedProps.maxHeight,
        passedProps.minHeight,
        passedProps.placeholder,
        passedProps.placeholderBracketHint,
        passedProps.performanceTracking,
        passedProps.inputSamplingLimit,
        passedProps.defaultValue,
        passedProps.assistiveLabel,
        passedProps.assistiveDescribedBy,
        passedProps.popupsMountPoint,
        passedProps.popupsBoundariesElement,
        passedProps.popupsScrollableElement,
        passedProps.editorActions,
        passedProps.onEditorReady,
        passedProps.onDestroy,
        passedProps.onChange,
        passedProps.onCancel,
        passedProps.onSSRMeasure,
        passedProps.extensionProviders,
        passedProps.UNSAFE_useAnalyticsContext,
        passedProps.useStickyToolbar,
        passedProps.isEditorModernisationEnabled,
        passedProps.featureFlags,
        passedProps.onSave,
        passedProps.sanitizePrivateContent,
        passedProps.media,
        passedProps.collabEdit,
        passedProps.primaryToolbarComponents,
        passedProps.allowUndoRedoButtons,
        passedProps.linking,
        passedProps.activityProvider,
        passedProps.searchProvider,
        passedProps.annotationProviders,
        passedProps.collabEditProvider,
        passedProps.presenceProvider,
        passedProps.emojiProvider,
        passedProps.taskDecisionProvider,
        passedProps.legacyImageUploadProvider,
        passedProps.mentionProvider,
        passedProps.autoformattingProvider,
        passedProps.macroProvider,
        passedProps.contextIdentifierProvider,
        passedProps.allowExpand,
        passedProps.allowNestedTasks,
        passedProps.allowBlockType,
        passedProps.allowTasksAndDecisions,
        passedProps.allowBreakout,
        passedProps.allowRule,
        passedProps.allowHelpDialog,
        passedProps.allowPanel,
        passedProps.allowExtension,
        passedProps.allowConfluenceInlineComment,
        passedProps.allowTemplatePlaceholders,
        passedProps.allowDate,
        passedProps.allowLayouts,
        passedProps.allowStatus,
        passedProps.allowTextAlignment,
        passedProps.allowIndentation,
        passedProps.showIndentationButtons,
        passedProps.allowFindReplace,
        passedProps.allowBorderMark,
        passedProps.allowFragmentMark,
        passedProps.autoScrollIntoView,
        passedProps.elementBrowser,
        passedProps.maxContentSize,
        passedProps.saveOnEnter,
        passedProps.feedbackInfo,
        passedProps.mention,
        passedProps.mentionInsertDisplayName,
        passedProps.uploadErrorHandler,
        passedProps.waitForMediaUpload,
        passedProps.extensionHandlers,
        passedProps.allowTextColor,
        passedProps.allowTables,
        passedProps.insertMenuItems,
        passedProps.UNSAFE_cards,
        passedProps.smartLinks,
        passedProps.allowAnalyticsGASV3,
        passedProps.codeBlock,
        passedProps.textFormatting,
        passedProps.__livePage,
        passedProps.AppearanceComponent,
        passedProps.skipValidation,
        passedProps.syncBlock,
        passedProps.syncedBlockProvider,
        passedProps.pasteWarningOptions,
        passedProps.UNSAFE_containLayout
    ]);
    return memodProps;
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$59027617dd172e2d$export$2e2bcd8739ae039 = $59027617dd172e2d$export$d9d7e48a5f16fb4d;

});

parcelRegister("6PsdZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $921a2da88f3344e4$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $5zxDU = parcelRequire("5zxDU");

var $eczqR = parcelRequire("eczqR");

var $6ME30 = parcelRequire("6ME30");

var $fSZYE = parcelRequire("fSZYE");

var $j5Zfs = parcelRequire("j5Zfs");
function $921a2da88f3344e4$var$useEditorRef(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
preset) {
    const apiRef = (0, $bSJIT.useRef)();
    (0, $bSJIT.useEffect)(()=>{
        return preset === null || preset === void 0 ? void 0 : preset.apiResolver.on((api)=>{
            apiRef.current = api;
        });
    }, [
        preset === null || preset === void 0 ? void 0 : preset.apiResolver
    ]);
    return apiRef;
}
function $921a2da88f3344e4$var$prepareProviders(editorActions, apiRef, quickInsert, extensionProviders, createAnalyticsEvent) {
    const extensionProvider = (0, $eczqR.default)(()=>editorActions)(extensionProviders);
    const quickInsertProvider = (0, $6ME30.default)(editorActions, apiRef, extensionProvider, quickInsert, createAnalyticsEvent);
    return {
        extensionProvider: extensionProvider,
        quickInsertProvider: quickInsertProvider
    };
}
function $921a2da88f3344e4$export$2e2bcd8739ae039(props, editorActions, createAnalyticsEvent) {
    const { autoformattingProvider: autoformattingProvider, emojiProvider: emojiProvider, mentionProvider: mentionProvider, legacyImageUploadProvider: legacyImageUploadProvider, taskDecisionProvider: taskDecisionProvider, contextIdentifierProvider: contextIdentifierProvider, searchProvider: searchProvider, macroProvider: macroProvider, activityProvider: activityProvider, collabEdit: collabEdit, collabEditProvider: collabEditProvider, presenceProvider: presenceProvider, quickInsert: quickInsert, extensionProviders: extensionProviders } = props;
    const providers = (0, $bSJIT.useMemo)(()=>(0, $fSZYE.default)({
            autoformattingProvider: autoformattingProvider,
            emojiProvider: emojiProvider,
            mentionProvider: mentionProvider,
            legacyImageUploadProvider: legacyImageUploadProvider,
            taskDecisionProvider: taskDecisionProvider,
            contextIdentifierProvider: contextIdentifierProvider,
            searchProvider: searchProvider,
            macroProvider: macroProvider,
            activityProvider: activityProvider,
            collabEdit: collabEdit,
            collabEditProvider: collabEditProvider,
            presenceProvider: presenceProvider
        }), [
        autoformattingProvider,
        emojiProvider,
        mentionProvider,
        legacyImageUploadProvider,
        taskDecisionProvider,
        contextIdentifierProvider,
        searchProvider,
        macroProvider,
        activityProvider,
        collabEdit,
        collabEditProvider,
        presenceProvider
    ]);
    const providerFactory = (0, $bSJIT.useRef)(new (0, $5zxDU.default)());
    const editorRef = $921a2da88f3344e4$var$useEditorRef(props.preset);
    const preparedProviders = (0, $bSJIT.useMemo)(()=>// Though this will introduce some performance regression related to quick insert
        // loading but we can remove it soon when Forge will move to new API.
        // quickInsert={Promise.resolve(consumerQuickInsert)} is one of the main reason behind this performance issue.
        $921a2da88f3344e4$var$prepareProviders(editorActions, editorRef, quickInsert, extensionProviders, createAnalyticsEvent), [
        extensionProviders,
        quickInsert,
        editorActions,
        createAnalyticsEvent,
        editorRef
    ]);
    (0, $bSJIT.useEffect)(()=>{
        (0, $j5Zfs.default)(providerFactory.current, providers, preparedProviders.extensionProvider, preparedProviders.quickInsertProvider);
    }, [
        providers,
        preparedProviders
    ]);
    // componentWillUnmount equivalent
    (0, $bSJIT.useEffect)(()=>{
        return ()=>{
            // Disable this next line because it is not a React node
            // so we can safely call destroy on the ref.
            // eslint-disable-next-line react-hooks/exhaustive-deps
            providerFactory.current.destroy();
        };
    }, []);
    return providerFactory.current;
}

});
parcelRegister("eczqR", function(module, exports) {
$parcel$export(module.exports, "default", () => $6a478f2712c7c6ef$export$2e2bcd8739ae039);

var $57l7A = parcelRequire("57l7A");

var $ctQbi = parcelRequire("ctQbi");
function $6a478f2712c7c6ef$var$prepareExtensionProvidersInternal(editorActions, extensionProviders) {
    if (!extensionProviders) return;
    if (typeof extensionProviders === 'function') return (0, $ctQbi.default)(extensionProviders(editorActions));
    return (0, $ctQbi.default)(extensionProviders);
}
const $6a478f2712c7c6ef$var$prepareExtensionProvider = (getEditorActions)=>(0, $57l7A.default)((extensionProviders)=>$6a478f2712c7c6ef$var$prepareExtensionProvidersInternal(getEditorActions(), extensionProviders));
var $6a478f2712c7c6ef$export$2e2bcd8739ae039 = $6a478f2712c7c6ef$var$prepareExtensionProvider;

});

parcelRegister("6ME30", function(module, exports) {
$parcel$export(module.exports, "default", () => $e1b1e82344aa6c6b$export$2e2bcd8739ae039);

var $3Fd0H = parcelRequire("3Fd0H");

var $dty20 = parcelRequire("dty20");
function $e1b1e82344aa6c6b$export$2e2bcd8739ae039(editorActions, apiRef, extensionProvider, quickInsert, createAnalyticsEvent) {
    const quickInsertProvider = quickInsert && typeof quickInsert !== 'boolean' && quickInsert.provider;
    const extensionQuickInsertProvider = extensionProvider && (0, $dty20.extensionProviderToQuickInsertProvider)(extensionProvider, editorActions, apiRef, createAnalyticsEvent);
    return quickInsertProvider && extensionQuickInsertProvider ? Promise.resolve((0, $3Fd0H.combineQuickInsertProviders)([
        quickInsertProvider,
        extensionQuickInsertProvider
    ])) : quickInsertProvider || extensionQuickInsertProvider;
}

});
parcelRegister("3Fd0H", function(module, exports) {
$parcel$export(module.exports, "combineQuickInsertProviders", () => $5194c255f313563c$export$e3759a254d73dcb7);

var $83V7I = parcelRequire("83V7I");
function $5194c255f313563c$export$e3759a254d73dcb7(quickInsertProviders) {
    const { invokeList: invokeList, invokeOptionalList: invokeOptionalList } = (0, $83V7I.default)(quickInsertProviders);
    return {
        getComponents () {
            return invokeOptionalList('getComponents');
        },
        getItems () {
            return invokeList('getItems');
        }
    };
}

});

parcelRegister("dty20", function(module, exports) {
$parcel$export(module.exports, "extensionProviderToQuickInsertProvider", () => $32ba905dd684aff7$export$6b0bb34c2583056f);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $deAR2 = parcelRequire("deAR2");

var $cJJTb = parcelRequire("cJJTb");

var $bTWXs = parcelRequire("bTWXs");

var $g6Qq4 = parcelRequire("g6Qq4");

var $6o5zV = parcelRequire("6o5zV");

var $kky6V = parcelRequire("kky6V");

var $6m8Z0 = parcelRequire("6m8Z0");

var $3y2s4 = parcelRequire("3y2s4");

var $2up0m = parcelRequire("2up0m");
/**
 * Utils to send analytics event when an extension is inserted using quickInsert
 */ function $32ba905dd684aff7$var$sendExtensionQuickInsertAnalytics(item, selection, createAnalyticsEvent, source) {
    if (createAnalyticsEvent) {
        const insertLocation = (0, $6m8Z0.findInsertLocation)(selection);
        (0, $bTWXs.fireAnalyticsEvent)(createAnalyticsEvent)({
            payload: {
                action: (0, $g6Qq4.ACTION).INSERTED,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).DOCUMENT,
                actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).EXTENSION,
                attributes: {
                    extensionType: item.extensionType,
                    extensionKey: item.extensionKey,
                    key: item.key,
                    inputMethod: source || (0, $g6Qq4.INPUT_METHOD).QUICK_INSERT,
                    ...insertLocation ? {
                        insertLocation: insertLocation
                    } : {}
                },
                eventType: (0, $g6Qq4.EVENT_TYPE).TRACK
            }
        });
    }
}
const $32ba905dd684aff7$var$showDummyAPIWarning = (location)=>{};
const $32ba905dd684aff7$var$dummyExtensionAPI = {
    editInContextPanel: ()=>$32ba905dd684aff7$var$showDummyAPIWarning('editInContextPanel'),
    _editInLegacyMacroBrowser: ()=>$32ba905dd684aff7$var$showDummyAPIWarning('_editInLegacyMacroBrowser'),
    getNodeWithPosByLocalId: ()=>({
            node: null,
            pos: null
        }),
    doc: {
        insertAfter: ()=>$32ba905dd684aff7$var$showDummyAPIWarning('doc:insertAfter'),
        scrollTo: ()=>$32ba905dd684aff7$var$showDummyAPIWarning('doc:scrollTo'),
        update: ()=>$32ba905dd684aff7$var$showDummyAPIWarning('doc:update')
    }
};
// Keep lazy icon component identities stable across menu unmounts and remounts.
const $32ba905dd684aff7$var$lazyExtensionIconCache = new WeakMap();
const $32ba905dd684aff7$var$LazyExtensionIcon = ({ iconLoader: iconLoader })=>{
    let Icon = $32ba905dd684aff7$var$lazyExtensionIconCache.get(iconLoader);
    if (!Icon) {
        Icon = (0, $cJJTb.lazy)(()=>iconLoader(), {});
        $32ba905dd684aff7$var$lazyExtensionIconCache.set(iconLoader, Icon);
    }
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $cJJTb.LazySuspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $dc70d.jsx)(Icon, {
            label: ""
        })
    });
};
async function $32ba905dd684aff7$export$6b0bb34c2583056f(extensionProvider, editorActions, apiRef, createAnalyticsEvent) {
    const extensions = await extensionProvider.getExtensions();
    const getMenuItems = ()=>(0, $kky6V.getQuickInsertItemsFromModule)(extensions, (item)=>item);
    return {
        getComponents: ()=>{
            var _apiRef$current;
            const isMarkdownMode = (_apiRef$current = apiRef.current) === null || _apiRef$current === void 0 || (_apiRef$current = _apiRef$current.markdownMode) === null || _apiRef$current === void 0 || (_apiRef$current = _apiRef$current.sharedState.currentState()) === null || _apiRef$current === void 0 ? void 0 : _apiRef$current.isMarkdownMode;
            if (!(0, $3y2s4.isExperimentEnabled)('platform_editor_slash_command') || isMarkdownMode) return Promise.resolve([]);
            return Promise.resolve((0, $2up0m.getExtensionQuickInsertComponents)({
                apiRef: apiRef,
                createAnalyticsEvent: createAnalyticsEvent,
                editorActions: editorActions,
                items: getMenuItems()
            }));
        },
        getItems: ()=>{
            var _apiRef$current2;
            // `extensionProvider` is supplied independently of the preset, so
            // suppress its items in markdown mode where rich-only content cannot
            // be inserted. See `MarkdownModeReader` above for why this is read
            // via a structural cast rather than the typed plugin API.
            const isMarkdownMode = (_apiRef$current2 = apiRef.current) === null || _apiRef$current2 === void 0 || (_apiRef$current2 = _apiRef$current2.markdownMode) === null || _apiRef$current2 === void 0 || (_apiRef$current2 = _apiRef$current2.sharedState.currentState()) === null || _apiRef$current2 === void 0 ? void 0 : _apiRef$current2.isMarkdownMode;
            if (isMarkdownMode) return Promise.resolve([]);
            const quickInsertItems = (0, $kky6V.getQuickInsertItemsFromModule)(extensions, (item)=>{
                return {
                    ...item.app ? {
                        app: item.app
                    } : {},
                    // Add module key so typeahead/quick-insert can identify items
                    // **locale-agnostically**! nb: we _already_ send key in analytics
                    // events, this standardises and makes our items more predictable.
                    key: item.key,
                    title: item.title,
                    description: item.description,
                    ...item.preview ? {
                        preview: item.preview
                    } : {},
                    icon: ()=>{
                        if ((0, $3y2s4.isExperimentEnabled)('platform_editor_loosely_lazy_migration')) return /*#__PURE__*/ (0, $dc70d.jsx)($32ba905dd684aff7$var$LazyExtensionIcon, {
                            iconLoader: item.icon
                        });
                        const Icon = (0, (/*@__PURE__*/$parcel$interopDefault($deAR2)))({
                            loader: item.icon,
                            loading: ()=>null
                        });
                        return /*#__PURE__*/ (0, $dc70d.jsx)(Icon, {
                            label: ""
                        });
                    },
                    keywords: item.keywords,
                    featured: item.featured,
                    priority: item.priority,
                    ...item.category ? {
                        category: item.category
                    } : {},
                    categories: item.categories,
                    ...item.lozenge != null && {
                        lozenge: item.lozenge
                    },
                    ...item.isHidden ? {
                        isHidden: item.isHidden
                    } : {},
                    isDisabledOffline: true,
                    // This legacy action intentionally mirrors executeExtensionQuickInsertItem,
                    // which serves the registered representation of the same item.
                    action: (insert, state, source)=>{
                        if (typeof item.node === 'function') {
                            var _apiRef$current3;
                            const extensionAPI = apiRef === null || apiRef === void 0 || (_apiRef$current3 = apiRef.current) === null || _apiRef$current3 === void 0 || (_apiRef$current3 = _apiRef$current3.extension) === null || _apiRef$current3 === void 0 || (_apiRef$current3 = _apiRef$current3.actions) === null || _apiRef$current3 === void 0 ? void 0 : _apiRef$current3.api();
                            // While this should only run when the extension some setups of editor
                            // may not have the extension API
                            if (extensionAPI) (0, $6o5zV.resolveImport)(item.node(extensionAPI)).then((node)=>{
                                $32ba905dd684aff7$var$sendExtensionQuickInsertAnalytics(item, state.selection, createAnalyticsEvent, source);
                                if (node) editorActions.replaceSelection(node);
                            });
                            else // Originally it was understood we could only use this if we were using the extension plugin
                            // However there are some edge cases where this is not true (ie. in jira)
                            // Since making it optional now would be a breaking change - instead we can just pass a dummy extension API to consumers that warns them of using the methods.
                            (0, $6o5zV.resolveImport)(item.node($32ba905dd684aff7$var$dummyExtensionAPI)).then((node)=>{
                                $32ba905dd684aff7$var$sendExtensionQuickInsertAnalytics(item, state.selection, createAnalyticsEvent, source);
                                if (node) editorActions.replaceSelection(node);
                            });
                            return insert('');
                        } else {
                            $32ba905dd684aff7$var$sendExtensionQuickInsertAnalytics(item, state.selection, createAnalyticsEvent, source);
                            return insert(item.node);
                        }
                    }
                };
            });
            return Promise.all(quickInsertItems);
        }
    };
}

});
parcelRegister("kky6V", function(module, exports) {
$parcel$export(module.exports, "getQuickInsertItemsFromModule", () => $357bc6146791bed4$export$a1d0004a197b97a3);
$parcel$export(module.exports, "getExtensionAutoConvertersFromProvider", () => $357bc6146791bed4$export$38a3a11e6509754a);
$parcel$export(module.exports, "getContextualToolbarItemsFromModule", () => $357bc6146791bed4$export$9d13b95c50a2a6c9);

var $87yMV = parcelRequire("87yMV");

var $3v1JZ = parcelRequire("3v1JZ");


const $357bc6146791bed4$export$a1d0004a197b97a3 = (extensions, transformFunction)=>{
    const items = extensions.map((manifest)=>{
        const modules = manifest.modules.quickInsert || [];
        return modules.map((extensionModule)=>(0, $87yMV.buildMenuItem)(manifest, extensionModule));
    });
    const flatItems = [].concat(...items);
    return flatItems.map(transformFunction);
};
async function $357bc6146791bed4$export$38a3a11e6509754a(extensionProviderPromise) {
    const extensionProvider = await extensionProviderPromise;
    const extensionAutoConverters = await extensionProvider.getAutoConverter();
    return (0, $3v1JZ.createAutoConverterRunner)(extensionAutoConverters);
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $357bc6146791bed4$var$logError = (msg, ...args)=>{
    // eslint-disable-next-line no-console
    console.error(msg, ...args);
};
const $357bc6146791bed4$var$toolbarItemToButtonConfig = (toolbarButton, parentKey)=>{
    const { tooltip: tooltip, tooltipStyle: tooltipStyle, key: key, label: label, ariaLabel: ariaLabel, icon: icon, action: action, disabled: disabled } = toolbarButton;
    const itemKey = [
        parentKey,
        key
    ].join(':');
    if (typeof action !== 'function') $357bc6146791bed4$var$logError(`Provided action is not a function for extension toolbar button: ${label} (${itemKey})`);
    let labelAndIcon = {};
    switch(toolbarButton.display){
        case 'icon':
            if (!icon) $357bc6146791bed4$var$logError(`icon should be provided for extension toolbar button (${itemKey}), when display is set to 'icon'`);
            labelAndIcon = {
                icon: icon
            };
            break;
        case 'label':
            if (!label) $357bc6146791bed4$var$logError(`label should be provided for extension toolbar button (${itemKey}), when display is set to 'label'`);
            labelAndIcon = {
                label: label
            };
            break;
        default:
            if (!label || !icon) $357bc6146791bed4$var$logError(`label and icon should be provided for extension toolbar button (${itemKey}), when display is not set or set to 'icon-and-label'`);
            labelAndIcon = {
                icon: icon,
                label: label
            };
            break;
    }
    return {
        key: itemKey,
        ariaLabel: ariaLabel,
        tooltip: tooltip,
        tooltipStyle: tooltipStyle,
        action: action,
        disabled: disabled,
        ...labelAndIcon
    };
};
const $357bc6146791bed4$var$compareContext = (contextA, contextB)=>{
    if (contextA.type === contextB.type && contextA.nodeType === contextB.nodeType) {
        if (contextA.type === 'node') return true;
        if (contextA.type === 'extension' && contextB.type === 'extension') return contextA.extensionKey === contextB.extensionKey && contextA.extensionType === contextB.extensionType;
    }
    return false;
};
const $357bc6146791bed4$var$hasDuplicateContext = (contextualToolbars)=>{
    if (contextualToolbars.length > 1) {
        const contexts = contextualToolbars.map((contextualToolbar)=>contextualToolbar.context);
        return contexts.find((currentContext, currentIndex)=>currentIndex !== contexts.findIndex((context)=>$357bc6146791bed4$var$compareContext(currentContext, context)));
    }
};
const $357bc6146791bed4$export$9d13b95c50a2a6c9 = (extensions, node, api)=>{
    return extensions.map((extension)=>{
        if (extension.modules.contextualToolbars) {
            const duplicateContext = $357bc6146791bed4$var$hasDuplicateContext(extension.modules.contextualToolbars);
            if (duplicateContext) {
                $357bc6146791bed4$var$logError(`[contextualToolbars] Duplicate context detected - ${JSON.stringify(duplicateContext)}.`);
                return [];
            }
            return extension.modules.contextualToolbars.map((contextualToolbar)=>{
                if ($357bc6146791bed4$var$shouldAddExtensionItemForNode(contextualToolbar, node)) {
                    const { toolbarItems: toolbarItems } = contextualToolbar;
                    if (typeof toolbarItems === 'function') return toolbarItems(node, api);
                    return toolbarItems;
                }
                return [];
            }).flatMap((toolbarItems)=>toolbarItems.map((toolbarItem)=>{
                    if ($357bc6146791bed4$var$isToolbarButton(toolbarItem)) return $357bc6146791bed4$var$toolbarItemToButtonConfig(toolbarItem, extension.key);
                    return toolbarItem;
                }));
        }
        return [];
    }).flatMap((extensionToolbarButtons)=>extensionToolbarButtons);
};
const $357bc6146791bed4$var$isToolbarButton = (toolbarItem)=>{
    if ('type' in toolbarItem) return false;
    return true;
};
// defines whether to add toolbar item for the given node
function $357bc6146791bed4$var$shouldAddExtensionItemForNode(item, node) {
    var _node$attrs;
    // if item type is a standard node - should match the nodeType
    if (item.context.type === 'node' && item.context.nodeType === node.type) return true;
    // for other cases should be an extension and match the nodeType ("extension" | "inlineExtension" | "bodiedExtension" | "multiBodiedExtension")
    if (item.context.type !== 'extension' || node.type !== item.context.nodeType) return false;
    // in cases where we need custom exclusion depending on the node
    if (item.context.shouldExclude) {
        if (item.context.shouldExclude(node)) return false;
    }
    const { extensionType: extensionType, extensionKey: extensionKey } = item.context;
    // if extension type is given - should match extension type
    if (extensionType && extensionType !== ((_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.extensionType)) return false;
    // if extension key is a string
    if (typeof extensionKey === 'string') {
        var _node$attrs2;
        return extensionKey === ((_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.extensionKey);
    }
    // if extension key is an array
    if (Array.isArray(extensionKey) && extensionKey.length) {
        var _node$attrs3;
        return extensionKey.includes((_node$attrs3 = node.attrs) === null || _node$attrs3 === void 0 ? void 0 : _node$attrs3.extensionKey);
    }
    return false;
}

});
parcelRegister("87yMV", function(module, exports) {
$parcel$export(module.exports, "buildMenuItem", () => $95c0386785db3d01$export$30871400b97708b4);

var $3y2s4 = parcelRequire("3y2s4");

var $6o5zV = parcelRequire("6o5zV");
function $95c0386785db3d01$export$30871400b97708b4(manifest, extensionModule) {
    const title = extensionModule.title || manifest.title;
    const key = `${manifest.key}:${extensionModule.key}`;
    const node = (0, $6o5zV.buildAction)(extensionModule.action, manifest);
    const preview = extensionModule.preview ?? manifest.preview;
    const category = (0, $3y2s4.isExperimentEnabled)('platform_editor_slash_command') ? extensionModule.category ?? manifest.category : undefined;
    if (!node) throw new Error(`Couldn't find any action for ${title} (${key})`);
    return {
        app: extensionModule.app ?? manifest.app ?? {
            key: manifest.key
        },
        key: key,
        moduleKey: extensionModule.key,
        title: title,
        extensionType: manifest.type,
        extensionKey: manifest.key,
        keywords: extensionModule.keywords || manifest.keywords || [],
        featured: extensionModule.featured || false,
        // Keep `categories` populated for legacy Quick Insert consumers while
        // the singular category field is introduced.
        ...category !== null && category !== void 0 && category.trim() ? {
            category: category
        } : {},
        categories: category !== null && category !== void 0 && category.trim() ? [
            category
        ] : extensionModule.categories || manifest.categories || [],
        description: extensionModule.description || manifest.description,
        summary: manifest.summary,
        documentationUrl: manifest.documentationUrl,
        priority: extensionModule.priority,
        ...preview != null && {
            preview: preview
        },
        ...extensionModule.lozenge != null && {
            lozenge: extensionModule.lozenge
        },
        ...extensionModule.parameters && {
            parameters: extensionModule.parameters
        },
        icon: extensionModule.icon || manifest.icons['48'],
        ...extensionModule.isHidden ? {
            isHidden: extensionModule.isHidden
        } : {},
        node: node
    };
}

});

parcelRegister("3v1JZ", function(module, exports) {
$parcel$export(module.exports, "createAutoConverterRunner", () => $3a1ca8f3fa7c0b85$export$5ae7aa0814ef4090);
const $3a1ca8f3fa7c0b85$export$5ae7aa0814ef4090 = (autoConvertHandlers)=>(text)=>{
        for (const handler of autoConvertHandlers){
            const result = handler(text);
            if (result) return result;
        }
    };

});


parcelRegister("2up0m", function(module, exports) {
$parcel$export(module.exports, "getExtensionQuickInsertComponents", () => $ec0d9ff35c2a4314$export$52cb7b7c93bddc96);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $b8Hvx = parcelRequire("b8Hvx");

var $4WpTU = parcelRequire("4WpTU");

var $9woaI = parcelRequire("9woaI");

var $am2Qg = parcelRequire("am2Qg");

var $DYnNA = parcelRequire("DYnNA");

var $8hkQp = parcelRequire("8hkQp");
const $ec0d9ff35c2a4314$var$structureExtensionItemKeyRanks = {
    'toc:toc': 600,
    [(0, $9woaI.TABS_MENU_ITEM).key]: 1900,
    'cards:quick-insert': 2000,
    'carousel:quick-insert': 2100,
    'spotlight:quick-insert': 2200,
    'create-from-template:create-from-template': 2700,
    'anchor:anchor': 2900,
    'smart-button:quick-insert': 3000
};
const $ec0d9ff35c2a4314$var$UNRECOGNIZED_STRUCTURE_EXTENSION_ITEM_RANK = 3100;
const $ec0d9ff35c2a4314$var$APP_DATA_AND_CHARTS_ITEM_RANK = 2700;
const $ec0d9ff35c2a4314$var$APP_EMBED_ITEM_RANK = (0, $am2Qg.EXTENSION_ITEM_RANK);
const $ec0d9ff35c2a4314$var$APP_MEDIA_ITEM_RANK = Math.max(...Object.values((0, $am2Qg.MEDIA_SECTION_RANK))) + 100;
const $ec0d9ff35c2a4314$var$APP_OTHER_ITEM_RANK = (0, $am2Qg.EXTENSION_ITEM_RANK);
const $ec0d9ff35c2a4314$var$getStructureExtensionItemRank = (item)=>$ec0d9ff35c2a4314$var$structureExtensionItemKeyRanks[item.key];
const $ec0d9ff35c2a4314$var$isExtensionItemInSection = (item, sectionKey)=>(0, $4WpTU.getQuickInsertMenuItemParents)({
        category: item.category,
        legacyCategories: item.categories,
        rank: 0
    }).some((parent)=>parent.key === sectionKey);
const $ec0d9ff35c2a4314$var$compareMenuItemsByTitleAndKey = (firstItem, secondItem)=>firstItem.title.localeCompare(secondItem.title) || firstItem.key.localeCompare(secondItem.key);
const $ec0d9ff35c2a4314$var$getAlphabeticalItemRanks = (items, isRankedItem, firstRank)=>new Map(items.filter(isRankedItem).sort($ec0d9ff35c2a4314$var$compareMenuItemsByTitleAndKey).map((item, index)=>[
            item,
            firstRank + index
        ]));
const $ec0d9ff35c2a4314$var$hasNoNegativePriority = (item)=>item.priority === undefined || item.priority >= 0;
const $ec0d9ff35c2a4314$var$getSectionAlphabeticalItemRanks = (items, sectionKey, firstRank, isRankedItem = $ec0d9ff35c2a4314$var$hasNoNegativePriority)=>$ec0d9ff35c2a4314$var$getAlphabeticalItemRanks(items, (item)=>$ec0d9ff35c2a4314$var$isExtensionItemInSection(item, sectionKey) && isRankedItem(item), firstRank);
// Rank each parent section separately so a macro in multiple categories gets the right order in each.
const $ec0d9ff35c2a4314$var$createExtensionItemRanker = (items)=>{
    const sections = [
        [
            (0, $9woaI.EMBED_SECTION).key,
            $ec0d9ff35c2a4314$var$APP_EMBED_ITEM_RANK
        ],
        [
            (0, $9woaI.MEDIA_SECTION).key,
            $ec0d9ff35c2a4314$var$APP_MEDIA_ITEM_RANK
        ],
        [
            (0, $9woaI.OTHER_SECTION).key,
            $ec0d9ff35c2a4314$var$APP_OTHER_ITEM_RANK
        ],
        [
            (0, $9woaI.STRUCTURE_SECTION).key,
            $ec0d9ff35c2a4314$var$UNRECOGNIZED_STRUCTURE_EXTENSION_ITEM_RANK,
            (item)=>$ec0d9ff35c2a4314$var$getStructureExtensionItemRank(item) === undefined
        ],
        [
            (0, $9woaI.DATA_AND_CHARTS_SECTION).key,
            $ec0d9ff35c2a4314$var$APP_DATA_AND_CHARTS_ITEM_RANK,
            (item)=>item.priority === undefined
        ]
    ];
    const ranksBySection = new Map(sections.map(([sectionKey, firstRank, isRankedItem])=>[
            sectionKey,
            $ec0d9ff35c2a4314$var$getSectionAlphabeticalItemRanks(items, sectionKey, firstRank, isRankedItem)
        ]));
    return ({ index: index, knownRank: knownRank, item: item, sectionKey: sectionKey })=>{
        var _ranksBySection$get;
        if (knownRank !== undefined) return knownRank;
        if (sectionKey === (0, $9woaI.BLOCK_TEMPLATES_SECTION).key && item.priority !== undefined) return item.priority;
        const sectionRank = (_ranksBySection$get = ranksBySection.get(sectionKey)) === null || _ranksBySection$get === void 0 ? void 0 : _ranksBySection$get.get(item);
        return sectionRank ?? (0, $am2Qg.EXTENSION_ITEM_RANK) + (item.priority ?? index);
    };
};
const $ec0d9ff35c2a4314$export$52cb7b7c93bddc96 = ({ apiRef: apiRef, createAnalyticsEvent: createAnalyticsEvent, editorActions: editorActions, items: items })=>{
    const getExtensionItemRank = $ec0d9ff35c2a4314$var$createExtensionItemRanker(items);
    return items.map((item, index)=>{
        const structureRank = $ec0d9ff35c2a4314$var$getStructureExtensionItemRank(item);
        const isStructureItem = structureRank !== undefined;
        const categories = isStructureItem ? [
            'structure'
        ] : item.categories;
        const parents = (0, $4WpTU.getQuickInsertMenuItemParents)({
            category: item.category,
            legacyCategories: categories,
            rank: 0
        });
        return {
            type: 'menu-item',
            key: item.key,
            isHidden: item.isHidden,
            parents: parents.map((parent)=>({
                    key: parent.key,
                    type: parent.type,
                    rank: getExtensionItemRank({
                        index: index,
                        knownRank: (0, $am2Qg.CREATE_SECTION_RANK)[item.key] ?? structureRank,
                        item: item,
                        sectionKey: parent.key
                    })
                })),
            match: (0, $b8Hvx.createQuickInsertMatcher)(()=>({
                    description: item.description,
                    keywords: item.keywords,
                    title: item.title
                })),
            component: (props)=>{
                const Component = item.extensionType === 'com.atlassian.rovo.skill' ? (0, $8hkQp.QuickInsertSkillMenuItem) : (0, $DYnNA.ExtensionQuickInsertMenuItem);
                return /*#__PURE__*/ (0, $dc70d.jsx)(Component, {
                    apiRef: apiRef,
                    createAnalyticsEvent: createAnalyticsEvent,
                    editorActions: editorActions,
                    item: item,
                    onInsert: props.onInsert
                });
            }
        };
    });
};

});
parcelRegister("b8Hvx", function(module, exports) {
$parcel$export(module.exports, "createQuickInsertMatcher", () => $ed656cab9309742a$export$70e88a6d504b41d8);

var $6NaLT = parcelRequire("6NaLT");

var $3y2s4 = parcelRequire("3y2s4");
const $ed656cab9309742a$var$options = {
    includeScore: true,
    keys: [
        {
            name: 'title',
            weight: 0.57
        },
        {
            name: 'keywords',
            weight: 0.08
        },
        {
            name: 'description',
            weight: 0.04
        },
        {
            name: 'shortcut',
            weight: 0.01
        }
    ],
    threshold: 0.3
};
const $ed656cab9309742a$var$normalizeScore = (score)=>Math.min(1, Math.max(0, score ?? 1));
const $ed656cab9309742a$var$getDescription = (matcher, formatMessage)=>{
    var _getSearchData, _ref;
    return matcher === null || matcher === void 0 || (_getSearchData = (_ref = matcher).getSearchData) === null || _getSearchData === void 0 ? void 0 : _getSearchData.call(_ref, {
        formatMessage: formatMessage
    }).description;
};
const $ed656cab9309742a$export$70e88a6d504b41d8 = (getSearchData)=>{
    let cachedFormatMessage;
    let fuse;
    const matcher = ({ formatMessage: formatMessage, query: query })=>{
        const normalizedQuery = query.trim();
        if (!normalizedQuery) return {
            score: 0
        };
        if (!fuse || cachedFormatMessage !== formatMessage) {
            fuse = new (0, $6NaLT.default)([
                getSearchData({
                    formatMessage: formatMessage
                })
            ], $ed656cab9309742a$var$options);
            cachedFormatMessage = formatMessage;
        }
        const result = fuse.search(normalizedQuery)[0];
        return result ? {
            score: $ed656cab9309742a$var$normalizeScore(result.score)
        } : null;
    };
    if ((0, $3y2s4.isExperimentEnabled)('platform_editor_slash_command')) {
        matcher.getSearchData = getSearchData;
        $ed656cab9309742a$export$70e88a6d504b41d8.getDescription = $ed656cab9309742a$var$getDescription;
    }
    return matcher;
};

});
parcelRegister("6NaLT", function(module, exports) {
$parcel$export(module.exports, "default", () => $4f1facae9bfcfd99$export$2e2bcd8739ae039);
/**
 * Fuse.js v6.6.2 - Lightweight fuzzy-search (http://fusejs.io)
 *
 * Copyright (c) 2022 Kiro Risk (http://kiro.me)
 * All Rights Reserved. Apache Software License 2.0
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 */ function $4f1facae9bfcfd99$var$isArray(value) {
    return !Array.isArray ? $4f1facae9bfcfd99$var$getTag(value) === '[object Array]' : Array.isArray(value);
}
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/baseToString.js
const $4f1facae9bfcfd99$var$INFINITY = 1 / 0;
function $4f1facae9bfcfd99$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    let result = value + '';
    return result == '0' && 1 / value == -$4f1facae9bfcfd99$var$INFINITY ? '-0' : result;
}
function $4f1facae9bfcfd99$var$toString(value) {
    return value == null ? '' : $4f1facae9bfcfd99$var$baseToString(value);
}
function $4f1facae9bfcfd99$var$isString(value) {
    return typeof value === 'string';
}
function $4f1facae9bfcfd99$var$isNumber(value) {
    return typeof value === 'number';
}
// Adapted from: https://github.com/lodash/lodash/blob/master/isBoolean.js
function $4f1facae9bfcfd99$var$isBoolean(value) {
    return value === true || value === false || $4f1facae9bfcfd99$var$isObjectLike(value) && $4f1facae9bfcfd99$var$getTag(value) == '[object Boolean]';
}
function $4f1facae9bfcfd99$var$isObject(value) {
    return typeof value === 'object';
}
// Checks if `value` is object-like.
function $4f1facae9bfcfd99$var$isObjectLike(value) {
    return $4f1facae9bfcfd99$var$isObject(value) && value !== null;
}
function $4f1facae9bfcfd99$var$isDefined(value) {
    return value !== undefined && value !== null;
}
function $4f1facae9bfcfd99$var$isBlank(value) {
    return !value.trim().length;
}
// Gets the `toStringTag` of `value`.
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/getTag.js
function $4f1facae9bfcfd99$var$getTag(value) {
    return value == null ? value === undefined ? '[object Undefined]' : '[object Null]' : Object.prototype.toString.call(value);
}
const $4f1facae9bfcfd99$var$EXTENDED_SEARCH_UNAVAILABLE = 'Extended search is not available';
const $4f1facae9bfcfd99$var$INCORRECT_INDEX_TYPE = "Incorrect 'index' type";
const $4f1facae9bfcfd99$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY = (key)=>`Invalid value for key ${key}`;
const $4f1facae9bfcfd99$var$PATTERN_LENGTH_TOO_LARGE = (max)=>`Pattern length exceeds max of ${max}.`;
const $4f1facae9bfcfd99$var$MISSING_KEY_PROPERTY = (name)=>`Missing ${name} property in key`;
const $4f1facae9bfcfd99$var$INVALID_KEY_WEIGHT_VALUE = (key)=>`Property 'weight' in key '${key}' must be a positive integer`;
const $4f1facae9bfcfd99$var$hasOwn = Object.prototype.hasOwnProperty;
class $4f1facae9bfcfd99$var$KeyStore {
    constructor(keys){
        this._keys = [];
        this._keyMap = {};
        let totalWeight = 0;
        keys.forEach((key)=>{
            let obj = $4f1facae9bfcfd99$var$createKey(key);
            totalWeight += obj.weight;
            this._keys.push(obj);
            this._keyMap[obj.id] = obj;
            totalWeight += obj.weight;
        });
        // Normalize weights so that their sum is equal to 1
        this._keys.forEach((key)=>{
            key.weight /= totalWeight;
        });
    }
    get(keyId) {
        return this._keyMap[keyId];
    }
    keys() {
        return this._keys;
    }
    toJSON() {
        return JSON.stringify(this._keys);
    }
}
function $4f1facae9bfcfd99$var$createKey(key) {
    let path = null;
    let id = null;
    let src = null;
    let weight = 1;
    let getFn = null;
    if ($4f1facae9bfcfd99$var$isString(key) || $4f1facae9bfcfd99$var$isArray(key)) {
        src = key;
        path = $4f1facae9bfcfd99$var$createKeyPath(key);
        id = $4f1facae9bfcfd99$var$createKeyId(key);
    } else {
        if (!$4f1facae9bfcfd99$var$hasOwn.call(key, 'name')) throw new Error($4f1facae9bfcfd99$var$MISSING_KEY_PROPERTY('name'));
        const name = key.name;
        src = name;
        if ($4f1facae9bfcfd99$var$hasOwn.call(key, 'weight')) {
            weight = key.weight;
            if (weight <= 0) throw new Error($4f1facae9bfcfd99$var$INVALID_KEY_WEIGHT_VALUE(name));
        }
        path = $4f1facae9bfcfd99$var$createKeyPath(name);
        id = $4f1facae9bfcfd99$var$createKeyId(name);
        getFn = key.getFn;
    }
    return {
        path: path,
        id: id,
        weight: weight,
        src: src,
        getFn: getFn
    };
}
function $4f1facae9bfcfd99$var$createKeyPath(key) {
    return $4f1facae9bfcfd99$var$isArray(key) ? key : key.split('.');
}
function $4f1facae9bfcfd99$var$createKeyId(key) {
    return $4f1facae9bfcfd99$var$isArray(key) ? key.join('.') : key;
}
function $4f1facae9bfcfd99$var$get(obj, path) {
    let list = [];
    let arr = false;
    const deepGet = (obj, path, index)=>{
        if (!$4f1facae9bfcfd99$var$isDefined(obj)) return;
        if (!path[index]) // If there's no path left, we've arrived at the object we care about.
        list.push(obj);
        else {
            let key = path[index];
            const value = obj[key];
            if (!$4f1facae9bfcfd99$var$isDefined(value)) return;
            // If we're at the last value in the path, and if it's a string/number/bool,
            // add it to the list
            if (index === path.length - 1 && ($4f1facae9bfcfd99$var$isString(value) || $4f1facae9bfcfd99$var$isNumber(value) || $4f1facae9bfcfd99$var$isBoolean(value))) list.push($4f1facae9bfcfd99$var$toString(value));
            else if ($4f1facae9bfcfd99$var$isArray(value)) {
                arr = true;
                // Search each item in the array.
                for(let i = 0, len = value.length; i < len; i += 1)deepGet(value[i], path, index + 1);
            } else if (path.length) // An object. Recurse further.
            deepGet(value, path, index + 1);
        }
    };
    // Backwards compatibility (since path used to be a string)
    deepGet(obj, $4f1facae9bfcfd99$var$isString(path) ? path.split('.') : path, 0);
    return arr ? list : list[0];
}
const $4f1facae9bfcfd99$var$MatchOptions = {
    // Whether the matches should be included in the result set. When `true`, each record in the result
    // set will include the indices of the matched characters.
    // These can consequently be used for highlighting purposes.
    includeMatches: false,
    // When `true`, the matching function will continue to the end of a search pattern even if
    // a perfect match has already been located in the string.
    findAllMatches: false,
    // Minimum number of characters that must be matched before a result is considered a match
    minMatchCharLength: 1
};
const $4f1facae9bfcfd99$var$BasicOptions = {
    // When `true`, the algorithm continues searching to the end of the input even if a perfect
    // match is found before the end of the same input.
    isCaseSensitive: false,
    // When true, the matching function will continue to the end of a search pattern even if
    includeScore: false,
    // List of properties that will be searched. This also supports nested properties.
    keys: [],
    // Whether to sort the result list, by score
    shouldSort: true,
    // Default sort function: sort by ascending score, ascending index
    sortFn: (a, b)=>a.score === b.score ? a.idx < b.idx ? -1 : 1 : a.score < b.score ? -1 : 1
};
const $4f1facae9bfcfd99$var$FuzzyOptions = {
    // Approximately where in the text is the pattern expected to be found?
    location: 0,
    // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match
    // (of both letters and location), a threshold of '1.0' would match anything.
    threshold: 0.6,
    // Determines how close the match must be to the fuzzy location (specified above).
    // An exact letter match which is 'distance' characters away from the fuzzy location
    // would score as a complete mismatch. A distance of '0' requires the match be at
    // the exact location specified, a threshold of '1000' would require a perfect match
    // to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
    distance: 100
};
const $4f1facae9bfcfd99$var$AdvancedOptions = {
    // When `true`, it enables the use of unix-like search commands
    useExtendedSearch: false,
    // The get function to use when fetching an object's properties.
    // The default will search nested paths *ie foo.bar.baz*
    getFn: $4f1facae9bfcfd99$var$get,
    // When `true`, search will ignore `location` and `distance`, so it won't matter
    // where in the string the pattern appears.
    // More info: https://fusejs.io/concepts/scoring-theory.html#fuzziness-score
    ignoreLocation: false,
    // When `true`, the calculation for the relevance score (used for sorting) will
    // ignore the field-length norm.
    // More info: https://fusejs.io/concepts/scoring-theory.html#field-length-norm
    ignoreFieldNorm: false,
    // The weight to determine how much field length norm effects scoring.
    fieldNormWeight: 1
};
var $4f1facae9bfcfd99$var$Config = {
    ...$4f1facae9bfcfd99$var$BasicOptions,
    ...$4f1facae9bfcfd99$var$MatchOptions,
    ...$4f1facae9bfcfd99$var$FuzzyOptions,
    ...$4f1facae9bfcfd99$var$AdvancedOptions
};
const $4f1facae9bfcfd99$var$SPACE = /[^ ]+/g;
// Field-length norm: the shorter the field, the higher the weight.
// Set to 3 decimals to reduce index size.
function $4f1facae9bfcfd99$var$norm(weight = 1, mantissa = 3) {
    const cache = new Map();
    const m = Math.pow(10, mantissa);
    return {
        get (value) {
            const numTokens = value.match($4f1facae9bfcfd99$var$SPACE).length;
            if (cache.has(numTokens)) return cache.get(numTokens);
            // Default function is 1/sqrt(x), weight makes that variable
            const norm = 1 / Math.pow(numTokens, 0.5 * weight);
            // In place of `toFixed(mantissa)`, for faster computation
            const n = parseFloat(Math.round(norm * m) / m);
            cache.set(numTokens, n);
            return n;
        },
        clear () {
            cache.clear();
        }
    };
}
class $4f1facae9bfcfd99$var$FuseIndex {
    constructor({ getFn: getFn = $4f1facae9bfcfd99$var$Config.getFn, fieldNormWeight: fieldNormWeight = $4f1facae9bfcfd99$var$Config.fieldNormWeight } = {}){
        this.norm = $4f1facae9bfcfd99$var$norm(fieldNormWeight, 3);
        this.getFn = getFn;
        this.isCreated = false;
        this.setIndexRecords();
    }
    setSources(docs = []) {
        this.docs = docs;
    }
    setIndexRecords(records = []) {
        this.records = records;
    }
    setKeys(keys = []) {
        this.keys = keys;
        this._keysMap = {};
        keys.forEach((key, idx)=>{
            this._keysMap[key.id] = idx;
        });
    }
    create() {
        if (this.isCreated || !this.docs.length) return;
        this.isCreated = true;
        // List is Array<String>
        if ($4f1facae9bfcfd99$var$isString(this.docs[0])) this.docs.forEach((doc, docIndex)=>{
            this._addString(doc, docIndex);
        });
        else // List is Array<Object>
        this.docs.forEach((doc, docIndex)=>{
            this._addObject(doc, docIndex);
        });
        this.norm.clear();
    }
    // Adds a doc to the end of the index
    add(doc) {
        const idx = this.size();
        if ($4f1facae9bfcfd99$var$isString(doc)) this._addString(doc, idx);
        else this._addObject(doc, idx);
    }
    // Removes the doc at the specified index of the index
    removeAt(idx) {
        this.records.splice(idx, 1);
        // Change ref index of every subsquent doc
        for(let i = idx, len = this.size(); i < len; i += 1)this.records[i].i -= 1;
    }
    getValueForItemAtKeyId(item, keyId) {
        return item[this._keysMap[keyId]];
    }
    size() {
        return this.records.length;
    }
    _addString(doc, docIndex) {
        if (!$4f1facae9bfcfd99$var$isDefined(doc) || $4f1facae9bfcfd99$var$isBlank(doc)) return;
        let record = {
            v: doc,
            i: docIndex,
            n: this.norm.get(doc)
        };
        this.records.push(record);
    }
    _addObject(doc, docIndex) {
        let record = {
            i: docIndex,
            $: {}
        };
        // Iterate over every key (i.e, path), and fetch the value at that key
        this.keys.forEach((key, keyIndex)=>{
            let value = key.getFn ? key.getFn(doc) : this.getFn(doc, key.path);
            if (!$4f1facae9bfcfd99$var$isDefined(value)) return;
            if ($4f1facae9bfcfd99$var$isArray(value)) {
                let subRecords = [];
                const stack = [
                    {
                        nestedArrIndex: -1,
                        value: value
                    }
                ];
                while(stack.length){
                    const { nestedArrIndex: nestedArrIndex, value: value } = stack.pop();
                    if (!$4f1facae9bfcfd99$var$isDefined(value)) continue;
                    if ($4f1facae9bfcfd99$var$isString(value) && !$4f1facae9bfcfd99$var$isBlank(value)) {
                        let subRecord = {
                            v: value,
                            i: nestedArrIndex,
                            n: this.norm.get(value)
                        };
                        subRecords.push(subRecord);
                    } else if ($4f1facae9bfcfd99$var$isArray(value)) value.forEach((item, k)=>{
                        stack.push({
                            nestedArrIndex: k,
                            value: item
                        });
                    });
                }
                record.$[keyIndex] = subRecords;
            } else if ($4f1facae9bfcfd99$var$isString(value) && !$4f1facae9bfcfd99$var$isBlank(value)) {
                let subRecord = {
                    v: value,
                    n: this.norm.get(value)
                };
                record.$[keyIndex] = subRecord;
            }
        });
        this.records.push(record);
    }
    toJSON() {
        return {
            keys: this.keys,
            records: this.records
        };
    }
}
function $4f1facae9bfcfd99$var$createIndex(keys, docs, { getFn: getFn = $4f1facae9bfcfd99$var$Config.getFn, fieldNormWeight: fieldNormWeight = $4f1facae9bfcfd99$var$Config.fieldNormWeight } = {}) {
    const myIndex = new $4f1facae9bfcfd99$var$FuseIndex({
        getFn: getFn,
        fieldNormWeight: fieldNormWeight
    });
    myIndex.setKeys(keys.map($4f1facae9bfcfd99$var$createKey));
    myIndex.setSources(docs);
    myIndex.create();
    return myIndex;
}
function $4f1facae9bfcfd99$var$parseIndex(data, { getFn: getFn = $4f1facae9bfcfd99$var$Config.getFn, fieldNormWeight: fieldNormWeight = $4f1facae9bfcfd99$var$Config.fieldNormWeight } = {}) {
    const { keys: keys, records: records } = data;
    const myIndex = new $4f1facae9bfcfd99$var$FuseIndex({
        getFn: getFn,
        fieldNormWeight: fieldNormWeight
    });
    myIndex.setKeys(keys);
    myIndex.setIndexRecords(records);
    return myIndex;
}
function $4f1facae9bfcfd99$var$computeScore$1(pattern, { errors: errors = 0, currentLocation: currentLocation = 0, expectedLocation: expectedLocation = 0, distance: distance = $4f1facae9bfcfd99$var$Config.distance, ignoreLocation: ignoreLocation = $4f1facae9bfcfd99$var$Config.ignoreLocation } = {}) {
    const accuracy = errors / pattern.length;
    if (ignoreLocation) return accuracy;
    const proximity = Math.abs(expectedLocation - currentLocation);
    if (!distance) // Dodge divide by zero error.
    return proximity ? 1.0 : accuracy;
    return accuracy + proximity / distance;
}
function $4f1facae9bfcfd99$var$convertMaskToIndices(matchmask = [], minMatchCharLength = $4f1facae9bfcfd99$var$Config.minMatchCharLength) {
    let indices = [];
    let start = -1;
    let end = -1;
    let i = 0;
    for(let len = matchmask.length; i < len; i += 1){
        let match = matchmask[i];
        if (match && start === -1) start = i;
        else if (!match && start !== -1) {
            end = i - 1;
            if (end - start + 1 >= minMatchCharLength) indices.push([
                start,
                end
            ]);
            start = -1;
        }
    }
    // (i-1 - start) + 1 => i - start
    if (matchmask[i - 1] && i - start >= minMatchCharLength) indices.push([
        start,
        i - 1
    ]);
    return indices;
}
// Machine word size
const $4f1facae9bfcfd99$var$MAX_BITS = 32;
function $4f1facae9bfcfd99$var$search(text, pattern, patternAlphabet, { location: location = $4f1facae9bfcfd99$var$Config.location, distance: distance = $4f1facae9bfcfd99$var$Config.distance, threshold: threshold = $4f1facae9bfcfd99$var$Config.threshold, findAllMatches: findAllMatches = $4f1facae9bfcfd99$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $4f1facae9bfcfd99$var$Config.minMatchCharLength, includeMatches: includeMatches = $4f1facae9bfcfd99$var$Config.includeMatches, ignoreLocation: ignoreLocation = $4f1facae9bfcfd99$var$Config.ignoreLocation } = {}) {
    if (pattern.length > $4f1facae9bfcfd99$var$MAX_BITS) throw new Error($4f1facae9bfcfd99$var$PATTERN_LENGTH_TOO_LARGE($4f1facae9bfcfd99$var$MAX_BITS));
    const patternLen = pattern.length;
    // Set starting location at beginning text and initialize the alphabet.
    const textLen = text.length;
    // Handle the case when location > text.length
    const expectedLocation = Math.max(0, Math.min(location, textLen));
    // Highest score beyond which we give up.
    let currentThreshold = threshold;
    // Is there a nearby exact match? (speedup)
    let bestLocation = expectedLocation;
    // Performance: only computer matches when the minMatchCharLength > 1
    // OR if `includeMatches` is true.
    const computeMatches = minMatchCharLength > 1 || includeMatches;
    // A mask of the matches, used for building the indices
    const matchMask = computeMatches ? Array(textLen) : [];
    let index;
    // Get all exact matches, here for speed up
    while((index = text.indexOf(pattern, bestLocation)) > -1){
        let score = $4f1facae9bfcfd99$var$computeScore$1(pattern, {
            currentLocation: index,
            expectedLocation: expectedLocation,
            distance: distance,
            ignoreLocation: ignoreLocation
        });
        currentThreshold = Math.min(score, currentThreshold);
        bestLocation = index + patternLen;
        if (computeMatches) {
            let i = 0;
            while(i < patternLen){
                matchMask[index + i] = 1;
                i += 1;
            }
        }
    }
    // Reset the best location
    bestLocation = -1;
    let lastBitArr = [];
    let finalScore = 1;
    let binMax = patternLen + textLen;
    const mask = 1 << patternLen - 1;
    for(let i = 0; i < patternLen; i += 1){
        // Scan for the best match; each iteration allows for one more error.
        // Run a binary search to determine how far from the match location we can stray
        // at this error level.
        let binMin = 0;
        let binMid = binMax;
        while(binMin < binMid){
            const score = $4f1facae9bfcfd99$var$computeScore$1(pattern, {
                errors: i,
                currentLocation: expectedLocation + binMid,
                expectedLocation: expectedLocation,
                distance: distance,
                ignoreLocation: ignoreLocation
            });
            if (score <= currentThreshold) binMin = binMid;
            else binMax = binMid;
            binMid = Math.floor((binMax - binMin) / 2 + binMin);
        }
        // Use the result from this iteration as the maximum for the next.
        binMax = binMid;
        let start = Math.max(1, expectedLocation - binMid + 1);
        let finish = findAllMatches ? textLen : Math.min(expectedLocation + binMid, textLen) + patternLen;
        // Initialize the bit array
        let bitArr = Array(finish + 2);
        bitArr[finish + 1] = (1 << i) - 1;
        for(let j = finish; j >= start; j -= 1){
            let currentLocation = j - 1;
            let charMatch = patternAlphabet[text.charAt(currentLocation)];
            if (computeMatches) // Speed up: quick bool to int conversion (i.e, `charMatch ? 1 : 0`)
            matchMask[currentLocation] = +!!charMatch;
            // First pass: exact match
            bitArr[j] = (bitArr[j + 1] << 1 | 1) & charMatch;
            // Subsequent passes: fuzzy match
            if (i) bitArr[j] |= (lastBitArr[j + 1] | lastBitArr[j]) << 1 | 1 | lastBitArr[j + 1];
            if (bitArr[j] & mask) {
                finalScore = $4f1facae9bfcfd99$var$computeScore$1(pattern, {
                    errors: i,
                    currentLocation: currentLocation,
                    expectedLocation: expectedLocation,
                    distance: distance,
                    ignoreLocation: ignoreLocation
                });
                // This match will almost certainly be better than any existing match.
                // But check anyway.
                if (finalScore <= currentThreshold) {
                    // Indeed it is
                    currentThreshold = finalScore;
                    bestLocation = currentLocation;
                    // Already passed `loc`, downhill from here on in.
                    if (bestLocation <= expectedLocation) break;
                    // When passing `bestLocation`, don't exceed our current distance from `expectedLocation`.
                    start = Math.max(1, 2 * expectedLocation - bestLocation);
                }
            }
        }
        // No hope for a (better) match at greater error levels.
        const score = $4f1facae9bfcfd99$var$computeScore$1(pattern, {
            errors: i + 1,
            currentLocation: expectedLocation,
            expectedLocation: expectedLocation,
            distance: distance,
            ignoreLocation: ignoreLocation
        });
        if (score > currentThreshold) break;
        lastBitArr = bitArr;
    }
    const result = {
        isMatch: bestLocation >= 0,
        // Count exact matches (those with a score of 0) to be "almost" exact
        score: Math.max(0.001, finalScore)
    };
    if (computeMatches) {
        const indices = $4f1facae9bfcfd99$var$convertMaskToIndices(matchMask, minMatchCharLength);
        if (!indices.length) result.isMatch = false;
        else if (includeMatches) result.indices = indices;
    }
    return result;
}
function $4f1facae9bfcfd99$var$createPatternAlphabet(pattern) {
    let mask = {};
    for(let i = 0, len = pattern.length; i < len; i += 1){
        const char = pattern.charAt(i);
        mask[char] = (mask[char] || 0) | 1 << len - i - 1;
    }
    return mask;
}
class $4f1facae9bfcfd99$var$BitapSearch {
    constructor(pattern, { location: location = $4f1facae9bfcfd99$var$Config.location, threshold: threshold = $4f1facae9bfcfd99$var$Config.threshold, distance: distance = $4f1facae9bfcfd99$var$Config.distance, includeMatches: includeMatches = $4f1facae9bfcfd99$var$Config.includeMatches, findAllMatches: findAllMatches = $4f1facae9bfcfd99$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $4f1facae9bfcfd99$var$Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = $4f1facae9bfcfd99$var$Config.isCaseSensitive, ignoreLocation: ignoreLocation = $4f1facae9bfcfd99$var$Config.ignoreLocation } = {}){
        this.options = {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive,
            ignoreLocation: ignoreLocation
        };
        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        this.chunks = [];
        if (!this.pattern.length) return;
        const addChunk = (pattern, startIndex)=>{
            this.chunks.push({
                pattern: pattern,
                alphabet: $4f1facae9bfcfd99$var$createPatternAlphabet(pattern),
                startIndex: startIndex
            });
        };
        const len = this.pattern.length;
        if (len > $4f1facae9bfcfd99$var$MAX_BITS) {
            let i = 0;
            const remainder = len % $4f1facae9bfcfd99$var$MAX_BITS;
            const end = len - remainder;
            while(i < end){
                addChunk(this.pattern.substr(i, $4f1facae9bfcfd99$var$MAX_BITS), i);
                i += $4f1facae9bfcfd99$var$MAX_BITS;
            }
            if (remainder) {
                const startIndex = len - $4f1facae9bfcfd99$var$MAX_BITS;
                addChunk(this.pattern.substr(startIndex), startIndex);
            }
        } else addChunk(this.pattern, 0);
    }
    searchIn(text) {
        const { isCaseSensitive: isCaseSensitive, includeMatches: includeMatches } = this.options;
        if (!isCaseSensitive) text = text.toLowerCase();
        // Exact match
        if (this.pattern === text) {
            let result = {
                isMatch: true,
                score: 0
            };
            if (includeMatches) result.indices = [
                [
                    0,
                    text.length - 1
                ]
            ];
            return result;
        }
        // Otherwise, use Bitap algorithm
        const { location: location, distance: distance, threshold: threshold, findAllMatches: findAllMatches, minMatchCharLength: minMatchCharLength, ignoreLocation: ignoreLocation } = this.options;
        let allIndices = [];
        let totalScore = 0;
        let hasMatches = false;
        this.chunks.forEach(({ pattern: pattern, alphabet: alphabet, startIndex: startIndex })=>{
            const { isMatch: isMatch, score: score, indices: indices } = $4f1facae9bfcfd99$var$search(text, pattern, alphabet, {
                location: location + startIndex,
                distance: distance,
                threshold: threshold,
                findAllMatches: findAllMatches,
                minMatchCharLength: minMatchCharLength,
                includeMatches: includeMatches,
                ignoreLocation: ignoreLocation
            });
            if (isMatch) hasMatches = true;
            totalScore += score;
            if (isMatch && indices) allIndices = [
                ...allIndices,
                ...indices
            ];
        });
        let result = {
            isMatch: hasMatches,
            score: hasMatches ? totalScore / this.chunks.length : 1
        };
        if (hasMatches && includeMatches) result.indices = allIndices;
        return result;
    }
}
class $4f1facae9bfcfd99$var$BaseMatch {
    constructor(pattern){
        this.pattern = pattern;
    }
    static isMultiMatch(pattern) {
        return $4f1facae9bfcfd99$var$getMatch(pattern, this.multiRegex);
    }
    static isSingleMatch(pattern) {
        return $4f1facae9bfcfd99$var$getMatch(pattern, this.singleRegex);
    }
    search() {}
}
function $4f1facae9bfcfd99$var$getMatch(pattern, exp) {
    const matches = pattern.match(exp);
    return matches ? matches[1] : null;
}
// Token: 'file
class $4f1facae9bfcfd99$var$ExactMatch extends $4f1facae9bfcfd99$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'exact';
    }
    static get multiRegex() {
        return /^="(.*)"$/;
    }
    static get singleRegex() {
        return /^=(.*)$/;
    }
    search(text) {
        const isMatch = text === this.pattern;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                this.pattern.length - 1
            ]
        };
    }
}
// Token: !fire
class $4f1facae9bfcfd99$var$InverseExactMatch extends $4f1facae9bfcfd99$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'inverse-exact';
    }
    static get multiRegex() {
        return /^!"(.*)"$/;
    }
    static get singleRegex() {
        return /^!(.*)$/;
    }
    search(text) {
        const index = text.indexOf(this.pattern);
        const isMatch = index === -1;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
// Token: ^file
class $4f1facae9bfcfd99$var$PrefixExactMatch extends $4f1facae9bfcfd99$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'prefix-exact';
    }
    static get multiRegex() {
        return /^\^"(.*)"$/;
    }
    static get singleRegex() {
        return /^\^(.*)$/;
    }
    search(text) {
        const isMatch = text.startsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                this.pattern.length - 1
            ]
        };
    }
}
// Token: !^fire
class $4f1facae9bfcfd99$var$InversePrefixExactMatch extends $4f1facae9bfcfd99$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'inverse-prefix-exact';
    }
    static get multiRegex() {
        return /^!\^"(.*)"$/;
    }
    static get singleRegex() {
        return /^!\^(.*)$/;
    }
    search(text) {
        const isMatch = !text.startsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
// Token: .file$
class $4f1facae9bfcfd99$var$SuffixExactMatch extends $4f1facae9bfcfd99$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'suffix-exact';
    }
    static get multiRegex() {
        return /^"(.*)"\$$/;
    }
    static get singleRegex() {
        return /^(.*)\$$/;
    }
    search(text) {
        const isMatch = text.endsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                text.length - this.pattern.length,
                text.length - 1
            ]
        };
    }
}
// Token: !.file$
class $4f1facae9bfcfd99$var$InverseSuffixExactMatch extends $4f1facae9bfcfd99$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'inverse-suffix-exact';
    }
    static get multiRegex() {
        return /^!"(.*)"\$$/;
    }
    static get singleRegex() {
        return /^!(.*)\$$/;
    }
    search(text) {
        const isMatch = !text.endsWith(this.pattern);
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: [
                0,
                text.length - 1
            ]
        };
    }
}
class $4f1facae9bfcfd99$var$FuzzyMatch extends $4f1facae9bfcfd99$var$BaseMatch {
    constructor(pattern, { location: location = $4f1facae9bfcfd99$var$Config.location, threshold: threshold = $4f1facae9bfcfd99$var$Config.threshold, distance: distance = $4f1facae9bfcfd99$var$Config.distance, includeMatches: includeMatches = $4f1facae9bfcfd99$var$Config.includeMatches, findAllMatches: findAllMatches = $4f1facae9bfcfd99$var$Config.findAllMatches, minMatchCharLength: minMatchCharLength = $4f1facae9bfcfd99$var$Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = $4f1facae9bfcfd99$var$Config.isCaseSensitive, ignoreLocation: ignoreLocation = $4f1facae9bfcfd99$var$Config.ignoreLocation } = {}){
        super(pattern);
        this._bitapSearch = new $4f1facae9bfcfd99$var$BitapSearch(pattern, {
            location: location,
            threshold: threshold,
            distance: distance,
            includeMatches: includeMatches,
            findAllMatches: findAllMatches,
            minMatchCharLength: minMatchCharLength,
            isCaseSensitive: isCaseSensitive,
            ignoreLocation: ignoreLocation
        });
    }
    static get type() {
        return 'fuzzy';
    }
    static get multiRegex() {
        return /^"(.*)"$/;
    }
    static get singleRegex() {
        return /^(.*)$/;
    }
    search(text) {
        return this._bitapSearch.searchIn(text);
    }
}
// Token: 'file
class $4f1facae9bfcfd99$var$IncludeMatch extends $4f1facae9bfcfd99$var$BaseMatch {
    constructor(pattern){
        super(pattern);
    }
    static get type() {
        return 'include';
    }
    static get multiRegex() {
        return /^'"(.*)"$/;
    }
    static get singleRegex() {
        return /^'(.*)$/;
    }
    search(text) {
        let location = 0;
        let index;
        const indices = [];
        const patternLen = this.pattern.length;
        // Get all exact matches
        while((index = text.indexOf(this.pattern, location)) > -1){
            location = index + patternLen;
            indices.push([
                index,
                location - 1
            ]);
        }
        const isMatch = !!indices.length;
        return {
            isMatch: isMatch,
            score: isMatch ? 0 : 1,
            indices: indices
        };
    }
}
// ❗Order is important. DO NOT CHANGE.
const $4f1facae9bfcfd99$var$searchers = [
    $4f1facae9bfcfd99$var$ExactMatch,
    $4f1facae9bfcfd99$var$IncludeMatch,
    $4f1facae9bfcfd99$var$PrefixExactMatch,
    $4f1facae9bfcfd99$var$InversePrefixExactMatch,
    $4f1facae9bfcfd99$var$InverseSuffixExactMatch,
    $4f1facae9bfcfd99$var$SuffixExactMatch,
    $4f1facae9bfcfd99$var$InverseExactMatch,
    $4f1facae9bfcfd99$var$FuzzyMatch
];
const $4f1facae9bfcfd99$var$searchersLen = $4f1facae9bfcfd99$var$searchers.length;
// Regex to split by spaces, but keep anything in quotes together
const $4f1facae9bfcfd99$var$SPACE_RE = / +(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/;
const $4f1facae9bfcfd99$var$OR_TOKEN = '|';
// Return a 2D array representation of the query, for simpler parsing.
// Example:
// "^core go$ | rb$ | py$ xy$" => [["^core", "go$"], ["rb$"], ["py$", "xy$"]]
function $4f1facae9bfcfd99$var$parseQuery(pattern, options = {}) {
    return pattern.split($4f1facae9bfcfd99$var$OR_TOKEN).map((item)=>{
        let query = item.trim().split($4f1facae9bfcfd99$var$SPACE_RE).filter((item)=>item && !!item.trim());
        let results = [];
        for(let i = 0, len = query.length; i < len; i += 1){
            const queryItem = query[i];
            // 1. Handle multiple query match (i.e, once that are quoted, like `"hello world"`)
            let found = false;
            let idx = -1;
            while(!found && ++idx < $4f1facae9bfcfd99$var$searchersLen){
                const searcher = $4f1facae9bfcfd99$var$searchers[idx];
                let token = searcher.isMultiMatch(queryItem);
                if (token) {
                    results.push(new searcher(token, options));
                    found = true;
                }
            }
            if (found) continue;
            // 2. Handle single query matches (i.e, once that are *not* quoted)
            idx = -1;
            while(++idx < $4f1facae9bfcfd99$var$searchersLen){
                const searcher = $4f1facae9bfcfd99$var$searchers[idx];
                let token = searcher.isSingleMatch(queryItem);
                if (token) {
                    results.push(new searcher(token, options));
                    break;
                }
            }
        }
        return results;
    });
}
// These extended matchers can return an array of matches, as opposed
// to a singl match
const $4f1facae9bfcfd99$var$MultiMatchSet = new Set([
    $4f1facae9bfcfd99$var$FuzzyMatch.type,
    $4f1facae9bfcfd99$var$IncludeMatch.type
]);
/**
 * Command-like searching
 * ======================
 *
 * Given multiple search terms delimited by spaces.e.g. `^jscript .python$ ruby !java`,
 * search in a given text.
 *
 * Search syntax:
 *
 * | Token       | Match type                 | Description                            |
 * | ----------- | -------------------------- | -------------------------------------- |
 * | `jscript`   | fuzzy-match                | Items that fuzzy match `jscript`       |
 * | `=scheme`   | exact-match                | Items that are `scheme`                |
 * | `'python`   | include-match              | Items that include `python`            |
 * | `!ruby`     | inverse-exact-match        | Items that do not include `ruby`       |
 * | `^java`     | prefix-exact-match         | Items that start with `java`           |
 * | `!^earlang` | inverse-prefix-exact-match | Items that do not start with `earlang` |
 * | `.js$`      | suffix-exact-match         | Items that end with `.js`              |
 * | `!.go$`     | inverse-suffix-exact-match | Items that do not end with `.go`       |
 *
 * A single pipe character acts as an OR operator. For example, the following
 * query matches entries that start with `core` and end with either`go`, `rb`,
 * or`py`.
 *
 * ```
 * ^core go$ | rb$ | py$
 * ```
 */ class $4f1facae9bfcfd99$var$ExtendedSearch {
    constructor(pattern, { isCaseSensitive: isCaseSensitive = $4f1facae9bfcfd99$var$Config.isCaseSensitive, includeMatches: includeMatches = $4f1facae9bfcfd99$var$Config.includeMatches, minMatchCharLength: minMatchCharLength = $4f1facae9bfcfd99$var$Config.minMatchCharLength, ignoreLocation: ignoreLocation = $4f1facae9bfcfd99$var$Config.ignoreLocation, findAllMatches: findAllMatches = $4f1facae9bfcfd99$var$Config.findAllMatches, location: location = $4f1facae9bfcfd99$var$Config.location, threshold: threshold = $4f1facae9bfcfd99$var$Config.threshold, distance: distance = $4f1facae9bfcfd99$var$Config.distance } = {}){
        this.query = null;
        this.options = {
            isCaseSensitive: isCaseSensitive,
            includeMatches: includeMatches,
            minMatchCharLength: minMatchCharLength,
            findAllMatches: findAllMatches,
            ignoreLocation: ignoreLocation,
            location: location,
            threshold: threshold,
            distance: distance
        };
        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
        this.query = $4f1facae9bfcfd99$var$parseQuery(this.pattern, this.options);
    }
    static condition(_, options) {
        return options.useExtendedSearch;
    }
    searchIn(text) {
        const query = this.query;
        if (!query) return {
            isMatch: false,
            score: 1
        };
        const { includeMatches: includeMatches, isCaseSensitive: isCaseSensitive } = this.options;
        text = isCaseSensitive ? text : text.toLowerCase();
        let numMatches = 0;
        let allIndices = [];
        let totalScore = 0;
        // ORs
        for(let i = 0, qLen = query.length; i < qLen; i += 1){
            const searchers = query[i];
            // Reset indices
            allIndices.length = 0;
            numMatches = 0;
            // ANDs
            for(let j = 0, pLen = searchers.length; j < pLen; j += 1){
                const searcher = searchers[j];
                const { isMatch: isMatch, indices: indices, score: score } = searcher.search(text);
                if (isMatch) {
                    numMatches += 1;
                    totalScore += score;
                    if (includeMatches) {
                        const type = searcher.constructor.type;
                        if ($4f1facae9bfcfd99$var$MultiMatchSet.has(type)) allIndices = [
                            ...allIndices,
                            ...indices
                        ];
                        else allIndices.push(indices);
                    }
                } else {
                    totalScore = 0;
                    numMatches = 0;
                    allIndices.length = 0;
                    break;
                }
            }
            // OR condition, so if TRUE, return
            if (numMatches) {
                let result = {
                    isMatch: true,
                    score: totalScore / numMatches
                };
                if (includeMatches) result.indices = allIndices;
                return result;
            }
        }
        // Nothing was matched
        return {
            isMatch: false,
            score: 1
        };
    }
}
const $4f1facae9bfcfd99$var$registeredSearchers = [];
function $4f1facae9bfcfd99$var$register(...args) {
    $4f1facae9bfcfd99$var$registeredSearchers.push(...args);
}
function $4f1facae9bfcfd99$var$createSearcher(pattern, options) {
    for(let i = 0, len = $4f1facae9bfcfd99$var$registeredSearchers.length; i < len; i += 1){
        let searcherClass = $4f1facae9bfcfd99$var$registeredSearchers[i];
        if (searcherClass.condition(pattern, options)) return new searcherClass(pattern, options);
    }
    return new $4f1facae9bfcfd99$var$BitapSearch(pattern, options);
}
const $4f1facae9bfcfd99$var$LogicalOperator = {
    AND: '$and',
    OR: '$or'
};
const $4f1facae9bfcfd99$var$KeyType = {
    PATH: '$path',
    PATTERN: '$val'
};
const $4f1facae9bfcfd99$var$isExpression = (query)=>!!(query[$4f1facae9bfcfd99$var$LogicalOperator.AND] || query[$4f1facae9bfcfd99$var$LogicalOperator.OR]);
const $4f1facae9bfcfd99$var$isPath = (query)=>!!query[$4f1facae9bfcfd99$var$KeyType.PATH];
const $4f1facae9bfcfd99$var$isLeaf = (query)=>!$4f1facae9bfcfd99$var$isArray(query) && $4f1facae9bfcfd99$var$isObject(query) && !$4f1facae9bfcfd99$var$isExpression(query);
const $4f1facae9bfcfd99$var$convertToExplicit = (query)=>({
        [$4f1facae9bfcfd99$var$LogicalOperator.AND]: Object.keys(query).map((key)=>({
                [key]: query[key]
            }))
    });
// When `auto` is `true`, the parse function will infer and initialize and add
// the appropriate `Searcher` instance
function $4f1facae9bfcfd99$var$parse(query, options, { auto: auto = true } = {}) {
    const next = (query)=>{
        let keys = Object.keys(query);
        const isQueryPath = $4f1facae9bfcfd99$var$isPath(query);
        if (!isQueryPath && keys.length > 1 && !$4f1facae9bfcfd99$var$isExpression(query)) return next($4f1facae9bfcfd99$var$convertToExplicit(query));
        if ($4f1facae9bfcfd99$var$isLeaf(query)) {
            const key = isQueryPath ? query[$4f1facae9bfcfd99$var$KeyType.PATH] : keys[0];
            const pattern = isQueryPath ? query[$4f1facae9bfcfd99$var$KeyType.PATTERN] : query[key];
            if (!$4f1facae9bfcfd99$var$isString(pattern)) throw new Error($4f1facae9bfcfd99$var$LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY(key));
            const obj = {
                keyId: $4f1facae9bfcfd99$var$createKeyId(key),
                pattern: pattern
            };
            if (auto) obj.searcher = $4f1facae9bfcfd99$var$createSearcher(pattern, options);
            return obj;
        }
        let node = {
            children: [],
            operator: keys[0]
        };
        keys.forEach((key)=>{
            const value = query[key];
            if ($4f1facae9bfcfd99$var$isArray(value)) value.forEach((item)=>{
                node.children.push(next(item));
            });
        });
        return node;
    };
    if (!$4f1facae9bfcfd99$var$isExpression(query)) query = $4f1facae9bfcfd99$var$convertToExplicit(query);
    return next(query);
}
// Practical scoring function
function $4f1facae9bfcfd99$var$computeScore(results, { ignoreFieldNorm: ignoreFieldNorm = $4f1facae9bfcfd99$var$Config.ignoreFieldNorm }) {
    results.forEach((result)=>{
        let totalScore = 1;
        result.matches.forEach(({ key: key, norm: norm, score: score })=>{
            const weight = key ? key.weight : null;
            totalScore *= Math.pow(score === 0 && weight ? Number.EPSILON : score, (weight || 1) * (ignoreFieldNorm ? 1 : norm));
        });
        result.score = totalScore;
    });
}
function $4f1facae9bfcfd99$var$transformMatches(result, data) {
    const matches = result.matches;
    data.matches = [];
    if (!$4f1facae9bfcfd99$var$isDefined(matches)) return;
    matches.forEach((match)=>{
        if (!$4f1facae9bfcfd99$var$isDefined(match.indices) || !match.indices.length) return;
        const { indices: indices, value: value } = match;
        let obj = {
            indices: indices,
            value: value
        };
        if (match.key) obj.key = match.key.src;
        if (match.idx > -1) obj.refIndex = match.idx;
        data.matches.push(obj);
    });
}
function $4f1facae9bfcfd99$var$transformScore(result, data) {
    data.score = result.score;
}
function $4f1facae9bfcfd99$var$format(results, docs, { includeMatches: includeMatches = $4f1facae9bfcfd99$var$Config.includeMatches, includeScore: includeScore = $4f1facae9bfcfd99$var$Config.includeScore } = {}) {
    const transformers = [];
    if (includeMatches) transformers.push($4f1facae9bfcfd99$var$transformMatches);
    if (includeScore) transformers.push($4f1facae9bfcfd99$var$transformScore);
    return results.map((result)=>{
        const { idx: idx } = result;
        const data = {
            item: docs[idx],
            refIndex: idx
        };
        if (transformers.length) transformers.forEach((transformer)=>{
            transformer(result, data);
        });
        return data;
    });
}
class $4f1facae9bfcfd99$export$2e2bcd8739ae039 {
    constructor(docs, options = {}, index){
        this.options = {
            ...$4f1facae9bfcfd99$var$Config,
            ...options
        };
        this.options.useExtendedSearch;
        this._keyStore = new $4f1facae9bfcfd99$var$KeyStore(this.options.keys);
        this.setCollection(docs, index);
    }
    setCollection(docs, index) {
        this._docs = docs;
        if (index && !(index instanceof $4f1facae9bfcfd99$var$FuseIndex)) throw new Error($4f1facae9bfcfd99$var$INCORRECT_INDEX_TYPE);
        this._myIndex = index || $4f1facae9bfcfd99$var$createIndex(this.options.keys, this._docs, {
            getFn: this.options.getFn,
            fieldNormWeight: this.options.fieldNormWeight
        });
    }
    add(doc) {
        if (!$4f1facae9bfcfd99$var$isDefined(doc)) return;
        this._docs.push(doc);
        this._myIndex.add(doc);
    }
    remove(predicate = ()=>false) {
        const results = [];
        for(let i = 0, len = this._docs.length; i < len; i += 1){
            const doc = this._docs[i];
            if (predicate(doc, i)) {
                this.removeAt(i);
                i -= 1;
                len -= 1;
                results.push(doc);
            }
        }
        return results;
    }
    removeAt(idx) {
        this._docs.splice(idx, 1);
        this._myIndex.removeAt(idx);
    }
    getIndex() {
        return this._myIndex;
    }
    search(query, { limit: limit = -1 } = {}) {
        const { includeMatches: includeMatches, includeScore: includeScore, shouldSort: shouldSort, sortFn: sortFn, ignoreFieldNorm: ignoreFieldNorm } = this.options;
        let results = $4f1facae9bfcfd99$var$isString(query) ? $4f1facae9bfcfd99$var$isString(this._docs[0]) ? this._searchStringList(query) : this._searchObjectList(query) : this._searchLogical(query);
        $4f1facae9bfcfd99$var$computeScore(results, {
            ignoreFieldNorm: ignoreFieldNorm
        });
        if (shouldSort) results.sort(sortFn);
        if ($4f1facae9bfcfd99$var$isNumber(limit) && limit > -1) results = results.slice(0, limit);
        return $4f1facae9bfcfd99$var$format(results, this._docs, {
            includeMatches: includeMatches,
            includeScore: includeScore
        });
    }
    _searchStringList(query) {
        const searcher = $4f1facae9bfcfd99$var$createSearcher(query, this.options);
        const { records: records } = this._myIndex;
        const results = [];
        // Iterate over every string in the index
        records.forEach(({ v: text, i: idx, n: norm })=>{
            if (!$4f1facae9bfcfd99$var$isDefined(text)) return;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) results.push({
                item: text,
                idx: idx,
                matches: [
                    {
                        score: score,
                        value: text,
                        norm: norm,
                        indices: indices
                    }
                ]
            });
        });
        return results;
    }
    _searchLogical(query) {
        const expression = $4f1facae9bfcfd99$var$parse(query, this.options);
        const evaluate = (node, item, idx)=>{
            if (!node.children) {
                const { keyId: keyId, searcher: searcher } = node;
                const matches = this._findMatches({
                    key: this._keyStore.get(keyId),
                    value: this._myIndex.getValueForItemAtKeyId(item, keyId),
                    searcher: searcher
                });
                if (matches && matches.length) return [
                    {
                        idx: idx,
                        item: item,
                        matches: matches
                    }
                ];
                return [];
            }
            const res = [];
            for(let i = 0, len = node.children.length; i < len; i += 1){
                const child = node.children[i];
                const result = evaluate(child, item, idx);
                if (result.length) res.push(...result);
                else if (node.operator === $4f1facae9bfcfd99$var$LogicalOperator.AND) return [];
            }
            return res;
        };
        const records = this._myIndex.records;
        const resultMap = {};
        const results = [];
        records.forEach(({ $: item, i: idx })=>{
            if ($4f1facae9bfcfd99$var$isDefined(item)) {
                let expResults = evaluate(expression, item, idx);
                if (expResults.length) {
                    // Dedupe when adding
                    if (!resultMap[idx]) {
                        resultMap[idx] = {
                            idx: idx,
                            item: item,
                            matches: []
                        };
                        results.push(resultMap[idx]);
                    }
                    expResults.forEach(({ matches: matches })=>{
                        resultMap[idx].matches.push(...matches);
                    });
                }
            }
        });
        return results;
    }
    _searchObjectList(query) {
        const searcher = $4f1facae9bfcfd99$var$createSearcher(query, this.options);
        const { keys: keys, records: records } = this._myIndex;
        const results = [];
        // List is Array<Object>
        records.forEach(({ $: item, i: idx })=>{
            if (!$4f1facae9bfcfd99$var$isDefined(item)) return;
            let matches = [];
            // Iterate over every key (i.e, path), and fetch the value at that key
            keys.forEach((key, keyIndex)=>{
                matches.push(...this._findMatches({
                    key: key,
                    value: item[keyIndex],
                    searcher: searcher
                }));
            });
            if (matches.length) results.push({
                idx: idx,
                item: item,
                matches: matches
            });
        });
        return results;
    }
    _findMatches({ key: key, value: value, searcher: searcher }) {
        if (!$4f1facae9bfcfd99$var$isDefined(value)) return [];
        let matches = [];
        if ($4f1facae9bfcfd99$var$isArray(value)) value.forEach(({ v: text, i: idx, n: norm })=>{
            if (!$4f1facae9bfcfd99$var$isDefined(text)) return;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) matches.push({
                score: score,
                key: key,
                value: text,
                idx: idx,
                norm: norm,
                indices: indices
            });
        });
        else {
            const { v: text, n: norm } = value;
            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
            if (isMatch) matches.push({
                score: score,
                key: key,
                value: text,
                norm: norm,
                indices: indices
            });
        }
        return matches;
    }
}
$4f1facae9bfcfd99$export$2e2bcd8739ae039.version = '6.6.2';
$4f1facae9bfcfd99$export$2e2bcd8739ae039.createIndex = $4f1facae9bfcfd99$var$createIndex;
$4f1facae9bfcfd99$export$2e2bcd8739ae039.parseIndex = $4f1facae9bfcfd99$var$parseIndex;
$4f1facae9bfcfd99$export$2e2bcd8739ae039.config = $4f1facae9bfcfd99$var$Config;
$4f1facae9bfcfd99$export$2e2bcd8739ae039.parseQuery = $4f1facae9bfcfd99$var$parse;
$4f1facae9bfcfd99$var$register($4f1facae9bfcfd99$var$ExtendedSearch);

});


parcelRegister("4WpTU", function(module, exports) {
$parcel$export(module.exports, "getQuickInsertMenuItemParents", () => $83c4ef3161d1a625$export$4d73fce96a3946b3);

var $5AAvL = parcelRequire("5AAvL");

var $9woaI = parcelRequire("9woaI");
const $83c4ef3161d1a625$var$categorySections = {
    admin: (0, $9woaI.STRUCTURE_SECTION),
    ai: (0, $9woaI.ROVO_SECTION),
    'block-templates': (0, $9woaI.BLOCK_TEMPLATES_SECTION),
    communication: (0, $9woaI.MEDIA_SECTION),
    'confluence-content': (0, $9woaI.STRUCTURE_SECTION),
    create: (0, $9woaI.CREATE_SECTION),
    'data-and-charts': (0, $9woaI.DATA_AND_CHARTS_SECTION),
    development: (0, $9woaI.DATA_AND_CHARTS_SECTION),
    embed: (0, $9woaI.EMBED_SECTION),
    'external-content': (0, $9woaI.EMBED_SECTION),
    formatting: (0, $9woaI.STRUCTURE_SECTION),
    media: (0, $9woaI.MEDIA_SECTION),
    navigation: (0, $9woaI.STRUCTURE_SECTION),
    other: (0, $9woaI.OTHER_SECTION),
    reporting: (0, $9woaI.DATA_AND_CHARTS_SECTION),
    skills: (0, $9woaI.ROVO_SECTION),
    structure: (0, $9woaI.STRUCTURE_SECTION),
    'text-formatting': (0, $9woaI.TEXT_FORMATTING_SECTION),
    visuals: (0, $9woaI.MEDIA_SECTION)
};
const $83c4ef3161d1a625$export$4d73fce96a3946b3 = ({ category: category, legacyCategories: legacyCategories, rank: rank })=>{
    const sections = new Map();
    for (const itemCategory of (0, $5AAvL.getActiveQuickInsertCategories)(category, legacyCategories)){
        const section = $83c4ef3161d1a625$var$categorySections[itemCategory.trim().toLowerCase()];
        if (section) sections.set(section.key, section);
    }
    if (sections.size === 0) sections.set((0, $9woaI.OTHER_SECTION).key, (0, $9woaI.OTHER_SECTION));
    return Array.from(sections.values(), (section)=>({
            ...section,
            rank: rank
        }));
};

});
parcelRegister("5AAvL", function(module, exports) {
$parcel$export(module.exports, "getActiveQuickInsertCategories", () => $6e3a850a00973e98$export$aacf51666602968b);

var $3y2s4 = parcelRequire("3y2s4");
const $6e3a850a00973e98$export$aacf51666602968b = (category, legacyCategories)=>(0, $3y2s4.isExperimentEnabled)('platform_editor_slash_command') && category !== null && category !== void 0 && category.trim() ? [
        category
    ] : legacyCategories ?? [];

});

parcelRegister("9woaI", function(module, exports) {
$parcel$export(module.exports, "MENU", () => $1766fe43b4a34ebb$export$4f072ecaef317163);
$parcel$export(module.exports, "RECOMMENDED_SECTION", () => $1766fe43b4a34ebb$export$12f7d9cc46f85973);
$parcel$export(module.exports, "STRUCTURE_SECTION", () => $1766fe43b4a34ebb$export$41f49f07caa65d63);
$parcel$export(module.exports, "MEDIA_SECTION", () => $1766fe43b4a34ebb$export$6521aedf84b8b3bf);
$parcel$export(module.exports, "CREATE_SECTION", () => $1766fe43b4a34ebb$export$1f997d459e75316e);
$parcel$export(module.exports, "EMBED_SECTION", () => $1766fe43b4a34ebb$export$988ed94425cfd0b);
$parcel$export(module.exports, "TEXT_FORMATTING_SECTION", () => $1766fe43b4a34ebb$export$b9615e67024cae79);
$parcel$export(module.exports, "ROVO_SECTION", () => $1766fe43b4a34ebb$export$4d3917764bce77f3);
$parcel$export(module.exports, "DATA_AND_CHARTS_SECTION", () => $1766fe43b4a34ebb$export$a450ef18bc9a77fc);
$parcel$export(module.exports, "BLOCK_TEMPLATES_SECTION", () => $1766fe43b4a34ebb$export$9b7c7169ab55ead9);
$parcel$export(module.exports, "OTHER_SECTION", () => $1766fe43b4a34ebb$export$90dd0db03c1b30a2);
$parcel$export(module.exports, "SEARCH_RESULTS_SECTION", () => $1766fe43b4a34ebb$export$617a107f5291cf03);
$parcel$export(module.exports, "VIEW_ALL_ELEMENTS_MENU_ITEM", () => $1766fe43b4a34ebb$export$fb73f92f07d07ccc);
$parcel$export(module.exports, "ACTION_MENU_ITEM", () => $1766fe43b4a34ebb$export$79188ae36be9c645);
$parcel$export(module.exports, "TABLE_MENU_ITEM", () => $1766fe43b4a34ebb$export$328b64d203821c99);
$parcel$export(module.exports, "STATUS_MENU_ITEM", () => $1766fe43b4a34ebb$export$3e6c1978b43719ef);
$parcel$export(module.exports, "DATE_MENU_ITEM", () => $1766fe43b4a34ebb$export$2c9678b90187641a);
$parcel$export(module.exports, "SYNCED_BLOCK_MENU_ITEM", () => $1766fe43b4a34ebb$export$56991b572eda72a5);
$parcel$export(module.exports, "EXPAND_MENU_ITEM", () => $1766fe43b4a34ebb$export$aadca0eda4e34e44);
$parcel$export(module.exports, "DECISION_MENU_ITEM", () => $1766fe43b4a34ebb$export$ace0c9d2823bcdf3);
$parcel$export(module.exports, "INFO_PANEL_MENU_ITEM", () => $1766fe43b4a34ebb$export$43670f72e3d0d426);
$parcel$export(module.exports, "NOTE_PANEL_MENU_ITEM", () => $1766fe43b4a34ebb$export$5c5a802e2beca5e6);
$parcel$export(module.exports, "SUCCESS_PANEL_MENU_ITEM", () => $1766fe43b4a34ebb$export$dc17447a7754878c);
$parcel$export(module.exports, "WARNING_PANEL_MENU_ITEM", () => $1766fe43b4a34ebb$export$5016ca24764bca67);
$parcel$export(module.exports, "ERROR_PANEL_MENU_ITEM", () => $1766fe43b4a34ebb$export$2ccc07729da0e1f6);
$parcel$export(module.exports, "CUSTOM_PANEL_MENU_ITEM", () => $1766fe43b4a34ebb$export$1e42ac55e66427a3);
$parcel$export(module.exports, "TWO_COLUMNS_LAYOUT_MENU_ITEM", () => $1766fe43b4a34ebb$export$b83dd909cbd80b37);
$parcel$export(module.exports, "THREE_COLUMNS_LAYOUT_MENU_ITEM", () => $1766fe43b4a34ebb$export$879afacac85e1350);
$parcel$export(module.exports, "FOUR_COLUMNS_LAYOUT_MENU_ITEM", () => $1766fe43b4a34ebb$export$11cb660affb9cc3e);
$parcel$export(module.exports, "FIVE_COLUMNS_LAYOUT_MENU_ITEM", () => $1766fe43b4a34ebb$export$d3001594711c32af);
$parcel$export(module.exports, "MEDIA_INSERT_MENU_ITEM", () => $1766fe43b4a34ebb$export$edc8911e49093d88);
$parcel$export(module.exports, "HYPERLINK_MENU_ITEM", () => $1766fe43b4a34ebb$export$4d3261dcd0a641ce);
$parcel$export(module.exports, "EMOJI_MENU_ITEM", () => $1766fe43b4a34ebb$export$61aba1c1fbb4d4d5);
$parcel$export(module.exports, "LOOM_MENU_ITEM", () => $1766fe43b4a34ebb$export$4ac3fd1884a40118);
$parcel$export(module.exports, "JIRA_ISSUE_MENU_ITEM", () => $1766fe43b4a34ebb$export$7f8dbb610dfebda2);
$parcel$export(module.exports, "CONFLUENCE_PAGE_MENU_ITEM", () => $1766fe43b4a34ebb$export$9df29af67675a123);
$parcel$export(module.exports, "WHITEBOARD_MENU_ITEM", () => $1766fe43b4a34ebb$export$7ed85d77b9460692);
$parcel$export(module.exports, "DIAGRAM_MENU_ITEM", () => $1766fe43b4a34ebb$export$ef8c8f918b423983);
$parcel$export(module.exports, "FLOWCHART_MENU_ITEM", () => $1766fe43b4a34ebb$export$95f461aeae2e4a35);
$parcel$export(module.exports, "BRAINSTORMING_MENU_ITEM", () => $1766fe43b4a34ebb$export$8862466ef67bab6b);
$parcel$export(module.exports, "RETROSPECTIVE_MENU_ITEM", () => $1766fe43b4a34ebb$export$4df8c4dbbbfb30ad);
$parcel$export(module.exports, "ROADMAP_MENU_ITEM", () => $1766fe43b4a34ebb$export$c082d5d300851bfd);
$parcel$export(module.exports, "DATABASE_MENU_ITEM", () => $1766fe43b4a34ebb$export$4a7a11c8e00b21e9);
$parcel$export(module.exports, "TABS_MENU_ITEM", () => $1766fe43b4a34ebb$export$6efdc85fa9d62055);
$parcel$export(module.exports, "MENTION_MENU_ITEM", () => $1766fe43b4a34ebb$export$e4db028613c854f5);
$parcel$export(module.exports, "AI_IMAGE_GENERATION_MENU_ITEM", () => $1766fe43b4a34ebb$export$cda433de81e33e4f);
$parcel$export(module.exports, "HEADING_1_MENU_ITEM", () => $1766fe43b4a34ebb$export$2469e8506da598d3);
$parcel$export(module.exports, "HEADING_2_MENU_ITEM", () => $1766fe43b4a34ebb$export$a065aede28a4fa60);
$parcel$export(module.exports, "HEADING_3_MENU_ITEM", () => $1766fe43b4a34ebb$export$85070b7c6d42e3bb);
$parcel$export(module.exports, "HEADING_4_MENU_ITEM", () => $1766fe43b4a34ebb$export$e78c2531f67b545f);
$parcel$export(module.exports, "HEADING_5_MENU_ITEM", () => $1766fe43b4a34ebb$export$a92294de346392be);
$parcel$export(module.exports, "HEADING_6_MENU_ITEM", () => $1766fe43b4a34ebb$export$9c3cdc8e6d51ce82);
$parcel$export(module.exports, "BLOCKQUOTE_MENU_ITEM", () => $1766fe43b4a34ebb$export$7414b1347762a017);
$parcel$export(module.exports, "CODE_BLOCK_MENU_ITEM", () => $1766fe43b4a34ebb$export$1defd18ee2c88dcf);
$parcel$export(module.exports, "RULE_MENU_ITEM", () => $1766fe43b4a34ebb$export$bc00157d6d81cff9);
$parcel$export(module.exports, "PLACEHOLDER_TEXT_MENU_ITEM", () => $1766fe43b4a34ebb$export$982479fd333b2f72);
$parcel$export(module.exports, "UNORDERED_LIST_MENU_ITEM", () => $1766fe43b4a34ebb$export$b704a063314308a1);
$parcel$export(module.exports, "ORDERED_LIST_MENU_ITEM", () => $1766fe43b4a34ebb$export$c95c058d1846bc54);
$parcel$export(module.exports, "ASK_ROVO_MENU_ITEM", () => $1766fe43b4a34ebb$export$93a4bc45160383ab);
$parcel$export(module.exports, "JIRA_WORK_ITEMS_MENU_ITEM", () => $1766fe43b4a34ebb$export$106f3f08183d9dab);
$parcel$export(module.exports, "ASSETS_MENU_ITEM", () => $1766fe43b4a34ebb$export$2a7c2762dfc65a41);
$parcel$export(module.exports, "CONFLUENCE_LIST_MENU_ITEM", () => $1766fe43b4a34ebb$export$975e8c95a552486e);
$parcel$export(module.exports, "HELP_DIALOG_MENU_ITEM", () => $1766fe43b4a34ebb$export$238627b0efbd611c);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ const $1766fe43b4a34ebb$export$4f072ecaef317163 = {
    key: 'quick-insert-menu',
    type: 'menu'
};
const $1766fe43b4a34ebb$export$12f7d9cc46f85973 = {
    key: 'quick-insert-recommended-section',
    type: 'menu-section'
};
const $1766fe43b4a34ebb$export$41f49f07caa65d63 = {
    key: 'quick-insert-structure-section',
    type: 'menu-section'
};
const $1766fe43b4a34ebb$export$6521aedf84b8b3bf = {
    key: 'quick-insert-media-section',
    type: 'menu-section'
};
const $1766fe43b4a34ebb$export$1f997d459e75316e = {
    key: 'quick-insert-create-section',
    type: 'menu-section'
};
const $1766fe43b4a34ebb$export$988ed94425cfd0b = {
    key: 'quick-insert-embed-section',
    type: 'menu-section'
};
const $1766fe43b4a34ebb$export$b9615e67024cae79 = {
    key: 'quick-insert-text-formatting-section',
    type: 'menu-section'
};
const $1766fe43b4a34ebb$export$4d3917764bce77f3 = {
    key: 'quick-insert-rovo-section',
    type: 'menu-section'
};
const $1766fe43b4a34ebb$export$a450ef18bc9a77fc = {
    key: 'quick-insert-data-and-charts-section',
    type: 'menu-section'
};
const $1766fe43b4a34ebb$export$9b7c7169ab55ead9 = {
    key: 'quick-insert-block-templates-section',
    type: 'menu-section'
};
const $1766fe43b4a34ebb$export$90dd0db03c1b30a2 = {
    key: 'quick-insert-other-section',
    type: 'menu-section'
};
const $1766fe43b4a34ebb$export$617a107f5291cf03 = {
    key: 'quick-insert-search-results-section',
    type: 'menu-section'
};
const $1766fe43b4a34ebb$export$fb73f92f07d07ccc = {
    key: 'quick-insert-view-all-elements-menu-item',
    type: 'menu-item'
};
const $1766fe43b4a34ebb$export$79188ae36be9c645 = {
    key: 'quick-insert-action-menu-item',
    type: 'menu-item'
};
const $1766fe43b4a34ebb$export$328b64d203821c99 = {
    key: 'quick-insert-table-menu-item',
    type: 'menu-item'
};
const $1766fe43b4a34ebb$export$3e6c1978b43719ef = {
    key: 'quick-insert-status-menu-item',
    type: 'menu-item'
};
const $1766fe43b4a34ebb$export$2c9678b90187641a = {
    key: 'quick-insert-date-menu-item',
    type: 'menu-item'
};
const $1766fe43b4a34ebb$export$56991b572eda72a5 = {
    key: 'quick-insert-synced-block-menu-item',
    type: 'menu-item'
};
const $1766fe43b4a34ebb$export$aadca0eda4e34e44 = {
    key: 'quick-insert-expand-menu-item',
    type: 'menu-item'
};
const $1766fe43b4a34ebb$export$ace0c9d2823bcdf3 = {
    key: 'quick-insert-decision-menu-item',
    type: 'menu-item'
};
const $1766fe43b4a34ebb$export$43670f72e3d0d426 = {
    key: 'quick-insert-info-panel-menu-item',
    type: 'menu-item'
};
const $1766fe43b4a34ebb$export$5c5a802e2beca5e6 = {
    key: 'quick-insert-note-panel-menu-item',
    type: 'menu-item'
};
const $1766fe43b4a34ebb$export$dc17447a7754878c = {
    key: 'quick-insert-success-panel-menu-item',
    type: 'menu-item'
};
const $1766fe43b4a34ebb$export$5016ca24764bca67 = {
    key: 'quick-insert-warning-panel-menu-item',
    type: 'menu-item'
};
const $1766fe43b4a34ebb$export$2ccc07729da0e1f6 = {
    key: 'quick-insert-error-panel-menu-item',
    type: 'menu-item'
};
const $1766fe43b4a34ebb$export$1e42ac55e66427a3 = {
    key: 'quick-insert-custom-panel-menu-item',
    type: 'menu-item'
};
const $1766fe43b4a34ebb$export$b83dd909cbd80b37 = {
    key: 'quick-insert-two-columns-layout-menu-item',
    type: 'menu-item'
};
const $1766fe43b4a34ebb$export$879afacac85e1350 = {
    key: 'quick-insert-three-columns-layout-menu-item',
    type: 'menu-item'
};
const $1766fe43b4a34ebb$export$11cb660affb9cc3e = {
    key: 'quick-insert-four-columns-layout-menu-item',
    type: 'menu-item'
};
const $1766fe43b4a34ebb$export$d3001594711c32af = {
    key: 'quick-insert-five-columns-layout-menu-item',
    type: 'menu-item'
};
const $1766fe43b4a34ebb$export$edc8911e49093d88 = {
    key: 'quick-insert-media-insert-menu-item',
    type: 'menu-item'
};
const $1766fe43b4a34ebb$export$4d3261dcd0a641ce = {
    key: 'quick-insert-hyperlink-menu-item',
    type: 'menu-item'
};
const $1766fe43b4a34ebb$export$61aba1c1fbb4d4d5 = {
    key: 'quick-insert-emoji-menu-item',
    type: 'menu-item'
};
const $1766fe43b4a34ebb$export$4ac3fd1884a40118 = {
    key: 'quick-insert-loom-menu-item',
    type: 'menu-item'
};
const $1766fe43b4a34ebb$export$7f8dbb610dfebda2 = {
    key: 'com.atlassian.linking-platform.create:linking-platform-create-jira-issue',
    type: 'menu-item'
};
const $1766fe43b4a34ebb$export$9df29af67675a123 = {
    key: 'com.atlassian.linking-platform.create:linking-platform-create-confluence-page',
    type: 'menu-item'
};
const $1766fe43b4a34ebb$export$7ed85d77b9460692 = {
    key: 'whiteboard-extension:create-whiteboard',
    type: 'menu-item'
};
const $1766fe43b4a34ebb$export$ef8c8f918b423983 = {
    key: 'whiteboard-extension:create-diagram',
    type: 'menu-item'
};
const $1766fe43b4a34ebb$export$95f461aeae2e4a35 = {
    key: 'whiteboard-extension:create-flowchart',
    type: 'menu-item'
};
const $1766fe43b4a34ebb$export$8862466ef67bab6b = {
    key: 'whiteboard-extension:create-brainstorming',
    type: 'menu-item'
};
const $1766fe43b4a34ebb$export$4df8c4dbbbfb30ad = {
    key: 'whiteboard-extension:create-retrospective',
    type: 'menu-item'
};
const $1766fe43b4a34ebb$export$c082d5d300851bfd = {
    key: 'whiteboard-extension:create-roadmap',
    type: 'menu-item'
};
const $1766fe43b4a34ebb$export$4a7a11c8e00b21e9 = {
    key: 'database-extension:create-database',
    type: 'menu-item'
};
const $1766fe43b4a34ebb$export$6efdc85fa9d62055 = {
    key: 'native-tabs:native-tabs',
    type: 'menu-item'
};
const $1766fe43b4a34ebb$export$8b2d76d0bf6ffa67 = {
    key: 'skill:add-suggestions-to-content',
    type: 'menu-item'
};
const $1766fe43b4a34ebb$export$e4db028613c854f5 = {
    key: 'quick-insert-mention-menu-item',
    type: 'menu-item'
};
const $1766fe43b4a34ebb$export$cda433de81e33e4f = {
    key: 'quick-insert-ai-image-generation-menu-item',
    type: 'menu-item'
};
const $1766fe43b4a34ebb$export$2469e8506da598d3 = {
    key: 'quick-insert-heading-1-menu-item',
    type: 'menu-item'
};
const $1766fe43b4a34ebb$export$a065aede28a4fa60 = {
    key: 'quick-insert-heading-2-menu-item',
    type: 'menu-item'
};
const $1766fe43b4a34ebb$export$85070b7c6d42e3bb = {
    key: 'quick-insert-heading-3-menu-item',
    type: 'menu-item'
};
const $1766fe43b4a34ebb$export$e78c2531f67b545f = {
    key: 'quick-insert-heading-4-menu-item',
    type: 'menu-item'
};
const $1766fe43b4a34ebb$export$a92294de346392be = {
    key: 'quick-insert-heading-5-menu-item',
    type: 'menu-item'
};
const $1766fe43b4a34ebb$export$9c3cdc8e6d51ce82 = {
    key: 'quick-insert-heading-6-menu-item',
    type: 'menu-item'
};
const $1766fe43b4a34ebb$export$7414b1347762a017 = {
    key: 'quick-insert-blockquote-menu-item',
    type: 'menu-item'
};
const $1766fe43b4a34ebb$export$1defd18ee2c88dcf = {
    key: 'quick-insert-code-block-menu-item',
    type: 'menu-item'
};
const $1766fe43b4a34ebb$export$bc00157d6d81cff9 = {
    key: 'quick-insert-rule-menu-item',
    type: 'menu-item'
};
const $1766fe43b4a34ebb$export$982479fd333b2f72 = {
    key: 'quick-insert-placeholder-text-menu-item',
    type: 'menu-item'
};
const $1766fe43b4a34ebb$export$b704a063314308a1 = {
    key: 'quick-insert-unordered-list-menu-item',
    type: 'menu-item'
};
const $1766fe43b4a34ebb$export$c95c058d1846bc54 = {
    key: 'quick-insert-ordered-list-menu-item',
    type: 'menu-item'
};
const $1766fe43b4a34ebb$export$93a4bc45160383ab = {
    key: 'quick-insert-ask-rovo-menu-item',
    type: 'menu-item'
};
const $1766fe43b4a34ebb$export$106f3f08183d9dab = {
    key: 'quick-insert-jira-work-items-menu-item',
    type: 'menu-item'
};
const $1766fe43b4a34ebb$export$2a7c2762dfc65a41 = {
    key: 'quick-insert-assets-menu-item',
    type: 'menu-item'
};
const $1766fe43b4a34ebb$export$975e8c95a552486e = {
    key: 'quick-insert-confluence-list-menu-item',
    type: 'menu-item'
};
const $1766fe43b4a34ebb$export$238627b0efbd611c = {
    key: 'quick-insert-help-dialog-menu-item',
    type: 'menu-item'
};
const $1766fe43b4a34ebb$export$e92f59b111ab0aef = (id)=>({
        key: `quick-insert-block-template-${id}`,
        type: 'menu-item'
    });

});


parcelRegister("am2Qg", function(module, exports) {
$parcel$export(module.exports, "QUICK_INSERT_MENU_RANK", () => $2ae71f8e562f82c0$export$6f0b97a44c333c02);
$parcel$export(module.exports, "STRUCTURE_SECTION_RANK", () => $2ae71f8e562f82c0$export$4b636ca6c5524d2);
$parcel$export(module.exports, "MEDIA_SECTION_RANK", () => $2ae71f8e562f82c0$export$d55d14a4c5066acf);
$parcel$export(module.exports, "CREATE_SECTION_RANK", () => $2ae71f8e562f82c0$export$6fbfc97c4b6bda0c);
$parcel$export(module.exports, "TEXT_FORMATTING_SECTION_RANK", () => $2ae71f8e562f82c0$export$80d05dd98646a9d2);
$parcel$export(module.exports, "DATA_AND_CHARTS_SECTION_RANK", () => $2ae71f8e562f82c0$export$c93d592e1d5bcf63);
$parcel$export(module.exports, "EXTENSION_ITEM_RANK", () => $2ae71f8e562f82c0$export$7a7912903a77addf);
$parcel$export(module.exports, "CATEGORY_VIEW_MORE_RANK", () => $2ae71f8e562f82c0$export$8fe8500e35b378be);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $9woaI = parcelRequire("9woaI");
const $2ae71f8e562f82c0$export$6f0b97a44c333c02 = {
    [(0, $9woaI.RECOMMENDED_SECTION).key]: 0,
    [(0, $9woaI.STRUCTURE_SECTION).key]: 1,
    [(0, $9woaI.MEDIA_SECTION).key]: 2,
    [(0, $9woaI.CREATE_SECTION).key]: 3,
    [(0, $9woaI.EMBED_SECTION).key]: 4,
    [(0, $9woaI.TEXT_FORMATTING_SECTION).key]: 5,
    [(0, $9woaI.ROVO_SECTION).key]: 6,
    [(0, $9woaI.DATA_AND_CHARTS_SECTION).key]: 7,
    [(0, $9woaI.BLOCK_TEMPLATES_SECTION).key]: 8,
    [(0, $9woaI.OTHER_SECTION).key]: 9
};
const $2ae71f8e562f82c0$export$4b636ca6c5524d2 = {
    [(0, $9woaI.ACTION_MENU_ITEM).key]: 100,
    [(0, $9woaI.TABLE_MENU_ITEM).key]: 200,
    [(0, $9woaI.STATUS_MENU_ITEM).key]: 300,
    [(0, $9woaI.DATE_MENU_ITEM).key]: 400,
    [(0, $9woaI.MENTION_MENU_ITEM).key]: 500,
    [(0, $9woaI.EXPAND_MENU_ITEM).key]: 700,
    [(0, $9woaI.CODE_BLOCK_MENU_ITEM).key]: 800,
    [(0, $9woaI.INFO_PANEL_MENU_ITEM).key]: 900,
    [(0, $9woaI.NOTE_PANEL_MENU_ITEM).key]: 1000,
    [(0, $9woaI.SUCCESS_PANEL_MENU_ITEM).key]: 1100,
    [(0, $9woaI.WARNING_PANEL_MENU_ITEM).key]: 1200,
    [(0, $9woaI.ERROR_PANEL_MENU_ITEM).key]: 1300,
    [(0, $9woaI.CUSTOM_PANEL_MENU_ITEM).key]: 1400,
    [(0, $9woaI.TWO_COLUMNS_LAYOUT_MENU_ITEM).key]: 1500,
    [(0, $9woaI.THREE_COLUMNS_LAYOUT_MENU_ITEM).key]: 1600,
    [(0, $9woaI.FOUR_COLUMNS_LAYOUT_MENU_ITEM).key]: 1700,
    [(0, $9woaI.FIVE_COLUMNS_LAYOUT_MENU_ITEM).key]: 1800,
    [(0, $9woaI.SYNCED_BLOCK_MENU_ITEM).key]: 2300,
    [(0, $9woaI.RULE_MENU_ITEM).key]: 2400,
    [(0, $9woaI.DECISION_MENU_ITEM).key]: 2800
};
const $2ae71f8e562f82c0$export$d55d14a4c5066acf = {
    [(0, $9woaI.MEDIA_INSERT_MENU_ITEM).key]: 100,
    [(0, $9woaI.HYPERLINK_MENU_ITEM).key]: 200,
    [(0, $9woaI.EMOJI_MENU_ITEM).key]: 300,
    [(0, $9woaI.AI_IMAGE_GENERATION_MENU_ITEM).key]: 1600
};
const $2ae71f8e562f82c0$export$6fbfc97c4b6bda0c = {
    [(0, $9woaI.JIRA_ISSUE_MENU_ITEM).key]: 100,
    [(0, $9woaI.LOOM_MENU_ITEM).key]: 200,
    [(0, $9woaI.CONFLUENCE_PAGE_MENU_ITEM).key]: 300,
    [(0, $9woaI.DATABASE_MENU_ITEM).key]: 400,
    [(0, $9woaI.WHITEBOARD_MENU_ITEM).key]: 500,
    [(0, $9woaI.DIAGRAM_MENU_ITEM).key]: 600,
    [(0, $9woaI.FLOWCHART_MENU_ITEM).key]: 700,
    [(0, $9woaI.BRAINSTORMING_MENU_ITEM).key]: 800,
    [(0, $9woaI.RETROSPECTIVE_MENU_ITEM).key]: 900,
    [(0, $9woaI.ROADMAP_MENU_ITEM).key]: 1000
};
const $2ae71f8e562f82c0$export$80d05dd98646a9d2 = {
    [(0, $9woaI.UNORDERED_LIST_MENU_ITEM).key]: 100,
    [(0, $9woaI.ORDERED_LIST_MENU_ITEM).key]: 200,
    [(0, $9woaI.HEADING_1_MENU_ITEM).key]: 300,
    [(0, $9woaI.HEADING_2_MENU_ITEM).key]: 400,
    [(0, $9woaI.HEADING_3_MENU_ITEM).key]: 500,
    [(0, $9woaI.HEADING_4_MENU_ITEM).key]: 600,
    [(0, $9woaI.HEADING_5_MENU_ITEM).key]: 700,
    [(0, $9woaI.HEADING_6_MENU_ITEM).key]: 800,
    [(0, $9woaI.BLOCKQUOTE_MENU_ITEM).key]: 900,
    [(0, $9woaI.PLACEHOLDER_TEXT_MENU_ITEM).key]: 1000
};
const $2ae71f8e562f82c0$export$c9a42cd46f7a81c6 = {
    [(0, $9woaI.ASK_ROVO_MENU_ITEM).key]: 100
};
const $2ae71f8e562f82c0$export$c93d592e1d5bcf63 = {
    [(0, $9woaI.JIRA_WORK_ITEMS_MENU_ITEM).key]: 300,
    [(0, $9woaI.CONFLUENCE_LIST_MENU_ITEM).key]: 400,
    [(0, $9woaI.ASSETS_MENU_ITEM).key]: 500
};
const $2ae71f8e562f82c0$export$f3c53099acc8e95f = {
    [(0, $9woaI.HELP_DIALOG_MENU_ITEM).key]: 100
};
const $2ae71f8e562f82c0$export$7a7912903a77addf = 1500;
const $2ae71f8e562f82c0$export$8fe8500e35b378be = Number.MAX_SAFE_INTEGER;

});

parcelRegister("DYnNA", function(module, exports) {
$parcel$export(module.exports, "ExtensionQuickInsertMenuItem", () => $78a67ef8f6b804ad$export$c56df9875b147e5d);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $fT9mF = parcelRequire("fT9mF");

var $efcwg = parcelRequire("efcwg");

var $6NFXF = parcelRequire("6NFXF");

var $3Gvpq = parcelRequire("3Gvpq");
const $78a67ef8f6b804ad$export$c56df9875b147e5d = ({ apiRef: apiRef, createAnalyticsEvent: createAnalyticsEvent, editorActions: editorActions, item: item, onInsert: onInsert })=>{
    const { editorView: editorView, isOffline: isOffline } = (0, $efcwg.useQuickInsertContext)();
    const onSelect = (0, $bSJIT.useCallback)(({ insert: insert, source: source })=>{
        const result = (0, $6NFXF.executeExtensionQuickInsertItem)({
            apiRef: apiRef,
            createAnalyticsEvent: createAnalyticsEvent,
            editorActions: editorActions,
            insert: insert,
            item: item,
            source: source,
            state: editorView.state
        });
        if (result) onInsert === null || onInsert === void 0 || onInsert();
        return result;
    }, [
        apiRef,
        createAnalyticsEvent,
        editorActions,
        editorView.state,
        item,
        onInsert
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $fT9mF.QuickInsertMenuItem), {
        iconBefore: /*#__PURE__*/ (0, $dc70d.jsx)((0, $3Gvpq.ExtensionQuickInsertIcon), {
            getIcon: item.icon,
            itemKey: item.key,
            label: ""
        }),
        isDisabled: isOffline,
        lozenge: item.lozenge,
        onSelect: onSelect,
        preview: item.preview,
        description: item.description,
        title: item.title
    });
};

});
parcelRegister("fT9mF", function(module, exports) {
$parcel$export(module.exports, "QuickInsertMenuItem", () => $f9f1859b59f13c45$export$d0d3cb02f0dbbd98);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $fbClv = parcelRequire("fbClv");

var $2nLnO = parcelRequire("2nLnO");

var $efcwg = parcelRequire("efcwg");
const $f9f1859b59f13c45$export$d0d3cb02f0dbbd98 = ({ ariaLabel: ariaLabel, description: description, iconBefore: iconBefore, isDisabled: isDisabled, lozenge: lozenge, onSelect: onSelect, preview: preview, previewIcon: previewIcon, previewImageUrls: previewImageUrls, shortcut: shortcut, titleContent: titleContent, shouldShowPreview: shouldShowPreview, shouldClampPreview: shouldClampPreview, shouldWrapIcon: shouldWrapIcon, title: title })=>{
    const { surface: surface } = (0, $efcwg.useQuickInsertContext)();
    return surface === 'element-browser' ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $2nLnO.ElementBrowserQuickInsertMenuItem), {
        ariaLabel: ariaLabel,
        description: description,
        iconBefore: iconBefore,
        isDisabled: isDisabled,
        lozenge: lozenge,
        onSelect: onSelect,
        shortcut: shortcut,
        titleContent: titleContent,
        shouldWrapIcon: shouldWrapIcon,
        title: title
    }) : /*#__PURE__*/ (0, $dc70d.jsx)((0, $fbClv.CompactQuickInsertMenuItem), {
        ariaLabel: ariaLabel,
        description: description,
        iconBefore: iconBefore,
        isDisabled: isDisabled,
        lozenge: lozenge,
        onSelect: onSelect,
        preview: preview,
        previewIcon: previewIcon,
        previewImageUrls: previewImageUrls,
        shortcut: shortcut,
        titleContent: titleContent,
        shouldShowPreview: shouldShowPreview,
        shouldClampPreview: shouldClampPreview,
        shouldWrapIcon: shouldWrapIcon,
        title: title
    });
};

});
parcelRegister("fbClv", function(module, exports) {
$parcel$export(module.exports, "CompactQuickInsertMenuItem", () => $2e619933db8dbde7$export$46fa03f3f74132e0);
/* CompactQuickInsertMenuItem.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $9PwDt = parcelRequire("9PwDt");

var $fZ0ZI = parcelRequire("fZ0ZI");

var $8aT4G = parcelRequire("8aT4G");

var $aHbh3 = parcelRequire("aHbh3");

var $9BVpB = parcelRequire("9BVpB");

var $1bo0y = parcelRequire("1bo0y");

var $ghjHH = parcelRequire("ghjHH");

var $efcwg = parcelRequire("efcwg");
const $2e619933db8dbde7$var$styles = {
    iconContainer: "_4cvr1h6o _1e0c1txw _1o9zidpf _1bah1h6o _1tke1tcg _1ul91tcg",
    content: "_16jlkb7n _1o9zkb7n _i0dlidpf _1ul9idpf",
    iconLarge: "_2rko1mok _1reo15vq _18m915vq _1h6d1l7x _1dqonqa1 _189ee4h9 _4cvr1h6o _bfhk1bhr _1e0c1txw _4t3izwfg _1bah1h6o _1bsbzwfg",
    shortcut: "_2rko12b0 _11c8wadc _1rjcv77o _18zr1b66 _bfhki8nm _syazazsu"
};
const $2e619933db8dbde7$var$iconColorStyles = null;
// Some icons pin a neutral colour inline (for example the Forge and Spotlight icons use
// color.icon.subtle or color.icon.accent.gray), which would ignore the colour set by the menu item.
// Reset only those so every icon follows the menu item (color.icon, or the disabled colour).
// Do NOT widen this to all icon colours: some icons are intentionally coloured (for example skill
// and brand icons that use other --ds-icon-accent-* tokens) and must keep their own colour.
/* eslint-disable @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-important-styles -- Icons pin their colour with an inline style, which only an !important rule on a descendant selector can override. */ const $2e619933db8dbde7$var$pinnedIconColorResetStyles = null;
/* eslint-enable @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-important-styles */ const $2e619933db8dbde7$var$itemStyles = (0, $9BVpB.xcss)({
    alignItems: 'center',
    backgroundColor: 'elevation.surface.overlay',
    color: 'color.text',
    display: 'flex',
    gap: 'space.150',
    minHeight: '44px',
    paddingBlock: 'space.075',
    paddingInline: 'space.200',
    textAlign: 'start',
    width: '100%',
    ':hover': {
        backgroundColor: 'elevation.surface.overlay.hovered'
    }
});
const $2e619933db8dbde7$var$selectedItemStyles = (0, $9BVpB.xcss)({
    alignItems: 'center',
    backgroundColor: 'elevation.surface.overlay.hovered',
    color: 'color.text',
    display: 'flex',
    gap: 'space.150',
    minHeight: '44px',
    paddingBlock: 'space.075',
    paddingInline: 'space.200',
    position: 'relative',
    textAlign: 'start',
    width: '100%',
    ':hover': {
        backgroundColor: 'elevation.surface.overlay.hovered'
    },
    '::before': {
        borderInlineStartColor: 'color.border.selected',
        borderInlineStartStyle: 'solid',
        borderInlineStartWidth: 'border.width.selected',
        content: "''",
        insetBlock: 'space.0',
        insetInlineStart: 'space.0',
        pointerEvents: 'none',
        position: 'absolute'
    }
});
const $2e619933db8dbde7$var$disabledItemStyles = (0, $9BVpB.xcss)({
    alignItems: 'center',
    backgroundColor: 'elevation.surface.overlay',
    color: 'color.text.disabled',
    display: 'flex',
    gap: 'space.150',
    minHeight: '44px',
    paddingBlock: 'space.075',
    paddingInline: 'space.200',
    textAlign: 'start',
    width: '100%'
});
const $2e619933db8dbde7$export$46fa03f3f74132e0 = ({ ariaLabel: ariaLabel, description: description, iconBefore: iconBefore, isDisabled: isDisabled, lozenge: lozenge, onSelect: onSelect, preview: preview, previewIcon: previewIcon, previewImageUrls: previewImageUrls, shortcut: shortcut, titleContent: titleContent, shouldShowPreview: shouldShowPreview = true, shouldClampPreview: shouldClampPreview, shouldWrapIcon: shouldWrapIcon = true, title: title })=>{
    var _resolvedPreview$attr, _resolvedPreview$imag;
    const { item: item, popupsMountPoint: popupsMountPoint } = (0, $efcwg.useQuickInsertContext)();
    const { id: id, isPreviewActive: isPreviewActive, isSelected: isSelected } = item ?? {
        id: undefined,
        isPreviewActive: undefined,
        isSelected: false
    };
    const resolvedDescription = description ?? (item === null || item === void 0 ? void 0 : item.description);
    const previewId = (0, $bSJIT.useId)();
    const handleClick = (0, $ghjHH.useQuickInsertMenuItemSelection)(onSelect);
    const [referenceElement, setReferenceElement] = (0, $bSJIT.useState)(null);
    const resolvedPreview = (0, $bSJIT.useMemo)(()=>preview ?? (previewImageUrls ? {
            image: previewImageUrls
        } : {}), [
        preview,
        previewImageUrls
    ]);
    const shouldRenderPreview = shouldShowPreview && (isPreviewActive ?? isSelected) && !isDisabled;
    const hasAccessiblePreview = Boolean(resolvedDescription || (resolvedPreview === null || resolvedPreview === void 0 ? void 0 : resolvedPreview.attribution));
    const previewAttributionName = (_resolvedPreview$attr = resolvedPreview.attribution) === null || _resolvedPreview$attr === void 0 ? void 0 : _resolvedPreview$attr.name;
    const previewAttributionKey = typeof previewAttributionName === 'string' ? previewAttributionName : previewAttributionName === null || previewAttributionName === void 0 ? void 0 : previewAttributionName.id;
    const rowTitle = titleContent ?? /*#__PURE__*/ (0, $dc70d.jsx)((0, $8aT4G.Text), {
        color: isDisabled ? 'color.text.disabled' : 'color.text',
        children: title
    });
    const wrappedIcon = iconBefore && shouldWrapIcon ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
        xcss: $2e619933db8dbde7$var$styles.iconLarge,
        children: iconBefore
    }) : iconBefore;
    return /*#__PURE__*/ (0, $dc70d.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $dc70d.jsxs)((0, $aHbh3.Pressable), {
                ref: setReferenceElement,
                "aria-label": ariaLabel,
                "aria-describedby": shouldRenderPreview && hasAccessiblePreview ? previewId : undefined,
                "aria-selected": isSelected,
                id: id,
                isDisabled: isDisabled,
                onClick: handleClick,
                role: "option",
                xcss: isDisabled ? $2e619933db8dbde7$var$disabledItemStyles : isSelected ? $2e619933db8dbde7$var$selectedItemStyles : $2e619933db8dbde7$var$itemStyles,
                children: [
                    wrappedIcon && /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
                        xcss: $2e619933db8dbde7$var$styles.iconContainer,
                        children: /*#__PURE__*/ (0, $dc70d.jsx)("span", {
                            className: (0, $9fU1q.default)([
                                "_rpzpjdj5 _1pgcjdj5",
                                !isDisabled && "_syaz1q3r"
                            ]),
                            children: wrappedIcon
                        })
                    }),
                    /*#__PURE__*/ (0, $dc70d.jsxs)((0, $fZ0ZI.Inline), {
                        alignBlock: "center",
                        spread: "space-between",
                        xcss: $2e619933db8dbde7$var$styles.content,
                        children: [
                            lozenge ? /*#__PURE__*/ (0, $dc70d.jsxs)((0, $fZ0ZI.Inline), {
                                alignBlock: "center",
                                space: "space.100",
                                children: [
                                    rowTitle,
                                    lozenge
                                ]
                            }) : rowTitle,
                            shortcut && /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
                                as: "span",
                                xcss: $2e619933db8dbde7$var$styles.shortcut,
                                children: shortcut
                            })
                        ]
                    })
                ]
            }),
            shouldRenderPreview && referenceElement && /*#__PURE__*/ (0, $dc70d.jsx)((0, $1bo0y.QuickInsertHoverPreview), {
                id: previewId,
                description: resolvedDescription,
                preview: resolvedPreview,
                popupsMountPoint: popupsMountPoint,
                referenceElement: referenceElement,
                title: title,
                titleContent: titleContent,
                icon: previewIcon,
                shouldClampText: shouldClampPreview
            }, ((_resolvedPreview$imag = resolvedPreview.image) === null || _resolvedPreview$imag === void 0 ? void 0 : _resolvedPreview$imag.light) ?? previewAttributionKey ?? title)
        ]
    });
};

});
parcelRegister("1bo0y", function(module, exports) {
$parcel$export(module.exports, "QuickInsertHoverPreview", () => $bd975c1b27c67b7e$export$ff7b0dfb01a1c1fe);
/* QuickInsertHoverPreview.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $4Sf72 = parcelRequire("4Sf72");

var $bAB3U = parcelRequire("bAB3U");

var $4vLTk = parcelRequire("4vLTk");

var $3r3CF = parcelRequire("3r3CF");

var $9PwDt = parcelRequire("9PwDt");

var $fZ0ZI = parcelRequire("fZ0ZI");

var $8aT4G = parcelRequire("8aT4G");

var $ceb9s = parcelRequire("ceb9s");

var $64eKJ = parcelRequire("64eKJ");
const $bd975c1b27c67b7e$var$PREVIEW_MODIFIERS = [
    {
        name: 'offset',
        options: {
            offset: [
                0,
                4
            ]
        }
    },
    {
        name: 'flip',
        options: {
            fallbackPlacements: [
                'left-start'
            ],
            // Choose the side by horizontal space; vertical overflow is shifted into view.
            altAxis: false,
            padding: 8,
            rootBoundary: 'viewport'
        }
    },
    {
        name: 'preventOverflow',
        options: {
            mainAxis: true,
            altAxis: true,
            tether: false,
            padding: 8,
            rootBoundary: 'viewport'
        }
    }
];
const $bd975c1b27c67b7e$var$layoutStyles = {
    titleRow: "_1ul9idpf",
    titleIcon: "_4cvr1h6o _1e0c1txw _1o9zidpf _1bah1h6o",
    attributionText: "_16jlkb7n _1o9zkb7n _i0dl1wug _1ul9idpf _1i4qfg65"
};
const $bd975c1b27c67b7e$var$styles = {
    positioner: "_c71lk6is _p12f1oec _1pby16oo",
    panel: "_2rko1qi0 _1reo15vq _18m915vq _1rjcutpp _18zrutpp _vchhusvi _bfhk1bhr _16qs130s _c71l1kw7 _p12f1osq _1bsbncxg",
    content: "_zulpu2gc _1e0c1txw _2lx21bp4",
    title: "_11c81qyo _16jlkb7n _1o9zkb7n _i0dl1wug _1reo15vq _18m915vq _syazazsu _1ul9idpf _1i4qfg65 _1e0ccj1k _sudp1e54 _1yyjcs5v",
    unclampedTitle: "_11c8fhey _16jlkb7n _1o9zkb7n _i0dl1wug _syazi7uo _k48pwu06 _1ul9idpf _1i4qfg65",
    description: "_11c8fhey _1reo15vq _18m915vq _syazi7uo _1e0ccj1k _1i4qfg65 _sudp1e54 _1yyjegat",
    unclampedDescription: "_11c8fhey _syazi7uo _1i4qfg65",
    imageArea: "_2rko12b0 _1reo15vq _18m915vq _bfhkhfxm _4t3i68cl _6rthu2gc _p12f1osq _1bsbp3fh",
    image: "_1e0c1ule _4t3i1osq _5ral1f51 _1bsb1osq",
    imageHidden: "_3um015vq",
    attribution: "_zulp1b66 _4cvr1h6o _syazazsu _1e0c1txw _1i4qfg65",
    compactAttribution: "_11c8wadc",
    attributionIcon: "_16jlidpf _1o9zidpf _i0dlexct _4cvr1h6o _1e0c1txw _4t3i7vkz _1bah1h6o _1bsb7vkz"
};
const $bd975c1b27c67b7e$export$ff7b0dfb01a1c1fe = ({ description: description, icon: icon, id: id, preview: preview, popupsMountPoint: popupsMountPoint, referenceElement: referenceElement, shouldClampText: shouldClampText = true, title: title, titleContent: titleContent })=>{
    const { colorMode: colorMode } = (0, $ceb9s.useThemeObserver)();
    const imageUrl = preview.image ? colorMode === 'dark' && preview.image.dark ? preview.image.dark : preview.image.light : undefined;
    const hasAccessibleContent = Boolean(description || preview.attribution);
    const portalTarget = popupsMountPoint ?? referenceElement.ownerDocument.body;
    return /*#__PURE__*/ (0, $4Sf72.createPortal)(/*#__PURE__*/ (0, $dc70d.jsx)((0, $3r3CF.Popper), {
        placement: "right-start",
        referenceElement: referenceElement,
        strategy: popupsMountPoint ? 'absolute' : 'fixed',
        modifiers: $bd975c1b27c67b7e$var$PREVIEW_MODIFIERS,
        children: ({ ref: ref, style: style, update: update })=>/*#__PURE__*/ (0, $dc70d.jsx)("div", {
                ref: ref,
                style: style,
                className: (0, $9fU1q.default)([
                    $bd975c1b27c67b7e$var$styles.positioner
                ]),
                children: /*#__PURE__*/ (0, $dc70d.jsx)($bd975c1b27c67b7e$var$QuickInsertPreviewPanel, {
                    description: description,
                    icon: icon,
                    id: hasAccessibleContent ? id : undefined,
                    imageUrl: imageUrl,
                    preview: preview,
                    popupsMountPoint: popupsMountPoint,
                    referenceElement: referenceElement,
                    shouldClampText: shouldClampText,
                    title: title,
                    titleContent: titleContent,
                    update: update
                })
            })
    }), portalTarget);
};
const $bd975c1b27c67b7e$var$QuickInsertPreviewPanel = ({ description: description, icon: icon, id: id, imageUrl: imageUrl, preview: preview, popupsMountPoint: popupsMountPoint, referenceElement: referenceElement, shouldClampText: shouldClampText, title: title, titleContent: titleContent, update: update })=>{
    var _preview$attribution, _preview$attribution2;
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const [panelElement, setPanelElement] = (0, $bSJIT.useState)(null);
    const AttributionIcon = (_preview$attribution = preview.attribution) === null || _preview$attribution === void 0 ? void 0 : _preview$attribution.icon;
    const attributionName = (_preview$attribution2 = preview.attribution) === null || _preview$attribution2 === void 0 ? void 0 : _preview$attribution2.name;
    const formattedAttributionName = typeof attributionName === 'string' ? attributionName : attributionName ? formatMessage(attributionName) : '';
    (0, $bSJIT.useLayoutEffect)(()=>{
        var _ownerDocument$defaul;
        update();
        const { ownerDocument: ownerDocument } = referenceElement;
        const onScroll = ()=>void update();
        const unbindScrollListener = (0, $bAB3U.bind)(ownerDocument, {
            type: 'scroll',
            listener: onScroll,
            options: true
        });
        const ResizeObserverConstructor = (_ownerDocument$defaul = ownerDocument.defaultView) === null || _ownerDocument$defaul === void 0 ? void 0 : _ownerDocument$defaul.ResizeObserver;
        if (!panelElement || !ResizeObserverConstructor) return unbindScrollListener;
        const observer = new ResizeObserverConstructor(()=>void update());
        observer.observe(panelElement);
        observer.observe(referenceElement);
        if (popupsMountPoint) observer.observe(popupsMountPoint);
        return ()=>{
            unbindScrollListener();
            observer.disconnect();
        };
    }, [
        panelElement,
        popupsMountPoint,
        referenceElement,
        update
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        ref: setPanelElement,
        id: id,
        role: id ? 'tooltip' : undefined,
        "data-testid": "quick-insert-preview-panel",
        className: (0, $9fU1q.default)([
            $bd975c1b27c67b7e$var$styles.panel
        ]),
        children: /*#__PURE__*/ (0, $dc70d.jsxs)((0, $dc70d.Fragment), {
            children: [
                imageUrl && /*#__PURE__*/ (0, $dc70d.jsx)($bd975c1b27c67b7e$var$PreviewImage, {
                    imageUrl: imageUrl
                }, imageUrl),
                /*#__PURE__*/ (0, $dc70d.jsxs)("div", {
                    className: (0, $9fU1q.default)([
                        $bd975c1b27c67b7e$var$styles.content
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $dc70d.jsxs)((0, $fZ0ZI.Inline), {
                            alignBlock: "center",
                            space: "space.100",
                            xcss: $bd975c1b27c67b7e$var$layoutStyles.titleRow,
                            "aria-hidden": "true",
                            children: [
                                icon && /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
                                    as: "span",
                                    "aria-hidden": "true",
                                    xcss: $bd975c1b27c67b7e$var$layoutStyles.titleIcon,
                                    children: icon
                                }),
                                /*#__PURE__*/ (0, $dc70d.jsx)("span", {
                                    className: (0, $9fU1q.default)([
                                        shouldClampText && $bd975c1b27c67b7e$var$styles.title,
                                        !shouldClampText && $bd975c1b27c67b7e$var$styles.unclampedTitle
                                    ]),
                                    children: titleContent ?? title
                                })
                            ]
                        }),
                        description && /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                            className: (0, $9fU1q.default)([
                                shouldClampText && $bd975c1b27c67b7e$var$styles.description,
                                !shouldClampText && $bd975c1b27c67b7e$var$styles.unclampedDescription
                            ]),
                            children: description
                        }),
                        preview.attribution && /*#__PURE__*/ (0, $dc70d.jsxs)("div", {
                            className: (0, $9fU1q.default)([
                                $bd975c1b27c67b7e$var$styles.attribution,
                                shouldClampText && $bd975c1b27c67b7e$var$styles.compactAttribution
                            ]),
                            children: [
                                AttributionIcon && /*#__PURE__*/ (0, $dc70d.jsx)("span", {
                                    "aria-hidden": "true",
                                    className: (0, $9fU1q.default)([
                                        $bd975c1b27c67b7e$var$styles.attributionIcon
                                    ]),
                                    children: /*#__PURE__*/ (0, $dc70d.jsx)(AttributionIcon, {})
                                }),
                                /*#__PURE__*/ (0, $dc70d.jsx)("span", {
                                    className: (0, $9fU1q.default)([
                                        $bd975c1b27c67b7e$var$layoutStyles.attributionText
                                    ]),
                                    children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $8aT4G.Text), {
                                        size: "small",
                                        color: "color.text.subtle",
                                        children: AttributionIcon ? formattedAttributionName : formatMessage((0, $64eKJ.messages).previewAttributionBy, {
                                            name: formattedAttributionName
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
const $bd975c1b27c67b7e$var$PreviewImage = ({ imageUrl: imageUrl })=>{
    const [hasFailed, setHasFailed] = (0, $bSJIT.useState)(false);
    const [hasLoaded, setHasLoaded] = (0, $bSJIT.useState)(false);
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        "aria-hidden": "true",
        "data-testid": "quick-insert-preview-image-area",
        className: (0, $9fU1q.default)([
            $bd975c1b27c67b7e$var$styles.imageArea
        ]),
        children: !hasFailed && /*#__PURE__*/ (0, $dc70d.jsx)("img", {
            "aria-hidden": "true",
            "data-testid": "quick-insert-hover-preview",
            src: imageUrl,
            alt: "",
            onLoad: ()=>setHasLoaded(true),
            onError: ()=>setHasFailed(true),
            className: (0, $9fU1q.default)([
                $bd975c1b27c67b7e$var$styles.image,
                !hasLoaded && $bd975c1b27c67b7e$var$styles.imageHidden
            ])
        })
    });
};

});
parcelRegister("64eKJ", function(module, exports) {
$parcel$export(module.exports, "messages", () => $ab3674d974285c8c$export$defe85febe8b728c);

var $f0Pt4 = parcelRequire("f0Pt4");
const $ab3674d974285c8c$export$defe85febe8b728c = (0, $f0Pt4.defineMessages)({
    help: {
        id: 'fabric.editor.elementBrowser.help',
        defaultMessage: 'Help',
        description: 'Button label shown in the element browser or quick insert menu. Opens help documentation for the element browser feature.'
    },
    insert: {
        id: 'fabric.editor.elementbrowser.modal.insert',
        defaultMessage: 'Insert',
        description: 'Button label shown in the element browser modal dialog. Confirms and inserts the selected element into the document.'
    },
    close: {
        id: 'fabric.editor.elementbrowser.modal.close',
        defaultMessage: 'Close',
        description: 'Button label shown in the element browser modal dialog. Closes the element browser without inserting any elements.'
    },
    all: {
        id: 'fabric.editor.elementbrowser.categorylist.category-all',
        defaultMessage: 'All',
        description: 'Label for a category filter button in the element browser sidebar that displays all available elements when selected.'
    },
    formatting: {
        id: 'fabric.editor.elementbrowser.categorylist.category-formatting',
        defaultMessage: 'Formatting',
        description: 'Label for a category filter button in the element browser sidebar that filters the list to show only formatting-related elements.'
    },
    'confluence-content': {
        id: 'fabric.editor.elementbrowser.categorylist.category-confluence-content',
        defaultMessage: 'Confluence content',
        description: 'Label for a category filter button in the element browser sidebar that filters the list to show only Confluence content elements.'
    },
    media: {
        id: 'fabric.editor.elementbrowser.categorylist.category-media',
        defaultMessage: 'Media',
        description: 'Label for a category filter button in the element browser sidebar that filters the list to show only media-related elements.'
    },
    visuals: {
        id: 'fabric.editor.elementbrowser.categorylist.category-visuals',
        defaultMessage: 'Visuals & images',
        description: 'Label for a category filter button in the element browser sidebar that filters the list to show only visual and image elements.'
    },
    navigation: {
        id: 'fabric.editor.elementbrowser.categorylist.category-navigation',
        defaultMessage: 'Navigation',
        description: 'Label for a category filter button in the element browser sidebar that filters the list to show only navigation-related elements.'
    },
    'external-content': {
        id: 'fabric.editor.elementbrowser.categorylist.category-external-content',
        defaultMessage: 'External content',
        description: 'Label for a category filter button in the element browser sidebar that filters the list to show only external content elements.'
    },
    communication: {
        id: 'fabric.editor.elementbrowser.categorylist.category-communication',
        defaultMessage: 'Communication',
        description: 'Label for a category filter button in the element browser sidebar that filters the list to show only communication-related elements.'
    },
    reporting: {
        id: 'fabric.editor.elementbrowser.categorylist.category-reporting',
        defaultMessage: 'Reporting',
        description: 'Label for a category filter button in the element browser sidebar that filters the list to show only reporting-related elements.'
    },
    admin: {
        id: 'fabric.editor.elementbrowser.categorylist.category-admin',
        defaultMessage: 'Administration',
        description: 'Label for a category filter button in the element browser sidebar that filters the list to show only administration-related elements.'
    },
    development: {
        id: 'fabric.editor.elementbrowser.categorylist.category-development',
        defaultMessage: 'Development',
        description: 'Label for a category filter button in the element browser sidebar that filters the list to show only development-related elements.'
    },
    AI: {
        id: 'fabric.editor.elementbrowser.categorylist.category-ai',
        defaultMessage: 'Rovo',
        description: 'Label for a category filter button in the element browser sidebar that filters the list to show only Rovo AI-powered elements.'
    },
    featuredWhiteboardDescription: {
        id: 'fabric.editor.elementbrowser.featured.whiteboard.description',
        defaultMessage: 'Use a whiteboard to add visuals to your page',
        description: 'Featured description shown in the element browser. Promotes the whiteboard feature for adding visual content to pages.'
    },
    browse: {
        id: 'fabric.editor.elementbrowser.sidebar.heading',
        defaultMessage: 'Browse',
        description: 'Heading text displayed at the top of the element browser sidebar where users can browse and filter available elements to insert.'
    },
    categoryRecommended: {
        id: 'editor-common.quick-insert.categoryRecommended',
        defaultMessage: 'Recommended',
        description: 'Recommended items in the Quick Insert menu.'
    },
    categoryStructure: {
        id: 'editor-common.quick-insert.categoryStructure',
        defaultMessage: 'Structure',
        description: 'Structure items in the Quick Insert menu.'
    },
    categoryMedia: {
        id: 'editor-common.quick-insert.categoryMedia',
        defaultMessage: 'Media',
        description: 'Media items in the Quick Insert menu.'
    },
    categoryCreate: {
        id: 'editor-common.quick-insert.categoryCreate',
        defaultMessage: 'Create',
        description: 'Create items in the Quick Insert menu.'
    },
    categoryEmbed: {
        id: 'editor-common.quick-insert.categoryEmbed',
        defaultMessage: 'Embed',
        description: 'Embed items in the Quick Insert menu.'
    },
    categoryTextFormatting: {
        id: 'editor-common.quick-insert.categoryTextFormatting',
        defaultMessage: 'Text formatting',
        description: 'Text formatting items in the Quick Insert menu.'
    },
    categoryRovo: {
        id: 'editor-common.quick-insert.categoryRovo',
        defaultMessage: 'Rovo',
        description: 'Rovo items in the Quick Insert menu.'
    },
    categoryDataAndCharts: {
        id: 'editor-common.quick-insert.categoryDataAndCharts',
        defaultMessage: 'Data and charts',
        description: 'Data and chart items in the Quick Insert menu.'
    },
    categoryBlockTemplates: {
        id: 'editor-common.quick-insert.categoryBlockTemplates',
        defaultMessage: 'Block templates',
        description: 'Block template items in the Quick Insert menu.'
    },
    categoryOther: {
        id: 'editor-common.quick-insert.categoryOther',
        defaultMessage: 'Other elements',
        description: 'Other items in the Quick Insert menu.'
    },
    searchResults: {
        id: 'editor-common.quick-insert.searchResults',
        defaultMessage: 'Search results',
        description: 'Heading shown above the matching items when searching in the Quick Insert menu.'
    },
    noSearchResults: {
        id: 'editor-common.quick-insert.noSearchResults',
        defaultMessage: "We couldn't find any results.",
        description: 'Message shown when a Quick Insert search has no matching results.'
    },
    previewAttributionBy: {
        id: 'editor-common.quick-insert.previewAttributionBy',
        defaultMessage: 'By {name}',
        description: 'Attribution shown in a Quick Insert item preview.'
    },
    previewAttributionAtlassian: {
        id: 'editor-common.quick-insert.previewAttributionAtlassian.ai-non-final',
        defaultMessage: 'Atlassian',
        description: 'Atlassian company name shown as the creator in a slash-command preview attribution.'
    },
    previewAttributionAssets: {
        id: 'editor-common.quick-insert.previewAttributionAssets.ai-non-final',
        defaultMessage: 'Assets',
        description: 'Assets product name shown as the creator in a slash-command preview attribution.'
    },
    previewAttributionConfluence: {
        id: 'editor-common.quick-insert.previewAttributionConfluence.ai-non-final',
        defaultMessage: 'Confluence',
        description: 'Confluence product name shown as the creator in a slash-command preview attribution.'
    },
    previewAttributionJira: {
        id: 'editor-common.quick-insert.previewAttributionJira.ai-non-final',
        defaultMessage: 'Jira',
        description: 'Jira product name shown as the creator in a slash-command preview attribution.'
    },
    previewAttributionJiraServiceManagement: {
        id: 'editor-common.quick-insert.previewAttributionJiraServiceManagement.ai-non-final',
        defaultMessage: 'Jira Service Management',
        description: 'Jira Service Management product name shown as the creator in a slash-command preview attribution.'
    },
    previewAttributionTalent: {
        id: 'editor-common.quick-insert.previewAttributionTalent.ai-non-final',
        defaultMessage: 'Talent',
        description: 'Talent product name shown as the creator in a slash-command preview attribution.'
    },
    previewAttributionStudio: {
        id: 'editor-common.quick-insert.previewAttributionStudio.ai-non-final',
        defaultMessage: 'Studio',
        description: 'Studio product name shown as the creator in a slash-command preview attribution.'
    },
    previewAttributionFocus: {
        id: 'editor-common.quick-insert.previewAttributionFocus.ai-non-final',
        defaultMessage: 'Focus',
        description: 'Focus product name shown as the creator in a slash-command preview attribution.'
    },
    previewAttributionTrello: {
        id: 'editor-common.quick-insert.previewAttributionTrello.ai-non-final',
        defaultMessage: 'Trello',
        description: 'Trello product name shown as the creator in a slash-command preview attribution.'
    },
    previewAttributionFeedback: {
        id: 'editor-common.quick-insert.previewAttributionFeedback.ai-non-final',
        defaultMessage: 'Feedback',
        description: 'Feedback product name shown as the creator in a slash-command preview attribution.'
    },
    previewAttributionMicrosoft: {
        id: 'editor-common.quick-insert.previewAttributionMicrosoft.ai-non-final',
        defaultMessage: 'Microsoft',
        description: 'Microsoft company name shown as the creator in a slash-command preview attribution.'
    }
});

});


parcelRegister("ghjHH", function(module, exports) {
$parcel$export(module.exports, "useQuickInsertMenuItemSelection", () => $b7b3c699273658e3$export$79f8e24b7ec7c1d9);

var $bSJIT = parcelRequire("bSJIT");

var $efcwg = parcelRequire("efcwg");
const $b7b3c699273658e3$export$79f8e24b7ec7c1d9 = (onSelect)=>{
    const { editorView: editorView, select: select } = (0, $efcwg.useQuickInsertContext)();
    return (0, $bSJIT.useCallback)(()=>select((selectionContext)=>onSelect({
                editorView: editorView,
                insert: selectionContext.insert,
                source: selectionContext.source
            })), [
        editorView,
        onSelect,
        select
    ]);
};

});
parcelRegister("efcwg", function(module, exports) {
$parcel$export(module.exports, "useQuickInsertContext", () => $7bcc6a7dd80083bb$export$2c0ceb75d6ddbe1f);

var $bSJIT = parcelRequire("bSJIT");

var $qQDWx = parcelRequire("qQDWx");
const $7bcc6a7dd80083bb$export$2c0ceb75d6ddbe1f = ()=>{
    const value = (0, $bSJIT.useContext)((0, $qQDWx.QuickInsertContext));
    if (!value) throw new Error('useQuickInsertContext must be used within QuickInsertProvider');
    return value;
};

});
parcelRegister("qQDWx", function(module, exports) {
$parcel$export(module.exports, "QuickInsertContext", () => $6ecae40f66a9fe86$export$dbec038872997d65);

var $bSJIT = parcelRequire("bSJIT");
const $6ecae40f66a9fe86$export$dbec038872997d65 = (0, $bSJIT.createContext)(null);

});




parcelRegister("2nLnO", function(module, exports) {
$parcel$export(module.exports, "ElementBrowserQuickInsertMenuItem", () => $a3261def6c317aad$export$6bc6abb4df11dffb);
/* ElementBrowserQuickInsertMenuItem.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $3y2s4 = parcelRequire("3y2s4");

var $gUpf2 = parcelRequire("gUpf2");

var $2IITT = parcelRequire("2IITT");

var $aHbh3 = parcelRequire("aHbh3");

var $hYh8H = parcelRequire("hYh8H");

var $aRsbV = parcelRequire("aRsbV");

var $9BVpB = parcelRequire("9BVpB");

var $ghjHH = parcelRequire("ghjHH");

var $efcwg = parcelRequire("efcwg");
const $a3261def6c317aad$var$borderlessItemStyles = (0, $9BVpB.xcss)({
    alignItems: 'start',
    backgroundColor: 'color.background.neutral.subtle',
    borderRadius: 'radius.medium',
    color: 'color.text',
    cursor: 'pointer',
    display: 'flex',
    gap: 'space.150',
    height: '88px',
    padding: 'space.150',
    textAlign: 'start',
    width: '100%'
});
const $a3261def6c317aad$var$borderlessSelectedItemStyles = (0, $9BVpB.xcss)({
    alignItems: 'start',
    backgroundColor: 'color.background.selected',
    borderRadius: 'radius.medium',
    color: 'color.text',
    cursor: 'pointer',
    display: 'flex',
    gap: 'space.150',
    height: '88px',
    padding: 'space.150',
    position: 'relative',
    textAlign: 'start',
    width: '100%',
    '::before': {
        borderInlineStartColor: 'color.border.selected',
        borderInlineStartStyle: 'solid',
        borderInlineStartWidth: 'border.width.selected',
        content: "''",
        insetBlock: 'space.0',
        insetInlineStart: 'space.0',
        pointerEvents: 'none',
        position: 'absolute'
    }
});
const $a3261def6c317aad$var$borderlessDisabledItemStyles = (0, $9BVpB.xcss)({
    alignItems: 'start',
    backgroundColor: 'color.background.neutral.subtle',
    borderRadius: 'radius.medium',
    color: 'color.text.disabled',
    cursor: 'not-allowed',
    display: 'flex',
    gap: 'space.150',
    height: '88px',
    padding: 'space.150',
    textAlign: 'start',
    width: '100%'
});
const $a3261def6c317aad$var$hoveredItemStyles = (0, $9BVpB.xcss)({
    ':hover': {
        backgroundColor: 'elevation.surface.hovered',
        borderRadius: 'radius.medium'
    }
});
const $a3261def6c317aad$var$iconStyles = (0, $9BVpB.xcss)({
    alignItems: 'center',
    backgroundColor: 'elevation.surface.overlay',
    borderColor: 'color.border',
    borderRadius: 'radius.medium',
    borderStyle: 'solid',
    borderWidth: 'border.width',
    display: 'flex',
    flexShrink: 0,
    height: '40px',
    justifyContent: 'center',
    overflow: 'hidden',
    width: '40px'
});
const $a3261def6c317aad$var$iconLargeStyles = (0, $9BVpB.xcss)({
    alignItems: 'center',
    backgroundColor: 'elevation.surface.overlay',
    borderColor: 'color.border',
    borderRadius: 'radius.large',
    borderStyle: 'solid',
    borderWidth: 'border.width',
    display: 'flex',
    flexShrink: 0,
    height: '40px',
    justifyContent: 'center',
    overflow: 'hidden',
    width: '40px'
});
const $a3261def6c317aad$var$iconColorStyles = null;
// Some icons pin a neutral colour inline (for example the Forge and Spotlight icons use
// color.icon.subtle or color.icon.accent.gray), which would ignore the colour set by the menu item.
// Reset only those so every icon follows the menu item (color.icon, or the disabled colour).
// Do NOT widen this to all icon colours: some icons are intentionally coloured (for example skill
// and brand icons that use other --ds-icon-accent-* tokens) and must keep their own colour.
/* eslint-disable @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-important-styles -- Icons pin their colour with an inline style, which only an !important rule on a descendant selector can override. */ const $a3261def6c317aad$var$pinnedIconColorResetStyles = null;
/* eslint-enable @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-important-styles */ const $a3261def6c317aad$var$shortcutStyles = (0, $9BVpB.xcss)({
    backgroundColor: 'color.background.neutral',
    borderRadius: 'radius.small',
    color: 'color.text.subtle',
    font: 'font.body.small',
    paddingBlock: 'space.025',
    paddingInline: 'space.050'
});
const $a3261def6c317aad$export$6bc6abb4df11dffb = ({ ariaLabel: ariaLabel, description: description, iconBefore: iconBefore, isDisabled: isDisabled, lozenge: lozenge, onSelect: onSelect, shortcut: shortcut, titleContent: titleContent, shouldWrapIcon: shouldWrapIcon = true, title: title })=>{
    const { item: item } = (0, $efcwg.useQuickInsertContext)();
    const { id: id, isSelected: isSelected } = item ?? {
        id: undefined,
        isSelected: false
    };
    const itemDescription = description ?? (item === null || item === void 0 ? void 0 : item.description);
    const handleClick = (0, $ghjHH.useQuickInsertMenuItemSelection)(onSelect);
    const itemStyles = (0, $bSJIT.useMemo)(()=>[
            isDisabled ? $a3261def6c317aad$var$borderlessDisabledItemStyles : isSelected ? $a3261def6c317aad$var$borderlessSelectedItemStyles : $a3261def6c317aad$var$borderlessItemStyles,
            (0, $3y2s4.isExperimentEnabled)('platform_editor_slash_command') && !isDisabled && !isSelected && $a3261def6c317aad$var$hoveredItemStyles
        ], [
        isDisabled,
        isSelected
    ]);
    const itemTitle = titleContent ?? /*#__PURE__*/ (0, $dc70d.jsx)((0, $aRsbV.Text), {
        color: isDisabled ? 'color.text.disabled' : 'color.text',
        maxLines: 1,
        size: "medium",
        weight: "medium",
        children: title
    });
    // Disabled items keep the dimmed colour inherited from the item.
    const icon = iconBefore ? /*#__PURE__*/ (0, $dc70d.jsx)("span", {
        className: (0, $9fU1q.default)([
            "_rpzpjdj5 _1pgcjdj5",
            !isDisabled && "_syaz1q3r"
        ]),
        children: iconBefore
    }) : iconBefore;
    return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $aHbh3.Pressable), {
        "aria-label": ariaLabel,
        "aria-selected": isSelected,
        id: id,
        isDisabled: isDisabled,
        onClick: handleClick,
        role: "option",
        tabIndex: isSelected ? 0 : -1,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Memoizes composition of module-scoped xcss styles for Pressable.
        xcss: itemStyles,
        children: [
            iconBefore && shouldWrapIcon ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $gUpf2.Box), {
                xcss: (0, $3y2s4.isExperimentEnabled)('platform_editor_slash_command') ? $a3261def6c317aad$var$iconLargeStyles : $a3261def6c317aad$var$iconStyles,
                children: icon
            }) : icon,
            /*#__PURE__*/ (0, $dc70d.jsxs)((0, $hYh8H.Stack), {
                space: "space.050",
                grow: "fill",
                children: [
                    /*#__PURE__*/ (0, $dc70d.jsxs)((0, $2IITT.Inline), {
                        alignBlock: "center",
                        spread: "space-between",
                        space: "space.100",
                        children: [
                            lozenge ? /*#__PURE__*/ (0, $dc70d.jsxs)((0, $2IITT.Inline), {
                                alignBlock: "center",
                                space: "space.100",
                                children: [
                                    itemTitle,
                                    lozenge
                                ]
                            }) : itemTitle,
                            shortcut && /*#__PURE__*/ (0, $dc70d.jsx)((0, $gUpf2.Box), {
                                as: "span",
                                xcss: $a3261def6c317aad$var$shortcutStyles,
                                children: shortcut
                            })
                        ]
                    }),
                    itemDescription && /*#__PURE__*/ (0, $dc70d.jsx)((0, $aRsbV.Text), {
                        color: "color.text.subtlest",
                        maxLines: 2,
                        size: "small",
                        weight: "regular",
                        children: itemDescription
                    })
                ]
            })
        ]
    });
};

});


parcelRegister("6NFXF", function(module, exports) {
$parcel$export(module.exports, "executeExtensionQuickInsertItem", () => $e93f21dd197fd0bf$export$70dcc8733cd2c05e);

var $bTWXs = parcelRequire("bTWXs");

var $g6Qq4 = parcelRequire("g6Qq4");

var $6o5zV = parcelRequire("6o5zV");

var $j2Y9J = parcelRequire("j2Y9J");

var $85mAs = parcelRequire("85mAs");
var $fcrbf = parcelRequire("fcrbf");

var $6m8Z0 = parcelRequire("6m8Z0");

var $gab48 = parcelRequire("gab48");
const $e93f21dd197fd0bf$var$sendAnalytics = (item, selection, createAnalyticsEvent, source)=>{
    if (createAnalyticsEvent) {
        const insertLocation = (0, $6m8Z0.findInsertLocation)(selection);
        (0, $bTWXs.fireAnalyticsEvent)(createAnalyticsEvent)({
            payload: {
                action: (0, $g6Qq4.ACTION).INSERTED,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).DOCUMENT,
                actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).EXTENSION,
                attributes: {
                    extensionType: item.extensionType,
                    extensionKey: item.extensionKey,
                    key: item.key,
                    inputMethod: source || (0, $g6Qq4.INPUT_METHOD).QUICK_INSERT,
                    ...insertLocation ? {
                        insertLocation: insertLocation
                    } : {}
                },
                eventType: (0, $g6Qq4.EVENT_TYPE).TRACK
            }
        });
    }
};
const $e93f21dd197fd0bf$var$warnDummyAPI = (location)=>{};
const $e93f21dd197fd0bf$var$dummyExtensionAPI = {
    editInContextPanel: ()=>$e93f21dd197fd0bf$var$warnDummyAPI('editInContextPanel'),
    _editInLegacyMacroBrowser: ()=>$e93f21dd197fd0bf$var$warnDummyAPI('_editInLegacyMacroBrowser'),
    getNodeWithPosByLocalId: ()=>({
            node: null,
            pos: null
        }),
    doc: {
        insertAfter: ()=>$e93f21dd197fd0bf$var$warnDummyAPI('doc:insertAfter'),
        scrollTo: ()=>$e93f21dd197fd0bf$var$warnDummyAPI('doc:scrollTo'),
        update: ()=>$e93f21dd197fd0bf$var$warnDummyAPI('doc:update')
    }
};
const $e93f21dd197fd0bf$export$70dcc8733cd2c05e = ({ apiRef: apiRef, createAnalyticsEvent: createAnalyticsEvent, editorActions: editorActions, insert: insert, item: item, source: source, state: state })=>{
    if (typeof item.node === 'function') {
        var _apiRef$current;
        const extensionAPI = ((_apiRef$current = apiRef.current) === null || _apiRef$current === void 0 || (_apiRef$current = _apiRef$current.extension) === null || _apiRef$current === void 0 || (_apiRef$current = _apiRef$current.actions) === null || _apiRef$current === void 0 ? void 0 : _apiRef$current.api()) ?? $e93f21dd197fd0bf$var$dummyExtensionAPI;
        (0, $6o5zV.resolveImport)(item.node(extensionAPI)).then((node)=>{
            $e93f21dd197fd0bf$var$sendAnalytics(item, state.selection, createAnalyticsEvent, source);
            if (node) {
                const api = apiRef.current;
                if (!api) {
                    editorActions.replaceSelection(node);
                    return;
                }
                api.core.actions.execute(({ tr: tr })=>{
                    const content = Array.isArray(node) ? (0, $85mAs.processRawFragmentValue)(tr.doc.type.schema, node) : (0, $fcrbf.processRawValue)(tr.doc.type.schema, node);
                    return content ? (0, $gab48.safeInsert)(content)(tr).scrollIntoView() : null;
                });
            }
        }).catch((error)=>(0, $j2Y9J.logException)(error, {
                location: 'editor-core/quick-insert'
            }));
        return insert('');
    }
    $e93f21dd197fd0bf$var$sendAnalytics(item, state.selection, createAnalyticsEvent, source);
    return insert(item.node);
};

});

parcelRegister("3Gvpq", function(module, exports) {
$parcel$export(module.exports, "ExtensionQuickInsertIcon", () => $c825aa0e091c75c7$export$fa4d06fd361b5e56);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $7jffA = parcelRequire("7jffA");

var $5pq7B = parcelRequire("5pq7B");

var $hL5C4 = parcelRequire("hL5C4");

var $kNU38 = parcelRequire("kNU38");

var $1BhEG = parcelRequire("1BhEG");

var $dLQt5 = parcelRequire("dLQt5");
const $c825aa0e091c75c7$var$lazyExtensionIconCache = new WeakMap();
const $c825aa0e091c75c7$var$whiteboardQuickInsertItemKeys = new Set([
    'whiteboard-extension:create-whiteboard',
    'whiteboard-extension:create-diagram',
    'whiteboard-extension:create-flowchart',
    'whiteboard-extension:create-brainstorming',
    'whiteboard-extension:create-retrospective',
    'whiteboard-extension:create-roadmap'
]);
const $c825aa0e091c75c7$var$quickInsertItemIcons = {
    'toc:toc': (0, (/*@__PURE__*/$parcel$interopDefault($5pq7B))),
    'cards:quick-insert': (0, (/*@__PURE__*/$parcel$interopDefault($1BhEG))),
    'carousel:quick-insert': (0, (/*@__PURE__*/$parcel$interopDefault($7jffA))),
    'create-from-template:create-from-template': (0, (/*@__PURE__*/$parcel$interopDefault($hL5C4)))
};
const $c825aa0e091c75c7$var$resolveExtensionIcon = async (getIcon)=>{
    try {
        const maybeIcon = await (getIcon === null || getIcon === void 0 ? void 0 : getIcon());
        if (!maybeIcon) return 0, (/*@__PURE__*/$parcel$interopDefault($kNU38));
        if (Object.prototype.hasOwnProperty.call(maybeIcon, 'default')) return maybeIcon.default ?? (0, (/*@__PURE__*/$parcel$interopDefault($kNU38)));
        return maybeIcon;
    } catch  {
        return 0, (/*@__PURE__*/$parcel$interopDefault($kNU38));
    }
};
const $c825aa0e091c75c7$var$createLazyExtensionIcon = (getIcon)=>{
    const cachedIcon = $c825aa0e091c75c7$var$lazyExtensionIconCache.get(getIcon);
    if (cachedIcon) return cachedIcon;
    const LazyIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).lazy(()=>$c825aa0e091c75c7$var$resolveExtensionIcon(getIcon).then((Icon)=>({
                default: Icon
            })));
    LazyIcon.displayName = 'lazy(ExtensionIcon)';
    const Icon = ({ label: label, size: size })=>/*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Suspense, {
            fallback: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kNU38))), {
                label: label,
                size: size
            }),
            children: /*#__PURE__*/ (0, $dc70d.jsx)(LazyIcon, {
                label: label,
                size: size
            })
        });
    $c825aa0e091c75c7$var$lazyExtensionIconCache.set(getIcon, Icon);
    return Icon;
};
const $c825aa0e091c75c7$export$fa4d06fd361b5e56 = ({ getIcon: getIcon, itemKey: itemKey, label: label, size: size })=>{
    const Icon = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useMemo(()=>{
        const quickInsertItemIcon = $c825aa0e091c75c7$var$quickInsertItemIcons[itemKey];
        if (quickInsertItemIcon) return quickInsertItemIcon;
        if ($c825aa0e091c75c7$var$whiteboardQuickInsertItemKeys.has(itemKey)) return 0, (/*@__PURE__*/$parcel$interopDefault($dLQt5));
        return getIcon ? $c825aa0e091c75c7$var$createLazyExtensionIcon(getIcon) : (0, (/*@__PURE__*/$parcel$interopDefault($kNU38)));
    }, [
        getIcon,
        itemKey
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)(Icon, {
        label: label,
        size: size
    });
};

});
parcelRegister("7jffA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::435baa6d24c46bfcc411e1a21e3f5a79>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5526232be9242f0a$var$_react = $5526232be9242f0a$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $5526232be9242f0a$var$_iconNew = $5526232be9242f0a$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $5526232be9242f0a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Carousel".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/carousel
 * Usage guidance:
 * Reserved for representing carousel macro in editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5526232be9242f0a$var$CarouselIcon = (props)=>/*#__PURE__*/ $5526232be9242f0a$var$_react.default.createElement($5526232be9242f0a$var$_iconNew.default, Object.assign({
        name: "CarouselIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11.25 3a.5.5 0 0 0-.5-.5h-5.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h5.5a.5.5 0 0 0 .5-.5zm1.5 10a2 2 0 0 1-2 2h-5.5a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h5.5a2 2 0 0 1 2 2zM14.5 2.75H16v10.5h-1.5zM0 2.75h1.5v10.5H0z"/><path fill="currentcolor" d="M9.44 6.5a.75.75 0 0 1 .64.3l2.52 3.38-1.2.9-1.84-2.47-3.41 5.78-1.29-.76 3.98-6.75a.75.75 0 0 1 .61-.37M7 4a1.25 1.25 0 1 1 0 2.5A1.25 1.25 0 0 1 7 4"/>`
    }, props));
$5526232be9242f0a$var$CarouselIcon.displayName = 'CarouselIcon';
var $5526232be9242f0a$var$_default = module.exports.default = $5526232be9242f0a$var$CarouselIcon;

});

parcelRegister("5pq7B", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ba8e3178d04dd5e3d53ab4dd399b430d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3f038cc557cd0ca0$var$_react = $3f038cc557cd0ca0$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $3f038cc557cd0ca0$var$_iconNew = $3f038cc557cd0ca0$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $3f038cc557cd0ca0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TableOfContent".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/table-of-content
 * Usage guidance:
 * Reserved for representing table of contents.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3f038cc557cd0ca0$var$TableOfContentIcon = (props)=>/*#__PURE__*/ $3f038cc557cd0ca0$var$_react.default.createElement($3f038cc557cd0ca0$var$_iconNew.default, Object.assign({
        name: "TableOfContentIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14 3.75v-1.5H4v1.5zm0 10v-1.5H4v1.5zm2-6.5v1.5H8v-1.5zM6 9H4V7h2zM2 4H0V2h2zm0 10H0v-2h2z"/>`
    }, props));
$3f038cc557cd0ca0$var$TableOfContentIcon.displayName = 'TableOfContentIcon';
var $3f038cc557cd0ca0$var$_default = module.exports.default = $3f038cc557cd0ca0$var$TableOfContentIcon;

});

parcelRegister("hL5C4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::11ff3476759ba85eb0a355499bddb2e2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cedb2e0fc712bba6$var$_react = $cedb2e0fc712bba6$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $cedb2e0fc712bba6$var$_iconNew = $cedb2e0fc712bba6$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $cedb2e0fc712bba6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Template".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/template
 * Usage guidance:
 * Reserved fore templates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cedb2e0fc712bba6$var$TemplateIcon = (props)=>/*#__PURE__*/ $cedb2e0fc712bba6$var$_react.default.createElement($cedb2e0fc712bba6$var$_iconNew.default, Object.assign({
        name: "TemplateIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 6h-7v7.5H13a.5.5 0 0 0 .5-.5zm-11 7a.5.5 0 0 0 .5.5h2V6H2.5zm11-10a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v1.5h11zM15 13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"/>`
    }, props));
$cedb2e0fc712bba6$var$TemplateIcon.displayName = 'TemplateIcon';
var $cedb2e0fc712bba6$var$_default = module.exports.default = $cedb2e0fc712bba6$var$TemplateIcon;

});



parcelRegister("8hkQp", function(module, exports) {
$parcel$export(module.exports, "QuickInsertSkillMenuItem", () => $55cabb658cfca516$export$605ca0190b93d615);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $fT9mF = parcelRequire("fT9mF");

var $hJwPU = parcelRequire("hJwPU");

var $efcwg = parcelRequire("efcwg");

var $6NFXF = parcelRequire("6NFXF");

var $3Gvpq = parcelRequire("3Gvpq");
const $55cabb658cfca516$export$605ca0190b93d615 = ({ apiRef: apiRef, createAnalyticsEvent: createAnalyticsEvent, editorActions: editorActions, item: item, onInsert: onInsert })=>{
    var _item$parameters;
    const { editorView: editorView, isOffline: isOffline } = (0, $efcwg.useQuickInsertContext)();
    const onSelect = (0, $bSJIT.useCallback)(({ insert: insert, source: source })=>{
        const result = (0, $6NFXF.executeExtensionQuickInsertItem)({
            apiRef: apiRef,
            createAnalyticsEvent: createAnalyticsEvent,
            editorActions: editorActions,
            insert: insert,
            item: item,
            source: source,
            state: editorView.state
        });
        if (result) onInsert === null || onInsert === void 0 || onInsert();
        return result;
    }, [
        apiRef,
        createAnalyticsEvent,
        editorActions,
        editorView.state,
        item,
        onInsert
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $fT9mF.QuickInsertMenuItem), {
        ariaLabel: item.title,
        description: item.description,
        iconBefore: /*#__PURE__*/ (0, $dc70d.jsx)((0, $3Gvpq.ExtensionQuickInsertIcon), {
            getIcon: item.icon,
            itemKey: item.key,
            label: ""
        }),
        isDisabled: isOffline,
        lozenge: item.lozenge,
        onSelect: onSelect,
        preview: item.preview,
        previewIcon: /*#__PURE__*/ (0, $dc70d.jsx)((0, $3Gvpq.ExtensionQuickInsertIcon), {
            getIcon: item.icon,
            itemKey: item.key,
            label: "",
            size: "small"
        }),
        shouldClampPreview: false,
        title: item.title,
        titleContent: item.moduleKey ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $hJwPU.SkillTag), {
            color: (_item$parameters = item.parameters) === null || _item$parameters === void 0 ? void 0 : _item$parameters.color,
            isDisabled: isOffline,
            slug: item.moduleKey
        }) : undefined
    });
};

});
parcelRegister("hJwPU", function(module, exports) {
$parcel$export(module.exports, "SkillTag", () => $c2be379d245cd199$export$55feb0e4f341a6f6);
/* SkillTag.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $9fU1q = parcelRequire("9fU1q");
parcelRequire("bSJIT");
// SVG fills use background and border colour tokens, which @atlaskit/css's schema does not allow for `fill`.
// The edges fill the tag background, and the slash is a coloured stripe over the start edge.
const $c2be379d245cd199$var$START_EDGE_PATH = 'M4.88566 1.4253C5.13945 0.579336 5.91809 0 6.80131 0H7.31325V20H2.00131C0.661586 20 -0.299308 18.7085 0.0856588 17.4253L4.88566 1.4253Z';
const $c2be379d245cd199$var$END_EDGE_PATH = 'M4.39518 1.91565C4.73628 0.778646 5.78281 0 6.96988 0V20H3.00197C0.99238 20 -0.448963 18.0628 0.128488 16.138L4.39518 1.91565Z';
const $c2be379d245cd199$var$SLASH_PATH = 'M5.06145 1.4253C5.31524 0.579336 6.09388 0 6.9771 0H7.48904L1.48904 20C0.49224 20 -0.222695 19.0391 0.0637328 18.0843L5.06145 1.4253Z';
const $c2be379d245cd199$var$styles = {
    tag: "_1e0c1nu9 _1i4qfg65 _o5724jg8",
    text: "_11c8fhey _syazi7uo",
    textDisabled: "_syaz1gmx",
    noWrap: "_o5721q9c",
    highlight: "_bfhki8nm _16d9qvcn _1e0c1nu9",
    highlightDisabled: "_bfhk187o",
    highlightStart: "_bozgv77o",
    highlightEnd: "_y4tiv77o",
    edge: "_1e0c1nu9 _bozgu2gc _kqswh2mm",
    edgeShape: "_4t3i1osq _152tze3t _1e02ze3t _kqswstnw _1bsb1osq"
};
const $c2be379d245cd199$var$fillStyles = {
    edge: "_lswui8nm",
    edgeDisabled: "_lswu187o",
    slashDisabled: "_lswubk0g"
};
const $c2be379d245cd199$var$slashColorStyles = {
    LIME: "_lswunf89",
    RED: "_lswu16y8",
    ORANGE: "_lswu1b2s",
    YELLOW: "_lswufeiv",
    GREEN: "_lswu1crs",
    TEAL: "_lswu1h3o",
    BLUE: "_lswu1w55",
    PURPLE: "_lswu1hqq",
    MAGENTA: "_lswuuwd0",
    GRAY: "_lswu8yml",
    DEFAULT: "_lswu1l7x"
};
const $c2be379d245cd199$var$SKILL_TAG_COLORS = [
    'LIME',
    'RED',
    'ORANGE',
    'YELLOW',
    'GREEN',
    'TEAL',
    'BLUE',
    'PURPLE',
    'MAGENTA',
    'GRAY',
    'DEFAULT'
];
const $c2be379d245cd199$var$isSkillTagColor = (color)=>$c2be379d245cd199$var$SKILL_TAG_COLORS.includes(color);
const $c2be379d245cd199$var$Edge = ({ children: children, isDisabled: isDisabled })=>/*#__PURE__*/ (0, $dc70d.jsx)("span", {
        "aria-hidden": "true",
        className: (0, $9fU1q.default)([
            $c2be379d245cd199$var$styles.edge
        ]),
        children: /*#__PURE__*/ (0, $dc70d.jsx)("svg", {
            focusable: "false",
            preserveAspectRatio: "none",
            viewBox: "0 0 8 20",
            className: (0, $9fU1q.default)([
                $c2be379d245cd199$var$styles.edgeShape,
                $c2be379d245cd199$var$fillStyles.edge,
                isDisabled && $c2be379d245cd199$var$fillStyles.edgeDisabled
            ]),
            children: children
        })
    });
const $c2be379d245cd199$var$Highlight = ({ children: children, isDisabled: isDisabled, side: side })=>/*#__PURE__*/ (0, $dc70d.jsx)("span", {
        className: (0, $9fU1q.default)([
            $c2be379d245cd199$var$styles.highlight,
            isDisabled && $c2be379d245cd199$var$styles.highlightDisabled,
            side === 'start' && $c2be379d245cd199$var$styles.highlightStart,
            side === 'end' && $c2be379d245cd199$var$styles.highlightEnd
        ]),
        children: children
    });
const $c2be379d245cd199$export$55feb0e4f341a6f6 = ({ color: color, slug: slug, isDisabled: isDisabled = false })=>{
    const slashColor = $c2be379d245cd199$var$isSkillTagColor(color) ? color : 'DEFAULT';
    // The first and last characters share a no-wrap span with the edge beside them, so a long slug
    // can wrap without leaving an edge alone at the start or end of a line.
    const firstCharacter = slug.slice(0, 1);
    const middleCharacters = slug.slice(1, -1);
    const lastCharacter = slug.slice(1).slice(-1);
    return /*#__PURE__*/ (0, $dc70d.jsxs)("span", {
        className: (0, $9fU1q.default)([
            $c2be379d245cd199$var$styles.tag,
            $c2be379d245cd199$var$styles.text,
            isDisabled && $c2be379d245cd199$var$styles.textDisabled
        ]),
        children: [
            /*#__PURE__*/ (0, $dc70d.jsxs)("span", {
                className: (0, $9fU1q.default)([
                    $c2be379d245cd199$var$styles.noWrap
                ]),
                children: [
                    /*#__PURE__*/ (0, $dc70d.jsxs)($c2be379d245cd199$var$Edge, {
                        isDisabled: isDisabled,
                        children: [
                            /*#__PURE__*/ (0, $dc70d.jsx)("path", {
                                d: $c2be379d245cd199$var$START_EDGE_PATH,
                                transform: "translate(0.686 0)"
                            }),
                            /*#__PURE__*/ (0, $dc70d.jsx)("path", {
                                d: $c2be379d245cd199$var$SLASH_PATH,
                                transform: "translate(0.511 0)",
                                className: (0, $9fU1q.default)([
                                    $c2be379d245cd199$var$slashColorStyles[slashColor],
                                    isDisabled && $c2be379d245cd199$var$fillStyles.slashDisabled
                                ])
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $dc70d.jsx)($c2be379d245cd199$var$Highlight, {
                        isDisabled: isDisabled,
                        side: "start",
                        children: firstCharacter
                    })
                ]
            }),
            middleCharacters && /*#__PURE__*/ (0, $dc70d.jsx)($c2be379d245cd199$var$Highlight, {
                isDisabled: isDisabled,
                children: middleCharacters
            }),
            /*#__PURE__*/ (0, $dc70d.jsxs)("span", {
                className: (0, $9fU1q.default)([
                    $c2be379d245cd199$var$styles.noWrap
                ]),
                children: [
                    /*#__PURE__*/ (0, $dc70d.jsx)($c2be379d245cd199$var$Highlight, {
                        isDisabled: isDisabled,
                        side: "end",
                        children: lastCharacter
                    }),
                    /*#__PURE__*/ (0, $dc70d.jsx)($c2be379d245cd199$var$Edge, {
                        isDisabled: isDisabled,
                        children: /*#__PURE__*/ (0, $dc70d.jsx)("path", {
                            d: $c2be379d245cd199$var$END_EDGE_PATH,
                            transform: "rotate(180 4 10) translate(1.03 0)"
                        })
                    })
                ]
            })
        ]
    });
};

});





parcelRegister("fSZYE", function(module, exports) {
$parcel$export(module.exports, "default", () => $3ca4045045db937f$export$2e2bcd8739ae039);
function $3ca4045045db937f$export$2e2bcd8739ae039({ autoformattingProvider: autoformattingProvider, emojiProvider: emojiProvider, mentionProvider: mentionProvider, legacyImageUploadProvider: legacyImageUploadProvider, taskDecisionProvider: taskDecisionProvider, contextIdentifierProvider: contextIdentifierProvider, searchProvider: searchProvider, macroProvider: macroProvider, activityProvider: activityProvider, collabEdit: collabEdit, collabEditProvider: collabEditProvider, presenceProvider: presenceProvider }) {
    return {
        emojiProvider: emojiProvider,
        mentionProvider: mentionProvider,
        autoformattingProvider: autoformattingProvider,
        activityProvider: activityProvider,
        imageUploadProvider: legacyImageUploadProvider,
        taskDecisionProvider: taskDecisionProvider,
        contextIdentifierProvider: contextIdentifierProvider,
        searchProvider: searchProvider,
        presenceProvider: presenceProvider,
        macroProvider: macroProvider,
        collabEditProvider: collabEdit !== null && collabEdit !== void 0 && collabEdit.provider ? collabEdit.provider : collabEditProvider
    };
}

});

parcelRegister("j5Zfs", function(module, exports) {
$parcel$export(module.exports, "default", () => $e98840b705647d95$export$2e2bcd8739ae039);
function $e98840b705647d95$export$2e2bcd8739ae039(providerFactory, { mentionProvider: mentionProvider, contextIdentifierProvider: contextIdentifierProvider, collabEditProvider: collabEditProvider, activityProvider: activityProvider, presenceProvider: presenceProvider, macroProvider: macroProvider, imageUploadProvider: imageUploadProvider, searchProvider: searchProvider }, extensionProvider, quickInsertProvider) {
    providerFactory.setProvider('mentionProvider', mentionProvider);
    providerFactory.setProvider('contextIdentifierProvider', contextIdentifierProvider);
    providerFactory.setProvider('imageUploadProvider', imageUploadProvider);
    providerFactory.setProvider('collabEditProvider', collabEditProvider);
    providerFactory.setProvider('activityProvider', activityProvider);
    providerFactory.setProvider('searchProvider', searchProvider);
    providerFactory.setProvider('presenceProvider', presenceProvider);
    providerFactory.setProvider('macroProvider', macroProvider);
    if (extensionProvider) providerFactory.setProvider('extensionProvider', Promise.resolve(extensionProvider));
    if (quickInsertProvider) providerFactory.setProvider('quickInsertProvider', quickInsertProvider);
}

});




parcelRegister("2z97M", function(module, exports) {
$parcel$export(module.exports, "alignmentMessages", () => $9af2749f482ebd9c$export$5229ffea355cfdf6);

var $f0Pt4 = parcelRequire("f0Pt4");
const $9af2749f482ebd9c$export$5229ffea355cfdf6 = (0, $f0Pt4.defineMessages)({
    alignment: {
        id: 'fabric.editor.alignment',
        defaultMessage: 'Text alignment',
        description: 'Opens drop down menu of options to configure text alignment'
    },
    alignLeft: {
        id: 'fabric.editor.alignLeft',
        defaultMessage: 'Align left',
        description: 'Label for a toolbar button that aligns the selected text to the left margin of the editor.'
    },
    alignCenter: {
        id: 'fabric.editor.alignCenter',
        defaultMessage: 'Align center',
        description: 'label stating that text is aligned center'
    },
    alignRight: {
        id: 'fabric.editor.alignRight',
        defaultMessage: 'Align right',
        description: 'label stating that text is aligned right'
    }
});

});

parcelRegister("fuAsP", function(module, exports) {
$parcel$export(module.exports, "annotationMessages", () => $ac6a66c46af02d23$export$ff612ca71703201d);

var $f0Pt4 = parcelRequire("f0Pt4");
const $ac6a66c46af02d23$export$ff612ca71703201d = (0, $f0Pt4.defineMessages)({
    createComment: {
        id: 'fabric.editor.createComment',
        defaultMessage: 'Comment',
        description: 'Create/add an inline comment based on the users selection'
    },
    // Ignored via go/ees007
    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
    // TODO: Remove this message when the editor_inline_comments_on_inline_nodes FF is removed
    createCommentInvalid: {
        id: 'fabric.editor.createCommentInvalid',
        defaultMessage: 'You can only comment on text and headings',
        description: 'Error message to communicate to the user they can only do the current action in certain contexts'
    },
    createCommentDisabled: {
        id: 'fabric.editor.createCommentDisabled',
        defaultMessage: 'You can only comment on text, headings, emojis, dates, mentions, links, and statuses.',
        description: 'Error message to communicate to the user they can only do the current action in certain contexts'
    },
    // Duplicated by Confluence's
    // highlight-actions.inline-comments.comment.no.permission
    noPermissionToAddComment: {
        id: 'fabric.editor.noPermissionToAddComment',
        defaultMessage: '{contentType, select, blogpost {You do not have permission to add comments to this blogpost} page {You do not have permission to add comments to this page} other {You do not have permission to add comments to this page}}',
        description: 'Tooltip for when the user does not have permission to add inline comments'
    },
    toolbar: {
        id: 'fabric.editor.annotationToolbar',
        defaultMessage: 'Annotation toolbar',
        description: 'A label for a toolbar (UI element) that creates annotations/comments in the document'
    }
});

});

parcelRegister("hETL4", function(module, exports) {
$parcel$export(module.exports, "messages", () => $f6ee907a324121b0$export$defe85febe8b728c);

var $f0Pt4 = parcelRequire("f0Pt4");
const $f6ee907a324121b0$export$defe85febe8b728c = (0, $f0Pt4.defineMessages)({
    moveUpBlock: {
        id: 'fabric.editor.block.menu.move.up',
        defaultMessage: 'Move up',
        description: 'Move the selected block up in the document'
    },
    moveDownBlock: {
        id: 'fabric.editor.block.menu.move.down',
        defaultMessage: 'Move down',
        description: 'Move the selected block down in the document'
    },
    copy: {
        id: 'fabric.editor.block.menu.copy',
        defaultMessage: 'Copy',
        description: 'Copy the selected content to the clipboard'
    },
    copyLink: {
        id: 'fabric.editor.block.menu.copy.link',
        defaultMessage: 'Copy link',
        description: 'Label for a menu item in the block controls menu that copies a direct link to the selected content block to the clipboard.'
    },
    copyLinkToSelection: {
        id: 'fabric.editor.block.menu.copy.link.to.selection',
        defaultMessage: 'Copy link to selection',
        description: 'Label for a menu item in the block controls menu that copies a link pointing to the current text selection to the clipboard.'
    },
    linkCopiedToClipboard: {
        id: 'fabric.editor.block.menu.link.copied.to.clipboard',
        defaultMessage: 'Link copied to clipboard',
        description: 'Confirmation message shown when link is copied to clipboard'
    },
    paragraph: {
        id: 'fabric.editor.block.menu.paragraph',
        defaultMessage: 'Paragraph',
        description: 'Change the selected block to a paragraph'
    },
    normalText: {
        id: 'fabric.editor.block.menu.normal.text',
        defaultMessage: 'Normal text',
        description: 'Change the selected block to normal text'
    },
    codeBlock: {
        id: 'fabric.editor.block.menu.codeblock',
        defaultMessage: 'Code block',
        description: 'Convert the selected block to a code block'
    },
    layout: {
        id: 'fabric.editor.block.menu.layout',
        defaultMessage: 'Layout',
        description: 'Convert the selected block to a layout node'
    },
    deleteBlock: {
        id: 'fabric.editor.block.menu.delete.block',
        defaultMessage: 'Delete',
        description: 'Delete the selected block from the document'
    },
    turnInto: {
        id: 'fabric.editor.block.menu.turn.into',
        defaultMessage: 'Turn into',
        description: 'Turn the selected block into another type'
    },
    changeFormat: {
        id: 'fabric.editor.block.menu.change.format',
        defaultMessage: 'Change format',
        description: 'Change the selected block to another format'
    },
    syncBlock: {
        id: 'fabric.editor.block.menu.sync.block',
        defaultMessage: 'Sync block',
        description: 'Create a synced block at this line, converting the selection to a synced block if applicable'
    },
    copySyncedBlock: {
        id: 'fabric.editor.block.menu.copy.synced.block',
        defaultMessage: 'Copy synced block',
        description: 'Copy the selected synced block to the clipboard'
    },
    newLozenge: {
        id: 'fabric.editor.block.menu.new.lozenge',
        defaultMessage: 'New',
        description: 'Text in lozenge which appears next to newly added menu items'
    },
    decisionList: {
        id: 'fabric.editor.block.menu.decision',
        defaultMessage: 'Decision',
        description: 'Label for the decision option in the block menu transformation menu'
    },
    wrapIcon: {
        id: 'fabric.editor.block.menu.wrap.icon',
        defaultMessage: 'Wrap',
        description: 'Aria label for the wrap icon in code block toolbar'
    },
    create: {
        id: 'fabric.editor.block.menu.create',
        defaultMessage: 'Create',
        description: 'Menu section title for creating new block types'
    },
    headings: {
        id: 'fabric.editor.block.menu.headings',
        defaultMessage: 'Headings',
        description: 'Menu section title for heading block types'
    },
    textFormatting: {
        id: 'fabric.editor.block.menu.text.formatting',
        defaultMessage: 'Text formatting',
        description: 'Menu section title for text formatting block types'
    },
    suggested: {
        id: 'fabric.editor.block.menu.suggested',
        defaultMessage: 'Suggested',
        description: 'Menu section title for suggested block types'
    },
    structure: {
        id: 'fabric.editor.block.menu.structure',
        defaultMessage: 'Structure',
        description: 'Menu section title for structural block types'
    },
    fallbackNestedMenu: {
        id: 'fabric.editor.block.menu.fallback.nested.menu',
        defaultMessage: 'Nested Menu',
        description: 'Fallback text displayed for nested menu component in block menu when proper component is not available'
    },
    fallbackMenuItem: {
        id: 'fabric.editor.block.menu.fallback.menu.item',
        defaultMessage: 'Block Menu Item',
        description: 'Fallback text displayed for menu item component in block menu when proper component is not available'
    }
});

});

parcelRegister("8iYGb", function(module, exports) {
$parcel$export(module.exports, "messages", () => $5553f7c84ec4eb72$export$defe85febe8b728c);

var $f0Pt4 = parcelRequire("f0Pt4");
const $5553f7c84ec4eb72$export$defe85febe8b728c = (0, $f0Pt4.defineMessages)({
    normal: {
        id: 'fabric.editor.normal',
        defaultMessage: 'Normal text',
        description: 'Label for a drop-down item in the text style selector that applies the default paragraph style, removing any heading or special formatting.'
    },
    smallText: {
        id: 'fabric.editor.smallText',
        defaultMessage: 'Small text',
        description: 'This is a smaller variant of the normal text style'
    },
    heading1: {
        id: 'fabric.editor.heading1',
        defaultMessage: 'Heading 1',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading1Description: {
        id: 'fabric.editor.heading1Description',
        defaultMessage: 'Use this for a top level heading',
        description: 'Description of the main heading, heading 1'
    },
    heading2: {
        id: 'fabric.editor.heading2',
        defaultMessage: 'Heading 2',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading2Description: {
        id: 'fabric.editor.heading2Description',
        defaultMessage: 'Use this for key sections',
        description: 'Description of a subtitle heading or secondary heading'
    },
    heading3: {
        id: 'fabric.editor.heading3',
        defaultMessage: 'Heading 3',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading3Description: {
        id: 'fabric.editor.heading3Description',
        defaultMessage: 'Use this for sub sections and group headings',
        description: 'Description text shown in the block type menu to help users understand when to use Heading 3 for sub sections and group headings in the editor.'
    },
    heading4: {
        id: 'fabric.editor.heading4',
        defaultMessage: 'Heading 4',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading4Description: {
        id: 'fabric.editor.heading4Description',
        defaultMessage: 'Use this for deep headings',
        description: 'Description text shown in the block type menu to help users understand when to use Heading 4 for deep headings in the editor.'
    },
    heading5: {
        id: 'fabric.editor.heading5',
        defaultMessage: 'Heading 5',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading5Description: {
        id: 'fabric.editor.heading5Description',
        defaultMessage: 'Use this for grouping list items',
        description: 'Description text shown in the block type menu to help users understand when to use Heading 5 for grouping list items in the editor.'
    },
    heading6: {
        id: 'fabric.editor.heading6',
        defaultMessage: 'Heading 6',
        description: 'Used for the title of a section of your document, headings run from 1 (largest size) to 6 (smallest size)'
    },
    heading6Description: {
        id: 'fabric.editor.heading6Description',
        defaultMessage: 'Use this for low level headings',
        description: 'Description text shown in the block type menu to help users understand when to use Heading 6 for low level headings in the editor.'
    },
    blockquote: {
        id: 'fabric.editor.blockquote2',
        defaultMessage: 'Quote',
        description: 'Label shown as a menu item in the block type dropdown to insert a blockquote for quoting text in the editor.'
    },
    blockquoteDescription: {
        id: 'fabric.editor.blockquote.description',
        defaultMessage: 'Insert a quote or citation',
        description: 'Description text shown in the block type menu to help users understand the blockquote option for inserting a quote or citation in the editor.'
    },
    codeblock: {
        id: 'fabric.editor.codeblock',
        defaultMessage: 'Code snippet',
        description: 'Insert a snippet/segment of code (code block)'
    },
    codeblockDescription: {
        id: 'fabric.editor.codeblock.description',
        defaultMessage: 'Display code with syntax highlighting',
        description: 'Menu description shown in the quick insert menu. Explains that selecting this option inserts a code block with syntax highlighting support.'
    },
    infoPanel: {
        id: 'fabric.editor.infoPanel',
        defaultMessage: 'Info panel',
        description: 'Visually distinguishes your text by adding a background colour (blue, purple, yellow, green, red)'
    },
    infoPanelDescription: {
        id: 'fabric.editor.infoPanel.description',
        defaultMessage: 'Highlight information in a colored panel',
        description: 'Visually distinguishes your text by adding a background colour (blue, purple, yellow, green, red)'
    },
    notePanel: {
        id: 'fabric.editor.notePanel',
        defaultMessage: 'Note panel',
        description: 'Visually distinguishes your text by adding a note panel'
    },
    notePanelDescription: {
        id: 'fabric.editor.notePanel.description',
        defaultMessage: 'Add a note in a colored panel',
        description: 'Visually distinguishes your text by adding a note panel'
    },
    successPanel: {
        id: 'fabric.editor.successPanel',
        defaultMessage: 'Success panel',
        description: 'Visually distinguishes your text by adding a success panel'
    },
    successPanelDescription: {
        id: 'fabric.editor.successPanel.description',
        defaultMessage: 'Add tips in a colored panel',
        description: 'Visually distinguishes your text by adding a success panel'
    },
    warningPanel: {
        id: 'fabric.editor.warningPanel',
        defaultMessage: 'Warning panel',
        description: 'Visually distinguishes your text by adding a warning panel'
    },
    warningPanelDescription: {
        id: 'fabric.editor.warningPanel.description',
        defaultMessage: 'Add a note of caution in a colored panel',
        description: 'Visually distinguishes your text by adding a warning panel'
    },
    errorPanel: {
        id: 'fabric.editor.errorPanel',
        defaultMessage: 'Error panel',
        description: 'Visually distinguishes your text by adding a error panel'
    },
    errorPanelDescription: {
        id: 'fabric.editor.errorPanel.description',
        defaultMessage: 'Call out errors in a colored panel',
        description: 'Visually distinguishes your text by adding a error panel'
    },
    customPanel: {
        id: 'fabric.editor.customPanel',
        defaultMessage: 'Custom panel',
        description: 'Visually distinguishes your panel by adding a emoji icon and background color'
    },
    customPanelDescription: {
        id: 'fabric.editor.customPanel.description',
        defaultMessage: 'Add a note with an emoji and colored background',
        description: 'Visually distinguishes your panel by adding a emoji icon and background color '
    },
    syncedBlock: {
        id: 'fabric.editor.syncedBlock',
        defaultMessage: 'Create synced block',
        description: 'Inserts a synced block that auto-updates content across Atlassian apps'
    },
    syncBlock: {
        id: 'fabric.editor.syncBlock',
        defaultMessage: 'Sync block',
        description: 'Short label for inserting a synced block'
    },
    syncedBlockQuickInsertTitle: {
        id: 'editor-common.messages.block-type.syncedBlockQuickInsertTitle',
        defaultMessage: 'Synced block',
        description: 'Label for the synced block item in the quick insert menu. This names the object that the item inserts.'
    },
    syncedBlockDescription: {
        id: 'fabric.editor.syncedBlock.description',
        defaultMessage: 'Sync content across multiple locations',
        description: 'Description of the synced block that auto-updates content across Atlassian apps'
    },
    newLozenge: {
        id: 'fabric.editor.quickinsert.new.lozenge',
        defaultMessage: 'New',
        description: 'Text in lozenge that appears next to new quick insert items'
    },
    panel: {
        id: 'fabric.editor.panel',
        defaultMessage: 'Panel',
        description: 'Visually distinguishes your text by adding a panel'
    },
    other: {
        id: 'fabric.editor.other',
        defaultMessage: 'Others...',
        description: 'Label shown as a menu item in the block type dropdown to access additional text formatting options in the editor.'
    },
    numberedHeadings: {
        id: 'editor-common.messages.block-type.numberedHeadings',
        defaultMessage: 'Numbered headings',
        description: 'Label for a toggle in the text styles menu that turns automatic numbering (1, 1.1, 1.1.1) on or off for every heading on the page.'
    }
});

});

parcelRegister("glyUo", function(module, exports) {
$parcel$export(module.exports, "toolbarMessages", () => $49730dae02a79745$export$81b075fd34c2f0bb);

var $f0Pt4 = parcelRequire("f0Pt4");
const $49730dae02a79745$export$81b075fd34c2f0bb = (0, $f0Pt4.defineMessages)({
    underline: {
        id: 'fabric.editor.underline',
        defaultMessage: 'Underline',
        description: 'Whether the text selection has underlined text'
    },
    strike: {
        id: 'fabric.editor.strike',
        defaultMessage: 'Strikethrough',
        description: 'Whether the text selection has crossed out text'
    },
    code: {
        id: 'fabric.editor.code',
        defaultMessage: 'Code',
        description: 'Whether the text selection has monospaced/code font'
    },
    codeOn: {
        id: 'fabric.editor.code.on',
        defaultMessage: '{textFormattingOff}, Code On',
        description: 'Reports that code formatting has been turned on'
    },
    subscript: {
        id: 'fabric.editor.subscript',
        defaultMessage: 'Subscript',
        description: 'Whether the text selection is written below the line in a slightly smaller size'
    },
    subscriptOffSuperscriptOn: {
        id: 'fabric.editor.subscript.off.superscript.on',
        defaultMessage: 'Subscript Off, Superscript On',
        description: 'Reports text formatting in case when subscript off and superscript on'
    },
    superscript: {
        id: 'fabric.editor.superscript',
        defaultMessage: 'Superscript',
        description: 'Whether the text selection is written above the line in a slightly smaller size'
    },
    superscriptOffSubscriptOn: {
        id: 'fabric.editor.superscript.off.subscript.on',
        defaultMessage: 'Superscript Off, Subscript On',
        description: 'Describe text formatting in case when Superscript Off and Subscript on'
    },
    clearFormatting: {
        id: 'fabric.editor.clearFormatting',
        defaultMessage: 'Clear formatting',
        description: 'Remove all rich text formatting from the selected text'
    },
    moreFormatting: {
        id: 'fabric.editor.moreFormatting',
        defaultMessage: 'More formatting',
        description: 'Clicking this will show a menu with additional formatting options'
    },
    textFormatting: {
        id: 'fabric.editor.textFormatting',
        defaultMessage: 'Text formatting',
        description: 'Aria label for the wrapper of text format buttons'
    },
    textFormat: {
        id: 'fabric.editor.textFormat',
        defaultMessage: 'Format text',
        description: 'Aria label for the wrapper of text format buttons'
    },
    bold: {
        id: 'fabric.editor.bold',
        defaultMessage: 'Bold',
        description: "This refers to bold or \u201Cstrong\u201D formatting, indicates that its contents have strong importance, seriousness, or urgency."
    },
    italic: {
        id: 'fabric.editor.italic',
        defaultMessage: 'Italic',
        description: 'This refers to italics or emphasized formatting.'
    },
    on: {
        id: 'fabric.editor.on',
        defaultMessage: '{formattingType} On',
        description: 'Reports that text formatting has been turned on'
    },
    off: {
        id: 'fabric.editor.off',
        defaultMessage: '{formattingType} Off',
        description: 'Reports that text formatting has been turned off'
    },
    textStyles: {
        id: 'fabric.editor.textStyles',
        defaultMessage: '{blockTypeName} Text styles',
        description: 'Menu label that provides access to various heading styles or normal text. For example: normal text styles, heading 1 text styles.'
    },
    textStylesTooltip: {
        id: 'fabric.editor.textStylesTooltip',
        defaultMessage: 'Text styles',
        description: 'Tooltip text for menu that provides access to various heading styles or normal text.'
    },
    textFormattingOff: {
        id: 'fabric.editor.text.formatting.off',
        defaultMessage: 'Text formatting Off',
        description: 'Reports that text formatting has been turned off'
    },
    navigateToEditorToolbar: {
        id: 'fabric.editor.navigate.toolbar.editor',
        defaultMessage: 'Navigate to editor toolbar',
        description: 'Label for the keyboard shortcut action that moves focus to the main editor toolbar, allowing keyboard users to access toolbar buttons.'
    },
    navigateToFloatingToolbar: {
        id: 'fabric.editor.navigate.toolbar.floating',
        defaultMessage: 'Navigate to floating toolbar',
        description: 'Navigate to a floating toolbar for relevant nodes (e.g. tables or panels).'
    },
    askAI: {
        id: 'fabric.editor.navigate.toolbar.askAI',
        defaultMessage: 'Ask AI',
        description: 'Open the AI panel to ask a question or generate content.'
    },
    selectionToolbarOverflowMenuTooltip: {
        id: 'fabric.editor.selectionToolbarOverflowMenuTooltip',
        defaultMessage: 'More options',
        description: 'Tooltip for the overflow menu in the selection toolbar'
    }
});

});

parcelRegister("anv2i", function(module, exports) {
$parcel$export(module.exports, "messages", () => $a7b2a57bdecb7728$export$defe85febe8b728c);
// Common Translations will live here

var $f0Pt4 = parcelRequire("f0Pt4");
const $a7b2a57bdecb7728$export$defe85febe8b728c = (0, $f0Pt4.defineMessages)({
    unorderedList: {
        id: 'fabric.editor.unorderedList',
        defaultMessage: 'Bullet list',
        description: "A list with bullets. Also known as an \u201Cunordered\u201D list"
    },
    unorderedListDescription: {
        id: 'fabric.editor.unorderedList.description',
        defaultMessage: 'Create an unordered list',
        description: 'The text is shown as a description for the bullet list item in the quick insert menu when the user searches for formatting options.'
    },
    bulletedList: {
        id: 'fabric.editor.bulletedList',
        defaultMessage: 'Bulleted list',
        description: "A list with bullets. Also known as an \u201Cunordered\u201D list"
    },
    orderedList: {
        id: 'fabric.editor.orderedList',
        defaultMessage: 'Numbered list',
        description: 'The text is shown as the label for the numbered list option in the editor toolbar or menu, allowing the user to insert a sequentially numbered list into their document.'
    },
    orderedListDescription: {
        id: 'fabric.editor.orderedList.description',
        defaultMessage: 'Create an ordered list',
        description: 'The text is shown as a description for the numbered list item in the quick insert menu when the user searches for formatting options.'
    },
    lists: {
        id: 'fabric.editor.lists',
        defaultMessage: 'Lists',
        description: 'Menu shows ordered/bullet list and unordered/numbered lists'
    },
    listsFormat: {
        id: 'fabric.editor.listsFormat',
        defaultMessage: 'List formatting',
        description: 'Aria label for the wrapper of list buttons'
    }
});

});

parcelRegister("7tsTi", function(module, exports) {
$parcel$export(module.exports, "messages", () => $a393d8217363cfb8$export$defe85febe8b728c);

var $f0Pt4 = parcelRequire("f0Pt4");
const $a393d8217363cfb8$export$defe85febe8b728c = (0, $f0Pt4.defineMessages)({
    undo: {
        id: 'fabric.editor.undo',
        defaultMessage: 'Undo',
        description: 'Undo the previously performed action.'
    },
    redo: {
        id: 'fabric.editor.redo',
        defaultMessage: 'Redo',
        description: 'Redo the previously undone action.'
    }
});

});

parcelRegister("gvmlr", function(module, exports) {
$parcel$export(module.exports, "tasksAndDecisionsMessages", () => $7d09eb6a36117a24$export$273d864e9e6d0b1f);

var $f0Pt4 = parcelRequire("f0Pt4");
const $7d09eb6a36117a24$export$273d864e9e6d0b1f = (0, $f0Pt4.defineMessages)({
    taskPlaceholder: {
        id: 'fabric.editor.taskPlaceholder',
        defaultMessage: "Type your action, use '@' to assign to someone.",
        description: 'Placeholder description for an empty action/task in the editor'
    },
    decisionPlaceholder: {
        id: 'fabric.editor.decisionPlaceholder',
        defaultMessage: "Add a decision\u2026",
        description: 'Placeholder description for an empty decision in the editor'
    },
    editAccessTitle: {
        id: 'fabric.editor.editAccessTitle',
        defaultMessage: 'You need edit access',
        description: 'Title in the popup when we click on action item checkbox without edit permission'
    },
    requestToEditDescription: {
        id: 'fabric.editor.requestToEditDescription',
        defaultMessage: 'When you request access, the page owner will receive a notification.',
        description: 'Description in the popup when we click on action item checkbox without edit permission'
    },
    requestToEdit: {
        id: 'fabric.editor.requestToEdit',
        defaultMessage: 'Request to edit',
        description: 'Button in the popup when we click on action item checkbox without edit permission'
    },
    dismiss: {
        id: 'fabric.editor.requestToEditDismiss',
        defaultMessage: 'Dismiss',
        description: 'Button in the popup when we click on dismiss without edit permission'
    },
    markTaskAsCompleted: {
        id: 'fabric.editor.taskDecision.markTaskAsCompleted',
        defaultMessage: 'Mark task as completed',
        description: 'Button to mark a task as complete in the editor'
    },
    markTaskAsNotCompleted: {
        id: 'fabric.editor.taskDecision.markTaskAsNotCompleted',
        defaultMessage: 'Mark task as not completed',
        description: 'Button to mark a task as not complete in the editor'
    },
    taskList: {
        id: 'fabric.editor.taskList',
        defaultMessage: 'Task list',
        description: 'Accessible label for the task list container element in the editor, used by screen readers to identify a list of action items.'
    },
    decisionAriaLabel: {
        id: 'fabric.editor.decisionAriaLabel',
        defaultMessage: 'Decision',
        description: 'Accessible ARIA label for a decision element in the editor, announced by screen readers to identify the element as a decision.'
    },
    undefinedDecisionAriaLabel: {
        id: 'fabric.editor.undefinedDecisionAriaLabel',
        defaultMessage: 'Undefined decision',
        description: 'Descriptive text for an undefined decision element'
    }
});

});

parcelRegister("4fPJw", function(module, exports) {
$parcel$export(module.exports, "placeholderTextMessages", () => $726c32fd549acc85$export$ee8ab8a034b5a8bd);

var $f0Pt4 = parcelRequire("f0Pt4");
const $726c32fd549acc85$export$ee8ab8a034b5a8bd = (0, $f0Pt4.defineMessages)({
    placeholderTextPlaceholder: {
        id: 'fabric.editor.placeholderTextPlaceholder',
        defaultMessage: 'Add placeholder text',
        description: 'Placeholder text shown in the editor when a placeholder text node is inserted, prompting the user to add custom placeholder content.'
    },
    shortEmptyNodePlaceholderText: {
        id: 'fabric.editor.shortEmptyNodePlaceholderText',
        defaultMessage: '/ to insert',
        description: 'Short placeholder text shown inside empty editor nodes, instructing users to type / to open the quick-insert menu.'
    },
    shortEmptyNodePlaceholderADFSlashShortcut: {
        id: 'fabric.editor.shortEmptyNodePlaceholderSlash',
        defaultMessage: '/',
        description: 'Slash character in short empty node placeholder'
    },
    shortEmptyNodePlaceholderADFSuffix: {
        id: 'fabric.editor.shortEmptyNodePlaceholderSuffix',
        defaultMessage: ' to insert',
        description: 'Text after slash in short empty node placeholder'
    },
    longEmptyNodePlaceholderText: {
        id: 'fabric.editor.longEmptyNodePlaceholderText',
        defaultMessage: 'Type / to insert elements',
        description: 'Longer placeholder text shown inside empty editor nodes, instructing users to type / to open the quick-insert menu and add elements.'
    },
    longEmptyNodePlaceholderADFPrefix: {
        id: 'fabric.editor.longEmptyNodePlaceholderPrefix',
        defaultMessage: 'Type ',
        description: 'Text before slash in long empty node placeholder'
    },
    longEmptyNodePlaceholderADFSlashShortcut: {
        id: 'fabric.editor.longEmptyNodePlaceholderSlash',
        defaultMessage: '/',
        description: 'Slash character in long empty node placeholder'
    },
    longEmptyNodePlaceholderADFSuffix: {
        id: 'fabric.editor.longEmptyNodePlaceholderSuffix',
        defaultMessage: ' to insert elements',
        description: 'Text after slash in long empty node placeholder'
    },
    sourceSyncBlockPlaceholderText: {
        id: 'fabric.editor.sourceSyncBlockPlaceholderText',
        defaultMessage: 'Add content you want to reuse. Copy and paste this block to sync in other locations.',
        description: 'Placeholder text shown inside an empty source sync block, prompting users to add reusable content that can be synced across multiple locations.'
    },
    multiBodiedExtensionEmptyFramePlaceholderText: {
        id: 'fabric.editor.multiBodiedExtensionEmptyFramePlaceholderText',
        defaultMessage: 'Type / to insert elements',
        description: 'Placeholder text shown inside an empty multi-bodied extension frame, prompting users to type / to open the quick-insert menu and add elements.'
    }
});

});

parcelRegister("6ny6f", function(module, exports) {
$parcel$export(module.exports, "mentionMessages", () => $cfef086d5c47ce3e$export$33aafd5ccbbbd00a);

var $f0Pt4 = parcelRequire("f0Pt4");
const $cfef086d5c47ce3e$export$33aafd5ccbbbd00a = (0, $f0Pt4.defineMessages)({
    inviteItemTitle: {
        id: 'fabric.editor.inviteItem.title',
        defaultMessage: '{userRole, select, admin {Invite} trusted {Invite} other {Add}} teammate to {productName}',
        description: 'Title of the invite teammate item in typeahead plugin'
    },
    mentionsAddLabel: {
        id: 'fabric.editor.mentionsAddLabel',
        defaultMessage: 'add-icon',
        description: 'icon label to describe adding a new mention'
    },
    mentionsIconLabel: {
        id: 'fabric.editor.mentionsIconLabel',
        defaultMessage: 'Mention',
        description: 'Accessible label for the mention icon displayed in the editor toolbar, indicating that clicking it inserts a mention.'
    },
    mentionsNodeLabel: {
        id: 'fabric.editor.mentionNode.label',
        defaultMessage: 'Tagged user',
        description: 'Label to indicate mention node to Screen reader users, that preceeds with user name ex: "Tagged user @XXX'
    },
    unknownLabel: {
        id: 'fabric.editor.unknown.label',
        defaultMessage: 'Unknown',
        description: 'Accessible label for a mention node when the referenced user cannot be identified or resolved.'
    },
    inviteTeammateInvalidEmail: {
        id: 'fabric.editor.inviteItem.invalidEmail',
        defaultMessage: 'Enter a valid email address',
        description: 'By line text for invite teammate option shown in mentions when the email is invalid. This is a placeholder for the actual error message that will be shown to the user.'
    },
    sendInvite: {
        id: 'fabric.editor.inviteItem.sendInvite',
        defaultMessage: 'Send request to invite teammate',
        description: 'By line text for send request to invite teammate option shown in mentions.'
    },
    typeAheadSectionPeople: {
        id: 'fabric.editor.typeAhead.mentionSection.people',
        defaultMessage: 'People',
        description: 'Section header for people (non-agent) results in the mention type-ahead menu'
    },
    typeAheadSectionAgents: {
        id: 'fabric.editor.typeAhead.mentionSection.agents',
        defaultMessage: 'Agents',
        description: 'Section header for agent results in the mention type-ahead menu'
    },
    typeAheadSectionAgentsLabsLozengeLabel: {
        id: 'editor-common.messages.mentions.typeAheadSectionAgentsLabsLozengeLabel',
        defaultMessage: 'Labs',
        description: 'Lozenge label shown next to the Agents section header in the mention type-ahead menu to indicate that agent mentions are experimental. This label is intentionally captialised.'
    },
    typeAheadSectionAgentsLoadError: {
        id: 'editor-common.messages.mentions.typeAheadSectionAgentsLoadError',
        defaultMessage: 'Unable to load agents',
        description: 'Error text shown in the Agents section of the mention type-ahead menu when agent results fail to load.'
    },
    typeAheadSectionAgentsRetry: {
        id: 'editor-common.messages.mentions.typeAheadSectionAgentsRetry',
        defaultMessage: 'Retry',
        description: 'Retry action text shown next to the agent loading error in the mention type-ahead menu.'
    }
});

});

parcelRegister("gG6Zw", function(module, exports) {
$parcel$export(module.exports, "highlightMessages", () => $4087ec50533d295d$export$456100c8374b6011);

var $f0Pt4 = parcelRequire("f0Pt4");
const $4087ec50533d295d$export$456100c8374b6011 = (0, $f0Pt4.defineMessages)({
    clearColors: {
        id: 'fabric.editor.highlight.clearColors',
        defaultMessage: 'Clear all colors',
        description: 'Button content for clearing the applied text and/ or highlight colors.'
    },
    highlight: {
        id: 'fabric.editor.highlight',
        defaultMessage: 'Highlight color',
        description: 'Label for the highlight color menu option in the primary editor toolbar. Opens up the color palette for the highlight colors.'
    },
    highlightFloatingToolbar: {
        id: 'fabric.editor.highlightFloatingToolbar',
        defaultMessage: 'Highlight',
        description: 'Button content for the highlight color menu option in the editor floating toolbar. Opens up the color palette for the highlight colors.'
    },
    removeColor: {
        id: 'fabric.editor.highlight.removeColor',
        defaultMessage: 'Remove color',
        description: 'Button content for the combined text highlight and color menu, removes either the applied text color or highlight color.'
    },
    removeHighlight: {
        id: 'fabric.editor.highlight.removeHighlight',
        defaultMessage: 'Remove highlight',
        description: 'Button content for removing the applied highlight color.'
    }
});

});

parcelRegister("kictP", function(module, exports) {
$parcel$export(module.exports, "messages", () => $a80c68b1225ad2ff$export$defe85febe8b728c);

var $f0Pt4 = parcelRequire("f0Pt4");
const $a80c68b1225ad2ff$export$defe85febe8b728c = (0, $f0Pt4.defineMessages)({
    dragToMove: {
        id: 'fabric.editor.blockControlDragHandleMove',
        defaultMessage: 'Drag to move',
        description: 'Tooltip shown on the drag handle of a content block in the editor, indicating the user can drag this handle to reposition the block.'
    },
    dragToMoveClickToOpen: {
        id: 'fabric.editor.blockControlDragHandleMoveOrOpen',
        defaultMessage: 'Drag to move {br} Click to open menu',
        description: 'Use drag handle to move content or click to open the menu'
    },
    dragToRearrange: {
        id: 'fabric.editor.blockControlDragHandleRearrange',
        defaultMessage: 'Drag to rearrange',
        description: 'Tooltip shown on the drag handle of a layout column in the editor, indicating the user can drag this handle to reorder columns.'
    },
    insert: {
        id: 'fabric.editor.blockControlInsert',
        defaultMessage: 'Insert',
        description: 'Label on button to insert content at the current cursor position'
    },
    collapseSection: {
        id: 'editor-common.messages.block-controls.collapseSection',
        defaultMessage: 'Collapse section',
        description: 'Accessible label for the button that collapses a heading section.'
    },
    expandSection: {
        id: 'editor-common.messages.block-controls.expandSection',
        defaultMessage: 'Expand section',
        description: 'Accessible label for the button that expands a heading section.'
    },
    moveUp: {
        id: 'fabric.editor.blockControlMoveUp',
        defaultMessage: 'Move up',
        description: 'Label for a button in the block controls menu that moves the selected content block up in the editor.'
    },
    moveDown: {
        id: 'fabric.editor.blockControlMoveDown',
        defaultMessage: 'Move down',
        description: 'Label for a button in the block controls menu that moves the selected content block down in the editor.'
    },
    movedup: {
        id: 'fabric.editor.blockControlMovedUp',
        defaultMessage: 'Content has been moved up',
        description: 'Assistive announcement read by screen readers to confirm the selected content block has been successfully moved up in the editor.'
    },
    movedDown: {
        id: 'fabric.editor.blockControlMovedDown',
        defaultMessage: 'Content has been moved down',
        description: 'Assistive announcement read by screen readers to confirm the selected content block has been successfully moved down in the editor.'
    },
    moveLeft: {
        id: 'fabric.editor.blockControlMoveLeft',
        defaultMessage: 'Move left',
        description: 'Label for a button in the block controls menu that moves the selected content block to the left.'
    },
    moveRight: {
        id: 'fabric.editor.blockControlMoveRight',
        defaultMessage: 'Move right',
        description: 'Label for a button in the block controls menu that moves the selected content block to the right.'
    },
    delete: {
        id: 'fabric.editor.blockControlDelete',
        defaultMessage: 'Delete',
        description: 'Label for a button in the block controls menu that deletes the currently selected content block from the editor.'
    }
});

});

parcelRegister("fXN8M", function(module, exports) {
$parcel$export(module.exports, "containsClassName", () => $80f72631c5b08df0$export$c8913a477cc44663);
/**
 * IE11 doesn't support classList to SVGElements
 **/ const $80f72631c5b08df0$export$c8913a477cc44663 = (node, className)=>{
    if (!node) return false;
    if (node.classList && node.classList.contains) return node.classList.contains(className);
    if (!node.className) return false;
    const classNames = typeof node.className.baseVal === 'string' ? node.className.baseVal : node.className;
    return classNames.split(' ').indexOf(className) !== -1;
};

});

parcelRegister("i1MIo", function(module, exports) {
$parcel$export(module.exports, "accessibilityUtilsPlugin", () => $84eb8abb113477cf$export$8bab9b7a6db7fbeb);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $7lseo = parcelRequire("7lseo");

var $f7Kk4 = parcelRequire("f7Kk4");

var $5beht = parcelRequire("5beht");

var $cw0wu = parcelRequire("cw0wu");

var $9Abbn = parcelRequire("9Abbn");
const $84eb8abb113477cf$var$accessibilityUtilsPluginKey = new (0, $cw0wu.PluginKey)('accessibilityUtilsPlugin');
const $84eb8abb113477cf$export$8bab9b7a6db7fbeb = ({ api: api })=>{
    let editorView;
    const setEditorView = (newEditorView)=>{
        editorView = newEditorView;
    };
    return {
        name: 'accessibilityUtils',
        actions: {
            ariaNotify: (message, ariaLiveElementAttributes)=>{
                if (!editorView) // at time of writing, this should never happen
                return;
                const tr = editorView.state.tr;
                tr.setMeta($84eb8abb113477cf$var$accessibilityUtilsPluginKey, {
                    message: message,
                    ariaLiveElementAttributes: ariaLiveElementAttributes,
                    key: Date.now().toString()
                });
                editorView.dispatch(tr);
                return;
            }
        },
        contentComponent: ()=>{
            if (!editorView || (0, $7lseo.isSSR)()) return null;
            return /*#__PURE__*/ (0, $dc70d.jsx)($84eb8abb113477cf$var$ContentComponent, {
                api: api
            });
        },
        getSharedState (editorState) {
            if (!editorState) return null;
            return $84eb8abb113477cf$var$accessibilityUtilsPluginKey.getState(editorState);
        },
        pmPlugins () {
            return [
                {
                    name: 'get-editor-view',
                    plugin: ()=>{
                        return new (0, $f7Kk4.SafePlugin)({
                            key: $84eb8abb113477cf$var$accessibilityUtilsPluginKey,
                            state: {
                                init: ()=>({
                                        message: '',
                                        ariaLiveElementAttributes: {}
                                    }),
                                apply: (tr, prevState)=>{
                                    const meta = tr.getMeta($84eb8abb113477cf$var$accessibilityUtilsPluginKey);
                                    if (meta) return {
                                        ...prevState,
                                        ...meta
                                    };
                                    return prevState;
                                }
                            },
                            view (editorView) {
                                setEditorView(editorView);
                                return {};
                            }
                        });
                    }
                }
            ];
        }
    };
};
function $84eb8abb113477cf$var$ContentComponent({ api: api }) {
    const { ariaLiveElementAttributes: ariaLiveElementAttributes, key: key, message: message } = (0, $5beht.useSharedPluginStateWithSelector)(api, [
        'accessibilityUtils'
    ], (states)=>{
        var _states$accessibility, _states$accessibility2, _states$accessibility3;
        return {
            ariaLiveElementAttributes: (_states$accessibility = states.accessibilityUtilsState) === null || _states$accessibility === void 0 ? void 0 : _states$accessibility.ariaLiveElementAttributes,
            key: (_states$accessibility2 = states.accessibilityUtilsState) === null || _states$accessibility2 === void 0 ? void 0 : _states$accessibility2.key,
            message: (_states$accessibility3 = states.accessibilityUtilsState) === null || _states$accessibility3 === void 0 ? void 0 : _states$accessibility3.message
        };
    });
    const role = (ariaLiveElementAttributes === null || ariaLiveElementAttributes === void 0 ? void 0 : ariaLiveElementAttributes.priority) === 'important' ? 'alert' : 'status';
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $9Abbn.default), {
        testId: 'accessibility-message-wrapper',
        role: role,
        ...role === 'alert' && {
            key: key
        },
        children: message
    });
}

});

parcelRegister("fY1MC", function(module, exports) {
$parcel$export(module.exports, "alignmentPlugin", () => $78ed72e0b7878462$export$48e8beb2d4cfb048);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $2HNFa = parcelRequire("2HNFa");

var $797yE = parcelRequire("797yE");

var $kylbd = parcelRequire("kylbd");

var $l6Dnt = parcelRequire("l6Dnt");

var $aZ0PI = parcelRequire("aZ0PI");

var $7lz77 = parcelRequire("7lz77");

var $29Kgy = parcelRequire("29Kgy");
const $78ed72e0b7878462$var$defaultConfig = {
    align: 'start'
};
const $78ed72e0b7878462$export$48e8beb2d4cfb048 = ({ api: api })=>{
    const isToolbarAIFCEnabled = Boolean(api === null || api === void 0 ? void 0 : api.toolbar);
    const primaryToolbarComponent = ({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, disabled: disabled, isToolbarReducedSpacing: isToolbarReducedSpacing })=>{
        if (!editorView) return null;
        return /*#__PURE__*/ (0, $dc70d.jsx)((0, $7lz77.PrimaryToolbarComponent), {
            api: api,
            editorView: editorView,
            disabled: disabled,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            isToolbarReducedSpacing: isToolbarReducedSpacing
        });
    };
    if (isToolbarAIFCEnabled) {
        var _api$toolbar;
        api === null || api === void 0 || (_api$toolbar = api.toolbar) === null || _api$toolbar === void 0 || _api$toolbar.actions.registerComponents((0, $29Kgy.getToolbarComponents)(api));
    } else {
        var _api$primaryToolbar;
        api === null || api === void 0 || (_api$primaryToolbar = api.primaryToolbar) === null || _api$primaryToolbar === void 0 || _api$primaryToolbar.actions.registerComponent({
            name: 'alignment',
            component: primaryToolbarComponent
        });
    }
    return {
        name: 'alignment',
        marks () {
            return [
                {
                    name: 'alignment',
                    mark: (0, $2HNFa.alignment)
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const pluginState = (0, $l6Dnt.pluginKey).getState(editorState);
            return pluginState ? {
                align: pluginState.align,
                isEnabled: pluginState.isEnabled
            } : undefined;
        },
        pmPlugins () {
            return [
                {
                    name: 'alignmentPlugin',
                    plugin: ({ dispatch: dispatch })=>(0, $l6Dnt.createPlugin)(dispatch, $78ed72e0b7878462$var$defaultConfig)
                },
                {
                    name: 'annotationKeymap',
                    plugin: ()=>(0, $kylbd.keymapPlugin)(api)
                }
            ];
        },
        pluginsOptions: {
            selectionToolbar: isToolbarAIFCEnabled ? undefined : ()=>{
                var _api$userPreferences;
                const toolbarDocking = api === null || api === void 0 || (_api$userPreferences = api.userPreferences) === null || _api$userPreferences === void 0 || (_api$userPreferences = _api$userPreferences.sharedState.currentState()) === null || _api$userPreferences === void 0 || (_api$userPreferences = _api$userPreferences.preferences) === null || _api$userPreferences === void 0 ? void 0 : _api$userPreferences.toolbarDockingPosition;
                if (toolbarDocking === 'none' && (0, $797yE.editorExperiment)('platform_editor_controls', 'variant1', {
                    exposure: true
                })) {
                    const toolbarCustom = {
                        type: 'custom',
                        render: (view)=>{
                            if (!view) return;
                            return /*#__PURE__*/ (0, $dc70d.jsx)((0, $aZ0PI.FloatingToolbarComponent), {
                                api: api,
                                editorView: view
                            });
                        },
                        fallback: []
                    };
                    return {
                        isToolbarAbove: true,
                        items: [
                            toolbarCustom
                        ],
                        rank: 4,
                        pluginName: 'alignment'
                    };
                } else return undefined;
            }
        },
        primaryToolbarComponent: !(api !== null && api !== void 0 && api.primaryToolbar) && !isToolbarAIFCEnabled ? primaryToolbarComponent : undefined
    };
};

});
parcelRegister("kylbd", function(module, exports) {
$parcel$export(module.exports, "keymapPlugin", () => $f2be1d1cd90c95c0$export$e832373cff8dec22);

var $g6Qq4 = parcelRequire("g6Qq4");

var $bdXbU = parcelRequire("bdXbU");

var $cv8id = parcelRequire("cv8id");

var $3RNLX = parcelRequire("3RNLX");
function $f2be1d1cd90c95c0$export$e832373cff8dec22(api) {
    const list = {};
    // Ignored via go/ees005
    (0, $cv8id.bindKeymapWithCommand)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $cv8id.alignLeft).common, (0, $3RNLX.changeAlignment)('start', api, (0, $g6Qq4.INPUT_METHOD).SHORTCUT), list);
    // Ignored via go/ees005
    (0, $cv8id.bindKeymapWithCommand)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $cv8id.alignCenter).common, (0, $3RNLX.changeAlignment)('center', api, (0, $g6Qq4.INPUT_METHOD).SHORTCUT), list);
    // Ignored via go/ees005
    (0, $cv8id.bindKeymapWithCommand)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $cv8id.alignRight).common, (0, $3RNLX.changeAlignment)('end', api, (0, $g6Qq4.INPUT_METHOD).SHORTCUT), list);
    return (0, $bdXbU.keymap)(list);
}

});
parcelRegister("bdXbU", function(module, exports) {
$parcel$export(module.exports, "keymap", () => $87e374c1cb810105$export$5043418e2ef368d5);

var $kitud = parcelRequire("kitud");

var $ejrfk = parcelRequire("ejrfk");

var $f7Kk4 = parcelRequire("f7Kk4");
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $87e374c1cb810105$var$NON_LATIN_KEY_REGEX = /[^\u0000-\u007f]/;
function $87e374c1cb810105$export$5043418e2ef368d5(bindings) {
    return new (0, $f7Kk4.SafePlugin)({
        props: {
            handleKeyDown (view, event) {
                const name = (0, $kitud.keyName)(event);
                let keyboardEvent = event;
                // We will try to bypass the keycode only if any of mod keys are pressed,
                // to allow users to use non-latin and Dead characters.
                const isModKeyPressed = event.ctrlKey || event.metaKey;
                // Check the unicode of the character to assert that it's not an ASCII character.
                // These are characters outside latin's range.
                const isNonLatinKey = name.length === 1 && $87e374c1cb810105$var$NON_LATIN_KEY_REGEX.test(name);
                // The `Dead` key is a key that combines with a following key to produce a combined character.
                // It will have `even.key === 'Dead'` in some browsers but the `keyCode` will be the same as in a qwerty-keyboard.
                // See https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key and https://en.wikipedia.org/wiki/Dead_key
                const isDeadKey = name === 'Dead';
                if (isModKeyPressed && (isNonLatinKey || isDeadKey)) keyboardEvent = new KeyboardEvent(event.type, {
                    // Ignored via go/ees007
                    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
                    // FIXME: The event.keyCode is deprecated (see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/keyCode),
                    // and could be removed in any time, but the w3c-keyname library doesn't provide a way to get
                    // a key by event.code.
                    key: (0, $kitud.base)[event.keyCode],
                    code: event.code,
                    ctrlKey: event.ctrlKey,
                    altKey: event.altKey,
                    metaKey: event.metaKey,
                    shiftKey: event.shiftKey
                });
                return (0, $ejrfk.keydownHandler)(bindings)(view, keyboardEvent);
            }
        }
    });
}

});

parcelRegister("cv8id", function(module, exports) {
$parcel$export(module.exports, "addAltText", () => $9d680eb148465d1f$export$82527b23b485fa7f);
$parcel$export(module.exports, "makeKeyMapWithCommon", () => $9d680eb148465d1f$export$7e6b588cc98b34f1);
$parcel$export(module.exports, "navToEditorToolbar", () => $9d680eb148465d1f$export$9288bbefb6b7498b);
$parcel$export(module.exports, "navToFloatingToolbar", () => $9d680eb148465d1f$export$7be006a99a30f86b);
$parcel$export(module.exports, "askAIQuickInsert", () => $9d680eb148465d1f$export$ae37214e128d9cc3);
$parcel$export(module.exports, "toggleBold", () => $9d680eb148465d1f$export$183fe6d20e9e58ba);
$parcel$export(module.exports, "toggleItalic", () => $9d680eb148465d1f$export$b03177f345903916);
$parcel$export(module.exports, "toggleUnderline", () => $9d680eb148465d1f$export$6bcc93697958b66d);
$parcel$export(module.exports, "toggleStrikethrough", () => $9d680eb148465d1f$export$6d564ba4eaf138d9);
$parcel$export(module.exports, "toggleSubscript", () => $9d680eb148465d1f$export$d26ab98fee0c804);
$parcel$export(module.exports, "toggleSuperscript", () => $9d680eb148465d1f$export$4af6b58e12324fd);
$parcel$export(module.exports, "toggleCode", () => $9d680eb148465d1f$export$70686c6e7e15ed46);
$parcel$export(module.exports, "pastePlainText", () => $9d680eb148465d1f$export$ab06dc742bb20e03);
$parcel$export(module.exports, "clearFormatting", () => $9d680eb148465d1f$export$195de5d8e201efd7);
$parcel$export(module.exports, "setNormalText", () => $9d680eb148465d1f$export$63c4f0859cc75dc6);
$parcel$export(module.exports, "toggleHeading1", () => $9d680eb148465d1f$export$953ab0e6a5d310a9);
$parcel$export(module.exports, "toggleHeading2", () => $9d680eb148465d1f$export$192a351cfd6ca247);
$parcel$export(module.exports, "toggleHeading3", () => $9d680eb148465d1f$export$fe382f3f4c871c62);
$parcel$export(module.exports, "toggleHeading4", () => $9d680eb148465d1f$export$4073e08db19e0e31);
$parcel$export(module.exports, "toggleHeading5", () => $9d680eb148465d1f$export$b84e85b2035ddb39);
$parcel$export(module.exports, "toggleHeading6", () => $9d680eb148465d1f$export$86b1ac99fd15509b);
$parcel$export(module.exports, "toggleSmallText", () => $9d680eb148465d1f$export$16f43eb2b2380de5);
$parcel$export(module.exports, "toggleOrderedList", () => $9d680eb148465d1f$export$dca848a1b50b6a31);
$parcel$export(module.exports, "toggleBulletList", () => $9d680eb148465d1f$export$c0e115f47553645e);
$parcel$export(module.exports, "toggleBlockQuote", () => $9d680eb148465d1f$export$34ed0cbd4f7ff88);
$parcel$export(module.exports, "insertNewLine", () => $9d680eb148465d1f$export$c2d9390f63354627);
$parcel$export(module.exports, "insertRule", () => $9d680eb148465d1f$export$5f13bbad564673d4);
$parcel$export(module.exports, "undo", () => $9d680eb148465d1f$export$21f930c44940fd98);
$parcel$export(module.exports, "moveUp", () => $9d680eb148465d1f$export$44935f8a884b57b9);
$parcel$export(module.exports, "moveDown", () => $9d680eb148465d1f$export$8eba228b343b3599);
$parcel$export(module.exports, "moveLeft", () => $9d680eb148465d1f$export$108f27160c89e515);
$parcel$export(module.exports, "moveRight", () => $9d680eb148465d1f$export$e2c874fbfec7201);
$parcel$export(module.exports, "indentList", () => $9d680eb148465d1f$export$8066a906978eedb2);
$parcel$export(module.exports, "outdentList", () => $9d680eb148465d1f$export$959569198ddbbe17);
$parcel$export(module.exports, "redoAlt", () => $9d680eb148465d1f$export$c0e41ad67d77f6bb);
$parcel$export(module.exports, "redo", () => $9d680eb148465d1f$export$1688e416fee0a49e);
$parcel$export(module.exports, "openHelp", () => $9d680eb148465d1f$export$1e2fd7795238a2d3);
$parcel$export(module.exports, "addLink", () => $9d680eb148465d1f$export$56b88caa6d8a3bff);
$parcel$export(module.exports, "addInlineComment", () => $9d680eb148465d1f$export$fd78ad47ea0892f4);
$parcel$export(module.exports, "copyLinkToBlock", () => $9d680eb148465d1f$export$278533b7b7607665);
$parcel$export(module.exports, "submit", () => $9d680eb148465d1f$export$853c27de4ce0f746);
$parcel$export(module.exports, "enter", () => $9d680eb148465d1f$export$e668df1bcd81e4d2);
$parcel$export(module.exports, "tab", () => $9d680eb148465d1f$export$62d58b1c91e8e902);
$parcel$export(module.exports, "indent", () => $9d680eb148465d1f$export$79ebfa808dffa5c6);
$parcel$export(module.exports, "outdent", () => $9d680eb148465d1f$export$25755c0352544598);
$parcel$export(module.exports, "backspace", () => $9d680eb148465d1f$export$1ea584ca7009bcc1);
$parcel$export(module.exports, "deleteKey", () => $9d680eb148465d1f$export$9603e93cdf38d7);
$parcel$export(module.exports, "forwardDelete", () => $9d680eb148465d1f$export$9e41eded5cb7e706);
$parcel$export(module.exports, "escape", () => $9d680eb148465d1f$export$4e7f196112fea3c5);
$parcel$export(module.exports, "nextCell", () => $9d680eb148465d1f$export$172699367bb25225);
$parcel$export(module.exports, "previousCell", () => $9d680eb148465d1f$export$69838570e03d7193);
$parcel$export(module.exports, "shiftArrowUp", () => $9d680eb148465d1f$export$776c0cd47234205a);
$parcel$export(module.exports, "shiftTab", () => $9d680eb148465d1f$export$9ad63694f5781e16);
$parcel$export(module.exports, "toggleTable", () => $9d680eb148465d1f$export$33b9473b3f67763f);
$parcel$export(module.exports, "focusTableResizer", () => $9d680eb148465d1f$export$a57fbe0d9c764ae0);
$parcel$export(module.exports, "addRowBefore", () => $9d680eb148465d1f$export$2e3087448cf87857);
$parcel$export(module.exports, "addRowAfter", () => $9d680eb148465d1f$export$fbcf51cabbe4a007);
$parcel$export(module.exports, "addColumnAfter", () => $9d680eb148465d1f$export$bf95f7b7d259c19f);
$parcel$export(module.exports, "addColumnBefore", () => $9d680eb148465d1f$export$717d5ccb817cdecc);
$parcel$export(module.exports, "addRowBeforeVO", () => $9d680eb148465d1f$export$5851c701392d3bfd);
$parcel$export(module.exports, "addRowAfterVO", () => $9d680eb148465d1f$export$73fa63faf0fd6077);
$parcel$export(module.exports, "addColumnAfterVO", () => $9d680eb148465d1f$export$875b853996fced8d);
$parcel$export(module.exports, "addColumnBeforeVO", () => $9d680eb148465d1f$export$414418ca306c22bd);
$parcel$export(module.exports, "moveColumnLeftOld", () => $9d680eb148465d1f$export$a055d05df46abae5);
$parcel$export(module.exports, "moveColumnLeft", () => $9d680eb148465d1f$export$f092689a35ce978d);
$parcel$export(module.exports, "moveColumnRightOld", () => $9d680eb148465d1f$export$7ff94d9a4edfc7f);
$parcel$export(module.exports, "moveColumnRight", () => $9d680eb148465d1f$export$863ee96d9e15383b);
$parcel$export(module.exports, "moveRowDownOld", () => $9d680eb148465d1f$export$180b7d3240961d01);
$parcel$export(module.exports, "moveRowDown", () => $9d680eb148465d1f$export$13c2dd2d968ada2a);
$parcel$export(module.exports, "moveRowUpOld", () => $9d680eb148465d1f$export$88de3148cc9ddd81);
$parcel$export(module.exports, "moveRowUp", () => $9d680eb148465d1f$export$e6749a6fc243b921);
$parcel$export(module.exports, "deleteColumn", () => $9d680eb148465d1f$export$f4f2d7d33085c714);
$parcel$export(module.exports, "deleteRow", () => $9d680eb148465d1f$export$2ef39e5ffdaff9ed);
$parcel$export(module.exports, "startColumnResizing", () => $9d680eb148465d1f$export$8f58457f1327dd26);
$parcel$export(module.exports, "find", () => $9d680eb148465d1f$export$71aa6c912b956294);
$parcel$export(module.exports, "alignLeft", () => $9d680eb148465d1f$export$ca42dd9a1a0eb501);
$parcel$export(module.exports, "alignCenter", () => $9d680eb148465d1f$export$f4a51ff076cc9a09);
$parcel$export(module.exports, "alignRight", () => $9d680eb148465d1f$export$faf8793e4a37a5a2);
$parcel$export(module.exports, "toggleTaskItemCheckbox", () => $9d680eb148465d1f$export$6f041e7a1d88fa51);
$parcel$export(module.exports, "toggleTaskList", () => $9d680eb148465d1f$export$2e48e3ea1c210731);
$parcel$export(module.exports, "selectRow", () => $9d680eb148465d1f$export$e247ed8cec4832f4);
$parcel$export(module.exports, "selectColumn", () => $9d680eb148465d1f$export$c2e8772deb1607ea);
$parcel$export(module.exports, "selectTable", () => $9d680eb148465d1f$export$625c5b9bf13f01a8);
$parcel$export(module.exports, "increaseMediaSize", () => $9d680eb148465d1f$export$fdeca4160ac263c5);
$parcel$export(module.exports, "decreaseMediaSize", () => $9d680eb148465d1f$export$5ec5f857fec297eb);
$parcel$export(module.exports, "activateVideoControls", () => $9d680eb148465d1f$export$36141559a83247ee);
$parcel$export(module.exports, "toggleHighlightPalette", () => $9d680eb148465d1f$export$ec123199f2fe4770);
$parcel$export(module.exports, "applyYellowHighlight", () => $9d680eb148465d1f$export$62f87f0ca411e518);
$parcel$export(module.exports, "focusToContextMenuTrigger", () => $9d680eb148465d1f$export$6b05735f625d1c82);
$parcel$export(module.exports, "dragToMoveUp", () => $9d680eb148465d1f$export$a1bdda43619f945f);
$parcel$export(module.exports, "dragToMoveDown", () => $9d680eb148465d1f$export$9bf312985dc8137e);
$parcel$export(module.exports, "dragToMoveLeft", () => $9d680eb148465d1f$export$c4f661b85fc92fd1);
$parcel$export(module.exports, "dragToMoveRight", () => $9d680eb148465d1f$export$61c867f4a21787f6);
$parcel$export(module.exports, "showElementDragHandle", () => $9d680eb148465d1f$export$ba34d2a4e6aa10e4);
$parcel$export(module.exports, "toggleCodeBlock", () => $9d680eb148465d1f$export$e9c6aab026be9523);
$parcel$export(module.exports, "insertEmoji", () => $9d680eb148465d1f$export$8d5c072327044b6f);
$parcel$export(module.exports, "insertMention", () => $9d680eb148465d1f$export$8c4314a90d4c5fc1);
$parcel$export(module.exports, "insertTaskList", () => $9d680eb148465d1f$export$cf3c284f81e5d477);
$parcel$export(module.exports, "insertElements", () => $9d680eb148465d1f$export$edd9d3cec5b0a9b6);
$parcel$export(module.exports, "formatShortcut", () => $9d680eb148465d1f$export$384a290f8c265cc5);
$parcel$export(module.exports, "tooltip", () => $9d680eb148465d1f$export$4e6f96734dfe12f4);
$parcel$export(module.exports, "ToolTipContent", () => $9d680eb148465d1f$export$4096cb8ab9668358);
$parcel$export(module.exports, "TooltipContentWithMultipleShortcuts", () => $9d680eb148465d1f$export$9f7e5fe6d45c5f7);
$parcel$export(module.exports, "findKeymapByDescription", () => $9d680eb148465d1f$export$c4e6735ce96cc7b3);
$parcel$export(module.exports, "findShortcutByKeymap", () => $9d680eb148465d1f$export$d69faf3b7bc3451);
$parcel$export(module.exports, "getAriaKeyshortcuts", () => $9d680eb148465d1f$export$6db28e5c399297b0);
$parcel$export(module.exports, "bindKeymapWithCommand", () => $9d680eb148465d1f$export$4bced0ac29aaf950);
$parcel$export(module.exports, "bindKeymapArrayWithCommand", () => $9d680eb148465d1f$export$e40cfdbcfa26f180);
$parcel$export(module.exports, "bindKeymapWithEditorCommand", () => $9d680eb148465d1f$export$b87d3e1cb85f0ba1);
$parcel$export(module.exports, "findKeyMapForBrowser", () => $9d680eb148465d1f$export$b2dbe47650bcfa54);
$parcel$export(module.exports, "isCapsLockOnAndModifyKeyboardEvent", () => $9d680eb148465d1f$export$f2da701c7659a26c);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $kitud = parcelRequire("kitud");

var $iPR6g = parcelRequire("iPR6g");

var $jxkn6 = parcelRequire("jxkn6");


// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $9d680eb148465d1f$var$MOD_REGEX = /Mod/i;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $9d680eb148465d1f$var$CMD_REGEX = /Cmd/i;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $9d680eb148465d1f$var$SHIFT_REGEX = /Shift/i;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $9d680eb148465d1f$var$CTRL_REGEX = /Ctrl/i;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $9d680eb148465d1f$var$ALT_REGEX = /Alt/i;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $9d680eb148465d1f$var$BACKSPACE_REGEX = /Backspace/i;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $9d680eb148465d1f$var$ENTER_REGEX = /Enter/i;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $9d680eb148465d1f$var$UPPERCASE_START_REGEX = /^[A-Z]/;
const $9d680eb148465d1f$export$82527b23b485fa7f = $9d680eb148465d1f$export$7e6b588cc98b34f1('Add Alt Text', 'Mod-Alt-y');
const $9d680eb148465d1f$export$c515872d50566e7b = $9d680eb148465d1f$export$7e6b588cc98b34f1('Toggle markdown view', 'Mod-e');
const $9d680eb148465d1f$export$22d712d636967812 = $9d680eb148465d1f$export$7e6b588cc98b34f1('View changes', 'Mod-Alt-z');
const $9d680eb148465d1f$export$9288bbefb6b7498b = $9d680eb148465d1f$export$7e6b588cc98b34f1('Navigate to editor toolbar', 'Alt-F9');
const $9d680eb148465d1f$export$7be006a99a30f86b = $9d680eb148465d1f$export$7e6b588cc98b34f1('Navigate to floating toolbar', 'Alt-F10');
const $9d680eb148465d1f$export$ae37214e128d9cc3 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Ask AI', "Mod-'");
const $9d680eb148465d1f$export$183fe6d20e9e58ba = $9d680eb148465d1f$export$7e6b588cc98b34f1('Bold', 'Mod-b');
const $9d680eb148465d1f$export$b03177f345903916 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Italic', 'Mod-i');
const $9d680eb148465d1f$export$6bcc93697958b66d = $9d680eb148465d1f$export$7e6b588cc98b34f1('Underline', 'Mod-u');
const $9d680eb148465d1f$export$6d564ba4eaf138d9 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Strikethrough', 'Mod-Shift-s');
const $9d680eb148465d1f$export$d26ab98fee0c804 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Subscript', 'Mod-Shift-,');
const $9d680eb148465d1f$export$4af6b58e12324fd = $9d680eb148465d1f$export$7e6b588cc98b34f1('Superscript', 'Mod-Shift-.');
const $9d680eb148465d1f$export$70686c6e7e15ed46 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Code', 'Mod-Shift-m');
const $9d680eb148465d1f$export$ab06dc742bb20e03 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Paste Plain Text', 'Mod-Shift-v');
const $9d680eb148465d1f$export$195de5d8e201efd7 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Clear formatting', 'Mod-\\');
const $9d680eb148465d1f$export$63c4f0859cc75dc6 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Normal text', 'Mod-Alt-0');
const $9d680eb148465d1f$export$953ab0e6a5d310a9 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Heading 1', 'Mod-Alt-1');
const $9d680eb148465d1f$export$192a351cfd6ca247 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Heading 2', 'Mod-Alt-2');
const $9d680eb148465d1f$export$fe382f3f4c871c62 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Heading 3', 'Mod-Alt-3');
const $9d680eb148465d1f$export$4073e08db19e0e31 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Heading 4', 'Mod-Alt-4');
const $9d680eb148465d1f$export$b84e85b2035ddb39 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Heading 5', 'Mod-Alt-5');
const $9d680eb148465d1f$export$86b1ac99fd15509b = $9d680eb148465d1f$export$7e6b588cc98b34f1('Heading 6', 'Mod-Alt-6');
const $9d680eb148465d1f$export$16f43eb2b2380de5 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Small text', 'Mod-Alt-7');
const $9d680eb148465d1f$export$dca848a1b50b6a31 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Numbered list', 'Mod-Shift-7');
const $9d680eb148465d1f$export$17f69a767ce93bb3 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Cmd + Backspace', 'Mod-Backspace');
const $9d680eb148465d1f$export$c0e115f47553645e = $9d680eb148465d1f$export$7e6b588cc98b34f1('Bullet list', 'Mod-Shift-8');
const $9d680eb148465d1f$export$34ed0cbd4f7ff88 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Quote', 'Mod-Shift-9');
const $9d680eb148465d1f$export$c2d9390f63354627 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Insert new line', 'Shift-Enter');
const $9d680eb148465d1f$export$dfd73a1c108b1570 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Shift Backspace', 'Shift-Backspace');
const $9d680eb148465d1f$export$9e5a9569a07601f2 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Split code block', 'Enter');
const $9d680eb148465d1f$export$e920ee2eb756d384 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Split list item', 'Enter');
const $9d680eb148465d1f$export$5f13bbad564673d4 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Insert horizontal rule', 'Mod-Shift--');
const $9d680eb148465d1f$export$21f930c44940fd98 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Undo', 'Mod-z');
const $9d680eb148465d1f$export$44935f8a884b57b9 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Move up', 'ArrowUp');
const $9d680eb148465d1f$export$8eba228b343b3599 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Move down', 'ArrowDown');
const $9d680eb148465d1f$export$108f27160c89e515 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Move left', 'ArrowLeft');
const $9d680eb148465d1f$export$e2c874fbfec7201 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Move right', 'ArrowRight');
const $9d680eb148465d1f$export$8066a906978eedb2 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Indent List', 'Tab');
const $9d680eb148465d1f$export$959569198ddbbe17 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Outdent List', 'Shift-Tab');
const $9d680eb148465d1f$export$c0e41ad67d77f6bb = $9d680eb148465d1f$export$7e6b588cc98b34f1('Redo', 'Mod-y');
const $9d680eb148465d1f$export$1688e416fee0a49e = $9d680eb148465d1f$export$d8a7f422d8d42038('Redo', 'Ctrl-y', 'Mod-Shift-z');
const $9d680eb148465d1f$export$1e2fd7795238a2d3 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Open Help', 'Mod-/');
const $9d680eb148465d1f$export$56b88caa6d8a3bff = $9d680eb148465d1f$export$7e6b588cc98b34f1('Link', 'Mod-k');
const $9d680eb148465d1f$export$fd78ad47ea0892f4 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Annotate', 'Mod-Alt-c');
const $9d680eb148465d1f$export$278533b7b7607665 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Copy link to selection', 'Mod-Alt-a');
const $9d680eb148465d1f$export$853c27de4ce0f746 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Submit Content', 'Mod-Enter');
const $9d680eb148465d1f$export$e668df1bcd81e4d2 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Enter', 'Enter');
const $9d680eb148465d1f$export$9f99fe2ed5bb7a29 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Shift Enter', 'Shift-Enter');
const $9d680eb148465d1f$export$62d58b1c91e8e902 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Tab', 'Tab');
const $9d680eb148465d1f$export$79ebfa808dffa5c6 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Indent', 'Tab');
const $9d680eb148465d1f$export$25755c0352544598 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Outdent', 'Shift-Tab');
const $9d680eb148465d1f$export$1ea584ca7009bcc1 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Backspace', 'Backspace');
const $9d680eb148465d1f$export$9603e93cdf38d7 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Delete', 'Delete');
const $9d680eb148465d1f$export$9e41eded5cb7e706 = $9d680eb148465d1f$export$d8a7f422d8d42038('Forward Delete', '', 'Ctrl-d');
const $9d680eb148465d1f$export$a941ed4b947d12f8 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Space', 'Space');
const $9d680eb148465d1f$export$4e7f196112fea3c5 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Escape', 'Escape');
const $9d680eb148465d1f$export$172699367bb25225 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Next cell', 'Tab');
const $9d680eb148465d1f$export$69838570e03d7193 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Previous cell', 'Shift-Tab');
const $9d680eb148465d1f$export$776c0cd47234205a = $9d680eb148465d1f$export$7e6b588cc98b34f1('Shift ArrowUp', 'Shift-ArrowUp');
const $9d680eb148465d1f$export$9ad63694f5781e16 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Shift Tab', 'Shift-Tab');
const $9d680eb148465d1f$export$33b9473b3f67763f = $9d680eb148465d1f$export$7e6b588cc98b34f1('Table', 'Shift-Alt-t');
const $9d680eb148465d1f$export$a57fbe0d9c764ae0 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Focus Table Resizer', 'Mod-Alt-Shift-r');
const $9d680eb148465d1f$export$2e3087448cf87857 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Add Row Above', 'Ctrl-Alt-ArrowUp');
const $9d680eb148465d1f$export$fbcf51cabbe4a007 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Add Row Below', 'Ctrl-Alt-ArrowDown');
const $9d680eb148465d1f$export$bf95f7b7d259c19f = $9d680eb148465d1f$export$7e6b588cc98b34f1('Add Column After', 'Ctrl-Alt-ArrowRight');
const $9d680eb148465d1f$export$717d5ccb817cdecc = $9d680eb148465d1f$export$7e6b588cc98b34f1('Add Column Before', 'Ctrl-Alt-ArrowLeft');
const $9d680eb148465d1f$export$5851c701392d3bfd = $9d680eb148465d1f$export$7e6b588cc98b34f1('Add Row Above', 'Mod-Alt-[');
const $9d680eb148465d1f$export$73fa63faf0fd6077 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Add Row Below', 'Mod-Alt-]');
const $9d680eb148465d1f$export$875b853996fced8d = $9d680eb148465d1f$export$7e6b588cc98b34f1('Add Column After', 'Mod-Alt-=');
const $9d680eb148465d1f$export$414418ca306c22bd = $9d680eb148465d1f$export$7e6b588cc98b34f1('Add Column Before', 'Mod-Alt--');
const $9d680eb148465d1f$export$a055d05df46abae5 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Move Column Left', 'Ctrl-Alt-Shift-ArrowLeft');
const $9d680eb148465d1f$export$f092689a35ce978d = $9d680eb148465d1f$export$7e6b588cc98b34f1('Move Column Left', 'Mod-Alt-Shift--');
const $9d680eb148465d1f$export$7ff94d9a4edfc7f = $9d680eb148465d1f$export$7e6b588cc98b34f1('Move Column Right', 'Ctrl-Alt-Shift-ArrowRight');
const $9d680eb148465d1f$export$863ee96d9e15383b = $9d680eb148465d1f$export$7e6b588cc98b34f1('Move Column Right', 'Mod-Alt-Shift-=');
const $9d680eb148465d1f$export$180b7d3240961d01 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Move Row Down', 'Ctrl-Alt-Shift-ArrowDown');
const $9d680eb148465d1f$export$13c2dd2d968ada2a = $9d680eb148465d1f$export$7e6b588cc98b34f1('Move Row Down', 'Mod-Alt-Shift-]');
const $9d680eb148465d1f$export$88de3148cc9ddd81 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Move Row Up', 'Ctrl-Alt-Shift-ArrowUp');
const $9d680eb148465d1f$export$e6749a6fc243b921 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Move Row Up', 'Mod-Alt-Shift-[');
const $9d680eb148465d1f$export$f4f2d7d33085c714 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Delete Column', 'Ctrl-Backspace');
const $9d680eb148465d1f$export$2ef39e5ffdaff9ed = $9d680eb148465d1f$export$7e6b588cc98b34f1('Delete Row', 'Ctrl-Backspace');
const $9d680eb148465d1f$export$8f58457f1327dd26 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Activate Column Resize', 'Mod-Alt-Shift-c');
const $9d680eb148465d1f$export$af2a99f971a346e6 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Cut', 'Mod-x');
const $9d680eb148465d1f$export$784d13d8ee351f07 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Copy', 'Mod-c');
const $9d680eb148465d1f$export$9b6706c8686cfc8e = $9d680eb148465d1f$export$7e6b588cc98b34f1('Paste', 'Mod-v');
const $9d680eb148465d1f$export$3c1455b21d3e7aab = $9d680eb148465d1f$export$7e6b588cc98b34f1('Paste', 'Mod-Shift-v');
const $9d680eb148465d1f$export$71aa6c912b956294 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Find', 'Mod-f');
const $9d680eb148465d1f$export$ca42dd9a1a0eb501 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Align Left', 'Mod-Shift-l');
const $9d680eb148465d1f$export$f4a51ff076cc9a09 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Align Center', 'Mod-Alt-e');
const $9d680eb148465d1f$export$faf8793e4a37a5a2 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Align Right', 'Mod-Alt-t');
const $9d680eb148465d1f$export$6f041e7a1d88fa51 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Toggles task item', 'Mod-Alt-Enter');
const $9d680eb148465d1f$export$2e48e3ea1c210731 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Toggle task list', 'Mod-Shift-6');
const $9d680eb148465d1f$export$e247ed8cec4832f4 = $9d680eb148465d1f$export$5882c1dfa05eb556('Select row', [
    'Mod-Alt-Shift-ArrowLeft',
    'Mod-Alt-Shift-ArrowRight'
]);
const $9d680eb148465d1f$export$c2e8772deb1607ea = $9d680eb148465d1f$export$5882c1dfa05eb556('Select column', [
    'Mod-Alt-Shift-ArrowDown',
    'Mod-Alt-Shift-ArrowUp'
]);
const $9d680eb148465d1f$export$625c5b9bf13f01a8 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Select table', 'Mod-a');
const $9d680eb148465d1f$export$fdeca4160ac263c5 = $9d680eb148465d1f$export$7e6b588cc98b34f1('increase image size', 'Mod-Alt-]');
const $9d680eb148465d1f$export$5ec5f857fec297eb = $9d680eb148465d1f$export$7e6b588cc98b34f1('increase image size', 'Mod-Alt-[');
const $9d680eb148465d1f$export$36141559a83247ee = $9d680eb148465d1f$export$7e6b588cc98b34f1('Activate controls panel on video', 'Shift-F10');
const $9d680eb148465d1f$export$ec123199f2fe4770 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Toggle Highlight Palette', 'Mod-Alt-b');
const $9d680eb148465d1f$export$62f87f0ca411e518 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Apply Yellow Highlight', 'Mod-Alt-y');
const $9d680eb148465d1f$export$6b05735f625d1c82 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Focus table context menu trigger', 'Shift-F10');
const $9d680eb148465d1f$export$a1bdda43619f945f = $9d680eb148465d1f$export$7e6b588cc98b34f1('Move node up in the document', 'Ctrl-Shift-ArrowUp');
const $9d680eb148465d1f$export$9bf312985dc8137e = $9d680eb148465d1f$export$7e6b588cc98b34f1('Move node down in the document', 'Ctrl-Shift-ArrowDown');
const $9d680eb148465d1f$export$c4f661b85fc92fd1 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Move node to the left column in the document', 'Ctrl-Shift-Alt-ArrowLeft');
const $9d680eb148465d1f$export$61c867f4a21787f6 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Move node to the right column in the document', 'Ctrl-Shift-Alt-ArrowRight');
const $9d680eb148465d1f$export$ba34d2a4e6aa10e4 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Show drag handle for editor element', 'Ctrl-Shift-h');
const $9d680eb148465d1f$export$e9c6aab026be9523 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Toggle Code Block', '```');
const $9d680eb148465d1f$export$8d5c072327044b6f = $9d680eb148465d1f$export$7e6b588cc98b34f1('Insert Emoji', ':');
const $9d680eb148465d1f$export$8c4314a90d4c5fc1 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Insert Mention', '@');
const $9d680eb148465d1f$export$cf3c284f81e5d477 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Insert Action Item', '[]');
const $9d680eb148465d1f$export$edd9d3cec5b0a9b6 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Insert Elements', '/');
const $9d680eb148465d1f$export$54f122e0d55178a9 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Continue in Rovo chat', 'Alt-Enter');
const $9d680eb148465d1f$var$arrowKeysMap = {
    // for reference: https://wincent.com/wiki/Unicode_representations_of_modifier_keys
    ARROWLEFT: '\u2190',
    ARROWRIGHT: '\u2192',
    ARROWUP: '\u2191',
    ARROWDOWN: '\u2193'
};
const $9d680eb148465d1f$var$tooltipShortcutStyle = /*#__PURE__*/ (0, $9dQre.css)({
    borderRadius: "var(--ds-radius-xsmall, 2px)",
    backgroundColor: "var(--ds-background-inverse-subtle, #00000029)",
    padding: `0 ${"var(--ds-space-025, 2px)"}`,
    // NOTE: This might not actually do anything: https://atlassian.slack.com/archives/CFG3PSQ9E/p1647395052443259?thread_ts=1647394572.556029&cid=CFG3PSQ9E
    label: 'tooltip-shortcut'
});
function $9d680eb148465d1f$export$384a290f8c265cc5(keymap) {
    let shortcut;
    const browser = (0, $jxkn6.getBrowserInfo)();
    if (browser.mac) // for reference: https://wincent.com/wiki/Unicode_representations_of_modifier_keys
    shortcut = keymap.mac.replace($9d680eb148465d1f$var$CMD_REGEX, '\u2318').replace($9d680eb148465d1f$var$SHIFT_REGEX, '\u21E7').replace($9d680eb148465d1f$var$CTRL_REGEX, '\u2303').replace($9d680eb148465d1f$var$ALT_REGEX, '\u2325').replace($9d680eb148465d1f$var$BACKSPACE_REGEX, '\u232B').replace($9d680eb148465d1f$var$ENTER_REGEX, '\u23CE');
    else shortcut = keymap.windows.replace($9d680eb148465d1f$var$BACKSPACE_REGEX, '\u232B');
    // If there are two - keys side by side preserve it's place so we can add it back
    const keys = shortcut.split('-');
    let storedEnDash = false;
    if (keys[keys.length - 1] === '' && keys[keys.length - 2] === '') storedEnDash = true;
    let lastKey = keys[keys.length - 1];
    if (lastKey.length === 1) // capitalise single letters
    lastKey = lastKey.toUpperCase();
    keys[keys.length - 1] = $9d680eb148465d1f$var$arrowKeysMap[lastKey.toUpperCase()] || lastKey;
    if (storedEnDash) keys[keys.length - 1] = '-';
    return keys.join(browser.mac ? '' : '+');
}
function $9d680eb148465d1f$export$4e6f96734dfe12f4(keymap, description) {
    if (keymap) {
        const shortcut = $9d680eb148465d1f$export$384a290f8c265cc5(keymap);
        return description ? `${description} ${shortcut}` : shortcut;
    }
    return;
}
const $9d680eb148465d1f$export$4096cb8ab9668358 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).memo(({ description: description, shortcutOverride: shortcutOverride, keymap: keymap })=>{
    const shortcut = shortcutOverride || keymap && $9d680eb148465d1f$export$384a290f8c265cc5(keymap);
    return shortcut || description ? /*#__PURE__*/ (0, $9dQre.jsx)((0, $bSJIT.Fragment), null, description, shortcut && description && '\u00A0', shortcut && /*#__PURE__*/ (0, $9dQre.jsx)("span", {
        css: $9d680eb148465d1f$var$tooltipShortcutStyle
    }, shortcut)) : null;
});
const $9d680eb148465d1f$export$9f7e5fe6d45c5f7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).memo(({ helpDescriptors: helpDescriptors })=>{
    const keymapCount = helpDescriptors.length;
    return /*#__PURE__*/ (0, $9dQre.jsx)((0, $bSJIT.Fragment), null, helpDescriptors.map((descriptor, index)=>// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        /*#__PURE__*/ (0, $9dQre.jsx)((0, $bSJIT.Fragment), {
            key: index
        }, /*#__PURE__*/ (0, $9dQre.jsx)($9d680eb148465d1f$export$4096cb8ab9668358, descriptor), ' ', index < keymapCount - 1 && /*#__PURE__*/ (0, $9dQre.jsx)("br", null))));
});
function $9d680eb148465d1f$export$c4e6735ce96cc7b3(description) {
    const matches = $9d680eb148465d1f$var$ALL.filter((keymap)=>keymap.description.toUpperCase() === description.toUpperCase());
    return matches[0];
}
function $9d680eb148465d1f$export$ca66063a345ce3ab(description) {
    const keymap = $9d680eb148465d1f$export$c4e6735ce96cc7b3(description);
    if (keymap) return $9d680eb148465d1f$export$d69faf3b7bc3451(keymap);
    return;
}
function $9d680eb148465d1f$export$d69faf3b7bc3451(keymap) {
    const browser = (0, $jxkn6.getBrowserInfo)();
    if (browser.mac) return keymap.mac;
    return keymap.windows;
}
function $9d680eb148465d1f$export$6db28e5c399297b0(keymap) {
    let keyShortcuts;
    const browser = (0, $jxkn6.getBrowserInfo)();
    if (typeof keymap === 'string') keyShortcuts = keymap;
    else if (typeof keymap === 'object') keyShortcuts = keymap[browser.mac ? 'mac' : 'windows'];
    if (keyShortcuts) return keyShortcuts.toLowerCase().split('-').filter(Boolean).map((modifier)=>{
        switch(modifier){
            case 'cmd':
                return 'Meta';
            case 'ctrl':
                return 'Control';
            case 'alt':
                return 'Alt';
            case 'shift':
                return 'Shift';
            case 'enter':
                return 'Enter';
            case 'esc':
                return 'Esc';
            case 'tab':
                return 'Tab';
            case 'space':
                return 'Space';
            case 'backspace':
                return 'Backspace';
            case 'arrowup':
                return 'Arrow Up';
            case 'arrowdown':
                return 'Arrow Down';
            default:
                // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
                return modifier.split('').join(' ');
        }
    }).join('+');
    else return undefined;
}
const $9d680eb148465d1f$var$ALL = [
    $9d680eb148465d1f$export$dca848a1b50b6a31,
    $9d680eb148465d1f$export$c0e115f47553645e,
    $9d680eb148465d1f$export$183fe6d20e9e58ba,
    $9d680eb148465d1f$export$b03177f345903916,
    $9d680eb148465d1f$export$6bcc93697958b66d,
    $9d680eb148465d1f$export$6d564ba4eaf138d9,
    $9d680eb148465d1f$export$d26ab98fee0c804,
    $9d680eb148465d1f$export$4af6b58e12324fd,
    $9d680eb148465d1f$export$70686c6e7e15ed46,
    $9d680eb148465d1f$export$63c4f0859cc75dc6,
    $9d680eb148465d1f$export$953ab0e6a5d310a9,
    $9d680eb148465d1f$export$192a351cfd6ca247,
    $9d680eb148465d1f$export$fe382f3f4c871c62,
    $9d680eb148465d1f$export$4073e08db19e0e31,
    $9d680eb148465d1f$export$b84e85b2035ddb39,
    $9d680eb148465d1f$export$86b1ac99fd15509b,
    $9d680eb148465d1f$export$16f43eb2b2380de5,
    $9d680eb148465d1f$export$34ed0cbd4f7ff88,
    $9d680eb148465d1f$export$c2d9390f63354627,
    $9d680eb148465d1f$export$5f13bbad564673d4,
    $9d680eb148465d1f$export$9e5a9569a07601f2,
    $9d680eb148465d1f$export$e920ee2eb756d384,
    $9d680eb148465d1f$export$1688e416fee0a49e,
    $9d680eb148465d1f$export$21f930c44940fd98,
    $9d680eb148465d1f$export$71aa6c912b956294,
    $9d680eb148465d1f$export$4e7f196112fea3c5,
    $9d680eb148465d1f$export$e668df1bcd81e4d2,
    $9d680eb148465d1f$export$9f99fe2ed5bb7a29
];
function $9d680eb148465d1f$export$d8a7f422d8d42038(description, windows, mac, common) {
    return {
        description: description,
        windows: windows.replace($9d680eb148465d1f$var$MOD_REGEX, 'Ctrl'),
        mac: mac.replace($9d680eb148465d1f$var$MOD_REGEX, 'Cmd'),
        common: common
    };
}
function $9d680eb148465d1f$export$7e6b588cc98b34f1(description, common) {
    const windows = common.replace($9d680eb148465d1f$var$MOD_REGEX, 'Ctrl');
    const mac = common.replace($9d680eb148465d1f$var$MOD_REGEX, 'Cmd');
    return $9d680eb148465d1f$export$d8a7f422d8d42038(description, windows, mac, common);
}
function $9d680eb148465d1f$export$5882c1dfa05eb556(description, shortcuts) {
    const keymapArray = [];
    shortcuts.forEach((shortcut)=>{
        keymapArray.push($9d680eb148465d1f$export$7e6b588cc98b34f1(description, shortcut));
    });
    return keymapArray;
}
function $9d680eb148465d1f$var$combineWithOldCommand(cmd, oldCmd) {
    return (state, dispatch, editorView)=>{
        return oldCmd(state, dispatch) || cmd(state, dispatch, editorView);
    };
}
function $9d680eb148465d1f$export$4bced0ac29aaf950(shortcut, cmd, keymap) {
    const oldCmd = keymap[shortcut];
    keymap[shortcut] = oldCmd ? $9d680eb148465d1f$var$combineWithOldCommand(cmd, oldCmd) : cmd;
}
function $9d680eb148465d1f$export$e40cfdbcfa26f180(shortcutsArray, cmd, keymap) {
    shortcutsArray.forEach((shortcut)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return $9d680eb148465d1f$export$4bced0ac29aaf950(shortcut.common, cmd, keymap);
    });
}
function $9d680eb148465d1f$export$b87d3e1cb85f0ba1(shortcut, cmd, keymap) {
    $9d680eb148465d1f$export$4bced0ac29aaf950(shortcut, (0, $iPR6g.editorCommandToPMCommand)(cmd), keymap);
}
function $9d680eb148465d1f$export$b2dbe47650bcfa54(keyMap) {
    if (keyMap) {
        const browser = (0, $jxkn6.getBrowserInfo)();
        if (browser.mac) return keyMap.mac;
        return keyMap.windows;
    }
    return;
}
function $9d680eb148465d1f$export$f2da701c7659a26c(event) {
    let keyboardEvent = event;
    const name = (0, $kitud.keyName)(event);
    if (event.ctrlKey && event.getModifierState('CapsLock') && !event.getModifierState('Shift') && name.length === 1 && $9d680eb148465d1f$var$UPPERCASE_START_REGEX.test(name)) keyboardEvent = new KeyboardEvent('keydown', {
        key: (0, $kitud.base)[event.keyCode].toLowerCase(),
        code: event.code,
        ctrlKey: true
    });
    return keyboardEvent;
}

});

parcelRegister("3RNLX", function(module, exports) {
$parcel$export(module.exports, "isAlignable", () => $93caf96a83add8e3$export$f3f99b2459c4a09f);
$parcel$export(module.exports, "changeAlignment", () => $93caf96a83add8e3$export$7364e99daa3bbf34);
$parcel$export(module.exports, "changeAlignmentTr", () => $93caf96a83add8e3$export$69636f7bd4c47a65);

var $g6Qq4 = parcelRequire("g6Qq4");

var $bq0hv = parcelRequire("bq0hv");

var $5NaaJ = parcelRequire("5NaaJ");

var $cw0wu = parcelRequire("cw0wu");
/**
 * Iterates over the commands one after the other,
 * passes the tr through and dispatches the cumulated transaction
 */ function $93caf96a83add8e3$var$cascadeCommands(cmds) {
    return (state, dispatch)=>{
        const { tr: baseTr } = state;
        let shouldDispatch = false;
        const onDispatchAction = (tr)=>{
            const selectionJSON = tr.selection.toJSON();
            baseTr.setSelection((0, $cw0wu.Selection).fromJSON(baseTr.doc, selectionJSON));
            tr.steps.forEach((st)=>{
                baseTr.step(st);
            });
            shouldDispatch = true;
        };
        cmds.forEach((cmd)=>cmd(state, onDispatchAction));
        if (dispatch && shouldDispatch) {
            dispatch(baseTr);
            return true;
        }
        return false;
    };
}
const $93caf96a83add8e3$export$f3f99b2459c4a09f = (align)=>(state, dispatch)=>{
        const { nodes: { paragraph: paragraph, heading: heading }, marks: { alignment: alignment } } = state.schema;
        return (0, $bq0hv.toggleBlockMark)(alignment, ()=>!align ? undefined : align === 'start' ? false : {
                align: align
            }, [
            paragraph,
            heading
        ])(state, dispatch);
    };
const $93caf96a83add8e3$var$changeBlockAlignmentWithAnalytics = (editorAnalyticsApi, align, inputMethod)=>(state, dispatch)=>{
        const { nodes: { paragraph: paragraph, heading: heading }, marks: { alignment: alignment } } = state.schema;
        return (0, $5NaaJ.withAnalytics)(editorAnalyticsApi, {
            eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).ALIGNMENT,
            action: (0, $g6Qq4.ACTION).UPDATED,
            actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).TEXT,
            attributes: {
                alignmentType: align,
                inputMethod: inputMethod
            }
        })((0, $bq0hv.toggleBlockMark)(alignment, ()=>!align ? undefined : align === 'start' ? false : {
                align: align
            }, [
            paragraph,
            heading
        ]))(state, dispatch);
    };
const $93caf96a83add8e3$var$changeBlockAlignmentWithAnalyticsTr = (api, align, inputMethod)=>({ tr: tr })=>{
        const { nodes: { paragraph: paragraph, heading: heading }, marks: { alignment: alignment } } = tr.doc.type.schema;
        const alignmentApplied = (0, $bq0hv.toggleBlockMarkNext)(alignment, ()=>!align ? undefined : align === 'start' ? false : {
                align: align
            }, [
            paragraph,
            heading
        ])(tr);
        if (alignmentApplied) {
            var _api$analytics;
            api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 || _api$analytics.actions.attachAnalyticsEvent({
                eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).ALIGNMENT,
                action: (0, $g6Qq4.ACTION).UPDATED,
                actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).TEXT,
                attributes: {
                    alignmentType: align,
                    inputMethod: inputMethod
                }
            })(tr);
        }
        return tr;
    };
const $93caf96a83add8e3$var$changeImageAlignmentWithAnalytics = (editorAnalyticsApi, align, inputMethod)=>(state, dispatch)=>{
        return (0, $5NaaJ.withAnalytics)(editorAnalyticsApi, {
            eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).ALIGNMENT,
            action: (0, $g6Qq4.ACTION).UPDATED,
            actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).MEDIA_SINGLE,
            attributes: {
                alignmentType: align,
                inputMethod: inputMethod
            }
        })((0, $bq0hv.changeImageAlignment)(align))(state, dispatch);
    };
const $93caf96a83add8e3$var$changeImageAlignmentWithAnalyticsTr = (api, align, inputMethod)=>({ tr: tr })=>{
        const alignmentApplied = (0, $bq0hv.changeImageAlignmentNext)(align)(tr);
        if (alignmentApplied) {
            var _api$analytics2;
            api === null || api === void 0 || (_api$analytics2 = api.analytics) === null || _api$analytics2 === void 0 || _api$analytics2.actions.attachAnalyticsEvent({
                eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).ALIGNMENT,
                action: (0, $g6Qq4.ACTION).UPDATED,
                actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).MEDIA_SINGLE,
                attributes: {
                    alignmentType: align,
                    inputMethod: inputMethod
                }
            })(tr);
        }
        return tr;
    };
const $93caf96a83add8e3$export$7364e99daa3bbf34 = (align, api, inputMethod)=>(state, dispatch)=>{
        var _api$analytics3, _api$analytics4;
        return $93caf96a83add8e3$var$cascadeCommands([
            $93caf96a83add8e3$var$changeImageAlignmentWithAnalytics(api === null || api === void 0 || (_api$analytics3 = api.analytics) === null || _api$analytics3 === void 0 ? void 0 : _api$analytics3.actions, align, inputMethod),
            $93caf96a83add8e3$var$changeBlockAlignmentWithAnalytics(api === null || api === void 0 || (_api$analytics4 = api.analytics) === null || _api$analytics4 === void 0 ? void 0 : _api$analytics4.actions, align, inputMethod)
        ])(state, dispatch);
    };
const $93caf96a83add8e3$export$69636f7bd4c47a65 = (api, align, inputMethod)=>({ tr: tr })=>{
        $93caf96a83add8e3$var$changeBlockAlignmentWithAnalyticsTr(api, align, inputMethod)({
            tr: tr
        });
        $93caf96a83add8e3$var$changeImageAlignmentWithAnalyticsTr(api, align, inputMethod)({
            tr: tr
        });
        return tr;
    };

});
parcelRegister("5NaaJ", function(module, exports) {
$parcel$export(module.exports, "withAnalytics", () => $7d5fca0b82786a24$export$af9baadf0e4f6e13);
function $7d5fca0b82786a24$export$af9baadf0e4f6e13(analyticsApi, payload, channel) {
    return (command)=>(state, dispatch, view)=>command(state, (tr)=>{
                if (dispatch) {
                    if (payload instanceof Function) {
                        const dynamicPayload = payload(state, {
                            currentDoc: tr.doc
                        });
                        if (dynamicPayload) {
                            analyticsApi === null || analyticsApi === void 0 || analyticsApi.attachAnalyticsEvent(dynamicPayload, channel)(tr);
                            dispatch(tr);
                        }
                    } else {
                        analyticsApi === null || analyticsApi === void 0 || analyticsApi.attachAnalyticsEvent(payload, channel)(tr);
                        dispatch(tr);
                    }
                }
            }, view);
}

});



parcelRegister("l6Dnt", function(module, exports) {
$parcel$export(module.exports, "pluginKey", () => $cb2864f0d2ad87e1$export$18d4026d1ea86bb1);
$parcel$export(module.exports, "createPlugin", () => $cb2864f0d2ad87e1$export$ae829ec7b2625219);

var $f7Kk4 = parcelRequire("f7Kk4");

var $cw0wu = parcelRequire("cw0wu");

var $3RNLX = parcelRequire("3RNLX");

var $dSRv5 = parcelRequire("dSRv5");
function $cb2864f0d2ad87e1$var$createInitialPluginState(editorState, pluginConfig) {
    return {
        align: (0, $dSRv5.getActiveAlignment)(editorState) || pluginConfig.align,
        isEnabled: true
    };
}
const $cb2864f0d2ad87e1$export$18d4026d1ea86bb1 = new (0, $cw0wu.PluginKey)('alignmentPlugin');
function $cb2864f0d2ad87e1$export$ae829ec7b2625219(dispatch, pluginConfig) {
    return new (0, $f7Kk4.SafePlugin)({
        key: $cb2864f0d2ad87e1$export$18d4026d1ea86bb1,
        state: {
            init (_, editorState) {
                return $cb2864f0d2ad87e1$var$createInitialPluginState(editorState, pluginConfig);
            },
            apply (_tr, state, _prevState, nextState) {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const nextPluginState = (0, $dSRv5.getActiveAlignment)(nextState);
                const isEnabled = (0, $3RNLX.isAlignable)(nextPluginState)(nextState);
                const newState = {
                    ...state,
                    align: nextPluginState,
                    isEnabled: isEnabled
                };
                if (nextPluginState !== state.align || isEnabled !== state.isEnabled) dispatch($cb2864f0d2ad87e1$export$18d4026d1ea86bb1, newState);
                return newState;
            }
        }
    });
}

});
parcelRegister("dSRv5", function(module, exports) {
$parcel$export(module.exports, "getActiveAlignment", () => $0b11abf13cf0f711$export$fcb629559422d129);

var $gab48 = parcelRequire("gab48");

var $2E7OD = parcelRequire("2E7OD");
const $0b11abf13cf0f711$export$fcb629559422d129 = (state)=>{
    if (state.selection instanceof (0, $2E7OD.CellSelection)) {
        const marks = [];
        state.selection.forEachCell((cell)=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const mark = cell.firstChild.marks.filter((mark)=>mark.type === state.schema.marks.alignment)[0];
            marks.push(mark ? mark.attrs.align : 'start');
        });
        return marks.every((mark)=>mark === marks[0]) ? marks[0] : 'start';
    }
    const node = (0, $gab48.findParentNodeOfType)([
        state.schema.nodes.paragraph,
        state.schema.nodes.heading
    ])(state.selection);
    const getMark = node && node.node.marks.filter((mark)=>mark.type === state.schema.marks.alignment)[0];
    return getMark && getMark.attrs.align || 'start';
};

});


parcelRegister("aZ0PI", function(module, exports) {
$parcel$export(module.exports, "FloatingToolbarComponent", () => $1b03f3749d5e7258$export$b15abb95157a91c7);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $g6Qq4 = parcelRequire("g6Qq4");

var $5beht = parcelRequire("5beht");

var $797yE = parcelRequire("797yE");

var $3RNLX = parcelRequire("3RNLX");

var $cPL12 = parcelRequire("cPL12");

var $a7X0Q = parcelRequire("a7X0Q");
const $1b03f3749d5e7258$var$FloatingToolbarSettings = {
    disabled: false,
    isToolbarReducedSpacing: true
};
function $1b03f3749d5e7258$export$b15abb95157a91c7({ api: api, editorView: editorView }) {
    const { align: align, isEnabled: isEnabled } = (0, $5beht.useSharedPluginStateWithSelector)(api, [
        'alignment'
    ], (states)=>{
        var _states$alignmentStat, _states$alignmentStat2;
        return {
            align: (_states$alignmentStat = states.alignmentState) === null || _states$alignmentStat === void 0 ? void 0 : _states$alignmentStat.align,
            isEnabled: (_states$alignmentStat2 = states.alignmentState) === null || _states$alignmentStat2 === void 0 ? void 0 : _states$alignmentStat2.isEnabled
        };
    });
    const changeAlignmentCallback = (0, $bSJIT.useCallback)((align)=>{
        return (0, $3RNLX.changeAlignment)(align, api, (0, $g6Qq4.INPUT_METHOD).FLOATING_TB)(editorView.state, editorView.dispatch);
    }, [
        editorView,
        api
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $a7X0Q.default), {
        align: align,
        isReducedSpacing: (0, $797yE.editorExperiment)('platform_editor_controls', 'variant1') ? false : $1b03f3749d5e7258$var$FloatingToolbarSettings.isToolbarReducedSpacing,
        changeAlignment: changeAlignmentCallback,
        disabled: $1b03f3749d5e7258$var$FloatingToolbarSettings.disabled || !isEnabled,
        toolbarType: (0, $cPL12.ToolbarType).FLOATING,
        api: api
    });
}

});
parcelRegister("cPL12", function(module, exports) {
$parcel$export(module.exports, "ToolbarType", () => $7b8d5389ff24cad9$export$a5d11b3163e4b1a5);
var $7b8d5389ff24cad9$export$a5d11b3163e4b1a5 = /*#__PURE__*/ function(ToolbarType) {
    ToolbarType["PRIMARY"] = "primaryToolbar";
    ToolbarType["FLOATING"] = "floatingToolbar";
    return ToolbarType;
}({});

});

parcelRegister("a7X0Q", function(module, exports) {
$parcel$export(module.exports, "default", () => $829b2ef8ffe77fef$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $fK3tS = parcelRequire("fK3tS");

var $2z97M = parcelRequire("2z97M");

var $cv8id = parcelRequire("cv8id");

var $cut9B = parcelRequire("cut9B");

var $imBU3 = parcelRequire("imBU3");

var $6bWVw = parcelRequire("6bWVw");

var $fWCaV = parcelRequire("fWCaV");

var $8zO6u = parcelRequire("8zO6u");

var $9xI4S = parcelRequire("9xI4S");

var $024dl = parcelRequire("024dl");

var $hdcuV = parcelRequire("hdcuV");

var $58mAd = parcelRequire("58mAd");

var $gKziX = parcelRequire("gKziX");

var $dvoJo = parcelRequire("dvoJo");

var $i7u95 = parcelRequire("i7u95");

var $797yE = parcelRequire("797yE");

var $cPL12 = parcelRequire("cPL12");

var $8egyr = parcelRequire("8egyr");

var $2D87o = parcelRequire("2D87o");
// eslint-disable-next-line @repo/internal/react/no-class-components
class $829b2ef8ffe77fef$var$AlignmentToolbar extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Component {
    static #_ = this.displayName = 'AlignmentToolbar';
    render() {
        const { isOpen: isOpen } = this.state;
        const { popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isReducedSpacing: isReducedSpacing, align: align, disabled: disabled, intl: intl, api: api } = this.props;
        const alignment = align ?? 'start';
        const title = intl.formatMessage((0, $2z97M.alignmentMessages).alignment);
        const alignmentLabelMap = {
            start: intl.formatMessage((0, $2z97M.alignmentMessages).alignLeft),
            center: intl.formatMessage((0, $2z97M.alignmentMessages).alignCenter),
            end: intl.formatMessage((0, $2z97M.alignmentMessages).alignRight)
        };
        const ariaLabel = `${title}, ${alignmentLabelMap[alignment] ?? ''}`;
        const reducedSpacing = (0, $797yE.editorExperiment)('platform_editor_controls', 'variant1', {
            exposure: true
        }) ? 'compact' : 'none';
        const items = [
            {
                key: 'alignmentLeft',
                content: intl.formatMessage((0, $2z97M.alignmentMessages).alignLeft),
                value: {
                    name: 'start'
                },
                isActive: align === 'start',
                elemAfter: /*#__PURE__*/ (0, $dc70d.jsx)((0, $cut9B.Shortcut), {
                    children: (0, $cv8id.tooltip)((0, $cv8id.alignLeft))
                }),
                elemBefore: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dvoJo))), {
                    label: ""
                })
            },
            {
                key: 'alignmentCenter',
                content: intl.formatMessage((0, $2z97M.alignmentMessages).alignCenter),
                value: {
                    name: 'center'
                },
                isActive: align === 'center',
                elemAfter: /*#__PURE__*/ (0, $dc70d.jsx)((0, $cut9B.Shortcut), {
                    children: (0, $cv8id.tooltip)((0, $cv8id.alignCenter))
                }),
                elemBefore: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gKziX))), {
                    label: ""
                })
            },
            {
                key: 'alignmentRight',
                content: intl.formatMessage((0, $2z97M.alignmentMessages).alignRight),
                value: {
                    name: 'end'
                },
                isActive: align === 'end',
                elemAfter: /*#__PURE__*/ (0, $dc70d.jsx)((0, $cut9B.Shortcut), {
                    children: (0, $cv8id.tooltip)((0, $cv8id.alignRight))
                }),
                elemBefore: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i7u95))), {
                    label: ""
                })
            }
        ];
        return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $024dl.ToolbarDropdownWrapper), {
            children: [
                (0, $797yE.editorExperiment)('platform_editor_controls', 'variant1') ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $fWCaV.DropdownMenuWithKeyboardNavigation), {
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    arrowKeyNavigationProviderOptions: {
                        type: (0, $imBU3.ArrowKeyNavigationType).MENU
                    },
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    items: [
                        {
                            items: items
                        }
                    ],
                    isOpen: isOpen,
                    onItemActivated: this.handleOnItemActivated,
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    onOpenChange: (attrs)=>this.setState({
                            isOpen: attrs === null || attrs === void 0 ? void 0 : attrs.isOpen
                        }),
                    mountTo: popupsMountPoint,
                    boundariesElement: popupsBoundariesElement,
                    scrollableElement: popupsScrollableElement,
                    fitWidth: 200,
                    children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $8zO6u.default), {
                        spacing: isReducedSpacing ? reducedSpacing : 'default',
                        disabled: disabled,
                        selected: isOpen,
                        title: title,
                        "aria-label": ariaLabel,
                        "aria-expanded": isOpen,
                        "aria-haspopup": true,
                        onClick: this.toggleOpen,
                        onKeyDown: this.toggleOpenByKeyboard,
                        iconBefore: /*#__PURE__*/ (0, $dc70d.jsxs)((0, $9xI4S.ToolbarDropdownTriggerWrapper), {
                            children: [
                                /*#__PURE__*/ (0, $dc70d.jsx)((0, $2D87o.IconMap), {
                                    alignment: alignment
                                }),
                                /*#__PURE__*/ (0, $dc70d.jsx)((0, $hdcuV.ToolbarExpandIcon), {})
                            ]
                        })
                    })
                }) : /*#__PURE__*/ (0, $dc70d.jsx)((0, $6bWVw.DropdownContainer), {
                    mountTo: popupsMountPoint,
                    boundariesElement: popupsBoundariesElement,
                    scrollableElement: popupsScrollableElement,
                    isOpen: isOpen,
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    handleClickOutside: (event)=>{
                        if (event instanceof MouseEvent) this.hide({
                            isOpen: false,
                            event: event
                        });
                    },
                    handleEscapeKeydown: this.hideOnEscape,
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    arrowKeyNavigationProviderOptions: {
                        type: (0, $imBU3.ArrowKeyNavigationType).MENU
                    },
                    fitWidth: 112,
                    fitHeight: 80,
                    closeOnTab: true,
                    trigger: /*#__PURE__*/ (0, $dc70d.jsx)((0, $8zO6u.default), {
                        spacing: isReducedSpacing ? reducedSpacing : 'default',
                        disabled: disabled,
                        selected: isOpen,
                        title: title,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides -- Ignored via go/DSP-18766
                        className: "align-btn",
                        "aria-label": ariaLabel,
                        "aria-expanded": isOpen,
                        "aria-haspopup": true,
                        onClick: this.toggleOpen,
                        onKeyDown: this.toggleOpenByKeyboard,
                        iconBefore: /*#__PURE__*/ (0, $dc70d.jsxs)((0, $9xI4S.ToolbarDropdownTriggerWrapper), {
                            children: [
                                /*#__PURE__*/ (0, $dc70d.jsx)((0, $2D87o.IconMap), {
                                    alignment: alignment
                                }),
                                /*#__PURE__*/ (0, $dc70d.jsx)((0, $hdcuV.ToolbarExpandIcon), {})
                            ]
                        }),
                        ref: this.toolbarItemRef
                    }),
                    children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $8egyr.default), {
                        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                        onClick: (align)=>this.changeAlignment(align, false),
                        selectedAlignment: alignment
                    })
                }),
                !(api !== null && api !== void 0 && api.primaryToolbar) && /*#__PURE__*/ (0, $dc70d.jsx)((0, $58mAd.ToolbarSeparator), {})
            ]
        });
    }
    componentDidUpdate(_prevProps) {
        if (this.props.toolbarType !== (0, $cPL12.ToolbarType).FLOATING && this.state.isOpen) // by triggering the keyboard event with a setTimeout, we ensure that the tooltip
        // associated with the alignment button doesn't render until the next render cycle
        // where the popup will be correctly positioned and the relative position of the tooltip
        // will not overlap with the button.
        setTimeout(()=>{
            var _this$toolbarItemRef$;
            const keyboardEvent = new KeyboardEvent('keydown', {
                bubbles: true,
                key: 'ArrowDown'
            });
            (_this$toolbarItemRef$ = this.toolbarItemRef.current) === null || _this$toolbarItemRef$ === void 0 || _this$toolbarItemRef$.dispatchEvent(keyboardEvent);
        }, 0);
    }
    constructor(...args){
        super(...args), this.toolbarItemRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createRef(), this.state = {
            isOpen: false
        }, this.changeAlignment = (align, togglePopup)=>{
            if (togglePopup) this.toggleOpen();
            return this.props.changeAlignment(align);
        }, this.toggleOpen = ()=>{
            this.setState({
                isOpen: !this.state.isOpen
            });
        }, this.toggleOpenByKeyboard = (event)=>{
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                this.setState({
                    isOpen: !this.state.isOpen
                });
            }
        }, this.handleOnItemActivated = ({ item: item, shouldCloseMenu: shouldCloseMenu = true })=>this.changeAlignment(item.value.name, shouldCloseMenu), this.hide = (attrs)=>{
            if (this.state.isOpen) {
                this.setState({
                    isOpen: false
                });
                if ((attrs === null || attrs === void 0 ? void 0 : attrs.event) instanceof KeyboardEvent && attrs.event.key === 'Escape') {
                    var _this$toolbarItemRef;
                    (_this$toolbarItemRef = this.toolbarItemRef) === null || _this$toolbarItemRef === void 0 || (_this$toolbarItemRef = _this$toolbarItemRef.current) === null || _this$toolbarItemRef === void 0 || _this$toolbarItemRef.focus();
                }
            }
        }, this.hideOnEscape = ()=>{
            var _this$toolbarItemRef2;
            this.hide();
            (_this$toolbarItemRef2 = this.toolbarItemRef) === null || _this$toolbarItemRef2 === void 0 || (_this$toolbarItemRef2 = _this$toolbarItemRef2.current) === null || _this$toolbarItemRef2 === void 0 || _this$toolbarItemRef2.focus();
        };
    }
}
// eslint-disable-next-line @typescript-eslint/no-restricted-types
const $829b2ef8ffe77fef$var$_default_1 = (0, $fK3tS.default)($829b2ef8ffe77fef$var$AlignmentToolbar);
var $829b2ef8ffe77fef$export$2e2bcd8739ae039 = $829b2ef8ffe77fef$var$_default_1;

});
parcelRegister("cut9B", function(module, exports) {
$parcel$export(module.exports, "Shortcut", () => $89461c49293f548e$export$59451aa6b6270879);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $9fU1q = parcelRequire("9fU1q");
parcelRequire("bSJIT");
const $89461c49293f548e$var$shortcutStyle = null;
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- This rule thinks this isn't a `css()` call due to the name mapping
const $89461c49293f548e$var$shortcutStyleUnbounded = null;
function $89461c49293f548e$export$59451aa6b6270879({ children: children }) {
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        className: (0, $9fU1q.default)([
            "_2rkofajl _1wpzesu3 _ca0q1b66 _n3td1b66 _19bv1b66 _u5f31b66 _syazazsu _bfhki8nm _1ggkglyw",
            "_1wyb1qpa"
        ]),
        children: children
    });
}

});

parcelRegister("imBU3", function(module, exports) {
$parcel$export(module.exports, "ArrowKeyNavigationType", () => $e8deb42e43b8f148$export$26c2c5e2f61f437a);
var $e8deb42e43b8f148$export$26c2c5e2f61f437a = /*#__PURE__*/ function(ArrowKeyNavigationType) {
    ArrowKeyNavigationType["COLOR"] = "color";
    ArrowKeyNavigationType["MENU"] = "menu";
    return ArrowKeyNavigationType;
}({});

});

parcelRegister("6bWVw", function(module, exports) {
$parcel$export(module.exports, "DropdownContainer", () => $fb67660717f60621$export$49166591ec160d97);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $imBU3 = parcelRequire("imBU3");

var $e2NQI = parcelRequire("e2NQI");

var $aHqLs = parcelRequire("aHqLs");
const $fb67660717f60621$export$49166591ec160d97 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).memo(function DropdownContainer(props) {
    const keyDownHandlerContext = (0, $bSJIT.useContext)((0, $aHqLs.KeyDownHandlerContext));
    let newArrowKeyNavigationProviderOptions = props.arrowKeyNavigationProviderOptions;
    // if the dropdown is of type menu, use this keyDownHandlerContext
    if (props.arrowKeyNavigationProviderOptions.type === (0, $imBU3.ArrowKeyNavigationType).MENU) newArrowKeyNavigationProviderOptions = {
        ...props.arrowKeyNavigationProviderOptions,
        keyDownHandlerContext: keyDownHandlerContext
    };
    return(//This context is to handle the tab, Arrow Right/Left key events for dropdown.
    //Default context has the void callbacks for above key events
    /*#__PURE__*/ (0, $9dQre.jsx)((0, $e2NQI.default), {
        ...props,
        arrowKeyNavigationProviderOptions: newArrowKeyNavigationProviderOptions
    }));
});

});
parcelRegister("e2NQI", function(module, exports) {
$parcel$export(module.exports, "default", () => $e70db9ee9e766b33$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $3Aq92 = parcelRequire("3Aq92");
var $cf2n1 = parcelRequire("cf2n1");

var $ctt7l = parcelRequire("ctt7l");

var $5zk80 = parcelRequire("5zk80");

var $9xvBa = parcelRequire("9xvBa");

var $5chfg = parcelRequire("5chfg");
class $e70db9ee9e766b33$export$931cbfb6bfb85fc extends (0, $bSJIT.PureComponent) {
    constructor(props){
        super(props), this.handleRef = (setOutsideClickTargetRef)=>(target)=>{
                setOutsideClickTargetRef(target);
                this.setState({
                    target: target || undefined
                });
            }, this.updatePopupPlacement = (placement)=>{
            this.setState({
                popupPlacement: placement
            });
        }, this.handleCloseAndFocus = (event)=>{
            var _this$state$target;
            (_this$state$target = this.state.target) === null || _this$state$target === void 0 || (_this$state$target = _this$state$target.querySelector('button')) === null || _this$state$target === void 0 || _this$state$target.focus();
            this.handleClose(event);
        }, this.handleClose = (event)=>{
            if (this.props.onOpenChange) this.props.onOpenChange({
                isOpen: false,
                event: event
            });
        };
        this.state = {
            popupPlacement: [
                'bottom',
                'left'
            ]
        };
    }
    componentDidUpdate(prevProps) {
        if (!prevProps.isOpen && this.props.isOpen && this.state.target) {
            // Dropdown flickers when opens as placement is calculated in Popup component and updated after the first render.
            // popupPlacement is set to ['bottom', 'left'] by default, but it may not be the correct placement and is required in DropdownList.
            // To avoid flicker we calculate placement here and set it to state when the dropdown opens.
            const initialPlacement = (0, $9xvBa.calculatePlacement)(this.state.target, this.props.boundariesElement || document.body, this.props.fitWidth, this.props.fitHeight, this.props.alignX, this.props.alignY, this.props.forcePlacement);
            this.setState({
                popupPlacement: initialPlacement
            });
        }
    }
    renderDropdown() {
        const { target: target, popupPlacement: popupPlacement } = this.state;
        const { children: children, mountTo: mountTo, boundariesElement: boundariesElement, scrollableElement: scrollableElement, onOpenChange: onOpenChange, fitHeight: fitHeight, fitWidth: fitWidth, zIndex: zIndex, arrowKeyNavigationProviderOptions: arrowKeyNavigationProviderOptions, dropdownListId: dropdownListId, alignDropdownWithParentElement: alignDropdownWithParentElement, target: targetProp, forcePlacement: forcePlacement, alignX: alignX, alignY: alignY, offset: offset, shouldFitContainer: shouldFitContainer = true, testId: testId } = this.props;
        return /*#__PURE__*/ (0, $dc70d.jsx)((0, $5zk80.default), {
            target: targetProp ?? (alignDropdownWithParentElement ? // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            target === null || target === void 0 ? void 0 : target.closest("[data-testid='editor-floating-toolbar']") : target),
            mountTo: mountTo,
            boundariesElement: boundariesElement,
            scrollableElement: scrollableElement,
            onPlacementChanged: forcePlacement ? undefined : this.updatePopupPlacement,
            fitHeight: fitHeight,
            fitWidth: fitWidth,
            zIndex: zIndex,
            allowOutOfBounds: alignDropdownWithParentElement,
            alignX: alignX,
            alignY: alignY,
            forcePlacement: forcePlacement,
            offset: offset,
            children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $5chfg.ArrowKeyNavigationProvider), {
                ...arrowKeyNavigationProviderOptions,
                closeOnTab: true,
                handleClose: this.handleCloseAndFocus,
                children: /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                    style: {
                        height: 0,
                        minWidth: fitWidth || 0
                    },
                    children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $ctt7l.default), {
                        isOpen: true,
                        onOpenChange: onOpenChange,
                        position: popupPlacement.join(' '),
                        shouldFitContainer: shouldFitContainer,
                        id: dropdownListId,
                        testId: testId,
                        children: children
                    })
                })
            })
        });
    }
    render() {
        const { trigger: trigger, isOpen: isOpen } = this.props;
        return trigger ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $3Aq92.OutsideClickTargetRefContext).Consumer, {
            children: (setOutsideClickTargetRef)=>/*#__PURE__*/ (0, $dc70d.jsxs)((0, $dc70d.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                            ref: this.handleRef(setOutsideClickTargetRef),
                            children: trigger
                        }),
                        isOpen ? this.renderDropdown() : null
                    ]
                })
        }) : /*#__PURE__*/ (0, $dc70d.jsx)((0, $dc70d.Fragment), {
            children: isOpen ? this.renderDropdown() : null
        });
    }
}
const $e70db9ee9e766b33$var$DropdownWithOuterListeners = (0, $cf2n1.default)($e70db9ee9e766b33$export$931cbfb6bfb85fc);
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$e70db9ee9e766b33$export$2e2bcd8739ae039 = $e70db9ee9e766b33$var$DropdownWithOuterListeners;

});
parcelRegister("3Aq92", function(module, exports) {
$parcel$export(module.exports, "OutsideClickTargetRefContext", () => $6b38a28ab6ceae87$export$798d66d2e25c3c95);

var $bSJIT = parcelRequire("bSJIT");
const $6b38a28ab6ceae87$export$798d66d2e25c3c95 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createContext(()=>Object);

});

parcelRegister("cf2n1", function(module, exports) {
$parcel$export(module.exports, "default", () => $7ef7087888b8dc32$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $797yE = parcelRequire("797yE");

var $3Aq92 = parcelRequire("3Aq92");

var $jC0lZ = parcelRequire("jC0lZ");
// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
class $7ef7087888b8dc32$var$WithOutsideClick extends (0, $bSJIT.PureComponent) {
    componentDidMount() {
        if (this.props.handleClickOutside) {
            const options = this.props.captureClick && (0, $797yE.editorExperiment)('platform_editor_controls', 'variant1') ? {
                capture: true
            } : false;
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('click', this.handleClick, options);
        }
        if (this.props.handleEscapeKeydown || this.props.handleBackspaceDeleteKeydown || this.props.handleKeyDown) {
            var _this$props$editorRef;
            // Attached event to the menu so that 'ESC' events from the opened menu also will be handled.
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            (this.props.popupsMountPoint ? this.props.popupsMountPoint : // @ts-ignore - TS2873 TypeScript 5.9.2 upgrade
            ((_this$props$editorRef = this.props.editorRef) === null || _this$props$editorRef === void 0 ? void 0 : _this$props$editorRef.current) || this.props.targetRef || document).addEventListener('keydown', this.handleKeyDown, false);
        }
    }
    componentWillUnmount() {
        if (this.props.handleClickOutside) {
            const options = this.props.captureClick && (0, $797yE.editorExperiment)('platform_editor_controls', 'variant1') ? {
                capture: true
            } : false;
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('click', this.handleClick, options);
        }
        if (this.props.handleEscapeKeydown || this.props.handleBackspaceDeleteKeydown || this.props.handleKeyDown) {
            var _this$props$editorRef2;
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            (this.props.popupsMountPoint ? this.props.popupsMountPoint : // @ts-ignore - TS2873 TypeScript 5.9.2 upgrade
            ((_this$props$editorRef2 = this.props.editorRef) === null || _this$props$editorRef2 === void 0 ? void 0 : _this$props$editorRef2.current) || this.props.targetRef || document).removeEventListener('keydown', this.handleKeyDown, false);
        }
    }
    render() {
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.handleClick = (evt)=>{
            var _this$props$outsideCl;
            if (!this.props.isActiveComponent || !this.props.handleClickOutside) return;
            const domNode = (_this$props$outsideCl = this.props.outsideClickTargetRef.current) === null || _this$props$outsideCl === void 0 ? void 0 : _this$props$outsideCl.deref();
            if (!domNode || evt.target instanceof Node && !domNode.contains(evt.target)) {
                var _this$props$editorVie;
                this.props.handleClickOutside(evt);
                // When the menus are closed by clicking outside the focus is set on editor.
                if (!((_this$props$editorVie = this.props.editorView) !== null && _this$props$editorVie !== void 0 && _this$props$editorVie.hasFocus())) {
                    var _this$props$editorVie2;
                    (_this$props$editorVie2 = this.props.editorView) === null || _this$props$editorVie2 === void 0 || _this$props$editorVie2.focus();
                }
            }
        }, this.handleKeyDown = (evt)=>{
            var _this$props$handleKey, _this$props;
            if (!this.props.isActiveComponent) return;
            if (evt.code === 'Escape' && this.props.handleEscapeKeydown) {
                evt.preventDefault();
                evt.stopPropagation();
                this.props.handleEscapeKeydown(evt);
                // on 'Esc', Focus is handled in 'handleEscapeKeydown'.
                return false;
            } else if (evt.code === 'Enter' && this.props.handleEnterKeydown) this.props.handleEnterKeydown(evt);
            else if (evt.code === 'Tab' && this.props.handleEscapeKeydown && this.props.closeOnTab) // The menus should be closed when the tab is pressed as it takes the focus out of the menu
            this.props.handleEscapeKeydown(evt);
            else if ((evt.code === 'Delete' || evt.code === 'Backspace') && this.props.handleBackspaceDeleteKeydown) this.props.handleBackspaceDeleteKeydown(evt);
            (_this$props$handleKey = (_this$props = this.props).handleKeyDown) === null || _this$props$handleKey === void 0 || _this$props$handleKey.call(_this$props, evt);
        };
    }
}
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $7ef7087888b8dc32$var$hasIsOpen(props) {
    return 'isOpen' in props;
}
function $7ef7087888b8dc32$export$2e2bcd8739ae039(Component) {
    return ({ captureClick: captureClick, closeOnTab: closeOnTab, handleBackspaceDeleteKeydown: handleBackspaceDeleteKeydown, handleClickOutside: handleClickOutside, handleEnterKeydown: handleEnterKeydown, handleEscapeKeydown: handleEscapeKeydown, handleKeyDown: handleKeyDown, ...props })=>{
        const isActiveProp = $7ef7087888b8dc32$var$hasIsOpen(props) ? props.isOpen : true;
        const [isActiveComponent, setActiveComponent] = (0, $bSJIT.useState)(false);
        const outsideClickTargetRef = (0, $bSJIT.useRef)(null);
        const setOutsideClickTargetRef = (0, $bSJIT.useCallback)((el)=>{
            outsideClickTargetRef.current = el && new WeakRef(el);
        }, [
            outsideClickTargetRef
        ]);
        (0, $bSJIT.useEffect)(()=>{
            requestAnimationFrame(()=>{
                setActiveComponent(isActiveProp);
            });
        }, [
            isActiveProp
        ]);
        return /*#__PURE__*/ (0, $dc70d.jsx)((0, $jC0lZ.default).Consumer, {
            children: ({ editorView: editorView, popupsMountPoint: popupsMountPoint, editorRef: editorRef })=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $3Aq92.OutsideClickTargetRefContext).Provider, {
                    value: setOutsideClickTargetRef,
                    children: /*#__PURE__*/ (0, $dc70d.jsx)($7ef7087888b8dc32$var$WithOutsideClick, {
                        editorView: editorView,
                        editorRef: editorRef,
                        targetRef: props.targetRef,
                        outsideClickTargetRef: outsideClickTargetRef,
                        popupsMountPoint: popupsMountPoint,
                        isActiveComponent: isActiveComponent,
                        handleClickOutside: handleClickOutside,
                        handleEnterKeydown: handleEnterKeydown,
                        handleEscapeKeydown: handleEscapeKeydown,
                        handleBackspaceDeleteKeydown: handleBackspaceDeleteKeydown,
                        handleKeyDown: handleKeyDown,
                        closeOnTab: closeOnTab,
                        captureClick: captureClick,
                        children: /*#__PURE__*/ (0, $dc70d.jsx)(Component, {
                            ...props
                        })
                    })
                })
        });
    };
}

});

parcelRegister("ctt7l", function(module, exports) {
$parcel$export(module.exports, "default", () => $1310cf0cbe525930$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $jeyHF = parcelRequire("jeyHF");

var $2usNr = parcelRequire("2usNr");

var $kIbto = parcelRequire("kIbto");

var $ibtdp = parcelRequire("ibtdp");
const $1310cf0cbe525930$var$packageName = undefined;
const $1310cf0cbe525930$var$packageVersion = undefined;
const $1310cf0cbe525930$var$halfFocusRing = 1;
const $1310cf0cbe525930$var$dropOffset = '0, 8';
// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
class $1310cf0cbe525930$var$DropList extends (0, $bSJIT.Component) {
    render() {
        const { children: children, isOpen: isOpen, position: position, trigger: trigger, onPositioned: onPositioned, testId: testId, id: id } = this.props;
        const layerContent = isOpen ? /*#__PURE__*/ (0, $9dQre.jsx)("div", {
            css: this.menuWrapper,
            "data-role": "droplistContent",
            "data-testid": testId && `${testId}--content`,
            ref: this.handleContentRef,
            id: id,
            role: "presentation"
        }, children) : null;
        return /*#__PURE__*/ (0, $9dQre.jsx)("div", {
            css: this.wrapperStyles,
            ref: this.handleDroplistRef
        }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $ibtdp.default), {
            content: layerContent,
            offset: $1310cf0cbe525930$var$dropOffset,
            position: position,
            onPositioned: onPositioned
        }, /*#__PURE__*/ (0, $9dQre.jsx)("div", {
            css: this.triggerStyles,
            ref: this.handleTriggerRef
        }, trigger)));
    }
    constructor(...args){
        super(...args), this.wrapperStyles = /*#__PURE__*/ (0, $9dQre.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            display: this.props.shouldFitContainer ? 'block' : 'inline-flex',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            flex: this.props.shouldFitContainer ? '1 1 auto' : undefined,
            transitionDuration: '0.2s',
            transition: 'box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)'
        }), this.triggerStyles = /*#__PURE__*/ (0, $9dQre.css)({
            transitionDuration: '0.2s',
            transition: 'box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            display: this.props.shouldFitContainer ? 'block' : 'inline-flex',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            boxSizing: this.props.shouldFitContainer ? 'border-box' : undefined
        }), /* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ this.menuWrapper = ()=>{
            return /*#__PURE__*/ (0, $9dQre.css)({
                color: "var(--ds-text-subtle, #505258)",
                backgroundColor: "var(--ds-surface-overlay, #FFFFFF)",
                borderRadius: "var(--ds-radius-small, 3px)",
                boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)",
                boxSizing: 'border-box',
                overflow: 'auto',
                padding: `${"var(--ds-space-050, 4px)"} 0`,
                maxHeight: '90vh'
            });
        }, /* eslint-enable @atlaskit/design-system/ensure-design-token-usage */ this.componentDidMount = ()=>{
            this.setContentWidth();
            // We use a captured event here to avoid a radio or checkbox dropdown item firing its
            // click event first, which would cause a re-render of the element and prevent DropList
            // from detecting the actual source of this original click event.
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('click', this.handleClickOutside, true);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('keydown', this.handleEsc);
        }, this.componentDidUpdate = ()=>{
            if (this.props.isOpen) this.setContentWidth();
        }, this.componentWillUnmount = ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('click', this.handleClickOutside, true);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('keydown', this.handleEsc);
        }, this.setContentWidth = ()=>{
            const { dropContentRef: dropContentRef, triggerRef: triggerRef } = this;
            const { shouldFitContainer: shouldFitContainer } = this.props;
            // We need to manually set the content width to match the trigger width
            if (shouldFitContainer && dropContentRef && triggerRef) dropContentRef.style.width = `${triggerRef.offsetWidth - $1310cf0cbe525930$var$halfFocusRing * 2}px`;
        }, this.handleEsc = (event)=>{
            if ((event.key === 'Escape' || event.key === 'Esc') && this.props.isOpen) this.close(event);
        }, this.handleClickOutside = (event)=>{
            if (this.props.isOpen) {
                if (event.target instanceof Node) {
                    // Rather than check for the target within the entire DropList, we specify the trigger/content.
                    // This aids with future effort in scroll-locking DropList when isMenuFixed is enabled; the scroll
                    // blanket which stretches to the viewport should not stop 'close' from being triggered.
                    const withinTrigger = this.triggerRef && this.triggerRef.contains(event.target);
                    const withinContent = this.dropContentRef && this.dropContentRef.contains(event.target);
                    if (!withinTrigger && !withinContent) this.close(event);
                }
            }
        }, this.close = (event)=>{
            if (this.props.onOpenChange) this.props.onOpenChange({
                isOpen: false,
                event: event
            });
        }, this.handleContentRef = (ref)=>{
            this.dropContentRef = ref;
            // If the dropdown has just been opened, we focus on the containing element so the
            // user can tab to the first dropdown item. We will only receive this ref if isOpen
            // is true or null, so no need to check for truthiness here.
            if (ref) ref.focus();
        }, this.handleDroplistRef = (ref)=>{
            var _this$props$onDroplis, _this$props;
            (_this$props$onDroplis = (_this$props = this.props).onDroplistRef) === null || _this$props$onDroplis === void 0 || _this$props$onDroplis.call(_this$props, ref);
        }, this.handleTriggerRef = (ref)=>{
            this.triggerRef = ref;
        };
    }
}
const $1310cf0cbe525930$var$createAndFireEventOnAtlaskit = (0, $jeyHF.default)('atlaskit');
const $1310cf0cbe525930$var$_default_1 = (0, $2usNr.default)({
    componentName: 'droplist',
    packageName: $1310cf0cbe525930$var$packageName,
    packageVersion: $1310cf0cbe525930$var$packageVersion
})((0, $kIbto.default)({
    onOpenChange: $1310cf0cbe525930$var$createAndFireEventOnAtlaskit({
        action: 'toggled',
        actionSubject: 'droplist',
        attributes: {
            componentName: 'droplist',
            packageName: $1310cf0cbe525930$var$packageName,
            packageVersion: $1310cf0cbe525930$var$packageVersion
        }
    })
})($1310cf0cbe525930$var$DropList));
var $1310cf0cbe525930$export$2e2bcd8739ae039 = $1310cf0cbe525930$var$_default_1;

});
parcelRegister("ibtdp", function(module, exports) {
$parcel$export(module.exports, "default", () => $8afbaa2b5286db3c$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $343Ee = parcelRequire("343Ee");

var $9wZWu = parcelRequire("9wZWu");

var $gdUUy = parcelRequire("gdUUy");

var $ffwxl = parcelRequire("ffwxl");

var $hKfUT = parcelRequire("hKfUT");
const $8afbaa2b5286db3c$var$defaultState = {
    hasExtractedStyles: false,
    // We set these default offsets to prevent a flash of popper content in the wrong position
    // which can cause incorrect height calculations. Popper will calculate these values
    offsets: {
        popper: {
            left: -9999,
            top: -9999,
            position: null
        }
    },
    cssPosition: 'absolute',
    originalHeight: null,
    maxHeight: null
};
function $8afbaa2b5286db3c$var$defaultOnPositioned() {}
const $8afbaa2b5286db3c$var$defaultProps = {
    boundariesElement: 'viewport',
    children: null,
    content: null,
    offset: '0, 0',
    position: 'right middle',
    zIndex: 400,
    lockScroll: false,
    isAlwaysFixed: false,
    onPositioned: $8afbaa2b5286db3c$var$defaultOnPositioned
};
// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
class $8afbaa2b5286db3c$var$LegacyLayer extends (0, $bSJIT.Component) {
    static #_ = // working with extract-react-types
    this.defaultProps = $8afbaa2b5286db3c$var$defaultProps;
    constructor(props){
        super(props), this.targetRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createRef(), this.contentRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createRef(), this.extractStyles = (state)=>{
            if (state) {
                const popperHeight = state.offsets.popper.height;
                const left = Math.round(state.offsets.popper.left);
                const top = Math.round(state.offsets.popper.top);
                const cssPosition = 'absolute';
                const originalHeight = this.state.originalHeight || popperHeight;
                const maxHeight = this.calculateMaxHeight(originalHeight, popperHeight, top, cssPosition);
                this.setState({
                    cssPosition: // position: fixed or absolute
                    cssPosition,
                    hasExtractedStyles: true,
                    transform: `translate3d(${left}px, ${top}px, 0px)`,
                    originalHeight: originalHeight,
                    maxHeight: maxHeight
                });
            }
        };
        this.state = $8afbaa2b5286db3c$var$defaultState;
        this.extractStyles = (0, $9wZWu.default)(this.extractStyles.bind(this));
    }
    componentDidMount() {
        this.applyPopper(this.props);
    }
    componentDidUpdate(prevProps, prevState) {
        const { onPositioned: onPositioned } = this.props;
        const { hasExtractedStyles: hasExtractedStyles } = this.state;
        if (this.props !== prevProps) this.applyPopper(this.props);
        // This flag is set the first time the position is calculated from Popper and applied to the content
        if (!prevState.hasExtractedStyles && hasExtractedStyles && onPositioned) onPositioned();
    }
    componentWillUnmount() {
        // this.extractStyles.cancel();
        if (this.popper) this.popper.destroy();
    }
    /* Calculate the max height of the popper if it's height is greater than the viewport to prevent
   * the bottom of the popper not being viewable.
   * Only works if the popper uses viewport as the boundary and has a fixed position ancestor.
   */ calculateMaxHeight(originalHeight, currentHeight, positionTop, cssPosition) {
        let DocumentElementClientHeight = 0;
        if (document.documentElement) DocumentElementClientHeight = document.documentElement.clientHeight;
        if (cssPosition !== 'fixed') return null;
        const viewportHeight = Math.max(DocumentElementClientHeight, window.innerHeight || 0);
        return viewportHeight < originalHeight && currentHeight + positionTop >= viewportHeight - 50 ? // allow some spacing either side of viewport height
        viewportHeight - 12 : null;
    }
    applyPopper(props) {
        if (!this.targetRef.current || !this.contentRef.current) return;
        if (this.popper) this.popper.destroy();
        // "new Popper(...)" operation is very expensive when called on virtual DOM.
        // This condition reduces the number of calls so we can run our tests faster
        // (time was reduced from 100s to 13s).
        if (!props.content) return;
        // we wrap our target in a div so that we can safely get a reference to it, but we pass the
        // actual target to popper
        const isAlwaysFixed = false;
        const actualTarget = this.targetRef.current.children[0];
        const popperOpts = {
            placement: (0, $hKfUT.positionPropToPopperPosition)(props.position),
            onCreate: this.extractStyles,
            onUpdate: this.extractStyles,
            modifiers: {
                applyStyle: {
                    enabled: false
                },
                hide: {
                    enabled: false
                },
                offset: {
                    enabled: true,
                    offset: this.props.offset
                },
                flip: {
                    enabled: false,
                    flipVariations: true,
                    boundariesElement: 'viewport',
                    padding: 0 // leave 0 pixels between popper and the boundariesElement
                },
                preventOverflow: {
                    enabled: false,
                    escapeWithReference: true
                }
            },
            positionFixed: isAlwaysFixed
        };
        if (actualTarget) this.popper = new (0, $343Ee.default)(actualTarget, this.contentRef.current, popperOpts);
    }
    render() {
        const { transform: transform, hasExtractedStyles: hasExtractedStyles, maxHeight: maxHeight } = this.state;
        const opacity = hasExtractedStyles ? {} : {
            opacity: 0
        };
        return /*#__PURE__*/ (0, $dc70d.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                    ref: this.targetRef,
                    children: this.props.children
                }),
                /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                    ref: this.contentRef,
                    style: {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        top: 0,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        left: 0,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        position: 'absolute',
                        transform: // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        transform,
                        maxHeight: maxHeight ? maxHeight : 'auto',
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        ...opacity
                    },
                    children: this.props.content
                })
            ]
        });
    }
}
function $8afbaa2b5286db3c$var$parseOffset({ offset: offset }) {
    const [rawSkidding, rawDistance] = offset.split(',');
    const skidding = Number.parseFloat(rawSkidding);
    const distance = Number.parseFloat(rawDistance);
    return [
        Number.isFinite(skidding) ? skidding : 0,
        Number.isFinite(distance) ? distance : 0
    ];
}
const $8afbaa2b5286db3c$var$popperInteropModifiers = [
    {
        name: 'flip',
        enabled: false
    },
    {
        name: 'preventOverflow',
        enabled: false
    },
    {
        name: 'hide',
        enabled: false
    }
];
function $8afbaa2b5286db3c$var$usePopperInteropModifiers({ onPositioned: onPositioned }) {
    const onPositionedRef = (0, $bSJIT.useRef)(onPositioned);
    const hasPositionedRef = (0, $bSJIT.useRef)(false);
    (0, $bSJIT.useLayoutEffect)(()=>{
        onPositionedRef.current = onPositioned;
    }, [
        onPositioned
    ]);
    return (0, $bSJIT.useMemo)(()=>[
            ...$8afbaa2b5286db3c$var$popperInteropModifiers,
            {
                name: 'editorLayerFirstPositioned',
                enabled: true,
                // React Popper commits calculated styles in `write`; the legacy callback ran afterwards.
                phase: 'afterWrite',
                fn () {
                    if (hasPositionedRef.current) return;
                    hasPositionedRef.current = true;
                    onPositionedRef.current();
                }
            }
        ], []);
}
function $8afbaa2b5286db3c$var$PopperInterop({ children: children, content: content, offset: offset, onPositioned: onPositioned, position: position, strategy: strategy }) {
    const targetRef = (0, $bSJIT.useRef)(null);
    const [referenceElement, setReferenceElement] = (0, $bSJIT.useState)(null);
    const modifiers = $8afbaa2b5286db3c$var$usePopperInteropModifiers({
        onPositioned: onPositioned
    });
    // Popper v2 compares the offset prop by reference, so memoise to avoid re-running positioning every render.
    const parsedOffset = (0, $bSJIT.useMemo)(()=>$8afbaa2b5286db3c$var$parseOffset({
            offset: offset
        }), [
        offset
    ]);
    (0, $bSJIT.useLayoutEffect)(()=>{
        var _targetRef$current;
        const actualTarget = (_targetRef$current = targetRef.current) === null || _targetRef$current === void 0 ? void 0 : _targetRef$current.children[0];
        setReferenceElement(actualTarget instanceof HTMLElement ? actualTarget : null);
    }, [
        children
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                ref: targetRef,
                children: children
            }),
            content && referenceElement ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $ffwxl.Popper), {
                modifiers: modifiers,
                offset: parsedOffset,
                placement: (0, $hKfUT.positionPropToPopperPosition)(position),
                referenceElement: referenceElement,
                strategy: strategy,
                children: ({ ref: ref, style: style })=>/*#__PURE__*/ (0, $dc70d.jsx)("div", {
                        ref: ref,
                        style: style,
                        children: content
                    })
            }) : /*#__PURE__*/ (0, $dc70d.jsx)("div", {})
        ]
    });
}
function $8afbaa2b5286db3c$export$2e2bcd8739ae039({ children: children = $8afbaa2b5286db3c$var$defaultProps.children, content: content = $8afbaa2b5286db3c$var$defaultProps.content, offset: offset = $8afbaa2b5286db3c$var$defaultProps.offset, onPositioned: onPositioned = $8afbaa2b5286db3c$var$defaultProps.onPositioned, position: position = $8afbaa2b5286db3c$var$defaultProps.position }) {
    if ((0, $gdUUy.fg)('platform-dst-popper-consolidation')) return /*#__PURE__*/ (0, $dc70d.jsx)($8afbaa2b5286db3c$var$PopperInterop, {
        content: content,
        offset: offset,
        onPositioned: onPositioned,
        position: position,
        strategy: "absolute",
        children: children
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)($8afbaa2b5286db3c$var$LegacyLayer, {
        content: content,
        offset: offset,
        onPositioned: onPositioned,
        position: position,
        children: children
    });
}

});
parcelRegister("343Ee", function(module, exports) {
$parcel$export(module.exports, "default", () => $23b4933aa108927a$export$2e2bcd8739ae039);
/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ var $23b4933aa108927a$var$isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';
var $23b4933aa108927a$var$timeoutDuration = function() {
    var longerTimeoutBrowsers = [
        'Edge',
        'Trident',
        'Firefox'
    ];
    for(var i = 0; i < longerTimeoutBrowsers.length; i += 1){
        if ($23b4933aa108927a$var$isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) return 1;
    }
    return 0;
}();
function $23b4933aa108927a$var$microtaskDebounce(fn) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        window.Promise.resolve().then(function() {
            called = false;
            fn();
        });
    };
}
function $23b4933aa108927a$var$taskDebounce(fn) {
    var scheduled = false;
    return function() {
        if (!scheduled) {
            scheduled = true;
            setTimeout(function() {
                scheduled = false;
                fn();
            }, $23b4933aa108927a$var$timeoutDuration);
        }
    };
}
var $23b4933aa108927a$var$supportsMicroTasks = $23b4933aa108927a$var$isBrowser && window.Promise;
/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/ var $23b4933aa108927a$var$debounce = $23b4933aa108927a$var$supportsMicroTasks ? $23b4933aa108927a$var$microtaskDebounce : $23b4933aa108927a$var$taskDebounce;
/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */ function $23b4933aa108927a$var$isFunction(functionToCheck) {
    var getType = {};
    return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}
/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */ function $23b4933aa108927a$var$getStyleComputedProperty(element, property) {
    if (element.nodeType !== 1) return [];
    // NOTE: 1 DOM access here
    var window1 = element.ownerDocument.defaultView;
    var css = window1.getComputedStyle(element, null);
    return property ? css[property] : css;
}
/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */ function $23b4933aa108927a$var$getParentNode(element) {
    if (element.nodeName === 'HTML') return element;
    return element.parentNode || element.host;
}
/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */ function $23b4933aa108927a$var$getScrollParent(element) {
    // Return body, `getScroll` will take care to get the correct `scrollTop` from it
    if (!element) return document.body;
    switch(element.nodeName){
        case 'HTML':
        case 'BODY':
            return element.ownerDocument.body;
        case '#document':
            return element.body;
    }
    // Firefox want us to check `-x` and `-y` variations as well
    var _getStyleComputedProp = $23b4933aa108927a$var$getStyleComputedProperty(element), overflow = _getStyleComputedProp.overflow, overflowX = _getStyleComputedProp.overflowX, overflowY = _getStyleComputedProp.overflowY;
    if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) return element;
    return $23b4933aa108927a$var$getScrollParent($23b4933aa108927a$var$getParentNode(element));
}
/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */ function $23b4933aa108927a$var$getReferenceNode(reference) {
    return reference && reference.referenceNode ? reference.referenceNode : reference;
}
var $23b4933aa108927a$var$isIE11 = $23b4933aa108927a$var$isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var $23b4933aa108927a$var$isIE10 = $23b4933aa108927a$var$isBrowser && /MSIE 10/.test(navigator.userAgent);
/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */ function $23b4933aa108927a$var$isIE(version) {
    if (version === 11) return $23b4933aa108927a$var$isIE11;
    if (version === 10) return $23b4933aa108927a$var$isIE10;
    return $23b4933aa108927a$var$isIE11 || $23b4933aa108927a$var$isIE10;
}
/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */ function $23b4933aa108927a$var$getOffsetParent(element) {
    if (!element) return document.documentElement;
    var noOffsetParent = $23b4933aa108927a$var$isIE(10) ? document.body : null;
    // NOTE: 1 DOM access here
    var offsetParent = element.offsetParent || null;
    // Skip hidden elements which don't have an offsetParent
    while(offsetParent === noOffsetParent && element.nextElementSibling)offsetParent = (element = element.nextElementSibling).offsetParent;
    var nodeName = offsetParent && offsetParent.nodeName;
    if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') return element ? element.ownerDocument.documentElement : document.documentElement;
    // .offsetParent will return the closest TH, TD or TABLE in case
    // no offsetParent is present, I hate this job...
    if ([
        'TH',
        'TD',
        'TABLE'
    ].indexOf(offsetParent.nodeName) !== -1 && $23b4933aa108927a$var$getStyleComputedProperty(offsetParent, 'position') === 'static') return $23b4933aa108927a$var$getOffsetParent(offsetParent);
    return offsetParent;
}
function $23b4933aa108927a$var$isOffsetContainer(element) {
    var nodeName = element.nodeName;
    if (nodeName === 'BODY') return false;
    return nodeName === 'HTML' || $23b4933aa108927a$var$getOffsetParent(element.firstElementChild) === element;
}
/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */ function $23b4933aa108927a$var$getRoot(node) {
    if (node.parentNode !== null) return $23b4933aa108927a$var$getRoot(node.parentNode);
    return node;
}
/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */ function $23b4933aa108927a$var$findCommonOffsetParent(element1, element2) {
    // This check is needed to avoid errors in case one of the elements isn't defined for any reason
    if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) return document.documentElement;
    // Here we make sure to give as "start" the element that comes first in the DOM
    var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
    var start = order ? element1 : element2;
    var end = order ? element2 : element1;
    // Get common ancestor container
    var range = document.createRange();
    range.setStart(start, 0);
    range.setEnd(end, 0);
    var commonAncestorContainer = range.commonAncestorContainer;
    // Both nodes are inside #document
    if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
        if ($23b4933aa108927a$var$isOffsetContainer(commonAncestorContainer)) return commonAncestorContainer;
        return $23b4933aa108927a$var$getOffsetParent(commonAncestorContainer);
    }
    // one of the nodes is inside shadowDOM, find which one
    var element1root = $23b4933aa108927a$var$getRoot(element1);
    if (element1root.host) return $23b4933aa108927a$var$findCommonOffsetParent(element1root.host, element2);
    else return $23b4933aa108927a$var$findCommonOffsetParent(element1, $23b4933aa108927a$var$getRoot(element2).host);
}
/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */ function $23b4933aa108927a$var$getScroll(element) {
    var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
    var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
    var nodeName = element.nodeName;
    if (nodeName === 'BODY' || nodeName === 'HTML') {
        var html = element.ownerDocument.documentElement;
        var scrollingElement = element.ownerDocument.scrollingElement || html;
        return scrollingElement[upperSide];
    }
    return element[upperSide];
}
/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */ function $23b4933aa108927a$var$includeScroll(rect, element) {
    var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var scrollTop = $23b4933aa108927a$var$getScroll(element, 'top');
    var scrollLeft = $23b4933aa108927a$var$getScroll(element, 'left');
    var modifier = subtract ? -1 : 1;
    rect.top += scrollTop * modifier;
    rect.bottom += scrollTop * modifier;
    rect.left += scrollLeft * modifier;
    rect.right += scrollLeft * modifier;
    return rect;
}
/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */ function $23b4933aa108927a$var$getBordersSize(styles, axis) {
    var sideA = axis === 'x' ? 'Left' : 'Top';
    var sideB = sideA === 'Left' ? 'Right' : 'Bottom';
    return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
}
function $23b4933aa108927a$var$getSize(axis, body, html, computedStyle) {
    return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], $23b4933aa108927a$var$isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}
function $23b4933aa108927a$var$getWindowSizes(document1) {
    var body = document1.body;
    var html = document1.documentElement;
    var computedStyle = $23b4933aa108927a$var$isIE(10) && getComputedStyle(html);
    return {
        height: $23b4933aa108927a$var$getSize('Height', body, html, computedStyle),
        width: $23b4933aa108927a$var$getSize('Width', body, html, computedStyle)
    };
}
var $23b4933aa108927a$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $23b4933aa108927a$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $23b4933aa108927a$var$defineProperty = function(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
};
var $23b4933aa108927a$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */ function $23b4933aa108927a$var$getClientRect(offsets) {
    return $23b4933aa108927a$var$_extends({}, offsets, {
        right: offsets.left + offsets.width,
        bottom: offsets.top + offsets.height
    });
}
/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */ function $23b4933aa108927a$var$getBoundingClientRect(element) {
    var rect = {};
    // IE10 10 FIX: Please, don't ask, the element isn't
    // considered in DOM in some circumstances...
    // This isn't reproducible in IE10 compatibility mode of IE11
    try {
        if ($23b4933aa108927a$var$isIE(10)) {
            rect = element.getBoundingClientRect();
            var scrollTop = $23b4933aa108927a$var$getScroll(element, 'top');
            var scrollLeft = $23b4933aa108927a$var$getScroll(element, 'left');
            rect.top += scrollTop;
            rect.left += scrollLeft;
            rect.bottom += scrollTop;
            rect.right += scrollLeft;
        } else rect = element.getBoundingClientRect();
    } catch (e) {}
    var result = {
        left: rect.left,
        top: rect.top,
        width: rect.right - rect.left,
        height: rect.bottom - rect.top
    };
    // subtract scrollbar size from sizes
    var sizes = element.nodeName === 'HTML' ? $23b4933aa108927a$var$getWindowSizes(element.ownerDocument) : {};
    var width = sizes.width || element.clientWidth || result.width;
    var height = sizes.height || element.clientHeight || result.height;
    var horizScrollbar = element.offsetWidth - width;
    var vertScrollbar = element.offsetHeight - height;
    // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
    // we make this check conditional for performance reasons
    if (horizScrollbar || vertScrollbar) {
        var styles = $23b4933aa108927a$var$getStyleComputedProperty(element);
        horizScrollbar -= $23b4933aa108927a$var$getBordersSize(styles, 'x');
        vertScrollbar -= $23b4933aa108927a$var$getBordersSize(styles, 'y');
        result.width -= horizScrollbar;
        result.height -= vertScrollbar;
    }
    return $23b4933aa108927a$var$getClientRect(result);
}
function $23b4933aa108927a$var$getOffsetRectRelativeToArbitraryNode(children, parent) {
    var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isIE10 = $23b4933aa108927a$var$isIE(10);
    var isHTML = parent.nodeName === 'HTML';
    var childrenRect = $23b4933aa108927a$var$getBoundingClientRect(children);
    var parentRect = $23b4933aa108927a$var$getBoundingClientRect(parent);
    var scrollParent = $23b4933aa108927a$var$getScrollParent(children);
    var styles = $23b4933aa108927a$var$getStyleComputedProperty(parent);
    var borderTopWidth = parseFloat(styles.borderTopWidth);
    var borderLeftWidth = parseFloat(styles.borderLeftWidth);
    // In cases where the parent is fixed, we must ignore negative scroll in offset calc
    if (fixedPosition && isHTML) {
        parentRect.top = Math.max(parentRect.top, 0);
        parentRect.left = Math.max(parentRect.left, 0);
    }
    var offsets = $23b4933aa108927a$var$getClientRect({
        top: childrenRect.top - parentRect.top - borderTopWidth,
        left: childrenRect.left - parentRect.left - borderLeftWidth,
        width: childrenRect.width,
        height: childrenRect.height
    });
    offsets.marginTop = 0;
    offsets.marginLeft = 0;
    // Subtract margins of documentElement in case it's being used as parent
    // we do this only on HTML because it's the only element that behaves
    // differently when margins are applied to it. The margins are included in
    // the box of the documentElement, in the other cases not.
    if (!isIE10 && isHTML) {
        var marginTop = parseFloat(styles.marginTop);
        var marginLeft = parseFloat(styles.marginLeft);
        offsets.top -= borderTopWidth - marginTop;
        offsets.bottom -= borderTopWidth - marginTop;
        offsets.left -= borderLeftWidth - marginLeft;
        offsets.right -= borderLeftWidth - marginLeft;
        // Attach marginTop and marginLeft because in some circumstances we may need them
        offsets.marginTop = marginTop;
        offsets.marginLeft = marginLeft;
    }
    if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') offsets = $23b4933aa108927a$var$includeScroll(offsets, parent);
    return offsets;
}
function $23b4933aa108927a$var$getViewportOffsetRectRelativeToArtbitraryNode(element) {
    var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var html = element.ownerDocument.documentElement;
    var relativeOffset = $23b4933aa108927a$var$getOffsetRectRelativeToArbitraryNode(element, html);
    var width = Math.max(html.clientWidth, window.innerWidth || 0);
    var height = Math.max(html.clientHeight, window.innerHeight || 0);
    var scrollTop = !excludeScroll ? $23b4933aa108927a$var$getScroll(html) : 0;
    var scrollLeft = !excludeScroll ? $23b4933aa108927a$var$getScroll(html, 'left') : 0;
    var offset = {
        top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
        left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
        width: width,
        height: height
    };
    return $23b4933aa108927a$var$getClientRect(offset);
}
/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */ function $23b4933aa108927a$var$isFixed(element) {
    var nodeName = element.nodeName;
    if (nodeName === 'BODY' || nodeName === 'HTML') return false;
    if ($23b4933aa108927a$var$getStyleComputedProperty(element, 'position') === 'fixed') return true;
    var parentNode = $23b4933aa108927a$var$getParentNode(element);
    if (!parentNode) return false;
    return $23b4933aa108927a$var$isFixed(parentNode);
}
/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */ function $23b4933aa108927a$var$getFixedPositionOffsetParent(element) {
    // This check is needed to avoid errors in case one of the elements isn't defined for any reason
    if (!element || !element.parentElement || $23b4933aa108927a$var$isIE()) return document.documentElement;
    var el = element.parentElement;
    while(el && $23b4933aa108927a$var$getStyleComputedProperty(el, 'transform') === 'none')el = el.parentElement;
    return el || document.documentElement;
}
/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */ function $23b4933aa108927a$var$getBoundaries(popper, reference, padding, boundariesElement) {
    var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    // NOTE: 1 DOM access here
    var boundaries = {
        top: 0,
        left: 0
    };
    var offsetParent = fixedPosition ? $23b4933aa108927a$var$getFixedPositionOffsetParent(popper) : $23b4933aa108927a$var$findCommonOffsetParent(popper, $23b4933aa108927a$var$getReferenceNode(reference));
    // Handle viewport case
    if (boundariesElement === 'viewport') boundaries = $23b4933aa108927a$var$getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
    else {
        // Handle other cases based on DOM element used as boundaries
        var boundariesNode = void 0;
        if (boundariesElement === 'scrollParent') {
            boundariesNode = $23b4933aa108927a$var$getScrollParent($23b4933aa108927a$var$getParentNode(reference));
            if (boundariesNode.nodeName === 'BODY') boundariesNode = popper.ownerDocument.documentElement;
        } else if (boundariesElement === 'window') boundariesNode = popper.ownerDocument.documentElement;
        else boundariesNode = boundariesElement;
        var offsets = $23b4933aa108927a$var$getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);
        // In case of HTML, we need a different computation
        if (boundariesNode.nodeName === 'HTML' && !$23b4933aa108927a$var$isFixed(offsetParent)) {
            var _getWindowSizes = $23b4933aa108927a$var$getWindowSizes(popper.ownerDocument), height = _getWindowSizes.height, width = _getWindowSizes.width;
            boundaries.top += offsets.top - offsets.marginTop;
            boundaries.bottom = height + offsets.top;
            boundaries.left += offsets.left - offsets.marginLeft;
            boundaries.right = width + offsets.left;
        } else // for all the other DOM elements, this one is good
        boundaries = offsets;
    }
    // Add paddings
    padding = padding || 0;
    var isPaddingNumber = typeof padding === 'number';
    boundaries.left += isPaddingNumber ? padding : padding.left || 0;
    boundaries.top += isPaddingNumber ? padding : padding.top || 0;
    boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
    boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;
    return boundaries;
}
function $23b4933aa108927a$var$getArea(_ref) {
    var width = _ref.width, height = _ref.height;
    return width * height;
}
/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $23b4933aa108927a$var$computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
    var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
    if (placement.indexOf('auto') === -1) return placement;
    var boundaries = $23b4933aa108927a$var$getBoundaries(popper, reference, padding, boundariesElement);
    var rects = {
        top: {
            width: boundaries.width,
            height: refRect.top - boundaries.top
        },
        right: {
            width: boundaries.right - refRect.right,
            height: boundaries.height
        },
        bottom: {
            width: boundaries.width,
            height: boundaries.bottom - refRect.bottom
        },
        left: {
            width: refRect.left - boundaries.left,
            height: boundaries.height
        }
    };
    var sortedAreas = Object.keys(rects).map(function(key) {
        return $23b4933aa108927a$var$_extends({
            key: key
        }, rects[key], {
            area: $23b4933aa108927a$var$getArea(rects[key])
        });
    }).sort(function(a, b) {
        return b.area - a.area;
    });
    var filteredAreas = sortedAreas.filter(function(_ref2) {
        var width = _ref2.width, height = _ref2.height;
        return width >= popper.clientWidth && height >= popper.clientHeight;
    });
    var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
    var variation = placement.split('-')[1];
    return computedPlacement + (variation ? '-' + variation : '');
}
/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */ function $23b4933aa108927a$var$getReferenceOffsets(state, popper, reference) {
    var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var commonOffsetParent = fixedPosition ? $23b4933aa108927a$var$getFixedPositionOffsetParent(popper) : $23b4933aa108927a$var$findCommonOffsetParent(popper, $23b4933aa108927a$var$getReferenceNode(reference));
    return $23b4933aa108927a$var$getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}
/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */ function $23b4933aa108927a$var$getOuterSizes(element) {
    var window1 = element.ownerDocument.defaultView;
    var styles = window1.getComputedStyle(element);
    var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
    var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
    var result = {
        width: element.offsetWidth + y,
        height: element.offsetHeight + x
    };
    return result;
}
/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */ function $23b4933aa108927a$var$getOppositePlacement(placement) {
    var hash = {
        left: 'right',
        right: 'left',
        bottom: 'top',
        top: 'bottom'
    };
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return hash[matched];
    });
}
/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */ function $23b4933aa108927a$var$getPopperOffsets(popper, referenceOffsets, placement) {
    placement = placement.split('-')[0];
    // Get popper node sizes
    var popperRect = $23b4933aa108927a$var$getOuterSizes(popper);
    // Add position, width and height to our offsets object
    var popperOffsets = {
        width: popperRect.width,
        height: popperRect.height
    };
    // depending by the popper placement we have to compute its offsets slightly differently
    var isHoriz = [
        'right',
        'left'
    ].indexOf(placement) !== -1;
    var mainSide = isHoriz ? 'top' : 'left';
    var secondarySide = isHoriz ? 'left' : 'top';
    var measurement = isHoriz ? 'height' : 'width';
    var secondaryMeasurement = !isHoriz ? 'height' : 'width';
    popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
    if (placement === secondarySide) popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
    else popperOffsets[secondarySide] = referenceOffsets[$23b4933aa108927a$var$getOppositePlacement(secondarySide)];
    return popperOffsets;
}
/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */ function $23b4933aa108927a$var$find(arr, check) {
    // use native find if supported
    if (Array.prototype.find) return arr.find(check);
    // use `filter` to obtain the same behavior of `find`
    return arr.filter(check)[0];
}
/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */ function $23b4933aa108927a$var$findIndex(arr, prop, value) {
    // use native findIndex if supported
    if (Array.prototype.findIndex) return arr.findIndex(function(cur) {
        return cur[prop] === value;
    });
    // use `find` + `indexOf` if `findIndex` isn't supported
    var match = $23b4933aa108927a$var$find(arr, function(obj) {
        return obj[prop] === value;
    });
    return arr.indexOf(match);
}
/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */ function $23b4933aa108927a$var$runModifiers(modifiers, data, ends) {
    var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, $23b4933aa108927a$var$findIndex(modifiers, 'name', ends));
    modifiersToRun.forEach(function(modifier) {
        if (modifier['function']) // eslint-disable-line dot-notation
        console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
        var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
        if (modifier.enabled && $23b4933aa108927a$var$isFunction(fn)) {
            // Add properties to offsets to make them a complete clientRect object
            // we do this before each modifier to make sure the previous one doesn't
            // mess with these values
            data.offsets.popper = $23b4933aa108927a$var$getClientRect(data.offsets.popper);
            data.offsets.reference = $23b4933aa108927a$var$getClientRect(data.offsets.reference);
            data = fn(data, modifier);
        }
    });
    return data;
}
/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */ function $23b4933aa108927a$var$update() {
    // if popper is destroyed, don't perform any further update
    if (this.state.isDestroyed) return;
    var data = {
        instance: this,
        styles: {},
        arrowStyles: {},
        attributes: {},
        flipped: false,
        offsets: {}
    };
    // compute reference element offsets
    data.offsets.reference = $23b4933aa108927a$var$getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);
    // compute auto placement, store placement inside the data object,
    // modifiers will be able to edit `placement` if needed
    // and refer to originalPlacement to know the original value
    data.placement = $23b4933aa108927a$var$computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);
    // store the computed placement inside `originalPlacement`
    data.originalPlacement = data.placement;
    data.positionFixed = this.options.positionFixed;
    // compute the popper offsets
    data.offsets.popper = $23b4933aa108927a$var$getPopperOffsets(this.popper, data.offsets.reference, data.placement);
    data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';
    // run the modifiers
    data = $23b4933aa108927a$var$runModifiers(this.modifiers, data);
    // the first `update` will call `onCreate` callback
    // the other ones will call `onUpdate` callback
    if (!this.state.isCreated) {
        this.state.isCreated = true;
        this.options.onCreate(data);
    } else this.options.onUpdate(data);
}
/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */ function $23b4933aa108927a$var$isModifierEnabled(modifiers, modifierName) {
    return modifiers.some(function(_ref) {
        var name = _ref.name, enabled = _ref.enabled;
        return enabled && name === modifierName;
    });
}
/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */ function $23b4933aa108927a$var$getSupportedPropertyName(property) {
    var prefixes = [
        false,
        'ms',
        'Webkit',
        'Moz',
        'O'
    ];
    var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
    for(var i = 0; i < prefixes.length; i++){
        var prefix = prefixes[i];
        var toCheck = prefix ? '' + prefix + upperProp : property;
        if (typeof document.body.style[toCheck] !== 'undefined') return toCheck;
    }
    return null;
}
/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */ function $23b4933aa108927a$var$destroy() {
    this.state.isDestroyed = true;
    // touch DOM only if `applyStyle` modifier is enabled
    if ($23b4933aa108927a$var$isModifierEnabled(this.modifiers, 'applyStyle')) {
        this.popper.removeAttribute('x-placement');
        this.popper.style.position = '';
        this.popper.style.top = '';
        this.popper.style.left = '';
        this.popper.style.right = '';
        this.popper.style.bottom = '';
        this.popper.style.willChange = '';
        this.popper.style[$23b4933aa108927a$var$getSupportedPropertyName('transform')] = '';
    }
    this.disableEventListeners();
    // remove the popper if user explicitly asked for the deletion on destroy
    // do not use `remove` because IE11 doesn't support it
    if (this.options.removeOnDestroy) this.popper.parentNode.removeChild(this.popper);
    return this;
}
/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */ function $23b4933aa108927a$var$getWindow(element) {
    var ownerDocument = element.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView : window;
}
function $23b4933aa108927a$var$attachToScrollParents(scrollParent, event, callback, scrollParents) {
    var isBody = scrollParent.nodeName === 'BODY';
    var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
    target.addEventListener(event, callback, {
        passive: true
    });
    if (!isBody) $23b4933aa108927a$var$attachToScrollParents($23b4933aa108927a$var$getScrollParent(target.parentNode), event, callback, scrollParents);
    scrollParents.push(target);
}
/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */ function $23b4933aa108927a$var$setupEventListeners(reference, options, state, updateBound) {
    // Resize event listener on window
    state.updateBound = updateBound;
    $23b4933aa108927a$var$getWindow(reference).addEventListener('resize', state.updateBound, {
        passive: true
    });
    // Scroll event listener on scroll parents
    var scrollElement = $23b4933aa108927a$var$getScrollParent(reference);
    $23b4933aa108927a$var$attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
    state.scrollElement = scrollElement;
    state.eventsEnabled = true;
    return state;
}
/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */ function $23b4933aa108927a$var$enableEventListeners() {
    if (!this.state.eventsEnabled) this.state = $23b4933aa108927a$var$setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
}
/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */ function $23b4933aa108927a$var$removeEventListeners(reference, state) {
    // Remove resize event listener on window
    $23b4933aa108927a$var$getWindow(reference).removeEventListener('resize', state.updateBound);
    // Remove scroll event listener on scroll parents
    state.scrollParents.forEach(function(target) {
        target.removeEventListener('scroll', state.updateBound);
    });
    // Reset state
    state.updateBound = null;
    state.scrollParents = [];
    state.scrollElement = null;
    state.eventsEnabled = false;
    return state;
}
/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */ function $23b4933aa108927a$var$disableEventListeners() {
    if (this.state.eventsEnabled) {
        cancelAnimationFrame(this.scheduleUpdate);
        this.state = $23b4933aa108927a$var$removeEventListeners(this.reference, this.state);
    }
}
/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */ function $23b4933aa108927a$var$isNumeric(n) {
    return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}
/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */ function $23b4933aa108927a$var$setStyles(element, styles) {
    Object.keys(styles).forEach(function(prop) {
        var unit = '';
        // add unit if the value is numeric and is one of the following
        if ([
            'width',
            'height',
            'top',
            'right',
            'bottom',
            'left'
        ].indexOf(prop) !== -1 && $23b4933aa108927a$var$isNumeric(styles[prop])) unit = 'px';
        element.style[prop] = styles[prop] + unit;
    });
}
/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */ function $23b4933aa108927a$var$setAttributes(element, attributes) {
    Object.keys(attributes).forEach(function(prop) {
        var value = attributes[prop];
        if (value !== false) element.setAttribute(prop, attributes[prop]);
        else element.removeAttribute(prop);
    });
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */ function $23b4933aa108927a$var$applyStyle(data) {
    // any property present in `data.styles` will be applied to the popper,
    // in this way we can make the 3rd party modifiers add custom styles to it
    // Be aware, modifiers could override the properties defined in the previous
    // lines of this modifier!
    $23b4933aa108927a$var$setStyles(data.instance.popper, data.styles);
    // any property present in `data.attributes` will be applied to the popper,
    // they will be set as HTML attributes of the element
    $23b4933aa108927a$var$setAttributes(data.instance.popper, data.attributes);
    // if arrowElement is defined and arrowStyles has some properties
    if (data.arrowElement && Object.keys(data.arrowStyles).length) $23b4933aa108927a$var$setStyles(data.arrowElement, data.arrowStyles);
    return data;
}
/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */ function $23b4933aa108927a$var$applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
    // compute reference element offsets
    var referenceOffsets = $23b4933aa108927a$var$getReferenceOffsets(state, popper, reference, options.positionFixed);
    // compute auto placement, store placement inside the data object,
    // modifiers will be able to edit `placement` if needed
    // and refer to originalPlacement to know the original value
    var placement = $23b4933aa108927a$var$computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
    popper.setAttribute('x-placement', placement);
    // Apply `position` to popper before anything else because
    // without the position applied we can't guarantee correct computations
    $23b4933aa108927a$var$setStyles(popper, {
        position: options.positionFixed ? 'fixed' : 'absolute'
    });
    return options;
}
/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */ function $23b4933aa108927a$var$getRoundedOffsets(data, shouldRound) {
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var round = Math.round, floor = Math.floor;
    var noRound = function noRound(v) {
        return v;
    };
    var referenceWidth = round(reference.width);
    var popperWidth = round(popper.width);
    var isVertical = [
        'left',
        'right'
    ].indexOf(data.placement) !== -1;
    var isVariation = data.placement.indexOf('-') !== -1;
    var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
    var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;
    var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
    var verticalToInteger = !shouldRound ? noRound : round;
    return {
        left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
        top: verticalToInteger(popper.top),
        bottom: verticalToInteger(popper.bottom),
        right: horizontalToInteger(popper.right)
    };
}
var $23b4933aa108927a$var$isFirefox = $23b4933aa108927a$var$isBrowser && /Firefox/i.test(navigator.userAgent);
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $23b4933aa108927a$var$computeStyle(data, options) {
    var x = options.x, y = options.y;
    var popper = data.offsets.popper;
    // Remove this legacy support in Popper.js v2
    var legacyGpuAccelerationOption = $23b4933aa108927a$var$find(data.instance.modifiers, function(modifier) {
        return modifier.name === 'applyStyle';
    }).gpuAcceleration;
    if (legacyGpuAccelerationOption !== undefined) console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
    var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
    var offsetParent = $23b4933aa108927a$var$getOffsetParent(data.instance.popper);
    var offsetParentRect = $23b4933aa108927a$var$getBoundingClientRect(offsetParent);
    // Styles
    var styles = {
        position: popper.position
    };
    var offsets = $23b4933aa108927a$var$getRoundedOffsets(data, window.devicePixelRatio < 2 || !$23b4933aa108927a$var$isFirefox);
    var sideA = x === 'bottom' ? 'top' : 'bottom';
    var sideB = y === 'right' ? 'left' : 'right';
    // if gpuAcceleration is set to `true` and transform is supported,
    //  we use `translate3d` to apply the position to the popper we
    // automatically use the supported prefixed version if needed
    var prefixedProperty = $23b4933aa108927a$var$getSupportedPropertyName('transform');
    // now, let's make a step back and look at this code closely (wtf?)
    // If the content of the popper grows once it's been positioned, it
    // may happen that the popper gets misplaced because of the new content
    // overflowing its reference element
    // To avoid this problem, we provide two options (x and y), which allow
    // the consumer to define the offset origin.
    // If we position a popper on top of a reference element, we can set
    // `x` to `top` to make the popper grow towards its top instead of
    // its bottom.
    var left = void 0, top = void 0;
    if (sideA === 'bottom') {
        // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
        // and not the bottom of the html element
        if (offsetParent.nodeName === 'HTML') top = -offsetParent.clientHeight + offsets.bottom;
        else top = -offsetParentRect.height + offsets.bottom;
    } else top = offsets.top;
    if (sideB === 'right') {
        if (offsetParent.nodeName === 'HTML') left = -offsetParent.clientWidth + offsets.right;
        else left = -offsetParentRect.width + offsets.right;
    } else left = offsets.left;
    if (gpuAcceleration && prefixedProperty) {
        styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
        styles[sideA] = 0;
        styles[sideB] = 0;
        styles.willChange = 'transform';
    } else {
        // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
        var invertTop = sideA === 'bottom' ? -1 : 1;
        var invertLeft = sideB === 'right' ? -1 : 1;
        styles[sideA] = top * invertTop;
        styles[sideB] = left * invertLeft;
        styles.willChange = sideA + ', ' + sideB;
    }
    // Attributes
    var attributes = {
        'x-placement': data.placement
    };
    // Update `data` attributes, styles and arrowStyles
    data.attributes = $23b4933aa108927a$var$_extends({}, attributes, data.attributes);
    data.styles = $23b4933aa108927a$var$_extends({}, styles, data.styles);
    data.arrowStyles = $23b4933aa108927a$var$_extends({}, data.offsets.arrow, data.arrowStyles);
    return data;
}
/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */ function $23b4933aa108927a$var$isModifierRequired(modifiers, requestingName, requestedName) {
    var requesting = $23b4933aa108927a$var$find(modifiers, function(_ref) {
        var name = _ref.name;
        return name === requestingName;
    });
    var isRequired = !!requesting && modifiers.some(function(modifier) {
        return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
    });
    if (!isRequired) {
        var _requesting = '`' + requestingName + '`';
        var requested = '`' + requestedName + '`';
        console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
    }
    return isRequired;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $23b4933aa108927a$var$arrow(data, options) {
    var _data$offsets$arrow;
    // arrow depends on keepTogether in order to work
    if (!$23b4933aa108927a$var$isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) return data;
    var arrowElement = options.element;
    // if arrowElement is a string, suppose it's a CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = data.instance.popper.querySelector(arrowElement);
        // if arrowElement is not found, don't run the modifier
        if (!arrowElement) return data;
    } else // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
        console.warn('WARNING: `arrow.element` must be child of its popper element!');
        return data;
    }
    var placement = data.placement.split('-')[0];
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var isVertical = [
        'left',
        'right'
    ].indexOf(placement) !== -1;
    var len = isVertical ? 'height' : 'width';
    var sideCapitalized = isVertical ? 'Top' : 'Left';
    var side = sideCapitalized.toLowerCase();
    var altSide = isVertical ? 'left' : 'top';
    var opSide = isVertical ? 'bottom' : 'right';
    var arrowElementSize = $23b4933aa108927a$var$getOuterSizes(arrowElement)[len];
    //
    // extends keepTogether behavior making sure the popper and its
    // reference have enough pixels in conjunction
    //
    // top/left side
    if (reference[opSide] - arrowElementSize < popper[side]) data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
    // bottom/right side
    if (reference[side] + arrowElementSize > popper[opSide]) data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
    data.offsets.popper = $23b4933aa108927a$var$getClientRect(data.offsets.popper);
    // compute center of the popper
    var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;
    // Compute the sideValue using the updated popper offsets
    // take popper margin in account because we don't have this info available
    var css = $23b4933aa108927a$var$getStyleComputedProperty(data.instance.popper);
    var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
    var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
    var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;
    // prevent arrowElement from being placed not contiguously to its popper
    sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
    data.arrowElement = arrowElement;
    data.offsets.arrow = (_data$offsets$arrow = {}, $23b4933aa108927a$var$defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), $23b4933aa108927a$var$defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);
    return data;
}
/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */ function $23b4933aa108927a$var$getOppositeVariation(variation) {
    if (variation === 'end') return 'start';
    else if (variation === 'start') return 'end';
    return variation;
}
/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */ var $23b4933aa108927a$var$placements = [
    'auto-start',
    'auto',
    'auto-end',
    'top-start',
    'top',
    'top-end',
    'right-start',
    'right',
    'right-end',
    'bottom-end',
    'bottom',
    'bottom-start',
    'left-end',
    'left',
    'left-start'
];
// Get rid of `auto` `auto-start` and `auto-end`
var $23b4933aa108927a$var$validPlacements = $23b4933aa108927a$var$placements.slice(3);
/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */ function $23b4933aa108927a$var$clockwise(placement) {
    var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var index = $23b4933aa108927a$var$validPlacements.indexOf(placement);
    var arr = $23b4933aa108927a$var$validPlacements.slice(index + 1).concat($23b4933aa108927a$var$validPlacements.slice(0, index));
    return counter ? arr.reverse() : arr;
}
var $23b4933aa108927a$var$BEHAVIORS = {
    FLIP: 'flip',
    CLOCKWISE: 'clockwise',
    COUNTERCLOCKWISE: 'counterclockwise'
};
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $23b4933aa108927a$var$flip(data, options) {
    // if `inner` modifier is enabled, we can't use the `flip` modifier
    if ($23b4933aa108927a$var$isModifierEnabled(data.instance.modifiers, 'inner')) return data;
    if (data.flipped && data.placement === data.originalPlacement) // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
    var boundaries = $23b4933aa108927a$var$getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
    var placement = data.placement.split('-')[0];
    var placementOpposite = $23b4933aa108927a$var$getOppositePlacement(placement);
    var variation = data.placement.split('-')[1] || '';
    var flipOrder = [];
    switch(options.behavior){
        case $23b4933aa108927a$var$BEHAVIORS.FLIP:
            flipOrder = [
                placement,
                placementOpposite
            ];
            break;
        case $23b4933aa108927a$var$BEHAVIORS.CLOCKWISE:
            flipOrder = $23b4933aa108927a$var$clockwise(placement);
            break;
        case $23b4933aa108927a$var$BEHAVIORS.COUNTERCLOCKWISE:
            flipOrder = $23b4933aa108927a$var$clockwise(placement, true);
            break;
        default:
            flipOrder = options.behavior;
    }
    flipOrder.forEach(function(step, index) {
        if (placement !== step || flipOrder.length === index + 1) return data;
        placement = data.placement.split('-')[0];
        placementOpposite = $23b4933aa108927a$var$getOppositePlacement(placement);
        var popperOffsets = data.offsets.popper;
        var refOffsets = data.offsets.reference;
        // using floor because the reference offsets may contain decimals we are not going to consider here
        var floor = Math.floor;
        var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);
        var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
        var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
        var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
        var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
        var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;
        // flip the variation if required
        var isVertical = [
            'top',
            'bottom'
        ].indexOf(placement) !== -1;
        // flips variation if reference element overflows boundaries
        var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);
        // flips variation if popper content overflows boundaries
        var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);
        var flippedVariation = flippedVariationByRef || flippedVariationByContent;
        if (overlapsRef || overflowsBoundaries || flippedVariation) {
            // this boolean to detect any flip loop
            data.flipped = true;
            if (overlapsRef || overflowsBoundaries) placement = flipOrder[index + 1];
            if (flippedVariation) variation = $23b4933aa108927a$var$getOppositeVariation(variation);
            data.placement = placement + (variation ? '-' + variation : '');
            // this object contains `position`, we want to preserve it along with
            // any additional property we may add in the future
            data.offsets.popper = $23b4933aa108927a$var$_extends({}, data.offsets.popper, $23b4933aa108927a$var$getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
            data = $23b4933aa108927a$var$runModifiers(data.instance.modifiers, data, 'flip');
        }
    });
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $23b4933aa108927a$var$keepTogether(data) {
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var placement = data.placement.split('-')[0];
    var floor = Math.floor;
    var isVertical = [
        'top',
        'bottom'
    ].indexOf(placement) !== -1;
    var side = isVertical ? 'right' : 'bottom';
    var opSide = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';
    if (popper[side] < floor(reference[opSide])) data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
    if (popper[opSide] > floor(reference[side])) data.offsets.popper[opSide] = floor(reference[side]);
    return data;
}
/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */ function $23b4933aa108927a$var$toValue(str, measurement, popperOffsets, referenceOffsets) {
    // separate value from unit
    var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
    var value = +split[1];
    var unit = split[2];
    // If it's not a number it's an operator, I guess
    if (!value) return str;
    if (unit.indexOf('%') === 0) {
        var element = void 0;
        switch(unit){
            case '%p':
                element = popperOffsets;
                break;
            case '%':
            case '%r':
            default:
                element = referenceOffsets;
        }
        var rect = $23b4933aa108927a$var$getClientRect(element);
        return rect[measurement] / 100 * value;
    } else if (unit === 'vh' || unit === 'vw') {
        // if is a vh or vw, we calculate the size based on the viewport
        var size = void 0;
        if (unit === 'vh') size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        else size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        return size / 100 * value;
    } else // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
}
/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */ function $23b4933aa108927a$var$parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
    var offsets = [
        0,
        0
    ];
    // Use height if placement is left or right and index is 0 otherwise use width
    // in this way the first offset will use an axis and the second one
    // will use the other one
    var useHeight = [
        'right',
        'left'
    ].indexOf(basePlacement) !== -1;
    // Split the offset string to obtain a list of values and operands
    // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
    var fragments = offset.split(/(\+|\-)/).map(function(frag) {
        return frag.trim();
    });
    // Detect if the offset string contains a pair of values or a single one
    // they could be separated by comma or space
    var divider = fragments.indexOf($23b4933aa108927a$var$find(fragments, function(frag) {
        return frag.search(/,|\s/) !== -1;
    }));
    if (fragments[divider] && fragments[divider].indexOf(',') === -1) console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
    // If divider is found, we divide the list of values and operands to divide
    // them by ofset X and Y.
    var splitRegex = /\s*,\s*|\s+/;
    var ops = divider !== -1 ? [
        fragments.slice(0, divider).concat([
            fragments[divider].split(splitRegex)[0]
        ]),
        [
            fragments[divider].split(splitRegex)[1]
        ].concat(fragments.slice(divider + 1))
    ] : [
        fragments
    ];
    // Convert the values with units to absolute pixels to allow our computations
    ops = ops.map(function(op, index) {
        // Most of the units rely on the orientation of the popper
        var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
        var mergeWithPrevious = false;
        return op// This aggregates any `+` or `-` sign that aren't considered operators
        // e.g.: 10 + +5 => [10, +, +5]
        .reduce(function(a, b) {
            if (a[a.length - 1] === '' && [
                '+',
                '-'
            ].indexOf(b) !== -1) {
                a[a.length - 1] = b;
                mergeWithPrevious = true;
                return a;
            } else if (mergeWithPrevious) {
                a[a.length - 1] += b;
                mergeWithPrevious = false;
                return a;
            } else return a.concat(b);
        }, [])// Here we convert the string values into number values (in px)
        .map(function(str) {
            return $23b4933aa108927a$var$toValue(str, measurement, popperOffsets, referenceOffsets);
        });
    });
    // Loop trough the offsets arrays and execute the operations
    ops.forEach(function(op, index) {
        op.forEach(function(frag, index2) {
            if ($23b4933aa108927a$var$isNumeric(frag)) offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
        });
    });
    return offsets;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */ function $23b4933aa108927a$var$offset(data, _ref) {
    var offset = _ref.offset;
    var placement = data.placement, _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var basePlacement = placement.split('-')[0];
    var offsets = void 0;
    if ($23b4933aa108927a$var$isNumeric(+offset)) offsets = [
        +offset,
        0
    ];
    else offsets = $23b4933aa108927a$var$parseOffset(offset, popper, reference, basePlacement);
    if (basePlacement === 'left') {
        popper.top += offsets[0];
        popper.left -= offsets[1];
    } else if (basePlacement === 'right') {
        popper.top += offsets[0];
        popper.left += offsets[1];
    } else if (basePlacement === 'top') {
        popper.left += offsets[0];
        popper.top -= offsets[1];
    } else if (basePlacement === 'bottom') {
        popper.left += offsets[0];
        popper.top += offsets[1];
    }
    data.popper = popper;
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $23b4933aa108927a$var$preventOverflow(data, options) {
    var boundariesElement = options.boundariesElement || $23b4933aa108927a$var$getOffsetParent(data.instance.popper);
    // If offsetParent is the reference element, we really want to
    // go one step up and use the next offsetParent as reference to
    // avoid to make this modifier completely useless and look like broken
    if (data.instance.reference === boundariesElement) boundariesElement = $23b4933aa108927a$var$getOffsetParent(boundariesElement);
    // NOTE: DOM access here
    // resets the popper's position so that the document size can be calculated excluding
    // the size of the popper element itself
    var transformProp = $23b4933aa108927a$var$getSupportedPropertyName('transform');
    var popperStyles = data.instance.popper.style; // assignment to help minification
    var top = popperStyles.top, left = popperStyles.left, transform = popperStyles[transformProp];
    popperStyles.top = '';
    popperStyles.left = '';
    popperStyles[transformProp] = '';
    var boundaries = $23b4933aa108927a$var$getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);
    // NOTE: DOM access here
    // restores the original style properties after the offsets have been computed
    popperStyles.top = top;
    popperStyles.left = left;
    popperStyles[transformProp] = transform;
    options.boundaries = boundaries;
    var order = options.priority;
    var popper = data.offsets.popper;
    var check = {
        primary: function primary(placement) {
            var value = popper[placement];
            if (popper[placement] < boundaries[placement] && !options.escapeWithReference) value = Math.max(popper[placement], boundaries[placement]);
            return $23b4933aa108927a$var$defineProperty({}, placement, value);
        },
        secondary: function secondary(placement) {
            var mainSide = placement === 'right' ? 'left' : 'top';
            var value = popper[mainSide];
            if (popper[placement] > boundaries[placement] && !options.escapeWithReference) value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
            return $23b4933aa108927a$var$defineProperty({}, mainSide, value);
        }
    };
    order.forEach(function(placement) {
        var side = [
            'left',
            'top'
        ].indexOf(placement) !== -1 ? 'primary' : 'secondary';
        popper = $23b4933aa108927a$var$_extends({}, popper, check[side](placement));
    });
    data.offsets.popper = popper;
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $23b4933aa108927a$var$shift(data) {
    var placement = data.placement;
    var basePlacement = placement.split('-')[0];
    var shiftvariation = placement.split('-')[1];
    // if shift shiftvariation is specified, run the modifier
    if (shiftvariation) {
        var _data$offsets = data.offsets, reference = _data$offsets.reference, popper = _data$offsets.popper;
        var isVertical = [
            'bottom',
            'top'
        ].indexOf(basePlacement) !== -1;
        var side = isVertical ? 'left' : 'top';
        var measurement = isVertical ? 'width' : 'height';
        var shiftOffsets = {
            start: $23b4933aa108927a$var$defineProperty({}, side, reference[side]),
            end: $23b4933aa108927a$var$defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
        };
        data.offsets.popper = $23b4933aa108927a$var$_extends({}, popper, shiftOffsets[shiftvariation]);
    }
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $23b4933aa108927a$var$hide(data) {
    if (!$23b4933aa108927a$var$isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) return data;
    var refRect = data.offsets.reference;
    var bound = $23b4933aa108927a$var$find(data.instance.modifiers, function(modifier) {
        return modifier.name === 'preventOverflow';
    }).boundaries;
    if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
        // Avoid unnecessary DOM access if visibility hasn't changed
        if (data.hide === true) return data;
        data.hide = true;
        data.attributes['x-out-of-boundaries'] = '';
    } else {
        // Avoid unnecessary DOM access if visibility hasn't changed
        if (data.hide === false) return data;
        data.hide = false;
        data.attributes['x-out-of-boundaries'] = false;
    }
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $23b4933aa108927a$var$inner(data) {
    var placement = data.placement;
    var basePlacement = placement.split('-')[0];
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var isHoriz = [
        'left',
        'right'
    ].indexOf(basePlacement) !== -1;
    var subtractLength = [
        'top',
        'left'
    ].indexOf(basePlacement) === -1;
    popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);
    data.placement = $23b4933aa108927a$var$getOppositePlacement(placement);
    data.offsets.popper = $23b4933aa108927a$var$getClientRect(popper);
    return data;
}
/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */ /**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */ var $23b4933aa108927a$var$modifiers = {
    /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */ shift: {
        /** @prop {number} order=100 - Index used to define the order of execution */ order: 100,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $23b4933aa108927a$var$shift
    },
    /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */ offset: {
        /** @prop {number} order=200 - Index used to define the order of execution */ order: 200,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $23b4933aa108927a$var$offset,
        /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */ offset: 0
    },
    /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */ preventOverflow: {
        /** @prop {number} order=300 - Index used to define the order of execution */ order: 300,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $23b4933aa108927a$var$preventOverflow,
        /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */ priority: [
            'left',
            'right',
            'top',
            'bottom'
        ],
        /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */ padding: 5,
        /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */ boundariesElement: 'scrollParent'
    },
    /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */ keepTogether: {
        /** @prop {number} order=400 - Index used to define the order of execution */ order: 400,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $23b4933aa108927a$var$keepTogether
    },
    /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */ arrow: {
        /** @prop {number} order=500 - Index used to define the order of execution */ order: 500,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $23b4933aa108927a$var$arrow,
        /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */ element: '[x-arrow]'
    },
    /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */ flip: {
        /** @prop {number} order=600 - Index used to define the order of execution */ order: 600,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $23b4933aa108927a$var$flip,
        /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */ behavior: 'flip',
        /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */ padding: 5,
        /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */ boundariesElement: 'viewport',
        /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */ flipVariations: false,
        /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */ flipVariationsByContent: false
    },
    /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */ inner: {
        /** @prop {number} order=700 - Index used to define the order of execution */ order: 700,
        /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */ enabled: false,
        /** @prop {ModifierFn} */ fn: $23b4933aa108927a$var$inner
    },
    /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */ hide: {
        /** @prop {number} order=800 - Index used to define the order of execution */ order: 800,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $23b4933aa108927a$var$hide
    },
    /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */ computeStyle: {
        /** @prop {number} order=850 - Index used to define the order of execution */ order: 850,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $23b4933aa108927a$var$computeStyle,
        /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */ gpuAcceleration: true,
        /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */ x: 'bottom',
        /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */ y: 'right'
    },
    /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */ applyStyle: {
        /** @prop {number} order=900 - Index used to define the order of execution */ order: 900,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $23b4933aa108927a$var$applyStyle,
        /** @prop {Function} */ onLoad: $23b4933aa108927a$var$applyStyleOnLoad,
        /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */ gpuAcceleration: undefined
    }
};
/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */ /**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */ var $23b4933aa108927a$var$Defaults = {
    /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */ placement: 'bottom',
    /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */ positionFixed: false,
    /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */ eventsEnabled: true,
    /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */ removeOnDestroy: false,
    /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */ onCreate: function onCreate() {},
    /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */ onUpdate: function onUpdate() {},
    /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */ modifiers: $23b4933aa108927a$var$modifiers
};
/**
 * @callback onCreate
 * @param {dataObject} data
 */ /**
 * @callback onUpdate
 * @param {dataObject} data
 */ // Utils
// Methods
var $23b4933aa108927a$var$Popper = function() {
    /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */ function Popper(reference, popper) {
        var _this = this;
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        $23b4933aa108927a$var$classCallCheck(this, Popper);
        this.scheduleUpdate = function() {
            return requestAnimationFrame(_this.update);
        };
        // make update() debounced, so that it only runs at most once-per-tick
        this.update = $23b4933aa108927a$var$debounce(this.update.bind(this));
        // with {} we create a new object with the options inside it
        this.options = $23b4933aa108927a$var$_extends({}, Popper.Defaults, options);
        // init state
        this.state = {
            isDestroyed: false,
            isCreated: false,
            scrollParents: []
        };
        // get reference and popper elements (allow jQuery wrappers)
        this.reference = reference && reference.jquery ? reference[0] : reference;
        this.popper = popper && popper.jquery ? popper[0] : popper;
        // Deep merge modifiers options
        this.options.modifiers = {};
        Object.keys($23b4933aa108927a$var$_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function(name) {
            _this.options.modifiers[name] = $23b4933aa108927a$var$_extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
        });
        // Refactoring modifiers' list (Object => Array)
        this.modifiers = Object.keys(this.options.modifiers).map(function(name) {
            return $23b4933aa108927a$var$_extends({
                name: name
            }, _this.options.modifiers[name]);
        })// sort the modifiers by order
        .sort(function(a, b) {
            return a.order - b.order;
        });
        // modifiers have the ability to execute arbitrary code when Popper.js get inited
        // such code is executed in the same order of its modifier
        // they could add new properties to their options configuration
        // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
        this.modifiers.forEach(function(modifierOptions) {
            if (modifierOptions.enabled && $23b4933aa108927a$var$isFunction(modifierOptions.onLoad)) modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
        });
        // fire the first update to position the popper in the right place
        this.update();
        var eventsEnabled = this.options.eventsEnabled;
        if (eventsEnabled) // setup event listeners, they will take care of update the position in specific situations
        this.enableEventListeners();
        this.state.eventsEnabled = eventsEnabled;
    }
    // We can't use class properties because they don't get listed in the
    // class prototype and break stuff like Sinon stubs
    $23b4933aa108927a$var$createClass(Popper, [
        {
            key: 'update',
            value: function update$$1() {
                return $23b4933aa108927a$var$update.call(this);
            }
        },
        {
            key: 'destroy',
            value: function destroy$$1() {
                return $23b4933aa108927a$var$destroy.call(this);
            }
        },
        {
            key: 'enableEventListeners',
            value: function enableEventListeners$$1() {
                return $23b4933aa108927a$var$enableEventListeners.call(this);
            }
        },
        {
            key: 'disableEventListeners',
            value: function disableEventListeners$$1() {
                return $23b4933aa108927a$var$disableEventListeners.call(this);
            }
        }
    ]);
    return Popper;
}();
/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */ $23b4933aa108927a$var$Popper.Utils = (typeof window !== 'undefined' ? window : $parcel$global).PopperUtils;
$23b4933aa108927a$var$Popper.placements = $23b4933aa108927a$var$placements;
$23b4933aa108927a$var$Popper.Defaults = $23b4933aa108927a$var$Defaults;
var $23b4933aa108927a$export$2e2bcd8739ae039 = $23b4933aa108927a$var$Popper;

});

parcelRegister("hKfUT", function(module, exports) {
$parcel$export(module.exports, "positionPropToPopperPosition", () => $ddd6b59462ded57b$export$9e6a7c92c66a7cdd);

var $jHNyU = parcelRequire("jHNyU");
const $ddd6b59462ded57b$var$positionMap = {
    'top left': {
        position: 'top-start',
        animation: 'top'
    },
    'top center': {
        position: 'top',
        animation: 'top'
    },
    'top right': {
        position: 'top-end',
        animation: 'top'
    },
    'right top': {
        position: 'right-start',
        animation: 'right'
    },
    'right middle': {
        position: 'right',
        animation: 'right'
    },
    'right bottom': {
        position: 'right-end',
        animation: 'right'
    },
    'bottom left': {
        position: 'bottom-start',
        animation: 'bottom'
    },
    'bottom center': {
        position: 'bottom',
        animation: 'bottom'
    },
    'bottom right': {
        position: 'bottom-end',
        animation: 'bottom'
    },
    'left top': {
        position: 'left-start',
        animation: 'left'
    },
    'left middle': {
        position: 'left',
        animation: 'left'
    },
    'left bottom': {
        position: 'left-end',
        animation: 'left'
    }
};
function $ddd6b59462ded57b$var$positionToPopper(position) {
    return position && $ddd6b59462ded57b$var$positionMap[position] ? $ddd6b59462ded57b$var$positionMap[position].position : null;
}
function $ddd6b59462ded57b$export$9e6a7c92c66a7cdd(position) {
    return $ddd6b59462ded57b$var$positionToPopper(position) || $ddd6b59462ded57b$var$positionMap[(0, $jHNyU.POSITION_ATTRIBUTE_ENUM).default].position;
} // eslint-disable-next-line @atlaskit/editor/no-re-export

});
parcelRegister("jHNyU", function(module, exports) {
$parcel$export(module.exports, "POSITION_ATTRIBUTE_ENUM", () => $3aeb38f891251e34$export$f6c90e9517ee2ce0);
const $3aeb38f891251e34$export$f6c90e9517ee2ce0 = {
    values: [
        'top left',
        'top center',
        'top right',
        'right top',
        'right middle',
        'right bottom',
        'bottom left',
        'bottom center',
        'bottom right',
        'left top',
        'left middle',
        'left bottom'
    ],
    default: 'right middle'
};

});




parcelRegister("5zk80", function(module, exports) {
$parcel$export(module.exports, "default", () => $63c2bc695ef8884a$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $4Sf72 = parcelRequire("4Sf72");

var $bAB3U = parcelRequire("bAB3U");

var $iOdDG = parcelRequire("iOdDG");

var $9wZWu = parcelRequire("9wZWu");

var $5bbjm = parcelRequire("5bbjm");

var $3y2s4 = parcelRequire("3y2s4");

var $9xvBa = parcelRequire("9xvBa");

var $jkv2I = parcelRequire("jkv2I");
var $63c2bc695ef8884a$var$_window;
class $63c2bc695ef8884a$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Component {
    static #_ = this.defaultProps = {
        offset: [
            0,
            0
        ],
        allowOutOfBound: false
    };
    /**
   * Calculates new popup position
   */ calculatePosition(props, popup) {
        const { target: target, fitHeight: fitHeight, fitWidth: fitWidth, boundariesElement: boundariesElement, minPopupMargin: minPopupMargin, offset: offset, onPositionCalculated: onPositionCalculated, onPlacementChanged: onPlacementChanged, alignX: alignX, alignY: alignY, stick: stick, forcePlacement: forcePlacement, allowOutOfBounds: allowOutOfBounds, rect: rect, preventOverflow: preventOverflow, absoluteOffset: absoluteOffset } = props;
        if (!target || !popup) return {};
        const placement = (0, $9xvBa.calculatePlacement)(target, // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- Existing Popup positioning fallback; keep unchanged for safety.
        boundariesElement || document.body, fitWidth, fitHeight, alignX, alignY, forcePlacement, preventOverflow);
        if (onPlacementChanged && this.placement.join('') !== placement.join('')) {
            onPlacementChanged(placement);
            this.placement = placement;
        }
        let position = (0, $9xvBa.calculatePosition)({
            placement: placement,
            popup: popup,
            target: target,
            stick: stick,
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            offset: offset,
            allowOutOfBounds: allowOutOfBounds,
            rect: rect,
            // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- Existing Popup positioning fallback; keep unchanged for safety.
            boundariesElement: boundariesElement || document.body,
            minPopupMargin: minPopupMargin,
            scrollableElement: stick ? this.scrollElement : undefined
        });
        position = onPositionCalculated ? onPositionCalculated(position) : position;
        if (typeof position.top !== 'undefined' && absoluteOffset !== null && absoluteOffset !== void 0 && absoluteOffset.top) position.top = position.top + absoluteOffset.top;
        if (typeof position.bottom !== 'undefined' && absoluteOffset !== null && absoluteOffset !== void 0 && absoluteOffset.bottom) position.bottom = position.bottom + absoluteOffset.bottom;
        if (typeof position.right !== 'undefined' && absoluteOffset !== null && absoluteOffset !== void 0 && absoluteOffset.right) position.right = position.right + absoluteOffset.right;
        if (typeof position.left !== 'undefined' && absoluteOffset !== null && absoluteOffset !== void 0 && absoluteOffset.left) position.left = position.left + absoluteOffset.left;
        return {
            position: position,
            validPosition: (0, $jkv2I.validatePosition)(target)
        };
    }
    updatePosition(props = this.props, state = this.state) {
        const { popup: popup } = state;
        const { position: position, validPosition: validPosition } = this.calculatePosition(props, popup);
        if (position && validPosition) (0, $4Sf72.flushSync)(()=>{
            this.setState({
                position: position,
                validPosition: validPosition
            });
        });
    }
    initTargetVisibilityObserver() {
        var _this$targetVisibilit, _observedTarget$owner;
        const { hideWhenTargetOutOfView: hideWhenTargetOutOfView, target: target, visibilityTarget: visibilityTarget } = this.props;
        const observedTarget = visibilityTarget ?? target;
        (_this$targetVisibilit = this.targetVisibilityObserver) === null || _this$targetVisibilit === void 0 || _this$targetVisibilit.disconnect();
        this.targetVisibilityObserver = undefined;
        if (!hideWhenTargetOutOfView || !(0, $3y2s4.isExperimentEnabled)('platform_editor_popup_target_visibility')) {
            if (!this.state.targetVisible) this.setTargetVisibility(true);
            return;
        }
        this.reportedTargetVisibility = undefined;
        const IntersectionObserverConstructor = observedTarget === null || observedTarget === void 0 || (_observedTarget$owner = observedTarget.ownerDocument.defaultView) === null || _observedTarget$owner === void 0 ? void 0 : _observedTarget$owner.IntersectionObserver;
        if (!IntersectionObserverConstructor || !observedTarget) {
            this.setTargetVisibility(true);
            return;
        }
        this.targetVisibilityObserver = new IntersectionObserverConstructor((entries)=>{
            const entry = entries[entries.length - 1];
            this.setTargetVisibility((entry === null || entry === void 0 ? void 0 : entry.isIntersecting) ?? true);
        }, {
            root: null
        });
        this.targetVisibilityObserver.observe(observedTarget);
        this.setTargetVisibility(true);
    }
    cannotSetPopup(popup, target, overflowScrollParent) {
        /**
     * Check whether:
     * 1. Popup's offset targets which means whether or not its possible to correctly position popup along with given target.
     * 2. Popup is inside "overflow: scroll" container, but its offset parent isn't.
     *
     * Currently Popup isn't capable of position itself correctly in case 2,
     * Add "position: relative" to "overflow: scroll" container or to some other FloatingPanel wrapper inside it.
     */ return !target || // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- Existing Popup containment check; keep unchanged for safety.
        document.body.contains(target) && popup.offsetParent && // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        !popup.offsetParent.contains(target) || overflowScrollParent && !overflowScrollParent.contains(popup.offsetParent);
    }
    /**
   * Popup initialization.
   * Checks whether it's possible to position popup along given target, and if it's not throws an error.
   */ initPopup(popup) {
        if (this.popupRef.current) {
            var _this$resizeObserver;
            (_this$resizeObserver = this.resizeObserver) === null || _this$resizeObserver === void 0 || _this$resizeObserver.unobserve(this.popupRef.current);
        }
        this.popupRef.current = popup;
        const { target: target } = this.props;
        const overflowScrollParent = (0, $9xvBa.findOverflowScrollParent)(popup);
        if (this.cannotSetPopup(popup, target, overflowScrollParent)) return;
        this.setState({
            popup: popup
        });
        /**
     * Some plugins (like image) have async rendering of component in floating toolbar(which is popup).
     * Now, floating toolbar position depends on it's size.
     * Size of floating toolbar changes, when async component renders.
     * There is currently, no way to re position floating toolbar or
     *  better to not show floating toolbar till all the async component are ready to render.
     * Also, it is not even Popup's responsibility to take care of it as popup's children are passed
     *  as a prop.
     * So, calling scheduledUpdatePosition to position popup on next request animation frame,
     * which is currently working for most of the floating toolbar and other popups.
     */ this.scheduledUpdatePosition(this.props);
        if (this.props.focusTrap) this.initFocusTrap();
        if (this.popupRef.current) {
            var _this$resizeObserver2;
            (_this$resizeObserver2 = this.resizeObserver) === null || _this$resizeObserver2 === void 0 || _this$resizeObserver2.observe(this.popupRef.current);
        }
    }
    /**
   * Cancels the initialisation of the focus trap if it has not yet occured
   * Deactivates the focus trap if it exists
   */ destroyFocusTrap() {
        var _this$focusTrap3;
        this.initFocusTrap.cancel();
        (_this$focusTrap3 = this.focusTrap) === null || _this$focusTrap3 === void 0 || _this$focusTrap3.deactivate();
    }
    /**
   * Handle pausing, unpausing, and initialising (if not yet initialised) of the focus trap
   */ handleChangedFocusTrapProp(prevProps) {
        if (prevProps.focusTrap !== this.props.focusTrap) {
            // If currently set to disable, then pause the trap if it exists
            if (!this.props.focusTrap) {
                var _this$focusTrap4;
                return (_this$focusTrap4 = this.focusTrap) === null || _this$focusTrap4 === void 0 ? void 0 : _this$focusTrap4.pause();
            }
            // If set to enabled and trap already exists, unpause
            if (this.focusTrap) this.focusTrap.unpause();
            // Else initialise the focus trap
            return this.initFocusTrap();
        }
    }
    /**
   * Idempotent scroll element setup — tears down any previous listener/observer
   * then attaches to the current scroll parent.
   */ initScrollElement() {
        var _this$unbindScroll;
        const { stick: stick, target: target, scrollableElement: scrollableElement } = this.props;
        (_this$unbindScroll = this.unbindScroll) === null || _this$unbindScroll === void 0 || _this$unbindScroll.call(this);
        if (this.scrollElement && this.resizeObserver) this.resizeObserver.unobserve(this.scrollElement);
        this.scrollElement = scrollableElement;
        if (stick && !this.scrollElement && target) this.scrollElement = (0, $9xvBa.findOverflowScrollParent)(target);
        if (this.scrollElement) {
            if (this.resizeObserver) this.resizeObserver.observe(this.scrollElement);
            this.unbindScroll = (0, $bAB3U.bind)(this.scrollElement, {
                type: 'scroll',
                listener: this.onResize
            });
        }
    }
    componentDidUpdate(prevProps) {
        this.handleChangedFocusTrapProp(prevProps);
        if (prevProps.scrollableElement !== this.props.scrollableElement) this.initScrollElement();
        // Reconfigure while enabled, or once after disabling to clean up the existing observer.
        // A different target must be observed again.
        if ((prevProps.hideWhenTargetOutOfView || this.props.hideWhenTargetOutOfView) && (prevProps.hideWhenTargetOutOfView !== this.props.hideWhenTargetOutOfView || prevProps.target !== this.props.target || prevProps.visibilityTarget !== this.props.visibilityTarget)) this.initTargetVisibilityObserver();
        if (this.props !== prevProps) this.scheduledUpdatePosition(prevProps);
    }
    componentDidMount() {
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.addEventListener('resize', this.onResize);
        this.initScrollElement();
        if (this.props.hideWhenTargetOutOfView) this.initTargetVisibilityObserver();
    }
    componentWillUnmount() {
        var _this$targetVisibilit2, _this$unbindScroll2, _this$resizeObserver3;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.removeEventListener('resize', this.onResize);
        (_this$targetVisibilit2 = this.targetVisibilityObserver) === null || _this$targetVisibilit2 === void 0 || _this$targetVisibilit2.disconnect();
        (_this$unbindScroll2 = this.unbindScroll) === null || _this$unbindScroll2 === void 0 || _this$unbindScroll2.call(this);
        if (this.scrollElement) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        this.scrollElement.removeEventListener('scroll', this.onResize);
        (_this$resizeObserver3 = this.resizeObserver) === null || _this$resizeObserver3 === void 0 || _this$resizeObserver3.disconnect();
        this.scheduledUpdatePosition.cancel();
        this.destroyFocusTrap();
        const { onUnmount: onUnmount } = this.props;
        if (onUnmount) onUnmount();
    }
    renderPopup() {
        const { position: position, targetVisible: targetVisible } = this.state;
        const { shouldRenderPopup: shouldRenderPopup } = this.props;
        if (shouldRenderPopup && !shouldRenderPopup(position || {})) return null;
        /**
     * https://a11y.atlassian.net/browse/A11Y-9995
     * We set aria-label to undefined if it's null, no more 'Popup' fallback.
     * It is meaningless for screen readers and causes confusion.
     */ const ariaLabel = this.props.ariaLabel ?? undefined;
        const getRole = ()=>{
            // Provide a valid role only when aria-label is present to satisfy a11y rules, as when aria-label is present, role is required
            // use role = dialog as default role, as dialog role itself is not a parent role that requires specific children to function as some other ARIA roles(menu) do
            // if set default role to menu, tons of integration tests will fail as many of our popup usages do not have children that satisfy menu role requirements
            if (ariaLabel) return this.props.role || 'dialog';
            return undefined;
        };
        return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
            ref: this.handleRef,
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                position: 'absolute',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                zIndex: this.props.zIndex || (0, $5bbjm.akEditorFloatingPanelZIndex),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                ...position,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                ...this.props.style,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Runtime visibility follows the target's scroll position.
                ...this.props.hideWhenTargetOutOfView && (0, $3y2s4.isExperimentEnabled)('platform_editor_popup_target_visibility') && !targetVisible && {
                    visibility: 'hidden'
                }
            },
            role: getRole(),
            "aria-label": ariaLabel,
            "data-testid": "popup-wrapper",
            // Indicates component is an editor pop. Required for focus handling in Message.tsx
            "data-editor-popup": true,
            children: this.props.children
        });
    }
    render() {
        const { target: target, mountTo: mountTo } = this.props;
        const { validPosition: validPosition } = this.state;
        if (!target || !validPosition) return null;
        if (mountTo) return /*#__PURE__*/ (0, $4Sf72.createPortal)(this.renderPopup(), mountTo);
        // Without mountTo property renders popup as is,
        // which means it will be cropped by "overflow: hidden" container.
        return this.renderPopup();
    }
    constructor(...args){
        super(...args), this.rafIds = new Set(), this.state = {
            targetVisible: true,
            validPosition: true
        }, this.popupRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createRef(), this.placement = [
            '',
            ''
        ], this.setTargetVisibility = (targetVisible)=>{
            if (targetVisible !== this.state.targetVisible) {
                if (!targetVisible) {
                    var _this$focusTrap;
                    // Let consumers preserve focus before the popup becomes hidden.
                    this.reportTargetVisibility(targetVisible);
                    (_this$focusTrap = this.focusTrap) === null || _this$focusTrap === void 0 || _this$focusTrap.pause();
                    this.setState({
                        targetVisible: targetVisible
                    });
                    return;
                }
                // Reveal the popup before consumers restore focus to its contents.
                this.setState({
                    targetVisible: targetVisible
                }, ()=>{
                    if (this.props.focusTrap) {
                        var _this$focusTrap2;
                        (_this$focusTrap2 = this.focusTrap) === null || _this$focusTrap2 === void 0 || _this$focusTrap2.unpause();
                    }
                    this.reportTargetVisibility(targetVisible);
                });
                return;
            }
            this.reportTargetVisibility(targetVisible);
        }, this.reportTargetVisibility = (targetVisible)=>{
            if (targetVisible !== this.reportedTargetVisibility) {
                var _this$props$onTargetV, _this$props;
                this.reportedTargetVisibility = targetVisible;
                (_this$props$onTargetV = (_this$props = this.props).onTargetVisibilityChanged) === null || _this$props$onTargetV === void 0 || _this$props$onTargetV.call(_this$props, targetVisible);
            }
        }, this.handleRef = (popup)=>{
            if (!popup) return;
            this.initPopup(popup);
        }, this.scheduledUpdatePosition = (0, $9wZWu.default)((_props)=>{
            this.updatePosition(this.props);
        }), this.onResize = ()=>this.scheduledUpdatePosition(this.props), this.resizeObserver = ($63c2bc695ef8884a$var$_window = window) !== null && $63c2bc695ef8884a$var$_window !== void 0 && $63c2bc695ef8884a$var$_window.ResizeObserver ? new ResizeObserver(()=>{
            this.scheduledUpdatePosition(this.props);
        }) : undefined, /**
   * Raf scheduled so that it also occurs after the initial update position
   */ this.initFocusTrap = (0, $9wZWu.default)(()=>{
            const popup = this.popupRef.current;
            if (!popup) return;
            const defaultTrapConfig = {
                clickOutsideDeactivates: true,
                escapeDeactivates: true,
                initialFocus: popup,
                fallbackFocus: popup,
                returnFocusOnDeactivate: false
            };
            const trapConfig = typeof this.props.focusTrap === 'boolean' ? defaultTrapConfig : {
                ...defaultTrapConfig,
                ...this.props.focusTrap
            };
            this.focusTrap = (0, (/*@__PURE__*/$parcel$interopDefault($iOdDG)))(popup, trapConfig);
            this.focusTrap.activate();
        });
    }
}

});
parcelRegister("9xvBa", function(module, exports) {
$parcel$export(module.exports, "calculatePlacement", () => $e49754192d007a9b$export$b81415a09b611cb);
$parcel$export(module.exports, "findOverflowScrollParent", () => $e49754192d007a9b$export$69742dd9a26edd3e);
$parcel$export(module.exports, "calculatePosition", () => $e49754192d007a9b$export$b3ceb0cbf1056d98);

var $9Q9Gx = parcelRequire("9Q9Gx");

var $5rs89 = parcelRequire("5rs89");

function $e49754192d007a9b$export$ba5b1093dd832251(target, boundariesElement, fitHeight, alignY, forcePlacement, preventOverflow) {
    if (forcePlacement && alignY) return alignY;
    if (!fitHeight) return 'bottom';
    if ((0, $5rs89.isTextNode)(target)) // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    target = target.parentElement;
    const boundariesClientRect = boundariesElement.getBoundingClientRect();
    const { height: boundariesHeight } = boundariesClientRect;
    const boundariesTop = (0, $9Q9Gx.isBody)(boundariesElement) ? 0 : boundariesClientRect.top;
    const { top: targetTop, height: targetHeight } = target.getBoundingClientRect();
    const spaceAbove = targetTop - (boundariesTop - boundariesElement.scrollTop);
    const spaceBelow = boundariesTop + boundariesHeight - (targetTop + targetHeight);
    // Force vertical placement to bottom if the space above doesn't accomodate the fitHeight
    if (preventOverflow) {
        if (spaceAbove <= fitHeight) return 'bottom';
    }
    if (spaceBelow >= fitHeight) return 'bottom';
    if (spaceAbove >= fitHeight) return 'top';
    // If neither space can accommodate the full height, prefer the one with more space
    // When spaces are equal, prefer 'top' to show the top portion of the popup
    return spaceAbove >= spaceBelow ? 'top' : 'bottom';
}
function $e49754192d007a9b$export$af26c34d66be95d6(target, boundariesElement, fitWidth, alignX, forcePlacement, preventOverflow) {
    // force placement unless preventOverflow is enabled
    if (forcePlacement && alignX && !preventOverflow) return alignX;
    if (!fitWidth) return alignX || 'left';
    if ((0, $5rs89.isTextNode)(target)) // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    target = target.parentElement;
    const { left: targetLeft, width: targetWidth } = target.getBoundingClientRect();
    const { left: boundariesLeft, width: boundariesWidth } = boundariesElement.getBoundingClientRect();
    const spaceLeft = targetLeft - boundariesLeft + targetWidth;
    const spaceRight = boundariesLeft + boundariesWidth - targetLeft;
    if (alignX && spaceLeft > fitWidth && spaceRight > fitWidth) return alignX;
    else if (spaceRight >= fitWidth || spaceRight >= spaceLeft && !alignX) return 'left';
    return 'right';
}
function $e49754192d007a9b$export$b81415a09b611cb(target, boundariesElement, fitWidth, fitHeight, alignX, alignY, forcePlacement, preventOverflow) {
    return [
        $e49754192d007a9b$export$ba5b1093dd832251(target, boundariesElement, fitHeight, alignY, forcePlacement, preventOverflow),
        $e49754192d007a9b$export$af26c34d66be95d6(target, boundariesElement, fitWidth, alignX, forcePlacement, preventOverflow)
    ];
}
const $e49754192d007a9b$var$calculateHorizontalPlacement = ({ placement: placement, targetLeft: targetLeft, targetRight: targetRight, targetWidth: targetWidth, isPopupParentBody: isPopupParentBody, popupOffsetParentLeft: popupOffsetParentLeft, popupOffsetParentRight: popupOffsetParentRight, popupOffsetParentScrollLeft: popupOffsetParentScrollLeft, popupOffsetParentClientWidth: popupOffsetParentClientWidth, popupClientWidth: popupClientWidth, offset: offset, allowOutOfBounds: allowOutOfBounds = false, minPopupMargin: minPopupMargin })=>{
    const position = {};
    if (placement === 'left') position.left = Math.ceil(targetLeft - popupOffsetParentLeft + (isPopupParentBody ? 0 : popupOffsetParentScrollLeft) + offset[0]);
    else if (placement === 'center') position.left = Math.ceil(targetLeft - popupOffsetParentLeft + (isPopupParentBody ? 0 : popupOffsetParentScrollLeft) + offset[0] + targetWidth / 2 - popupClientWidth / 2);
    else if (placement === 'end') {
        const left = Math.ceil(targetRight - popupOffsetParentLeft + (isPopupParentBody ? 0 : popupOffsetParentScrollLeft) + offset[0]);
        position.left = left;
    } else position.right = Math.ceil(popupOffsetParentRight - targetRight - (isPopupParentBody ? 0 : popupOffsetParentScrollLeft) + offset[0]);
    if (!allowOutOfBounds) {
        if (position.left !== undefined) position.left = $e49754192d007a9b$var$getPopupXInsideParent(position.left, popupClientWidth, popupOffsetParentClientWidth, minPopupMargin);
        if (position.right !== undefined) position.right = $e49754192d007a9b$var$getPopupXInsideParent(position.right, popupClientWidth, popupOffsetParentClientWidth, minPopupMargin);
    }
    return position;
};
const $e49754192d007a9b$var$getPopupXInsideParent = (x, popupClientWidth, popupOffsetParentClientWidth, minPopupMargin = 1)=>{
    // prevent going too far right
    if (popupOffsetParentClientWidth < x + popupClientWidth) x = popupOffsetParentClientWidth - popupClientWidth - minPopupMargin;
    // prevent going too far left
    return Math.max(minPopupMargin, x);
};
const $e49754192d007a9b$var$calculateVerticalStickBottom = ({ target: target, targetTop: targetTop, targetHeight: targetHeight, popup: popup, offset: offset, position: position, boundariesElement: boundariesElement, scrollableElement: scrollableElement })=>{
    const scrollParent = scrollableElement || $e49754192d007a9b$export$69742dd9a26edd3e(target) || boundariesElement;
    const newPos = {
        ...position
    };
    if (scrollParent) {
        const topOffsetTop = targetTop - scrollParent.getBoundingClientRect().top;
        const targetEnd = targetHeight + topOffsetTop;
        if (scrollParent.clientHeight - targetEnd <= popup.clientHeight + offset[1] * 2 && topOffsetTop < scrollParent.clientHeight) {
            const scroll = targetEnd - scrollParent.clientHeight + offset[1] * 2;
            let top = newPos.top || 0;
            top = top - (scroll + popup.clientHeight);
            newPos.top = top;
        }
    }
    return newPos;
};
const $e49754192d007a9b$var$calculateVerticalStickTop = ({ target: target, targetTop: targetTop, targetHeight: targetHeight, popupOffsetParentHeight: popupOffsetParentHeight, popupOffsetParent: popupOffsetParent, offset: offset, position: position, placement: placement, boundariesElement: boundariesElement, scrollableElement: scrollableElement })=>{
    const scrollParent = scrollableElement || $e49754192d007a9b$export$69742dd9a26edd3e(target) || boundariesElement;
    const newPos = {
        ...position
    };
    if (scrollParent) {
        const { top: scrollParentTop } = scrollParent.getBoundingClientRect();
        const topBoundary = targetTop - scrollParentTop;
        const scrollParentScrollTop = scrollParent.scrollTop;
        if (topBoundary < 0) {
            const isBelowNodeBoundary = targetTop + (scrollParentScrollTop - scrollParentTop) + targetHeight + offset[1] < scrollParentScrollTop;
            if (placement === 'top') {
                if (isBelowNodeBoundary) newPos.bottom = popupOffsetParentHeight - (topBoundary + popupOffsetParent.scrollTop + targetHeight);
                else newPos.bottom = topBoundary + (newPos.bottom || 0);
            }
            if (placement === 'start') {
                if (isBelowNodeBoundary) newPos.top = topBoundary + popupOffsetParent.scrollTop + targetHeight;
                else newPos.top = Math.abs(topBoundary) + (newPos.top || 0) + offset[1];
            }
        }
    }
    return newPos;
};
const $e49754192d007a9b$var$calculateVerticalPlacement = ({ placement: placement, targetTop: targetTop, targetHeight: targetHeight, isPopupParentBody: isPopupParentBody, popupOffsetParentHeight: popupOffsetParentHeight, popupOffsetParentTop: popupOffsetParentTop, popupOffsetParentScrollTop: popupOffsetParentScrollTop, borderBottomWidth: borderBottomWidth, offset: offset })=>{
    const position = {};
    if (placement === 'top') position.bottom = Math.ceil(popupOffsetParentHeight - (targetTop - popupOffsetParentTop) - (isPopupParentBody ? 0 : popupOffsetParentScrollTop) - borderBottomWidth + offset[1]);
    else if (placement === 'start') position.top = Math.ceil(targetTop - popupOffsetParentTop - offset[1] + (isPopupParentBody ? 0 : popupOffsetParentScrollTop));
    else {
        const top = Math.ceil(targetTop - popupOffsetParentTop + targetHeight + (isPopupParentBody ? 0 : popupOffsetParentScrollTop) - borderBottomWidth + offset[1]);
        position.top = top;
    }
    return position;
};
function $e49754192d007a9b$export$b3ceb0cbf1056d98({ placement: placement, target: target, popup: popup, offset: offset, stick: stick, allowOutOfBounds: allowOutOfBounds = false, rect: rect, boundariesElement: boundariesElement, minPopupMargin: minPopupMargin, scrollableElement: scrollableElement }) {
    let position = {};
    if (!target || !popup || !popup.offsetParent || !$e49754192d007a9b$var$isHTMLElementNode(popup.offsetParent)) return position;
    if ((0, $5rs89.isTextNode)(target)) // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    target = target.parentElement;
    const popupOffsetParent = popup.offsetParent;
    const offsetParentStyle = popupOffsetParent.style;
    let borderBottomWidth = 0;
    if (offsetParentStyle && offsetParentStyle.borderBottomWidth) borderBottomWidth = parseInt(offsetParentStyle.borderBottomWidth, 10);
    const [verticalPlacement, horizontalPlacement] = placement;
    const { top: popupOffsetParentTop, left: popupOffsetParentLeft, right: popupOffsetParentRight, height: popupOffsetParentHeight } = rect ? rect : popupOffsetParent.getBoundingClientRect();
    // Calculate scrollbar dimensions to adjust positions
    // clientWidth/Height excludes scrollbars, offsetWidth/Height includes them
    const scrollbarWidth = popupOffsetParent.offsetWidth - popupOffsetParent.clientWidth;
    const scrollbarHeight = popupOffsetParent.offsetHeight - popupOffsetParent.clientHeight;
    const { top: targetTop, left: targetLeft, right: targetRight, height: targetHeight, width: targetWidth } = target.getBoundingClientRect();
    const isPopupParentBody = (0, $9Q9Gx.isBody)(popupOffsetParent);
    const verticalPosition = $e49754192d007a9b$var$calculateVerticalPlacement({
        placement: verticalPlacement,
        targetTop: targetTop,
        isPopupParentBody: isPopupParentBody,
        popupOffsetParentHeight: popupOffsetParentHeight - (isPopupParentBody ? 0 : scrollbarHeight),
        popupOffsetParentTop: popupOffsetParentTop,
        popupOffsetParentScrollTop: popupOffsetParent.scrollTop || 0,
        targetHeight: targetHeight,
        borderBottomWidth: borderBottomWidth,
        offset: offset
    });
    position = {
        ...position,
        ...verticalPosition
    };
    if ((verticalPlacement === 'top' || verticalPlacement === 'start') && stick) position = $e49754192d007a9b$var$calculateVerticalStickTop({
        target: target,
        targetTop: targetTop,
        targetHeight: targetHeight,
        popupOffsetParentHeight: popupOffsetParentHeight,
        popupOffsetParent: popupOffsetParent,
        popup: popup,
        offset: offset,
        position: position,
        placement: verticalPlacement,
        boundariesElement: boundariesElement,
        scrollableElement: scrollableElement
    });
    if (verticalPlacement !== 'top' && verticalPlacement !== 'start' && stick) position = $e49754192d007a9b$var$calculateVerticalStickBottom({
        target: target,
        targetTop: targetTop,
        targetHeight: targetHeight,
        popup: popup,
        offset: offset,
        position: position,
        boundariesElement: boundariesElement,
        scrollableElement: scrollableElement
    });
    const horizontalPosition = $e49754192d007a9b$var$calculateHorizontalPlacement({
        placement: horizontalPlacement,
        targetLeft: targetLeft,
        targetRight: targetRight,
        targetWidth: targetWidth,
        isPopupParentBody: isPopupParentBody,
        popupOffsetParentLeft: popupOffsetParentLeft,
        popupOffsetParentRight: popupOffsetParentRight - (isPopupParentBody ? 0 : scrollbarWidth),
        popupOffsetParentScrollLeft: popupOffsetParent.scrollLeft || 0,
        popupOffsetParentClientWidth: popup.offsetParent.clientWidth,
        popupClientWidth: popup.clientWidth || 0,
        offset: offset,
        allowOutOfBounds: allowOutOfBounds,
        minPopupMargin: minPopupMargin
    });
    position = {
        ...position,
        ...horizontalPosition
    };
    return position;
}
function $e49754192d007a9b$export$69742dd9a26edd3e(popup) {
    let parent = popup;
    if (!parent) return false;
    // Ignored via go/ees005
    // eslint-disable-next-line no-cond-assign
    while(parent = parent.parentElement){
        // IE11 on Window 8 doesn't show styles from CSS when accessing through element.style property.
        const style = window.getComputedStyle(parent);
        if (style.overflow === 'scroll' || style.overflowX === 'scroll' || style.overflowY === 'scroll' || parent.classList.contains('fabric-editor-popup-scroll-parent')) return parent;
    }
    return false;
}
// Helper function to check if the passed node is of Element class
function $e49754192d007a9b$var$isElementNode(node) {
    return node.nodeType === 1;
}
// Helper function to check if the passed node is of HTMLElement class
function $e49754192d007a9b$var$isHTMLElementNode(node) {
    return $e49754192d007a9b$var$isElementNode(node) && node.namespaceURI === 'http://www.w3.org/1999/xhtml';
}

});
parcelRegister("9Q9Gx", function(module, exports) {
$parcel$export(module.exports, "isBody", () => $ee1085f4697f750d$export$540dbd453ede1ce3);
function $ee1085f4697f750d$export$540dbd453ede1ce3(elem) {
    return elem === document.body;
}

});

parcelRegister("5rs89", function(module, exports) {
$parcel$export(module.exports, "isTextNode", () => $58f97192a2eca8c9$export$ccbedd67ef6e9417);
function $58f97192a2eca8c9$export$ccbedd67ef6e9417(elem) {
    return elem && elem.nodeType === 3;
}

});


parcelRegister("jkv2I", function(module, exports) {
$parcel$export(module.exports, "validatePosition", () => $94c13627b4a8e331$export$ab306cb155a0ca1b);
function $94c13627b4a8e331$export$ab306cb155a0ca1b(popup) {
    // popup.offsetParent does not exist if the popup element is not mounted
    if (!popup || !popup.offsetParent) return false;
    return true;
}

});


parcelRegister("5chfg", function(module, exports) {
$parcel$export(module.exports, "ArrowKeyNavigationProvider", () => $285dedc2fe9d1c91$export$ee87cc4950b6d6fe);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $jC0lZ = parcelRequire("jC0lZ");

var $S4SjX = parcelRequire("S4SjX");

var $9JuOY = parcelRequire("9JuOY");

var $imBU3 = parcelRequire("imBU3");
const $285dedc2fe9d1c91$export$ee87cc4950b6d6fe = (props)=>{
    const { children: children, type: type, ...restProps } = props;
    if (type === (0, $imBU3.ArrowKeyNavigationType).COLOR) return /*#__PURE__*/ (0, $dc70d.jsx)((0, $jC0lZ.default).Consumer, {
        children: ({ popupsMountPoint: popupsMountPoint, editorView: editorView, editorRef: editorRef })=>editorRef && /*#__PURE__*/ (0, $dc70d.jsx)((0, $S4SjX.ColorPaletteArrowKeyNavigationProvider), {
                selectedRowIndex: props.selectedRowIndex,
                selectedColumnIndex: props.selectedColumnIndex,
                isOpenedByKeyboard: props.isOpenedByKeyboard,
                isPopupPositioned: props.isPopupPositioned,
                editorRef: editorRef,
                popupsMountPoint: popupsMountPoint,
                ...restProps,
                children: children
            })
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $jC0lZ.default).Consumer, {
        children: ({ popupsMountPoint: popupsMountPoint, editorView: editorView, editorRef: editorRef })=>editorRef && /*#__PURE__*/ (0, $dc70d.jsx)((0, $9JuOY.MenuArrowKeyNavigationProvider), {
                editorRef: editorRef,
                popupsMountPoint: popupsMountPoint,
                ...restProps,
                children: children
            })
    });
};

});
parcelRegister("S4SjX", function(module, exports) {
$parcel$export(module.exports, "ColorPaletteArrowKeyNavigationProvider", () => $eb0748862a49084e$export$e17115e9cf808589);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");
const $eb0748862a49084e$export$e17115e9cf808589 = ({ children: children, selectedRowIndex: selectedRowIndex, selectedColumnIndex: selectedColumnIndex, isOpenedByKeyboard: isOpenedByKeyboard, isPopupPositioned: isPopupPositioned, handleClose: handleClose, closeOnTab: closeOnTab, editorRef: editorRef, ignoreEscapeKey: ignoreEscapeKey, popupsMountPoint: popupsMountPoint })=>{
    const wrapperRef = (0, $bSJIT.useRef)(null);
    const currentSelectedColumnIndex = (0, $bSJIT.useRef)(selectedColumnIndex === -1 ? 0 : selectedColumnIndex);
    const currentSelectedRowIndex = (0, $bSJIT.useRef)(selectedRowIndex === -1 ? 0 : selectedRowIndex);
    const element = popupsMountPoint ? popupsMountPoint : editorRef.current;
    const [listenerTargetElement] = (0, $bSJIT.useState)(element);
    const incrementRowIndex = (rowElements, columnElements)=>{
        if (currentSelectedRowIndex.current === rowElements.length - 1) currentSelectedRowIndex.current = 0;
        else currentSelectedRowIndex.current = currentSelectedRowIndex.current + 1;
    };
    const decrementRowIndex = (rowElements, columnElements)=>{
        if (currentSelectedRowIndex.current === 0) currentSelectedRowIndex.current = rowElements.length - 1;
        else currentSelectedRowIndex.current = currentSelectedRowIndex.current - 1;
    };
    (0, $bSJIT.useLayoutEffect)(()=>{
        const incrementColumnIndex = (rowElements, columnElements)=>{
            if (currentSelectedColumnIndex.current === columnElements.length - 1) {
                incrementRowIndex(rowElements, columnElements);
                currentSelectedColumnIndex.current = 0;
            } else currentSelectedColumnIndex.current = currentSelectedColumnIndex.current + 1;
        };
        const decrementColumnIndex = (rowElements, columnElements)=>{
            if (currentSelectedColumnIndex.current === 0) {
                decrementRowIndex(rowElements, columnElements);
                currentSelectedColumnIndex.current = columnElements.length - 1;
            } else currentSelectedColumnIndex.current = currentSelectedColumnIndex.current - 1;
        };
        const focusColorSwatch = ()=>{
            var _focusableElements$cu;
            const colorSwatchesRowElements = $eb0748862a49084e$var$getColorSwatchesRows(wrapperRef === null || wrapperRef === void 0 ? void 0 : wrapperRef.current);
            const currentSelectedColorSwatchRowElement = colorSwatchesRowElements[currentSelectedRowIndex.current];
            const focusableElements = $eb0748862a49084e$var$getFocusableElements(currentSelectedColorSwatchRowElement);
            if (!focusableElements || (focusableElements === null || focusableElements === void 0 ? void 0 : focusableElements.length) === 0) return;
            (_focusableElements$cu = focusableElements[currentSelectedColumnIndex.current]) === null || _focusableElements$cu === void 0 || _focusableElements$cu.focus();
        };
        /**
     * To handle the key events on the list
     * @param event
     */ const handleKeyDown = (event)=>{
            if (event.key === 'Tab' && closeOnTab) {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                handleClose(event);
                return;
            }
            const colorSwatchesRowElements = $eb0748862a49084e$var$getColorSwatchesRows(wrapperRef === null || wrapperRef === void 0 ? void 0 : wrapperRef.current);
            const currentSelectedColorSwatchRowElement = colorSwatchesRowElements[currentSelectedRowIndex.current];
            const focusableElements = $eb0748862a49084e$var$getFocusableElements(currentSelectedColorSwatchRowElement);
            switch(event.key){
                case 'ArrowDown':
                    incrementRowIndex(colorSwatchesRowElements, focusableElements);
                    focusColorSwatch();
                    event.preventDefault();
                    break;
                case 'ArrowUp':
                    decrementRowIndex(colorSwatchesRowElements, focusableElements);
                    focusColorSwatch();
                    event.preventDefault();
                    break;
                case 'ArrowLeft':
                    decrementColumnIndex(colorSwatchesRowElements, focusableElements);
                    focusColorSwatch();
                    event.preventDefault();
                    break;
                case 'ArrowRight':
                    incrementColumnIndex(colorSwatchesRowElements, focusableElements);
                    focusColorSwatch();
                    event.preventDefault();
                    break;
                case 'Escape':
                    if (!ignoreEscapeKey) // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    handleClose(event);
                    break;
                default:
                    return;
            }
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        listenerTargetElement && listenerTargetElement.addEventListener('keydown', handleKeyDown);
        // set focus to current selected color swatch if only opened by keyboard
        if (isOpenedByKeyboard && isPopupPositioned) // Using timeout because, we need to wait till color palette is rendered
        //  and visible on screen, then only focus color swatch, otherwise focus will be
        //  moved to body
        setTimeout(()=>{
            focusColorSwatch();
        });
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            listenerTargetElement && listenerTargetElement.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        currentSelectedColumnIndex,
        isOpenedByKeyboard,
        isPopupPositioned,
        wrapperRef,
        handleClose,
        closeOnTab,
        ignoreEscapeKey,
        listenerTargetElement
    ]);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        className: "custom-key-handler-wrapper",
        ref: wrapperRef,
        children: children
    }));
};
function $eb0748862a49084e$var$getColorSwatchesRows(rootNode) {
    if (!rootNode) return [];
    const colorSwatchesRowElements = rootNode.querySelectorAll('div[role=radiogroup]') || [];
    return Array.from(colorSwatchesRowElements);
}
function $eb0748862a49084e$var$getFocusableElements(rootNode) {
    if (!rootNode) return [];
    const focusableModalElements = rootNode.querySelectorAll('button[role=radio]:not([disabled])') || [];
    return Array.from(focusableModalElements);
}

});

parcelRegister("9JuOY", function(module, exports) {
$parcel$export(module.exports, "MenuArrowKeyNavigationProvider", () => $db0fa228c82c7925$export$e12b037790bf03e3);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $c9wRy = parcelRequire("c9wRy");
const $db0fa228c82c7925$var$hasEnabledItems = (list)=>list.some((item)=>item.getAttribute('aria-disabled') !== 'true');
const $db0fa228c82c7925$export$e12b037790bf03e3 = ({ children: children, handleClose: handleClose, disableArrowKeyNavigation: disableArrowKeyNavigation, keyDownHandlerContext: keyDownHandlerContext, closeOnTab: closeOnTab, onSelection: onSelection, editorRef: editorRef, popupsMountPoint: popupsMountPoint, disableCloseOnArrowClick: disableCloseOnArrowClick })=>{
    const wrapperRef = (0, $bSJIT.useRef)(null);
    const [currentSelectedItemIndex, setCurrentSelectedItemIndex] = (0, $bSJIT.useState)(-1);
    const element = popupsMountPoint ? [
        popupsMountPoint,
        editorRef.current
    ] : [
        editorRef.current
    ];
    const [listenerTargetElement] = (0, $bSJIT.useState)(element);
    const getCurrentIndex = (0, $bSJIT.useCallback)((list)=>{
        var _getDocument;
        const activeElement = (_getDocument = (0, $c9wRy.getDocument)()) === null || _getDocument === void 0 ? void 0 : _getDocument.activeElement;
        if (!(activeElement instanceof HTMLElement)) return currentSelectedItemIndex;
        const activeElementIndex = list.indexOf(activeElement);
        return activeElementIndex >= 0 ? activeElementIndex : currentSelectedItemIndex;
    }, [
        currentSelectedItemIndex
    ]);
    const incrementIndex = (0, $bSJIT.useCallback)((list)=>{
        const currentIndex = getCurrentIndex(list);
        let nextIndex = (currentIndex + 1) % list.length;
        // Skips disabled items. Previously this function relied on a list of enabled elements which caused a
        // difference between currentIndex and the item index in the menu.
        while(nextIndex !== currentIndex && list[nextIndex].getAttribute('aria-disabled') === 'true')nextIndex = (nextIndex + 1) % list.length;
        setCurrentSelectedItemIndex(nextIndex);
        return nextIndex;
    }, [
        getCurrentIndex
    ]);
    const decrementIndex = (0, $bSJIT.useCallback)((list)=>{
        const currentIndex = getCurrentIndex(list);
        let nextIndex = (list.length + currentIndex - 1) % list.length;
        while(nextIndex !== currentIndex && list[nextIndex].getAttribute('aria-disabled') === 'true')nextIndex = (list.length + nextIndex - 1) % list.length;
        setCurrentSelectedItemIndex(nextIndex);
        return nextIndex;
    }, [
        getCurrentIndex
    ]);
    // this useEffect uses onSelection in it's dependency list which gets
    // changed as a result of the dropdown menu getting re-rendered in it's
    // parent component. Note that if onSelection gets updated to useMemo
    // this will no longer work.
    (0, $bSJIT.useEffect)(()=>{
        const currentIndex = currentSelectedItemIndex;
        const list = $db0fa228c82c7925$var$getFocusableElements(wrapperRef === null || wrapperRef === void 0 ? void 0 : wrapperRef.current);
        const currentElement = list[currentIndex];
        // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- Ignored via go/ees017 (to be fixed)
        if (currentElement && currentElement.getAttribute('aria-disabled') === 'true') {
            var _list$focusIndex;
            // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- Ignored via go/ees017 (to be fixed)
            const focusIndex = incrementIndex(list);
            // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- Ignored via go/ees017 (to be fixed)
            (_list$focusIndex = list[focusIndex]) === null || _list$focusIndex === void 0 || _list$focusIndex.focus();
        }
    }, [
        currentSelectedItemIndex,
        onSelection,
        incrementIndex,
        decrementIndex
    ]);
    (0, $bSJIT.useLayoutEffect)(()=>{
        // Backwards compatible behaviour:
        // - `true` disables all key handling (no listeners attached)
        // - a function is evaluated per event inside the handler
        if (disableArrowKeyNavigation === true) return;
        /**
     * To handle the key events on the list
     * @param event
     */ const handleKeyDown = (event)=>{
            var _wrapperRef$current;
            if (typeof disableArrowKeyNavigation === 'function' && disableArrowKeyNavigation(event)) return;
            const targetElement = event.target;
            // Tab key on menu items can be handled in the parent components of dropdown menus with KeydownHandlerContext
            if (event.key === 'Tab' && closeOnTab) {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                handleClose(event);
                keyDownHandlerContext === null || keyDownHandlerContext === void 0 || keyDownHandlerContext.handleTab();
                return;
            }
            // To trap the focus inside the toolbar using left and right arrow keys
            const focusableElements = $db0fa228c82c7925$var$getFocusableElements(wrapperRef === null || wrapperRef === void 0 ? void 0 : wrapperRef.current);
            if (!focusableElements || (focusableElements === null || focusableElements === void 0 ? void 0 : focusableElements.length) === 0) return;
            if (targetElement instanceof HTMLElement && !((_wrapperRef$current = wrapperRef.current) !== null && _wrapperRef$current !== void 0 && _wrapperRef$current.contains(targetElement))) setCurrentSelectedItemIndex(-1);
            switch(event.key){
                case 'ArrowDown':
                    if ($db0fa228c82c7925$var$hasEnabledItems(focusableElements)) {
                        var _focusableElements$fo;
                        const focusIndex = incrementIndex(focusableElements);
                        (_focusableElements$fo = focusableElements[focusIndex]) === null || _focusableElements$fo === void 0 || _focusableElements$fo.focus();
                        event.preventDefault();
                    }
                    break;
                case 'ArrowUp':
                    if ($db0fa228c82c7925$var$hasEnabledItems(focusableElements)) {
                        var _focusableElements$fo2;
                        const focusIndex = decrementIndex(focusableElements);
                        (_focusableElements$fo2 = focusableElements[focusIndex]) === null || _focusableElements$fo2 === void 0 || _focusableElements$fo2.focus();
                        event.preventDefault();
                    }
                    break;
                // ArrowLeft/Right on the menu should close the menus
                // then logic to retain the focus can be handled in the parent components with KeydownHandlerContext
                case 'ArrowLeft':
                    if (targetElement instanceof HTMLElement && !targetElement.closest('.custom-key-handler-wrapper')) return;
                    if (!disableCloseOnArrowClick) // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    handleClose(event);
                    if (targetElement instanceof HTMLElement && !targetElement.closest('[data-testid="editor-floating-toolbar"]')) keyDownHandlerContext === null || keyDownHandlerContext === void 0 || keyDownHandlerContext.handleArrowLeft();
                    break;
                case 'ArrowRight':
                    if (targetElement instanceof HTMLElement && !targetElement.closest('.custom-key-handler-wrapper')) return;
                    if (!disableCloseOnArrowClick) // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    handleClose(event);
                    if (targetElement instanceof HTMLElement && !targetElement.closest('[data-testid="editor-floating-toolbar"]')) keyDownHandlerContext === null || keyDownHandlerContext === void 0 || keyDownHandlerContext.handleArrowRight();
                    break;
                case 'Escape':
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    handleClose(event);
                    break;
                case 'Enter':
                    if (typeof onSelection === 'function') onSelection(currentSelectedItemIndex);
                    break;
                default:
                    return;
            }
        };
        listenerTargetElement && listenerTargetElement.forEach(function(elem) {
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            elem && elem.addEventListener('keydown', handleKeyDown);
        });
        return ()=>{
            listenerTargetElement && listenerTargetElement.forEach(function(elem) {
                // Ignored via go/ees005
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                elem && elem.removeEventListener('keydown', handleKeyDown);
            });
        };
    }, [
        currentSelectedItemIndex,
        wrapperRef,
        handleClose,
        disableArrowKeyNavigation,
        keyDownHandlerContext,
        closeOnTab,
        onSelection,
        incrementIndex,
        decrementIndex,
        listenerTargetElement,
        disableCloseOnArrowClick
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "menu-key-handler-wrapper custom-key-handler-wrapper",
        ref: wrapperRef,
        children: children
    });
};
function $db0fa228c82c7925$var$getFocusableElements(rootNode) {
    if (!rootNode) return [];
    const focusableModalElements = rootNode.querySelectorAll('a[href], button:not([disabled]), textarea, input, select, div[tabindex="-1"]') || [];
    return Array.from(focusableModalElements);
}

});




parcelRegister("fWCaV", function(module, exports) {
$parcel$export(module.exports, "default", () => $fb02948693ccf15a$export$2e2bcd8739ae039);
$parcel$export(module.exports, "DropdownMenuItem", () => $fb02948693ccf15a$export$ed97964d1871885d);
$parcel$export(module.exports, "DropdownMenuWithKeyboardNavigation", () => $fb02948693ccf15a$export$9e0cd5a62a7d99cf);
/* eslint-disable @repo/internal/react/no-class-components */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $5bbjm = parcelRequire("5bbjm");

var $cjQhO = parcelRequire("cjQhO");

var $65Fe1 = parcelRequire("65Fe1");

var $7LtMZ = parcelRequire("7LtMZ");

var $3y2s4 = parcelRequire("3y2s4");

var $797yE = parcelRequire("797yE");

var $lavtv = parcelRequire("lavtv");

var $iw14B = parcelRequire("iw14B");

var $aHqLs = parcelRequire("aHqLs");

var $3Aq92 = parcelRequire("3Aq92");
var $cf2n1 = parcelRequire("cf2n1");

var $ctt7l = parcelRequire("ctt7l");

var $5zk80 = parcelRequire("5zk80");

var $5chfg = parcelRequire("5chfg");

var $imBU3 = parcelRequire("imBU3");
function $fb02948693ccf15a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $fb02948693ccf15a$var$wrapper = {
    name: "ul2689",
    styles: "& > div > div{display:flex;}"
};
const $fb02948693ccf15a$var$focusedMenuItemStyle = /*#__PURE__*/ (0, $9dQre.css)({
    boxShadow: `inset 0px 0px 0px 2px ${"var(--ds-border-focused, #4688EC)"}`,
    outline: 'none'
});
const $fb02948693ccf15a$var$buttonStyles = (isActive, submenuActive)=>{
    if (isActive) {
        if ((0, $797yE.editorExperiment)('platform_editor_controls', 'variant1')) /**
       * Hack for item to imitate old dropdown-menu selected styles
       */ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
        return /*#__PURE__*/ (0, $9dQre.css)("position:relative;&::before{display:block;height:100%;width:2px;position:absolute;left:0;top:0;background:var(--ds-border-selected, #1868DB);content:'';}>span,>span:hover,>span:active{background:var(--ds-background-selected, #E9F2FE);color:var(--ds-text-selected, #1868DB);}:focus>span[aria-disabled='false']{", $fb02948693ccf15a$var$focusedMenuItemStyle, ";}:focus-visible,:focus-visible>span[aria-disabled='false']{outline:none;}");
        /**
     * Hack for item to imitate old dropdown-menu selected styles
     */ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
        return /*#__PURE__*/ (0, $9dQre.css)(">span,>span:hover,>span:active{background:var(--ds-background-selected, #E9F2FE);color:var(--ds-text-selected, #1868DB);}:focus>span[aria-disabled='false']{", $fb02948693ccf15a$var$focusedMenuItemStyle, ";}:focus-visible,:focus-visible>span[aria-disabled='false']{outline:none;}");
    } else // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
    return /*#__PURE__*/ (0, $9dQre.css)(">span:hover[aria-disabled='false']{color:var(--ds-text, #292A2E);background-color:var(--ds-background-neutral-subtle-hovered, #0515240F);}", !submenuActive && `
					> span:active[aria-disabled='false'] {
						background-color: ${"var(--ds-background-neutral-subtle-pressed, #0B120E24)"};
					}`, ">span[aria-disabled='true']{color:var(--ds-text-disabled, #080F214A);}:focus>span[aria-disabled='false']{", $fb02948693ccf15a$var$focusedMenuItemStyle, ";}:focus-visible,:focus-visible>span[aria-disabled='false']{outline:none;}"); // The default focus-visible style is removed to ensure consistency across browsers
};
const $fb02948693ccf15a$var$DropListWithOutsideClickTargetRef = (props)=>{
    const setOutsideClickTargetRef = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useContext((0, $3Aq92.OutsideClickTargetRefContext));
    // eslint-disable-next-line react/jsx-props-no-spreading -- Spreading props to pass through dynamic component props
    return /*#__PURE__*/ (0, $9dQre.jsx)((0, $ctt7l.default), {
        onDroplistRef: setOutsideClickTargetRef,
        ...props
    });
};
const $fb02948693ccf15a$var$DropListWithOutsideListeners = (0, $cf2n1.default)($fb02948693ccf15a$var$DropListWithOutsideClickTargetRef);
class $fb02948693ccf15a$export$2e2bcd8739ae039 extends (0, $bSJIT.PureComponent) {
    renderDropdownMenu() {
        const { target: target, popupPlacement: popupPlacement } = this.state;
        const { items: items, mountTo: mountTo, boundariesElement: boundariesElement, scrollableElement: scrollableElement, offset: offset, fitHeight: fitHeight, fitWidth: fitWidth, isOpen: isOpen, zIndex: zIndex, shouldUseDefaultRole: shouldUseDefaultRole, onItemActivated: onItemActivated, arrowKeyNavigationProviderOptions: arrowKeyNavigationProviderOptions, section: section, handleEscapeKeydown: handleEscapeKeydown } = this.props;
        // Note that this onSelection function can't be refactored to useMemo for
        // performance gains as it is being used as a dependency in a useEffect in
        // MenuArrowKeyNavigationProvider in order to check for re-renders to adjust
        // focus for accessibility. If this needs to be refactored in future refer
        // back to ED-16740 for context.
        const navigationProviderProps = arrowKeyNavigationProviderOptions.type === (0, $imBU3.ArrowKeyNavigationType).COLOR ? arrowKeyNavigationProviderOptions : {
            ...arrowKeyNavigationProviderOptions,
            onSelection: (index)=>{
                let result = [];
                if (typeof onItemActivated === 'function') {
                    result = items.reduce((result, group)=>{
                        return result.concat(group.items);
                    }, result);
                    onItemActivated({
                        item: result[index],
                        shouldCloseMenu: false
                    });
                }
            }
        };
        return /*#__PURE__*/ (0, $9dQre.jsx)((0, $5zk80.default), {
            target: isOpen ? target : undefined,
            mountTo: mountTo,
            boundariesElement: boundariesElement,
            scrollableElement: scrollableElement,
            onPlacementChanged: this.updatePopupPlacement,
            fitHeight: fitHeight,
            fitWidth: fitWidth,
            zIndex: zIndex || (0, $5bbjm.akEditorFloatingPanelZIndex),
            offset: offset
        }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $5chfg.ArrowKeyNavigationProvider), {
            ...navigationProviderProps,
            handleClose: this.handleCloseAndFocus,
            closeOnTab: true
        }, /*#__PURE__*/ (0, $9dQre.jsx)($fb02948693ccf15a$var$DropListWithOutsideListeners, {
            isOpen: true,
            position: popupPlacement.join(' '),
            shouldFitContainer: true,
            handleClickOutside: this.handleClose,
            handleEscapeKeydown: handleEscapeKeydown || this.handleCloseAndFocus,
            handleEnterKeydown: this.handleEnterKeydown,
            targetRef: this.state.target
        }, /*#__PURE__*/ (0, $9dQre.jsx)("div", {
            style: {
                height: 0,
                minWidth: fitWidth || 0
            }
        }), /*#__PURE__*/ (0, $9dQre.jsx)("div", {
            ref: this.popupRef
        }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $65Fe1.default), {
            role: shouldUseDefaultRole ? 'group' : 'menu'
        }, items.map((group, index)=>/*#__PURE__*/ (0, $9dQre.jsx)((0, $7LtMZ.default), {
                hasSeparator: (section === null || section === void 0 ? void 0 : section.hasSeparator) && index > 0,
                title: section === null || section === void 0 ? void 0 : section.title,
                // Ignored via go/ees005
                // eslint-disable-next-line react/no-array-index-key
                key: index
            }, group.items.map((item)=>/*#__PURE__*/ (0, $9dQre.jsx)($fb02948693ccf15a$export$ed97964d1871885d, {
                    key: item.key ?? String(item.content),
                    item: item,
                    onItemActivated: this.props.onItemActivated,
                    shouldUseDefaultRole: this.props.shouldUseDefaultRole,
                    onMouseEnter: this.props.onMouseEnter,
                    onMouseLeave: this.props.onMouseLeave
                })))))))));
    }
    render() {
        const { children: children, isOpen: isOpen } = this.props;
        return /*#__PURE__*/ (0, $9dQre.jsx)("div", {
            css: $fb02948693ccf15a$var$wrapper
        }, /*#__PURE__*/ (0, $9dQre.jsx)("div", {
            ref: this.handleRef
        }, children), isOpen ? this.renderDropdownMenu() : null);
    }
    componentDidUpdate(previousProps) {
        const { mountTo: mountTo, isOpen: isOpen } = this.props;
        const isOpenToggled = isOpen !== previousProps.isOpen;
        if (isOpen && isOpenToggled) {
            if (typeof this.props.shouldFocusFirstItem === 'function' && this.props.shouldFocusFirstItem()) {
                var _this$state$target2;
                const keyboardEvent = new KeyboardEvent('keydown', {
                    key: 'ArrowDown',
                    bubbles: true
                });
                if (mountTo) {
                    mountTo.dispatchEvent(keyboardEvent);
                    return;
                }
                (_this$state$target2 = this.state.target) === null || _this$state$target2 === void 0 || _this$state$target2.dispatchEvent(keyboardEvent);
            }
        }
    }
    constructor(...args){
        super(...args), this.state = {
            popupPlacement: [
                'bottom',
                'left'
            ],
            selectionIndex: -1
        }, this.popupRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createRef(), this.handleRef = (target)=>{
            this.setState({
                target: target || undefined
            });
        }, this.updatePopupPlacement = (placement)=>{
            const { popupPlacement: previousPlacement } = this.state;
            if (placement[0] !== previousPlacement[0] || placement[1] !== previousPlacement[1]) this.setState({
                popupPlacement: placement
            });
        }, this.handleCloseAndFocus = (event)=>{
            var _this$state$target;
            (_this$state$target = this.state.target) === null || _this$state$target === void 0 || (_this$state$target = _this$state$target.querySelector('button')) === null || _this$state$target === void 0 || _this$state$target.focus();
            this.handleClose(event);
        }, this.handleClose = (event)=>{
            const { onOpenChange: onOpenChange } = this.props;
            if (onOpenChange) onOpenChange({
                isOpen: false,
                event: event
            });
        }, this.handleEnterKeydown = (e)=>{
            if (!this.props.allowEnterDefaultBehavior) e.preventDefault();
            e.stopPropagation();
        };
    }
}
const $fb02948693ccf15a$var$DropdownMenuItemCustomComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).forwardRef((props, ref)=>{
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $9dQre.jsx)("span", {
        ref: ref,
        ...rest,
        style: {
            // This forces the item container back to be `position: static`, the default value.
            // This ensures the custom nested menu for table color picker still works as now
            // menu items from @atlaskit/menu all have `position: relative` set for the selected borders.
            // The current implementation unfortunately is very brittle. Design System Team will
            // be prioritizing official support for accessible nested menus that we want you to move
            // to in the future.
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'static'
        }
    }, children);
});
function $fb02948693ccf15a$export$ed97964d1871885d({ item: item, onItemActivated: onItemActivated, shouldUseDefaultRole: shouldUseDefaultRole, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave }) {
    const [submenuActive, setSubmenuActive] = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useState(false);
    const memoizedOnClick = (0, $bSJIT.useCallback)(()=>onItemActivated && onItemActivated({
            item: item
        }), [
        onItemActivated,
        item
    ]);
    const onClick = (0, $3y2s4.isExperimentEnabled)('platform_editor_perf_lint_cleanup') ? memoizedOnClick : ()=>onItemActivated && onItemActivated({
            item: item
        });
    const memoizedOnMouseDown = (0, $bSJIT.useCallback)((e)=>{
        e.preventDefault();
    }, []);
    const onMouseDown = (0, $3y2s4.isExperimentEnabled)('platform_editor_perf_lint_cleanup') ? memoizedOnMouseDown : (e)=>{
        e.preventDefault();
    };
    const memoizedOnMouseEnter = (0, $bSJIT.useCallback)(()=>onMouseEnter && onMouseEnter({
            item: item
        }), [
        onMouseEnter,
        item
    ]);
    const onMouseEnterHandler = (0, $3y2s4.isExperimentEnabled)('platform_editor_perf_lint_cleanup') ? memoizedOnMouseEnter : ()=>onMouseEnter && onMouseEnter({
            item: item
        });
    const memoizedOnMouseLeave = (0, $bSJIT.useCallback)(()=>onMouseLeave && onMouseLeave({
            item: item
        }), [
        onMouseLeave,
        item
    ]);
    const onMouseLeaveHandler = (0, $3y2s4.isExperimentEnabled)('platform_editor_perf_lint_cleanup') ? memoizedOnMouseLeave : ()=>onMouseLeave && onMouseLeave({
            item: item
        });
    // onClick and value.name are the action indicators in the handlers
    // If neither are present, don't wrap in an Item.
    if (!item.onClick && !(item.value && item.value.name)) return /*#__PURE__*/ (0, $9dQre.jsx)("span", {
        key: String(item.content)
    }, item.content);
    const _handleSubmenuActive = (event)=>{
        setSubmenuActive(Boolean(event.target instanceof HTMLElement && event.target.closest(`.${(0, $iw14B.DropdownMenuSharedCssClassName).SUBMENU}`)));
    };
    const ariaLabel = item['aria-label'] === '' ? undefined : item['aria-label'] || String(item.content);
    const testId = item['data-testid'] || `dropdown-item__${item.content}`;
    // From time to time we don't want to have any tabIndex on item wrapper
    // especially when we pass any interactive element as a item.content
    const tabIndex = item.wrapperTabIndex === null ? undefined : item.wrapperTabIndex || -1;
    const dropListItem = /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        css: ()=>$fb02948693ccf15a$var$buttonStyles(item.isActive, submenuActive),
        role: shouldUseDefaultRole ? undefined : 'menuitem',
        tabIndex: tabIndex,
        "aria-disabled": item.isDisabled ? 'true' : 'false',
        "aria-expanded": item['aria-expanded'],
        onMouseDown: _handleSubmenuActive
    }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $cjQhO.default), {
        item: item,
        key: item.key ?? String(item.content),
        testId: testId,
        role: shouldUseDefaultRole ? 'button' : undefined,
        iconBefore: item.elemBefore,
        iconAfter: item.elemAfter,
        isDisabled: item.isDisabled,
        onClick: onClick,
        "aria-label": ariaLabel,
        "aria-pressed": shouldUseDefaultRole ? item.isActive : undefined,
        "aria-keyshortcuts": item['aria-keyshortcuts'],
        onMouseDown: onMouseDown,
        component: $fb02948693ccf15a$var$DropdownMenuItemCustomComponent,
        onMouseEnter: onMouseEnterHandler,
        onMouseLeave: onMouseLeaveHandler
    }, item.content));
    if (item.tooltipDescription) return /*#__PURE__*/ (0, $9dQre.jsx)((0, $lavtv.default), {
        key: item.key ?? String(item.content),
        content: item.tooltipDescription,
        position: item.tooltipPosition
    }, dropListItem);
    return dropListItem;
}
const $fb02948693ccf15a$export$9e0cd5a62a7d99cf = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).memo(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
({ ...props })=>{
    const keyDownHandlerContext = (0, $bSJIT.useContext)((0, $aHqLs.KeyDownHandlerContext));
    // This context is to handle the tab, Arrow Right/Left key events for dropdown.
    // Default context has the void callbacks for above key events
    const memoizedArrowKeyNavOptions = (0, $bSJIT.useMemo)(()=>({
            ...props.arrowKeyNavigationProviderOptions,
            keyDownHandlerContext: keyDownHandlerContext
        }), [
        props.arrowKeyNavigationProviderOptions,
        keyDownHandlerContext
    ]);
    const arrowKeyNavOptions = (0, $3y2s4.isExperimentEnabled)('platform_editor_perf_lint_cleanup') ? memoizedArrowKeyNavOptions : {
        ...props.arrowKeyNavigationProviderOptions,
        keyDownHandlerContext: keyDownHandlerContext
    };
    return /*#__PURE__*/ (0, $9dQre.jsx)($fb02948693ccf15a$export$2e2bcd8739ae039, {
        arrowKeyNavigationProviderOptions: arrowKeyNavOptions,
        ...props
    });
});

});
parcelRegister("iw14B", function(module, exports) {
$parcel$export(module.exports, "DropdownMenuSharedCssClassName", () => $19a67e1beea32624$export$94c0f60c32e7bd13);
const $19a67e1beea32624$export$15eb942addb87cf6 = 'pm-dropdown';
const $19a67e1beea32624$export$94c0f60c32e7bd13 = {
    SUBMENU: `${$19a67e1beea32624$export$15eb942addb87cf6}-submenu`
};

});


parcelRegister("8zO6u", function(module, exports) {
$parcel$export(module.exports, "default", () => $ea082f1119b2dfc6$export$2e2bcd8739ae039);
// If you make any change here, copy it to above file as well
// and notify about the change in #team-fc-editor-ai-dev channel.
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $1l5zG = parcelRequire("1l5zG");

var $lavtv = parcelRequire("lavtv");

var $g6Qq4 = parcelRequire("g6Qq4");

var $cv8id = parcelRequire("cv8id");

var $5lcX9 = parcelRequire("5lcX9");
function $ea082f1119b2dfc6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ea082f1119b2dfc6$var$buttonWrapper = {
    name: "15currb",
    styles: "display:flex;height:100%"
};
const $ea082f1119b2dfc6$var$ToolbarButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).forwardRef((props, ref)=>{
    const { buttonId: buttonId, testId: testId, className: className = '', href: href, iconAfter: iconAfter, iconBefore: iconBefore, disabled: disabled, selected: selected, spacing: spacing, target: target, children: children, hideTooltip: hideTooltip, title: title, keymap: keymap, titlePosition: titlePosition = 'top', item: item, rel: rel, 'aria-label': ariaLabel, 'aria-haspopup': ariaHasPopup, 'aria-expanded': ariaExpanded, 'aria-pressed': ariaPressed, 'aria-keyshortcuts': ariaKeyShortcuts, 'aria-controls': ariaControls, 'data-ds--level': dataDsLevel, onClick: onClick, onKeyDown: onKeyDown, onItemClick: onItemClick, onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave } = props;
    const handleClick = (0, $bSJIT.useCallback)((event, analyticsEvent)=>{
        if (disabled) return;
        if (buttonId) analyticsEvent.update((payload)=>({
                ...payload,
                action: (0, $g6Qq4.ACTION).CLICKED,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).TOOLBAR_BUTTON,
                actionSubjectId: buttonId,
                eventType: (0, $g6Qq4.EVENT_TYPE).UI
            })).fire((0, $1l5zG.FabricChannel).editor);
        if (onClick) onClick(event);
        if (item && onItemClick) onItemClick(item);
    }, [
        disabled,
        onClick,
        onItemClick,
        item,
        buttonId
    ]);
    const button = /*#__PURE__*/ (0, $9dQre.jsx)((0, $5lcX9.default), {
        ref: ref,
        appearance: "subtle",
        testId: testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        href: href,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isDisabled: disabled,
        isSelected: selected,
        onClick: handleClick,
        spacing: spacing || 'default',
        target: target,
        shouldFitContainer: true,
        "aria-expanded": ariaExpanded,
        "aria-controls": ariaControls,
        "aria-haspopup": ariaHasPopup,
        "aria-label": ariaLabel,
        "aria-pressed": ariaPressed,
        "aria-keyshortcuts": ariaKeyShortcuts,
        onKeyDown: onKeyDown,
        onFocus: onFocus,
        onBlur: onBlur,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        "data-ds--level": dataDsLevel,
        rel: rel
    }, children);
    if (!title) return button;
    const tooltipContent = hideTooltip ? null : /*#__PURE__*/ (0, $9dQre.jsx)((0, $cv8id.ToolTipContent), {
        description: title,
        keymap: keymap
    });
    return /*#__PURE__*/ (0, $9dQre.jsx)((0, $lavtv.default), {
        content: tooltipContent,
        hideTooltipOnClick: true,
        position: titlePosition
    }, /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        css: $ea082f1119b2dfc6$var$buttonWrapper
    }, button));
});
var $ea082f1119b2dfc6$export$2e2bcd8739ae039 = $ea082f1119b2dfc6$var$ToolbarButton;

});
parcelRegister("5lcX9", function(module, exports) {
$parcel$export(module.exports, "default", () => $b3ad357120bfa2e6$export$2e2bcd8739ae039);
// If you make any change here, copy it to above file as well
//  and notify about the change in #team-fc-editor-ai-dev channel.

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $hzFIQ = parcelRequire("hzFIQ");

var $3y2s4 = parcelRequire("3y2s4");
const $b3ad357120bfa2e6$var$toolbarButtonStyle = {
    alignItems: 'center'
};
const $b3ad357120bfa2e6$var$_default_1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).forwardRef((props, ref)=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $hzFIQ.default), {
        ref: ref,
        ...props,
        // Ignored via go/ees007
        // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
        // TODO: (from codemod) Buttons with "component", "css" or "style" prop can't be automatically migrated with codemods. Please migrate it manually.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: (0, $3y2s4.isExperimentEnabled)('platform_editor_perf_lint_cleanup') ? $b3ad357120bfa2e6$var$toolbarButtonStyle : {
            alignItems: 'center'
        }
    });
});
var $b3ad357120bfa2e6$export$2e2bcd8739ae039 = $b3ad357120bfa2e6$var$_default_1;

});


parcelRegister("9xI4S", function(module, exports) {
$parcel$export(module.exports, "ToolbarDropdownTriggerWrapper", () => $47d9390780cab925$export$bddd4c3563999c);
/* DropdownTriggerWrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $9fU1q = parcelRequire("9fU1q");
parcelRequire("bSJIT");
const $47d9390780cab925$var$triggerWrapperStylesWithPadding = null;
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- This rule thinks this isn't a `css()` call due to the name mapping
const $47d9390780cab925$var$triggerWrapperStylesUnbounded = null;
function $47d9390780cab925$export$bddd4c3563999c({ children: children }) {
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        className: (0, $9fU1q.default)([
            "_1e0c1txw _u5f3v77o",
            "_1fvdglyw"
        ]),
        children: children
    });
}

});

parcelRegister("024dl", function(module, exports) {
$parcel$export(module.exports, "ToolbarDropdownWrapper", () => $0938f941a9870767$export$b4f55ae464964425);
/* DropdownWrapper.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $9fU1q = parcelRequire("9fU1q");
parcelRequire("bSJIT");
const $0938f941a9870767$var$wrapperStyle = null;
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- This rule thinks this isn't a `css()` call due to the name mapping
const $0938f941a9870767$var$wrapperStylesUnbounded = null;
function $0938f941a9870767$export$b4f55ae464964425({ children: children }) {
    return /*#__PURE__*/ (0, $dc70d.jsx)("span", {
        className: (0, $9fU1q.default)([
            "_1e0c1txw _4cvr1h6o _18u0idpf _1ul91wug",
            "_p7r11txw _1xdi1txw _1ylx1txw _1fvdglyw"
        ]),
        children: children
    });
}

});

parcelRegister("hdcuV", function(module, exports) {
$parcel$export(module.exports, "ToolbarExpandIcon", () => $cc5cd69c97d236e6$export$12d8719856664799);
/* ExpandIcon.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $4GWyU = parcelRequire("4GWyU");
const $cc5cd69c97d236e6$var$expandIconContainerStyle = null;
function $cc5cd69c97d236e6$export$12d8719856664799() {
    return /*#__PURE__*/ (0, $dc70d.jsx)("span", {
        className: (0, $9fU1q.default)([
            "_1e0c1txw _4cvr1h6o"
        ]),
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4GWyU))), {
            label: "",
            color: "currentColor",
            size: "small"
        })
    });
}

});

parcelRegister("58mAd", function(module, exports) {
$parcel$export(module.exports, "ToolbarSeparator", () => $bc3484ba82bc7bdd$export$291e1a31e8ec7868);
/* Separator.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
const $bc3484ba82bc7bdd$var$separatorStyles = null;
function $bc3484ba82bc7bdd$export$291e1a31e8ec7868() {
    return /*#__PURE__*/ (0, $dc70d.jsx)("span", {
        "data-testid": "editor-toolbar-seperator",
        className: (0, $9fU1q.default)([
            "_1e0c1o8l _1bsbt94y _4t3i1tcg _19pkze3t _otyrze3t _18u0u2gc _2hwxu2gc _uiztglyw _bfhkplhp"
        ])
    });
}

});

parcelRegister("8egyr", function(module, exports) {
$parcel$export(module.exports, "default", () => $94a51bf1fc2b1d24$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $fK3tS = parcelRequire("fK3tS");

var $2z97M = parcelRequire("2z97M");

var $cv8id = parcelRequire("cv8id");

var $2D87o = parcelRequire("2D87o");

var $46qNV = parcelRequire("46qNV");
const $94a51bf1fc2b1d24$var$alignmentWrapper = null;
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- This rule thinks this isn't a `css()` call due to the name mapping
const $94a51bf1fc2b1d24$var$alignmentWrapperStylesUnbounded = null;
const $94a51bf1fc2b1d24$var$alignCenterKeyboardShortcut = (0, $cv8id.alignCenter);
const $94a51bf1fc2b1d24$var$alignRightKeyboardShortcut = (0, $cv8id.alignRight);
const $94a51bf1fc2b1d24$var$alignmentOptions = [
    {
        title: (0, $2z97M.alignmentMessages).alignLeft,
        shortcut: (0, $cv8id.alignLeft),
        value: 'start'
    },
    {
        title: (0, $2z97M.alignmentMessages).alignCenter,
        shortcut: $94a51bf1fc2b1d24$var$alignCenterKeyboardShortcut,
        value: 'center'
    },
    {
        title: (0, $2z97M.alignmentMessages).alignRight,
        shortcut: $94a51bf1fc2b1d24$var$alignRightKeyboardShortcut,
        value: 'end'
    }
];
function $94a51bf1fc2b1d24$var$Alignment({ onClick: onClick, selectedAlignment: selectedAlignment, className: className, intl: intl }) {
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        "data-testid": "alignment-buttons",
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $9fU1q.default)([
            "_1e0c1txw _ca0qze3t _n3tdze3t _19bvu2gc _u5f3u2gc _p12f53f4 _gy1pv77o",
            "_1fvdglyw",
            className
        ]),
        children: $94a51bf1fc2b1d24$var$alignmentOptions.map((alignment)=>{
            const { value: value, title: title, shortcut: shortcut } = alignment;
            const message = intl.formatMessage(title);
            return /*#__PURE__*/ (0, $dc70d.jsx)((0, $46qNV.default), {
                content: /*#__PURE__*/ (0, $dc70d.jsx)((0, $2D87o.IconMap), {
                    alignment: value
                }),
                value: value,
                label: message,
                shortcut: shortcut,
                onClick: onClick,
                isSelected: value === selectedAlignment
            }, value);
        })
    });
}
const $94a51bf1fc2b1d24$var$_default_1 = (0, $fK3tS.default)($94a51bf1fc2b1d24$var$Alignment);
var $94a51bf1fc2b1d24$export$2e2bcd8739ae039 = $94a51bf1fc2b1d24$var$_default_1;

});
parcelRegister("2D87o", function(module, exports) {
$parcel$export(module.exports, "IconMap", () => $53830329ff292e75$export$e75cf43d5d0a9444);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $2z97M = parcelRequire("2z97M");

var $gKziX = parcelRequire("gKziX");

var $dvoJo = parcelRequire("dvoJo");

var $i7u95 = parcelRequire("i7u95");
const $53830329ff292e75$var$iconAndMessageMap = {
    start: {
        Component: (0, (/*@__PURE__*/$parcel$interopDefault($dvoJo))),
        label: (0, $2z97M.alignmentMessages).alignLeft
    },
    end: {
        Component: (0, (/*@__PURE__*/$parcel$interopDefault($i7u95))),
        label: (0, $2z97M.alignmentMessages).alignRight
    },
    center: {
        Component: (0, (/*@__PURE__*/$parcel$interopDefault($gKziX))),
        label: (0, $2z97M.alignmentMessages).alignCenter
    }
};
const $53830329ff292e75$export$e75cf43d5d0a9444 = (props)=>{
    const { Component: Component, label: label } = $53830329ff292e75$var$iconAndMessageMap[props.alignment];
    const intl = (0, $4vLTk.default)();
    return /*#__PURE__*/ (0, $dc70d.jsx)(Component, {
        label: intl.formatMessage(label),
        color: "currentColor",
        spacing: "spacious"
    });
};

});

parcelRegister("46qNV", function(module, exports) {
$parcel$export(module.exports, "default", () => $a3453eace9a9a406$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $cv8id = parcelRequire("cv8id");

var $8zO6u = parcelRequire("8zO6u");
function $a3453eace9a9a406$var$AlignmentButton({ label: label, isSelected: isSelected, content: content, shortcut: shortcut, onClick: onClick, value: value }) {
    const onClickCallback = (e)=>{
        // detect if the click event comes from keyboard where screenX and screenY are 0
        const isMouseEvent = e instanceof MouseEvent;
        e.preventDefault();
        onClick(value, isMouseEvent);
    };
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $8zO6u.default), {
        disabled: false,
        selected: isSelected,
        title: /*#__PURE__*/ (0, $dc70d.jsx)((0, $cv8id.ToolTipContent), {
            description: label,
            keymap: shortcut
        }),
        "aria-label": shortcut ? (0, $cv8id.tooltip)(shortcut, label) : label,
        "aria-pressed": isSelected,
        "aria-keyshortcuts": (0, $cv8id.getAriaKeyshortcuts)(shortcut),
        onClick: onClickCallback,
        iconBefore: content,
        titlePosition: 'bottom'
    });
}
var $a3453eace9a9a406$export$2e2bcd8739ae039 = $a3453eace9a9a406$var$AlignmentButton;

});




parcelRegister("7lz77", function(module, exports) {
$parcel$export(module.exports, "PrimaryToolbarComponent", () => $de52b112d32b0ddf$export$94516d5cccf573e3);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $g6Qq4 = parcelRequire("g6Qq4");

var $5beht = parcelRequire("5beht");

var $3RNLX = parcelRequire("3RNLX");

var $cPL12 = parcelRequire("cPL12");

var $a7X0Q = parcelRequire("a7X0Q");
function $de52b112d32b0ddf$export$94516d5cccf573e3({ api: api, editorView: editorView, disabled: disabled, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isToolbarReducedSpacing: isToolbarReducedSpacing }) {
    const { align: align, isEnabled: isEnabled } = (0, $5beht.useSharedPluginStateWithSelector)(api, [
        'alignment'
    ], (states)=>{
        var _states$alignmentStat, _states$alignmentStat2;
        return {
            align: (_states$alignmentStat = states.alignmentState) === null || _states$alignmentStat === void 0 ? void 0 : _states$alignmentStat.align,
            isEnabled: (_states$alignmentStat2 = states.alignmentState) === null || _states$alignmentStat2 === void 0 ? void 0 : _states$alignmentStat2.isEnabled
        };
    });
    const changeAlignmentCallback = (0, $bSJIT.useCallback)((align)=>(0, $3RNLX.changeAlignment)(align, api, (0, $g6Qq4.INPUT_METHOD).TOOLBAR)(editorView.state, editorView.dispatch), [
        editorView,
        api
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $a7X0Q.default), {
        align: align,
        isReducedSpacing: isToolbarReducedSpacing,
        changeAlignment: changeAlignmentCallback,
        disabled: disabled || !isEnabled,
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        api: api,
        toolbarType: (0, $cPL12.ToolbarType).PRIMARY
    });
}

});

parcelRegister("29Kgy", function(module, exports) {
$parcel$export(module.exports, "getToolbarComponents", () => $3360a5742ac2aac2$export$a758406ca53b86a5);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $4rzOL = parcelRequire("4rzOL");

var $fiku8 = parcelRequire("fiku8");

var $g4awd = parcelRequire("g4awd");

var $2jPHU = parcelRequire("2jPHU");

var $1rBu3 = parcelRequire("1rBu3");

var $dSE5S = parcelRequire("dSE5S");
const $3360a5742ac2aac2$var$getAlignmentMenuItems = (api)=>{
    return Object.entries((0, $dSE5S.alignmentOptions)()).map(([alignment, item])=>{
        const { key: key, type: type, rank: rank } = item;
        return {
            type: type,
            key: key,
            parents: [
                {
                    type: (0, $4rzOL.ALIGNMENT_MENU_SECTION).type,
                    key: (0, $4rzOL.ALIGNMENT_MENU_SECTION).key,
                    rank: rank
                }
            ],
            component: ({ parents: parents })=>{
                return /*#__PURE__*/ (0, $dc70d.jsx)((0, $2jPHU.AlignmentMenuItem), {
                    api: api,
                    option: item,
                    alignment: alignment,
                    parents: parents
                });
            }
        };
    });
};
const $3360a5742ac2aac2$export$a758406ca53b86a5 = (api)=>{
    return [
        {
            type: (0, $4rzOL.ALIGNMENT_GROUP).type,
            key: (0, $4rzOL.ALIGNMENT_GROUP).key,
            parents: [
                {
                    type: (0, $4rzOL.TEXT_SECTION).type,
                    key: (0, $4rzOL.TEXT_SECTION).key,
                    rank: (0, $fiku8.TEXT_SECTION_RANK)[(0, $4rzOL.ALIGNMENT_GROUP).key]
                },
                {
                    type: (0, $4rzOL.TEXT_SECTION_PRIMARY_TOOLBAR).type,
                    key: (0, $4rzOL.TEXT_SECTION_PRIMARY_TOOLBAR).key,
                    rank: (0, $fiku8.TEXT_SECTION_PRIMARY_TOOLBAR_RANK)[(0, $4rzOL.ALIGNMENT_GROUP).key]
                }
            ]
        },
        {
            type: (0, $4rzOL.ALIGNMENT_MENU).type,
            key: (0, $4rzOL.ALIGNMENT_MENU).key,
            parents: [
                {
                    type: (0, $4rzOL.ALIGNMENT_GROUP).type,
                    key: (0, $4rzOL.ALIGNMENT_GROUP).key,
                    rank: (0, $fiku8.ALIGNMENT_GROUP_RANK)[(0, $4rzOL.ALIGNMENT_MENU).key]
                }
            ],
            component: ({ children: children })=>{
                return /*#__PURE__*/ (0, $dc70d.jsx)((0, $g4awd.AlignmentMenu), {
                    api: api,
                    children: children
                });
            }
        },
        {
            type: (0, $4rzOL.ALIGNMENT_MENU_SECTION).type,
            key: (0, $4rzOL.ALIGNMENT_MENU_SECTION).key,
            parents: [
                {
                    type: (0, $4rzOL.ALIGNMENT_MENU).type,
                    key: (0, $4rzOL.ALIGNMENT_MENU).key,
                    rank: (0, $fiku8.ALIGNMENT_MENU_RANK)[(0, $4rzOL.ALIGNMENT_MENU_SECTION).key]
                },
                {
                    type: (0, $4rzOL.TEXT_COLLAPSED_MENU).type,
                    key: (0, $4rzOL.TEXT_COLLAPSED_MENU).key,
                    rank: (0, $fiku8.TEXT_COLLAPSED_MENU_RANK)[(0, $4rzOL.ALIGNMENT_MENU_SECTION).key]
                }
            ],
            component: (0, $1rBu3.MenuSection)
        },
        ...$3360a5742ac2aac2$var$getAlignmentMenuItems(api)
    ];
};

});
parcelRegister("fiku8", function(module, exports) {
$parcel$export(module.exports, "TOOLBAR_RANK", () => $4c7d59faa18f3828$export$bc7b81cc80d86c30);
$parcel$export(module.exports, "TEXT_SECTION_RANK", () => $4c7d59faa18f3828$export$6784d5340d4a1b21);
$parcel$export(module.exports, "TEXT_SECTION_PRIMARY_TOOLBAR_RANK", () => $4c7d59faa18f3828$export$a3445a42840bc6d9);
$parcel$export(module.exports, "TEXT_COLLAPSED_MENU_RANK", () => $4c7d59faa18f3828$export$d5a685ed621e9024);
$parcel$export(module.exports, "TEXT_STYLES_GROUP_RANK", () => $4c7d59faa18f3828$export$26a9865aa120e992);
$parcel$export(module.exports, "TEXT_STYLES_MENU_RANK", () => $4c7d59faa18f3828$export$51921362eebd85ab);
$parcel$export(module.exports, "TEXT_STYLES_MENU_SECTION_RANK", () => $4c7d59faa18f3828$export$6449a65588a19d38);
$parcel$export(module.exports, "TEXT_FORMAT_GROUP_RANK", () => $4c7d59faa18f3828$export$9cdaceac32c6b4d8);
$parcel$export(module.exports, "TEXT_FORMAT_GROUP_COLLAPSED_RANK", () => $4c7d59faa18f3828$export$6d00774ee584bc52);
$parcel$export(module.exports, "TEXT_FORMAT_MENU_RANK", () => $4c7d59faa18f3828$export$669a394c241c9256);
$parcel$export(module.exports, "TEXT_FORMATTING_MENU_SECTION_RANK", () => $4c7d59faa18f3828$export$20900530b02fcff9);
$parcel$export(module.exports, "CLEAR_FORMARTTING_MENU_SECTION_RANK", () => $4c7d59faa18f3828$export$b62a699881de3ad5);
$parcel$export(module.exports, "SYNCED_BLOCK_SECTION_RANK", () => $4c7d59faa18f3828$export$f2dba222dee1738d);
$parcel$export(module.exports, "LISTS_INDENTATION_GROUP_RANK", () => $4c7d59faa18f3828$export$bbc17a51edaecf5e);
$parcel$export(module.exports, "LISTS_INDENTATION_GROUP_COLLAPSED_RANK", () => $4c7d59faa18f3828$export$c57e1bc67b28ed16);
$parcel$export(module.exports, "LISTS_INDENTATION_MENU_RANK", () => $4c7d59faa18f3828$export$29d19572f6bf97d3);
$parcel$export(module.exports, "LISTS_INDENTATION_MENU_SECTION_RANK", () => $4c7d59faa18f3828$export$70af84b45a4dbc54);
$parcel$export(module.exports, "ALIGNMENT_GROUP_RANK", () => $4c7d59faa18f3828$export$f2b3800989381ab8);
$parcel$export(module.exports, "ALIGNMENT_MENU_RANK", () => $4c7d59faa18f3828$export$50e3ab1607836660);
$parcel$export(module.exports, "ALIGNMENT_MENU_SECTION_RANK", () => $4c7d59faa18f3828$export$fe18fd9800ea0b78);
$parcel$export(module.exports, "TEXT_COLOR_HIGHLIGHT_GROUP_RANK", () => $4c7d59faa18f3828$export$ae4377fbd160eba4);
$parcel$export(module.exports, "TEXT_COLOR_HIGHLIGHT_MENU_RANK", () => $4c7d59faa18f3828$export$7aebf1f83f92aec4);
$parcel$export(module.exports, "TEXT_COLOR_HIGHLIGHT_MENU_SECTION_RANK", () => $4c7d59faa18f3828$export$6d61bddc04226fae);
$parcel$export(module.exports, "INSERT_BLOCK_SECTION_RANK", () => $4c7d59faa18f3828$export$d501e2da4fccd3d9);
$parcel$export(module.exports, "TASK_LIST_GROUP_RANK", () => $4c7d59faa18f3828$export$ca5c9182c556b0ba);
$parcel$export(module.exports, "MEDIA_GROUP_RANK", () => $4c7d59faa18f3828$export$41b6a2bde3ffc16c);
$parcel$export(module.exports, "CODE_BLOCK_GROUP_RANK", () => $4c7d59faa18f3828$export$2e369b4fbf595d64);
$parcel$export(module.exports, "MENTION_GROUP_RANK", () => $4c7d59faa18f3828$export$9834991fe1fe77a);
$parcel$export(module.exports, "EMOJI_GROUP_RANK", () => $4c7d59faa18f3828$export$5e431f0b402bc573);
$parcel$export(module.exports, "LAYOUT_GROUP_RANK", () => $4c7d59faa18f3828$export$18725f40b7ed45c9);
$parcel$export(module.exports, "TABLE_GROUP_RANK", () => $4c7d59faa18f3828$export$3b68d352d79ba4dc);
$parcel$export(module.exports, "INSERT_GROUP_RANK", () => $4c7d59faa18f3828$export$6b93bebdb0c4f64b);
$parcel$export(module.exports, "LINKING_SECTION_RANK", () => $4c7d59faa18f3828$export$c7c28a2a4f553552);
$parcel$export(module.exports, "LINKING_GROUP_RANK", () => $4c7d59faa18f3828$export$400d2c257bc9421e);
$parcel$export(module.exports, "COLLAB_SECTION_RANK", () => $4c7d59faa18f3828$export$efde8251fb2b89d5);
$parcel$export(module.exports, "TRACK_CHANGES_SECTION_RANK", () => $4c7d59faa18f3828$export$6795fbb63d664162);
$parcel$export(module.exports, "UNDO_CHANGES_GROUP_RANK", () => $4c7d59faa18f3828$export$8b9f9ebddc5f6d72);
$parcel$export(module.exports, "REDO_CHANGES_GROUP_RANK", () => $4c7d59faa18f3828$export$faf3ae5c01b97598);
$parcel$export(module.exports, "OVERFLOW_SECTION_RANK", () => $4c7d59faa18f3828$export$d63a7078a6c0dc57);
$parcel$export(module.exports, "OVERFLOW_GROUP_RANK", () => $4c7d59faa18f3828$export$7aecad5ed6bcab55);
$parcel$export(module.exports, "OVERFLOW_MENU_RANK", () => $4c7d59faa18f3828$export$ea9c3eff8619984);
$parcel$export(module.exports, "PIN_MENU_SECTION_RANK", () => $4c7d59faa18f3828$export$510811eb0f5e0b21);
$parcel$export(module.exports, "OVERFLOW_EXTENSIONS_MENU_SECTION_RANK", () => $4c7d59faa18f3828$export$6184a38ba6130c9c);
$parcel$export(module.exports, "OVERFLOW_SECTION_PRIMARY_TOOLBAR_RANK", () => $4c7d59faa18f3828$export$3bdd20aa1e9eee2);
$parcel$export(module.exports, "OVERFLOW_GROUP_PRIMARY_TOOLBAR_RANK", () => $4c7d59faa18f3828$export$dc811b512e84a8a4);
$parcel$export(module.exports, "OVERFLOW_MENU_PRIMARY_TOOLBAR_RANK", () => $4c7d59faa18f3828$export$9cc8eee968218e62);
$parcel$export(module.exports, "PIN_SECTION_RANK", () => $4c7d59faa18f3828$export$58a4b339bb5abbc1);
$parcel$export(module.exports, "PIN_GROUP_RANK", () => $4c7d59faa18f3828$export$cb4d99d2936acb14);
$parcel$export(module.exports, "LOOM_MENU_SECTION_RANK", () => $4c7d59faa18f3828$export$d27db3643df90b4d);
$parcel$export(module.exports, "PASTE_MENU_RANK", () => $4c7d59faa18f3828$export$a766c0ef72fbd3e1);
$parcel$export(module.exports, "PASTE_MENU_SECTION_RANK", () => $4c7d59faa18f3828$export$1e88c7dcdd9c7430);
$parcel$export(module.exports, "PASTE_NESTED_MENU_RANK", () => $4c7d59faa18f3828$export$c200baaef3fcc623);
$parcel$export(module.exports, "PASTE_MENU_NESTED_SECTION_RANK", () => $4c7d59faa18f3828$export$8afb46bea363e001);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $4rzOL = parcelRequire("4rzOL");
const $4c7d59faa18f3828$export$bc7b81cc80d86c30 = {
    [(0, $4rzOL.AI_SECTION).key]: 100,
    [(0, $4rzOL.AI_VIEW_SECTION).key]: 100,
    [(0, $4rzOL.TEXT_SECTION).key]: 200,
    /* Same rank as TEXT_SECTION as only one is ever shown at a time */ [(0, $4rzOL.TEXT_SECTION_COLLAPSED).key]: 200,
    [(0, $4rzOL.INSERT_BLOCK_SECTION).key]: 300,
    [(0, $4rzOL.LINKING_SECTION).key]: 400,
    [(0, $4rzOL.COLLAB_SECTION).key]: 500,
    [(0, $4rzOL.APPS_SECTION).key]: 600,
    [(0, $4rzOL.TRACK_CHANGES_SECTION).key]: 700,
    [(0, $4rzOL.OVERFLOW_SECTION).key]: 800,
    [(0, $4rzOL.PIN_SECTION).key]: 900,
    /* Sits between PIN (900) and OVERFLOW_SECTION_PRIMARY_TOOLBAR (1000)
   * so the markdown view-mode toggle renders to the right of all formatting
   * controls but still to the left of the overflow `…` menu. */ [(0, $4rzOL.VIEW_MODE_TOGGLE_SECTION).key]: 950,
    [(0, $4rzOL.OVERFLOW_SECTION_PRIMARY_TOOLBAR).key]: 1000
};
const $4c7d59faa18f3828$export$466bb91cec477703 = {
    [(0, $4rzOL.ROVO_GROUP).key]: 100,
    [(0, $4rzOL.ROVO_GROUP_DISPLAY_SMALL).key]: 100,
    [(0, $4rzOL.ROVO_GROUP_PRIMARY_TOOLBAR).key]: 100,
    [(0, $4rzOL.DEFINE_GROUP).key]: 200,
    [(0, $4rzOL.IMPROVE_WRITING_GROUP).key]: 300,
    [(0, $4rzOL.AI_SUGGESTIONS_GROUP).key]: 400,
    [(0, $4rzOL.HERO_PROMPT_BUTTON_GROUP).key]: 500
};
const $4c7d59faa18f3828$export$7f767b9830d79831 = {
    [(0, $4rzOL.AI_SUGGESTIONS_BUTTON).key]: 100
};
const $4c7d59faa18f3828$export$ff4863cfaec82192 = {
    [(0, $4rzOL.ROVO_HERO_BUTTON).key]: 100,
    [(0, $4rzOL.ROVO_WRITE_BUTTON_PRIMARY_TOOLBAR).key]: 100,
    [(0, $4rzOL.ROVO_MENU).key]: 200
};
const $4c7d59faa18f3828$export$bc7ded9825806f2 = {
    [(0, $4rzOL.ROVO_HERO_BUTTON).key]: 100,
    [(0, $4rzOL.ROVO_MENU_DISPLAY_SMALL).key]: 200,
    [(0, $4rzOL.HERO_PROMPT_BUTTON).key]: 300,
    [(0, $4rzOL.AI_SUGGESTIONS_BUTTON).key]: 400
};
const $4c7d59faa18f3828$export$322be3308b7fba35 = {
    [(0, $4rzOL.DEFINE_BUTTON).key]: 100
};
const $4c7d59faa18f3828$export$6f336126efb2136d = {
    [(0, $4rzOL.IMPROVE_WRITING_BUTTON).key]: 100
};
const $4c7d59faa18f3828$export$5eed3dfe1bf849e5 = {
    [(0, $4rzOL.HERO_PROMPT_BUTTON).key]: 100
};
const $4c7d59faa18f3828$export$dd95f65f4139e5c7 = {
    [(0, $4rzOL.ROVO_PROMPT_MENU_SECTION_DISPLAY_SMALL).key]: 100,
    [(0, $4rzOL.ROVO_PROMPT_MENU_SECTION).key]: 100
};
const $4c7d59faa18f3828$export$bfac571871e409b2 = {
    [(0, $4rzOL.IMPROVE_WRITING_MENU_ITEM).key]: 100,
    [(0, $4rzOL.HERO_PROMPT_MENU_ITEM).key]: 100,
    [(0, $4rzOL.ADD_POLISH_MENU_ITEM).key]: 100,
    [(0, $4rzOL.SPELLING_AND_GRAMMAR_MENU_ITEM).key]: 300,
    [(0, $4rzOL.CHANGE_TONE_NESTED_MENU).key]: 400,
    [(0, $4rzOL.MAKE_SHORTER_MENU_ITEM).key]: 500,
    [(0, $4rzOL.MAKE_LONGER_MENU_ITEM).key]: 600,
    [(0, $4rzOL.TRANSLATE_NESTED_MENU).key]: 700,
    [(0, $4rzOL.DEFINE_MENU_ITEM).key]: 800
};
const $4c7d59faa18f3828$export$e63f50c00e536f07 = {
    [(0, $4rzOL.CHANGE_TONE_MENU_SECTION).key]: 100
};
const $4c7d59faa18f3828$export$b55028e61899c679 = {
    [(0, $4rzOL.MORE_PROFESSIONAL_MENU_ITEM).key]: 100,
    [(0, $4rzOL.MORE_CASUAL_MENU_ITEM).key]: 200,
    [(0, $4rzOL.MORE_EMPATHETIC_MENU_ITEM).key]: 300
};
const $4c7d59faa18f3828$export$6f11aef2061f527c = {
    [(0, $4rzOL.TRANSLATE_MENU_SECTION).key]: 100
};
const $4c7d59faa18f3828$export$6784d5340d4a1b21 = {
    [(0, $4rzOL.TEXT_STYLES_GROUP).key]: 100,
    [(0, $4rzOL.TEXT_FORMATTING_GROUP).key]: 200,
    [(0, $4rzOL.LISTS_INDENTATION_GROUP).key]: 300,
    [(0, $4rzOL.ALIGNMENT_GROUP).key]: 400,
    [(0, $4rzOL.TEXT_COLOR_HIGHLIGHT_GROUP).key]: 500
};
const $4c7d59faa18f3828$export$a3445a42840bc6d9 = {
    [(0, $4rzOL.TEXT_STYLES_GROUP).key]: 100,
    [(0, $4rzOL.BOLD_BUTTON_GROUP).key]: 200,
    [(0, $4rzOL.UNDERLINE_BUTTON_GROUP).key]: 300,
    [(0, $4rzOL.TEXT_FORMATTING_GROUP).key]: 400,
    [(0, $4rzOL.BULLETED_LIST_BUTTON_GROUP).key]: 500,
    [(0, $4rzOL.LISTS_INDENTATION_GROUP).key]: 600,
    [(0, $4rzOL.ALIGNMENT_GROUP).key]: 700,
    [(0, $4rzOL.TEXT_COLOR_HIGHLIGHT_GROUP).key]: 800
};
const $4c7d59faa18f3828$export$b3332537c956e2f5 = {
    [(0, $4rzOL.TEXT_COLLAPSED_GROUP).key]: 100
};
const $4c7d59faa18f3828$export$d0c8ffa085b6d177 = {
    [(0, $4rzOL.TEXT_COLLAPSED_MENU).key]: 100
};
const $4c7d59faa18f3828$export$d5a685ed621e9024 = {
    [(0, $4rzOL.TEXT_STYLES_MENU_SECTION).key]: 100,
    [(0, $4rzOL.NUMBERED_HEADINGS_MENU_SECTION).key]: 150,
    [(0, $4rzOL.TEXT_FORMATTING_MENU_SECTION).key]: 200,
    [(0, $4rzOL.CLEAR_FORMARTTING_MENU_SECTION).key]: 300,
    [(0, $4rzOL.LISTS_INDENTATION_MENU_SECTION).key]: 400,
    [(0, $4rzOL.ALIGNMENT_MENU_SECTION).key]: 500,
    [(0, $4rzOL.TEXT_COLOR_HIGHLIGHT_MENU_SECTION).key]: 600
};
const $4c7d59faa18f3828$export$26a9865aa120e992 = {
    [(0, $4rzOL.TEXT_STYLES_MENU).key]: 100
};
const $4c7d59faa18f3828$export$51921362eebd85ab = {
    [(0, $4rzOL.TEXT_STYLES_MENU_SECTION).key]: 100,
    [(0, $4rzOL.NUMBERED_HEADINGS_MENU_SECTION).key]: 200
};
const $4c7d59faa18f3828$export$4e0e4a86166f19d1 = {
    [(0, $4rzOL.NUMBERED_HEADINGS_MENU_ITEM).key]: 100
};
const $4c7d59faa18f3828$export$6449a65588a19d38 = {
    [(0, $4rzOL.NORMAL_TEXT_MENU_ITEM).key]: 100,
    [(0, $4rzOL.SMALL_TEXT_MENU_ITEM).key]: 150,
    [(0, $4rzOL.HEADING_1_MENU_ITEM).key]: 200,
    [(0, $4rzOL.HEADING_2_MENU_ITEM).key]: 300,
    [(0, $4rzOL.HEADING_3_MENU_ITEM).key]: 400,
    [(0, $4rzOL.HEADING_4_MENU_ITEM).key]: 500,
    [(0, $4rzOL.HEADING_5_MENU_ITEM).key]: 600,
    [(0, $4rzOL.HEADING_6_MENU_ITEM).key]: 700,
    [(0, $4rzOL.BLOCK_QUOTE_MENU_ITEM).key]: 800
};
const $4c7d59faa18f3828$export$9cdaceac32c6b4d8 = {
    [(0, $4rzOL.TEXT_FORMATTING_HERO_BUTTON).key]: 100,
    [(0, $4rzOL.TEXT_FORMATTING_MENU).key]: 200
};
const $4c7d59faa18f3828$export$6d00774ee584bc52 = {
    [(0, $4rzOL.TEXT_FORMATTING_HERO_BUTTON_COLLAPSED).key]: 100,
    [(0, $4rzOL.TEXT_FORMATTING_MENU).key]: 200
};
const $4c7d59faa18f3828$export$669a394c241c9256 = {
    [(0, $4rzOL.TEXT_FORMATTING_MENU_SECTION).key]: 100,
    [(0, $4rzOL.CLEAR_FORMARTTING_MENU_SECTION).key]: 200
};
const $4c7d59faa18f3828$export$20900530b02fcff9 = {
    [(0, $4rzOL.BOLD_MENU_ITEM).key]: 100,
    [(0, $4rzOL.ITALIC_MENU_ITEM).key]: 200,
    [(0, $4rzOL.UNDERLINE_MENU_ITEM).key]: 300,
    [(0, $4rzOL.STRIKE_MENU_ITEM).key]: 400,
    [(0, $4rzOL.CODE_MENU_ITEM).key]: 500,
    [(0, $4rzOL.SUBSCRIPT_MENU_ITEM).key]: 600,
    [(0, $4rzOL.SUPERSCRIPT_MENU_ITEM).key]: 700
};
const $4c7d59faa18f3828$export$b62a699881de3ad5 = {
    [(0, $4rzOL.CLEAR_FORMATTING_MENU_ITEM).key]: 100
};
const $4c7d59faa18f3828$export$f2dba222dee1738d = {
    [(0, $4rzOL.SYNCED_BLOCK_BUTTON).key]: 100
};
const $4c7d59faa18f3828$export$bbc17a51edaecf5e = {
    [(0, $4rzOL.BULLETED_LIST_BUTTON).key]: 100,
    [(0, $4rzOL.LISTS_INDENTATION_HERO_BUTTON).key]: 200,
    [(0, $4rzOL.LISTS_INDENTATION_MENU).key]: 300
};
const $4c7d59faa18f3828$export$c57e1bc67b28ed16 = {
    [(0, $4rzOL.LISTS_INDENTATION_HERO_BUTTON_COLLAPSED).key]: 100,
    [(0, $4rzOL.LISTS_INDENTATION_MENU).key]: 200
};
const $4c7d59faa18f3828$export$29d19572f6bf97d3 = {
    [(0, $4rzOL.LISTS_INDENTATION_MENU_SECTION).key]: 100
};
const $4c7d59faa18f3828$export$70af84b45a4dbc54 = {
    [(0, $4rzOL.BULLETED_LIST_MENU_ITEM).key]: 100,
    [(0, $4rzOL.NUMBERED_LIST_MENU_ITEM).key]: 200,
    [(0, $4rzOL.TASK_LIST_MENU_ITEM).key]: 300,
    [(0, $4rzOL.OUTDENT_MENU_ITEM).key]: 400,
    [(0, $4rzOL.INDENT_MENU_ITEM).key]: 500
};
const $4c7d59faa18f3828$export$f2b3800989381ab8 = {
    [(0, $4rzOL.ALIGNMENT_MENU).key]: 100
};
const $4c7d59faa18f3828$export$50e3ab1607836660 = {
    [(0, $4rzOL.ALIGNMENT_MENU_SECTION).key]: 100
};
const $4c7d59faa18f3828$export$fe18fd9800ea0b78 = {
    [(0, $4rzOL.ALIGN_LEFT_MENU_ITEM).key]: 100,
    [(0, $4rzOL.ALIGN_CENTER_MENU_ITEM).key]: 200,
    [(0, $4rzOL.ALIGN_RIGHT_MENU_ITEM).key]: 300
};
const $4c7d59faa18f3828$export$ae4377fbd160eba4 = {
    [(0, $4rzOL.TEXT_COLOR_HIGHLIGHT_MENU).key]: 100
};
const $4c7d59faa18f3828$export$7aebf1f83f92aec4 = {
    [(0, $4rzOL.TEXT_COLOR_HIGHLIGHT_MENU_SECTION).key]: 100
};
const $4c7d59faa18f3828$export$6d61bddc04226fae = {
    [(0, $4rzOL.TEXT_COLOR_MENU_ITEM).key]: 100,
    [(0, $4rzOL.HIGHLIGHT_MENU_ITEM).key]: 200,
    [(0, $4rzOL.CLEAR_COLOR_MENU_ITEM).key]: 300,
    [(0, $4rzOL.COLOR_ACCESSIBILITY_MENU_ITEM).key]: 400
};
const $4c7d59faa18f3828$export$d501e2da4fccd3d9 = {
    [(0, $4rzOL.TASK_LIST_GROUP).key]: 100,
    [(0, $4rzOL.MEDIA_GROUP).key]: 200,
    [(0, $4rzOL.CODE_BLOCK_GROUP).key]: 300,
    [(0, $4rzOL.MENTION_GROUP).key]: 400,
    [(0, $4rzOL.EMOJI_GROUP).key]: 500,
    [(0, $4rzOL.LAYOUT_GROUP).key]: 600,
    [(0, $4rzOL.SYNCED_BLOCK_GROUP).key]: 700,
    [(0, $4rzOL.TABLE_GROUP).key]: 800,
    [(0, $4rzOL.INSERT_GROUP).key]: 900
};
const $4c7d59faa18f3828$export$ca5c9182c556b0ba = {
    [(0, $4rzOL.TASK_LIST_BUTTON).key]: 100
};
const $4c7d59faa18f3828$export$41b6a2bde3ffc16c = {
    [(0, $4rzOL.MEDIA_BUTTON).key]: 100
};
const $4c7d59faa18f3828$export$2e369b4fbf595d64 = {
    [(0, $4rzOL.CODE_BLOCK_BUTTON).key]: 100
};
const $4c7d59faa18f3828$export$9834991fe1fe77a = {
    [(0, $4rzOL.MENTION_BUTTON).key]: 100
};
const $4c7d59faa18f3828$export$5e431f0b402bc573 = {
    [(0, $4rzOL.EMOJI_BUTTON).key]: 100
};
const $4c7d59faa18f3828$export$18725f40b7ed45c9 = {
    [(0, $4rzOL.LAYOUT_BUTTON).key]: 100
};
const $4c7d59faa18f3828$export$3b68d352d79ba4dc = {
    [(0, $4rzOL.TABLE_BUTTON).key]: 100,
    [(0, $4rzOL.TABLE_SIZE_PICKER).key]: 200
};
const $4c7d59faa18f3828$export$6b93bebdb0c4f64b = {
    [(0, $4rzOL.INSERT_BUTTON).key]: 100
};
const $4c7d59faa18f3828$export$c7c28a2a4f553552 = {
    [(0, $4rzOL.LINKING_GROUP).key]: 100
};
const $4c7d59faa18f3828$export$400d2c257bc9421e = {
    [(0, $4rzOL.LINKING_BUTTON).key]: 100
};
const $4c7d59faa18f3828$export$efde8251fb2b89d5 = {
    [(0, $4rzOL.COMMENT_GROUP).key]: 100
};
const $4c7d59faa18f3828$export$4f59ebca6ea8293b = {
    [(0, $4rzOL.COMMENT_HERO_BUTTON).key]: 100
};
const $4c7d59faa18f3828$export$6795fbb63d664162 = {
    [(0, $4rzOL.UNDO_CHANGES_GROUP).key]: 100,
    [(0, $4rzOL.REDO_CHANGES_GROUP).key]: 200,
    [(0, $4rzOL.TRACK_CHANGES_GROUP).key]: 300
};
const $4c7d59faa18f3828$export$8b9f9ebddc5f6d72 = {
    [(0, $4rzOL.UNDO_BUTTON).key]: 100
};
const $4c7d59faa18f3828$export$faf3ae5c01b97598 = {
    [(0, $4rzOL.REDO_BUTTON).key]: 100
};
const $4c7d59faa18f3828$export$e9551bb6af82297a = {
    [(0, $4rzOL.TRACK_CHANGES_BUTTON).key]: 100
};
const $4c7d59faa18f3828$export$d63a7078a6c0dc57 = {
    [(0, $4rzOL.OVERFLOW_GROUP).key]: 100
};
const $4c7d59faa18f3828$export$7aecad5ed6bcab55 = {
    [(0, $4rzOL.OVERFLOW_MENU).key]: 100
};
const $4c7d59faa18f3828$export$ea9c3eff8619984 = {
    [(0, $4rzOL.PIN_MENU_SECTION).key]: 100,
    [(0, $4rzOL.LOOM_MENU_SECTION).key]: 200,
    [(0, $4rzOL.OVERFLOW_EXTENSIONS_MENU_SECTION).key]: 300,
    [(0, $4rzOL.SELECTION_EXTENSION_MENU_SECTION).key]: 300,
    [(0, $4rzOL.SYNCED_BLOCK_SECTION).key]: 400
};
const $4c7d59faa18f3828$export$510811eb0f5e0b21 = {
    [(0, $4rzOL.PIN_MENU_ITEM).key]: 100
};
const $4c7d59faa18f3828$export$6184a38ba6130c9c = {
    [(0, $4rzOL.LOOM_MENU_ITEM).key]: 100,
    [(0, $4rzOL.FIRST_PARTY_EXTENSIONS_MENU_ITEM).key]: 200,
    [(0, $4rzOL.EXTERNAL_EXTENSIONS_MENU_ITEM).key]: 300
};
const $4c7d59faa18f3828$export$3bdd20aa1e9eee2 = {
    [(0, $4rzOL.OVERFLOW_GROUP_PRIMARY_TOOLBAR).key]: 100
};
const $4c7d59faa18f3828$export$dc811b512e84a8a4 = {
    [(0, $4rzOL.OVERFLOW_MENU_PRIMARY_TOOLBAR).key]: 100
};
const $4c7d59faa18f3828$export$9cc8eee968218e62 = {
    [(0, $4rzOL.LOOM_MENU_SECTION).key]: 100
};
const $4c7d59faa18f3828$export$58a4b339bb5abbc1 = {
    [(0, $4rzOL.PIN_GROUP).key]: 100
};
const $4c7d59faa18f3828$export$cb4d99d2936acb14 = {
    [(0, $4rzOL.PIN_BUTTON).key]: 100
};
const $4c7d59faa18f3828$export$d27db3643df90b4d = {
    [(0, $4rzOL.LOOM_MENU_ITEM).key]: 100
};
const $4c7d59faa18f3828$export$a766c0ef72fbd3e1 = {
    [(0, $4rzOL.AI_PASTE_MENU_SECTION).key]: 50,
    [(0, $4rzOL.PASTE_MENU_SECTION).key]: 100
};
const $4c7d59faa18f3828$export$1e88c7dcdd9c7430 = {
    [(0, $4rzOL.PASTE_NESTED_MENU).key]: 100
};
const $4c7d59faa18f3828$export$c200baaef3fcc623 = {
    [(0, $4rzOL.PASTE_MENU_NESTED_SECTION).key]: 100
};
const $4c7d59faa18f3828$export$8afb46bea363e001 = {
    [(0, $4rzOL.PASTE_RICH_TEXT_MENU_ITEM).key]: 100,
    [(0, $4rzOL.PASTE_MARKDOWN_MENU_ITEM).key]: 200,
    [(0, $4rzOL.PASTE_PLAIN_TEXT_MENU_ITEM).key]: 300
};

});

parcelRegister("g4awd", function(module, exports) {
$parcel$export(module.exports, "AlignmentMenu", () => $ebc74e29a6c3102e$export$4301fcd45f99f8a5);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $2z97M = parcelRequire("2z97M");

var $5beht = parcelRequire("5beht");

var $6PDfA = parcelRequire("6PDfA");

var $eHnl8 = parcelRequire("eHnl8");

var $dSE5S = parcelRequire("dSE5S");
const $ebc74e29a6c3102e$export$4301fcd45f99f8a5 = ({ children: children, api: api })=>{
    const { align: align = 'start', isEnabled: isEnabled } = (0, $5beht.useSharedPluginStateWithSelector)(api, [
        'alignment'
    ], (states)=>{
        var _states$alignmentStat, _states$alignmentStat2;
        return {
            align: (_states$alignmentStat = states.alignmentState) === null || _states$alignmentStat === void 0 ? void 0 : _states$alignmentStat.align,
            isEnabled: (_states$alignmentStat2 = states.alignmentState) === null || _states$alignmentStat2 === void 0 ? void 0 : _states$alignmentStat2.isEnabled
        };
    });
    const { icon: Icon } = (0, $dSE5S.alignmentOptions)()[align];
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const title = formatMessage((0, $2z97M.alignmentMessages).alignment);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $6PDfA.ToolbarDropdownMenu), {
        iconBefore: /*#__PURE__*/ (0, $dc70d.jsx)(Icon, {
            label: "",
            size: "small",
            testId: `text-alignment-menu-${align}-icon`
        }),
        isDisabled: !isEnabled,
        testId: "text-alignment-menu",
        label: title,
        tooltipComponent: /*#__PURE__*/ (0, $dc70d.jsx)((0, $eHnl8.ToolbarTooltip), {
            content: title
        }),
        children: children
    });
};

});
parcelRegister("6PDfA", function(module, exports) {
$parcel$export(module.exports, "ToolbarDropdownMenu", () => $236b42d2b9c9c025$export$fffc3e0cfea7888f);
/* ToolbarDropdownMenu.tsx generated by @compiled/babel-plugin v3.0.2 */ /* ToolbarDropdownMenu.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $14TCm = parcelRequire("14TCm");

var $lkSXl = parcelRequire("lkSXl");

var $gdUUy = parcelRequire("gdUUy");

var $9PwDt = parcelRequire("9PwDt");

var $aBdvW = parcelRequire("aBdvW");

var $7cgYb = parcelRequire("7cgYb");

var $7bYyx = parcelRequire("7bYyx");
const $236b42d2b9c9c025$var$styles = {
    sectionMargin: "_1mouv77o",
    firstSectionSeparator: "_18l8n7od",
    scrollContainer: "_c71lnklw _18m91wug",
    renderToParent: "_1bsb1ris"
};
const $236b42d2b9c9c025$var$ToolbarDropdownMenuContent = ({ iconBefore: iconBefore, tooltipComponent: tooltipComponent, children: children, isDisabled: isDisabled, id: id, testId: testId, label: label, onClick: onClick, shouldRenderToParent: shouldRenderToParent })=>{
    const { onDropdownOpenChanged: onDropdownOpenChanged } = (0, $aBdvW.useToolbarUI)();
    const menuContext = (0, $7bYyx.useToolbarDropdownMenu)();
    const handleOpenChange = (0, $bSJIT.useCallback)((args)=>{
        onDropdownOpenChanged(args);
        if (!args.isOpen) menuContext === null || menuContext === void 0 || menuContext.closeMenu(args.event);
    }, [
        menuContext,
        onDropdownOpenChanged
    ]);
    const handleClick = (0, $bSJIT.useCallback)((e)=>{
        if (!(menuContext !== null && menuContext !== void 0 && menuContext.isOpen)) menuContext === null || menuContext === void 0 || menuContext.openMenu(e);
        else menuContext === null || menuContext === void 0 || menuContext.closeMenu(e);
    }, [
        menuContext
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $lkSXl.default), {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        trigger: (triggerProps)=>{
            const toolbarButton = /*#__PURE__*/ (0, $dc70d.jsx)((0, $7cgYb.ToolbarButton), {
                ref: triggerProps.triggerRef,
                isSelected: triggerProps.isSelected,
                "aria-expanded": triggerProps['aria-expanded'],
                "aria-haspopup": triggerProps['aria-haspopup'],
                "aria-controls": triggerProps['aria-controls'],
                onBlur: triggerProps.onBlur,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                onClick: (e)=>{
                    onClick && onClick(e, !(menuContext !== null && menuContext !== void 0 && menuContext.isOpen));
                    handleClick(e);
                    triggerProps.onClick && triggerProps.onClick(e);
                },
                onFocus: triggerProps.onFocus,
                id: id,
                testId: testId,
                iconBefore: iconBefore,
                isDisabled: isDisabled,
                label: label
            });
            if (tooltipComponent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).cloneElement(tooltipComponent, {
                children: toolbarButton
            });
            return toolbarButton;
        },
        onOpenChange: handleOpenChange,
        isOpen: menuContext === null || menuContext === void 0 ? void 0 : menuContext.isOpen,
        shouldRenderToParent: shouldRenderToParent ? true : undefined,
        strategy: shouldRenderToParent ? 'absolute' : undefined,
        children: children
    });
};
const $236b42d2b9c9c025$export$fffc3e0cfea7888f = ({ iconBefore: iconBefore, children: children, isDisabled: isDisabled, id: id, testId: testId, label: label, hasSectionMargin: hasSectionMargin = true, enableMaxHeight: enableMaxHeight = false, onClick: onClick, tooltipComponent: tooltipComponent, shouldRenderToParent: shouldRenderToParent })=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)($236b42d2b9c9c025$var$ToolbarDropdownMenuContent, {
        iconBefore: iconBefore,
        isDisabled: isDisabled,
        id: id,
        testId: testId,
        label: label,
        onClick: onClick,
        tooltipComponent: tooltipComponent,
        shouldRenderToParent: shouldRenderToParent,
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
            xcss: (0, $14TCm.cx)(hasSectionMargin && $236b42d2b9c9c025$var$styles.sectionMargin, enableMaxHeight && $236b42d2b9c9c025$var$styles.scrollContainer, shouldRenderToParent && (0, $gdUUy.fg)('platform_editor_fix_text_styles_width') && $236b42d2b9c9c025$var$styles.renderToParent, $236b42d2b9c9c025$var$styles.firstSectionSeparator),
            "data-toolbar-component": "menu",
            children: children
        })
    });
};

});
parcelRegister("7cgYb", function(module, exports) {
$parcel$export(module.exports, "ToolbarButton", () => $c705d286e94262c2$export$e5c1a33878e86e9e);
/* ToolbarButton.tsx generated by @compiled/babel-plugin v3.0.2 */ /* ToolbarButton.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $jDsoo = parcelRequire("jDsoo");

var $gXqq0 = parcelRequire("gXqq0");

var $aBdvW = parcelRequire("aBdvW");
const $c705d286e94262c2$var$styles = {
    button: "_zulp12x7 _2rko12b0 _11c8fhey _1e0c1txw _bfhksm61 _o5721q9c _4cvr1h6o _1bah1h6o _1tke1f4h _syazazsu _19bvu2gc _u5f3u2gc _1ah3idpf _g0pbkb7n _oh03h2mm",
    enabled: "_irr31dpa _1di6fcek",
    disabled: "_syaz1gmx _80om13gf",
    selected: "_bfhk15s3 _syaz6x5g _irr3ufnl _1di6nozp"
};
const $c705d286e94262c2$export$e5c1a33878e86e9e = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ iconBefore: iconBefore, children: children, onClick: onClick, isSelected: isSelected, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup, 'aria-controls': ariaControls, 'data-ds--level': dataDsLevel, onBlur: onBlur, onFocus: onFocus, testId: testId, id: id, isDisabled: isDisabled, ariaKeyshortcuts: ariaKeyshortcuts, label: label, interactionName: interactionName, ignoreInteractionDisabled: ignoreInteractionDisabled }, ref)=>{
    const { preventDefaultOnMouseDown: preventDefaultOnMouseDown, isDisabled: ctxDisabled, disabledWithoutInteractionLogic: disabledWithoutInteractionLogic } = (0, $aBdvW.useToolbarUI)();
    // When ignoreInteractionDisabled=true, only use the disabled state without the interaction check
    const disabled = Boolean((ignoreInteractionDisabled ? disabledWithoutInteractionLogic : ctxDisabled) || isDisabled);
    return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $gXqq0.Pressable), {
        ref: ref,
        xcss: (0, $jDsoo.cx)($c705d286e94262c2$var$styles.button, disabled ? $c705d286e94262c2$var$styles.disabled : isSelected ? $c705d286e94262c2$var$styles.selected : $c705d286e94262c2$var$styles.enabled),
        "aria-pressed": Boolean(ariaHasPopup) ? undefined // No aria-pressed for dropdown buttons
         : isSelected,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": ariaHasPopup,
        "aria-controls": ariaControls,
        "aria-keyshortcuts": ariaKeyshortcuts,
        "aria-label": label,
        "data-ds--level": dataDsLevel,
        onClick: onClick,
        onBlur: onBlur,
        onFocus: onFocus,
        testId: testId,
        id: id,
        isDisabled: disabled,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onMouseDown: (event)=>{
            if (preventDefaultOnMouseDown) event.preventDefault();
        },
        "data-toolbar-component": "button",
        "data-selected": isSelected,
        interactionName: interactionName,
        children: [
            iconBefore,
            children
        ]
    });
});

});

parcelRegister("7bYyx", function(module, exports) {
$parcel$export(module.exports, "useToolbarDropdownMenu", () => $eda02e1a49b784c8$export$4a532e97cc88ad2f);
$parcel$export(module.exports, "ToolbarDropdownMenuProvider", () => $eda02e1a49b784c8$export$7baf0d20f25b94dd);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $aBdvW = parcelRequire("aBdvW");
const $eda02e1a49b784c8$var$ToolbarDropdownMenuContext = /*#__PURE__*/ (0, $bSJIT.createContext)(undefined);
const $eda02e1a49b784c8$export$4a532e97cc88ad2f = ()=>{
    return (0, $bSJIT.useContext)($eda02e1a49b784c8$var$ToolbarDropdownMenuContext);
};
const $eda02e1a49b784c8$export$7baf0d20f25b94dd = ({ children: children, isOpen: isOpen, setIsOpen: setIsOpen })=>{
    const [isOpenInternal, setIsOpenInternal] = (0, $bSJIT.useState)(false);
    const { onDropdownOpenChanged: onDropdownOpenChanged } = (0, $aBdvW.useToolbarUI)();
    const openMenu = (event)=>{
        if (setIsOpen !== undefined) setIsOpen(true);
        else setIsOpenInternal(true);
        onDropdownOpenChanged({
            isOpen: true,
            event: event
        });
    };
    const closeMenu = (event)=>{
        if (setIsOpen !== undefined) setIsOpen(false);
        else setIsOpenInternal(false);
        onDropdownOpenChanged({
            isOpen: false,
            event: event
        });
    };
    const contextValue = {
        openMenu: openMenu,
        closeMenu: closeMenu,
        isOpen: isOpen !== undefined ? isOpen : isOpenInternal
    };
    return /*#__PURE__*/ (0, $dc70d.jsx)($eda02e1a49b784c8$var$ToolbarDropdownMenuContext.Provider, {
        value: contextValue,
        children: children
    });
};

});


parcelRegister("eHnl8", function(module, exports) {
$parcel$export(module.exports, "ToolbarTooltip", () => $3e19b4a248f079eb$export$7293ce116b97b92a);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $lavtv = parcelRequire("lavtv");
const $3e19b4a248f079eb$export$7293ce116b97b92a = ({ content: content, shortcut: shortcut, children: children, position: position = 'top', delay: delay })=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $lavtv.default), {
        content: content,
        position: position,
        delay: delay,
        shortcut: shortcut,
        // the information in toolbar tooltips is already announced by aria-label and aria-keyshortcuts on the item
        // so we need to disable screen reader announcement of tooltip to avoid duplicate announcements
        isScreenReaderAnnouncementDisabled: true,
        children: children
    });
};

});

parcelRegister("dSE5S", function(module, exports) {
$parcel$export(module.exports, "alignmentOptions", () => $fdf76e8a17e46dbe$export$8a5a39b03f4aaab);

var $2z97M = parcelRequire("2z97M");

var $cv8id = parcelRequire("cv8id");

var $4rzOL = parcelRequire("4rzOL");

var $fiku8 = parcelRequire("fiku8");

var $gKziX = parcelRequire("gKziX");

var $dvoJo = parcelRequire("dvoJo");

var $i7u95 = parcelRequire("i7u95");
const $fdf76e8a17e46dbe$export$8a5a39b03f4aaab = ()=>({
        start: {
            key: (0, $4rzOL.ALIGN_LEFT_MENU_ITEM).key,
            type: (0, $4rzOL.ALIGN_LEFT_MENU_ITEM).type,
            rank: (0, $fiku8.ALIGNMENT_MENU_SECTION_RANK)[(0, $4rzOL.ALIGN_LEFT_MENU_ITEM).key],
            label: (0, $2z97M.alignmentMessages).alignLeft,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($dvoJo))),
            keymap: (0, $cv8id.alignLeft)
        },
        center: {
            key: (0, $4rzOL.ALIGN_CENTER_MENU_ITEM).key,
            type: (0, $4rzOL.ALIGN_CENTER_MENU_ITEM).type,
            rank: (0, $fiku8.ALIGNMENT_MENU_SECTION_RANK)[(0, $4rzOL.ALIGN_CENTER_MENU_ITEM).key],
            label: (0, $2z97M.alignmentMessages).alignCenter,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($gKziX))),
            keymap: (0, $cv8id.alignCenter)
        },
        end: {
            key: (0, $4rzOL.ALIGN_RIGHT_MENU_ITEM).key,
            type: (0, $4rzOL.ALIGN_RIGHT_MENU_ITEM).type,
            rank: (0, $fiku8.ALIGNMENT_MENU_SECTION_RANK)[(0, $4rzOL.ALIGN_RIGHT_MENU_ITEM).key],
            label: (0, $2z97M.alignmentMessages).alignRight,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($i7u95))),
            keymap: (0, $cv8id.alignRight)
        }
    });

});


parcelRegister("2jPHU", function(module, exports) {
$parcel$export(module.exports, "AlignmentMenuItem", () => $efb992cf0ab3366e$export$ff21a61af4a241d);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $cv8id = parcelRequire("cv8id");

var $96hEQ = parcelRequire("96hEQ");

var $5beht = parcelRequire("5beht");

var $dbuPt = parcelRequire("dbuPt");

var $jBWM2 = parcelRequire("jBWM2");

var $3RNLX = parcelRequire("3RNLX");
const $efb992cf0ab3366e$export$ff21a61af4a241d = ({ option: { label: label, icon: Icon, keymap: keymap }, api: api, alignment: alignment, parents: parents })=>{
    const { align: align } = (0, $5beht.useSharedPluginStateWithSelector)(api, [
        'alignment'
    ], (states)=>{
        var _states$alignmentStat;
        return {
            align: (_states$alignmentStat = states.alignmentState) === null || _states$alignmentStat === void 0 ? void 0 : _states$alignmentStat.align
        };
    });
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const shortcut = (0, $cv8id.tooltip)(keymap);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dbuPt.ToolbarDropdownItem), {
        isSelected: align === alignment,
        elemBefore: /*#__PURE__*/ (0, $dc70d.jsx)(Icon, {
            size: "small",
            label: ""
        }),
        elemAfter: shortcut && /*#__PURE__*/ (0, $dc70d.jsx)((0, $jBWM2.ToolbarKeyboardShortcutHint), {
            shortcut: shortcut
        }),
        ariaKeyshortcuts: (0, $cv8id.getAriaKeyshortcuts)(keymap),
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onClick: ()=>{
            api === null || api === void 0 || api.core.actions.execute((0, $3RNLX.changeAlignmentTr)(api, alignment, (0, $96hEQ.getInputMethodFromParentKeys)(parents)));
        },
        children: formatMessage(label)
    });
};

});
parcelRegister("96hEQ", function(module, exports) {
$parcel$export(module.exports, "getInputMethodFromParentKeys", () => $5717f13f1b49f4ce$export$19f6cf3733198aff);

var $g6Qq4 = parcelRequire("g6Qq4");

var $4rzOL = parcelRequire("4rzOL");
const $5717f13f1b49f4ce$export$19f6cf3733198aff = (parents)=>{
    var _parents$at;
    return ((_parents$at = parents.at(0)) === null || _parents$at === void 0 ? void 0 : _parents$at.key) === (0, $4rzOL.TOOLBARS).INLINE_TEXT_TOOLBAR ? (0, $g6Qq4.INPUT_METHOD).FLOATING_TB : (0, $g6Qq4.INPUT_METHOD).TOOLBAR;
};

});

parcelRegister("dbuPt", function(module, exports) {
$parcel$export(module.exports, "ToolbarDropdownItem", () => $b3bb7b3bbffe48ea$export$abcb00136d206988);
/* ToolbarDropdownItem.tsx generated by @compiled/babel-plugin v3.0.2 */ /* ToolbarDropdownItem.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $jDsoo = parcelRequire("jDsoo");

var $ag7mU = parcelRequire("ag7mU");

var $bLXMw = parcelRequire("bLXMw");

var $9PwDt = parcelRequire("9PwDt");

var $gXqq0 = parcelRequire("gXqq0");

var $7bYyx = parcelRequire("7bYyx");
const $b3bb7b3bbffe48ea$var$styles = {
    toolbarDropdownItem: "_11c8fhey _18zrutpp _1rjc1b66 _1e0c1txw _kqswh2mm _bfhksm61 _1bsb1osq _1tkezwfg _1ul9eoa3 _syazazsu _1bas12b0 _1ah31i6y",
    anchor: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1053azsu _9oik1r31 _1bnxglyw _jf4cnqa1 _30l3azsu",
    enabled: "_irr31dpa _1di6fcek",
    disabled: "_syaz1gmx _80om13gf",
    selected: "_bfhk15s3 _syaz6x5g _irr3ufnl _1di6nozp",
    elemAfterText: "_18u012x7"
};
const $b3bb7b3bbffe48ea$var$CustomDropdownMenuItemButton = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ children: children, 'data-testid': testId, 'aria-haspopup': ariaHasPopup, 'aria-disabled': ariaDisabled, 'aria-pressed': ariaPressed, 'aria-keyshortcuts': ariaKeyshortcuts, onClick: onClick, onBlur: onBlur, onFocus: onFocus, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, tabIndex: tabIndex, title: title, 'data-extension-item-key': dataExtensionItemKey, itemRole: itemRole }, ref)=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $gXqq0.Pressable), {
        role: itemRole || 'menuitem',
        testId: testId,
        xcss: (0, $jDsoo.cx)($b3bb7b3bbffe48ea$var$styles.toolbarDropdownItem, ariaDisabled ? $b3bb7b3bbffe48ea$var$styles.disabled : ariaPressed ? $b3bb7b3bbffe48ea$var$styles.selected : $b3bb7b3bbffe48ea$var$styles.enabled),
        onClick: onClick,
        onBlur: onBlur,
        onFocus: onFocus,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        tabIndex: tabIndex,
        "aria-haspopup": ariaHasPopup,
        "aria-expanded": ariaHasPopup ? ariaPressed ? true : false : undefined,
        "aria-checked": itemRole === 'menuitemradio' || itemRole === 'menuitemcheckbox' ? ariaPressed : undefined,
        "aria-disabled": ariaDisabled,
        "aria-keyshortcuts": ariaKeyshortcuts,
        "data-toolbar-component": "menu-item",
        ref: ref,
        title: title,
        "data-extension-item-key": dataExtensionItemKey,
        children: children
    }));
const $b3bb7b3bbffe48ea$var$CustomDropdownMenuItemAnchor = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ children: children, 'data-testid': testId, 'aria-haspopup': ariaHasPopup, 'aria-disabled': ariaDisabled, 'aria-pressed': ariaPressed, 'aria-keyshortcuts': ariaKeyshortcuts, onClick: onClick, onBlur: onBlur, onFocus: onFocus, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, tabIndex: tabIndex, href: href, target: target, rel: rel, title: title, itemRole: itemRole, ...dataAttributes }, ref)=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $bLXMw.Anchor), {
        role: itemRole || 'menuitem',
        testId: testId,
        xcss: (0, $jDsoo.cx)($b3bb7b3bbffe48ea$var$styles.toolbarDropdownItem, $b3bb7b3bbffe48ea$var$styles.anchor, ariaDisabled ? $b3bb7b3bbffe48ea$var$styles.disabled : ariaPressed ? $b3bb7b3bbffe48ea$var$styles.selected : $b3bb7b3bbffe48ea$var$styles.enabled),
        onClick: onClick,
        onBlur: onBlur,
        onFocus: onFocus,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        tabIndex: tabIndex,
        "aria-haspopup": ariaHasPopup,
        "aria-expanded": ariaHasPopup ? ariaPressed ? true : false : undefined,
        "aria-checked": itemRole === 'menuitemradio' || itemRole === 'menuitemcheckbox' ? ariaPressed : undefined,
        "aria-disabled": ariaDisabled,
        "aria-keyshortcuts": ariaKeyshortcuts,
        "data-toolbar-component": "menu-item",
        ref: ref,
        href: href,
        target: target,
        rel: rel,
        title: title,
        ...dataAttributes,
        children: children
    }));
const $b3bb7b3bbffe48ea$export$abcb00136d206988 = ({ onClick: onClick, onBlur: onBlur, onFocus: onFocus, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, elemBefore: elemBefore, elemAfter: elemAfter, elemAfterText: elemAfterText, isSelected: isSelected, children: children, isDisabled: isDisabled, hasNestedDropdownMenu: hasNestedDropdownMenu, triggerRef: triggerRef, title: title, shouldTitleWrap: shouldTitleWrap = true, testId: testId, ariaKeyshortcuts: ariaKeyshortcuts, href: href, target: target, rel: rel, role: role, ...dataAttributes })=>{
    const parentContext = (0, $7bYyx.useToolbarDropdownMenu)();
    const injectedElemAfter = (()=>{
        if (!/*#__PURE__*/ (0, $bSJIT.isValidElement)(elemAfter)) return elemAfter;
        const elementProps = elemAfter.props;
        if ('isDisabled' in elementProps) return elemAfter;
        return /*#__PURE__*/ (0, $bSJIT.cloneElement)(elemAfter, {
            ...elementProps,
            isDisabled: isDisabled
        });
    })();
    return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $ag7mU.default), {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onClick: (e)=>{
            if (!hasNestedDropdownMenu) parentContext === null || parentContext === void 0 || parentContext.closeMenu(e);
            onClick === null || onClick === void 0 || onClick(e);
        },
        onBlur: onBlur,
        onFocus: onFocus,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        elemBefore: elemBefore,
        elemAfter: injectedElemAfter,
        isSelected: isSelected,
        isDisabled: isDisabled,
        "aria-haspopup": hasNestedDropdownMenu,
        "aria-pressed": isSelected,
        "aria-keyshortcuts": ariaKeyshortcuts,
        itemRole: role,
        ref: triggerRef,
        href: href,
        target: target,
        rel: rel,
        // @ts-ignore -- This `CustomDropdownMenuItemButton` has type conflicts with the `DropdownItem` component in a way that cannot be reconciled (ignored as it fails types in Jira and should in Platform)
        component: href ? $b3bb7b3bbffe48ea$var$CustomDropdownMenuItemAnchor : $b3bb7b3bbffe48ea$var$CustomDropdownMenuItemButton,
        testId: testId,
        "data-toolbar-component": "menu-item",
        title: title,
        shouldTitleWrap: shouldTitleWrap,
        ...dataAttributes,
        children: [
            children,
            elemAfterText ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
                as: "span",
                xcss: $b3bb7b3bbffe48ea$var$styles.elemAfterText,
                children: elemAfterText
            }) : null
        ]
    });
};

});

parcelRegister("jBWM2", function(module, exports) {
$parcel$export(module.exports, "ToolbarKeyboardShortcutHint", () => $6af7b31d2b4f067a$export$f433dac65060f723);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $8xlF3 = parcelRequire("8xlF3");

var $8aT4G = parcelRequire("8aT4G");
const $6af7b31d2b4f067a$export$f433dac65060f723 = ({ shortcut: shortcut, isDisabled: isDisabled })=>{
    if (isDisabled) return /*#__PURE__*/ (0, $dc70d.jsx)((0, $8xlF3.default), {
        appearance: "inverse",
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $8aT4G.Text), {
            color: "color.text.disabled",
            children: shortcut
        })
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $8xlF3.default), {
        children: shortcut
    });
};

});


parcelRegister("1rBu3", function(module, exports) {
$parcel$export(module.exports, "MenuSection", () => $7ffd2781b47683d1$export$4b1545b4f2016d26);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $4rzOL = parcelRequire("4rzOL");

var $dlk6h = parcelRequire("dlk6h");
const $7ffd2781b47683d1$export$4b1545b4f2016d26 = ({ children: children, title: title, parents: parents })=>{
    const hasSeparator = parents.some((parent)=>parent.key === (0, $4rzOL.TEXT_COLLAPSED_MENU).key);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dlk6h.ToolbarDropdownItemSection), {
        hasSeparator: hasSeparator,
        title: title,
        children: children
    });
};

});



parcelRegister("3TnFr", function(module, exports) {
$parcel$export(module.exports, "pluginFactory", () => $4b493af464112545$export$3dd00fb488ab385a);
/**
 * Creates a ProseMirror plugin's state and handles UI updates.
 *
 * Here's a few things to keep in mind:
 * - plugin's state is stored as a single object
 * - `Reducer` specifies how plugin's state changes in response to commands
 * - `Command` describes only what happen, but not how state changes
 * - `mapping` could be used to map ProseMirror positions stored in plugin's state
 *
 * Example:
 *  const { createPluginState, createCommand, getPluginState } = pluginFactory(
 *    reducer,
 *    pluginKey
 *  );
 *
 *  export const createPlugin = (dispatch: Dispatch, initialState) =>
 *    new SafePlugin({
 *      state: createPluginState(dispatch, initialState),
 *      key: pluginKey
 *    });
 *
 * Example of a reducer:
 *
 *  export const reducer = (
 *    state: TablePluginState,
 *    action: TableAction,
 *  ): TablePluginState => {
 *    switch (action.type) {
 *      case 'TOGGLE_CONTEXTUAL_MENU':
 *      return {
 *        ...state,
 *        isContextualMenuOpen: !state.isContextualMenuOpen,
 *      };
 *    default:
 *      return state;
 *    }
 *  };
 *
 *
 * Example of a command:
 *
 * export const toggleContextualMenu = createCommand({
 *   type: 'TOGGLE_CONTEXTUAL_MENU',
 * }, tr => tr.setMeta('addToHistory', false));
 *
 */ // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $4b493af464112545$var$isFunction(x) {
    return typeof x === 'function';
}
function $4b493af464112545$export$3dd00fb488ab385a(pluginKey, reducer, options = {}) {
    const { mapping: mapping, onDocChanged: onDocChanged, onSelectionChanged: onSelectionChanged } = options;
    return {
        createPluginState (dispatch, initialState) {
            return {
                init: (_, state)=>$4b493af464112545$var$isFunction(initialState) ? initialState(state) : initialState,
                apply: (tr, _pluginState, _oldEditorState, newEditorState)=>{
                    const oldPluginState = mapping ? mapping(tr, _pluginState, newEditorState) : _pluginState;
                    let newPluginState = oldPluginState;
                    const meta = tr.getMeta(pluginKey);
                    if (meta) newPluginState = reducer(oldPluginState, meta);
                    if (onDocChanged && tr.docChanged) newPluginState = onDocChanged(tr, newPluginState, newEditorState);
                    else if (onSelectionChanged && tr.selectionSet) newPluginState = onSelectionChanged(tr, newPluginState, newEditorState);
                    if (newPluginState !== oldPluginState) dispatch(pluginKey, newPluginState);
                    return newPluginState;
                }
            };
        },
        createCommand (action, transform) {
            return (state, dispatch)=>{
                if (dispatch) {
                    const tr = transform ? transform(state.tr, state) : state.tr;
                    const resolvedAction = $4b493af464112545$var$isFunction(action) ? action(state) : action;
                    if (tr && resolvedAction) dispatch(tr.setMeta(pluginKey, resolvedAction));
                    else return false;
                }
                return true;
            };
        },
        getPluginState (state) {
            return pluginKey.getState(state);
        }
    };
}

});

parcelRegister("hpVfr", function(module, exports) {
$parcel$export(module.exports, "currentMediaNodeWithPos", () => $616aabfa8b46f026$export$22e4c8c04f58169d);

var $cw0wu = parcelRequire("cw0wu");
const $616aabfa8b46f026$export$22e4c8c04f58169d = (editorState)=>{
    const { doc: doc, selection: selection, schema: schema } = editorState;
    if (!doc || !selection || !(selection instanceof (0, $cw0wu.NodeSelection)) || selection.node.type !== schema.nodes.mediaSingle) return;
    const pos = selection.$anchor.pos + 1;
    const node = doc.nodeAt(pos);
    if (!node || node.type !== schema.nodes.media) return;
    return {
        node: node,
        pos: pos
    };
};

});

parcelRegister("fGjxM", function(module, exports) {
$parcel$export(module.exports, "applyMarkOnRange", () => $9b8b2650ebc07ea9$export$94a1aa532f5398df);
$parcel$export(module.exports, "toggleMark", () => $9b8b2650ebc07ea9$export$797ad2667b8015a8);

var $cw0wu = parcelRequire("cw0wu");

var $2E7OD = parcelRequire("2E7OD");

var $gdUUy = parcelRequire("gdUUy");

var $aPnf6 = parcelRequire("aPnf6");


const $9b8b2650ebc07ea9$var$SMART_TO_ASCII = {
    "\u2026": '...',
    "\u2192": '->',
    "\u2190": '<-',
    "\u2013": '--',
    "\u201C": '"',
    "\u201D": '"',
    "\u2018": "'",
    "\u2019": "'"
};
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $9b8b2650ebc07ea9$var$FIND_SMART_CHAR = new RegExp(`[${Object.keys($9b8b2650ebc07ea9$var$SMART_TO_ASCII).join('')}]`, 'g');
function $9b8b2650ebc07ea9$export$abc5e6e01568db39(from, to, tr) {
    const { doc: doc } = tr;
    const { schema: schema } = doc.type;
    const { mention: mentionNodeType, text: textNodeType, emoji: emojiNodeType, inlineCard: inlineCardNodeType } = schema.nodes;
    const nodesToChange = [];
    doc.nodesBetween(from, to, (node, pos, _parent)=>{
        if ([
            mentionNodeType,
            textNodeType,
            emojiNodeType,
            inlineCardNodeType
        ].includes(node.type)) nodesToChange.push({
            node: node,
            pos: pos
        });
    });
    nodesToChange.forEach(({ node: node, pos: pos })=>{
        if (node.type !== textNodeType) {
            const newText = node.attrs.url || // url for inlineCard
            node.attrs.text || `${node.type.name} text missing`; // fallback for missing text
            const currentPos = tr.mapping.map(pos);
            tr.replaceWith(currentPos, currentPos + node.nodeSize, schema.text(newText, node.marks));
        } else if (node.text) {
            // Find a valid start and end position because the text may be partially selected.
            const startPositionInSelection = Math.max(pos, from);
            const endPositionInSelection = Math.min(pos + node.nodeSize, to);
            const textForReplacing = doc.textBetween(startPositionInSelection, endPositionInSelection);
            // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
            const newText = textForReplacing.replace($9b8b2650ebc07ea9$var$FIND_SMART_CHAR, (match)=>$9b8b2650ebc07ea9$var$SMART_TO_ASCII[match] ?? match);
            const currentStartPos = tr.mapping.map(startPositionInSelection);
            const currentEndPos = tr.mapping.map(endPositionInSelection);
            tr.replaceWith(currentStartPos, currentEndPos, schema.text(newText, node.marks));
        }
    });
}
const $9b8b2650ebc07ea9$export$94a1aa532f5398df = (from, to, removeMark, mark, tr)=>{
    const { schema: schema } = tr.doc.type;
    const { code: code } = schema.marks;
    if (mark.type === code) $9b8b2650ebc07ea9$export$abc5e6e01568db39(from, to, tr);
    tr.doc.nodesBetween(tr.mapping.map(from), tr.mapping.map(to), (node, pos)=>{
        if ((0, $gdUUy.fg)('editor_inline_comments_on_inline_nodes')) {
            if (!node.isText) {
                const isAllowedInlineNode = [
                    'emoji',
                    'status',
                    'date',
                    'mention',
                    'inlineCard'
                ].includes(node.type.name);
                if (!isAllowedInlineNode) return true;
            }
        } else {
            if (!node.isText) return true;
        }
        // This is an issue when the user selects some text.
        // We need to check if the current node position is less than the range selection from.
        // If it’s true, that means we should apply the mark using the range selection,
        // not the current node position.
        const nodeBetweenFrom = Math.max(pos, tr.mapping.map(from));
        const nodeBetweenTo = Math.min(pos + node.nodeSize, tr.mapping.map(to));
        if (removeMark) tr.removeMark(nodeBetweenFrom, nodeBetweenTo, mark);
        else tr.addMark(nodeBetweenFrom, nodeBetweenTo, mark);
        return true;
    });
    return tr;
};
const $9b8b2650ebc07ea9$var$toggleMarkInRange = (mark)=>({ tr: tr })=>{
        if (tr.selection instanceof (0, $2E7OD.CellSelection)) {
            let removeMark = true;
            const cells = [];
            tr.selection.forEachCell((cell, cellPos)=>{
                cells.push({
                    node: cell,
                    pos: cellPos
                });
                const from = cellPos;
                const to = cellPos + cell.nodeSize;
                removeMark && (removeMark = (0, $aPnf6.entireSelectionContainsMark)(mark, tr.doc, from, to));
            });
            for(let i = cells.length - 1; i >= 0; i--){
                const cell = cells[i];
                const from = cell.pos;
                const to = from + cell.node.nodeSize;
                $9b8b2650ebc07ea9$export$94a1aa532f5398df(from, to, removeMark, mark, tr);
            }
        } else {
            const { $from: $from, $to: $to } = tr.selection;
            // We decide to remove the mark only if the entire selection contains the mark
            // Examples with *bold* text
            // Scenario 1: Selection contains both bold and non-bold text -> bold entire selection
            // Scenario 2: Selection contains only bold text -> un-bold entire selection
            // Scenario 3: Selection contains no bold text -> bold entire selection
            const removeMark = (0, $aPnf6.entireSelectionContainsMark)(mark, tr.doc, $from.pos, $to.pos);
            $9b8b2650ebc07ea9$export$94a1aa532f5398df($from.pos, $to.pos, removeMark, mark, tr);
        }
        if (tr.docChanged) return tr;
        return null;
    };
const $9b8b2650ebc07ea9$export$797ad2667b8015a8 = (markType, attrs)=>({ tr: tr })=>{
        const mark = markType.create(attrs);
        // For cursor selections we can use the default behaviour.
        if (tr.selection instanceof (0, $cw0wu.TextSelection) && tr.selection.$cursor) {
            if (mark.isInSet(tr.storedMarks || tr.selection.$cursor.marks())) tr.removeStoredMark(mark);
            else tr.addStoredMark(mark);
            return tr;
        }
        return $9b8b2650ebc07ea9$var$toggleMarkInRange(mark)({
            tr: tr
        });
    };

});
parcelRegister("aPnf6", function(module, exports) {
$parcel$export(module.exports, "entireSelectionContainsMark", () => $4d1027daf7538c7c$export$cc5a5f0a00f537f5);
const $4d1027daf7538c7c$export$cc5a5f0a00f537f5 = (mark, doc, fromPos, toPos)=>{
    let onlyContainsMark = true;
    doc.nodesBetween(fromPos, toPos, (node)=>{
        // Skip recursion once we've found text which doesn't include the mark
        if (!onlyContainsMark) return false;
        if (node.isText) onlyContainsMark && (onlyContainsMark = !!(mark !== null && mark !== void 0 && mark.isInSet(node.marks)));
    });
    return onlyContainsMark;
};

});


parcelRegister("auga3", function(module, exports) {
$parcel$export(module.exports, "removeMark", () => $827e217a84f4eec1$export$5c9d031211c1b7c9);

var $cw0wu = parcelRequire("cw0wu");

var $2E7OD = parcelRequire("2E7OD");
const $827e217a84f4eec1$export$5c9d031211c1b7c9 = (mark)=>({ tr: tr })=>{
        const { selection: selection } = tr;
        if (selection instanceof (0, $2E7OD.CellSelection)) selection.forEachCell((cell, cellPos)=>{
            const from = cellPos;
            const to = cellPos + cell.nodeSize;
            tr.removeMark(from, to, mark);
        });
        else if (selection instanceof (0, $cw0wu.TextSelection) && selection.$cursor) tr.removeStoredMark(mark);
        else {
            const { from: from, to: to } = selection;
            tr.removeMark(from, to, mark);
        }
        return tr;
    };

});

parcelRegister("hpQD7", function(module, exports) {
$parcel$export(module.exports, "findNodePosByLocalIds", () => $2ca8dab5eb81a9e4$export$947fc26275418e36);
const $2ca8dab5eb81a9e4$export$947fc26275418e36 = (state, ids, option = {})=>{
    var _state$doc$attrs;
    if (ids.length === 0) return [];
    const nodes = [];
    const localIdSet = new Set(ids);
    if (option.includeDocNode && localIdSet.has((_state$doc$attrs = state.doc.attrs) === null || _state$doc$attrs === void 0 ? void 0 : _state$doc$attrs.localId)) nodes.push({
        node: state.doc,
        pos: 0
    });
    state.doc.descendants((node, pos)=>{
        var _node$attrs;
        if (localIdSet.has((_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId)) nodes.push({
            node: node,
            pos: pos
        });
        // stop traversing once we found all the nodes
        return localIdSet.size !== nodes.length;
    });
    return nodes;
};

});

parcelRegister("inSrS", function(module, exports) {
$parcel$export(module.exports, "calculateToolbarPositionAboveSelection", () => $9a32350dc1bdd2e4$export$5966a251e0deb6ac);
$parcel$export(module.exports, "calculateToolbarPositionTrackHead", () => $9a32350dc1bdd2e4$export$4fdfbe77de19eec);
$parcel$export(module.exports, "calculateToolbarPositionOnCellSelection", () => $9a32350dc1bdd2e4$export$2d9cc331fb808a87);

var $gab48 = parcelRequire("gab48");

var $2E7OD = parcelRequire("2E7OD");
const $9a32350dc1bdd2e4$var$MAXIMUM_BROWSER_SCROLLBAR_WIDTH = 20;
const $9a32350dc1bdd2e4$export$5966a251e0deb6ac = (toolbarTitle)=>(editorView, nextPos)=>{
        const toolbar = document.querySelector(`div[aria-label="${toolbarTitle}"]`);
        if (!toolbar) return nextPos;
        // scroll wrapper for full page, fall back to document body
        // Ignored via go/ees007
        // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
        // TODO: look into using getScrollGutterOptions()
        const scrollWrapper = editorView.dom.closest('.fabric-editor-popup-scroll-parent') || document.body;
        const wrapperBounds = scrollWrapper.getBoundingClientRect();
        const selection = window && window.getSelection();
        const range = selection && !selection.isCollapsed && selection.getRangeAt(0);
        if (!range) return nextPos;
        const toolbarRect = toolbar.getBoundingClientRect();
        const { head: head, anchor: anchor } = editorView.state.selection;
        const topCoords = editorView.coordsAtPos(Math.min(head, anchor));
        const bottomCoords = editorView.coordsAtPos(Math.max(head, anchor) - Math.min(range.endOffset, 1));
        let top = (topCoords.top || 0) - toolbarRect.height * 1.5;
        let left = 0;
        // If not on the same line
        if (topCoords.top !== bottomCoords.top) {
            // selecting downwards
            if (head > anchor) left = Math.max(topCoords.right, bottomCoords.right);
            else left = Math.min(topCoords.left, bottomCoords.left);
            /*
         short selection above a long paragraph
         eg. short {<}heading
         The purpose of this text is to show the selection range{>}.
         The horizontal positioning should center around "heading",
         not where it ends at "range".
         Note: if it was "head<b>ing</b>" then it would only center
         around "head". Undesireable but matches the current renderer.
       */ const cliffPosition = range.getClientRects()[0];
            if (cliffPosition.right < left) left = cliffPosition.left + cliffPosition.width / 2;
        } else // Otherwise center on the single line selection
        left = topCoords.left + (bottomCoords.right - topCoords.left) / 2;
        left -= toolbarRect.width / 2;
        // Place toolbar below selection if not sufficient space above
        if (top < wrapperBounds.top) ({ top: top, left: left } = $9a32350dc1bdd2e4$var$getCoordsBelowSelection(bottomCoords, toolbarRect));
        // remap positions from browser document to wrapperBounds
        return {
            top: top - wrapperBounds.top + scrollWrapper.scrollTop,
            left: Math.max(0, left - wrapperBounds.left)
        };
    };
const $9a32350dc1bdd2e4$export$4fdfbe77de19eec = (toolbarTitle)=>(editorView, nextPos)=>{
        const toolbar = document.querySelector(`div[aria-label="${toolbarTitle}"]`);
        if (!toolbar) return nextPos;
        // scroll wrapper for full page, fall back to document body
        // Ignored via go/ees007
        // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
        // TODO: look into using getScrollGutterOptions()
        const scrollWrapper = editorView.dom.closest('.fabric-editor-popup-scroll-parent') || document.body;
        const wrapperBounds = scrollWrapper.getBoundingClientRect();
        const selection = window && window.getSelection();
        const moreRovoOptionsButton = document.querySelector('button[aria-label="More Rovo options"], [aria-label="More Rovo options"]');
        const isMoreRovoOptionsButtonVisible = !!moreRovoOptionsButton && moreRovoOptionsButton instanceof HTMLElement && !!moreRovoOptionsButton.offsetParent;
        let range = null;
        if (isMoreRovoOptionsButtonVisible) {
            if (selection && selection.getRangeAt && selection.rangeCount > 0) {
                const maybeRange = selection.getRangeAt(0);
                if (maybeRange instanceof Range) range = maybeRange;
            }
        } else if (selection && !selection.isCollapsed && selection.getRangeAt && selection.rangeCount > 0) {
            const maybeRange = selection.getRangeAt(0);
            if (maybeRange instanceof Range) range = maybeRange;
        }
        if (!range) return nextPos;
        const toolbarRect = toolbar.getBoundingClientRect();
        const { head: head, anchor: anchor } = editorView.state.selection;
        const topCoords = editorView.coordsAtPos(Math.min(head, anchor));
        const bottomCoords = editorView.coordsAtPos(Math.max(head, anchor) - Math.min(range.endOffset, 1));
        let top;
        // If not the same line, display toolbar below.
        if (head > anchor && topCoords.top !== bottomCoords.top) // We are taking the previous pos to the maxium, so avoid end of line positions
        // returning the next line's rect.
        top = (bottomCoords.top || 0) + toolbarRect.height / 1.15;
        else top = (topCoords.top || 0) - toolbarRect.height * 1.5;
        let left = (head > anchor ? bottomCoords.right : topCoords.left) - toolbarRect.width / 2;
        // Place toolbar below selection if not sufficient space above
        if (top < wrapperBounds.top) ({ top: top, left: left } = $9a32350dc1bdd2e4$var$getCoordsBelowSelection(bottomCoords, toolbarRect));
        let leftCoord = Math.max(0, left - wrapperBounds.left);
        if (leftCoord + toolbarRect.width > wrapperBounds.width) {
            const scrollbarWidth = $9a32350dc1bdd2e4$var$MAXIMUM_BROWSER_SCROLLBAR_WIDTH;
            leftCoord = Math.max(0, wrapperBounds.width - (toolbarRect.width + scrollbarWidth));
        }
        // remap positions from browser document to wrapperBounds
        return {
            top: top - wrapperBounds.top + scrollWrapper.scrollTop,
            left: leftCoord
        };
    };
/**
 * Returns the coordintes at the bottom the selection.
 */ const $9a32350dc1bdd2e4$var$getCoordsBelowSelection = (bottomCoords, toolbarRect)=>{
    return {
        top: (bottomCoords.top || 0) + toolbarRect.height / 1.15,
        left: bottomCoords.right - toolbarRect.width / 2
    };
};
const $9a32350dc1bdd2e4$var$cellSelectionToolbarOffsetTop = 10;
const $9a32350dc1bdd2e4$var$scrollbarWidth = 20;
const $9a32350dc1bdd2e4$var$offsetTopOnColumnSelection = 4;
const $9a32350dc1bdd2e4$export$2d9cc331fb808a87 = (toolbarTitle)=>(editorView, nextPos)=>{
        const toolbar = document.querySelector(`div[aria-label="${toolbarTitle}"]`);
        if (!toolbar) return nextPos;
        const { selection: selection } = editorView.state;
        if (!(selection instanceof (0, $2E7OD.CellSelection))) return nextPos;
        const { $anchorCell: $anchorCell, $headCell: $headCell } = selection;
        const domAtPos = editorView.domAtPos.bind(editorView);
        const anchorCellDOM = (0, $gab48.findDomRefAtPos)($anchorCell.pos, domAtPos);
        const headCellDOM = (0, $gab48.findDomRefAtPos)($headCell.pos, domAtPos);
        if (!(anchorCellDOM instanceof HTMLElement) || !(headCellDOM instanceof HTMLElement)) return nextPos;
        const anchorCellRect = anchorCellDOM.getBoundingClientRect();
        const headCellRect = headCellDOM.getBoundingClientRect();
        const toolbarRect = toolbar.getBoundingClientRect();
        let top;
        if (headCellRect.top <= anchorCellRect.top) // Display Selection toolbar at the top of the selection
        top = headCellRect.top - toolbarRect.height - $9a32350dc1bdd2e4$var$cellSelectionToolbarOffsetTop;
        else // Display Selection toolbar at the bottom of the selection
        top = headCellRect.bottom + $9a32350dc1bdd2e4$var$cellSelectionToolbarOffsetTop;
        // scroll wrapper for full page, fall back to document body
        // Ignored via go/ees007
        // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
        // TODO: look into using getScrollGutterOptions()
        const scrollWrapper = editorView.dom.closest('.fabric-editor-popup-scroll-parent') || document.body;
        const wrapperBounds = scrollWrapper.getBoundingClientRect();
        // Place toolbar below selection if not sufficient space above
        if (top < wrapperBounds.top && headCellRect.top <= anchorCellRect.top) top = anchorCellRect.bottom + $9a32350dc1bdd2e4$var$cellSelectionToolbarOffsetTop;
        let left;
        if (headCellRect.left < anchorCellRect.left) left = headCellRect.left;
        else if (headCellRect.left === anchorCellRect.left) left = headCellRect.left + headCellRect.width / 2;
        else left = headCellRect.right;
        // If a user selected multiple columns via clicking on a drag handle
        // (clicking first on the left column and then shift clicking on the right column),
        // the $headcell stays in place and $anchorcell changes position. If they clicked on the right column
        // and then shift clicked on the left, the $headCell will change while $anchor stays in place.
        // Where is no way to know if user was dragging to select the cells or clicking on the drag handle.
        // So if all cells in columns are selected, we will align the Text Formatting toolbar
        // relative to center of the selected area.
        if (selection.isColSelection()) {
            if (headCellRect.left < anchorCellRect.left) left = headCellRect.left + (anchorCellRect.right - headCellRect.left) / 2;
            else if (headCellRect.left === anchorCellRect.left) left;
            else left = anchorCellRect.left + (headCellRect.right - anchorCellRect.left) / 2;
            // When column is selected, adjust top position to ensure that the toolbar does not
            // touch column drag handle
            top = top - $9a32350dc1bdd2e4$var$offsetTopOnColumnSelection;
        }
        let adjustedLeft = Math.max(0, left - toolbarRect.width / 2 - wrapperBounds.left);
        if (adjustedLeft + toolbarRect.width > wrapperBounds.width) adjustedLeft = Math.max(0, wrapperBounds.width - (toolbarRect.width + $9a32350dc1bdd2e4$var$scrollbarWidth));
        // If the toolbar is to be placed at the bottom of the selection (it happens when
        // there is no sufficient space above) and the bottom of the selection is not in the view,
        // place the toolbar at the bottom of the visible part of selection
        if (selection.isColSelection() && top + toolbarRect.height > wrapperBounds.bottom) top = top - (top - wrapperBounds.bottom) - (toolbarRect.height + 2 * $9a32350dc1bdd2e4$var$cellSelectionToolbarOffsetTop);
        return {
            top: top - wrapperBounds.top + scrollWrapper.scrollTop,
            left: adjustedLeft
        };
    };

});

parcelRegister("cFpoi", function(module, exports) {
$parcel$export(module.exports, "batchAttributeUpdatesPlugin", () => $a394a4a64a06976e$export$5af772f765987c49);

var $fVej6 = parcelRequire("fVej6");
const $a394a4a64a06976e$export$5af772f765987c49 = ()=>{
    return {
        name: 'batchAttributeUpdates',
        actions: {
            batchSteps: $fVej6.batchSteps
        }
    };
};

});
parcelRegister("fVej6", function(module, exports) {
$parcel$export(module.exports, "batchSteps", () => $ac777be75dac4f8e$export$383250d570a1fb48);

var $48ZJc = parcelRequire("48ZJc");

var $4eNaz = parcelRequire("4eNaz");

var $3DNV7 = parcelRequire("3DNV7");
const $ac777be75dac4f8e$export$1ccab2571cac8f23 = (step)=>{
    if (step instanceof (0, $4eNaz.SetAttrsStep)) return {
        position: step.pos,
        attrs: step.attrs
    };
    return {
        position: step.pos,
        attrs: {
            [step.attr]: step.value
        }
    };
};
const $ac777be75dac4f8e$export$2d36bf32f2dffb3e = (steps)=>{
    const mappedData = steps.reduce((acc, step)=>{
        const parsedStep = $ac777be75dac4f8e$export$1ccab2571cac8f23(step);
        const previousAttributes = acc.get(parsedStep.position) || {};
        acc.set(parsedStep.position, {
            ...previousAttributes,
            ...parsedStep.attrs
        });
        return acc;
    }, new Map());
    return Array.from(mappedData, ([position, attrs])=>({
            position: position,
            attrs: attrs
        }));
};
const $ac777be75dac4f8e$var$isValidSteps = (steps)=>{
    const hasInvalidSteps = steps.some((step)=>{
        const isSetAttrsStep = step instanceof (0, $4eNaz.SetAttrsStep);
        const isAttrStep = step instanceof (0, $3DNV7.AttrStep);
        const isValidStep = isSetAttrsStep || isAttrStep;
        return !isValidStep;
    });
    return !hasInvalidSteps;
};
const $ac777be75dac4f8e$export$383250d570a1fb48 = ({ doc: doc, steps: maybeAttrSteps })=>{
    if (!$ac777be75dac4f8e$var$isValidSteps(maybeAttrSteps)) // This is important to avoid any bad usage to ending up with data loss
    throw new Error('BatchAttrsSteps error: Invalid BatchStep usage - non attribute step used');
    const positionsAndAttributesData = $ac777be75dac4f8e$export$2d36bf32f2dffb3e(maybeAttrSteps);
    const data = positionsAndAttributesData.map(({ position: position, attrs: attrs })=>{
        const maybeNode = doc.nodeAt(position);
        if (!maybeNode) throw new Error(`BatchAttrsSteps error: Node does not exist at the position ${position}.`);
        const nodeType = maybeNode.type.name;
        return {
            position: position,
            attrs: attrs,
            nodeType: nodeType
        };
    });
    return new (0, $48ZJc.BatchAttrsStep)(data);
};

});
parcelRegister("48ZJc", function(module, exports) {
$parcel$export(module.exports, "BatchAttrsStep", () => $c75050ec658472fe$export$4fd0fe0f65803356);
// oxlint-disable-next-line import/no-duplicates

var $kW8qW = parcelRequire("kW8qW");

var $3DNV7 = parcelRequire("3DNV7");
parcelRequire("bUbIU");
var $3DNV7 = parcelRequire("3DNV7");
const $c75050ec658472fe$var$stepType = 'batchAttrs';
const $c75050ec658472fe$var$isValidData = (data)=>{
    if (data !== null && !Array.isArray(data)) return false;
    return !data.some((d)=>{
        const invalidPosition = typeof d.position !== 'number';
        const invalidNodeType = typeof d.nodeType !== 'string';
        const invalidAttrs = typeof d.attrs !== 'object';
        return invalidPosition || invalidNodeType || invalidAttrs;
    });
};
class $c75050ec658472fe$export$4fd0fe0f65803356 extends (0, $3DNV7.Step) {
    constructor(data, inverted = false){
        super(), this.data = data, this.inverted = inverted;
    }
    apply(doc) {
        const resultDoc = this.data.reduce((acc, value)=>{
            var _acc$doc;
            if (!acc.doc || acc.failed) return acc;
            const { position: position, attrs: attrs } = value;
            if (acc.doc && position > acc.doc.nodeSize || position < 0) return (0, $3DNV7.StepResult).fail(`Position ${position} out of document range.`);
            const target = (_acc$doc = acc.doc) === null || _acc$doc === void 0 ? void 0 : _acc$doc.nodeAt(position);
            if (!target) return (0, $3DNV7.StepResult).fail(`No node at given position: ${position}`);
            if (target.isText) return (0, $3DNV7.StepResult).fail('Target is a text node. Attributes are not allowed.');
            const mergedAttrs = {
                ...target.attrs || {},
                ...attrs || {}
            };
            const updatedNode = target.type.create(mergedAttrs, null, target.marks);
            const slice = new (0, $kW8qW.Slice)((0, $kW8qW.Fragment).from(updatedNode), 0, target.isLeaf ? 0 : 1);
            return (0, $3DNV7.StepResult).fromReplace(acc.doc, position, position + 1, slice);
        }, (0, $3DNV7.StepResult).ok(doc));
        return resultDoc;
    }
    invert(doc) {
        const previousData = this.data.reduce((acc, value)=>{
            const { position: position, nodeType: nodeType, attrs: nextAttrs } = value;
            if (position > doc.nodeSize) return acc;
            const target = doc.nodeAt(position);
            if (!target) return acc;
            if (target.isText) return acc;
            const previousAttrs = Object.keys(nextAttrs).reduce((attributesIterator, key)=>{
                const oldValue = target.attrs[key];
                attributesIterator[key] = oldValue;
                return attributesIterator;
            }, {});
            const prev = {
                position: position,
                nodeType: nodeType,
                attrs: previousAttrs
            };
            acc.push(prev);
            return acc;
        }, []);
        return new $c75050ec658472fe$export$4fd0fe0f65803356(previousData, true);
    }
    map(mapping) {
        const mappedData = this.data.reduce((acc, value)=>{
            const { position: position } = value;
            const mappedPosition = mapping.mapResult(position);
            if (mappedPosition.deleted) return acc;
            acc.push({
                ...value,
                position: mappedPosition.pos
            });
            return acc;
        }, []);
        if (mappedData.length === 0) return null;
        return new $c75050ec658472fe$export$4fd0fe0f65803356(mappedData, this.inverted);
    }
    toJSON() {
        return {
            stepType: $c75050ec658472fe$var$stepType,
            data: this.data,
            inverted: this.inverted
        };
    }
    static fromJSON(_schema, json) {
        const data = json === null || json === void 0 ? void 0 : json.data;
        if (!$c75050ec658472fe$var$isValidData(data)) throw new Error('Invalid input for BatchAttrsStep.fromJSON');
        return new $c75050ec658472fe$export$4fd0fe0f65803356(data, Boolean(json.inverted));
    }
}
(0, $3DNV7.Step).jsonID($c75050ec658472fe$var$stepType, $c75050ec658472fe$export$4fd0fe0f65803356);

});

parcelRegister("4eNaz", function(module, exports) {
$parcel$export(module.exports, "SetAttrsStep", () => $0431a3a3ca22733f$export$8cfd0a0bfa522949);

var $kW8qW = parcelRequire("kW8qW");

var $3DNV7 = parcelRequire("3DNV7");
parcelRequire("bUbIU");
var $3DNV7 = parcelRequire("3DNV7");
class $0431a3a3ca22733f$export$8cfd0a0bfa522949 extends (0, $3DNV7.Step) {
    constructor(pos, attrs){
        super();
        this.pos = pos;
        this.attrs = attrs;
    }
    apply(doc) {
        const target = doc.nodeAt(this.pos);
        if (!target) return (0, $3DNV7.StepResult).fail('No node at given position');
        if (target.isText) return (0, $3DNV7.StepResult).fail('Target is a text node. Attributes are not allowed.');
        const attrs = {
            ...target.attrs || {},
            ...this.attrs || {}
        };
        const newNode = target.type.create(attrs, (0, $kW8qW.Fragment).empty, target.marks);
        const slice = new (0, $kW8qW.Slice)((0, $kW8qW.Fragment).from(newNode), 0, target.isLeaf ? 0 : 1);
        return (0, $3DNV7.StepResult).fromReplace(doc, this.pos, this.pos + 1, slice);
    }
    invert(doc) {
        const target = doc.nodeAt(this.pos);
        return new $0431a3a3ca22733f$export$8cfd0a0bfa522949(this.pos, target ? target.attrs : {});
    }
    map(mapping) {
        const result = mapping.mapResult(this.pos, 1);
        return result.deleted ? null : new $0431a3a3ca22733f$export$8cfd0a0bfa522949(result.pos, this.attrs);
    }
    toJSON() {
        return {
            stepType: 'setAttrs',
            pos: this.pos,
            attrs: this.attrs
        };
    }
    static fromJSON(_schema, json) {
        if (typeof json.pos !== 'number' || json.attrs !== null && typeof json.attrs !== 'object') throw new RangeError('Invalid input for SetAttrsStep.fromJSON');
        return new $0431a3a3ca22733f$export$8cfd0a0bfa522949(json.pos, json.attrs);
    }
}
(0, $3DNV7.Step).jsonID('setAttrs', $0431a3a3ca22733f$export$8cfd0a0bfa522949);

});



parcelRegister("dALum", function(module, exports) {
$parcel$export(module.exports, "BLOCK_CONTROLS_LEFT_SURFACE", () => $12d829ea6b6ce788$export$76a6a1a11bf37303);
$parcel$export(module.exports, "BLOCK_CONTROLS_RIGHT_SURFACE", () => $12d829ea6b6ce788$export$5a6c50f695285558);
$parcel$export(module.exports, "BLOCK_CONTROLS_LEFT_SECTION", () => $12d829ea6b6ce788$export$9fddb3a143534e39);
$parcel$export(module.exports, "BLOCK_CONTROLS_LEFT_GROUP", () => $12d829ea6b6ce788$export$208f300edc77a23d);
$parcel$export(module.exports, "BLOCK_CONTROLS_DRAG_HANDLE", () => $12d829ea6b6ce788$export$9e969878f70f6975);
$parcel$export(module.exports, "BLOCK_CONTROLS_RIGHT_SECTION", () => $12d829ea6b6ce788$export$73f1b163e50ec1f);
$parcel$export(module.exports, "BLOCK_CONTROLS_RIGHT_GROUP", () => $12d829ea6b6ce788$export$85ebfa09f7b0b850);
/**
 * Stable identifiers for registry-backed block-control surfaces and their layout containers.
 * They live in editor-common so contributors do not depend on the Block Controls plugin.
 */ const $12d829ea6b6ce788$export$76a6a1a11bf37303 = {
    key: 'block-controls-left',
    type: 'toolbar'
};
const $12d829ea6b6ce788$export$5a6c50f695285558 = {
    key: 'block-controls-right',
    type: 'toolbar'
};
const $12d829ea6b6ce788$export$9fddb3a143534e39 = {
    key: 'block-controls-left-section',
    type: 'section'
};
const $12d829ea6b6ce788$export$208f300edc77a23d = {
    key: 'block-controls-left-group',
    type: 'group'
};
const $12d829ea6b6ce788$export$9e969878f70f6975 = {
    key: 'block-controls-drag-handle',
    type: 'button'
};
const $12d829ea6b6ce788$export$73f1b163e50ec1f = {
    key: 'block-controls-right-section',
    type: 'section'
};
const $12d829ea6b6ce788$export$85ebfa09f7b0b850 = {
    key: 'block-controls-right-group',
    type: 'group'
};

});

parcelRegister("5ameN", function(module, exports) {
$parcel$export(module.exports, "expandSelectionBounds", () => $fbe0ad9364372bbe$export$748c2428d313e6d0);
const $fbe0ad9364372bbe$export$748c2428d313e6d0 = ($anchor, $head)=>{
    const sharedDepth = $anchor.sharedDepth($head.pos) + 1;
    const $from = $anchor.min($head);
    const $to = $anchor.max($head);
    const fromDepth = $from.depth;
    const toDepth = $to.depth;
    let selectionStart;
    let selectionEnd;
    const selectionHasGrandparent = toDepth > 1 && fromDepth > 1;
    const selectionIsAcrossDiffParents = selectionHasGrandparent && !$to.parent.isTextblock && !$to.sameParent($from);
    const selectionIsAcrossTextBlocksWithDiffParents = selectionHasGrandparent && $to.parent.isTextblock && $to.before(toDepth - 1) !== $from.before(fromDepth - 1);
    if (toDepth > fromDepth) {
        selectionStart = $from.before(sharedDepth);
        selectionEnd = $to.after(sharedDepth);
    } else if (toDepth < fromDepth) {
        selectionStart = $from.before(sharedDepth);
        selectionEnd = $to.after(sharedDepth);
    } else if (selectionIsAcrossDiffParents || selectionIsAcrossTextBlocksWithDiffParents) {
        // when selection from/to share same depth with different parents, hoist up the selection to the parent of the highest depth in the selection
        selectionStart = $from.before(sharedDepth);
        selectionEnd = $to.after(sharedDepth);
    } else if (!$from.node().inlineContent) // when selection might be a Node selection, return what was passed in
    return {
        $anchor: $anchor,
        $head: $head
    };
    else {
        selectionStart = fromDepth ? $from.before() : $from.pos;
        selectionEnd = toDepth ? $to.after() : $to.pos;
    }
    const $expandedFrom = $anchor.doc.resolve(selectionStart);
    const $expandedTo = $anchor.doc.resolve(selectionEnd);
    return {
        $anchor: $anchor === $from ? $expandedFrom : $expandedTo,
        $head: $head === $to ? $expandedTo : $expandedFrom
    };
};

});

parcelRegister("8qHhy", function(module, exports) {
$parcel$export(module.exports, "areToolbarFlagsEnabled", () => $703b3cd691826553$export$c6d9af905adcabd8);

var $797yE = parcelRequire("797yE");
const $703b3cd691826553$export$c6d9af905adcabd8 = (isNewToolbarEnabled)=>Boolean((0, $797yE.editorExperiment)('platform_editor_controls', 'variant1') || isNewToolbarEnabled);

});

parcelRegister("6Cbfp", function(module, exports) {
$parcel$export(module.exports, "atTheEndOfBlock", () => $3c1c7b9b7ed0cbe3$export$6f303ca7dac350ae);
$parcel$export(module.exports, "atTheBeginningOfBlock", () => $3c1c7b9b7ed0cbe3$export$8351d833af62ae68);
$parcel$export(module.exports, "selectionIsAtTheBeginningOfBlock", () => $3c1c7b9b7ed0cbe3$export$dba2543e302d55ed);
$parcel$export(module.exports, "deleteSelectedRange", () => $3c1c7b9b7ed0cbe3$export$2c0117b92050cffe);
$parcel$export(module.exports, "expandToBlockRange", () => $3c1c7b9b7ed0cbe3$export$f69f5016bc6a173);
$parcel$export(module.exports, "expandSelectionToBlockRange", () => $3c1c7b9b7ed0cbe3$export$cf7b5a42a57ba7c7);
$parcel$export(module.exports, "isMultiBlockSelection", () => $3c1c7b9b7ed0cbe3$export$87365ac27c0f1ed1);
$parcel$export(module.exports, "getSourceNodesFromSelectionRange", () => $3c1c7b9b7ed0cbe3$export$d9d2142e5263c662);

var $cw0wu = parcelRequire("cw0wu");

var $5BCfR = parcelRequire("5BCfR");
var $czibn = parcelRequire("czibn");

var $iE5F1 = parcelRequire("iE5F1");

var $BqAL4 = parcelRequire("BqAL4");

var $j7pt0 = parcelRequire("j7pt0");

var $kf85x = parcelRequire("kf85x");

var $7k00C = parcelRequire("7k00C");





function $3c1c7b9b7ed0cbe3$export$6f303ca7dac350ae(state) {
    const { selection: selection } = state;
    const { $to: $to } = selection;
    if (selection instanceof (0, $j7pt0.GapCursorSelection)) return false;
    if (selection instanceof (0, $cw0wu.NodeSelection) && selection.node.isBlock) return true;
    return (0, $BqAL4.endPositionOfParent)($to) === $to.pos + 1;
}
function $3c1c7b9b7ed0cbe3$export$8351d833af62ae68(state) {
    const { selection: selection } = state;
    return $3c1c7b9b7ed0cbe3$export$dba2543e302d55ed(selection);
}
function $3c1c7b9b7ed0cbe3$export$dba2543e302d55ed(selection) {
    const { $from: $from } = selection;
    if (selection instanceof (0, $j7pt0.GapCursorSelection)) return false;
    if (selection instanceof (0, $cw0wu.NodeSelection) && selection.node.isBlock) return true;
    return (0, $7k00C.startPositionOfParent)($from) === $from.pos;
}
const $3c1c7b9b7ed0cbe3$export$2c0117b92050cffe = (tr, selectionToUse)=>{
    const selection = selectionToUse || tr.selection;
    let from = selection.$from.pos;
    let to = selection.$to.pos;
    if (selection instanceof (0, $cw0wu.TextSelection)) {
        // Expand just the from position to the start of the block
        // This ensures entire paragraphs are deleted instead of just
        // the text content, which avoids leaving an empty line behind
        const expanded = $3c1c7b9b7ed0cbe3$export$f69f5016bc6a173(selection.$from, selection.$to);
        from = expanded.$from.pos;
    } else if ((0, $czibn.isTableSelected)(selection)) {
        const table = (0, $5BCfR.findTable)(selection);
        if (table) {
            from = table.pos;
            to = table.pos + table.node.nodeSize;
        }
    }
    tr.deleteRange(from, to);
    return tr;
};
const $3c1c7b9b7ed0cbe3$var$getDefaultPredicate = ({ nodes: nodes })=>{
    const requiresFurtherExpansion = new Set([
        nodes.bulletList,
        nodes.orderedList,
        nodes.taskList,
        nodes.listItem,
        nodes.taskItem,
        nodes.tableHeader,
        nodes.tableRow,
        nodes.tableCell,
        nodes.table,
        nodes.mediaGroup,
        nodes.mediaSingle
    ]);
    return (node)=>!requiresFurtherExpansion.has(node.type);
};
const $3c1c7b9b7ed0cbe3$export$f69f5016bc6a173 = ($from, $to, predicate = $3c1c7b9b7ed0cbe3$var$getDefaultPredicate($from.doc.type.schema))=>{
    const range = $from.blockRange($to, predicate);
    if (!range) return {
        $from: $from,
        $to: $to
    };
    return {
        $from: $from.doc.resolve(range.start),
        $to: $to.doc.resolve(range.end),
        range: range
    };
};
const $3c1c7b9b7ed0cbe3$export$cf7b5a42a57ba7c7 = ({ $from: $from, $to: $to })=>{
    return $3c1c7b9b7ed0cbe3$export$f69f5016bc6a173($from, $to);
};
function $3c1c7b9b7ed0cbe3$export$87365ac27c0f1ed1(selection) {
    const { range: range } = $3c1c7b9b7ed0cbe3$export$cf7b5a42a57ba7c7(selection);
    if (!range) return false;
    return (0, $kf85x.isMultiBlockRange)(range);
}
function $3c1c7b9b7ed0cbe3$export$d9d2142e5263c662(tr, selection) {
    const { $from: $from, $to: $to } = $3c1c7b9b7ed0cbe3$export$cf7b5a42a57ba7c7(selection);
    const selectedParent = $from.parent;
    const isList = (0, $iE5F1.isListNode)(selectedParent);
    const sliceStart = isList ? $from.pos - 1 : $from.pos;
    const sliceEnd = isList ? $to.pos + 1 : $to.pos;
    const slice = tr.doc.slice(sliceStart, sliceEnd);
    return [
        ...slice.content.content
    ];
}

});
parcelRegister("5BCfR", function(module, exports) {
$parcel$export(module.exports, "findTable", () => $0538dda7465183a6$export$1ae6a0a4f7784fc4);

var $gab48 = parcelRequire("gab48");
const $0538dda7465183a6$export$1ae6a0a4f7784fc4 = (selection)=>(0, $gab48.findParentNode)((node)=>node.type.spec.tableRole && node.type.spec.tableRole === 'table')(selection);

});

parcelRegister("czibn", function(module, exports) {
$parcel$export(module.exports, "isTableSelected", () => $9902671cf472aa34$export$5d08de4a0eeb0408);

var $jCYj3 = parcelRequire("jCYj3");

var $ju9YQ = parcelRequire("ju9YQ");

var $8eBXN = parcelRequire("8eBXN");
const $9902671cf472aa34$export$5d08de4a0eeb0408 = (selection)=>{
    if ((0, $8eBXN.isSelectionType)(selection, 'cell')) {
        const map = (0, $jCYj3.TableMap).get(selection.$anchorCell.node(-1));
        return (0, $ju9YQ.isRectSelected)({
            left: 0,
            right: map.width,
            top: 0,
            bottom: map.height
        })(selection);
    }
    return false;
};

});
parcelRegister("ju9YQ", function(module, exports) {
$parcel$export(module.exports, "isRectSelected", () => $46ed3ad2c2fcd9de$export$d06743a3adc2076d);

var $jCYj3 = parcelRequire("jCYj3");

var $8eBXN = parcelRequire("8eBXN");
const $46ed3ad2c2fcd9de$export$d06743a3adc2076d = (rect)=>(selection)=>{
        if (!(0, $8eBXN.isSelectionType)(selection, 'cell')) return false;
        const map = (0, $jCYj3.TableMap).get(selection.$anchorCell.node(-1));
        const start = selection.$anchorCell.start(-1);
        const cells = map.cellsInRect(rect);
        const selectedCells = map.cellsInRect(map.rectBetween(selection.$anchorCell.pos - start, selection.$headCell.pos - start));
        for(let i = 0, count = cells.length; i < count; i++){
            if (selectedCells.indexOf(cells[i]) === -1) return false;
        }
        return true;
    };

});
parcelRegister("8eBXN", function(module, exports) {
$parcel$export(module.exports, "isSelectionType", () => $dc54418b38c61138$export$626dcc173023aed7);
function $dc54418b38c61138$export$626dcc173023aed7(selection, type) {
    if (!selection) return false;
    const serialized = selection.toJSON();
    return serialized.type === type;
}

});



parcelRegister("iE5F1", function(module, exports) {
$parcel$export(module.exports, "isListNode", () => $67d733ee607da42e$export$a7d7d2b9ba4d4dbb);
function $67d733ee607da42e$export$a7d7d2b9ba4d4dbb(node) {
    return Boolean(node && node.type && [
        'orderedList',
        'bulletList'
    ].includes(node.type.name));
}

});

parcelRegister("BqAL4", function(module, exports) {
$parcel$export(module.exports, "endPositionOfParent", () => $97307cd0baa13e6f$export$8e09b50c60354750);
function $97307cd0baa13e6f$export$8e09b50c60354750(resolvedPos) {
    return resolvedPos.end(resolvedPos.depth) + 1;
}

});

parcelRegister("kf85x", function(module, exports) {
$parcel$export(module.exports, "isMultiBlockRange", () => $b4ed8061944df7c2$export$4327aeb0536d2384);
const $b4ed8061944df7c2$export$4327aeb0536d2384 = (range)=>{
    if (range.endIndex - range.startIndex <= 1) return false; // At most one child
    // Count block nodes in the range, return true if more than one
    let blockCount = 0;
    for(let i = range.startIndex; i < range.endIndex; i++){
        if (range.parent.child(i).isBlock) blockCount++;
        if (blockCount > 1) return true;
    }
    return false;
};

});

parcelRegister("7k00C", function(module, exports) {
$parcel$export(module.exports, "startPositionOfParent", () => $5375caf7ebb6cbca$export$ced77c72038c89cb);
function $5375caf7ebb6cbca$export$ced77c72038c89cb(resolvedPos) {
    return resolvedPos.start(resolvedPos.depth);
}

});


parcelRegister("1akDd", function(module, exports) {
$parcel$export(module.exports, "isSelectionAtStartOfNode", () => $c72137b53cf61d61$export$2543715425b0bf0b);
const $c72137b53cf61d61$export$2543715425b0bf0b = ($pos, parentNode)=>{
    if (!parentNode) return false;
    for(let i = $pos.depth + 1; i > 0; i--){
        const node = $pos.node(i);
        if (node && node.eq(parentNode)) break;
        if (i > 1 && $pos.before(i) !== $pos.before(i - 1) + 1) return false;
    }
    return true;
};

});

parcelRegister("k0RsJ", function(module, exports) {
$parcel$export(module.exports, "isSelectionAtEndOfNode", () => $7101d3203e760317$export$5762916b8b83bc6d);
const $7101d3203e760317$export$5762916b8b83bc6d = ($pos, parentNode)=>{
    if (!parentNode) return false;
    for(let i = $pos.depth + 1; i > 0; i--){
        const node = $pos.node(i);
        if (node && node.eq(parentNode)) break;
        if (i > 1 && $pos.after(i) !== $pos.after(i - 1) - 1) return false;
    }
    return true;
};

});

parcelRegister("5iSwO", function(module, exports) {
$parcel$export(module.exports, "atTheBeginningOfDoc", () => $0d2eae66516d80a4$export$e9083e8cbe24bec0);
function $0d2eae66516d80a4$export$e9083e8cbe24bec0(state) {
    const { selection: selection } = state;
    return selection.$from.pos === selection.$from.depth;
}

});

parcelRegister("fdcHc", function(module, exports) {
$parcel$export(module.exports, "DRAG_HANDLE_SELECTOR", () => $f21837754b7bd26c$export$21d634b1d5d9bee3);
$parcel$export(module.exports, "DRAG_HANDLE_WIDTH", () => $f21837754b7bd26c$export$8e6a2e69f746ce30);
$parcel$export(module.exports, "NESTED_DROPDOWN_MENU", () => $f21837754b7bd26c$export$4ca64d379b54b5d9);
const $f21837754b7bd26c$export$21d634b1d5d9bee3 = '[data-editor-block-ctrl-drag-handle]';
const $f21837754b7bd26c$export$8e6a2e69f746ce30 = 12;
const $f21837754b7bd26c$export$4ca64d379b54b5d9 = '[data-toolbar-nested-dropdown-menu]';

});

parcelRegister("7zYtf", function(module, exports) {
$parcel$export(module.exports, "breakoutResizableNodes", () => $7fcf9a07167ea6cc$export$2626b4a7243208a1);
const $7fcf9a07167ea6cc$export$2626b4a7243208a1 = [
    'expand',
    'layoutSection',
    'codeBlock',
    'syncBlock',
    'bodiedSyncBlock'
];

});

parcelRegister("30RfR", function(module, exports) {
$parcel$export(module.exports, "getBreakoutResizableNodes", () => $c84053175fe4d7da$export$6bce50340fc7ba13);

var $3y2s4 = parcelRequire("3y2s4");

var $7zYtf = parcelRequire("7zYtf");
const $c84053175fe4d7da$var$extensionNodes = [
    'extension',
    'bodiedExtension',
    'multiBodiedExtension'
];
const $c84053175fe4d7da$export$6bce50340fc7ba13 = ()=>{
    let breakoutResizableNodesList = (0, $7zYtf.breakoutResizableNodes);
    if ((0, $3y2s4.isExperimentEnabled)('platform_editor_lovability_resize_dividers_panels')) breakoutResizableNodesList = [
        ...breakoutResizableNodesList,
        'rule',
        'panel',
        'panel_c1'
    ];
    if ((0, $3y2s4.isExperimentEnabled)('platform_editor_lovability_resize_extensions')) breakoutResizableNodesList = [
        ...breakoutResizableNodesList,
        ...$c84053175fe4d7da$var$extensionNodes
    ];
    return breakoutResizableNodesList;
};

});

parcelRegister("01Z6w", function(module, exports) {
$parcel$export(module.exports, "getBaseNodeTypeName", () => $a55207bf5e023ee6$export$e7c4aaf94dfc397d);
$parcel$export(module.exports, "isNodeOfSameBaseType", () => $a55207bf5e023ee6$export$7138504956ccb99);
$parcel$export(module.exports, "isNodeTypeValidChildOf", () => $a55207bf5e023ee6$export$5131954471e1003);
$parcel$export(module.exports, "pickPanelTypeForInsertion", () => $a55207bf5e023ee6$export$1dccb55ec61cba15);

var $kW8qW = parcelRequire("kW8qW");
/**
 * Returns the base name of a node type, stripping known variant suffixes.
 */ const $a55207bf5e023ee6$var$variantToBaseNameMap = {
    panel_c1: 'panel'
};
function $a55207bf5e023ee6$export$e7c4aaf94dfc397d(nodeType) {
    return $a55207bf5e023ee6$var$variantToBaseNameMap[nodeType.name] ?? nodeType.name;
}
function $a55207bf5e023ee6$export$7138504956ccb99(a, b) {
    return $a55207bf5e023ee6$export$e7c4aaf94dfc397d(a) === $a55207bf5e023ee6$export$e7c4aaf94dfc397d(b);
}
function $a55207bf5e023ee6$export$5131954471e1003(childTypeName, parentNode, schema) {
    const childType = schema.nodes[childTypeName];
    if (!childType) return false;
    const candidate = childType.createAndFill();
    if (!candidate) return false;
    return parentNode.type.validContent((0, $kW8qW.Fragment).from(candidate));
}
function $a55207bf5e023ee6$export$1dccb55ec61cba15($from) {
    const schema = $from.doc.type.schema;
    const { panel: panel, panel_c1: panel_c1 } = schema.nodes;
    if (!panel_c1) return panel;
    for(let depth = $from.depth; depth >= 0; depth--){
        const parent = $from.node(depth);
        const index = $from.index(depth);
        if (parent.canReplaceWith(index, index, panel_c1)) return panel_c1;
        const spec = parent.type.spec;
        // Stop at isolating containers (e.g. expand, tableCell) — hard walls where
        // the panel stays inside and should use the regular panel type.
        if (spec.isolating) return panel;
    }
    return panel;
}

});

parcelRegister("fUWld", function(module, exports) {
$parcel$export(module.exports, "getParentOfTypeCount", () => $29678597decf299e$export$d5cbd8b17958f08b);
const $29678597decf299e$export$d5cbd8b17958f08b = (nodeType)=>($pos)=>{
        let count = 0;
        // Loop through parent nodes from bottom to top
        for(let depth = $pos.depth; depth > 0; depth--){
            const node = $pos.node(depth);
            // Count the table nodes
            if (node.type === nodeType) count++;
        }
        return count;
    };

});

parcelRegister("a7bfT", function(module, exports) {
$parcel$export(module.exports, "findTableClosestToPos", () => $133c7de1c1c860e0$export$9323c80f9a3e899f);

var $gab48 = parcelRequire("gab48");
const $133c7de1c1c860e0$export$9323c80f9a3e899f = ($pos)=>{
    const predicate = (node)=>node.type.spec.tableRole && node.type.spec.tableRole === 'table';
    return (0, $gab48.findParentNodeClosestToPos)($pos, predicate);
};

});

parcelRegister("6bBgj", function(module, exports) {
$parcel$export(module.exports, "INSERTED_TRAILING_PARAGRAPH_TO_LAST_NODE_META", () => $3d946ff277b3ee36$export$fee081d0fba011ce);
const $3d946ff277b3ee36$export$fee081d0fba011ce = 'insertedTrailingParagraphToLastNode';

});

parcelRegister("56AB9", function(module, exports) {
$parcel$export(module.exports, "pmHistoryPluginKey", () => $7d39a780128d9ddb$export$d4f2631252432abf);
$parcel$export(module.exports, "shallowEqual", () => $7d39a780128d9ddb$export$d36bdfa510afb180);
$parcel$export(module.exports, "isSelectionInsideLastNodeInDocument", () => $7d39a780128d9ddb$export$51bf7c6695e13879);
$parcel$export(module.exports, "isInListItem", () => $7d39a780128d9ddb$export$92d47fcf661e090e);
$parcel$export(module.exports, "findFarthestParentNode", () => $7d39a780128d9ddb$export$6b982788a5f0ccef);
$parcel$export(module.exports, "insideTableCell", () => $7d39a780128d9ddb$export$1350ff12653c84d4);
$parcel$export(module.exports, "checkNodeDown", () => $7d39a780128d9ddb$export$d0951c59cd3dac0f);
$parcel$export(module.exports, "isEmptyNode", () => $7d39a780128d9ddb$export$641fdf56f693bfbc);
$parcel$export(module.exports, "isNodeEmpty", () => $7d39a780128d9ddb$export$cd58ff1081f6abe9);
$parcel$export(module.exports, "isInEmptyLine", () => $7d39a780128d9ddb$export$3b68253250b41118);
$parcel$export(module.exports, "isEmptyParagraph", () => (parcelRequire("24xJB")).isEmptyParagraph);
$parcel$export(module.exports, "hasDocAsParent", () => (parcelRequire("lwCmV")).hasDocAsParent);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ // Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $gab48 = parcelRequire("gab48");

var $lwCmV = parcelRequire("lwCmV");

var $24xJB = parcelRequire("24xJB");

var $hhAGP = parcelRequire("hhAGP");

var $cWyqT = parcelRequire("cWyqT");

var $7XB6A = parcelRequire("7XB6A");

var $ehhh6 = parcelRequire("ehhh6");

var $cOmYT = parcelRequire("cOmYT");

var $12B4z = parcelRequire("12B4z");

var $5eokt = parcelRequire("5eokt");

var $1ej2m = parcelRequire("1ej2m");

var $bzUTH = parcelRequire("bzUTH");

var $5BDGB = parcelRequire("5BDGB");

var $adkFe = parcelRequire("adkFe");

var $aTdXU = parcelRequire("aTdXU");

var $e8ZGk = parcelRequire("e8ZGk");

var $lCS4v = parcelRequire("lCS4v");

var $hcuPh = parcelRequire("hcuPh");

var $6I9KR = parcelRequire("6I9KR");

var $j2OLx = parcelRequire("j2OLx");

var $dEhT6 = parcelRequire("dEhT6");

var $aanyd = parcelRequire("aanyd");

var $7mZGn = parcelRequire("7mZGn");

var $bjG1c = parcelRequire("bjG1c");

var $7zYtf = parcelRequire("7zYtf");

var $4f6lt = parcelRequire("4f6lt");

var $30RfR = parcelRequire("30RfR");

var $5UO9m = parcelRequire("5UO9m");

var $gKvvI = parcelRequire("gKvvI");

var $bRrJF = parcelRequire("bRrJF");

var $cUlhg = parcelRequire("cUlhg");

var $7PvVz = parcelRequire("7PvVz");

var $81ojn = parcelRequire("81ojn");

var $5DWw8 = parcelRequire("5DWw8");

var $kRFDj = parcelRequire("kRFDj");

var $5vR15 = parcelRequire("5vR15");

var $5DJ1z = parcelRequire("5DJ1z");

var $3TnFr = parcelRequire("3TnFr");

var $f3zvU = parcelRequire("f3zvU");

var $4ClnP = parcelRequire("4ClnP");

var $fXN8M = parcelRequire("fXN8M");

var $enEa6 = parcelRequire("enEa6");

var $71ibJ = parcelRequire("71ibJ");

var $1T9YU = parcelRequire("1T9YU");

var $9OQBm = parcelRequire("9OQBm");

var $imwRr = parcelRequire("imwRr");

var $4a3ln = parcelRequire("4a3ln");

var $96ZAq = parcelRequire("96ZAq");

var $lrWkt = parcelRequire("lrWkt");

var $i8aUK = parcelRequire("i8aUK");

var $iBqsj = parcelRequire("iBqsj");

var $hIeOw = parcelRequire("hIeOw");

var $5jtWj = parcelRequire("5jtWj");

var $eRA48 = parcelRequire("eRA48");

var $jqEKs = parcelRequire("jqEKs");

var $iQfR9 = parcelRequire("iQfR9");

var $jRBYX = parcelRequire("jRBYX");

var $ewIHf = parcelRequire("ewIHf");

var $2a0xe = parcelRequire("2a0xe");

var $g4e18 = parcelRequire("g4e18");

var $l7ENf = parcelRequire("l7ENf");

var $aU4zH = parcelRequire("aU4zH");

var $lsbSX = parcelRequire("lsbSX");

var $iiWgs = parcelRequire("iiWgs");

var $dfSJl = parcelRequire("dfSJl");

var $hk8Gf = parcelRequire("hk8Gf");

var $fkNZo = parcelRequire("fkNZo");

var $g5o8N = parcelRequire("g5o8N");

var $kuD5k = parcelRequire("kuD5k");

var $ahwoz = parcelRequire("ahwoz");

var $4gQ3f = parcelRequire("4gQ3f");

var $avkEM = parcelRequire("avkEM");

var $6ygSb = parcelRequire("6ygSb");

var $fdVRQ = parcelRequire("fdVRQ");

var $7RKgO = parcelRequire("7RKgO");

var $fjuP7 = parcelRequire("fjuP7");

var $9v2LJ = parcelRequire("9v2LJ");

var $i6r6F = parcelRequire("i6r6F");

var $13Qhp = parcelRequire("13Qhp");

var $3IDI7 = parcelRequire("3IDI7");

var $7nLBT = parcelRequire("7nLBT");

var $iE5F1 = parcelRequire("iE5F1");

var $4Dhpb = parcelRequire("4Dhpb");

var $4EVbq = parcelRequire("4EVbq");

var $f3Svn = parcelRequire("f3Svn");

var $gdYRL = parcelRequire("gdYRL");

var $amIzn = parcelRequire("amIzn");

var $cgQ5m = parcelRequire("cgQ5m");

var $2P442 = parcelRequire("2P442");

var $6Z6Le = parcelRequire("6Z6Le");

var $98KMe = parcelRequire("98KMe");

var $e4CUM = parcelRequire("e4CUM");

var $cPyt7 = parcelRequire("cPyt7");

var $bCYNR = parcelRequire("bCYNR");

var $asFQ7 = parcelRequire("asFQ7");

var $55o0j = parcelRequire("55o0j");

var $KawKV = parcelRequire("KawKV");

var $fcrbf = parcelRequire("fcrbf");

var $l9Hpy = parcelRequire("l9Hpy");

var $acax3 = parcelRequire("acax3");

var $9PK5v = parcelRequire("9PK5v");

var $6B1yf = parcelRequire("6B1yf");

var $1QLHG = parcelRequire("1QLHG");

var $8gKUV = parcelRequire("8gKUV");

var $8XENo = parcelRequire("8XENo");

var $1wpTP = parcelRequire("1wpTP");

var $h7zC7 = parcelRequire("h7zC7");
var $cSk7K = parcelRequire("cSk7K");

var $9dUiE = parcelRequire("9dUiE");

var $bwDP2 = parcelRequire("bwDP2");

var $0fR8c = parcelRequire("0fR8c");

var $iUiR7 = parcelRequire("iUiR7");

var $33v8M = parcelRequire("33v8M");

var $hfNS8 = parcelRequire("hfNS8");

var $di3Bh = parcelRequire("di3Bh");

var $1SmGf = parcelRequire("1SmGf");

var $9MlgY = parcelRequire("9MlgY");

var $b9WCP = parcelRequire("b9WCP");

var $inSrS = parcelRequire("inSrS");

var $hpQD7 = parcelRequire("hpQD7");

var $ljmZN = parcelRequire("ljmZN");

var $gB6pl = parcelRequire("gB6pl");
const $7d39a780128d9ddb$export$d4f2631252432abf = 'history$';
function $7d39a780128d9ddb$export$d36bdfa510afb180(obj1 = {}, obj2 = {}) {
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);
    return keys1.length === keys2.length && keys1.reduce((acc, key)=>acc && obj1[key] === obj2[key], true);
}
function $7d39a780128d9ddb$export$51bf7c6695e13879(selection) {
    const docNode = selection.$anchor.node(0);
    const rootNode = selection.$anchor.node(1);
    return docNode.lastChild === rootNode;
}
const $7d39a780128d9ddb$export$92d47fcf661e090e = (state)=>{
    return (0, $gab48.hasParentNodeOfType)(state.schema.nodes.listItem)(state.selection);
};
const $7d39a780128d9ddb$export$6b982788a5f0ccef = (predicate)=>($pos)=>{
        let candidate = null;
        for(let i = $pos.depth; i > 0; i--){
            const node = $pos.node(i);
            if (predicate(node)) candidate = {
                pos: i > 0 ? $pos.before(i) : 0,
                start: $pos.start(i),
                depth: i,
                node: node
            };
        }
        return candidate;
    };
const $7d39a780128d9ddb$export$1350ff12653c84d4 = (state)=>{
    const { tableCell: tableCell, tableHeader: tableHeader } = state.schema.nodes;
    return (0, $gab48.hasParentNodeOfType)([
        tableCell,
        tableHeader
    ])(state.selection);
};
/**
 * Traverse the document until an "ancestor" is found. Any nestable block can be an ancestor.
 */ // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $7d39a780128d9ddb$var$findAncestorPosition(doc, pos) {
    const nestableBlocks = [
        'blockquote',
        'bulletList',
        'orderedList'
    ];
    if (pos.depth === 1) return pos;
    let node = pos.node(pos.depth);
    let newPos = pos;
    while(pos.depth >= 1){
        pos = doc.resolve(pos.before(pos.depth));
        node = pos.node(pos.depth);
        if (node && nestableBlocks.indexOf(node.type.name) !== -1) newPos = pos;
    }
    return newPos;
}
function $7d39a780128d9ddb$export$d0951c59cd3dac0f(selection, doc, filter) {
    const ancestorDepth = $7d39a780128d9ddb$var$findAncestorPosition(doc, selection.$to).depth;
    // Top level node
    if (ancestorDepth === 0) return false;
    const res = doc.resolve(selection.$to.after(ancestorDepth));
    return res.nodeAfter ? filter(res.nodeAfter) : false;
}
const $7d39a780128d9ddb$export$641fdf56f693bfbc = (schema)=>{
    const { doc: doc, paragraph: paragraph, expand: expand, codeBlock: codeBlock, blockquote: blockquote, panel: panel, heading: heading, listItem: listItem, bulletList: bulletList, orderedList: orderedList, taskList: taskList, taskItem: taskItem, decisionList: decisionList, decisionItem: decisionItem, media: media, mediaGroup: mediaGroup, mediaSingle: mediaSingle } = schema.nodes;
    const innerIsEmptyNode = (node)=>{
        switch(node.type){
            case media:
            case mediaGroup:
            case mediaSingle:
                return false;
            case paragraph:
            case codeBlock:
            case heading:
            case taskItem:
            case decisionItem:
                return node.content.size === 0;
            case expand:
            case blockquote:
            case panel:
            case listItem:
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                return node.content.size === 2 && innerIsEmptyNode(node.content.firstChild);
            case bulletList:
            case orderedList:
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                return node.content.size === 4 && innerIsEmptyNode(node.content.firstChild);
            case taskList:
            case decisionList:
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                return node.content.size === 2 && innerIsEmptyNode(node.content.firstChild);
            case doc:
                let isEmpty = true;
                node.content.forEach((child)=>{
                    isEmpty = isEmpty && innerIsEmptyNode(child);
                });
                return isEmpty;
            default:
                return $7d39a780128d9ddb$export$cd58ff1081f6abe9(node);
        }
    };
    return innerIsEmptyNode;
};
function $7d39a780128d9ddb$export$cd58ff1081f6abe9(node) {
    if (node && node.textContent) return false;
    if (!node || !node.childCount || node.childCount === 1 && (0, $24xJB.isEmptyParagraph)(node.firstChild)) return true;
    const block = [];
    const nonBlock = [];
    node.forEach((child)=>{
        child.isInline ? nonBlock.push(child) : block.push(child);
    });
    return !nonBlock.length && !block.filter((childNode)=>!!childNode.childCount && !(childNode.childCount === 1 && (0, $24xJB.isEmptyParagraph)(childNode.firstChild)) || childNode.isAtom).length;
}
function $7d39a780128d9ddb$export$3b68253250b41118(state) {
    const { selection: selection } = state;
    const { $cursor: $cursor, $anchor: $anchor } = selection;
    if (!$cursor) return false;
    const node = $cursor.node();
    if (!node) return false;
    return (0, $24xJB.isEmptyParagraph)(node) && (0, $lwCmV.hasDocAsParent)($anchor);
}

});
parcelRegister("lwCmV", function(module, exports) {
$parcel$export(module.exports, "hasDocAsParent", () => $d95d78ea15bd935a$export$f76a7d770092ea11);
function $d95d78ea15bd935a$export$f76a7d770092ea11($anchor) {
    return $anchor.depth === 1;
}

});

parcelRegister("7XB6A", function(module, exports) {
$parcel$export(module.exports, "getExtensionLozengeData", () => $5ccfb39b24200488$export$4fd8ecadd193bea0);
const $5ccfb39b24200488$export$4fd8ecadd193bea0 = ({ node: node, type: type })=>{
    if (!node.attrs.parameters) return;
    const { macroMetadata: macroMetadata } = node.attrs.parameters;
    // EDITOR-4007: guard against non-array placeholder to prevent `TypeError: ... forEach is not a function`.
    const hasValidPlaceholder = macroMetadata && Array.isArray(macroMetadata.placeholder);
    if (hasValidPlaceholder) {
        let placeholderData;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        macroMetadata.placeholder.forEach((placeholder)=>{
            if (placeholder.type === type && placeholder.data && placeholder.data.url) placeholderData = placeholder.data;
        });
        return placeholderData;
    }
    return;
};

});

parcelRegister("12B4z", function(module, exports) {
$parcel$export(module.exports, "stepAddsOneOf", () => $5d9715042b3ba452$export$f4d51ccab05f55c9);
$parcel$export(module.exports, "removeBlockMarks", () => $5d9715042b3ba452$export$fba8af3b998832b9);

var $aanyd = parcelRequire("aanyd");













function $5d9715042b3ba452$export$f4d51ccab05f55c9(step, nodeTypes) {
    let adds = false;
    if (!(0, $aanyd.stepHasSlice)(step)) return adds;
    step.slice.content.descendants((node)=>{
        if (nodeTypes.has(node.type)) adds = true;
        return !adds;
    });
    return adds;
}
const $5d9715042b3ba452$export$fba8af3b998832b9 = (state, marks)=>{
    const { selection: selection, schema: schema } = state;
    let { tr: tr } = state;
    // Marks might not exist in Schema
    const marksToRemove = marks.filter(Boolean);
    if (marksToRemove.length === 0) return undefined;
    /** Saves an extra dispatch */ let blockMarksExists = false;
    const hasMark = (mark)=>marksToRemove.indexOf(mark.type) > -1;
    /**
   * When you need to toggle the selection
   * when another type which does not allow alignment is applied
   */ state.doc.nodesBetween(selection.from, selection.to, (node, pos)=>{
        if (node.type === schema.nodes.paragraph && node.marks.some(hasMark)) {
            blockMarksExists = true;
            const resolvedPos = state.doc.resolve(pos);
            const withoutBlockMarks = node.marks.filter($5d9715042b3ba452$var$not(hasMark));
            tr = tr.setNodeMarkup(resolvedPos.pos, undefined, node.attrs, withoutBlockMarks);
        }
    });
    return blockMarksExists ? tr : undefined;
};
const $5d9715042b3ba452$var$not = (fn)=>(arg)=>!fn(arg);

});
parcelRegister("aanyd", function(module, exports) {
$parcel$export(module.exports, "stepHasSlice", () => $8bf9e3a0f8c5736e$export$53780b185b887309);
const $8bf9e3a0f8c5736e$export$53780b185b887309 = (step)=>step && step.hasOwnProperty('slice');

});


parcelRegister("5eokt", function(module, exports) {
$parcel$export(module.exports, "extractSliceFromStep", () => $49e7ed2c857708a0$export$d0a9dfe2556a9577);

var $3DNV7 = parcelRequire("3DNV7");
const $49e7ed2c857708a0$export$d0a9dfe2556a9577 = (step)=>{
    if (!(step instanceof (0, $3DNV7.ReplaceStep)) && !(step instanceof (0, $3DNV7.ReplaceAroundStep))) return null;
    // However, we need to read it to found if the step was adding a newline
    const slice = step.slice;
    return slice;
};

});

parcelRegister("1ej2m", function(module, exports) {
$parcel$export(module.exports, "filterChildrenBetween", () => $fc849e668adde42f$export$e46323d96cf32194);
function $fc849e668adde42f$export$e46323d96cf32194(doc, from, to, predicate) {
    const results = [];
    doc.nodesBetween(from, to, (node, pos, parent)=>{
        if (predicate(node, pos, parent)) results.push({
            node: node,
            pos: pos
        });
    });
    return results;
}

});

parcelRegister("bzUTH", function(module, exports) {
$parcel$export(module.exports, "isElementInTableCell", () => $a25d493b751700af$export$5588122b9eea7733);

var $enEa6 = parcelRequire("enEa6");
const $a25d493b751700af$export$5588122b9eea7733 = (element)=>{
    return (0, $enEa6.closest)(element, 'td, th');
};

});

parcelRegister("5BDGB", function(module, exports) {
$parcel$export(module.exports, "isInLayoutColumn", () => $25b36ce41c705e71$export$2de06a6e688827fd);

var $gab48 = parcelRequire("gab48");
const $25b36ce41c705e71$export$2de06a6e688827fd = (state)=>{
    return (0, $gab48.hasParentNodeOfType)(state.schema.nodes.layoutSection)(state.selection);
};

});

parcelRegister("adkFe", function(module, exports) {
$parcel$export(module.exports, "isLastItemMediaGroup", () => $2b71d9371641b28c$export$142c0ee6457f50d6);
const $2b71d9371641b28c$export$142c0ee6457f50d6 = (node)=>{
    const { content: content } = node;
    return !!content.lastChild && content.lastChild.type.name === 'mediaGroup';
};

});

parcelRegister("aTdXU", function(module, exports) {
$parcel$export(module.exports, "isTextSelection", () => $cbf690e11c348713$export$38b50bf35e79aaf3);

var $cw0wu = parcelRequire("cw0wu");
const $cbf690e11c348713$export$38b50bf35e79aaf3 = (selection)=>selection instanceof (0, $cw0wu.TextSelection);

});

parcelRegister("e8ZGk", function(module, exports) {
$parcel$export(module.exports, "isValidPosition", () => $c6a46e69638e1ee0$export$de0495c7bd37bf4e);
const $c6a46e69638e1ee0$export$de0495c7bd37bf4e = (pos, state)=>{
    if (typeof pos !== 'number') return false;
    if (pos >= 0 && pos <= state.doc.resolve(0).end()) return true;
    return false;
};

});

parcelRegister("lCS4v", function(module, exports) {
$parcel$export(module.exports, "nonNullable", () => $a2774a417a748d99$export$26128561c93f5847);
function $a2774a417a748d99$export$26128561c93f5847(value) {
    return value !== null && value !== undefined;
}

});

parcelRegister("hcuPh", function(module, exports) {
$parcel$export(module.exports, "setAllSelection", () => $4d7575d2d5bbe7b4$export$abad69d764760c05);

var $cw0wu = parcelRequire("cw0wu");
function $4d7575d2d5bbe7b4$export$abad69d764760c05(view) {
    const { state: state, dispatch: dispatch } = view;
    const tr = state.tr.setSelection(new (0, $cw0wu.AllSelection)(view.state.doc));
    dispatch(tr);
}

});

parcelRegister("6I9KR", function(module, exports) {
$parcel$export(module.exports, "setCellSelection", () => $ef88646d146d654d$export$8f10f8581a0e9ba2);

var $2E7OD = parcelRequire("2E7OD");
function $ef88646d146d654d$export$8f10f8581a0e9ba2(view, anchor, head) {
    const { state: state, dispatch: dispatch } = view;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    dispatch(state.tr.setSelection((0, $2E7OD.CellSelection).create(state.doc, anchor, head)));
}

});

parcelRegister("j2OLx", function(module, exports) {
$parcel$export(module.exports, "setNodeSelection", () => $25ef3798a2e90cda$export$a367515ca2c9ace1);

var $cw0wu = parcelRequire("cw0wu");
const $25ef3798a2e90cda$export$a367515ca2c9ace1 = (view, pos)=>{
    const { state: state, dispatch: dispatch } = view;
    if (!isFinite(pos)) return;
    const tr = state.tr.setSelection((0, $cw0wu.NodeSelection).create(state.doc, pos));
    dispatch(tr);
};

});

parcelRegister("dEhT6", function(module, exports) {
$parcel$export(module.exports, "setTextSelection", () => $0a383d9173fcc7d0$export$1df6d14df6b0b758);

var $cw0wu = parcelRequire("cw0wu");
function $0a383d9173fcc7d0$export$1df6d14df6b0b758(view, anchor, head) {
    const { state: state, dispatch: dispatch } = view;
    const tr = state.tr.setSelection((0, $cw0wu.TextSelection).create(state.doc, anchor, head));
    dispatch(tr);
}

});

parcelRegister("4f6lt", function(module, exports) {
$parcel$export(module.exports, "getBreakoutResizableNodeTypes", () => $34b3eac27a024298$export$c2c078d93ed82790);
const $34b3eac27a024298$export$c2c078d93ed82790 = (schema, isRuleAndPanelResizingEnabled = false)=>{
    const { expand: expand, codeBlock: codeBlock, layoutSection: layoutSection, syncBlock: syncBlock, bodiedSyncBlock: bodiedSyncBlock, rule: rule, panel: panel, panel_c1: panel_c1 } = schema.nodes;
    const breakoutResizableNodeTypes = [
        expand,
        codeBlock,
        layoutSection,
        syncBlock,
        bodiedSyncBlock
    ];
    if (isRuleAndPanelResizingEnabled) breakoutResizableNodeTypes.push(rule, panel, panel_c1);
    return new Set(breakoutResizableNodeTypes);
};

});

parcelRegister("5UO9m", function(module, exports) {
$parcel$export(module.exports, "getBreakoutResizableNodeTypesNew", () => $8b0f70414891d5ed$export$7c479d9dbea59bfe);

var $3y2s4 = parcelRequire("3y2s4");
const $8b0f70414891d5ed$export$7c479d9dbea59bfe = (schema)=>{
    const { expand: expand, codeBlock: codeBlock, layoutSection: layoutSection, syncBlock: syncBlock, bodiedSyncBlock: bodiedSyncBlock, rule: rule, panel: panel, panel_c1: panel_c1, extension: extension, bodiedExtension: bodiedExtension, multiBodiedExtension: multiBodiedExtension } = schema.nodes;
    const breakoutResizableNodeTypes = [
        expand,
        codeBlock,
        layoutSection,
        syncBlock,
        bodiedSyncBlock
    ];
    if ((0, $3y2s4.isExperimentEnabled)('platform_editor_lovability_resize_dividers_panels')) breakoutResizableNodeTypes.push(rule, panel, panel_c1);
    if ((0, $3y2s4.isExperimentEnabled)('platform_editor_lovability_resize_extensions')) breakoutResizableNodeTypes.push(extension, bodiedExtension, multiBodiedExtension);
    return new Set(breakoutResizableNodeTypes);
};

});

parcelRegister("gKvvI", function(module, exports) {
$parcel$export(module.exports, "getNextBreakoutMode", () => $6867897c5c706b00$export$7eb758567e6644fd);
const $6867897c5c706b00$export$7eb758567e6644fd = (currentMode)=>{
    if (currentMode === 'full-width') return 'center';
    else if (currentMode === 'wide') return 'full-width';
    return 'wide';
};

});

parcelRegister("bRrJF", function(module, exports) {
$parcel$export(module.exports, "getTitle", () => $2d2e051a85282e03$export$70d1bf7729efff40);

var $fNLdd = parcelRequire("fNLdd");
const $2d2e051a85282e03$export$70d1bf7729efff40 = (layout)=>{
    switch(layout){
        case 'full-width':
            return (0, $fNLdd.default).layoutFixedWidth;
        case 'wide':
            return (0, $fNLdd.default).layoutFullWidth;
        default:
            return (0, $fNLdd.default).layoutWide;
    }
};

});

parcelRegister("7PvVz", function(module, exports) {
$parcel$export(module.exports, "findChangedNodesFromTransaction", () => $3a5fe5b3f7a545c5$export$cdc577fd3f583194);
const $3a5fe5b3f7a545c5$export$cdc577fd3f583194 = (tr)=>{
    const nodes = [];
    const steps = tr.steps || [];
    steps.forEach((step)=>{
        step.getMap().forEach((_oldStart, _oldEnd, newStart, newEnd)=>{
            tr.doc.nodesBetween(newStart, Math.min(newEnd, tr.doc.content.size), (node)=>{
                if (!nodes.find((n)=>n === node)) nodes.push(node);
                return false;
            });
        });
    });
    return nodes;
};

});

parcelRegister("81ojn", function(module, exports) {
$parcel$export(module.exports, "isMediaNode", () => $09559bce054b0925$export$d6ca4605aefeca32);
const $09559bce054b0925$export$d6ca4605aefeca32 = (node)=>{
    return [
        'media',
        'mediaInline',
        'mediaGroup',
        'mediaSingle'
    ].includes(node.type.name);
};

});

parcelRegister("5DWw8", function(module, exports) {
$parcel$export(module.exports, "isNodeBeforeMediaNode", () => $08baa178b495ab9f$export$cfaa7840b0c93780);

var $gab48 = parcelRequire("gab48");
const $08baa178b495ab9f$export$cfaa7840b0c93780 = ($pos, state)=>{
    let nodeBefore = $pos.nodeBefore;
    if (!nodeBefore) {
        const depthOfParent = $pos.depth - 1 || 1;
        const parentNode = (0, $gab48.findParentNodeOfType)([
            state.schema.nodes[`${$pos.node(depthOfParent).type.name}`]
        ])(state.selection);
        const resolvedPosOfParentNode = parentNode ? state.tr.doc.resolve(parentNode.pos) : undefined;
        const nodeBeforeParent = resolvedPosOfParentNode && resolvedPosOfParentNode.pos < state.doc.nodeSize ? resolvedPosOfParentNode.nodeBefore : undefined;
        if (nodeBeforeParent) nodeBefore = nodeBeforeParent;
    }
    if (nodeBefore) return [
        'media',
        'mediaInline',
        'mediaGroup',
        'mediaSingle'
    ].includes(nodeBefore.type.name);
    return false;
};

});

parcelRegister("kRFDj", function(module, exports) {
$parcel$export(module.exports, "isSupportedInParent", () => $acd96269a6ea9faf$export$b6e38334b1fb4d1b);
const $acd96269a6ea9faf$export$b6e38334b1fb4d1b = (state, fragment, currentAppearance)=>{
    const depth = currentAppearance === 'embed' || currentAppearance === 'block' ? undefined : -1;
    const parent = state.selection.$from.node(depth);
    return parent && parent.type.validContent(fragment);
};

});

parcelRegister("1T9YU", function(module, exports) {
$parcel$export(module.exports, "removeNestedEmptyEls", () => $85cc9137c766954a$export$5b66dc78851adb5e);
/**
 * Walks up DOM removing elements if they are empty until it finds
 * one that is not
 */ function $85cc9137c766954a$export$5b66dc78851adb5e(el) {
    while(el.parentElement && el.childElementCount === 0 && el.textContent === ''){
        const parentEl = el.parentElement;
        parentEl.removeChild(el);
        el = parentEl;
    }
}

});

parcelRegister("9OQBm", function(module, exports) {
$parcel$export(module.exports, "unwrap", () => $878011471af73d57$export$debb760848ca95a);
/**
 * Takes all children out from wrapped el and puts them directly inside
 * the parent el, at the wrapped el's position
 */ function $878011471af73d57$export$debb760848ca95a(parent, wrapped) {
    const docsFragment = document.createDocumentFragment();
    Array.from(wrapped.children).forEach((child)=>{
        docsFragment.appendChild(child);
    });
    parent.replaceChild(docsFragment, wrapped);
}

});

parcelRegister("imwRr", function(module, exports) {
$parcel$export(module.exports, "walkUpTreeUntil", () => $7eb897bc93463fd2$export$df14aaf7a527ab0c);
/**
 * Walks a DOM tree up to the provided `stopElement`, or if falsy before.
 * @param element
 * @param stopElement
 */ function $7eb897bc93463fd2$export$df14aaf7a527ab0c(element, shouldStop) {
    let rootElement = element;
    while(rootElement && rootElement.parentElement && !shouldStop(rootElement))rootElement = rootElement.parentElement;
    return rootElement;
}

});

parcelRegister("4a3ln", function(module, exports) {
$parcel$export(module.exports, "default", () => $fd55e50b0a83ab78$export$2e2bcd8739ae039);
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
class $fd55e50b0a83ab78$var$ADFTraversor {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(doc){
        this.subscribers = new Map();
        this.doc = doc;
    }
    subscribe(type, callback) {
        const callbacks = this.subscribers.get(type);
        if (!callbacks) this.subscribers.set(type, [
            callback
        ]);
        else callbacks.push(callback);
    }
    exec() {
        if (!this.doc || !Array.isArray(this.doc.content)) return;
        let candidates = this.doc.content.slice(0);
        while(candidates.length){
            const node = candidates.shift();
            if (Array.isArray(node.content)) candidates = candidates.concat(node.content);
            const callbacks = this.subscribers.get(node.type);
            if (!callbacks) continue;
            for(let i = 0; i < callbacks.length; i++)callbacks[i](node);
        }
    }
}
var $fd55e50b0a83ab78$export$2e2bcd8739ae039 = $fd55e50b0a83ab78$var$ADFTraversor;

});

parcelRegister("iQfR9", function(module, exports) {
$parcel$export(module.exports, "startMeasure", () => $64ea585791792e33$export$b62aa2130c86b59b);
$parcel$export(module.exports, "stopMeasure", () => $64ea585791792e33$export$37c25be427bec097);
$parcel$export(module.exports, "clearMeasure", () => $64ea585791792e33$export$6f766653554dac02);

var $jRBYX = parcelRequire("jRBYX");
const $64ea585791792e33$var$measureMap = new Map();
function $64ea585791792e33$export$b62aa2130c86b59b(measureName) {
    if (!(0, $jRBYX.isPerformanceAPIAvailable)()) return;
    performance.mark(`${measureName}::start`);
    $64ea585791792e33$var$measureMap.set(measureName, performance.now());
}
function $64ea585791792e33$export$37c25be427bec097(measureName, onMeasureComplete) {
    if (!(0, $jRBYX.isPerformanceAPIAvailable)()) return;
    performance.mark(`${measureName}::end`);
    const start = onMeasureComplete ? $64ea585791792e33$var$measureMap.get(measureName) : undefined;
    try {
        performance.measure(measureName, `${measureName}::start`, `${measureName}::end`);
    } catch (error) {} finally{
        if (onMeasureComplete) {
            const entry = performance.getEntriesByName(measureName).pop();
            if (entry) onMeasureComplete(entry.duration, entry.startTime);
            else if (start) onMeasureComplete(performance.now() - start, start);
        }
        $64ea585791792e33$export$6f766653554dac02(measureName);
    }
}
function $64ea585791792e33$export$6f766653554dac02(measureName) {
    if (!(0, $jRBYX.isPerformanceAPIAvailable)()) return;
    $64ea585791792e33$var$measureMap.delete(measureName);
    performance.clearMarks(`${measureName}::start`);
    performance.clearMarks(`${measureName}::end`);
    performance.clearMeasures(measureName);
}

});

parcelRegister("iiWgs", function(module, exports) {
$parcel$export(module.exports, "isPositionNearTableRow", () => $b9c478033ecfc3c1$export$889a8e446452be16);
function $b9c478033ecfc3c1$export$889a8e446452be16(pos, schema, direction) {
    if (!schema.nodes.tableRow) return false;
    const doc = pos.doc;
    let resolved = pos;
    const sibling = direction === 'before' ? 'nodeBefore' : 'nodeAfter';
    while(resolved.depth > 0){
        var _resolved$sibling;
        const siblingType = (_resolved$sibling = resolved[sibling]) === null || _resolved$sibling === void 0 ? void 0 : _resolved$sibling.type;
        if (siblingType === schema.nodes.tableRow) return true;
        resolved = doc.resolve(resolved[direction]());
    }
    return false;
}

});

parcelRegister("g5o8N", function(module, exports) {
$parcel$export(module.exports, "isTextInput", () => $7db0965fb2fdb2c6$export$3e6057b9bf6b0bbb);

var $3DNV7 = parcelRequire("3DNV7");
const $7db0965fb2fdb2c6$export$3e6057b9bf6b0bbb = (tr)=>{
    const [step] = tr.steps;
    if (!step || !(step instanceof (0, $3DNV7.ReplaceStep))) return false;
    const { slice: { content: content }, from: from, to: to } = step;
    const char = content.firstChild;
    return from === to && content.childCount === 1 && !!char && !!char.text && char.text.length === 1;
};

});

parcelRegister("kuD5k", function(module, exports) {
$parcel$export(module.exports, "ZERO_WIDTH_SPACE", () => $cfe7026eba0c9ad9$export$15a09f5ef055bcfa);
$parcel$export(module.exports, "ZERO_WIDTH_JOINER", () => $cfe7026eba0c9ad9$export$2b4d00c13dcd3c1f);
const $cfe7026eba0c9ad9$export$15a09f5ef055bcfa = '\u200b';
const $cfe7026eba0c9ad9$export$2b4d00c13dcd3c1f = '\u200d';

});

parcelRegister("4gQ3f", function(module, exports) {
$parcel$export(module.exports, "getModeFromTheme", () => $021f67aaf4431694$export$182aef7d0c8bdba7);
// Resolves the provided mode into either 'dark' or 'light'.
function $021f67aaf4431694$export$182aef7d0c8bdba7(theme) {
    return theme === 'dark' ? 'dark' : 'light';
}

});

parcelRegister("avkEM", function(module, exports) {
$parcel$export(module.exports, "sniffUserBrowserExtensions", () => $4d623dd53f12fd93$export$4cd1ca2600761f65);
const $4d623dd53f12fd93$var$registerDetectors = (targetExtensions, supportedDetectors)=>{
    const detectors = supportedDetectors.filter((registration)=>targetExtensions.includes(registration.name));
    return detectors.map((detector)=>({
            name: detector.name,
            state: {
                detected: false
            },
            fns: {
                async: detector.fns.async,
                sync: detector.fns.sync
            }
        }));
};
const $4d623dd53f12fd93$var$RACE_COMPLETE = 'race_complete';
const $4d623dd53f12fd93$var$SELECTORS = {
    GRAMMARLY: 'grammarly-extension, grammarly-popups, [data-grammarly-shadow-root]'
};
/**
 * This is the official list of supported browser extension detectors. To add support
 * for detecting an additional browser extension, simply add a (DetectorRegistration)
 * object like below to the list:
 *
 * ```
 * {
 *  name: 'exampleExtension',
 *  fns: {
 *    // a synchronous check that should return true if the extension is detected
 *    sync: () => !!document.querySelector(".some-example-class"),
 *    // an asynchronous check that should invoke 'detected' if the extension is detected.
 *    // it can also invoke 'cleanup' with a callback to schedule cleanup tasks
 *    // (such as disconnecting observers).
 *    async: (detected, cleanup) => {
 *      if (document.querySelector(".some-example-class")) {
 *        detected();
 *      }
 *    }
 *  }
 * }
 * ```
 */ const $4d623dd53f12fd93$var$supportedDetectors = [
    {
        name: 'grammarly',
        fns: {
            sync: ()=>{
                var _document;
                return Boolean((_document = document) === null || _document === void 0 ? void 0 : _document.querySelector($4d623dd53f12fd93$var$SELECTORS.GRAMMARLY));
            },
            async: (detected, cleanup)=>{
                var _document2;
                // First check to see if grammarly already exists on page
                const exists = Boolean((_document2 = document) === null || _document2 === void 0 ? void 0 : _document2.querySelector($4d623dd53f12fd93$var$SELECTORS.GRAMMARLY));
                if (exists) detected();
                // Otherwise, setup a mutation observer to observe the page and its children
                // for newly added nodes. Collect observed mutations in a queue and in 1 second
                // intervals either process the queue or schedule the processing task for when
                // the user agent's main thread is idle (if possible).
                let queue = [];
                const processQueue = ()=>{
                    for (const mutations of queue)for (const mutation of mutations){
                        var _mutation$addedNodes;
                        if ((mutation === null || mutation === void 0 ? void 0 : mutation.type) === 'childList' && mutation !== null && mutation !== void 0 && (_mutation$addedNodes = mutation.addedNodes) !== null && _mutation$addedNodes !== void 0 && _mutation$addedNodes.length) {
                            const exists = Array.from(mutation.addedNodes).some((node)=>{
                                var _node$parentElement;
                                return (_node$parentElement = node.parentElement) === null || _node$parentElement === void 0 ? void 0 : _node$parentElement.querySelector($4d623dd53f12fd93$var$SELECTORS.GRAMMARLY);
                            });
                            if (exists) detected();
                        }
                    }
                    queue = [];
                };
                const intervalId = setInterval(()=>{
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    if (typeof window.requestIdleCallback === 'function') // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    window.requestIdleCallback(processQueue);
                    else window.requestAnimationFrame(processQueue);
                }, 1000);
                const observer = new MutationObserver((mutations)=>{
                    queue.push(mutations);
                });
                cleanup(()=>{
                    queue = [];
                    clearInterval(intervalId);
                    observer === null || observer === void 0 || observer.disconnect();
                });
                observer.observe(document.documentElement, {
                    childList: true,
                    subtree: true
                });
            }
        }
    }
];
function $4d623dd53f12fd93$export$4cd1ca2600761f65(options) {
    try {
        // First we filter out supported extensions that aren't requested through options. We also
        // prepare detector objects with some initial internal state (e.g. detector.state.detected = false)
        const detectors = $4d623dd53f12fd93$var$registerDetectors(options.extensions, $4d623dd53f12fd93$var$supportedDetectors);
        // If async mode is enabled, we convert the list of detector objects to a list of promises
        // that resolve when the detector invokes detected() during its asynchronous check.
        // We also track any scheduled cleanup() tasks.
        if (options.async === true) {
            const asyncCleanups = [];
            const asyncDetections = Promise.all(detectors.map((detector)=>{
                return new Promise((resolve)=>{
                    const detected = ()=>{
                        detector.state.detected = true;
                        resolve();
                    };
                    const cleanup = (cb)=>{
                        asyncCleanups.push(cb);
                    };
                    if (typeof detector.fns.async === 'function') detector.fns.async(detected, cleanup);
                    else {
                        detector.state.detected = false;
                        resolve();
                    }
                });
            }));
            // We race all asynchronous checkers against a user-defined timeout (asyncTimeoutMs).
            // When asynchronous checks are finalised first,or if the timeout elapses, we return
            // the list of extensions detected up until that point.
            const globalTimeout = new Promise((resolve)=>setTimeout(resolve, options.asyncTimeoutMs, $4d623dd53f12fd93$var$RACE_COMPLETE));
            return Promise.race([
                asyncDetections,
                globalTimeout
            ]).then(()=>{
                return detectors.filter((detector)=>detector.state.detected).map((detector)=>detector.name);
            })// If there are any errors, we fail safely and silently with zero detected extensions.
            .catch(()=>[]).finally(()=>asyncCleanups.map((cleanup)=>cleanup()));
        } else // If sync mode, we immediately execute synchronous checks
        // and return a list of extensions whose synchronous checks returned true.
        return detectors.filter((detector)=>{
            var _detector$fns$sync, _detector$fns;
            return (_detector$fns$sync = (_detector$fns = detector.fns).sync) === null || _detector$fns$sync === void 0 ? void 0 : _detector$fns$sync.call(_detector$fns);
        }).map((detector)=>detector.name);
    } catch (err) {
        // If there are any unhandled errors, we fail safely and silently with zero detected extensions.
        return options.async ? Promise.resolve([]) : [];
    }
}

});

parcelRegister("6ygSb", function(module, exports) {
$parcel$export(module.exports, "PROFILER_KEY", () => $7354983ac17c95d2$export$d797387adb80fff6);
$parcel$export(module.exports, "RenderCountProfiler", () => $7354983ac17c95d2$export$6410a9092d17aaa6);
const $7354983ac17c95d2$export$d797387adb80fff6 = '__editorRenderCountProfiler';
class $7354983ac17c95d2$export$6410a9092d17aaa6 {
    constructor({ store: store }){
        this.store = store;
    }
    /**
   * Returns the singleton/cached instance of RenderCountProfiler that
   * currently exists. If it hasn't been instantiated yet, the singleton
   * instance will be created using the given params. Returns the latest
   * singleton/instance.
   */ static getInstance(params) {
        if (!$7354983ac17c95d2$export$6410a9092d17aaa6.instance) $7354983ac17c95d2$export$6410a9092d17aaa6.instance = new $7354983ac17c95d2$export$6410a9092d17aaa6({
            store: params.store
        });
        return $7354983ac17c95d2$export$6410a9092d17aaa6.instance;
    }
    getData(profilerKey) {
        var _this$store;
        return (_this$store = this.store) === null || _this$store === void 0 ? void 0 : _this$store[profilerKey];
    }
    enable() {
        this.store[$7354983ac17c95d2$export$d797387adb80fff6] = {
            ...this.store[$7354983ac17c95d2$export$d797387adb80fff6],
            enabled: true
        };
    }
    remove() {
        delete this.store[$7354983ac17c95d2$export$d797387adb80fff6];
    }
    isEnabled() {
        var _this$store2;
        return Boolean((_this$store2 = this.store) === null || _this$store2 === void 0 || (_this$store2 = _this$store2[$7354983ac17c95d2$export$d797387adb80fff6]) === null || _this$store2 === void 0 ? void 0 : _this$store2.enabled);
    }
    setRenderCount({ componentId: componentId, renderCount: renderCount, instanceId: instanceId }) {
        const profilerData = this.store[$7354983ac17c95d2$export$d797387adb80fff6];
        const instance = {
            count: renderCount
        };
        const existingComponents = profilerData === null || profilerData === void 0 ? void 0 : profilerData.components;
        const existingInstances = existingComponents === null || existingComponents === void 0 ? void 0 : existingComponents[componentId];
        const updatedComponent = {
            ...existingInstances,
            [instanceId]: instance
        };
        this.store[$7354983ac17c95d2$export$d797387adb80fff6] = {
            ...profilerData,
            components: {
                ...existingComponents,
                [componentId]: updatedComponent
            }
        };
    }
    getInstanceRenderCounters({ componentId: componentId }) {
        var _this$store3;
        const component = ((_this$store3 = this.store) === null || _this$store3 === void 0 || (_this$store3 = _this$store3[$7354983ac17c95d2$export$d797387adb80fff6]) === null || _this$store3 === void 0 || (_this$store3 = _this$store3.components) === null || _this$store3 === void 0 ? void 0 : _this$store3[componentId]) ?? {};
        const counters = [];
        // eslint-disable-next-line guard-for-in
        for(const instanceId in component){
            const counter = {
                instanceId: instanceId,
                count: component[instanceId].count
            };
            counters.push(counter);
        }
        return counters;
    }
    getRenderCount({ componentId: componentId }) {
        var _this$store4;
        const component = ((_this$store4 = this.store) === null || _this$store4 === void 0 || (_this$store4 = _this$store4[$7354983ac17c95d2$export$d797387adb80fff6]) === null || _this$store4 === void 0 || (_this$store4 = _this$store4.components) === null || _this$store4 === void 0 ? void 0 : _this$store4[componentId]) ?? {};
        let total = 0;
        // eslint-disable-next-line guard-for-in
        for(const instanceId in component)total += component[instanceId].count;
        return total;
    }
}

});

parcelRegister("9v2LJ", function(module, exports) {
$parcel$export(module.exports, "autoJoinTr", () => $1699b0555a71f08c$export$c7c1e59168a7f554);

var $3DNV7 = parcelRequire("3DNV7");
function $1699b0555a71f08c$export$c7c1e59168a7f554(tr, isJoinable) {
    if (Array.isArray(isJoinable)) {
        const types = isJoinable;
        isJoinable = (node)=>types.indexOf(node.type.name) > -1;
    }
    const ranges = [];
    for(let i = 0; i < tr.mapping.maps.length; i++){
        const map = tr.mapping.maps[i];
        for(let j = 0; j < ranges.length; j++)ranges[j] = map.map(ranges[j]);
        map.forEach((_s, _e, from, to)=>ranges.push(from, to));
    }
    // Figure out which joinable points exist inside those ranges,
    // by checking all node boundaries in their parent nodes.
    const joinable = [];
    for(let i = 0; i < ranges.length; i += 2){
        const from = ranges[i];
        const to = ranges[i + 1];
        const $from = tr.doc.resolve(from);
        const depth = $from.sharedDepth(to);
        const parent = $from.node(depth);
        for(let index = $from.indexAfter(depth), pos = $from.after(depth + 1); pos <= to; ++index){
            const after = parent.maybeChild(index);
            if (!after) break;
            if (index && joinable.indexOf(pos) === -1) {
                const before = parent.child(index - 1);
                if (before.type === after.type && isJoinable(before, after)) joinable.push(pos);
            }
            pos += after.nodeSize;
        }
    }
    // Join the joinable points
    joinable.sort((a, b)=>a - b);
    for(let i = joinable.length - 1; i >= 0; i--)if ((0, $3DNV7.canJoin)(tr.doc, joinable[i])) tr.join(joinable[i]);
}

});

parcelRegister("i6r6F", function(module, exports) {
$parcel$export(module.exports, "getNodeName", () => $672dcc8a15e0f121$export$651544f548703224);
const $672dcc8a15e0f121$export$651544f548703224 = (state, node)=>{
    var _node$marks;
    return (node === null || node === void 0 || (_node$marks = node.marks) === null || _node$marks === void 0 || (_node$marks = _node$marks.find((mark)=>mark.type === state.schema.marks.fragment)) === null || _node$marks === void 0 || (_node$marks = _node$marks.attrs) === null || _node$marks === void 0 ? void 0 : _node$marks.name) ?? '';
};

});

parcelRegister("13Qhp", function(module, exports) {
$parcel$export(module.exports, "isReferencedSource", () => $02ba49a2344d2c23$export$d35a68bd2e0b55da);
$parcel$export(module.exports, "removeConnectedNodes", () => $02ba49a2344d2c23$export$657e59857351232d);
$parcel$export(module.exports, "getChildrenInfo", () => $02ba49a2344d2c23$export$c98d43680e607ac1);

const $02ba49a2344d2c23$export$d35a68bd2e0b55da = (state, node)=>{
    var _node$attrs, _node$marks;
    if (!node) return false;
    let found = false;
    // Handle nodes having 2 uuids. They could have a localId or a fragment. Regardless this needs
    // to check if either id is used by a data consumer.
    const localIds = new Set([
        (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.localId,
        (_node$marks = node.marks) === null || _node$marks === void 0 || (_node$marks = _node$marks.find((mark)=>mark.type === state.schema.marks.fragment)) === null || _node$marks === void 0 || (_node$marks = _node$marks.attrs) === null || _node$marks === void 0 ? void 0 : _node$marks.localId
    ].filter(Boolean));
    // If there are no uuids on the node then it's not possible for it to be referenced anywhere.
    if (!localIds.size) return false;
    state.doc.descendants((node)=>{
        var _dataConsumer$attrs$s;
        if (found) return false;
        const dataConsumer = node.marks.find((mark)=>mark.type === state.schema.marks.dataConsumer);
        if (!dataConsumer) return true;
        found = ((_dataConsumer$attrs$s = dataConsumer.attrs.sources) === null || _dataConsumer$attrs$s === void 0 ? void 0 : _dataConsumer$attrs$s.some((src)=>localIds.has(src))) ?? false;
        return !found;
    });
    return found;
};
const $02ba49a2344d2c23$export$82b9f8f75cc709b4 = (state)=>{
    const result = {};
    const { doc: doc, schema: schema } = state;
    // Keeps a map of all raw ids -> to their preferred normalised varient. A node with both fragmentMark & localId will
    // have both ids mapped here to the same normalized version.
    const normalizedIds = new Map();
    const dataConsumerSources = new Map();
    // Perform a prelim scan creating the initial id to connection link mappings.
    // This will also save a list of data sources consumed per node.
    doc.descendants((node, pos)=>{
        var _node$attrs2, _fragmentMark, _node$attrs3, _fragmentMark2, _node$attrs4, _fragmentMark3;
        let dataConsumer;
        let fragmentMark;
        node.marks.some((mark)=>{
            if (mark.type === schema.marks.dataConsumer) dataConsumer = mark;
            else if (mark.type === schema.marks.fragment) fragmentMark = mark;
            // Stop searching marks if we've found both consumer and fragment.
            return !!dataConsumer && !!fragmentMark;
        });
        // If node cannot be referenced by any means then abort.
        if (!fragmentMark && !((_node$attrs2 = node.attrs) !== null && _node$attrs2 !== void 0 && _node$attrs2.localId)) return true;
        const normalizedId = ((_fragmentMark = fragmentMark) === null || _fragmentMark === void 0 || (_fragmentMark = _fragmentMark.attrs) === null || _fragmentMark === void 0 ? void 0 : _fragmentMark.localId) ?? ((_node$attrs3 = node.attrs) === null || _node$attrs3 === void 0 ? void 0 : _node$attrs3.localId);
        if (!normalizedId) return true;
        if (!!((_fragmentMark2 = fragmentMark) !== null && _fragmentMark2 !== void 0 && (_fragmentMark2 = _fragmentMark2.attrs) !== null && _fragmentMark2 !== void 0 && _fragmentMark2.localId)) normalizedIds.set(fragmentMark.attrs.localId, normalizedId);
        if (!!((_node$attrs4 = node.attrs) !== null && _node$attrs4 !== void 0 && _node$attrs4.localId)) normalizedIds.set(node.attrs.localId, normalizedId);
        if (!!result[normalizedId]) // Duplicate ID has been found, we'll care about the first one for now.
        return true;
        result[normalizedId] = {
            localId: normalizedId,
            name: (_fragmentMark3 = fragmentMark) === null || _fragmentMark3 === void 0 || (_fragmentMark3 = _fragmentMark3.attrs) === null || _fragmentMark3 === void 0 ? void 0 : _fragmentMark3.name,
            node: node,
            pos: pos,
            targets: []
        };
        if (!!dataConsumer && dataConsumer.attrs.sources.length) dataConsumerSources.set(normalizedId, dataConsumer.attrs.sources);
        // Do not descend into children of a node which has a dataConsumer attached. This assumes all children of the node cannot
        // be referenced by another node.
        return !dataConsumer;
    });
    // This 2nd-pass only looks at the consumer sources and updates all connections with the correct id refs.
    for (const [localId, sources] of dataConsumerSources)// This is a ref to the node (connection link) which contains the consumer.
    sources.forEach((src)=>{
        const normalizedId = normalizedIds.get(src) ?? src;
        const srcLink = result[normalizedId];
        if (srcLink && normalizedId !== localId) srcLink.targets.push(localId);
    });
    return result;
};
const $02ba49a2344d2c23$export$657e59857351232d = (state, node)=>{
    if (!node) return state.tr;
    const selectedLocalIds = $02ba49a2344d2c23$var$getSelectedLocalIds(state, node);
    const allNodes = $02ba49a2344d2c23$export$82b9f8f75cc709b4(state);
    const idsToBeDeleted = $02ba49a2344d2c23$var$getIdsToBeDeleted(selectedLocalIds, allNodes);
    if (!(idsToBeDeleted !== null && idsToBeDeleted !== void 0 && idsToBeDeleted.length)) return state.tr;
    const { tr: tr } = state;
    let newTr = tr;
    idsToBeDeleted.forEach((id)=>{
        if (!allNodes[id]) return;
        const { node: node, pos: pos } = allNodes[id];
        newTr = newTr.delete(newTr.mapping.map(pos), newTr.mapping.map(node.nodeSize + pos));
    });
    return newTr;
};
// find all ids need to be remove connected to selected extension
const $02ba49a2344d2c23$var$getIdsToBeDeleted = (selectedIds, allNodes)=>{
    if (!selectedIds.size) return [];
    let searchSet = [
        ...selectedIds
    ];
    const deletedIds = new Set();
    while(searchSet.length){
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const id = searchSet.pop();
        if (allNodes[id]) {
            var _allNodes$id;
            deletedIds.add(allNodes[id].localId);
            searchSet = searchSet.concat(((_allNodes$id = allNodes[id]) === null || _allNodes$id === void 0 ? void 0 : _allNodes$id.targets.filter((targetId)=>{
                var _allNodes$targetId;
                return !deletedIds.has((_allNodes$targetId = allNodes[targetId]) === null || _allNodes$targetId === void 0 ? void 0 : _allNodes$targetId.localId);
            })) ?? []);
        }
    }
    return Array.from(deletedIds);
};
const $02ba49a2344d2c23$export$c98d43680e607ac1 = (state, node)=>{
    let allChildrenHadName = true;
    if (!node) return [];
    const childrenIdSet = new Set();
    const childrenInfoArray = [];
    const allNodes = $02ba49a2344d2c23$export$82b9f8f75cc709b4(state);
    const selectedNodeIds = $02ba49a2344d2c23$var$getSelectedLocalIds(state, node);
    selectedNodeIds.forEach((id)=>{
        if (allNodes[id]) allNodes[id].targets.forEach(childrenIdSet.add, childrenIdSet);
    });
    for (const id of childrenIdSet)if (!$02ba49a2344d2c23$var$getNodeNameById(id, allNodes)) {
        allChildrenHadName = false;
        break;
    } else childrenInfoArray.push({
        id: id,
        name: $02ba49a2344d2c23$var$getNodeNameById(id, allNodes),
        amount: $02ba49a2344d2c23$var$getChildrenNodeAmount(id, allNodes)
    });
    return allChildrenHadName ? childrenInfoArray : [];
};
const $02ba49a2344d2c23$var$getChildrenNodeAmount = (id, allNodes)=>{
    const searchTerms = new Set([
        id
    ]);
    const traverseHistory = new Map();
    const childrenIds = new Set();
    traverseHistory.set(id, false);
    while(searchTerms.size > 0){
        const [currTerm] = searchTerms;
        const targets = $02ba49a2344d2c23$var$getNodeTargetsById(currTerm, allNodes);
        targets.forEach((target)=>{
            const isTargetCounted = traverseHistory.get(target);
            if (!isTargetCounted) {
                searchTerms.add(target);
                childrenIds.add(target);
            }
            target !== id && childrenIds.add(target);
        });
        traverseHistory.set(currTerm, true);
        searchTerms.delete(currTerm);
    }
    return childrenIds.size;
};
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $02ba49a2344d2c23$var$getNodeTargetsById = (id, allNodes)=>{
    if (!id || !allNodes[id]) return [];
    return allNodes[id].targets;
};
const $02ba49a2344d2c23$var$getNodeNameById = (id, allNodes)=>{
    if (typeof id === 'object') {
        let name;
        id.forEach((localId)=>{
            var _allNodes$localId;
            name = name ?? ((_allNodes$localId = allNodes[localId]) === null || _allNodes$localId === void 0 ? void 0 : _allNodes$localId.name);
        });
        return name || null;
    }
    if (!id || !allNodes[id]) return null;
    return allNodes[id].name;
};
const $02ba49a2344d2c23$var$getSelectedLocalIds = (state, node)=>{
    var _node$attrs5, _node$marks2;
    if (!node) return new Set([]);
    const localIds = new Set([
        (_node$attrs5 = node.attrs) === null || _node$attrs5 === void 0 ? void 0 : _node$attrs5.localId,
        (_node$marks2 = node.marks) === null || _node$marks2 === void 0 || (_node$marks2 = _node$marks2.find((mark)=>mark.type === state.schema.marks.fragment)) === null || _node$marks2 === void 0 || (_node$marks2 = _node$marks2.attrs) === null || _node$marks2 === void 0 ? void 0 : _node$marks2.localId
    ].filter(Boolean));
    return localIds;
};

});

parcelRegister("3IDI7", function(module, exports) {
$parcel$export(module.exports, "isBulletList", () => $8e4c3c41311ed930$export$35b2f400604e700);
function $8e4c3c41311ed930$export$35b2f400604e700(node) {
    return Boolean(node && node.type && 'bulletList' === node.type.name);
}

});

parcelRegister("7nLBT", function(module, exports) {
$parcel$export(module.exports, "isListItemNode", () => $3cc8dfcf0de3778c$export$2ddb0a75547407f6);
function $3cc8dfcf0de3778c$export$2ddb0a75547407f6(node) {
    return Boolean(node && node.type && 'listItem' === node.type.name);
}

});

parcelRegister("4Dhpb", function(module, exports) {
$parcel$export(module.exports, "isParagraphNode", () => $5f3765caa26cb237$export$35f600abfe6f0127);
function $5f3765caa26cb237$export$35f600abfe6f0127(node) {
    return Boolean(node && node.type && 'paragraph' === node.type.name);
}

});

parcelRegister("amIzn", function(module, exports) {
$parcel$export(module.exports, "LinkMatcher", () => $fc853e8dd2e3fed4$export$4490385c12bf3d4);

var $d7B5f = parcelRequire("d7B5f");

var $6Z6Le = parcelRequire("6Z6Le");
class $fc853e8dd2e3fed4$export$4490385c12bf3d4 {
    static create() {
        class LinkMatcherRegex {
            exec(str) {
                const stringsBySpace = str.slice(0, str.length - 1).split(' ');
                const lastStringBeforeSpace = stringsBySpace[stringsBySpace.length - 1];
                const isLastStringValid = lastStringBeforeSpace.length > 0;
                if (!str.endsWith(' ') || !isLastStringValid) return null;
                if ((0, $6Z6Le.DONTLINKIFY_REGEXP).test(lastStringBeforeSpace)) return null;
                const links = (0, $d7B5f.linkify).match(lastStringBeforeSpace);
                if (!links || links.length === 0) return null;
                const lastMatch = links[links.length - 1];
                const lastLink = links[links.length - 1];
                lastLink.input = str.substring(lastMatch.index);
                lastLink.length = lastLink.lastIndex - lastLink.index + 1;
                lastLink.index = str.lastIndexOf(lastStringBeforeSpace) + lastMatch.index;
                return lastLink;
            }
        }
        return new LinkMatcherRegex();
    }
}

});

parcelRegister("cgQ5m", function(module, exports) {
$parcel$export(module.exports, "canLinkBeCreatedInRange", () => $aea646ae74d5d73d$export$b7392a423e62dc8c);
const $aea646ae74d5d73d$export$b7392a423e62dc8c = (from, to)=>(state)=>{
        if (!state.doc.rangeHasMark(from, to, state.schema.marks.link)) {
            const $from = state.doc.resolve(from);
            const $to = state.doc.resolve(to);
            const link = state.schema.marks.link;
            if ($from.parent === $to.parent && $from.parent.isTextblock) {
                if ($from.parent.type.allowsMarkType(link)) {
                    let allowed = true;
                    state.doc.nodesBetween(from, to, (node)=>{
                        const hasInlineCard = node.type === state.schema.nodes.inlineCard;
                        allowed = allowed && !node.marks.some((m)=>m.type.excludes(link)) && !hasInlineCard;
                        return allowed;
                    });
                    return allowed;
                }
            }
        }
        return false;
    };

});

parcelRegister("e4CUM", function(module, exports) {
$parcel$export(module.exports, "gridTypeForLayout", () => $247b853a70f17798$export$27813bf9aa3826dc);
const $247b853a70f17798$export$27813bf9aa3826dc = (layout)=>layout === 'wrap-left' || layout === 'wrap-right' ? 'wrapped' : 'full';

});

parcelRegister("cPyt7", function(module, exports) {
$parcel$export(module.exports, "bracketTyped", () => $aa4b552431b52fa3$export$df0539d254c75c33);
$parcel$export(module.exports, "nodesBetweenChanged", () => $aa4b552431b52fa3$export$f9e52d2e832a6aae);
$parcel$export(module.exports, "getChangedNodes", () => $aa4b552431b52fa3$export$fd9c3e0f31aab835);
$parcel$export(module.exports, "isReplaceDocOperation", () => $aa4b552431b52fa3$export$b81ebf241519dbe1);
$parcel$export(module.exports, "areNodesEqualIgnoreAttrs", () => $aa4b552431b52fa3$export$e3b603f98921291f);

var $3DNV7 = parcelRequire("3DNV7");

var $bCYNR = parcelRequire("bCYNR");

var $lwCmV = parcelRequire("lwCmV");

var $55o0j = parcelRequire("55o0j");


function $aa4b552431b52fa3$export$df0539d254c75c33(state) {
    const { selection: selection } = state;
    const { $cursor: $cursor, $anchor: $anchor } = selection;
    if (!$cursor) return false;
    const node = $cursor.nodeBefore;
    if (!node) return false;
    if (node.type.name === 'text' && node.text === '{') {
        const paragraphNode = $anchor.node();
        return paragraphNode.marks.length === 0 && (0, $lwCmV.hasDocAsParent)($anchor);
    }
    return false;
}
function $aa4b552431b52fa3$export$f9e52d2e832a6aae(tr, f, startPos) {
    const stepRange = (0, $bCYNR.getStepRange)(tr);
    if (!stepRange) return;
    tr.doc.nodesBetween(stepRange.from, stepRange.to, f, startPos);
}
function $aa4b552431b52fa3$var$getChangedNodesIn({ tr: tr, doc: doc }) {
    const nodes = [];
    const stepRange = (0, $bCYNR.getStepRange)(tr);
    if (!stepRange) return nodes;
    const from = Math.min(doc.nodeSize - 2, stepRange.from);
    const to = Math.min(doc.nodeSize - 2, stepRange.to);
    doc.nodesBetween(from, to, (node, pos)=>{
        nodes.push({
            node: node,
            pos: pos
        });
    });
    return nodes;
}
function $aa4b552431b52fa3$export$fd9c3e0f31aab835(tr) {
    return $aa4b552431b52fa3$var$getChangedNodesIn({
        tr: tr,
        doc: tr.doc
    });
}
const $aa4b552431b52fa3$export$b81ebf241519dbe1 = (transactions, oldState)=>{
    return transactions.some((tr)=>{
        if (tr.getMeta('replaceDocument')) return true;
        const hasStepReplacingEntireDocument = tr.steps.some((step)=>{
            if (!(step instanceof (0, $3DNV7.ReplaceStep))) return false;
            const isStepReplacingFromDocStart = step.from === 0;
            const isStepReplacingUntilTheEndOfDocument = step.to === oldState.doc.content.size;
            if (!isStepReplacingFromDocStart || !isStepReplacingUntilTheEndOfDocument) return false;
            return true;
        });
        return hasStepReplacingEntireDocument;
    });
};
function $aa4b552431b52fa3$var$marksEqualInOrder(m1, m2) {
    if (m1.length !== m2.length) return false;
    return m1.every((m, i)=>m.eq(m2[i]));
}
function $aa4b552431b52fa3$var$marksEqualIgnoringOrder(m1, m2) {
    if (m1.length !== m2.length) return false;
    const m2Used = new Set();
    for (const mark1 of m1){
        const idx = m2.findIndex((mark2, i)=>!m2Used.has(i) && mark1.eq(mark2));
        if (idx === -1) return false;
        m2Used.add(idx);
    }
    return true;
}
function $aa4b552431b52fa3$export$e3b603f98921291f(node1, node2, attributesToIgnore, opts) {
    const ignoreMarkOrder = (opts === null || opts === void 0 ? void 0 : opts.ignoreMarkOrder) ?? true;
    if (node1.isText) {
        if (ignoreMarkOrder) return node1.text === node2.text && $aa4b552431b52fa3$var$marksEqualIgnoringOrder(node1.marks, node2.marks);
        return node1.eq(node2);
    }
    const marksEqual = ignoreMarkOrder ? $aa4b552431b52fa3$var$marksEqualIgnoringOrder(node1.marks, node2.marks) : $aa4b552431b52fa3$var$marksEqualInOrder(node1.marks, node2.marks);
    // If no attributes to ignore, compare all attributes
    if (!attributesToIgnore || attributesToIgnore.length === 0) return node1 === node2 || node1.hasMarkup(node2.type, node1.attrs, node1.marks) && marksEqual && $aa4b552431b52fa3$var$areFragmentsEqual(node1.content, node2.content, undefined, opts);
    // Build attrs to compare by excluding ignored attributes
    const attrsToCompare = {
        ...node2.attrs
    };
    const ignoreSet = new Set(attributesToIgnore);
    for(const key in node2.attrs)if (ignoreSet.has(key)) attrsToCompare[key] = node1.attrs[key];
    return node1 === node2 || node1.type === node2.type && node1.hasMarkup(node2.type, attrsToCompare, node1.marks) && marksEqual && $aa4b552431b52fa3$var$areFragmentsEqual(node1.content, node2.content, attributesToIgnore, opts);
}
function $aa4b552431b52fa3$var$areFragmentsEqual(frag1, frag2, attributesToIgnore, opts) {
    if (frag1.content.length !== frag2.content.length) return false;
    let childrenEqual = true;
    frag1.content.forEach((child, i)=>{
        const otherChild = frag2.child(i);
        if (child === otherChild || otherChild && $aa4b552431b52fa3$export$e3b603f98921291f(child, otherChild, attributesToIgnore, opts)) return;
        childrenEqual = false;
    });
    return childrenEqual;
}

});
parcelRegister("bCYNR", function(module, exports) {
$parcel$export(module.exports, "getStepRange", () => $dcaaacbea32e2e41$export$c8e611b6ac095e6d);

var $4wRhu = parcelRequire("4wRhu");
const $dcaaacbea32e2e41$export$c8e611b6ac095e6d = (transaction)=>{
    let from = -1;
    let to = -1;
    transaction.mapping.maps.forEach((stepMap, index)=>{
        stepMap.forEach((oldStart, oldEnd)=>{
            const newStart = transaction.mapping.slice(index).map(oldStart, -1);
            const newEnd = transaction.mapping.slice(index).map(oldEnd);
            const docSize = transaction.doc.content.size;
            from = (0, (/*@__PURE__*/$parcel$interopDefault($4wRhu)))(newStart < from || from === -1 ? newStart : from, 0, docSize);
            to = (0, (/*@__PURE__*/$parcel$interopDefault($4wRhu)))(newEnd > to || to === -1 ? newEnd : to, 0, docSize);
        });
    });
    if (from !== -1) return {
        from: from,
        to: to
    };
    return null;
};

});


parcelRegister("asFQ7", function(module, exports) {
$parcel$export(module.exports, "hasVisibleContent", () => $3f1b939f6aec38be$export$c9083db5521330d3);
function $3f1b939f6aec38be$export$c9083db5521330d3(node) {
    const isInlineNodeHasVisibleContent = (inlineNode)=>{
        return inlineNode.isText ? !!inlineNode.textContent.trim() : inlineNode.type.name !== 'hardBreak';
    };
    if (node.isInline) return isInlineNodeHasVisibleContent(node);
    else if (node.isBlock && (node.isLeaf || node.isAtom)) return true;
    else if (!node.childCount) return false;
    for(let index = 0; index < node.childCount; index++){
        const child = node.child(index);
        const invisibleNodeTypes = [
            'paragraph',
            'text',
            'hardBreak'
        ];
        if (!invisibleNodeTypes.includes(child.type.name) || $3f1b939f6aec38be$export$c9083db5521330d3(child)) return true;
    }
    return false;
}

});

parcelRegister("KawKV", function(module, exports) {
$parcel$export(module.exports, "isSelectionEndOfParagraph", () => $27c4b60751ccb9af$export$435c1d4e61a8723b);
const $27c4b60751ccb9af$export$435c1d4e61a8723b = (state)=>state.selection.$to.parent.type === state.schema.nodes.paragraph && state.selection.$to.pos === state.doc.resolve(state.selection.$to.pos).end();

});

parcelRegister("l9Hpy", function(module, exports) {
$parcel$export(module.exports, "calculateSnapPoints", () => $73e5137b70a12cfe$export$de65085e667b4bf1);

var $5bbjm = parcelRequire("5bbjm");

var $lMufz = parcelRequire("lMufz");
function $73e5137b70a12cfe$export$de65085e667b4bf1({ $pos: $pos, akEditorWideLayoutWidth: akEditorWideLayoutWidth, allowBreakoutSnapPoints: allowBreakoutSnapPoints, containerWidth: containerWidth, gridSize: gridSize, gridWidth: gridWidth, insideInlineLike: insideInlineLike, insideLayout: insideLayout, isVideoFile: isVideoFile, lineLength: lineLength, offsetLeft: offsetLeft, wrappedLayout: wrappedLayout }) {
    const snapTargets = [];
    for(let i = 0; i < gridWidth; i++){
        const pxFromColumns = (0, $lMufz.calcPxFromColumns)(i, lineLength, gridWidth);
        snapTargets.push(insideLayout ? pxFromColumns : pxFromColumns - offsetLeft);
    }
    // full width
    snapTargets.push(lineLength - offsetLeft);
    const columns = wrappedLayout || insideInlineLike ? 1 : 2;
    const minimumWidth = (0, $lMufz.calcPxFromColumns)(columns, lineLength, gridSize);
    let snapPoints = snapTargets.filter((width)=>width >= minimumWidth);
    if (!$pos) return snapPoints;
    snapPoints = isVideoFile ? snapPoints.filter((width)=>width > 320) : snapPoints;
    const isTopLevel = $pos.parent.type.name === 'doc';
    if (isTopLevel && allowBreakoutSnapPoints) {
        snapPoints.push(akEditorWideLayoutWidth);
        const fullWidthPoint = containerWidth - (0, $5bbjm.akEditorBreakoutPadding);
        if (fullWidthPoint > akEditorWideLayoutWidth) snapPoints.push(fullWidthPoint);
    }
    // EDM-1107: Ensure new snapPoints are sorted with existing points
    snapPoints = snapPoints.sort((a, b)=>a - b);
    return snapPoints;
}

});
parcelRegister("lMufz", function(module, exports) {
$parcel$export(module.exports, "calcPxFromColumns", () => $2844c3ecffb60f16$export$1e3701608f0cee80);

var $29qUP = parcelRequire("29qUP");
function $2844c3ecffb60f16$export$1e3701608f0cee80(columns, lineLength, gridSize) {
    const maxWidth = lineLength + (0, $29qUP.MEDIA_SINGLE_GUTTER_SIZE);
    return maxWidth / gridSize * columns - (0, $29qUP.MEDIA_SINGLE_GUTTER_SIZE);
}

});


parcelRegister("acax3", function(module, exports) {
$parcel$export(module.exports, "floatingLayouts", () => $b699354dd016ec7a$export$7c0073a4d21b222d);
const $b699354dd016ec7a$export$7c0073a4d21b222d = [
    'wrap-left',
    'wrap-right'
];

});

parcelRegister("9PK5v", function(module, exports) {
$parcel$export(module.exports, "isRichMediaInsideOfBlockNode", () => $c68d335157081ba6$export$55fb9d6810f2e04b);

var $gab48 = parcelRequire("gab48");
const $c68d335157081ba6$export$55fb9d6810f2e04b = (view, pos)=>{
    if (typeof pos !== 'number' || isNaN(pos) || !view) return false;
    const $pos = view.state.doc.resolve(pos);
    const { expand: expand, nestedExpand: nestedExpand, layoutColumn: layoutColumn, bodiedSyncBlock: bodiedSyncBlock } = view.state.schema.nodes;
    return !!(0, $gab48.findParentNodeOfTypeClosestToPos)($pos, [
        expand,
        nestedExpand,
        layoutColumn,
        bodiedSyncBlock
    ]);
};

});

parcelRegister("1QLHG", function(module, exports) {
$parcel$export(module.exports, "alignAttributes", () => $18c00f5a9d00ceeb$export$b2258912a400ba32);

var $76GIX = parcelRequire("76GIX");

var $6B1yf = parcelRequire("6B1yf");

var $bdpTj = parcelRequire("bdpTj");



const $18c00f5a9d00ceeb$export$b2258912a400ba32 = (layout, oldAttrs, gridSize = 12, originalWidth, lineLength)=>{
    let width = oldAttrs.width;
    const oldLayout = oldAttrs.layout;
    const oldLayoutIsNonWrapped = (0, $6B1yf.nonWrappedLayouts).indexOf(oldLayout) > -1;
    const newLayoutIsNonWrapped = (0, $6B1yf.nonWrappedLayouts).indexOf(layout) > -1;
    const newLayoutIsWrapped = (0, $76GIX.wrappedLayouts).indexOf(layout) > -1;
    const oldLayoutIsWrapped = (0, $76GIX.wrappedLayouts).indexOf(oldLayout) > -1;
    if (oldLayoutIsNonWrapped && (0, $bdpTj.shouldAddDefaultWrappedWidth)(layout, originalWidth, lineLength)) // 'full-width' or 'wide' or 'center' -> 'wrap-left' or 'wrap-right' or 'align-end' or 'align-start'
    {
        if (!width || width >= 100 || oldLayout !== 'center' // == 'full-width' or 'wide'
        ) width = 50;
    } else if (layout !== oldLayout && [
        'full-width',
        'wide'
    ].indexOf(oldLayout) > -1) // 'full-width' -> 'center' or 'wide'
    // 'wide' -> 'center' or 'full-width'
    // unset width
    width = undefined;
    else if (width) {
        const cols = Math.round(width / 100 * gridSize);
        let targetCols = cols;
        if (oldLayoutIsWrapped && newLayoutIsNonWrapped) {
            // wrap -> center needs to align to even grid
            targetCols = Math.floor(targetCols / 2) * 2;
            width = undefined;
        } else if (oldLayoutIsNonWrapped && newLayoutIsWrapped) {
            // Can be here only if
            // 'full-width' or 'wide' or 'center' -> 'wrap-left' or 'wrap-right' or 'align-end' or 'align-start'
            // AND
            // !originalWidth || !lineLength || small image
            // AND
            // width defined!
            // cannot resize to full column width, and cannot resize to 1 column
            if (cols <= 1) targetCols = 2;
            else if (cols >= gridSize) targetCols = 10;
        }
        if (targetCols !== cols) width = targetCols / gridSize * 100;
    }
    return {
        ...oldAttrs,
        layout: layout,
        width: width
    };
};

});

parcelRegister("h7zC7", function(module, exports) {
$parcel$export(module.exports, "walkNextNode", () => $310cd270eb13286c$export$a5ae75c0b3dfe1c0);
$parcel$export(module.exports, "walkPrevNode", () => $310cd270eb13286c$export$cab15df6ad89b5a0);
$parcel$export(module.exports, "insertNewLineWithAnalytics", () => $310cd270eb13286c$export$67efd148fa31066c);
$parcel$export(module.exports, "createNewParagraphAbove", () => $310cd270eb13286c$export$fd094c1e3c1540bf);
$parcel$export(module.exports, "createParagraphNear", () => $310cd270eb13286c$export$d0f80ac1b4510888);
$parcel$export(module.exports, "createNewParagraphBelow", () => $310cd270eb13286c$export$d4296e42f66d8dc6);
$parcel$export(module.exports, "deleteEmptyParagraphAndMoveBlockUp", () => $310cd270eb13286c$export$a52ade1f964aef2c);
$parcel$export(module.exports, "isEmptySelectionAtStart", () => $310cd270eb13286c$export$55f1e30b4664ff16);
$parcel$export(module.exports, "isEmptySelectionAtEnd", () => $310cd270eb13286c$export$aedf35c057f77b82);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $cw0wu = parcelRequire("cw0wu");

var $g6Qq4 = parcelRequire("g6Qq4");

var $5NaaJ = parcelRequire("5NaaJ");

var $j7pt0 = parcelRequire("j7pt0");

var $8gOte = parcelRequire("8gOte");

var $16eXf = parcelRequire("16eXf");

var $cSk7K = parcelRequire("cSk7K");

var $7yXHq = parcelRequire("7yXHq");

var $24xJB = parcelRequire("24xJB");

var $81ojn = parcelRequire("81ojn");

const $310cd270eb13286c$export$a5ae75c0b3dfe1c0 = ($startPos)=>{
    let $pos = $startPos;
    // invariant 1: don't walk past the end of the document
    // invariant 2: we are at the beginning or
    //              we haven't walked to the start of *any* node
    //              parentOffset includes textOffset.
    while($pos.pos < $pos.doc.nodeSize - 2 && ($pos.pos === $startPos.pos || $pos.parentOffset > 0))$pos = $pos.doc.resolve($pos.pos + 1);
    return {
        $pos: $pos,
        foundNode: $pos.pos < $pos.doc.nodeSize - 2
    };
};
const $310cd270eb13286c$export$cab15df6ad89b5a0 = ($startPos)=>{
    let $pos = $startPos;
    while($pos.pos > 0 && ($pos.pos === $startPos.pos || $pos.parentOffset < $pos.parent.nodeSize - 2))$pos = $pos.doc.resolve($pos.pos - 1);
    return {
        $pos: $pos,
        foundNode: $pos.pos > 0
    };
};
const $310cd270eb13286c$export$67efd148fa31066c = (editorAnalyticsAPI)=>(0, $5NaaJ.withAnalytics)(editorAnalyticsAPI, {
        action: (0, $g6Qq4.ACTION).INSERTED,
        actionSubject: (0, $g6Qq4.ACTION_SUBJECT).TEXT,
        actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).LINE_BREAK,
        eventType: (0, $g6Qq4.EVENT_TYPE).TRACK
    })((0, $7yXHq.insertNewLine)());
const $310cd270eb13286c$export$fd094c1e3c1540bf = (state, dispatch)=>{
    const append = false;
    if (!$310cd270eb13286c$var$canMoveUp(state) && $310cd270eb13286c$var$canCreateParagraphNear(state)) {
        $310cd270eb13286c$export$d0f80ac1b4510888(append)(state, dispatch);
        return true;
    }
    return false;
};
const $310cd270eb13286c$export$d4296e42f66d8dc6 = (state, dispatch)=>{
    const append = true;
    if (!$310cd270eb13286c$var$canMoveDown(state) && $310cd270eb13286c$var$canCreateParagraphNear(state)) {
        $310cd270eb13286c$export$d0f80ac1b4510888(append)(state, dispatch);
        return true;
    }
    return false;
};
function $310cd270eb13286c$var$canCreateParagraphNear(state) {
    const { selection: { $from: $from } } = state;
    const node = $from.node($from.depth);
    const insideCodeBlock = !!node && node.type === state.schema.nodes.codeBlock;
    const isNodeSelection = state.selection instanceof (0, $cw0wu.NodeSelection);
    return $from.depth > 1 || isNodeSelection || insideCodeBlock;
}
function $310cd270eb13286c$export$d0f80ac1b4510888(append = true) {
    return function(state, dispatch) {
        const paragraph = state.schema.nodes.paragraph;
        if (!paragraph) return false;
        let insertPos;
        if (state.selection instanceof (0, $cw0wu.TextSelection)) {
            if ($310cd270eb13286c$var$topLevelNodeIsEmptyTextBlock(state)) return false;
            insertPos = $310cd270eb13286c$var$getInsertPosFromTextBlock(state, append);
        } else insertPos = $310cd270eb13286c$var$getInsertPosFromNonTextBlock(state, append);
        const tr = state.tr.insert(insertPos, paragraph.createAndFill());
        tr.setSelection((0, $cw0wu.TextSelection).create(tr.doc, insertPos + 1));
        if (dispatch) dispatch(tr);
        return true;
    };
}
function $310cd270eb13286c$var$getInsertPosFromTextBlock(state, append) {
    const { $from: $from, $to: $to } = state.selection;
    let pos;
    if (!append) pos = $from.start(0);
    else pos = $to.end(0);
    return pos;
}
function $310cd270eb13286c$var$getInsertPosFromNonTextBlock(state, append) {
    const { $from: $from, $to: $to } = state.selection;
    const nodeAtSelection = state.selection instanceof (0, $cw0wu.NodeSelection) && state.doc.nodeAt(state.selection.$anchor.pos);
    const isMediaSelection = nodeAtSelection && nodeAtSelection.type.name === 'mediaGroup';
    let pos;
    if (!append) {
        // The start position is different with text block because it starts from 0
        pos = $from.start($from.depth);
        // The depth is different with text block because it starts from 0
        pos = $from.depth > 0 && !isMediaSelection ? pos - 1 : pos;
    } else {
        pos = $to.end($to.depth);
        pos = $to.depth > 0 && !isMediaSelection ? pos + 1 : pos;
    }
    return pos;
}
function $310cd270eb13286c$var$topLevelNodeIsEmptyTextBlock(state) {
    const topLevelNode = state.selection.$from.node(1);
    return topLevelNode.isTextblock && topLevelNode.type !== state.schema.nodes.codeBlock && topLevelNode.nodeSize === 2;
}
function $310cd270eb13286c$var$canMoveUp(state) {
    const { selection: selection } = state;
    /**
   * If there's a media element on the selection it will use a gap cursor to move
   */ if (selection instanceof (0, $cw0wu.NodeSelection) && (0, $81ojn.isMediaNode)(selection.node)) return true;
    return !(0, $8gOte.atTheBeginningOfDoc)(state);
}
function $310cd270eb13286c$var$canMoveDown(state) {
    const { selection: selection } = state;
    /**
   * If there's a media element on the selection it will use a gap cursor to move
   */ if (selection instanceof (0, $cw0wu.NodeSelection) && (0, $81ojn.isMediaNode)(selection.node)) return true;
    return !(0, $16eXf.atTheEndOfDoc)(state);
}
const $310cd270eb13286c$export$a52ade1f964aef2c = (canNextNodeMoveUp)=>{
    return (state, dispatch, view)=>{
        const { selection: { $from: { pos: pos, parent: parent }, $head: $head, empty: empty }, tr: tr, doc: doc } = state;
        const { $pos: $pos } = $310cd270eb13286c$export$a5ae75c0b3dfe1c0($head);
        const nextPMNode = doc.nodeAt($pos.pos - 1);
        if (empty && nextPMNode && canNextNodeMoveUp(nextPMNode) && (0, $24xJB.isEmptyParagraph)(parent) && view !== null && view !== void 0 && view.endOfTextblock('right')) {
            tr.deleteRange(pos - 1, pos + 1);
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };
};
const $310cd270eb13286c$export$55f1e30b4664ff16 = (state)=>{
    const { blockTaskItem: blockTaskItem } = state.schema.nodes;
    const { empty: empty, $from: $from } = state.selection;
    // If blockTaskItem is in the schema,
    // we need to check if the selection is inside a blockTaskItem
    if (blockTaskItem && empty) {
        // If the parent is in a textblock,
        // check if it's nested inside a blockTaskItem
        if ($from.parent.isTextblock) {
            const $posAtStartOfTextBlock = state.doc.resolve($from.start($from.depth - 1));
            const parentOfTextBlock = $posAtStartOfTextBlock.parent;
            // If the parent of the textblock is a blockTaskItem,
            // we need to if the textblock is the first node in the blockTaskItem
            if (parentOfTextBlock.type === blockTaskItem) {
                const firstChildOfBlockTaskItem = parentOfTextBlock.firstChild;
                if (firstChildOfBlockTaskItem === $from.parent) {
                    // If the textblock is the first node in the blockTaskItem,
                    // check if the selection is at the start of the textblock
                    const firstTextPosInTextBlock = $from.start($from.depth);
                    return $from.pos === firstTextPosInTextBlock;
                } else return false;
            }
        } else if ($from.parent.type === blockTaskItem) {
            // Check if the selection is at the start of the blockTaskItem
            const blockTaskItemDepth = $from.depth;
            const firstPosInBlockTaskItem = $from.start(blockTaskItemDepth);
            // Is the selection at the first possible position inside the blockTaskItem
            return $from.pos === firstPosInBlockTaskItem;
        }
    }
    return empty && ($from.parentOffset === 0 || state.selection instanceof (0, $j7pt0.GapCursorSelection));
};
const $310cd270eb13286c$export$aedf35c057f77b82 = (state)=>{
    const { blockTaskItem: blockTaskItem } = state.schema.nodes;
    const { empty: empty, $from: $from } = state.selection;
    // If blockTaskItem is in the schema,
    // we need to check if the selection is inside a blockTaskItem
    if (blockTaskItem && empty) {
        // If the parent is in a textblock,
        // check if it's nested inside a blockTaskItem
        if ($from.parent.isTextblock) {
            const $posAtEndOfTextBlock = state.doc.resolve($from.end($from.depth - 1));
            const parentOfTextBlock = $posAtEndOfTextBlock.parent;
            // If the parent of the textblock is a blockTaskItem,
            // we need to know if the textblock is the last node in the blockTaskItem
            if (parentOfTextBlock.type === blockTaskItem) {
                const lastChildOfBlockTaskItem = parentOfTextBlock.lastChild;
                if (lastChildOfBlockTaskItem === $from.parent) {
                    // If the textblock is the last node in the blockTaskItem,
                    // check if the selection is at the end of the textblock
                    const lastTextPosInTextBlock = $from.end($from.depth);
                    return $from.pos === lastTextPosInTextBlock;
                } else return false;
            }
        } else if ($from.parent.type === blockTaskItem) {
            // Check if the selection is at the end of the blockTaskItem
            const lastPosInBlockTaskItem = $from.end();
            return $from.pos === lastPosInBlockTaskItem;
        }
    }
    return empty && ($from.end() === $from.pos || state.selection instanceof (0, $j7pt0.GapCursorSelection));
};

});
parcelRegister("8gOte", function(module, exports) {
$parcel$export(module.exports, "atTheBeginningOfDoc", () => $6caea33aeccf3f0b$export$e9083e8cbe24bec0);
function $6caea33aeccf3f0b$export$e9083e8cbe24bec0(state) {
    const { selection: selection } = state;
    return selection.$from.pos === selection.$from.depth;
}

});

parcelRegister("16eXf", function(module, exports) {
$parcel$export(module.exports, "atTheEndOfDoc", () => $e3681dead17fd6b7$export$4ca816540352da02);
function $e3681dead17fd6b7$export$4ca816540352da02(state) {
    const { selection: selection, doc: doc } = state;
    return doc.nodeSize - selection.$to.pos - 2 === selection.$to.depth;
}

});

parcelRegister("cSk7K", function(module, exports) {
$parcel$export(module.exports, "filter", () => $9a9474ab8e4072d8$export$3dea766d36a8935f);
const $9a9474ab8e4072d8$export$3dea766d36a8935f = (predicates, cmd)=>{
    return function(state, dispatch, view) {
        if (!Array.isArray(predicates)) predicates = [
            predicates
        ];
        if (predicates.some((pred)=>!pred(state, view))) return false;
        return cmd(state, dispatch, view) || false;
    };
};

});

parcelRegister("7yXHq", function(module, exports) {
$parcel$export(module.exports, "insertNewLine", () => $7c54f386d105d982$export$c2d9390f63354627);

var $kW8qW = parcelRequire("kW8qW");

var $cw0wu = parcelRequire("cw0wu");
function $7c54f386d105d982$export$c2d9390f63354627() {
    return function(state, dispatch) {
        const { $from: $from } = state.selection;
        const parent = $from.parent;
        const { hardBreak: hardBreak } = state.schema.nodes;
        if (hardBreak) {
            const hardBreakNode = hardBreak.createChecked();
            if (parent && parent.type.validContent((0, $kW8qW.Fragment).from(hardBreakNode))) {
                if (dispatch) dispatch(state.tr.replaceSelectionWith(hardBreakNode, false));
                return true;
            }
        }
        if (state.selection instanceof (0, $cw0wu.TextSelection)) {
            if (dispatch) dispatch(state.tr.insertText('\n'));
            return true;
        }
        return false;
    };
}

});


parcelRegister("9dUiE", function(module, exports) {
$parcel$export(module.exports, "insertContentDeleteRange", () => $74488b53f0677c92$export$1a87582f65bdc5db);

var $cw0wu = parcelRequire("cw0wu");
const $74488b53f0677c92$export$1a87582f65bdc5db = (tr, getSelectionResolvedPos, insertions, deletions)=>{
    insertions.forEach((contentInsert)=>{
        const [content, pos] = contentInsert;
        tr.insert(tr.mapping.map(pos), content);
    });
    deletions.forEach((deleteRange)=>{
        const [firstPos, lastPos] = deleteRange;
        tr.delete(tr.mapping.map(firstPos), tr.mapping.map(lastPos));
    });
    tr.setSelection(new (0, $cw0wu.TextSelection)(getSelectionResolvedPos(tr)));
};

});

parcelRegister("bwDP2", function(module, exports) {
$parcel$export(module.exports, "GUTTER_SIZE_IN_PX", () => $b1fd41b31f6c489c$export$f4dbeaf4c0e3c381);
$parcel$export(module.exports, "GUTTER_SIZE_MOBILE_IN_PX", () => $b1fd41b31f6c489c$export$8b3ad80c47d385e3);
$parcel$export(module.exports, "GUTTER_SELECTOR", () => $b1fd41b31f6c489c$export$c90c3407e87d7a1f);
const $b1fd41b31f6c489c$export$f4dbeaf4c0e3c381 = 120; // Default gutter size
const $b1fd41b31f6c489c$export$8b3ad80c47d385e3 = 36; // Gutter size for Mobile
const $b1fd41b31f6c489c$export$c90c3407e87d7a1f = '#editor-scroll-gutter';

});

parcelRegister("0fR8c", function(module, exports) {
$parcel$export(module.exports, "getTimeSince", () => $6efce07e8d6d8446$export$a26b90db2c8f1b97);
/**
 * Calculate the difference between performance.now() and the given startTime.
 * This allows for the timing to be overridable during tests.
 *
 * @param startTime DOMHighResTimeStamp
 * @returns DOMHighResTimeStamp
 */ const $6efce07e8d6d8446$export$a26b90db2c8f1b97 = (startTime)=>performance.now() - startTime;

});

parcelRegister("iUiR7", function(module, exports) {
$parcel$export(module.exports, "countNodes", () => $2b0ad206724cbc51$export$1daf15cbaf649dad);
function $2b0ad206724cbc51$export$1daf15cbaf649dad(state) {
    var _nodeTypes$extension, _nodeTypes$inlineExte, _nodeTypes$bodiedExte, _nodeTypes$multiBodie;
    const nodeCount = {};
    const extensionNodeCount = {};
    const nodeTypes = state.schema.nodes;
    const extensionNodeTypes = [
        (_nodeTypes$extension = nodeTypes.extension) === null || _nodeTypes$extension === void 0 ? void 0 : _nodeTypes$extension.name,
        (_nodeTypes$inlineExte = nodeTypes.inlineExtension) === null || _nodeTypes$inlineExte === void 0 ? void 0 : _nodeTypes$inlineExte.name,
        (_nodeTypes$bodiedExte = nodeTypes.bodiedExtension) === null || _nodeTypes$bodiedExte === void 0 ? void 0 : _nodeTypes$bodiedExte.name,
        (_nodeTypes$multiBodie = nodeTypes.multiBodiedExtension) === null || _nodeTypes$multiBodie === void 0 ? void 0 : _nodeTypes$multiBodie.name
    ];
    state.doc.descendants((node)=>{
        var _node$attrs;
        const nodeName = node.type.name;
        if (nodeName in nodeCount) nodeCount[nodeName]++;
        else nodeCount[nodeName] = 1;
        let extensionNodeName = nodeName;
        if (extensionNodeTypes.includes(extensionNodeName) && (_node$attrs = node.attrs) !== null && _node$attrs !== void 0 && _node$attrs.extensionType) {
            var _node$attrs2;
            extensionNodeName = `${node.attrs.extensionType} - ${(_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.extensionKey}`;
            if (extensionNodeName in extensionNodeCount) extensionNodeCount[extensionNodeName]++;
            else extensionNodeCount[extensionNodeName] = 1;
        }
        return true;
    });
    return {
        nodeCount: nodeCount,
        extensionNodeCount: extensionNodeCount
    };
}

});

parcelRegister("33v8M", function(module, exports) {
$parcel$export(module.exports, "createRule", () => $2d9bdccb8f932ebc$export$56e87122f905fac0);

var $kQkyj = parcelRequire("kQkyj");
const $2d9bdccb8f932ebc$export$56e87122f905fac0 = (match, handler, allowsBackwardMatch = false)=>{
    return {
        match: match,
        handler: handler,
        onHandlerApply: (_state, tr)=>{
            (0, $kQkyj.closeHistory)(tr);
        },
        allowsBackwardMatch: allowsBackwardMatch
    };
};

});
parcelRegister("kQkyj", function(module, exports) {
$parcel$export(module.exports, "closeHistory", () => $194042f5a9e26217$export$181a649d919c589e);

var $ft3yp = parcelRequire("ft3yp");
function $194042f5a9e26217$export$181a649d919c589e(tr) {
    return tr.setMeta((0, $ft3yp.closeHistoryKey), true);
}

});


parcelRegister("hfNS8", function(module, exports) {
$parcel$export(module.exports, "inputRuleWithAnalytics", () => $55c609400039874f$export$333ee6e3f01bb8f9);
$parcel$export(module.exports, "createWrappingJoinRule", () => $55c609400039874f$export$6341edfa2d147bc);

var $3DNV7 = parcelRequire("3DNV7");

var $gpVit = parcelRequire("gpVit");

var $33v8M = parcelRequire("33v8M");
const $55c609400039874f$export$333ee6e3f01bb8f9 = (getPayload, analyticsApi)=>{
    return (originalRule)=>{
        const onHandlerApply = (state, tr, matchResult)=>{
            const payload = typeof getPayload === 'function' ? getPayload(state, matchResult) : getPayload;
            if (payload && payload.attributes) payload.attributes.formatSize = typeof matchResult[0] === 'string' ? matchResult[0].length : 0;
            analyticsApi === null || analyticsApi === void 0 || analyticsApi.attachAnalyticsEvent(payload)(tr);
            if (originalRule.onHandlerApply) originalRule.onHandlerApply(state, tr, matchResult);
        };
        return {
            ...originalRule,
            onHandlerApply: onHandlerApply
        };
    };
};
const $55c609400039874f$export$6341edfa2d147bc = ({ match: match, nodeType: nodeType, getAttrs: getAttrs, joinPredicate: joinPredicate })=>{
    const handler = (state, match, start, end)=>{
        const attrs = (getAttrs instanceof Function ? getAttrs(match) : getAttrs) || {};
        const tr = state.tr;
        const fixedStart = Math.max(start, 1);
        tr.delete(fixedStart, end);
        const $start = tr.doc.resolve(fixedStart);
        const range = $start.blockRange();
        const wrapping = range && (0, $3DNV7.findWrapping)(range, nodeType, attrs);
        if (!wrapping || !range) return null;
        const parentNodePosMapped = tr.mapping.map(range.start);
        const parentNode = tr.doc.nodeAt(parentNodePosMapped);
        const lastWrap = wrapping[wrapping.length - 1];
        if (parentNode && lastWrap) {
            const allowedMarks = lastWrap.type.allowedMarks(parentNode.marks) || [];
            tr.setNodeMarkup(parentNodePosMapped, parentNode.type, parentNode.attrs, allowedMarks);
        }
        tr.wrap(range, wrapping);
        const before = tr.doc.resolve(fixedStart - 1).nodeBefore;
        if (before && before.type === nodeType && (0, $3DNV7.canJoin)(tr.doc, fixedStart - 1) && (!joinPredicate || joinPredicate(match, before, (0, $gpVit.JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST).JOINED_TO_LIST_ABOVE))) tr.join(fixedStart - 1);
        return tr;
    };
    return (0, $33v8M.createRule)(match, handler);
};

});
parcelRegister("gpVit", function(module, exports) {
$parcel$export(module.exports, "DELETE_DIRECTION", () => $ce76588290ba6636$export$a9b79b94eb5ffad);
$parcel$export(module.exports, "LIST_TEXT_SCENARIOS", () => $ce76588290ba6636$export$c3c848735ee9408a);
$parcel$export(module.exports, "JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST", () => $ce76588290ba6636$export$43e6a678b13eb45f);
var $ce76588290ba6636$export$a9b79b94eb5ffad = /*#__PURE__*/ function(DELETE_DIRECTION) {
    DELETE_DIRECTION["BACKWARD"] = "backward";
    DELETE_DIRECTION["FORWARD"] = "forward";
    return DELETE_DIRECTION;
}({});
var $ce76588290ba6636$export$c3c848735ee9408a = /*#__PURE__*/ function(LIST_TEXT_SCENARIOS) {
    LIST_TEXT_SCENARIOS["JOIN_SIBLINGS"] = "joinSiblings";
    LIST_TEXT_SCENARIOS["JOIN_DESCENDANT_TO_PARENT"] = "joinDescendantToParent";
    LIST_TEXT_SCENARIOS["JOIN_TO_SIBLING_DESCENDANT"] = "joinToSiblingDescendant";
    LIST_TEXT_SCENARIOS["JOIN_PARAGRAPH_WITH_LIST"] = "joinParagraphWithList";
    LIST_TEXT_SCENARIOS["JOIN_PARENT_SIBLING_TO_PARENT_CHILD"] = "joinParentSiblingToParentChild";
    LIST_TEXT_SCENARIOS["JOIN_LIST_ITEM_WITH_PARAGRAPH"] = "joinListItemWithParagraph";
    return LIST_TEXT_SCENARIOS;
}({});
var $ce76588290ba6636$export$43e6a678b13eb45f = /*#__PURE__*/ function(JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST) {
    JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST["NO_JOIN"] = "noJoin";
    JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST["JOINED_TO_LIST_ABOVE"] = "joinedToListAbove";
    JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST["JOINED_TO_LIST_BELOW"] = "joinedToListBelow";
    return JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST;
}({});
var $ce76588290ba6636$export$ed4ba8ac11f6cbc8 = /*#__PURE__*/ function(OUTDENT_SCENARIOS) {
    OUTDENT_SCENARIOS["SPLIT_LIST"] = "splitList";
    return OUTDENT_SCENARIOS;
}({});

});


parcelRegister("di3Bh", function(module, exports) {
$parcel$export(module.exports, "dedupe", () => $4189c3f3121f8a0c$export$f3a259b74a77132f);
function $4189c3f3121f8a0c$export$f3a259b74a77132f(list = [], iteratee = (p)=>p) {
    /**
               .,
     .      _,'f----.._
     |\ ,-'"/  |     ,'
     |,_  ,--.      /
     /,-. ,'`.     (_
     f  o|  o|__     "`-.
     ,-._.,--'_ `.   _.,-`
     `"' ___.,'` j,-'
       `-.__.,--'
     Gotta go fast!
  */ const seen = new Set();
    list.forEach((l)=>seen.add(iteratee(l)));
    return list.filter((l)=>{
        const it = iteratee(l);
        if (seen.has(it)) {
            seen.delete(it);
            return true;
        }
        return false;
    });
}

});

parcelRegister("1SmGf", function(module, exports) {
$parcel$export(module.exports, "createWrapSelectionTransaction", () => $9c2b400d0dfd84d6$export$d5c308539c2b2123);
$parcel$export(module.exports, "getWrappingOptions", () => $9c2b400d0dfd84d6$export$656aa714448bfa8a);

var $cw0wu = parcelRequire("cw0wu");

var $3DNV7 = parcelRequire("3DNV7");

var $gab48 = parcelRequire("gab48");

var $12B4z = parcelRequire("12B4z");
function $9c2b400d0dfd84d6$export$d5c308539c2b2123({ state: state, type: type, nodeAttributes: nodeAttributes }) {
    let { tr: tr } = state;
    const { alignment: alignment, indentation: indentation } = state.schema.marks;
    /** Alignment or Indentation is not valid inside block types */ const removeAlignTr = (0, $12B4z.removeBlockMarks)(state, [
        alignment,
        indentation
    ]);
    tr = removeAlignTr || tr;
    /**Get range and wrapping needed for the selection*/ const { range: range, wrapping: wrapping } = $9c2b400d0dfd84d6$export$656aa714448bfa8a(state, type, nodeAttributes);
    if (wrapping) tr.wrap(range, wrapping).scrollIntoView();
    else /** We always want to append a block type */ (0, $gab48.safeInsert)(type.createAndFill(nodeAttributes))(tr).scrollIntoView();
    return tr;
}
function $9c2b400d0dfd84d6$export$656aa714448bfa8a(state, type, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
nodeAttributes) {
    const { $from: $from, $to: $to, from: from } = state.selection;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let range = $from.blockRange($to);
    const isMediaSelection = state.selection instanceof (0, $cw0wu.NodeSelection) && state.selection.node.type === state.schema.nodes.media;
    /**
   * To wrap a media group we need to start the range from one position
   * before a media selection's from position.
   */ if (isMediaSelection) {
        const prev = from - 1;
        range = state.doc.resolve(from > 0 ? prev : from).blockRange($to);
    }
    let isAllowedChild = true;
    /**
   * Added a check to avoid wrapping codeblock
   */ if (state.selection.empty) state.doc.nodesBetween($from.pos, $to.pos, (node)=>{
        if (!isAllowedChild) return false;
        return isAllowedChild = node.type !== state.schema.nodes.codeBlock;
    });
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const wrapping = isAllowedChild && range && (0, $3DNV7.findWrapping)(range, type, nodeAttributes);
    return {
        range: range,
        wrapping: wrapping
    };
}

});

parcelRegister("9MlgY", function(module, exports) {
$parcel$export(module.exports, "transformNodeIntoListItem", () => $a3b4cc7aac9a5879$export$f4c81471ccea5042);

var $kW8qW = parcelRequire("kW8qW");

var $cw0wu = parcelRequire("cw0wu");

var $gab48 = parcelRequire("gab48");

var $iE5F1 = parcelRequire("iE5F1");
// Taken from `editor-plugin-content-insertion`
function $a3b4cc7aac9a5879$var$setSelectionToValidTextNode(tr, node, from) {
    const sliceInserted = (0, $kW8qW.Slice).maxOpen((0, $kW8qW.Fragment).from(node));
    const openPosition = Math.min(from + (node.isAtom ? node.nodeSize : sliceInserted.openStart), tr.doc.content.size);
    const FORWARD_DIRECTION = 1;
    const nextSelection = (0, $cw0wu.TextSelection).findFrom(tr.doc.resolve(openPosition), FORWARD_DIRECTION, true);
    if (nextSelection) return tr.setSelection(nextSelection);
}
function $a3b4cc7aac9a5879$export$f4c81471ccea5042(tr, node) {
    var _tr$doc$nodeAt;
    const { $to: $to, $from: $from, to: to, from: from } = tr.selection;
    const { orderedList: orderedList, bulletList: bulletList, listItem: listItem } = tr.doc.type.schema.nodes;
    const startLinePosition = $from.start();
    const parentStartPosition = $from.depth === 0 ? 0 : $from.before();
    // Setting the start position
    const startMapped = startLinePosition === from ? parentStartPosition : from;
    // Selected nodes
    const selectionParentListItemNode = (0, $gab48.findParentNodeOfType)(listItem)(tr.selection);
    const selectionParentListNodeWithPos = (0, $gab48.findParentNodeOfType)([
        bulletList,
        orderedList
    ])(tr.selection);
    const selectionParentListNode = selectionParentListNodeWithPos === null || selectionParentListNodeWithPos === void 0 ? void 0 : selectionParentListNodeWithPos.node;
    if (!selectionParentListNodeWithPos) return tr;
    // Offsets
    const listWrappingOffset = $to.depth - selectionParentListNodeWithPos.depth + 1; // difference in depth between to position and list node
    const listItemWrappingOffset = $to.depth - selectionParentListNodeWithPos.depth; // difference in depth between to position and list item node
    // Anything to do with nested lists should safeInsert and not be handled here
    const grandParentListNode = (0, $gab48.findParentNodeOfTypeClosestToPos)(tr.doc.resolve(selectionParentListNodeWithPos.pos), [
        bulletList,
        orderedList
    ]);
    const selectionIsInNestedList = !!grandParentListNode;
    let selectedListItemHasNestedList = false;
    selectionParentListItemNode === null || selectionParentListItemNode === void 0 || selectionParentListItemNode.node.content.forEach((child)=>{
        if ((0, $iE5F1.isListNode)(child)) selectedListItemHasNestedList = true;
    });
    if (selectedListItemHasNestedList || selectionIsInNestedList) return (0, $gab48.safeInsert)(node)(tr).scrollIntoView();
    // Check if node after the insert position is listItem
    const isNodeAfterInsertPositionIsListItem = ((_tr$doc$nodeAt = tr.doc.nodeAt(to + listItemWrappingOffset)) === null || _tr$doc$nodeAt === void 0 ? void 0 : _tr$doc$nodeAt.type) === listItem;
    let replaceTo;
    if (isNodeAfterInsertPositionIsListItem) replaceTo = to + listItemWrappingOffset;
    else if (!isNodeAfterInsertPositionIsListItem) replaceTo = to;
    else replaceTo = to + listWrappingOffset;
    // handle the insertion of the slice
    tr.replaceWith(startMapped, replaceTo, node).scrollIntoView();
    // Get the next list items position (used later to find the split out ordered list)
    const indexOfNextListItem = $to.indexAfter($to.depth - listItemWrappingOffset);
    const positionOfNextListItem = tr.doc.resolve(selectionParentListNodeWithPos.pos + 1).posAtIndex(indexOfNextListItem);
    // Place the selection at the replaced location
    $a3b4cc7aac9a5879$var$setSelectionToValidTextNode(tr, node, from);
    // Find the ordered list node after the pasted content so we can set it's order
    const mappedPositionOfNextListItem = tr.mapping.map(positionOfNextListItem);
    if (mappedPositionOfNextListItem > tr.doc.nodeSize) return tr;
    const nodeAfterPastedContentResolvedPos = (0, $gab48.findParentNodeOfTypeClosestToPos)(tr.doc.resolve(mappedPositionOfNextListItem), [
        orderedList
    ]);
    // Work out the new split out lists 'order' (the number it starts from)
    const originalParentOrderedListNodeOrder = selectionParentListNode === null || selectionParentListNode === void 0 ? void 0 : selectionParentListNode.attrs.order;
    const nodeOfOriginalList = (0, $gab48.findParentNodeOfTypeClosestToPos)(tr.doc.resolve(from - 1), [
        orderedList
    ]);
    const numOfListItemsInOriginalList = nodeOfOriginalList === null || nodeOfOriginalList === void 0 ? void 0 : nodeOfOriginalList.node.childCount;
    // Set the new split out lists order attribute
    if (typeof originalParentOrderedListNodeOrder === 'number' && numOfListItemsInOriginalList && nodeAfterPastedContentResolvedPos && // We only want to apply the node markup if we're referring to the split
    // list rather than the original
    (nodeOfOriginalList === null || nodeOfOriginalList === void 0 ? void 0 : nodeOfOriginalList.node) !== (nodeAfterPastedContentResolvedPos === null || nodeAfterPastedContentResolvedPos === void 0 ? void 0 : nodeAfterPastedContentResolvedPos.node)) tr.setNodeMarkup(nodeAfterPastedContentResolvedPos.pos, orderedList, {
        ...nodeAfterPastedContentResolvedPos.node.attrs,
        order: originalParentOrderedListNodeOrder + numOfListItemsInOriginalList
    });
    return tr;
}

});

parcelRegister("b9WCP", function(module, exports) {
$parcel$export(module.exports, "wrapSelectionIn", () => $ba90eb6a6b6c02ad$export$f63f505240212912);

var $1SmGf = parcelRequire("1SmGf");
function $ba90eb6a6b6c02ad$export$f63f505240212912(type) {
    return function(state, dispatch) {
        const tr = (0, $1SmGf.createWrapSelectionTransaction)({
            state: state,
            type: type
        });
        if (dispatch) dispatch(tr);
        return true;
    };
}

});

parcelRegister("ljmZN", function(module, exports) {
$parcel$export(module.exports, "getPageElementCounts", () => $7b9d440d920f2617$export$46a7f65963d82cf5);

var $5dP8l = parcelRequire("5dP8l");

var $84v5S = parcelRequire("84v5S");
const $7b9d440d920f2617$export$46a7f65963d82cf5 = (doc)=>{
    const pageElementCounts = {
        elements: {},
        textFormats: {},
        macros: {},
        unexpectedElements: {}
    };
    (0, $5dP8l.reduce)(doc, (acc, node)=>{
        if (node.type === 'text') {
            if (node.marks) node.marks.forEach((mark)=>{
                const markType = mark.type;
                acc.textFormats[markType] = (acc.textFormats[markType] ?? 0) + 1;
            });
            acc.elements[node.type] = (acc.elements[node.type] ?? 0) + 1;
        } else if (node.type === 'extension' || node.type === 'inlineExtension' || node.type === 'bodiedExtension' || node.type === 'multiBodiedExtension' || node.type === 'extensionFrame') {
            if ('attrs' in node && node.attrs && 'extensionKey' in node.attrs && node.attrs.extensionKey) {
                let extensionKey = node.attrs.extensionKey;
                // If there is a nested table extension
                if ((0, $84v5S.isNestedTableExtension)(node)) {
                    if ('parameters' in node.attrs && node.attrs.parameters && 'adf' in node.attrs.parameters) {
                        // Check to see if the ADF contains a nested table
                        const adfString = node.attrs.parameters.adf;
                        const adf = JSON.parse(adfString);
                        if (adfString.includes('{"type":"table"')) {
                            if ($7b9d440d920f2617$var$getHasNestedTable(adf)) acc.unexpectedElements['tablesNestedMoreThanOnce'] = (acc.unexpectedElements['tablesNestedMoreThanOnce'] ?? 0) + 1;
                        }
                    }
                }
                // If macros extensionKey has <UUID>/<UUID>/static/ prepended to it, remove the prefix
                if (extensionKey.includes('/static/')) {
                    const extensionKeyParts = extensionKey.split('/');
                    extensionKey = extensionKeyParts[extensionKeyParts.length - 1];
                }
                acc.macros[extensionKey] = (acc.macros[extensionKey] ?? 0) + 1;
            }
        } else acc.elements[node.type] = (acc.elements[node.type] ?? 0) + 1;
        return acc;
    }, pageElementCounts);
    return pageElementCounts;
};
/**
 * Return true is the JSON document contains a table nested within a table
 */ const $7b9d440d920f2617$var$getHasNestedTable = (node)=>{
    return (0, $5dP8l.reduce)(node, (hasNestedTable, node)=>{
        if (hasNestedTable) return hasNestedTable;
        if (node.type === 'table') {
            // The first node that we pass into the reduce function is a table node, and we need to ignore it
            let foundFirstTable = false;
            return (0, $5dP8l.reduce)(node, (hasNestedTable, node)=>{
                if (hasNestedTable) return hasNestedTable;
                if (node.type === 'table' && foundFirstTable) return true;
                else if (node.type === 'table') foundFirstTable = true;
                return hasNestedTable;
            }, false);
        }
        return hasNestedTable;
    }, false);
};

});

parcelRegister("gB6pl", function(module, exports) {
$parcel$export(module.exports, "withFeatureFlaggedComponent", () => $57ee208176430643$export$55dba0d8ccf3da86);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");
const $57ee208176430643$export$55dba0d8ccf3da86 = (ComponentOld, ComponentNext, featureFlagFn)=>{
    return (props)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return featureFlagFn() ? /*#__PURE__*/ (0, $dc70d.jsx)(ComponentNext, {
            ...props
        }) : /*#__PURE__*/ (0, $dc70d.jsx)(ComponentOld, {
            ...props
        });
    };
};

});


parcelRegister("jYhRK", function(module, exports) {
$parcel$export(module.exports, "DIRECTION", () => $51a42c1b0b20c048$export$9106728c49045482);
var $51a42c1b0b20c048$export$9106728c49045482 = /*#__PURE__*/ function(DIRECTION) {
    DIRECTION["UP"] = "up";
    DIRECTION["DOWN"] = "down";
    DIRECTION["LEFT"] = "left";
    DIRECTION["RIGHT"] = "right";
    return DIRECTION;
}({});

});

parcelRegister("eutMJ", function(module, exports) {
$parcel$export(module.exports, "expandedState", () => $424f417e6295f5a0$export$de2a5eca4f1cacc0);
$parcel$export(module.exports, "TOGGLE_EXPAND_RANGE_META_KEY", () => $424f417e6295f5a0$export$657fbcd00719af4b);
$parcel$export(module.exports, "toggleExpandRange", () => $424f417e6295f5a0$export$de35616b4bcd2077);
$parcel$export(module.exports, "isExpandCollapsed", () => $424f417e6295f5a0$export$785b8bfd794fa7b6);
$parcel$export(module.exports, "getNextNodeExpandPos", () => $424f417e6295f5a0$export$90f32e719ed9ccda);

var $gab48 = parcelRequire("gab48");

var $gdUUy = parcelRequire("gdUUy");
const $424f417e6295f5a0$export$de2a5eca4f1cacc0 = new WeakMap();
const $424f417e6295f5a0$export$657fbcd00719af4b = 'toggleExpandRange';
const $424f417e6295f5a0$export$de35616b4bcd2077 = (from, to, open = true)=>({ tr: tr })=>{
        const { expand: expand, nestedExpand: nestedExpand } = tr.doc.type.schema.nodes;
        const fromClamped = from && from >= 0 ? from : 0;
        const toClamped = to && to <= tr.doc.content.size ? to : tr.doc.content.size;
        const positions = [];
        tr.doc.nodesBetween(fromClamped, toClamped, (node, pos)=>{
            if ([
                expand,
                nestedExpand
            ].includes(node.type)) {
                $424f417e6295f5a0$export$de2a5eca4f1cacc0.set(node, open);
                positions.push(pos);
            }
        });
        if (positions.length === 0) // No expand nodes found in the range — nothing to dispatch.
        return null;
        // preserve positions from earlier calls on the same transaction so callers can target disjoint ranges
        // without opening unrelated expands between them.
        const existingMeta = tr.getMeta($424f417e6295f5a0$export$657fbcd00719af4b);
        const combinedPositions = (existingMeta === null || existingMeta === void 0 ? void 0 : existingMeta.open) === open && (0, $gdUUy.fg)('platform_editor_ai_show_diff_patch_2') ? Array.from(new Set([
            ...existingMeta.positions,
            ...positions
        ])) : positions;
        // Set meta so the expand PM plugin can add node decorations.
        // This ensures ExpandNodeView.update() receives the decoration and visually
        // opens or closes the expand.
        tr.setMeta($424f417e6295f5a0$export$657fbcd00719af4b, {
            positions: combinedPositions,
            open: open
        });
        return tr;
    };
const $424f417e6295f5a0$export$785b8bfd794fa7b6 = (node)=>{
    // @ts-ignore - TS2869 TypeScript 5.9.2 upgrade
    return !$424f417e6295f5a0$export$de2a5eca4f1cacc0.get(node) ?? false;
};
const $424f417e6295f5a0$export$90f32e719ed9ccda = (editorView, selection)=>{
    let parentNode = (0, $gab48.findParentNodeOfType)([
        editorView.state.schema.nodes.listItem,
        editorView.state.schema.nodes.heading,
        editorView.state.schema.nodes.blockquote,
        editorView.state.schema.nodes.taskItem,
        editorView.state.schema.nodes.mediaSingle
    ])(selection);
    const tableRowNode = (0, $gab48.findParentNodeOfType)([
        editorView.state.schema.nodes.tableRow
    ])(selection);
    if (tableRowNode) parentNode = tableRowNode;
    if (!parentNode) {
        const paragraphNode = (0, $gab48.findParentNodeOfType)([
            editorView.state.schema.nodes.paragraph
        ])(selection);
        if (!paragraphNode) return;
        parentNode = paragraphNode;
    }
    if (!parentNode) return undefined;
    const endPosOffset = parentNode && [
        'taskItem',
        'listItem',
        'tableRow'
    ].includes(parentNode.node.type.name) ? 1 : 0;
    const endOfTextblockPos = parentNode.start + parentNode.node.content.size + endPosOffset + 1;
    if (endOfTextblockPos > editorView.state.doc.content.size) return undefined;
    const $endOfTextblockPos = editorView.state.doc.resolve(endOfTextblockPos);
    if ($endOfTextblockPos !== null && $endOfTextblockPos !== void 0 && $endOfTextblockPos.nodeAfter && [
        'expand',
        'nestedExpand'
    ].includes($endOfTextblockPos.nodeAfter.type.name)) return endOfTextblockPos + 1;
    return undefined;
};

});

parcelRegister("58V7h", function(module, exports) {
$parcel$export(module.exports, "transformSliceNestedExpandToExpand", () => $f7d4adeee427edd3$export$fd33fafbf6b5abc7);

var $kW8qW = parcelRequire("kW8qW");

var $4ClnP = parcelRequire("4ClnP");
const $f7d4adeee427edd3$export$fd33fafbf6b5abc7 = (slice, schema)=>{
    const { expand: expand, nestedExpand: nestedExpand } = schema.nodes;
    const children = [];
    (0, $4ClnP.mapChildren)(slice.content, (node)=>{
        if (node.type === nestedExpand) children.push(expand.createChecked(node.attrs, node.content, node.marks));
        else children.push(node);
    });
    return new (0, $kW8qW.Slice)((0, $kW8qW.Fragment).fromArray(children), slice.openStart, slice.openEnd);
};

});

parcelRegister("hfHX9", function(module, exports) {
$parcel$export(module.exports, "isInTable", () => $a9047ba2f609fcf2$export$217a88ad224d1b11);
function $a9047ba2f609fcf2$export$217a88ad224d1b11(state) {
    const { $head: $head } = state.selection;
    for(let d = $head.depth; d > 0; d--){
        if ($head.node(d).type.spec.tableRole === 'row') return true;
    }
    return false;
}

});

parcelRegister("guQFl", function(module, exports) {
$parcel$export(module.exports, "FORMAT_SELECTION_SYNC_META", () => $5ddf550c5ae588b6$export$c97c07443881dcfe);
/**
 * Transaction meta key used by the selection-preservation plugin
 * to detect formatting operations that need selection re-syncing.
 *
 * When a formatting command (text color, highlight, etc.) changes the document,
 * it sets this meta key to `true` so the selection-preservation plugin can
 * re-sync the DOM selection after the transaction is applied.
 */ const $5ddf550c5ae588b6$export$c97c07443881dcfe = 'editorPluginSelectionPreservationFormatSync';

});

parcelRegister("1KaSt", function(module, exports) {
$parcel$export(module.exports, "PassThrough", () => $585fdca6eaa5792f$export$b5d6a35b0cce4297);
$parcel$export(module.exports, "getComponentIdentity", () => $585fdca6eaa5792f$export$c6c0878963f3d78c);
$parcel$export(module.exports, "resolveSurface", () => $585fdca6eaa5792f$export$fe6905bc20e8faef);
$parcel$export(module.exports, "willComponentRender", () => $585fdca6eaa5792f$export$51a8f8a5d7877637);

var $3y2s4 = parcelRequire("3y2s4");
const $585fdca6eaa5792f$export$b5d6a35b0cce4297 = (props)=>props.children ?? null;
const $585fdca6eaa5792f$export$c6c0878963f3d78c = ({ type: type, key: key })=>(0, $3y2s4.isExperimentEnabled)('platform_editor_slash_command') || (0, $3y2s4.isExperimentEnabled)('platform_editor_block_control_migration') ? `${type}:${key}` : key;
const $585fdca6eaa5792f$export$c3213ee7169ceb28 = (components, surface)=>{
    return components.find((c)=>c.key === surface.key && c.type === surface.type && (!c.parents || c.parents.length === 0));
};
const $585fdca6eaa5792f$export$93e686d60d327014 = (components)=>{
    const childrenMap = new Map();
    for (const component of components){
        if (component.parents && component.parents.length > 0) for (const parent of component.parents){
            const parentIdentity = $585fdca6eaa5792f$export$c6c0878963f3d78c(parent);
            const existing = childrenMap.get(parentIdentity) || [];
            existing.push(component);
            childrenMap.set(parentIdentity, existing);
        }
    }
    for (const [parentIdentity, children] of childrenMap.entries())children.sort((a, b)=>{
        var _a$parents, _b$parents;
        const rankA = ((_a$parents = a.parents) === null || _a$parents === void 0 || (_a$parents = _a$parents.find((parent)=>$585fdca6eaa5792f$export$c6c0878963f3d78c(parent) === parentIdentity)) === null || _a$parents === void 0 ? void 0 : _a$parents.rank) ?? 0;
        const rankB = ((_b$parents = b.parents) === null || _b$parents === void 0 || (_b$parents = _b$parents.find((parent)=>$585fdca6eaa5792f$export$c6c0878963f3d78c(parent) === parentIdentity)) === null || _b$parents === void 0 ? void 0 : _b$parents.rank) ?? 0;
        return rankA - rankB;
    });
    return childrenMap;
};
const $585fdca6eaa5792f$export$fe6905bc20e8faef = (components, surface)=>{
    const root = $585fdca6eaa5792f$export$c3213ee7169ceb28(components, surface);
    const childrenMap = $585fdca6eaa5792f$export$93e686d60d327014(components);
    const surfaceComponents = [];
    if (root) {
        const visited = new Set();
        const visit = (component)=>{
            var _childrenMap$get;
            const identity = $585fdca6eaa5792f$export$c6c0878963f3d78c(component);
            if (visited.has(identity)) return;
            visited.add(identity);
            surfaceComponents.push(component);
            (_childrenMap$get = childrenMap.get(identity)) === null || _childrenMap$get === void 0 || _childrenMap$get.forEach(visit);
        };
        visit(root);
    }
    return {
        root: root,
        childrenMap: childrenMap,
        components: surfaceComponents,
        topLevelChildren: root ? childrenMap.get($585fdca6eaa5792f$export$c6c0878963f3d78c(root)) : undefined
    };
};
const $585fdca6eaa5792f$export$51a8f8a5d7877637 = (component, childrenMap, surfaceContext)=>{
    return $585fdca6eaa5792f$var$willComponentRenderWithAncestors(component, childrenMap, surfaceContext, new Set());
};
const $585fdca6eaa5792f$var$willComponentRenderWithAncestors = (component, childrenMap, surfaceContext, ancestors)=>{
    var _component$isHidden, _component$isHidden2;
    const isHidden = surfaceContext ? (_component$isHidden = component.isHidden) === null || _component$isHidden === void 0 ? void 0 : _component$isHidden.call(component, {
        surfaceContext: surfaceContext
    }) : (_component$isHidden2 = component.isHidden) === null || _component$isHidden2 === void 0 ? void 0 : _component$isHidden2.call(component);
    if (isHidden) return false;
    const identity = $585fdca6eaa5792f$export$c6c0878963f3d78c(component);
    if (ancestors.has(identity)) return false;
    const children = childrenMap.get(identity);
    if (!children || children.length === 0) return true;
    const nextAncestors = new Set(ancestors).add(identity);
    return children.some((child)=>$585fdca6eaa5792f$var$willComponentRenderWithAncestors(child, childrenMap, surfaceContext, nextAncestors));
};
const $585fdca6eaa5792f$export$c2309330e26ec74a = (components, surface, surfaceContext)=>{
    const { root: root, childrenMap: childrenMap } = $585fdca6eaa5792f$export$fe6905bc20e8faef(components, surface);
    return root ? $585fdca6eaa5792f$export$51a8f8a5d7877637(root, childrenMap, surfaceContext) : false;
};

});

parcelRegister("aCqPV", function(module, exports) {
$parcel$export(module.exports, "BLOCK_CONTROL_UI_CONTEXT", () => $2658245bf74f2d60$export$fefd0975cd9833d1);

var $2jViS = parcelRequire("2jViS");
const $2658245bf74f2d60$export$fefd0975cd9833d1 = (0, $2jViS.createContextToken)('block-control-ui');

});
parcelRegister("2jViS", function(module, exports) {
$parcel$export(module.exports, "createContextToken", () => $087b4c21977b7b9c$export$6314af1277ad7e78);
const $087b4c21977b7b9c$export$6314af1277ad7e78 = (description)=>Symbol(description);

});


parcelRegister("29Z7Q", function(module, exports) {
$parcel$export(module.exports, "createSurfaceContext", () => $a06aa013e590d077$export$942ad7aa4b1e11ec);
const $a06aa013e590d077$export$942ad7aa4b1e11ec = (token, value)=>({
        get: (requestedToken)=>requestedToken === token ? value : undefined
    });

});

parcelRegister("7fEzQ", function(module, exports) {
$parcel$export(module.exports, "SurfaceRenderer", () => $0b438a0aa6d5ee8f$export$86ec1cc3842ae5f);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $d4bYH = parcelRequire("d4bYH");

var $1KaSt = parcelRequire("1KaSt");
const $0b438a0aa6d5ee8f$var$ROOT_PARENTS = [];
const $0b438a0aa6d5ee8f$export$86ec1cc3842ae5f = ({ surface: surface, components: components, fallbacks: fallbacks, surfaceContext: surfaceContext })=>{
    const { root: root, childrenMap: childrenMap, topLevelChildren: topLevelChildren } = (0, $bSJIT.useMemo)(()=>{
        return (0, $1KaSt.resolveSurface)(components, surface);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        components,
        surface.key,
        surface.type
    ]);
    if (!root) return null;
    if (!(0, $1KaSt.willComponentRender)(root, childrenMap, surfaceContext)) return null;
    const RootComponent = root.component ?? (0, $1KaSt.PassThrough);
    return /*#__PURE__*/ (0, $dc70d.jsx)(RootComponent, {
        parents: $0b438a0aa6d5ee8f$var$ROOT_PARENTS,
        surfaceContext: surfaceContext,
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $d4bYH.SurfaceComponents), {
            components: topLevelChildren,
            childrenMap: childrenMap,
            fallbacks: fallbacks,
            /* eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed) */ parents: [
                {
                    key: root.key,
                    type: root.type
                }
            ],
            surfaceContext: surfaceContext
        })
    });
};

});
parcelRegister("d4bYH", function(module, exports) {
$parcel$export(module.exports, "SurfaceComponents", () => $5e9d396604db910b$export$e96f1fc68164e845);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $gfWA2 = parcelRequire("gfWA2");

var $1KaSt = parcelRequire("1KaSt");
const $5e9d396604db910b$export$e96f1fc68164e845 = ({ components: components, childrenMap: childrenMap, fallbacks: fallbacks, parents: parents, surfaceContext: surfaceContext })=>{
    if (!(components !== null && components !== void 0 && components.length)) return null;
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dc70d.Fragment), {
        children: components.map((component)=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $gfWA2.SurfaceComponent), {
                component: component,
                childrenMap: childrenMap,
                fallbacks: fallbacks,
                parents: parents,
                surfaceContext: surfaceContext
            }, (0, $1KaSt.getComponentIdentity)(component)))
    });
};

});
parcelRegister("gfWA2", function(module, exports) {
$parcel$export(module.exports, "SurfaceComponent", () => $f8e556853c351087$export$f6eb6537c5785f1e);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $d4bYH = parcelRequire("d4bYH");

var $1KaSt = parcelRequire("1KaSt");
const $f8e556853c351087$export$f6eb6537c5785f1e = ({ component: component, childrenMap: childrenMap, fallbacks: fallbacks, parents: parents, surfaceContext: surfaceContext })=>{
    if (!(0, $1KaSt.willComponentRender)(component, childrenMap, surfaceContext)) return null;
    const children = childrenMap.get((0, $1KaSt.getComponentIdentity)(component));
    const Component = component.component ?? (fallbacks === null || fallbacks === void 0 ? void 0 : fallbacks[component.type]) ?? (0, $1KaSt.PassThrough);
    const newParents = [
        ...parents,
        {
            key: component.key,
            type: component.type
        }
    ];
    if (!children || children.length === 0) return /*#__PURE__*/ (0, $dc70d.jsx)(Component, {
        parents: parents,
        surfaceContext: surfaceContext,
        children: null
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)(Component, {
        parents: parents,
        surfaceContext: surfaceContext,
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $d4bYH.SurfaceComponents), {
            components: children,
            childrenMap: childrenMap,
            fallbacks: fallbacks,
            parents: newParents,
            surfaceContext: surfaceContext
        })
    });
};

});



parcelRegister("2j1Ci", function(module, exports) {
$parcel$export(module.exports, "resizerItemClassName", () => $07ac6742969d310b$export$a06160db3520e5a2);
$parcel$export(module.exports, "resizerHoverZoneClassName", () => $07ac6742969d310b$export$c42cdcfd48254bda);
$parcel$export(module.exports, "resizerExtendedZone", () => $07ac6742969d310b$export$10b67c6ff1748bd);
$parcel$export(module.exports, "resizerHandleClassName", () => $07ac6742969d310b$export$6afc20f0ff6d041);
$parcel$export(module.exports, "resizerHandleTrackClassName", () => $07ac6742969d310b$export$a5792d7e2a486d41);
$parcel$export(module.exports, "resizerHandleThumbClassName", () => $07ac6742969d310b$export$2201bc1aaee73f36);
$parcel$export(module.exports, "resizerDangerClassName", () => $07ac6742969d310b$export$97a99610b6f0a178);
$parcel$export(module.exports, "handleWrapperClass", () => $07ac6742969d310b$export$b123b2c8a2536d05);
$parcel$export(module.exports, "resizerHandleThumbWidth", () => $07ac6742969d310b$export$b5fa87f62ced4967);
$parcel$export(module.exports, "resizerHandleZIndex", () => $07ac6742969d310b$export$3d867927ebf9bc1f);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ /*
  Styles in this file are based on
  packages/editor/editor-core/src/plugins/media/styles.ts
*/ const $07ac6742969d310b$export$a06160db3520e5a2 = 'resizer-item';
const $07ac6742969d310b$export$c42cdcfd48254bda = 'resizer-hover-zone';
const $07ac6742969d310b$export$10b67c6ff1748bd = 'resizer-is-extended';
const $07ac6742969d310b$export$6afc20f0ff6d041 = 'resizer-handle';
const $07ac6742969d310b$export$a5792d7e2a486d41 = `${$07ac6742969d310b$export$6afc20f0ff6d041}-track`;
const $07ac6742969d310b$export$2201bc1aaee73f36 = `${$07ac6742969d310b$export$6afc20f0ff6d041}-thumb`;
const $07ac6742969d310b$export$97a99610b6f0a178 = `${$07ac6742969d310b$export$6afc20f0ff6d041}-danger`;
const $07ac6742969d310b$export$b123b2c8a2536d05 = 'resizer-handle-wrapper';
const $07ac6742969d310b$export$b5fa87f62ced4967 = 3;
const $07ac6742969d310b$export$3d867927ebf9bc1f = 1;

});

parcelRegister("bosp6", function(module, exports) {
$parcel$export(module.exports, "surfaceDragHandleElementStore", () => $5f7efb3fbd882a70$export$77832c0bea73da80);
const $5f7efb3fbd882a70$var$elementByView = new WeakMap();
const $5f7efb3fbd882a70$var$listenersByView = new WeakMap();
const $5f7efb3fbd882a70$export$77832c0bea73da80 = {
    get: (view)=>{
        const element = view && $5f7efb3fbd882a70$var$elementByView.get(view) || null;
        return element !== null && element !== void 0 && element.isConnected ? element : null;
    },
    release: (view, element)=>{
        if (!view || !element || $5f7efb3fbd882a70$var$elementByView.get(view) !== element) return;
        $5f7efb3fbd882a70$export$77832c0bea73da80.set(view, null);
    },
    set: (view, element)=>{
        var _listenersByView$get;
        if (!view) return;
        const current = $5f7efb3fbd882a70$var$elementByView.get(view) ?? null;
        if (current === element) return;
        if (element) $5f7efb3fbd882a70$var$elementByView.set(view, element);
        else $5f7efb3fbd882a70$var$elementByView.delete(view);
        (_listenersByView$get = $5f7efb3fbd882a70$var$listenersByView.get(view)) === null || _listenersByView$get === void 0 || _listenersByView$get.forEach((listener)=>listener());
    },
    subscribe: (view, listener)=>{
        if (!view) return ()=>{};
        const listeners = $5f7efb3fbd882a70$var$listenersByView.get(view) ?? new Set();
        listeners.add(listener);
        $5f7efb3fbd882a70$var$listenersByView.set(view, listeners);
        return ()=>{
            listeners.delete(listener);
        };
    }
};

});

parcelRegister("3J3tU", function(module, exports) {
$parcel$export(module.exports, "defaultWordWrapState", () => $619e230c2e411c8b$export$dea78458f6234074);
$parcel$export(module.exports, "codeBlockWrappedStates", () => $619e230c2e411c8b$export$15e74cb2b99d4f44);
$parcel$export(module.exports, "getDefaultCodeBlockAttrs", () => $619e230c2e411c8b$export$f86d342c9776cad6);
$parcel$export(module.exports, "normalizeMarkdownCodeBlockAttrsInSlice", () => $619e230c2e411c8b$export$95a2b1adfd5a9190);
$parcel$export(module.exports, "getInsertedCodeBlocksInTransaction", () => $619e230c2e411c8b$export$ee996fbdea8dfc30);
$parcel$export(module.exports, "isCodeBlockWordWrapEnabled", () => $619e230c2e411c8b$export$ca74aa614fc297de);
$parcel$export(module.exports, "areCodeBlockLineNumbersHidden", () => $619e230c2e411c8b$export$ae57f08acfae6877);
$parcel$export(module.exports, "areCodeBlockLineNumbersVisible", () => $619e230c2e411c8b$export$17fa4cce31080ba8);
$parcel$export(module.exports, "getCodeBlockFoldState", () => $619e230c2e411c8b$export$dd8d371c28bc93ab);
$parcel$export(module.exports, "setCodeBlockFoldState", () => $619e230c2e411c8b$export$84bbe896418e05aa);
$parcel$export(module.exports, "transferCodeBlockWrappedValue", () => $619e230c2e411c8b$export$8de8069131d61656);
$parcel$export(module.exports, "updateCodeBlockWrappedStateNodeKeys", () => $619e230c2e411c8b$export$de41d58f29620282);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $9RSBE = parcelRequire("9RSBE");

var $3DNV7 = parcelRequire("3DNV7");

var $5N1Y4 = parcelRequire("5N1Y4");

var $4zjoa = parcelRequire("4zjoa");

var $4ClnP = parcelRequire("4ClnP");
const $619e230c2e411c8b$export$dea78458f6234074 = false;
const $619e230c2e411c8b$export$15e74cb2b99d4f44 = new WeakMap();
const $619e230c2e411c8b$export$f86d342c9776cad6 = (attrs)=>{
    const localId = (attrs === null || attrs === void 0 ? void 0 : attrs.localId) ?? ((0, $5N1Y4.expValEquals)('platform_editor_code_block_q4_lovability', 'isEnabled', true) ? (0, $9RSBE.uuid).generate() : undefined);
    const attrsWithLocalId = localId ? {
        ...attrs,
        localId: localId
    } : attrs;
    if (!(0, $4zjoa.expValEqualsNoExposure)('platform_editor_code_block_q4_lovability', 'isEnabled', true)) return attrsWithLocalId;
    // Only boolean wrap values represent caller intent. null/undefined means unset.
    if ((attrs === null || attrs === void 0 ? void 0 : attrs.wrap) === true || (attrs === null || attrs === void 0 ? void 0 : attrs.wrap) === false) return attrsWithLocalId;
    return {
        ...attrsWithLocalId,
        wrap: true
    };
};
const $619e230c2e411c8b$export$95a2b1adfd5a9190 = (slice, schema)=>{
    if (!(0, $5N1Y4.expValEquals)('platform_editor_code_block_q4_lovability', 'isEnabled', true)) return slice;
    return (0, $4ClnP.mapSlice)(slice, (node)=>{
        if (node.type !== schema.nodes.codeBlock || node.attrs.wrap === true) return node;
        // Markdown conversion uses MarkdownParser token mappings and creates code block nodes
        // with the schema-default wrap:false. Since Markdown has no wrap syntax, treat that
        // default as missing user intent and change it to wrap:true.
        return node.type.create($619e230c2e411c8b$export$f86d342c9776cad6(node.attrs), node.content, node.marks);
    });
};
const $619e230c2e411c8b$var$isReplaceStep = (step)=>step instanceof (0, $3DNV7.ReplaceStep) || step instanceof (0, $3DNV7.ReplaceAroundStep);
const $619e230c2e411c8b$var$isNodeShellReplaceStep = (step)=>step instanceof (0, $3DNV7.ReplaceAroundStep) && // Node shell updates preserve all inner content and only replace the outer node boundary.
    step.gapFrom === step.from + 1 && step.gapTo === step.to - 1;
const $619e230c2e411c8b$var$hasInsertedCodeBlockInStep = (step, codeBlockType, filter)=>{
    let hasInsertedCodeBlock = false;
    step.slice.content.descendants((node)=>{
        if (node.type === codeBlockType && (!filter || filter(node))) {
            hasInsertedCodeBlock = true;
            return false;
        }
        return !hasInsertedCodeBlock;
    });
    return hasInsertedCodeBlock;
};
const $619e230c2e411c8b$var$collectMappedInsertedRanges = (tr, stepIndex)=>{
    const ranges = [];
    const stepMap = tr.mapping.maps[stepIndex];
    const remainingMaps = tr.mapping.slice(stepIndex + 1);
    stepMap.forEach((_oldStart, _oldEnd, newStart, newEnd)=>{
        if (newStart === newEnd) return;
        const finalFrom = remainingMaps.map(newStart, 1);
        const finalTo = remainingMaps.map(newEnd, -1);
        if (finalFrom < finalTo) ranges.push([
            finalFrom,
            finalTo
        ]);
    });
    return ranges;
};
const $619e230c2e411c8b$export$ee996fbdea8dfc30 = (tr, codeBlockType, options = {})=>{
    const insertedCodeBlocks = [];
    const seenPositions = new Set();
    tr.steps.forEach((step, stepIndex)=>{
        if (!$619e230c2e411c8b$var$isReplaceStep(step)) return;
        // Attribute/type updates can replace just the node shell while preserving content.
        // Those should not make an existing code block look newly inserted.
        if ($619e230c2e411c8b$var$isNodeShellReplaceStep(step)) return;
        const insertedCodeBlockByStep = $619e230c2e411c8b$var$hasInsertedCodeBlockInStep(step, codeBlockType, options.filter);
        if (!insertedCodeBlockByStep) return;
        $619e230c2e411c8b$var$collectMappedInsertedRanges(tr, stepIndex).forEach(([from, to])=>{
            tr.doc.nodesBetween(from, to, (node, pos)=>{
                if (pos >= from && node.type === codeBlockType && (!options.filter || options.filter(node)) && !seenPositions.has(pos)) {
                    seenPositions.add(pos);
                    insertedCodeBlocks.push({
                        node: node,
                        pos: pos
                    });
                    return false;
                }
                return true;
            });
        });
    });
    return insertedCodeBlocks;
};
const $619e230c2e411c8b$var$codeBlockFoldStates = new WeakMap();
const $619e230c2e411c8b$export$ca74aa614fc297de = (codeBlockNode)=>{
    if ((0, $4zjoa.expValEqualsNoExposure)('platform_editor_code_block_q4_lovability', 'isEnabled', true)) return Boolean(codeBlockNode.attrs.wrap);
    const currentNodeWordWrapState = $619e230c2e411c8b$export$15e74cb2b99d4f44.get(codeBlockNode);
    return currentNodeWordWrapState !== undefined ? currentNodeWordWrapState : $619e230c2e411c8b$export$dea78458f6234074;
};
const $619e230c2e411c8b$export$ae57f08acfae6877 = (codeBlockNode)=>{
    if (!(0, $4zjoa.expValEqualsNoExposure)('platform_editor_code_block_q4_lovability', 'isEnabled', true)) return false;
    return Boolean(codeBlockNode.attrs.hideLineNumbers);
};
const $619e230c2e411c8b$export$17fa4cce31080ba8 = (codeBlockNode)=>!$619e230c2e411c8b$export$ae57f08acfae6877(codeBlockNode);
const $619e230c2e411c8b$export$dd8d371c28bc93ab = (codeBlockNode)=>{
    const currentNodeFoldState = $619e230c2e411c8b$var$codeBlockFoldStates.get(codeBlockNode);
    return currentNodeFoldState || [];
};
const $619e230c2e411c8b$export$84bbe896418e05aa = (codeBlockNode, foldRanges)=>{
    $619e230c2e411c8b$var$codeBlockFoldStates.set(codeBlockNode, foldRanges);
};
const $619e230c2e411c8b$export$8de8069131d61656 = (oldCodeBlockNode, newCodeBlockNode)=>{
    $619e230c2e411c8b$var$transferCodeBlockFoldValue(oldCodeBlockNode, newCodeBlockNode);
    // Don't overwrite the value for the new node if it already exists.
    // This can happen when a drag&drop is swapping nodes.
    if ($619e230c2e411c8b$export$15e74cb2b99d4f44.has(newCodeBlockNode)) return;
    const previousValue = $619e230c2e411c8b$export$ca74aa614fc297de(oldCodeBlockNode);
    $619e230c2e411c8b$export$15e74cb2b99d4f44.set(newCodeBlockNode, previousValue);
    $619e230c2e411c8b$export$15e74cb2b99d4f44.delete(oldCodeBlockNode);
};
/**
 * Swap the old node key with the new node key in the fold states WeakMap.
 */ const $619e230c2e411c8b$var$transferCodeBlockFoldValue = (oldCodeBlockNode, newCodeBlockNode)=>{
    // Don't overwrite the value for the new node if it already exists.
    // This can happen when a drag&drop is swapping nodes.
    if ($619e230c2e411c8b$var$codeBlockFoldStates.has(newCodeBlockNode)) return;
    const previousValue = $619e230c2e411c8b$export$dd8d371c28bc93ab(oldCodeBlockNode);
    $619e230c2e411c8b$var$codeBlockFoldStates.set(newCodeBlockNode, previousValue);
    $619e230c2e411c8b$var$codeBlockFoldStates.delete(oldCodeBlockNode);
};
const $619e230c2e411c8b$export$de41d58f29620282 = (newCodeBlockNodes, oldState)=>{
    newCodeBlockNodes.forEach((newCodeBlockNode)=>{
        $619e230c2e411c8b$var$updateCodeBlockFoldStateNodeKeys(newCodeBlockNode, oldState);
        // Don't overwrite the value for the new node if it already exists.
        // This can happen when a drag&drop is swapping nodes.
        if ($619e230c2e411c8b$export$15e74cb2b99d4f44.has(newCodeBlockNode.node)) return;
        // Do not go out of range on the oldState doc. Happens on initial load.
        if (oldState.doc.content.size <= newCodeBlockNode.pos) return;
        const oldCodeBlockNode = oldState.doc.nodeAt(newCodeBlockNode.pos);
        if (!oldCodeBlockNode || oldCodeBlockNode.type !== oldState.schema.nodes.codeBlock) return;
        const previousValue = $619e230c2e411c8b$export$ca74aa614fc297de(oldCodeBlockNode);
        $619e230c2e411c8b$export$15e74cb2b99d4f44.set(newCodeBlockNode.node, previousValue);
    });
};
/**
 * As the code block node is used as the fold state key, there is instances where the node will be destroyed & recreated and is no longer a valid key.
 * In these instances, we must get the value from that old node and set it to the value of the new node.
 * This function takes all the given nodes, finds their old nodes from the old state and updates these old node keys.
 */ const $619e230c2e411c8b$var$updateCodeBlockFoldStateNodeKeys = (newCodeBlockNode, oldState)=>{
    // Don't overwrite the value for the new node if it already exists.
    // This can happen when a drag&drop is swapping nodes.
    if ($619e230c2e411c8b$var$codeBlockFoldStates.has(newCodeBlockNode.node)) return;
    // Do not go out of range on the oldState doc. Happens on initial load.
    if (oldState.doc.content.size <= newCodeBlockNode.pos) return;
    const oldCodeBlockNode = oldState.doc.nodeAt(newCodeBlockNode.pos);
    if (!oldCodeBlockNode || oldCodeBlockNode.type !== oldState.schema.nodes.codeBlock) return;
    const previousValue = $619e230c2e411c8b$export$dd8d371c28bc93ab(oldCodeBlockNode);
    $619e230c2e411c8b$var$codeBlockFoldStates.set(newCodeBlockNode.node, previousValue);
};

});

parcelRegister("kBP5h", function(module, exports) {
$parcel$export(module.exports, "BreakoutCssClassName", () => $45120dbcaf3857d4$export$c21a3b023fccd534);
const $45120dbcaf3857d4$export$c21a3b023fccd534 = {
    BREAKOUT_MARK: 'fabric-editor-breakout-mark',
    BREAKOUT_MARK_DOM: 'fabric-editor-breakout-mark-dom'
};

});

parcelRegister("kjMQA", function(module, exports) {
$parcel$export(module.exports, "VANILLA_TOOLTIP_DEFAULT_CLASS", () => $1f2aa83b329c5c47$export$3c00f79c82af3714);
$parcel$export(module.exports, "VanillaTooltip", () => $1f2aa83b329c5c47$export$47a232ed95817c75);

var $eDeOg = parcelRequire("eDeOg");

var $bAB3U = parcelRequire("bAB3U");

var $3y2s4 = parcelRequire("3y2s4");

var $gdUUy = parcelRequire("gdUUy");

var $6DIg6 = parcelRequire("6DIg6");

var $j2Y9J = parcelRequire("j2Y9J");
const $1f2aa83b329c5c47$var$startingOffset = {
    name: 'offset',
    options: {
        offset: [
            0,
            4
        ]
    }
};
const $1f2aa83b329c5c47$var$endingOffset = {
    name: 'offset',
    options: {
        offset: [
            0,
            8
        ]
    }
};
const $1f2aa83b329c5c47$export$3c00f79c82af3714 = 'ak-editor-vanilla-tooltip-default';
/**
 * Namespaced to keep generated ids from colliding with ids the host page owns, since they share
 * the document's single id space.
 */ const $1f2aa83b329c5c47$var$TOOLTIP_ID_PREFIX = 'ak-editor-internal-tooltip';
/**
 * Generates a tooltip id for `aria-describedby`/`popovertarget`.
 *
 * `crypto.randomUUID` covers effectively all production traffic
 * The counter is only a fallback for environments without it (for example a non-secure context)
 * and is scoped to this closure rather than module state.
 */ const $1f2aa83b329c5c47$var$generateTooltipId = (()=>{
    let count = 0;
    return ()=>typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function' ? `${$1f2aa83b329c5c47$var$TOOLTIP_ID_PREFIX}-${crypto.randomUUID()}` : `${$1f2aa83b329c5c47$var$TOOLTIP_ID_PREFIX}-${count += 1}`;
})();
function $1f2aa83b329c5c47$var$getCreatePopper() {
    if ((0, $gdUUy.fg)('platform-dst-popper-consolidation')) return 0, $6DIg6.createPopper;
    return 0, $eDeOg.createPopper;
}
class $1f2aa83b329c5c47$export$47a232ed95817c75 {
    constructor(/**
   * The element that the tooltip describes and Popper uses as its anchor.
   *
   * Prefer a `<button>`: it is focusable and announced by assistive tech for free, and is the
   * only element the browser honours `popovertarget` on. Anything else works, since this
   * class calls `showPopover()`/`hidePopover()` itself, but then make sure it:
   *
   * - **Renders its children**, as the tooltip is appended to the trigger — unless
   *   `hoistContainer` is given. `<img>`, `<input>` and `<br>` accept the append without error
   *   but never render it, leaving the tooltip silently at zero size.
   * - **Is reachable**, if keyboard and screen reader users need the tooltip — usually
   *   `tabindex="0"` plus a role and accessible name, since `focus`/`blur` are bound to the
   *   trigger and `aria-describedby` is set on it.
   */ trigger, content, /**
   * Id associated to the tooltip - must be unique within the document.
   *
   * Pass `undefined` to have one generated, which is preferred: callers otherwise have to
   * solve uniqueness themselves, and every consumer had solved it differently.
   */ id, /**
   * Class Name – used for styling.
   */ className, timeout = 300, /**
   * Optional inline styles to apply directly to the tooltip element.
   * Useful when the tooltip is rendered in the browser's top layer (via Popover API),
   * where ancestor CSS selectors cannot reach it.
   */ styles, /**
   * Called when the tooltip has become visible, after `timeout` has elapsed.
   * Not called when the pointer leaves before the tooltip is shown, matching
   * the `onShow` semantics of "@atlaskit/tooltip".
   */ onShow, /**
   * Where the tooltip sits relative to the trigger.
   *
   * Defaults to `'top'`, matching the default `position` of "@atlaskit/tooltip". Use
   * `'bottom'` to match its `position="mouse"`, which places the tooltip below the cursor.
   */ placement = 'top', /**
   * Where to append the tooltip, instead of inside the trigger.
   *
   * Pass a container when anything between the trigger and the viewport is transformed. The
   * browser resolves a top-layer popover's position against the viewport, while Popper — which
   * reads `offsetParent`, and gets `null` for anything in the top layer — falls back to the
   * nearest ancestor with a `transform`. Inside a wide image that ancestor is `.rich-media-item`,
   * whose `translateX(-50%)` threw the tooltip off screen (EDITOR-8971). Appended to a container
   * with no transform above it, the two measure from the same origin.
   *
   * Opt-in per caller: the tooltip leaves the trigger's subtree, so anything styling it through
   * an ancestor stops matching — including `VANILLA_TOOLTIP_DEFAULT_CLASS`, whose rule is scoped
   * under `.ProseMirror`. Pass `styles` for the look instead.
   */ hoistContainer){
        this.trigger = trigger;
        this.timeout = timeout;
        this.onShow = onShow;
        this.placement = placement;
        this.hoistContainer = hoistContainer;
        this.listeners = [];
        this.shouldHidePopover = false;
        this.isDisplayed = false;
        // Created in the trigger's own document rather than the global one, so nothing depends on
        // the parent realm when the editor renders inside an iframe. Gated alongside the Escape
        // listener's window so the whole iframe fix moves as a single unit.
        const ownerDocument = (0, $3y2s4.isExperimentEnabled)('platform_editor_use_vanilla_components') ? trigger.ownerDocument : document;
        const tooltip = ownerDocument.createElement('span');
        tooltip.role = 'tooltip';
        tooltip.popover = 'hint';
        tooltip.className = className;
        tooltip.id = id ?? $1f2aa83b329c5c47$var$generateTooltipId();
        tooltip.textContent = content;
        // A tooltip is never a hit target. Set before the caller's styles so it can be overridden.
        if ((0, $3y2s4.isExperimentEnabled)('platform_editor_use_vanilla_components')) tooltip.style.pointerEvents = 'none';
        if (styles) Object.assign(tooltip.style, styles);
        this.tooltip = tooltip;
        (hoistContainer ?? this.trigger).appendChild(tooltip);
        this.trigger.setAttribute('popovertarget', tooltip.id);
        this.trigger.setAttribute('aria-describedby', tooltip.id);
        const showEvents = [
            'mouseenter',
            'focus'
        ];
        const hideEvents = [
            'mouseleave',
            'blur'
        ];
        showEvents.forEach((event)=>{
            this.listeners.push((0, $bAB3U.bind)(this.trigger, {
                type: event,
                listener: ()=>this.show()
            }));
        });
        hideEvents.forEach((event)=>{
            this.listeners.push((0, $bAB3U.bind)(this.trigger, {
                type: event,
                listener: ()=>this.hide()
            }));
        });
        // Bound for this tooltip's whole lifetime, even while it is off screen. The experiment
        // moves this to `show()` so nothing is retained at rest.
        if (!(0, $3y2s4.isExperimentEnabled)('platform_editor_use_vanilla_components')) this.listeners.push((0, $bAB3U.bind)(window, {
            type: 'keydown',
            listener: (e)=>{
                if (e.key === 'Escape') this.hide(true);
            }
        }));
        // Resets `isDisplayed` when the browser closes the popover without going through `hide()`
        // (e.g. light-dismissal). Prevents the guard in `show()` from becoming stale.
        if ((0, $3y2s4.isExperimentEnabled)('platform_editor_use_vanilla_components') && (0, $gdUUy.fg)('platform_editor_use_vanilla_components_patch_2')) this.listeners.push((0, $bAB3U.bind)(tooltip, {
            type: 'toggle',
            listener: (event)=>{
                if (event.newState === 'closed') {
                    this.isDisplayed = false;
                    // Cancel a pending show, which would otherwise mark a closed popover as
                    // displayed and announce a tooltip the user never saw.
                    //
                    // `shouldHidePopover` is set by `hide()` and cleared by `show()`, so it
                    // is false exactly when the pending timeout is a show. A pending hide
                    // must survive: it still has the positioning instance to release.
                    if (!this.shouldHidePopover && this.currentTimeoutId !== undefined) clearTimeout(this.currentTimeoutId);
                }
            }
        }));
        // Hide the tooltip if the hide transition has completed.
        //
        // Only reachable in the control arm: no consumer declares a transition on the tooltip, so
        // this never fires today, and the experiment closes the popover in `hide()` regardless.
        if (!(0, $3y2s4.isExperimentEnabled)('platform_editor_use_vanilla_components')) this.tooltip.ontransitionend = ()=>{
            if (this.shouldHidePopover) this.tooltip.hidePopover();
        };
    }
    /**
   * The tooltip element, for callers that own its accessibility semantics — a hoisted tooltip is no
   * longer reachable from the trigger.
   */ get element() {
        return this.tooltip;
    }
    /**
   * Closes the popover, tolerating it already being closed.
   *
   * A `hint` popover is light-dismissed by the browser whenever another `hint` or `auto` popover
   * opens, so the caller can never be sure this one is still showing.
   */ closePopover() {
        try {
            this.tooltip.hidePopover();
        } catch (error) {
            // `hidePopover()` raises `InvalidStateError` both when the popover is not showing
            // when the tooltip is disconnected or has lost its `popover` attribute.
            if (!this.tooltip.isConnected || !this.tooltip.hasAttribute('popover')) (0, $j2Y9J.logException)(error, {
                location: 'editor-common/vanilla-tooltip'
            });
        }
    }
    /**
   * Opens the popover, tolerating it already being open.
   *
   * A hover returning during a pending hide re-enters `show()` before `isDisplayed` is set, so
   * this runs against an already-open popover on that path.
   */ openPopover() {
        try {
            this.tooltip.showPopover();
        } catch (error) {
            // `showPopover()` raises `InvalidStateError` both when the tooltip is already in the
            // top layer and when it is disconnected or has lost its `popover` attribute.
            if (!this.tooltip.isConnected || !this.tooltip.hasAttribute('popover')) (0, $j2Y9J.logException)(error, {
                location: 'editor-common/vanilla-tooltip'
            });
        }
    }
    createPopperInstance() {
        this.popperInstance = $1f2aa83b329c5c47$var$getCreatePopper()(this.trigger, this.tooltip, {
            placement: this.placement,
            modifiers: [
                $1f2aa83b329c5c47$var$startingOffset
            ]
        });
    }
    destroy() {
        var _this$popperInstance;
        // Cancels any pending show/hide, which would otherwise run against detached DOM and
        // invoke `onShow` after the owner has gone away.
        clearTimeout(this.currentTimeoutId);
        // Destroying while visible must not leave the listener bound to a dead tooltip.
        this.unbindEscapeListener();
        (_this$popperInstance = this.popperInstance) === null || _this$popperInstance === void 0 || _this$popperInstance.destroy();
        this.listeners.forEach((listener)=>{
            listener();
        });
        // Undoes what the constructor added to the trigger, matching the React `@atlaskit/tooltip`
        // callers are moving off, whose unmount took its DOM with it. A hoisted tooltip is removed
        // either way: it sits outside the trigger, so nothing else takes it away with it.
        if ((0, $3y2s4.isExperimentEnabled)('platform_editor_use_vanilla_components') || this.hoistContainer) {
            // A popover removed while still showing is never light-dismissed, so the top layer
            // keeps treating it as open.
            this.closePopover();
            this.tooltip.remove();
            if (this.trigger.getAttribute('aria-describedby') === this.tooltip.id) this.trigger.removeAttribute('aria-describedby');
            if (this.trigger.getAttribute('popovertarget') === this.tooltip.id) this.trigger.removeAttribute('popovertarget');
        }
    }
    /**
   * Starts listening for Escape to dismiss this tooltip.
   *
   * A tooltip only ever needs one Escape listener, so this does nothing when one is already
   * bound.
   */ bindEscapeListener() {
        if (this.unbindEscape) return;
        this.unbindEscape = (0, $bAB3U.bind)(this.trigger.ownerDocument.defaultView ?? window, {
            type: 'keydown',
            listener: (e)=>{
                if (e.key === 'Escape') this.hide(true);
            }
        });
    }
    /**
   * Stops listening for Escape, so no listener is retained while this tooltip is off screen.
   *
   * Does nothing when no listener is bound.
   */ unbindEscapeListener() {
        var _this$unbindEscape;
        (_this$unbindEscape = this.unbindEscape) === null || _this$unbindEscape === void 0 || _this$unbindEscape.call(this);
        this.unbindEscape = undefined;
    }
    hide(immediate = false) {
        clearTimeout(this.currentTimeoutId);
        // Unbound synchronously so a repeated Escape does not re-enter this tooltip while the
        // hide is still pending.
        this.unbindEscapeListener();
        this.shouldHidePopover = true;
        // Disable the event listeners
        this.currentTimeoutId = setTimeout(()=>{
            if ((0, $3y2s4.isExperimentEnabled)('platform_editor_use_vanilla_components')) {
                var _this$popperInstance2;
                // Released rather than reconfigured. The instance was previously kept for the
                // trigger's whole lifetime, so every element the pointer passed over retained
                // one — and under `platform-dst-popper-consolidation` an instance owns a
                // detached React root, so that was a retained root per hovered trigger.
                //
                // Destroying is also the only way to release that root's capture-phase
                // `scroll`/`resize` listeners on the consolidated path, where the
                // `eventListeners: false` reconfiguration in the control arm is accepted but
                // does nothing.
                (_this$popperInstance2 = this.popperInstance) === null || _this$popperInstance2 === void 0 || _this$popperInstance2.destroy();
                this.popperInstance = undefined;
                this.tooltip.style.opacity = '0';
                this.isDisplayed = false;
                // Closed here rather than from `ontransitionend`. No consumer declares a
                // transition on the tooltip, so that event never fires and the popover would
                // otherwise stay open in the top layer for good.
                this.closePopover();
                // Paired with the `visibility` that `show()` sets, so a popover left open by
                // a failed close cannot intercept pointer events over the content.
                this.tooltip.style.visibility = 'hidden';
            } else {
                var _this$popperInstance3;
                (_this$popperInstance3 = this.popperInstance) === null || _this$popperInstance3 === void 0 || _this$popperInstance3.setOptions((options)=>({
                        ...options,
                        modifiers: [
                            $1f2aa83b329c5c47$var$startingOffset,
                            {
                                name: 'eventListeners',
                                enabled: false
                            }
                        ]
                    }));
                this.tooltip.style.opacity = '0';
                this.isDisplayed = false;
                // If transition animations are disabled immediately hide the popover
                if (this.tooltip.style.transition === 'none') this.tooltip.hidePopover();
            }
        }, immediate ? 0 : this.timeout);
    }
    show() {
        // Ahead of the `isDisplayed` guard, unlike the equivalent below: `hide()` takes effect
        // synchronously but leaves the tooltip on screen until its timeout, so a pointer
        // returning in that window finds `isDisplayed` still true and returns early. Cancelling
        // first keeps the tooltip up and stops it being left undismissable with a hide pending.
        if ((0, $3y2s4.isExperimentEnabled)('platform_editor_use_vanilla_components')) {
            this.bindEscapeListener();
            clearTimeout(this.currentTimeoutId);
            this.shouldHidePopover = false;
        }
        if (this.isDisplayed) return;
        // Control only: the experiment cancels above, ahead of the guard. Kept gated rather than
        // left unconditional — despite being a no-op once the block above has run — so that
        // experiment cleanup can delete it outright instead of having to reason about it.
        if (!(0, $3y2s4.isExperimentEnabled)('platform_editor_use_vanilla_components')) {
            clearTimeout(this.currentTimeoutId);
            this.shouldHidePopover = false;
        }
        // Make the tooltip visible - but hide until
        this.tooltip.style.visibility = 'hidden';
        if ((0, $3y2s4.isExperimentEnabled)('platform_editor_use_vanilla_components')) this.openPopover();
        else this.tooltip.showPopover();
        // Update its position
        if (!this.popperInstance) this.createPopperInstance();
        else this.popperInstance.update();
        // Enable the event listeners
        this.currentTimeoutId = setTimeout(()=>{
            var _this$popperInstance4, _this$onShow;
            this.tooltip.style.opacity = '1';
            this.tooltip.style.visibility = 'visible';
            (_this$popperInstance4 = this.popperInstance) === null || _this$popperInstance4 === void 0 || _this$popperInstance4.setOptions((options)=>({
                    ...options,
                    modifiers: [
                        $1f2aa83b329c5c47$var$endingOffset,
                        {
                            name: 'eventListeners',
                            enabled: true
                        }
                    ]
                }));
            this.isDisplayed = true;
            (_this$onShow = this.onShow) === null || _this$onShow === void 0 || _this$onShow.call(this);
        }, this.timeout);
    }
}

});
parcelRegister("6DIg6", function(module, exports) {
$parcel$export(module.exports, "createPopper", () => $d9359724e4df5ead$export$8f7491d57c8f97a9);
/**
 * UNSAFE compatibility entry point. `createPopper` for non-React, imperative
 * consumers moving direct `@popperjs/core` dependency ownership onto
 * `@atlaskit/popper`.
 *
 * Do not use this for new code. New overlays should build on
 * `@atlaskit/top-layer` directly: `Popover` + `useAnchoredPopover`. top-layer
 * has no imperative positioning API and is not getting one — see
 * `top-layer/notes/migrations/popper-migration.md` -> "Decision: popper brings
 * its own React".
 *
 * Behind the `platform-dst-top-layer` feature gate this returns a top-layer
 * backed instance: the element is positioned with CSS Anchor Positioning and
 * lifted into the browser top layer. Flag-off it is the raw Popper.js v2
 * engine. See `createPopperTopLayer` for the option-handling tiers.
 */ 
var $eDeOg = parcelRequire("eDeOg");

var $gdUUy = parcelRequire("gdUUy");

var $6z8e5 = parcelRequire("6z8e5");
const $d9359724e4df5ead$export$8f7491d57c8f97a9 = (reference, popper, options)=>{
    if ((0, $gdUUy.fg)('platform-dst-top-layer')) return (0, $6z8e5.createPopperTopLayer)(reference, popper, options);
    return (0, $eDeOg.createPopper)(reference, popper, options);
};

});
parcelRegister("6z8e5", function(module, exports) {
$parcel$export(module.exports, "createPopperTopLayer", () => $8415e6f6b7305434$export$3f3476d827c0bd92);
/**
 * FF-on implementation of `@atlaskit/popper/unsafe-imperative`'s
 * `createPopper`.
 *
 * `@atlaskit/top-layer`'s positioning primitives are React hooks, and this
 * entry point is imperative. Rather than growing an imperative positioning API
 * on top-layer for a frozen escape hatch, this file brings its own React: it
 * owns a detached root rendering `PositioningBridge`, a component that renders
 * nothing and exists only to run top-layer's positioning hooks against the DOM
 * nodes the caller already owns.
 *
 * The upside is that the imperative path consumes exactly the same public
 * top-layer API as the React `<Popper>` adapter in `popper-top-layer.tsx`, so
 * the CSS Anchor Positioning path, the JS fallback, and virtual-anchor handling
 * are shared rather than reimplemented — and `@atlaskit/top-layer` gains no new
 * public API for it.
 *
 * **This is deliberately not a full-parity Popper.js implementation.** The
 * entry point is frozen with a single grandfathered caller (editor's
 * `VanillaTooltip`) and the ratchet blocks new ones, so the goal is reasonable,
 * well-documented behaviour for a niche surface rather than byte-for-byte
 * engine equivalence. See
 * `top-layer/notes/migrations/popper-migration.md` -> "Imperative
 * `createPopper` adapter".
 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $ltkSJ = parcelRequire("ltkSJ");

var $c9wRy = parcelRequire("c9wRy");

var $65Dj6 = parcelRequire("65Dj6");

var $7nmZk = parcelRequire("7nmZk");

var $8Ihum = parcelRequire("8Ihum");

var $4mi4Q = parcelRequire("4mi4Q");

var $4AqC0 = parcelRequire("4AqC0");

var $lloz0 = parcelRequire("lloz0");
/**
 * Popper.js defaults, applied when the caller omits them.
 * <https://popper.js.org/docs/v2/constructors/#options>
 */ const $8415e6f6b7305434$var$DEFAULT_PLACEMENT = 'bottom';
const $8415e6f6b7305434$var$DEFAULT_STRATEGY = 'absolute';
/**
 * Popper.js' `offset` modifier defaults to `[0, 0]` — no gap. This differs from
 * ADS `<Popper>` (`[0, 8]`) and from top-layer's own `space.100` default, so the
 * offset is always passed explicitly: a caller that asked for no offset keeps
 * getting none.
 */ const $8415e6f6b7305434$var$NO_OFFSET = [
    0,
    0
];
/**
 * Fills in Popper.js' option defaults so `state.options` is always complete,
 * matching what the real engine exposes.
 */ function $8415e6f6b7305434$var$resolveOptions(options) {
    return {
        placement: (options === null || options === void 0 ? void 0 : options.placement) ?? $8415e6f6b7305434$var$DEFAULT_PLACEMENT,
        modifiers: (options === null || options === void 0 ? void 0 : options.modifiers) ?? [],
        strategy: (options === null || options === void 0 ? void 0 : options.strategy) ?? $8415e6f6b7305434$var$DEFAULT_STRATEGY,
        onFirstUpdate: options === null || options === void 0 ? void 0 : options.onFirstUpdate
    };
}
/**
 * Reads the `offset` modifier's `[skidding, distance]` tuple.
 *
 * Popper.js merges duplicate modifier entries by name with later entries
 * winning, so the last `offset` entry is the one that counts. A disabled
 * modifier, or a function-valued `offset` (which Popper.js resolves per-update
 * against live rects and CSS Anchor Positioning has no equivalent for), falls
 * back to no offset.
 */ function $8415e6f6b7305434$var$getOffset(modifiers) {
    var _offsetModifier$optio;
    const offsetModifier = modifiers.filter((modifier)=>(modifier === null || modifier === void 0 ? void 0 : modifier.name) === 'offset').pop();
    if (!offsetModifier || offsetModifier.enabled === false) return $8415e6f6b7305434$var$NO_OFFSET;
    const offset = (_offsetModifier$optio = offsetModifier.options) === null || _offsetModifier$optio === void 0 ? void 0 : _offsetModifier$optio.offset;
    if (!Array.isArray(offset)) return $8415e6f6b7305434$var$NO_OFFSET;
    const [along, away] = offset;
    return [
        along ?? 0,
        away ?? 0
    ];
}
/**
 * Maps resolved Popper.js options onto top-layer's placement input.
 *
 * Not memoized: the bridge remounts on every option change, so a `useMemo` cache
 * could never be read, and `useAnchoredPopover` already re-derives a stable
 * placement from the primitive fields.
 */ function $8415e6f6b7305434$var$toTopLayerPlacement(options) {
    return (0, $65Dj6.fromLegacyPlacement)({
        legacy: (0, $lloz0.toLegacyPlacement)(options.placement),
        offset: $8415e6f6b7305434$var$getOffset(options.modifiers)
    });
}
/**
 * Neutralises the UA stylesheet's `[popover]` rules for an element this adapter
 * promoted, so promotion is a change of paint order and nothing else.
 *
 * The UA sheet gives every popover `border: solid`, `padding: 0.25em`,
 * `overflow: auto`, `width` / `height: fit-content`, `color: CanvasText` and
 * `background-color: Canvas`. `<Popover>` overrides these in its own Compiled
 * class, but the element here belongs to the caller, so inline styles are the
 * wrong tool: they would beat the caller's own stylesheet rather than only the
 * UA's. A zero-specificity `:where()` rule in the author origin is exactly the
 * right precedence — it always beats the UA sheet and always loses to any
 * caller selector.
 *
 * `inline-size` is deliberately left at the UA default, matching `<Popover>`
 * (which keeps it for anchor-width matching).
 */ const $8415e6f6b7305434$var$PROMOTED_ATTRIBUTE = 'data-ds--popper-promoted';
function $8415e6f6b7305434$var$ensurePromotedStyles(element) {
    // Injected into the element's own document rather than a module-cached one,
    // so a caller positioning inside an iframe still gets the reset.
    const document = element.ownerDocument;
    if (document.querySelector(`style[${$8415e6f6b7305434$var$PROMOTED_ATTRIBUTE}]`)) return;
    const style = document.createElement('style');
    style.setAttribute($8415e6f6b7305434$var$PROMOTED_ATTRIBUTE, 'true');
    style.textContent = `:where([${$8415e6f6b7305434$var$PROMOTED_ATTRIBUTE}]){border-style:none;padding:0;overflow:visible;block-size:auto;color:inherit;background-color:transparent;}`;
    document.head.appendChild(style);
}
/**
 * Lifts the caller's element into the browser top layer.
 *
 * Uses `popover="manual"` so the element gets top-layer promotion without light
 * dismiss and without joining the auto-dismiss stack - the caller keeps owning
 * visibility, which matches Popper.js' contract (and mirrors the
 * `<Popover mode="manual">` the React `<Popper>` FF-on path uses).
 *
 * Returns `undefined` when no promotion happened: the element is already a
 * popover / `<dialog>` (the caller owns the top layer already), or the browser
 * has no Popover API. The latter is unpositioned flag-on — but so is every
 * other `@atlaskit/top-layer` consumer, because the whole stack is built on the
 * Popover API. It is not a gap specific to this adapter.
 */ function $8415e6f6b7305434$var$promoteToTopLayer(element) {
    if (element.hasAttribute('popover') || element.tagName === 'DIALOG') return undefined;
    if (typeof element.showPopover !== 'function') return undefined;
    $8415e6f6b7305434$var$ensurePromotedStyles(element);
    element.setAttribute($8415e6f6b7305434$var$PROMOTED_ATTRIBUTE, 'true');
    element.setAttribute('popover', 'manual');
    try {
        element.showPopover();
    } catch  {
        // `showPopover()` throws `InvalidStateError` for a disconnected element.
        // Leave the element in normal flow rather than stranding it as a hidden,
        // never-shown popover.
        element.removeAttribute('popover');
        element.removeAttribute($8415e6f6b7305434$var$PROMOTED_ATTRIBUTE);
        return undefined;
    }
    return function undoPromotion() {
        try {
            element.hidePopover();
        } catch  {}
        element.removeAttribute('popover');
        element.removeAttribute($8415e6f6b7305434$var$PROMOTED_ATTRIBUTE);
    };
}
const $8415e6f6b7305434$var$EMPTY_RECT = {
    width: 0,
    height: 0,
    x: 0,
    y: 0
};
/**
 * `VirtualElement.getBoundingClientRect()` is typed as `ClientRect | DOMRect`,
 * and `ClientRect` has no `x` / `y` - so read the physical edges instead.
 */ function $8415e6f6b7305434$var$toRect(rect) {
    return {
        width: rect.width,
        height: rect.height,
        x: rect.left,
        y: rect.top
    };
}
/**
 * Renders nothing; it exists purely so top-layer's positioning hooks can run
 * against elements that live outside any React tree.
 *
 * `shouldPreserveInlineSize` on both bridges, because the positioned element is
 * the CALLER's: it was `position: absolute` under Popper.js, so its own
 * stylesheet `width` was its width, and the hook's inline
 * `inline-size: max-content` would override it.
 *
 * Anything that is not a real DOM element (a `VirtualElement`, an SVG element, an
 * element from another realm) cannot carry `anchor-name`, so its rect is reduced
 * to the geometrically-equivalent point for the requested placement.
 */ function $8415e6f6b7305434$var$PositioningBridge({ reference: reference, popover: popover, options: options }) {
    return reference instanceof HTMLElement ? /*#__PURE__*/ (0, $dc70d.jsx)($8415e6f6b7305434$var$ElementBridge, {
        anchor: reference,
        popover: popover,
        options: options
    }) : /*#__PURE__*/ (0, $dc70d.jsx)($8415e6f6b7305434$var$PointBridge, {
        reference: reference,
        popover: popover,
        options: options
    });
}
function $8415e6f6b7305434$var$ElementBridge({ anchor: anchor, popover: popover, options: options }) {
    const anchorRef = (0, $bSJIT.useRef)(anchor);
    const popoverRef = (0, $bSJIT.useRef)(popover);
    (0, $7nmZk.useAnchoredPopover)({
        anchorRef: anchorRef,
        popoverRef: popoverRef,
        placement: $8415e6f6b7305434$var$toTopLayerPlacement(options),
        isOpen: true,
        shouldPreserveInlineSize: true
    });
    return null;
}
function $8415e6f6b7305434$var$PointBridge({ reference: reference, popover: popover, options: options }) {
    const popoverRef = (0, $bSJIT.useRef)(popover);
    const placement = $8415e6f6b7305434$var$toTopLayerPlacement(options);
    (0, $8Ihum.useAnchoredPopoverAtPoint)({
        popoverRef: popoverRef,
        placement: placement,
        isOpen: true,
        shouldPreserveInlineSize: true,
        getPoint: ()=>(0, $4AqC0.rectPointForPlacement)({
                rect: reference.getBoundingClientRect(),
                placement: placement,
                isRtl: (0, $4mi4Q.isPageRtl)()
            })
    });
    return null;
}
function $8415e6f6b7305434$export$3f3476d827c0bd92(reference, popper, options) {
    var _getDocument;
    let currentOptions = $8415e6f6b7305434$var$resolveOptions(options);
    let isDestroyed = false;
    // Used as the bridge's `key` and bumped by every call that re-positions, so
    // the bridge remounts and its hook re-runs from scratch. See "Instance
    // surface" above for why that is load-bearing on both bridges.
    let generation = 0;
    // Promote BEFORE the first render so the popover is already open when the
    // hook's layout effect runs - `useAnchoredPopover`'s JS fallback detects an
    // already-open popover and measures immediately instead of waiting for a
    // `toggle` event it would otherwise have missed.
    const undoPromotion = $8415e6f6b7305434$var$promoteToTopLayer(popper);
    // React host for the bridge. The bridge renders `null`, so this container
    // stays empty and is deliberately never appended to the document: React only
    // needs an element to own, and effects run either way.
    const container = (_getDocument = (0, $c9wRy.getDocument)()) === null || _getDocument === void 0 ? void 0 : _getDocument.createElement('div');
    const root = container ? (0, $ltkSJ.createRoot)(container) : null;
    const state = {
        elements: {
            reference: reference,
            popper: popper
        },
        options: currentOptions,
        placement: currentOptions.placement,
        strategy: currentOptions.strategy,
        orderedModifiers: [],
        rects: {
            reference: $8415e6f6b7305434$var$EMPTY_RECT,
            popper: $8415e6f6b7305434$var$EMPTY_RECT
        },
        scrollParents: {
            reference: [],
            popper: []
        },
        styles: {},
        attributes: {},
        modifiersData: {},
        reset: false
    };
    function render() {
        if (!root || isDestroyed) return;
        // Deliberately NOT wrapped in `flushSync`. React commits this on its own
        // schedule, so positioning lands on the next tick rather than before this
        // call returns. Popper.js is the same (its first update is async), and
        // forcing a sync flush is not an option: a React consumer calling
        // `createPopper` from an effect would trip
        // "flushSync was called from inside a lifecycle method", which React
        // downgrades to an async commit anyway — so the flush buys a console
        // error and nothing else.
        root.render(/*#__PURE__*/ (0, $dc70d.jsx)($8415e6f6b7305434$var$PositioningBridge, {
            reference: reference,
            popover: popper,
            options: currentOptions
        }, generation));
        // Measured at call time, so `rects.popper` reflects the position before
        // this render commits. Popper.js' `state` is likewise only as fresh as the
        // last completed update.
        state.rects = {
            reference: $8415e6f6b7305434$var$toRect(reference.getBoundingClientRect()),
            popper: $8415e6f6b7305434$var$toRect(popper.getBoundingClientRect())
        };
    }
    render();
    // Popper.js resolves `onFirstUpdate` asynchronously, after the first update
    // completes. Match that timing so callers that mutate state in the callback
    // do not do so during their own `createPopper()` call.
    const { onFirstUpdate: onFirstUpdate } = currentOptions;
    if (onFirstUpdate) Promise.resolve().then(()=>{
        if (!isDestroyed) onFirstUpdate(state);
    });
    return {
        state: state,
        update () {
            generation += 1;
            render();
            return Promise.resolve(state);
        },
        forceUpdate () {
            generation += 1;
            render();
        },
        setOptions (setOptionsAction) {
            if (isDestroyed) return Promise.resolve(state);
            const next = typeof setOptionsAction === 'function' ? setOptionsAction(currentOptions) : setOptionsAction;
            currentOptions = $8415e6f6b7305434$var$resolveOptions({
                ...currentOptions,
                ...next
            });
            state.options = currentOptions;
            state.placement = currentOptions.placement;
            state.strategy = currentOptions.strategy;
            generation += 1;
            render();
            return Promise.resolve(state);
        },
        destroy () {
            if (isDestroyed) return;
            // Set synchronously so a `render()` already in flight is dropped and
            // `onFirstUpdate` never fires after `destroy()`.
            isDestroyed = true;
            // Deferred to a microtask, NOT run inline. `root.unmount()` is
            // synchronous, and React logs "Attempted to synchronously unmount a
            // root while React was already rendering" when it is called during a
            // commit — which is exactly where a React caller destroys, since
            // effect cleanups run in the commit phase. React also downgrades the
            // unmount to an async commit there, so inline teardown would restore
            // the hooks' styles *after* `undoPromotion()` had already run,
            // inverting the order below. A microtask leaves the commit and gets
            // both: no warning, and teardown in the right order.
            queueMicrotask(()=>{
                // Unmounting runs the hooks' cleanups, which restore every inline
                // style they wrote and remove any synthetic anchor.
                root === null || root === void 0 || root.unmount();
                undoPromotion === null || undoPromotion === void 0 || undoPromotion();
            });
        }
    };
}

});



parcelRegister("5N9nM", function(module, exports) {
$parcel$export(module.exports, "NodeViewContentHole", () => $a4cca79e8e06787a$export$27292f9d0a2a0aef);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $7lseo = parcelRequire("7lseo");
const $a4cca79e8e06787a$export$27292f9d0a2a0aef = /*#__PURE__*/ (0, $bSJIT.forwardRef)((props, ref)=>/*#__PURE__*/ (0, $dc70d.jsx)("div", {
        ...props,
        ref: ref,
        "data-ssr-content-dom-ref": (0, $7lseo.isSSR)() ? '' : undefined
    }));

});

parcelRegister("btLjd", function(module, exports) {
$parcel$export(module.exports, "SelectionBasedNodeView", () => $36c5304af7f0ce6a$export$9f83dc95adfbb293);

var $0Xboy = parcelRequire("0Xboy");
class $36c5304af7f0ce6a$export$9f83dc95adfbb293 extends (0, $0Xboy.default) {
    constructor(node, view, getPos, portalProviderAPI, eventDispatcher, reactComponentProps, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    reactComponent, viewShouldUpdate, shouldRenderImmediatelyInPortal){
        super(node, view, getPos, portalProviderAPI, eventDispatcher, reactComponentProps, reactComponent, viewShouldUpdate, shouldRenderImmediatelyInPortal), this.isSelectedNode = false, this.isNodeInsideSelection = (from, to, pos, posEnd)=>{
            ({ pos: pos, posEnd: posEnd } = this.getPositionsWithDefault(pos, posEnd));
            if (typeof pos !== 'number' || typeof posEnd !== 'number') return false;
            return from <= pos && to >= posEnd;
        }, this.isSelectionInsideNode = (from, to, pos, posEnd)=>{
            ({ pos: pos, posEnd: posEnd } = this.getPositionsWithDefault(pos, posEnd));
            if (typeof pos !== 'number' || typeof posEnd !== 'number') return false;
            return pos < from && to < posEnd;
        }, this.insideSelection = ()=>{
            const { selection: { from: from, to: to } } = this.view.state;
            return this.isSelectedNode || this.isSelectionInsideNode(from, to);
        }, this.nodeInsideSelection = ()=>{
            const { selection: selection } = this.view.state;
            const { from: from, to: to } = selection;
            return this.isSelectedNode || this.isNodeInsideSelection(from, to);
        };
        this.updatePos();
    }
    /**
   * Update current node's start and end positions.
   *
   * Prefer `this.pos` rather than getPos(), because calling getPos is
   * expensive, unless you know you're definitely going to render.
   */ updatePos() {
        if (typeof this.getPos === 'boolean') return;
        const pos = this.getPos();
        if (typeof pos === 'number') {
            this.pos = pos;
            this.posEnd = pos + this.node.nodeSize;
        }
    }
    getPositionsWithDefault(pos, posEnd) {
        return {
            pos: typeof pos !== 'number' ? this.pos : pos,
            posEnd: typeof posEnd !== 'number' ? this.posEnd : posEnd
        };
    }
    selectNode() {
        this.isSelectedNode = true;
        this.update(this.node, this.decorations);
    }
    deselectNode() {
        this.isSelectedNode = false;
        this.update(this.node, this.decorations);
    }
}

});
parcelRegister("0Xboy", function(module, exports) {
$parcel$export(module.exports, "default", () => $1cf766ea3052870f$export$2e2bcd8739ae039);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $g6Qq4 = parcelRequire("g6Qq4");

var $7lseo = parcelRequire("7lseo");

var $eXGEf = parcelRequire("eXGEf");

var $iUiGU = parcelRequire("iUiGU");

var $lrWkt = parcelRequire("lrWkt");

var $3UrUG = parcelRequire("3UrUG");


var $5N9nM = parcelRequire("5N9nM");
class $1cf766ea3052870f$export$2e2bcd8739ae039 {
    constructor(node, view, getPos, portalProviderAPI, eventDispatcher, reactComponentProps, // Spreading props to pass through dynamic component props
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    reactComponent, viewShouldUpdate, shouldRenderImmediatelyInPortal){
        /**
   * Tracks whether a React portal is currently mounted into `domRef`. A node view whose
   * `render()` returns `null` does not mount one at all.
   */ this.hasMountedPortal = false;
        this.decorations = [];
        this.handleRef = (node)=>this._handleRef(node);
        this.dispatchAnalyticsEvent = (payload)=>{
            if (this.eventDispatcher) {
                const dispatch = (0, $eXGEf.createDispatch)(this.eventDispatcher);
                dispatch((0, $lrWkt.analyticsEventKey), {
                    payload: payload
                });
            }
        };
        this.node = node;
        this.view = view;
        this.getPos = getPos;
        this.portalProviderAPI = portalProviderAPI;
        this.reactComponentProps = reactComponentProps || {};
        this.reactComponent = reactComponent;
        this._viewShouldUpdate = viewShouldUpdate;
        this.eventDispatcher = eventDispatcher;
        this.key = (0, $3UrUG.generateUniqueNodeKey)();
        this.shouldRenderImmediatelyInPortal = shouldRenderImmediatelyInPortal || false;
    }
    /**
   * This method exists to move initialization logic out of the constructor,
   * so object can be initialized properly before calling render first time.
   *
   * Example:
   * Instance properties get added to an object only after super call in
   * constructor, which leads to some methods being undefined during the
   * first render.
   */ init(shouldSkipInitRender = false) {
        this.domRef = this.createDomRef();
        this.setDomAttrs(this.node, this.domRef);
        const { dom: contentDOMWrapper, contentDOM: contentDOM } = this.getContentDOM() || {
            dom: undefined,
            contentDOM: undefined
        };
        if (this.domRef && contentDOMWrapper) {
            this.domRef.appendChild(contentDOMWrapper);
            this.contentDOM = contentDOM ? contentDOM : contentDOMWrapper;
            this.contentDOMWrapper = contentDOMWrapper || contentDOM;
        }
        // @see ED-3790
        // something gets messed up during mutation processing inside of a
        // nodeView if DOM structure has nested plain "div"s, it doesn't see the
        // difference between them and it kills the nodeView
        this.domRef.classList.add(`${this.node.type.name}View-content-wrap`);
        if (!shouldSkipInitRender) {
            this.renderReactComponent(()=>this.render(this.reactComponentProps, this.handleRef));
            // During SSR, renderToStaticMarkup + container.innerHTML (in portal) clobbers the
            // contentDOMWrapper that was appended above. The React ref callback
            // (forwardRef) never fires in renderToStaticMarkup, so contentDOM is
            // left detached. Re-attach it by finding the marked SSR ref target.
            if ((0, $7lseo.isSSR)() && this.domRef) {
                const refTarget = this.domRef.querySelector('[data-ssr-content-dom-ref]');
                if (refTarget) {
                    this.handleRef(refTarget);
                    // The marker is only needed to locate the re-attach target during
                    // this SSR pass. Remove it so it doesn't leak into the streamed
                    // HTML (it has no meaning on the client).
                    refTarget.removeAttribute('data-ssr-content-dom-ref');
                }
            }
        }
        return this;
    }
    // Spreading props to pass through dynamic component props
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    renderReactComponent(component) {
        if (!this.domRef || !component) return;
        // React 18 does event delegation per portal container: `createPortal` calls
        // `listenToAllSupportedEvents(container)`, which registers a bubble *and* a capture
        // listener for every supported event type — roughly 130 real `addEventListener` calls
        // on the container element. Those listeners are never removed (React has no
        // un-listen path), so mounting a portal for a node view that renders nothing is pure
        // overhead that scales with the number of such nodes in the document.
        //
        // `PortalProviderAPI.render` already invokes the thunk eagerly (see
        // `getPortalProviderAPI`), so evaluating the element here does not change *when*
        // `render()` runs — the pre-evaluated element is handed to the same render call below.
        // If a node view starts out empty and later renders something, `update()` calls back into
        // this method and the portal is mounted at that point.
        const element = component();
        if (element === null) {
            if (this.hasMountedPortal) {
                this.portalProviderAPI.remove(this.key);
                this.hasMountedPortal = false;
            }
            return;
        }
        this.hasMountedPortal = true;
        const renderComponent = ()=>element;
        const componentWithErrorBoundary = ()=>{
            var _this$node;
            return /*#__PURE__*/ (0, $dc70d.jsx)((0, $iUiGU.ErrorBoundary), {
                component: (0, $g6Qq4.ACTION_SUBJECT).REACT_NODE_VIEW,
                componentId: (this === null || this === void 0 || (_this$node = this.node) === null || _this$node === void 0 || (_this$node = _this$node.type) === null || _this$node === void 0 ? void 0 : _this$node.name) ?? (0, $g6Qq4.ACTION_SUBJECT_ID).UNKNOWN_NODE,
                dispatchAnalyticsEvent: this.dispatchAnalyticsEvent,
                children: renderComponent()
            });
        };
        this.portalProviderAPI.render(componentWithErrorBoundary, // Spreading props to pass through dynamic component props
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.domRef, this.key, undefined, this.shouldRenderImmediatelyInPortal);
    }
    createDomRef() {
        if (!this.node.isInline) return document.createElement('div');
        const htmlElement = document.createElement('span');
        return htmlElement;
    }
    getContentDOM() {
        return undefined;
    }
    _handleRef(node) {
        const contentDOM = this.contentDOMWrapper || this.contentDOM;
        // Spreading props to pass through dynamic component props
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let oldIgnoreMutation;
        let selectionBookmark;
        let mutationsIgnored = false;
        // move the contentDOM node inside the inner reference after rendering
        if (node && contentDOM && !node.contains(contentDOM)) {
            // @ts-ignore - ignoreMutation may not be declared
            oldIgnoreMutation = this.ignoreMutation; // store ref to previous ignoreMutation
            // ignore all mutations caused by ProseMirror's MutationObserver triggering
            // after DOM change, except selection changes
            // @ts-ignore ProseMirror adds selection type to MutationRecord
            this.ignoreMutation = (m)=>{
                const isSelectionMutation = m.type === 'selection';
                if (!isSelectionMutation) mutationsIgnored = true;
                return !isSelectionMutation;
            };
            // capture document selection state before React DOM changes triggers ProseMirror selection change transaction
            if (this.view.state.selection.visible) selectionBookmark = this.view.state.selection.getBookmark();
            node.appendChild(contentDOM);
            // After the next frame:
            requestAnimationFrame(()=>{
                // Restore the original mutation handler
                // @ts-ignore - this may not have been declared by implementing class
                this.ignoreMutation = oldIgnoreMutation;
                // Restore the selection only if:
                // - We have a selection bookmark
                // - Mutations were ignored during the table move
                // - The bookmarked selection is different from the current selection.
                if (selectionBookmark && mutationsIgnored) {
                    const resolvedSelection = selectionBookmark.resolve(this.view.state.tr.doc);
                    // Don't set the selection if it's the same as the current selection.
                    if (!resolvedSelection.eq(this.view.state.selection)) {
                        const tr = this.view.state.tr.setSelection(resolvedSelection);
                        tr.setMeta('source', 'ReactNodeView:_handleRef:selection-resync');
                        this.view.dispatch(tr);
                    }
                }
            });
        }
    }
    // Spreading props to pass through dynamic component props
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    render(props, forwardRef) {
        return this.reactComponent ? /*#__PURE__*/ (0, $dc70d.jsx)(this.reactComponent, {
            view: this.view,
            getPos: this.getPos,
            node: this.node,
            forwardRef: forwardRef,
            ...props
        }) : null;
    }
    update(node, decorations, _innerDecorations, validUpdate = ()=>true) {
        // @see https://github.com/ProseMirror/prosemirror/issues/648
        const isValidUpdate = this.node.type === node.type && validUpdate(this.node, node);
        this.decorations = decorations;
        if (!isValidUpdate) return false;
        if (this.domRef && !this.node.sameMarkup(node)) this.setDomAttrs(node, this.domRef);
        // View should not process a re-render if this is false.
        // We dont want to destroy the view, so we return true.
        // TODO: ED-13910 - Fix viewShouldUpdate readonly decoration array
        if (!this.viewShouldUpdate(node, decorations)) {
            this.node = node;
            return true;
        }
        this.node = node;
        this.renderReactComponent(()=>this.render(this.reactComponentProps, this.handleRef));
        return true;
    }
    viewShouldUpdate(nextNode, _decorations) {
        if (this._viewShouldUpdate) return this._viewShouldUpdate(nextNode);
        return true;
    }
    /**
   * Copies the attributes from a ProseMirror Node to a DOM node.
   * @param node The Prosemirror Node from which to source the attributes
   */ setDomAttrs(node, element) {
        Object.keys(node.attrs || {}).forEach((attr)=>{
            element.setAttribute(attr, node.attrs[attr]);
        });
    }
    get dom() {
        // Only return reference if domRef is defined
        if (this.domRef === undefined) //raise an error
        throw new Error('domRef is not defined or may have been destroyed');
        // Spreading props to pass through dynamic component props
        return this.domRef;
    }
    destroy() {
        if (!this.domRef) return;
        this.portalProviderAPI.remove(this.key);
        this.domRef = undefined;
        this.contentDOM = undefined;
    }
    static fromComponent(// Spreading props to pass through dynamic component props
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    component, portalProviderAPI, eventDispatcher, props, viewShouldUpdate) {
        return (node, view, getPos)=>new $1cf766ea3052870f$export$2e2bcd8739ae039(node, view, getPos, portalProviderAPI, eventDispatcher, props, component, viewShouldUpdate).init();
    }
}

});
parcelRegister("iUiGU", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundary", () => $1d75aa129ae2c3b4$export$e926676385687eaf);

var $bSJIT = parcelRequire("bSJIT");

var $g6Qq4 = parcelRequire("g6Qq4");

var $j2Y9J = parcelRequire("j2Y9J");
class $1d75aa129ae2c3b4$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Component {
    hasFallback() {
        return typeof this.props.fallbackComponent !== 'undefined';
    }
    shouldRecover() {
        return this.hasFallback() && this.state.errorCaptured;
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.dispatchAnalyticsEvent) this.props.dispatchAnalyticsEvent({
            action: (0, $g6Qq4.ACTION).EDITOR_CRASHED,
            actionSubject: this.props.component,
            actionSubjectId: this.props.componentId,
            eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL,
            attributes: {
                error: error,
                errorInfo: errorInfo,
                errorRethrown: !this.hasFallback()
            }
        });
        (0, $j2Y9J.logException)(error, {
            location: 'editor-common'
        });
        if (this.hasFallback()) this.setState({
            errorCaptured: true
        });
    }
    render() {
        if (this.shouldRecover()) return this.props.fallbackComponent;
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.state = {
            errorCaptured: false
        };
    }
}

});

parcelRegister("3UrUG", function(module, exports) {
$parcel$export(module.exports, "generateUniqueNodeKey", () => $a1daea07eb1bec8d$export$4a323a0542a1e4d1);
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $7RHfd = parcelRequire("7RHfd");
const $a1daea07eb1bec8d$export$4a323a0542a1e4d1 = ()=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    return (0, $7RHfd.default)();
};

});



parcelRegister("7kMXC", function(module, exports) {
$parcel$export(module.exports, "cardPlugin", () => $43d21bccd9b8b016$export$2a6748328f902e16);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $5BUNL = parcelRequire("5BUNL");

var $278lv = parcelRequire("278lv");

var $8XENo = parcelRequire("8XENo");

var $a2Ugg = parcelRequire("a2Ugg");

var $6yEAN = parcelRequire("6yEAN");

var $1zOmw = parcelRequire("1zOmw");

var $3y2s4 = parcelRequire("3y2s4");

var $gdUUy = parcelRequire("gdUUy");
parcelRequire("ixBwV");
var $kZ1UZ = parcelRequire("kZ1UZ");

var $5TMXh = parcelRequire("5TMXh");

var $iUYTC = parcelRequire("iUYTC");

var $bNyMY = parcelRequire("bNyMY");

var $k5X6V = parcelRequire("k5X6V");

var $a76m2 = parcelRequire("a76m2");

var $f6kwz = parcelRequire("f6kwz");

var $3Qw5l = parcelRequire("3Qw5l");

var $1fMby = parcelRequire("1fMby");

var $cKhMH = parcelRequire("cKhMH");

var $emowl = parcelRequire("emowl");

var $7yaCs = parcelRequire("7yaCs");

var $jPC2c = parcelRequire("jPC2c");

var $lVWRr = parcelRequire("lVWRr");

var $3VgrS = parcelRequire("3VgrS");

var $9eoOg = parcelRequire("9eoOg");

var $aD2Bo = parcelRequire("aD2Bo");

var $4wBHs = parcelRequire("4wBHs");

var $cFebM = parcelRequire("cFebM");
const $43d21bccd9b8b016$var$PasteMenuSmartCardClientSync = ({ clientRef: clientRef })=>{
    var _smartCardContext$con2;
    const smartCardContext = (0, $bSJIT.useContext)((0, $1zOmw.SmartCardContext));
    (0, $bSJIT.useEffect)(()=>{
        var _smartCardContext$con;
        clientRef.current = smartCardContext === null || smartCardContext === void 0 || (_smartCardContext$con = smartCardContext.connections) === null || _smartCardContext$con === void 0 ? void 0 : _smartCardContext$con.client;
    }, [
        clientRef,
        smartCardContext === null || smartCardContext === void 0 || (_smartCardContext$con2 = smartCardContext.connections) === null || _smartCardContext$con2 === void 0 ? void 0 : _smartCardContext$con2.client
    ]);
    return null;
};
const $43d21bccd9b8b016$export$2a6748328f902e16 = ({ config: options = {}, api: api })=>{
    var _api$base;
    let previousCardProvider;
    const cardPluginEvents = (0, $emowl.createEventsQueue)();
    const isRegisteredSlashCommandEnabled = (0, $3y2s4.isExperimentEnabled)('platform_editor_slash_command');
    let instanceEmbedCardTransformers = options.embedCardTransformers;
    let editorViewForPasteMenu;
    const pasteMenuSmartCardClientRef = {
        current: undefined
    };
    const pasteMenuVariant = (0, $kZ1UZ.expValNoExposure)('platform_editor_paste_actions_menu_v2', 'variant', 'control');
    const shouldRegisterPasteDisplayAsMenu = options.enablePasteDisplayAsMenu && [
        'hasSpellingAndGrammar',
        'hasAltAiActions'
    ].includes(pasteMenuVariant);
    if (shouldRegisterPasteDisplayAsMenu) {
        var _api$uiControlRegistr;
        api === null || api === void 0 || (_api$uiControlRegistr = api.uiControlRegistry) === null || _api$uiControlRegistr === void 0 || _api$uiControlRegistr.actions.register((0, $9eoOg.getPasteDisplayAsMenuComponents)({
            api: api,
            allowBlockCards: options.onlyInlineCards ? false : options.allowBlockCards ?? true,
            allowEmbeds: options.onlyInlineCards ? false : options.allowEmbeds,
            getEditorView: ()=>editorViewForPasteMenu,
            smartCardClientRef: pasteMenuSmartCardClientRef
        }));
    }
    if (isRegisteredSlashCommandEnabled) {
        var _api$uiControlRegistr2;
        api === null || api === void 0 || (_api$uiControlRegistr2 = api.uiControlRegistry) === null || _api$uiControlRegistr2 === void 0 || _api$uiControlRegistr2.actions.register((0, $4wBHs.getCardQuickInsertComponents)({
            api: api,
            options: options
        }));
    }
    api === null || api === void 0 || (_api$base = api.base) === null || _api$base === void 0 || _api$base.actions.registerMarks(({ tr: tr, node: node, pos: pos })=>{
        const { doc: doc } = tr;
        const { schema: schema } = doc.type;
        const { inlineCard: inlineCardNodeType } = schema.nodes;
        if (node.type === inlineCardNodeType) {
            const newText = node.attrs.url;
            const currentPos = tr.mapping.map(pos);
            tr.replaceWith(currentPos, currentPos + node.nodeSize, schema.text(newText, node.marks));
        }
    });
    return {
        name: 'card',
        getSharedState (editorState) {
            if (!editorState) return null;
            return (0, $1fMby.pluginKey).getState(editorState) || null;
        },
        nodes () {
            const nodes = [
                {
                    name: 'inlineCard',
                    node: (0, $bNyMY.inlineCardSpecWithFixedToDOM)()
                }
            ];
            // `onlyInlineCards` is a hard gate: when set, blockCard/embedCard
            // stay out of the schema regardless of allowBlockCards/allowEmbeds.
            if (options.onlyInlineCards) return nodes;
            nodes.push({
                name: 'blockCard',
                node: (0, $5TMXh.blockCardSpecWithFixedToDOM)()
            });
            if (options.allowEmbeds) nodes.push({
                name: 'embedCard',
                node: (0, $iUYTC.embedCardSpecWithFixedToDOM)()
            });
            return nodes;
        },
        pmPlugins () {
            // onlyInlineCards forces block/embed off regardless of caller-passed flags,
            // keeping the schema gate (in nodes()) and the runtime gate in sync.
            const allowBlockCards = options.onlyInlineCards ? false : options.allowBlockCards ?? true;
            const allowEmbeds = options.onlyInlineCards ? false : options.allowEmbeds;
            const allowResizing = options.allowResizing ?? true;
            const useAlternativePreloader = options.useAlternativePreloader ?? true;
            const allowWrapping = options.allowWrapping ?? true;
            const allowAlignment = options.allowAlignment ?? true;
            const allowDatasource = options.allowDatasource ?? false;
            const showUpgradeDiscoverability = options.showUpgradeDiscoverability ?? true;
            const plugins = [
                {
                    name: 'card',
                    plugin: (0, $3Qw5l.createPlugin)({
                        ...options,
                        allowBlockCards: allowBlockCards,
                        allowEmbeds: allowEmbeds,
                        allowResizing: allowResizing,
                        useAlternativePreloader: useAlternativePreloader,
                        allowWrapping: allowWrapping,
                        allowAlignment: allowAlignment,
                        allowDatasource: allowDatasource,
                        cardPluginEvents: cardPluginEvents,
                        embedCardTransformers: instanceEmbedCardTransformers,
                        showUpgradeDiscoverability: showUpgradeDiscoverability
                    }, api)
                }
            ];
            plugins.push({
                name: 'cardKeymap',
                plugin: ({ featureFlags: featureFlags })=>{
                    return (0, $f6kwz.cardKeymap)(featureFlags);
                }
            });
            return plugins;
        },
        contentComponent ({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement, popupsBoundariesElement: popupsBoundariesElement }) {
            var _options$experimental;
            if (!editorView) return null;
            editorViewForPasteMenu = editorView;
            const breakoutEnabled = options.editorAppearance === 'full-page';
            const isPreAuthModalOptedOut = ((_options$experimental = options.experimentalConfigurationOptions) === null || _options$experimental === void 0 ? void 0 : _options$experimental.platform_sl_3p_preauth_value_modal_killswitch) === false;
            const isPreAuthModalKillswitchEnabled = (0, $gdUUy.fg)('platform_sl_3p_preauth_value_modal_killswitch');
            const shouldRenderPreAuthValuePropositionModal = !isPreAuthModalOptedOut && isPreAuthModalKillswitchEnabled;
            return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $dc70d.Fragment), {
                children: [
                    shouldRenderPreAuthValuePropositionModal ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $aD2Bo.PreAuthValuePropositionModalListener), {
                        api: api,
                        cardPluginEvents: cardPluginEvents
                    }) : null,
                    shouldRegisterPasteDisplayAsMenu && /*#__PURE__*/ (0, $dc70d.jsx)($43d21bccd9b8b016$var$PasteMenuSmartCardClientSync, {
                        clientRef: pasteMenuSmartCardClientRef
                    }),
                    /*#__PURE__*/ (0, $dc70d.jsx)((0, $lVWRr.EditorSmartCardEvents), {
                        editorView: editorView
                    }),
                    /*#__PURE__*/ (0, $dc70d.jsx)((0, $jPC2c.EditorLinkingPlatformAnalytics), {
                        cardPluginEvents: cardPluginEvents,
                        editorView: editorView
                    }),
                    breakoutEnabled && /*#__PURE__*/ (0, $dc70d.jsx)((0, $3VgrS.default), {
                        api: api,
                        editorView: editorView,
                        mountPoint: popupsMountPoint,
                        scrollableElement: popupsScrollableElement,
                        boundariesElement: popupsBoundariesElement
                    }),
                    /*#__PURE__*/ (0, $dc70d.jsx)((0, $7yaCs.default), {
                        api: api,
                        editorView: editorView
                    })
                ]
            });
        },
        commands: {
            queueCardsFromRange: (from, to, source, analyticsAction, normalizeLinkText, sourceEvent, appearance)=>({ tr: tr })=>(0, $a76m2.queueCardsFromRange)(// Synthesise the minimal EditorState shape the impl actually reads.
                    {
                        schema: tr.doc.type.schema,
                        selection: tr.selection
                    }, tr, from, to, source, analyticsAction, normalizeLinkText, sourceEvent, appearance)
        },
        actions: {
            setProvider: async (providerPromise)=>{
                const provider = await providerPromise;
                // Prevent someone trying to set the exact same provider twice for performance reasons
                if (previousCardProvider === provider || (options === null || options === void 0 ? void 0 : options.provider) === providerPromise) return false;
                previousCardProvider = provider;
                return (api === null || api === void 0 ? void 0 : api.core.actions.execute(({ tr: tr })=>(0, $k5X6V.setProvider)(provider)(tr))) ?? false;
            },
            hideLinkToolbar: $k5X6V.hideLinkToolbar,
            queueCardsFromChangedTr: $a76m2.queueCardsFromChangedTr,
            queueCardsFromRange: $a76m2.queueCardsFromRange,
            registerEmbedCardTransformer: (transformers)=>{
                instanceEmbedCardTransformers = transformers;
            },
            resolveShortLinkUrl: async (url)=>{
                if (!options.provider) return undefined;
                try {
                    const provider = await options.provider;
                    // EditorCardProvider holds a CardClient instance internally. We access it
                    // directly to call fetchData, which gives us the raw ORS JSON-LD response
                    // including the canonical url field — something provider.resolve() does not
                    // surface. This is intentionally a structural cast rather than a typed
                    // dependency on EditorCardProvider's private API.
                    const clientHolder = provider;
                    const client = clientHolder.cardClient;
                    if (!client) return undefined;
                    const response = await client.fetchData(url);
                    // ORS returns a JsonLd.Response whose data union includes BaseData,
                    // BaseCollectionData, and BaseCollectionPage. We only care about the
                    // `url` field which is present on BaseData (Primitives.Object). Cast
                    // to a minimal shape rather than accessing through the full union type.
                    const data = response === null || response === void 0 ? void 0 : response.data;
                    if (!data) return undefined;
                    const urlField = data.url;
                    // Property<string | Link> can be a string, a Link object, or an array.
                    // Short-link responses always return a plain string URL.
                    if (typeof urlField === 'string' && urlField !== url) return urlField;
                    // Fallback: Link object shape with href or @id
                    if (urlField && typeof urlField === 'object' && !Array.isArray(urlField)) {
                        const linkObj = urlField;
                        const id = linkObj['@id'] ?? linkObj['href'];
                        if (typeof id === 'string' && id !== url) return id;
                    }
                } catch  {
                // Swallow errors — callers handle undefined
                }
                return undefined;
            },
            getStartingToolbarItems: (0, $cFebM.getStartingToolbarItems)(options, api),
            getEndingToolbarItems: (0, $cFebM.getEndingToolbarItems)(options, api)
        },
        pluginsOptions: {
            floatingToolbar: (0, $cFebM.floatingToolbar)(options, options.lpLinkPicker ?? false, options.linkPicker, api, options.disableFloatingToolbar),
            ...isRegisteredSlashCommandEnabled ? {} : {
                quickInsert: ({ formatMessage: formatMessage })=>{
                    const quickInsertArray = [];
                    if (!options.allowDatasource) return quickInsertArray;
                    quickInsertArray.push({
                        id: 'datasource',
                        title: formatMessage((0, $gdUUy.fg)('confluence-issue-terminology-refresh') ? (0, $278lv.messages).datasourceJiraIssueIssueTermRefresh : (0, $278lv.messages).datasourceJiraIssue),
                        description: formatMessage((0, $gdUUy.fg)('confluence-issue-terminology-refresh') ? (0, $278lv.messages).datasourceJiraIssueDescriptionIssueTermRefresh : (0, $278lv.messages).datasourceJiraIssueDescription),
                        isDisabledOffline: true,
                        categories: [
                            'external-content',
                            'development'
                        ],
                        keywords: [
                            'jira'
                        ],
                        featured: true,
                        priority: 500,
                        icon: ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $5BUNL.IconDatasourceJiraIssue), {}),
                        action (insert) {
                            const tr = insert(undefined);
                            (0, $k5X6V.showDatasourceModal)('jira')(tr);
                            return tr;
                        }
                    });
                    if ((0, $8XENo.canRenderDatasource)((0, $a2Ugg.ASSETS_LIST_OF_LINKS_DATASOURCE_ID))) quickInsertArray.push({
                        id: 'datasource',
                        title: formatMessage((0, $278lv.messages).datasourceAssetsObjectsGeneralAvailability),
                        description: formatMessage((0, $278lv.messages).datasourceAssetsObjectsDescription),
                        isDisabledOffline: true,
                        categories: [
                            'external-content',
                            'development'
                        ],
                        keywords: [
                            'assets'
                        ],
                        icon: ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $5BUNL.IconDatasourceAssetsObjects), {}),
                        action (insert) {
                            const tr = insert(undefined);
                            (0, $k5X6V.showDatasourceModal)('assets')(tr);
                            return tr;
                        }
                    });
                    if ((0, $cKhMH.isDatasourceConfigEditable)((0, $6yEAN.CONFLUENCE_SEARCH_DATASOURCE_ID))) quickInsertArray.push({
                        id: 'datasource',
                        title: formatMessage((0, $278lv.messages).datasourceConfluenceSearch),
                        description: formatMessage((0, $278lv.messages).datasourceConfluenceSearchDescription),
                        isDisabledOffline: true,
                        categories: [
                            'external-content',
                            'development'
                        ],
                        keywords: [
                            'confluence'
                        ],
                        featured: true,
                        icon: ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $5BUNL.IconDatasourceConfluenceSearch), {}),
                        action (insert) {
                            const tr = insert(undefined);
                            (0, $k5X6V.showDatasourceModal)('confluence-search')(tr);
                            return tr;
                        }
                    });
                    return quickInsertArray;
                }
            }
        }
    };
};

});
parcelRegister("5BUNL", function(module, exports) {
$parcel$export(module.exports, "IconAction", () => $3300279a3f4ed2cc$export$e40fe94b4cff8ec5);
$parcel$export(module.exports, "IconCode", () => $3300279a3f4ed2cc$export$e332a83b9159d69d);
$parcel$export(module.exports, "IconDate", () => $3300279a3f4ed2cc$export$39617668a6028b06);
$parcel$export(module.exports, "IconDecision", () => $3300279a3f4ed2cc$export$6eb71591d1461541);
$parcel$export(module.exports, "IconDivider", () => $3300279a3f4ed2cc$export$f2ab17920c9d243);
$parcel$export(module.exports, "IconEmoji", () => $3300279a3f4ed2cc$export$8bd591d4b34dcafa);
$parcel$export(module.exports, "IconImages", () => $3300279a3f4ed2cc$export$c17cf1164355efc2);
$parcel$export(module.exports, "IconLayout", () => $3300279a3f4ed2cc$export$fba0c846789a9d87);
$parcel$export(module.exports, "IconLink", () => $3300279a3f4ed2cc$export$23da1e9f164f7ea1);
$parcel$export(module.exports, "IconListNumber", () => $3300279a3f4ed2cc$export$32f6affcc5f19c17);
$parcel$export(module.exports, "IconList", () => $3300279a3f4ed2cc$export$527d32aa1785fdd4);
$parcel$export(module.exports, "IconMention", () => $3300279a3f4ed2cc$export$de1d1a07ff53cf53);
$parcel$export(module.exports, "IconPanelError", () => $3300279a3f4ed2cc$export$a1c6b14f5f0a0c20);
$parcel$export(module.exports, "IconPanelNote", () => $3300279a3f4ed2cc$export$4d90d09f9e3039e);
$parcel$export(module.exports, "IconPanelSuccess", () => $3300279a3f4ed2cc$export$cc5c1cc765c068a0);
$parcel$export(module.exports, "IconPanelWarning", () => $3300279a3f4ed2cc$export$e728578e48814100);
$parcel$export(module.exports, "IconPanel", () => $3300279a3f4ed2cc$export$18978208c8652af3);
$parcel$export(module.exports, "IconQuote", () => $3300279a3f4ed2cc$export$2478ed0e296e2752);
$parcel$export(module.exports, "IconStatus", () => $3300279a3f4ed2cc$export$4635bc8225f90ec6);
$parcel$export(module.exports, "IconOneColumnLayout", () => $3300279a3f4ed2cc$export$8f1e9e900568bfce);
$parcel$export(module.exports, "IconTwoColumnLayout", () => $3300279a3f4ed2cc$export$732a7fc4975ab5a4);
$parcel$export(module.exports, "IconThreeColumnLayout", () => $3300279a3f4ed2cc$export$fdfaf73f45072edb);
$parcel$export(module.exports, "IconFourColumnLayout", () => $3300279a3f4ed2cc$export$a1588f873a973762);
$parcel$export(module.exports, "IconFiveColumnLayout", () => $3300279a3f4ed2cc$export$ff1f32987b4c27d9);
$parcel$export(module.exports, "IconHeading", () => $3300279a3f4ed2cc$export$1a33a10ac24d7971);
$parcel$export(module.exports, "IconFeedback", () => $3300279a3f4ed2cc$export$e25449dcffb445e);
$parcel$export(module.exports, "IconExpand", () => $3300279a3f4ed2cc$export$209d03a445a7dc8e);
$parcel$export(module.exports, "IconDatasourceJiraIssue", () => $3300279a3f4ed2cc$export$c9b1dcefa7c9a7aa);
$parcel$export(module.exports, "IconDatasourceAssetsObjects", () => $3300279a3f4ed2cc$export$7d6f860161da0fa6);
$parcel$export(module.exports, "IconDatasourceConfluenceSearch", () => $3300279a3f4ed2cc$export$29a810fd0b8c3f03);
$parcel$export(module.exports, "IconSyncBlock", () => $3300279a3f4ed2cc$export$4dc65faf2ef9e446);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $deAR2 = parcelRequire("deAR2");

var $cJJTb = parcelRequire("cJJTb");

var $3y2s4 = parcelRequire("3y2s4");

const $3300279a3f4ed2cc$var$loadIconAction = ()=>(parcelRequire("8V5qZ")).then((module)=>module.default);

const $3300279a3f4ed2cc$var$IconActionLazy = (0, $cJJTb.lazy)(()=>(parcelRequire("8V5qZ")).then((module)=>module.default), {
    moduleId: "../platform/packages/editor/editor-common/src/quick-insert/assets/action.tsx"
});
$3300279a3f4ed2cc$var$IconActionLazy.displayName = 'lazy(IconAction)';
const $3300279a3f4ed2cc$var$IconActionLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($deAR2)))({
    loader: $3300279a3f4ed2cc$var$loadIconAction,
    loading: ()=>null
});
const $3300279a3f4ed2cc$export$e40fe94b4cff8ec5 = (props)=>(0, $3y2s4.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $cJJTb.LazySuspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $dc70d.jsx)($3300279a3f4ed2cc$var$IconActionLazy, {
            ...props
        })
    }) : // eslint-disable-next-line react/jsx-props-no-spreading -- pass icon props to the legacy component
    /*#__PURE__*/ (0, $dc70d.jsx)($3300279a3f4ed2cc$var$IconActionLoadable, {
        ...props
    });
$3300279a3f4ed2cc$export$e40fe94b4cff8ec5.preload = ()=>(0, $3y2s4.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? $3300279a3f4ed2cc$var$IconActionLazy.preload() : $3300279a3f4ed2cc$var$IconActionLoadable.preload();

const $3300279a3f4ed2cc$var$loadIconCode = ()=>(parcelRequire("11wHC")).then((module)=>module.default);

const $3300279a3f4ed2cc$var$IconCodeLazy = (0, $cJJTb.lazy)(()=>(parcelRequire("11wHC")).then((module)=>module.default), {
    moduleId: "../platform/packages/editor/editor-common/src/quick-insert/assets/code.tsx"
});
$3300279a3f4ed2cc$var$IconCodeLazy.displayName = 'lazy(IconCode)';
const $3300279a3f4ed2cc$var$IconCodeLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($deAR2)))({
    loader: $3300279a3f4ed2cc$var$loadIconCode,
    loading: ()=>null
});
const $3300279a3f4ed2cc$export$e332a83b9159d69d = (props)=>(0, $3y2s4.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $cJJTb.LazySuspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $dc70d.jsx)($3300279a3f4ed2cc$var$IconCodeLazy, {
            ...props
        })
    }) : // eslint-disable-next-line react/jsx-props-no-spreading -- pass icon props to the legacy component
    /*#__PURE__*/ (0, $dc70d.jsx)($3300279a3f4ed2cc$var$IconCodeLoadable, {
        ...props
    });
$3300279a3f4ed2cc$export$e332a83b9159d69d.preload = ()=>(0, $3y2s4.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? $3300279a3f4ed2cc$var$IconCodeLazy.preload() : $3300279a3f4ed2cc$var$IconCodeLoadable.preload();

const $3300279a3f4ed2cc$var$loadIconDate = ()=>(parcelRequire("kiDW3")).then((module)=>module.default);

const $3300279a3f4ed2cc$var$IconDateLazy = (0, $cJJTb.lazy)(()=>(parcelRequire("kiDW3")).then((module)=>module.default), {
    moduleId: "../platform/packages/editor/editor-common/src/quick-insert/assets/date.tsx"
});
$3300279a3f4ed2cc$var$IconDateLazy.displayName = 'lazy(IconDate)';
const $3300279a3f4ed2cc$var$IconDateLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($deAR2)))({
    loader: $3300279a3f4ed2cc$var$loadIconDate,
    loading: ()=>null
});
const $3300279a3f4ed2cc$export$39617668a6028b06 = (props)=>(0, $3y2s4.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $cJJTb.LazySuspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $dc70d.jsx)($3300279a3f4ed2cc$var$IconDateLazy, {
            ...props
        })
    }) : // eslint-disable-next-line react/jsx-props-no-spreading -- pass icon props to the legacy component
    /*#__PURE__*/ (0, $dc70d.jsx)($3300279a3f4ed2cc$var$IconDateLoadable, {
        ...props
    });
$3300279a3f4ed2cc$export$39617668a6028b06.preload = ()=>(0, $3y2s4.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? $3300279a3f4ed2cc$var$IconDateLazy.preload() : $3300279a3f4ed2cc$var$IconDateLoadable.preload();

const $3300279a3f4ed2cc$var$loadIconDecision = ()=>(parcelRequire("hIgzp")).then((module)=>module.default);

const $3300279a3f4ed2cc$var$IconDecisionLazy = (0, $cJJTb.lazy)(()=>(parcelRequire("hIgzp")).then((module)=>module.default), {
    moduleId: "../platform/packages/editor/editor-common/src/quick-insert/assets/decision.tsx"
});
$3300279a3f4ed2cc$var$IconDecisionLazy.displayName = 'lazy(IconDecision)';
const $3300279a3f4ed2cc$var$IconDecisionLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($deAR2)))({
    loader: $3300279a3f4ed2cc$var$loadIconDecision,
    loading: ()=>null
});
const $3300279a3f4ed2cc$export$6eb71591d1461541 = (props)=>(0, $3y2s4.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $cJJTb.LazySuspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $dc70d.jsx)($3300279a3f4ed2cc$var$IconDecisionLazy, {
            ...props
        })
    }) : // eslint-disable-next-line react/jsx-props-no-spreading -- pass icon props to the legacy component
    /*#__PURE__*/ (0, $dc70d.jsx)($3300279a3f4ed2cc$var$IconDecisionLoadable, {
        ...props
    });
$3300279a3f4ed2cc$export$6eb71591d1461541.preload = ()=>(0, $3y2s4.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? $3300279a3f4ed2cc$var$IconDecisionLazy.preload() : $3300279a3f4ed2cc$var$IconDecisionLoadable.preload();

const $3300279a3f4ed2cc$var$loadIconDivider = ()=>(parcelRequire("lR8yA")).then((module)=>module.default);

const $3300279a3f4ed2cc$var$IconDividerLazy = (0, $cJJTb.lazy)(()=>(parcelRequire("lR8yA")).then((module)=>module.default), {
    moduleId: "../platform/packages/editor/editor-common/src/quick-insert/assets/divider.tsx"
});
$3300279a3f4ed2cc$var$IconDividerLazy.displayName = 'lazy(IconDivider)';
const $3300279a3f4ed2cc$var$IconDividerLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($deAR2)))({
    loader: $3300279a3f4ed2cc$var$loadIconDivider,
    loading: ()=>null
});
const $3300279a3f4ed2cc$export$f2ab17920c9d243 = (props)=>(0, $3y2s4.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $cJJTb.LazySuspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $dc70d.jsx)($3300279a3f4ed2cc$var$IconDividerLazy, {
            ...props
        })
    }) : // eslint-disable-next-line react/jsx-props-no-spreading -- pass icon props to the legacy component
    /*#__PURE__*/ (0, $dc70d.jsx)($3300279a3f4ed2cc$var$IconDividerLoadable, {
        ...props
    });
$3300279a3f4ed2cc$export$f2ab17920c9d243.preload = ()=>(0, $3y2s4.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? $3300279a3f4ed2cc$var$IconDividerLazy.preload() : $3300279a3f4ed2cc$var$IconDividerLoadable.preload();

const $3300279a3f4ed2cc$var$loadIconEmoji = ()=>(parcelRequire("2RkWQ")).then((module)=>module.default);

const $3300279a3f4ed2cc$var$IconEmojiLazy = (0, $cJJTb.lazy)(()=>(parcelRequire("2RkWQ")).then((module)=>module.default), {
    moduleId: "../platform/packages/editor/editor-common/src/quick-insert/assets/emoji.tsx"
});
$3300279a3f4ed2cc$var$IconEmojiLazy.displayName = 'lazy(IconEmoji)';
const $3300279a3f4ed2cc$var$IconEmojiLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($deAR2)))({
    loader: $3300279a3f4ed2cc$var$loadIconEmoji,
    loading: ()=>null
});
const $3300279a3f4ed2cc$export$8bd591d4b34dcafa = (props)=>(0, $3y2s4.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $cJJTb.LazySuspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $dc70d.jsx)($3300279a3f4ed2cc$var$IconEmojiLazy, {
            ...props
        })
    }) : // eslint-disable-next-line react/jsx-props-no-spreading -- pass icon props to the legacy component
    /*#__PURE__*/ (0, $dc70d.jsx)($3300279a3f4ed2cc$var$IconEmojiLoadable, {
        ...props
    });
$3300279a3f4ed2cc$export$8bd591d4b34dcafa.preload = ()=>(0, $3y2s4.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? $3300279a3f4ed2cc$var$IconEmojiLazy.preload() : $3300279a3f4ed2cc$var$IconEmojiLoadable.preload();

const $3300279a3f4ed2cc$var$loadIconImages = ()=>(parcelRequire("5M3hu")).then((module)=>module.default);

const $3300279a3f4ed2cc$var$IconImagesLazy = (0, $cJJTb.lazy)(()=>(parcelRequire("5M3hu")).then((module)=>module.default), {
    moduleId: "../platform/packages/editor/editor-common/src/quick-insert/assets/images.tsx"
});
$3300279a3f4ed2cc$var$IconImagesLazy.displayName = 'lazy(IconImages)';
const $3300279a3f4ed2cc$var$IconImagesLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($deAR2)))({
    loader: $3300279a3f4ed2cc$var$loadIconImages,
    loading: ()=>null
});
const $3300279a3f4ed2cc$export$c17cf1164355efc2 = (props)=>(0, $3y2s4.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $cJJTb.LazySuspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $dc70d.jsx)($3300279a3f4ed2cc$var$IconImagesLazy, {
            ...props
        })
    }) : // eslint-disable-next-line react/jsx-props-no-spreading -- pass icon props to the legacy component
    /*#__PURE__*/ (0, $dc70d.jsx)($3300279a3f4ed2cc$var$IconImagesLoadable, {
        ...props
    });
$3300279a3f4ed2cc$export$c17cf1164355efc2.preload = ()=>(0, $3y2s4.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? $3300279a3f4ed2cc$var$IconImagesLazy.preload() : $3300279a3f4ed2cc$var$IconImagesLoadable.preload();

const $3300279a3f4ed2cc$var$loadIconLayout = ()=>(parcelRequire("7wZJL")).then((module)=>module.default);

const $3300279a3f4ed2cc$var$IconLayoutLazy = (0, $cJJTb.lazy)(()=>(parcelRequire("7wZJL")).then((module)=>module.default), {
    moduleId: "../platform/packages/editor/editor-common/src/quick-insert/assets/layout.tsx"
});
$3300279a3f4ed2cc$var$IconLayoutLazy.displayName = 'lazy(IconLayout)';
const $3300279a3f4ed2cc$var$IconLayoutLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($deAR2)))({
    loader: $3300279a3f4ed2cc$var$loadIconLayout,
    loading: ()=>null
});
const $3300279a3f4ed2cc$export$fba0c846789a9d87 = (props)=>(0, $3y2s4.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $cJJTb.LazySuspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $dc70d.jsx)($3300279a3f4ed2cc$var$IconLayoutLazy, {
            ...props
        })
    }) : // eslint-disable-next-line react/jsx-props-no-spreading -- pass icon props to the legacy component
    /*#__PURE__*/ (0, $dc70d.jsx)($3300279a3f4ed2cc$var$IconLayoutLoadable, {
        ...props
    });
$3300279a3f4ed2cc$export$fba0c846789a9d87.preload = ()=>(0, $3y2s4.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? $3300279a3f4ed2cc$var$IconLayoutLazy.preload() : $3300279a3f4ed2cc$var$IconLayoutLoadable.preload();

const $3300279a3f4ed2cc$var$loadIconLink = ()=>(parcelRequire("8oMxX")).then((module)=>module.default);

const $3300279a3f4ed2cc$var$IconLinkLazy = (0, $cJJTb.lazy)(()=>(parcelRequire("8oMxX")).then((module)=>module.default), {
    moduleId: "../platform/packages/editor/editor-common/src/quick-insert/assets/link.tsx"
});
$3300279a3f4ed2cc$var$IconLinkLazy.displayName = 'lazy(IconLink)';
const $3300279a3f4ed2cc$var$IconLinkLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($deAR2)))({
    loader: $3300279a3f4ed2cc$var$loadIconLink,
    loading: ()=>null
});
const $3300279a3f4ed2cc$export$23da1e9f164f7ea1 = (props)=>(0, $3y2s4.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $cJJTb.LazySuspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $dc70d.jsx)($3300279a3f4ed2cc$var$IconLinkLazy, {
            ...props
        })
    }) : // eslint-disable-next-line react/jsx-props-no-spreading -- pass icon props to the legacy component
    /*#__PURE__*/ (0, $dc70d.jsx)($3300279a3f4ed2cc$var$IconLinkLoadable, {
        ...props
    });
$3300279a3f4ed2cc$export$23da1e9f164f7ea1.preload = ()=>(0, $3y2s4.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? $3300279a3f4ed2cc$var$IconLinkLazy.preload() : $3300279a3f4ed2cc$var$IconLinkLoadable.preload();

const $3300279a3f4ed2cc$var$loadIconListNumber = ()=>(parcelRequire("3XIn9")).then((module)=>module.default);

const $3300279a3f4ed2cc$var$IconListNumberLazy = (0, $cJJTb.lazy)(()=>(parcelRequire("3XIn9")).then((module)=>module.default), {
    moduleId: "../platform/packages/editor/editor-common/src/quick-insert/assets/list-number.tsx"
});
$3300279a3f4ed2cc$var$IconListNumberLazy.displayName = 'lazy(IconListNumber)';
const $3300279a3f4ed2cc$var$IconListNumberLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($deAR2)))({
    loader: $3300279a3f4ed2cc$var$loadIconListNumber,
    loading: ()=>null
});
const $3300279a3f4ed2cc$export$32f6affcc5f19c17 = (props)=>(0, $3y2s4.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $cJJTb.LazySuspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $dc70d.jsx)($3300279a3f4ed2cc$var$IconListNumberLazy, {
            ...props
        })
    }) : // eslint-disable-next-line react/jsx-props-no-spreading -- pass icon props to the legacy component
    /*#__PURE__*/ (0, $dc70d.jsx)($3300279a3f4ed2cc$var$IconListNumberLoadable, {
        ...props
    });
$3300279a3f4ed2cc$export$32f6affcc5f19c17.preload = ()=>(0, $3y2s4.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? $3300279a3f4ed2cc$var$IconListNumberLazy.preload() : $3300279a3f4ed2cc$var$IconListNumberLoadable.preload();

const $3300279a3f4ed2cc$var$loadIconList = ()=>(parcelRequire("aA0Wf")).then((module)=>module.default);

const $3300279a3f4ed2cc$var$IconListLazy = (0, $cJJTb.lazy)(()=>(parcelRequire("aA0Wf")).then((module)=>module.default), {
    moduleId: "../platform/packages/editor/editor-common/src/quick-insert/assets/list.tsx"
});
$3300279a3f4ed2cc$var$IconListLazy.displayName = 'lazy(IconList)';
const $3300279a3f4ed2cc$var$IconListLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($deAR2)))({
    loader: $3300279a3f4ed2cc$var$loadIconList,
    loading: ()=>null
});
const $3300279a3f4ed2cc$export$527d32aa1785fdd4 = (props)=>(0, $3y2s4.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $cJJTb.LazySuspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $dc70d.jsx)($3300279a3f4ed2cc$var$IconListLazy, {
            ...props
        })
    }) : // eslint-disable-next-line react/jsx-props-no-spreading -- pass icon props to the legacy component
    /*#__PURE__*/ (0, $dc70d.jsx)($3300279a3f4ed2cc$var$IconListLoadable, {
        ...props
    });
$3300279a3f4ed2cc$export$527d32aa1785fdd4.preload = ()=>(0, $3y2s4.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? $3300279a3f4ed2cc$var$IconListLazy.preload() : $3300279a3f4ed2cc$var$IconListLoadable.preload();

const $3300279a3f4ed2cc$var$loadIconMention = ()=>(parcelRequire("haPY3")).then((module)=>module.default);

const $3300279a3f4ed2cc$var$IconMentionLazy = (0, $cJJTb.lazy)(()=>(parcelRequire("haPY3")).then((module)=>module.default), {
    moduleId: "../platform/packages/editor/editor-common/src/quick-insert/assets/mention.tsx"
});
$3300279a3f4ed2cc$var$IconMentionLazy.displayName = 'lazy(IconMention)';
const $3300279a3f4ed2cc$var$IconMentionLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($deAR2)))({
    loader: $3300279a3f4ed2cc$var$loadIconMention,
    loading: ()=>null
});
const $3300279a3f4ed2cc$export$de1d1a07ff53cf53 = (props)=>(0, $3y2s4.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $cJJTb.LazySuspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $dc70d.jsx)($3300279a3f4ed2cc$var$IconMentionLazy, {
            ...props
        })
    }) : // eslint-disable-next-line react/jsx-props-no-spreading -- pass icon props to the legacy component
    /*#__PURE__*/ (0, $dc70d.jsx)($3300279a3f4ed2cc$var$IconMentionLoadable, {
        ...props
    });
$3300279a3f4ed2cc$export$de1d1a07ff53cf53.preload = ()=>(0, $3y2s4.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? $3300279a3f4ed2cc$var$IconMentionLazy.preload() : $3300279a3f4ed2cc$var$IconMentionLoadable.preload();

const $3300279a3f4ed2cc$var$loadIconPanelError = ()=>(parcelRequire("8zvZd")).then((module)=>module.default);

const $3300279a3f4ed2cc$var$IconPanelErrorLazy = (0, $cJJTb.lazy)(()=>(parcelRequire("8zvZd")).then((module)=>module.default), {
    moduleId: "../platform/packages/editor/editor-common/src/quick-insert/assets/panel-error.tsx"
});
$3300279a3f4ed2cc$var$IconPanelErrorLazy.displayName = 'lazy(IconPanelError)';
const $3300279a3f4ed2cc$var$IconPanelErrorLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($deAR2)))({
    loader: $3300279a3f4ed2cc$var$loadIconPanelError,
    loading: ()=>null
});
const $3300279a3f4ed2cc$export$a1c6b14f5f0a0c20 = (props)=>(0, $3y2s4.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $cJJTb.LazySuspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $dc70d.jsx)($3300279a3f4ed2cc$var$IconPanelErrorLazy, {
            ...props
        })
    }) : // eslint-disable-next-line react/jsx-props-no-spreading -- pass icon props to the legacy component
    /*#__PURE__*/ (0, $dc70d.jsx)($3300279a3f4ed2cc$var$IconPanelErrorLoadable, {
        ...props
    });
$3300279a3f4ed2cc$export$a1c6b14f5f0a0c20.preload = ()=>(0, $3y2s4.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? $3300279a3f4ed2cc$var$IconPanelErrorLazy.preload() : $3300279a3f4ed2cc$var$IconPanelErrorLoadable.preload();

const $3300279a3f4ed2cc$var$loadIconPanelNote = ()=>(parcelRequire("4cNNn")).then((module)=>module.default);

const $3300279a3f4ed2cc$var$IconPanelNoteLazy = (0, $cJJTb.lazy)(()=>(parcelRequire("4cNNn")).then((module)=>module.default), {
    moduleId: "../platform/packages/editor/editor-common/src/quick-insert/assets/panel-note.tsx"
});
$3300279a3f4ed2cc$var$IconPanelNoteLazy.displayName = 'lazy(IconPanelNote)';
const $3300279a3f4ed2cc$var$IconPanelNoteLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($deAR2)))({
    loader: $3300279a3f4ed2cc$var$loadIconPanelNote,
    loading: ()=>null
});
const $3300279a3f4ed2cc$export$4d90d09f9e3039e = (props)=>(0, $3y2s4.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $cJJTb.LazySuspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $dc70d.jsx)($3300279a3f4ed2cc$var$IconPanelNoteLazy, {
            ...props
        })
    }) : // eslint-disable-next-line react/jsx-props-no-spreading -- pass icon props to the legacy component
    /*#__PURE__*/ (0, $dc70d.jsx)($3300279a3f4ed2cc$var$IconPanelNoteLoadable, {
        ...props
    });
$3300279a3f4ed2cc$export$4d90d09f9e3039e.preload = ()=>(0, $3y2s4.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? $3300279a3f4ed2cc$var$IconPanelNoteLazy.preload() : $3300279a3f4ed2cc$var$IconPanelNoteLoadable.preload();

const $3300279a3f4ed2cc$var$loadIconPanelSuccess = ()=>(parcelRequire("1UJ3I")).then((module)=>module.default);

const $3300279a3f4ed2cc$var$IconPanelSuccessLazy = (0, $cJJTb.lazy)(()=>(parcelRequire("1UJ3I")).then((module)=>module.default), {
    moduleId: "../platform/packages/editor/editor-common/src/quick-insert/assets/panel-success.tsx"
});
$3300279a3f4ed2cc$var$IconPanelSuccessLazy.displayName = 'lazy(IconPanelSuccess)';
const $3300279a3f4ed2cc$var$IconPanelSuccessLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($deAR2)))({
    loader: $3300279a3f4ed2cc$var$loadIconPanelSuccess,
    loading: ()=>null
});
const $3300279a3f4ed2cc$export$cc5c1cc765c068a0 = (props)=>(0, $3y2s4.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $cJJTb.LazySuspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $dc70d.jsx)($3300279a3f4ed2cc$var$IconPanelSuccessLazy, {
            ...props
        })
    }) : // eslint-disable-next-line react/jsx-props-no-spreading -- pass icon props to the legacy component
    /*#__PURE__*/ (0, $dc70d.jsx)($3300279a3f4ed2cc$var$IconPanelSuccessLoadable, {
        ...props
    });
$3300279a3f4ed2cc$export$cc5c1cc765c068a0.preload = ()=>(0, $3y2s4.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? $3300279a3f4ed2cc$var$IconPanelSuccessLazy.preload() : $3300279a3f4ed2cc$var$IconPanelSuccessLoadable.preload();

const $3300279a3f4ed2cc$var$loadIconPanelWarning = ()=>(parcelRequire("amBJK")).then((module)=>module.default);

const $3300279a3f4ed2cc$var$IconPanelWarningLazy = (0, $cJJTb.lazy)(()=>(parcelRequire("amBJK")).then((module)=>module.default), {
    moduleId: "../platform/packages/editor/editor-common/src/quick-insert/assets/panel-warning.tsx"
});
$3300279a3f4ed2cc$var$IconPanelWarningLazy.displayName = 'lazy(IconPanelWarning)';
const $3300279a3f4ed2cc$var$IconPanelWarningLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($deAR2)))({
    loader: $3300279a3f4ed2cc$var$loadIconPanelWarning,
    loading: ()=>null
});
const $3300279a3f4ed2cc$export$e728578e48814100 = (props)=>(0, $3y2s4.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $cJJTb.LazySuspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $dc70d.jsx)($3300279a3f4ed2cc$var$IconPanelWarningLazy, {
            ...props
        })
    }) : // eslint-disable-next-line react/jsx-props-no-spreading -- pass icon props to the legacy component
    /*#__PURE__*/ (0, $dc70d.jsx)($3300279a3f4ed2cc$var$IconPanelWarningLoadable, {
        ...props
    });
$3300279a3f4ed2cc$export$e728578e48814100.preload = ()=>(0, $3y2s4.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? $3300279a3f4ed2cc$var$IconPanelWarningLazy.preload() : $3300279a3f4ed2cc$var$IconPanelWarningLoadable.preload();

const $3300279a3f4ed2cc$var$loadIconPanel = ()=>(parcelRequire("iP11F")).then((module)=>module.default);

const $3300279a3f4ed2cc$var$IconPanelLazy = (0, $cJJTb.lazy)(()=>(parcelRequire("iP11F")).then((module)=>module.default), {
    moduleId: "../platform/packages/editor/editor-common/src/quick-insert/assets/panel.tsx"
});
$3300279a3f4ed2cc$var$IconPanelLazy.displayName = 'lazy(IconPanel)';
const $3300279a3f4ed2cc$var$IconPanelLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($deAR2)))({
    loader: $3300279a3f4ed2cc$var$loadIconPanel,
    loading: ()=>null
});
const $3300279a3f4ed2cc$export$18978208c8652af3 = (props)=>(0, $3y2s4.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $cJJTb.LazySuspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $dc70d.jsx)($3300279a3f4ed2cc$var$IconPanelLazy, {
            ...props
        })
    }) : // eslint-disable-next-line react/jsx-props-no-spreading -- pass icon props to the legacy component
    /*#__PURE__*/ (0, $dc70d.jsx)($3300279a3f4ed2cc$var$IconPanelLoadable, {
        ...props
    });
$3300279a3f4ed2cc$export$18978208c8652af3.preload = ()=>(0, $3y2s4.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? $3300279a3f4ed2cc$var$IconPanelLazy.preload() : $3300279a3f4ed2cc$var$IconPanelLoadable.preload();

const $3300279a3f4ed2cc$var$loadIconQuote = ()=>(parcelRequire("88x8c")).then((module)=>module.default);

const $3300279a3f4ed2cc$var$IconQuoteLazy = (0, $cJJTb.lazy)(()=>(parcelRequire("88x8c")).then((module)=>module.default), {
    moduleId: "../platform/packages/editor/editor-common/src/quick-insert/assets/quote.tsx"
});
$3300279a3f4ed2cc$var$IconQuoteLazy.displayName = 'lazy(IconQuote)';
const $3300279a3f4ed2cc$var$IconQuoteLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($deAR2)))({
    loader: $3300279a3f4ed2cc$var$loadIconQuote,
    loading: ()=>null
});
const $3300279a3f4ed2cc$export$2478ed0e296e2752 = (props)=>(0, $3y2s4.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $cJJTb.LazySuspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $dc70d.jsx)($3300279a3f4ed2cc$var$IconQuoteLazy, {
            ...props
        })
    }) : // eslint-disable-next-line react/jsx-props-no-spreading -- pass icon props to the legacy component
    /*#__PURE__*/ (0, $dc70d.jsx)($3300279a3f4ed2cc$var$IconQuoteLoadable, {
        ...props
    });
$3300279a3f4ed2cc$export$2478ed0e296e2752.preload = ()=>(0, $3y2s4.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? $3300279a3f4ed2cc$var$IconQuoteLazy.preload() : $3300279a3f4ed2cc$var$IconQuoteLoadable.preload();

const $3300279a3f4ed2cc$var$loadIconStatus = ()=>(parcelRequire("d0gK5")).then((module)=>module.default);

const $3300279a3f4ed2cc$var$IconStatusLazy = (0, $cJJTb.lazy)(()=>(parcelRequire("d0gK5")).then((module)=>module.default), {
    moduleId: "../platform/packages/editor/editor-common/src/quick-insert/assets/status.tsx"
});
$3300279a3f4ed2cc$var$IconStatusLazy.displayName = 'lazy(IconStatus)';
const $3300279a3f4ed2cc$var$IconStatusLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($deAR2)))({
    loader: $3300279a3f4ed2cc$var$loadIconStatus,
    loading: ()=>null
});
const $3300279a3f4ed2cc$export$4635bc8225f90ec6 = (props)=>(0, $3y2s4.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $cJJTb.LazySuspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $dc70d.jsx)($3300279a3f4ed2cc$var$IconStatusLazy, {
            ...props
        })
    }) : // eslint-disable-next-line react/jsx-props-no-spreading -- pass icon props to the legacy component
    /*#__PURE__*/ (0, $dc70d.jsx)($3300279a3f4ed2cc$var$IconStatusLoadable, {
        ...props
    });
$3300279a3f4ed2cc$export$4635bc8225f90ec6.preload = ()=>(0, $3y2s4.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? $3300279a3f4ed2cc$var$IconStatusLazy.preload() : $3300279a3f4ed2cc$var$IconStatusLoadable.preload();

const $3300279a3f4ed2cc$var$loadIconOneColumnLayout = ()=>(parcelRequire("9uTAu")).then((module)=>module.default);

const $3300279a3f4ed2cc$var$IconOneColumnLayoutLazy = (0, $cJJTb.lazy)(()=>(parcelRequire("9uTAu")).then((module)=>module.default), {
    moduleId: "../platform/packages/editor/editor-common/src/quick-insert/assets/one-column-layout.tsx"
});
$3300279a3f4ed2cc$var$IconOneColumnLayoutLazy.displayName = 'lazy(IconOneColumnLayout)';
const $3300279a3f4ed2cc$var$IconOneColumnLayoutLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($deAR2)))({
    loader: $3300279a3f4ed2cc$var$loadIconOneColumnLayout,
    loading: ()=>null
});
const $3300279a3f4ed2cc$export$8f1e9e900568bfce = (props)=>(0, $3y2s4.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $cJJTb.LazySuspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $dc70d.jsx)($3300279a3f4ed2cc$var$IconOneColumnLayoutLazy, {
            ...props
        })
    }) : // eslint-disable-next-line react/jsx-props-no-spreading -- pass icon props to the legacy component
    /*#__PURE__*/ (0, $dc70d.jsx)($3300279a3f4ed2cc$var$IconOneColumnLayoutLoadable, {
        ...props
    });
$3300279a3f4ed2cc$export$8f1e9e900568bfce.preload = ()=>(0, $3y2s4.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? $3300279a3f4ed2cc$var$IconOneColumnLayoutLazy.preload() : $3300279a3f4ed2cc$var$IconOneColumnLayoutLoadable.preload();

const $3300279a3f4ed2cc$var$loadIconTwoColumnLayout = ()=>(parcelRequire("3qJkH")).then((module)=>module.default);

const $3300279a3f4ed2cc$var$IconTwoColumnLayoutLazy = (0, $cJJTb.lazy)(()=>(parcelRequire("3qJkH")).then((module)=>module.default), {
    moduleId: "../platform/packages/editor/editor-common/src/quick-insert/assets/two-column-layout.tsx"
});
$3300279a3f4ed2cc$var$IconTwoColumnLayoutLazy.displayName = 'lazy(IconTwoColumnLayout)';
const $3300279a3f4ed2cc$var$IconTwoColumnLayoutLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($deAR2)))({
    loader: $3300279a3f4ed2cc$var$loadIconTwoColumnLayout,
    loading: ()=>null
});
const $3300279a3f4ed2cc$export$732a7fc4975ab5a4 = (props)=>(0, $3y2s4.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $cJJTb.LazySuspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $dc70d.jsx)($3300279a3f4ed2cc$var$IconTwoColumnLayoutLazy, {
            ...props
        })
    }) : // eslint-disable-next-line react/jsx-props-no-spreading -- pass icon props to the legacy component
    /*#__PURE__*/ (0, $dc70d.jsx)($3300279a3f4ed2cc$var$IconTwoColumnLayoutLoadable, {
        ...props
    });
$3300279a3f4ed2cc$export$732a7fc4975ab5a4.preload = ()=>(0, $3y2s4.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? $3300279a3f4ed2cc$var$IconTwoColumnLayoutLazy.preload() : $3300279a3f4ed2cc$var$IconTwoColumnLayoutLoadable.preload();

const $3300279a3f4ed2cc$var$loadIconThreeColumnLayout = ()=>(parcelRequire("gBDvP")).then((module)=>module.default);

const $3300279a3f4ed2cc$var$IconThreeColumnLayoutLazy = (0, $cJJTb.lazy)(()=>(parcelRequire("gBDvP")).then((module)=>module.default), {
    moduleId: "../platform/packages/editor/editor-common/src/quick-insert/assets/three-column-layout.tsx"
});
$3300279a3f4ed2cc$var$IconThreeColumnLayoutLazy.displayName = 'lazy(IconThreeColumnLayout)';
const $3300279a3f4ed2cc$var$IconThreeColumnLayoutLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($deAR2)))({
    loader: $3300279a3f4ed2cc$var$loadIconThreeColumnLayout,
    loading: ()=>null
});
const $3300279a3f4ed2cc$export$fdfaf73f45072edb = (props)=>(0, $3y2s4.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $cJJTb.LazySuspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $dc70d.jsx)($3300279a3f4ed2cc$var$IconThreeColumnLayoutLazy, {
            ...props
        })
    }) : // eslint-disable-next-line react/jsx-props-no-spreading -- pass icon props to the legacy component
    /*#__PURE__*/ (0, $dc70d.jsx)($3300279a3f4ed2cc$var$IconThreeColumnLayoutLoadable, {
        ...props
    });
$3300279a3f4ed2cc$export$fdfaf73f45072edb.preload = ()=>(0, $3y2s4.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? $3300279a3f4ed2cc$var$IconThreeColumnLayoutLazy.preload() : $3300279a3f4ed2cc$var$IconThreeColumnLayoutLoadable.preload();

const $3300279a3f4ed2cc$var$loadIconFourColumnLayout = ()=>(parcelRequire("9ICKv")).then((module)=>module.default);

const $3300279a3f4ed2cc$var$IconFourColumnLayoutLazy = (0, $cJJTb.lazy)(()=>(parcelRequire("9ICKv")).then((module)=>module.default), {
    moduleId: "../platform/packages/editor/editor-common/src/quick-insert/assets/four-column-layout.tsx"
});
$3300279a3f4ed2cc$var$IconFourColumnLayoutLazy.displayName = 'lazy(IconFourColumnLayout)';
const $3300279a3f4ed2cc$var$IconFourColumnLayoutLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($deAR2)))({
    loader: $3300279a3f4ed2cc$var$loadIconFourColumnLayout,
    loading: ()=>null
});
const $3300279a3f4ed2cc$export$a1588f873a973762 = (props)=>(0, $3y2s4.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $cJJTb.LazySuspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $dc70d.jsx)($3300279a3f4ed2cc$var$IconFourColumnLayoutLazy, {
            ...props
        })
    }) : // eslint-disable-next-line react/jsx-props-no-spreading -- pass icon props to the legacy component
    /*#__PURE__*/ (0, $dc70d.jsx)($3300279a3f4ed2cc$var$IconFourColumnLayoutLoadable, {
        ...props
    });
$3300279a3f4ed2cc$export$a1588f873a973762.preload = ()=>(0, $3y2s4.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? $3300279a3f4ed2cc$var$IconFourColumnLayoutLazy.preload() : $3300279a3f4ed2cc$var$IconFourColumnLayoutLoadable.preload();

const $3300279a3f4ed2cc$var$loadIconFiveColumnLayout = ()=>(parcelRequire("478Kb")).then((module)=>module.default);

const $3300279a3f4ed2cc$var$IconFiveColumnLayoutLazy = (0, $cJJTb.lazy)(()=>(parcelRequire("478Kb")).then((module)=>module.default), {
    moduleId: "../platform/packages/editor/editor-common/src/quick-insert/assets/five-column-layout.tsx"
});
$3300279a3f4ed2cc$var$IconFiveColumnLayoutLazy.displayName = 'lazy(IconFiveColumnLayout)';
const $3300279a3f4ed2cc$var$IconFiveColumnLayoutLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($deAR2)))({
    loader: $3300279a3f4ed2cc$var$loadIconFiveColumnLayout,
    loading: ()=>null
});
const $3300279a3f4ed2cc$export$ff1f32987b4c27d9 = (props)=>(0, $3y2s4.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $cJJTb.LazySuspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $dc70d.jsx)($3300279a3f4ed2cc$var$IconFiveColumnLayoutLazy, {
            ...props
        })
    }) : // eslint-disable-next-line react/jsx-props-no-spreading -- pass icon props to the legacy component
    /*#__PURE__*/ (0, $dc70d.jsx)($3300279a3f4ed2cc$var$IconFiveColumnLayoutLoadable, {
        ...props
    });
$3300279a3f4ed2cc$export$ff1f32987b4c27d9.preload = ()=>(0, $3y2s4.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? $3300279a3f4ed2cc$var$IconFiveColumnLayoutLazy.preload() : $3300279a3f4ed2cc$var$IconFiveColumnLayoutLoadable.preload();






function $3300279a3f4ed2cc$var$importHeading(level) {
    switch(level){
        case 1:
            return (parcelRequire("kF2jY"));
        case 2:
            return (parcelRequire("gUMlp"));
        case 3:
            return (parcelRequire("hjI3f"));
        case 4:
            return (parcelRequire("8GCZT"));
        case 5:
            return (parcelRequire("6pLYs"));
        case 6:
        default:
            return (parcelRequire("cSadb"));
    }
}
const $3300279a3f4ed2cc$export$1a33a10ac24d7971 = ({ level: level, label: label })=>{
    const loadIconHeading = ()=>$3300279a3f4ed2cc$var$importHeading(level).then((module)=>module.default);
    const IconHeadingLazy = (0, $cJJTb.lazy)(()=>loadIconHeading(), {});
    IconHeadingLazy.displayName = `lazy(IconHeading${level})`;
    const IconHeadingLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($deAR2)))({
        loader: loadIconHeading,
        loading: ()=>null
    });
    return (0, $3y2s4.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $cJJTb.LazySuspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $dc70d.jsx)(IconHeadingLazy, {
            label: label
        })
    }) : /*#__PURE__*/ (0, $dc70d.jsx)(IconHeadingLoadable, {
        label: label
    });
};

const $3300279a3f4ed2cc$var$loadIconFeedback = ()=>(parcelRequire("L3h7U")).then((module)=>module.default);

const $3300279a3f4ed2cc$var$IconFeedbackLazy = (0, $cJJTb.lazy)(()=>(parcelRequire("L3h7U")).then((module)=>module.default), {
    moduleId: "../platform/packages/editor/editor-common/src/quick-insert/assets/feedback.tsx"
});
$3300279a3f4ed2cc$var$IconFeedbackLazy.displayName = 'lazy(IconFeedback)';
const $3300279a3f4ed2cc$var$IconFeedbackLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($deAR2)))({
    loader: $3300279a3f4ed2cc$var$loadIconFeedback,
    loading: ()=>null
});
const $3300279a3f4ed2cc$export$e25449dcffb445e = (props)=>(0, $3y2s4.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $cJJTb.LazySuspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $dc70d.jsx)($3300279a3f4ed2cc$var$IconFeedbackLazy, {
            ...props
        })
    }) : // eslint-disable-next-line react/jsx-props-no-spreading -- pass icon props to the legacy component
    /*#__PURE__*/ (0, $dc70d.jsx)($3300279a3f4ed2cc$var$IconFeedbackLoadable, {
        ...props
    });
$3300279a3f4ed2cc$export$e25449dcffb445e.preload = ()=>(0, $3y2s4.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? $3300279a3f4ed2cc$var$IconFeedbackLazy.preload() : $3300279a3f4ed2cc$var$IconFeedbackLoadable.preload();

const $3300279a3f4ed2cc$var$loadIconExpand = ()=>(parcelRequire("1MVKK")).then((module)=>module.default);

const $3300279a3f4ed2cc$var$IconExpandLazy = (0, $cJJTb.lazy)(()=>(parcelRequire("1MVKK")).then((module)=>module.default), {
    moduleId: "../platform/packages/editor/editor-common/src/quick-insert/assets/expand.tsx"
});
$3300279a3f4ed2cc$var$IconExpandLazy.displayName = 'lazy(IconExpand)';
const $3300279a3f4ed2cc$var$IconExpandLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($deAR2)))({
    loader: $3300279a3f4ed2cc$var$loadIconExpand,
    loading: ()=>null
});
const $3300279a3f4ed2cc$export$209d03a445a7dc8e = (props)=>(0, $3y2s4.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $cJJTb.LazySuspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $dc70d.jsx)($3300279a3f4ed2cc$var$IconExpandLazy, {
            ...props
        })
    }) : // eslint-disable-next-line react/jsx-props-no-spreading -- pass icon props to the legacy component
    /*#__PURE__*/ (0, $dc70d.jsx)($3300279a3f4ed2cc$var$IconExpandLoadable, {
        ...props
    });
$3300279a3f4ed2cc$export$209d03a445a7dc8e.preload = ()=>(0, $3y2s4.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? $3300279a3f4ed2cc$var$IconExpandLazy.preload() : $3300279a3f4ed2cc$var$IconExpandLoadable.preload();

const $3300279a3f4ed2cc$var$loadIconDatasourceJiraIssue = ()=>(parcelRequire("ePDu2")).then((module)=>module.default);

const $3300279a3f4ed2cc$var$IconDatasourceJiraIssueLazy = (0, $cJJTb.lazy)(()=>(parcelRequire("ePDu2")).then((module)=>module.default), {
    moduleId: "../platform/packages/editor/editor-common/src/quick-insert/assets/datasource-jira-issue.tsx"
});
$3300279a3f4ed2cc$var$IconDatasourceJiraIssueLazy.displayName = 'lazy(IconDatasourceJiraIssue)';
const $3300279a3f4ed2cc$var$IconDatasourceJiraIssueLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($deAR2)))({
    loader: $3300279a3f4ed2cc$var$loadIconDatasourceJiraIssue,
    loading: ()=>null
});
const $3300279a3f4ed2cc$export$c9b1dcefa7c9a7aa = (props)=>(0, $3y2s4.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $cJJTb.LazySuspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $dc70d.jsx)($3300279a3f4ed2cc$var$IconDatasourceJiraIssueLazy, {
            ...props
        })
    }) : // eslint-disable-next-line react/jsx-props-no-spreading -- pass icon props to the legacy component
    /*#__PURE__*/ (0, $dc70d.jsx)($3300279a3f4ed2cc$var$IconDatasourceJiraIssueLoadable, {
        ...props
    });
$3300279a3f4ed2cc$export$c9b1dcefa7c9a7aa.preload = ()=>(0, $3y2s4.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? $3300279a3f4ed2cc$var$IconDatasourceJiraIssueLazy.preload() : $3300279a3f4ed2cc$var$IconDatasourceJiraIssueLoadable.preload();

const $3300279a3f4ed2cc$var$loadIconDatasourceAssetsObjects = ()=>(parcelRequire("39LKU")).then((module)=>module.default);

const $3300279a3f4ed2cc$var$IconDatasourceAssetsObjectsLazy = (0, $cJJTb.lazy)(()=>(parcelRequire("39LKU")).then((module)=>module.default), {
    moduleId: "../platform/packages/editor/editor-common/src/quick-insert/assets/datasource-assets-objects.tsx"
});
$3300279a3f4ed2cc$var$IconDatasourceAssetsObjectsLazy.displayName = 'lazy(IconDatasourceAssetsObjects)';
const $3300279a3f4ed2cc$var$IconDatasourceAssetsObjectsLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($deAR2)))({
    loader: $3300279a3f4ed2cc$var$loadIconDatasourceAssetsObjects,
    loading: ()=>null
});
const $3300279a3f4ed2cc$export$7d6f860161da0fa6 = (props)=>(0, $3y2s4.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $cJJTb.LazySuspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $dc70d.jsx)($3300279a3f4ed2cc$var$IconDatasourceAssetsObjectsLazy, {
            ...props
        })
    }) : // eslint-disable-next-line react/jsx-props-no-spreading -- pass icon props to the legacy component
    /*#__PURE__*/ (0, $dc70d.jsx)($3300279a3f4ed2cc$var$IconDatasourceAssetsObjectsLoadable, {
        ...props
    });
$3300279a3f4ed2cc$export$7d6f860161da0fa6.preload = ()=>(0, $3y2s4.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? $3300279a3f4ed2cc$var$IconDatasourceAssetsObjectsLazy.preload() : $3300279a3f4ed2cc$var$IconDatasourceAssetsObjectsLoadable.preload();

const $3300279a3f4ed2cc$var$loadIconDatasourceConfluenceSearch = ()=>(parcelRequire("jQ5ky")).then((module)=>module.default);

const $3300279a3f4ed2cc$var$IconDatasourceConfluenceSearchLazy = (0, $cJJTb.lazy)(()=>(parcelRequire("jQ5ky")).then((module)=>module.default), {
    moduleId: "../platform/packages/editor/editor-common/src/quick-insert/assets/datasource-confluence-search.tsx"
});
$3300279a3f4ed2cc$var$IconDatasourceConfluenceSearchLazy.displayName = 'lazy(IconDatasourceConfluenceSearch)';
const $3300279a3f4ed2cc$var$IconDatasourceConfluenceSearchLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($deAR2)))({
    loader: $3300279a3f4ed2cc$var$loadIconDatasourceConfluenceSearch,
    loading: ()=>null
});
const $3300279a3f4ed2cc$export$29a810fd0b8c3f03 = (props)=>(0, $3y2s4.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $cJJTb.LazySuspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $dc70d.jsx)($3300279a3f4ed2cc$var$IconDatasourceConfluenceSearchLazy, {
            ...props
        })
    }) : // eslint-disable-next-line react/jsx-props-no-spreading -- pass icon props to the legacy component
    /*#__PURE__*/ (0, $dc70d.jsx)($3300279a3f4ed2cc$var$IconDatasourceConfluenceSearchLoadable, {
        ...props
    });
$3300279a3f4ed2cc$export$29a810fd0b8c3f03.preload = ()=>(0, $3y2s4.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? $3300279a3f4ed2cc$var$IconDatasourceConfluenceSearchLazy.preload() : $3300279a3f4ed2cc$var$IconDatasourceConfluenceSearchLoadable.preload();

const $3300279a3f4ed2cc$var$loadIconLoom = ()=>(parcelRequire("eWPEh")).then((module)=>module.default);

const $3300279a3f4ed2cc$var$IconLoomLazy = (0, $cJJTb.lazy)(()=>(parcelRequire("eWPEh")).then((module)=>module.default), {
    moduleId: "../platform/packages/editor/editor-common/src/quick-insert/assets/loom.tsx"
});
$3300279a3f4ed2cc$var$IconLoomLazy.displayName = 'lazy(IconLoom)';
const $3300279a3f4ed2cc$var$IconLoomLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($deAR2)))({
    loader: $3300279a3f4ed2cc$var$loadIconLoom,
    loading: ()=>null
});
const $3300279a3f4ed2cc$export$ccbb24eed51aea20 = (props)=>(0, $3y2s4.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $cJJTb.LazySuspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $dc70d.jsx)($3300279a3f4ed2cc$var$IconLoomLazy, {
            ...props
        })
    }) : // eslint-disable-next-line react/jsx-props-no-spreading -- pass icon props to the legacy component
    /*#__PURE__*/ (0, $dc70d.jsx)($3300279a3f4ed2cc$var$IconLoomLoadable, {
        ...props
    });
$3300279a3f4ed2cc$export$ccbb24eed51aea20.preload = ()=>(0, $3y2s4.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? $3300279a3f4ed2cc$var$IconLoomLazy.preload() : $3300279a3f4ed2cc$var$IconLoomLoadable.preload();

const $3300279a3f4ed2cc$var$loadIconSyncBlock = ()=>(parcelRequire("bsMEc")).then((module)=>module.default);

const $3300279a3f4ed2cc$var$IconSyncBlockLazy = (0, $cJJTb.lazy)(()=>(parcelRequire("bsMEc")).then((module)=>module.default), {
    moduleId: "../platform/packages/editor/editor-common/src/quick-insert/assets/syncBlock.tsx"
});
$3300279a3f4ed2cc$var$IconSyncBlockLazy.displayName = 'lazy(IconSyncBlock)';
const $3300279a3f4ed2cc$var$IconSyncBlockLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($deAR2)))({
    loader: $3300279a3f4ed2cc$var$loadIconSyncBlock,
    loading: ()=>null
});
const $3300279a3f4ed2cc$export$4dc65faf2ef9e446 = (props)=>(0, $3y2s4.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $cJJTb.LazySuspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $dc70d.jsx)($3300279a3f4ed2cc$var$IconSyncBlockLazy, {
            ...props
        })
    }) : // eslint-disable-next-line react/jsx-props-no-spreading -- pass icon props to the legacy component
    /*#__PURE__*/ (0, $dc70d.jsx)($3300279a3f4ed2cc$var$IconSyncBlockLoadable, {
        ...props
    });
$3300279a3f4ed2cc$export$4dc65faf2ef9e446.preload = ()=>(0, $3y2s4.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? $3300279a3f4ed2cc$var$IconSyncBlockLazy.preload() : $3300279a3f4ed2cc$var$IconSyncBlockLoadable.preload();

});
parcelRegister("8V5qZ", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("4D4GE").then(()=>parcelRequire('lRWcq'));

});
parcelRegister("kOunM", function(module, exports) {
"use strict";

function $f2700b8349aa6afb$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("gBxz7")).resolve(id));
}
module.exports = $f2700b8349aa6afb$var$load;

});
parcelRegister("gBxz7", function(module, exports) {
$parcel$export(module.exports, "register", () => $c16a23763a54f59d$export$6503ec6e8aabbaf, (v) => $c16a23763a54f59d$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $c16a23763a54f59d$export$f7ad0328861e2f03, (v) => $c16a23763a54f59d$export$f7ad0328861e2f03 = v);
var $c16a23763a54f59d$export$6503ec6e8aabbaf;
var $c16a23763a54f59d$export$f7ad0328861e2f03;
"use strict";
var $c16a23763a54f59d$var$mapping = new Map();
function $c16a23763a54f59d$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$c16a23763a54f59d$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $c16a23763a54f59d$var$resolve(id) {
    var resolved = $c16a23763a54f59d$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$c16a23763a54f59d$export$6503ec6e8aabbaf = $c16a23763a54f59d$var$register;
$c16a23763a54f59d$export$f7ad0328861e2f03 = $c16a23763a54f59d$var$resolve;

});



parcelRegister("11wHC", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("iQRgq").then(()=>parcelRequire('hSuet'));

});

parcelRegister("kiDW3", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("jFu3W").then(()=>parcelRequire('hlVOz'));

});

parcelRegister("hIgzp", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("lbjEc").then(()=>parcelRequire('2PryA'));

});

parcelRegister("lR8yA", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("betgh").then(()=>parcelRequire('kAFhw'));

});

parcelRegister("2RkWQ", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("h4vxb").then(()=>parcelRequire('bDLvL'));

});

parcelRegister("5M3hu", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("gsaWm").then(()=>parcelRequire('6wJpm'));

});

parcelRegister("7wZJL", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("5s27V").then(()=>parcelRequire('icpKD'));

});

parcelRegister("8oMxX", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("kvfsv").then(()=>parcelRequire('ejIek'));

});

parcelRegister("3XIn9", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("85QQK").then(()=>parcelRequire('lkST7'));

});

parcelRegister("aA0Wf", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("dfDEN").then(()=>parcelRequire('eksFY'));

});

parcelRegister("haPY3", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("eM16W").then(()=>parcelRequire('emj4N'));

});

parcelRegister("8zvZd", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("03Dw3").then(()=>parcelRequire('lGaBg'));

});

parcelRegister("4cNNn", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("1TMxH").then(()=>parcelRequire('gAfsZ'));

});

parcelRegister("1UJ3I", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("iYjoV").then(()=>parcelRequire('hPGJn'));

});

parcelRegister("amBJK", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("g4g4X").then(()=>parcelRequire('9vt7Q'));

});

parcelRegister("iP11F", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("2oqvW").then(()=>parcelRequire('cgtQj'));

});

parcelRegister("88x8c", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("k2vAI").then(()=>parcelRequire('aIIHc'));

});

parcelRegister("d0gK5", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("7S7CR").then(()=>parcelRequire('5Rjnh'));

});

parcelRegister("9uTAu", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("bNMB9").then(()=>parcelRequire('b5ziR'));

});

parcelRegister("3qJkH", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("79E7a").then(()=>parcelRequire('dXioM'));

});

parcelRegister("gBDvP", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("Joyn2").then(()=>parcelRequire('1ArUQ'));

});

parcelRegister("9ICKv", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("iN6NB").then(()=>parcelRequire('10tzX'));

});

parcelRegister("478Kb", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("8zDah").then(()=>parcelRequire('3W5xV'));

});

parcelRegister("kF2jY", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("2qL04").then(()=>parcelRequire('11jGi'));

});

parcelRegister("gUMlp", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("kYow4").then(()=>parcelRequire('3uluu'));

});

parcelRegister("hjI3f", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("j4nJN").then(()=>parcelRequire('hVMad'));

});

parcelRegister("8GCZT", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("astQb").then(()=>parcelRequire('ghV35'));

});

parcelRegister("6pLYs", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("lDaMS").then(()=>parcelRequire('7o1ME'));

});

parcelRegister("cSadb", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("aB67c").then(()=>parcelRequire('9fMgn'));

});

parcelRegister("L3h7U", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("5CQoM").then(()=>parcelRequire('i1aaU'));

});

parcelRegister("1MVKK", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("i6xo4").then(()=>parcelRequire('9bDdy'));

});

parcelRegister("ePDu2", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("eXNdj").then(()=>parcelRequire('9wSrf'));

});

parcelRegister("39LKU", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("ak4YB").then(()=>parcelRequire('hrXX4'));

});

parcelRegister("jQ5ky", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("5ltWY").then(()=>parcelRequire('5N6zh'));

});

parcelRegister("eWPEh", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("8GdqH").then(()=>parcelRequire('icHt8'));

});

parcelRegister("bsMEc", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("adlxf").then(()=>parcelRequire('4yrQe'));

});


parcelRegister("ixBwV", function(module, exports) {
$parcel$export(module.exports, "expValInternal", () => $b5ae222af1a28014$export$48708229abf6ab93);
$parcel$export(module.exports, "expVal", () => (parcelRequire("eW8cK")).expVal);
$parcel$export(module.exports, "expValNoExposure", () => (parcelRequire("kZ1UZ")).expValNoExposure);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ /* eslint-disable @atlaskit/editor/no-re-export -- deprecated shims re-exporting the split `expVal`/`expValNoExposure` modules for backwards compatibility (VOLTC-139). */ 
var $87QgR = parcelRequire("87QgR");

var $i2aoZ = parcelRequire("i2aoZ");

var $1ojCy = parcelRequire("1ojCy");

var $hj2cZ = parcelRequire("hj2cZ");

var $eW8cK = parcelRequire("eW8cK");

var $kZ1UZ = parcelRequire("kZ1UZ");
function $b5ae222af1a28014$export$48708229abf6ab93({ experimentName: experimentName, experimentParam: experimentParam, defaultValue: defaultValue, fireExperimentExposure: fireExperimentExposure }) {
    var _paramOverrides2, _experimentConfig$pro;
    const experimentConfig = (0, $1ojCy.editorExperimentsConfig)[experimentName];
    if (experimentConfig === undefined) // Warning! If a product is improperly configured (ie. their editor packages are misaligned)
    // it can cause the editor to crash here or if the experiment does not exist.
    // We will definitely crash via any code path later in this function - this just makes the error explicit and clear.
    throw new Error(`Editor experiment configuration is not defined ${experimentName}. Likely the experiment does not exist or editor package versions are misaligned`);
    if ((0, $hj2cZ._overrides)[experimentName] !== undefined) // This will be hit in the case of a test setting an override
    // @ts-ignore need to loosen the type here to allow for any experiment name
    return (0, $hj2cZ._overrides)[experimentName];
    // Check for parameter overrides
    const paramOverride = (_paramOverrides2 = (0, $hj2cZ._paramOverrides)[experimentName]) === null || _paramOverrides2 === void 0 ? void 0 : _paramOverrides2[experimentParam];
    if (paramOverride !== undefined) return paramOverride;
    // If client is not initialized, we return the default value
    if (!(0, $87QgR.default).initializeCompleted()) return defaultValue;
    if (!(0, $hj2cZ._product)) // This will be hit in the case of a product not having setup the editor experiment tooling
    return defaultValue;
    // Typescript is complaining here about accessing the productKeys property
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const experimentKey = experimentConfig === null || experimentConfig === void 0 || (_experimentConfig$pro = experimentConfig.productKeys) === null || _experimentConfig$pro === void 0 ? void 0 : _experimentConfig$pro[0, $hj2cZ._product];
    if (!experimentKey) // This will be hit in the case of an experiment not being set up for the product
    return defaultValue;
    const resolvedExperimentKey = (0, $1ojCy.disallowsProductKeys).includes(experimentName) ? experimentName : experimentKey;
    // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
    const experimentValue = (0, $87QgR.default).getExperimentValue(resolvedExperimentKey, experimentParam, defaultValue, {
        fireExperimentExposure: fireExperimentExposure
    });
    // Duplicated from /confluence/next/packages/feature-experiments/src/index.ts
    (0, $i2aoZ.addFeatureFlagAccessed)(`${resolvedExperimentKey}:${experimentParam}`, experimentValue);
    return experimentValue;
}

});
parcelRegister("eW8cK", function(module, exports) {
$parcel$export(module.exports, "expVal", () => $246801280494b3aa$export$9db1624a8af791a4);

var $ixBwV = parcelRequire("ixBwV");
function $246801280494b3aa$export$9db1624a8af791a4(experimentName, experimentParam, defaultValue) {
    return (0, $ixBwV.expValInternal)({
        experimentName: experimentName,
        experimentParam: experimentParam,
        defaultValue: defaultValue,
        fireExperimentExposure: true
    });
}

});

parcelRegister("kZ1UZ", function(module, exports) {
$parcel$export(module.exports, "expValNoExposure", () => $d7e8f158ea3e5617$export$94f132839aec533f);

var $ixBwV = parcelRequire("ixBwV");
function $d7e8f158ea3e5617$export$94f132839aec533f(experimentName, experimentParam, defaultValue) {
    return (0, $ixBwV.expValInternal)({
        experimentName: experimentName,
        experimentParam: experimentParam,
        defaultValue: defaultValue,
        fireExperimentExposure: false
    });
}

});


parcelRegister("5TMXh", function(module, exports) {
$parcel$export(module.exports, "blockCardSpecWithFixedToDOM", () => $66e51d8b8840a50c$export$f664dd11022c8749);

var $k0msq = parcelRequire("k0msq");

var $PFzWP = parcelRequire("PFzWP");

var $gdUUy = parcelRequire("gdUUy");
const $66e51d8b8840a50c$export$f664dd11022c8749 = ()=>{
    const blockCardNode = (0, $gdUUy.fg)('platform_editor_adf_with_localid') ? (0, $k0msq.blockCardWithLocalId) : (0, $k0msq.blockCard);
    return {
        ...blockCardNode,
        toDOM: (node)=>{
            var _node$attrs;
            const { url: url } = node.attrs;
            const { data: data } = node.attrs;
            const { layout: layout, width: width, datasource: datasource } = node.attrs;
            const attrs = {
                'data-block-card': '',
                'data-card-url': url || '',
                'data-card-data': data ? JSON.stringify(data) : '',
                'data-datasource': datasource ? JSON.stringify(datasource) : '',
                'data-layout': layout,
                'data-width': `${width}`,
                class: 'blockCardView-content-wrap',
                ...(0, $gdUUy.fg)('platform_editor_adf_with_localid') ? {
                    'data-local-id': node.attrs.localId
                } : {}
            };
            return [
                'div',
                attrs,
                [
                    'a',
                    {
                        // To match `packages/linking-platform/smart-card/src/view/CardWithUrl/component-lazy/LoadingCardLink.tsx`
                        // Which uses frame styling `packages/linking-platform/smart-card/src/view/InlineCard/Frame/styled.ts`
                        style: (0, $PFzWP.convertToInlineCss)({
                            padding: `${"var(--ds-space-025, 2px)"} 0px`,
                            marginLeft: "var(--ds-space-negative-025, -2px)",
                            display: 'inline',
                            boxDecorationBreak: 'clone',
                            WebkitBoxDecorationBreak: 'clone',
                            borderRadius: "var(--ds-radius-small, 4px)",
                            color: "var(--ds-link, #1868DB)",
                            lineHeight: '22px',
                            WebkitTransition: '0.1s all ease-in-out',
                            transition: '0.1s all ease-in-out',
                            userSelect: 'text',
                            WebkitUserSelect: 'text',
                            msUserSelect: 'text',
                            MozUserSelect: 'none' // -moz-user-select
                        }),
                        href: url || ''
                    },
                    (node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.url) || ' '
                ]
            ];
        }
    };
};

});
parcelRegister("PFzWP", function(module, exports) {
$parcel$export(module.exports, "convertToInlineCss", () => $a5932bc0f120e5f1$export$7da93c9174ab9340);
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $a5932bc0f120e5f1$var$MS_PREFIX_REGEX = /^ms/;
/**
 * Converts a camelCased CSS property name to a hyphenated CSS property name.
 *
 * @param property - CamelCased CSS property name.
 * @returns Hyphenated CSS property name.
 */ function $a5932bc0f120e5f1$var$hyphenate(property) {
    // Ignored via go/ees005
    /* eslint-disable require-unicode-regexp */ return property.replace(/[A-Z]/g, (match)=>`-${match.toLowerCase()}`).replace($a5932bc0f120e5f1$var$MS_PREFIX_REGEX, '-ms');
/* eslint-enable require-unicode-regexp */ }
function $a5932bc0f120e5f1$export$7da93c9174ab9340(properties) {
    const cssString = Object.entries(properties).sort(([a], [b])=>a.localeCompare(b)).map(([property, value])=>`${property.startsWith('--') ? property : $a5932bc0f120e5f1$var$hyphenate(property)}: ${value};`).join(' ');
    return cssString;
}

});


parcelRegister("iUYTC", function(module, exports) {
$parcel$export(module.exports, "embedCardSpecWithFixedToDOM", () => $3e253ac2a13f3268$export$f8faabd3267a007e);
/**
 * Some of these functions and styling are duplicated from their custom node view equivalents
 *
 * WHY?
 * This will eventually move to `@atlaskit/adf-schema` and we cannot reference
 * `@atlaskit/editor-common` from here or it will cause dependency issues.
 *
 * In the long term likely `toDOM` will move back out of `adf-schema` in which
 * case we can consolidate them.
 */ 
var $8NN4H = parcelRequire("8NN4H");

var $PFzWP = parcelRequire("PFzWP");

var $5bbjm = parcelRequire("5bbjm");

var $gdUUy = parcelRequire("gdUUy");
// From `packages/editor/editor-common/src/ui/MediaSingle/styled.tsx`
function $3e253ac2a13f3268$var$calcMargin(layout) {
    switch(layout){
        case 'wrap-right':
            return '12px auto 12px 12px';
        case 'wrap-left':
            return '12px 12px 12px auto';
        default:
            return '24px auto';
    }
}
// From `packages/editor/editor-common/src/ui/MediaSingle/styled.tsx`
function $3e253ac2a13f3268$var$float(layout) {
    switch(layout){
        case 'wrap-right':
            return 'right';
        case 'wrap-left':
            return 'left';
        default:
            return 'none';
    }
}
// From `packages/editor/editor-common/src/media-single/constants.ts`
const $3e253ac2a13f3268$var$MEDIA_SINGLE_GUTTER_SIZE = 24;
// From `packages/editor/editor-common/src/ui/MediaSingle/styled.tsx`
function $3e253ac2a13f3268$var$calcPxFromPct(pct, lineLength) {
    const maxWidth = lineLength + $3e253ac2a13f3268$var$MEDIA_SINGLE_GUTTER_SIZE;
    return maxWidth * pct - $3e253ac2a13f3268$var$MEDIA_SINGLE_GUTTER_SIZE;
}
// ED-24488: We can't retrieve the editor width from here easily.
// For now we're using the default line length here, but this will be
// incorrect on smaller devices.
const $3e253ac2a13f3268$var$LINE_LENGTH = 760;
const $3e253ac2a13f3268$export$f8faabd3267a007e = ()=>{
    const embedCardNode = (0, $gdUUy.fg)('platform_editor_adf_with_localid') ? (0, $8NN4H.embedCardWithLocalId) : (0, $8NN4H.embedCard);
    return {
        ...embedCardNode,
        toDOM: (node)=>{
            const { url: url, layout: layout, width: width, originalWidth: originalWidth, originalHeight: originalHeight } = node.attrs;
            const aspectRatio = originalWidth && originalHeight ? originalWidth / originalHeight : (0, $5bbjm.DEFAULT_EMBED_CARD_WIDTH) / (0, $5bbjm.DEFAULT_EMBED_CARD_HEIGHT);
            const attrs = {
                'data-embed-card': '',
                'data-card-url': url,
                'data-layout': layout,
                'data-width': width,
                'data-original-width': originalWidth,
                'data-original-height': originalHeight,
                class: 'embedCardView-content-wrap',
                // From `packages/editor/editor-plugin-card/src/ui/ResizableEmbedCard.tsx`
                style: (0, $PFzWP.convertToInlineCss)({
                    margin: $3e253ac2a13f3268$var$calcMargin(layout),
                    width: `${Math.ceil($3e253ac2a13f3268$var$calcPxFromPct(width / 100, $3e253ac2a13f3268$var$LINE_LENGTH))}px`,
                    marginRight: layout === 'align-end' ? '0' : '',
                    marginLeft: layout === 'align-start' ? '0' : '',
                    float: $3e253ac2a13f3268$var$float(layout)
                }),
                ...(0, $gdUUy.fg)('platform_editor_adf_with_localid') ? {
                    'data-local-id': node.attrs.localId
                } : {}
            };
            return [
                'div',
                attrs,
                // This is the only modification to the embed card `toDOM`
                // This is to match the behaviour of Card which lazy loads
                // and uses just a URL as a fallback
                //
                // To match: `packages/linking-platform/smart-card/src/view/CardWithUrl/component-lazy/LoadingCardLink.tsx`
                [
                    'a',
                    {
                        style: (0, $PFzWP.convertToInlineCss)({
                            padding: `${"var(--ds-space-025, 2px)"} 0px`,
                            marginLeft: "var(--ds-space-negative-025, -2px)",
                            display: 'inline',
                            boxDecorationBreak: 'clone',
                            borderRadius: "var(--ds-radius-small, 4px)",
                            color: "var(--ds-link, #1868DB)",
                            lineHeight: '22px',
                            WebkitTransition: '0.1s all ease-in-out',
                            transition: '0.1s all ease-in-out',
                            userSelect: 'text',
                            WebkitUserSelect: 'text',
                            msUserSelect: 'text',
                            MozUserSelect: 'none' // -moz-user-select
                        })
                    },
                    url ?? ''
                ],
                // From `packages/editor/editor-plugin-card/src/ui/ResizableEmbedCard.tsx`
                // The `getHeightDefiningComponent` that defines the height of the element
                [
                    'span',
                    {
                        style: (0, $PFzWP.convertToInlineCss)({
                            display: 'block',
                            paddingBottom: `calc(${(1 / aspectRatio * 100).toFixed(3)}% + ${"var(--ds-space-400, 32px)"})`
                        })
                    }
                ]
            ];
        }
    };
};

});

parcelRegister("bNyMY", function(module, exports) {
$parcel$export(module.exports, "inlineCardSpecWithFixedToDOM", () => $747ecf3a965dd982$export$290edac762b9f37c);

var $4d4Lm = parcelRequire("4d4Lm");

var $PFzWP = parcelRequire("PFzWP");

var $gdUUy = parcelRequire("gdUUy");
const $747ecf3a965dd982$export$290edac762b9f37c = ()=>{
    const inlineCardNode = (0, $gdUUy.fg)('platform_editor_adf_with_localid') ? (0, $4d4Lm.inlineCardWithLocalId) : (0, $4d4Lm.inlineCard);
    return {
        ...inlineCardNode,
        toDOM: (node)=>{
            const wrapperAttrs = {
                class: 'inlineCardView-content-wrap inlineNodeView'
            };
            const cardAttrs = {
                'aria-busy': 'true',
                class: 'card'
            };
            const attrs = {
                'data-inline-card': '',
                href: node.attrs.url || '',
                'data-card-data': node.attrs.data ? JSON.stringify(node.attrs.data) : '',
                // LoadingCardLink used for Suspense in `packages/linking-platform/smart-card/src/view/CardWithUrl/loader.tsx`
                // We need to match the style of LoadingCardLink
                // Which uses frame styling `packages/linking-platform/smart-card/src/view/InlineCard/Frame/styled.ts`, with withoutBackground=true
                style: (0, $PFzWP.convertToInlineCss)({
                    padding: `${"var(--ds-space-025, 2px)"} 0px`,
                    marginLeft: "var(--ds-space-negative-025, -2px)",
                    display: 'inline',
                    boxDecorationBreak: 'clone',
                    WebkitBoxDecorationBreak: 'clone',
                    borderRadius: "var(--ds-radius-small, 4px)",
                    color: "var(--ds-link, #1868DB)",
                    lineHeight: '22px',
                    WebkitTransition: '0.1s all ease-in-out',
                    transition: '0.1s all ease-in-out',
                    userSelect: 'text',
                    WebkitUserSelect: 'text',
                    msUserSelect: 'text',
                    MozUserSelect: 'none' // -moz-user-select
                }),
                ...(0, $gdUUy.fg)('platform_editor_adf_with_localid') ? {
                    'data-local-id': node.attrs.localId
                } : {}
            };
            if (node.attrs.url) return [
                'span',
                wrapperAttrs,
                [
                    'span',
                    cardAttrs,
                    [
                        'a',
                        attrs,
                        node.attrs.url
                    ]
                ]
            ];
            else return [
                'span',
                wrapperAttrs,
                [
                    'span',
                    cardAttrs,
                    [
                        'a',
                        attrs
                    ]
                ]
            ];
        }
    };
};

});

parcelRegister("k5X6V", function(module, exports) {
$parcel$export(module.exports, "resolveCard", () => $49ff144ae286c9f6$export$2b7045d36e3e01d4);
$parcel$export(module.exports, "queueCards", () => $49ff144ae286c9f6$export$5312e3a17c3f6d3);
$parcel$export(module.exports, "registerCard", () => $49ff144ae286c9f6$export$af5afab36c1f83f6);
$parcel$export(module.exports, "removeCard", () => $49ff144ae286c9f6$export$3301f76e6efaf85e);
$parcel$export(module.exports, "registerRemoveOverlay", () => $49ff144ae286c9f6$export$a3d5a5cb818ce9d9);
$parcel$export(module.exports, "registerSmartCardEvents", () => $49ff144ae286c9f6$export$55288255874724a1);
$parcel$export(module.exports, "setProvider", () => $49ff144ae286c9f6$export$1572b3eade6662f9);
$parcel$export(module.exports, "setDatasourceTableRef", () => $49ff144ae286c9f6$export$f9c5be16586d220a);
$parcel$export(module.exports, "setResolvedToolbarAttributes", () => $49ff144ae286c9f6$export$63a1bdeb24c4dd9f);
$parcel$export(module.exports, "setCardLayout", () => $49ff144ae286c9f6$export$c9a25858ed46807c);
$parcel$export(module.exports, "setCardLayoutAndDatasourceTableRef", () => $49ff144ae286c9f6$export$dd3435a1df9b2a3f);
$parcel$export(module.exports, "showLinkToolbar", () => $49ff144ae286c9f6$export$83c364d103479f90);
$parcel$export(module.exports, "hideLinkToolbar", () => $49ff144ae286c9f6$export$bd1cd60a9b31da5e);
$parcel$export(module.exports, "showDatasourceModal", () => $49ff144ae286c9f6$export$2c79f54b873d04be);
$parcel$export(module.exports, "hideDatasourceModal", () => $49ff144ae286c9f6$export$e545bc176b552938);
$parcel$export(module.exports, "clearOverlayCandidate", () => $49ff144ae286c9f6$export$a2922c2e95ff48f7);
$parcel$export(module.exports, "setDatasourceStash", () => $49ff144ae286c9f6$export$53e36aa41bbce673);
$parcel$export(module.exports, "removeDatasourceStash", () => $49ff144ae286c9f6$export$4b1fde77584594b5);

var $1fMby = parcelRequire("1fMby");
const $49ff144ae286c9f6$export$a884a52152489cc3 = (tr, action)=>{
    return tr.setMeta((0, $1fMby.pluginKey), action);
};
const $49ff144ae286c9f6$export$2b7045d36e3e01d4 = (url)=>(tr)=>$49ff144ae286c9f6$export$a884a52152489cc3(tr, {
            type: 'RESOLVE',
            url: url
        });
const $49ff144ae286c9f6$export$5312e3a17c3f6d3 = (requests)=>(tr)=>$49ff144ae286c9f6$export$a884a52152489cc3(tr, {
            type: 'QUEUE',
            requests: requests
        });
const $49ff144ae286c9f6$export$af5afab36c1f83f6 = (info)=>(tr)=>$49ff144ae286c9f6$export$a884a52152489cc3(tr, {
            type: 'REGISTER',
            info: info
        });
const $49ff144ae286c9f6$export$3301f76e6efaf85e = (info)=>(tr)=>$49ff144ae286c9f6$export$a884a52152489cc3(tr, {
            type: 'REMOVE_CARD',
            info: info
        });
const $49ff144ae286c9f6$export$a3d5a5cb818ce9d9 = (callback, info)=>(tr)=>$49ff144ae286c9f6$export$a884a52152489cc3(tr, {
            type: 'REGISTER_REMOVE_OVERLAY_ON_INSERTED_LINK',
            callback: callback,
            info: info
        });
const $49ff144ae286c9f6$export$55288255874724a1 = (smartLinkEvents)=>(tr)=>$49ff144ae286c9f6$export$a884a52152489cc3(tr, {
            type: 'REGISTER_EVENTS',
            smartLinkEvents: smartLinkEvents
        });
const $49ff144ae286c9f6$export$1572b3eade6662f9 = (cardProvider)=>(tr)=>$49ff144ae286c9f6$export$a884a52152489cc3(tr, {
            type: 'SET_PROVIDER',
            provider: cardProvider
        });
const $49ff144ae286c9f6$export$f9c5be16586d220a = (datasourceTableRef)=>(tr)=>$49ff144ae286c9f6$export$a884a52152489cc3(tr, {
            type: 'SET_DATASOURCE_TABLE_REF',
            datasourceTableRef: datasourceTableRef
        });
const $49ff144ae286c9f6$export$63a1bdeb24c4dd9f = (url, attributes)=>(tr)=>$49ff144ae286c9f6$export$a884a52152489cc3(tr, {
            type: 'SET_RESOLVED_TOOLBAR_ATTRIBUTES',
            url: url,
            attributes: attributes
        });
const $49ff144ae286c9f6$export$c9a25858ed46807c = (layout)=>(tr)=>$49ff144ae286c9f6$export$a884a52152489cc3(tr, {
            type: 'SET_CARD_LAYOUT',
            layout: layout
        });
const $49ff144ae286c9f6$export$dd3435a1df9b2a3f = ({ layout: layout, datasourceTableRef: datasourceTableRef })=>(tr)=>$49ff144ae286c9f6$export$a884a52152489cc3(tr, {
            type: 'SET_CARD_LAYOUT_AND_DATASOURCE_TABLE_REF',
            layout: layout,
            datasourceTableRef: datasourceTableRef
        });
const $49ff144ae286c9f6$export$83c364d103479f90 = (tr)=>$49ff144ae286c9f6$export$a884a52152489cc3(tr, {
        type: 'SHOW_LINK_TOOLBAR'
    });
const $49ff144ae286c9f6$export$bd1cd60a9b31da5e = (tr)=>$49ff144ae286c9f6$export$a884a52152489cc3(tr, {
        type: 'HIDE_LINK_TOOLBAR'
    });
const $49ff144ae286c9f6$export$2c79f54b873d04be = (modalType)=>(tr)=>$49ff144ae286c9f6$export$a884a52152489cc3(tr, {
            type: 'SHOW_DATASOURCE_MODAL',
            modalType: modalType
        });
const $49ff144ae286c9f6$export$e545bc176b552938 = (tr)=>$49ff144ae286c9f6$export$a884a52152489cc3(tr, {
        type: 'HIDE_DATASOURCE_MODAL'
    });
const $49ff144ae286c9f6$export$a2922c2e95ff48f7 = (tr)=>$49ff144ae286c9f6$export$a884a52152489cc3(tr, {
        type: 'CLEAR_OVERLAY_CANDIDATE'
    });
const $49ff144ae286c9f6$export$53e36aa41bbce673 = (tr, datasourceStash)=>$49ff144ae286c9f6$export$a884a52152489cc3(tr, {
        type: 'SET_DATASOURCE_STASH',
        datasourceStash: datasourceStash
    });
const $49ff144ae286c9f6$export$4b1fde77584594b5 = (tr, url)=>$49ff144ae286c9f6$export$a884a52152489cc3(tr, {
        type: 'REMOVE_DATASOURCE_STASH',
        url: url
    });

});
parcelRegister("1fMby", function(module, exports) {
$parcel$export(module.exports, "pluginKey", () => $f837470f9b7b1efc$export$18d4026d1ea86bb1);

var $cw0wu = parcelRequire("cw0wu");
const $f837470f9b7b1efc$export$18d4026d1ea86bb1 = new (0, $cw0wu.PluginKey)('cardPlugin');

});


parcelRegister("a76m2", function(module, exports) {
$parcel$export(module.exports, "replaceQueuedUrlWithCard", () => $7da2610f190051f1$export$78f5a0da64579d3e);
$parcel$export(module.exports, "handleFallbackWithAnalytics", () => $7da2610f190051f1$export$2bb01cc4a12e0b44);
$parcel$export(module.exports, "queueCardsFromChangedTr", () => $7da2610f190051f1$export$f17c48478174211e);
$parcel$export(module.exports, "queueCardsFromRange", () => $7da2610f190051f1$export$86b4b08ffadfa0a6);
$parcel$export(module.exports, "changeSelectedCardToLink", () => $7da2610f190051f1$export$3f14f692ecc2a0d9);
$parcel$export(module.exports, "changeSelectedCardToLinkFallback", () => $7da2610f190051f1$export$56a04318a610dc7c);
$parcel$export(module.exports, "updateCard", () => $7da2610f190051f1$export$884fcee347ca969b);
$parcel$export(module.exports, "changeSelectedCardToText", () => $7da2610f190051f1$export$23c9e012c8c1ce24);
$parcel$export(module.exports, "setSelectedCardAppearance", () => $7da2610f190051f1$export$a188ef61ddbb94f);
$parcel$export(module.exports, "updateCardViaDatasource", () => $7da2610f190051f1$export$113cdaf1b279f308);
$parcel$export(module.exports, "insertDatasource", () => $7da2610f190051f1$export$7f7b236478a618df);

var $dMMwa = parcelRequire("dMMwa");

var $7nI18 = parcelRequire("7nI18");

var $ci54V = parcelRequire("ci54V");

var $g6Qq4 = parcelRequire("g6Qq4");

var $6vldb = parcelRequire("6vldb");

var $dVt29 = parcelRequire("dVt29");

var $bk3yN = parcelRequire("bk3yN");

var $fcrbf = parcelRequire("fcrbf");

var $cWyqT = parcelRequire("cWyqT");

var $cPyt7 = parcelRequire("cPyt7");

var $6Z6Le = parcelRequire("6Z6Le");

var $cw0wu = parcelRequire("cw0wu");

var $gdUUy = parcelRequire("gdUUy");

var $kQkyj = parcelRequire("kQkyj");

var $797yE = parcelRequire("797yE");

var $k5X6V = parcelRequire("k5X6V");

var $1fMby = parcelRequire("1fMby");

var $19vcu = parcelRequire("19vcu");

var $cKhMH = parcelRequire("cKhMH");
/**
 * Attempt to replace the link into the respective card.
 */ function $7da2610f190051f1$var$replaceLinksToCards(tr, cardAdf, schema, request) {
    const { inlineCard: inlineCard } = schema.nodes;
    const { url: url } = request;
    if (!(0, $7nI18.isSafeUrl)(url)) return;
    // replace all the outstanding links with their cards
    const pos = tr.mapping.map(request.pos);
    const $pos = tr.doc.resolve(pos);
    const $head = tr.selection.$head;
    const node = tr.doc.nodeAt(pos);
    if (!node || !node.type.isText) return;
    const replaceLink = request.shouldReplaceLink || (0, $19vcu.shouldReplaceLink)(node, request.compareLinkText, url);
    if (!replaceLink) return;
    // ED-5638: add an extra space after inline cards to avoid re-rendering them
    const nodes = [
        cardAdf
    ];
    if (cardAdf.type === inlineCard) nodes.push(schema.text(' '));
    tr.replaceWith(pos, pos + (node.text || url).length, nodes);
    const annotationMarksForPos = (0, $cWyqT.getAnnotationMarksForPos)($head);
    if (annotationMarksForPos && annotationMarksForPos.length > 0) annotationMarksForPos.forEach((annotationMark)=>{
        // Add the annotation mark on to the inlineCard node and the trailing space node.
        tr.addMark(pos, pos + nodes[0].nodeSize + nodes[1].nodeSize, annotationMark);
    });
    return $pos.node($pos.depth - 1).type.name;
}
const $7da2610f190051f1$export$78f5a0da64579d3e = (url, cardData, analyticsAction, editorAnalyticsApi, createAnalyticsEvent, embedCardNodeTransformer)=>(editorState, dispatch)=>{
        const state = (0, $1fMby.pluginKey).getState(editorState);
        if (!state) return false;
        // find the requests for this URL
        const requests = state.requests.filter((req)=>req.url === url);
        // try to transform response to ADF
        const schema = editorState.schema;
        let cardAdf = null;
        // If an embed card transformer is provided and the resolved card is an embedCard,
        // attempt to transform it into an alternative node representation first.
        if (cardData.type === 'embedCard' && embedCardNodeTransformer && (0, $gdUUy.fg)('platform_native_embeds_rollout_non_maui_experience')) {
            const transformResult = embedCardNodeTransformer(schema, cardData.attrs);
            // The transformer may return a Promise for async transformations (e.g. short-link expansion).
            // When async, we snapshot the current requests and positions now (before any dispatch),
            // then insert the resolved node and clean up the queue in one transaction once the
            // Promise settles. This avoids the stale-editorState problem: rather than re-running
            // replaceQueuedUrlWithCard with an outdated state snapshot, we capture what we need
            // immediately and apply a targeted insert when ready.
            if (transformResult instanceof Promise) {
                // Snapshot requests now, while the queue still contains this URL.
                const pendingRequests = [
                    ...requests
                ];
                transformResult.then((resolvedNode)=>{
                    if (!dispatch) return;
                    // Build a fresh transaction (editorState is the snapshot at call-time; positions
                    // are mapped through it). For the async case we fall back to cardData if the
                    // transform returned nothing, mirroring what the sync path would do.
                    const asyncCardAdf = resolvedNode ? resolvedNode : (0, $fcrbf.processRawValue)(schema, cardData) ?? null;
                    const asyncTr = editorState.tr;
                    if (asyncCardAdf) pendingRequests.forEach((request)=>$7da2610f190051f1$var$replaceLinksToCards(asyncTr, asyncCardAdf, schema, request));
                    dispatch((0, $k5X6V.resolveCard)(url)((0, $kQkyj.closeHistory)(asyncTr)));
                });
                return true;
            }
            cardAdf = transformResult ?? null;
        }
        if (!cardAdf) cardAdf = (0, $fcrbf.processRawValue)(schema, cardData) ?? null;
        const tr = editorState.tr;
        if (cardAdf) {
            // Should prevent any other node than cards? [inlineCard, blockCard].includes(cardAdf.type)
            const nodeContexts = requests.map((request)=>$7da2610f190051f1$var$replaceLinksToCards(tr, cardAdf, schema, request)).filter((context)=>!!context); // context exist
            // Send analytics information
            if (nodeContexts.length) {
                const nodeContext = nodeContexts.every((context)=>context === nodeContexts[0]) ? nodeContexts[0] : 'mixed';
                /** For block links v1, default to inline links */ const nodeType = 'inlineCard';
                const [, , domainName] = url.split('/');
                if (state.smartLinkEvents) state.smartLinkEvents.insertSmartLink(domainName, 'inline', createAnalyticsEvent);
                /**
       * TODO:
       * What if each request has a different source?
       * Unlikely, but need to define behaviour.
       * Ignore analytics event? take first? provide 'mixed' as well?
       */ const inputMethod = requests[0].source;
                const sourceEvent = requests[0].sourceEvent;
                editorAnalyticsApi === null || editorAnalyticsApi === void 0 || editorAnalyticsApi.attachAnalyticsEvent({
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    action: analyticsAction || (0, $g6Qq4.ACTION).INSERTED,
                    actionSubject: (0, $g6Qq4.ACTION_SUBJECT).DOCUMENT,
                    actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).SMART_LINK,
                    eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
                    attributes: {
                        inputMethod: inputMethod,
                        nodeType: nodeType,
                        nodeContext: nodeContext,
                        fromCurrentDomain: (0, $6Z6Le.isFromCurrentDomain)(url)
                    },
                    nonPrivacySafeAttributes: {
                        domainName: domainName
                    }
                })(tr);
                (0, $dVt29.addLinkMetadata)(editorState.selection, tr, {
                    action: analyticsAction,
                    inputMethod: inputMethod,
                    cardAction: 'RESOLVE',
                    sourceEvent: sourceEvent
                });
            }
        }
        if (dispatch) dispatch((0, $k5X6V.resolveCard)(url)((0, $kQkyj.closeHistory)(tr)));
        return true;
    };
const $7da2610f190051f1$export$2bb01cc4a12e0b44 = (request, editorAnalyticsApi)=>(state, dispatch)=>{
        const cardState = (0, $1fMby.pluginKey).getState(state);
        if (!cardState) return false;
        const tr = state.tr;
        if (request.source !== (0, $g6Qq4.INPUT_METHOD).FLOATING_TB) editorAnalyticsApi === null || editorAnalyticsApi === void 0 || editorAnalyticsApi.attachAnalyticsEvent((0, $6Z6Le.getLinkCreationAnalyticsEvent)(request.source, request.url))(tr);
        (0, $dVt29.addLinkMetadata)(state.selection, tr, {
            action: request.analyticsAction,
            inputMethod: request.source,
            sourceEvent: request.sourceEvent
        });
        if (dispatch) dispatch((0, $k5X6V.resolveCard)(request.url)(tr));
        return true;
    };
/**
 * Per-node walker shared by `queueCardsFromChangedTr` and
 * `queueCardsFromRange`. Pushes a smart-link resolution request for every
 * text node carrying a qualifying `link` mark.
 *
 * Returning `true`/`false` follows the ProseMirror `nodesBetween`/
 * `nodesBetweenChanged` walker contract: `true` to descend into children,
 * `false` to skip subtree.
 */ const $7da2610f190051f1$var$collectLinkRequest = (requests, node, pos, options)=>{
    if (!node.isText) return true;
    const linkMark = node.marks.find((mark)=>mark.type === options.linkMarkType);
    if (linkMark) {
        if (!(0, $19vcu.shouldReplaceLink)(node, options.normalizeLinkText)) return false;
        requests.push({
            url: linkMark.attrs.href,
            pos: pos,
            appearance: options.appearance,
            compareLinkText: options.normalizeLinkText,
            source: options.source,
            analyticsAction: options.analyticsAction,
            sourceEvent: options.sourceEvent
        });
    }
    return false;
};
const $7da2610f190051f1$export$f17c48478174211e = (state, tr, source, analyticsAction, normalizeLinkText = true, sourceEvent, appearance = 'inline')=>{
    const { schema: schema } = state;
    const { link: link } = schema.marks;
    const requests = [];
    const options = {
        analyticsAction: analyticsAction,
        appearance: appearance,
        linkMarkType: link,
        normalizeLinkText: normalizeLinkText,
        source: source,
        sourceEvent: sourceEvent
    };
    (0, $cPyt7.nodesBetweenChanged)(tr, (node, pos)=>$7da2610f190051f1$var$collectLinkRequest(requests, node, pos, options));
    if (analyticsAction) (0, $dVt29.addLinkMetadata)(state.selection, tr, {
        action: analyticsAction
    });
    return (0, $k5X6V.queueCards)(requests)(tr);
};
const $7da2610f190051f1$export$86b4b08ffadfa0a6 = (state, tr, from, to, source, analyticsAction, normalizeLinkText = true, sourceEvent, appearance = 'inline')=>{
    const { schema: schema } = state;
    const { link: link } = schema.marks;
    const requests = [];
    const options = {
        analyticsAction: analyticsAction,
        appearance: appearance,
        linkMarkType: link,
        normalizeLinkText: normalizeLinkText,
        source: source,
        sourceEvent: sourceEvent
    };
    const clampedFrom = Math.max(0, from);
    const clampedTo = Math.min(tr.doc.content.size, to);
    if (clampedFrom < clampedTo) tr.doc.nodesBetween(clampedFrom, clampedTo, (node, pos)=>$7da2610f190051f1$var$collectLinkRequest(requests, node, pos, options));
    if (analyticsAction) (0, $dVt29.addLinkMetadata)(state.selection, tr, {
        action: analyticsAction
    });
    return (0, $k5X6V.queueCards)(requests)(tr);
};
const $7da2610f190051f1$export$717aabd99c4fc685 = (state, tr, source, analyticsAction, normalizeLinkText = true, sourceEvent, previousAppearance)=>{
    const { schema: schema } = state;
    const { link: link } = schema.marks;
    const requests = [];
    (0, $cPyt7.nodesBetweenChanged)(tr, (node, pos)=>{
        if (!node.isText) return true;
        const linkMark = node.marks.find((mark)=>mark.type === link);
        if (linkMark) {
            if (!(0, $19vcu.shouldReplaceLink)(node, normalizeLinkText)) return false;
            requests.push({
                url: linkMark.attrs.href,
                pos: pos,
                appearance: 'inline',
                previousAppearance: previousAppearance,
                compareLinkText: normalizeLinkText,
                source: source,
                analyticsAction: analyticsAction,
                sourceEvent: sourceEvent
            });
        }
        return false;
    });
    (0, $dVt29.addLinkMetadata)(state.selection, tr, {
        action: analyticsAction
    });
    return (0, $k5X6V.queueCards)(requests)(tr);
};
const $7da2610f190051f1$export$c8301558911030d4 = (state, source, appearance, normalizeLinkText = true)=>{
    const { schema: schema } = state;
    const { link: link } = schema.marks;
    const requests = [];
    const createRequest = (linkMark, pos)=>({
            url: linkMark.attrs.href,
            pos: pos,
            appearance: appearance,
            previousAppearance: 'url',
            compareLinkText: normalizeLinkText,
            source: source,
            analyticsAction: (0, $g6Qq4.ACTION).CHANGED_TYPE,
            shouldReplaceLink: true
        });
    if ((0, $797yE.editorExperiment)('platform_editor_controls', 'variant1')) {
        const activeLinkMark = (0, $bk3yN.getActiveLinkMark)(state);
        if (activeLinkMark) {
            const linkMark = activeLinkMark.node.marks.find((mark)=>mark.type === link);
            if (linkMark) requests.push(createRequest(linkMark, activeLinkMark.pos));
        }
    } else state.tr.doc.nodesBetween(state.selection.from, state.selection.to, (node, pos)=>{
        const linkMark = node.marks.find((mark)=>mark.type === link);
        if (linkMark) requests.push(createRequest(linkMark, pos));
    });
    (0, $dVt29.addLinkMetadata)(state.selection, state.tr, {
        action: (0, $g6Qq4.ACTION).CHANGED_TYPE
    });
    return (0, $k5X6V.queueCards)(requests)(state.tr);
};
const $7da2610f190051f1$export$3f14f692ecc2a0d9 = (text, href, sendAnalytics, node, pos, editorAnalyticsApi)=>(state, dispatch)=>{
        const selectedNode = state.selection instanceof (0, $cw0wu.NodeSelection) ? state.selection.node : undefined;
        let tr;
        if (node && pos !== undefined) tr = $7da2610f190051f1$var$cardNodeToLinkWithTransaction(state, text, href, node, pos);
        else tr = $7da2610f190051f1$var$cardToLinkWithTransaction(state, text, href);
        $7da2610f190051f1$var$updateDatasourceStash(tr, selectedNode);
        if (sendAnalytics) {
            if (selectedNode) editorAnalyticsApi === null || editorAnalyticsApi === void 0 || editorAnalyticsApi.attachAnalyticsEvent({
                action: (0, $g6Qq4.ACTION).CHANGED_TYPE,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).SMART_LINK,
                eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
                attributes: {
                    newType: (0, $6vldb.SMART_LINK_TYPE).URL,
                    previousType: (0, $cKhMH.appearanceForNodeType)(selectedNode.type)
                }
            })(tr);
        }
        if (dispatch) dispatch(tr.scrollIntoView());
        return true;
    };
const $7da2610f190051f1$export$56a04318a610dc7c = (text, href, sendAnalytics, node, pos, editorAnalyticsApi)=>(state, dispatch)=>{
        let tr;
        if (node && pos !== undefined) tr = $7da2610f190051f1$var$cardNodeToLinkWithTransaction(state, text, href, node, pos);
        else tr = $7da2610f190051f1$var$cardToLinkWithTransaction(state, text, href);
        if (sendAnalytics) editorAnalyticsApi === null || editorAnalyticsApi === void 0 || editorAnalyticsApi.attachAnalyticsEvent({
            action: (0, $g6Qq4.ACTION).ERRORED,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).SMART_LINK,
            eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL,
            attributes: {
                error: 'Smart card falling back to link.'
            }
        })(tr);
        if (dispatch) dispatch(tr.setMeta('addToHistory', false));
        return true;
    };
const $7da2610f190051f1$export$884fcee347ca969b = (href, sourceEvent)=>(state, dispatch)=>{
        const selectedNode = state.selection instanceof (0, $cw0wu.NodeSelection) && state.selection.node;
        if (!selectedNode) return false;
        const cardAppearance = (0, $cKhMH.selectedCardAppearance)(state);
        const tr = $7da2610f190051f1$var$cardToLinkWithTransaction(state, href, href);
        $7da2610f190051f1$export$717aabd99c4fc685(state, tr, (0, $g6Qq4.INPUT_METHOD).MANUAL, (0, $g6Qq4.ACTION).UPDATED, undefined, sourceEvent, cardAppearance);
        if (dispatch) dispatch(tr.scrollIntoView());
        return true;
    };
function $7da2610f190051f1$var$cardToLinkWithTransaction(state, text, href) {
    const selectedNode = state.selection instanceof (0, $cw0wu.NodeSelection) && state.selection.node;
    if (!selectedNode) return state.tr;
    const { link: link } = state.schema.marks;
    const url = selectedNode.attrs.url || selectedNode.attrs.data.url;
    const tr = state.tr.replaceSelectionWith(state.schema.text(text || url, [
        link.create({
            href: href || url
        })
    ]), false);
    return tr;
}
function $7da2610f190051f1$var$cardNodeToLinkWithTransaction(state, text, href, node, pos) {
    const { link: link } = state.schema.marks;
    const url = node.attrs.url || node.attrs.data.url;
    return state.tr.replaceWith(pos, pos + node.nodeSize, state.schema.text(text || url, [
        link.create({
            href: href || url
        })
    ]));
}
const $7da2610f190051f1$export$23c9e012c8c1ce24 = (text, editorAnalyticsApi)=>(state, dispatch)=>{
        const selectedNode = state.selection instanceof (0, $cw0wu.NodeSelection) && state.selection.node;
        if (!selectedNode) return false;
        const tr = state.tr.replaceSelectionWith(state.schema.text(text), false);
        if (dispatch) {
            (0, $dVt29.addLinkMetadata)(state.selection, tr, {
                action: (0, $g6Qq4.ACTION).UNLINK
            });
            tr.scrollIntoView();
            editorAnalyticsApi === null || editorAnalyticsApi === void 0 || editorAnalyticsApi.attachAnalyticsEvent((0, $ci54V.unlinkPayload)((0, $g6Qq4.ACTION_SUBJECT_ID).CARD_INLINE))(tr);
            dispatch(tr);
        }
        return true;
    };
const $7da2610f190051f1$export$a188ef61ddbb94f = (appearance, editorAnalyticsApi)=>(state, dispatch)=>{
        var _selectedNode$attrs$d, _previousNode$type;
        const selectedNode = state.selection instanceof (0, $cw0wu.NodeSelection) ? state.selection.node : undefined;
        if (!selectedNode) {
            // When there is no selected node, we insert a new one
            // and replace the existing blue link
            const tr = $7da2610f190051f1$export$c8301558911030d4(state, (0, $g6Qq4.INPUT_METHOD).FLOATING_TB, appearance);
            if (dispatch) {
                (0, $dVt29.addLinkMetadata)(state.selection, tr, {
                    action: (0, $g6Qq4.ACTION).CHANGED_TYPE
                });
                dispatch(tr.scrollIntoView());
            }
            return false;
        }
        if ((0, $cKhMH.appearanceForNodeType)(selectedNode.type) === appearance && !selectedNode.attrs.datasource) return false;
        const attrs = $7da2610f190051f1$export$85bb3e53350e35b8(appearance, selectedNode, state.selection.$from.parent.type.name === 'bodiedSyncBlock');
        const { from: from, to: to } = state.selection;
        const nodeType = $7da2610f190051f1$export$8fa45b4ca74a84b6(appearance, state.schema.nodes);
        const tr = state.tr.setNodeMarkup(from, nodeType, attrs, selectedNode.marks);
        // If switching to embed appearance, attempt to use a registered transform command
        // to create an alternative node representation (e.g. a native embed).
        if (appearance === 'embed' && (selectedNode.attrs.url || (_selectedNode$attrs$d = selectedNode.attrs.data) !== null && _selectedNode$attrs$d !== void 0 && _selectedNode$attrs$d.url)) {
            var _cardState$embedCardT;
            const cardState = (0, $1fMby.pluginKey).getState(state);
            const createEmbedCardTransformCommand = cardState === null || cardState === void 0 || (_cardState$embedCardT = cardState.embedCardTransformers) === null || _cardState$embedCardT === void 0 ? void 0 : _cardState$embedCardT.createEmbedCardTransformCommand;
            if (createEmbedCardTransformCommand) {
                const transformCommand = createEmbedCardTransformCommand({
                    editorAnalyticsApi: editorAnalyticsApi,
                    augmentTransaction: (augmentTr)=>{
                        $7da2610f190051f1$var$updateDatasourceStash(augmentTr, selectedNode);
                        editorAnalyticsApi === null || editorAnalyticsApi === void 0 || editorAnalyticsApi.attachAnalyticsEvent({
                            action: (0, $g6Qq4.ACTION).CHANGED_TYPE,
                            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).SMART_LINK,
                            eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
                            attributes: {
                                newType: appearance,
                                previousType: (0, $cKhMH.appearanceForNodeType)(selectedNode.type)
                            }
                        })(augmentTr);
                        (0, $dVt29.addLinkMetadata)(state.selection, augmentTr, {
                            action: (0, $g6Qq4.ACTION).CHANGED_TYPE
                        });
                    }
                });
                if (transformCommand(state, dispatch)) return true;
            }
        }
        $7da2610f190051f1$var$updateDatasourceStash(tr, selectedNode);
        // When the selected card is the last element in the doc we add a new paragraph after it for consistent replacement
        if (tr.doc.nodeSize - 2 === to) tr.insertText(' ', to);
        tr.setSelection((0, $cw0wu.TextSelection).create(tr.doc, to + 1));
        const previousNodePos = from - 1 > 0 ? from - 1 : 0;
        const previousNode = tr.doc.nodeAt(previousNodePos);
        if ((previousNode === null || previousNode === void 0 || (_previousNode$type = previousNode.type) === null || _previousNode$type === void 0 ? void 0 : _previousNode$type.name) === 'paragraph') tr.delete(previousNodePos, from);
        editorAnalyticsApi === null || editorAnalyticsApi === void 0 || editorAnalyticsApi.attachAnalyticsEvent({
            action: (0, $g6Qq4.ACTION).CHANGED_TYPE,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).SMART_LINK,
            eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
            attributes: {
                newType: appearance,
                previousType: (0, $cKhMH.appearanceForNodeType)(selectedNode.type)
            }
        })(tr);
        (0, $dVt29.addLinkMetadata)(state.selection, tr, {
            action: (0, $g6Qq4.ACTION).CHANGED_TYPE
        });
        if (dispatch) dispatch(tr.scrollIntoView());
        return true;
    };
const $7da2610f190051f1$export$8fa45b4ca74a84b6 = (appearance, linkNodes)=>{
    switch(appearance){
        case 'inline':
            return linkNodes.inlineCard;
        case 'block':
            return linkNodes.blockCard;
        case 'embed':
            return linkNodes.embedCard;
    }
};
const $7da2610f190051f1$export$113cdaf1b279f308 = (args)=>{
    const { state: state, node: node, newAdf: newAdf, view: view, sourceEvent: sourceEvent, isDeletingConfig: isDeletingConfig, inputMethod: inputMethod } = args;
    const { tr: tr, selection: { from: from, to: to }, schema: { nodes: schemaNodes } } = state;
    if (newAdf.type === 'blockCard') {
        var _node$attrs, _newAdf$attrs;
        if ((_node$attrs = node.attrs) !== null && _node$attrs !== void 0 && _node$attrs.datasource && (_newAdf$attrs = newAdf.attrs) !== null && _newAdf$attrs !== void 0 && _newAdf$attrs.datasource) {
            var _oldViews$properties, _newViews$properties;
            const newAttrs = newAdf.attrs;
            const oldAttrs = node.attrs;
            const [newViews] = newAttrs.datasource.views ?? [];
            const [oldViews] = oldAttrs.datasource.views ?? [];
            const isColumnChange = !(0, (/*@__PURE__*/$parcel$interopDefault($dMMwa)))(oldViews === null || oldViews === void 0 || (_oldViews$properties = oldViews.properties) === null || _oldViews$properties === void 0 ? void 0 : _oldViews$properties.columns, newViews === null || newViews === void 0 || (_newViews$properties = newViews.properties) === null || _newViews$properties === void 0 ? void 0 : _newViews$properties.columns);
            const isUrlChange = newAttrs.url !== oldAttrs.url;
            const isParametersChange = (0, $gdUUy.fg)('platform_lp_sllv_preserve_assets_columns') && !(0, (/*@__PURE__*/$parcel$interopDefault($dMMwa)))(oldAttrs.datasource.parameters, newAttrs.datasource.parameters);
            if (isColumnChange || isUrlChange || isParametersChange) tr.setNodeMarkup(from, schemaNodes.blockCard, {
                ...oldAttrs,
                ...newAdf.attrs
            });
        } else if (node.type.isText) {
            // url to datasource
            let link;
            state.doc.nodesBetween(from, to, (node, pos)=>{
                // get the actual start position of a link within the node
                const linkMark = node.marks.find((mark)=>mark.type === state.schema.marks.link);
                if (linkMark) {
                    link = {
                        url: linkMark.attrs.href,
                        text: node.text,
                        pos: pos
                    };
                    return false;
                }
                return true;
            });
            if (link) {
                const newNode = schemaNodes.blockCard.createChecked(newAdf.attrs);
                tr.replaceWith(link.pos, link.pos + (link.text || link.url).length, [
                    newNode
                ]);
            }
        } else // inline or blockCard to datasource
        tr.setNodeMarkup(from, schemaNodes.blockCard, newAdf.attrs);
    } else if (newAdf.type === 'inlineCard') // card type to inlineCard
    tr.setNodeMarkup(from, schemaNodes.inlineCard, newAdf.attrs);
    (0, $dVt29.addLinkMetadata)(state.selection, tr, {
        action: (0, $g6Qq4.ACTION).UPDATED,
        sourceEvent: sourceEvent,
        inputMethod: inputMethod
    });
    if (isDeletingConfig) {
        if (typeof node.attrs.url === 'string') (0, $k5X6V.removeDatasourceStash)(tr, node.attrs.url);
    } else (0, $k5X6V.hideDatasourceModal)(tr);
    view.dispatch(tr.scrollIntoView());
};
const $7da2610f190051f1$export$7f7b236478a618df = (state, adf, view, sourceEvent)=>{
    const { tr: tr, selection: { from: from }, schema: { nodes: schemaNodes } } = state;
    const { attrs: attrs, type: type } = adf;
    const schemaNode = type === 'inlineCard' ? schemaNodes.inlineCard : schemaNodes.blockCard;
    const newNode = schemaNode.createChecked(attrs);
    // in future, if we decide to do datasource insertion from the main toolbar, we should probably consider editor-plugin-content-insertion instead of tr.insert
    // this will allow us to deal with insertions from multiple paths in a more consistent way
    newNode && tr.insert(from, newNode);
    (0, $k5X6V.hideDatasourceModal)(tr);
    (0, $dVt29.addLinkMetadata)(state.selection, tr, {
        action: (0, $g6Qq4.ACTION).INSERTED,
        sourceEvent: sourceEvent
    });
    view.dispatch(tr.scrollIntoView());
};
const $7da2610f190051f1$export$85bb3e53350e35b8 = (appearance, selectedNode, isInsideBodiedSyncBlock = false)=>{
    if (appearance === 'embed') return {
        ...selectedNode.attrs,
        layout: 'center',
        ...isInsideBodiedSyncBlock ? // When converting to embed, width attribute is set to null and when the document is published, the width attribute is set to 100 as per schema default
        // For editor, width is not required to render the embed card, but it's required in renderer
        // Because sync block has nested renderer in editor, we need width to be defined even in editor so embed in reference sync block can be rendered properly
        {
            width: selectedNode.attrs.width ?? 100
        } : {}
    };
    if ((0, $cKhMH.isDatasourceNode)(selectedNode)) return {
        url: selectedNode.attrs.url
    };
    return selectedNode.attrs;
};
const $7da2610f190051f1$var$updateDatasourceStash = (tr, selectedNode)=>{
    if ((0, $cKhMH.isDatasourceNode)(selectedNode) && !(0, $cKhMH.isDatasourceConfigEditable)(selectedNode.attrs.datasource.id) && selectedNode.attrs.url) (0, $k5X6V.setDatasourceStash)(tr, {
        url: selectedNode.attrs.url,
        views: selectedNode.attrs.datasource.views
    });
};

});
parcelRegister("6vldb", function(module, exports) {
$parcel$export(module.exports, "LAYOUT_TYPE", () => $91f98c70159b9779$export$9710eda883ce7be2);
$parcel$export(module.exports, "SMART_LINK_TYPE", () => $91f98c70159b9779$export$804a928ffc86c02c);
var $91f98c70159b9779$export$9710eda883ce7be2 = /*#__PURE__*/ function(LAYOUT_TYPE) {
    LAYOUT_TYPE["SINGLE_COL"] = "singleColumn";
    LAYOUT_TYPE["TWO_COLS_EQUAL"] = "twoColumnsEqual";
    LAYOUT_TYPE["THREE_COLS_EQUAL"] = "threeColumnsEqual";
    LAYOUT_TYPE["LEFT_SIDEBAR"] = "twoColumnsLeftSidebar";
    LAYOUT_TYPE["RIGHT_SIDEBAR"] = "twoColumnsRightSidebar";
    LAYOUT_TYPE["THREE_WITH_SIDEBARS"] = "threeColumnsWithSidebars ";
    LAYOUT_TYPE["FOUR_COLS_EQUAL"] = "fourColumnsEqual";
    LAYOUT_TYPE["FIVE_COLS_EQUAL"] = "fiveColumnsEqual";
    return LAYOUT_TYPE;
}({});
var $91f98c70159b9779$export$804a928ffc86c02c = /*#__PURE__*/ function(SMART_LINK_TYPE) {
    SMART_LINK_TYPE["INLINE_CARD"] = "inline";
    SMART_LINK_TYPE["BLOCK_CARD"] = "block";
    SMART_LINK_TYPE["URL"] = "url";
    return SMART_LINK_TYPE;
}({});

});

parcelRegister("dVt29", function(module, exports) {
$parcel$export(module.exports, "addLinkMetadata", () => $5742229f2e25660d$export$e2d4855dca88ecc1);

var $jsWoI = parcelRequire("jsWoI");
function $5742229f2e25660d$export$e2d4855dca88ecc1(initialSelection, tr, metadata) {
    const { storedMarks: storedMarks } = tr;
    const pos = tr.mapping.map(initialSelection.$from.pos);
    tr.step(new (0, $jsWoI.LinkMetaStep)(pos, metadata));
    // When you add a new step all the storedMarks are removed it
    if (storedMarks) tr.setStoredMarks(storedMarks);
    return tr;
}

});
parcelRegister("jsWoI", function(module, exports) {
$parcel$export(module.exports, "LinkMetaStep", () => $eb4863d14c29e892$export$40e33c9d27895078);

var $kW8qW = parcelRequire("kW8qW");

var $3DNV7 = parcelRequire("3DNV7");
parcelRequire("bUbIU");
var $3DNV7 = parcelRequire("3DNV7");
const $eb4863d14c29e892$export$954e3f6aa93d9ba3 = 'editor-linking-meta';
const $eb4863d14c29e892$export$2774298c489a128f = 'editor-linking-meta-invert';
class $eb4863d14c29e892$export$40e33c9d27895078 extends (0, $3DNV7.Step) {
    constructor(pos, metadata, isInverted = false){
        super(), this.pos = pos, this.metadata = metadata, this.isInverted = isInverted;
    }
    getMetadata() {
        return this.metadata;
    }
    /**
   * Generate new undo/redo analytics event when step is inverted
   */ invert() {
        /**
     * Omit sourceEvent in history
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { sourceEvent: sourceEvent, ...metadata } = this.metadata;
        return new $eb4863d14c29e892$export$40e33c9d27895078(this.pos, metadata, true);
    }
    // Should make no modifications to the doc
    apply(doc) {
        return (0, $3DNV7.StepResult).ok(doc);
    }
    map(mapping) {
        let newPos = this.pos;
        if (typeof newPos === 'number') newPos = mapping.map(newPos);
        // Return the same events, this step will never be removed
        return new $eb4863d14c29e892$export$40e33c9d27895078(newPos, this.metadata, this.isInverted);
    }
    getMap() {
        return new (0, $3DNV7.StepMap)([
            this.pos || 0,
            0,
            0
        ]);
    }
    // Return null to avoid merging events
    merge() {
        return null;
    }
    toJSON() {
        // When serialized we should create a noop Replace step
        return {
            stepType: 'replace',
            from: 0,
            to: 0
        };
    }
    static fromJSON() {
        // This is a "local custom step" once serialized
        // we need to transform it in a no-operation action
        return new (0, $3DNV7.ReplaceStep)(0, 0, (0, $kW8qW.Slice).empty);
    }
}
/** Register this step with Prosemirror */ (0, $3DNV7.Step).jsonID($eb4863d14c29e892$export$954e3f6aa93d9ba3, $eb4863d14c29e892$export$40e33c9d27895078);

});


parcelRegister("bk3yN", function(module, exports) {
$parcel$export(module.exports, "getLinkPreferencesURLFromENV", () => $1c5655d3547a165b$export$e5404273592f5dbd);
$parcel$export(module.exports, "getActiveLinkMark", () => $1c5655d3547a165b$export$819e108a65d33088);

var $dLOrv = parcelRequire("dLOrv");

var $797yE = parcelRequire("797yE");

var $eXm5c = parcelRequire("eXm5c");


const $1c5655d3547a165b$var$STAGING = 'staging';
const $1c5655d3547a165b$var$PRODUCTION = 'prod';
const $1c5655d3547a165b$var$DEV = 'dev';
const $1c5655d3547a165b$export$e5404273592f5dbd = ()=>{
    const envType = $1c5655d3547a165b$var$PRODUCTION;
    return (0, $dLOrv.getUrlForDomainInContext)('id', envType) + (0, $eXm5c.linkPreferencesPath);
};
const $1c5655d3547a165b$var$isSelectionInsideLink = (state)=>!!state.doc.type.schema.marks.link.isInSet(state.selection.$from.marks());
const $1c5655d3547a165b$var$isEmptySelectionBeforeLink = (state)=>{
    var _$from$nodeAfter;
    const { $from: $from, $to: $to } = state.selection;
    return $from === $to && !!state.doc.type.schema.marks.link.isInSet(((_$from$nodeAfter = $from.nodeAfter) === null || _$from$nodeAfter === void 0 ? void 0 : _$from$nodeAfter.marks) || []);
};
const $1c5655d3547a165b$var$isEmptySelectionAfterLink = (state)=>{
    var _$from$nodeBefore;
    const { $from: $from, $to: $to } = state.selection;
    return $from === $to && !!state.doc.type.schema.marks.link.isInSet(((_$from$nodeBefore = $from.nodeBefore) === null || _$from$nodeBefore === void 0 ? void 0 : _$from$nodeBefore.marks) || []);
};
const $1c5655d3547a165b$var$isSelectionAroundLink = (state)=>{
    const { $from: $from, $to: $to } = state.selection;
    const node = $from.nodeAfter;
    return !!node && $from.textOffset === 0 && $to.pos - $from.pos === node.nodeSize && !!state.doc.type.schema.marks.link.isInSet(node.marks);
};
const $1c5655d3547a165b$export$819e108a65d33088 = (state)=>{
    const { selection: { $from: $from } } = state;
    if ($1c5655d3547a165b$var$isSelectionInsideLink(state) || $1c5655d3547a165b$var$isSelectionAroundLink(state)) {
        const pos = $from.pos - $from.textOffset;
        const node = state.doc.nodeAt(pos);
        return node && node.isText ? {
            node: node,
            pos: pos
        } : undefined;
    }
    if ($1c5655d3547a165b$var$isEmptySelectionBeforeLink(state) && (0, $797yE.editorExperiment)('platform_editor_controls', 'variant1')) {
        // if user clicks right before the link, we want to show the toolbar for the link
        // but only if the link is a single character
        const node = state.doc.nodeAt($from.pos);
        return node && node.isText && node.nodeSize === 1 ? {
            node: node,
            pos: $from.pos
        } : undefined;
    }
    if ($1c5655d3547a165b$var$isEmptySelectionAfterLink(state) && (0, $797yE.editorExperiment)('platform_editor_controls', 'variant1')) {
        // if user clicks right after the link, we want to show the toolbar for the link
        // but only if the link is a single character
        // and we return the position of the link
        const node = state.doc.nodeAt($from.pos - 1);
        return node && node.isText && node.nodeSize === 1 ? {
            node: node,
            pos: $from.pos - 1
        } : undefined;
    }
    return undefined;
};

});
parcelRegister("eXm5c", function(module, exports) {
$parcel$export(module.exports, "linkPreferencesPath", () => $68480cb6679659bf$export$f0972e90f14682b1);
const $68480cb6679659bf$export$f0972e90f14682b1 = '/manage-profile/link-preferences';

});


parcelRegister("19vcu", function(module, exports) {
$parcel$export(module.exports, "shouldReplaceLink", () => $8c42d16bc2ed7c1e$export$f85e921f66e987fa);

var $9Lnex = parcelRequire("9Lnex");

var $68s4D = parcelRequire("68s4D");
function $8c42d16bc2ed7c1e$export$f85e921f66e987fa(node, compareLinkText = true, compareToUrl) {
    const linkMark = node.marks.find((mark)=>mark.type.name === 'link');
    if (!linkMark) // not a link anymore
    return false;
    // ED-6041: compare normalised link text after linkfy from Markdown transformer
    // instead, since it always decodes URL ('%20' -> ' ') on the link text
    const normalisedHref = (0, $9Lnex.normalizeUrl)((0, $68s4D.md).normalizeLinkText(linkMark.attrs.href));
    const normalizedLinkText = (0, $9Lnex.normalizeUrl)((0, $68s4D.md).normalizeLinkText(node.text || ''));
    if (compareLinkText && normalisedHref !== normalizedLinkText) return false;
    if (compareToUrl) {
        const normalizedUrl = (0, $9Lnex.normalizeUrl)((0, $68s4D.md).normalizeLinkText(compareToUrl));
        if (normalizedUrl !== normalisedHref) return false;
    }
    return true;
}

});
parcelRegister("68s4D", function(module, exports) {
$parcel$export(module.exports, "md", () => $3075890ba81eabe4$export$f4de1c043ce6927);
// File has been copied to packages/editor/editor-plugin-ai/src/provider/markdown-transformer/md/index.ts
// If changes are made to this file, please make the same update in the linked file.

var $kyro8 = parcelRequire("kyro8");

var $apNd0 = parcelRequire("apNd0");

var $kGeF3 = parcelRequire("kGeF3");

var $5VEh9 = parcelRequire("5VEh9");

var $9EuLL = parcelRequire("9EuLL");
const $3075890ba81eabe4$export$f4de1c043ce6927 = (0, $kyro8.default)('zero', {
    html: false
});
$3075890ba81eabe4$export$f4de1c043ce6927.enable([
    // Process html entity - &#123;, &#xAF;, &quot;, ...
    'entity',
    // Process escaped chars and hardbreaks
    'escape',
    'newline'
]);
$3075890ba81eabe4$export$f4de1c043ce6927.use((0, $9EuLL.default));
// enable modified version of linkify plugin
// @see https://product-fabric.atlassian.net/browse/ED-3097
$3075890ba81eabe4$export$f4de1c043ce6927.use((0, $kGeF3.default));
$3075890ba81eabe4$export$f4de1c043ce6927.use((0, $5VEh9.default));
$3075890ba81eabe4$export$f4de1c043ce6927.use((0, $apNd0.default));

});
parcelRegister("apNd0", function(module, exports) {
$parcel$export(module.exports, "default", () => $471c2b46c7a36da1$export$2e2bcd8739ae039);
/*
 * ED-15646
 * Headings in list items are not supported in our schema.
 * As the markdown transformer is used by the paste plugin,
 * certain pastes will strip invalid lines as
 * prosemirror-markdown cannot conform to the schema
 */ function $471c2b46c7a36da1$var$handleHeadingOpen(state, token, acc, index) {
    var _state$tokens;
    const isInListItem = ((_state$tokens = state.tokens[index - 1]) === null || _state$tokens === void 0 ? void 0 : _state$tokens.type) === 'list_item_open';
    if (isInListItem) acc.push(new state.Token('paragraph_open', 'p', 1));
    else acc.push(token);
}
function $471c2b46c7a36da1$var$handleHeadingClose(state, token, acc, index) {
    var _state$tokens2;
    const isInListItem = ((_state$tokens2 = state.tokens[index + 1]) === null || _state$tokens2 === void 0 ? void 0 : _state$tokens2.type) === 'list_item_close';
    if (isInListItem) acc.push(new state.Token('paragraph_close', 'p', -1));
    else acc.push(token);
}
function $471c2b46c7a36da1$export$2e2bcd8739ae039(md) {
    md.core.ruler.after('inline', 'ignore-list-heading-md-plugin', function(state) {
        state.tokens = state.tokens.reduce((acc, token, index)=>{
            const { type: type } = token;
            if (type === 'heading_open') $471c2b46c7a36da1$var$handleHeadingOpen(state, token, acc, index);
            else if (type === 'heading_close') $471c2b46c7a36da1$var$handleHeadingClose(state, token, acc, index);
            else acc.push(token);
            return acc;
        }, []);
    });
}

});

parcelRegister("kGeF3", function(module, exports) {
$parcel$export(module.exports, "default", () => $6f44b33ec58b1cbf$export$2e2bcd8739ae039);
// File has been copied to packages/editor/editor-plugin-ai/src/provider/markdown-transformer/md/linkify-md-plugin.ts
// If changes are made to this file, please make the same update in the linked file.
// See https://product-fabric.atlassian.net/browse/ED-3097 for why this file exists.

var $cAudd = parcelRequire("cAudd");

var $270j3 = parcelRequire("270j3");

var $6Z6Le = parcelRequire("6Z6Le");
var $hhAGP = parcelRequire("hhAGP");
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $6f44b33ec58b1cbf$var$LINK_OPEN_REGEX = /^<a[>\s]/i;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $6f44b33ec58b1cbf$var$LINK_CLOSE_REGEX = /^<\/a\s*>/i;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $6f44b33ec58b1cbf$var$HTTP_PREFIX_REGEX = /^http:\/\//;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $6f44b33ec58b1cbf$var$MAILTO_CASE_INSENSITIVE_REGEX = /^mailto:/i;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $6f44b33ec58b1cbf$var$MAILTO_REGEX = /^mailto:/;
// modified version of the original markdown-it Linkify plugin
// https://github.com/markdown-it/markdown-it/blob/master/lib/rules_core/linkify.js
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $6f44b33ec58b1cbf$var$arrayReplaceAt = (src, pos, newElements)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return [].concat(src.slice(0, pos), newElements, src.slice(pos + 1));
};
const $6f44b33ec58b1cbf$var$isLinkOpen = (str)=>{
    return $6f44b33ec58b1cbf$var$LINK_OPEN_REGEX.test(str);
};
const $6f44b33ec58b1cbf$var$isLinkClose = (str)=>{
    return $6f44b33ec58b1cbf$var$LINK_CLOSE_REGEX.test(str);
};
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $6f44b33ec58b1cbf$var$linkify = (state)=>{
    const blockTokens = state.tokens;
    const linkify = new (0, $cAudd.default)();
    for(let j = 0, l = blockTokens.length; j < l; j++){
        if (blockTokens[j].type !== 'inline' || !linkify.pretest(blockTokens[j].content)) continue;
        let tokens = blockTokens[j].children;
        let htmlLinkLevel = 0;
        // We scan from the end, to keep position when new tags added.
        // Use reversed logic in links start/end match
        for(let i = tokens.length - 1; i >= 0; i--){
            const currentToken = tokens[i];
            // Skip content of markdown links
            if (currentToken.type === 'link_close') {
                i--;
                while(tokens[i].level !== currentToken.level && tokens[i].type !== 'link_open')i--;
                continue;
            }
            // Skip content of html tag links
            if (currentToken.type === 'html_inline') {
                if ($6f44b33ec58b1cbf$var$isLinkOpen(currentToken.content) && htmlLinkLevel > 0) htmlLinkLevel--;
                if ($6f44b33ec58b1cbf$var$isLinkClose(currentToken.content)) htmlLinkLevel++;
            }
            if (htmlLinkLevel > 0) continue;
            if (currentToken.type === 'text' && linkify.test(currentToken.content)) {
                const text = currentToken.content;
                let links = (0, $270j3.linkifyMatch)(text);
                if (!links.length) links = linkify.match(text) || [];
                links = links.filter((link)=>(0, $hhAGP.shouldAutoLinkifyMatch)(link));
                // Now split string to nodes
                const nodes = [];
                let level = currentToken.level;
                let lastPos = 0;
                const filepaths = (0, $6Z6Le.findFilepaths)(text);
                for(let ln = 0; ln < links.length; ln++){
                    if ((0, $6Z6Le.isLinkInMatches)(links[ln].index, filepaths)) continue;
                    const { url: url } = links[ln];
                    const fullUrl = state.md.normalizeLink(url);
                    if (!state.md.validateLink(fullUrl)) continue;
                    let urlText = links[ln].text;
                    // Linkifier might send raw hostnames like "example.com", where url
                    // starts with domain name. So we prepend http:// in those cases,
                    // and remove it afterwards.
                    //
                    if (!links[ln].schema) // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
                    urlText = state.md.normalizeLinkText('http://' + urlText).replace($6f44b33ec58b1cbf$var$HTTP_PREFIX_REGEX, '');
                    else if (links[ln].schema === 'mailto:' && !$6f44b33ec58b1cbf$var$MAILTO_CASE_INSENSITIVE_REGEX.test(urlText)) // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
                    urlText = state.md.normalizeLinkText('mailto:' + urlText).replace($6f44b33ec58b1cbf$var$MAILTO_REGEX, '');
                    else urlText = state.md.normalizeLinkText(urlText);
                    const pos = links[ln].index;
                    if (pos > lastPos) {
                        const token = new state.Token('text', '', 0);
                        token.content = text.slice(lastPos, pos);
                        token.level = level;
                        nodes.push(token);
                    }
                    let token = new state.Token('link_open', 'a', 1);
                    token.attrs = [
                        [
                            'href',
                            fullUrl
                        ]
                    ];
                    token.level = level++;
                    token.markup = 'linkify';
                    token.info = 'auto';
                    nodes.push(token);
                    token = new state.Token('text', '', 0);
                    token.content = urlText;
                    token.level = level;
                    nodes.push(token);
                    token = new state.Token('link_close', 'a', -1);
                    token.level = --level;
                    token.markup = 'linkify';
                    token.info = 'auto';
                    nodes.push(token);
                    lastPos = links[ln].lastIndex;
                }
                if (lastPos < text.length) {
                    const token = new state.Token('text', '', 0);
                    token.content = text.slice(lastPos);
                    token.level = level;
                    nodes.push(token);
                }
                // replace current node
                blockTokens[j].children = tokens = $6f44b33ec58b1cbf$var$arrayReplaceAt(tokens, i, nodes);
            }
        }
    }
};
var // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$6f44b33ec58b1cbf$export$2e2bcd8739ae039 = (md)=>md.core.ruler.push('custom-linkify', $6f44b33ec58b1cbf$var$linkify);

});

parcelRegister("5VEh9", function(module, exports) {
$parcel$export(module.exports, "default", () => $cc40e87be532f301$export$2e2bcd8739ae039);
// File has been copied to packages/editor/editor-plugin-ai/src/provider/markdown-transformer/md/newline-md-plugin.ts
// If changes are made to this file, please make the same update in the linked file.
// ED-15363: modified version of the original newline plugin
// https://github.com/markdown-it/markdown-it/blob/master/lib/rules_inline/newline.js
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $cc40e87be532f301$var$newline = (state, silent)=>{
    let pos = state.pos;
    // ED-15363: unread variables
    // max,
    // ws,
    if (state.src.charCodeAt(pos) !== 0x0a /* \n */ ) return false;
    const pmax = state.pending.length - 1;
    // ED-15363: unread variable
    // max = state.posMax;
    // '  \n' -> hardbreak
    // Lookup in pending chars is bad practice! Don't copy to other rules!
    // Pending string is stored in concat mode, indexed lookups will cause
    // convertion to flat mode.
    if (!silent) {
        if (pmax >= 0 && state.pending.charCodeAt(pmax) === 0x20) {
            if (pmax >= 1 && state.pending.charCodeAt(pmax - 1) === 0x20) // ED-15363: We commented out this logic to preserve trailing whitespaces
            // for each line of text when pasting plain text
            // // Find whitespaces tail of pending chars.
            // ws = pmax - 1;
            // while (ws >= 1 && state.pending.charCodeAt(ws - 1) === 0x20) {
            //   ws--;
            // }
            // state.pending = state.pending.slice(0, ws);
            state.push('hardbreak', 'br', 0);
            else {
                state.pending = state.pending.slice(0, -1);
                state.push('softbreak', 'br', 0);
            }
        } else state.push('softbreak', 'br', 0);
    }
    pos++;
    // ED-15363: We commented out this logic from the original library to
    // preserve leading whitespaces for each line of text when pasting plain
    // text (to preserve whitespace-based indentation).
    // // skip heading spaces for next line
    // while (pos < max && isSpace(state.src.charCodeAt(pos))) {
    //   pos++;
    // }
    state.pos = pos;
    return true;
};
var // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$cc40e87be532f301$export$2e2bcd8739ae039 = (md)=>md.inline.ruler.at('newline', $cc40e87be532f301$var$newline);

});

parcelRegister("9EuLL", function(module, exports) {
$parcel$export(module.exports, "default", () => $c2487070faad81f8$export$2e2bcd8739ae039);
// File has been copied to packages/editor/editor-plugin-ai/src/provider/markdown-transformer/md/paragraph-md-plugin.ts
// If changes are made to this file, please make the same update in the linked file.
// ED-15363: modified version of the original paragraph plugin
// https://github.com/markdown-it/markdown-it/blob/master/lib/rules_block/paragraph.js
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $c2487070faad81f8$var$paragraph = (state, startLine)=>{
    let terminate, i, l, token, nextLine = startLine + 1;
    const terminatorRules = state.md.block.ruler.getRules('paragraph');
    const endLine = state.lineMax;
    const oldParentType = state.parentType;
    state.parentType = 'paragraph';
    // jump line-by-line until empty one or EOF
    for(; nextLine < endLine && !state.isEmpty(nextLine); nextLine++){
        // this would be a code block normally, but after paragraph
        // it's considered a lazy continuation regardless of what's there
        if (state.sCount[nextLine] - state.blkIndent > 3) continue;
        // quirk for blockquotes, this line should already be checked by that rule
        if (state.sCount[nextLine] < 0) continue;
        // Some tags can terminate paragraph without empty line.
        terminate = false;
        for(i = 0, l = terminatorRules.length; i < l; i++)if (terminatorRules[i](state, nextLine, endLine, true)) {
            terminate = true;
            break;
        }
        if (terminate) break;
    }
    // ED-15363: We removed .trim() from this logic from the original library to
    // preserve leading whitespaces at the beginning and end of paragraph blocks
    // when pasting plain text (to preserve whitespace-based indentation, at the
    // beginning and end of paragraphs).
    // content = state.getLines(startLine, nextLine, state.blkIndent, false) .trim()
    const content = state.getLines(startLine, nextLine, state.blkIndent, false);
    state.line = nextLine;
    token = state.push('paragraph_open', 'p', 1);
    token.map = [
        startLine,
        state.line
    ];
    token = state.push('inline', '', 0);
    token.content = content;
    token.map = [
        startLine,
        state.line
    ];
    token.children = [];
    token = state.push('paragraph_close', 'p', -1);
    state.parentType = oldParentType;
    return true;
};
var // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$c2487070faad81f8$export$2e2bcd8739ae039 = (md)=>md.block.ruler.at('paragraph', $c2487070faad81f8$var$paragraph);

});



parcelRegister("cKhMH", function(module, exports) {
$parcel$export(module.exports, "appearanceForNodeType", () => $605b458d01796064$export$71376de76fa352d1);
$parcel$export(module.exports, "selectedCardAppearance", () => $605b458d01796064$export$a5ff7aecd33e6813);
$parcel$export(module.exports, "titleUrlPairFromNode", () => $605b458d01796064$export$15bc29504ff06986);
$parcel$export(module.exports, "displayInfoForCard", () => $605b458d01796064$export$a6fcef6250c64f76);
$parcel$export(module.exports, "findCardInfo", () => $605b458d01796064$export$f3f2332ef0853029);
$parcel$export(module.exports, "isEmbedSupportedAtPosition", () => $605b458d01796064$export$b31d21baab1bb9f);
$parcel$export(module.exports, "isBlockSupportedAtPosition", () => $605b458d01796064$export$290208dc31723a19);
$parcel$export(module.exports, "getResolvedAttributesFromStore", () => $605b458d01796064$export$a0e5429851d8d8a9);
$parcel$export(module.exports, "isDatasourceConfigEditable", () => $605b458d01796064$export$c677d64dd26b7aa2);
$parcel$export(module.exports, "isDatasourceNode", () => $605b458d01796064$export$962cfe99b8da8614);
$parcel$export(module.exports, "focusEditorView", () => $605b458d01796064$export$bab6ff782a349bd3);
$parcel$export(module.exports, "getAwarenessProps", () => $605b458d01796064$export$ea8b03e32bcc0b2d);

var $kW8qW = parcelRequire("kW8qW");

var $cw0wu = parcelRequire("cw0wu");

var $8Er4C = parcelRequire("8Er4C");

var $a2Ugg = parcelRequire("a2Ugg");

var $6yEAN = parcelRequire("6yEAN");

var $ka4gR = parcelRequire("ka4gR");

var $1fMby = parcelRequire("1fMby");
const $605b458d01796064$export$71376de76fa352d1 = (spec)=>{
    if (spec.name === 'inlineCard') return 'inline';
    else if (spec.name === 'blockCard') return 'block';
    else if (spec.name === 'embedCard') return 'embed';
    return;
};
const $605b458d01796064$export$a5ff7aecd33e6813 = (state)=>{
    if (state.selection instanceof (0, $cw0wu.NodeSelection)) return $605b458d01796064$export$71376de76fa352d1(state.selection.node.type);
};
const $605b458d01796064$export$15bc29504ff06986 = (node)=>{
    const { attrs: attrs } = node;
    return {
        url: attrs.url || attrs.data && attrs.data.url,
        title: attrs.data && attrs.data.title
    };
};
const $605b458d01796064$export$fe497395c317d106 = (titleUrlPair, info)=>{
    return {
        title: info && info.title || titleUrlPair.title,
        url: info && info.url || titleUrlPair.url
    };
};
const $605b458d01796064$export$a6fcef6250c64f76 = (node, info)=>$605b458d01796064$export$fe497395c317d106($605b458d01796064$export$15bc29504ff06986(node), info);
const $605b458d01796064$export$f3f2332ef0853029 = (state)=>{
    const pluginState = (0, $1fMby.pluginKey).getState(state);
    if (!pluginState) return undefined;
    return pluginState.cards.find((cardInfo)=>cardInfo.pos === state.selection.from);
};
const $605b458d01796064$var$isAppearanceSupportedInParent = (currentNodePosition, editorState, fragment, currentAppearance)=>{
    const resolvedPosition = editorState.doc.resolve(currentNodePosition);
    const parent = currentAppearance === 'embed' || currentAppearance === 'block' ? resolvedPosition.node() : resolvedPosition.node(-1);
    return parent && parent.type.validContent(fragment);
};
const $605b458d01796064$export$b31d21baab1bb9f = (currentNodePosition, editorState, currentAppearance)=>$605b458d01796064$var$isAppearanceSupportedInParent(currentNodePosition, editorState, (0, $kW8qW.Fragment).from(editorState.schema.nodes.embedCard.createChecked({})), currentAppearance);
const $605b458d01796064$export$290208dc31723a19 = (currentNodePosition, editorState, currentAppearance)=>$605b458d01796064$var$isAppearanceSupportedInParent(currentNodePosition, editorState, (0, $kW8qW.Fragment).from(editorState.schema.nodes.blockCard.createChecked({})), currentAppearance);
const $605b458d01796064$export$a0e5429851d8d8a9 = (url, display, store)=>{
    if (!store) return {};
    const urlState = store === null || store === void 0 ? void 0 : store.getState()[url];
    const displayCategory = display === 'url' ? 'link' : undefined;
    return (0, $8Er4C.getResolvedAttributes)({
        url: url,
        displayCategory: displayCategory
    }, urlState === null || urlState === void 0 ? void 0 : urlState.details);
};
const $605b458d01796064$export$c677d64dd26b7aa2 = (datasourceId)=>{
    const datasourcesWithConfigModal = [
        (0, $ka4gR.JIRA_LIST_OF_LINKS_DATASOURCE_ID),
        (0, $a2Ugg.ASSETS_LIST_OF_LINKS_DATASOURCE_ID),
        (0, $6yEAN.CONFLUENCE_SEARCH_DATASOURCE_ID)
    ];
    return datasourcesWithConfigModal.includes(datasourceId);
};
const $605b458d01796064$export$48ba7bd006cffb5e = (attrs)=>{
    // Check is attributes object
    if (!(typeof attrs === 'object' && attrs !== null)) return false;
    // Check datasource attribute is an object
    if (!('datasource' in attrs)) return false;
    if (typeof attrs.datasource !== 'object' || attrs.datasource === null) return false;
    const hasId = 'id' in attrs.datasource && typeof attrs.datasource.id === 'string';
    const hasParameters = 'parameters' in attrs.datasource && typeof attrs.datasource.parameters === 'object' && attrs.datasource.parameters !== null && !Array.isArray(attrs.datasource.parameters);
    const hasViews = 'views' in attrs.datasource && Array.isArray(attrs.datasource.views);
    return hasId && hasParameters && hasViews;
};
const $605b458d01796064$export$962cfe99b8da8614 = (node)=>{
    if (!node) return false;
    return node.type.name === 'blockCard' && $605b458d01796064$export$48ba7bd006cffb5e(node.attrs);
};
const $605b458d01796064$export$bab6ff782a349bd3 = (editorView)=>{
    if (!editorView.hasFocus()) editorView.focus();
};
const $605b458d01796064$export$ea8b03e32bcc0b2d = (editorState, getPos, allowEmbeds, allowBlockCards, disableOverlay = false)=>{
    var _editorState$selectio, _editorState$selectio2;
    const getPosFunction = typeof getPos !== 'boolean' ? getPos : undefined;
    const linkPosition = getPosFunction === null || getPosFunction === void 0 ? void 0 : getPosFunction();
    const canBeUpgradedToEmbed = !!linkPosition && allowEmbeds ? $605b458d01796064$export$b31d21baab1bb9f(linkPosition, editorState, 'inline') : false;
    const canBeUpgradedToBlock = !!linkPosition && allowBlockCards ? $605b458d01796064$export$290208dc31723a19(linkPosition, editorState, 'inline') : false;
    const isSelected = editorState.selection instanceof (0, $cw0wu.NodeSelection) && ((_editorState$selectio = editorState.selection) === null || _editorState$selectio === void 0 || (_editorState$selectio = _editorState$selectio.node) === null || _editorState$selectio === void 0 ? void 0 : _editorState$selectio.type) === editorState.schema.nodes.inlineCard && ((_editorState$selectio2 = editorState.selection) === null || _editorState$selectio2 === void 0 ? void 0 : _editorState$selectio2.from) === (getPosFunction === null || getPosFunction === void 0 ? void 0 : getPosFunction());
    return {
        isPulseEnabled: canBeUpgradedToEmbed,
        isOverlayEnabled: !disableOverlay && (canBeUpgradedToEmbed || canBeUpgradedToBlock),
        isSelected: isSelected
    };
};

});


parcelRegister("f6kwz", function(module, exports) {
$parcel$export(module.exports, "cardKeymap", () => $f85137ee056d035f$export$fc7a7a088775f35d);

var $jxkn6 = parcelRequire("jxkn6");

var $cv8id = parcelRequire("cv8id");

var $ejrfk = parcelRequire("ejrfk");

var $cw0wu = parcelRequire("cw0wu");

var $gab48 = parcelRequire("gab48");
const $f85137ee056d035f$var$lookupPixel = 10;
const $f85137ee056d035f$var$getClosestInlineCardPos = (state, editorView, direction)=>{
    var _editorView$posAtCoor;
    const { selection: selection } = state;
    const { parent: parent } = selection.$from;
    const inlineCardType = state.schema.nodes.inlineCard;
    if (!(0, $gab48.flatten)(parent, false).some(({ node: node })=>node.type === inlineCardType)) return null;
    const coord = editorView.coordsAtPos(selection.$anchor.pos);
    const nearPos = (_editorView$posAtCoor = editorView.posAtCoords({
        left: coord.left,
        top: direction === 'up' ? coord.top - $f85137ee056d035f$var$lookupPixel : coord.bottom + $f85137ee056d035f$var$lookupPixel
    })) === null || _editorView$posAtCoor === void 0 ? void 0 : _editorView$posAtCoor.inside;
    if (typeof nearPos === 'number' && nearPos > -1) {
        const newNode = state.doc.nodeAt(nearPos);
        if (newNode) {
            if (newNode.type !== inlineCardType || (0, $gab48.findChildren)(parent, (node)=>node === newNode, false).length === 0 || newNode === selection.node) return null;
            return nearPos;
        }
    }
    return null;
};
const $f85137ee056d035f$var$selectAboveBelowInlineCard = (direction)=>{
    return (state, dispatch, editorView)=>{
        if (!editorView || !dispatch) return false;
        const pos = $f85137ee056d035f$var$getClosestInlineCardPos(state, editorView, direction);
        if (pos) {
            dispatch(state.tr.setSelection(new (0, $cw0wu.NodeSelection)(state.doc.resolve(pos))));
            return true;
        }
        return false;
    };
};
function $f85137ee056d035f$export$fc7a7a088775f35d(featureFlags) {
    const list = {};
    const browser = (0, $jxkn6.getBrowserInfo)();
    // https://bugs.chromium.org/p/chromium/issues/detail?id=1227468 introduced since Chrome 91
    if (browser.chrome && browser.chrome_version > 90) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $cv8id.bindKeymapWithCommand)((0, $cv8id.moveUp).common, $f85137ee056d035f$var$selectAboveBelowInlineCard('up'), list);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $cv8id.bindKeymapWithCommand)((0, $cv8id.moveDown).common, $f85137ee056d035f$var$selectAboveBelowInlineCard('down'), list);
    }
    return (0, $ejrfk.keymap)(list);
}

});

parcelRegister("3Qw5l", function(module, exports) {
$parcel$export(module.exports, "createPlugin", () => $7850e57426a54bab$export$ae829ec7b2625219);

var $9wZWu = parcelRequire("9wZWu");

var $bkZOB = parcelRequire("bkZOB");

var $7lseo = parcelRequire("7lseo");

var $f7Kk4 = parcelRequire("f7Kk4");

var $eacW2 = parcelRequire("eacW2");

var $cw0wu = parcelRequire("cw0wu");

var $gab48 = parcelRequire("gab48");

var $iyAOY = parcelRequire("iyAOY");

var $3y2s4 = parcelRequire("3y2s4");

var $7ZryX = parcelRequire("7ZryX");

var $5QVr6 = parcelRequire("5QVr6");

var $4iI1W = parcelRequire("4iI1W");

var $cymkt = parcelRequire("cymkt");

var $4ENMR = parcelRequire("4ENMR");

var $eusna = parcelRequire("eusna");

var $a2gwZ = parcelRequire("a2gwZ");

var $k5X6V = parcelRequire("k5X6V");

var $1fMby = parcelRequire("1fMby");

var $bckCt = parcelRequire("bckCt");

var $aZzYb = parcelRequire("aZzYb");

var $9R86V = parcelRequire("9R86V");

var $cKhMH = parcelRequire("cKhMH");
const $7850e57426a54bab$var$LOCAL_STORAGE_DISCOVERY_KEY_SMART_LINK = 'smart-link-upgrade-pulse';
// Only the first resolved inline smart link is needed for PO spotlight targeting
const $7850e57426a54bab$var$MAX_RESOLVED_INLINE_SMART_LINKS = 1;
const $7850e57426a54bab$var$handleAwarenessOverlay = (view)=>{
    const currentState = (0, $9R86V.getPluginState)(view.state);
    const overlayCandidatePos = currentState === null || currentState === void 0 ? void 0 : currentState.overlayCandidatePosition;
    if (overlayCandidatePos) {
        var _currentState$removeO;
        (_currentState$removeO = currentState.removeOverlay) === null || _currentState$removeO === void 0 || _currentState$removeO.call(currentState);
        const tr = view.state.tr;
        (0, $k5X6V.clearOverlayCandidate)(tr);
        view.dispatch(tr);
    }
};
const $7850e57426a54bab$export$ae829ec7b2625219 = (options, pluginInjectionApi)=>(pmPluginFactoryParams)=>{
        const { editorAppearance: editorAppearance, allowResizing: allowResizing, useAlternativePreloader: useAlternativePreloader, fullWidthMode: fullWidthMode, actionOptions: actionOptions, cardPluginEvents: cardPluginEvents, showUpgradeDiscoverability: showUpgradeDiscoverability, allowEmbeds: allowEmbeds, allowBlockCards: allowBlockCards, onClickCallback: onClickCallback, isPageSSRed: isPageSSRed, provider: provider, CompetitorPrompt: CompetitorPrompt, smartCardContext: smartCardContext, embedCardTransformers: embedCardTransformers } = options;
        const intl = pmPluginFactoryParams.getIntl();
        const enableInlineUpgradeFeatures = !!showUpgradeDiscoverability;
        const inlineCardViewProducer = (0, $bkZOB.getInlineNodeViewProducer)({
            pmPluginFactoryParams: pmPluginFactoryParams,
            Component: (0, $4iI1W.InlineCardNodeView),
            extraComponentProps: {
                useAlternativePreloader: useAlternativePreloader,
                actionOptions: actionOptions,
                enableInlineUpgradeFeatures: enableInlineUpgradeFeatures,
                allowEmbeds: allowEmbeds,
                allowBlockCards: allowBlockCards,
                pluginInjectionApi: pluginInjectionApi,
                onClickCallback: onClickCallback,
                isPageSSRed: isPageSSRed,
                provider: provider,
                CompetitorPrompt: (0, $7lseo.isSSR)() ? undefined : CompetitorPrompt,
                intl: intl,
                smartCardContext: smartCardContext
            }
        });
        return new (0, $f7Kk4.SafePlugin)({
            state: {
                init () {
                    return {
                        requests: [],
                        provider: null,
                        cards: [],
                        datasourceStash: {},
                        resolvedToolbarAttributesByUrl: {},
                        showLinkingToolbar: false,
                        smartLinkEvents: undefined,
                        editorAppearance: editorAppearance,
                        embedCardTransformers: embedCardTransformers,
                        showDatasourceModal: false,
                        datasourceModalType: undefined,
                        datasourceTableRef: undefined,
                        layout: undefined
                    };
                },
                apply (tr, pluginState, prevEditorState) {
                    var _pluginState$requests, _pluginState$requests2;
                    // Update all the positions of outstanding requests and
                    // cards in the plugin state.
                    const pluginStateWithUpdatedPos = (0, $9R86V.getPluginStateWithUpdatedPos)(pluginState, tr);
                    // apply any actions
                    const meta = tr.getMeta((0, $1fMby.pluginKey));
                    if (cardPluginEvents) {
                        const events = (0, $4ENMR.eventsFromTransaction)(tr, prevEditorState);
                        cardPluginEvents.push(...events);
                    }
                    if (!meta) {
                        if (pluginState.datasourceTableRef) {
                            if (!(tr.selection instanceof (0, $cw0wu.NodeSelection)) || !tr.selection.node.attrs.datasource) // disable resize button when switching from datasource to block card
                            return {
                                ...pluginStateWithUpdatedPos,
                                datasourceTableRef: undefined
                            };
                        }
                    }
                    if (!meta) return pluginStateWithUpdatedPos;
                    const newState = (0, $bckCt.default)(pluginStateWithUpdatedPos, meta);
                    // Track the first resolved inline smart link for PO spotlight DOM targeting
                    if (meta.type === 'RESOLVE' && pluginState !== null && pluginState !== void 0 && (_pluginState$requests = pluginState.requests) !== null && _pluginState$requests !== void 0 && _pluginState$requests.length) {
                        const resolvedRequest = pluginState.requests.find((req)=>req.url === meta.url);
                        if ((resolvedRequest === null || resolvedRequest === void 0 ? void 0 : resolvedRequest.appearance) === 'inline') {
                            var _newState$resolvedInl;
                            if ((((_newState$resolvedInl = newState.resolvedInlineSmartLinks) === null || _newState$resolvedInl === void 0 ? void 0 : _newState$resolvedInl.length) ?? 0) < $7850e57426a54bab$var$MAX_RESOLVED_INLINE_SMART_LINKS) newState.resolvedInlineSmartLinks = [
                                ...newState.resolvedInlineSmartLinks ?? [],
                                {
                                    pos: resolvedRequest.pos,
                                    url: resolvedRequest.url,
                                    source: resolvedRequest.source
                                }
                            ];
                        }
                    }
                    if (!enableInlineUpgradeFeatures) return newState;
                    // the code below is related to the "Inline Switcher" project, for more information pls see EDM-7984
                    const isSingleInlineLink = (pluginState === null || pluginState === void 0 || (_pluginState$requests2 = pluginState.requests) === null || _pluginState$requests2 === void 0 ? void 0 : _pluginState$requests2.length) === 1 && pluginState.requests[0].appearance === 'inline';
                    const isSmartLinkPulseDiscovered = (0, $a2gwZ.isLocalStorageKeyDiscovered)($7850e57426a54bab$var$LOCAL_STORAGE_DISCOVERY_KEY_SMART_LINK);
                    if (meta.type !== 'RESOLVE' || !isSingleInlineLink) return newState;
                    const linkPosition = pluginState.requests[0].pos;
                    const canBeUpgradedToBlock = allowBlockCards && (0, $cKhMH.isBlockSupportedAtPosition)(linkPosition, prevEditorState, 'inline');
                    const canBeUpgradedToEmbed = allowEmbeds && (0, $cKhMH.isEmbedSupportedAtPosition)(linkPosition, prevEditorState, 'inline');
                    if (canBeUpgradedToBlock || canBeUpgradedToEmbed) newState.overlayCandidatePosition = linkPosition;
                    if (!isSmartLinkPulseDiscovered && canBeUpgradedToEmbed) newState.inlineCardAwarenessCandidatePosition = linkPosition;
                    return newState;
                }
            },
            filterTransaction (tr) {
                const isOutsideClicked = tr.getMeta('outsideProsemirrorEditorClicked');
                if (isOutsideClicked) {
                    const isInlineEditingActive = document.getElementById('sllv-active-inline-edit');
                    if (isInlineEditingActive) return false;
                }
                return true;
            },
            view (view) {
                const domAtPos = view.domAtPos.bind(view);
                const rafCancellationCallbacks = [];
                if (options.provider) (0, $aZzYb.handleProvider)('cardProvider', options.provider, view);
                return {
                    update (view, prevState) {
                        var _selection$node;
                        const currentState = (0, $9R86V.getPluginState)(view.state);
                        const oldState = (0, $9R86V.getPluginState)(prevState);
                        const { state: state, dispatch: dispatch } = view;
                        const { selection: selection, tr: tr, schema: schema } = state;
                        const isBlockCardSelected = selection instanceof (0, $cw0wu.NodeSelection) && ((_selection$node = selection.node) === null || _selection$node === void 0 ? void 0 : _selection$node.type) === schema.nodes.blockCard;
                        if (isBlockCardSelected) {
                            var _findDomRefAtPos, _node$attrs;
                            // Ignored via go/ees005
                            // eslint-disable-next-line @atlaskit/editor/no-as-casting
                            const datasourceTableRef = // Ignored via go/ees005
                            // eslint-disable-next-line @atlaskit/editor/no-as-casting
                            (_findDomRefAtPos = (0, $gab48.findDomRefAtPos)(selection.from, domAtPos)) === null || _findDomRefAtPos === void 0 ? void 0 : _findDomRefAtPos.querySelector(`.${(0, $eacW2.DATASOURCE_INNER_CONTAINER_CLASSNAME)}`);
                            const { node: node } = selection;
                            const isDatasource = !!(node !== null && node !== void 0 && (_node$attrs = node.attrs) !== null && _node$attrs !== void 0 && _node$attrs.datasource);
                            const shouldUpdateTableRef = datasourceTableRef && (currentState === null || currentState === void 0 ? void 0 : currentState.datasourceTableRef) !== datasourceTableRef;
                            if (isDatasource && shouldUpdateTableRef) {
                                // since we use the plugin state, which is a shared state, we need to update the datasourceTableRef, layout on each selection
                                const layout = (0, $eusna.isDatasourceTableLayout)(node.attrs.layout) ? node.attrs.layout : (0, $iyAOY.DATASOURCE_DEFAULT_LAYOUT);
                                const isNested = selection.$anchor.depth > 0;
                                // we want to disable resize button when datasource table is nested by not setting then datasourceTableRef on selection
                                if (!isNested) // we use cardAction to set the same meta, hence, we will need to combine both layout+datasourceTableRef in one transaction
                                dispatch((0, $k5X6V.setCardLayoutAndDatasourceTableRef)({
                                    datasourceTableRef: datasourceTableRef,
                                    layout: layout
                                })(tr));
                            }
                        } else if (currentState !== null && currentState !== void 0 && currentState.datasourceTableRef) dispatch((0, $k5X6V.setDatasourceTableRef)(undefined)(tr));
                        if (currentState && currentState.provider) {
                            // Find requests in this state that weren't in the old one.
                            const newRequests = (0, $9R86V.getNewRequests)(oldState, currentState);
                            // Ask the CardProvider to resolve all new requests.
                            const { provider: provider } = currentState;
                            newRequests.forEach((request)=>{
                                /**
               * Queue each asynchronous resolve request on separate frames.
               * ---
               * NB: The promise for each request is queued to take place on separate animation frames. This avoids
               * the scenario debugged and discovered in EDM-668, wherein the queuing of too many promises in quick succession
               * leads to the browser's macrotask queue being overwhelmed, locking interactivity of the browser tab.
               * By using this approach, the browser is free to schedule the resolution of the promises below in between rendering/network/
               * other tasks as per common implementations of the JavaScript event loop in browsers.
               */ const invoke = (0, $9wZWu.default)(()=>{
                                    var _pluginInjectionApi$a, _pluginInjectionApi$a2, _currentState$embedCa;
                                    if ((0, $3y2s4.isExperimentEnabled)('platform_editor_reduce_memory_leaks')) {
                                        const index = rafCancellationCallbacks.indexOf(invoke.cancel);
                                        if (index !== -1) rafCancellationCallbacks.splice(index, 1);
                                    }
                                    (0, $aZzYb.resolveWithProvider)(view, provider, request, options, pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$a = pluginInjectionApi.analytics) === null || _pluginInjectionApi$a === void 0 ? void 0 : _pluginInjectionApi$a.actions, (pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$a2 = pluginInjectionApi.analytics) === null || _pluginInjectionApi$a2 === void 0 || (_pluginInjectionApi$a2 = _pluginInjectionApi$a2.sharedState.currentState()) === null || _pluginInjectionApi$a2 === void 0 ? void 0 : _pluginInjectionApi$a2.createAnalyticsEvent) ?? undefined, currentState === null || currentState === void 0 || (_currentState$embedCa = currentState.embedCardTransformers) === null || _currentState$embedCa === void 0 ? void 0 : _currentState$embedCa.embedCardNodeTransformer);
                                });
                                rafCancellationCallbacks.push(invoke.cancel);
                                invoke();
                            });
                        }
                        /**
           * If there have been any events queued, flush them
           * so subscribers can now be notified and dispatch
           * analytics events
           */ cardPluginEvents === null || cardPluginEvents === void 0 || cardPluginEvents.flush();
                    },
                    destroy () {
                        // Cancel any outstanding raf callbacks.
                        rafCancellationCallbacks.forEach((cancellationCallback)=>cancellationCallback());
                    }
                };
            },
            props: {
                nodeViews: {
                    inlineCard: (0, $cymkt.lazyInlineCardView)({
                        inlineCardViewProducer: inlineCardViewProducer,
                        isPageSSRed: isPageSSRed
                    }),
                    blockCard: (0, $7ZryX.blockCardNodeView)({
                        pmPluginFactoryParams: pmPluginFactoryParams,
                        actionOptions: actionOptions,
                        pluginInjectionApi: pluginInjectionApi,
                        onClickCallback: onClickCallback,
                        allowDatasource: options.allowDatasource,
                        inlineCardViewProducer: inlineCardViewProducer,
                        isPageSSRed: isPageSSRed,
                        provider: provider,
                        CompetitorPrompt: (0, $7lseo.isSSR)() ? undefined : options.CompetitorPrompt,
                        intl: intl,
                        smartCardContext: smartCardContext
                    }),
                    embedCard: (0, $5QVr6.embedCardNodeView)({
                        allowResizing: allowResizing,
                        fullWidthMode: fullWidthMode,
                        pmPluginFactoryParams: pmPluginFactoryParams,
                        pluginInjectionApi: pluginInjectionApi,
                        actionOptions: actionOptions,
                        onClickCallback: options.onClickCallback,
                        isPageSSRed: isPageSSRed,
                        provider: provider,
                        CompetitorPrompt: (0, $7lseo.isSSR)() ? undefined : options.CompetitorPrompt,
                        intl: intl,
                        smartCardContext: smartCardContext
                    })
                },
                ...enableInlineUpgradeFeatures && {
                    handleKeyDown: (view)=>{
                        $7850e57426a54bab$var$handleAwarenessOverlay(view);
                        return false;
                    },
                    handleClick: (view)=>{
                        $7850e57426a54bab$var$handleAwarenessOverlay(view);
                        return false;
                    }
                }
            },
            key: (0, $1fMby.pluginKey)
        });
    };

});
parcelRegister("bkZOB", function(module, exports) {
$parcel$export(module.exports, "getInlineNodeViewProducer", () => $969e7ba7959fd6a0$export$17a8c3162956317d);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $kW8qW = parcelRequire("kW8qW");

var $g6Qq4 = parcelRequire("g6Qq4");

var $7lseo = parcelRequire("7lseo");

var $iUiGU = parcelRequire("iUiGU");

var $lrWkt = parcelRequire("lrWkt");

var $jxkn6 = parcelRequire("jxkn6");

var $kuD5k = parcelRequire("kuD5k");

var $3UrUG = parcelRequire("3UrUG");

var $8crSL = parcelRequire("8crSL");
const $969e7ba7959fd6a0$export$dfb58b577a6f1cd9 = 'inlineNodeView';
const $969e7ba7959fd6a0$var$canRenderFallback = (node)=>{
    return node.type.isInline && node.type.isAtom && node.type.isLeaf;
};
// list of inline nodes with toDOM fallback implementations that can be virtualized. As
// additional nodes are converted they should be added here
const $969e7ba7959fd6a0$var$virtualizedNodeAllowlist = [
    'inlineCard'
];
function $969e7ba7959fd6a0$var$createNodeView({ nodeViewParams: nodeViewParams, pmPluginFactoryParams: pmPluginFactoryParams, Component: Component, extraComponentProps: extraComponentProps, extraNodeViewProps: extraNodeViewProps }) {
    // We set a variable for the current node which is
    // used for comparisions when doing updates, before being
    // overwritten to the updated node.
    let currentNode = nodeViewParams.node;
    const key = (0, $3UrUG.generateUniqueNodeKey)();
    // First we setup the dom element which will be rendered and "tracked" by prosemirror
    // and also used as a "editor portal" (not react portal) target by the editor
    // portal provider api, for rendering the Component passed.
    let domRef = document.createElement('span');
    domRef.contentEditable = 'false';
    $969e7ba7959fd6a0$var$setDomAttrs(nodeViewParams.node, domRef);
    const fallbackRef = {
        current: null
    };
    // @see ED-3790
    // something gets messed up during mutation processing inside of a
    // nodeView if DOM structure has nested plain "div"s, it doesn't see the
    // difference between them and it kills the nodeView
    domRef.classList.add(`${nodeViewParams.node.type.name}View-content-wrap`, `${$969e7ba7959fd6a0$export$dfb58b577a6f1cd9}`);
    // This util is shared for tracking rendering, and the ErrorBoundary that
    // is setup to wrap the Component when rendering
    // NOTE: This is not a prosemirror dispatch
    function dispatchAnalyticsEvent(payload) {
        pmPluginFactoryParams.eventDispatcher.emit((0, $lrWkt.analyticsEventKey), {
            payload: payload
        });
    }
    // This is called to render the Component into domRef which is inside the
    // prosemirror View.
    // Internally it uses the unstable_renderSubtreeIntoContainer api to render,
    // to the passed dom element (domRef) which means it is automatically
    // "cleaned up" when you do a "re render".
    function renderComponent() {
        pmPluginFactoryParams.portalProviderAPI.render($969e7ba7959fd6a0$var$getPortalChildren({
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            currentNode: currentNode,
            nodeViewParams: nodeViewParams,
            Component: Component,
            extraComponentProps: extraComponentProps
        }), domRef, key);
    }
    // We render the component while creating the node view
    renderComponent();
    const extraNodeViewPropsWithStopEvent = {
        ...extraNodeViewProps
    };
    // https://prosemirror.net/docs/ref/#view.NodeView
    const nodeView = {
        get dom () {
            return domRef;
        },
        update (nextNode, _decorations) {
            // Let ProseMirror handle the update if node types are different.
            // This prevents an issue where it was not possible to select the
            // inline node view then replace it by entering text - the node
            // view contents would be deleted but the node view itself would
            // stay in the view and become uneditable.
            if (currentNode.type !== nextNode.type) return false;
            // On updates, we only set the new attributes if the type, attributes, and marks
            // have changed on the node.
            // NOTE: this could mean attrs changes aren't reflected in the dom,
            // when an attribute key which was previously present is no longer
            // present.
            // ie.
            // -> Original attributes { text: "hello world", color: "red" }
            // -> Updated attributes { color: "blue" }
            // in this case, the dom text attribute will not be cleared.
            //
            // This may not be an issue with any of our current node schemas.
            if (!currentNode.sameMarkup(nextNode)) $969e7ba7959fd6a0$var$setDomAttrs(nextNode, domRef);
            currentNode = nextNode;
            renderComponent();
            return true;
        },
        destroy () {
            // When prosemirror destroys the node view, we need to clean up
            // what we have previously rendered using the editor portal
            // provider api.
            pmPluginFactoryParams.portalProviderAPI.remove(key);
            // @ts-expect-error Expect an error as domRef is expected to be
            // of HTMLSpanElement type however once the node view has
            // been destroyed no other consumers should still be using it.
            domRef = undefined;
            fallbackRef.current = null;
        },
        ...extraNodeViewPropsWithStopEvent
    };
    return nodeView;
}
function $969e7ba7959fd6a0$var$createNodeViewVirtualized({ nodeViewParams: nodeViewParams, pmPluginFactoryParams: pmPluginFactoryParams, Component: Component, extraComponentProps: extraComponentProps, extraNodeViewProps: extraNodeViewProps }) {
    // We set a variable for the current node which is
    // used for comparisions when doing updates, before being
    // overwritten to the updated node.
    let currentNode = nodeViewParams.node;
    const key = (0, $3UrUG.generateUniqueNodeKey)();
    // First we setup the dom element which will be rendered and "tracked" by prosemirror
    // and also used as a "editor portal" (not react portal) target by the editor
    // portal provider api, for rendering the Component passed.
    let domRef = document.createElement('span');
    domRef.contentEditable = 'false';
    $969e7ba7959fd6a0$var$setDomAttrs(nodeViewParams.node, domRef);
    const fallbackRef = {
        current: null
    };
    // @see ED-3790
    // something gets messed up during mutation processing inside of a
    // nodeView if DOM structure has nested plain "div"s, it doesn't see the
    // difference between them and it kills the nodeView
    domRef.classList.add(`${nodeViewParams.node.type.name}View-content-wrap`, `${$969e7ba7959fd6a0$export$dfb58b577a6f1cd9}`);
    function onBeforeReactDomRender() {
        if (!fallbackRef.current) return;
        domRef.removeChild(fallbackRef.current);
        fallbackRef.current = null;
    }
    // This util is shared for tracking rendering, and the ErrorBoundary that
    // is setup to wrap the Component when rendering
    // NOTE: This is not a prosemirror dispatch
    function dispatchAnalyticsEvent(payload) {
        pmPluginFactoryParams.eventDispatcher.emit((0, $lrWkt.analyticsEventKey), {
            payload: payload
        });
    }
    // This is called to render the Component into domRef which is inside the
    // prosemirror View.
    // Internally it uses the unstable_renderSubtreeIntoContainer api to render,
    // to the passed dom element (domRef) which means it is automatically
    // "cleaned up" when you do a "re render".
    function renderComponent() {
        pmPluginFactoryParams.portalProviderAPI.render($969e7ba7959fd6a0$var$getPortalChildren({
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            currentNode: currentNode,
            nodeViewParams: nodeViewParams,
            Component: Component,
            extraComponentProps: extraComponentProps
        }), domRef, key, onBeforeReactDomRender);
    }
    let didRenderComponentWithIntersectionObserver = false;
    let destroyed = false;
    let removeIntersectionObserver = ()=>{};
    function renderFallback() {
        var _currentNode$type;
        if (!$969e7ba7959fd6a0$var$canRenderFallback(currentNode) || typeof ((_currentNode$type = currentNode.type) === null || _currentNode$type === void 0 || (_currentNode$type = _currentNode$type.spec) === null || _currentNode$type === void 0 ? void 0 : _currentNode$type.toDOM) !== 'function') return;
        const fallback = (0, $kW8qW.DOMSerializer).renderSpec(document, currentNode.type.spec.toDOM(currentNode));
        const dom = fallback.dom;
        fallbackRef.current = dom;
        domRef.replaceChildren(dom);
    }
    function attachNodeViewObserver() {
        const observer = (0, $8crSL.getOrCreateOnVisibleObserver)(nodeViewParams.view);
        if (domRef) removeIntersectionObserver = observer.observe(domRef, ()=>{
            if (!didRenderComponentWithIntersectionObserver && !destroyed) {
                renderComponent();
                didRenderComponentWithIntersectionObserver = true;
            }
        });
    }
    renderFallback();
    // allow the fallback to render first before attaching the observer.
    // Will tweak this in a follow up PR to optimise rendering of visible
    // nodes without fallback rendering.
    setTimeout(()=>{
        attachNodeViewObserver();
    }, 0);
    const extraNodeViewPropsWithStopEvent = {
        ...extraNodeViewProps,
        stopEvent: (event)=>{
            const maybeStopEvent = extraNodeViewProps === null || extraNodeViewProps === void 0 ? void 0 : extraNodeViewProps.stopEvent;
            if (typeof maybeStopEvent === 'function') return maybeStopEvent(event);
            return false;
        }
    };
    // https://prosemirror.net/docs/ref/#view.NodeView
    const nodeView = {
        get dom () {
            return domRef;
        },
        update (nextNode, _decorations) {
            // Let ProseMirror handle the update if node types are different.
            // This prevents an issue where it was not possible to select the
            // inline node view then replace it by entering text - the node
            // view contents would be deleted but the node view itself would
            // stay in the view and become uneditable.
            if (currentNode.type !== nextNode.type) return false;
            // On updates, we only set the new attributes if the type, attributes, and marks
            // have changed on the node.
            // NOTE: this could mean attrs changes aren't reflected in the dom,
            // when an attribute key which was previously present is no longer
            // present.
            // ie.
            // -> Original attributes { text: "hello world", color: "red" }
            // -> Updated attributes { color: "blue" }
            // in this case, the dom text attribute will not be cleared.
            //
            // This may not be an issue with any of our current node schemas.
            if (!currentNode.sameMarkup(nextNode)) $969e7ba7959fd6a0$var$setDomAttrs(nextNode, domRef);
            currentNode = nextNode;
            if (didRenderComponentWithIntersectionObserver) renderComponent();
            return true;
        },
        destroy () {
            removeIntersectionObserver();
            destroyed = true;
            // When prosemirror destroys the node view, we need to clean up
            // what we have previously rendered using the editor portal
            // provider api.
            pmPluginFactoryParams.portalProviderAPI.remove(key);
            // @ts-expect-error Expect an error as domRef is expected to be
            // of HTMLSpanElement type however once the node view has
            // been destroyed no other consumers should still be using it.
            domRef = undefined;
            fallbackRef.current = null;
        },
        ...extraNodeViewPropsWithStopEvent
    };
    return nodeView;
}
/**
 * Copies the attributes from a ProseMirror Node to a DOM node.
 * @param node The Prosemirror Node from which to source the attributes
 */ function $969e7ba7959fd6a0$var$setDomAttrs(node, element) {
    Object.keys(node.attrs || {}).forEach((attr)=>{
        element.setAttribute(attr, node.attrs[attr]);
    });
}
function $969e7ba7959fd6a0$var$getPortalChildren({ dispatchAnalyticsEvent: dispatchAnalyticsEvent, currentNode: currentNode, nodeViewParams: nodeViewParams, Component: Component, extraComponentProps: extraComponentProps }) {
    return function portalChildren() {
        var _currentNode$type2;
        //  All inline nodes use `display: inline` to allow for multi-line
        //  wrapping. This does produce an issue in Chrome where it is not
        //  possible to click select the position after the node,
        //  see: https://product-fabric.atlassian.net/browse/ED-12003
        //  however this is only a problem for node views that use
        //  `display: inline-block` somewhere within the Component.
        //  Looking at the below structure, spans with className
        //  `inlineNodeViewAddZeroWidthSpace` have pseudo elements that
        //  add a zero width space which fixes the problem.
        //  Without the additional zero width space before the Component,
        //  it is not possible to use the keyboard to range select in Safari.
        //
        //  Zero width spaces on either side of the Component also prevent
        //  the cursor from appearing inside the node view on all browsers.
        //
        //  Note:
        //  In future it is worth considering prohibiting the use of `display: inline-block`
        //  within inline node view Components however would require a sizable
        //  refactor. A test suite to catch any instances of this is ideal however
        //  the refactor required is currently out of scope for https://product-fabric.atlassian.net/browse/ED-14176
        return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $iUiGU.ErrorBoundary), {
            component: (0, $g6Qq4.ACTION_SUBJECT).REACT_NODE_VIEW,
            componentId: (currentNode === null || currentNode === void 0 || (_currentNode$type2 = currentNode.type) === null || _currentNode$type2 === void 0 ? void 0 : _currentNode$type2.name) ?? (0, $g6Qq4.ACTION_SUBJECT_ID).UNKNOWN_NODE,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            children: [
                /*#__PURE__*/ (0, $dc70d.jsxs)("span", {
                    className: `zeroWidthSpaceContainer`,
                    children: [
                        /*#__PURE__*/ (0, $dc70d.jsx)("span", {
                            className: `${$969e7ba7959fd6a0$export$dfb58b577a6f1cd9}AddZeroWidthSpace`
                        }),
                        (0, $kuD5k.ZERO_WIDTH_SPACE)
                    ]
                }),
                /*#__PURE__*/ (0, $dc70d.jsx)(Component, {
                    view: nodeViewParams.view,
                    // TODO: ED-13910 - Remove the boolean to fix the prosemirror view type
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    getPos: nodeViewParams.getPos,
                    node: currentNode,
                    ...extraComponentProps
                }),
                (0, $jxkn6.getBrowserInfo)().android ? // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, $dc70d.jsxs)("span", {
                    className: `zeroWidthSpaceContainer`,
                    contentEditable: "false",
                    children: [
                        /*#__PURE__*/ (0, $dc70d.jsx)("span", {
                            className: `${$969e7ba7959fd6a0$export$dfb58b577a6f1cd9}AddZeroWidthSpace`
                        }),
                        (0, $kuD5k.ZERO_WIDTH_SPACE)
                    ]
                }) : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, $dc70d.jsx)("span", {
                    className: `${$969e7ba7959fd6a0$export$dfb58b577a6f1cd9}AddZeroWidthSpace`
                })
            ]
        });
    };
}
const $969e7ba7959fd6a0$var$counterPerEditorViewMap = new WeakMap();
function $969e7ba7959fd6a0$export$17a8c3162956317d({ pmPluginFactoryParams: pmPluginFactoryParams, Component: Component, extraComponentProps: extraComponentProps, extraNodeViewProps: extraNodeViewProps }) {
    function nodeViewProducer(...nodeViewProducerParameters) {
        var _node$type;
        const view = nodeViewProducerParameters[1];
        const node = nodeViewProducerParameters[0];
        const parameters = {
            nodeViewParams: {
                node: node,
                view: view,
                getPos: nodeViewProducerParameters[2],
                decorations: nodeViewProducerParameters[3]
            },
            pmPluginFactoryParams: pmPluginFactoryParams,
            Component: Component,
            extraComponentProps: extraComponentProps,
            extraNodeViewProps: extraNodeViewProps
        };
        const isNodeTypeAllowedToBeVirtualized = $969e7ba7959fd6a0$var$virtualizedNodeAllowlist.includes((node === null || node === void 0 || (_node$type = node.type) === null || _node$type === void 0 ? void 0 : _node$type.name) || '');
        if (!isNodeTypeAllowedToBeVirtualized || (0, $7lseo.isSSR)()) return $969e7ba7959fd6a0$var$createNodeView(parameters);
        let inlineNodeViewsVirtualizationCounter = $969e7ba7959fd6a0$var$counterPerEditorViewMap.get(view) || 0;
        inlineNodeViewsVirtualizationCounter += 1;
        $969e7ba7959fd6a0$var$counterPerEditorViewMap.set(view, inlineNodeViewsVirtualizationCounter);
        // We never virtualize the 100th first elements
        if (inlineNodeViewsVirtualizationCounter <= 100) return $969e7ba7959fd6a0$var$createNodeView(parameters);
        return $969e7ba7959fd6a0$var$createNodeViewVirtualized(parameters);
    }
    return nodeViewProducer;
}

});
parcelRegister("8crSL", function(module, exports) {
$parcel$export(module.exports, "getOrCreateOnVisibleObserver", () => $ba756b6fec2bd8d5$export$d73c873f0a6a03c3);
// oxlint-disable-next-line @atlassian/no-restricted-imports

var $8XNPf = parcelRequire("8XNPf");
// Use this selector to set the intersection observer boundary for editor's inline node views
// If this does not exist, it will use the IntersectionObserver's default root
const $ba756b6fec2bd8d5$var$INTERSECTION_OBSERVER_ROOT_SELECTOR = '[data-editor-scroll-container="true"]';
const $ba756b6fec2bd8d5$var$INTERSECTION_OBSERVER_OPTIONS = {
    rootMargin: '0px 0px 100px 0px',
    threshold: 0
};
const $ba756b6fec2bd8d5$export$d73c873f0a6a03c3 = (0, (/*@__PURE__*/$parcel$interopDefault($8XNPf)))((view)=>{
    const intersectionObserverOptions = {
        root: view.dom.closest($ba756b6fec2bd8d5$var$INTERSECTION_OBSERVER_ROOT_SELECTOR),
        ...$ba756b6fec2bd8d5$var$INTERSECTION_OBSERVER_OPTIONS
    };
    const callbackMap = new WeakMap();
    const observer = new IntersectionObserver((entries)=>{
        entries.filter((entry)=>entry.isIntersecting) // Only process visible entries
        .map((entry)=>callbackMap.get(entry.target))// Invoke callbacks together to group browser rendering
        // Avoiding requestAnimationFrame to reduce visual flickering
        .forEach((cb)=>cb === null || cb === void 0 ? void 0 : cb());
    }, intersectionObserverOptions);
    return {
        observe: (el, callback)=>{
            callbackMap.set(el, callback);
            observer.observe(el);
            return ()=>observer.unobserve(el);
        }
    };
});

});


parcelRegister("eacW2", function(module, exports) {
$parcel$export(module.exports, "DATASOURCE_INNER_CONTAINER_CLASSNAME", () => $fbd470e121b1654f$export$32f80df830e375f6);
$parcel$export(module.exports, "FLOATING_TOOLBAR_LINKPICKER_CLASSNAME", () => $fbd470e121b1654f$export$863ae87a9d233606);
const $fbd470e121b1654f$export$32f80df830e375f6 = 'datasourceView-content-inner-wrap';
const $fbd470e121b1654f$export$863ae87a9d233606 = 'card-floating-toolbar--link-picker';

});

parcelRegister("iyAOY", function(module, exports) {
$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $90a55255f4b0ff64$export$85183a312807388d);
$parcel$export(module.exports, "DATASOURCE_DEFAULT_LAYOUT", () => $90a55255f4b0ff64$export$60efea3f80310017);
const $90a55255f4b0ff64$export$85183a312807388d = 'media';
const $90a55255f4b0ff64$export$60efea3f80310017 = 'wide';

});

parcelRegister("7ZryX", function(module, exports) {
$parcel$export(module.exports, "BlockCardComponent", () => $544bc4fba82f2713$export$780882fb750d3c8d);
$parcel$export(module.exports, "blockCardNodeView", () => $544bc4fba82f2713$export$8c11099266e71f4);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9wZWu = parcelRequire("9wZWu");

var $7RHfd = parcelRequire("7RHfd");

var $jxkn6 = parcelRequire("jxkn6");

var $9xvBa = parcelRequire("9xvBa");

var $0Xboy = parcelRequire("0Xboy");

var $d8JFj = parcelRequire("d8JFj");

var $8XENo = parcelRequire("8XENo");

var $47K0n = parcelRequire("47K0n");

var $3y2s4 = parcelRequire("3y2s4");

var $dETMy = parcelRequire("dETMy");

var $iOHZU = parcelRequire("iOHZU");

var $99PDZ = parcelRequire("99PDZ");

var $k5X6V = parcelRequire("k5X6V");

var $cKhMH = parcelRequire("cKhMH");

var $9ZsM7 = parcelRequire("9ZsM7");

var $aciCL = parcelRequire("aciCL");

var $2kWIB = parcelRequire("2kWIB");
class $544bc4fba82f2713$export$780882fb750d3c8d extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).PureComponent {
    constructor(props){
        super(props), this.onResolve = (data)=>{
            const { getPos: getPos, view: view } = this.props;
            if (!getPos || typeof getPos === 'boolean') return;
            const { title: title, url: url } = data;
            // don't dispatch immediately since we might be in the middle of
            // rendering a nodeview
            const scheduleRegisterCard = (0, $9wZWu.default)(()=>{
                const pos = getPos();
                if (typeof pos !== 'number') return;
                view.dispatch((0, $k5X6V.registerCard)({
                    title: title,
                    url: url,
                    pos: pos,
                    id: this.props.id
                })(view.state.tr));
            });
            if ((0, $3y2s4.isExperimentEnabled)('platform_editor_reduce_memory_leaks')) this.pendingRegisterCard = scheduleRegisterCard;
            scheduleRegisterCard();
        }, this.removeCardDispatched = false, this.gapCursorSpan = ()=>{
            const browser = (0, $jxkn6.getBrowserInfo)();
            // Don't render in EdgeHTMl version <= 18 (Edge version 44)
            // as it forces the edit popup to render 24px lower than it should
            if (browser.ie && browser.ie_version < 79) return;
            // render an empty span afterwards to get around Webkit bug
            // that puts caret in next editable text element
            return /*#__PURE__*/ (0, $dc70d.jsx)("span", {
                contentEditable: true
            });
        }, this.onError = ({ err: err })=>{
            if (err) throw err;
        };
        this.scrollContainer = (0, $3y2s4.isExperimentEnabled)('platform_editor_reduce_forced_layout_2') && (0, $2kWIB.isIntersectionObserverSupported)() ? undefined : // eslint-disable-next-line @atlaskit/editor/no-as-casting
        (0, $9xvBa.findOverflowScrollParent)(props.view.dom) || undefined;
    }
    componentWillUnmount() {
        if ((0, $3y2s4.isExperimentEnabled)('platform_editor_reduce_memory_leaks')) {
            var _this$pendingRegister;
            (_this$pendingRegister = this.pendingRegisterCard) === null || _this$pendingRegister === void 0 || _this$pendingRegister.cancel();
            this.pendingRegisterCard = undefined;
        }
        this.removeCard();
    }
    removeCard() {
        if (this.removeCardDispatched) return;
        this.removeCardDispatched = true;
        const { tr: tr } = this.props.view.state;
        (0, $k5X6V.removeCard)({
            id: this.props.id
        })(tr);
        this.props.view.dispatch(tr);
    }
    render() {
        const { node: node, cardContext: cardContext, actionOptions: actionOptions, onClick: onClick, CompetitorPrompt: CompetitorPrompt, isPageSSRed: isPageSSRed } = this.props;
        const { url: url, data: data } = node.attrs;
        const cardInner = isPageSSRed ? /*#__PURE__*/ (0, $dc70d.jsxs)((0, $dc70d.Fragment), {
            children: [
                /*#__PURE__*/ (0, $dc70d.jsx)((0, $iOHZU.CardSSR), {
                    url: url ?? data.url,
                    container: this.scrollContainer,
                    appearance: "block",
                    onClick: onClick,
                    onResolve: this.onResolve,
                    onError: this.onError,
                    platform: 'web',
                    actionOptions: actionOptions,
                    CompetitorPrompt: CompetitorPrompt,
                    hideIconLoadingSkeleton: true
                }, url),
                this.gapCursorSpan()
            ]
        }) : /*#__PURE__*/ (0, $dc70d.jsxs)((0, $dc70d.Fragment), {
            children: [
                /*#__PURE__*/ (0, $dc70d.jsx)((0, $dETMy.Card), {
                    url: url ?? data.url,
                    container: this.scrollContainer,
                    appearance: "block",
                    onClick: onClick,
                    onResolve: this.onResolve,
                    onError: this.onError,
                    platform: 'web',
                    actionOptions: actionOptions,
                    CompetitorPrompt: CompetitorPrompt
                }, url),
                this.gapCursorSpan()
            ]
        });
        // [WS-2307]: we only render card wrapped into a Provider when the value is ready,
        // otherwise if we got data, we can render the card directly since it doesn't need the Provider
        return /*#__PURE__*/ (0, $dc70d.jsx)((0, $47K0n.SmartLinkDraggable), {
            url: url,
            appearance: (0, $47K0n.SMART_LINK_APPEARANCE).BLOCK,
            source: (0, $47K0n.SMART_LINK_DRAG_TYPES).EDITOR,
            children: /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                children: cardContext && cardContext.value ? /*#__PURE__*/ (0, $dc70d.jsx)(cardContext.Provider, {
                    value: cardContext.value,
                    children: cardInner
                }) : data ? cardInner : null
            })
        });
    }
}
const $544bc4fba82f2713$var$WrappedBlockCard = (0, $aciCL.Card)($544bc4fba82f2713$export$780882fb750d3c8d, (0, $d8JFj.default));
class $544bc4fba82f2713$export$d18ccd25c0d2c6b0 extends (0, $0Xboy.default) {
    createDomRef() {
        var _this$reactComponentP, _this$reactComponentP2;
        const domRef = document.createElement('div');
        // workaround Chrome bug in https://product-fabric.atlassian.net/browse/ED-5379
        // see also: https://github.com/ProseMirror/prosemirror/issues/884
        this.unsubscribe = (_this$reactComponentP = this.reactComponentProps.pluginInjectionApi) === null || _this$reactComponentP === void 0 || (_this$reactComponentP = _this$reactComponentP.editorViewMode) === null || _this$reactComponentP === void 0 ? void 0 : _this$reactComponentP.sharedState.onChange(({ nextSharedState: nextSharedState })=>this.updateContentEditable(nextSharedState, domRef));
        this.updateContentEditable((_this$reactComponentP2 = this.reactComponentProps.pluginInjectionApi) === null || _this$reactComponentP2 === void 0 || (_this$reactComponentP2 = _this$reactComponentP2.editorViewMode) === null || _this$reactComponentP2 === void 0 ? void 0 : _this$reactComponentP2.sharedState.currentState(), domRef);
        domRef.setAttribute('spellcheck', 'false');
        return domRef;
    }
    // Need this function to check if the datasource attribute was added or not to a blockCard.
    // If so, we return false so we can get the node to re-render properly as a datasource node instead.
    // Otherwise, the node view will still consider the node as a blockCard and render a regular blockCard.
    validUpdate(currentNode, newNode) {
        const isCurrentNodeBlockCard = !(0, $cKhMH.isDatasourceNode)(currentNode);
        const isNewNodeDatasource = (0, $cKhMH.isDatasourceNode)(newNode);
        // need to return falsy to update node
        return !(isCurrentNodeBlockCard && isNewNodeDatasource);
    }
    update(node, decorations, _innerDecorations) {
        return super.update(node, decorations, _innerDecorations, this.validUpdate);
    }
    render() {
        const { actionOptions: actionOptions, pluginInjectionApi: pluginInjectionApi, onClickCallback: onClickCallback, CompetitorPrompt: CompetitorPrompt, isPageSSRed: isPageSSRed, provider: provider, intl: intl, smartCardContext: smartCardContext } = this.reactComponentProps;
        return /*#__PURE__*/ (0, $dc70d.jsx)((0, $9ZsM7.SmartCardSSRReactContextsProvider), {
            intl: intl,
            smartCardContext: smartCardContext,
            children: /*#__PURE__*/ (0, $dc70d.jsx)($544bc4fba82f2713$var$WrappedBlockCard, {
                node: this.node,
                view: this.view,
                getPos: this.getPos,
                actionOptions: actionOptions,
                pluginInjectionApi: pluginInjectionApi,
                onClickCallback: onClickCallback,
                id: this.id,
                CompetitorPrompt: CompetitorPrompt,
                isPageSSRed: isPageSSRed,
                provider: provider
            })
        });
    }
    /**
   * Prevent ProseMirror from handling drag events on the smart-element-link,
   * allowing native drag to work so SmartLinkDraggable can intercept it.
   * @see {@link https://prosemirror.net/docs/ref/#view.NodeView.stopEvent}
   */ stopEvent(event) {
        if (event.type === 'dragstart') {
            const target = event.target;
            if (target instanceof HTMLElement && target.closest('[data-smart-element-link]')) return true;
        }
        return false;
    }
    destroy() {
        var _this$unsubscribe;
        (_this$unsubscribe = this.unsubscribe) === null || _this$unsubscribe === void 0 || _this$unsubscribe.call(this);
        super.destroy();
    }
    constructor(...args){
        super(...args), // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        this.id = (0, $7RHfd.default)(), this.updateContentEditable = (editorViewModeState, divElement)=>{
            divElement.contentEditable = (editorViewModeState === null || editorViewModeState === void 0 ? void 0 : editorViewModeState.mode) === 'view' ? 'false' : 'true';
        };
    }
}
const $544bc4fba82f2713$export$8c11099266e71f4 = ({ pmPluginFactoryParams: pmPluginFactoryParams, actionOptions: actionOptions, pluginInjectionApi: pluginInjectionApi, onClickCallback: onClickCallback, allowDatasource: allowDatasource, inlineCardViewProducer: inlineCardViewProducer, CompetitorPrompt: CompetitorPrompt, isPageSSRed: isPageSSRed, provider: provider, intl: intl, smartCardContext: smartCardContext })=>(node, view, getPos, decorations)=>{
        const { portalProviderAPI: portalProviderAPI, eventDispatcher: eventDispatcher } = pmPluginFactoryParams;
        const reactComponentProps = {
            actionOptions: actionOptions,
            pluginInjectionApi: pluginInjectionApi,
            onClickCallback: onClickCallback,
            CompetitorPrompt: CompetitorPrompt,
            isPageSSRed: isPageSSRed,
            provider: provider,
            intl: intl,
            smartCardContext: smartCardContext
        };
        const isDatasource = (0, $cKhMH.isDatasourceNode)(node);
        if (isDatasource) {
            var _node$attrs;
            if (allowDatasource && (0, $8XENo.canRenderDatasource)(node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 || (_node$attrs = _node$attrs.datasource) === null || _node$attrs === void 0 ? void 0 : _node$attrs.id)) {
                const datasourcePosition = typeof getPos === 'function' && getPos();
                const datasourceResolvedPosition = datasourcePosition && view.state.doc.resolve(datasourcePosition);
                const isNodeNested = !!(datasourceResolvedPosition && datasourceResolvedPosition.depth > 0);
                return new (0, $99PDZ.Datasource)({
                    node: node,
                    view: view,
                    getPos: getPos,
                    portalProviderAPI: portalProviderAPI,
                    eventDispatcher: eventDispatcher,
                    pluginInjectionApi: pluginInjectionApi,
                    isNodeNested: isNodeNested
                }).init();
            } else return inlineCardViewProducer(node, view, getPos, decorations);
        }
        return new $544bc4fba82f2713$export$d18ccd25c0d2c6b0(node, view, getPos, portalProviderAPI, eventDispatcher, reactComponentProps, undefined).init();
    };

});
parcelRegister("99PDZ", function(module, exports) {
$parcel$export(module.exports, "Datasource", () => $9fe60a0024003509$export$9dd55813d0ee0514);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $0Xboy = parcelRequire("0Xboy");

var $9hOTY = parcelRequire("9hOTY");

var $eacW2 = parcelRequire("eacW2");

var $lmZMT = parcelRequire("lmZMT");

var $bjG1c = parcelRequire("bjG1c");

var $1g3fM = parcelRequire("1g3fM");

var $cmWuu = parcelRequire("cmWuu");

var $frwzM = parcelRequire("frwzM");

var $iyAOY = parcelRequire("iyAOY");

var $gBI2J = parcelRequire("gBI2J");

var $4Gsah = parcelRequire("4Gsah");
const $9fe60a0024003509$var$getPosSafely = (pos)=>{
    if (!pos || typeof pos === 'boolean') return;
    try {
        return pos();
    } catch (e) {
    // Can blow up in rare cases, when node has been removed.
    }
};
class $9fe60a0024003509$export$1deb9aaa193645a1 extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).PureComponent {
    constructor(props){
        super(props), this.getDatasource = ()=>this.props.node.attrs.datasource, this.getTableView = ()=>{
            const views = this.getDatasource().views;
            return views.find((view)=>view.type === 'table') || undefined;
        }, this.handleColumnChange = (columnKeys)=>{
            const { wrappedColumnKeys: wrappedColumnKeys = [], columnCustomSizes: columnCustomSizes = {} } = this.getColumnsInfo();
            this.updateTableProperties(columnKeys, columnCustomSizes, wrappedColumnKeys);
        }, this.handleColumnResize = (key, width)=>{
            const { wrappedColumnKeys: wrappedColumnKeys = [], columnCustomSizes: columnCustomSizes = {}, visibleColumnKeys: visibleColumnKeys = [] } = this.getColumnsInfo();
            const newColumnCustomSizes = {
                ...columnCustomSizes,
                [key]: width
            };
            this.updateTableProperties(visibleColumnKeys, newColumnCustomSizes, wrappedColumnKeys);
        }, this.handleWrappedColumnChange = (key, shouldWrap)=>{
            const { wrappedColumnKeys: wrappedColumnKeys = [], columnCustomSizes: columnCustomSizes = {}, visibleColumnKeys: visibleColumnKeys = [] } = this.getColumnsInfo();
            const wrappedColumnKeysSet = new Set(wrappedColumnKeys);
            if (shouldWrap) wrappedColumnKeysSet.add(key);
            else wrappedColumnKeysSet.delete(key);
            this.updateTableProperties(visibleColumnKeys, columnCustomSizes, Array.from(wrappedColumnKeysSet));
        }, this.handleWrappedColumnsChange = (wrappedColumnKeys)=>{
            const { columnCustomSizes: columnCustomSizes = {}, visibleColumnKeys: visibleColumnKeys = [] } = this.getColumnsInfo();
            this.updateTableProperties(visibleColumnKeys, columnCustomSizes, wrappedColumnKeys);
        }, this.onError = ({ err: err })=>{
            if (err) throw err;
        };
    }
    updateTableProperties(columnKeysArg, columnCustomSizes, wrappedColumnKeys) {
        const { state: state, dispatch: dispatch } = this.props.view;
        const pos = $9fe60a0024003509$var$getPosSafely(this.props.getPos);
        if (pos === undefined) return;
        // In case for some reason there are no visible keys stored in ADF, we take them
        // from incoming sets of attributes like column sizes and wrapped column keys
        // columnKeys are needed to update ADF (
        // since attributes (like custom width and wrapped state) only make sense for a visible column )
        // So this part effectively adds a visible column if it wasn't there but attributes were given.
        const columnKeys = columnKeysArg.length > 0 ? columnKeysArg : Array.from(new Set([
            ...Object.keys(columnCustomSizes),
            ...wrappedColumnKeys
        ]));
        const views = [
            {
                type: 'table',
                properties: {
                    columns: columnKeys.map((key)=>{
                        const width = columnCustomSizes[key];
                        const isWrapped = wrappedColumnKeys.includes(key);
                        return {
                            key: key,
                            ...width ? {
                                width: width
                            } : {},
                            ...isWrapped ? {
                                isWrapped: isWrapped
                            } : {}
                        };
                    })
                }
            }
        ];
        const attrs = this.props.node.attrs;
        const tr = state.tr.setNodeMarkup(pos, undefined, {
            ...attrs,
            datasource: {
                ...attrs.datasource,
                views: views
            }
        });
        // Ensures dispatch does not contribute to undo history (otherwise user requires three undo's to revert table)
        tr.setMeta('addToHistory', false);
        tr.setMeta('scrollIntoView', false);
        dispatch(tr);
    }
    getColumnsInfo() {
        var _tableView$properties;
        const tableView = this.getTableView();
        const columnsProp = tableView === null || tableView === void 0 || (_tableView$properties = tableView.properties) === null || _tableView$properties === void 0 ? void 0 : _tableView$properties.columns;
        const visibleColumnKeys = columnsProp === null || columnsProp === void 0 ? void 0 : columnsProp.map(({ key: key })=>key);
        let columnCustomSizes;
        const columnsWithWidth = columnsProp === null || columnsProp === void 0 ? void 0 : columnsProp.filter((c)=>!!c.width);
        if (columnsWithWidth) {
            const keyWidthPairs = columnsWithWidth.map((c)=>[
                    c.key,
                    c.width
                ]);
            columnCustomSizes = Object.fromEntries(keyWidthPairs);
        }
        const wrappedColumnKeys = columnsProp === null || columnsProp === void 0 ? void 0 : columnsProp.filter((c)=>c.isWrapped).map((c)=>c.key);
        return {
            visibleColumnKeys: visibleColumnKeys,
            columnCustomSizes: columnCustomSizes,
            wrappedColumnKeys: wrappedColumnKeys
        };
    }
    render() {
        const datasource = this.getDatasource();
        const attrs = this.props.node.attrs;
        const tableView = this.getTableView();
        if (tableView) {
            const { visibleColumnKeys: visibleColumnKeys, columnCustomSizes: columnCustomSizes, wrappedColumnKeys: wrappedColumnKeys } = this.getColumnsInfo();
            return /*#__PURE__*/ (0, $9dQre.jsx)((0, $frwzM.EditorSmartCardProviderValueGuard), null, /*#__PURE__*/ (0, $9dQre.jsx)((0, $4Gsah.EditorAnalyticsContext), {
                editorView: this.props.view
            }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $cmWuu.EditorSmartCardProvider), null, /*#__PURE__*/ (0, $9dQre.jsx)((0, $1g3fM.DatasourceTableViewWithWrappers), {
                datasourceId: datasource.id,
                parameters: datasource.parameters,
                visibleColumnKeys: visibleColumnKeys,
                onVisibleColumnKeysChange: this.handleColumnChange,
                url: attrs === null || attrs === void 0 ? void 0 : attrs.url,
                onColumnResize: this.handleColumnResize,
                columnCustomSizes: columnCustomSizes,
                onWrappedColumnChange: this.handleWrappedColumnChange,
                onWrappedColumnsChange: this.handleWrappedColumnsChange,
                wrappedColumnKeys: wrappedColumnKeys
            }))));
        }
        return null;
    }
}
class $9fe60a0024003509$export$9dd55813d0ee0514 extends (0, $0Xboy.default) {
    constructor(props){
        var _props$pluginInjectio, _sharedState$currentS;
        super(props.node, props.view, props.getPos, props.portalProviderAPI, props.eventDispatcher, props);
        const sharedState = props === null || props === void 0 || (_props$pluginInjectio = props.pluginInjectionApi) === null || _props$pluginInjectio === void 0 || (_props$pluginInjectio = _props$pluginInjectio.width) === null || _props$pluginInjectio === void 0 ? void 0 : _props$pluginInjectio.sharedState;
        this.tableWidth = sharedState === null || sharedState === void 0 || (_sharedState$currentS = sharedState.currentState()) === null || _sharedState$currentS === void 0 ? void 0 : _sharedState$currentS.width;
        this.isNodeNested = props.isNodeNested;
        sharedState === null || sharedState === void 0 || sharedState.onChange(({ nextSharedState: nextSharedState })=>{
            if (nextSharedState !== null && nextSharedState !== void 0 && nextSharedState.width && this.tableWidth !== (nextSharedState === null || nextSharedState === void 0 ? void 0 : nextSharedState.width)) {
                this.tableWidth = nextSharedState === null || nextSharedState === void 0 ? void 0 : nextSharedState.width;
                this.update(this.node, []); // required to update the width when page is resized.
            }
        });
    }
    // Need this function to check if the datasource attribute was added or not to a blockCard.
    // If not, we return false so we can get the node to re-render properly as a block node instead.
    // Otherwise, the node view will still consider the node as a Datasource and render a such.
    validUpdate(_, newNode) {
        var _newNode$attrs;
        return !!((_newNode$attrs = newNode.attrs) !== null && _newNode$attrs !== void 0 && _newNode$attrs.datasource);
    }
    update(node, decorations, _innerDecorations) {
        return super.update(node, decorations, _innerDecorations, this.validUpdate);
    }
    createDomRef() {
        const domRef = document.createElement('div');
        domRef.setAttribute('contenteditable', 'true');
        domRef.classList.add((0, $9hOTY.SmartCardSharedCssClassName).DATASOURCE_CONTAINER);
        return domRef;
    }
    /**
   * Node views may render interactive elements that should not have their events reach editor
   *
   * We should the stop editor from handling events from following elements:
   * - typing in input
   * - activating buttons via spacebar
   *
   * Can be used to prevent the editor view from trying to handle some or all DOM events that bubble up from the node view.
   * Events for which this returns true are not handled by the editor.
   * @see {@link https://prosemirror.net/docs/ref/#view.NodeView.stopEvent}
   */ stopEvent(event) {
        const isFormElement = [
            HTMLButtonElement,
            HTMLInputElement
        ].some((element)=>event.target instanceof element);
        if (isFormElement) return true;
        return false;
    }
    render() {
        var _this$domRef, _attrs$datasource;
        const { attrs: attrs } = this.node;
        // EDM-10607: Workaround to remove datasource table draggable attribute
        // @ts-ignore TS2341: Property domRef is private
        (_this$domRef = this.domRef) === null || _this$domRef === void 0 || _this$domRef.setAttribute('draggable', 'false');
        return /*#__PURE__*/ (0, $9dQre.jsx)((0, $gBI2J.DatasourceErrorBoundary), {
            unsupportedComponent: (0, $lmZMT.default),
            view: this.view,
            url: attrs.url,
            datasourceId: attrs === null || attrs === void 0 || (_attrs$datasource = attrs.datasource) === null || _attrs$datasource === void 0 ? void 0 : _attrs$datasource.id
        }, /*#__PURE__*/ (0, $9dQre.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, $eacW2.DATASOURCE_INNER_CONTAINER_CLASSNAME),
            style: {
                minWidth: this.isNodeNested ? '100%' : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                (0, $bjG1c.calcBreakoutWidth)(attrs.layout || (0, $iyAOY.DATASOURCE_DEFAULT_LAYOUT), this.tableWidth)
            }
        }, /*#__PURE__*/ (0, $9dQre.jsx)($9fe60a0024003509$export$1deb9aaa193645a1, {
            node: this.node,
            view: this.view,
            getPos: this.getPos
        })));
    }
}

});
parcelRegister("cmWuu", function(module, exports) {
$parcel$export(module.exports, "EditorSmartCardProvider", () => $e3f8b64f59970c99$export$2a29ca11e08dc129);

var $bSJIT = parcelRequire("bSJIT");

var $6TyVm = parcelRequire("6TyVm");
const $e3f8b64f59970c99$export$2a29ca11e08dc129 = ({ children: children })=>{
    const cardContext = (0, $6TyVm.useSmartCardContext)();
    const Provider = cardContext.Provider;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(Provider, {
        value: cardContext.value
    }, children);
};

});

parcelRegister("frwzM", function(module, exports) {
$parcel$export(module.exports, "EditorSmartCardProviderValueGuard", () => $3508917552d25cbf$export$797e3658f090919c);

var $bSJIT = parcelRequire("bSJIT");

var $6TyVm = parcelRequire("6TyVm");
const $3508917552d25cbf$export$797e3658f090919c = ({ children: children })=>{
    const cardContext = (0, $6TyVm.useSmartCardContext)();
    if (!(cardContext !== null && cardContext !== void 0 && cardContext.value)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, children);
};

});

parcelRegister("gBI2J", function(module, exports) {
$parcel$export(module.exports, "DatasourceErrorBoundary", () => $08c1d546ac6c20f7$export$76664c71b9b1a689);
/* eslint-disable @repo/internal/react/no-class-components */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $7nI18 = parcelRequire("7nI18");

var $3hL7H = parcelRequire("3hL7H");

var $a76m2 = parcelRequire("a76m2");
class $08c1d546ac6c20f7$export$76664c71b9b1a689 extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Component {
    static getDerivedStateFromError(error) {
        return {
            isError: true,
            error: error
        };
    }
    componentDidCatch(error) {
        if (this.props.handleError) this.props.handleError();
        // prevent re-render children with error
        if (this.state.isError) this.setState({
            isError: true,
            error: error
        });
    }
    render() {
        const { url: url, unsupportedComponent: UnsupportedComponent, view: view, datasourceModalType: datasourceModalType, datasourceId: datasourceId } = this.props;
        if (this.state.isError) {
            if (url && (0, $7nI18.isSafeUrl)(url)) return /*#__PURE__*/ (0, $dc70d.jsx)((0, $3hL7H.LazyLoadedDatasourceRenderFailedAnalyticsWrapper), {
                datasourceId: datasourceId,
                error: this.state.error,
                children: (0, $a76m2.setSelectedCardAppearance)('inline', undefined)(view.state, view.dispatch)
            });
            else {
                const unsupportedComponent = UnsupportedComponent ? /*#__PURE__*/ (0, $dc70d.jsx)(UnsupportedComponent, {}) : null;
                return /*#__PURE__*/ (0, $dc70d.jsx)((0, $3hL7H.LazyLoadedDatasourceRenderFailedAnalyticsWrapper), {
                    datasourceModalType: datasourceModalType,
                    datasourceId: datasourceId,
                    error: this.state.error,
                    children: unsupportedComponent
                });
            }
        } else return this.props.children;
    }
    constructor(...args){
        super(...args), this.state = {
            isError: false,
            error: null
        };
    }
}

});

parcelRegister("4Gsah", function(module, exports) {
$parcel$export(module.exports, "EditorAnalyticsContext", () => $845435fef5ea066a$export$b49e513cc101a4b6);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $dwOcU = parcelRequire("dwOcU");

var $lrWkt = parcelRequire("lrWkt");

var $9R86V = parcelRequire("9R86V");
const $845435fef5ea066a$export$b49e513cc101a4b6 = ({ editorView: editorView, children: children })=>{
    var _getPluginState;
    const editorAppearance = editorView ? (_getPluginState = (0, $9R86V.getPluginState)(editorView.state)) === null || _getPluginState === void 0 ? void 0 : _getPluginState.editorAppearance : undefined;
    const analyticsEditorAppearance = (0, $lrWkt.getAnalyticsEditorAppearance)(editorAppearance);
    const analyticsData = {
        attributes: {
            location: analyticsEditorAppearance
        },
        // Below is added for the future implementation of Linking Platform namespaced analytic context
        location: analyticsEditorAppearance
    };
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dwOcU.default), {
        data: analyticsData,
        children: children
    });
};

});
parcelRegister("9R86V", function(module, exports) {
$parcel$export(module.exports, "getPluginState", () => $bb35d653000291bf$export$f05434c51e3762e);
$parcel$export(module.exports, "getPluginStateWithUpdatedPos", () => $bb35d653000291bf$export$be237c815d2927d4);
$parcel$export(module.exports, "getNewRequests", () => $bb35d653000291bf$export$cd9326e2f6dc42c0);

var $1fMby = parcelRequire("1fMby");
const $bb35d653000291bf$export$f05434c51e3762e = (editorState)=>(0, $1fMby.pluginKey).getState(editorState);
const $bb35d653000291bf$export$be237c815d2927d4 = (pluginState, tr)=>{
    var _pluginState$resolved;
    return {
        ...pluginState,
        requests: pluginState.requests.map((request)=>({
                ...request,
                pos: tr.mapping.map(request.pos)
            })),
        cards: pluginState.cards.map((card)=>({
                ...card,
                pos: tr.mapping.map(card.pos)
            })),
        resolvedInlineSmartLinks: (_pluginState$resolved = pluginState.resolvedInlineSmartLinks) === null || _pluginState$resolved === void 0 ? void 0 : _pluginState$resolved.map((card)=>({
                ...card,
                pos: tr.mapping.map(card.pos)
            }))
    };
};
const $bb35d653000291bf$export$cd9326e2f6dc42c0 = (oldState, currentState)=>{
    if (oldState) return currentState.requests.filter((req)=>!oldState.requests.find((oldReq)=>$bb35d653000291bf$var$isSameRequest(oldReq, req)));
    return currentState.requests;
};
const $bb35d653000291bf$var$isSameRequest = (requestA, requestB)=>requestA.url === requestB.url && requestA.pos === requestB.pos;

});



parcelRegister("9ZsM7", function(module, exports) {
$parcel$export(module.exports, "SmartCardSSRReactContextsProvider", () => $ed5212be3ad53a7c$export$d59258481d10b16b);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $fK3tS = parcelRequire("fK3tS");

var $7lseo = parcelRequire("7lseo");

var $1zOmw = parcelRequire("1zOmw");
function $ed5212be3ad53a7c$export$d59258481d10b16b({ smartCardContext: smartCardContext, children: children, intl: intl }) {
    if (!(0, $7lseo.isSSR)()) return children;
    if (!intl || !smartCardContext) return children;
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $fK3tS.Provider), {
        value: intl,
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $1zOmw.SmartCardContext).Provider, {
            value: smartCardContext,
            children: children
        })
    });
}

});

parcelRegister("aciCL", function(module, exports) {
$parcel$export(module.exports, "Card", () => $862472ed3e9bfa1d$export$60332b2344f7fe41);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $7nI18 = parcelRequire("7nI18");

var $dwOcU = parcelRequire("dwOcU");

var $5beht = parcelRequire("5beht");

var $lrWkt = parcelRequire("lrWkt");

var $9Rfip = parcelRequire("9Rfip");

var $a76m2 = parcelRequire("a76m2");

var $9R86V = parcelRequire("9R86V");

var $cKhMH = parcelRequire("cKhMH");

var $83npI = parcelRequire("83npI");
const $862472ed3e9bfa1d$var$fatalErrorPositionMap = new Map();
const $862472ed3e9bfa1d$var$WithClickHandler = ({ pluginInjectionApi: pluginInjectionApi, url: url, onClickCallback: onClickCallback, children: children })=>{
    const { mode: mode } = (0, $5beht.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'editorViewMode'
    ], (states)=>{
        var _states$editorViewMod;
        return {
            mode: (_states$editorViewMod = states.editorViewModeState) === null || _states$editorViewMod === void 0 ? void 0 : _states$editorViewMod.mode
        };
    });
    const onClick = (0, $bSJIT.useCallback)((event)=>{
        if (typeof onClickCallback === 'function') try {
            onClickCallback({
                event: event,
                url: url
            });
        } catch  {}
    }, [
        url,
        onClickCallback
    ]);
    // Setting `onClick` to `undefined` ensures clicks on smartcards navigate to the URL.
    // If in view mode and not overriding with onClickCallback option, then allow smartlinks to navigate on click.
    const allowNavigation = mode === 'view' && !onClickCallback;
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dc70d.Fragment), {
        children: children({
            onClick: allowNavigation ? undefined : onClick
        })
    });
};
function $862472ed3e9bfa1d$export$60332b2344f7fe41(SmartCardComponent, UnsupportedComponent) {
    return class extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Component {
        render() {
            var _getPluginState;
            const { pluginInjectionApi: pluginInjectionApi, onClickCallback: onClickCallback } = this.props;
            const { url: url } = (0, $cKhMH.titleUrlPairFromNode)(this.props.node);
            if (url && !(0, $7nI18.isSafeUrl)(url)) return /*#__PURE__*/ (0, $dc70d.jsx)(UnsupportedComponent, {});
            if (this.state.isError) {
                if (url) return /*#__PURE__*/ (0, $dc70d.jsx)((0, $9Rfip.default), {
                    href: url,
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    onClick: (e)=>{
                        e.preventDefault();
                    },
                    children: url
                });
                else return /*#__PURE__*/ (0, $dc70d.jsx)(UnsupportedComponent, {});
            }
            const editorAppearance = (_getPluginState = (0, $9R86V.getPluginState)(this.props.view.state)) === null || _getPluginState === void 0 ? void 0 : _getPluginState.editorAppearance;
            const analyticsEditorAppearance = (0, $lrWkt.getAnalyticsEditorAppearance)(editorAppearance);
            return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dwOcU.default), {
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                data: {
                    attributes: {
                        location: analyticsEditorAppearance
                    },
                    // Below is added for the future implementation of Linking Platform namespaced analytics context
                    location: analyticsEditorAppearance
                },
                children: /*#__PURE__*/ (0, $dc70d.jsx)($862472ed3e9bfa1d$var$WithClickHandler, {
                    pluginInjectionApi: pluginInjectionApi,
                    onClickCallback: onClickCallback,
                    url: url,
                    children: ({ onClick: onClick })=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $83npI.WithCardContext), {
                            children: (cardContext)=>/*#__PURE__*/ (0, $dc70d.jsx)(SmartCardComponent, {
                                    cardContext: cardContext,
                                    ...this.props,
                                    onClick: onClick
                                }, url)
                        })
                })
            });
        }
        componentDidCatch(error) {
            const maybeAPIError = error;
            // NB: errors received in this component are propagated by the `@atlaskit/smart-card` component.
            // Depending on the kind of error, the expectation for this component is to either:
            // (1) Render a blue link whilst retaining `inlineCard` in the ADF (non-fatal errs);
            // (2) Render a blue link whilst downgrading to `link` in the ADF (fatal errs).
            if (maybeAPIError.kind && maybeAPIError.kind === 'fatal') {
                var _pluginInjectionApi$a;
                this.setState({
                    isError: true
                });
                const { view: view, node: node, getPos: getPos, pluginInjectionApi: pluginInjectionApi } = this.props;
                const { url: url } = (0, $cKhMH.titleUrlPairFromNode)(node);
                if (!getPos || typeof getPos === 'boolean') return;
                const pos = getPos();
                /**
         * We cache fatal errors by position to avoid retrying the same errors
         * on the same links at the same position.
         */ if (url && pos && $862472ed3e9bfa1d$var$fatalErrorPositionMap.get(url) === pos) return null;
                (0, $a76m2.changeSelectedCardToLinkFallback)(undefined, url, true, node, getPos(), pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$a = pluginInjectionApi.analytics) === null || _pluginInjectionApi$a === void 0 ? void 0 : _pluginInjectionApi$a.actions)(view.state, view.dispatch);
                if (url && pos) $862472ed3e9bfa1d$var$fatalErrorPositionMap.set(url, pos);
                return null;
            } else // Otherwise, render a blue link as fallback (above in render()).
            this.setState({
                isError: true
            });
        }
        constructor(...args){
            super(...args), this.state = {
                isError: false
            };
        }
    };
}

});
parcelRegister("83npI", function(module, exports) {
$parcel$export(module.exports, "WithCardContext", () => $0e4d1dcc80b64254$export$722ea04dd4ef208e);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $6TyVm = parcelRequire("6TyVm");
const $0e4d1dcc80b64254$export$722ea04dd4ef208e = ({ children: children })=>{
    const cardContext = (0, $6TyVm.useSmartCardContext)();
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dc70d.Fragment), {
        children: children(cardContext)
    });
};

});


parcelRegister("2kWIB", function(module, exports) {
$parcel$export(module.exports, "isIntersectionObserverSupported", () => $7b7d7925b7da24ed$export$6c837641a9ab03cb);
/**
 * Mirrors the internal check in `@atlaskit/smart-card`
 * (`src/utils/is-intersection-observer-supported.tsx`), which is not part of that package's
 * public API and so cannot be imported here.
 *
 * Smart Card only forwards its `container` prop to `react-lazily-render` when
 * `IntersectionObserver` is unavailable. When it is available the prop is never read, so the
 * caller can skip resolving a scroll container entirely.
 */ const $7b7d7925b7da24ed$export$6c837641a9ab03cb = ()=>typeof IntersectionObserver !== 'undefined';

});


parcelRegister("5QVr6", function(module, exports) {
$parcel$export(module.exports, "embedCardNodeView", () => $ffa3746f77e9863e$export$86904605fa83de6c);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9wZWu = parcelRequire("9wZWu");

var $7RHfd = parcelRequire("7RHfd");

var $4eNaz = parcelRequire("4eNaz");

var $3PYUJ = parcelRequire("3PYUJ");

var $1mebE = parcelRequire("1mebE");

var $9xvBa = parcelRequire("9xvBa");

var $0Xboy = parcelRequire("0Xboy");

var $d8JFj = parcelRequire("d8JFj");

var $2pWL6 = parcelRequire("2pWL6");

var $5beht = parcelRequire("5beht");

var $acax3 = parcelRequire("acax3");
var $9PK5v = parcelRequire("9PK5v");

var $5bbjm = parcelRequire("5bbjm");

var $47K0n = parcelRequire("47K0n");

var $3y2s4 = parcelRequire("3y2s4");

var $3aMs2 = parcelRequire("3aMs2");

var $gdUUy = parcelRequire("gdUUy");

var $dETMy = parcelRequire("dETMy");

var $2Irvz = parcelRequire("2Irvz");

var $iOHZU = parcelRequire("iOHZU");

var $797yE = parcelRequire("797yE");

var $4zjoa = parcelRequire("4zjoa");

var $k5X6V = parcelRequire("k5X6V");

var $awX3d = parcelRequire("awX3d");

var $9ZsM7 = parcelRequire("9ZsM7");

var $7ZryX = parcelRequire("7ZryX");

var $aciCL = parcelRequire("aciCL");

var $2kWIB = parcelRequire("2kWIB");
const $ffa3746f77e9863e$export$d79f14ec3c108fc0 = (url)=>{
    if (url && (0, $3PYUJ.isConfluenceSlideUrl)(url) && !(0, $gdUUy.fg)('cc-mui-slides-opted-out') && (0, $4zjoa.expValEqualsNoExposure)('cc-mui-slides-experiment', 'isEnabled', true)) // Slides have a 16:9 canvas
    return 16 / 9;
    return undefined;
};
const $ffa3746f77e9863e$var$selector = (states)=>{
    var _states$widthState, _states$widthState2, _states$editorDisable;
    return {
        widthStateLineLength: ((_states$widthState = states.widthState) === null || _states$widthState === void 0 ? void 0 : _states$widthState.lineLength) || 0,
        widthStateWidth: ((_states$widthState2 = states.widthState) === null || _states$widthState2 === void 0 ? void 0 : _states$widthState2.width) || 0,
        editorDisabled: (_states$editorDisable = states.editorDisabledState) === null || _states$editorDisable === void 0 ? void 0 : _states$editorDisable.editorDisabled
    };
};
const $ffa3746f77e9863e$var$CardInner = ({ pluginInjectionApi: pluginInjectionApi, getPosSafely: getPosSafely, getLineLength: getLineLength, view: view, smartCard: smartCard, updateSize: updateSize, getPos: getPos, aspectRatio: aspectRatio, allowResizing: allowResizing, hasPreview: hasPreview, heightAlone: heightAlone, cardProps: cardProps, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
    const { widthStateLineLength: widthStateLineLength, widthStateWidth: widthStateWidth, editorDisabled: editorDisabled } = (0, $5beht.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'width',
        'editorDisabled'
    ], $ffa3746f77e9863e$var$selector);
    const pos = getPosSafely();
    if (pos === undefined) return null;
    const lineLength = getLineLength(view, pos, widthStateLineLength);
    const containerWidth = (0, $9PK5v.isRichMediaInsideOfBlockNode)(view, pos) ? lineLength : widthStateWidth;
    if (!allowResizing || !hasPreview) {
        // There are two ways `width` and `height` can be defined here:
        // 1) Either as `heightAlone` as height value and no width
        // 2) or as `1` for height and aspectRation (defined or a default one) as a width
        // See above for how aspectRation is calculated.
        const defaultAspectRatio = (0, $5bbjm.DEFAULT_EMBED_CARD_WIDTH) / (0, $5bbjm.DEFAULT_EMBED_CARD_HEIGHT);
        let richMediaWrapperHeight = 1;
        let richMediaWrapperWidth = aspectRatio || defaultAspectRatio;
        if (heightAlone) {
            richMediaWrapperHeight = heightAlone;
            richMediaWrapperWidth = undefined;
        }
        return /*#__PURE__*/ (0, $dc70d.jsx)((0, $1mebE.default), {
            ...cardProps,
            height: richMediaWrapperHeight,
            width: richMediaWrapperWidth,
            nodeType: "embedCard",
            hasFallbackContainer: hasPreview,
            lineLength: lineLength,
            containerWidth: containerWidth,
            children: smartCard
        });
    }
    const displayGrid = (visible, gridType, highlight)=>{
        var _pluginInjectionApi$g;
        return pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$g = pluginInjectionApi.grid) === null || _pluginInjectionApi$g === void 0 || (_pluginInjectionApi$g = _pluginInjectionApi$g.actions) === null || _pluginInjectionApi$g === void 0 ? void 0 : _pluginInjectionApi$g.displayGrid(view)({
            visible: visible,
            gridType: gridType,
            highlight: highlight
        });
    };
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $awX3d.default), {
        ...cardProps,
        height: heightAlone,
        aspectRatio: aspectRatio,
        view: view,
        getPos: getPos,
        lineLength: lineLength,
        gridSize: 12,
        containerWidth: containerWidth,
        displayGrid: displayGrid,
        updateSize: updateSize,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        isResizeDisabled: editorDisabled,
        children: smartCard
    });
};
class $ffa3746f77e9863e$export$61b2782f78272a37 extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).PureComponent {
    constructor(props){
        super(props), this.embedIframeRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createRef(), this.getPosSafely = ()=>{
            const { getPos: getPos } = this.props;
            if (!getPos || typeof getPos === 'boolean') return;
            try {
                return getPos();
            } catch  {
            // Can blow up in rare cases, when node has been removed.
            }
        }, this.onResolve = (data)=>{
            const { view: view } = this.props;
            const { title: title, url: url, aspectRatio: resolvedAspectRatio } = data;
            const { originalHeight: originalHeight, originalWidth: originalWidth } = this.props.node.attrs;
            const aspectRatio = $ffa3746f77e9863e$export$d79f14ec3c108fc0(url) ?? resolvedAspectRatio;
            if (aspectRatio && !originalHeight && !originalWidth) {
                // Assumption here is if ADF already have both height and width set,
                // we will going to use that later on in this class as aspectRatio
                // Most likely we dealing with an embed that received aspectRatio via onResolve previously
                // and now this information already stored in ADF.
                this.setState({
                    initialAspectRatio: aspectRatio
                });
                this.saveOriginalDimensionsAttributes((0, $5bbjm.DEFAULT_EMBED_CARD_HEIGHT), (0, $5bbjm.DEFAULT_EMBED_CARD_HEIGHT) * aspectRatio);
            }
            // don't dispatch immediately since we might be in the middle of
            // rendering a nodeview
            (0, $9wZWu.default)(()=>{
                const pos = this.getPosSafely();
                if (pos === undefined) return;
                return view.dispatch((0, $k5X6V.registerCard)({
                    title: title,
                    url: url,
                    pos: pos,
                    id: this.props.id
                })(view.state.tr));
            })();
            try {
                var _this$props$cardConte, _this$props$cardConte2;
                const cardContext = (_this$props$cardConte = this.props.cardContext) !== null && _this$props$cardConte !== void 0 && _this$props$cardConte.value ? (_this$props$cardConte2 = this.props.cardContext) === null || _this$props$cardConte2 === void 0 ? void 0 : _this$props$cardConte2.value : undefined;
                const hasPreview = url && cardContext && cardContext.extractors.getPreview(url, 'web');
                if (!hasPreview) this.setState({
                    hasPreview: false
                });
            } catch  {}
        }, this.updateSize = (pctWidth, layout)=>{
            const { state: state, dispatch: dispatch } = this.props.view;
            const pos = this.getPosSafely();
            if (pos === undefined) return;
            const tr = state.tr.setNodeMarkup(pos, undefined, {
                ...this.props.node.attrs,
                width: pctWidth,
                layout: layout
            });
            tr.setMeta('scrollIntoView', false);
            dispatch(tr);
            return true;
        }, /**
   * Defers line-length measurement until the embed card DOM has fully rendered.
   *
   * When put embed in the expand, reload the page and open that expand, the embed was collapsed.
   * Because the `.rich-media-item` can temporarily report `offsetWidth = 1`, as proportional width styles have not been applied yet.
   * Measuring at that moment would cache the bogus width and break resize calculations.
   * Scheduling a measurement on the next animation frame ensures layout has
   * settled. We then force the node view to re-render so `getLineLength`
   * re-runs and captures the correct width.
   */ this.scheduleLineLengthRemeasureRaf = (0, $9wZWu.default)((view)=>{
            if (view) this.forceUpdate();
        }), this.getLineLength = (view, pos, originalLineLength)=>{
            if (typeof pos === 'number' && (0, $9PK5v.isRichMediaInsideOfBlockNode)(view, pos)) {
                const $pos = view.state.doc.resolve(pos);
                const domNode = view.nodeDOM($pos.pos);
                if ($pos.nodeAfter && (0, $acax3.floatingLayouts).indexOf($pos.nodeAfter.attrs.layout) > -1 && domNode && domNode.parentElement) return domNode.parentElement.offsetWidth;
                if (domNode instanceof HTMLElement) {
                    const measuredWidth = domNode.offsetWidth;
                    if (measuredWidth <= 1) {
                        this.scheduleLineLengthRemeasureRaf(view);
                        return originalLineLength;
                    }
                    return measuredWidth;
                }
            }
            return originalLineLength;
        }, /**
   * Even though render is capable of listening and reacting to iframely wrapper iframe sent `resize` events
   * it's good idea to store latest actual height in ADF, so that when renderer (well, editor as well) is loading
   * we will show embed window of appropriate size and avoid unnecessary content jumping.
   */ this.saveOriginalDimensionsAttributes = (height, width)=>{
            const { view: view } = this.props;
            // Please, do not copy or use this kind of code below
            // @ts-ignore
            const fakeTableResizePluginKey = {
                key: 'tableFlexiColumnResizing$',
                getState: (state)=>{
                    // eslint-disable-next-line
                    return state['tableFlexiColumnResizing$'];
                }
            };
            const fakeTableResizeState = fakeTableResizePluginKey.getState(view.state);
            // We are not updating ADF when this function fired while table is resizing.
            // Changing ADF in the middle of resize will break table resize plugin logic
            // (tables will be considered different at the end of the drag and cell size won't be stored)
            // But this is not a big problem, editor user will be seeing latest height anyway (via updated state)
            // And even if page to be saved with slightly outdated height, renderer is capable of reading latest height value
            // when embed loads, and so it won't be a problem.
            if (fakeTableResizeState !== null && fakeTableResizeState !== void 0 && fakeTableResizeState.dragging) return;
            (0, $9wZWu.default)(()=>{
                const pos = this.getPosSafely();
                if (pos === undefined) return;
                view.dispatch(view.state.tr.step(new (0, $4eNaz.SetAttrsStep)(pos, {
                    originalHeight: height,
                    originalWidth: width
                })).setMeta('addToHistory', false));
            })();
        }, this.onHeightUpdate = (height)=>{
            this.setState({
                liveHeight: height
            });
            this.saveOriginalDimensionsAttributes(height, undefined);
        }, this.onError = ({ err: err })=>{
            if (err) throw err;
        }, this.removeCardDispatched = false;
        this.scrollContainer = (0, $3y2s4.isExperimentEnabled)('platform_editor_reduce_forced_layout_2') && (0, $2kWIB.isIntersectionObserverSupported)() ? undefined : // eslint-disable-next-line @atlaskit/editor/no-as-casting
        (0, $9xvBa.findOverflowScrollParent)(props.view.dom) || undefined;
        this.state = {
            hasPreview: true
        };
    }
    componentWillUnmount() {
        this.removeCard();
    }
    removeCard() {
        if (this.removeCardDispatched) return;
        this.removeCardDispatched = true;
        const { tr: tr } = this.props.view.state;
        (0, $k5X6V.removeCard)({
            id: this.props.id
        })(tr);
        this.props.view.dispatch(tr);
    }
    render() {
        const { node: node, allowResizing: allowResizing, fullWidthMode: fullWidthMode, view: view, dispatchAnalyticsEvent: dispatchAnalyticsEvent, getPos: getPos, pluginInjectionApi: pluginInjectionApi, actionOptions: actionOptions, onClick: onClick, CompetitorPrompt: CompetitorPrompt, isPageSSRed: isPageSSRed } = this.props;
        const { url: url, width: pctWidth, layout: layout, originalHeight: originalHeight, originalWidth: originalWidth } = node.attrs;
        const { hasPreview: hasPreview, liveHeight: liveHeight, initialAspectRatio: initialAspectRatio } = this.state;
        // We don't want to use `originalHeight` when `originalWidth` also present,
        // since `heightAlone` is defined only when just height is available.
        const heightAlone = liveHeight ?? (!originalWidth && originalHeight || undefined);
        const aspectRatio = !heightAlone && // No need getting aspectRatio if heightAlone defined already
        (initialAspectRatio || // If we have initialAspectRatio (coming from iframely) we should go with that
        originalHeight && originalWidth && originalWidth / originalHeight) || // If ADF contains both width and height we get ratio from that
        undefined;
        const cardProps = {
            layout: layout,
            pctWidth: pctWidth,
            fullWidthMode: fullWidthMode
        };
        const smartCard = isPageSSRed ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $iOHZU.CardSSR), {
            url: url,
            appearance: "embed",
            onClick: onClick,
            onResolve: this.onResolve,
            onError: this.onError,
            frameStyle: "show",
            inheritDimensions: true,
            platform: 'web',
            container: this.scrollContainer,
            embedIframeRef: this.embedIframeRef,
            actionOptions: actionOptions,
            CompetitorPrompt: CompetitorPrompt,
            hideIconLoadingSkeleton: true
        }, url) : /*#__PURE__*/ (0, $dc70d.jsx)((0, $dETMy.Card), {
            url: url,
            appearance: "embed",
            onClick: onClick,
            onResolve: this.onResolve,
            onError: this.onError,
            frameStyle: "show",
            inheritDimensions: true,
            platform: 'web',
            container: this.scrollContainer,
            embedIframeRef: this.embedIframeRef,
            actionOptions: actionOptions,
            CompetitorPrompt: CompetitorPrompt
        }, url);
        return /*#__PURE__*/ (0, $dc70d.jsx)((0, $47K0n.SmartLinkDraggable), {
            url: url,
            appearance: (0, $47K0n.SMART_LINK_APPEARANCE).EMBED,
            source: (0, $47K0n.SMART_LINK_DRAG_TYPES).EDITOR,
            children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $2Irvz.EmbedResizeMessageListener), {
                embedIframeRef: this.embedIframeRef,
                onHeightUpdate: this.onHeightUpdate,
                children: /*#__PURE__*/ (0, $dc70d.jsx)($ffa3746f77e9863e$var$CardInner, {
                    pluginInjectionApi: pluginInjectionApi,
                    smartCard: smartCard,
                    hasPreview: hasPreview,
                    getPosSafely: this.getPosSafely,
                    view: view,
                    getLineLength: this.getLineLength,
                    eventDispatcher: this.props.eventDispatcher,
                    updateSize: this.updateSize,
                    getPos: getPos,
                    aspectRatio: aspectRatio,
                    allowResizing: allowResizing,
                    heightAlone: heightAlone,
                    cardProps: cardProps,
                    dispatchAnalyticsEvent: dispatchAnalyticsEvent
                })
            })
        });
    }
}
const $ffa3746f77e9863e$export$a2e44368c194a658 = (props)=>{
    const width = (0, $2pWL6.useSharedPluginStateSelector)(props.pluginInjectionApi, 'width.width');
    const viewAsBlockCard = width && width <= (0, $5bbjm.akEditorFullPageNarrowBreakout);
    return viewAsBlockCard ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $7ZryX.BlockCardComponent), {
        id: props.id,
        node: props.node,
        view: props.view,
        getPos: props.getPos,
        pluginInjectionApi: props.pluginInjectionApi,
        actionOptions: props.actionOptions,
        onClick: props.onClick,
        CompetitorPrompt: props.CompetitorPrompt,
        allowResizing: props.allowResizing,
        fullWidthMode: props.fullWidthMode,
        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
        eventDispatcher: props.eventDispatcher,
        cardContext: props.cardContext,
        smartCard: props.smartCard,
        hasPreview: props.hasPreview,
        liveHeight: props.liveHeight,
        initialAspectRatio: props.initialAspectRatio,
        isPageSSRed: props.isPageSSRed,
        provider: props.provider
    }) : /*#__PURE__*/ (0, $dc70d.jsx)($ffa3746f77e9863e$export$61b2782f78272a37, {
        id: props.id,
        node: props.node,
        view: props.view,
        getPos: props.getPos,
        pluginInjectionApi: props.pluginInjectionApi,
        actionOptions: props.actionOptions,
        onClick: props.onClick,
        CompetitorPrompt: props.CompetitorPrompt,
        allowResizing: props.allowResizing,
        fullWidthMode: props.fullWidthMode,
        dispatchAnalyticsEvent: props.dispatchAnalyticsEvent,
        eventDispatcher: props.eventDispatcher,
        cardContext: props.cardContext,
        smartCard: props.smartCard,
        hasPreview: props.hasPreview,
        liveHeight: props.liveHeight,
        initialAspectRatio: props.initialAspectRatio,
        isPageSSRed: props.isPageSSRed,
        provider: props.provider
    });
};
const $ffa3746f77e9863e$var$WrappedEmbedCardWithCondition = (0, $3aMs2.componentWithCondition)(()=>(0, $797yE.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    }), $ffa3746f77e9863e$export$a2e44368c194a658, $ffa3746f77e9863e$export$61b2782f78272a37);
const $ffa3746f77e9863e$var$WrappedEmbedCard = (0, $aciCL.Card)($ffa3746f77e9863e$var$WrappedEmbedCardWithCondition, (0, $d8JFj.default));
class $ffa3746f77e9863e$export$6789d7ecdc77631b extends (0, $0Xboy.default) {
    viewShouldUpdate(nextNode) {
        if (this.node.attrs !== nextNode.attrs) return true;
        return super.viewShouldUpdate(nextNode);
    }
    createDomRef() {
        var _this$reactComponentP, _this$reactComponentP2;
        const domRef = document.createElement('div');
        // It is a tradeoff for the bug mentioned that occurs in Chrome: https://product-fabric.atlassian.net/browse/ED-5379, https://github.com/ProseMirror/prosemirror/issues/884
        this.unsubscribe = (_this$reactComponentP = this.reactComponentProps.pluginInjectionApi) === null || _this$reactComponentP === void 0 || (_this$reactComponentP = _this$reactComponentP.editorViewMode) === null || _this$reactComponentP === void 0 ? void 0 : _this$reactComponentP.sharedState.onChange(({ nextSharedState: nextSharedState })=>this.updateContentEditable(nextSharedState, domRef));
        this.updateContentEditable((_this$reactComponentP2 = this.reactComponentProps.pluginInjectionApi) === null || _this$reactComponentP2 === void 0 || (_this$reactComponentP2 = _this$reactComponentP2.editorViewMode) === null || _this$reactComponentP2 === void 0 ? void 0 : _this$reactComponentP2.sharedState.currentState(), domRef);
        domRef.setAttribute('spellcheck', 'false');
        return domRef;
    }
    render() {
        const { eventDispatcher: eventDispatcher, allowResizing: allowResizing, fullWidthMode: fullWidthMode, dispatchAnalyticsEvent: dispatchAnalyticsEvent, pluginInjectionApi: pluginInjectionApi, onClickCallback: onClickCallback, CompetitorPrompt: CompetitorPrompt, isPageSSRed: isPageSSRed, provider: provider, intl: intl, smartCardContext: smartCardContext } = this.reactComponentProps;
        return /*#__PURE__*/ (0, $dc70d.jsx)((0, $9ZsM7.SmartCardSSRReactContextsProvider), {
            intl: intl,
            smartCardContext: smartCardContext,
            children: /*#__PURE__*/ (0, $dc70d.jsx)($ffa3746f77e9863e$var$WrappedEmbedCard, {
                node: this.node,
                view: this.view,
                eventDispatcher: eventDispatcher,
                getPos: this.getPos,
                allowResizing: allowResizing,
                fullWidthMode: fullWidthMode,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                pluginInjectionApi: pluginInjectionApi,
                onClickCallback: onClickCallback,
                id: this.id,
                CompetitorPrompt: CompetitorPrompt,
                isPageSSRed: isPageSSRed,
                provider: provider
            })
        });
    }
    /**
   * Prevent ProseMirror from handling drag events on the smart-element-link,
   * allowing native drag to work so SmartLinkDraggable can intercept it.
   * @see {@link https://prosemirror.net/docs/ref/#view.NodeView.stopEvent}
   */ stopEvent(event) {
        if (event.type === 'dragstart') {
            const target = event.target;
            if (target instanceof HTMLElement && target.closest('[data-smart-element-link]')) return true;
        }
        return false;
    }
    destroy() {
        var _this$unsubscribe;
        (_this$unsubscribe = this.unsubscribe) === null || _this$unsubscribe === void 0 || _this$unsubscribe.call(this);
        super.destroy();
    }
    constructor(...args){
        super(...args), // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        this.id = (0, $7RHfd.default)(), this.updateContentEditable = (editorViewModeState, divElement)=>{
            divElement.contentEditable = (editorViewModeState === null || editorViewModeState === void 0 ? void 0 : editorViewModeState.mode) === 'view' ? 'false' : 'true';
        };
    }
}
const $ffa3746f77e9863e$export$86904605fa83de6c = ({ allowResizing: allowResizing, fullWidthMode: fullWidthMode, pmPluginFactoryParams: pmPluginFactoryParams, pluginInjectionApi: pluginInjectionApi, actionOptions: actionOptions, onClickCallback: onClickCallback, CompetitorPrompt: CompetitorPrompt, isPageSSRed: isPageSSRed, provider: provider, intl: intl, smartCardContext: smartCardContext })=>(node, view, getPos)=>{
        const { portalProviderAPI: portalProviderAPI, eventDispatcher: eventDispatcher, dispatchAnalyticsEvent: dispatchAnalyticsEvent } = pmPluginFactoryParams;
        const reactComponentProps = {
            eventDispatcher: eventDispatcher,
            allowResizing: allowResizing,
            fullWidthMode: fullWidthMode,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            pluginInjectionApi: pluginInjectionApi,
            actionOptions: actionOptions,
            onClickCallback: onClickCallback,
            CompetitorPrompt: CompetitorPrompt,
            isPageSSRed: isPageSSRed,
            provider: provider,
            intl: intl,
            smartCardContext: smartCardContext
        };
        return new $ffa3746f77e9863e$export$6789d7ecdc77631b(node, view, getPos, portalProviderAPI, eventDispatcher, reactComponentProps).init();
    };

});
parcelRegister("awX3d", function(module, exports) {
$parcel$export(module.exports, "default", () => $279f413c8f78694b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $e6onJ = parcelRequire("e6onJ");

var $73T1A = parcelRequire("73T1A");

var $glfR6 = parcelRequire("glfR6");

var $gm0BY = parcelRequire("gm0BY");
var $20rxI = parcelRequire("20rxI");
var $lMufz = parcelRequire("lMufz");
var $hzHr6 = parcelRequire("hzHr6");
var $1nvog = parcelRequire("1nvog");
var $13E3v = parcelRequire("13E3v");
var $76GIX = parcelRequire("76GIX");

var $cw0wu = parcelRequire("cw0wu");

var $gab48 = parcelRequire("gab48");

var $5bbjm = parcelRequire("5bbjm");

var $3y2s4 = parcelRequire("3y2s4");

var $2Irvz = parcelRequire("2Irvz");

var $5N1Y4 = parcelRequire("5N1Y4");
// Layouts where the left handle is the only resize handle today.
// These must keep the left handle.
// Remove during 'platform_editor_lovability_resize_dividers_panels' cleanup
const $279f413c8f78694b$var$leftHandleOnlyLayouts = [
    'wrap-right',
    'align-end'
];
class $279f413c8f78694b$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Component {
    static #_ = this.defaultProps = {
        aspectRatio: (0, $5bbjm.DEFAULT_EMBED_CARD_WIDTH) / (0, $5bbjm.DEFAULT_EMBED_CARD_HEIGHT)
    };
    componentDidUpdate(prevProps) {
        const offsetLeft = this.calcOffsetLeft();
        if (offsetLeft !== this.state.offsetLeft && offsetLeft >= 0) this.setState({
            offsetLeft: offsetLeft
        });
        if (this.props.layout !== prevProps.layout) this.checkLayout(prevProps.layout, this.props.layout);
    }
    get wrappedLayout() {
        return (0, $76GIX.wrappedLayouts).indexOf(this.props.layout) > -1;
    }
    /**
   * When returning to center layout from a wrapped/aligned layout, it might actually
   * be wide or full-width
   */ checkLayout(oldLayout, newLayout) {
        const { resizedPctWidth: resizedPctWidth } = this.state;
        if ((0, $76GIX.wrappedLayouts).indexOf(oldLayout) > -1 && newLayout === 'center' && resizedPctWidth) {
            const layout = this.calcUnwrappedLayout(resizedPctWidth, this.calcPxWidth(newLayout));
            this.props.updateSize(resizedPctWidth, layout);
        }
    }
    get $pos() {
        if (typeof this.props.getPos !== 'function') return null;
        const pos = this.props.getPos();
        if (Number.isNaN(pos) || typeof pos !== 'number') return null;
        // need to pass view because we may not get updated props in time
        return this.props.view.state.doc.resolve(pos);
    }
    /**
   * The maxmimum number of grid columns this node can resize to.
   */ get gridWidth() {
        const { gridSize: gridSize } = this.props;
        return !(this.wrappedLayout || this.insideInlineLike) ? gridSize / 2 : gridSize;
    }
    calcOffsetLeft() {
        let offsetLeft = 0;
        if (this.wrapper && this.insideInlineLike) {
            const currentNode = this.wrapper;
            const boundingRect = currentNode.getBoundingClientRect();
            const pmRect = this.props.view.dom.getBoundingClientRect();
            offsetLeft = boundingRect.left - pmRect.left;
        }
        return offsetLeft;
    }
    get wideLayoutWidth() {
        const { lineLength: lineLength } = this.props;
        if (lineLength) return Math.ceil(lineLength * (0, $5bbjm.breakoutWideScaleRatio));
        else return 0, $5bbjm.akEditorWideLayoutWidth;
    }
    // check if is inside of a table
    isNestedInTable() {
        const { table: table } = this.props.view.state.schema.nodes;
        if (!this.$pos) return false;
        return !!(0, $gab48.findParentNodeOfTypeClosestToPos)(this.$pos, table);
    }
    calcSnapPoints() {
        const { offsetLeft: offsetLeft } = this.state;
        const { containerWidth: containerWidth, lineLength: lineLength } = this.props;
        const snapTargets = [];
        for(let i = 0; i < this.gridWidth; i++)snapTargets.push((0, $lMufz.calcPxFromColumns)(i, lineLength, this.gridWidth) - offsetLeft);
        // full width
        snapTargets.push(lineLength - offsetLeft);
        const minimumWidth = (0, $lMufz.calcPxFromColumns)(this.wrappedLayout || this.insideInlineLike ? 1 : 2, lineLength, this.props.gridSize);
        const snapPoints = snapTargets.filter((width)=>width >= minimumWidth);
        const $pos = this.$pos;
        if (!$pos) return snapPoints;
        const isTopLevel = $pos.parent.type.name === 'doc';
        if (isTopLevel) {
            snapPoints.push(this.wideLayoutWidth);
            const fullWidthPoint = containerWidth - (0, $5bbjm.akEditorBreakoutPadding);
            if (fullWidthPoint > this.wideLayoutWidth) snapPoints.push(fullWidthPoint);
        }
        return snapPoints;
    }
    get insideInlineLike() {
        const $pos = this.$pos;
        if (!$pos) return false;
        const { listItem: listItem } = this.props.view.state.schema.nodes;
        return !!(0, $gab48.findParentNodeOfTypeClosestToPos)($pos, [
            listItem
        ]);
    }
    /**
   * Previously height of the box was controlled with paddingTop/paddingBottom trick inside Wrapper.
   * It allowed height to be defined by a given percent ratio and so absolute value was defined by actual width.
   * Also, it was part of styled component, which was fine because it was static through out life time of component.
   *
   * Now, two things changed:
   * 1. If `height` is present we take it as actual height of the box, and hence we don't need
   * (or even can't have, due to lack of width value) paddingTop trick.
   * 2. Since `height` can be changing through out life time of a component, we can't have it as part of styled component,
   * and hence we use `style` prop.
   */ getHeightDefiningComponent() {
        const { height: height, aspectRatio: aspectRatio } = this.props;
        let heightDefiningStyles;
        if (height) heightDefiningStyles = {
            height: `${height}px`
        };
        else // paddingBottom css trick defines ratio of `iframe height (y) + header (32)` to `width (x)`,
        // where is `aspectRatio` defines iframe aspectRatio alone
        // So, visually:
        //
        //            x
        //       ┌──────────┐
        //       │  header  │ 32
        //       ├──────────┤
        //       │          │
        //       │  iframe  │ y
        //       │          │
        //       └──────────┘
        //
        // aspectRatio = x / y
        // paddingBottom = (y + 32) / x
        // which can be achieved with css calc() as (1 / (x/y)) * 100)% + 32px
        heightDefiningStyles = {
            paddingBottom: `calc(${(1 / aspectRatio * 100).toFixed(3)}% + ${0, $2Irvz.embedHeaderHeight}px)`
        };
        return /*#__PURE__*/ (0, $9dQre.jsx)("span", {
            "data-testid": 'resizable-embed-card-height-definer',
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                display: 'block',
                /* Fixes extra padding problem in Firefox */ // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
                fontSize: 0,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
                lineHeight: 0,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                ...heightDefiningStyles
            }
        });
    }
    render() {
        const { layout: layout, pctWidth: pctWidth, containerWidth: containerWidth, fullWidthMode: fullWidthMode, isResizeDisabled: isResizeDisabled, children: children } = this.props;
        const resizerProps = {
            width: this.calcPxWidth(),
            innerPadding: (0, $5bbjm.akEditorMediaResizeHandlerPadding)
        };
        const isLeftResizeHandleDisabled = (0, $5N1Y4.expValEquals)('platform_editor_lovability_resize_dividers_panels', 'isEnabled', true) || (0, $3y2s4.isExperimentEnabled)('platform_editor_remove_left_resize_handle');
        const enable = {};
        (0, $hzHr6.handleSides).forEach((side)=>{
            if (isResizeDisabled) {
                enable[side] = false;
                return;
            }
            // Disable the left handle up-front (except for layouts where it is the
            // only handle) before computing whether it would otherwise be enabled.
            if (side === 'left' && isLeftResizeHandleDisabled && !$279f413c8f78694b$var$leftHandleOnlyLayouts.includes(layout)) {
                enable[side] = false;
                return;
            }
            const oppositeSide = side === 'left' ? 'right' : 'left';
            enable[side] = [
                'full-width',
                'wide',
                'center'
            ].concat(`wrap-${oppositeSide}`).concat(`align-${(0, $1nvog.imageAlignmentMap)[oppositeSide]}`).indexOf(layout) > -1;
            if (side === 'left' && this.insideInlineLike) enable[side] = false;
        });
        const nestedInTableHandleStyles = (isNestedInTable)=>{
            if (!isNestedInTable) return;
            return {
                left: {
                    left: `calc(${"var(--ds-space-negative-025, -2px)"} * 0.5)`,
                    paddingLeft: '0px'
                },
                right: {
                    right: `calc(${"var(--ds-space-negative-025, -2px)"} * 0.5)`,
                    paddingRight: '0px'
                }
            };
        };
        /* eslint-disable  @atlaskit/design-system/consistent-css-prop-usage */ return /*#__PURE__*/ (0, $9dQre.jsx)("div", {
            "data-testid": "resizable-embed-card-spacing"
        }, /*#__PURE__*/ (0, $9dQre.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            css: (0, $glfR6.wrapperStyle)({
                layout: layout,
                isResized: !!pctWidth,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                containerWidth: containerWidth || (0, $5bbjm.DEFAULT_EMBED_CARD_WIDTH),
                fullWidthMode: fullWidthMode
            })
        }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $73T1A.default), {
            ...this.props,
            enable: enable,
            calcNewSize: this.calcNewSize,
            snapPoints: this.calcSnapPoints(),
            scaleFactor: !this.wrappedLayout && !this.insideInlineLike ? 2 : 1,
            highlights: this.highlights,
            nodeType: "embed",
            onResizeStart: this.handleResizeStart,
            handleStyles: nestedInTableHandleStyles(this.isNestedInTable()),
            ...resizerProps
        }, children, this.getHeightDefiningComponent())));
    /* eslint-enable @atlaskit/design-system/consistent-css-prop-usage */ }
    constructor(...args){
        super(...args), this.state = {
            offsetLeft: this.calcOffsetLeft()
        }, this.calcNewSize = (newWidth, stop)=>{
            const { layout: layout, view: { state: state } } = this.props;
            const newPct = (0, $20rxI.calcPctFromPx)(newWidth, this.props.lineLength) * 100;
            this.setState({
                resizedPctWidth: newPct
            });
            let newLayout = (0, $gab48.hasParentNodeOfType)(state.schema.nodes.table)(state.selection) ? layout : this.calcUnwrappedLayout(newPct, newWidth);
            if (newPct <= 100) {
                if (this.wrappedLayout && (stop ? newPct !== 100 : true)) newLayout = layout;
                return {
                    width: newPct,
                    layout: newLayout
                };
            } else return {
                width: this.props.pctWidth || null,
                layout: newLayout
            };
        }, this.calcUnwrappedLayout = (pct, width)=>{
            if (pct <= 100) return 'center';
            if (width <= this.wideLayoutWidth) return 'wide';
            return 'full-width';
        }, this.calcColumnLeftOffset = ()=>{
            const { offsetLeft: offsetLeft } = this.state;
            return this.insideInlineLike ? (0, $gm0BY.calcColumnsFromPx)(offsetLeft, this.props.lineLength, this.props.gridSize) : 0;
        }, this.calcPxWidth = (useLayout)=>{
            const { layout: layout, pctWidth: pctWidth, lineLength: lineLength, containerWidth: containerWidth, fullWidthMode: fullWidthMode, getPos: getPos, view: { state: state } } = this.props;
            const { resizedPctWidth: resizedPctWidth } = this.state;
            const pos = typeof getPos === 'function' ? getPos() : undefined;
            return (0, $e6onJ.calcMediaPxWidth)({
                origWidth: (0, $5bbjm.DEFAULT_EMBED_CARD_WIDTH),
                origHeight: (0, $5bbjm.DEFAULT_EMBED_CARD_HEIGHT),
                pctWidth: pctWidth,
                state: state,
                containerWidth: {
                    width: containerWidth,
                    lineLength: lineLength
                },
                isFullWidthModeEnabled: fullWidthMode,
                layout: useLayout || layout,
                pos: pos,
                resizedPctWidth: resizedPctWidth
            });
        }, this.handleResizeStart = ()=>{
            const { view: view, getPos: getPos } = this.props;
            if (typeof getPos === 'function') {
                const pos = getPos();
                if (typeof pos === 'number') {
                    const tr = view.state.tr.setSelection((0, $cw0wu.NodeSelection).create(view.state.doc, pos));
                    tr.setMeta('scrollIntoView', false);
                    view.dispatch(tr);
                }
            }
        }, this.highlights = (newWidth, snapPoints)=>{
            const snapWidth = (0, $13E3v.snapTo)(newWidth, snapPoints);
            const { layoutColumn: layoutColumn, table: table, expand: expand, nestedExpand: nestedExpand, bodiedSyncBlock: bodiedSyncBlock } = this.props.view.state.schema.nodes;
            // Hide resizing guideline when embed is nested
            if (this.$pos && !!(0, $gab48.findParentNodeOfTypeClosestToPos)(this.$pos, [
                layoutColumn,
                table,
                expand,
                nestedExpand,
                bodiedSyncBlock
            ])) return [];
            if (snapWidth > this.wideLayoutWidth) return [
                'full-width'
            ];
            const { layout: layout, lineLength: lineLength, gridSize: gridSize } = this.props;
            const columns = (0, $gm0BY.calcColumnsFromPx)(snapWidth, lineLength, gridSize);
            const columnWidth = Math.round(columns);
            const highlight = [];
            if (layout === 'wrap-left' || layout === 'align-start') highlight.push(0, columnWidth);
            else if (layout === 'wrap-right' || layout === 'align-end') highlight.push(gridSize, gridSize - columnWidth);
            else if (this.insideInlineLike) highlight.push(Math.round(columns + this.calcColumnLeftOffset()));
            else highlight.push(Math.floor((gridSize - columnWidth) / 2), Math.ceil((gridSize + columnWidth) / 2));
            return highlight;
        };
    }
}

});
parcelRegister("e6onJ", function(module, exports) {
$parcel$export(module.exports, "calcMediaPxWidth", () => $d84b779d741ca97e$export$5e51fc02b9ada5af);

var $5bbjm = parcelRequire("5bbjm");

var $gm0BY = parcelRequire("gm0BY");

var $lMufz = parcelRequire("lMufz");

var $gmylC = parcelRequire("gmylC");

var $76GIX = parcelRequire("76GIX");

const $d84b779d741ca97e$var$validWidthModes = [
    'center',
    'wrap-left',
    'wrap-right',
    'align-start',
    'align-end'
];
const $d84b779d741ca97e$export$adfc02948d64a4f2 = (layout)=>$d84b779d741ca97e$var$validWidthModes.indexOf(layout) > -1;
const $d84b779d741ca97e$export$144a1e648ed4962e = (containerWidth, pctWidth, origWidth, origHeight)=>pctWidth && origWidth && origHeight && Math.ceil((0, $gmylC.calcPxFromPct)(pctWidth / 100, containerWidth.lineLength || containerWidth.width));
const $d84b779d741ca97e$export$5e51fc02b9ada5af = (opts)=>{
    const { origWidth: origWidth, origHeight: origHeight, layout: layout, pctWidth: pctWidth, containerWidth: containerWidth, resizedPctWidth: resizedPctWidth } = opts;
    const { width: width, lineLength: lineLength } = containerWidth;
    const calculatedPctWidth = $d84b779d741ca97e$export$144a1e648ed4962e(containerWidth, pctWidth, origWidth, origHeight);
    const calculatedResizedPctWidth = $d84b779d741ca97e$export$144a1e648ed4962e(containerWidth, resizedPctWidth, origWidth, origHeight);
    if (layout === 'wide') {
        if (lineLength) {
            const wideWidth = Math.ceil(lineLength * (0, $5bbjm.breakoutWideScaleRatio));
            return wideWidth > width ? lineLength : wideWidth;
        }
    } else if (layout === 'full-width') return width - (0, $5bbjm.akEditorBreakoutPadding);
    else if (calculatedPctWidth) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        if ((0, $76GIX.wrappedLayouts).indexOf(layout) > -1) {
            if (calculatedResizedPctWidth) {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                if (resizedPctWidth < 50) return calculatedResizedPctWidth;
                return calculatedPctWidth;
            }
            return calculatedPctWidth;
        }
        if (calculatedResizedPctWidth) return calculatedResizedPctWidth;
        return calculatedPctWidth;
    } else if (layout === 'center') {
        if (calculatedResizedPctWidth) return calculatedResizedPctWidth;
        return Math.min(origWidth, lineLength || width);
    } else if (layout && (0, $76GIX.wrappedLayouts).indexOf(layout) !== -1) // when layout is wrap-left, wrap-right, align-start, align-end
    // but no pctWidth is defined
    return Math.min((0, $gmylC.calcPxFromPct)(0.5, lineLength || width), origWidth);
    return origWidth;
};
const $d84b779d741ca97e$export$195604d042fd3f87 = (gridWidth, width, height, lineLength, gridSize)=>{
    const pxWidth = (0, $gmylC.calcPxFromPct)(gridWidth / 100, lineLength);
    const columnSpan = Math.round((0, $gm0BY.calcColumnsFromPx)(pxWidth, lineLength, gridSize));
    const alignedWidth = (0, $lMufz.calcPxFromColumns)(columnSpan, lineLength, gridSize);
    return {
        height: height / width * alignedWidth,
        width: alignedWidth
    };
};

});
parcelRegister("gm0BY", function(module, exports) {
$parcel$export(module.exports, "calcColumnsFromPx", () => $577e38a1f403c520$export$10912f14d8d54640);

var $29qUP = parcelRequire("29qUP");
function $577e38a1f403c520$export$10912f14d8d54640(width, lineLength, gridSize) {
    const maxWidth = lineLength + (0, $29qUP.MEDIA_SINGLE_GUTTER_SIZE);
    return (width + (0, $29qUP.MEDIA_SINGLE_GUTTER_SIZE)) * gridSize / maxWidth;
}

});

parcelRegister("gmylC", function(module, exports) {
$parcel$export(module.exports, "calcPxFromPct", () => $1394a594a615bc25$export$e70e278a1f662f8d);

var $29qUP = parcelRequire("29qUP");
function $1394a594a615bc25$export$e70e278a1f662f8d(pct, lineLength) {
    const maxWidth = lineLength + (0, $29qUP.MEDIA_SINGLE_GUTTER_SIZE);
    return maxWidth * pct - (0, $29qUP.MEDIA_SINGLE_GUTTER_SIZE);
}

});


parcelRegister("73T1A", function(module, exports) {
$parcel$export(module.exports, "default", () => $96aae3bbcab29847$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $2YfQG = parcelRequire("2YfQG");

var $4UfGH = parcelRequire("4UfGH");

var $5bbjm = parcelRequire("5bbjm");

var $3y2s4 = parcelRequire("3y2s4");

var $g6Qq4 = parcelRequire("g6Qq4");

var $5LDnu = parcelRequire("5LDnu");

var $e4CUM = parcelRequire("e4CUM");

var $hzHr6 = parcelRequire("hzHr6");

var $13E3v = parcelRequire("13E3v");
const $96aae3bbcab29847$var$getResizeAnalyticsEvent = (type, size, layout)=>{
    const actionSubject = type === 'embed' ? (0, $g6Qq4.ACTION_SUBJECT).EMBEDS : (0, $g6Qq4.ACTION_SUBJECT).MEDIA_SINGLE;
    return {
        action: (0, $g6Qq4.ACTION).EDITED,
        actionSubject: actionSubject,
        actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).RESIZED,
        attributes: {
            size: size,
            layout: layout
        },
        eventType: (0, $g6Qq4.EVENT_TYPE).UI
    };
};
const $96aae3bbcab29847$var$getWidthFromSnapPoints = (width, snapPoints)=>{
    if (snapPoints.length) return Math.min(Math.max(width, snapPoints[0]), snapPoints[snapPoints.length - 1]);
    return width;
};
class $96aae3bbcab29847$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Component {
    render() {
        const baseHandleStyles = {};
        const handles = {};
        const handleComponent = {};
        const { innerPadding: innerPadding = 0, width: width, pctWidth: pctWidth, selected: selected, layout: layout, enable: enable, children: children, ratio: ratio, handleComponentFunc: handleComponentFunc, handleStyles: handleStyles } = this.props;
        const { isResizing: isResizing } = this.state;
        // Tables supply the lower value; media outside tables retains its existing layer.
        const resizeHandleZIndex = (0, $3y2s4.isExperimentEnabled)('platform_editor_sticky_headers_zindex') ? `var(--ak-editor-table-resize-handle-z-index, ${0, $5bbjm.akRichMediaResizeZIndex})` : (0, $5bbjm.akRichMediaResizeZIndex);
        (0, $hzHr6.handleSides).forEach((side)=>{
            handles[side] = `richMedia-resize-handle-${side}`;
            baseHandleStyles[side] = {
                width: '24px',
                [side]: `${-13 - innerPadding}px`,
                zIndex: resizeHandleZIndex,
                pointerEvents: 'auto'
            };
            const sideHandleComponent = handleComponentFunc && handleComponentFunc(side);
            if (sideHandleComponent) handleComponent[side] = sideHandleComponent;
        });
        const updatedHandleStyles = {
            left: {
                ...baseHandleStyles.left,
                ...handleStyles === null || handleStyles === void 0 ? void 0 : handleStyles.left
            },
            right: {
                ...baseHandleStyles.right,
                ...handleStyles === null || handleStyles === void 0 ? void 0 : handleStyles.right
            }
        };
        const className = (0, (/*@__PURE__*/$parcel$interopDefault($2YfQG)))((0, $5LDnu.richMediaClassName), `image-${layout}`, this.props.className, {
            'is-resizing': isResizing,
            'not-resized': !pctWidth,
            'richMedia-selected': selected,
            'rich-media-wrapped': layout === 'wrap-left' || layout === 'wrap-right'
        });
        let handleWrapperStyle;
        if (ratio) handleWrapperStyle = {
            position: 'absolute',
            width: '100%',
            paddingBottom: `${ratio}%`,
            top: 0,
            pointerEvents: 'none'
        };
        const nonZeroWidth = width || '100%'; // In SSR width could be 0 initially
        // Ideally, Resizable would let you pass in the component rather than
        // the div. For now, we just apply the same styles using CSS
        return /*#__PURE__*/ (0, $dc70d.jsx)((0, $4UfGH.Resizable), {
            ref: this.resizable,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            size: {
                width: nonZeroWidth,
                // just content itself (no paddings)
                height: 'auto'
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            handleClasses: handles,
            handleStyles: updatedHandleStyles,
            handleWrapperStyle: handleWrapperStyle,
            handleComponent: handleComponent,
            enable: enable,
            onResize: this.handleResize,
            onResizeStop: this.handleResizeStop,
            onResizeStart: this.handleResizeStart,
            children: children
        });
    }
    constructor(...args){
        super(...args), this.resizable = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createRef(), this.state = {
            isResizing: false
        }, this.handleResizeStart = (event)=>{
            const { innerPadding: innerPadding = 0, highlights: highlights, displayGrid: displayGrid, layout: layout, width: width, snapPoints: snapPoints, onResizeStart: onResizeStart } = this.props;
            // prevent creating a drag event on Firefox
            event.preventDefault();
            if (onResizeStart) onResizeStart();
            this.setState({
                isResizing: true
            }, ()=>{
                const newHighlights = highlights(width + innerPadding, snapPoints);
                displayGrid === null || displayGrid === void 0 || displayGrid(newHighlights.length > 0, (0, $e4CUM.gridTypeForLayout)(layout), newHighlights);
            });
        }, this.handleResize = (_event, _direction, _elementRef, delta)=>{
            const { highlights: highlights, calcNewSize: calcNewSize, scaleFactor: scaleFactor, snapPoints: snapPoints, displayGrid: displayGrid, layout: layout, updateSize: updateSize, innerPadding: innerPadding = 0 } = this.props;
            const resizable = this.resizable.current;
            const { isResizing: isResizing } = this.state;
            if (!resizable || !resizable.state.original || !isResizing) return;
            const newWidth = $96aae3bbcab29847$var$getWidthFromSnapPoints(resizable.state.original.width + delta.width * (scaleFactor || 1), snapPoints);
            const newSize = calcNewSize(newWidth + innerPadding, false);
            if (newSize.layout !== layout) updateSize(newSize.width, newSize.layout);
            const newHighlights = highlights(newWidth, snapPoints);
            displayGrid === null || displayGrid === void 0 || displayGrid(newHighlights.length > 0, (0, $e4CUM.gridTypeForLayout)(newSize.layout), newHighlights);
            resizable.updateSize({
                width: newWidth,
                height: 'auto'
            });
            resizable.setState({
                isResizing: true
            });
        }, this.handleResizeStop = (_event, _direction, _elementRef, delta)=>{
            const { highlights: highlights, calcNewSize: calcNewSize, snapPoints: snapPoints, displayGrid: displayGrid, layout: layout, updateSize: updateSize, dispatchAnalyticsEvent: dispatchAnalyticsEvent, nodeType: nodeType } = this.props;
            const resizable = this.resizable.current;
            const { isResizing: isResizing } = this.state;
            if (!resizable || !resizable.state.original || !isResizing) return;
            const newWidth = $96aae3bbcab29847$var$getWidthFromSnapPoints(resizable.state.original.width + delta.width, snapPoints);
            const snapWidth = (0, $13E3v.snapTo)(newWidth, snapPoints);
            const newSize = calcNewSize(snapWidth, true);
            const newHighlights = highlights(newWidth, snapPoints);
            if (dispatchAnalyticsEvent) dispatchAnalyticsEvent($96aae3bbcab29847$var$getResizeAnalyticsEvent(nodeType, newSize.width, newSize.layout));
            // show committed grid size
            displayGrid === null || displayGrid === void 0 || displayGrid(newHighlights.length > 0, (0, $e4CUM.gridTypeForLayout)(newSize.layout), newHighlights);
            this.setState({
                isResizing: false
            }, ()=>{
                updateSize(newSize.width, newSize.layout);
                displayGrid === null || displayGrid === void 0 || displayGrid(false, (0, $e4CUM.gridTypeForLayout)(layout), []);
            });
        };
    }
}

});
parcelRegister("4UfGH", function(module, exports) {
"use strict";
var $39288fa70c8527a9$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $39288fa70c8527a9$var$__assign = module.exports && module.exports.__assign || function() {
    $39288fa70c8527a9$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $39288fa70c8527a9$var$__assign.apply(this, arguments);
};
var $39288fa70c8527a9$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result["default"] = mod;
    return result;
};
var $39288fa70c8527a9$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $39288fa70c8527a9$var$React = $39288fa70c8527a9$var$__importStar((parcelRequire("bSJIT")));

var $bSibd = parcelRequire("bSibd");

var $39288fa70c8527a9$var$fast_memoize_1 = $39288fa70c8527a9$var$__importDefault((parcelRequire("036ir")));
var $39288fa70c8527a9$var$DEFAULT_SIZE = {
    width: 'auto',
    height: 'auto'
};
var $39288fa70c8527a9$var$clamp = $39288fa70c8527a9$var$fast_memoize_1.default(function(n, min, max) {
    return Math.max(Math.min(n, max), min);
});
var $39288fa70c8527a9$var$snap = $39288fa70c8527a9$var$fast_memoize_1.default(function(n, size) {
    return Math.round(n / size) * size;
});
var $39288fa70c8527a9$var$hasDirection = $39288fa70c8527a9$var$fast_memoize_1.default(function(dir, target) {
    return new RegExp(dir, 'i').test(target);
});
var $39288fa70c8527a9$var$findClosestSnap = $39288fa70c8527a9$var$fast_memoize_1.default(function(n, snapArray, snapGap) {
    if (snapGap === void 0) snapGap = 0;
    var closestGapIndex = snapArray.reduce(function(prev, curr, index) {
        return Math.abs(curr - n) < Math.abs(snapArray[prev] - n) ? index : prev;
    }, 0);
    var gap = Math.abs(snapArray[closestGapIndex] - n);
    return snapGap === 0 || gap < snapGap ? snapArray[closestGapIndex] : n;
});
var $39288fa70c8527a9$var$endsWith = $39288fa70c8527a9$var$fast_memoize_1.default(function(str, searchStr) {
    return str.substr(str.length - searchStr.length, searchStr.length) === searchStr;
});
var $39288fa70c8527a9$var$getStringSize = $39288fa70c8527a9$var$fast_memoize_1.default(function(n) {
    n = n.toString();
    if (n === 'auto') return n;
    if ($39288fa70c8527a9$var$endsWith(n, 'px')) return n;
    if ($39288fa70c8527a9$var$endsWith(n, '%')) return n;
    if ($39288fa70c8527a9$var$endsWith(n, 'vh')) return n;
    if ($39288fa70c8527a9$var$endsWith(n, 'vw')) return n;
    if ($39288fa70c8527a9$var$endsWith(n, 'vmax')) return n;
    if ($39288fa70c8527a9$var$endsWith(n, 'vmin')) return n;
    return n + "px";
});
var $39288fa70c8527a9$var$calculateNewMax = $39288fa70c8527a9$var$fast_memoize_1.default(function(parentSize, maxWidth, maxHeight, minWidth, minHeight) {
    if (maxWidth && typeof maxWidth === 'string' && $39288fa70c8527a9$var$endsWith(maxWidth, '%')) {
        var ratio = Number(maxWidth.replace('%', '')) / 100;
        maxWidth = parentSize.width * ratio;
    }
    if (maxHeight && typeof maxHeight === 'string' && $39288fa70c8527a9$var$endsWith(maxHeight, '%')) {
        var ratio = Number(maxHeight.replace('%', '')) / 100;
        maxHeight = parentSize.height * ratio;
    }
    if (minWidth && typeof minWidth === 'string' && $39288fa70c8527a9$var$endsWith(minWidth, '%')) {
        var ratio = Number(minWidth.replace('%', '')) / 100;
        minWidth = parentSize.width * ratio;
    }
    if (minHeight && typeof minHeight === 'string' && $39288fa70c8527a9$var$endsWith(minHeight, '%')) {
        var ratio = Number(minHeight.replace('%', '')) / 100;
        minHeight = parentSize.height * ratio;
    }
    return {
        maxWidth: typeof maxWidth === 'undefined' ? undefined : Number(maxWidth),
        maxHeight: typeof maxHeight === 'undefined' ? undefined : Number(maxHeight),
        minWidth: typeof minWidth === 'undefined' ? undefined : Number(minWidth),
        minHeight: typeof minHeight === 'undefined' ? undefined : Number(minHeight)
    };
});
var $39288fa70c8527a9$var$definedProps = [
    'style',
    'className',
    'grid',
    'snap',
    'bounds',
    'size',
    'defaultSize',
    'minWidth',
    'minHeight',
    'maxWidth',
    'maxHeight',
    'lockAspectRatio',
    'lockAspectRatioExtraWidth',
    'lockAspectRatioExtraHeight',
    'enable',
    'handleStyles',
    'handleClasses',
    'handleWrapperStyle',
    'handleWrapperClass',
    'children',
    'onResizeStart',
    'onResize',
    'onResizeStop',
    'handleComponent',
    'scale',
    'resizeRatio',
    'snapGap'
];
// HACK: This class is used to calculate % size.
var $39288fa70c8527a9$var$baseClassName = '__resizable_base__';
var $39288fa70c8527a9$var$Resizable = /** @class */ function(_super) {
    $39288fa70c8527a9$var$__extends(Resizable, _super);
    function Resizable(props) {
        var _this = _super.call(this, props) || this;
        _this.ratio = 1;
        _this.resizable = null;
        // For parent boundary
        _this.parentLeft = 0;
        _this.parentTop = 0;
        // For boundary
        _this.resizableLeft = 0;
        _this.resizableTop = 0;
        // For target boundary
        _this.targetLeft = 0;
        _this.targetTop = 0;
        _this.state = {
            isResizing: false,
            resizeCursor: 'auto',
            width: typeof (_this.propsSize && _this.propsSize.width) === 'undefined' ? 'auto' : _this.propsSize && _this.propsSize.width,
            height: typeof (_this.propsSize && _this.propsSize.height) === 'undefined' ? 'auto' : _this.propsSize && _this.propsSize.height,
            direction: 'right',
            original: {
                x: 0,
                y: 0,
                width: 0,
                height: 0
            }
        };
        _this.onResizeStart = _this.onResizeStart.bind(_this);
        _this.onMouseMove = _this.onMouseMove.bind(_this);
        _this.onMouseUp = _this.onMouseUp.bind(_this);
        if (typeof window !== 'undefined') {
            window.addEventListener('mouseup', _this.onMouseUp);
            window.addEventListener('mousemove', _this.onMouseMove);
            window.addEventListener('mouseleave', _this.onMouseUp);
            window.addEventListener('touchmove', _this.onMouseMove);
            window.addEventListener('touchend', _this.onMouseUp);
        }
        return _this;
    }
    Object.defineProperty(Resizable.prototype, "parentNode", {
        get: function() {
            if (!this.resizable) return null;
            return this.resizable.parentNode;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "propsSize", {
        get: function() {
            return this.props.size || this.props.defaultSize || $39288fa70c8527a9$var$DEFAULT_SIZE;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "base", {
        get: function() {
            var parent = this.parentNode;
            if (!parent) return undefined;
            var children = [].slice.call(parent.children);
            for(var _i = 0, children_1 = children; _i < children_1.length; _i++){
                var n = children_1[_i];
                if (n instanceof HTMLElement) {
                    if (n.classList.contains($39288fa70c8527a9$var$baseClassName)) return n;
                }
            }
            return undefined;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "size", {
        get: function() {
            var width = 0;
            var height = 0;
            if (typeof window !== 'undefined' && this.resizable) {
                var orgWidth = this.resizable.offsetWidth;
                var orgHeight = this.resizable.offsetHeight;
                // HACK: Set position `relative` to get parent size.
                //       This is because when re-resizable set `absolute`, I can not get base width correctly.
                var orgPosition = this.resizable.style.position;
                if (orgPosition !== 'relative') this.resizable.style.position = 'relative';
                // INFO: Use original width or height if set auto.
                width = this.resizable.style.width !== 'auto' ? this.resizable.offsetWidth : orgWidth;
                height = this.resizable.style.height !== 'auto' ? this.resizable.offsetHeight : orgHeight;
                // Restore original position
                this.resizable.style.position = orgPosition;
            }
            return {
                width: width,
                height: height
            };
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Resizable.prototype, "sizeStyle", {
        get: function() {
            var _this = this;
            var size = this.props.size;
            var getSize = function(key) {
                if (typeof _this.state[key] === 'undefined' || _this.state[key] === 'auto') return 'auto';
                if (_this.propsSize && _this.propsSize[key] && $39288fa70c8527a9$var$endsWith(_this.propsSize[key].toString(), '%')) {
                    if ($39288fa70c8527a9$var$endsWith(_this.state[key].toString(), '%')) return _this.state[key].toString();
                    var parentSize = _this.getParentSize();
                    var value = Number(_this.state[key].toString().replace('px', ''));
                    var percent = value / parentSize[key] * 100;
                    return percent + "%";
                }
                return $39288fa70c8527a9$var$getStringSize(_this.state[key]);
            };
            var width = size && typeof size.width !== 'undefined' && !this.state.isResizing ? $39288fa70c8527a9$var$getStringSize(size.width) : getSize('width');
            var height = size && typeof size.height !== 'undefined' && !this.state.isResizing ? $39288fa70c8527a9$var$getStringSize(size.height) : getSize('height');
            return {
                width: width,
                height: height
            };
        },
        enumerable: true,
        configurable: true
    });
    Resizable.prototype.getParentSize = function() {
        if (!this.base || !this.parentNode) return {
            width: window.innerWidth,
            height: window.innerHeight
        };
        // INFO: To calculate parent width with flex layout
        var wrapChanged = false;
        var wrap = this.parentNode.style.flexWrap;
        var minWidth = this.base.style.minWidth;
        if (wrap !== 'wrap') {
            wrapChanged = true;
            this.parentNode.style.flexWrap = 'wrap';
        // HACK: Use relative to get parent padding size
        }
        this.base.style.position = 'relative';
        this.base.style.minWidth = '100%';
        var size = {
            width: this.base.offsetWidth,
            height: this.base.offsetHeight
        };
        this.base.style.position = 'absolute';
        if (wrapChanged) this.parentNode.style.flexWrap = wrap;
        this.base.style.minWidth = minWidth;
        return size;
    };
    Resizable.prototype.componentDidMount = function() {
        this.setState({
            width: this.state.width || this.size.width,
            height: this.state.height || this.size.height
        });
        var parent = this.parentNode;
        if (!(parent instanceof HTMLElement)) return;
        if (this.base) return;
        var element = document.createElement('div');
        element.style.width = '100%';
        element.style.height = '100%';
        element.style.position = 'absolute';
        element.style.transform = 'scale(0, 0)';
        element.style.left = '0';
        element.style.flex = '0';
        if (element.classList) element.classList.add($39288fa70c8527a9$var$baseClassName);
        else element.className += $39288fa70c8527a9$var$baseClassName;
        parent.appendChild(element);
    };
    Resizable.prototype.componentWillUnmount = function() {
        if (typeof window !== 'undefined') {
            window.removeEventListener('mouseup', this.onMouseUp);
            window.removeEventListener('mousemove', this.onMouseMove);
            window.removeEventListener('mouseleave', this.onMouseUp);
            window.removeEventListener('touchmove', this.onMouseMove);
            window.removeEventListener('touchend', this.onMouseUp);
            var parent_1 = this.parentNode;
            if (!this.base || !parent_1) return;
            if (!(parent_1 instanceof HTMLElement) || !(this.base instanceof Node)) return;
            parent_1.removeChild(this.base);
        }
    };
    Resizable.prototype.createSizeForCssProperty = function(newSize, kind) {
        var propsSize = this.propsSize && this.propsSize[kind];
        return this.state[kind] === 'auto' && this.state.original[kind] === newSize && (typeof propsSize === 'undefined' || propsSize === 'auto') ? 'auto' : newSize;
    };
    Resizable.prototype.calculateNewMaxFromBoundary = function(maxWidth, maxHeight) {
        if (this.props.bounds === 'parent') {
            var parent_2 = this.parentNode;
            if (parent_2 instanceof HTMLElement) {
                var boundWidth = parent_2.offsetWidth + (this.parentLeft - this.resizableLeft);
                var boundHeight = parent_2.offsetHeight + (this.parentTop - this.resizableTop);
                maxWidth = maxWidth && maxWidth < boundWidth ? maxWidth : boundWidth;
                maxHeight = maxHeight && maxHeight < boundHeight ? maxHeight : boundHeight;
            }
        } else if (this.props.bounds === 'window') {
            if (typeof window !== 'undefined') {
                var boundWidth = window.innerWidth - this.resizableLeft;
                var boundHeight = window.innerHeight - this.resizableTop;
                maxWidth = maxWidth && maxWidth < boundWidth ? maxWidth : boundWidth;
                maxHeight = maxHeight && maxHeight < boundHeight ? maxHeight : boundHeight;
            }
        } else if (this.props.bounds instanceof HTMLElement) {
            var boundWidth = this.props.bounds.offsetWidth + (this.targetLeft - this.resizableLeft);
            var boundHeight = this.props.bounds.offsetHeight + (this.targetTop - this.resizableTop);
            maxWidth = maxWidth && maxWidth < boundWidth ? maxWidth : boundWidth;
            maxHeight = maxHeight && maxHeight < boundHeight ? maxHeight : boundHeight;
        }
        return {
            maxWidth: maxWidth,
            maxHeight: maxHeight
        };
    };
    Resizable.prototype.calculateNewSizeFromDirection = function(clientX, clientY) {
        var scale = this.props.scale || 1;
        var resizeRatio = this.props.resizeRatio || 1;
        var _a = this.state, direction = _a.direction, original = _a.original;
        var _b = this.props, lockAspectRatio = _b.lockAspectRatio, lockAspectRatioExtraHeight = _b.lockAspectRatioExtraHeight, lockAspectRatioExtraWidth = _b.lockAspectRatioExtraWidth;
        var newWidth = original.width;
        var newHeight = original.height;
        var extraHeight = lockAspectRatioExtraHeight || 0;
        var extraWidth = lockAspectRatioExtraWidth || 0;
        if ($39288fa70c8527a9$var$hasDirection('right', direction)) {
            newWidth = original.width + (clientX - original.x) * resizeRatio / scale;
            if (lockAspectRatio) newHeight = (newWidth - extraWidth) / this.ratio + extraHeight;
        }
        if ($39288fa70c8527a9$var$hasDirection('left', direction)) {
            newWidth = original.width - (clientX - original.x) * resizeRatio / scale;
            if (lockAspectRatio) newHeight = (newWidth - extraWidth) / this.ratio + extraHeight;
        }
        if ($39288fa70c8527a9$var$hasDirection('bottom', direction)) {
            newHeight = original.height + (clientY - original.y) * resizeRatio / scale;
            if (lockAspectRatio) newWidth = (newHeight - extraHeight) * this.ratio + extraWidth;
        }
        if ($39288fa70c8527a9$var$hasDirection('top', direction)) {
            newHeight = original.height - (clientY - original.y) * resizeRatio / scale;
            if (lockAspectRatio) newWidth = (newHeight - extraHeight) * this.ratio + extraWidth;
        }
        return {
            newWidth: newWidth,
            newHeight: newHeight
        };
    };
    Resizable.prototype.calculateNewSizeFromAspectRatio = function(newWidth, newHeight, max, min) {
        var _a = this.props, lockAspectRatio = _a.lockAspectRatio, lockAspectRatioExtraHeight = _a.lockAspectRatioExtraHeight, lockAspectRatioExtraWidth = _a.lockAspectRatioExtraWidth;
        var computedMinWidth = typeof min.width === 'undefined' ? 10 : min.width;
        var computedMaxWidth = typeof max.width === 'undefined' || max.width < 0 ? newWidth : max.width;
        var computedMinHeight = typeof min.height === 'undefined' ? 10 : min.height;
        var computedMaxHeight = typeof max.height === 'undefined' || max.height < 0 ? newHeight : max.height;
        var extraHeight = lockAspectRatioExtraHeight || 0;
        var extraWidth = lockAspectRatioExtraWidth || 0;
        if (lockAspectRatio) {
            var extraMinWidth = (computedMinHeight - extraHeight) * this.ratio + extraWidth;
            var extraMaxWidth = (computedMaxHeight - extraHeight) * this.ratio + extraWidth;
            var extraMinHeight = (computedMinWidth - extraWidth) / this.ratio + extraHeight;
            var extraMaxHeight = (computedMaxWidth - extraWidth) / this.ratio + extraHeight;
            var lockedMinWidth = Math.max(computedMinWidth, extraMinWidth);
            var lockedMaxWidth = Math.min(computedMaxWidth, extraMaxWidth);
            var lockedMinHeight = Math.max(computedMinHeight, extraMinHeight);
            var lockedMaxHeight = Math.min(computedMaxHeight, extraMaxHeight);
            newWidth = $39288fa70c8527a9$var$clamp(newWidth, lockedMinWidth, lockedMaxWidth);
            newHeight = $39288fa70c8527a9$var$clamp(newHeight, lockedMinHeight, lockedMaxHeight);
        } else {
            newWidth = $39288fa70c8527a9$var$clamp(newWidth, computedMinWidth, computedMaxWidth);
            newHeight = $39288fa70c8527a9$var$clamp(newHeight, computedMinHeight, computedMaxHeight);
        }
        return {
            newWidth: newWidth,
            newHeight: newHeight
        };
    };
    Resizable.prototype.setBoundingClientRect = function() {
        // For parent boundary
        if (this.props.bounds === 'parent') {
            var parent_3 = this.parentNode;
            if (parent_3 instanceof HTMLElement) {
                var parentRect = parent_3.getBoundingClientRect();
                this.parentLeft = parentRect.left;
                this.parentTop = parentRect.top;
            }
        }
        // For target(html element) boundary
        if (this.props.bounds instanceof HTMLElement) {
            var targetRect = this.props.bounds.getBoundingClientRect();
            this.targetLeft = targetRect.left;
            this.targetTop = targetRect.top;
        }
        // For boundary
        if (this.resizable) {
            var _a = this.resizable.getBoundingClientRect(), left = _a.left, top_1 = _a.top;
            this.resizableLeft = left;
            this.resizableTop = top_1;
        }
    };
    Resizable.prototype.onResizeStart = function(event, direction) {
        var clientX = 0;
        var clientY = 0;
        if (event.nativeEvent instanceof MouseEvent) {
            clientX = event.nativeEvent.clientX;
            clientY = event.nativeEvent.clientY;
            // When user click with right button the resize is stuck in resizing mode
            // until users clicks again, dont continue if right click is used.
            // HACK: MouseEvent does not have `which` from flow-bin v0.68.
            if (event.nativeEvent.which === 3) return;
        } else if (event.nativeEvent instanceof TouchEvent) {
            clientX = event.nativeEvent.touches[0].clientX;
            clientY = event.nativeEvent.touches[0].clientY;
        }
        if (this.props.onResizeStart) {
            if (this.resizable) {
                var startResize = this.props.onResizeStart(event, direction, this.resizable);
                if (startResize === false) return;
            }
        }
        // Fix #168
        if (this.props.size) {
            if (typeof this.props.size.height !== 'undefined' && this.props.size.height !== this.state.height) this.setState({
                height: this.props.size.height
            });
            if (typeof this.props.size.width !== 'undefined' && this.props.size.width !== this.state.width) this.setState({
                width: this.props.size.width
            });
        }
        // For lockAspectRatio case
        this.ratio = typeof this.props.lockAspectRatio === 'number' ? this.props.lockAspectRatio : this.size.width / this.size.height;
        // For boundary
        this.setBoundingClientRect();
        this.setState({
            original: {
                x: clientX,
                y: clientY,
                width: this.size.width,
                height: this.size.height
            },
            isResizing: true,
            resizeCursor: window.getComputedStyle(event.target).cursor || 'auto',
            direction: direction
        });
    };
    Resizable.prototype.onMouseMove = function(event) {
        if (!this.state.isResizing || !this.resizable) return;
        var _a = this.props, maxWidth = _a.maxWidth, maxHeight = _a.maxHeight, minWidth = _a.minWidth, minHeight = _a.minHeight;
        var clientX = event instanceof MouseEvent ? event.clientX : event.touches[0].clientX;
        var clientY = event instanceof MouseEvent ? event.clientY : event.touches[0].clientY;
        var _b = this.state, direction = _b.direction, original = _b.original, width = _b.width, height = _b.height;
        var parentSize = this.getParentSize();
        var max = $39288fa70c8527a9$var$calculateNewMax(parentSize, maxWidth, maxHeight, minWidth, minHeight);
        maxWidth = max.maxWidth;
        maxHeight = max.maxHeight;
        minWidth = max.minWidth;
        minHeight = max.minHeight;
        // Calculate new size
        var _c = this.calculateNewSizeFromDirection(clientX, clientY), newHeight = _c.newHeight, newWidth = _c.newWidth;
        // Calculate max size from boundary settings
        var boundaryMax = this.calculateNewMaxFromBoundary(maxWidth, maxHeight);
        // Calculate new size from aspect ratio
        var newSize = this.calculateNewSizeFromAspectRatio(newWidth, newHeight, {
            width: boundaryMax.maxWidth,
            height: boundaryMax.maxHeight
        }, {
            width: minWidth,
            height: minHeight
        });
        newWidth = newSize.newWidth;
        newHeight = newSize.newHeight;
        if (this.props.grid) {
            var newGridWidth = $39288fa70c8527a9$var$snap(newWidth, this.props.grid[0]);
            var newGridHeight = $39288fa70c8527a9$var$snap(newHeight, this.props.grid[1]);
            var gap = this.props.snapGap || 0;
            newWidth = gap === 0 || Math.abs(newGridWidth - newWidth) <= gap ? newGridWidth : newWidth;
            newHeight = gap === 0 || Math.abs(newGridHeight - newHeight) <= gap ? newGridHeight : newHeight;
        }
        if (this.props.snap && this.props.snap.x) newWidth = $39288fa70c8527a9$var$findClosestSnap(newWidth, this.props.snap.x, this.props.snapGap);
        if (this.props.snap && this.props.snap.y) newHeight = $39288fa70c8527a9$var$findClosestSnap(newHeight, this.props.snap.y, this.props.snapGap);
        var delta = {
            width: newWidth - original.width,
            height: newHeight - original.height
        };
        if (width && typeof width === 'string') {
            if ($39288fa70c8527a9$var$endsWith(width, '%')) {
                var percent = newWidth / parentSize.width * 100;
                newWidth = percent + "%";
            } else if ($39288fa70c8527a9$var$endsWith(width, 'vw')) {
                var vw = newWidth / window.innerWidth * 100;
                newWidth = vw + "vw";
            } else if ($39288fa70c8527a9$var$endsWith(width, 'vh')) {
                var vh = newWidth / window.innerHeight * 100;
                newWidth = vh + "vh";
            }
        }
        if (height && typeof height === 'string') {
            if ($39288fa70c8527a9$var$endsWith(height, '%')) {
                var percent = newHeight / parentSize.height * 100;
                newHeight = percent + "%";
            } else if ($39288fa70c8527a9$var$endsWith(height, 'vw')) {
                var vw = newHeight / window.innerWidth * 100;
                newHeight = vw + "vw";
            } else if ($39288fa70c8527a9$var$endsWith(height, 'vh')) {
                var vh = newHeight / window.innerHeight * 100;
                newHeight = vh + "vh";
            }
        }
        this.setState({
            width: this.createSizeForCssProperty(newWidth, 'width'),
            height: this.createSizeForCssProperty(newHeight, 'height')
        });
        if (this.props.onResize) this.props.onResize(event, direction, this.resizable, delta);
    };
    Resizable.prototype.onMouseUp = function(event) {
        var _a = this.state, isResizing = _a.isResizing, direction = _a.direction, original = _a.original;
        if (!isResizing || !this.resizable) return;
        var delta = {
            width: this.size.width - original.width,
            height: this.size.height - original.height
        };
        if (this.props.onResizeStop) this.props.onResizeStop(event, direction, this.resizable, delta);
        if (this.props.size) this.setState(this.props.size);
        this.setState({
            isResizing: false,
            resizeCursor: 'auto'
        });
    };
    Resizable.prototype.updateSize = function(size) {
        this.setState({
            width: size.width,
            height: size.height
        });
    };
    Resizable.prototype.renderResizer = function() {
        var _this = this;
        var _a = this.props, enable = _a.enable, handleStyles = _a.handleStyles, handleClasses = _a.handleClasses, handleWrapperStyle = _a.handleWrapperStyle, handleWrapperClass = _a.handleWrapperClass, handleComponent = _a.handleComponent;
        if (!enable) return null;
        var resizers = Object.keys(enable).map(function(dir) {
            if (enable[dir] !== false) return $39288fa70c8527a9$var$React.createElement($bSibd.Resizer, {
                key: dir,
                direction: dir,
                onResizeStart: _this.onResizeStart,
                replaceStyles: handleStyles && handleStyles[dir],
                className: handleClasses && handleClasses[dir]
            }, handleComponent && handleComponent[dir] ? handleComponent[dir] : null);
            return null;
        });
        // #93 Wrap the resize box in span (will not break 100% width/height)
        return $39288fa70c8527a9$var$React.createElement("span", {
            className: handleWrapperClass,
            style: handleWrapperStyle
        }, resizers);
    };
    Resizable.prototype.render = function() {
        var _this = this;
        var extendsProps = Object.keys(this.props).reduce(function(acc, key) {
            if ($39288fa70c8527a9$var$definedProps.indexOf(key) !== -1) return acc;
            acc[key] = _this.props[key];
            return acc;
        }, {});
        return $39288fa70c8527a9$var$React.createElement("div", $39288fa70c8527a9$var$__assign({
            ref: function(c) {
                if (c) _this.resizable = c;
            },
            style: $39288fa70c8527a9$var$__assign({
                position: 'relative',
                userSelect: this.state.isResizing ? 'none' : 'auto'
            }, this.props.style, this.sizeStyle, {
                maxWidth: this.props.maxWidth,
                maxHeight: this.props.maxHeight,
                minWidth: this.props.minWidth,
                minHeight: this.props.minHeight,
                boxSizing: 'border-box'
            }),
            className: this.props.className
        }, extendsProps), this.state.isResizing && $39288fa70c8527a9$var$React.createElement("div", {
            style: {
                height: '100%',
                width: '100%',
                backgroundColor: 'rgba(0,0,0,0)',
                cursor: "" + (this.state.resizeCursor || 'auto'),
                opacity: 0,
                position: 'fixed',
                zIndex: 9999,
                top: '0',
                left: '0',
                bottom: '0',
                right: '0'
            }
        }), this.props.children, this.renderResizer());
    };
    Resizable.defaultProps = {
        onResizeStart: function() {},
        onResize: function() {},
        onResizeStop: function() {},
        enable: {
            top: true,
            right: true,
            bottom: true,
            left: true,
            topRight: true,
            bottomRight: true,
            bottomLeft: true,
            topLeft: true
        },
        style: {},
        grid: [
            1,
            1
        ],
        lockAspectRatio: false,
        lockAspectRatioExtraWidth: 0,
        lockAspectRatioExtraHeight: 0,
        scale: 1,
        resizeRatio: 1,
        snapGap: 0
    };
    return Resizable;
}($39288fa70c8527a9$var$React.PureComponent);
module.exports.Resizable = $39288fa70c8527a9$var$Resizable;

});
parcelRegister("bSibd", function(module, exports) {
"use strict";
var $8a52d7055e98d5e9$var$__assign = module.exports && module.exports.__assign || function() {
    $8a52d7055e98d5e9$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $8a52d7055e98d5e9$var$__assign.apply(this, arguments);
};
var $8a52d7055e98d5e9$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result["default"] = mod;
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8a52d7055e98d5e9$var$React = $8a52d7055e98d5e9$var$__importStar((parcelRequire("bSJIT")));
var $8a52d7055e98d5e9$var$styles = {
    top: {
        width: '100%',
        height: '10px',
        top: '-5px',
        left: '0px',
        cursor: 'row-resize'
    },
    right: {
        width: '10px',
        height: '100%',
        top: '0px',
        right: '-5px',
        cursor: 'col-resize'
    },
    bottom: {
        width: '100%',
        height: '10px',
        bottom: '-5px',
        left: '0px',
        cursor: 'row-resize'
    },
    left: {
        width: '10px',
        height: '100%',
        top: '0px',
        left: '-5px',
        cursor: 'col-resize'
    },
    topRight: {
        width: '20px',
        height: '20px',
        position: 'absolute',
        right: '-10px',
        top: '-10px',
        cursor: 'ne-resize'
    },
    bottomRight: {
        width: '20px',
        height: '20px',
        position: 'absolute',
        right: '-10px',
        bottom: '-10px',
        cursor: 'se-resize'
    },
    bottomLeft: {
        width: '20px',
        height: '20px',
        position: 'absolute',
        left: '-10px',
        bottom: '-10px',
        cursor: 'sw-resize'
    },
    topLeft: {
        width: '20px',
        height: '20px',
        position: 'absolute',
        left: '-10px',
        top: '-10px',
        cursor: 'nw-resize'
    }
};
function $8a52d7055e98d5e9$var$Resizer(props) {
    return $8a52d7055e98d5e9$var$React.createElement("div", {
        className: props.className || '',
        style: $8a52d7055e98d5e9$var$__assign({
            position: 'absolute',
            userSelect: 'none'
        }, $8a52d7055e98d5e9$var$styles[props.direction], props.replaceStyles || {}),
        onMouseDown: function(e) {
            props.onResizeStart(e, props.direction);
        },
        onTouchStart: function(e) {
            props.onResizeStart(e, props.direction);
        }
    }, props.children);
}
module.exports.Resizer = $8a52d7055e98d5e9$var$Resizer;

});

parcelRegister("036ir", function(module, exports) {
//
// Main
//
function $00952a4c1b1e0106$var$memoize(fn, options) {
    var cache = options && options.cache ? options.cache : $00952a4c1b1e0106$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $00952a4c1b1e0106$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $00952a4c1b1e0106$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $00952a4c1b1e0106$var$isPrimitive(value) {
    return value == null || typeof value === 'number' || typeof value === 'boolean' // || typeof value === "string" 'unsafe' primitive for our needs
    ;
}
function $00952a4c1b1e0106$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $00952a4c1b1e0106$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $00952a4c1b1e0106$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $00952a4c1b1e0106$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $00952a4c1b1e0106$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $00952a4c1b1e0106$var$monadic : $00952a4c1b1e0106$var$variadic;
    return $00952a4c1b1e0106$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $00952a4c1b1e0106$var$strategyVariadic(fn, options) {
    var strategy = $00952a4c1b1e0106$var$variadic;
    return $00952a4c1b1e0106$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $00952a4c1b1e0106$var$strategyMonadic(fn, options) {
    var strategy = $00952a4c1b1e0106$var$monadic;
    return $00952a4c1b1e0106$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
//
// Serializer
//
function $00952a4c1b1e0106$var$serializerDefault() {
    return JSON.stringify(arguments);
}
//
// Cache
//
function $00952a4c1b1e0106$var$ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
$00952a4c1b1e0106$var$ObjectWithoutPrototypeCache.prototype.has = function(key) {
    return key in this.cache;
};
$00952a4c1b1e0106$var$ObjectWithoutPrototypeCache.prototype.get = function(key) {
    return this.cache[key];
};
$00952a4c1b1e0106$var$ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
    this.cache[key] = value;
};
var $00952a4c1b1e0106$var$cacheDefault = {
    create: function create() {
        return new $00952a4c1b1e0106$var$ObjectWithoutPrototypeCache();
    }
};
//
// API
//
module.exports = $00952a4c1b1e0106$var$memoize;
module.exports.strategies = {
    variadic: $00952a4c1b1e0106$var$strategyVariadic,
    monadic: $00952a4c1b1e0106$var$strategyMonadic
};

});


parcelRegister("hzHr6", function(module, exports) {
$parcel$export(module.exports, "handleSides", () => $2ecd9c66ebcd71e7$export$8ee741c8b9b43371);
const $2ecd9c66ebcd71e7$export$8ee741c8b9b43371 = [
    'left',
    'right'
];

});

parcelRegister("13E3v", function(module, exports) {
$parcel$export(module.exports, "snapTo", () => $4a620e7e51684133$export$ce5a040a76868800);
const $4a620e7e51684133$export$ce5a040a76868800 = (target, points)=>{
    return points.length === 0 ? // extreme last case if there are no points somehow
    target : points.reduce((point, closest)=>{
        return Math.abs(closest - target) < Math.abs(point - target) ? closest : point;
    });
};

});


parcelRegister("glfR6", function(module, exports) {
$parcel$export(module.exports, "wrapperStyle", () => $70084616c326e963$export$c4d4f06a25de97f);
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9dQre = parcelRequire("9dQre");

var $4v4Uu = parcelRequire("4v4Uu");
const $70084616c326e963$export$c4d4f06a25de97f = (props)=>/*#__PURE__*/ (0, $9dQre.css)("&>div{", (0, $4v4Uu.MediaSingleDimensionHelper)(props), ";position:relative;clear:both;>div{position:absolute;height:100%;width:100%;}}");

});

parcelRegister("20rxI", function(module, exports) {
$parcel$export(module.exports, "calcPctFromPx", () => $2afa11bf20ec5d5d$export$55ddb36b3404ec6d);

var $29qUP = parcelRequire("29qUP");
function $2afa11bf20ec5d5d$export$55ddb36b3404ec6d(width, lineLength) {
    const maxWidth = lineLength + (0, $29qUP.MEDIA_SINGLE_GUTTER_SIZE);
    return (width + (0, $29qUP.MEDIA_SINGLE_GUTTER_SIZE)) / maxWidth;
}

});

parcelRegister("1nvog", function(module, exports) {
$parcel$export(module.exports, "imageAlignmentMap", () => $9ba8b303d7498846$export$9aaf3d5fbdfcf5c5);
const $9ba8b303d7498846$export$9aaf3d5fbdfcf5c5 = {
    left: 'start',
    right: 'end'
};

});



parcelRegister("4iI1W", function(module, exports) {
$parcel$export(module.exports, "InlineCardNodeView", () => $92756e70c0c5c468$export$2626b4e17577ac62);
$parcel$export(module.exports, "inlineCardNodeView", () => $92756e70c0c5c468$export$ebfb9e1798b8aa0e);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $lmZMT = parcelRequire("lmZMT");

var $5beht = parcelRequire("5beht");

var $47K0n = parcelRequire("47K0n");

var $cKhMH = parcelRequire("cKhMH");

var $9ZsM7 = parcelRequire("9ZsM7");

var $aciCL = parcelRequire("aciCL");

var $Y2xFC = parcelRequire("Y2xFC");
const $92756e70c0c5c468$var$WrappedInlineCardWithAwareness = (0, $aciCL.Card)((0, $Y2xFC.InlineCardWithAwareness), (0, $lmZMT.default));
const $92756e70c0c5c468$var$selectorWithCard = (states)=>{
    var _states$editorViewMod, _states$cardState;
    return {
        mode: (_states$editorViewMod = states.editorViewModeState) === null || _states$editorViewMod === void 0 ? void 0 : _states$editorViewMod.mode,
        resolvedInlineSmartLinks: (_states$cardState = states.cardState) === null || _states$cardState === void 0 ? void 0 : _states$cardState.resolvedInlineSmartLinks
    };
};
function $92756e70c0c5c468$export$2626b4e17577ac62(props) {
    var _resolvedInlineSmartL;
    const { useAlternativePreloader: useAlternativePreloader, node: node, view: view, getPos: getPos, actionOptions: actionOptions, allowEmbeds: allowEmbeds, allowBlockCards: allowBlockCards, enableInlineUpgradeFeatures: enableInlineUpgradeFeatures, pluginInjectionApi: pluginInjectionApi, onClickCallback: onClickCallback, isPageSSRed: isPageSSRed, provider: provider, CompetitorPrompt: CompetitorPrompt, intl: intl, smartCardContext: smartCardContext } = props;
    const { mode: mode, resolvedInlineSmartLinks: resolvedInlineSmartLinks } = (0, $5beht.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'editorViewMode',
        'card'
    ], $92756e70c0c5c468$var$selectorWithCard);
    const url = node.attrs.url;
    const CompetitorPromptComponent = CompetitorPrompt && url ? /*#__PURE__*/ (0, $dc70d.jsx)(CompetitorPrompt, {
        sourceUrl: url,
        linkType: "inline"
    }) : null;
    (0, $bSJIT.useEffect)(()=>{
        provider === null || provider === void 0 || provider.then((providerInstance)=>{
            var _refreshCache, _ref;
            (_refreshCache = (_ref = providerInstance).refreshCache) === null || _refreshCache === void 0 || _refreshCache.call(_ref, props.node);
        });
    }, [
        provider,
        props.node
    ]);
    const linkPosition = (0, $bSJIT.useMemo)(()=>{
        if (!getPos || typeof getPos === 'boolean') return undefined;
        const pos = getPos();
        return typeof pos === 'number' ? pos : undefined;
    }, [
        getPos
    ]);
    const isChangeboardTarget = linkPosition !== undefined && (resolvedInlineSmartLinks === null || resolvedInlineSmartLinks === void 0 || (_resolvedInlineSmartL = resolvedInlineSmartLinks[0]) === null || _resolvedInlineSmartL === void 0 ? void 0 : _resolvedInlineSmartL.pos) === linkPosition;
    const inlineCardContent = /*#__PURE__*/ (0, $dc70d.jsxs)((0, $dc70d.Fragment), {
        children: [
            /*#__PURE__*/ (0, $dc70d.jsx)($92756e70c0c5c468$var$WrappedInlineCardWithAwareness, {
                node: node,
                view: view,
                getPos: getPos,
                actionOptions: actionOptions,
                useAlternativePreloader: useAlternativePreloader,
                pluginInjectionApi: pluginInjectionApi,
                onClickCallback: onClickCallback,
                isPageSSRed: isPageSSRed,
                provider: provider,
                appearance: "inline",
                ...enableInlineUpgradeFeatures && (0, $cKhMH.getAwarenessProps)(view.state, getPos, allowEmbeds, allowBlockCards, mode === 'view')
            }),
            CompetitorPromptComponent
        ]
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $9ZsM7.SmartCardSSRReactContextsProvider), {
        intl: intl,
        smartCardContext: smartCardContext,
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $47K0n.SmartLinkDraggable), {
            url: url,
            appearance: (0, $47K0n.SMART_LINK_APPEARANCE).INLINE,
            source: (0, $47K0n.SMART_LINK_DRAG_TYPES).EDITOR,
            isChangeboardTarget: isChangeboardTarget,
            children: inlineCardContent
        })
    });
}
const $92756e70c0c5c468$export$ebfb9e1798b8aa0e = ({ inlineCardViewProducer: inlineCardViewProducer })=>(node, view, getPos, decorations)=>{
        return inlineCardViewProducer(node, view, getPos, decorations);
    };

});
parcelRegister("Y2xFC", function(module, exports) {
$parcel$export(module.exports, "InlineCardWithAwareness", () => $cface2c84efd7d89$export$2b341c5236b55a2);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $g6Qq4 = parcelRequire("g6Qq4");

var $cJJ21 = parcelRequire("cJJ21");

var $5beht = parcelRequire("5beht");

var $cw0wu = parcelRequire("cw0wu");

var $dWNt9 = parcelRequire("dWNt9");

var $8y99z = parcelRequire("8y99z");

var $3y2s4 = parcelRequire("3y2s4");

var $aihc7 = parcelRequire("aihc7");
var $2mPLm = parcelRequire("2mPLm");
var $6FJC6 = parcelRequire("6FJC6");

var $bxzRa = parcelRequire("bxzRa");

var $5N1Y4 = parcelRequire("5N1Y4");

var $k5X6V = parcelRequire("k5X6V");

var $1fMby = parcelRequire("1fMby");

var $lX0eu = parcelRequire("lX0eu");

var $ehP1N = parcelRequire("ehP1N");

var $fRgJI = parcelRequire("fRgJI");
// Module scope so the stored callback's closure chain cannot reach the
// component scope (getPos, node, view) via V8 context sharing.
const $cface2c84efd7d89$var$createRemoveOverlay = (setIsInsertedRef)=>()=>{
        var _setIsInsertedRef$cur;
        return (_setIsInsertedRef$cur = setIsInsertedRef.current) === null || _setIsInsertedRef$cur === void 0 ? void 0 : _setIsInsertedRef$cur.call(setIsInsertedRef, false);
    };
const $cface2c84efd7d89$var$selector = (states)=>{
    var _states$editorViewMod, _states$selectionStat;
    return {
        mode: (_states$editorViewMod = states.editorViewModeState) === null || _states$editorViewMod === void 0 ? void 0 : _states$editorViewMod.mode,
        selection: (_states$selectionStat = states.selectionState) === null || _states$selectionStat === void 0 ? void 0 : _states$selectionStat.selection
    };
};
const $cface2c84efd7d89$export$2b341c5236b55a2 = /*#__PURE__*/ (0, $bSJIT.memo)(({ node: node, cardContext: cardContext, actionOptions: actionOptions, useAlternativePreloader: useAlternativePreloader, view: view, getPos: getPos, pluginInjectionApi: pluginInjectionApi, onClick: onClick, isPulseEnabled: isPulseEnabled, isOverlayEnabled: isOverlayEnabled, isSelected: isSelected, isPageSSRed: isPageSSRed, provider: provider, appearance: appearance })=>{
    var _pluginInjectionApi$c;
    const [isHovered, setIsHovered] = (0, $bSJIT.useState)(false);
    const [isInserted, setIsInserted] = (0, $bSJIT.useState)(false);
    const setIsInsertedRef = (0, $bSJIT.useRef)(setIsInserted);
    (0, $bSJIT.useEffect)(()=>{
        return ()=>{
            if ((0, $3y2s4.isExperimentEnabled)('platform_editor_reduce_memory_leaks')) setIsInsertedRef.current = undefined;
        };
    }, []);
    const [isResolvedViewRendered, setIsResolvedViewRendered] = (0, $bSJIT.useState)(false);
    const editorAppearance = pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$c = pluginInjectionApi.card.sharedState.currentState()) === null || _pluginInjectionApi$c === void 0 ? void 0 : _pluginInjectionApi$c.editorAppearance;
    const destinationUrl = (0, $bxzRa.useSmartLinkDestinationUrl)(node.attrs.url);
    const onResolve = (0, $bSJIT.useCallback)((tr, title)=>{
        const metadata = tr.getMeta((0, $1fMby.pluginKey));
        const removeOverlay = (0, $3y2s4.isExperimentEnabled)('platform_editor_reduce_memory_leaks') ? $cface2c84efd7d89$var$createRemoveOverlay(setIsInsertedRef) : ()=>setIsInserted(false);
        if (metadata && metadata.type === 'REGISTER') (0, $k5X6V.registerRemoveOverlay)(removeOverlay, metadata.info)(tr);
        else (0, $k5X6V.registerRemoveOverlay)(removeOverlay)(tr);
        if (title) setIsResolvedViewRendered(true);
    }, []);
    const markMostRecentlyInsertedLink = (0, $bSJIT.useCallback)((isLinkMostRecentlyInserted)=>{
        if (isOverlayEnabled) setIsInserted(isLinkMostRecentlyInserted);
    }, [
        isOverlayEnabled
    ]);
    const setOverlayHoveredStyles = (0, $bSJIT.useCallback)((isHovered)=>{
        if (isOverlayEnabled) setIsHovered(isHovered);
    }, [
        isOverlayEnabled
    ]);
    const { mode: mode, selection: selection } = (0, $5beht.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'selection',
        'editorViewMode'
    ], $cface2c84efd7d89$var$selector);
    const floatingToolbarNode = selection instanceof (0, $cw0wu.NodeSelection) && selection.node;
    // This is a prop to show Hover card, Hover card should be shown only in Live View and Classic Renderer (note when only Editor controls enabled we don't show in Live view)
    const showHoverPreview = floatingToolbarNode !== node;
    const innerCardWithOpenButtonOverlay = (0, $bSJIT.useMemo)(()=>{
        var _pluginInjectionApi$a;
        return /*#__PURE__*/ (0, $dc70d.jsx)((0, $cJJ21.default), {
            isVisible: isResolvedViewRendered,
            url: node.attrs.url,
            destinationUrl: destinationUrl,
            compactPadding: editorAppearance === 'comment' || editorAppearance === 'chromeless',
            editorAnalyticsApi: pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$a = pluginInjectionApi.analytics) === null || _pluginInjectionApi$a === void 0 ? void 0 : _pluginInjectionApi$a.actions,
            view: view,
            children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $fRgJI.InlineCard), {
                node: node,
                view: view,
                getPos: getPos,
                useAlternativePreloader: useAlternativePreloader,
                actionOptions: actionOptions,
                onResolve: onResolve,
                onClick: onClick,
                cardContext: cardContext,
                isHovered: isHovered,
                isPageSSRed: isPageSSRed,
                provider: provider,
                pluginInjectionApi: pluginInjectionApi,
                disablePreviewPanel: true
            })
        });
    }, [
        isResolvedViewRendered,
        node,
        editorAppearance,
        view,
        getPos,
        useAlternativePreloader,
        actionOptions,
        onResolve,
        onClick,
        cardContext,
        isHovered,
        isPageSSRed,
        provider,
        pluginInjectionApi,
        destinationUrl
    ]);
    const innerCardOriginal = (0, $bSJIT.useMemo)(()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $fRgJI.InlineCard), {
            node: node,
            view: view,
            getPos: getPos,
            useAlternativePreloader: useAlternativePreloader,
            actionOptions: actionOptions,
            onResolve: onResolve,
            onClick: onClick,
            cardContext: cardContext,
            isHovered: isHovered,
            isPageSSRed: isPageSSRed,
            provider: provider,
            pluginInjectionApi: pluginInjectionApi,
            showHoverPreview: false
        }), [
        actionOptions,
        cardContext,
        getPos,
        isHovered,
        node,
        onClick,
        onResolve,
        useAlternativePreloader,
        view,
        isPageSSRed,
        provider,
        pluginInjectionApi
    ]);
    const shouldShowOpenButtonOverlay = (0, $bSJIT.useMemo)(()=>{
        const shouldShowOpenButtonOverlayInChomeless = editorAppearance === 'chromeless';
        return mode === 'edit' || editorAppearance === 'comment' || shouldShowOpenButtonOverlayInChomeless;
    }, [
        mode,
        editorAppearance
    ]);
    let innerCard = shouldShowOpenButtonOverlay ? innerCardWithOpenButtonOverlay : innerCardOriginal;
    if (mode === 'view') {
        var _cardContext$value;
        const url = node.attrs.url;
        const cardState = cardContext === null || cardContext === void 0 || (_cardContext$value = cardContext.value) === null || _cardContext$value === void 0 || (_cardContext$value = _cardContext$value.store) === null || _cardContext$value === void 0 ? void 0 : _cardContext$value.getState()[url];
        if (cardState) {
            var _cardContext$value2, _cardContext$value2$i, _cardContext$value3;
            const ari = (0, $aihc7.getObjectAri)(cardState.details);
            const name = (0, $6FJC6.getObjectName)(cardState.details);
            const iconUrl = (0, $2mPLm.getObjectIconUrl)(cardState.details);
            const isPanelAvailable = ari && (cardContext === null || cardContext === void 0 || (_cardContext$value2 = cardContext.value) === null || _cardContext$value2 === void 0 || (_cardContext$value2$i = _cardContext$value2.isPreviewPanelAvailable) === null || _cardContext$value2$i === void 0 ? void 0 : _cardContext$value2$i.call(_cardContext$value2, {
                ari: ari
            }));
            const openPreviewPanel = cardContext === null || cardContext === void 0 || (_cardContext$value3 = cardContext.value) === null || _cardContext$value3 === void 0 ? void 0 : _cardContext$value3.openPreviewPanel;
            const isPreviewPanelAvailable = Boolean(openPreviewPanel && isPanelAvailable);
            const firePreviewPanelClickEvent = ({ previewType: previewType })=>{
                var _cardContext$value4, _pluginInjectionApi$a2;
                const store = cardContext === null || cardContext === void 0 || (_cardContext$value4 = cardContext.value) === null || _cardContext$value4 === void 0 ? void 0 : _cardContext$value4.store;
                const urlState = store === null || store === void 0 ? void 0 : store.getState()[url || ''];
                if (pluginInjectionApi !== null && pluginInjectionApi !== void 0 && (_pluginInjectionApi$a2 = pluginInjectionApi.analytics) !== null && _pluginInjectionApi$a2 !== void 0 && _pluginInjectionApi$a2.actions) {
                    var _pluginInjectionApi$a3, _urlState$details, _urlState$details2;
                    pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$a3 = pluginInjectionApi.analytics) === null || _pluginInjectionApi$a3 === void 0 || (_pluginInjectionApi$a3 = _pluginInjectionApi$a3.actions) === null || _pluginInjectionApi$a3 === void 0 || _pluginInjectionApi$a3.fireAnalyticsEvent({
                        action: (0, $g6Qq4.ACTION).CLICKED,
                        actionSubject: (0, $g6Qq4.ACTION_SUBJECT).SMART_LINK,
                        actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).HOVER_LABEL,
                        eventType: (0, $g6Qq4.EVENT_TYPE).UI,
                        attributes: {
                            previewType: previewType,
                            destinationProduct: (urlState === null || urlState === void 0 || (_urlState$details = urlState.details) === null || _urlState$details === void 0 || (_urlState$details = _urlState$details.meta) === null || _urlState$details === void 0 ? void 0 : _urlState$details.product) ?? null,
                            destinationSubproduct: (urlState === null || urlState === void 0 || (_urlState$details2 = urlState.details) === null || _urlState$details2 === void 0 || (_urlState$details2 = _urlState$details2.meta) === null || _urlState$details2 === void 0 ? void 0 : _urlState$details2.subproduct) ?? null
                        }
                    });
                }
            };
            const innerCardWithPanelButtonOverlay = /*#__PURE__*/ (0, $dc70d.jsx)((0, $ehP1N.PreviewInvoker), {
                url: url,
                appearance: "inline",
                children: ({ canPreview: canPreview, invokePreview: invokePreview })=>{
                    const isPreviewModalAvailable = Boolean(canPreview && invokePreview);
                    // In view mode we show HoverLinkOverlay only with if preview mode or panel is available
                    // otherwise a use can click on smartlink itself to open the link in a new tab.
                    const isPreviewAvailable = isPreviewPanelAvailable || isPreviewModalAvailable;
                    // When inside preview panel iframe, hide the overlay button
                    const isInPreviewPanel = (0, $8y99z.isWithinPreviewPanelIFrame)();
                    const showPanelButton = isInPreviewPanel ? isPreviewPanelAvailable : isPreviewAvailable;
                    if (isPreviewAvailable) {
                        var _pluginInjectionApi$a4;
                        return /*#__PURE__*/ (0, $dc70d.jsx)((0, $cJJ21.default), {
                            isVisible: isResolvedViewRendered,
                            url: url,
                            destinationUrl: destinationUrl,
                            compactPadding: editorAppearance === 'comment' || editorAppearance === 'chromeless',
                            editorAnalyticsApi: pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$a4 = pluginInjectionApi.analytics) === null || _pluginInjectionApi$a4 === void 0 ? void 0 : _pluginInjectionApi$a4.actions,
                            view: view,
                            showPanelButton: showPanelButton,
                            showPanelButtonIcon: isPreviewAvailable && isPreviewPanelAvailable ? 'panel' : 'modal',
                            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                            onClick: (event)=>{
                                if (isPreviewPanelAvailable) {
                                    var _extractSmartLinkEmbe;
                                    event.preventDefault();
                                    openPreviewPanel === null || openPreviewPanel === void 0 || openPreviewPanel({
                                        url: url,
                                        ari: ari || '',
                                        name: name || '',
                                        iconUrl: iconUrl,
                                        panelData: {
                                            embedUrl: (0, $5N1Y4.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') ? (_extractSmartLinkEmbe = (0, $dWNt9.extractSmartLinkEmbed)(cardState === null || cardState === void 0 ? void 0 : cardState.details)) === null || _extractSmartLinkEmbe === void 0 ? void 0 : _extractSmartLinkEmbe.src : undefined
                                        }
                                    });
                                    firePreviewPanelClickEvent({
                                        previewType: 'panel'
                                    });
                                } else if (isPreviewModalAvailable) {
                                    event.preventDefault();
                                    invokePreview === null || invokePreview === void 0 || invokePreview();
                                    firePreviewPanelClickEvent({
                                        previewType: 'modal'
                                    });
                                }
                            },
                            children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $fRgJI.InlineCard), {
                                node: node,
                                view: view,
                                getPos: getPos,
                                useAlternativePreloader: useAlternativePreloader,
                                actionOptions: actionOptions,
                                onResolve: onResolve,
                                onClick: onClick,
                                cardContext: cardContext,
                                isHovered: isHovered,
                                isPageSSRed: isPageSSRed,
                                provider: provider,
                                pluginInjectionApi: pluginInjectionApi,
                                showHoverPreview: mode === 'view' && showHoverPreview,
                                disablePreviewPanel: true
                            })
                        });
                    } else return /*#__PURE__*/ (0, $dc70d.jsx)((0, $fRgJI.InlineCard), {
                        node: node,
                        view: view,
                        getPos: getPos,
                        useAlternativePreloader: useAlternativePreloader,
                        actionOptions: actionOptions,
                        onResolve: onResolve,
                        onClick: onClick,
                        cardContext: cardContext,
                        isHovered: isHovered,
                        isPageSSRed: isPageSSRed,
                        provider: provider,
                        pluginInjectionApi: pluginInjectionApi,
                        showHoverPreview: mode === 'view' && showHoverPreview
                    });
                }
            });
            innerCard = innerCardWithPanelButtonOverlay;
        }
    }
    const getPosFunction = typeof getPos === 'function' ? getPos : undefined;
    const placeholderUniqId = (getPosFunction === null || getPosFunction === void 0 ? void 0 : getPosFunction()) || 0;
    return isOverlayEnabled || isPulseEnabled ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $lX0eu.AwarenessWrapper), {
        isOverlayEnabled: isOverlayEnabled,
        isPulseEnabled: isPulseEnabled,
        cardContext: cardContext,
        getPos: getPos,
        isHovered: isHovered,
        isInserted: isInserted,
        url: node.attrs.url,
        isSelected: isSelected,
        isResolvedViewRendered: isResolvedViewRendered,
        markMostRecentlyInsertedLink: markMostRecentlyInsertedLink,
        pluginInjectionApi: pluginInjectionApi,
        setOverlayHoveredStyles: setOverlayHoveredStyles,
        appearance: appearance,
        children: innerCard
    }) : /*#__PURE__*/ (0, $dc70d.jsx)("span", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "card",
        "data-vc": "editor-plugin-inline-card",
        "data-ssr-placeholder": `editor-plugin-inline-card-${placeholderUniqId}`,
        "data-ssr-placeholder-replace": `editor-plugin-inline-card-${placeholderUniqId}`,
        children: innerCard
    });
});

});
parcelRegister("lX0eu", function(module, exports) {
$parcel$export(module.exports, "AwarenessWrapper", () => $22c2757ec1f179c7$export$cc11bcf19366e14b);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $dwOcU = parcelRequire("dwOcU");

var $cKhMH = parcelRequire("cKhMH");

var $1EVCP = parcelRequire("1EVCP");

var $a2gwZ = parcelRequire("a2gwZ");

var $kf36C = parcelRequire("kf36C");
function $22c2757ec1f179c7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// editor adds a standard line-height that is bigger than an inline smart link
// due to that the link has a bit of white space around it, which doesn't look right when there is pulse around it
const $22c2757ec1f179c7$var$loaderWrapperStyles = {
    name: "8ncb35",
    styles: ".loader-wrapper{line-height:normal;}"
};
const $22c2757ec1f179c7$export$cc11bcf19366e14b = ({ cardContext: cardContext, children: children, getPos: getPos, isOverlayEnabled: isOverlayEnabled, isSelected: isSelected, isResolvedViewRendered: isResolvedViewRendered, isPulseEnabled: isPulseEnabled, markMostRecentlyInsertedLink: markMostRecentlyInsertedLink, pluginInjectionApi: pluginInjectionApi, url: url, appearance: appearance })=>{
    var _cardContext$value2;
    const linkPosition = (0, $bSJIT.useMemo)(()=>{
        if (!getPos || typeof getPos === 'boolean') return undefined;
        const pos = getPos();
        return typeof pos === 'number' ? pos : undefined;
    }, [
        getPos
    ]);
    const { shouldShowLinkPulse: shouldShowLinkPulse, shouldShowToolbarPulse: shouldShowToolbarPulse, shouldShowLinkOverlay: shouldShowLinkOverlay, isLinkMostRecentlyInserted: isLinkMostRecentlyInserted } = (0, $1EVCP.default)({
        url: url,
        linkPosition: linkPosition || -1,
        cardContext: cardContext === null || cardContext === void 0 ? void 0 : cardContext.value,
        pluginInjectionApi: pluginInjectionApi,
        isOverlayEnabled: isOverlayEnabled,
        isPulseEnabled: isPulseEnabled
    });
    // If the toolbar pulse has not yet been invalidated and this is a case where we will be showing it,
    // we need to invalidate the link pulse too. Toolbar pulse will be invalidated in the corresponding component.
    if (isSelected && shouldShowToolbarPulse && !(0, $a2gwZ.isLocalStorageKeyDiscovered)((0, $a2gwZ.LOCAL_STORAGE_DISCOVERY_KEY_TOOLBAR))) (0, $a2gwZ.markLocalStorageKeyDiscovered)((0, $a2gwZ.LOCAL_STORAGE_DISCOVERY_KEY_SMART_LINK));
    (0, $bSJIT.useEffect)(()=>{
        if (shouldShowLinkOverlay && isLinkMostRecentlyInserted) markMostRecentlyInsertedLink(true);
    }, [
        isLinkMostRecentlyInserted,
        markMostRecentlyInsertedLink,
        shouldShowLinkOverlay
    ]);
    const isInline = appearance === 'inline';
    const placeholderUniqId = linkPosition || 0;
    return (0, $bSJIT.useMemo)(()=>{
        var _cardContext$value;
        return /*#__PURE__*/ (0, $9dQre.jsx)("span", {
            css: shouldShowLinkPulse && $22c2757ec1f179c7$var$loaderWrapperStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "card",
            "data-vc": "awareness-wrapper",
            "data-ssr-placeholder": `awareness-wrapper-${placeholderUniqId}`,
            "data-ssr-placeholder-replace": `awareness-wrapper-${placeholderUniqId}`
        }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $dwOcU.default), {
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            data: {
                attributes: (0, $cKhMH.getResolvedAttributesFromStore)(url, 'inline', cardContext === null || cardContext === void 0 || (_cardContext$value = cardContext.value) === null || _cardContext$value === void 0 ? void 0 : _cardContext$value.store)
            }
        }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $kf36C.DiscoveryPulse), {
            localStorageKey: (0, $a2gwZ.LOCAL_STORAGE_DISCOVERY_KEY_SMART_LINK),
            localStorageKeyExpirationInMs: (0, $a2gwZ.ONE_DAY_IN_MILLISECONDS),
            discoveryMode: "start",
            shouldShowPulse: isResolvedViewRendered && shouldShowLinkPulse,
            testId: "link-discovery-pulse",
            isInline: isInline
        }, children)));
    }, [
        shouldShowLinkPulse,
        url,
        cardContext === null || cardContext === void 0 || (_cardContext$value2 = cardContext.value) === null || _cardContext$value2 === void 0 ? void 0 : _cardContext$value2.store,
        isResolvedViewRendered,
        children,
        isInline,
        placeholderUniqId
    ]);
};

});
parcelRegister("1EVCP", function(module, exports) {
$parcel$export(module.exports, "default", () => $6a4063f08fe95dc8$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $a2gwZ = parcelRequire("a2gwZ");
const $6a4063f08fe95dc8$var$useLinkUpgradeDiscoverability = ({ url: url, linkPosition: linkPosition, cardContext: cardContext, pluginInjectionApi: pluginInjectionApi, isPulseEnabled: isPulseEnabled, isOverlayEnabled: isOverlayEnabled })=>{
    var _cardContext$store, _pluginInjectionApi$c;
    const [urlState, setUrlState] = (0, $bSJIT.useState)(cardContext === null || cardContext === void 0 || (_cardContext$store = cardContext.store) === null || _cardContext$store === void 0 ? void 0 : _cardContext$store.getState()[url]);
    const { overlayCandidatePosition: overlayCandidatePosition, inlineCardAwarenessCandidatePosition: inlineCardAwarenessCandidatePosition } = (pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$c = pluginInjectionApi.card) === null || _pluginInjectionApi$c === void 0 || (_pluginInjectionApi$c = _pluginInjectionApi$c.sharedState) === null || _pluginInjectionApi$c === void 0 ? void 0 : _pluginInjectionApi$c.currentState()) || {};
    (0, $bSJIT.useEffect)(()=>{
        var _cardContext$store2;
        const unsubscribe = cardContext === null || cardContext === void 0 || (_cardContext$store2 = cardContext.store) === null || _cardContext$store2 === void 0 ? void 0 : _cardContext$store2.subscribe(()=>{
            var _cardContext$store3;
            setUrlState(cardContext === null || cardContext === void 0 || (_cardContext$store3 = cardContext.store) === null || _cardContext$store3 === void 0 ? void 0 : _cardContext$store3.getState()[url]);
        });
        return ()=>{
            if (unsubscribe) unsubscribe();
        };
    }, [
        cardContext === null || cardContext === void 0 ? void 0 : cardContext.store,
        url
    ]);
    const canBeUpgradedToEmbed = (0, $bSJIT.useMemo)(()=>{
        var _cardContext$extracto;
        const isResolved = (urlState === null || urlState === void 0 ? void 0 : urlState.status) === 'resolved';
        return isResolved && !!(cardContext !== null && cardContext !== void 0 && (_cardContext$extracto = cardContext.extractors) !== null && _cardContext$extracto !== void 0 && _cardContext$extracto.getPreview(url, 'web'));
    }, [
        cardContext === null || cardContext === void 0 ? void 0 : cardContext.extractors,
        url,
        urlState === null || urlState === void 0 ? void 0 : urlState.status
    ]);
    const shouldShowLinkPulse = (0, $bSJIT.useMemo)(()=>{
        return isPulseEnabled && linkPosition === inlineCardAwarenessCandidatePosition && canBeUpgradedToEmbed;
    }, [
        canBeUpgradedToEmbed,
        isPulseEnabled,
        linkPosition,
        inlineCardAwarenessCandidatePosition
    ]);
    const shouldShowLinkOverlay = (urlState === null || urlState === void 0 ? void 0 : urlState.status) === 'resolved' && isOverlayEnabled;
    const isLinkMostRecentlyInserted = overlayCandidatePosition === linkPosition;
    const shouldShowToolbarPulse = (0, $bSJIT.useMemo)(()=>isPulseEnabled && !(0, $a2gwZ.isLocalStorageKeyDiscovered)((0, $a2gwZ.LOCAL_STORAGE_DISCOVERY_KEY_TOOLBAR)) && canBeUpgradedToEmbed, [
        canBeUpgradedToEmbed,
        isPulseEnabled
    ]);
    return {
        shouldShowToolbarPulse: shouldShowToolbarPulse,
        shouldShowLinkPulse: shouldShowLinkPulse,
        shouldShowLinkOverlay: shouldShowLinkOverlay,
        isLinkMostRecentlyInserted: isLinkMostRecentlyInserted
    };
};
var $6a4063f08fe95dc8$export$2e2bcd8739ae039 = $6a4063f08fe95dc8$var$useLinkUpgradeDiscoverability;

});
parcelRegister("a2gwZ", function(module, exports) {
$parcel$export(module.exports, "LOCAL_STORAGE_DISCOVERY_KEY_SMART_LINK", () => $c8052f577fb8bbbf$export$613f4cbb1d6327d6);
$parcel$export(module.exports, "LOCAL_STORAGE_DISCOVERY_KEY_TOOLBAR", () => $c8052f577fb8bbbf$export$b1ab83c904a5352e);
$parcel$export(module.exports, "ONE_DAY_IN_MILLISECONDS", () => $c8052f577fb8bbbf$export$2cf27d95188f1c13);
$parcel$export(module.exports, "isLocalStorageKeyDiscovered", () => $c8052f577fb8bbbf$export$f029a1bf9ca298da);
$parcel$export(module.exports, "markLocalStorageKeyDiscovered", () => $c8052f577fb8bbbf$export$6b9d1ae5ec92c88e);

var $hYVMR = parcelRequire("hYVMR");
const $c8052f577fb8bbbf$export$c0fd7e3ed450d078 = '@atlaskit/editor-plugin-card';
const $c8052f577fb8bbbf$export$4521957a9ae858f5 = 'discovered';
const $c8052f577fb8bbbf$export$613f4cbb1d6327d6 = 'smart-link-upgrade-pulse';
const $c8052f577fb8bbbf$export$b1ab83c904a5352e = 'toolbar-upgrade-pulse';
const $c8052f577fb8bbbf$export$2cf27d95188f1c13 = 86400000;
const $c8052f577fb8bbbf$var$storageClient = new (0, $hYVMR.StorageClient)($c8052f577fb8bbbf$export$c0fd7e3ed450d078);
const $c8052f577fb8bbbf$export$f029a1bf9ca298da = (key)=>{
    try {
        const localStorageValue = $c8052f577fb8bbbf$var$storageClient.getItem(key);
        return !!localStorageValue && localStorageValue === $c8052f577fb8bbbf$export$4521957a9ae858f5;
    } catch  {
        // If localStorage is not available, don't show feature discovery component. Treat it as 'discovered'.
        return true;
    }
};
const $c8052f577fb8bbbf$export$6b9d1ae5ec92c88e = (key, expiration)=>{
    try {
        $c8052f577fb8bbbf$var$storageClient.setItemWithExpiry(key, $c8052f577fb8bbbf$export$4521957a9ae858f5, expiration);
    } catch  {
    // silent error
    }
};

});


parcelRegister("kf36C", function(module, exports) {
$parcel$export(module.exports, "DiscoveryPulse", () => $c63905d2510fda43$export$1f5748a1623673d7);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $6WltM = parcelRequire("6WltM");

var $c7BHx = parcelRequire("c7BHx");

var $a2gwZ = parcelRequire("a2gwZ");
const $c63905d2510fda43$export$1f5748a1623673d7 = ({ children: children, localStorageKey: localStorageKey, localStorageKeyExpirationInMs: localStorageKeyExpirationInMs, discoveryMode: discoveryMode = 'iteration', shouldShowPulse: shouldShowPulse, testId: testId, isInline: isInline })=>{
    const discovered = (0, $a2gwZ.isLocalStorageKeyDiscovered)(localStorageKey);
    const showPulse = shouldShowPulse ?? !discovered;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    (0, $bSJIT.useEffect)(()=>{
        if (showPulse) createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'pulse',
            eventType: 'ui',
            attributes: {
                pulseIdentifier: localStorageKey
            }
        }).fire('media');
    }, [
        createAnalyticsEvent,
        discovered,
        localStorageKey,
        showPulse
    ]);
    const onDiscovery = (0, $bSJIT.useCallback)(()=>{
        if (!discovered) (0, $a2gwZ.markLocalStorageKeyDiscovered)(localStorageKey, localStorageKeyExpirationInMs);
    }, [
        discovered,
        localStorageKey,
        localStorageKeyExpirationInMs
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $c7BHx.Pulse), {
        onAnimationIteration: discoveryMode === 'iteration' ? onDiscovery : undefined,
        onAnimationStart: discoveryMode === 'start' ? onDiscovery : undefined,
        showPulse: showPulse,
        testId: testId,
        isInline: isInline,
        children: children
    });
};

});
parcelRegister("c7BHx", function(module, exports) {
$parcel$export(module.exports, "Pulse", () => $1c79ce0964e2af41$export$927d63e2511364c0);
/* Pulse.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");
const $1c79ce0964e2af41$var$pulseKeyframes = null;
const $1c79ce0964e2af41$var$pulseStyles = null;
const $1c79ce0964e2af41$var$commonStyles = null;
const $1c79ce0964e2af41$export$927d63e2511364c0 = ({ children: children, showPulse: showPulse = false, onAnimationIteration: onAnimationIteration, onAnimationStart: onAnimationStart, testId: testId = 'discovery-pulse', isInline: isInline = false })=>{
    // this ref is to persist the animation through rerenders
    const pulseStarted = (0, $bSJIT.useRef)(false);
    if (showPulse) pulseStarted.current = true;
    const stopPropagation = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useCallback((e)=>{
        e.stopPropagation();
    }, []);
    const WrapperTag = isInline ? 'span' : 'div';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(WrapperTag, {
        "data-testid": testId,
        onAnimationIteration: onAnimationIteration,
        onAnimationStart: onAnimationStart,
        className: (0, $9fU1q.default)([
            "_1e0c1nu9",
            pulseStarted.current && "",
            pulseStarted.current && "_2rkofajl _16qs1l47 _j7hq8j16 _5sagw34l _1pgl1trn _tip811wp"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("span", {
        onAnimationIteration: stopPropagation,
        onAnimationStart: stopPropagation
    }, children));
};

});



parcelRegister("ehP1N", function(module, exports) {
$parcel$export(module.exports, "PreviewInvoker", () => $32097ba86e017f8c$export$a43fddf3dfb4c066);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $bCQGV = parcelRequire("bCQGV");
const $32097ba86e017f8c$export$a43fddf3dfb4c066 = ({ url: url, appearance: appearance, children: children })=>{
    const actions = (0, $bCQGV.useSmartLinkActions)({
        url: url,
        appearance: appearance
    });
    const preview = (0, $bSJIT.useMemo)(()=>actions.find((action)=>action.id === 'preview-content'), [
        actions
    ]);
    const invokePreview = (0, $bSJIT.useCallback)(()=>{
        try {
            preview === null || preview === void 0 || preview.invoke();
        } catch  {}
    }, [
        preview
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dc70d.Fragment), {
        children: children({
            canPreview: !!preview,
            invokePreview: invokePreview
        })
    });
};

});

parcelRegister("fRgJI", function(module, exports) {
$parcel$export(module.exports, "InlineCard", () => $b5225440e62c445b$export$aff6291803939b05);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9wZWu = parcelRequire("9wZWu");

var $7RHfd = parcelRequire("7RHfd");

var $g6Qq4 = parcelRequire("g6Qq4");

var $9xvBa = parcelRequire("9xvBa");

var $3y2s4 = parcelRequire("3y2s4");

var $dETMy = parcelRequire("dETMy");

var $iOHZU = parcelRequire("iOHZU");

var $797yE = parcelRequire("797yE");

var $k5X6V = parcelRequire("k5X6V");

var $cFebM = parcelRequire("cFebM");

var $2kWIB = parcelRequire("2kWIB");
const $b5225440e62c445b$export$aff6291803939b05 = /*#__PURE__*/ (0, $bSJIT.memo)(({ node: node, cardContext: cardContext, actionOptions: actionOptions, useAlternativePreloader: useAlternativePreloader, view: view, getPos: getPos, onClick: propsOnClick, onResolve: onRes, isHovered: isHovered, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, isPageSSRed: isPageSSRed, pluginInjectionApi: pluginInjectionApi, disablePreviewPanel: disablePreviewPanel })=>{
    var _cardContext$value;
    const { url: url, data: data } = node.attrs;
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const refId = (0, $bSJIT.useRef)((0, $7RHfd.default)());
    const removeCardDispatched = (0, $bSJIT.useRef)(false);
    const pendingRegisterCard = (0, $bSJIT.useRef)(null);
    (0, $bSJIT.useEffect)(()=>{
        return ()=>{
            if ((0, $3y2s4.isExperimentEnabled)('platform_editor_reduce_memory_leaks')) {
                var _pendingRegisterCard$;
                (_pendingRegisterCard$ = pendingRegisterCard.current) === null || _pendingRegisterCard$ === void 0 || _pendingRegisterCard$.cancel();
                pendingRegisterCard.current = null;
            }
        };
    }, []);
    const { getState: getSmartlinkState } = (cardContext === null || cardContext === void 0 || (_cardContext$value = cardContext.value) === null || _cardContext$value === void 0 ? void 0 : _cardContext$value.store) || {};
    const cardState = getSmartlinkState === null || getSmartlinkState === void 0 ? void 0 : getSmartlinkState()[url || ''];
    (0, $bSJIT.useEffect)(()=>{
        const id = refId.current;
        removeCardDispatched.current = false;
        return ()=>{
            if ((0, $3y2s4.isExperimentEnabled)('platform_editor_inline_card_dispatch_guard') && removeCardDispatched.current) return;
            removeCardDispatched.current = true;
            const { tr: tr } = view.state;
            (0, $k5X6V.removeCard)({
                id: id
            })(tr);
            view.dispatch(tr);
        };
    }, [
        getPos,
        view
    ]);
    const scrollContainer = (0, $bSJIT.useMemo)(()=>(0, $3y2s4.isExperimentEnabled)('platform_editor_reduce_forced_layout_2') && (0, $2kWIB.isIntersectionObserverSupported)() ? undefined : // eslint-disable-next-line @atlaskit/editor/no-as-casting
        (0, $9xvBa.findOverflowScrollParent)(view.dom) || undefined, [
        view.dom
    ]);
    const onResolve = (0, $bSJIT.useCallback)((data)=>{
        if (!getPos || typeof getPos === 'boolean') return;
        const { title: title, url: url } = data;
        // don't dispatch immediately since we might be in the middle of
        // rendering a nodeview
        const scheduleRegisterCard = (0, $9wZWu.default)(()=>{
            // prosemirror-bump-fix
            const pos = getPos();
            if (typeof pos !== 'number') return;
            const tr = view.state.tr;
            (0, $k5X6V.registerCard)({
                title: title,
                url: url,
                pos: pos,
                id: refId.current
            })(tr);
            onRes === null || onRes === void 0 || onRes(tr, title);
            view.dispatch(tr);
        });
        if ((0, $3y2s4.isExperimentEnabled)('platform_editor_reduce_memory_leaks')) pendingRegisterCard.current = scheduleRegisterCard;
        scheduleRegisterCard();
    }, [
        getPos,
        view,
        onRes
    ]);
    const onError = (0, $bSJIT.useCallback)((data)=>{
        const { url: url, err: err } = data;
        if (err) throw err;
        onResolve({
            url: url
        });
    }, [
        onResolve
    ]);
    const handleOnClick = (0, $bSJIT.useCallback)((event, data)=>{
        if (event.metaKey || event.ctrlKey) {
            const { actions: editorAnalyticsApi } = (pluginInjectionApi === null || pluginInjectionApi === void 0 ? void 0 : pluginInjectionApi.analytics) ?? {};
            (0, $cFebM.visitCardLinkAnalytics)(editorAnalyticsApi, (0, $g6Qq4.INPUT_METHOD).META_CLICK)(view.state, view.dispatch);
            window.open((data === null || data === void 0 ? void 0 : data.destinationUrl) ?? url, '_blank');
        } else // only trigger the provided onClick callback if the meta key or ctrl key is not pressed
        propsOnClick === null || propsOnClick === void 0 || propsOnClick(event);
    }, [
        propsOnClick,
        url,
        view,
        pluginInjectionApi
    ]);
    const onClick = (0, $797yE.editorExperiment)('platform_editor_controls', 'variant1') ? handleOnClick : propsOnClick;
    const card = (0, $bSJIT.useMemo)(()=>{
        if ((isPageSSRed || cardState) && url) return /*#__PURE__*/ (0, $dc70d.jsx)((0, $iOHZU.CardSSR), {
            url: url,
            appearance: "inline",
            onClick: onClick,
            container: scrollContainer,
            onResolve: onResolve,
            onError: onError,
            inlinePreloaderStyle: useAlternativePreloader ? 'on-right-without-skeleton' : undefined,
            actionOptions: actionOptions,
            isHovered: isHovered,
            showHoverPreview: showHoverPreview,
            hoverPreviewOptions: hoverPreviewOptions,
            disablePreviewPanel: disablePreviewPanel,
            hideIconLoadingSkeleton: true
        }, url);
        return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dETMy.Card), {
            url: url ?? data.url,
            appearance: "inline",
            onClick: onClick,
            container: scrollContainer,
            onResolve: onResolve,
            onError: onError,
            inlinePreloaderStyle: useAlternativePreloader ? 'on-right-without-skeleton' : undefined,
            actionOptions: actionOptions,
            isHovered: isHovered,
            showHoverPreview: showHoverPreview,
            hoverPreviewOptions: hoverPreviewOptions,
            disablePreviewPanel: disablePreviewPanel
        }, url);
    }, [
        url,
        data,
        onClick,
        scrollContainer,
        onResolve,
        onError,
        useAlternativePreloader,
        actionOptions,
        isHovered,
        showHoverPreview,
        hoverPreviewOptions,
        isPageSSRed,
        disablePreviewPanel,
        cardState
    ]);
    // [WS-2307]: we only render card wrapped into a Provider when the value is ready,
    // otherwise if we got data, we can render the card directly since it doesn't need the Provider
    return cardContext && cardContext.value ? /*#__PURE__*/ (0, $dc70d.jsx)(cardContext.Provider, {
        value: cardContext.value,
        children: card
    }) : data ? card : null;
});

});
parcelRegister("cFebM", function(module, exports) {
$parcel$export(module.exports, "visitCardLinkAnalytics", () => $4efc96972221dc8f$export$7ee76be08aa43a42);
$parcel$export(module.exports, "floatingToolbar", () => $4efc96972221dc8f$export$4850df084251d287);
$parcel$export(module.exports, "shouldRenderToolbarPulse", () => $4efc96972221dc8f$export$ddeab6943680f5be);
$parcel$export(module.exports, "getStartingToolbarItems", () => $4efc96972221dc8f$export$bb790f15a666b7f0);
$parcel$export(module.exports, "getEndingToolbarItems", () => $4efc96972221dc8f$export$d5ca70670b9f6b9);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $7nI18 = parcelRequire("7nI18");

var $ci54V = parcelRequire("ci54V");

var $g6Qq4 = parcelRequire("g6Qq4");

var $gHATu = parcelRequire("gHATu");

var $hGzMn = parcelRequire("hGzMn");

var $hVGJk = parcelRequire("hVGJk");

var $bk3yN = parcelRequire("bk3yN");

var $fNLdd = parcelRequire("fNLdd");

var $fuAsP = parcelRequire("fuAsP");

var $278lv = parcelRequire("278lv");

var $8FY43 = parcelRequire("8FY43");

var $ejFiy = parcelRequire("ejFiy");

var $5LDnu = parcelRequire("5LDnu");

var $eacW2 = parcelRequire("eacW2");

var $8qHhy = parcelRequire("8qHhy");

var $8XENo = parcelRequire("8XENo");

var $cw0wu = parcelRequire("cw0wu");

var $gab48 = parcelRequire("gab48");

var $5bbjm = parcelRequire("5bbjm");

var $eYvps = parcelRequire("eYvps");

var $c81bI = parcelRequire("c81bI");

var $gV64P = parcelRequire("gV64P");

var $5Uddy = parcelRequire("5Uddy");

var $1c4Ad = parcelRequire("1c4Ad");

var $92LrB = parcelRequire("92LrB");

var $5xL0X = parcelRequire("5xL0X");

var $797yE = parcelRequire("797yE");

var $a76m2 = parcelRequire("a76m2");

var $1fMby = parcelRequire("1fMby");

var $cKhMH = parcelRequire("cKhMH");

var $hU1ZA = parcelRequire("hU1ZA");

var $g6njf = parcelRequire("g6njf");

var $f371K = parcelRequire("f371K");

var $8OKVL = parcelRequire("8OKVL");

var $9owK5 = parcelRequire("9owK5");

var $5Zj7S = parcelRequire("5Zj7S");

var $e2l6k = parcelRequire("e2l6k");

var $jDbCT = parcelRequire("jDbCT");

var $amwXS = parcelRequire("amwXS");

var $6D2Cw = parcelRequire("6D2Cw");
const $4efc96972221dc8f$export$3301f76e6efaf85e = (editorAnalyticsApi)=>(0, $hGzMn.commandWithMetadata)((state, dispatch)=>{
        if (!(state.selection instanceof (0, $cw0wu.NodeSelection))) return false;
        const type = state.selection.node.type.name;
        const payload = {
            action: (0, $g6Qq4.ACTION).DELETED,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).SMART_LINK,
            actionSubjectId: type,
            attributes: {
                inputMethod: (0, $g6Qq4.INPUT_METHOD).FLOATING_TB,
                displayMode: type
            },
            eventType: (0, $g6Qq4.EVENT_TYPE).TRACK
        };
        if (dispatch) {
            const { tr: tr } = state;
            (0, $gab48.removeSelectedNode)(tr);
            editorAnalyticsApi === null || editorAnalyticsApi === void 0 || editorAnalyticsApi.attachAnalyticsEvent(payload)(tr);
            dispatch(tr);
        }
        return true;
    }, {
        action: (0, $g6Qq4.ACTION).DELETED
    });
const $4efc96972221dc8f$export$7ee76be08aa43a42 = (editorAnalyticsApi, inputMethod, resolvedAttributes)=>(state, dispatch)=>{
        if (!(state.selection instanceof (0, $cw0wu.NodeSelection))) return false;
        const { type: type } = state.selection.node;
        if (dispatch) {
            const { tr: tr } = state;
            editorAnalyticsApi === null || editorAnalyticsApi === void 0 || editorAnalyticsApi.attachAnalyticsEvent((0, $ci54V.buildVisitedNonHyperLinkPayload)(type.name, inputMethod, resolvedAttributes))(tr);
            dispatch(tr);
        }
        return true;
    };
const $4efc96972221dc8f$var$fireOpenLinkToolbarAnalytics = (editorAnalyticsApi, inputMethod, resolvedAttributes = {})=>(state, dispatch)=>{
        const linkAnalyticsRecorded = $4efc96972221dc8f$export$7ee76be08aa43a42(editorAnalyticsApi, inputMethod, resolvedAttributes)(state, dispatch);
        if (!linkAnalyticsRecorded) return false;
        editorAnalyticsApi === null || editorAnalyticsApi === void 0 || editorAnalyticsApi.fireAnalyticsEvent({
            action: (0, $g6Qq4.ACTION).CLICKED,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).BUTTON,
            actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).OPEN_LINK,
            attributes: {
                displayCategory: resolvedAttributes.displayCategory,
                extensionKey: resolvedAttributes.extensionKey,
                status: resolvedAttributes.status,
                statusDetails: resolvedAttributes.statusDetails
            },
            eventType: (0, $g6Qq4.EVENT_TYPE).UI
        });
        return true;
    };
const $4efc96972221dc8f$export$96ed3b1dd32b989d = (editorAnalyticsApi)=>(state, dispatch)=>{
        if (!(state.selection instanceof (0, $cw0wu.NodeSelection))) return false;
        if (dispatch) {
            const { tr: tr, selection: { node: { type: type } } } = state;
            editorAnalyticsApi === null || editorAnalyticsApi === void 0 || editorAnalyticsApi.attachAnalyticsEvent((0, $ci54V.buildOpenedSettingsPayload)(type.name))(tr);
            dispatch(tr);
        }
        return true;
    };
const $4efc96972221dc8f$export$4850df084251d287 = (cardOptions, lpLinkPicker, linkPickerOptions, pluginInjectionApi, disableFloatingToolbar)=>{
    return (state, intl, providerFactory)=>{
        if (disableFloatingToolbar) return;
        const { inlineCard: inlineCard, blockCard: blockCard, embedCard: embedCard } = state.schema.nodes;
        const nodeType = [
            inlineCard,
            blockCard,
            embedCard
        ];
        const pluginState = (0, $1fMby.pluginKey).getState(state);
        if (!(state.selection instanceof (0, $cw0wu.NodeSelection))) return;
        const selectedNode = state.selection.node;
        if (!selectedNode) return;
        const isEmbedCard = (0, $cKhMH.appearanceForNodeType)(selectedNode.type) === 'embed';
        /* add an offset to embeds due to extra padding */ const toolbarOffset = isEmbedCard ? {
            offset: [
                0,
                24
            ]
        } : {};
        // Applies padding override for when link picker is currently displayed
        const className = pluginState !== null && pluginState !== void 0 && pluginState.showLinkingToolbar ? (0, $eacW2.FLOATING_TOOLBAR_LINKPICKER_CLASSNAME) : undefined;
        const isLinkPickerEnabled = !!lpLinkPicker;
        return {
            title: intl.formatMessage((0, $278lv.messages).card),
            className: className,
            nodeType: nodeType,
            preventPopupOverflow: isLinkPickerEnabled,
            ...toolbarOffset,
            getDomRef: (view)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const element = (0, $gab48.findDomRefAtPos)(view.state.selection.from, view.domAtPos.bind(view));
                if (!element) return undefined;
                if (isEmbedCard) {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    const richMediaElement = element.querySelector(`.${(0, $5LDnu.richMediaClassName)}`);
                    if (!(0, $797yE.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
                        exposure: true
                    })) return richMediaElement;
                    if (richMediaElement) return richMediaElement;
                }
                return element;
            },
            items: $4efc96972221dc8f$var$generateToolbarItems(state, intl, providerFactory, cardOptions, lpLinkPicker, linkPickerOptions, pluginInjectionApi),
            scrollable: pluginState !== null && pluginState !== void 0 && pluginState.showLinkingToolbar ? false : true,
            ...(0, $g6njf.editLinkToolbarConfig)(Boolean(pluginState === null || pluginState === void 0 ? void 0 : pluginState.showLinkingToolbar), isLinkPickerEnabled, linkPickerOptions)
        };
    };
};
const $4efc96972221dc8f$var$unlinkCard = (node, state, editorAnalyticsApi)=>{
    const displayInfo = (0, $cKhMH.displayInfoForCard)(node, (0, $cKhMH.findCardInfo)(state));
    const text = displayInfo.title || displayInfo.url;
    if (text) return (0, $hGzMn.commandWithMetadata)((0, $a76m2.changeSelectedCardToText)(text, editorAnalyticsApi), {
        action: (0, $g6Qq4.ACTION).UNLINK
    });
    return ()=>false;
};
const $4efc96972221dc8f$var$buildAlignmentOptions = (state, intl, widthPluginDependencyApi, analyticsApi, cardOptions, areAnyNewToolbarFlagsEnabled)=>{
    if (areAnyNewToolbarFlagsEnabled) return (0, $gHATu.buildLayoutDropdown)(state, intl, state.schema.nodes.embedCard, widthPluginDependencyApi, analyticsApi, true, true, cardOptions === null || cardOptions === void 0 ? void 0 : cardOptions.allowWrapping, cardOptions === null || cardOptions === void 0 ? void 0 : cardOptions.allowAlignment);
    return (0, $gHATu.default)(state, intl, state.schema.nodes.embedCard, widthPluginDependencyApi, analyticsApi, true, true, cardOptions === null || cardOptions === void 0 ? void 0 : cardOptions.allowWrapping, cardOptions === null || cardOptions === void 0 ? void 0 : cardOptions.allowAlignment);
};
const $4efc96972221dc8f$var$withToolbarMetadata = (command)=>(0, $hGzMn.commandWithMetadata)(command, {
        inputMethod: (0, $g6Qq4.INPUT_METHOD).FLOATING_TB
    });
const $4efc96972221dc8f$var$getToolbarViewedItem = (url, display)=>{
    if (!url) return [];
    return [
        {
            type: 'custom',
            fallback: [],
            render: (editorView)=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $6D2Cw.ToolbarViewedEvent), {
                    url: url,
                    display: display,
                    editorView: editorView
                }, "edit.link.menu.viewed")
        }
    ];
};
const $4efc96972221dc8f$var$generateToolbarItems = (state, intl, providerFactory, cardOptions, lpLinkPicker, linkPicker, pluginInjectionApi)=>(node)=>{
        var _pluginInjectionApi$d, _pluginInjectionApi$a, _node$attrs;
        const { url: url } = (0, $cKhMH.titleUrlPairFromNode)(node);
        const { actions: editorAnalyticsApi } = (pluginInjectionApi === null || pluginInjectionApi === void 0 ? void 0 : pluginInjectionApi.analytics) ?? {};
        let metadata = {};
        if (url && !(0, $7nI18.isSafeUrl)(url)) return [];
        else {
            const { title: title } = (0, $cKhMH.displayInfoForCard)(node, (0, $cKhMH.findCardInfo)(state));
            metadata = {
                url: url,
                title: title
            };
        }
        const areAllNewToolbarFlagsDisabled = !(0, $8qHhy.areToolbarFlagsEnabled)(Boolean(pluginInjectionApi === null || pluginInjectionApi === void 0 ? void 0 : pluginInjectionApi.toolbar));
        const currentAppearance = (0, $cKhMH.appearanceForNodeType)(node.type);
        const { hoverDecoration: hoverDecoration } = (pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$d = pluginInjectionApi.decorations) === null || _pluginInjectionApi$d === void 0 ? void 0 : _pluginInjectionApi$d.actions) ?? {};
        const isDatasource = (0, $cKhMH.isDatasourceNode)(node);
        const pluginState = (0, $1fMby.pluginKey).getState(state);
        const annotationApiState = pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$a = pluginInjectionApi.annotation) === null || _pluginInjectionApi$a === void 0 ? void 0 : _pluginInjectionApi$a.sharedState.currentState();
        const activeCommentMark = node.marks.find((mark)=>mark.type.name === 'annotation' && (annotationApiState === null || annotationApiState === void 0 ? void 0 : annotationApiState.annotations[mark.attrs.id]) === false);
        const isCommentEnabled = annotationApiState && annotationApiState.isVisible && !annotationApiState.bookmark && !annotationApiState.mouseData.isSelecting && !activeCommentMark && node.type === state.schema.nodes.inlineCard;
        const onCommentButtonClick = (state, dispatch)=>{
            var _pluginInjectionApi$a2;
            if (!(pluginInjectionApi !== null && pluginInjectionApi !== void 0 && pluginInjectionApi.annotation) || !isCommentEnabled) return false;
            pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$a2 = pluginInjectionApi.analytics) === null || _pluginInjectionApi$a2 === void 0 || (_pluginInjectionApi$a2 = _pluginInjectionApi$a2.actions) === null || _pluginInjectionApi$a2 === void 0 || _pluginInjectionApi$a2.fireAnalyticsEvent({
                action: (0, $g6Qq4.ACTION).CLICKED,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).BUTTON,
                actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).CREATE_INLINE_COMMENT_FROM_HIGHLIGHT_ACTIONS_MENU,
                eventType: (0, $g6Qq4.EVENT_TYPE).UI,
                attributes: {
                    source: 'highlightActionsMenu',
                    pageMode: 'edit',
                    sourceNode: 'inlineCard'
                }
            });
            const { setInlineCommentDraftState: setInlineCommentDraftState } = pluginInjectionApi.annotation.actions;
            const command = setInlineCommentDraftState(true, (0, $g6Qq4.INPUT_METHOD).FLOATING_TB);
            return command(state, dispatch);
        };
        const shouldRenderDatasourceToolbar = isDatasource && cardOptions.allowDatasource && (0, $8XENo.canRenderDatasource)(node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 || (_node$attrs = _node$attrs.datasource) === null || _node$attrs === void 0 ? void 0 : _node$attrs.id);
        if (pluginState !== null && pluginState !== void 0 && pluginState.showLinkingToolbar) return [
            (0, $g6njf.buildEditLinkToolbar)({
                providerFactory: providerFactory,
                linkPicker: linkPicker,
                node: node,
                pluginInjectionApi: pluginInjectionApi,
                lpLinkPicker: lpLinkPicker
            })
        ];
        else if (shouldRenderDatasourceToolbar) return $4efc96972221dc8f$var$getDatasourceButtonGroup(metadata, intl, editorAnalyticsApi, node, hoverDecoration, node.attrs.datasource.id, state, cardOptions, currentAppearance, pluginInjectionApi);
        else {
            var _pluginInjectionApi$c;
            const { inlineCard: inlineCard } = state.schema.nodes;
            const editItems = cardOptions.allowDatasource ? [
                {
                    type: 'custom',
                    fallback: [],
                    render: (editorView)=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $f371K.EditToolbarButton), {
                            url: url,
                            intl: intl,
                            editorAnalyticsApi: editorAnalyticsApi,
                            editorView: editorView,
                            onLinkEditClick: (0, $g6njf.getEditLinkCallback)(editorAnalyticsApi, true),
                            currentAppearance: currentAppearance,
                            areAnyNewToolbarFlagsEnabled: !areAllNewToolbarFlagsDisabled
                        }, "edit-toolbar-item")
                }
            ] : [
                {
                    id: 'editor.link.edit',
                    type: 'button',
                    selected: false,
                    metadata: metadata,
                    title: intl.formatMessage((0, $ejFiy.linkToolbarMessages).editLink),
                    showTitle: true,
                    testId: 'link-toolbar-edit-link-button',
                    onClick: (0, $g6njf.getEditLinkCallback)(editorAnalyticsApi, true)
                },
                {
                    type: 'separator'
                }
            ];
            const commentItems = isCommentEnabled ? [
                {
                    id: 'editor.link.commentLink',
                    type: 'button',
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($eYvps))),
                    testId: 'inline-card-toolbar-comment-button',
                    iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($eYvps))),
                    title: intl.formatMessage((0, $fuAsP.annotationMessages).createComment),
                    showTitle: (0, $797yE.editorExperiment)('platform_editor_controls', 'control') ? undefined : true,
                    onClick: onCommentButtonClick,
                    disabled: (0, $hVGJk.isOfflineMode)(pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$c = pluginInjectionApi.connectivity) === null || _pluginInjectionApi$c === void 0 || (_pluginInjectionApi$c = _pluginInjectionApi$c.sharedState) === null || _pluginInjectionApi$c === void 0 || (_pluginInjectionApi$c = _pluginInjectionApi$c.currentState()) === null || _pluginInjectionApi$c === void 0 ? void 0 : _pluginInjectionApi$c.mode)
                },
                {
                    type: 'separator'
                }
            ] : [];
            const openLinkInputMethod = (0, $g6Qq4.INPUT_METHOD).FLOATING_TB;
            const editButtonItems = cardOptions.allowDatasource ? [
                {
                    type: 'custom',
                    fallback: [],
                    render: (editorView)=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $f371K.EditToolbarButton), {
                            url: url,
                            intl: intl,
                            editorAnalyticsApi: editorAnalyticsApi,
                            editorView: editorView,
                            onLinkEditClick: (0, $g6njf.getEditLinkCallback)(editorAnalyticsApi, true),
                            currentAppearance: currentAppearance,
                            areAnyNewToolbarFlagsEnabled: !areAllNewToolbarFlagsDisabled
                        }, "edit-toolbar-item")
                }
            ] : [
                {
                    id: 'editor.link.edit',
                    type: 'button',
                    selected: false,
                    metadata: metadata,
                    title: intl.formatMessage((0, $ejFiy.linkToolbarMessages).editLink),
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($5Uddy))),
                    testId: 'link-toolbar-edit-link-button',
                    onClick: (0, $g6njf.getEditLinkCallback)(editorAnalyticsApi, true)
                }
            ];
            const openPreviewPanelItems = [
                {
                    type: 'custom',
                    fallback: [],
                    render: ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $amwXS.OpenPreviewPanelToolbarButton), {
                            node: node,
                            intl: intl,
                            editorAnalyticsApi: editorAnalyticsApi,
                            areAnyNewToolbarFlagsEnabled: !areAllNewToolbarFlagsDisabled
                        })
                }
            ];
            const resolvedToolbarAttributes = url ? (pluginState === null || pluginState === void 0 ? void 0 : pluginState.resolvedToolbarAttributesByUrl[url]) ?? {} : {};
            const openLinkToolbarItemFallback = {
                id: 'editor.link.openLink',
                type: 'button',
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($92LrB))),
                iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($92LrB))),
                metadata: metadata,
                className: 'hyperlink-open-link',
                title: intl.formatMessage((0, $8FY43.linkMessages).openLink),
                onClick: $4efc96972221dc8f$var$fireOpenLinkToolbarAnalytics(editorAnalyticsApi, openLinkInputMethod, resolvedToolbarAttributes),
                href: url,
                target: '_blank'
            };
            const openLinkToolbarItem = {
                type: 'custom',
                fallback: [
                    openLinkToolbarItemFallback
                ],
                render: (editorView)=>editorView && url ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $jDbCT.OpenLinkToolbarButton), {
                        url: url,
                        title: intl.formatMessage((0, $8FY43.linkMessages).openLink),
                        editorView: editorView,
                        onClick: $4efc96972221dc8f$var$fireOpenLinkToolbarAnalytics(editorAnalyticsApi, openLinkInputMethod, resolvedToolbarAttributes),
                        areAnyNewToolbarFlagsEnabled: !areAllNewToolbarFlagsDisabled
                    }) : null
            };
            const toolbarItems = areAllNewToolbarFlagsDisabled ? [
                ...editItems,
                ...commentItems,
                ...openPreviewPanelItems,
                openLinkToolbarItem,
                {
                    type: 'separator'
                },
                ...$4efc96972221dc8f$var$getUnlinkButtonGroup(state, intl, node, inlineCard, editorAnalyticsApi, !areAllNewToolbarFlagsDisabled),
                {
                    type: 'copy-button',
                    items: [
                        {
                            state: state,
                            formatMessage: intl.formatMessage,
                            nodeType: node.type
                        }
                    ]
                },
                {
                    type: 'separator'
                },
                $4efc96972221dc8f$export$62592e141464e202(intl, editorAnalyticsApi, cardOptions.userPreferencesLink),
                {
                    type: 'separator'
                },
                {
                    id: 'editor.link.delete',
                    focusEditoronEnter: true,
                    type: 'button',
                    appearance: 'danger',
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($gV64P))),
                    iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($gV64P))),
                    onMouseEnter: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(node.type, true),
                    onMouseLeave: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(node.type, false),
                    onFocus: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(node.type, true),
                    onBlur: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(node.type, false),
                    title: intl.formatMessage((0, $fNLdd.default).remove),
                    onClick: $4efc96972221dc8f$var$withToolbarMetadata($4efc96972221dc8f$export$3301f76e6efaf85e(editorAnalyticsApi))
                }
            ] : [
                ...editButtonItems,
                ...$4efc96972221dc8f$var$getUnlinkButtonGroup(state, intl, node, inlineCard, editorAnalyticsApi, !areAllNewToolbarFlagsDisabled),
                {
                    type: 'separator',
                    fullHeight: true
                },
                ...openPreviewPanelItems,
                openLinkToolbarItem,
                ...commentItems.length > 1 ? [
                    {
                        type: 'separator',
                        fullHeight: true
                    },
                    commentItems[0]
                ] : commentItems
            ];
            if (currentAppearance === 'embed') {
                var _pluginInjectionApi$a3;
                const alignmentOptions = $4efc96972221dc8f$var$buildAlignmentOptions(state, intl, pluginInjectionApi === null || pluginInjectionApi === void 0 ? void 0 : pluginInjectionApi.width, pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$a3 = pluginInjectionApi.analytics) === null || _pluginInjectionApi$a3 === void 0 ? void 0 : _pluginInjectionApi$a3.actions, cardOptions, !areAllNewToolbarFlagsDisabled);
                if (alignmentOptions.length && areAllNewToolbarFlagsDisabled) alignmentOptions.push({
                    type: 'separator'
                });
                toolbarItems.unshift(...alignmentOptions);
            }
            const { allowBlockCards: allowBlockCards, allowEmbeds: allowEmbeds, allowDatasource: allowDatasource, showUpgradeDiscoverability: showUpgradeDiscoverability } = cardOptions;
            // This code will be executed only for appearances such as "inline", "block" & "embed"
            // For url appearance, please see HyperlinkToolbarAppearanceProps
            if (currentAppearance) {
                const showDatasourceAppearance = allowDatasource && url;
                toolbarItems.unshift(...$4efc96972221dc8f$var$getToolbarViewedItem(url, currentAppearance), areAllNewToolbarFlagsDisabled ? {
                    type: 'custom',
                    fallback: [],
                    render: (editorView)=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $5Zj7S.LinkToolbarAppearance), {
                            url: url,
                            intl: intl,
                            currentAppearance: currentAppearance,
                            editorView: editorView,
                            editorState: state,
                            allowEmbeds: allowEmbeds,
                            allowBlockCards: allowBlockCards,
                            editorAnalyticsApi: editorAnalyticsApi,
                            showUpgradeDiscoverability: showUpgradeDiscoverability,
                            areAnyNewToolbarFlagsEnabled: false
                        }, "link-appearance")
                } : (0, $e2l6k.getLinkAppearanceDropdown)({
                    url: url,
                    intl: intl,
                    currentAppearance: currentAppearance,
                    editorState: state,
                    allowEmbeds: allowEmbeds,
                    allowBlockCards: allowBlockCards,
                    editorAnalyticsApi: editorAnalyticsApi,
                    allowDatasource: cardOptions.allowDatasource,
                    showUpgradeDiscoverability: showUpgradeDiscoverability,
                    settingsConfig: $4efc96972221dc8f$export$62592e141464e202(intl, editorAnalyticsApi, cardOptions.userPreferencesLink),
                    isDatasourceView: isDatasource,
                    areAnyNewToolbarFlagsEnabled: !areAllNewToolbarFlagsDisabled
                }), ...showDatasourceAppearance && areAllNewToolbarFlagsDisabled ? [
                    {
                        type: 'custom',
                        fallback: [],
                        render: (editorView)=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $hU1ZA.DatasourceAppearanceButton), {
                                intl: intl,
                                editorAnalyticsApi: editorAnalyticsApi,
                                url: url,
                                editorView: editorView,
                                editorState: state,
                                inputMethod: (0, $g6Qq4.INPUT_METHOD).FLOATING_TB,
                                areAnyNewToolbarFlagsEnabled: !areAllNewToolbarFlagsDisabled
                            })
                    }
                ] : [], ...!areAllNewToolbarFlagsDisabled ? [] : [
                    {
                        type: 'separator'
                    }
                ]);
            }
            if (!areAllNewToolbarFlagsDisabled) {
                const hoverDecorationProps = (nodeType, className)=>({
                        onMouseEnter: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(nodeType, true, className),
                        onMouseLeave: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(nodeType, false, className),
                        onFocus: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(nodeType, true, className),
                        onBlur: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(nodeType, false, className)
                    });
                // testId is required to show focus on trigger button on ESC key press
                // see hideOnEsc in platform/packages/editor/editor-plugin-floating-toolbar/src/ui/Dropdown.tsx
                const testId = 'card-overflow-dropdown-trigger';
                const overflowMenuConfig = [
                    {
                        type: 'separator',
                        fullHeight: true
                    },
                    {
                        type: 'overflow-dropdown',
                        testId: testId,
                        options: [
                            {
                                title: intl.formatMessage((0, $fNLdd.default).copyToClipboard),
                                onClick: ()=>{
                                    var _pluginInjectionApi$c2, _pluginInjectionApi$f;
                                    pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$c2 = pluginInjectionApi.core) === null || _pluginInjectionApi$c2 === void 0 || _pluginInjectionApi$c2.actions.execute(pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$f = pluginInjectionApi.floatingToolbar) === null || _pluginInjectionApi$f === void 0 ? void 0 : _pluginInjectionApi$f.commands.copyNode(node.type, (0, $g6Qq4.INPUT_METHOD).FLOATING_TB));
                                    return true;
                                },
                                icon: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c81bI))), {
                                    label: intl.formatMessage((0, $fNLdd.default).copyToClipboard)
                                }),
                                ...hoverDecorationProps(node.type, (0, $5bbjm.akEditorSelectedNodeClassName))
                            },
                            {
                                title: intl.formatMessage((0, $fNLdd.default).delete),
                                onClick: $4efc96972221dc8f$var$withToolbarMetadata($4efc96972221dc8f$export$3301f76e6efaf85e(editorAnalyticsApi)),
                                icon: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gV64P))), {
                                    label: intl.formatMessage((0, $fNLdd.default).delete)
                                }),
                                ...hoverDecorationProps(node.type)
                            }
                        ]
                    }
                ];
                toolbarItems.push(...overflowMenuConfig);
            }
            return toolbarItems;
        }
    };
const $4efc96972221dc8f$var$getUnlinkButtonGroup = (state, intl, node, inlineCard, editorAnalyticsApi, areAnyNewToolbarFlagsEnabled)=>{
    return node.type === inlineCard ? [
        {
            id: 'editor.link.unlink',
            focusEditoronEnter: true,
            type: 'button',
            title: intl.formatMessage((0, $ejFiy.linkToolbarMessages).unlink),
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($1c4Ad))),
            iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($1c4Ad))),
            onClick: $4efc96972221dc8f$var$withToolbarMetadata($4efc96972221dc8f$var$unlinkCard(node, state, editorAnalyticsApi))
        },
        ...areAnyNewToolbarFlagsEnabled ? [] : [
            {
                type: 'separator'
            }
        ]
    ] : [];
};
const $4efc96972221dc8f$export$62592e141464e202 = (intl, editorAnalyticsApi, userPreferencesLink)=>{
    return {
        id: 'editor.link.settings',
        type: 'button',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5xL0X))),
        iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($5xL0X))),
        title: intl.formatMessage((0, $ejFiy.linkToolbarMessages).settingsLink),
        onClick: $4efc96972221dc8f$export$96ed3b1dd32b989d(editorAnalyticsApi),
        href: userPreferencesLink || (0, $bk3yN.getLinkPreferencesURLFromENV)(),
        target: '_blank'
    };
};
const $4efc96972221dc8f$var$getDatasourceButtonGroup = (metadata, intl, editorAnalyticsApi, node, hoverDecoration, datasourceId, state, cardOptions, currentAppearance, pluginInjectionApi)=>{
    var _node$attrs2, _node$attrs3;
    const toolbarItems = [];
    toolbarItems.push(...$4efc96972221dc8f$var$getToolbarViewedItem(node === null || node === void 0 || (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.url, currentAppearance ?? 'url'));
    const areAllNewToolbarFlagsDisabled = !(0, $8qHhy.areToolbarFlagsEnabled)(Boolean(pluginInjectionApi === null || pluginInjectionApi === void 0 ? void 0 : pluginInjectionApi.toolbar));
    const canShowAppearanceSwitch = ()=>{
        // we do not show smart-link or the datasource icons when the node does not have a url to resolve
        if (!metadata.url) return false;
        return true;
    };
    if (canShowAppearanceSwitch()) {
        const { allowBlockCards: allowBlockCards, allowEmbeds: allowEmbeds, showUpgradeDiscoverability: showUpgradeDiscoverability } = cardOptions;
        const { url: url } = metadata;
        if (areAllNewToolbarFlagsDisabled) toolbarItems.push({
            type: 'custom',
            fallback: [],
            render: (editorView)=>{
                return /*#__PURE__*/ (0, $dc70d.jsx)((0, $5Zj7S.LinkToolbarAppearance), {
                    url: url,
                    intl: intl,
                    currentAppearance: currentAppearance,
                    editorView: editorView,
                    editorState: state,
                    allowEmbeds: allowEmbeds,
                    allowBlockCards: allowBlockCards,
                    editorAnalyticsApi: editorAnalyticsApi,
                    showUpgradeDiscoverability: showUpgradeDiscoverability,
                    isDatasourceView: true,
                    areAnyNewToolbarFlagsEnabled: false
                }, "link-appearance");
            }
        }, {
            type: 'custom',
            fallback: [],
            render: (editorView)=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $hU1ZA.DatasourceAppearanceButton), {
                    intl: intl,
                    editorAnalyticsApi: editorAnalyticsApi,
                    url: url,
                    editorView: editorView,
                    editorState: state,
                    selected: true,
                    inputMethod: (0, $g6Qq4.INPUT_METHOD).FLOATING_TB,
                    areAnyNewToolbarFlagsEnabled: !areAllNewToolbarFlagsDisabled
                })
        }, {
            type: 'separator'
        });
        else toolbarItems.push((0, $e2l6k.getLinkAppearanceDropdown)({
            url: url,
            intl: intl,
            currentAppearance: currentAppearance,
            editorState: state,
            allowEmbeds: allowEmbeds,
            allowBlockCards: allowBlockCards,
            editorAnalyticsApi: editorAnalyticsApi,
            allowDatasource: cardOptions.allowDatasource,
            showUpgradeDiscoverability: showUpgradeDiscoverability,
            settingsConfig: $4efc96972221dc8f$export$62592e141464e202(intl, editorAnalyticsApi, cardOptions.userPreferencesLink),
            isDatasourceView: true,
            areAnyNewToolbarFlagsEnabled: !areAllNewToolbarFlagsDisabled
        }), {
            type: 'separator'
        });
    }
    const openLinkInputMethod = (0, $g6Qq4.INPUT_METHOD).FLOATING_TB;
    const pluginState = (0, $1fMby.pluginKey).getState(state);
    toolbarItems.push({
        type: 'custom',
        fallback: [],
        render: (editorView)=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $f371K.EditToolbarButton), {
                datasourceId: datasourceId,
                node: node,
                url: metadata.url,
                intl: intl,
                editorAnalyticsApi: editorAnalyticsApi,
                editorView: editorView,
                onLinkEditClick: (0, $g6njf.getEditLinkCallback)(editorAnalyticsApi, false),
                currentAppearance: "datasource",
                areAnyNewToolbarFlagsEnabled: !areAllNewToolbarFlagsDisabled
            }, "edit-toolbar-item")
    });
    if (node !== null && node !== void 0 && (_node$attrs3 = node.attrs) !== null && _node$attrs3 !== void 0 && _node$attrs3.url) {
        const openLinkToolbarItemFallback = {
            id: 'editor.link.openLink',
            type: 'button',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($92LrB))),
            iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($92LrB))),
            metadata: metadata,
            className: 'hyperlink-open-link',
            title: intl.formatMessage((0, $8FY43.linkMessages).openLink),
            onClick: $4efc96972221dc8f$var$fireOpenLinkToolbarAnalytics(editorAnalyticsApi, openLinkInputMethod, (pluginState === null || pluginState === void 0 ? void 0 : pluginState.resolvedToolbarAttributesByUrl[node.attrs.url]) ?? {}),
            href: node.attrs.url,
            target: '_blank'
        };
        toolbarItems.push({
            type: 'custom',
            fallback: [
                openLinkToolbarItemFallback
            ],
            render: (editorView)=>editorView ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $jDbCT.OpenLinkToolbarButton), {
                    url: node.attrs.url,
                    title: intl.formatMessage((0, $8FY43.linkMessages).openLink),
                    editorView: editorView,
                    onClick: $4efc96972221dc8f$var$fireOpenLinkToolbarAnalytics(editorAnalyticsApi, openLinkInputMethod, (pluginState === null || pluginState === void 0 ? void 0 : pluginState.resolvedToolbarAttributesByUrl[node.attrs.url]) ?? {}),
                    areAnyNewToolbarFlagsEnabled: !areAllNewToolbarFlagsDisabled
                }) : null
        });
        if (areAllNewToolbarFlagsDisabled) toolbarItems.push({
            type: 'separator'
        });
    }
    if (areAllNewToolbarFlagsDisabled) toolbarItems.push({
        type: 'copy-button',
        supportsViewMode: true,
        items: [
            {
                state: state,
                formatMessage: intl.formatMessage,
                nodeType: node.type
            }
        ]
    }, {
        type: 'separator'
    }, $4efc96972221dc8f$export$62592e141464e202(intl, editorAnalyticsApi, cardOptions === null || cardOptions === void 0 ? void 0 : cardOptions.userPreferencesLink), {
        type: 'separator'
    }, {
        id: 'editor.link.delete',
        focusEditoronEnter: true,
        type: 'button',
        appearance: 'danger',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gV64P))),
        iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($gV64P))),
        onMouseEnter: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(node.type, true),
        onMouseLeave: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(node.type, false),
        onFocus: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(node.type, true),
        onBlur: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(node.type, false),
        title: intl.formatMessage((0, $fNLdd.default).remove),
        onClick: $4efc96972221dc8f$var$withToolbarMetadata($4efc96972221dc8f$export$3301f76e6efaf85e(editorAnalyticsApi))
    });
    else {
        // testId is required to show focus on trigger button on ESC key press
        // see hideOnEsc in platform/packages/editor/editor-plugin-floating-toolbar/src/ui/Dropdown.tsx
        const testId = 'datasource-overflow-dropdown-trigger';
        // When canShowAppearanceSwitch is true, and platform_editor_controls is on, the link appearance dropdown shows, which includes a link preference button
        // So only add the link appearance button when canShowAppearanceSwitch is false
        if (!canShowAppearanceSwitch()) {
            const linkPreferenceButton = $4efc96972221dc8f$export$62592e141464e202(intl, editorAnalyticsApi, cardOptions === null || cardOptions === void 0 ? void 0 : cardOptions.userPreferencesLink);
            toolbarItems.push({
                type: 'separator',
                fullHeight: true
            }, linkPreferenceButton, {
                type: 'separator',
                fullHeight: true
            });
        } else toolbarItems.push({
            type: 'separator',
            fullHeight: true
        });
        const overflowMenuConfig = [
            {
                type: 'overflow-dropdown',
                testId: testId,
                options: [
                    {
                        title: intl.formatMessage((0, $fNLdd.default).copyToClipboard),
                        onClick: ()=>{
                            var _pluginInjectionApi$c3, _pluginInjectionApi$f2;
                            pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$c3 = pluginInjectionApi.core) === null || _pluginInjectionApi$c3 === void 0 || _pluginInjectionApi$c3.actions.execute(pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$f2 = pluginInjectionApi.floatingToolbar) === null || _pluginInjectionApi$f2 === void 0 ? void 0 : _pluginInjectionApi$f2.commands.copyNode(node.type, (0, $g6Qq4.INPUT_METHOD).FLOATING_TB));
                            return true;
                        },
                        onMouseEnter: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(node.type, true, (0, $5bbjm.akEditorSelectedNodeClassName)),
                        onMouseLeave: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(node.type, false, (0, $5bbjm.akEditorSelectedNodeClassName)),
                        onFocus: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(node.type, true, (0, $5bbjm.akEditorSelectedNodeClassName)),
                        onBlur: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(node.type, false, (0, $5bbjm.akEditorSelectedNodeClassName)),
                        icon: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c81bI))), {
                            label: intl.formatMessage((0, $fNLdd.default).copyToClipboard)
                        })
                    },
                    {
                        title: intl.formatMessage((0, $fNLdd.default).delete),
                        onClick: $4efc96972221dc8f$var$withToolbarMetadata($4efc96972221dc8f$export$3301f76e6efaf85e(editorAnalyticsApi)),
                        onMouseEnter: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(node.type, true),
                        onMouseLeave: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(node.type, false),
                        onFocus: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(node.type, true),
                        onBlur: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(node.type, false),
                        icon: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gV64P))), {
                            label: intl.formatMessage((0, $fNLdd.default).delete)
                        })
                    }
                ]
            }
        ];
        toolbarItems.push(...overflowMenuConfig);
    }
    return toolbarItems;
};
const $4efc96972221dc8f$export$ddeab6943680f5be = (embedEnabled, appearance, status, isDiscoverabilityEnabled)=>{
    return embedEnabled && appearance === 'inline' && status === 'resolved' && isDiscoverabilityEnabled;
};
const $4efc96972221dc8f$export$bb790f15a666b7f0 = (options, api)=>{
    return (intl, link, onEditLink, metadata, _state)=>{
        const areAllNewToolbarFlagsDisabled = !(0, $8qHhy.areToolbarFlagsEnabled)(Boolean(api === null || api === void 0 ? void 0 : api.toolbar));
        const editLinkItem = options.allowDatasource ? [
            {
                type: 'custom',
                fallback: [],
                render: (editorView)=>{
                    var _api$analytics;
                    if (!editorView) return null;
                    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $f371K.EditToolbarButton), {
                        intl: intl,
                        editorAnalyticsApi: api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions,
                        url: link,
                        editorView: editorView,
                        onLinkEditClick: onEditLink,
                        currentAppearance: "url",
                        areAnyNewToolbarFlagsEnabled: !areAllNewToolbarFlagsDisabled
                    }, "edit-toolbar-button");
                }
            }
        ] : [
            {
                id: 'editor.link.edit',
                testId: 'editor.link.edit',
                type: 'button',
                onClick: onEditLink,
                title: intl.formatMessage((0, $ejFiy.linkToolbarMessages).editLink),
                showTitle: (0, $797yE.editorExperiment)('platform_editor_controls', 'variant1') ? false : true,
                metadata: metadata,
                icon: (0, $797yE.editorExperiment)('platform_editor_controls', 'variant1') ? (0, (/*@__PURE__*/$parcel$interopDefault($5Uddy))) : undefined
            },
            {
                type: 'separator'
            }
        ];
        if (!areAllNewToolbarFlagsDisabled) {
            var _api$analytics2, _api$analytics3;
            const hyperlinkAppearance = [
                (0, $9owK5.getCustomHyperlinkAppearanceDropdown)({
                    url: link,
                    intl: intl,
                    editorAnalyticsApi: api === null || api === void 0 || (_api$analytics2 = api.analytics) === null || _api$analytics2 === void 0 ? void 0 : _api$analytics2.actions,
                    allowDatasource: options.allowDatasource,
                    editorPluginApi: api,
                    cardOptions: options,
                    settingsConfig: $4efc96972221dc8f$export$62592e141464e202(intl, api === null || api === void 0 || (_api$analytics3 = api.analytics) === null || _api$analytics3 === void 0 ? void 0 : _api$analytics3.actions, options.userPreferencesLink),
                    isDatasourceView: false
                })
            ];
            return [
                {
                    type: 'custom',
                    fallback: [],
                    render: (editorView)=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $6D2Cw.ToolbarViewedEvent), {
                            url: link,
                            display: "url",
                            editorView: editorView
                        }, "edit.link.menu.viewed")
                },
                ...hyperlinkAppearance,
                ...editLinkItem
            ];
        }
        return [
            {
                type: 'custom',
                fallback: [],
                render: (editorView)=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $6D2Cw.ToolbarViewedEvent), {
                        url: link,
                        display: "url",
                        editorView: editorView
                    }, "edit.link.menu.viewed")
            },
            {
                type: 'custom',
                fallback: [],
                render: (editorView)=>{
                    var _api$analytics4;
                    if (!editorView) return null;
                    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $8OKVL.HyperlinkToolbarAppearance), {
                        url: link,
                        intl: intl,
                        editorView: editorView,
                        editorState: editorView.state,
                        cardOptions: options,
                        editorAnalyticsApi: api === null || api === void 0 || (_api$analytics4 = api.analytics) === null || _api$analytics4 === void 0 ? void 0 : _api$analytics4.actions,
                        editorPluginApi: api
                    }, "link-appearance");
                }
            },
            ...editLinkItem
        ];
    };
};
const $4efc96972221dc8f$export$d5ca70670b9f6b9 = (options, api)=>(intl, _link)=>{
        /**
   * Require either provider to be supplied (controls link preferences)
   * Or explicit user preferences config in order to enable button
   */ if ((options.provider || options.userPreferencesLink) && !(0, $8qHhy.areToolbarFlagsEnabled)(Boolean(api === null || api === void 0 ? void 0 : api.toolbar))) {
            var _api$analytics5;
            return [
                {
                    type: 'separator'
                },
                $4efc96972221dc8f$export$62592e141464e202(intl, api === null || api === void 0 || (_api$analytics5 = api.analytics) === null || _api$analytics5 === void 0 ? void 0 : _api$analytics5.actions, options.userPreferencesLink)
            ];
        }
        return [];
    };

});
parcelRegister("gHATu", function(module, exports) {
$parcel$export(module.exports, "alignmentIcons", () => $86b24d084c5f5e8f$export$45400139bf999022);
$parcel$export(module.exports, "wrappingIcons", () => $86b24d084c5f5e8f$export$88511ca1ca567d46);
$parcel$export(module.exports, "layoutToMessages", () => $86b24d084c5f5e8f$export$b978ceeb25a89f87);
$parcel$export(module.exports, "buildLayoutDropdown", () => $86b24d084c5f5e8f$export$31e29507a90f6f72);
$parcel$export(module.exports, "default", () => $86b24d084c5f5e8f$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $cw0wu = parcelRequire("cw0wu");

var $gab48 = parcelRequire("gab48");

var $5bbjm = parcelRequire("5bbjm");

var $btTAJ = parcelRequire("btTAJ");

var $7VT7s = parcelRequire("7VT7s");

var $7rvQD = parcelRequire("7rvQD");

var $gKziX = parcelRequire("gKziX");

var $dvoJo = parcelRequire("dvoJo");

var $i7u95 = parcelRequire("i7u95");

var $ebcTd = parcelRequire("ebcTd");

var $4S97w = parcelRequire("4S97w");

var $4wMHO = parcelRequire("4wMHO");

var $l94df = parcelRequire("l94df");

var $5N1Y4 = parcelRequire("5N1Y4");

var $g6Qq4 = parcelRequire("g6Qq4");

var $afHZ2 = parcelRequire("afHZ2");

var $cv8id = parcelRequire("cv8id");

var $fNLdd = parcelRequire("fNLdd");
var $ahEv1 = parcelRequire("ahEv1");

var $cut9B = parcelRequire("cut9B");

var $1QLHG = parcelRequire("1QLHG");
var $5BDGB = parcelRequire("5BDGB");
var $6B1yf = parcelRequire("6B1yf");
const $86b24d084c5f5e8f$export$45400139bf999022 = [
    {
        id: 'editor.media.alignLeft',
        value: 'align-start',
        icon: ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7VT7s))), {
                color: "currentColor",
                spacing: "spacious",
                label: "media-toolbar-align-left-icon"
            })
    },
    {
        id: 'editor.media.alignCenter',
        value: 'center',
        icon: ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($btTAJ))), {
                color: "currentColor",
                spacing: "spacious",
                label: "media-toolbar-align-center-icon"
            })
    },
    {
        id: 'editor.media.alignRight',
        value: 'align-end',
        icon: ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7rvQD))), {
                color: "currentColor",
                spacing: "spacious",
                label: "media-toolbar-align-right-icon"
            })
    }
];
const $86b24d084c5f5e8f$var$alignmentIconsControls = [
    {
        id: 'editor.media.alignLeft',
        value: 'align-start',
        icon: ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dvoJo))), {
                color: "currentColor",
                spacing: "spacious",
                label: ""
            }),
        keyboardShortcut: (0, $cv8id.alignLeft)
    },
    {
        id: 'editor.media.alignCenter',
        value: 'center',
        icon: ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gKziX))), {
                color: "currentColor",
                spacing: "spacious",
                label: ""
            }),
        keyboardShortcut: (0, $cv8id.alignCenter)
    },
    {
        id: 'editor.media.alignRight',
        value: 'align-end',
        icon: ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($i7u95))), {
                color: "currentColor",
                spacing: "spacious",
                label: ""
            }),
        keyboardShortcut: (0, $cv8id.alignRight)
    }
];
const $86b24d084c5f5e8f$export$88511ca1ca567d46 = [
    {
        id: 'editor.media.wrapLeft',
        value: 'wrap-left',
        icon: ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4S97w))), {
                color: "currentColor",
                spacing: "spacious",
                label: "media-toolbar-wrap-left-icon"
            })
    },
    {
        id: 'editor.media.wrapRight',
        value: 'wrap-right',
        icon: ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4wMHO))), {
                color: "currentColor",
                spacing: "spacious",
                label: "media-toolbar-wrap-right-icon"
            })
    }
];
const $86b24d084c5f5e8f$var$breakoutIcons = [
    {
        value: 'wide',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ebcTd)))
    },
    {
        value: 'full-width',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($l94df)))
    }
];
const $86b24d084c5f5e8f$export$b978ceeb25a89f87 = {
    'wrap-left': (0, $ahEv1.toolbarMessages).wrapLeft,
    center: (0, $fNLdd.default).alignImageCenter,
    'wrap-right': (0, $ahEv1.toolbarMessages).wrapRight,
    wide: (0, $fNLdd.default).layoutWide,
    'full-width': (0, $fNLdd.default).layoutFullWidth,
    'align-end': (0, $fNLdd.default).alignImageRight,
    'align-start': (0, $fNLdd.default).alignImageLeft
};
const $86b24d084c5f5e8f$var$getNodeWidth = (node, schema)=>{
    const { embedCard: embedCard } = schema.nodes;
    if (node.type === embedCard) return node.attrs.originalWidth || (0, $5bbjm.DEFAULT_EMBED_CARD_WIDTH);
    return node.firstChild && node.firstChild.attrs.width || node.attrs.width;
};
const $86b24d084c5f5e8f$var$makeAlign = (layout, nodeType, widthPluginDependencyApi, analyticsApi, allowPixelResizing)=>{
    return (state, dispatch)=>{
        const { node: node } = state.selection;
        const { layout: previousLayoutType } = node.attrs;
        const { mediaSingle: mediaSingle } = state.schema.nodes;
        if (!dispatch) return false;
        const widthPluginState = widthPluginDependencyApi === null || widthPluginDependencyApi === void 0 ? void 0 : widthPluginDependencyApi.sharedState.currentState();
        if (!node || node.type !== nodeType || !widthPluginState) return false;
        const nodeWidth = $86b24d084c5f5e8f$var$getNodeWidth(node, state.schema);
        const newAttrs = allowPixelResizing ? // with extended experience, change alignment does not change media single width
        {
            ...node.attrs,
            layout: layout
        } : (0, $1QLHG.alignAttributes)(layout, node.attrs, undefined, nodeWidth, widthPluginState.lineLength);
        const tr = state.tr.setNodeMarkup(state.selection.from, undefined, newAttrs);
        tr.setMeta('scrollIntoView', false);
        // when image captions are enabled, the wrong node gets selected after
        // setNodeMarkup is called
        tr.setSelection((0, $cw0wu.NodeSelection).create(tr.doc, state.selection.from));
        const { doc: { type: { schema: { nodes: { paragraph: paragraph } } } } } = tr;
        // see https://product-fabric.atlassian.net/browse/ED-15518 insert a new paragraph when an embedded card is wrapped left or right
        if (layout.startsWith('wrap') && paragraph && !tr.doc.nodeAt(state.selection.to) && ((0, $afHZ2.insideTable)(state) || (0, $5BDGB.isInLayoutColumn)(state))) {
            const emptyParaghraph = paragraph.createAndFill();
            if (emptyParaghraph) tr.insert(state.selection.to, emptyParaghraph);
        }
        analyticsApi === null || analyticsApi === void 0 || analyticsApi.attachAnalyticsEvent({
            eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
            action: (0, $g6Qq4.ACTION).SELECTED,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT)[node.type === mediaSingle ? 'MEDIA_SINGLE' : 'EMBEDS'],
            actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).RICH_MEDIA_LAYOUT,
            attributes: {
                previousLayoutType: previousLayoutType,
                currentLayoutType: layout
            }
        })(tr);
        dispatch(tr);
        return true;
    };
};
const $86b24d084c5f5e8f$var$getToolbarLayout = (layout, allowPixelResizing)=>{
    if ((0, $6B1yf.nonWrappedLayouts).includes(layout) && allowPixelResizing) return 'center';
    return layout;
};
const $86b24d084c5f5e8f$var$mapIconsToToolbarItem = (icons, layout, intl, nodeType, widthPluginDependencyApi, analyticsApi, isChangingLayoutDisabled, allowPixelResizing)=>icons.map((toolbarItem)=>{
        const { id: id, value: value } = toolbarItem;
        return {
            id: id,
            type: 'button',
            icon: toolbarItem.icon,
            title: intl.formatMessage($86b24d084c5f5e8f$export$b978ceeb25a89f87[value]),
            selected: $86b24d084c5f5e8f$var$getToolbarLayout(layout, allowPixelResizing) === value,
            onClick: $86b24d084c5f5e8f$var$makeAlign(value, nodeType, widthPluginDependencyApi, analyticsApi, allowPixelResizing),
            ...isChangingLayoutDisabled && {
                disabled: value !== 'center'
            }
        };
    });
const $86b24d084c5f5e8f$var$mapIconsToDropdownOptions = ({ icons: icons, layout: layout, intl: intl, nodeType: nodeType, widthPluginDependencyApi: widthPluginDependencyApi, analyticsApi: analyticsApi, isChangingLayoutDisabled: isChangingLayoutDisabled, allowPixelResizing: allowPixelResizing })=>icons.map((layoutOption)=>{
        const { id: id, value: value } = layoutOption;
        return {
            id: id,
            icon: /*#__PURE__*/ (0, $dc70d.jsx)(layoutOption.icon, {
                label: ""
            }),
            title: intl.formatMessage($86b24d084c5f5e8f$export$b978ceeb25a89f87[value]),
            selected: $86b24d084c5f5e8f$var$getToolbarLayout(layout, allowPixelResizing) === value,
            onClick: $86b24d084c5f5e8f$var$makeAlign(value, nodeType, widthPluginDependencyApi, analyticsApi, allowPixelResizing),
            ...layoutOption.keyboardShortcut && {
                elemAfter: /*#__PURE__*/ (0, $dc70d.jsx)((0, $cut9B.Shortcut), {
                    children: (0, $cv8id.tooltip)(layoutOption.keyboardShortcut)
                })
            },
            ...isChangingLayoutDisabled && {
                disabled: value !== 'center'
            }
        };
    });
const $86b24d084c5f5e8f$var$shouldHideLayoutToolbar = (selection, { nodes: nodes }, allowResizingInTables)=>{
    return (0, $gab48.hasParentNodeOfType)([
        nodes.bodiedExtension,
        nodes.extensionFrame,
        nodes.listItem,
        ...(0, $5N1Y4.expValEquals)('editor_enable_image_alignment_in_expand', 'isEnabled', true) ? [] : [
            nodes.expand,
            nodes.nestedExpand
        ],
        ...allowResizingInTables ? [] : [
            nodes.table
        ]
    ].filter(Boolean))(selection);
};
const $86b24d084c5f5e8f$var$buildLayoutButtons = (state, intl, nodeType, widthPluginDependencyApi, analyticsApi, allowResizing, allowResizingInTables, allowWrapping = true, allowAlignment = true, isChangingLayoutDisabled, allowPixelResizing)=>{
    const { selection: selection } = state;
    if (!(selection instanceof (0, $cw0wu.NodeSelection)) || !selection.node || !nodeType || $86b24d084c5f5e8f$var$shouldHideLayoutToolbar(selection, state.schema, allowResizingInTables)) return [];
    const { layout: layout } = selection.node.attrs;
    const alignmentToolbarItems = allowAlignment ? $86b24d084c5f5e8f$var$mapIconsToToolbarItem($86b24d084c5f5e8f$export$45400139bf999022, layout, intl, nodeType, widthPluginDependencyApi, analyticsApi, isChangingLayoutDisabled, allowPixelResizing) : [];
    const wrappingToolbarItems = allowWrapping ? $86b24d084c5f5e8f$var$mapIconsToToolbarItem($86b24d084c5f5e8f$export$88511ca1ca567d46, layout, intl, nodeType, widthPluginDependencyApi, analyticsApi, isChangingLayoutDisabled, allowPixelResizing) : [];
    const breakOutToolbarItems = !allowResizing ? $86b24d084c5f5e8f$var$mapIconsToToolbarItem($86b24d084c5f5e8f$var$breakoutIcons, layout, intl, nodeType, widthPluginDependencyApi, analyticsApi, allowPixelResizing) : [];
    const items = [
        ...alignmentToolbarItems,
        ...$86b24d084c5f5e8f$var$getSeparatorBetweenAlignmentAndWrapping(allowAlignment, allowWrapping),
        ...wrappingToolbarItems,
        ...$86b24d084c5f5e8f$var$getSeparatorBeforeBreakoutItems(allowAlignment, allowWrapping, allowResizing),
        ...breakOutToolbarItems
    ];
    return items;
};
const $86b24d084c5f5e8f$export$31e29507a90f6f72 = (state, intl, nodeType, widthPluginDependencyApi, analyticsApi, allowResizing, allowResizingInTables, allowWrapping = true, allowAlignment = true, isChangingLayoutDisabled, allowPixelResizing)=>{
    const { selection: selection } = state;
    if (!(selection instanceof (0, $cw0wu.NodeSelection)) || !selection.node || !nodeType || $86b24d084c5f5e8f$var$shouldHideLayoutToolbar(selection, state.schema, allowResizingInTables)) return [];
    const { layout: layout } = selection.node.attrs;
    const icons = [];
    if (allowAlignment) icons.push(...$86b24d084c5f5e8f$var$alignmentIconsControls);
    if (allowWrapping) icons.push(...$86b24d084c5f5e8f$export$88511ca1ca567d46);
    if (!allowResizing) icons.push(...$86b24d084c5f5e8f$var$breakoutIcons);
    if (icons.length === 0) return [];
    const selectedLayout = $86b24d084c5f5e8f$var$getSelectedLayoutIcon(icons, selection.node) || icons[0];
    if (!selectedLayout) return [];
    const alignmentDropdownOptions = $86b24d084c5f5e8f$var$mapIconsToDropdownOptions({
        icons: icons,
        layout: layout,
        intl: intl,
        nodeType: nodeType,
        widthPluginDependencyApi: widthPluginDependencyApi,
        analyticsApi: analyticsApi,
        isChangingLayoutDisabled: isChangingLayoutDisabled,
        allowPixelResizing: allowPixelResizing
    });
    return [
        {
            type: 'dropdown',
            title: intl.formatMessage($86b24d084c5f5e8f$export$b978ceeb25a89f87[selectedLayout.value]),
            icon: selectedLayout.icon,
            options: alignmentDropdownOptions,
            shouldFitContainer: false,
            testId: `${nodeType.name}-layout-dropdown-trigger-button`
        }
    ];
};
const $86b24d084c5f5e8f$var$getSelectedLayoutIcon = (layoutIcons, selectedNode)=>{
    const selectedLayout = selectedNode.attrs.layout;
    return layoutIcons.find((icon)=>icon.value === ((0, $6B1yf.nonWrappedLayouts).includes(selectedLayout) ? 'center' : selectedLayout));
};
const $86b24d084c5f5e8f$var$getSeparatorBetweenAlignmentAndWrapping = (allowAlignment, allowWrapping)=>allowAlignment && allowWrapping ? [
        {
            type: 'separator'
        }
    ] : [];
const $86b24d084c5f5e8f$var$getSeparatorBeforeBreakoutItems = (allowAlignment, allowWrapping, allowResizing)=>!allowResizing && (allowAlignment || allowWrapping) ? [
        {
            type: 'separator'
        }
    ] : [];
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$86b24d084c5f5e8f$export$2e2bcd8739ae039 = $86b24d084c5f5e8f$var$buildLayoutButtons;

});
parcelRegister("afHZ2", function(module, exports) {
$parcel$export(module.exports, "insideTable", () => $84c95559d5cf85af$export$244bf4b32387ef62);

var $gab48 = parcelRequire("gab48");
const $84c95559d5cf85af$export$244bf4b32387ef62 = (state)=>{
    const { table: table, tableCell: tableCell } = state.schema.nodes;
    return (0, $gab48.hasParentNodeOfType)([
        table,
        tableCell
    ])(state.selection);
};

});


parcelRegister("hGzMn", function(module, exports) {
$parcel$export(module.exports, "commandWithMetadata", () => $bd4449d7d66d8198$export$76125a95b70625ac);

var $dVt29 = parcelRequire("dVt29");

const $bd4449d7d66d8198$export$76125a95b70625ac = (command, metadata)=>{
    return (state, dispatch, view)=>{
        if (!dispatch) return command(state, dispatch, view);
        return command(state, (tr)=>{
            (0, $dVt29.addLinkMetadata)(state.selection, tr, metadata);
            dispatch(tr);
        }, view);
    };
};

});

parcelRegister("8FY43", function(module, exports) {
$parcel$export(module.exports, "linkMessages", () => $40f30e9c3e2dd839$export$4ce3884394d6d9);

var $f0Pt4 = parcelRequire("f0Pt4");
const $40f30e9c3e2dd839$export$4ce3884394d6d9 = (0, $f0Pt4.defineMessages)({
    openLink: {
        id: 'fabric.editor.openLink',
        defaultMessage: 'Open link in a new tab',
        description: 'The text is shown as a link action in the editor toolbar or context menu when a user can open a linked URL in a new browser tab.'
    },
    openPreviewPanel: {
        id: 'fabric.editor.openPreviewPanel',
        defaultMessage: 'Open preview panel',
        description: 'Opens preview panel and loads the page inside it'
    }
});

});

parcelRegister("ejFiy", function(module, exports) {
$parcel$export(module.exports, "linkToolbarMessages", () => $551ffa2f62fd2d47$export$2d7676d841c8ae9);

var $f0Pt4 = parcelRequire("f0Pt4");
const $551ffa2f62fd2d47$export$2d7676d841c8ae9 = (0, $f0Pt4.defineMessages)({
    addLink: {
        id: 'fabric.editor.mediaAddLink',
        defaultMessage: 'Add link',
        description: 'The text is shown as a button label in the editor link toolbar when the user wants to add a hyperlink to selected content.'
    },
    unableToOpenLink: {
        id: 'fabric.editor.unableToOpenLink',
        defaultMessage: 'Unable to open this link',
        description: 'The text is shown as an error message in the editor link toolbar when the application cannot open the selected hyperlink.'
    },
    unlink: {
        id: 'fabric.editor.unlink',
        defaultMessage: 'Unlink',
        description: 'Removes the hyperlink but keeps your text.'
    },
    editDatasourceStandalone: {
        id: 'fabric.editor.editDatasourceStandalone',
        defaultMessage: 'Edit',
        description: 'A standalone edit button to edit the datasource via a config modal'
    },
    editDatasourceStandaloneTooltip: {
        id: 'fabric.editor.editDatasourceStandaloneTooltip',
        defaultMessage: 'Edit search query',
        description: 'A standalone edit button tooltip to hint at editing the datasource via a config modal'
    },
    editLink: {
        id: 'fabric.editor.editLink',
        defaultMessage: 'Edit link',
        description: 'Label for the button in the link floating toolbar that opens the link editing panel where users can update the URL or display text.'
    },
    placeholder: {
        id: 'fabric.editor.hyperlinkToolbarPlaceholder',
        defaultMessage: 'Paste or search for link',
        description: 'The text is shown as placeholder text in the hyperlink toolbar input field where the user can paste a URL or search for a link.'
    },
    linkPlaceholder: {
        id: 'fabric.editor.linkPlaceholder',
        defaultMessage: 'Paste link',
        description: 'Placeholder text shown in the link input field prompting users to paste a URL to create a new link.'
    },
    linkAddress: {
        id: 'fabric.editor.linkAddress',
        defaultMessage: 'Link address',
        description: 'Label for the link address input field. Prompts users to enter or paste the URL address for the hyperlink.'
    },
    invalidLink: {
        id: 'fabric.editor.invalidLink',
        defaultMessage: 'Please enter a valid link.',
        description: 'The text is shown as an error message in the editor link toolbar when the user enters a URL that is not valid or properly formatted.'
    },
    emptyLink: {
        id: 'fabric.editor.emptyLink',
        defaultMessage: 'Please enter a link.',
        description: 'The text is shown as an error message in the editor link toolbar when the user submits the link field without entering any URL.'
    },
    settingsLink: {
        id: 'fabric.editor.settingsLinks',
        defaultMessage: 'Go to Link Preferences',
        description: 'The text is shown as a link in the editor link toolbar that navigates the user to the link preferences settings page.'
    },
    preferencesLink: {
        id: 'fabric.editor.preferencesLink',
        defaultMessage: 'Link preferences',
        description: 'The text is shown as a link label in the editor toolbar that opens the link preferences settings for the user.'
    },
    editDatasource: {
        id: 'fabric.editor.edit.datasource',
        defaultMessage: 'Edit search query',
        description: 'Label for the edit button in the datasource floating toolbar that opens the datasource configuration modal to update the search query.'
    },
    searchInput: {
        id: 'fabric.editor.edit.searchInput',
        defaultMessage: 'Add a link',
        description: 'Accessible label for the link search input field in the datasource toolbar where users type to search for or add a link.'
    }
});

});

parcelRegister("hU1ZA", function(module, exports) {
$parcel$export(module.exports, "DatasourceAppearanceButton", () => $b87a5cb84daf9001$export$76de8066d79563a4);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $7HjEm = parcelRequire("7HjEm");

var $278lv = parcelRequire("278lv");

var $8XENo = parcelRequire("8XENo");

var $cw0wu = parcelRequire("cw0wu");

var $jqvxO = parcelRequire("jqvxO");

var $6bOBo = parcelRequire("6bOBo");

var $6X9z7 = parcelRequire("6X9z7");

var $a76m2 = parcelRequire("a76m2");

var $1fMby = parcelRequire("1fMby");

var $1H7gO = parcelRequire("1H7gO");

var $h5Xzz = parcelRequire("h5Xzz");
function $b87a5cb84daf9001$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b87a5cb84daf9001$var$buttonStyles = {
    name: "1quw0ni",
    styles: "pointer-events:auto"
};
const $b87a5cb84daf9001$var$DatasourceAppearanceButtonWithCardContext = ({ cardContext: cardContext, intl: intl, url: url, editorView: editorView, editorState: editorState, selected: selected, inputMethod: inputMethod, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled })=>{
    const { datasourceId: datasourceId, parameters: parameters } = (0, $h5Xzz.useFetchDatasourceInfo)({
        isRegularCardNode: true,
        url: url,
        cardContext: cardContext
    });
    const onChangeAppearance = (0, $bSJIT.useCallback)(()=>{
        var _state$datasourceStas;
        if (!editorView || !datasourceId || !parameters) return;
        const state = (0, $1fMby.pluginKey).getState(editorState);
        const newAdf = (0, $jqvxO.buildDatasourceAdf)({
            id: datasourceId,
            parameters: parameters,
            views: (state === null || state === void 0 || (_state$datasourceStas = state.datasourceStash[url]) === null || _state$datasourceStas === void 0 ? void 0 : _state$datasourceStas.views) ?? [
                {
                    type: 'table'
                }
            ]
        }, url);
        const { selection: selection } = editorState;
        let existingNode;
        // Check if the selection contains a link mark
        const $pos = editorState.doc.resolve(selection.from);
        const isLinkMark = $pos.marks().some((mark)=>mark.type === editorState.schema.marks.link);
        // When selection is a TextNode and a link Mark is present return that node
        if (selection instanceof (0, $cw0wu.NodeSelection)) existingNode = selection.node;
        else if (isLinkMark) existingNode = editorState.doc.nodeAt(selection.from) ?? undefined;
        if (existingNode) (0, $a76m2.updateCardViaDatasource)({
            state: editorState,
            node: existingNode,
            newAdf: newAdf,
            view: editorView,
            sourceEvent: undefined,
            isDeletingConfig: true,
            inputMethod: inputMethod
        });
    }, [
        parameters,
        datasourceId,
        inputMethod,
        editorState,
        editorView,
        url
    ]);
    if (!parameters || !datasourceId || !(0, $8XENo.canRenderDatasource)(datasourceId)) return null;
    if (url) {
        var _cardContext$store, _urlState$error;
        const urlState = cardContext === null || cardContext === void 0 || (_cardContext$store = cardContext.store) === null || _cardContext$store === void 0 ? void 0 : _cardContext$store.getState()[url];
        if ((urlState === null || urlState === void 0 || (_urlState$error = urlState.error) === null || _urlState$error === void 0 ? void 0 : _urlState$error.kind) === 'fatal') return null;
    }
    const buttonLabel = intl.formatMessage((0, $278lv.messages).datasourceAppearanceTitle);
    return /*#__PURE__*/ (0, $9dQre.jsx)((0, $6X9z7.Flex), null, /*#__PURE__*/ (0, $9dQre.jsx)((0, $7HjEm.default), {
        css: $b87a5cb84daf9001$var$buttonStyles,
        title: buttonLabel,
        icon: /*#__PURE__*/ (0, $9dQre.jsx)((0, $1H7gO.DatasourceIcon), {
            label: buttonLabel
        }),
        selected: selected,
        onClick: onChangeAppearance,
        testId: 'card-datasource-appearance-button',
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    }));
};
const $b87a5cb84daf9001$export$76de8066d79563a4 = ({ intl: intl, editorAnalyticsApi: editorAnalyticsApi, url: url, editorView: editorView, editorState: editorState, selected: selected, inputMethod: inputMethod, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled })=>{
    const cardContext = (0, $6bOBo.useSmartLinkContext)();
    return /*#__PURE__*/ (0, $9dQre.jsx)($b87a5cb84daf9001$var$DatasourceAppearanceButtonWithCardContext, {
        url: url,
        intl: intl,
        editorAnalyticsApi: editorAnalyticsApi,
        editorView: editorView,
        editorState: editorState,
        cardContext: cardContext,
        selected: selected,
        inputMethod: inputMethod,
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    });
};

});
parcelRegister("7HjEm", function(module, exports) {
$parcel$export(module.exports, "default", () => $5af231fce0ab270d$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $2U5M0 = parcelRequire("2U5M0");

var $5N1Y4 = parcelRequire("5N1Y4");

var $lavtv = parcelRequire("lavtv");

var $7Dc9X = parcelRequire("7Dc9X");

var $4T0BS = parcelRequire("4T0BS");
const $5af231fce0ab270d$var$customSizeAndPadding = {
    minWidth: "var(--ds-space-400, 32px)",
    padding: `0px ${"var(--ds-space-050, 4px)"}`
};
const $5af231fce0ab270d$var$FloatingToolbarButton = ({ title: title, icon: icon, iconAfter: iconAfter, onClick: onClick, onKeyDown: onKeyDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onFocus: onFocus, onBlur: onBlur, onMount: onMount, onUnmount: onUnmount, selected: selected, disabled: disabled, href: href, target: target, appearance: appearance = 'subtle', children: children, className: className, tooltipContent: tooltipContent, tooltipStyle: tooltipStyle, testId: testId, interactionName: interactionName, hideTooltipOnClick: hideTooltipOnClick = true, hasNewContentOnTriggerClick: hasNewContentOnTriggerClick, ariaHasPopup: ariaHasPopup, tabIndex: tabIndex, areaControls: areaControls, ariaLabel: ariaLabel, isRadioButton: isRadioButton, isLoading: isLoading, pulse: pulse, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled }, forwardedRef)=>{
    // Check if there's only an icon and add additional styles
    const iconOnly = (icon || iconAfter) && !children;
    const customSpacing = iconOnly ? (0, $7Dc9X.iconOnlySpacing) : {};
    const isButtonPressed = ariaHasPopup ? undefined : selected;
    /**
   * If it's a radio button, we need to reflect false values too, hence
   * we cast it as a Boolean
   */ const ariaChecked = isRadioButton ? Boolean(isButtonPressed) : undefined;
    const ariaPressed = isRadioButton ? undefined : isButtonPressed;
    (0, $bSJIT.useEffect)(()=>{
        onMount === null || onMount === void 0 || onMount();
        return ()=>onUnmount === null || onUnmount === void 0 ? void 0 : onUnmount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleOnClick = (0, $bSJIT.useCallback)((event)=>{
        onClick === null || onClick === void 0 || onClick(event);
    }, [
        onClick
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dc70d.Fragment), {
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $lavtv.default), {
            // Only fallback to title for tooltip if title is not shown
            content: tooltipContent || (iconOnly ? title : undefined),
            component: tooltipStyle,
            hideTooltipOnClick: hideTooltipOnClick,
            hasNewContentOnTriggerClick: hasNewContentOnTriggerClick,
            position: "top",
            children: /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                onMouseEnter: (0, $5N1Y4.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? undefined : onMouseEnter,
                onMouseLeave: (0, $5N1Y4.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? undefined : onMouseLeave,
                children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $2U5M0.default), {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides -- Ignored via go/DSP-18766
                    className: className,
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    ref: (buttonElement)=>{
                        if (forwardedRef) {
                            if (typeof forwardedRef === 'function') forwardedRef(buttonElement);
                            else if (typeof forwardedRef === 'object') forwardedRef.current = buttonElement;
                        }
                    },
                    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    theme: (adgTheme, themeProps)=>{
                        const { buttonStyles: buttonStyles, ...rest } = adgTheme(themeProps);
                        return {
                            buttonStyles: {
                                ...buttonStyles,
                                ...customSpacing,
                                ...appearance === 'danger' && (0, $4T0BS.getButtonStyles)({
                                    appearance: appearance,
                                    state: themeProps.state,
                                    mode: themeProps.mode
                                }),
                                ...areAnyNewToolbarFlagsEnabled ? $5af231fce0ab270d$var$customSizeAndPadding : {}
                            },
                            ...rest
                        };
                    },
                    "aria-label": ariaLabel || title,
                    "aria-pressed": ariaPressed,
                    "aria-checked": ariaChecked,
                    role: isRadioButton ? 'radio' : undefined,
                    "aria-expanded": ariaHasPopup ? selected : undefined,
                    "aria-controls": ariaHasPopup ? areaControls : undefined,
                    spacing: areAnyNewToolbarFlagsEnabled ? 'default' : 'compact',
                    href: href,
                    target: target,
                    appearance: appearance,
                    "aria-haspopup": ariaHasPopup,
                    iconBefore: icon || undefined,
                    iconAfter: iconAfter,
                    onClick: handleOnClick,
                    onKeyDown: onKeyDown,
                    isSelected: selected,
                    isDisabled: disabled,
                    isLoading: isLoading,
                    testId: testId,
                    interactionName: interactionName,
                    onMouseEnter: (0, $5N1Y4.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? onMouseEnter : undefined,
                    onMouseLeave: (0, $5N1Y4.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? onMouseLeave : undefined,
                    onFocus: onFocus,
                    onBlur: onBlur,
                    // @ts-ignore
                    // tabIndex set as 0 by default in the design system  ButtonBase component
                    // this is not expected for all buttons, we have to use tabIndex={null} for some cases
                    // should be fixed here https://a11y-internal.atlassian.net/browse/DST-287
                    tabIndex: tabIndex,
                    children: children
                })
            })
        })
    });
};
const $5af231fce0ab270d$var$FloatingToolbarButtonWithRef = /*#__PURE__*/ (0, $bSJIT.forwardRef)($5af231fce0ab270d$var$FloatingToolbarButton);
var $5af231fce0ab270d$export$2e2bcd8739ae039 = $5af231fce0ab270d$var$FloatingToolbarButtonWithRef;

});
parcelRegister("7Dc9X", function(module, exports) {
$parcel$export(module.exports, "iconOnlySpacing", () => $9d23af5bc28a1736$export$7d8cec9727d4e603);
const $9d23af5bc28a1736$export$7d8cec9727d4e603 = {
    '&&': {
        padding: '0px'
    },
    '& > span': {
        margin: '0px'
    }
};

});

parcelRegister("4T0BS", function(module, exports) {
$parcel$export(module.exports, "getButtonStyles", () => $020a6d3928f2bd8c$export$f98ea88a275be66c);
const $020a6d3928f2bd8c$var$getStyles = (property, { appearance: appearance = 'default', state: state = 'default', mode: mode = 'light' })=>{
    if (!property[appearance] || !property[appearance][state]) return 'initial';
    return property[appearance][state][mode];
};
const $020a6d3928f2bd8c$var$backgroundVisualRefresh = {
    danger: {
        default: {
            light: 'inherit',
            dark: 'inherit'
        },
        hover: {
            light: "var(--ds-background-danger-hovered, #FFD5D2)",
            dark: "var(--ds-background-danger-hovered, #FFD5D2)"
        },
        active: {
            light: "var(--ds-background-danger-pressed, #FFB8B2)",
            dark: "var(--ds-background-danger-pressed, #FFB8B2)"
        }
    }
};
const $020a6d3928f2bd8c$var$colorVisualRefresh = {
    danger: {
        default: {
            light: "var(--ds-icon-subtle, #505258)",
            dark: "var(--ds-icon-subtle, #505258)"
        },
        hover: {
            light: "var(--ds-icon-danger, #C9372C)",
            dark: "var(--ds-icon-danger, #C9372C)"
        },
        active: {
            light: "var(--ds-icon-danger, #C9372C)",
            dark: "var(--ds-icon-danger, #C9372C)"
        }
    }
};
const $020a6d3928f2bd8c$export$f98ea88a275be66c = (props)=>({
        background: $020a6d3928f2bd8c$var$getStyles($020a6d3928f2bd8c$var$backgroundVisualRefresh, props),
        color: $020a6d3928f2bd8c$var$getStyles($020a6d3928f2bd8c$var$colorVisualRefresh, props)
    }); // eslint-disable-next-line @atlaskit/editor/no-re-export

});


parcelRegister("1H7gO", function(module, exports) {
$parcel$export(module.exports, "DatasourceIcon", () => $116cce2a06e582dc$export$8819453811a57211);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $d6RFo = parcelRequire("d6RFo");

var $cMYsY = parcelRequire("cMYsY");

var $9BVpB = parcelRequire("9BVpB");
const $116cce2a06e582dc$var$wrapperStyles = (0, $9BVpB.xcss)({
    padding: 'space.050',
    justifyContent: 'center',
    alignItems: 'center',
    width: 'space.300',
    height: 'space.300'
});
const $116cce2a06e582dc$export$8819453811a57211 = (props)=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $cMYsY.Flex), {
        xcss: $116cce2a06e582dc$var$wrapperStyles,
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d6RFo))), {
            label: props === null || props === void 0 ? void 0 : props.label
        })
    });
};

});

parcelRegister("h5Xzz", function(module, exports) {
$parcel$export(module.exports, "useFetchDatasourceInfo", () => $b27788be4de96cc5$export$d01c44dffc996c80);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");
const $b27788be4de96cc5$export$d01c44dffc996c80 = ({ isRegularCardNode: isRegularCardNode, url: url, cardContext: cardContext, nodeParameters: nodeParameters })=>{
    const [datasourceId, setDatasourceId] = (0, $bSJIT.useState)(undefined);
    const [parameters, setParameters] = (0, $bSJIT.useState)(nodeParameters);
    // Since fetchData() is async, using this ready check to see if we have the parameters before passing it to the modal.
    // Only non-datasource nodes will be not ready initially since we need to fetch data.
    const [ready, setReady] = (0, $bSJIT.useState)(!isRegularCardNode);
    const [extensionKey, setExtensionKey] = (0, $bSJIT.useState)(undefined);
    (0, $bSJIT.useEffect)(()=>{
        const fetchDatasource = async ()=>{
            try {
                var _cardContext$connecti, _datasources$, _datasources$2;
                if (!url || !cardContext) {
                    // Don't block rendering of modal of somehow we don't get these two args --> just open with empty params
                    setReady(true);
                    return;
                }
                const response = await (cardContext === null || cardContext === void 0 || (_cardContext$connecti = cardContext.connections) === null || _cardContext$connecti === void 0 || (_cardContext$connecti = _cardContext$connecti.client) === null || _cardContext$connecti === void 0 ? void 0 : _cardContext$connecti.fetchData(url));
                const datasources = response && response.datasources || [];
                setExtensionKey(response === null || response === void 0 ? void 0 : response.meta.key);
                setDatasourceId((_datasources$ = datasources[0]) === null || _datasources$ === void 0 ? void 0 : _datasources$.id);
                setParameters((_datasources$2 = datasources[0]) === null || _datasources$2 === void 0 ? void 0 : _datasources$2.parameters);
                setReady(true);
            } catch (e) {
                setDatasourceId(undefined);
                setParameters(undefined);
                setExtensionKey(undefined);
                // If fetch somehow errors, still set ready as true so we don't block the rendering of the modal.
                // It will just open with empty params.
                setReady(true);
            }
        };
        if (isRegularCardNode) fetchDatasource();
    }, [
        isRegularCardNode,
        cardContext,
        url
    ]);
    return {
        datasourceId: datasourceId,
        parameters: parameters,
        ready: ready,
        extensionKey: extensionKey
    };
};

});


parcelRegister("g6njf", function(module, exports) {
$parcel$export(module.exports, "getEditLinkCallback", () => $79ce3b35ea38e165$export$c389e1daeae312a9);
$parcel$export(module.exports, "buildEditLinkToolbar", () => $79ce3b35ea38e165$export$dec3901e38d4e7ff);
$parcel$export(module.exports, "editLinkToolbarConfig", () => $79ce3b35ea38e165$export$acaefd190fd8ff4d);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $ci54V = parcelRequire("ci54V");

var $g6Qq4 = parcelRequire("g6Qq4");

var $hGzMn = parcelRequire("hGzMn");

var $7Zwry = parcelRequire("7Zwry");

var $GdBew = parcelRequire("GdBew");

var $ejFiy = parcelRequire("ejFiy");

var $cw0wu = parcelRequire("cw0wu");

var $k5X6V = parcelRequire("k5X6V");

var $a76m2 = parcelRequire("a76m2");

var $cKhMH = parcelRequire("cKhMH");
function $79ce3b35ea38e165$export$a46cebff622c3cae({ linkPickerOptions: linkPickerOptions = {}, onSubmit: onSubmit, displayText: displayText, displayUrl: displayUrl, providerFactory: providerFactory, view: view, onCancel: onCancel, invokeMethod: invokeMethod, lpLinkPicker: lpLinkPicker, onClose: onClose, onEscapeCallback: onEscapeCallback, onClickAwayCallback: onClickAwayCallback }) {
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $GdBew.HyperlinkAddToolbar), {
        linkPickerOptions: linkPickerOptions,
        onSubmit: onSubmit,
        displayText: displayText,
        displayUrl: displayUrl,
        providerFactory: providerFactory,
        view: view,
        onCancel: onCancel,
        invokeMethod: invokeMethod,
        lpLinkPicker: lpLinkPicker,
        onClose: onClose,
        onEscapeCallback: onEscapeCallback,
        onClickAwayCallback: onClickAwayCallback
    });
}
class $79ce3b35ea38e165$export$3d21e16152ee408f extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Component {
    componentDidUpdate(prevProps) {
        if (prevProps.node !== this.props.node) this.hideLinkToolbar();
    }
    componentWillUnmount() {
        this.hideLinkToolbar();
    }
    hideLinkToolbar() {
        const { view: view } = this.props;
        view.dispatch((0, $k5X6V.hideLinkToolbar)(view.state.tr));
    }
    render() {
        const { linkPickerOptions: linkPickerOptions, providerFactory: providerFactory, url: url, text: text, view: view, onSubmit: onSubmit, forceFocusSelector: forceFocusSelector, lpLinkPicker: lpLinkPicker } = this.props;
        return /*#__PURE__*/ (0, $dc70d.jsx)($79ce3b35ea38e165$export$a46cebff622c3cae, {
            view: view,
            linkPickerOptions: linkPickerOptions,
            providerFactory: providerFactory,
            displayUrl: url,
            displayText: text,
            // Assumes that the smart card link picker can only ever be invoked by clicking "edit"
            // via the floating toolbar
            invokeMethod: (0, $g6Qq4.INPUT_METHOD).FLOATING_TB,
            lpLinkPicker: lpLinkPicker,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onSubmit: (href, title, displayText, inputMethod, analytic)=>{
                this.hideLinkToolbar();
                if (onSubmit) onSubmit(href, displayText || title, inputMethod, analytic);
            },
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onEscapeCallback: (state, dispatch)=>{
                const { tr: tr } = state;
                (0, $k5X6V.hideLinkToolbar)(tr);
                forceFocusSelector === null || forceFocusSelector === void 0 || forceFocusSelector(`[aria-label="${(0, $ejFiy.linkToolbarMessages).editLink.defaultMessage}"]`)(tr);
                if (dispatch) {
                    dispatch(tr);
                    return true;
                }
                return false;
            },
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onClickAwayCallback: (state, dispatch)=>{
                const { tr: tr } = state;
                if (dispatch) {
                    dispatch(tr);
                    return true;
                }
                return false;
            }
        });
    }
}
const $79ce3b35ea38e165$export$c389e1daeae312a9 = (editorAnalyticsApi, scrollIntoView)=>(state, dispatch)=>{
        let type = 'hyperlink';
        if (state.selection instanceof (0, $cw0wu.NodeSelection)) type = state.selection.node.type.name;
        if (dispatch) {
            const { tr: tr } = state;
            (0, $k5X6V.showLinkToolbar)(tr);
            editorAnalyticsApi === null || editorAnalyticsApi === void 0 || editorAnalyticsApi.attachAnalyticsEvent((0, $ci54V.buildEditLinkPayload)(type))(tr);
            tr.setMeta('scrollIntoView', scrollIntoView);
            dispatch(tr);
            return true;
        }
        return false;
    };
const $79ce3b35ea38e165$export$dec3901e38d4e7ff = ({ providerFactory: providerFactory, node: node, pluginInjectionApi: pluginInjectionApi, linkPicker: linkPicker, lpLinkPicker: lpLinkPicker })=>{
    return {
        type: 'custom',
        disableArrowNavigation: true,
        fallback: [],
        render: (view, idx)=>{
            var _pluginInjectionApi$f;
            if (!view || !providerFactory) return null;
            const displayInfo = (0, $cKhMH.displayInfoForCard)(node, (0, $cKhMH.findCardInfo)(view.state));
            return /*#__PURE__*/ (0, $dc70d.jsx)($79ce3b35ea38e165$export$3d21e16152ee408f, {
                view: view,
                linkPickerOptions: linkPicker,
                providerFactory: providerFactory,
                url: displayInfo.url,
                text: displayInfo.title || '',
                node: node,
                lpLinkPicker: lpLinkPicker,
                forceFocusSelector: pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$f = pluginInjectionApi.floatingToolbar) === null || _pluginInjectionApi$f === void 0 || (_pluginInjectionApi$f = _pluginInjectionApi$f.actions) === null || _pluginInjectionApi$f === void 0 ? void 0 : _pluginInjectionApi$f.forceFocusSelector,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                onSubmit: (newHref, newText, inputMethod, analytic)=>{
                    const urlChanged = newHref !== displayInfo.url;
                    const titleChanged = newText !== displayInfo.title;
                    // If the title is changed in a smartlink, convert to standard blue hyperlink
                    // (even if the url was also changed) - we don't want to lose the custom title.
                    if (titleChanged) {
                        var _pluginInjectionApi$a;
                        return (0, $hGzMn.commandWithMetadata)((0, $a76m2.changeSelectedCardToLink)(newText, newHref, undefined, undefined, undefined, pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$a = pluginInjectionApi.analytics) === null || _pluginInjectionApi$a === void 0 ? void 0 : _pluginInjectionApi$a.actions), {
                            action: (0, $g6Qq4.ACTION).UPDATED,
                            inputMethod: inputMethod,
                            sourceEvent: analytic
                        })(view.state, view.dispatch);
                    }
                    if (urlChanged) // If *only* the url is changed in a smart link, reresolve
                    return (0, $a76m2.updateCard)(newHref, analytic)(view.state, view.dispatch);
                }
            }, idx);
        }
    };
};
const $79ce3b35ea38e165$export$acaefd190fd8ff4d = (showLinkingToolbar, lpLinkPicker, linkPickerOptions)=>{
    if (!showLinkingToolbar) return {};
    return {
        height: (linkPickerOptions === null || linkPickerOptions === void 0 ? void 0 : linkPickerOptions.popupHeight) ?? (lpLinkPicker ? (0, $7Zwry.LINKPICKER_HEIGHT_IN_PX) : (0, $7Zwry.RECENT_SEARCH_HEIGHT_IN_PX)),
        width: (linkPickerOptions === null || linkPickerOptions === void 0 ? void 0 : linkPickerOptions.popupWidth) ?? (0, $7Zwry.RECENT_SEARCH_WIDTH_IN_PX),
        // forcePlacement is always true to prevent the popup from rendering off-screen
        forcePlacement: true
    };
};

});
parcelRegister("7Zwry", function(module, exports) {
$parcel$export(module.exports, "RECENT_SEARCH_WIDTH_IN_PX", () => $a79deb74bf0d9dd7$export$a62aa932daf22ffe);
$parcel$export(module.exports, "RECENT_SEARCH_WIDTH_WITHOUT_ITEMS_IN_PX", () => $a79deb74bf0d9dd7$export$92a2501826f554f6);
$parcel$export(module.exports, "RECENT_SEARCH_HEIGHT_IN_PX", () => $a79deb74bf0d9dd7$export$c04a5ad015d45447);
$parcel$export(module.exports, "LINKPICKER_HEIGHT_IN_PX", () => $a79deb74bf0d9dd7$export$c635b83728f81640);
const $a79deb74bf0d9dd7$export$a62aa932daf22ffe = 420;
const $a79deb74bf0d9dd7$export$92a2501826f554f6 = 360;
const $a79deb74bf0d9dd7$export$c04a5ad015d45447 = 360;
const $a79deb74bf0d9dd7$export$c635b83728f81640 = 570;
const $a79deb74bf0d9dd7$export$6174bb2f16361f4e = 464;
const $a79deb74bf0d9dd7$export$6d1047548150003f = 512;

});

parcelRegister("GdBew", function(module, exports) {
$parcel$export(module.exports, "HyperlinkAddToolbar", () => $b284cac60a3045b1$export$8be6a38cd66ace65);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $3y2s4 = parcelRequire("3y2s4");

var $g6Qq4 = parcelRequire("g6Qq4");

var $fRXfs = parcelRequire("fRXfs");

var $9cPwp = parcelRequire("9cPwp");

var $3iYde = parcelRequire("3iYde");
const $b284cac60a3045b1$var$HYPERLINK_PROVIDERS = [
    'activityProvider',
    'searchProvider'
];
/**
 * Wraps around the editor's onSubmit handler so that the plugin can interface with the link picker
 */ const $b284cac60a3045b1$var$onSubmitInterface = (onSubmit)=>({ url: url, title: title, displayText: displayText, rawUrl: rawUrl, meta: meta }, analytic)=>{
        onSubmit(url, title ?? rawUrl, displayText || undefined, meta.inputMethod === 'manual' ? (0, $g6Qq4.INPUT_METHOD).MANUAL : (0, $g6Qq4.INPUT_METHOD).TYPEAHEAD, analytic, meta.appearance);
    };
function $b284cac60a3045b1$export$8be6a38cd66ace65({ linkPickerOptions: { popupWidth: _popupWidth, popupHeight: _popupHeight, ...linkPickerOptions } = {}, onSubmit: onSubmit, displayText: displayText, displayUrl: displayUrl, providerFactory: providerFactory, view: view, onCancel: onCancel, invokeMethod: invokeMethod, lpLinkPicker: lpLinkPicker, onClose: onClose, onEscapeCallback: onEscapeCallback, onClickAwayCallback: onClickAwayCallback, editorAppearance: editorAppearance, inputMethod: inputMethod, searchSessionId: searchSessionId, timesViewed: timesViewed, isOffline: isOffline }) {
    const memoizedOnSubmitWithInterface = (0, $bSJIT.useMemo)(()=>$b284cac60a3045b1$var$onSubmitInterface(onSubmit), [
        onSubmit
    ]);
    const memoizedRenderNode = (0, $bSJIT.useCallback)(({ activityProvider: activityProvider, searchProvider: searchProvider })=>{
        // If we're offline fallback to HyperlinkAddToolbarComp as we may not have loaded
        // EditorLinkPicker into the bundle
        if (lpLinkPicker && !Boolean(isOffline)) return /*#__PURE__*/ (0, $dc70d.jsx)((0, $9cPwp.EditorLinkPicker), {
            view: view,
            invokeMethod: // Provide `invokeMethod` prop as preferred value (card plugin passes as prop) otherwise assume this
            // is being used from inside the hyperlink plugin and use inputMethod from plugin state
            invokeMethod ?? inputMethod,
            editorAppearance: editorAppearance,
            ...linkPickerOptions,
            url: displayUrl,
            displayText: displayText,
            onSubmit: memoizedOnSubmitWithInterface,
            onCancel: onCancel,
            onClose: onClose,
            onEscapeCallback: onEscapeCallback,
            onClickAwayCallback: onClickAwayCallback
        });
        return /*#__PURE__*/ (0, $dc70d.jsx)((0, $3iYde.default), {
            activityProvider: activityProvider,
            searchProvider: searchProvider,
            onSubmit: onSubmit,
            displayText: displayText,
            displayUrl: displayUrl,
            view: view,
            onEscapeCallback: onEscapeCallback,
            onClickAwayCallback: onClickAwayCallback,
            inputMethod: inputMethod,
            searchSessionId: searchSessionId,
            timesViewed: timesViewed
        });
    }, [
        lpLinkPicker,
        isOffline,
        view,
        invokeMethod,
        inputMethod,
        editorAppearance,
        linkPickerOptions,
        displayUrl,
        displayText,
        onSubmit,
        memoizedOnSubmitWithInterface,
        onCancel,
        onClose,
        onEscapeCallback,
        onClickAwayCallback,
        searchSessionId,
        timesViewed
    ]);
    const providers = (0, $3y2s4.isExperimentEnabled)('platform_editor_perf_lint_cleanup') ? $b284cac60a3045b1$var$HYPERLINK_PROVIDERS : // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- intentional fallback for experiment off path
    [
        'activityProvider',
        'searchProvider'
    ];
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $fRXfs.WithProviders), {
        providers: providers,
        providerFactory: providerFactory,
        renderNode: (0, $3y2s4.isExperimentEnabled)('platform_editor_perf_lint_cleanup') ? memoizedRenderNode : // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- intentional fallback for experiment off path
        ({ activityProvider: activityProvider, searchProvider: searchProvider })=>{
            // If we're offline fallback to HyperlinkAddToolbarComp as we may not have loaded
            // EditorLinkPicker into the bundle
            if (lpLinkPicker && !Boolean(isOffline)) return /*#__PURE__*/ (0, $dc70d.jsx)((0, $9cPwp.EditorLinkPicker), {
                view: view,
                invokeMethod: // Provide `invokeMethod` prop as preferred value (card plugin passes as prop) otherwise assume this
                // is being used from inside the hyperlink plugin and use inputMethod from plugin state
                invokeMethod ?? inputMethod,
                editorAppearance: editorAppearance,
                ...linkPickerOptions,
                url: displayUrl,
                displayText: displayText,
                onSubmit: $b284cac60a3045b1$var$onSubmitInterface(onSubmit),
                onCancel: onCancel,
                onClose: onClose,
                onEscapeCallback: onEscapeCallback,
                onClickAwayCallback: onClickAwayCallback
            });
            return /*#__PURE__*/ (0, $dc70d.jsx)((0, $3iYde.default), {
                activityProvider: activityProvider,
                searchProvider: searchProvider,
                onSubmit: onSubmit,
                displayText: displayText,
                displayUrl: displayUrl,
                view: view,
                onEscapeCallback: onEscapeCallback,
                onClickAwayCallback: onClickAwayCallback,
                inputMethod: inputMethod,
                searchSessionId: searchSessionId,
                timesViewed: timesViewed
            });
        }
    });
}

});
parcelRegister("9cPwp", function(module, exports) {
$parcel$export(module.exports, "EditorLinkPicker", () => $fe6b1425b40b1bbd$export$da2f76555f5c8d0a);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $kqAcG = parcelRequire("kqAcG");

var $dwOcU = parcelRequire("dwOcU");

var $8hi3G = parcelRequire("8hi3G");

var $3y2s4 = parcelRequire("3y2s4");

var $5N1Y4 = parcelRequire("5N1Y4");

var $lrWkt = parcelRequire("lrWkt");

var $3nTQK = parcelRequire("3nTQK");
const $fe6b1425b40b1bbd$var$PREVENT_SCROLL = {
    preventScroll: true
};
const $fe6b1425b40b1bbd$export$da2f76555f5c8d0a = ({ view: view, onCancel: onCancel, invokeMethod: invokeMethod = '_unknown', editorAppearance: editorAppearance, onClose: onClose, onEscapeCallback: onEscapeCallback, onClickAwayCallback: onClickAwayCallback, ...restProps })=>{
    /**
   * Track onClose handler in a
   * ref so that we void needing it in the dependency array
   * below
   */ const onCloseRef = (0, $bSJIT.useRef)(onClose);
    (0, $bSJIT.useEffect)(()=>{
        onCloseRef.current = onClose;
    });
    /**
   * Call onClose on mount, usefull to provide
   * a handler for performing an action after the component has been
   * unmounted (e.g. return focus to the editors)
   */ (0, $bSJIT.useEffect)(()=>()=>{
            var _onCloseRef$current;
            return (_onCloseRef$current = onCloseRef.current) === null || _onCloseRef$current === void 0 ? void 0 : _onCloseRef$current.call(onCloseRef);
        }, []);
    const onEscape = (0, $bSJIT.useCallback)(()=>{
        const { state: state, dispatch: dispatch } = view;
        onEscapeCallback === null || onEscapeCallback === void 0 || onEscapeCallback(state, dispatch);
        onCancel === null || onCancel === void 0 || onCancel();
    }, [
        view,
        onCancel,
        onEscapeCallback
    ]);
    const onClickAway = (0, $bSJIT.useCallback)(()=>{
        const { state: state, dispatch: dispatch } = view;
        onClickAwayCallback === null || onClickAwayCallback === void 0 || onClickAwayCallback(state, dispatch);
        onCancel === null || onCancel === void 0 || onCancel();
    }, [
        view,
        onCancel,
        onClickAwayCallback
    ]);
    const ref = (0, $3nTQK.useEscapeClickaway)(onEscape, onClickAway);
    const analyticsEditorAppearance = (0, $lrWkt.getAnalyticsEditorAppearance)(editorAppearance);
    const analyticsData = (0, $bSJIT.useMemo)(()=>({
            attributes: {
                invokeMethod: invokeMethod,
                location: analyticsEditorAppearance
            },
            // Below is added for the future implementation of Linking Platform namespaced analytic context
            location: analyticsEditorAppearance
        }), [
        invokeMethod,
        analyticsEditorAppearance
    ]);
    const returnFocus = (0, $3y2s4.isExperimentEnabled)('platform_editor_perf_lint_cleanup') ? $fe6b1425b40b1bbd$var$PREVENT_SCROLL : // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- intentional fallback for experiment off path
    {
        preventScroll: true
    };
    const focusOptions = (0, $3y2s4.isExperimentEnabled)('platform_editor_perf_lint_cleanup') ? $fe6b1425b40b1bbd$var$PREVENT_SCROLL : // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- intentional fallback for experiment off path
    {
        preventScroll: true
    };
    if ((0, $5N1Y4.expValEquals)('platform_editor_a11y_escape_link_dialog', 'isEnabled', true)) return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        ref: ref,
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $dwOcU.default), {
            data: analyticsData,
            children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $kqAcG.default), {
                returnFocus: returnFocus,
                focusOptions: focusOptions,
                children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $8hi3G.default), {
                    ...restProps,
                    onCancel: onEscape
                })
            })
        })
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        ref: ref,
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $dwOcU.default), {
            data: analyticsData,
            children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $8hi3G.default), {
                ...restProps,
                onCancel: onEscape
            })
        })
    });
};

});
parcelRegister("8hi3G", function(module, exports) {
$parcel$export(module.exports, "default", () => $286ce1d10647f1ec$export$2e2bcd8739ae039);

var $cJJTb = parcelRequire("cJJTb");

var $a5qVj = parcelRequire("a5qVj");

const $286ce1d10647f1ec$var$LazyLinkPickerComponent = (0, $cJJTb.lazyForPaint)(()=>(parcelRequire("78End")).then(({ LinkPicker: LinkPicker })=>({
            default: LinkPicker
        })), {
    moduleId: "../platform/packages/linking-platform/link-picker/src/ui/link-picker/index.tsx"
});
// Must be a default export to be able to support prop docs
// eslint-disable-next-line import/no-default-export
const $286ce1d10647f1ec$var$_default_1 = (0, $a5qVj.composeLinkPicker)($286ce1d10647f1ec$var$LazyLinkPickerComponent);
var $286ce1d10647f1ec$export$2e2bcd8739ae039 = $286ce1d10647f1ec$var$_default_1;

});
parcelRegister("a5qVj", function(module, exports) {
$parcel$export(module.exports, "composeLinkPicker", () => $445aa1c7c74ad15e$export$922eb685ceb4a294);
/* main.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $cJJTb = parcelRequire("cJJTb");

var $dwOcU = parcelRequire("dwOcU");

var $iZbtd = parcelRequire("iZbtd");

var $hRJrl = parcelRequire("hRJrl");

var $gkBZT = parcelRequire("gkBZT");

var $lPv5L = parcelRequire("lPv5L");

var $2VmqJ = parcelRequire("2VmqJ");
const $445aa1c7c74ad15e$export$800daf5fbbe96aff = {
    linkPickerRoot: 'link-picker-root'
};
const $445aa1c7c74ad15e$export$a2495bb1f182689d = {
    packageName: '',
    packageVersion: '',
    componentName: (0, $iZbtd.COMPONENT_NAME),
    source: (0, $iZbtd.COMPONENT_NAME)
};
const $445aa1c7c74ad15e$var$DefaultRootComponent = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        "data-testid": $445aa1c7c74ad15e$export$800daf5fbbe96aff.linkPickerRoot
    }, children);
};
const $445aa1c7c74ad15e$var$fixedWidthContainerStyles = null;
const $445aa1c7c74ad15e$var$FixedWidthContainer = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        role: "dialog",
        "aria-modal": "false",
        "aria-label": "link-picker",
        ...props,
        className: (0, $9fU1q.default)([
            "_1bsb1ubl"
        ])
    });
};
const $445aa1c7c74ad15e$export$922eb685ceb4a294 = (Component)=>{
    return /*#__PURE__*/ (0, $bSJIT.memo)((props)=>{
        const { component: component } = props;
        const RootComponent = component ?? $445aa1c7c74ad15e$var$DefaultRootComponent;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $dwOcU.default), {
            data: $445aa1c7c74ad15e$export$a2495bb1f182689d
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $hRJrl.LinkPickerSessionProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2VmqJ.MessagesProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
            style: {
                ['--link-picker-width']: props.disableWidth ? '100%' : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                `${0, $iZbtd.LINK_PICKER_WIDTH_IN_PX}px`,
                ['--link-picker-padding-left']: props.paddingLeft ?? "var(--ds-space-200, 16px)",
                ['--link-picker-padding-right']: props.paddingRight ?? "var(--ds-space-200, 16px)",
                ['--link-picker-padding-top']: props.paddingTop ?? "var(--ds-space-200, 16px)",
                ['--link-picker-padding-bottom']: props.paddingBottom ?? "var(--ds-space-200, 16px)"
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($445aa1c7c74ad15e$var$FixedWidthContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gkBZT.ErrorBoundary), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cJJTb.LazySuspense), {
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lPv5L.LoaderFallback), {
                url: props.url,
                hideDisplayText: props.hideDisplayText,
                isLoadingPlugins: props.isLoadingPlugins,
                plugins: props.plugins
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(RootComponent, {
            ...props,
            "data-testid": $445aa1c7c74ad15e$export$800daf5fbbe96aff.linkPickerRoot
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(Component, props)))))))));
    });
};

});
parcelRegister("iZbtd", function(module, exports) {
$parcel$export(module.exports, "ANALYTICS_CHANNEL", () => $874851f5bded9620$export$85183a312807388d);
$parcel$export(module.exports, "COMPONENT_NAME", () => $874851f5bded9620$export$fc44104665f4d1e5);
$parcel$export(module.exports, "RECENT_SEARCH_LIST_SIZE", () => $874851f5bded9620$export$452f1062ecf44be7);
$parcel$export(module.exports, "LINK_PICKER_WIDTH_IN_PX", () => $874851f5bded9620$export$bf31a09f182d5584);
$parcel$export(module.exports, "LINK_PICKER_MIN_HEIGHT_IN_PX_FALLBACK", () => $874851f5bded9620$export$542fb16962bf430c);
const $874851f5bded9620$export$85183a312807388d = 'media';
const $874851f5bded9620$export$fc44104665f4d1e5 = 'linkPicker';
const $874851f5bded9620$export$452f1062ecf44be7 = 5;
const $874851f5bded9620$export$bf31a09f182d5584 = 342;
const $874851f5bded9620$export$542fb16962bf430c = '290px';

});

parcelRegister("hRJrl", function(module, exports) {
$parcel$export(module.exports, "LinkPickerSessionProvider", () => $5e7bdb47a104f04e$export$2f19832fd2d620ca);
$parcel$export(module.exports, "useLinkPickerSessionId", () => $5e7bdb47a104f04e$export$36ecc935abdc3636);

var $bSJIT = parcelRequire("bSJIT");

var $7RHfd = parcelRequire("7RHfd");

var $ktp0q = parcelRequire("ktp0q");
const $5e7bdb47a104f04e$export$c07727f5eddb98f = 'SESSION_UNINITIALIZED';
const $5e7bdb47a104f04e$export$3285420c698bc605 = /*#__PURE__*/ (0, $bSJIT.createContext)($5e7bdb47a104f04e$export$c07727f5eddb98f);
const $5e7bdb47a104f04e$export$2f19832fd2d620ca = ({ children: children })=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const { current: sessionId } = (0, $bSJIT.useRef)((0, $7RHfd.default)());
    (0, $bSJIT.useEffect)(()=>{
        (0, $ktp0q.startUfoExperience)((0, $ktp0q.ufoExperience).mounted, sessionId);
        return ()=>(0, $ktp0q.abortUfoExperience)((0, $ktp0q.ufoExperience).mounted, sessionId);
    }, [
        sessionId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($5e7bdb47a104f04e$export$3285420c698bc605.Provider, {
        value: sessionId
    }, children);
};
const $5e7bdb47a104f04e$export$36ecc935abdc3636 = ()=>(0, $bSJIT.useContext)($5e7bdb47a104f04e$export$3285420c698bc605);

});
parcelRegister("ktp0q", function(module, exports) {
$parcel$export(module.exports, "ufoExperience", () => $539ed4dd5267f0de$export$f9c7780c574346a2);
$parcel$export(module.exports, "startUfoExperience", () => $539ed4dd5267f0de$export$5e9287b6a10f8075);
$parcel$export(module.exports, "succeedUfoExperience", () => $539ed4dd5267f0de$export$c5a5cf072c836c0e);
$parcel$export(module.exports, "failUfoExperience", () => $539ed4dd5267f0de$export$8dda83bafca11b77);
$parcel$export(module.exports, "abortUfoExperience", () => $539ed4dd5267f0de$export$b1021040eb94cdca);

var $5bALc = parcelRequire("5bALc");

var $mx1V1 = parcelRequire("mx1V1");
const $539ed4dd5267f0de$export$f9c7780c574346a2 = {
    mounted: 'component-mounted'
};
const $539ed4dd5267f0de$var$ufoExperiences = {
    [$539ed4dd5267f0de$export$f9c7780c574346a2.mounted]: new (0, $5bALc.ConcurrentExperience)($539ed4dd5267f0de$export$f9c7780c574346a2.mounted, {
        type: (0, $mx1V1.ExperienceTypes).Load,
        performanceType: (0, $mx1V1.ExperiencePerformanceTypes).PageSegmentLoad,
        platform: {
            component: 'link-picker'
        }
    })
};
const $539ed4dd5267f0de$export$5e9287b6a10f8075 = (experienceName, id, metadata)=>{
    const experience = $539ed4dd5267f0de$var$ufoExperiences[experienceName].getInstance(id);
    experience.start();
    if (metadata) experience.addMetadata(metadata);
};
const $539ed4dd5267f0de$export$c5a5cf072c836c0e = (experienceName, id, metadata)=>{
    const experience = $539ed4dd5267f0de$var$ufoExperiences[experienceName].getInstance(id);
    experience.success({
        metadata: metadata
    });
};
const $539ed4dd5267f0de$export$8dda83bafca11b77 = (experienceName, id, metadata)=>{
    const experience = $539ed4dd5267f0de$var$ufoExperiences[experienceName].getInstance(id);
    experience.failure({
        metadata: metadata
    });
};
const $539ed4dd5267f0de$export$b1021040eb94cdca = (experienceName, id, metadata)=>{
    const experience = $539ed4dd5267f0de$var$ufoExperiences[experienceName].getInstance(id);
    experience.abort({
        metadata: metadata
    });
};

});


parcelRegister("gkBZT", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundary", () => $86bd4ba36f3556da$export$e926676385687eaf);

var $bSJIT = parcelRequire("bSJIT");

var $6WltM = parcelRequire("6WltM");

var $ktp0q = parcelRequire("ktp0q");

var $iZbtd = parcelRequire("iZbtd");

var $9VCFZ = parcelRequire("9VCFZ");

var $hRJrl = parcelRequire("hRJrl");

var $aE8w5 = parcelRequire("aE8w5");

var $6cNNg = parcelRequire("6cNNg");
function $86bd4ba36f3556da$export$e926676385687eaf({ children: children }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const linkPickerSessionId = (0, $hRJrl.useLinkPickerSessionId)();
    const handleError = (0, $bSJIT.useCallback)((error, info)=>{
        var _window;
        // Fire Analytics event
        createAnalyticsEvent((0, $9VCFZ.default)('ui.linkPicker.unhandledErrorCaught', {
            browserInfo: ((_window = window) === null || _window === void 0 || (_window = _window.navigator) === null || _window === void 0 ? void 0 : _window.userAgent) || 'unknown',
            error: error.toString(),
            componentStack: (info === null || info === void 0 ? void 0 : info.componentStack) ?? ''
        })).fire((0, $iZbtd.ANALYTICS_CHANNEL));
        // Fire UFO failed experience
        (0, $ktp0q.failUfoExperience)((0, $ktp0q.ufoExperience).mounted, linkPickerSessionId);
    }, [
        createAnalyticsEvent,
        linkPickerSessionId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $aE8w5.BaseErrorBoundary), {
        onError: handleError,
        ErrorComponent: (0, $6cNNg.ErrorBoundaryFallback)
    }, children);
}

});
parcelRegister("9VCFZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $0fd393ac45f711c1$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::8ad800c149f887c26cf6e1c701c20ed0>>
 * @codegenCommand afm workspace @atlaskit/link-picker codegen-analytics
 */ function $0fd393ac45f711c1$var$createEventPayload(eventKey, attributes) {
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        action: action,
        attributes: attributes
    };
}
var $0fd393ac45f711c1$export$2e2bcd8739ae039 = $0fd393ac45f711c1$var$createEventPayload;

});

parcelRegister("aE8w5", function(module, exports) {
$parcel$export(module.exports, "BaseErrorBoundary", () => $934dbfe50c079690$export$688779ac61ee945f);

var $bSJIT = parcelRequire("bSJIT");
class $934dbfe50c079690$export$688779ac61ee945f extends (0, $bSJIT.Component) {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    componentDidCatch(error, info) {
        const { onError: onError } = this.props;
        onError && onError(error, info);
        this.setState({
            hasError: true
        });
    }
    render() {
        const { children: children, ErrorComponent: ErrorComponent } = this.props;
        const { hasError: hasError } = this.state;
        if (hasError && ErrorComponent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(ErrorComponent, null);
        return children;
    }
}

});

parcelRegister("6cNNg", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundaryFallback", () => $a6c08ad6478f64b9$export$8a28b7e38e4685dd);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $f0Pt4 = parcelRequire("f0Pt4");
var $4vLTk = parcelRequire("4vLTk");

var $iZbtd = parcelRequire("iZbtd");

var $dNLOD = parcelRequire("dNLOD");

var $f4SD9 = parcelRequire("f4SD9");

var $lvzhv = parcelRequire("lvzhv");
const $a6c08ad6478f64b9$var$errorBoundaryFallbackStyles = null;
const $a6c08ad6478f64b9$var$messages = (0, $f0Pt4.defineMessages)({
    heading: {
        defaultMessage: 'Something went wrong!',
        description: 'Heading displayed when an unhandled error occurs.',
        id: 'fabric.linkPicker.unhandledError.heading'
    },
    description: {
        defaultMessage: 'Try reloading the page.',
        description: 'Body message shown underneath the heading when an unhandled error occurs.',
        id: 'fabric.linkPicker.unhandledError.description'
    }
});
const $a6c08ad6478f64b9$export$8a28b7e38e4685dd = ()=>{
    const intl = (0, $4vLTk.default)();
    const header = intl.formatMessage($a6c08ad6478f64b9$var$messages.heading);
    const description = intl.formatMessage($a6c08ad6478f64b9$var$messages.description);
    return /*#__PURE__*/ $bSJIT.createElement((0, $lvzhv.MinHeightContainer), {
        minHeight: (0, $iZbtd.LINK_PICKER_MIN_HEIGHT_IN_PX_FALLBACK),
        "data-testid": "link-picker-root-error-boundary-ui",
        className: (0, $9fU1q.default)([
            "_11c8i4vh"
        ])
    }, /*#__PURE__*/ $bSJIT.createElement((0, $f4SD9.EmptyState), {
        header: header,
        renderImage: ()=>/*#__PURE__*/ $bSJIT.createElement((0, $dNLOD.GenericErrorSVG), null),
        description: description
    }));
};

});
parcelRegister("dNLOD", function(module, exports) {
$parcel$export(module.exports, "GenericErrorSVG", () => $1fcd810b879691dc$export$e54420a1a27457a4);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");
const $1fcd810b879691dc$var$SIZE = 96;
const $1fcd810b879691dc$var$genericErrorStyles = null;
const $1fcd810b879691dc$export$e54420a1a27457a4 = (props)=>{
    return /*#__PURE__*/ $bSJIT.createElement("svg", {
        viewBox: "0 0 96 96",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        className: (0, $9fU1q.default)([
            "_1bsb16xz _4t3i16xz _1e0c1ule"
        ])
    }, /*#__PURE__*/ $bSJIT.createElement("path", {
        fill: "#fff",
        d: "M64.861 32.06a27.753 27.753 0 0 0-2.667-4.133 28.187 28.187 0 0 0-3.376-3.669c-6.985-6.311-15.57-6.89-23.609-2.53a30.226 30.226 0 0 0-4.056 2.656 30.624 30.624 0 0 0-3.735 3.4c-6.225 6.717-7.82 15.154-3.505 23.462a28.108 28.108 0 0 0 2.698 4.193 27.67 27.67 0 0 0 3.33 3.62c6.94 6.266 15.518 6.85 23.596 2.507a30.492 30.492 0 0 0 4.23-2.758 30.07 30.07 0 0 0 3.593-3.257c6.252-6.692 7.847-15.161 3.494-23.49h.007Z"
    }), /*#__PURE__*/ $bSJIT.createElement("path", {
        fill: "#DDDEE1",
        d: "M43.092 66.774c-5.306 0-10.382-1.997-14.75-5.938a30.405 30.405 0 0 1-3.62-3.93 30.243 30.243 0 0 1-2.928-4.553c-4.657-8.961-3.247-18.509 3.871-26.192a33.271 33.271 0 0 1 4.025-3.67 32.834 32.834 0 0 1 4.378-2.869c9.209-4.995 18.816-3.951 26.353 2.86a30.945 30.945 0 0 1 3.665 3.98 30.303 30.303 0 0 1 2.898 4.488c4.705 9.003 3.295 18.565-3.868 26.231a32.148 32.148 0 0 1-3.879 3.515 33.415 33.415 0 0 1-4.562 2.975c-3.858 2.073-7.782 3.1-11.583 3.1v.003Zm2.53-45.486c-3.019 0-6.147.84-9.275 2.54a28.433 28.433 0 0 0-3.735 2.448 28.059 28.059 0 0 0-3.442 3.135c-5.746 6.203-6.86 13.566-3.135 20.736a25.395 25.395 0 0 0 2.472 3.83 25.304 25.304 0 0 0 3.044 3.309c5.99 5.41 13.398 6.182 20.862 2.175a28.02 28.02 0 0 0 3.899-2.545 28.03 28.03 0 0 0 3.31-2.999c5.777-6.182 6.883-13.552 3.124-20.75a25.553 25.553 0 0 0-2.44-3.777 25.848 25.848 0 0 0-3.087-3.358c-3.49-3.153-7.442-4.744-11.59-4.744h-.006Z"
    }), /*#__PURE__*/ $bSJIT.createElement("path", {
        fill: "#DDDEE1",
        d: "M62.822 59.694c-1.235-1.72-2.562-1.71-3.857-.708-1.215.939-1.54 2.21-.244 3.882l1.48 1.913 4.102-3.174-1.48-1.913Z"
    }), /*#__PURE__*/ $bSJIT.createElement("path", {
        fill: "#DDDEE1",
        d: "m65.334 60.811-6.159 4.762L70.748 80.54l6.16-4.761L65.333 60.81Z"
    }), /*#__PURE__*/ $bSJIT.createElement("path", {
        fill: "#B7B9BE",
        d: "m64.344 61.577-4.178 3.23 3.925 5.076 4.178-3.23-3.925-5.076Z"
    }), /*#__PURE__*/ $bSJIT.createElement("path", {
        fill: "#DDDEE1",
        fillRule: "evenodd",
        d: "M55.057 33.452 36.213 52.296l-2.468-2.469 18.844-18.844 2.468 2.469Z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ $bSJIT.createElement("path", {
        fill: "#DDDEE1",
        fillRule: "evenodd",
        d: "M52.589 52.296 33.745 33.452l2.468-2.469 18.844 18.844-2.468 2.469Z",
        clipRule: "evenodd"
    }));
};

});

parcelRegister("f4SD9", function(module, exports) {
$parcel$export(module.exports, "EmptyState", () => $5ced0d8c7ac42e38$export$fddf379e22a74b00);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ /* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $jDsoo = parcelRequire("jDsoo");

var $7WQx2 = parcelRequire("7WQx2");

var $6X9z7 = parcelRequire("6X9z7");

var $8aT4G = parcelRequire("8aT4G");
const $5ced0d8c7ac42e38$var$styles = {
    containerV2: "_ca0q1ejb _u5f3oahv _19bvoahv _n3td1jfw _y3gn1h6o",
    whiteSpaceNormal: "_o5724jg8"
};
const $5ced0d8c7ac42e38$export$fddf379e22a74b00 = ({ testId: testId, header: header, description: description, action: action, renderImage: renderImage })=>{
    return /*#__PURE__*/ $bSJIT.createElement((0, $6X9z7.Flex), {
        xcss: (0, $jDsoo.cx)($5ced0d8c7ac42e38$var$styles.containerV2, $5ced0d8c7ac42e38$var$styles.whiteSpaceNormal),
        testId: testId,
        direction: "column",
        alignItems: "center",
        gap: "space.200"
    }, renderImage === null || renderImage === void 0 ? void 0 : renderImage(), /*#__PURE__*/ $bSJIT.createElement((0, $7WQx2.default), {
        size: "small",
        as: "h2"
    }, header), description && /*#__PURE__*/ $bSJIT.createElement((0, $8aT4G.Text), {
        as: "p",
        color: "color.text"
    }, description), action && action);
};

});

parcelRegister("lvzhv", function(module, exports) {
$parcel$export(module.exports, "MinHeightContainer", () => $36d1836be6113bc7$export$42134e2a251518b3);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");
const $36d1836be6113bc7$var$minHeightComponentStyles = null;
const $36d1836be6113bc7$export$42134e2a251518b3 = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ className: className, minHeight: minHeight, ...props }, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $9fU1q.default)([
            "_1e0c1txw _4cvr1fhb _1bah1h6o _1tke16li",
            className
        ]),
        ...props,
        style: {
            ['--link-picker-min-height']: minHeight
        }
    });
});

});



parcelRegister("lPv5L", function(module, exports) {
$parcel$export(module.exports, "LoaderFallback", () => $ce03b31ead22de9b$export$d96e921133238c41);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $hDkm2 = parcelRequire("hDkm2");

var $lvzhv = parcelRequire("lvzhv");
const $ce03b31ead22de9b$var$styles = null;
const $ce03b31ead22de9b$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITHOUT_DISPLAYTEXT = '495px';
const $ce03b31ead22de9b$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITH_DISPLAYTEXT = '590px';
const $ce03b31ead22de9b$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITH_DISPLAYTEXT = '545px';
const $ce03b31ead22de9b$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITHOUT_DISPLAYTEXT = '450px';
const $ce03b31ead22de9b$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_DISPLAYTEXT = '252px';
const $ce03b31ead22de9b$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITHOUT_DISPLAYTEXT = '155px';
const $ce03b31ead22de9b$var$getEstimatedMinHeight = ({ hideDisplayText: hideDisplayText, isLoadingPlugins: isLoadingPlugins, plugins: plugins, url: url })=>{
    /**
   * "Insert mode" (search results shown initially)
   */ if (!url) {
        /**
     * With tabs
     */ if (plugins && plugins.length > 1 || isLoadingPlugins) return hideDisplayText ? $ce03b31ead22de9b$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITHOUT_DISPLAYTEXT : $ce03b31ead22de9b$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITH_TABS_WITH_DISPLAYTEXT;
        /**
     * Without tabs
     */ if ((plugins === null || plugins === void 0 ? void 0 : plugins.length) === 1) return hideDisplayText ? $ce03b31ead22de9b$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITHOUT_DISPLAYTEXT : $ce03b31ead22de9b$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_PLUGIN_WITH_DISPLAYTEXT;
    }
    return hideDisplayText ? $ce03b31ead22de9b$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITHOUT_DISPLAYTEXT : $ce03b31ead22de9b$var$LINK_PICKER_MIN_HEIGHT_IN_PX_WITHOUT_TABS_WITH_DISPLAYTEXT;
};
const $ce03b31ead22de9b$export$d96e921133238c41 = (props)=>{
    const minHeight = $ce03b31ead22de9b$var$getEstimatedMinHeight(props);
    return /*#__PURE__*/ $bSJIT.createElement((0, $lvzhv.MinHeightContainer), {
        minHeight: minHeight,
        "data-testid": "link-picker-root-loader-boundary-ui",
        className: (0, $9fU1q.default)([
            "_4cvr1h6o"
        ])
    }, /*#__PURE__*/ $bSJIT.createElement((0, $hDkm2.default), {
        testId: "link-picker.component-loading-indicator",
        interactionName: props.name || 'link-picker-loading',
        size: "medium"
    }));
};

});

parcelRegister("2VmqJ", function(module, exports) {
$parcel$export(module.exports, "MessagesProvider", () => $0ccc9ee8d9e15e9c$export$54320b51a950d54a);

var $bSJIT = parcelRequire("bSJIT");

var $cyhvX = parcelRequire("cyhvX");
const $0ccc9ee8d9e15e9c$export$54320b51a950d54a = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $cyhvX.LazyMessagesProvider), null, children);
};

});
parcelRegister("cyhvX", function(module, exports) {
$parcel$export(module.exports, "LazyMessagesProvider", () => $75fa3f8b434bacbd$export$d013d33430f9fb4b);

var $bSJIT = parcelRequire("bSJIT");

var $igKbN = parcelRequire("igKbN");

var $89wjR = parcelRequire("89wjR");

var $8zX7s = parcelRequire("8zX7s");
const $75fa3f8b434bacbd$export$d013d33430f9fb4b = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $igKbN.default), {
        defaultMessages: (0, $89wjR.default),
        loaderFn: (0, $8zX7s.fetchMessagesForLocale)
    }, children);
};

});
parcelRegister("89wjR", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $058c11d29d47685b$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $lW8TW = parcelRequire("lW8TW");
var $058c11d29d47685b$export$2e2bcd8739ae039 = (0, $lW8TW.default);

});
parcelRegister("lW8TW", function(module, exports) {
$parcel$export(module.exports, "default", () => $8e5bb5553144a1d5$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
* NOTE: 
*
* This file is automatically generated by Traduki 2.0. 
* DO NOT CHANGE IT BY HAND or your changes will be lost. 
*/ //
var $8e5bb5553144a1d5$export$2e2bcd8739ae039 = {
    "fabric.linkPicker.button.cancel": "Cancel",
    "fabric.linkPicker.button.insert": "Insert",
    "fabric.linkPicker.button.save": "Save",
    "fabric.linkPicker.clearLink": "Clear",
    "fabric.linkPicker.clearLinkText": "Clear text",
    "fabric.linkPicker.hyperlink.searchLinkResults": "{count, plural, =0 {no results} one {# result} other {# results}} found",
    "fabric.linkPicker.linkAriaLabel": "Type or paste a link into the field",
    "fabric.linkPicker.linkHelperTextAriaLabel": "Link display helper text",
    "fabric.linkPicker.linkHelperTextLabel": "Give this link a title or description",
    "fabric.linkPicker.linkInvalid": "Enter a valid URL.",
    "fabric.linkPicker.linkLabel": "Link",
    "fabric.linkPicker.linkPlaceholder": "Paste a link",
    "fabric.linkPicker.linkTextAriaLabel": "Link display text",
    "fabric.linkPicker.linkTextLabel": "Display text (optional)",
    "fabric.linkPicker.linkTextPlaceholder": "Text to display",
    "fabric.linkPicker.listTitle.recentlyViewedFormatted": "Recently viewed",
    "fabric.linkPicker.listTitle.results": "Results",
    "fabric.linkPicker.noEmbed": "Embed view isn't supported for this link. <a>More about why some Smart Links don't display content.</a>",
    "fabric.linkPicker.search.error.description": "Refresh the page, or contact <a>Atlassian Support</a> if this keeps happening.",
    "fabric.linkPicker.search.error.heading": "We\u2019re having trouble loading data.",
    "fabric.linkPicker.search.error.retry": "Refresh",
    "fabric.linkPicker.search.linkAriaLabel": "Suggestions will appear below as you type into the field",
    "fabric.linkPicker.search.linkLabel": "Search or paste a link",
    "fabric.linkPicker.search.linkPlaceholder": "Find recent links or paste a new link",
    "fabric.linkPicker.search.noResults.description": "Try again with a different term.",
    "fabric.linkPicker.search.noResults.heading": "We couldn\u2019t find anything matching your search.",
    "fabric.linkPicker.status.submitting": "Submitting",
    "fabric.linkPicker.time.message.updated": "Updated {time}",
    "fabric.linkPicker.time.message.viewed": "Viewed {time}",
    "fabric.linkPicker.unhandledError.description": "Try reloading the page.",
    "fabric.linkPicker.unhandledError.heading": "Something went wrong!",
    "foo": "Default string"
};

});


parcelRegister("8zX7s", function(module, exports) {
$parcel$export(module.exports, "fetchMessagesForLocale", () => $01e14fca953617ac$export$2b153a2030b0feb2);

var $7J5Id = parcelRequire("7J5Id");
const $01e14fca953617ac$export$2b153a2030b0feb2 = async (locale)=>{
    try {
        const localeKey = locale.replace('-', '_');
        if (localeKey in (0, $7J5Id.locales)) {
            const messages = await (0, $7J5Id.locales)[localeKey]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
    try {
        const parentLocale = locale.split(/[-_]/)[0];
        if (parentLocale in (0, $7J5Id.locales)) {
            const messages = await (0, $7J5Id.locales)[parentLocale]();
            return messages.default;
        }
    } catch (e) {
    // ignore
    }
};

});
parcelRegister("7J5Id", function(module, exports) {
$parcel$export(module.exports, "locales", () => $32b275fa2911b4df$export$df1c34db1371eeed);

























const $32b275fa2911b4df$export$df1c34db1371eeed = {
    cs: ()=>(parcelRequire("hagcX")),
    da: ()=>(parcelRequire("gbv3a")),
    de: ()=>(parcelRequire("a6WBs")),
    en_GB: ()=>(parcelRequire("i2u25")),
    en_ZZ: ()=>(parcelRequire("geevH")),
    en: ()=>Promise.resolve((parcelRequire("89wjR"))),
    es: ()=>(parcelRequire("4AvMi")),
    fi: ()=>(parcelRequire("1OXKz")),
    fr: ()=>(parcelRequire("56Dan")),
    hu: ()=>(parcelRequire("o4vJ4")),
    it: ()=>(parcelRequire("kgwRa")),
    ja: ()=>(parcelRequire("i6qdM")),
    ko: ()=>(parcelRequire("5lHX4")),
    nb: ()=>(parcelRequire("aKOim")),
    nl: ()=>(parcelRequire("lk433")),
    pl: ()=>(parcelRequire("3psVD")),
    pt_BR: ()=>(parcelRequire("peQEl")),
    ru: ()=>(parcelRequire("6Frk7")),
    sv: ()=>(parcelRequire("hVkhG")),
    th: ()=>(parcelRequire("gsiGh")),
    tr: ()=>(parcelRequire("9t29V")),
    uk: ()=>(parcelRequire("lpwFA")),
    vi: ()=>(parcelRequire("4Uk4J")),
    zh_TW: ()=>(parcelRequire("7bczp")),
    zh: ()=>(parcelRequire("lplUM"))
};

});
parcelRegister("hagcX", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("fGPtd").then(()=>parcelRequire('5MomH'));

});

parcelRegister("gbv3a", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("ciiYb").then(()=>parcelRequire('fYUKt'));

});

parcelRegister("a6WBs", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("kbKei").then(()=>parcelRequire('frcqj'));

});

parcelRegister("i2u25", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("6efBc").then(()=>parcelRequire('fliHE'));

});

parcelRegister("geevH", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("7Y2fU").then(()=>parcelRequire('8zuw0'));

});

parcelRegister("4AvMi", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("5849l").then(()=>parcelRequire('4gYQX'));

});

parcelRegister("1OXKz", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("7QGFR").then(()=>parcelRequire('fEWDk'));

});

parcelRegister("56Dan", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("9nQbS").then(()=>parcelRequire('6wA32'));

});

parcelRegister("o4vJ4", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("jF2uM").then(()=>parcelRequire('57JwT'));

});

parcelRegister("kgwRa", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("7z160").then(()=>parcelRequire('lvyFx'));

});

parcelRegister("i6qdM", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("a6xQ1").then(()=>parcelRequire('6gr6z'));

});

parcelRegister("5lHX4", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("bo6Oq").then(()=>parcelRequire('dIRA5'));

});

parcelRegister("aKOim", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("14gg5").then(()=>parcelRequire('aDqRK'));

});

parcelRegister("lk433", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("4sJc3").then(()=>parcelRequire('46PX2'));

});

parcelRegister("3psVD", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("fqKVQ").then(()=>parcelRequire('cC9u4'));

});

parcelRegister("peQEl", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("PFcra").then(()=>parcelRequire('jkpZG'));

});

parcelRegister("6Frk7", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("ccMRA").then(()=>parcelRequire('sBGJT'));

});

parcelRegister("hVkhG", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("9waBk").then(()=>parcelRequire('auBLU'));

});

parcelRegister("gsiGh", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("2ZNML").then(()=>parcelRequire('2IJWY'));

});

parcelRegister("9t29V", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("9MT7Y").then(()=>parcelRequire('hn0A2'));

});

parcelRegister("lpwFA", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("kAky8").then(()=>parcelRequire('1F0e5'));

});

parcelRegister("4Uk4J", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("4SaGv").then(()=>parcelRequire('lhFG8'));

});

parcelRegister("7bczp", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("aRnE3").then(()=>parcelRequire('7Lxe4'));

});

parcelRegister("lplUM", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("egvF4").then(()=>parcelRequire('8t9Jz'));

});






parcelRegister("78End", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("36aBu"),
    $kOunM("hxBTu")
]).then(()=>parcelRequire('4MxuW'));

});


parcelRegister("3nTQK", function(module, exports) {
$parcel$export(module.exports, "useEscapeClickaway", () => $e09c38ab91c0b3a7$export$886f2fdec3f419af);

var $bSJIT = parcelRequire("bSJIT");
const $e09c38ab91c0b3a7$export$886f2fdec3f419af = (onEscape, onClickAway)=>{
    const ref = (0, $bSJIT.useRef)(null);
    (0, $bSJIT.useEffect)(()=>{
        const handleClickAway = (event)=>{
            const el = ref.current;
            if (event.target instanceof Element && el && !el.contains(event.target)) onClickAway();
        };
        const handleKeydown = (event)=>{
            if (event.key === 'Escape') {
                event.preventDefault();
                onEscape();
            }
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.addEventListener('mousedown', handleClickAway);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.addEventListener('keydown', handleKeydown);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('mousedown', handleClickAway);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('keydown', handleKeydown);
        };
    }, [
        onClickAway,
        onEscape
    ]);
    return ref;
};

});


parcelRegister("3iYde", function(module, exports) {
$parcel$export(module.exports, "default", () => $fa2bf5746f941f2d$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $4Sf72 = parcelRequire("4Sf72");

var $9dQre = parcelRequire("9dQre");

var $inh7J = parcelRequire("inh7J");

var $kqAcG = parcelRequire("kqAcG");

var $fK3tS = parcelRequire("fK3tS");

var $7nI18 = parcelRequire("7nI18");

var $kIbto = parcelRequire("kIbto");

var $cBVmT = parcelRequire("cBVmT");

var $iPH47 = parcelRequire("iPH47");

var $aHbh3 = parcelRequire("aHbh3");

var $9BVpB = parcelRequire("9BVpB");

var $5N1Y4 = parcelRequire("5N1Y4");

var $lavtv = parcelRequire("lavtv");

var $g6Qq4 = parcelRequire("g6Qq4");
var $bTWXs = parcelRequire("bTWXs");

var $4ambm = parcelRequire("4ambm");
var $kGWDu = parcelRequire("kGWDu");

var $98KMe = parcelRequire("98KMe");

var $jxkn6 = parcelRequire("jxkn6");

var $cjXwI = parcelRequire("cjXwI");

var $fIEl2 = parcelRequire("fIEl2");

var $3vuKa = parcelRequire("3vuKa");

var $ffAKP = parcelRequire("ffAKP");

var $9Dkwx = parcelRequire("9Dkwx");

var $iTcdH = parcelRequire("iTcdH");

var $45VR5 = parcelRequire("45VR5");

var $aqIaQ = parcelRequire("aqIaQ");
function $fa2bf5746f941f2d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $fa2bf5746f941f2d$export$8dd524ceb40e3d16 = {
    name: "19nbz8q",
    styles: "clip:rect(1px, 1px, 1px, 1px);clip-path:inset(50%);height:1px;width:1px;margin:var(--ds-space-negative-025, -2px);overflow:hidden;padding:0;position:absolute"
};
const $fa2bf5746f941f2d$export$452f1062ecf44be7 = 5;
const $fa2bf5746f941f2d$var$clearTextButtonStyles = (0, $9BVpB.xcss)({
    padding: 'space.0',
    marginRight: 'space.100',
    backgroundColor: 'color.background.neutral.subtle',
    border: 'none'
});
const $fa2bf5746f941f2d$var$clearTextWrapper = {
    name: "154v9b4",
    styles: "position:absolute;right:0"
};
const $fa2bf5746f941f2d$var$containerPadding = /*#__PURE__*/ (0, $9dQre.css)({
    padding: `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-100, 8px)"}`
});
const $fa2bf5746f941f2d$var$textLabelMargin = {
    name: "1s21os8",
    styles: "margin-top:var(--ds-space-150, 12px)"
};
const $fa2bf5746f941f2d$var$inputLabel = {
    name: "oad2n7",
    styles: "color:var(--ds-text-subtlest, #6B6E76);padding-bottom:var(--ds-space-050, 4px);font:var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);font-weight:var(--ds-font-weight-medium, 500)"
};
const $fa2bf5746f941f2d$var$inputWrapperPosition = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $fa2bf5746f941f2d$var$defaultIcon = /*#__PURE__*/ (0, $9dQre.jsx)((0, $iPH47.default), {
    label: "page"
});
const $fa2bf5746f941f2d$var$mapActivityProviderResultToLinkSearchItemData = ({ name: name, container: container, iconUrl: iconUrl, objectId: objectId, url: url, viewedTimestamp: viewedTimestamp })=>({
        objectId: objectId,
        name: name,
        container: container,
        iconUrl: iconUrl,
        url: url,
        lastViewedDate: viewedTimestamp ? new Date(viewedTimestamp) : undefined,
        prefetch: true
    });
const $fa2bf5746f941f2d$var$mapSearchProviderResultToLinkSearchItemData = ({ objectId: objectId, container: container, title: title, contentType: contentType, url: url, updatedTimestamp: updatedTimestamp })=>({
        objectId: objectId,
        container: container,
        name: title,
        url: url,
        lastUpdatedDate: updatedTimestamp ? new Date(updatedTimestamp) : undefined,
        icon: contentType && (0, $45VR5.mapContentTypeToIcon)[contentType] || $fa2bf5746f941f2d$var$defaultIcon,
        prefetch: false
    });
class $fa2bf5746f941f2d$export$7acbf008e0847b89 extends (0, $bSJIT.PureComponent) {
    constructor(props){
        super(props), /* To prevent double submit */ this.submitted = false, this.urlInputContainer = null, this.displayTextInputContainer = null, this.wrapperRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createRef(), this.listItemRefs = {
            current: {}
        }, this.quickSearchQueryVersion = 0, this.analyticSource = 'createLinkInlineDialog', this.quickSearch = async (input, items, quickSearchLimit)=>{
            const { searchProvider: searchProvider, displayUrl: displayUrl } = this.state;
            const { searchSessionId: searchSessionId } = this.props;
            if (!searchProvider) return;
            const queryVersion = ++this.quickSearchQueryVersion;
            this.fireAnalytics({
                action: (0, $g6Qq4.ACTION).ENTERED,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).TEXT,
                actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).LINK_SEARCH_INPUT,
                attributes: {
                    queryLength: input.length,
                    queryVersion: queryVersion,
                    queryHash: (0, $iTcdH.sha1)(input),
                    searchSessionId: searchSessionId ?? '',
                    wordCount: (0, $aqIaQ.wordCount)(input),
                    source: this.analyticSource
                },
                nonPrivacySafeAttributes: {
                    query: input
                },
                eventType: (0, $g6Qq4.EVENT_TYPE).UI
            });
            const perfStart = performance.now();
            try {
                const searchProviderResultItems = await searchProvider.quickSearch(input, quickSearchLimit);
                const searchItems = $fa2bf5746f941f2d$var$limit((0, $ffAKP.filterUniqueItems)([
                    ...items,
                    ...searchProviderResultItems.map($fa2bf5746f941f2d$var$mapSearchProviderResultToLinkSearchItemData)
                ], (firstItem, secondItem)=>firstItem.objectId === secondItem.objectId));
                if (displayUrl === input && queryVersion === this.quickSearchQueryVersion) this.setState({
                    items: searchItems,
                    isLoading: false
                });
                const perfStop = performance.now();
                const duration = perfStop - perfStart;
                this.fireAnalytics({
                    action: (0, $g6Qq4.ACTION).INVOKED,
                    actionSubject: (0, $g6Qq4.ACTION_SUBJECT).SEARCH_RESULT,
                    actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).QUICK_SEARCH,
                    attributes: {
                        duration: duration,
                        count: searchProviderResultItems.length
                    },
                    eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL
                });
                this.fireAnalytics({
                    action: (0, $g6Qq4.ACTION).SHOWN,
                    actionSubject: (0, $g6Qq4.ACTION_SUBJECT).SEARCH_RESULT,
                    actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).POST_QUERY_SEARCH_RESULTS,
                    attributes: {
                        source: this.analyticSource,
                        postQueryRequestDurationMs: duration,
                        searchSessionId: searchSessionId ?? '',
                        resultCount: searchProviderResultItems.length,
                        results: searchProviderResultItems.map((item)=>({
                                resultContentId: item.objectId,
                                resultType: item.contentType
                            }))
                    },
                    eventType: (0, $g6Qq4.EVENT_TYPE).UI
                });
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (err) {
                const perfStop = performance.now();
                const duration = perfStop - perfStart;
                this.fireAnalytics({
                    action: (0, $g6Qq4.ACTION).INVOKED,
                    actionSubject: (0, $g6Qq4.ACTION_SUBJECT).SEARCH_RESULT,
                    actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).QUICK_SEARCH,
                    attributes: {
                        duration: duration,
                        count: -1,
                        errorCode: err.status
                    },
                    eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL
                });
            }
        }, this.updateInput = async (input)=>{
            const { activityProvider: activityProvider, searchProvider: searchProvider } = this.state;
            this.setState({
                displayUrl: input
            });
            if (activityProvider) {
                if (input.length === 0) this.setState({
                    items: await this.getRecentItems(activityProvider),
                    selectedIndex: -1
                });
                else if ((0, $7nI18.isSafeUrl)(input)) this.setState({
                    items: [],
                    selectedIndex: -1,
                    isLoading: false
                });
                else {
                    const items = await this.getRecentItems(activityProvider, input);
                    const shouldQuerySearchProvider = items.length < $fa2bf5746f941f2d$export$452f1062ecf44be7 && !!searchProvider;
                    this.setState({
                        items: items,
                        isLoading: shouldQuerySearchProvider
                    });
                    if (shouldQuerySearchProvider) this.debouncedQuickSearch(input, items, $fa2bf5746f941f2d$export$452f1062ecf44be7);
                }
            }
        }, this.createClearHandler = (field)=>{
            return async ()=>{
                const { activityProvider: activityProvider } = this.state;
                switch(field){
                    case 'displayUrl':
                        this.setState({
                            [field]: '',
                            items: !!activityProvider ? $fa2bf5746f941f2d$var$limit(await activityProvider.getRecentItems()) : []
                        });
                        if (this.urlInputContainer) this.urlInputContainer.focus();
                        break;
                    case 'displayText':
                        this.setState({
                            [field]: ''
                        });
                        if (this.displayTextInputContainer) this.displayTextInputContainer.focus();
                }
            };
        }, this.handleClickOutside = (event)=>{
            if (event.target instanceof Element && this.wrapperRef.current && !this.wrapperRef.current.contains(event.target)) {
                const { view: { state: state, dispatch: dispatch }, onClickAwayCallback: onClickAwayCallback } = this.props;
                onClickAwayCallback === null || onClickAwayCallback === void 0 || onClickAwayCallback(state, dispatch);
            }
        }, this.getScreenReaderText = ()=>{
            const { intl: intl } = this.props;
            const { items: items, selectedIndex: selectedIndex } = this.state;
            if (items.length && selectedIndex > -1) {
                const { name: name, container: container, lastUpdatedDate: lastUpdatedDate, lastViewedDate: lastViewedDate } = items[selectedIndex];
                const date = (0, $3vuKa.transformTimeStamp)(intl, lastViewedDate, lastUpdatedDate);
                return `${name}, ${container}, ${date === null || date === void 0 ? void 0 : date.pageAction} ${date === null || date === void 0 ? void 0 : date.dateString} ${(date === null || date === void 0 ? void 0 : date.timeSince) || ''}`;
            }
        }, this.listItemRefCallback = (el, id)=>{
            if (!this.listItemRefs.current) return;
            if (el === null) delete this.listItemRefs.current[id];
            else this.listItemRefs.current[id] = el;
        }, this.isUrlPopulatedWithSelectedItem = ()=>{
            /**
     * When we use ArrowKey to navigate through result items,
     * the URL field will be populated with the content of
     * selected item.
     * This function will check if the URL field is populated
     * with selected item.
     * It can be useful to detect whether we want to insert a
     * smartlink or a hyperlink with customized title
     */ const { items: items, selectedIndex: selectedIndex, displayUrl: displayUrl } = this.state;
            const selectedItem = items[selectedIndex];
            if (selectedItem && selectedItem.url === displayUrl) return true;
            return false;
        }, this.handleSelected = (href, text)=>{
            this.handleInsert(href, text, (0, $g6Qq4.INPUT_METHOD).TYPEAHEAD, 'click');
        }, this.handleInsert = (href, title, inputType, interaction)=>{
            const { searchSessionId: searchSessionId, onSubmit: onSubmit } = this.props;
            const { items: items, selectedIndex: selectedIndex, displayText: displayText } = this.state;
            if (onSubmit) {
                this.submitted = true;
                onSubmit(href, title, displayText, inputType);
            }
            if (interaction === 'click' || this.isUrlPopulatedWithSelectedItem()) {
                /**
       * When it's a mouse click even or the selectedItem.url matches displayUrl, we think
       * it's selected from the result list and fire the
       * analytic
       */ const selectedItem = items[selectedIndex];
                this.fireAnalytics({
                    action: (0, $g6Qq4.ACTION).SELECTED,
                    actionSubject: (0, $g6Qq4.ACTION_SUBJECT).SEARCH_RESULT,
                    attributes: {
                        source: this.analyticSource,
                        searchSessionId: searchSessionId ?? '',
                        trigger: interaction,
                        resultCount: items.length,
                        selectedResultId: selectedItem.objectId,
                        selectedRelativePosition: selectedIndex,
                        prefetch: selectedItem.prefetch ?? false
                    },
                    eventType: (0, $g6Qq4.EVENT_TYPE).UI
                });
            }
        }, this.handleMouseEnterResultItem = (objectId)=>{
            const { items: items } = this.state;
            const index = $fa2bf5746f941f2d$var$findIndex(items, (item)=>item.objectId === objectId);
            this.setState({
                selectedIndex: index
            });
        }, this.handleMouseLeaveResultItem = (objectId)=>{
            const { items: items, selectedIndex: selectedIndex } = this.state;
            const index = $fa2bf5746f941f2d$var$findIndex(items, (item)=>item.objectId === objectId);
            // This is to avoid updating index that was set by other mouseenter event
            if (selectedIndex === index) this.setState({
                selectedIndex: -1
            });
        }, this.handleSubmit = ()=>{
            const { displayUrl: displayUrl, selectedIndex: selectedIndex, items: items } = this.state;
            const selectedItem = items[selectedIndex];
            if (this.isUrlPopulatedWithSelectedItem()) this.handleInsert((0, $98KMe.normalizeUrl)(selectedItem.url), selectedItem.name, (0, $g6Qq4.INPUT_METHOD).TYPEAHEAD, 'keyboard');
            else if (displayUrl && displayUrl.length > 0) {
                const url = (0, $98KMe.normalizeUrl)(displayUrl);
                if (url) this.handleInsert(url, displayUrl, (0, $g6Qq4.INPUT_METHOD).MANUAL, 'notselected');
            }
        }, this.handleClearTextKeyDown = (event)=>{
            const KEY_CODE_TAB = 9;
            const { keyCode: keyCode } = event;
            if (keyCode === KEY_CODE_TAB) {
                /** If there are items in the list, allow normal tabbing so focus moves to the next interactive element (in this case, a search result item).
       */ if (this.state.items.length > 0) return;
                if (!this.submitted) {
                    const { displayUrl: displayUrl, displayText: displayText } = this.state;
                    const url = (0, $98KMe.normalizeUrl)(displayUrl);
                    this.handleInsert(url, displayText || displayUrl, (0, $g6Qq4.INPUT_METHOD).MANUAL, 'notselected');
                }
                event.preventDefault();
                return;
            }
        }, this.handleListItemFocus = (index)=>{
            this.setState({
                selectedIndex: index
            });
        }, this.handleListItemBlur = ()=>{
            this.setState({
                selectedIndex: -1
            });
        }, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.handleKeyDown = (event)=>{
            const { items: items, selectedIndex: selectedIndex } = this.state;
            const { view: view, onEscapeCallback: onEscapeCallback, searchSessionId: searchSessionId } = this.props;
            const { keyCode: keyCode } = event;
            const KEY_CODE_ESCAPE = 27;
            const KEY_CODE_ARROW_DOWN = 40;
            const KEY_CODE_ARROW_UP = 38;
            if (keyCode === KEY_CODE_ESCAPE) {
                // escape
                event.preventDefault();
                const { state: state, dispatch: dispatch } = view;
                onEscapeCallback === null || onEscapeCallback === void 0 || onEscapeCallback(state, dispatch);
                return;
            }
            if (!items || !items.length) return;
            let updatedIndex = selectedIndex;
            if (keyCode === KEY_CODE_ARROW_DOWN) {
                // down
                event.preventDefault();
                updatedIndex = (selectedIndex + 1) % items.length;
            } else if (keyCode === KEY_CODE_ARROW_UP) {
                // up
                event.preventDefault();
                updatedIndex = selectedIndex > 0 ? selectedIndex - 1 : items.length - 1;
            }
            if ([
                KEY_CODE_ARROW_DOWN,
                KEY_CODE_ARROW_UP
            ].includes(keyCode) && items[updatedIndex]) {
                if (this.listItemRefs.current) {
                    var _this$listItemRefs$cu;
                    (_this$listItemRefs$cu = this.listItemRefs.current[items[updatedIndex].objectId]) === null || _this$listItemRefs$cu === void 0 || _this$listItemRefs$cu.focus();
                }
                this.setState({
                    selectedIndex: updatedIndex,
                    displayUrl: items[updatedIndex].url
                });
                this.fireAnalytics({
                    action: (0, $g6Qq4.ACTION).HIGHLIGHTED,
                    actionSubject: (0, $g6Qq4.ACTION_SUBJECT).SEARCH_RESULT,
                    attributes: {
                        source: this.analyticSource,
                        searchSessionId: searchSessionId ?? '',
                        selectedResultId: items[updatedIndex].objectId,
                        selectedRelativePosition: updatedIndex
                    },
                    eventType: (0, $g6Qq4.EVENT_TYPE).UI
                });
            }
        }, this.updateTextInput = (displayText)=>{
            this.setState({
                displayText: displayText
            });
        }, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.handleCancel = (e)=>{
            const { view: { state: state, dispatch: dispatch }, onClickAwayCallback: onClickAwayCallback } = this.props;
            e.preventDefault();
            onClickAwayCallback === null || onClickAwayCallback === void 0 || onClickAwayCallback(state, dispatch);
        };
        this.state = {
            selectedIndex: -1,
            isLoading: false,
            displayUrl: (0, $98KMe.normalizeUrl)(props.displayUrl),
            displayText: props.displayText,
            items: []
        };
        /* Cache functions */ this.handleClearText = this.createClearHandler('displayUrl');
        this.handleClearDisplayText = this.createClearHandler('displayText');
        this.debouncedQuickSearch = (0, (/*@__PURE__*/$parcel$interopDefault($inh7J)))(this.quickSearch, 400);
        this.fireCustomAnalytics = (0, $bTWXs.fireAnalyticsEvent)(props.createAnalyticsEvent);
    }
    async componentDidMount() {
        const { timesViewed: timesViewed, inputMethod: inputMethod, searchSessionId: searchSessionId } = this.props;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners, @atlaskit/platform/no-direct-document-usage
        document.addEventListener('mousedown', this.handleClickOutside);
        this.fireAnalytics({
            action: (0, $g6Qq4.ACTION).VIEWED,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).CREATE_LINK_INLINE_DIALOG,
            attributes: {
                timesViewed: timesViewed ?? 0,
                searchSessionId: searchSessionId ?? '',
                trigger: inputMethod ?? ''
            },
            eventType: (0, $g6Qq4.EVENT_TYPE).SCREEN
        });
        const [activityProvider, searchProvider] = await Promise.all([
            this.props.activityProvider,
            this.props.searchProvider
        ]);
        // loadInitialLinkSearchResult and updateInput rely on activityProvider being set in state
        (0, $4Sf72.flushSync)(()=>this.setState({
                activityProvider: activityProvider,
                searchProvider: searchProvider
            }));
        await this.loadInitialLinkSearchResult();
    }
    componentWillUnmount() {
        const { searchSessionId: searchSessionId } = this.props;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners, @atlaskit/platform/no-direct-document-usage
        document.removeEventListener('mousedown', this.handleClickOutside);
        if (!this.submitted) this.fireAnalytics({
            action: (0, $g6Qq4.ACTION).DISMISSED,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).CREATE_LINK_INLINE_DIALOG,
            attributes: {
                source: this.analyticSource,
                searchSessionId: searchSessionId ?? '',
                trigger: 'blur'
            },
            eventType: (0, $g6Qq4.EVENT_TYPE).UI
        });
    }
    async getRecentItems(activityProvider, query) {
        const { searchSessionId: searchSessionId } = this.props;
        const perfStart = performance.now();
        try {
            const activityRecentItems = $fa2bf5746f941f2d$var$limit(query ? await activityProvider.searchRecent(query) : await activityProvider.getRecentItems());
            const items = activityRecentItems.map($fa2bf5746f941f2d$var$mapActivityProviderResultToLinkSearchItemData);
            const perfStop = performance.now();
            const duration = perfStop - perfStart;
            this.fireAnalytics({
                action: (0, $g6Qq4.ACTION).INVOKED,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).SEARCH_RESULT,
                actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).RECENT_ACTIVITIES,
                attributes: {
                    duration: duration,
                    count: items.length
                },
                eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL
            });
            this.fireAnalytics({
                action: (0, $g6Qq4.ACTION).SHOWN,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).SEARCH_RESULT,
                actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).PRE_QUERY_SEARCH_RESULTS,
                attributes: {
                    source: this.analyticSource,
                    preQueryRequestDurationMs: duration,
                    searchSessionId: searchSessionId ?? '',
                    resultCount: items.length,
                    results: activityRecentItems.map((item)=>({
                            resultContentId: item.objectId,
                            resultType: item.type ?? ''
                        }))
                },
                eventType: (0, $g6Qq4.EVENT_TYPE).UI
            });
            return items;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            const perfStop = performance.now();
            const duration = perfStop - perfStart;
            this.fireAnalytics({
                action: (0, $g6Qq4.ACTION).INVOKED,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).SEARCH_RESULT,
                actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).RECENT_ACTIVITIES,
                attributes: {
                    duration: duration,
                    count: -1,
                    errorCode: err.status
                },
                eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL
            });
            return [];
        }
    }
    fireAnalytics(payload) {
        if (this.props.createAnalyticsEvent && this.fireCustomAnalytics) this.fireCustomAnalytics({
            payload: payload
        });
    }
    async loadInitialLinkSearchResult() {
        const { displayUrl: displayUrl, activityProvider: activityProvider } = this.state;
        try {
            if (!displayUrl && activityProvider) {
                this.setState({
                    isLoading: true
                });
                const items = await this.getRecentItems(activityProvider);
                this.setState({
                    items: items
                });
            }
        } finally{
            this.setState({
                isLoading: false
            });
        }
    }
    render() {
        const { items: items, isLoading: isLoading, selectedIndex: selectedIndex, displayUrl: displayUrl, displayText: displayText } = this.state;
        const { intl: { formatMessage: formatMessage } } = this.props;
        const formatClearLinkText = formatMessage((0, $9Dkwx.messages).clearLink);
        const screenReaderDescriptionId = 'search-recent-links-field-description';
        const linkSearchListId = 'hyperlink-search-list';
        const ariaActiveDescendant = selectedIndex > -1 ? `link-search-list-item-${selectedIndex}` : '';
        const linkSearchInputId = 'search-recent-links-field-id';
        const displayTextInputId = 'display-text-filed-id';
        const browser = (0, $jxkn6.getBrowserInfo)();
        // Added workaround with a screen reader Announcer specifically for VoiceOver + Safari
        // as the Aria design pattern for combobox does not work in this case
        // for details: https://a11y-internal.atlassian.net/browse/AK-740
        const screenReaderText = browser.safari && this.getScreenReaderText();
        const hyperlinkElement = /*#__PURE__*/ (0, $9dQre.jsx)("div", {
            "aria-label": formatMessage((0, $9Dkwx.messages).hyperlinkAriaLabel),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "recent-list",
            "data-testid": "hyperlink-add-toolbar"
        }, /*#__PURE__*/ (0, $9dQre.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            css: [
                (0, $fIEl2.container),
                (0, $fIEl2.narrowContainerWidth),
                $fa2bf5746f941f2d$var$containerPadding
            ],
            ref: this.wrapperRef
        }, /*#__PURE__*/ (0, $9dQre.jsx)("label", {
            htmlFor: linkSearchInputId,
            css: $fa2bf5746f941f2d$var$inputLabel
        }, formatMessage((0, $9Dkwx.messages).linkVisibleLabel)), /*#__PURE__*/ (0, $9dQre.jsx)("div", {
            css: [
                (0, $fIEl2.inputWrapper),
                $fa2bf5746f941f2d$var$inputWrapperPosition
            ]
        }, screenReaderText && /*#__PURE__*/ (0, $9dQre.jsx)((0, $4ambm.default), {
            ariaLive: "assertive",
            text: screenReaderText,
            ariaRelevant: "additions",
            delay: 250
        }), /*#__PURE__*/ (0, $9dQre.jsx)("div", {
            css: $fa2bf5746f941f2d$export$8dd524ceb40e3d16,
            "aria-hidden": "true",
            id: screenReaderDescriptionId
        }, formatMessage((0, $9Dkwx.messages).searchLinkAriaDescription)), /*#__PURE__*/ (0, $9dQre.jsx)((0, $kGWDu.default), {
            role: "combobox",
            ariaExpanded: items && items.length > 0 && !isLoading,
            ariaActiveDescendant: ariaActiveDescendant,
            ariaControls: linkSearchListId,
            ariaAutoComplete: true,
            describedById: screenReaderDescriptionId,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            ref: (ele)=>this.urlInputContainer = ele,
            testId: 'link-url',
            onSubmit: this.handleSubmit,
            onChange: this.updateInput,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            autoFocus: {
                preventScroll: true
            },
            onCancel: this.handleCancel,
            defaultValue: displayUrl,
            onKeyDown: this.handleKeyDown,
            inputId: linkSearchInputId
        }), displayUrl && /*#__PURE__*/ (0, $9dQre.jsx)("div", {
            css: $fa2bf5746f941f2d$var$clearTextWrapper
        }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $lavtv.default), {
            content: formatClearLinkText
        }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $aHbh3.Pressable), {
            xcss: $fa2bf5746f941f2d$var$clearTextButtonStyles,
            onClick: this.handleClearText
        }, /*#__PURE__*/ (0, $9dQre.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cBVmT))), {
            label: formatClearLinkText,
            color: "var(--ds-icon-subtle, #505258)"
        }))))), /*#__PURE__*/ (0, $9dQre.jsx)("label", {
            htmlFor: displayTextInputId,
            css: [
                $fa2bf5746f941f2d$var$inputLabel,
                $fa2bf5746f941f2d$var$textLabelMargin
            ]
        }, formatMessage((0, $9Dkwx.messages).textVisibleLabel)), /*#__PURE__*/ (0, $9dQre.jsx)("div", {
            css: [
                (0, $fIEl2.inputWrapper),
                $fa2bf5746f941f2d$var$inputWrapperPosition
            ]
        }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $kGWDu.default), {
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            ref: (ele)=>this.displayTextInputContainer = ele,
            testId: 'link-text',
            onChange: this.updateTextInput,
            onCancel: this.handleCancel,
            defaultValue: displayText,
            onSubmit: this.handleSubmit,
            onKeyDown: this.handleKeyDown,
            inputId: displayTextInputId
        }), displayText && /*#__PURE__*/ (0, $9dQre.jsx)("div", {
            css: $fa2bf5746f941f2d$var$clearTextWrapper
        }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $lavtv.default), {
            content: formatMessage((0, $9Dkwx.messages).clearText)
        }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $aHbh3.Pressable), {
            xcss: $fa2bf5746f941f2d$var$clearTextButtonStyles,
            onClick: this.handleClearDisplayText,
            onKeyDown: this.handleClearTextKeyDown
        }, /*#__PURE__*/ (0, $9dQre.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cBVmT))), {
            label: formatMessage((0, $9Dkwx.messages).clearText),
            color: "var(--ds-icon-subtle, #505258)"
        }))))), /*#__PURE__*/ (0, $9dQre.jsx)("div", {
            css: $fa2bf5746f941f2d$export$8dd524ceb40e3d16,
            "aria-live": "polite",
            "aria-atomic": "true",
            id: "fabric.editor.hyperlink.suggested.results"
        }, displayUrl && formatMessage((0, $9Dkwx.messages).searchLinkResults, {
            count: items.length
        })), /*#__PURE__*/ (0, $9dQre.jsx)((0, $cjXwI.default), {
            ariaControls: "fabric.editor.hyperlink.suggested.results",
            id: linkSearchListId,
            role: "listbox",
            items: items,
            isLoading: isLoading,
            selectedIndex: selectedIndex,
            listItemRefCallback: this.listItemRefCallback,
            onFocus: this.handleListItemFocus,
            onBlur: this.handleListItemBlur,
            onKeyDown: this.handleKeyDown,
            onSelect: this.handleSelected,
            onMouseEnter: this.handleMouseEnterResultItem,
            onMouseLeave: this.handleMouseLeaveResultItem
        })));
        if ((0, $5N1Y4.expValEquals)('platform_editor_a11y_escape_link_dialog', 'isEnabled', true)) return(// eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        /*#__PURE__*/ (0, $9dQre.jsx)((0, $kqAcG.default), {
            returnFocus: {
                preventScroll: true
            },
            focusOptions: {
                preventScroll: true
            }
        }, hyperlinkElement));
        return hyperlinkElement;
    }
}
function $fa2bf5746f941f2d$var$findIndex(array, predicate) {
    let index = -1;
    array.some((item, i)=>{
        if (predicate(item)) {
            index = i;
            return true;
        }
        return false;
    });
    return index;
}
function $fa2bf5746f941f2d$var$limit(items) {
    return items.slice(0, $fa2bf5746f941f2d$export$452f1062ecf44be7);
}
const $fa2bf5746f941f2d$export$527bb787d3e8324e = (0, $fK3tS.default)($fa2bf5746f941f2d$export$7acbf008e0847b89);
const $fa2bf5746f941f2d$var$_default_1 = (0, $kIbto.default)()($fa2bf5746f941f2d$export$527bb787d3e8324e);
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$fa2bf5746f941f2d$export$2e2bcd8739ae039 = $fa2bf5746f941f2d$var$_default_1;

});
parcelRegister("4ambm", function(module, exports) {
$parcel$export(module.exports, "default", () => $0f3d042b5a604bf8$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");
// Note: Flag 'contentRendered' resolves bug with duplicates messages (NVDA + Firefox)
// https://github.com/nvaccess/nvda/labels/bug%2Fdouble-speaking
let $0f3d042b5a604bf8$var$timer;
const $0f3d042b5a604bf8$var$Announcer = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ ariaAtomic: ariaAtomic = 'true', ariaLive: ariaLive = 'polite', ariaRelevant: ariaRelevant = 'all', role: role = 'status', text: text = '', delay: delay = 0 }, ref)=>{
    const [contentRendered, setContentRendered] = (0, $bSJIT.useState)(false);
    (0, $bSJIT.useEffect)(()=>{
        clearTimeout($0f3d042b5a604bf8$var$timer);
        setContentRendered(false);
        $0f3d042b5a604bf8$var$timer = setTimeout(()=>{
            setContentRendered(true);
        }, delay);
        return ()=>clearTimeout($0f3d042b5a604bf8$var$timer);
    }, [
        text,
        delay
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "assistive",
        ref: ref,
        role: role,
        "aria-atomic": ariaAtomic,
        "aria-relevant": ariaRelevant,
        "aria-live": ariaLive,
        children: contentRendered && /*#__PURE__*/ (0, $dc70d.jsx)("span", {
            children: text
        })
    });
});
const $0f3d042b5a604bf8$var$_default_1 = /*#__PURE__*/ (0, $bSJIT.memo)($0f3d042b5a604bf8$var$Announcer);
var $0f3d042b5a604bf8$export$2e2bcd8739ae039 = $0f3d042b5a604bf8$var$_default_1;

});

parcelRegister("kGWDu", function(module, exports) {
$parcel$export(module.exports, "default", () => $cc85c4f07ba9c373$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $jxkn6 = parcelRequire("jxkn6");

var $anWec = parcelRequire("anWec");
const $cc85c4f07ba9c373$var$KeyZCode = 90;
const $cc85c4f07ba9c373$var$KeyYCode = 89;
class $cc85c4f07ba9c373$export$2e2bcd8739ae039 extends (0, $bSJIT.PureComponent) {
    constructor(props){
        super(props), this.onMouseDown = ()=>{
            const { onMouseDown: onMouseDown } = this.props;
            if (onMouseDown) onMouseDown();
        }, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onBlur = (e)=>{
            const { onBlur: onBlur } = this.props;
            if (onBlur) onBlur(e);
        }, this.handleChange = ()=>{
            const { onChange: onChange } = this.props;
            if (this.input) this.setState({
                value: this.input.value
            });
            if (onChange && this.input) onChange(this.input.value);
        }, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.handleKeydown = (e)=>{
            const { onUndo: onUndo, onRedo: onRedo, onSubmit: onSubmit, onCancel: onCancel } = this.props;
            if (e.keyCode === 13 && onSubmit) {
                e.preventDefault(); // Prevent from submitting if an editor is inside a form.
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                onSubmit(this.input.value);
            } else if (e.keyCode === 27 && onCancel) onCancel(e);
            else if (typeof onUndo === 'function' && this.isUndoEvent(e)) {
                e.preventDefault();
                onUndo();
            } else if (typeof onRedo === 'function' && this.isRedoEvent(e)) {
                e.preventDefault();
                onRedo();
            }
            if (this.props.onKeyDown) this.props.onKeyDown(e);
        }, this.handleRef = (input)=>{
            if (input instanceof HTMLInputElement) {
                this.input = input;
                if (this.props.autoFocus) // Need this to prevent jumping when we render TextInput inside Portal @see ED-2992
                this.focusTimeoutId = window.setTimeout(()=>this.focus());
            } else this.input = undefined;
        };
        this.state = {
            value: props.defaultValue || ''
        };
    }
    componentDidUpdate(prevProps) {
        if (prevProps.defaultValue !== this.props.defaultValue) this.setState({
            value: this.props.defaultValue
        });
    }
    componentWillUnmount() {
        window.clearTimeout(this.focusTimeoutId);
    }
    render() {
        var _this$props, _this$props2;
        const { placeholder: placeholder, width: width, maxLength: maxLength, testId: testId, ariaLabel: ariaLabel, describedById: describedById, ariaActiveDescendant: ariaActiveDescendant, ariaControls: ariaControls, ariaExpanded: ariaExpanded, ariaAutoComplete: ariaAutoComplete, role: role, inputId: inputId } = this.props;
        const { value: value } = this.state;
        return /*#__PURE__*/ (0, $9dQre.jsx)("input", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            css: [
                (0, $anWec.panelTextInput),
                width !== undefined && (0, $anWec.panelTextInputWithCustomWidth)(width)
            ],
            role: role,
            "aria-autocomplete": ariaAutoComplete ? 'list' : undefined,
            "aria-expanded": ariaExpanded,
            "aria-controls": ariaControls,
            "aria-activedescendant": ariaActiveDescendant,
            "aria-describedby": describedById,
            "data-testid": testId || '',
            type: "text",
            placeholder: placeholder,
            value: value,
            onChange: this.handleChange,
            onKeyDown: this.handleKeydown,
            onMouseDown: this.onMouseDown,
            onBlur: this.onBlur,
            ref: this.handleRef,
            maxLength: maxLength,
            "aria-label": ariaLabel,
            "aria-required": (_this$props = this.props) === null || _this$props === void 0 ? void 0 : _this$props.ariaRequired,
            "aria-invalid": (_this$props2 = this.props) === null || _this$props2 === void 0 ? void 0 : _this$props2.ariaInvalid,
            id: inputId
        });
    }
    focus() {
        const { input: input } = this;
        if (input) {
            const focusOpts = typeof this.props.autoFocus === 'object' ? this.props.autoFocus : {};
            input.focus(focusOpts);
        }
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    isUndoEvent(event) {
        const browser = (0, $jxkn6.getBrowserInfo)();
        return event.keyCode === $cc85c4f07ba9c373$var$KeyZCode && // cmd + z for mac
        (browser.mac && event.metaKey && !event.shiftKey || // ctrl + z for non-mac
        !browser.mac && event.ctrlKey);
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    isRedoEvent(event) {
        const browser = (0, $jxkn6.getBrowserInfo)();
        return(// ctrl + y for non-mac
        !browser.mac && event.ctrlKey && event.keyCode === $cc85c4f07ba9c373$var$KeyYCode || browser.mac && event.metaKey && event.shiftKey && event.keyCode === $cc85c4f07ba9c373$var$KeyZCode || event.ctrlKey && event.shiftKey && event.keyCode === $cc85c4f07ba9c373$var$KeyZCode);
    }
}

});
parcelRegister("anWec", function(module, exports) {
$parcel$export(module.exports, "panelTextInput", () => $5ca8fdee63bdf0b2$export$b81ddbf3e2eaad80);
$parcel$export(module.exports, "panelTextInputWithCustomWidth", () => $5ca8fdee63bdf0b2$export$c9f899b6422903f6);
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9dQre = parcelRequire("9dQre");

var $5bbjm = parcelRequire("5bbjm");
const $5ca8fdee63bdf0b2$export$b81ddbf3e2eaad80 = /*#__PURE__*/ (0, $9dQre.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    'input&': {
        background: 'transparent',
        border: `1px solid ${"var(--ds-border-input, #8C8F97)"}`,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
        borderRadius: "var(--ds-radius-small, 3px)",
        boxSizing: 'content-box',
        color: "var(--ds-text, #292A2E)",
        flexGrow: 1,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        fontSize: (0, $5bbjm.relativeFontSizeToBase16)(13),
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: '20px',
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-400, 32px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"}`,
        minWidth: '145px',
        /* Hides IE10+ built-in [x] clear input button */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&::-ms-clear': {
            display: 'none'
        },
        '&:focus': {
            outline: 'none',
            backgroundColor: "var(--ds-background-input-pressed, #FFFFFF)",
            borderColor: "var(--ds-border-focused, #4688EC)",
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${"var(--ds-border-focused, #4688EC)"}`
        },
        '&::placeholder': {
            color: "var(--ds-text-subtlest, #6B6E76)"
        }
    }
});
const $5ca8fdee63bdf0b2$export$c9f899b6422903f6 = (width)=>/*#__PURE__*/ (0, $9dQre.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        'input&': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            width: `${width}px`
        }
    });

});


parcelRegister("cjXwI", function(module, exports) {
$parcel$export(module.exports, "default", () => $e1ffde9f23e69976$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $9dQre = parcelRequire("9dQre");

var $hDkm2 = parcelRequire("hDkm2");

var $djvqW = parcelRequire("djvqW");
function $e1ffde9f23e69976$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e1ffde9f23e69976$var$listContainer = /*#__PURE__*/ (0, $9dQre.css)({
    paddingTop: 0,
    marginTop: "var(--ds-space-150, 12px)",
    borderTop: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`
});
const $e1ffde9f23e69976$var$spinnerContainer = {
    name: "q64ud4",
    styles: "text-align:center;min-height:80px;margin-top:var(--ds-space-400, 32px)"
};
const $e1ffde9f23e69976$export$ca0620a9deb4a3fe = {
    name: "n1lsvi",
    styles: "padding:0;list-style:none"
};
const $e1ffde9f23e69976$var$LinkSearchList = ({ listItemRefCallback: listItemRefCallback, onBlur: onBlur, onFocus: onFocus, onKeyDown: onKeyDown, onSelect: onSelect, onMouseMove: onMouseMove, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, items: items, selectedIndex: selectedIndex, isLoading: isLoading, ariaControls: ariaControls, role: role, id: id })=>{
    let itemsContent;
    let loadingContent;
    if (items && items.length > 0) itemsContent = /*#__PURE__*/ (0, $9dQre.jsx)("ul", {
        css: $e1ffde9f23e69976$export$ca0620a9deb4a3fe,
        id: id,
        role: role,
        "aria-controls": ariaControls,
        "data-testid": `${id}--items`
    }, items.map((item, index)=>/*#__PURE__*/ (0, $9dQre.jsx)((0, $djvqW.default), {
            id: `link-search-list-item-${index}`,
            item: item,
            selected: selectedIndex === index,
            onBlur: onBlur,
            // eslint-disable-next-line @atlassian/perf-linting/detect-unnecessary-rerenders, @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onFocus: ()=>onFocus === null || onFocus === void 0 ? void 0 : onFocus(index),
            onKeyDown: onKeyDown,
            onMouseMove: onMouseMove,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onSelect: onSelect,
            key: item.objectId,
            // eslint-disable-next-line @atlassian/perf-linting/detect-unnecessary-rerenders, @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            ref: (el)=>listItemRefCallback === null || listItemRefCallback === void 0 ? void 0 : listItemRefCallback(el, item.objectId)
        })));
    if (isLoading) loadingContent = /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        id: id,
        "data-testid": `${id}--loading`,
        css: $e1ffde9f23e69976$var$spinnerContainer
    }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $hDkm2.default), {
        size: "medium",
        interactionName: "link-search-spinner"
    }));
    return /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        css: $e1ffde9f23e69976$var$listContainer
    }, itemsContent, loadingContent);
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$e1ffde9f23e69976$export$2e2bcd8739ae039 = $e1ffde9f23e69976$var$LinkSearchList;

});
parcelRegister("djvqW", function(module, exports) {
$parcel$export(module.exports, "default", () => $2210f1f6c64bd405$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $fK3tS = parcelRequire("fK3tS");

var $5bbjm = parcelRequire("5bbjm");

var $5N1Y4 = parcelRequire("5N1Y4");

var $eT2Ii = parcelRequire("eT2Ii");

var $3vuKa = parcelRequire("3vuKa");
function $2210f1f6c64bd405$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2210f1f6c64bd405$export$34e0f9847d4c02dd = /*#__PURE__*/ (0, $9dQre.css)({
    backgroundColor: 'transparent',
    padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-150, 12px)"}`,
    cursor: 'pointer',
    display: 'flex',
    marginTop: 0
});
const $2210f1f6c64bd405$export$624ac72e8eeb8e3d = {
    name: "172qvh2",
    styles: "background-color:var(--ds-background-neutral-subtle-hovered, #0515240F)"
};
const $2210f1f6c64bd405$var$nameWrapper = {
    name: "d3v9zr",
    styles: "overflow:hidden"
};
const $2210f1f6c64bd405$export$d6a1b4d10134b7d7 = {
    name: "15va48x",
    styles: "color:var(--ds-text, #292A2E);overflow:hidden;text-overflow:ellipsis;white-space:nowrap;line-height:20px"
};
const $2210f1f6c64bd405$export$ff1446d682f75fb9 = /*#__PURE__*/ (0, $9dQre.css)({
    color: "var(--ds-text-subtlest, #6B6E76)",
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '14px',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: (0, $5bbjm.relativeFontSizeToBase16)(11)
});
const $2210f1f6c64bd405$var$iconStyle = {
    name: "r2c2s1",
    styles: "min-width:16px;margin-top:var(--ds-space-050, 4px);margin-right:var(--ds-space-150, 12px);img{max-width:16px;}"
};
const $2210f1f6c64bd405$var$LinkSearchListItem = (props, ref)=>{
    const { id: id, item: item, onBlur: onBlur, onFocus: onFocus, onKeyDown: onKeyDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseMove: onMouseMove, onSelect: onSelect, selected: selected, intl: intl } = props;
    const handleSelect = (0, $bSJIT.useCallback)((e)=>{
        e.preventDefault(); // don't let editor lose focus
        onSelect(item.url, item.name);
    }, [
        onSelect,
        item.url,
        item.name
    ]);
    const handleKeyDown = (0, $bSJIT.useCallback)((event)=>{
        if (event.key === 'Enter') onSelect(item.url, item.name);
        onKeyDown === null || onKeyDown === void 0 || onKeyDown(event);
    }, [
        onSelect,
        onKeyDown,
        item.url,
        item.name
    ]);
    const handleMouseMove = (0, $bSJIT.useCallback)(()=>{
        onMouseMove === null || onMouseMove === void 0 || onMouseMove(item.objectId);
    }, [
        onMouseMove,
        item.objectId
    ]);
    const handleMouseEnter = (0, $bSJIT.useCallback)(()=>{
        onMouseEnter === null || onMouseEnter === void 0 || onMouseEnter(item.objectId);
    }, [
        onMouseEnter,
        item.objectId
    ]);
    const handleMouseLeave = (0, $bSJIT.useCallback)(()=>{
        onMouseLeave === null || onMouseLeave === void 0 || onMouseLeave(item.objectId);
    }, [
        onMouseLeave,
        item.objectId
    ]);
    const renderIcon = ()=>{
        if (item.icon) return /*#__PURE__*/ (0, $9dQre.jsx)("span", {
            css: $2210f1f6c64bd405$var$iconStyle
        }, item.icon);
        if (item.iconUrl) return /*#__PURE__*/ (0, $9dQre.jsx)("span", {
            css: $2210f1f6c64bd405$var$iconStyle
        }, /*#__PURE__*/ (0, $9dQre.jsx)("img", {
            src: item.iconUrl,
            alt: (0, $eT2Ii.getCorrectAltByIconUrl)(item.iconUrl, intl)
        }));
        return null;
    };
    const renderTimeStamp = ()=>{
        const date = (0, $3vuKa.transformTimeStamp)(intl, item.lastViewedDate, item.lastUpdatedDate);
        return date && /*#__PURE__*/ (0, $9dQre.jsx)((0, $bSJIT.Fragment), null, "\xa0 \u2022", /*#__PURE__*/ (0, $9dQre.jsx)("span", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "link-search-timestamp",
            "data-testid": "link-search-timestamp"
        }, "\xa0 ", date.pageAction, " ", date.dateString, " ", date.timeSince || ''));
    };
    return /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        ref: ref,
        css: [
            $2210f1f6c64bd405$export$34e0f9847d4c02dd,
            selected && $2210f1f6c64bd405$export$624ac72e8eeb8e3d
        ],
        role: 'option',
        tabIndex: 0,
        id: id,
        "aria-selected": selected,
        "data-testid": "link-search-list-item",
        onBlur: (0, $5N1Y4.expValEquals)('editor_a11y__enghealth-46814_fy26', 'isEnabled', true) ? onBlur : undefined,
        onFocus: onFocus,
        onKeyDown: handleKeyDown,
        onMouseMove: handleMouseMove,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onClick: handleSelect
    }, renderIcon(), /*#__PURE__*/ (0, $9dQre.jsx)("span", {
        css: $2210f1f6c64bd405$var$nameWrapper
    }, /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        css: $2210f1f6c64bd405$export$d6a1b4d10134b7d7
    }, item.name), /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        "data-testid": "link-search-list-item-container",
        css: $2210f1f6c64bd405$export$ff1446d682f75fb9
    }, item.container, renderTimeStamp())));
};
const $2210f1f6c64bd405$var$ForwardedLinkSearchListItem = /*#__PURE__*/ (0, $bSJIT.forwardRef)($2210f1f6c64bd405$var$LinkSearchListItem);
const $2210f1f6c64bd405$export$1896ba66c9a2c53b = (0, $fK3tS.default)($2210f1f6c64bd405$var$ForwardedLinkSearchListItem, {
    forwardRef: true
});
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$2210f1f6c64bd405$export$2e2bcd8739ae039 = $2210f1f6c64bd405$export$1896ba66c9a2c53b;

});
parcelRegister("eT2Ii", function(module, exports) {
$parcel$export(module.exports, "getCorrectAltByIconUrl", () => $ded2db580031c24e$export$ac1fda7301622804);

var $f0Pt4 = parcelRequire("f0Pt4");
const $ded2db580031c24e$var$messages = (0, $f0Pt4.defineMessages)({
    story: {
        id: 'fabric.editor.story',
        defaultMessage: 'Story',
        description: 'Alt text for the issue type icon displayed in link search results when the linked item is a Story issue type.'
    },
    epic: {
        id: 'fabric.editor.epic',
        defaultMessage: 'Epic',
        description: 'Alt text for the issue type icon displayed in link search results when the linked item is an Epic issue type.'
    },
    task: {
        id: 'fabric.editor.task',
        defaultMessage: 'Task',
        description: 'Alt text for the issue type icon displayed in link search results when the linked item is a Task issue type.'
    },
    bug: {
        id: 'fabric.editor.bug',
        defaultMessage: 'Bug',
        description: 'Alt text for the issue type icon displayed in link search results when the linked item is a Bug issue type.'
    },
    subTask: {
        id: 'fabric.editor.subTask',
        defaultMessage: 'Sub-task',
        description: 'Alt text for the issue type icon displayed in link search results when the linked item is a Sub-task issue type.'
    },
    improvement: {
        id: 'fabric.editor.improvement',
        defaultMessage: 'Improvement',
        description: 'Alt text for the issue type icon displayed in link search results when the linked item is an Improvement issue type.'
    },
    defaultAltText: {
        id: 'fabric.editor.defaultAltText',
        defaultMessage: 'Document',
        description: 'The text is used as the default alternative text for an image in a link search list item when no specific alt text is available, representing a generic document result.'
    }
});
const $ded2db580031c24e$export$ac1fda7301622804 = (iconUrl, intl)=>{
    let alt = intl.formatMessage($ded2db580031c24e$var$messages.defaultAltText);
    if (iconUrl.includes('story.svg')) alt = intl.formatMessage($ded2db580031c24e$var$messages.story);
    if (iconUrl.includes('epic.svg')) alt = intl.formatMessage($ded2db580031c24e$var$messages.epic);
    if (iconUrl.includes('avatarId=10318')) alt = intl.formatMessage($ded2db580031c24e$var$messages.task);
    if (iconUrl.includes('avatarId=10303')) alt = intl.formatMessage($ded2db580031c24e$var$messages.bug);
    if (iconUrl.includes('avatarId=10518')) alt = intl.formatMessage($ded2db580031c24e$var$messages.subTask);
    if (iconUrl.includes('avatarId=10310')) alt = intl.formatMessage($ded2db580031c24e$var$messages.improvement);
    return alt;
};

});

parcelRegister("3vuKa", function(module, exports) {
$parcel$export(module.exports, "transformTimeStamp", () => $41bdef42d58ae59c$export$439b9bb86eb9f500);

var $bAER0 = parcelRequire("bAER0");

var $53JkC = parcelRequire("53JkC");

var $3VOQ9 = parcelRequire("3VOQ9");

var $fNLdd = parcelRequire("fNLdd");
const $41bdef42d58ae59c$var$renderAbsoluteOrRelativeDate = (timeStamp, pageAction, intl)=>{
    let pageActionText = '';
    switch(pageAction){
        case 'updated':
            pageActionText = intl.formatMessage((0, $fNLdd.default).timeUpdated);
            break;
        case 'viewed':
            pageActionText = intl.formatMessage((0, $fNLdd.default).timeViewed);
            break;
    }
    if ((0, $bAER0.default)(timeStamp, Date.now()) < -7) return {
        pageAction: pageActionText,
        dateString: (0, $53JkC.default)(timeStamp, 'MMMM dd, yyyy')
    };
    return {
        pageAction: pageActionText,
        dateString: (0, $3VOQ9.default)(timeStamp, Date.now()),
        timeSince: intl.formatMessage((0, $fNLdd.default).timeAgo)
    };
};
const $41bdef42d58ae59c$export$439b9bb86eb9f500 = (intl, lastViewedDate, lastUpdatedDate)=>{
    if (lastViewedDate) return $41bdef42d58ae59c$var$renderAbsoluteOrRelativeDate(lastViewedDate, 'viewed', intl);
    if (lastUpdatedDate) return $41bdef42d58ae59c$var$renderAbsoluteOrRelativeDate(lastUpdatedDate, 'updated', intl);
};

});
parcelRegister("3VOQ9", function(module, exports) {
$parcel$export(module.exports, "default", () => $2dce21bd6932fa11$export$2e2bcd8739ae039);

var $lLJTa = parcelRequire("lLJTa");

var $jAkEQ = parcelRequire("jAkEQ");

var $cQ3ZD = parcelRequire("cQ3ZD");

var $8px33 = parcelRequire("8px33");

var $3Bqtq = parcelRequire("3Bqtq");

var $897M5 = parcelRequire("897M5");

var $9IkH5 = parcelRequire("9IkH5");

var $5ztic = parcelRequire("5ztic");

var $6nu0h = parcelRequire("6nu0h");

var $OPOsJ = parcelRequire("OPOsJ");
var $2dce21bd6932fa11$var$MINUTES_IN_DAY = 1440;
var $2dce21bd6932fa11$var$MINUTES_IN_ALMOST_TWO_DAYS = 2520;
var $2dce21bd6932fa11$var$MINUTES_IN_MONTH = 43200;
var $2dce21bd6932fa11$var$MINUTES_IN_TWO_MONTHS = 86400;
function $2dce21bd6932fa11$export$2e2bcd8739ae039(dirtyDate, dirtyBaseDate, options) {
    var _ref, _options$locale;
    (0, $OPOsJ.default)(2, arguments);
    var defaultOptions = (0, $lLJTa.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $3Bqtq.default);
    if (!locale.formatDistance) throw new RangeError('locale must contain formatDistance property');
    var comparison = (0, $jAkEQ.default)(dirtyDate, dirtyBaseDate);
    if (isNaN(comparison)) throw new RangeError('Invalid time value');
    var localizeOptions = (0, $5ztic.default)((0, $9IkH5.default)(options), {
        addSuffix: Boolean(options === null || options === void 0 ? void 0 : options.addSuffix),
        comparison: comparison
    });
    var dateLeft;
    var dateRight;
    if (comparison > 0) {
        dateLeft = (0, $897M5.default)(dirtyBaseDate);
        dateRight = (0, $897M5.default)(dirtyDate);
    } else {
        dateLeft = (0, $897M5.default)(dirtyDate);
        dateRight = (0, $897M5.default)(dirtyBaseDate);
    }
    var seconds = (0, $8px33.default)(dateRight, dateLeft);
    var offsetInSeconds = ((0, $6nu0h.default)(dateRight) - (0, $6nu0h.default)(dateLeft)) / 1000;
    var minutes = Math.round((seconds - offsetInSeconds) / 60);
    var months;
    // 0 up to 2 mins
    if (minutes < 2) {
        if (options !== null && options !== void 0 && options.includeSeconds) {
            if (seconds < 5) return locale.formatDistance('lessThanXSeconds', 5, localizeOptions);
            else if (seconds < 10) return locale.formatDistance('lessThanXSeconds', 10, localizeOptions);
            else if (seconds < 20) return locale.formatDistance('lessThanXSeconds', 20, localizeOptions);
            else if (seconds < 40) return locale.formatDistance('halfAMinute', 0, localizeOptions);
            else if (seconds < 60) return locale.formatDistance('lessThanXMinutes', 1, localizeOptions);
            else return locale.formatDistance('xMinutes', 1, localizeOptions);
        } else {
            if (minutes === 0) return locale.formatDistance('lessThanXMinutes', 1, localizeOptions);
            else return locale.formatDistance('xMinutes', minutes, localizeOptions);
        }
    } else if (minutes < 45) return locale.formatDistance('xMinutes', minutes, localizeOptions);
    else if (minutes < 90) return locale.formatDistance('aboutXHours', 1, localizeOptions);
    else if (minutes < $2dce21bd6932fa11$var$MINUTES_IN_DAY) {
        var hours = Math.round(minutes / 60);
        return locale.formatDistance('aboutXHours', hours, localizeOptions);
    // 1 day up to 1.75 days
    } else if (minutes < $2dce21bd6932fa11$var$MINUTES_IN_ALMOST_TWO_DAYS) return locale.formatDistance('xDays', 1, localizeOptions);
    else if (minutes < $2dce21bd6932fa11$var$MINUTES_IN_MONTH) {
        var days = Math.round(minutes / $2dce21bd6932fa11$var$MINUTES_IN_DAY);
        return locale.formatDistance('xDays', days, localizeOptions);
    // 1 month up to 2 months
    } else if (minutes < $2dce21bd6932fa11$var$MINUTES_IN_TWO_MONTHS) {
        months = Math.round(minutes / $2dce21bd6932fa11$var$MINUTES_IN_MONTH);
        return locale.formatDistance('aboutXMonths', months, localizeOptions);
    }
    months = (0, $cQ3ZD.default)(dateRight, dateLeft);
    // 2 months up to 12 months
    if (months < 12) {
        var nearestMonth = Math.round(minutes / $2dce21bd6932fa11$var$MINUTES_IN_MONTH);
        return locale.formatDistance('xMonths', nearestMonth, localizeOptions);
    // 1 year up to max Date
    } else {
        var monthsSinceStartOfYear = months % 12;
        var years = Math.floor(months / 12);
        // N years up to 1 years 3 months
        if (monthsSinceStartOfYear < 3) return locale.formatDistance('aboutXYears', years, localizeOptions);
        else if (monthsSinceStartOfYear < 9) return locale.formatDistance('overXYears', years, localizeOptions);
        else return locale.formatDistance('almostXYears', years + 1, localizeOptions);
    }
}

});
parcelRegister("8px33", function(module, exports) {
$parcel$export(module.exports, "default", () => $61fa4b3521e94e00$export$2e2bcd8739ae039);

var $2G2qr = parcelRequire("2G2qr");

var $OPOsJ = parcelRequire("OPOsJ");

var $lqDOV = parcelRequire("lqDOV");
function $61fa4b3521e94e00$export$2e2bcd8739ae039(dateLeft, dateRight, options) {
    (0, $OPOsJ.default)(2, arguments);
    var diff = (0, $2G2qr.default)(dateLeft, dateRight) / 1000;
    return (0, $lqDOV.getRoundingMethod)(options === null || options === void 0 ? void 0 : options.roundingMethod)(diff);
}

});
parcelRegister("2G2qr", function(module, exports) {
$parcel$export(module.exports, "default", () => $1f3162a5f5ed286e$export$2e2bcd8739ae039);

var $897M5 = parcelRequire("897M5");

var $OPOsJ = parcelRequire("OPOsJ");
function $1f3162a5f5ed286e$export$2e2bcd8739ae039(dateLeft, dateRight) {
    (0, $OPOsJ.default)(2, arguments);
    return (0, $897M5.default)(dateLeft).getTime() - (0, $897M5.default)(dateRight).getTime();
}

});

parcelRegister("lqDOV", function(module, exports) {
$parcel$export(module.exports, "getRoundingMethod", () => $f99aea308bb71ab3$export$b6474a47258c1211);
var $f99aea308bb71ab3$var$roundingMap = {
    ceil: Math.ceil,
    round: Math.round,
    floor: Math.floor,
    trunc: function trunc(value) {
        return value < 0 ? Math.ceil(value) : Math.floor(value);
    } // Math.trunc is not supported by IE
};
var $f99aea308bb71ab3$var$defaultRoundingMethod = 'trunc';
function $f99aea308bb71ab3$export$b6474a47258c1211(method) {
    return method ? $f99aea308bb71ab3$var$roundingMap[method] : $f99aea308bb71ab3$var$roundingMap[$f99aea308bb71ab3$var$defaultRoundingMethod];
}

});


parcelRegister("9IkH5", function(module, exports) {
$parcel$export(module.exports, "default", () => $7128467c1c49cbbc$export$2e2bcd8739ae039);

var $5ztic = parcelRequire("5ztic");
function $7128467c1c49cbbc$export$2e2bcd8739ae039(object) {
    return (0, $5ztic.default)({}, object);
}

});





parcelRegister("fIEl2", function(module, exports) {
$parcel$export(module.exports, "inputWrapper", () => $951f46957062ba30$export$248a47518f3a0001);
$parcel$export(module.exports, "container", () => $951f46957062ba30$export$34e0f9847d4c02dd);
$parcel$export(module.exports, "containerWithProvider", () => $951f46957062ba30$export$8fb2d297355596b4);
$parcel$export(module.exports, "narrowContainerWidth", () => $951f46957062ba30$export$b45558f4e00a3f09);
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9dQre = parcelRequire("9dQre");

var $7Zwry = parcelRequire("7Zwry");
function $951f46957062ba30$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $951f46957062ba30$export$248a47518f3a0001 = /*#__PURE__*/ (0, $9dQre.css)({
    display: 'flex',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 0,
    padding: `${"var(--ds-space-075, 6px)"} 0`,
    alignItems: 'center'
});
const $951f46957062ba30$export$34e0f9847d4c02dd = /*#__PURE__*/ (0, $9dQre.css)({
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
    padding: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $7Zwry.RECENT_SEARCH_WIDTH_WITHOUT_ITEMS_IN_PX)}px`,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 'initial'
});
const $951f46957062ba30$export$8fb2d297355596b4 = /*#__PURE__*/ (0, $9dQre.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $7Zwry.RECENT_SEARCH_WIDTH_IN_PX)}px`
});
const $951f46957062ba30$export$b45558f4e00a3f09 = {
    name: "1raezz8",
    styles: "width:292px"
};

});

parcelRegister("ffAKP", function(module, exports) {
$parcel$export(module.exports, "filterUniqueItems", () => $dbbdf563bfbe0fe7$export$8437fc55448c6e05);
function $dbbdf563bfbe0fe7$export$8437fc55448c6e05(arr, comparator) {
    return arr.filter((firstItem, index, self)=>{
        return self.findIndex((secondItem)=>comparator ? comparator(firstItem, secondItem) : firstItem === secondItem) === index;
    });
}

});

parcelRegister("9Dkwx", function(module, exports) {
$parcel$export(module.exports, "messages", () => $4d71fb43e24d3957$export$defe85febe8b728c);

var $f0Pt4 = parcelRequire("f0Pt4");
const $4d71fb43e24d3957$export$defe85febe8b728c = (0, $f0Pt4.defineMessages)({
    displayText: {
        id: 'fabric.editor.displayText',
        defaultMessage: 'Text to display',
        description: 'Label for the text input field in the hyperlink toolbar where users enter the display text for a link.'
    },
    clearText: {
        id: 'fabric.editor.clearLinkText',
        defaultMessage: 'Clear text',
        description: 'The text is shown on a button in the hyperlink toolbar that clears the display text field, removing any custom link text the user has entered.'
    },
    clearLink: {
        id: 'fabric.editor.clearLink',
        defaultMessage: 'Clear link',
        description: 'The text is shown on a button in the hyperlink toolbar that clears the URL field, removing any link address the user has entered.'
    },
    hyperlinkAriaLabel: {
        id: 'fabric.editor.hyperlink.ariaLabel',
        defaultMessage: 'Hyperlink Edit',
        description: 'Aria label for the Hyperlink Add Toolbar'
    },
    searchLinkAriaDescription: {
        id: 'fabric.editor.hyperlink.searchLinkAriaDescription',
        defaultMessage: 'Suggestions will appear below as you type into the field',
        description: 'Describes what the search field does for screen reader users.'
    },
    searchLinkResults: {
        id: 'fabric.editor.hyperlink.searchLinkResults',
        defaultMessage: '{count, plural, =0 {no results} one {# result} other {# results}} found',
        description: 'Announce search results for screen-reader users.'
    },
    linkVisibleLabel: {
        id: 'fabric.editor.hyperlink.linkVisibleLabel',
        defaultMessage: 'Paste or search for link',
        description: 'Visible label for link input in hyperlink floating control'
    },
    textVisibleLabel: {
        id: 'fabric.editor.hyperlink.textVisibleLabel',
        defaultMessage: 'Display text (optional)',
        description: 'Visible label for text input in hyperlink floating control'
    }
});

});

parcelRegister("iTcdH", function(module, exports) {
$parcel$export(module.exports, "sha1", () => $4f15c558b228498a$export$5091bdda49ba90f5);

var $PHIeZ = parcelRequire("PHIeZ");
const $4f15c558b228498a$export$5091bdda49ba90f5 = (input)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($PHIeZ))).createHash().update(input).digest('hex');
};

});

parcelRegister("45VR5", function(module, exports) {
$parcel$export(module.exports, "mapContentTypeToIcon", () => $b2a34c0661c99135$export$80e948449ec854a9);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $fK3tS = parcelRequire("fK3tS");

var $5L1nf = parcelRequire("5L1nf");

var $5GXrT = parcelRequire("5GXrT");

var $iPH47 = parcelRequire("iPH47");

var $f4EgE = parcelRequire("f4EgE");

var $iLUhj = parcelRequire("iLUhj");

var $24J67 = parcelRequire("24J67");

var $gdUUy = parcelRequire("gdUUy");

var $byLwz = parcelRequire("byLwz");



const $b2a34c0661c99135$var$Issue16 = (props)=>{
    const { intl: intl } = props;
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $24J67.default), {
        label: intl.formatMessage((0, $gdUUy.fg)('confluence-issue-terminology-refresh') ? (0, $byLwz.utilMessages).hyperlinkIconIssueLabelIssueTermRefresh : (0, $byLwz.utilMessages).hyperlinkIconIssueLabel)
    });
};
const $b2a34c0661c99135$var$Bug16 = (props)=>{
    const { intl: intl } = props;
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $5GXrT.default), {
        label: intl.formatMessage((0, $byLwz.utilMessages).hyperlinkIconBugLabel)
    });
};
const $b2a34c0661c99135$var$Story16 = (props)=>{
    const { intl: intl } = props;
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $f4EgE.default), {
        label: intl.formatMessage((0, $byLwz.utilMessages).hyperlinkIconStoryLabel)
    });
};
const $b2a34c0661c99135$var$Task16 = (props)=>{
    const { intl: intl } = props;
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $iLUhj.default), {
        label: intl.formatMessage((0, $byLwz.utilMessages).hyperlinkIconTaskLabel)
    });
};
const $b2a34c0661c99135$var$Page16 = (props)=>{
    const { intl: intl } = props;
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $iPH47.default), {
        label: intl.formatMessage((0, $byLwz.utilMessages).hyperlinkIconPageLabel)
    });
};
const $b2a34c0661c99135$var$Blog16 = (props)=>{
    const { intl: intl } = props;
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $5L1nf.default), {
        label: intl.formatMessage((0, $byLwz.utilMessages).hyperlinkIconBlogLabel)
    });
};
const $b2a34c0661c99135$var$IntlIssue16Icon = (0, $fK3tS.default)($b2a34c0661c99135$var$Issue16);
const $b2a34c0661c99135$var$IntlBug16Icon = (0, $fK3tS.default)($b2a34c0661c99135$var$Bug16);
const $b2a34c0661c99135$var$IntlStory16Icon = (0, $fK3tS.default)($b2a34c0661c99135$var$Story16);
const $b2a34c0661c99135$var$IntlTask16Icon = (0, $fK3tS.default)($b2a34c0661c99135$var$Task16);
const $b2a34c0661c99135$var$IntlPage16Icon = (0, $fK3tS.default)($b2a34c0661c99135$var$Page16);
const $b2a34c0661c99135$var$IntlBlog16Icon = (0, $fK3tS.default)($b2a34c0661c99135$var$Blog16);
const $b2a34c0661c99135$export$80e948449ec854a9 = {
    'jira.issue': /*#__PURE__*/ (0, $dc70d.jsx)($b2a34c0661c99135$var$IntlIssue16Icon, {}),
    'jira.issue.bug': /*#__PURE__*/ (0, $dc70d.jsx)($b2a34c0661c99135$var$IntlBug16Icon, {}),
    'jira.issue.story': /*#__PURE__*/ (0, $dc70d.jsx)($b2a34c0661c99135$var$IntlStory16Icon, {}),
    'jira.issue.task': /*#__PURE__*/ (0, $dc70d.jsx)($b2a34c0661c99135$var$IntlTask16Icon, {}),
    'confluence.page': /*#__PURE__*/ (0, $dc70d.jsx)($b2a34c0661c99135$var$IntlPage16Icon, {}),
    'confluence.blogpost': /*#__PURE__*/ (0, $dc70d.jsx)($b2a34c0661c99135$var$IntlBlog16Icon, {})
};

});
parcelRegister("byLwz", function(module, exports) {
$parcel$export(module.exports, "utilMessages", () => $21a5b4c025651cc4$export$ecd9e62648c1046a);

var $f0Pt4 = parcelRequire("f0Pt4");
const $21a5b4c025651cc4$export$ecd9e62648c1046a = (0, $f0Pt4.defineMessages)({
    hyperlinkIconIssueLabel: {
        id: 'fabric.editor.headingLink.hyperlinkIconIssueLabel',
        defaultMessage: 'Issue',
        description: 'Accessible label for the Jira issue icon displayed in the hyperlink add toolbar when users search for or insert a link to a Jira issue.'
    },
    hyperlinkIconBugLabel: {
        id: 'fabric.editor.headingLink.hyperlinkIconBugLabel',
        defaultMessage: 'Bug',
        description: 'Accessible label for the Jira bug icon displayed in the hyperlink add toolbar when users search for or insert a link to a Jira bug.'
    },
    hyperlinkIconStoryLabel: {
        id: 'fabric.editor.headingLink.hyperlinkIconStoryLabel',
        defaultMessage: 'Story',
        description: 'Accessible label for the Jira story icon displayed in the hyperlink add toolbar when users search for or insert a link to a Jira story.'
    },
    hyperlinkIconTaskLabel: {
        id: 'fabric.editor.headingLink.hyperlinkIconTaskLabel',
        defaultMessage: 'Task',
        description: 'Accessible label for the Jira task icon displayed in the hyperlink add toolbar when users search for or insert a link to a Jira task.'
    },
    hyperlinkIconPageLabel: {
        id: 'fabric.editor.headingLink.hyperlinkIconPageLabel',
        defaultMessage: 'Page',
        description: 'The text is shown as an icon label in the hyperlink toolbar to identify Confluence pages. Displayed next to the page icon when users are linking to Confluence pages in the editor.'
    },
    hyperlinkIconBlogLabel: {
        id: 'fabric.editor.headingLink.hyperlinkIconBlogLabel',
        defaultMessage: 'Blog',
        description: 'The text is shown as an icon label in the hyperlink toolbar to identify Confluence blog posts. Displayed next to the blog icon when users are linking to Confluence blogs in the editor.'
    },
    hyperlinkIconIssueLabelIssueTermRefresh: {
        id: 'fabric.editor.headingLink.hyperlinkIconIssueLabel.issue-term-refresh',
        defaultMessage: 'Work Item',
        description: 'Accessible label for the Jira issue icon displayed in the hyperlink add toolbar when users search for or insert a link to a Jira work item. This is the refreshed terminology used instead of "Issue".'
    }
});

});


parcelRegister("aqIaQ", function(module, exports) {
$parcel$export(module.exports, "wordCount", () => $182d831a9e430039$export$24d5ff955141c347);
const $182d831a9e430039$export$24d5ff955141c347 = (input)=>{
    return input.split(' ').length;
};

});




parcelRegister("f371K", function(module, exports) {
$parcel$export(module.exports, "EditToolbarButton", () => $74f9e01d7b87600f$export$4f24788e7d04736b);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $5cKiX = parcelRequire("5cKiX");

var $7HjEm = parcelRequire("7HjEm");

var $2Bpgx = parcelRequire("2Bpgx");

var $278lv = parcelRequire("278lv");

var $ejFiy = parcelRequire("ejFiy");

var $imBU3 = parcelRequire("imBU3");

var $6bWVw = parcelRequire("6bWVw");

var $4GWyU = parcelRequire("4GWyU");

var $6bOBo = parcelRequire("6bOBo");

var $kpgiw = parcelRequire("kpgiw");

var $6X9z7 = parcelRequire("6X9z7");

var $797yE = parcelRequire("797yE");

var $cKhMH = parcelRequire("cKhMH");

var $8VMcp = parcelRequire("8VMcp");

var $3JSsy = parcelRequire("3JSsy");

var $h5Xzz = parcelRequire("h5Xzz");

var $gel6b = parcelRequire("gel6b");
const $74f9e01d7b87600f$var$dropdownExpandContainer = /*#__PURE__*/ (0, $9dQre.css)({
    margin: `0px ${"var(--ds-space-negative-050, -4px)"}`
});
const $74f9e01d7b87600f$var$EditToolbarButtonWithCardContext = (props)=>{
    const { cardContext: cardContext, currentAppearance: currentAppearance, editorAnalyticsApi: editorAnalyticsApi, editorView: editorView, intl: intl, onLinkEditClick: onLinkEditClick, url: url, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled } = props;
    const { extensionKey: extensionKey, ...response } = (0, $h5Xzz.useFetchDatasourceInfo)({
        isRegularCardNode: true,
        url: url,
        cardContext: cardContext
    });
    const datasourceId = response.datasourceId ?? props.datasourceId;
    const [isOpen, setIsOpen] = (0, $bSJIT.useState)(false);
    const containerRef = (0, $bSJIT.useRef)();
    const toggleOpen = ()=>setIsOpen((open)=>!open);
    const onClose = ()=>setIsOpen(false);
    const onEditLink = (0, $bSJIT.useCallback)(()=>{
        if (editorView) {
            onLinkEditClick(editorView.state, editorView.dispatch);
            (0, $cKhMH.focusEditorView)(editorView);
        }
    }, [
        editorView,
        onLinkEditClick
    ]);
    const editVariant = (0, $bSJIT.useMemo)(()=>{
        const hasUrl = url !== null && url !== undefined;
        if (!datasourceId || !(0, $cKhMH.isDatasourceConfigEditable)(datasourceId)) {
            if (hasUrl) return 'edit-link';
            return 'none';
        }
        if (hasUrl) {
            var _cardContext$store, _urlState$error;
            const urlState = cardContext === null || cardContext === void 0 || (_cardContext$store = cardContext.store) === null || _cardContext$store === void 0 ? void 0 : _cardContext$store.getState()[url];
            if ((urlState === null || urlState === void 0 || (_urlState$error = urlState.error) === null || _urlState$error === void 0 ? void 0 : _urlState$error.kind) === 'fatal') return 'edit-link';
            return 'edit-dropdown';
        } else return 'edit-datasource';
    }, [
        cardContext === null || cardContext === void 0 ? void 0 : cardContext.store,
        datasourceId,
        url
    ]);
    const onEditDatasource = (0, $bSJIT.useCallback)(()=>{
        if (editorView && datasourceId) {
            (0, $8VMcp.editDatasource)(datasourceId, editorAnalyticsApi, currentAppearance, extensionKey)(editorView.state, editorView.dispatch);
            (0, $cKhMH.focusEditorView)(editorView);
        }
    }, [
        currentAppearance,
        datasourceId,
        editorAnalyticsApi,
        editorView,
        extensionKey
    ]);
    switch(editVariant){
        case 'edit-link':
            return /*#__PURE__*/ (0, $9dQre.jsx)((0, $6X9z7.Flex), {
                gap: "space.050"
            }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $7HjEm.default), {
                testId: "edit-link",
                onClick: onEditLink,
                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
            }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $5cKiX.default), (0, $ejFiy.linkToolbarMessages).editLink)), !(0, $797yE.editorExperiment)('platform_editor_controls', 'variant1') && /*#__PURE__*/ (0, $9dQre.jsx)((0, $2Bpgx.default), {
                areAnyNewToolbarFlagsEnabled: false
            }));
        case 'edit-datasource':
            return /*#__PURE__*/ (0, $9dQre.jsx)((0, $6X9z7.Flex), {
                gap: "space.050"
            }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $7HjEm.default), {
                testId: "edit-datasource",
                tooltipContent: intl.formatMessage((0, $ejFiy.linkToolbarMessages).editDatasourceStandaloneTooltip),
                onClick: onEditDatasource,
                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
            }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $5cKiX.default), (0, $ejFiy.linkToolbarMessages).editDatasourceStandalone)), !(0, $797yE.editorExperiment)('platform_editor_controls', 'variant1') && /*#__PURE__*/ (0, $9dQre.jsx)((0, $2Bpgx.default), {
                areAnyNewToolbarFlagsEnabled: false
            }));
        case 'edit-dropdown':
            {
                const trigger = /*#__PURE__*/ (0, $9dQre.jsx)((0, $6X9z7.Flex), {
                    gap: "space.050"
                }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $7HjEm.default), {
                    testId: "edit-dropdown-trigger",
                    iconAfter: /*#__PURE__*/ (0, $9dQre.jsx)("span", {
                        css: $74f9e01d7b87600f$var$dropdownExpandContainer
                    }, /*#__PURE__*/ (0, $9dQre.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4GWyU))), {
                        label: intl.formatMessage((0, $278lv.messages).editDropdownTriggerTitle),
                        size: "small"
                    })),
                    onClick: toggleOpen,
                    selected: isOpen,
                    disabled: false,
                    ariaHasPopup: true,
                    areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
                }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $5cKiX.default), (0, $278lv.messages).editDropdownTriggerTitle)), !(0, $797yE.editorExperiment)('platform_editor_controls', 'variant1') && /*#__PURE__*/ (0, $9dQre.jsx)((0, $2Bpgx.default), {
                    areAnyNewToolbarFlagsEnabled: false
                }));
                return /*#__PURE__*/ (0, $9dQre.jsx)((0, $6X9z7.Flex), {
                    ref: containerRef
                }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $6bWVw.DropdownContainer), {
                    mountTo: containerRef.current,
                    isOpen: isOpen,
                    handleClickOutside: onClose,
                    handleEscapeKeydown: onClose,
                    trigger: trigger,
                    scrollableElement: containerRef.current,
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    arrowKeyNavigationProviderOptions: {
                        type: (0, $imBU3.ArrowKeyNavigationType).MENU
                    }
                }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $kpgiw.default), {
                    key: "edit.link",
                    onClick: onEditLink,
                    testId: "edit-dropdown-edit-link-item"
                }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $5cKiX.default), (0, $278lv.messages).editDropdownEditLinkTitle)), /*#__PURE__*/ (0, $9dQre.jsx)((0, $kpgiw.default), {
                    key: "edit.datasource",
                    onClick: onEditDatasource,
                    testId: "edit-dropdown-edit-datasource-item"
                }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $5cKiX.default), (0, $278lv.messages).editDropdownEditDatasourceTitle))));
            }
        case 'none':
        default:
            return null;
    }
};
const $74f9e01d7b87600f$var$EditToolbarButtonWithUrl = (props)=>{
    const { cardContext: cardContext, currentAppearance: currentAppearance, datasourceId: datasourceIdFromAdf, editorAnalyticsApi: editorAnalyticsApi, editorView: editorView, intl: intl, onLinkEditClick: onLinkEditClick, url: url, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled } = props;
    const { extensionKey: extensionKey, datasourceId: datasourceIdFromUrl } = (0, $h5Xzz.useFetchDatasourceInfo)({
        isRegularCardNode: true,
        url: url,
        cardContext: cardContext
    });
    const datasourceId = datasourceIdFromUrl ?? datasourceIdFromAdf;
    const editVariant = (0, $bSJIT.useMemo)(()=>{
        var _cardContext$store2, _urlState$error2;
        if (!datasourceId || !(0, $cKhMH.isDatasourceConfigEditable)(datasourceId)) return 'edit-link';
        const urlState = cardContext === null || cardContext === void 0 || (_cardContext$store2 = cardContext.store) === null || _cardContext$store2 === void 0 ? void 0 : _cardContext$store2.getState()[url];
        if ((urlState === null || urlState === void 0 || (_urlState$error2 = urlState.error) === null || _urlState$error2 === void 0 ? void 0 : _urlState$error2.kind) === 'fatal') return 'edit-link';
        return 'edit-dropdown';
    }, [
        cardContext === null || cardContext === void 0 ? void 0 : cardContext.store,
        datasourceId,
        url
    ]);
    return /*#__PURE__*/ (0, $9dQre.jsx)((0, $gel6b.default), {
        datasourceId: datasourceId,
        currentAppearance: currentAppearance,
        editorAnalyticsApi: editorAnalyticsApi,
        editVariant: editVariant,
        editorView: editorView,
        extensionKey: extensionKey,
        onLinkEditClick: onLinkEditClick,
        intl: intl,
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    });
};
const $74f9e01d7b87600f$var$EditToolbarButtonWithDatasourceId = (props)=>{
    const { currentAppearance: currentAppearance, editorAnalyticsApi: editorAnalyticsApi, editorView: editorView, intl: intl, onLinkEditClick: onLinkEditClick, datasourceId: datasourceId, node: node, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled } = props;
    const fetchData = (0, $bSJIT.useMemo)(()=>{
        try {
            var _attrs$datasource$vie;
            const attrs = node.attrs;
            const parameters = attrs.datasource.parameters;
            const visibleColumnKeys = (_attrs$datasource$vie = attrs.datasource.views[0]) === null || _attrs$datasource$vie === void 0 || (_attrs$datasource$vie = _attrs$datasource$vie.properties) === null || _attrs$datasource$vie === void 0 ? void 0 : _attrs$datasource$vie.columns.map((c)=>c.key);
            return {
                parameters: parameters,
                visibleColumnKeys: visibleColumnKeys
            };
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    }, [
        node.attrs
    ]);
    const { extensionKey: extensionKey } = (0, $3JSsy.useFetchDatasourceDataInfo)({
        datasourceId: datasourceId,
        parameters: fetchData === null || fetchData === void 0 ? void 0 : fetchData.parameters,
        visibleColumnKeys: fetchData === null || fetchData === void 0 ? void 0 : fetchData.visibleColumnKeys
    });
    const editVariant = (0, $bSJIT.useMemo)(()=>{
        if (!datasourceId || !(0, $cKhMH.isDatasourceConfigEditable)(datasourceId)) return 'none';
        return 'edit-datasource';
    }, [
        datasourceId
    ]);
    return /*#__PURE__*/ (0, $9dQre.jsx)((0, $gel6b.default), {
        datasourceId: datasourceId,
        currentAppearance: currentAppearance,
        editorAnalyticsApi: editorAnalyticsApi,
        editVariant: editVariant,
        editorView: editorView,
        extensionKey: extensionKey,
        onLinkEditClick: onLinkEditClick,
        intl: intl,
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    });
};
const $74f9e01d7b87600f$export$4f24788e7d04736b = (props)=>{
    const { currentAppearance: currentAppearance, datasourceId: datasourceId, editorAnalyticsApi: editorAnalyticsApi, editorView: editorView, intl: intl, onLinkEditClick: onLinkEditClick, url: url, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled } = props;
    const cardContext = (0, $6bOBo.useSmartLinkContext)();
    if (props.url) return /*#__PURE__*/ (0, $9dQre.jsx)($74f9e01d7b87600f$var$EditToolbarButtonWithUrl, {
        datasourceId: datasourceId,
        url: props.url,
        intl: intl,
        editorAnalyticsApi: editorAnalyticsApi,
        editorView: editorView,
        cardContext: cardContext,
        onLinkEditClick: onLinkEditClick,
        currentAppearance: currentAppearance,
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    });
    if (props.datasourceId && props.node) return /*#__PURE__*/ (0, $9dQre.jsx)($74f9e01d7b87600f$var$EditToolbarButtonWithDatasourceId, {
        datasourceId: props.datasourceId,
        node: props.node,
        intl: intl,
        editorAnalyticsApi: editorAnalyticsApi,
        editorView: editorView,
        onLinkEditClick: onLinkEditClick,
        currentAppearance: currentAppearance,
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    });
    return /*#__PURE__*/ (0, $9dQre.jsx)($74f9e01d7b87600f$var$EditToolbarButtonWithCardContext, {
        datasourceId: datasourceId,
        url: url,
        intl: intl,
        editorAnalyticsApi: editorAnalyticsApi,
        editorView: editorView,
        cardContext: cardContext,
        onLinkEditClick: onLinkEditClick,
        currentAppearance: currentAppearance,
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    });
};

});
parcelRegister("2Bpgx", function(module, exports) {
$parcel$export(module.exports, "default", () => $7dac8b00e7a19114$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled, @typescript-eslint/consistent-type-imports -- Ignored via go/DSP-18766; jsx required at runtime for @jsxRuntime classic

var $9dQre = parcelRequire("9dQre");
function $7dac8b00e7a19114$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7dac8b00e7a19114$var$separator = /*#__PURE__*/ (0, $9dQre.css)({
    background: "var(--ds-border, #0B120E24)",
    width: '1px',
    height: '20px',
    margin: `0 ${"var(--ds-space-050, 4px)"}`,
    alignSelf: 'center'
});
const $7dac8b00e7a19114$var$separatorNew = {
    name: "pange0",
    styles: "background:var(--ds-border, #0B120E24);width:1px;height:20px;align-self:center"
};
const $7dac8b00e7a19114$var$separatorFullHeight = {
    name: "1k18kha",
    styles: "height:40px"
};
var $7dac8b00e7a19114$export$2e2bcd8739ae039 = ({ fullHeight: fullHeight, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled })=>/*#__PURE__*/ (0, $9dQre.jsx)("div", {
        css: [
            areAnyNewToolbarFlagsEnabled ? $7dac8b00e7a19114$var$separatorNew : $7dac8b00e7a19114$var$separator,
            fullHeight && $7dac8b00e7a19114$var$separatorFullHeight
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "separator"
    });

});

parcelRegister("8VMcp", function(module, exports) {
$parcel$export(module.exports, "editDatasource", () => $300d51aad5398521$export$687401cc190b9ec3);

var $g6Qq4 = parcelRequire("g6Qq4");

var $1wpTP = parcelRequire("1wpTP");

var $k5X6V = parcelRequire("k5X6V");
const $300d51aad5398521$export$687401cc190b9ec3 = (datasourceId, editorAnalyticsApi, appearance, extensionKey)=>(state, dispatch)=>{
        const datasourceType = (0, $1wpTP.getDatasourceType)(datasourceId);
        if (dispatch && datasourceType) {
            const { tr: tr } = state;
            (0, $k5X6V.showDatasourceModal)(datasourceType)(tr);
            editorAnalyticsApi === null || editorAnalyticsApi === void 0 || editorAnalyticsApi.attachAnalyticsEvent({
                action: (0, $g6Qq4.ACTION).CLICKED,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).BUTTON,
                actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).EDIT_DATASOURCE,
                eventType: (0, $g6Qq4.EVENT_TYPE).UI,
                attributes: {
                    extensionKey: extensionKey,
                    appearance: appearance
                }
            })(tr);
            dispatch(tr);
            return true;
        }
        return false;
    };

});

parcelRegister("3JSsy", function(module, exports) {
$parcel$export(module.exports, "useFetchDatasourceDataInfo", () => $d369f8a50a9458d0$export$25222ec28f4cbba5);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $jX24c = parcelRequire("jX24c");
const $d369f8a50a9458d0$export$25222ec28f4cbba5 = ({ datasourceId: datasourceId, parameters: parameters, visibleColumnKeys: visibleColumnKeys })=>{
    const [extensionKey, setExtensionKey] = (0, $bSJIT.useState)(undefined);
    const { getDatasourceData: getDatasourceData } = (0, $jX24c.useDatasourceClientExtension)();
    (0, $bSJIT.useEffect)(()=>{
        const fetchDatasource = async ()=>{
            try {
                if (!datasourceId || !parameters || !visibleColumnKeys) return;
                const datasourceDataRequest = {
                    parameters: parameters,
                    pageSize: (0, $jX24c.DEFAULT_GET_DATASOURCE_DATA_PAGE_SIZE),
                    pageCursor: undefined,
                    fields: visibleColumnKeys,
                    includeSchema: true
                };
                const { meta: meta } = await getDatasourceData(datasourceId, datasourceDataRequest, false);
                setExtensionKey(meta.extensionKey);
            } catch (e) {
                // eslint-disable-next-line no-console
                console.error(e);
                setExtensionKey(undefined);
            }
        };
        fetchDatasource();
    }, [
        getDatasourceData,
        visibleColumnKeys,
        parameters,
        datasourceId
    ]);
    return {
        extensionKey: extensionKey
    };
};

});

parcelRegister("gel6b", function(module, exports) {
$parcel$export(module.exports, "default", () => $32ce2bcf95d59414$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $5cKiX = parcelRequire("5cKiX");

var $7HjEm = parcelRequire("7HjEm");

var $2Bpgx = parcelRequire("2Bpgx");

var $278lv = parcelRequire("278lv");

var $ejFiy = parcelRequire("ejFiy");

var $imBU3 = parcelRequire("imBU3");

var $6bWVw = parcelRequire("6bWVw");

var $4GWyU = parcelRequire("4GWyU");

var $5Uddy = parcelRequire("5Uddy");

var $kpgiw = parcelRequire("kpgiw");

var $6X9z7 = parcelRequire("6X9z7");

var $cKhMH = parcelRequire("cKhMH");

var $8VMcp = parcelRequire("8VMcp");
const $32ce2bcf95d59414$var$dropdownExpandContainer = /*#__PURE__*/ (0, $9dQre.css)({
    margin: `0px ${"var(--ds-space-negative-050, -4px)"}`
});
const $32ce2bcf95d59414$var$EditToolbarButtonPresentation = ({ datasourceId: datasourceId, currentAppearance: currentAppearance, editorAnalyticsApi: editorAnalyticsApi, editVariant: editVariant, editorView: editorView, extensionKey: extensionKey, onLinkEditClick: onLinkEditClick, intl: intl, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled })=>{
    const [isOpen, setIsOpen] = (0, $bSJIT.useState)(false);
    const containerRef = (0, $bSJIT.useRef)();
    const toggleOpen = ()=>setIsOpen((open)=>!open);
    const onClose = ()=>setIsOpen(false);
    const onEditLink = (0, $bSJIT.useCallback)(()=>{
        if (editorView) {
            onLinkEditClick(editorView.state, editorView.dispatch);
            (0, $cKhMH.focusEditorView)(editorView);
        }
    }, [
        editorView,
        onLinkEditClick
    ]);
    const onEditDatasource = (0, $bSJIT.useCallback)(()=>{
        if (editorView && datasourceId) {
            (0, $8VMcp.editDatasource)(datasourceId, editorAnalyticsApi, currentAppearance, extensionKey)(editorView.state, editorView.dispatch);
            (0, $cKhMH.focusEditorView)(editorView);
        }
    }, [
        currentAppearance,
        datasourceId,
        editorAnalyticsApi,
        editorView,
        extensionKey
    ]);
    const icon = areAnyNewToolbarFlagsEnabled ? /*#__PURE__*/ (0, $9dQre.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5Uddy))), {
        label: ""
    }) : undefined;
    const tooltipContent = areAnyNewToolbarFlagsEnabled ? intl.formatMessage((0, $ejFiy.linkToolbarMessages).editLink) : undefined;
    switch(editVariant){
        case 'edit-link':
            return /*#__PURE__*/ (0, $9dQre.jsx)((0, $6X9z7.Flex), {
                gap: "space.050"
            }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $7HjEm.default), {
                testId: "edit-link",
                onClick: onEditLink,
                icon: icon,
                ariaLabel: areAnyNewToolbarFlagsEnabled ? intl.formatMessage((0, $ejFiy.linkToolbarMessages).editLink) : undefined,
                tooltipContent: tooltipContent,
                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
            }, !areAnyNewToolbarFlagsEnabled && /*#__PURE__*/ (0, $9dQre.jsx)((0, $5cKiX.default), (0, $ejFiy.linkToolbarMessages).editLink)), !areAnyNewToolbarFlagsEnabled && /*#__PURE__*/ (0, $9dQre.jsx)((0, $2Bpgx.default), {
                areAnyNewToolbarFlagsEnabled: false
            }));
        case 'edit-datasource':
            return /*#__PURE__*/ (0, $9dQre.jsx)((0, $6X9z7.Flex), {
                gap: "space.050"
            }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $7HjEm.default), {
                testId: "edit-datasource",
                tooltipContent: intl.formatMessage((0, $ejFiy.linkToolbarMessages).editDatasourceStandaloneTooltip),
                onClick: onEditDatasource,
                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
            }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $5cKiX.default), (0, $ejFiy.linkToolbarMessages).editDatasourceStandalone)), !areAnyNewToolbarFlagsEnabled && /*#__PURE__*/ (0, $9dQre.jsx)((0, $2Bpgx.default), {
                areAnyNewToolbarFlagsEnabled: false
            }));
        case 'edit-dropdown':
            {
                const trigger = /*#__PURE__*/ (0, $9dQre.jsx)((0, $6X9z7.Flex), {
                    gap: "space.050"
                }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $7HjEm.default), {
                    testId: "edit-dropdown-trigger",
                    iconAfter: /*#__PURE__*/ (0, $9dQre.jsx)("span", {
                        css: $32ce2bcf95d59414$var$dropdownExpandContainer
                    }, /*#__PURE__*/ (0, $9dQre.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4GWyU))), {
                        label: intl.formatMessage((0, $278lv.messages).editDropdownTriggerTitle),
                        size: "small"
                    })),
                    onClick: toggleOpen,
                    selected: isOpen,
                    disabled: false,
                    ariaHasPopup: true,
                    areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
                }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $5cKiX.default), (0, $278lv.messages).editDropdownTriggerTitle)), !areAnyNewToolbarFlagsEnabled && /*#__PURE__*/ (0, $9dQre.jsx)((0, $2Bpgx.default), {
                    areAnyNewToolbarFlagsEnabled: false
                }));
                return /*#__PURE__*/ (0, $9dQre.jsx)((0, $6X9z7.Flex), {
                    ref: containerRef
                }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $6bWVw.DropdownContainer), {
                    mountTo: containerRef.current,
                    isOpen: isOpen,
                    handleClickOutside: onClose,
                    handleEscapeKeydown: onClose,
                    trigger: trigger,
                    scrollableElement: containerRef.current,
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    arrowKeyNavigationProviderOptions: {
                        type: (0, $imBU3.ArrowKeyNavigationType).MENU
                    }
                }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $kpgiw.default), {
                    key: "edit.link",
                    onClick: onEditLink,
                    testId: "edit-dropdown-edit-link-item"
                }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $5cKiX.default), (0, $278lv.messages).editDropdownEditLinkTitle)), /*#__PURE__*/ (0, $9dQre.jsx)((0, $kpgiw.default), {
                    key: "edit.datasource",
                    onClick: onEditDatasource,
                    testId: "edit-dropdown-edit-datasource-item"
                }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $5cKiX.default), (0, $278lv.messages).editDropdownEditDatasourceTitle))));
            }
        case 'none':
        default:
            return null;
    }
};
var $32ce2bcf95d59414$export$2e2bcd8739ae039 = $32ce2bcf95d59414$var$EditToolbarButtonPresentation;

});


parcelRegister("8OKVL", function(module, exports) {
$parcel$export(module.exports, "HyperlinkToolbarAppearance", () => $9450d024c2b050e5$export$33d351e602b13f5c);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $g6Qq4 = parcelRequire("g6Qq4");

var $2Bpgx = parcelRequire("2Bpgx");

var $8qHhy = parcelRequire("8qHhy");

var $6X9z7 = parcelRequire("6X9z7");

var $hU1ZA = parcelRequire("hU1ZA");

var $5Zj7S = parcelRequire("5Zj7S");
function $9450d024c2b050e5$export$33d351e602b13f5c(props) {
    var _props$cardOptions3, _props$editorPluginAp2;
    const [supportedUrlsMap, setSupportedUrlsMap] = (0, $bSJIT.useState)(new Map());
    const cardProvider = (0, $bSJIT.useRef)(undefined);
    const { url: url, intl: intl, editorView: editorView, editorState: editorState, cardOptions: cardOptions, editorAnalyticsApi: editorAnalyticsApi } = props;
    // Ignored via go/ees005
    // eslint-disable-next-line require-await
    const getProvider = async ()=>{
        var _props$cardOptions;
        if ((_props$cardOptions = props.cardOptions) !== null && _props$cardOptions !== void 0 && _props$cardOptions.provider) {
            var _props$cardOptions2;
            return (_props$cardOptions2 = props.cardOptions) === null || _props$cardOptions2 === void 0 ? void 0 : _props$cardOptions2.provider;
        }
        if (cardProvider.current) return cardProvider.current;
        return new Promise((resolve)=>{
            var _props$editorPluginAp;
            const cardProvider = (_props$editorPluginAp = props.editorPluginApi) === null || _props$editorPluginAp === void 0 || (_props$editorPluginAp = _props$editorPluginAp.card) === null || _props$editorPluginAp === void 0 || (_props$editorPluginAp = _props$editorPluginAp.sharedState) === null || _props$editorPluginAp === void 0 || (_props$editorPluginAp = _props$editorPluginAp.currentState()) === null || _props$editorPluginAp === void 0 ? void 0 : _props$editorPluginAp.provider;
            if (cardProvider) resolve(cardProvider);
        });
    };
    const resolveUrl = async (url)=>{
        if (supportedUrlsMap.has(url)) return;
        let isUrlSupported = false;
        try {
            const provider = await getProvider();
            isUrlSupported = await (provider === null || provider === void 0 ? void 0 : provider.findPattern(url)) ?? false;
        } catch (error) {
            isUrlSupported = false;
        }
        const newMap = new Map(supportedUrlsMap);
        newMap.set(url, isUrlSupported);
        setSupportedUrlsMap(newMap);
    };
    (0, $bSJIT.useEffect)(()=>{
        resolveUrl(url);
    // before migrating from a class to a functional component, we were only reacting to changes in the url
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        url,
        (_props$cardOptions3 = props.cardOptions) === null || _props$cardOptions3 === void 0 ? void 0 : _props$cardOptions3.provider,
        props.editorPluginApi
    ]);
    if (!supportedUrlsMap.get(url)) return null;
    const areAnyNewToolbarFlagsEnabled = (0, $8qHhy.areToolbarFlagsEnabled)(Boolean((_props$editorPluginAp2 = props.editorPluginApi) === null || _props$editorPluginAp2 === void 0 ? void 0 : _props$editorPluginAp2.toolbar));
    return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $6X9z7.Flex), {
        children: [
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $5Zj7S.LinkToolbarAppearance), {
                url: url,
                intl: intl,
                editorView: editorView,
                editorState: editorState,
                allowEmbeds: cardOptions === null || cardOptions === void 0 ? void 0 : cardOptions.allowEmbeds,
                allowBlockCards: cardOptions === null || cardOptions === void 0 ? void 0 : cardOptions.allowBlockCards,
                editorAnalyticsApi: editorAnalyticsApi,
                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
            }, "link-appearance"),
            (cardOptions === null || cardOptions === void 0 ? void 0 : cardOptions.allowDatasource) && /*#__PURE__*/ (0, $dc70d.jsx)((0, $hU1ZA.DatasourceAppearanceButton), {
                intl: intl,
                url: url,
                editorState: editorState,
                editorView: editorView,
                editorAnalyticsApi: editorAnalyticsApi,
                inputMethod: (0, $g6Qq4.INPUT_METHOD).FLOATING_TB,
                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $2Bpgx.default), {
                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
            })
        ]
    });
}

});
parcelRegister("5Zj7S", function(module, exports) {
$parcel$export(module.exports, "LinkToolbarAppearance", () => $87725f2d8393e29a$export$2a8c6fb42753b13e);
$parcel$export(module.exports, "getUnavailableMessage", () => $87725f2d8393e29a$export$74e77d31eb18de27);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $dwOcU = parcelRequire("dwOcU");

var $g6Qq4 = parcelRequire("g6Qq4");

var $di9NP = parcelRequire("di9NP");

var $1MyyG = parcelRequire("1MyyG");

var $hGzMn = parcelRequire("hGzMn");

var $fNLdd = parcelRequire("fNLdd");

var $278lv = parcelRequire("278lv");

var $kRFDj = parcelRequire("kRFDj");

var $kW8qW = parcelRequire("kW8qW");

var $a76m2 = parcelRequire("a76m2");

var $cKhMH = parcelRequire("cKhMH");

var $a2gwZ = parcelRequire("a2gwZ");

var $kf36C = parcelRequire("kf36C");

var $cFebM = parcelRequire("cFebM");

var $83npI = parcelRequire("83npI");
class $87725f2d8393e29a$export$2a8c6fb42753b13e extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Component {
    render() {
        const { editorView: editorView } = this.props;
        return /*#__PURE__*/ (0, $dc70d.jsx)((0, $83npI.WithCardContext), {
            children: (cardContext)=>this.renderDropdown(editorView, cardContext && cardContext.value)
        });
    }
    constructor(...args){
        super(...args), this.renderDropdown = (view, cardContext)=>{
            var _cardContext$store2;
            const { url: url, intl: intl, currentAppearance: currentAppearance, editorState: editorState, allowEmbeds: allowEmbeds, allowBlockCards: allowBlockCards = true, editorAnalyticsApi: editorAnalyticsApi, showUpgradeDiscoverability: showUpgradeDiscoverability = true, isDatasourceView: isDatasourceView, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled } = this.props;
            const preview = allowEmbeds && cardContext && url && cardContext.extractors.getPreview(url, 'web');
            const defaultCommand = ()=>false;
            if (url) {
                var _cardContext$store, _urlState$error;
                const urlState = cardContext === null || cardContext === void 0 || (_cardContext$store = cardContext.store) === null || _cardContext$store === void 0 ? void 0 : _cardContext$store.getState()[url];
                if ((urlState === null || urlState === void 0 || (_urlState$error = urlState.error) === null || _urlState$error === void 0 ? void 0 : _urlState$error.kind) === 'fatal') return null;
            }
            const isBlockCardLinkSupportedInParent = allowBlockCards ? (0, $kRFDj.isSupportedInParent)(editorState, (0, $kW8qW.Fragment).from(editorState.schema.nodes.blockCard.createChecked({})), currentAppearance) : false;
            const isEmbedCardLinkSupportedInParent = allowEmbeds ? (0, $kRFDj.isSupportedInParent)(editorState, (0, $kW8qW.Fragment).from(editorState.schema.nodes.embedCard.createChecked({})), currentAppearance) : false;
            const embedOption = allowEmbeds && preview && {
                appearance: 'embed',
                title: intl.formatMessage((0, $278lv.messages).embed),
                onClick: (0, $a76m2.setSelectedCardAppearance)('embed', editorAnalyticsApi) ?? defaultCommand,
                selected: currentAppearance === 'embed',
                hidden: false,
                testId: 'embed-appearance',
                disabled: !isEmbedCardLinkSupportedInParent,
                tooltip: isEmbedCardLinkSupportedInParent ? undefined : $87725f2d8393e29a$export$74e77d31eb18de27(editorState, intl)
            };
            const blockCardOption = allowBlockCards && {
                appearance: 'block',
                title: intl.formatMessage((0, $278lv.messages).block),
                onClick: (0, $a76m2.setSelectedCardAppearance)('block', editorAnalyticsApi) ?? defaultCommand,
                selected: currentAppearance === 'block' && !isDatasourceView,
                testId: 'block-appearance',
                disabled: !isBlockCardLinkSupportedInParent,
                tooltip: isBlockCardLinkSupportedInParent ? undefined : $87725f2d8393e29a$export$74e77d31eb18de27(editorState, intl)
            };
            const options = [
                {
                    title: intl.formatMessage((0, $278lv.messages).url),
                    onClick: (0, $hGzMn.commandWithMetadata)((0, $a76m2.changeSelectedCardToLink)(url, url, true, undefined, undefined, editorAnalyticsApi) ?? defaultCommand, {
                        action: (0, $g6Qq4.ACTION).CHANGED_TYPE
                    }),
                    selected: !currentAppearance && !isDatasourceView,
                    testId: 'url-appearance'
                },
                {
                    appearance: 'inline',
                    title: intl.formatMessage((0, $278lv.messages).inline),
                    onClick: (0, $a76m2.setSelectedCardAppearance)('inline', editorAnalyticsApi) ?? defaultCommand,
                    selected: currentAppearance === 'inline',
                    testId: 'inline-appearance'
                }
            ];
            const dispatchCommand = (fn)=>{
                fn && fn(editorState, view && view.dispatch);
                // Refocus the view to ensure the editor has focus
                if (view && !view.hasFocus()) view.focus();
            };
            if (blockCardOption) options.push(blockCardOption);
            if (embedOption) options.push(embedOption);
            const LinkToolbarButtons = /*#__PURE__*/ (0, $dc70d.jsx)((0, $1MyyG.LinkToolbarButtonGroup), {
                options: options.map((option)=>(0, $di9NP.getButtonGroupOption)(intl, areAnyNewToolbarFlagsEnabled, dispatchCommand, {
                        ...option,
                        onClick: (0, $hGzMn.commandWithMetadata)(option.onClick, {
                            inputMethod: (0, $g6Qq4.INPUT_METHOD).FLOATING_TB
                        })
                    }))
            }, "link-toolbar-button-group");
            const status = url ? cardContext === null || cardContext === void 0 || (_cardContext$store2 = cardContext.store) === null || _cardContext$store2 === void 0 || (_cardContext$store2 = _cardContext$store2.getState()[url]) === null || _cardContext$store2 === void 0 ? void 0 : _cardContext$store2.status : '';
            const embedEnabled = embedOption ? !embedOption.disabled : false;
            if ((0, $cFebM.shouldRenderToolbarPulse)(embedEnabled, currentAppearance ?? '', status ?? '', showUpgradeDiscoverability)) {
                const resolvedAnalyticsAttributes = (0, $cKhMH.getResolvedAttributesFromStore)(url || '', currentAppearance || null, cardContext === null || cardContext === void 0 ? void 0 : cardContext.store);
                return(// eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                /*#__PURE__*/ (0, $dc70d.jsx)((0, $dwOcU.default), {
                    data: {
                        attributes: {
                            ...resolvedAnalyticsAttributes
                        }
                    },
                    children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $kf36C.DiscoveryPulse), {
                        localStorageKey: (0, $a2gwZ.LOCAL_STORAGE_DISCOVERY_KEY_TOOLBAR),
                        testId: "toolbar-discovery-pulse",
                        children: LinkToolbarButtons
                    })
                }));
            }
            return LinkToolbarButtons;
        };
    }
}
const $87725f2d8393e29a$export$74e77d31eb18de27 = (state, intl)=>{
    try {
        const parentNode = state.selection.$from.node(1);
        const parentName = intl.formatMessage((0, $fNLdd.default)[parentNode.type.name]);
        const tooltip = intl.formatMessage((0, $278lv.messages).displayOptionUnavailableInParentNode, {
            node: parentName
        });
        return tooltip;
    } catch (e) {
        // eslint-disable-line no-unused-vars
        return intl.formatMessage((0, $278lv.messages).displayOptionUnavailableInParentNode, {
            node: intl.formatMessage((0, $fNLdd.default).defaultBlockNode)
        });
    }
};

});
parcelRegister("di9NP", function(module, exports) {
$parcel$export(module.exports, "getButtonGroupOption", () => $6bfe49e1ad9b39a0$export$9de0d67eaa25f178);

var $41dWF = parcelRequire("41dWF");
const $6bfe49e1ad9b39a0$export$9de0d67eaa25f178 = (intl, areAnyNewToolbarFlagsEnabled, dispatchCommand, { disabled: disabled, onClick: onClick, selected: selected, appearance: appearance, testId: testId, tooltip: tooltip })=>{
    const { title: title, icon: icon } = (0, $41dWF.appearancePropsMap)[appearance ?? 'url'];
    return {
        title: intl.formatMessage(title),
        icon: icon,
        onClick: ()=>dispatchCommand(onClick),
        disabled: Boolean(disabled),
        tooltipContent: tooltip || null,
        testId: testId,
        selected: selected,
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    };
};

});
parcelRegister("41dWF", function(module, exports) {
$parcel$export(module.exports, "appearancePropsMap", () => $5e890c8b3e4afdc5$export$b5524c7a5a82630a);

var $g3Ytr = parcelRequire("g3Ytr");

var $lWuWs = parcelRequire("lWuWs");

var $lqWtA = parcelRequire("lqWtA");

var $jaXwU = parcelRequire("jaXwU");

var $278lv = parcelRequire("278lv");
const $5e890c8b3e4afdc5$export$b5524c7a5a82630a = {
    url: {
        title: (0, $278lv.messages).urlTitle,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($g3Ytr)))
    },
    inline: {
        title: (0, $278lv.messages).inlineTitle,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jaXwU)))
    },
    block: {
        title: (0, $278lv.messages).blockTitle,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lWuWs)))
    },
    embed: {
        title: (0, $278lv.messages).embedTitle,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lqWtA)))
    }
};

});


parcelRegister("1MyyG", function(module, exports) {
$parcel$export(module.exports, "LinkToolbarButtonGroup", () => $eab0df604b55a17a$export$41ba5f90e13b0c51);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $f1bHg = parcelRequire("f1bHg");

var $7HjEm = parcelRequire("7HjEm");
function $eab0df604b55a17a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
/**
 * Applying `pointer-events: none;` when disabled allows the Tooltip to be displayed
 */ const $eab0df604b55a17a$var$buttonStyle = {
    name: "1quw0ni",
    styles: "pointer-events:auto"
};
const $eab0df604b55a17a$var$buttonStyleNoneEvent = {
    name: "je8g23",
    styles: "pointer-events:none"
};
const $eab0df604b55a17a$var$DisallowedWrapper = ({ disabled: disabled, children: children })=>{
    return /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        css: disabled ? $eab0df604b55a17a$var$disallowedWrapperStyle : $eab0df604b55a17a$var$defaultWrapperStyle
    }, children);
};
/**
 * The button requires `pointer-events: none;` in order to fix the tooltip, hence
 * leaving us without a disabled cursor, the following fixes this:
 */ const $eab0df604b55a17a$var$defaultWrapperStyle = {
    name: "e0dnmk",
    styles: "cursor:pointer"
};
const $eab0df604b55a17a$var$disallowedWrapperStyle = {
    name: "1sfig4b",
    styles: "cursor:not-allowed"
};
const $eab0df604b55a17a$export$41ba5f90e13b0c51 = ({ options: options })=>{
    return /*#__PURE__*/ (0, $9dQre.jsx)((0, $f1bHg.default), null, options.map(({ onClick: onClick, selected: selected, disabled: disabled, testId: testId, tooltipContent: tooltipContent, title: title, icon: icon, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled })=>{
        const ButtonIcon = icon;
        return /*#__PURE__*/ (0, $9dQre.jsx)($eab0df604b55a17a$var$DisallowedWrapper, {
            key: testId,
            disabled: disabled
        }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $7HjEm.default), {
            css: disabled ? $eab0df604b55a17a$var$buttonStyleNoneEvent : $eab0df604b55a17a$var$buttonStyle,
            title: title,
            icon: /*#__PURE__*/ (0, $9dQre.jsx)(ButtonIcon, {
                label: title,
                spacing: "spacious"
            }),
            selected: selected,
            onClick: onClick,
            testId: testId,
            disabled: disabled,
            tooltipContent: tooltipContent,
            areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
        }));
    }));
};

});



parcelRegister("9owK5", function(module, exports) {
$parcel$export(module.exports, "getCustomHyperlinkAppearanceDropdown", () => $dfedc50ace198dd6$export$5b48c4cfa5ad82e1);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $41dWF = parcelRequire("41dWF");

var $7HjEm = parcelRequire("7HjEm");

var $2Bpgx = parcelRequire("2Bpgx");

var $8qHhy = parcelRequire("8qHhy");

var $imBU3 = parcelRequire("imBU3");

var $6bWVw = parcelRequire("6bWVw");

var $4GWyU = parcelRequire("4GWyU");

var $6X9z7 = parcelRequire("6X9z7");

var $e2l6k = parcelRequire("e2l6k");
const $dfedc50ace198dd6$var$CustomHyperlinkDropdown = (props)=>{
    var _props$editorPluginAp, _props$cardOptions3, _props$editorPluginAp3, _props$editorPluginAp4;
    const [supportedUrlsMap, setSupportedUrlsMap] = (0, $bSJIT.useState)(new Map());
    const [isOpen, setIsOpen] = (0, $bSJIT.useState)(false);
    const cardProvider = (0, $bSJIT.useRef)(undefined);
    const containerRef = (0, $bSJIT.useRef)(undefined);
    const areAnyNewToolbarFlagsEnabled = (0, $8qHhy.areToolbarFlagsEnabled)(Boolean((_props$editorPluginAp = props.editorPluginApi) === null || _props$editorPluginAp === void 0 ? void 0 : _props$editorPluginAp.toolbar));
    const { url: url, intl: intl, editorView: editorView, cardOptions: cardOptions, editorAnalyticsApi: editorAnalyticsApi, allowDatasource: allowDatasource, isDatasourceView: isDatasourceView, settingsConfig: settingsConfig } = props;
    // Ignored via go/ees005
    // eslint-disable-next-line require-await
    const getProvider = async ()=>{
        var _props$cardOptions;
        if ((_props$cardOptions = props.cardOptions) !== null && _props$cardOptions !== void 0 && _props$cardOptions.provider) {
            var _props$cardOptions2;
            return (_props$cardOptions2 = props.cardOptions) === null || _props$cardOptions2 === void 0 ? void 0 : _props$cardOptions2.provider;
        }
        if (cardProvider.current) return cardProvider.current;
        return new Promise((resolve)=>{
            var _props$editorPluginAp2;
            const cardProvider = (_props$editorPluginAp2 = props.editorPluginApi) === null || _props$editorPluginAp2 === void 0 || (_props$editorPluginAp2 = _props$editorPluginAp2.card) === null || _props$editorPluginAp2 === void 0 || (_props$editorPluginAp2 = _props$editorPluginAp2.sharedState) === null || _props$editorPluginAp2 === void 0 || (_props$editorPluginAp2 = _props$editorPluginAp2.currentState()) === null || _props$editorPluginAp2 === void 0 ? void 0 : _props$editorPluginAp2.provider;
            if (cardProvider) resolve(cardProvider);
        });
    };
    const resolveUrl = async (url)=>{
        if (supportedUrlsMap.has(url)) return;
        let isUrlSupported = false;
        try {
            const provider = await getProvider();
            isUrlSupported = await (provider === null || provider === void 0 ? void 0 : provider.findPattern(url)) ?? false;
        } catch (error) {
            // eslint-disable-line no-unused-vars
            isUrlSupported = false;
        }
        const newMap = new Map(supportedUrlsMap);
        newMap.set(url, isUrlSupported);
        setSupportedUrlsMap(newMap);
    };
    (0, $bSJIT.useEffect)(()=>{
        resolveUrl(url);
    // before migrating from a class to a functional component, we were only reacting to changes in the url
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        url,
        (_props$cardOptions3 = props.cardOptions) === null || _props$cardOptions3 === void 0 ? void 0 : _props$cardOptions3.provider,
        props.editorPluginApi
    ]);
    if (!supportedUrlsMap.get(url)) return null;
    if (!editorView) return null;
    const dispatchCommand = (fn)=>{
        fn && fn(editorView && editorView.state, editorView && editorView.dispatch, editorView);
        // Refocus the view to ensure the editor has focus
        if (editorView && !editorView.hasFocus()) editorView.focus();
    };
    const toggleOpen = ()=>setIsOpen((open)=>!open);
    const close = ()=>setIsOpen(false);
    const currentAppearanceDisplayInformation = (0, $41dWF.appearancePropsMap)['url'];
    const title = intl.formatMessage(currentAppearanceDisplayInformation.title);
    const trigger = /*#__PURE__*/ (0, $dc70d.jsx)((0, $7HjEm.default), {
        selected: isOpen,
        title: title,
        "aria-label": title,
        "aria-expanded": isOpen,
        "aria-haspopup": true,
        onClick: toggleOpen,
        icon: currentAppearanceDisplayInformation.icon({
            label: ''
        }),
        iconAfter: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4GWyU))), {
            label: "",
            spacing: "compact",
            size: "small"
        }),
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled,
        children: title
    });
    return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $6X9z7.Flex), {
        ref: containerRef,
        gap: "space.075",
        children: [
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $6bWVw.DropdownContainer), {
                mountTo: containerRef.current,
                isOpen: isOpen,
                handleClickOutside: close,
                handleEscapeKeydown: close,
                trigger: trigger,
                scrollableElement: containerRef.current,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                arrowKeyNavigationProviderOptions: {
                    type: (0, $imBU3.ArrowKeyNavigationType).MENU
                },
                fitHeight: 400,
                fitWidth: 200,
                children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $e2l6k.LinkAppearanceMenu), {
                    url: url,
                    intl: intl,
                    currentAppearance: undefined,
                    editorState: editorView.state,
                    allowEmbeds: cardOptions === null || cardOptions === void 0 ? void 0 : cardOptions.allowEmbeds,
                    allowBlockCards: cardOptions === null || cardOptions === void 0 ? void 0 : cardOptions.allowBlockCards,
                    editorAnalyticsApi: editorAnalyticsApi,
                    isDatasourceView: isDatasourceView,
                    allowDatasource: allowDatasource,
                    dispatchCommand: dispatchCommand,
                    settingsConfig: settingsConfig,
                    areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
                })
            }),
            !(0, $8qHhy.areToolbarFlagsEnabled)(Boolean((_props$editorPluginAp3 = props.editorPluginApi) === null || _props$editorPluginAp3 === void 0 ? void 0 : _props$editorPluginAp3.toolbar)) && /*#__PURE__*/ (0, $dc70d.jsx)((0, $2Bpgx.default), {
                areAnyNewToolbarFlagsEnabled: (0, $8qHhy.areToolbarFlagsEnabled)(Boolean((_props$editorPluginAp4 = props.editorPluginApi) === null || _props$editorPluginAp4 === void 0 ? void 0 : _props$editorPluginAp4.toolbar))
            })
        ]
    });
};
const $dfedc50ace198dd6$export$5b48c4cfa5ad82e1 = ({ url: url, intl: intl, editorAnalyticsApi: editorAnalyticsApi, editorPluginApi: editorPluginApi, settingsConfig: settingsConfig, cardOptions: cardOptions, allowDatasource: allowDatasource, isDatasourceView: isDatasourceView })=>{
    return {
        type: 'custom',
        fallback: [],
        render: (editorView)=>{
            if (!editorView) return;
            return /*#__PURE__*/ (0, $dc70d.jsx)($dfedc50ace198dd6$var$CustomHyperlinkDropdown, {
                intl: intl,
                url: url,
                editorAnalyticsApi: editorAnalyticsApi,
                editorPluginApi: editorPluginApi,
                editorView: editorView,
                settingsConfig: settingsConfig,
                cardOptions: cardOptions,
                allowDatasource: allowDatasource,
                isDatasourceView: isDatasourceView
            });
        }
    };
};

});
parcelRegister("e2l6k", function(module, exports) {
$parcel$export(module.exports, "LinkAppearanceMenu", () => $d55e30b07c45ef36$export$6ce0ca681c51cdfb);
$parcel$export(module.exports, "getLinkAppearanceDropdown", () => $d55e30b07c45ef36$export$1faf5b64d0bbe935);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $g6Qq4 = parcelRequire("g6Qq4");

var $41dWF = parcelRequire("41dWF");

var $9a1Je = parcelRequire("9a1Je");

var $hGzMn = parcelRequire("hGzMn");

var $278lv = parcelRequire("278lv");

var $ejFiy = parcelRequire("ejFiy");

var $kRFDj = parcelRequire("kRFDj");

var $kW8qW = parcelRequire("kW8qW");

var $6TyVm = parcelRequire("6TyVm");

var $kpgiw = parcelRequire("kpgiw");

var $682kQ = parcelRequire("682kQ");

var $65Fe1 = parcelRequire("65Fe1");

var $7LtMZ = parcelRequire("7LtMZ");

var $797yE = parcelRequire("797yE");

var $a76m2 = parcelRequire("a76m2");

var $7kos7 = parcelRequire("7kos7");

var $5Zj7S = parcelRequire("5Zj7S");
const $d55e30b07c45ef36$export$6ce0ca681c51cdfb = ({ url: url, intl: intl, currentAppearance: currentAppearance, editorState: editorState, allowEmbeds: allowEmbeds, allowBlockCards: allowBlockCards = true, allowDatasource: allowDatasource, editorAnalyticsApi: editorAnalyticsApi, isDatasourceView: isDatasourceView, dispatchCommand: dispatchCommand, settingsConfig: settingsConfig })=>{
    var _cardContext$value;
    const cardContext = (0, $6TyVm.useSmartCardContext)();
    const preview = allowEmbeds && cardContext && url && ((_cardContext$value = cardContext.value) === null || _cardContext$value === void 0 ? void 0 : _cardContext$value.extractors.getPreview(url, 'web'));
    const defaultCommand = ()=>false;
    if (url) {
        var _cardContext$value2, _urlState$error;
        const urlState = (_cardContext$value2 = cardContext.value) === null || _cardContext$value2 === void 0 || (_cardContext$value2 = _cardContext$value2.store) === null || _cardContext$value2 === void 0 ? void 0 : _cardContext$value2.getState()[url];
        if ((urlState === null || urlState === void 0 || (_urlState$error = urlState.error) === null || _urlState$error === void 0 ? void 0 : _urlState$error.kind) === 'fatal') return null;
    }
    const isBlockCardLinkSupportedInParent = allowBlockCards ? (0, $kRFDj.isSupportedInParent)(editorState, (0, $kW8qW.Fragment).from(editorState.schema.nodes.blockCard.createChecked({})), currentAppearance) : false;
    const isEmbedCardLinkSupportedInParent = allowEmbeds ? (0, $kRFDj.isSupportedInParent)(editorState, (0, $kW8qW.Fragment).from(editorState.schema.nodes.embedCard.createChecked({})), currentAppearance) : false;
    const embedOption = allowEmbeds && preview && {
        appearance: 'embed',
        title: intl.formatMessage((0, $278lv.messages).embed),
        onClick: (0, $a76m2.setSelectedCardAppearance)('embed', editorAnalyticsApi) ?? defaultCommand,
        selected: currentAppearance === 'embed',
        hidden: false,
        testId: 'embed-appearance',
        disabled: !isEmbedCardLinkSupportedInParent,
        tooltip: isEmbedCardLinkSupportedInParent ? undefined : (0, $5Zj7S.getUnavailableMessage)(editorState, intl),
        description: (0, $797yE.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
            exposure: true
        }) ? intl.formatMessage((0, $278lv.messages).embedToBlockCardWarning) : undefined
    };
    const blockCardOption = allowBlockCards && {
        appearance: 'block',
        title: intl.formatMessage((0, $278lv.messages).block),
        onClick: (0, $a76m2.setSelectedCardAppearance)('block', editorAnalyticsApi) ?? defaultCommand,
        selected: currentAppearance === 'block' && !isDatasourceView,
        testId: 'block-appearance',
        disabled: !isBlockCardLinkSupportedInParent,
        tooltip: isBlockCardLinkSupportedInParent ? undefined : (0, $5Zj7S.getUnavailableMessage)(editorState, intl)
    };
    const options = [
        {
            title: intl.formatMessage((0, $278lv.messages).url),
            onClick: (0, $hGzMn.commandWithMetadata)((0, $a76m2.changeSelectedCardToLink)(url, url, true, undefined, undefined, editorAnalyticsApi) ?? defaultCommand, {
                action: (0, $g6Qq4.ACTION).CHANGED_TYPE
            }),
            selected: !currentAppearance && !isDatasourceView,
            testId: 'url-appearance'
        },
        {
            appearance: 'inline',
            title: intl.formatMessage((0, $278lv.messages).inline),
            onClick: (0, $a76m2.setSelectedCardAppearance)('inline', editorAnalyticsApi) ?? defaultCommand,
            selected: currentAppearance === 'inline',
            testId: 'inline-appearance'
        }
    ];
    if (blockCardOption) options.push(blockCardOption);
    if (embedOption) options.push(embedOption);
    const finalOptions = options.map((option)=>(0, $9a1Je.getDropdownOption)(intl, dispatchCommand, {
            ...option,
            onClick: (0, $hGzMn.commandWithMetadata)(option.onClick, {
                inputMethod: (0, $g6Qq4.INPUT_METHOD).FLOATING_TB
            })
        }));
    let Icon;
    if ('icon' in settingsConfig && settingsConfig.icon !== undefined) Icon = settingsConfig.icon;
    // TODO: ED-26961 - packages/editor/editor-plugin-card/src/ui/LinkToolbarAppearance.tsx supports change boarding via pulse
    // this implementation doesn't
    return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $65Fe1.default), {
        children: [
            /*#__PURE__*/ (0, $dc70d.jsxs)((0, $7LtMZ.default), {
                children: [
                    finalOptions.map((option)=>{
                        return /*#__PURE__*/ (0, $dc70d.jsx)((0, $kpgiw.default), {
                            iconBefore: option.icon,
                            // eslint-disable-next-line @atlassian/perf-linting/detect-unnecessary-rerenders, @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                            onClick: ()=>option.onClick(),
                            isSelected: option.selected,
                            description: option.description,
                            shouldDescriptionWrap: true,
                            children: option.title
                        }, option.title);
                    }),
                    /*#__PURE__*/ (0, $dc70d.jsx)((0, $7kos7.DatasourceDropdownOption), {
                        allowDatasource: allowDatasource,
                        intl: intl,
                        url: url ?? '',
                        selected: Boolean(isDatasourceView),
                        inputMethod: (0, $g6Qq4.INPUT_METHOD).FLOATING_TB,
                        dispatchCommand: dispatchCommand
                    })
                ]
            }),
            'href' in settingsConfig && settingsConfig.href && /*#__PURE__*/ (0, $dc70d.jsx)((0, $7LtMZ.default), {
                hasSeparator: true,
                children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $682kQ.default), {
                    iconBefore: Icon && /*#__PURE__*/ (0, $dc70d.jsx)(Icon, {
                        label: "Settings"
                    }),
                    href: settingsConfig.href,
                    target: 'target' in settingsConfig ? settingsConfig.target : undefined,
                    children: intl.formatMessage((0, $ejFiy.linkToolbarMessages).preferencesLink)
                })
            })
        ]
    });
};
const $d55e30b07c45ef36$export$1faf5b64d0bbe935 = ({ url: url, intl: intl, currentAppearance: currentAppearance, editorState: editorState, allowEmbeds: allowEmbeds, allowBlockCards: allowBlockCards = true, allowDatasource: allowDatasource, editorAnalyticsApi: editorAnalyticsApi, showUpgradeDiscoverability: showUpgradeDiscoverability = true, isDatasourceView: isDatasourceView, settingsConfig: settingsConfig, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled })=>{
    const alignmentItemOptions = {
        render: (props)=>{
            return /*#__PURE__*/ (0, $dc70d.jsx)($d55e30b07c45ef36$export$6ce0ca681c51cdfb, {
                url: url,
                intl: intl,
                currentAppearance: currentAppearance,
                editorState: editorState,
                allowEmbeds: allowEmbeds,
                allowBlockCards: allowBlockCards,
                editorAnalyticsApi: editorAnalyticsApi,
                showUpgradeDiscoverability: showUpgradeDiscoverability,
                isDatasourceView: isDatasourceView,
                allowDatasource: allowDatasource,
                dispatchCommand: props.dispatchCommand,
                settingsConfig: settingsConfig,
                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
            });
        },
        width: 200,
        height: 400
    };
    const currentAppearanceDisplayInformation = isDatasourceView ? (0, $7kos7.datasourceDisplayInformation) : (0, $41dWF.appearancePropsMap)[currentAppearance ?? 'url'];
    const alignmentToolbarItem = {
        id: 'card-appearance',
        testId: 'card-appearance-dropdown',
        type: 'dropdown',
        options: alignmentItemOptions,
        title: intl.formatMessage(currentAppearanceDisplayInformation.title),
        iconBefore: currentAppearanceDisplayInformation.icon
    };
    return alignmentToolbarItem;
};

});
parcelRegister("9a1Je", function(module, exports) {
$parcel$export(module.exports, "getDropdownOption", () => $91cc369d3d22e787$export$1405b80fcb4301ca);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $41dWF = parcelRequire("41dWF");
const $91cc369d3d22e787$export$1405b80fcb4301ca = (intl, dispatchCommand, { disabled: disabled, onClick: onClick, selected: selected, appearance: appearance, testId: testId, tooltip: tooltip, description: description })=>{
    const { title: title, icon: Icon } = (0, $41dWF.appearancePropsMap)[appearance ?? 'url'];
    return {
        title: intl.formatMessage(title),
        icon: /*#__PURE__*/ (0, $dc70d.jsx)(Icon, {
            label: intl.formatMessage(title)
        }),
        onClick: ()=>dispatchCommand(onClick),
        disabled: Boolean(disabled),
        testId: testId,
        selected: selected,
        tooltip: tooltip ?? '',
        description: description
    };
};

});

parcelRegister("7kos7", function(module, exports) {
$parcel$export(module.exports, "datasourceDisplayInformation", () => $c8166a8f6f0b3f0c$export$12f82ee4a2a1a1c9);
$parcel$export(module.exports, "DatasourceDropdownOption", () => $c8166a8f6f0b3f0c$export$b08a863b9d82986d);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $278lv = parcelRequire("278lv");

var $cw0wu = parcelRequire("cw0wu");

var $d6RFo = parcelRequire("d6RFo");

var $jqvxO = parcelRequire("jqvxO");

var $6bOBo = parcelRequire("6bOBo");

var $kpgiw = parcelRequire("kpgiw");

var $a76m2 = parcelRequire("a76m2");

var $1fMby = parcelRequire("1fMby");

var $h5Xzz = parcelRequire("h5Xzz");
const $c8166a8f6f0b3f0c$export$12f82ee4a2a1a1c9 = {
    title: (0, $278lv.messages).datasourceAppearanceTitle,
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($d6RFo))),
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($d6RFo)))
};
const $c8166a8f6f0b3f0c$export$b08a863b9d82986d = ({ allowDatasource: allowDatasource, intl: intl, url: url, selected: selected, inputMethod: inputMethod, dispatchCommand: dispatchCommand })=>{
    const cardContext = (0, $6bOBo.useSmartLinkContext)();
    const { datasourceId: datasourceId, parameters: parameters } = (0, $h5Xzz.useFetchDatasourceInfo)({
        isRegularCardNode: true,
        url: url,
        cardContext: cardContext
    });
    if (!allowDatasource || !datasourceId || !parameters) return null;
    const onChangeAppearance = (editorState, _dispatch, view)=>{
        var _state$datasourceStas;
        if (!view || !datasourceId || !parameters) return false;
        const state = (0, $1fMby.pluginKey).getState(editorState);
        const newAdf = (0, $jqvxO.buildDatasourceAdf)({
            id: datasourceId,
            parameters: parameters,
            views: (state === null || state === void 0 || (_state$datasourceStas = state.datasourceStash[url]) === null || _state$datasourceStas === void 0 ? void 0 : _state$datasourceStas.views) ?? [
                {
                    type: 'table'
                }
            ]
        }, url);
        const { selection: selection } = editorState;
        let existingNode;
        // Check if the selection contains a link mark
        const $pos = editorState.doc.resolve(selection.from);
        const isLinkMark = $pos.marks().some((mark)=>mark.type === editorState.schema.marks.link);
        // When selection is a TextNode and a link Mark is present return that node
        if (selection instanceof (0, $cw0wu.NodeSelection)) existingNode = selection.node;
        else if (isLinkMark) existingNode = editorState.doc.nodeAt(selection.from) ?? undefined;
        if (existingNode) {
            (0, $a76m2.updateCardViaDatasource)({
                state: editorState,
                node: existingNode,
                newAdf: newAdf,
                view: view,
                sourceEvent: undefined,
                isDeletingConfig: true,
                inputMethod: inputMethod
            });
            return true;
        }
        return false;
    };
    if (url) {
        var _cardContext$store, _urlState$error;
        const urlState = cardContext === null || cardContext === void 0 || (_cardContext$store = cardContext.store) === null || _cardContext$store === void 0 ? void 0 : _cardContext$store.getState()[url];
        if ((urlState === null || urlState === void 0 || (_urlState$error = urlState.error) === null || _urlState$error === void 0 ? void 0 : _urlState$error.kind) === 'fatal') return null;
    }
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $kpgiw.default), {
        iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($d6RFo)))({
            label: intl.formatMessage((0, $278lv.messages).datasourceAppearanceTitle)
        }),
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onClick: ()=>dispatchCommand(onChangeAppearance),
        isSelected: selected,
        children: intl.formatMessage((0, $278lv.messages).datasourceAppearanceTitle)
    }, intl.formatMessage((0, $278lv.messages).datasourceAppearanceTitle));
};

});



parcelRegister("jDbCT", function(module, exports) {
$parcel$export(module.exports, "OpenLinkToolbarButton", () => $503ccab34f06d843$export$ba65a32bf3972d3b);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $7HjEm = parcelRequire("7HjEm");

var $92LrB = parcelRequire("92LrB");

var $bxzRa = parcelRequire("bxzRa");
const $503ccab34f06d843$export$ba65a32bf3972d3b = ({ url: url, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled, editorView: editorView, onClick: onClick, title: title })=>{
    const destinationUrl = (0, $bxzRa.useSmartLinkDestinationUrl)(url);
    const handleClick = (0, $bSJIT.useCallback)(()=>{
        onClick(editorView.state, editorView.dispatch);
    }, [
        editorView,
        onClick
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $7HjEm.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "hyperlink-open-link",
        title: title,
        icon: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($92LrB))), {
            label: ""
        }),
        href: destinationUrl,
        target: "_blank",
        onClick: handleClick,
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    });
};

});

parcelRegister("amwXS", function(module, exports) {
$parcel$export(module.exports, "OpenPreviewPanelToolbarButton", () => $6ae48cfcc0136e8f$export$9ed3225219cdbbe9);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $g6Qq4 = parcelRequire("g6Qq4");

var $7HjEm = parcelRequire("7HjEm");

var $8FY43 = parcelRequire("8FY43");

var $hpM3n = parcelRequire("hpM3n");

var $dWNt9 = parcelRequire("dWNt9");

var $6bOBo = parcelRequire("6bOBo");

var $9PwDt = parcelRequire("9PwDt");

var $6X9z7 = parcelRequire("6X9z7");

var $fZ0ZI = parcelRequire("fZ0ZI");

var $aihc7 = parcelRequire("aihc7");
var $2mPLm = parcelRequire("2mPLm");
var $6FJC6 = parcelRequire("6FJC6");

var $5N1Y4 = parcelRequire("5N1Y4");

var $cKhMH = parcelRequire("cKhMH");

var $8o1QB = parcelRequire("8o1QB");
const $6ae48cfcc0136e8f$export$9ed3225219cdbbe9 = ({ node: node, intl: intl, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled, editorAnalyticsApi: editorAnalyticsApi, editorView: editorView })=>{
    const { store: store, isPreviewPanelAvailable: isPreviewPanelAvailable, openPreviewPanel: openPreviewPanel } = (0, $6bOBo.useSmartLinkContext)();
    const url = node.attrs.url;
    const display = (0, $8o1QB.appearanceForLink)(node);
    const cardState = store === null || store === void 0 ? void 0 : store.getState()[url];
    if (cardState) {
        const ari = (0, $aihc7.getObjectAri)(cardState.details);
        const name = (0, $6FJC6.getObjectName)(cardState.details);
        const iconUrl = (0, $2mPLm.getObjectIconUrl)(cardState.details);
        const isPanelAvailable = ari && (isPreviewPanelAvailable === null || isPreviewPanelAvailable === void 0 ? void 0 : isPreviewPanelAvailable({
            ari: ari
        }));
        const handleOpenGlancePanelClick = ()=>{
            if (openPreviewPanel && isPanelAvailable) {
                var _extractSmartLinkEmbe;
                openPreviewPanel({
                    url: url,
                    ari: ari,
                    name: name || '',
                    iconUrl: iconUrl,
                    panelData: {
                        embedUrl: (0, $5N1Y4.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') ? (_extractSmartLinkEmbe = (0, $dWNt9.extractSmartLinkEmbed)(cardState === null || cardState === void 0 ? void 0 : cardState.details)) === null || _extractSmartLinkEmbe === void 0 ? void 0 : _extractSmartLinkEmbe.src : undefined
                    }
                });
            }
            editorAnalyticsApi === null || editorAnalyticsApi === void 0 || editorAnalyticsApi.fireAnalyticsEvent({
                action: (0, $g6Qq4.ACTION).CLICKED,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).SMART_LINK,
                actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).TOOLBAR_PREVIEW,
                attributes: {
                    previewType: 'panel',
                    ...(0, $cKhMH.getResolvedAttributesFromStore)(url, display, store)
                },
                eventType: (0, $g6Qq4.EVENT_TYPE).UI
            });
        };
        const title = intl.formatMessage((0, $8FY43.linkMessages).openPreviewPanel);
        const icon = areAnyNewToolbarFlagsEnabled ? /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hpM3n))), {
            label: "",
            spacing: "spacious"
        }) : // This is a hack required for Jira until areToolbarFlagsEnabled are enabled to ensure the icon has padding
        // Padding is removed when areToolbarFlagsEnabled for a button with icon only in platform/packages/editor/editor-common/src/ui/FloatingToolbar/Button.tsx
        /*#__PURE__*/ (0, $dc70d.jsxs)((0, $fZ0ZI.Inline), {
            as: "span",
            space: "space.050",
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
                    as: "span",
                    "aria-hidden": true,
                    role: "presentation"
                }),
                /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hpM3n))), {
                    label: "",
                    spacing: "spacious"
                }),
                /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
                    as: "span",
                    "aria-hidden": true,
                    role: "presentation"
                })
            ]
        });
        if (openPreviewPanel && isPanelAvailable) return /*#__PURE__*/ (0, $dc70d.jsx)((0, $6X9z7.Flex), {
            gap: "space.050",
            children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $7HjEm.default), {
                testId: "open-preview-panel-floating-toolbar-button",
                onClick: handleOpenGlancePanelClick,
                icon: icon,
                title: title,
                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
            })
        });
    }
    return null;
};

});
parcelRegister("8o1QB", function(module, exports) {
$parcel$export(module.exports, "getNodeSubject", () => $4e85b7c4dd238e8b$export$d3d4c2526aede29a);
$parcel$export(module.exports, "appearanceForLink", () => $4e85b7c4dd238e8b$export$599e1b655555ab1d);
$parcel$export(module.exports, "getUrl", () => $4e85b7c4dd238e8b$export$94df0e59ebebf4a7);
$parcel$export(module.exports, "getNodeContext", () => $4e85b7c4dd238e8b$export$c63a892fcfc539bc);
$parcel$export(module.exports, "findAtPositions", () => $4e85b7c4dd238e8b$export$7ea2145b3909e5c6);
$parcel$export(module.exports, "findInNodeRange", () => $4e85b7c4dd238e8b$export$dbc52ec0d340ce50);
$parcel$export(module.exports, "areSameNodes", () => $4e85b7c4dd238e8b$export$1f3592a520a7960d);

var $cKhMH = parcelRequire("cKhMH");

var $anGu7 = parcelRequire("anGu7");
function $4e85b7c4dd238e8b$export$962cfe99b8da8614(node) {
    return 'datasource' in node.attrs && !!node.attrs.datasource;
}
const $4e85b7c4dd238e8b$export$26ada819291bd8df = (node)=>{
    if ($4e85b7c4dd238e8b$export$962cfe99b8da8614(node)) return false;
    if (!!(0, $cKhMH.appearanceForNodeType)(node.type)) return true;
    return $4e85b7c4dd238e8b$var$hasLinkMark(node);
};
function $4e85b7c4dd238e8b$export$d3d4c2526aede29a(node) {
    if ($4e85b7c4dd238e8b$export$962cfe99b8da8614(node)) return (0, $anGu7.EVENT_SUBJECT).DATASOURCE;
    if ($4e85b7c4dd238e8b$export$26ada819291bd8df(node)) return (0, $anGu7.EVENT_SUBJECT).LINK;
    return null;
}
function $4e85b7c4dd238e8b$export$599e1b655555ab1d(node) {
    const appearance = (0, $cKhMH.appearanceForNodeType)(node.type);
    if (appearance) return appearance;
    return 'url';
}
const $4e85b7c4dd238e8b$var$getLinkMark = (node)=>{
    if (node.marks) for(let i = 0; i < node.marks.length; i++){
        const mark = node.marks[i];
        if (mark.type.name === 'link') return mark;
    }
};
const $4e85b7c4dd238e8b$var$hasLinkMark = (node)=>{
    return !!$4e85b7c4dd238e8b$var$getLinkMark(node);
};
function $4e85b7c4dd238e8b$export$94df0e59ebebf4a7(node) {
    var _node$attrs, _getLinkMark;
    return ((_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.url) ?? ((_getLinkMark = $4e85b7c4dd238e8b$var$getLinkMark(node)) === null || _getLinkMark === void 0 || (_getLinkMark = _getLinkMark.attrs) === null || _getLinkMark === void 0 ? void 0 : _getLinkMark.href);
}
const $4e85b7c4dd238e8b$export$c63a892fcfc539bc = (doc, pos)=>{
    const $pos = doc.resolve(pos);
    const maxDepth = 3;
    for(let i = 0; i <= maxDepth; i++){
        const node = $pos.node($pos.depth - i);
        if (node && node.type.name !== 'paragraph') return node.type.name;
    }
    return 'unknown';
};
const $4e85b7c4dd238e8b$export$7ea2145b3909e5c6 = (tr, positions)=>{
    const entities = [];
    for(let i = 0; i < positions.length; i++){
        const pos = positions[i];
        const node = tr.doc.nodeAt(pos);
        if (!node) continue;
        const nodeContext = $4e85b7c4dd238e8b$export$c63a892fcfc539bc(tr.doc, pos);
        entities.push({
            pos: pos,
            node: node,
            nodeContext: nodeContext
        });
    }
    return entities;
};
const $4e85b7c4dd238e8b$export$dbc52ec0d340ce50 = (doc, from, to, predicate)=>{
    const entities = [];
    doc.nodesBetween(from, to, (node, pos)=>{
        if (predicate(node)) {
            const entirelyInRange = pos >= from && pos + node.nodeSize <= to;
            if (entirelyInRange) {
                const nodeContext = $4e85b7c4dd238e8b$export$c63a892fcfc539bc(doc, pos);
                entities.push({
                    pos: pos,
                    node: node,
                    nodeContext: nodeContext
                });
            }
        }
    });
    return entities;
};
const $4e85b7c4dd238e8b$export$1f3592a520a7960d = (setA, setB)=>{
    if (setA.length !== setB.length) return false;
    for(let i = 0; i < setA.length; i++){
        const a = setA[i];
        const b = setB[i];
        if ($4e85b7c4dd238e8b$export$94df0e59ebebf4a7(a.node) !== $4e85b7c4dd238e8b$export$94df0e59ebebf4a7(b.node) || $4e85b7c4dd238e8b$export$599e1b655555ab1d(a.node) !== $4e85b7c4dd238e8b$export$599e1b655555ab1d(b.node)) return false;
    }
    return true;
};

});
parcelRegister("anGu7", function(module, exports) {
$parcel$export(module.exports, "EVENT", () => $12fc4d5c93605de6$export$e39a34cfd532e15);
$parcel$export(module.exports, "EVENT_SUBJECT", () => $12fc4d5c93605de6$export$97c6cb64ce06a88a);
var $12fc4d5c93605de6$export$e39a34cfd532e15 = /*#__PURE__*/ function(EVENT) {
    EVENT["CREATED"] = "created";
    EVENT["UPDATED"] = "updated";
    EVENT["DELETED"] = "deleted";
    return EVENT;
}({});
var $12fc4d5c93605de6$export$97c6cb64ce06a88a = /*#__PURE__*/ function(EVENT_SUBJECT) {
    EVENT_SUBJECT["LINK"] = "link";
    EVENT_SUBJECT["DATASOURCE"] = "datasource";
    return EVENT_SUBJECT;
}({});

});



parcelRegister("6D2Cw", function(module, exports) {
$parcel$export(module.exports, "ToolbarViewedEvent", () => $68b62bd670210ca2$export$998ac2a59a1547dd);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $6WltM = parcelRequire("6WltM");

var $6bOBo = parcelRequire("6bOBo");

var $k5X6V = parcelRequire("k5X6V");

var $9R86V = parcelRequire("9R86V");

var $cKhMH = parcelRequire("cKhMH");

var $4Gsah = parcelRequire("4Gsah");
const $68b62bd670210ca2$var$areResolvedAttributesEqual = (current, next)=>(current === null || current === void 0 ? void 0 : current.displayCategory) === (next === null || next === void 0 ? void 0 : next.displayCategory) && (current === null || current === void 0 ? void 0 : current.extensionKey) === (next === null || next === void 0 ? void 0 : next.extensionKey) && (current === null || current === void 0 ? void 0 : current.status) === (next === null || next === void 0 ? void 0 : next.status) && (current === null || current === void 0 ? void 0 : current.statusDetails) === (next === null || next === void 0 ? void 0 : next.statusDetails);
/**
 * Handles firing the toolbar viewed event
 */ const $68b62bd670210ca2$var$ToolbarViewedEventBase = ({ url: url, display: display, cardContext: cardContext, editorView: editorView })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const store = cardContext === null || cardContext === void 0 ? void 0 : cardContext.store;
    (0, $bSJIT.useEffect)(()=>{
        var _getPluginState;
        const resolvedAttributes = (0, $cKhMH.getResolvedAttributesFromStore)(url, display, store);
        createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'inlineDialog',
            actionSubjectId: 'editLinkToolbar',
            eventType: 'ui',
            attributes: {
                ...resolvedAttributes,
                display: display
            }
        }).fire('media');
        if (!editorView) return;
        const currentResolvedAttributes = (_getPluginState = (0, $9R86V.getPluginState)(editorView.state)) === null || _getPluginState === void 0 ? void 0 : _getPluginState.resolvedToolbarAttributesByUrl[url];
        if ($68b62bd670210ca2$var$areResolvedAttributesEqual(currentResolvedAttributes, resolvedAttributes)) return;
        editorView.dispatch((0, $k5X6V.setResolvedToolbarAttributes)(url, resolvedAttributes)(editorView.state.tr));
    }, [
        createAnalyticsEvent,
        display,
        editorView,
        url,
        store
    ]);
    return null;
};
const $68b62bd670210ca2$export$998ac2a59a1547dd = ({ url: url, display: display, editorView: editorView })=>{
    const cardContext = (0, $6bOBo.useSmartLinkContext)();
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $4Gsah.EditorAnalyticsContext), {
        editorView: editorView,
        children: url ? /*#__PURE__*/ (0, $dc70d.jsx)($68b62bd670210ca2$var$ToolbarViewedEventBase, {
            url: url,
            display: display,
            cardContext: cardContext,
            editorView: editorView
        }) : null
    });
};

});





parcelRegister("cymkt", function(module, exports) {
$parcel$export(module.exports, "lazyInlineCardView", () => $33f840ab2ca4e174$export$cd3f6a9b84ab8435);

var $4iI1W = parcelRequire("4iI1W");
const $33f840ab2ca4e174$export$cd3f6a9b84ab8435 = (props)=>{
    return (0, $4iI1W.inlineCardNodeView)(props);
};

});

parcelRegister("4ENMR", function(module, exports) {
$parcel$export(module.exports, "eventsFromTransaction", () => $6b2f5cc51615b851$export$c985b35883eaea59);

var $jsWoI = parcelRequire("jsWoI");

var $lDdgh = parcelRequire("lDdgh");

var $g6Qq4 = parcelRequire("g6Qq4");

var $kMLcy = parcelRequire("kMLcy");

var $56AB9 = parcelRequire("56AB9");

var $5vR15 = parcelRequire("5vR15");

var $3DNV7 = parcelRequire("3DNV7");

var $1fMby = parcelRequire("1fMby");

var $9R86V = parcelRequire("9R86V");

var $anGu7 = parcelRequire("anGu7");

var $8o1QB = parcelRequire("8o1QB");
const $6b2f5cc51615b851$export$200d2ac836975ed5 = (tr, state)=>{
    const schema = tr.doc.type.schema;
    const removed = [];
    const inserted = [];
    /**
   * Ideally we have the "before" and "after" states of the "entity"
   * being updated, but if the update is via a "queue for upgrade"
   * then we no longer have access to the "before" state, because the "before"
   * state was replaced with a blue link to be upgraded
   */ const updated = [];
    const queuedForUpgrade = $6b2f5cc51615b851$var$isTransactionQueuedForUpgrade(tr);
    const isResolveReplace = $6b2f5cc51615b851$var$isTransactionResolveReplace(tr);
    const isAutoConvert = $6b2f5cc51615b851$var$isAutoConvertTr(tr);
    // History
    const historyMeta = tr.getMeta((0, $56AB9.pmHistoryPluginKey));
    const isUndo = $6b2f5cc51615b851$var$isHistoryMeta(historyMeta) && historyMeta.redo === false;
    const isRedo = $6b2f5cc51615b851$var$isHistoryMeta(historyMeta) && historyMeta.redo === true;
    const isUpdate = $6b2f5cc51615b851$var$isUpdateTr(tr, isUndo || isRedo);
    for(let i = 0; i < tr.steps.length; i++){
        const step = tr.steps[i];
        const stepMap = step.getMap();
        const removedInStep = [];
        const insertedInStep = [];
        const before = tr.docs[i] ?? tr.before;
        const after = tr.docs[i + 1] ?? tr.doc;
        /**
     * AddMarkStep and RemoveMarkSteps don't produce stepMap ranges
     * because there are no "changed tokens" only marks added/removed
     * So have to check these manually
     */ if (step instanceof (0, $3DNV7.AddMarkStep)) {
            const addMarkStep = step;
            if ((0, $5vR15.isLinkMark)(addMarkStep.mark, schema)) {
                const node = after.nodeAt(addMarkStep.from);
                if (node) /**
           * For url text pasted on plain text
           */ insertedInStep.push({
                    pos: addMarkStep.from,
                    node: node,
                    nodeContext: (0, $8o1QB.getNodeContext)(after, addMarkStep.from)
                });
            }
        }
        if (step instanceof (0, $3DNV7.RemoveMarkStep)) {
            const removeMarkStep = step;
            if ((0, $5vR15.isLinkMark)(removeMarkStep.mark, schema)) {
                const node = before.nodeAt(removeMarkStep.from);
                if (node) removedInStep.push({
                    pos: removeMarkStep.from,
                    node: node,
                    nodeContext: (0, $8o1QB.getNodeContext)(before, removeMarkStep.from)
                });
            }
        }
        stepMap.forEach((oldStart, oldEnd, newStart, newEnd)=>{
            const before = tr.docs[i];
            const after = tr.docs[i + 1] ?? tr.doc;
            const removedInRange = [];
            const insertedInRange = [];
            // Removed
            removedInRange.push(...(0, $8o1QB.findInNodeRange)(before, oldStart, oldEnd, (node)=>!!(0, $8o1QB.getNodeSubject)(node)));
            // Inserted
            insertedInRange.push(...(0, $8o1QB.findInNodeRange)(after, newStart, newEnd, (node)=>!!(0, $8o1QB.getNodeSubject)(node)));
            removedInStep.push(...removedInRange);
            insertedInStep.push(...insertedInRange);
        });
        const omitRequestsForUpgrade = (links)=>{
            if (!queuedForUpgrade) return links;
            /**
       * Skip/filter out links that have been queued, they will be tracked later
       */ const queuedPositions = $6b2f5cc51615b851$var$getQueuedPositions(tr);
            return links.filter((link)=>!queuedPositions.includes(link.pos));
        };
        /**
     * Skip "deletions" when the transaction is relating to
     * replacing links queued for upgrade to cards,
     * because the "deleted" link has not actually been
     * tracked as "created" yet.
     * Also skip when the transaction is an auto-convert
     * (e.g. a pasted link being converted to a native embed extension),
     * because the link is being converted, not deleted by the user.
     */ if (!isResolveReplace && !isAutoConvert) removed.push(...removedInStep);
        inserted.push(...omitRequestsForUpgrade(insertedInStep));
    }
    /**
   * If there are no links changed but the transaction is a "resolve" action
   * Then this means we have resolved a link but it has failed to upgrade
   * We should track all resolved links as now being created
   */ if (inserted.length === 0 && isResolveReplace) {
        const positions = $6b2f5cc51615b851$var$getResolvePositions(tr, state);
        inserted.push(...(0, $8o1QB.findAtPositions)(tr, positions));
    }
    if (!isUpdate) {
        const { inputMethod: inputMethod } = (0, $kMLcy.getLinkMetadataFromTransaction)(tr);
        /**
     * If there is no identifiable input method, and the links inserted and removed appear to be the same,
     * then this transaction likely is not intended to be considered to be the insertion and removal of links
     */ if (!inputMethod && (0, $8o1QB.areSameNodes)(removed, inserted)) return {
            removed: [],
            inserted: [],
            updated: updated
        };
        return {
            removed: removed,
            inserted: inserted,
            updated: updated
        };
    }
    const updateInserted = [];
    const updateRemoved = [];
    for(let i = 0; i < inserted.length; i++){
        if (isResolveReplace) {
            const newLink = inserted[i];
            // what is the 2nd argument 'assoc = -1' doing here exactly?
            const mappedPos = tr.mapping.map(newLink.pos, -1);
            const previousDisplay = $6b2f5cc51615b851$var$getResolveLinkPrevDisplay(state, mappedPos);
            updated.push({
                inserted: inserted[i],
                previous: {
                    display: previousDisplay
                }
            });
            continue;
        }
        if (inserted.length === removed.length) {
            const previousSubject = (0, $8o1QB.getNodeSubject)(removed[i].node);
            const currentSubject = (0, $8o1QB.getNodeSubject)(inserted[i].node);
            if ($6b2f5cc51615b851$var$isDatasourceUpgrade(previousSubject, currentSubject) || $6b2f5cc51615b851$var$isDatasourceDowngrade(previousSubject, currentSubject)) {
                updateInserted.push(inserted[i]);
                updateRemoved.push(removed[i]);
            } else updated.push({
                removed: removed[i],
                inserted: inserted[i]
            });
        }
    }
    return {
        inserted: updateInserted,
        removed: updateRemoved,
        updated: updated
    };
};
/**
 * List of actions to be considered link "updates"
 */ const $6b2f5cc51615b851$var$UPDATE_ACTIONS = [
    (0, $g6Qq4.ACTION).CHANGED_TYPE,
    (0, $g6Qq4.ACTION).UPDATED
];
/**
 * Returns true if the transaction has LinkMetaSteps that indicate the transaction is
 * intended to be perceived as an update to links, rather than insertion+deletion
 */ const $6b2f5cc51615b851$var$isUpdateTr = (tr, isUndoOrRedo)=>{
    return !!tr.steps.find((step)=>{
        if (!(step instanceof (0, $jsWoI.LinkMetaStep))) return false;
        const { action: action, cardAction: cardAction } = step.getMetadata();
        /**
     * Undo of a resolve step should be considered an update
     * because the user is choosing to update the url back to the un-upgraded display
     */ if (cardAction === 'RESOLVE' && isUndoOrRedo) return true;
        if (!action) return false;
        return $6b2f5cc51615b851$var$UPDATE_ACTIONS.includes(action);
    });
};
const $6b2f5cc51615b851$var$hasType = (pluginMeta)=>{
    return typeof pluginMeta === 'object' && pluginMeta !== null && 'type' in pluginMeta;
};
const $6b2f5cc51615b851$var$isTransactionQueuedForUpgrade = (tr)=>{
    const pluginMeta = tr.getMeta((0, $1fMby.pluginKey));
    return $6b2f5cc51615b851$var$isMetadataQueue(pluginMeta);
};
const $6b2f5cc51615b851$var$isMetadataQueue = (metaData)=>{
    return $6b2f5cc51615b851$var$hasType(metaData) && metaData.type === 'QUEUE';
};
const $6b2f5cc51615b851$var$isTransactionResolveReplace = (tr)=>{
    const pluginMeta = tr.getMeta((0, $1fMby.pluginKey));
    return $6b2f5cc51615b851$var$isMetadataResolve(pluginMeta);
};
/**
 * Checks if the transaction is an auto-convert action
 * (e.g. a pasted link being converted to a native embed extension node).
 * In this case the link removal should not be tracked as a deletion.
 */ const $6b2f5cc51615b851$var$isAutoConvertTr = (tr)=>{
    return !!tr.steps.find((step)=>{
        if (!(step instanceof (0, $jsWoI.LinkMetaStep))) return false;
        return step.getMetadata().cardAction === 'AUTO_CONVERT';
    });
};
const $6b2f5cc51615b851$var$isMetadataResolve = (metaData)=>{
    return $6b2f5cc51615b851$var$hasType(metaData) && metaData.type === 'RESOLVE';
};
const $6b2f5cc51615b851$var$isHistoryMeta = (meta)=>{
    return typeof meta === 'object' && meta !== null && 'redo' in meta;
};
const $6b2f5cc51615b851$var$getQueuedPositions = (tr)=>{
    const pluginMeta = tr.getMeta((0, $1fMby.pluginKey));
    if (!$6b2f5cc51615b851$var$isMetadataQueue(pluginMeta)) return [];
    return pluginMeta.requests.map(({ pos: pos })=>pos);
};
const $6b2f5cc51615b851$var$getResolvePositions = (tr, state)=>{
    const cardState = (0, $9R86V.getPluginState)(state);
    if (!cardState) return [];
    const pluginMeta = tr.getMeta((0, $1fMby.pluginKey));
    if (!$6b2f5cc51615b851$var$isMetadataResolve(pluginMeta)) return [];
    return cardState.requests.filter((request)=>request.url === pluginMeta.url).map((request)=>request.pos);
};
const $6b2f5cc51615b851$var$getResolveLinkPrevDisplay = (state, pos)=>{
    var _cardState$requests$f;
    const cardState = (0, $9R86V.getPluginState)(state);
    if (!cardState) return undefined;
    return (_cardState$requests$f = cardState.requests.find((request)=>request.pos === pos)) === null || _cardState$requests$f === void 0 ? void 0 : _cardState$requests$f.previousAppearance;
};
const $6b2f5cc51615b851$var$isDatasourceDowngrade = (previousSubject, currentSubject)=>previousSubject === (0, $anGu7.EVENT_SUBJECT).DATASOURCE && currentSubject === (0, $anGu7.EVENT_SUBJECT).LINK;
const $6b2f5cc51615b851$var$isDatasourceUpgrade = (previousSubject, currentSubject)=>previousSubject === (0, $anGu7.EVENT_SUBJECT).LINK && currentSubject === (0, $anGu7.EVENT_SUBJECT).DATASOURCE;
function $6b2f5cc51615b851$export$c985b35883eaea59(tr, state) {
    const events = [];
    try {
        /**
     * Skip transactions sent by collab (identified by 'isRemote' key)
     * Skip entire document replace steps
     * We are only concerned with transactions performed on the document directly by the user
     */ const isRemote = tr.getMeta('isRemote');
        const isReplaceDocument = tr.getMeta('replaceDocument');
        const isTableSort = tr.steps.find((step)=>step instanceof (0, $lDdgh.TableSortStep));
        if (isRemote || isReplaceDocument || isTableSort) return events;
        const historyMeta = tr.getMeta((0, $56AB9.pmHistoryPluginKey));
        const isUndo = $6b2f5cc51615b851$var$isHistoryMeta(historyMeta) && historyMeta.redo === false;
        const isRedo = $6b2f5cc51615b851$var$isHistoryMeta(historyMeta) && historyMeta.redo === true;
        /**
     * Retrieve metadata from the LinkMetaStep(s) in the transaction
     */ const { action: action, inputMethod: inputMethod, sourceEvent: sourceEvent } = (0, $kMLcy.getLinkMetadataFromTransaction)(tr);
        const { removed: removed, inserted: inserted, updated: updated } = $6b2f5cc51615b851$export$200d2ac836975ed5(tr, state);
        const MAX_LINK_EVENTS = 50;
        if ([
            removed,
            inserted,
            updated
        ].some((arr)=>arr.length > MAX_LINK_EVENTS)) return [];
        for(let i = 0; i < updated.length; i++){
            const update = updated[i];
            const { inserted: inserted } = update;
            const { node: node, nodeContext: nodeContext } = inserted;
            const subject = (0, $8o1QB.getNodeSubject)(node);
            /**
       * Not great, wish we had the previous node but we never stored it
       */ const previousDisplay = 'removed' in update ? (0, $8o1QB.appearanceForLink)(update.removed.node) : update.previous.display ?? 'unknown';
            if (subject) events.push({
                event: (0, $anGu7.EVENT).UPDATED,
                subject: subject,
                data: {
                    node: node,
                    nodeContext: nodeContext,
                    action: action,
                    inputMethod: inputMethod,
                    sourceEvent: sourceEvent,
                    isUndo: isUndo,
                    isRedo: isRedo,
                    previousDisplay: previousDisplay
                }
            });
        }
        const pushEvents = (entities, event)=>{
            for(let i = 0; i < entities.length; i++){
                const { node: node, nodeContext: nodeContext } = entities[i];
                const subject = (0, $8o1QB.getNodeSubject)(node);
                if (subject) events.push({
                    event: event,
                    subject: subject,
                    data: {
                        node: node,
                        nodeContext: nodeContext,
                        action: action,
                        inputMethod: inputMethod,
                        sourceEvent: sourceEvent,
                        isUndo: isUndo,
                        isRedo: isRedo
                    }
                });
            }
        };
        pushEvents(removed, (0, $anGu7.EVENT).DELETED);
        pushEvents(inserted, (0, $anGu7.EVENT).CREATED);
        return events;
    } catch (err) {
        return events;
    }
}

});
parcelRegister("lDdgh", function(module, exports) {
$parcel$export(module.exports, "TableSortStep", () => $b01a2eefe13c49db$export$c1b7e6427b2a2113);

var $kW8qW = parcelRequire("kW8qW");

var $3DNV7 = parcelRequire("3DNV7");
parcelRequire("bUbIU");
var $3DNV7 = parcelRequire("3DNV7");
const $b01a2eefe13c49db$export$3f33e36adb7672cc = 'atlaskit-table-sorting-ordering';
class $b01a2eefe13c49db$export$c1b7e6427b2a2113 extends (0, $3DNV7.Step) {
    constructor(pos, prev, next){
        super();
        this.prev = prev;
        this.next = next;
        this.pos = pos;
    }
    invert() {
        return new $b01a2eefe13c49db$export$c1b7e6427b2a2113(this.pos, this.next, this.prev);
    }
    apply(doc) {
        return (0, $3DNV7.StepResult).ok(doc);
    }
    map() {
        return null;
    }
    getMap() {
        return new (0, $3DNV7.StepMap)([
            0,
            0,
            0
        ]);
    }
    toJSON() {
        return {
            stepType: $b01a2eefe13c49db$export$3f33e36adb7672cc
        };
    }
    static fromJSON() {
        return new (0, $3DNV7.ReplaceStep)(0, 0, (0, $kW8qW.Slice).empty);
    }
}
/** Register this step with Prosemirror */ (0, $3DNV7.Step).jsonID($b01a2eefe13c49db$export$3f33e36adb7672cc, $b01a2eefe13c49db$export$c1b7e6427b2a2113);

});

parcelRegister("kMLcy", function(module, exports) {
$parcel$export(module.exports, "getLinkMetadataFromTransaction", () => $e108ac739b98061b$export$3aba02526a1e2e78);

var $jsWoI = parcelRequire("jsWoI");
function $e108ac739b98061b$export$3aba02526a1e2e78(tr) {
    return tr.steps.reduce((metadata, step)=>{
        if (!(step instanceof (0, $jsWoI.LinkMetaStep))) return metadata;
        return {
            ...metadata,
            ...step.getMetadata()
        };
    }, {});
}

});


parcelRegister("eusna", function(module, exports) {
$parcel$export(module.exports, "getDatasource", () => $cbf9d29bdc181c07$export$32844f9f273856e4);
$parcel$export(module.exports, "isDatasourceTableLayout", () => $cbf9d29bdc181c07$export$8467cbb601c13bfc);

var $gab48 = parcelRequire("gab48");

var $cKhMH = parcelRequire("cKhMH");

var $5jg1E = parcelRequire("5jg1E");
const $cbf9d29bdc181c07$export$32844f9f273856e4 = (editorView)=>{
    if (editorView) {
        const { selection: selection, schema: schema } = editorView.state;
        const { blockCard: blockCard } = schema.nodes;
        const findResult = (0, $gab48.findSelectedNodeOfType)([
            blockCard
        ])(selection);
        if (findResult && (0, $cKhMH.isDatasourceNode)(findResult.node)) return {
            ...findResult,
            node: findResult.node
        };
    }
    return {
        node: undefined,
        pos: undefined
    };
};
const $cbf9d29bdc181c07$export$8467cbb601c13bfc = (layout)=>{
    return (0, $5jg1E.DATASOURCE_TABLE_LAYOUTS).some((l)=>l === layout);
};

});
parcelRegister("5jg1E", function(module, exports) {
$parcel$export(module.exports, "DATASOURCE_TABLE_LAYOUTS", () => $e088df841a90df30$export$3f155c85880510c8);
const $e088df841a90df30$export$3f155c85880510c8 = [
    'full-width',
    'center',
    'wide'
];

});


parcelRegister("bckCt", function(module, exports) {
$parcel$export(module.exports, "default", () => $cde3feb7803ed4a3$export$2e2bcd8739ae039);

var $3y2s4 = parcelRequire("3y2s4");
const $cde3feb7803ed4a3$var$queue = (state, action)=>{
    return {
        ...state,
        requests: state.requests.concat(action.requests)
    };
};
const $cde3feb7803ed4a3$var$resolve = (state, action)=>{
    const requests = state.requests.reduce((requests, request)=>{
        if (request.url !== action.url) requests.push(request);
        return requests;
    }, []);
    return {
        ...state,
        requests: requests
    };
};
const $cde3feb7803ed4a3$var$register = (state, action)=>{
    return {
        ...state,
        cards: state.cards.filter((card)=>card.pos !== action.info.pos).concat(action.info)
    };
};
const $cde3feb7803ed4a3$var$removeCard = (state, action)=>{
    const cards = state.cards.filter((card)=>card.id !== action.info.id);
    if ((0, $3y2s4.isExperimentEnabled)('platform_editor_reduce_memory_leaks') && state.removeOverlayCardId !== undefined && state.removeOverlayCardId === action.info.id) return {
        ...state,
        cards: cards,
        removeOverlay: undefined,
        removeOverlayCardId: undefined
    };
    return {
        ...state,
        cards: cards
    };
};
const $cde3feb7803ed4a3$var$setProvider = (state, action)=>{
    return {
        ...state,
        provider: action.provider
    };
};
const $cde3feb7803ed4a3$var$setCardLayout = (state, action)=>{
    return {
        ...state,
        layout: action.layout
    };
};
const $cde3feb7803ed4a3$var$setDatasourceTableRef = (state, action)=>{
    return {
        ...state,
        datasourceTableRef: action.datasourceTableRef
    };
};
const $cde3feb7803ed4a3$var$setResolvedToolbarAttributes = (state, action)=>{
    return {
        ...state,
        resolvedToolbarAttributesByUrl: {
            ...state.resolvedToolbarAttributesByUrl,
            [action.url]: action.attributes
        }
    };
};
const $cde3feb7803ed4a3$var$setCardLayoutDatasourceTableRef = (state, action)=>{
    return {
        ...state,
        datasourceTableRef: action.datasourceTableRef,
        layout: action.layout
    };
};
const $cde3feb7803ed4a3$var$registerEvents = (state, action)=>{
    return {
        ...state,
        smartLinkEvents: action.smartLinkEvents
    };
};
const $cde3feb7803ed4a3$var$setLinkToolbar = (state, action)=>{
    return {
        ...state,
        showLinkingToolbar: action.type === 'SHOW_LINK_TOOLBAR'
    };
};
const $cde3feb7803ed4a3$var$showDatasourceModal = (state, action)=>{
    return {
        ...state,
        showDatasourceModal: true,
        datasourceModalType: action.type === 'SHOW_DATASOURCE_MODAL' ? action.modalType : undefined
    };
};
const $cde3feb7803ed4a3$var$hideDatasourceModal = (state)=>{
    return {
        ...state,
        showDatasourceModal: false,
        datasourceModalType: undefined
    };
};
const $cde3feb7803ed4a3$var$clearOverlayCandidate = (state)=>{
    if ((0, $3y2s4.isExperimentEnabled)('platform_editor_reduce_memory_leaks')) return {
        ...state,
        overlayCandidatePosition: undefined,
        removeOverlay: undefined,
        removeOverlayCardId: undefined
    };
    return {
        ...state,
        overlayCandidatePosition: undefined
    };
};
const $cde3feb7803ed4a3$var$registerRemoveOverlayOnInsertedLink = (state, action)=>{
    var _action$info2;
    return {
        ...state,
        cards: action.info ? state.cards.filter((card)=>{
            var _action$info;
            return card.pos !== ((_action$info = action.info) === null || _action$info === void 0 ? void 0 : _action$info.pos);
        }).concat(action.info) : state.cards,
        removeOverlay: action.callback,
        ...(0, $3y2s4.isExperimentEnabled)('platform_editor_reduce_memory_leaks') ? {
            removeOverlayCardId: (_action$info2 = action.info) === null || _action$info2 === void 0 ? void 0 : _action$info2.id
        } : {}
    };
};
const $cde3feb7803ed4a3$var$setDatasourceStash = (state, action)=>{
    return {
        ...state,
        datasourceStash: {
            ...state.datasourceStash,
            [action.datasourceStash.url]: {
                views: action.datasourceStash.views
            }
        }
    };
};
const $cde3feb7803ed4a3$var$removeDatasourceStash = (state, action)=>{
    const { [action.url]: _, ...datasourceStash } = state.datasourceStash;
    return {
        ...state,
        datasourceStash: datasourceStash
    };
};
var $cde3feb7803ed4a3$export$2e2bcd8739ae039 = (state, action)=>{
    switch(action.type){
        case 'QUEUE':
            return $cde3feb7803ed4a3$var$queue(state, action);
        case 'SET_PROVIDER':
            return $cde3feb7803ed4a3$var$setProvider(state, action);
        case 'RESOLVE':
            return $cde3feb7803ed4a3$var$resolve(state, action);
        case 'REGISTER':
            return $cde3feb7803ed4a3$var$register(state, action);
        case 'REMOVE_CARD':
            return $cde3feb7803ed4a3$var$removeCard(state, action);
        case 'REGISTER_EVENTS':
            return $cde3feb7803ed4a3$var$registerEvents(state, action);
        case 'SET_DATASOURCE_TABLE_REF':
            return $cde3feb7803ed4a3$var$setDatasourceTableRef(state, action);
        case 'SET_RESOLVED_TOOLBAR_ATTRIBUTES':
            return $cde3feb7803ed4a3$var$setResolvedToolbarAttributes(state, action);
        case 'SET_CARD_LAYOUT':
            return $cde3feb7803ed4a3$var$setCardLayout(state, action);
        case 'SET_CARD_LAYOUT_AND_DATASOURCE_TABLE_REF':
            return $cde3feb7803ed4a3$var$setCardLayoutDatasourceTableRef(state, action);
        case 'SHOW_LINK_TOOLBAR':
        case 'HIDE_LINK_TOOLBAR':
            return $cde3feb7803ed4a3$var$setLinkToolbar(state, action);
        case 'SHOW_DATASOURCE_MODAL':
            return $cde3feb7803ed4a3$var$showDatasourceModal(state, action);
        case 'HIDE_DATASOURCE_MODAL':
            return $cde3feb7803ed4a3$var$hideDatasourceModal(state);
        case 'CLEAR_OVERLAY_CANDIDATE':
            return $cde3feb7803ed4a3$var$clearOverlayCandidate(state);
        case 'REGISTER_REMOVE_OVERLAY_ON_INSERTED_LINK':
            return $cde3feb7803ed4a3$var$registerRemoveOverlayOnInsertedLink(state, action);
        case 'SET_DATASOURCE_STASH':
            return $cde3feb7803ed4a3$var$setDatasourceStash(state, action);
        case 'REMOVE_DATASOURCE_STASH':
            return $cde3feb7803ed4a3$var$removeDatasourceStash(state, action);
    }
};

});

parcelRegister("aZzYb", function(module, exports) {
$parcel$export(module.exports, "resolveWithProvider", () => $f4aa812f050035a3$export$2007d0af08977743);
$parcel$export(module.exports, "handleProvider", () => $f4aa812f050035a3$export$96766f42428c9e7f);
parcelRequire("56AB9");
var $lwCmV = parcelRequire("lwCmV");

var $8XENo = parcelRequire("8XENo");

var $k5X6V = parcelRequire("k5X6V");

var $a76m2 = parcelRequire("a76m2");
const $f4aa812f050035a3$var$isFreshlyPastedOnNewLine = (view)=>{
    const { selection: selection } = view.state;
    const { $cursor: $cursor, $anchor: $anchor } = selection;
    if (!$cursor) return false;
    if (!(0, $lwCmV.hasDocAsParent)($anchor)) return false;
    const node = $cursor.node();
    if (!node) return false;
    if (node.type.name !== 'paragraph') return false;
    return node.childCount === 1; // The pasted blue link itself
};
const $f4aa812f050035a3$export$2007d0af08977743 = (view, provider, request, options, editorAnalyticsApi, createAnalyticsEvent, embedCardNodeTransformer)=>{
    const isEmbedFriendlyLocation = $f4aa812f050035a3$var$isFreshlyPastedOnNewLine(view);
    // When user manually changes appearance from blue link to smart link, we should respect that,
    const shouldForceAppearance = // This flag is set to true only in one place atm:
    // packages/editor/editor-core/src/plugins/card/pm-plugins/doc.ts @ convertHyperlinkToSmartCard
    // Which is used when user switching from URL to smart link appearance.
    !!request.shouldReplaceLink;
    const handleResolve = provider.resolve(request.url, request.appearance, shouldForceAppearance, isEmbedFriendlyLocation).then($f4aa812f050035a3$var$handleResolved(view, request, editorAnalyticsApi, createAnalyticsEvent, options, embedCardNodeTransformer), $f4aa812f050035a3$var$handleRejected(view, request, editorAnalyticsApi));
    return handleResolve;
};
const $f4aa812f050035a3$var$updateCardType = (resolvedCard, options)=>{
    if (resolvedCard.type === 'blockCard' && 'datasource' in resolvedCard.attrs) {
        const datasourceId = resolvedCard.attrs.datasource.id;
        if (!options.allowDatasource || !(0, $8XENo.canRenderDatasource)(datasourceId)) {
            delete resolvedCard.attrs.datasource;
            resolvedCard.type = 'inlineCard';
            return;
        }
    }
    if ((resolvedCard === null || resolvedCard === void 0 ? void 0 : resolvedCard.type) === 'blockCard' && !options.allowBlockCards || (resolvedCard === null || resolvedCard === void 0 ? void 0 : resolvedCard.type) === 'embedCard' && !options.allowEmbeds) {
        // clean out the 'layout' attr from an embedCard type that should be transformed into the inlineCard type.
        if (resolvedCard.type === 'embedCard') // eslint-disable-next-line @typescript-eslint/no-explicit-any
        delete resolvedCard.attrs.layout;
        resolvedCard.type = 'inlineCard';
    }
};
const $f4aa812f050035a3$var$handleResolved = (view, request, editorAnalyticsApi, createAnalyticsEvent, options, embedCardNodeTransformer)=>(resolvedCard)=>{
        $f4aa812f050035a3$var$updateCardType(resolvedCard, options);
        (0, $a76m2.replaceQueuedUrlWithCard)(request.url, resolvedCard, request.analyticsAction, editorAnalyticsApi, createAnalyticsEvent, embedCardNodeTransformer)(view.state, view.dispatch);
        return resolvedCard;
    };
const $f4aa812f050035a3$var$handleRejected = (view, request, editorAnalyticsApi)=>()=>{
        (0, $a76m2.handleFallbackWithAnalytics)(request, editorAnalyticsApi)(view.state, view.dispatch);
    };
const $f4aa812f050035a3$export$96766f42428c9e7f = (_, provider, view)=>{
    if (!provider) return;
    provider.then((cardProvider)=>{
        const { state: state, dispatch: dispatch } = view;
        dispatch((0, $k5X6V.setProvider)(cardProvider)(state.tr));
    });
};

});


parcelRegister("emowl", function(module, exports) {
$parcel$export(module.exports, "createEventsQueue", () => $dab8982355a7e801$export$5115a388c364848d);
const $dab8982355a7e801$export$5115a388c364848d = ()=>{
    const queue = [];
    const subscribers = new Set();
    const subscribe = (subscriber)=>{
        subscribers.add(subscriber);
        return ()=>{
            subscribers.delete(subscriber);
        };
    };
    const push = (...events)=>{
        queue.push(...events);
    };
    const flush = ()=>{
        while(queue.length){
            const event = queue.shift();
            if (event) subscribers.forEach((subscriber)=>{
                subscriber(event);
            });
        }
    };
    const getSize = ()=>queue.length;
    return {
        push: push,
        flush: flush,
        subscribe: subscribe,
        getSize: getSize
    };
};

});

parcelRegister("7yaCs", function(module, exports) {
$parcel$export(module.exports, "default", () => $8c04579e8e9082db$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $5beht = parcelRequire("5beht");

var $G916T = parcelRequire("G916T");

var $a2Ugg = parcelRequire("a2Ugg");

var $7Vty7 = parcelRequire("7Vty7");

var $6yEAN = parcelRequire("6yEAN");

var $8jcko = parcelRequire("8jcko");

var $ka4gR = parcelRequire("ka4gR");

var $frwzM = parcelRequire("frwzM");

var $6bOBo = parcelRequire("6bOBo");

var $gBI2J = parcelRequire("gBI2J");

var $y0KPg = parcelRequire("y0KPg");
const $8c04579e8e9082db$var$selector = (states)=>{
    var _states$cardState, _states$cardState2;
    return {
        showDatasourceModal: (_states$cardState = states.cardState) === null || _states$cardState === void 0 ? void 0 : _states$cardState.showDatasourceModal,
        datasourceModalType: (_states$cardState2 = states.cardState) === null || _states$cardState2 === void 0 ? void 0 : _states$cardState2.datasourceModalType
    };
};
const $8c04579e8e9082db$var$ModalWithState = ({ api: api, editorView: editorView })=>{
    const cardContext = (0, $6bOBo.useSmartLinkContext)();
    const { showDatasourceModal: showDatasourceModal, datasourceModalType: datasourceModalType } = (0, $5beht.useSharedPluginStateWithSelector)(api, [
        'card'
    ], $8c04579e8e9082db$var$selector);
    if (!showDatasourceModal || !datasourceModalType) return null;
    const { datasourceId: datasourceId, componentType: componentType } = $8c04579e8e9082db$export$aeed689b34941117[datasourceModalType];
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $gBI2J.DatasourceErrorBoundary), {
        view: editorView,
        datasourceModalType: datasourceModalType,
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $y0KPg.DatasourceModal), {
            view: editorView,
            cardContext: cardContext,
            datasourceId: datasourceId,
            componentType: componentType
        })
    });
};
const $8c04579e8e9082db$var$SafeModalWithState = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).memo(({ api: api, editorView: editorView })=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $frwzM.EditorSmartCardProviderValueGuard), {
        children: /*#__PURE__*/ (0, $dc70d.jsx)($8c04579e8e9082db$var$ModalWithState, {
            api: api,
            editorView: editorView
        })
    });
});
const $8c04579e8e9082db$export$aeed689b34941117 = {
    jira: {
        componentType: (0, $8jcko.JiraIssuesConfigModalWithWrappers),
        datasourceId: (0, $ka4gR.JIRA_LIST_OF_LINKS_DATASOURCE_ID)
    },
    'confluence-search': {
        componentType: (0, $7Vty7.ConfluenceSearchConfigModalWithWrappers),
        datasourceId: (0, $6yEAN.CONFLUENCE_SEARCH_DATASOURCE_ID)
    },
    assets: {
        componentType: (0, $G916T.AssetsConfigModalWithWrappers),
        datasourceId: (0, $a2Ugg.ASSETS_LIST_OF_LINKS_DATASOURCE_ID)
    }
};
var $8c04579e8e9082db$export$2e2bcd8739ae039 = $8c04579e8e9082db$var$SafeModalWithState;

});
parcelRegister("y0KPg", function(module, exports) {
$parcel$export(module.exports, "DatasourceModal", () => $2f7b69e6579989eb$export$95702e90d329951a);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $cw0wu = parcelRequire("cw0wu");

var $k5X6V = parcelRequire("k5X6V");

var $a76m2 = parcelRequire("a76m2");

var $h5Xzz = parcelRequire("h5Xzz");
const $2f7b69e6579989eb$export$95702e90d329951a = ({ view: view, cardContext: cardContext, datasourceId: defaultDatasourceId, componentType: Component })=>{
    var _existingNode$attrs, _existingNode$attrs2;
    const { state: state } = view;
    const existingNode = $2f7b69e6579989eb$var$getExistingNode(state);
    const { dispatch: dispatch, state: { tr: transaction } } = view;
    const onClose = (0, $bSJIT.useCallback)(()=>{
        dispatch((0, $k5X6V.hideDatasourceModal)(transaction));
    }, [
        dispatch,
        transaction
    ]);
    const updateAdf = $2f7b69e6579989eb$var$useUpdateAdf(view, existingNode);
    const isRegularCardNode = !!(existingNode && !(existingNode !== null && existingNode !== void 0 && (_existingNode$attrs = existingNode.attrs) !== null && _existingNode$attrs !== void 0 && _existingNode$attrs.datasource));
    const { id: datasourceId = defaultDatasourceId, views: views = [], parameters: nodeParameters } = (existingNode === null || existingNode === void 0 || (_existingNode$attrs2 = existingNode.attrs) === null || _existingNode$attrs2 === void 0 ? void 0 : _existingNode$attrs2.datasource) || {};
    const { visibleColumnKeys: visibleColumnKeys, wrappedColumnKeys: wrappedColumnKeys, columnCustomSizes: columnCustomSizes } = $2f7b69e6579989eb$var$resolveColumnsConfig(views);
    const { parameters: parameters, ready: ready } = (0, $h5Xzz.useFetchDatasourceInfo)({
        isRegularCardNode: isRegularCardNode,
        url: existingNode === null || existingNode === void 0 ? void 0 : existingNode.attrs.url,
        cardContext: cardContext,
        nodeParameters: nodeParameters
    });
    if (!ready) return null;
    return /*#__PURE__*/ (0, $dc70d.jsx)(Component, {
        datasourceId: datasourceId,
        viewMode: isRegularCardNode ? 'inline' : 'table',
        parameters: parameters,
        url: existingNode === null || existingNode === void 0 ? void 0 : existingNode.attrs.url,
        visibleColumnKeys: visibleColumnKeys,
        columnCustomSizes: columnCustomSizes,
        wrappedColumnKeys: wrappedColumnKeys,
        onCancel: onClose,
        onInsert: updateAdf
    });
};
const $2f7b69e6579989eb$var$useUpdateAdf = (view, existingNode)=>{
    return (0, $bSJIT.useCallback)((newAdf, analyticEvent)=>{
        if (analyticEvent) analyticEvent.update((payload)=>({
                ...payload,
                attributes: {
                    ...payload.attributes,
                    inputMethod: 'datasource_config'
                }
            }));
        if (existingNode) (0, $a76m2.updateCardViaDatasource)({
            state: view.state,
            node: existingNode,
            newAdf: newAdf,
            view: view,
            sourceEvent: analyticEvent
        });
        else (0, $a76m2.insertDatasource)(view.state, newAdf, view, analyticEvent);
    }, [
        existingNode,
        view
    ]);
};
const $2f7b69e6579989eb$var$getExistingNode = (state)=>{
    const { selection: selection } = state;
    let existingNode;
    // Check if the selection contains a link mark
    const isLinkMark = state.doc.resolve(selection.from).marks().some((mark)=>mark.type === state.schema.marks.link);
    // When selection is a TextNode and a link Mark is present return that node
    if (selection instanceof (0, $cw0wu.NodeSelection)) existingNode = selection.node;
    else if (isLinkMark) existingNode = state.doc.nodeAt(selection.from) ?? undefined;
    return existingNode;
};
const $2f7b69e6579989eb$var$resolveColumnsConfig = (views)=>{
    var _tableView$properties;
    const [tableView] = views;
    const visibleColumnKeys = [];
    const wrappedColumnKeys = [];
    const columnCustomSizes = {};
    const columns = tableView === null || tableView === void 0 || (_tableView$properties = tableView.properties) === null || _tableView$properties === void 0 ? void 0 : _tableView$properties.columns;
    if (columns) for (const { key: key, width: width, isWrapped: isWrapped } of columns){
        visibleColumnKeys.push(key);
        if (width) columnCustomSizes[key] = width;
        if (isWrapped) wrappedColumnKeys.push(key);
    }
    return {
        visibleColumnKeys: visibleColumnKeys,
        wrappedColumnKeys: wrappedColumnKeys,
        columnCustomSizes: columnCustomSizes
    };
};

});


parcelRegister("jPC2c", function(module, exports) {
$parcel$export(module.exports, "EditorLinkingPlatformAnalytics", () => $080ad7e0df7491ae$export$c083a9ed3df8f5ac);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $cmWuu = parcelRequire("cmWuu");

var $frwzM = parcelRequire("frwzM");

var $4Gsah = parcelRequire("4Gsah");

var $lMqQc = parcelRequire("lMqQc");

var $7wtCx = parcelRequire("7wtCx");
class $080ad7e0df7491ae$export$c083a9ed3df8f5ac extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).PureComponent {
    render() {
        if (!this.props.editorView) return null;
        return /*#__PURE__*/ (0, $dc70d.jsx)((0, $cmWuu.EditorSmartCardProvider), {
            children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $frwzM.EditorSmartCardProviderValueGuard), {
                children: /*#__PURE__*/ (0, $dc70d.jsxs)((0, $4Gsah.EditorAnalyticsContext), {
                    editorView: this.props.editorView,
                    children: [
                        /*#__PURE__*/ (0, $dc70d.jsx)((0, $7wtCx.LinkEventsBinding), {
                            ...this.props
                        }),
                        /*#__PURE__*/ (0, $dc70d.jsx)((0, $lMqQc.DatasourceEventsBinding), {
                            ...this.props
                        })
                    ]
                })
            })
        });
    }
}

});
parcelRegister("lMqQc", function(module, exports) {
$parcel$export(module.exports, "DatasourceEventsBinding", () => $733f55317232b75e$export$bddcbec746c26287);

var $bSJIT = parcelRequire("bSJIT");

var $hCYNe = parcelRequire("hCYNe");

var $2fYSR = parcelRequire("2fYSR");

var $anGu7 = parcelRequire("anGu7");

var $clnwZ = parcelRequire("clnwZ");
function $733f55317232b75e$var$getDatasourceDisplay(datasourceAttrs) {
    var _datasourceAttrs$data;
    return (_datasourceAttrs$data = datasourceAttrs.datasource.views[0]) === null || _datasourceAttrs$data === void 0 ? void 0 : _datasourceAttrs$data.type;
}
function $733f55317232b75e$var$getDisplayedColumnCount(datasourceAttrs) {
    var _datasourceAttrs$data2;
    return ((_datasourceAttrs$data2 = datasourceAttrs.datasource.views[0]) === null || _datasourceAttrs$data2 === void 0 || (_datasourceAttrs$data2 = _datasourceAttrs$data2.properties) === null || _datasourceAttrs$data2 === void 0 || (_datasourceAttrs$data2 = _datasourceAttrs$data2.columns) === null || _datasourceAttrs$data2 === void 0 ? void 0 : _datasourceAttrs$data2.length) ?? undefined;
}
function $733f55317232b75e$var$getSearchMethod(creationMethod, metadata) {
    if (creationMethod === 'editor_paste' || creationMethod === 'editor_type') return '';
    const { sourceEvent: sourceEvent } = metadata;
    if (sourceEvent instanceof (0, $hCYNe.default)) {
        var _event$payload$attrib;
        const event = sourceEvent;
        return (_event$payload$attrib = event.payload.attributes) === null || _event$payload$attrib === void 0 ? void 0 : _event$payload$attrib.searchMethod;
    }
    return 'unknown';
}
function $733f55317232b75e$var$getAnalyticAttributesFromNode(datasourceAttrs, metadata) {
    const { url: url, datasource: { id: datasourceId, parameters: parameters } } = datasourceAttrs;
    const display = $733f55317232b75e$var$getDatasourceDisplay(datasourceAttrs);
    let inputMethod = '';
    let actions = [];
    if (metadata.inputMethod) inputMethod = (0, $clnwZ.getMethod)(metadata) ?? '';
    else if (metadata.sourceEvent instanceof (0, $hCYNe.default)) {
        var _metadata$sourceEvent, _metadata$sourceEvent2;
        inputMethod = (_metadata$sourceEvent = metadata.sourceEvent.payload.attributes) === null || _metadata$sourceEvent === void 0 ? void 0 : _metadata$sourceEvent.inputMethod;
        actions = (_metadata$sourceEvent2 = metadata.sourceEvent.payload.attributes) === null || _metadata$sourceEvent2 === void 0 ? void 0 : _metadata$sourceEvent2.actions;
    }
    const displayedColumnCount = $733f55317232b75e$var$getDisplayedColumnCount(datasourceAttrs);
    const searchMethod = $733f55317232b75e$var$getSearchMethod(inputMethod, metadata);
    return {
        actions: actions,
        inputMethod: inputMethod,
        datasourceId: datasourceId,
        display: display,
        displayedColumnCount: displayedColumnCount,
        parameters: parameters,
        searchMethod: searchMethod,
        url: url
    };
}
const $733f55317232b75e$export$bddcbec746c26287 = ({ cardPluginEvents: cardPluginEvents })=>{
    const { datasourceCreated: datasourceCreated, datasourceUpdated: datasourceUpdated, datasourceDeleted: datasourceDeleted } = (0, $2fYSR.useDatasourceLifecycleAnalytics)();
    const eventHandlers = (0, $bSJIT.useMemo)(()=>{
        return {
            [(0, $anGu7.EVENT).CREATED]: ({ node: node, nodeContext: nodeContext, ...metadata })=>{
                const attributes = $733f55317232b75e$var$getAnalyticAttributesFromNode(node.attrs, metadata);
                const { actions: actions, inputMethod: inputMethod, datasourceId: datasourceId, display: display, displayedColumnCount: displayedColumnCount, parameters: parameters, searchMethod: searchMethod, url: url } = attributes;
                datasourceCreated({
                    datasourceId: datasourceId,
                    parameters: parameters,
                    url: url
                }, null, {
                    actions: actions,
                    creationMethod: inputMethod,
                    display: display,
                    ...typeof displayedColumnCount === 'number' ? {
                        displayedColumnCount: displayedColumnCount
                    } : {},
                    nodeContext: nodeContext,
                    searchMethod: searchMethod
                });
            },
            [(0, $anGu7.EVENT).UPDATED]: ({ node: node, nodeContext: nodeContext, ...metadata })=>{
                const attributes = $733f55317232b75e$var$getAnalyticAttributesFromNode(node.attrs, metadata);
                const { actions: actions, datasourceId: datasourceId, display: display, displayedColumnCount: displayedColumnCount, inputMethod: inputMethod, parameters: parameters, searchMethod: searchMethod, url: url } = attributes;
                datasourceUpdated({
                    datasourceId: datasourceId,
                    parameters: parameters,
                    url: url
                }, null, {
                    actions: actions,
                    display: display,
                    displayedColumnCount: displayedColumnCount,
                    nodeContext: nodeContext,
                    searchMethod: searchMethod,
                    updateMethod: inputMethod
                });
            },
            [(0, $anGu7.EVENT).DELETED]: ({ node: node, nodeContext: nodeContext, ...metadata })=>{
                const attributes = $733f55317232b75e$var$getAnalyticAttributesFromNode(node.attrs, metadata);
                const { datasourceId: datasourceId, display: display, displayedColumnCount: displayedColumnCount, inputMethod: inputMethod, parameters: parameters, searchMethod: searchMethod, url: url } = attributes;
                datasourceDeleted({
                    datasourceId: datasourceId,
                    parameters: parameters,
                    url: url
                }, null, {
                    deleteMethod: inputMethod,
                    display: display,
                    displayedColumnCount: displayedColumnCount,
                    nodeContext: nodeContext,
                    searchMethod: searchMethod
                });
            }
        };
    }, [
        datasourceCreated,
        datasourceUpdated,
        datasourceDeleted
    ]);
    /**
   * Subscribe to datasource events
   */ (0, $bSJIT.useEffect)(()=>{
        const unsubscribe = cardPluginEvents.subscribe(({ event: event, subject: subject, data: data })=>{
            if (subject === (0, $anGu7.EVENT_SUBJECT).DATASOURCE) eventHandlers[event](data);
        });
        return ()=>unsubscribe();
    }, [
        eventHandlers,
        cardPluginEvents
    ]);
    return null;
};

});
parcelRegister("2fYSR", function(module, exports) {
$parcel$export(module.exports, "useDatasourceLifecycleAnalytics", () => $f462ec45372eadea$export$c82e48d9fd97c55b);

var $bSJIT = parcelRequire("bSJIT");

var $jeyHF = parcelRequire("jeyHF");

var $6WltM = parcelRequire("6WltM");

var $jX24c = parcelRequire("jX24c");

var $4hUAn = parcelRequire("4hUAn");

var $02RAa = parcelRequire("02RAa");

var $dmhJq = parcelRequire("dmhJq");

const $f462ec45372eadea$export$c82e48d9fd97c55b = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const { getDatasourceData: getDatasourceData } = (0, $jX24c.useDatasourceClientExtension)();
    return (0, $bSJIT.useMemo)(()=>{
        const factory = (action)=>(...args)=>{
                try {
                    (0, $dmhJq.runWhenIdle)(()=>{
                        (0, $jeyHF.default)((0, $02RAa.EVENT_CHANNEL))((0, $4hUAn.default)('operational.fireAnalyticEvent.commenced', {
                            action: action
                        }))(createAnalyticsEvent);
                    });
                    (0, $dmhJq.runWhenIdle)(async ()=>{
                        const { fireDatasourceEvent: fireDatasourceEvent } = await (parcelRequire("gSjLP"));
                        fireDatasourceEvent(action, createAnalyticsEvent, getDatasourceData)(...args);
                    });
                } catch (error) {
                    (0, $jeyHF.default)((0, $02RAa.EVENT_CHANNEL))((0, $4hUAn.default)('operational.fireAnalyticEvent.failed', {
                        error: error instanceof Error ? error.toString() : '',
                        action: action
                    }))(createAnalyticsEvent);
                }
            };
        return {
            datasourceCreated: factory('created'),
            datasourceUpdated: factory('updated'),
            datasourceDeleted: factory('deleted')
        };
    }, [
        createAnalyticsEvent,
        getDatasourceData
    ]);
};

});
parcelRegister("4hUAn", function(module, exports) {
$parcel$export(module.exports, "default", () => $63b1194d9afa4fff$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::c64352804e2dc1a0b65a6765b7979b51>>
 * @codegenCommand afm workspace @atlassian/analytics-tooling analytics:codegen link-analytics
 */ const $63b1194d9afa4fff$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $63b1194d9afa4fff$export$2e2bcd8739ae039 = $63b1194d9afa4fff$var$createEventPayload;

});

parcelRegister("02RAa", function(module, exports) {
$parcel$export(module.exports, "EVENT_CHANNEL", () => $bbc4ee0cae303c59$export$3f072f06b90c3985);
const $bbc4ee0cae303c59$export$3f072f06b90c3985 = 'media';

});

parcelRegister("dmhJq", function(module, exports) {
$parcel$export(module.exports, "runWhenIdle", () => $8e8ceec5715a6d60$export$51d09170c61ebe04);
/* eslint-disable compat/compat */ const $8e8ceec5715a6d60$export$51d09170c61ebe04 = (callback)=>window.requestIdleCallback ? window.requestIdleCallback(callback, {
        timeout: 5000
    }) : window.requestAnimationFrame(callback);

});

parcelRegister("gSjLP", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("8w6Hm"),
    $kOunM("4HRwt")
]).then(()=>parcelRequire('5vQ3l'));

});


parcelRegister("clnwZ", function(module, exports) {
$parcel$export(module.exports, "getMethod", () => $3dd3de9653fe988f$export$8793fab959da70d1);
$parcel$export(module.exports, "getLinkCreationType", () => $3dd3de9653fe988f$export$3dfce3fcb9ec933);
$parcel$export(module.exports, "getUpdateType", () => $3dd3de9653fe988f$export$df2aa842dc5172b0);
$parcel$export(module.exports, "getDeleteType", () => $3dd3de9653fe988f$export$1cf3d8365b174bde);
$parcel$export(module.exports, "getSourceEventFromMetadata", () => $3dd3de9653fe988f$export$b3b4df0d75d4c011);

var $hCYNe = parcelRequire("hCYNe");

var $g6Qq4 = parcelRequire("g6Qq4");
/**
 * If the metadata is for a history event,
 * returns undo/redo instead of instead of what fn(metadata) would have otherwise
 * returned
 */ const $3dd3de9653fe988f$var$withHistoryMethod = (fn)=>{
    return (metadata)=>{
        const { isUndo: isUndo, isRedo: isRedo } = metadata;
        if (isUndo) return 'undo';
        if (isRedo) return 'redo';
        return fn(metadata);
    };
};
const $3dd3de9653fe988f$export$8793fab959da70d1 = $3dd3de9653fe988f$var$withHistoryMethod(({ inputMethod: inputMethod, sourceEvent: sourceEvent })=>{
    var _payload;
    inputMethod = inputMethod ?? (sourceEvent === null || sourceEvent === void 0 || (_payload = sourceEvent.payload) === null || _payload === void 0 || (_payload = _payload.attributes) === null || _payload === void 0 ? void 0 : _payload.inputMethod);
    switch(inputMethod){
        case (0, $g6Qq4.INPUT_METHOD).CLIPBOARD:
            return 'editor_paste';
        case (0, $g6Qq4.INPUT_METHOD).FLOATING_TB:
            return 'editor_floatingToolbar';
        case (0, $g6Qq4.INPUT_METHOD).AUTO_DETECT:
        case (0, $g6Qq4.INPUT_METHOD).FORMATTING:
            return 'editor_type';
        case (0, $g6Qq4.INPUT_METHOD).TYPEAHEAD:
        case (0, $g6Qq4.INPUT_METHOD).MENTION_TYPEAHEAD:
            return 'linkpicker_searchResult';
        case (0, $g6Qq4.INPUT_METHOD).MANUAL:
            return 'linkpicker_manual';
        case (0, $g6Qq4.INPUT_METHOD).DATASOURCE:
            return 'datasource_config';
        default:
            return 'unknown';
    }
});
const $3dd3de9653fe988f$export$3dfce3fcb9ec933 = ({ inputMethod: inputMethod }, display)=>{
    if (inputMethod === (0, $g6Qq4.INPUT_METHOD).MENTION_TYPEAHEAD) return 'mention';
    return display === 'url' ? 'link' : 'conventionalSmartLink';
};
const $3dd3de9653fe988f$export$df2aa842dc5172b0 = $3dd3de9653fe988f$var$withHistoryMethod(({ action: action })=>{
    switch(action){
        case (0, $g6Qq4.ACTION).CHANGED_TYPE:
            return 'display_update';
        case (0, $g6Qq4.ACTION).UPDATED:
            return 'link_update';
        default:
            return 'unknown';
    }
});
const $3dd3de9653fe988f$export$1cf3d8365b174bde = $3dd3de9653fe988f$var$withHistoryMethod(({ action: action })=>{
    if (action === (0, $g6Qq4.ACTION).UNLINK) return 'unlink';
    return 'delete';
});
const $3dd3de9653fe988f$export$b3b4df0d75d4c011 = (metadata)=>{
    return metadata.sourceEvent instanceof (0, $hCYNe.default) ? metadata.sourceEvent : null;
};

});


parcelRegister("7wtCx", function(module, exports) {
$parcel$export(module.exports, "LinkEventsBinding", () => $cda756d1cfca9afc$export$aa142efb89c75ed5);

var $bSJIT = parcelRequire("bSJIT");

var $lVmeL = parcelRequire("lVmeL");

var $anGu7 = parcelRequire("anGu7");

var $8o1QB = parcelRequire("8o1QB");

var $clnwZ = parcelRequire("clnwZ");
/**
 * Set display category as `link` if not displaying the link as a smart card
 */ const $cda756d1cfca9afc$var$displayCategoryFromDisplay = (display)=>{
    if (display === 'url') return 'link';
};
const $cda756d1cfca9afc$export$aa142efb89c75ed5 = ({ cardPluginEvents: cardPluginEvents })=>{
    /**
   * These callbacks internally use window.requestIdleCallback/requestAnimationFrame
   * to defer any heavy operations involving network
   *
   * The callbacks themselves should not be deferred, they should be called syncronously the moment
   * the events take place.
   */ const { linkCreated: linkCreated, linkUpdated: linkUpdated, linkDeleted: linkDeleted } = (0, $lVmeL.useSmartLinkLifecycleAnalytics)();
    const linkEvents = (0, $bSJIT.useMemo)(()=>{
        return {
            [(0, $anGu7.EVENT).CREATED]: ({ node: node, nodeContext: nodeContext, ...metadata })=>{
                const url = (0, $8o1QB.getUrl)(node);
                if (!url) return;
                const display = (0, $8o1QB.appearanceForLink)(node);
                const displayCategory = $cda756d1cfca9afc$var$displayCategoryFromDisplay(display);
                const sourceEvent = (0, $clnwZ.getSourceEventFromMetadata)(metadata);
                const creationMethod = (0, $clnwZ.getMethod)(metadata);
                linkCreated({
                    url: url,
                    displayCategory: displayCategory
                }, sourceEvent, {
                    display: display,
                    nodeContext: nodeContext,
                    creationMethod: creationMethod,
                    linkCreationType: (0, $clnwZ.getLinkCreationType)(metadata, display)
                });
            },
            [(0, $anGu7.EVENT).UPDATED]: ({ node: node, nodeContext: nodeContext, previousDisplay: previousDisplay, ...metadata })=>{
                const url = (0, $8o1QB.getUrl)(node);
                if (!url) return;
                const display = (0, $8o1QB.appearanceForLink)(node);
                const displayCategory = $cda756d1cfca9afc$var$displayCategoryFromDisplay(display);
                const sourceEvent = (0, $clnwZ.getSourceEventFromMetadata)(metadata);
                const updateMethod = (0, $clnwZ.getMethod)(metadata);
                const updateType = (0, $clnwZ.getUpdateType)(metadata);
                linkUpdated({
                    url: url,
                    displayCategory: displayCategory
                }, sourceEvent, {
                    display: display,
                    previousDisplay: previousDisplay,
                    nodeContext: nodeContext,
                    updateMethod: updateMethod,
                    updateType: updateType
                });
            },
            [(0, $anGu7.EVENT).DELETED]: ({ node: node, nodeContext: nodeContext, ...metadata })=>{
                const url = (0, $8o1QB.getUrl)(node);
                if (!url) return;
                const display = (0, $8o1QB.appearanceForLink)(node);
                const displayCategory = $cda756d1cfca9afc$var$displayCategoryFromDisplay(display);
                const sourceEvent = (0, $clnwZ.getSourceEventFromMetadata)(metadata);
                const deleteMethod = (0, $clnwZ.getMethod)(metadata);
                const deleteType = (0, $clnwZ.getDeleteType)(metadata);
                linkDeleted({
                    url: url,
                    displayCategory: displayCategory
                }, sourceEvent, {
                    display: display,
                    nodeContext: nodeContext,
                    deleteMethod: deleteMethod,
                    deleteType: deleteType
                });
            }
        };
    }, [
        linkCreated,
        linkUpdated,
        linkDeleted
    ]);
    /**
   * Subscribe to link events
   */ (0, $bSJIT.useEffect)(()=>{
        const unsubscribe = cardPluginEvents.subscribe(({ event: event, subject: subject, data: data })=>{
            if (subject === (0, $anGu7.EVENT_SUBJECT).LINK) linkEvents[event](data);
        });
        return ()=>unsubscribe();
    }, [
        linkEvents,
        cardPluginEvents
    ]);
    return null;
};

});
parcelRegister("lVmeL", function(module, exports) {
$parcel$export(module.exports, "useSmartLinkLifecycleAnalytics", () => $72d194b9251a0ad7$export$612752b1e088a45e);

var $bSJIT = parcelRequire("bSJIT");

var $jeyHF = parcelRequire("jeyHF");

var $6WltM = parcelRequire("6WltM");

var $6bOBo = parcelRequire("6bOBo");

var $4hUAn = parcelRequire("4hUAn");

var $02RAa = parcelRequire("02RAa");

var $dmhJq = parcelRequire("dmhJq");

const $72d194b9251a0ad7$export$612752b1e088a45e = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
    const { store: store, connections: { client: client } } = (0, $6bOBo.useSmartLinkContext)();
    return (0, $bSJIT.useMemo)(()=>{
        const factory = (action)=>(...args)=>{
                try {
                    (0, $dmhJq.runWhenIdle)(()=>{
                        (0, $jeyHF.default)((0, $02RAa.EVENT_CHANNEL))((0, $4hUAn.default)('operational.fireAnalyticEvent.commenced', {
                            action: action
                        }))(createAnalyticsEvent);
                    });
                    (0, $dmhJq.runWhenIdle)(async ()=>{
                        const { default: fireEvent } = await (parcelRequire("f1MPr"));
                        fireEvent(action, createAnalyticsEvent, client, store)(...args);
                    });
                } catch (error) {
                    (0, $jeyHF.default)((0, $02RAa.EVENT_CHANNEL))((0, $4hUAn.default)('operational.fireAnalyticEvent.failed', {
                        error: error instanceof Error ? error.toString() : '',
                        action: action
                    }))(createAnalyticsEvent);
                }
            };
        return {
            linkCreated: factory('created'),
            linkUpdated: factory('updated'),
            linkDeleted: factory('deleted')
        };
    }, [
        client,
        store,
        createAnalyticsEvent
    ]);
};

});
parcelRegister("f1MPr", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("8w6Hm").then(()=>parcelRequire('8i2bP'));

});




parcelRegister("lVWRr", function(module, exports) {
$parcel$export(module.exports, "EditorSmartCardEvents", () => $b273f217bee106e1$export$e7d7ea2bc9a806d9);

var $bSJIT = parcelRequire("bSJIT");

var $i9EIo = parcelRequire("i9EIo");

var $k5X6V = parcelRequire("k5X6V");
const $b273f217bee106e1$export$e7d7ea2bc9a806d9 = ({ editorView: editorView })=>{
    const events = (0, $i9EIo.useSmartLinkEvents)();
    (0, $bSJIT.useEffect)(()=>{
        if (!events || !editorView) return;
        editorView.dispatch((0, $k5X6V.registerSmartCardEvents)(events)(editorView.state.tr));
    }, [
        events,
        editorView
    ]);
    return null;
};

});
parcelRegister("i9EIo", function(module, exports) {
$parcel$export(module.exports, "useSmartLinkEvents", () => $ae1789a1e702b62a$export$ed70996d478e16d3);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $bSJIT = parcelRequire("bSJIT");

var $k84EQ = parcelRequire("k84EQ");

function $ae1789a1e702b62a$export$ed70996d478e16d3() {
    /**
   * this utility maybe extended in the future to include
   * more contextual info about SLs
   */ const events = (0, $bSJIT.useMemo)(()=>new (0, $k84EQ.SmartLinkEvents)(), []);
    return events;
}

});
parcelRegister("k84EQ", function(module, exports) {
$parcel$export(module.exports, "SmartLinkEvents", () => $70b2c9c0f4390274$export$b91e0203b928470c);

var $3XeOI = parcelRequire("3XeOI");
class $70b2c9c0f4390274$export$b91e0203b928470c {
    insertSmartLink(url, type, createAnalyticsEvent) {
        (0, $3XeOI.fireSmartLinkEvent)({
            action: 'inserted',
            actionSubject: 'smartLink',
            eventType: 'track',
            attributes: {
                type: type
            },
            nonPrivacySafeAttributes: {
                domainName: url
            }
        }, createAnalyticsEvent);
    }
}

});
parcelRegister("3XeOI", function(module, exports) {
$parcel$export(module.exports, "fireSmartLinkEvent", () => $c365fbacb95e27c5$export$2a123f7ee48a122c);

var $2hVNZ = parcelRequire("2hVNZ");
const $c365fbacb95e27c5$export$2a123f7ee48a122c = (payload, createAnalyticsEvent)=>{
    if (createAnalyticsEvent) createAnalyticsEvent(payload).fire((0, $2hVNZ.ANALYTICS_CHANNEL));
};

});




parcelRegister("3VgrS", function(module, exports) {
$parcel$export(module.exports, "default", () => $13443bcc91585c86$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $fK3tS = parcelRequire("fK3tS");

var $5zk80 = parcelRequire("5zk80");

var $8zO6u = parcelRequire("8zO6u");

var $5beht = parcelRequire("5beht");

var $gKvvI = parcelRequire("gKvvI");
var $bRrJF = parcelRequire("bRrJF");

var $fuLqG = parcelRequire("fuLqG");

var $4PSAV = parcelRequire("4PSAV");

var $iyAOY = parcelRequire("iyAOY");

var $k5X6V = parcelRequire("k5X6V");

var $cKhMH = parcelRequire("cKhMH");

var $eusna = parcelRequire("eusna");
const $13443bcc91585c86$var$toolbarButtonWrapperStyles = /*#__PURE__*/ (0, $9dQre.css)({
    background: `${"var(--ds-background-neutral, #0515240F)"}`,
    color: `${"var(--ds-icon, #292A2E)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':hover': {
        background: `${"var(--ds-background-neutral-hovered, #0B120E24)"}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        color: `${"var(--ds-icon, #292A2E)"} !important`
    }
});
const $13443bcc91585c86$export$b5a1df4e06cdc467 = ({ onLayoutChange: onLayoutChange, layout: layout = (0, $iyAOY.DATASOURCE_DEFAULT_LAYOUT), intl: { formatMessage: formatMessage }, mountPoint: mountPoint, boundariesElement: boundariesElement, scrollableElement: scrollableElement, targetElement: targetElement, testId: testId = 'datasource-table-layout-button' })=>{
    const handleClick = (0, $bSJIT.useCallback)(()=>{
        onLayoutChange && onLayoutChange((0, $gKvvI.getNextBreakoutMode)(layout));
    }, [
        layout,
        onLayoutChange
    ]);
    const title = (0, $bSJIT.useMemo)(()=>{
        return formatMessage((0, $bRrJF.getTitle)(layout));
    }, [
        formatMessage,
        layout
    ]);
    if (!targetElement) return null;
    return /*#__PURE__*/ (0, $9dQre.jsx)((0, $5zk80.default), {
        mountTo: mountPoint,
        boundariesElement: boundariesElement,
        scrollableElement: scrollableElement,
        target: targetElement,
        alignY: "start",
        alignX: "end",
        forcePlacement: true,
        stick: true,
        ariaLabel: title
    }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $8zO6u.default), {
        testId: testId,
        css: $13443bcc91585c86$var$toolbarButtonWrapperStyles,
        title: title,
        onClick: handleClick,
        iconBefore: layout === 'full-width' ? /*#__PURE__*/ (0, $9dQre.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4PSAV))), {
            label: title
        }) : /*#__PURE__*/ (0, $9dQre.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fuLqG))), {
            label: title
        })
    }));
};
const $13443bcc91585c86$var$selector = (states)=>{
    var _states$cardState, _states$cardState2;
    return {
        layout: (_states$cardState = states.cardState) === null || _states$cardState === void 0 ? void 0 : _states$cardState.layout,
        datasourceTableRef: (_states$cardState2 = states.cardState) === null || _states$cardState2 === void 0 ? void 0 : _states$cardState2.datasourceTableRef
    };
};
const $13443bcc91585c86$var$LayoutButtonWrapper = ({ editorView: editorView, mountPoint: mountPoint, scrollableElement: scrollableElement, boundariesElement: boundariesElement, intl: intl, api: api })=>{
    var _node$attrs;
    const { node: node, pos: pos } = (0, $eusna.getDatasource)(editorView);
    const { layout: layout = (node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.layout) || undefined, datasourceTableRef: datasourceTableRef } = (0, $5beht.useSharedPluginStateWithSelector)(api, [
        'card'
    ], $13443bcc91585c86$var$selector);
    const isDatasource = (0, $cKhMH.isDatasourceNode)(node);
    if (!isDatasource) return null;
    const onLayoutChange = (layout)=>{
        if (pos === undefined) return;
        const { state: state, dispatch: dispatch } = editorView;
        // If the button does not re-render due to no card state change, node reference will be stale
        const datasourceNode = (0, $eusna.getDatasource)(editorView).node ?? node;
        const tr = state.tr.setNodeMarkup(pos, undefined, {
            ...datasourceNode === null || datasourceNode === void 0 ? void 0 : datasourceNode.attrs,
            layout: layout
        });
        tr.setMeta('scrollIntoView', false);
        dispatch((0, $k5X6V.setCardLayout)(layout)(tr));
    };
    return /*#__PURE__*/ (0, $9dQre.jsx)($13443bcc91585c86$export$b5a1df4e06cdc467, {
        mountPoint: mountPoint,
        scrollableElement: scrollableElement,
        boundariesElement: boundariesElement,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        targetElement: datasourceTableRef,
        layout: (0, $eusna.isDatasourceTableLayout)(layout) ? layout : undefined,
        onLayoutChange: onLayoutChange,
        intl: intl
    });
};
const $13443bcc91585c86$var$_default_1 = (0, $fK3tS.default)($13443bcc91585c86$var$LayoutButtonWrapper);
var $13443bcc91585c86$export$2e2bcd8739ae039 = $13443bcc91585c86$var$_default_1;

});

parcelRegister("9eoOg", function(module, exports) {
$parcel$export(module.exports, "getPasteDisplayAsMenuComponents", () => $6e2376bd76e1aa5c$export$996593790cad4497);
/* PasteDisplayAsMenu.tsx generated by @compiled/babel-plugin v3.0.2 */ /* PasteDisplayAsMenu.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $jDsoo = parcelRequire("jDsoo");

var $41dWF = parcelRequire("41dWF");

var $bk3yN = parcelRequire("bk3yN");

var $28qc1 = parcelRequire("28qc1");

var $4rzOL = parcelRequire("4rzOL");

var $5beht = parcelRequire("5beht");

var $kRFDj = parcelRequire("kRFDj");

var $kW8qW = parcelRequire("kW8qW");

var $cw0wu = parcelRequire("cw0wu");

var $dlk6h = parcelRequire("dlk6h");

var $7bYyx = parcelRequire("7bYyx");

var $eHnl8 = parcelRequire("eHnl8");

var $g3Ytr = parcelRequire("g3Ytr");

var $lWuWs = parcelRequire("lWuWs");

var $lqWtA = parcelRequire("lqWtA");

var $jaXwU = parcelRequire("jaXwU");

var $6TyVm = parcelRequire("6TyVm");

var $9PwDt = parcelRequire("9PwDt");

var $6X9z7 = parcelRequire("6X9z7");

var $gXqq0 = parcelRequire("gXqq0");

var $4zjoa = parcelRequire("4zjoa");

var $a76m2 = parcelRequire("a76m2");

var $5DpNP = parcelRequire("5DpNP");

var $5cz2o = parcelRequire("5cz2o");

var $4FG8b = parcelRequire("4FG8b");
const $6e2376bd76e1aa5c$export$3360e99680efcdd8 = 'smart-link-display-as-paste-menu-section';
const $6e2376bd76e1aa5c$var$styles = {
    appearanceBox: "_2rko1qi0 _bfhkhfxm _19pku2gc _2hwxu2gc _otyru2gc _18u0u2gc _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
    iconWrapper: "_1e0c11p5 _yv0ehkll _1bsb1osq",
    iconButton: "_2rko1qi0 _1h6d1l7x _1dqonqa1 _189ee4h9 _4cvr1h6o _syazi7uo _1e0c1txw _4t3izwfg _1bah1h6o _1bsb1osq _bfhksm61 _irr31dpa _1di6fcek",
    iconButtonSelected: "_2rko1qi0 _1h6dq98m _1dqonqa1 _189ee4h9 _4cvr1h6o _bfhk15s3 _syazi7uo _1e0c1txw _4t3izwfg _1bah1h6o _1bsb1osq _irr3ufnl _1di6nozp",
    iconButtonDisabled: "_2rko1qi0 _1h6dbk0g _1dqonqa1 _189ee4h9 _4cvr1h6o _bfhk187o _syaz1gmx _1e0c1txw _4t3izwfg _1bah1h6o _1bsb1osq"
};
const $6e2376bd76e1aa5c$var$AppearanceOptionIconButton = ({ appearance: appearance, currentAppearance: currentAppearance, isDisabled: isDisabled, label: label, Icon: Icon, onClick: onClick })=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
        xcss: $6e2376bd76e1aa5c$var$styles.iconWrapper,
        "data-toolbar-component": "menu-item",
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $eHnl8.ToolbarTooltip), {
            content: label,
            position: "bottom",
            children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $gXqq0.Pressable), {
                xcss: (0, $jDsoo.cx)($6e2376bd76e1aa5c$var$styles.iconButton, isDisabled && $6e2376bd76e1aa5c$var$styles.iconButtonDisabled, !isDisabled && currentAppearance === appearance && $6e2376bd76e1aa5c$var$styles.iconButtonSelected),
                "aria-label": label,
                "aria-pressed": currentAppearance === appearance,
                isDisabled: isDisabled,
                onClick: onClick,
                children: /*#__PURE__*/ (0, $dc70d.jsx)(Icon, {
                    label: label
                })
            })
        })
    });
};
const $6e2376bd76e1aa5c$var$InlineAppearanceIconButton = ({ currentAppearance: currentAppearance, isDisabled: isDisabled, label: label, onClick: onClick })=>/*#__PURE__*/ (0, $dc70d.jsx)($6e2376bd76e1aa5c$var$AppearanceOptionIconButton, {
        appearance: "inline",
        currentAppearance: currentAppearance,
        isDisabled: isDisabled,
        label: label,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($jaXwU))),
        onClick: onClick
    });
const $6e2376bd76e1aa5c$var$BlockAppearanceIconButton = ({ currentAppearance: currentAppearance, isDisabled: isDisabled, label: label, onClick: onClick })=>/*#__PURE__*/ (0, $dc70d.jsx)($6e2376bd76e1aa5c$var$AppearanceOptionIconButton, {
        appearance: "block",
        currentAppearance: currentAppearance,
        isDisabled: isDisabled,
        label: label,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($lWuWs))),
        onClick: onClick
    });
const $6e2376bd76e1aa5c$var$EmbedAppearanceIconButton = ({ currentAppearance: currentAppearance, isDisabled: isDisabled, label: label, onClick: onClick })=>/*#__PURE__*/ (0, $dc70d.jsx)($6e2376bd76e1aa5c$var$AppearanceOptionIconButton, {
        appearance: "embed",
        currentAppearance: currentAppearance,
        isDisabled: isDisabled,
        label: label,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($lqWtA))),
        onClick: onClick
    });
const $6e2376bd76e1aa5c$var$getCurrentPastedSlice = (api)=>{
    var _apiWithPaste$paste, _pasteState$lastConte;
    const apiWithPaste = api;
    const pasteState = apiWithPaste === null || apiWithPaste === void 0 || (_apiWithPaste$paste = apiWithPaste.paste) === null || _apiWithPaste$paste === void 0 ? void 0 : _apiWithPaste$paste.sharedState.currentState();
    const slice = pasteState === null || pasteState === void 0 || (_pasteState$lastConte = pasteState.lastContentPasted) === null || _pasteState$lastConte === void 0 ? void 0 : _pasteState$lastConte.pastedSlice;
    return slice;
};
const $6e2376bd76e1aa5c$var$getCardUrlAtPasteRange = ({ editorView: editorView, pasteStartPos: pasteStartPos, pasteEndPos: pasteEndPos })=>{
    var _maybeAttrs$data;
    const cardAtPasteRange = (0, $4FG8b.getCardAtPasteRange)(editorView.state, pasteStartPos, pasteEndPos);
    if (!cardAtPasteRange) return undefined;
    const node = editorView.state.doc.nodeAt(cardAtPasteRange.pos);
    if (!node) return undefined;
    if (cardAtPasteRange.isNativeEmbed) return (0, $5cz2o.getNativeEmbedUrl)(node);
    const maybeAttrs = node.attrs;
    const maybeUrl = (maybeAttrs === null || maybeAttrs === void 0 ? void 0 : maybeAttrs.url) ?? (maybeAttrs === null || maybeAttrs === void 0 || (_maybeAttrs$data = maybeAttrs.data) === null || _maybeAttrs$data === void 0 ? void 0 : _maybeAttrs$data.url);
    return typeof maybeUrl === 'string' ? maybeUrl : undefined;
};
const $6e2376bd76e1aa5c$export$790142d87e85490c = ({ editorView: editorView, pasteStartPos: pasteStartPos, pasteEndPos: pasteEndPos, targetPos: targetPos })=>{
    const { state: state, dispatch: dispatch } = editorView;
    const maxPos = state.doc.content.size;
    const clampedStart = Math.max(0, Math.min(pasteStartPos, maxPos));
    const clampedEnd = Math.max(0, Math.min(pasteEndPos, maxPos));
    const from = Math.min(clampedStart, clampedEnd);
    const to = Math.max(clampedStart, clampedEnd);
    const isTargetPosInBounds = targetPos !== undefined && targetPos >= 0 && targetPos <= state.doc.content.size;
    try {
        const nextSelection = isTargetPosInBounds && targetPos !== undefined ? (0, $cw0wu.NodeSelection).create(state.doc, targetPos) : (0, $cw0wu.TextSelection).create(state.doc, from, to);
        const tr = state.tr.setSelection(nextSelection);
        dispatch(tr);
        return true;
    } catch  {
        return false;
    }
};
const $6e2376bd76e1aa5c$export$1c4f761565a0a1c6 = (editorView)=>{
    const { state: state } = editorView;
    const linkMarkType = state.schema.marks.link;
    if (!linkMarkType) return;
    let firstLinkRange;
    state.doc.nodesBetween(state.selection.from, state.selection.to, (node, pos)=>{
        if (firstLinkRange || !node.isText) return;
        if (linkMarkType.isInSet(node.marks)) firstLinkRange = {
            from: pos,
            to: pos + node.nodeSize
        };
    });
    return firstLinkRange;
};
const $6e2376bd76e1aa5c$export$50ed46eb055a4a90 = ({ editorView: editorView, targetPos: targetPos })=>{
    if (targetPos !== undefined || (0, $bk3yN.getActiveLinkMark)(editorView.state)) return;
    const firstLinkRange = $6e2376bd76e1aa5c$export$1c4f761565a0a1c6(editorView);
    if (!firstLinkRange) return;
    const linkRangeSelectionTr = editorView.state.tr.setSelection((0, $cw0wu.TextSelection).create(editorView.state.doc, firstLinkRange.from, firstLinkRange.to));
    editorView.dispatch(linkRangeSelectionTr);
};
const $6e2376bd76e1aa5c$var$PasteDisplayAsMenuHorizontalView = ({ api: api, allowBlockCards: allowBlockCards, allowEmbeds: allowEmbeds })=>{
    var _smartCardContext$val, _smartCardContext$val2;
    const intl = (0, $4vLTk.default)();
    const { editorView: editorView } = (0, $28qc1.useEditorToolbar)();
    const toolbarDropdownMenu = (0, $7bYyx.useToolbarDropdownMenu)();
    const smartCardContext = (0, $6TyVm.useSmartCardContext)();
    const frameRef = (0, $bSJIT.useRef)(null);
    const isApplyingRef = (0, $bSJIT.useRef)(false);
    const apiWithPasteOptionsToolbar = api;
    const pasteRange = (0, $5beht.useSharedPluginStateWithSelector)(apiWithPasteOptionsToolbar, [
        'pasteOptionsToolbarPlugin'
    ], (states)=>{
        const pluginState = states.pasteOptionsToolbarPluginState;
        return pluginState ? {
            pasteEndPos: pluginState.pasteEndPos,
            pasteStartPos: pluginState.pasteStartPos
        } : undefined;
    });
    // Subscribe to card state so the menu re-renders when resolved card metadata updates.
    (0, $5beht.useSharedPluginStateWithSelector)(api, [
        'card'
    ], (states)=>{
        return states.cardState;
    });
    const pastedLinkUrlFromSlice = (0, $5DpNP.getSingleSmartLinkUrlFromSlice)($6e2376bd76e1aa5c$var$getCurrentPastedSlice(api));
    const pastedLinkUrlFromCard = editorView && pasteRange ? $6e2376bd76e1aa5c$var$getCardUrlAtPasteRange({
        editorView: editorView,
        pasteStartPos: pasteRange.pasteStartPos,
        pasteEndPos: pasteRange.pasteEndPos
    }) : undefined;
    const pastedLinkUrl = pastedLinkUrlFromSlice ?? pastedLinkUrlFromCard;
    const pastedLinkUrlState = pastedLinkUrl ? (_smartCardContext$val = smartCardContext.value) === null || _smartCardContext$val === void 0 || (_smartCardContext$val = _smartCardContext$val.store) === null || _smartCardContext$val === void 0 || (_smartCardContext$val = _smartCardContext$val.getState()) === null || _smartCardContext$val === void 0 ? void 0 : _smartCardContext$val[pastedLinkUrl] : undefined;
    const hasResolvedSmartLinkData = Boolean(pastedLinkUrlState === null || pastedLinkUrlState === void 0 ? void 0 : pastedLinkUrlState.details);
    const cardAtPasteRange = editorView && pasteRange ? (0, $4FG8b.getCardAtPasteRange)(editorView.state, pasteRange.pasteStartPos, pasteRange.pasteEndPos, pastedLinkUrl) : undefined;
    const currentAppearance = editorView && pasteRange ? (cardAtPasteRange === null || cardAtPasteRange === void 0 ? void 0 : cardAtPasteRange.appearance) ?? 'url' : undefined;
    // A 1P link that resolves to an embed is inserted as a native embed, not an embedCard.
    // It displays as an embed, but the card commands cannot change its appearance.
    const isNativeEmbedPaste = Boolean(cardAtPasteRange === null || cardAtPasteRange === void 0 ? void 0 : cardAtPasteRange.isNativeEmbed);
    const handleClick = (0, $bSJIT.useCallback)((appearance)=>()=>{
            var _state$doc$nodeAt, _targetNodeAttrs$data;
            if (!editorView || !pasteRange || !pastedLinkUrl || !currentAppearance || isApplyingRef.current) return;
            isApplyingRef.current = true;
            const { state: state, dispatch: dispatch } = editorView;
            const { pasteStartPos: pasteStartPos, pasteEndPos: pasteEndPos } = pasteRange;
            const cardAtRange = (0, $4FG8b.getCardAtPasteRange)(state, pasteStartPos, pasteEndPos, pastedLinkUrl);
            if (cardAtRange !== null && cardAtRange !== void 0 && cardAtRange.isNativeEmbed) {
                const nativeEmbedNode = state.doc.nodeAt(cardAtRange.pos);
                // 'embed' is what a native embed already displays as, so there is nothing to apply.
                if (nativeEmbedNode && appearance !== 'embed') {
                    var _api$analytics;
                    (0, $5cz2o.changeNativeEmbedAppearance)({
                        editorView: editorView,
                        pos: cardAtRange.pos,
                        node: nativeEmbedNode,
                        appearance: appearance,
                        url: pastedLinkUrl,
                        editorAnalyticsApi: api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions
                    });
                }
                toolbarDropdownMenu === null || toolbarDropdownMenu === void 0 || toolbarDropdownMenu.closeMenu(null);
                isApplyingRef.current = false;
                return;
            }
            if (appearance === 'url') {
                if (cardAtRange) {
                    var _api$analytics2;
                    (0, $a76m2.changeSelectedCardToLink)(pastedLinkUrl, pastedLinkUrl, true, state.doc.nodeAt(cardAtRange.pos) ?? undefined, cardAtRange.pos, api === null || api === void 0 || (_api$analytics2 = api.analytics) === null || _api$analytics2 === void 0 ? void 0 : _api$analytics2.actions)(state, dispatch, editorView);
                }
                toolbarDropdownMenu === null || toolbarDropdownMenu === void 0 || toolbarDropdownMenu.closeMenu(null);
                isApplyingRef.current = false;
                return;
            }
            const targetPos = cardAtRange === null || cardAtRange === void 0 ? void 0 : cardAtRange.pos;
            const targetNodeAttrs = targetPos === undefined ? undefined : (_state$doc$nodeAt = state.doc.nodeAt(targetPos)) === null || _state$doc$nodeAt === void 0 ? void 0 : _state$doc$nodeAt.attrs;
            const targetNodeUrl = (targetNodeAttrs === null || targetNodeAttrs === void 0 ? void 0 : targetNodeAttrs.url) ?? (targetNodeAttrs === null || targetNodeAttrs === void 0 || (_targetNodeAttrs$data = targetNodeAttrs.data) === null || _targetNodeAttrs$data === void 0 ? void 0 : _targetNodeAttrs$data.url);
            const isRecoveredAdjacentPastedCard = (0, $4zjoa.expValEqualsNoExposure)('confluence_editor_paste_3p_link_actions_menu', 'isEnabled', true) && targetPos === pasteStartPos - 1 && pasteStartPos === pasteEndPos && targetNodeUrl === pastedLinkUrl;
            if (targetPos !== undefined && targetPos < pasteStartPos && !isRecoveredAdjacentPastedCard) {
                isApplyingRef.current = false;
                return;
            }
            const didApplySelection = $6e2376bd76e1aa5c$export$790142d87e85490c({
                editorView: editorView,
                pasteStartPos: pasteStartPos,
                pasteEndPos: pasteEndPos,
                targetPos: targetPos
            });
            if (!didApplySelection) {
                toolbarDropdownMenu === null || toolbarDropdownMenu === void 0 || toolbarDropdownMenu.closeMenu(null);
                isApplyingRef.current = false;
                return;
            }
            $6e2376bd76e1aa5c$export$50ed46eb055a4a90({
                editorView: editorView,
                targetPos: targetPos
            });
            frameRef.current = requestAnimationFrame(()=>{
                var _api$analytics3;
                frameRef.current = null;
                (0, $a76m2.setSelectedCardAppearance)(appearance, api === null || api === void 0 || (_api$analytics3 = api.analytics) === null || _api$analytics3 === void 0 ? void 0 : _api$analytics3.actions)(editorView.state, editorView.dispatch, editorView);
                toolbarDropdownMenu === null || toolbarDropdownMenu === void 0 || toolbarDropdownMenu.closeMenu(null);
                isApplyingRef.current = false;
            });
        }, [
        api,
        currentAppearance,
        editorView,
        pasteRange,
        pastedLinkUrl,
        toolbarDropdownMenu
    ]);
    (0, $bSJIT.useEffect)(()=>{
        return ()=>{
            if (frameRef.current !== null) cancelAnimationFrame(frameRef.current);
            isApplyingRef.current = false;
        };
    }, []);
    if (!editorView || !pasteRange || !pastedLinkUrl || !currentAppearance) return null;
    const preview = allowEmbeds && pastedLinkUrl && ((_smartCardContext$val2 = smartCardContext.value) === null || _smartCardContext$val2 === void 0 ? void 0 : _smartCardContext$val2.extractors.getPreview(pastedLinkUrl, 'web'));
    const blockCardNodeType = editorView.state.schema.nodes.blockCard;
    const embedCardNodeType = editorView.state.schema.nodes.embedCard;
    const isBlockSupportedFromAppearanceContext = allowBlockCards && blockCardNodeType && (0, $kRFDj.isSupportedInParent)(editorView.state, (0, $kW8qW.Fragment).from(blockCardNodeType.createChecked({})), currentAppearance === 'url' || currentAppearance === 'inline' ? undefined : currentAppearance);
    const isEmbedSupportedFromAppearanceContext = allowEmbeds && preview && embedCardNodeType && (0, $kRFDj.isSupportedInParent)(editorView.state, (0, $kW8qW.Fragment).from(embedCardNodeType.createChecked({})), currentAppearance === 'url' || currentAppearance === 'inline' ? undefined : currentAppearance);
    const isSmartLinkConvertible = hasResolvedSmartLinkData;
    const isBlockSupportedFromSelection = allowBlockCards && blockCardNodeType && (0, $kRFDj.isSupportedInParent)(editorView.state, (0, $kW8qW.Fragment).from(blockCardNodeType.createChecked({})), undefined);
    const isEmbedSupportedFromSelection = allowEmbeds && preview && embedCardNodeType && (0, $kRFDj.isSupportedInParent)(editorView.state, (0, $kW8qW.Fragment).from(embedCardNodeType.createChecked({})), undefined);
    // A native embed is replaced in place, so support depends on what its own position
    // accepts rather than on the current selection or on an embed preview being available.
    const nativeEmbedPos = isNativeEmbedPaste ? cardAtPasteRange === null || cardAtPasteRange === void 0 ? void 0 : cardAtPasteRange.pos : undefined;
    const isSupportedForNativeEmbed = (appearance)=>nativeEmbedPos !== undefined && (0, $5cz2o.isNativeEmbedAppearanceSupported)({
            editorView: editorView,
            pos: nativeEmbedPos,
            appearance: appearance
        });
    const isInlineSupported = isNativeEmbedPaste ? isSupportedForNativeEmbed('inline') : true;
    const isBlockSupported = isNativeEmbedPaste ? allowBlockCards && isSupportedForNativeEmbed('block') : Boolean(isBlockSupportedFromAppearanceContext || isBlockSupportedFromSelection);
    const isEmbedSupported = // Whatever was pasted already displays this way, so the option must stay selectable.
    currentAppearance === 'embed' || Boolean(isEmbedSupportedFromAppearanceContext || isEmbedSupportedFromSelection);
    return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $6X9z7.Flex), {
        xcss: $6e2376bd76e1aa5c$var$styles.appearanceBox,
        gap: "space.050",
        children: [
            /*#__PURE__*/ (0, $dc70d.jsx)($6e2376bd76e1aa5c$var$AppearanceOptionIconButton, {
                appearance: "url",
                currentAppearance: currentAppearance,
                isDisabled: isNativeEmbedPaste && !isSupportedForNativeEmbed('url'),
                label: intl.formatMessage((0, $41dWF.appearancePropsMap).url.title),
                Icon: (0, (/*@__PURE__*/$parcel$interopDefault($g3Ytr))),
                onClick: handleClick('url')
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)($6e2376bd76e1aa5c$var$InlineAppearanceIconButton, {
                currentAppearance: currentAppearance,
                isDisabled: isNativeEmbedPaste ? !isInlineSupported : !isSmartLinkConvertible,
                label: intl.formatMessage((0, $41dWF.appearancePropsMap).inline.title),
                onClick: handleClick('inline')
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)($6e2376bd76e1aa5c$var$BlockAppearanceIconButton, {
                currentAppearance: currentAppearance,
                isDisabled: !isBlockSupported || !isNativeEmbedPaste && !isSmartLinkConvertible,
                label: intl.formatMessage((0, $41dWF.appearancePropsMap).block.title),
                onClick: handleClick('block')
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)($6e2376bd76e1aa5c$var$EmbedAppearanceIconButton, {
                currentAppearance: currentAppearance,
                isDisabled: !isEmbedSupported,
                label: intl.formatMessage((0, $41dWF.appearancePropsMap).embed.title),
                onClick: handleClick('embed')
            })
        ]
    });
};
const $6e2376bd76e1aa5c$var$PasteDisplayAsMenuSection = ({ api: api, allowBlockCards: allowBlockCards, allowEmbeds: allowEmbeds })=>{
    const intl = (0, $4vLTk.default)();
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dlk6h.ToolbarDropdownItemSection), {
        title: intl.formatMessage({
            defaultMessage: 'Display as',
            description: 'Section title for Smart Link display options in the paste actions menu.',
            id: 'fabric.editor.pasteDisplayAsMenu.displayAs'
        }),
        children: /*#__PURE__*/ (0, $dc70d.jsx)($6e2376bd76e1aa5c$var$PasteDisplayAsMenuHorizontalView, {
            api: api,
            allowBlockCards: allowBlockCards,
            allowEmbeds: allowEmbeds
        })
    });
};
const $6e2376bd76e1aa5c$export$996593790cad4497 = ({ api: api, allowBlockCards: allowBlockCards, allowEmbeds: allowEmbeds, getEditorView: getEditorView, smartCardClientRef: smartCardClientRef })=>{
    const smartlinkAsyncHidden = async (context)=>{
        const { pastedUrl: pastedUrl } = context;
        if (!pastedUrl) return false;
        const isEnabled = (0, $4zjoa.expValEqualsNoExposure)('confluence_editor_paste_3p_link_actions_menu', 'isEnabled', true);
        const smartCardClient = smartCardClientRef === null || smartCardClientRef === void 0 ? void 0 : smartCardClientRef.current;
        if (!isEnabled || !smartCardClient) return true;
        try {
            var _response$meta;
            const response = await smartCardClient.fetchData(pastedUrl);
            return ((_response$meta = response.meta) === null || _response$meta === void 0 ? void 0 : _response$meta.access) !== 'granted';
        } catch  {
            // Network / auth errors → hide
            return true;
        }
    };
    return [
        {
            type: 'menu-section',
            key: $6e2376bd76e1aa5c$export$3360e99680efcdd8,
            parents: [
                {
                    type: (0, $4rzOL.PASTE_MENU).type,
                    key: (0, $4rzOL.PASTE_MENU).key,
                    rank: 60
                }
            ],
            isAsyncHidden: smartlinkAsyncHidden,
            isHidden: ()=>{
                var _apiWithPasteOptionsT, _apiWithPasteOptionsT2;
                if (!(0, $4zjoa.expValEqualsNoExposure)('confluence_editor_paste_3p_link_actions_menu', 'isEnabled', true)) return true;
                const apiWithPasteOptionsToolbar = api;
                const pasteRange = apiWithPasteOptionsToolbar === null || apiWithPasteOptionsToolbar === void 0 || (_apiWithPasteOptionsT = apiWithPasteOptionsToolbar.pasteOptionsToolbarPlugin) === null || _apiWithPasteOptionsT === void 0 ? void 0 : _apiWithPasteOptionsT.sharedState.currentState();
                const editorView = getEditorView();
                if (!editorView || !pasteRange) return true;
                // Slice-shape check — delegated to the toolbar plugin's shared
                // `notSingleLinkRule` via the structural cast (see note above).
                const rules = apiWithPasteOptionsToolbar === null || apiWithPasteOptionsToolbar === void 0 || (_apiWithPasteOptionsT2 = apiWithPasteOptionsToolbar.pasteOptionsToolbarPlugin) === null || _apiWithPasteOptionsT2 === void 0 ? void 0 : _apiWithPasteOptionsT2.actions.getPasteMenuRules();
                if (!rules || rules.notSingleLinkRule()) return true;
                const urlFromSlice = (0, $5DpNP.getSingleSmartLinkUrlFromSlice)($6e2376bd76e1aa5c$var$getCurrentPastedSlice(api));
                if (urlFromSlice) return false;
                // Fallback: plain-text URL paste that the card plugin already resolved into a card node in the doc.
                const urlFromCard = $6e2376bd76e1aa5c$var$getCardUrlAtPasteRange({
                    editorView: editorView,
                    pasteStartPos: pasteRange.pasteStartPos,
                    pasteEndPos: pasteRange.pasteEndPos
                });
                return !urlFromCard;
            },
            component: ()=>/*#__PURE__*/ (0, $dc70d.jsx)($6e2376bd76e1aa5c$var$PasteDisplayAsMenuSection, {
                    api: api,
                    allowBlockCards: allowBlockCards,
                    allowEmbeds: allowEmbeds
                })
        }
    ];
};

});
parcelRegister("5DpNP", function(module, exports) {
$parcel$export(module.exports, "getSingleSmartLinkUrlFromSlice", () => $21232ead11f29694$export$6f4c320e305ef7dc);
const $21232ead11f29694$var$getUrlFromTextLinkNode = (node)=>{
    var _node$marks$0$attrs;
    if (!node.isText || node.marks.length !== 1 || node.marks[0].type.name !== 'link') return undefined;
    const href = (_node$marks$0$attrs = node.marks[0].attrs) === null || _node$marks$0$attrs === void 0 ? void 0 : _node$marks$0$attrs.href;
    return typeof href === 'string' && node.text === href ? href : undefined;
};
const $21232ead11f29694$var$getUrlFromCardNode = (node)=>{
    var _node$attrs, _node$attrs2;
    if (node.type.name !== 'inlineCard' && node.type.name !== 'blockCard' && node.type.name !== 'embedCard') return undefined;
    const url = ((_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.url) ?? ((_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 || (_node$attrs2 = _node$attrs2.data) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.url);
    return typeof url === 'string' ? url : undefined;
};
const $21232ead11f29694$var$significantChildren = (fragment)=>{
    const children = [];
    fragment.forEach((child)=>{
        var _child$text;
        if (child.isText && ((_child$text = child.text) === null || _child$text === void 0 ? void 0 : _child$text.trim()) === '') return;
        children.push(child);
    });
    return children;
};
const $21232ead11f29694$export$6f4c320e305ef7dc = (slice)=>{
    if (!slice || slice.content.childCount !== 1) return undefined;
    const topNode = slice.content.child(0);
    const topNodeUrl = $21232ead11f29694$var$getUrlFromTextLinkNode(topNode) ?? $21232ead11f29694$var$getUrlFromCardNode(topNode);
    if (topNodeUrl) return topNodeUrl;
    if (topNode.type.name !== 'paragraph') return undefined;
    const children = $21232ead11f29694$var$significantChildren(topNode.content);
    if (children.length !== 1) return undefined;
    return $21232ead11f29694$var$getUrlFromTextLinkNode(children[0]) ?? $21232ead11f29694$var$getUrlFromCardNode(children[0]);
};

});

parcelRegister("5cz2o", function(module, exports) {
$parcel$export(module.exports, "isNativeEmbedNode", () => $6c8992afd155ac7d$export$a990e9e9e93229aa);
$parcel$export(module.exports, "getNativeEmbedUrl", () => $6c8992afd155ac7d$export$98ee8d0cf866fa75);
$parcel$export(module.exports, "isNativeEmbedAppearanceSupported", () => $6c8992afd155ac7d$export$36c7c06292ba7472);
$parcel$export(module.exports, "changeNativeEmbedAppearance", () => $6c8992afd155ac7d$export$127d7a4a58bf6ed2);

var $7nI18 = parcelRequire("7nI18");

var $g6Qq4 = parcelRequire("g6Qq4");

var $6o5zV = parcelRequire("6o5zV");
const $6c8992afd155ac7d$export$a990e9e9e93229aa = (node)=>{
    var _node$attrs, _node$attrs2;
    return (node === null || node === void 0 ? void 0 : node.type.name) === 'extension' && ((_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.extensionType) === (0, $6o5zV.NATIVE_EMBED_EXTENSION_TYPE) && typeof ((_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.extensionKey) === 'string' && node.attrs.extensionKey.includes((0, $6o5zV.NATIVE_EMBED_EXTENSION_KEY));
};
const $6c8992afd155ac7d$export$98ee8d0cf866fa75 = (node)=>{
    var _node$attrs3, _parameters$macroPara, _parameters$macroMeta;
    const parameters = (_node$attrs3 = node.attrs) === null || _node$attrs3 === void 0 ? void 0 : _node$attrs3.parameters;
    const macroParamUrl = parameters === null || parameters === void 0 || (_parameters$macroPara = parameters.macroParams) === null || _parameters$macroPara === void 0 ? void 0 : _parameters$macroPara.url;
    const url = (macroParamUrl && typeof macroParamUrl === 'object' && 'value' in macroParamUrl ? macroParamUrl.value : macroParamUrl) ?? (parameters === null || parameters === void 0 || (_parameters$macroMeta = parameters.macroMetadata) === null || _parameters$macroMeta === void 0 ? void 0 : _parameters$macroMeta.url);
    return typeof url === 'string' ? url : undefined;
};
const $6c8992afd155ac7d$var$canReplaceNodeWith = (view, pos, nodeType)=>{
    if (!nodeType) return false;
    try {
        const $pos = view.state.doc.resolve(pos);
        const index = $pos.index();
        return $pos.parent.canReplaceWith(index, index + 1, nodeType);
    } catch  {
        return false;
    }
};
const $6c8992afd155ac7d$export$36c7c06292ba7472 = ({ editorView: editorView, pos: pos, appearance: appearance })=>{
    const { paragraph: paragraph, inlineCard: inlineCard, blockCard: blockCard } = editorView.state.schema.nodes;
    if (appearance === 'block') return $6c8992afd155ac7d$var$canReplaceNodeWith(editorView, pos, blockCard);
    if (appearance === 'inline' && !inlineCard) return false;
    if (appearance === 'url' && !editorView.state.schema.marks.link) return false;
    return $6c8992afd155ac7d$var$canReplaceNodeWith(editorView, pos, paragraph);
};
const $6c8992afd155ac7d$export$127d7a4a58bf6ed2 = ({ editorView: editorView, pos: pos, node: node, appearance: appearance, url: url, editorAnalyticsApi: editorAnalyticsApi })=>{
    const { state: state, dispatch: dispatch } = editorView;
    const { paragraph: paragraph, inlineCard: inlineCard, blockCard: blockCard } = state.schema.nodes;
    const { link: link } = state.schema.marks;
    if (!(0, $7nI18.isSafeUrl)(url)) return false;
    let content;
    if (appearance === 'url' && link && paragraph) content = paragraph.create(null, state.schema.text(url, [
        link.create({
            href: url
        })
    ]));
    else if (appearance === 'inline' && inlineCard && paragraph) content = paragraph.create(null, inlineCard.create({
        url: url
    }));
    else if (appearance === 'block' && blockCard) content = blockCard.create({
        url: url
    });
    if (!content) return false;
    try {
        const tr = state.tr.replaceWith(pos, pos + node.nodeSize, content).scrollIntoView();
        editorAnalyticsApi === null || editorAnalyticsApi === void 0 || editorAnalyticsApi.attachAnalyticsEvent({
            action: (0, $g6Qq4.ACTION).CHANGED_TYPE,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).NATIVE_EMBED,
            eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
            attributes: {
                newType: appearance,
                previousType: 'nativeEmbed'
            }
        })(tr);
        dispatch(tr);
        return true;
    } catch  {
        return false;
    }
};

});

parcelRegister("4FG8b", function(module, exports) {
$parcel$export(module.exports, "getCardAtPasteRange", () => $a77b7b9df153da7d$export$bfdec0913b4999e8);

var $5cz2o = parcelRequire("5cz2o");
const $a77b7b9df153da7d$export$96b638002b74480f = [
    'url',
    'inline',
    'block',
    'embed'
];
const $a77b7b9df153da7d$var$cardAtPos = (node, pos)=>{
    switch(node === null || node === void 0 ? void 0 : node.type.name){
        case 'inlineCard':
            return {
                appearance: 'inline',
                pos: pos
            };
        case 'blockCard':
            return {
                appearance: 'block',
                pos: pos
            };
        case 'embedCard':
            return {
                appearance: 'embed',
                pos: pos
            };
        default:
            return (0, $5cz2o.isNativeEmbedNode)(node) ? {
                appearance: 'embed',
                isNativeEmbed: true,
                pos: pos
            } : undefined;
    }
};
const $a77b7b9df153da7d$var$getNodeUrl = (node)=>{
    var _attrs$data;
    if ((0, $5cz2o.isNativeEmbedNode)(node)) return (0, $5cz2o.getNativeEmbedUrl)(node);
    const attrs = node.attrs;
    const url = (attrs === null || attrs === void 0 ? void 0 : attrs.url) ?? (attrs === null || attrs === void 0 || (_attrs$data = attrs.data) === null || _attrs$data === void 0 ? void 0 : _attrs$data.url);
    return typeof url === 'string' ? url : undefined;
};
const $a77b7b9df153da7d$export$bfdec0913b4999e8 = (state, pasteStartPos, pasteEndPos, pastedUrl)=>{
    const docContentSize = state.doc.content.size;
    const clampedStart = Math.max(0, Math.min(pasteStartPos, docContentSize));
    const clampedEnd = Math.max(0, Math.min(pasteEndPos, docContentSize));
    const from = Math.min(clampedStart, clampedEnd);
    const to = Math.max(clampedStart, clampedEnd);
    try {
        var _inRange;
        const candidateAt = (pos)=>{
            if (pos < 0 || pos >= docContentSize) return undefined;
            const node = state.doc.nodeAt(pos);
            const card = $a77b7b9df153da7d$var$cardAtPos(node, pos);
            return node && card ? {
                card: card,
                url: $a77b7b9df153da7d$var$getNodeUrl(node)
            } : undefined;
        };
        const adjacent = [
            candidateAt(from - 1),
            candidateAt(from)
        ].filter((candidate)=>Boolean(candidate));
        const inRange = [];
        state.doc.nodesBetween(from, to, (node, pos)=>{
            const card = $a77b7b9df153da7d$var$cardAtPos(node, pos);
            if (card) {
                inRange.push({
                    card: card,
                    url: $a77b7b9df153da7d$var$getNodeUrl(node)
                });
                return false;
            }
            return true;
        });
        if (pastedUrl) {
            const match = [
                ...adjacent,
                ...inRange
            ].find((candidate)=>candidate.url === pastedUrl);
            if (match) return match.card;
        }
        if (from === to) {
            const [firstAdjacent] = adjacent;
            if (firstAdjacent) return firstAdjacent.card;
        }
        return (_inRange = inRange[inRange.length - 1]) === null || _inRange === void 0 ? void 0 : _inRange.card;
    } catch  {
        return undefined;
    }
};

});


parcelRegister("aD2Bo", function(module, exports) {
$parcel$export(module.exports, "PreAuthValuePropositionModalListener", () => $786d86717734f2f3$export$79a277fe892e4f35);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $anGu7 = parcelRequire("anGu7");

var $8o1QB = parcelRequire("8o1QB");

const $786d86717734f2f3$var$PreAuthValuePropositionModal = /*#__PURE__*/ (0, $bSJIT.lazy)(()=>(parcelRequire("5kHNp")).then((module)=>({
            default: module.PreAuthValuePropositionModal
        })));
const $786d86717734f2f3$var$getNewSmartLinkUrl = (event)=>{
    if (event.subject !== (0, $anGu7.EVENT_SUBJECT).LINK || event.data.isUndo || event.data.isRedo || (0, $8o1QB.appearanceForLink)(event.data.node) === 'url') return;
    if (event.event === (0, $anGu7.EVENT).CREATED || event.event === (0, $anGu7.EVENT).UPDATED && event.data.previousDisplay === 'url') return (0, $8o1QB.getUrl)(event.data.node);
};
const $786d86717734f2f3$var$ModalListener = ({ api: api, cardPluginEvents: cardPluginEvents })=>{
    const [url, setUrl] = (0, $bSJIT.useState)();
    const [isOpen, setIsOpen] = (0, $bSJIT.useState)(false);
    // While the pre-auth modal is visible, use 'overlayOpen' to suppress the floating toolbar.
    // Jira portals editor popups above its issue dialog, so the toolbar would otherwise appear
    // above the modal blanket. Keep it available while link eligibility is still being checked.
    // On close or unmount, restore the previous intent unless another interaction has changed it.
    (0, $bSJIT.useEffect)(()=>{
        var _api$userIntent$share;
        if (!isOpen || !(api !== null && api !== void 0 && api.userIntent)) return;
        const previousIntent = ((_api$userIntent$share = api.userIntent.sharedState.currentState()) === null || _api$userIntent$share === void 0 ? void 0 : _api$userIntent$share.currentUserIntent) ?? 'default';
        api.core.actions.execute(api.userIntent.commands.setCurrentUserIntent('overlayOpen'));
        return ()=>{
            var _api$userIntent;
            if (((_api$userIntent = api.userIntent) === null || _api$userIntent === void 0 || (_api$userIntent = _api$userIntent.sharedState.currentState()) === null || _api$userIntent === void 0 ? void 0 : _api$userIntent.currentUserIntent) === 'overlayOpen') api.core.actions.execute(api.userIntent.commands.setCurrentUserIntent(previousIntent));
        };
    }, [
        api,
        isOpen
    ]);
    (0, $bSJIT.useEffect)(()=>cardPluginEvents.subscribe((event)=>{
            const newSmartLinkUrl = $786d86717734f2f3$var$getNewSmartLinkUrl(event);
            if (newSmartLinkUrl) setUrl((currentUrl)=>currentUrl ?? newSmartLinkUrl);
        }), [
        cardPluginEvents
    ]);
    const onFinished = (0, $bSJIT.useCallback)(()=>{
        setIsOpen(false);
        setUrl(undefined);
    }, []);
    return url ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $bSJIT.Suspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $dc70d.jsx)($786d86717734f2f3$var$PreAuthValuePropositionModal, {
            url: url,
            onFinished: onFinished,
            onOpenChange: setIsOpen
        }, url)
    }) : null;
};
const $786d86717734f2f3$export$79a277fe892e4f35 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).memo($786d86717734f2f3$var$ModalListener);

});
parcelRegister("5kHNp", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("ecq3d").then(()=>parcelRequire('7ZLnC'));

});


parcelRegister("4wBHs", function(module, exports) {
$parcel$export(module.exports, "getCardQuickInsertComponents", () => $35649bcc7323ef9f$export$7da4affb2ef3577f);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $278lv = parcelRequire("278lv");

var $b8Hvx = parcelRequire("b8Hvx");

var $9woaI = parcelRequire("9woaI");

var $am2Qg = parcelRequire("am2Qg");

var $8XENo = parcelRequire("8XENo");

var $a2Ugg = parcelRequire("a2Ugg");

var $6yEAN = parcelRequire("6yEAN");

var $gdUUy = parcelRequire("gdUUy");

var $cKhMH = parcelRequire("cKhMH");

var $2aT6E = parcelRequire("2aT6E");
const $35649bcc7323ef9f$var$datasourcePreviewImageUrlsByKey = {
    [(0, $9woaI.JIRA_WORK_ITEMS_MENU_ITEM).key]: {
        dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVIM.png',
        light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVLA.png'
    },
    [(0, $9woaI.CONFLUENCE_LIST_MENU_ITEM).key]: {
        dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVIK.png',
        light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVMD.png'
    },
    [(0, $9woaI.ASSETS_MENU_ITEM).key]: {
        dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVJ2.png',
        light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVM6.png'
    }
};
const $35649bcc7323ef9f$export$7da4affb2ef3577f = ({ api: api, options: options })=>{
    if (!options.allowDatasource) return [];
    const components = [
        {
            key: (0, $9woaI.JIRA_WORK_ITEMS_MENU_ITEM).key,
            type: (0, $9woaI.JIRA_WORK_ITEMS_MENU_ITEM).type,
            parents: [
                {
                    key: (0, $9woaI.DATA_AND_CHARTS_SECTION).key,
                    type: (0, $9woaI.DATA_AND_CHARTS_SECTION).type,
                    rank: (0, $am2Qg.DATA_AND_CHARTS_SECTION_RANK)[(0, $9woaI.JIRA_WORK_ITEMS_MENU_ITEM).key]
                }
            ],
            match: (0, $b8Hvx.createQuickInsertMatcher)(({ formatMessage: formatMessage })=>({
                    description: formatMessage((0, $gdUUy.fg)('confluence-issue-terminology-refresh') ? (0, $278lv.messages).datasourceJiraIssueDescriptionIssueTermRefresh : (0, $278lv.messages).datasourceJiraIssueDescription),
                    keywords: [
                        'jira'
                    ],
                    title: formatMessage((0, $gdUUy.fg)('confluence-issue-terminology-refresh') ? (0, $278lv.messages).datasourceJiraIssueIssueTermRefresh : (0, $278lv.messages).datasourceJiraIssue)
                })),
            component: ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $2aT6E.DatasourceQuickInsertMenuItem), {
                    api: api,
                    previewImageUrls: $35649bcc7323ef9f$var$datasourcePreviewImageUrlsByKey[(0, $9woaI.JIRA_WORK_ITEMS_MENU_ITEM).key],
                    type: "jira"
                })
        }
    ];
    if ((0, $8XENo.canRenderDatasource)((0, $a2Ugg.ASSETS_LIST_OF_LINKS_DATASOURCE_ID))) components.push({
        key: (0, $9woaI.ASSETS_MENU_ITEM).key,
        type: (0, $9woaI.ASSETS_MENU_ITEM).type,
        parents: [
            {
                key: (0, $9woaI.DATA_AND_CHARTS_SECTION).key,
                type: (0, $9woaI.DATA_AND_CHARTS_SECTION).type,
                rank: (0, $am2Qg.DATA_AND_CHARTS_SECTION_RANK)[(0, $9woaI.ASSETS_MENU_ITEM).key]
            }
        ],
        match: (0, $b8Hvx.createQuickInsertMatcher)(({ formatMessage: formatMessage })=>({
                description: formatMessage((0, $278lv.messages).datasourceAssetsObjectsDescription),
                keywords: [
                    'assets'
                ],
                title: formatMessage((0, $278lv.messages).datasourceAssetsObjectsGeneralAvailability)
            })),
        component: ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $2aT6E.DatasourceQuickInsertMenuItem), {
                api: api,
                previewImageUrls: $35649bcc7323ef9f$var$datasourcePreviewImageUrlsByKey[(0, $9woaI.ASSETS_MENU_ITEM).key],
                type: "assets"
            })
    });
    if ((0, $cKhMH.isDatasourceConfigEditable)((0, $6yEAN.CONFLUENCE_SEARCH_DATASOURCE_ID))) components.push({
        key: (0, $9woaI.CONFLUENCE_LIST_MENU_ITEM).key,
        type: (0, $9woaI.CONFLUENCE_LIST_MENU_ITEM).type,
        parents: [
            {
                key: (0, $9woaI.DATA_AND_CHARTS_SECTION).key,
                type: (0, $9woaI.DATA_AND_CHARTS_SECTION).type,
                rank: (0, $am2Qg.DATA_AND_CHARTS_SECTION_RANK)[(0, $9woaI.CONFLUENCE_LIST_MENU_ITEM).key]
            }
        ],
        match: (0, $b8Hvx.createQuickInsertMatcher)(({ formatMessage: formatMessage })=>({
                description: formatMessage((0, $278lv.messages).datasourceConfluenceSearchDescription),
                keywords: [
                    'confluence'
                ],
                title: formatMessage((0, $278lv.messages).datasourceConfluenceSearch)
            })),
        component: ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $2aT6E.DatasourceQuickInsertMenuItem), {
                api: api,
                previewImageUrls: $35649bcc7323ef9f$var$datasourcePreviewImageUrlsByKey[(0, $9woaI.CONFLUENCE_LIST_MENU_ITEM).key],
                type: "confluence-search"
            })
    });
    return components;
};

});
parcelRegister("2aT6E", function(module, exports) {
$parcel$export(module.exports, "DatasourceQuickInsertMenuItem", () => $0340972a4ce9bf8e$export$19175c221bcdac39);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $278lv = parcelRequire("278lv");

var $1xCVB = parcelRequire("1xCVB");

var $kMpeH = parcelRequire("kMpeH");

var $fT9mF = parcelRequire("fT9mF");

var $64eKJ = parcelRequire("64eKJ");

var $efcwg = parcelRequire("efcwg");

var $jOW0B = parcelRequire("jOW0B");

var $iUkOP = parcelRequire("iUkOP");

var $2rvGO = parcelRequire("2rvGO");

var $gdUUy = parcelRequire("gdUUy");

var $k5X6V = parcelRequire("k5X6V");
const $0340972a4ce9bf8e$export$19175c221bcdac39 = ({ previewImageUrls: previewImageUrls, type: type })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const { isOffline: isOffline } = (0, $efcwg.useQuickInsertContext)();
    const isJira = type === 'jira';
    const isConfluenceSearch = type === 'confluence-search';
    const description = formatMessage(isJira ? (0, $gdUUy.fg)('confluence-issue-terminology-refresh') ? (0, $278lv.messages).datasourceJiraIssueDescriptionIssueTermRefresh : (0, $278lv.messages).datasourceJiraIssueDescription : isConfluenceSearch ? (0, $278lv.messages).datasourceConfluenceSearchDescription : (0, $278lv.messages).datasourceAssetsObjectsDescription);
    const preview = (0, $bSJIT.useMemo)(()=>previewImageUrls ? {
            image: previewImageUrls,
            attribution: {
                name: formatMessage(isJira ? (0, $64eKJ.messages).previewAttributionJira : isConfluenceSearch ? (0, $64eKJ.messages).previewAttributionConfluence : (0, $64eKJ.messages).previewAttributionAssets),
                ...(isJira || isConfluenceSearch) && {
                    icon: isJira ? (0, $kMpeH.JiraAttributionIcon) : (0, $1xCVB.ConfluenceAttributionIcon)
                }
            }
        } : undefined, [
        formatMessage,
        isConfluenceSearch,
        isJira,
        previewImageUrls
    ]);
    const onSelect = (0, $bSJIT.useCallback)(({ insert: insert })=>{
        const tr = insert(undefined);
        (0, $k5X6V.showDatasourceModal)(type)(tr);
        return tr;
    }, [
        type
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $fT9mF.QuickInsertMenuItem), {
        description: description,
        iconBefore: isJira ? /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2rvGO))), {
            label: ""
        }) : isConfluenceSearch ? /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iUkOP))), {
            label: ""
        }) : /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jOW0B))), {
            label: ""
        }),
        isDisabled: isOffline,
        onSelect: onSelect,
        preview: preview,
        title: formatMessage(isJira ? (0, $gdUUy.fg)('confluence-issue-terminology-refresh') ? (0, $278lv.messages).datasourceJiraIssueIssueTermRefresh : (0, $278lv.messages).datasourceJiraIssue : isConfluenceSearch ? (0, $278lv.messages).datasourceConfluenceSearch : (0, $278lv.messages).datasourceAssetsObjectsGeneralAvailability)
    });
};

});
parcelRegister("1xCVB", function(module, exports) {
$parcel$export(module.exports, "ConfluenceAttributionIcon", () => $8f2efe18441432af$export$f5752395a477e5ed);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $ewUT0 = parcelRequire("ewUT0");
const $8f2efe18441432af$export$f5752395a477e5ed = ()=>/*#__PURE__*/ (0, $dc70d.jsx)("img", {
        src: (0, $ewUT0.confluenceIcon),
        alt: "",
        width: 16,
        height: 16
    });

});

parcelRegister("kMpeH", function(module, exports) {
$parcel$export(module.exports, "JiraAttributionIcon", () => $bf0f7436e4e41f36$export$5a5b2410f606869);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $ewUT0 = parcelRequire("ewUT0");
const $bf0f7436e4e41f36$export$5a5b2410f606869 = ()=>/*#__PURE__*/ (0, $dc70d.jsx)("img", {
        src: (0, $ewUT0.jiraIcon),
        alt: "",
        width: 16,
        height: 16
    });

});




parcelRegister("8K5q6", function(module, exports) {
$parcel$export(module.exports, "useIconThemed", () => $e980d9b3069c3fb8$export$a38bb9a8c9e5bc30);

var $ceb9s = parcelRequire("ceb9s");
const $e980d9b3069c3fb8$export$a38bb9a8c9e5bc30 = ()=>{
    const { colorMode: colorMode } = (0, $ceb9s.useThemeObserver)();
    return {
        iconThemed: (colors)=>{
            return colorMode && colorMode === 'dark' ? colors['dark'] : colors['light'];
        }
    };
};

});

parcelRegister("5sUZ8", function(module, exports) {
$parcel$export(module.exports, "InsertTypeAheadStages", () => $71019d5218a5167f$export$1b2be0bed116d664);
$parcel$export(module.exports, "InsertTypeAheadStep", () => $71019d5218a5167f$export$5ca6d15deb246b5d);

var $kW8qW = parcelRequire("kW8qW");

var $3DNV7 = parcelRequire("3DNV7");
parcelRequire("bUbIU");
var $3DNV7 = parcelRequire("3DNV7");
const $71019d5218a5167f$export$2f0b0962a5993fe0 = 'atlaskit-insert-type-ahead';
var $71019d5218a5167f$export$1b2be0bed116d664 = /*#__PURE__*/ function(InsertTypeAheadStages) {
    InsertTypeAheadStages["DELETING_RAW_QUERY"] = "DELETING_RAW_QUERY";
    InsertTypeAheadStages["INSERTING_ITEM"] = "INSERTING_ITEM";
    return InsertTypeAheadStages;
}({});
class $71019d5218a5167f$export$5ca6d15deb246b5d extends (0, $3DNV7.Step) {
    constructor({ stage: stage, query: query, trigger: trigger, selectedIndex: selectedIndex }, isInvertStep = false){
        super();
        this.isInvertStep = isInvertStep;
        this.stage = stage;
        this.query = query;
        this.trigger = trigger;
        this.selectedIndex = selectedIndex;
    }
    invert() {
        const config = {
            stage: this.stage,
            query: this.query,
            trigger: this.trigger,
            selectedIndex: this.selectedIndex
        };
        return new $71019d5218a5167f$export$5ca6d15deb246b5d(config, !this.isInvertStep);
    }
    apply(doc) {
        return (0, $3DNV7.StepResult).ok(doc);
    }
    merge() {
        return null;
    }
    isInsertionStep() {
        return !this.isInvertStep;
    }
    isUndoingStep() {
        return this.isInvertStep;
    }
    map() {
        const config = {
            stage: this.stage,
            query: this.query,
            trigger: this.trigger,
            selectedIndex: this.selectedIndex
        };
        // Return the same events, this step will never be removed
        return new $71019d5218a5167f$export$5ca6d15deb246b5d(config, this.isInvertStep);
    }
    getMap() {
        return new (0, $3DNV7.StepMap)([
            0,
            0,
            0
        ]);
    }
    toJSON() {
        // When serialized we should create a noop Replace step
        return {
            stepType: 'replace',
            from: 0,
            to: 0
        };
    }
    static fromJSON() {
        // This is a "local custom step" once serialized
        // we need to transform it in a no-operation action
        return new (0, $3DNV7.ReplaceStep)(0, 0, (0, $kW8qW.Slice).empty);
    }
}
/** Register this step with Prosemirror */ (0, $3DNV7.Step).jsonID($71019d5218a5167f$export$2f0b0962a5993fe0, $71019d5218a5167f$export$5ca6d15deb246b5d);

});

parcelRegister("1oK0T", function(module, exports) {
$parcel$export(module.exports, "tableNodeTypes", () => $b26e8145540d9ac0$export$c7782132717464bc);
function $b26e8145540d9ac0$export$c7782132717464bc(schema) {
    let result = schema.cached.tableNodeTypes;
    if (!result) {
        result = {};
        // eslint-disable-next-line no-param-reassign
        schema.cached.tableNodeTypes = result;
        // eslint-disable-next-line guard-for-in
        for(const name in schema.nodes){
            const type = schema.nodes[name];
            const role = type.spec.tableRole;
            if (role) result[role] = type;
        }
    }
    return result;
}

});

parcelRegister("fjZzq", function(module, exports) {
$parcel$export(module.exports, "contentInsertionPlugin", () => $a15844a2437640fb$export$8469b5a27995930b);

var $cQjaA = parcelRequire("cQjaA");
const $a15844a2437640fb$export$8469b5a27995930b = ({ api: api })=>{
    var _api$analytics;
    const { actions: actions, commands: commands } = (0, $cQjaA.createInsertNodeAPI)(api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions);
    return {
        name: 'contentInsertion',
        actions: actions,
        commands: commands
    };
};

});
parcelRegister("cQjaA", function(module, exports) {
$parcel$export(module.exports, "createInsertNodeAPI", () => $57daf61e1ea97567$export$e8397698249f8f72);

var $lvz20 = parcelRequire("lvz20");
const $57daf61e1ea97567$export$e8397698249f8f72 = (analyticsApi)=>({
        actions: {
            insert: ({ state: state, dispatch: dispatch, node: node, options: options })=>{
                if (!state || !dispatch) return false;
                const { tr: tr } = state;
                (0, $lvz20.handleInsertContent)({
                    node: node,
                    options: options
                })(tr);
                if (options.analyticsPayload) analyticsApi === null || analyticsApi === void 0 || analyticsApi.attachAnalyticsEvent(options.analyticsPayload)(tr);
                dispatch(tr);
                return true;
            }
        },
        commands: {
            insert: ({ node: node, options: options })=>({ tr: tr })=>{
                    (0, $lvz20.handleInsertContent)({
                        node: node,
                        options: options
                    })(tr);
                    if (options.analyticsPayload) analyticsApi === null || analyticsApi === void 0 || analyticsApi.attachAnalyticsEvent(options.analyticsPayload)(tr);
                    return tr;
                }
        }
    });

});
parcelRegister("lvz20", function(module, exports) {
$parcel$export(module.exports, "handleInsertContent", () => $bcff04102c38429e$export$68b1ab6a0b98c537);

var $kW8qW = parcelRequire("kW8qW");

var $1mQc2 = parcelRequire("1mQc2");
const $bcff04102c38429e$export$68b1ab6a0b98c537 = ({ node: node, options: options })=>(tr)=>{
        const position = options.insertAt ?? tr.selection;
        if (!(node instanceof (0, $kW8qW.Node) || node instanceof (0, $kW8qW.Fragment))) return false;
        (0, $1mQc2.insertProseMirrorContent)({
            tr: tr,
            node: node,
            position: position,
            selectNodeInserted: options.selectNodeInserted
        });
        tr.scrollIntoView();
        return true;
    };

});
parcelRegister("1mQc2", function(module, exports) {
$parcel$export(module.exports, "insertProseMirrorContent", () => $86bb7b54d91c7acc$export$a6d88483216c3859);
/* Copied from type-ahead */ 
var $dw0oh = parcelRequire("dw0oh");

var $kW8qW = parcelRequire("kW8qW");

var $cw0wu = parcelRequire("cw0wu");
function $86bb7b54d91c7acc$var$findInsertPoint(doc, pos, nodeToInsert) {
    const $pos = doc.resolve(pos);
    const createInsertPosition = (from, to)=>({
            from: from,
            to: to || from
        });
    // Search for a valid position for nodeToInsert in progressively higher levels
    for(let level = $pos.depth; level >= 0; level--){
        const nodeAtLevel = $pos.node(level);
        // Try to replace the empty paragraph in the level above
        // Scenario:
        //   doc(
        //     table(
        //       row(
        //         cell(
        //           p('{<>}'),
        //         ),
        //       )
        //     )
        //   )
        const levelAbove = Math.max(level - 1, 0);
        const parentNode = $pos.node(levelAbove);
        // Special case: when this is true, the 'to' position should be the end
        // of the empty paragraph
        const isNodeAtLevelEmptyParagraph = nodeAtLevel.type.name === 'paragraph' && nodeAtLevel.content.size === 0;
        const indexAtLevelAbove = $pos.index(levelAbove);
        const canReplaceNodeAtLevelAbove = parentNode.canReplaceWith(indexAtLevelAbove, indexAtLevelAbove, nodeToInsert.type);
        if (isNodeAtLevelEmptyParagraph && canReplaceNodeAtLevelAbove) {
            const from = $pos.posAtIndex(indexAtLevelAbove, levelAbove);
            return createInsertPosition(from, from + nodeAtLevel.nodeSize);
        }
        // Try to insert this node right after the node in the level above
        // Scenario:
        //   doc(
        //     panel(
        //       p('{<>}'),
        //     )
        //   )
        const indexAfterAtLevelAbove = $pos.indexAfter(levelAbove);
        const canInsertNodeAtLevelAbove = parentNode.canReplaceWith(indexAfterAtLevelAbove, indexAfterAtLevelAbove, nodeToInsert.type);
        if (canInsertNodeAtLevelAbove) return createInsertPosition($pos.posAtIndex(indexAfterAtLevelAbove, levelAbove));
    }
    return createInsertPosition(0);
}
const $86bb7b54d91c7acc$export$faec73a52dd47a2c = ({ node: node, tr: tr, position: position })=>{
    const { $from: { pos: start }, $to: { pos: end } } = position;
    if (node.isText) return tr.replaceWith(start, end, node);
    if (node.isBlock) {
        const mappedStart = start;
        const nodeNormalized = (0, $dw0oh.normaliseNestedLayout)(tr, node);
        // Handle edge cases for hr and mediaSingle
        const inserted = (0, $dw0oh.safeInsert)(nodeNormalized, mappedStart)(tr);
        if (inserted) return tr;
        const sliceInserted = (0, $kW8qW.Slice).maxOpen((0, $kW8qW.Fragment).from(nodeNormalized));
        const { from: from, to: to } = $86bb7b54d91c7acc$var$findInsertPoint(tr.doc, mappedStart, nodeNormalized);
        tr.replaceWith(from, to, node);
        const openPosition = Math.min(from + (node.isAtom ? node.nodeSize : sliceInserted.openStart), tr.doc.content.size);
        const FORWARD_DIRECTION = 1;
        const nextSelection = (0, $cw0wu.TextSelection).findFrom(tr.doc.resolve(openPosition), FORWARD_DIRECTION, true);
        if (nextSelection) return tr.setSelection(nextSelection);
    }
    return tr;
};
const $86bb7b54d91c7acc$export$a6d430434014dc1c = ({ maybeFragment: maybeFragment, tr: tr, position: position, selectInlineNode: selectInlineNode })=>{
    const { $from: { pos: start }, $to: { pos: end } } = position;
    const fragment = maybeFragment instanceof (0, $kW8qW.Node) ? (0, $kW8qW.Fragment).from(maybeFragment) : maybeFragment;
    tr.replaceWith(start, end, fragment);
    if (selectInlineNode) return tr.setSelection((0, $cw0wu.NodeSelection).create(tr.doc, start));
    return tr.setSelection((0, $cw0wu.TextSelection).near(tr.doc.resolve(start + ((fragment === null || fragment === void 0 ? void 0 : fragment.size) || 0))));
};
const $86bb7b54d91c7acc$export$a6d88483216c3859 = ({ tr: tr, node: node, position: position, selectNodeInserted: selectNodeInserted })=>{
    if (node instanceof (0, $kW8qW.Node) && node.isBlock) $86bb7b54d91c7acc$export$faec73a52dd47a2c({
        node: node,
        tr: tr,
        position: position
    });
    else $86bb7b54d91c7acc$export$a6d430434014dc1c({
        maybeFragment: node,
        tr: tr,
        position: position,
        selectInlineNode: selectNodeInserted
    });
};

});
parcelRegister("dw0oh", function(module, exports) {
$parcel$export(module.exports, "normaliseNestedLayout", () => $cd2cf1fbbf0ba8f4$export$9a3d0d2a50538e52);
$parcel$export(module.exports, "safeInsert", () => $cd2cf1fbbf0ba8f4$export$5fe92db78385e37c);
$parcel$export(module.exports, "shouldSplitSelectedNodeOnNodeInsertion", () => $cd2cf1fbbf0ba8f4$export$b80431b156693a98);
$parcel$export(module.exports, "insertSelectedItem", () => $cd2cf1fbbf0ba8f4$export$e3c00faab58641c5);
$parcel$export(module.exports, "contentAllowedInCodeBlock", () => $cd2cf1fbbf0ba8f4$export$b6980e4b8ea578a5);

var $kW8qW = parcelRequire("kW8qW");

var $cw0wu = parcelRequire("cw0wu");

var $3DNV7 = parcelRequire("3DNV7");

var $gab48 = parcelRequire("gab48");

var $j7pt0 = parcelRequire("j7pt0");
var $8t2a4 = parcelRequire("8t2a4");
parcelRequire("56AB9");
var $24xJB = parcelRequire("24xJB");
var $7nLBT = parcelRequire("7nLBT");
var $cd2cf1fbbf0ba8f4$export$cbdce50c60b34c89 = /*#__PURE__*/ function(LookDirection) {
    LookDirection["Before"] = "before";
    LookDirection["After"] = "after";
    return LookDirection;
}({});
const $cd2cf1fbbf0ba8f4$export$9a3d0d2a50538e52 = ({ selection: selection, doc: doc }, node)=>{
    if (selection.$from.depth > 1) {
        if (node.attrs.layout && node.attrs.layout !== 'default') return node.type.createChecked({
            ...node.attrs,
            layout: 'default'
        }, node.content, node.marks);
        // If its a breakout layout, we can remove the mark
        // Since default isn't a valid breakout mode.
        const breakoutMark = doc.type.schema.marks.breakout;
        if (breakoutMark && breakoutMark.isInSet(node.marks)) {
            const newMarks = breakoutMark.removeFromSet(node.marks);
            return node.type.createChecked(node.attrs, node.content, newMarks);
        }
    }
    return node;
};
const $cd2cf1fbbf0ba8f4$var$isLastChild = ($pos, doc)=>doc.resolve($pos.after()).node().lastChild === $pos.node();
const $cd2cf1fbbf0ba8f4$var$isFirstChild = ($pos, doc)=>doc.resolve($pos.before()).node().firstChild === $pos.node();
const $cd2cf1fbbf0ba8f4$var$nodeIsInsideAList = (tr)=>{
    const { nodes: nodes } = tr.doc.type.schema;
    return (0, $gab48.hasParentNodeOfType)([
        nodes.orderedList,
        nodes.bulletList
    ])(tr.selection);
};
const $cd2cf1fbbf0ba8f4$var$selectionIsInsideAPanel = (tr)=>{
    const { nodes: nodes } = tr.doc.type.schema;
    return (0, $gab48.hasParentNodeOfType)(nodes.panel)(tr.selection);
};
const $cd2cf1fbbf0ba8f4$var$selectionIsInNestedList = (tr)=>{
    const { nodes: nodes } = tr.doc.type.schema;
    const parentListNode = (0, $gab48.findParentNodeOfType)([
        nodes.orderedList,
        nodes.bulletList
    ])(tr.selection);
    if (!parentListNode) return false;
    return (0, $7nLBT.isListItemNode)(tr.doc.resolve(parentListNode.pos).parent);
};
const $cd2cf1fbbf0ba8f4$var$insertBeforeOrAfter = (tr, lookDirection, $parentPos, $proposedPosition, content)=>{
    /**
   * This block caters for the first item in a parent with the cursor being at the very start
   * or the last item with the cursor being at the very end
   *
   * e.g.
   * ul
   *  li {<>}Scenario one
   *  li
   *  li Scenario two{<>}
   */ if ($cd2cf1fbbf0ba8f4$var$isFirstChild($proposedPosition, tr.doc) && lookDirection === "before" || $cd2cf1fbbf0ba8f4$var$isLastChild($proposedPosition, tr.doc) && lookDirection === "after") return tr.insert($parentPos[lookDirection](), content);
    return tr.insert($proposedPosition[lookDirection](), content);
};
// Ignored via go/ees007
// eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
// FIXME: A more sustainable and configurable way to choose when to split
// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $cd2cf1fbbf0ba8f4$var$shouldSplit = (nodeType, schemaNodes)=>{
    return [
        schemaNodes.bulletList,
        schemaNodes.orderedList,
        schemaNodes.panel
    ].includes(nodeType);
};
const $cd2cf1fbbf0ba8f4$export$5fe92db78385e37c = (content, position)=>(tr)=>{
        var _tr$selection$$from$n;
        const { nodes: nodes } = tr.doc.type.schema;
        const whitelist = [
            nodes.rule,
            nodes.mediaSingle
        ];
        if (content instanceof (0, $kW8qW.Fragment) || !whitelist.includes(content.type)) return null;
        // Check for selection
        if (!tr.selection.empty || (0, $gab48.isNodeSelection)(tr.selection)) // NOT IMPLEMENTED
        return null;
        const { $from: $from } = tr.selection;
        const $insertPos = position ? tr.doc.resolve(position) : (0, $gab48.isNodeSelection)(tr.selection) ? tr.doc.resolve($from.pos + 1) : $from;
        let lookDirection;
        const insertPosEnd = $insertPos.end();
        const insertPosStart = $insertPos.start();
        // When parent node is an empty paragraph,
        // check the empty paragraph is the first or last node of its parent.
        if ((0, $24xJB.isEmptyParagraph)($insertPos.parent)) {
            if ($cd2cf1fbbf0ba8f4$var$isLastChild($insertPos, tr.doc)) lookDirection = "after";
            else if ($cd2cf1fbbf0ba8f4$var$isFirstChild($insertPos, tr.doc)) lookDirection = "before";
        } else {
            if ($insertPos.pos === insertPosEnd) lookDirection = "after";
            else if ($insertPos.pos === insertPosStart) lookDirection = "before";
        }
        const grandParentNodeType = (_tr$selection$$from$n = tr.selection.$from.node(-1)) === null || _tr$selection$$from$n === void 0 ? void 0 : _tr$selection$$from$n.type;
        const parentNodeType = tr.selection.$from.parent.type;
        // if there is no direction, and cannot split for this particular node
        const noDirectionAndShouldNotSplit = !lookDirection && !$cd2cf1fbbf0ba8f4$export$b80431b156693a98({
            parentNodeType: parentNodeType,
            grandParentNodeType: grandParentNodeType,
            content: content
        });
        const ruleNodeInANestedListNode = content.type === nodes.rule && $cd2cf1fbbf0ba8f4$var$selectionIsInNestedList(tr);
        const nonRuleNodeInListNode = !(content.type === nodes.rule) && $cd2cf1fbbf0ba8f4$var$nodeIsInsideAList(tr);
        if (ruleNodeInANestedListNode || noDirectionAndShouldNotSplit && nonRuleNodeInListNode || noDirectionAndShouldNotSplit && !$cd2cf1fbbf0ba8f4$var$nodeIsInsideAList(tr)) // node to be inserted is an invalid child of selection so insert below selected node
        return (0, $gab48.safeInsert)(content, tr.selection.from)(tr);
        // if node is a rule and that is a flat list splitting and not at the end of a list
        const { from: from, to: to } = tr.selection;
        const ruleTypeInAList = content.type === nodes.rule && $cd2cf1fbbf0ba8f4$var$nodeIsInsideAList(tr);
        if (ruleTypeInAList && !($insertPos.pos === insertPosEnd)) return tr.replaceRange(from, to, new (0, $kW8qW.Slice)((0, $kW8qW.Fragment).from(nodes.rule.createChecked()), 0, 0));
        if (!lookDirection) // fallback to consumer for now
        return null;
        // Replace empty paragraph
        if ((0, $24xJB.isEmptyParagraph)($insertPos.parent) && (0, $gab48.canInsert)(tr.doc.resolve($insertPos[lookDirection]()), content)) return $cd2cf1fbbf0ba8f4$var$finaliseInsert(tr.replaceWith($insertPos.before(), $insertPos.after(), content), -1);
        let $proposedPosition = $insertPos;
        while($proposedPosition.depth > 0){
            const $parentPos = tr.doc.resolve($proposedPosition[lookDirection]());
            const parentNode = $parentPos.node();
            // Insert at position (before or after target pos)
            if ((0, $gab48.canInsert)($proposedPosition, content)) return $cd2cf1fbbf0ba8f4$var$finaliseInsert(tr.insert($proposedPosition.pos, content), content.nodeSize);
            // If we can't insert, and we think we should split, we fallback to consumer for now
            if ($cd2cf1fbbf0ba8f4$var$shouldSplit(parentNode.type, tr.doc.type.schema.nodes)) {
                const nextTr = $cd2cf1fbbf0ba8f4$var$finaliseInsert($cd2cf1fbbf0ba8f4$var$insertBeforeOrAfter(tr, lookDirection, $parentPos, $proposedPosition, content), content.nodeSize);
                // Move selection to the closest text node, otherwise it defaults to the whatever the lookDirection is set to above
                if ([
                    nodes.orderedList,
                    nodes.bulletList
                ].includes(parentNode.type) && nextTr) return nextTr.setSelection((0, $cw0wu.TextSelection).between(nextTr.selection.$from, nextTr.selection.$from));
                else return nextTr;
            }
            // Can not insert into current parent, step up one parent
            $proposedPosition = $parentPos;
        }
        return $cd2cf1fbbf0ba8f4$var$finaliseInsert(tr.insert($proposedPosition.pos, content), content.nodeSize);
    };
const $cd2cf1fbbf0ba8f4$var$finaliseInsert = (tr, nodeLength)=>{
    const lastStep = tr.steps[tr.steps.length - 1];
    if (!(lastStep instanceof (0, $3DNV7.ReplaceStep) || lastStep instanceof (0, $3DNV7.ReplaceAroundStep))) return null;
    // Place gap cursor after the newly inserted node
    const gapCursorPos = lastStep.to + lastStep.slice.openStart + nodeLength;
    return tr.setSelection(new (0, $j7pt0.GapCursorSelection)(tr.doc.resolve(gapCursorPos), (0, $8t2a4.Side).RIGHT)).scrollIntoView();
};
const $cd2cf1fbbf0ba8f4$export$e3c00faab58641c5 = (maybeNode, opts = {})=>(state, tr, start)=>{
        if (!maybeNode) return tr;
        const isInputFragment = maybeNode instanceof (0, $kW8qW.Fragment);
        let node;
        try {
            node = maybeNode instanceof (0, $kW8qW.Node) || isInputFragment ? maybeNode : typeof maybeNode === 'string' ? state.schema.text(maybeNode) : (0, $kW8qW.Node).fromJSON(state.schema, maybeNode);
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
            return tr;
        }
        if (node instanceof (0, $kW8qW.Node) && node.isText) tr = tr.replaceWith(start, start, node);
        else if (node instanceof (0, $kW8qW.Node) && node.isBlock) {
            /**
     *
     * Rule has unique insertion behaviour
     * so using this safeInsert function in order to handle specific cases in flat list vs nested list
     * instead of a generic pmSafeInsert (i.e appending at the end)
     *
     */ const selectionInsideAPanel = $cd2cf1fbbf0ba8f4$var$selectionIsInsideAPanel(tr);
            if (node.type.name === 'rule' && !selectionInsideAPanel && // ED-17438 If the selection is not an empty paragraph we want to use pmSafeInsert
            // This fixes a bug where if a rule was inserted using safeInsert and the selection
            // was an empty paragraph it would not be inserted
            !(0, $24xJB.isEmptyParagraph)(tr.selection.$from.parent)) tr = $cd2cf1fbbf0ba8f4$export$5fe92db78385e37c(node, tr.selection.from)(tr) ?? tr;
            else tr = (0, $gab48.safeInsert)($cd2cf1fbbf0ba8f4$export$9a3d0d2a50538e52(state, node), undefined, true)(tr);
        /**
     *
     * Replacing a type ahead query mark with an inline node.
     *
     */ } else if (node instanceof (0, $kW8qW.Node) && node.isInline || isInputFragment) {
            const fragment = isInputFragment ? node : (0, $kW8qW.Fragment).fromArray([
                node,
                state.schema.text(' ')
            ]);
            tr = tr.replaceWith(start, start, fragment);
            if (opts.selectInlineNode) // Select inserted node
            tr = tr.setSelection((0, $cw0wu.NodeSelection).create(tr.doc, start));
            else // Placing cursor after node + space.
            tr = tr.setSelection((0, $cw0wu.Selection).near(tr.doc.resolve(start + fragment.size)));
        }
        return tr;
    };
const $cd2cf1fbbf0ba8f4$export$b80431b156693a98 = ({ parentNodeType: parentNodeType, grandParentNodeType: grandParentNodeType, content: content })=>{
    if (parentNodeType.name === 'doc' || parentNodeType.name === 'paragraph' && grandParentNodeType.validContent((0, $kW8qW.Fragment).from(content))) return true;
    return false;
};
function $cd2cf1fbbf0ba8f4$export$b6980e4b8ea578a5(state) {
    const { $from: $from, $to: $to } = state.selection;
    let isAllowedChild = true;
    state.doc.nodesBetween($from.pos, $to.pos, (node, pos)=>{
        const withinSelection = $from.pos <= pos && pos + node.nodeSize <= $to.pos;
        if (!withinSelection) return;
        if (!isAllowedChild) return false;
        return isAllowedChild = node.type === state.schema.nodes.listItem || node.type === state.schema.nodes.bulletList || node.type === state.schema.nodes.orderedList || node.type === state.schema.nodes.paragraph || node.isInline || node.type === state.schema.nodes.panel || node.isText;
    });
    return isAllowedChild;
}
function $cd2cf1fbbf0ba8f4$export$2b1594c8921b5b2e(fragment, nodeType) {
    let doesContainNodeType = false;
    fragment.descendants((node)=>{
        if (node.type === nodeType) {
            doesContainNodeType = true;
            // Stop looking
            return false;
        }
        return true;
    });
    return doesContainNodeType;
}

});





parcelRegister("aKIKQ", function(module, exports) {
$parcel$export(module.exports, "dataConsumerPlugin", () => $d13cc410d6e5a55e$export$1dc90efb79c37811);

var $j5dhp = parcelRequire("j5dhp");
const $d13cc410d6e5a55e$export$1dc90efb79c37811 = ()=>({
        name: 'dataConsumer',
        marks () {
            return [
                {
                    name: 'dataConsumer',
                    mark: (0, $j5dhp.dataConsumer)
                }
            ];
        }
    });

});

parcelRegister("ZKS7T", function(module, exports) {
$parcel$export(module.exports, "PlainOutsideClickTargetRefContext", () => $15f7cc70443f6d91$export$6a802fb2263552f1);

var $bSJIT = parcelRequire("bSJIT");
const $15f7cc70443f6d91$export$6a802fb2263552f1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createContext(()=>{});

});

parcelRegister("llZUW", function(module, exports) {
$parcel$export(module.exports, "default", () => $555e57ec1b4e1e92$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $ZKS7T = parcelRequire("ZKS7T");
function $555e57ec1b4e1e92$export$2e2bcd8739ae039(Component) {
    return class WithOutsideClick extends (0, $bSJIT.PureComponent) {
        componentDidMount() {
            if (this.props.handleClickOutside) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('click', this.handleClick, false);
            if (this.props.handleEscapeKeydown) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('keydown', this.handleKeydown, false);
        }
        componentWillUnmount() {
            if (this.props.handleClickOutside) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('click', this.handleClick, false);
            if (this.props.handleEscapeKeydown) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('keydown', this.handleKeydown, false);
        }
        render() {
            return /*#__PURE__*/ (0, $dc70d.jsx)((0, $ZKS7T.PlainOutsideClickTargetRefContext).Provider, {
                value: this.setOutsideClickTargetRef,
                children: /*#__PURE__*/ (0, $dc70d.jsx)(Component, {
                    ...this.props
                })
            });
        }
        constructor(...args){
            super(...args), this.outsideClickTargetRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createRef(), this.handleClick = (evt)=>{
                var _this$outsideClickTar;
                const domNode = (_this$outsideClickTar = this.outsideClickTargetRef.current) === null || _this$outsideClickTar === void 0 ? void 0 : _this$outsideClickTar.deref();
                if (!domNode || evt.target instanceof Node && !domNode.contains(evt.target)) {
                    var _this$props$handleCli, _this$props;
                    (_this$props$handleCli = (_this$props = this.props).handleClickOutside) === null || _this$props$handleCli === void 0 || _this$props$handleCli.call(_this$props, evt);
                }
            }, this.handleKeydown = (evt)=>{
                if (evt.code === 'Escape' && this.props.handleEscapeKeydown) this.props.handleEscapeKeydown(evt);
            }, this.setOutsideClickTargetRef = (el)=>{
                this.outsideClickTargetRef.current = el && new WeakRef(el);
            };
        }
    };
}

});

parcelRegister("8JT0u", function(module, exports) {
$parcel$export(module.exports, "emojiPlugin", () => $66dc18963fdb6332$export$d1221bd3f80501e0);
$parcel$export(module.exports, "emojiPluginKey", () => $66dc18963fdb6332$export$e3ef5170578bd8ba);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $g6Qq4 = parcelRequire("g6Qq4");

var $5BUNL = parcelRequire("5BUNL");

var $cv8id = parcelRequire("cv8id");

var $fuAsP = parcelRequire("fuAsP");

var $cW1gB = parcelRequire("cW1gB");

var $f7Kk4 = parcelRequire("f7Kk4");

var $aaLLt = parcelRequire("aaLLt");

var $inSrS = parcelRequire("inSrS");

var $cw0wu = parcelRequire("cw0wu");

var $38n7T = parcelRequire("38n7T");
var $2xmC2 = parcelRequire("2xmC2");
var $5yA8z = parcelRequire("5yA8z");

var $fLxHc = parcelRequire("fLxHc");

var $5nwBg = parcelRequire("5nwBg");

var $eYvps = parcelRequire("eYvps");

var $3y2s4 = parcelRequire("3y2s4");

var $797yE = parcelRequire("797yE");

var $iNzJH = parcelRequire("iNzJH");

var $j1SPC = parcelRequire("j1SPC");

var $4KWKM = parcelRequire("4KWKM");

var $jRe2h = parcelRequire("jRe2h");

var $IL4BL = parcelRequire("IL4BL");

var $zBWY4 = parcelRequire("zBWY4");

var $2ymsV = parcelRequire("2ymsV");
const $66dc18963fdb6332$export$144d1b98bacb98cc = (emoji, emojiProvider)=>({
        title: emoji.shortName || '',
        key: emoji.id || emoji.shortName,
        render ({ isSelected: isSelected, onClick: onClick, onHover: onHover }) {
            return /*#__PURE__*/ (0, $dc70d.jsx)((0, $fLxHc.EmojiTypeAheadItem), {
                emoji: emoji,
                selected: isSelected,
                onMouseMove: onHover,
                onSelection: onClick,
                emojiProvider: emojiProvider
            });
        },
        emoji: emoji
    });
function $66dc18963fdb6332$export$fc10aeed3a532e2a(fn) {
    // Cache results here
    const seen = new Map();
    function memoized(emoji, emojiProvider) {
        // Check cache for hits
        const hit = seen.get(emoji.id || emoji.shortName);
        if (hit) return hit;
        // Generate new result and cache it
        const result = fn(emoji, emojiProvider);
        seen.set(emoji.id || emoji.shortName, result);
        return result;
    }
    return {
        call: memoized,
        clear: seen.clear.bind(seen)
    };
}
const $66dc18963fdb6332$var$memoizedToItem = $66dc18963fdb6332$export$fc10aeed3a532e2a($66dc18963fdb6332$export$144d1b98bacb98cc);
const $66dc18963fdb6332$var$defaultListLimit = 50;
const $66dc18963fdb6332$var$isFullShortName = (query)=>query && query.length > 1 && query.charAt(0) === ':' && query.charAt(query.length - 1) === ':';
const $66dc18963fdb6332$var$TRIGGER = ':';
function $66dc18963fdb6332$var$delayUntilIdle(cb) {
    if (typeof window === 'undefined') return;
    // eslint-disable-next-line compat/compat
    if (window.requestIdleCallback !== undefined) // eslint-disable-next-line compat/compat
    return window.requestIdleCallback(()=>cb(), {
        timeout: 500
    });
    return window.requestAnimationFrame(()=>cb());
}
const $66dc18963fdb6332$export$d1221bd3f80501e0 = ({ config: options, api: api })=>{
    var _api$base, _api$analytics5;
    let previousEmojiProvider;
    const typeAhead = {
        id: (0, $aaLLt.TypeAheadAvailableNodes).EMOJI,
        trigger: $66dc18963fdb6332$var$TRIGGER,
        // Custom regex must have a capture group around trigger
        // so it's possible to use it without needing to scan through all triggers again
        customRegex: '\\(?(:)',
        headless: options ? options.headless : undefined,
        getItems ({ query: query, editorState: editorState }) {
            const pluginState = $66dc18963fdb6332$var$getEmojiPluginState(editorState);
            const emojiProvider = pluginState.emojiProvider;
            if (!emojiProvider) return Promise.resolve([]);
            return new Promise((resolve)=>{
                const emojiProviderChangeHandler = {
                    result (emojiResult) {
                        if (!emojiResult || !emojiResult.emojis) resolve([]);
                        else {
                            const emojiItems = emojiResult.emojis.map((emoji)=>$66dc18963fdb6332$var$memoizedToItem.call(emoji, emojiProvider));
                            resolve(emojiItems);
                        }
                        emojiProvider.unsubscribe(emojiProviderChangeHandler);
                    }
                };
                emojiProvider.subscribe(emojiProviderChangeHandler);
                emojiProvider.filter($66dc18963fdb6332$var$TRIGGER.concat(query), {
                    limit: $66dc18963fdb6332$var$defaultListLimit,
                    skinTone: emojiProvider.getSelectedTone(),
                    sort: !query.length ? (0, $5nwBg.SearchSort).UsageFrequency : (0, $5nwBg.SearchSort).Default
                });
            });
        },
        forceSelect ({ query: query, items: items, editorState: editorState }) {
            const { asciiMap: asciiMap } = $66dc18963fdb6332$export$e3ef5170578bd8ba.getState(editorState) || {};
            const normalizedQuery = $66dc18963fdb6332$var$TRIGGER.concat(query);
            // if the query has space at the end
            // check the ascii map for emojis
            if (!(options !== null && options !== void 0 && options.disableAutoformat) && asciiMap && normalizedQuery.length >= 3 && normalizedQuery.endsWith(' ') && asciiMap.has(normalizedQuery.trim())) {
                const emoji = asciiMap.get(normalizedQuery.trim());
                return {
                    title: (emoji === null || emoji === void 0 ? void 0 : emoji.name) || '',
                    emoji: emoji
                };
            }
            const matchedItem = $66dc18963fdb6332$var$isFullShortName(normalizedQuery) ? items.find((item)=>item.title.toLowerCase() === normalizedQuery) : undefined;
            return matchedItem;
        },
        selectItem (state, item, insert, { mode: mode }) {
            var _api$analytics3;
            const emojiPluginState = $66dc18963fdb6332$export$e3ef5170578bd8ba.getState(state);
            if (emojiPluginState.emojiProvider && emojiPluginState.emojiProvider.recordSelection && item.emoji) {
                var _api$analytics, _api$analytics2;
                emojiPluginState.emojiProvider.recordSelection(item.emoji).then((0, $5yA8z.recordSelectionSucceededSli)(item.emoji, {
                    createAnalyticsEvent: (api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 || (_api$analytics = _api$analytics.sharedState.currentState()) === null || _api$analytics === void 0 ? void 0 : _api$analytics.createAnalyticsEvent) ?? undefined
                })).catch((0, $2xmC2.recordSelectionFailedSli)(item.emoji, {
                    createAnalyticsEvent: (api === null || api === void 0 || (_api$analytics2 = api.analytics) === null || _api$analytics2 === void 0 || (_api$analytics2 = _api$analytics2.sharedState.currentState()) === null || _api$analytics2 === void 0 ? void 0 : _api$analytics2.createAnalyticsEvent) ?? undefined
                }));
            }
            const fragment = (0, $iNzJH.createEmojiFragment)(state.doc, state.selection.$head, item.emoji);
            const tr = insert(fragment);
            api === null || api === void 0 || (_api$analytics3 = api.analytics) === null || _api$analytics3 === void 0 || _api$analytics3.actions.attachAnalyticsEvent({
                action: (0, $g6Qq4.ACTION).INSERTED,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).DOCUMENT,
                actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).EMOJI,
                attributes: {
                    inputMethod: (0, $g6Qq4.INPUT_METHOD).TYPEAHEAD
                },
                eventType: (0, $g6Qq4.EVENT_TYPE).TRACK
            })(tr);
            return tr;
        }
    };
    const selectEmojiFromQuickInsert = (insert)=>{
        var _api$typeAhead;
        if ((0, $797yE.editorExperiment)('platform_editor_controls', 'variant1', {
            exposure: true
        })) return (0, $jRe2h.setInlineEmojiPopupOpen)(true)(insert(''));
        const tr = insert(undefined);
        api === null || api === void 0 || (_api$typeAhead = api.typeAhead) === null || _api$typeAhead === void 0 || _api$typeAhead.actions.openAtTransaction({
            triggerHandler: typeAhead,
            inputMethod: (0, $g6Qq4.INPUT_METHOD).QUICK_INSERT
        })(tr);
        return tr;
    };
    const isRegisteredSlashCommandEnabled = (0, $3y2s4.isExperimentEnabled)('platform_editor_slash_command');
    if (isRegisteredSlashCommandEnabled) {
        var _api$uiControlRegistr;
        api === null || api === void 0 || (_api$uiControlRegistr = api.uiControlRegistry) === null || _api$uiControlRegistr === void 0 || _api$uiControlRegistr.actions.register((0, $2ymsV.getEmojiQuickInsertComponents)({
            selectEmojiFromQuickInsert: selectEmojiFromQuickInsert
        }));
    }
    api === null || api === void 0 || (_api$base = api.base) === null || _api$base === void 0 || _api$base.actions.registerMarks(({ tr: tr, node: node, pos: pos })=>{
        const { doc: doc } = tr;
        const { schema: schema } = doc.type;
        const { emoji: emojiNodeType } = schema.nodes;
        if (node.type === emojiNodeType) {
            const newText = node.attrs.text;
            const currentPos = tr.mapping.map(pos);
            tr.replaceWith(currentPos, currentPos + node.nodeSize, schema.text(newText, node.marks));
        }
    });
    return {
        name: 'emoji',
        nodes () {
            return [
                {
                    name: 'emoji',
                    node: (0, $j1SPC.emojiNodeSpec)()
                }
            ];
        },
        usePluginHook () {
            (0, $bSJIT.useEffect)(()=>{
                $66dc18963fdb6332$var$delayUntilIdle(()=>{
                    (0, $38n7T.preloadEmojiPicker)();
                });
            }, []);
        },
        pmPlugins () {
            return [
                {
                    name: 'emoji',
                    plugin: (pmPluginFactoryParams)=>{
                        return $66dc18963fdb6332$var$createEmojiPlugin(pmPluginFactoryParams, options, api);
                    }
                },
                {
                    name: 'emojiAsciiInputRule',
                    plugin: ({ schema: schema })=>{
                        var _api$analytics4;
                        return (0, $IL4BL.inputRulePlugin)(schema, api === null || api === void 0 || (_api$analytics4 = api.analytics) === null || _api$analytics4 === void 0 ? void 0 : _api$analytics4.actions, api, options === null || options === void 0 ? void 0 : options.disableAutoformat);
                    }
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const { emojiResourceConfig: emojiResourceConfig, asciiMap: asciiMap, emojiProvider: emojiProvider, inlineEmojiPopupOpen: inlineEmojiPopupOpen, emojiProviderPromise: emojiProviderPromise } = $66dc18963fdb6332$export$e3ef5170578bd8ba.getState(editorState) ?? {};
            return {
                contentId: options === null || options === void 0 ? void 0 : options.contentId,
                emojiResourceConfig: emojiResourceConfig,
                asciiMap: asciiMap,
                typeAheadHandler: typeAhead,
                emojiProvider: emojiProvider,
                emojiProviderPromise: emojiProviderPromise,
                inlineEmojiPopupOpen: inlineEmojiPopupOpen
            };
        },
        actions: {
            openTypeAhead: (0, $jRe2h.openTypeAhead)(typeAhead, api),
            setProvider: async (providerPromise)=>{
                const provider = await providerPromise;
                // Prevent someone trying to set the exact same provider twice for performance reasons
                if (previousEmojiProvider === provider || (options === null || options === void 0 ? void 0 : options.emojiProvider) === providerPromise) return false;
                previousEmojiProvider = provider;
                return (api === null || api === void 0 ? void 0 : api.core.actions.execute(({ tr: tr })=>$66dc18963fdb6332$var$setProviderTr(provider)(tr))) ?? false;
            }
        },
        commands: {
            insertEmoji: (0, $iNzJH.insertEmoji)(api === null || api === void 0 || (_api$analytics5 = api.analytics) === null || _api$analytics5 === void 0 ? void 0 : _api$analytics5.actions)
        },
        contentComponent ({ editorView: editorView, popupsBoundariesElement: popupsBoundariesElement, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement }) {
            if (!api || (0, $797yE.editorExperiment)('platform_editor_controls', 'control') || !editorView) return null;
            return /*#__PURE__*/ (0, $dc70d.jsx)((0, $zBWY4.InlineEmojiPopup), {
                api: api,
                contentId: options === null || options === void 0 ? void 0 : options.contentId,
                editorView: editorView,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsMountPoint: popupsMountPoint,
                popupsScrollableElement: popupsScrollableElement
            });
        },
        pluginsOptions: {
            ...isRegisteredSlashCommandEnabled ? {} : {
                quickInsert: ({ formatMessage: formatMessage })=>[
                        {
                            id: 'emoji',
                            title: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).emoji),
                            description: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).emojiDescription),
                            priority: 500,
                            keyshortcut: ':',
                            isDisabledOffline: false,
                            icon: ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $5BUNL.IconEmoji), {}),
                            action: selectEmojiFromQuickInsert
                        }
                    ]
            },
            typeAhead: typeAhead,
            floatingToolbar: (state, intl)=>{
                const isViewMode = ()=>{
                    var _api$editorViewMode;
                    return (api === null || api === void 0 || (_api$editorViewMode = api.editorViewMode) === null || _api$editorViewMode === void 0 || (_api$editorViewMode = _api$editorViewMode.sharedState.currentState()) === null || _api$editorViewMode === void 0 ? void 0 : _api$editorViewMode.mode) === 'view';
                };
                if (!isViewMode()) return undefined;
                const onClick = (stateFromClickEvent, dispatch)=>{
                    var _api$analytics6, _api$annotation;
                    if (!(api !== null && api !== void 0 && api.annotation)) return true;
                    if (api !== null && api !== void 0 && (_api$analytics6 = api.analytics) !== null && _api$analytics6 !== void 0 && _api$analytics6.actions) {
                        var _api$analytics7;
                        api === null || api === void 0 || (_api$analytics7 = api.analytics) === null || _api$analytics7 === void 0 || (_api$analytics7 = _api$analytics7.actions) === null || _api$analytics7 === void 0 || _api$analytics7.fireAnalyticsEvent({
                            action: (0, $g6Qq4.ACTION).CLICKED,
                            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).BUTTON,
                            actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).CREATE_INLINE_COMMENT_FROM_HIGHLIGHT_ACTIONS_MENU,
                            eventType: (0, $g6Qq4.EVENT_TYPE).UI,
                            attributes: {
                                source: 'highlightActionsMenu',
                                pageMode: 'edit',
                                sourceNode: 'emoji'
                            }
                        });
                    }
                    const command = (_api$annotation = api.annotation) === null || _api$annotation === void 0 || (_api$annotation = _api$annotation.actions) === null || _api$annotation === void 0 ? void 0 : _api$annotation.setInlineCommentDraftState(true, (0, $g6Qq4.INPUT_METHOD).TOOLBAR);
                    return command(stateFromClickEvent, dispatch);
                };
                return {
                    title: 'Emoji floating toolbar',
                    nodeType: [
                        state.schema.nodes.emoji
                    ],
                    onPositionCalculated: (0, $inSrS.calculateToolbarPositionAboveSelection)('Emoji floating toolbar'),
                    items: (node)=>{
                        var _api$annotation2;
                        const annotationState = api === null || api === void 0 || (_api$annotation2 = api.annotation) === null || _api$annotation2 === void 0 ? void 0 : _api$annotation2.sharedState.currentState();
                        const activeCommentMark = node.marks.find((mark)=>mark.type.name === 'annotation' && (annotationState === null || annotationState === void 0 ? void 0 : annotationState.annotations[mark.attrs.id]) === false);
                        const showAnnotation = annotationState && annotationState.isVisible && !annotationState.bookmark && !annotationState.mouseData.isSelecting && !activeCommentMark && isViewMode();
                        if (showAnnotation) return [
                            {
                                type: 'button',
                                showTitle: true,
                                testId: 'add-comment-emoji-button',
                                icon: (0, (/*@__PURE__*/$parcel$interopDefault($eYvps))),
                                title: intl.formatMessage((0, $fuAsP.annotationMessages).createComment),
                                onClick: onClick,
                                tooltipContent: /*#__PURE__*/ (0, $dc70d.jsx)((0, $cv8id.ToolTipContent), {
                                    description: intl.formatMessage((0, $fuAsP.annotationMessages).createComment)
                                }),
                                supportsViewMode: true
                            }
                        ];
                        return [];
                    }
                };
            }
        }
    };
};
/**
 * Actions
 */ const $66dc18963fdb6332$var$setAsciiMap = (asciiMap)=>(state, dispatch)=>{
        if (dispatch) {
            const tr = (0, $jRe2h.setAsciiMap)(asciiMap)(state.tr);
            dispatch(tr);
        }
        return true;
    };
function $66dc18963fdb6332$export$ae9fa76f15c1e295(fn, limitTime, limitCount, onLimitReached) {
    let lastCallTime = 0;
    let callCount = 0;
    return function wrappedFn(...args) {
        const now = Date.now();
        if (now - lastCallTime < limitTime) {
            if (++callCount > limitCount) onLimitReached === null || onLimitReached === void 0 || onLimitReached();
        } else {
            lastCallTime = now;
            callCount = 1;
        }
        return fn(...args);
    };
}
// At this stage console.error only
const $66dc18963fdb6332$var$logRateWarning = ()=>{};
const $66dc18963fdb6332$var$setProviderTr = $66dc18963fdb6332$export$ae9fa76f15c1e295((provider)=>(tr)=>(0, $jRe2h.setProvider)(provider)(tr), // If we change the emoji provider more than three times every 5 seconds we should warn.
// This seems like a really long time but the performance can be that laggy that we don't
// even get 3 events in 3 seconds and miss this indicator.
5000, 3, $66dc18963fdb6332$var$logRateWarning);
const $66dc18963fdb6332$var$setProvider = (provider)=>(state, dispatch)=>{
        if (dispatch) {
            const tr = $66dc18963fdb6332$var$setProviderTr(provider)(state.tr);
            dispatch(tr);
        }
        return true;
    };
const $66dc18963fdb6332$export$e3ef5170578bd8ba = new (0, $cw0wu.PluginKey)('emojiPlugin');
function $66dc18963fdb6332$var$getEmojiPluginState(state) {
    return $66dc18963fdb6332$export$e3ef5170578bd8ba.getState(state) || {};
}
function $66dc18963fdb6332$var$createEmojiPlugin(pmPluginFactoryParams, options, api) {
    return new (0, $f7Kk4.SafePlugin)({
        key: $66dc18963fdb6332$export$e3ef5170578bd8ba,
        state: {
            init () {
                if (options !== null && options !== void 0 && options.emojiProvider) return {
                    emojiProviderPromise: options.emojiProvider
                };
                return {};
            },
            apply (tr, pluginState) {
                const { action: action, params: params } = tr.getMeta($66dc18963fdb6332$export$e3ef5170578bd8ba) || {
                    action: null,
                    params: null
                };
                let newPluginState = pluginState;
                switch(action){
                    case (0, $jRe2h.ACTIONS).SET_PROVIDER:
                        newPluginState = {
                            ...pluginState,
                            emojiProvider: params.provider,
                            emojiProviderPromise: Promise.resolve(params.provider)
                        };
                        pmPluginFactoryParams.dispatch($66dc18963fdb6332$export$e3ef5170578bd8ba, newPluginState);
                        return newPluginState;
                    case (0, $jRe2h.ACTIONS).SET_ASCII_MAP:
                        newPluginState = {
                            ...pluginState,
                            asciiMap: params.asciiMap
                        };
                        pmPluginFactoryParams.dispatch($66dc18963fdb6332$export$e3ef5170578bd8ba, newPluginState);
                        return newPluginState;
                    case (0, $jRe2h.ACTIONS).SET_INLINE_POPUP:
                        newPluginState = {
                            ...pluginState,
                            inlineEmojiPopupOpen: params.open
                        };
                        pmPluginFactoryParams.dispatch($66dc18963fdb6332$export$e3ef5170578bd8ba, newPluginState);
                        return newPluginState;
                }
                return newPluginState;
            }
        },
        props: {
            nodeViews: {
                emoji: (node)=>{
                    return new (0, $4KWKM.EmojiNodeView)(node, {
                        intl: pmPluginFactoryParams.getIntl(),
                        api: api,
                        emojiNodeDataProvider: options === null || options === void 0 ? void 0 : options.emojiNodeDataProvider
                    });
                }
            }
        },
        view (editorView) {
            const providerHandler = (name, providerPromise)=>{
                switch(name){
                    case 'emojiProvider':
                        if (!providerPromise) {
                            var _setProvider;
                            return $66dc18963fdb6332$var$setProvider === null || $66dc18963fdb6332$var$setProvider === void 0 || (_setProvider = $66dc18963fdb6332$var$setProvider(undefined)) === null || _setProvider === void 0 ? void 0 : _setProvider(editorView.state, editorView.dispatch);
                        }
                        providerPromise.then((provider)=>{
                            var _setProvider2;
                            $66dc18963fdb6332$var$setProvider === null || $66dc18963fdb6332$var$setProvider === void 0 || (_setProvider2 = $66dc18963fdb6332$var$setProvider(provider)) === null || _setProvider2 === void 0 || _setProvider2(editorView.state, editorView.dispatch);
                            provider.getAsciiMap().then((asciiMap)=>{
                                $66dc18963fdb6332$var$setAsciiMap(asciiMap)(editorView.state, editorView.dispatch);
                            });
                        }).catch(()=>{
                            var _setProvider3;
                            return $66dc18963fdb6332$var$setProvider === null || $66dc18963fdb6332$var$setProvider === void 0 || (_setProvider3 = $66dc18963fdb6332$var$setProvider(undefined)) === null || _setProvider3 === void 0 ? void 0 : _setProvider3(editorView.state, editorView.dispatch);
                        });
                        break;
                }
                return;
            };
            if (options !== null && options !== void 0 && options.emojiProvider) providerHandler('emojiProvider', options.emojiProvider);
            return {
                destroy () {
                    if (pmPluginFactoryParams.providerFactory) pmPluginFactoryParams.providerFactory.unsubscribe('emojiProvider', providerHandler);
                }
            };
        }
    });
}

});
parcelRegister("aaLLt", function(module, exports) {
$parcel$export(module.exports, "TypeAheadAvailableNodes", () => $cbf607cb4c4cef25$export$8c4c885c87e5cc07);
$parcel$export(module.exports, "SelectItemMode", () => $cbf607cb4c4cef25$export$4d7d0343c6d95a0e);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $cbf607cb4c4cef25$export$8c4c885c87e5cc07 = /*#__PURE__*/ function(TypeAheadAvailableNodes) {
    TypeAheadAvailableNodes["EMOJI"] = "emojiTypeAhead";
    TypeAheadAvailableNodes["MENTION"] = "mentionTypeAhead";
    TypeAheadAvailableNodes["QUICK_INSERT"] = "quickInsertTypeAhead";
    return TypeAheadAvailableNodes;
}({});
var $cbf607cb4c4cef25$export$4d7d0343c6d95a0e = /*#__PURE__*/ function(SelectItemMode) {
    SelectItemMode["SHIFT_ENTER"] = "shift-enter";
    SelectItemMode["ENTER"] = "enter";
    SelectItemMode["SPACE"] = "space";
    SelectItemMode["SELECTED"] = "selected";
    return SelectItemMode;
}({});

});

parcelRegister("38n7T", function(module, exports) {
$parcel$export(module.exports, "preloadEmojiPicker", () => $1cb607b90a5f4cb2$export$6b47bb4986b03271);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $9UZnQ = parcelRequire("9UZnQ");

var $1Aemb = parcelRequire("1Aemb");
const $1cb607b90a5f4cb2$export$6b47bb4986b03271 = ()=>{
    (0, $1Aemb.emojiPickerLoader)().then((component)=>{
        (0, $9UZnQ.EmojiPickerInternal).AsyncLoadedComponent = component;
    });
};

});
parcelRegister("9UZnQ", function(module, exports) {
$parcel$export(module.exports, "EmojiPickerInternal", () => $d3332455fe543e0f$export$bcf219a275f21b24);
/* EmojiPickerInternal.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $4VhyM = parcelRequire("4VhyM");

var $dihY4 = parcelRequire("dihY4");

var $g3vc1 = parcelRequire("g3vc1");

var $evJGV = parcelRequire("evJGV");

var $zztyk = parcelRequire("zztyk");

var $45OtX = parcelRequire("45OtX");

var $1Aemb = parcelRequire("1Aemb");

var $c6w5O = parcelRequire("c6w5O");
const $d3332455fe543e0f$var$isRefreshEmojiPickerEnabled = ()=>{
    return (0, $evJGV.isTeamoji26RefreshEmojiPickerEnabled)();
};
const $d3332455fe543e0f$var$emojiPicker = null;
const $d3332455fe543e0f$var$emojiPickerNew = null;
class $d3332455fe543e0f$export$bcf219a275f21b24 extends (0, $zztyk.default) {
    static #_ = this.defaultProps = {
        size: (0, $g3vc1.defaultEmojiPickerSize)
    };
    constructor(props){
        super(props, {}), this.state = {
            asyncLoadedComponent: $d3332455fe543e0f$export$bcf219a275f21b24.AsyncLoadedComponent
        };
        (0, $dihY4.ufoExperiences)['emoji-picker-opened'].start();
    }
    asyncLoadComponent() {
        (0, $1Aemb.emojiPickerLoader)().then((component)=>{
            $d3332455fe543e0f$export$bcf219a275f21b24.AsyncLoadedComponent = component;
            this.setAsyncState(component);
        });
    }
    renderLoading() {
        const item = new (0, $c6w5O.LoadingItem)();
        const handlePickerRef = (ref)=>{
            if (this.props.onPickerRef) this.props.onPickerRef(ref);
        };
        (0, $dihY4.ufoExperiences)['emoji-picker-opened'].markFMP();
        return $d3332455fe543e0f$var$isRefreshEmojiPickerEnabled() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
            ref: handlePickerRef,
            className: (0, $9fU1q.default)([
                "_19itahnd _2rko1mok _1e0c1txw _2lx21bp4 _1bah1yb4 _bfhk1bhr _16qs130s _4t3iixjv _1bsb1edt _1ul91edt _1tke5x59 _c71l1y6z"
            ])
        }, item.renderItem()) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
            ref: handlePickerRef,
            className: (0, $9fU1q.default)([
                "_19itahnd _2rkofajl _1e0c1txw _2lx21bp4 _1bah1yb4 _bfhk1bhr _16qs130s _4t3iixjv _1bsb1edt _1ul91edt _1tke5x59 _c71l1y6z"
            ])
        }, item.renderItem());
    }
    renderLoaded(loadedEmojiProvider, EmojiPickerComponent) {
        const { emojiProvider: emojiProvider, ...otherProps } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $45OtX.UfoErrorBoundary), {
            experiences: [
                (0, $dihY4.ufoExperiences)['emoji-picker-opened']
            ]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $4VhyM.EmojiCommonProvider), {
            emojiProvider: loadedEmojiProvider
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(EmojiPickerComponent, otherProps)));
    }
}

});
parcelRegister("zztyk", function(module, exports) {
$parcel$export(module.exports, "default", () => $fc9e644e802c3a5d$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");
class $fc9e644e802c3a5d$export$2e2bcd8739ae039 extends (0, $bSJIT.Component) {
    constructor(props, state){
        super(props), this.isUnmounted = false, this.loaded = (state)=>!!state.asyncLoadedComponent && !!state.loadedEmojiProvider;
        this.state = state;
        // initializing here instead of componentDidMount to avoid needless
        // rerendering if emojiProvider resolves immediately.
        this.loadEmojiProvider(this.props.emojiProvider);
    }
    componentDidMount() {
        // check for the module has not yet been loaded
        // state.asyncLoadedComponent should be initialised
        // with static field to prevent unnecessary rerender
        if (!this.state.asyncLoadedComponent) this.asyncLoadComponent();
    }
    componentDidUpdate(prevProps) {
        if (this.props !== prevProps) this.loadEmojiProvider(this.props.emojiProvider);
    }
    componentWillUnmount() {
        this.isUnmounted = true;
    }
    loadEmojiProvider(futureEmojiProvider) {
        futureEmojiProvider.then((loadedEmojiProvider)=>{
            if (!this.isUnmounted) this.setState({
                loadedEmojiProvider: loadedEmojiProvider
            });
        }).catch(()=>{
            if (!this.isUnmounted) this.setState({
                loadedEmojiProvider: undefined
            });
        });
    }
    setAsyncState(asyncLoadedComponent) {
        if (!this.isUnmounted) this.setState({
            asyncLoadedComponent: asyncLoadedComponent
        });
    }
    renderLoading() {
        return null;
    }
    render() {
        if (this.loaded(this.state)) {
            const { loadedEmojiProvider: loadedEmojiProvider, asyncLoadedComponent: asyncLoadedComponent } = this.state;
            return this.renderLoaded(loadedEmojiProvider, asyncLoadedComponent);
        }
        return this.renderLoading();
    }
}

});

parcelRegister("1Aemb", function(module, exports) {
$parcel$export(module.exports, "emojiPickerLoader", () => $cbd9738bd8910b45$export$6b1deaa9ff7c5a6c);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("bSJIT");

var $2HJ3r = parcelRequire("2HJ3r");
const $cbd9738bd8910b45$export$6b1deaa9ff7c5a6c = ()=>(0, $2HJ3r.emojiPickerModuleLoader)().then((module)=>module.default);

});
parcelRegister("2HJ3r", function(module, exports) {
$parcel$export(module.exports, "emojiPickerModuleLoader", () => $4b35b51b21bed7ad$export$de1ffc44591c1877);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
const $4b35b51b21bed7ad$export$de1ffc44591c1877 = ()=>(parcelRequire("1M1MB"));

});
parcelRegister("1M1MB", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("elre8"),
    $kOunM("hqSeG"),
    $kOunM("eKuC0"),
    $kOunM("4RPAW"),
    $kOunM("bSe9k"),
    $kOunM("4pxn9"),
    $kOunM("4pe2B")
]).then(()=>parcelRequire('hjjLr'));

});



parcelRegister("c6w5O", function(module, exports) {
$parcel$export(module.exports, "LoadingItem", () => $fb0b90dc9652a0ee$export$a16bfd7fb92e211d);
/* LoadingItem.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $hDkm2 = parcelRequire("hDkm2");

var $f19sA = parcelRequire("f19sA");

var $dA3fR = parcelRequire("dA3fR");
const $fb0b90dc9652a0ee$var$emojiPickerSpinner = null;
class $fb0b90dc9652a0ee$export$a16bfd7fb92e211d extends (0, $f19sA.AbstractItem) {
    constructor(){
        super({}, (0, $dA3fR.sizes).loadingRowHeight), this.renderItem = ()=>/*#__PURE__*/ $bSJIT.createElement("div", {
                className: (0, $9fU1q.default)([
                    "_1e0c1txw _1bsb1osq _4t3i1w81 _1bah1h6o _4cvr1h6o _nphsidpf _t1edidpf _1t3b1wug"
                ])
            }, /*#__PURE__*/ $bSJIT.createElement("div", null, /*#__PURE__*/ $bSJIT.createElement((0, $hDkm2.default), {
                size: "medium"
            })));
    }
}

});
parcelRegister("f19sA", function(module, exports) {
$parcel$export(module.exports, "AbstractItem", () => $7e2d344161d8b984$export$8faa7b3aa4960e00);
class $7e2d344161d8b984$export$8faa7b3aa4960e00 {
    constructor(props, height){
        this.props = props;
        this.height = height;
    }
}

});

parcelRegister("dA3fR", function(module, exports) {
$parcel$export(module.exports, "sizes", () => $d00718e4700722ce$export$c647cb0ee6e282fe);

var $g3vc1 = parcelRequire("g3vc1");
const $d00718e4700722ce$export$c647cb0ee6e282fe = {
    listHeight: (0, $g3vc1.emojiPickerListHeight),
    listHeightNew: (0, $g3vc1.emojiPickerListHeightNew),
    listWidth: (0, $g3vc1.emojiPickerWidth),
    searchHeight: 52,
    // 32px height + 10px padding top/bottom
    categoryHeadingHeight: 30,
    // 20px height + 5px padding top/bottom
    emojiRowHeight: 40,
    // 32px button height + 4px padding top/bottom
    addEmojiHeight: 32,
    // 32px height
    loadingRowHeight: 150,
    // Fills remaining space without scrolling when loading.
    noResultsHeight: 300,
    // illustration (200px) + button + padding + gap
    uploadActionHeight: 40,
    // 40px height
    emojiPerRow: 8
};

});




parcelRegister("2xmC2", function(module, exports) {
$parcel$export(module.exports, "recordSelectionFailedSli", () => $bf93bfad6d329552$export$d1176b797f0912b8);

var $jeyHF = parcelRequire("jeyHF");

var $5nwBg = parcelRequire("5nwBg");

var $3THTz = parcelRequire("3THTz");
const $bf93bfad6d329552$export$d1176b797f0912b8 = (emoji, options)=>(err)=>{
        if (options && options.createAnalyticsEvent) (0, $jeyHF.default)('editor')((0, $3THTz.recordFailedEmoji)(emoji)((0, $5nwBg.SearchSourceTypes).TYPEAHEAD))(options.createAnalyticsEvent);
        return Promise.reject(err);
    };

});
parcelRegister("3THTz", function(module, exports) {
$parcel$export(module.exports, "recordFailedEmoji", () => $1acf68cc8bc6bbcb$export$ccd0c8bcbda28b7a);

var $5T1Xz = parcelRequire("5T1Xz");
const $1acf68cc8bc6bbcb$export$ccd0c8bcbda28b7a = (emoji)=>(source)=>{
        return (0, $5T1Xz.createEvent)('operational', 'failed', 'recordEmojiSelection', undefined, {
            source: source,
            emojiId: emoji === null || emoji === void 0 ? void 0 : emoji.id,
            emojiType: emoji === null || emoji === void 0 ? void 0 : emoji.type,
            emojiCategory: emoji === null || emoji === void 0 ? void 0 : emoji.category
        });
    };

});
parcelRegister("5T1Xz", function(module, exports) {
$parcel$export(module.exports, "createEvent", () => $309a117a49b64ce8$export$c30017717ce2168e);
const $309a117a49b64ce8$export$c30017717ce2168e = (eventType, action, actionSubject, actionSubjectId, attributes = {})=>({
        eventType: eventType,
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: {
            packageName: undefined,
            packageVersion: undefined,
            ...attributes
        }
    });

});



parcelRegister("5yA8z", function(module, exports) {
$parcel$export(module.exports, "recordSelectionSucceededSli", () => $38e7dea0560c5add$export$524400435f62e003);

var $jeyHF = parcelRequire("jeyHF");

var $5nwBg = parcelRequire("5nwBg");

var $5rN7U = parcelRequire("5rN7U");
const $38e7dea0560c5add$export$524400435f62e003 = (emoji, options)=>()=>{
        if (options && options.createAnalyticsEvent) (0, $jeyHF.default)('editor')((0, $5rN7U.recordSucceededEmoji)(emoji)((0, $5nwBg.SearchSourceTypes).TYPEAHEAD))(options.createAnalyticsEvent);
    };

});
parcelRegister("5rN7U", function(module, exports) {
$parcel$export(module.exports, "recordSucceededEmoji", () => $e73977ed3e5b9ddb$export$3125c3f60f61a0a9);

var $5T1Xz = parcelRequire("5T1Xz");
const $e73977ed3e5b9ddb$export$3125c3f60f61a0a9 = (emoji)=>(source)=>{
        return (0, $5T1Xz.createEvent)('operational', 'succeeded', 'recordEmojiSelection', undefined, {
            source: source,
            emojiId: emoji === null || emoji === void 0 ? void 0 : emoji.id,
            emojiType: emoji === null || emoji === void 0 ? void 0 : emoji.type,
            emojiCategory: emoji === null || emoji === void 0 ? void 0 : emoji.category
        });
    };

});


parcelRegister("fLxHc", function(module, exports) {
$parcel$export(module.exports, "EmojiTypeAheadItem", () => $564d4e7cb4c84526$export$daacac59bb40fabe);
/* EmojiTypeAheadItem.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $bSJIT = parcelRequire("bSJIT");

var $doLfY = parcelRequire("doLfY");
const $564d4e7cb4c84526$export$b48686835ee0e5db = 350;
const $564d4e7cb4c84526$export$daacac59bb40fabe = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).forwardRef((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $doLfY.EmojiTypeAheadItemInternal), {
        ...props,
        forwardedRef: ref
    }));
var $564d4e7cb4c84526$export$2e2bcd8739ae039 = $564d4e7cb4c84526$export$daacac59bb40fabe;

});
parcelRegister("doLfY", function(module, exports) {
$parcel$export(module.exports, "EmojiTypeAheadItemInternal", () => $83fc04905e6859c5$export$616ca81e9448d046);
/* EmojiTypeAheadItemInternal.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $gdUUy = parcelRequire("gdUUy");

var $4VhyM = parcelRequire("4VhyM");

var $hQiBh = parcelRequire("hQiBh");

var $aR8hx = parcelRequire("aR8hx");

var $eE2JW = parcelRequire("eE2JW");

var $kfsB2 = parcelRequire("kfsB2");
const $83fc04905e6859c5$var$typeAheadItem = null;
const $83fc04905e6859c5$var$selectedStyles = null;
const $83fc04905e6859c5$var$typeAheadItemRow = null;
function $83fc04905e6859c5$export$616ca81e9448d046(props) {
    const { emoji: emoji, onSelection: onSelection, onMouseMove: onMouseMove, selected: selected, emojiProvider: emojiProvider, forwardedRef: forwardedRef } = props;
    const onEmojiSelected = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useCallback((event)=>{
        if ((0, $hQiBh.leftClick)(event) && onSelection) {
            event.preventDefault();
            onSelection((0, $aR8hx.toEmojiId)(emoji), emoji, event);
        }
    }, [
        emoji,
        onSelection
    ]);
    const onEmojiMenuItemMouseMove = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useCallback((event)=>{
        if (onMouseMove) onMouseMove((0, $aR8hx.toEmojiId)(emoji), emoji, event);
    }, [
        emoji,
        onMouseMove
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $4VhyM.EmojiCommonProvider), {
        emojiProvider: emojiProvider
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $9fU1q.default)([
            "_1reo15vq _18m915vq _80omtlke _1e0c1ule _2mzuglyw _1bsb1edt",
            selected && "_bfhki8nm",
            `ak-emoji-typeahead-item ${selected ? (0, $kfsB2.typeaheadSelected) : ''}`
        ]),
        onMouseDown: onEmojiSelected,
        onMouseMove: onEmojiMenuItemMouseMove,
        "data-emoji-id": emoji.shortName,
        ref: forwardedRef,
        role: (0, $gdUUy.fg)('platform_suppression_removal_fix_reactions') ? 'button' : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
        className: (0, $9fU1q.default)([
            "_1e0c1txw _2lx2vrvc _1n261g80 _s7n4nkob"
        ])
    }, emoji && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $eE2JW.EmojiPreviewComponent), {
        emoji: emoji
    }))));
}

});
parcelRegister("eE2JW", function(module, exports) {
$parcel$export(module.exports, "EmojiPreviewComponent", () => $9d811c9a2345a1ed$export$222c91bd2db2d158);
/* EmojiPreviewComponent.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $cVUdM = parcelRequire("cVUdM");
const $9d811c9a2345a1ed$var$emojiName = null;
const $9d811c9a2345a1ed$var$emojiShortName = null;
const $9d811c9a2345a1ed$var$preview = null;
const $9d811c9a2345a1ed$var$previewImg = null;
const $9d811c9a2345a1ed$var$previewText = null;
const $9d811c9a2345a1ed$export$222c91bd2db2d158 = ({ emoji: emoji })=>{
    return /*#__PURE__*/ $bSJIT.createElement("div", {
        className: (0, $9fU1q.default)([
            "_ca0q19bv _u5f319bv _n3td19bv _19bv19bv _1e0c1txw _2lx2vrvc _1n261q9c _4t3izwfg _4cvr1h6o"
        ])
    }, /*#__PURE__*/ $bSJIT.createElement("span", {
        className: (0, $9fU1q.default)([
            "_1e0c1o8l _1bsbzwfg _12s6idpf _1e4didpf _1dvqidpf _vwlxidpf _1gdiidpf _1f45idpf _pdfdidpf _mwo3idpf _5ilezwfg _boltzwfg _1pc7zwfg _u5wqzwfg _w7981kw7 _1vqe1kw7 _1l4xidpf _1l79idpf _118didpf _1pa4idpf _1pglh2mm _1vjf1ssb _1h6o1ssb _8fp6dbra _1os4zwfg _1e7azwfg _7mh21ule"
        ])
    }, /*#__PURE__*/ $bSJIT.createElement((0, $cVUdM.default), {
        key: emoji.id || emoji.shortName,
        emoji: emoji
    })), /*#__PURE__*/ $bSJIT.createElement("div", {
        className: (0, $9fU1q.default)([
            "_1e0c1txw _2lx21bp4 _1wpz1h6o _19pk1i6y _18u019bv _p12f3sup _1bsb3sup _16jlkb7n _1o9zkb7n"
        ])
    }, emoji.name && /*#__PURE__*/ $bSJIT.createElement("div", {
        className: (0, $9fU1q.default)([
            "_1reo15vq _18m915vq _1e0c1ule _syazi7uo _1bto1l2s _o5721q9c _299mangw"
        ])
    }, emoji.name), /*#__PURE__*/ $bSJIT.createElement("div", {
        className: (0, $9fU1q.default)([
            "_11c8wadc _1reo15vq _18m915vq _1e0c1ule _syazazsu _vwz4kb7n _otyr1i6y _n3tdv77o _1bto1l2s _o5721q9c _10hwfhey _pnmbi7uo"
        ])
    }, emoji.shortName)));
};

});
parcelRegister("cVUdM", function(module, exports) {
$parcel$export(module.exports, "default", () => $e8d04227a35a3a15$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $2u9sW = parcelRequire("2u9sW");

var $75gsN = parcelRequire("75gsN");

var $dihY4 = parcelRequire("dihY4");

var $i7XuO = parcelRequire("i7XuO");

var $g3vc1 = parcelRequire("g3vc1");

var $4CEaO = parcelRequire("4CEaO");

var $50HdX = parcelRequire("50HdX");

var $8MOlQ = parcelRequire("8MOlQ");

var $53fYj = parcelRequire("53fYj");

var $45OtX = parcelRequire("45OtX");
const $e8d04227a35a3a15$export$e81207f376d36133 = (props)=>{
    // Optimisation to only render CachingMediaEmoji if necessary
    // slight performance hit, which accumulates for a large number of emoji.
    const { emoji: emoji, placeholderSize: placeholderSize, ...restProps } = props;
    // start emoji rendered experience, it may have already started earlier in `ResourcedEmoji`.
    (0, $i7XuO.useSampledUFOComponentExperience)((0, $dihY4.ufoExperiences)['emoji-rendered'].getInstance(emoji.id || emoji.shortName), (0, $g3vc1.SAMPLING_RATE_EMOJI_RENDERED_EXP), {
        source: 'CachingEmoji',
        emojiId: emoji.id
    });
    (0, $bSJIT.useEffect)(()=>{
        if (!(0, $2u9sW.hasUfoMarked)((0, $75gsN.sampledUfoRenderedEmoji)(emoji), 'fmp')) (0, $75gsN.sampledUfoRenderedEmoji)(emoji).markFMP();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const emojiNode = ()=>{
        if ((0, $4CEaO.isMediaEmoji)(emoji)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $50HdX.CachingMediaEmoji), {
            emoji: emoji,
            placeholderSize: placeholderSize,
            ...restProps
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($e8d04227a35a3a15$var$StandardEmoji, {
            emoji: emoji,
            ...restProps
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $45OtX.UfoErrorBoundary), {
        experiences: [
            (0, $dihY4.ufoExperiences)['emoji-rendered'].getInstance(props.emoji.id || props.emoji.shortName)
        ]
    }, emojiNode());
};
const $e8d04227a35a3a15$var$StandardEmoji = (props)=>{
    const { emoji: emoji, ...restProps } = props;
    const [imageLoadError, setImageLoadError] = (0, $bSJIT.useState)(false);
    const handleLoadError = (_emojiId)=>{
        setImageLoadError(true);
    };
    if (imageLoadError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $53fYj.default), {
        emoji: emoji,
        ...restProps
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8MOlQ.default), {
        emoji: emoji,
        onLoadError: handleLoadError,
        ...restProps
    });
};
const $e8d04227a35a3a15$var$_default_1 = /*#__PURE__*/ (0, $bSJIT.memo)($e8d04227a35a3a15$export$e81207f376d36133);
var $e8d04227a35a3a15$export$2e2bcd8739ae039 = $e8d04227a35a3a15$var$_default_1;

});
parcelRegister("50HdX", function(module, exports) {
$parcel$export(module.exports, "CachingMediaEmoji", () => $b86b98fdc5162e2d$export$aa961da7639f7a98);

var $bSJIT = parcelRequire("bSJIT");

var $5gxwP = parcelRequire("5gxwP");

var $5nwBg = parcelRequire("5nwBg");

var $5K8fJ = parcelRequire("5K8fJ");

var $75gsN = parcelRequire("75gsN");

var $cz2rC = parcelRequire("cz2rC");

var $8MOlQ = parcelRequire("8MOlQ");

var $7hbMQ = parcelRequire("7hbMQ");
const $b86b98fdc5162e2d$export$aa961da7639f7a98 = (props)=>{
    const { emoji: emoji, placeholderSize: placeholderSize, showTooltip: showTooltip, fitToHeight: fitToHeight, children: children, ...restProps } = props;
    const { shortName: shortName, representation: representation } = emoji;
    const [cachedEmoji, setCachedEmoji] = (0, $bSJIT.useState)();
    const [inValidImage, setInvalidImage] = (0, $bSJIT.useState)(false);
    const { emojiProvider: emojiProvider } = (0, $5gxwP.useEmoji)();
    const loadEmoji = (0, $bSJIT.useCallback)((emojiProvider)=>{
        (0, $cz2rC.default)('Loading image via media cache', emoji.shortName);
        (0, $75gsN.sampledUfoRenderedEmoji)(emoji).mark((0, $5nwBg.UfoEmojiTimings).MEDIA_START);
        emojiProvider.getMediaEmojiDescriptionURLWithInlineToken(emoji).then((cachedEmoji)=>{
            setCachedEmoji(cachedEmoji);
            setInvalidImage(false);
            (0, $75gsN.sampledUfoRenderedEmoji)(emoji).mark((0, $5nwBg.UfoEmojiTimings).MEDIA_END);
        }).catch((error)=>{
            setCachedEmoji(undefined);
            setInvalidImage(true);
            (0, $75gsN.sampledUfoRenderedEmoji)(emoji).failure({
                metadata: {
                    error: (0, $5K8fJ.extractErrorInfo)(error),
                    reason: 'failed to load media emoji',
                    source: 'CachingMediaEmoji',
                    emojiId: emoji.id
                }
            });
        });
    }, [
        emoji
    ]);
    (0, $bSJIT.useEffect)(()=>{
        if (emojiProvider) loadEmoji(emojiProvider);
    }, [
        emojiProvider,
        loadEmoji
    ]);
    const handleLoadError = (_emojiId)=>{
        (0, $75gsN.sampledUfoRenderedEmoji)(_emojiId).failure({
            metadata: {
                reason: 'load error',
                source: 'CachingMediaEmoji',
                emojiId: _emojiId.id
            }
        });
        setInvalidImage(true);
    };
    if (cachedEmoji && !inValidImage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8MOlQ.default), {
        ...restProps,
        showTooltip: showTooltip,
        fitToHeight: fitToHeight,
        emoji: cachedEmoji,
        onLoadError: handleLoadError
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $7hbMQ.default), {
        size: fitToHeight || placeholderSize,
        shortName: shortName,
        showTooltip: showTooltip,
        representation: representation
    });
};

});
parcelRegister("5gxwP", function(module, exports) {
$parcel$export(module.exports, "useEmoji", () => $e0d3086ef1ed1ec5$export$482903c4ce3f5633);

var $bSJIT = parcelRequire("bSJIT");

var $1Hsl1 = parcelRequire("1Hsl1");
const $e0d3086ef1ed1ec5$var$supportsUploadFeature = (emojiProvider)=>{
    const emojiUploadProvider = emojiProvider;
    return !!emojiUploadProvider.isUploadSupported && !!emojiUploadProvider.uploadCustomEmoji && !!emojiUploadProvider.prepareForUpload;
};
const $e0d3086ef1ed1ec5$export$482903c4ce3f5633 = ()=>{
    const context = (0, $bSJIT.useContext)((0, $1Hsl1.EmojiContext));
    // Hooks API
    const [isUploadSupported, setIsUploadSupported] = (0, $bSJIT.useState)(false);
    if (!context) throw new Error('useEmoji must be used within EmojiContext');
    const { emojiProvider: emojiProvider } = context.emoji;
    (0, $bSJIT.useEffect)(()=>{
        if ($e0d3086ef1ed1ec5$var$supportsUploadFeature(emojiProvider)) {
            const checkIfUploadIsSupported = async ()=>{
                try {
                    const supported = await emojiProvider.isUploadSupported();
                    setIsUploadSupported(supported);
                    return true;
                } catch (error) {
                    return false;
                }
            };
            checkIfUploadIsSupported();
        }
    }, [
        emojiProvider
    ]);
    return {
        emojiProvider: emojiProvider,
        isUploadSupported: isUploadSupported
    };
};

});

parcelRegister("5K8fJ", function(module, exports) {
$parcel$export(module.exports, "extractErrorInfo", () => $b5c1d2dc1e195648$export$74aaf4784c2edb2c);
/**
 * Used for store failure metadata for analytics
 * @param error The error could be a service error with {code, reason} or an Error
 * @returns any
 */ const $b5c1d2dc1e195648$export$74aaf4784c2edb2c = (error)=>{
    if (error instanceof Error) return {
        name: error.name,
        message: error.message
    };
    return error;
};

});


parcelRegister("53fYj", function(module, exports) {
$parcel$export(module.exports, "default", () => $db8e38eb727c6e56$export$2e2bcd8739ae039);
/* EmojiFallback.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $8MOlQ = parcelRequire("8MOlQ");

var $55FVI = parcelRequire("55FVI");
const $db8e38eb727c6e56$var$emojiFallbackStyles = null;
const $db8e38eb727c6e56$export$e3a226c1c0d61870 = (props)=>{
    const { emoji: emoji, selected: selected, selectOnHover: selectOnHover, className: className } = props;
    const { fallback: fallback, shortName: shortName } = emoji;
    const classes = `${(0, $55FVI.emojiNodeStyles)} ${selected ? (0, $55FVI.commonSelectedStyles) : ''} ${selectOnHover ? (0, $55FVI.selectOnHoverStyles) : ''} ${className ? className : ''}`;
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $8MOlQ.EmojiNodeWrapper), {
        type: "image",
        ...props,
        className: classes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("span", {
        className: (0, $9fU1q.default)([
            "_1reo15vq _18m915vq _1e0c1txw _1bsb1osq _4t3i1osq _1bah1h6o _4cvr1h6o"
        ])
    }, fallback || shortName)));
};
var $db8e38eb727c6e56$export$2e2bcd8739ae039 = $db8e38eb727c6e56$export$e3a226c1c0d61870;

});



parcelRegister("kfsB2", function(module, exports) {
$parcel$export(module.exports, "typeaheadSelected", () => $09ab62b1caaed590$export$214089244105a739);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
const $09ab62b1caaed590$export$dca0df2a2f0ab6cf = 'emoji-typeahead-element';
const $09ab62b1caaed590$export$9b2d029b494a863e = 'emoji-typeahead-list-container';
const $09ab62b1caaed590$export$214089244105a739 = 'emoji-typeahead-selected';

});



parcelRegister("iNzJH", function(module, exports) {
$parcel$export(module.exports, "createEmojiFragment", () => $5b3221da884ca084$export$c62c7770bca4be17);
$parcel$export(module.exports, "insertEmoji", () => $5b3221da884ca084$export$8d5c072327044b6f);

var $g6Qq4 = parcelRequire("g6Qq4");

var $cWyqT = parcelRequire("cWyqT");

var $kW8qW = parcelRequire("kW8qW");

var $cw0wu = parcelRequire("cw0wu");

var $gab48 = parcelRequire("gab48");
const $5b3221da884ca084$export$c62c7770bca4be17 = (doc, pos, emoji)=>{
    const { id: id = '', fallback: fallback, shortName: shortName } = emoji;
    const annotationMarksForPos = (0, $cWyqT.getAnnotationMarksForPos)(pos);
    const emojiNode = doc.type.schema.nodes.emoji.createChecked({
        shortName: shortName,
        id: id,
        text: fallback || shortName
    }, null, annotationMarksForPos);
    const space = doc.type.schema.text(' ', annotationMarksForPos);
    return (0, $kW8qW.Fragment).fromArray([
        emojiNode,
        space
    ]);
};
const $5b3221da884ca084$export$8d5c072327044b6f = (editorAnalyticsAPI)=>(emojiId, inputMethod)=>{
        return ({ tr: tr })=>{
            const { doc: doc, selection: selection } = tr;
            const { emoji: emoji } = tr.doc.type.schema.nodes;
            if (emoji && emojiId) {
                const fragment = $5b3221da884ca084$export$c62c7770bca4be17(doc, selection.$head, emojiId);
                const newTr = (0, $gab48.safeInsert)(fragment)(tr);
                if (inputMethod) editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent({
                    action: (0, $g6Qq4.ACTION).INSERTED,
                    actionSubject: (0, $g6Qq4.ACTION_SUBJECT).DOCUMENT,
                    actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).EMOJI,
                    attributes: {
                        inputMethod: inputMethod
                    },
                    eventType: (0, $g6Qq4.EVENT_TYPE).TRACK
                })(newTr);
                newTr.setSelection((0, $cw0wu.Selection).near(newTr.doc.resolve(selection.$from.pos + fragment.size)));
                return newTr;
            }
            return null;
        };
    };

});

parcelRegister("j1SPC", function(module, exports) {
$parcel$export(module.exports, "emojiNodeSpec", () => $30b857f3e84eaabc$export$d122e24cc43292f6);
$parcel$export(module.exports, "emojiToDom", () => $30b857f3e84eaabc$export$9edeb07c311f4561);

var $cf5lB = parcelRequire("cf5lB");

var $PFzWP = parcelRequire("PFzWP");

var $gdUUy = parcelRequire("gdUUy");

var $5N1Y4 = parcelRequire("5N1Y4");
const $30b857f3e84eaabc$var$isSSR = Boolean(undefined);
const $30b857f3e84eaabc$export$d122e24cc43292f6 = ()=>{
    const emojiNode = (0, $gdUUy.fg)('platform_editor_adf_with_localid') ? (0, $cf5lB.emojiWithLocalId) : (0, $cf5lB.emoji);
    if ($30b857f3e84eaabc$var$isSSR) return emojiNode;
    return {
        ...emojiNode,
        toDOM: (node)=>$30b857f3e84eaabc$export$9edeb07c311f4561(node)
    };
};
function $30b857f3e84eaabc$export$9edeb07c311f4561(node) {
    // From packages/elements/emoji/src/components/common/EmojiPlaceholder.tsx
    const { shortName: shortName, id: id, text: text } = node.attrs;
    const isEmojiScalingEnabled = (0, $5N1Y4.expValEquals)('platform_editor_lovability_emoji_scaling', 'isEnabled', true);
    const attrs = {
        'data-emoji-short-name': shortName,
        'data-emoji-id': id,
        'data-emoji-text': text,
        contenteditable: 'false',
        style: (0, $PFzWP.convertToInlineCss)({
            content: "''",
            fill: "var(--ds-background-neutral, #0515240F)",
            ...isEmojiScalingEnabled ? {
                minWidth: '16.25px',
                minHeight: '16.25px'
            } : {
                minWidth: `20px`,
                width: `20px`,
                height: `20px`
            },
            position: 'relative',
            margin: '-1px 0',
            display: 'inline-block',
            background: "var(--ds-background-neutral, #0515240F)",
            borderRadius: "var(--ds-radius-small, 3px)",
            overflow: 'hidden',
            verticalAlign: 'middle',
            whiteSpace: 'nowrap',
            textAlign: 'center'
        }),
        'aria-busy': 'true',
        'aria-label': shortName,
        class: 'emoji-common-placeholder'
    };
    if ((0, $gdUUy.fg)('platform_editor_adf_with_localid')) attrs['data-local-id'] = node.attrs.localId;
    return [
        'span',
        attrs
    ];
}

});

parcelRegister("4KWKM", function(module, exports) {
$parcel$export(module.exports, "EmojiNodeView", () => $794db571bf2c3ca3$export$cadc6675ce598ba8);

var $bAB3U = parcelRequire("bAB3U");

var $dMMwa = parcelRequire("dMMwa");

var $iiozI = parcelRequire("iiozI");

var $c9wRy = parcelRequire("c9wRy");

var $hVGJk = parcelRequire("hVGJk");

var $gfs9q = parcelRequire("gfs9q");

var $7lseo = parcelRequire("7lseo");

var $j2Y9J = parcelRequire("j2Y9J");

var $dZp9s = parcelRequire("dZp9s");

var $j7bkr = parcelRequire("j7bkr");

var $kjMQA = parcelRequire("kjMQA");

var $kW8qW = parcelRequire("kW8qW");

var $g3vc1 = parcelRequire("g3vc1");

var $3y2s4 = parcelRequire("3y2s4");

var $5N1Y4 = parcelRequire("5N1Y4");

var $j1SPC = parcelRequire("j1SPC");
/**
 * Emoji node view for renderering emoji nodes
 */ const $794db571bf2c3ca3$var$EMOJI_TOOLTIP_CLASS = 'emoji-tooltip-editor';
/**
 * Shared default look plus our own hook, replacing the inline styles the control arm passes.
 */ const $794db571bf2c3ca3$var$EMOJI_TOOLTIP_CLASS_NAMES = `${(0, $kjMQA.VANILLA_TOOLTIP_DEFAULT_CLASS)} ${$794db571bf2c3ca3$var$EMOJI_TOOLTIP_CLASS}`;
/**
 * Control arm only — `VanillaTooltip` generates its own id when none is supplied.
 * `crypto.randomUUID()` is undefined outside a secure context, hence the `uniqueId` fallback.
 */ const $794db571bf2c3ca3$var$nextFallbackTooltipId = ()=>typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function' ? `emoji-tooltip-${crypto.randomUUID()}` : (0, (/*@__PURE__*/$parcel$interopDefault($iiozI)))('emoji-tooltip-');
class $794db571bf2c3ca3$export$cadc6675ce598ba8 {
    destroyTooltip() {
        var _this$destroyLazyTool, _this$tooltipInstance;
        (_this$destroyLazyTool = this.destroyLazyTooltipListeners) === null || _this$destroyLazyTool === void 0 || _this$destroyLazyTool.call(this);
        (_this$tooltipInstance = this.tooltipInstance) === null || _this$tooltipInstance === void 0 || _this$tooltipInstance.destroy();
        // with platform_editor_use_vanilla_components the tooltipInstance?.destroy()
        // will remove the popovertarget and aria-describedby attributes from the tooltipTarget
        if (!(0, $3y2s4.isExperimentEnabled)('platform_editor_use_vanilla_components')) {
            var _this$tooltipTarget, _this$tooltipTarget2;
            (_this$tooltipTarget = this.tooltipTarget) === null || _this$tooltipTarget === void 0 || _this$tooltipTarget.removeAttribute('popovertarget');
            (_this$tooltipTarget2 = this.tooltipTarget) === null || _this$tooltipTarget2 === void 0 || _this$tooltipTarget2.removeAttribute('aria-describedby');
        }
        this.destroyLazyTooltipListeners = undefined;
        this.tooltipInstance = undefined;
        this.tooltipTarget = undefined;
    }
    static logError(error) {
        (0, $j2Y9J.logException)(error, {
            location: 'editor-plugin-emoji/EmojiNodeView'
        });
    }
    /**
   * Prosemirror node view for rendering emoji nodes. This class is responsible for
   * rendering emoji nodes in the editor, handling updates, and managing fallback rendering.
   *
   * @param node - The ProseMirror node representing the emoji.
   * @param extraProps - An object containing additional parameters.
   * @param extraProps.intl - The internationalization object for formatting messages.
   * @param extraProps.api - The editor API for accessing shared state and connectivity features.
   * @param extraProps.emojiNodeDataProvider - (Optional) A provider for fetching emoji data.
   *
   * @example
   * const emojiNodeView = new EmojiNodeView(node, { intl, api, emojiNodeDataProvider });
   */ constructor(node, { intl: intl, api: api, emojiNodeDataProvider: emojiNodeDataProvider }){
        this.renderingFallback = false;
        this.destroy = ()=>{
            if (this.tooltipInstance || this.tooltipTarget || this.destroyLazyTooltipListeners) this.destroyTooltip();
        };
        this.node = node;
        this.intl = intl;
        const { dom: dom } = (0, $kW8qW.DOMSerializer).renderSpec(document, (0, $j1SPC.emojiToDom)(this.node));
        this.dom = dom;
        this.domElement = this.isHTMLElement(dom) ? dom : undefined;
        if (emojiNodeDataProvider) {
            let previousEmojiDescription;
            emojiNodeDataProvider.getData(node, (payload)=>{
                if (payload.error) {
                    $794db571bf2c3ca3$export$cadc6675ce598ba8.logError(payload.error);
                    this.renderFallback();
                    return;
                }
                const optionalEmojiDescription = payload.data;
                if (!optionalEmojiDescription) {
                    this.renderFallback();
                    return;
                }
                const emojiRepresentation = optionalEmojiDescription === null || optionalEmojiDescription === void 0 ? void 0 : optionalEmojiDescription.representation;
                if (!$794db571bf2c3ca3$export$cadc6675ce598ba8.isEmojiRepresentationSupported(emojiRepresentation)) {
                    this.renderFallback();
                    return;
                }
                if ((0, (/*@__PURE__*/$parcel$interopDefault($dMMwa)))(previousEmojiDescription, optionalEmojiDescription)) // Do not re-render if the emoji description is the same as before
                return;
                previousEmojiDescription = optionalEmojiDescription;
                this.renderEmoji(optionalEmojiDescription, emojiRepresentation);
            });
        } else {
            var _api$emoji, _sharedState$currentS, _api$connectivity;
            if ((0, $7lseo.isSSR)()) // The provider doesn't work in SSR, and we don't want to render fallback in SSR,
            // that's why we don't need to continue node rendering.
            // In SSR we want to show a placeholder, that `emojiToDom()` returns.
            return;
            // We use the `emojiProvider` from the shared state
            // because it supports the `emojiProvider` prop in the `ComposableEditor` options
            // as well as the `emojiProvider` in the `EmojiPlugin` options.
            const sharedState = api === null || api === void 0 || (_api$emoji = api.emoji) === null || _api$emoji === void 0 ? void 0 : _api$emoji.sharedState;
            if (!sharedState) return;
            let emojiProvider = (_sharedState$currentS = sharedState.currentState()) === null || _sharedState$currentS === void 0 ? void 0 : _sharedState$currentS.emojiProvider;
            if (emojiProvider) this.updateDom(emojiProvider);
            const unsubscribe = sharedState.onChange(({ nextSharedState: nextSharedState })=>{
                if (emojiProvider === (nextSharedState === null || nextSharedState === void 0 ? void 0 : nextSharedState.emojiProvider)) // Do not update if the provider is the same
                return;
                emojiProvider = nextSharedState === null || nextSharedState === void 0 ? void 0 : nextSharedState.emojiProvider;
                this.updateDom(emojiProvider);
            });
            // Refresh emojis if we go back online
            const subscribeToConnection = api === null || api === void 0 || (_api$connectivity = api.connectivity) === null || _api$connectivity === void 0 ? void 0 : _api$connectivity.sharedState.onChange(({ prevSharedState: prevSharedState, nextSharedState: nextSharedState })=>{
                if ((0, $hVGJk.isOfflineMode)(prevSharedState === null || prevSharedState === void 0 ? void 0 : prevSharedState.mode) && (nextSharedState === null || nextSharedState === void 0 ? void 0 : nextSharedState.mode) === 'online' && this.renderingFallback) {
                    var _sharedState$currentS2;
                    this.updateDom((_sharedState$currentS2 = sharedState.currentState()) === null || _sharedState$currentS2 === void 0 ? void 0 : _sharedState$currentS2.emojiProvider);
                }
            });
            this.destroy = ()=>{
                unsubscribe();
                subscribeToConnection === null || subscribeToConnection === void 0 || subscribeToConnection();
                this.destroyTooltip();
            };
        }
    }
    /** Type guard to check if a Node is an HTMLElement in a safe way. */ isHTMLElement(element) {
        if (element === null) return false;
        // In SSR `HTMLElement` is not defined, so we need to use duck typing here
        return 'innerHTML' in element && 'style' in element && 'classList' in element;
    }
    async updateDom(emojiProvider) {
        try {
            const { shortName: shortName, id: id, text: fallback } = this.node.attrs;
            const emojiDescription = await (emojiProvider === null || emojiProvider === void 0 ? void 0 : emojiProvider.fetchByEmojiId({
                id: id,
                shortName: shortName,
                fallback: fallback
            }, true));
            if (!emojiDescription) {
                $794db571bf2c3ca3$export$cadc6675ce598ba8.logError(new Error('Emoji description is not loaded'));
                this.renderFallback();
                return;
            }
            const emojiRepresentation = emojiDescription === null || emojiDescription === void 0 ? void 0 : emojiDescription.representation;
            if (!$794db571bf2c3ca3$export$cadc6675ce598ba8.isEmojiRepresentationSupported(emojiRepresentation)) {
                $794db571bf2c3ca3$export$cadc6675ce598ba8.logError(new Error('Emoji representation is not supported'));
                this.renderFallback();
                return;
            }
            this.renderEmoji(emojiDescription, emojiRepresentation);
        } catch (error) {
            $794db571bf2c3ca3$export$cadc6675ce598ba8.logError(error instanceof Error ? error : new Error('Unknown error on EmojiNodeView updateDom'));
            this.renderFallback();
        }
    }
    static isEmojiRepresentationSupported(representation) {
        return !!representation && ('sprite' in representation || 'imagePath' in representation || 'mediaPath' in representation);
    }
    // Pay attention, this method should be called only when the emoji provider returns
    // emoji data to prevent rendering empty emoji during loading.
    cleanUpAndRenderCommonAttributes() {
        this.destroyTooltip();
        // Clean up the DOM before rendering the new emoji
        if (this.domElement) {
            this.domElement.innerHTML = '';
            this.domElement.style.cssText = '';
            this.domElement.classList.remove((0, $dZp9s.EmojiSharedCssClassName).EMOJI_PLACEHOLDER);
            this.domElement.removeAttribute('aria-label'); // The label is set in the renderEmoji method
            this.domElement.removeAttribute('aria-busy');
        }
    }
    /**
   * Lazily creates a VanillaTooltip on the given element showing the emoji shortName.
   * Gated behind the platform_editor_emoji_hover_show_tooltip experiment.
   * When the tooltip is active, the native `title` attribute is removed to avoid
   * showing both the browser tooltip and the custom tooltip.
   */ createTooltip(element, shortName) {
        if (!(0, $5N1Y4.expValEquals)('platform_editor_emoji_hover_show_tooltip', 'isEnabled', true)) return;
        if ((0, $7lseo.isSSR)()) return;
        const initTooltip = (event)=>{
            var _this$destroyLazyTool2;
            (_this$destroyLazyTool2 = this.destroyLazyTooltipListeners) === null || _this$destroyLazyTool2 === void 0 || _this$destroyLazyTool2.call(this);
            this.destroyLazyTooltipListeners = undefined;
            // `undefined` lets `VanillaTooltip` generate the id.
            const tooltipId = (0, $3y2s4.isExperimentEnabled)('platform_editor_use_vanilla_components') ? undefined : $794db571bf2c3ca3$var$nextFallbackTooltipId();
            // Control arm only — the experiment arm gets the same declarations from
            // `VANILLA_TOOLTIP_DEFAULT_CLASS`.
            const tooltipStyles = (0, $3y2s4.isExperimentEnabled)('platform_editor_use_vanilla_components') ? undefined : {
                boxSizing: 'border-box',
                maxWidth: '240px',
                backgroundColor: "var(--ds-background-neutral-bold, #292A2E)",
                border: 'none',
                borderRadius: "var(--ds-radius-small, 3px)",
                color: "var(--ds-text-inverse, #FFFFFF)",
                font: "var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
                fontFamily: "var(--ds-font-family-body, \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
                insetBlockStart: "var(--ds-space-0, 0px)",
                insetInlineStart: "var(--ds-space-0, 0px)",
                overflowWrap: 'break-word',
                paddingBlockStart: "var(--ds-space-050, 4px)",
                paddingBlockEnd: "var(--ds-space-050, 4px)",
                paddingInlineEnd: "var(--ds-space-075, 6px)",
                paddingInlineStart: "var(--ds-space-075, 6px)",
                whiteSpace: 'normal'
            };
            try {
                // Flag-on (platform-dst-top-layer), positioning is async via a React root;
                // safe here as VanillaTooltip stays hidden until positioned.
                const tooltipInstance = new (0, $kjMQA.VanillaTooltip)(element, shortName, tooltipId, (0, $3y2s4.isExperimentEnabled)('platform_editor_use_vanilla_components') ? $794db571bf2c3ca3$var$EMOJI_TOOLTIP_CLASS_NAMES : $794db571bf2c3ca3$var$EMOJI_TOOLTIP_CLASS, // default timeout
                300, tooltipStyles);
                this.tooltipInstance = tooltipInstance;
                this.tooltipTarget = element;
                element.removeAttribute('title');
                element.dispatchEvent(new Event(event.type));
            } catch (error) {
                element.removeAttribute('popovertarget');
                element.removeAttribute('aria-describedby');
                $794db571bf2c3ca3$export$cadc6675ce598ba8.logError(error instanceof Error ? error : new Error(String(error)));
            }
        };
        const unbindMouseEnter = (0, $bAB3U.bind)(element, {
            type: 'mouseenter',
            listener: initTooltip,
            options: {
                once: true
            }
        });
        const unbindFocus = (0, $bAB3U.bind)(element, {
            type: 'focus',
            listener: initTooltip,
            options: {
                once: true
            }
        });
        this.destroyLazyTooltipListeners = ()=>{
            unbindMouseEnter();
            unbindFocus();
        };
    }
    renderFallback() {
        this.renderingFallback = true;
        this.cleanUpAndRenderCommonAttributes();
        let doc = (0, $c9wRy.getDocument)();
        if (!doc) // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        doc = document;
        const fallbackElement = doc.createElement('span');
        const { text: text, shortName: shortName } = this.node.attrs;
        // Custom emojis (fallback text is not a single standard Unicode emoji)
        // render the Unicode Replacement Character (U+FFFD) instead of the
        // shortName text. Standard emojis fall back to their Unicode text.
        const fallbackText = text || shortName;
        const renderedFallbackText = (0, $j7bkr.isSingleEmoji)(fallbackText) ? fallbackText : '\uFFFD';
        fallbackElement.innerText = renderedFallbackText;
        fallbackElement.setAttribute('role', 'img');
        fallbackElement.setAttribute('title', shortName);
        fallbackElement.setAttribute('aria-label', shortName);
        fallbackElement.setAttribute('data-testid', `fallback-emoji-${shortName}`);
        fallbackElement.setAttribute('data-emoji-type', 'fallback');
        this.dom.appendChild(fallbackElement);
        this.createTooltip(fallbackElement, shortName);
    }
    renderEmoji(description, representation) {
        this.renderingFallback = false;
        this.cleanUpAndRenderCommonAttributes();
        const emojiType = 'sprite' in representation ? 'sprite' : 'image';
        let doc = (0, $c9wRy.getDocument)();
        if (!doc) // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        doc = document;
        // Add wrapper for the emoji
        const containerElement = doc.createElement('span');
        containerElement.setAttribute('role', 'img');
        containerElement.setAttribute('title', description.shortName);
        containerElement.classList.add((0, $dZp9s.EmojiSharedCssClassName).EMOJI_CONTAINER);
        containerElement.setAttribute('data-testid', `${emojiType}-emoji-${description.shortName}`);
        containerElement.setAttribute('data-emoji-type', emojiType);
        containerElement.setAttribute('aria-label', `${this.intl.formatMessage((0, $gfs9q.messages).emojiNodeLabel)} ${description.shortName}`);
        const emojiElement = 'sprite' in representation ? this.createSpriteEmojiElement(representation) : this.createImageEmojiElement(description, representation);
        containerElement.appendChild(emojiElement);
        this.dom.appendChild(containerElement);
        this.createTooltip(containerElement, description.shortName);
    }
    createSpriteEmojiElement(representation) {
        let doc = (0, $c9wRy.getDocument)();
        if (!doc) // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        doc = document;
        const spriteElement = doc.createElement('span');
        spriteElement.classList.add((0, $dZp9s.EmojiSharedCssClassName).EMOJI_SPRITE);
        const sprite = representation.sprite;
        const xPositionInPercent = 100 / (sprite.column - 1) * representation.xIndex;
        const yPositionInPercent = 100 / (sprite.row - 1) * representation.yIndex;
        spriteElement.style.backgroundImage = `url(${sprite.url})`;
        spriteElement.style.backgroundPosition = `${xPositionInPercent}% ${yPositionInPercent}%`;
        spriteElement.style.backgroundSize = `${sprite.column * 100}% ${sprite.row * 100}%`;
        spriteElement.style.minWidth = `${0, $g3vc1.defaultEmojiHeight}px`;
        spriteElement.style.minHeight = `${0, $g3vc1.defaultEmojiHeight}px`;
        if (!(0, $5N1Y4.expValEquals)('platform_editor_lovability_emoji_scaling', 'isEnabled', true)) {
            spriteElement.style.width = `${0, $g3vc1.defaultEmojiHeight}px`;
            spriteElement.style.height = `${0, $g3vc1.defaultEmojiHeight}px`;
        }
        return spriteElement;
    }
    createImageEmojiElement(emojiDescription, representation) {
        let doc = (0, $c9wRy.getDocument)();
        if (!doc) // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
        doc = document;
        const imageElement = doc.createElement('img');
        imageElement.classList.add((0, $dZp9s.EmojiSharedCssClassName).EMOJI_IMAGE);
        imageElement.src = 'imagePath' in representation ? representation.imagePath : representation.mediaPath;
        imageElement.loading = 'lazy';
        imageElement.alt = emojiDescription.name || emojiDescription.shortName;
        imageElement.style.minWidth = `${0, $g3vc1.defaultEmojiHeight}px`;
        imageElement.style.objectFit = 'contain';
        imageElement.height = (0, $g3vc1.defaultEmojiHeight);
        imageElement.onerror = ()=>{
            // If there's an error (ie. offline) render the ascii fallback if possible, otherwise
            // mark the node to refresh when returning online.
            // Create a check that confirms if this.node.attrs.text if an ascii emoji
            if ((0, $j7bkr.isSingleEmoji)(this.node.attrs.text)) this.renderFallback();
            else this.renderingFallback = true;
        };
        return imageElement;
    }
}

});

parcelRegister("jRe2h", function(module, exports) {
$parcel$export(module.exports, "ACTIONS", () => $73639de019f78dc4$export$92a1a3b7554e9387);
$parcel$export(module.exports, "setAsciiMap", () => $73639de019f78dc4$export$5e8f481ab8296997);
$parcel$export(module.exports, "openTypeAhead", () => $73639de019f78dc4$export$adbec20dbbf15a6b);
$parcel$export(module.exports, "setProvider", () => $73639de019f78dc4$export$1572b3eade6662f9);
$parcel$export(module.exports, "setInlineEmojiPopupOpen", () => $73639de019f78dc4$export$f53f9c9a74ec859b);

var $8JT0u = parcelRequire("8JT0u");
const $73639de019f78dc4$export$92a1a3b7554e9387 = {
    SET_PROVIDER: 'SET_PROVIDER',
    SET_RESULTS: 'SET_RESULTS',
    SET_ASCII_MAP: 'SET_ASCII_MAP',
    SET_INLINE_POPUP: 'SET_INLINE_POPUP'
};
const $73639de019f78dc4$export$5e8f481ab8296997 = (asciiMap)=>(tr)=>{
        return tr.setMeta((0, $8JT0u.emojiPluginKey), {
            action: $73639de019f78dc4$export$92a1a3b7554e9387.SET_ASCII_MAP,
            params: {
                asciiMap: asciiMap
            }
        });
    };
const $73639de019f78dc4$export$adbec20dbbf15a6b = (typeaheadHandler, api)=>(inputMethod)=>{
        var _api$typeAhead;
        return Boolean(api === null || api === void 0 || (_api$typeAhead = api.typeAhead) === null || _api$typeAhead === void 0 ? void 0 : _api$typeAhead.actions.open({
            triggerHandler: typeaheadHandler,
            inputMethod: inputMethod
        }));
    };
const $73639de019f78dc4$export$1572b3eade6662f9 = (provider)=>(tr)=>{
        return tr.setMeta((0, $8JT0u.emojiPluginKey), {
            action: $73639de019f78dc4$export$92a1a3b7554e9387.SET_PROVIDER,
            params: {
                provider: provider
            }
        });
    };
const $73639de019f78dc4$export$f53f9c9a74ec859b = (open)=>(tr)=>tr.setMeta((0, $8JT0u.emojiPluginKey), {
            action: $73639de019f78dc4$export$92a1a3b7554e9387.SET_INLINE_POPUP,
            params: {
                open: open
            }
        });

});

parcelRegister("IL4BL", function(module, exports) {
$parcel$export(module.exports, "inputRulePlugin", () => $8a2935645a018326$export$568a7ed6897c4817);

var $g6Qq4 = parcelRequire("g6Qq4");

var $f7Kk4 = parcelRequire("f7Kk4");

var $33v8M = parcelRequire("33v8M");

var $b9BdF = parcelRequire("b9BdF");

var $8t09p = parcelRequire("8t09p");
let $8a2935645a018326$var$matcher;
function $8a2935645a018326$export$568a7ed6897c4817(schema, editorAnalyticsAPI, pluginInjectionApi, disableAutoformat) {
    if (disableAutoformat) return;
    if (schema.nodes.emoji) {
        $8a2935645a018326$var$initMatcher(pluginInjectionApi);
        const asciiEmojiRule = (0, $33v8M.createRule)($8a2935645a018326$var$AsciiEmojiMatcher.REGEX, $8a2935645a018326$var$inputRuleHandler(editorAnalyticsAPI));
        return new (0, $f7Kk4.SafePlugin)((0, $8t09p.createPlugin)('emoji', [
            asciiEmojiRule
        ]));
    }
    return;
}
function $8a2935645a018326$var$initMatcher(pluginInjectionApi) {
    pluginInjectionApi === null || pluginInjectionApi === void 0 || pluginInjectionApi.emoji.sharedState.onChange(({ nextSharedState: nextSharedState })=>{
        const emojiProvider = nextSharedState === null || nextSharedState === void 0 ? void 0 : nextSharedState.emojiProvider;
        if (emojiProvider) emojiProvider.getAsciiMap().then((map)=>{
            $8a2935645a018326$var$matcher = new $8a2935645a018326$var$RecordingAsciiEmojiMatcher(emojiProvider, map);
        });
    });
}
const $8a2935645a018326$var$inputRuleHandler = (editorAnalyticsAPI)=>(state, matchParts, start, end)=>{
        if (!$8a2935645a018326$var$matcher) return null;
        const match = $8a2935645a018326$var$matcher.match(matchParts);
        if (match) {
            const transactionCreator = new $8a2935645a018326$var$AsciiEmojiTransactionCreator(state, match, start, end, editorAnalyticsAPI);
            return transactionCreator.create();
        }
        return null;
    };
const $8a2935645a018326$var$REGEX_LEADING_CAPTURE_INDEX = 1;
const $8a2935645a018326$var$REGEX_EMOJI_LEADING_PARENTHESES = 2;
const $8a2935645a018326$var$REGEX_EMOJI_ASCII_CAPTURE_INDEX = 3;
const $8a2935645a018326$var$REGEX_TRAILING_CAPTURE_INDEX = 4;
const $8a2935645a018326$var$getLeadingString = (match, withParenthesis = true)=>match[$8a2935645a018326$var$REGEX_LEADING_CAPTURE_INDEX] + (withParenthesis ? match[$8a2935645a018326$var$REGEX_EMOJI_LEADING_PARENTHESES] : '');
const $8a2935645a018326$var$getLeadingStringWithoutParentheses = (match)=>$8a2935645a018326$var$getLeadingString(match, false);
const $8a2935645a018326$var$getAscii = (match, withParentheses = false)=>(withParentheses ? match[$8a2935645a018326$var$REGEX_EMOJI_LEADING_PARENTHESES] : '') + match[$8a2935645a018326$var$REGEX_EMOJI_ASCII_CAPTURE_INDEX].trim();
const $8a2935645a018326$var$getAsciiWithParentheses = (matchParts)=>$8a2935645a018326$var$getAscii(matchParts, true);
const $8a2935645a018326$var$getTrailingString = (match)=>match[$8a2935645a018326$var$REGEX_TRAILING_CAPTURE_INDEX] || '';
class $8a2935645a018326$var$AsciiEmojiMatcher {
    static #_ = /**
   * This regex matches 2 scenarios:
   * 1. an emoticon starting with a colon character (e.g. :D => 😃)
   * 2. an emoticon not starting with a colon character (e.g. 8-D => 😎)
   *
   * Explanation (${leafNodeReplacementCharacter} is replaced with character \ufffc)
   *
   *  1st Capturing Group ((?:^|[\s\ufffc])(?:\(*?))
   *    Non-capturing group (?:^|[\s\ufffc])
   *      1st Alternative ^
   *        ^ asserts position at start of the string
   *      2nd Alternative [\s\ufffc]
   *        matches a single character present in [\s\ufffc]
   *    Non-capturing group (?:\(*?)
   *      matches the character ( literally between zero and unlimited times, as few times as possible, expanding as needed (lazy)
   *  2nd Capturing Group (\(?)
   *    matches a single ( if present
   *  3rd Capturing Group ([^:\s\ufffc\(]\S{1,3}|:\S{1,3}( ))
   *    1st Alternative [^:\s\ufffc\(]\S{1,3}
   *      matches a single character not present in [^:\s\ufffc\(] between 1 and 3 times, as many times as possible, giving back as needed (greedy)
   *    2nd Alternative :\S{1,3}( )
   *      : matches the character : literally
   *      \S{1,3} matches any non-whitespace character between 1 and 3 times, as many times as possible, giving back as needed (greedy)
   *  4th Capturing Group ( )
   *
   * See https://regex101.com/r/HRS9O2/4
   */ // New behavior: All emoticons require whitespace after them
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    this.REGEX = new RegExp(`((?:^|[\\s${(0, $b9BdF.leafNodeReplacementCharacter)}])(?:\\(*?))(\\(?)([^:\\s${(0, $b9BdF.leafNodeReplacementCharacter)}\\(]\\S{1,3}|:\\S{1,3})([\\s\\t\\n])$`);
    constructor(asciiToEmojiMap){
        this.asciiToEmojiMap = asciiToEmojiMap;
    }
    match(matchParts) {
        return this.getAsciiEmojiMatch($8a2935645a018326$var$getLeadingStringWithoutParentheses(matchParts), $8a2935645a018326$var$getAsciiWithParentheses(matchParts), $8a2935645a018326$var$getTrailingString(matchParts)) || this.getAsciiEmojiMatch($8a2935645a018326$var$getLeadingString(matchParts), $8a2935645a018326$var$getAscii(matchParts), $8a2935645a018326$var$getTrailingString(matchParts));
    }
    getAsciiEmojiMatch(leading, ascii, trailing) {
        const emoji = this.asciiToEmojiMap.get(ascii);
        return emoji ? {
            emoji: emoji,
            leadingString: leading,
            trailingString: trailing
        } : undefined;
    }
}
/**
 * A matcher that will record ascii matches as usages of the matched emoji.
 */ class $8a2935645a018326$var$RecordingAsciiEmojiMatcher extends $8a2935645a018326$var$AsciiEmojiMatcher {
    constructor(emojiProvider, asciiToEmojiMap){
        super(asciiToEmojiMap);
        this.emojiProvider = emojiProvider;
    }
    match(matchParts) {
        const match = super.match(matchParts);
        if (match && this.emojiProvider.recordSelection) this.emojiProvider.recordSelection(match.emoji);
        return match;
    }
}
class $8a2935645a018326$var$AsciiEmojiTransactionCreator {
    constructor(state, match, start, end, editorAnalyticsAPI){
        this.state = state;
        this.match = match;
        this.start = start;
        this.end = end;
        this.editorAnalyticsAPI = editorAnalyticsAPI;
    }
    create() {
        var _this$editorAnalytics;
        const tr = this.state.tr.replaceWith(this.from, this.to, this.createNodes());
        (_this$editorAnalytics = this.editorAnalyticsAPI) === null || _this$editorAnalytics === void 0 || _this$editorAnalytics.attachAnalyticsEvent({
            action: (0, $g6Qq4.ACTION).INSERTED,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).DOCUMENT,
            actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).EMOJI,
            attributes: {
                inputMethod: (0, $g6Qq4.INPUT_METHOD).ASCII
            },
            eventType: (0, $g6Qq4.EVENT_TYPE).TRACK
        })(tr);
        return tr;
    }
    get from() {
        return this.start + this.match.leadingString.length;
    }
    get to() {
        return this.end;
    }
    createNodes() {
        const nodes = [
            this.createEmojiNode()
        ];
        if (this.trailingTextNodeRequired()) nodes.push(this.createTrailingTextNode());
        return nodes;
    }
    createEmojiNode() {
        const { emoji: emojiTypeNode } = this.state.schema.nodes;
        return emojiTypeNode.create(this.getEmojiNodeAttrs());
    }
    getEmojiNodeAttrs() {
        const emoji = this.match.emoji;
        return {
            id: emoji.id,
            shortName: emoji.shortName,
            text: emoji.fallback || emoji.shortName
        };
    }
    trailingTextNodeRequired() {
        return this.match.trailingString.length > 0;
    }
    createTrailingTextNode() {
        return this.state.schema.text(this.match.trailingString);
    }
}
const $8a2935645a018326$var$plugins = (schema, providerFactory, featureFlags, editorAnalyticsAPI, pluginInjectionApi)=>{
    return [
        $8a2935645a018326$export$568a7ed6897c4817(schema, editorAnalyticsAPI, pluginInjectionApi)
    ].filter((plugin)=>!!plugin);
};
var $8a2935645a018326$export$2e2bcd8739ae039 = $8a2935645a018326$var$plugins;

});
parcelRegister("b9BdF", function(module, exports) {
$parcel$export(module.exports, "leafNodeReplacementCharacter", () => $2a3c8141d034a94a$export$a96b909f1510512b);
$parcel$export(module.exports, "TEXT_INPUT_RULE_TRANSACTION_KEY", () => $2a3c8141d034a94a$export$e56dc8305776db1f);
$parcel$export(module.exports, "MAX_REGEX_MATCH", () => $2a3c8141d034a94a$export$af78bb669dec9658);
$parcel$export(module.exports, "TYPEAHEAD_TRIGGERS", () => $2a3c8141d034a94a$export$3082ca29ad268435);
// ProseMirror uses the Unicode Character 'OBJECT REPLACEMENT CHARACTER' (U+FFFC) as text representation for
// leaf nodes, i.e. nodes that don't have any content or text property (e.g. hardBreak, emoji, mention, rule)
// It was introduced because of https://github.com/ProseMirror/prosemirror/issues/262
// This can be used in an input rule regex to be able to include or exclude such nodes.
const $2a3c8141d034a94a$export$a96b909f1510512b = '\ufffc';
const $2a3c8141d034a94a$export$e56dc8305776db1f = 'input_rule_plugin_transaction';
const $2a3c8141d034a94a$export$af78bb669dec9658 = 500;
const $2a3c8141d034a94a$export$3082ca29ad268435 = [
    ':',
    '/',
    '@'
];

});

parcelRegister("8t09p", function(module, exports) {
$parcel$export(module.exports, "createPlugin", () => $b510bd88c3ab1f98$export$ae829ec7b2625219);

var $cw0wu = parcelRequire("cw0wu");

var $kQkyj = parcelRequire("kQkyj");

var $43tx6 = parcelRequire("43tx6");

var $2GZTs = parcelRequire("2GZTs");
const $b510bd88c3ab1f98$var$hasUnsupportedMarks = (state, start, end, marksNameUnsupported)=>{
    const isUnsupportedMark = (node)=>(marksNameUnsupported || []).includes(node.type.name);
    const $from = state.doc.resolve(start);
    const $to = state.doc.resolve(end);
    const marksInSelection = start === end ? $from.marks() : $from.marksAcross($to);
    return (marksInSelection || []).some(isUnsupportedMark);
};
const $b510bd88c3ab1f98$var$isCursorInsideUnsupportedMarks = (state, marksNameUnsupported)=>{
    var _$cursor$nodeBefore;
    const { selection: selection } = state;
    if (!(selection instanceof (0, $cw0wu.TextSelection))) return false;
    const { $cursor: $cursor } = selection;
    const isUnsupportedMark = (node)=>marksNameUnsupported.includes(node.type.name);
    return Boolean($cursor === null || $cursor === void 0 || (_$cursor$nodeBefore = $cursor.nodeBefore) === null || _$cursor$nodeBefore === void 0 || (_$cursor$nodeBefore = _$cursor$nodeBefore.marks) === null || _$cursor$nodeBefore === void 0 ? void 0 : _$cursor$nodeBefore.some(isUnsupportedMark));
};
const $b510bd88c3ab1f98$export$ae829ec7b2625219 = (pluginName, rules, options = {})=>{
    const { isBlockNodeRule: isBlockNodeRule = false, allowInsertTextOnDocument: allowInsertTextOnDocument = true, checkOnBlur: checkOnBlur, appendTextOnBlur: appendTextOnBlur } = options;
    const onInputEvent = ({ state: state, from: from, to: to })=>{
        const unsupportedMarks = isBlockNodeRule ? [
            'code',
            'link',
            'typeAheadQuery'
        ] : [
            'code'
        ];
        const $from = state.selection.$from;
        const isInline = state.selection instanceof (0, $cw0wu.NodeSelection) && state.selection.node.type.isInline;
        if ($from.parent.type.spec.code || !(state.selection instanceof (0, $cw0wu.TextSelection)) && !(0, $43tx6.isGapCursorSelection)(state.selection) && !isInline || $b510bd88c3ab1f98$var$hasUnsupportedMarks(state, from, to, unsupportedMarks) || isBlockNodeRule && $b510bd88c3ab1f98$var$isCursorInsideUnsupportedMarks(state, unsupportedMarks)) return false;
        return true;
    };
    return (0, $2GZTs.createInputRulePlugin)(pluginName, rules, {
        allowInsertTextOnDocument: allowInsertTextOnDocument,
        onInputEvent: onInputEvent,
        onBeforeRegexMatch: (tr)=>{
            (0, $kQkyj.closeHistory)(tr);
        },
        checkOnBlur: checkOnBlur,
        appendTextOnBlur: appendTextOnBlur
    });
};

});
parcelRegister("43tx6", function(module, exports) {
$parcel$export(module.exports, "isGapCursorSelection", () => $f4f8efd5e78f95a9$export$b0e17cd4423f50ca);
/**
 * This file is to duplicate types that exist in editor-common
 * so that input-rules does not depend on it.
 *
 * This simplifies our dependencies and makes adoption much easier.
 */ const $f4f8efd5e78f95a9$export$b0e17cd4423f50ca = (selection)=>{
    // @ts-expect-error
    return Boolean(selection.jsonID === 'gapcursor');
};

});

parcelRegister("2GZTs", function(module, exports) {
$parcel$export(module.exports, "createInputRulePlugin", () => $79fe6e20ba4afebe$export$dc83f374e2af640d);

var $cw0wu = parcelRequire("cw0wu");

var $5N1Y4 = parcelRequire("5N1Y4");

var $b9BdF = parcelRequire("b9BdF");

var $lMkdp = parcelRequire("lMkdp");
function $79fe6e20ba4afebe$export$dc83f374e2af640d(pluginName, rules, options = {}) {
    const onInputEvent = options === null || options === void 0 ? void 0 : options.onInputEvent;
    const onBeforeRegexMatch = options === null || options === void 0 ? void 0 : options.onBeforeRegexMatch;
    const allowInsertTextOnDocument = Boolean(options === null || options === void 0 ? void 0 : options.allowInsertTextOnDocument);
    const pluginKey = new (0, $cw0wu.PluginKey)(`inputRulePlugin__${pluginName}`);
    const inputEvent = (0, $lMkdp.createInputEventHandler)({
        allowInsertTextOnDocument: allowInsertTextOnDocument,
        pluginKey: pluginKey,
        rules: rules,
        onInputEvent: onInputEvent,
        onBeforeRegexMatch: onBeforeRegexMatch
    });
    return {
        key: pluginKey,
        state: {
            init () {
                return null;
            },
            apply (tr, prev) {
                const stored = tr.getMeta(pluginKey);
                if (stored) return stored;
                return tr.selectionSet || tr.docChanged ? null : prev;
            }
        },
        appendTransaction: (transactions, oldState, newState)=>{
            const transactionWithInputRuleMeta = transactions.find((tr)=>tr.getMeta(pluginKey));
            const pluginState = transactionWithInputRuleMeta === null || transactionWithInputRuleMeta === void 0 ? void 0 : transactionWithInputRuleMeta.getMeta(pluginKey);
            if (!pluginState || !transactionWithInputRuleMeta) return null;
            const { matchedRule: matchedRule, from: from, to: to, isBackwardMatch: isBackwardMatch } = pluginState;
            const { result: result } = matchedRule;
            const mappedTo = transactionWithInputRuleMeta.mapping.map(to);
            const tr = matchedRule.handler(newState, result, from, mappedTo);
            if (!tr) return null;
            tr.setMeta((0, $b9BdF.TEXT_INPUT_RULE_TRANSACTION_KEY), true);
            if (matchedRule.onHandlerApply) matchedRule.onHandlerApply(newState, tr, matchedRule.result);
            // after inserting inline code, we need to reset the selection back
            // else, we set the selection at the end of the inline code which doesn't make sense if we are closing the inline code from R to L
            if (isBackwardMatch && (0, $5N1Y4.expValEquals)('platform_editor_lovability_inline_code', 'isEnabled', true)) {
                const prevSelection = oldState.selection.map(tr.doc, tr.mapping);
                tr.setSelection(new (0, $cw0wu.TextSelection)(prevSelection.$from));
            }
            return tr;
        },
        props: {
            handleTextInput (view, from, to, text) {
                return inputEvent({
                    view: view,
                    from: from,
                    to: to,
                    text: text
                });
            },
            handleDOMEvents: {
                blur: (view)=>{
                    if (!(options !== null && options !== void 0 && options.checkOnBlur)) return false;
                    const selection = view.state.selection;
                    if (!(selection instanceof (0, $cw0wu.TextSelection))) return;
                    const { $cursor: $cursor } = selection;
                    if ($cursor) inputEvent({
                        view: view,
                        from: $cursor.pos,
                        to: $cursor.pos,
                        text: options.appendTextOnBlur ?? ''
                    });
                    return false;
                },
                compositionend: (view)=>{
                    setTimeout(()=>{
                        const selection = view.state.selection;
                        if (!(selection instanceof (0, $cw0wu.TextSelection))) return;
                        const { $cursor: $cursor } = selection;
                        if ($cursor) inputEvent({
                            view: view,
                            from: $cursor.pos,
                            to: $cursor.pos,
                            text: ''
                        });
                    });
                    return false;
                }
            }
        },
        // However, there is no typing ffor this, yet.
        isInputRules: true
    };
}

});
parcelRegister("lMkdp", function(module, exports) {
$parcel$export(module.exports, "createInputEventHandler", () => $918cf5e7375e0292$export$9bcba4b183c6bb83);

var $5N1Y4 = parcelRequire("5N1Y4");

var $b9BdF = parcelRequire("b9BdF");

var $43tx6 = parcelRequire("43tx6");
const $918cf5e7375e0292$export$9bcba4b183c6bb83 = ({ rules: rules, pluginKey: pluginKey, allowInsertTextOnDocument: allowInsertTextOnDocument, onInputEvent: onInputEvent, onBeforeRegexMatch: onBeforeRegexMatch })=>({ view: view, from: from, to: to, text: text })=>{
        if (view.composing) return false;
        const state = view.state;
        const $from = state.doc.resolve(from);
        if ($from.parent.type.spec.code) return false;
        if (onInputEvent && !onInputEvent({
            state: state,
            from: from,
            to: to
        })) return false;
        const textBefore = $from.parent.textBetween(Math.max(0, $from.parentOffset - (0, $b9BdF.MAX_REGEX_MATCH)), $from.parentOffset, undefined, (0, $b9BdF.leafNodeReplacementCharacter)) + text;
        let result = $918cf5e7375e0292$var$findMatchOnRules({
            rules: rules,
            textToMatch: textBefore,
            from: from,
            to: to,
            state: state
        });
        let isBackwardMatch;
        if (!result && (0, $5N1Y4.expValEquals)('platform_editor_lovability_inline_code', 'isEnabled', true)) {
            if ((0, $b9BdF.TYPEAHEAD_TRIGGERS).includes(text)) return false;
            const textAfter = text + $from.parent.textBetween($from.parentOffset, Math.min($from.parent.content.size, $from.parentOffset + (0, $b9BdF.MAX_REGEX_MATCH)), undefined, (0, $b9BdF.leafNodeReplacementCharacter));
            isBackwardMatch = true;
            const backwardMatchRules = rules.filter((rule)=>rule.allowsBackwardMatch);
            result = $918cf5e7375e0292$var$findMatchOnRules({
                rules: backwardMatchRules,
                textToMatch: textAfter,
                from: from,
                to: to,
                state: state,
                isBackwardMatch: isBackwardMatch
            });
            if (!result) return false;
        }
        if (!result) return false;
        const tr = allowInsertTextOnDocument ? state.tr.insertText(text, from, to) : state.tr;
        tr.setMeta((0, $b9BdF.TEXT_INPUT_RULE_TRANSACTION_KEY), true);
        tr.setMeta(pluginKey, {
            textInserted: text,
            from: result.from,
            to: result.to,
            matchedRule: result.matchedRule,
            isBackwardMatch: isBackwardMatch
        });
        if (onBeforeRegexMatch) onBeforeRegexMatch(tr);
        view.dispatch(tr);
        return true;
    };
function $918cf5e7375e0292$var$findMatchOnRules({ rules: rules, textToMatch: textToMatch, from: from, to: to, state: state, isBackwardMatch: isBackwardMatch }) {
    for(let i = 0; i < rules.length; i++){
        const rule = rules[i];
        // Some plugins like Typeahead require a whitespace before a trigger character.
        // We want them to fire inside a gap cursor. Yet, a gap cursor is not considered a whitespace,
        // and `textToMatch` contains the text in the previous block before the gap cursor.
        // Here is a workaround: if we inside a gap cursor, match the input rule only against the last typed character
        // (which may be a typeahead trigger) and ignore the rest.
        const matchString = (0, $43tx6.isGapCursorSelection)(state.selection) ? textToMatch.at(-1) ?? '' : textToMatch;
        // if the user is formatting text to inline code from R to L i.e. backwards
        if (rule.allowsBackwardMatch && isBackwardMatch && (0, $5N1Y4.expValEquals)('platform_editor_lovability_inline_code', 'isEnabled', true)) {
            // if the match has a parenthesis before it, but no whitespace or empty space before that, exit
            const charBefore = state.doc.textBetween(from - 1, from);
            if (charBefore === '(') {
                const charBeforeParenthesis = state.doc.textBetween(from - 2, from - 1);
                if (charBeforeParenthesis !== ' ' && charBeforeParenthesis !== '') continue;
            } else if (charBefore !== ' ' && charBefore !== '') continue;
            const match = rule.match.exec(matchString);
            if (!match) continue;
            const matchEndPos = from + match[0].length - 1;
            const transform = rule.handler(state, match, from, matchEndPos);
            if (transform) return {
                from: from,
                to: matchEndPos,
                matchedRule: {
                    ...rule,
                    result: match
                }
            };
            return null;
        }
        const match = rule.match.exec(matchString);
        if (!match) continue;
        const parentNodeStartAt = state.selection.$from.start();
        const offset = Math.max(0, state.selection.$from.parentOffset - (0, $b9BdF.MAX_REGEX_MATCH));
        const fromFixed = Math.max(parentNodeStartAt + match.index + offset, 1);
        const transform = rule.handler(state, match, fromFixed, to);
        if (transform) return {
            from: fromFixed,
            to: to,
            matchedRule: {
                ...rule,
                result: match
            }
        };
    }
    return null;
}

});




parcelRegister("zBWY4", function(module, exports) {
$parcel$export(module.exports, "InlineEmojiPopup", () => $fa8f7144936bc5ec$export$295b54f3ba0abfa5);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $g6Qq4 = parcelRequire("g6Qq4");

var $jn0n9 = parcelRequire("jn0n9");

var $5zk80 = parcelRequire("5zk80");

var $3Aq92 = parcelRequire("3Aq92");

var $cf2n1 = parcelRequire("cf2n1");

var $9x1C7 = parcelRequire("9x1C7");

var $2pWL6 = parcelRequire("2pWL6");

var $5bbjm = parcelRequire("5bbjm");

var $asaws = parcelRequire("asaws");

var $gdUUy = parcelRequire("gdUUy");

var $jRe2h = parcelRequire("jRe2h");
const $fa8f7144936bc5ec$var$PopupWithListeners = (0, $cf2n1.default)((0, $5zk80.default));
const $fa8f7144936bc5ec$var$emojiPopupMessages = {
    emojiPickerAriaLabel: {
        id: 'fabric.emoji.picker.aria.label',
        defaultMessage: 'Emoji picker',
        description: 'Accessible label for the emoji picker popup'
    }
};
const $fa8f7144936bc5ec$export$b7ec9ebb3bbf8534 = ({ api: api, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, editorView: editorView, contentId: contentId, onClose: onClose })=>{
    var _useSharedPluginState, _api$analytics;
    const { emojiProvider: emojiProvider, inlineEmojiPopupOpen: isOpen } = ((_useSharedPluginState = (0, $9x1C7.useSharedPluginState)(api, [
        'emoji'
    ])) === null || _useSharedPluginState === void 0 ? void 0 : _useSharedPluginState.emojiState) ?? {};
    const intl = (0, $4vLTk.default)();
    (0, $bSJIT.useEffect)(()=>{
        if (isOpen && (0, $gdUUy.fg)('platform_editor_ease_of_use_metrics')) {
            var _api$metrics;
            api === null || api === void 0 || api.core.actions.execute(api === null || api === void 0 || (_api$metrics = api.metrics) === null || _api$metrics === void 0 ? void 0 : _api$metrics.commands.handleIntentToStartEdit({
                shouldStartTimer: false,
                shouldPersistActiveSession: true
            }));
        }
    }, [
        isOpen,
        api
    ]);
    const handleOnClose = (0, $bSJIT.useCallback)(()=>{
        if ((0, $gdUUy.fg)('platform_editor_ease_of_use_metrics')) {
            var _api$metrics2;
            api === null || api === void 0 || api.core.actions.execute(api === null || api === void 0 || (_api$metrics2 = api.metrics) === null || _api$metrics2 === void 0 ? void 0 : _api$metrics2.commands.startActiveSessionTimer());
        }
        onClose === null || onClose === void 0 || onClose();
    }, [
        onClose,
        api
    ]);
    const focusEditor = (0, $bSJIT.useCallback)(()=>{
        // use requestAnimationFrame to run this async after the call
        requestAnimationFrame(()=>editorView.focus());
    }, [
        editorView
    ]);
    const handleSelection = (0, $bSJIT.useCallback)((emojiId)=>{
        api.core.actions.execute(api.emoji.commands.insertEmoji(emojiId, (0, $g6Qq4.INPUT_METHOD).PICKER));
        handleOnClose();
    }, [
        api.core.actions,
        api.emoji.commands,
        handleOnClose
    ]);
    if (!isOpen || !emojiProvider) return null;
    const domRef = (0, $jn0n9.getDomRefFromSelection)(editorView, (0, $g6Qq4.ACTION_SUBJECT_ID).PICKER_EMOJI, api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions);
    return /*#__PURE__*/ (0, $dc70d.jsx)($fa8f7144936bc5ec$var$PopupWithListeners, {
        ariaLabel: intl.formatMessage($fa8f7144936bc5ec$var$emojiPopupMessages.emojiPickerAriaLabel),
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        offset: [
            0,
            12
        ],
        mountTo: popupsMountPoint,
        boundariesElement: popupsBoundariesElement,
        scrollableElement: popupsScrollableElement,
        zIndex: (0, $5bbjm.akEditorFloatingDialogZIndex),
        fitHeight: 350,
        fitWidth: 350,
        target: domRef,
        onUnmount: focusEditor,
        focusTrap: true,
        preventOverflow: true,
        handleClickOutside: handleOnClose,
        handleEscapeKeydown: handleOnClose,
        captureClick: true,
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $3Aq92.OutsideClickTargetRefContext).Consumer, {
            children: (setOutsideClickTargetRef)=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $asaws.EmojiPicker), {
                    contentId: contentId,
                    emojiProvider: Promise.resolve(emojiProvider),
                    onPickerRef: setOutsideClickTargetRef,
                    onSelection: handleSelection
                })
        })
    });
};
const $fa8f7144936bc5ec$var$InlineEmojiPopupContent = ({ api: api, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, editorView: editorView, contentId: contentId })=>{
    var _api$metrics4, _api$metrics6, _api$analytics3;
    const emojiProvider = (0, $2pWL6.useSharedPluginStateSelector)(api, 'emoji.emojiProvider');
    const intl = (0, $4vLTk.default)();
    (0, $bSJIT.useEffect)(()=>{
        if ((0, $gdUUy.fg)('platform_editor_ease_of_use_metrics')) {
            var _api$metrics3;
            api === null || api === void 0 || api.core.actions.execute(api === null || api === void 0 || (_api$metrics3 = api.metrics) === null || _api$metrics3 === void 0 ? void 0 : _api$metrics3.commands.handleIntentToStartEdit({
                shouldStartTimer: false,
                shouldPersistActiveSession: true
            }));
        }
    }, [
        api === null || api === void 0 ? void 0 : api.core.actions,
        api === null || api === void 0 || (_api$metrics4 = api.metrics) === null || _api$metrics4 === void 0 ? void 0 : _api$metrics4.commands
    ]);
    const handleOnClose = (0, $bSJIT.useCallback)(()=>{
        editorView.dispatch((0, $jRe2h.setInlineEmojiPopupOpen)(false)(editorView.state.tr));
        if ((0, $gdUUy.fg)('platform_editor_ease_of_use_metrics')) {
            var _api$metrics5;
            api === null || api === void 0 || api.core.actions.execute(api === null || api === void 0 || (_api$metrics5 = api.metrics) === null || _api$metrics5 === void 0 ? void 0 : _api$metrics5.commands.startActiveSessionTimer());
        }
    }, [
        editorView,
        api.core.actions,
        (_api$metrics6 = api.metrics) === null || _api$metrics6 === void 0 ? void 0 : _api$metrics6.commands
    ]);
    const focusEditor = (0, $bSJIT.useCallback)(()=>{
        // use requestAnimationFrame to run this async after the call
        requestAnimationFrame(()=>editorView.focus());
    }, [
        editorView
    ]);
    const handleSelection = (0, $bSJIT.useCallback)((emojiId)=>{
        api.core.actions.execute(api.emoji.commands.insertEmoji(emojiId, (0, $g6Qq4.INPUT_METHOD).PICKER));
        handleOnClose();
    }, [
        api.core.actions,
        api.emoji.commands,
        handleOnClose
    ]);
    const domRef = (0, $bSJIT.useMemo)(()=>{
        var _api$analytics2;
        return (0, $jn0n9.getDomRefFromSelection)(editorView, (0, $g6Qq4.ACTION_SUBJECT_ID).PICKER_EMOJI, api === null || api === void 0 || (_api$analytics2 = api.analytics) === null || _api$analytics2 === void 0 ? void 0 : _api$analytics2.actions);
    }, [
        editorView,
        api === null || api === void 0 || (_api$analytics3 = api.analytics) === null || _api$analytics3 === void 0 ? void 0 : _api$analytics3.actions
    ]);
    if (!emojiProvider) return null;
    return /*#__PURE__*/ (0, $dc70d.jsx)($fa8f7144936bc5ec$var$PopupWithListeners, {
        ariaLabel: intl.formatMessage($fa8f7144936bc5ec$var$emojiPopupMessages.emojiPickerAriaLabel),
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        offset: [
            0,
            12
        ],
        mountTo: popupsMountPoint,
        boundariesElement: popupsBoundariesElement,
        scrollableElement: popupsScrollableElement,
        zIndex: (0, $5bbjm.akEditorFloatingDialogZIndex),
        fitHeight: 350,
        fitWidth: 350,
        target: domRef,
        onUnmount: focusEditor,
        focusTrap: true,
        preventOverflow: true,
        handleClickOutside: handleOnClose,
        handleEscapeKeydown: handleOnClose,
        captureClick: true,
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $3Aq92.OutsideClickTargetRefContext).Consumer, {
            children: (setOutsideClickTargetRef)=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $asaws.EmojiPicker), {
                    contentId: contentId,
                    emojiProvider: Promise.resolve(emojiProvider),
                    onPickerRef: setOutsideClickTargetRef,
                    onSelection: handleSelection
                })
        })
    });
};
const $fa8f7144936bc5ec$export$295b54f3ba0abfa5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).memo(({ api: api, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, editorView: editorView, contentId: contentId })=>{
    const isOpen = (0, $2pWL6.useSharedPluginStateSelector)(api, 'emoji.inlineEmojiPopupOpen');
    if (!isOpen) return null;
    return /*#__PURE__*/ (0, $dc70d.jsx)($fa8f7144936bc5ec$var$InlineEmojiPopupContent, {
        api: api,
        editorView: editorView,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsMountPoint: popupsMountPoint,
        popupsScrollableElement: popupsScrollableElement,
        contentId: contentId
    });
});

});
parcelRegister("jn0n9", function(module, exports) {
$parcel$export(module.exports, "getDomRefFromSelection", () => $39f84f4097fa4392$export$49d74ed2464a12b9);

var $gab48 = parcelRequire("gab48");

var $g6Qq4 = parcelRequire("g6Qq4");
const $39f84f4097fa4392$export$49d74ed2464a12b9 = (view, actionSubjectId, editorAnalyticsAPI)=>{
    try {
        const domRef = (0, $gab48.findDomRefAtPos)(view.state.selection.from, view.domAtPos.bind(view));
        if (domRef instanceof HTMLElement) {
            // If element is not a paragraph, we need to find the closest paragraph parent
            if (domRef.nodeName !== 'P') {
                const paragraphRef = domRef.closest('p');
                if (paragraphRef) return paragraphRef;
            }
            return domRef;
        } else throw new Error('Invalid DOM reference');
    } catch (error) {
        if (editorAnalyticsAPI) {
            const payload = {
                action: (0, $g6Qq4.ACTION).ERRORED,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).PICKER,
                actionSubjectId: actionSubjectId,
                eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    error: 'Error getting DOM reference from selection'
                }
            };
            editorAnalyticsAPI.fireAnalyticsEvent(payload);
        }
    }
};

});

parcelRegister("asaws", function(module, exports) {
$parcel$export(module.exports, "EmojiPicker", () => $8a38ced7c0a667d2$export$6335145236247192);
$parcel$export(module.exports, "default", () => $8a38ced7c0a667d2$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("bSJIT");

var $kIbto = parcelRequire("kIbto");

var $9UZnQ = parcelRequire("9UZnQ");



const $8a38ced7c0a667d2$export$6335145236247192 = (0, $kIbto.default)()((0, $9UZnQ.EmojiPickerInternal));
var $8a38ced7c0a667d2$export$2e2bcd8739ae039 = $8a38ced7c0a667d2$export$6335145236247192;

});


parcelRegister("2ymsV", function(module, exports) {
$parcel$export(module.exports, "getEmojiQuickInsertComponents", () => $31038dd182af31e4$export$cff8c6d3484f6a4c);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $cW1gB = parcelRequire("cW1gB");

var $b8Hvx = parcelRequire("b8Hvx");

var $9woaI = parcelRequire("9woaI");

var $am2Qg = parcelRequire("am2Qg");

var $qZGne = parcelRequire("qZGne");
const $31038dd182af31e4$export$cff8c6d3484f6a4c = ({ selectEmojiFromQuickInsert: selectEmojiFromQuickInsert })=>[
        {
            key: (0, $9woaI.EMOJI_MENU_ITEM).key,
            type: (0, $9woaI.EMOJI_MENU_ITEM).type,
            parents: [
                {
                    key: (0, $9woaI.MEDIA_SECTION).key,
                    type: (0, $9woaI.MEDIA_SECTION).type,
                    rank: (0, $am2Qg.MEDIA_SECTION_RANK)[(0, $9woaI.EMOJI_MENU_ITEM).key]
                }
            ],
            match: (0, $b8Hvx.createQuickInsertMatcher)(({ formatMessage: formatMessage })=>({
                    description: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).emojiDescription),
                    shortcut: ':',
                    title: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).emoji)
                })),
            component: ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $qZGne.EmojiQuickInsertMenuItem), {
                    selectEmojiFromQuickInsert: selectEmojiFromQuickInsert
                })
        }
    ];

});
parcelRegister("qZGne", function(module, exports) {
$parcel$export(module.exports, "EmojiQuickInsertMenuItem", () => $84b2c233347713e1$export$436810d83faf90ed);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $cW1gB = parcelRequire("cW1gB");

var $fT9mF = parcelRequire("fT9mF");

var $64eKJ = parcelRequire("64eKJ");

var $9YTEJ = parcelRequire("9YTEJ");
const $84b2c233347713e1$var$previewImageUrls = {
    dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVH4.png',
    light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVKH.png'
};
const $84b2c233347713e1$export$436810d83faf90ed = ({ selectEmojiFromQuickInsert: selectEmojiFromQuickInsert })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const preview = (0, $bSJIT.useMemo)(()=>({
            image: $84b2c233347713e1$var$previewImageUrls,
            attribution: {
                name: formatMessage((0, $64eKJ.messages).previewAttributionAtlassian)
            }
        }), [
        formatMessage
    ]);
    const onSelect = (0, $bSJIT.useCallback)(({ insert: insert })=>selectEmojiFromQuickInsert(insert), [
        selectEmojiFromQuickInsert
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $fT9mF.QuickInsertMenuItem), {
        description: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).emojiDescription),
        iconBefore: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9YTEJ))), {
            label: ""
        }),
        onSelect: onSelect,
        preview: preview,
        shortcut: ":",
        title: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).emoji)
    });
};

});



parcelRegister("30Yan", function(module, exports) {
$parcel$export(module.exports, "TRANSFORM_MENU_SECTION", () => $beba5a8176031fd0$export$a3c0fcb7531fdfae);
$parcel$export(module.exports, "TRANSFORM_MENU_ITEM", () => $beba5a8176031fd0$export$3ca3ae97eef4f3f0);
$parcel$export(module.exports, "TRANSFORM_CREATE_MENU_SECTION", () => $beba5a8176031fd0$export$34447db936e8c6fc);
$parcel$export(module.exports, "TRANSFORM_TEXTFORMATTING_MENU_SECTION", () => $beba5a8176031fd0$export$e1a8ae26a2a31202);
$parcel$export(module.exports, "TRANSFORM_HEADINGS_H1_MENU_ITEM", () => $beba5a8176031fd0$export$80e640e763379a61);
$parcel$export(module.exports, "TRANSFORM_HEADINGS_H2_MENU_ITEM", () => $beba5a8176031fd0$export$d31447f17d5c40f8);
$parcel$export(module.exports, "TRANSFORM_HEADINGS_H3_MENU_ITEM", () => $beba5a8176031fd0$export$2d9132330244bad7);
$parcel$export(module.exports, "TRANSFORM_HEADINGS_H4_MENU_ITEM", () => $beba5a8176031fd0$export$b5bbd55812f553dd);
$parcel$export(module.exports, "TRANSFORM_HEADINGS_H5_MENU_ITEM", () => $beba5a8176031fd0$export$33814ca575ac386);
$parcel$export(module.exports, "TRANSFORM_HEADINGS_H6_MENU_ITEM", () => $beba5a8176031fd0$export$a8ceacf53925c4c2);
$parcel$export(module.exports, "TRANSFORM_SUGGESTED_MENU_SECTION", () => $beba5a8176031fd0$export$bbc46da54e477efa);
$parcel$export(module.exports, "TRANSFORM_STRUCTURE_MENU_SECTION", () => $beba5a8176031fd0$export$c2d6d85aaa7f89);
$parcel$export(module.exports, "TRANSFORM_SUGGESTED_MENU_ITEM", () => $beba5a8176031fd0$export$d816a8e427c44cab);
$parcel$export(module.exports, "TRANSFORM_STRUCTURE_BULLETED_LIST_MENU_ITEM", () => $beba5a8176031fd0$export$e99d73a096eba9d8);
$parcel$export(module.exports, "TRANSFORM_STRUCTURE_TASK_LIST_MENU_ITEM", () => $beba5a8176031fd0$export$4f5251553e2c0d3b);
$parcel$export(module.exports, "TRANSFORM_STRUCTURE_NUMBERED_LIST_MENU_ITEM", () => $beba5a8176031fd0$export$320d169c65770531);
$parcel$export(module.exports, "TRANSFORM_STRUCTURE_CODE_BLOCK_MENU_ITEM", () => $beba5a8176031fd0$export$5bbaff6e2e9a6ff0);
$parcel$export(module.exports, "TRANSFORM_STRUCTURE_PANEL_MENU_ITEM", () => $beba5a8176031fd0$export$3017e11a8c1f80da);
$parcel$export(module.exports, "TRANSFORM_STRUCTURE_EXPAND_MENU_ITEM", () => $beba5a8176031fd0$export$6177b4b3a7cfe84a);
$parcel$export(module.exports, "TRANSFORM_STRUCTURE_LAYOUT_MENU_ITEM", () => $beba5a8176031fd0$export$63f059e253c26b26);
$parcel$export(module.exports, "TRANSFORM_STRUCTURE_QUOTE_MENU_ITEM", () => $beba5a8176031fd0$export$f2570dad43233f20);
$parcel$export(module.exports, "TRANSFORM_STRUCTURE_EXTENSION_SLOT_MENU_ITEM", () => $beba5a8176031fd0$export$627960d6631b7765);
$parcel$export(module.exports, "TRANSFORM_STRUCTURE_DECISION_MENU_ITEM", () => $beba5a8176031fd0$export$6f504bddd3dd2224);
$parcel$export(module.exports, "TRANSFORM_STRUCTURE_STATUS_MENU_ITEM", () => $beba5a8176031fd0$export$6e0886e3a8476d88);
$parcel$export(module.exports, "TRANSFORM_STRUCTURE_PARAGRAPH_MENU_ITEM", () => $beba5a8176031fd0$export$cc2e3e5d65e6f0d4);
$parcel$export(module.exports, "TRANSFORM_TEXT_FORMATTING_SMALL_TEXT_MENU_ITEM", () => $beba5a8176031fd0$export$35c0153bfbe9bc5);
$parcel$export(module.exports, "TRANSFORM_CLEAR_MENU_SECTION", () => $beba5a8176031fd0$export$a23188d593dca4ea);
$parcel$export(module.exports, "TRANSFORM_CLEAR_MENU_ITEM", () => $beba5a8176031fd0$export$745da57990b04239);
$parcel$export(module.exports, "TRANSFORM_DEFAULT_EXTENSION_SLOT_MENU_ITEM", () => $beba5a8176031fd0$export$a3f6bf14b5ca64b8);
$parcel$export(module.exports, "BLOCK_ACTIONS_FEATURED_EXTENSION_SLOT_MENU_ITEM", () => $beba5a8176031fd0$export$c1df15c59989a309);
$parcel$export(module.exports, "BLOCK_ACTIONS_TEMPLATE_SECTION", () => $beba5a8176031fd0$export$3867fe0cfddbf139);
$parcel$export(module.exports, "BLOCK_ACTIONS_MENU_SECTION", () => $beba5a8176031fd0$export$ac3b29d06d42b0ea);
$parcel$export(module.exports, "BLOCK_ACTIONS_CREATE_SYNCED_BLOCK_MENU_ITEM", () => $beba5a8176031fd0$export$cfe82275ae8140a2);
$parcel$export(module.exports, "BLOCK_ACTIONS_COPY_LINK_TO_BLOCK_MENU_ITEM", () => $beba5a8176031fd0$export$b20c456de8129c0);
$parcel$export(module.exports, "BLOCK_ACTIONS_COPY_MENU_SECTION", () => $beba5a8176031fd0$export$483ea0be292b7dac);
$parcel$export(module.exports, "POSITION_MENU_SECTION", () => $beba5a8176031fd0$export$770efbdcddf7d03b);
$parcel$export(module.exports, "POSITION_MOVE_UP_MENU_ITEM", () => $beba5a8176031fd0$export$f74c131f207c4e6e);
$parcel$export(module.exports, "POSITION_MOVE_DOWN_MENU_ITEM", () => $beba5a8176031fd0$export$849e72f364364410);
$parcel$export(module.exports, "DELETE_MENU_SECTION", () => $beba5a8176031fd0$export$ca2108a38e6280a5);
$parcel$export(module.exports, "DELETE_MENU_ITEM", () => $beba5a8176031fd0$export$1bb697e1417f5dce);
$parcel$export(module.exports, "BLOCK_MENU_TEST_ID", () => $beba5a8176031fd0$export$f826d1887c683892);
$parcel$export(module.exports, "BLOCK_MENU_ACTION_TEST_ID", () => $beba5a8176031fd0$export$58ecf5644244b209);
$parcel$export(module.exports, "EXTENSION_MENU_ITEM_TEST_ID", () => $beba5a8176031fd0$export$9bac3cc6a7894e2);
$parcel$export(module.exports, "AI_MENU_SECTION", () => $beba5a8176031fd0$export$8ee5435f172be1d5);
$parcel$export(module.exports, "AI_ASK_ROVO_MENU_ITEM", () => $beba5a8176031fd0$export$e118f97623bf0ced);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ // Transformation
const $beba5a8176031fd0$export$a3c0fcb7531fdfae = {
    key: 'transform-menu-section'
};
const $beba5a8176031fd0$export$3ca3ae97eef4f3f0 = {
    key: 'transform-menu-item'
};
const $beba5a8176031fd0$export$34447db936e8c6fc = {
    key: 'transform-create-menu-section'
};
const $beba5a8176031fd0$export$e1a8ae26a2a31202 = {
    key: 'transform-headings-menu-secion'
};
const $beba5a8176031fd0$export$385a1c1d9736262f = $beba5a8176031fd0$export$e1a8ae26a2a31202;
const $beba5a8176031fd0$export$80e640e763379a61 = {
    key: 'transform-headings-h1-menu-item'
};
const $beba5a8176031fd0$export$d31447f17d5c40f8 = {
    key: 'transform-headings-heading-2-menu-item'
};
const $beba5a8176031fd0$export$2d9132330244bad7 = {
    key: 'transform-headings-heading-3-menu-item'
};
const $beba5a8176031fd0$export$b5bbd55812f553dd = {
    key: 'transform-headings-heading-4-menu-item'
};
const $beba5a8176031fd0$export$33814ca575ac386 = {
    key: 'transform-headings-heading-5-menu-item'
};
const $beba5a8176031fd0$export$a8ceacf53925c4c2 = {
    key: 'transform-headings-heading-6-menu-item'
};
const $beba5a8176031fd0$export$bbc46da54e477efa = {
    key: 'transform-suggested-menu-section'
};
const $beba5a8176031fd0$export$c2d6d85aaa7f89 = {
    key: 'transform-structure-menu-section'
};
const $beba5a8176031fd0$export$d816a8e427c44cab = {
    key: 'transform-suggested-menu-item'
};
const $beba5a8176031fd0$export$e99d73a096eba9d8 = {
    key: 'transform-structure-bulleted-list-menu-item'
};
const $beba5a8176031fd0$export$4f5251553e2c0d3b = {
    key: 'transform-structure-task-list-menu-item'
};
const $beba5a8176031fd0$export$320d169c65770531 = {
    key: 'transform-structure-numbered-list-menu-item'
};
const $beba5a8176031fd0$export$5bbaff6e2e9a6ff0 = {
    key: 'transform-structure-code-block-menu-item'
};
const $beba5a8176031fd0$export$3017e11a8c1f80da = {
    key: 'transform-structure-panel-menu-item'
};
const $beba5a8176031fd0$export$6177b4b3a7cfe84a = {
    key: 'transform-structure-expand-menu-item'
};
const $beba5a8176031fd0$export$63f059e253c26b26 = {
    key: 'transform-structure-layout-menu-item'
};
const $beba5a8176031fd0$export$f2570dad43233f20 = {
    key: 'transform-structure-quote-menu-item'
};
const $beba5a8176031fd0$export$627960d6631b7765 = {
    key: 'transform-structure-extension-slot-menu-item'
};
const $beba5a8176031fd0$export$6f504bddd3dd2224 = {
    key: 'transform-structure-decision-menu-item'
};
const $beba5a8176031fd0$export$6e0886e3a8476d88 = {
    key: 'transform-structure-status-menu-item'
};
const $beba5a8176031fd0$export$cc2e3e5d65e6f0d4 = {
    key: 'transform-structure-paragraph-menu-item'
};
const $beba5a8176031fd0$export$35c0153bfbe9bc5 = {
    key: 'transform-text-formatting-small-text-menu-item'
};
const $beba5a8176031fd0$export$a23188d593dca4ea = {
    key: 'transform-clear-menu-section'
};
const $beba5a8176031fd0$export$745da57990b04239 = {
    key: 'transform-clear-menu-item'
};
const $beba5a8176031fd0$export$a3f6bf14b5ca64b8 = {
    key: 'transform-default-extension-slot-menu-item'
};
const $beba5a8176031fd0$export$c1df15c59989a309 = {
    key: 'block-actions-featured-extension-slot-menu-item'
};
const $beba5a8176031fd0$export$3867fe0cfddbf139 = {
    key: 'block-actions-template-section'
};
const $beba5a8176031fd0$export$6fea06990444f5d3 = [
    'block-actions-template-section'
];
const $beba5a8176031fd0$export$ac3b29d06d42b0ea = {
    key: 'block-actions-menu-section'
};
const $beba5a8176031fd0$export$cfe82275ae8140a2 = {
    key: 'block-actions-create-synced-block-menu-item'
};
const $beba5a8176031fd0$export$b20c456de8129c0 = {
    key: 'block-actions-copy-link-to-block-menu-item'
};
const $beba5a8176031fd0$export$483ea0be292b7dac = {
    key: 'block-actions-copy-menu-section'
};
const $beba5a8176031fd0$export$770efbdcddf7d03b = {
    key: 'position-menu-section'
};
const $beba5a8176031fd0$export$f74c131f207c4e6e = {
    key: 'position-move-up-menu-item'
};
const $beba5a8176031fd0$export$849e72f364364410 = {
    key: 'position-move-down-menu-item'
};
const $beba5a8176031fd0$export$ca2108a38e6280a5 = {
    key: 'delete-menu-section'
};
const $beba5a8176031fd0$export$1bb697e1417f5dce = {
    key: 'delete-menu-item'
};
const $beba5a8176031fd0$export$f826d1887c683892 = 'editor-block-menu';
const $beba5a8176031fd0$export$58ecf5644244b209 = {
    MOVE_UP: 'block-menu-move-up',
    MOVE_DOWN: 'block-menu-move-down',
    DELETE: 'block-menu-delete',
    COPY_LINK: 'block-menu-copy-link'
};
const $beba5a8176031fd0$export$9bac3cc6a7894e2 = 'extension-menu-item';
const $beba5a8176031fd0$export$8ee5435f172be1d5 = {
    key: 'ai-menu-section'
};
const $beba5a8176031fd0$export$fb755d72aa4ac157 = 300;
const $beba5a8176031fd0$export$e118f97623bf0ced = {
    key: 'block-menu-ai-ask-rovo-menu-item'
};
const $beba5a8176031fd0$export$3c7acd6b38230e6c = {
    key: 'block-menu-ai-improve-writing-menu-item'
};
const $beba5a8176031fd0$export$1aa04b5aeed1c667 = {
    key: 'block-menu-ai-polish-menu-item'
};
const $beba5a8176031fd0$export$c5db784a4bf3dac3 = {
    key: 'block-menu-ai-remix-menu-item'
};

});

parcelRegister("fY4jW", function(module, exports) {
$parcel$export(module.exports, "MAIN_BLOCK_MENU_SECTION_RANK", () => $5f06cb0c20d4ee0d$export$1fa59ca2cd42fda1);
$parcel$export(module.exports, "TRANSFORM_MENU_SECTION_RANK", () => $5f06cb0c20d4ee0d$export$9e41545bda08797e);
$parcel$export(module.exports, "BLOCK_ACTIONS_FEATURED_EXTENSION_ITEM_RANK", () => $5f06cb0c20d4ee0d$export$d0040892fb8e31d3);
$parcel$export(module.exports, "TRANSFORM_SUGGESTED_MENU_SECTION_RANK", () => $5f06cb0c20d4ee0d$export$b3f35fbdee992328);
$parcel$export(module.exports, "TRANSFORM_MENU_ITEM_RANK", () => $5f06cb0c20d4ee0d$export$fb745cd9e8ece9b3);
$parcel$export(module.exports, "TRANSFORM_CREATE_MENU_SECTION_RANK", () => $5f06cb0c20d4ee0d$export$8a17e62e7bf2e23a);
$parcel$export(module.exports, "TRANSFORM_HEADINGS_MENU_SECTION_RANK", () => $5f06cb0c20d4ee0d$export$41ce132dcee74abf);
$parcel$export(module.exports, "TRANSFORM_TEXT_FORMATTING_MENU_SECTION_RANK", () => $5f06cb0c20d4ee0d$export$cd907d75ec836af);
$parcel$export(module.exports, "TRANSFORM_STRUCTURE_MENU_SECTION_RANK", () => $5f06cb0c20d4ee0d$export$575896636002a88);
$parcel$export(module.exports, "BLOCK_ACTIONS_COPY_MENU_SECTION_RANK", () => $5f06cb0c20d4ee0d$export$15097da746e4c9f2);
$parcel$export(module.exports, "POSITION_MENU_SECTION_RANK", () => $5f06cb0c20d4ee0d$export$5d8a5a6209dd67c3);
$parcel$export(module.exports, "DELETE_MENU_SECTION_RANK", () => $5f06cb0c20d4ee0d$export$c635062ff5e2cdef);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ 
var $30Yan = parcelRequire("30Yan");
const $5f06cb0c20d4ee0d$export$1fa59ca2cd42fda1 = {
    [(0, $30Yan.AI_MENU_SECTION).key]: 100,
    [(0, $30Yan.TRANSFORM_MENU_SECTION).key]: 200,
    [(0, $30Yan.BLOCK_ACTIONS_TEMPLATE_SECTION).key]: 250,
    [(0, $30Yan.BLOCK_ACTIONS_MENU_SECTION).key]: 300,
    [(0, $30Yan.BLOCK_ACTIONS_COPY_MENU_SECTION).key]: 350,
    [(0, $30Yan.POSITION_MENU_SECTION).key]: 400,
    [(0, $30Yan.DELETE_MENU_SECTION).key]: 500
};
const $5f06cb0c20d4ee0d$export$f6e766e0dc1b4cae = {
    [(0, $30Yan.AI_ASK_ROVO_MENU_ITEM).key]: 100
};
const $5f06cb0c20d4ee0d$export$9e41545bda08797e = {
    [(0, $30Yan.TRANSFORM_MENU_ITEM).key]: 100,
    [(0, $30Yan.BLOCK_ACTIONS_CREATE_SYNCED_BLOCK_MENU_ITEM).key]: 200,
    [(0, $30Yan.BLOCK_ACTIONS_FEATURED_EXTENSION_SLOT_MENU_ITEM).key]: 300
};
const $5f06cb0c20d4ee0d$export$d0040892fb8e31d3 = {
    [(0, $30Yan.BLOCK_ACTIONS_FEATURED_EXTENSION_SLOT_MENU_ITEM).key]: 100
};
const $5f06cb0c20d4ee0d$export$b3f35fbdee992328 = {
    [(0, $30Yan.TRANSFORM_SUGGESTED_MENU_ITEM).key]: 100
};
const $5f06cb0c20d4ee0d$export$fb745cd9e8ece9b3 = {
    [(0, $30Yan.TRANSFORM_SUGGESTED_MENU_SECTION).key]: 100,
    [(0, $30Yan.TRANSFORM_CREATE_MENU_SECTION).key]: 200,
    [(0, $30Yan.TRANSFORM_STRUCTURE_MENU_SECTION).key]: 300,
    [(0, $30Yan.TRANSFORM_TEXTFORMATTING_MENU_SECTION).key]: 400,
    [(0, $30Yan.TRANSFORM_CLEAR_MENU_SECTION).key]: 500
};
const $5f06cb0c20d4ee0d$export$8a17e62e7bf2e23a = {
    [(0, $30Yan.TRANSFORM_DEFAULT_EXTENSION_SLOT_MENU_ITEM).key]: 1000
};
const $5f06cb0c20d4ee0d$export$41ce132dcee74abf = {
    [(0, $30Yan.TRANSFORM_HEADINGS_H1_MENU_ITEM).key]: 100,
    [(0, $30Yan.TRANSFORM_HEADINGS_H2_MENU_ITEM).key]: 200,
    [(0, $30Yan.TRANSFORM_HEADINGS_H3_MENU_ITEM).key]: 300,
    [(0, $30Yan.TRANSFORM_HEADINGS_H4_MENU_ITEM).key]: 400,
    [(0, $30Yan.TRANSFORM_HEADINGS_H5_MENU_ITEM).key]: 500,
    [(0, $30Yan.TRANSFORM_HEADINGS_H6_MENU_ITEM).key]: 600
};
const $5f06cb0c20d4ee0d$export$cd907d75ec836af = {
    [(0, $30Yan.TRANSFORM_STRUCTURE_BULLETED_LIST_MENU_ITEM).key]: 100,
    [(0, $30Yan.TRANSFORM_STRUCTURE_NUMBERED_LIST_MENU_ITEM).key]: 200,
    [(0, $30Yan.TRANSFORM_STRUCTURE_QUOTE_MENU_ITEM).key]: 300,
    [(0, $30Yan.TRANSFORM_STRUCTURE_PARAGRAPH_MENU_ITEM).key]: 400,
    [(0, $30Yan.TRANSFORM_TEXT_FORMATTING_SMALL_TEXT_MENU_ITEM).key]: 500,
    [(0, $30Yan.TRANSFORM_HEADINGS_H1_MENU_ITEM).key]: 600,
    [(0, $30Yan.TRANSFORM_HEADINGS_H2_MENU_ITEM).key]: 700,
    [(0, $30Yan.TRANSFORM_HEADINGS_H3_MENU_ITEM).key]: 800,
    [(0, $30Yan.TRANSFORM_HEADINGS_H4_MENU_ITEM).key]: 900,
    [(0, $30Yan.TRANSFORM_HEADINGS_H5_MENU_ITEM).key]: 1000,
    [(0, $30Yan.TRANSFORM_HEADINGS_H6_MENU_ITEM).key]: 1100
};
const $5f06cb0c20d4ee0d$export$575896636002a88 = {
    [(0, $30Yan.TRANSFORM_STRUCTURE_BULLETED_LIST_MENU_ITEM).key]: 100,
    [(0, $30Yan.TRANSFORM_STRUCTURE_TASK_LIST_MENU_ITEM).key]: 200,
    [(0, $30Yan.TRANSFORM_STRUCTURE_NUMBERED_LIST_MENU_ITEM).key]: 300,
    [(0, $30Yan.TRANSFORM_STRUCTURE_STATUS_MENU_ITEM).key]: 350,
    [(0, $30Yan.TRANSFORM_STRUCTURE_CODE_BLOCK_MENU_ITEM).key]: 400,
    [(0, $30Yan.TRANSFORM_STRUCTURE_PANEL_MENU_ITEM).key]: 500,
    [(0, $30Yan.TRANSFORM_STRUCTURE_EXPAND_MENU_ITEM).key]: 600,
    [(0, $30Yan.TRANSFORM_STRUCTURE_LAYOUT_MENU_ITEM).key]: 700,
    [(0, $30Yan.TRANSFORM_STRUCTURE_QUOTE_MENU_ITEM).key]: 800,
    [(0, $30Yan.TRANSFORM_STRUCTURE_EXTENSION_SLOT_MENU_ITEM).key]: 850,
    [(0, $30Yan.TRANSFORM_STRUCTURE_DECISION_MENU_ITEM).key]: 900,
    [(0, $30Yan.TRANSFORM_STRUCTURE_PARAGRAPH_MENU_ITEM).key]: 1000
};
const $5f06cb0c20d4ee0d$export$a36e8b8d5a6bf549 = {
    [(0, $30Yan.TRANSFORM_CLEAR_MENU_ITEM).key]: 100
};
const $5f06cb0c20d4ee0d$export$ad596cf0c7684e08 = {
    [(0, $30Yan.BLOCK_ACTIONS_CREATE_SYNCED_BLOCK_MENU_ITEM).key]: 100,
    [(0, $30Yan.BLOCK_ACTIONS_FEATURED_EXTENSION_SLOT_MENU_ITEM).key]: 200,
    [(0, $30Yan.BLOCK_ACTIONS_COPY_LINK_TO_BLOCK_MENU_ITEM).key]: 300
};
const $5f06cb0c20d4ee0d$export$15097da746e4c9f2 = {
    [(0, $30Yan.BLOCK_ACTIONS_COPY_LINK_TO_BLOCK_MENU_ITEM).key]: 100
};
const $5f06cb0c20d4ee0d$export$5d8a5a6209dd67c3 = {
    [(0, $30Yan.POSITION_MOVE_UP_MENU_ITEM).key]: 100,
    [(0, $30Yan.POSITION_MOVE_DOWN_MENU_ITEM).key]: 200
};
const $5f06cb0c20d4ee0d$export$c635062ff5e2cdef = {
    [(0, $30Yan.DELETE_MENU_ITEM).key]: 100
};

});

parcelRegister("kLBYz", function(module, exports) {
$parcel$export(module.exports, "expandIconContainerStyle", () => $9dc3d0a652c1f775$export$2e9dabdcf16aeb54);
$parcel$export(module.exports, "expandClassNames", () => $9dc3d0a652c1f775$export$6ba39aa0ead007b7);
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
function $9dc3d0a652c1f775$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9dc3d0a652c1f775$export$e1f541b6d8e35681 = {
    name: "1igsh0u",
    styles: "margin-left:var(--ds-space-negative-100, -8px)"
};
const $9dc3d0a652c1f775$export$2e9dabdcf16aeb54 = {
    name: "s5xdrg",
    styles: "display:flex;align-items:center"
};
const $9dc3d0a652c1f775$var$prefix = 'ak-editor-expand';
const $9dc3d0a652c1f775$export$6ba39aa0ead007b7 = {
    prefix: $9dc3d0a652c1f775$var$prefix,
    expanded: `${$9dc3d0a652c1f775$var$prefix}__expanded`,
    titleContainer: `${$9dc3d0a652c1f775$var$prefix}__title-container`,
    inputContainer: `${$9dc3d0a652c1f775$var$prefix}__input-container`,
    iconContainer: `${$9dc3d0a652c1f775$var$prefix}__icon-container`,
    icon: `${$9dc3d0a652c1f775$var$prefix}__icon`,
    iconButton: `${$9dc3d0a652c1f775$var$prefix}__icon-button`,
    iconSvg: `${$9dc3d0a652c1f775$var$prefix}__icon-svg`,
    titleInput: `${$9dc3d0a652c1f775$var$prefix}__title-input`,
    content: `${$9dc3d0a652c1f775$var$prefix}__content`,
    contentCollapsed: `${$9dc3d0a652c1f775$var$prefix}__content--collapsed`,
    type: (type)=>`${$9dc3d0a652c1f775$var$prefix}__type-${type}`
};

});

parcelRegister("fUfre", function(module, exports) {
$parcel$export(module.exports, "RelativeSelectionPos", () => $42a97ad8faa31a07$export$cb9005d223ae8de7);
var $42a97ad8faa31a07$export$cb9005d223ae8de7 = /*#__PURE__*/ function(RelativeSelectionPos) {
    RelativeSelectionPos["Before"] = "Before";
    RelativeSelectionPos["Start"] = "Start";
    RelativeSelectionPos["Inside"] = "Inside";
    RelativeSelectionPos["End"] = "End";
    return RelativeSelectionPos;
}({});

});

parcelRegister("8KAjj", function(module, exports) {
$parcel$export(module.exports, "getNodeSelectionAnalyticsPayload", () => $9faf3041671492f9$export$3162c38157c33ee6);
$parcel$export(module.exports, "getAllSelectionAnalyticsPayload", () => $9faf3041671492f9$export$9f3a063378bdcaa1);
$parcel$export(module.exports, "getCellSelectionAnalyticsPayload", () => $9faf3041671492f9$export$dcdd07dcad6adb98);
$parcel$export(module.exports, "getRangeSelectionAnalyticsPayload", () => $9faf3041671492f9$export$bf6883b886d952b0);
$parcel$export(module.exports, "createSelectionClickHandler", () => $9faf3041671492f9$export$563f7987ca7936f1);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $cw0wu = parcelRequire("cw0wu");

var $2E7OD = parcelRequire("2E7OD");

var $dh2Lm = parcelRequire("dh2Lm");

var $g6Qq4 = parcelRequire("g6Qq4");


var $8t2a4 = parcelRequire("8t2a4");

var $j7pt0 = parcelRequire("j7pt0");






var $5iSwO = parcelRequire("5iSwO");

var $5m3y9 = parcelRequire("5m3y9");

var $BqAL4 = parcelRequire("BqAL4");

var $5ameN = parcelRequire("5ameN");

var $kf85x = parcelRequire("kf85x");

var $k0RsJ = parcelRequire("k0RsJ");

var $1akDd = parcelRequire("1akDd");

var $7k00C = parcelRequire("7k00C");



var $8qh5l = parcelRequire("8qh5l");

var $lH2B7 = parcelRequire("lH2B7");

var $guQFl = parcelRequire("guQFl");
function $9faf3041671492f9$export$3162c38157c33ee6(selection) {
    if (selection instanceof (0, $cw0wu.NodeSelection)) return {
        action: (0, $g6Qq4.ACTION).SELECTED,
        actionSubject: (0, $g6Qq4.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).NODE,
        eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
        attributes: {
            node: selection.node.type.name
        }
    };
}
function $9faf3041671492f9$export$9f3a063378bdcaa1(selection) {
    if (selection instanceof (0, $cw0wu.AllSelection)) return {
        action: (0, $g6Qq4.ACTION).SELECTED,
        actionSubject: (0, $g6Qq4.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).ALL,
        eventType: (0, $g6Qq4.EVENT_TYPE).TRACK
    };
}
function $9faf3041671492f9$export$dcdd07dcad6adb98(state) {
    if (state.selection instanceof (0, $2E7OD.CellSelection)) {
        const rect = (0, $dh2Lm.selectedRect)(state);
        const selectedCells = rect.map.cellsInRect(rect).length;
        const totalCells = rect.map.map.length;
        return {
            action: (0, $g6Qq4.ACTION).SELECTED,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).DOCUMENT,
            actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).CELL,
            eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
            attributes: {
                selectedCells: selectedCells,
                totalCells: totalCells
            }
        };
    }
}
function $9faf3041671492f9$export$bf6883b886d952b0(selection, doc) {
    if (selection instanceof (0, $cw0wu.TextSelection) && selection.from !== selection.to) {
        const { from: from, to: to, anchor: anchor, head: head } = selection;
        const nodes = [];
        doc.nodesBetween(from, to, (node, pos)=>{
            // We want to send top-level nodes only, ie.the nodes that would have the selection styling
            // We allow text nodes that are not fully covered as they are a special case
            if (node.isText || pos >= from && pos + node.nodeSize <= to) {
                nodes.push(node.type.name);
                return false;
            }
        });
        return {
            action: (0, $g6Qq4.ACTION).SELECTED,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).DOCUMENT,
            actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).RANGE,
            eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
            attributes: {
                from: anchor,
                to: head,
                nodes: nodes
            }
        };
    }
}
const $9faf3041671492f9$export$cbcb4f775d907a9e = (pos)=>(state, dispatch)=>{
        if (dispatch) dispatch(state.tr.setSelection(new (0, $cw0wu.NodeSelection)(state.doc.resolve(pos))));
        return true;
    };
function $9faf3041671492f9$export$563f7987ca7936f1(nodes, isValidTarget, options) {
    return function handleClickOn(view, _pos, node, nodePos, event, direct) {
        if (options.useLongPressSelection) return false;
        if (direct && nodes.indexOf(node.type.name) !== -1) {
            const target = event.target;
            if (target instanceof HTMLElement && isValidTarget(target)) {
                const selectionPos = options.getNodeSelectionPos ? options.getNodeSelectionPos(view.state, nodePos) : nodePos;
                $9faf3041671492f9$export$cbcb4f775d907a9e(selectionPos)(view.state, view.dispatch);
                return true;
            }
        }
        return false;
    };
}

});
parcelRegister("dh2Lm", function(module, exports) {
$parcel$export(module.exports, "selectedRect", () => $526035761c292ca4$export$39ce22e69aa9ed17);

var $2E7OD = parcelRequire("2E7OD");

var $jCYj3 = parcelRequire("jCYj3");

var $gs1fw = parcelRequire("gs1fw");
function $526035761c292ca4$export$39ce22e69aa9ed17(state) {
    const sel = state.selection;
    const $pos = (0, $gs1fw.selectionCell)(sel);
    if (!$pos) throw new Error(`selectedRect: invalid $pos for selection`);
    const table = $pos.node(-1);
    const tableStart = $pos.start(-1);
    const map = (0, $jCYj3.TableMap).get(table);
    let rect;
    if (sel instanceof (0, $2E7OD.CellSelection)) rect = map.rectBetween(sel.$anchorCell.pos - tableStart, sel.$headCell.pos - tableStart);
    else rect = map.findCell($pos.pos - tableStart);
    rect.tableStart = tableStart;
    rect.map = map;
    rect.table = table;
    return rect;
}

});
parcelRegister("gs1fw", function(module, exports) {
$parcel$export(module.exports, "selectionCell", () => $590ce5f7d6d85084$export$aad75348c8f2d244);

var $5Xa4e = parcelRequire("5Xa4e");

var $9W7js = parcelRequire("9W7js");

var $8eBXN = parcelRequire("8eBXN");
function $590ce5f7d6d85084$export$aad75348c8f2d244(selection) {
    if ((0, $8eBXN.isSelectionType)(selection, 'cell')) return selection.$anchorCell.pos > selection.$headCell.pos ? selection.$anchorCell : selection.$headCell;
    if ((0, $8eBXN.isSelectionType)(selection, 'node') && selection.node.type.spec.tableRole === 'cell') return selection.$anchor;
    return (0, $5Xa4e.cellAround)(selection.$head) || (0, $9W7js.cellNear)(selection.$head);
}

});
parcelRegister("5Xa4e", function(module, exports) {
$parcel$export(module.exports, "cellAround", () => $7a78e0067867f7c7$export$1f482d92c57578ce);
function $7a78e0067867f7c7$export$1f482d92c57578ce($pos) {
    for(let d = $pos.depth - 1; d > 0; d--){
        if ($pos.node(d).type.spec.tableRole === 'row') return $pos.node(0).resolve($pos.before(d + 1));
    }
    return null;
}

});

parcelRegister("9W7js", function(module, exports) {
$parcel$export(module.exports, "cellNear", () => $f389cf3d3a44f199$export$7a283ef453dbae9e);
function $f389cf3d3a44f199$export$7a283ef453dbae9e($pos) {
    for(let after = $pos.nodeAfter, { pos: pos } = $pos; after; after = after.firstChild, pos++){
        const role = after.type.spec.tableRole;
        if (role === 'cell' || role === 'header_cell') return $pos.doc.resolve(pos);
    }
    for(let before = $pos.nodeBefore, { pos: pos } = $pos; before; before = before.lastChild, pos--){
        const role = before.type.spec.tableRole;
        if (role === 'cell' || role === 'header_cell') return $pos.doc.resolve(pos - before.nodeSize);
    }
    return null;
}

});



parcelRegister("5m3y9", function(module, exports) {
$parcel$export(module.exports, "atTheEndOfDoc", () => $0224f77ea8dc54b2$export$4ca816540352da02);
function $0224f77ea8dc54b2$export$4ca816540352da02(state) {
    const { selection: selection, doc: doc } = state;
    return doc.nodeSize - selection.$to.pos - 2 === selection.$to.depth;
}

});


parcelRegister("r0VQo", function(module, exports) {
$parcel$export(module.exports, "estimateTableIntrinsicHeight", () => $937639266ff5416b$export$a46aa8d421938f93);
$parcel$export(module.exports, "estimateExpandIntrinsicHeight", () => $937639266ff5416b$export$59dd572f532305a4);
$parcel$export(module.exports, "estimateMediaSingleIntrinsicSize", () => $937639266ff5416b$export$de14b68aa02ed4b0);
$parcel$export(module.exports, "applyContentVisibility", () => $937639266ff5416b$export$d4b89d12f4e0387a);

var $3y2s4 = parcelRequire("3y2s4");

var $33OA0 = parcelRequire("33OA0");
// Rough per-node rendered-size constants (px), grounded in the real style defaults from
// `styles/shared/table.ts`, `EditorContentContainer/styles/expandStyles.ts` and
// `EditorContentContainer/styles/layout.ts`. These only need to be a decent first estimate: the
// `auto` keyword in `contain-intrinsic-*: auto <estimate>` makes the browser remember each
// element's real size after its first render, so any inaccuracy self-corrects on scroll. Where the
// estimate can't be exact we intentionally err slightly HIGH — over-reserving leaves a marginally
// long scrollbar that shrinks on scroll, whereas under-reserving makes content jump upward.
const $937639266ff5416b$var$TABLE_ROW_HEIGHT = 44; // row content: line-height + cell padding (space.100 ×2) + cell border
const $937639266ff5416b$var$TABLE_VERTICAL_MARGIN = 40; // tableMarginTop(24) + tableMarginBottom(16)
const $937639266ff5416b$var$TABLE_MIN_HEIGHT = 120;
const $937639266ff5416b$var$BLOCK_HEIGHT = 28; // a typical paragraph/block line + spacing
const $937639266ff5416b$var$EXPAND_HEADER_HEIGHT = 48; // min-height:25 + padding + margin of the title row
const $937639266ff5416b$var$EXPAND_CONTENT_PADDING = 8; // space.100 padding-top when expanded
const $937639266ff5416b$var$MEDIA_SINGLE_MIN_HEIGHT = 100;
const $937639266ff5416b$var$MEDIA_SINGLE_GUTTER = 12; // MEDIA_SINGLE_GUTTER_SIZE — gap between resizer handle and media
const $937639266ff5416b$var$MEDIA_SINGLE_VERTICAL_MARGIN = 24; // rich-media-item margin: space.150 top + bottom
const $937639266ff5416b$var$MEDIA_CAPTION_HEIGHT = 32; // caption line-height + vertical padding, when a caption is present
const $937639266ff5416b$var$DEFAULT_MEDIA_ASPECT_RATIO = 9 / 16; // used only when the media has no intrinsic dimensions
function $937639266ff5416b$export$a46aa8d421938f93(node) {
    const rows = node.childCount;
    return Math.max($937639266ff5416b$var$TABLE_MIN_HEIGHT, rows * $937639266ff5416b$var$TABLE_ROW_HEIGHT + $937639266ff5416b$var$TABLE_VERTICAL_MARGIN);
}
function $937639266ff5416b$export$59dd572f532305a4(node, expanded) {
    if (!expanded) return $937639266ff5416b$var$EXPAND_HEADER_HEIGHT;
    return $937639266ff5416b$var$EXPAND_HEADER_HEIGHT + node.childCount * $937639266ff5416b$var$BLOCK_HEIGHT + $937639266ff5416b$var$EXPAND_CONTENT_PADDING;
}
function $937639266ff5416b$export$de14b68aa02ed4b0(node, lineLength, containerWidth) {
    var _media$attrs, _media$attrs2;
    const media = node.firstChild;
    const origWidth = Number(media === null || media === void 0 || (_media$attrs = media.attrs) === null || _media$attrs === void 0 ? void 0 : _media$attrs.width) || 0;
    const origHeight = Number(media === null || media === void 0 || (_media$attrs2 = media.attrs) === null || _media$attrs2 === void 0 ? void 0 : _media$attrs2.height) || 0;
    const aspectRatio = origWidth && origHeight ? origHeight / origWidth : $937639266ff5416b$var$DEFAULT_MEDIA_ASPECT_RATIO;
    const pixelWidth = (0, $33OA0.calcMediaSinglePixelWidth)({
        width: node.attrs.width ?? undefined,
        widthType: node.attrs.widthType,
        origWidth: origWidth || lineLength || containerWidth,
        layout: node.attrs.layout ?? 'center',
        contentWidth: lineLength || undefined,
        containerWidth: containerWidth || lineLength,
        gutterOffset: $937639266ff5416b$var$MEDIA_SINGLE_GUTTER
    });
    // A caption child (childCount > 1) sits below the media, and the mediaSingle block reserves
    // vertical margin above and below regardless.
    const captionHeight = node.childCount > 1 ? $937639266ff5416b$var$MEDIA_CAPTION_HEIGHT : 0;
    const height = Math.max($937639266ff5416b$var$MEDIA_SINGLE_MIN_HEIGHT, Math.round(pixelWidth * aspectRatio) + captionHeight + $937639266ff5416b$var$MEDIA_SINGLE_VERTICAL_MARGIN);
    return {
        width: Math.round(pixelWidth),
        height: height
    };
}
function $937639266ff5416b$export$9edae5e0213a441f(px) {
    return `auto ${Math.round(px)}px`;
}
function $937639266ff5416b$export$40a2f56815ced340(limitedModeEnabled, getIntrinsicSize) {
    if (!limitedModeEnabled || !(0, $3y2s4.isExperimentEnabled)('cc_editor_limited_mode_perf_improvements')) return undefined;
    const { width: width, height: height } = getIntrinsicSize();
    return {
        contentVisibility: 'auto',
        containIntrinsicHeight: $937639266ff5416b$export$9edae5e0213a441f(height),
        ...width !== undefined ? {
            containIntrinsicWidth: $937639266ff5416b$export$9edae5e0213a441f(width)
        } : {}
    };
}
function $937639266ff5416b$export$d4b89d12f4e0387a(dom, limitedModeEnabled, getIntrinsicSize) {
    const style = $937639266ff5416b$export$40a2f56815ced340(limitedModeEnabled, getIntrinsicSize);
    if (!style) {
        dom.style.contentVisibility = '';
        dom.style.containIntrinsicHeight = '';
        dom.style.containIntrinsicWidth = '';
        return false;
    }
    dom.style.contentVisibility = style.contentVisibility;
    dom.style.containIntrinsicHeight = style.containIntrinsicHeight;
    dom.style.containIntrinsicWidth = style.containIntrinsicWidth ?? '';
    return true;
}

});
parcelRegister("33OA0", function(module, exports) {
$parcel$export(module.exports, "calcMediaSinglePixelWidth", () => $0763604c1895d400$export$5091b2c0d1cd2361);
$parcel$export(module.exports, "getMaxWidthForNestedNodeNext", () => $0763604c1895d400$export$bcefe8f1d5d7bbf3);

var $5bbjm = parcelRequire("5bbjm");

var $acax3 = parcelRequire("acax3");

var $1HfwI = parcelRequire("1HfwI");

var $29qUP = parcelRequire("29qUP");

var $7Pkpg = parcelRequire("7Pkpg");






const $0763604c1895d400$export$5091b2c0d1cd2361 = ({ width: width, widthType: widthType = 'percentage', origWidth: origWidth, layout: layout, contentWidth: contentWidth, containerWidth: containerWidth, gutterOffset: gutterOffset = 0 })=>{
    if (widthType === 'pixel' && width) return width;
    switch(layout){
        case 'wide':
            return $0763604c1895d400$var$calcLegacyWideWidth(containerWidth, origWidth, contentWidth);
        case 'full-width':
            // legacy and new experience have different definitions of full-width,
            // since it's for new experience, we convert to the new definition
            return (0, $1HfwI.calcMediaSingleMaxWidth)(containerWidth);
        default:
            if (width) return Math.ceil(((contentWidth || containerWidth) + gutterOffset) * (width / 100) - gutterOffset);
    }
    // Handle the case of not resized node with wrapped layout
    // It's possible that the node is first inserted with align layout (e.g. jira)
    // in which the legacy image would render the width as min(origWidth, halfContentWidth).
    // However, new experience won't be able to distinguish the two. Thus, we render halfContentWidth
    // to make sure confluence legacy node is renderered correctly
    if ((0, $29qUP.wrappedLayouts).includes(layout)) return Math.ceil((contentWidth || containerWidth) / 2);
    // set initial width for not resized legacy image
    return (0, $7Pkpg.getMediaSingleInitialWidth)(origWidth, // in case containerWidth is 0, we fallback to undefined to use akEditorDefaultLayoutWidth
    contentWidth || containerWidth || undefined);
};
/**
 * Calculate pixel width for legacy media single
 * @param contentWidth editor content width
 * @param containerWidth editor container width
 */ const $0763604c1895d400$var$calcLegacyWideWidth = (containerWidth, origWidth, contentWidth)=>{
    if (contentWidth) {
        const wideWidth = Math.ceil(contentWidth * (0, $5bbjm.breakoutWideScaleRatio));
        return wideWidth > containerWidth ? contentWidth : wideWidth;
    }
    return origWidth;
};
const $0763604c1895d400$var$calcParentPadding = (view, resolvedPos)=>{
    // since table has constant padding, use hardcoded constant instead of query the dom
    const tablePadding = 8;
    const { tableCell: tableCell, tableHeader: tableHeader } = view.state.schema.nodes;
    return [
        tableCell,
        tableHeader
    ].includes(resolvedPos.parent.type) ? tablePadding * 2 : 0;
};
const $0763604c1895d400$export$bcefe8f1d5d7bbf3 = (view, pos, forInsertion)=>{
    if (typeof pos !== 'number') return null;
    const $pos = view.state.doc.resolve(pos);
    if ($pos && $pos.parent.type.name !== 'doc') return forInsertion ? $0763604c1895d400$export$7cc71489edfd26f8($pos, view) : $0763604c1895d400$export$4226a56ec6bfa71c($pos, view);
    return null;
};
const $0763604c1895d400$export$4226a56ec6bfa71c = (resolvedPos, view)=>{
    const domNode = view.nodeDOM(resolvedPos.pos);
    if (resolvedPos.nodeAfter && (0, $acax3.floatingLayouts).includes(resolvedPos.nodeAfter.attrs.layout) && domNode && domNode.parentElement) {
        const parentPadding = $0763604c1895d400$var$calcParentPadding(view, resolvedPos);
        return domNode.parentElement.offsetWidth - parentPadding;
    }
    if (domNode instanceof HTMLElement) return domNode.offsetWidth;
    return null;
};
const $0763604c1895d400$export$7cc71489edfd26f8 = (resolvedPos, view)=>{
    const parentPos = resolvedPos.before(resolvedPos.depth);
    const parentDomNode = view.nodeDOM(parentPos);
    const parentPadding = $0763604c1895d400$var$calcParentPadding(view, resolvedPos);
    if (parentDomNode instanceof HTMLElement) return parentDomNode.offsetWidth - parentPadding;
    return null;
};

});
parcelRegister("1HfwI", function(module, exports) {
$parcel$export(module.exports, "calcMediaSingleMaxWidth", () => $5fdbfac0fef95794$export$a2e7f6320d796a21);

var $5bbjm = parcelRequire("5bbjm");

var $797yE = parcelRequire("797yE");
const $5fdbfac0fef95794$export$a2e7f6320d796a21 = (containerWidth, editorAppearance)=>{
    const fullPagePadding = editorAppearance === 'full-page' && containerWidth <= (0, $5bbjm.akEditorFullPageNarrowBreakout) && (0, $797yE.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    }) ? (0, $5bbjm.akEditorGutterPaddingReduced) : (0, $5bbjm.akEditorGutterPaddingDynamic)();
    const fullWidthPadding = editorAppearance === 'full-page' ? fullPagePadding * 2 : (0, $5bbjm.akEditorGutterPadding) * 2;
    return Math.min(containerWidth - fullWidthPadding, (0, $5bbjm.akEditorFullWidthLayoutWidth));
};

});

parcelRegister("7Pkpg", function(module, exports) {
$parcel$export(module.exports, "getMediaSingleInitialWidth", () => $c67dbb25ee367459$export$4ab195f543459515);

var $5bbjm = parcelRequire("5bbjm");

var $29qUP = parcelRequire("29qUP");
const $c67dbb25ee367459$export$4ab195f543459515 = (origWidth = (0, $29qUP.DEFAULT_IMAGE_WIDTH), maxWidth = (0, $5bbjm.akEditorDefaultLayoutWidth), minWidth = (0, $29qUP.MEDIA_SINGLE_DEFAULT_MIN_PIXEL_WIDTH))=>{
    return Math.max(Math.min(origWidth, maxWidth), minWidth);
};

});



parcelRegister("kAhws", function(module, exports) {
$parcel$export(module.exports, "copyToClipboard", () => $d1de9b402ec14103$export$2cdf1b96a9f86d16);
$parcel$export(module.exports, "copyHTMLToClipboardPolyfill", () => $d1de9b402ec14103$export$97e18ff8b98c7078);
$parcel$export(module.exports, "copyHTMLToClipboard", () => $d1de9b402ec14103$export$8b344d2a6a3e9af3);
$parcel$export(module.exports, "copyHTMLToClipboardSynchronously", () => $d1de9b402ec14103$export$d37585adb0a1218e);
$parcel$export(module.exports, "getAnalyticsPayload", () => $d1de9b402ec14103$export$4feda93c1c6b2d80);
$parcel$export(module.exports, "getNodeCopiedAnalyticsPayload", () => $d1de9b402ec14103$export$f8811fa45a00fd64);

var $bAB3U = parcelRequire("bAB3U");

var $w14eP = parcelRequire("w14eP");

var $c9wRy = parcelRequire("c9wRy");

var $cw0wu = parcelRequire("cw0wu");

var $g6Qq4 = parcelRequire("g6Qq4");

var $8KAjj = parcelRequire("8KAjj");
const $d1de9b402ec14103$var$isClipboardApiSupported = ()=>!!navigator.clipboard && typeof navigator.clipboard.writeText === 'function';
const $d1de9b402ec14103$var$isIEClipboardApiSupported = ()=>// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.clipboardData && typeof window.clipboardData.setData === 'function';
const $d1de9b402ec14103$var$isExtensionNode = (node)=>{
    if (node === 'extension' || node === 'bodiedExtension' || node === 'inlineExtension' || node === 'multiBodiedExtension') return true;
    return false;
};
const $d1de9b402ec14103$export$2cdf1b96a9f86d16 = async (textToCopy)=>{
    if ($d1de9b402ec14103$var$isClipboardApiSupported()) try {
        await navigator.clipboard.writeText(textToCopy);
    } catch (error) {
        throw new Error('Clipboard api is not supported');
    }
    else if ($d1de9b402ec14103$var$isIEClipboardApiSupported()) try {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        await window.clipboardData.setData('text', textToCopy);
    } catch (error) {
        throw new Error('IE clipboard api is not supported');
    }
    else throw new Error('Clipboard api is not supported');
};
// EDF-2436: the copy helpers below are called fire-and-forget from click handlers, so a
// late rejection (eg. the polyfill's DOM fallback running after the document is gone)
// becomes an unhandled rejection and takes down the whole process. Attaching a no-op
// handler marks it handled; callers that await still receive the error.
const $d1de9b402ec14103$var$markRejectionHandled = (promise)=>{
    promise.catch(()=>{});
    return promise;
};
const $d1de9b402ec14103$var$writeHTMLToClipboard = async (elementToCopy, plainTextToCopy)=>{
    if ($d1de9b402ec14103$var$isClipboardApiSupported() && typeof ClipboardItem !== 'undefined') try {
        const data = new ClipboardItem({
            'text/plain': new Blob([
                plainTextToCopy || elementToCopy.innerText
            ], {
                type: 'text/plain'
            }),
            'text/html': new Blob([
                elementToCopy.innerHTML
            ], {
                type: 'text/html'
            })
        });
        await navigator.clipboard.write([
            data
        ]);
    } catch (error) {
        throw new Error('Clipboard api is not supported');
    }
    else if (!!document && typeof document === 'object') try {
        // ED-17083 extension copy seems have issue with ClipboardItem API
        // Hence of use of this polyfill
        // Awaited so the polyfill's async failures land in the catch below.
        await $d1de9b402ec14103$export$97e18ff8b98c7078(elementToCopy, plainTextToCopy);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
    }
};
const $d1de9b402ec14103$export$8b344d2a6a3e9af3 = (elementToCopy, plainTextToCopy)=>$d1de9b402ec14103$var$markRejectionHandled($d1de9b402ec14103$var$writeHTMLToClipboard(elementToCopy, plainTextToCopy));
const $d1de9b402ec14103$var$writeHTMLToClipboardPolyfill = async (elementToCopy, plainTextToCopy)=>{
    const dt = new $w14eP.ClipboardItem({
        'text/html': new Blob([
            elementToCopy.innerHTML
        ], {
            type: 'text/html'
        }),
        'text/plain': new Blob([
            plainTextToCopy || elementToCopy.innerText
        ], {
            type: 'text/plain'
        })
    });
    await $w14eP.write([
        dt
    ]);
};
const $d1de9b402ec14103$export$97e18ff8b98c7078 = (elementToCopy, plainTextToCopy)=>$d1de9b402ec14103$var$markRejectionHandled($d1de9b402ec14103$var$writeHTMLToClipboardPolyfill(elementToCopy, plainTextToCopy));
const $d1de9b402ec14103$export$d37585adb0a1218e = (elementToCopy, plainTextToCopy)=>{
    const document1 = (0, $c9wRy.getDocument)();
    if (!document1) return false;
    let didWriteClipboardData = false;
    const unbind = (0, $bAB3U.bind)(document1, {
        type: 'copy',
        listener: (event)=>{
            if (!event.clipboardData) return;
            event.preventDefault();
            event.clipboardData.setData('text/html', elementToCopy.innerHTML);
            event.clipboardData.setData('text/plain', plainTextToCopy || elementToCopy.innerText);
            didWriteClipboardData = true;
        }
    });
    try {
        return document1.execCommand('copy') && didWriteClipboardData;
    } catch  {
        return false;
    } finally{
        unbind();
    }
};
const $d1de9b402ec14103$export$4feda93c1c6b2d80 = (state, action)=>{
    const { selection: selection, doc: doc } = state;
    const selectionAnalyticsPayload = (0, $8KAjj.getNodeSelectionAnalyticsPayload)(selection) || (0, $8KAjj.getRangeSelectionAnalyticsPayload)(selection, doc) || (0, $8KAjj.getAllSelectionAnalyticsPayload)(selection) || (0, $8KAjj.getCellSelectionAnalyticsPayload)(state);
    if (selectionAnalyticsPayload) {
        var _attributes;
        const { actionSubjectId: selectionActionSubjectId } = selectionAnalyticsPayload;
        const node = (_attributes = selectionAnalyticsPayload.attributes) === null || _attributes === void 0 ? void 0 : _attributes.node;
        const content = [];
        let extensionType;
        let extensionKey;
        switch(selectionActionSubjectId){
            case (0, $g6Qq4.ACTION_SUBJECT_ID).NODE:
                if (node) {
                    content.push(node);
                    if ($d1de9b402ec14103$var$isExtensionNode(node)) {
                        extensionType = selection.node.attrs.extensionType;
                        extensionKey = selection.node.attrs.extensionKey;
                    }
                }
                break;
            case (0, $g6Qq4.ACTION_SUBJECT_ID).RANGE:
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                content.push(...selectionAnalyticsPayload.attributes.nodes);
                break;
            case (0, $g6Qq4.ACTION_SUBJECT_ID).ALL:
                content.push('all');
                break;
            case (0, $g6Qq4.ACTION_SUBJECT_ID).CELL:
                {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    const { selectedCells: selectedCells } = selectionAnalyticsPayload.attributes;
                    content.push(...Array(selectedCells).fill('tableCell'));
                    break;
                }
        }
        if ($d1de9b402ec14103$var$isExtensionNode(node)) return {
            eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
            action: action,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).DOCUMENT,
            attributes: {
                content: content,
                extensionKey: extensionKey,
                extensionType: extensionType
            }
        };
        return {
            eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
            action: action,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).DOCUMENT,
            attributes: {
                content: content
            }
        };
    }
    if (selection instanceof (0, $cw0wu.TextSelection) && selection.$cursor) return {
        eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
        action: action,
        actionSubject: (0, $g6Qq4.ACTION_SUBJECT).DOCUMENT,
        attributes: {
            content: [
                'caret'
            ]
        }
    };
};
const $d1de9b402ec14103$export$f8811fa45a00fd64 = (node, inputMethod)=>{
    const nodeType = node.type.name;
    let extensionType;
    let extensionKey;
    if ($d1de9b402ec14103$var$isExtensionNode(nodeType)) {
        extensionType = node.attrs.extensionType;
        extensionKey = node.attrs.extensionKey;
    }
    const payload = {
        eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
        action: (0, $g6Qq4.ACTION).COPIED,
        actionSubject: (0, $g6Qq4.ACTION_SUBJECT).DOCUMENT,
        attributes: {
            content: [
                nodeType
            ],
            inputMethod: inputMethod,
            nodeType: nodeType,
            ...extensionType ? {
                extensionType: extensionType
            } : {},
            ...extensionKey ? {
                extensionKey: extensionKey
            } : {}
        }
    };
    return payload;
};

});
parcelRegister("w14eP", function(module, exports) {
$parcel$export(module.exports, "ClipboardItem", () => $0603d13a778a1040$export$3b1380c0957dc8fe);
$parcel$export(module.exports, "write", () => $0603d13a778a1040$export$68d8715fc104d294);
// src/clipboard-polyfill/ClipboardItem/data-types.ts
var $0603d13a778a1040$var$TEXT_PLAIN = "text/plain";
var $0603d13a778a1040$var$TEXT_HTML = "text/html";
// src/clipboard-polyfill/debug.ts
var $0603d13a778a1040$var$debugLogImpl = (s)=>{};
function $0603d13a778a1040$var$debugLog(s) {
    $0603d13a778a1040$var$debugLogImpl(s);
}
function $0603d13a778a1040$export$e014146e87162c32(logFn) {
    $0603d13a778a1040$var$debugLogImpl = logFn;
}
var $0603d13a778a1040$var$showWarnings = true;
function $0603d13a778a1040$export$ba5c9528becaaf25() {
    $0603d13a778a1040$var$showWarnings = false;
}
function $0603d13a778a1040$var$shouldShowWarnings() {
    return $0603d13a778a1040$var$showWarnings;
}
function $0603d13a778a1040$var$warnOrLog() {
    (console.warn || console.log).apply(console, arguments);
}
var $0603d13a778a1040$var$warn = $0603d13a778a1040$var$warnOrLog.bind("[clipboard-polyfill]");
// src/clipboard-polyfill/builtins/window-globalThis.ts
var $0603d13a778a1040$var$originalWindow = typeof window === "undefined" ? void 0 : window;
var $0603d13a778a1040$var$originalGlobalThis = typeof globalThis === "undefined" ? void 0 : globalThis;
// src/clipboard-polyfill/builtins/promise-constructor.ts
var $0603d13a778a1040$var$_a, $0603d13a778a1040$var$_b, $0603d13a778a1040$var$_c;
var $0603d13a778a1040$var$promiseConstructorImpl = ($0603d13a778a1040$var$_c = ($0603d13a778a1040$var$_a = $0603d13a778a1040$var$originalWindow) == null ? void 0 : $0603d13a778a1040$var$_a.Promise) != null ? $0603d13a778a1040$var$_c : ($0603d13a778a1040$var$_b = $0603d13a778a1040$var$originalGlobalThis) == null ? void 0 : $0603d13a778a1040$var$_b.Promise;
function $0603d13a778a1040$var$getPromiseConstructor() {
    if (!$0603d13a778a1040$var$promiseConstructorImpl) throw new Error("No `Promise` implementation available for `clipboard-polyfill`. Consider using: https://github.com/lgarron/clipboard-polyfill#flat-file-version-with-promise-included");
    return $0603d13a778a1040$var$promiseConstructorImpl;
}
// src/clipboard-polyfill/builtins/builtin-globals.ts
var $0603d13a778a1040$var$originalNavigator = typeof navigator === "undefined" ? void 0 : navigator;
var $0603d13a778a1040$var$originalNavigatorClipboard = $0603d13a778a1040$var$originalNavigator == null ? void 0 : $0603d13a778a1040$var$originalNavigator.clipboard;
var $0603d13a778a1040$var$_a2;
var $0603d13a778a1040$var$originalNavigatorClipboardRead = ($0603d13a778a1040$var$_a2 = $0603d13a778a1040$var$originalNavigatorClipboard == null ? void 0 : $0603d13a778a1040$var$originalNavigatorClipboard.read) == null ? void 0 : $0603d13a778a1040$var$_a2.bind($0603d13a778a1040$var$originalNavigatorClipboard);
var $0603d13a778a1040$var$_a3;
var $0603d13a778a1040$var$originalNavigatorClipboardReadText = ($0603d13a778a1040$var$_a3 = $0603d13a778a1040$var$originalNavigatorClipboard == null ? void 0 : $0603d13a778a1040$var$originalNavigatorClipboard.readText) == null ? void 0 : $0603d13a778a1040$var$_a3.bind($0603d13a778a1040$var$originalNavigatorClipboard);
var $0603d13a778a1040$var$_a4;
var $0603d13a778a1040$var$originalNavigatorClipboardWrite = ($0603d13a778a1040$var$_a4 = $0603d13a778a1040$var$originalNavigatorClipboard == null ? void 0 : $0603d13a778a1040$var$originalNavigatorClipboard.write) == null ? void 0 : $0603d13a778a1040$var$_a4.bind($0603d13a778a1040$var$originalNavigatorClipboard);
var $0603d13a778a1040$var$_a5;
var $0603d13a778a1040$var$originalNavigatorClipboardWriteText = ($0603d13a778a1040$var$_a5 = $0603d13a778a1040$var$originalNavigatorClipboard == null ? void 0 : $0603d13a778a1040$var$originalNavigatorClipboard.writeText) == null ? void 0 : $0603d13a778a1040$var$_a5.bind($0603d13a778a1040$var$originalNavigatorClipboard);
var $0603d13a778a1040$var$_a6;
var $0603d13a778a1040$var$originalWindowClipboardItem = ($0603d13a778a1040$var$_a6 = $0603d13a778a1040$var$originalWindow) == null ? void 0 : $0603d13a778a1040$var$_a6.ClipboardItem;
var $0603d13a778a1040$var$promiseConstructor = $0603d13a778a1040$var$getPromiseConstructor();
// src/clipboard-polyfill/strategies/internet-explorer.ts
var $0603d13a778a1040$var$ieWindow = $0603d13a778a1040$var$originalWindow;
function $0603d13a778a1040$var$seemToBeInIE() {
    return typeof ClipboardEvent === "undefined" && typeof ($0603d13a778a1040$var$ieWindow == null ? void 0 : $0603d13a778a1040$var$ieWindow.clipboardData) !== "undefined" && typeof ($0603d13a778a1040$var$ieWindow == null ? void 0 : $0603d13a778a1040$var$ieWindow.clipboardData.setData) !== "undefined";
}
function $0603d13a778a1040$var$writeTextIE(text) {
    if (!$0603d13a778a1040$var$ieWindow.clipboardData) return false;
    var success = $0603d13a778a1040$var$ieWindow.clipboardData.setData("Text", text);
    if (success) $0603d13a778a1040$var$debugLog("writeTextIE worked");
    return success;
}
function $0603d13a778a1040$var$readTextIE() {
    if (!$0603d13a778a1040$var$ieWindow.clipboardData) throw new Error("Cannot read IE clipboard Data ");
    var text = $0603d13a778a1040$var$ieWindow.clipboardData.getData("Text");
    if (text === "") throw new Error("Empty clipboard or could not read plain text from clipboard");
    return text;
}
// src/clipboard-polyfill/strategies/dom.ts
function $0603d13a778a1040$var$copyListener(tracker, data, e) {
    $0603d13a778a1040$var$debugLog("listener called");
    tracker.success = true;
    for(var type in data){
        var value = data[type];
        var clipboardData = e.clipboardData;
        clipboardData.setData(type, value);
        if (type === $0603d13a778a1040$var$TEXT_PLAIN && clipboardData.getData(type) !== value) {
            $0603d13a778a1040$var$debugLog("setting text/plain failed");
            tracker.success = false;
        }
    }
    e.preventDefault();
}
function $0603d13a778a1040$var$execCopy(data) {
    var tracker = {
        success: false
    };
    var listener = $0603d13a778a1040$var$copyListener.bind(this, tracker, data);
    document.addEventListener("copy", listener);
    try {
        document.execCommand("copy");
    } finally{
        document.removeEventListener("copy", listener);
    }
    return tracker.success;
}
function $0603d13a778a1040$var$copyUsingTempSelection(e, data) {
    $0603d13a778a1040$var$selectionSet(e);
    var success = $0603d13a778a1040$var$execCopy(data);
    $0603d13a778a1040$var$selectionClear();
    return success;
}
function $0603d13a778a1040$var$copyUsingTempElem(data) {
    var tempElem = document.createElement("div");
    tempElem.setAttribute("style", "-webkit-user-select: text !important");
    tempElem.textContent = "temporary element";
    document.body.appendChild(tempElem);
    var success = $0603d13a778a1040$var$copyUsingTempSelection(tempElem, data);
    document.body.removeChild(tempElem);
    return success;
}
function $0603d13a778a1040$var$copyTextUsingDOM(str) {
    $0603d13a778a1040$var$debugLog("copyTextUsingDOM");
    var tempElem = document.createElement("div");
    tempElem.setAttribute("style", "-webkit-user-select: text !important");
    var spanParent = tempElem;
    if (tempElem.attachShadow) {
        $0603d13a778a1040$var$debugLog("Using shadow DOM.");
        spanParent = tempElem.attachShadow({
            mode: "open"
        });
    }
    var span = document.createElement("span");
    span.innerText = str;
    spanParent.appendChild(span);
    document.body.appendChild(tempElem);
    $0603d13a778a1040$var$selectionSet(span);
    var result = document.execCommand("copy");
    $0603d13a778a1040$var$selectionClear();
    document.body.removeChild(tempElem);
    return result;
}
function $0603d13a778a1040$var$selectionSet(elem) {
    var sel = document.getSelection();
    if (sel) {
        var range = document.createRange();
        range.selectNodeContents(elem);
        sel.removeAllRanges();
        sel.addRange(range);
    }
}
function $0603d13a778a1040$var$selectionClear() {
    var sel = document.getSelection();
    if (sel) sel.removeAllRanges();
}
// src/clipboard-polyfill/implementations/write-fallback.ts
function $0603d13a778a1040$var$writeFallback(stringItem) {
    var hasTextPlain = $0603d13a778a1040$var$TEXT_PLAIN in stringItem;
    if ($0603d13a778a1040$var$seemToBeInIE()) {
        if (!hasTextPlain) throw new Error("No `text/plain` value was specified.");
        if ($0603d13a778a1040$var$writeTextIE(stringItem[$0603d13a778a1040$var$TEXT_PLAIN])) return true;
        else throw new Error("Copying failed, possibly because the user rejected it.");
    }
    if ($0603d13a778a1040$var$execCopy(stringItem)) {
        $0603d13a778a1040$var$debugLog("regular execCopy worked");
        return true;
    }
    if (navigator.userAgent.indexOf("Edge") > -1) {
        $0603d13a778a1040$var$debugLog('UA "Edge" => assuming success');
        return true;
    }
    if ($0603d13a778a1040$var$copyUsingTempSelection(document.body, stringItem)) {
        $0603d13a778a1040$var$debugLog("copyUsingTempSelection worked");
        return true;
    }
    if ($0603d13a778a1040$var$copyUsingTempElem(stringItem)) {
        $0603d13a778a1040$var$debugLog("copyUsingTempElem worked");
        return true;
    }
    if ($0603d13a778a1040$var$copyTextUsingDOM(stringItem[$0603d13a778a1040$var$TEXT_PLAIN])) {
        $0603d13a778a1040$var$debugLog("copyTextUsingDOM worked");
        return true;
    }
    return false;
}
// src/clipboard-polyfill/promise/promise-compat.ts
function $0603d13a778a1040$var$promiseRecordMap(keys, f) {
    var promiseList = [];
    for(var i in keys){
        var key = keys[i];
        promiseList.push(f(key));
    }
    return $0603d13a778a1040$var$promiseConstructor.all(promiseList).then((vList)=>{
        var dataOut = {};
        for(var i2 = 0; i2 < keys.length; i2++)dataOut[keys[i2]] = vList[i2];
        return dataOut;
    });
}
var $0603d13a778a1040$var$voidPromise = $0603d13a778a1040$var$promiseConstructor.resolve();
var $0603d13a778a1040$var$truePromiseFn = ()=>$0603d13a778a1040$var$promiseConstructor.resolve(true);
var $0603d13a778a1040$var$falsePromise = $0603d13a778a1040$var$promiseConstructor.resolve(false);
function $0603d13a778a1040$var$rejectThrownErrors(executor) {
    return new $0603d13a778a1040$var$promiseConstructor((resolve, reject)=>{
        try {
            resolve(executor());
        } catch (e) {
            reject(e);
        }
    });
}
// src/clipboard-polyfill/implementations/text.ts
function $0603d13a778a1040$var$stringToStringItem(s) {
    var stringItem = {};
    stringItem[$0603d13a778a1040$var$TEXT_PLAIN] = s;
    return stringItem;
}
function $0603d13a778a1040$export$bec150f75a9b8f11(s) {
    return $0603d13a778a1040$var$rejectThrownErrors(()=>{
        if ($0603d13a778a1040$var$originalNavigatorClipboardWriteText) {
            $0603d13a778a1040$var$debugLog("Using `navigator.clipboard.writeText()`.");
            return $0603d13a778a1040$var$originalNavigatorClipboardWriteText(s).catch($0603d13a778a1040$var$writeTextStringFallback);
        }
        return $0603d13a778a1040$var$promiseConstructor.resolve($0603d13a778a1040$var$writeTextStringFallback(s));
    });
}
function $0603d13a778a1040$var$writeTextStringFallback(s) {
    if (!$0603d13a778a1040$var$writeFallback($0603d13a778a1040$var$stringToStringItem(s))) throw new Error("writeText() failed");
}
function $0603d13a778a1040$export$bee0113684d8879b() {
    return $0603d13a778a1040$var$rejectThrownErrors(()=>{
        if ($0603d13a778a1040$var$originalNavigatorClipboardReadText) {
            $0603d13a778a1040$var$debugLog("Using `navigator.clipboard.readText()`.");
            return $0603d13a778a1040$var$originalNavigatorClipboardReadText();
        }
        if ($0603d13a778a1040$var$seemToBeInIE()) {
            var result = $0603d13a778a1040$var$readTextIE();
            return $0603d13a778a1040$var$promiseConstructor.resolve(result);
        }
        throw new Error("Read is not supported in your browser.");
    });
}
// src/clipboard-polyfill/ClipboardItem/check.ts
function $0603d13a778a1040$var$hasItemWithType(clipboardItems, typeName) {
    for(var i in clipboardItems){
        var item = clipboardItems[i];
        if (item.types.indexOf(typeName) !== -1) return true;
    }
    return false;
}
// src/clipboard-polyfill/ClipboardItem/ClipboardItemPolyfill.ts
function $0603d13a778a1040$var$ClipboardItemPolyfillImpl(items, options) {
    var _a7;
    var types = Object.keys(items);
    var _items = {};
    for(var type in items){
        var item = items[type];
        if (typeof item === "string") _items[type] = $0603d13a778a1040$var$stringToBlob(type, item);
        else _items[type] = item;
    }
    var presentationStyle = (_a7 = options == null ? void 0 : options.presentationStyle) != null ? _a7 : "unspecified";
    function getType(type2) {
        return $0603d13a778a1040$var$promiseConstructor.resolve(_items[type2]);
    }
    return {
        types: types,
        presentationStyle: presentationStyle,
        getType: getType
    };
}
var $0603d13a778a1040$export$3b1380c0957dc8fe = $0603d13a778a1040$var$ClipboardItemPolyfillImpl;
// src/clipboard-polyfill/ClipboardItem/convert.ts
function $0603d13a778a1040$var$stringToBlob(type, str) {
    return new Blob([
        str
    ], {
        type: type
    });
}
function $0603d13a778a1040$var$blobToString(blob) {
    return new $0603d13a778a1040$var$promiseConstructor((resolve, reject)=>{
        var fileReader = new FileReader();
        fileReader.addEventListener("load", ()=>{
            var result = fileReader.result;
            if (typeof result === "string") resolve(result);
            else reject("could not convert blob to string");
        });
        fileReader.readAsText(blob);
    });
}
function $0603d13a778a1040$var$clipboardItemToGlobalClipboardItem(clipboardItem) {
    return $0603d13a778a1040$var$promiseRecordMap(clipboardItem.types, function(type) {
        return clipboardItem.getType(type);
    }).then((items)=>{
        return new Promise((resolve, reject)=>{
            var options = {};
            if (clipboardItem.presentationStyle) options.presentationStyle = clipboardItem.presentationStyle;
            if ($0603d13a778a1040$var$originalWindowClipboardItem) resolve(new $0603d13a778a1040$var$originalWindowClipboardItem(items, options));
            else reject("window.ClipboardItem is not defined");
        });
    });
}
function $0603d13a778a1040$var$textToClipboardItem(text) {
    var items = {};
    items[$0603d13a778a1040$var$TEXT_PLAIN] = $0603d13a778a1040$var$stringToBlob(text, $0603d13a778a1040$var$TEXT_PLAIN);
    return new $0603d13a778a1040$export$3b1380c0957dc8fe(items);
}
function $0603d13a778a1040$var$getTypeAsString(clipboardItem, type) {
    return clipboardItem.getType(type).then((text)=>{
        return $0603d13a778a1040$var$blobToString(text);
    });
}
function $0603d13a778a1040$var$toStringItem(data) {
    return $0603d13a778a1040$var$promiseRecordMap(data.types, function(type) {
        return $0603d13a778a1040$var$getTypeAsString(data, type);
    });
}
// src/clipboard-polyfill/implementations/blob.ts
function $0603d13a778a1040$export$68d8715fc104d294(data) {
    return $0603d13a778a1040$var$rejectThrownErrors(()=>{
        if ($0603d13a778a1040$var$originalNavigatorClipboardWrite && $0603d13a778a1040$var$originalWindowClipboardItem) {
            var originalNavigatorClipboardWriteCached = $0603d13a778a1040$var$originalNavigatorClipboardWrite;
            $0603d13a778a1040$var$debugLog("Using `navigator.clipboard.write()`.");
            return $0603d13a778a1040$var$promiseConstructor.all(data.map($0603d13a778a1040$var$clipboardItemToGlobalClipboardItem)).then((globalClipboardItems)=>{
                return originalNavigatorClipboardWriteCached(globalClipboardItems).then($0603d13a778a1040$var$truePromiseFn).catch((e)=>{
                    if (!$0603d13a778a1040$var$hasItemWithType(data, $0603d13a778a1040$var$TEXT_PLAIN) && !$0603d13a778a1040$var$hasItemWithType(data, $0603d13a778a1040$var$TEXT_HTML)) throw e;
                    return $0603d13a778a1040$var$falsePromise;
                });
            });
        }
        return $0603d13a778a1040$var$falsePromise;
    }).then((success)=>{
        if (success) return $0603d13a778a1040$var$voidPromise;
        var hasTextPlain = $0603d13a778a1040$var$hasItemWithType(data, $0603d13a778a1040$var$TEXT_PLAIN);
        if ($0603d13a778a1040$var$shouldShowWarnings() && !hasTextPlain) $0603d13a778a1040$var$debugLog("clipboard.write() was called without a `text/plain` data type. On some platforms, this may result in an empty clipboard. Call suppressWarnings() to suppress this warning.");
        return $0603d13a778a1040$var$toStringItem(data[0]).then((stringItem)=>{
            if (!$0603d13a778a1040$var$writeFallback(stringItem)) throw new Error("write() failed");
        });
    });
}
function $0603d13a778a1040$export$aafa59e2e03f2942() {
    return $0603d13a778a1040$var$rejectThrownErrors(()=>{
        if ($0603d13a778a1040$var$originalNavigatorClipboardRead) {
            $0603d13a778a1040$var$debugLog("Using `navigator.clipboard.read()`.");
            return $0603d13a778a1040$var$originalNavigatorClipboardRead();
        }
        return $0603d13a778a1040$export$bee0113684d8879b().then((text)=>{
            return [
                $0603d13a778a1040$var$textToClipboardItem(text)
            ];
        });
    });
}

});


parcelRegister("epqkL", function(module, exports) {
$parcel$export(module.exports, "textPaletteTooltipMessages", () => $ac51748e811e2599$export$d8fe76863446580e);
$parcel$export(module.exports, "backgroundPaletteTooltipMessages", () => $ac51748e811e2599$export$c671ecebb9c48677);
$parcel$export(module.exports, "chartsColorPaletteTooltipMessages", () => $ac51748e811e2599$export$f8b88c9f6c817aff);
$parcel$export(module.exports, "borderPaletteTooltipMessages", () => $ac51748e811e2599$export$515e8edd15e08de7);

var $f0Pt4 = parcelRequire("f0Pt4");

var $fCoGG = parcelRequire("fCoGG");

var $6gblp = parcelRequire("6gblp");

var $lb6hd = parcelRequire("lb6hd");
const $ac51748e811e2599$var$darkModeTextPaletteOverrides = (0, $f0Pt4.defineMessages)({
    '#FFFFFF': {
        id: 'fabric.theme.dark-gray',
        defaultMessage: 'Dark gray',
        description: 'The text is shown as a tooltip label for a color swatch in the editor text color picker in dark mode when the user hovers over the dark gray color option.'
    }
});
const $ac51748e811e2599$export$cca9f3b863b77c82 = {
    ...(0, $lb6hd.lightTextPaletteTooltipMessages),
    ...$ac51748e811e2599$var$darkModeTextPaletteOverrides
};
const $ac51748e811e2599$export$d8fe76863446580e = {
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    light: (0, $lb6hd.lightTextPaletteTooltipMessages),
    dark: $ac51748e811e2599$export$cca9f3b863b77c82
};
const $ac51748e811e2599$var$darkModeBackgroundPaletteOverrides = (0, $f0Pt4.defineMessages)({
    '#FFFFFF': {
        id: 'fabric.theme.subtle-gray',
        defaultMessage: 'Subtle gray',
        description: 'The text is shown as a tooltip label for a color swatch in the editor background color picker in dark mode when the user hovers over the subtle gray color option.'
    },
    '#B3BAC5': {
        id: 'fabric.theme.bold-gray',
        defaultMessage: 'Bold gray',
        description: 'The text is shown as a tooltip label for a color swatch in the editor background color picker in dark mode when the user hovers over the bold gray color option.'
    }
});
const $ac51748e811e2599$export$d1327856929fda16 = {
    ...(0, $fCoGG.lightBackgroundPaletteTooltipMessages),
    ...$ac51748e811e2599$var$darkModeBackgroundPaletteOverrides
};
const $ac51748e811e2599$export$c671ecebb9c48677 = {
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    light: (0, $fCoGG.lightBackgroundPaletteTooltipMessages),
    dark: $ac51748e811e2599$export$d1327856929fda16
};
const $ac51748e811e2599$var$darkChartsColorPaletteTooltipMessages = {
    ...(0, $6gblp.lightChartsColorPaletteTooltipMessages)
};
const $ac51748e811e2599$export$f8b88c9f6c817aff = {
    // eslint-disable-next-line @atlaskit/editor/no-re-export
    light: (0, $6gblp.lightChartsColorPaletteTooltipMessages),
    dark: $ac51748e811e2599$var$darkChartsColorPaletteTooltipMessages
};
const $ac51748e811e2599$var$lightBorderPaletteTooltipMessages = (0, $f0Pt4.defineMessages)({
    '#091E4224': {
        id: 'fabric.theme.subtle-gray',
        defaultMessage: 'Subtle gray',
        description: 'The text is shown as a tooltip label for a color swatch in the editor border color picker when the user hovers over the subtle gray color option.'
    },
    '#758195': {
        id: 'fabric.theme.gray',
        defaultMessage: 'Gray',
        description: 'The text is shown as a tooltip label for a color swatch in the editor border color picker when the user hovers over the gray color option.'
    },
    '#172B4D': {
        id: 'fabric.theme.bold-gray',
        defaultMessage: 'Bold gray',
        description: 'The text is shown as a tooltip label for a color swatch in the editor border color picker when the user hovers over the bold gray color option.'
    }
});
const $ac51748e811e2599$var$darkBorderPaletteTooltipMessages = {
    ...$ac51748e811e2599$var$lightBorderPaletteTooltipMessages
};
const $ac51748e811e2599$export$515e8edd15e08de7 = {
    light: $ac51748e811e2599$var$lightBorderPaletteTooltipMessages,
    dark: $ac51748e811e2599$var$darkBorderPaletteTooltipMessages
};

});
parcelRegister("fCoGG", function(module, exports) {
$parcel$export(module.exports, "lightBackgroundPaletteTooltipMessages", () => $2a1b0cf267794dc9$export$12d66ae3e5b38d26);

var $f0Pt4 = parcelRequire("f0Pt4");
const $2a1b0cf267794dc9$export$12d66ae3e5b38d26 = (0, $f0Pt4.defineMessages)({
    '#DEEBFF': {
        id: 'fabric.theme.subtle-blue',
        defaultMessage: 'Subtle blue',
        description: 'The text is shown as a tooltip label for a color swatch in the editor background color picker when the user hovers over the subtle blue color option.'
    },
    '#B3D4FF': {
        id: 'fabric.theme.blue',
        defaultMessage: 'Blue',
        description: 'The text is shown as a tooltip label for a color swatch in the editor background color picker when the user hovers over the blue color option.'
    },
    '#4C9AFF': {
        id: 'fabric.theme.bold-blue',
        defaultMessage: 'Bold blue',
        description: 'The text is shown as a tooltip label for a color swatch in the editor background color picker when the user hovers over the bold blue color option.'
    },
    '#ADCBFB': {
        id: 'fabric.theme.bold-blue-new',
        defaultMessage: 'Bold blue',
        description: 'The text is shown as a tooltip label for a color swatch in the editor background color picker when the user hovers over the bold blue color option.'
    },
    '#E6FCFF': {
        id: 'fabric.theme.subtle-teal',
        defaultMessage: 'Subtle teal',
        description: 'The text is shown as a tooltip label for a color swatch in the editor background color picker when the user hovers over the subtle teal color option.'
    },
    '#B3F5FF': {
        id: 'fabric.theme.teal',
        defaultMessage: 'Teal',
        description: 'The text is shown as a tooltip label for a color swatch in the editor background color picker when the user hovers over the teal color option.'
    },
    '#79E2F2': {
        id: 'fabric.theme.bold-teal',
        defaultMessage: 'Bold teal',
        description: 'The text is shown as a tooltip label for a color swatch in the editor background color picker when the user hovers over the bold teal color option.'
    },
    '#B1E4F7': {
        id: 'fabric.theme.bold-teal-new',
        defaultMessage: 'Bold teal',
        description: 'The text is shown as a tooltip label for a color swatch in the editor background color picker when the user hovers over the bold teal color option.'
    },
    '#E3FCEF': {
        id: 'fabric.theme.subtle-green',
        defaultMessage: 'Subtle green',
        description: 'The text is shown as a tooltip label for a color swatch in the editor background color picker when the user hovers over the subtle green color option.'
    },
    '#ABF5D1': {
        id: 'fabric.theme.green',
        defaultMessage: 'Green',
        description: 'The text is shown as a tooltip label for a color swatch in the editor background color picker when the user hovers over the green color option.'
    },
    '#57D9A3': {
        id: 'fabric.theme.bold-green',
        defaultMessage: 'Bold green',
        description: 'The text is shown as a tooltip label for a color swatch in the editor background color picker when the user hovers over the bold green color option.'
    },
    '#97EDC9': {
        id: 'fabric.theme.bold-green-new',
        defaultMessage: 'Bold green',
        description: 'The text is shown as a tooltip label for a color swatch in the editor background color picker when the user hovers over the bold green color option.'
    },
    '#FFFAE6': {
        id: 'fabric.theme.subtle-yellow',
        defaultMessage: 'Subtle yellow',
        description: 'The text is shown as a tooltip label for a color swatch in the editor background color picker when the user hovers over the subtle yellow color option.'
    },
    '#FFF0B3': {
        id: 'fabric.theme.yellow',
        defaultMessage: 'Yellow',
        description: 'The text is shown as a tooltip label for a color swatch in the editor background color picker when the user hovers over the yellow color option.'
    },
    '#FFC400': {
        id: 'fabric.theme.bold-yellow',
        defaultMessage: 'Bold yellow',
        description: 'The text is shown as a tooltip label for a color swatch in the editor background color picker when the user hovers over the bold yellow color option.'
    },
    '#EFDD4E': {
        id: 'fabric.theme.bold-yellow-new',
        defaultMessage: 'Bold yellow',
        description: 'The text is shown as a tooltip label for a color swatch in the editor background color picker when the user hovers over the bold yellow color option.'
    },
    '#FFEBE6': {
        id: 'fabric.theme.subtle-red',
        defaultMessage: 'Subtle red',
        description: 'The text is shown as a tooltip label for a color swatch in the editor background color picker when the user hovers over the subtle red color option.'
    },
    '#FFBDAD': {
        id: 'fabric.theme.red',
        defaultMessage: 'Red',
        description: 'The text is shown as a tooltip label for a color swatch in the editor background color picker when the user hovers over the red color option.'
    },
    '#FF8F73': {
        id: 'fabric.theme.bold-red',
        defaultMessage: 'Bold red',
        description: 'The text is shown as a tooltip label for a color swatch in the editor background color picker when the user hovers over the bold red color option.'
    },
    '#FFB8B2': {
        id: 'fabric.theme.bold-red-new',
        defaultMessage: 'Bold red',
        description: 'The text is shown as a tooltip label for a color swatch in the editor background color picker when the user hovers over the bold red color option.'
    },
    '#EAE6FF': {
        id: 'fabric.theme.subtle-purple',
        defaultMessage: 'Subtle purple',
        description: 'The text is shown as a tooltip label for a color swatch in the editor background color picker when the user hovers over the subtle purple color option.'
    },
    '#C0B6F2': {
        id: 'fabric.theme.purple',
        defaultMessage: 'Purple',
        description: 'The text is shown as a tooltip label for a color swatch in the editor background color picker when the user hovers over the purple color option.'
    },
    '#998DD9': {
        id: 'fabric.theme.bold-purple',
        defaultMessage: 'Bold purple',
        description: 'The text is shown as a tooltip label for a color swatch in the editor background color picker when the user hovers over the bold purple color option.'
    },
    '#E3BDFA': {
        id: 'fabric.theme.bold-purple-new',
        defaultMessage: 'Bold purple',
        description: 'The text is shown as a tooltip label for a color swatch in the editor background color picker when the user hovers over the bold purple color option.'
    },
    '#FFFFFF': {
        id: 'fabric.theme.white',
        defaultMessage: 'White',
        description: 'The text is shown as a tooltip label for a color swatch in the editor background color picker when the user hovers over the white color option.'
    },
    '#F4F5F7': {
        id: 'fabric.theme.gray',
        defaultMessage: 'Gray',
        description: 'The text is shown as a tooltip label for a color swatch in the editor background color picker when the user hovers over the gray color option.'
    },
    '#B3BAC5': {
        id: 'fabric.theme.bold-gray',
        defaultMessage: 'Bold gray',
        description: 'The text is shown as a tooltip label for a color swatch in the editor background color picker when the user hovers over the bold gray color option.'
    },
    '#B7B9BE': {
        id: 'fabric.theme.bold-gray-new',
        defaultMessage: 'Bold gray',
        description: 'The text is shown as a tooltip label for a color swatch in the editor background color picker when the user hovers over the bold gray color option.'
    },
    '#EFFFD6': {
        id: 'fabric.theme.subtle-lime',
        defaultMessage: 'Subtle lime',
        description: 'The text is shown as a tooltip label for a color swatch in the editor background color picker when the user hovers over the subtle lime color option.'
    },
    '#D3F1A7': {
        id: 'fabric.theme.lime',
        defaultMessage: 'Lime',
        description: 'The text is shown as a tooltip label for a color swatch in the editor background color picker when the user hovers over the lime color option.'
    },
    '#BDE97C': {
        id: 'fabric.theme.bold-lime',
        defaultMessage: 'Bold lime',
        description: 'The text is shown as a tooltip label for a color swatch in the editor background color picker when the user hovers over the bold lime color option.'
    },
    '#FFF5DB': {
        id: 'fabric.theme.subtle-orange',
        defaultMessage: 'Subtle orange',
        description: 'The text is shown as a tooltip label for a color swatch in the editor background color picker when the user hovers over the subtle orange color option.'
    },
    '#FCE4A6': {
        id: 'fabric.theme.orange',
        defaultMessage: 'Orange',
        description: 'The text is shown as a tooltip label for a color swatch in the editor background color picker when the user hovers over the orange color option.'
    },
    '#FBD779': {
        id: 'fabric.theme.bold-orange',
        defaultMessage: 'Bold orange',
        description: 'The text is shown as a tooltip label for a color swatch in the editor background color picker when the user hovers over the bold orange color option.'
    },
    '#FFECF8': {
        id: 'fabric.theme.subtle-magenta',
        defaultMessage: 'Subtle magenta',
        description: 'The text is shown as a tooltip label for a color swatch in the editor background color picker when the user hovers over the subtle magenta color option.'
    },
    '#FDD0EC': {
        id: 'fabric.theme.magenta',
        defaultMessage: 'Magenta',
        description: 'The text is shown as a tooltip label for a color swatch in the editor background color picker when the user hovers over the magenta color option.'
    },
    '#FCB6E1': {
        id: 'fabric.theme.bold-magenta',
        defaultMessage: 'Bold magenta',
        description: 'The text is shown as a tooltip label for a color swatch in the editor background color picker when the user hovers over the bold magenta color option.'
    }
});

});

parcelRegister("6gblp", function(module, exports) {
$parcel$export(module.exports, "lightChartsColorPaletteTooltipMessages", () => $7de0fdf2d5835b13$export$3db7ab7dd64ad21a);

var $f0Pt4 = parcelRequire("f0Pt4");
const $7de0fdf2d5835b13$export$3db7ab7dd64ad21a = (0, $f0Pt4.defineMessages)({
    // Blue color
    '#7AB2FF': {
        id: 'fabric.theme.subtle-blue',
        defaultMessage: 'Subtle blue',
        description: 'The text is shown as a tooltip label for a color swatch in the editor charts color picker when the user hovers over the subtle blue color option.'
    },
    '#247FFF': {
        id: 'fabric.theme.blue',
        defaultMessage: 'Blue',
        description: 'The text is shown as a tooltip label for a color swatch in the editor charts color picker when the user hovers over the blue color option.'
    },
    '#0055CC': {
        id: 'fabric.theme.bold-blue',
        defaultMessage: 'Bold blue',
        description: 'The text is shown as a tooltip label for a color swatch in the editor charts color picker when the user hovers over the bold blue color option.'
    },
    '#003884': {
        id: 'fabric.theme.bolder-blue',
        defaultMessage: 'Bolder blue',
        description: 'The text is shown as a tooltip label for a color swatch in the editor charts color picker when the user hovers over the bolder blue color option.'
    },
    // Teal color
    '#60C6D2': {
        id: 'fabric.theme.subtle-teal',
        defaultMessage: 'Subtle teal',
        description: 'The text is shown as a tooltip label for a color swatch in the editor charts color picker when the user hovers over the subtle teal color option.'
    },
    '#1D9AAA': {
        id: 'fabric.theme.teal',
        defaultMessage: 'Teal',
        description: 'The text is shown as a tooltip label for a color swatch in the editor charts color picker when the user hovers over the teal color option.'
    },
    '#1D7F8C': {
        id: 'fabric.theme.bold-teal',
        defaultMessage: 'Bold teal',
        description: 'The text is shown as a tooltip label for a color swatch in the editor charts color picker when the user hovers over the bold teal color option.'
    },
    '#206B74': {
        id: 'fabric.theme.bolder-teal',
        defaultMessage: 'Bolder teal',
        description: 'The text is shown as a tooltip label for a color swatch in the editor charts color picker when the user hovers over the bolder teal color option.'
    },
    // Green color
    '#6BE1B0': {
        id: 'fabric.theme.subtle-green',
        defaultMessage: 'Subtle green',
        description: 'The text is shown as a tooltip label for a color swatch in the editor charts color picker when the user hovers over the subtle green color option.'
    },
    '#23A971': {
        id: 'fabric.theme.green',
        defaultMessage: 'Green',
        description: 'The text is shown as a tooltip label for a color swatch in the editor charts color picker when the user hovers over the green color option.'
    },
    '#177D52': {
        id: 'fabric.theme.bold-green',
        defaultMessage: 'Bold green',
        description: 'The text is shown as a tooltip label for a color swatch in the editor charts color picker when the user hovers over the bold green color option.'
    },
    '#055C3F': {
        id: 'fabric.theme.bolder-green',
        defaultMessage: 'Bolder green',
        description: 'The text is shown as a tooltip label for a color swatch in the editor charts color picker when the user hovers over the bolder green color option.'
    },
    // Yellow color
    '#FFDB57': {
        id: 'fabric.theme.subtle-yellow',
        defaultMessage: 'Subtle yellow',
        description: 'The text is shown as a tooltip label for a color swatch in the editor charts color picker when the user hovers over the subtle yellow color option.'
    },
    '#FFBE33': {
        id: 'fabric.theme.yellow',
        defaultMessage: 'Yellow',
        description: 'The text is shown as a tooltip label for a color swatch in the editor charts color picker when the user hovers over the yellow color option.'
    },
    '#FF9D00': {
        id: 'fabric.theme.bold-yellow',
        defaultMessage: 'Bold yellow',
        description: 'The text is shown as a tooltip label for a color swatch in the editor charts color picker when the user hovers over the bold yellow color option.'
    },
    '#946104': {
        id: 'fabric.theme.bolder-yellow',
        defaultMessage: 'Bolder yellow',
        description: 'The text is shown as a tooltip label for a color swatch in the editor charts color picker when the user hovers over the bolder yellow color option.'
    },
    // Red color
    '#FF8F73': {
        id: 'fabric.theme.subtle-red',
        defaultMessage: 'Subtle red',
        description: 'The text is shown as a tooltip label for a color swatch in the editor charts color picker when the user hovers over the subtle red color option.'
    },
    '#FC552C': {
        id: 'fabric.theme.red',
        defaultMessage: 'Red',
        description: 'The text is shown as a tooltip label for a color swatch in the editor charts color picker when the user hovers over the red color option.'
    },
    '#D32D03': {
        id: 'fabric.theme.bold-red',
        defaultMessage: 'Bold red',
        description: 'The text is shown as a tooltip label for a color swatch in the editor charts color picker when the user hovers over the bold red color option.'
    },
    '#A32000': {
        id: 'fabric.theme.bolder-red',
        defaultMessage: 'Bolder red',
        description: 'The text is shown as a tooltip label for a color swatch in the editor charts color picker when the user hovers over the bolder red color option.'
    },
    // Orange color
    '#FAA53D': {
        id: 'fabric.theme.subtle-orange',
        defaultMessage: 'Subtle orange',
        description: 'The text is shown as a tooltip label for a color swatch in the editor charts color picker when the user hovers over the subtle orange color option.'
    },
    '#D97008': {
        id: 'fabric.theme.orange',
        defaultMessage: 'Orange',
        description: 'The text is shown as a tooltip label for a color swatch in the editor charts color picker when the user hovers over the orange color option.'
    },
    '#B65C02': {
        id: 'fabric.theme.bold-orange',
        defaultMessage: 'Bold orange',
        description: 'The text is shown as a tooltip label for a color swatch in the editor charts color picker when the user hovers over the bold orange color option.'
    },
    '#974F0C': {
        id: 'fabric.theme.bolder-orange',
        defaultMessage: 'Bolder orange',
        description: 'The text is shown as a tooltip label for a color swatch in the editor charts color picker when the user hovers over the bolder orange color option.'
    },
    // Magenta color
    '#E774BB': {
        id: 'fabric.theme.subtle-magenta',
        defaultMessage: 'Subtle magenta',
        description: 'The text is shown as a tooltip label for a color swatch in the editor charts color picker when the user hovers over the subtle magenta color option.'
    },
    '#DA62AC': {
        id: 'fabric.theme.magenta',
        defaultMessage: 'Magenta',
        description: 'The text is shown as a tooltip label for a color swatch in the editor charts color picker when the user hovers over the magenta color option.'
    },
    '#CD519D': {
        id: 'fabric.theme.bold-magenta',
        defaultMessage: 'Bold magenta',
        description: 'The text is shown as a tooltip label for a color swatch in the editor charts color picker when the user hovers over the bold magenta color option.'
    },
    '#943D73': {
        id: 'fabric.theme.bolder-magenta',
        defaultMessage: 'Bolder magenta',
        description: 'The text is shown as a tooltip label for a color swatch in the editor charts color picker when the user hovers over the bolder magenta color option.'
    },
    // Purple color
    '#B5A7FB': {
        id: 'fabric.theme.subtle-purple',
        defaultMessage: 'Subtle purple',
        description: 'The text is shown as a tooltip label for a color swatch in the editor charts color picker when the user hovers over the subtle purple color option.'
    },
    '#8B77EE': {
        id: 'fabric.theme.purple',
        defaultMessage: 'Purple',
        description: 'The text is shown as a tooltip label for a color swatch in the editor charts color picker when the user hovers over the purple color option.'
    },
    '#5A43D0': {
        id: 'fabric.theme.bold-purple',
        defaultMessage: 'Bold purple',
        description: 'The text is shown as a tooltip label for a color swatch in the editor charts color picker when the user hovers over the bold purple color option.'
    },
    '#44368B': {
        id: 'fabric.theme.bolder-purple',
        defaultMessage: 'Bolder purple',
        description: 'The text is shown as a tooltip label for a color swatch in the editor charts color picker when the user hovers over the bolder purple color option.'
    },
    // Gray color
    '#8993A5': {
        id: 'fabric.theme.subtle-gray',
        defaultMessage: 'Subtle gray',
        description: 'The text is shown as a tooltip label for a color swatch in the editor charts color picker when the user hovers over the subtle gray color option.'
    },
    '#8590A2': {
        id: 'fabric.theme.gray',
        defaultMessage: 'Gray',
        description: 'The text is shown as a tooltip label for a color swatch in the editor charts color picker when the user hovers over the gray color option.'
    },
    '#758195': {
        id: 'fabric.theme.bold-gray',
        defaultMessage: 'Bold gray',
        description: 'The text is shown as a tooltip label for a color swatch in the editor charts color picker when the user hovers over the bold gray color option.'
    },
    '#44546F': {
        id: 'fabric.theme.bolder-gray',
        defaultMessage: 'Bolder gray',
        description: 'The text is shown as a tooltip label for a color swatch in the editor charts color picker when the user hovers over the bolder gray color option.'
    }
});

});

parcelRegister("lb6hd", function(module, exports) {
$parcel$export(module.exports, "lightTextPaletteTooltipMessages", () => $f62764609badda1d$export$788a656fb7fb7897);

var $f0Pt4 = parcelRequire("f0Pt4");
const $f62764609badda1d$export$788a656fb7fb7897 = (0, $f0Pt4.defineMessages)({
    '#FFFFFF': {
        id: 'fabric.theme.white',
        defaultMessage: 'White',
        description: 'The text is shown as a tooltip label for a color swatch in the editor text color picker when the user hovers over the white color option.'
    },
    '#B3D4FF': {
        id: 'fabric.theme.subtle-blue',
        defaultMessage: 'Subtle blue',
        description: 'The text is shown as a tooltip label for a color swatch in the editor text color picker when the user hovers over the subtle blue color option.'
    },
    '#B3F5FF': {
        id: 'fabric.theme.subtle-teal',
        defaultMessage: 'Subtle teal',
        description: 'The text is shown as a tooltip label for a color swatch in the editor text color picker when the user hovers over the subtle teal color option.'
    },
    '#ABF5D1': {
        id: 'fabric.theme.subtle-green',
        defaultMessage: 'Subtle green',
        description: 'The text is shown as a tooltip label for a color swatch in the editor text color picker when the user hovers over the subtle green color option.'
    },
    '#FFF0B3': {
        id: 'fabric.theme.subtle-yellow',
        defaultMessage: 'Subtle yellow',
        description: 'The text is shown as a tooltip label for a color swatch in the editor text color picker when the user hovers over the subtle yellow color option.'
    },
    '#FFBDAD': {
        id: 'fabric.theme.subtle-red',
        defaultMessage: 'Subtle red',
        description: 'The text is shown as a tooltip label for a color swatch in the editor text color picker when the user hovers over the subtle red color option.'
    },
    '#EAE6FF': {
        id: 'fabric.theme.subtle-purple',
        defaultMessage: 'Subtle purple',
        description: 'The text is shown as a tooltip label for a color swatch in the editor text color picker when the user hovers over the subtle purple color option.'
    },
    '#97A0AF': {
        id: 'fabric.theme.gray',
        defaultMessage: 'Gray',
        description: 'The text is shown as a tooltip label for a color swatch in the editor text color picker when the user hovers over the gray color option.'
    },
    '#4C9AFF': {
        id: 'fabric.theme.blue',
        defaultMessage: 'Blue',
        description: 'The text is shown as a tooltip label for a color swatch in the editor text color picker when the user hovers over the blue color option.'
    },
    '#00B8D9': {
        id: 'fabric.theme.teal',
        defaultMessage: 'Teal',
        description: 'The text is shown as a tooltip label for a color swatch in the editor text color picker when the user hovers over the teal color option.'
    },
    '#36B37E': {
        id: 'fabric.theme.green',
        defaultMessage: 'Green',
        description: 'The text is shown as a tooltip label for a color swatch in the editor text color picker when the user hovers over the green color option.'
    },
    '#FFC400': {
        id: 'fabric.theme.yellow',
        defaultMessage: 'Yellow',
        description: 'The text is shown as a tooltip label for a color swatch in the editor text color picker when the user hovers over the yellow color option.'
    },
    '#FF5630': {
        id: 'fabric.theme.red',
        defaultMessage: 'Red',
        description: 'The text is shown as a tooltip label for a color swatch in the editor text color picker when the user hovers over the red color option.'
    },
    '#FF991F': {
        id: 'fabric.theme.bold-orange',
        defaultMessage: 'Bold orange',
        description: 'The text is shown as a tooltip label for a color swatch in the editor text color picker when the user hovers over the bold orange color option.'
    },
    '#6554C0': {
        id: 'fabric.theme.purple',
        defaultMessage: 'Purple',
        description: 'The text is shown as a tooltip label for a color swatch in the editor text color picker when the user hovers over the purple color option.'
    },
    '#0747A6': {
        id: 'fabric.theme.bold-blue',
        defaultMessage: 'Bold blue',
        description: 'The text is shown as a tooltip label for a color swatch in the editor text color picker when the user hovers over the bold blue color option.'
    },
    '#008DA6': {
        id: 'fabric.theme.bold-teal',
        defaultMessage: 'Bold teal',
        description: 'The text is shown as a tooltip label for a color swatch in the editor text color picker when the user hovers over the bold teal color option.'
    },
    '#006644': {
        id: 'fabric.theme.bold-green',
        defaultMessage: 'Bold green',
        description: 'The text is shown as a tooltip label for a color swatch in the editor text color picker when the user hovers over the bold green color option.'
    },
    '#BF2600': {
        id: 'fabric.theme.bold-red',
        defaultMessage: 'Bold red',
        description: 'The text is shown as a tooltip label for a color swatch in the editor text color picker when the user hovers over the bold red color option.'
    },
    '#403294': {
        id: 'fabric.theme.bold-purple',
        defaultMessage: 'Bold purple',
        description: 'The text is shown as a tooltip label for a color swatch in the editor text color picker when the user hovers over the bold purple color option.'
    },
    '#172B4D': {
        id: 'fabric.theme.default',
        defaultMessage: 'Default',
        description: 'The text is shown as a tooltip label for a color swatch in the editor text color picker when the user hovers over the default color option.'
    },
    '#D3F1A7': {
        id: 'fabric.theme.subtle-lime',
        defaultMessage: 'Subtle lime',
        description: 'The text is shown as a tooltip label for a color swatch in the editor text color picker when the user hovers over the subtle lime color option.'
    },
    '#FDD0EC': {
        id: 'fabric.theme.subtle-magenta',
        defaultMessage: 'Subtle magenta',
        description: 'The text is shown as a tooltip label for a color swatch in the editor text color picker when the user hovers over the subtle magenta color option.'
    },
    '#6A9A23': {
        id: 'fabric.theme.lime',
        defaultMessage: 'Lime',
        description: 'The text is shown as a tooltip label for a color swatch in the editor text color picker when the user hovers over the lime color option.'
    },
    '#CD519D': {
        id: 'fabric.theme.magenta',
        defaultMessage: 'Magenta',
        description: 'The text is shown as a tooltip label for a color swatch in the editor text color picker when the user hovers over the magenta color option.'
    },
    '#4C6B1F': {
        id: 'fabric.theme.bold-lime',
        defaultMessage: 'Bold lime',
        description: 'The text is shown as a tooltip label for a color swatch in the editor text color picker when the user hovers over the bold lime color option.'
    },
    '#943D73': {
        id: 'fabric.theme.bold-magenta',
        defaultMessage: 'Bold magenta',
        description: 'The text is shown as a tooltip label for a color swatch in the editor text color picker when the user hovers over the bold magenta color option.'
    },
    '#B38600': {
        id: 'fabric.theme.yellow',
        defaultMessage: 'Yellow',
        description: 'The text is shown as a tooltip label for a color swatch in the editor text color picker when the user hovers over the yellow color option.'
    },
    '#7F5F01': {
        id: 'fabric.theme.bold-yellow',
        defaultMessage: 'Bold yellow',
        description: 'The text is shown as a tooltip label for a color swatch in the editor text color picker when the user hovers over the bold yellow color option.'
    },
    '#FCE4A6': {
        id: 'fabric.theme.subtle-orange',
        defaultMessage: 'Subtle orange',
        description: 'The text is shown as a tooltip label for a color swatch in the editor text color picker when the user hovers over the subtle orange color option.'
    },
    '#E06C00': {
        id: 'fabric.theme.orange',
        defaultMessage: 'Orange',
        description: 'The text is shown as a tooltip label for a color swatch in the editor text color picker when the user hovers over the orange color option.'
    },
    '#9E4C00': {
        id: 'fabric.theme.bold-orange',
        defaultMessage: 'Bold orange',
        description: 'The text is shown as a tooltip label for a color swatch in the editor text color picker when the user hovers over the bold orange color option.'
    }
});

});


parcelRegister("eUTDo", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_BORDER_COLOR", () => $79a2a58a32612e6a$export$f54f5cacf382b9f2);

var $7qLn8 = parcelRequire("7qLn8");
/**
 * For a given color set the alpha channel to alpha
 *
 * @param color color string, suppports HEX, RGB, RGBA etc.
 * @param alpha Alpha channel value as fraction of 1
 * @return CSS RGBA string with applied alpha channel
 */ function $79a2a58a32612e6a$var$setAlpha(color, alpha) {
    const { r: r, g: g, b: b } = (0, $7qLn8.default).convert(color).rgb;
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
const $79a2a58a32612e6a$export$f54f5cacf382b9f2 = $79a2a58a32612e6a$var$setAlpha('#172B4D', 0.12); /* eslint-enable @atlaskit/design-system/ensure-design-token-usage */ 

});

parcelRegister("1NElZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $76327f4b936ebc0a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $4vLTk = parcelRequire("4vLTk");

var $2usNr = parcelRequire("2usNr");

var $kIbto = parcelRequire("kIbto");

var $jNJGJ = parcelRequire("jNJGJ");

var $4GWyU = parcelRequire("4GWyU");

var $3y2s4 = parcelRequire("3y2s4");

var $gUpf2 = parcelRequire("gUpf2");

var $2IITT = parcelRequire("2IITT");

var $9BVpB = parcelRequire("9BVpB");

var $797yE = parcelRequire("797yE");

var $lavtv = parcelRequire("lavtv");

var $g6Qq4 = parcelRequire("g6Qq4");
var $cP1y8 = parcelRequire("cP1y8");

var $jjKlo = parcelRequire("jjKlo");

var $5CXZA = parcelRequire("5CXZA");
var $eUTDo = parcelRequire("eUTDo");
var $czomm = parcelRequire("czomm");

var $cf2n1 = parcelRequire("cf2n1");

var $5zk80 = parcelRequire("5zk80");

var $5chfg = parcelRequire("5chfg");

var $imBU3 = parcelRequire("imBU3");
function $76327f4b936ebc0a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// helps adjusts position of popup
const $76327f4b936ebc0a$var$colorPickerButtonWrapper = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $76327f4b936ebc0a$var$colorPickerExpandContainerVisualRefresh = (0, $9BVpB.xcss)({
    marginTop: 'space.negative.025',
    marginRight: 'space.negative.050'
});
const $76327f4b936ebc0a$var$colorPickerButtonStyle = /*#__PURE__*/ (0, $9dQre.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    button: {
        '&::after': {
            border: 'none'
        },
        '&:hover': {
            backgroundColor: `${"var(--ds-background-selected, #E9F2FE)"}`
        }
    }
});
// Control the size of color picker buttons and preview
// TODO: DSP-4134 - Color picking UI
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $76327f4b936ebc0a$var$colorPickerWrapper = ()=>/*#__PURE__*/ (0, $9dQre.css)({
        borderRadius: "var(--ds-radius-small, 3px)",
        backgroundColor: "var(--ds-surface-overlay, #FFFFFF)",
        boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)",
        padding: `${"var(--ds-space-100, 8px)"} 0px`
    });
const $76327f4b936ebc0a$var$ColorPaletteWithReactViewListeners = (0, $cf2n1.default)((0, $5CXZA.default));
const $76327f4b936ebc0a$var$COLOR_PICKER_POPUP_OFFSET = [
    0,
    10
];
const $76327f4b936ebc0a$var$ColorPickerButton = (props)=>{
    const buttonRef = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useRef(null);
    const [isPopupOpen, setIsPopupOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useState(false);
    const [isPopupPositioned, setIsPopupPositioned] = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useState(false);
    const [isOpenedByKeyboard, setIsOpenedByKeyboard] = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useState(false);
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const memoizedHandleClose = (0, $bSJIT.useCallback)(()=>setIsPopupOpen(false), [
        setIsPopupOpen
    ]);
    const handleClose = (0, $3y2s4.isExperimentEnabled)('platform_editor_perf_lint_cleanup') ? memoizedHandleClose : ()=>setIsPopupOpen(false);
    const memoizedTogglePopup = (0, $bSJIT.useCallback)(()=>{
        setIsPopupOpen((prevIsOpen)=>{
            if (!prevIsOpen) {
                setIsOpenedByKeyboard(false);
                setIsPopupPositioned(false);
            }
            return !prevIsOpen;
        });
    }, []);
    const togglePopup = (0, $3y2s4.isExperimentEnabled)('platform_editor_perf_lint_cleanup') ? memoizedTogglePopup : ()=>{
        setIsPopupOpen(!isPopupOpen);
        if (!isPopupOpen) {
            setIsOpenedByKeyboard(false);
            setIsPopupPositioned(false);
        }
    };
    const memoizedOnKeyDown = (0, $bSJIT.useCallback)((event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            memoizedTogglePopup();
            setIsOpenedByKeyboard(true);
        }
    }, [
        memoizedTogglePopup
    ]);
    const onKeyDown = (0, $3y2s4.isExperimentEnabled)('platform_editor_perf_lint_cleanup') ? memoizedOnKeyDown : (event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            togglePopup();
            setIsOpenedByKeyboard(true);
        }
    };
    const memoizedPaletteOptions = (0, $bSJIT.useMemo)(()=>({
            palette: props.colorPalette,
            hexToPaletteColor: props.hexToPaletteColor,
            paletteColorTooltipMessages: props.paletteColorTooltipMessages
        }), [
        props.colorPalette,
        props.hexToPaletteColor,
        props.paletteColorTooltipMessages
    ]);
    const paletteOptions = (0, $3y2s4.isExperimentEnabled)('platform_editor_perf_lint_cleanup') ? memoizedPaletteOptions : {
        palette: props.colorPalette,
        hexToPaletteColor: props.hexToPaletteColor,
        paletteColorTooltipMessages: props.paletteColorTooltipMessages
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useEffect(()=>{
        if (props.setDisableParentScroll) props.setDisableParentScroll(isPopupOpen);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isPopupOpen
    ]);
    const focusButton = ()=>{
        var _buttonRef$current;
        (_buttonRef$current = buttonRef.current) === null || _buttonRef$current === void 0 || _buttonRef$current.focus();
    };
    const handleEsc = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useCallback(()=>{
        setIsOpenedByKeyboard(false);
        setIsPopupPositioned(false);
        setIsPopupOpen(false);
        focusButton();
    }, []);
    const onPositionCalculated = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useCallback((position)=>{
        setIsPopupPositioned(true);
        return position;
    }, []);
    const { onChange: onChange, createAnalyticsEvent: createAnalyticsEvent, colorPalette: colorPalette, placement: placement, skipFocusButtonAfterPick: skipFocusButtonAfterPick, hideExpandIcon: hideExpandIcon = false } = props;
    const onColorSelected = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useCallback((color, label)=>{
        setIsOpenedByKeyboard(false);
        setIsPopupOpen(false);
        setIsPopupPositioned(false);
        if (onChange) {
            if (createAnalyticsEvent) {
                // fire analytics
                const payload = {
                    action: (0, $g6Qq4.ACTION).UPDATED,
                    actionSubject: (0, $g6Qq4.ACTION_SUBJECT).PICKER,
                    actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).PICKER_COLOR,
                    attributes: {
                        color: color,
                        label: label,
                        placement: placement
                    },
                    eventType: (0, $g6Qq4.EVENT_TYPE).TRACK
                };
                createAnalyticsEvent(payload).fire((0, $cP1y8.editorAnalyticsChannel));
            }
            const newPalette = colorPalette.find((colorPalette)=>colorPalette.value === color);
            newPalette && onChange(newPalette);
        }
        if (!skipFocusButtonAfterPick) focusButton();
    }, [
        colorPalette,
        onChange,
        createAnalyticsEvent,
        placement,
        skipFocusButtonAfterPick
    ]);
    const renderPopup = ()=>{
        if (!isPopupOpen || !buttonRef.current) return;
        const selectedColor = props.currentColor || null;
        const { selectedRowIndex: selectedRowIndex, selectedColumnIndex: selectedColumnIndex } = (0, $czomm.getSelectedRowAndColumnFromPalette)(props.colorPalette, selectedColor, props.cols);
        return /*#__PURE__*/ (0, $9dQre.jsx)((0, $5zk80.default), {
            target: buttonRef.current,
            fitHeight: 350,
            fitWidth: 350,
            offset: (0, $3y2s4.isExperimentEnabled)('platform_editor_perf_lint_cleanup') ? $76327f4b936ebc0a$var$COLOR_PICKER_POPUP_OFFSET : [
                0,
                10
            ],
            alignX: props.alignX,
            mountTo: props.setDisableParentScroll ? props.mountPoint : undefined,
            absoluteOffset: props.absoluteOffset,
            // Confluence inline comment editor has z-index: 500
            // if the toolbar is scrollable, this will be mounted in the root editor
            // we need an index of > 500 to display over it
            zIndex: props.setDisableParentScroll ? 600 : undefined,
            ariaLabel: formatMessage((0, $jjKlo.colorPickerButtonMessages).colorPickerMenuLabel),
            onPositionCalculated: onPositionCalculated
        }, /*#__PURE__*/ (0, $9dQre.jsx)("div", {
            css: $76327f4b936ebc0a$var$colorPickerWrapper,
            "data-test-id": "color-picker-menu"
        }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $5chfg.ArrowKeyNavigationProvider), {
            type: (0, $imBU3.ArrowKeyNavigationType).COLOR,
            selectedRowIndex: selectedRowIndex,
            selectedColumnIndex: selectedColumnIndex,
            closeOnTab: true,
            handleClose: handleClose,
            isOpenedByKeyboard: isOpenedByKeyboard,
            isPopupPositioned: isPopupPositioned,
            ignoreEscapeKey: props.returnEscToButton
        }, /*#__PURE__*/ (0, $9dQre.jsx)($76327f4b936ebc0a$var$ColorPaletteWithReactViewListeners, {
            cols: props.cols,
            selectedColor: selectedColor,
            onClick: onColorSelected,
            handleClickOutside: togglePopup,
            handleEscapeKeydown: handleEsc,
            paletteOptions: paletteOptions
        }))));
    };
    const title = props.title || '';
    const currentColor = props.currentColor && props.hexToPaletteColor ? props.hexToPaletteColor(props.currentColor) : props.currentColor;
    const buttonStyleVisualRefresh = ()=>{
        var _props$size, _props$size2, _props$size3;
        return /*#__PURE__*/ (0, $9dQre.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            height: `${!!((_props$size = props.size) !== null && _props$size !== void 0 && _props$size.height) ? 'inherit' : ''}`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '&:before': {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                alignSelf: 'center',
                content: "''",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                border: `${"var(--ds-border-width, 1px)"} solid ${(0, $eUTDo.DEFAULT_BORDER_COLOR)}`,
                borderRadius: "var(--ds-radius-small, 3px)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                backgroundColor: currentColor || 'transparent',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                width: ((_props$size2 = props.size) === null || _props$size2 === void 0 ? void 0 : _props$size2.width) || '14px',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                height: ((_props$size3 = props.size) === null || _props$size3 === void 0 ? void 0 : _props$size3.height) || '14px',
                marginTop: `${"var(--ds-space-025, 2px)"}`
            }
        });
    };
    return /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        css: $76327f4b936ebc0a$var$colorPickerButtonWrapper
    }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $lavtv.default), {
        content: title,
        position: "top"
    }, /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        css: $76327f4b936ebc0a$var$colorPickerButtonStyle
    }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $jNJGJ.default), {
        appearance: 'subtle',
        ref: buttonRef,
        "aria-label": title,
        "aria-expanded": props.isAriaExpanded ? isPopupOpen : undefined,
        spacing: (0, $797yE.editorExperiment)('platform_editor_controls', 'variant1') ? 'default' : 'compact',
        onClick: togglePopup,
        onKeyDown: onKeyDown,
        "data-selected-color": props.currentColor,
        isSelected: isPopupOpen
    }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $2IITT.Inline), {
        alignBlock: "start"
    }, /*#__PURE__*/ (0, $9dQre.jsx)("span", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: buttonStyleVisualRefresh
    }), !hideExpandIcon && /*#__PURE__*/ (0, $9dQre.jsx)((0, $gUpf2.Box), {
        xcss: $76327f4b936ebc0a$var$colorPickerExpandContainerVisualRefresh
    }, /*#__PURE__*/ (0, $9dQre.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4GWyU))), {
        color: "currentColor",
        spacing: "spacious",
        label: "color-picker-chevron-down",
        size: "small"
    })))))), renderPopup());
};
const $76327f4b936ebc0a$var$_default_1 = (0, $2usNr.default)({
    source: 'ConfigPanel'
})((0, $kIbto.default)()($76327f4b936ebc0a$var$ColorPickerButton));
var $76327f4b936ebc0a$export$2e2bcd8739ae039 = $76327f4b936ebc0a$var$_default_1;

});
parcelRegister("jjKlo", function(module, exports) {
$parcel$export(module.exports, "colorPickerButtonMessages", () => $8cff0d73ec17e2be$export$46fbf624c87d759a);

var $f0Pt4 = parcelRequire("f0Pt4");
const $8cff0d73ec17e2be$export$46fbf624c87d759a = (0, $f0Pt4.defineMessages)({
    colorPickerMenuLabel: {
        id: 'fabric.editor.colorPicker.menuLabel',
        defaultMessage: 'Color picker menu',
        description: 'The label for the color picker menu popup window'
    }
});

});

parcelRegister("5CXZA", function(module, exports) {
$parcel$export(module.exports, "default", () => $078fb058279b6b14$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $7qLn8 = parcelRequire("7qLn8");

var $fK3tS = parcelRequire("fK3tS");

var $3y2s4 = parcelRequire("3y2s4");

var $ceb9s = parcelRequire("ceb9s");

var $1DpbD = parcelRequire("1DpbD");

var $c7jdP = parcelRequire("c7jdP");

var $afNME = parcelRequire("afNME");

var $czomm = parcelRequire("czomm");
/**
 * For a given color pick the color from a list of colors with
 * the highest contrast
 *
 * @param color color string, supports HEX, RGB, RGBA etc.
 * @param useIconToken boolean, describes if a token should be used for the icon color
 * @return Highest contrast color in pool
 */ function $078fb058279b6b14$var$getCheckMarkColor(color, useIconToken) {
    const tokenVal = (0, $czomm.getTokenCSSVariableValue)(color);
    const colorValue = !!tokenVal ? tokenVal : color;
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    const contrastColor = [
        '#FFFFFF',
        '#42526E'
    ].sort((a, b)=>(0, $7qLn8.default).difference(b, colorValue) - (0, $7qLn8.default).difference(a, colorValue))[0];
    if (!useIconToken) return contrastColor;
    // Use of these token comes from guidance from designers in the Design System team
    // they are only intended for use with text colors (and there are different tokens
    // planned to be used when this extended to be used with other palettes).
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    return contrastColor === '#FFFFFF' ? "var(--ds-icon-inverse, #FFFFFF)" : "var(--ds-icon, #292A2E)";
}
const $078fb058279b6b14$var$ColorPalette = (props)=>{
    const { cols: cols = (0, $czomm.DEFAULT_COLOR_PICKER_COLUMNS), onClick: onClick, onKeyDown: onKeyDown, selectedColor: selectedColor, className: className, intl: { formatMessage: formatMessage }, paletteOptions: paletteOptions, ariaLabel: ariaLabel } = props;
    const { palette: palette, hexToPaletteColor: hexToPaletteColor, paletteColorTooltipMessages: paletteColorTooltipMessages } = paletteOptions;
    const { colorMode: tokenTheme } = (0, $ceb9s.useThemeObserver)();
    const useIconToken = !!hexToPaletteColor;
    const isDividerExperimentEnabled = (0, $3y2s4.isExperimentEnabled)('platform_editor_lovability_dividers');
    const colorsPerRow = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useMemo(()=>{
        return (0, $czomm.getColorsPerRowFromPalette)(palette, cols);
    }, [
        palette,
        cols
    ]);
    return /*#__PURE__*/ (0, $9dQre.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, colorsPerRow.map((row)=>/*#__PURE__*/ (0, $9dQre.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            css: (0, $afNME.colorPaletteWrapper),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            key: `row-first-color-${row[0].value}`,
            role: "radiogroup",
            "aria-label": ariaLabel
        }, row.map(({ value: value, label: label, border: border, message: message, decorator: decorator })=>{
            if (paletteColorTooltipMessages) {
                if (tokenTheme === 'dark') message = (0, $c7jdP.default)(paletteColorTooltipMessages.dark, value.toUpperCase());
                if (tokenTheme === 'light') message = (0, $c7jdP.default)(paletteColorTooltipMessages.light, value.toUpperCase());
            }
            return /*#__PURE__*/ (0, $9dQre.jsx)((0, $1DpbD.default), {
                key: value,
                value: value,
                borderColor: border,
                label: message ? formatMessage(message) : label,
                onClick: onClick,
                onKeyDown: onKeyDown,
                isSelected: value === selectedColor,
                checkMarkColor: isDividerExperimentEnabled ? $078fb058279b6b14$var$getCheckMarkColor(value, useIconToken) : undefined,
                hexToPaletteColor: hexToPaletteColor,
                decorator: decorator
            });
        }))));
};
// eslint-disable-next-line @typescript-eslint/no-restricted-types
const $078fb058279b6b14$var$_default_1 = (0, $fK3tS.default)($078fb058279b6b14$var$ColorPalette);
var $078fb058279b6b14$export$2e2bcd8739ae039 = $078fb058279b6b14$var$_default_1;

});
parcelRegister("1DpbD", function(module, exports) {
$parcel$export(module.exports, "default", () => $724146acbae01591$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $k9Jtq = parcelRequire("k9Jtq");

var $lavtv = parcelRequire("lavtv");

var $ezbvm = parcelRequire("ezbvm");
const $724146acbae01591$var$Color = (props)=>{
    const { autoFocus: autoFocus, tabIndex: tabIndex, value: value, label: label, isSelected: isSelected, borderColor: borderColor, checkMarkColor: checkMarkColor, hexToPaletteColor: /**
     * When hexToPaletteColor prop is set,
     * it will be used to get background color style based on
     * value (which will be hexcode) prop
     */ hexToPaletteColor, decorator: decorator } = props;
    const colorStyle = hexToPaletteColor ? hexToPaletteColor(value) : value;
    const onMouseDown = (e)=>{
        e.preventDefault();
    };
    const onClick = (e)=>{
        const { onClick: onClick, value: value, label: label } = props;
        e.preventDefault();
        onClick(value, label);
    };
    const onKeyDown = (e)=>{
        const { onKeyDown: onKeyDown, value: value, label: label } = props;
        if (!onKeyDown) return undefined;
        e.preventDefault();
        onKeyDown(value, label, e);
    };
    return /*#__PURE__*/ (0, $9dQre.jsx)((0, $lavtv.default), {
        content: label
    }, /*#__PURE__*/ (0, $9dQre.jsx)("span", {
        css: (0, $ezbvm.buttonWrapperStyle)
    }, /*#__PURE__*/ (0, $9dQre.jsx)("button", {
        type: "button",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: (0, $ezbvm.buttonStyle),
        "aria-label": label,
        role: "radio",
        "aria-checked": isSelected,
        onClick: onClick,
        onKeyDown: onKeyDown,
        onMouseDown: onMouseDown,
        tabIndex: tabIndex,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `${isSelected ? 'selected' : ''}`,
        style: {
            backgroundColor: colorStyle || "var(--ds-background-input, #FFFFFF)",
            border: `${"var(--ds-border-width, 1px)"} solid ${borderColor}`
        },
        autoFocus: autoFocus
    }, !decorator && isSelected && /*#__PURE__*/ (0, $9dQre.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($k9Jtq))), {
        label: "",
        color: checkMarkColor
    }), decorator)));
};
var $724146acbae01591$export$2e2bcd8739ae039 = $724146acbae01591$var$Color;

});
parcelRegister("ezbvm", function(module, exports) {
$parcel$export(module.exports, "buttonStyle", () => $f05282c936b847d7$export$fd4d27a26b4854f3);
$parcel$export(module.exports, "buttonWrapperStyle", () => $f05282c936b847d7$export$7afe8f4b3442c19d);
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9dQre = parcelRequire("9dQre");
const $f05282c936b847d7$export$fd4d27a26b4854f3 = /*#__PURE__*/ (0, $9dQre.css)({
    height: '26px',
    width: '26px',
    background: "var(--ds-background-neutral, #0515240F)",
    padding: 0,
    borderRadius: "var(--ds-radius-small, 4px)",
    border: `1px solid ${"var(--ds-border-inverse, #FFFFFF)"}`,
    cursor: 'pointer',
    display: 'block'
});
const $f05282c936b847d7$export$7afe8f4b3442c19d = /*#__PURE__*/ (0, $9dQre.css)({
    border: '1px solid transparent',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    fontSize: 0,
    display: 'flex',
    alignItems: 'center',
    padding: "var(--ds-space-025, 2px)",
    borderRadius: "var(--ds-radius-medium, 6px)",
    '&:focus-within, &:focus, &:hover': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
        borderColor: `${"var(--ds-border, #0B120E24)"} !important`
    }
}); /* eslint-enable @atlaskit/design-system/ensure-design-token-usage */ 

});


parcelRegister("afNME", function(module, exports) {
$parcel$export(module.exports, "colorPaletteWrapper", () => $0b8cd7245d297fc2$export$506342f5c0767858);
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9dQre = parcelRequire("9dQre");
const $0b8cd7245d297fc2$export$506342f5c0767858 = /*#__PURE__*/ (0, $9dQre.css)({
    padding: `0 ${"var(--ds-space-100, 8px)"}`,
    /* Firefox bug fix: https://product-fabric.atlassian.net/browse/ED-1789 */ display: 'flex'
});

});

parcelRegister("czomm", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_COLOR_PICKER_COLUMNS", () => $525d6a61a912d113$export$dc37d14f75a32acb);
$parcel$export(module.exports, "getColorsPerRowFromPalette", () => $525d6a61a912d113$export$d97d52770ca27b6f);
$parcel$export(module.exports, "getSelectedRowAndColumnFromPalette", () => $525d6a61a912d113$export$c16ae5b27ec0c8f6);
$parcel$export(module.exports, "getTokenCSSVariableValue", () => $525d6a61a912d113$export$426cbff16166281c);
$parcel$export(module.exports, "getTokenCSSVariableValueForNonActiveTheme", () => $525d6a61a912d113$export$6c1720cebb7dda4b);

var $k2sBB = parcelRequire("k2sBB");

var $cfahw = parcelRequire("cfahw");

var $eBIfo = parcelRequire("eBIfo");

var $5A4bG = parcelRequire("5A4bG");

var $ZnlFT = parcelRequire("ZnlFT");
const $525d6a61a912d113$export$dc37d14f75a32acb = 7;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $525d6a61a912d113$var$CSS_VAR_EXPRESSION_REGEX = /var\(([^,\)]+)(,.*)?\)/;
const $525d6a61a912d113$var$getCSSVariableParts = (variableExpression)=>{
    const matcher = variableExpression.match($525d6a61a912d113$var$CSS_VAR_EXPRESSION_REGEX);
    if (!matcher) return undefined;
    return {
        fallback: matcher[2] ? matcher[2].replace(',', '').trim() : '',
        variable: matcher[1].trim()
    };
};
// Build the reverse lookup (CSS variable -> token name) once at module load so that
// each lookup is O(1) instead of O(n) with an extra array allocation per call.
const $525d6a61a912d113$var$cssVariableToTokenName = new Map(Object.entries((0, $5A4bG.default)).map(([tokenName, cssVariable])=>[
        cssVariable,
        tokenName
    ]));
const $525d6a61a912d113$var$getTokenName = (cssVariable)=>$525d6a61a912d113$var$cssVariableToTokenName.get(cssVariable);
const $525d6a61a912d113$var$resolveRawTokenValue = (value)=>{
    var _paletteRaw$find;
    if (typeof value !== 'string') return undefined;
    const paletteValue = (_paletteRaw$find = (0, $eBIfo.default).find((paletteToken)=>paletteToken.path[paletteToken.path.length - 1] === value)) === null || _paletteRaw$find === void 0 ? void 0 : _paletteRaw$find.value;
    return typeof paletteValue === 'string' ? paletteValue : value;
};
const $525d6a61a912d113$var$getCurrentThemeMode = ()=>{
    if (typeof document === 'undefined') return 'light';
    return document.documentElement.getAttribute('data-color-mode') === 'dark' ? 'dark' : 'light';
};
const $525d6a61a912d113$var$getNonActiveThemeMode = ()=>$525d6a61a912d113$var$getCurrentThemeMode() === 'dark' ? 'light' : 'dark';
function $525d6a61a912d113$export$d97d52770ca27b6f(palette, cols = $525d6a61a912d113$export$dc37d14f75a32acb) {
    return palette.reduce((resultArray, item, index)=>{
        const chunkIndex = Math.floor(index / cols);
        resultArray[chunkIndex] = resultArray[chunkIndex] || []; // start a new chunk
        resultArray[chunkIndex].push(item);
        return resultArray;
    }, []);
}
function $525d6a61a912d113$export$c16ae5b27ec0c8f6(palette, selectedColor, cols = $525d6a61a912d113$export$dc37d14f75a32acb) {
    const colorsPerRow = $525d6a61a912d113$export$d97d52770ca27b6f(palette, cols);
    return (0, $ZnlFT.getSelectedRowAndColumn)(colorsPerRow, selectedColor);
}
const $525d6a61a912d113$export$426cbff16166281c = (variableExpression)=>{
    const matcher = variableExpression.match($525d6a61a912d113$var$CSS_VAR_EXPRESSION_REGEX);
    if (matcher) {
        const variable = matcher[1].trim();
        const fallback = matcher[2] ? matcher[2].replace(',', '').trim() : '';
        if (typeof document === 'undefined') return fallback;
        const value = window.getComputedStyle(document.documentElement).getPropertyValue(variable).trim();
        return value || fallback;
    }
    return '';
};
const $525d6a61a912d113$export$6c1720cebb7dda4b = (variableExpression, fallback)=>{
    const cssVariableParts = $525d6a61a912d113$var$getCSSVariableParts(variableExpression);
    const tokenName = cssVariableParts ? $525d6a61a912d113$var$getTokenName(cssVariableParts.variable) : undefined;
    const rawToken = ($525d6a61a912d113$var$getNonActiveThemeMode() === 'light' ? (0, $cfahw.default) : (0, $k2sBB.default)).find((token)=>token.cleanName === tokenName);
    if (rawToken) return $525d6a61a912d113$var$resolveRawTokenValue(rawToken.value) || fallback;
    return (cssVariableParts === null || cssVariableParts === void 0 ? void 0 : cssVariableParts.fallback) || fallback;
};

});
parcelRegister("k2sBB", function(module, exports) {
$parcel$export(module.exports, "default", () => $999ff9597f880fd1$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a310062cb7336e4c0e920ee15f52e421>>
 * @codegenCommand yarn build tokens
 */ const $999ff9597f880fd1$var$tokens = [
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.6.0",
            "description": "Use for for backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
        },
        "value": "#28311B",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.6.0",
                "description": "Use for for backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
            },
            "value": "Lime1000"
        },
        "name": "color.background.accent.lime.subtlest.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "lime",
            "subtlest",
            "[default]"
        ],
        "cleanName": "color.background.accent.lime.subtlest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.lime.subtlest."
        },
        "value": "#37471F",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.lime.subtlest."
            },
            "value": "Lime900"
        },
        "name": "color.background.accent.lime.subtlest.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "lime",
            "subtlest",
            "hovered"
        ],
        "cleanName": "color.background.accent.lime.subtlest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.lime.subtlest."
        },
        "value": "#3F5224",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.lime.subtlest."
            },
            "value": "Lime850"
        },
        "name": "color.background.accent.lime.subtlest.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "lime",
            "subtlest",
            "pressed"
        ],
        "cleanName": "color.background.accent.lime.subtlest.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.6.0",
            "description": "Use for for backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#37471F",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.6.0",
                "description": "Use for for backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Lime900"
        },
        "name": "color.background.accent.lime.subtler.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "lime",
            "subtler",
            "[default]"
        ],
        "cleanName": "color.background.accent.lime.subtler"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.lime.subtler."
        },
        "value": "#3F5224",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.lime.subtler."
            },
            "value": "Lime850"
        },
        "name": "color.background.accent.lime.subtler.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "lime",
            "subtler",
            "hovered"
        ],
        "cleanName": "color.background.accent.lime.subtler.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.lime.subtler."
        },
        "value": "#4C6B1F",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.lime.subtler."
            },
            "value": "Lime800"
        },
        "name": "color.background.accent.lime.subtler.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "lime",
            "subtler",
            "pressed"
        ],
        "cleanName": "color.background.accent.lime.subtler.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.6.0",
            "description": "Use for vibrant for backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#4C6B1F",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.6.0",
                "description": "Use for vibrant for backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Lime800"
        },
        "name": "color.background.accent.lime.subtle.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "lime",
            "subtle",
            "[default]"
        ],
        "cleanName": "color.background.accent.lime.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.lime.subtle."
        },
        "value": "#3F5224",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.lime.subtle."
            },
            "value": "Lime850"
        },
        "name": "color.background.accent.lime.subtle.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "lime",
            "subtle",
            "hovered"
        ],
        "cleanName": "color.background.accent.lime.subtle.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.lime.subtle."
        },
        "value": "#37471F",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.lime.subtle."
            },
            "value": "Lime900"
        },
        "name": "color.background.accent.lime.subtle.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "lime",
            "subtle",
            "pressed"
        ],
        "cleanName": "color.background.accent.lime.subtle.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.6.0",
            "description": "Use for for backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
        },
        "value": "#94C748",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.6.0",
                "description": "Use for for backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
            },
            "value": "Lime400"
        },
        "name": "color.background.accent.lime.bolder.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "lime",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.background.accent.lime.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.lime.bolder."
        },
        "value": "#B3DF72",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.lime.bolder."
            },
            "value": "Lime300"
        },
        "name": "color.background.accent.lime.bolder.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "lime",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.background.accent.lime.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.lime.bolder."
        },
        "value": "#BDE97C",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.lime.bolder."
            },
            "value": "Lime250"
        },
        "name": "color.background.accent.lime.bolder.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "lime",
            "bolder",
            "pressed"
        ],
        "cleanName": "color.background.accent.lime.bolder.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for red backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
        },
        "value": "#42221F",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for red backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
            },
            "value": "Red1000"
        },
        "name": "color.background.accent.red.subtlest.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "red",
            "subtlest",
            "[default]"
        ],
        "cleanName": "color.background.accent.red.subtlest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.red.subtlest."
        },
        "value": "#5D1F1A",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.red.subtlest."
            },
            "value": "Red900"
        },
        "name": "color.background.accent.red.subtlest.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "red",
            "subtlest",
            "hovered"
        ],
        "cleanName": "color.background.accent.red.subtlest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.red.subtlest."
        },
        "value": "#872821",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.red.subtlest."
            },
            "value": "Red850"
        },
        "name": "color.background.accent.red.subtlest.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "red",
            "subtlest",
            "pressed"
        ],
        "cleanName": "color.background.accent.red.subtlest.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for red backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#5D1F1A",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for red backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Red900"
        },
        "name": "color.background.accent.red.subtler.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "red",
            "subtler",
            "[default]"
        ],
        "cleanName": "color.background.accent.red.subtler"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.red.subtler."
        },
        "value": "#872821",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.red.subtler."
            },
            "value": "Red850"
        },
        "name": "color.background.accent.red.subtler.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "red",
            "subtler",
            "hovered"
        ],
        "cleanName": "color.background.accent.red.subtler.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.red.subtler."
        },
        "value": "#AE2E24",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.red.subtler."
            },
            "value": "Red800"
        },
        "name": "color.background.accent.red.subtler.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "red",
            "subtler",
            "pressed"
        ],
        "cleanName": "color.background.accent.red.subtler.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for vibrant red backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#AE2E24",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for vibrant red backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Red800"
        },
        "name": "color.background.accent.red.subtle.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "red",
            "subtle",
            "[default]"
        ],
        "cleanName": "color.background.accent.red.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.red.subtle."
        },
        "value": "#872821",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.red.subtle."
            },
            "value": "Red850"
        },
        "name": "color.background.accent.red.subtle.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "red",
            "subtle",
            "hovered"
        ],
        "cleanName": "color.background.accent.red.subtle.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.red.subtle."
        },
        "value": "#5D1F1A",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.red.subtle."
            },
            "value": "Red900"
        },
        "name": "color.background.accent.red.subtle.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "red",
            "subtle",
            "pressed"
        ],
        "cleanName": "color.background.accent.red.subtle.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for red backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
        },
        "value": "#F87168",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for red backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
            },
            "value": "Red400"
        },
        "name": "color.background.accent.red.bolder.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "red",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.background.accent.red.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.red.bolder."
        },
        "value": "#FD9891",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.red.bolder."
            },
            "value": "Red300"
        },
        "name": "color.background.accent.red.bolder.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "red",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.background.accent.red.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.red.bolder."
        },
        "value": "#FFB8B2",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.red.bolder."
            },
            "value": "Red250"
        },
        "name": "color.background.accent.red.bolder.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "red",
            "bolder",
            "pressed"
        ],
        "cleanName": "color.background.accent.red.bolder.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for orange backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
        },
        "value": "#3A2C1F",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for orange backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
            },
            "value": "Orange1000"
        },
        "name": "color.background.accent.orange.subtlest.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "orange",
            "subtlest",
            "[default]"
        ],
        "cleanName": "color.background.accent.orange.subtlest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.orange.subtlest."
        },
        "value": "#693200",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.orange.subtlest."
            },
            "value": "Orange900"
        },
        "name": "color.background.accent.orange.subtlest.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "orange",
            "subtlest",
            "hovered"
        ],
        "cleanName": "color.background.accent.orange.subtlest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.orange.subtlest."
        },
        "value": "#7A3B00",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.orange.subtlest."
            },
            "value": "Orange850"
        },
        "name": "color.background.accent.orange.subtlest.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "orange",
            "subtlest",
            "pressed"
        ],
        "cleanName": "color.background.accent.orange.subtlest.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for orange backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#693200",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for orange backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Orange900"
        },
        "name": "color.background.accent.orange.subtler.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "orange",
            "subtler",
            "[default]"
        ],
        "cleanName": "color.background.accent.orange.subtler"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.orange.subtler."
        },
        "value": "#7A3B00",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.orange.subtler."
            },
            "value": "Orange850"
        },
        "name": "color.background.accent.orange.subtler.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "orange",
            "subtler",
            "hovered"
        ],
        "cleanName": "color.background.accent.orange.subtler.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.orange.subtler."
        },
        "value": "#9E4C00",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.orange.subtler."
            },
            "value": "Orange800"
        },
        "name": "color.background.accent.orange.subtler.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "orange",
            "subtler",
            "pressed"
        ],
        "cleanName": "color.background.accent.orange.subtler.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for vibrant orange backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#9E4C00",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for vibrant orange backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Orange800"
        },
        "name": "color.background.accent.orange.subtle.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "orange",
            "subtle",
            "[default]"
        ],
        "cleanName": "color.background.accent.orange.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.orange.subtle."
        },
        "value": "#7A3B00",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.orange.subtle."
            },
            "value": "Orange850"
        },
        "name": "color.background.accent.orange.subtle.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "orange",
            "subtle",
            "hovered"
        ],
        "cleanName": "color.background.accent.orange.subtle.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.orange.subtle."
        },
        "value": "#693200",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.orange.subtle."
            },
            "value": "Orange900"
        },
        "name": "color.background.accent.orange.subtle.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "orange",
            "subtle",
            "pressed"
        ],
        "cleanName": "color.background.accent.orange.subtle.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for orange backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
        },
        "value": "#FCA700",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for orange backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
            },
            "value": "Orange400"
        },
        "name": "color.background.accent.orange.bolder.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "orange",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.background.accent.orange.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.orange.bolder."
        },
        "value": "#FBC828",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.orange.bolder."
            },
            "value": "Orange300"
        },
        "name": "color.background.accent.orange.bolder.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "orange",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.background.accent.orange.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.orange.bolder."
        },
        "value": "#FBD779",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.orange.bolder."
            },
            "value": "Orange250"
        },
        "name": "color.background.accent.orange.bolder.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "orange",
            "bolder",
            "pressed"
        ],
        "cleanName": "color.background.accent.orange.bolder.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for yellow backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
        },
        "value": "#332E1B",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for yellow backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
            },
            "value": "Yellow1000"
        },
        "name": "color.background.accent.yellow.subtlest.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "yellow",
            "subtlest",
            "[default]"
        ],
        "cleanName": "color.background.accent.yellow.subtlest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.yellow.subtlest."
        },
        "value": "#533F04",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.yellow.subtlest."
            },
            "value": "Yellow900"
        },
        "name": "color.background.accent.yellow.subtlest.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "yellow",
            "subtlest",
            "hovered"
        ],
        "cleanName": "color.background.accent.yellow.subtlest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.yellow.subtlest."
        },
        "value": "#614A05",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.yellow.subtlest."
            },
            "value": "Yellow850"
        },
        "name": "color.background.accent.yellow.subtlest.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "yellow",
            "subtlest",
            "pressed"
        ],
        "cleanName": "color.background.accent.yellow.subtlest.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for yellow backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#533F04",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for yellow backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Yellow900"
        },
        "name": "color.background.accent.yellow.subtler.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "yellow",
            "subtler",
            "[default]"
        ],
        "cleanName": "color.background.accent.yellow.subtler"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.yellow.subtler."
        },
        "value": "#614A05",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.yellow.subtler."
            },
            "value": "Yellow850"
        },
        "name": "color.background.accent.yellow.subtler.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "yellow",
            "subtler",
            "hovered"
        ],
        "cleanName": "color.background.accent.yellow.subtler.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.yellow.subtler."
        },
        "value": "#7F5F01",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.yellow.subtler."
            },
            "value": "Yellow800"
        },
        "name": "color.background.accent.yellow.subtler.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "yellow",
            "subtler",
            "pressed"
        ],
        "cleanName": "color.background.accent.yellow.subtler.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for vibrant yellow backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#7F5F01",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for vibrant yellow backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Yellow800"
        },
        "name": "color.background.accent.yellow.subtle.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "yellow",
            "subtle",
            "[default]"
        ],
        "cleanName": "color.background.accent.yellow.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.yellow.subtle."
        },
        "value": "#614A05",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.yellow.subtle."
            },
            "value": "Yellow850"
        },
        "name": "color.background.accent.yellow.subtle.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "yellow",
            "subtle",
            "hovered"
        ],
        "cleanName": "color.background.accent.yellow.subtle.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.yellow.subtle."
        },
        "value": "#533F04",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.yellow.subtle."
            },
            "value": "Yellow900"
        },
        "name": "color.background.accent.yellow.subtle.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "yellow",
            "subtle",
            "pressed"
        ],
        "cleanName": "color.background.accent.yellow.subtle.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for yellow backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
        },
        "value": "#DDB30E",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for yellow backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
            },
            "value": "Yellow400"
        },
        "name": "color.background.accent.yellow.bolder.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "yellow",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.background.accent.yellow.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.yellow.bolder."
        },
        "value": "#EED12B",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.yellow.bolder."
            },
            "value": "Yellow300"
        },
        "name": "color.background.accent.yellow.bolder.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "yellow",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.background.accent.yellow.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.yellow.bolder."
        },
        "value": "#EFDD4E",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.yellow.bolder."
            },
            "value": "Yellow250"
        },
        "name": "color.background.accent.yellow.bolder.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "yellow",
            "bolder",
            "pressed"
        ],
        "cleanName": "color.background.accent.yellow.bolder.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for green backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
        },
        "value": "#1C3329",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for green backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
            },
            "value": "Green1000"
        },
        "name": "color.background.accent.green.subtlest.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "green",
            "subtlest",
            "[default]"
        ],
        "cleanName": "color.background.accent.green.subtlest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.green.subtlest."
        },
        "value": "#164B35",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.green.subtlest."
            },
            "value": "Green900"
        },
        "name": "color.background.accent.green.subtlest.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "green",
            "subtlest",
            "hovered"
        ],
        "cleanName": "color.background.accent.green.subtlest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.green.subtlest."
        },
        "value": "#19573D",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.green.subtlest."
            },
            "value": "Green850"
        },
        "name": "color.background.accent.green.subtlest.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "green",
            "subtlest",
            "pressed"
        ],
        "cleanName": "color.background.accent.green.subtlest.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for green backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#164B35",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for green backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Green900"
        },
        "name": "color.background.accent.green.subtler.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "green",
            "subtler",
            "[default]"
        ],
        "cleanName": "color.background.accent.green.subtler"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.green.subtler."
        },
        "value": "#19573D",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.green.subtler."
            },
            "value": "Green850"
        },
        "name": "color.background.accent.green.subtler.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "green",
            "subtler",
            "hovered"
        ],
        "cleanName": "color.background.accent.green.subtler.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.green.subtler."
        },
        "value": "#216E4E",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.green.subtler."
            },
            "value": "Green800"
        },
        "name": "color.background.accent.green.subtler.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "green",
            "subtler",
            "pressed"
        ],
        "cleanName": "color.background.accent.green.subtler.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for vibrant green backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#216E4E",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for vibrant green backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Green800"
        },
        "name": "color.background.accent.green.subtle.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "green",
            "subtle",
            "[default]"
        ],
        "cleanName": "color.background.accent.green.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.green.subtle."
        },
        "value": "#19573D",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.green.subtle."
            },
            "value": "Green850"
        },
        "name": "color.background.accent.green.subtle.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "green",
            "subtle",
            "hovered"
        ],
        "cleanName": "color.background.accent.green.subtle.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.green.subtle."
        },
        "value": "#164B35",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.green.subtle."
            },
            "value": "Green900"
        },
        "name": "color.background.accent.green.subtle.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "green",
            "subtle",
            "pressed"
        ],
        "cleanName": "color.background.accent.green.subtle.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for green backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
        },
        "value": "#4BCE97",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for green backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
            },
            "value": "Green400"
        },
        "name": "color.background.accent.green.bolder.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "green",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.background.accent.green.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.green.bolder."
        },
        "value": "#7EE2B8",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.green.bolder."
            },
            "value": "Green300"
        },
        "name": "color.background.accent.green.bolder.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "green",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.background.accent.green.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.green.bolder."
        },
        "value": "#97EDC9",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.green.bolder."
            },
            "value": "Green250"
        },
        "name": "color.background.accent.green.bolder.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "green",
            "bolder",
            "pressed"
        ],
        "cleanName": "color.background.accent.green.bolder.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for teal backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
        },
        "value": "#1E3137",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for teal backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
            },
            "value": "Teal1000"
        },
        "name": "color.background.accent.teal.subtlest.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "teal",
            "subtlest",
            "[default]"
        ],
        "cleanName": "color.background.accent.teal.subtlest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.teal.subtlest."
        },
        "value": "#164555",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.teal.subtlest."
            },
            "value": "Teal900"
        },
        "name": "color.background.accent.teal.subtlest.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "teal",
            "subtlest",
            "hovered"
        ],
        "cleanName": "color.background.accent.teal.subtlest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.teal.subtlest."
        },
        "value": "#1A5265",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.teal.subtlest."
            },
            "value": "Teal850"
        },
        "name": "color.background.accent.teal.subtlest.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "teal",
            "subtlest",
            "pressed"
        ],
        "cleanName": "color.background.accent.teal.subtlest.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for teal backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#164555",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for teal backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Teal900"
        },
        "name": "color.background.accent.teal.subtler.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "teal",
            "subtler",
            "[default]"
        ],
        "cleanName": "color.background.accent.teal.subtler"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.teal.subtler."
        },
        "value": "#1A5265",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.teal.subtler."
            },
            "value": "Teal850"
        },
        "name": "color.background.accent.teal.subtler.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "teal",
            "subtler",
            "hovered"
        ],
        "cleanName": "color.background.accent.teal.subtler.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.teal.subtler."
        },
        "value": "#206A83",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.teal.subtler."
            },
            "value": "Teal800"
        },
        "name": "color.background.accent.teal.subtler.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "teal",
            "subtler",
            "pressed"
        ],
        "cleanName": "color.background.accent.teal.subtler.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for vibrant teal backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#206A83",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for vibrant teal backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Teal800"
        },
        "name": "color.background.accent.teal.subtle.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "teal",
            "subtle",
            "[default]"
        ],
        "cleanName": "color.background.accent.teal.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.teal.subtle."
        },
        "value": "#1A5265",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.teal.subtle."
            },
            "value": "Teal850"
        },
        "name": "color.background.accent.teal.subtle.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "teal",
            "subtle",
            "hovered"
        ],
        "cleanName": "color.background.accent.teal.subtle.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.teal.subtle."
        },
        "value": "#164555",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.teal.subtle."
            },
            "value": "Teal900"
        },
        "name": "color.background.accent.teal.subtle.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "teal",
            "subtle",
            "pressed"
        ],
        "cleanName": "color.background.accent.teal.subtle.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for teal backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
        },
        "value": "#6CC3E0",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for teal backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
            },
            "value": "Teal400"
        },
        "name": "color.background.accent.teal.bolder.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "teal",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.background.accent.teal.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.teal.bolder."
        },
        "value": "#9DD9EE",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.teal.bolder."
            },
            "value": "Teal300"
        },
        "name": "color.background.accent.teal.bolder.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "teal",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.background.accent.teal.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.teal.bolder."
        },
        "value": "#B1E4F7",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.teal.bolder."
            },
            "value": "Teal250"
        },
        "name": "color.background.accent.teal.bolder.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "teal",
            "bolder",
            "pressed"
        ],
        "cleanName": "color.background.accent.teal.bolder.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for blue backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
        },
        "value": "#1C2B42",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for blue backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
            },
            "value": "Blue1000"
        },
        "name": "color.background.accent.blue.subtlest.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "blue",
            "subtlest",
            "[default]"
        ],
        "cleanName": "color.background.accent.blue.subtlest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.blue.subtlest."
        },
        "value": "#123263",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.blue.subtlest."
            },
            "value": "Blue900"
        },
        "name": "color.background.accent.blue.subtlest.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "blue",
            "subtlest",
            "hovered"
        ],
        "cleanName": "color.background.accent.blue.subtlest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.blue.subtlest."
        },
        "value": "#144794",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.blue.subtlest."
            },
            "value": "Blue850"
        },
        "name": "color.background.accent.blue.subtlest.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "blue",
            "subtlest",
            "pressed"
        ],
        "cleanName": "color.background.accent.blue.subtlest.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for blue backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#123263",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for blue backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Blue900"
        },
        "name": "color.background.accent.blue.subtler.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "blue",
            "subtler",
            "[default]"
        ],
        "cleanName": "color.background.accent.blue.subtler"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.blue.subtler."
        },
        "value": "#144794",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.blue.subtler."
            },
            "value": "Blue850"
        },
        "name": "color.background.accent.blue.subtler.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "blue",
            "subtler",
            "hovered"
        ],
        "cleanName": "color.background.accent.blue.subtler.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.blue.subtler."
        },
        "value": "#1558BC",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.blue.subtler."
            },
            "value": "Blue800"
        },
        "name": "color.background.accent.blue.subtler.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "blue",
            "subtler",
            "pressed"
        ],
        "cleanName": "color.background.accent.blue.subtler.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for vibrant blue backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#1558BC",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for vibrant blue backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Blue800"
        },
        "name": "color.background.accent.blue.subtle.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "blue",
            "subtle",
            "[default]"
        ],
        "cleanName": "color.background.accent.blue.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.blue.subtle."
        },
        "value": "#144794",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.blue.subtle."
            },
            "value": "Blue850"
        },
        "name": "color.background.accent.blue.subtle.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "blue",
            "subtle",
            "hovered"
        ],
        "cleanName": "color.background.accent.blue.subtle.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.blue.subtle."
        },
        "value": "#123263",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.blue.subtle."
            },
            "value": "Blue900"
        },
        "name": "color.background.accent.blue.subtle.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "blue",
            "subtle",
            "pressed"
        ],
        "cleanName": "color.background.accent.blue.subtle.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for blue backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
        },
        "value": "#669DF1",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for blue backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
            },
            "value": "Blue400"
        },
        "name": "color.background.accent.blue.bolder.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "blue",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.background.accent.blue.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.blue.bolder."
        },
        "value": "#8FB8F6",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.blue.bolder."
            },
            "value": "Blue300"
        },
        "name": "color.background.accent.blue.bolder.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "blue",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.background.accent.blue.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.blue.bolder."
        },
        "value": "#ADCBFB",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.blue.bolder."
            },
            "value": "Blue250"
        },
        "name": "color.background.accent.blue.bolder.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "blue",
            "bolder",
            "pressed"
        ],
        "cleanName": "color.background.accent.blue.bolder.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for purple backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
        },
        "value": "#35243F",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for purple backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
            },
            "value": "Purple1000"
        },
        "name": "color.background.accent.purple.subtlest.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "purple",
            "subtlest",
            "[default]"
        ],
        "cleanName": "color.background.accent.purple.subtlest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.purple.subtlest."
        },
        "value": "#48245D",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.purple.subtlest."
            },
            "value": "Purple900"
        },
        "name": "color.background.accent.purple.subtlest.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "purple",
            "subtlest",
            "hovered"
        ],
        "cleanName": "color.background.accent.purple.subtlest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.purple.subtlest."
        },
        "value": "#673286",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.purple.subtlest."
            },
            "value": "Purple850"
        },
        "name": "color.background.accent.purple.subtlest.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "purple",
            "subtlest",
            "pressed"
        ],
        "cleanName": "color.background.accent.purple.subtlest.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for purple backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#48245D",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for purple backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Purple900"
        },
        "name": "color.background.accent.purple.subtler.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "purple",
            "subtler",
            "[default]"
        ],
        "cleanName": "color.background.accent.purple.subtler"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.purple.subtler."
        },
        "value": "#673286",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.purple.subtler."
            },
            "value": "Purple850"
        },
        "name": "color.background.accent.purple.subtler.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "purple",
            "subtler",
            "hovered"
        ],
        "cleanName": "color.background.accent.purple.subtler.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.purple.subtler."
        },
        "value": "#803FA5",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.purple.subtler."
            },
            "value": "Purple800"
        },
        "name": "color.background.accent.purple.subtler.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "purple",
            "subtler",
            "pressed"
        ],
        "cleanName": "color.background.accent.purple.subtler.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for vibrant purple backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#803FA5",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for vibrant purple backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Purple800"
        },
        "name": "color.background.accent.purple.subtle.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "purple",
            "subtle",
            "[default]"
        ],
        "cleanName": "color.background.accent.purple.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.purple.subtle."
        },
        "value": "#673286",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.purple.subtle."
            },
            "value": "Purple850"
        },
        "name": "color.background.accent.purple.subtle.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "purple",
            "subtle",
            "hovered"
        ],
        "cleanName": "color.background.accent.purple.subtle.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.purple.subtle."
        },
        "value": "#48245D",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.purple.subtle."
            },
            "value": "Purple900"
        },
        "name": "color.background.accent.purple.subtle.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "purple",
            "subtle",
            "pressed"
        ],
        "cleanName": "color.background.accent.purple.subtle.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for purple backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
        },
        "value": "#C97CF4",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for purple backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
            },
            "value": "Purple400"
        },
        "name": "color.background.accent.purple.bolder.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "purple",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.background.accent.purple.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.purple.bolder."
        },
        "value": "#D8A0F7",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.purple.bolder."
            },
            "value": "Purple300"
        },
        "name": "color.background.accent.purple.bolder.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "purple",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.background.accent.purple.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.purple.bolder."
        },
        "value": "#E3BDFA",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.purple.bolder."
            },
            "value": "Purple250"
        },
        "name": "color.background.accent.purple.bolder.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "purple",
            "bolder",
            "pressed"
        ],
        "cleanName": "color.background.accent.purple.bolder.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for magenta backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
        },
        "value": "#3D2232",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for magenta backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
            },
            "value": "Magenta1000"
        },
        "name": "color.background.accent.magenta.subtlest.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "magenta",
            "subtlest",
            "[default]"
        ],
        "cleanName": "color.background.accent.magenta.subtlest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.magenta.subtlest."
        },
        "value": "#50253F",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.magenta.subtlest."
            },
            "value": "Magenta900"
        },
        "name": "color.background.accent.magenta.subtlest.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "magenta",
            "subtlest",
            "hovered"
        ],
        "cleanName": "color.background.accent.magenta.subtlest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.magenta.subtlest."
        },
        "value": "#77325B",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.magenta.subtlest."
            },
            "value": "Magenta850"
        },
        "name": "color.background.accent.magenta.subtlest.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "magenta",
            "subtlest",
            "pressed"
        ],
        "cleanName": "color.background.accent.magenta.subtlest.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for magenta backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#50253F",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for magenta backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Magenta900"
        },
        "name": "color.background.accent.magenta.subtler.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "magenta",
            "subtler",
            "[default]"
        ],
        "cleanName": "color.background.accent.magenta.subtler"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.magenta.subtler."
        },
        "value": "#77325B",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.magenta.subtler."
            },
            "value": "Magenta850"
        },
        "name": "color.background.accent.magenta.subtler.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "magenta",
            "subtler",
            "hovered"
        ],
        "cleanName": "color.background.accent.magenta.subtler.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.magenta.subtler."
        },
        "value": "#943D73",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.magenta.subtler."
            },
            "value": "Magenta800"
        },
        "name": "color.background.accent.magenta.subtler.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "magenta",
            "subtler",
            "pressed"
        ],
        "cleanName": "color.background.accent.magenta.subtler.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for vibrant magenta backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#943D73",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for vibrant magenta backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Magenta800"
        },
        "name": "color.background.accent.magenta.subtle.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "magenta",
            "subtle",
            "[default]"
        ],
        "cleanName": "color.background.accent.magenta.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.magenta.subtle."
        },
        "value": "#77325B",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.magenta.subtle."
            },
            "value": "Magenta850"
        },
        "name": "color.background.accent.magenta.subtle.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "magenta",
            "subtle",
            "hovered"
        ],
        "cleanName": "color.background.accent.magenta.subtle.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.magenta.subtle."
        },
        "value": "#50253F",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.magenta.subtle."
            },
            "value": "Magenta900"
        },
        "name": "color.background.accent.magenta.subtle.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "magenta",
            "subtle",
            "pressed"
        ],
        "cleanName": "color.background.accent.magenta.subtle.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for magenta backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
        },
        "value": "#E774BB",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for magenta backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
            },
            "value": "Magenta400"
        },
        "name": "color.background.accent.magenta.bolder.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "magenta",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.background.accent.magenta.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.magenta.bolder."
        },
        "value": "#F797D2",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.magenta.bolder."
            },
            "value": "Magenta300"
        },
        "name": "color.background.accent.magenta.bolder.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "magenta",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.background.accent.magenta.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.magenta.bolder."
        },
        "value": "#FCB6E1",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.magenta.bolder."
            },
            "value": "Magenta250"
        },
        "name": "color.background.accent.magenta.bolder.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "magenta",
            "bolder",
            "pressed"
        ],
        "cleanName": "color.background.accent.magenta.bolder.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for gray backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
        },
        "value": "#303134",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for gray backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
            },
            "value": "DarkNeutral300"
        },
        "name": "color.background.accent.gray.subtlest.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "gray",
            "subtlest",
            "[default]"
        ],
        "cleanName": "color.background.accent.gray.subtlest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.gray.subtlest."
        },
        "value": "#3D3F43",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.gray.subtlest."
            },
            "value": "DarkNeutral350"
        },
        "name": "color.background.accent.gray.subtlest.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "gray",
            "subtlest",
            "hovered"
        ],
        "cleanName": "color.background.accent.gray.subtlest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.gray.subtlest."
        },
        "value": "#4B4D51",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.gray.subtlest."
            },
            "value": "DarkNeutral400"
        },
        "name": "color.background.accent.gray.subtlest.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "gray",
            "subtlest",
            "pressed"
        ],
        "cleanName": "color.background.accent.gray.subtlest.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for gray backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#4B4D51",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for gray backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "DarkNeutral400"
        },
        "name": "color.background.accent.gray.subtler.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "gray",
            "subtler",
            "[default]"
        ],
        "cleanName": "color.background.accent.gray.subtler"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.gray.subtler."
        },
        "value": "#63666B",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.gray.subtler."
            },
            "value": "DarkNeutral500"
        },
        "name": "color.background.accent.gray.subtler.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "gray",
            "subtler",
            "hovered"
        ],
        "cleanName": "color.background.accent.gray.subtler.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.gray.subtler."
        },
        "value": "#7E8188",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.gray.subtler."
            },
            "value": "DarkNeutral600"
        },
        "name": "color.background.accent.gray.subtler.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "gray",
            "subtler",
            "pressed"
        ],
        "cleanName": "color.background.accent.gray.subtler.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for vibrant gray backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#63666B",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for vibrant gray backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "DarkNeutral500"
        },
        "name": "color.background.accent.gray.subtle.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "gray",
            "subtle",
            "[default]"
        ],
        "cleanName": "color.background.accent.gray.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.gray.subtle."
        },
        "value": "#4B4D51",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.gray.subtle."
            },
            "value": "DarkNeutral400"
        },
        "name": "color.background.accent.gray.subtle.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "gray",
            "subtle",
            "hovered"
        ],
        "cleanName": "color.background.accent.gray.subtle.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.gray.subtle."
        },
        "value": "#3D3F43",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.gray.subtle."
            },
            "value": "DarkNeutral350"
        },
        "name": "color.background.accent.gray.subtle.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "gray",
            "subtle",
            "pressed"
        ],
        "cleanName": "color.background.accent.gray.subtle.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for gray backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
        },
        "value": "#96999E",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for gray backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
            },
            "value": "DarkNeutral700"
        },
        "name": "color.background.accent.gray.bolder.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "gray",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.background.accent.gray.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.gray.bolder."
        },
        "value": "#A9ABAF",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.gray.bolder."
            },
            "value": "DarkNeutral800"
        },
        "name": "color.background.accent.gray.bolder.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "gray",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.background.accent.gray.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.gray.subtlest."
        },
        "value": "#BFC1C4",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.gray.subtlest."
            },
            "value": "DarkNeutral900"
        },
        "name": "color.background.accent.gray.bolder.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "gray",
            "bolder",
            "pressed"
        ],
        "cleanName": "color.background.accent.gray.bolder.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for highlighted added code lines."
        },
        "value": "#1C3329",
        "filePath": "schema/themes/atlassian-dark/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for highlighted added code lines."
            },
            "value": "Green1000"
        },
        "name": "color.background.code.added.highlight",
        "path": [
            "color",
            "background",
            "code",
            "added",
            "highlight"
        ],
        "cleanName": "color.background.code.added.highlight"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for added code lines."
        },
        "value": "#164B35B2",
        "filePath": "schema/themes/atlassian-dark/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for added code lines."
            },
            "value": "Green900A70"
        },
        "name": "color.background.code.added.line",
        "path": [
            "color",
            "background",
            "code",
            "added",
            "line"
        ],
        "cleanName": "color.background.code.added.line"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for the default background of code blocks and code diffs."
        },
        "value": "#1F1F21",
        "filePath": "schema/themes/atlassian-dark/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for the default background of code blocks and code diffs."
            },
            "value": "DarkNeutral100"
        },
        "name": "color.background.code.default",
        "path": [
            "color",
            "background",
            "code",
            "default"
        ],
        "cleanName": "color.background.code.default"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for the background of code gutters."
        },
        "value": "#242528",
        "filePath": "schema/themes/atlassian-dark/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for the background of code gutters."
            },
            "value": "DarkNeutral200"
        },
        "name": "color.background.code.gutter",
        "path": [
            "color",
            "background",
            "code",
            "gutter"
        ],
        "cleanName": "color.background.code.gutter"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for highlighted unchanged code lines."
        },
        "value": "#242528",
        "filePath": "schema/themes/atlassian-dark/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for highlighted unchanged code lines."
            },
            "value": "DarkNeutral200"
        },
        "name": "color.background.code.highlight",
        "path": [
            "color",
            "background",
            "code",
            "highlight"
        ],
        "cleanName": "color.background.code.highlight"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for highlighted removed code lines."
        },
        "value": "#42221F",
        "filePath": "schema/themes/atlassian-dark/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for highlighted removed code lines."
            },
            "value": "Red1000"
        },
        "name": "color.background.code.removed.highlight",
        "path": [
            "color",
            "background",
            "code",
            "removed",
            "highlight"
        ],
        "cleanName": "color.background.code.removed.highlight"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for removed code lines."
        },
        "value": "#5D1F1AB2",
        "filePath": "schema/themes/atlassian-dark/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for removed code lines."
            },
            "value": "Red900A70"
        },
        "name": "color.background.code.removed.line",
        "path": [
            "color",
            "background",
            "code",
            "removed",
            "line"
        ],
        "cleanName": "color.background.code.removed.line"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.0.15",
            "description": "Use for backgrounds of elements in a disabled state."
        },
        "value": "#E3E4F21F",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.0.15",
                "description": "Use for backgrounds of elements in a disabled state."
            },
            "value": "DarkNeutral300A"
        },
        "name": "color.background.disabled",
        "path": [
            "color",
            "background",
            "disabled"
        ],
        "cleanName": "color.background.disabled"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for background of form UI elements, such as text fields, checkboxes, and radio buttons."
        },
        "value": "#242528",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for background of form UI elements, such as text fields, checkboxes, and radio buttons."
            },
            "value": "DarkNeutral200"
        },
        "name": "color.background.input.[default]",
        "path": [
            "color",
            "background",
            "input",
            "[default]"
        ],
        "cleanName": "color.background.input"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Hovered state for color.background.input"
        },
        "value": "#2B2C2F",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Hovered state for color.background.input"
            },
            "value": "DarkNeutral250"
        },
        "name": "color.background.input.hovered",
        "path": [
            "color",
            "background",
            "input",
            "hovered"
        ],
        "cleanName": "color.background.input.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Pressed state for color.background.input"
        },
        "value": "#242528",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Pressed state for color.background.input"
            },
            "value": "DarkNeutral200"
        },
        "name": "color.background.input.pressed",
        "path": [
            "color",
            "background",
            "input",
            "pressed"
        ],
        "cleanName": "color.background.input.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.8.3",
            "description": "Use for backgrounds of elements on a bold background, such as in the buttons on spotlight cards."
        },
        "value": "#FFFFFF29",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.8.3",
                "description": "Use for backgrounds of elements on a bold background, such as in the buttons on spotlight cards."
            },
            "value": "#FFFFFF29"
        },
        "name": "color.background.inverse.subtle.[default]",
        "path": [
            "color",
            "background",
            "inverse",
            "subtle",
            "[default]"
        ],
        "cleanName": "color.background.inverse.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.8.3",
            "description": "Use for the hovered state of color.background.inverse.subtle"
        },
        "value": "#FFFFFF3D",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.8.3",
                "description": "Use for the hovered state of color.background.inverse.subtle"
            },
            "value": "#FFFFFF3D"
        },
        "name": "color.background.inverse.subtle.hovered",
        "path": [
            "color",
            "background",
            "inverse",
            "subtle",
            "hovered"
        ],
        "cleanName": "color.background.inverse.subtle.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.8.3",
            "description": "Use for the pressed state of color.background.inverse.subtle"
        },
        "value": "#FFFFFF52",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.8.3",
                "description": "Use for the pressed state of color.background.inverse.subtle"
            },
            "value": "#FFFFFF52"
        },
        "name": "color.background.inverse.subtle.pressed",
        "path": [
            "color",
            "background",
            "inverse",
            "subtle",
            "pressed"
        ],
        "cleanName": "color.background.inverse.subtle.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "The default background for neutral elements, such as default buttons."
        },
        "value": "#CECED912",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "The default background for neutral elements, such as default buttons."
            },
            "value": "DarkNeutral200A"
        },
        "name": "color.background.neutral.[default].[default]",
        "path": [
            "color",
            "background",
            "neutral",
            "[default]",
            "[default]"
        ],
        "cleanName": "color.background.neutral"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Hovered state for color.background.neutral"
        },
        "value": "#E3E4F21F",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Hovered state for color.background.neutral"
            },
            "value": "DarkNeutral300A"
        },
        "name": "color.background.neutral.[default].hovered",
        "path": [
            "color",
            "background",
            "neutral",
            "[default]",
            "hovered"
        ],
        "cleanName": "color.background.neutral.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Pressed state for color.background.neutral"
        },
        "value": "#E5E9F640",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Pressed state for color.background.neutral"
            },
            "value": "DarkNeutral400A"
        },
        "name": "color.background.neutral.[default].pressed",
        "path": [
            "color",
            "background",
            "neutral",
            "[default]",
            "pressed"
        ],
        "cleanName": "color.background.neutral.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for the background of elements that appear to have no background in a resting state, such as subtle buttons and menu items."
        },
        "value": "#00000000",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for the background of elements that appear to have no background in a resting state, such as subtle buttons and menu items."
            },
            "value": "transparent"
        },
        "name": "color.background.neutral.subtle.[default]",
        "path": [
            "color",
            "background",
            "neutral",
            "subtle",
            "[default]"
        ],
        "cleanName": "color.background.neutral.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Hovered state for color.background.neutral.subtle"
        },
        "value": "#CECED912",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Hovered state for color.background.neutral.subtle"
            },
            "value": "DarkNeutral200A"
        },
        "name": "color.background.neutral.subtle.hovered",
        "path": [
            "color",
            "background",
            "neutral",
            "subtle",
            "hovered"
        ],
        "cleanName": "color.background.neutral.subtle.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Pressed state for color.background.neutral.subtle"
        },
        "value": "#E3E4F21F",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Pressed state for color.background.neutral.subtle"
            },
            "value": "DarkNeutral300A"
        },
        "name": "color.background.neutral.subtle.pressed",
        "path": [
            "color",
            "background",
            "neutral",
            "subtle",
            "pressed"
        ],
        "cleanName": "color.background.neutral.subtle.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "A vibrant background option for neutral UI elements, such as announcement banners."
        },
        "value": "#CECFD2",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "A vibrant background option for neutral UI elements, such as announcement banners."
            },
            "value": "DarkNeutral1000"
        },
        "name": "color.background.neutral.bold.[default]",
        "path": [
            "color",
            "background",
            "neutral",
            "bold",
            "[default]"
        ],
        "cleanName": "color.background.neutral.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Hovered state of color.background.neutral.bold"
        },
        "value": "#BFC1C4",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Hovered state of color.background.neutral.bold"
            },
            "value": "DarkNeutral900"
        },
        "name": "color.background.neutral.bold.hovered",
        "path": [
            "color",
            "background",
            "neutral",
            "bold",
            "hovered"
        ],
        "cleanName": "color.background.neutral.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Pressed state of color.background.neutral.bold"
        },
        "value": "#A9ABAF",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Pressed state of color.background.neutral.bold"
            },
            "value": "DarkNeutral800"
        },
        "name": "color.background.neutral.bold.pressed",
        "path": [
            "color",
            "background",
            "neutral",
            "bold",
            "pressed"
        ],
        "cleanName": "color.background.neutral.bold.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.2",
            "description": "Use for the background of an element that communicates selection, such as a selected navigation item, or the opened state of a dropdown trigger. Use color.background.selected.hovered or color.background.selected.pressed when interacting with a selected element. Selection is distinct from keyboard focus and hover alone."
        },
        "value": "#1C2B42",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.2",
                "description": "Use for the background of an element that communicates selection, such as a selected navigation item, or the opened state of a dropdown trigger. Use color.background.selected.hovered or color.background.selected.pressed when interacting with a selected element. Selection is distinct from keyboard focus and hover alone."
            },
            "value": "Blue1000"
        },
        "name": "color.background.selected.[default].[default]",
        "path": [
            "color",
            "background",
            "selected",
            "[default]",
            "[default]"
        ],
        "cleanName": "color.background.selected"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.2",
            "description": "Use for the background of an element that is selected and hovered. This preserves selection while showing pointer hover; do not use for an unselected element or keyboard focus alone."
        },
        "value": "#123263",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.2",
                "description": "Use for the background of an element that is selected and hovered. This preserves selection while showing pointer hover; do not use for an unselected element or keyboard focus alone."
            },
            "value": "Blue900"
        },
        "name": "color.background.selected.[default].hovered",
        "path": [
            "color",
            "background",
            "selected",
            "[default]",
            "hovered"
        ],
        "cleanName": "color.background.selected.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.2",
            "description": "Use for the background of an element that is selected and being pressed. Return to color.background.selected or color.background.selected.hovered when the press ends and the element remains selected. Do not use for an unselected element or keyboard focus alone."
        },
        "value": "#1558BC",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.2",
                "description": "Use for the background of an element that is selected and being pressed. Return to color.background.selected or color.background.selected.hovered when the press ends and the element remains selected. Do not use for an unselected element or keyboard focus alone."
            },
            "value": "Blue800"
        },
        "name": "color.background.selected.[default].pressed",
        "path": [
            "color",
            "background",
            "selected",
            "[default]",
            "pressed"
        ],
        "cleanName": "color.background.selected.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.2",
            "description": "Use for the bold background of selected controls, such as checked checkboxes and selected radio buttons. Pair with color.text.inverse or color.icon.inverse for foreground content. Do not use for primary actions or keyboard focus alone."
        },
        "value": "#669DF1",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.2",
                "description": "Use for the bold background of selected controls, such as checked checkboxes and selected radio buttons. Pair with color.text.inverse or color.icon.inverse for foreground content. Do not use for primary actions or keyboard focus alone."
            },
            "value": "Blue400"
        },
        "name": "color.background.selected.bold.[default]",
        "path": [
            "color",
            "background",
            "selected",
            "bold",
            "[default]"
        ],
        "cleanName": "color.background.selected.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.2",
            "description": "Use for the background of a selected control that uses color.background.selected.bold while it is hovered, such as a checked checkbox. Pair with color.text.inverse or color.icon.inverse for foreground content. Do not use for an unselected control or keyboard focus alone."
        },
        "value": "#8FB8F6",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.2",
                "description": "Use for the background of a selected control that uses color.background.selected.bold while it is hovered, such as a checked checkbox. Pair with color.text.inverse or color.icon.inverse for foreground content. Do not use for an unselected control or keyboard focus alone."
            },
            "value": "Blue300"
        },
        "name": "color.background.selected.bold.hovered",
        "path": [
            "color",
            "background",
            "selected",
            "bold",
            "hovered"
        ],
        "cleanName": "color.background.selected.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.2",
            "description": "Use for the background of a selected control that uses color.background.selected.bold while it is being pressed, such as a checked checkbox. Pair with color.text.inverse or color.icon.inverse for foreground content. Do not use for an unselected control or keyboard focus alone."
        },
        "value": "#CFE1FD",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.2",
                "description": "Use for the background of a selected control that uses color.background.selected.bold while it is being pressed, such as a checked checkbox. Pair with color.text.inverse or color.icon.inverse for foreground content. Do not use for an unselected control or keyboard focus alone."
            },
            "value": "Blue200"
        },
        "name": "color.background.selected.bold.pressed",
        "path": [
            "color",
            "background",
            "selected",
            "bold",
            "pressed"
        ],
        "cleanName": "color.background.selected.bold.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.13.0",
            "description": "Use for the background of elements used to reinforce our brand, but with less emphasis."
        },
        "value": "#1C2B42",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.13.0",
                "description": "Use for the background of elements used to reinforce our brand, but with less emphasis."
            },
            "value": "Blue1000"
        },
        "name": "color.background.brand.subtlest.[default]",
        "path": [
            "color",
            "background",
            "brand",
            "subtlest",
            "[default]"
        ],
        "cleanName": "color.background.brand.subtlest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.13.0",
            "description": "Hovered state of color.background.brand.subtlest."
        },
        "value": "#123263",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.13.0",
                "description": "Hovered state of color.background.brand.subtlest."
            },
            "value": "Blue900"
        },
        "name": "color.background.brand.subtlest.hovered",
        "path": [
            "color",
            "background",
            "brand",
            "subtlest",
            "hovered"
        ],
        "cleanName": "color.background.brand.subtlest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.13.0",
            "description": "Pressed state of color.background.brand.subtlest"
        },
        "value": "#144794",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.13.0",
                "description": "Pressed state of color.background.brand.subtlest"
            },
            "value": "Blue850"
        },
        "name": "color.background.brand.subtlest.pressed",
        "path": [
            "color",
            "background",
            "brand",
            "subtlest",
            "pressed"
        ],
        "cleanName": "color.background.brand.subtlest.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for the background of elements used to reinforce our brand, but with more emphasis."
        },
        "value": "#669DF1",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for the background of elements used to reinforce our brand, but with more emphasis."
            },
            "value": "Blue400"
        },
        "name": "color.background.brand.bold.[default]",
        "path": [
            "color",
            "background",
            "brand",
            "bold",
            "[default]"
        ],
        "cleanName": "color.background.brand.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Hovered state of color.background.brand.bold."
        },
        "value": "#8FB8F6",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Hovered state of color.background.brand.bold."
            },
            "value": "Blue300"
        },
        "name": "color.background.brand.bold.hovered",
        "path": [
            "color",
            "background",
            "brand",
            "bold",
            "hovered"
        ],
        "cleanName": "color.background.brand.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Pressed state of color.background.brand.bold."
        },
        "value": "#ADCBFB",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Pressed state of color.background.brand.bold."
            },
            "value": "Blue250"
        },
        "name": "color.background.brand.bold.pressed",
        "path": [
            "color",
            "background",
            "brand",
            "bold",
            "pressed"
        ],
        "cleanName": "color.background.brand.bold.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.13.0",
            "description": "Use for the background of elements used to reinforce our brand, that need to stand out a lot."
        },
        "value": "#E9F2FE",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.13.0",
                "description": "Use for the background of elements used to reinforce our brand, that need to stand out a lot."
            },
            "value": "Blue100"
        },
        "name": "color.background.brand.boldest.[default]",
        "path": [
            "color",
            "background",
            "brand",
            "boldest",
            "[default]"
        ],
        "cleanName": "color.background.brand.boldest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.13.0",
            "description": "Hovered state of color.background.brand.boldest."
        },
        "value": "#CFE1FD",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.13.0",
                "description": "Hovered state of color.background.brand.boldest."
            },
            "value": "Blue200"
        },
        "name": "color.background.brand.boldest.hovered",
        "path": [
            "color",
            "background",
            "brand",
            "boldest",
            "hovered"
        ],
        "cleanName": "color.background.brand.boldest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.13.0",
            "description": "Pressed state of color.background.brand.boldest."
        },
        "value": "#ADCBFB",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.13.0",
                "description": "Pressed state of color.background.brand.boldest."
            },
            "value": "Blue250"
        },
        "name": "color.background.brand.boldest.pressed",
        "path": [
            "color",
            "background",
            "brand",
            "boldest",
            "pressed"
        ],
        "cleanName": "color.background.brand.boldest.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for backgrounds communicating critical information, such in error section messages."
        },
        "value": "#42221F",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for backgrounds communicating critical information, such in error section messages."
            },
            "value": "Red1000"
        },
        "name": "color.background.danger.[default].[default]",
        "path": [
            "color",
            "background",
            "danger",
            "[default]",
            "[default]"
        ],
        "cleanName": "color.background.danger"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Hovered state for color.background.danger"
        },
        "value": "#5D1F1A",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Hovered state for color.background.danger"
            },
            "value": "Red900"
        },
        "name": "color.background.danger.[default].hovered",
        "path": [
            "color",
            "background",
            "danger",
            "[default]",
            "hovered"
        ],
        "cleanName": "color.background.danger.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Pressed state for color.background.danger"
        },
        "value": "#872821",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Pressed state for color.background.danger"
            },
            "value": "Red850"
        },
        "name": "color.background.danger.[default].pressed",
        "path": [
            "color",
            "background",
            "danger",
            "[default]",
            "pressed"
        ],
        "cleanName": "color.background.danger.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Use for backgrounds of danger lozenges and badges to ensure accessibility and desired visual appearance."
        },
        "value": "#5D1F1A",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Use for backgrounds of danger lozenges and badges to ensure accessibility and desired visual appearance."
            },
            "value": "Red900"
        },
        "name": "color.background.danger.subtler.[default]",
        "path": [
            "color",
            "background",
            "danger",
            "subtler",
            "[default]"
        ],
        "cleanName": "color.background.danger.subtler"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Hovered state of color.background.danger.subtler"
        },
        "value": "#872821",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Hovered state of color.background.danger.subtler"
            },
            "value": "Red850"
        },
        "name": "color.background.danger.subtler.hovered",
        "path": [
            "color",
            "background",
            "danger",
            "subtler",
            "hovered"
        ],
        "cleanName": "color.background.danger.subtler.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Pressed state of color.background.danger.subtler"
        },
        "value": "#AE2E24",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Pressed state of color.background.danger.subtler"
            },
            "value": "Red800"
        },
        "name": "color.background.danger.subtler.pressed",
        "path": [
            "color",
            "background",
            "danger",
            "subtler",
            "pressed"
        ],
        "cleanName": "color.background.danger.subtler.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Background colour for non-interactive elements communicating critical danger information (e.g. semantic badges, status pills, callout chips). Sits between subtler and bold in visual emphasis. Not for interactive surfaces \u2014 see color.background.danger.bold or color.background.danger.subtler for interactive states."
        },
        "value": "#AE2E24",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Background colour for non-interactive elements communicating critical danger information (e.g. semantic badges, status pills, callout chips). Sits between subtler and bold in visual emphasis. Not for interactive surfaces \u2014 see color.background.danger.bold or color.background.danger.subtler for interactive states."
            },
            "value": "Red800"
        },
        "name": "color.background.danger.subtle.[default]",
        "path": [
            "color",
            "background",
            "danger",
            "subtle",
            "[default]"
        ],
        "cleanName": "color.background.danger.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "A vibrant background option for communicating critical information, such as in danger buttons and error banners."
        },
        "value": "#F87168",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "A vibrant background option for communicating critical information, such as in danger buttons and error banners."
            },
            "value": "Red400"
        },
        "name": "color.background.danger.bold.[default]",
        "path": [
            "color",
            "background",
            "danger",
            "bold",
            "[default]"
        ],
        "cleanName": "color.background.danger.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Hovered state of color.background.danger.bold"
        },
        "value": "#FD9891",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Hovered state of color.background.danger.bold"
            },
            "value": "Red300"
        },
        "name": "color.background.danger.bold.hovered",
        "path": [
            "color",
            "background",
            "danger",
            "bold",
            "hovered"
        ],
        "cleanName": "color.background.danger.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Pressed state of color.background.danger.bold"
        },
        "value": "#FFB8B2",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Pressed state of color.background.danger.bold"
            },
            "value": "Red250"
        },
        "name": "color.background.danger.bold.pressed",
        "path": [
            "color",
            "background",
            "danger",
            "bold",
            "pressed"
        ],
        "cleanName": "color.background.danger.bold.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for backgrounds communicating caution, such as in warning section messages."
        },
        "value": "#3A2C1F",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for backgrounds communicating caution, such as in warning section messages."
            },
            "value": "Orange1000"
        },
        "name": "color.background.warning.[default].[default]",
        "path": [
            "color",
            "background",
            "warning",
            "[default]",
            "[default]"
        ],
        "cleanName": "color.background.warning"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Hovered state for color.background.warning"
        },
        "value": "#693200",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Hovered state for color.background.warning"
            },
            "value": "Orange900"
        },
        "name": "color.background.warning.[default].hovered",
        "path": [
            "color",
            "background",
            "warning",
            "[default]",
            "hovered"
        ],
        "cleanName": "color.background.warning.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Pressed state for color.background.warning"
        },
        "value": "#7A3B00",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Pressed state for color.background.warning"
            },
            "value": "Orange850"
        },
        "name": "color.background.warning.[default].pressed",
        "path": [
            "color",
            "background",
            "warning",
            "[default]",
            "pressed"
        ],
        "cleanName": "color.background.warning.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Use for backgrounds of warning lozenges and badges to ensure accessibility and desired visual appearance."
        },
        "value": "#693200",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Use for backgrounds of warning lozenges and badges to ensure accessibility and desired visual appearance."
            },
            "value": "Orange900"
        },
        "name": "color.background.warning.subtler.[default]",
        "path": [
            "color",
            "background",
            "warning",
            "subtler",
            "[default]"
        ],
        "cleanName": "color.background.warning.subtler"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Hovered state of color.background.warning.subtler"
        },
        "value": "#7A3B00",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Hovered state of color.background.warning.subtler"
            },
            "value": "Orange850"
        },
        "name": "color.background.warning.subtler.hovered",
        "path": [
            "color",
            "background",
            "warning",
            "subtler",
            "hovered"
        ],
        "cleanName": "color.background.warning.subtler.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Pressed state of color.background.warning.subtler"
        },
        "value": "#9E4C00",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Pressed state of color.background.warning.subtler"
            },
            "value": "Orange800"
        },
        "name": "color.background.warning.subtler.pressed",
        "path": [
            "color",
            "background",
            "warning",
            "subtler",
            "pressed"
        ],
        "cleanName": "color.background.warning.subtler.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Background colour for non-interactive elements communicating caution (e.g. status pills, callout chips). Sits between subtler and bold in visual emphasis. Not for interactive surfaces \u2014 see color.background.warning.bold or color.background.warning.subtler for interactive states."
        },
        "value": "#9E4C00",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Background colour for non-interactive elements communicating caution (e.g. status pills, callout chips). Sits between subtler and bold in visual emphasis. Not for interactive surfaces \u2014 see color.background.warning.bold or color.background.warning.subtler for interactive states."
            },
            "value": "Orange800"
        },
        "name": "color.background.warning.subtle.[default]",
        "path": [
            "color",
            "background",
            "warning",
            "subtle",
            "[default]"
        ],
        "cleanName": "color.background.warning.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "A vibrant background option for communicating caution, such as in warning buttons and warning banners."
        },
        "value": "#FBC828",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "A vibrant background option for communicating caution, such as in warning buttons and warning banners."
            },
            "value": "Orange300"
        },
        "name": "color.background.warning.bold.[default]",
        "path": [
            "color",
            "background",
            "warning",
            "bold",
            "[default]"
        ],
        "cleanName": "color.background.warning.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Hovered state of color.background.warning.bold"
        },
        "value": "#FCA700",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Hovered state of color.background.warning.bold"
            },
            "value": "Orange400"
        },
        "name": "color.background.warning.bold.hovered",
        "path": [
            "color",
            "background",
            "warning",
            "bold",
            "hovered"
        ],
        "cleanName": "color.background.warning.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Pressed state of color.background.warning.bold"
        },
        "value": "#F68909",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Pressed state of color.background.warning.bold"
            },
            "value": "Orange500"
        },
        "name": "color.background.warning.bold.pressed",
        "path": [
            "color",
            "background",
            "warning",
            "bold",
            "pressed"
        ],
        "cleanName": "color.background.warning.bold.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for backgrounds communicating a favorable outcome, such as in success section messages."
        },
        "value": "#28311B",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for backgrounds communicating a favorable outcome, such as in success section messages."
            },
            "value": "Lime1000"
        },
        "name": "color.background.success.[default].[default]",
        "path": [
            "color",
            "background",
            "success",
            "[default]",
            "[default]"
        ],
        "cleanName": "color.background.success"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Hovered state for color.background.success"
        },
        "value": "#37471F",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Hovered state for color.background.success"
            },
            "value": "Lime900"
        },
        "name": "color.background.success.[default].hovered",
        "path": [
            "color",
            "background",
            "success",
            "[default]",
            "hovered"
        ],
        "cleanName": "color.background.success.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Pressed state for color.background.success"
        },
        "value": "#3F5224",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Pressed state for color.background.success"
            },
            "value": "Lime850"
        },
        "name": "color.background.success.[default].pressed",
        "path": [
            "color",
            "background",
            "success",
            "[default]",
            "pressed"
        ],
        "cleanName": "color.background.success.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Use for backgrounds of success lozenges and badges to ensure accessibility and desired visual appearance."
        },
        "value": "#37471F",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Use for backgrounds of success lozenges and badges to ensure accessibility and desired visual appearance."
            },
            "value": "Lime900"
        },
        "name": "color.background.success.subtler.[default]",
        "path": [
            "color",
            "background",
            "success",
            "subtler",
            "[default]"
        ],
        "cleanName": "color.background.success.subtler"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Hovered state of color.background.success.subtler"
        },
        "value": "#3F5224",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Hovered state of color.background.success.subtler"
            },
            "value": "Lime850"
        },
        "name": "color.background.success.subtler.hovered",
        "path": [
            "color",
            "background",
            "success",
            "subtler",
            "hovered"
        ],
        "cleanName": "color.background.success.subtler.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Pressed state of color.background.success.subtler"
        },
        "value": "#4C6B1F",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Pressed state of color.background.success.subtler"
            },
            "value": "Lime800"
        },
        "name": "color.background.success.subtler.pressed",
        "path": [
            "color",
            "background",
            "success",
            "subtler",
            "pressed"
        ],
        "cleanName": "color.background.success.subtler.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Background colour for non-interactive elements communicating success (e.g. semantic badges, status pills, callout chips). Sits between subtler and bold in visual emphasis. Not for interactive surfaces \u2014 see color.background.success.bold or color.background.success.subtler for interactive states."
        },
        "value": "#4C6B1F",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Background colour for non-interactive elements communicating success (e.g. semantic badges, status pills, callout chips). Sits between subtler and bold in visual emphasis. Not for interactive surfaces \u2014 see color.background.success.bold or color.background.success.subtler for interactive states."
            },
            "value": "Lime800"
        },
        "name": "color.background.success.subtle.[default]",
        "path": [
            "color",
            "background",
            "success",
            "subtle",
            "[default]"
        ],
        "cleanName": "color.background.success.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "A vibrant background option for communicating a favorable outcome, such as in checked toggles."
        },
        "value": "#94C748",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "A vibrant background option for communicating a favorable outcome, such as in checked toggles."
            },
            "value": "Lime400"
        },
        "name": "color.background.success.bold.[default]",
        "path": [
            "color",
            "background",
            "success",
            "bold",
            "[default]"
        ],
        "cleanName": "color.background.success.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Hovered state of color.background.success.bold"
        },
        "value": "#B3DF72",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Hovered state of color.background.success.bold"
            },
            "value": "Lime300"
        },
        "name": "color.background.success.bold.hovered",
        "path": [
            "color",
            "background",
            "success",
            "bold",
            "hovered"
        ],
        "cleanName": "color.background.success.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Pressed state of color.background.success.bold"
        },
        "value": "#BDE97C",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Pressed state of color.background.success.bold"
            },
            "value": "Lime250"
        },
        "name": "color.background.success.bold.pressed",
        "path": [
            "color",
            "background",
            "success",
            "bold",
            "pressed"
        ],
        "cleanName": "color.background.success.bold.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for backgrounds communicating change or something new, such as in discovery section messages."
        },
        "value": "#35243F",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for backgrounds communicating change or something new, such as in discovery section messages."
            },
            "value": "Purple1000"
        },
        "name": "color.background.discovery.[default].[default]",
        "path": [
            "color",
            "background",
            "discovery",
            "[default]",
            "[default]"
        ],
        "cleanName": "color.background.discovery"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Hover state for color.background.discovery"
        },
        "value": "#48245D",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Hover state for color.background.discovery"
            },
            "value": "Purple900"
        },
        "name": "color.background.discovery.[default].hovered",
        "path": [
            "color",
            "background",
            "discovery",
            "[default]",
            "hovered"
        ],
        "cleanName": "color.background.discovery.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Pressed state for color.background.discovery"
        },
        "value": "#673286",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Pressed state for color.background.discovery"
            },
            "value": "Purple850"
        },
        "name": "color.background.discovery.[default].pressed",
        "path": [
            "color",
            "background",
            "discovery",
            "[default]",
            "pressed"
        ],
        "cleanName": "color.background.discovery.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Use for backgrounds of discovery lozenges and badges to ensure accessibility and desired visual appearance."
        },
        "value": "#48245D",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Use for backgrounds of discovery lozenges and badges to ensure accessibility and desired visual appearance."
            },
            "value": "Purple900"
        },
        "name": "color.background.discovery.subtler.[default]",
        "path": [
            "color",
            "background",
            "discovery",
            "subtler",
            "[default]"
        ],
        "cleanName": "color.background.discovery.subtler"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Hovered state of color.background.discovery.subtler"
        },
        "value": "#673286",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Hovered state of color.background.discovery.subtler"
            },
            "value": "Purple850"
        },
        "name": "color.background.discovery.subtler.hovered",
        "path": [
            "color",
            "background",
            "discovery",
            "subtler",
            "hovered"
        ],
        "cleanName": "color.background.discovery.subtler.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Pressed state of color.background.discovery.subtler"
        },
        "value": "#803FA5",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Pressed state of color.background.discovery.subtler"
            },
            "value": "Purple800"
        },
        "name": "color.background.discovery.subtler.pressed",
        "path": [
            "color",
            "background",
            "discovery",
            "subtler",
            "pressed"
        ],
        "cleanName": "color.background.discovery.subtler.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Background colour for non-interactive elements communicating discovery (e.g. semantic badges, status pills, callout chips). Sits between subtler and bold in visual emphasis. Not for interactive surfaces \u2014 see color.background.discovery.bold or color.background.discovery.subtler for interactive states."
        },
        "value": "#803FA5",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Background colour for non-interactive elements communicating discovery (e.g. semantic badges, status pills, callout chips). Sits between subtler and bold in visual emphasis. Not for interactive surfaces \u2014 see color.background.discovery.bold or color.background.discovery.subtler for interactive states."
            },
            "value": "Purple800"
        },
        "name": "color.background.discovery.subtle.[default]",
        "path": [
            "color",
            "background",
            "discovery",
            "subtle",
            "[default]"
        ],
        "cleanName": "color.background.discovery.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "A vibrant background option communicating change or something new, such as in onboarding spotlights."
        },
        "value": "#C97CF4",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "A vibrant background option communicating change or something new, such as in onboarding spotlights."
            },
            "value": "Purple400"
        },
        "name": "color.background.discovery.bold.[default]",
        "path": [
            "color",
            "background",
            "discovery",
            "bold",
            "[default]"
        ],
        "cleanName": "color.background.discovery.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Hovered state of color.background.discovery.bold"
        },
        "value": "#D8A0F7",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Hovered state of color.background.discovery.bold"
            },
            "value": "Purple300"
        },
        "name": "color.background.discovery.bold.hovered",
        "path": [
            "color",
            "background",
            "discovery",
            "bold",
            "hovered"
        ],
        "cleanName": "color.background.discovery.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Pressed state of color.background.discovery.bold"
        },
        "value": "#E3BDFA",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Pressed state of color.background.discovery.bold"
            },
            "value": "Purple250"
        },
        "name": "color.background.discovery.bold.pressed",
        "path": [
            "color",
            "background",
            "discovery",
            "bold",
            "pressed"
        ],
        "cleanName": "color.background.discovery.bold.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for backgrounds communicating information or something in-progress, such as in information section messages."
        },
        "value": "#1C2B42",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for backgrounds communicating information or something in-progress, such as in information section messages."
            },
            "value": "Blue1000"
        },
        "name": "color.background.information.[default].[default]",
        "path": [
            "color",
            "background",
            "information",
            "[default]",
            "[default]"
        ],
        "cleanName": "color.background.information"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Hovered state of color.background.information"
        },
        "value": "#123263",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Hovered state of color.background.information"
            },
            "value": "Blue900"
        },
        "name": "color.background.information.[default].hovered",
        "path": [
            "color",
            "background",
            "information",
            "[default]",
            "hovered"
        ],
        "cleanName": "color.background.information.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Pressed state of color.background.information"
        },
        "value": "#144794",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Pressed state of color.background.information"
            },
            "value": "Blue850"
        },
        "name": "color.background.information.[default].pressed",
        "path": [
            "color",
            "background",
            "information",
            "[default]",
            "pressed"
        ],
        "cleanName": "color.background.information.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Use for backgrounds of information lozenges and badges to ensure accessibility and desired visual appearance."
        },
        "value": "#123263",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Use for backgrounds of information lozenges and badges to ensure accessibility and desired visual appearance."
            },
            "value": "Blue900"
        },
        "name": "color.background.information.subtler.[default]",
        "path": [
            "color",
            "background",
            "information",
            "subtler",
            "[default]"
        ],
        "cleanName": "color.background.information.subtler"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Hovered state of color.background.information.subtler"
        },
        "value": "#144794",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Hovered state of color.background.information.subtler"
            },
            "value": "Blue850"
        },
        "name": "color.background.information.subtler.hovered",
        "path": [
            "color",
            "background",
            "information",
            "subtler",
            "hovered"
        ],
        "cleanName": "color.background.information.subtler.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Pressed state of color.background.information.subtler"
        },
        "value": "#1558BC",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Pressed state of color.background.information.subtler"
            },
            "value": "Blue800"
        },
        "name": "color.background.information.subtler.pressed",
        "path": [
            "color",
            "background",
            "information",
            "subtler",
            "pressed"
        ],
        "cleanName": "color.background.information.subtler.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Background colour for non-interactive elements communicating information (e.g. semantic badges, status pills, callout chips). Sits between subtler and bold in visual emphasis. Not for interactive surfaces \u2014 see color.background.information.bold or color.background.information.subtler for interactive states."
        },
        "value": "#1558BC",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Background colour for non-interactive elements communicating information (e.g. semantic badges, status pills, callout chips). Sits between subtler and bold in visual emphasis. Not for interactive surfaces \u2014 see color.background.information.bold or color.background.information.subtler for interactive states."
            },
            "value": "Blue800"
        },
        "name": "color.background.information.subtle.[default]",
        "path": [
            "color",
            "background",
            "information",
            "subtle",
            "[default]"
        ],
        "cleanName": "color.background.information.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "A vibrant background option for communicating information or something in-progress."
        },
        "value": "#669DF1",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "A vibrant background option for communicating information or something in-progress."
            },
            "value": "Blue400"
        },
        "name": "color.background.information.bold.[default]",
        "path": [
            "color",
            "background",
            "information",
            "bold",
            "[default]"
        ],
        "cleanName": "color.background.information.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Hovered state of color.background.information.bold"
        },
        "value": "#8FB8F6",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Hovered state of color.background.information.bold"
            },
            "value": "Blue300"
        },
        "name": "color.background.information.bold.hovered",
        "path": [
            "color",
            "background",
            "information",
            "bold",
            "hovered"
        ],
        "cleanName": "color.background.information.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Pressed state of color.background.information.bold"
        },
        "value": "#ADCBFB",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Pressed state of color.background.information.bold"
            },
            "value": "Blue250"
        },
        "name": "color.background.information.bold.pressed",
        "path": [
            "color",
            "background",
            "information",
            "bold",
            "pressed"
        ],
        "cleanName": "color.background.information.bold.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use to visually group or separate UI elements, such as flat cards or side panel dividers."
        },
        "value": "#E3E4F21F",
        "filePath": "schema/themes/atlassian-dark/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use to visually group or separate UI elements, such as flat cards or side panel dividers."
            },
            "value": "DarkNeutral300A"
        },
        "name": "color.border.[default]",
        "path": [
            "color",
            "border",
            "[default]"
        ],
        "cleanName": "color.border"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.6.0",
            "description": "Use for lime borders on non-bold backgrounds when there is no meaning tied to the color."
        },
        "value": "#82B536",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.6.0",
                "description": "Use for lime borders on non-bold backgrounds when there is no meaning tied to the color."
            },
            "value": "Lime500"
        },
        "name": "color.border.accent.lime.[default]",
        "path": [
            "color",
            "border",
            "accent",
            "lime",
            "[default]"
        ],
        "cleanName": "color.border.accent.lime"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Use for decorative lime borders that do not need to meet 3:1 contrast requirements."
        },
        "value": "#4C6B1F",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Use for decorative lime borders that do not need to meet 3:1 contrast requirements."
            },
            "value": "Lime800"
        },
        "name": "color.border.accent.lime.subtle",
        "path": [
            "color",
            "border",
            "accent",
            "lime",
            "subtle"
        ],
        "cleanName": "color.border.accent.lime.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for red borders on non-bold backgrounds when there is no meaning tied to the color."
        },
        "value": "#F15B50",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for red borders on non-bold backgrounds when there is no meaning tied to the color."
            },
            "value": "Red500"
        },
        "name": "color.border.accent.red.[default]",
        "path": [
            "color",
            "border",
            "accent",
            "red",
            "[default]"
        ],
        "cleanName": "color.border.accent.red"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Use for decorative red borders that do not need to meet 3:1 contrast requirements."
        },
        "value": "#AE2E24",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Use for decorative red borders that do not need to meet 3:1 contrast requirements."
            },
            "value": "Red800"
        },
        "name": "color.border.accent.red.subtle",
        "path": [
            "color",
            "border",
            "accent",
            "red",
            "subtle"
        ],
        "cleanName": "color.border.accent.red.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for orange borders on non-bold backgrounds when there is no meaning tied to the color."
        },
        "value": "#F68909",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for orange borders on non-bold backgrounds when there is no meaning tied to the color."
            },
            "value": "Orange500"
        },
        "name": "color.border.accent.orange.[default]",
        "path": [
            "color",
            "border",
            "accent",
            "orange",
            "[default]"
        ],
        "cleanName": "color.border.accent.orange"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Use for decorative orange borders that do not need to meet 3:1 contrast requirements."
        },
        "value": "#9E4C00",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Use for decorative orange borders that do not need to meet 3:1 contrast requirements."
            },
            "value": "Orange800"
        },
        "name": "color.border.accent.orange.subtle",
        "path": [
            "color",
            "border",
            "accent",
            "orange",
            "subtle"
        ],
        "cleanName": "color.border.accent.orange.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for yellow borders on non-bold backgrounds when there is no meaning tied to the color."
        },
        "value": "#CF9F02",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for yellow borders on non-bold backgrounds when there is no meaning tied to the color."
            },
            "value": "Yellow500"
        },
        "name": "color.border.accent.yellow.[default]",
        "path": [
            "color",
            "border",
            "accent",
            "yellow",
            "[default]"
        ],
        "cleanName": "color.border.accent.yellow"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Use for decorative yellow borders that do not need to meet 3:1 contrast requirements."
        },
        "value": "#7F5F01",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Use for decorative yellow borders that do not need to meet 3:1 contrast requirements."
            },
            "value": "Yellow800"
        },
        "name": "color.border.accent.yellow.subtle",
        "path": [
            "color",
            "border",
            "accent",
            "yellow",
            "subtle"
        ],
        "cleanName": "color.border.accent.yellow.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for green borders on non-bold backgrounds when there is no meaning tied to the color."
        },
        "value": "#2ABB7F",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for green borders on non-bold backgrounds when there is no meaning tied to the color."
            },
            "value": "Green500"
        },
        "name": "color.border.accent.green.[default]",
        "path": [
            "color",
            "border",
            "accent",
            "green",
            "[default]"
        ],
        "cleanName": "color.border.accent.green"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Use for decorative green borders that do not need to meet 3:1 contrast requirements."
        },
        "value": "#216E4E",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Use for decorative green borders that do not need to meet 3:1 contrast requirements."
            },
            "value": "Green800"
        },
        "name": "color.border.accent.green.subtle",
        "path": [
            "color",
            "border",
            "accent",
            "green",
            "subtle"
        ],
        "cleanName": "color.border.accent.green.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for teal borders on non-bold backgrounds when there is no meaning tied to the color."
        },
        "value": "#42B2D7",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for teal borders on non-bold backgrounds when there is no meaning tied to the color."
            },
            "value": "Teal500"
        },
        "name": "color.border.accent.teal.[default]",
        "path": [
            "color",
            "border",
            "accent",
            "teal",
            "[default]"
        ],
        "cleanName": "color.border.accent.teal"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Use for decorative teal borders that do not need to meet 3:1 contrast requirements."
        },
        "value": "#206A83",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Use for decorative teal borders that do not need to meet 3:1 contrast requirements."
            },
            "value": "Teal800"
        },
        "name": "color.border.accent.teal.subtle",
        "path": [
            "color",
            "border",
            "accent",
            "teal",
            "subtle"
        ],
        "cleanName": "color.border.accent.teal.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for blue borders on non-bold backgrounds when there is no meaning tied to the color."
        },
        "value": "#4688EC",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for blue borders on non-bold backgrounds when there is no meaning tied to the color."
            },
            "value": "Blue500"
        },
        "name": "color.border.accent.blue.[default]",
        "path": [
            "color",
            "border",
            "accent",
            "blue",
            "[default]"
        ],
        "cleanName": "color.border.accent.blue"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Use for decorative blue borders that do not need to meet 3:1 contrast requirements."
        },
        "value": "#1558BC",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Use for decorative blue borders that do not need to meet 3:1 contrast requirements."
            },
            "value": "Blue800"
        },
        "name": "color.border.accent.blue.subtle",
        "path": [
            "color",
            "border",
            "accent",
            "blue",
            "subtle"
        ],
        "cleanName": "color.border.accent.blue.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for purple borders on non-bold backgrounds when there is no meaning tied to the color."
        },
        "value": "#BF63F3",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for purple borders on non-bold backgrounds when there is no meaning tied to the color."
            },
            "value": "Purple500"
        },
        "name": "color.border.accent.purple.[default]",
        "path": [
            "color",
            "border",
            "accent",
            "purple",
            "[default]"
        ],
        "cleanName": "color.border.accent.purple"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Use for decorative purple borders that do not need to meet 3:1 contrast requirements."
        },
        "value": "#803FA5",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Use for decorative purple borders that do not need to meet 3:1 contrast requirements."
            },
            "value": "Purple800"
        },
        "name": "color.border.accent.purple.subtle",
        "path": [
            "color",
            "border",
            "accent",
            "purple",
            "subtle"
        ],
        "cleanName": "color.border.accent.purple.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for magenta borders on non-bold backgrounds when there is no meaning tied to the color."
        },
        "value": "#DA62AC",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for magenta borders on non-bold backgrounds when there is no meaning tied to the color."
            },
            "value": "Magenta500"
        },
        "name": "color.border.accent.magenta.[default]",
        "path": [
            "color",
            "border",
            "accent",
            "magenta",
            "[default]"
        ],
        "cleanName": "color.border.accent.magenta"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Use for decorative magenta borders that do not need to meet 3:1 contrast requirements."
        },
        "value": "#943D73",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Use for decorative magenta borders that do not need to meet 3:1 contrast requirements."
            },
            "value": "Magenta800"
        },
        "name": "color.border.accent.magenta.subtle",
        "path": [
            "color",
            "border",
            "accent",
            "magenta",
            "subtle"
        ],
        "cleanName": "color.border.accent.magenta.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.10.5",
            "description": "Use for borders on non-bold gray accent backgrounds."
        },
        "value": "#7E8188",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.10.5",
                "description": "Use for borders on non-bold gray accent backgrounds."
            },
            "value": "DarkNeutral600"
        },
        "name": "color.border.accent.gray.[default]",
        "path": [
            "color",
            "border",
            "accent",
            "gray",
            "[default]"
        ],
        "cleanName": "color.border.accent.gray"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Use for decorative gray borders that do not need to meet 3:1 contrast requirements."
        },
        "value": "#4B4D51",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Use for decorative gray borders that do not need to meet 3:1 contrast requirements."
            },
            "value": "DarkNeutral400"
        },
        "name": "color.border.accent.gray.subtle",
        "path": [
            "color",
            "border",
            "accent",
            "gray",
            "subtle"
        ],
        "cleanName": "color.border.accent.gray.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for code block and code diff borders."
        },
        "value": "#E3E4F21F",
        "filePath": "schema/themes/atlassian-dark/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for code block and code diff borders."
            },
            "value": "DarkNeutral300A"
        },
        "name": "color.border.code",
        "path": [
            "color",
            "border",
            "code"
        ],
        "cleanName": "color.border.code"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for borders of elements in a disabled state."
        },
        "value": "#CECED912",
        "filePath": "schema/themes/atlassian-dark/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for borders of elements in a disabled state."
            },
            "value": "DarkNeutral200A"
        },
        "name": "color.border.disabled",
        "path": [
            "color",
            "border",
            "disabled"
        ],
        "cleanName": "color.border.disabled"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for the focus ring or border of an element that currently has keyboard or input focus. Do not use to indicate selection or hover alone. When an element is both selected and focused, keep its selected treatment and add a separate focus indicator."
        },
        "value": "#8FB8F6",
        "filePath": "schema/themes/atlassian-dark/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for the focus ring or border of an element that currently has keyboard or input focus. Do not use to indicate selection or hover alone. When an element is both selected and focused, keep its selected treatment and add a separate focus indicator."
            },
            "value": "Blue300"
        },
        "name": "color.border.focused",
        "path": [
            "color",
            "border",
            "focused"
        ],
        "cleanName": "color.border.focused"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for borders of form UI elements, such as text fields, checkboxes, and radio buttons."
        },
        "value": "#7E8188",
        "filePath": "schema/themes/atlassian-dark/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for borders of form UI elements, such as text fields, checkboxes, and radio buttons."
            },
            "value": "DarkNeutral600"
        },
        "name": "color.border.input.[default]",
        "path": [
            "color",
            "border",
            "input",
            "[default]"
        ],
        "cleanName": "color.border.input"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.12.0",
            "description": "Use for the border of search inputs."
        },
        "value": "#E3E4F21F",
        "filePath": "schema/themes/atlassian-dark/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.12.0",
                "description": "Use for the border of search inputs."
            },
            "value": "DarkNeutral300A"
        },
        "name": "color.border.input.search",
        "path": [
            "color",
            "border",
            "input",
            "search"
        ],
        "cleanName": "color.border.input.search"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for borders on bold backgrounds."
        },
        "value": "#18191A",
        "filePath": "schema/themes/atlassian-dark/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for borders on bold backgrounds."
            },
            "value": "DarkNeutral0"
        },
        "name": "color.border.inverse",
        "path": [
            "color",
            "border",
            "inverse"
        ],
        "cleanName": "color.border.inverse"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.2",
            "description": "Use for borders or visual indicators that communicate selection, such as the active tab or a selected menu item, or the opened state of a dropdown trigger. Do not use as a keyboard focus indicator; use color.border.focused for focus and preserve the selected treatment when both states apply."
        },
        "value": "#669DF1",
        "filePath": "schema/themes/atlassian-dark/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.2",
                "description": "Use for borders or visual indicators that communicate selection, such as the active tab or a selected menu item, or the opened state of a dropdown trigger. Do not use as a keyboard focus indicator; use color.border.focused for focus and preserve the selected treatment when both states apply."
            },
            "value": "Blue400"
        },
        "name": "color.border.selected",
        "path": [
            "color",
            "border",
            "selected"
        ],
        "cleanName": "color.border.selected"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for borders or visual indicators of elements that reinforce our brand, such as logos or primary buttons."
        },
        "value": "#669DF1",
        "filePath": "schema/themes/atlassian-dark/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for borders or visual indicators of elements that reinforce our brand, such as logos or primary buttons."
            },
            "value": "Blue400"
        },
        "name": "color.border.brand",
        "path": [
            "color",
            "border",
            "brand"
        ],
        "cleanName": "color.border.brand"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for borders communicating critical information, such as the borders on invalid text fields."
        },
        "value": "#F15B50",
        "filePath": "schema/themes/atlassian-dark/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for borders communicating critical information, such as the borders on invalid text fields."
            },
            "value": "Red500"
        },
        "name": "color.border.danger.[default]",
        "path": [
            "color",
            "border",
            "danger",
            "[default]"
        ],
        "cleanName": "color.border.danger"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Use for decorative danger borders that do not need to meet 3:1 contrast requirements."
        },
        "value": "#AE2E24",
        "filePath": "schema/themes/atlassian-dark/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Use for decorative danger borders that do not need to meet 3:1 contrast requirements."
            },
            "value": "Red800"
        },
        "name": "color.border.danger.subtle",
        "path": [
            "color",
            "border",
            "danger",
            "subtle"
        ],
        "cleanName": "color.border.danger.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for borders communicating caution."
        },
        "value": "#F68909",
        "filePath": "schema/themes/atlassian-dark/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for borders communicating caution."
            },
            "value": "Orange500"
        },
        "name": "color.border.warning.[default]",
        "path": [
            "color",
            "border",
            "warning",
            "[default]"
        ],
        "cleanName": "color.border.warning"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Use for decorative warning borders that do not need to meet 3:1 contrast requirements."
        },
        "value": "#9E4C00",
        "filePath": "schema/themes/atlassian-dark/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Use for decorative warning borders that do not need to meet 3:1 contrast requirements."
            },
            "value": "Orange800"
        },
        "name": "color.border.warning.subtle",
        "path": [
            "color",
            "border",
            "warning",
            "subtle"
        ],
        "cleanName": "color.border.warning.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for borders communicating a favorable outcome, such as the borders on validated text fields."
        },
        "value": "#82B536",
        "filePath": "schema/themes/atlassian-dark/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for borders communicating a favorable outcome, such as the borders on validated text fields."
            },
            "value": "Lime500"
        },
        "name": "color.border.success.[default]",
        "path": [
            "color",
            "border",
            "success",
            "[default]"
        ],
        "cleanName": "color.border.success"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Use for decorative success borders that do not need to meet 3:1 contrast requirements."
        },
        "value": "#4C6B1F",
        "filePath": "schema/themes/atlassian-dark/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Use for decorative success borders that do not need to meet 3:1 contrast requirements."
            },
            "value": "Lime800"
        },
        "name": "color.border.success.subtle",
        "path": [
            "color",
            "border",
            "success",
            "subtle"
        ],
        "cleanName": "color.border.success.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for borders communicating change or something new, such as the borders in onboarding spotlights."
        },
        "value": "#BF63F3",
        "filePath": "schema/themes/atlassian-dark/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for borders communicating change or something new, such as the borders in onboarding spotlights."
            },
            "value": "Purple500"
        },
        "name": "color.border.discovery.[default]",
        "path": [
            "color",
            "border",
            "discovery",
            "[default]"
        ],
        "cleanName": "color.border.discovery"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Use for decorative discovery borders that do not need to meet 3:1 contrast requirements."
        },
        "value": "#803FA5",
        "filePath": "schema/themes/atlassian-dark/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Use for decorative discovery borders that do not need to meet 3:1 contrast requirements."
            },
            "value": "Purple800"
        },
        "name": "color.border.discovery.subtle",
        "path": [
            "color",
            "border",
            "discovery",
            "subtle"
        ],
        "cleanName": "color.border.discovery.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for borders communicating information or something in-progress."
        },
        "value": "#4688EC",
        "filePath": "schema/themes/atlassian-dark/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for borders communicating information or something in-progress."
            },
            "value": "Blue500"
        },
        "name": "color.border.information.[default]",
        "path": [
            "color",
            "border",
            "information",
            "[default]"
        ],
        "cleanName": "color.border.information"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Use for decorative information borders that do not need to meet 3:1 contrast requirements."
        },
        "value": "#1558BC",
        "filePath": "schema/themes/atlassian-dark/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Use for decorative information borders that do not need to meet 3:1 contrast requirements."
            },
            "value": "Blue800"
        },
        "name": "color.border.information.subtle",
        "path": [
            "color",
            "border",
            "information",
            "subtle"
        ],
        "cleanName": "color.border.information.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.10.8",
            "description": "A neutral border option that passes min 3:1 contrast ratios."
        },
        "value": "#7E8188",
        "filePath": "schema/themes/atlassian-dark/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.10.8",
                "description": "A neutral border option that passes min 3:1 contrast ratios."
            },
            "value": "DarkNeutral600"
        },
        "name": "color.border.bold",
        "path": [
            "color",
            "border",
            "bold"
        ],
        "cleanName": "color.border.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for primary text, such as body copy, sentence case headers, and buttons."
        },
        "value": "#CECFD2",
        "filePath": "schema/themes/atlassian-dark/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for primary text, such as body copy, sentence case headers, and buttons."
            },
            "value": "DarkNeutral1000"
        },
        "name": "color.text.[default]",
        "path": [
            "color",
            "text",
            "[default]"
        ],
        "cleanName": "color.text"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.8.0",
            "description": "Use for lime text on subtlest and subtler lime accent backgrounds when there is no meaning tied to the color."
        },
        "value": "#B3DF72",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.8.0",
                "description": "Use for lime text on subtlest and subtler lime accent backgrounds when there is no meaning tied to the color."
            },
            "value": "Lime300"
        },
        "name": "color.text.accent.lime.[default]",
        "path": [
            "color",
            "text",
            "accent",
            "lime",
            "[default]"
        ],
        "cleanName": "color.text.accent.lime"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.8.0",
            "description": "Use for lime text on subtle lime accent backgrounds when there is no meaning tied to the color."
        },
        "value": "#D3F1A7",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.8.0",
                "description": "Use for lime text on subtle lime accent backgrounds when there is no meaning tied to the color."
            },
            "value": "Lime200"
        },
        "name": "color.text.accent.lime.bolder",
        "path": [
            "color",
            "text",
            "accent",
            "lime",
            "bolder"
        ],
        "cleanName": "color.text.accent.lime.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for red text on subtlest and subtler red accent backgrounds when there is no meaning tied to the color."
        },
        "value": "#FD9891",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for red text on subtlest and subtler red accent backgrounds when there is no meaning tied to the color."
            },
            "value": "Red300"
        },
        "name": "color.text.accent.red.[default]",
        "path": [
            "color",
            "text",
            "accent",
            "red",
            "[default]"
        ],
        "cleanName": "color.text.accent.red"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for red text on subtle red accent backgrounds when there is no meaning tied to the color."
        },
        "value": "#FFD5D2",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for red text on subtle red accent backgrounds when there is no meaning tied to the color."
            },
            "value": "Red200"
        },
        "name": "color.text.accent.red.bolder",
        "path": [
            "color",
            "text",
            "accent",
            "red",
            "bolder"
        ],
        "cleanName": "color.text.accent.red.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for orange text on subtlest and subtler orange accent backgrounds when there is no meaning tied to the color."
        },
        "value": "#FBC828",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for orange text on subtlest and subtler orange accent backgrounds when there is no meaning tied to the color."
            },
            "value": "Orange300"
        },
        "name": "color.text.accent.orange.[default]",
        "path": [
            "color",
            "text",
            "accent",
            "orange",
            "[default]"
        ],
        "cleanName": "color.text.accent.orange"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for orange text on subtle orange accent backgrounds when there is no meaning tied to the color."
        },
        "value": "#FCE4A6",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for orange text on subtle orange accent backgrounds when there is no meaning tied to the color."
            },
            "value": "Orange200"
        },
        "name": "color.text.accent.orange.bolder",
        "path": [
            "color",
            "text",
            "accent",
            "orange",
            "bolder"
        ],
        "cleanName": "color.text.accent.orange.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for yellow text on subtlest and subtler yellow accent backgrounds when there is no meaning tied to the color."
        },
        "value": "#EED12B",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for yellow text on subtlest and subtler yellow accent backgrounds when there is no meaning tied to the color."
            },
            "value": "Yellow300"
        },
        "name": "color.text.accent.yellow.[default]",
        "path": [
            "color",
            "text",
            "accent",
            "yellow",
            "[default]"
        ],
        "cleanName": "color.text.accent.yellow"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for yellow text on subtle yellow accent backgrounds when there is no meaning tied to the color."
        },
        "value": "#F5E989",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for yellow text on subtle yellow accent backgrounds when there is no meaning tied to the color."
            },
            "value": "Yellow200"
        },
        "name": "color.text.accent.yellow.bolder",
        "path": [
            "color",
            "text",
            "accent",
            "yellow",
            "bolder"
        ],
        "cleanName": "color.text.accent.yellow.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for green text on subtlest and subtler green accent backgrounds when there is no meaning tied to the color."
        },
        "value": "#7EE2B8",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for green text on subtlest and subtler green accent backgrounds when there is no meaning tied to the color."
            },
            "value": "Green300"
        },
        "name": "color.text.accent.green.[default]",
        "path": [
            "color",
            "text",
            "accent",
            "green",
            "[default]"
        ],
        "cleanName": "color.text.accent.green"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for green text on subtle green accent backgrounds when there is no meaning tied to the color."
        },
        "value": "#BAF3DB",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for green text on subtle green accent backgrounds when there is no meaning tied to the color."
            },
            "value": "Green200"
        },
        "name": "color.text.accent.green.bolder",
        "path": [
            "color",
            "text",
            "accent",
            "green",
            "bolder"
        ],
        "cleanName": "color.text.accent.green.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for teal text on subtlest and subtler teal accent backgrounds when there is no meaning tied to the color."
        },
        "value": "#9DD9EE",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for teal text on subtlest and subtler teal accent backgrounds when there is no meaning tied to the color."
            },
            "value": "Teal300"
        },
        "name": "color.text.accent.teal.[default]",
        "path": [
            "color",
            "text",
            "accent",
            "teal",
            "[default]"
        ],
        "cleanName": "color.text.accent.teal"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for teal text on subtle teal accent backgrounds when there is no meaning tied to the color."
        },
        "value": "#C6EDFB",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for teal text on subtle teal accent backgrounds when there is no meaning tied to the color."
            },
            "value": "Teal200"
        },
        "name": "color.text.accent.teal.bolder",
        "path": [
            "color",
            "text",
            "accent",
            "teal",
            "bolder"
        ],
        "cleanName": "color.text.accent.teal.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for blue text on subtlest and subtler blue accent backgrounds when there is no meaning tied to the color."
        },
        "value": "#8FB8F6",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for blue text on subtlest and subtler blue accent backgrounds when there is no meaning tied to the color."
            },
            "value": "Blue300"
        },
        "name": "color.text.accent.blue.[default]",
        "path": [
            "color",
            "text",
            "accent",
            "blue",
            "[default]"
        ],
        "cleanName": "color.text.accent.blue"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for blue text on subtle blue accent backgrounds when there is no meaning tied to the color."
        },
        "value": "#CFE1FD",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for blue text on subtle blue accent backgrounds when there is no meaning tied to the color."
            },
            "value": "Blue200"
        },
        "name": "color.text.accent.blue.bolder",
        "path": [
            "color",
            "text",
            "accent",
            "blue",
            "bolder"
        ],
        "cleanName": "color.text.accent.blue.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for purple text on subtlest and subtler purple accent backgrounds when there is no meaning tied to the color."
        },
        "value": "#D8A0F7",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for purple text on subtlest and subtler purple accent backgrounds when there is no meaning tied to the color."
            },
            "value": "Purple300"
        },
        "name": "color.text.accent.purple.[default]",
        "path": [
            "color",
            "text",
            "accent",
            "purple",
            "[default]"
        ],
        "cleanName": "color.text.accent.purple"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for purple text on subtle purple accent backgrounds when there is no meaning tied to the color."
        },
        "value": "#EED7FC",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for purple text on subtle purple accent backgrounds when there is no meaning tied to the color."
            },
            "value": "Purple200"
        },
        "name": "color.text.accent.purple.bolder",
        "path": [
            "color",
            "text",
            "accent",
            "purple",
            "bolder"
        ],
        "cleanName": "color.text.accent.purple.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for magenta text on subtlest and subtler magenta accent backgrounds when there is no meaning tied to the color."
        },
        "value": "#F797D2",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for magenta text on subtlest and subtler magenta accent backgrounds when there is no meaning tied to the color."
            },
            "value": "Magenta300"
        },
        "name": "color.text.accent.magenta.[default]",
        "path": [
            "color",
            "text",
            "accent",
            "magenta",
            "[default]"
        ],
        "cleanName": "color.text.accent.magenta"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for magenta text on subtle magenta accent backgrounds when there is no meaning tied to the color."
        },
        "value": "#FDD0EC",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for magenta text on subtle magenta accent backgrounds when there is no meaning tied to the color."
            },
            "value": "Magenta200"
        },
        "name": "color.text.accent.magenta.bolder",
        "path": [
            "color",
            "text",
            "accent",
            "magenta",
            "bolder"
        ],
        "cleanName": "color.text.accent.magenta.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.10.5",
            "description": "Use for text on non-bold gray accent backgrounds, such as colored tags."
        },
        "value": "#A9ABAF",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.10.5",
                "description": "Use for text on non-bold gray accent backgrounds, such as colored tags."
            },
            "value": "DarkNeutral800"
        },
        "name": "color.text.accent.gray.[default]",
        "path": [
            "color",
            "text",
            "accent",
            "gray",
            "[default]"
        ],
        "cleanName": "color.text.accent.gray"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.10.5",
            "description": "Use for text and icons on gray subtle accent backgrounds."
        },
        "value": "#E2E3E4",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.10.5",
                "description": "Use for text and icons on gray subtle accent backgrounds."
            },
            "value": "DarkNeutral1100"
        },
        "name": "color.text.accent.gray.bolder",
        "path": [
            "color",
            "text",
            "accent",
            "gray",
            "bolder"
        ],
        "cleanName": "color.text.accent.gray.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for an additional syntax-highlighting text color."
        },
        "value": "#F797D2",
        "filePath": "schema/themes/atlassian-dark/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for an additional syntax-highlighting text color."
            },
            "value": "Magenta300"
        },
        "name": "color.text.code.accent.1",
        "path": [
            "color",
            "text",
            "code",
            "accent",
            "1"
        ],
        "cleanName": "color.text.code.accent.1"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for an additional syntax-highlighting text color."
        },
        "value": "#8FB8F6",
        "filePath": "schema/themes/atlassian-dark/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for an additional syntax-highlighting text color."
            },
            "value": "Blue300"
        },
        "name": "color.text.code.accent.2",
        "path": [
            "color",
            "text",
            "code",
            "accent",
            "2"
        ],
        "cleanName": "color.text.code.accent.2"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for comments in syntax-highlighted code."
        },
        "value": "#A9ABAF",
        "filePath": "schema/themes/atlassian-dark/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for comments in syntax-highlighted code."
            },
            "value": "DarkNeutral800"
        },
        "name": "color.text.code.comments",
        "path": [
            "color",
            "text",
            "code",
            "comments"
        ],
        "cleanName": "color.text.code.comments"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for default text in code blocks and code diffs."
        },
        "value": "#A9ABAF",
        "filePath": "schema/themes/atlassian-dark/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for default text in code blocks and code diffs."
            },
            "value": "DarkNeutral800"
        },
        "name": "color.text.code.default",
        "path": [
            "color",
            "text",
            "code",
            "default"
        ],
        "cleanName": "color.text.code.default"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for functions in syntax-highlighted code."
        },
        "value": "#7EE2B8",
        "filePath": "schema/themes/atlassian-dark/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for functions in syntax-highlighted code."
            },
            "value": "Green300"
        },
        "name": "color.text.code.functions",
        "path": [
            "color",
            "text",
            "code",
            "functions"
        ],
        "cleanName": "color.text.code.functions"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for line numbers and other code gutter text."
        },
        "value": "#96999E",
        "filePath": "schema/themes/atlassian-dark/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for line numbers and other code gutter text."
            },
            "value": "DarkNeutral700"
        },
        "name": "color.text.code.gutter",
        "path": [
            "color",
            "text",
            "code",
            "gutter"
        ],
        "cleanName": "color.text.code.gutter"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for language keywords in syntax-highlighted code."
        },
        "value": "#FD9891",
        "filePath": "schema/themes/atlassian-dark/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for language keywords in syntax-highlighted code."
            },
            "value": "Red300"
        },
        "name": "color.text.code.keywords",
        "path": [
            "color",
            "text",
            "code",
            "keywords"
        ],
        "cleanName": "color.text.code.keywords"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for numeric values in syntax-highlighted code."
        },
        "value": "#EED12B",
        "filePath": "schema/themes/atlassian-dark/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for numeric values in syntax-highlighted code."
            },
            "value": "Yellow300"
        },
        "name": "color.text.code.numbers",
        "path": [
            "color",
            "text",
            "code",
            "numbers"
        ],
        "cleanName": "color.text.code.numbers"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for operators and punctuation in syntax-highlighted code."
        },
        "value": "#CECFD2",
        "filePath": "schema/themes/atlassian-dark/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for operators and punctuation in syntax-highlighted code."
            },
            "value": "DarkNeutral1000"
        },
        "name": "color.text.code.operators",
        "path": [
            "color",
            "text",
            "code",
            "operators"
        ],
        "cleanName": "color.text.code.operators"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for string values in syntax-highlighted code."
        },
        "value": "#B3DF72",
        "filePath": "schema/themes/atlassian-dark/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for string values in syntax-highlighted code."
            },
            "value": "Lime300"
        },
        "name": "color.text.code.strings",
        "path": [
            "color",
            "text",
            "code",
            "strings"
        ],
        "cleanName": "color.text.code.strings"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for tags in syntax-highlighted code."
        },
        "value": "#FCA700",
        "filePath": "schema/themes/atlassian-dark/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for tags in syntax-highlighted code."
            },
            "value": "Orange400"
        },
        "name": "color.text.code.tags",
        "path": [
            "color",
            "text",
            "code",
            "tags"
        ],
        "cleanName": "color.text.code.tags"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.0.15",
            "description": "Use for text in a disabled state."
        },
        "value": "#E5E9F640",
        "filePath": "schema/themes/atlassian-dark/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.0.15",
                "description": "Use for text in a disabled state."
            },
            "value": "DarkNeutral400A"
        },
        "name": "color.text.disabled",
        "path": [
            "color",
            "text",
            "disabled"
        ],
        "cleanName": "color.text.disabled"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for text on bold backgrounds."
        },
        "value": "#1F1F21",
        "filePath": "schema/themes/atlassian-dark/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for text on bold backgrounds."
            },
            "value": "DarkNeutral100"
        },
        "name": "color.text.inverse",
        "path": [
            "color",
            "text",
            "inverse"
        ],
        "cleanName": "color.text.inverse"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for text that communicates selection, such as the active tab or a selected navigation item, or the opened state of a dropdown trigger. On bold selected backgrounds, use color.text.inverse instead. Do not use for unselected links, brand emphasis, or hover alone. Keep the selected text treatment when the element also has focus."
        },
        "value": "#669DF1",
        "filePath": "schema/themes/atlassian-dark/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for text that communicates selection, such as the active tab or a selected navigation item, or the opened state of a dropdown trigger. On bold selected backgrounds, use color.text.inverse instead. Do not use for unselected links, brand emphasis, or hover alone. Keep the selected text treatment when the element also has focus."
            },
            "value": "Blue400"
        },
        "name": "color.text.selected",
        "path": [
            "color",
            "text",
            "selected"
        ],
        "cleanName": "color.text.selected"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for text that reinforces our brand."
        },
        "value": "#669DF1",
        "filePath": "schema/themes/atlassian-dark/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for text that reinforces our brand."
            },
            "value": "Blue400"
        },
        "name": "color.text.brand",
        "path": [
            "color",
            "text",
            "brand"
        ],
        "cleanName": "color.text.brand"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.0.15",
            "description": "Use for critical text, such as input field error messaging."
        },
        "value": "#FD9891",
        "filePath": "schema/themes/atlassian-dark/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.0.15",
                "description": "Use for critical text, such as input field error messaging."
            },
            "value": "Red300"
        },
        "name": "color.text.danger.[default]",
        "path": [
            "color",
            "text",
            "danger",
            "[default]"
        ],
        "cleanName": "color.text.danger"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Use for text on top of danger semantic labels to ensure accessibility and desired visual appearance."
        },
        "value": "#FFD5D2",
        "filePath": "schema/themes/atlassian-dark/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Use for text on top of danger semantic labels to ensure accessibility and desired visual appearance."
            },
            "value": "Red200"
        },
        "name": "color.text.danger.bolder",
        "path": [
            "color",
            "text",
            "danger",
            "bolder"
        ],
        "cleanName": "color.text.danger.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.0.15",
            "description": "Use for text to emphasize caution, such as in moved lozenges."
        },
        "value": "#FBC828",
        "filePath": "schema/themes/atlassian-dark/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.0.15",
                "description": "Use for text to emphasize caution, such as in moved lozenges."
            },
            "value": "Orange300"
        },
        "name": "color.text.warning.[default]",
        "path": [
            "color",
            "text",
            "warning",
            "[default]"
        ],
        "cleanName": "color.text.warning"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for text when on bold warning backgrounds."
        },
        "value": "#1F1F21",
        "filePath": "schema/themes/atlassian-dark/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for text when on bold warning backgrounds."
            },
            "value": "DarkNeutral100"
        },
        "name": "color.text.warning.inverse",
        "path": [
            "color",
            "text",
            "warning",
            "inverse"
        ],
        "cleanName": "color.text.warning.inverse"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Use for text on top of warning semantic labels to ensure accessibility and desired visual appearance."
        },
        "value": "#FCE4A6",
        "filePath": "schema/themes/atlassian-dark/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Use for text on top of warning semantic labels to ensure accessibility and desired visual appearance."
            },
            "value": "Orange200"
        },
        "name": "color.text.warning.bolder",
        "path": [
            "color",
            "text",
            "warning",
            "bolder"
        ],
        "cleanName": "color.text.warning.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.0.15",
            "description": "Use for text to communicate a favorable outcome, such as input field success messaging."
        },
        "value": "#B3DF72",
        "filePath": "schema/themes/atlassian-dark/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.0.15",
                "description": "Use for text to communicate a favorable outcome, such as input field success messaging."
            },
            "value": "Lime300"
        },
        "name": "color.text.success.[default]",
        "path": [
            "color",
            "text",
            "success",
            "[default]"
        ],
        "cleanName": "color.text.success"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Use for text on top of success semantic labels to ensure accessibility and desired visual appearance."
        },
        "value": "#D3F1A7",
        "filePath": "schema/themes/atlassian-dark/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Use for text on top of success semantic labels to ensure accessibility and desired visual appearance."
            },
            "value": "Lime200"
        },
        "name": "color.text.success.bolder",
        "path": [
            "color",
            "text",
            "success",
            "bolder"
        ],
        "cleanName": "color.text.success.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.0.15",
            "description": "Use for text to emphasize change or something new, such as in new lozenges."
        },
        "value": "#D8A0F7",
        "filePath": "schema/themes/atlassian-dark/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.0.15",
                "description": "Use for text to emphasize change or something new, such as in new lozenges."
            },
            "value": "Purple300"
        },
        "name": "color.text.discovery.[default]",
        "path": [
            "color",
            "text",
            "discovery",
            "[default]"
        ],
        "cleanName": "color.text.discovery"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Use for text on top of discovery semantic labels to ensure accessibility and desired visual appearance."
        },
        "value": "#EED7FC",
        "filePath": "schema/themes/atlassian-dark/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Use for text on top of discovery semantic labels to ensure accessibility and desired visual appearance."
            },
            "value": "Purple200"
        },
        "name": "color.text.discovery.bolder",
        "path": [
            "color",
            "text",
            "discovery",
            "bolder"
        ],
        "cleanName": "color.text.discovery.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for informative text or to communicate something is in progress, such as in-progress lozenges."
        },
        "value": "#8FB8F6",
        "filePath": "schema/themes/atlassian-dark/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for informative text or to communicate something is in progress, such as in-progress lozenges."
            },
            "value": "Blue300"
        },
        "name": "color.text.information.[default]",
        "path": [
            "color",
            "text",
            "information",
            "[default]"
        ],
        "cleanName": "color.text.information"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Use for text on top of information semantic labels to ensure accessibility and desired visual appearance."
        },
        "value": "#CFE1FD",
        "filePath": "schema/themes/atlassian-dark/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Use for text on top of information semantic labels to ensure accessibility and desired visual appearance."
            },
            "value": "Blue200"
        },
        "name": "color.text.information.bolder",
        "path": [
            "color",
            "text",
            "information",
            "bolder"
        ],
        "cleanName": "color.text.information.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for tertiary text, such as meta-data, breadcrumbs, input field placeholder and helper text."
        },
        "value": "#96999E",
        "filePath": "schema/themes/atlassian-dark/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for tertiary text, such as meta-data, breadcrumbs, input field placeholder and helper text."
            },
            "value": "DarkNeutral700"
        },
        "name": "color.text.subtlest",
        "path": [
            "color",
            "text",
            "subtlest"
        ],
        "cleanName": "color.text.subtlest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for secondary text, such as navigation, subtle button links, input field labels, and all caps subheadings."
        },
        "value": "#A9ABAF",
        "filePath": "schema/themes/atlassian-dark/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for secondary text, such as navigation, subtle button links, input field labels, and all caps subheadings."
            },
            "value": "DarkNeutral800"
        },
        "name": "color.text.subtle",
        "path": [
            "color",
            "text",
            "subtle"
        ],
        "cleanName": "color.text.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for icon-only buttons, or icons paired with color.text"
        },
        "value": "#CECFD2",
        "filePath": "schema/themes/atlassian-dark/color/icon.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for icon-only buttons, or icons paired with color.text"
            },
            "value": "DarkNeutral1000"
        },
        "name": "color.icon.[default]",
        "path": [
            "color",
            "icon",
            "[default]"
        ],
        "cleanName": "color.icon"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.6.0",
            "description": "Use for lime icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
        },
        "value": "#82B536",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.6.0",
                "description": "Use for lime icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
            },
            "value": "Lime500"
        },
        "name": "color.icon.accent.lime",
        "path": [
            "color",
            "icon",
            "accent",
            "lime"
        ],
        "cleanName": "color.icon.accent.lime"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for red icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
        },
        "value": "#E2483D",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for red icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
            },
            "value": "Red600"
        },
        "name": "color.icon.accent.red",
        "path": [
            "color",
            "icon",
            "accent",
            "red"
        ],
        "cleanName": "color.icon.accent.red"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for orange icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
        },
        "value": "#F68909",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for orange icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
            },
            "value": "Orange500"
        },
        "name": "color.icon.accent.orange",
        "path": [
            "color",
            "icon",
            "accent",
            "orange"
        ],
        "cleanName": "color.icon.accent.orange"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for yellow icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
        },
        "value": "#EED12B",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for yellow icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
            },
            "value": "Yellow300"
        },
        "name": "color.icon.accent.yellow",
        "path": [
            "color",
            "icon",
            "accent",
            "yellow"
        ],
        "cleanName": "color.icon.accent.yellow"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for green icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
        },
        "value": "#2ABB7F",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for green icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
            },
            "value": "Green500"
        },
        "name": "color.icon.accent.green",
        "path": [
            "color",
            "icon",
            "accent",
            "green"
        ],
        "cleanName": "color.icon.accent.green"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for teal icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
        },
        "value": "#42B2D7",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for teal icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
            },
            "value": "Teal500"
        },
        "name": "color.icon.accent.teal",
        "path": [
            "color",
            "icon",
            "accent",
            "teal"
        ],
        "cleanName": "color.icon.accent.teal"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for blue icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
        },
        "value": "#4688EC",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for blue icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
            },
            "value": "Blue500"
        },
        "name": "color.icon.accent.blue",
        "path": [
            "color",
            "icon",
            "accent",
            "blue"
        ],
        "cleanName": "color.icon.accent.blue"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for purple icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
        },
        "value": "#BF63F3",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for purple icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
            },
            "value": "Purple500"
        },
        "name": "color.icon.accent.purple",
        "path": [
            "color",
            "icon",
            "accent",
            "purple"
        ],
        "cleanName": "color.icon.accent.purple"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for magenta icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
        },
        "value": "#DA62AC",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for magenta icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
            },
            "value": "Magenta500"
        },
        "name": "color.icon.accent.magenta",
        "path": [
            "color",
            "icon",
            "accent",
            "magenta"
        ],
        "cleanName": "color.icon.accent.magenta"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.10.5",
            "description": "Use for icons on non-bold gray accent backgrounds, such as file type icons."
        },
        "value": "#7E8188",
        "filePath": "schema/themes/atlassian-dark/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.10.5",
                "description": "Use for icons on non-bold gray accent backgrounds, such as file type icons."
            },
            "value": "DarkNeutral600"
        },
        "name": "color.icon.accent.gray",
        "path": [
            "color",
            "icon",
            "accent",
            "gray"
        ],
        "cleanName": "color.icon.accent.gray"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for icons in a disabled state."
        },
        "value": "#E5E9F640",
        "filePath": "schema/themes/atlassian-dark/color/icon.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for icons in a disabled state."
            },
            "value": "DarkNeutral400A"
        },
        "name": "color.icon.disabled",
        "path": [
            "color",
            "icon",
            "disabled"
        ],
        "cleanName": "color.icon.disabled"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for icons on bold backgrounds."
        },
        "value": "#1F1F21",
        "filePath": "schema/themes/atlassian-dark/color/icon.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for icons on bold backgrounds."
            },
            "value": "DarkNeutral100"
        },
        "name": "color.icon.inverse",
        "path": [
            "color",
            "icon",
            "inverse"
        ],
        "cleanName": "color.icon.inverse"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.2",
            "description": "Use for icons that communicate selection, such as icons in selected navigation items, or the opened state of a dropdown trigger. On bold selected backgrounds, use color.icon.inverse instead. Do not use for brand emphasis or hover alone. Keep the selected icon treatment when the element also has focus."
        },
        "value": "#669DF1",
        "filePath": "schema/themes/atlassian-dark/color/icon.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.2",
                "description": "Use for icons that communicate selection, such as icons in selected navigation items, or the opened state of a dropdown trigger. On bold selected backgrounds, use color.icon.inverse instead. Do not use for brand emphasis or hover alone. Keep the selected icon treatment when the element also has focus."
            },
            "value": "Blue400"
        },
        "name": "color.icon.selected",
        "path": [
            "color",
            "icon",
            "selected"
        ],
        "cleanName": "color.icon.selected"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for icons that reinforce our brand."
        },
        "value": "#669DF1",
        "filePath": "schema/themes/atlassian-dark/color/icon.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for icons that reinforce our brand."
            },
            "value": "Blue400"
        },
        "name": "color.icon.brand",
        "path": [
            "color",
            "icon",
            "brand"
        ],
        "cleanName": "color.icon.brand"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for icons communicating critical information, such as those used in error handing."
        },
        "value": "#F15B50",
        "filePath": "schema/themes/atlassian-dark/color/icon.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for icons communicating critical information, such as those used in error handing."
            },
            "value": "Red500"
        },
        "name": "color.icon.danger",
        "path": [
            "color",
            "icon",
            "danger"
        ],
        "cleanName": "color.icon.danger"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for icons communicating caution, such as those used in warning section messages."
        },
        "value": "#FBC828",
        "filePath": "schema/themes/atlassian-dark/color/icon.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for icons communicating caution, such as those used in warning section messages."
            },
            "value": "Orange300"
        },
        "name": "color.icon.warning.[default]",
        "path": [
            "color",
            "icon",
            "warning",
            "[default]"
        ],
        "cleanName": "color.icon.warning"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for icons when on bold warning backgrounds."
        },
        "value": "#1F1F21",
        "filePath": "schema/themes/atlassian-dark/color/icon.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for icons when on bold warning backgrounds."
            },
            "value": "DarkNeutral100"
        },
        "name": "color.icon.warning.inverse",
        "path": [
            "color",
            "icon",
            "warning",
            "inverse"
        ],
        "cleanName": "color.icon.warning.inverse"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for icons communicating a favorable outcome, such as those used in success section messaged."
        },
        "value": "#82B536",
        "filePath": "schema/themes/atlassian-dark/color/icon.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for icons communicating a favorable outcome, such as those used in success section messaged."
            },
            "value": "Lime500"
        },
        "name": "color.icon.success",
        "path": [
            "color",
            "icon",
            "success"
        ],
        "cleanName": "color.icon.success"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for icons communicating change or something new, such as discovery section messages."
        },
        "value": "#BF63F3",
        "filePath": "schema/themes/atlassian-dark/color/icon.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for icons communicating change or something new, such as discovery section messages."
            },
            "value": "Purple500"
        },
        "name": "color.icon.discovery",
        "path": [
            "color",
            "icon",
            "discovery"
        ],
        "cleanName": "color.icon.discovery"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for icons communicating information or something in-progress, such as information section messages."
        },
        "value": "#4688EC",
        "filePath": "schema/themes/atlassian-dark/color/icon.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for icons communicating information or something in-progress, such as information section messages."
            },
            "value": "Blue500"
        },
        "name": "color.icon.information",
        "path": [
            "color",
            "icon",
            "information"
        ],
        "cleanName": "color.icon.information"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.54.0",
            "description": "Use for icons paired with color.text.subtlest"
        },
        "value": "#96999E",
        "filePath": "schema/themes/atlassian-dark/color/icon.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.54.0",
                "description": "Use for icons paired with color.text.subtlest"
            },
            "value": "DarkNeutral700"
        },
        "name": "color.icon.subtlest",
        "path": [
            "color",
            "icon",
            "subtlest"
        ],
        "cleanName": "color.icon.subtlest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for icons paired with color.text.subtle"
        },
        "value": "#A9ABAF",
        "filePath": "schema/themes/atlassian-dark/color/icon.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for icons paired with color.text.subtle"
            },
            "value": "DarkNeutral800"
        },
        "name": "color.icon.subtle",
        "path": [
            "color",
            "icon",
            "subtle"
        ],
        "cleanName": "color.icon.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for links in a default or hovered state. Add an underline for hovered states."
        },
        "value": "#669DF1",
        "filePath": "schema/themes/atlassian-dark/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for links in a default or hovered state. Add an underline for hovered states."
            },
            "value": "Blue400"
        },
        "name": "color.link.[default]",
        "path": [
            "color",
            "link",
            "[default]"
        ],
        "cleanName": "color.link"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for links in a pressed state."
        },
        "value": "#8FB8F6",
        "filePath": "schema/themes/atlassian-dark/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for links in a pressed state."
            },
            "value": "Blue300"
        },
        "name": "color.link.pressed",
        "path": [
            "color",
            "link",
            "pressed"
        ],
        "cleanName": "color.link.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.23.0",
            "description": "Use for visited links."
        },
        "value": "#D8A0F7",
        "filePath": "schema/themes/atlassian-dark/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.23.0",
                "description": "Use for visited links."
            },
            "value": "Purple300"
        },
        "name": "color.link.visited.[default]",
        "path": [
            "color",
            "link",
            "visited",
            "[default]"
        ],
        "cleanName": "color.link.visited"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.43.0",
            "description": "Use for visited links in a pressed state."
        },
        "value": "#EED7FC",
        "filePath": "schema/themes/atlassian-dark/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.43.0",
                "description": "Use for visited links in a pressed state."
            },
            "value": "Purple200"
        },
        "name": "color.link.visited.pressed",
        "path": [
            "color",
            "link",
            "visited",
            "pressed"
        ],
        "cleanName": "color.link.visited.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use as a background overlay for elements in a hovered state when their background color cannot change, such as avatars."
        },
        "value": "#ffffff33",
        "filePath": "schema/themes/atlassian-dark/color/interaction.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use as a background overlay for elements in a hovered state when their background color cannot change, such as avatars."
            },
            "value": "#ffffff33"
        },
        "name": "color.interaction.hovered",
        "path": [
            "color",
            "interaction",
            "hovered"
        ],
        "cleanName": "color.interaction.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use as a background overlay for elements in a pressed state when their background color cannot change, such as avatars."
        },
        "value": "#ffffff5c",
        "filePath": "schema/themes/atlassian-dark/color/interaction.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use as a background overlay for elements in a pressed state when their background color cannot change, such as avatars."
            },
            "value": "#ffffff5c"
        },
        "name": "color.interaction.pressed",
        "path": [
            "color",
            "interaction",
            "pressed"
        ],
        "cleanName": "color.interaction.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.8.0",
            "description": "Use for skeleton loading states"
        },
        "value": "#CECED912",
        "filePath": "schema/themes/atlassian-dark/color/skeleton.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.8.0",
                "description": "Use for skeleton loading states"
            },
            "value": "DarkNeutral200A"
        },
        "name": "color.skeleton.[default]",
        "path": [
            "color",
            "skeleton",
            "[default]"
        ],
        "cleanName": "color.skeleton"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.8.0",
            "description": "Use for the pulse or shimmer effect in skeleton loading states"
        },
        "value": "#BDBDBD0A",
        "filePath": "schema/themes/atlassian-dark/color/skeleton.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.8.0",
                "description": "Use for the pulse or shimmer effect in skeleton loading states"
            },
            "value": "DarkNeutral100A"
        },
        "name": "color.skeleton.subtle",
        "path": [
            "color",
            "skeleton",
            "subtle"
        ],
        "cleanName": "color.skeleton.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.0.15",
            "description": "Use for the screen overlay that appears with modal dialogs"
        },
        "value": "#10121499",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.0.15",
                "description": "Use for the screen overlay that appears with modal dialogs"
            },
            "value": "#10121499"
        },
        "name": "color.blanket.[default]",
        "path": [
            "color",
            "blanket",
            "[default]"
        ],
        "cleanName": "color.blanket"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use as a translucent blanket to communicate selection when changing the background of the selected content is not possible, such as selected Editor blocks. The content beneath remains visible. Do not use to indicate keyboard focus or hover alone."
        },
        "value": "#1D7AFC14",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use as a translucent blanket to communicate selection when changing the background of the selected content is not possible, such as selected Editor blocks. The content beneath remains visible. Do not use to indicate keyboard focus or hover alone."
            },
            "value": "#1D7AFC14"
        },
        "name": "color.blanket.selected",
        "path": [
            "color",
            "blanket",
            "selected"
        ],
        "cleanName": "color.blanket.selected"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use as an overlay to communicate danger states when a simple background color change isn't possible, such as deletion of Editor block elements"
        },
        "value": "#E3493514",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use as an overlay to communicate danger states when a simple background color change isn't possible, such as deletion of Editor block elements"
            },
            "value": "#E3493514"
        },
        "name": "color.blanket.danger",
        "path": [
            "color",
            "blanket",
            "danger"
        ],
        "cleanName": "color.blanket.danger"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only. Follow numbered sequence."
        },
        "value": "#4688EC",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only. Follow numbered sequence."
            },
            "value": "Blue500"
        },
        "name": "color.chart.categorical.1.[default]",
        "path": [
            "color",
            "chart",
            "categorical",
            "1",
            "[default]"
        ],
        "cleanName": "color.chart.categorical.1"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.categorical.1."
        },
        "value": "#669DF1",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.categorical.1."
            },
            "value": "Blue400"
        },
        "name": "color.chart.categorical.1.hovered",
        "path": [
            "color",
            "chart",
            "categorical",
            "1",
            "hovered"
        ],
        "cleanName": "color.chart.categorical.1.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only. Follow numbered sequence."
        },
        "value": "#94C748",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only. Follow numbered sequence."
            },
            "value": "Lime400"
        },
        "name": "color.chart.categorical.2.[default]",
        "path": [
            "color",
            "chart",
            "categorical",
            "2",
            "[default]"
        ],
        "cleanName": "color.chart.categorical.2"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.categorical.2."
        },
        "value": "#B3DF72",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.categorical.2."
            },
            "value": "Lime300"
        },
        "name": "color.chart.categorical.2.hovered",
        "path": [
            "color",
            "chart",
            "categorical",
            "2",
            "hovered"
        ],
        "cleanName": "color.chart.categorical.2.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only. Follow numbered sequence."
        },
        "value": "#C97CF4",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only. Follow numbered sequence."
            },
            "value": "Purple400"
        },
        "name": "color.chart.categorical.3.[default]",
        "path": [
            "color",
            "chart",
            "categorical",
            "3",
            "[default]"
        ],
        "cleanName": "color.chart.categorical.3"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.categorical.3."
        },
        "value": "#D8A0F7",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.categorical.3."
            },
            "value": "Purple300"
        },
        "name": "color.chart.categorical.3.hovered",
        "path": [
            "color",
            "chart",
            "categorical",
            "3",
            "hovered"
        ],
        "cleanName": "color.chart.categorical.3.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only. Follow numbered sequence."
        },
        "value": "#FCA700",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only. Follow numbered sequence."
            },
            "value": "Orange400"
        },
        "name": "color.chart.categorical.4.[default]",
        "path": [
            "color",
            "chart",
            "categorical",
            "4",
            "[default]"
        ],
        "cleanName": "color.chart.categorical.4"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.categorical.4."
        },
        "value": "#FBC828",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.categorical.4."
            },
            "value": "Orange300"
        },
        "name": "color.chart.categorical.4.hovered",
        "path": [
            "color",
            "chart",
            "categorical",
            "4",
            "hovered"
        ],
        "cleanName": "color.chart.categorical.4.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only. Follow numbered sequence."
        },
        "value": "#1558BC",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only. Follow numbered sequence."
            },
            "value": "Blue800"
        },
        "name": "color.chart.categorical.5.[default]",
        "path": [
            "color",
            "chart",
            "categorical",
            "5",
            "[default]"
        ],
        "cleanName": "color.chart.categorical.5"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.categorical.5."
        },
        "value": "#1868DB",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.categorical.5."
            },
            "value": "Blue700"
        },
        "name": "color.chart.categorical.5.hovered",
        "path": [
            "color",
            "chart",
            "categorical",
            "5",
            "hovered"
        ],
        "cleanName": "color.chart.categorical.5.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only. Follow numbered sequence."
        },
        "value": "#964AC0",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only. Follow numbered sequence."
            },
            "value": "Purple700"
        },
        "name": "color.chart.categorical.6.[default]",
        "path": [
            "color",
            "chart",
            "categorical",
            "6",
            "[default]"
        ],
        "cleanName": "color.chart.categorical.6"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.categorical.6."
        },
        "value": "#AF59E1",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.categorical.6."
            },
            "value": "Purple600"
        },
        "name": "color.chart.categorical.6.hovered",
        "path": [
            "color",
            "chart",
            "categorical",
            "6",
            "hovered"
        ],
        "cleanName": "color.chart.categorical.6.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only. Follow numbered sequence."
        },
        "value": "#42B2D7",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only. Follow numbered sequence."
            },
            "value": "Teal500"
        },
        "name": "color.chart.categorical.7.[default]",
        "path": [
            "color",
            "chart",
            "categorical",
            "7",
            "[default]"
        ],
        "cleanName": "color.chart.categorical.7"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.categorical.7."
        },
        "value": "#6CC3E0",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.categorical.7."
            },
            "value": "Teal400"
        },
        "name": "color.chart.categorical.7.hovered",
        "path": [
            "color",
            "chart",
            "categorical",
            "7",
            "hovered"
        ],
        "cleanName": "color.chart.categorical.7.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only. Follow numbered sequence."
        },
        "value": "#E06C00",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only. Follow numbered sequence."
            },
            "value": "Orange600"
        },
        "name": "color.chart.categorical.8.[default]",
        "path": [
            "color",
            "chart",
            "categorical",
            "8",
            "[default]"
        ],
        "cleanName": "color.chart.categorical.8"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.categorical.8."
        },
        "value": "#FBD779",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.categorical.8."
            },
            "value": "Orange250"
        },
        "name": "color.chart.categorical.8.hovered",
        "path": [
            "color",
            "chart",
            "categorical",
            "8",
            "hovered"
        ],
        "cleanName": "color.chart.categorical.8.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.8.0",
            "description": "For data visualisation only."
        },
        "value": "#82B536",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.8.0",
                "description": "For data visualisation only."
            },
            "value": "Lime500"
        },
        "name": "color.chart.lime.bold.[default]",
        "path": [
            "color",
            "chart",
            "lime",
            "bold",
            "[default]"
        ],
        "cleanName": "color.chart.lime.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.8.0",
            "description": "Hovered state of color.chart.lime.bold."
        },
        "value": "#94C748",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.8.0",
                "description": "Hovered state of color.chart.lime.bold."
            },
            "value": "Lime400"
        },
        "name": "color.chart.lime.bold.hovered",
        "path": [
            "color",
            "chart",
            "lime",
            "bold",
            "hovered"
        ],
        "cleanName": "color.chart.lime.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.8.0",
            "description": "For data visualisation only."
        },
        "value": "#94C748",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.8.0",
                "description": "For data visualisation only."
            },
            "value": "Lime400"
        },
        "name": "color.chart.lime.bolder.[default]",
        "path": [
            "color",
            "chart",
            "lime",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.chart.lime.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.8.0",
            "description": "Hovered state of color.chart.lime.bolder."
        },
        "value": "#B3DF72",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.8.0",
                "description": "Hovered state of color.chart.lime.bolder."
            },
            "value": "Lime300"
        },
        "name": "color.chart.lime.bolder.hovered",
        "path": [
            "color",
            "chart",
            "lime",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.chart.lime.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.8.0",
            "description": "For data visualisation only."
        },
        "value": "#B3DF72",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.8.0",
                "description": "For data visualisation only."
            },
            "value": "Lime300"
        },
        "name": "color.chart.lime.boldest.[default]",
        "path": [
            "color",
            "chart",
            "lime",
            "boldest",
            "[default]"
        ],
        "cleanName": "color.chart.lime.boldest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.8.0",
            "description": "Hovered state of color.chart.lime.boldest."
        },
        "value": "#D3F1A7",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.8.0",
                "description": "Hovered state of color.chart.lime.boldest."
            },
            "value": "Lime200"
        },
        "name": "color.chart.lime.boldest.hovered",
        "path": [
            "color",
            "chart",
            "lime",
            "boldest",
            "hovered"
        ],
        "cleanName": "color.chart.lime.boldest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "A secondary color for data visualisation or to communicate 'to-do' statues."
        },
        "value": "#7E8188",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "A secondary color for data visualisation or to communicate 'to-do' statues."
            },
            "value": "DarkNeutral600"
        },
        "name": "color.chart.neutral.[default]",
        "path": [
            "color",
            "chart",
            "neutral",
            "[default]"
        ],
        "cleanName": "color.chart.neutral"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.neutral."
        },
        "value": "#96999E",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.neutral."
            },
            "value": "DarkNeutral700"
        },
        "name": "color.chart.neutral.hovered",
        "path": [
            "color",
            "chart",
            "neutral",
            "hovered"
        ],
        "cleanName": "color.chart.neutral.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#E2483D",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Red600"
        },
        "name": "color.chart.red.bold.[default]",
        "path": [
            "color",
            "chart",
            "red",
            "bold",
            "[default]"
        ],
        "cleanName": "color.chart.red.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.red.bold."
        },
        "value": "#F15B50",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.red.bold."
            },
            "value": "Red500"
        },
        "name": "color.chart.red.bold.hovered",
        "path": [
            "color",
            "chart",
            "red",
            "bold",
            "hovered"
        ],
        "cleanName": "color.chart.red.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#F15B50",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Red500"
        },
        "name": "color.chart.red.bolder.[default]",
        "path": [
            "color",
            "chart",
            "red",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.chart.red.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.red.bolder."
        },
        "value": "#F87168",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.red.bolder."
            },
            "value": "Red400"
        },
        "name": "color.chart.red.bolder.hovered",
        "path": [
            "color",
            "chart",
            "red",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.chart.red.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#FD9891",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Red300"
        },
        "name": "color.chart.red.boldest.[default]",
        "path": [
            "color",
            "chart",
            "red",
            "boldest",
            "[default]"
        ],
        "cleanName": "color.chart.red.boldest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.red.boldest."
        },
        "value": "#FFD5D2",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.red.boldest."
            },
            "value": "Red200"
        },
        "name": "color.chart.red.boldest.hovered",
        "path": [
            "color",
            "chart",
            "red",
            "boldest",
            "hovered"
        ],
        "cleanName": "color.chart.red.boldest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#F68909",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Orange500"
        },
        "name": "color.chart.orange.bold.[default]",
        "path": [
            "color",
            "chart",
            "orange",
            "bold",
            "[default]"
        ],
        "cleanName": "color.chart.orange.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.orange.bold."
        },
        "value": "#FCA700",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.orange.bold."
            },
            "value": "Orange400"
        },
        "name": "color.chart.orange.bold.hovered",
        "path": [
            "color",
            "chart",
            "orange",
            "bold",
            "hovered"
        ],
        "cleanName": "color.chart.orange.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#FCA700",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Orange400"
        },
        "name": "color.chart.orange.bolder.[default]",
        "path": [
            "color",
            "chart",
            "orange",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.chart.orange.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.orange.bolder."
        },
        "value": "#FBC828",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.orange.bolder."
            },
            "value": "Orange300"
        },
        "name": "color.chart.orange.bolder.hovered",
        "path": [
            "color",
            "chart",
            "orange",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.chart.orange.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#FBD779",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Orange250"
        },
        "name": "color.chart.orange.boldest.[default]",
        "path": [
            "color",
            "chart",
            "orange",
            "boldest",
            "[default]"
        ],
        "cleanName": "color.chart.orange.boldest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.orange.boldest."
        },
        "value": "#FCE4A6",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.orange.boldest."
            },
            "value": "Orange200"
        },
        "name": "color.chart.orange.boldest.hovered",
        "path": [
            "color",
            "chart",
            "orange",
            "boldest",
            "hovered"
        ],
        "cleanName": "color.chart.orange.boldest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#CF9F02",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Yellow500"
        },
        "name": "color.chart.yellow.bold.[default]",
        "path": [
            "color",
            "chart",
            "yellow",
            "bold",
            "[default]"
        ],
        "cleanName": "color.chart.yellow.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.yellow.bold."
        },
        "value": "#DDB30E",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.yellow.bold."
            },
            "value": "Yellow400"
        },
        "name": "color.chart.yellow.bold.hovered",
        "path": [
            "color",
            "chart",
            "yellow",
            "bold",
            "hovered"
        ],
        "cleanName": "color.chart.yellow.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#DDB30E",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Yellow400"
        },
        "name": "color.chart.yellow.bolder.[default]",
        "path": [
            "color",
            "chart",
            "yellow",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.chart.yellow.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.yellow.bolder."
        },
        "value": "#EED12B",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.yellow.bolder."
            },
            "value": "Yellow300"
        },
        "name": "color.chart.yellow.bolder.hovered",
        "path": [
            "color",
            "chart",
            "yellow",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.chart.yellow.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#EED12B",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Yellow300"
        },
        "name": "color.chart.yellow.boldest.[default]",
        "path": [
            "color",
            "chart",
            "yellow",
            "boldest",
            "[default]"
        ],
        "cleanName": "color.chart.yellow.boldest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.yellow.boldest."
        },
        "value": "#F5E989",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.yellow.boldest."
            },
            "value": "Yellow200"
        },
        "name": "color.chart.yellow.boldest.hovered",
        "path": [
            "color",
            "chart",
            "yellow",
            "boldest",
            "hovered"
        ],
        "cleanName": "color.chart.yellow.boldest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#2ABB7F",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Green500"
        },
        "name": "color.chart.green.bold.[default]",
        "path": [
            "color",
            "chart",
            "green",
            "bold",
            "[default]"
        ],
        "cleanName": "color.chart.green.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.green.bold."
        },
        "value": "#4BCE97",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.green.bold."
            },
            "value": "Green400"
        },
        "name": "color.chart.green.bold.hovered",
        "path": [
            "color",
            "chart",
            "green",
            "bold",
            "hovered"
        ],
        "cleanName": "color.chart.green.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#4BCE97",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Green400"
        },
        "name": "color.chart.green.bolder.[default]",
        "path": [
            "color",
            "chart",
            "green",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.chart.green.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.green.bolder."
        },
        "value": "#7EE2B8",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.green.bolder."
            },
            "value": "Green300"
        },
        "name": "color.chart.green.bolder.hovered",
        "path": [
            "color",
            "chart",
            "green",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.chart.green.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#7EE2B8",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Green300"
        },
        "name": "color.chart.green.boldest.[default]",
        "path": [
            "color",
            "chart",
            "green",
            "boldest",
            "[default]"
        ],
        "cleanName": "color.chart.green.boldest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.green.boldest."
        },
        "value": "#BAF3DB",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.green.boldest."
            },
            "value": "Green200"
        },
        "name": "color.chart.green.boldest.hovered",
        "path": [
            "color",
            "chart",
            "green",
            "boldest",
            "hovered"
        ],
        "cleanName": "color.chart.green.boldest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#42B2D7",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Teal500"
        },
        "name": "color.chart.teal.bold.[default]",
        "path": [
            "color",
            "chart",
            "teal",
            "bold",
            "[default]"
        ],
        "cleanName": "color.chart.teal.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.teal.bold."
        },
        "value": "#6CC3E0",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.teal.bold."
            },
            "value": "Teal400"
        },
        "name": "color.chart.teal.bold.hovered",
        "path": [
            "color",
            "chart",
            "teal",
            "bold",
            "hovered"
        ],
        "cleanName": "color.chart.teal.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#6CC3E0",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Teal400"
        },
        "name": "color.chart.teal.bolder.[default]",
        "path": [
            "color",
            "chart",
            "teal",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.chart.teal.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.teal.bolder."
        },
        "value": "#9DD9EE",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.teal.bolder."
            },
            "value": "Teal300"
        },
        "name": "color.chart.teal.bolder.hovered",
        "path": [
            "color",
            "chart",
            "teal",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.chart.teal.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#9DD9EE",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Teal300"
        },
        "name": "color.chart.teal.boldest.[default]",
        "path": [
            "color",
            "chart",
            "teal",
            "boldest",
            "[default]"
        ],
        "cleanName": "color.chart.teal.boldest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.teal.boldest."
        },
        "value": "#C6EDFB",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.teal.boldest."
            },
            "value": "Teal200"
        },
        "name": "color.chart.teal.boldest.hovered",
        "path": [
            "color",
            "chart",
            "teal",
            "boldest",
            "hovered"
        ],
        "cleanName": "color.chart.teal.boldest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#357DE8",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Blue600"
        },
        "name": "color.chart.blue.bold.[default]",
        "path": [
            "color",
            "chart",
            "blue",
            "bold",
            "[default]"
        ],
        "cleanName": "color.chart.blue.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.blue.bold."
        },
        "value": "#4688EC",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.blue.bold."
            },
            "value": "Blue500"
        },
        "name": "color.chart.blue.bold.hovered",
        "path": [
            "color",
            "chart",
            "blue",
            "bold",
            "hovered"
        ],
        "cleanName": "color.chart.blue.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#4688EC",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Blue500"
        },
        "name": "color.chart.blue.bolder.[default]",
        "path": [
            "color",
            "chart",
            "blue",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.chart.blue.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.blue.bolder."
        },
        "value": "#669DF1",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.blue.bolder."
            },
            "value": "Blue400"
        },
        "name": "color.chart.blue.bolder.hovered",
        "path": [
            "color",
            "chart",
            "blue",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.chart.blue.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#8FB8F6",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Blue300"
        },
        "name": "color.chart.blue.boldest.[default]",
        "path": [
            "color",
            "chart",
            "blue",
            "boldest",
            "[default]"
        ],
        "cleanName": "color.chart.blue.boldest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.blue.boldest."
        },
        "value": "#CFE1FD",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.blue.boldest."
            },
            "value": "Blue200"
        },
        "name": "color.chart.blue.boldest.hovered",
        "path": [
            "color",
            "chart",
            "blue",
            "boldest",
            "hovered"
        ],
        "cleanName": "color.chart.blue.boldest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#AF59E1",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Purple600"
        },
        "name": "color.chart.purple.bold.[default]",
        "path": [
            "color",
            "chart",
            "purple",
            "bold",
            "[default]"
        ],
        "cleanName": "color.chart.purple.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.purple.bold."
        },
        "value": "#BF63F3",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.purple.bold."
            },
            "value": "Purple500"
        },
        "name": "color.chart.purple.bold.hovered",
        "path": [
            "color",
            "chart",
            "purple",
            "bold",
            "hovered"
        ],
        "cleanName": "color.chart.purple.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#BF63F3",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Purple500"
        },
        "name": "color.chart.purple.bolder.[default]",
        "path": [
            "color",
            "chart",
            "purple",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.chart.purple.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.purple.bolder."
        },
        "value": "#C97CF4",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.purple.bolder."
            },
            "value": "Purple400"
        },
        "name": "color.chart.purple.bolder.hovered",
        "path": [
            "color",
            "chart",
            "purple",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.chart.purple.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#D8A0F7",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Purple300"
        },
        "name": "color.chart.purple.boldest.[default]",
        "path": [
            "color",
            "chart",
            "purple",
            "boldest",
            "[default]"
        ],
        "cleanName": "color.chart.purple.boldest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.purple.boldest."
        },
        "value": "#EED7FC",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.purple.boldest."
            },
            "value": "Purple200"
        },
        "name": "color.chart.purple.boldest.hovered",
        "path": [
            "color",
            "chart",
            "purple",
            "boldest",
            "hovered"
        ],
        "cleanName": "color.chart.purple.boldest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#CD519D",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Magenta600"
        },
        "name": "color.chart.magenta.bold.[default]",
        "path": [
            "color",
            "chart",
            "magenta",
            "bold",
            "[default]"
        ],
        "cleanName": "color.chart.magenta.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.magenta.bold."
        },
        "value": "#DA62AC",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.magenta.bold."
            },
            "value": "Magenta500"
        },
        "name": "color.chart.magenta.bold.hovered",
        "path": [
            "color",
            "chart",
            "magenta",
            "bold",
            "hovered"
        ],
        "cleanName": "color.chart.magenta.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#DA62AC",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Magenta500"
        },
        "name": "color.chart.magenta.bolder.[default]",
        "path": [
            "color",
            "chart",
            "magenta",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.chart.magenta.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.magenta.bolder."
        },
        "value": "#E774BB",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.magenta.bolder."
            },
            "value": "Magenta400"
        },
        "name": "color.chart.magenta.bolder.hovered",
        "path": [
            "color",
            "chart",
            "magenta",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.chart.magenta.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#F797D2",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Magenta300"
        },
        "name": "color.chart.magenta.boldest.[default]",
        "path": [
            "color",
            "chart",
            "magenta",
            "boldest",
            "[default]"
        ],
        "cleanName": "color.chart.magenta.boldest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.magenta.boldest."
        },
        "value": "#FDD0EC",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.magenta.boldest."
            },
            "value": "Magenta200"
        },
        "name": "color.chart.magenta.boldest.hovered",
        "path": [
            "color",
            "chart",
            "magenta",
            "boldest",
            "hovered"
        ],
        "cleanName": "color.chart.magenta.boldest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#7E8188",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "DarkNeutral600"
        },
        "name": "color.chart.gray.bold.[default]",
        "path": [
            "color",
            "chart",
            "gray",
            "bold",
            "[default]"
        ],
        "cleanName": "color.chart.gray.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.gray.bold."
        },
        "value": "#96999E",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.gray.bold."
            },
            "value": "DarkNeutral700"
        },
        "name": "color.chart.gray.bold.hovered",
        "path": [
            "color",
            "chart",
            "gray",
            "bold",
            "hovered"
        ],
        "cleanName": "color.chart.gray.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#96999E",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "DarkNeutral700"
        },
        "name": "color.chart.gray.bolder.[default]",
        "path": [
            "color",
            "chart",
            "gray",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.chart.gray.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.gray.bolder."
        },
        "value": "#A9ABAF",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.gray.bolder."
            },
            "value": "DarkNeutral800"
        },
        "name": "color.chart.gray.bolder.hovered",
        "path": [
            "color",
            "chart",
            "gray",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.chart.gray.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#A9ABAF",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "DarkNeutral800"
        },
        "name": "color.chart.gray.boldest.[default]",
        "path": [
            "color",
            "chart",
            "gray",
            "boldest",
            "[default]"
        ],
        "cleanName": "color.chart.gray.boldest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.gray.boldest."
        },
        "value": "#BFC1C4",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.gray.boldest."
            },
            "value": "DarkNeutral900"
        },
        "name": "color.chart.gray.boldest.hovered",
        "path": [
            "color",
            "chart",
            "gray",
            "boldest",
            "hovered"
        ],
        "cleanName": "color.chart.gray.boldest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Our primary color for data visualisation. Use when only one color is required."
        },
        "value": "#4688EC",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Our primary color for data visualisation. Use when only one color is required."
            },
            "value": "Blue500"
        },
        "name": "color.chart.brand.[default]",
        "path": [
            "color",
            "chart",
            "brand",
            "[default]"
        ],
        "cleanName": "color.chart.brand"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.brand."
        },
        "value": "#669DF1",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.brand."
            },
            "value": "Blue400"
        },
        "name": "color.chart.brand.hovered",
        "path": [
            "color",
            "chart",
            "brand",
            "hovered"
        ],
        "cleanName": "color.chart.brand.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation communicating negative information, such as 'off track'."
        },
        "value": "#E2483D",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation communicating negative information, such as 'off track'."
            },
            "value": "Red600"
        },
        "name": "color.chart.danger.[default].[default]",
        "path": [
            "color",
            "chart",
            "danger",
            "[default]",
            "[default]"
        ],
        "cleanName": "color.chart.danger"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.danger."
        },
        "value": "#F15B50",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.danger."
            },
            "value": "Red500"
        },
        "name": "color.chart.danger.[default].hovered",
        "path": [
            "color",
            "chart",
            "danger",
            "[default]",
            "hovered"
        ],
        "cleanName": "color.chart.danger.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "A stronger emphasis option of color.chart.danger."
        },
        "value": "#FFB8B2",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "A stronger emphasis option of color.chart.danger."
            },
            "value": "Red250"
        },
        "name": "color.chart.danger.bold.[default]",
        "path": [
            "color",
            "chart",
            "danger",
            "bold",
            "[default]"
        ],
        "cleanName": "color.chart.danger.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.danger.bold."
        },
        "value": "#FD9891",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.danger.bold."
            },
            "value": "Red300"
        },
        "name": "color.chart.danger.bold.hovered",
        "path": [
            "color",
            "chart",
            "danger",
            "bold",
            "hovered"
        ],
        "cleanName": "color.chart.danger.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation communicating caution, such as 'at risk' statuses."
        },
        "value": "#F68909",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation communicating caution, such as 'at risk' statuses."
            },
            "value": "Orange500"
        },
        "name": "color.chart.warning.[default].[default]",
        "path": [
            "color",
            "chart",
            "warning",
            "[default]",
            "[default]"
        ],
        "cleanName": "color.chart.warning"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.warning."
        },
        "value": "#FCA700",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.warning."
            },
            "value": "Orange400"
        },
        "name": "color.chart.warning.[default].hovered",
        "path": [
            "color",
            "chart",
            "warning",
            "[default]",
            "hovered"
        ],
        "cleanName": "color.chart.warning.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "A stronger emphasis option of color.chart.warning."
        },
        "value": "#FBC828",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "A stronger emphasis option of color.chart.warning."
            },
            "value": "Orange300"
        },
        "name": "color.chart.warning.bold.[default]",
        "path": [
            "color",
            "chart",
            "warning",
            "bold",
            "[default]"
        ],
        "cleanName": "color.chart.warning.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.warning.bold."
        },
        "value": "#FCE4A6",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.warning.bold."
            },
            "value": "Orange200"
        },
        "name": "color.chart.warning.bold.hovered",
        "path": [
            "color",
            "chart",
            "warning",
            "bold",
            "hovered"
        ],
        "cleanName": "color.chart.warning.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation communicating positive information, such as 'on track'."
        },
        "value": "#82B536",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation communicating positive information, such as 'on track'."
            },
            "value": "Lime500"
        },
        "name": "color.chart.success.[default].[default]",
        "path": [
            "color",
            "chart",
            "success",
            "[default]",
            "[default]"
        ],
        "cleanName": "color.chart.success"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.success."
        },
        "value": "#94C748",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.success."
            },
            "value": "Lime400"
        },
        "name": "color.chart.success.[default].hovered",
        "path": [
            "color",
            "chart",
            "success",
            "[default]",
            "hovered"
        ],
        "cleanName": "color.chart.success.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "A stronger emphasis option of color.chart.success."
        },
        "value": "#B3DF72",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "A stronger emphasis option of color.chart.success."
            },
            "value": "Lime300"
        },
        "name": "color.chart.success.bold.[default]",
        "path": [
            "color",
            "chart",
            "success",
            "bold",
            "[default]"
        ],
        "cleanName": "color.chart.success.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.success.bold."
        },
        "value": "#D3F1A7",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.success.bold."
            },
            "value": "Lime200"
        },
        "name": "color.chart.success.bold.hovered",
        "path": [
            "color",
            "chart",
            "success",
            "bold",
            "hovered"
        ],
        "cleanName": "color.chart.success.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation communicating 'new' statuses."
        },
        "value": "#BF63F3",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation communicating 'new' statuses."
            },
            "value": "Purple500"
        },
        "name": "color.chart.discovery.[default].[default]",
        "path": [
            "color",
            "chart",
            "discovery",
            "[default]",
            "[default]"
        ],
        "cleanName": "color.chart.discovery"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.discovery."
        },
        "value": "#C97CF4",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.discovery."
            },
            "value": "Purple400"
        },
        "name": "color.chart.discovery.[default].hovered",
        "path": [
            "color",
            "chart",
            "discovery",
            "[default]",
            "hovered"
        ],
        "cleanName": "color.chart.discovery.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "A stronger emphasis option of color.chart.discovery."
        },
        "value": "#D8A0F7",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "A stronger emphasis option of color.chart.discovery."
            },
            "value": "Purple300"
        },
        "name": "color.chart.discovery.bold.[default]",
        "path": [
            "color",
            "chart",
            "discovery",
            "bold",
            "[default]"
        ],
        "cleanName": "color.chart.discovery.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.discovery.bold."
        },
        "value": "#EED7FC",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.discovery.bold."
            },
            "value": "Purple200"
        },
        "name": "color.chart.discovery.bold.hovered",
        "path": [
            "color",
            "chart",
            "discovery",
            "bold",
            "hovered"
        ],
        "cleanName": "color.chart.discovery.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation communicating low priority or in-progress statuses."
        },
        "value": "#4688EC",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation communicating low priority or in-progress statuses."
            },
            "value": "Blue500"
        },
        "name": "color.chart.information.[default].[default]",
        "path": [
            "color",
            "chart",
            "information",
            "[default]",
            "[default]"
        ],
        "cleanName": "color.chart.information"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.information."
        },
        "value": "#669DF1",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.information."
            },
            "value": "Blue400"
        },
        "name": "color.chart.information.[default].hovered",
        "path": [
            "color",
            "chart",
            "information",
            "[default]",
            "hovered"
        ],
        "cleanName": "color.chart.information.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "A stronger emphasis option of color.chart.information."
        },
        "value": "#8FB8F6",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "A stronger emphasis option of color.chart.information."
            },
            "value": "Blue300"
        },
        "name": "color.chart.information.bold.[default]",
        "path": [
            "color",
            "chart",
            "information",
            "bold",
            "[default]"
        ],
        "cleanName": "color.chart.information.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.information.bold."
        },
        "value": "#CFE1FD",
        "filePath": "schema/themes/atlassian-dark/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.information.bold."
            },
            "value": "Blue200"
        },
        "name": "color.chart.information.bold.hovered",
        "path": [
            "color",
            "chart",
            "information",
            "bold",
            "hovered"
        ],
        "cleanName": "color.chart.information.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.2.0",
            "description": "Background color for Rovo brand emphasis."
        },
        "value": "#FFFFFF",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.2.0",
                "description": "Background color for Rovo brand emphasis."
            },
            "value": "DarkNeutral1200"
        },
        "name": "color.rovo.background.brand.bold.[default]",
        "path": [
            "color",
            "rovo",
            "background",
            "brand",
            "bold",
            "[default]"
        ],
        "cleanName": "color.rovo.background.brand.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.2.0",
            "description": "Hovered state of color.rovo.background.brand.bold."
        },
        "value": "#E2E3E4",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.2.0",
                "description": "Hovered state of color.rovo.background.brand.bold."
            },
            "value": "DarkNeutral1100"
        },
        "name": "color.rovo.background.brand.bold.hovered",
        "path": [
            "color",
            "rovo",
            "background",
            "brand",
            "bold",
            "hovered"
        ],
        "cleanName": "color.rovo.background.brand.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.2.0",
            "description": "Pressed state of color.rovo.background.brand.bold."
        },
        "value": "#CECFD2",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.2.0",
                "description": "Pressed state of color.rovo.background.brand.bold."
            },
            "value": "DarkNeutral1000"
        },
        "name": "color.rovo.background.brand.bold.pressed",
        "path": [
            "color",
            "rovo",
            "background",
            "brand",
            "bold",
            "pressed"
        ],
        "cleanName": "color.rovo.background.brand.bold.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.1.1",
            "description": "Use for Rovo lime borders."
        },
        "value": "#82B536",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.1.1",
                "description": "Use for Rovo lime borders."
            },
            "value": "Lime500"
        },
        "name": "color.rovo.border.lime",
        "path": [
            "color",
            "rovo",
            "border",
            "lime"
        ],
        "cleanName": "color.rovo.border.lime"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.1.1",
            "description": "Use for Rovo saffron borders."
        },
        "value": "#FCA700",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.1.1",
                "description": "Use for Rovo saffron borders."
            },
            "value": "Orange400"
        },
        "name": "color.rovo.border.saffron",
        "path": [
            "color",
            "rovo",
            "border",
            "saffron"
        ],
        "cleanName": "color.rovo.border.saffron"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.1.1",
            "description": "Use for Rovo blue borders."
        },
        "value": "#357DE8",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.1.1",
                "description": "Use for Rovo blue borders."
            },
            "value": "Blue600"
        },
        "name": "color.rovo.border.blue",
        "path": [
            "color",
            "rovo",
            "border",
            "blue"
        ],
        "cleanName": "color.rovo.border.blue"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.1.1",
            "description": "Use for Rovo purple borders."
        },
        "value": "#BF63F3",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.1.1",
                "description": "Use for Rovo purple borders."
            },
            "value": "Purple500"
        },
        "name": "color.rovo.border.purple",
        "path": [
            "color",
            "rovo",
            "border",
            "purple"
        ],
        "cleanName": "color.rovo.border.purple"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.1.1",
            "description": "Use for Rovo lime icons."
        },
        "value": "#82B536",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.1.1",
                "description": "Use for Rovo lime icons."
            },
            "value": "Lime500"
        },
        "name": "color.rovo.icon.lime",
        "path": [
            "color",
            "rovo",
            "icon",
            "lime"
        ],
        "cleanName": "color.rovo.icon.lime"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.1.1",
            "description": "Use for Rovo saffron icons."
        },
        "value": "#FCA700",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.1.1",
                "description": "Use for Rovo saffron icons."
            },
            "value": "Orange400"
        },
        "name": "color.rovo.icon.saffron",
        "path": [
            "color",
            "rovo",
            "icon",
            "saffron"
        ],
        "cleanName": "color.rovo.icon.saffron"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.1.1",
            "description": "Use for Rovo blue icons."
        },
        "value": "#357DE8",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.1.1",
                "description": "Use for Rovo blue icons."
            },
            "value": "Blue600"
        },
        "name": "color.rovo.icon.blue",
        "path": [
            "color",
            "rovo",
            "icon",
            "blue"
        ],
        "cleanName": "color.rovo.icon.blue"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.1.1",
            "description": "Use for Rovo purple icons."
        },
        "value": "#BF63F3",
        "filePath": "schema/themes/atlassian-dark/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.1.1",
                "description": "Use for Rovo purple icons."
            },
            "value": "Purple500"
        },
        "name": "color.rovo.icon.purple",
        "path": [
            "color",
            "rovo",
            "icon",
            "purple"
        ],
        "cleanName": "color.rovo.icon.purple"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use as the primary background for the UI."
        },
        "value": "#1F1F21",
        "filePath": "schema/themes/atlassian-dark/elevation/surface.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use as the primary background for the UI."
            },
            "value": "DarkNeutral100"
        },
        "name": "elevation.surface.[default].[default]",
        "path": [
            "elevation",
            "surface",
            "[default]",
            "[default]"
        ],
        "cleanName": "elevation.surface"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.10.20",
            "description": "Hovered state of elevation.surface"
        },
        "value": "#242528",
        "filePath": "schema/themes/atlassian-dark/elevation/surface.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.10.20",
                "description": "Hovered state of elevation.surface"
            },
            "value": "DarkNeutral200"
        },
        "name": "elevation.surface.[default].hovered",
        "path": [
            "elevation",
            "surface",
            "[default]",
            "hovered"
        ],
        "cleanName": "elevation.surface.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.10.20",
            "description": "Pressed state of elevation.surface"
        },
        "value": "#2B2C2F",
        "filePath": "schema/themes/atlassian-dark/elevation/surface.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.10.20",
                "description": "Pressed state of elevation.surface"
            },
            "value": "DarkNeutral250"
        },
        "name": "elevation.surface.[default].pressed",
        "path": [
            "elevation",
            "surface",
            "[default]",
            "pressed"
        ],
        "cleanName": "elevation.surface.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.3.0",
            "description": "Use as a neutral container surface background."
        },
        "value": "#BDBDBD0A",
        "filePath": "schema/themes/atlassian-dark/elevation/surface.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.3.0",
                "description": "Use as a neutral container surface background."
            },
            "value": "DarkNeutral100A"
        },
        "name": "elevation.surface.container.[default]",
        "path": [
            "elevation",
            "surface",
            "container",
            "[default]"
        ],
        "cleanName": "elevation.surface.container"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "14.1.0",
            "description": "Hovered state of elevation.surface.container"
        },
        "value": "#CECED912",
        "filePath": "schema/themes/atlassian-dark/elevation/surface.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "14.1.0",
                "description": "Hovered state of elevation.surface.container"
            },
            "value": "DarkNeutral200A"
        },
        "name": "elevation.surface.container.hovered",
        "path": [
            "elevation",
            "surface",
            "container",
            "hovered"
        ],
        "cleanName": "elevation.surface.container.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "14.1.0",
            "description": "Pressed state of elevation.surface.container"
        },
        "value": "#D9DAE71A",
        "filePath": "schema/themes/atlassian-dark/elevation/surface.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "14.1.0",
                "description": "Pressed state of elevation.surface.container"
            },
            "value": "DarkNeutral250A"
        },
        "name": "elevation.surface.container.pressed",
        "path": [
            "elevation",
            "surface",
            "container",
            "pressed"
        ],
        "cleanName": "elevation.surface.container.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for the background of elements that sit on top of they UI, such as modals, dialogs, dropdown menus, floating toolbars, and floating single-action buttons. Also use for the background of raised cards in a dragged state. Combine with elevation.shadow.overlay."
        },
        "value": "#2B2C2F",
        "filePath": "schema/themes/atlassian-dark/elevation/surface.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for the background of elements that sit on top of they UI, such as modals, dialogs, dropdown menus, floating toolbars, and floating single-action buttons. Also use for the background of raised cards in a dragged state. Combine with elevation.shadow.overlay."
            },
            "value": "DarkNeutral250"
        },
        "name": "elevation.surface.overlay.[default]",
        "path": [
            "elevation",
            "surface",
            "overlay",
            "[default]"
        ],
        "cleanName": "elevation.surface.overlay"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.10.20",
            "description": "Hovered state of elevation.surface.overlay"
        },
        "value": "#303134",
        "filePath": "schema/themes/atlassian-dark/elevation/surface.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.10.20",
                "description": "Hovered state of elevation.surface.overlay"
            },
            "value": "DarkNeutral300"
        },
        "name": "elevation.surface.overlay.hovered",
        "path": [
            "elevation",
            "surface",
            "overlay",
            "hovered"
        ],
        "cleanName": "elevation.surface.overlay.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.10.20",
            "description": "Pressed state of elevation.surface.overlay"
        },
        "value": "#3D3F43",
        "filePath": "schema/themes/atlassian-dark/elevation/surface.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.10.20",
                "description": "Pressed state of elevation.surface.overlay"
            },
            "value": "DarkNeutral350"
        },
        "name": "elevation.surface.overlay.pressed",
        "path": [
            "elevation",
            "surface",
            "overlay",
            "pressed"
        ],
        "cleanName": "elevation.surface.overlay.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for the background of cards that can be moved, such as Jira cards on a Kanban board. Combine with elevation.shadow.raised."
        },
        "value": "#242528",
        "filePath": "schema/themes/atlassian-dark/elevation/surface.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for the background of cards that can be moved, such as Jira cards on a Kanban board. Combine with elevation.shadow.raised."
            },
            "value": "DarkNeutral200"
        },
        "name": "elevation.surface.raised.[default]",
        "path": [
            "elevation",
            "surface",
            "raised",
            "[default]"
        ],
        "cleanName": "elevation.surface.raised"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.10.20",
            "description": "Hovered state of elevation.surface.raised"
        },
        "value": "#2B2C2F",
        "filePath": "schema/themes/atlassian-dark/elevation/surface.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.10.20",
                "description": "Hovered state of elevation.surface.raised"
            },
            "value": "DarkNeutral250"
        },
        "name": "elevation.surface.raised.hovered",
        "path": [
            "elevation",
            "surface",
            "raised",
            "hovered"
        ],
        "cleanName": "elevation.surface.raised.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.10.20",
            "description": "Pressed state of elevation.surface.raised"
        },
        "value": "#303134",
        "filePath": "schema/themes/atlassian-dark/elevation/surface.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.10.20",
                "description": "Pressed state of elevation.surface.raised"
            },
            "value": "DarkNeutral300"
        },
        "name": "elevation.surface.raised.pressed",
        "path": [
            "elevation",
            "surface",
            "raised",
            "pressed"
        ],
        "cleanName": "elevation.surface.raised.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "A secondary background for the UI commonly used for grouping items, such as Jira cards in columns."
        },
        "value": "#18191A",
        "filePath": "schema/themes/atlassian-dark/elevation/surface.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "A secondary background for the UI commonly used for grouping items, such as Jira cards in columns."
            },
            "value": "DarkNeutral0"
        },
        "name": "elevation.surface.sunken",
        "path": [
            "elevation",
            "surface",
            "sunken"
        ],
        "cleanName": "elevation.surface.sunken"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.3.0",
            "description": "Use for Rovo overlay surface backgrounds."
        },
        "value": "#242528",
        "filePath": "schema/themes/atlassian-dark/elevation/rovo/surface.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.3.0",
                "description": "Use for Rovo overlay surface backgrounds."
            },
            "value": "DarkNeutral200"
        },
        "name": "elevation.rovo.surface.overlay.[default]",
        "path": [
            "elevation",
            "rovo",
            "surface",
            "overlay",
            "[default]"
        ],
        "cleanName": "elevation.rovo.surface.overlay"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.3.0",
            "description": "Hovered state of elevation.rovo.surface.overlay."
        },
        "value": "#2B2C2F",
        "filePath": "schema/themes/atlassian-dark/elevation/rovo/surface.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.3.0",
                "description": "Hovered state of elevation.rovo.surface.overlay."
            },
            "value": "DarkNeutral250"
        },
        "name": "elevation.rovo.surface.overlay.hovered",
        "path": [
            "elevation",
            "rovo",
            "surface",
            "overlay",
            "hovered"
        ],
        "cleanName": "elevation.rovo.surface.overlay.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.3.0",
            "description": "Pressed state of elevation.rovo.surface.overlay."
        },
        "value": "#303134",
        "filePath": "schema/themes/atlassian-dark/elevation/rovo/surface.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.3.0",
                "description": "Pressed state of elevation.rovo.surface.overlay."
            },
            "value": "DarkNeutral300"
        },
        "name": "elevation.rovo.surface.overlay.pressed",
        "path": [
            "elevation",
            "rovo",
            "surface",
            "overlay",
            "pressed"
        ],
        "cleanName": "elevation.rovo.surface.overlay.pressed"
    },
    {
        "attributes": {
            "group": "shadow",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use to create a shadow when content scrolls under other content."
        },
        "value": [
            {
                "radius": 12,
                "offset": {
                    "x": 0,
                    "y": 0
                },
                "color": "#01040475",
                "opacity": 0.56
            },
            {
                "radius": 1,
                "offset": {
                    "x": 0,
                    "y": 0
                },
                "color": "#01040475",
                "opacity": 0.5
            }
        ],
        "filePath": "schema/themes/atlassian-dark/elevation/shadow.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "shadow",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use to create a shadow when content scrolls under other content."
            },
            "value": [
                {
                    "radius": 12,
                    "offset": {
                        "x": 0,
                        "y": 0
                    },
                    "color": "DarkNeutral-100A",
                    "opacity": 0.56
                },
                {
                    "radius": 1,
                    "offset": {
                        "x": 0,
                        "y": 0
                    },
                    "color": "DarkNeutral-100A",
                    "opacity": 0.5
                }
            ]
        },
        "name": "elevation.shadow.overflow.[default]",
        "path": [
            "elevation",
            "shadow",
            "overflow",
            "[default]"
        ],
        "cleanName": "elevation.shadow.overflow"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.10.32",
            "description": "Use only when elevation.shadow.overflow is not technically feasible to implement. Pair with elevation.shadow.overflow.spread to replicate the overflow shadow."
        },
        "value": "#01040480",
        "filePath": "schema/themes/atlassian-dark/elevation/shadow.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.10.32",
                "description": "Use only when elevation.shadow.overflow is not technically feasible to implement. Pair with elevation.shadow.overflow.spread to replicate the overflow shadow."
            },
            "value": "#01040480"
        },
        "name": "elevation.shadow.overflow.perimeter",
        "path": [
            "elevation",
            "shadow",
            "overflow",
            "perimeter"
        ],
        "cleanName": "elevation.shadow.overflow.perimeter"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.10.32",
            "description": "Use only when elevation.shadow.overflow is not technically feasible to implement. Pair with elevation.shadow.overflow.perimeter to replicate the overflow shadow."
        },
        "value": "#0104048f",
        "filePath": "schema/themes/atlassian-dark/elevation/shadow.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.10.32",
                "description": "Use only when elevation.shadow.overflow is not technically feasible to implement. Pair with elevation.shadow.overflow.perimeter to replicate the overflow shadow."
            },
            "value": "#0104048f"
        },
        "name": "elevation.shadow.overflow.spread",
        "path": [
            "elevation",
            "shadow",
            "overflow",
            "spread"
        ],
        "cleanName": "elevation.shadow.overflow.spread"
    },
    {
        "attributes": {
            "group": "shadow",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for the box shadow of elements that sit on top of the UI, such as modals, dropdown menus, flags, and inline dialogs. Combine with elevation.surface.overlay\n\nAlso use for the box shadow of raised cards in a dragged state."
        },
        "value": [
            {
                "radius": 0,
                "spread": 1,
                "color": "#BDBDBD",
                "offset": {
                    "x": 0,
                    "y": 0
                },
                "opacity": 0.12
            },
            {
                "radius": 12,
                "offset": {
                    "x": 0,
                    "y": 8
                },
                "color": "#01040475",
                "opacity": 0.36
            },
            {
                "radius": 1,
                "spread": 1,
                "offset": {
                    "x": 0,
                    "y": 0
                },
                "color": "#01040475",
                "opacity": 0.5
            }
        ],
        "filePath": "schema/themes/atlassian-dark/elevation/shadow.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "shadow",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for the box shadow of elements that sit on top of the UI, such as modals, dropdown menus, flags, and inline dialogs. Combine with elevation.surface.overlay\n\nAlso use for the box shadow of raised cards in a dragged state."
            },
            "value": [
                {
                    "radius": 0,
                    "spread": 1,
                    "color": "#BDBDBD",
                    "offset": {
                        "x": 0,
                        "y": 0
                    },
                    "opacity": 0.12
                },
                {
                    "radius": 12,
                    "offset": {
                        "x": 0,
                        "y": 8
                    },
                    "color": "DarkNeutral-100A",
                    "opacity": 0.36
                },
                {
                    "radius": 1,
                    "spread": 1,
                    "offset": {
                        "x": 0,
                        "y": 0
                    },
                    "color": "DarkNeutral-100A",
                    "opacity": 0.5
                }
            ]
        },
        "name": "elevation.shadow.overlay",
        "path": [
            "elevation",
            "shadow",
            "overlay"
        ],
        "cleanName": "elevation.shadow.overlay"
    },
    {
        "attributes": {
            "group": "shadow",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for the box shadow of raised card elements, such as Jira cards on a Kanban board. Combine with elevation.surface.raised"
        },
        "value": [
            {
                "radius": 0,
                "spread": 1,
                "color": "#000000",
                "offset": {
                    "x": 0,
                    "y": 0
                },
                "opacity": 0
            },
            {
                "radius": 1,
                "offset": {
                    "x": 0,
                    "y": 1
                },
                "color": "#01040475",
                "opacity": 0.5
            },
            {
                "radius": 1,
                "offset": {
                    "x": 0,
                    "y": 0
                },
                "color": "#01040475",
                "opacity": 0.5
            }
        ],
        "filePath": "schema/themes/atlassian-dark/elevation/shadow.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "shadow",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for the box shadow of raised card elements, such as Jira cards on a Kanban board. Combine with elevation.surface.raised"
            },
            "value": [
                {
                    "radius": 0,
                    "spread": 1,
                    "color": "#000000",
                    "offset": {
                        "x": 0,
                        "y": 0
                    },
                    "opacity": 0
                },
                {
                    "radius": 1,
                    "offset": {
                        "x": 0,
                        "y": 1
                    },
                    "color": "DarkNeutral-100A",
                    "opacity": 0.5
                },
                {
                    "radius": 1,
                    "offset": {
                        "x": 0,
                        "y": 0
                    },
                    "color": "DarkNeutral-100A",
                    "opacity": 0.5
                }
            ]
        },
        "name": "elevation.shadow.raised",
        "path": [
            "elevation",
            "shadow",
            "raised"
        ],
        "cleanName": "elevation.shadow.raised"
    },
    {
        "attributes": {
            "group": "opacity",
            "state": "active",
            "introduced": "0.10.13",
            "description": "Apply to images when in a disabled state."
        },
        "value": 0.4,
        "filePath": "schema/themes/atlassian-dark/opacity/opacity.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "opacity",
                "state": "active",
                "introduced": "0.10.13",
                "description": "Apply to images when in a disabled state."
            },
            "value": "Opacity40"
        },
        "name": "opacity.disabled",
        "path": [
            "opacity",
            "disabled"
        ],
        "cleanName": "opacity.disabled"
    },
    {
        "attributes": {
            "group": "opacity",
            "state": "active",
            "introduced": "0.10.13",
            "description": "Apply to content that sits under a loading spinner."
        },
        "value": 0.2,
        "filePath": "schema/themes/atlassian-dark/opacity/opacity.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "opacity",
                "state": "active",
                "introduced": "0.10.13",
                "description": "Apply to content that sits under a loading spinner."
            },
            "value": "Opacity20"
        },
        "name": "opacity.loading",
        "path": [
            "opacity",
            "loading"
        ],
        "cleanName": "opacity.loading"
    },
    {
        "attributes": {
            "group": "raw",
            "state": "active",
            "introduced": "0.1.1",
            "description": "Transparent token used for backwards compatibility between new and old theming solutions"
        },
        "value": "transparent",
        "filePath": "schema/themes/atlassian-dark/utility/utility.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "raw",
                "state": "active",
                "introduced": "0.1.1",
                "description": "Transparent token used for backwards compatibility between new and old theming solutions"
            },
            "value": "transparent"
        },
        "name": "utility.UNSAFE.transparent",
        "path": [
            "utility",
            "UNSAFE",
            "transparent"
        ],
        "cleanName": "utility.UNSAFE.transparent"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.14.0",
            "description": "A dynamic token that represents the current surface color set by a parent element. It defaults to the 'elevation.surface' token value."
        },
        "value": "#1F1F21",
        "filePath": "schema/themes/atlassian-dark/utility/utility.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.14.0",
                "description": "A dynamic token that represents the current surface color set by a parent element. It defaults to the 'elevation.surface' token value."
            },
            "value": "DarkNeutral100"
        },
        "name": "utility.elevation.surface.current",
        "path": [
            "utility",
            "elevation",
            "surface",
            "current"
        ],
        "cleanName": "utility.elevation.surface.current"
    }
];
var $999ff9597f880fd1$export$2e2bcd8739ae039 = $999ff9597f880fd1$var$tokens;

});

parcelRegister("cfahw", function(module, exports) {
$parcel$export(module.exports, "default", () => $30e1ee4df420e489$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5fe28fde9f84f65da4f55e608e01a49f>>
 * @codegenCommand yarn build tokens
 */ const $30e1ee4df420e489$var$tokens = [
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.6.0",
            "description": "Use for for backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
        },
        "value": "#EFFFD6",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.6.0",
                "description": "Use for for backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
            },
            "value": "Lime100"
        },
        "name": "color.background.accent.lime.subtlest.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "lime",
            "subtlest",
            "[default]"
        ],
        "cleanName": "color.background.accent.lime.subtlest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.lime.subtlest."
        },
        "value": "#D3F1A7",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.lime.subtlest."
            },
            "value": "Lime200"
        },
        "name": "color.background.accent.lime.subtlest.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "lime",
            "subtlest",
            "hovered"
        ],
        "cleanName": "color.background.accent.lime.subtlest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.lime.subtlest."
        },
        "value": "#BDE97C",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.lime.subtlest."
            },
            "value": "Lime250"
        },
        "name": "color.background.accent.lime.subtlest.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "lime",
            "subtlest",
            "pressed"
        ],
        "cleanName": "color.background.accent.lime.subtlest.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.6.0",
            "description": "Use for for backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#D3F1A7",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.6.0",
                "description": "Use for for backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Lime200"
        },
        "name": "color.background.accent.lime.subtler.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "lime",
            "subtler",
            "[default]"
        ],
        "cleanName": "color.background.accent.lime.subtler"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.lime.subtler."
        },
        "value": "#BDE97C",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.lime.subtler."
            },
            "value": "Lime250"
        },
        "name": "color.background.accent.lime.subtler.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "lime",
            "subtler",
            "hovered"
        ],
        "cleanName": "color.background.accent.lime.subtler.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.lime.subtler."
        },
        "value": "#B3DF72",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.lime.subtler."
            },
            "value": "Lime300"
        },
        "name": "color.background.accent.lime.subtler.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "lime",
            "subtler",
            "pressed"
        ],
        "cleanName": "color.background.accent.lime.subtler.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.6.0",
            "description": "Use for vibrant for backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#94C748",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.6.0",
                "description": "Use for vibrant for backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Lime400"
        },
        "name": "color.background.accent.lime.subtle.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "lime",
            "subtle",
            "[default]"
        ],
        "cleanName": "color.background.accent.lime.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.lime.subtle."
        },
        "value": "#B3DF72",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.lime.subtle."
            },
            "value": "Lime300"
        },
        "name": "color.background.accent.lime.subtle.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "lime",
            "subtle",
            "hovered"
        ],
        "cleanName": "color.background.accent.lime.subtle.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.lime.subtle."
        },
        "value": "#BDE97C",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.lime.subtle."
            },
            "value": "Lime250"
        },
        "name": "color.background.accent.lime.subtle.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "lime",
            "subtle",
            "pressed"
        ],
        "cleanName": "color.background.accent.lime.subtle.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.6.0",
            "description": "Use for for backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
        },
        "value": "#5B7F24",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.6.0",
                "description": "Use for for backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
            },
            "value": "Lime700"
        },
        "name": "color.background.accent.lime.bolder.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "lime",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.background.accent.lime.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.lime.bolder."
        },
        "value": "#4C6B1F",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.lime.bolder."
            },
            "value": "Lime800"
        },
        "name": "color.background.accent.lime.bolder.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "lime",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.background.accent.lime.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.lime.bolder."
        },
        "value": "#3F5224",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.lime.bolder."
            },
            "value": "Lime850"
        },
        "name": "color.background.accent.lime.bolder.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "lime",
            "bolder",
            "pressed"
        ],
        "cleanName": "color.background.accent.lime.bolder.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for red backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
        },
        "value": "#FFECEB",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for red backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
            },
            "value": "Red100"
        },
        "name": "color.background.accent.red.subtlest.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "red",
            "subtlest",
            "[default]"
        ],
        "cleanName": "color.background.accent.red.subtlest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.red.subtlest."
        },
        "value": "#FFD5D2",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.red.subtlest."
            },
            "value": "Red200"
        },
        "name": "color.background.accent.red.subtlest.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "red",
            "subtlest",
            "hovered"
        ],
        "cleanName": "color.background.accent.red.subtlest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.red.subtlest."
        },
        "value": "#FFB8B2",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.red.subtlest."
            },
            "value": "Red250"
        },
        "name": "color.background.accent.red.subtlest.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "red",
            "subtlest",
            "pressed"
        ],
        "cleanName": "color.background.accent.red.subtlest.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for red backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#FFD5D2",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for red backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Red200"
        },
        "name": "color.background.accent.red.subtler.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "red",
            "subtler",
            "[default]"
        ],
        "cleanName": "color.background.accent.red.subtler"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.red.subtler."
        },
        "value": "#FFB8B2",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.red.subtler."
            },
            "value": "Red250"
        },
        "name": "color.background.accent.red.subtler.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "red",
            "subtler",
            "hovered"
        ],
        "cleanName": "color.background.accent.red.subtler.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.red.subtler."
        },
        "value": "#FD9891",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.red.subtler."
            },
            "value": "Red300"
        },
        "name": "color.background.accent.red.subtler.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "red",
            "subtler",
            "pressed"
        ],
        "cleanName": "color.background.accent.red.subtler.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for vibrant red backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#F87168",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for vibrant red backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Red400"
        },
        "name": "color.background.accent.red.subtle.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "red",
            "subtle",
            "[default]"
        ],
        "cleanName": "color.background.accent.red.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.red.subtle."
        },
        "value": "#FD9891",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.red.subtle."
            },
            "value": "Red300"
        },
        "name": "color.background.accent.red.subtle.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "red",
            "subtle",
            "hovered"
        ],
        "cleanName": "color.background.accent.red.subtle.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.red.subtle."
        },
        "value": "#FFB8B2",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.red.subtle."
            },
            "value": "Red250"
        },
        "name": "color.background.accent.red.subtle.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "red",
            "subtle",
            "pressed"
        ],
        "cleanName": "color.background.accent.red.subtle.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for red backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
        },
        "value": "#C9372C",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for red backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
            },
            "value": "Red700"
        },
        "name": "color.background.accent.red.bolder.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "red",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.background.accent.red.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.red.bolder."
        },
        "value": "#AE2E24",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.red.bolder."
            },
            "value": "Red800"
        },
        "name": "color.background.accent.red.bolder.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "red",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.background.accent.red.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.red.bolder."
        },
        "value": "#872821",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.red.bolder."
            },
            "value": "Red850"
        },
        "name": "color.background.accent.red.bolder.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "red",
            "bolder",
            "pressed"
        ],
        "cleanName": "color.background.accent.red.bolder.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for orange backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
        },
        "value": "#FFF5DB",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for orange backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
            },
            "value": "Orange100"
        },
        "name": "color.background.accent.orange.subtlest.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "orange",
            "subtlest",
            "[default]"
        ],
        "cleanName": "color.background.accent.orange.subtlest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.orange.subtlest."
        },
        "value": "#FCE4A6",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.orange.subtlest."
            },
            "value": "Orange200"
        },
        "name": "color.background.accent.orange.subtlest.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "orange",
            "subtlest",
            "hovered"
        ],
        "cleanName": "color.background.accent.orange.subtlest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.orange.subtlest."
        },
        "value": "#FBD779",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.orange.subtlest."
            },
            "value": "Orange250"
        },
        "name": "color.background.accent.orange.subtlest.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "orange",
            "subtlest",
            "pressed"
        ],
        "cleanName": "color.background.accent.orange.subtlest.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for orange backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#FCE4A6",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for orange backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Orange200"
        },
        "name": "color.background.accent.orange.subtler.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "orange",
            "subtler",
            "[default]"
        ],
        "cleanName": "color.background.accent.orange.subtler"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.orange.subtler."
        },
        "value": "#FBD779",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.orange.subtler."
            },
            "value": "Orange250"
        },
        "name": "color.background.accent.orange.subtler.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "orange",
            "subtler",
            "hovered"
        ],
        "cleanName": "color.background.accent.orange.subtler.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.orange.subtler."
        },
        "value": "#FBC828",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.orange.subtler."
            },
            "value": "Orange300"
        },
        "name": "color.background.accent.orange.subtler.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "orange",
            "subtler",
            "pressed"
        ],
        "cleanName": "color.background.accent.orange.subtler.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for vibrant orange backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#FCA700",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for vibrant orange backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Orange400"
        },
        "name": "color.background.accent.orange.subtle.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "orange",
            "subtle",
            "[default]"
        ],
        "cleanName": "color.background.accent.orange.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.orange.subtle."
        },
        "value": "#FBC828",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.orange.subtle."
            },
            "value": "Orange300"
        },
        "name": "color.background.accent.orange.subtle.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "orange",
            "subtle",
            "hovered"
        ],
        "cleanName": "color.background.accent.orange.subtle.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.orange.subtle."
        },
        "value": "#FBD779",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.orange.subtle."
            },
            "value": "Orange250"
        },
        "name": "color.background.accent.orange.subtle.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "orange",
            "subtle",
            "pressed"
        ],
        "cleanName": "color.background.accent.orange.subtle.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for orange backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
        },
        "value": "#BD5B00",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for orange backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
            },
            "value": "Orange700"
        },
        "name": "color.background.accent.orange.bolder.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "orange",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.background.accent.orange.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.orange.bolder."
        },
        "value": "#9E4C00",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.orange.bolder."
            },
            "value": "Orange800"
        },
        "name": "color.background.accent.orange.bolder.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "orange",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.background.accent.orange.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.orange.bolder."
        },
        "value": "#7A3B00",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.orange.bolder."
            },
            "value": "Orange850"
        },
        "name": "color.background.accent.orange.bolder.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "orange",
            "bolder",
            "pressed"
        ],
        "cleanName": "color.background.accent.orange.bolder.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for yellow backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
        },
        "value": "#FEF7C8",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for yellow backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
            },
            "value": "Yellow100"
        },
        "name": "color.background.accent.yellow.subtlest.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "yellow",
            "subtlest",
            "[default]"
        ],
        "cleanName": "color.background.accent.yellow.subtlest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.yellow.subtlest."
        },
        "value": "#F5E989",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.yellow.subtlest."
            },
            "value": "Yellow200"
        },
        "name": "color.background.accent.yellow.subtlest.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "yellow",
            "subtlest",
            "hovered"
        ],
        "cleanName": "color.background.accent.yellow.subtlest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.yellow.subtlest."
        },
        "value": "#EFDD4E",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.yellow.subtlest."
            },
            "value": "Yellow250"
        },
        "name": "color.background.accent.yellow.subtlest.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "yellow",
            "subtlest",
            "pressed"
        ],
        "cleanName": "color.background.accent.yellow.subtlest.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for yellow backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#F5E989",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for yellow backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Yellow200"
        },
        "name": "color.background.accent.yellow.subtler.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "yellow",
            "subtler",
            "[default]"
        ],
        "cleanName": "color.background.accent.yellow.subtler"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.yellow.subtler."
        },
        "value": "#EFDD4E",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.yellow.subtler."
            },
            "value": "Yellow250"
        },
        "name": "color.background.accent.yellow.subtler.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "yellow",
            "subtler",
            "hovered"
        ],
        "cleanName": "color.background.accent.yellow.subtler.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.yellow.subtler."
        },
        "value": "#EED12B",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.yellow.subtler."
            },
            "value": "Yellow300"
        },
        "name": "color.background.accent.yellow.subtler.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "yellow",
            "subtler",
            "pressed"
        ],
        "cleanName": "color.background.accent.yellow.subtler.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for vibrant yellow backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#EED12B",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for vibrant yellow backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Yellow300"
        },
        "name": "color.background.accent.yellow.subtle.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "yellow",
            "subtle",
            "[default]"
        ],
        "cleanName": "color.background.accent.yellow.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.yellow.subtle."
        },
        "value": "#DDB30E",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.yellow.subtle."
            },
            "value": "Yellow400"
        },
        "name": "color.background.accent.yellow.subtle.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "yellow",
            "subtle",
            "hovered"
        ],
        "cleanName": "color.background.accent.yellow.subtle.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.yellow.subtle."
        },
        "value": "#EFDD4E",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.yellow.subtle."
            },
            "value": "Yellow250"
        },
        "name": "color.background.accent.yellow.subtle.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "yellow",
            "subtle",
            "pressed"
        ],
        "cleanName": "color.background.accent.yellow.subtle.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for yellow backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
        },
        "value": "#946F00",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for yellow backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
            },
            "value": "Yellow700"
        },
        "name": "color.background.accent.yellow.bolder.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "yellow",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.background.accent.yellow.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.yellow.bolder."
        },
        "value": "#7F5F01",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.yellow.bolder."
            },
            "value": "Yellow800"
        },
        "name": "color.background.accent.yellow.bolder.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "yellow",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.background.accent.yellow.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.yellow.bolder."
        },
        "value": "#614A05",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.yellow.bolder."
            },
            "value": "Yellow850"
        },
        "name": "color.background.accent.yellow.bolder.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "yellow",
            "bolder",
            "pressed"
        ],
        "cleanName": "color.background.accent.yellow.bolder.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for green backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
        },
        "value": "#DCFFF1",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for green backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
            },
            "value": "Green100"
        },
        "name": "color.background.accent.green.subtlest.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "green",
            "subtlest",
            "[default]"
        ],
        "cleanName": "color.background.accent.green.subtlest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.green.subtlest."
        },
        "value": "#BAF3DB",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.green.subtlest."
            },
            "value": "Green200"
        },
        "name": "color.background.accent.green.subtlest.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "green",
            "subtlest",
            "hovered"
        ],
        "cleanName": "color.background.accent.green.subtlest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.green.subtlest."
        },
        "value": "#97EDC9",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.green.subtlest."
            },
            "value": "Green250"
        },
        "name": "color.background.accent.green.subtlest.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "green",
            "subtlest",
            "pressed"
        ],
        "cleanName": "color.background.accent.green.subtlest.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for green backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#BAF3DB",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for green backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Green200"
        },
        "name": "color.background.accent.green.subtler.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "green",
            "subtler",
            "[default]"
        ],
        "cleanName": "color.background.accent.green.subtler"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.green.subtler."
        },
        "value": "#97EDC9",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.green.subtler."
            },
            "value": "Green250"
        },
        "name": "color.background.accent.green.subtler.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "green",
            "subtler",
            "hovered"
        ],
        "cleanName": "color.background.accent.green.subtler.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.green.subtler."
        },
        "value": "#7EE2B8",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.green.subtler."
            },
            "value": "Green300"
        },
        "name": "color.background.accent.green.subtler.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "green",
            "subtler",
            "pressed"
        ],
        "cleanName": "color.background.accent.green.subtler.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for vibrant green backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#4BCE97",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for vibrant green backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Green400"
        },
        "name": "color.background.accent.green.subtle.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "green",
            "subtle",
            "[default]"
        ],
        "cleanName": "color.background.accent.green.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.green.subtle."
        },
        "value": "#7EE2B8",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.green.subtle."
            },
            "value": "Green300"
        },
        "name": "color.background.accent.green.subtle.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "green",
            "subtle",
            "hovered"
        ],
        "cleanName": "color.background.accent.green.subtle.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.green.subtle."
        },
        "value": "#97EDC9",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.green.subtle."
            },
            "value": "Green250"
        },
        "name": "color.background.accent.green.subtle.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "green",
            "subtle",
            "pressed"
        ],
        "cleanName": "color.background.accent.green.subtle.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for green backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
        },
        "value": "#1F845A",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for green backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
            },
            "value": "Green700"
        },
        "name": "color.background.accent.green.bolder.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "green",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.background.accent.green.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.green.bolder."
        },
        "value": "#216E4E",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.green.bolder."
            },
            "value": "Green800"
        },
        "name": "color.background.accent.green.bolder.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "green",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.background.accent.green.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.green.bolder."
        },
        "value": "#19573D",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.green.bolder."
            },
            "value": "Green850"
        },
        "name": "color.background.accent.green.bolder.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "green",
            "bolder",
            "pressed"
        ],
        "cleanName": "color.background.accent.green.bolder.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for teal backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
        },
        "value": "#E7F9FF",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for teal backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
            },
            "value": "Teal100"
        },
        "name": "color.background.accent.teal.subtlest.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "teal",
            "subtlest",
            "[default]"
        ],
        "cleanName": "color.background.accent.teal.subtlest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.teal.subtlest."
        },
        "value": "#C6EDFB",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.teal.subtlest."
            },
            "value": "Teal200"
        },
        "name": "color.background.accent.teal.subtlest.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "teal",
            "subtlest",
            "hovered"
        ],
        "cleanName": "color.background.accent.teal.subtlest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.teal.subtlest."
        },
        "value": "#B1E4F7",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.teal.subtlest."
            },
            "value": "Teal250"
        },
        "name": "color.background.accent.teal.subtlest.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "teal",
            "subtlest",
            "pressed"
        ],
        "cleanName": "color.background.accent.teal.subtlest.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for teal backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#C6EDFB",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for teal backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Teal200"
        },
        "name": "color.background.accent.teal.subtler.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "teal",
            "subtler",
            "[default]"
        ],
        "cleanName": "color.background.accent.teal.subtler"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.teal.subtler."
        },
        "value": "#B1E4F7",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.teal.subtler."
            },
            "value": "Teal250"
        },
        "name": "color.background.accent.teal.subtler.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "teal",
            "subtler",
            "hovered"
        ],
        "cleanName": "color.background.accent.teal.subtler.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.teal.subtler."
        },
        "value": "#9DD9EE",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.teal.subtler."
            },
            "value": "Teal300"
        },
        "name": "color.background.accent.teal.subtler.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "teal",
            "subtler",
            "pressed"
        ],
        "cleanName": "color.background.accent.teal.subtler.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for vibrant teal backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#6CC3E0",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for vibrant teal backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Teal400"
        },
        "name": "color.background.accent.teal.subtle.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "teal",
            "subtle",
            "[default]"
        ],
        "cleanName": "color.background.accent.teal.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.teal.subtle."
        },
        "value": "#9DD9EE",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.teal.subtle."
            },
            "value": "Teal300"
        },
        "name": "color.background.accent.teal.subtle.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "teal",
            "subtle",
            "hovered"
        ],
        "cleanName": "color.background.accent.teal.subtle.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.teal.subtle."
        },
        "value": "#B1E4F7",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.teal.subtle."
            },
            "value": "Teal250"
        },
        "name": "color.background.accent.teal.subtle.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "teal",
            "subtle",
            "pressed"
        ],
        "cleanName": "color.background.accent.teal.subtle.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for teal backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
        },
        "value": "#227D9B",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for teal backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
            },
            "value": "Teal700"
        },
        "name": "color.background.accent.teal.bolder.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "teal",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.background.accent.teal.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.teal.bolder."
        },
        "value": "#206A83",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.teal.bolder."
            },
            "value": "Teal800"
        },
        "name": "color.background.accent.teal.bolder.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "teal",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.background.accent.teal.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.teal.bolder."
        },
        "value": "#1A5265",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.teal.bolder."
            },
            "value": "Teal850"
        },
        "name": "color.background.accent.teal.bolder.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "teal",
            "bolder",
            "pressed"
        ],
        "cleanName": "color.background.accent.teal.bolder.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for blue backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
        },
        "value": "#E9F2FE",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for blue backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
            },
            "value": "Blue100"
        },
        "name": "color.background.accent.blue.subtlest.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "blue",
            "subtlest",
            "[default]"
        ],
        "cleanName": "color.background.accent.blue.subtlest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.blue.subtlest."
        },
        "value": "#CFE1FD",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.blue.subtlest."
            },
            "value": "Blue200"
        },
        "name": "color.background.accent.blue.subtlest.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "blue",
            "subtlest",
            "hovered"
        ],
        "cleanName": "color.background.accent.blue.subtlest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.blue.subtlest."
        },
        "value": "#ADCBFB",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.blue.subtlest."
            },
            "value": "Blue250"
        },
        "name": "color.background.accent.blue.subtlest.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "blue",
            "subtlest",
            "pressed"
        ],
        "cleanName": "color.background.accent.blue.subtlest.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for blue backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#CFE1FD",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for blue backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Blue200"
        },
        "name": "color.background.accent.blue.subtler.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "blue",
            "subtler",
            "[default]"
        ],
        "cleanName": "color.background.accent.blue.subtler"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.blue.subtler."
        },
        "value": "#ADCBFB",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.blue.subtler."
            },
            "value": "Blue250"
        },
        "name": "color.background.accent.blue.subtler.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "blue",
            "subtler",
            "hovered"
        ],
        "cleanName": "color.background.accent.blue.subtler.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.blue.subtler."
        },
        "value": "#8FB8F6",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.blue.subtler."
            },
            "value": "Blue300"
        },
        "name": "color.background.accent.blue.subtler.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "blue",
            "subtler",
            "pressed"
        ],
        "cleanName": "color.background.accent.blue.subtler.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for vibrant blue backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#669DF1",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for vibrant blue backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Blue400"
        },
        "name": "color.background.accent.blue.subtle.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "blue",
            "subtle",
            "[default]"
        ],
        "cleanName": "color.background.accent.blue.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.blue.subtle."
        },
        "value": "#8FB8F6",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.blue.subtle."
            },
            "value": "Blue300"
        },
        "name": "color.background.accent.blue.subtle.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "blue",
            "subtle",
            "hovered"
        ],
        "cleanName": "color.background.accent.blue.subtle.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.blue.subtle."
        },
        "value": "#ADCBFB",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.blue.subtle."
            },
            "value": "Blue250"
        },
        "name": "color.background.accent.blue.subtle.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "blue",
            "subtle",
            "pressed"
        ],
        "cleanName": "color.background.accent.blue.subtle.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for blue backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
        },
        "value": "#1868DB",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for blue backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
            },
            "value": "Blue700"
        },
        "name": "color.background.accent.blue.bolder.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "blue",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.background.accent.blue.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.blue.bolder."
        },
        "value": "#1558BC",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.blue.bolder."
            },
            "value": "Blue800"
        },
        "name": "color.background.accent.blue.bolder.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "blue",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.background.accent.blue.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.blue.bolder."
        },
        "value": "#144794",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.blue.bolder."
            },
            "value": "Blue850"
        },
        "name": "color.background.accent.blue.bolder.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "blue",
            "bolder",
            "pressed"
        ],
        "cleanName": "color.background.accent.blue.bolder.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for purple backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
        },
        "value": "#F8EEFE",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for purple backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
            },
            "value": "Purple100"
        },
        "name": "color.background.accent.purple.subtlest.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "purple",
            "subtlest",
            "[default]"
        ],
        "cleanName": "color.background.accent.purple.subtlest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.purple.subtlest."
        },
        "value": "#EED7FC",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.purple.subtlest."
            },
            "value": "Purple200"
        },
        "name": "color.background.accent.purple.subtlest.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "purple",
            "subtlest",
            "hovered"
        ],
        "cleanName": "color.background.accent.purple.subtlest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.purple.subtlest."
        },
        "value": "#E3BDFA",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.purple.subtlest."
            },
            "value": "Purple250"
        },
        "name": "color.background.accent.purple.subtlest.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "purple",
            "subtlest",
            "pressed"
        ],
        "cleanName": "color.background.accent.purple.subtlest.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for purple backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#EED7FC",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for purple backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Purple200"
        },
        "name": "color.background.accent.purple.subtler.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "purple",
            "subtler",
            "[default]"
        ],
        "cleanName": "color.background.accent.purple.subtler"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.purple.subtler."
        },
        "value": "#E3BDFA",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.purple.subtler."
            },
            "value": "Purple250"
        },
        "name": "color.background.accent.purple.subtler.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "purple",
            "subtler",
            "hovered"
        ],
        "cleanName": "color.background.accent.purple.subtler.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.purple.subtler."
        },
        "value": "#D8A0F7",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.purple.subtler."
            },
            "value": "Purple300"
        },
        "name": "color.background.accent.purple.subtler.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "purple",
            "subtler",
            "pressed"
        ],
        "cleanName": "color.background.accent.purple.subtler.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for vibrant purple backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#C97CF4",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for vibrant purple backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Purple400"
        },
        "name": "color.background.accent.purple.subtle.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "purple",
            "subtle",
            "[default]"
        ],
        "cleanName": "color.background.accent.purple.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.purple.subtle."
        },
        "value": "#D8A0F7",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.purple.subtle."
            },
            "value": "Purple300"
        },
        "name": "color.background.accent.purple.subtle.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "purple",
            "subtle",
            "hovered"
        ],
        "cleanName": "color.background.accent.purple.subtle.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.purple.subtle."
        },
        "value": "#E3BDFA",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.purple.subtle."
            },
            "value": "Purple250"
        },
        "name": "color.background.accent.purple.subtle.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "purple",
            "subtle",
            "pressed"
        ],
        "cleanName": "color.background.accent.purple.subtle.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for purple backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
        },
        "value": "#964AC0",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for purple backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
            },
            "value": "Purple700"
        },
        "name": "color.background.accent.purple.bolder.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "purple",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.background.accent.purple.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.purple.bolder."
        },
        "value": "#803FA5",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.purple.bolder."
            },
            "value": "Purple800"
        },
        "name": "color.background.accent.purple.bolder.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "purple",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.background.accent.purple.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.purple.bolder."
        },
        "value": "#673286",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.purple.bolder."
            },
            "value": "Purple850"
        },
        "name": "color.background.accent.purple.bolder.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "purple",
            "bolder",
            "pressed"
        ],
        "cleanName": "color.background.accent.purple.bolder.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for magenta backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
        },
        "value": "#FFECF8",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for magenta backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
            },
            "value": "Magenta100"
        },
        "name": "color.background.accent.magenta.subtlest.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "magenta",
            "subtlest",
            "[default]"
        ],
        "cleanName": "color.background.accent.magenta.subtlest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.magenta.subtlest."
        },
        "value": "#FDD0EC",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.magenta.subtlest."
            },
            "value": "Magenta200"
        },
        "name": "color.background.accent.magenta.subtlest.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "magenta",
            "subtlest",
            "hovered"
        ],
        "cleanName": "color.background.accent.magenta.subtlest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.magenta.subtlest."
        },
        "value": "#FCB6E1",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.magenta.subtlest."
            },
            "value": "Magenta250"
        },
        "name": "color.background.accent.magenta.subtlest.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "magenta",
            "subtlest",
            "pressed"
        ],
        "cleanName": "color.background.accent.magenta.subtlest.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for magenta backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#FDD0EC",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for magenta backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Magenta200"
        },
        "name": "color.background.accent.magenta.subtler.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "magenta",
            "subtler",
            "[default]"
        ],
        "cleanName": "color.background.accent.magenta.subtler"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.magenta.subtler."
        },
        "value": "#FCB6E1",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.magenta.subtler."
            },
            "value": "Magenta250"
        },
        "name": "color.background.accent.magenta.subtler.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "magenta",
            "subtler",
            "hovered"
        ],
        "cleanName": "color.background.accent.magenta.subtler.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.magenta.subtler."
        },
        "value": "#F797D2",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.magenta.subtler."
            },
            "value": "Magenta300"
        },
        "name": "color.background.accent.magenta.subtler.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "magenta",
            "subtler",
            "pressed"
        ],
        "cleanName": "color.background.accent.magenta.subtler.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for vibrant magenta backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#E774BB",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for vibrant magenta backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Magenta400"
        },
        "name": "color.background.accent.magenta.subtle.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "magenta",
            "subtle",
            "[default]"
        ],
        "cleanName": "color.background.accent.magenta.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.magenta.subtle."
        },
        "value": "#F797D2",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.magenta.subtle."
            },
            "value": "Magenta300"
        },
        "name": "color.background.accent.magenta.subtle.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "magenta",
            "subtle",
            "hovered"
        ],
        "cleanName": "color.background.accent.magenta.subtle.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.magenta.subtle."
        },
        "value": "#FCB6E1",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.magenta.subtle."
            },
            "value": "Magenta250"
        },
        "name": "color.background.accent.magenta.subtle.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "magenta",
            "subtle",
            "pressed"
        ],
        "cleanName": "color.background.accent.magenta.subtle.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for magenta backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
        },
        "value": "#AE4787",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for magenta backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
            },
            "value": "Magenta700"
        },
        "name": "color.background.accent.magenta.bolder.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "magenta",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.background.accent.magenta.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.magenta.bolder."
        },
        "value": "#943D73",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.magenta.bolder."
            },
            "value": "Magenta800"
        },
        "name": "color.background.accent.magenta.bolder.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "magenta",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.background.accent.magenta.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.magenta.bolder."
        },
        "value": "#77325B",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.magenta.bolder."
            },
            "value": "Magenta850"
        },
        "name": "color.background.accent.magenta.bolder.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "magenta",
            "bolder",
            "pressed"
        ],
        "cleanName": "color.background.accent.magenta.bolder.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for gray backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
        },
        "value": "#F0F1F2",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for gray backgrounds when there is no meaning tied to the color. Reserved for when you only want a hint of color."
            },
            "value": "Neutral200"
        },
        "name": "color.background.accent.gray.subtlest.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "gray",
            "subtlest",
            "[default]"
        ],
        "cleanName": "color.background.accent.gray.subtlest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.gray.subtlest."
        },
        "value": "#DDDEE1",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.gray.subtlest."
            },
            "value": "Neutral300"
        },
        "name": "color.background.accent.gray.subtlest.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "gray",
            "subtlest",
            "hovered"
        ],
        "cleanName": "color.background.accent.gray.subtlest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.gray.subtlest."
        },
        "value": "#B7B9BE",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.gray.subtlest."
            },
            "value": "Neutral400"
        },
        "name": "color.background.accent.gray.subtlest.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "gray",
            "subtlest",
            "pressed"
        ],
        "cleanName": "color.background.accent.gray.subtlest.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for gray backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#DDDEE1",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for gray backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Neutral300"
        },
        "name": "color.background.accent.gray.subtler.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "gray",
            "subtler",
            "[default]"
        ],
        "cleanName": "color.background.accent.gray.subtler"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.gray.subtler."
        },
        "value": "#B7B9BE",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.gray.subtler."
            },
            "value": "Neutral400"
        },
        "name": "color.background.accent.gray.subtler.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "gray",
            "subtler",
            "hovered"
        ],
        "cleanName": "color.background.accent.gray.subtler.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.gray.subtler."
        },
        "value": "#8C8F97",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.gray.subtler."
            },
            "value": "Neutral500"
        },
        "name": "color.background.accent.gray.subtler.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "gray",
            "subtler",
            "pressed"
        ],
        "cleanName": "color.background.accent.gray.subtler.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for vibrant gray backgrounds when there is no meaning tied to the color, such as colored tags."
        },
        "value": "#8C8F97",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for vibrant gray backgrounds when there is no meaning tied to the color, such as colored tags."
            },
            "value": "Neutral500"
        },
        "name": "color.background.accent.gray.subtle.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "gray",
            "subtle",
            "[default]"
        ],
        "cleanName": "color.background.accent.gray.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.gray.subtle."
        },
        "value": "#B7B9BE",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.gray.subtle."
            },
            "value": "Neutral400"
        },
        "name": "color.background.accent.gray.subtle.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "gray",
            "subtle",
            "hovered"
        ],
        "cleanName": "color.background.accent.gray.subtle.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.gray.subtle."
        },
        "value": "#DDDEE1",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.gray.subtle."
            },
            "value": "Neutral300"
        },
        "name": "color.background.accent.gray.subtle.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "gray",
            "subtle",
            "pressed"
        ],
        "cleanName": "color.background.accent.gray.subtle.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for gray backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
        },
        "value": "#6B6E76",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for gray backgrounds when there is no meaning tied to the color, and the background needs to pass min 3:1 contrast requirements."
            },
            "value": "Neutral700"
        },
        "name": "color.background.accent.gray.bolder.[default]",
        "path": [
            "color",
            "background",
            "accent",
            "gray",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.background.accent.gray.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Hovered state of color.background.accent.gray.bolder."
        },
        "value": "#505258",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Hovered state of color.background.accent.gray.bolder."
            },
            "value": "Neutral800"
        },
        "name": "color.background.accent.gray.bolder.hovered",
        "path": [
            "color",
            "background",
            "accent",
            "gray",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.background.accent.gray.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.19.0",
            "description": "Pressed state of color.background.accent.gray.subtlest."
        },
        "value": "#3B3D42",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.19.0",
                "description": "Pressed state of color.background.accent.gray.subtlest."
            },
            "value": "Neutral900"
        },
        "name": "color.background.accent.gray.bolder.pressed",
        "path": [
            "color",
            "background",
            "accent",
            "gray",
            "bolder",
            "pressed"
        ],
        "cleanName": "color.background.accent.gray.bolder.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for highlighted added code lines."
        },
        "value": "#DCFFF1",
        "filePath": "schema/themes/atlassian-light/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for highlighted added code lines."
            },
            "value": "Green100"
        },
        "name": "color.background.code.added.highlight",
        "path": [
            "color",
            "background",
            "code",
            "added",
            "highlight"
        ],
        "cleanName": "color.background.code.added.highlight"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for added code lines."
        },
        "value": "#BAF3DB66",
        "filePath": "schema/themes/atlassian-light/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for added code lines."
            },
            "value": "Green200A40"
        },
        "name": "color.background.code.added.line",
        "path": [
            "color",
            "background",
            "code",
            "added",
            "line"
        ],
        "cleanName": "color.background.code.added.line"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for the default background of code blocks and code diffs."
        },
        "value": "#FFFFFF",
        "filePath": "schema/themes/atlassian-light/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for the default background of code blocks and code diffs."
            },
            "value": "Neutral0"
        },
        "name": "color.background.code.default",
        "path": [
            "color",
            "background",
            "code",
            "default"
        ],
        "cleanName": "color.background.code.default"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for the background of code gutters."
        },
        "value": "#F0F1F2",
        "filePath": "schema/themes/atlassian-light/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for the background of code gutters."
            },
            "value": "Neutral200"
        },
        "name": "color.background.code.gutter",
        "path": [
            "color",
            "background",
            "code",
            "gutter"
        ],
        "cleanName": "color.background.code.gutter"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for highlighted unchanged code lines."
        },
        "value": "#F0F1F2",
        "filePath": "schema/themes/atlassian-light/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for highlighted unchanged code lines."
            },
            "value": "Neutral200"
        },
        "name": "color.background.code.highlight",
        "path": [
            "color",
            "background",
            "code",
            "highlight"
        ],
        "cleanName": "color.background.code.highlight"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for highlighted removed code lines."
        },
        "value": "#FFECEB",
        "filePath": "schema/themes/atlassian-light/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for highlighted removed code lines."
            },
            "value": "Red100"
        },
        "name": "color.background.code.removed.highlight",
        "path": [
            "color",
            "background",
            "code",
            "removed",
            "highlight"
        ],
        "cleanName": "color.background.code.removed.highlight"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for removed code lines."
        },
        "value": "#FFD5D266",
        "filePath": "schema/themes/atlassian-light/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for removed code lines."
            },
            "value": "Red200A40"
        },
        "name": "color.background.code.removed.line",
        "path": [
            "color",
            "background",
            "code",
            "removed",
            "line"
        ],
        "cleanName": "color.background.code.removed.line"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.0.15",
            "description": "Use for backgrounds of elements in a disabled state."
        },
        "value": "#0515240F",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.0.15",
                "description": "Use for backgrounds of elements in a disabled state."
            },
            "value": "Neutral200A"
        },
        "name": "color.background.disabled",
        "path": [
            "color",
            "background",
            "disabled"
        ],
        "cleanName": "color.background.disabled"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for background of form UI elements, such as text fields, checkboxes, and radio buttons."
        },
        "value": "#FFFFFF",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for background of form UI elements, such as text fields, checkboxes, and radio buttons."
            },
            "value": "Neutral0"
        },
        "name": "color.background.input.[default]",
        "path": [
            "color",
            "background",
            "input",
            "[default]"
        ],
        "cleanName": "color.background.input"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Hovered state for color.background.input"
        },
        "value": "#F8F8F8",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Hovered state for color.background.input"
            },
            "value": "Neutral100"
        },
        "name": "color.background.input.hovered",
        "path": [
            "color",
            "background",
            "input",
            "hovered"
        ],
        "cleanName": "color.background.input.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Pressed state for color.background.input"
        },
        "value": "#FFFFFF",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Pressed state for color.background.input"
            },
            "value": "Neutral0"
        },
        "name": "color.background.input.pressed",
        "path": [
            "color",
            "background",
            "input",
            "pressed"
        ],
        "cleanName": "color.background.input.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.8.3",
            "description": "Use for backgrounds of elements on a bold background, such as in the buttons on spotlight cards."
        },
        "value": "#00000029",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.8.3",
                "description": "Use for backgrounds of elements on a bold background, such as in the buttons on spotlight cards."
            },
            "value": "#00000029"
        },
        "name": "color.background.inverse.subtle.[default]",
        "path": [
            "color",
            "background",
            "inverse",
            "subtle",
            "[default]"
        ],
        "cleanName": "color.background.inverse.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.8.3",
            "description": "Use for the hovered state of color.background.inverse.subtle"
        },
        "value": "#0000003D",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.8.3",
                "description": "Use for the hovered state of color.background.inverse.subtle"
            },
            "value": "#0000003D"
        },
        "name": "color.background.inverse.subtle.hovered",
        "path": [
            "color",
            "background",
            "inverse",
            "subtle",
            "hovered"
        ],
        "cleanName": "color.background.inverse.subtle.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.8.3",
            "description": "Use for the pressed state of color.background.inverse.subtle"
        },
        "value": "#00000052",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.8.3",
                "description": "Use for the pressed state of color.background.inverse.subtle"
            },
            "value": "#00000052"
        },
        "name": "color.background.inverse.subtle.pressed",
        "path": [
            "color",
            "background",
            "inverse",
            "subtle",
            "pressed"
        ],
        "cleanName": "color.background.inverse.subtle.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "The default background for neutral elements, such as default buttons."
        },
        "value": "#0515240F",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "The default background for neutral elements, such as default buttons."
            },
            "value": "Neutral200A"
        },
        "name": "color.background.neutral.[default].[default]",
        "path": [
            "color",
            "background",
            "neutral",
            "[default]",
            "[default]"
        ],
        "cleanName": "color.background.neutral"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Hovered state for color.background.neutral"
        },
        "value": "#0B120E24",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Hovered state for color.background.neutral"
            },
            "value": "Neutral300A"
        },
        "name": "color.background.neutral.[default].hovered",
        "path": [
            "color",
            "background",
            "neutral",
            "[default]",
            "hovered"
        ],
        "cleanName": "color.background.neutral.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Pressed state for color.background.neutral"
        },
        "value": "#080F214A",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Pressed state for color.background.neutral"
            },
            "value": "Neutral400A"
        },
        "name": "color.background.neutral.[default].pressed",
        "path": [
            "color",
            "background",
            "neutral",
            "[default]",
            "pressed"
        ],
        "cleanName": "color.background.neutral.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for the background of elements that appear to have no background in a resting state, such as subtle buttons and menu items."
        },
        "value": "#00000000",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for the background of elements that appear to have no background in a resting state, such as subtle buttons and menu items."
            },
            "value": "transparent"
        },
        "name": "color.background.neutral.subtle.[default]",
        "path": [
            "color",
            "background",
            "neutral",
            "subtle",
            "[default]"
        ],
        "cleanName": "color.background.neutral.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Hovered state for color.background.neutral.subtle"
        },
        "value": "#0515240F",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Hovered state for color.background.neutral.subtle"
            },
            "value": "Neutral200A"
        },
        "name": "color.background.neutral.subtle.hovered",
        "path": [
            "color",
            "background",
            "neutral",
            "subtle",
            "hovered"
        ],
        "cleanName": "color.background.neutral.subtle.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Pressed state for color.background.neutral.subtle"
        },
        "value": "#0B120E24",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Pressed state for color.background.neutral.subtle"
            },
            "value": "Neutral300A"
        },
        "name": "color.background.neutral.subtle.pressed",
        "path": [
            "color",
            "background",
            "neutral",
            "subtle",
            "pressed"
        ],
        "cleanName": "color.background.neutral.subtle.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "A vibrant background option for neutral UI elements, such as announcement banners."
        },
        "value": "#292A2E",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "A vibrant background option for neutral UI elements, such as announcement banners."
            },
            "value": "Neutral1000"
        },
        "name": "color.background.neutral.bold.[default]",
        "path": [
            "color",
            "background",
            "neutral",
            "bold",
            "[default]"
        ],
        "cleanName": "color.background.neutral.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Hovered state of color.background.neutral.bold"
        },
        "value": "#3B3D42",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Hovered state of color.background.neutral.bold"
            },
            "value": "Neutral900"
        },
        "name": "color.background.neutral.bold.hovered",
        "path": [
            "color",
            "background",
            "neutral",
            "bold",
            "hovered"
        ],
        "cleanName": "color.background.neutral.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Pressed state of color.background.neutral.bold"
        },
        "value": "#505258",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Pressed state of color.background.neutral.bold"
            },
            "value": "Neutral800"
        },
        "name": "color.background.neutral.bold.pressed",
        "path": [
            "color",
            "background",
            "neutral",
            "bold",
            "pressed"
        ],
        "cleanName": "color.background.neutral.bold.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.2",
            "description": "Use for the background of an element that communicates selection, such as a selected navigation item, or the opened state of a dropdown trigger. Use color.background.selected.hovered or color.background.selected.pressed when interacting with a selected element. Selection is distinct from keyboard focus and hover alone."
        },
        "value": "#E9F2FE",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.2",
                "description": "Use for the background of an element that communicates selection, such as a selected navigation item, or the opened state of a dropdown trigger. Use color.background.selected.hovered or color.background.selected.pressed when interacting with a selected element. Selection is distinct from keyboard focus and hover alone."
            },
            "value": "Blue100"
        },
        "name": "color.background.selected.[default].[default]",
        "path": [
            "color",
            "background",
            "selected",
            "[default]",
            "[default]"
        ],
        "cleanName": "color.background.selected"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.2",
            "description": "Use for the background of an element that is selected and hovered. This preserves selection while showing pointer hover; do not use for an unselected element or keyboard focus alone."
        },
        "value": "#CFE1FD",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.2",
                "description": "Use for the background of an element that is selected and hovered. This preserves selection while showing pointer hover; do not use for an unselected element or keyboard focus alone."
            },
            "value": "Blue200"
        },
        "name": "color.background.selected.[default].hovered",
        "path": [
            "color",
            "background",
            "selected",
            "[default]",
            "hovered"
        ],
        "cleanName": "color.background.selected.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.2",
            "description": "Use for the background of an element that is selected and being pressed. Return to color.background.selected or color.background.selected.hovered when the press ends and the element remains selected. Do not use for an unselected element or keyboard focus alone."
        },
        "value": "#8FB8F6",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.2",
                "description": "Use for the background of an element that is selected and being pressed. Return to color.background.selected or color.background.selected.hovered when the press ends and the element remains selected. Do not use for an unselected element or keyboard focus alone."
            },
            "value": "Blue300"
        },
        "name": "color.background.selected.[default].pressed",
        "path": [
            "color",
            "background",
            "selected",
            "[default]",
            "pressed"
        ],
        "cleanName": "color.background.selected.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.2",
            "description": "Use for the bold background of selected controls, such as checked checkboxes and selected radio buttons. Pair with color.text.inverse or color.icon.inverse for foreground content. Do not use for primary actions or keyboard focus alone."
        },
        "value": "#1868DB",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.2",
                "description": "Use for the bold background of selected controls, such as checked checkboxes and selected radio buttons. Pair with color.text.inverse or color.icon.inverse for foreground content. Do not use for primary actions or keyboard focus alone."
            },
            "value": "Blue700"
        },
        "name": "color.background.selected.bold.[default]",
        "path": [
            "color",
            "background",
            "selected",
            "bold",
            "[default]"
        ],
        "cleanName": "color.background.selected.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.2",
            "description": "Use for the background of a selected control that uses color.background.selected.bold while it is hovered, such as a checked checkbox. Pair with color.text.inverse or color.icon.inverse for foreground content. Do not use for an unselected control or keyboard focus alone."
        },
        "value": "#1558BC",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.2",
                "description": "Use for the background of a selected control that uses color.background.selected.bold while it is hovered, such as a checked checkbox. Pair with color.text.inverse or color.icon.inverse for foreground content. Do not use for an unselected control or keyboard focus alone."
            },
            "value": "Blue800"
        },
        "name": "color.background.selected.bold.hovered",
        "path": [
            "color",
            "background",
            "selected",
            "bold",
            "hovered"
        ],
        "cleanName": "color.background.selected.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.2",
            "description": "Use for the background of a selected control that uses color.background.selected.bold while it is being pressed, such as a checked checkbox. Pair with color.text.inverse or color.icon.inverse for foreground content. Do not use for an unselected control or keyboard focus alone."
        },
        "value": "#123263",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.2",
                "description": "Use for the background of a selected control that uses color.background.selected.bold while it is being pressed, such as a checked checkbox. Pair with color.text.inverse or color.icon.inverse for foreground content. Do not use for an unselected control or keyboard focus alone."
            },
            "value": "Blue900"
        },
        "name": "color.background.selected.bold.pressed",
        "path": [
            "color",
            "background",
            "selected",
            "bold",
            "pressed"
        ],
        "cleanName": "color.background.selected.bold.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.13.0",
            "description": "Use for the background of elements used to reinforce our brand, but with less emphasis."
        },
        "value": "#E9F2FE",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.13.0",
                "description": "Use for the background of elements used to reinforce our brand, but with less emphasis."
            },
            "value": "Blue100"
        },
        "name": "color.background.brand.subtlest.[default]",
        "path": [
            "color",
            "background",
            "brand",
            "subtlest",
            "[default]"
        ],
        "cleanName": "color.background.brand.subtlest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.13.0",
            "description": "Hovered state of color.background.brand.subtlest."
        },
        "value": "#CFE1FD",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.13.0",
                "description": "Hovered state of color.background.brand.subtlest."
            },
            "value": "Blue200"
        },
        "name": "color.background.brand.subtlest.hovered",
        "path": [
            "color",
            "background",
            "brand",
            "subtlest",
            "hovered"
        ],
        "cleanName": "color.background.brand.subtlest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.13.0",
            "description": "Pressed state of color.background.brand.subtlest"
        },
        "value": "#ADCBFB",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.13.0",
                "description": "Pressed state of color.background.brand.subtlest"
            },
            "value": "Blue250"
        },
        "name": "color.background.brand.subtlest.pressed",
        "path": [
            "color",
            "background",
            "brand",
            "subtlest",
            "pressed"
        ],
        "cleanName": "color.background.brand.subtlest.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for the background of elements used to reinforce our brand, but with more emphasis."
        },
        "value": "#1868DB",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for the background of elements used to reinforce our brand, but with more emphasis."
            },
            "value": "Blue700"
        },
        "name": "color.background.brand.bold.[default]",
        "path": [
            "color",
            "background",
            "brand",
            "bold",
            "[default]"
        ],
        "cleanName": "color.background.brand.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Hovered state of color.background.brand.bold."
        },
        "value": "#1558BC",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Hovered state of color.background.brand.bold."
            },
            "value": "Blue800"
        },
        "name": "color.background.brand.bold.hovered",
        "path": [
            "color",
            "background",
            "brand",
            "bold",
            "hovered"
        ],
        "cleanName": "color.background.brand.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Pressed state of color.background.brand.bold."
        },
        "value": "#144794",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Pressed state of color.background.brand.bold."
            },
            "value": "Blue850"
        },
        "name": "color.background.brand.bold.pressed",
        "path": [
            "color",
            "background",
            "brand",
            "bold",
            "pressed"
        ],
        "cleanName": "color.background.brand.bold.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.13.0",
            "description": "Use for the background of elements used to reinforce our brand, that need to stand out a lot."
        },
        "value": "#1C2B42",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.13.0",
                "description": "Use for the background of elements used to reinforce our brand, that need to stand out a lot."
            },
            "value": "Blue1000"
        },
        "name": "color.background.brand.boldest.[default]",
        "path": [
            "color",
            "background",
            "brand",
            "boldest",
            "[default]"
        ],
        "cleanName": "color.background.brand.boldest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.13.0",
            "description": "Hovered state of color.background.brand.boldest."
        },
        "value": "#123263",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.13.0",
                "description": "Hovered state of color.background.brand.boldest."
            },
            "value": "Blue900"
        },
        "name": "color.background.brand.boldest.hovered",
        "path": [
            "color",
            "background",
            "brand",
            "boldest",
            "hovered"
        ],
        "cleanName": "color.background.brand.boldest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.13.0",
            "description": "Pressed state of color.background.brand.boldest."
        },
        "value": "#144794",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.13.0",
                "description": "Pressed state of color.background.brand.boldest."
            },
            "value": "Blue850"
        },
        "name": "color.background.brand.boldest.pressed",
        "path": [
            "color",
            "background",
            "brand",
            "boldest",
            "pressed"
        ],
        "cleanName": "color.background.brand.boldest.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for backgrounds communicating critical information, such in error section messages."
        },
        "value": "#FFECEB",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for backgrounds communicating critical information, such in error section messages."
            },
            "value": "Red100"
        },
        "name": "color.background.danger.[default].[default]",
        "path": [
            "color",
            "background",
            "danger",
            "[default]",
            "[default]"
        ],
        "cleanName": "color.background.danger"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Hovered state for color.background.danger"
        },
        "value": "#FFD5D2",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Hovered state for color.background.danger"
            },
            "value": "Red200"
        },
        "name": "color.background.danger.[default].hovered",
        "path": [
            "color",
            "background",
            "danger",
            "[default]",
            "hovered"
        ],
        "cleanName": "color.background.danger.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Pressed state for color.background.danger"
        },
        "value": "#FFB8B2",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Pressed state for color.background.danger"
            },
            "value": "Red250"
        },
        "name": "color.background.danger.[default].pressed",
        "path": [
            "color",
            "background",
            "danger",
            "[default]",
            "pressed"
        ],
        "cleanName": "color.background.danger.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Use for backgrounds of danger lozenges and badges to ensure accessibility and desired visual appearance."
        },
        "value": "#FFD5D2",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Use for backgrounds of danger lozenges and badges to ensure accessibility and desired visual appearance."
            },
            "value": "Red200"
        },
        "name": "color.background.danger.subtler.[default]",
        "path": [
            "color",
            "background",
            "danger",
            "subtler",
            "[default]"
        ],
        "cleanName": "color.background.danger.subtler"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Hovered state of color.background.danger.subtler"
        },
        "value": "#FFB8B2",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Hovered state of color.background.danger.subtler"
            },
            "value": "Red250"
        },
        "name": "color.background.danger.subtler.hovered",
        "path": [
            "color",
            "background",
            "danger",
            "subtler",
            "hovered"
        ],
        "cleanName": "color.background.danger.subtler.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Pressed state of color.background.danger.subtler"
        },
        "value": "#FD9891",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Pressed state of color.background.danger.subtler"
            },
            "value": "Red300"
        },
        "name": "color.background.danger.subtler.pressed",
        "path": [
            "color",
            "background",
            "danger",
            "subtler",
            "pressed"
        ],
        "cleanName": "color.background.danger.subtler.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Background colour for non-interactive elements communicating critical danger information (e.g. semantic badges, status pills, callout chips). Sits between subtler and bold in visual emphasis. Not for interactive surfaces \u2014 see color.background.danger.bold or color.background.danger.subtler for interactive states."
        },
        "value": "#FD9891",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Background colour for non-interactive elements communicating critical danger information (e.g. semantic badges, status pills, callout chips). Sits between subtler and bold in visual emphasis. Not for interactive surfaces \u2014 see color.background.danger.bold or color.background.danger.subtler for interactive states."
            },
            "value": "Red300"
        },
        "name": "color.background.danger.subtle.[default]",
        "path": [
            "color",
            "background",
            "danger",
            "subtle",
            "[default]"
        ],
        "cleanName": "color.background.danger.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "A vibrant background option for communicating critical information, such as in danger buttons and error banners."
        },
        "value": "#C9372C",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "A vibrant background option for communicating critical information, such as in danger buttons and error banners."
            },
            "value": "Red700"
        },
        "name": "color.background.danger.bold.[default]",
        "path": [
            "color",
            "background",
            "danger",
            "bold",
            "[default]"
        ],
        "cleanName": "color.background.danger.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Hovered state of color.background.danger.bold"
        },
        "value": "#AE2E24",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Hovered state of color.background.danger.bold"
            },
            "value": "Red800"
        },
        "name": "color.background.danger.bold.hovered",
        "path": [
            "color",
            "background",
            "danger",
            "bold",
            "hovered"
        ],
        "cleanName": "color.background.danger.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Pressed state of color.background.danger.bold"
        },
        "value": "#872821",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Pressed state of color.background.danger.bold"
            },
            "value": "Red850"
        },
        "name": "color.background.danger.bold.pressed",
        "path": [
            "color",
            "background",
            "danger",
            "bold",
            "pressed"
        ],
        "cleanName": "color.background.danger.bold.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for backgrounds communicating caution, such as in warning section messages."
        },
        "value": "#FFF5DB",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for backgrounds communicating caution, such as in warning section messages."
            },
            "value": "Orange100"
        },
        "name": "color.background.warning.[default].[default]",
        "path": [
            "color",
            "background",
            "warning",
            "[default]",
            "[default]"
        ],
        "cleanName": "color.background.warning"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Hovered state for color.background.warning"
        },
        "value": "#FCE4A6",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Hovered state for color.background.warning"
            },
            "value": "Orange200"
        },
        "name": "color.background.warning.[default].hovered",
        "path": [
            "color",
            "background",
            "warning",
            "[default]",
            "hovered"
        ],
        "cleanName": "color.background.warning.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Pressed state for color.background.warning"
        },
        "value": "#FBD779",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Pressed state for color.background.warning"
            },
            "value": "Orange250"
        },
        "name": "color.background.warning.[default].pressed",
        "path": [
            "color",
            "background",
            "warning",
            "[default]",
            "pressed"
        ],
        "cleanName": "color.background.warning.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Use for backgrounds of warning lozenges and badges to ensure accessibility and desired visual appearance."
        },
        "value": "#FCE4A6",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Use for backgrounds of warning lozenges and badges to ensure accessibility and desired visual appearance."
            },
            "value": "Orange200"
        },
        "name": "color.background.warning.subtler.[default]",
        "path": [
            "color",
            "background",
            "warning",
            "subtler",
            "[default]"
        ],
        "cleanName": "color.background.warning.subtler"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Hovered state of color.background.warning.subtler"
        },
        "value": "#FBD779",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Hovered state of color.background.warning.subtler"
            },
            "value": "Orange250"
        },
        "name": "color.background.warning.subtler.hovered",
        "path": [
            "color",
            "background",
            "warning",
            "subtler",
            "hovered"
        ],
        "cleanName": "color.background.warning.subtler.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Pressed state of color.background.warning.subtler"
        },
        "value": "#FBC828",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Pressed state of color.background.warning.subtler"
            },
            "value": "Orange300"
        },
        "name": "color.background.warning.subtler.pressed",
        "path": [
            "color",
            "background",
            "warning",
            "subtler",
            "pressed"
        ],
        "cleanName": "color.background.warning.subtler.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Background colour for non-interactive elements communicating caution (e.g. status pills, callout chips). Sits between subtler and bold in visual emphasis. Not for interactive surfaces \u2014 see color.background.warning.bold or color.background.warning.subtler for interactive states."
        },
        "value": "#FBD779",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Background colour for non-interactive elements communicating caution (e.g. status pills, callout chips). Sits between subtler and bold in visual emphasis. Not for interactive surfaces \u2014 see color.background.warning.bold or color.background.warning.subtler for interactive states."
            },
            "value": "Orange250"
        },
        "name": "color.background.warning.subtle.[default]",
        "path": [
            "color",
            "background",
            "warning",
            "subtle",
            "[default]"
        ],
        "cleanName": "color.background.warning.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "A vibrant background option for communicating caution, such as in warning buttons and warning banners."
        },
        "value": "#FBC828",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "A vibrant background option for communicating caution, such as in warning buttons and warning banners."
            },
            "value": "Orange300"
        },
        "name": "color.background.warning.bold.[default]",
        "path": [
            "color",
            "background",
            "warning",
            "bold",
            "[default]"
        ],
        "cleanName": "color.background.warning.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Hovered state of color.background.warning.bold"
        },
        "value": "#FCA700",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Hovered state of color.background.warning.bold"
            },
            "value": "Orange400"
        },
        "name": "color.background.warning.bold.hovered",
        "path": [
            "color",
            "background",
            "warning",
            "bold",
            "hovered"
        ],
        "cleanName": "color.background.warning.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Pressed state of color.background.warning.bold"
        },
        "value": "#F68909",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Pressed state of color.background.warning.bold"
            },
            "value": "Orange500"
        },
        "name": "color.background.warning.bold.pressed",
        "path": [
            "color",
            "background",
            "warning",
            "bold",
            "pressed"
        ],
        "cleanName": "color.background.warning.bold.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for backgrounds communicating a favorable outcome, such as in success section messages."
        },
        "value": "#EFFFD6",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for backgrounds communicating a favorable outcome, such as in success section messages."
            },
            "value": "Lime100"
        },
        "name": "color.background.success.[default].[default]",
        "path": [
            "color",
            "background",
            "success",
            "[default]",
            "[default]"
        ],
        "cleanName": "color.background.success"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Hovered state for color.background.success"
        },
        "value": "#D3F1A7",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Hovered state for color.background.success"
            },
            "value": "Lime200"
        },
        "name": "color.background.success.[default].hovered",
        "path": [
            "color",
            "background",
            "success",
            "[default]",
            "hovered"
        ],
        "cleanName": "color.background.success.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Pressed state for color.background.success"
        },
        "value": "#BDE97C",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Pressed state for color.background.success"
            },
            "value": "Lime250"
        },
        "name": "color.background.success.[default].pressed",
        "path": [
            "color",
            "background",
            "success",
            "[default]",
            "pressed"
        ],
        "cleanName": "color.background.success.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Use for backgrounds of success lozenges and badges to ensure accessibility and desired visual appearance."
        },
        "value": "#D3F1A7",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Use for backgrounds of success lozenges and badges to ensure accessibility and desired visual appearance."
            },
            "value": "Lime200"
        },
        "name": "color.background.success.subtler.[default]",
        "path": [
            "color",
            "background",
            "success",
            "subtler",
            "[default]"
        ],
        "cleanName": "color.background.success.subtler"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Hovered state of color.background.success.subtler"
        },
        "value": "#BDE97C",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Hovered state of color.background.success.subtler"
            },
            "value": "Lime250"
        },
        "name": "color.background.success.subtler.hovered",
        "path": [
            "color",
            "background",
            "success",
            "subtler",
            "hovered"
        ],
        "cleanName": "color.background.success.subtler.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Pressed state of color.background.success.subtler"
        },
        "value": "#B3DF72",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Pressed state of color.background.success.subtler"
            },
            "value": "Lime300"
        },
        "name": "color.background.success.subtler.pressed",
        "path": [
            "color",
            "background",
            "success",
            "subtler",
            "pressed"
        ],
        "cleanName": "color.background.success.subtler.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Background colour for non-interactive elements communicating success (e.g. semantic badges, status pills, callout chips). Sits between subtler and bold in visual emphasis. Not for interactive surfaces \u2014 see color.background.success.bold or color.background.success.subtler for interactive states."
        },
        "value": "#B3DF72",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Background colour for non-interactive elements communicating success (e.g. semantic badges, status pills, callout chips). Sits between subtler and bold in visual emphasis. Not for interactive surfaces \u2014 see color.background.success.bold or color.background.success.subtler for interactive states."
            },
            "value": "Lime300"
        },
        "name": "color.background.success.subtle.[default]",
        "path": [
            "color",
            "background",
            "success",
            "subtle",
            "[default]"
        ],
        "cleanName": "color.background.success.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "A vibrant background option for communicating a favorable outcome, such as in checked toggles."
        },
        "value": "#5B7F24",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "A vibrant background option for communicating a favorable outcome, such as in checked toggles."
            },
            "value": "Lime700"
        },
        "name": "color.background.success.bold.[default]",
        "path": [
            "color",
            "background",
            "success",
            "bold",
            "[default]"
        ],
        "cleanName": "color.background.success.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Hovered state of color.background.success.bold"
        },
        "value": "#4C6B1F",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Hovered state of color.background.success.bold"
            },
            "value": "Lime800"
        },
        "name": "color.background.success.bold.hovered",
        "path": [
            "color",
            "background",
            "success",
            "bold",
            "hovered"
        ],
        "cleanName": "color.background.success.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Pressed state of color.background.success.bold"
        },
        "value": "#3F5224",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Pressed state of color.background.success.bold"
            },
            "value": "Lime850"
        },
        "name": "color.background.success.bold.pressed",
        "path": [
            "color",
            "background",
            "success",
            "bold",
            "pressed"
        ],
        "cleanName": "color.background.success.bold.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for backgrounds communicating change or something new, such as in discovery section messages."
        },
        "value": "#F8EEFE",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for backgrounds communicating change or something new, such as in discovery section messages."
            },
            "value": "Purple100"
        },
        "name": "color.background.discovery.[default].[default]",
        "path": [
            "color",
            "background",
            "discovery",
            "[default]",
            "[default]"
        ],
        "cleanName": "color.background.discovery"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Hover state for color.background.discovery"
        },
        "value": "#EED7FC",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Hover state for color.background.discovery"
            },
            "value": "Purple200"
        },
        "name": "color.background.discovery.[default].hovered",
        "path": [
            "color",
            "background",
            "discovery",
            "[default]",
            "hovered"
        ],
        "cleanName": "color.background.discovery.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Pressed state for color.background.discovery"
        },
        "value": "#E3BDFA",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Pressed state for color.background.discovery"
            },
            "value": "Purple250"
        },
        "name": "color.background.discovery.[default].pressed",
        "path": [
            "color",
            "background",
            "discovery",
            "[default]",
            "pressed"
        ],
        "cleanName": "color.background.discovery.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Use for backgrounds of discovery lozenges and badges to ensure accessibility and desired visual appearance."
        },
        "value": "#EED7FC",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Use for backgrounds of discovery lozenges and badges to ensure accessibility and desired visual appearance."
            },
            "value": "Purple200"
        },
        "name": "color.background.discovery.subtler.[default]",
        "path": [
            "color",
            "background",
            "discovery",
            "subtler",
            "[default]"
        ],
        "cleanName": "color.background.discovery.subtler"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Hovered state of color.background.discovery.subtler"
        },
        "value": "#E3BDFA",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Hovered state of color.background.discovery.subtler"
            },
            "value": "Purple250"
        },
        "name": "color.background.discovery.subtler.hovered",
        "path": [
            "color",
            "background",
            "discovery",
            "subtler",
            "hovered"
        ],
        "cleanName": "color.background.discovery.subtler.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Pressed state of color.background.discovery.subtler"
        },
        "value": "#D8A0F7",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Pressed state of color.background.discovery.subtler"
            },
            "value": "Purple300"
        },
        "name": "color.background.discovery.subtler.pressed",
        "path": [
            "color",
            "background",
            "discovery",
            "subtler",
            "pressed"
        ],
        "cleanName": "color.background.discovery.subtler.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Background colour for non-interactive elements communicating discovery (e.g. semantic badges, status pills, callout chips). Sits between subtler and bold in visual emphasis. Not for interactive surfaces \u2014 see color.background.discovery.bold or color.background.discovery.subtler for interactive states."
        },
        "value": "#D8A0F7",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Background colour for non-interactive elements communicating discovery (e.g. semantic badges, status pills, callout chips). Sits between subtler and bold in visual emphasis. Not for interactive surfaces \u2014 see color.background.discovery.bold or color.background.discovery.subtler for interactive states."
            },
            "value": "Purple300"
        },
        "name": "color.background.discovery.subtle.[default]",
        "path": [
            "color",
            "background",
            "discovery",
            "subtle",
            "[default]"
        ],
        "cleanName": "color.background.discovery.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "A vibrant background option communicating change or something new, such as in onboarding spotlights."
        },
        "value": "#964AC0",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "A vibrant background option communicating change or something new, such as in onboarding spotlights."
            },
            "value": "Purple700"
        },
        "name": "color.background.discovery.bold.[default]",
        "path": [
            "color",
            "background",
            "discovery",
            "bold",
            "[default]"
        ],
        "cleanName": "color.background.discovery.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Hovered state of color.background.discovery.bold"
        },
        "value": "#803FA5",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Hovered state of color.background.discovery.bold"
            },
            "value": "Purple800"
        },
        "name": "color.background.discovery.bold.hovered",
        "path": [
            "color",
            "background",
            "discovery",
            "bold",
            "hovered"
        ],
        "cleanName": "color.background.discovery.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Pressed state of color.background.discovery.bold"
        },
        "value": "#673286",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Pressed state of color.background.discovery.bold"
            },
            "value": "Purple850"
        },
        "name": "color.background.discovery.bold.pressed",
        "path": [
            "color",
            "background",
            "discovery",
            "bold",
            "pressed"
        ],
        "cleanName": "color.background.discovery.bold.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for backgrounds communicating information or something in-progress, such as in information section messages."
        },
        "value": "#E9F2FE",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for backgrounds communicating information or something in-progress, such as in information section messages."
            },
            "value": "Blue100"
        },
        "name": "color.background.information.[default].[default]",
        "path": [
            "color",
            "background",
            "information",
            "[default]",
            "[default]"
        ],
        "cleanName": "color.background.information"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Hovered state of color.background.information"
        },
        "value": "#CFE1FD",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Hovered state of color.background.information"
            },
            "value": "Blue200"
        },
        "name": "color.background.information.[default].hovered",
        "path": [
            "color",
            "background",
            "information",
            "[default]",
            "hovered"
        ],
        "cleanName": "color.background.information.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Pressed state of color.background.information"
        },
        "value": "#ADCBFB",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Pressed state of color.background.information"
            },
            "value": "Blue250"
        },
        "name": "color.background.information.[default].pressed",
        "path": [
            "color",
            "background",
            "information",
            "[default]",
            "pressed"
        ],
        "cleanName": "color.background.information.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Use for backgrounds of information lozenges and badges to ensure accessibility and desired visual appearance."
        },
        "value": "#CFE1FD",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Use for backgrounds of information lozenges and badges to ensure accessibility and desired visual appearance."
            },
            "value": "Blue200"
        },
        "name": "color.background.information.subtler.[default]",
        "path": [
            "color",
            "background",
            "information",
            "subtler",
            "[default]"
        ],
        "cleanName": "color.background.information.subtler"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Hovered state of color.background.information.subtler"
        },
        "value": "#ADCBFB",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Hovered state of color.background.information.subtler"
            },
            "value": "Blue250"
        },
        "name": "color.background.information.subtler.hovered",
        "path": [
            "color",
            "background",
            "information",
            "subtler",
            "hovered"
        ],
        "cleanName": "color.background.information.subtler.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Pressed state of color.background.information.subtler"
        },
        "value": "#8FB8F6",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Pressed state of color.background.information.subtler"
            },
            "value": "Blue300"
        },
        "name": "color.background.information.subtler.pressed",
        "path": [
            "color",
            "background",
            "information",
            "subtler",
            "pressed"
        ],
        "cleanName": "color.background.information.subtler.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Background colour for non-interactive elements communicating information (e.g. semantic badges, status pills, callout chips). Sits between subtler and bold in visual emphasis. Not for interactive surfaces \u2014 see color.background.information.bold or color.background.information.subtler for interactive states."
        },
        "value": "#8FB8F6",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Background colour for non-interactive elements communicating information (e.g. semantic badges, status pills, callout chips). Sits between subtler and bold in visual emphasis. Not for interactive surfaces \u2014 see color.background.information.bold or color.background.information.subtler for interactive states."
            },
            "value": "Blue300"
        },
        "name": "color.background.information.subtle.[default]",
        "path": [
            "color",
            "background",
            "information",
            "subtle",
            "[default]"
        ],
        "cleanName": "color.background.information.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "A vibrant background option for communicating information or something in-progress."
        },
        "value": "#1868DB",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "A vibrant background option for communicating information or something in-progress."
            },
            "value": "Blue700"
        },
        "name": "color.background.information.bold.[default]",
        "path": [
            "color",
            "background",
            "information",
            "bold",
            "[default]"
        ],
        "cleanName": "color.background.information.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Hovered state of color.background.information.bold"
        },
        "value": "#1558BC",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Hovered state of color.background.information.bold"
            },
            "value": "Blue800"
        },
        "name": "color.background.information.bold.hovered",
        "path": [
            "color",
            "background",
            "information",
            "bold",
            "hovered"
        ],
        "cleanName": "color.background.information.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Pressed state of color.background.information.bold"
        },
        "value": "#144794",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Pressed state of color.background.information.bold"
            },
            "value": "Blue850"
        },
        "name": "color.background.information.bold.pressed",
        "path": [
            "color",
            "background",
            "information",
            "bold",
            "pressed"
        ],
        "cleanName": "color.background.information.bold.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use to visually group or separate UI elements, such as flat cards or side panel dividers."
        },
        "value": "#0B120E24",
        "filePath": "schema/themes/atlassian-light/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use to visually group or separate UI elements, such as flat cards or side panel dividers."
            },
            "value": "Neutral300A"
        },
        "name": "color.border.[default]",
        "path": [
            "color",
            "border",
            "[default]"
        ],
        "cleanName": "color.border"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.6.0",
            "description": "Use for lime borders on non-bold backgrounds when there is no meaning tied to the color."
        },
        "value": "#6A9A23",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.6.0",
                "description": "Use for lime borders on non-bold backgrounds when there is no meaning tied to the color."
            },
            "value": "Lime600"
        },
        "name": "color.border.accent.lime.[default]",
        "path": [
            "color",
            "border",
            "accent",
            "lime",
            "[default]"
        ],
        "cleanName": "color.border.accent.lime"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Use for decorative lime borders that do not need to meet 3:1 contrast requirements."
        },
        "value": "#B3DF72",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Use for decorative lime borders that do not need to meet 3:1 contrast requirements."
            },
            "value": "Lime300"
        },
        "name": "color.border.accent.lime.subtle",
        "path": [
            "color",
            "border",
            "accent",
            "lime",
            "subtle"
        ],
        "cleanName": "color.border.accent.lime.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for red borders on non-bold backgrounds when there is no meaning tied to the color."
        },
        "value": "#E2483D",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for red borders on non-bold backgrounds when there is no meaning tied to the color."
            },
            "value": "Red600"
        },
        "name": "color.border.accent.red.[default]",
        "path": [
            "color",
            "border",
            "accent",
            "red",
            "[default]"
        ],
        "cleanName": "color.border.accent.red"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Use for decorative red borders that do not need to meet 3:1 contrast requirements."
        },
        "value": "#FD9891",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Use for decorative red borders that do not need to meet 3:1 contrast requirements."
            },
            "value": "Red300"
        },
        "name": "color.border.accent.red.subtle",
        "path": [
            "color",
            "border",
            "accent",
            "red",
            "subtle"
        ],
        "cleanName": "color.border.accent.red.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for orange borders on non-bold backgrounds when there is no meaning tied to the color."
        },
        "value": "#E06C00",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for orange borders on non-bold backgrounds when there is no meaning tied to the color."
            },
            "value": "Orange600"
        },
        "name": "color.border.accent.orange.[default]",
        "path": [
            "color",
            "border",
            "accent",
            "orange",
            "[default]"
        ],
        "cleanName": "color.border.accent.orange"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Use for decorative orange borders that do not need to meet 3:1 contrast requirements."
        },
        "value": "#FBC828",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Use for decorative orange borders that do not need to meet 3:1 contrast requirements."
            },
            "value": "Orange300"
        },
        "name": "color.border.accent.orange.subtle",
        "path": [
            "color",
            "border",
            "accent",
            "orange",
            "subtle"
        ],
        "cleanName": "color.border.accent.orange.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for yellow borders on non-bold backgrounds when there is no meaning tied to the color."
        },
        "value": "#B38600",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for yellow borders on non-bold backgrounds when there is no meaning tied to the color."
            },
            "value": "Yellow600"
        },
        "name": "color.border.accent.yellow.[default]",
        "path": [
            "color",
            "border",
            "accent",
            "yellow",
            "[default]"
        ],
        "cleanName": "color.border.accent.yellow"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Use for decorative yellow borders that do not need to meet 3:1 contrast requirements."
        },
        "value": "#EED12B",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Use for decorative yellow borders that do not need to meet 3:1 contrast requirements."
            },
            "value": "Yellow300"
        },
        "name": "color.border.accent.yellow.subtle",
        "path": [
            "color",
            "border",
            "accent",
            "yellow",
            "subtle"
        ],
        "cleanName": "color.border.accent.yellow.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for green borders on non-bold backgrounds when there is no meaning tied to the color."
        },
        "value": "#22A06B",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for green borders on non-bold backgrounds when there is no meaning tied to the color."
            },
            "value": "Green600"
        },
        "name": "color.border.accent.green.[default]",
        "path": [
            "color",
            "border",
            "accent",
            "green",
            "[default]"
        ],
        "cleanName": "color.border.accent.green"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Use for decorative green borders that do not need to meet 3:1 contrast requirements."
        },
        "value": "#7EE2B8",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Use for decorative green borders that do not need to meet 3:1 contrast requirements."
            },
            "value": "Green300"
        },
        "name": "color.border.accent.green.subtle",
        "path": [
            "color",
            "border",
            "accent",
            "green",
            "subtle"
        ],
        "cleanName": "color.border.accent.green.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for teal borders on non-bold backgrounds when there is no meaning tied to the color."
        },
        "value": "#2898BD",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for teal borders on non-bold backgrounds when there is no meaning tied to the color."
            },
            "value": "Teal600"
        },
        "name": "color.border.accent.teal.[default]",
        "path": [
            "color",
            "border",
            "accent",
            "teal",
            "[default]"
        ],
        "cleanName": "color.border.accent.teal"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Use for decorative teal borders that do not need to meet 3:1 contrast requirements."
        },
        "value": "#9DD9EE",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Use for decorative teal borders that do not need to meet 3:1 contrast requirements."
            },
            "value": "Teal300"
        },
        "name": "color.border.accent.teal.subtle",
        "path": [
            "color",
            "border",
            "accent",
            "teal",
            "subtle"
        ],
        "cleanName": "color.border.accent.teal.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for blue borders on non-bold backgrounds when there is no meaning tied to the color."
        },
        "value": "#357DE8",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for blue borders on non-bold backgrounds when there is no meaning tied to the color."
            },
            "value": "Blue600"
        },
        "name": "color.border.accent.blue.[default]",
        "path": [
            "color",
            "border",
            "accent",
            "blue",
            "[default]"
        ],
        "cleanName": "color.border.accent.blue"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Use for decorative blue borders that do not need to meet 3:1 contrast requirements."
        },
        "value": "#8FB8F6",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Use for decorative blue borders that do not need to meet 3:1 contrast requirements."
            },
            "value": "Blue300"
        },
        "name": "color.border.accent.blue.subtle",
        "path": [
            "color",
            "border",
            "accent",
            "blue",
            "subtle"
        ],
        "cleanName": "color.border.accent.blue.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for purple borders on non-bold backgrounds when there is no meaning tied to the color."
        },
        "value": "#AF59E1",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for purple borders on non-bold backgrounds when there is no meaning tied to the color."
            },
            "value": "Purple600"
        },
        "name": "color.border.accent.purple.[default]",
        "path": [
            "color",
            "border",
            "accent",
            "purple",
            "[default]"
        ],
        "cleanName": "color.border.accent.purple"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Use for decorative purple borders that do not need to meet 3:1 contrast requirements."
        },
        "value": "#D8A0F7",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Use for decorative purple borders that do not need to meet 3:1 contrast requirements."
            },
            "value": "Purple300"
        },
        "name": "color.border.accent.purple.subtle",
        "path": [
            "color",
            "border",
            "accent",
            "purple",
            "subtle"
        ],
        "cleanName": "color.border.accent.purple.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for magenta borders on non-bold backgrounds when there is no meaning tied to the color."
        },
        "value": "#CD519D",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for magenta borders on non-bold backgrounds when there is no meaning tied to the color."
            },
            "value": "Magenta600"
        },
        "name": "color.border.accent.magenta.[default]",
        "path": [
            "color",
            "border",
            "accent",
            "magenta",
            "[default]"
        ],
        "cleanName": "color.border.accent.magenta"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Use for decorative magenta borders that do not need to meet 3:1 contrast requirements."
        },
        "value": "#F797D2",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Use for decorative magenta borders that do not need to meet 3:1 contrast requirements."
            },
            "value": "Magenta300"
        },
        "name": "color.border.accent.magenta.subtle",
        "path": [
            "color",
            "border",
            "accent",
            "magenta",
            "subtle"
        ],
        "cleanName": "color.border.accent.magenta.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.10.5",
            "description": "Use for borders on non-bold gray accent backgrounds."
        },
        "value": "#7D818A",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.10.5",
                "description": "Use for borders on non-bold gray accent backgrounds."
            },
            "value": "Neutral600"
        },
        "name": "color.border.accent.gray.[default]",
        "path": [
            "color",
            "border",
            "accent",
            "gray",
            "[default]"
        ],
        "cleanName": "color.border.accent.gray"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Use for decorative gray borders that do not need to meet 3:1 contrast requirements."
        },
        "value": "#B7B9BE",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Use for decorative gray borders that do not need to meet 3:1 contrast requirements."
            },
            "value": "Neutral400"
        },
        "name": "color.border.accent.gray.subtle",
        "path": [
            "color",
            "border",
            "accent",
            "gray",
            "subtle"
        ],
        "cleanName": "color.border.accent.gray.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for code block and code diff borders."
        },
        "value": "#0B120E24",
        "filePath": "schema/themes/atlassian-light/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for code block and code diff borders."
            },
            "value": "Neutral300A"
        },
        "name": "color.border.code",
        "path": [
            "color",
            "border",
            "code"
        ],
        "cleanName": "color.border.code"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for borders of elements in a disabled state."
        },
        "value": "#0515240F",
        "filePath": "schema/themes/atlassian-light/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for borders of elements in a disabled state."
            },
            "value": "Neutral200A"
        },
        "name": "color.border.disabled",
        "path": [
            "color",
            "border",
            "disabled"
        ],
        "cleanName": "color.border.disabled"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for the focus ring or border of an element that currently has keyboard or input focus. Do not use to indicate selection or hover alone. When an element is both selected and focused, keep its selected treatment and add a separate focus indicator."
        },
        "value": "#4688EC",
        "filePath": "schema/themes/atlassian-light/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for the focus ring or border of an element that currently has keyboard or input focus. Do not use to indicate selection or hover alone. When an element is both selected and focused, keep its selected treatment and add a separate focus indicator."
            },
            "value": "Blue500"
        },
        "name": "color.border.focused",
        "path": [
            "color",
            "border",
            "focused"
        ],
        "cleanName": "color.border.focused"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for borders of form UI elements, such as text fields, checkboxes, and radio buttons."
        },
        "value": "#8C8F97",
        "filePath": "schema/themes/atlassian-light/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for borders of form UI elements, such as text fields, checkboxes, and radio buttons."
            },
            "value": "Neutral500"
        },
        "name": "color.border.input.[default]",
        "path": [
            "color",
            "border",
            "input",
            "[default]"
        ],
        "cleanName": "color.border.input"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.12.0",
            "description": "Use for the border of search inputs."
        },
        "value": "#0B120E24",
        "filePath": "schema/themes/atlassian-light/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.12.0",
                "description": "Use for the border of search inputs."
            },
            "value": "Neutral300A"
        },
        "name": "color.border.input.search",
        "path": [
            "color",
            "border",
            "input",
            "search"
        ],
        "cleanName": "color.border.input.search"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for borders on bold backgrounds."
        },
        "value": "#FFFFFF",
        "filePath": "schema/themes/atlassian-light/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for borders on bold backgrounds."
            },
            "value": "Neutral0"
        },
        "name": "color.border.inverse",
        "path": [
            "color",
            "border",
            "inverse"
        ],
        "cleanName": "color.border.inverse"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.2",
            "description": "Use for borders or visual indicators that communicate selection, such as the active tab or a selected menu item, or the opened state of a dropdown trigger. Do not use as a keyboard focus indicator; use color.border.focused for focus and preserve the selected treatment when both states apply."
        },
        "value": "#1868DB",
        "filePath": "schema/themes/atlassian-light/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.2",
                "description": "Use for borders or visual indicators that communicate selection, such as the active tab or a selected menu item, or the opened state of a dropdown trigger. Do not use as a keyboard focus indicator; use color.border.focused for focus and preserve the selected treatment when both states apply."
            },
            "value": "Blue700"
        },
        "name": "color.border.selected",
        "path": [
            "color",
            "border",
            "selected"
        ],
        "cleanName": "color.border.selected"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for borders or visual indicators of elements that reinforce our brand, such as logos or primary buttons."
        },
        "value": "#1868DB",
        "filePath": "schema/themes/atlassian-light/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for borders or visual indicators of elements that reinforce our brand, such as logos or primary buttons."
            },
            "value": "Blue700"
        },
        "name": "color.border.brand",
        "path": [
            "color",
            "border",
            "brand"
        ],
        "cleanName": "color.border.brand"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for borders communicating critical information, such as the borders on invalid text fields."
        },
        "value": "#E2483D",
        "filePath": "schema/themes/atlassian-light/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for borders communicating critical information, such as the borders on invalid text fields."
            },
            "value": "Red600"
        },
        "name": "color.border.danger.[default]",
        "path": [
            "color",
            "border",
            "danger",
            "[default]"
        ],
        "cleanName": "color.border.danger"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Use for decorative danger borders that do not need to meet 3:1 contrast requirements."
        },
        "value": "#FD9891",
        "filePath": "schema/themes/atlassian-light/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Use for decorative danger borders that do not need to meet 3:1 contrast requirements."
            },
            "value": "Red300"
        },
        "name": "color.border.danger.subtle",
        "path": [
            "color",
            "border",
            "danger",
            "subtle"
        ],
        "cleanName": "color.border.danger.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for borders communicating caution."
        },
        "value": "#E06C00",
        "filePath": "schema/themes/atlassian-light/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for borders communicating caution."
            },
            "value": "Orange600"
        },
        "name": "color.border.warning.[default]",
        "path": [
            "color",
            "border",
            "warning",
            "[default]"
        ],
        "cleanName": "color.border.warning"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Use for decorative warning borders that do not need to meet 3:1 contrast requirements."
        },
        "value": "#FBC828",
        "filePath": "schema/themes/atlassian-light/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Use for decorative warning borders that do not need to meet 3:1 contrast requirements."
            },
            "value": "Orange300"
        },
        "name": "color.border.warning.subtle",
        "path": [
            "color",
            "border",
            "warning",
            "subtle"
        ],
        "cleanName": "color.border.warning.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for borders communicating a favorable outcome, such as the borders on validated text fields."
        },
        "value": "#6A9A23",
        "filePath": "schema/themes/atlassian-light/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for borders communicating a favorable outcome, such as the borders on validated text fields."
            },
            "value": "Lime600"
        },
        "name": "color.border.success.[default]",
        "path": [
            "color",
            "border",
            "success",
            "[default]"
        ],
        "cleanName": "color.border.success"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Use for decorative success borders that do not need to meet 3:1 contrast requirements."
        },
        "value": "#B3DF72",
        "filePath": "schema/themes/atlassian-light/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Use for decorative success borders that do not need to meet 3:1 contrast requirements."
            },
            "value": "Lime300"
        },
        "name": "color.border.success.subtle",
        "path": [
            "color",
            "border",
            "success",
            "subtle"
        ],
        "cleanName": "color.border.success.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for borders communicating change or something new, such as the borders in onboarding spotlights."
        },
        "value": "#AF59E1",
        "filePath": "schema/themes/atlassian-light/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for borders communicating change or something new, such as the borders in onboarding spotlights."
            },
            "value": "Purple600"
        },
        "name": "color.border.discovery.[default]",
        "path": [
            "color",
            "border",
            "discovery",
            "[default]"
        ],
        "cleanName": "color.border.discovery"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Use for decorative discovery borders that do not need to meet 3:1 contrast requirements."
        },
        "value": "#D8A0F7",
        "filePath": "schema/themes/atlassian-light/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Use for decorative discovery borders that do not need to meet 3:1 contrast requirements."
            },
            "value": "Purple300"
        },
        "name": "color.border.discovery.subtle",
        "path": [
            "color",
            "border",
            "discovery",
            "subtle"
        ],
        "cleanName": "color.border.discovery.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for borders communicating information or something in-progress."
        },
        "value": "#357DE8",
        "filePath": "schema/themes/atlassian-light/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for borders communicating information or something in-progress."
            },
            "value": "Blue600"
        },
        "name": "color.border.information.[default]",
        "path": [
            "color",
            "border",
            "information",
            "[default]"
        ],
        "cleanName": "color.border.information"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.2.0",
            "description": "Use for decorative information borders that do not need to meet 3:1 contrast requirements."
        },
        "value": "#8FB8F6",
        "filePath": "schema/themes/atlassian-light/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.2.0",
                "description": "Use for decorative information borders that do not need to meet 3:1 contrast requirements."
            },
            "value": "Blue300"
        },
        "name": "color.border.information.subtle",
        "path": [
            "color",
            "border",
            "information",
            "subtle"
        ],
        "cleanName": "color.border.information.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.10.8",
            "description": "A neutral border option that passes min 3:1 contrast ratios."
        },
        "value": "#7D818A",
        "filePath": "schema/themes/atlassian-light/color/border.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.10.8",
                "description": "A neutral border option that passes min 3:1 contrast ratios."
            },
            "value": "Neutral600"
        },
        "name": "color.border.bold",
        "path": [
            "color",
            "border",
            "bold"
        ],
        "cleanName": "color.border.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for primary text, such as body copy, sentence case headers, and buttons."
        },
        "value": "#292A2E",
        "filePath": "schema/themes/atlassian-light/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for primary text, such as body copy, sentence case headers, and buttons."
            },
            "value": "Neutral1000"
        },
        "name": "color.text.[default]",
        "path": [
            "color",
            "text",
            "[default]"
        ],
        "cleanName": "color.text"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.8.0",
            "description": "Use for lime text on subtlest and subtler lime accent backgrounds when there is no meaning tied to the color."
        },
        "value": "#4C6B1F",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.8.0",
                "description": "Use for lime text on subtlest and subtler lime accent backgrounds when there is no meaning tied to the color."
            },
            "value": "Lime800"
        },
        "name": "color.text.accent.lime.[default]",
        "path": [
            "color",
            "text",
            "accent",
            "lime",
            "[default]"
        ],
        "cleanName": "color.text.accent.lime"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.8.0",
            "description": "Use for lime text on subtle lime accent backgrounds when there is no meaning tied to the color."
        },
        "value": "#37471F",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.8.0",
                "description": "Use for lime text on subtle lime accent backgrounds when there is no meaning tied to the color."
            },
            "value": "Lime900"
        },
        "name": "color.text.accent.lime.bolder",
        "path": [
            "color",
            "text",
            "accent",
            "lime",
            "bolder"
        ],
        "cleanName": "color.text.accent.lime.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for red text on subtlest and subtler red accent backgrounds when there is no meaning tied to the color."
        },
        "value": "#AE2E24",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for red text on subtlest and subtler red accent backgrounds when there is no meaning tied to the color."
            },
            "value": "Red800"
        },
        "name": "color.text.accent.red.[default]",
        "path": [
            "color",
            "text",
            "accent",
            "red",
            "[default]"
        ],
        "cleanName": "color.text.accent.red"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for red text on subtle red accent backgrounds when there is no meaning tied to the color."
        },
        "value": "#5D1F1A",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for red text on subtle red accent backgrounds when there is no meaning tied to the color."
            },
            "value": "Red900"
        },
        "name": "color.text.accent.red.bolder",
        "path": [
            "color",
            "text",
            "accent",
            "red",
            "bolder"
        ],
        "cleanName": "color.text.accent.red.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for orange text on subtlest and subtler orange accent backgrounds when there is no meaning tied to the color."
        },
        "value": "#9E4C00",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for orange text on subtlest and subtler orange accent backgrounds when there is no meaning tied to the color."
            },
            "value": "Orange800"
        },
        "name": "color.text.accent.orange.[default]",
        "path": [
            "color",
            "text",
            "accent",
            "orange",
            "[default]"
        ],
        "cleanName": "color.text.accent.orange"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for orange text on subtle orange accent backgrounds when there is no meaning tied to the color."
        },
        "value": "#693200",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for orange text on subtle orange accent backgrounds when there is no meaning tied to the color."
            },
            "value": "Orange900"
        },
        "name": "color.text.accent.orange.bolder",
        "path": [
            "color",
            "text",
            "accent",
            "orange",
            "bolder"
        ],
        "cleanName": "color.text.accent.orange.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for yellow text on subtlest and subtler yellow accent backgrounds when there is no meaning tied to the color."
        },
        "value": "#7F5F01",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for yellow text on subtlest and subtler yellow accent backgrounds when there is no meaning tied to the color."
            },
            "value": "Yellow800"
        },
        "name": "color.text.accent.yellow.[default]",
        "path": [
            "color",
            "text",
            "accent",
            "yellow",
            "[default]"
        ],
        "cleanName": "color.text.accent.yellow"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for yellow text on subtle yellow accent backgrounds when there is no meaning tied to the color."
        },
        "value": "#533F04",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for yellow text on subtle yellow accent backgrounds when there is no meaning tied to the color."
            },
            "value": "Yellow900"
        },
        "name": "color.text.accent.yellow.bolder",
        "path": [
            "color",
            "text",
            "accent",
            "yellow",
            "bolder"
        ],
        "cleanName": "color.text.accent.yellow.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for green text on subtlest and subtler green accent backgrounds when there is no meaning tied to the color."
        },
        "value": "#216E4E",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for green text on subtlest and subtler green accent backgrounds when there is no meaning tied to the color."
            },
            "value": "Green800"
        },
        "name": "color.text.accent.green.[default]",
        "path": [
            "color",
            "text",
            "accent",
            "green",
            "[default]"
        ],
        "cleanName": "color.text.accent.green"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for green text on subtle green accent backgrounds when there is no meaning tied to the color."
        },
        "value": "#164B35",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for green text on subtle green accent backgrounds when there is no meaning tied to the color."
            },
            "value": "Green900"
        },
        "name": "color.text.accent.green.bolder",
        "path": [
            "color",
            "text",
            "accent",
            "green",
            "bolder"
        ],
        "cleanName": "color.text.accent.green.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for teal text on subtlest and subtler teal accent backgrounds when there is no meaning tied to the color."
        },
        "value": "#206A83",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for teal text on subtlest and subtler teal accent backgrounds when there is no meaning tied to the color."
            },
            "value": "Teal800"
        },
        "name": "color.text.accent.teal.[default]",
        "path": [
            "color",
            "text",
            "accent",
            "teal",
            "[default]"
        ],
        "cleanName": "color.text.accent.teal"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for teal text on subtle teal accent backgrounds when there is no meaning tied to the color."
        },
        "value": "#164555",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for teal text on subtle teal accent backgrounds when there is no meaning tied to the color."
            },
            "value": "Teal900"
        },
        "name": "color.text.accent.teal.bolder",
        "path": [
            "color",
            "text",
            "accent",
            "teal",
            "bolder"
        ],
        "cleanName": "color.text.accent.teal.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for blue text on subtlest and subtler blue accent backgrounds when there is no meaning tied to the color."
        },
        "value": "#1558BC",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for blue text on subtlest and subtler blue accent backgrounds when there is no meaning tied to the color."
            },
            "value": "Blue800"
        },
        "name": "color.text.accent.blue.[default]",
        "path": [
            "color",
            "text",
            "accent",
            "blue",
            "[default]"
        ],
        "cleanName": "color.text.accent.blue"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for blue text on subtle blue accent backgrounds when there is no meaning tied to the color."
        },
        "value": "#123263",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for blue text on subtle blue accent backgrounds when there is no meaning tied to the color."
            },
            "value": "Blue900"
        },
        "name": "color.text.accent.blue.bolder",
        "path": [
            "color",
            "text",
            "accent",
            "blue",
            "bolder"
        ],
        "cleanName": "color.text.accent.blue.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for purple text on subtlest and subtler purple accent backgrounds when there is no meaning tied to the color."
        },
        "value": "#803FA5",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for purple text on subtlest and subtler purple accent backgrounds when there is no meaning tied to the color."
            },
            "value": "Purple800"
        },
        "name": "color.text.accent.purple.[default]",
        "path": [
            "color",
            "text",
            "accent",
            "purple",
            "[default]"
        ],
        "cleanName": "color.text.accent.purple"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for purple text on subtle purple accent backgrounds when there is no meaning tied to the color."
        },
        "value": "#48245D",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for purple text on subtle purple accent backgrounds when there is no meaning tied to the color."
            },
            "value": "Purple900"
        },
        "name": "color.text.accent.purple.bolder",
        "path": [
            "color",
            "text",
            "accent",
            "purple",
            "bolder"
        ],
        "cleanName": "color.text.accent.purple.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for magenta text on subtlest and subtler magenta accent backgrounds when there is no meaning tied to the color."
        },
        "value": "#943D73",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for magenta text on subtlest and subtler magenta accent backgrounds when there is no meaning tied to the color."
            },
            "value": "Magenta800"
        },
        "name": "color.text.accent.magenta.[default]",
        "path": [
            "color",
            "text",
            "accent",
            "magenta",
            "[default]"
        ],
        "cleanName": "color.text.accent.magenta"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.7.0",
            "description": "Use for magenta text on subtle magenta accent backgrounds when there is no meaning tied to the color."
        },
        "value": "#50253F",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.7.0",
                "description": "Use for magenta text on subtle magenta accent backgrounds when there is no meaning tied to the color."
            },
            "value": "Magenta900"
        },
        "name": "color.text.accent.magenta.bolder",
        "path": [
            "color",
            "text",
            "accent",
            "magenta",
            "bolder"
        ],
        "cleanName": "color.text.accent.magenta.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.10.5",
            "description": "Use for text on non-bold gray accent backgrounds, such as colored tags."
        },
        "value": "#505258",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.10.5",
                "description": "Use for text on non-bold gray accent backgrounds, such as colored tags."
            },
            "value": "Neutral800"
        },
        "name": "color.text.accent.gray.[default]",
        "path": [
            "color",
            "text",
            "accent",
            "gray",
            "[default]"
        ],
        "cleanName": "color.text.accent.gray"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.10.5",
            "description": "Use for text and icons on gray subtle accent backgrounds."
        },
        "value": "#1E1F21",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.10.5",
                "description": "Use for text and icons on gray subtle accent backgrounds."
            },
            "value": "Neutral1100"
        },
        "name": "color.text.accent.gray.bolder",
        "path": [
            "color",
            "text",
            "accent",
            "gray",
            "bolder"
        ],
        "cleanName": "color.text.accent.gray.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for an additional syntax-highlighting text color."
        },
        "value": "#943D73",
        "filePath": "schema/themes/atlassian-light/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for an additional syntax-highlighting text color."
            },
            "value": "Magenta800"
        },
        "name": "color.text.code.accent.1",
        "path": [
            "color",
            "text",
            "code",
            "accent",
            "1"
        ],
        "cleanName": "color.text.code.accent.1"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for an additional syntax-highlighting text color."
        },
        "value": "#1558BC",
        "filePath": "schema/themes/atlassian-light/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for an additional syntax-highlighting text color."
            },
            "value": "Blue800"
        },
        "name": "color.text.code.accent.2",
        "path": [
            "color",
            "text",
            "code",
            "accent",
            "2"
        ],
        "cleanName": "color.text.code.accent.2"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for comments in syntax-highlighted code."
        },
        "value": "#505258",
        "filePath": "schema/themes/atlassian-light/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for comments in syntax-highlighted code."
            },
            "value": "Neutral800"
        },
        "name": "color.text.code.comments",
        "path": [
            "color",
            "text",
            "code",
            "comments"
        ],
        "cleanName": "color.text.code.comments"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for default text in code blocks and code diffs."
        },
        "value": "#505258",
        "filePath": "schema/themes/atlassian-light/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for default text in code blocks and code diffs."
            },
            "value": "Neutral800"
        },
        "name": "color.text.code.default",
        "path": [
            "color",
            "text",
            "code",
            "default"
        ],
        "cleanName": "color.text.code.default"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for functions in syntax-highlighted code."
        },
        "value": "#216E4E",
        "filePath": "schema/themes/atlassian-light/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for functions in syntax-highlighted code."
            },
            "value": "Green800"
        },
        "name": "color.text.code.functions",
        "path": [
            "color",
            "text",
            "code",
            "functions"
        ],
        "cleanName": "color.text.code.functions"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for line numbers and other code gutter text."
        },
        "value": "#6B6E76",
        "filePath": "schema/themes/atlassian-light/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for line numbers and other code gutter text."
            },
            "value": "Neutral700"
        },
        "name": "color.text.code.gutter",
        "path": [
            "color",
            "text",
            "code",
            "gutter"
        ],
        "cleanName": "color.text.code.gutter"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for language keywords in syntax-highlighted code."
        },
        "value": "#AE2E24",
        "filePath": "schema/themes/atlassian-light/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for language keywords in syntax-highlighted code."
            },
            "value": "Red800"
        },
        "name": "color.text.code.keywords",
        "path": [
            "color",
            "text",
            "code",
            "keywords"
        ],
        "cleanName": "color.text.code.keywords"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for numeric values in syntax-highlighted code."
        },
        "value": "#7F5F01",
        "filePath": "schema/themes/atlassian-light/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for numeric values in syntax-highlighted code."
            },
            "value": "Yellow800"
        },
        "name": "color.text.code.numbers",
        "path": [
            "color",
            "text",
            "code",
            "numbers"
        ],
        "cleanName": "color.text.code.numbers"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for operators and punctuation in syntax-highlighted code."
        },
        "value": "#292A2E",
        "filePath": "schema/themes/atlassian-light/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for operators and punctuation in syntax-highlighted code."
            },
            "value": "Neutral1000"
        },
        "name": "color.text.code.operators",
        "path": [
            "color",
            "text",
            "code",
            "operators"
        ],
        "cleanName": "color.text.code.operators"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for string values in syntax-highlighted code."
        },
        "value": "#4C6B1F",
        "filePath": "schema/themes/atlassian-light/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for string values in syntax-highlighted code."
            },
            "value": "Lime800"
        },
        "name": "color.text.code.strings",
        "path": [
            "color",
            "text",
            "code",
            "strings"
        ],
        "cleanName": "color.text.code.strings"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "16.0.0",
            "description": "Use for tags in syntax-highlighted code."
        },
        "value": "#9E4C00",
        "filePath": "schema/themes/atlassian-light/color/code.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "16.0.0",
                "description": "Use for tags in syntax-highlighted code."
            },
            "value": "Orange800"
        },
        "name": "color.text.code.tags",
        "path": [
            "color",
            "text",
            "code",
            "tags"
        ],
        "cleanName": "color.text.code.tags"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.0.15",
            "description": "Use for text in a disabled state."
        },
        "value": "#080F214A",
        "filePath": "schema/themes/atlassian-light/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.0.15",
                "description": "Use for text in a disabled state."
            },
            "value": "Neutral400A"
        },
        "name": "color.text.disabled",
        "path": [
            "color",
            "text",
            "disabled"
        ],
        "cleanName": "color.text.disabled"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for text on bold backgrounds."
        },
        "value": "#FFFFFF",
        "filePath": "schema/themes/atlassian-light/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for text on bold backgrounds."
            },
            "value": "Neutral0"
        },
        "name": "color.text.inverse",
        "path": [
            "color",
            "text",
            "inverse"
        ],
        "cleanName": "color.text.inverse"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for text that communicates selection, such as the active tab or a selected navigation item, or the opened state of a dropdown trigger. On bold selected backgrounds, use color.text.inverse instead. Do not use for unselected links, brand emphasis, or hover alone. Keep the selected text treatment when the element also has focus."
        },
        "value": "#1868DB",
        "filePath": "schema/themes/atlassian-light/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for text that communicates selection, such as the active tab or a selected navigation item, or the opened state of a dropdown trigger. On bold selected backgrounds, use color.text.inverse instead. Do not use for unselected links, brand emphasis, or hover alone. Keep the selected text treatment when the element also has focus."
            },
            "value": "Blue700"
        },
        "name": "color.text.selected",
        "path": [
            "color",
            "text",
            "selected"
        ],
        "cleanName": "color.text.selected"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for text that reinforces our brand."
        },
        "value": "#1868DB",
        "filePath": "schema/themes/atlassian-light/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for text that reinforces our brand."
            },
            "value": "Blue700"
        },
        "name": "color.text.brand",
        "path": [
            "color",
            "text",
            "brand"
        ],
        "cleanName": "color.text.brand"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.0.15",
            "description": "Use for critical text, such as input field error messaging."
        },
        "value": "#AE2E24",
        "filePath": "schema/themes/atlassian-light/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.0.15",
                "description": "Use for critical text, such as input field error messaging."
            },
            "value": "Red800"
        },
        "name": "color.text.danger.[default]",
        "path": [
            "color",
            "text",
            "danger",
            "[default]"
        ],
        "cleanName": "color.text.danger"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Use for text on top of danger semantic labels to ensure accessibility and desired visual appearance."
        },
        "value": "#5D1F1A",
        "filePath": "schema/themes/atlassian-light/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Use for text on top of danger semantic labels to ensure accessibility and desired visual appearance."
            },
            "value": "Red900"
        },
        "name": "color.text.danger.bolder",
        "path": [
            "color",
            "text",
            "danger",
            "bolder"
        ],
        "cleanName": "color.text.danger.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.0.15",
            "description": "Use for text to emphasize caution, such as in moved lozenges."
        },
        "value": "#9E4C00",
        "filePath": "schema/themes/atlassian-light/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.0.15",
                "description": "Use for text to emphasize caution, such as in moved lozenges."
            },
            "value": "Orange800"
        },
        "name": "color.text.warning.[default]",
        "path": [
            "color",
            "text",
            "warning",
            "[default]"
        ],
        "cleanName": "color.text.warning"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for text when on bold warning backgrounds."
        },
        "value": "#292A2E",
        "filePath": "schema/themes/atlassian-light/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for text when on bold warning backgrounds."
            },
            "value": "Neutral1000"
        },
        "name": "color.text.warning.inverse",
        "path": [
            "color",
            "text",
            "warning",
            "inverse"
        ],
        "cleanName": "color.text.warning.inverse"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Use for text on top of warning semantic labels to ensure accessibility and desired visual appearance."
        },
        "value": "#693200",
        "filePath": "schema/themes/atlassian-light/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Use for text on top of warning semantic labels to ensure accessibility and desired visual appearance."
            },
            "value": "Orange900"
        },
        "name": "color.text.warning.bolder",
        "path": [
            "color",
            "text",
            "warning",
            "bolder"
        ],
        "cleanName": "color.text.warning.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.0.15",
            "description": "Use for text to communicate a favorable outcome, such as input field success messaging."
        },
        "value": "#4C6B1F",
        "filePath": "schema/themes/atlassian-light/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.0.15",
                "description": "Use for text to communicate a favorable outcome, such as input field success messaging."
            },
            "value": "Lime800"
        },
        "name": "color.text.success.[default]",
        "path": [
            "color",
            "text",
            "success",
            "[default]"
        ],
        "cleanName": "color.text.success"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Use for text on top of success semantic labels to ensure accessibility and desired visual appearance."
        },
        "value": "#37471F",
        "filePath": "schema/themes/atlassian-light/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Use for text on top of success semantic labels to ensure accessibility and desired visual appearance."
            },
            "value": "Lime900"
        },
        "name": "color.text.success.bolder",
        "path": [
            "color",
            "text",
            "success",
            "bolder"
        ],
        "cleanName": "color.text.success.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.0.15",
            "description": "Use for text to emphasize change or something new, such as in new lozenges."
        },
        "value": "#803FA5",
        "filePath": "schema/themes/atlassian-light/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.0.15",
                "description": "Use for text to emphasize change or something new, such as in new lozenges."
            },
            "value": "Purple800"
        },
        "name": "color.text.discovery.[default]",
        "path": [
            "color",
            "text",
            "discovery",
            "[default]"
        ],
        "cleanName": "color.text.discovery"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Use for text on top of discovery semantic labels to ensure accessibility and desired visual appearance."
        },
        "value": "#48245D",
        "filePath": "schema/themes/atlassian-light/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Use for text on top of discovery semantic labels to ensure accessibility and desired visual appearance."
            },
            "value": "Purple900"
        },
        "name": "color.text.discovery.bolder",
        "path": [
            "color",
            "text",
            "discovery",
            "bolder"
        ],
        "cleanName": "color.text.discovery.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for informative text or to communicate something is in progress, such as in-progress lozenges."
        },
        "value": "#1558BC",
        "filePath": "schema/themes/atlassian-light/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for informative text or to communicate something is in progress, such as in-progress lozenges."
            },
            "value": "Blue800"
        },
        "name": "color.text.information.[default]",
        "path": [
            "color",
            "text",
            "information",
            "[default]"
        ],
        "cleanName": "color.text.information"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.1.0",
            "description": "Use for text on top of information semantic labels to ensure accessibility and desired visual appearance."
        },
        "value": "#123263",
        "filePath": "schema/themes/atlassian-light/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.1.0",
                "description": "Use for text on top of information semantic labels to ensure accessibility and desired visual appearance."
            },
            "value": "Blue900"
        },
        "name": "color.text.information.bolder",
        "path": [
            "color",
            "text",
            "information",
            "bolder"
        ],
        "cleanName": "color.text.information.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for tertiary text, such as meta-data, breadcrumbs, input field placeholder and helper text."
        },
        "value": "#6B6E76",
        "filePath": "schema/themes/atlassian-light/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for tertiary text, such as meta-data, breadcrumbs, input field placeholder and helper text."
            },
            "value": "Neutral700"
        },
        "name": "color.text.subtlest",
        "path": [
            "color",
            "text",
            "subtlest"
        ],
        "cleanName": "color.text.subtlest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for secondary text, such as navigation, subtle button links, input field labels, and all caps subheadings."
        },
        "value": "#505258",
        "filePath": "schema/themes/atlassian-light/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for secondary text, such as navigation, subtle button links, input field labels, and all caps subheadings."
            },
            "value": "Neutral800"
        },
        "name": "color.text.subtle",
        "path": [
            "color",
            "text",
            "subtle"
        ],
        "cleanName": "color.text.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for icon-only buttons, or icons paired with color.text"
        },
        "value": "#292A2E",
        "filePath": "schema/themes/atlassian-light/color/icon.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for icon-only buttons, or icons paired with color.text"
            },
            "value": "Neutral1000"
        },
        "name": "color.icon.[default]",
        "path": [
            "color",
            "icon",
            "[default]"
        ],
        "cleanName": "color.icon"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.6.0",
            "description": "Use for lime icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
        },
        "value": "#6A9A23",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.6.0",
                "description": "Use for lime icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
            },
            "value": "Lime600"
        },
        "name": "color.icon.accent.lime",
        "path": [
            "color",
            "icon",
            "accent",
            "lime"
        ],
        "cleanName": "color.icon.accent.lime"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for red icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
        },
        "value": "#C9372C",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for red icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
            },
            "value": "Red700"
        },
        "name": "color.icon.accent.red",
        "path": [
            "color",
            "icon",
            "accent",
            "red"
        ],
        "cleanName": "color.icon.accent.red"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for orange icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
        },
        "value": "#E06C00",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for orange icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
            },
            "value": "Orange600"
        },
        "name": "color.icon.accent.orange",
        "path": [
            "color",
            "icon",
            "accent",
            "orange"
        ],
        "cleanName": "color.icon.accent.orange"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for yellow icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
        },
        "value": "#B38600",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for yellow icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
            },
            "value": "Yellow600"
        },
        "name": "color.icon.accent.yellow",
        "path": [
            "color",
            "icon",
            "accent",
            "yellow"
        ],
        "cleanName": "color.icon.accent.yellow"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for green icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
        },
        "value": "#22A06B",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for green icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
            },
            "value": "Green600"
        },
        "name": "color.icon.accent.green",
        "path": [
            "color",
            "icon",
            "accent",
            "green"
        ],
        "cleanName": "color.icon.accent.green"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for teal icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
        },
        "value": "#2898BD",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for teal icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
            },
            "value": "Teal600"
        },
        "name": "color.icon.accent.teal",
        "path": [
            "color",
            "icon",
            "accent",
            "teal"
        ],
        "cleanName": "color.icon.accent.teal"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for blue icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
        },
        "value": "#357DE8",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for blue icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
            },
            "value": "Blue600"
        },
        "name": "color.icon.accent.blue",
        "path": [
            "color",
            "icon",
            "accent",
            "blue"
        ],
        "cleanName": "color.icon.accent.blue"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for purple icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
        },
        "value": "#AF59E1",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for purple icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
            },
            "value": "Purple600"
        },
        "name": "color.icon.accent.purple",
        "path": [
            "color",
            "icon",
            "accent",
            "purple"
        ],
        "cleanName": "color.icon.accent.purple"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for magenta icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
        },
        "value": "#CD519D",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for magenta icons on non-bold backgrounds when there is no meaning tied to the color, such as file type icons."
            },
            "value": "Magenta600"
        },
        "name": "color.icon.accent.magenta",
        "path": [
            "color",
            "icon",
            "accent",
            "magenta"
        ],
        "cleanName": "color.icon.accent.magenta"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.10.5",
            "description": "Use for icons on non-bold gray accent backgrounds, such as file type icons."
        },
        "value": "#7D818A",
        "filePath": "schema/themes/atlassian-light/color/accent.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.10.5",
                "description": "Use for icons on non-bold gray accent backgrounds, such as file type icons."
            },
            "value": "Neutral600"
        },
        "name": "color.icon.accent.gray",
        "path": [
            "color",
            "icon",
            "accent",
            "gray"
        ],
        "cleanName": "color.icon.accent.gray"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for icons in a disabled state."
        },
        "value": "#080F214A",
        "filePath": "schema/themes/atlassian-light/color/icon.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for icons in a disabled state."
            },
            "value": "Neutral400A"
        },
        "name": "color.icon.disabled",
        "path": [
            "color",
            "icon",
            "disabled"
        ],
        "cleanName": "color.icon.disabled"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for icons on bold backgrounds."
        },
        "value": "#FFFFFF",
        "filePath": "schema/themes/atlassian-light/color/icon.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for icons on bold backgrounds."
            },
            "value": "Neutral0"
        },
        "name": "color.icon.inverse",
        "path": [
            "color",
            "icon",
            "inverse"
        ],
        "cleanName": "color.icon.inverse"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.2",
            "description": "Use for icons that communicate selection, such as icons in selected navigation items, or the opened state of a dropdown trigger. On bold selected backgrounds, use color.icon.inverse instead. Do not use for brand emphasis or hover alone. Keep the selected icon treatment when the element also has focus."
        },
        "value": "#1868DB",
        "filePath": "schema/themes/atlassian-light/color/icon.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.2",
                "description": "Use for icons that communicate selection, such as icons in selected navigation items, or the opened state of a dropdown trigger. On bold selected backgrounds, use color.icon.inverse instead. Do not use for brand emphasis or hover alone. Keep the selected icon treatment when the element also has focus."
            },
            "value": "Blue700"
        },
        "name": "color.icon.selected",
        "path": [
            "color",
            "icon",
            "selected"
        ],
        "cleanName": "color.icon.selected"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for icons that reinforce our brand."
        },
        "value": "#1868DB",
        "filePath": "schema/themes/atlassian-light/color/icon.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for icons that reinforce our brand."
            },
            "value": "Blue700"
        },
        "name": "color.icon.brand",
        "path": [
            "color",
            "icon",
            "brand"
        ],
        "cleanName": "color.icon.brand"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for icons communicating critical information, such as those used in error handing."
        },
        "value": "#C9372C",
        "filePath": "schema/themes/atlassian-light/color/icon.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for icons communicating critical information, such as those used in error handing."
            },
            "value": "Red700"
        },
        "name": "color.icon.danger",
        "path": [
            "color",
            "icon",
            "danger"
        ],
        "cleanName": "color.icon.danger"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for icons communicating caution, such as those used in warning section messages."
        },
        "value": "#E06C00",
        "filePath": "schema/themes/atlassian-light/color/icon.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for icons communicating caution, such as those used in warning section messages."
            },
            "value": "Orange600"
        },
        "name": "color.icon.warning.[default]",
        "path": [
            "color",
            "icon",
            "warning",
            "[default]"
        ],
        "cleanName": "color.icon.warning"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for icons when on bold warning backgrounds."
        },
        "value": "#292A2E",
        "filePath": "schema/themes/atlassian-light/color/icon.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for icons when on bold warning backgrounds."
            },
            "value": "Neutral1000"
        },
        "name": "color.icon.warning.inverse",
        "path": [
            "color",
            "icon",
            "warning",
            "inverse"
        ],
        "cleanName": "color.icon.warning.inverse"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for icons communicating a favorable outcome, such as those used in success section messaged."
        },
        "value": "#6A9A23",
        "filePath": "schema/themes/atlassian-light/color/icon.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for icons communicating a favorable outcome, such as those used in success section messaged."
            },
            "value": "Lime600"
        },
        "name": "color.icon.success",
        "path": [
            "color",
            "icon",
            "success"
        ],
        "cleanName": "color.icon.success"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for icons communicating change or something new, such as discovery section messages."
        },
        "value": "#AF59E1",
        "filePath": "schema/themes/atlassian-light/color/icon.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for icons communicating change or something new, such as discovery section messages."
            },
            "value": "Purple600"
        },
        "name": "color.icon.discovery",
        "path": [
            "color",
            "icon",
            "discovery"
        ],
        "cleanName": "color.icon.discovery"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for icons communicating information or something in-progress, such as information section messages."
        },
        "value": "#357DE8",
        "filePath": "schema/themes/atlassian-light/color/icon.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for icons communicating information or something in-progress, such as information section messages."
            },
            "value": "Blue600"
        },
        "name": "color.icon.information",
        "path": [
            "color",
            "icon",
            "information"
        ],
        "cleanName": "color.icon.information"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.54.0",
            "description": "Use for icons paired with color.text.subtlest"
        },
        "value": "#6B6E76",
        "filePath": "schema/themes/atlassian-light/color/icon.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.54.0",
                "description": "Use for icons paired with color.text.subtlest"
            },
            "value": "Neutral700"
        },
        "name": "color.icon.subtlest",
        "path": [
            "color",
            "icon",
            "subtlest"
        ],
        "cleanName": "color.icon.subtlest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for icons paired with color.text.subtle"
        },
        "value": "#505258",
        "filePath": "schema/themes/atlassian-light/color/icon.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for icons paired with color.text.subtle"
            },
            "value": "Neutral800"
        },
        "name": "color.icon.subtle",
        "path": [
            "color",
            "icon",
            "subtle"
        ],
        "cleanName": "color.icon.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for links in a default or hovered state. Add an underline for hovered states."
        },
        "value": "#1868DB",
        "filePath": "schema/themes/atlassian-light/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for links in a default or hovered state. Add an underline for hovered states."
            },
            "value": "Blue700"
        },
        "name": "color.link.[default]",
        "path": [
            "color",
            "link",
            "[default]"
        ],
        "cleanName": "color.link"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for links in a pressed state."
        },
        "value": "#1558BC",
        "filePath": "schema/themes/atlassian-light/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for links in a pressed state."
            },
            "value": "Blue800"
        },
        "name": "color.link.pressed",
        "path": [
            "color",
            "link",
            "pressed"
        ],
        "cleanName": "color.link.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.23.0",
            "description": "Use for visited links."
        },
        "value": "#803FA5",
        "filePath": "schema/themes/atlassian-light/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.23.0",
                "description": "Use for visited links."
            },
            "value": "Purple800"
        },
        "name": "color.link.visited.[default]",
        "path": [
            "color",
            "link",
            "visited",
            "[default]"
        ],
        "cleanName": "color.link.visited"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.43.0",
            "description": "Use for visited links in a pressed state."
        },
        "value": "#48245D",
        "filePath": "schema/themes/atlassian-light/color/text.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.43.0",
                "description": "Use for visited links in a pressed state."
            },
            "value": "Purple900"
        },
        "name": "color.link.visited.pressed",
        "path": [
            "color",
            "link",
            "visited",
            "pressed"
        ],
        "cleanName": "color.link.visited.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use as a background overlay for elements in a hovered state when their background color cannot change, such as avatars."
        },
        "value": "#00000029",
        "filePath": "schema/themes/atlassian-light/color/interaction.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use as a background overlay for elements in a hovered state when their background color cannot change, such as avatars."
            },
            "value": "#00000029"
        },
        "name": "color.interaction.hovered",
        "path": [
            "color",
            "interaction",
            "hovered"
        ],
        "cleanName": "color.interaction.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use as a background overlay for elements in a pressed state when their background color cannot change, such as avatars."
        },
        "value": "#00000052",
        "filePath": "schema/themes/atlassian-light/color/interaction.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use as a background overlay for elements in a pressed state when their background color cannot change, such as avatars."
            },
            "value": "#00000052"
        },
        "name": "color.interaction.pressed",
        "path": [
            "color",
            "interaction",
            "pressed"
        ],
        "cleanName": "color.interaction.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.8.0",
            "description": "Use for skeleton loading states"
        },
        "value": "#0515240F",
        "filePath": "schema/themes/atlassian-light/color/skeleton.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.8.0",
                "description": "Use for skeleton loading states"
            },
            "value": "Neutral200A"
        },
        "name": "color.skeleton.[default]",
        "path": [
            "color",
            "skeleton",
            "[default]"
        ],
        "cleanName": "color.skeleton"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.8.0",
            "description": "Use for the pulse or shimmer effect in skeleton loading states"
        },
        "value": "#17171708",
        "filePath": "schema/themes/atlassian-light/color/skeleton.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.8.0",
                "description": "Use for the pulse or shimmer effect in skeleton loading states"
            },
            "value": "Neutral100A"
        },
        "name": "color.skeleton.subtle",
        "path": [
            "color",
            "skeleton",
            "subtle"
        ],
        "cleanName": "color.skeleton.subtle"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.0.15",
            "description": "Use for the screen overlay that appears with modal dialogs"
        },
        "value": "#050C1F75",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.0.15",
                "description": "Use for the screen overlay that appears with modal dialogs"
            },
            "value": "Neutral500A"
        },
        "name": "color.blanket.[default]",
        "path": [
            "color",
            "blanket",
            "[default]"
        ],
        "cleanName": "color.blanket"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use as a translucent blanket to communicate selection when changing the background of the selected content is not possible, such as selected Editor blocks. The content beneath remains visible. Do not use to indicate keyboard focus or hover alone."
        },
        "value": "#388BFF14",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use as a translucent blanket to communicate selection when changing the background of the selected content is not possible, such as selected Editor blocks. The content beneath remains visible. Do not use to indicate keyboard focus or hover alone."
            },
            "value": "#388BFF14"
        },
        "name": "color.blanket.selected",
        "path": [
            "color",
            "blanket",
            "selected"
        ],
        "cleanName": "color.blanket.selected"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use as an overlay to communicate danger states when a simple background color change isn't possible, such as deletion of Editor block elements"
        },
        "value": "#EF5C4814",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use as an overlay to communicate danger states when a simple background color change isn't possible, such as deletion of Editor block elements"
            },
            "value": "#EF5C4814"
        },
        "name": "color.blanket.danger",
        "path": [
            "color",
            "blanket",
            "danger"
        ],
        "cleanName": "color.blanket.danger"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only. Follow numbered sequence."
        },
        "value": "#357DE8",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only. Follow numbered sequence."
            },
            "value": "Blue600"
        },
        "name": "color.chart.categorical.1.[default]",
        "path": [
            "color",
            "chart",
            "categorical",
            "1",
            "[default]"
        ],
        "cleanName": "color.chart.categorical.1"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.categorical.1."
        },
        "value": "#1868DB",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.categorical.1."
            },
            "value": "Blue700"
        },
        "name": "color.chart.categorical.1.hovered",
        "path": [
            "color",
            "chart",
            "categorical",
            "1",
            "hovered"
        ],
        "cleanName": "color.chart.categorical.1.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only. Follow numbered sequence."
        },
        "value": "#82B536",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only. Follow numbered sequence."
            },
            "value": "Lime500"
        },
        "name": "color.chart.categorical.2.[default]",
        "path": [
            "color",
            "chart",
            "categorical",
            "2",
            "[default]"
        ],
        "cleanName": "color.chart.categorical.2"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.categorical.2."
        },
        "value": "#6A9A23",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.categorical.2."
            },
            "value": "Lime600"
        },
        "name": "color.chart.categorical.2.hovered",
        "path": [
            "color",
            "chart",
            "categorical",
            "2",
            "hovered"
        ],
        "cleanName": "color.chart.categorical.2.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only. Follow numbered sequence."
        },
        "value": "#BF63F3",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only. Follow numbered sequence."
            },
            "value": "Purple500"
        },
        "name": "color.chart.categorical.3.[default]",
        "path": [
            "color",
            "chart",
            "categorical",
            "3",
            "[default]"
        ],
        "cleanName": "color.chart.categorical.3"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.categorical.3."
        },
        "value": "#AF59E1",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.categorical.3."
            },
            "value": "Purple600"
        },
        "name": "color.chart.categorical.3.hovered",
        "path": [
            "color",
            "chart",
            "categorical",
            "3",
            "hovered"
        ],
        "cleanName": "color.chart.categorical.3.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only. Follow numbered sequence."
        },
        "value": "#F68909",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only. Follow numbered sequence."
            },
            "value": "Orange500"
        },
        "name": "color.chart.categorical.4.[default]",
        "path": [
            "color",
            "chart",
            "categorical",
            "4",
            "[default]"
        ],
        "cleanName": "color.chart.categorical.4"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.categorical.4."
        },
        "value": "#E06C00",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.categorical.4."
            },
            "value": "Orange600"
        },
        "name": "color.chart.categorical.4.hovered",
        "path": [
            "color",
            "chart",
            "categorical",
            "4",
            "hovered"
        ],
        "cleanName": "color.chart.categorical.4.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only. Follow numbered sequence."
        },
        "value": "#1558BC",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only. Follow numbered sequence."
            },
            "value": "Blue800"
        },
        "name": "color.chart.categorical.5.[default]",
        "path": [
            "color",
            "chart",
            "categorical",
            "5",
            "[default]"
        ],
        "cleanName": "color.chart.categorical.5"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.categorical.5."
        },
        "value": "#123263",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.categorical.5."
            },
            "value": "Blue900"
        },
        "name": "color.chart.categorical.5.hovered",
        "path": [
            "color",
            "chart",
            "categorical",
            "5",
            "hovered"
        ],
        "cleanName": "color.chart.categorical.5.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only. Follow numbered sequence."
        },
        "value": "#964AC0",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only. Follow numbered sequence."
            },
            "value": "Purple700"
        },
        "name": "color.chart.categorical.6.[default]",
        "path": [
            "color",
            "chart",
            "categorical",
            "6",
            "[default]"
        ],
        "cleanName": "color.chart.categorical.6"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.categorical.6."
        },
        "value": "#803FA5",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.categorical.6."
            },
            "value": "Purple800"
        },
        "name": "color.chart.categorical.6.hovered",
        "path": [
            "color",
            "chart",
            "categorical",
            "6",
            "hovered"
        ],
        "cleanName": "color.chart.categorical.6.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only. Follow numbered sequence."
        },
        "value": "#42B2D7",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only. Follow numbered sequence."
            },
            "value": "Teal500"
        },
        "name": "color.chart.categorical.7.[default]",
        "path": [
            "color",
            "chart",
            "categorical",
            "7",
            "[default]"
        ],
        "cleanName": "color.chart.categorical.7"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.categorical.7."
        },
        "value": "#2898BD",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.categorical.7."
            },
            "value": "Teal600"
        },
        "name": "color.chart.categorical.7.hovered",
        "path": [
            "color",
            "chart",
            "categorical",
            "7",
            "hovered"
        ],
        "cleanName": "color.chart.categorical.7.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only. Follow numbered sequence."
        },
        "value": "#BD5B00",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only. Follow numbered sequence."
            },
            "value": "Orange700"
        },
        "name": "color.chart.categorical.8.[default]",
        "path": [
            "color",
            "chart",
            "categorical",
            "8",
            "[default]"
        ],
        "cleanName": "color.chart.categorical.8"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.categorical.8."
        },
        "value": "#7A3B00",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.categorical.8."
            },
            "value": "Orange850"
        },
        "name": "color.chart.categorical.8.hovered",
        "path": [
            "color",
            "chart",
            "categorical",
            "8",
            "hovered"
        ],
        "cleanName": "color.chart.categorical.8.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.8.0",
            "description": "For data visualisation only."
        },
        "value": "#6A9A23",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.8.0",
                "description": "For data visualisation only."
            },
            "value": "Lime600"
        },
        "name": "color.chart.lime.bold.[default]",
        "path": [
            "color",
            "chart",
            "lime",
            "bold",
            "[default]"
        ],
        "cleanName": "color.chart.lime.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.8.0",
            "description": "Hovered state of color.chart.lime.bold."
        },
        "value": "#5B7F24",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.8.0",
                "description": "Hovered state of color.chart.lime.bold."
            },
            "value": "Lime700"
        },
        "name": "color.chart.lime.bold.hovered",
        "path": [
            "color",
            "chart",
            "lime",
            "bold",
            "hovered"
        ],
        "cleanName": "color.chart.lime.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.8.0",
            "description": "For data visualisation only."
        },
        "value": "#5B7F24",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.8.0",
                "description": "For data visualisation only."
            },
            "value": "Lime700"
        },
        "name": "color.chart.lime.bolder.[default]",
        "path": [
            "color",
            "chart",
            "lime",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.chart.lime.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.8.0",
            "description": "Hovered state of color.chart.lime.bolder."
        },
        "value": "#4C6B1F",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.8.0",
                "description": "Hovered state of color.chart.lime.bolder."
            },
            "value": "Lime800"
        },
        "name": "color.chart.lime.bolder.hovered",
        "path": [
            "color",
            "chart",
            "lime",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.chart.lime.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.8.0",
            "description": "For data visualisation only."
        },
        "value": "#4C6B1F",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.8.0",
                "description": "For data visualisation only."
            },
            "value": "Lime800"
        },
        "name": "color.chart.lime.boldest.[default]",
        "path": [
            "color",
            "chart",
            "lime",
            "boldest",
            "[default]"
        ],
        "cleanName": "color.chart.lime.boldest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.8.0",
            "description": "Hovered state of color.chart.lime.boldest."
        },
        "value": "#37471F",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.8.0",
                "description": "Hovered state of color.chart.lime.boldest."
            },
            "value": "Lime900"
        },
        "name": "color.chart.lime.boldest.hovered",
        "path": [
            "color",
            "chart",
            "lime",
            "boldest",
            "hovered"
        ],
        "cleanName": "color.chart.lime.boldest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "A secondary color for data visualisation or to communicate 'to-do' statues."
        },
        "value": "#8C8F97",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "A secondary color for data visualisation or to communicate 'to-do' statues."
            },
            "value": "Neutral500"
        },
        "name": "color.chart.neutral.[default]",
        "path": [
            "color",
            "chart",
            "neutral",
            "[default]"
        ],
        "cleanName": "color.chart.neutral"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.neutral."
        },
        "value": "#7D818A",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.neutral."
            },
            "value": "Neutral600"
        },
        "name": "color.chart.neutral.hovered",
        "path": [
            "color",
            "chart",
            "neutral",
            "hovered"
        ],
        "cleanName": "color.chart.neutral.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#F15B50",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Red500"
        },
        "name": "color.chart.red.bold.[default]",
        "path": [
            "color",
            "chart",
            "red",
            "bold",
            "[default]"
        ],
        "cleanName": "color.chart.red.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.red.bold."
        },
        "value": "#E2483D",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.red.bold."
            },
            "value": "Red600"
        },
        "name": "color.chart.red.bold.hovered",
        "path": [
            "color",
            "chart",
            "red",
            "bold",
            "hovered"
        ],
        "cleanName": "color.chart.red.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#E2483D",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Red600"
        },
        "name": "color.chart.red.bolder.[default]",
        "path": [
            "color",
            "chart",
            "red",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.chart.red.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.red.bolder."
        },
        "value": "#C9372C",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.red.bolder."
            },
            "value": "Red700"
        },
        "name": "color.chart.red.bolder.hovered",
        "path": [
            "color",
            "chart",
            "red",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.chart.red.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#AE2E24",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Red800"
        },
        "name": "color.chart.red.boldest.[default]",
        "path": [
            "color",
            "chart",
            "red",
            "boldest",
            "[default]"
        ],
        "cleanName": "color.chart.red.boldest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.red.boldest."
        },
        "value": "#5D1F1A",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.red.boldest."
            },
            "value": "Red900"
        },
        "name": "color.chart.red.boldest.hovered",
        "path": [
            "color",
            "chart",
            "red",
            "boldest",
            "hovered"
        ],
        "cleanName": "color.chart.red.boldest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#E06C00",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Orange600"
        },
        "name": "color.chart.orange.bold.[default]",
        "path": [
            "color",
            "chart",
            "orange",
            "bold",
            "[default]"
        ],
        "cleanName": "color.chart.orange.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.orange.bold."
        },
        "value": "#BD5B00",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.orange.bold."
            },
            "value": "Orange700"
        },
        "name": "color.chart.orange.bold.hovered",
        "path": [
            "color",
            "chart",
            "orange",
            "bold",
            "hovered"
        ],
        "cleanName": "color.chart.orange.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#BD5B00",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Orange700"
        },
        "name": "color.chart.orange.bolder.[default]",
        "path": [
            "color",
            "chart",
            "orange",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.chart.orange.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.orange.bolder."
        },
        "value": "#9E4C00",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.orange.bolder."
            },
            "value": "Orange800"
        },
        "name": "color.chart.orange.bolder.hovered",
        "path": [
            "color",
            "chart",
            "orange",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.chart.orange.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#7A3B00",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Orange850"
        },
        "name": "color.chart.orange.boldest.[default]",
        "path": [
            "color",
            "chart",
            "orange",
            "boldest",
            "[default]"
        ],
        "cleanName": "color.chart.orange.boldest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.orange.boldest."
        },
        "value": "#693200",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.orange.boldest."
            },
            "value": "Orange900"
        },
        "name": "color.chart.orange.boldest.hovered",
        "path": [
            "color",
            "chart",
            "orange",
            "boldest",
            "hovered"
        ],
        "cleanName": "color.chart.orange.boldest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#B38600",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Yellow600"
        },
        "name": "color.chart.yellow.bold.[default]",
        "path": [
            "color",
            "chart",
            "yellow",
            "bold",
            "[default]"
        ],
        "cleanName": "color.chart.yellow.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.yellow.bold."
        },
        "value": "#946F00",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.yellow.bold."
            },
            "value": "Yellow700"
        },
        "name": "color.chart.yellow.bold.hovered",
        "path": [
            "color",
            "chart",
            "yellow",
            "bold",
            "hovered"
        ],
        "cleanName": "color.chart.yellow.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#946F00",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Yellow700"
        },
        "name": "color.chart.yellow.bolder.[default]",
        "path": [
            "color",
            "chart",
            "yellow",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.chart.yellow.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.yellow.bolder."
        },
        "value": "#7F5F01",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.yellow.bolder."
            },
            "value": "Yellow800"
        },
        "name": "color.chart.yellow.bolder.hovered",
        "path": [
            "color",
            "chart",
            "yellow",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.chart.yellow.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#7F5F01",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Yellow800"
        },
        "name": "color.chart.yellow.boldest.[default]",
        "path": [
            "color",
            "chart",
            "yellow",
            "boldest",
            "[default]"
        ],
        "cleanName": "color.chart.yellow.boldest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.yellow.boldest."
        },
        "value": "#533F04",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.yellow.boldest."
            },
            "value": "Yellow900"
        },
        "name": "color.chart.yellow.boldest.hovered",
        "path": [
            "color",
            "chart",
            "yellow",
            "boldest",
            "hovered"
        ],
        "cleanName": "color.chart.yellow.boldest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#22A06B",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Green600"
        },
        "name": "color.chart.green.bold.[default]",
        "path": [
            "color",
            "chart",
            "green",
            "bold",
            "[default]"
        ],
        "cleanName": "color.chart.green.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.green.bold."
        },
        "value": "#1F845A",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.green.bold."
            },
            "value": "Green700"
        },
        "name": "color.chart.green.bold.hovered",
        "path": [
            "color",
            "chart",
            "green",
            "bold",
            "hovered"
        ],
        "cleanName": "color.chart.green.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#1F845A",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Green700"
        },
        "name": "color.chart.green.bolder.[default]",
        "path": [
            "color",
            "chart",
            "green",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.chart.green.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.green.bolder."
        },
        "value": "#216E4E",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.green.bolder."
            },
            "value": "Green800"
        },
        "name": "color.chart.green.bolder.hovered",
        "path": [
            "color",
            "chart",
            "green",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.chart.green.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#216E4E",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Green800"
        },
        "name": "color.chart.green.boldest.[default]",
        "path": [
            "color",
            "chart",
            "green",
            "boldest",
            "[default]"
        ],
        "cleanName": "color.chart.green.boldest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.green.boldest."
        },
        "value": "#164B35",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.green.boldest."
            },
            "value": "Green900"
        },
        "name": "color.chart.green.boldest.hovered",
        "path": [
            "color",
            "chart",
            "green",
            "boldest",
            "hovered"
        ],
        "cleanName": "color.chart.green.boldest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#2898BD",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Teal600"
        },
        "name": "color.chart.teal.bold.[default]",
        "path": [
            "color",
            "chart",
            "teal",
            "bold",
            "[default]"
        ],
        "cleanName": "color.chart.teal.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.teal.bold."
        },
        "value": "#227D9B",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.teal.bold."
            },
            "value": "Teal700"
        },
        "name": "color.chart.teal.bold.hovered",
        "path": [
            "color",
            "chart",
            "teal",
            "bold",
            "hovered"
        ],
        "cleanName": "color.chart.teal.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#227D9B",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Teal700"
        },
        "name": "color.chart.teal.bolder.[default]",
        "path": [
            "color",
            "chart",
            "teal",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.chart.teal.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.teal.bolder."
        },
        "value": "#206A83",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.teal.bolder."
            },
            "value": "Teal800"
        },
        "name": "color.chart.teal.bolder.hovered",
        "path": [
            "color",
            "chart",
            "teal",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.chart.teal.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#206A83",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Teal800"
        },
        "name": "color.chart.teal.boldest.[default]",
        "path": [
            "color",
            "chart",
            "teal",
            "boldest",
            "[default]"
        ],
        "cleanName": "color.chart.teal.boldest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.teal.boldest."
        },
        "value": "#164555",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.teal.boldest."
            },
            "value": "Teal900"
        },
        "name": "color.chart.teal.boldest.hovered",
        "path": [
            "color",
            "chart",
            "teal",
            "boldest",
            "hovered"
        ],
        "cleanName": "color.chart.teal.boldest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#4688EC",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Blue500"
        },
        "name": "color.chart.blue.bold.[default]",
        "path": [
            "color",
            "chart",
            "blue",
            "bold",
            "[default]"
        ],
        "cleanName": "color.chart.blue.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.blue.bold."
        },
        "value": "#357DE8",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.blue.bold."
            },
            "value": "Blue600"
        },
        "name": "color.chart.blue.bold.hovered",
        "path": [
            "color",
            "chart",
            "blue",
            "bold",
            "hovered"
        ],
        "cleanName": "color.chart.blue.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#357DE8",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Blue600"
        },
        "name": "color.chart.blue.bolder.[default]",
        "path": [
            "color",
            "chart",
            "blue",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.chart.blue.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.blue.bolder."
        },
        "value": "#1868DB",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.blue.bolder."
            },
            "value": "Blue700"
        },
        "name": "color.chart.blue.bolder.hovered",
        "path": [
            "color",
            "chart",
            "blue",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.chart.blue.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#1558BC",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Blue800"
        },
        "name": "color.chart.blue.boldest.[default]",
        "path": [
            "color",
            "chart",
            "blue",
            "boldest",
            "[default]"
        ],
        "cleanName": "color.chart.blue.boldest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.blue.boldest."
        },
        "value": "#123263",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.blue.boldest."
            },
            "value": "Blue900"
        },
        "name": "color.chart.blue.boldest.hovered",
        "path": [
            "color",
            "chart",
            "blue",
            "boldest",
            "hovered"
        ],
        "cleanName": "color.chart.blue.boldest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#BF63F3",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Purple500"
        },
        "name": "color.chart.purple.bold.[default]",
        "path": [
            "color",
            "chart",
            "purple",
            "bold",
            "[default]"
        ],
        "cleanName": "color.chart.purple.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.purple.bold."
        },
        "value": "#AF59E1",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.purple.bold."
            },
            "value": "Purple600"
        },
        "name": "color.chart.purple.bold.hovered",
        "path": [
            "color",
            "chart",
            "purple",
            "bold",
            "hovered"
        ],
        "cleanName": "color.chart.purple.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#AF59E1",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Purple600"
        },
        "name": "color.chart.purple.bolder.[default]",
        "path": [
            "color",
            "chart",
            "purple",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.chart.purple.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.purple.bolder."
        },
        "value": "#964AC0",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.purple.bolder."
            },
            "value": "Purple700"
        },
        "name": "color.chart.purple.bolder.hovered",
        "path": [
            "color",
            "chart",
            "purple",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.chart.purple.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#803FA5",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Purple800"
        },
        "name": "color.chart.purple.boldest.[default]",
        "path": [
            "color",
            "chart",
            "purple",
            "boldest",
            "[default]"
        ],
        "cleanName": "color.chart.purple.boldest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.purple.boldest."
        },
        "value": "#48245D",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.purple.boldest."
            },
            "value": "Purple900"
        },
        "name": "color.chart.purple.boldest.hovered",
        "path": [
            "color",
            "chart",
            "purple",
            "boldest",
            "hovered"
        ],
        "cleanName": "color.chart.purple.boldest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#DA62AC",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Magenta500"
        },
        "name": "color.chart.magenta.bold.[default]",
        "path": [
            "color",
            "chart",
            "magenta",
            "bold",
            "[default]"
        ],
        "cleanName": "color.chart.magenta.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.magenta.bold."
        },
        "value": "#CD519D",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.magenta.bold."
            },
            "value": "Magenta600"
        },
        "name": "color.chart.magenta.bold.hovered",
        "path": [
            "color",
            "chart",
            "magenta",
            "bold",
            "hovered"
        ],
        "cleanName": "color.chart.magenta.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#CD519D",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Magenta600"
        },
        "name": "color.chart.magenta.bolder.[default]",
        "path": [
            "color",
            "chart",
            "magenta",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.chart.magenta.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.magenta.bolder."
        },
        "value": "#AE4787",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.magenta.bolder."
            },
            "value": "Magenta700"
        },
        "name": "color.chart.magenta.bolder.hovered",
        "path": [
            "color",
            "chart",
            "magenta",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.chart.magenta.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#943D73",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Magenta800"
        },
        "name": "color.chart.magenta.boldest.[default]",
        "path": [
            "color",
            "chart",
            "magenta",
            "boldest",
            "[default]"
        ],
        "cleanName": "color.chart.magenta.boldest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.magenta.boldest."
        },
        "value": "#50253F",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.magenta.boldest."
            },
            "value": "Magenta900"
        },
        "name": "color.chart.magenta.boldest.hovered",
        "path": [
            "color",
            "chart",
            "magenta",
            "boldest",
            "hovered"
        ],
        "cleanName": "color.chart.magenta.boldest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#8C8F97",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Neutral500"
        },
        "name": "color.chart.gray.bold.[default]",
        "path": [
            "color",
            "chart",
            "gray",
            "bold",
            "[default]"
        ],
        "cleanName": "color.chart.gray.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.gray.bold."
        },
        "value": "#7D818A",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.gray.bold."
            },
            "value": "Neutral600"
        },
        "name": "color.chart.gray.bold.hovered",
        "path": [
            "color",
            "chart",
            "gray",
            "bold",
            "hovered"
        ],
        "cleanName": "color.chart.gray.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#7D818A",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Neutral600"
        },
        "name": "color.chart.gray.bolder.[default]",
        "path": [
            "color",
            "chart",
            "gray",
            "bolder",
            "[default]"
        ],
        "cleanName": "color.chart.gray.bolder"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.gray.bolder."
        },
        "value": "#6B6E76",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.gray.bolder."
            },
            "value": "Neutral700"
        },
        "name": "color.chart.gray.bolder.hovered",
        "path": [
            "color",
            "chart",
            "gray",
            "bolder",
            "hovered"
        ],
        "cleanName": "color.chart.gray.bolder.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation only."
        },
        "value": "#505258",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation only."
            },
            "value": "Neutral800"
        },
        "name": "color.chart.gray.boldest.[default]",
        "path": [
            "color",
            "chart",
            "gray",
            "boldest",
            "[default]"
        ],
        "cleanName": "color.chart.gray.boldest"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.gray.boldest."
        },
        "value": "#3B3D42",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.gray.boldest."
            },
            "value": "Neutral900"
        },
        "name": "color.chart.gray.boldest.hovered",
        "path": [
            "color",
            "chart",
            "gray",
            "boldest",
            "hovered"
        ],
        "cleanName": "color.chart.gray.boldest.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Our primary color for data visualisation. Use when only one color is required."
        },
        "value": "#357DE8",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Our primary color for data visualisation. Use when only one color is required."
            },
            "value": "Blue600"
        },
        "name": "color.chart.brand.[default]",
        "path": [
            "color",
            "chart",
            "brand",
            "[default]"
        ],
        "cleanName": "color.chart.brand"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.brand."
        },
        "value": "#1868DB",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.brand."
            },
            "value": "Blue700"
        },
        "name": "color.chart.brand.hovered",
        "path": [
            "color",
            "chart",
            "brand",
            "hovered"
        ],
        "cleanName": "color.chart.brand.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation communicating negative information, such as 'off track'."
        },
        "value": "#E2483D",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation communicating negative information, such as 'off track'."
            },
            "value": "Red600"
        },
        "name": "color.chart.danger.[default].[default]",
        "path": [
            "color",
            "chart",
            "danger",
            "[default]",
            "[default]"
        ],
        "cleanName": "color.chart.danger"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.danger."
        },
        "value": "#C9372C",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.danger."
            },
            "value": "Red700"
        },
        "name": "color.chart.danger.[default].hovered",
        "path": [
            "color",
            "chart",
            "danger",
            "[default]",
            "hovered"
        ],
        "cleanName": "color.chart.danger.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "A stronger emphasis option of color.chart.danger."
        },
        "value": "#872821",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "A stronger emphasis option of color.chart.danger."
            },
            "value": "Red850"
        },
        "name": "color.chart.danger.bold.[default]",
        "path": [
            "color",
            "chart",
            "danger",
            "bold",
            "[default]"
        ],
        "cleanName": "color.chart.danger.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.danger.bold."
        },
        "value": "#5D1F1A",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.danger.bold."
            },
            "value": "Red900"
        },
        "name": "color.chart.danger.bold.hovered",
        "path": [
            "color",
            "chart",
            "danger",
            "bold",
            "hovered"
        ],
        "cleanName": "color.chart.danger.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation communicating caution, such as 'at risk' statuses."
        },
        "value": "#F68909",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation communicating caution, such as 'at risk' statuses."
            },
            "value": "Orange500"
        },
        "name": "color.chart.warning.[default].[default]",
        "path": [
            "color",
            "chart",
            "warning",
            "[default]",
            "[default]"
        ],
        "cleanName": "color.chart.warning"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.warning."
        },
        "value": "#E06C00",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.warning."
            },
            "value": "Orange600"
        },
        "name": "color.chart.warning.[default].hovered",
        "path": [
            "color",
            "chart",
            "warning",
            "[default]",
            "hovered"
        ],
        "cleanName": "color.chart.warning.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "A stronger emphasis option of color.chart.warning."
        },
        "value": "#BD5B00",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "A stronger emphasis option of color.chart.warning."
            },
            "value": "Orange700"
        },
        "name": "color.chart.warning.bold.[default]",
        "path": [
            "color",
            "chart",
            "warning",
            "bold",
            "[default]"
        ],
        "cleanName": "color.chart.warning.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.warning.bold."
        },
        "value": "#9E4C00",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.warning.bold."
            },
            "value": "Orange800"
        },
        "name": "color.chart.warning.bold.hovered",
        "path": [
            "color",
            "chart",
            "warning",
            "bold",
            "hovered"
        ],
        "cleanName": "color.chart.warning.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation communicating positive information, such as 'on track'."
        },
        "value": "#82B536",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation communicating positive information, such as 'on track'."
            },
            "value": "Lime500"
        },
        "name": "color.chart.success.[default].[default]",
        "path": [
            "color",
            "chart",
            "success",
            "[default]",
            "[default]"
        ],
        "cleanName": "color.chart.success"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.success."
        },
        "value": "#6A9A23",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.success."
            },
            "value": "Lime600"
        },
        "name": "color.chart.success.[default].hovered",
        "path": [
            "color",
            "chart",
            "success",
            "[default]",
            "hovered"
        ],
        "cleanName": "color.chart.success.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "A stronger emphasis option of color.chart.success."
        },
        "value": "#5B7F24",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "A stronger emphasis option of color.chart.success."
            },
            "value": "Lime700"
        },
        "name": "color.chart.success.bold.[default]",
        "path": [
            "color",
            "chart",
            "success",
            "bold",
            "[default]"
        ],
        "cleanName": "color.chart.success.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.success.bold."
        },
        "value": "#4C6B1F",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.success.bold."
            },
            "value": "Lime800"
        },
        "name": "color.chart.success.bold.hovered",
        "path": [
            "color",
            "chart",
            "success",
            "bold",
            "hovered"
        ],
        "cleanName": "color.chart.success.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation communicating 'new' statuses."
        },
        "value": "#BF63F3",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation communicating 'new' statuses."
            },
            "value": "Purple500"
        },
        "name": "color.chart.discovery.[default].[default]",
        "path": [
            "color",
            "chart",
            "discovery",
            "[default]",
            "[default]"
        ],
        "cleanName": "color.chart.discovery"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.discovery."
        },
        "value": "#AF59E1",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.discovery."
            },
            "value": "Purple600"
        },
        "name": "color.chart.discovery.[default].hovered",
        "path": [
            "color",
            "chart",
            "discovery",
            "[default]",
            "hovered"
        ],
        "cleanName": "color.chart.discovery.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "A stronger emphasis option of color.chart.discovery."
        },
        "value": "#803FA5",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "A stronger emphasis option of color.chart.discovery."
            },
            "value": "Purple800"
        },
        "name": "color.chart.discovery.bold.[default]",
        "path": [
            "color",
            "chart",
            "discovery",
            "bold",
            "[default]"
        ],
        "cleanName": "color.chart.discovery.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.discovery.bold."
        },
        "value": "#964AC0",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.discovery.bold."
            },
            "value": "Purple700"
        },
        "name": "color.chart.discovery.bold.hovered",
        "path": [
            "color",
            "chart",
            "discovery",
            "bold",
            "hovered"
        ],
        "cleanName": "color.chart.discovery.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "For data visualisation communicating low priority or in-progress statuses."
        },
        "value": "#357DE8",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "For data visualisation communicating low priority or in-progress statuses."
            },
            "value": "Blue600"
        },
        "name": "color.chart.information.[default].[default]",
        "path": [
            "color",
            "chart",
            "information",
            "[default]",
            "[default]"
        ],
        "cleanName": "color.chart.information"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.information."
        },
        "value": "#1868DB",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.information."
            },
            "value": "Blue700"
        },
        "name": "color.chart.information.[default].hovered",
        "path": [
            "color",
            "chart",
            "information",
            "[default]",
            "hovered"
        ],
        "cleanName": "color.chart.information.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "A stronger emphasis option of color.chart.information."
        },
        "value": "#1558BC",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "A stronger emphasis option of color.chart.information."
            },
            "value": "Blue800"
        },
        "name": "color.chart.information.bold.[default]",
        "path": [
            "color",
            "chart",
            "information",
            "bold",
            "[default]"
        ],
        "cleanName": "color.chart.information.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.13.3",
            "description": "Hovered state of color.chart.information.bold."
        },
        "value": "#123263",
        "filePath": "schema/themes/atlassian-light/color/chart.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.13.3",
                "description": "Hovered state of color.chart.information.bold."
            },
            "value": "Blue900"
        },
        "name": "color.chart.information.bold.hovered",
        "path": [
            "color",
            "chart",
            "information",
            "bold",
            "hovered"
        ],
        "cleanName": "color.chart.information.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.2.0",
            "description": "Background color for Rovo brand emphasis."
        },
        "value": "#000000",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.2.0",
                "description": "Background color for Rovo brand emphasis."
            },
            "value": "Neutral1200"
        },
        "name": "color.rovo.background.brand.bold.[default]",
        "path": [
            "color",
            "rovo",
            "background",
            "brand",
            "bold",
            "[default]"
        ],
        "cleanName": "color.rovo.background.brand.bold"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.2.0",
            "description": "Hovered state of color.rovo.background.brand.bold."
        },
        "value": "#1E1F21",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.2.0",
                "description": "Hovered state of color.rovo.background.brand.bold."
            },
            "value": "Neutral1100"
        },
        "name": "color.rovo.background.brand.bold.hovered",
        "path": [
            "color",
            "rovo",
            "background",
            "brand",
            "bold",
            "hovered"
        ],
        "cleanName": "color.rovo.background.brand.bold.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "8.2.0",
            "description": "Pressed state of color.rovo.background.brand.bold."
        },
        "value": "#292A2E",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "8.2.0",
                "description": "Pressed state of color.rovo.background.brand.bold."
            },
            "value": "Neutral1000"
        },
        "name": "color.rovo.background.brand.bold.pressed",
        "path": [
            "color",
            "rovo",
            "background",
            "brand",
            "bold",
            "pressed"
        ],
        "cleanName": "color.rovo.background.brand.bold.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.1.1",
            "description": "Use for Rovo lime borders."
        },
        "value": "#6A9A23",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.1.1",
                "description": "Use for Rovo lime borders."
            },
            "value": "Lime600"
        },
        "name": "color.rovo.border.lime",
        "path": [
            "color",
            "rovo",
            "border",
            "lime"
        ],
        "cleanName": "color.rovo.border.lime"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.1.1",
            "description": "Use for Rovo saffron borders."
        },
        "value": "#FCA700",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.1.1",
                "description": "Use for Rovo saffron borders."
            },
            "value": "Orange400"
        },
        "name": "color.rovo.border.saffron",
        "path": [
            "color",
            "rovo",
            "border",
            "saffron"
        ],
        "cleanName": "color.rovo.border.saffron"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.1.1",
            "description": "Use for Rovo blue borders."
        },
        "value": "#1868DB",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.1.1",
                "description": "Use for Rovo blue borders."
            },
            "value": "Blue700"
        },
        "name": "color.rovo.border.blue",
        "path": [
            "color",
            "rovo",
            "border",
            "blue"
        ],
        "cleanName": "color.rovo.border.blue"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.1.1",
            "description": "Use for Rovo purple borders."
        },
        "value": "#AF59E1",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.1.1",
                "description": "Use for Rovo purple borders."
            },
            "value": "Purple600"
        },
        "name": "color.rovo.border.purple",
        "path": [
            "color",
            "rovo",
            "border",
            "purple"
        ],
        "cleanName": "color.rovo.border.purple"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.1.1",
            "description": "Use for Rovo lime icons."
        },
        "value": "#6A9A23",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.1.1",
                "description": "Use for Rovo lime icons."
            },
            "value": "Lime600"
        },
        "name": "color.rovo.icon.lime",
        "path": [
            "color",
            "rovo",
            "icon",
            "lime"
        ],
        "cleanName": "color.rovo.icon.lime"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.1.1",
            "description": "Use for Rovo saffron icons."
        },
        "value": "#FCA700",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.1.1",
                "description": "Use for Rovo saffron icons."
            },
            "value": "Orange400"
        },
        "name": "color.rovo.icon.saffron",
        "path": [
            "color",
            "rovo",
            "icon",
            "saffron"
        ],
        "cleanName": "color.rovo.icon.saffron"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.1.1",
            "description": "Use for Rovo blue icons."
        },
        "value": "#1868DB",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.1.1",
                "description": "Use for Rovo blue icons."
            },
            "value": "Blue700"
        },
        "name": "color.rovo.icon.blue",
        "path": [
            "color",
            "rovo",
            "icon",
            "blue"
        ],
        "cleanName": "color.rovo.icon.blue"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.1.1",
            "description": "Use for Rovo purple icons."
        },
        "value": "#AF59E1",
        "filePath": "schema/themes/atlassian-light/color/background.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.1.1",
                "description": "Use for Rovo purple icons."
            },
            "value": "Purple600"
        },
        "name": "color.rovo.icon.purple",
        "path": [
            "color",
            "rovo",
            "icon",
            "purple"
        ],
        "cleanName": "color.rovo.icon.purple"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use as the primary background for the UI."
        },
        "value": "#FFFFFF",
        "filePath": "schema/themes/atlassian-light/elevation/surface.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use as the primary background for the UI."
            },
            "value": "Neutral0"
        },
        "name": "elevation.surface.[default].[default]",
        "path": [
            "elevation",
            "surface",
            "[default]",
            "[default]"
        ],
        "cleanName": "elevation.surface"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.10.20",
            "description": "Hovered state of elevation.surface"
        },
        "value": "#F0F1F2",
        "filePath": "schema/themes/atlassian-light/elevation/surface.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.10.20",
                "description": "Hovered state of elevation.surface"
            },
            "value": "Neutral200"
        },
        "name": "elevation.surface.[default].hovered",
        "path": [
            "elevation",
            "surface",
            "[default]",
            "hovered"
        ],
        "cleanName": "elevation.surface.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.10.20",
            "description": "Pressed state of elevation.surface"
        },
        "value": "#DDDEE1",
        "filePath": "schema/themes/atlassian-light/elevation/surface.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.10.20",
                "description": "Pressed state of elevation.surface"
            },
            "value": "Neutral300"
        },
        "name": "elevation.surface.[default].pressed",
        "path": [
            "elevation",
            "surface",
            "[default]",
            "pressed"
        ],
        "cleanName": "elevation.surface.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.3.0",
            "description": "Use as a neutral container surface background."
        },
        "value": "#17171708",
        "filePath": "schema/themes/atlassian-light/elevation/surface.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.3.0",
                "description": "Use as a neutral container surface background."
            },
            "value": "Neutral100A"
        },
        "name": "elevation.surface.container.[default]",
        "path": [
            "elevation",
            "surface",
            "container",
            "[default]"
        ],
        "cleanName": "elevation.surface.container"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "14.1.0",
            "description": "Hovered state of elevation.surface.container"
        },
        "value": "#0515240F",
        "filePath": "schema/themes/atlassian-light/elevation/surface.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "14.1.0",
                "description": "Hovered state of elevation.surface.container"
            },
            "value": "Neutral200A"
        },
        "name": "elevation.surface.container.hovered",
        "path": [
            "elevation",
            "surface",
            "container",
            "hovered"
        ],
        "cleanName": "elevation.surface.container.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "14.1.0",
            "description": "Pressed state of elevation.surface.container"
        },
        "value": "#0B120E24",
        "filePath": "schema/themes/atlassian-light/elevation/surface.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "14.1.0",
                "description": "Pressed state of elevation.surface.container"
            },
            "value": "Neutral300A"
        },
        "name": "elevation.surface.container.pressed",
        "path": [
            "elevation",
            "surface",
            "container",
            "pressed"
        ],
        "cleanName": "elevation.surface.container.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for the background of elements that sit on top of they UI, such as modals, dialogs, dropdown menus, floating toolbars, and floating single-action buttons. Also use for the background of raised cards in a dragged state. Combine with elevation.shadow.overlay."
        },
        "value": "#FFFFFF",
        "filePath": "schema/themes/atlassian-light/elevation/surface.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for the background of elements that sit on top of they UI, such as modals, dialogs, dropdown menus, floating toolbars, and floating single-action buttons. Also use for the background of raised cards in a dragged state. Combine with elevation.shadow.overlay."
            },
            "value": "Neutral0"
        },
        "name": "elevation.surface.overlay.[default]",
        "path": [
            "elevation",
            "surface",
            "overlay",
            "[default]"
        ],
        "cleanName": "elevation.surface.overlay"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.10.20",
            "description": "Hovered state of elevation.surface.overlay"
        },
        "value": "#F0F1F2",
        "filePath": "schema/themes/atlassian-light/elevation/surface.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.10.20",
                "description": "Hovered state of elevation.surface.overlay"
            },
            "value": "Neutral200"
        },
        "name": "elevation.surface.overlay.hovered",
        "path": [
            "elevation",
            "surface",
            "overlay",
            "hovered"
        ],
        "cleanName": "elevation.surface.overlay.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.10.20",
            "description": "Pressed state of elevation.surface.overlay"
        },
        "value": "#DDDEE1",
        "filePath": "schema/themes/atlassian-light/elevation/surface.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.10.20",
                "description": "Pressed state of elevation.surface.overlay"
            },
            "value": "Neutral300"
        },
        "name": "elevation.surface.overlay.pressed",
        "path": [
            "elevation",
            "surface",
            "overlay",
            "pressed"
        ],
        "cleanName": "elevation.surface.overlay.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for the background of cards that can be moved, such as Jira cards on a Kanban board. Combine with elevation.shadow.raised."
        },
        "value": "#FFFFFF",
        "filePath": "schema/themes/atlassian-light/elevation/surface.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for the background of cards that can be moved, such as Jira cards on a Kanban board. Combine with elevation.shadow.raised."
            },
            "value": "Neutral0"
        },
        "name": "elevation.surface.raised.[default]",
        "path": [
            "elevation",
            "surface",
            "raised",
            "[default]"
        ],
        "cleanName": "elevation.surface.raised"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.10.20",
            "description": "Hovered state of elevation.surface.raised"
        },
        "value": "#F0F1F2",
        "filePath": "schema/themes/atlassian-light/elevation/surface.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.10.20",
                "description": "Hovered state of elevation.surface.raised"
            },
            "value": "Neutral200"
        },
        "name": "elevation.surface.raised.hovered",
        "path": [
            "elevation",
            "surface",
            "raised",
            "hovered"
        ],
        "cleanName": "elevation.surface.raised.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.10.20",
            "description": "Pressed state of elevation.surface.raised"
        },
        "value": "#DDDEE1",
        "filePath": "schema/themes/atlassian-light/elevation/surface.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.10.20",
                "description": "Pressed state of elevation.surface.raised"
            },
            "value": "Neutral300"
        },
        "name": "elevation.surface.raised.pressed",
        "path": [
            "elevation",
            "surface",
            "raised",
            "pressed"
        ],
        "cleanName": "elevation.surface.raised.pressed"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.6.0",
            "description": "A secondary background for the UI commonly used for grouping items, such as Jira cards in columns."
        },
        "value": "#F8F8F8",
        "filePath": "schema/themes/atlassian-light/elevation/surface.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.6.0",
                "description": "A secondary background for the UI commonly used for grouping items, such as Jira cards in columns."
            },
            "value": "Neutral100"
        },
        "name": "elevation.surface.sunken",
        "path": [
            "elevation",
            "surface",
            "sunken"
        ],
        "cleanName": "elevation.surface.sunken"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.3.0",
            "description": "Use for Rovo overlay surface backgrounds."
        },
        "value": "#F8F8F8",
        "filePath": "schema/themes/atlassian-light/elevation/rovo/surface.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.3.0",
                "description": "Use for Rovo overlay surface backgrounds."
            },
            "value": "Neutral100"
        },
        "name": "elevation.rovo.surface.overlay.[default]",
        "path": [
            "elevation",
            "rovo",
            "surface",
            "overlay",
            "[default]"
        ],
        "cleanName": "elevation.rovo.surface.overlay"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.3.0",
            "description": "Hovered state of elevation.rovo.surface.overlay."
        },
        "value": "#F0F1F2",
        "filePath": "schema/themes/atlassian-light/elevation/rovo/surface.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.3.0",
                "description": "Hovered state of elevation.rovo.surface.overlay."
            },
            "value": "Neutral200"
        },
        "name": "elevation.rovo.surface.overlay.hovered",
        "path": [
            "elevation",
            "rovo",
            "surface",
            "overlay",
            "hovered"
        ],
        "cleanName": "elevation.rovo.surface.overlay.hovered"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "13.3.0",
            "description": "Pressed state of elevation.rovo.surface.overlay."
        },
        "value": "#DDDEE1",
        "filePath": "schema/themes/atlassian-light/elevation/rovo/surface.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "13.3.0",
                "description": "Pressed state of elevation.rovo.surface.overlay."
            },
            "value": "Neutral300"
        },
        "name": "elevation.rovo.surface.overlay.pressed",
        "path": [
            "elevation",
            "rovo",
            "surface",
            "overlay",
            "pressed"
        ],
        "cleanName": "elevation.rovo.surface.overlay.pressed"
    },
    {
        "attributes": {
            "group": "shadow",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use to create a shadow when content scrolls under other content."
        },
        "value": [
            {
                "radius": 8,
                "offset": {
                    "x": 0,
                    "y": 0
                },
                "color": "#1E1F21",
                "opacity": 0.16
            },
            {
                "radius": 1,
                "offset": {
                    "x": 0,
                    "y": 0
                },
                "color": "#1E1F21",
                "opacity": 0.12
            }
        ],
        "filePath": "schema/themes/atlassian-light/elevation/shadow.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "shadow",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use to create a shadow when content scrolls under other content."
            },
            "value": [
                {
                    "radius": 8,
                    "offset": {
                        "x": 0,
                        "y": 0
                    },
                    "color": "Neutral1100",
                    "opacity": 0.16
                },
                {
                    "radius": 1,
                    "offset": {
                        "x": 0,
                        "y": 0
                    },
                    "color": "Neutral1100",
                    "opacity": 0.12
                }
            ]
        },
        "name": "elevation.shadow.overflow.[default]",
        "path": [
            "elevation",
            "shadow",
            "overflow",
            "[default]"
        ],
        "cleanName": "elevation.shadow.overflow"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.10.32",
            "description": "Use only when elevation.shadow.overflow is not technically feasible to implement. Pair with elevation.shadow.overflow.spread to replicate the overflow shadow."
        },
        "value": "#1E1F211f",
        "filePath": "schema/themes/atlassian-light/elevation/shadow.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.10.32",
                "description": "Use only when elevation.shadow.overflow is not technically feasible to implement. Pair with elevation.shadow.overflow.spread to replicate the overflow shadow."
            },
            "value": "#1E1F211f"
        },
        "name": "elevation.shadow.overflow.perimeter",
        "path": [
            "elevation",
            "shadow",
            "overflow",
            "perimeter"
        ],
        "cleanName": "elevation.shadow.overflow.perimeter"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "0.10.32",
            "description": "Use only when elevation.shadow.overflow is not technically feasible to implement. Pair with elevation.shadow.overflow.perimeter to replicate the overflow shadow."
        },
        "value": "#1E1F2129",
        "filePath": "schema/themes/atlassian-light/elevation/shadow.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "0.10.32",
                "description": "Use only when elevation.shadow.overflow is not technically feasible to implement. Pair with elevation.shadow.overflow.perimeter to replicate the overflow shadow."
            },
            "value": "#1E1F2129"
        },
        "name": "elevation.shadow.overflow.spread",
        "path": [
            "elevation",
            "shadow",
            "overflow",
            "spread"
        ],
        "cleanName": "elevation.shadow.overflow.spread"
    },
    {
        "attributes": {
            "group": "shadow",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for the box shadow of elements that sit on top of the UI, such as modals, dropdown menus, flags, and inline dialogs. Combine with elevation.surface.overlay\n\nAlso use for the box shadow of raised cards in a dragged state."
        },
        "value": [
            {
                "radius": 12,
                "offset": {
                    "x": 0,
                    "y": 8
                },
                "color": "#1E1F21",
                "opacity": 0.15
            },
            {
                "radius": 1,
                "offset": {
                    "x": 0,
                    "y": 0
                },
                "color": "#1E1F21",
                "opacity": 0.31
            }
        ],
        "filePath": "schema/themes/atlassian-light/elevation/shadow.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "shadow",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for the box shadow of elements that sit on top of the UI, such as modals, dropdown menus, flags, and inline dialogs. Combine with elevation.surface.overlay\n\nAlso use for the box shadow of raised cards in a dragged state."
            },
            "value": [
                {
                    "radius": 12,
                    "offset": {
                        "x": 0,
                        "y": 8
                    },
                    "color": "Neutral1100",
                    "opacity": 0.15
                },
                {
                    "radius": 1,
                    "offset": {
                        "x": 0,
                        "y": 0
                    },
                    "color": "Neutral1100",
                    "opacity": 0.31
                }
            ]
        },
        "name": "elevation.shadow.overlay",
        "path": [
            "elevation",
            "shadow",
            "overlay"
        ],
        "cleanName": "elevation.shadow.overlay"
    },
    {
        "attributes": {
            "group": "shadow",
            "state": "active",
            "introduced": "0.6.0",
            "description": "Use for the box shadow of raised card elements, such as Jira cards on a Kanban board. Combine with elevation.surface.raised"
        },
        "value": [
            {
                "radius": 1,
                "offset": {
                    "x": 0,
                    "y": 1
                },
                "color": "#1E1F21",
                "opacity": 0.25
            },
            {
                "radius": 1,
                "offset": {
                    "x": 0,
                    "y": 0
                },
                "color": "#1E1F21",
                "opacity": 0.31
            }
        ],
        "filePath": "schema/themes/atlassian-light/elevation/shadow.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "shadow",
                "state": "active",
                "introduced": "0.6.0",
                "description": "Use for the box shadow of raised card elements, such as Jira cards on a Kanban board. Combine with elevation.surface.raised"
            },
            "value": [
                {
                    "radius": 1,
                    "offset": {
                        "x": 0,
                        "y": 1
                    },
                    "color": "Neutral1100",
                    "opacity": 0.25
                },
                {
                    "radius": 1,
                    "offset": {
                        "x": 0,
                        "y": 0
                    },
                    "color": "Neutral1100",
                    "opacity": 0.31
                }
            ]
        },
        "name": "elevation.shadow.raised",
        "path": [
            "elevation",
            "shadow",
            "raised"
        ],
        "cleanName": "elevation.shadow.raised"
    },
    {
        "attributes": {
            "group": "opacity",
            "state": "active",
            "introduced": "0.10.13",
            "description": "Apply to images when in a disabled state."
        },
        "value": 0.4,
        "filePath": "schema/themes/atlassian-light/opacity/opacity.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "opacity",
                "state": "active",
                "introduced": "0.10.13",
                "description": "Apply to images when in a disabled state."
            },
            "value": "Opacity40"
        },
        "name": "opacity.disabled",
        "path": [
            "opacity",
            "disabled"
        ],
        "cleanName": "opacity.disabled"
    },
    {
        "attributes": {
            "group": "opacity",
            "state": "active",
            "introduced": "0.10.13",
            "description": "Apply to content that sits under a loading spinner."
        },
        "value": 0.2,
        "filePath": "schema/themes/atlassian-light/opacity/opacity.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "opacity",
                "state": "active",
                "introduced": "0.10.13",
                "description": "Apply to content that sits under a loading spinner."
            },
            "value": "Opacity20"
        },
        "name": "opacity.loading",
        "path": [
            "opacity",
            "loading"
        ],
        "cleanName": "opacity.loading"
    },
    {
        "attributes": {
            "group": "raw",
            "state": "active",
            "introduced": "0.1.1",
            "description": "Transparent token used for backwards compatibility between new and old theming solutions"
        },
        "value": "transparent",
        "filePath": "schema/themes/atlassian-light/utility/utility.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "raw",
                "state": "active",
                "introduced": "0.1.1",
                "description": "Transparent token used for backwards compatibility between new and old theming solutions"
            },
            "value": "transparent"
        },
        "name": "utility.UNSAFE.transparent",
        "path": [
            "utility",
            "UNSAFE",
            "transparent"
        ],
        "cleanName": "utility.UNSAFE.transparent"
    },
    {
        "attributes": {
            "group": "paint",
            "state": "active",
            "introduced": "1.14.0",
            "description": "A dynamic token that represents the current surface color set by a parent element. It defaults to the 'elevation.surface' token value."
        },
        "value": "#FFFFFF",
        "filePath": "schema/themes/atlassian-light/utility/utility.tsx",
        "isSource": true,
        "original": {
            "attributes": {
                "group": "paint",
                "state": "active",
                "introduced": "1.14.0",
                "description": "A dynamic token that represents the current surface color set by a parent element. It defaults to the 'elevation.surface' token value."
            },
            "value": "Neutral0"
        },
        "name": "utility.elevation.surface.current",
        "path": [
            "utility",
            "elevation",
            "surface",
            "current"
        ],
        "cleanName": "utility.elevation.surface.current"
    }
];
var $30e1ee4df420e489$export$2e2bcd8739ae039 = $30e1ee4df420e489$var$tokens;

});

parcelRegister("eBIfo", function(module, exports) {
$parcel$export(module.exports, "default", () => $ad786f73b03d4c02$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d990bbd734a8d8e531136e364654fcbc>>
 * @codegenCommand yarn build tokens
 */ const $ad786f73b03d4c02$var$tokens = [
    {
        "value": "#EFFFD6",
        "attributes": {
            "group": "palette",
            "category": "lime"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#EFFFD6",
            "attributes": {
                "group": "palette",
                "category": "lime"
            }
        },
        "name": "color.palette.Lime100",
        "path": [
            "color",
            "palette",
            "Lime100"
        ]
    },
    {
        "value": "#D3F1A7",
        "attributes": {
            "group": "palette",
            "category": "lime"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#D3F1A7",
            "attributes": {
                "group": "palette",
                "category": "lime"
            }
        },
        "name": "color.palette.Lime200",
        "path": [
            "color",
            "palette",
            "Lime200"
        ]
    },
    {
        "value": "#BDE97C",
        "attributes": {
            "group": "palette",
            "category": "lime"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#BDE97C",
            "attributes": {
                "group": "palette",
                "category": "lime"
            }
        },
        "name": "color.palette.Lime250",
        "path": [
            "color",
            "palette",
            "Lime250"
        ]
    },
    {
        "value": "#B3DF72",
        "attributes": {
            "group": "palette",
            "category": "lime"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#B3DF72",
            "attributes": {
                "group": "palette",
                "category": "lime"
            }
        },
        "name": "color.palette.Lime300",
        "path": [
            "color",
            "palette",
            "Lime300"
        ]
    },
    {
        "value": "#94C748",
        "attributes": {
            "group": "palette",
            "category": "lime"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#94C748",
            "attributes": {
                "group": "palette",
                "category": "lime"
            }
        },
        "name": "color.palette.Lime400",
        "path": [
            "color",
            "palette",
            "Lime400"
        ]
    },
    {
        "value": "#82B536",
        "attributes": {
            "group": "palette",
            "category": "lime"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#82B536",
            "attributes": {
                "group": "palette",
                "category": "lime"
            }
        },
        "name": "color.palette.Lime500",
        "path": [
            "color",
            "palette",
            "Lime500"
        ]
    },
    {
        "value": "#6A9A23",
        "attributes": {
            "group": "palette",
            "category": "lime"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#6A9A23",
            "attributes": {
                "group": "palette",
                "category": "lime"
            }
        },
        "name": "color.palette.Lime600",
        "path": [
            "color",
            "palette",
            "Lime600"
        ]
    },
    {
        "value": "#5B7F24",
        "attributes": {
            "group": "palette",
            "category": "lime"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#5B7F24",
            "attributes": {
                "group": "palette",
                "category": "lime"
            }
        },
        "name": "color.palette.Lime700",
        "path": [
            "color",
            "palette",
            "Lime700"
        ]
    },
    {
        "value": "#4C6B1F",
        "attributes": {
            "group": "palette",
            "category": "lime"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#4C6B1F",
            "attributes": {
                "group": "palette",
                "category": "lime"
            }
        },
        "name": "color.palette.Lime800",
        "path": [
            "color",
            "palette",
            "Lime800"
        ]
    },
    {
        "value": "#3F5224",
        "attributes": {
            "group": "palette",
            "category": "lime"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#3F5224",
            "attributes": {
                "group": "palette",
                "category": "lime"
            }
        },
        "name": "color.palette.Lime850",
        "path": [
            "color",
            "palette",
            "Lime850"
        ]
    },
    {
        "value": "#37471F",
        "attributes": {
            "group": "palette",
            "category": "lime"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#37471F",
            "attributes": {
                "group": "palette",
                "category": "lime"
            }
        },
        "name": "color.palette.Lime900",
        "path": [
            "color",
            "palette",
            "Lime900"
        ]
    },
    {
        "value": "#28311B",
        "attributes": {
            "group": "palette",
            "category": "lime"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#28311B",
            "attributes": {
                "group": "palette",
                "category": "lime"
            }
        },
        "name": "color.palette.Lime1000",
        "path": [
            "color",
            "palette",
            "Lime1000"
        ]
    },
    {
        "value": "#FFECEB",
        "attributes": {
            "group": "palette",
            "category": "red"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#FFECEB",
            "attributes": {
                "group": "palette",
                "category": "red"
            }
        },
        "name": "color.palette.Red100",
        "path": [
            "color",
            "palette",
            "Red100"
        ]
    },
    {
        "value": "#FFD5D2",
        "attributes": {
            "group": "palette",
            "category": "red"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#FFD5D2",
            "attributes": {
                "group": "palette",
                "category": "red"
            }
        },
        "name": "color.palette.Red200",
        "path": [
            "color",
            "palette",
            "Red200"
        ]
    },
    {
        "value": "#FFD5D266",
        "attributes": {
            "group": "palette",
            "category": "red"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#FFD5D266",
            "attributes": {
                "group": "palette",
                "category": "red"
            }
        },
        "name": "color.palette.Red200A40",
        "path": [
            "color",
            "palette",
            "Red200A40"
        ]
    },
    {
        "value": "#FFB8B2",
        "attributes": {
            "group": "palette",
            "category": "red"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#FFB8B2",
            "attributes": {
                "group": "palette",
                "category": "red"
            }
        },
        "name": "color.palette.Red250",
        "path": [
            "color",
            "palette",
            "Red250"
        ]
    },
    {
        "value": "#FD9891",
        "attributes": {
            "group": "palette",
            "category": "red"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#FD9891",
            "attributes": {
                "group": "palette",
                "category": "red"
            }
        },
        "name": "color.palette.Red300",
        "path": [
            "color",
            "palette",
            "Red300"
        ]
    },
    {
        "value": "#F87168",
        "attributes": {
            "group": "palette",
            "category": "red"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#F87168",
            "attributes": {
                "group": "palette",
                "category": "red"
            }
        },
        "name": "color.palette.Red400",
        "path": [
            "color",
            "palette",
            "Red400"
        ]
    },
    {
        "value": "#F15B50",
        "attributes": {
            "group": "palette",
            "category": "red"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#F15B50",
            "attributes": {
                "group": "palette",
                "category": "red"
            }
        },
        "name": "color.palette.Red500",
        "path": [
            "color",
            "palette",
            "Red500"
        ]
    },
    {
        "value": "#E2483D",
        "attributes": {
            "group": "palette",
            "category": "red"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#E2483D",
            "attributes": {
                "group": "palette",
                "category": "red"
            }
        },
        "name": "color.palette.Red600",
        "path": [
            "color",
            "palette",
            "Red600"
        ]
    },
    {
        "value": "#C9372C",
        "attributes": {
            "group": "palette",
            "category": "red"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#C9372C",
            "attributes": {
                "group": "palette",
                "category": "red"
            }
        },
        "name": "color.palette.Red700",
        "path": [
            "color",
            "palette",
            "Red700"
        ]
    },
    {
        "value": "#AE2E24",
        "attributes": {
            "group": "palette",
            "category": "red"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#AE2E24",
            "attributes": {
                "group": "palette",
                "category": "red"
            }
        },
        "name": "color.palette.Red800",
        "path": [
            "color",
            "palette",
            "Red800"
        ]
    },
    {
        "value": "#872821",
        "attributes": {
            "group": "palette",
            "category": "red"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#872821",
            "attributes": {
                "group": "palette",
                "category": "red"
            }
        },
        "name": "color.palette.Red850",
        "path": [
            "color",
            "palette",
            "Red850"
        ]
    },
    {
        "value": "#5D1F1A",
        "attributes": {
            "group": "palette",
            "category": "red"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#5D1F1A",
            "attributes": {
                "group": "palette",
                "category": "red"
            }
        },
        "name": "color.palette.Red900",
        "path": [
            "color",
            "palette",
            "Red900"
        ]
    },
    {
        "value": "#5D1F1AB2",
        "attributes": {
            "group": "palette",
            "category": "red"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#5D1F1AB2",
            "attributes": {
                "group": "palette",
                "category": "red"
            }
        },
        "name": "color.palette.Red900A70",
        "path": [
            "color",
            "palette",
            "Red900A70"
        ]
    },
    {
        "value": "#42221F",
        "attributes": {
            "group": "palette",
            "category": "red"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#42221F",
            "attributes": {
                "group": "palette",
                "category": "red"
            }
        },
        "name": "color.palette.Red1000",
        "path": [
            "color",
            "palette",
            "Red1000"
        ]
    },
    {
        "value": "#FFF5DB",
        "attributes": {
            "group": "palette",
            "category": "orange"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#FFF5DB",
            "attributes": {
                "group": "palette",
                "category": "orange"
            }
        },
        "name": "color.palette.Orange100",
        "path": [
            "color",
            "palette",
            "Orange100"
        ]
    },
    {
        "value": "#FCE4A6",
        "attributes": {
            "group": "palette",
            "category": "orange"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#FCE4A6",
            "attributes": {
                "group": "palette",
                "category": "orange"
            }
        },
        "name": "color.palette.Orange200",
        "path": [
            "color",
            "palette",
            "Orange200"
        ]
    },
    {
        "value": "#FBD779",
        "attributes": {
            "group": "palette",
            "category": "orange"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#FBD779",
            "attributes": {
                "group": "palette",
                "category": "orange"
            }
        },
        "name": "color.palette.Orange250",
        "path": [
            "color",
            "palette",
            "Orange250"
        ]
    },
    {
        "value": "#FBC828",
        "attributes": {
            "group": "palette",
            "category": "orange"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#FBC828",
            "attributes": {
                "group": "palette",
                "category": "orange"
            }
        },
        "name": "color.palette.Orange300",
        "path": [
            "color",
            "palette",
            "Orange300"
        ]
    },
    {
        "value": "#FCA700",
        "attributes": {
            "group": "palette",
            "category": "orange"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#FCA700",
            "attributes": {
                "group": "palette",
                "category": "orange"
            }
        },
        "name": "color.palette.Orange400",
        "path": [
            "color",
            "palette",
            "Orange400"
        ]
    },
    {
        "value": "#F68909",
        "attributes": {
            "group": "palette",
            "category": "orange"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#F68909",
            "attributes": {
                "group": "palette",
                "category": "orange"
            }
        },
        "name": "color.palette.Orange500",
        "path": [
            "color",
            "palette",
            "Orange500"
        ]
    },
    {
        "value": "#E06C00",
        "attributes": {
            "group": "palette",
            "category": "orange"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#E06C00",
            "attributes": {
                "group": "palette",
                "category": "orange"
            }
        },
        "name": "color.palette.Orange600",
        "path": [
            "color",
            "palette",
            "Orange600"
        ]
    },
    {
        "value": "#BD5B00",
        "attributes": {
            "group": "palette",
            "category": "orange"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#BD5B00",
            "attributes": {
                "group": "palette",
                "category": "orange"
            }
        },
        "name": "color.palette.Orange700",
        "path": [
            "color",
            "palette",
            "Orange700"
        ]
    },
    {
        "value": "#9E4C00",
        "attributes": {
            "group": "palette",
            "category": "orange"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#9E4C00",
            "attributes": {
                "group": "palette",
                "category": "orange"
            }
        },
        "name": "color.palette.Orange800",
        "path": [
            "color",
            "palette",
            "Orange800"
        ]
    },
    {
        "value": "#7A3B00",
        "attributes": {
            "group": "palette",
            "category": "orange"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#7A3B00",
            "attributes": {
                "group": "palette",
                "category": "orange"
            }
        },
        "name": "color.palette.Orange850",
        "path": [
            "color",
            "palette",
            "Orange850"
        ]
    },
    {
        "value": "#693200",
        "attributes": {
            "group": "palette",
            "category": "orange"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#693200",
            "attributes": {
                "group": "palette",
                "category": "orange"
            }
        },
        "name": "color.palette.Orange900",
        "path": [
            "color",
            "palette",
            "Orange900"
        ]
    },
    {
        "value": "#3A2C1F",
        "attributes": {
            "group": "palette",
            "category": "orange"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#3A2C1F",
            "attributes": {
                "group": "palette",
                "category": "orange"
            }
        },
        "name": "color.palette.Orange1000",
        "path": [
            "color",
            "palette",
            "Orange1000"
        ]
    },
    {
        "value": "#FEF7C8",
        "attributes": {
            "group": "palette",
            "category": "yellow"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#FEF7C8",
            "attributes": {
                "group": "palette",
                "category": "yellow"
            }
        },
        "name": "color.palette.Yellow100",
        "path": [
            "color",
            "palette",
            "Yellow100"
        ]
    },
    {
        "value": "#F5E989",
        "attributes": {
            "group": "palette",
            "category": "yellow"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#F5E989",
            "attributes": {
                "group": "palette",
                "category": "yellow"
            }
        },
        "name": "color.palette.Yellow200",
        "path": [
            "color",
            "palette",
            "Yellow200"
        ]
    },
    {
        "value": "#EFDD4E",
        "attributes": {
            "group": "palette",
            "category": "yellow"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#EFDD4E",
            "attributes": {
                "group": "palette",
                "category": "yellow"
            }
        },
        "name": "color.palette.Yellow250",
        "path": [
            "color",
            "palette",
            "Yellow250"
        ]
    },
    {
        "value": "#EED12B",
        "attributes": {
            "group": "palette",
            "category": "yellow"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#EED12B",
            "attributes": {
                "group": "palette",
                "category": "yellow"
            }
        },
        "name": "color.palette.Yellow300",
        "path": [
            "color",
            "palette",
            "Yellow300"
        ]
    },
    {
        "value": "#DDB30E",
        "attributes": {
            "group": "palette",
            "category": "yellow"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#DDB30E",
            "attributes": {
                "group": "palette",
                "category": "yellow"
            }
        },
        "name": "color.palette.Yellow400",
        "path": [
            "color",
            "palette",
            "Yellow400"
        ]
    },
    {
        "value": "#CF9F02",
        "attributes": {
            "group": "palette",
            "category": "yellow"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#CF9F02",
            "attributes": {
                "group": "palette",
                "category": "yellow"
            }
        },
        "name": "color.palette.Yellow500",
        "path": [
            "color",
            "palette",
            "Yellow500"
        ]
    },
    {
        "value": "#B38600",
        "attributes": {
            "group": "palette",
            "category": "yellow"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#B38600",
            "attributes": {
                "group": "palette",
                "category": "yellow"
            }
        },
        "name": "color.palette.Yellow600",
        "path": [
            "color",
            "palette",
            "Yellow600"
        ]
    },
    {
        "value": "#946F00",
        "attributes": {
            "group": "palette",
            "category": "yellow"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#946F00",
            "attributes": {
                "group": "palette",
                "category": "yellow"
            }
        },
        "name": "color.palette.Yellow700",
        "path": [
            "color",
            "palette",
            "Yellow700"
        ]
    },
    {
        "value": "#7F5F01",
        "attributes": {
            "group": "palette",
            "category": "yellow"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#7F5F01",
            "attributes": {
                "group": "palette",
                "category": "yellow"
            }
        },
        "name": "color.palette.Yellow800",
        "path": [
            "color",
            "palette",
            "Yellow800"
        ]
    },
    {
        "value": "#614A05",
        "attributes": {
            "group": "palette",
            "category": "yellow"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#614A05",
            "attributes": {
                "group": "palette",
                "category": "yellow"
            }
        },
        "name": "color.palette.Yellow850",
        "path": [
            "color",
            "palette",
            "Yellow850"
        ]
    },
    {
        "value": "#533F04",
        "attributes": {
            "group": "palette",
            "category": "yellow"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#533F04",
            "attributes": {
                "group": "palette",
                "category": "yellow"
            }
        },
        "name": "color.palette.Yellow900",
        "path": [
            "color",
            "palette",
            "Yellow900"
        ]
    },
    {
        "value": "#332E1B",
        "attributes": {
            "group": "palette",
            "category": "yellow"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#332E1B",
            "attributes": {
                "group": "palette",
                "category": "yellow"
            }
        },
        "name": "color.palette.Yellow1000",
        "path": [
            "color",
            "palette",
            "Yellow1000"
        ]
    },
    {
        "value": "#DCFFF1",
        "attributes": {
            "group": "palette",
            "category": "green"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#DCFFF1",
            "attributes": {
                "group": "palette",
                "category": "green"
            }
        },
        "name": "color.palette.Green100",
        "path": [
            "color",
            "palette",
            "Green100"
        ]
    },
    {
        "value": "#BAF3DB",
        "attributes": {
            "group": "palette",
            "category": "green"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#BAF3DB",
            "attributes": {
                "group": "palette",
                "category": "green"
            }
        },
        "name": "color.palette.Green200",
        "path": [
            "color",
            "palette",
            "Green200"
        ]
    },
    {
        "value": "#BAF3DB66",
        "attributes": {
            "group": "palette",
            "category": "green"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#BAF3DB66",
            "attributes": {
                "group": "palette",
                "category": "green"
            }
        },
        "name": "color.palette.Green200A40",
        "path": [
            "color",
            "palette",
            "Green200A40"
        ]
    },
    {
        "value": "#97EDC9",
        "attributes": {
            "group": "palette",
            "category": "green"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#97EDC9",
            "attributes": {
                "group": "palette",
                "category": "green"
            }
        },
        "name": "color.palette.Green250",
        "path": [
            "color",
            "palette",
            "Green250"
        ]
    },
    {
        "value": "#7EE2B8",
        "attributes": {
            "group": "palette",
            "category": "green"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#7EE2B8",
            "attributes": {
                "group": "palette",
                "category": "green"
            }
        },
        "name": "color.palette.Green300",
        "path": [
            "color",
            "palette",
            "Green300"
        ]
    },
    {
        "value": "#4BCE97",
        "attributes": {
            "group": "palette",
            "category": "green"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#4BCE97",
            "attributes": {
                "group": "palette",
                "category": "green"
            }
        },
        "name": "color.palette.Green400",
        "path": [
            "color",
            "palette",
            "Green400"
        ]
    },
    {
        "value": "#2ABB7F",
        "attributes": {
            "group": "palette",
            "category": "green"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#2ABB7F",
            "attributes": {
                "group": "palette",
                "category": "green"
            }
        },
        "name": "color.palette.Green500",
        "path": [
            "color",
            "palette",
            "Green500"
        ]
    },
    {
        "value": "#22A06B",
        "attributes": {
            "group": "palette",
            "category": "green"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#22A06B",
            "attributes": {
                "group": "palette",
                "category": "green"
            }
        },
        "name": "color.palette.Green600",
        "path": [
            "color",
            "palette",
            "Green600"
        ]
    },
    {
        "value": "#1F845A",
        "attributes": {
            "group": "palette",
            "category": "green"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#1F845A",
            "attributes": {
                "group": "palette",
                "category": "green"
            }
        },
        "name": "color.palette.Green700",
        "path": [
            "color",
            "palette",
            "Green700"
        ]
    },
    {
        "value": "#216E4E",
        "attributes": {
            "group": "palette",
            "category": "green"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#216E4E",
            "attributes": {
                "group": "palette",
                "category": "green"
            }
        },
        "name": "color.palette.Green800",
        "path": [
            "color",
            "palette",
            "Green800"
        ]
    },
    {
        "value": "#19573D",
        "attributes": {
            "group": "palette",
            "category": "green"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#19573D",
            "attributes": {
                "group": "palette",
                "category": "green"
            }
        },
        "name": "color.palette.Green850",
        "path": [
            "color",
            "palette",
            "Green850"
        ]
    },
    {
        "value": "#164B35",
        "attributes": {
            "group": "palette",
            "category": "green"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#164B35",
            "attributes": {
                "group": "palette",
                "category": "green"
            }
        },
        "name": "color.palette.Green900",
        "path": [
            "color",
            "palette",
            "Green900"
        ]
    },
    {
        "value": "#164B35B2",
        "attributes": {
            "group": "palette",
            "category": "green"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#164B35B2",
            "attributes": {
                "group": "palette",
                "category": "green"
            }
        },
        "name": "color.palette.Green900A70",
        "path": [
            "color",
            "palette",
            "Green900A70"
        ]
    },
    {
        "value": "#1C3329",
        "attributes": {
            "group": "palette",
            "category": "green"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#1C3329",
            "attributes": {
                "group": "palette",
                "category": "green"
            }
        },
        "name": "color.palette.Green1000",
        "path": [
            "color",
            "palette",
            "Green1000"
        ]
    },
    {
        "value": "#E7F9FF",
        "attributes": {
            "group": "palette",
            "category": "teal"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#E7F9FF",
            "attributes": {
                "group": "palette",
                "category": "teal"
            }
        },
        "name": "color.palette.Teal100",
        "path": [
            "color",
            "palette",
            "Teal100"
        ]
    },
    {
        "value": "#C6EDFB",
        "attributes": {
            "group": "palette",
            "category": "teal"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#C6EDFB",
            "attributes": {
                "group": "palette",
                "category": "teal"
            }
        },
        "name": "color.palette.Teal200",
        "path": [
            "color",
            "palette",
            "Teal200"
        ]
    },
    {
        "value": "#B1E4F7",
        "attributes": {
            "group": "palette",
            "category": "teal"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#B1E4F7",
            "attributes": {
                "group": "palette",
                "category": "teal"
            }
        },
        "name": "color.palette.Teal250",
        "path": [
            "color",
            "palette",
            "Teal250"
        ]
    },
    {
        "value": "#9DD9EE",
        "attributes": {
            "group": "palette",
            "category": "teal"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#9DD9EE",
            "attributes": {
                "group": "palette",
                "category": "teal"
            }
        },
        "name": "color.palette.Teal300",
        "path": [
            "color",
            "palette",
            "Teal300"
        ]
    },
    {
        "value": "#6CC3E0",
        "attributes": {
            "group": "palette",
            "category": "teal"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#6CC3E0",
            "attributes": {
                "group": "palette",
                "category": "teal"
            }
        },
        "name": "color.palette.Teal400",
        "path": [
            "color",
            "palette",
            "Teal400"
        ]
    },
    {
        "value": "#42B2D7",
        "attributes": {
            "group": "palette",
            "category": "teal"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#42B2D7",
            "attributes": {
                "group": "palette",
                "category": "teal"
            }
        },
        "name": "color.palette.Teal500",
        "path": [
            "color",
            "palette",
            "Teal500"
        ]
    },
    {
        "value": "#2898BD",
        "attributes": {
            "group": "palette",
            "category": "teal"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#2898BD",
            "attributes": {
                "group": "palette",
                "category": "teal"
            }
        },
        "name": "color.palette.Teal600",
        "path": [
            "color",
            "palette",
            "Teal600"
        ]
    },
    {
        "value": "#227D9B",
        "attributes": {
            "group": "palette",
            "category": "teal"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#227D9B",
            "attributes": {
                "group": "palette",
                "category": "teal"
            }
        },
        "name": "color.palette.Teal700",
        "path": [
            "color",
            "palette",
            "Teal700"
        ]
    },
    {
        "value": "#206A83",
        "attributes": {
            "group": "palette",
            "category": "teal"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#206A83",
            "attributes": {
                "group": "palette",
                "category": "teal"
            }
        },
        "name": "color.palette.Teal800",
        "path": [
            "color",
            "palette",
            "Teal800"
        ]
    },
    {
        "value": "#1A5265",
        "attributes": {
            "group": "palette",
            "category": "teal"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#1A5265",
            "attributes": {
                "group": "palette",
                "category": "teal"
            }
        },
        "name": "color.palette.Teal850",
        "path": [
            "color",
            "palette",
            "Teal850"
        ]
    },
    {
        "value": "#164555",
        "attributes": {
            "group": "palette",
            "category": "teal"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#164555",
            "attributes": {
                "group": "palette",
                "category": "teal"
            }
        },
        "name": "color.palette.Teal900",
        "path": [
            "color",
            "palette",
            "Teal900"
        ]
    },
    {
        "value": "#1E3137",
        "attributes": {
            "group": "palette",
            "category": "teal"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#1E3137",
            "attributes": {
                "group": "palette",
                "category": "teal"
            }
        },
        "name": "color.palette.Teal1000",
        "path": [
            "color",
            "palette",
            "Teal1000"
        ]
    },
    {
        "value": "#E9F2FE",
        "attributes": {
            "group": "palette",
            "category": "blue"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#E9F2FE",
            "attributes": {
                "group": "palette",
                "category": "blue"
            }
        },
        "name": "color.palette.Blue100",
        "path": [
            "color",
            "palette",
            "Blue100"
        ]
    },
    {
        "value": "#CFE1FD",
        "attributes": {
            "group": "palette",
            "category": "blue"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#CFE1FD",
            "attributes": {
                "group": "palette",
                "category": "blue"
            }
        },
        "name": "color.palette.Blue200",
        "path": [
            "color",
            "palette",
            "Blue200"
        ]
    },
    {
        "value": "#ADCBFB",
        "attributes": {
            "group": "palette",
            "category": "blue"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#ADCBFB",
            "attributes": {
                "group": "palette",
                "category": "blue"
            }
        },
        "name": "color.palette.Blue250",
        "path": [
            "color",
            "palette",
            "Blue250"
        ]
    },
    {
        "value": "#8FB8F6",
        "attributes": {
            "group": "palette",
            "category": "blue"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#8FB8F6",
            "attributes": {
                "group": "palette",
                "category": "blue"
            }
        },
        "name": "color.palette.Blue300",
        "path": [
            "color",
            "palette",
            "Blue300"
        ]
    },
    {
        "value": "#669DF1",
        "attributes": {
            "group": "palette",
            "category": "blue"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#669DF1",
            "attributes": {
                "group": "palette",
                "category": "blue"
            }
        },
        "name": "color.palette.Blue400",
        "path": [
            "color",
            "palette",
            "Blue400"
        ]
    },
    {
        "value": "#4688EC",
        "attributes": {
            "group": "palette",
            "category": "blue"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#4688EC",
            "attributes": {
                "group": "palette",
                "category": "blue"
            }
        },
        "name": "color.palette.Blue500",
        "path": [
            "color",
            "palette",
            "Blue500"
        ]
    },
    {
        "value": "#357DE8",
        "attributes": {
            "group": "palette",
            "category": "blue"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#357DE8",
            "attributes": {
                "group": "palette",
                "category": "blue"
            }
        },
        "name": "color.palette.Blue600",
        "path": [
            "color",
            "palette",
            "Blue600"
        ]
    },
    {
        "value": "#1868DB",
        "attributes": {
            "group": "palette",
            "category": "blue"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#1868DB",
            "attributes": {
                "group": "palette",
                "category": "blue"
            }
        },
        "name": "color.palette.Blue700",
        "path": [
            "color",
            "palette",
            "Blue700"
        ]
    },
    {
        "value": "#1558BC",
        "attributes": {
            "group": "palette",
            "category": "blue"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#1558BC",
            "attributes": {
                "group": "palette",
                "category": "blue"
            }
        },
        "name": "color.palette.Blue800",
        "path": [
            "color",
            "palette",
            "Blue800"
        ]
    },
    {
        "value": "#144794",
        "attributes": {
            "group": "palette",
            "category": "blue"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#144794",
            "attributes": {
                "group": "palette",
                "category": "blue"
            }
        },
        "name": "color.palette.Blue850",
        "path": [
            "color",
            "palette",
            "Blue850"
        ]
    },
    {
        "value": "#123263",
        "attributes": {
            "group": "palette",
            "category": "blue"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#123263",
            "attributes": {
                "group": "palette",
                "category": "blue"
            }
        },
        "name": "color.palette.Blue900",
        "path": [
            "color",
            "palette",
            "Blue900"
        ]
    },
    {
        "value": "#1C2B42",
        "attributes": {
            "group": "palette",
            "category": "blue"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#1C2B42",
            "attributes": {
                "group": "palette",
                "category": "blue"
            }
        },
        "name": "color.palette.Blue1000",
        "path": [
            "color",
            "palette",
            "Blue1000"
        ]
    },
    {
        "value": "#F8EEFE",
        "attributes": {
            "group": "palette",
            "category": "purple"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#F8EEFE",
            "attributes": {
                "group": "palette",
                "category": "purple"
            }
        },
        "name": "color.palette.Purple100",
        "path": [
            "color",
            "palette",
            "Purple100"
        ]
    },
    {
        "value": "#EED7FC",
        "attributes": {
            "group": "palette",
            "category": "purple"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#EED7FC",
            "attributes": {
                "group": "palette",
                "category": "purple"
            }
        },
        "name": "color.palette.Purple200",
        "path": [
            "color",
            "palette",
            "Purple200"
        ]
    },
    {
        "value": "#E3BDFA",
        "attributes": {
            "group": "palette",
            "category": "purple"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#E3BDFA",
            "attributes": {
                "group": "palette",
                "category": "purple"
            }
        },
        "name": "color.palette.Purple250",
        "path": [
            "color",
            "palette",
            "Purple250"
        ]
    },
    {
        "value": "#D8A0F7",
        "attributes": {
            "group": "palette",
            "category": "purple"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#D8A0F7",
            "attributes": {
                "group": "palette",
                "category": "purple"
            }
        },
        "name": "color.palette.Purple300",
        "path": [
            "color",
            "palette",
            "Purple300"
        ]
    },
    {
        "value": "#C97CF4",
        "attributes": {
            "group": "palette",
            "category": "purple"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#C97CF4",
            "attributes": {
                "group": "palette",
                "category": "purple"
            }
        },
        "name": "color.palette.Purple400",
        "path": [
            "color",
            "palette",
            "Purple400"
        ]
    },
    {
        "value": "#BF63F3",
        "attributes": {
            "group": "palette",
            "category": "purple"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#BF63F3",
            "attributes": {
                "group": "palette",
                "category": "purple"
            }
        },
        "name": "color.palette.Purple500",
        "path": [
            "color",
            "palette",
            "Purple500"
        ]
    },
    {
        "value": "#AF59E1",
        "attributes": {
            "group": "palette",
            "category": "purple"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#AF59E1",
            "attributes": {
                "group": "palette",
                "category": "purple"
            }
        },
        "name": "color.palette.Purple600",
        "path": [
            "color",
            "palette",
            "Purple600"
        ]
    },
    {
        "value": "#964AC0",
        "attributes": {
            "group": "palette",
            "category": "purple"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#964AC0",
            "attributes": {
                "group": "palette",
                "category": "purple"
            }
        },
        "name": "color.palette.Purple700",
        "path": [
            "color",
            "palette",
            "Purple700"
        ]
    },
    {
        "value": "#803FA5",
        "attributes": {
            "group": "palette",
            "category": "purple"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#803FA5",
            "attributes": {
                "group": "palette",
                "category": "purple"
            }
        },
        "name": "color.palette.Purple800",
        "path": [
            "color",
            "palette",
            "Purple800"
        ]
    },
    {
        "value": "#673286",
        "attributes": {
            "group": "palette",
            "category": "purple"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#673286",
            "attributes": {
                "group": "palette",
                "category": "purple"
            }
        },
        "name": "color.palette.Purple850",
        "path": [
            "color",
            "palette",
            "Purple850"
        ]
    },
    {
        "value": "#48245D",
        "attributes": {
            "group": "palette",
            "category": "purple"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#48245D",
            "attributes": {
                "group": "palette",
                "category": "purple"
            }
        },
        "name": "color.palette.Purple900",
        "path": [
            "color",
            "palette",
            "Purple900"
        ]
    },
    {
        "value": "#35243F",
        "attributes": {
            "group": "palette",
            "category": "purple"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#35243F",
            "attributes": {
                "group": "palette",
                "category": "purple"
            }
        },
        "name": "color.palette.Purple1000",
        "path": [
            "color",
            "palette",
            "Purple1000"
        ]
    },
    {
        "value": "#FFECF8",
        "attributes": {
            "group": "palette",
            "category": "magenta"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#FFECF8",
            "attributes": {
                "group": "palette",
                "category": "magenta"
            }
        },
        "name": "color.palette.Magenta100",
        "path": [
            "color",
            "palette",
            "Magenta100"
        ]
    },
    {
        "value": "#FDD0EC",
        "attributes": {
            "group": "palette",
            "category": "magenta"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#FDD0EC",
            "attributes": {
                "group": "palette",
                "category": "magenta"
            }
        },
        "name": "color.palette.Magenta200",
        "path": [
            "color",
            "palette",
            "Magenta200"
        ]
    },
    {
        "value": "#FCB6E1",
        "attributes": {
            "group": "palette",
            "category": "magenta"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#FCB6E1",
            "attributes": {
                "group": "palette",
                "category": "magenta"
            }
        },
        "name": "color.palette.Magenta250",
        "path": [
            "color",
            "palette",
            "Magenta250"
        ]
    },
    {
        "value": "#F797D2",
        "attributes": {
            "group": "palette",
            "category": "magenta"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#F797D2",
            "attributes": {
                "group": "palette",
                "category": "magenta"
            }
        },
        "name": "color.palette.Magenta300",
        "path": [
            "color",
            "palette",
            "Magenta300"
        ]
    },
    {
        "value": "#E774BB",
        "attributes": {
            "group": "palette",
            "category": "magenta"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#E774BB",
            "attributes": {
                "group": "palette",
                "category": "magenta"
            }
        },
        "name": "color.palette.Magenta400",
        "path": [
            "color",
            "palette",
            "Magenta400"
        ]
    },
    {
        "value": "#DA62AC",
        "attributes": {
            "group": "palette",
            "category": "magenta"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#DA62AC",
            "attributes": {
                "group": "palette",
                "category": "magenta"
            }
        },
        "name": "color.palette.Magenta500",
        "path": [
            "color",
            "palette",
            "Magenta500"
        ]
    },
    {
        "value": "#CD519D",
        "attributes": {
            "group": "palette",
            "category": "magenta"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#CD519D",
            "attributes": {
                "group": "palette",
                "category": "magenta"
            }
        },
        "name": "color.palette.Magenta600",
        "path": [
            "color",
            "palette",
            "Magenta600"
        ]
    },
    {
        "value": "#AE4787",
        "attributes": {
            "group": "palette",
            "category": "magenta"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#AE4787",
            "attributes": {
                "group": "palette",
                "category": "magenta"
            }
        },
        "name": "color.palette.Magenta700",
        "path": [
            "color",
            "palette",
            "Magenta700"
        ]
    },
    {
        "value": "#943D73",
        "attributes": {
            "group": "palette",
            "category": "magenta"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#943D73",
            "attributes": {
                "group": "palette",
                "category": "magenta"
            }
        },
        "name": "color.palette.Magenta800",
        "path": [
            "color",
            "palette",
            "Magenta800"
        ]
    },
    {
        "value": "#77325B",
        "attributes": {
            "group": "palette",
            "category": "magenta"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#77325B",
            "attributes": {
                "group": "palette",
                "category": "magenta"
            }
        },
        "name": "color.palette.Magenta850",
        "path": [
            "color",
            "palette",
            "Magenta850"
        ]
    },
    {
        "value": "#50253F",
        "attributes": {
            "group": "palette",
            "category": "magenta"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#50253F",
            "attributes": {
                "group": "palette",
                "category": "magenta"
            }
        },
        "name": "color.palette.Magenta900",
        "path": [
            "color",
            "palette",
            "Magenta900"
        ]
    },
    {
        "value": "#3D2232",
        "attributes": {
            "group": "palette",
            "category": "magenta"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#3D2232",
            "attributes": {
                "group": "palette",
                "category": "magenta"
            }
        },
        "name": "color.palette.Magenta1000",
        "path": [
            "color",
            "palette",
            "Magenta1000"
        ]
    },
    {
        "value": "#FFFFFF",
        "attributes": {
            "group": "palette",
            "category": "light mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#FFFFFF",
            "attributes": {
                "group": "palette",
                "category": "light mode neutral"
            }
        },
        "name": "color.palette.Neutral0",
        "path": [
            "color",
            "palette",
            "Neutral0"
        ]
    },
    {
        "value": "#F8F8F8",
        "attributes": {
            "group": "palette",
            "category": "light mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#F8F8F8",
            "attributes": {
                "group": "palette",
                "category": "light mode neutral"
            }
        },
        "name": "color.palette.Neutral100",
        "path": [
            "color",
            "palette",
            "Neutral100"
        ]
    },
    {
        "value": "#F0F1F2",
        "attributes": {
            "group": "palette",
            "category": "light mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#F0F1F2",
            "attributes": {
                "group": "palette",
                "category": "light mode neutral"
            }
        },
        "name": "color.palette.Neutral200",
        "path": [
            "color",
            "palette",
            "Neutral200"
        ]
    },
    {
        "value": "#DDDEE1",
        "attributes": {
            "group": "palette",
            "category": "light mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#DDDEE1",
            "attributes": {
                "group": "palette",
                "category": "light mode neutral"
            }
        },
        "name": "color.palette.Neutral300",
        "path": [
            "color",
            "palette",
            "Neutral300"
        ]
    },
    {
        "value": "#B7B9BE",
        "attributes": {
            "group": "palette",
            "category": "light mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#B7B9BE",
            "attributes": {
                "group": "palette",
                "category": "light mode neutral"
            }
        },
        "name": "color.palette.Neutral400",
        "path": [
            "color",
            "palette",
            "Neutral400"
        ]
    },
    {
        "value": "#8C8F97",
        "attributes": {
            "group": "palette",
            "category": "light mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#8C8F97",
            "attributes": {
                "group": "palette",
                "category": "light mode neutral"
            }
        },
        "name": "color.palette.Neutral500",
        "path": [
            "color",
            "palette",
            "Neutral500"
        ]
    },
    {
        "value": "#7D818A",
        "attributes": {
            "group": "palette",
            "category": "light mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#7D818A",
            "attributes": {
                "group": "palette",
                "category": "light mode neutral"
            }
        },
        "name": "color.palette.Neutral600",
        "path": [
            "color",
            "palette",
            "Neutral600"
        ]
    },
    {
        "value": "#6B6E76",
        "attributes": {
            "group": "palette",
            "category": "light mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#6B6E76",
            "attributes": {
                "group": "palette",
                "category": "light mode neutral"
            }
        },
        "name": "color.palette.Neutral700",
        "path": [
            "color",
            "palette",
            "Neutral700"
        ]
    },
    {
        "value": "#505258",
        "attributes": {
            "group": "palette",
            "category": "light mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#505258",
            "attributes": {
                "group": "palette",
                "category": "light mode neutral"
            }
        },
        "name": "color.palette.Neutral800",
        "path": [
            "color",
            "palette",
            "Neutral800"
        ]
    },
    {
        "value": "#3B3D42",
        "attributes": {
            "group": "palette",
            "category": "light mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#3B3D42",
            "attributes": {
                "group": "palette",
                "category": "light mode neutral"
            }
        },
        "name": "color.palette.Neutral900",
        "path": [
            "color",
            "palette",
            "Neutral900"
        ]
    },
    {
        "value": "#292A2E",
        "attributes": {
            "group": "palette",
            "category": "light mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#292A2E",
            "attributes": {
                "group": "palette",
                "category": "light mode neutral"
            }
        },
        "name": "color.palette.Neutral1000",
        "path": [
            "color",
            "palette",
            "Neutral1000"
        ]
    },
    {
        "value": "#1E1F21",
        "attributes": {
            "group": "palette",
            "category": "light mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#1E1F21",
            "attributes": {
                "group": "palette",
                "category": "light mode neutral"
            }
        },
        "name": "color.palette.Neutral1100",
        "path": [
            "color",
            "palette",
            "Neutral1100"
        ]
    },
    {
        "value": "#000000",
        "attributes": {
            "group": "palette",
            "category": "light mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#000000",
            "attributes": {
                "group": "palette",
                "category": "light mode neutral"
            }
        },
        "name": "color.palette.Neutral1200",
        "path": [
            "color",
            "palette",
            "Neutral1200"
        ]
    },
    {
        "value": "#17171708",
        "attributes": {
            "group": "palette",
            "category": "light mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#17171708",
            "attributes": {
                "group": "palette",
                "category": "light mode neutral"
            }
        },
        "name": "color.palette.Neutral100A",
        "path": [
            "color",
            "palette",
            "Neutral100A"
        ]
    },
    {
        "value": "#0515240F",
        "attributes": {
            "group": "palette",
            "category": "light mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#0515240F",
            "attributes": {
                "group": "palette",
                "category": "light mode neutral"
            }
        },
        "name": "color.palette.Neutral200A",
        "path": [
            "color",
            "palette",
            "Neutral200A"
        ]
    },
    {
        "value": "#0B120E24",
        "attributes": {
            "group": "palette",
            "category": "light mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#0B120E24",
            "attributes": {
                "group": "palette",
                "category": "light mode neutral"
            }
        },
        "name": "color.palette.Neutral300A",
        "path": [
            "color",
            "palette",
            "Neutral300A"
        ]
    },
    {
        "value": "#080F214A",
        "attributes": {
            "group": "palette",
            "category": "light mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#080F214A",
            "attributes": {
                "group": "palette",
                "category": "light mode neutral"
            }
        },
        "name": "color.palette.Neutral400A",
        "path": [
            "color",
            "palette",
            "Neutral400A"
        ]
    },
    {
        "value": "#050C1F75",
        "attributes": {
            "group": "palette",
            "category": "light mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#050C1F75",
            "attributes": {
                "group": "palette",
                "category": "light mode neutral"
            }
        },
        "name": "color.palette.Neutral500A",
        "path": [
            "color",
            "palette",
            "Neutral500A"
        ]
    },
    {
        "value": "#111213",
        "attributes": {
            "group": "palette",
            "category": "dark mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#111213",
            "attributes": {
                "group": "palette",
                "category": "dark mode neutral"
            }
        },
        "name": "color.palette.DarkNeutral-100",
        "path": [
            "color",
            "palette",
            "DarkNeutral-100"
        ]
    },
    {
        "value": "#18191A",
        "attributes": {
            "group": "palette",
            "category": "dark mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#18191A",
            "attributes": {
                "group": "palette",
                "category": "dark mode neutral"
            }
        },
        "name": "color.palette.DarkNeutral0",
        "path": [
            "color",
            "palette",
            "DarkNeutral0"
        ]
    },
    {
        "value": "#1F1F21",
        "attributes": {
            "group": "palette",
            "category": "dark mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#1F1F21",
            "attributes": {
                "group": "palette",
                "category": "dark mode neutral"
            }
        },
        "name": "color.palette.DarkNeutral100",
        "path": [
            "color",
            "palette",
            "DarkNeutral100"
        ]
    },
    {
        "value": "#242528",
        "attributes": {
            "group": "palette",
            "category": "dark mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#242528",
            "attributes": {
                "group": "palette",
                "category": "dark mode neutral"
            }
        },
        "name": "color.palette.DarkNeutral200",
        "path": [
            "color",
            "palette",
            "DarkNeutral200"
        ]
    },
    {
        "value": "#2B2C2F",
        "attributes": {
            "group": "palette",
            "category": "dark mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#2B2C2F",
            "attributes": {
                "group": "palette",
                "category": "dark mode neutral"
            }
        },
        "name": "color.palette.DarkNeutral250",
        "path": [
            "color",
            "palette",
            "DarkNeutral250"
        ]
    },
    {
        "value": "#303134",
        "attributes": {
            "group": "palette",
            "category": "dark mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#303134",
            "attributes": {
                "group": "palette",
                "category": "dark mode neutral"
            }
        },
        "name": "color.palette.DarkNeutral300",
        "path": [
            "color",
            "palette",
            "DarkNeutral300"
        ]
    },
    {
        "value": "#3D3F43",
        "attributes": {
            "group": "palette",
            "category": "dark mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#3D3F43",
            "attributes": {
                "group": "palette",
                "category": "dark mode neutral"
            }
        },
        "name": "color.palette.DarkNeutral350",
        "path": [
            "color",
            "palette",
            "DarkNeutral350"
        ]
    },
    {
        "value": "#4B4D51",
        "attributes": {
            "group": "palette",
            "category": "dark mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#4B4D51",
            "attributes": {
                "group": "palette",
                "category": "dark mode neutral"
            }
        },
        "name": "color.palette.DarkNeutral400",
        "path": [
            "color",
            "palette",
            "DarkNeutral400"
        ]
    },
    {
        "value": "#63666B",
        "attributes": {
            "group": "palette",
            "category": "dark mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#63666B",
            "attributes": {
                "group": "palette",
                "category": "dark mode neutral"
            }
        },
        "name": "color.palette.DarkNeutral500",
        "path": [
            "color",
            "palette",
            "DarkNeutral500"
        ]
    },
    {
        "value": "#7E8188",
        "attributes": {
            "group": "palette",
            "category": "dark mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#7E8188",
            "attributes": {
                "group": "palette",
                "category": "dark mode neutral"
            }
        },
        "name": "color.palette.DarkNeutral600",
        "path": [
            "color",
            "palette",
            "DarkNeutral600"
        ]
    },
    {
        "value": "#96999E",
        "attributes": {
            "group": "palette",
            "category": "dark mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#96999E",
            "attributes": {
                "group": "palette",
                "category": "dark mode neutral"
            }
        },
        "name": "color.palette.DarkNeutral700",
        "path": [
            "color",
            "palette",
            "DarkNeutral700"
        ]
    },
    {
        "value": "#A9ABAF",
        "attributes": {
            "group": "palette",
            "category": "dark mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#A9ABAF",
            "attributes": {
                "group": "palette",
                "category": "dark mode neutral"
            }
        },
        "name": "color.palette.DarkNeutral800",
        "path": [
            "color",
            "palette",
            "DarkNeutral800"
        ]
    },
    {
        "value": "#BFC1C4",
        "attributes": {
            "group": "palette",
            "category": "dark mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#BFC1C4",
            "attributes": {
                "group": "palette",
                "category": "dark mode neutral"
            }
        },
        "name": "color.palette.DarkNeutral900",
        "path": [
            "color",
            "palette",
            "DarkNeutral900"
        ]
    },
    {
        "value": "#CECFD2",
        "attributes": {
            "group": "palette",
            "category": "dark mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#CECFD2",
            "attributes": {
                "group": "palette",
                "category": "dark mode neutral"
            }
        },
        "name": "color.palette.DarkNeutral1000",
        "path": [
            "color",
            "palette",
            "DarkNeutral1000"
        ]
    },
    {
        "value": "#E2E3E4",
        "attributes": {
            "group": "palette",
            "category": "dark mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#E2E3E4",
            "attributes": {
                "group": "palette",
                "category": "dark mode neutral"
            }
        },
        "name": "color.palette.DarkNeutral1100",
        "path": [
            "color",
            "palette",
            "DarkNeutral1100"
        ]
    },
    {
        "value": "#FFFFFF",
        "attributes": {
            "group": "palette",
            "category": "dark mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#FFFFFF",
            "attributes": {
                "group": "palette",
                "category": "dark mode neutral"
            }
        },
        "name": "color.palette.DarkNeutral1200",
        "path": [
            "color",
            "palette",
            "DarkNeutral1200"
        ]
    },
    {
        "value": "#01040475",
        "attributes": {
            "group": "palette",
            "category": "dark mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#01040475",
            "attributes": {
                "group": "palette",
                "category": "dark mode neutral"
            }
        },
        "name": "color.palette.DarkNeutral-100A",
        "path": [
            "color",
            "palette",
            "DarkNeutral-100A"
        ]
    },
    {
        "value": "#BDBDBD0A",
        "attributes": {
            "group": "palette",
            "category": "dark mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#BDBDBD0A",
            "attributes": {
                "group": "palette",
                "category": "dark mode neutral"
            }
        },
        "name": "color.palette.DarkNeutral100A",
        "path": [
            "color",
            "palette",
            "DarkNeutral100A"
        ]
    },
    {
        "value": "#CECED912",
        "attributes": {
            "group": "palette",
            "category": "dark mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#CECED912",
            "attributes": {
                "group": "palette",
                "category": "dark mode neutral"
            }
        },
        "name": "color.palette.DarkNeutral200A",
        "path": [
            "color",
            "palette",
            "DarkNeutral200A"
        ]
    },
    {
        "value": "#D9DAE71A",
        "attributes": {
            "group": "palette",
            "category": "dark mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#D9DAE71A",
            "attributes": {
                "group": "palette",
                "category": "dark mode neutral"
            }
        },
        "name": "color.palette.DarkNeutral250A",
        "path": [
            "color",
            "palette",
            "DarkNeutral250A"
        ]
    },
    {
        "value": "#E3E4F21F",
        "attributes": {
            "group": "palette",
            "category": "dark mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#E3E4F21F",
            "attributes": {
                "group": "palette",
                "category": "dark mode neutral"
            }
        },
        "name": "color.palette.DarkNeutral300A",
        "path": [
            "color",
            "palette",
            "DarkNeutral300A"
        ]
    },
    {
        "value": "#E8EDFD2E",
        "attributes": {
            "group": "palette",
            "category": "dark mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#E8EDFD2E",
            "attributes": {
                "group": "palette",
                "category": "dark mode neutral"
            }
        },
        "name": "color.palette.DarkNeutral350A",
        "path": [
            "color",
            "palette",
            "DarkNeutral350A"
        ]
    },
    {
        "value": "#E5E9F640",
        "attributes": {
            "group": "palette",
            "category": "dark mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#E5E9F640",
            "attributes": {
                "group": "palette",
                "category": "dark mode neutral"
            }
        },
        "name": "color.palette.DarkNeutral400A",
        "path": [
            "color",
            "palette",
            "DarkNeutral400A"
        ]
    },
    {
        "value": "#E9F0FB5C",
        "attributes": {
            "group": "palette",
            "category": "dark mode neutral"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": "#E9F0FB5C",
            "attributes": {
                "group": "palette",
                "category": "dark mode neutral"
            }
        },
        "name": "color.palette.DarkNeutral500A",
        "path": [
            "color",
            "palette",
            "DarkNeutral500A"
        ]
    },
    {
        "value": 0.2,
        "attributes": {
            "group": "palette",
            "category": "opacity"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": 0.2,
            "attributes": {
                "group": "palette",
                "category": "opacity"
            }
        },
        "name": "value.opacity.Opacity20",
        "path": [
            "value",
            "opacity",
            "Opacity20"
        ]
    },
    {
        "value": 0.4,
        "attributes": {
            "group": "palette",
            "category": "opacity"
        },
        "filePath": "schema/palettes/palette.tsx",
        "isSource": true,
        "original": {
            "value": 0.4,
            "attributes": {
                "group": "palette",
                "category": "opacity"
            }
        },
        "name": "value.opacity.Opacity40",
        "path": [
            "value",
            "opacity",
            "Opacity40"
        ]
    }
];
var $ad786f73b03d4c02$export$2e2bcd8739ae039 = $ad786f73b03d4c02$var$tokens;

});

parcelRegister("ZnlFT", function(module, exports) {
$parcel$export(module.exports, "getSelectedRowAndColumn", () => $d02774efc86745d8$export$17092ffd56d3b3b2);
function $d02774efc86745d8$export$17092ffd56d3b3b2(colorsPerRow, selectedColor) {
    let selectedRowIndex = -1;
    let selectedColumnIndex = -1;
    colorsPerRow.forEach((row, rowIndex)=>{
        row.forEach(({ value: value }, columnIndex)=>{
            if (value === selectedColor) {
                selectedRowIndex = rowIndex;
                selectedColumnIndex = columnIndex;
            }
        });
    });
    return {
        selectedRowIndex: selectedRowIndex,
        selectedColumnIndex: selectedColumnIndex
    };
}

});




parcelRegister("c9IsT", function(module, exports) {
$parcel$export(module.exports, "conditionalHooksFactory", () => $c4c5d2d4c3687fd3$export$691e93bad45e6f07);

var $dViOv = parcelRequire("dViOv");
function $c4c5d2d4c3687fd3$export$691e93bad45e6f07(condition, newHook, oldHook) {
    const hookFn = (...args)=>{
        // call each time so we can track exposures
        const conditionResult = condition();
        const cache = globalThis[0, $dViOv.CACHE_MAP_KEY];
        if (!cache.has(hookFn)) cache.set(hookFn, conditionResult);
        if (cache.get(hookFn)) return newHook(...args);
        else return oldHook(...args);
    };
    return hookFn;
}

});
parcelRegister("dViOv", function(module, exports) {
$parcel$export(module.exports, "CACHE_MAP_KEY", () => $9f63f497d82ceaa9$export$3c82709bf1b7e3a);
const $9f63f497d82ceaa9$export$3c82709bf1b7e3a = '__conditionalHooksFactory_conditionCacheMap_dont_modify_this_manually_unless_you_want_react_to_blow_up';
globalThis[$9f63f497d82ceaa9$export$3c82709bf1b7e3a] = globalThis[$9f63f497d82ceaa9$export$3c82709bf1b7e3a] || new WeakMap();

});


parcelRegister("bnf0l", function(module, exports) {
$parcel$export(module.exports, "TOOLBAR_ACTION_SUBJECT_ID", () => $6b7df7ad70bbcda0$export$f90c25d407b3694a);
var $6b7df7ad70bbcda0$export$f90c25d407b3694a = /*#__PURE__*/ function(TOOLBAR_ACTION_SUBJECT_ID) {
    TOOLBAR_ACTION_SUBJECT_ID["FIND_REPLACE"] = "findReplace";
    TOOLBAR_ACTION_SUBJECT_ID["EMOJI"] = "emoji";
    TOOLBAR_ACTION_SUBJECT_ID["ORDERED_LIST"] = "orderedList";
    TOOLBAR_ACTION_SUBJECT_ID["BULLET_LIST"] = "bulletList";
    TOOLBAR_ACTION_SUBJECT_ID["MEDIA"] = "media";
    TOOLBAR_ACTION_SUBJECT_ID["MENTION"] = "mention";
    TOOLBAR_ACTION_SUBJECT_ID["DECISION_LIST"] = "decisionList";
    TOOLBAR_ACTION_SUBJECT_ID["TASK_LIST"] = "taskList";
    TOOLBAR_ACTION_SUBJECT_ID["TEXT_COLOR"] = "color";
    TOOLBAR_ACTION_SUBJECT_ID["BACKGROUND_COLOR"] = "backgroundColor";
    TOOLBAR_ACTION_SUBJECT_ID["TEXT_FORMATTING_STRONG"] = "strong";
    TOOLBAR_ACTION_SUBJECT_ID["TEXT_FORMATTING_ITALIC"] = "italic";
    TOOLBAR_ACTION_SUBJECT_ID["TEXT_FORMATTING_UNDERLINE"] = "underline";
    TOOLBAR_ACTION_SUBJECT_ID["UNDO"] = "undo";
    TOOLBAR_ACTION_SUBJECT_ID["REDO"] = "redo";
    TOOLBAR_ACTION_SUBJECT_ID["INDENT"] = "indent";
    TOOLBAR_ACTION_SUBJECT_ID["OUTDENT"] = "outdent";
    TOOLBAR_ACTION_SUBJECT_ID["RECORD_VIDEO"] = "recordVideo";
    TOOLBAR_ACTION_SUBJECT_ID["AI"] = "atlassian-intelligence";
    return TOOLBAR_ACTION_SUBJECT_ID;
}({});

});

parcelRegister("fKhmN", function(module, exports) {
$parcel$export(module.exports, "gridPlugin", () => $e88a199727284fdf$export$c090e341e8f725a9);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $2YfQG = parcelRequire("2YfQG");

var $7lseo = parcelRequire("7lseo");

var $f7Kk4 = parcelRequire("f7Kk4");

var $5beht = parcelRequire("5beht");

var $cw0wu = parcelRequire("cw0wu");

var $5bbjm = parcelRequire("5bbjm");
const $e88a199727284fdf$export$bc90872e265d166e = 12;
// Matches the existing `.gridParent` 12px left + 12px right gutter expansion.
const $e88a199727284fdf$var$GRID_GUTTER_WIDTH = 24;
const $e88a199727284fdf$var$key = new (0, $cw0wu.PluginKey)('gridPlugin');
const $e88a199727284fdf$var$createDisplayGrid = (view)=>(props)=>{
        const { dispatch: dispatch, state: state } = view;
        const tr = state.tr.setMeta($e88a199727284fdf$var$key, props);
        dispatch(tr);
        return true;
    };
const $e88a199727284fdf$var$sides = [
    'left',
    'right'
];
const $e88a199727284fdf$var$overflowHighlight = (highlights, side, start, size)=>{
    if (!highlights.length) return false;
    const numericHighlights = highlights.filter((highlight)=>typeof highlight === 'number');
    const minHighlight = Math.min(...numericHighlights);
    const maxHighlight = Math.max(...numericHighlights);
    if (side === 'left') return minHighlight < 0 && minHighlight <= -start && (typeof size === 'number' ? minHighlight >= -(start + size) : true);
    else return maxHighlight > $e88a199727284fdf$export$bc90872e265d166e && maxHighlight >= $e88a199727284fdf$export$bc90872e265d166e + start && (typeof size === 'number' ? maxHighlight <= $e88a199727284fdf$export$bc90872e265d166e + size : true);
};
const $e88a199727284fdf$var$gutterGridLines = (editorMaxWidth, editorWidth, highlights, shouldCalcBreakoutGridLines)=>{
    const gridLines = [];
    if (!shouldCalcBreakoutGridLines) return gridLines;
    const wideSpacing = (editorMaxWidth * (0, $5bbjm.breakoutWideScaleRatio) - editorMaxWidth) / 2;
    $e88a199727284fdf$var$sides.forEach((side)=>{
        gridLines.push(/*#__PURE__*/ (0, $dc70d.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, (/*@__PURE__*/$parcel$interopDefault($2YfQG)))('gridLine', $e88a199727284fdf$var$overflowHighlight(highlights, side, 0, 4) ? 'highlight' : ''),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                position: 'absolute',
                [side]: `-${wideSpacing}px`
            }
        }, side));
        gridLines.push(/*#__PURE__*/ (0, $dc70d.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, (/*@__PURE__*/$parcel$interopDefault($2YfQG)))('gridLine', highlights.indexOf('full-width') > -1 ? 'highlight' : ''),
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                position: 'absolute',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                [side]: `-${(editorWidth - editorMaxWidth - (0, $5bbjm.akEditorBreakoutPadding)) / 2}px`
            }
        }, side + '-bk'));
    });
    return gridLines;
};
const $e88a199727284fdf$var$lineLengthGridLines = (highlights)=>{
    const gridLines = [];
    const gridSpacing = 100 / $e88a199727284fdf$export$bc90872e265d166e;
    for(let i = 0; i <= $e88a199727284fdf$export$bc90872e265d166e; i++){
        const style = {
            paddingLeft: `${gridSpacing}%`
        };
        gridLines.push(/*#__PURE__*/ (0, $dc70d.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, (/*@__PURE__*/$parcel$interopDefault($2YfQG)))('gridLine', highlights.indexOf(i) > -1 ? 'highlight' : ''),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: i < $e88a199727284fdf$export$bc90872e265d166e ? style : undefined
        }, i));
    }
    return gridLines;
};
const $e88a199727284fdf$var$GridNext = ({ highlight: highlight, shouldCalcBreakoutGridLines: shouldCalcBreakoutGridLines, containerElement: containerElement, editorWidth: editorWidth, gridType: gridType, overlayWidth: overlayWidth, visible: visible })=>{
    const editorMaxWidth = (0, $5bbjm.akEditorDefaultLayoutWidth);
    const gridLines = [
        ...$e88a199727284fdf$var$lineLengthGridLines(highlight),
        ...$e88a199727284fdf$var$gutterGridLines(editorMaxWidth, editorWidth, highlight, shouldCalcBreakoutGridLines)
    ];
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        className: "gridParent",
        children: /*#__PURE__*/ (0, $dc70d.jsx)("div", {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: (0, (/*@__PURE__*/$parcel$interopDefault($2YfQG)))('gridContainer', gridType),
            style: {
                height: `${containerElement.scrollHeight}px`,
                display: visible ? 'block' : 'none',
                width: `${overlayWidth}px`
            },
            "data-testid": "gridContainer",
            children: gridLines
        })
    }));
};
const $e88a199727284fdf$var$selector = (states)=>{
    var _states$widthState, _states$widthState2, _states$gridState, _states$gridState2, _states$gridState3;
    return {
        lineLength: (_states$widthState = states.widthState) === null || _states$widthState === void 0 ? void 0 : _states$widthState.lineLength,
        width: (_states$widthState2 = states.widthState) === null || _states$widthState2 === void 0 ? void 0 : _states$widthState2.width,
        visible: (_states$gridState = states.gridState) === null || _states$gridState === void 0 ? void 0 : _states$gridState.visible,
        gridType: (_states$gridState2 = states.gridState) === null || _states$gridState2 === void 0 ? void 0 : _states$gridState2.gridType,
        highlight: (_states$gridState3 = states.gridState) === null || _states$gridState3 === void 0 ? void 0 : _states$gridState3.highlight
    };
};
const $e88a199727284fdf$var$ContentComponent = ({ api: api, editorView: editorView, options: options })=>{
    const { lineLength: lineLength, width: width, visible: visible, gridType: gridType, highlight: highlight } = (0, $5beht.useSharedPluginStateWithSelector)(api, [
        'width',
        'grid'
    ], $e88a199727284fdf$var$selector);
    const overlayWidth = (lineLength || width || (0, $5bbjm.akEditorFullPageMaxWidth)) + $e88a199727284fdf$var$GRID_GUTTER_WIDTH;
    if (!visible || !highlight) return null;
    return /*#__PURE__*/ (0, $dc70d.jsx)($e88a199727284fdf$var$GridNext, {
        shouldCalcBreakoutGridLines: options && options.shouldCalcBreakoutGridLines,
        editorWidth: width ?? (0, $5bbjm.akEditorFullPageMaxWidth),
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        containerElement: editorView.dom,
        visible: visible,
        gridType: gridType ?? 'full',
        highlight: highlight,
        overlayWidth: overlayWidth
    });
};
const $e88a199727284fdf$var$EMPTY_STATE = {
    visible: false,
    highlight: []
};
const $e88a199727284fdf$var$gridPMPlugin = new (0, $f7Kk4.SafePlugin)({
    key: $e88a199727284fdf$var$key,
    state: {
        init () {
            return $e88a199727284fdf$var$EMPTY_STATE;
        },
        apply (tr, currentPluginState) {
            const nextPluginState = tr.getMeta($e88a199727284fdf$var$key);
            if (nextPluginState) return nextPluginState;
            return currentPluginState;
        }
    }
});
const $e88a199727284fdf$export$c090e341e8f725a9 = ({ config: options, api: api })=>{
    return {
        name: 'grid',
        getSharedState (editorState) {
            if (!editorState) return null;
            return $e88a199727284fdf$var$key.getState(editorState) || null;
        },
        actions: {
            displayGrid: $e88a199727284fdf$var$createDisplayGrid
        },
        pmPlugins () {
            return [
                {
                    name: 'grid',
                    plugin: ()=>$e88a199727284fdf$var$gridPMPlugin
                }
            ];
        },
        contentComponent: ({ editorView: editorView })=>{
            if (!editorView || (0, $7lseo.isSSR)()) return null;
            return /*#__PURE__*/ (0, $dc70d.jsx)($e88a199727284fdf$var$ContentComponent, {
                editorView: editorView,
                options: options,
                api: api
            });
        }
    };
};

});

parcelRegister("f0BVc", function(module, exports) {
$parcel$export(module.exports, "guidelinePlugin", () => $c63ee7182083ecfa$export$63925ade01f824c4);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9dQre = parcelRequire("9dQre");

var $f7Kk4 = parcelRequire("f7Kk4");

var $5beht = parcelRequire("5beht");

var $cw0wu = parcelRequire("cw0wu");

var $5bbjm = parcelRequire("5bbjm");

var $69Q4m = parcelRequire("69Q4m");
const $c63ee7182083ecfa$var$guidelineStyles = /*#__PURE__*/ (0, $9dQre.css)({
    position: 'absolute',
    width: '100%',
    left: 0,
    right: 0,
    transform: `scale(1)`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    zIndex: `${(0, $5bbjm.akEditorGridLineZIndex)};`,
    display: 'flex',
    justifyContent: 'center'
});
const $c63ee7182083ecfa$var$key = new (0, $cw0wu.PluginKey)('guidelinePlugin');
const $c63ee7182083ecfa$var$displayGuideline = (view)=>(props)=>{
        const { dispatch: dispatch, state: state } = view;
        const tr = state.tr.setMeta($c63ee7182083ecfa$var$key, props);
        dispatch(tr);
        return true;
    };
const $c63ee7182083ecfa$export$f040258c471d4154 = {
    guidelines: []
};
const $c63ee7182083ecfa$var$guidelinePMPlugin = new (0, $f7Kk4.SafePlugin)({
    key: $c63ee7182083ecfa$var$key,
    state: {
        init () {
            return $c63ee7182083ecfa$export$f040258c471d4154;
        },
        apply (tr, currentPluginState) {
            const nextPluginState = tr.getMeta($c63ee7182083ecfa$var$key);
            if (nextPluginState) return {
                ...currentPluginState,
                ...nextPluginState
            };
            return currentPluginState;
        }
    }
});
const $c63ee7182083ecfa$var$selector = (states)=>{
    var _states$widthState, _states$widthState2, _states$guidelineStat, _states$guidelineStat2;
    return {
        width: (_states$widthState = states.widthState) === null || _states$widthState === void 0 ? void 0 : _states$widthState.width,
        lineLength: (_states$widthState2 = states.widthState) === null || _states$widthState2 === void 0 ? void 0 : _states$widthState2.lineLength,
        guidelines: (_states$guidelineStat = states.guidelineState) === null || _states$guidelineStat === void 0 ? void 0 : _states$guidelineStat.guidelines,
        rect: (_states$guidelineStat2 = states.guidelineState) === null || _states$guidelineStat2 === void 0 ? void 0 : _states$guidelineStat2.rect
    };
};
const $c63ee7182083ecfa$var$ContentComponent = ({ api: api, editorView: editorView, options: options })=>{
    const { width: width, lineLength: lineLength, guidelines: guidelines, rect: rect } = (0, $5beht.useSharedPluginStateWithSelector)(api, [
        'width',
        'guideline'
    ], $c63ee7182083ecfa$var$selector);
    if (!width || !lineLength || !guidelines || guidelines.length === 0) return null;
    const updateRect = ({ top: top, left: left })=>{
        const { dispatch: dispatch, state: state } = editorView;
        const { top: prevTop, left: prevLeft } = rect || {};
        if (prevTop !== top || prevLeft !== left) {
            const tr = state.tr.setMeta($c63ee7182083ecfa$var$key, {
                rect: {
                    top: top,
                    left: left
                }
            });
            dispatch(tr);
            return true;
        }
    };
    return /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        css: $c63ee7182083ecfa$var$guidelineStyles
    }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $69Q4m.GuidelineContainer), {
        guidelines: guidelines,
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        height: editorView.dom.scrollHeight,
        width: width,
        editorWidth: lineLength,
        updateRect: updateRect
    }));
};
const $c63ee7182083ecfa$export$63925ade01f824c4 = ({ config: options, api: api })=>({
        name: 'guideline',
        getSharedState (editorState) {
            if (!editorState) return null;
            return $c63ee7182083ecfa$var$key.getState(editorState) || null;
        },
        actions: {
            displayGuideline: $c63ee7182083ecfa$var$displayGuideline
        },
        pmPlugins () {
            return [
                {
                    name: 'guideline',
                    plugin: ()=>$c63ee7182083ecfa$var$guidelinePMPlugin
                }
            ];
        },
        contentComponent: ({ editorView: editorView })=>{
            if (!editorView) return null;
            return /*#__PURE__*/ (0, $9dQre.jsx)($c63ee7182083ecfa$var$ContentComponent, {
                editorView: editorView,
                options: options,
                api: api
            });
        }
    });

});
parcelRegister("69Q4m", function(module, exports) {
$parcel$export(module.exports, "GuidelineContainer", () => $a3daedaba66561a3$export$e0b9e5fb6186afa);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $5bbjm = parcelRequire("5bbjm");

var $gAWRo = parcelRequire("gAWRo");

var $alz09 = parcelRequire("alz09");
const $a3daedaba66561a3$var$guidelineContainerStyles = /*#__PURE__*/ (0, $9dQre.css)({
    position: 'fixed',
    height: '100vh',
    width: '100%',
    display: 'grid',
    pointerEvents: 'none',
    border: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: `${(0, $5bbjm.akEditorFullWidthLayoutWidth)}px`
});
const $a3daedaba66561a3$export$e0b9e5fb6186afa = (props)=>{
    const { guidelines: guidelines, height: height, updateRect: updateRect } = props;
    const [offset, setOffset] = (0, $bSJIT.useState)(0);
    const ref = (0, $bSJIT.useRef)(null);
    (0, $bSJIT.useLayoutEffect)(()=>{
        var _ref$current;
        const rect = ref === null || ref === void 0 || (_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.getBoundingClientRect();
        if (rect) {
            const centerOffset = rect.width / 2 - 0.5;
            // X pixels from guideline container left to editor center.
            if (offset !== centerOffset) setOffset(centerOffset);
            updateRect({
                top: rect.top,
                left: rect.left
            });
        }
    }, [
        updateRect,
        offset
    ]);
    const style = {
        [(0, $gAWRo.VAR_POSITION_OFFSET_X)]: `${offset}px`,
        [(0, $gAWRo.VAR_POSITION_OFFSET_Y)]: `0px`,
        height: height
    };
    return /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        ref: ref,
        css: $a3daedaba66561a3$var$guidelineContainerStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        "data-testid": "guidelineContainer"
    }, guidelines.map((guideline)=>{
        const { key: key, ...guidelineProps } = guideline;
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        return /*#__PURE__*/ (0, $9dQre.jsx)((0, $alz09.Guideline), {
            key: key,
            ...guidelineProps
        });
    }));
};

});
parcelRegister("gAWRo", function(module, exports) {
$parcel$export(module.exports, "VAR_POSITION_OFFSET_X", () => $6be1f823851675cd$export$a18117c61b4f3090);
$parcel$export(module.exports, "VAR_POSITION_OFFSET_Y", () => $6be1f823851675cd$export$343adffee41775d9);
const $6be1f823851675cd$export$a18117c61b4f3090 = '--guideline-offset-x';
const $6be1f823851675cd$export$343adffee41775d9 = '--guideline-offset-y';

});

parcelRegister("alz09", function(module, exports) {
$parcel$export(module.exports, "Guideline", () => $340779a1c77f1501$export$1f92f20006072ef);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled, @typescript-eslint/consistent-type-imports

var $9dQre = parcelRequire("9dQre");

var $6RJYH = parcelRequire("6RJYH");

var $eQlib = parcelRequire("eQlib");
function $340779a1c77f1501$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $340779a1c77f1501$var$basicGuidelineStyles = /*#__PURE__*/ (0, $9dQre.css)({
    position: 'absolute',
    zIndex: 0,
    opacity: 1,
    transition: 'border-color 0.15s linear, opacity 0.15s linear',
    borderColor: `${"var(--ds-border-disabled, #0515240F)"}`,
    borderStyle: 'solid'
});
const $340779a1c77f1501$var$verticalStyles = /*#__PURE__*/ (0, $9dQre.css)({
    borderWidth: `0 0 0 ${"var(--ds-border-width, 1px)"}`,
    width: '1px',
    height: '100%'
});
const $340779a1c77f1501$var$horizontalStyles = /*#__PURE__*/ (0, $9dQre.css)({
    borderWidth: `${"var(--ds-border-width, 1px)"} 0 0 0`,
    width: '100%',
    height: '1px'
});
const $340779a1c77f1501$var$activeGuidelineStyles = {
    name: "uh8fzh",
    styles: "border-color:var(--ds-border-focused, #4688EC);&:before, &:after{background-color:var(--ds-border-focused, #4688EC);}"
};
const $340779a1c77f1501$var$hiddenGuidelineStyles = {
    name: "mws4fn",
    styles: "opacity:0"
};
const $340779a1c77f1501$var$dashedGuidelineStyles = {
    name: "10ikx64",
    styles: "border-style:dashed"
};
const $340779a1c77f1501$var$verticalCapStyles = {
    name: "4o8hyx",
    styles: "&:before, &:after{background-color:var(--ds-border-disabled, #0515240F);content:\"\";position:absolute;height:5px;width:1px;transform:translateY(-50%);}&:after{right:0;}"
};
const $340779a1c77f1501$var$horizontalCapStyles = /*#__PURE__*/ (0, $9dQre.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:before, &:after': {
        backgroundColor: `${"var(--ds-border-disabled, #0515240F)"}`,
        content: '""',
        position: 'absolute',
        height: '1px',
        width: '5px',
        transform: 'translateX(-50%)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:after': {
        bottom: 0
    }
});
const $340779a1c77f1501$export$1f92f20006072ef = (props)=>{
    const { position: position, active: active, show: show = true, styles: styles = {} } = props;
    const isVerticalPos = (0, $6RJYH.isVerticalPosition)(position);
    const { lineStyle: lineStyle, color: color, capStyle: capStyle } = styles;
    return /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        css: [
            $340779a1c77f1501$var$basicGuidelineStyles,
            isVerticalPos ? $340779a1c77f1501$var$verticalStyles : $340779a1c77f1501$var$horizontalStyles,
            capStyle === 'line' && (isVerticalPos ? $340779a1c77f1501$var$horizontalCapStyles : $340779a1c77f1501$var$verticalCapStyles),
            active && $340779a1c77f1501$var$activeGuidelineStyles,
            !show && $340779a1c77f1501$var$hiddenGuidelineStyles,
            lineStyle === 'dashed' && $340779a1c77f1501$var$dashedGuidelineStyles
        ],
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            ...color && {
                borderColor: `${color}`
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            ...(0, $eQlib.getPositionStyles)(position)
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "guideline"
    });
};

});
parcelRegister("6RJYH", function(module, exports) {
$parcel$export(module.exports, "isVerticalPosition", () => $6698f1796af84a96$export$75d81fc396e386db);

var $aLMs7 = parcelRequire("aLMs7");




const $6698f1796af84a96$export$75d81fc396e386db = (pos)=>(0, $aLMs7.isNumber)(pos.x);

});
parcelRegister("aLMs7", function(module, exports) {
$parcel$export(module.exports, "isNumber", () => $fc7dd67cb43e598c$export$7e4aa119212bc614);
const $fc7dd67cb43e598c$export$7e4aa119212bc614 = (x)=>typeof x === 'number' && !isNaN(x) && isFinite(x);

});


parcelRegister("eQlib", function(module, exports) {
$parcel$export(module.exports, "getPositionStyles", () => $1bdc35e9b6af80d2$export$a5b21f38d58b1de0);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage/preview */ 
var $6RJYH = parcelRequire("6RJYH");

var $gAWRo = parcelRequire("gAWRo");
const $1bdc35e9b6af80d2$export$7e4aa119212bc614 = (x)=>typeof x === 'number' && !isNaN(x) && isFinite(x);
const $1bdc35e9b6af80d2$var$getXPosition = (pixel)=>$1bdc35e9b6af80d2$export$7e4aa119212bc614(pixel) ? `calc(${pixel}px + var(${0, $gAWRo.VAR_POSITION_OFFSET_X}, '0px'))` : 'unset';
const $1bdc35e9b6af80d2$var$getYPosition = (pixel)=>$1bdc35e9b6af80d2$export$7e4aa119212bc614(pixel) ? `calc(${pixel}px + var(${0, $gAWRo.VAR_POSITION_OFFSET_Y}, '0px'))` : 'unset';
const $1bdc35e9b6af80d2$export$a5b21f38d58b1de0 = (pos)=>{
    var _pos$y, _pos$x;
    return (0, $6RJYH.isVerticalPosition)(pos) ? {
        left: $1bdc35e9b6af80d2$var$getXPosition(pos.x),
        top: $1bdc35e9b6af80d2$var$getYPosition((_pos$y = pos.y) === null || _pos$y === void 0 ? void 0 : _pos$y.start),
        height: pos.y ? `${pos.y.end - pos.y.start}px` : '100%'
    } : {
        top: $1bdc35e9b6af80d2$var$getYPosition(pos.y),
        left: $1bdc35e9b6af80d2$var$getXPosition((_pos$x = pos.x) === null || _pos$x === void 0 ? void 0 : _pos$x.start),
        width: pos.x ? `${pos.x.end - pos.x.start}px` : '100%'
    };
};

});




parcelRegister("aMbh4", function(module, exports) {
$parcel$export(module.exports, "isPastedFile", () => $54676bcbf028c4c7$export$30c8e5e50a78a591);

var $fq1Zd = parcelRequire("fq1Zd");
function $54676bcbf028c4c7$export$30c8e5e50a78a591(rawEvent) {
    const { clipboardData: clipboardData } = rawEvent;
    if (!clipboardData) return false;
    return (0, $fq1Zd.checkClipboardTypes)(clipboardData.types, 'Files');
}

});
parcelRegister("fq1Zd", function(module, exports) {
$parcel$export(module.exports, "checkClipboardTypes", () => $e1d3697bd443fa35$export$e20225b4cda674a8);
function $e1d3697bd443fa35$export$e20225b4cda674a8(type, item) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const isDOMStringList = (t)=>!t.indexOf && !!t.contains;
    return isDOMStringList(type) ? type.contains(item) : type.indexOf(item) > -1;
}

});


parcelRegister("9QU20", function(module, exports) {
$parcel$export(module.exports, "indentationPlugin", () => $3affe0c0a9a5deb2$export$171e576bb7c729fa);

var $lRfQ8 = parcelRequire("lRfQ8");

var $7aCjN = parcelRequire("7aCjN");

var $ee6YV = parcelRequire("ee6YV");

var $68biO = parcelRequire("68biO");
const $3affe0c0a9a5deb2$export$171e576bb7c729fa = ({ api: api })=>{
    var _api$analytics, _api$analytics2;
    return {
        name: 'indentation',
        marks () {
            return [
                {
                    name: 'indentation',
                    mark: (0, $lRfQ8.indentation)
                }
            ];
        },
        actions: {
            indentParagraphOrHeading: (0, $ee6YV.getIndentCommand)(api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions),
            outdentParagraphOrHeading: (0, $ee6YV.getOutdentCommand)(api === null || api === void 0 || (_api$analytics2 = api.analytics) === null || _api$analytics2 === void 0 ? void 0 : _api$analytics2.actions)
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const { tr: { selection: selection }, schema: { marks: { indentation: indentation } } } = editorState;
            const node = selection.$from.node();
            const indentationMark = node.marks.find((mark)=>mark.type === indentation);
            return {
                isIndentationAllowed: (0, $ee6YV.isIndentationAllowed)(editorState.schema, node),
                // @ts-ignore - TS2869 TypeScript 5.9.2 upgrade
                indentDisabled: ((indentationMark === null || indentationMark === void 0 ? void 0 : indentationMark.attrs.level) >= (0, $7aCjN.MAX_INDENTATION_LEVEL)) ?? false,
                outdentDisabled: !indentationMark
            };
        },
        pmPlugins () {
            return [
                {
                    name: 'indentationKeymap',
                    plugin: ()=>{
                        var _api$analytics3;
                        return (0, $68biO.keymapPlugin)(api === null || api === void 0 || (_api$analytics3 = api.analytics) === null || _api$analytics3 === void 0 ? void 0 : _api$analytics3.actions);
                    }
                }
            ];
        }
    };
};

});
parcelRegister("7aCjN", function(module, exports) {
$parcel$export(module.exports, "MAX_INDENTATION_LEVEL", () => $6f4bf3bd09adbb4c$export$d5851c05c73d1974);
const $6f4bf3bd09adbb4c$export$d5851c05c73d1974 = 6;

});

parcelRegister("ee6YV", function(module, exports) {
$parcel$export(module.exports, "isIndentationAllowed", () => $d6fb7053ebe9105f$export$54db194d337db321);
$parcel$export(module.exports, "getIndentCommand", () => $d6fb7053ebe9105f$export$b294289254b8cdac);
$parcel$export(module.exports, "getOutdentCommand", () => $d6fb7053ebe9105f$export$620b2a1f10eb3a5f);

var $g6Qq4 = parcelRequire("g6Qq4");

var $31L32 = parcelRequire("31L32");

var $bq0hv = parcelRequire("bq0hv");

var $7aCjN = parcelRequire("7aCjN");

var $28h5H = parcelRequire("28h5H");

var $k8J7j = parcelRequire("k8J7j");
const $d6fb7053ebe9105f$export$54db194d337db321 = (schema, node)=>{
    const { nodes: { paragraph: paragraph, heading: heading }, marks: { alignment: alignment } } = schema;
    if ([
        paragraph,
        heading
    ].indexOf(node.type) > -1) {
        if (alignment) {
            const hasAlignment = node.marks.filter((mark)=>mark.type === alignment)[0];
            return !hasAlignment;
        }
        return true;
    }
    return false;
};
/**
 * Create new indentation command (Either indent or outdent depend of getArgsFn)
 * @param getNewIndentationAttrs Function to handle new indentation level
 */ function $d6fb7053ebe9105f$var$createIndentationCommand(getNewIndentationAttrs) {
    return (state, dispatch)=>{
        const { indentation: indentation } = state.schema.marks;
        return (0, $bq0hv.toggleBlockMark)(indentation, getNewIndentationAttrs, $d6fb7053ebe9105f$export$54db194d337db321)(state, dispatch);
    };
}
function $d6fb7053ebe9105f$var$createIndentationCommandWithAnalytics({ getNewIndentationAttrs: getNewIndentationAttrs, direction: direction, inputMethod: inputMethod, editorAnalyticsAPI: editorAnalyticsAPI }) {
    // Create a new getAttrs function to record the changes
    const { getAttrs: getAttrs, getAndResetAttrsChanges: getAndResetAttrsChanges } = (0, $28h5H.default)(getNewIndentationAttrs, {
        direction: direction
    });
    // Use new getAttrs wrapper
    const indentationCommand = $d6fb7053ebe9105f$var$createIndentationCommand(getAttrs);
    // Return a new command where we change dispatch for our analytics dispatch
    return (state, dispatch)=>{
        return indentationCommand(state, (0, $k8J7j.createAnalyticsDispatch)({
            getAttrsChanges: getAndResetAttrsChanges,
            inputMethod: inputMethod,
            editorAnalyticsAPI: editorAnalyticsAPI,
            state: state,
            dispatch: dispatch
        }));
    };
}
/**
 * Get new level for outdent
 * @param oldAttr Old attributes for the mark, undefined if the mark doesn't exit
 * @returns  - undefined; No change required
 *           - false; Remove the mark
 *           - object; Update attributes
 */ const $d6fb7053ebe9105f$var$getIndentAttrs = (oldAttr)=>{
    if (!oldAttr) return {
        level: 1
    }; // No mark exist, create a new one with level 1
    const { level: level } = oldAttr;
    if (level >= (0, $7aCjN.MAX_INDENTATION_LEVEL)) return undefined; // Max indentation level reached, do nothing.
    return {
        level: level + 1
    }; // Otherwise, increase the level by one
};
const $d6fb7053ebe9105f$export$b294289254b8cdac = (editorAnalyticsAPI)=>(inputMethod = (0, $g6Qq4.INPUT_METHOD).KEYBOARD)=>$d6fb7053ebe9105f$var$createIndentationCommandWithAnalytics({
            getNewIndentationAttrs: $d6fb7053ebe9105f$var$getIndentAttrs,
            direction: (0, $31L32.INDENT_DIRECTION).INDENT,
            inputMethod: inputMethod,
            editorAnalyticsAPI: editorAnalyticsAPI
        });
/**
 * Get new level for outdent
 * @param oldAttr Old attributes for the mark, undefined if the mark doesn't exit
 * @returns  - undefined; No change required
 *           - false; Remove the mark
 *           - object; Update attributes
 */ const $d6fb7053ebe9105f$var$getOutdentAttrs = (oldAttr)=>{
    if (!oldAttr) return undefined; // Do nothing;
    const { level: level } = oldAttr;
    if (level <= 1) return false; // Remove the mark
    return {
        level: level - 1
    }; // Decrease the level on other cases
};
const $d6fb7053ebe9105f$export$620b2a1f10eb3a5f = (editorAnalyticsAPI)=>(inputMethod = (0, $g6Qq4.INPUT_METHOD).KEYBOARD)=>$d6fb7053ebe9105f$var$createIndentationCommandWithAnalytics({
            getNewIndentationAttrs: $d6fb7053ebe9105f$var$getOutdentAttrs,
            direction: (0, $31L32.INDENT_DIRECTION).OUTDENT,
            inputMethod: inputMethod,
            editorAnalyticsAPI: editorAnalyticsAPI
        });
const $d6fb7053ebe9105f$export$33ad14ed4b6e7a8e = (state, dispatch)=>(0, $bq0hv.toggleBlockMark)(state.schema.marks.indentation, ()=>false)(state, dispatch);

});
parcelRegister("31L32", function(module, exports) {
$parcel$export(module.exports, "INDENT_DIRECTION", () => $4735b67111f88508$export$c8090e81b8640d69);
$parcel$export(module.exports, "INDENT_TYPE", () => $4735b67111f88508$export$303836d45647271d);
var $4735b67111f88508$export$c8090e81b8640d69 = /*#__PURE__*/ function(INDENT_DIRECTION) {
    INDENT_DIRECTION["INDENT"] = "indent";
    INDENT_DIRECTION["OUTDENT"] = "outdent";
    return INDENT_DIRECTION;
}({});
var $4735b67111f88508$export$303836d45647271d = /*#__PURE__*/ function(INDENT_TYPE) {
    INDENT_TYPE["PARAGRAPH"] = "paragraph";
    INDENT_TYPE["LIST"] = "list";
    INDENT_TYPE["HEADING"] = "heading";
    INDENT_TYPE["CODE_BLOCK"] = "codeBlock";
    INDENT_TYPE["TASK_LIST"] = "taskList";
    return INDENT_TYPE;
}({});

});

parcelRegister("28h5H", function(module, exports) {
$parcel$export(module.exports, "default", () => $86facc6f00f18558$export$2e2bcd8739ae039);
function $86facc6f00f18558$export$2e2bcd8739ae039(getAttrs, options) {
    let changes = [];
    function getAttrsWithChangesRecorder(prevAttrs, node) {
        const newAttrs = getAttrs(prevAttrs, node);
        changes.push({
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            node: node,
            prevAttrs: prevAttrs,
            newAttrs: newAttrs,
            options: options
        });
        return newAttrs;
    }
    return {
        getAttrs: getAttrsWithChangesRecorder,
        getAndResetAttrsChanges () {
            const oldChanges = changes;
            changes = [];
            return oldChanges;
        }
    };
}

});

parcelRegister("k8J7j", function(module, exports) {
$parcel$export(module.exports, "createAnalyticsDispatch", () => $282ac8cad8615c10$export$4f15b45384b61427);

var $g6Qq4 = parcelRequire("g6Qq4");

var $31L32 = parcelRequire("31L32");
const $282ac8cad8615c10$var$indentTypes = {
    paragraph: (0, $31L32.INDENT_TYPE).PARAGRAPH,
    heading: (0, $31L32.INDENT_TYPE).HEADING
};
function $282ac8cad8615c10$export$c67aac760a384f96(prevAttrs, newAttrs) {
    if (newAttrs === undefined) return $282ac8cad8615c10$export$697340b93338bcbd(prevAttrs);
    else if (newAttrs === false) return 0;
    return newAttrs.level;
}
function $282ac8cad8615c10$export$697340b93338bcbd(prevAttrs) {
    if (prevAttrs === undefined) return 0;
    return prevAttrs.level;
}
function $282ac8cad8615c10$export$4f15b45384b61427({ getAttrsChanges: getAttrsChanges, inputMethod: inputMethod, editorAnalyticsAPI: editorAnalyticsAPI, state: state, dispatch: dispatch }) {
    return (tr)=>{
        const currentTr = tr;
        const changes = getAttrsChanges(); // Get all attributes changes
        // Add analytics event for each change stored.
        changes.forEach(({ node: node, prevAttrs: prevAttrs, newAttrs: newAttrs, options: { direction: direction } })=>{
            const indentType = $282ac8cad8615c10$var$indentTypes[node.type.name];
            if (!indentType) return; // If no valid indent type continue
            editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent({
                action: (0, $g6Qq4.ACTION).FORMATTED,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).TEXT,
                actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).FORMAT_INDENT,
                eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
                attributes: {
                    inputMethod: inputMethod,
                    previousIndentationLevel: $282ac8cad8615c10$export$697340b93338bcbd(prevAttrs),
                    newIndentLevel: $282ac8cad8615c10$export$c67aac760a384f96(prevAttrs, newAttrs),
                    direction: direction,
                    indentType: indentType
                }
            })(currentTr);
        });
        // Dispatch analytics if exist
        if (dispatch) dispatch(tr);
    };
}

});


parcelRegister("68biO", function(module, exports) {
$parcel$export(module.exports, "keymapPlugin", () => $5d25b7f474b640fe$export$e832373cff8dec22);

var $g6Qq4 = parcelRequire("g6Qq4");

var $cv8id = parcelRequire("cv8id");

var $aTdXU = parcelRequire("aTdXU");

var $ejrfk = parcelRequire("ejrfk");

var $gab48 = parcelRequire("gab48");

var $ee6YV = parcelRequire("ee6YV");
function $5d25b7f474b640fe$export$e832373cff8dec22(editorAnalyticsAPI) {
    const list = {};
    (0, $cv8id.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $cv8id.findShortcutByKeymap)((0, $cv8id.indent)), (state, dispatch)=>{
        const { blockTaskItem: blockTaskItem, paragraph: paragraph, doc: doc } = state.schema.nodes;
        if (blockTaskItem) {
            let hasBlockTaskItem = false;
            let hasParagraphAtDocLevel = false;
            // Check if the selection contains a blockTaskItem
            state.doc.nodesBetween(state.selection.from, state.selection.to, (node, _pos, parent)=>{
                if (node.type === blockTaskItem) {
                    hasBlockTaskItem = true;
                    return false; // stop iterating
                }
                if (node.type === paragraph && (parent === null || parent === void 0 ? void 0 : parent.type) === doc) hasParagraphAtDocLevel = true;
            });
            if (hasBlockTaskItem && !hasParagraphAtDocLevel) return false; // let `editor-plugin-tasks-and-decisions` handle indentation
        }
        return (0, $ee6YV.getIndentCommand)(editorAnalyticsAPI)((0, $g6Qq4.INPUT_METHOD).KEYBOARD)(state, dispatch);
    }, list);
    (0, $cv8id.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $cv8id.findShortcutByKeymap)((0, $cv8id.outdent)), (0, $ee6YV.getOutdentCommand)(editorAnalyticsAPI)((0, $g6Qq4.INPUT_METHOD).KEYBOARD), list);
    (0, $cv8id.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $cv8id.findShortcutByKeymap)((0, $cv8id.backspace)), (state, dispatch)=>{
        const { selection: selection } = state;
        const { blockTaskItem: blockTaskItem } = state.schema.nodes;
        // Let `editor-plugin-tasks-and-decisions` handle indentation inside blockTaskItems
        if ((0, $aTdXU.isTextSelection)(selection) && selection.$cursor && selection.$cursor.parentOffset === 0 && !(0, $gab48.hasParentNodeOfType)([
            blockTaskItem
        ])(selection)) return dispatch ? (0, $ee6YV.getOutdentCommand)(editorAnalyticsAPI)((0, $g6Qq4.INPUT_METHOD).KEYBOARD)(state, dispatch) : false;
        return false;
    }, list);
    return (0, $ejrfk.keymap)(list);
}
var $5d25b7f474b640fe$export$2e2bcd8739ae039 = $5d25b7f474b640fe$export$e832373cff8dec22;

});


parcelRegister("b4WtV", function(module, exports) {
$parcel$export(module.exports, "insertBlockPlugin", () => $34325823df1bce51$export$b7df1817ade19df9);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $g6Qq4 = parcelRequire("g6Qq4");

var $hVGJk = parcelRequire("hVGJk");

var $disn5 = parcelRequire("disn5");

var $d0HRE = parcelRequire("d0HRE");

var $2pWL6 = parcelRequire("2pWL6");

var $5beht = parcelRequire("5beht");

var $97VXU = parcelRequire("97VXU");

var $2NuJy = parcelRequire("2NuJy");

var $SOqL6 = parcelRequire("SOqL6");

var $9sxpZ = parcelRequire("9sxpZ");

var $6r3dU = parcelRequire("6r3dU");
const $34325823df1bce51$export$7e87882fdef9bc6 = (toolbarSize, appearance)=>{
    // Different button numbers for full-page to better match full page toolbar breakpoints
    if (appearance === 'full-page') switch(toolbarSize){
        case (0, $d0HRE.ToolbarSize).XXL:
        case (0, $d0HRE.ToolbarSize).XL:
        case (0, $d0HRE.ToolbarSize).L:
            return 7;
        case (0, $d0HRE.ToolbarSize).M:
            return 3;
        default:
            return 0;
    }
    switch(toolbarSize){
        case (0, $d0HRE.ToolbarSize).XXL:
        case (0, $d0HRE.ToolbarSize).XL:
            return 7;
        case (0, $d0HRE.ToolbarSize).L:
            return 5;
        case (0, $d0HRE.ToolbarSize).M:
        case (0, $d0HRE.ToolbarSize).S:
            return 2;
        default:
            return 0;
    }
};
/**
 * Wrapper over insertBlockTypeWithAnalytics to autobind toolbar input method
 * @param name Block name
 */ function $34325823df1bce51$var$handleInsertBlockType(insertCodeBlock, insertPanel, insertBlockQuote) {
    return (name)=>{
        if (name === (0, $97VXU.CODE_BLOCK).name && insertCodeBlock) return insertCodeBlock((0, $g6Qq4.INPUT_METHOD).TOOLBAR);
        if (name === (0, $97VXU.PANEL).name && insertPanel) return insertPanel((0, $g6Qq4.INPUT_METHOD).TOOLBAR);
        if (name === (0, $97VXU.BLOCK_QUOTE).name && insertBlockQuote) return insertBlockQuote((0, $g6Qq4.INPUT_METHOD).INSERT_MENU);
        return ()=>false;
    };
}
function $34325823df1bce51$var$delayUntilIdle(cb) {
    if (typeof window === 'undefined') return;
    // eslint-disable-next-line compat/compat
    if (window.requestIdleCallback !== undefined) // eslint-disable-next-line compat/compat
    return window.requestIdleCallback(()=>cb(), {
        timeout: 500
    });
    return window.requestAnimationFrame(()=>cb());
}
const $34325823df1bce51$export$b7df1817ade19df9 = ({ config: options = {}, api: api })=>{
    const isToolbarAIFCEnabled = Boolean(api === null || api === void 0 ? void 0 : api.toolbar);
    const refs = {};
    const primaryToolbarComponent = ({ editorView: editorView, editorActions: editorActions, dispatchAnalyticsEvent: dispatchAnalyticsEvent, providerFactory: providerFactory, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, toolbarSize: toolbarSize, disabled: disabled, isToolbarReducedSpacing: isToolbarReducedSpacing, isLastItem: isLastItem })=>{
        refs.popupsMountPoint = popupsMountPoint || undefined;
        if (!editorView) return null;
        return /*#__PURE__*/ (0, $dc70d.jsx)($34325823df1bce51$var$ToolbarInsertBlockWithInjectionApi, {
            pluginInjectionApi: api,
            editorView: editorView,
            editorActions: editorActions,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            providerFactory: providerFactory,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            toolbarSize: toolbarSize,
            disabled: disabled,
            isToolbarReducedSpacing: isToolbarReducedSpacing,
            isLastItem: isLastItem,
            options: options,
            appearance: options.appearance
        });
    };
    if (isToolbarAIFCEnabled) {
        var _api$toolbar, _api$codeBlock, _api$panel, _api$blockType;
        api === null || api === void 0 || (_api$toolbar = api.toolbar) === null || _api$toolbar === void 0 || _api$toolbar.actions.registerComponents((0, $9sxpZ.getToolbarComponents)({
            api: api,
            onInsertBlockType: $34325823df1bce51$var$handleInsertBlockType(api === null || api === void 0 || (_api$codeBlock = api.codeBlock) === null || _api$codeBlock === void 0 ? void 0 : _api$codeBlock.actions.insertCodeBlock, api === null || api === void 0 || (_api$panel = api.panel) === null || _api$panel === void 0 ? void 0 : _api$panel.actions.insertPanel, api === null || api === void 0 || (_api$blockType = api.blockType) === null || _api$blockType === void 0 ? void 0 : _api$blockType.actions.insertBlockQuote),
            options: options
        }));
    } else {
        var _api$primaryToolbar;
        api === null || api === void 0 || (_api$primaryToolbar = api.primaryToolbar) === null || _api$primaryToolbar === void 0 || _api$primaryToolbar.actions.registerComponent({
            name: 'insertBlock',
            component: primaryToolbarComponent
        });
    }
    const plugin = {
        name: 'insertBlock',
        actions: {
            toggleAdditionalMenu: ()=>{
                var _api$core;
                api === null || api === void 0 || (_api$core = api.core) === null || _api$core === void 0 || _api$core.actions.execute(({ tr: tr })=>{
                    return tr.setMeta((0, $SOqL6.toggleInsertBlockPmKey), true);
                });
            }
        },
        getSharedState: (editorState)=>{
            if (!editorState || ![
                'full-page',
                'full-width'
            ].includes(options.appearance ?? '')) return;
            const toggleInsertBlockPluginState = (0, $SOqL6.toggleInsertBlockPmKey).getState(editorState);
            return {
                showElementBrowser: (toggleInsertBlockPluginState === null || toggleInsertBlockPluginState === void 0 ? void 0 : toggleInsertBlockPluginState.showElementBrowser) || false
            };
        },
        usePluginHook () {
            (0, $bSJIT.useEffect)(()=>{
                // This is to optimise the UI so that when the user first clicks on the insert
                // menu it opens instantly. As we're delaying the loading this won't affect the
                // initial editor rendering metrics.
                $34325823df1bce51$var$delayUntilIdle(()=>{
                    (0, $disn5.default).preload();
                });
            }, []);
        },
        pmPlugins: ()=>{
            [
                'full-page',
                'full-width'
            ].includes(options.appearance ?? '');
            const plugins = [];
            plugins.push({
                name: 'toggleInsertBlockPmPlugin',
                plugin: ()=>(0, $SOqL6.toggleInsertBlockPmPlugin)()
            });
            plugins.push({
                name: 'toolbarActionExperiences',
                plugin: ()=>(0, $2NuJy.getToolbarActionExperiencesPlugin)({
                        dispatchAnalyticsEvent: (payload)=>{
                            var _api$analytics;
                            return api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 || (_api$analytics = _api$analytics.actions) === null || _api$analytics === void 0 ? void 0 : _api$analytics.fireAnalyticsEvent(payload);
                        }
                    })
            });
            return plugins;
        },
        pluginsOptions: {},
        primaryToolbarComponent: !(api !== null && api !== void 0 && api.primaryToolbar) ? primaryToolbarComponent : undefined
    };
    return plugin;
};
const $34325823df1bce51$var$selector = (states)=>{
    var _states$mediaState, _states$mediaState2, _states$insertBlockSt, _states$typeAheadStat, _states$mentionState, _states$mentionState2, _states$dateState, _states$placeholderTe, _states$connectivityS, _states$imageUploadSt, _states$blockTypeStat, _states$hyperlinkStat, _states$hyperlinkStat2, _states$emojiState;
    return {
        showMediaPicker: (_states$mediaState = states.mediaState) === null || _states$mediaState === void 0 ? void 0 : _states$mediaState.showMediaPicker,
        mediaAllowsUploads: (_states$mediaState2 = states.mediaState) === null || _states$mediaState2 === void 0 ? void 0 : _states$mediaState2.allowsUploads,
        showElementBrowser: (_states$insertBlockSt = states.insertBlockState) === null || _states$insertBlockSt === void 0 ? void 0 : _states$insertBlockSt.showElementBrowser,
        isTypeAheadAllowed: (_states$typeAheadStat = states.typeAheadState) === null || _states$typeAheadStat === void 0 ? void 0 : _states$typeAheadStat.isAllowed,
        mentionProvider: (_states$mentionState = states.mentionState) === null || _states$mentionState === void 0 ? void 0 : _states$mentionState.mentionProvider,
        canInsertMention: (_states$mentionState2 = states.mentionState) === null || _states$mentionState2 === void 0 ? void 0 : _states$mentionState2.canInsertMention,
        dateEnabled: (_states$dateState = states.dateState) === null || _states$dateState === void 0 ? void 0 : _states$dateState.isInitialised,
        placeholderTextAllowInserting: (_states$placeholderTe = states.placeholderTextState) === null || _states$placeholderTe === void 0 ? void 0 : _states$placeholderTe.allowInserting,
        connectivityMode: (_states$connectivityS = states.connectivityState) === null || _states$connectivityS === void 0 ? void 0 : _states$connectivityS.mode,
        imageUploadEnabled: (_states$imageUploadSt = states.imageUploadState) === null || _states$imageUploadSt === void 0 ? void 0 : _states$imageUploadSt.enabled,
        availableWrapperBlockTypes: (_states$blockTypeStat = states.blockTypeState) === null || _states$blockTypeStat === void 0 ? void 0 : _states$blockTypeStat.availableWrapperBlockTypes,
        canInsertLink: (_states$hyperlinkStat = states.hyperlinkState) === null || _states$hyperlinkStat === void 0 ? void 0 : _states$hyperlinkStat.canInsertLink,
        activeLinkMark: (_states$hyperlinkStat2 = states.hyperlinkState) === null || _states$hyperlinkStat2 === void 0 ? void 0 : _states$hyperlinkStat2.activeLinkMark,
        emojiContentId: (_states$emojiState = states.emojiState) === null || _states$emojiState === void 0 ? void 0 : _states$emojiState.contentId
    };
};
function $34325823df1bce51$var$ToolbarInsertBlockWithInjectionApi({ editorView: editorView, editorActions: editorActions, dispatchAnalyticsEvent: dispatchAnalyticsEvent, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, toolbarSize: toolbarSize, disabled: disabled, isToolbarReducedSpacing: isToolbarReducedSpacing, isLastItem: isLastItem, pluginInjectionApi: pluginInjectionApi, options: options, appearance: appearance }) {
    var _pluginInjectionApi$i, _pluginInjectionApi$c2, _pluginInjectionApi$p, _pluginInjectionApi$b, _pluginInjectionApi$e;
    const buttons = $34325823df1bce51$export$7e87882fdef9bc6(toolbarSize, appearance);
    const { showMediaPicker: showMediaPicker, mediaAllowsUploads: mediaAllowsUploads, showElementBrowser: showElementBrowser, isTypeAheadAllowed: isTypeAheadAllowed, mentionProvider: mentionProvider, canInsertMention: canInsertMention, dateEnabled: dateEnabled, placeholderTextAllowInserting: placeholderTextAllowInserting, connectivityMode: connectivityMode, imageUploadEnabled: imageUploadEnabled, availableWrapperBlockTypes: availableWrapperBlockTypes, canInsertLink: canInsertLink, activeLinkMark: activeLinkMark, emojiContentId: emojiContentId } = (0, $5beht.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'hyperlink',
        'date',
        'imageUpload',
        'mention',
        'emoji',
        'blockType',
        'media',
        'typeAhead',
        'placeholderText',
        'insertBlock',
        'connectivity'
    ], $34325823df1bce51$var$selector);
    const emojiProvider = (0, $2pWL6.useSharedPluginStateSelector)(pluginInjectionApi, 'emoji.emojiProviderPromise');
    const onShowMediaPicker = (mountInfo)=>{
        var _pluginInjectionApi$m, _pluginInjectionApi$c, _pluginInjectionApi$m2;
        if (!showMediaPicker) return;
        pluginInjectionApi !== null && pluginInjectionApi !== void 0 && (_pluginInjectionApi$m = pluginInjectionApi.mediaInsert) !== null && _pluginInjectionApi$m !== void 0 && _pluginInjectionApi$m.commands.showMediaInsertPopup ? pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$c = pluginInjectionApi.core) === null || _pluginInjectionApi$c === void 0 || _pluginInjectionApi$c.actions.execute(pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$m2 = pluginInjectionApi.mediaInsert) === null || _pluginInjectionApi$m2 === void 0 ? void 0 : _pluginInjectionApi$m2.commands.showMediaInsertPopup(mountInfo)) : showMediaPicker();
    };
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $6r3dU.default), {
        emojiContentId: emojiContentId,
        showElementBrowser: showElementBrowser || false,
        pluginInjectionApi: pluginInjectionApi,
        buttons: buttons,
        isReducedSpacing: isToolbarReducedSpacing,
        isDisabled: disabled,
        isTypeAheadAllowed: Boolean(isTypeAheadAllowed),
        editorView: editorView,
        tableSupported: !!editorView.state.schema.nodes.table,
        tableSelectorSupported: options.tableSelectorSupported && !!editorView.state.schema.nodes.table,
        actionSupported: !!editorView.state.schema.nodes.taskItem,
        mentionsSupported: !!mentionProvider,
        mentionsDisabled: !canInsertMention,
        decisionSupported: !!editorView.state.schema.nodes.decisionItem,
        dateEnabled: !!dateEnabled,
        placeholderTextEnabled: !!placeholderTextAllowInserting,
        layoutSectionEnabled: Boolean(pluginInjectionApi === null || pluginInjectionApi === void 0 ? void 0 : pluginInjectionApi.layout),
        expandEnabled: !!options.allowExpand,
        mediaUploadsEnabled: mediaAllowsUploads ?? undefined,
        onShowMediaPicker: onShowMediaPicker,
        mediaSupported: mediaAllowsUploads !== undefined,
        isEditorOffline: (0, $hVGJk.isOfflineMode)(connectivityMode),
        imageUploadSupported: !!(pluginInjectionApi !== null && pluginInjectionApi !== void 0 && pluginInjectionApi.imageUpload),
        imageUploadEnabled: imageUploadEnabled,
        handleImageUpload: pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$i = pluginInjectionApi.imageUpload) === null || _pluginInjectionApi$i === void 0 ? void 0 : _pluginInjectionApi$i.actions.startUpload,
        availableWrapperBlockTypes: availableWrapperBlockTypes,
        linkSupported: canInsertLink !== undefined,
        linkDisabled: !canInsertLink || !!activeLinkMark,
        emojiDisabled: !emojiProvider,
        emojiProvider: emojiProvider,
        nativeStatusSupported: options.nativeStatusSupported,
        horizontalRuleEnabled: options.horizontalRuleEnabled,
        onInsertBlockType: $34325823df1bce51$var$handleInsertBlockType(pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$c2 = pluginInjectionApi.codeBlock) === null || _pluginInjectionApi$c2 === void 0 ? void 0 : _pluginInjectionApi$c2.actions.insertCodeBlock, pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$p = pluginInjectionApi.panel) === null || _pluginInjectionApi$p === void 0 ? void 0 : _pluginInjectionApi$p.actions.insertPanel, pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$b = pluginInjectionApi.blockType) === null || _pluginInjectionApi$b === void 0 ? void 0 : _pluginInjectionApi$b.actions.insertBlockQuote),
        onInsertMacroFromMacroBrowser: pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$e = pluginInjectionApi.extension) === null || _pluginInjectionApi$e === void 0 ? void 0 : _pluginInjectionApi$e.actions.insertMacroFromMacroBrowser,
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        insertMenuItems: options.insertMenuItems,
        itemFilter: options.itemFilter,
        editorActions: editorActions,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        showElementBrowserLink: options.showElementBrowserLink,
        showSeparator: !isLastItem && toolbarSize <= (0, $d0HRE.ToolbarSize).S,
        editorAppearance: options.appearance
    });
}

});
parcelRegister("disn5", function(module, exports) {
$parcel$export(module.exports, "default", () => $08e5cfb588d9cc73$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $deAR2 = parcelRequire("deAR2");

var $cJJTb = parcelRequire("cJJTb");

var $3y2s4 = parcelRequire("3y2s4");

var $hDkm2 = parcelRequire("hDkm2");
function $08e5cfb588d9cc73$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $08e5cfb588d9cc73$var$spinnerContainer = {
    name: "c1gsw5",
    styles: "display:flex;align-items:center;justify-content:center;height:100%;width:100%"
};

const $08e5cfb588d9cc73$var$loadElementBrowser = ()=>(parcelRequire("bPaQa")).then((module)=>module.default);

const $08e5cfb588d9cc73$var$ElementBrowserLazy = (0, $cJJTb.lazy)(()=>(parcelRequire("bPaQa")).then((module)=>module.default), {
    moduleId: "../platform/packages/editor/editor-common/src/element-browser/ElementBrowser.tsx"
});
$08e5cfb588d9cc73$var$ElementBrowserLazy.displayName = 'lazy(ElementBrowser)';
const $08e5cfb588d9cc73$var$ElementBrowserLoadable = (0, (/*@__PURE__*/$parcel$interopDefault($deAR2)))({
    loader: $08e5cfb588d9cc73$var$loadElementBrowser,
    loading: ()=>/*#__PURE__*/ (0, $9dQre.jsx)("div", {
            css: $08e5cfb588d9cc73$var$spinnerContainer
        }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $hDkm2.default), {
            size: "medium",
            interactionName: "element-browser-spinner"
        }))
});
const $08e5cfb588d9cc73$var$ElementBrowserLoader = (props)=>(0, $3y2s4.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? /*#__PURE__*/ (0, $9dQre.jsx)((0, $cJJTb.LazySuspense), {
        fallback: null
    }, /*#__PURE__*/ (0, $9dQre.jsx)($08e5cfb588d9cc73$var$ElementBrowserLazy, props)) : // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $9dQre.jsx)($08e5cfb588d9cc73$var$ElementBrowserLoadable, props);
$08e5cfb588d9cc73$var$ElementBrowserLoader.preload = ()=>(0, $3y2s4.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? $08e5cfb588d9cc73$var$ElementBrowserLazy.preload() : $08e5cfb588d9cc73$var$ElementBrowserLoadable.preload();
var $08e5cfb588d9cc73$export$2e2bcd8739ae039 = $08e5cfb588d9cc73$var$ElementBrowserLoader;

});
parcelRegister("bPaQa", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("crTID").then(()=>parcelRequire('9CVRW'));

});


parcelRegister("97VXU", function(module, exports) {
$parcel$export(module.exports, "NORMAL_TEXT", () => $06f3fc38b68b081e$export$58d6de174a4025df);
$parcel$export(module.exports, "SMALL_TEXT", () => $06f3fc38b68b081e$export$1c89d6b8fe002592);
$parcel$export(module.exports, "HEADING_1", () => $06f3fc38b68b081e$export$aca53469ff012f69);
$parcel$export(module.exports, "HEADING_2", () => $06f3fc38b68b081e$export$8af5e2d4f952c9f0);
$parcel$export(module.exports, "HEADING_3", () => $06f3fc38b68b081e$export$4b4c4ef3a93a84d8);
$parcel$export(module.exports, "HEADING_4", () => $06f3fc38b68b081e$export$67379271b4d26982);
$parcel$export(module.exports, "HEADING_5", () => $06f3fc38b68b081e$export$230d7efa1736763e);
$parcel$export(module.exports, "HEADING_6", () => $06f3fc38b68b081e$export$329adfa5d98f30d5);
$parcel$export(module.exports, "BLOCK_QUOTE", () => $06f3fc38b68b081e$export$175cdd8bc7e4b125);
$parcel$export(module.exports, "CODE_BLOCK", () => $06f3fc38b68b081e$export$cf55d1bff75690da);
$parcel$export(module.exports, "PANEL", () => $06f3fc38b68b081e$export$867b449446b85962);
$parcel$export(module.exports, "OTHER", () => $06f3fc38b68b081e$export$d46a05f8561f868a);
$parcel$export(module.exports, "TEXT_BLOCK_TYPES", () => $06f3fc38b68b081e$export$2ec1d6c4f06d927);
$parcel$export(module.exports, "toolbarBlockTypesWithRank", () => $06f3fc38b68b081e$export$eb0a3dded5e1d29b);
$parcel$export(module.exports, "FORMATTING_NODE_TYPES", () => $06f3fc38b68b081e$export$a5cb0c20bd02ce0c);
$parcel$export(module.exports, "FORMATTING_MARK_TYPES", () => $06f3fc38b68b081e$export$73b50f8f13648c71);
$parcel$export(module.exports, "WRAPPER_BLOCK_TYPES", () => $06f3fc38b68b081e$export$c6516682f7569488);
$parcel$export(module.exports, "getBlockTypesInDropdown", () => $06f3fc38b68b081e$export$a1bb601016dd2309);
$parcel$export(module.exports, "HEADINGS_BY_LEVEL", () => $06f3fc38b68b081e$export$110c9c3e05131569);
$parcel$export(module.exports, "HEADINGS_BY_NAME", () => $06f3fc38b68b081e$export$33dfdcd30c23ea87);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $8iYGb = parcelRequire("8iYGb");

var $4rzOL = parcelRequire("4rzOL");

var $fiku8 = parcelRequire("fiku8");

var $c6mZq = parcelRequire("c6mZq");

var $hxpn3 = parcelRequire("hxpn3");

var $dhuIq = parcelRequire("dhuIq");

var $bbism = parcelRequire("bbism");

var $5RnyC = parcelRequire("5RnyC");

var $hz5BZ = parcelRequire("hz5BZ");

var $jHVBL = parcelRequire("jHVBL");

var $eo2bn = parcelRequire("eo2bn");

var $1SDp1 = parcelRequire("1SDp1");

var $c6mZq = parcelRequire("c6mZq");

var $hxpn3 = parcelRequire("hxpn3");

var $dhuIq = parcelRequire("dhuIq");

var $bbism = parcelRequire("bbism");

var $5RnyC = parcelRequire("5RnyC");

var $hz5BZ = parcelRequire("hz5BZ");

var $dca9w = parcelRequire("dca9w");

var $4gLfY = parcelRequire("4gLfY");
const $06f3fc38b68b081e$export$58d6de174a4025df = {
    name: 'normal',
    title: (0, $8iYGb.messages).normal,
    nodeName: 'paragraph',
    tagName: 'p',
    icon: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dca9w))), {
        label: ""
    }),
    LEGACY_icon: /*#__PURE__*/ (0, $dc70d.jsx)((0, $4gLfY.Text), {})
};
const $06f3fc38b68b081e$export$1c89d6b8fe002592 = {
    name: 'smallText',
    title: (0, $8iYGb.messages).smallText,
    nodeName: 'paragraph',
    markName: 'fontSize',
    icon: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1SDp1))), {
        label: ""
    }),
    LEGACY_icon: /*#__PURE__*/ (0, $dc70d.jsx)((0, $4gLfY.Text), {})
};
const $06f3fc38b68b081e$export$aca53469ff012f69 = {
    name: 'heading1',
    title: (0, $8iYGb.messages).heading1,
    nodeName: 'heading',
    tagName: 'h1',
    level: 1,
    icon: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dhuIq))), {
        label: ""
    }),
    LEGACY_icon: /*#__PURE__*/ (0, $dc70d.jsx)((0, $4gLfY.H1), {})
};
const $06f3fc38b68b081e$export$8af5e2d4f952c9f0 = {
    name: 'heading2',
    title: (0, $8iYGb.messages).heading2,
    nodeName: 'heading',
    tagName: 'h2',
    level: 2,
    icon: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hz5BZ))), {
        label: ""
    }),
    LEGACY_icon: /*#__PURE__*/ (0, $dc70d.jsx)((0, $4gLfY.H2), {})
};
const $06f3fc38b68b081e$export$4b4c4ef3a93a84d8 = {
    name: 'heading3',
    title: (0, $8iYGb.messages).heading3,
    nodeName: 'heading',
    tagName: 'h3',
    level: 3,
    icon: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5RnyC))), {
        label: ""
    }),
    LEGACY_icon: /*#__PURE__*/ (0, $dc70d.jsx)((0, $4gLfY.H3), {})
};
const $06f3fc38b68b081e$export$67379271b4d26982 = {
    name: 'heading4',
    title: (0, $8iYGb.messages).heading4,
    nodeName: 'heading',
    tagName: 'h4',
    level: 4,
    icon: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hxpn3))), {
        label: ""
    }),
    LEGACY_icon: /*#__PURE__*/ (0, $dc70d.jsx)((0, $4gLfY.H4), {})
};
const $06f3fc38b68b081e$export$230d7efa1736763e = {
    name: 'heading5',
    title: (0, $8iYGb.messages).heading5,
    nodeName: 'heading',
    tagName: 'h5',
    level: 5,
    icon: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c6mZq))), {
        label: ""
    }),
    LEGACY_icon: /*#__PURE__*/ (0, $dc70d.jsx)((0, $4gLfY.H5), {})
};
const $06f3fc38b68b081e$export$329adfa5d98f30d5 = {
    name: 'heading6',
    title: (0, $8iYGb.messages).heading6,
    nodeName: 'heading',
    tagName: 'h6',
    level: 6,
    icon: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bbism))), {
        label: ""
    }),
    LEGACY_icon: /*#__PURE__*/ (0, $dc70d.jsx)((0, $4gLfY.H6), {})
};
const $06f3fc38b68b081e$export$175cdd8bc7e4b125 = {
    name: 'blockquote',
    title: (0, $8iYGb.messages).blockquote,
    nodeName: 'blockquote',
    tagName: 'blockquote'
};
const $06f3fc38b68b081e$export$cf55d1bff75690da = {
    name: 'codeblock',
    title: (0, $8iYGb.messages).codeblock,
    nodeName: 'codeBlock'
};
const $06f3fc38b68b081e$export$867b449446b85962 = {
    name: 'panel',
    title: (0, $8iYGb.messages).infoPanel,
    nodeName: 'panel'
};
const $06f3fc38b68b081e$export$d46a05f8561f868a = {
    name: 'other',
    title: (0, $8iYGb.messages).other,
    nodeName: ''
};
const $06f3fc38b68b081e$export$2ec1d6c4f06d927 = [
    $06f3fc38b68b081e$export$58d6de174a4025df,
    $06f3fc38b68b081e$export$1c89d6b8fe002592,
    $06f3fc38b68b081e$export$aca53469ff012f69,
    $06f3fc38b68b081e$export$8af5e2d4f952c9f0,
    $06f3fc38b68b081e$export$4b4c4ef3a93a84d8,
    $06f3fc38b68b081e$export$67379271b4d26982,
    $06f3fc38b68b081e$export$230d7efa1736763e,
    $06f3fc38b68b081e$export$329adfa5d98f30d5
];
var $06f3fc38b68b081e$var$ToolbarBlockTypes = /*#__PURE__*/ function(ToolbarBlockTypes) {
    ToolbarBlockTypes["normal"] = "normal";
    ToolbarBlockTypes["heading1"] = "heading1";
    ToolbarBlockTypes["heading2"] = "heading2";
    ToolbarBlockTypes["heading3"] = "heading3";
    ToolbarBlockTypes["heading4"] = "heading4";
    ToolbarBlockTypes["heading5"] = "heading5";
    ToolbarBlockTypes["heading6"] = "heading6";
    ToolbarBlockTypes["blockquote"] = "blockquote";
    return ToolbarBlockTypes;
}($06f3fc38b68b081e$var$ToolbarBlockTypes || {});
const $06f3fc38b68b081e$export$eb0a3dded5e1d29b = ({ allowFontSize: allowFontSize })=>({
        normal: {
            ...$06f3fc38b68b081e$export$58d6de174a4025df,
            icon: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eo2bn))), {
                size: "small",
                label: ""
            }),
            toolbarRank: (0, $fiku8.TEXT_STYLES_MENU_SECTION_RANK)[(0, $4rzOL.NORMAL_TEXT_MENU_ITEM).key],
            toolbarKey: (0, $4rzOL.NORMAL_TEXT_MENU_ITEM).key
        },
        ...allowFontSize && {
            smallText: {
                ...$06f3fc38b68b081e$export$1c89d6b8fe002592,
                icon: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1SDp1))), {
                    size: "small",
                    label: ""
                }),
                toolbarRank: (0, $fiku8.TEXT_STYLES_MENU_SECTION_RANK)[(0, $4rzOL.SMALL_TEXT_MENU_ITEM).key],
                toolbarKey: (0, $4rzOL.SMALL_TEXT_MENU_ITEM).key
            }
        },
        heading1: {
            ...$06f3fc38b68b081e$export$aca53469ff012f69,
            icon: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dhuIq))), {
                size: "small",
                label: ""
            }),
            toolbarRank: (0, $fiku8.TEXT_STYLES_MENU_SECTION_RANK)[(0, $4rzOL.HEADING_1_MENU_ITEM).key],
            toolbarKey: (0, $4rzOL.HEADING_1_MENU_ITEM).key
        },
        heading2: {
            ...$06f3fc38b68b081e$export$8af5e2d4f952c9f0,
            icon: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hz5BZ))), {
                size: "small",
                label: ""
            }),
            toolbarRank: (0, $fiku8.TEXT_STYLES_MENU_SECTION_RANK)[(0, $4rzOL.HEADING_2_MENU_ITEM).key],
            toolbarKey: (0, $4rzOL.HEADING_2_MENU_ITEM).key
        },
        heading3: {
            ...$06f3fc38b68b081e$export$4b4c4ef3a93a84d8,
            icon: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5RnyC))), {
                size: "small",
                label: ""
            }),
            toolbarRank: (0, $fiku8.TEXT_STYLES_MENU_SECTION_RANK)[(0, $4rzOL.HEADING_3_MENU_ITEM).key],
            toolbarKey: (0, $4rzOL.HEADING_3_MENU_ITEM).key
        },
        heading4: {
            ...$06f3fc38b68b081e$export$67379271b4d26982,
            icon: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hxpn3))), {
                size: "small",
                label: ""
            }),
            toolbarRank: (0, $fiku8.TEXT_STYLES_MENU_SECTION_RANK)[(0, $4rzOL.HEADING_4_MENU_ITEM).key],
            toolbarKey: (0, $4rzOL.HEADING_4_MENU_ITEM).key
        },
        heading5: {
            ...$06f3fc38b68b081e$export$230d7efa1736763e,
            icon: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c6mZq))), {
                size: "small",
                label: ""
            }),
            toolbarRank: (0, $fiku8.TEXT_STYLES_MENU_SECTION_RANK)[(0, $4rzOL.HEADING_5_MENU_ITEM).key],
            toolbarKey: (0, $4rzOL.HEADING_5_MENU_ITEM).key
        },
        heading6: {
            ...$06f3fc38b68b081e$export$329adfa5d98f30d5,
            icon: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bbism))), {
                size: "small",
                label: ""
            }),
            toolbarRank: (0, $fiku8.TEXT_STYLES_MENU_SECTION_RANK)[(0, $4rzOL.HEADING_6_MENU_ITEM).key],
            toolbarKey: (0, $4rzOL.HEADING_6_MENU_ITEM).key
        },
        blockquote: {
            ...$06f3fc38b68b081e$export$175cdd8bc7e4b125,
            icon: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jHVBL))), {
                size: "small",
                label: ""
            }),
            toolbarRank: (0, $fiku8.TEXT_STYLES_MENU_SECTION_RANK)[(0, $4rzOL.BLOCK_QUOTE_MENU_ITEM).key],
            toolbarKey: (0, $4rzOL.BLOCK_QUOTE_MENU_ITEM).key
        }
    });
const $06f3fc38b68b081e$export$a5cb0c20bd02ce0c = [
    'heading',
    'blockquote'
];
const $06f3fc38b68b081e$export$73b50f8f13648c71 = [
    'em',
    'code',
    'strike',
    'strong',
    'underline',
    'textColor',
    'subsup',
    'backgroundColor'
];
const $06f3fc38b68b081e$export$c6516682f7569488 = [
    $06f3fc38b68b081e$export$175cdd8bc7e4b125,
    $06f3fc38b68b081e$export$cf55d1bff75690da,
    $06f3fc38b68b081e$export$867b449446b85962
];
const $06f3fc38b68b081e$export$237f26fa8dbc0d9a = $06f3fc38b68b081e$export$2ec1d6c4f06d927.concat($06f3fc38b68b081e$export$c6516682f7569488);
const $06f3fc38b68b081e$export$a1bb601016dd2309 = (includeBlockQuoteAsTextstyleOption)=>{
    return includeBlockQuoteAsTextstyleOption ? [
        ...$06f3fc38b68b081e$export$2ec1d6c4f06d927,
        $06f3fc38b68b081e$export$175cdd8bc7e4b125
    ] : $06f3fc38b68b081e$export$2ec1d6c4f06d927;
};
const $06f3fc38b68b081e$export$110c9c3e05131569 = $06f3fc38b68b081e$export$2ec1d6c4f06d927.reduce((acc, blockType)=>{
    if (blockType.level && blockType.nodeName === 'heading') acc[blockType.level] = blockType;
    return acc;
}, {});
const $06f3fc38b68b081e$export$33dfdcd30c23ea87 = $06f3fc38b68b081e$export$2ec1d6c4f06d927.reduce((acc, blockType)=>{
    if (blockType.level && blockType.nodeName === 'heading') acc[blockType.name] = blockType;
    return acc;
}, {});

});
parcelRegister("c6mZq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e682ba944fbdbd4c1fcce527cadb9f7f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8cf7e0d7c1849ef8$var$_react = $8cf7e0d7c1849ef8$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $8cf7e0d7c1849ef8$var$_iconNew = $8cf7e0d7c1849ef8$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $8cf7e0d7c1849ef8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextHeadingFive".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/text-heading-five
 * Usage guidance:
 * Reserved for H5 / Heading 5 text style
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8cf7e0d7c1849ef8$var$TextHeadingFiveIcon = (props)=>/*#__PURE__*/ $8cf7e0d7c1849ef8$var$_react.default.createElement($8cf7e0d7c1849ef8$var$_iconNew.default, Object.assign({
        name: "TextHeadingFiveIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M16 8.5h-3.75a.75.75 0 0 0-.75.75v3c0 .41.34.75.75.75h2.25v1.5h-3V16h3.13c.76 0 1.38-.62 1.38-1.37v-1.75c0-.76-.62-1.37-1.37-1.37H13V10h3zM2.5 6.25V1H1v12h1.5V7.75H8V13h1.5V1H8v5.25z" clip-rule="evenodd"/>`
    }, props));
$8cf7e0d7c1849ef8$var$TextHeadingFiveIcon.displayName = 'TextHeadingFiveIcon';
var $8cf7e0d7c1849ef8$var$_default = module.exports.default = $8cf7e0d7c1849ef8$var$TextHeadingFiveIcon;

});

parcelRegister("hxpn3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::56266a4ed3a7385017d69b3774d73b99>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cc4932dd1ab88088$var$_react = $cc4932dd1ab88088$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $cc4932dd1ab88088$var$_iconNew = $cc4932dd1ab88088$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $cc4932dd1ab88088$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextHeadingFour".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/text-heading-four
 * Usage guidance:
 * Reserved for H4 / Heading 4 text style
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cc4932dd1ab88088$var$TextHeadingFourIcon = (props)=>/*#__PURE__*/ $cc4932dd1ab88088$var$_react.default.createElement($cc4932dd1ab88088$var$_iconNew.default, Object.assign({
        name: "TextHeadingFourIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.5 12V8.5H11v3.63c0 .76.62 1.38 1.38 1.38h2.12V16H16V8.5h-1.5V12zm-10-5.75V1H1v12h1.5V7.75H8V13h1.5V1H8v5.25z" clip-rule="evenodd"/>`
    }, props));
$cc4932dd1ab88088$var$TextHeadingFourIcon.displayName = 'TextHeadingFourIcon';
var $cc4932dd1ab88088$var$_default = module.exports.default = $cc4932dd1ab88088$var$TextHeadingFourIcon;

});

parcelRegister("dhuIq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::17c71ed2e395e146d0ed5eb5962cd4a6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9ab4b05acd70d96a$var$_react = $9ab4b05acd70d96a$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $9ab4b05acd70d96a$var$_iconNew = $9ab4b05acd70d96a$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $9ab4b05acd70d96a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextHeadingOne".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/text-heading-one
 * Usage guidance:
 * Reserved for H1 / Heading 1 text style
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9ab4b05acd70d96a$var$TextHeadingOneIcon = (props)=>/*#__PURE__*/ $9ab4b05acd70d96a$var$_react.default.createElement($9ab4b05acd70d96a$var$_iconNew.default, Object.assign({
        name: "TextHeadingOneIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2.5 6.25V1H1v12h1.5V7.75H8V13h1.5V1H8v5.25zM12 8.5h1.75a.75.75 0 0 1 .75.75V16H13v-6h-1z" clip-rule="evenodd"/>`
    }, props));
$9ab4b05acd70d96a$var$TextHeadingOneIcon.displayName = 'TextHeadingOneIcon';
var $9ab4b05acd70d96a$var$_default = module.exports.default = $9ab4b05acd70d96a$var$TextHeadingOneIcon;

});

parcelRegister("bbism", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8f8309572174719fe79637b699c3906e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $823f09d8d5f7fe98$var$_react = $823f09d8d5f7fe98$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $823f09d8d5f7fe98$var$_iconNew = $823f09d8d5f7fe98$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $823f09d8d5f7fe98$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextHeadingSix".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/text-heading-six
 * Usage guidance:
 * Reserved for H6 / Heading 6 text style
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $823f09d8d5f7fe98$var$TextHeadingSixIcon = (props)=>/*#__PURE__*/ $823f09d8d5f7fe98$var$_react.default.createElement($823f09d8d5f7fe98$var$_iconNew.default, Object.assign({
        name: "TextHeadingSixIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15.5 8.5h-2.62c-.76 0-1.37.62-1.37 1.38v4.75c0 .76.62 1.38 1.38 1.38h1.75c.76 0 1.38-.62 1.38-1.37v-1.75c0-.76-.62-1.37-1.37-1.37H13V10h2.5zM13 13h1.5v1.5H13zM2.5 6.25V1H1v12h1.5V7.75H8V13h1.5V1H8v5.25z" clip-rule="evenodd"/>`
    }, props));
$823f09d8d5f7fe98$var$TextHeadingSixIcon.displayName = 'TextHeadingSixIcon';
var $823f09d8d5f7fe98$var$_default = module.exports.default = $823f09d8d5f7fe98$var$TextHeadingSixIcon;

});

parcelRegister("5RnyC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::78d4c5c3f7e0406ec16a86e075508747>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $44442cfe487658ae$var$_react = $44442cfe487658ae$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $44442cfe487658ae$var$_iconNew = $44442cfe487658ae$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $44442cfe487658ae$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextHeadingThree".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/text-heading-three
 * Usage guidance:
 * Reserved for H3 / Heading 3 text style
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $44442cfe487658ae$var$TextHeadingThreeIcon = (props)=>/*#__PURE__*/ $44442cfe487658ae$var$_react.default.createElement($44442cfe487658ae$var$_iconNew.default, Object.assign({
        name: "TextHeadingThreeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.5 8.5h3.13c.76 0 1.38.62 1.38 1.38v4.75c0 .76-.62 1.38-1.37 1.38H11.5v-1.5h3V13h-3v-1.5h3V10h-3zm-9-2.25V1H1v12h1.5V7.75H8V13h1.5V1H8v5.25z" clip-rule="evenodd"/>`
    }, props));
$44442cfe487658ae$var$TextHeadingThreeIcon.displayName = 'TextHeadingThreeIcon';
var $44442cfe487658ae$var$_default = module.exports.default = $44442cfe487658ae$var$TextHeadingThreeIcon;

});

parcelRegister("hz5BZ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e4b1f18d38f6a57234559d758bef21af>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cc9a0ef1e189dff1$var$_react = $cc9a0ef1e189dff1$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $cc9a0ef1e189dff1$var$_iconNew = $cc9a0ef1e189dff1$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $cc9a0ef1e189dff1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextHeadingTwo".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/text-heading-two
 * Usage guidance:
 * Reserved for H2 / Heading 2 text style
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cc9a0ef1e189dff1$var$TextHeadingTwoIcon = (props)=>/*#__PURE__*/ $cc9a0ef1e189dff1$var$_react.default.createElement($cc9a0ef1e189dff1$var$_iconNew.default, Object.assign({
        name: "TextHeadingTwoIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.5 8.5h3.13c.76 0 1.38.62 1.38 1.38v1.75c0 .76-.62 1.38-1.37 1.38H13v1.5h3V16h-3.75a.75.75 0 0 1-.75-.75v-2.37c0-.76.62-1.37 1.38-1.37h1.62V10h-3zm-9-2.25V1H1v12h1.5V7.75H8V13h1.5V1H8v5.25z" clip-rule="evenodd"/>`
    }, props));
$cc9a0ef1e189dff1$var$TextHeadingTwoIcon.displayName = 'TextHeadingTwoIcon';
var $cc9a0ef1e189dff1$var$_default = module.exports.default = $cc9a0ef1e189dff1$var$TextHeadingTwoIcon;

});

parcelRegister("eo2bn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::17bd805cb619485deb9fdaf816288569>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $02b3f39cdf4648d0$var$_react = $02b3f39cdf4648d0$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $02b3f39cdf4648d0$var$_iconNew = $02b3f39cdf4648d0$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $02b3f39cdf4648d0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextNormal".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/text-normal
 * Usage guidance:
 * Reserved for representing Paragraph text style / Normal text style.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $02b3f39cdf4648d0$var$TextNormalIcon = (props)=>/*#__PURE__*/ $02b3f39cdf4648d0$var$_react.default.createElement($02b3f39cdf4648d0$var$_iconNew.default, Object.assign({
        name: "TextNormalIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M13.5 1v1.5H8.751V15h-1.5V2.5H2.5V1z"/>`
    }, props));
$02b3f39cdf4648d0$var$TextNormalIcon.displayName = 'TextNormalIcon';
var $02b3f39cdf4648d0$var$_default = module.exports.default = $02b3f39cdf4648d0$var$TextNormalIcon;

});

parcelRegister("1SDp1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8835498eec0187a147a0313d2735c400>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $15e9662408156ecd$var$_react = $15e9662408156ecd$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $15e9662408156ecd$var$_iconNew = $15e9662408156ecd$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $15e9662408156ecd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextSmall".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/text-small
 * Usage guidance:
 * Reserved for representing small text style in text editor experiences.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $15e9662408156ecd$var$TextSmallIcon = (props)=>/*#__PURE__*/ $15e9662408156ecd$var$_react.default.createElement($15e9662408156ecd$var$_iconNew.default, Object.assign({
        name: "TextSmallIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11 1v1.5H6.251V15h-1.5V2.5H0V1zm3.5 11.375v-.5c0-.621-.504-1.125-1.125-1.125h-1.75A2.625 2.625 0 0 1 9 8.125v-.5A2.625 2.625 0 0 1 11.625 5H13.5A2.5 2.5 0 0 1 16 7.5h-1.5a1 1 0 0 0-1-1h-1.875c-.621 0-1.125.504-1.125 1.125v.5c0 .621.504 1.125 1.125 1.125h1.75A2.625 2.625 0 0 1 16 11.875v.5A2.625 2.625 0 0 1 13.375 15H11.5A2.5 2.5 0 0 1 9 12.5h1.5a1 1 0 0 0 1 1h1.875c.621 0 1.125-.504 1.125-1.125"/>`
    }, props));
$15e9662408156ecd$var$TextSmallIcon.displayName = 'TextSmallIcon';
var $15e9662408156ecd$var$_default = module.exports.default = $15e9662408156ecd$var$TextSmallIcon;

});

parcelRegister("4gLfY", function(module, exports) {
$parcel$export(module.exports, "Text", () => $316299dbf872f86d$export$5f1af8db9871e1d6);
$parcel$export(module.exports, "H1", () => $316299dbf872f86d$export$5523b16adee8048);
$parcel$export(module.exports, "H2", () => $316299dbf872f86d$export$cb94397127ac9363);
$parcel$export(module.exports, "H3", () => $316299dbf872f86d$export$746be9e3a3dfff1f);
$parcel$export(module.exports, "H4", () => $316299dbf872f86d$export$cc5e069d64fda823);
$parcel$export(module.exports, "H5", () => $316299dbf872f86d$export$88ef9fdaf11f7a1f);
$parcel$export(module.exports, "H6", () => $316299dbf872f86d$export$a559fb8039b06400);
/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");
const $316299dbf872f86d$var$SVGContainer = ({ children: children })=>/*#__PURE__*/ (0, $dc70d.jsx)("span", {
        style: {
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)",
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center'
        },
        children: children
    });
const $316299dbf872f86d$export$5f1af8db9871e1d6 = ()=>/*#__PURE__*/ (0, $dc70d.jsx)($316299dbf872f86d$var$SVGContainer, {
        children: /*#__PURE__*/ (0, $dc70d.jsx)("svg", {
            width: "16",
            height: "16",
            viewBox: "0 0 16 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $dc70d.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M2 1H14V5H12.5V2.5H8.8125V13.5H10.5V15H5.5V13.5H7.3125V2.5H3.5V5H2V1Z",
                fill: "currentColor"
            })
        })
    });
const $316299dbf872f86d$export$5523b16adee8048 = ()=>/*#__PURE__*/ (0, $dc70d.jsx)($316299dbf872f86d$var$SVGContainer, {
        children: /*#__PURE__*/ (0, $dc70d.jsx)("svg", {
            width: "14",
            height: "14",
            viewBox: "0 0 14 14",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $dc70d.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M0 0H1.5V6.25H6V0H7.5V6.25V7.75V14H6V7.75H1.5V14H0V7.75V6.25V0ZM9.85801 12.6959V14H13.9999V12.6959H12.8161V7.83108H11.3138L9.8418 8.86406V10.4342L11.3499 9.31528V12.6959H9.85801Z",
                fill: "currentColor"
            })
        })
    });
const $316299dbf872f86d$export$cb94397127ac9363 = ()=>/*#__PURE__*/ (0, $dc70d.jsx)($316299dbf872f86d$var$SVGContainer, {
        children: /*#__PURE__*/ (0, $dc70d.jsx)("svg", {
            width: "14",
            height: "14",
            viewBox: "0 0 14 14",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $dc70d.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                "clip-rule": "evenodd",
                d: "M1.5 0H0V6.25V7.75V14H1.5V7.75H6V14H7.5V7.75V6.25V0H6V6.25H1.5V0ZM9.2395 12.8296V14H14V12.6553H11.5637V12.573L12.4146 11.875C12.7826 11.5734 13.0772 11.2981 13.2986 11.0491C13.5199 10.8 13.679 10.5635 13.7759 10.3394C13.8755 10.1152 13.9253 9.89111 13.9253 9.66699V9.64624C13.9253 9.28101 13.8285 8.96419 13.6348 8.6958C13.4411 8.42464 13.1685 8.21574 12.8171 8.06909C12.4685 7.91968 12.0562 7.84497 11.5803 7.84497C11.0906 7.84497 10.6617 7.93075 10.2937 8.10229C9.92847 8.27108 9.64347 8.50903 9.43872 8.81616C9.23674 9.12052 9.13574 9.47884 9.13574 9.89111V9.92432H10.7378V9.88696C10.7378 9.74308 10.771 9.6158 10.8374 9.50513C10.9038 9.39445 10.9951 9.30729 11.1113 9.24365C11.2303 9.18001 11.3659 9.14819 11.5181 9.14819C11.6647 9.14819 11.7906 9.1731 11.8958 9.2229C12.0037 9.27271 12.0853 9.34465 12.1406 9.43872C12.1987 9.5328 12.2278 9.64486 12.2278 9.7749V9.79565C12.2278 9.9008 12.1946 10.0115 12.1282 10.1277C12.0645 10.2439 11.9497 10.3878 11.7837 10.5593C11.6177 10.7281 11.3811 10.9467 11.074 11.2151L9.2395 12.8296Z",
                fill: "currentColor"
            })
        })
    });
const $316299dbf872f86d$export$746be9e3a3dfff1f = ()=>/*#__PURE__*/ (0, $dc70d.jsx)($316299dbf872f86d$var$SVGContainer, {
        children: /*#__PURE__*/ (0, $dc70d.jsx)("svg", {
            width: "14",
            height: "14",
            viewBox: "0 0 14 14",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $dc70d.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M1.5 0H0V6.25V7.75V14H1.5V7.75H6V14H7.5V7.75V6.25V0H6V6.25H1.5V0ZM10.219 13.7649C10.5811 13.9216 11.0012 14 11.4794 14C12.0009 14 12.4494 13.9257 12.825 13.7771C13.2005 13.6258 13.4896 13.411 13.6922 13.1327C13.8976 12.8544 14.0002 12.5248 14.0002 12.1438V12.1357C14.0002 11.7575 13.8706 11.4535 13.6112 11.2239C13.3518 10.9942 13.0006 10.8564 12.5575 10.8105V10.7781C12.7709 10.7348 12.9681 10.6565 13.1492 10.543C13.3329 10.4295 13.4801 10.2823 13.5909 10.1013C13.7017 9.91755 13.7571 9.70275 13.7571 9.45688V9.44878C13.7571 9.12186 13.6639 8.83817 13.4774 8.5977C13.291 8.35454 13.0262 8.16541 12.6831 8.03032C12.34 7.89523 11.9347 7.82769 11.4673 7.82769C11.0134 7.82769 10.6162 7.90469 10.2758 8.05869C9.93805 8.20999 9.67057 8.42479 9.47334 8.70308C9.27611 8.98136 9.16533 9.31099 9.14102 9.69194L9.13696 9.75273H10.6851L10.6892 9.71626C10.7027 9.58927 10.7418 9.4785 10.8067 9.38394C10.8715 9.28667 10.9593 9.21237 11.0701 9.16104C11.1836 9.107 11.316 9.07998 11.4673 9.07998C11.6132 9.07998 11.7388 9.10565 11.8442 9.15698C11.9523 9.20562 12.0347 9.27586 12.0914 9.36772C12.1481 9.45959 12.1765 9.56631 12.1765 9.68789V9.696C12.1765 9.81488 12.1427 9.9189 12.0752 10.0081C12.0104 10.0945 11.9158 10.1607 11.7915 10.2066C11.6672 10.2526 11.5159 10.2755 11.3376 10.2755H10.7337V11.4062H11.3376C11.6348 11.4062 11.8618 11.4589 12.0185 11.5643C12.1752 11.667 12.2535 11.8183 12.2535 12.0182V12.0263C12.2535 12.1506 12.2224 12.2614 12.1603 12.3586C12.0982 12.4532 12.009 12.5289 11.8928 12.5856C11.7766 12.6396 11.6375 12.6667 11.4754 12.6667C11.3133 12.6667 11.1728 12.641 11.0539 12.5896C10.935 12.5383 10.8405 12.4681 10.7702 12.3789C10.7 12.2897 10.6567 12.1911 10.6405 12.0831L10.6324 12.0344H8.99512L8.99917 12.0871C9.02889 12.4762 9.14912 12.8139 9.35986 13.1003C9.57061 13.3867 9.857 13.6082 10.219 13.7649Z",
                fill: "currentColor"
            })
        })
    });
const $316299dbf872f86d$export$cc5e069d64fda823 = ()=>/*#__PURE__*/ (0, $dc70d.jsx)($316299dbf872f86d$var$SVGContainer, {
        children: /*#__PURE__*/ (0, $dc70d.jsx)("svg", {
            width: "14",
            height: "14",
            viewBox: "0 0 14 14",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $dc70d.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M1.5 0H0V6.25V7.75V14H1.5V7.75H6V14H7.5V7.75V6.25V0H6V6.25H1.5V0ZM11.542 13.0117V14H13.2607V13.0117H13.9998V11.6195H13.2607V7.79961H10.7428C10.5852 8.05169 10.4291 8.30378 10.2744 8.55586C10.1226 8.80508 9.97077 9.05573 9.81894 9.30781C9.66999 9.5599 9.52103 9.81628 9.37207 10.077C9.22311 10.3348 9.07559 10.5969 8.92949 10.8633C8.7834 11.1268 8.6373 11.3975 8.49121 11.6754V13.0117H11.542ZM11.5936 11.6883H10.0338V11.6023C10.1226 11.4276 10.2143 11.2543 10.3088 11.0824C10.4033 10.9077 10.4993 10.7344 10.5967 10.5625C10.6969 10.3906 10.7972 10.2202 10.8975 10.0512C10.9977 9.8793 11.098 9.71029 11.1982 9.54414C11.3014 9.37799 11.4045 9.21328 11.5076 9.05H11.5936V11.6883Z",
                fill: "currentColor"
            })
        })
    });
const $316299dbf872f86d$export$88ef9fdaf11f7a1f = ()=>/*#__PURE__*/ (0, $dc70d.jsx)($316299dbf872f86d$var$SVGContainer, {
        children: /*#__PURE__*/ (0, $dc70d.jsx)("svg", {
            width: "14",
            height: "14",
            viewBox: "0 0 14 14",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $dc70d.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M1.5 0H0V6.25V7.75V14H1.5V7.75H6V14H7.5V7.75V6.25V0H6V6.25H1.5V0ZM10.2808 13.7551C10.6349 13.9184 11.0527 14 11.5342 14C12.0239 14 12.4542 13.9101 12.825 13.7302C13.1957 13.5476 13.4835 13.2917 13.6882 12.9624C13.8958 12.6331 13.9995 12.2499 13.9995 11.8127V11.8044C13.9995 11.4281 13.9165 11.0961 13.7505 10.8083C13.5872 10.5178 13.3617 10.2896 13.074 10.1235C12.7862 9.95752 12.457 9.87451 12.0862 9.87451C11.887 9.87451 11.703 9.90356 11.5342 9.96167C11.3682 10.0198 11.2243 10.1 11.1025 10.2024C10.9808 10.3048 10.884 10.4237 10.812 10.5593H10.729L10.8203 9.1731H13.6177V7.84497H9.45898L9.22241 11.4973H10.7207C10.7511 11.4392 10.7913 11.3839 10.8411 11.3313C10.8909 11.276 10.9462 11.2275 11.0071 11.186C11.079 11.139 11.1579 11.103 11.2437 11.0781C11.3322 11.0505 11.4277 11.0366 11.53 11.0366C11.6933 11.0366 11.8385 11.0712 11.9658 11.1404C12.0931 11.2068 12.1927 11.2995 12.2646 11.4185C12.3366 11.5374 12.3726 11.6772 12.3726 11.8376V11.8459C12.3726 12.0037 12.3366 12.1448 12.2646 12.2693C12.1927 12.391 12.0931 12.4865 11.9658 12.5557C11.8413 12.6248 11.6974 12.6594 11.5342 12.6594C11.3903 12.6594 11.2616 12.6345 11.1482 12.5847C11.0347 12.5349 10.9393 12.4685 10.8618 12.3855C10.7871 12.2997 10.7318 12.2056 10.6958 12.1033L10.6875 12.0784H9.12695L9.1311 12.1531C9.15047 12.4989 9.25838 12.8116 9.45483 13.0911C9.65405 13.3705 9.92936 13.5919 10.2808 13.7551Z",
                fill: "currentColor"
            })
        })
    });
const $316299dbf872f86d$export$a559fb8039b06400 = ()=>/*#__PURE__*/ (0, $dc70d.jsx)($316299dbf872f86d$var$SVGContainer, {
        children: /*#__PURE__*/ (0, $dc70d.jsx)("svg", {
            width: "14",
            height: "14",
            viewBox: "0 0 14 14",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $dc70d.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M1.5 0H0V6.25V7.75V14H1.5V7.75H6V14H7.5V7.75V6.25V0H6V6.25H1.5V0ZM10.4615 13.7893C10.7857 13.9298 11.1531 14 11.5638 14C12.0501 14 12.4757 13.9068 12.8404 13.7204C13.2052 13.5339 13.4889 13.28 13.6915 12.9584C13.8968 12.6342 13.9995 12.2681 13.9995 11.8602V11.8521C13.9995 11.4873 13.9225 11.1644 13.7685 10.8834C13.6172 10.5998 13.3997 10.3782 13.116 10.2188C12.835 10.0567 12.4973 9.97563 12.1028 9.97563C11.8272 9.97563 11.5935 10.0135 11.4017 10.0891C11.2099 10.1648 11.0532 10.2634 10.9316 10.385C10.81 10.5065 10.7141 10.6389 10.6438 10.7821H10.5547C10.5548 10.7402 10.5561 10.6984 10.5587 10.6565C10.575 10.3539 10.6195 10.0878 10.6925 9.8581C10.7681 9.62845 10.8762 9.44878 11.0167 9.31909C11.1572 9.1894 11.3328 9.12456 11.5436 9.12456C11.6624 9.12456 11.7678 9.14347 11.8597 9.1813C11.9542 9.21912 12.0353 9.27046 12.1028 9.3353C12.1704 9.40015 12.2204 9.47309 12.2528 9.55415L12.2649 9.58252H13.9266L13.9225 9.5582C13.8685 9.23398 13.7334 8.94219 13.5172 8.68281C13.3011 8.42074 13.0215 8.21269 12.6783 8.05869C12.3379 7.90469 11.9542 7.82768 11.5273 7.82768C11.0032 7.82768 10.5466 7.95062 10.1575 8.19648C9.76846 8.44235 9.4672 8.79629 9.25376 9.2583C9.04032 9.71761 8.93359 10.2674 8.93359 10.9078V10.9159C8.93359 11.3941 8.99303 11.8237 9.11191 12.2046C9.23079 12.5856 9.40371 12.9098 9.63066 13.1773C9.86032 13.4421 10.1373 13.6461 10.4615 13.7893ZM10.7492 11.9047C10.7492 12.056 10.7843 12.1925 10.8546 12.3141C10.9275 12.4356 11.0248 12.5316 11.1464 12.6018C11.2707 12.6694 11.4071 12.7031 11.5557 12.7031C11.707 12.7031 11.8435 12.6694 11.965 12.6018C12.0866 12.5316 12.1839 12.4383 12.2568 12.3222C12.3298 12.206 12.3663 12.075 12.3663 11.9291V11.9209C12.3663 11.7696 12.3311 11.6359 12.2609 11.5197C12.1906 11.4035 12.0947 11.3117 11.9731 11.2441C11.8543 11.1766 11.7165 11.1428 11.5598 11.1428C11.4112 11.1428 11.2747 11.1752 11.1504 11.2401C11.0289 11.3022 10.9316 11.39 10.8586 11.5035C10.7857 11.617 10.7492 11.748 10.7492 11.8966V11.9047Z",
                fill: "currentColor"
            })
        })
    });

});


parcelRegister("2NuJy", function(module, exports) {
$parcel$export(module.exports, "getToolbarActionExperiencesPlugin", () => $8b0052a7310412e5$export$452d41e37eef397d);

var $bAB3U = parcelRequire("bAB3U");

var $c9wRy = parcelRequire("c9wRy");

var $faLOc = parcelRequire("faLOc");

var $bApp6 = parcelRequire("bApp6");

var $b8RGE = parcelRequire("b8RGE");

var $73iZo = parcelRequire("73iZo");

var $1EaP8 = parcelRequire("1EaP8");

var $9skTL = parcelRequire("9skTL");

var $f7Kk4 = parcelRequire("f7Kk4");

var $4rzOL = parcelRequire("4rzOL");

var $cw0wu = parcelRequire("cw0wu");

var $kYtnk = parcelRequire("kYtnk");
const $8b0052a7310412e5$var$pluginKey = new (0, $cw0wu.PluginKey)('toolbarActionExperiences');
const $8b0052a7310412e5$var$TIMEOUT_DURATION = 1000;
const $8b0052a7310412e5$var$PRIMARY_TOOLBAR = 'primaryToolbar';
const $8b0052a7310412e5$var$ABORT_REASON = {
    USER_CANCELED: 'userCanceled',
    EDITOR_DESTROYED: 'editorDestroyed'
};
const $8b0052a7310412e5$export$452d41e37eef397d = ({ dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
    let editorView;
    let lastClickedToolbarButton;
    const getEditorDom = ()=>{
        var _editorView;
        if (((_editorView = editorView) === null || _editorView === void 0 ? void 0 : _editorView.dom) instanceof HTMLElement) return editorView.dom;
        return null;
    };
    const getInlinePopupTarget = ()=>{
        if (!lastClickedToolbarButton) return undefined;
        return lastClickedToolbarButton.closest('[data-toolbar-component="button-group"]') ?? lastClickedToolbarButton;
    };
    const observeConfigs = ()=>{
        const narrowTarget = (0, $faLOc.getSelectionAncestorDOM)(editorView);
        const editorDom = getEditorDom();
        return [
            ...narrowTarget ? [
                {
                    target: narrowTarget,
                    options: {
                        childList: true,
                        subtree: true
                    }
                }
            ] : [],
            ...editorDom ? [
                {
                    target: editorDom,
                    options: {
                        childList: true
                    }
                }
            ] : []
        ];
    };
    const createNodeInsertExperience = (action)=>new (0, $b8RGE.Experience)((0, $bApp6.EXPERIENCE_ID).TOOLBAR_ACTION, {
            action: action,
            actionSubjectId: $8b0052a7310412e5$var$PRIMARY_TOOLBAR,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            checks: [
                new (0, $9skTL.ExperienceCheckTimeout)({
                    durationMs: $8b0052a7310412e5$var$TIMEOUT_DURATION
                }),
                new (0, $73iZo.ExperienceCheckDomMutation)({
                    onDomMutation: (0, $kYtnk.handleEditorNodeInsertDomMutation),
                    observeConfig: observeConfigs
                })
            ]
        });
    const buildPopupMutationConfig = (popupSelector, type)=>{
        switch(type){
            case 'inline':
                return {
                    type: type,
                    nestedElementQuery: popupSelector,
                    getTarget: getInlinePopupTarget,
                    subtree: true
                };
            case 'editorRoot':
                return {
                    type: type,
                    nestedElementQuery: popupSelector,
                    getEditorDom: getEditorDom
                };
        }
    };
    const createPopupExperience = (action, popupSelector, type)=>new (0, $b8RGE.Experience)((0, $bApp6.EXPERIENCE_ID).TOOLBAR_ACTION, {
            action: action,
            actionSubjectId: $8b0052a7310412e5$var$PRIMARY_TOOLBAR,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            checks: [
                new (0, $9skTL.ExperienceCheckTimeout)({
                    durationMs: $8b0052a7310412e5$var$TIMEOUT_DURATION
                }),
                new (0, $1EaP8.ExperienceCheckPopupMutation)(buildPopupMutationConfig(popupSelector, type))
            ]
        });
    const experienceButtonMappings = [
        {
            experience: createPopupExperience('insert', '[data-testid="popup-wrapper"]', 'inline'),
            buttonTestId: (0, $4rzOL.TOOLBAR_BUTTON_TEST_ID).INSERT
        },
        {
            experience: createPopupExperience('emoji', '[data-emoji-picker-container], [data-emoji-picker-container="true"], [data-testid="popup-wrapper"]', 'inline'),
            buttonTestId: (0, $4rzOL.TOOLBAR_BUTTON_TEST_ID).EMOJI
        },
        {
            experience: createPopupExperience('media', '[data-testid="popup-wrapper"]', 'inline'),
            buttonTestId: (0, $4rzOL.TOOLBAR_BUTTON_TEST_ID).MEDIA
        },
        {
            experience: createPopupExperience('mention', '[data-testid="popup-wrapper"], [data-type-ahead="typeaheadDecoration"]', 'editorRoot'),
            buttonTestId: (0, $4rzOL.TOOLBAR_BUTTON_TEST_ID).MENTION
        },
        {
            experience: createNodeInsertExperience('table'),
            buttonTestId: (0, $4rzOL.TOOLBAR_BUTTON_TEST_ID).TABLE
        },
        {
            experience: createPopupExperience('tableSelector', '[data-testid="popup-wrapper"]', 'inline'),
            buttonTestId: (0, $4rzOL.TOOLBAR_BUTTON_TEST_ID).TABLE_SELECTOR
        },
        {
            experience: createNodeInsertExperience('layout'),
            buttonTestId: (0, $4rzOL.TOOLBAR_BUTTON_TEST_ID).LAYOUT
        },
        {
            experience: createPopupExperience('image', '[data-testid="popup-wrapper"]', 'inline'),
            buttonTestId: (0, $4rzOL.TOOLBAR_BUTTON_TEST_ID).IMAGE
        },
        {
            experience: createNodeInsertExperience('action'),
            buttonTestId: (0, $4rzOL.TOOLBAR_BUTTON_TEST_ID).TASK_LIST
        }
    ];
    const handleToolbarButtonClick = (target)=>{
        for (const { experience: experience, buttonTestId: buttonTestId } of experienceButtonMappings)if ((0, $kYtnk.isToolbarButtonClick)(target, buttonTestId)) {
            // Store the clicked button so inline popup checks can find its button-group
            lastClickedToolbarButton = target;
            experience.start({
                forceRestart: true
            });
            return;
        }
    };
    const abortAllExperiences = (reason)=>{
        for (const { experience: experience } of experienceButtonMappings)experience.abort({
            reason: reason
        });
    };
    const doc = (0, $c9wRy.getDocument)();
    if (!doc) return new (0, $f7Kk4.SafePlugin)({
        key: $8b0052a7310412e5$var$pluginKey
    });
    const unbindClickListener = (0, $bAB3U.bind)(doc, {
        type: 'click',
        listener: (event)=>{
            const target = event.target;
            if (target instanceof HTMLElement) handleToolbarButtonClick(target);
        },
        options: {
            capture: true
        }
    });
    const unbindKeydownListener = (0, $bAB3U.bind)(doc, {
        type: 'keydown',
        listener: (event)=>{
            if (event.key === 'Escape') abortAllExperiences($8b0052a7310412e5$var$ABORT_REASON.USER_CANCELED);
        },
        options: {
            capture: true
        }
    });
    return new (0, $f7Kk4.SafePlugin)({
        key: $8b0052a7310412e5$var$pluginKey,
        view: (view)=>{
            editorView = view;
            return {
                destroy: ()=>{
                    abortAllExperiences($8b0052a7310412e5$var$ABORT_REASON.EDITOR_DESTROYED);
                    editorView = undefined;
                    unbindClickListener();
                    unbindKeydownListener();
                }
            };
        }
    });
};

});
parcelRegister("faLOc", function(module, exports) {
$parcel$export(module.exports, "getSelectionAncestorDOM", () => $81d95a22325be8cd$export$fe7123d322bc7614);
const $81d95a22325be8cd$export$fe7123d322bc7614 = (editorView)=>{
    if (!editorView) return null;
    const pmDom = editorView.dom;
    const { selection: selection } = editorView.state;
    // nodeDOM can return null when editor loses focus (e.g. toolbar click) or for certain positions.
    // Fall back to domAtPos which resolves the DOM node at the given position.
    let currentNode = editorView.nodeDOM(selection.from);
    if (!currentNode) try {
        const { node: node } = editorView.domAtPos(selection.from);
        currentNode = node instanceof HTMLElement ? node : node.parentElement;
    } catch  {
        return null;
    }
    let lastValidAncestor = currentNode;
    while(currentNode instanceof HTMLElement && currentNode !== pmDom){
        lastValidAncestor = currentNode;
        currentNode = currentNode.parentElement;
    }
    return lastValidAncestor instanceof HTMLElement ? lastValidAncestor : null;
};

});

parcelRegister("bApp6", function(module, exports) {
$parcel$export(module.exports, "EXPERIENCE_FAILURE_REASON", () => $b490f4c20ac5eca9$export$21dde0ac9b2abe83);
$parcel$export(module.exports, "EXPERIENCE_ABORT_REASON", () => $b490f4c20ac5eca9$export$e6589edd1f8a04af);
$parcel$export(module.exports, "DEFAULT_EXPERIENCE_SAMPLE_RATE", () => $b490f4c20ac5eca9$export$8e85905c8b6efc67);
$parcel$export(module.exports, "EXPERIENCE_ID", () => $b490f4c20ac5eca9$export$b110169935468339);
/**
 * Built-in failure reasons for experience checks
 *
 * These are used by the various ExperienceCheck implementations to
 * provide consistent, well-known failure reasons for analytics and debugging.
 */ const $b490f4c20ac5eca9$export$21dde0ac9b2abe83 = {
    /**
   * Experience timed out before completion
   */ TIMEOUT: 'timeout',
    /**
   * Target element could not be found when starting DOM mutation observation
   */ DOM_MUTATION_TARGET_NOT_FOUND: 'domMutationTargetNotFound',
    /**
   * Error occurred during DOM mutation check execution
   */ DOM_MUTATION_CHECK_ERROR: 'domMutationCheckError'
};
const $b490f4c20ac5eca9$export$e6589edd1f8a04af = {
    /**
   * Experience was aborted because it was restarted while already in progress
   */ RESTARTED: 'restarted'
};
const $b490f4c20ac5eca9$export$8e85905c8b6efc67 = 0.001;
const $b490f4c20ac5eca9$export$b110169935468339 = {
    ASYNC_OPERATION: 'asyncOperation',
    MENU_ACTION: 'menuAction',
    MENU_OPEN: 'menuOpen',
    TOOLBAR_ACTION: 'toolbarAction',
    TOOLBAR_OPEN: 'toolbarOpen'
};

});

parcelRegister("b8RGE", function(module, exports) {
$parcel$export(module.exports, "Experience", () => $bf043ae8b29fa58c$export$c90b54e658fc4d7c);

var $4ZEck = parcelRequire("4ZEck");

var $g6Qq4 = parcelRequire("g6Qq4");

var $bApp6 = parcelRequire("bApp6");

var $2Nh1s = parcelRequire("2Nh1s");

var $26hnq = parcelRequire("26hnq");
class $bf043ae8b29fa58c$export$c90b54e658fc4d7c {
    /**
   * Creates a new Experience instance for tracking user experiences.
   *
   * @param id - Unique identifier for the experience e.g. 'toolbarOpen' 'menuAction'
   * @param options - Configuration options for the experience
   * @param options.checks - Experience checks to monitor for completion
   * @param options.dispatchAnalyticsEvent - Function to dispatch analytics events
   * @param options.sampleRate - Sample rate for experienceSampled events
   * @param options.metadata - Global metadata to attach to all events
   * @param options.action - Optional sub identifier for the specific experience action e.g. 'bold' 'insertTable'
   * @param options.actionSubjectId - Optional sub identifier for the experience action subject e.g. 'selectionToolbar' 'quickInsert'
   */ constructor(id, options){
        this.currentState = 'pending';
        /**
   * Set of experience states that have been seen in the current session.
   *
   * Used to determine if experienceStatusFirstSeen flag should be set in events.
   */ this.statesSeen = new Set();
        this.id = id;
        this.actionSubjectId = options.actionSubjectId;
        this.dispatchAnalyticsEvent = options.dispatchAnalyticsEvent;
        this.sampleRate = options.sampleRate ?? (0, $bApp6.DEFAULT_EXPERIENCE_SAMPLE_RATE);
        this.globalMetadata = {
            ...options.metadata,
            experienceAction: options.action
        };
        this.check = new (0, $26hnq.ExperienceCheckComposite)(options.checks || []);
    }
    startCheck() {
        this.stopCheck();
        this.check.start(({ status: status, reason: reason, metadata: metadata })=>{
            if (status === 'success') this.success({
                reason: reason,
                metadata: metadata
            });
            else if (status === 'abort') this.abort({
                reason: reason,
                metadata: metadata
            });
            else if (status === 'failure') this.failure({
                reason: reason,
                metadata: metadata
            });
        });
    }
    stopCheck() {
        this.check.stop();
    }
    getEndStateMetadata(options = {}) {
        const metadata = {
            ...options.metadata
        };
        if (options.reason) metadata.experienceEndReason = options.reason;
        return metadata;
    }
    /**
   * Transitions to a new experience state and tracks analytics events.
   *
   * Upon transition to each state, two events are tracked:
   * - experienceMeasured: tracked on every successful transition, used for data analysis
   * - experienceSampled: tracked only on 1 out of every N transitions based on sample rate
   *
   * @param toState - The target state to transition to
   * @param metadata - Optional metadata to attach to the analytics events
   * @returns true if transition was successful, false if invalid transition
   */ transitionTo(toState, metadata) {
        if (!(0, $2Nh1s.canTransition)(this.currentState, toState)) return false;
        this.currentState = toState;
        if (toState === 'started') {
            this.isSampledTrackingEnabled = Math.random() < this.sampleRate;
            this.startTimeMs = Date.now();
            this.startMetadata = metadata;
        }
        this.trackTransition(toState, metadata);
        if (toState === 'started') this.startCheck();
        else {
            this.stopCheck();
            this.startMetadata = undefined;
        }
        this.statesSeen.add(toState);
        return true;
    }
    /**
   * Tracks analytics events for a state transition.
   *
   * Fires both experienceMeasured (always) and experienceSampled (sampled) events.
   *
   * @param toState - The state that was transitioned to
   * @param metadata - Metadata to include in the event, including firstInSession flag
   */ trackTransition(toState, metadata) {
        const attributes = {
            experienceKey: this.id,
            experienceStatus: toState,
            experienceStatusFirstSeen: !this.statesSeen.has(toState),
            experienceStartTime: this.startTimeMs || 0,
            experienceDuration: this.startTimeMs ? Date.now() - this.startTimeMs : 0,
            ...this.globalMetadata,
            ...this.startMetadata,
            ...metadata
        };
        const experienceMeasuredEvent = {
            action: (0, $g6Qq4.ACTION).EXPERIENCE_MEASURED,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).EDITOR,
            actionSubjectId: this.actionSubjectId,
            eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL,
            attributes: attributes
        };
        this.dispatchAnalyticsEvent(experienceMeasuredEvent);
        if (this.isSampledTrackingEnabled) {
            const experienceSampledEvent = {
                action: (0, $g6Qq4.ACTION).EXPERIENCE_SAMPLED,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).EDITOR,
                actionSubjectId: this.actionSubjectId,
                eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL,
                attributes: (0, $4ZEck.dynamicConfigBooleanValue)('duplicate_actionsubjectid_to_attributes') ? {
                    ...attributes,
                    actionSubjectId: this.actionSubjectId
                } : attributes
            };
            this.dispatchAnalyticsEvent(experienceSampledEvent);
        }
    }
    /**
   * Starts tracking the experience and all checks which monitor for completion.
   *
   * Metadata from options will be merged with metadata provided in subsequent events.
   *
   * @param options - Configuration for starting the experience
   * @param options.metadata - Optional custom metadata attached to all subsequent events for this started experience
   * @param options.forceRestart - If true and experience already in progress will abort and restart
   * @param options.method - Optional method for experience start, e.g., how the experience was initiated
   */ start(options = {}) {
        if (options.forceRestart && this.currentState === 'started') this.abort({
            reason: (0, $bApp6.EXPERIENCE_ABORT_REASON).RESTARTED
        });
        return this.transitionTo('started', {
            experienceStartMethod: options.method,
            ...options.metadata
        });
    }
    /**
   * Marks the experience as successful and stops any ongoing checks.
   *
   * @param options - Configuration for the success event
   * @param options.metadata - Optional custom metadata attached to the success event
   * @param options.reason - Optional reason for success
   * @returns false if transition to success state was not valid
   */ success(options = {}) {
        const metadata = this.getEndStateMetadata(options);
        return this.transitionTo('succeeded', metadata);
    }
    /**
   * Aborts the experience and stops any ongoing checks.
   *
   * Use this when a started experience terminates early due to user action or context change
   * (e.g., component unmount, navigation). This is neither success nor failure.
   *
   * @param options - Configuration for the abort event
   * @param options.metadata - Optional custom metadata attached to the abort event
   * @param options.reason - Optional reason for abort
   *
   * @example
   * // Abort on component unmount
   * useEffect(() => {
   *   return () => experience.abort({ reason: 'unmount', metadata: { someKey: 'someValue' } });
   * }, []);
   *
   * @returns false if transition to aborted state was not valid
   */ abort(options = {}) {
        const metadata = this.getEndStateMetadata(options);
        return this.transitionTo('aborted', metadata);
    }
    /**
   * Manually marks the experience as failed and stops any ongoing checks.
   *
   * Use this for actual failures in the experience flow (e.g., timeout, error conditions).
   *
   * @param options - Configuration for the failure event
   * @param options.metadata - Optional custom metadata attached to the failure event
   * @param options.reason - Optional reason for failure
   * @returns false if transition to failed state was not valid
   */ failure(options = {}) {
        const metadata = this.getEndStateMetadata(options);
        return this.transitionTo('failed', metadata);
    }
}

});
parcelRegister("4ZEck", function(module, exports) {
$parcel$export(module.exports, "dynamicConfigBooleanValue", () => $9a66b63f3f257614$export$50c76ae467e0a257);

var $87QgR = parcelRequire("87QgR");
const $9a66b63f3f257614$var$BOOLEAN_CONFIG_KEY = 'value';
function $9a66b63f3f257614$export$50c76ae467e0a257(configName, defaultValue = false) {
    if (!(0, $87QgR.default).initializeCompleted()) return defaultValue;
    try {
        // Dynamic configs are exposed through the same client surface as experiments.
        // eslint-disable-next-line @atlaskit/platform/use-recommended-utils
        const config = (0, $87QgR.default).getExperiment(configName);
        const candidate = config.value[$9a66b63f3f257614$var$BOOLEAN_CONFIG_KEY];
        if (typeof candidate !== 'boolean') return defaultValue;
        return candidate;
    } catch  {
        return defaultValue;
    }
}

});

parcelRegister("2Nh1s", function(module, exports) {
$parcel$export(module.exports, "canTransition", () => $92b5ec9c5138c0e3$export$178881f329fdb81f);

var $bjeSw = parcelRequire("bjeSw");
const $92b5ec9c5138c0e3$export$178881f329fdb81f = (fromState, toState)=>{
    var _EXPERIENCE_STATE_TRA;
    return ((_EXPERIENCE_STATE_TRA = (0, $bjeSw.EXPERIENCE_STATE_TRANSITIONS)[fromState]) === null || _EXPERIENCE_STATE_TRA === void 0 ? void 0 : _EXPERIENCE_STATE_TRA.includes(toState)) ?? false;
};

});
parcelRegister("bjeSw", function(module, exports) {
$parcel$export(module.exports, "EXPERIENCE_STATE_TRANSITIONS", () => $b2e6dd67084c868f$export$180fe852598a23ab);
const $b2e6dd67084c868f$export$180fe852598a23ab = {
    pending: [
        'started'
    ],
    started: [
        'aborted',
        'failed',
        'succeeded'
    ],
    aborted: [
        'started'
    ],
    failed: [
        'started'
    ],
    succeeded: [
        'started'
    ]
};

});


parcelRegister("26hnq", function(module, exports) {
$parcel$export(module.exports, "ExperienceCheckComposite", () => $b2de488d31bf1ec2$export$fa331fd384051f6a);
class $b2de488d31bf1ec2$export$fa331fd384051f6a {
    constructor(checks){
        this.checks = checks;
    }
    start(callback) {
        this.checks.forEach((check)=>check.start(callback));
    }
    stop() {
        this.checks.forEach((check)=>check.stop());
    }
}

});


parcelRegister("73iZo", function(module, exports) {
$parcel$export(module.exports, "ExperienceCheckDomMutation", () => $c98e70cfcd067294$export$e76932dc77daa06a);

var $bApp6 = parcelRequire("bApp6");
class $c98e70cfcd067294$export$e76932dc77daa06a {
    constructor({ onDomMutation: onDomMutation, observeConfig: observeConfig }){
        this.onDomMutation = onDomMutation;
        this.observeConfig = observeConfig;
    }
    start(callback) {
        this.stop();
        const configResult = this.observeConfig();
        const configs = Array.isArray(configResult) ? configResult : [
            configResult
        ];
        const validConfigs = configs.filter((config)=>!!(config !== null && config !== void 0 && config.target));
        if (validConfigs.length === 0) {
            callback({
                status: 'failure',
                reason: (0, $bApp6.EXPERIENCE_FAILURE_REASON).DOM_MUTATION_TARGET_NOT_FOUND
            });
            return;
        }
        this.mutationObserver = new MutationObserver((mutations)=>{
            try {
                const result = this.onDomMutation({
                    mutations: mutations
                });
                if (result) callback(result);
            } catch  {
                callback({
                    status: 'failure',
                    reason: (0, $bApp6.EXPERIENCE_FAILURE_REASON).DOM_MUTATION_CHECK_ERROR
                });
            }
        });
        for (const config of validConfigs){
            const { target: target, options: options } = config;
            if (target) this.mutationObserver.observe(target, options ?? {
                childList: true
            });
        }
    }
    stop() {
        if (this.mutationObserver) {
            this.mutationObserver.disconnect();
            this.mutationObserver = undefined;
        }
    }
}

});

parcelRegister("1EaP8", function(module, exports) {
$parcel$export(module.exports, "ExperienceCheckPopupMutation", () => $0ccd7aacda1c9361$export$10f7d66405927699);

var $c9wRy = parcelRequire("c9wRy");

var $bApp6 = parcelRequire("bApp6");

var $6kZ0x = parcelRequire("6kZ0x");
const $0ccd7aacda1c9361$var$PORTAL_CONTAINER_SELECTOR = 'body > .atlaskit-portal-container';
class $0ccd7aacda1c9361$export$10f7d66405927699 {
    constructor(config){
        this.observers = [];
        this.config = config;
    }
    /**
   * Returns the list of DOM elements to observe based on popup type.
   */ getObserveTargets() {
        const { config: config } = this;
        switch(config.type){
            case 'inline':
                return this.getInlineTargets(config);
            case 'editorRoot':
                return this.getEditorRootTargets(config);
            case 'editorContent':
                return this.getEditorContentTargets(config);
            case 'portalRoot':
                return this.getPortalRootTargets();
        }
    }
    /**
   * For 'portalRoot' type: observe .atlaskit-portal-container.
   * Popups like flags and modals render in body > .atlaskit-portal-container.
   */ getPortalRootTargets() {
        var _getDocument;
        const portalContainer = (_getDocument = (0, $c9wRy.getDocument)()) === null || _getDocument === void 0 ? void 0 : _getDocument.querySelector($0ccd7aacda1c9361$var$PORTAL_CONTAINER_SELECTOR);
        return portalContainer ? [
            portalContainer
        ] : [];
    }
    /**
   * For 'editorContent' type: observe the target (mount point) and any existing
   * [data-editor-popup] wrappers within it. Content-level popups and modals
   * appear in portal containers.
   */ getEditorContentTargets(config) {
        const target = config.getTarget();
        if (!target) return [];
        const targets = [
            target
        ];
        const wrappers = target.querySelectorAll('[data-editor-popup]');
        for (const wrapper of wrappers)targets.push(wrapper);
        return targets;
    }
    /**
   * For 'inline' type: observe the target element directly.
   * The caller is responsible for resolving the correct container
   * (e.g. the toolbar button-group) via the getTarget function.
   */ getInlineTargets(config) {
        const target = config.getTarget();
        if (!target) return [];
        return [
            target
        ];
    }
    /**
   * For 'editorRoot' type: observe the actual editor root container.
   * The editorDom is the ProseMirror element, but popups appear as direct children
   * of the parent .akEditor container. So we observe the parent of editorDom.
   */ getEditorRootTargets(config) {
        const targets = [];
        const editorDom = config.getEditorDom();
        if (editorDom) {
            const editorRoot = editorDom.closest('.akEditor') || editorDom.parentElement;
            if (editorRoot instanceof HTMLElement) targets.push(editorRoot);
        }
        return targets;
    }
    start(callback) {
        const doc = (0, $c9wRy.getDocument)();
        const observeTargets = this.getObserveTargets();
        if (!doc || !observeTargets.length) {
            callback({
                status: 'failure',
                reason: (0, $bApp6.EXPERIENCE_FAILURE_REASON).DOM_MUTATION_TARGET_NOT_FOUND
            });
            return;
        }
        const query = this.config.nestedElementQuery;
        const subtree = this.config.type === 'inline' && this.config.subtree === true;
        const observe = (el)=>{
            const observer = new MutationObserver(onMutation);
            observer.observe(el, {
                childList: true,
                subtree: subtree
            });
            this.observers.push(observer);
        };
        const onMutation = (mutations)=>{
            const found = mutations.some(({ type: type, addedNodes: addedNodes })=>type === 'childList' && [
                    ...addedNodes
                ].some((node)=>node instanceof HTMLElement && ((0, $6kZ0x.popupWithNestedElement)(node, query) || node.matches(query) || node.querySelector(query) !== null)));
            if (found) {
                callback({
                    status: 'success'
                });
                return;
            }
        };
        for (const observeTarget of observeTargets)observe(observeTarget);
    }
    stop() {
        for (const observer of this.observers)observer.disconnect();
        this.observers = [];
    }
}

});
parcelRegister("6kZ0x", function(module, exports) {
$parcel$export(module.exports, "popupWithNestedElement", () => $d69488c9d6d31ca1$export$8a7378047752ffb6);
/**
 * Returns the popup with a nested element identified by a specific test ID if it exists.
 *
 * @param node - The node to check.
 * @param nestedElementQuery - The query to look for the nested element.
 * @returns Element if the node contains the popup, undefined otherwise.
 */ const $d69488c9d6d31ca1$export$8a7378047752ffb6 = (node, nestedElementQuery)=>{
    if (!(node instanceof HTMLElement)) return undefined;
    // Check if node itself has the popup attribute and contains the element matching the nestedElementQuery
    if (node.matches('[data-editor-popup="true"]')) return node.querySelector(nestedElementQuery);
    // Check if any direct child with popup attribute contains the element matching the nestedElementQuery
    return node.querySelector(`:scope > [data-editor-popup="true"] ${nestedElementQuery}`);
};

});


parcelRegister("9skTL", function(module, exports) {
$parcel$export(module.exports, "ExperienceCheckTimeout", () => $148cdb105ae42439$export$1a6fa509d14ac50);

var $bApp6 = parcelRequire("bApp6");
const $148cdb105ae42439$var$DEFAULT_FAILURE_RESULT = {
    status: 'failure',
    reason: (0, $bApp6.EXPERIENCE_FAILURE_REASON).TIMEOUT
};
class $148cdb105ae42439$export$1a6fa509d14ac50 {
    constructor({ durationMs: durationMs, onTimeout: onTimeout = ()=>$148cdb105ae42439$var$DEFAULT_FAILURE_RESULT }){
        this.durationMs = 0;
        this.durationMs = durationMs;
        this.onTimeout = onTimeout;
    }
    start(callback) {
        this.stop();
        this.timeoutId = setTimeout(()=>{
            const result = this.onTimeout() || $148cdb105ae42439$var$DEFAULT_FAILURE_RESULT;
            callback(result);
        }, this.durationMs);
    }
    stop() {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
            this.timeoutId = undefined;
        }
    }
}

});

parcelRegister("kYtnk", function(module, exports) {
$parcel$export(module.exports, "isToolbarButtonClick", () => $8332ea1c0fcafd03$export$34c38be5e72a33bf);
$parcel$export(module.exports, "handleEditorNodeInsertDomMutation", () => $8332ea1c0fcafd03$export$b8034202af77aa76);
const $8332ea1c0fcafd03$export$812255e19597c431 = {
    TABLE: '.tableView-content-wrap',
    LAYOUT: '.layoutSectionView-content-wrap',
    LAYOUT_COLUMN: '.layoutColumnView-content-wrap',
    TASK_LIST: '[data-node-type="actionList"]',
    TASK_ITEM: '.taskItemView-content-wrap'
};
const $8332ea1c0fcafd03$var$COMBINED_NODE_INSERT_SELECTOR = [
    $8332ea1c0fcafd03$export$812255e19597c431.TABLE,
    $8332ea1c0fcafd03$export$812255e19597c431.LAYOUT,
    $8332ea1c0fcafd03$export$812255e19597c431.LAYOUT_COLUMN,
    $8332ea1c0fcafd03$export$812255e19597c431.TASK_LIST,
    $8332ea1c0fcafd03$export$812255e19597c431.TASK_ITEM
].join(', ');
const $8332ea1c0fcafd03$export$34c38be5e72a33bf = (target, testId)=>{
    const button = target.closest(`button[data-testid="${testId}"]`);
    if (!button) return false;
    return !button.disabled && button.getAttribute('aria-disabled') !== 'true';
};
/**
 * Checks whether a DOM node matches any known node insert marker,
 * either directly or via a nested element (e.g. breakout mark wrapper).
 */ const $8332ea1c0fcafd03$var$matchesNodeInsertMarker = (node)=>{
    if (!(node instanceof HTMLElement)) return false;
    return node.matches($8332ea1c0fcafd03$var$COMBINED_NODE_INSERT_SELECTOR) || !!node.querySelector($8332ea1c0fcafd03$var$COMBINED_NODE_INSERT_SELECTOR);
};
const $8332ea1c0fcafd03$export$b8034202af77aa76 = ({ mutations: mutations })=>{
    let hasAddedElement = false;
    for (const mutation of mutations){
        if (mutation.type !== 'childList') continue;
        for (const node of mutation.addedNodes){
            if ($8332ea1c0fcafd03$var$matchesNodeInsertMarker(node)) return {
                status: 'success'
            };
            if (node instanceof HTMLElement) hasAddedElement = true;
        }
    }
    if (hasAddedElement) return {
        status: 'success'
    };
    return undefined;
};

});


parcelRegister("SOqL6", function(module, exports) {
$parcel$export(module.exports, "toggleInsertBlockPmKey", () => $deffbb9f1a92dfb7$export$fef912314604ae84);
$parcel$export(module.exports, "toggleInsertBlockPmPlugin", () => $deffbb9f1a92dfb7$export$6f80226cf0aae60e);

var $f7Kk4 = parcelRequire("f7Kk4");

var $cw0wu = parcelRequire("cw0wu");
const $deffbb9f1a92dfb7$export$fef912314604ae84 = new (0, $cw0wu.PluginKey)('toggleInsertBlockPmKey');
const $deffbb9f1a92dfb7$export$6f80226cf0aae60e = ()=>new (0, $f7Kk4.SafePlugin)({
        key: $deffbb9f1a92dfb7$export$fef912314604ae84,
        state: {
            init () {
                return {
                    showElementBrowser: false
                };
            },
            apply (tr, pluginState) {
                const meta = tr.getMeta($deffbb9f1a92dfb7$export$fef912314604ae84);
                if (!meta) return pluginState;
                return {
                    showElementBrowser: !pluginState.showElementBrowser
                };
            }
        }
    });

});

parcelRegister("9sxpZ", function(module, exports) {
$parcel$export(module.exports, "getToolbarComponents", () => $f7d2b63163623b6f$export$a758406ca53b86a5);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $4rzOL = parcelRequire("4rzOL");

var $fiku8 = parcelRequire("fiku8");

var $f6IUb = parcelRequire("f6IUb");

var $5gDEv = parcelRequire("5gDEv");

var $3y2s4 = parcelRequire("3y2s4");

var $fqeMn = parcelRequire("fqeMn");

var $hhBlT = parcelRequire("hhBlT");

var $k2pNP = parcelRequire("k2pNP");

var $2tCEh = parcelRequire("2tCEh");

var $gbYcG = parcelRequire("gbYcG");

var $2RgL0 = parcelRequire("2RgL0");

var $jdyej = parcelRequire("jdyej");

var $iXlu8 = parcelRequire("iXlu8");

var $iZa2a = parcelRequire("iZa2a");

var $fnO7j = parcelRequire("fnO7j");

var $gLaFJ = parcelRequire("gLaFJ");

var $hgqQ6 = parcelRequire("hgqQ6");
const $f7d2b63163623b6f$export$a758406ca53b86a5 = ({ api: api, options: options, onInsertBlockType: onInsertBlockType })=>{
    var _config$taskList, _config$media, _config$codeBlock, _config$mention, _config$emoji, _config$layout, _config$table, _config$insert;
    const config = (0, $k2pNP.resolveToolbarConfig)(options);
    const components = [];
    // Helper function to create responsive wrapper component
    const createResponsiveComponent = (showAt)=>{
        return ({ children: children })=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $f6IUb.Show), {
                above: showAt || 'lg',
                children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $5gDEv.ToolbarButtonGroup), {
                    children: children
                })
            });
    };
    // TaskList Group
    if ((_config$taskList = config.taskList) !== null && _config$taskList !== void 0 && _config$taskList.enabled) {
        var _config$taskList2;
        components.push({
            type: (0, $4rzOL.TASK_LIST_GROUP).type,
            key: (0, $4rzOL.TASK_LIST_GROUP).key,
            parents: [
                {
                    type: (0, $4rzOL.INSERT_BLOCK_SECTION).type,
                    key: (0, $4rzOL.INSERT_BLOCK_SECTION).key,
                    rank: (0, $fiku8.INSERT_BLOCK_SECTION_RANK)[(0, $4rzOL.TASK_LIST_GROUP).key]
                }
            ],
            component: createResponsiveComponent((_config$taskList2 = config.taskList) === null || _config$taskList2 === void 0 ? void 0 : _config$taskList2.showAt)
        });
        components.push({
            type: (0, $4rzOL.TASK_LIST_BUTTON).type,
            key: (0, $4rzOL.TASK_LIST_BUTTON).key,
            parents: [
                {
                    type: (0, $4rzOL.TASK_LIST_GROUP).type,
                    key: (0, $4rzOL.TASK_LIST_GROUP).key,
                    rank: (0, $fiku8.TASK_LIST_GROUP_RANK)[(0, $4rzOL.TASK_LIST_BUTTON).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $hgqQ6.TaskListButton), {
                    api: api
                })
        });
    }
    // Media Group
    if ((_config$media = config.media) !== null && _config$media !== void 0 && _config$media.enabled) {
        var _config$media2;
        components.push({
            type: (0, $4rzOL.MEDIA_GROUP).type,
            key: (0, $4rzOL.MEDIA_GROUP).key,
            parents: [
                {
                    type: (0, $4rzOL.INSERT_BLOCK_SECTION).type,
                    key: (0, $4rzOL.INSERT_BLOCK_SECTION).key,
                    rank: (0, $fiku8.INSERT_BLOCK_SECTION_RANK)[(0, $4rzOL.MEDIA_GROUP).key]
                }
            ],
            component: createResponsiveComponent((_config$media2 = config.media) === null || _config$media2 === void 0 ? void 0 : _config$media2.showAt)
        });
        components.push({
            type: (0, $4rzOL.MEDIA_BUTTON).type,
            key: (0, $4rzOL.MEDIA_BUTTON).key,
            parents: [
                {
                    type: (0, $4rzOL.MEDIA_GROUP).type,
                    key: (0, $4rzOL.MEDIA_GROUP).key,
                    rank: (0, $fiku8.MEDIA_GROUP_RANK)[(0, $4rzOL.MEDIA_BUTTON).key]
                }
            ],
            component: ()=>!!(api !== null && api !== void 0 && api.imageUpload) ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $gbYcG.ImageButton), {
                    api: api
                }) : /*#__PURE__*/ (0, $dc70d.jsx)((0, $iXlu8.MediaButton), {
                    api: api
                })
        });
    }
    // CodeBlock Group
    if ((_config$codeBlock = config.codeBlock) !== null && _config$codeBlock !== void 0 && _config$codeBlock.enabled) {
        var _config$codeBlock2;
        components.push({
            type: (0, $4rzOL.CODE_BLOCK_GROUP).type,
            key: (0, $4rzOL.CODE_BLOCK_GROUP).key,
            parents: [
                {
                    type: (0, $4rzOL.INSERT_BLOCK_SECTION).type,
                    key: (0, $4rzOL.INSERT_BLOCK_SECTION).key,
                    rank: (0, $fiku8.INSERT_BLOCK_SECTION_RANK)[(0, $4rzOL.CODE_BLOCK_GROUP).key]
                }
            ],
            component: createResponsiveComponent((_config$codeBlock2 = config.codeBlock) === null || _config$codeBlock2 === void 0 ? void 0 : _config$codeBlock2.showAt)
        });
        components.push({
            type: (0, $4rzOL.CODE_BLOCK_BUTTON).type,
            key: (0, $4rzOL.CODE_BLOCK_BUTTON).key,
            parents: [
                {
                    type: (0, $4rzOL.CODE_BLOCK_GROUP).type,
                    key: (0, $4rzOL.CODE_BLOCK_GROUP).key,
                    rank: (0, $fiku8.CODE_BLOCK_GROUP_RANK)[(0, $4rzOL.CODE_BLOCK_BUTTON).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $hhBlT.CodeBlockButton), {
                    api: api
                })
        });
    }
    // Mention Group
    if ((_config$mention = config.mention) !== null && _config$mention !== void 0 && _config$mention.enabled) {
        components.push({
            type: (0, $4rzOL.MENTION_GROUP).type,
            key: (0, $4rzOL.MENTION_GROUP).key,
            parents: [
                {
                    type: (0, $4rzOL.INSERT_BLOCK_SECTION).type,
                    key: (0, $4rzOL.INSERT_BLOCK_SECTION).key,
                    rank: (0, $fiku8.INSERT_BLOCK_SECTION_RANK)[(0, $4rzOL.MENTION_GROUP).key]
                }
            ],
            component: createResponsiveComponent(config.mention.showAt)
        });
        components.push({
            type: (0, $4rzOL.MENTION_BUTTON).type,
            key: (0, $4rzOL.MENTION_BUTTON).key,
            parents: [
                {
                    type: (0, $4rzOL.MENTION_GROUP).type,
                    key: (0, $4rzOL.MENTION_GROUP).key,
                    rank: (0, $fiku8.MENTION_GROUP_RANK)[(0, $4rzOL.MENTION_BUTTON).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $iZa2a.MentionButton), {
                    api: api
                })
        });
    }
    // Emoji Group
    if ((_config$emoji = config.emoji) !== null && _config$emoji !== void 0 && _config$emoji.enabled) {
        components.push({
            type: (0, $4rzOL.EMOJI_GROUP).type,
            key: (0, $4rzOL.EMOJI_GROUP).key,
            parents: [
                {
                    type: (0, $4rzOL.INSERT_BLOCK_SECTION).type,
                    key: (0, $4rzOL.INSERT_BLOCK_SECTION).key,
                    rank: (0, $fiku8.INSERT_BLOCK_SECTION_RANK)[(0, $4rzOL.EMOJI_GROUP).key]
                }
            ],
            component: createResponsiveComponent(config.emoji.showAt)
        });
        components.push({
            type: (0, $4rzOL.EMOJI_BUTTON).type,
            key: (0, $4rzOL.EMOJI_BUTTON).key,
            parents: [
                {
                    type: (0, $4rzOL.EMOJI_GROUP).type,
                    key: (0, $4rzOL.EMOJI_GROUP).key,
                    rank: (0, $fiku8.EMOJI_GROUP_RANK)[(0, $4rzOL.EMOJI_BUTTON).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $2tCEh.EmojiButton), {
                    api: api
                })
        });
    }
    // Layout Group
    if ((_config$layout = config.layout) !== null && _config$layout !== void 0 && _config$layout.enabled) {
        components.push({
            type: (0, $4rzOL.LAYOUT_GROUP).type,
            key: (0, $4rzOL.LAYOUT_GROUP).key,
            parents: [
                {
                    type: (0, $4rzOL.INSERT_BLOCK_SECTION).type,
                    key: (0, $4rzOL.INSERT_BLOCK_SECTION).key,
                    rank: (0, $fiku8.INSERT_BLOCK_SECTION_RANK)[(0, $4rzOL.LAYOUT_GROUP).key]
                }
            ],
            component: createResponsiveComponent(config.layout.showAt)
        });
        components.push({
            type: (0, $4rzOL.LAYOUT_BUTTON).type,
            key: (0, $4rzOL.LAYOUT_BUTTON).key,
            parents: [
                {
                    type: (0, $4rzOL.LAYOUT_GROUP).type,
                    key: (0, $4rzOL.LAYOUT_GROUP).key,
                    rank: (0, $fiku8.LAYOUT_GROUP_RANK)[(0, $4rzOL.LAYOUT_BUTTON).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $jdyej.LayoutButton), {
                    api: api
                })
        });
    }
    // Table Group
    if ((_config$table = config.table) !== null && _config$table !== void 0 && _config$table.enabled) {
        components.push({
            type: (0, $4rzOL.TABLE_GROUP).type,
            key: (0, $4rzOL.TABLE_GROUP).key,
            parents: [
                {
                    type: (0, $4rzOL.INSERT_BLOCK_SECTION).type,
                    key: (0, $4rzOL.INSERT_BLOCK_SECTION).key,
                    rank: (0, $fiku8.INSERT_BLOCK_SECTION_RANK)[(0, $4rzOL.TABLE_GROUP).key]
                }
            ],
            component: createResponsiveComponent(config.table.showAt)
        });
        components.push({
            type: (0, $4rzOL.TABLE_BUTTON).type,
            key: (0, $4rzOL.TABLE_BUTTON).key,
            parents: [
                {
                    type: (0, $4rzOL.TABLE_GROUP).type,
                    key: (0, $4rzOL.TABLE_GROUP).key,
                    rank: (0, $fiku8.TABLE_GROUP_RANK)[(0, $4rzOL.TABLE_BUTTON).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $fnO7j.TableButton), {
                    api: api
                })
        });
        if (options.tableSelectorSupported) components.push({
            type: (0, $4rzOL.TABLE_SIZE_PICKER).type,
            key: (0, $4rzOL.TABLE_SIZE_PICKER).key,
            parents: [
                {
                    type: (0, $4rzOL.TABLE_GROUP).type,
                    key: (0, $4rzOL.TABLE_GROUP).key,
                    rank: (0, $fiku8.TABLE_GROUP_RANK)[(0, $4rzOL.TABLE_SIZE_PICKER).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $gLaFJ.TableSizePicker), {
                    api: api,
                    tableSelectorSupported: options.tableSelectorSupported
                })
        });
    }
    // Insert Group
    if ((_config$insert = config.insert) !== null && _config$insert !== void 0 && _config$insert.enabled) {
        const createInsertButtonComponent = (breakpoint)=>{
            return ()=>(0, $3y2s4.isExperimentEnabled)('platform_editor_slash_command') ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $fqeMn.RegisteredInsertButton), {
                    api: api
                }) : /*#__PURE__*/ (0, $dc70d.jsx)((0, $2RgL0.InsertButton), {
                    api: api,
                    breakpoint: breakpoint,
                    toolbarConfig: config,
                    showElementBrowserLink: options.showElementBrowserLink,
                    tableSelectorSupported: options.tableSelectorSupported,
                    onInsertBlockType: onInsertBlockType,
                    nativeStatusSupported: options.nativeStatusSupported,
                    horizontalRuleEnabled: options.horizontalRuleEnabled,
                    expandEnabled: options.allowExpand,
                    insertMenuItems: options.insertMenuItems,
                    itemFilter: options.itemFilter,
                    numberOfButtons: 0
                });
        };
        components.push({
            type: (0, $4rzOL.INSERT_GROUP).type,
            key: `${(0, $4rzOL.INSERT_GROUP).key}-none`,
            parents: [
                {
                    type: (0, $4rzOL.INSERT_BLOCK_SECTION).type,
                    key: (0, $4rzOL.INSERT_BLOCK_SECTION).key,
                    rank: (0, $fiku8.INSERT_BLOCK_SECTION_RANK)[(0, $4rzOL.INSERT_GROUP).key]
                }
            ],
            component: ({ children: children })=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $f6IUb.Show), {
                    below: "sm",
                    children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $5gDEv.ToolbarButtonGroup), {
                        children: children
                    })
                })
        });
        components.push({
            type: (0, $4rzOL.INSERT_BUTTON).type,
            key: (0, $4rzOL.INSERT_BUTTON).key,
            parents: [
                {
                    type: (0, $4rzOL.INSERT_GROUP).type,
                    key: `${(0, $4rzOL.INSERT_GROUP).key}-none`,
                    rank: (0, $fiku8.INSERT_GROUP_RANK)[(0, $4rzOL.INSERT_BUTTON).key]
                }
            ],
            component: createInsertButtonComponent(null)
        });
        components.push({
            type: (0, $4rzOL.INSERT_GROUP).type,
            key: `${(0, $4rzOL.INSERT_GROUP).key}-sm`,
            parents: [
                {
                    type: (0, $4rzOL.INSERT_BLOCK_SECTION).type,
                    key: (0, $4rzOL.INSERT_BLOCK_SECTION).key,
                    rank: (0, $fiku8.INSERT_BLOCK_SECTION_RANK)[(0, $4rzOL.INSERT_GROUP).key]
                }
            ],
            component: ({ children: children })=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $f6IUb.Show), {
                    only: "sm",
                    children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $5gDEv.ToolbarButtonGroup), {
                        children: children
                    })
                })
        });
        components.push({
            type: (0, $4rzOL.INSERT_BUTTON).type,
            key: (0, $4rzOL.INSERT_BUTTON).key,
            parents: [
                {
                    type: (0, $4rzOL.INSERT_GROUP).type,
                    key: `${(0, $4rzOL.INSERT_GROUP).key}-sm`,
                    rank: (0, $fiku8.INSERT_GROUP_RANK)[(0, $4rzOL.INSERT_BUTTON).key]
                }
            ],
            component: createInsertButtonComponent('sm')
        });
        components.push({
            type: (0, $4rzOL.INSERT_GROUP).type,
            key: `${(0, $4rzOL.INSERT_GROUP).key}-md`,
            parents: [
                {
                    type: (0, $4rzOL.INSERT_BLOCK_SECTION).type,
                    key: (0, $4rzOL.INSERT_BLOCK_SECTION).key,
                    rank: (0, $fiku8.INSERT_BLOCK_SECTION_RANK)[(0, $4rzOL.INSERT_GROUP).key]
                }
            ],
            component: ({ children: children })=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $f6IUb.Show), {
                    only: "md",
                    children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $5gDEv.ToolbarButtonGroup), {
                        children: children
                    })
                })
        });
        components.push({
            type: (0, $4rzOL.INSERT_BUTTON).type,
            key: (0, $4rzOL.INSERT_BUTTON).key,
            parents: [
                {
                    type: (0, $4rzOL.INSERT_GROUP).type,
                    key: `${(0, $4rzOL.INSERT_GROUP).key}-md`,
                    rank: (0, $fiku8.INSERT_GROUP_RANK)[(0, $4rzOL.INSERT_BUTTON).key]
                }
            ],
            component: createInsertButtonComponent('md')
        });
        components.push({
            type: (0, $4rzOL.INSERT_GROUP).type,
            key: `${(0, $4rzOL.INSERT_GROUP).key}-lg`,
            parents: [
                {
                    type: (0, $4rzOL.INSERT_BLOCK_SECTION).type,
                    key: (0, $4rzOL.INSERT_BLOCK_SECTION).key,
                    rank: (0, $fiku8.INSERT_BLOCK_SECTION_RANK)[(0, $4rzOL.INSERT_GROUP).key]
                }
            ],
            component: ({ children: children })=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $f6IUb.Show), {
                    only: "lg",
                    children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $5gDEv.ToolbarButtonGroup), {
                        children: children
                    })
                })
        });
        components.push({
            type: (0, $4rzOL.INSERT_BUTTON).type,
            key: (0, $4rzOL.INSERT_BUTTON).key,
            parents: [
                {
                    type: (0, $4rzOL.INSERT_GROUP).type,
                    key: `${(0, $4rzOL.INSERT_GROUP).key}-lg`,
                    rank: (0, $fiku8.INSERT_GROUP_RANK)[(0, $4rzOL.INSERT_BUTTON).key]
                }
            ],
            component: createInsertButtonComponent('lg')
        });
        components.push({
            type: (0, $4rzOL.INSERT_GROUP).type,
            key: `${(0, $4rzOL.INSERT_GROUP).key}-xl`,
            parents: [
                {
                    type: (0, $4rzOL.INSERT_BLOCK_SECTION).type,
                    key: (0, $4rzOL.INSERT_BLOCK_SECTION).key,
                    rank: (0, $fiku8.INSERT_BLOCK_SECTION_RANK)[(0, $4rzOL.INSERT_GROUP).key]
                }
            ],
            component: ({ children: children })=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $f6IUb.Show), {
                    only: "xl",
                    children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $5gDEv.ToolbarButtonGroup), {
                        children: children
                    })
                })
        });
        components.push({
            type: (0, $4rzOL.INSERT_BUTTON).type,
            key: (0, $4rzOL.INSERT_BUTTON).key,
            parents: [
                {
                    type: (0, $4rzOL.INSERT_GROUP).type,
                    key: `${(0, $4rzOL.INSERT_GROUP).key}-xl`,
                    rank: (0, $fiku8.INSERT_GROUP_RANK)[(0, $4rzOL.INSERT_BUTTON).key]
                }
            ],
            component: createInsertButtonComponent('xl')
        });
    }
    return components;
};

});
parcelRegister("f6IUb", function(module, exports) {
$parcel$export(module.exports, "Show", () => $e2f29d65c133f266$export$f6a3d19be20f5819);
/* eslint-disable @atlaskit/ui-styling-standard/no-classname-prop */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");
/**
 * Generate a className based on the breakpoints provided.
 *
 * **Warning** - must much classnames defined in ResponsiveContainer.tsx
 * @param above - The breakpoint to show the element above.
 * @param below - The breakpoint to show the element below.
 * @returns The className to apply to the element.
 */ const $e2f29d65c133f266$var$generateClassName = (above, below, only)=>{
    if (only) return `show-only-${only}`;
    const classes = [];
    if (above) classes.push(`show-above-${above}`);
    if (below) classes.push(`show-below-${below}`);
    return classes.length > 0 ? classes.join(' ') : undefined;
};
const $e2f29d65c133f266$export$f6a3d19be20f5819 = ({ children: children, above: above, below: below, only: only })=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        className: $e2f29d65c133f266$var$generateClassName(above, below, only),
        children: children
    });
};

});

parcelRegister("fqeMn", function(module, exports) {
$parcel$export(module.exports, "RegisteredInsertButton", () => $9a660a5068ececae$export$2ad61b4dff240aa4);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $hVGJk = parcelRequire("hVGJk");

var $cv8id = parcelRequire("cv8id");

var $cW1gB = parcelRequire("cW1gB");

var $5zk80 = parcelRequire("5zk80");

var $e3nP3 = parcelRequire("e3nP3");

var $28qc1 = parcelRequire("28qc1");

var $4rzOL = parcelRequire("4rzOL");

var $5beht = parcelRequire("5beht");

var $5bbjm = parcelRequire("5bbjm");

var $kFWau = parcelRequire("kFWau");

var $7cgYb = parcelRequire("7cgYb");

var $eHnl8 = parcelRequire("eHnl8");

var $aBdvW = parcelRequire("aBdvW");

var $hRynz = parcelRequire("hRynz");
const $9a660a5068ececae$var$DEFAULT_MENU_MAX_HEIGHT = 520;
const $9a660a5068ececae$var$POPUP_OFFSET = [
    0,
    3
];
const $9a660a5068ececae$export$2ad61b4dff240aa4 = ({ api: api })=>{
    const { editorView: editorView } = (0, $28qc1.useEditorToolbar)();
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const { isDisabled: isDisabled, popupsBoundariesElement: popupsBoundariesElement, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement } = (0, $aBdvW.useToolbarUI)();
    const [isOpen, setIsOpen] = (0, $bSJIT.useState)(false);
    const buttonRef = (0, $bSJIT.useRef)(null);
    const menuHeight = (0, $e3nP3.useMenuPopupSizing)({
        target: buttonRef.current,
        boundariesElement: popupsBoundariesElement,
        scrollableElement: popupsScrollableElement,
        maxHeight: $9a660a5068ececae$var$DEFAULT_MENU_MAX_HEIGHT,
        offset: $9a660a5068ececae$var$POPUP_OFFSET[1],
        isOpen: isOpen
    });
    const { connectivityMode: connectivityMode, isAllowed: isAllowed } = (0, $5beht.useSharedPluginStateWithSelector)(api, [
        'connectivity',
        'typeAhead'
    ], (states)=>{
        var _states$connectivityS, _states$typeAheadStat;
        return {
            connectivityMode: (_states$connectivityS = states.connectivityState) === null || _states$connectivityS === void 0 ? void 0 : _states$connectivityS.mode,
            isAllowed: (_states$typeAheadStat = states.typeAheadState) === null || _states$typeAheadStat === void 0 ? void 0 : _states$typeAheadStat.isAllowed
        };
    });
    const close = (0, $bSJIT.useCallback)((restoreFocus = false)=>{
        setIsOpen(false);
        if (restoreFocus) requestAnimationFrame(()=>{
            var _buttonRef$current;
            return (_buttonRef$current = buttonRef.current) === null || _buttonRef$current === void 0 ? void 0 : _buttonRef$current.focus();
        });
    }, []);
    const open = (0, $bSJIT.useCallback)(()=>{
        setIsOpen(true);
    }, []);
    const onPopupUnmount = (0, $bSJIT.useCallback)(()=>{
        // Outside dismissal must not move focus away from the element that was clicked.
        setIsOpen(false);
    }, []);
    const closeAndRestoreFocus = (0, $bSJIT.useCallback)(()=>close(true), [
        close
    ]);
    const closeForSelection = (0, $bSJIT.useCallback)(()=>close(false), [
        close
    ]);
    if (!(api !== null && api !== void 0 && api.insertBlock) || !editorView) return null;
    return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $dc70d.Fragment), {
        children: [
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $eHnl8.ToolbarTooltip), {
                content: /*#__PURE__*/ (0, $dc70d.jsx)((0, $cv8id.ToolTipContent), {
                    description: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).insertMenu),
                    keymap: (0, $cv8id.insertElements)
                }),
                children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $7cgYb.ToolbarButton), {
                    ariaKeyshortcuts: (0, $cv8id.getAriaKeyshortcuts)((0, $cv8id.insertElements)),
                    iconBefore: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kFWau))), {
                        size: "small",
                        label: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).insertMenu)
                    }),
                    isDisabled: !isAllowed || isDisabled,
                    isSelected: isOpen,
                    onClick: isOpen ? ()=>close(true) : open,
                    ref: buttonRef,
                    testId: (0, $4rzOL.TOOLBAR_BUTTON_TEST_ID).INSERT
                })
            }),
            isOpen && buttonRef.current && /*#__PURE__*/ (0, $dc70d.jsx)((0, $5zk80.default), {
                alignX: "right",
                boundariesElement: popupsBoundariesElement,
                fitHeight: menuHeight,
                fitWidth: 350,
                mountTo: popupsMountPoint,
                offset: $9a660a5068ececae$var$POPUP_OFFSET,
                onUnmount: onPopupUnmount,
                preventOverflow: true,
                scrollableElement: popupsScrollableElement,
                target: buttonRef.current,
                zIndex: (0, $5bbjm.akEditorMenuZIndex),
                children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $hRynz.RegisteredInsertMenuContent), {
                    api: api,
                    maxHeight: menuHeight,
                    editorView: editorView,
                    isOffline: (0, $hVGJk.isOfflineMode)(connectivityMode),
                    onClose: closeAndRestoreFocus,
                    onDismiss: closeForSelection,
                    onSelect: closeForSelection,
                    target: buttonRef.current
                })
            })
        ]
    });
};

});
parcelRegister("e3nP3", function(module, exports) {
$parcel$export(module.exports, "useMenuPopupSizing", () => $9dd7c036642d537a$export$848937512415483);

var $bSJIT = parcelRequire("bSJIT");

var $bAB3U = parcelRequire("bAB3U");

var $9wZWu = parcelRequire("9wZWu");

var $9xvBa = parcelRequire("9xvBa");
function $9dd7c036642d537a$export$848937512415483({ target: target, boundariesElement: boundariesElement, scrollableElement: scrollableElement, maxHeight: maxHeight, offset: offset, isOpen: isOpen = true }) {
    const [height, setHeight] = (0, $bSJIT.useState)(maxHeight);
    (0, $bSJIT.useLayoutEffect)(()=>{
        const view = target === null || target === void 0 ? void 0 : target.ownerDocument.defaultView;
        if (!target || !view || !isOpen) return;
        const boundary = boundariesElement || target.ownerDocument.body;
        const scrollParent = scrollableElement || (0, $9xvBa.findOverflowScrollParent)(target);
        const update = ()=>{
            const rect = target.getBoundingClientRect();
            const bounds = boundary.getBoundingClientRect();
            const above = Math.max(0, rect.top - (bounds.top - boundary.scrollTop) - offset);
            const below = Math.max(0, bounds.bottom - rect.bottom - offset);
            const space = below >= maxHeight ? below : Math.max(above, below);
            // Popup rounds its position up to a CSS pixel. Reserve that pixel at the edge.
            const available = Math.max(0, Math.floor(space) - 1);
            setHeight(Math.min(maxHeight, available));
        };
        const schedule = (0, $9wZWu.default)(update);
        update();
        const unbindResize = (0, $bAB3U.bind)(view, {
            type: 'resize',
            listener: schedule
        });
        const unbindScroll = scrollParent ? (0, $bAB3U.bind)(scrollParent, {
            type: 'scroll',
            listener: schedule
        }) : undefined;
        return ()=>{
            unbindResize();
            unbindScroll === null || unbindScroll === void 0 || unbindScroll();
            schedule.cancel();
        };
    }, [
        target,
        boundariesElement,
        scrollableElement,
        maxHeight,
        offset,
        isOpen
    ]);
    return height;
}

});

parcelRegister("hRynz", function(module, exports) {
$parcel$export(module.exports, "RegisteredInsertMenuContent", () => $372c359217cbe42d$export$e1e5c28f0ef130e2);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9woaI = parcelRequire("9woaI");

var $ZKS7T = parcelRequire("ZKS7T");

var $llZUW = parcelRequire("llZUW");

var $6gJ7m = parcelRequire("6gJ7m");
const $372c359217cbe42d$var$EMPTY_COMPONENTS = [];
const $372c359217cbe42d$var$subscribeToNothing = ()=>()=>{};
const $372c359217cbe42d$var$RegisteredInsertMenuContainer = ({ children: children })=>{
    const setOutsideClickTargetRef = (0, $bSJIT.useContext)((0, $ZKS7T.PlainOutsideClickTargetRefContext));
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        ref: setOutsideClickTargetRef,
        children: children
    });
};
const $372c359217cbe42d$var$RegisteredInsertMenuWithListeners = (0, $llZUW.default)($372c359217cbe42d$var$RegisteredInsertMenuContainer);
const $372c359217cbe42d$export$e1e5c28f0ef130e2 = ({ api: api, editorView: editorView, isOffline: isOffline, maxHeight: maxHeight, onClose: onClose, onDismiss: onDismiss, onSelect: onSelect, target: target })=>{
    var _api$uiControlRegistr2, _api$quickInsert, _api$analytics, _api$quickInsert2;
    const getComponents = (0, $bSJIT.useCallback)(()=>{
        var _api$uiControlRegistr;
        const components = api === null || api === void 0 || (_api$uiControlRegistr = api.uiControlRegistry) === null || _api$uiControlRegistr === void 0 ? void 0 : _api$uiControlRegistr.actions.getComponents((0, $9woaI.MENU).key);
        return components !== null && components !== void 0 && components.length ? components : $372c359217cbe42d$var$EMPTY_COMPONENTS;
    }, [
        api
    ]);
    const components = (0, $bSJIT.useSyncExternalStore)((api === null || api === void 0 || (_api$uiControlRegistr2 = api.uiControlRegistry) === null || _api$uiControlRegistr2 === void 0 ? void 0 : _api$uiControlRegistr2.actions.subscribe) ?? $372c359217cbe42d$var$subscribeToNothing, getComponents, getComponents);
    const onClickOutside = (0, $bSJIT.useCallback)((event)=>{
        if (event.target instanceof Node && target !== null && target !== void 0 && target.contains(event.target)) return;
        onDismiss();
    }, [
        onDismiss,
        target
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)($372c359217cbe42d$var$RegisteredInsertMenuWithListeners, {
        handleClickOutside: onClickOutside,
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $6gJ7m.RegisteredInsertMenu), {
            components: components,
            editorView: editorView,
            emptyStateHandler: api === null || api === void 0 || (_api$quickInsert = api.quickInsert) === null || _api$quickInsert === void 0 || (_api$quickInsert = _api$quickInsert.sharedState.currentState()) === null || _api$quickInsert === void 0 ? void 0 : _api$quickInsert.emptyStateHandler,
            fireAnalyticsEvent: api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions.fireAnalyticsEvent,
            getItemRank: api === null || api === void 0 || (_api$quickInsert2 = api.quickInsert) === null || _api$quickInsert2 === void 0 || (_api$quickInsert2 = _api$quickInsert2.sharedState.currentState()) === null || _api$quickInsert2 === void 0 ? void 0 : _api$quickInsert2.getItemRank,
            isOffline: isOffline,
            maxHeight: maxHeight,
            onClose: onClose,
            onSelect: onSelect
        })
    });
};

});
parcelRegister("6gJ7m", function(module, exports) {
$parcel$export(module.exports, "RegisteredInsertMenu", () => $e93c2887ab18969f$export$16499b643323b21d);
/* RegisteredInsertMenu.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $c9wRy = parcelRequire("c9wRy");

var $cW1gB = parcelRequire("cW1gB");

var $9woaI = parcelRequire("9woaI");

var $A9iSs = parcelRequire("A9iSs");
var $b1eGy = parcelRequire("b1eGy");
var $i8Hch = parcelRequire("i8Hch");

var $88sf5 = parcelRequire("88sf5");

var $2WXs5 = parcelRequire("2WXs5");

var $3xPFq = parcelRequire("3xPFq");

var $29Z7Q = parcelRequire("29Z7Q");

var $9PwDt = parcelRequire("9PwDt");

var $jgsO4 = parcelRequire("jgsO4");

var $gvkhA = parcelRequire("gvkhA");
const $e93c2887ab18969f$var$DEFAULT_MENU_MAX_HEIGHT = 520;
const $e93c2887ab18969f$var$styles = {
    menu: "_2rko1mok _1reo15vq _18m915vq _bfhk1bhr _16qs130s _1e0c1txw _2lx21bp4 _1bsb1edt",
    search: "_18zrutpp _1o9zidpf _1q51utpp _85i5u2gc"
};
const $e93c2887ab18969f$export$16499b643323b21d = ({ components: components, emptyStateHandler: emptyStateHandler, fireAnalyticsEvent: fireAnalyticsEvent, getItemRank: getItemRank, editorView: editorView, isOffline: isOffline, maxHeight: maxHeight = $e93c2887ab18969f$var$DEFAULT_MENU_MAX_HEIGHT, onClose: onClose, onSelect: onSelect })=>{
    const menuStyle = {
        maxHeight: maxHeight
    };
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const listId = (0, $bSJIT.useId)();
    const [menuOpenId] = (0, $bSJIT.useState)(()=>Symbol('registered-insert-menu-open'));
    const [query, setQuery] = (0, $bSJIT.useState)('');
    const [selectedItemIndex, setSelectedItemIndex] = (0, $bSJIT.useState)(0);
    const selectedItemIndexRef = (0, $bSJIT.useRef)(selectedItemIndex);
    const [renderedItems, setRenderedItems] = (0, $bSJIT.useState)({
        startIndex: -1,
        stopIndex: -1
    });
    const searchRef = (0, $bSJIT.useRef)(null);
    (0, $bSJIT.useLayoutEffect)(()=>{
        var _searchRef$current;
        // Popup positions on the next frame; focusing must not scroll to its initial location.
        (_searchRef$current = searchRef.current) === null || _searchRef$current === void 0 || _searchRef$current.focus({
            preventScroll: true
        });
    }, []);
    const surfaceContext = (0, $bSJIT.useMemo)(()=>(0, $29Z7Q.createSurfaceContext)((0, $3xPFq.TYPE_AHEAD_SURFACE_CONTEXT), {
            menuOpenId: menuOpenId
        }), [
        menuOpenId
    ]);
    const hasSectionOverflowItems = (0, $bSJIT.useMemo)(()=>components.some(({ key: key })=>(0, $2WXs5.isSectionOverflowItemKey)(key)), [
        components
    ]);
    const model = (0, $bSJIT.useMemo)(()=>(0, $A9iSs.getQuickInsertMenuModel)({
            components: components,
            formatMessage: formatMessage,
            getItemRank: getItemRank,
            query: query,
            rootComponent: (0, $9woaI.MENU),
            selectCategoryItems: hasSectionOverflowItems ? (0, $i8Hch.selectQuickInsertCategoryItems) : undefined,
            surfaceContext: surfaceContext
        }), [
        components,
        formatMessage,
        getItemRank,
        hasSectionOverflowItems,
        query,
        surfaceContext
    ]);
    const [previewActivation, setPreviewActivation] = (0, $bSJIT.useState)();
    const activePreviewItemKey = (previewActivation === null || previewActivation === void 0 ? void 0 : previewActivation.model) === model ? previewActivation.itemKey : undefined;
    const searchResultCount = (0, $bSJIT.useMemo)(()=>model.sections.reduce((count, section)=>count + section.filter(({ key: key, type: type })=>type === 'menu-item' && !(0, $2WXs5.isSectionOverflowItemKey)(key)).length, 0), [
        model.sections
    ]);
    const flushSearchAnalytics = (0, $88sf5.useQuickInsertSearchAnalytics)({
        fireAnalyticsEvent: fireAnalyticsEvent,
        query: query,
        resultCount: searchResultCount,
        surface: 'toolbar'
    });
    const closeWithAnalytics = (0, $bSJIT.useCallback)(()=>{
        flushSearchAnalytics();
        onClose();
    }, [
        flushSearchAnalytics,
        onClose
    ]);
    const selectWithAnalytics = (0, $bSJIT.useCallback)(()=>{
        flushSearchAnalytics();
        onSelect();
    }, [
        flushSearchAnalytics,
        onSelect
    ]);
    const selectableItems = (0, $bSJIT.useMemo)(()=>(0, $b1eGy.getQuickInsertMenuRows)(model).filter((row)=>row.type === 'menu-item'), [
        model
    ]);
    const itemCount = selectableItems.length + (model.footer ? 1 : 0);
    const selectableItemKeys = (0, $bSJIT.useMemo)(()=>[
            ...selectableItems,
            ...model.footer ? [
                model.footer
            ] : []
        ].map(({ key: key })=>key).join(','), [
        model.footer,
        selectableItems
    ]);
    (0, $bSJIT.useLayoutEffect)(()=>{
        const initialItemIndex = itemCount > 0 ? 0 : -1;
        selectedItemIndexRef.current = initialItemIndex;
        setSelectedItemIndex(initialItemIndex);
    }, [
        itemCount,
        query,
        selectableItemKeys
    ]);
    (0, $bSJIT.useLayoutEffect)(()=>{
        setPreviewActivation(undefined);
    }, [
        model,
        query
    ]);
    const isActiveItemMounted = selectedItemIndex >= 0 && selectedItemIndex < itemCount && (selectedItemIndex >= renderedItems.startIndex && selectedItemIndex <= renderedItems.stopIndex || Boolean(model.footer) && selectedItemIndex === itemCount - 1);
    const activeItemId = `${listId}-${selectedItemIndex}`;
    const setKeyboardPreview = (0, $bSJIT.useCallback)((itemIndex)=>{
        const item = selectableItems[itemIndex];
        setPreviewActivation(item ? {
            itemKey: item.key,
            model: model,
            source: 'keyboard'
        } : undefined);
    }, [
        model,
        selectableItems
    ]);
    const selectNextItem = (0, $bSJIT.useCallback)(()=>{
        const currentIndex = selectedItemIndexRef.current;
        const nextIndex = itemCount === 0 ? -1 : currentIndex < 0 ? 0 : (currentIndex + 1) % itemCount;
        selectedItemIndexRef.current = nextIndex;
        setSelectedItemIndex(nextIndex);
        setKeyboardPreview(nextIndex);
    }, [
        itemCount,
        setKeyboardPreview
    ]);
    const selectPreviousItem = (0, $bSJIT.useCallback)(()=>{
        const currentIndex = selectedItemIndexRef.current;
        const previousIndex = itemCount === 0 ? -1 : currentIndex <= 0 ? itemCount - 1 : currentIndex - 1;
        selectedItemIndexRef.current = previousIndex;
        setSelectedItemIndex(previousIndex);
        setKeyboardPreview(previousIndex);
    }, [
        itemCount,
        setKeyboardPreview
    ]);
    const onItemHover = (0, $bSJIT.useCallback)((itemIndex, itemKey)=>{
        selectedItemIndexRef.current = itemIndex;
        setSelectedItemIndex(itemIndex);
        setPreviewActivation((current)=>{
            if ((current === null || current === void 0 ? void 0 : current.itemKey) === itemKey && (current === null || current === void 0 ? void 0 : current.model) === model && (current === null || current === void 0 ? void 0 : current.source) === 'pointer') return current;
            return itemKey ? {
                itemKey: itemKey,
                model: model,
                source: 'pointer'
            } : undefined;
        });
    }, [
        model
    ]);
    const onItemFocus = (0, $bSJIT.useCallback)((itemIndex, itemKey)=>{
        selectedItemIndexRef.current = itemIndex;
        setSelectedItemIndex(itemIndex);
        setPreviewActivation((current)=>{
            if ((current === null || current === void 0 ? void 0 : current.itemKey) === itemKey && (current === null || current === void 0 ? void 0 : current.model) === model) return current;
            return itemKey ? {
                itemKey: itemKey,
                model: model,
                source: 'keyboard'
            } : undefined;
        });
    }, [
        model
    ]);
    const onItemLeave = (0, $bSJIT.useCallback)((itemKey)=>{
        setPreviewActivation((current)=>(current === null || current === void 0 ? void 0 : current.source) === 'pointer' && current.itemKey === itemKey ? undefined : current);
    }, []);
    const onItemBlur = (0, $bSJIT.useCallback)((itemKey)=>{
        setPreviewActivation((current)=>(current === null || current === void 0 ? void 0 : current.itemKey) === itemKey ? undefined : current);
    }, []);
    const onItemVisibilityChange = (0, $bSJIT.useCallback)((itemKey, isVisible)=>{
        if (!isVisible) setPreviewActivation((current)=>(current === null || current === void 0 ? void 0 : current.source) === 'pointer' && current.itemKey === itemKey ? undefined : current);
    }, []);
    const selectActiveItem = (0, $bSJIT.useCallback)(()=>{
        if (isActiveItemMounted) {
            var _getDocument;
            (_getDocument = (0, $c9wRy.getDocument)()) === null || _getDocument === void 0 || (_getDocument = _getDocument.getElementById(activeItemId)) === null || _getDocument === void 0 || _getDocument.click();
        }
    }, [
        activeItemId,
        isActiveItemMounted
    ]);
    const onQueryChange = (0, $bSJIT.useCallback)((event)=>{
        setQuery(event.currentTarget.value);
    }, []);
    const onKeyDown = (0, $bSJIT.useCallback)((event)=>{
        if (event.key === 'Escape') {
            event.preventDefault();
            closeWithAnalytics();
            return;
        }
        // The search field owns the composite's arrow-key and Enter behaviour. Other
        // focusable controls, including consumer-provided empty-state content, need
        // to retain their native keyboard behaviour.
        if (event.target !== searchRef.current) return;
        switch(event.key){
            case 'ArrowDown':
                event.preventDefault();
                selectNextItem();
                break;
            case 'ArrowUp':
                event.preventDefault();
                selectPreviousItem();
                break;
            case 'Enter':
                event.preventDefault();
                selectActiveItem();
                break;
        }
    }, [
        closeWithAnalytics,
        selectActiveItem,
        selectNextItem,
        selectPreviousItem
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $9PwDt.Box), {
        "data-keyboard-navigation-independent": "",
        testId: "registered-insert-menu",
        onKeyDownCapture: onKeyDown,
        xcss: $e93c2887ab18969f$var$styles.menu,
        style: menuStyle,
        children: [
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
                xcss: $e93c2887ab18969f$var$styles.search,
                children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $jgsO4.default), {
                    "aria-activedescendant": isActiveItemMounted ? activeItemId : undefined,
                    "aria-controls": listId,
                    "aria-expanded": "true",
                    placeholder: "Search",
                    ref: searchRef,
                    role: "combobox",
                    value: query,
                    onChange: onQueryChange
                })
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $gvkhA.RegisteredInsertMenuList), {
                editorView: editorView,
                emptyStateHandler: emptyStateHandler,
                isOffline: isOffline,
                listId: listId,
                listLabel: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).insertMenu),
                maxHeight: maxHeight,
                menuOpenId: menuOpenId,
                model: model,
                onClose: selectWithAnalytics,
                onItemFocus: onItemFocus,
                onItemHover: onItemHover,
                onItemBlur: onItemBlur,
                onItemLeave: onItemLeave,
                onItemVisibilityChange: onItemVisibilityChange,
                onRenderedItemsChange: setRenderedItems,
                query: query,
                selectedItemIndex: selectedItemIndex,
                surfaceContext: surfaceContext,
                activePreviewItemKey: activePreviewItemKey
            })
        ]
    });
};

});
parcelRegister("A9iSs", function(module, exports) {
$parcel$export(module.exports, "getQuickInsertMenuModel", () => $884865507588ffc1$export$855a5defca8f2c1f);

var $1KaSt = parcelRequire("1KaSt");

var $93UeO = parcelRequire("93UeO");

var $2WXs5 = parcelRequire("2WXs5");

var $kqFPz = parcelRequire("kqFPz");

var $9woaI = parcelRequire("9woaI");

var $caCJy = parcelRequire("caCJy");
const $884865507588ffc1$var$SEARCH_TOP_MATCH_LIMIT = 5;
const $884865507588ffc1$var$SEARCH_RESULTS_HEADING = {
    key: (0, $9woaI.SEARCH_RESULTS_SECTION).key,
    type: (0, $9woaI.SEARCH_RESULTS_SECTION).type,
    component: (0, $caCJy.QuickInsertSearchResultsSection),
    parents: [
        {
            key: (0, $9woaI.MENU).key,
            type: (0, $9woaI.MENU).type,
            rank: 0
        }
    ]
};
const $884865507588ffc1$var$getParentRank = (component, parentKey)=>{
    var _component$parents;
    return ((_component$parents = component.parents) === null || _component$parents === void 0 || (_component$parents = _component$parents.find((parent)=>parent.key === parentKey)) === null || _component$parents === void 0 ? void 0 : _component$parents.rank) ?? Number.MAX_SAFE_INTEGER;
};
const $884865507588ffc1$var$compareMatchedItems = (a, b)=>a.sectionRank - b.sectionRank || a.score - b.score || a.itemRank - b.itemRank || a.sourceIndex - b.sourceIndex || a.identity.localeCompare(b.identity);
const $884865507588ffc1$var$compareSearchResults = (a, b)=>a.score - b.score || a.sectionRank - b.sectionRank || a.itemRank - b.itemRank || a.sourceIndex - b.sourceIndex || a.identity.localeCompare(b.identity);
const $884865507588ffc1$var$getSearchResults = (matches)=>{
    const topMatches = Array.from(matches).sort($884865507588ffc1$var$compareSearchResults).slice(0, $884865507588ffc1$var$SEARCH_TOP_MATCH_LIMIT);
    const topMatchIdentities = new Set(topMatches.map(({ identity: identity })=>identity));
    const tailMatches = matches.filter(({ identity: identity })=>!topMatchIdentities.has(identity));
    return [
        ...topMatches,
        ...tailMatches
    ].map(({ item: item })=>item);
};
const $884865507588ffc1$var$getRenderedMenuItems = (section, childrenMap, surfaceContext)=>(childrenMap.get((0, $1KaSt.getComponentIdentity)(section)) ?? []).filter((child)=>child.type === 'menu-item' && (0, $1KaSt.willComponentRender)(child, childrenMap, surfaceContext));
const $884865507588ffc1$var$buildBrowseSections = ({ childrenMap: childrenMap, contentSections: contentSections, selectCategoryItems: selectCategoryItems, surfaceContext: surfaceContext })=>{
    const sections = [];
    for (const section of contentSections){
        const children = $884865507588ffc1$var$getRenderedMenuItems(section, childrenMap, surfaceContext);
        const overflowItems = children.filter((child)=>(0, $2WXs5.isSectionOverflowItemKey)(child.key));
        const viewMoreItem = overflowItems[overflowItems.length - 1];
        const items = children.filter((child)=>!(0, $2WXs5.isSectionOverflowItemKey)(child.key));
        if (items.length === 0) continue;
        const selectedItems = viewMoreItem !== undefined && selectCategoryItems !== undefined ? selectCategoryItems(items) : items;
        if (selectedItems.length < items.length && viewMoreItem !== undefined) sections.push([
            section,
            ...selectedItems,
            viewMoreItem
        ]);
        else sections.push([
            section,
            ...selectedItems
        ]);
    }
    return {
        sections: sections
    };
};
const $884865507588ffc1$var$buildSearchSections = ({ childrenMap: childrenMap, components: components, contentSections: contentSections, formatMessage: formatMessage, query: query, root: root, surfaceContext: surfaceContext })=>{
    const matches = new Map();
    const sourceIndexByComponent = new Map(components.map((component, index)=>[
            component,
            index
        ]));
    for (const section of contentSections)for (const item of $884865507588ffc1$var$getRenderedMenuItems(section, childrenMap, surfaceContext)){
        var _item$match;
        if ((0, $2WXs5.isSectionOverflowItemKey)(item.key)) continue;
        const match = (_item$match = item.match) === null || _item$match === void 0 ? void 0 : _item$match.call(item, {
            formatMessage: formatMessage,
            query: query
        });
        if (item.match && match === null) continue;
        const candidate = {
            identity: `${item.type}:${item.key}`,
            item: item,
            itemRank: $884865507588ffc1$var$getParentRank(item, section.key),
            score: Math.min(1, Math.max(0, (match === null || match === void 0 ? void 0 : match.score) ?? 0)),
            sourceIndex: sourceIndexByComponent.get(item) ?? Number.MAX_SAFE_INTEGER,
            sectionRank: $884865507588ffc1$var$getParentRank(section, root.key)
        };
        const existing = matches.get(candidate.identity);
        if (!existing || $884865507588ffc1$var$compareMatchedItems(candidate, existing) < 0) matches.set(candidate.identity, candidate);
    }
    const uniqueMatches = Array.from(matches.values()).sort($884865507588ffc1$var$compareMatchedItems);
    const searchResults = $884865507588ffc1$var$getSearchResults(uniqueMatches);
    if (searchResults.length > 0) return {
        sections: [
            [
                $884865507588ffc1$var$SEARCH_RESULTS_HEADING,
                ...searchResults
            ]
        ]
    };
    const fallbackItem = contentSections.flatMap((section)=>childrenMap.get((0, $1KaSt.getComponentIdentity)(section)) ?? []).find((component)=>component.type === (0, $9woaI.ASK_ROVO_MENU_ITEM).type && component.key === (0, $9woaI.ASK_ROVO_MENU_ITEM).key && (0, $1KaSt.willComponentRender)(component, childrenMap, surfaceContext));
    return {
        fallbackItems: fallbackItem ? [
            fallbackItem
        ] : [],
        sections: []
    };
};
const $884865507588ffc1$export$855a5defca8f2c1f = ({ components: components, formatMessage: formatMessage, getItemRank: getItemRank, query: query, rootComponent: rootComponent, selectCategoryItems: selectCategoryItems, surfaceContext: surfaceContext })=>{
    const rankedComponents = (0, $kqFPz.applyRegisteredItemRanks)(components, getItemRank);
    const { childrenMap: childrenMap, root: root, topLevelChildren: topLevelChildren = [] } = (0, $1KaSt.resolveSurface)(rankedComponents, rootComponent);
    if (!root || !(0, $1KaSt.willComponentRender)(root, childrenMap, surfaceContext)) return {
        footer: undefined,
        root: undefined,
        sections: []
    };
    const renderedSections = topLevelChildren.filter((section)=>section.type === 'menu-section' && (0, $1KaSt.willComponentRender)(section, childrenMap, surfaceContext));
    const footerSection = renderedSections.find(({ key: key })=>(0, $93UeO.isMenuFooterSectionKey)(key));
    const contentSections = renderedSections.filter(({ key: key })=>!(0, $93UeO.isMenuFooterSectionKey)(key));
    const content = query === '' ? $884865507588ffc1$var$buildBrowseSections({
        childrenMap: childrenMap,
        contentSections: contentSections,
        selectCategoryItems: selectCategoryItems,
        surfaceContext: surfaceContext
    }) : $884865507588ffc1$var$buildSearchSections({
        childrenMap: childrenMap,
        components: rankedComponents,
        contentSections: contentSections,
        formatMessage: formatMessage,
        query: query,
        root: root,
        surfaceContext: surfaceContext
    });
    const footer = footerSection ? $884865507588ffc1$var$getRenderedMenuItems(footerSection, childrenMap, surfaceContext)[0] : undefined;
    return {
        ...content,
        footer: footer,
        root: root
    };
};

});
parcelRegister("93UeO", function(module, exports) {
$parcel$export(module.exports, "isMenuFooterSectionKey", () => $dd32b17b605b0eab$export$c16d021774078d85);

var $6vCxA = parcelRequire("6vCxA");
const $dd32b17b605b0eab$export$c16d021774078d85 = (key)=>key.endsWith((0, $6vCxA.MENU_FOOTER_SECTION_KEY_SUFFIX));

});
parcelRegister("6vCxA", function(module, exports) {
$parcel$export(module.exports, "MENU_FOOTER_SECTION_KEY_SUFFIX", () => $3cf981cd5dc2daf3$export$23db4396eb0ad54b);
/** Identifies reserved type-ahead sections whose item is rendered as the persistent menu footer. */ const $3cf981cd5dc2daf3$export$23db4396eb0ad54b = '--system-menu-footer';

});


parcelRegister("2WXs5", function(module, exports) {
$parcel$export(module.exports, "isSectionOverflowItemKey", () => $21aefe64e381c67a$export$f5728aa6537ffb8);

var $lf2zo = parcelRequire("lf2zo");
const $21aefe64e381c67a$export$f5728aa6537ffb8 = (key)=>key.endsWith((0, $lf2zo.SECTION_OVERFLOW_ITEM_KEY_SUFFIX));

});
parcelRegister("lf2zo", function(module, exports) {
$parcel$export(module.exports, "SECTION_OVERFLOW_ITEM_KEY_SUFFIX", () => $70272a86ff61ad22$export$9a2fe7e12b4abbb3);
/** Identifies system items that reveal the remaining items in a type-ahead section. */ const $70272a86ff61ad22$export$9a2fe7e12b4abbb3 = '--system-section-overflow';

});


parcelRegister("kqFPz", function(module, exports) {
$parcel$export(module.exports, "applyRegisteredItemRanks", () => $9205ed228c7895e7$export$d5197e4cf486093c);
const $9205ed228c7895e7$export$d5197e4cf486093c = (components, getRegisteredItemRank)=>{
    if (!getRegisteredItemRank) return components;
    return components.map((component)=>{
        if (!component.parents) return component;
        const parents = component.parents.map((parent)=>{
            var _getRegisteredItemRan;
            const rank = (_getRegisteredItemRan = getRegisteredItemRank({
                component: component,
                parent: parent
            })) === null || _getRegisteredItemRan === void 0 ? void 0 : _getRegisteredItemRan.rank;
            return {
                ...parent,
                rank: typeof rank === 'number' && Number.isFinite(rank) ? rank : parent.rank
            };
        });
        return Object.assign({}, component, {
            parents: parents
        });
    });
};

});

parcelRegister("caCJy", function(module, exports) {
$parcel$export(module.exports, "QuickInsertSearchResultsSection", () => $0303181e48609cc3$export$535b3a89bab4a2bc);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $64eKJ = parcelRequire("64eKJ");

var $g2pPc = parcelRequire("g2pPc");
const $0303181e48609cc3$export$535b3a89bab4a2bc = ({ children: children })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $g2pPc.QuickInsertMenuSection), {
        title: formatMessage((0, $64eKJ.messages).searchResults),
        children: children
    });
};

});
parcelRegister("g2pPc", function(module, exports) {
$parcel$export(module.exports, "QuickInsertMenuSection", () => $aca9b3bb1de3b0db$export$134421b496083e82);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $fsfgu = parcelRequire("fsfgu");

var $9PwDt = parcelRequire("9PwDt");
const $aca9b3bb1de3b0db$export$134421b496083e82 = ({ children: children, title: title })=>/*#__PURE__*/ (0, $dc70d.jsxs)((0, $9PwDt.Box), {
        role: "group",
        "aria-label": title,
        children: [
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
                paddingBlockStart: "space.150",
                paddingBlockEnd: "space.050",
                children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $fsfgu.default), {
                    "aria-hidden": true,
                    children: title
                })
            }),
            children
        ]
    });

});



parcelRegister("b1eGy", function(module, exports) {
$parcel$export(module.exports, "getQuickInsertMenuRows", () => $899a6d46c3258ac5$export$de69ce227e54e44b);
const $899a6d46c3258ac5$export$de69ce227e54e44b = (model)=>[
        ...model.sections.flat(),
        ...model.fallbackItems ?? []
    ];

});

parcelRegister("i8Hch", function(module, exports) {
$parcel$export(module.exports, "selectQuickInsertCategoryItems", () => $d0df760647a8d190$export$113115a191eefda5);

var $3eL0d = parcelRequire("3eL0d");
const $d0df760647a8d190$var$DEFAULT_ITEM_LIMIT = 30;
const $d0df760647a8d190$var$ECOSYSTEM_ITEM_LIMIT = 10;
const $d0df760647a8d190$var$isEcosystemQuickInsertItem = (item)=>(0, $3eL0d.quickInsertProviderMenuItemKey).isEcosystem(item.key);
const $d0df760647a8d190$export$113115a191eefda5 = (items)=>{
    let ecosystemItemCount = 0;
    return items.filter((item, index)=>{
        const isEcosystemItem = $d0df760647a8d190$var$isEcosystemQuickInsertItem(item);
        if (isEcosystemItem) ecosystemItemCount++;
        return index < $d0df760647a8d190$var$DEFAULT_ITEM_LIMIT || isEcosystemItem && ecosystemItemCount <= $d0df760647a8d190$var$ECOSYSTEM_ITEM_LIMIT;
    });
};

});
parcelRegister("3eL0d", function(module, exports) {
$parcel$export(module.exports, "getQuickInsertProviderMenuItemKey", () => $51d66ee4027b6822$export$a3569e804245f959);
$parcel$export(module.exports, "quickInsertProviderMenuItemKey", () => $51d66ee4027b6822$export$e29bc6dbc1ad9500);
const $51d66ee4027b6822$var$QUICK_INSERT_PROVIDER_MENU_ITEM_KEY_PREFIX = 'quick-insert-provider-';
const $51d66ee4027b6822$var$ECOSYSTEM_QUICK_INSERT_PROVIDER_MENU_ITEM_KEY_PREFIX = 'quick-insert-ecosystem';
const $51d66ee4027b6822$export$a3569e804245f959 = (key, app)=>(app === null || app === void 0 ? void 0 : app.source) === 'ecosystem' ? `${$51d66ee4027b6822$var$ECOSYSTEM_QUICK_INSERT_PROVIDER_MENU_ITEM_KEY_PREFIX}-${key}` : `${$51d66ee4027b6822$var$QUICK_INSERT_PROVIDER_MENU_ITEM_KEY_PREFIX}${key}`;
const $51d66ee4027b6822$var$isEcosystemQuickInsertProviderMenuItemKey = (key)=>key.startsWith($51d66ee4027b6822$var$ECOSYSTEM_QUICK_INSERT_PROVIDER_MENU_ITEM_KEY_PREFIX);
const $51d66ee4027b6822$var$normalizeQuickInsertProviderMenuItemKey = (key)=>$51d66ee4027b6822$var$isEcosystemQuickInsertProviderMenuItemKey(key) ? `${$51d66ee4027b6822$var$QUICK_INSERT_PROVIDER_MENU_ITEM_KEY_PREFIX}${key.slice(`${$51d66ee4027b6822$var$ECOSYSTEM_QUICK_INSERT_PROVIDER_MENU_ITEM_KEY_PREFIX}-`.length)}` : key;
/** Reverses `getQuickInsertProviderMenuItemKey`; keys without a provider prefix are returned unchanged. */ const $51d66ee4027b6822$var$getQuickInsertProviderMenuItemSourceKey = (key)=>{
    const normalizedKey = $51d66ee4027b6822$var$normalizeQuickInsertProviderMenuItemKey(key);
    return normalizedKey.startsWith($51d66ee4027b6822$var$QUICK_INSERT_PROVIDER_MENU_ITEM_KEY_PREFIX) ? normalizedKey.slice($51d66ee4027b6822$var$QUICK_INSERT_PROVIDER_MENU_ITEM_KEY_PREFIX.length) : key;
};
const $51d66ee4027b6822$export$e29bc6dbc1ad9500 = {
    get: $51d66ee4027b6822$export$a3569e804245f959,
    getSourceKey: $51d66ee4027b6822$var$getQuickInsertProviderMenuItemSourceKey,
    isEcosystem: $51d66ee4027b6822$var$isEcosystemQuickInsertProviderMenuItemKey,
    normalize: $51d66ee4027b6822$var$normalizeQuickInsertProviderMenuItemKey
};

});


parcelRegister("88sf5", function(module, exports) {
$parcel$export(module.exports, "useQuickInsertSearchAnalytics", () => $f7947e8edac8f63c$export$a657b16e2772859c);

var $bSJIT = parcelRequire("bSJIT");

var $g6Qq4 = parcelRequire("g6Qq4");
const $f7947e8edac8f63c$var$SEARCH_DEBOUNCE_MS = 1000;
const $f7947e8edac8f63c$export$a657b16e2772859c = ({ query: query, resultCount: resultCount, surface: surface, category: category, isOpen: isOpen = true, fireAnalyticsEvent: fireAnalyticsEvent })=>{
    const latestOptions = (0, $bSJIT.useRef)({
        query: query,
        resultCount: resultCount,
        surface: surface,
        category: category,
        fireAnalyticsEvent: fireAnalyticsEvent
    });
    latestOptions.current = {
        query: query,
        resultCount: resultCount,
        surface: surface,
        category: category,
        fireAnalyticsEvent: fireAnalyticsEvent
    };
    const pendingSearch = (0, $bSJIT.useRef)(null);
    const effectVersion = (0, $bSJIT.useRef)(0);
    const flush = (0, $bSJIT.useCallback)(()=>{
        const pending = pendingSearch.current;
        if (!pending) return;
        clearTimeout(pending.timer);
        pendingSearch.current = null;
        const current = latestOptions.current;
        if (current.query.trim() !== pending.query || !current.fireAnalyticsEvent) return;
        const attributes = {
            ...current.surface === 'element-browser' && current.category !== undefined ? {
                category: current.category
            } : {},
            isEmpty: current.resultCount === 0,
            queryLength: current.query.trim().length,
            resultCount: current.resultCount,
            surface: current.surface
        };
        const payload = {
            action: (0, $g6Qq4.ACTION).SEARCHED,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).QUICK_INSERT,
            eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
            attributes: attributes
        };
        current.fireAnalyticsEvent(payload);
    }, []);
    (0, $bSJIT.useEffect)(()=>{
        const currentVersion = ++effectVersion.current;
        if (!isOpen) {
            flush();
            return;
        }
        const trimmedQuery = query.trim();
        if (!trimmedQuery) {
            if (pendingSearch.current) {
                clearTimeout(pendingSearch.current.timer);
                pendingSearch.current = null;
            }
            return;
        }
        if (pendingSearch.current) clearTimeout(pendingSearch.current.timer);
        const timer = setTimeout(flush, $f7947e8edac8f63c$var$SEARCH_DEBOUNCE_MS);
        pendingSearch.current = {
            query: trimmedQuery,
            timer: timer
        };
        return ()=>{
            if (pendingSearch.current) clearTimeout(pendingSearch.current.timer);
            Promise.resolve().then(()=>{
                // oxlint-disable-next-line react-hooks/exhaustive-deps -- The live effect version distinguishes dependency cleanup from a real unmount.
                if (effectVersion.current === currentVersion) flush();
            });
        };
    }, [
        query,
        surface,
        category,
        isOpen,
        flush
    ]);
    return flush;
};

});

parcelRegister("3xPFq", function(module, exports) {
$parcel$export(module.exports, "TYPE_AHEAD_SURFACE_CONTEXT", () => $f080a48d01651f15$export$dc622db8dd989457);
const $f080a48d01651f15$export$dc622db8dd989457 = Symbol('type-ahead-surface-context');

});

parcelRegister("gvkhA", function(module, exports) {
$parcel$export(module.exports, "RegisteredInsertMenuList", () => $2779c281b4cda1da$export$a68f09c779ba1d52);
/* RegisteredInsertMenuList.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $afyUO = parcelRequire("afyUO");

var $dASxq = parcelRequire("dASxq");

var $dkZQn = parcelRequire("dkZQn");

var $b1eGy = parcelRequire("b1eGy");

var $bLecl = parcelRequire("bLecl");

var $9PwDt = parcelRequire("9PwDt");

var $6VwRD = parcelRequire("6VwRD");
const $2779c281b4cda1da$var$ESTIMATED_ROW_HEIGHT = 44;
// 44px item + 1px separator.
const $2779c281b4cda1da$var$MENU_FOOTER_HEIGHT = 45;
const $2779c281b4cda1da$var$MENU_SEARCH_HEIGHT = 64;
const $2779c281b4cda1da$var$LIST_WIDTH = 350;
const $2779c281b4cda1da$var$listAriaProps = {
    // @ts-expect-error react-virtualized forwards null to omit its grid-only default; its types exclude null.
    'aria-readonly': null
};
const $2779c281b4cda1da$var$styles = {
    content: "_1e0c1txw _2lx21bp4 _1tkeidpf",
    scrollable: "_16jlkb7n _1tkeidpf _18m91wug",
    footer: "_1o9zidpf",
    footerWithDivider: "_1i531l7x _15a5nqa1 _uwhke4h9 _1o9zidpf",
    externalControls: "_1i531l7x _15a5nqa1 _uwhke4h9 _1q51u2gc _85i5u2gc"
};
const $2779c281b4cda1da$var$RegisteredInsertMenuItemRow = ({ editorView: editorView, id: id, isOffline: isOffline, isSelected: isSelected, itemIndex: itemIndex, menuOpenId: menuOpenId, onClose: onClose, onItemFocus: onItemFocus, onItemBlur: onItemBlur, onItemHover: onItemHover, onItemLeave: onItemLeave, registration: registration, surfaceContext: surfaceContext })=>{
    (0, $bSJIT.useLayoutEffect)(()=>()=>onItemLeave(registration.key), [
        onItemLeave,
        registration.key
    ]);
    const onBlur = (0, $bSJIT.useCallback)((event)=>{
        if (!event.currentTarget.contains(event.relatedTarget)) onItemBlur(registration.key);
    }, [
        onItemBlur,
        registration.key
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        onBlur: onBlur,
        onFocus: ()=>onItemFocus(itemIndex, registration.key),
        onMouseLeave: ()=>onItemLeave(registration.key),
        onMouseMove: ()=>onItemHover(itemIndex, registration.key),
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $6VwRD.RegisteredInsertMenuItem), {
            editorView: editorView,
            id: id,
            isOffline: isOffline,
            isSelected: isSelected,
            menuOpenId: menuOpenId,
            onClose: onClose,
            registration: registration,
            surfaceContext: surfaceContext
        })
    });
};
const $2779c281b4cda1da$export$a68f09c779ba1d52 = ({ editorView: editorView, emptyStateHandler: emptyStateHandler, isOffline: isOffline, listId: listId, listLabel: listLabel, maxHeight: maxHeight, menuOpenId: menuOpenId, model: model, onClose: onClose, onItemFocus: onItemFocus, onItemBlur: onItemBlur, query: query, onItemHover: onItemHover, onItemLeave: onItemLeave, onItemVisibilityChange: onItemVisibilityChange, onRenderedItemsChange: onRenderedItemsChange, selectedItemIndex: selectedItemIndex, surfaceContext: surfaceContext, activePreviewItemKey: activePreviewItemKey })=>{
    var _model$root;
    const Root = ((_model$root = model.root) === null || _model$root === void 0 ? void 0 : _model$root.component) ?? (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment;
    const listRef = (0, $bSJIT.useRef)(null);
    const setListRef = (0, $bSJIT.useCallback)((list)=>{
        listRef.current = list;
    }, []);
    const rows = (0, $bSJIT.useMemo)(()=>(0, $b1eGy.getQuickInsertMenuRows)(model), [
        model
    ]);
    const cache = (0, $bSJIT.useMemo)(()=>new (0, $afyUO.CellMeasurerCache)({
            defaultHeight: $2779c281b4cda1da$var$ESTIMATED_ROW_HEIGHT,
            fixedWidth: true
        }), []);
    const itemIndexByRowIndex = (0, $bSJIT.useMemo)(()=>{
        const indexes = new Map();
        let itemIndex = 0;
        rows.forEach((registration, rowIndex)=>{
            if (registration.type === 'menu-item') indexes.set(rowIndex, itemIndex++);
        });
        return indexes;
    }, [
        rows
    ]);
    const selectedRowIndex = (0, $bSJIT.useMemo)(()=>{
        for (const [rowIndex, itemIndex] of itemIndexByRowIndex){
            if (itemIndex === selectedItemIndex) return rowIndex;
        }
        return -1;
    }, [
        itemIndexByRowIndex,
        selectedItemIndex
    ]);
    const rowKeySignature = (0, $bSJIT.useMemo)(()=>rows.map(({ key: key, type: type })=>`${type}:${key}`).join('\0'), [
        rows
    ]);
    const { height: measuredHeight, updateHeight: updateHeight } = (0, $bLecl.useMenuListHeight)(cache, rows.length, rowKeySignature);
    (0, $bSJIT.useLayoutEffect)(()=>{
        var _listRef$current, _listRef$current2;
        cache.clearAll();
        (_listRef$current = listRef.current) === null || _listRef$current === void 0 || _listRef$current.recomputeRowHeights();
        (_listRef$current2 = listRef.current) === null || _listRef$current2 === void 0 || _listRef$current2.scrollToPosition(0);
    }, [
        cache,
        rowKeySignature
    ]);
    const onRowsRendered = (0, $bSJIT.useCallback)(({ overscanStartIndex: overscanStartIndex, overscanStopIndex: overscanStopIndex, startIndex: startIndex, stopIndex: stopIndex })=>{
        if (activePreviewItemKey) {
            const previewRowIndex = rows.findIndex(({ key: key })=>key === activePreviewItemKey);
            if (previewRowIndex < startIndex || previewRowIndex > stopIndex) onItemVisibilityChange(activePreviewItemKey, false);
        }
        updateHeight();
        const indexes = [
            ...itemIndexByRowIndex
        ].filter(([rowIndex])=>rowIndex >= overscanStartIndex && rowIndex <= overscanStopIndex).map(([, itemIndex])=>itemIndex);
        onRenderedItemsChange({
            startIndex: indexes[0] ?? -1,
            stopIndex: indexes[indexes.length - 1] ?? -1
        });
    }, [
        activePreviewItemKey,
        itemIndexByRowIndex,
        onItemVisibilityChange,
        onRenderedItemsChange,
        rows,
        updateHeight
    ]);
    const onScrollableContentScroll = (0, $bSJIT.useCallback)((event)=>{
        if (event.target === event.currentTarget && activePreviewItemKey) onItemVisibilityChange(activePreviewItemKey, false);
    }, [
        activePreviewItemKey,
        onItemVisibilityChange
    ]);
    const renderRow = (0, $bSJIT.useCallback)(({ index: index, key: key, parent: parent, style: style })=>{
        const registration = rows[index];
        if (!registration) return null;
        const itemIndex = itemIndexByRowIndex.get(index);
        const rowContent = registration.type === 'menu-section' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(registration.component ?? (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, null) : /*#__PURE__*/ (0, $dc70d.jsx)($2779c281b4cda1da$var$RegisteredInsertMenuItemRow, {
            editorView: editorView,
            id: `${listId}-${itemIndex}`,
            isOffline: isOffline,
            isSelected: itemIndex === selectedItemIndex,
            itemIndex: itemIndex ?? 0,
            menuOpenId: menuOpenId,
            onClose: onClose,
            onItemFocus: onItemFocus,
            onItemBlur: onItemBlur,
            onItemHover: onItemHover,
            onItemLeave: onItemLeave,
            registration: registration,
            surfaceContext: surfaceContext
        });
        return /*#__PURE__*/ (0, $dc70d.jsx)((0, $afyUO.CellMeasurer), {
            cache: cache,
            parent: parent,
            columnIndex: 0,
            rowIndex: index,
            children: ({ registerChild: registerChild })=>/*#__PURE__*/ (0, $dc70d.jsx)("div", {
                    ref: (element)=>registerChild === null || registerChild === void 0 ? void 0 : registerChild(element ?? undefined),
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    style: style,
                    children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
                        paddingBlockEnd: index === rows.length - 1 ? 'space.100' : undefined,
                        children: rowContent
                    })
                })
        }, key);
    }, [
        cache,
        editorView,
        isOffline,
        itemIndexByRowIndex,
        listId,
        menuOpenId,
        onClose,
        onItemFocus,
        onItemBlur,
        onItemHover,
        onItemLeave,
        rows,
        selectedItemIndex,
        surfaceContext
    ]);
    const footerItemIndex = itemIndexByRowIndex.size;
    const footerItemId = `${listId}-${footerItemIndex}`;
    const hasExternalControls = model.fallbackItems !== undefined && emptyStateHandler !== undefined;
    const hasNoSearchResults = query !== '' && rows.length === 0;
    const externalControls = hasExternalControls && emptyStateHandler ? emptyStateHandler({
        mode: 'inline',
        searchTerm: query,
        showNoResultsMessage: false
    }) : null;
    const showFooterDivider = !hasNoSearchResults || Boolean(externalControls);
    const listMaxHeight = Math.max(0, maxHeight - $2779c281b4cda1da$var$MENU_SEARCH_HEIGHT - (model.footer ? $2779c281b4cda1da$var$MENU_FOOTER_HEIGHT : 0));
    const contentStyle = {
        maxHeight: Math.max(0, maxHeight - $2779c281b4cda1da$var$MENU_SEARCH_HEIGHT)
    };
    const onFooterItemHover = (0, $bSJIT.useCallback)(()=>onItemHover(footerItemIndex), [
        footerItemIndex,
        onItemHover
    ]);
    const onFooterItemFocus = (0, $bSJIT.useCallback)(()=>onItemFocus(footerItemIndex), [
        footerItemIndex,
        onItemFocus
    ]);
    const footer = model.footer ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
        testId: "registered-insert-menu-footer",
        xcss: showFooterDivider ? $2779c281b4cda1da$var$styles.footerWithDivider : $2779c281b4cda1da$var$styles.footer,
        onFocus: onFooterItemFocus,
        onMouseMove: onFooterItemHover,
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $6VwRD.RegisteredInsertMenuItem), {
            editorView: editorView,
            id: footerItemId,
            isOffline: isOffline,
            isSelected: footerItemIndex === selectedItemIndex,
            menuOpenId: menuOpenId,
            onClose: onClose,
            registration: model.footer,
            surfaceContext: surfaceContext
        })
    }) : null;
    if (!model.root) return null;
    return /*#__PURE__*/ (0, $dc70d.jsx)(Root, {
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $6VwRD.RegisteredInsertMenuPreviewContext).Provider, {
            value: activePreviewItemKey,
            children: /*#__PURE__*/ (0, $dc70d.jsxs)((0, $9PwDt.Box), {
                xcss: $2779c281b4cda1da$var$styles.content,
                style: contentStyle,
                children: [
                    /*#__PURE__*/ (0, $dc70d.jsxs)((0, $9PwDt.Box), {
                        xcss: $2779c281b4cda1da$var$styles.scrollable,
                        onScroll: onScrollableContentScroll,
                        children: [
                            /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
                                "aria-label": listLabel,
                                "aria-owns": model.footer ? footerItemId : undefined,
                                id: listId,
                                role: "listbox",
                                children: rows.length > 0 && /*#__PURE__*/ (0, $dc70d.jsx)((0, $dASxq.List), {
                                    ...$2779c281b4cda1da$var$listAriaProps,
                                    tabIndex: null,
                                    containerRole: "presentation",
                                    height: Math.min(measuredHeight, listMaxHeight),
                                    overscanRowCount: 3,
                                    onRowsRendered: onRowsRendered,
                                    ref: setListRef,
                                    role: "group",
                                    rowCount: rows.length,
                                    rowHeight: cache.rowHeight,
                                    rowRenderer: renderRow,
                                    scrollToAlignment: "auto",
                                    scrollToIndex: selectedRowIndex,
                                    width: $2779c281b4cda1da$var$LIST_WIDTH
                                })
                            }),
                            hasNoSearchResults && /*#__PURE__*/ (0, $dc70d.jsx)((0, $dkZQn.QuickInsertEmptyState), {
                                mode: "inline",
                                spacing: "compact"
                            }),
                            externalControls && /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
                                testId: "registered-insert-menu-external-controls",
                                xcss: $2779c281b4cda1da$var$styles.externalControls,
                                children: externalControls
                            })
                        ]
                    }),
                    footer
                ]
            })
        })
    });
};

});
parcelRegister("afyUO", function(module, exports) {
"use strict";

var $vsDHM = parcelRequire("vsDHM");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "CellMeasurer", {
    enumerable: true,
    get: function get() {
        return $77666388f4653021$var$_CellMeasurer["default"];
    }
});
Object.defineProperty(module.exports, "CellMeasurerCache", {
    enumerable: true,
    get: function get() {
        return $77666388f4653021$var$_CellMeasurerCache["default"];
    }
});
module.exports["default"] = void 0;

var $77666388f4653021$var$_CellMeasurer = $vsDHM((parcelRequire("bWMdQ")));

var $77666388f4653021$var$_CellMeasurerCache = $vsDHM((parcelRequire("9Ke65")));
var $77666388f4653021$var$_default = module.exports["default"] = $77666388f4653021$var$_CellMeasurer["default"];

});
parcelRegister("bWMdQ", function(module, exports) {
"use strict";

var $vsDHM = parcelRequire("vsDHM");

var $kH7Qm = parcelRequire("kH7Qm");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $8b2a846dffe4a36f$var$_classCallCheck2 = $vsDHM((parcelRequire("bU4DC")));

var $8b2a846dffe4a36f$var$_createClass2 = $vsDHM((parcelRequire("ho58I")));

var $8b2a846dffe4a36f$var$_possibleConstructorReturn2 = $vsDHM((parcelRequire("jZYbL")));

var $8b2a846dffe4a36f$var$_getPrototypeOf2 = $vsDHM((parcelRequire("5LBNB")));

var $8b2a846dffe4a36f$var$_inherits2 = $vsDHM((parcelRequire("cWKCb")));

var $8b2a846dffe4a36f$var$_defineProperty2 = $vsDHM((parcelRequire("bpeOS")));

var $8b2a846dffe4a36f$var$_react = $8b2a846dffe4a36f$var$_interopRequireWildcard((parcelRequire("bSJIT")));
var $8b2a846dffe4a36f$var$React = $8b2a846dffe4a36f$var$_react;
function $8b2a846dffe4a36f$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($8b2a846dffe4a36f$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $8b2a846dffe4a36f$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $kH7Qm(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $8b2a846dffe4a36f$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $8b2a846dffe4a36f$var$_callSuper(t, o, e) {
    return o = (0, $8b2a846dffe4a36f$var$_getPrototypeOf2["default"])(o), (0, $8b2a846dffe4a36f$var$_possibleConstructorReturn2["default"])(t, $8b2a846dffe4a36f$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $8b2a846dffe4a36f$var$_getPrototypeOf2["default"])(t).constructor) : o.apply(t, e));
}
function $8b2a846dffe4a36f$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($8b2a846dffe4a36f$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
} /*:: import type {CellMeasureCache} from './types';*/ 
/*:: type Children = (params: {measure: () => void}) => React.Element<*>;*/ /*:: type Cell = {
  columnIndex: number,
  rowIndex: number,
};*/ /*:: type Props = {
  cache: CellMeasureCache,
  children: Children | React.Element<*>,
  columnIndex?: number,
  index?: number,
  parent: {
    invalidateCellSizeAfterRender?: (cell: Cell) => void,
    recomputeGridSize?: (cell: Cell) => void,
  },
  rowIndex?: number,
};*/ /**
 * Wraps a cell and measures its rendered content.
 * Measurements are stored in a per-cell cache.
 * Cached-content is not be re-measured.
 */ var $8b2a846dffe4a36f$var$CellMeasurer = module.exports["default"] = /*#__PURE__*/ function(_React$PureComponent) {
    function CellMeasurer() {
        var _this;
        (0, $8b2a846dffe4a36f$var$_classCallCheck2["default"])(this, CellMeasurer);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $8b2a846dffe4a36f$var$_callSuper(this, CellMeasurer, [].concat(args));
        (0, $8b2a846dffe4a36f$var$_defineProperty2["default"])(_this, "_child", /*#__PURE__*/ $8b2a846dffe4a36f$var$React.createRef());
        (0, $8b2a846dffe4a36f$var$_defineProperty2["default"])(_this, "_measure", function() {
            var _this$props = _this.props, cache = _this$props.cache, _this$props$columnInd = _this$props.columnIndex, columnIndex = _this$props$columnInd === void 0 ? 0 : _this$props$columnInd, parent = _this$props.parent, _this$props$rowIndex = _this$props.rowIndex, rowIndex = _this$props$rowIndex === void 0 ? _this.props.index || 0 : _this$props$rowIndex;
            var _this$_getCellMeasure = _this._getCellMeasurements(), height = _this$_getCellMeasure.height, width = _this$_getCellMeasure.width;
            if (height !== cache.getHeight(rowIndex, columnIndex) || width !== cache.getWidth(rowIndex, columnIndex)) {
                cache.set(rowIndex, columnIndex, width, height);
                if (parent && typeof parent.recomputeGridSize === 'function') parent.recomputeGridSize({
                    columnIndex: columnIndex,
                    rowIndex: rowIndex
                });
            }
        });
        (0, $8b2a846dffe4a36f$var$_defineProperty2["default"])(_this, "_registerChild", function(element) {
            if (element && !(element instanceof Element)) console.warn('CellMeasurer registerChild expects to be passed Element or null');
            _this._child.current = element;
            if (element) _this._maybeMeasureCell();
        });
        return _this;
    }
    (0, $8b2a846dffe4a36f$var$_inherits2["default"])(CellMeasurer, _React$PureComponent);
    return (0, $8b2a846dffe4a36f$var$_createClass2["default"])(CellMeasurer, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this._maybeMeasureCell();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this._maybeMeasureCell();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var children = this.props.children;
                var resolvedChildren = typeof children === 'function' ? children({
                    measure: this._measure,
                    registerChild: this._registerChild
                }) : children;
                if (resolvedChildren === null) return resolvedChildren;
                return /*#__PURE__*/ (0, $8b2a846dffe4a36f$var$_react.cloneElement)(resolvedChildren, {
                    ref: function ref(node) {
                        if (typeof resolvedChildren.ref === 'function') resolvedChildren.ref(node);
                        else if (resolvedChildren.ref) resolvedChildren.ref.current = node;
                        _this2._child.current = node;
                    }
                });
            }
        },
        {
            key: "_getCellMeasurements",
            value: function _getCellMeasurements() {
                var cache = this.props.cache;
                var node = this._child.current;
                // TODO Check for a bad combination of fixedWidth and missing numeric width or vice versa with height
                if (node && node.ownerDocument && node.ownerDocument.defaultView && node instanceof node.ownerDocument.defaultView.HTMLElement) {
                    var styleWidth = node.style.width;
                    var styleHeight = node.style.height;
                    // If we are re-measuring a cell that has already been measured,
                    // It will have a hard-coded width/height from the previous measurement.
                    // The fact that we are measuring indicates this measurement is probably stale,
                    // So explicitly clear it out (eg set to "auto") so we can recalculate.
                    // See issue #593 for more info.
                    // Even if we are measuring initially- if we're inside of a MultiGrid component,
                    // Explicitly clear width/height before measuring to avoid being tainted by another Grid.
                    // eg top/left Grid renders before bottom/right Grid
                    // Since the CellMeasurerCache is shared between them this taints derived cell size values.
                    if (!cache.hasFixedWidth()) node.style.width = 'auto';
                    if (!cache.hasFixedHeight()) node.style.height = 'auto';
                    var height = Math.ceil(node.offsetHeight);
                    var width = Math.ceil(node.offsetWidth);
                    // Reset after measuring to avoid breaking styles; see #660
                    if (styleWidth) node.style.width = styleWidth;
                    if (styleHeight) node.style.height = styleHeight;
                    return {
                        height: height,
                        width: width
                    };
                } else return {
                    height: 0,
                    width: 0
                };
            }
        },
        {
            key: "_maybeMeasureCell",
            value: function _maybeMeasureCell() {
                var _this$props2 = this.props, cache = _this$props2.cache, _this$props2$columnIn = _this$props2.columnIndex, columnIndex = _this$props2$columnIn === void 0 ? 0 : _this$props2$columnIn, parent = _this$props2.parent, _this$props2$rowIndex = _this$props2.rowIndex, rowIndex = _this$props2$rowIndex === void 0 ? this.props.index || 0 : _this$props2$rowIndex;
                if (!cache.has(rowIndex, columnIndex)) {
                    var _this$_getCellMeasure2 = this._getCellMeasurements(), height = _this$_getCellMeasure2.height, width = _this$_getCellMeasure2.width;
                    cache.set(rowIndex, columnIndex, width, height);
                    // If size has changed, let Grid know to re-render.
                    if (parent && typeof parent.invalidateCellSizeAfterRender === 'function') parent.invalidateCellSizeAfterRender({
                        columnIndex: columnIndex,
                        rowIndex: rowIndex
                    });
                }
            }
        }
    ]);
}($8b2a846dffe4a36f$var$React.PureComponent); // Used for DEV mode warning check
(0, $8b2a846dffe4a36f$var$_defineProperty2["default"])($8b2a846dffe4a36f$var$CellMeasurer, "__internalCellMeasurerFlag", false);

});

parcelRegister("9Ke65", function(module, exports) {
"use strict";

var $vsDHM = parcelRequire("vsDHM");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = module.exports.DEFAULT_WIDTH = module.exports.DEFAULT_HEIGHT = void 0;

var $718358552ee90cae$var$_classCallCheck2 = $vsDHM((parcelRequire("bU4DC")));

var $718358552ee90cae$var$_createClass2 = $vsDHM((parcelRequire("ho58I")));

var $718358552ee90cae$var$_defineProperty2 = $vsDHM((parcelRequire("bpeOS")));
/*:: import type {CellMeasureCache} from './types';*/ var $718358552ee90cae$var$DEFAULT_HEIGHT = module.exports.DEFAULT_HEIGHT = 30;
var $718358552ee90cae$var$DEFAULT_WIDTH = module.exports.DEFAULT_WIDTH = 100;
// Enables more intelligent mapping of a given column and row index to an item ID.
// This prevents a cell cache from being invalidated when its parent collection is modified.
/*:: type KeyMapper = (rowIndex: number, columnIndex: number) => any;*/ /*:: type CellMeasurerCacheParams = {
  defaultHeight?: number,
  defaultWidth?: number,
  fixedHeight?: boolean,
  fixedWidth?: boolean,
  minHeight?: number,
  minWidth?: number,
  keyMapper?: KeyMapper,
};*/ /*:: type Cache = {
  [key: any]: number,
};*/ /*:: type IndexParam = {
  index: number,
};*/ /**
 * Caches measurements for a given cell.
 */ var $718358552ee90cae$var$CellMeasurerCache = module.exports["default"] = /*#__PURE__*/ function() {
    function CellMeasurerCache() {
        var _this = this;
        var params /*: CellMeasurerCacheParams*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, $718358552ee90cae$var$_classCallCheck2["default"])(this, CellMeasurerCache);
        (0, $718358552ee90cae$var$_defineProperty2["default"])(this, "_cellHeightCache", {});
        (0, $718358552ee90cae$var$_defineProperty2["default"])(this, "_cellWidthCache", {});
        (0, $718358552ee90cae$var$_defineProperty2["default"])(this, "_columnWidthCache", {});
        (0, $718358552ee90cae$var$_defineProperty2["default"])(this, "_rowHeightCache", {});
        (0, $718358552ee90cae$var$_defineProperty2["default"])(this, "_defaultHeight", void 0);
        (0, $718358552ee90cae$var$_defineProperty2["default"])(this, "_defaultWidth", void 0);
        (0, $718358552ee90cae$var$_defineProperty2["default"])(this, "_minHeight", void 0);
        (0, $718358552ee90cae$var$_defineProperty2["default"])(this, "_minWidth", void 0);
        (0, $718358552ee90cae$var$_defineProperty2["default"])(this, "_keyMapper", void 0);
        (0, $718358552ee90cae$var$_defineProperty2["default"])(this, "_hasFixedHeight", void 0);
        (0, $718358552ee90cae$var$_defineProperty2["default"])(this, "_hasFixedWidth", void 0);
        (0, $718358552ee90cae$var$_defineProperty2["default"])(this, "_columnCount", 0);
        (0, $718358552ee90cae$var$_defineProperty2["default"])(this, "_rowCount", 0);
        (0, $718358552ee90cae$var$_defineProperty2["default"])(this, "columnWidth", function(_ref /*:: */ ) {
            var index = _ref /*:: */ .index;
            var key = _this._keyMapper(0, index);
            return _this._columnWidthCache[key] !== undefined ? _this._columnWidthCache[key] : _this._defaultWidth;
        });
        (0, $718358552ee90cae$var$_defineProperty2["default"])(this, "rowHeight", function(_ref2 /*:: */ ) {
            var index = _ref2 /*:: */ .index;
            var key = _this._keyMapper(index, 0);
            return _this._rowHeightCache[key] !== undefined ? _this._rowHeightCache[key] : _this._defaultHeight;
        });
        var defaultHeight = params.defaultHeight, defaultWidth = params.defaultWidth, fixedHeight = params.fixedHeight, fixedWidth = params.fixedWidth, keyMapper = params.keyMapper, minHeight = params.minHeight, minWidth = params.minWidth;
        this._hasFixedHeight = fixedHeight === true;
        this._hasFixedWidth = fixedWidth === true;
        this._minHeight = minHeight || 0;
        this._minWidth = minWidth || 0;
        this._keyMapper = keyMapper || $718358552ee90cae$var$defaultKeyMapper;
        this._defaultHeight = Math.max(this._minHeight, typeof defaultHeight === 'number' ? defaultHeight : $718358552ee90cae$var$DEFAULT_HEIGHT);
        this._defaultWidth = Math.max(this._minWidth, typeof defaultWidth === 'number' ? defaultWidth : $718358552ee90cae$var$DEFAULT_WIDTH);
    }
    return (0, $718358552ee90cae$var$_createClass2["default"])(CellMeasurerCache, [
        {
            key: "clear",
            value: function clear(rowIndex /*: number*/ ) {
                var columnIndex /*: number*/  = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                var key = this._keyMapper(rowIndex, columnIndex);
                delete this._cellHeightCache[key];
                delete this._cellWidthCache[key];
                this._updateCachedColumnAndRowSizes(rowIndex, columnIndex);
            }
        },
        {
            key: "clearAll",
            value: function clearAll() {
                this._cellHeightCache = {};
                this._cellWidthCache = {};
                this._columnWidthCache = {};
                this._rowHeightCache = {};
                this._rowCount = 0;
                this._columnCount = 0;
            }
        },
        {
            key: "defaultHeight",
            get: function get() /*: number*/ {
                return this._defaultHeight;
            }
        },
        {
            key: "defaultWidth",
            get: function get() /*: number*/ {
                return this._defaultWidth;
            }
        },
        {
            key: "hasFixedHeight",
            value: function hasFixedHeight() /*: boolean*/ {
                return this._hasFixedHeight;
            }
        },
        {
            key: "hasFixedWidth",
            value: function hasFixedWidth() /*: boolean*/ {
                return this._hasFixedWidth;
            }
        },
        {
            key: "getHeight",
            value: function getHeight(rowIndex /*: number*/ ) /*: number*/ {
                var columnIndex /*: number*/  = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                if (this._hasFixedHeight) return this._defaultHeight;
                else {
                    var _key = this._keyMapper(rowIndex, columnIndex);
                    return this._cellHeightCache[_key] !== undefined ? Math.max(this._minHeight, this._cellHeightCache[_key]) : this._defaultHeight;
                }
            }
        },
        {
            key: "getWidth",
            value: function getWidth(rowIndex /*: number*/ ) /*: number*/ {
                var columnIndex /*: number*/  = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                if (this._hasFixedWidth) return this._defaultWidth;
                else {
                    var _key2 = this._keyMapper(rowIndex, columnIndex);
                    return this._cellWidthCache[_key2] !== undefined ? Math.max(this._minWidth, this._cellWidthCache[_key2]) : this._defaultWidth;
                }
            }
        },
        {
            key: "has",
            value: function has(rowIndex /*: number*/ ) /*: boolean*/ {
                var columnIndex /*: number*/  = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                var key = this._keyMapper(rowIndex, columnIndex);
                return this._cellHeightCache[key] !== undefined;
            }
        },
        {
            key: "set",
            value: function set(rowIndex /*: number*/ , columnIndex /*: number*/ , width /*: number*/ , height /*: number*/ ) /*: void*/ {
                var key = this._keyMapper(rowIndex, columnIndex);
                if (columnIndex >= this._columnCount) this._columnCount = columnIndex + 1;
                if (rowIndex >= this._rowCount) this._rowCount = rowIndex + 1;
                // Size is cached per cell so we don't have to re-measure if cells are re-ordered.
                this._cellHeightCache[key] = height;
                this._cellWidthCache[key] = width;
                this._updateCachedColumnAndRowSizes(rowIndex, columnIndex);
            }
        },
        {
            key: "_updateCachedColumnAndRowSizes",
            value: function _updateCachedColumnAndRowSizes(rowIndex /*: number*/ , columnIndex /*: number*/ ) {
                // :columnWidth and :rowHeight are derived based on all cells in a column/row.
                // Pre-cache these derived values for faster lookup later.
                // Reads are expected to occur more frequently than writes in this case.
                // Only update non-fixed dimensions though to avoid doing unnecessary work.
                if (!this._hasFixedWidth) {
                    var columnWidth = 0;
                    for(var i = 0; i < this._rowCount; i++)columnWidth = Math.max(columnWidth, this.getWidth(i, columnIndex));
                    var columnKey = this._keyMapper(0, columnIndex);
                    this._columnWidthCache[columnKey] = columnWidth;
                }
                if (!this._hasFixedHeight) {
                    var rowHeight = 0;
                    for(var _i = 0; _i < this._columnCount; _i++)rowHeight = Math.max(rowHeight, this.getHeight(rowIndex, _i));
                    var rowKey = this._keyMapper(rowIndex, 0);
                    this._rowHeightCache[rowKey] = rowHeight;
                }
            }
        }
    ]);
}();
function $718358552ee90cae$var$defaultKeyMapper(rowIndex /*: number*/ , columnIndex /*: number*/ ) {
    return "".concat(rowIndex, "-").concat(columnIndex);
}

});


parcelRegister("dASxq", function(module, exports) {
"use strict";

var $vsDHM = parcelRequire("vsDHM");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "List", {
    enumerable: true,
    get: function get() {
        return $9e58f149dc892a5b$var$_List["default"];
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function get() {
        return $9e58f149dc892a5b$var$_List["default"];
    }
});

var $9e58f149dc892a5b$var$_List = $vsDHM((parcelRequire("lC4M9")));

});
parcelRegister("lC4M9", function(module, exports) {
"use strict";

var $vsDHM = parcelRequire("vsDHM");

var $kH7Qm = parcelRequire("kH7Qm");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $fbc0d9f2400f3401$var$_extends2 = $vsDHM((parcelRequire("f7z2D")));

var $fbc0d9f2400f3401$var$_classCallCheck2 = $vsDHM((parcelRequire("bU4DC")));

var $fbc0d9f2400f3401$var$_createClass2 = $vsDHM((parcelRequire("ho58I")));

var $fbc0d9f2400f3401$var$_possibleConstructorReturn2 = $vsDHM((parcelRequire("jZYbL")));

var $fbc0d9f2400f3401$var$_getPrototypeOf2 = $vsDHM((parcelRequire("5LBNB")));

var $fbc0d9f2400f3401$var$_inherits2 = $vsDHM((parcelRequire("cWKCb")));

var $fbc0d9f2400f3401$var$_defineProperty2 = $vsDHM((parcelRequire("bpeOS")));

var $fbc0d9f2400f3401$var$_Grid = $fbc0d9f2400f3401$var$_interopRequireWildcard((parcelRequire("8ag0t")));

var $fbc0d9f2400f3401$var$React = $fbc0d9f2400f3401$var$_interopRequireWildcard((parcelRequire("bSJIT")));

var $fbc0d9f2400f3401$var$_clsx = $vsDHM((parcelRequire("gFZMB")));
function $fbc0d9f2400f3401$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($fbc0d9f2400f3401$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $fbc0d9f2400f3401$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $kH7Qm(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $fbc0d9f2400f3401$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $fbc0d9f2400f3401$var$_callSuper(t, o, e) {
    return o = (0, $fbc0d9f2400f3401$var$_getPrototypeOf2["default"])(o), (0, $fbc0d9f2400f3401$var$_possibleConstructorReturn2["default"])(t, $fbc0d9f2400f3401$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $fbc0d9f2400f3401$var$_getPrototypeOf2["default"])(t).constructor) : o.apply(t, e));
}
function $fbc0d9f2400f3401$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($fbc0d9f2400f3401$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
} /*:: import type {
  NoContentRenderer,
  Alignment,
  CellSize,
  CellPosition,
  OverscanIndicesGetter,
  RenderedSection,
  CellRendererParams,
  Scroll as GridScroll,
} from '../Grid';*/ 
/*:: import type {RowRenderer, RenderedRows, Scroll} from './types';*/ /**
 * It is inefficient to create and manage a large list of DOM elements within a scrolling container
 * if only a few of those elements are visible. The primary purpose of this component is to improve
 * performance by only rendering the DOM nodes that a user is able to see based on their current
 * scroll position.
 *
 * This component renders a virtualized list of elements with either fixed or dynamic heights.
 */ /*:: type Props = {
  'aria-label'?: string,

  /**
   * Removes fixed height from the scrollingContainer so that the total height
   * of rows can stretch the window. Intended for use with WindowScroller
   *-/
  autoHeight: boolean,

  /** Optional CSS class name *-/
  className?: string,

  /**
   * Used to estimate the total height of a List before all of its rows have actually been measured.
   * The estimated total height is adjusted as rows are rendered.
   *-/
  estimatedRowSize: number,

  /** Height constraint for list (determines how many actual rows are rendered) *-/
  height: number,

  /** Optional renderer to be used in place of rows when rowCount is 0 *-/
  noRowsRenderer: NoContentRenderer,

  /** Callback invoked with information about the slice of rows that were just rendered.  *-/

  onRowsRendered: (params: RenderedRows) => void,

  /**
   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
   * This callback can be used to sync scrolling between lists, tables, or grids.
   *-/
  onScroll: (params: Scroll) => void,

  /** See Grid#overscanIndicesGetter *-/
  overscanIndicesGetter: OverscanIndicesGetter,

  /**
   * Number of rows to render above/below the visible bounds of the list.
   * These rows can help for smoother scrolling on touch devices.
   *-/
  overscanRowCount: number,

  /** Either a fixed row height (number) or a function that returns the height of a row given its index.  *-/
  rowHeight: CellSize,

  /** Responsible for rendering a row given an index; ({ index: number }): node *-/
  rowRenderer: RowRenderer,

  /** Number of rows in list. *-/
  rowCount: number,

  /** See Grid#scrollToAlignment *-/
  scrollToAlignment: Alignment,

  /** Row index to ensure visible (by forcefully scrolling if necessary) *-/
  scrollToIndex: number,

  /** Vertical offset. *-/
  scrollTop?: number,

  /** Optional inline style *-/
  style: Object,

  /** Tab index for focus *-/
  tabIndex?: number,

  /** Width of list *-/
  width: number,
};*/ var $fbc0d9f2400f3401$var$List = module.exports["default"] = /*#__PURE__*/ function(_React$PureComponent) {
    function List() {
        var _this;
        (0, $fbc0d9f2400f3401$var$_classCallCheck2["default"])(this, List);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $fbc0d9f2400f3401$var$_callSuper(this, List, [].concat(args));
        (0, $fbc0d9f2400f3401$var$_defineProperty2["default"])(_this, "Grid", void 0);
        (0, $fbc0d9f2400f3401$var$_defineProperty2["default"])(_this, "_cellRenderer", function(_ref /*:: */ ) {
            var parent = _ref /*:: */ .parent, rowIndex = _ref /*:: */ .rowIndex, style = _ref /*:: */ .style, isScrolling = _ref /*:: */ .isScrolling, isVisible = _ref /*:: */ .isVisible, key = _ref /*:: */ .key;
            var rowRenderer = _this.props.rowRenderer;
            // TRICKY The style object is sometimes cached by Grid.
            // This prevents new style objects from bypassing shallowCompare().
            // However as of React 16, style props are auto-frozen (at least in dev mode)
            // Check to make sure we can still modify the style before proceeding.
            // https://github.com/facebook/react/commit/977357765b44af8ff0cfea327866861073095c12#commitcomment-20648713
            var widthDescriptor = Object.getOwnPropertyDescriptor(style, 'width');
            if (widthDescriptor && widthDescriptor.writable) // By default, List cells should be 100% width.
            // This prevents them from flowing under a scrollbar (if present).
            style.width = '100%';
            return rowRenderer({
                index: rowIndex,
                style: style,
                isScrolling: isScrolling,
                isVisible: isVisible,
                key: key,
                parent: parent
            });
        });
        (0, $fbc0d9f2400f3401$var$_defineProperty2["default"])(_this, "_setRef", function(ref /*: ?React.ElementRef<typeof Grid>*/ ) {
            _this.Grid = ref;
        });
        (0, $fbc0d9f2400f3401$var$_defineProperty2["default"])(_this, "_onScroll", function(_ref2 /*:: */ ) {
            var clientHeight = _ref2 /*:: */ .clientHeight, scrollHeight = _ref2 /*:: */ .scrollHeight, scrollTop = _ref2 /*:: */ .scrollTop;
            var onScroll = _this.props.onScroll;
            onScroll({
                clientHeight: clientHeight,
                scrollHeight: scrollHeight,
                scrollTop: scrollTop
            });
        });
        (0, $fbc0d9f2400f3401$var$_defineProperty2["default"])(_this, "_onSectionRendered", function(_ref3 /*:: */ ) {
            var rowOverscanStartIndex = _ref3 /*:: */ .rowOverscanStartIndex, rowOverscanStopIndex = _ref3 /*:: */ .rowOverscanStopIndex, rowStartIndex = _ref3 /*:: */ .rowStartIndex, rowStopIndex = _ref3 /*:: */ .rowStopIndex;
            var onRowsRendered = _this.props.onRowsRendered;
            onRowsRendered({
                overscanStartIndex: rowOverscanStartIndex,
                overscanStopIndex: rowOverscanStopIndex,
                startIndex: rowStartIndex,
                stopIndex: rowStopIndex
            });
        });
        return _this;
    }
    (0, $fbc0d9f2400f3401$var$_inherits2["default"])(List, _React$PureComponent);
    return (0, $fbc0d9f2400f3401$var$_createClass2["default"])(List, [
        {
            key: "forceUpdateGrid",
            value: function forceUpdateGrid() {
                if (this.Grid) this.Grid.forceUpdate();
            }
        },
        {
            key: "getOffsetForRow",
            value: function getOffsetForRow(_ref4 /*:: */ ) {
                var alignment = _ref4 /*:: */ .alignment, index = _ref4 /*:: */ .index;
                if (this.Grid) {
                    var _this$Grid$getOffsetF = this.Grid.getOffsetForCell({
                        alignment: alignment,
                        rowIndex: index,
                        columnIndex: 0
                    }), scrollTop = _this$Grid$getOffsetF.scrollTop;
                    return scrollTop;
                }
                return 0;
            }
        },
        {
            key: "invalidateCellSizeAfterRender",
            value: function invalidateCellSizeAfterRender(_ref5 /*:: */ ) {
                var columnIndex = _ref5 /*:: */ .columnIndex, rowIndex = _ref5 /*:: */ .rowIndex;
                if (this.Grid) this.Grid.invalidateCellSizeAfterRender({
                    rowIndex: rowIndex,
                    columnIndex: columnIndex
                });
            }
        },
        {
            key: "measureAllRows",
            value: function measureAllRows() {
                if (this.Grid) this.Grid.measureAllCells();
            }
        },
        {
            key: "recomputeGridSize",
            value: function recomputeGridSize() {
                var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref6$columnIndex = _ref6.columnIndex, columnIndex = _ref6$columnIndex === void 0 ? 0 : _ref6$columnIndex, _ref6$rowIndex = _ref6.rowIndex, rowIndex = _ref6$rowIndex === void 0 ? 0 : _ref6$rowIndex;
                if (this.Grid) this.Grid.recomputeGridSize({
                    rowIndex: rowIndex,
                    columnIndex: columnIndex
                });
            }
        },
        {
            key: "recomputeRowHeights",
            value: function recomputeRowHeights() {
                var index /*: number*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                if (this.Grid) this.Grid.recomputeGridSize({
                    rowIndex: index,
                    columnIndex: 0
                });
            }
        },
        {
            key: "scrollToPosition",
            value: function scrollToPosition() {
                var scrollTop /*: number*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                if (this.Grid) this.Grid.scrollToPosition({
                    scrollTop: scrollTop
                });
            }
        },
        {
            key: "scrollToRow",
            value: function scrollToRow() {
                var index /*: number*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                if (this.Grid) this.Grid.scrollToCell({
                    columnIndex: 0,
                    rowIndex: index
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, className = _this$props.className, noRowsRenderer = _this$props.noRowsRenderer, scrollToIndex = _this$props.scrollToIndex, width = _this$props.width;
                var classNames = (0, $fbc0d9f2400f3401$var$_clsx["default"])('ReactVirtualized__List', className);
                return /*#__PURE__*/ $fbc0d9f2400f3401$var$React.createElement($fbc0d9f2400f3401$var$_Grid["default"], (0, $fbc0d9f2400f3401$var$_extends2["default"])({}, this.props, {
                    autoContainerWidth: true,
                    cellRenderer: this._cellRenderer,
                    className: classNames,
                    columnWidth: width,
                    columnCount: 1,
                    noContentRenderer: noRowsRenderer,
                    onScroll: this._onScroll,
                    onSectionRendered: this._onSectionRendered,
                    ref: this._setRef,
                    scrollToRow: scrollToIndex
                }));
            }
        }
    ]);
}($fbc0d9f2400f3401$var$React.PureComponent);
(0, $fbc0d9f2400f3401$var$_defineProperty2["default"])($fbc0d9f2400f3401$var$List, "defaultProps", {
    autoHeight: false,
    estimatedRowSize: 30,
    onScroll: function onScroll() {},
    noRowsRenderer: function noRowsRenderer() {
        return null;
    },
    onRowsRendered: function onRowsRendered() {},
    overscanIndicesGetter: $fbc0d9f2400f3401$var$_Grid.accessibilityOverscanIndicesGetter,
    overscanRowCount: 10,
    scrollToAlignment: 'auto',
    scrollToIndex: -1,
    style: {}
});

});
parcelRegister("8ag0t", function(module, exports) {
"use strict";

var $vsDHM = parcelRequire("vsDHM");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "Grid", {
    enumerable: true,
    get: function get() {
        return $5f1bac7f8de48b75$var$_Grid["default"];
    }
});
Object.defineProperty(module.exports, "accessibilityOverscanIndicesGetter", {
    enumerable: true,
    get: function get() {
        return $5f1bac7f8de48b75$var$_accessibilityOverscanIndicesGetter["default"];
    }
});
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function get() {
        return $5f1bac7f8de48b75$var$_Grid["default"];
    }
});
Object.defineProperty(module.exports, "defaultCellRangeRenderer", {
    enumerable: true,
    get: function get() {
        return $5f1bac7f8de48b75$var$_defaultCellRangeRenderer["default"];
    }
});
Object.defineProperty(module.exports, "defaultOverscanIndicesGetter", {
    enumerable: true,
    get: function get() {
        return $5f1bac7f8de48b75$var$_defaultOverscanIndicesGetter["default"];
    }
});

var $5f1bac7f8de48b75$var$_Grid = $vsDHM((parcelRequire("4FxVk")));

var $5f1bac7f8de48b75$var$_accessibilityOverscanIndicesGetter = $vsDHM((parcelRequire("kXEDY")));

var $5f1bac7f8de48b75$var$_defaultCellRangeRenderer = $vsDHM((parcelRequire("lkxZ0")));

var $5f1bac7f8de48b75$var$_defaultOverscanIndicesGetter = $vsDHM((parcelRequire("9wmqs")));

});
parcelRegister("4FxVk", function(module, exports) {
"use strict";

var $vsDHM = parcelRequire("vsDHM");

Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = module.exports.DEFAULT_SCROLLING_RESET_TIME_INTERVAL = void 0;

var $36654e4dc6f53891$var$_extends2 = $vsDHM((parcelRequire("f7z2D")));

var $36654e4dc6f53891$var$_typeof2 = $vsDHM((parcelRequire("kH7Qm")));

var $36654e4dc6f53891$var$_classCallCheck2 = $vsDHM((parcelRequire("bU4DC")));

var $36654e4dc6f53891$var$_createClass2 = $vsDHM((parcelRequire("ho58I")));

var $36654e4dc6f53891$var$_possibleConstructorReturn2 = $vsDHM((parcelRequire("jZYbL")));

var $36654e4dc6f53891$var$_getPrototypeOf2 = $vsDHM((parcelRequire("5LBNB")));

var $36654e4dc6f53891$var$_inherits2 = $vsDHM((parcelRequire("cWKCb")));

var $36654e4dc6f53891$var$_defineProperty2 = $vsDHM((parcelRequire("bpeOS")));

var $36654e4dc6f53891$var$React = $36654e4dc6f53891$var$_interopRequireWildcard((parcelRequire("bSJIT")));

var $36654e4dc6f53891$var$_clsx = $vsDHM((parcelRequire("gFZMB")));

var $36654e4dc6f53891$var$_calculateSizeAndPositionDataAndUpdateScrollOffset = $vsDHM((parcelRequire("lNx1E")));

var $36654e4dc6f53891$var$_ScalingCellSizeAndPositionManager = $vsDHM((parcelRequire("j2OYZ")));

var $36654e4dc6f53891$var$_createCallbackMemoizer = $vsDHM((parcelRequire("5MR4I")));

var $36654e4dc6f53891$var$_defaultOverscanIndicesGetter = $36654e4dc6f53891$var$_interopRequireWildcard((parcelRequire("9wmqs")));

var $36654e4dc6f53891$var$_updateScrollIndexHelper = $vsDHM((parcelRequire("bliQZ")));

var $36654e4dc6f53891$var$_defaultCellRangeRenderer = $vsDHM((parcelRequire("lkxZ0")));

var $36654e4dc6f53891$var$_scrollbarSize = $vsDHM((parcelRequire("cFh2O")));

var $hudco = parcelRequire("hudco");

var $cKDwS = parcelRequire("cKDwS");
function $36654e4dc6f53891$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($36654e4dc6f53891$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $36654e4dc6f53891$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != (parcelRequire("kH7Qm"))(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $36654e4dc6f53891$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $36654e4dc6f53891$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $36654e4dc6f53891$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $36654e4dc6f53891$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $36654e4dc6f53891$var$_defineProperty2["default"])(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $36654e4dc6f53891$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $36654e4dc6f53891$var$_callSuper(t, o, e) {
    return o = (0, $36654e4dc6f53891$var$_getPrototypeOf2["default"])(o), (0, $36654e4dc6f53891$var$_possibleConstructorReturn2["default"])(t, $36654e4dc6f53891$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, $36654e4dc6f53891$var$_getPrototypeOf2["default"])(t).constructor) : o.apply(t, e));
}
function $36654e4dc6f53891$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($36654e4dc6f53891$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
} /*:: import type {
  CellRenderer,
  CellRangeRenderer,
  CellPosition,
  CellSize,
  CellSizeGetter,
  NoContentRenderer,
  Scroll,
  ScrollbarPresenceChange,
  RenderedSection,
  OverscanIndicesGetter,
  Alignment,
  CellCache,
  StyleCache,
} from './types';*/ 
/*:: import type {AnimationTimeoutId} from '../utils/requestAnimationTimeout';*/ /**
 * Specifies the number of milliseconds during which to disable pointer events while a scroll is in progress.
 * This improves performance and makes scrolling smoother.
 */ var $36654e4dc6f53891$var$DEFAULT_SCROLLING_RESET_TIME_INTERVAL = module.exports.DEFAULT_SCROLLING_RESET_TIME_INTERVAL = 150;
/**
 * Controls whether the Grid updates the DOM element's scrollLeft/scrollTop based on the current state or just observes it.
 * This prevents Grid from interrupting mouse-wheel animations (see issue #2).
 */ var $36654e4dc6f53891$var$SCROLL_POSITION_CHANGE_REASONS = {
    OBSERVED: 'observed',
    REQUESTED: 'requested'
};
var $36654e4dc6f53891$var$renderNull /*: NoContentRenderer*/  = function renderNull() {
    return null;
};
/*:: type ScrollPosition = {
  scrollTop?: number,
  scrollLeft?: number,
};*/ /*:: type Props = {
  'aria-label': string,
  'aria-readonly'?: boolean,

  /**
   * Set the width of the inner scrollable container to 'auto'.
   * This is useful for single-column Grids to ensure that the column doesn't extend below a vertical scrollbar.
   *-/
  autoContainerWidth: boolean,

  /**
   * Removes fixed height from the scrollingContainer so that the total height of rows can stretch the window.
   * Intended for use with WindowScroller
   *-/
  autoHeight: boolean,

  /**
   * Removes fixed width from the scrollingContainer so that the total width of rows can stretch the window.
   * Intended for use with WindowScroller
   *-/
  autoWidth: boolean,

  /** Responsible for rendering a cell given an row and column index.  *-/
  cellRenderer: CellRenderer,

  /** Responsible for rendering a group of cells given their index ranges.  *-/
  cellRangeRenderer: CellRangeRenderer,

  /** Optional custom CSS class name to attach to root Grid element.  *-/
  className?: string,

  /** Number of columns in grid.  *-/
  columnCount: number,

  /** Either a fixed column width (number) or a function that returns the width of a column given its index.  *-/
  columnWidth: CellSize,

  /** Unfiltered props for the Grid container. *-/
  containerProps?: Object,

  /** ARIA role for the cell-container.  *-/
  containerRole: string,

  /** Optional inline style applied to inner cell-container *-/
  containerStyle: Object,

  /**
   * If CellMeasurer is used to measure this Grid's children, this should be a pointer to its CellMeasurerCache.
   * A shared CellMeasurerCache reference enables Grid and CellMeasurer to share measurement data.
   *-/
  deferredMeasurementCache?: Object,

  /**
   * Used to estimate the total width of a Grid before all of its columns have actually been measured.
   * The estimated total width is adjusted as columns are rendered.
   *-/
  estimatedColumnSize: number,

  /**
   * Used to estimate the total height of a Grid before all of its rows have actually been measured.
   * The estimated total height is adjusted as rows are rendered.
   *-/
  estimatedRowSize: number,

  /** Exposed for testing purposes only.  *-/
  getScrollbarSize: () => number,

  /** Height of Grid; this property determines the number of visible (vs virtualized) rows.  *-/
  height: number,

  /** Optional custom id to attach to root Grid element.  *-/
  id?: string,

  /**
   * Override internal is-scrolling state tracking.
   * This property is primarily intended for use with the WindowScroller component.
   *-/
  isScrolling?: boolean,

  /**
   * Opt-out of isScrolling param passed to cellRangeRenderer.
   * To avoid the extra render when scroll stops.
   *-/
  isScrollingOptOut: boolean,

  /** Optional renderer to be used in place of rows when either :rowCount or :columnCount is 0.  *-/
  noContentRenderer: NoContentRenderer,

  /**
   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
   * This callback can be used to sync scrolling between lists, tables, or grids.
   *-/
  onScroll: (params: Scroll) => void,

  /**
   * Called whenever a horizontal or vertical scrollbar is added or removed.
   * This prop is not intended for end-user use;
   * It is used by MultiGrid to support fixed-row/fixed-column scroll syncing.
   *-/
  onScrollbarPresenceChange: (params: ScrollbarPresenceChange) => void,

  /** Callback invoked with information about the section of the Grid that was just rendered.  *-/
  onSectionRendered: (params: RenderedSection) => void,

  /**
   * Number of columns to render before/after the visible section of the grid.
   * These columns can help for smoother scrolling on touch devices or browsers that send scroll events infrequently.
   *-/
  overscanColumnCount: number,

  /**
   * Calculates the number of cells to overscan before and after a specified range.
   * This function ensures that overscanning doesn't exceed the available cells.
   *-/
  overscanIndicesGetter: OverscanIndicesGetter,

  /**
   * Number of rows to render above/below the visible section of the grid.
   * These rows can help for smoother scrolling on touch devices or browsers that send scroll events infrequently.
   *-/
  overscanRowCount: number,

  /** ARIA role for the grid element.  *-/
  role: string,

  /**
   * Either a fixed row height (number) or a function that returns the height of a row given its index.
   * Should implement the following interface: ({ index: number }): number
   *-/
  rowHeight: CellSize,

  /** Number of rows in grid.  *-/
  rowCount: number,

  /** Wait this amount of time after the last scroll event before resetting Grid `pointer-events`. *-/
  scrollingResetTimeInterval: number,

  /** Horizontal offset. *-/
  scrollLeft?: number,

  /**
   * Controls scroll-to-cell behavior of the Grid.
   * The default ("auto") scrolls the least amount possible to ensure that the specified cell is fully visible.
   * Use "start" to align cells to the top/left of the Grid and "end" to align bottom/right.
   *-/
  scrollToAlignment: Alignment,

  /** Column index to ensure visible (by forcefully scrolling if necessary) *-/
  scrollToColumn: number,

  /** Vertical offset. *-/
  scrollTop?: number,

  /** Row index to ensure visible (by forcefully scrolling if necessary) *-/
  scrollToRow: number,

  /** Optional inline style *-/
  style: Object,

  /** Tab index for focus *-/
  tabIndex: ?number,

  /** Width of Grid; this property determines the number of visible (vs virtualized) columns.  *-/
  width: number,

  /** Reference to DOM node *-/
  elementRef?: React.Ref<React.ElementType>,
};*/ /*:: type InstanceProps = {
  prevColumnWidth: CellSize,
  prevRowHeight: CellSize,

  prevColumnCount: number,
  prevRowCount: number,
  prevIsScrolling: boolean,
  prevScrollToColumn: number,
  prevScrollToRow: number,

  columnSizeAndPositionManager: ScalingCellSizeAndPositionManager,
  rowSizeAndPositionManager: ScalingCellSizeAndPositionManager,

  scrollbarSize: number,
  scrollbarSizeMeasured: boolean,
};*/ /*:: type State = {
  instanceProps: InstanceProps,
  isScrolling: boolean,
  scrollDirectionHorizontal: -1 | 1,
  scrollDirectionVertical: -1 | 1,
  scrollLeft: number,
  scrollTop: number,
  scrollPositionChangeReason: 'observed' | 'requested' | null,
  needToResetStyleCache: boolean,
};*/ /**
 * Renders tabular data with virtualization along the vertical and horizontal axes.
 * Row heights and column widths must be known ahead of time and specified as properties.
 */ var $36654e4dc6f53891$var$Grid = /*#__PURE__*/ function(_React$PureComponent) {
    function Grid(props /*: Props*/ ) {
        var _this;
        (0, $36654e4dc6f53891$var$_classCallCheck2["default"])(this, Grid);
        _this = $36654e4dc6f53891$var$_callSuper(this, Grid, [
            props
        ]);
        // Invokes onSectionRendered callback only when start/stop row or column indices change
        (0, $36654e4dc6f53891$var$_defineProperty2["default"])(_this, "_onGridRenderedMemoizer", (0, $36654e4dc6f53891$var$_createCallbackMemoizer["default"])());
        (0, $36654e4dc6f53891$var$_defineProperty2["default"])(_this, "_onScrollMemoizer", (0, $36654e4dc6f53891$var$_createCallbackMemoizer["default"])(false));
        (0, $36654e4dc6f53891$var$_defineProperty2["default"])(_this, "_deferredInvalidateColumnIndex", null);
        (0, $36654e4dc6f53891$var$_defineProperty2["default"])(_this, "_deferredInvalidateRowIndex", null);
        (0, $36654e4dc6f53891$var$_defineProperty2["default"])(_this, "_recomputeScrollLeftFlag", false);
        (0, $36654e4dc6f53891$var$_defineProperty2["default"])(_this, "_recomputeScrollTopFlag", false);
        (0, $36654e4dc6f53891$var$_defineProperty2["default"])(_this, "_horizontalScrollBarSize", 0);
        (0, $36654e4dc6f53891$var$_defineProperty2["default"])(_this, "_verticalScrollBarSize", 0);
        (0, $36654e4dc6f53891$var$_defineProperty2["default"])(_this, "_scrollbarPresenceChanged", false);
        (0, $36654e4dc6f53891$var$_defineProperty2["default"])(_this, "_scrollingContainer", void 0);
        (0, $36654e4dc6f53891$var$_defineProperty2["default"])(_this, "_childrenToDisplay", void 0);
        (0, $36654e4dc6f53891$var$_defineProperty2["default"])(_this, "_columnStartIndex", void 0);
        (0, $36654e4dc6f53891$var$_defineProperty2["default"])(_this, "_columnStopIndex", void 0);
        (0, $36654e4dc6f53891$var$_defineProperty2["default"])(_this, "_rowStartIndex", void 0);
        (0, $36654e4dc6f53891$var$_defineProperty2["default"])(_this, "_rowStopIndex", void 0);
        (0, $36654e4dc6f53891$var$_defineProperty2["default"])(_this, "_renderedColumnStartIndex", 0);
        (0, $36654e4dc6f53891$var$_defineProperty2["default"])(_this, "_renderedColumnStopIndex", 0);
        (0, $36654e4dc6f53891$var$_defineProperty2["default"])(_this, "_renderedRowStartIndex", 0);
        (0, $36654e4dc6f53891$var$_defineProperty2["default"])(_this, "_renderedRowStopIndex", 0);
        (0, $36654e4dc6f53891$var$_defineProperty2["default"])(_this, "_initialScrollTop", void 0);
        (0, $36654e4dc6f53891$var$_defineProperty2["default"])(_this, "_initialScrollLeft", void 0);
        (0, $36654e4dc6f53891$var$_defineProperty2["default"])(_this, "_disablePointerEventsTimeoutId", void 0);
        (0, $36654e4dc6f53891$var$_defineProperty2["default"])(_this, "_styleCache", {});
        (0, $36654e4dc6f53891$var$_defineProperty2["default"])(_this, "_cellCache", {});
        (0, $36654e4dc6f53891$var$_defineProperty2["default"])(_this, "_debounceScrollEndedCallback", function() {
            _this._disablePointerEventsTimeoutId = null;
            // isScrolling is used to determine if we reset styleCache
            _this.setState({
                isScrolling: false,
                needToResetStyleCache: false
            });
        });
        (0, $36654e4dc6f53891$var$_defineProperty2["default"])(_this, "_invokeOnGridRenderedHelper", function() {
            var onSectionRendered = _this.props.onSectionRendered;
            _this._onGridRenderedMemoizer({
                callback: onSectionRendered,
                indices: {
                    columnOverscanStartIndex: _this._columnStartIndex,
                    columnOverscanStopIndex: _this._columnStopIndex,
                    columnStartIndex: _this._renderedColumnStartIndex,
                    columnStopIndex: _this._renderedColumnStopIndex,
                    rowOverscanStartIndex: _this._rowStartIndex,
                    rowOverscanStopIndex: _this._rowStopIndex,
                    rowStartIndex: _this._renderedRowStartIndex,
                    rowStopIndex: _this._renderedRowStopIndex
                }
            });
        });
        (0, $36654e4dc6f53891$var$_defineProperty2["default"])(_this, "_setScrollingContainerRef", function(ref /*: Element*/ ) {
            _this._scrollingContainer = ref;
            if (typeof _this.props.elementRef === 'function') _this.props.elementRef(ref);
            else if ((0, $36654e4dc6f53891$var$_typeof2["default"])(_this.props.elementRef) === 'object') _this.props.elementRef.current = ref;
        });
        (0, $36654e4dc6f53891$var$_defineProperty2["default"])(_this, "_onScroll", function(event /*: Event*/ ) {
            // In certain edge-cases React dispatches an onScroll event with an invalid target.scrollLeft / target.scrollTop.
            // This invalid event can be detected by comparing event.target to this component's scrollable DOM element.
            // See issue #404 for more information.
            if (event.target === _this._scrollingContainer) _this.handleScrollEvent(event.target /*: any*/ );
        });
        var columnSizeAndPositionManager = new $36654e4dc6f53891$var$_ScalingCellSizeAndPositionManager["default"]({
            cellCount: props.columnCount,
            cellSizeGetter: function cellSizeGetter(params) {
                return Grid._wrapSizeGetter(props.columnWidth)(params);
            },
            estimatedCellSize: Grid._getEstimatedColumnSize(props)
        });
        var rowSizeAndPositionManager = new $36654e4dc6f53891$var$_ScalingCellSizeAndPositionManager["default"]({
            cellCount: props.rowCount,
            cellSizeGetter: function cellSizeGetter(params) {
                return Grid._wrapSizeGetter(props.rowHeight)(params);
            },
            estimatedCellSize: Grid._getEstimatedRowSize(props)
        });
        _this.state = {
            instanceProps: {
                columnSizeAndPositionManager: columnSizeAndPositionManager,
                rowSizeAndPositionManager: rowSizeAndPositionManager,
                prevColumnWidth: props.columnWidth,
                prevRowHeight: props.rowHeight,
                prevColumnCount: props.columnCount,
                prevRowCount: props.rowCount,
                prevIsScrolling: props.isScrolling === true,
                prevScrollToColumn: props.scrollToColumn,
                prevScrollToRow: props.scrollToRow,
                scrollbarSize: 0,
                scrollbarSizeMeasured: false
            },
            isScrolling: false,
            scrollDirectionHorizontal: $36654e4dc6f53891$var$_defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD,
            scrollDirectionVertical: $36654e4dc6f53891$var$_defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD,
            scrollLeft: 0,
            scrollTop: 0,
            scrollPositionChangeReason: null,
            needToResetStyleCache: false
        };
        if (props.scrollToRow > 0) _this._initialScrollTop = _this._getCalculatedScrollTop(props, _this.state);
        if (props.scrollToColumn > 0) _this._initialScrollLeft = _this._getCalculatedScrollLeft(props, _this.state);
        return _this;
    }
    /**
   * Gets offsets for a given cell and alignment.
   */ (0, $36654e4dc6f53891$var$_inherits2["default"])(Grid, _React$PureComponent);
    return (0, $36654e4dc6f53891$var$_createClass2["default"])(Grid, [
        {
            key: "getOffsetForCell",
            value: function getOffsetForCell() {
                var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref$alignment = _ref.alignment, alignment = _ref$alignment === void 0 ? this.props.scrollToAlignment : _ref$alignment, _ref$columnIndex = _ref.columnIndex, columnIndex = _ref$columnIndex === void 0 ? this.props.scrollToColumn : _ref$columnIndex, _ref$rowIndex = _ref.rowIndex, rowIndex = _ref$rowIndex === void 0 ? this.props.scrollToRow : _ref$rowIndex;
                var offsetProps = $36654e4dc6f53891$var$_objectSpread($36654e4dc6f53891$var$_objectSpread({}, this.props), {}, {
                    scrollToAlignment: alignment,
                    scrollToColumn: columnIndex,
                    scrollToRow: rowIndex
                });
                return {
                    scrollLeft: this._getCalculatedScrollLeft(offsetProps),
                    scrollTop: this._getCalculatedScrollTop(offsetProps)
                };
            }
        },
        {
            key: "getTotalRowsHeight",
            value: function getTotalRowsHeight() {
                return this.state.instanceProps.rowSizeAndPositionManager.getTotalSize();
            }
        },
        {
            key: "getTotalColumnsWidth",
            value: function getTotalColumnsWidth() {
                return this.state.instanceProps.columnSizeAndPositionManager.getTotalSize();
            }
        },
        {
            key: "handleScrollEvent",
            value: function handleScrollEvent(_ref2 /*:: */ ) {
                var _ref2$scrollLeft = _ref2 /*:: */ .scrollLeft, scrollLeftParam = _ref2$scrollLeft === void 0 ? 0 : _ref2$scrollLeft, _ref2$scrollTop = _ref2 /*:: */ .scrollTop, scrollTopParam = _ref2$scrollTop === void 0 ? 0 : _ref2$scrollTop;
                // On iOS, we can arrive at negative offsets by swiping past the start.
                // To prevent flicker here, we make playing in the negative offset zone cause nothing to happen.
                if (scrollTopParam < 0) return;
                // Prevent pointer events from interrupting a smooth scroll
                this._debounceScrollEnded();
                var _this$props = this.props, autoHeight = _this$props.autoHeight, autoWidth = _this$props.autoWidth, height = _this$props.height, width = _this$props.width;
                var instanceProps = this.state.instanceProps;
                // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
                // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
                // This causes a series of rapid renders that is slow for long lists.
                // We can avoid that by doing some simple bounds checking to ensure that scroll offsets never exceed their bounds.
                var scrollbarSize = instanceProps.scrollbarSize;
                var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
                var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
                var scrollLeft = Math.min(Math.max(0, totalColumnsWidth - width + scrollbarSize), scrollLeftParam);
                var scrollTop = Math.min(Math.max(0, totalRowsHeight - height + scrollbarSize), scrollTopParam);
                // Certain devices (like Apple touchpad) rapid-fire duplicate events.
                // Don't force a re-render if this is the case.
                // The mouse may move faster then the animation frame does.
                // Use requestAnimationFrame to avoid over-updating.
                if (this.state.scrollLeft !== scrollLeft || this.state.scrollTop !== scrollTop) {
                    // Track scrolling direction so we can more efficiently overscan rows to reduce empty space around the edges while scrolling.
                    // Don't change direction for an axis unless scroll offset has changed.
                    var scrollDirectionHorizontal = scrollLeft !== this.state.scrollLeft ? scrollLeft > this.state.scrollLeft ? $36654e4dc6f53891$var$_defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD : $36654e4dc6f53891$var$_defaultOverscanIndicesGetter.SCROLL_DIRECTION_BACKWARD : this.state.scrollDirectionHorizontal;
                    var scrollDirectionVertical = scrollTop !== this.state.scrollTop ? scrollTop > this.state.scrollTop ? $36654e4dc6f53891$var$_defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD : $36654e4dc6f53891$var$_defaultOverscanIndicesGetter.SCROLL_DIRECTION_BACKWARD : this.state.scrollDirectionVertical;
                    var newState /*: $Shape<State>*/  = {
                        isScrolling: true,
                        scrollDirectionHorizontal: scrollDirectionHorizontal,
                        scrollDirectionVertical: scrollDirectionVertical,
                        scrollPositionChangeReason: $36654e4dc6f53891$var$SCROLL_POSITION_CHANGE_REASONS.OBSERVED
                    };
                    if (!autoHeight) newState.scrollTop = scrollTop;
                    if (!autoWidth) newState.scrollLeft = scrollLeft;
                    newState.needToResetStyleCache = false;
                    this.setState(newState);
                }
                this._invokeOnScrollMemoizer({
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop,
                    totalColumnsWidth: totalColumnsWidth,
                    totalRowsHeight: totalRowsHeight
                });
            }
        },
        {
            key: "invalidateCellSizeAfterRender",
            value: function invalidateCellSizeAfterRender(_ref3 /*:: */ ) {
                var columnIndex = _ref3 /*:: */ .columnIndex, rowIndex = _ref3 /*:: */ .rowIndex;
                this._deferredInvalidateColumnIndex = typeof this._deferredInvalidateColumnIndex === 'number' ? Math.min(this._deferredInvalidateColumnIndex, columnIndex) : columnIndex;
                this._deferredInvalidateRowIndex = typeof this._deferredInvalidateRowIndex === 'number' ? Math.min(this._deferredInvalidateRowIndex, rowIndex) : rowIndex;
            }
        },
        {
            key: "measureAllCells",
            value: function measureAllCells() {
                var _this$props2 = this.props, columnCount = _this$props2.columnCount, rowCount = _this$props2.rowCount;
                var instanceProps = this.state.instanceProps;
                instanceProps.columnSizeAndPositionManager.getSizeAndPositionOfCell(columnCount - 1);
                instanceProps.rowSizeAndPositionManager.getSizeAndPositionOfCell(rowCount - 1);
            }
        },
        {
            key: "recomputeGridSize",
            value: function recomputeGridSize() {
                var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref4$columnIndex = _ref4.columnIndex, columnIndex = _ref4$columnIndex === void 0 ? 0 : _ref4$columnIndex, _ref4$rowIndex = _ref4.rowIndex, rowIndex = _ref4$rowIndex === void 0 ? 0 : _ref4$rowIndex;
                var _this$props3 = this.props, scrollToColumn = _this$props3.scrollToColumn, scrollToRow = _this$props3.scrollToRow;
                var instanceProps = this.state.instanceProps;
                instanceProps.columnSizeAndPositionManager.resetCell(columnIndex);
                instanceProps.rowSizeAndPositionManager.resetCell(rowIndex);
                // Cell sizes may be determined by a function property.
                // In this case the cDU handler can't know if they changed.
                // Store this flag to let the next cDU pass know it needs to recompute the scroll offset.
                this._recomputeScrollLeftFlag = scrollToColumn >= 0 && (this.state.scrollDirectionHorizontal === $36654e4dc6f53891$var$_defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD ? columnIndex <= scrollToColumn : columnIndex >= scrollToColumn);
                this._recomputeScrollTopFlag = scrollToRow >= 0 && (this.state.scrollDirectionVertical === $36654e4dc6f53891$var$_defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD ? rowIndex <= scrollToRow : rowIndex >= scrollToRow);
                // Clear cell cache in case we are scrolling;
                // Invalid row heights likely mean invalid cached content as well.
                this._styleCache = {};
                this._cellCache = {};
                this.forceUpdate();
            }
        },
        {
            key: "scrollToCell",
            value: function scrollToCell(_ref5 /*:: */ ) {
                var columnIndex = _ref5 /*:: */ .columnIndex, rowIndex = _ref5 /*:: */ .rowIndex;
                var columnCount = this.props.columnCount;
                var props = this.props;
                // Don't adjust scroll offset for single-column grids (eg List, Table).
                // This can cause a funky scroll offset because of the vertical scrollbar width.
                if (columnCount > 1 && columnIndex !== undefined) this._updateScrollLeftForScrollToColumn($36654e4dc6f53891$var$_objectSpread($36654e4dc6f53891$var$_objectSpread({}, props), {}, {
                    scrollToColumn: columnIndex
                }));
                if (rowIndex !== undefined) this._updateScrollTopForScrollToRow($36654e4dc6f53891$var$_objectSpread($36654e4dc6f53891$var$_objectSpread({}, props), {}, {
                    scrollToRow: rowIndex
                }));
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this$props4 = this.props, getScrollbarSize = _this$props4.getScrollbarSize, height = _this$props4.height, scrollLeft = _this$props4.scrollLeft, scrollToColumn = _this$props4.scrollToColumn, scrollTop = _this$props4.scrollTop, scrollToRow = _this$props4.scrollToRow, width = _this$props4.width;
                var instanceProps = this.state.instanceProps;
                // Reset initial offsets to be ignored in browser
                this._initialScrollTop = 0;
                this._initialScrollLeft = 0;
                // If cell sizes have been invalidated (eg we are using CellMeasurer) then reset cached positions.
                // We must do this at the start of the method as we may calculate and update scroll position below.
                this._handleInvalidatedGridSize();
                // If this component was first rendered server-side, scrollbar size will be undefined.
                // In that event we need to remeasure.
                if (!instanceProps.scrollbarSizeMeasured) this.setState(function(prevState) {
                    var stateUpdate = $36654e4dc6f53891$var$_objectSpread($36654e4dc6f53891$var$_objectSpread({}, prevState), {}, {
                        needToResetStyleCache: false
                    });
                    stateUpdate.instanceProps.scrollbarSize = getScrollbarSize();
                    stateUpdate.instanceProps.scrollbarSizeMeasured = true;
                    return stateUpdate;
                });
                if (typeof scrollLeft === 'number' && scrollLeft >= 0 || typeof scrollTop === 'number' && scrollTop >= 0) {
                    var stateUpdate = Grid._getScrollToPositionStateUpdate({
                        prevState: this.state,
                        scrollLeft: scrollLeft,
                        scrollTop: scrollTop
                    });
                    if (stateUpdate) {
                        stateUpdate.needToResetStyleCache = false;
                        this.setState(stateUpdate);
                    }
                }
                // refs don't work in `react-test-renderer`
                if (this._scrollingContainer) {
                    // setting the ref's scrollLeft and scrollTop.
                    // Somehow in MultiGrid the main grid doesn't trigger a update on mount.
                    if (this._scrollingContainer.scrollLeft !== this.state.scrollLeft) this._scrollingContainer.scrollLeft = this.state.scrollLeft;
                    if (this._scrollingContainer.scrollTop !== this.state.scrollTop) this._scrollingContainer.scrollTop = this.state.scrollTop;
                }
                // Don't update scroll offset if the size is 0; we don't render any cells in this case.
                // Setting a state may cause us to later thing we've updated the offce when we haven't.
                var sizeIsBiggerThanZero = height > 0 && width > 0;
                if (scrollToColumn >= 0 && sizeIsBiggerThanZero) this._updateScrollLeftForScrollToColumn();
                if (scrollToRow >= 0 && sizeIsBiggerThanZero) this._updateScrollTopForScrollToRow();
                // Update onRowsRendered callback
                this._invokeOnGridRenderedHelper();
                // Initialize onScroll callback
                this._invokeOnScrollMemoizer({
                    scrollLeft: scrollLeft || 0,
                    scrollTop: scrollTop || 0,
                    totalColumnsWidth: instanceProps.columnSizeAndPositionManager.getTotalSize(),
                    totalRowsHeight: instanceProps.rowSizeAndPositionManager.getTotalSize()
                });
                this._maybeCallOnScrollbarPresenceChange();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps /*: Props*/ , prevState /*: State*/ ) {
                var _this2 = this;
                var _this$props5 = this.props, autoHeight = _this$props5.autoHeight, autoWidth = _this$props5.autoWidth, columnCount = _this$props5.columnCount, height = _this$props5.height, rowCount = _this$props5.rowCount, scrollToAlignment = _this$props5.scrollToAlignment, scrollToColumn = _this$props5.scrollToColumn, scrollToRow = _this$props5.scrollToRow, width = _this$props5.width;
                var _this$state = this.state, scrollLeft = _this$state.scrollLeft, scrollPositionChangeReason = _this$state.scrollPositionChangeReason, scrollTop = _this$state.scrollTop, instanceProps = _this$state.instanceProps;
                // If cell sizes have been invalidated (eg we are using CellMeasurer) then reset cached positions.
                // We must do this at the start of the method as we may calculate and update scroll position below.
                this._handleInvalidatedGridSize();
                // Handle edge case where column or row count has only just increased over 0.
                // In this case we may have to restore a previously-specified scroll offset.
                // For more info see bvaughn/react-virtualized/issues/218
                var columnOrRowCountJustIncreasedFromZero = columnCount > 0 && prevProps.columnCount === 0 || rowCount > 0 && prevProps.rowCount === 0;
                // Make sure requested changes to :scrollLeft or :scrollTop get applied.
                // Assigning to scrollLeft/scrollTop tells the browser to interrupt any running scroll animations,
                // And to discard any pending async changes to the scroll position that may have happened in the meantime (e.g. on a separate scrolling thread).
                // So we only set these when we require an adjustment of the scroll position.
                // See issue #2 for more information.
                if (scrollPositionChangeReason === $36654e4dc6f53891$var$SCROLL_POSITION_CHANGE_REASONS.REQUESTED) {
                    // @TRICKY :autoHeight and :autoWidth properties instructs Grid to leave :scrollTop and :scrollLeft management to an external HOC (eg WindowScroller).
                    // In this case we should avoid checking scrollingContainer.scrollTop and scrollingContainer.scrollLeft since it forces layout/flow.
                    if (!autoWidth && scrollLeft >= 0 && (scrollLeft !== this._scrollingContainer.scrollLeft || columnOrRowCountJustIncreasedFromZero)) this._scrollingContainer.scrollLeft = scrollLeft;
                    if (!autoHeight && scrollTop >= 0 && (scrollTop !== this._scrollingContainer.scrollTop || columnOrRowCountJustIncreasedFromZero)) this._scrollingContainer.scrollTop = scrollTop;
                }
                // Special case where the previous size was 0:
                // In this case we don't show any windowed cells at all.
                // So we should always recalculate offset afterwards.
                var sizeJustIncreasedFromZero = (prevProps.width === 0 || prevProps.height === 0) && height > 0 && width > 0;
                // Update scroll offsets if the current :scrollToColumn or :scrollToRow values requires it
                // @TODO Do we also need this check or can the one in componentWillUpdate() suffice?
                if (this._recomputeScrollLeftFlag) {
                    this._recomputeScrollLeftFlag = false;
                    this._updateScrollLeftForScrollToColumn(this.props);
                } else (0, $36654e4dc6f53891$var$_updateScrollIndexHelper["default"])({
                    cellSizeAndPositionManager: instanceProps.columnSizeAndPositionManager,
                    previousCellsCount: prevProps.columnCount,
                    previousCellSize: prevProps.columnWidth,
                    previousScrollToAlignment: prevProps.scrollToAlignment,
                    previousScrollToIndex: prevProps.scrollToColumn,
                    previousSize: prevProps.width,
                    scrollOffset: scrollLeft,
                    scrollToAlignment: scrollToAlignment,
                    scrollToIndex: scrollToColumn,
                    size: width,
                    sizeJustIncreasedFromZero: sizeJustIncreasedFromZero,
                    updateScrollIndexCallback: function updateScrollIndexCallback() {
                        return _this2._updateScrollLeftForScrollToColumn(_this2.props);
                    }
                });
                if (this._recomputeScrollTopFlag) {
                    this._recomputeScrollTopFlag = false;
                    this._updateScrollTopForScrollToRow(this.props);
                } else (0, $36654e4dc6f53891$var$_updateScrollIndexHelper["default"])({
                    cellSizeAndPositionManager: instanceProps.rowSizeAndPositionManager,
                    previousCellsCount: prevProps.rowCount,
                    previousCellSize: prevProps.rowHeight,
                    previousScrollToAlignment: prevProps.scrollToAlignment,
                    previousScrollToIndex: prevProps.scrollToRow,
                    previousSize: prevProps.height,
                    scrollOffset: scrollTop,
                    scrollToAlignment: scrollToAlignment,
                    scrollToIndex: scrollToRow,
                    size: height,
                    sizeJustIncreasedFromZero: sizeJustIncreasedFromZero,
                    updateScrollIndexCallback: function updateScrollIndexCallback() {
                        return _this2._updateScrollTopForScrollToRow(_this2.props);
                    }
                });
                // Update onRowsRendered callback if start/stop indices have changed
                this._invokeOnGridRenderedHelper();
                // Changes to :scrollLeft or :scrollTop should also notify :onScroll listeners
                if (scrollLeft !== prevState.scrollLeft || scrollTop !== prevState.scrollTop) {
                    var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
                    var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
                    this._invokeOnScrollMemoizer({
                        scrollLeft: scrollLeft,
                        scrollTop: scrollTop,
                        totalColumnsWidth: totalColumnsWidth,
                        totalRowsHeight: totalRowsHeight
                    });
                }
                this._maybeCallOnScrollbarPresenceChange();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this._disablePointerEventsTimeoutId) (0, $cKDwS.cancelAnimationTimeout)(this._disablePointerEventsTimeoutId);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props6 = this.props, autoContainerWidth = _this$props6.autoContainerWidth, autoHeight = _this$props6.autoHeight, autoWidth = _this$props6.autoWidth, className = _this$props6.className, containerProps = _this$props6.containerProps, containerRole = _this$props6.containerRole, containerStyle = _this$props6.containerStyle, height = _this$props6.height, id = _this$props6.id, noContentRenderer = _this$props6.noContentRenderer, role = _this$props6.role, style = _this$props6.style, tabIndex = _this$props6.tabIndex, width = _this$props6.width;
                var _this$state2 = this.state, instanceProps = _this$state2.instanceProps, needToResetStyleCache = _this$state2.needToResetStyleCache;
                var isScrolling = this._isScrolling();
                var gridStyle /*: Object*/  = {
                    boxSizing: 'border-box',
                    direction: 'ltr',
                    height: autoHeight ? 'auto' : height,
                    position: 'relative',
                    width: autoWidth ? 'auto' : width,
                    WebkitOverflowScrolling: 'touch',
                    willChange: 'transform'
                };
                if (needToResetStyleCache) this._styleCache = {};
                // calculate _styleCache here
                // if state.isScrolling (not from _isScrolling) then reset
                if (!this.state.isScrolling) this._resetStyleCache();
                // calculate children to render here
                this._calculateChildrenToRender(this.props, this.state);
                var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
                var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
                // Force browser to hide scrollbars when we know they aren't necessary.
                // Otherwise once scrollbars appear they may not disappear again.
                // For more info see issue #116
                var verticalScrollBarSize = totalRowsHeight > height ? instanceProps.scrollbarSize : 0;
                var horizontalScrollBarSize = totalColumnsWidth > width ? instanceProps.scrollbarSize : 0;
                if (horizontalScrollBarSize !== this._horizontalScrollBarSize || verticalScrollBarSize !== this._verticalScrollBarSize) {
                    this._horizontalScrollBarSize = horizontalScrollBarSize;
                    this._verticalScrollBarSize = verticalScrollBarSize;
                    this._scrollbarPresenceChanged = true;
                }
                // Also explicitly init styles to 'auto' if scrollbars are required.
                // This works around an obscure edge case where external CSS styles have not yet been loaded,
                // But an initial scroll index of offset is set as an external prop.
                // Without this style, Grid would render the correct range of cells but would NOT update its internal offset.
                // This was originally reported via clauderic/react-infinite-calendar/issues/23
                gridStyle.overflowX = totalColumnsWidth + verticalScrollBarSize <= width ? 'hidden' : 'auto';
                gridStyle.overflowY = totalRowsHeight + horizontalScrollBarSize <= height ? 'hidden' : 'auto';
                var childrenToDisplay = this._childrenToDisplay;
                var showNoContentRenderer = childrenToDisplay.length === 0 && height > 0 && width > 0;
                return /*#__PURE__*/ $36654e4dc6f53891$var$React.createElement("div", (0, $36654e4dc6f53891$var$_extends2["default"])({
                    ref: this._setScrollingContainerRef
                }, containerProps, {
                    "aria-label": this.props['aria-label'],
                    "aria-readonly": this.props['aria-readonly'],
                    className: (0, $36654e4dc6f53891$var$_clsx["default"])('ReactVirtualized__Grid', className),
                    id: id,
                    onScroll: this._onScroll,
                    role: role,
                    style: $36654e4dc6f53891$var$_objectSpread($36654e4dc6f53891$var$_objectSpread({}, gridStyle), style),
                    tabIndex: tabIndex
                }), childrenToDisplay.length > 0 && /*#__PURE__*/ $36654e4dc6f53891$var$React.createElement("div", {
                    className: "ReactVirtualized__Grid__innerScrollContainer",
                    role: containerRole,
                    style: $36654e4dc6f53891$var$_objectSpread({
                        width: autoContainerWidth ? 'auto' : totalColumnsWidth,
                        height: totalRowsHeight,
                        maxWidth: totalColumnsWidth,
                        maxHeight: totalRowsHeight,
                        overflow: 'hidden',
                        pointerEvents: isScrolling ? 'none' : '',
                        position: 'relative'
                    }, containerStyle)
                }, childrenToDisplay), showNoContentRenderer && noContentRenderer());
            }
        },
        {
            key: "_calculateChildrenToRender",
            value: function _calculateChildrenToRender() {
                var props /*: Props*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                var state /*: State*/  = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
                var cellRenderer = props.cellRenderer, cellRangeRenderer = props.cellRangeRenderer, columnCount = props.columnCount, deferredMeasurementCache = props.deferredMeasurementCache, height = props.height, overscanColumnCount = props.overscanColumnCount, overscanIndicesGetter = props.overscanIndicesGetter, overscanRowCount = props.overscanRowCount, rowCount = props.rowCount, width = props.width, isScrollingOptOut = props.isScrollingOptOut;
                var scrollDirectionHorizontal = state.scrollDirectionHorizontal, scrollDirectionVertical = state.scrollDirectionVertical, instanceProps = state.instanceProps;
                var scrollTop = this._initialScrollTop > 0 ? this._initialScrollTop : state.scrollTop;
                var scrollLeft = this._initialScrollLeft > 0 ? this._initialScrollLeft : state.scrollLeft;
                var isScrolling = this._isScrolling(props, state);
                this._childrenToDisplay = [];
                // Render only enough columns and rows to cover the visible area of the grid.
                if (height > 0 && width > 0) {
                    var visibleColumnIndices = instanceProps.columnSizeAndPositionManager.getVisibleCellRange({
                        containerSize: width,
                        offset: scrollLeft
                    });
                    var visibleRowIndices = instanceProps.rowSizeAndPositionManager.getVisibleCellRange({
                        containerSize: height,
                        offset: scrollTop
                    });
                    var horizontalOffsetAdjustment = instanceProps.columnSizeAndPositionManager.getOffsetAdjustment({
                        containerSize: width,
                        offset: scrollLeft
                    });
                    var verticalOffsetAdjustment = instanceProps.rowSizeAndPositionManager.getOffsetAdjustment({
                        containerSize: height,
                        offset: scrollTop
                    });
                    // Store for _invokeOnGridRenderedHelper()
                    this._renderedColumnStartIndex = visibleColumnIndices.start;
                    this._renderedColumnStopIndex = visibleColumnIndices.stop;
                    this._renderedRowStartIndex = visibleRowIndices.start;
                    this._renderedRowStopIndex = visibleRowIndices.stop;
                    var overscanColumnIndices = overscanIndicesGetter({
                        direction: 'horizontal',
                        cellCount: columnCount,
                        overscanCellsCount: overscanColumnCount,
                        scrollDirection: scrollDirectionHorizontal,
                        startIndex: typeof visibleColumnIndices.start === 'number' ? visibleColumnIndices.start : 0,
                        stopIndex: typeof visibleColumnIndices.stop === 'number' ? visibleColumnIndices.stop : -1
                    });
                    var overscanRowIndices = overscanIndicesGetter({
                        direction: 'vertical',
                        cellCount: rowCount,
                        overscanCellsCount: overscanRowCount,
                        scrollDirection: scrollDirectionVertical,
                        startIndex: typeof visibleRowIndices.start === 'number' ? visibleRowIndices.start : 0,
                        stopIndex: typeof visibleRowIndices.stop === 'number' ? visibleRowIndices.stop : -1
                    });
                    // Store for _invokeOnGridRenderedHelper()
                    var columnStartIndex = overscanColumnIndices.overscanStartIndex;
                    var columnStopIndex = overscanColumnIndices.overscanStopIndex;
                    var rowStartIndex = overscanRowIndices.overscanStartIndex;
                    var rowStopIndex = overscanRowIndices.overscanStopIndex;
                    // Advanced use-cases (eg CellMeasurer) require batched measurements to determine accurate sizes.
                    if (deferredMeasurementCache) {
                        // If rows have a dynamic height, scan the rows we are about to render.
                        // If any have not yet been measured, then we need to render all columns initially,
                        // Because the height of the row is equal to the tallest cell within that row,
                        // (And so we can't know the height without measuring all column-cells first).
                        if (!deferredMeasurementCache.hasFixedHeight()) {
                            for(var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++)if (!deferredMeasurementCache.has(rowIndex, 0)) {
                                columnStartIndex = 0;
                                columnStopIndex = columnCount - 1;
                                break;
                            }
                        }
                        // If columns have a dynamic width, scan the columns we are about to render.
                        // If any have not yet been measured, then we need to render all rows initially,
                        // Because the width of the column is equal to the widest cell within that column,
                        // (And so we can't know the width without measuring all row-cells first).
                        if (!deferredMeasurementCache.hasFixedWidth()) {
                            for(var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++)if (!deferredMeasurementCache.has(0, columnIndex)) {
                                rowStartIndex = 0;
                                rowStopIndex = rowCount - 1;
                                break;
                            }
                        }
                    }
                    this._childrenToDisplay = cellRangeRenderer({
                        cellCache: this._cellCache,
                        cellRenderer: cellRenderer,
                        columnSizeAndPositionManager: instanceProps.columnSizeAndPositionManager,
                        columnStartIndex: columnStartIndex,
                        columnStopIndex: columnStopIndex,
                        deferredMeasurementCache: deferredMeasurementCache,
                        horizontalOffsetAdjustment: horizontalOffsetAdjustment,
                        isScrolling: isScrolling,
                        isScrollingOptOut: isScrollingOptOut,
                        parent: this,
                        rowSizeAndPositionManager: instanceProps.rowSizeAndPositionManager,
                        rowStartIndex: rowStartIndex,
                        rowStopIndex: rowStopIndex,
                        scrollLeft: scrollLeft,
                        scrollTop: scrollTop,
                        styleCache: this._styleCache,
                        verticalOffsetAdjustment: verticalOffsetAdjustment,
                        visibleColumnIndices: visibleColumnIndices,
                        visibleRowIndices: visibleRowIndices
                    });
                    // update the indices
                    this._columnStartIndex = columnStartIndex;
                    this._columnStopIndex = columnStopIndex;
                    this._rowStartIndex = rowStartIndex;
                    this._rowStopIndex = rowStopIndex;
                }
            }
        },
        {
            key: "_debounceScrollEnded",
            value: function _debounceScrollEnded() {
                var scrollingResetTimeInterval = this.props.scrollingResetTimeInterval;
                if (this._disablePointerEventsTimeoutId) (0, $cKDwS.cancelAnimationTimeout)(this._disablePointerEventsTimeoutId);
                this._disablePointerEventsTimeoutId = (0, $cKDwS.requestAnimationTimeout)(this._debounceScrollEndedCallback, scrollingResetTimeInterval);
            }
        },
        {
            key: "_handleInvalidatedGridSize",
            value: /**
     * Check for batched CellMeasurer size invalidations.
     * This will occur the first time one or more previously unmeasured cells are rendered.
     */ function _handleInvalidatedGridSize() {
                if (typeof this._deferredInvalidateColumnIndex === 'number' && typeof this._deferredInvalidateRowIndex === 'number') {
                    var columnIndex = this._deferredInvalidateColumnIndex;
                    var rowIndex = this._deferredInvalidateRowIndex;
                    this._deferredInvalidateColumnIndex = null;
                    this._deferredInvalidateRowIndex = null;
                    this.recomputeGridSize({
                        columnIndex: columnIndex,
                        rowIndex: rowIndex
                    });
                }
            }
        },
        {
            key: "_invokeOnScrollMemoizer",
            value: function _invokeOnScrollMemoizer(_ref6 /*:: */ ) {
                var _this3 = this;
                var scrollLeft = _ref6 /*:: */ .scrollLeft, scrollTop = _ref6 /*:: */ .scrollTop, totalColumnsWidth = _ref6 /*:: */ .totalColumnsWidth, totalRowsHeight = _ref6 /*:: */ .totalRowsHeight;
                this._onScrollMemoizer({
                    callback: function callback(_ref7) {
                        var scrollLeft = _ref7.scrollLeft, scrollTop = _ref7.scrollTop;
                        var _this3$props = _this3.props, height = _this3$props.height, onScroll = _this3$props.onScroll, width = _this3$props.width;
                        onScroll({
                            clientHeight: height,
                            clientWidth: width,
                            scrollHeight: totalRowsHeight,
                            scrollLeft: scrollLeft,
                            scrollTop: scrollTop,
                            scrollWidth: totalColumnsWidth
                        });
                    },
                    indices: {
                        scrollLeft: scrollLeft,
                        scrollTop: scrollTop
                    }
                });
            }
        },
        {
            key: "_isScrolling",
            value: function _isScrolling() /*: boolean*/ {
                var props /*: Props*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                var state /*: State*/  = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
                // If isScrolling is defined in props, use it to override the value in state
                // This is a performance optimization for WindowScroller + Grid
                return Object.hasOwnProperty.call(props, 'isScrolling') ? Boolean(props.isScrolling) : Boolean(state.isScrolling);
            }
        },
        {
            key: "_maybeCallOnScrollbarPresenceChange",
            value: function _maybeCallOnScrollbarPresenceChange() {
                if (this._scrollbarPresenceChanged) {
                    var onScrollbarPresenceChange = this.props.onScrollbarPresenceChange;
                    this._scrollbarPresenceChanged = false;
                    onScrollbarPresenceChange({
                        horizontal: this._horizontalScrollBarSize > 0,
                        size: this.state.instanceProps.scrollbarSize,
                        vertical: this._verticalScrollBarSize > 0
                    });
                }
            }
        },
        {
            key: "scrollToPosition",
            value: /**
     * Scroll to the specified offset(s).
     * Useful for animating position changes.
     */ function scrollToPosition(_ref8 /*:: */ ) {
                var scrollLeft = _ref8 /*:: */ .scrollLeft, scrollTop = _ref8 /*:: */ .scrollTop;
                var stateUpdate = Grid._getScrollToPositionStateUpdate({
                    prevState: this.state,
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop
                });
                if (stateUpdate) {
                    stateUpdate.needToResetStyleCache = false;
                    this.setState(stateUpdate);
                }
            }
        },
        {
            key: "_getCalculatedScrollLeft",
            value: function _getCalculatedScrollLeft() {
                var props /*: Props*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                var state /*: State*/  = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
                return Grid._getCalculatedScrollLeft(props, state);
            }
        },
        {
            key: "_updateScrollLeftForScrollToColumn",
            value: function _updateScrollLeftForScrollToColumn() {
                var props /*: Props*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                var state /*: State*/  = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
                var stateUpdate = Grid._getScrollLeftForScrollToColumnStateUpdate(props, state);
                if (stateUpdate) {
                    stateUpdate.needToResetStyleCache = false;
                    this.setState(stateUpdate);
                }
            }
        },
        {
            key: "_getCalculatedScrollTop",
            value: function _getCalculatedScrollTop() {
                var props /*: Props*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                var state /*: State*/  = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
                return Grid._getCalculatedScrollTop(props, state);
            }
        },
        {
            key: "_resetStyleCache",
            value: function _resetStyleCache() {
                var styleCache = this._styleCache;
                var cellCache = this._cellCache;
                var isScrollingOptOut = this.props.isScrollingOptOut;
                // Reset cell and style caches once scrolling stops.
                // This makes Grid simpler to use (since cells commonly change).
                // And it keeps the caches from growing too large.
                // Performance is most sensitive when a user is scrolling.
                // Don't clear visible cells from cellCache if isScrollingOptOut is specified.
                // This keeps the cellCache to a resonable size.
                this._cellCache = {};
                this._styleCache = {};
                // Copy over the visible cell styles so avoid unnecessary re-render.
                for(var rowIndex = this._rowStartIndex; rowIndex <= this._rowStopIndex; rowIndex++)for(var columnIndex = this._columnStartIndex; columnIndex <= this._columnStopIndex; columnIndex++){
                    var key = "".concat(rowIndex, "-").concat(columnIndex);
                    this._styleCache[key] = styleCache[key];
                    if (isScrollingOptOut) this._cellCache[key] = cellCache[key];
                }
            }
        },
        {
            key: "_updateScrollTopForScrollToRow",
            value: function _updateScrollTopForScrollToRow() {
                var props /*: Props*/  = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
                var state /*: State*/  = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
                var stateUpdate = Grid._getScrollTopForScrollToRowStateUpdate(props, state);
                if (stateUpdate) {
                    stateUpdate.needToResetStyleCache = false;
                    this.setState(stateUpdate);
                }
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps /*: Props*/ , prevState /*: State*/ ) /*: $Shape<State>*/ {
                var newState = {};
                if (nextProps.columnCount === 0 && prevState.scrollLeft !== 0 || nextProps.rowCount === 0 && prevState.scrollTop !== 0) {
                    newState.scrollLeft = 0;
                    newState.scrollTop = 0;
                // only use scroll{Left,Top} from props if scrollTo{Column,Row} isn't specified
                // scrollTo{Column,Row} should override scroll{Left,Top}
                } else if (nextProps.scrollLeft !== prevState.scrollLeft && nextProps.scrollToColumn < 0 || nextProps.scrollTop !== prevState.scrollTop && nextProps.scrollToRow < 0) Object.assign(newState, Grid._getScrollToPositionStateUpdate({
                    prevState: prevState,
                    scrollLeft: nextProps.scrollLeft,
                    scrollTop: nextProps.scrollTop
                }));
                var instanceProps = prevState.instanceProps;
                // Initially we should not clearStyleCache
                newState.needToResetStyleCache = false;
                if (nextProps.columnWidth !== instanceProps.prevColumnWidth || nextProps.rowHeight !== instanceProps.prevRowHeight) // Reset cache. set it to {} in render
                newState.needToResetStyleCache = true;
                instanceProps.columnSizeAndPositionManager.configure({
                    cellCount: nextProps.columnCount,
                    estimatedCellSize: Grid._getEstimatedColumnSize(nextProps),
                    cellSizeGetter: Grid._wrapSizeGetter(nextProps.columnWidth)
                });
                instanceProps.rowSizeAndPositionManager.configure({
                    cellCount: nextProps.rowCount,
                    estimatedCellSize: Grid._getEstimatedRowSize(nextProps),
                    cellSizeGetter: Grid._wrapSizeGetter(nextProps.rowHeight)
                });
                if (instanceProps.prevColumnCount === 0 || instanceProps.prevRowCount === 0) {
                    instanceProps.prevColumnCount = 0;
                    instanceProps.prevRowCount = 0;
                }
                // If scrolling is controlled outside this component, clear cache when scrolling stops
                if (nextProps.autoHeight && nextProps.isScrolling === false && instanceProps.prevIsScrolling === true) Object.assign(newState, {
                    isScrolling: false
                });
                var maybeStateA;
                var maybeStateB;
                (0, $36654e4dc6f53891$var$_calculateSizeAndPositionDataAndUpdateScrollOffset["default"])({
                    cellCount: instanceProps.prevColumnCount,
                    cellSize: typeof instanceProps.prevColumnWidth === 'number' ? instanceProps.prevColumnWidth : null,
                    computeMetadataCallback: function computeMetadataCallback() {
                        return instanceProps.columnSizeAndPositionManager.resetCell(0);
                    },
                    computeMetadataCallbackProps: nextProps,
                    nextCellsCount: nextProps.columnCount,
                    nextCellSize: typeof nextProps.columnWidth === 'number' ? nextProps.columnWidth : null,
                    nextScrollToIndex: nextProps.scrollToColumn,
                    scrollToIndex: instanceProps.prevScrollToColumn,
                    updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
                        maybeStateA = Grid._getScrollLeftForScrollToColumnStateUpdate(nextProps, prevState);
                    }
                });
                (0, $36654e4dc6f53891$var$_calculateSizeAndPositionDataAndUpdateScrollOffset["default"])({
                    cellCount: instanceProps.prevRowCount,
                    cellSize: typeof instanceProps.prevRowHeight === 'number' ? instanceProps.prevRowHeight : null,
                    computeMetadataCallback: function computeMetadataCallback() {
                        return instanceProps.rowSizeAndPositionManager.resetCell(0);
                    },
                    computeMetadataCallbackProps: nextProps,
                    nextCellsCount: nextProps.rowCount,
                    nextCellSize: typeof nextProps.rowHeight === 'number' ? nextProps.rowHeight : null,
                    nextScrollToIndex: nextProps.scrollToRow,
                    scrollToIndex: instanceProps.prevScrollToRow,
                    updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
                        maybeStateB = Grid._getScrollTopForScrollToRowStateUpdate(nextProps, prevState);
                    }
                });
                instanceProps.prevColumnCount = nextProps.columnCount;
                instanceProps.prevColumnWidth = nextProps.columnWidth;
                instanceProps.prevIsScrolling = nextProps.isScrolling === true;
                instanceProps.prevRowCount = nextProps.rowCount;
                instanceProps.prevRowHeight = nextProps.rowHeight;
                instanceProps.prevScrollToColumn = nextProps.scrollToColumn;
                instanceProps.prevScrollToRow = nextProps.scrollToRow;
                // getting scrollBarSize (moved from componentWillMount)
                instanceProps.scrollbarSize = nextProps.getScrollbarSize();
                if (instanceProps.scrollbarSize === undefined) {
                    instanceProps.scrollbarSizeMeasured = false;
                    instanceProps.scrollbarSize = 0;
                } else instanceProps.scrollbarSizeMeasured = true;
                newState.instanceProps = instanceProps;
                return $36654e4dc6f53891$var$_objectSpread($36654e4dc6f53891$var$_objectSpread($36654e4dc6f53891$var$_objectSpread({}, newState), maybeStateA), maybeStateB);
            }
        },
        {
            key: "_getEstimatedColumnSize",
            value: function _getEstimatedColumnSize(props /*: Props*/ ) {
                return typeof props.columnWidth === 'number' ? props.columnWidth : props.estimatedColumnSize;
            }
        },
        {
            key: "_getEstimatedRowSize",
            value: function _getEstimatedRowSize(props /*: Props*/ ) {
                return typeof props.rowHeight === 'number' ? props.rowHeight : props.estimatedRowSize;
            }
        },
        {
            key: "_getScrollToPositionStateUpdate",
            value: /**
     * Get the updated state after scrolling to
     * scrollLeft and scrollTop
     */ function _getScrollToPositionStateUpdate(_ref9 /*:: */ ) /*: $Shape<State>*/ {
                var prevState = _ref9 /*:: */ .prevState, scrollLeft = _ref9 /*:: */ .scrollLeft, scrollTop = _ref9 /*:: */ .scrollTop;
                var newState /*: Object*/  = {
                    scrollPositionChangeReason: $36654e4dc6f53891$var$SCROLL_POSITION_CHANGE_REASONS.REQUESTED
                };
                if (typeof scrollLeft === 'number' && scrollLeft >= 0) {
                    newState.scrollDirectionHorizontal = scrollLeft > prevState.scrollLeft ? $36654e4dc6f53891$var$_defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD : $36654e4dc6f53891$var$_defaultOverscanIndicesGetter.SCROLL_DIRECTION_BACKWARD;
                    newState.scrollLeft = scrollLeft;
                }
                if (typeof scrollTop === 'number' && scrollTop >= 0) {
                    newState.scrollDirectionVertical = scrollTop > prevState.scrollTop ? $36654e4dc6f53891$var$_defaultOverscanIndicesGetter.SCROLL_DIRECTION_FORWARD : $36654e4dc6f53891$var$_defaultOverscanIndicesGetter.SCROLL_DIRECTION_BACKWARD;
                    newState.scrollTop = scrollTop;
                }
                if (typeof scrollLeft === 'number' && scrollLeft >= 0 && scrollLeft !== prevState.scrollLeft || typeof scrollTop === 'number' && scrollTop >= 0 && scrollTop !== prevState.scrollTop) return newState;
                return {};
            }
        },
        {
            key: "_wrapSizeGetter",
            value: function _wrapSizeGetter(value /*: CellSize*/ ) /*: CellSizeGetter*/ {
                return typeof value === 'function' ? value : function() {
                    return value /*: any*/ ;
                };
            }
        },
        {
            key: "_getCalculatedScrollLeft",
            value: function _getCalculatedScrollLeft(nextProps /*: Props*/ , prevState /*: State*/ ) {
                var columnCount = nextProps.columnCount, height = nextProps.height, scrollToAlignment = nextProps.scrollToAlignment, scrollToColumn = nextProps.scrollToColumn, width = nextProps.width;
                var scrollLeft = prevState.scrollLeft, instanceProps = prevState.instanceProps;
                if (columnCount > 0) {
                    var finalColumn = columnCount - 1;
                    var targetIndex = scrollToColumn < 0 ? finalColumn : Math.min(finalColumn, scrollToColumn);
                    var totalRowsHeight = instanceProps.rowSizeAndPositionManager.getTotalSize();
                    var scrollBarSize = instanceProps.scrollbarSizeMeasured && totalRowsHeight > height ? instanceProps.scrollbarSize : 0;
                    return instanceProps.columnSizeAndPositionManager.getUpdatedOffsetForIndex({
                        align: scrollToAlignment,
                        containerSize: width - scrollBarSize,
                        currentOffset: scrollLeft,
                        targetIndex: targetIndex
                    });
                }
                return 0;
            }
        },
        {
            key: "_getScrollLeftForScrollToColumnStateUpdate",
            value: function _getScrollLeftForScrollToColumnStateUpdate(nextProps /*: Props*/ , prevState /*: State*/ ) /*: $Shape<State>*/ {
                var scrollLeft = prevState.scrollLeft;
                var calculatedScrollLeft = Grid._getCalculatedScrollLeft(nextProps, prevState);
                if (typeof calculatedScrollLeft === 'number' && calculatedScrollLeft >= 0 && scrollLeft !== calculatedScrollLeft) return Grid._getScrollToPositionStateUpdate({
                    prevState: prevState,
                    scrollLeft: calculatedScrollLeft,
                    scrollTop: -1
                });
                return {};
            }
        },
        {
            key: "_getCalculatedScrollTop",
            value: function _getCalculatedScrollTop(nextProps /*: Props*/ , prevState /*: State*/ ) {
                var height = nextProps.height, rowCount = nextProps.rowCount, scrollToAlignment = nextProps.scrollToAlignment, scrollToRow = nextProps.scrollToRow, width = nextProps.width;
                var scrollTop = prevState.scrollTop, instanceProps = prevState.instanceProps;
                if (rowCount > 0) {
                    var finalRow = rowCount - 1;
                    var targetIndex = scrollToRow < 0 ? finalRow : Math.min(finalRow, scrollToRow);
                    var totalColumnsWidth = instanceProps.columnSizeAndPositionManager.getTotalSize();
                    var scrollBarSize = instanceProps.scrollbarSizeMeasured && totalColumnsWidth > width ? instanceProps.scrollbarSize : 0;
                    return instanceProps.rowSizeAndPositionManager.getUpdatedOffsetForIndex({
                        align: scrollToAlignment,
                        containerSize: height - scrollBarSize,
                        currentOffset: scrollTop,
                        targetIndex: targetIndex
                    });
                }
                return 0;
            }
        },
        {
            key: "_getScrollTopForScrollToRowStateUpdate",
            value: function _getScrollTopForScrollToRowStateUpdate(nextProps /*: Props*/ , prevState /*: State*/ ) /*: $Shape<State>*/ {
                var scrollTop = prevState.scrollTop;
                var calculatedScrollTop = Grid._getCalculatedScrollTop(nextProps, prevState);
                if (typeof calculatedScrollTop === 'number' && calculatedScrollTop >= 0 && scrollTop !== calculatedScrollTop) return Grid._getScrollToPositionStateUpdate({
                    prevState: prevState,
                    scrollLeft: -1,
                    scrollTop: calculatedScrollTop
                });
                return {};
            }
        }
    ]);
}($36654e4dc6f53891$var$React.PureComponent);
(0, $36654e4dc6f53891$var$_defineProperty2["default"])($36654e4dc6f53891$var$Grid, "defaultProps", {
    'aria-label': 'grid',
    'aria-readonly': true,
    autoContainerWidth: false,
    autoHeight: false,
    autoWidth: false,
    cellRangeRenderer: $36654e4dc6f53891$var$_defaultCellRangeRenderer["default"],
    containerRole: 'row',
    containerStyle: {},
    estimatedColumnSize: 100,
    estimatedRowSize: 30,
    getScrollbarSize: $36654e4dc6f53891$var$_scrollbarSize["default"],
    noContentRenderer: $36654e4dc6f53891$var$renderNull,
    onScroll: function onScroll() {},
    onScrollbarPresenceChange: function onScrollbarPresenceChange() {},
    onSectionRendered: function onSectionRendered() {},
    overscanColumnCount: 0,
    overscanIndicesGetter: $36654e4dc6f53891$var$_defaultOverscanIndicesGetter["default"],
    overscanRowCount: 10,
    role: 'grid',
    scrollingResetTimeInterval: $36654e4dc6f53891$var$DEFAULT_SCROLLING_RESET_TIME_INTERVAL,
    scrollToAlignment: 'auto',
    scrollToColumn: -1,
    scrollToRow: -1,
    style: {},
    tabIndex: 0,
    isScrollingOptOut: false
});
(0, $hudco.polyfill)($36654e4dc6f53891$var$Grid);
var $36654e4dc6f53891$var$_default = module.exports["default"] = $36654e4dc6f53891$var$Grid;

});
parcelRegister("gFZMB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "clsx", () => $c240667f35366a17$export$4f5d2d50c9deca37);
$parcel$export(module.exports, "default", () => $c240667f35366a17$export$2e2bcd8739ae039);
function $c240667f35366a17$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $c240667f35366a17$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $c240667f35366a17$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $c240667f35366a17$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $c240667f35366a17$export$2e2bcd8739ae039 = $c240667f35366a17$export$4f5d2d50c9deca37;

});

parcelRegister("lNx1E", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $fde7cac3e0194fc6$var$calculateSizeAndPositionDataAndUpdateScrollOffset;
/**
 * Helper method that determines when to recalculate row or column metadata.
 */ /*:: type Params<T> = {
  // Number of rows or columns in the current axis
  cellCount: number,

  // Width or height of cells for the current axis
  cellSize: ?number,

  // Method to invoke if cell metadata should be recalculated
  computeMetadataCallback: (props: T) => void,

  // Parameters to pass to :computeMetadataCallback
  computeMetadataCallbackProps: T,

  // Newly updated number of rows or columns in the current axis
  nextCellsCount: number,

  // Newly updated width or height of cells for the current axis
  nextCellSize: ?number,

  // Newly updated scroll-to-index
  nextScrollToIndex: number,

  // Scroll-to-index
  scrollToIndex: number,

  // Callback to invoke if the scroll position should be recalculated
  updateScrollOffsetForScrollToIndex: () => void,
};*/ function $fde7cac3e0194fc6$var$calculateSizeAndPositionDataAndUpdateScrollOffset(_ref /*:: */ ) {
    var cellCount = _ref /*:: */ .cellCount, cellSize = _ref /*:: */ .cellSize, computeMetadataCallback = _ref /*:: */ .computeMetadataCallback, computeMetadataCallbackProps = _ref /*:: */ .computeMetadataCallbackProps, nextCellsCount = _ref /*:: */ .nextCellsCount, nextCellSize = _ref /*:: */ .nextCellSize, nextScrollToIndex = _ref /*:: */ .nextScrollToIndex, scrollToIndex = _ref /*:: */ .scrollToIndex, updateScrollOffsetForScrollToIndex = _ref /*:: */ .updateScrollOffsetForScrollToIndex;
    // Don't compare cell sizes if they are functions because inline functions would cause infinite loops.
    // In that event users should use the manual recompute methods to inform of changes.
    if (cellCount !== nextCellsCount || (typeof cellSize === 'number' || typeof nextCellSize === 'number') && cellSize !== nextCellSize) {
        computeMetadataCallback(computeMetadataCallbackProps);
        // Updated cell metadata may have hidden the previous scrolled-to item.
        // In this case we should also update the scrollTop to ensure it stays visible.
        if (scrollToIndex >= 0 && scrollToIndex === nextScrollToIndex) updateScrollOffsetForScrollToIndex();
    }
}

});

parcelRegister("j2OYZ", function(module, exports) {
"use strict";

var $vsDHM = parcelRequire("vsDHM");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $ddd5c059e878e6db$var$_objectWithoutProperties2 = $vsDHM((parcelRequire("27OrM")));

var $ddd5c059e878e6db$var$_classCallCheck2 = $vsDHM((parcelRequire("bU4DC")));

var $ddd5c059e878e6db$var$_createClass2 = $vsDHM((parcelRequire("ho58I")));

var $ddd5c059e878e6db$var$_defineProperty2 = $vsDHM((parcelRequire("bpeOS")));

var $ddd5c059e878e6db$var$_CellSizeAndPositionManager = $vsDHM((parcelRequire("ecRLE")));

var $fY4Po = parcelRequire("fY4Po");
var $ddd5c059e878e6db$var$_excluded = [
    "maxScrollSize"
];
/*:: import type {Alignment, CellSizeGetter, VisibleCellRange} from '../types';*/ /*:: type ContainerSizeAndOffset = {
  containerSize: number,
  offset: number,
};*/ /*:: type Params = {
  maxScrollSize?: number,
  cellCount: number,
  cellSizeGetter: CellSizeGetter,
  estimatedCellSize: number,
};*/ /**
 * Browsers have scroll offset limitations (eg Chrome stops scrolling at ~33.5M pixels where as Edge tops out at ~1.5M pixels).
 * After a certain position, the browser won't allow the user to scroll further (even via JavaScript scroll offset adjustments).
 * This util picks a lower ceiling for max size and artificially adjusts positions within to make it transparent for users.
 */ /**
 * Extends CellSizeAndPositionManager and adds scaling behavior for lists that are too large to fit within a browser's native limits.
 */ var $ddd5c059e878e6db$var$ScalingCellSizeAndPositionManager = module.exports["default"] = /*#__PURE__*/ function() {
    function ScalingCellSizeAndPositionManager(_ref /*:: */ ) {
        var _ref$maxScrollSize = _ref /*:: */ .maxScrollSize, maxScrollSize = _ref$maxScrollSize === void 0 ? (0, $fY4Po.getMaxElementSize)() : _ref$maxScrollSize, params = (0, $ddd5c059e878e6db$var$_objectWithoutProperties2["default"])(_ref /*:: */ , $ddd5c059e878e6db$var$_excluded);
        (0, $ddd5c059e878e6db$var$_classCallCheck2["default"])(this, ScalingCellSizeAndPositionManager);
        (0, $ddd5c059e878e6db$var$_defineProperty2["default"])(this, "_cellSizeAndPositionManager", void 0);
        (0, $ddd5c059e878e6db$var$_defineProperty2["default"])(this, "_maxScrollSize", void 0);
        // Favor composition over inheritance to simplify IE10 support
        this._cellSizeAndPositionManager = new $ddd5c059e878e6db$var$_CellSizeAndPositionManager["default"](params);
        this._maxScrollSize = maxScrollSize;
    }
    return (0, $ddd5c059e878e6db$var$_createClass2["default"])(ScalingCellSizeAndPositionManager, [
        {
            key: "areOffsetsAdjusted",
            value: function areOffsetsAdjusted() /*: boolean*/ {
                return this._cellSizeAndPositionManager.getTotalSize() > this._maxScrollSize;
            }
        },
        {
            key: "configure",
            value: function configure(params) {
                this._cellSizeAndPositionManager.configure(params);
            }
        },
        {
            key: "getCellCount",
            value: function getCellCount() /*: number*/ {
                return this._cellSizeAndPositionManager.getCellCount();
            }
        },
        {
            key: "getEstimatedCellSize",
            value: function getEstimatedCellSize() /*: number*/ {
                return this._cellSizeAndPositionManager.getEstimatedCellSize();
            }
        },
        {
            key: "getLastMeasuredIndex",
            value: function getLastMeasuredIndex() /*: number*/ {
                return this._cellSizeAndPositionManager.getLastMeasuredIndex();
            }
        },
        {
            key: "getOffsetAdjustment",
            value: function getOffsetAdjustment(_ref2 /*:: */ ) /*: number*/ {
                var containerSize = _ref2 /*:: */ .containerSize, offset = _ref2 /*:: */ .offset;
                var totalSize = this._cellSizeAndPositionManager.getTotalSize();
                var safeTotalSize = this.getTotalSize();
                var offsetPercentage = this._getOffsetPercentage({
                    containerSize: containerSize,
                    offset: offset,
                    totalSize: safeTotalSize
                });
                return Math.round(offsetPercentage * (safeTotalSize - totalSize));
            }
        },
        {
            key: "getSizeAndPositionOfCell",
            value: function getSizeAndPositionOfCell(index /*: number*/ ) {
                return this._cellSizeAndPositionManager.getSizeAndPositionOfCell(index);
            }
        },
        {
            key: "getSizeAndPositionOfLastMeasuredCell",
            value: function getSizeAndPositionOfLastMeasuredCell() {
                return this._cellSizeAndPositionManager.getSizeAndPositionOfLastMeasuredCell();
            }
        },
        {
            key: "getTotalSize",
            value: function getTotalSize() /*: number*/ {
                return Math.min(this._maxScrollSize, this._cellSizeAndPositionManager.getTotalSize());
            }
        },
        {
            key: "getUpdatedOffsetForIndex",
            value: function getUpdatedOffsetForIndex(_ref3 /*:: */ ) {
                var _ref3$align = _ref3 /*:: */ .align, align = _ref3$align === void 0 ? 'auto' : _ref3$align, containerSize = _ref3 /*:: */ .containerSize, currentOffset = _ref3 /*:: */ .currentOffset, targetIndex = _ref3 /*:: */ .targetIndex;
                currentOffset = this._safeOffsetToOffset({
                    containerSize: containerSize,
                    offset: currentOffset
                });
                var offset = this._cellSizeAndPositionManager.getUpdatedOffsetForIndex({
                    align: align,
                    containerSize: containerSize,
                    currentOffset: currentOffset,
                    targetIndex: targetIndex
                });
                return this._offsetToSafeOffset({
                    containerSize: containerSize,
                    offset: offset
                });
            }
        },
        {
            key: "getVisibleCellRange",
            value: function getVisibleCellRange(_ref4 /*:: */ ) /*: VisibleCellRange*/ {
                var containerSize = _ref4 /*:: */ .containerSize, offset = _ref4 /*:: */ .offset;
                offset = this._safeOffsetToOffset({
                    containerSize: containerSize,
                    offset: offset
                });
                return this._cellSizeAndPositionManager.getVisibleCellRange({
                    containerSize: containerSize,
                    offset: offset
                });
            }
        },
        {
            key: "resetCell",
            value: function resetCell(index /*: number*/ ) /*: void*/ {
                this._cellSizeAndPositionManager.resetCell(index);
            }
        },
        {
            key: "_getOffsetPercentage",
            value: function _getOffsetPercentage(_ref5 /*:: */ ) {
                var containerSize = _ref5 /*:: */ .containerSize, offset = _ref5 /*:: */ .offset, totalSize = _ref5 /*:: */ .totalSize;
                return totalSize <= containerSize ? 0 : offset / (totalSize - containerSize);
            }
        },
        {
            key: "_offsetToSafeOffset",
            value: function _offsetToSafeOffset(_ref6 /*:: */ ) /*: number*/ {
                var containerSize = _ref6 /*:: */ .containerSize, offset = _ref6 /*:: */ .offset;
                var totalSize = this._cellSizeAndPositionManager.getTotalSize();
                var safeTotalSize = this.getTotalSize();
                if (totalSize === safeTotalSize) return offset;
                else {
                    var offsetPercentage = this._getOffsetPercentage({
                        containerSize: containerSize,
                        offset: offset,
                        totalSize: totalSize
                    });
                    return Math.round(offsetPercentage * (safeTotalSize - containerSize));
                }
            }
        },
        {
            key: "_safeOffsetToOffset",
            value: function _safeOffsetToOffset(_ref7 /*:: */ ) /*: number*/ {
                var containerSize = _ref7 /*:: */ .containerSize, offset = _ref7 /*:: */ .offset;
                var totalSize = this._cellSizeAndPositionManager.getTotalSize();
                var safeTotalSize = this.getTotalSize();
                if (totalSize === safeTotalSize) return offset;
                else {
                    var offsetPercentage = this._getOffsetPercentage({
                        containerSize: containerSize,
                        offset: offset,
                        totalSize: safeTotalSize
                    });
                    return Math.round(offsetPercentage * (totalSize - containerSize));
                }
            }
        }
    ]);
}();

});
parcelRegister("ecRLE", function(module, exports) {
"use strict";

var $vsDHM = parcelRequire("vsDHM");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = void 0;

var $a57be4cf7062292d$var$_classCallCheck2 = $vsDHM((parcelRequire("bU4DC")));

var $a57be4cf7062292d$var$_createClass2 = $vsDHM((parcelRequire("ho58I")));

var $a57be4cf7062292d$var$_defineProperty2 = $vsDHM((parcelRequire("bpeOS")));
/*:: import type {Alignment, CellSizeGetter, VisibleCellRange} from '../types';*/ /*:: type CellSizeAndPositionManagerParams = {
  cellCount: number,
  cellSizeGetter: CellSizeGetter,
  estimatedCellSize: number,
};*/ /*:: type ConfigureParams = {
  cellCount: number,
  estimatedCellSize: number,
  cellSizeGetter: CellSizeGetter,
};*/ /*:: type GetUpdatedOffsetForIndex = {
  align: Alignment,
  containerSize: number,
  currentOffset: number,
  targetIndex: number,
};*/ /*:: type GetVisibleCellRangeParams = {
  containerSize: number,
  offset: number,
};*/ /*:: type SizeAndPositionData = {
  offset: number,
  size: number,
};*/ /**
 * Just-in-time calculates and caches size and position information for a collection of cells.
 */ var $a57be4cf7062292d$var$CellSizeAndPositionManager = module.exports["default"] = /*#__PURE__*/ function() {
    function CellSizeAndPositionManager(_ref /*:: */ ) {
        var cellCount = _ref /*:: */ .cellCount, cellSizeGetter = _ref /*:: */ .cellSizeGetter, estimatedCellSize = _ref /*:: */ .estimatedCellSize;
        (0, $a57be4cf7062292d$var$_classCallCheck2["default"])(this, CellSizeAndPositionManager);
        // Cache of size and position data for cells, mapped by cell index.
        // Note that invalid values may exist in this map so only rely on cells up to this._lastMeasuredIndex
        (0, $a57be4cf7062292d$var$_defineProperty2["default"])(this, "_cellSizeAndPositionData", {});
        // Measurements for cells up to this index can be trusted; cells afterward should be estimated.
        (0, $a57be4cf7062292d$var$_defineProperty2["default"])(this, "_lastMeasuredIndex", -1);
        // Used in deferred mode to track which cells have been queued for measurement.
        (0, $a57be4cf7062292d$var$_defineProperty2["default"])(this, "_lastBatchedIndex", -1);
        (0, $a57be4cf7062292d$var$_defineProperty2["default"])(this, "_cellCount", void 0);
        (0, $a57be4cf7062292d$var$_defineProperty2["default"])(this, "_cellSizeGetter", void 0);
        (0, $a57be4cf7062292d$var$_defineProperty2["default"])(this, "_estimatedCellSize", void 0);
        this._cellSizeGetter = cellSizeGetter;
        this._cellCount = cellCount;
        this._estimatedCellSize = estimatedCellSize;
    }
    return (0, $a57be4cf7062292d$var$_createClass2["default"])(CellSizeAndPositionManager, [
        {
            key: "areOffsetsAdjusted",
            value: function areOffsetsAdjusted() {
                return false;
            }
        },
        {
            key: "configure",
            value: function configure(_ref2 /*:: */ ) {
                var cellCount = _ref2 /*:: */ .cellCount, estimatedCellSize = _ref2 /*:: */ .estimatedCellSize, cellSizeGetter = _ref2 /*:: */ .cellSizeGetter;
                this._cellCount = cellCount;
                this._estimatedCellSize = estimatedCellSize;
                this._cellSizeGetter = cellSizeGetter;
            }
        },
        {
            key: "getCellCount",
            value: function getCellCount() /*: number*/ {
                return this._cellCount;
            }
        },
        {
            key: "getEstimatedCellSize",
            value: function getEstimatedCellSize() /*: number*/ {
                return this._estimatedCellSize;
            }
        },
        {
            key: "getLastMeasuredIndex",
            value: function getLastMeasuredIndex() /*: number*/ {
                return this._lastMeasuredIndex;
            }
        },
        {
            key: "getOffsetAdjustment",
            value: function getOffsetAdjustment() {
                return 0;
            }
        },
        {
            key: "getSizeAndPositionOfCell",
            value: function getSizeAndPositionOfCell(index /*: number*/ ) /*: SizeAndPositionData*/ {
                if (index < 0 || index >= this._cellCount) throw Error("Requested index ".concat(index, " is outside of range 0..").concat(this._cellCount));
                if (index > this._lastMeasuredIndex) {
                    var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
                    var offset = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;
                    for(var i = this._lastMeasuredIndex + 1; i <= index; i++){
                        var size = this._cellSizeGetter({
                            index: i
                        });
                        // undefined or NaN probably means a logic error in the size getter.
                        // null means we're using CellMeasurer and haven't yet measured a given index.
                        if (size === undefined || isNaN(size)) throw Error("Invalid size returned for cell ".concat(i, " of value ").concat(size));
                        else if (size === null) {
                            this._cellSizeAndPositionData[i] = {
                                offset: offset,
                                size: 0
                            };
                            this._lastBatchedIndex = index;
                        } else {
                            this._cellSizeAndPositionData[i] = {
                                offset: offset,
                                size: size
                            };
                            offset += size;
                            this._lastMeasuredIndex = index;
                        }
                    }
                }
                return this._cellSizeAndPositionData[index];
            }
        },
        {
            key: "getSizeAndPositionOfLastMeasuredCell",
            value: function getSizeAndPositionOfLastMeasuredCell() /*: SizeAndPositionData*/ {
                return this._lastMeasuredIndex >= 0 ? this._cellSizeAndPositionData[this._lastMeasuredIndex] : {
                    offset: 0,
                    size: 0
                };
            }
        },
        {
            key: "getTotalSize",
            value: function getTotalSize() /*: number*/ {
                var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
                var totalSizeOfMeasuredCells = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;
                var numUnmeasuredCells = this._cellCount - this._lastMeasuredIndex - 1;
                var totalSizeOfUnmeasuredCells = numUnmeasuredCells * this._estimatedCellSize;
                return totalSizeOfMeasuredCells + totalSizeOfUnmeasuredCells;
            }
        },
        {
            key: "getUpdatedOffsetForIndex",
            value: function getUpdatedOffsetForIndex(_ref3 /*:: */ ) /*: number*/ {
                var _ref3$align = _ref3 /*:: */ .align, align = _ref3$align === void 0 ? 'auto' : _ref3$align, containerSize = _ref3 /*:: */ .containerSize, currentOffset = _ref3 /*:: */ .currentOffset, targetIndex = _ref3 /*:: */ .targetIndex;
                if (containerSize <= 0) return 0;
                var datum = this.getSizeAndPositionOfCell(targetIndex);
                var maxOffset = datum.offset;
                var minOffset = maxOffset - containerSize + datum.size;
                var idealOffset;
                switch(align){
                    case 'start':
                        idealOffset = maxOffset;
                        break;
                    case 'end':
                        idealOffset = minOffset;
                        break;
                    case 'center':
                        idealOffset = maxOffset - (containerSize - datum.size) / 2;
                        break;
                    default:
                        idealOffset = Math.max(minOffset, Math.min(maxOffset, currentOffset));
                        break;
                }
                var totalSize = this.getTotalSize();
                return Math.max(0, Math.min(totalSize - containerSize, idealOffset));
            }
        },
        {
            key: "getVisibleCellRange",
            value: function getVisibleCellRange(params /*: GetVisibleCellRangeParams*/ ) /*: VisibleCellRange*/ {
                var containerSize = params.containerSize, offset = params.offset;
                var totalSize = this.getTotalSize();
                if (totalSize === 0) return {};
                var maxOffset = offset + containerSize;
                var start = this._findNearestCell(offset);
                var datum = this.getSizeAndPositionOfCell(start);
                offset = datum.offset + datum.size;
                var stop = start;
                while(offset < maxOffset && stop < this._cellCount - 1){
                    stop++;
                    offset += this.getSizeAndPositionOfCell(stop).size;
                }
                return {
                    start: start,
                    stop: stop
                };
            }
        },
        {
            key: "resetCell",
            value: function resetCell(index /*: number*/ ) /*: void*/ {
                this._lastMeasuredIndex = Math.min(this._lastMeasuredIndex, index - 1);
            }
        },
        {
            key: "_binarySearch",
            value: function _binarySearch(high /*: number*/ , low /*: number*/ , offset /*: number*/ ) /*: number*/ {
                while(low <= high){
                    var middle = low + Math.floor((high - low) / 2);
                    var currentOffset = this.getSizeAndPositionOfCell(middle).offset;
                    if (currentOffset === offset) return middle;
                    else if (currentOffset < offset) low = middle + 1;
                    else if (currentOffset > offset) high = middle - 1;
                }
                if (low > 0) return low - 1;
                else return 0;
            }
        },
        {
            key: "_exponentialSearch",
            value: function _exponentialSearch(index /*: number*/ , offset /*: number*/ ) /*: number*/ {
                var interval = 1;
                while(index < this._cellCount && this.getSizeAndPositionOfCell(index).offset < offset){
                    index += interval;
                    interval *= 2;
                }
                return this._binarySearch(Math.min(index, this._cellCount - 1), Math.floor(index / 2), offset);
            }
        },
        {
            key: "_findNearestCell",
            value: function _findNearestCell(offset /*: number*/ ) /*: number*/ {
                if (isNaN(offset)) throw Error("Invalid offset ".concat(offset, " specified"));
                // Our search algorithms find the nearest match at or below the specified offset.
                // So make sure the offset is at least 0 or no match will be found.
                offset = Math.max(0, offset);
                var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
                var lastMeasuredIndex = Math.max(0, this._lastMeasuredIndex);
                if (lastMeasuredCellSizeAndPosition.offset >= offset) // If we've already measured cells within this range just use a binary search as it's faster.
                return this._binarySearch(lastMeasuredIndex, 0, offset);
                else // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
                // The exponential search avoids pre-computing sizes for the full set of cells as a binary search would.
                // The overall complexity for this approach is O(log n).
                return this._exponentialSearch(lastMeasuredIndex, offset);
            }
        }
    ]);
}();

});

parcelRegister("fY4Po", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getMaxElementSize = void 0;
var $ba0034520daa61a3$var$DEFAULT_MAX_ELEMENT_SIZE = 1500000;
var $ba0034520daa61a3$var$CHROME_MAX_ELEMENT_SIZE = 1.67771e7;
var $ba0034520daa61a3$var$isBrowser = function isBrowser() {
    return typeof window !== 'undefined';
};
var $ba0034520daa61a3$var$isChrome = function isChrome() {
    return !!window.chrome;
};
var $ba0034520daa61a3$var$getMaxElementSize = module.exports.getMaxElementSize = function getMaxElementSize() /*: number*/ {
    if ($ba0034520daa61a3$var$isBrowser()) {
        if ($ba0034520daa61a3$var$isChrome()) return $ba0034520daa61a3$var$CHROME_MAX_ELEMENT_SIZE;
    }
    return $ba0034520daa61a3$var$DEFAULT_MAX_ELEMENT_SIZE;
};

});


parcelRegister("5MR4I", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $436a9b0dc9422c85$var$createCallbackMemoizer;
/**
 * Helper utility that updates the specified callback whenever any of the specified indices have changed.
 */ function $436a9b0dc9422c85$var$createCallbackMemoizer() {
    var requireAllKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var cachedIndices = {};
    return function(_ref) {
        var callback = _ref.callback, indices = _ref.indices;
        var keys = Object.keys(indices);
        var allInitialized = !requireAllKeys || keys.every(function(key) {
            var value = indices[key];
            return Array.isArray(value) ? value.length > 0 : value >= 0;
        });
        var indexChanged = keys.length !== Object.keys(cachedIndices).length || keys.some(function(key) {
            var cachedValue = cachedIndices[key];
            var value = indices[key];
            return Array.isArray(value) ? cachedValue.join(',') !== value.join(',') : cachedValue !== value;
        });
        cachedIndices = indices;
        if (allInitialized && indexChanged) callback(indices);
    };
}

});

parcelRegister("9wmqs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SCROLL_DIRECTION_VERTICAL = module.exports.SCROLL_DIRECTION_HORIZONTAL = module.exports.SCROLL_DIRECTION_FORWARD = module.exports.SCROLL_DIRECTION_BACKWARD = void 0;
module.exports["default"] = $6ee87f837f1229b2$var$defaultOverscanIndicesGetter;
/*:: import type {OverscanIndicesGetterParams, OverscanIndices} from './types';*/ var $6ee87f837f1229b2$var$SCROLL_DIRECTION_BACKWARD = module.exports.SCROLL_DIRECTION_BACKWARD = -1;
var $6ee87f837f1229b2$var$SCROLL_DIRECTION_FORWARD = module.exports.SCROLL_DIRECTION_FORWARD = 1;
var $6ee87f837f1229b2$var$SCROLL_DIRECTION_HORIZONTAL = module.exports.SCROLL_DIRECTION_HORIZONTAL = 'horizontal';
var $6ee87f837f1229b2$var$SCROLL_DIRECTION_VERTICAL = module.exports.SCROLL_DIRECTION_VERTICAL = 'vertical';
/**
 * Calculates the number of cells to overscan before and after a specified range.
 * This function ensures that overscanning doesn't exceed the available cells.
 */ function $6ee87f837f1229b2$var$defaultOverscanIndicesGetter(_ref /*:: */ ) /*: OverscanIndices*/ {
    var cellCount = _ref /*:: */ .cellCount, overscanCellsCount = _ref /*:: */ .overscanCellsCount, scrollDirection = _ref /*:: */ .scrollDirection, startIndex = _ref /*:: */ .startIndex, stopIndex = _ref /*:: */ .stopIndex;
    if (scrollDirection === $6ee87f837f1229b2$var$SCROLL_DIRECTION_FORWARD) return {
        overscanStartIndex: Math.max(0, startIndex),
        overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount)
    };
    else return {
        overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
        overscanStopIndex: Math.min(cellCount - 1, stopIndex)
    };
}

});

parcelRegister("bliQZ", function(module, exports) {
"use strict";

var $vsDHM = parcelRequire("vsDHM");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $842047d67f7cb7b2$var$updateScrollIndexHelper;

var $842047d67f7cb7b2$var$_ScalingCellSizeAndPositionManager = $vsDHM((parcelRequire("j2OYZ")));
/*:: import type {Alignment, CellSize} from '../types';*/ /**
 * Helper function that determines when to update scroll offsets to ensure that a scroll-to-index remains visible.
 * This function also ensures that the scroll ofset isn't past the last column/row of cells.
 */ /*:: type Params = {
  // Width or height of cells for the current axis
  cellSize?: CellSize,

  // Manages size and position metadata of cells
  cellSizeAndPositionManager: ScalingCellSizeAndPositionManager,

  // Previous number of rows or columns
  previousCellsCount: number,

  // Previous width or height of cells
  previousCellSize: CellSize,

  previousScrollToAlignment: Alignment,

  // Previous scroll-to-index
  previousScrollToIndex: number,

  // Previous width or height of the virtualized container
  previousSize: number,

  // Current scrollLeft or scrollTop
  scrollOffset: number,

  scrollToAlignment: Alignment,

  // Scroll-to-index
  scrollToIndex: number,

  // Width or height of the virtualized container
  size: number,

  sizeJustIncreasedFromZero: boolean,

  // Callback to invoke with an scroll-to-index value
  updateScrollIndexCallback: (index: number) => void,
};*/ function $842047d67f7cb7b2$var$updateScrollIndexHelper(_ref /*:: */ ) {
    var cellSize = _ref /*:: */ .cellSize, cellSizeAndPositionManager = _ref /*:: */ .cellSizeAndPositionManager, previousCellsCount = _ref /*:: */ .previousCellsCount, previousCellSize = _ref /*:: */ .previousCellSize, previousScrollToAlignment = _ref /*:: */ .previousScrollToAlignment, previousScrollToIndex = _ref /*:: */ .previousScrollToIndex, previousSize = _ref /*:: */ .previousSize, scrollOffset = _ref /*:: */ .scrollOffset, scrollToAlignment = _ref /*:: */ .scrollToAlignment, scrollToIndex = _ref /*:: */ .scrollToIndex, size = _ref /*:: */ .size, sizeJustIncreasedFromZero = _ref /*:: */ .sizeJustIncreasedFromZero, updateScrollIndexCallback = _ref /*:: */ .updateScrollIndexCallback;
    var cellCount = cellSizeAndPositionManager.getCellCount();
    var hasScrollToIndex = scrollToIndex >= 0 && scrollToIndex < cellCount;
    var sizeHasChanged = size !== previousSize || sizeJustIncreasedFromZero || !previousCellSize || typeof cellSize === 'number' && cellSize !== previousCellSize;
    // If we have a new scroll target OR if height/row-height has changed,
    // We should ensure that the scroll target is visible.
    if (hasScrollToIndex && (sizeHasChanged || scrollToAlignment !== previousScrollToAlignment || scrollToIndex !== previousScrollToIndex)) updateScrollIndexCallback(scrollToIndex);
    else if (!hasScrollToIndex && cellCount > 0 && (size < previousSize || cellCount < previousCellsCount)) // We need to ensure that the current scroll offset is still within the collection's range.
    // To do this, we don't need to measure everything; CellMeasurer would perform poorly.
    // Just check to make sure we're still okay.
    // Only adjust the scroll position if we've scrolled below the last set of rows.
    {
        if (scrollOffset > cellSizeAndPositionManager.getTotalSize() - size) updateScrollIndexCallback(cellCount - 1);
    }
}

});

parcelRegister("lkxZ0", function(module, exports) {
"use strict";

var $vsDHM = parcelRequire("vsDHM");
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports["default"] = $f875d38dda4abc8d$var$defaultCellRangeRenderer;

var $f875d38dda4abc8d$var$_react = $vsDHM((parcelRequire("bSJIT")));
/*:: import type {CellRangeRendererParams} from './types';*/ /**
 * Default implementation of cellRangeRenderer used by Grid.
 * This renderer supports cell-caching while the user is scrolling.
 */ function $f875d38dda4abc8d$var$defaultCellRangeRenderer(_ref /*:: */ ) {
    var cellCache = _ref /*:: */ .cellCache, cellRenderer = _ref /*:: */ .cellRenderer, columnSizeAndPositionManager = _ref /*:: */ .columnSizeAndPositionManager, columnStartIndex = _ref /*:: */ .columnStartIndex, columnStopIndex = _ref /*:: */ .columnStopIndex, deferredMeasurementCache = _ref /*:: */ .deferredMeasurementCache, horizontalOffsetAdjustment = _ref /*:: */ .horizontalOffsetAdjustment, isScrolling = _ref /*:: */ .isScrolling, isScrollingOptOut = _ref /*:: */ .isScrollingOptOut, parent = _ref /*:: */ .parent, rowSizeAndPositionManager = _ref /*:: */ .rowSizeAndPositionManager, rowStartIndex = _ref /*:: */ .rowStartIndex, rowStopIndex = _ref /*:: */ .rowStopIndex, styleCache = _ref /*:: */ .styleCache, verticalOffsetAdjustment = _ref /*:: */ .verticalOffsetAdjustment, visibleColumnIndices = _ref /*:: */ .visibleColumnIndices, visibleRowIndices = _ref /*:: */ .visibleRowIndices;
    var renderedCells = [];
    // Browsers have native size limits for elements (eg Chrome 33M pixels, IE 1.5M pixes).
    // User cannot scroll beyond these size limitations.
    // In order to work around this, ScalingCellSizeAndPositionManager compresses offsets.
    // We should never cache styles for compressed offsets though as this can lead to bugs.
    // See issue #576 for more.
    var areOffsetsAdjusted = columnSizeAndPositionManager.areOffsetsAdjusted() || rowSizeAndPositionManager.areOffsetsAdjusted();
    var canCacheStyle = !isScrolling && !areOffsetsAdjusted;
    for(var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++){
        var rowDatum = rowSizeAndPositionManager.getSizeAndPositionOfCell(rowIndex);
        for(var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++){
            var columnDatum = columnSizeAndPositionManager.getSizeAndPositionOfCell(columnIndex);
            var isVisible = columnIndex >= visibleColumnIndices.start && columnIndex <= visibleColumnIndices.stop && rowIndex >= visibleRowIndices.start && rowIndex <= visibleRowIndices.stop;
            var key = "".concat(rowIndex, "-").concat(columnIndex);
            var style = void 0;
            // Cache style objects so shallow-compare doesn't re-render unnecessarily.
            if (canCacheStyle && styleCache[key]) style = styleCache[key];
            else // In deferred mode, cells will be initially rendered before we know their size.
            // Don't interfere with CellMeasurer's measurements by setting an invalid size.
            if (deferredMeasurementCache && !deferredMeasurementCache.has(rowIndex, columnIndex)) // Position not-yet-measured cells at top/left 0,0,
            // And give them width/height of 'auto' so they can grow larger than the parent Grid if necessary.
            // Positioning them further to the right/bottom influences their measured size.
            style = {
                height: 'auto',
                left: 0,
                position: 'absolute',
                top: 0,
                width: 'auto'
            };
            else {
                style = {
                    height: rowDatum.size,
                    left: columnDatum.offset + horizontalOffsetAdjustment,
                    position: 'absolute',
                    top: rowDatum.offset + verticalOffsetAdjustment,
                    width: columnDatum.size
                };
                styleCache[key] = style;
            }
            var cellRendererParams = {
                columnIndex: columnIndex,
                isScrolling: isScrolling,
                isVisible: isVisible,
                key: key,
                parent: parent,
                rowIndex: rowIndex,
                style: style
            };
            var renderedCell = void 0;
            // Avoid re-creating cells while scrolling.
            // This can lead to the same cell being created many times and can cause performance issues for "heavy" cells.
            // If a scroll is in progress- cache and reuse cells.
            // This cache will be thrown away once scrolling completes.
            // However if we are scaling scroll positions and sizes, we should also avoid caching.
            // This is because the offset changes slightly as scroll position changes and caching leads to stale values.
            // For more info refer to issue #395
            //
            // If isScrollingOptOut is specified, we always cache cells.
            // For more info refer to issue #1028
            if ((isScrollingOptOut || isScrolling) && !horizontalOffsetAdjustment && !verticalOffsetAdjustment) {
                if (!cellCache[key]) cellCache[key] = cellRenderer(cellRendererParams);
                renderedCell = cellCache[key];
            // If the user is no longer scrolling, don't cache cells.
            // This makes dynamic cell content difficult for users and would also lead to a heavier memory footprint.
            } else renderedCell = cellRenderer(cellRendererParams);
            if (renderedCell == null || renderedCell === false) continue;
            if (!renderedCell.props.role) renderedCell = /*#__PURE__*/ $f875d38dda4abc8d$var$_react["default"].cloneElement(renderedCell, {
                role: 'gridcell'
            });
            renderedCells.push(renderedCell);
        }
    }
    return renderedCells;
}
function $f875d38dda4abc8d$var$warnAboutMissingStyle(parent, renderedCell) {}

});

parcelRegister("cFh2O", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $9386890b0db98f8c$export$2e2bcd8739ae039);

var $1gbOI = parcelRequire("1gbOI");
var $9386890b0db98f8c$var$size;
function $9386890b0db98f8c$export$2e2bcd8739ae039(recalc) {
    if (!$9386890b0db98f8c$var$size && $9386890b0db98f8c$var$size !== 0 || recalc) {
        if (0, $1gbOI.default) {
            var scrollDiv = document.createElement('div');
            scrollDiv.style.position = 'absolute';
            scrollDiv.style.top = '-9999px';
            scrollDiv.style.width = '50px';
            scrollDiv.style.height = '50px';
            scrollDiv.style.overflow = 'scroll';
            document.body.appendChild(scrollDiv);
            $9386890b0db98f8c$var$size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
            document.body.removeChild(scrollDiv);
        }
    }
    return $9386890b0db98f8c$var$size;
}

});
parcelRegister("1gbOI", function(module, exports) {
$parcel$export(module.exports, "default", () => $0eb073a8e0d84c4f$export$2e2bcd8739ae039);
var $0eb073a8e0d84c4f$export$2e2bcd8739ae039 = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

});


parcelRegister("cKDwS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.requestAnimationTimeout = module.exports.cancelAnimationTimeout = void 0;

var $auchO = parcelRequire("auchO");
/*:: export type AnimationTimeoutId = {
  id: number,
};*/ var $94887195041827fa$var$cancelAnimationTimeout = module.exports.cancelAnimationTimeout = function cancelAnimationTimeout(frame /*: AnimationTimeoutId*/ ) {
    return (0, $auchO.caf)(frame.id);
};
/**
 * Recursively calls requestAnimationFrame until a specified delay has been met or exceeded.
 * When the delay time has been reached the function you're timing out will be called.
 *
 * Credit: Joe Lambert (https://gist.github.com/joelambert/1002116#file-requesttimeout-js)
 */ var $94887195041827fa$var$requestAnimationTimeout = module.exports.requestAnimationTimeout = function requestAnimationTimeout(callback /*: Function*/ , delay /*: number*/ ) /*: AnimationTimeoutId*/ {
    var start;
    // wait for end of processing current event handler, because event handler may be long
    Promise.resolve().then(function() {
        start = Date.now();
    });
    var _timeout = function timeout() {
        if (Date.now() - start >= delay) callback.call();
        else frame.id = (0, $auchO.raf)(_timeout);
    };
    var frame /*: AnimationTimeoutId*/  = {
        id: (0, $auchO.raf)(_timeout)
    };
    return frame;
};

});
parcelRegister("auchO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.raf = module.exports.caf = void 0;
/*:: type Callback = (timestamp: number) => void;*/ /*:: type CancelAnimationFrame = (requestId: number) => void;*/ /*:: type RequestAnimationFrame = (callback: Callback) => number;*/ // Properly handle server-side rendering.
var $7a263c8c31628e05$var$win;
if (typeof window !== 'undefined') $7a263c8c31628e05$var$win = window;
else if (typeof self !== 'undefined') $7a263c8c31628e05$var$win = self;
else $7a263c8c31628e05$var$win = {};
// requestAnimationFrame() shim by Paul Irish
// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
var $7a263c8c31628e05$var$request = $7a263c8c31628e05$var$win.requestAnimationFrame || $7a263c8c31628e05$var$win.webkitRequestAnimationFrame || $7a263c8c31628e05$var$win.mozRequestAnimationFrame || $7a263c8c31628e05$var$win.oRequestAnimationFrame || $7a263c8c31628e05$var$win.msRequestAnimationFrame || function(callback /*: Callback*/ ) /*: RequestAnimationFrame*/ {
    return $7a263c8c31628e05$var$win /*: any*/ .setTimeout(callback, 1000 / 60);
};
var $7a263c8c31628e05$var$cancel = $7a263c8c31628e05$var$win.cancelAnimationFrame || $7a263c8c31628e05$var$win.webkitCancelAnimationFrame || $7a263c8c31628e05$var$win.mozCancelAnimationFrame || $7a263c8c31628e05$var$win.oCancelAnimationFrame || $7a263c8c31628e05$var$win.msCancelAnimationFrame || function(id /*: number*/ ) {
    $7a263c8c31628e05$var$win /*: any*/ .clearTimeout(id);
};
var $7a263c8c31628e05$var$raf /*: RequestAnimationFrame*/  = module.exports.raf = $7a263c8c31628e05$var$request /*: any*/ ;
var $7a263c8c31628e05$var$caf /*: CancelAnimationFrame*/  = module.exports.caf = $7a263c8c31628e05$var$cancel /*: any*/ ;

});



parcelRegister("kXEDY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SCROLL_DIRECTION_VERTICAL = module.exports.SCROLL_DIRECTION_HORIZONTAL = module.exports.SCROLL_DIRECTION_FORWARD = module.exports.SCROLL_DIRECTION_BACKWARD = void 0;
module.exports["default"] = $f428d8515157de6f$var$defaultOverscanIndicesGetter;
/*:: import type {OverscanIndicesGetterParams, OverscanIndices} from './types';*/ var $f428d8515157de6f$var$SCROLL_DIRECTION_BACKWARD = module.exports.SCROLL_DIRECTION_BACKWARD = -1;
var $f428d8515157de6f$var$SCROLL_DIRECTION_FORWARD = module.exports.SCROLL_DIRECTION_FORWARD = 1;
var $f428d8515157de6f$var$SCROLL_DIRECTION_HORIZONTAL = module.exports.SCROLL_DIRECTION_HORIZONTAL = 'horizontal';
var $f428d8515157de6f$var$SCROLL_DIRECTION_VERTICAL = module.exports.SCROLL_DIRECTION_VERTICAL = 'vertical';
/**
 * Calculates the number of cells to overscan before and after a specified range.
 * This function ensures that overscanning doesn't exceed the available cells.
 */ function $f428d8515157de6f$var$defaultOverscanIndicesGetter(_ref /*:: */ ) /*: OverscanIndices*/ {
    var cellCount = _ref /*:: */ .cellCount, overscanCellsCount = _ref /*:: */ .overscanCellsCount, scrollDirection = _ref /*:: */ .scrollDirection, startIndex = _ref /*:: */ .startIndex, stopIndex = _ref /*:: */ .stopIndex;
    // Make sure we render at least 1 cell extra before and after (except near boundaries)
    // This is necessary in order to support keyboard navigation (TAB/SHIFT+TAB) in some cases
    // For more info see issues #625
    overscanCellsCount = Math.max(1, overscanCellsCount);
    if (scrollDirection === $f428d8515157de6f$var$SCROLL_DIRECTION_FORWARD) return {
        overscanStartIndex: Math.max(0, startIndex - 1),
        overscanStopIndex: Math.min(cellCount - 1, stopIndex + overscanCellsCount)
    };
    else return {
        overscanStartIndex: Math.max(0, startIndex - overscanCellsCount),
        overscanStopIndex: Math.min(cellCount - 1, stopIndex + 1)
    };
}

});




parcelRegister("dkZQn", function(module, exports) {
$parcel$export(module.exports, "QuickInsertEmptyState", () => $182200d58e8a6ffe$export$adf0dc53f331d03d);
/* QuickInsertEmptyState.tsx generated by @compiled/babel-plugin v3.0.2 */ /* QuickInsertEmptyState.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $cJJTb = parcelRequire("cJJTb");

var $jDsoo = parcelRequire("jDsoo");

var $9PwDt = parcelRequire("9PwDt");

var $8aT4G = parcelRequire("8aT4G");

var $64eKJ = parcelRequire("64eKJ");

const $182200d58e8a6ffe$var$NoResultsIllustration = (0, $cJJTb.lazy)(()=>(parcelRequire("gmAyu")).then((module)=>module.default), {
    moduleId: "../platform/packages/editor/editor-common/src/quick-insert/assets/no-results.tsx"
});
const $182200d58e8a6ffe$var$styles = {
    base: "_zulp1ejb _4cvr1h6o _1e0c1txw _2lx21bp4 _1bah1h6o _1bsb1osq",
    compact: "_1rjcxy5q",
    spacious: "_1rjcoahv",
    inlineIllustration: "_4t3i1h39 _1bsb1mcy",
    fullIllustration: "_4t3io7ol _1bsbtudo"
};
const $182200d58e8a6ffe$export$adf0dc53f331d03d = ({ mode: mode, spacing: spacing = mode === 'full' ? 'spacious' : 'compact' })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const illustrationSize = mode === 'full' ? {
        width: 76,
        height: 84
    } : {
        width: 57,
        height: 63
    };
    return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $9PwDt.Box), {
        testId: "quick-insert-empty-state",
        xcss: (0, $jDsoo.cx)($182200d58e8a6ffe$var$styles.base, $182200d58e8a6ffe$var$styles[spacing]),
        children: [
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
                xcss: mode === 'full' ? $182200d58e8a6ffe$var$styles.fullIllustration : $182200d58e8a6ffe$var$styles.inlineIllustration,
                children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $cJJTb.LazySuspense), {
                    fallback: null,
                    children: /*#__PURE__*/ (0, $dc70d.jsx)($182200d58e8a6ffe$var$NoResultsIllustration, {
                        width: illustrationSize.width,
                        height: illustrationSize.height
                    })
                })
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $8aT4G.Text), {
                align: "center",
                children: formatMessage((0, $64eKJ.messages).noSearchResults)
            })
        ]
    });
};

});
parcelRegister("gmAyu", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = $kOunM("7LYN1").then(()=>parcelRequire('jykL3'));

});


parcelRegister("bLecl", function(module, exports) {
$parcel$export(module.exports, "useMenuListHeight", () => $aae5a60fa37ba015$export$990e159d9d1eed48);

var $bSJIT = parcelRequire("bSJIT");
function $aae5a60fa37ba015$export$990e159d9d1eed48(cache, rowCount, rowKeySignature) {
    const [height, setHeight] = (0, $bSJIT.useState)(()=>Array.from({
            length: rowCount
        }, (_, index)=>cache.rowHeight({
                index: index
            })).reduce((sum, value)=>sum + value, 0));
    const frame = (0, $bSJIT.useRef)();
    const updateHeight = (0, $bSJIT.useCallback)(()=>{
        if (frame.current !== undefined) cancelAnimationFrame(frame.current);
        // CellMeasurer updates its cache during commit. Read it after all rows have measured.
        frame.current = requestAnimationFrame(()=>{
            frame.current = undefined;
            const total = Array.from({
                length: rowCount
            }, (_, index)=>cache.rowHeight({
                    index: index
                })).reduce((sum, height)=>sum + height, 0);
            setHeight(total);
        });
    }, [
        cache,
        rowCount
    ]);
    (0, $bSJIT.useLayoutEffect)(()=>{
        updateHeight();
        return ()=>{
            if (frame.current !== undefined) cancelAnimationFrame(frame.current);
        };
    }, [
        rowKeySignature,
        updateHeight
    ]);
    return {
        height: height,
        updateHeight: updateHeight
    };
}

});

parcelRegister("6VwRD", function(module, exports) {
$parcel$export(module.exports, "RegisteredInsertMenuPreviewContext", () => $aa0952108ac6156b$export$1bfac1f1ae4f7945);
$parcel$export(module.exports, "RegisteredInsertMenuItem", () => $aa0952108ac6156b$export$29f7e8e1a92aeee8);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $g6Qq4 = parcelRequire("g6Qq4");

var $dw0oh = parcelRequire("dw0oh");

var $5PGJG = parcelRequire("5PGJG");
const $aa0952108ac6156b$export$1bfac1f1ae4f7945 = /*#__PURE__*/ (0, $bSJIT.createContext)(undefined);
const $aa0952108ac6156b$export$29f7e8e1a92aeee8 = ({ editorView: editorView, id: id, isOffline: isOffline, isSelected: isSelected, menuOpenId: menuOpenId, onClose: onClose, registration: registration, surfaceContext: surfaceContext })=>{
    const Component = registration.component ?? (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment;
    const activePreviewItemKey = (0, $bSJIT.useContext)($aa0952108ac6156b$export$1bfac1f1ae4f7945);
    const isPreviewActive = activePreviewItemKey === registration.key;
    const select = (0, $bSJIT.useCallback)((selectionHandler)=>{
        // Close first so a registered item may safely focus the editor or open its picker.
        onClose();
        queueMicrotask(()=>{
            const { state: state } = editorView;
            const insert = (content, options = {})=>(0, $dw0oh.insertSelectedItem)(content, options)(state, state.tr, state.selection.head);
            const transaction = selectionHandler({
                insert: insert,
                source: (0, $g6Qq4.INPUT_METHOD).INSERT_MENU
            });
            if (transaction) editorView.dispatch(transaction);
        });
    }, [
        editorView,
        onClose
    ]);
    const contextValue = (0, $bSJIT.useMemo)(()=>({
            editorView: editorView,
            isOffline: isOffline,
            item: {
                id: id,
                isPreviewActive: isPreviewActive,
                isSelected: isSelected
            },
            menuOpenId: menuOpenId,
            select: select,
            surface: 'toolbar',
            surfaceContext: surfaceContext
        }), [
        editorView,
        id,
        isOffline,
        isPreviewActive,
        isSelected,
        menuOpenId,
        select,
        surfaceContext
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $5PGJG.QuickInsertProvider), {
        value: contextValue,
        children: /*#__PURE__*/ (0, $dc70d.jsx)(Component, {
            children: null
        })
    });
};

});
parcelRegister("5PGJG", function(module, exports) {
$parcel$export(module.exports, "QuickInsertProvider", () => $1ad1335242ae5984$export$8ef13bedce759b55);

var $qQDWx = parcelRequire("qQDWx");
const $1ad1335242ae5984$export$8ef13bedce759b55 = (0, $qQDWx.QuickInsertContext).Provider;

});






parcelRegister("hhBlT", function(module, exports) {
$parcel$export(module.exports, "CodeBlockButton", () => $62c0cc69bd624b69$export$f18e402f09bee3a1);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $g6Qq4 = parcelRequire("g6Qq4");

var $cv8id = parcelRequire("cv8id");

var $8iYGb = parcelRequire("8iYGb");

var $28qc1 = parcelRequire("28qc1");

var $imwtU = parcelRequire("imwtU");

var $7cgYb = parcelRequire("7cgYb");

var $eHnl8 = parcelRequire("eHnl8");
const $62c0cc69bd624b69$export$f18e402f09bee3a1 = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const { editorView: editorView } = (0, $28qc1.useEditorToolbar)();
    if (!(api !== null && api !== void 0 && api.codeBlock)) return null;
    const onClick = ()=>{
        if (editorView) {
            var _api$codeBlock;
            api === null || api === void 0 || (_api$codeBlock = api.codeBlock) === null || _api$codeBlock === void 0 || _api$codeBlock.actions.insertCodeBlock((0, $g6Qq4.INPUT_METHOD).TOOLBAR)(editorView.state, editorView.dispatch);
        }
    };
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $eHnl8.ToolbarTooltip), {
        content: /*#__PURE__*/ (0, $dc70d.jsx)((0, $cv8id.ToolTipContent), {
            description: formatMessage((0, $8iYGb.messages).codeblock),
            keymap: (0, $cv8id.toggleCodeBlock)
        }),
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $7cgYb.ToolbarButton), {
            iconBefore: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($imwtU))), {
                label: formatMessage((0, $8iYGb.messages).codeblock),
                size: "small"
            }),
            onClick: onClick,
            ariaKeyshortcuts: (0, $cv8id.getAriaKeyshortcuts)((0, $cv8id.toggleCodeBlock))
        })
    });
};

});

parcelRegister("k2pNP", function(module, exports) {
$parcel$export(module.exports, "resolveToolbarConfig", () => $b685e608a0a20dd2$export$ab4e2221b4885da5);
const $b685e608a0a20dd2$export$ab4e2221b4885da5 = (options)=>{
    var _options$toolbarButto, _options$toolbarButto2, _options$toolbarButto3, _options$toolbarButto4, _options$toolbarButto5, _options$toolbarButto6, _options$toolbarButto7, _options$toolbarButto8;
    // Handle backward compatibility: toolbarShowPlusInsertOnly
    if (options.toolbarShowPlusInsertOnly) return {
        codeBlock: {
            enabled: false
        },
        emoji: {
            enabled: false
        },
        insert: {
            enabled: true
        },
        layout: {
            enabled: false
        },
        media: {
            enabled: false
        },
        mention: {
            enabled: false
        },
        table: {
            enabled: false
        },
        taskList: {
            enabled: false
        }
    };
    if (!options.toolbarButtons) // disable code block by default if there's no toolbarButtons options provided, e.g on full page editor
    return {
        codeBlock: {
            enabled: false
        },
        emoji: {
            enabled: true
        },
        insert: {
            enabled: true
        },
        layout: {
            enabled: true
        },
        media: {
            enabled: true
        },
        mention: {
            enabled: true
        },
        table: {
            enabled: true
        },
        taskList: {
            enabled: true
        }
    };
    const defaults = {
        enabled: false,
        showAt: 'lg'
    };
    const resolveGroupConfig = (groupConfig)=>{
        return {
            enabled: (groupConfig === null || groupConfig === void 0 ? void 0 : groupConfig.enabled) ?? defaults.enabled,
            showAt: (groupConfig === null || groupConfig === void 0 ? void 0 : groupConfig.showAt) ?? defaults.showAt
        };
    };
    return {
        codeBlock: resolveGroupConfig((_options$toolbarButto = options.toolbarButtons) === null || _options$toolbarButto === void 0 ? void 0 : _options$toolbarButto.codeBlock),
        emoji: resolveGroupConfig((_options$toolbarButto2 = options.toolbarButtons) === null || _options$toolbarButto2 === void 0 ? void 0 : _options$toolbarButto2.emoji),
        insert: resolveGroupConfig((_options$toolbarButto3 = options.toolbarButtons) === null || _options$toolbarButto3 === void 0 ? void 0 : _options$toolbarButto3.insert),
        layout: resolveGroupConfig((_options$toolbarButto4 = options.toolbarButtons) === null || _options$toolbarButto4 === void 0 ? void 0 : _options$toolbarButto4.layout),
        media: resolveGroupConfig((_options$toolbarButto5 = options.toolbarButtons) === null || _options$toolbarButto5 === void 0 ? void 0 : _options$toolbarButto5.media),
        mention: resolveGroupConfig((_options$toolbarButto6 = options.toolbarButtons) === null || _options$toolbarButto6 === void 0 ? void 0 : _options$toolbarButto6.mention),
        table: resolveGroupConfig((_options$toolbarButto7 = options.toolbarButtons) === null || _options$toolbarButto7 === void 0 ? void 0 : _options$toolbarButto7.table),
        taskList: resolveGroupConfig((_options$toolbarButto8 = options.toolbarButtons) === null || _options$toolbarButto8 === void 0 ? void 0 : _options$toolbarButto8.taskList)
    };
};

});

parcelRegister("2tCEh", function(module, exports) {
$parcel$export(module.exports, "EmojiButton", () => $ed3d6e6e395e57b8$export$e6ce3311a4d41b7f);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $cv8id = parcelRequire("cv8id");

var $cW1gB = parcelRequire("cW1gB");

var $4rzOL = parcelRequire("4rzOL");

var $5beht = parcelRequire("5beht");

var $9YTEJ = parcelRequire("9YTEJ");

var $7cgYb = parcelRequire("7cgYb");

var $eHnl8 = parcelRequire("eHnl8");

var $aBdvW = parcelRequire("aBdvW");

var $lvIlh = parcelRequire("lvIlh");

var $gVNLS = parcelRequire("gVNLS");
const $ed3d6e6e395e57b8$export$e6ce3311a4d41b7f = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const emojiButtonRef = (0, $bSJIT.useRef)(null);
    const { popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement } = (0, $aBdvW.useToolbarUI)();
    const { contentId: contentId, emojiProviderPromise: emojiProviderPromise, isTypeAheadAllowed: isTypeAheadAllowed } = (0, $5beht.useSharedPluginStateWithSelector)(api, [
        'emoji',
        'typeAhead'
    ], (states)=>{
        var _states$emojiState, _states$emojiState2, _states$typeAheadStat;
        return {
            contentId: (_states$emojiState = states.emojiState) === null || _states$emojiState === void 0 ? void 0 : _states$emojiState.contentId,
            emojiProviderPromise: (_states$emojiState2 = states.emojiState) === null || _states$emojiState2 === void 0 ? void 0 : _states$emojiState2.emojiProviderPromise,
            isTypeAheadAllowed: (_states$typeAheadStat = states.typeAheadState) === null || _states$typeAheadStat === void 0 ? void 0 : _states$typeAheadStat.isAllowed
        };
    });
    const emojiPickerPopup = (0, $lvIlh.useEmojiPickerPopup)({
        api: api,
        buttonRef: emojiButtonRef
    });
    if (!(api !== null && api !== void 0 && api.emoji)) return null;
    return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $dc70d.Fragment), {
        children: [
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $gVNLS.EmojiPickerPopup), {
                contentId: contentId,
                isOpen: emojiPickerPopup.isOpen,
                targetRef: emojiButtonRef,
                emojiProvider: emojiProviderPromise,
                onSelection: emojiPickerPopup.handleSelectedEmoji,
                onClickOutside: emojiPickerPopup.handleClickOutside,
                onEscapeKeydown: emojiPickerPopup.handleEscapeKeydown,
                onUnmount: emojiPickerPopup.onPopupUnmount,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $eHnl8.ToolbarTooltip), {
                content: /*#__PURE__*/ (0, $dc70d.jsx)((0, $cv8id.ToolTipContent), {
                    description: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).emoji),
                    keymap: (0, $cv8id.insertEmoji)
                }),
                children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $7cgYb.ToolbarButton), {
                    iconBefore: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9YTEJ))), {
                        label: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).emoji),
                        size: "small"
                    }),
                    ariaKeyshortcuts: "Shift+;",
                    ref: emojiButtonRef,
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    onClick: ()=>emojiPickerPopup.toggle(),
                    isSelected: emojiPickerPopup.isOpen,
                    isDisabled: !isTypeAheadAllowed || !emojiProviderPromise,
                    testId: (0, $4rzOL.TOOLBAR_BUTTON_TEST_ID).EMOJI
                })
            })
        ]
    });
};

});
parcelRegister("lvIlh", function(module, exports) {
$parcel$export(module.exports, "useEmojiPickerPopup", () => $0dee6e1a2ed8dc53$export$906c13b7666cd621);

var $bSJIT = parcelRequire("bSJIT");

var $g6Qq4 = parcelRequire("g6Qq4");

var $6SgET = parcelRequire("6SgET");
const $0dee6e1a2ed8dc53$export$906c13b7666cd621 = ({ api: api, buttonRef: buttonRef })=>{
    const popupManager = (0, $6SgET.usePopupManager)({
        focusTarget: buttonRef,
        analytics: {
            onToggle: (isOpen)=>{
                if (isOpen) {
                    var _api$analytics;
                    api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 || _api$analytics.actions.fireAnalyticsEvent({
                        action: (0, $g6Qq4.ACTION).OPENED,
                        actionSubject: (0, $g6Qq4.ACTION_SUBJECT).PICKER,
                        actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).PICKER_EMOJI,
                        attributes: {
                            inputMethod: (0, $g6Qq4.INPUT_METHOD).TOOLBAR
                        },
                        eventType: (0, $g6Qq4.EVENT_TYPE).UI
                    });
                }
            }
        }
    });
    const handleSelectedEmoji = (0, $bSJIT.useCallback)((emojiId)=>{
        var _api$emoji;
        api === null || api === void 0 || api.core.actions.focus();
        api === null || api === void 0 || api.core.actions.execute(api === null || api === void 0 || (_api$emoji = api.emoji) === null || _api$emoji === void 0 ? void 0 : _api$emoji.commands.insertEmoji(emojiId, (0, $g6Qq4.INPUT_METHOD).PICKER));
        popupManager.close();
        return true;
    }, [
        api,
        popupManager
    ]);
    const onPopupUnmount = (0, $bSJIT.useCallback)(()=>{
        requestAnimationFrame(()=>api === null || api === void 0 ? void 0 : api.core.actions.focus());
    }, [
        api
    ]);
    return {
        ...popupManager,
        handleSelectedEmoji: handleSelectedEmoji,
        onPopupUnmount: onPopupUnmount
    };
};

});
parcelRegister("6SgET", function(module, exports) {
$parcel$export(module.exports, "usePopupManager", () => $0c5300cf3e8158de$export$7db65f41c8758d11);

var $bSJIT = parcelRequire("bSJIT");

var $3vBr2 = parcelRequire("3vBr2");
const $0c5300cf3e8158de$export$7db65f41c8758d11 = (config = {})=>{
    const [isOpen, setIsOpen] = (0, $bSJIT.useState)(false);
    const [isOpenedByKeyboard, setIsOpenedByKeyboard] = (0, $bSJIT.useState)(false);
    const toggle = (0, $bSJIT.useCallback)((inputMethod)=>{
        var _config$analytics, _config$analytics$onT;
        const newState = !isOpen;
        setIsOpen(newState);
        if (newState) {
            var _config$onOpen;
            (_config$onOpen = config.onOpen) === null || _config$onOpen === void 0 || _config$onOpen.call(config, inputMethod);
        } else {
            var _config$onClose;
            (_config$onClose = config.onClose) === null || _config$onClose === void 0 || _config$onClose.call(config);
        }
        (_config$analytics = config.analytics) === null || _config$analytics === void 0 || (_config$analytics$onT = _config$analytics.onToggle) === null || _config$analytics$onT === void 0 || _config$analytics$onT.call(_config$analytics, newState, inputMethod);
    }, [
        isOpen,
        config
    ]);
    const close = (0, $bSJIT.useCallback)(()=>{
        var _config$onClose2, _config$analytics2, _config$analytics2$on;
        setIsOpen(false);
        (_config$onClose2 = config.onClose) === null || _config$onClose2 === void 0 || _config$onClose2.call(config);
        (_config$analytics2 = config.analytics) === null || _config$analytics2 === void 0 || (_config$analytics2$on = _config$analytics2.onToggle) === null || _config$analytics2$on === void 0 || _config$analytics2$on.call(_config$analytics2, false);
    }, [
        config
    ]);
    const handleEscapeKeydown = (0, $bSJIT.useCallback)(()=>{
        var _config$focusTarget;
        close();
        (_config$focusTarget = config.focusTarget) === null || _config$focusTarget === void 0 || (_config$focusTarget = _config$focusTarget.current) === null || _config$focusTarget === void 0 || _config$focusTarget.focus();
    }, [
        close,
        config.focusTarget
    ]);
    const handleClickOutside = (0, $bSJIT.useCallback)((e)=>{
        if (e.target instanceof HTMLElement && !(0, $3vBr2.isDetachedElement)(e.target)) close();
    }, [
        close
    ]);
    const handleKeyboardOpen = (0, $bSJIT.useCallback)((event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            setIsOpenedByKeyboard(true);
            event.preventDefault();
        }
    }, []);
    return {
        isOpen: isOpen,
        isOpenedByKeyboard: isOpenedByKeyboard,
        toggle: toggle,
        close: close,
        handleEscapeKeydown: handleEscapeKeydown,
        handleClickOutside: handleClickOutside,
        handleKeyboardOpen: handleKeyboardOpen
    };
};

});
parcelRegister("3vBr2", function(module, exports) {
$parcel$export(module.exports, "isDetachedElement", () => $4d49111d31a41161$export$2670f72994f3eb72);
/**
 * Checks if an element is detached (i.e. not in the current document)
 */ const $4d49111d31a41161$export$2670f72994f3eb72 = (el)=>!document.body.contains(el);

});



parcelRegister("gVNLS", function(module, exports) {
$parcel$export(module.exports, "EmojiPickerPopup", () => $e2eacce688271739$export$84d7903b9ff4f263);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $5zk80 = parcelRequire("5zk80");

var $3Aq92 = parcelRequire("3Aq92");

var $cf2n1 = parcelRequire("cf2n1");

var $5bbjm = parcelRequire("5bbjm");

var $asaws = parcelRequire("asaws");
const $e2eacce688271739$var$EmojiPicker = (props)=>{
    const setOutsideClickTargetRef = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useContext((0, $3Aq92.OutsideClickTargetRefContext));
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $asaws.default), {
        contentId: props.contentId,
        onPickerRef: setOutsideClickTargetRef,
        emojiProvider: props.emojiProvider,
        onSelection: props.onSelection
    });
};
const $e2eacce688271739$var$EmojiPickerWithListeners = (0, $cf2n1.default)($e2eacce688271739$var$EmojiPicker);
const $e2eacce688271739$export$84d7903b9ff4f263 = ({ contentId: contentId, isOpen: isOpen, targetRef: targetRef, emojiProvider: emojiProvider, onSelection: onSelection, onClickOutside: onClickOutside, onEscapeKeydown: onEscapeKeydown, onUnmount: onUnmount, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement })=>{
    if (!isOpen || !targetRef.current || !emojiProvider) return null;
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $5zk80.default), {
        target: targetRef.current,
        fitHeight: 350,
        fitWidth: 350,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        offset: [
            0,
            3
        ],
        mountTo: popupsMountPoint,
        boundariesElement: popupsBoundariesElement,
        scrollableElement: popupsScrollableElement,
        onUnmount: onUnmount,
        focusTrap: true,
        zIndex: (0, $5bbjm.akEditorMenuZIndex),
        children: /*#__PURE__*/ (0, $dc70d.jsx)($e2eacce688271739$var$EmojiPickerWithListeners, {
            contentId: contentId,
            emojiProvider: emojiProvider,
            onSelection: onSelection,
            handleClickOutside: onClickOutside,
            handleEscapeKeydown: onEscapeKeydown
        })
    });
};

});


parcelRegister("gbYcG", function(module, exports) {
$parcel$export(module.exports, "ImageButton", () => $a3452e58db0f789d$export$7554951b29a2b076);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $hVGJk = parcelRequire("hVGJk");

var $cW1gB = parcelRequire("cW1gB");

var $28qc1 = parcelRequire("28qc1");

var $4rzOL = parcelRequire("4rzOL");

var $5beht = parcelRequire("5beht");

var $g6NyP = parcelRequire("g6NyP");

var $7cgYb = parcelRequire("7cgYb");

var $eHnl8 = parcelRequire("eHnl8");
const $a3452e58db0f789d$export$7554951b29a2b076 = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const { connectivityMode: connectivityMode, imageUploadEnabled: imageUploadEnabled } = (0, $5beht.useSharedPluginStateWithSelector)(api, [
        'connectivity',
        'imageUpload'
    ], (states)=>{
        var _states$connectivityS, _states$imageUploadSt;
        return {
            connectivityMode: (_states$connectivityS = states.connectivityState) === null || _states$connectivityS === void 0 ? void 0 : _states$connectivityS.mode,
            imageUploadEnabled: (_states$imageUploadSt = states.imageUploadState) === null || _states$imageUploadSt === void 0 ? void 0 : _states$imageUploadSt.enabled
        };
    });
    const { editorView: editorView } = (0, $28qc1.useEditorToolbar)();
    const isOffline = (0, $hVGJk.isOfflineMode)(connectivityMode);
    const onClick = ()=>{
        if (editorView) {
            var _api$imageUpload;
            const { state: state, dispatch: dispatch } = editorView;
            api === null || api === void 0 || (_api$imageUpload = api.imageUpload) === null || _api$imageUpload === void 0 || _api$imageUpload.actions.startUpload()(state, dispatch);
        }
    };
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $eHnl8.ToolbarTooltip), {
        content: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).image),
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $7cgYb.ToolbarButton), {
            iconBefore: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g6NyP))), {
                label: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).image),
                size: "small"
            }),
            onClick: onClick,
            isDisabled: !imageUploadEnabled || isOffline,
            testId: (0, $4rzOL.TOOLBAR_BUTTON_TEST_ID).IMAGE
        })
    });
};

});

parcelRegister("2RgL0", function(module, exports) {
$parcel$export(module.exports, "InsertButton", () => $6c62dc3783f1b6d9$export$a84121b2ebfb3ce9);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $g6Qq4 = parcelRequire("g6Qq4");

var $cv8id = parcelRequire("cv8id");

var $cW1gB = parcelRequire("cW1gB");

var $5zk80 = parcelRequire("5zk80");

var $28qc1 = parcelRequire("28qc1");

var $4rzOL = parcelRequire("4rzOL");

var $2pWL6 = parcelRequire("2pWL6");

var $5bbjm = parcelRequire("5bbjm");

var $kFWau = parcelRequire("kFWau");

var $7cgYb = parcelRequire("7cgYb");

var $eHnl8 = parcelRequire("eHnl8");

var $aBdvW = parcelRequire("aBdvW");

var $iVq7n = parcelRequire("iVq7n");

var $4PIw5 = parcelRequire("4PIw5");

var $lvIlh = parcelRequire("lvIlh");

var $d2cRm = parcelRequire("d2cRm");

var $7bOJz = parcelRequire("7bOJz");

var $gVNLS = parcelRequire("gVNLS");
// This determines how the popup should fit. We prefer the insert menu
// opening on the bottom as we have a search bar and should only open on
// top if there is more than sufficient room.
const $6c62dc3783f1b6d9$var$FIT_HEIGHT_BUFFER = 100;
const $6c62dc3783f1b6d9$export$a84121b2ebfb3ce9 = ({ api: api, breakpoint: breakpoint, showElementBrowserLink: showElementBrowserLink = false, isFullPageAppearance: isFullPageAppearance = false, tableSelectorSupported: tableSelectorSupported, nativeStatusSupported: nativeStatusSupported, horizontalRuleEnabled: horizontalRuleEnabled, expandEnabled: expandEnabled, insertMenuItems: insertMenuItems, itemFilter: itemFilter, numberOfButtons: numberOfButtons, onInsertBlockType: onInsertBlockType, toolbarConfig: toolbarConfig })=>{
    const { editorView: editorView } = (0, $28qc1.useEditorToolbar)();
    const { isDisabled: isDisabled, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement } = (0, $aBdvW.useToolbarUI)();
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const [insertMenuOpen, setInsertMenuOpen] = (0, $bSJIT.useState)(false);
    const insertButtonRef = (0, $bSJIT.useRef)(null);
    const emojiPickerPopup = (0, $lvIlh.useEmojiPickerPopup)({
        api: api,
        buttonRef: insertButtonRef
    });
    const tableSelectorPopup = (0, $7bOJz.useTableSelectorPopup)({
        api: api,
        buttonRef: insertButtonRef
    });
    const showMediaPicker = (0, $2pWL6.useSharedPluginStateSelector)(api, 'media.showMediaPicker');
    const emojiContentId = (0, $2pWL6.useSharedPluginStateSelector)(api, 'emoji.contentId');
    const { dropdownItems: dropdownItems, emojiProvider: emojiProvider, isTypeAheadAllowed: isTypeAheadAllowed } = (0, $d2cRm.useInsertButtonState)({
        api: api,
        breakpoint: breakpoint,
        editorView: editorView || undefined,
        horizontalRuleEnabled: horizontalRuleEnabled,
        insertMenuItems: insertMenuItems,
        itemFilter: itemFilter,
        nativeStatusSupported: nativeStatusSupported,
        numberOfButtons: numberOfButtons,
        tableSelectorSupported: tableSelectorSupported,
        expandEnabled: expandEnabled,
        showElementBrowserLink: showElementBrowserLink,
        toolbarConfig: toolbarConfig
    });
    if (!(api !== null && api !== void 0 && api.insertBlock)) return null;
    const toggleInsertMenuOpen = (newState)=>{
        setInsertMenuOpen(newState);
    };
    const onPopupUnmount = ()=>{
        requestAnimationFrame(()=>api === null || api === void 0 ? void 0 : api.core.actions.focus());
    };
    const onClick = ()=>{
        toggleInsertMenuOpen(!insertMenuOpen);
    };
    const onItemActivated = ({ item: item, inputMethod: inputMethod })=>{
        var _api$core, _api$hyperlink, _api$imageUpload, _api$mention, _api$taskDecision, _api$rule, _api$core3, _api$date, _api$placeholderText, _api$layout, _api$core4, _api$status, _api$expand;
        if (!editorView) return;
        const { state: state, dispatch: dispatch } = editorView;
        // need to do this before inserting nodes so scrollIntoView works properly
        if (!editorView.hasFocus()) editorView.focus();
        switch(item.value.name){
            case 0, $4PIw5.LINK_BUTTON_KEY:
                api === null || api === void 0 || (_api$core = api.core) === null || _api$core === void 0 || _api$core.actions.execute(api === null || api === void 0 || (_api$hyperlink = api.hyperlink) === null || _api$hyperlink === void 0 ? void 0 : _api$hyperlink.commands.showLinkToolbar(inputMethod));
                break;
            case 'table':
                // workaround to solve race condition where cursor is not placed correctly inside table
                queueMicrotask(()=>{
                    var _api$table, _api$table$actions$in, _api$table$actions;
                    api === null || api === void 0 || (_api$table = api.table) === null || _api$table === void 0 || (_api$table$actions$in = (_api$table$actions = _api$table.actions).insertTable) === null || _api$table$actions$in === void 0 || _api$table$actions$in.call(_api$table$actions, {
                        action: (0, $g6Qq4.ACTION).INSERTED,
                        actionSubject: (0, $g6Qq4.ACTION_SUBJECT).DOCUMENT,
                        actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).TABLE,
                        attributes: {
                            inputMethod: inputMethod
                        },
                        eventType: (0, $g6Qq4.EVENT_TYPE).TRACK
                    })(state, dispatch);
                });
                break;
            case 'table selector':
                tableSelectorPopup.toggle(inputMethod);
                break;
            case 'image upload':
                if (api !== null && api !== void 0 && (_api$imageUpload = api.imageUpload) !== null && _api$imageUpload !== void 0 && _api$imageUpload.actions.startUpload) api.imageUpload.actions.startUpload()(state, dispatch);
                break;
            case 'media':
                if (showMediaPicker) {
                    var _api$mediaInsert, _api$core2, _api$mediaInsert2;
                    api !== null && api !== void 0 && (_api$mediaInsert = api.mediaInsert) !== null && _api$mediaInsert !== void 0 && _api$mediaInsert.commands.showMediaInsertPopup ? api === null || api === void 0 || (_api$core2 = api.core) === null || _api$core2 === void 0 || _api$core2.actions.execute(api === null || api === void 0 || (_api$mediaInsert2 = api.mediaInsert) === null || _api$mediaInsert2 === void 0 ? void 0 : _api$mediaInsert2.commands.showMediaInsertPopup()) : showMediaPicker === null || showMediaPicker === void 0 || showMediaPicker();
                }
                break;
            case 'mention':
                api === null || api === void 0 || (_api$mention = api.mention) === null || _api$mention === void 0 || (_api$mention = _api$mention.actions) === null || _api$mention === void 0 || _api$mention.openTypeAhead(inputMethod);
                break;
            case 'emoji':
                emojiPickerPopup.toggle(inputMethod);
                break;
            case 'codeblock':
            case 'blockquote':
            case 'panel':
                onInsertBlockType === null || onInsertBlockType === void 0 || onInsertBlockType(item.value.name)(state, dispatch);
                break;
            case 'action':
            case 'decision':
                const listType = item.value.name === 'action' ? 'taskList' : 'decisionList';
                api === null || api === void 0 || (_api$taskDecision = api.taskDecision) === null || _api$taskDecision === void 0 || _api$taskDecision.actions.insertTaskDecision(listType, inputMethod)(state, dispatch);
                break;
            case 'horizontalrule':
                api === null || api === void 0 || (_api$rule = api.rule) === null || _api$rule === void 0 || _api$rule.actions.insertHorizontalRule(inputMethod)(state, dispatch);
                break;
            case 'date':
                api === null || api === void 0 || (_api$core3 = api.core) === null || _api$core3 === void 0 || _api$core3.actions.execute(api === null || api === void 0 || (_api$date = api.date) === null || _api$date === void 0 || (_api$date = _api$date.commands) === null || _api$date === void 0 ? void 0 : _api$date.insertDate({
                    inputMethod: inputMethod
                }));
                break;
            case 'placeholder text':
                api === null || api === void 0 || (_api$placeholderText = api.placeholderText) === null || _api$placeholderText === void 0 || _api$placeholderText.actions.showPlaceholderFloatingToolbar(state, dispatch);
                break;
            case 'layout':
                api === null || api === void 0 || (_api$layout = api.layout) === null || _api$layout === void 0 || _api$layout.actions.insertLayoutColumns(inputMethod)(state, dispatch);
                break;
            case 'status':
                api === null || api === void 0 || (_api$core4 = api.core) === null || _api$core4 === void 0 || _api$core4.actions.execute(api === null || api === void 0 || (_api$status = api.status) === null || _api$status === void 0 || (_api$status = _api$status.commands) === null || _api$status === void 0 ? void 0 : _api$status.insertStatus(inputMethod));
                break;
            case 'expand':
                api === null || api === void 0 || (_api$expand = api.expand) === null || _api$expand === void 0 || _api$expand.actions.insertExpand(state, dispatch);
                break;
            default:
                if (item && item.onClick) item.onClick();
                break;
        }
        toggleInsertMenuOpen(false);
    };
    const onInsert = ({ item: item })=>{
        onItemActivated({
            item: item,
            inputMethod: (0, $g6Qq4.INPUT_METHOD).INSERT_MENU
        });
    };
    const toggleVisibility = ()=>{
        toggleInsertMenuOpen(!insertMenuOpen);
    };
    return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $dc70d.Fragment), {
        children: [
            insertMenuOpen && insertButtonRef.current && editorView && /*#__PURE__*/ (0, $dc70d.jsx)((0, $5zk80.default), {
                target: insertButtonRef.current,
                fitHeight: (0, $iVq7n.DEFAULT_HEIGHT) + $6c62dc3783f1b6d9$var$FIT_HEIGHT_BUFFER,
                fitWidth: 350,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                offset: [
                    0,
                    3
                ],
                mountTo: popupsMountPoint,
                boundariesElement: popupsBoundariesElement,
                scrollableElement: popupsScrollableElement,
                onUnmount: onPopupUnmount,
                focusTrap: true,
                zIndex: (0, $5bbjm.akEditorMenuZIndex),
                preventOverflow: true,
                alignX: "right",
                children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $iVq7n.default), {
                    editorView: editorView,
                    dropdownItems: dropdownItems,
                    onInsert: onInsert,
                    toggleVisiblity: toggleVisibility,
                    showElementBrowserLink: showElementBrowserLink,
                    pluginInjectionApi: api,
                    isFullPageAppearance: isFullPageAppearance
                })
            }),
            emojiProvider && /*#__PURE__*/ (0, $dc70d.jsx)((0, $gVNLS.EmojiPickerPopup), {
                contentId: emojiContentId,
                isOpen: emojiPickerPopup.isOpen,
                targetRef: insertButtonRef,
                emojiProvider: Promise.resolve(emojiProvider),
                onSelection: emojiPickerPopup.handleSelectedEmoji,
                onClickOutside: emojiPickerPopup.handleClickOutside,
                onEscapeKeydown: emojiPickerPopup.handleEscapeKeydown,
                onUnmount: emojiPickerPopup.onPopupUnmount,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $eHnl8.ToolbarTooltip), {
                content: /*#__PURE__*/ (0, $dc70d.jsx)((0, $cv8id.ToolTipContent), {
                    description: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).insertMenu),
                    keymap: (0, $cv8id.insertElements)
                }),
                children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $7cgYb.ToolbarButton), {
                    iconBefore: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kFWau))), {
                        size: "small",
                        label: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).insertMenu)
                    }),
                    ariaKeyshortcuts: (0, $cv8id.getAriaKeyshortcuts)((0, $cv8id.insertElements)),
                    ref: insertButtonRef,
                    onClick: onClick,
                    isSelected: insertMenuOpen,
                    isDisabled: !isTypeAheadAllowed || isDisabled,
                    testId: (0, $4rzOL.TOOLBAR_BUTTON_TEST_ID).INSERT
                })
            })
        ]
    });
};

});
parcelRegister("iVq7n", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_HEIGHT", () => $2cab17a458efcd19$export$611c894df53833b0);
$parcel$export(module.exports, "default", () => $2cab17a458efcd19$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $afyUO = parcelRequire("afyUO");

var $g6Qq4 = parcelRequire("g6Qq4");

var $5BUNL = parcelRequire("5BUNL");

var $hVGJk = parcelRequire("hVGJk");

var $kfANO = parcelRequire("kfANO");

var $disn5 = parcelRequire("disn5");

var $3Aq92 = parcelRequire("3Aq92");

var $cf2n1 = parcelRequire("cf2n1");

var $5beht = parcelRequire("5beht");
function $2cab17a458efcd19$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2cab17a458efcd19$export$611c894df53833b0 = 560;
const $2cab17a458efcd19$export$bc386af06edc2d75 = (featuredItems)=>{
    return featuredItems.slice(0).sort((a, b)=>(a.priority ?? Number.POSITIVE_INFINITY) - (b.priority ?? Number.POSITIVE_INFINITY));
};
const $2cab17a458efcd19$var$selector = (states)=>{
    var _states$connectivityS;
    return {
        connectivityMode: (_states$connectivityS = states.connectivityState) === null || _states$connectivityS === void 0 ? void 0 : _states$connectivityS.mode
    };
};
const $2cab17a458efcd19$var$InsertMenu = ({ editorView: editorView, dropdownItems: dropdownItems, showElementBrowserLink: showElementBrowserLink, onInsert: onInsert, toggleVisiblity: toggleVisiblity, pluginInjectionApi: pluginInjectionApi })=>{
    var _pluginInjectionApi$q4, _pluginInjectionApi$q5;
    const [itemCount, setItemCount] = (0, $bSJIT.useState)(0);
    const [height, setHeight] = (0, $bSJIT.useState)($2cab17a458efcd19$export$611c894df53833b0);
    const cache = (0, $bSJIT.useMemo)(()=>{
        return new (0, $afyUO.CellMeasurerCache)({
            fixedWidth: true,
            defaultHeight: (0, $kfANO.ELEMENT_ITEM_HEIGHT),
            minHeight: (0, $kfANO.ELEMENT_ITEM_HEIGHT)
        });
    }, []);
    (0, $bSJIT.useLayoutEffect)(()=>{
        // Figure based on visuals to exclude the searchbar, padding/margin, and the ViewMore item.
        const EXTRA_SPACE_EXCLUDING_ELEMENTLIST = 128;
        const totalItemHeight = // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- Ignored via go/ees017 (to be fixed)
        [
            ...Array(itemCount)
        ].reduce((sum, _, index)=>sum + cache.rowHeight({
                index: index
            }), 0) + EXTRA_SPACE_EXCLUDING_ELEMENTLIST;
        if (itemCount > 0 && totalItemHeight < $2cab17a458efcd19$export$611c894df53833b0) setHeight(totalItemHeight);
        else setHeight($2cab17a458efcd19$export$611c894df53833b0);
    }, [
        cache,
        itemCount
    ]);
    const transform = (0, $bSJIT.useCallback)((item)=>({
            title: item.content,
            description: item.tooltipDescription,
            keyshortcut: item.shortcut,
            icon: ()=>$2cab17a458efcd19$var$getSvgIconForItem({
                    name: item.value.name
                }) || item.elemBefore,
            /**
     * @note This transformed items action is only used when a quick insert item has been
     * called from the quick insert menu and a search has not been performed.
     */ action: ()=>onInsert({
                    item: item
                }),
            // "insertInsertMenuItem" expects these 2 properties.
            onClick: item.onClick,
            value: item.value
        }), [
        onInsert
    ]);
    const quickInsertDropdownItems = dropdownItems.map(transform);
    const onInsertItem = (0, $bSJIT.useCallback)((item)=>{
        var _pluginInjectionApi$q;
        toggleVisiblity();
        if (!editorView.hasFocus()) editorView.focus();
        pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$q = pluginInjectionApi.quickInsert) === null || _pluginInjectionApi$q === void 0 || _pluginInjectionApi$q.actions.insertItem(item, (0, $g6Qq4.INPUT_METHOD).TOOLBAR)(editorView.state, editorView.dispatch);
    }, [
        editorView,
        toggleVisiblity,
        pluginInjectionApi
    ]);
    const { connectivityMode: connectivityMode } = (0, $5beht.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'connectivity'
    ], $2cab17a458efcd19$var$selector);
    const getItems = (0, $bSJIT.useCallback)((query, category)=>{
        let result;
        /**
     * @warning The results if there is a query are not the same as the results if there is no query.
     * For example: If you have a typed panel and then select the panel item then it will call a different action
     * than is specified on the editor plugins quick insert
     * @see above transform function for more details.
     */ if (query) {
            var _pluginInjectionApi$q2;
            result = (pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$q2 = pluginInjectionApi.quickInsert) === null || _pluginInjectionApi$q2 === void 0 || (_pluginInjectionApi$q2 = _pluginInjectionApi$q2.actions.getSuggestions({
                query: query,
                category: category
            })) === null || _pluginInjectionApi$q2 === void 0 ? void 0 : _pluginInjectionApi$q2.map((item)=>(0, $hVGJk.isOfflineMode)(connectivityMode) && item.isDisabledOffline ? {
                    ...item,
                    isDisabled: true
                } : item)) ?? [];
        } else {
            var _pluginInjectionApi$q3;
            const featuredQuickInsertSuggestions = (pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$q3 = pluginInjectionApi.quickInsert) === null || _pluginInjectionApi$q3 === void 0 || (_pluginInjectionApi$q3 = _pluginInjectionApi$q3.actions.getSuggestions({
                category: category,
                featuredItems: true
            })) === null || _pluginInjectionApi$q3 === void 0 ? void 0 : _pluginInjectionApi$q3.map((item)=>(0, $hVGJk.isOfflineMode)(connectivityMode) && item.isDisabledOffline ? {
                    ...item,
                    isDisabled: true
                } : item)) ?? [];
            const unfilteredResult = quickInsertDropdownItems.concat(featuredQuickInsertSuggestions);
            // need to sort on the concatenated list so desired elements are at the top
            result = $2cab17a458efcd19$export$bc386af06edc2d75(unfilteredResult);
        }
        setItemCount(result.length);
        return result;
    }, [
        pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$q4 = pluginInjectionApi.quickInsert) === null || _pluginInjectionApi$q4 === void 0 ? void 0 : _pluginInjectionApi$q4.actions,
        quickInsertDropdownItems,
        connectivityMode
    ]);
    const emptyStateHandler = pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$q5 = pluginInjectionApi.quickInsert) === null || _pluginInjectionApi$q5 === void 0 || (_pluginInjectionApi$q5 = _pluginInjectionApi$q5.sharedState.currentState()) === null || _pluginInjectionApi$q5 === void 0 ? void 0 : _pluginInjectionApi$q5.emptyStateHandler;
    const onViewMore = (0, $bSJIT.useCallback)(()=>{
        var _pluginInjectionApi$c, _pluginInjectionApi$q6;
        toggleVisiblity();
        pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$c = pluginInjectionApi.core) === null || _pluginInjectionApi$c === void 0 || _pluginInjectionApi$c.actions.execute(pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$q6 = pluginInjectionApi.quickInsert) === null || _pluginInjectionApi$q6 === void 0 ? void 0 : _pluginInjectionApi$q6.commands.openElementBrowserModal);
    }, [
        pluginInjectionApi,
        toggleVisiblity
    ]);
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        css: $2cab17a458efcd19$var$insertMenuWrapper(height)
    }, /*#__PURE__*/ (0, $9dQre.jsx)($2cab17a458efcd19$var$ElementBrowserWrapper, {
        handleClickOutside: toggleVisiblity,
        handleEscapeKeydown: toggleVisiblity,
        closeOnTab: false
    }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $disn5.default), {
        mode: "inline",
        getItems: getItems,
        emptyStateHandler: emptyStateHandler,
        onInsertItem: onInsertItem,
        showSearch: true,
        showCategories: false,
        // On page resize we want the InlineElementBrowser to show updated tools/overflow items
        key: quickInsertDropdownItems.length,
        onViewMore: showElementBrowserLink ? onViewMore : undefined,
        cache: cache
    }))));
};
const $2cab17a458efcd19$var$getSvgIconForItem = ({ name: name })=>{
    const Icon = {
        codeblock: (0, $5BUNL.IconCode),
        panel: (0, $5BUNL.IconPanel),
        blockquote: (0, $5BUNL.IconQuote),
        decision: (0, $5BUNL.IconDecision),
        horizontalrule: (0, $5BUNL.IconDivider),
        expand: (0, $5BUNL.IconExpand),
        date: (0, $5BUNL.IconDate),
        status: (0, $5BUNL.IconStatus)
    }[name];
    return Icon ? /*#__PURE__*/ (0, $9dQre.jsx)(Icon, {
        label: ""
    }) : undefined;
};
const $2cab17a458efcd19$var$insertMenuWrapper = (height)=>{
    return /*#__PURE__*/ (0, $9dQre.css)({
        display: 'flex',
        flexDirection: 'column',
        width: '320px',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        height: `${height}px`,
        backgroundColor: `${"var(--ds-surface-overlay, #FFFFFF)"}`,
        borderRadius: "var(--ds-radius-small, 3px)",
        boxShadow: `${"var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)"}`
    });
};
const $2cab17a458efcd19$var$flexWrapperStyles = {
    name: "1wlc510",
    styles: "display:flex;flex:1;box-sizing:border-box;overflow:hidden"
};
const $2cab17a458efcd19$var$FlexWrapper = (props)=>{
    const setOutsideClickTargetRef = (0, $bSJIT.useContext)((0, $3Aq92.OutsideClickTargetRefContext));
    const { children: children, ...divProps } = props;
    return(// Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        ref: setOutsideClickTargetRef,
        css: $2cab17a458efcd19$var$flexWrapperStyles,
        ...divProps
    }, children));
};
const $2cab17a458efcd19$var$ElementBrowserWrapper = (0, $cf2n1.default)($2cab17a458efcd19$var$FlexWrapper);
var $2cab17a458efcd19$export$2e2bcd8739ae039 = $2cab17a458efcd19$var$InsertMenu;

});

parcelRegister("4PIw5", function(module, exports) {
$parcel$export(module.exports, "LINK_BUTTON_KEY", () => $75bdeaf4fa715bb7$export$7223d1a8f66d53b6);
$parcel$export(module.exports, "filterDropdownItemsByBreakpoint", () => $75bdeaf4fa715bb7$export$ebd3ed34e316bf9f);
const $75bdeaf4fa715bb7$var$ITEM_TO_BUTTON_MAP = {
    action: 'taskList',
    media: 'media',
    'image upload': 'media',
    mention: 'mention',
    emoji: 'emoji',
    table: 'table',
    layout: 'layout',
    codeblock: 'codeBlock'
};
const $75bdeaf4fa715bb7$export$7223d1a8f66d53b6 = 'link';
const $75bdeaf4fa715bb7$var$BREAKPOINT_ORDER = [
    'sm',
    'md',
    'lg',
    'xl'
];
/**
 * Determines if a toolbar button is visible at the current breakpoint.
 */ function $75bdeaf4fa715bb7$var$isButtonVisibleAtBreakpoint(buttonShowAt, currentBreakpoint) {
    if (!currentBreakpoint) return false;
    const showAtIndex = $75bdeaf4fa715bb7$var$BREAKPOINT_ORDER.indexOf(buttonShowAt);
    const currentIndex = $75bdeaf4fa715bb7$var$BREAKPOINT_ORDER.indexOf(currentBreakpoint);
    return currentIndex >= showAtIndex;
}
function $75bdeaf4fa715bb7$export$ebd3ed34e316bf9f(items, currentBreakpoint, toolbarConfig) {
    return items.filter((item)=>{
        const itemName = item.value.name;
        // filter out link button because it's always visible on the toolbar
        if (itemName === $75bdeaf4fa715bb7$export$7223d1a8f66d53b6) return false;
        const buttonKey = $75bdeaf4fa715bb7$var$ITEM_TO_BUTTON_MAP[itemName];
        if (!buttonKey) return true;
        const buttonConfig = toolbarConfig[buttonKey];
        if (!(buttonConfig !== null && buttonConfig !== void 0 && buttonConfig.enabled)) return true;
        const showAt = buttonConfig.showAt || 'lg';
        const isVisible = $75bdeaf4fa715bb7$var$isButtonVisibleAtBreakpoint(showAt, currentBreakpoint);
        return !isVisible;
    });
}

});

parcelRegister("d2cRm", function(module, exports) {
$parcel$export(module.exports, "useInsertButtonState", () => $90f8ce003e3ddf0e$export$94599bdafcdd887b);

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $hVGJk = parcelRequire("hVGJk");

var $2pWL6 = parcelRequire("2pWL6");

var $4QSvT = parcelRequire("4QSvT");

var $4PIw5 = parcelRequire("4PIw5");
const $90f8ce003e3ddf0e$export$94599bdafcdd887b = ({ api: api, breakpoint: breakpoint, editorView: editorView, horizontalRuleEnabled: horizontalRuleEnabled, insertMenuItems: insertMenuItems, itemFilter: itemFilter, nativeStatusSupported: nativeStatusSupported, numberOfButtons: numberOfButtons, tableSelectorSupported: tableSelectorSupported, expandEnabled: expandEnabled, showElementBrowserLink: showElementBrowserLink, toolbarConfig: toolbarConfig })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const isTypeAheadAllowed = (0, $2pWL6.useSharedPluginStateSelector)(api, 'typeAhead.isAllowed');
    const imageUploadEnabled = (0, $2pWL6.useSharedPluginStateSelector)(api, 'imageUpload.enabled');
    const mentionsSupported = !!(0, $2pWL6.useSharedPluginStateSelector)(api, 'mention.mentionProvider');
    const canInsertMention = (0, $2pWL6.useSharedPluginStateSelector)(api, 'mention.canInsertMention');
    const dateEnabled = (0, $2pWL6.useSharedPluginStateSelector)(api, 'date.isInitialised');
    const placeholderTextEnabled = (0, $2pWL6.useSharedPluginStateSelector)(api, 'placeholderText.allowInserting');
    const mediaAllowsUploads = (0, $2pWL6.useSharedPluginStateSelector)(api, 'media.allowsUploads');
    const canInsertLink = (0, $2pWL6.useSharedPluginStateSelector)(api, 'hyperlink.canInsertLink');
    const activeLinkMark = (0, $2pWL6.useSharedPluginStateSelector)(api, 'hyperlink.activeLinkMark');
    const connectivityMode = (0, $2pWL6.useSharedPluginStateSelector)(api, 'connectivity.mode');
    const emojiProvider = (0, $2pWL6.useSharedPluginStateSelector)(api, 'emoji.emojiProvider');
    const availableWrapperBlockTypes = (0, $2pWL6.useSharedPluginStateSelector)(api, 'blockType.availableWrapperBlockTypes');
    // Computed values
    const mediaUploadsEnabled = mediaAllowsUploads;
    const mediaSupported = mediaAllowsUploads !== undefined;
    const isEditorOffline = (0, $hVGJk.isOfflineMode)(connectivityMode);
    const imageUploadSupported = !!(api !== null && api !== void 0 && api.imageUpload);
    const mentionsDisabled = !canInsertMention;
    const linkSupported = canInsertLink !== undefined;
    const linkDisabled = !canInsertLink || !!activeLinkMark;
    const emojiDisabled = !emojiProvider;
    const actionSupported = !!(editorView !== null && editorView !== void 0 && editorView.state.schema.nodes.taskItem);
    const decisionSupported = !!(editorView !== null && editorView !== void 0 && editorView.state.schema.nodes.decisionItem);
    const layoutSectionEnabled = !!(api !== null && api !== void 0 && api.layout);
    const [, allDropdownItems] = editorView !== null && editorView !== void 0 && editorView.state.schema ? (0, $4QSvT.createItems)({
        isTypeAheadAllowed: isTypeAheadAllowed,
        tableSupported: !!(editorView !== null && editorView !== void 0 && editorView.state.schema.nodes.table),
        tableSelectorSupported: tableSelectorSupported,
        mediaUploadsEnabled: mediaUploadsEnabled,
        mediaSupported: mediaSupported,
        isEditorOffline: isEditorOffline,
        imageUploadSupported: imageUploadSupported,
        imageUploadEnabled: imageUploadEnabled,
        mentionsSupported: mentionsSupported,
        mentionsDisabled: mentionsDisabled,
        actionSupported: actionSupported,
        decisionSupported: decisionSupported,
        linkSupported: linkSupported,
        linkDisabled: linkDisabled,
        emojiDisabled: emojiDisabled,
        hasEmojiPlugin: !!(api !== null && api !== void 0 && api.emoji),
        hasMentionsPlugin: !!(api !== null && api !== void 0 && api.mention),
        hasMediaPlugin: !!(api !== null && api !== void 0 && api.media),
        nativeStatusSupported: nativeStatusSupported,
        dateEnabled: dateEnabled,
        placeholderTextEnabled: placeholderTextEnabled,
        horizontalRuleEnabled: horizontalRuleEnabled,
        layoutSectionEnabled: layoutSectionEnabled,
        expandEnabled: expandEnabled,
        showElementBrowserLink: showElementBrowserLink,
        emojiProvider: emojiProvider,
        availableWrapperBlockTypes: availableWrapperBlockTypes,
        insertMenuItems: insertMenuItems,
        itemFilter: itemFilter,
        schema: editorView === null || editorView === void 0 ? void 0 : editorView.state.schema,
        numberOfButtons: numberOfButtons || 0,
        formatMessage: formatMessage
    }) : [
        ,
        []
    ];
    const dropdownItems = (0, $bSJIT.useMemo)(()=>{
        if (!breakpoint || !toolbarConfig) return allDropdownItems;
        return (0, $4PIw5.filterDropdownItemsByBreakpoint)(allDropdownItems, breakpoint, toolbarConfig);
    }, [
        allDropdownItems,
        breakpoint,
        toolbarConfig
    ]);
    return {
        dropdownItems: dropdownItems,
        emojiProvider: emojiProvider,
        isTypeAheadAllowed: isTypeAheadAllowed
    };
};

});
parcelRegister("4QSvT", function(module, exports) {
$parcel$export(module.exports, "createItems", () => $34a428f8970b579e$export$af56db357559c888);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $8XNPf = parcelRequire("8XNPf");

var $57l7A = parcelRequire("57l7A");

var $cv8id = parcelRequire("cv8id");

var $8iYGb = parcelRequire("8iYGb");

var $cW1gB = parcelRequire("cW1gB");

var $feCrQ = parcelRequire("feCrQ");

var $aok4n = parcelRequire("aok4n");
const $34a428f8970b579e$var$buttonToItem = (0, (/*@__PURE__*/$parcel$interopDefault($8XNPf)))((button)=>({
        ...button,
        title: /*#__PURE__*/ (0, $dc70d.jsx)((0, $cv8id.ToolTipContent), {
            description: button.content,
            shortcutOverride: button.shortcut
        })
    }));
const $34a428f8970b579e$var$buttonToDropdownItem = (0, $57l7A.default)((title)=>(0, (/*@__PURE__*/$parcel$interopDefault($8XNPf)))((button)=>({
            ...button,
            title: /*#__PURE__*/ (0, $dc70d.jsx)((0, $cv8id.ToolTipContent), {
                description: title,
                shortcutOverride: "/"
            })
        })));
const $34a428f8970b579e$var$createInsertBlockItems = (config)=>{
    const { isTypeAheadAllowed: isTypeAheadAllowed, tableSupported: tableSupported, tableSelectorSupported: tableSelectorSupported, mediaUploadsEnabled: mediaUploadsEnabled, mediaSupported: mediaSupported, imageUploadSupported: imageUploadSupported, imageUploadEnabled: imageUploadEnabled, mentionsSupported: mentionsSupported, mentionsDisabled: mentionsDisabled, availableWrapperBlockTypes: availableWrapperBlockTypes, actionSupported: actionSupported, decisionSupported: decisionSupported, linkSupported: linkSupported, linkDisabled: linkDisabled, emojiDisabled: emojiDisabled, emojiProvider: emojiProvider, hasEmojiPlugin: hasEmojiPlugin, hasMentionsPlugin: hasMentionsPlugin, hasMediaPlugin: hasMediaPlugin, nativeStatusSupported: nativeStatusSupported, insertMenuItems: insertMenuItems, dateEnabled: dateEnabled, placeholderTextEnabled: placeholderTextEnabled, horizontalRuleEnabled: horizontalRuleEnabled, layoutSectionEnabled: layoutSectionEnabled, expandEnabled: expandEnabled, numberOfButtons: numberOfButtons, schema: schema, formatMessage: formatMessage, isEditorOffline: isEditorOffline, itemFilter: itemFilter } = config;
    const items = [];
    const isOffline = isEditorOffline === true;
    if (actionSupported) items.push((0, $feCrQ.action)({
        content: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).action),
        tooltipDescription: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).actionDescription),
        disabled: false
    }));
    if (linkSupported) items.push((0, $feCrQ.link)({
        content: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).link),
        tooltipDescription: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).linkDescription),
        disabled: !!linkDisabled,
        'aria-haspopup': 'dialog'
    }));
    if (imageUploadSupported) items.push((0, $feCrQ.imageUpload)({
        content: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).image),
        disabled: !imageUploadEnabled || isOffline
    }));
    else if (hasMediaPlugin) items.push((0, $feCrQ.media)({
        content: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).addMediaFiles),
        tooltipDescription: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).mediaFilesDescription),
        disabled: isOffline || !mediaSupported || !mediaUploadsEnabled
    }));
    if (hasMentionsPlugin) items.push((0, $feCrQ.mention)({
        content: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).mention),
        tooltipDescription: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).mentionDescription),
        disabled: !isTypeAheadAllowed || !!mentionsDisabled || !mentionsSupported,
        'aria-haspopup': 'listbox'
    }));
    if (hasEmojiPlugin) items.push((0, $feCrQ.emoji)({
        content: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).emoji),
        tooltipDescription: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).emojiDescription),
        disabled: emojiDisabled || !isTypeAheadAllowed || !emojiProvider,
        'aria-haspopup': 'dialog'
    }));
    if (tableSupported) items.push((0, $feCrQ.table)({
        content: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).table),
        tooltipDescription: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).tableDescription),
        disabled: false
    }));
    if (tableSupported && tableSelectorSupported) items.push((0, $feCrQ.tableSelector)({
        content: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).tableSelector),
        tooltipDescription: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).tableSelectorDescription),
        disabled: false
    }));
    if (layoutSectionEnabled) {
        const labelColumns = formatMessage((0, $cW1gB.toolbarInsertBlockMessages).columns);
        items.push((0, $feCrQ.layout)({
            content: labelColumns,
            tooltipDescription: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).columnsDescription),
            disabled: false
        }));
    }
    const blockTypes = availableWrapperBlockTypes || [];
    const codeblockData = blockTypes.find((type)=>type.name === 'codeblock');
    const panelData = blockTypes.find((type)=>type.name === 'panel');
    const blockquoteData = blockTypes.find((type)=>type.name === 'blockquote');
    if (codeblockData) items.push((0, $feCrQ.codeblock)({
        content: formatMessage(codeblockData.title),
        tooltipDescription: formatMessage((0, $8iYGb.messages).codeblockDescription),
        disabled: false,
        shortcut: '```'
    }));
    if (panelData) items.push((0, $feCrQ.panel)({
        content: formatMessage(panelData.title),
        tooltipDescription: formatMessage((0, $8iYGb.messages).infoPanelDescription),
        disabled: false
    }));
    if (blockquoteData) items.push((0, $feCrQ.blockquote)({
        content: formatMessage(blockquoteData.title),
        tooltipDescription: formatMessage((0, $8iYGb.messages).blockquoteDescription),
        disabled: false,
        shortcut: '>'
    }));
    if (decisionSupported) items.push((0, $feCrQ.decision)({
        content: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).decision),
        tooltipDescription: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).decisionDescription),
        disabled: false
    }));
    if (horizontalRuleEnabled && schema.nodes.rule) items.push((0, $feCrQ.horizontalrule)({
        content: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).horizontalRule),
        tooltipDescription: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).horizontalRuleDescription),
        disabled: false
    }));
    if (expandEnabled && schema.nodes.expand) items.push((0, $feCrQ.expand)({
        content: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).expand),
        tooltipDescription: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).expandDescription),
        disabled: false
    }));
    if (dateEnabled) {
        const labelDate = formatMessage((0, $cW1gB.toolbarInsertBlockMessages).date);
        items.push((0, $feCrQ.date)({
            content: labelDate,
            tooltipDescription: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).dateDescription),
            disabled: false
        }));
    }
    if (placeholderTextEnabled) items.push((0, $feCrQ.placeholder)({
        content: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).placeholderText),
        disabled: false
    }));
    if (nativeStatusSupported) {
        const labelStatus = formatMessage((0, $cW1gB.toolbarInsertBlockMessages).status);
        items.push((0, $feCrQ.status)({
            content: labelStatus,
            tooltipDescription: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).statusDescription),
            disabled: false
        }));
    }
    if (insertMenuItems) items.push(...insertMenuItems);
    // EDITOR-6558: apply consumer-supplied filter (e.g. Markdown Mode allowlist)
    // before computing toolbar button / dropdown splits so item counts are
    // correct downstream.
    const filteredItems = itemFilter ? items.filter(itemFilter) : items;
    let numButtonsAdjusted = numberOfButtons;
    if (filteredItems.slice(0, numButtonsAdjusted).some((item)=>item.value.name === 'table selector')) numButtonsAdjusted++;
    const buttonItems = filteredItems.slice(0, numButtonsAdjusted).map($34a428f8970b579e$var$buttonToItem);
    const remainingItems = filteredItems.slice(numButtonsAdjusted).filter(({ value: { name: name } })=>name !== 'table selector');
    const dropdownItems = remainingItems.map($34a428f8970b579e$var$buttonToDropdownItem(formatMessage((0, $cW1gB.toolbarInsertBlockMessages).insertMenu)));
    return [
        buttonItems,
        dropdownItems
    ];
};
const $34a428f8970b579e$export$af56db357559c888 = (0, $57l7A.default)($34a428f8970b579e$var$createInsertBlockItems, (0, $aok4n.shallowEquals));

});
parcelRegister("feCrQ", function(module, exports) {
$parcel$export(module.exports, "action", () => $172f5d402ac0f75b$export$31eb53bd5b582a97);
$parcel$export(module.exports, "link", () => $172f5d402ac0f75b$export$9c30223ca0a664fb);
$parcel$export(module.exports, "media", () => $172f5d402ac0f75b$export$987d49ffe1b0900f);
$parcel$export(module.exports, "imageUpload", () => $172f5d402ac0f75b$export$d5dd7159835f64ad);
$parcel$export(module.exports, "mention", () => $172f5d402ac0f75b$export$db83999c14438df4);
$parcel$export(module.exports, "emoji", () => $172f5d402ac0f75b$export$a19185d1233fc4b2);
$parcel$export(module.exports, "table", () => $172f5d402ac0f75b$export$9852986a3ec5f6a0);
$parcel$export(module.exports, "tableSelector", () => $172f5d402ac0f75b$export$614b510decb5e0d8);
$parcel$export(module.exports, "layout", () => $172f5d402ac0f75b$export$b3219800bda33a1f);
$parcel$export(module.exports, "codeblock", () => $172f5d402ac0f75b$export$c0626db977961abf);
$parcel$export(module.exports, "panel", () => $172f5d402ac0f75b$export$21f42ab9b6679f44);
$parcel$export(module.exports, "blockquote", () => $172f5d402ac0f75b$export$67dc04e652a298ca);
$parcel$export(module.exports, "decision", () => $172f5d402ac0f75b$export$29bcf506ab92b297);
$parcel$export(module.exports, "horizontalrule", () => $172f5d402ac0f75b$export$f7cc6d560fcfab9b);
$parcel$export(module.exports, "expand", () => $172f5d402ac0f75b$export$9f77e0932fb78f72);
$parcel$export(module.exports, "date", () => $172f5d402ac0f75b$export$324d90190a8b822a);
$parcel$export(module.exports, "placeholder", () => $172f5d402ac0f75b$export$c7187bbd1a7a9244);
$parcel$export(module.exports, "status", () => $172f5d402ac0f75b$export$471f7ae5c4103ae1);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $57l7A = parcelRequire("57l7A");

var $cv8id = parcelRequire("cv8id");

var $hqEKl = parcelRequire("hqEKl");

var $lwPmJ = parcelRequire("lwPmJ");

var $kXH8r = parcelRequire("kXH8r");

var $imwtU = parcelRequire("imwtU");

var $lPSjO = parcelRequire("lPSjO");

var $4GWyU = parcelRequire("4GWyU");

var $l9Ysx = parcelRequire("l9Ysx");

var $92iMp = parcelRequire("92iMp");

var $9YTEJ = parcelRequire("9YTEJ");

var $jFqMV = parcelRequire("jFqMV");

var $g6NyP = parcelRequire("g6NyP");

var $9ej3u = parcelRequire("9ej3u");

var $gRfjb = parcelRequire("gRfjb");

var $73atK = parcelRequire("73atK");

var $g3Ytr = parcelRequire("g3Ytr");

var $jHVBL = parcelRequire("jHVBL");

var $68E0O = parcelRequire("68E0O");

var $4ujxi = parcelRequire("4ujxi");

var $aok4n = parcelRequire("aok4n");
const $172f5d402ac0f75b$var$from = (init)=>({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        value: {
            name: init.name
        },
        elemBefore: /*#__PURE__*/ (0, $9dQre.jsx)(init.Icon, {
            label: "",
            color: "currentColor",
            spacing: "spacious"
        }),
        elemAfter: init.shortcut ? // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $9dQre.jsx)("div", {
            css: (0, $hqEKl.shortcutStyle)
        }, init.shortcut) : undefined,
        'aria-label': init.shortcut ? init.content + ' ' + init.shortcut : init.content,
        'aria-haspopup': init['aria-haspopup'],
        'aria-keyshortcuts': init['aria-keyshortcuts'],
        shortcut: init.shortcut,
        isDisabled: init.disabled
    });
const $172f5d402ac0f75b$var$mem = (fn)=>(0, $57l7A.default)(fn, (0, $aok4n.shallowEquals));
const $172f5d402ac0f75b$export$31eb53bd5b582a97 = $172f5d402ac0f75b$var$mem((init)=>{
    return $172f5d402ac0f75b$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'action',
        shortcut: '[]',
        Icon: ()=>/*#__PURE__*/ (0, $9dQre.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4ujxi))), {
                label: "",
                color: "currentColor",
                spacing: "spacious"
            }),
        'aria-keyshortcuts': '[ ] Space'
    });
});
const $172f5d402ac0f75b$export$9c30223ca0a664fb = $172f5d402ac0f75b$var$mem((init)=>$172f5d402ac0f75b$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'link',
        shortcut: (0, $cv8id.tooltip)((0, $cv8id.addLink)),
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($gRfjb))),
        'aria-haspopup': init['aria-haspopup'],
        'aria-keyshortcuts': (0, $cv8id.getAriaKeyshortcuts)((0, $cv8id.addLink))
    }));
const $172f5d402ac0f75b$export$987d49ffe1b0900f = $172f5d402ac0f75b$var$mem((init)=>$172f5d402ac0f75b$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'media',
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($g6NyP)))
    }));
const $172f5d402ac0f75b$export$d5dd7159835f64ad = $172f5d402ac0f75b$var$mem((init)=>$172f5d402ac0f75b$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'image upload',
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($g6NyP)))
    }));
const $172f5d402ac0f75b$export$db83999c14438df4 = $172f5d402ac0f75b$var$mem((init)=>$172f5d402ac0f75b$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'mention',
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($73atK))),
        shortcut: '@',
        'aria-haspopup': init['aria-haspopup'],
        'aria-keyshortcuts': 'Shift+2 Space'
    }));
const $172f5d402ac0f75b$export$a19185d1233fc4b2 = $172f5d402ac0f75b$var$mem((init)=>$172f5d402ac0f75b$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'emoji',
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($9YTEJ))),
        shortcut: ':',
        'aria-haspopup': init['aria-haspopup'],
        'aria-keyshortcuts': 'Shift+;'
    }));
const $172f5d402ac0f75b$export$9852986a3ec5f6a0 = $172f5d402ac0f75b$var$mem((init)=>$172f5d402ac0f75b$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'table',
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($jFqMV))),
        shortcut: (0, $cv8id.tooltip)((0, $cv8id.toggleTable)),
        'aria-keyshortcuts': (0, $cv8id.getAriaKeyshortcuts)((0, $cv8id.toggleTable))
    }));
const $172f5d402ac0f75b$export$614b510decb5e0d8 = $172f5d402ac0f75b$var$mem((init)=>$172f5d402ac0f75b$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'table selector',
        Icon: ()=>/*#__PURE__*/ (0, $9dQre.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4GWyU))), {
                label: "",
                color: "currentColor",
                size: "small"
            })
    }));
const $172f5d402ac0f75b$export$b3219800bda33a1f = $172f5d402ac0f75b$var$mem((init)=>$172f5d402ac0f75b$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'layout',
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($9ej3u)))
    }));
const $172f5d402ac0f75b$export$c0626db977961abf = $172f5d402ac0f75b$var$mem((init)=>$172f5d402ac0f75b$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'codeblock',
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($imwtU))),
        shortcut: init.shortcut,
        'aria-keyshortcuts': (0, $cv8id.getAriaKeyshortcuts)(init.shortcut)
    }));
const $172f5d402ac0f75b$export$21f42ab9b6679f44 = $172f5d402ac0f75b$var$mem((init)=>$172f5d402ac0f75b$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'panel',
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($68E0O))),
        shortcut: init.shortcut,
        'aria-keyshortcuts': (0, $cv8id.getAriaKeyshortcuts)(init.shortcut)
    }));
const $172f5d402ac0f75b$export$67dc04e652a298ca = $172f5d402ac0f75b$var$mem((init)=>$172f5d402ac0f75b$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'blockquote',
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($jHVBL))),
        shortcut: init.shortcut,
        'aria-keyshortcuts': 'Shift+. Space'
    }));
const $172f5d402ac0f75b$export$29bcf506ab92b297 = $172f5d402ac0f75b$var$mem((init)=>$172f5d402ac0f75b$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'decision',
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($92iMp))),
        shortcut: '<>',
        'aria-keyshortcuts': 'Shift+, Shift+. Space'
    }));
const $172f5d402ac0f75b$export$f7cc6d560fcfab9b = $172f5d402ac0f75b$var$mem((init)=>$172f5d402ac0f75b$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'horizontalrule',
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($g3Ytr))),
        shortcut: '---',
        'aria-keyshortcuts': '- - -'
    }));
const $172f5d402ac0f75b$export$9f77e0932fb78f72 = $172f5d402ac0f75b$var$mem((init)=>$172f5d402ac0f75b$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'expand',
        Icon: (iconProps)=>/*#__PURE__*/ (0, $9dQre.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($l9Ysx))), {
                label: iconProps.label,
                size: "small"
            })
    }));
const $172f5d402ac0f75b$export$324d90190a8b822a = $172f5d402ac0f75b$var$mem((init)=>$172f5d402ac0f75b$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'date',
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($lPSjO))),
        shortcut: '//',
        'aria-keyshortcuts': '/ / Enter'
    }));
const $172f5d402ac0f75b$export$c7187bbd1a7a9244 = $172f5d402ac0f75b$var$mem((init)=>$172f5d402ac0f75b$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'placeholder text',
        Icon: ()=>/*#__PURE__*/ (0, $9dQre.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lwPmJ))), {
                label: "",
                spacing: "spacious",
                color: "currentColor"
            })
    }));
const $172f5d402ac0f75b$export$471f7ae5c4103ae1 = $172f5d402ac0f75b$var$mem((init)=>$172f5d402ac0f75b$var$from({
        content: init.content,
        tooltipDescription: init.tooltipDescription,
        disabled: init.disabled,
        name: 'status',
        Icon: ()=>/*#__PURE__*/ (0, $9dQre.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kXH8r))), {
                label: "",
                color: "currentColor",
                spacing: "spacious"
            })
    }));

});
parcelRegister("hqEKl", function(module, exports) {
$parcel$export(module.exports, "shortcutStyle", () => $7dbe80262455a54d$export$297e5814a2c821bb);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9dQre = parcelRequire("9dQre");

var $5bbjm = parcelRequire("5bbjm");
const $7dbe80262455a54d$export$297e5814a2c821bb = /*#__PURE__*/ (0, $9dQre.css)("background-color:var(--ds-background-neutral, #0515240F);color:var(--ds-text-subtle, #505258);border-radius:var(--ds-radius-small, 3px);padding:var(--ds-space-050, 4px);line-height:12px;font-size:", (0, $5bbjm.relativeFontSizeToBase16)(11.67), ";align-self:flex-end;@media (max-width: ", (0, $5bbjm.akEditorMobileMaxWidth), "px){display:none;}");

});

parcelRegister("lwPmJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::32f92d4b4659c87427bca36d4cc14c22>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $040b6d222aab5356$var$_react = $040b6d222aab5356$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $040b6d222aab5356$var$_iconNew = $040b6d222aab5356$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $040b6d222aab5356$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FieldText".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/field-text
 * Usage guidance:
 * Multi purpose
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $040b6d222aab5356$var$FieldTextIcon = (props)=>/*#__PURE__*/ $040b6d222aab5356$var$_react.default.createElement($040b6d222aab5356$var$_iconNew.default, Object.assign({
        name: "FieldTextIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.75 2.5H8V1h5v1.5h-1.75v2H14a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-2.75v2H13V15H8v-1.5h1.75zm1.5 7.5H14a.5.5 0 0 0 .5-.5v-3A.5.5 0 0 0 14 6h-2.75zM2 6a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h6v1.5H2a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h6V6z" clip-rule="evenodd"/>`
    }, props));
$040b6d222aab5356$var$FieldTextIcon.displayName = 'FieldTextIcon';
var $040b6d222aab5356$var$_default = module.exports.default = $040b6d222aab5356$var$FieldTextIcon;

});

parcelRegister("kXH8r", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4275b74b17e4c9dfbe277c5314677c8b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f42ac71a666c71bd$var$_react = $f42ac71a666c71bd$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $f42ac71a666c71bd$var$_iconNew = $f42ac71a666c71bd$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $f42ac71a666c71bd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Lozenge".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/lozenge
 * Usage guidance:
 * Reserved for inserting status lozenges in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f42ac71a666c71bd$var$LozengeIcon = (props)=>/*#__PURE__*/ $f42ac71a666c71bd$var$_react.default.createElement($f42ac71a666c71bd$var$_iconNew.default, Object.assign({
        name: "LozengeIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v4a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V6a.5.5 0 0 0-.5-.5zm11 3.25H3v-1.5h10z" clip-rule="evenodd"/>`
    }, props));
$f42ac71a666c71bd$var$LozengeIcon.displayName = 'LozengeIcon';
var $f42ac71a666c71bd$var$_default = module.exports.default = $f42ac71a666c71bd$var$LozengeIcon;

});

parcelRegister("aok4n", function(module, exports) {
$parcel$export(module.exports, "shallowEquals", () => $3ac7f60705607c41$export$fa1c2bbf4100b8bc);
const $3ac7f60705607c41$export$fa1c2bbf4100b8bc = ([aRaw], [bRaw])=>{
    const a = aRaw;
    const b = bRaw;
    return !Object.keys(a).some((key)=>{
        const k = key;
        return a[k] !== b[k];
    });
};

});




parcelRegister("7bOJz", function(module, exports) {
$parcel$export(module.exports, "useTableSelectorPopup", () => $c235a240b42e641a$export$db7bd02db6cb687e);

var $bSJIT = parcelRequire("bSJIT");

var $g6Qq4 = parcelRequire("g6Qq4");

var $6SgET = parcelRequire("6SgET");
const $c235a240b42e641a$export$db7bd02db6cb687e = ({ api: api, buttonRef: buttonRef })=>{
    const popupManager = (0, $6SgET.usePopupManager)({
        focusTarget: buttonRef
    });
    const handleSelectedTableSize = (0, $bSJIT.useCallback)((rowsCount, colsCount)=>{
        // workaround to solve race condition where cursor is not placed correctly inside table
        queueMicrotask(()=>{
            var _api$core, _api$table;
            api === null || api === void 0 || (_api$core = api.core) === null || _api$core === void 0 || _api$core.actions.execute(api === null || api === void 0 || (_api$table = api.table) === null || _api$table === void 0 ? void 0 : _api$table.commands.insertTableWithSize(rowsCount, colsCount, (0, $g6Qq4.INPUT_METHOD).PICKER));
        });
        popupManager.close();
    }, [
        api,
        popupManager
    ]);
    const onPopupUnmount = (0, $bSJIT.useCallback)(()=>{
        api === null || api === void 0 || api.core.actions.focus();
    }, [
        api
    ]);
    return {
        ...popupManager,
        handleSelectedTableSize: handleSelectedTableSize,
        onPopupUnmount: onPopupUnmount
    };
};

});


parcelRegister("jdyej", function(module, exports) {
$parcel$export(module.exports, "LayoutButton", () => $8ff1623eef9e7174$export$b5a1df4e06cdc467);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $g6Qq4 = parcelRequire("g6Qq4");

var $cW1gB = parcelRequire("cW1gB");

var $28qc1 = parcelRequire("28qc1");

var $4rzOL = parcelRequire("4rzOL");

var $9ej3u = parcelRequire("9ej3u");

var $7cgYb = parcelRequire("7cgYb");

var $eHnl8 = parcelRequire("eHnl8");
const $8ff1623eef9e7174$export$b5a1df4e06cdc467 = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const { editorView: editorView } = (0, $28qc1.useEditorToolbar)();
    if (!(api !== null && api !== void 0 && api.layout)) return null;
    const onClick = ()=>{
        if (editorView) {
            var _api$layout;
            const { state: state, dispatch: dispatch } = editorView;
            api === null || api === void 0 || (_api$layout = api.layout) === null || _api$layout === void 0 || _api$layout.actions.insertLayoutColumns((0, $g6Qq4.INPUT_METHOD).TOOLBAR)(state, dispatch);
        }
    };
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $eHnl8.ToolbarTooltip), {
        content: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).columns),
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $7cgYb.ToolbarButton), {
            iconBefore: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9ej3u))), {
                label: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).columns),
                size: "small"
            }),
            onClick: onClick,
            testId: (0, $4rzOL.TOOLBAR_BUTTON_TEST_ID).LAYOUT
        })
    });
};

});

parcelRegister("iXlu8", function(module, exports) {
$parcel$export(module.exports, "MediaButton", () => $8d66b23cb82af249$export$38a6b9ce8791e252);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $g6Qq4 = parcelRequire("g6Qq4");

var $hVGJk = parcelRequire("hVGJk");

var $cW1gB = parcelRequire("cW1gB");

var $4rzOL = parcelRequire("4rzOL");

var $5beht = parcelRequire("5beht");

var $g6NyP = parcelRequire("g6NyP");

var $7cgYb = parcelRequire("7cgYb");

var $eHnl8 = parcelRequire("eHnl8");

var $aBdvW = parcelRequire("aBdvW");

var $3y2s4 = parcelRequire("3y2s4");
const $8d66b23cb82af249$export$38a6b9ce8791e252 = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const { popupsMountPoint: popupsMountPoint } = (0, $aBdvW.useToolbarUI)();
    const { showMediaPicker: showMediaPicker, connectivityMode: connectivityMode, allowsUploads: allowsUploads, isUploadPending: isUploadPending } = (0, $5beht.useSharedPluginStateWithSelector)(api, [
        'media',
        'connectivity'
    ], (states)=>{
        var _states$mediaState, _states$mediaState2, _states$connectivityS;
        return {
            showMediaPicker: (_states$mediaState = states.mediaState) === null || _states$mediaState === void 0 ? void 0 : _states$mediaState.showMediaPicker,
            allowsUploads: (_states$mediaState2 = states.mediaState) === null || _states$mediaState2 === void 0 ? void 0 : _states$mediaState2.allowsUploads,
            isUploadPending: !states.mediaState || states.mediaState.uploadStatus === 'pending',
            connectivityMode: (_states$connectivityS = states.connectivityState) === null || _states$connectivityS === void 0 ? void 0 : _states$connectivityS.mode
        };
    });
    const mediaButtonRef = (0, $bSJIT.useRef)(null);
    if (!(api !== null && api !== void 0 && api.media)) return null;
    const onClick = ()=>{
        var _api$mediaInsert, _api$analytics;
        if (!showMediaPicker) return;
        if (api !== null && api !== void 0 && (_api$mediaInsert = api.mediaInsert) !== null && _api$mediaInsert !== void 0 && (_api$mediaInsert = _api$mediaInsert.commands) !== null && _api$mediaInsert !== void 0 && _api$mediaInsert.showMediaInsertPopup) {
            var _api$core, _api$mediaInsert2;
            const ref = mediaButtonRef.current;
            const resolvedMountInfo = ref !== null && ref !== void 0 && ref.parentElement ? {
                ref: ref,
                mountPoint: popupsMountPoint ?? ref.parentElement
            } : undefined;
            api === null || api === void 0 || (_api$core = api.core) === null || _api$core === void 0 || _api$core.actions.execute(api === null || api === void 0 || (_api$mediaInsert2 = api.mediaInsert) === null || _api$mediaInsert2 === void 0 ? void 0 : _api$mediaInsert2.commands.showMediaInsertPopup(resolvedMountInfo));
        } else showMediaPicker();
        api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 || _api$analytics.actions.fireAnalyticsEvent({
            action: (0, $g6Qq4.ACTION).OPENED,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).PICKER,
            actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).PICKER_MEDIA,
            attributes: {
                inputMethod: (0, $g6Qq4.INPUT_METHOD).TOOLBAR
            },
            eventType: (0, $g6Qq4.EVENT_TYPE).UI
        });
    };
    const isOffline = (0, $hVGJk.isOfflineMode)(connectivityMode);
    const isDisabled = isOffline || !(allowsUploads || (0, $3y2s4.isExperimentEnabled)('platform_editor_ssr_toolbar_optimistic') && isUploadPending);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $eHnl8.ToolbarTooltip), {
        content: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).addMediaFiles),
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $7cgYb.ToolbarButton), {
            iconBefore: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g6NyP))), {
                label: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).addMediaFiles),
                size: "small"
            }),
            onClick: onClick,
            ref: mediaButtonRef,
            isDisabled: isDisabled,
            testId: (0, $4rzOL.TOOLBAR_BUTTON_TEST_ID).MEDIA
        })
    });
};

});

parcelRegister("iZa2a", function(module, exports) {
$parcel$export(module.exports, "MentionButton", () => $3d57f122c4fe6ede$export$d16f16312388c7e);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $g6Qq4 = parcelRequire("g6Qq4");

var $cv8id = parcelRequire("cv8id");

var $cW1gB = parcelRequire("cW1gB");

var $4rzOL = parcelRequire("4rzOL");

var $5beht = parcelRequire("5beht");

var $73atK = parcelRequire("73atK");

var $7cgYb = parcelRequire("7cgYb");

var $eHnl8 = parcelRequire("eHnl8");

var $3y2s4 = parcelRequire("3y2s4");
const $3d57f122c4fe6ede$export$d16f16312388c7e = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const { canInsertMention: canInsertMention, mentionProvider: mentionProvider, mentionProviderStatus: mentionProviderStatus, hasMentionState: hasMentionState, isTypeAheadAllowed: isTypeAheadAllowed } = (0, $5beht.useSharedPluginStateWithSelector)(api, [
        'mention',
        'typeAhead'
    ], (states)=>{
        var _states$mentionState, _states$mentionState2, _states$mentionState3, _states$typeAheadStat;
        return {
            canInsertMention: (_states$mentionState = states.mentionState) === null || _states$mentionState === void 0 ? void 0 : _states$mentionState.canInsertMention,
            mentionProvider: (_states$mentionState2 = states.mentionState) === null || _states$mentionState2 === void 0 ? void 0 : _states$mentionState2.mentionProvider,
            mentionProviderStatus: (_states$mentionState3 = states.mentionState) === null || _states$mentionState3 === void 0 ? void 0 : _states$mentionState3.mentionProviderStatus,
            hasMentionState: states.mentionState !== undefined,
            isTypeAheadAllowed: (_states$typeAheadStat = states.typeAheadState) === null || _states$typeAheadStat === void 0 ? void 0 : _states$typeAheadStat.isAllowed
        };
    });
    if (!(api !== null && api !== void 0 && api.mention)) return null;
    const onClick = ()=>{
        var _api$mention;
        api === null || api === void 0 || (_api$mention = api.mention) === null || _api$mention === void 0 || (_api$mention = _api$mention.actions) === null || _api$mention === void 0 || _api$mention.openTypeAhead((0, $g6Qq4.INPUT_METHOD).TOOLBAR);
    };
    // The SSR state cannot resolve providers. Keep pending and available visually identical,
    // while preserving known selection restrictions and settled provider failures.
    const isDisabled = (0, $3y2s4.isExperimentEnabled)('platform_editor_ssr_toolbar_optimistic') ? canInsertMention === false || hasMentionState && isTypeAheadAllowed === false || mentionProviderStatus !== 'pending' && hasMentionState && !mentionProvider : !canInsertMention || !mentionProvider || !isTypeAheadAllowed;
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $eHnl8.ToolbarTooltip), {
        content: /*#__PURE__*/ (0, $dc70d.jsx)((0, $cv8id.ToolTipContent), {
            description: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).mention),
            keymap: (0, $cv8id.insertMention)
        }),
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $7cgYb.ToolbarButton), {
            iconBefore: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($73atK))), {
                label: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).mention),
                size: "small"
            }),
            onClick: onClick,
            ariaKeyshortcuts: "Shift+2 Space",
            isDisabled: isDisabled,
            testId: (0, $4rzOL.TOOLBAR_BUTTON_TEST_ID).MENTION
        })
    });
};

});

parcelRegister("fnO7j", function(module, exports) {
$parcel$export(module.exports, "TableButton", () => $c053be8f99c6beff$export$a5d4a9df719d6bc1);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $g6Qq4 = parcelRequire("g6Qq4");

var $cv8id = parcelRequire("cv8id");

var $cW1gB = parcelRequire("cW1gB");

var $28qc1 = parcelRequire("28qc1");

var $4rzOL = parcelRequire("4rzOL");

var $jFqMV = parcelRequire("jFqMV");

var $7cgYb = parcelRequire("7cgYb");

var $eHnl8 = parcelRequire("eHnl8");
const $c053be8f99c6beff$export$a5d4a9df719d6bc1 = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const { editorView: editorView } = (0, $28qc1.useEditorToolbar)();
    if (!(api !== null && api !== void 0 && api.table)) return null;
    const onClick = ()=>{
        if (editorView) {
            const { state: state, dispatch: dispatch } = editorView;
            // workaround to solve race condition where cursor is not placed correctly inside table
            queueMicrotask(()=>{
                var _api$table, _api$table$actions$in, _api$table$actions;
                api === null || api === void 0 || (_api$table = api.table) === null || _api$table === void 0 || (_api$table$actions$in = (_api$table$actions = _api$table.actions).insertTable) === null || _api$table$actions$in === void 0 || _api$table$actions$in.call(_api$table$actions, {
                    action: (0, $g6Qq4.ACTION).INSERTED,
                    actionSubject: (0, $g6Qq4.ACTION_SUBJECT).DOCUMENT,
                    actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).TABLE,
                    attributes: {
                        inputMethod: (0, $g6Qq4.INPUT_METHOD).TOOLBAR
                    },
                    eventType: (0, $g6Qq4.EVENT_TYPE).TRACK
                })(state, dispatch);
            });
        }
    };
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $eHnl8.ToolbarTooltip), {
        content: /*#__PURE__*/ (0, $dc70d.jsx)((0, $cv8id.ToolTipContent), {
            description: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).table),
            keymap: (0, $cv8id.toggleTable)
        }),
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $7cgYb.ToolbarButton), {
            iconBefore: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jFqMV))), {
                label: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).table),
                size: "small"
            }),
            onClick: onClick,
            ariaKeyshortcuts: (0, $cv8id.getAriaKeyshortcuts)((0, $cv8id.toggleTable)),
            testId: (0, $4rzOL.TOOLBAR_BUTTON_TEST_ID).TABLE
        })
    });
};

});

parcelRegister("gLaFJ", function(module, exports) {
$parcel$export(module.exports, "TableSizePicker", () => $960e9f0fd6970a59$export$5468cf78b7a314d6);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $cW1gB = parcelRequire("cW1gB");

var $4rzOL = parcelRequire("4rzOL");

var $11XBj = parcelRequire("11XBj");

var $7cgYb = parcelRequire("7cgYb");

var $eHnl8 = parcelRequire("eHnl8");

var $aBdvW = parcelRequire("aBdvW");

var $7bOJz = parcelRequire("7bOJz");

var $lSgjl = parcelRequire("lSgjl");
const $960e9f0fd6970a59$export$5468cf78b7a314d6 = ({ api: api, tableSelectorSupported: tableSelectorSupported })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const tableSizePickerRef = (0, $bSJIT.useRef)(null);
    const { popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement } = (0, $aBdvW.useToolbarUI)();
    const tableSelectorPopup = (0, $7bOJz.useTableSelectorPopup)({
        api: api,
        buttonRef: tableSizePickerRef
    });
    if (!(api !== null && api !== void 0 && api.table) || !tableSelectorSupported) return null;
    const onClick = (event)=>{
        if (event.detail === 0) tableSelectorPopup.handleKeyboardOpen(event);
        tableSelectorPopup.toggle();
    };
    return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $dc70d.Fragment), {
        children: [
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $lSgjl.TableSelectorPopupWrapper), {
                isOpen: tableSelectorPopup.isOpen,
                targetRef: tableSizePickerRef,
                isOpenedByKeyboard: tableSelectorPopup.isOpenedByKeyboard,
                onSelection: tableSelectorPopup.handleSelectedTableSize,
                onClickOutside: tableSelectorPopup.handleClickOutside,
                onEscapeKeydown: tableSelectorPopup.handleEscapeKeydown,
                onUnmount: tableSelectorPopup.onPopupUnmount,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $eHnl8.ToolbarTooltip), {
                content: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).tableSelector),
                children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $7cgYb.ToolbarButton), {
                    iconBefore: /*#__PURE__*/ (0, $dc70d.jsx)((0, $11XBj.MoreItemsIcon), {
                        label: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).tableSelector)
                    }),
                    onClick: onClick,
                    isSelected: tableSelectorPopup.isOpen,
                    ref: tableSizePickerRef,
                    testId: (0, $4rzOL.TOOLBAR_BUTTON_TEST_ID).TABLE_SELECTOR
                })
            })
        ]
    });
};

});
parcelRegister("11XBj", function(module, exports) {
$parcel$export(module.exports, "MoreItemsIcon", () => $addc3fcadcb13ded$export$fab3805c25b17109);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $4GWyU = parcelRequire("4GWyU");
const $addc3fcadcb13ded$export$fab3805c25b17109 = ({ label: label, testId: testId, color: color, shouldRecommendSmallIcon: shouldRecommendSmallIcon, spacing: spacing })=>/*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4GWyU))), {
        label: label,
        testId: testId,
        color: color,
        shouldRecommendSmallIcon: shouldRecommendSmallIcon,
        spacing: spacing,
        size: "small"
    });

});

parcelRegister("lSgjl", function(module, exports) {
$parcel$export(module.exports, "TableSelectorPopupWrapper", () => $9efb866071578fe2$export$e82abb3e18a71b34);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $8qEmt = parcelRequire("8qEmt");
const $9efb866071578fe2$export$e82abb3e18a71b34 = ({ isOpen: isOpen, targetRef: targetRef, isOpenedByKeyboard: isOpenedByKeyboard, onSelection: onSelection, onClickOutside: onClickOutside, onEscapeKeydown: onEscapeKeydown, onUnmount: onUnmount, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement })=>{
    if (!isOpen || !targetRef.current) return null;
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $8qEmt.TableSelectorPopup), {
        allowOutsideSelection: true,
        target: targetRef.current,
        onUnmount: onUnmount,
        onSelection: onSelection,
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        handleClickOutside: onClickOutside,
        handleEscapeKeydown: onEscapeKeydown,
        isOpenedByKeyboard: isOpenedByKeyboard
    });
};

});
parcelRegister("8qEmt", function(module, exports) {
$parcel$export(module.exports, "TableSelectorPopup", () => $82f4da85c4c47833$export$4b4bd4d01ec9c7c9);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $bAB3U = parcelRequire("bAB3U");

var $5bbjm = parcelRequire("5bbjm");

var $3y2s4 = parcelRequire("3y2s4");

var $797yE = parcelRequire("797yE");

var $cf2n1 = parcelRequire("cf2n1");

var $5zk80 = parcelRequire("5zk80");

var $87V93 = parcelRequire("87V93");
const $82f4da85c4c47833$var$TABLE_SELECTOR_PADDING_TOP = 8;
const $82f4da85c4c47833$var$POPUP_OFFSET = [
    0,
    3
];
const $82f4da85c4c47833$var$TABLE_SELECTOR_PADDING_SIDE = 10;
const $82f4da85c4c47833$var$DEFAULT_TABLE_SELECTOR_ROWS = 5;
const $82f4da85c4c47833$var$DEFAULT_TABLE_SELECTOR_COLS = 10;
const $82f4da85c4c47833$var$DEFAULT_TABLE_SELECTOR_SELECTION_SIZE = 1;
const $82f4da85c4c47833$var$DEFAULT_MAX_TABLE_SELECTOR_ROWS = 10;
const $82f4da85c4c47833$var$TableSelectorWithListeners = (0, $cf2n1.default)((0, $87V93.default));
const $82f4da85c4c47833$var$initialSizeState = {
    col: $82f4da85c4c47833$var$DEFAULT_TABLE_SELECTOR_SELECTION_SIZE,
    row: $82f4da85c4c47833$var$DEFAULT_TABLE_SELECTOR_SELECTION_SIZE,
    maxCol: $82f4da85c4c47833$var$DEFAULT_TABLE_SELECTOR_COLS,
    maxRow: $82f4da85c4c47833$var$DEFAULT_TABLE_SELECTOR_ROWS
};
const $82f4da85c4c47833$var$tableSelectorPopupWrapperStyles = /*#__PURE__*/ (0, $9dQre.css)({
    borderRadius: "var(--ds-radius-small, 3px)",
    backgroundColor: "var(--ds-surface-overlay, #FFFFFF)",
    boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)",
    padding: `${"var(--ds-space-100, 8px)"} ${$82f4da85c4c47833$var$TABLE_SELECTOR_PADDING_SIDE}px`
});
const $82f4da85c4c47833$export$4b4bd4d01ec9c7c9 = (props)=>{
    const [size, setSize] = (0, $bSJIT.useState)({
        ...$82f4da85c4c47833$var$initialSizeState,
        ...props.defaultSize
    });
    const tablePopupRef = (0, $bSJIT.useRef)(null);
    // If popup opened by keyboard enable keyboard mode
    const isKeyboardMode = (0, $bSJIT.useRef)(props.isOpenedByKeyboard);
    const enableKeyboardMode = (0, $bSJIT.useCallback)(()=>{
        if (!isKeyboardMode.current) isKeyboardMode.current = true;
    }, [
        isKeyboardMode
    ]);
    const disableKeyboardMode = (0, $bSJIT.useCallback)(()=>{
        if (isKeyboardMode.current) isKeyboardMode.current = false;
    }, [
        isKeyboardMode
    ]);
    // Mouse move is used to allow selection changes outside of the popup and is more reactive to changes.
    const handleMouseMove = (0, $bSJIT.useCallback)((e)=>{
        if (!tablePopupRef.current) return;
        disableKeyboardMode();
        const tablePopup = tablePopupRef.current;
        const { left: left, top: top } = tablePopup.getBoundingClientRect();
        // Mouse position on popup
        const selectedWidth = e.clientX - left;
        const selectedHeight = e.clientY - top;
        // Calculate number grid cells selected
        let selectedGridCols = Math.ceil((selectedWidth - $82f4da85c4c47833$var$TABLE_SELECTOR_PADDING_SIDE + (0, $87V93.TABLE_SELECTOR_BUTTON_GAP)) / ((0, $87V93.TABLE_SELECTOR_BUTTON_GAP) + (0, $87V93.TABLE_SELECTOR_BUTTON_SIZE)));
        let selectedGridRows = Math.ceil((selectedHeight - $82f4da85c4c47833$var$TABLE_SELECTOR_PADDING_TOP + (0, $87V93.TABLE_SELECTOR_BUTTON_GAP)) / ((0, $87V93.TABLE_SELECTOR_BUTTON_GAP) + (0, $87V93.TABLE_SELECTOR_BUTTON_SIZE)));
        // Keep the selected rows and columns within the defined bounds
        let gridRows = $82f4da85c4c47833$var$DEFAULT_TABLE_SELECTOR_ROWS;
        if (selectedGridCols < 1) selectedGridCols = 1;
        if (selectedGridCols > size.maxCol) selectedGridCols = size.maxCol;
        if (selectedGridRows < 1) selectedGridRows = 1;
        // Expand grid when row selection is greater than the default grid size
        if (selectedGridRows >= $82f4da85c4c47833$var$DEFAULT_TABLE_SELECTOR_ROWS && selectedGridRows < $82f4da85c4c47833$var$DEFAULT_MAX_TABLE_SELECTOR_ROWS) gridRows = selectedGridRows + 1;
        if (selectedGridRows >= $82f4da85c4c47833$var$DEFAULT_MAX_TABLE_SELECTOR_ROWS) {
            selectedGridRows = $82f4da85c4c47833$var$DEFAULT_MAX_TABLE_SELECTOR_ROWS;
            gridRows = $82f4da85c4c47833$var$DEFAULT_MAX_TABLE_SELECTOR_ROWS;
        }
        if (selectedGridCols !== size.col || selectedGridRows !== size.row) setSize({
            col: selectedGridCols,
            row: selectedGridRows,
            maxCol: $82f4da85c4c47833$var$DEFAULT_TABLE_SELECTOR_COLS,
            maxRow: gridRows
        });
    }, [
        disableKeyboardMode,
        size,
        setSize
    ]);
    const decreasingSequence = (maxNumber, prevNumber)=>{
        let nextNumber = prevNumber - 1;
        if (prevNumber === 1) nextNumber = maxNumber;
        return nextNumber;
    };
    const getMaxRow = (prevSize, eventKey)=>{
        switch(eventKey){
            case 'ArrowDown':
                // Expand the grid size when last row selected
                if (prevSize.maxRow < $82f4da85c4c47833$var$DEFAULT_MAX_TABLE_SELECTOR_ROWS && prevSize.row >= $82f4da85c4c47833$var$DEFAULT_TABLE_SELECTOR_ROWS - 1) return prevSize.maxRow + 1;
                if (prevSize.row === $82f4da85c4c47833$var$DEFAULT_MAX_TABLE_SELECTOR_ROWS) return $82f4da85c4c47833$var$DEFAULT_TABLE_SELECTOR_ROWS;
                return prevSize.maxRow;
            case 'ArrowLeft':
                const moveToPrevRow = prevSize.col === 1 && prevSize.row > 1;
                const moveToLastRow = prevSize.row === 1 && prevSize.col === 1;
                // Expand the popup to max size when selected row wraps around to last row
                if (moveToLastRow) return $82f4da85c4c47833$var$DEFAULT_MAX_TABLE_SELECTOR_ROWS;
                // Decrease the popup when decreased row selection
                if (prevSize.maxRow > $82f4da85c4c47833$var$DEFAULT_TABLE_SELECTOR_ROWS && moveToPrevRow) return prevSize.row;
                return prevSize.maxRow;
            case 'ArrowUp':
                if (prevSize.row === 1) return $82f4da85c4c47833$var$DEFAULT_MAX_TABLE_SELECTOR_ROWS;
                else if (prevSize.maxRow > $82f4da85c4c47833$var$DEFAULT_TABLE_SELECTOR_ROWS) return prevSize.row;
                return prevSize.maxRow;
            case 'ArrowRight':
                const moveToNextRow = prevSize.col === $82f4da85c4c47833$var$DEFAULT_TABLE_SELECTOR_COLS;
                const increaseMaxRow = prevSize.maxRow < $82f4da85c4c47833$var$DEFAULT_MAX_TABLE_SELECTOR_ROWS && moveToNextRow && prevSize.row + 1 === prevSize.maxRow;
                // Decrease popup size for wrap around to selection 1 x 1
                if (prevSize.row === $82f4da85c4c47833$var$DEFAULT_MAX_TABLE_SELECTOR_ROWS && prevSize.col === $82f4da85c4c47833$var$DEFAULT_TABLE_SELECTOR_COLS) return $82f4da85c4c47833$var$DEFAULT_TABLE_SELECTOR_ROWS;
                else if (increaseMaxRow) return prevSize.maxRow + 1;
                return prevSize.maxRow;
            default:
                return prevSize.maxRow;
        }
    };
    const handleInitialButtonFocus = (0, $bSJIT.useCallback)(()=>{
        if (isKeyboardMode.current !== true) {
            enableKeyboardMode();
            setSize($82f4da85c4c47833$var$initialSizeState);
        }
    }, [
        enableKeyboardMode,
        setSize
    ]);
    const handleKeyDown = (0, $bSJIT.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (event)=>{
        if (event.key === 'ArrowDown') {
            enableKeyboardMode();
            setSize((prevSize)=>{
                return {
                    ...prevSize,
                    row: prevSize.row % prevSize.maxRow + 1,
                    maxRow: getMaxRow(prevSize, event.key)
                };
            });
            if ((0, $797yE.editorExperiment)('platform_editor_controls', 'variant1')) event.preventDefault();
        }
        if (event.key === 'ArrowRight') {
            enableKeyboardMode();
            setSize((prevSize)=>{
                const moveToNextRow = prevSize.col === $82f4da85c4c47833$var$DEFAULT_TABLE_SELECTOR_COLS;
                return {
                    ...prevSize,
                    col: prevSize.col % $82f4da85c4c47833$var$DEFAULT_TABLE_SELECTOR_COLS + 1,
                    row: moveToNextRow ? prevSize.row % prevSize.maxRow + 1 : prevSize.row,
                    maxRow: getMaxRow(prevSize, event.key)
                };
            });
        }
        if (event.key === 'ArrowLeft') {
            enableKeyboardMode();
            setSize((prevSize)=>{
                const getRow = (prevRow, prevCol)=>{
                    const row = prevRow;
                    // Move to previous row for wrap around
                    if (prevSize.col === 1 && prevSize.row > 1) return prevRow - 1;
                    else if (prevRow === 1 && prevCol === 1) return $82f4da85c4c47833$var$DEFAULT_MAX_TABLE_SELECTOR_ROWS;
                    return row;
                };
                return {
                    ...prevSize,
                    col: decreasingSequence(prevSize.maxCol, prevSize.col),
                    row: getRow(prevSize.row, prevSize.col),
                    maxRow: getMaxRow(prevSize, event.key)
                };
            });
        }
        if (event.key === 'ArrowUp') {
            enableKeyboardMode();
            setSize((prevSize)=>{
                const moveToLastRow = prevSize.row === 1;
                return {
                    ...prevSize,
                    row: moveToLastRow ? $82f4da85c4c47833$var$DEFAULT_MAX_TABLE_SELECTOR_ROWS : decreasingSequence(prevSize.maxRow, prevSize.row),
                    maxRow: getMaxRow(prevSize, event.key)
                };
            });
            if ((0, $797yE.editorExperiment)('platform_editor_controls', 'variant1')) event.preventDefault();
        }
    }, [
        enableKeyboardMode,
        setSize
    ]);
    (0, $bSJIT.useEffect)(()=>{
        let unbind;
        const target = props.allowOutsideSelection ? window : tablePopupRef.current;
        if (target) unbind = (0, $bAB3U.bind)(target, {
            type: 'mousemove',
            listener: handleMouseMove
        });
        return unbind;
    }, [
        handleMouseMove,
        props.allowOutsideSelection,
        tablePopupRef
    ]);
    const offset = (0, $3y2s4.isExperimentEnabled)('platform_editor_perf_lint_cleanup') ? $82f4da85c4c47833$var$POPUP_OFFSET : [
        0,
        3
    ];
    return /*#__PURE__*/ (0, $9dQre.jsx)((0, $5zk80.default), {
        target: props.target,
        offset: offset,
        mountTo: props.popupsMountPoint,
        boundariesElement: props.popupsBoundariesElement,
        scrollableElement: props.popupsScrollableElement,
        focusTrap: true,
        onUnmount: props.onUnmount,
        zIndex: (0, $5bbjm.akEditorMenuZIndex)
    }, /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        css: $82f4da85c4c47833$var$tableSelectorPopupWrapperStyles,
        ref: tablePopupRef
    }, /*#__PURE__*/ (0, $9dQre.jsx)($82f4da85c4c47833$var$TableSelectorWithListeners, {
        handleClickOutside: props.handleClickOutside,
        handleEscapeKeydown: props.handleEscapeKeydown,
        maxCols: size.maxCol,
        maxRows: size.maxRow,
        onSelection: props.onSelection,
        selectedCol: size.col,
        selectedRow: size.row,
        onKeyDown: handleKeyDown,
        isFocused: isKeyboardMode.current,
        handleInitialButtonFocus: handleInitialButtonFocus
    })));
};
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$82f4da85c4c47833$export$2e2bcd8739ae039 = $82f4da85c4c47833$export$4b4bd4d01ec9c7c9;

});
parcelRegister("87V93", function(module, exports) {
$parcel$export(module.exports, "TABLE_SELECTOR_BUTTON_GAP", () => $e79fde7127747f4c$export$fe015b05aaf05d59);
$parcel$export(module.exports, "TABLE_SELECTOR_BUTTON_SIZE", () => $e79fde7127747f4c$export$80d6f86639b2335);
$parcel$export(module.exports, "default", () => $e79fde7127747f4c$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $fK3tS = parcelRequire("fK3tS");

var $dDEhr = parcelRequire("dDEhr");

var $797yE = parcelRequire("797yE");

var $cW1gB = parcelRequire("cW1gB");

var $3Aq92 = parcelRequire("3Aq92");
function $e79fde7127747f4c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e79fde7127747f4c$export$fe015b05aaf05d59 = 2;
const $e79fde7127747f4c$export$80d6f86639b2335 = 17;
const $e79fde7127747f4c$var$MULTIPLICATION_SYMBOL = "\xd7";
const $e79fde7127747f4c$var$selectedButtonStyles = /*#__PURE__*/ (0, $9dQre.css)({
    backgroundColor: "var(--ds-background-accent-blue-subtlest, #E9F2FE)",
    border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-background-accent-blue-subtle, #669DF1)"}`
});
const $e79fde7127747f4c$var$buttonStyles = /*#__PURE__*/ (0, $9dQre.css)({
    height: `${$e79fde7127747f4c$export$80d6f86639b2335}px`,
    width: `${$e79fde7127747f4c$export$80d6f86639b2335}px`,
    border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    backgroundColor: "var(--ds-background-input, #FFFFFF)",
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
    borderRadius: "var(--ds-radius-small, 3px)",
    cursor: 'pointer',
    display: 'block',
    '&:focus': {
        outline: 'none',
        border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border-focused, #4688EC)"}`,
        boxShadow: `0 0 0 0.5px ${"var(--ds-border-focused, #4688EC)"}`
    }
});
const $e79fde7127747f4c$var$selectionSizeTextStyles = {
    name: "1d7cjgr",
    styles: "line-height:14px;display:flex;justify-content:center;margin-top:var(--ds-space-075, 6px);padding:var(--ds-space-075, 6px)"
};
const $e79fde7127747f4c$var$TableSelectorButton = ({ row: row, col: col, isActive: isActive, onClick: onClick, label: label, onKeyDown: onKeyDown, isFocused: isFocused, handleInitialButtonFocus: handleInitialButtonFocus })=>{
    const btnRef = (0, $bSJIT.useRef)(null);
    (0, $bSJIT.useEffect)(()=>{
        if (btnRef.current) {
            if (isFocused) btnRef.current.focus({
                preventScroll: (0, $797yE.editorExperiment)('platform_editor_controls', 'variant1') ? true : undefined
            });
            else btnRef.current.blur();
        }
    }, [
        isFocused,
        btnRef
    ]);
    const handleFocus = col === 1 && row === 1 ? ()=>handleInitialButtonFocus() : undefined;
    return /*#__PURE__*/ (0, $9dQre.jsx)("button", {
        type: "button",
        css: [
            $e79fde7127747f4c$var$buttonStyles,
            isActive ? $e79fde7127747f4c$var$selectedButtonStyles : undefined
        ],
        onClick: ()=>onClick(row, col),
        "aria-label": label,
        onKeyDown: onKeyDown,
        ref: btnRef,
        onFocus: handleFocus
    });
};
const $e79fde7127747f4c$var$createArray = (maxCols, maxRows)=>{
    const arr = [];
    for(let i = 1; i < maxRows + 1; i++)for(let j = 1; j < maxCols + 1; j++)arr.push({
        col: j,
        row: i
    });
    return arr;
};
const $e79fde7127747f4c$var$gridWrapperStyles = ({ maxCols: maxCols, maxRows: maxRows })=>/*#__PURE__*/ (0, $9dQre.css)({
        display: 'grid',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        gridTemplateColumns: `repeat(${maxCols}, 1fr)`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        gridTemplateRows: `repeat(${maxRows}, 1fr)`,
        gap: `${"var(--ds-space-025, 2px)"}`
    });
const $e79fde7127747f4c$var$TableSelectorPopup = ({ maxCols: maxCols, maxRows: maxRows, onSelection: onSelection, selectedCol: selectedCol, selectedRow: selectedRow, onKeyDown: onKeyDown, isFocused: isFocused, handleInitialButtonFocus: handleInitialButtonFocus, intl: { formatMessage: formatMessage } })=>{
    const buttons = (0, $bSJIT.useMemo)(()=>{
        return $e79fde7127747f4c$var$createArray(maxCols, maxRows);
    }, [
        maxCols,
        maxRows
    ]);
    const setOutsideClickTargetRef = (0, $bSJIT.useContext)((0, $3Aq92.OutsideClickTargetRefContext));
    return /*#__PURE__*/ (0, $9dQre.jsx)((0, $dDEhr.Stack), {
        ref: setOutsideClickTargetRef
    }, /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        "aria-label": `${formatMessage((0, $cW1gB.toolbarInsertBlockMessages).tableSizeSelectorPopup)}`,
        css: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        $e79fde7127747f4c$var$gridWrapperStyles({
            maxCols: maxCols,
            maxRows: maxRows
        })
    }, buttons.map(({ col: col, row: row }, index)=>{
        const isCurrentFocused = isFocused && selectedCol === col && selectedRow === row;
        const isActive = selectedCol >= col && selectedRow >= row ? true : false;
        return /*#__PURE__*/ (0, $9dQre.jsx)($e79fde7127747f4c$var$TableSelectorButton, {
            // Ignored via go/ees005
            // eslint-disable-next-line react/no-array-index-key
            key: index,
            isActive: isActive,
            col: col,
            row: row,
            onClick: onSelection,
            label: `${formatMessage((0, $cW1gB.toolbarInsertBlockMessages).tableSizeSelectorButton, {
                numberOfColumns: col,
                numberOfRows: row
            })}`,
            onKeyDown: onKeyDown,
            isFocused: isCurrentFocused,
            handleInitialButtonFocus: handleInitialButtonFocus
        });
    })), /*#__PURE__*/ (0, $9dQre.jsx)("span", {
        css: $e79fde7127747f4c$var$selectionSizeTextStyles,
        "aria-hidden": true
    }, `${selectedCol} ${$e79fde7127747f4c$var$MULTIPLICATION_SYMBOL} ${selectedRow}`));
};
const $e79fde7127747f4c$var$_default_1 = (0, $fK3tS.default)($e79fde7127747f4c$var$TableSelectorPopup);
var // eslint-disable-next-line @atlaskit/volt-strict-mode/no-multiple-exports
$e79fde7127747f4c$export$2e2bcd8739ae039 = $e79fde7127747f4c$var$_default_1;

});




parcelRegister("hgqQ6", function(module, exports) {
$parcel$export(module.exports, "TaskListButton", () => $05e7769b336df291$export$be2acb2f228dcb8b);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $g6Qq4 = parcelRequire("g6Qq4");

var $cv8id = parcelRequire("cv8id");

var $cW1gB = parcelRequire("cW1gB");

var $28qc1 = parcelRequire("28qc1");

var $4rzOL = parcelRequire("4rzOL");

var $4ujxi = parcelRequire("4ujxi");

var $7cgYb = parcelRequire("7cgYb");

var $eHnl8 = parcelRequire("eHnl8");
const $05e7769b336df291$export$be2acb2f228dcb8b = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const { editorView: editorView } = (0, $28qc1.useEditorToolbar)();
    if (!(api !== null && api !== void 0 && api.taskDecision)) return null;
    const onClick = ()=>{
        if (editorView) {
            var _api$taskDecision;
            const { state: state, dispatch: dispatch } = editorView;
            api === null || api === void 0 || (_api$taskDecision = api.taskDecision) === null || _api$taskDecision === void 0 || _api$taskDecision.actions.insertTaskDecision('taskList', (0, $g6Qq4.INPUT_METHOD).TOOLBAR)(state, dispatch);
        }
    };
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $eHnl8.ToolbarTooltip), {
        content: /*#__PURE__*/ (0, $dc70d.jsx)((0, $cv8id.ToolTipContent), {
            description: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).action),
            keymap: (0, $cv8id.insertTaskList)
        }),
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $7cgYb.ToolbarButton), {
            iconBefore: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4ujxi))), {
                label: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).action),
                size: "small"
            }),
            onClick: onClick,
            ariaKeyshortcuts: "[ ] Space",
            testId: (0, $4rzOL.TOOLBAR_BUTTON_TEST_ID).TASK_LIST
        })
    });
};

});


parcelRegister("6r3dU", function(module, exports) {
$parcel$export(module.exports, "default", () => $52fe137ea93b6296$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $fK3tS = parcelRequire("fK3tS");

var $g6Qq4 = parcelRequire("g6Qq4");

var $cW1gB = parcelRequire("cW1gB");

var $5zk80 = parcelRequire("5zk80");

var $g42cj = parcelRequire("g42cj");

var $8qEmt = parcelRequire("8qEmt");

var $8zO6u = parcelRequire("8zO6u");

var $3Aq92 = parcelRequire("3Aq92");

var $cf2n1 = parcelRequire("cf2n1");

var $5bbjm = parcelRequire("5bbjm");

var $asaws = parcelRequire("asaws");

var $3y2s4 = parcelRequire("3y2s4");

var $gdUUy = parcelRequire("gdUUy");

var $797yE = parcelRequire("797yE");

var $4PIw5 = parcelRequire("4PIw5");

var $dyNy2 = parcelRequire("dyNy2");

var $4QSvT = parcelRequire("4QSvT");
/**
 * Checks if an element is detached (i.e. not in the current document)
 */ // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage -- Existing DOM check surfaced by this mechanical PR.
const $52fe137ea93b6296$var$isDetachedElement = (el)=>!document.body.contains(el);
const $52fe137ea93b6296$var$TABLE_SELECTOR_STRING = 'table selector';
// TODO: ED-26959 - Jenga team will create a component for a split button using this css
const $52fe137ea93b6296$var$getHoverStyles = (selector)=>`&:hover ${selector} {
    background: ${"var(--ds-background-neutral-subtle-hovered, #0515240F)"};

    &:hover {
      background: ${"var(--ds-background-neutral-hovered, #0B120E24)"};
    }
  }`;
const $52fe137ea93b6296$var$EmojiPicker = (props)=>{
    const setOutsideClickTargetRef = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useContext((0, $3Aq92.OutsideClickTargetRefContext));
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $9dQre.jsx)((0, $asaws.default), {
        onPickerRef: setOutsideClickTargetRef,
        ...props
    });
};
const $52fe137ea93b6296$var$EmojiPickerWithListeners = (0, $cf2n1.default)($52fe137ea93b6296$var$EmojiPicker);
const $52fe137ea93b6296$export$6555404d88cb913b = ({ isTableSelectorOpen: isTableSelectorOpen, isButtonDisabled: isButtonDisabled })=>/*#__PURE__*/ // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Needs manual remediation due to mixins
    (0, $9dQre.css)("display:flex;", !isTableSelectorOpen && !isButtonDisabled && $52fe137ea93b6296$var$getHoverStyles('.table-selector-toolbar-btn'), " ", !isTableSelectorOpen && !isButtonDisabled && $52fe137ea93b6296$var$getHoverStyles('.table-toolbar-btn'), " .table-toolbar-btn{border-top-right-radius:var(--ds-radius-large, 0px);border-bottom-right-radius:var(--ds-radius-large, 0px);margin-right:var(--ds-space-025, 2px);padding:var(--ds-space-0, 0px);&>span{min-width:16px;margin:var(--ds-space-0, 0px);}}.table-selector-toolbar-btn{padding:var(--ds-space-0, 0px);border-top-left-radius:var(--ds-radius-large, 0px)!important;border-bottom-left-radius:var(--ds-radius-large, 0px)!important;&>span{margin:var(--ds-space-0, 0px);width:16px!important;display:flex;justify-content:center;}}");
class $52fe137ea93b6296$export$630ae7da9d01a215 extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).PureComponent {
    static getDerivedStateFromProps(props, state) {
        var _props$pluginInjectio, _props$pluginInjectio2, _props$pluginInjectio3;
        const [buttons, dropdownItems] = (0, $4QSvT.createItems)({
            isTypeAheadAllowed: props.isTypeAheadAllowed,
            tableSupported: props.tableSupported,
            tableSelectorSupported: props.tableSelectorSupported,
            mediaUploadsEnabled: props.mediaUploadsEnabled,
            mediaSupported: props.mediaSupported,
            isEditorOffline: props.isEditorOffline,
            imageUploadSupported: props.imageUploadSupported,
            imageUploadEnabled: props.imageUploadEnabled,
            mentionsSupported: props.mentionsSupported,
            mentionsDisabled: props.mentionsDisabled,
            actionSupported: props.actionSupported,
            decisionSupported: props.decisionSupported,
            linkSupported: props.linkSupported,
            linkDisabled: props.linkDisabled,
            emojiDisabled: props.emojiDisabled,
            hasEmojiPlugin: !!((_props$pluginInjectio = props.pluginInjectionApi) !== null && _props$pluginInjectio !== void 0 && _props$pluginInjectio.emoji),
            hasMentionsPlugin: !!((_props$pluginInjectio2 = props.pluginInjectionApi) !== null && _props$pluginInjectio2 !== void 0 && _props$pluginInjectio2.mention),
            hasMediaPlugin: !!((_props$pluginInjectio3 = props.pluginInjectionApi) !== null && _props$pluginInjectio3 !== void 0 && _props$pluginInjectio3.media),
            nativeStatusSupported: props.nativeStatusSupported,
            dateEnabled: props.dateEnabled,
            placeholderTextEnabled: props.placeholderTextEnabled,
            horizontalRuleEnabled: props.horizontalRuleEnabled,
            layoutSectionEnabled: props.layoutSectionEnabled,
            expandEnabled: props.expandEnabled,
            showElementBrowserLink: props.showElementBrowserLink,
            emojiProvider: props.emojiProvider,
            availableWrapperBlockTypes: props.availableWrapperBlockTypes,
            insertMenuItems: props.insertMenuItems,
            itemFilter: props.itemFilter,
            schema: props.editorView.state.schema,
            numberOfButtons: props.buttons,
            formatMessage: props.intl.formatMessage
        });
        return {
            ...state,
            buttons: buttons,
            dropdownItems: dropdownItems
        };
    }
    componentDidUpdate(prevProps) {
        // If number of visible buttons changed, close emoji picker and table selector
        if (prevProps.buttons !== this.props.buttons) this.setState({
            emojiPickerOpen: false,
            isTableSelectorOpen: false
        });
        if (this.state.isOpenedByKeyboard) {
            var _this$dropdownButtonR;
            const downArrowEvent = new KeyboardEvent('keydown', {
                bubbles: true,
                key: 'ArrowDown'
            });
            (_this$dropdownButtonR = this.dropdownButtonRef) === null || _this$dropdownButtonR === void 0 || (_this$dropdownButtonR = _this$dropdownButtonR.deref()) === null || _this$dropdownButtonR === void 0 || _this$dropdownButtonR.dispatchEvent(downArrowEvent);
            this.setState({
                ...this.state,
                isOpenedByKeyboard: false
            });
        }
        if (this.state.isTableSelectorOpen) this.setState({
            isTableSelectorOpenedByKeyboard: false
        });
        if (this.props.showElementBrowser !== prevProps.showElementBrowser) {
            this.handleClick();
            this.setState({
                ...this.state,
                isPlusMenuOpen: this.props.showElementBrowser
            });
        }
    }
    renderPopup() {
        const { emojiPickerOpen: emojiPickerOpen } = this.state;
        const { popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, emojiProvider: emojiProvider } = this.props;
        const dropdownEmoji = this.state.dropdownItems.some(({ value: { name: name } })=>name === 'emoji');
        const dropDownButtonRef = this.plusButtonRef;
        const ref = dropdownEmoji ? dropDownButtonRef : this.emojiButtonRef;
        if (!emojiPickerOpen || !ref || !emojiProvider) return null;
        const onUnmount = ()=>{
            requestAnimationFrame(()=>{
                var _this$props$pluginInj;
                return (_this$props$pluginInj = this.props.pluginInjectionApi) === null || _this$props$pluginInj === void 0 || (_this$props$pluginInj = _this$props$pluginInj.core) === null || _this$props$pluginInj === void 0 || (_this$props$pluginInj = _this$props$pluginInj.actions) === null || _this$props$pluginInj === void 0 ? void 0 : _this$props$pluginInj.focus();
            });
        };
        return /*#__PURE__*/ (0, $9dQre.jsx)((0, $5zk80.default), {
            target: ref.deref(),
            fitHeight: 350,
            fitWidth: 350,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            offset: [
                0,
                3
            ],
            mountTo: popupsMountPoint,
            boundariesElement: popupsBoundariesElement,
            scrollableElement: popupsScrollableElement,
            onUnmount: onUnmount,
            focusTrap: true,
            zIndex: (0, $5bbjm.akEditorMenuZIndex)
        }, /*#__PURE__*/ (0, $9dQre.jsx)($52fe137ea93b6296$var$EmojiPickerWithListeners, {
            contentId: this.props.emojiContentId,
            emojiProvider: emojiProvider,
            onSelection: this.handleSelectedEmoji,
            handleClickOutside: this.handleEmojiClickOutside,
            handleEscapeKeydown: this.handleEmojiPressEscape
        }));
    }
    renderTableSelectorPopup() {
        const { isTableSelectorOpen: isTableSelectorOpen, isTableSelectorOpenedByKeyboard: isTableSelectorOpenedByKeyboard } = this.state;
        const { popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, pluginInjectionApi: pluginInjectionApi } = this.props;
        const ref = this.tableButtonRef.current ?? undefined;
        if (!isTableSelectorOpen) return null;
        // We use focusTrap in the Popup. When we insert a table via popup,
        // the popup closes, focusTrap gets destroyed and the popup detaches.
        // The focus gets set to the body element. onUnmount method sets focus on the editor right before the
        // Popup will be unmounted to ensure that the new table has a selection with a blinking cursor.
        // So we can start typing right away.
        const onUnmount = ()=>{
            var _pluginInjectionApi$c;
            return pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$c = pluginInjectionApi.core) === null || _pluginInjectionApi$c === void 0 || (_pluginInjectionApi$c = _pluginInjectionApi$c.actions) === null || _pluginInjectionApi$c === void 0 ? void 0 : _pluginInjectionApi$c.focus();
        };
        return /*#__PURE__*/ (0, $9dQre.jsx)((0, $8qEmt.TableSelectorPopup), {
            allowOutsideSelection: true,
            target: ref,
            onUnmount: onUnmount,
            onSelection: this.handleSelectedTableSize,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            handleClickOutside: this.handleTableSelectorClickOutside,
            handleEscapeKeydown: this.handleTableSelectorPressEscape,
            isOpenedByKeyboard: isTableSelectorOpenedByKeyboard
        });
    }
    render() {
        var _tableButton, _tableButton2, _tableButton3, _tableButton4, _tableButton5, _tableButton6, _tableButton7, _tableSelectorButton, _tableSelectorButton2, _tableSelectorButton3, _tableSelectorButton4, _tableSelectorButton5, _tableSelectorButton6, _this$plusButtonRef, _this$props$pluginInj2;
        const { buttons: buttons, dropdownItems: dropdownItems, emojiPickerOpen: emojiPickerOpen, isTableSelectorOpen: isTableSelectorOpen } = this.state;
        const { isDisabled: isDisabled, isReducedSpacing: isReducedSpacing, editorAppearance: editorAppearance } = this.props;
        const isFullPageAppearance = [
            'full-page',
            'full-width'
        ].includes(editorAppearance ?? '');
        const isTableButtonVisible = buttons.some(({ value: value })=>value.name === 'table');
        const isTableSizeVisible = buttons.some(({ value: value })=>value.name === 'table selector');
        if (buttons.length === 0 && dropdownItems.length === 0 && !(0, $3y2s4.isExperimentEnabled)('platform_editor_slash_command')) return null;
        const toolbarButtons = [];
        let tableSelectorButton;
        let tableButton;
        // Seperate table buttons from toolbar buttons
        for (const btn of buttons){
            if (btn.value.name === $52fe137ea93b6296$var$TABLE_SELECTOR_STRING) tableSelectorButton = btn;
            else if (btn.value.name === 'table' && this.props.tableSelectorSupported) tableButton = btn;
            else toolbarButtons.push(btn);
        }
        return /*#__PURE__*/ (0, $9dQre.jsx)("span", {
            css: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $g42cj.buttonGroupStyle)
        }, toolbarButtons.map((btn)=>{
            return /*#__PURE__*/ (0, $9dQre.jsx)((0, $8zO6u.default), {
                item: btn,
                testId: this.getToolbarButtonTestId(btn),
                ref: this.handleToolbarRef(btn.value.name),
                key: btn.value.name,
                spacing: isReducedSpacing ? 'none' : 'default',
                disabled: isDisabled || btn.isDisabled,
                iconBefore: btn.elemBefore,
                selected: btn.value.name === 'emoji' && emojiPickerOpen || btn.isActive,
                title: btn.title,
                "aria-label": btn['aria-label'],
                "aria-haspopup": btn['aria-haspopup'],
                "aria-keyshortcuts": btn['aria-keyshortcuts'],
                onItemClick: this.insertToolbarMenuItem
            });
        }), this.props.tableSelectorSupported && (isTableButtonVisible || isTableSizeVisible) && /*#__PURE__*/ (0, $9dQre.jsx)("div", {
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            css: $52fe137ea93b6296$export$6555404d88cb913b({
                isTableSelectorOpen: isTableSelectorOpen,
                isButtonDisabled: (_tableButton = tableButton) === null || _tableButton === void 0 ? void 0 : _tableButton.isDisabled
            })
        }, isTableButtonVisible && /*#__PURE__*/ (0, $9dQre.jsx)((0, $8zO6u.default), {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides -- Ignored via go/DSP-18766
            className: "table-toolbar-btn",
            item: tableButton,
            ref: this.tableButtonRef,
            testId: String((_tableButton2 = tableButton) === null || _tableButton2 === void 0 ? void 0 : _tableButton2.content),
            key: (_tableButton3 = tableButton) === null || _tableButton3 === void 0 ? void 0 : _tableButton3.value.name,
            spacing: isReducedSpacing ? 'none' : 'default',
            disabled: isDisabled || ((_tableButton4 = tableButton) === null || _tableButton4 === void 0 ? void 0 : _tableButton4.isDisabled),
            iconBefore: (_tableButton5 = tableButton) === null || _tableButton5 === void 0 ? void 0 : _tableButton5.elemBefore,
            selected: ((_tableButton6 = tableButton) === null || _tableButton6 === void 0 ? void 0 : _tableButton6.isActive) || isTableSelectorOpen,
            title: (_tableButton7 = tableButton) === null || _tableButton7 === void 0 ? void 0 : _tableButton7.title,
            "aria-label": tableButton ? tableButton['aria-label'] : undefined,
            "aria-haspopup": tableButton ? tableButton['aria-haspopup'] : undefined,
            "aria-keyshortcuts": tableButton ? tableButton['aria-keyshortcuts'] : undefined,
            onItemClick: this.insertToolbarMenuItem
        }), isTableButtonVisible && /*#__PURE__*/ (0, $9dQre.jsx)((0, $8zO6u.default), {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides -- Ignored via go/DSP-18766
            className: "table-selector-toolbar-btn",
            item: tableSelectorButton,
            testId: String((_tableSelectorButton = tableSelectorButton) === null || _tableSelectorButton === void 0 ? void 0 : _tableSelectorButton.content),
            key: (_tableSelectorButton2 = tableSelectorButton) === null || _tableSelectorButton2 === void 0 ? void 0 : _tableSelectorButton2.value.name,
            ref: this.tableSelectorButtonRef,
            spacing: isReducedSpacing ? 'none' : 'default',
            disabled: isDisabled || ((_tableSelectorButton3 = tableSelectorButton) === null || _tableSelectorButton3 === void 0 ? void 0 : _tableSelectorButton3.isDisabled),
            iconBefore: (_tableSelectorButton4 = tableSelectorButton) === null || _tableSelectorButton4 === void 0 ? void 0 : _tableSelectorButton4.elemBefore,
            selected: ((_tableSelectorButton5 = tableSelectorButton) === null || _tableSelectorButton5 === void 0 ? void 0 : _tableSelectorButton5.isActive) || isTableSelectorOpen,
            title: (_tableSelectorButton6 = tableSelectorButton) === null || _tableSelectorButton6 === void 0 ? void 0 : _tableSelectorButton6.title,
            "aria-label": tableSelectorButton ? tableSelectorButton['aria-label'] : undefined,
            "aria-haspopup": tableSelectorButton ? tableSelectorButton['aria-haspopup'] : undefined,
            "aria-keyshortcuts": tableSelectorButton ? tableSelectorButton['aria-keyshortcuts'] : undefined,
            onItemClick: this.insertToolbarMenuItem,
            onKeyDown: this.handleTableSelectorOpenByKeyboard
        })), /*#__PURE__*/ (0, $9dQre.jsx)("span", {
            css: (0, $g42cj.wrapperStyle)
        }, this.renderPopup(), this.renderTableSelectorPopup(), /*#__PURE__*/ (0, $9dQre.jsx)((0, $dyNy2.BlockInsertMenu), {
            popupsMountPoint: this.props.popupsMountPoint,
            popupsBoundariesElement: this.props.popupsBoundariesElement,
            popupsScrollableElement: this.props.popupsScrollableElement,
            disabled: this.props.isDisabled ?? false,
            editorView: this.props.editorView,
            spacing: this.props.isReducedSpacing ? 'none' : 'default',
            label: this.props.intl.formatMessage((0, $cW1gB.toolbarInsertBlockMessages).insertMenu),
            open: this.state.isPlusMenuOpen,
            plusButtonRef: (_this$plusButtonRef = this.plusButtonRef) === null || _this$plusButtonRef === void 0 ? void 0 : _this$plusButtonRef.deref(),
            items: this.state.dropdownItems,
            onRef: this.handleDropDownButtonRef,
            onPlusButtonRef: this.handlePlusButtonRef,
            onClick: this.handleClick,
            onKeyDown: this.handleOpenByKeyboard,
            onInsert: this.insertInsertMenuItem,
            togglePlusMenuVisibility: this.togglePlusMenuVisibility,
            showElementBrowserLink: this.props.showElementBrowserLink || false,
            isEditorOffline: this.props.isEditorOffline,
            pluginInjectionApi: this.props.pluginInjectionApi,
            isFullPageAppearance: isFullPageAppearance
        })), (!((_this$props$pluginInj2 = this.props.pluginInjectionApi) !== null && _this$props$pluginInj2 !== void 0 && _this$props$pluginInj2.primaryToolbar) && this.props.showSeparator || isFullPageAppearance && (0, $797yE.editorExperiment)('platform_editor_controls', 'variant1')) && /* eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $9dQre.jsx)("span", {
            css: (0, $g42cj.separatorStyles)
        }));
    }
    constructor(...args){
        super(...args), this.tableButtonRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createRef(), this.tableSelectorButtonRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createRef(), this.state = {
            isPlusMenuOpen: false,
            emojiPickerOpen: false,
            isOpenedByKeyboard: false,
            buttons: [],
            dropdownItems: [],
            isTableSelectorOpen: false,
            isTableSelectorOpenedByKeyboard: false
        }, this.onOpenChange = (attrs)=>{
            const state = {
                isPlusMenuOpen: attrs.isPlusMenuOpen,
                emojiPickerOpen: this.state.emojiPickerOpen
            };
            if (this.state.emojiPickerOpen && !attrs.open) state.emojiPickerOpen = false;
            this.setState(state, ()=>{
                const { dispatchAnalyticsEvent: dispatchAnalyticsEvent } = this.props;
                if (!dispatchAnalyticsEvent) return;
                const { isPlusMenuOpen: isPlusMenuOpen } = this.state;
                if (isPlusMenuOpen) return dispatchAnalyticsEvent({
                    action: (0, $g6Qq4.ACTION).OPENED,
                    actionSubject: (0, $g6Qq4.ACTION_SUBJECT).PLUS_MENU,
                    eventType: (0, $g6Qq4.EVENT_TYPE).UI
                });
                return dispatchAnalyticsEvent({
                    action: (0, $g6Qq4.ACTION).CLOSED,
                    actionSubject: (0, $g6Qq4.ACTION_SUBJECT).PLUS_MENU,
                    eventType: (0, $g6Qq4.EVENT_TYPE).UI
                });
            });
        }, this.togglePlusMenuVisibility = (event)=>{
            const { isPlusMenuOpen: isPlusMenuOpen } = this.state;
            const { pluginInjectionApi: pluginInjectionApi } = this.props;
            if (pluginInjectionApi && (0, $gdUUy.fg)('platform_editor_ease_of_use_metrics')) pluginInjectionApi.core.actions.execute(({ tr: tr })=>{
                if (isPlusMenuOpen) {
                    var _pluginInjectionApi$m;
                    (_pluginInjectionApi$m = pluginInjectionApi.metrics) === null || _pluginInjectionApi$m === void 0 || _pluginInjectionApi$m.commands.startActiveSessionTimer()({
                        tr: tr
                    });
                } else {
                    var _pluginInjectionApi$m2;
                    (_pluginInjectionApi$m2 = pluginInjectionApi.metrics) === null || _pluginInjectionApi$m2 === void 0 || _pluginInjectionApi$m2.commands.handleIntentToStartEdit({
                        shouldStartTimer: false,
                        shouldPersistActiveSession: true
                    })({
                        tr: tr
                    });
                }
                return tr;
            });
            this.onOpenChange({
                isPlusMenuOpen: !isPlusMenuOpen
            });
            if ((event === null || event === void 0 ? void 0 : event.key) === 'Escape') {
                var _ref;
                (_ref = this.plusButtonRef || this.dropdownButtonRef) === null || _ref === void 0 || (_ref = _ref.deref()) === null || _ref === void 0 || _ref.focus();
            }
        }, this.toggleEmojiPicker = (inputMethod = (0, $g6Qq4.INPUT_METHOD).TOOLBAR)=>{
            this.setState((prevState)=>({
                    emojiPickerOpen: !prevState.emojiPickerOpen
                }), ()=>{
                if (this.state.emojiPickerOpen) {
                    const { dispatchAnalyticsEvent: dispatchAnalyticsEvent } = this.props;
                    if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
                        action: (0, $g6Qq4.ACTION).OPENED,
                        actionSubject: (0, $g6Qq4.ACTION_SUBJECT).PICKER,
                        actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).PICKER_EMOJI,
                        attributes: {
                            inputMethod: inputMethod
                        },
                        eventType: (0, $g6Qq4.EVENT_TYPE).UI
                    });
                }
            });
        }, this.handleEmojiPressEscape = ()=>{
            var _this$emojiButtonRef;
            this.toggleEmojiPicker((0, $g6Qq4.INPUT_METHOD).KEYBOARD);
            (_this$emojiButtonRef = this.emojiButtonRef) === null || _this$emojiButtonRef === void 0 || (_this$emojiButtonRef = _this$emojiButtonRef.deref()) === null || _this$emojiButtonRef === void 0 || _this$emojiButtonRef.focus();
        }, this.handleEmojiClickOutside = (e)=>{
            // Ignore click events for detached elements.
            // Workaround for FS-1322 - where two onClicks fire - one when the upload button is
            // still in the document, and one once it's detached. Does not always occur, and
            // may be a side effect of a react render optimisation
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            if (e.target && !$52fe137ea93b6296$var$isDetachedElement(e.target)) this.toggleEmojiPicker((0, $g6Qq4.INPUT_METHOD).TOOLBAR);
        }, this.getToolbarButtonTestId = (btn)=>{
            const buttonTestIds = {
                media: 'media-attachment-toolbar-button'
            };
            return buttonTestIds[btn.value.name] || String(btn.content);
        }, this.handleToolbarRef = (buttonName)=>(ref)=>{
                if (!ref) return;
                switch(buttonName){
                    case 'emoji':
                        this.emojiButtonRef = new WeakRef(ref);
                        break;
                    case 'media':
                        this.mediaButtonRef = new WeakRef(ref);
                        break;
                }
            }, this.handlePlusButtonRef = (ref)=>{
            if (ref) this.plusButtonRef = new WeakRef(ref);
        }, this.handleDropDownButtonRef = (ref)=>{
            if (ref) this.dropdownButtonRef = new WeakRef(ref);
        }, this.toggleTableSelector = (_inputMethod = (0, $g6Qq4.INPUT_METHOD).TOOLBAR)=>{
            this.setState((prevState)=>({
                    isTableSelectorOpen: !prevState.isTableSelectorOpen
                }));
        }, this.handleSelectedTableSize = (rowsCount, colsCount)=>{
            this.insertTableWithSize((0, $g6Qq4.INPUT_METHOD).TOOLBAR, rowsCount, colsCount)();
            this.toggleTableSelector();
        }, this.handleTableSelectorPressEscape = ()=>{
            var _this$tableSelectorBu;
            this.toggleTableSelector((0, $g6Qq4.INPUT_METHOD).KEYBOARD);
            (_this$tableSelectorBu = this.tableSelectorButtonRef.current) === null || _this$tableSelectorBu === void 0 || _this$tableSelectorBu.focus();
        }, this.handleTableSelectorClickOutside = (e)=>{
            // Ignore click events for detached elements.
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            if (e.target && !$52fe137ea93b6296$var$isDetachedElement(e.target)) this.toggleTableSelector((0, $g6Qq4.INPUT_METHOD).TOOLBAR);
        }, this.handleClick = ()=>{
            this.togglePlusMenuVisibility();
        }, this.handleOpenByKeyboard = (event)=>{
            if (event.key === 'Enter' || event.key === ' ') {
                this.setState({
                    ...this.state,
                    isOpenedByKeyboard: true
                });
                event.preventDefault();
                this.togglePlusMenuVisibility();
            }
        }, this.handleTableSelectorOpenByKeyboard = (event)=>{
            if (event.key === 'Enter' || event.key === ' ') this.setState({
                isTableSelectorOpenedByKeyboard: true
            });
        }, this.toggleLinkPanel = (inputMethod)=>{
            var _pluginInjectionApi$c2, _pluginInjectionApi$h;
            const { pluginInjectionApi: pluginInjectionApi } = this.props;
            return (pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$c2 = pluginInjectionApi.core) === null || _pluginInjectionApi$c2 === void 0 ? void 0 : _pluginInjectionApi$c2.actions.execute(pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$h = pluginInjectionApi.hyperlink) === null || _pluginInjectionApi$h === void 0 ? void 0 : _pluginInjectionApi$h.commands.showLinkToolbar(inputMethod))) ?? false;
        }, this.insertMention = (inputMethod)=>{
            var _pluginInjectionApi$m3, _pluginInjectionApi$m4;
            const { editorView: editorView, pluginInjectionApi: pluginInjectionApi } = this.props;
            if (!editorView) return true;
            const pluginState = pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$m3 = pluginInjectionApi.mention) === null || _pluginInjectionApi$m3 === void 0 ? void 0 : _pluginInjectionApi$m3.sharedState.currentState();
            if (pluginState && pluginState.canInsertMention === false) return false;
            return Boolean(pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$m4 = pluginInjectionApi.mention) === null || _pluginInjectionApi$m4 === void 0 || (_pluginInjectionApi$m4 = _pluginInjectionApi$m4.actions) === null || _pluginInjectionApi$m4 === void 0 ? void 0 : _pluginInjectionApi$m4.openTypeAhead(inputMethod));
        }, this.insertTable = (inputMethod)=>{
            const { pluginInjectionApi: pluginInjectionApi, editorView: editorView } = this.props;
            const { state: state, dispatch: dispatch } = editorView;
            // workaround to solve race condition where cursor is not placed correctly inside table
            queueMicrotask(()=>{
                var _pluginInjectionApi$t, _pluginInjectionApi$t2, _pluginInjectionApi$t3;
                pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$t = pluginInjectionApi.table) === null || _pluginInjectionApi$t === void 0 || (_pluginInjectionApi$t2 = (_pluginInjectionApi$t3 = _pluginInjectionApi$t.actions).insertTable) === null || _pluginInjectionApi$t2 === void 0 || _pluginInjectionApi$t2.call(_pluginInjectionApi$t3, {
                    action: (0, $g6Qq4.ACTION).INSERTED,
                    actionSubject: (0, $g6Qq4.ACTION_SUBJECT).DOCUMENT,
                    actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).TABLE,
                    attributes: {
                        inputMethod: inputMethod
                    },
                    eventType: (0, $g6Qq4.EVENT_TYPE).TRACK
                })(state, dispatch);
            });
        }, this.insertTableWithSize = (inputMethod, rowsCount, colsCount)=>()=>{
                const { pluginInjectionApi: pluginInjectionApi } = this.props;
                // workaround to solve race condition where cursor is not placed correctly inside table
                queueMicrotask(()=>{
                    var _pluginInjectionApi$c3, _pluginInjectionApi$t4;
                    pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$c3 = pluginInjectionApi.core) === null || _pluginInjectionApi$c3 === void 0 || _pluginInjectionApi$c3.actions.execute(pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$t4 = pluginInjectionApi.table) === null || _pluginInjectionApi$t4 === void 0 ? void 0 : _pluginInjectionApi$t4.commands.insertTableWithSize(rowsCount, colsCount, (0, $g6Qq4.INPUT_METHOD).PICKER));
                });
            }, this.createDate = (inputMethod)=>{
            var _pluginInjectionApi$c4, _pluginInjectionApi$d;
            const { pluginInjectionApi: pluginInjectionApi } = this.props;
            pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$c4 = pluginInjectionApi.core) === null || _pluginInjectionApi$c4 === void 0 || _pluginInjectionApi$c4.actions.execute(pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$d = pluginInjectionApi.date) === null || _pluginInjectionApi$d === void 0 || (_pluginInjectionApi$d = _pluginInjectionApi$d.commands) === null || _pluginInjectionApi$d === void 0 ? void 0 : _pluginInjectionApi$d.insertDate({
                inputMethod: inputMethod
            }));
            return true;
        }, this.createPlaceholderText = ()=>{
            var _pluginInjectionApi$p;
            const { editorView: editorView, pluginInjectionApi: pluginInjectionApi } = this.props;
            pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$p = pluginInjectionApi.placeholderText) === null || _pluginInjectionApi$p === void 0 || _pluginInjectionApi$p.actions.showPlaceholderFloatingToolbar(editorView.state, editorView.dispatch);
            return true;
        }, this.insertLayoutColumns = (inputMethod)=>{
            var _pluginInjectionApi$l;
            const { editorView: editorView, pluginInjectionApi: pluginInjectionApi } = this.props;
            pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$l = pluginInjectionApi.layout) === null || _pluginInjectionApi$l === void 0 || _pluginInjectionApi$l.actions.insertLayoutColumns(inputMethod)(editorView.state, editorView.dispatch);
            return true;
        }, this.createStatus = (inputMethod)=>{
            var _pluginInjectionApi$c5, _pluginInjectionApi$s;
            const { pluginInjectionApi: pluginInjectionApi } = this.props;
            return Boolean(pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$c5 = pluginInjectionApi.core) === null || _pluginInjectionApi$c5 === void 0 ? void 0 : _pluginInjectionApi$c5.actions.execute(pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$s = pluginInjectionApi.status) === null || _pluginInjectionApi$s === void 0 || (_pluginInjectionApi$s = _pluginInjectionApi$s.commands) === null || _pluginInjectionApi$s === void 0 ? void 0 : _pluginInjectionApi$s.insertStatus(inputMethod)));
        }, this.openMediaPicker = (inputMethod)=>{
            const { onShowMediaPicker: onShowMediaPicker, dispatchAnalyticsEvent: dispatchAnalyticsEvent } = this.props;
            if (onShowMediaPicker) {
                var _this$mediaButtonRef;
                const ref = (_this$mediaButtonRef = this.mediaButtonRef) === null || _this$mediaButtonRef === void 0 ? void 0 : _this$mediaButtonRef.deref();
                const args = ref !== null && ref !== void 0 && ref.parentElement ? {
                    ref: ref,
                    mountPoint: this.props.popupsMountPoint ?? ref.parentElement
                } : undefined;
                onShowMediaPicker(args);
                if (dispatchAnalyticsEvent) dispatchAnalyticsEvent({
                    action: (0, $g6Qq4.ACTION).OPENED,
                    actionSubject: (0, $g6Qq4.ACTION_SUBJECT).PICKER,
                    actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).PICKER_MEDIA,
                    attributes: {
                        inputMethod: inputMethod
                    },
                    eventType: (0, $g6Qq4.EVENT_TYPE).UI
                });
            }
            return true;
        }, this.insertTaskDecision = (name, inputMethod)=>()=>{
                var _pluginInjectionApi$t5;
                const { editorView: { state: state, dispatch: dispatch }, pluginInjectionApi: pluginInjectionApi } = this.props;
                const listType = name === 'action' ? 'taskList' : 'decisionList';
                return (pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$t5 = pluginInjectionApi.taskDecision) === null || _pluginInjectionApi$t5 === void 0 ? void 0 : _pluginInjectionApi$t5.actions.insertTaskDecision(listType, inputMethod)(state, dispatch)) ?? false;
            }, this.insertHorizontalRule = (inputMethod)=>{
            var _pluginInjectionApi$r;
            const { editorView: { state: state, dispatch: dispatch }, pluginInjectionApi: pluginInjectionApi } = this.props;
            return (pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$r = pluginInjectionApi.rule) === null || _pluginInjectionApi$r === void 0 ? void 0 : _pluginInjectionApi$r.actions.insertHorizontalRule(inputMethod)(state, dispatch)) ?? false;
        }, this.insertExpand = ()=>{
            var _pluginInjectionApi$e;
            const { editorView: { state: state, dispatch: dispatch }, pluginInjectionApi: pluginInjectionApi } = this.props;
            return (pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$e = pluginInjectionApi.expand) === null || _pluginInjectionApi$e === void 0 ? void 0 : _pluginInjectionApi$e.actions.insertExpand(state, dispatch)) ?? false;
        }, this.insertBlockType = (itemName)=>()=>{
                const { editorView: editorView, onInsertBlockType: onInsertBlockType } = this.props;
                const { state: state, dispatch: dispatch } = editorView;
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                onInsertBlockType(itemName)(state, dispatch);
                return true;
            }, this.handleSelectedEmoji = (emojiId)=>{
            var _pluginInjectionApi$c6, _pluginInjectionApi$e2;
            const { pluginInjectionApi: pluginInjectionApi } = this.props;
            this.props.editorView.focus();
            pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$c6 = pluginInjectionApi.core) === null || _pluginInjectionApi$c6 === void 0 || _pluginInjectionApi$c6.actions.execute((_pluginInjectionApi$e2 = pluginInjectionApi.emoji) === null || _pluginInjectionApi$e2 === void 0 ? void 0 : _pluginInjectionApi$e2.commands.insertEmoji(emojiId, (0, $g6Qq4.INPUT_METHOD).PICKER));
            this.toggleEmojiPicker();
            return true;
        }, this.onItemActivated = ({ item: item, inputMethod: inputMethod })=>{
            const { editorView: editorView, handleImageUpload: handleImageUpload, expandEnabled: expandEnabled } = this.props;
            // need to do this before inserting nodes so scrollIntoView works properly
            if (!editorView.hasFocus()) editorView.focus();
            switch(item.value.name){
                case 0, $4PIw5.LINK_BUTTON_KEY:
                    this.toggleLinkPanel(inputMethod);
                    break;
                case 'table':
                    this.insertTable(inputMethod);
                    break;
                case 'table selector':
                    this.toggleTableSelector(inputMethod);
                    break;
                case 'image upload':
                    if (handleImageUpload) {
                        const { state: state, dispatch: dispatch } = editorView;
                        handleImageUpload()(state, dispatch);
                    }
                    break;
                case 'media':
                    this.openMediaPicker(inputMethod);
                    break;
                case 'mention':
                    this.insertMention(inputMethod);
                    break;
                case 'emoji':
                    this.toggleEmojiPicker(inputMethod);
                    break;
                case 'codeblock':
                case 'blockquote':
                case 'panel':
                    this.insertBlockType(item.value.name)();
                    break;
                case 'action':
                case 'decision':
                    this.insertTaskDecision(item.value.name, inputMethod)();
                    break;
                case 'horizontalrule':
                    this.insertHorizontalRule(inputMethod);
                    break;
                case 'date':
                    this.createDate(inputMethod);
                    break;
                case 'placeholder text':
                    this.createPlaceholderText();
                    break;
                case 'layout':
                    this.insertLayoutColumns(inputMethod);
                    break;
                case 'status':
                    this.createStatus(inputMethod);
                    break;
                // https://product-fabric.atlassian.net/browse/ED-8053
                // @ts-ignore: OK to fallthrough to default
                case 'expand':
                    if (expandEnabled) {
                        this.insertExpand();
                        break;
                    }
                // eslint-disable-next-line no-fallthrough
                default:
                    if (item && item.onClick) {
                        item.onClick();
                        break;
                    }
            }
            this.setState({
                isPlusMenuOpen: false
            });
        }, this.insertToolbarMenuItem = (btn)=>this.onItemActivated({
                item: btn,
                inputMethod: (0, $g6Qq4.INPUT_METHOD).TOOLBAR
            }), this.insertInsertMenuItem = ({ item: item })=>this.onItemActivated({
                item: item,
                inputMethod: (0, $g6Qq4.INPUT_METHOD).INSERT_MENU
            });
    }
}
// eslint-disable-next-line @typescript-eslint/no-restricted-types
const $52fe137ea93b6296$var$_default_1 = (0, $fK3tS.default)($52fe137ea93b6296$export$630ae7da9d01a215);
var $52fe137ea93b6296$export$2e2bcd8739ae039 = $52fe137ea93b6296$var$_default_1;

});
parcelRegister("g42cj", function(module, exports) {
$parcel$export(module.exports, "buttonGroupStyle", () => $d98ad5380fe16f1a$export$5897f954e99cc6c0);
$parcel$export(module.exports, "separatorStyles", () => $d98ad5380fe16f1a$export$39b9f83b35c7456d);
$parcel$export(module.exports, "wrapperStyle", () => $d98ad5380fe16f1a$export$c4d4f06a25de97f);
$parcel$export(module.exports, "triggerWrapperStylesWithPadding", () => $d98ad5380fe16f1a$export$f2c6a721c78d3c4a);
$parcel$export(module.exports, "disableBlueBorderStyles", () => $d98ad5380fe16f1a$export$cd86615b96818354);
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9dQre = parcelRequire("9dQre");
function $d98ad5380fe16f1a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d98ad5380fe16f1a$export$7638a34f4ed2b514 = {
    name: "ewpfso",
    styles: "display:inline-flex;align-items:center;& > div{display:flex;}button:not(#local-media-upload-button){&:not([disabled])::after{border:none;}}"
};
const $d98ad5380fe16f1a$export$5897f954e99cc6c0 = {
    name: "ioewc",
    styles: "display:inline-flex;align-items:center;& > div{display:flex;}button:not(#local-media-upload-button){&:not([disabled])::after{border:none;}}gap:var(--ds-space-050, 4px);div[role=group]{gap:var(--ds-space-050, 4px);}"
};
const $d98ad5380fe16f1a$export$39b9f83b35c7456d = /*#__PURE__*/ (0, $9dQre.css)({
    background: "var(--ds-border, #0B120E24)",
    width: '1px',
    height: '24px',
    display: 'inline-block',
    margin: `0 ${"var(--ds-space-100, 8px)"}`,
    userSelect: 'none'
});
const $d98ad5380fe16f1a$export$c4d4f06a25de97f = {
    name: "1ty89h5",
    styles: "display:flex;align-items:center;> div, > span{display:flex;}> div > div{display:flex;}margin-left:0;min-width:auto;button{&:not([disabled])::after{border:none;}}"
};
const $d98ad5380fe16f1a$export$147e2cce6f264c9b = {
    name: "wb8qky",
    styles: "display:flex;button{&:not([disabled])::after{border:none;}}"
};
const $d98ad5380fe16f1a$export$f2c6a721c78d3c4a = {
    name: "4sd07o",
    styles: "display:flex;padding-right:var(--ds-space-025, 2px);button{&:not([disabled])::after{border:none;}}"
};
const $d98ad5380fe16f1a$export$cd86615b96818354 = {
    name: "ox0lz7",
    styles: "&:not([disabled])::after{border:none;}"
};

});

parcelRegister("dyNy2", function(module, exports) {
$parcel$export(module.exports, "BlockInsertMenu", () => $aee68aa30bb3e71d$export$4476666e12e8d26e);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $3y2s4 = parcelRequire("3y2s4");

var $1PSFK = parcelRequire("1PSFK");

var $hmp4i = parcelRequire("hmp4i");
const $aee68aa30bb3e71d$export$4476666e12e8d26e = (props)=>{
    if (props.items.length === 0 && !props.showElementBrowserLink && !(0, $3y2s4.isExperimentEnabled)('platform_editor_slash_command')) return null;
    if (props.disabled) return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $hmp4i.DropDownButton), {
            "aria-expanded": props.open,
            "aria-haspopup": true,
            handleRef: props.onRef,
            selected: props.open,
            disabled: props.disabled,
            onClick: props.onClick,
            onKeyDown: props.onKeyDown,
            spacing: props.spacing,
            label: props.label,
            "aria-keyshortcuts": "/"
        })
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $1PSFK.BlockInsertElementBrowser), {
        disabled: props.disabled,
        editorView: props.editorView,
        items: props.items,
        label: props.label,
        onClick: props.onClick,
        onKeyDown: props.onKeyDown,
        onInsert: props.onInsert,
        onRef: props.onPlusButtonRef,
        open: props.open,
        plusButtonRef: props.plusButtonRef,
        popupsBoundariesElement: props.popupsBoundariesElement,
        popupsMountPoint: props.popupsMountPoint,
        popupsScrollableElement: props.popupsScrollableElement,
        spacing: props.spacing,
        togglePlusMenuVisibility: props.togglePlusMenuVisibility,
        showElementBrowserLink: props.showElementBrowserLink,
        isEditorOffline: props.isEditorOffline,
        pluginInjectionApi: props.pluginInjectionApi,
        isFullPageAppearance: props.isFullPageAppearance
    });
};

});
parcelRegister("1PSFK", function(module, exports) {
$parcel$export(module.exports, "BlockInsertElementBrowser", () => $28d65a602d7ec95f$export$fa06a3a473615c12);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $5zk80 = parcelRequire("5zk80");

var $e3nP3 = parcelRequire("e3nP3");

var $3y2s4 = parcelRequire("3y2s4");

var $iVq7n = parcelRequire("iVq7n");

var $hRynz = parcelRequire("hRynz");

var $hmp4i = parcelRequire("hmp4i");
// This determines how the popup should fit. We prefer the insert menu
// opening on the bottom as we have a search bar and should only open on
// top if there is more than sufficient room.
const $28d65a602d7ec95f$var$FIT_HEIGHT_BUFFER = 100;
const $28d65a602d7ec95f$export$fa06a3a473615c12 = (props)=>{
    const { togglePlusMenuVisibility: togglePlusMenuVisibility, plusButtonRef: plusButtonRef } = props;
    const isRegisteredMenu = (0, $3y2s4.isExperimentEnabled)('platform_editor_slash_command');
    const menuHeight = (0, $e3nP3.useMenuPopupSizing)({
        target: plusButtonRef,
        boundariesElement: props.popupsBoundariesElement,
        scrollableElement: props.popupsScrollableElement,
        maxHeight: 520,
        offset: 3,
        isOpen: props.open && isRegisteredMenu
    });
    const closeRegisteredMenu = (0, $bSJIT.useCallback)(()=>togglePlusMenuVisibility(), [
        togglePlusMenuVisibility
    ]);
    const closeRegisteredMenuAndRestoreFocus = (0, $bSJIT.useCallback)(()=>{
        togglePlusMenuVisibility();
        plusButtonRef === null || plusButtonRef === void 0 || plusButtonRef.focus();
    }, [
        togglePlusMenuVisibility,
        plusButtonRef
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $dc70d.Fragment), {
        children: [
            props.open && /*#__PURE__*/ (0, $dc70d.jsx)((0, $5zk80.default), {
                target: props.plusButtonRef,
                fitHeight: isRegisteredMenu ? menuHeight : (0, $iVq7n.DEFAULT_HEIGHT) + $28d65a602d7ec95f$var$FIT_HEIGHT_BUFFER,
                fitWidth: 350,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                offset: [
                    0,
                    3
                ],
                mountTo: props.popupsMountPoint,
                boundariesElement: props.popupsBoundariesElement,
                scrollableElement: props.popupsScrollableElement,
                preventOverflow: true,
                alignX: "right",
                children: isRegisteredMenu ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $hRynz.RegisteredInsertMenuContent), {
                    api: props.pluginInjectionApi,
                    maxHeight: menuHeight,
                    editorView: props.editorView,
                    isOffline: Boolean(props.isEditorOffline),
                    onClose: closeRegisteredMenuAndRestoreFocus,
                    onDismiss: closeRegisteredMenu,
                    onSelect: closeRegisteredMenu,
                    target: props.plusButtonRef
                }) : /*#__PURE__*/ (0, $dc70d.jsx)((0, $iVq7n.default), {
                    editorView: props.editorView,
                    dropdownItems: props.items,
                    onInsert: props.onInsert,
                    toggleVisiblity: props.togglePlusMenuVisibility,
                    showElementBrowserLink: props.showElementBrowserLink,
                    pluginInjectionApi: props.pluginInjectionApi,
                    isFullPageAppearance: props.isFullPageAppearance
                })
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $hmp4i.DropDownButton), {
                "aria-expanded": props.open,
                "aria-haspopup": true,
                handleRef: props.onRef,
                selected: props.open,
                disabled: props.disabled,
                onClick: props.onClick,
                onKeyDown: props.onKeyDown,
                spacing: props.spacing,
                label: props.label,
                "aria-keyshortcuts": "/"
            })
        ]
    });
};

});
parcelRegister("hmp4i", function(module, exports) {
$parcel$export(module.exports, "DropDownButton", () => $147ec419c1ab3e98$export$e200d4ca2624495d);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $cv8id = parcelRequire("cv8id");

var $8zO6u = parcelRequire("8zO6u");

var $kFWau = parcelRequire("kFWau");

var $4GWyU = parcelRequire("4GWyU");

var $9NOHB = parcelRequire("9NOHB");
const $147ec419c1ab3e98$var$DropDownButtonIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).memo((props)=>// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $9dQre.jsx)("span", {
        css: (0, $9NOHB.triggerWrapper)
    }, /*#__PURE__*/ (0, $9dQre.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kFWau))), {
        label: props.label,
        color: "currentColor",
        spacing: "spacious"
    }), /*#__PURE__*/ (0, $9dQre.jsx)("span", null, /*#__PURE__*/ (0, $9dQre.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4GWyU))), {
        label: "",
        color: "currentColor",
        size: "small"
    }))));
const $147ec419c1ab3e98$export$e200d4ca2624495d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).memo((props)=>/*#__PURE__*/ (0, $9dQre.jsx)((0, $8zO6u.default), {
        ref: props.handleRef,
        selected: props.selected,
        disabled: props.disabled,
        onClick: props.onClick,
        onKeyDown: props.onKeyDown,
        spacing: props.spacing,
        "aria-expanded": props['aria-expanded'],
        "aria-haspopup": props['aria-haspopup'],
        "aria-keyshortcuts": props['aria-keyshortcuts'],
        "aria-label": `${props.label}`,
        iconBefore: /*#__PURE__*/ (0, $9dQre.jsx)($147ec419c1ab3e98$var$DropDownButtonIcon, {
            label: ""
        }),
        title: /*#__PURE__*/ (0, $9dQre.jsx)((0, $cv8id.ToolTipContent), {
            description: props.label,
            shortcutOverride: "/"
        })
    }));

});
parcelRegister("9NOHB", function(module, exports) {
$parcel$export(module.exports, "triggerWrapper", () => $1a14d83948e9beca$export$61533625d778d03b);
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766 */ function $1a14d83948e9beca$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1a14d83948e9beca$export$61533625d778d03b = {
    name: "y71vja",
    styles: "width:42px;display:flex;align-items:center;> div, > span{display:flex;}> div > div{display:flex;}"
};
const $1a14d83948e9beca$export$16be3daa8c26e74d = {
    name: "8gsxsd",
    styles: "margin-left:var(--ds-space-050, 4px)"
};

});






parcelRegister("hyCzT", function(module, exports) {
$parcel$export(module.exports, "default", () => $fb75d8fc46ebfd66$export$2e2bcd8739ae039);

var $3VXSn = parcelRequire("3VXSn");
function $fb75d8fc46ebfd66$var$editorUGCToken(path) {
    return (0, $3VXSn.editorUGCTokensRefreshed)[path];
}
var $fb75d8fc46ebfd66$export$2e2bcd8739ae039 = $fb75d8fc46ebfd66$var$editorUGCToken;

});

parcelRegister("6iC1e", function(module, exports) {
$parcel$export(module.exports, "default", () => $cf9c3c34204ce553$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $8K5q6 = parcelRequire("8K5q6");
function $cf9c3c34204ce553$export$2e2bcd8739ae039() {
    const { iconThemed: iconThemed } = (0, $8K5q6.useIconThemed)();
    return /*#__PURE__*/ (0, $dc70d.jsxs)("svg", {
        focusable: "false",
        "aria-hidden": true,
        width: 40,
        height: 40,
        viewBox: "0 0 40 40",
        children: [
            /*#__PURE__*/ (0, $dc70d.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $dc70d.jsxs)("linearGradient", {
                        x1: "-26.046%",
                        y1: "100%",
                        x2: "62.626%",
                        y2: "0%",
                        id: "fallback-a",
                        children: [
                            /*#__PURE__*/ (0, $dc70d.jsx)("stop", {
                                stopColor: "#B3BAC5",
                                offset: "0%"
                            }),
                            /*#__PURE__*/ (0, $dc70d.jsx)("stop", {
                                stopColor: "#A5ADBA",
                                offset: "100%"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $dc70d.jsxs)("linearGradient", {
                        x1: "-12.24%",
                        y1: "100%",
                        x2: "82.44%",
                        y2: "0%",
                        id: "fallback-b",
                        children: [
                            /*#__PURE__*/ (0, $dc70d.jsx)("stop", {
                                stopColor: "#5A6977",
                                offset: "0%"
                            }),
                            /*#__PURE__*/ (0, $dc70d.jsx)("stop", {
                                stopColor: "#454F59",
                                offset: "100%"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dc70d.jsxs)("g", {
                fill: "none",
                fillRule: "evenodd",
                children: [
                    /*#__PURE__*/ (0, $dc70d.jsx)("path", {
                        fill: iconThemed({
                            light: '#FFF',
                            dark: '#161A1D'
                        }),
                        d: "M0 0h40v40H0z"
                    }),
                    /*#__PURE__*/ (0, $dc70d.jsx)("path", {
                        fill: iconThemed({
                            light: '#DFE1E6',
                            dark: '#738496'
                        }),
                        d: "M20 16h12v12H20z"
                    }),
                    /*#__PURE__*/ (0, $dc70d.jsx)("path", {
                        fill: iconThemed({
                            light: 'url(#fallback-a)',
                            dark: 'url(#fallback-b)'
                        }),
                        d: "M8 16h12v12H8z"
                    }),
                    /*#__PURE__*/ (0, $dc70d.jsx)("path", {
                        d: "M20 16c-4 .5-6.029 2.5-6.086 6-.057 3.5-2.028 5.5-5.914 6h12V16z",
                        fill: iconThemed({
                            light: '#A5ADBA',
                            dark: '#454F59'
                        })
                    }),
                    /*#__PURE__*/ (0, $dc70d.jsx)("path", {
                        fill: iconThemed({
                            light: '#B3BAC5',
                            dark: '#454F59'
                        }),
                        d: "M17.5 13h5v3h-5z"
                    }),
                    /*#__PURE__*/ (0, $dc70d.jsx)("path", {
                        fill: iconThemed({
                            light: '#A5ADBA',
                            dark: '#454F59'
                        }),
                        d: "M10 13h5v3h-5z"
                    }),
                    /*#__PURE__*/ (0, $dc70d.jsx)("path", {
                        fill: iconThemed({
                            light: '#DFE1E6',
                            dark: '#738496'
                        }),
                        d: "M25 13h5v3h-5z"
                    })
                ]
            })
        ]
    });
}

});

parcelRegister("ab8ay", function(module, exports) {
$parcel$export(module.exports, "default", () => $fa58acfd773ff2cf$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $2YfQG = parcelRequire("2YfQG");

var $4UfGH = parcelRequire("4UfGH");

var $4vLTk = parcelRequire("4vLTk");

var $3y2s4 = parcelRequire("3y2s4");

var $gUpf2 = parcelRequire("gUpf2");

var $9BVpB = parcelRequire("9BVpB");

var $797yE = parcelRequire("797yE");

var $5N1Y4 = parcelRequire("5N1Y4");

var $4zjoa = parcelRequire("4zjoa");

var $lavtv = parcelRequire("lavtv");

var $kRPKQ = parcelRequire("kRPKQ");

var $2j1Ci = parcelRequire("2j1Ci");
const $fa58acfd773ff2cf$var$resizerLabelStyles = (0, $9BVpB.xcss)({
    position: 'absolute',
    bottom: "var(--ds-space-0, 0px)",
    width: '100%',
    overflow: 'visible',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: "var(--ds-space-0, 0px)",
    zIndex: 'layer' // 400 same z-index as the floating toolbar
});
const $fa58acfd773ff2cf$var$SUPPORTED_HANDLES = [
    'left',
    'right'
];
const $fa58acfd773ff2cf$var$SUPPORTED_HANDLES_FOR_VERTICAL_RESIZE = [
    'left',
    'right',
    'bottom'
];
const $fa58acfd773ff2cf$var$inheritedCSS = {
    position: 'inherit',
    height: 'inherit',
    width: 'inherit',
    display: 'inherit',
    flexDirection: 'inherit',
    justifyContent: 'inherit',
    alignItems: 'inherit'
};
const $fa58acfd773ff2cf$var$ResizerNext = (props, ref)=>{
    const [isResizing, setIsResizing] = (0, $bSJIT.useState)(false);
    const resizable = (0, $bSJIT.useRef)(null);
    const resizeHandleThumbRef = (0, $bSJIT.useRef)(null);
    (0, $bSJIT.useImperativeHandle)(ref, ()=>{
        return {
            getResizerThumbEl () {
                return resizeHandleThumbRef.current;
            }
        };
    }, [
        resizeHandleThumbRef
    ]);
    const { width: width, height: height, children: children, handleClassName: handleClassName, className: className, handleResize: handleResize, handleResizeStart: handleResizeStart, handleResizeStop: handleResizeStop, handleSize: handleSize = 'medium', handleAlignmentMethod: handleAlignmentMethod = 'center', handlePositioning: handlePositioning = 'overlap', appearance: appearance, handleStyles: handleStyles, resizeRatio: resizeRatio = 1, snap: snap, snapGap: snapGap, isHandleVisible: isHandleVisible = false, handleHighlight: handleHighlight = 'none', handleTooltipContent: handleTooltipContent, needExtendedResizeZone: needExtendedResizeZone = true, childrenDOMRef: childrenDOMRef, labelComponent: labelComponent, ...otherProps } = props;
    const isDatabasesV2Enabled = (0, $4zjoa.expValEqualsNoExposure)('cc-maui-experiment', 'isEnabled', true) && (0, $5N1Y4.expValEquals)('databases-native-embeds-v2', 'isEnabled', true);
    const supportedHandles = isDatabasesV2Enabled ? $fa58acfd773ff2cf$var$SUPPORTED_HANDLES_FOR_VERTICAL_RESIZE : $fa58acfd773ff2cf$var$SUPPORTED_HANDLES;
    const onResizeStart = (0, $bSJIT.useCallback)((event)=>{
        // prevent creating a drag event on Firefox
        event.preventDefault();
        setIsResizing(true);
        handleResizeStart();
    }, [
        handleResizeStart
    ]);
    const onResize = (0, $bSJIT.useCallback)((_event, direction, _elementRef, delta)=>{
        if (!handleResize) return;
        const resizableCurrent = resizable.current;
        if (!resizableCurrent || !resizableCurrent.state.original) return;
        const originalState = {
            x: resizableCurrent.state.original.x,
            y: resizableCurrent.state.original.y,
            width: resizableCurrent.state.original.width,
            height: resizableCurrent.state.original.height
        };
        if (isDatabasesV2Enabled) handleResize(originalState, delta, direction);
        else handleResize(originalState, delta);
    }, [
        handleResize,
        isDatabasesV2Enabled
    ]);
    const onResizeStop = (0, $bSJIT.useCallback)((_event, direction, _elementRef, delta)=>{
        const resizableCurrent = resizable.current;
        if (!resizableCurrent || !resizableCurrent.state.original) return;
        const originalState = {
            x: resizableCurrent.state.original.x,
            y: resizableCurrent.state.original.y,
            width: resizableCurrent.state.original.width,
            height: resizableCurrent.state.original.height
        };
        setIsResizing(false);
        if (isDatabasesV2Enabled) handleResizeStop(originalState, delta, direction);
        else handleResizeStop(originalState, delta);
    }, [
        handleResizeStop,
        isDatabasesV2Enabled
    ]);
    const handles = (0, $bSJIT.useMemo)(()=>supportedHandles.reduce((result, position)=>({
                ...result,
                [position]: (0, (/*@__PURE__*/$parcel$interopDefault($2YfQG)))(handleClassName ?? (0, $2j1Ci.resizerHandleClassName), position, handleSize, position === 'bottom' && isDatabasesV2Enabled ? undefined : handleAlignmentMethod)
            }), {}), [
        handleClassName,
        handleSize,
        handleAlignmentMethod,
        supportedHandles,
        isDatabasesV2Enabled
    ]);
    const handleWidth = handlePositioning === 'adjacent' ? "var(--ds-space-100, 8px)" : "var(--ds-space-300, 24px)";
    const baseHorizontalHandleStyles = {
        width: handleWidth,
        zIndex: (0, $2j1Ci.resizerHandleZIndex),
        pointerEvents: 'auto',
        alignItems: handlePositioning === 'adjacent' ? 'center' : undefined
    };
    const baseBottomHandleStyles = {
        height: handleWidth,
        zIndex: (0, $2j1Ci.resizerHandleZIndex),
        pointerEvents: 'auto',
        justifyContent: handlePositioning === 'adjacent' ? 'center' : undefined
    };
    const memoizedBaseHorizontalHandleStyles = (0, $bSJIT.useMemo)(()=>({
            width: handleWidth,
            zIndex: (0, $2j1Ci.resizerHandleZIndex),
            pointerEvents: 'auto',
            alignItems: handlePositioning === 'adjacent' ? 'center' : undefined
        }), [
        handleWidth,
        handlePositioning
    ]);
    const memoizedBaseBottomHandleStyles = (0, $bSJIT.useMemo)(()=>({
            height: handleWidth,
            zIndex: (0, $2j1Ci.resizerHandleZIndex),
            pointerEvents: 'auto',
            justifyContent: handlePositioning === 'adjacent' ? 'center' : undefined
        }), [
        handleWidth,
        handlePositioning
    ]);
    const offset = handlePositioning === 'adjacent' ? `calc(${handleWidth} * -1)` : `calc(${handleWidth} * -0.5)`;
    const memoizedNextHandleStyles = (0, $bSJIT.useMemo)(()=>supportedHandles.reduce((result, position)=>({
                ...result,
                [position]: {
                    ...position === 'bottom' ? memoizedBaseBottomHandleStyles : memoizedBaseHorizontalHandleStyles,
                    [position]: offset,
                    ...handleStyles === null || handleStyles === void 0 ? void 0 : handleStyles[position]
                }
            }), {}), [
        memoizedBaseBottomHandleStyles,
        memoizedBaseHorizontalHandleStyles,
        offset,
        handleStyles,
        supportedHandles
    ]);
    const nextHandleStyles = (0, $3y2s4.isExperimentEnabled)('platform_editor_perf_lint_cleanup') ? memoizedNextHandleStyles : // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- intentional fallback for experiment off path
    supportedHandles.reduce((result, position)=>({
            ...result,
            [position]: {
                ...position === 'bottom' ? baseBottomHandleStyles : baseHorizontalHandleStyles,
                [position]: offset,
                ...handleStyles === null || handleStyles === void 0 ? void 0 : handleStyles[position]
            }
        }), {});
    const resizerClassName = (0, (/*@__PURE__*/$parcel$interopDefault($2YfQG)))(className, (0, $2j1Ci.resizerItemClassName), {
        'is-resizing': isResizing,
        'display-handle': isHandleVisible,
        [(0, $2j1Ci.resizerDangerClassName)]: appearance === 'danger'
    });
    const resizerZoneClassName = (0, (/*@__PURE__*/$parcel$interopDefault($2YfQG)))((0, $2j1Ci.resizerHoverZoneClassName), {
        [(0, $2j1Ci.resizerExtendedZone)]: needExtendedResizeZone
    });
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const handleComponent = (0, $bSJIT.useMemo)(()=>{
        return supportedHandles.reduce((result, position)=>{
            const thumb = /*#__PURE__*/ (0, $dc70d.jsx)("button", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: (0, $2j1Ci.resizerHandleThumbClassName),
                "data-testid": `resizer-handle-${position}-thumb`,
                "aria-label": formatMessage((0, $kRPKQ.messages).resizeHandle),
                contentEditable: false,
                ref: resizeHandleThumbRef,
                type: "button",
                tabIndex: -1
            });
            if ((!handleHighlight || handleHighlight === 'none') && !handleTooltipContent) return {
                ...result,
                [position]: thumb
            };
            const thumbWithTrack = //It's important to have {thumb} element before the div, the thumb element is the one that gets focus and only the 1st element recives aria-descibedby attribute which is important for screen reader users
            /*#__PURE__*/ (0, $dc70d.jsxs)((0, $dc70d.Fragment), {
                children: [
                    thumb,
                    /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($2YfQG)))((0, $2j1Ci.resizerHandleTrackClassName), handleHighlight),
                        "data-testid": `resizer-handle-${position}-track`
                    })
                ]
            });
            if (!!handleTooltipContent) return {
                ...result,
                [position]: // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                    contentEditable: false,
                    style: $fa58acfd773ff2cf$var$inheritedCSS,
                    children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $lavtv.default), {
                        content: handleTooltipContent,
                        hideTooltipOnClick: true,
                        position: "mouse",
                        mousePosition: "auto-start",
                        testId: `resizer-handle-${position}-tooltip`,
                        children: thumbWithTrack
                    })
                })
            };
            return {
                ...result,
                [position]: // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                    contentEditable: false,
                    style: $fa58acfd773ff2cf$var$inheritedCSS,
                    children: thumbWithTrack
                })
            };
        }, {});
    }, [
        handleHighlight,
        handleTooltipContent,
        formatMessage,
        supportedHandles
    ]);
    // snapGap is usually a constant, if snap.x?.length is 0 and snapGap has a value resizer cannot be resized
    const snapGapActual = (0, $bSJIT.useMemo)(()=>{
        var _snap$x, _snap$y;
        if (!snap || ((_snap$x = snap.x) === null || _snap$x === void 0 ? void 0 : _snap$x.length) === 0 && ((_snap$y = snap.y) === null || _snap$y === void 0 ? void 0 : _snap$y.length) === 0) return undefined;
        return snapGap;
    }, [
        snap,
        snapGap
    ]);
    const resolvedHeight = isDatabasesV2Enabled ? height ?? 'auto' : 'auto';
    const resizerAutoSize = (0, $bSJIT.useMemo)(()=>({
            width: width ?? 'auto',
            height: resolvedHeight
        }), [
        resolvedHeight,
        width
    ]);
    const resizerSize = (0, $3y2s4.isExperimentEnabled)('platform_editor_perf_lint_cleanup') ? resizerAutoSize : // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- intentional fallback for experiment off path
    {
        width: width ?? 'auto',
        height: resolvedHeight
    };
    return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $4UfGH.Resizable), {
        ref: resizable,
        size: resizerSize,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resizerClassName,
        handleClasses: handles,
        handleWrapperClass: (0, $2j1Ci.handleWrapperClass),
        handleStyles: nextHandleStyles,
        onResizeStart: onResizeStart,
        onResize: onResize,
        onResizeStop: onResizeStop,
        resizeRatio: resizeRatio,
        snapGap: snapGapActual,
        snap: snap,
        handleComponent: handleComponent,
        ...otherProps,
        children: [
            /*#__PURE__*/ (0, $dc70d.jsx)("span", {
                className: resizerZoneClassName,
                ref: (ref)=>childrenDOMRef && childrenDOMRef(ref),
                children: children
            }),
            labelComponent && (0, $797yE.editorExperiment)('single_column_layouts', true) && /*#__PURE__*/ (0, $dc70d.jsx)((0, $gUpf2.Box), {
                xcss: $fa58acfd773ff2cf$var$resizerLabelStyles,
                children: labelComponent
            })
        ]
    });
};
const $fa58acfd773ff2cf$var$_default_1 = /*#__PURE__*/ (0, $bSJIT.forwardRef)($fa58acfd773ff2cf$var$ResizerNext);
var $fa58acfd773ff2cf$export$2e2bcd8739ae039 = $fa58acfd773ff2cf$var$_default_1;

});

parcelRegister("cp06f", function(module, exports) {
$parcel$export(module.exports, "UserIntentPopupWrapper", () => $de92a40eb6b2d178$export$99ff0262540b54dc);

var $bSJIT = parcelRequire("bSJIT");
const $de92a40eb6b2d178$export$99ff0262540b54dc = ({ userIntent: userIntent = 'popupOpen', children: children, api: api })=>{
    (0, $bSJIT.useEffect)(()=>{
        var _api$userIntent;
        api === null || api === void 0 || api.core.actions.execute(api === null || api === void 0 || (_api$userIntent = api.userIntent) === null || _api$userIntent === void 0 ? void 0 : _api$userIntent.commands.setCurrentUserIntent(userIntent));
        return ()=>{
            var _api$userIntent2;
            if (userIntent === (api === null || api === void 0 || (_api$userIntent2 = api.userIntent) === null || _api$userIntent2 === void 0 || (_api$userIntent2 = _api$userIntent2.sharedState.currentState()) === null || _api$userIntent2 === void 0 ? void 0 : _api$userIntent2.currentUserIntent)) // Defer the reset to avoid interfering with ongoing ProseMirror transactions
            // This fixes a race condition where cleanup happens during a transaction
            // (e.g., during drag handle mouse over -> unmountDecorations -> flushSync)
            setTimeout(()=>{
                var _api$userIntent3;
                api === null || api === void 0 || api.core.actions.execute(api === null || api === void 0 || (_api$userIntent3 = api.userIntent) === null || _api$userIntent3 === void 0 ? void 0 : _api$userIntent3.commands.setCurrentUserIntent('default'));
            }, 0);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return children;
};

});

parcelRegister("h6aQr", function(module, exports) {
$parcel$export(module.exports, "ToolbarMenuContainer", () => $1555f518650d7f29$export$7ddb7d7248bd500a);
/* ToolbarMenuContainer.tsx generated by @compiled/babel-plugin v3.0.2 */ /* ToolbarMenuContainer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $jDsoo = parcelRequire("jDsoo");

var $3y2s4 = parcelRequire("3y2s4");

var $9PwDt = parcelRequire("9PwDt");
const $1555f518650d7f29$var$styles = {
    container: "_2rko12b0 _bfhk1bhr _16qs130s",
    radiusUpdate: "_2rko1mok",
    emptyMenuSectionStyles: "_1cc0glyw _1k2yglyw"
};
const $1555f518650d7f29$export$7ddb7d7248bd500a = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ children: children, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, testId: testId, xcss: xcss }, ref)=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
        xcss: (0, $jDsoo.cx)($1555f518650d7f29$var$styles.container, (0, $3y2s4.isExperimentEnabled)('platform_editor_menu_radius_update') && $1555f518650d7f29$var$styles.radiusUpdate, (0, $3y2s4.isExperimentEnabled)('platform_editor_menu_radius_update') && $1555f518650d7f29$var$styles.emptyMenuSectionStyles, (0, $3y2s4.isExperimentEnabled)('platform_editor_menu_radius_update') && xcss),
        testId: testId,
        onMouseDown: onMouseDown,
        onMouseEnter: onMouseEnter,
        "data-toolbar-component": "menu",
        role: "menu",
        ref: ref,
        children: children
    });
});

});

parcelRegister("1gwdz", function(module, exports) {
$parcel$export(module.exports, "ToolbarNestedDropdownMenu", () => $f6a6ca96a15db1ff$export$21541b912954ea8c);
/* ToolbarNestedDropdownMenu.tsx generated by @compiled/babel-plugin v3.0.2 */ /* ToolbarNestedDropdownMenu.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $14TCm = parcelRequire("14TCm");

var $4dKmO = parcelRequire("4dKmO");

var $lkSXl = parcelRequire("lkSXl");

var $9PwDt = parcelRequire("9PwDt");

var $dbuPt = parcelRequire("dbuPt");

var $eHnl8 = parcelRequire("eHnl8");
const $f6a6ca96a15db1ff$var$styles = {
    scrollContainer: "_c71lnklw _18m91wug"
};
const $f6a6ca96a15db1ff$var$PopupVisibilityController = ({ isVisible: isVisible, popupContentIdRef: popupContentIdRef, triggerElementRef: triggerElementRef })=>{
    (0, $bSJIT.useLayoutEffect)(()=>{
        var _triggerElementRef$cu;
        if (isVisible) return;
        const popupContentId = popupContentIdRef.current;
        const popupElement = popupContentId ? (_triggerElementRef$cu = triggerElementRef.current) === null || _triggerElementRef$cu === void 0 ? void 0 : _triggerElementRef$cu.ownerDocument.getElementById(popupContentId) : null;
        if (!popupElement) return;
        const previousVisibility = popupElement.style.visibility;
        popupElement.style.visibility = 'hidden';
        return ()=>{
            popupElement.style.visibility = previousVisibility;
        };
    }, [
        isVisible,
        popupContentIdRef,
        triggerElementRef
    ]);
    return null;
};
const $f6a6ca96a15db1ff$export$21541b912954ea8c = ({ elemBefore: elemBefore, text: text, elemAfterText: elemAfterText, elemAfter: elemAfter, children: children, isDisabled: isDisabled, testId: testId, dropdownTestId: dropdownTestId, enableMaxHeight: enableMaxHeight = false, isPopupVisible: isPopupVisible, onClick: onClick, shouldFitContainer: shouldFitContainer = false, shouldIgnoreCloseEvent: shouldIgnoreCloseEvent, shouldTitleWrap: shouldTitleWrap, tooltipContent: tooltipContent, 'data-extension-item-key': dataExtensionItemKey })=>{
    const popupContentIdRef = (0, $bSJIT.useRef)(undefined);
    const triggerElementRef = (0, $bSJIT.useRef)(null);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $lkSXl.default), {
        shouldFitContainer: shouldFitContainer,
        shouldIgnoreCloseEvent: shouldIgnoreCloseEvent,
        placement: "right-start",
        testId: dropdownTestId,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        trigger: (triggerProps)=>{
            const captureTriggerRef = (element)=>{
                triggerElementRef.current = element;
                popupContentIdRef.current = element ? triggerProps['aria-controls'] : undefined;
            };
            const item = /*#__PURE__*/ (0, $dc70d.jsxs)((0, $dbuPt.ToolbarDropdownItem), {
                elemBefore: elemBefore,
                elemAfter: elemAfter,
                isSelected: triggerProps.isSelected,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                onClick: (e)=>{
                    onClick && onClick(e);
                    triggerProps.onClick && triggerProps.onClick(e);
                },
                testId: testId,
                triggerRef: isPopupVisible === undefined ? triggerProps.triggerRef : (0, $4dKmO.mergeRefs)([
                    triggerProps.triggerRef,
                    captureTriggerRef
                ]),
                hasNestedDropdownMenu: true,
                isDisabled: isDisabled,
                shouldTitleWrap: shouldTitleWrap,
                "data-extension-item-key": dataExtensionItemKey,
                children: [
                    text,
                    elemAfterText
                ]
            });
            if (tooltipContent) return /*#__PURE__*/ (0, $dc70d.jsx)((0, $eHnl8.ToolbarTooltip), {
                content: tooltipContent,
                position: "top",
                children: item
            });
            return item;
        },
        children: /*#__PURE__*/ (0, $dc70d.jsxs)((0, $9PwDt.Box), {
            xcss: (0, $14TCm.cx)(enableMaxHeight && $f6a6ca96a15db1ff$var$styles.scrollContainer),
            "data-toolbar-nested-dropdown-menu": true,
            children: [
                isPopupVisible !== undefined && /*#__PURE__*/ (0, $dc70d.jsx)($f6a6ca96a15db1ff$var$PopupVisibilityController, {
                    isVisible: isPopupVisible,
                    popupContentIdRef: popupContentIdRef,
                    triggerElementRef: triggerElementRef
                }),
                children
            ]
        })
    });
};

});

parcelRegister("dBFcf", function(module, exports) {
$parcel$export(module.exports, "listPlugin", () => $b6c3fcb3217a666f$export$aab29c128be6b8b2);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $cm5bx = parcelRequire("cm5bx");

var $co6dq = parcelRequire("co6dq");

var $drur6 = parcelRequire("drur6");

var $g6Qq4 = parcelRequire("g6Qq4");

var $5BUNL = parcelRequire("5BUNL");

var $cv8id = parcelRequire("cv8id");

var $anv2i = parcelRequire("anv2i");

var $3y2s4 = parcelRequire("3y2s4");

var $gdUUy = parcelRequire("gdUUy");

var $jMNEp = parcelRequire("jMNEp");

var $hEPiO = parcelRequire("hEPiO");

var $1y0UK = parcelRequire("1y0UK");

var $4KAVU = parcelRequire("4KAVU");

var $iQvt4 = parcelRequire("iQvt4");

var $hqaCP = parcelRequire("hqaCP");

var $7uTIW = parcelRequire("7uTIW");

var $9fsJn = parcelRequire("9fsJn");

var $7fMgH = parcelRequire("7fMgH");

var $Jdyi6 = parcelRequire("Jdyi6");
const $b6c3fcb3217a666f$export$aab29c128be6b8b2 = ({ api: api })=>{
    var _api$featureFlags, _api$analytics, _api$blockMenu;
    const featureFlags = (api === null || api === void 0 || (_api$featureFlags = api.featureFlags) === null || _api$featureFlags === void 0 ? void 0 : _api$featureFlags.sharedState.currentState()) || {};
    const editorAnalyticsAPI = api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions;
    api === null || api === void 0 || (_api$blockMenu = api.blockMenu) === null || _api$blockMenu === void 0 || _api$blockMenu.actions.registerBlockMenuComponents((0, $7fMgH.getListComponents)(api));
    const isRegisteredSlashCommandEnabled = (0, $3y2s4.isExperimentEnabled)('platform_editor_slash_command');
    if (isRegisteredSlashCommandEnabled) {
        var _api$uiControlRegistr;
        api === null || api === void 0 || (_api$uiControlRegistr = api.uiControlRegistry) === null || _api$uiControlRegistr === void 0 || _api$uiControlRegistr.actions.register((0, $Jdyi6.getListQuickInsertComponents)({
            api: api
        }));
    }
    return {
        name: 'list',
        actions: {
            isInsideListItem: $9fsJn.isInsideListItem,
            findRootParentListNode: $7uTIW.findRootParentListNode
        },
        commands: {
            indentList: (0, $hEPiO.indentList)(editorAnalyticsAPI),
            outdentList: (inputMethod)=>(0, $1y0UK.outdentList)(editorAnalyticsAPI)(inputMethod),
            toggleOrderedList: (0, $jMNEp.toggleOrderedList)(editorAnalyticsAPI),
            toggleBulletList: (0, $jMNEp.toggleBulletList)(editorAnalyticsAPI)
        },
        getSharedState: (editorState)=>{
            if (!editorState) return undefined;
            return (0, $hqaCP.pluginKey).getState(editorState);
        },
        nodes () {
            const getListItemNode = ()=>{
                if ((0, $gdUUy.fg)('platform_editor_adf_with_localid')) return 0, $co6dq.listItemWithLocalId;
                return 0, $co6dq.listItem;
            };
            return [
                {
                    name: 'bulletList',
                    node: (0, $gdUUy.fg)('platform_editor_adf_with_localid') ? (0, $cm5bx.bulletListWithLocalId) : (0, $cm5bx.bulletList)
                },
                {
                    name: 'orderedList',
                    node: (0, $gdUUy.fg)('platform_editor_adf_with_localid') ? (0, $drur6.orderedListWithOrderAndLocalId) : (0, $drur6.orderedListWithOrder)
                },
                {
                    name: 'listItem',
                    node: getListItemNode()
                }
            ];
        },
        pmPlugins () {
            return [
                {
                    name: 'list',
                    plugin: ({ dispatch: dispatch })=>(0, $hqaCP.createPlugin)(dispatch, featureFlags, api)
                },
                {
                    name: 'listInputRule',
                    plugin: ({ schema: schema })=>{
                        var _api$analytics2;
                        return (0, $4KAVU.default)(schema, api === null || api === void 0 || (_api$analytics2 = api.analytics) === null || _api$analytics2 === void 0 ? void 0 : _api$analytics2.actions);
                    }
                },
                {
                    name: 'listKeymap',
                    plugin: ()=>{
                        var _api$analytics3;
                        return (0, $iQvt4.default)(featureFlags, api === null || api === void 0 || (_api$analytics3 = api.analytics) === null || _api$analytics3 === void 0 ? void 0 : _api$analytics3.actions);
                    }
                }
            ];
        },
        pluginsOptions: isRegisteredSlashCommandEnabled ? {} : {
            quickInsert: ({ formatMessage: formatMessage })=>{
                return [
                    {
                        id: 'unorderedList',
                        title: formatMessage((0, $anv2i.messages).unorderedList),
                        description: formatMessage((0, $anv2i.messages).unorderedListDescription),
                        keywords: [
                            'ul',
                            'unordered'
                        ],
                        priority: 1100,
                        keyshortcut: (0, $cv8id.tooltip)((0, $cv8id.toggleBulletList)),
                        icon: ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $5BUNL.IconList), {}),
                        action (insert, state) {
                            const tr = insert(state.schema.nodes.bulletList.createChecked({}, state.schema.nodes.listItem.createChecked({}, state.schema.nodes.paragraph.createChecked())));
                            editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent({
                                action: (0, $g6Qq4.ACTION).INSERTED,
                                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).LIST,
                                actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).FORMAT_LIST_BULLET,
                                eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
                                attributes: {
                                    inputMethod: (0, $g6Qq4.INPUT_METHOD).QUICK_INSERT
                                }
                            })(tr);
                            return tr;
                        }
                    },
                    {
                        id: 'orderedList',
                        title: formatMessage((0, $anv2i.messages).orderedList),
                        description: formatMessage((0, $anv2i.messages).orderedListDescription),
                        keywords: [
                            'ol',
                            'ordered'
                        ],
                        priority: 1200,
                        keyshortcut: (0, $cv8id.tooltip)((0, $cv8id.toggleOrderedList)),
                        icon: ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $5BUNL.IconListNumber), {}),
                        action (insert, state) {
                            const tr = insert(state.schema.nodes.orderedList.createChecked({}, state.schema.nodes.listItem.createChecked({}, state.schema.nodes.paragraph.createChecked())));
                            editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent({
                                action: (0, $g6Qq4.ACTION).INSERTED,
                                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).LIST,
                                actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).FORMAT_LIST_NUMBER,
                                eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
                                attributes: {
                                    inputMethod: (0, $g6Qq4.INPUT_METHOD).QUICK_INSERT
                                }
                            })(tr);
                            return tr;
                        }
                    }
                ];
            }
        }
    };
};

});
parcelRegister("jMNEp", function(module, exports) {
$parcel$export(module.exports, "enterKeyCommand", () => $0f1e0d8c1b7e87a3$export$476a01d760cd8a14);
$parcel$export(module.exports, "backspaceKeyCommand", () => $0f1e0d8c1b7e87a3$export$c1d6e1a8db28fd58);
$parcel$export(module.exports, "deleteKeyCommand", () => $0f1e0d8c1b7e87a3$export$ca522099b17e5b55);
$parcel$export(module.exports, "toggleList", () => $0f1e0d8c1b7e87a3$export$78da663726cb9398);
$parcel$export(module.exports, "toggleBulletList", () => $0f1e0d8c1b7e87a3$export$c0e115f47553645e);
$parcel$export(module.exports, "toggleOrderedList", () => $0f1e0d8c1b7e87a3$export$dca848a1b50b6a31);

var $g6Qq4 = parcelRequire("g6Qq4");

var $bq0hv = parcelRequire("bq0hv");

var $eWnvc = parcelRequire("eWnvc");

var $k3wEw = parcelRequire("k3wEw");

var $84BHs = parcelRequire("84BHs");

var $iPR6g = parcelRequire("iPR6g");

var $j7pt0 = parcelRequire("j7pt0");

var $cSk7K = parcelRequire("cSk7K");
var $asFQ7 = parcelRequire("asFQ7");

var $h7zC7 = parcelRequire("h7zC7");

var $5FzRL = parcelRequire("5FzRL");

var $kW8qW = parcelRequire("kW8qW");

var $cw0wu = parcelRequire("cw0wu");

var $gab48 = parcelRequire("gab48");

var $3y2s4 = parcelRequire("3y2s4");

var $a0y81 = parcelRequire("a0y81");

var $8SO3W = parcelRequire("8SO3W");

var $kWmG3 = parcelRequire("kWmG3");

var $9Fhn4 = parcelRequire("9Fhn4");

var $9fsJn = parcelRequire("9fsJn");

var $daVVV = parcelRequire("daVVV");

var $7qb9c = parcelRequire("7qb9c");

var $dN4vy = parcelRequire("dN4vy");

var $1y0UK = parcelRequire("1y0UK");
const $0f1e0d8c1b7e87a3$export$476a01d760cd8a14 = (editorAnalyticsAPI)=>()=>(state, dispatch)=>{
            const { selection: selection } = state;
            if (selection.empty) {
                const { $from: $from } = selection;
                const { listItem: listItem, codeBlock: codeBlock } = state.schema.nodes;
                // the list item is the parent of the gap cursor
                // while for text, list item is the grandparent of the text node
                const isGapCursorSelection = selection instanceof (0, $j7pt0.GapCursorSelection);
                const wrapper = isGapCursorSelection ? $from.parent : $from.node($from.depth - 1);
                if (wrapper && wrapper.type === listItem) {
                    /** Check if the wrapper has any visible content */ const wrapperHasContent = (0, $asFQ7.hasVisibleContent)(wrapper);
                    if (!wrapperHasContent) return (0, $iPR6g.editorCommandToPMCommand)((0, $1y0UK.outdentList)(editorAnalyticsAPI)((0, $g6Qq4.INPUT_METHOD).KEYBOARD))(state, dispatch);
                    else if (!(0, $gab48.hasParentNodeOfType)(codeBlock)(selection)) return $0f1e0d8c1b7e87a3$var$splitListItem(listItem)(state, dispatch);
                }
            }
            return false;
        };
const $0f1e0d8c1b7e87a3$export$c1d6e1a8db28fd58 = (editorAnalyticsAPI)=>()=>(state, dispatch)=>{
            // Select an adjacent syncBlock before the list command chain can outdent the current list.
            if ((0, $h7zC7.isEmptySelectionAtStart)(state)) {
                var _$cut$nodeBefore;
                const $cut = (0, $bq0hv.findCutBefore)(state.selection.$from);
                if (($cut === null || $cut === void 0 || (_$cut$nodeBefore = $cut.nodeBefore) === null || _$cut$nodeBefore === void 0 ? void 0 : _$cut$nodeBefore.type.name) === 'syncBlock') {
                    if (dispatch) dispatch(state.tr.setSelection((0, $cw0wu.NodeSelection).create(state.doc, $cut.pos - $cut.nodeBefore.nodeSize)).scrollIntoView());
                    return true;
                }
            }
            return (0, $5FzRL.chainCommands)((0, $dN4vy.listBackspace)(editorAnalyticsAPI), // if we're at the start of a list item, we need to either backspace
            // directly to an empty list item above, or outdent this node
            (0, $cSk7K.filter)([
                (0, $h7zC7.isEmptySelectionAtStart),
                // list items might have multiple paragraphs; only do this at the first one
                (0, $daVVV.isFirstChildOfParent),
                (state)=>(0, $9fsJn.isInsideListItem)(state.tr)
            ], (0, $5FzRL.chainCommands)($0f1e0d8c1b7e87a3$var$deletePreviousEmptyListItem, (0, $iPR6g.editorCommandToPMCommand)((0, $1y0UK.outdentList)(editorAnalyticsAPI)((0, $g6Qq4.INPUT_METHOD).KEYBOARD)))), // if we're just inside a paragraph node (or gapcursor is shown) and backspace, then try to join
            // the text to the previous list item, if one exists
            (0, $cSk7K.filter)([
                (0, $h7zC7.isEmptySelectionAtStart),
                (state)=>(0, $9fsJn.canJoinToPreviousListItem)(state.tr)
            ], $0f1e0d8c1b7e87a3$var$joinToPreviousListItem))(state, dispatch);
        };
const $0f1e0d8c1b7e87a3$export$ca522099b17e5b55 = (editorAnalyticsAPI)=>(0, $7qb9c.joinListItemForward)(editorAnalyticsAPI);
// Get the depth of the nearest ancestor list
const $0f1e0d8c1b7e87a3$var$rootListDepth = (pos, nodes)=>{
    const { bulletList: bulletList, orderedList: orderedList, listItem: listItem } = nodes;
    let depth;
    for(let i = pos.depth - 1; i > 0; i--){
        const node = pos.node(i);
        if (node.type === bulletList || node.type === orderedList) depth = i;
        if (node.type !== bulletList && node.type !== orderedList && node.type !== listItem) break;
    }
    return depth;
};
function $0f1e0d8c1b7e87a3$var$untoggleSelectedList(tr) {
    const { selection: selection } = tr;
    const depth = $0f1e0d8c1b7e87a3$var$rootListDepth(selection.$to, tr.doc.type.schema.nodes);
    tr = (0, $kWmG3.liftFollowingList)(selection.$to.pos, selection.$to.end(depth), depth || 0, tr);
    if (selection instanceof (0, $cw0wu.NodeSelection) || selection instanceof (0, $j7pt0.GapCursorSelection)) return (0, $kWmG3.liftNodeSelectionList)(selection, tr);
    return (0, $kWmG3.liftTextSelectionList)(selection, tr);
}
const $0f1e0d8c1b7e87a3$export$78da663726cb9398 = (editorAnalyticsAPI)=>(inputMethod, listType)=>{
        return function({ tr: tr }) {
            const { taskList: taskList } = tr.doc.type.schema.nodes;
            if ((0, $gab48.hasParentNodeOfType)(taskList)(tr.selection)) return tr;
            const listInsideSelection = (0, $9fsJn.selectionContainsList)(tr);
            const listNodeType = tr.doc.type.schema.nodes[listType];
            const actionSubjectId = listType === 'bulletList' ? (0, $g6Qq4.ACTION_SUBJECT_ID).FORMAT_LIST_BULLET : (0, $g6Qq4.ACTION_SUBJECT_ID).FORMAT_LIST_NUMBER;
            if (listInsideSelection) {
                const { selection: selection } = tr;
                // for gap cursor or node selection - list is expected 1 level up (listItem -> list)
                // for text selection - list is expected 2 levels up (paragraph -> listItem -> list)
                const positionDiff = selection instanceof (0, $j7pt0.GapCursorSelection) || selection instanceof (0, $cw0wu.NodeSelection) ? 1 : 2;
                const fromNode = selection.$from.node(selection.$from.depth - positionDiff);
                const toNode = selection.$to.node(selection.$to.depth - positionDiff);
                const transformedFrom = listInsideSelection.type.name === 'bulletList' ? (0, $g6Qq4.ACTION_SUBJECT_ID).FORMAT_LIST_BULLET : (0, $g6Qq4.ACTION_SUBJECT_ID).FORMAT_LIST_NUMBER;
                if ((fromNode === null || fromNode === void 0 ? void 0 : fromNode.type.name) === listType && (toNode === null || toNode === void 0 ? void 0 : toNode.type.name) === listType) {
                    const commonAttributes = (0, $eWnvc.getCommonListAnalyticsAttributes)(tr);
                    $0f1e0d8c1b7e87a3$var$untoggleSelectedList(tr);
                    editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent({
                        action: (0, $g6Qq4.ACTION).CONVERTED,
                        actionSubject: (0, $g6Qq4.ACTION_SUBJECT).LIST,
                        actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).TEXT,
                        eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
                        attributes: {
                            ...commonAttributes,
                            transformedFrom: transformedFrom,
                            inputMethod: inputMethod
                        }
                    })(tr);
                    return tr;
                }
                (0, $a0y81.convertListType)({
                    tr: tr,
                    nextListNodeType: listNodeType
                });
                editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent({
                    action: (0, $g6Qq4.ACTION).CONVERTED,
                    actionSubject: (0, $g6Qq4.ACTION_SUBJECT).LIST,
                    actionSubjectId: actionSubjectId,
                    eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
                    attributes: {
                        ...(0, $eWnvc.getCommonListAnalyticsAttributes)(tr),
                        transformedFrom: transformedFrom,
                        inputMethod: inputMethod
                    }
                })(tr);
            } else {
                // Need to have this before wrapInList so the wrapping is done with valid content
                // For example, if trying to convert centre or right aligned paragraphs to lists
                (0, $9Fhn4.sanitiseMarksInSelection)(tr, listNodeType);
                (0, $8SO3W.wrapInListAndJoin)(listNodeType, tr);
                editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent({
                    action: (0, $g6Qq4.ACTION).INSERTED,
                    actionSubject: (0, $g6Qq4.ACTION_SUBJECT).LIST,
                    actionSubjectId: actionSubjectId,
                    eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
                    attributes: {
                        inputMethod: inputMethod
                    }
                })(tr);
            }
            // If document wasn't changed, return false from the command to indicate that the
            // editing action failed
            if (!tr.docChanged) return null;
            return tr;
        };
    };
const $0f1e0d8c1b7e87a3$export$c0e115f47553645e = (editorAnalyticsAPI)=>(inputMethod = (0, $g6Qq4.INPUT_METHOD).TOOLBAR)=>{
        return $0f1e0d8c1b7e87a3$export$78da663726cb9398(editorAnalyticsAPI)(inputMethod, 'bulletList');
    };
const $0f1e0d8c1b7e87a3$export$dca848a1b50b6a31 = (editorAnalyticsAPI)=>(inputMethod = (0, $g6Qq4.INPUT_METHOD).TOOLBAR)=>{
        return $0f1e0d8c1b7e87a3$export$78da663726cb9398(editorAnalyticsAPI)(inputMethod, 'orderedList');
    };
/**
 * Implementation taken and modified for our needs from PM
 * @param itemType Node
 * Splits the list items, specific implementation take from PM
 */ function $0f1e0d8c1b7e87a3$var$splitListItem(itemType) {
    return function(state, dispatch) {
        const ref = state.selection;
        const $from = ref.$from;
        const $to = ref.$to;
        const node = ref.node;
        if (node && node.isBlock || $from.depth < 2 || !$from.sameParent($to)) return false;
        // list item is the parent of the gap cursor instead of grandparent
        const isGapCursorSelection = ref instanceof (0, $j7pt0.GapCursorSelection);
        const wrapperListItem = isGapCursorSelection ? $from.parent : $from.node(-1);
        if (wrapperListItem.type !== itemType) return false;
        /** --> The following line changed from the original PM implementation to allow list additions with multiple paragraphs */ if (// eslint-disable-next-line @typescript-eslint/no-explicit-any
        wrapperListItem.content.content.length <= 1 && $from.parent.content.size === 0 && !(wrapperListItem.content.size === 0)) {
            // In an empty block. If this is a nested list, the wrapping
            // list item should be split. Otherwise, bail out and let next
            // command handle lifting.
            if ($from.depth === 2 || $from.node(-3).type !== itemType || $from.index(-2) !== $from.node(-2).childCount - 1) return false;
            if (dispatch) {
                let wrap = (0, $kW8qW.Fragment).empty;
                const keepItem = $from.index(-1) > 0;
                // Build a fragment containing empty versions of the structure
                // from the outer list item to the parent node of the cursor
                for(let d = $from.depth - (keepItem ? 1 : 2); d >= $from.depth - 3; d--)wrap = (0, $kW8qW.Fragment).from($from.node(d).copy(wrap));
                // Add a second list item with an empty default start node
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                wrap = wrap.append((0, $kW8qW.Fragment).from(itemType.createAndFill()));
                const tr$1 = state.tr.replace($from.before(keepItem ? undefined : -1), $from.after(-3), new (0, $kW8qW.Slice)(wrap, keepItem ? 3 : 2, 2));
                tr$1.setSelection(// eslint-disable-next-line @typescript-eslint/no-explicit-any
                state.selection.constructor.near(tr$1.doc.resolve($from.pos + (keepItem ? 3 : 2))));
                dispatch(tr$1.scrollIntoView());
            }
            return true;
        }
        const nextType = $to.pos === $from.end() ? wrapperListItem.contentMatchAt(0).defaultType : null;
        const tr = state.tr.delete($from.pos, $to.pos);
        const types = nextType && [
            null,
            {
                type: nextType
            }
        ];
        const fontSize = state.schema.marks.fontSize;
        const isFontSizeSupported = fontSize;
        const currentFontSizeAttrs = isFontSizeSupported ? (0, $k3wEw.getBlockMarkAttrs)($from.parent, fontSize) : false;
        if (dispatch) {
            var _$from$nodeBefore;
            if (ref instanceof (0, $cw0wu.TextSelection)) {
                const splitTr = tr.split($from.pos, 2, types ?? undefined);
                if (isFontSizeSupported) (0, $k3wEw.reconcileBlockMarkForParagraphAtPos)(splitTr, splitTr.selection.from, fontSize, currentFontSizeAttrs);
                dispatch(splitTr.scrollIntoView());
                return true;
            }
            // create new list item with empty paragraph when user clicks enter on gap cursor
            if (isGapCursorSelection && (_$from$nodeBefore = $from.nodeBefore) !== null && _$from$nodeBefore !== void 0 && _$from$nodeBefore.isBlock) {
                // For gap cursor selection, we cannot split the list item directly
                // We need to insert a new list item after the current list item to simulate the split behaviour
                const { listItem: listItem, paragraph: paragraph } = state.schema.nodes;
                const newListItem = listItem.createChecked({}, paragraph.createChecked({}, undefined, currentFontSizeAttrs && isFontSizeSupported ? [
                    fontSize.create(currentFontSizeAttrs)
                ] : undefined));
                dispatch(tr.insert($from.pos, newListItem).setSelection((0, $cw0wu.Selection).near(tr.doc.resolve($to.pos + 1))).scrollIntoView());
                return true;
            }
        }
        return false;
    };
}
const $0f1e0d8c1b7e87a3$var$deletePreviousEmptyListItem = (state, dispatch)=>{
    const { $from: $from } = state.selection;
    const { listItem: listItem } = state.schema.nodes;
    const $cut = (0, $bq0hv.findCutBefore)($from);
    if (!$cut || !$cut.nodeBefore || !($cut.nodeBefore.type === listItem)) return false;
    const nodeBeforeIsExtension = $cut.nodeBefore.firstChild && $cut.nodeBefore.firstChild.type.name === 'extension';
    const previousListItemEmpty = // Ignored via go/ees005
    $cut.nodeBefore.childCount === 1 && $cut.nodeBefore.firstChild && $cut.nodeBefore.firstChild.nodeSize <= 2 && !nodeBeforeIsExtension;
    if (previousListItemEmpty) {
        const { tr: tr } = state;
        if (dispatch) dispatch(tr.delete($cut.pos - $cut.nodeBefore.nodeSize, $from.pos).scrollIntoView());
        return true;
    }
    return false;
};
const $0f1e0d8c1b7e87a3$var$joinToPreviousListItem = (state, dispatch)=>{
    const { $from: $from } = state.selection;
    const { paragraph: paragraph, listItem: listItem, codeBlock: codeBlock, bulletList: bulletList, orderedList: orderedList } = state.schema.nodes;
    const { fontSize: fontSize } = state.schema.marks;
    const isGapCursorShown = state.selection instanceof (0, $j7pt0.GapCursorSelection);
    const $cutPos = isGapCursorShown ? state.doc.resolve($from.pos + 1) : $from;
    const $cut = (0, $bq0hv.findCutBefore)($cutPos);
    if (!$cut) return false;
    // see if the containing node is a list
    if ($cut.nodeBefore && [
        bulletList,
        orderedList
    ].indexOf($cut.nodeBefore.type) > -1) // and the node after this is a paragraph or a codeBlock
    {
        if ($cut.nodeAfter && ($cut.nodeAfter.type === paragraph || $cut.nodeAfter.type === codeBlock)) {
            // find the nearest paragraph that precedes this node
            let $lastNode = $cut.doc.resolve($cut.pos - 1);
            while($lastNode.parent.type !== paragraph && $lastNode.pos > 1)$lastNode = state.doc.resolve($lastNode.pos - 1);
            let { tr: tr } = state;
            if (isGapCursorShown) {
                const nodeBeforePos = (0, $gab48.findPositionOfNodeBefore)(tr.selection);
                if (typeof nodeBeforePos !== 'number') return false;
                // breakout marks are not valid inside a listItem
                const { breakout: breakout } = state.schema.marks;
                const nodeToNest = breakout && (0, $3y2s4.isExperimentEnabled)('platform_editor_list_join_strip_breakout') ? $cut.nodeAfter.mark(breakout.removeFromSet($cut.nodeAfter.marks)) : $cut.nodeAfter;
                // append the codeblock to the list node
                const list = $cut.nodeBefore.copy($cut.nodeBefore.content.append((0, $kW8qW.Fragment).from(listItem.createChecked({}, nodeToNest))));
                tr.replaceWith(nodeBeforePos, $from.pos + $cut.nodeAfter.nodeSize, list);
            } else {
                const step = (0, $84BHs.moveTargetIntoList)({
                    insertPosition: $lastNode.pos,
                    $target: $cut
                });
                // ED-13966: check if the step will cause an ProseMirror error
                // if there's an error don't apply the step as it will might lead into a data loss.
                // It doesn't play well with media being a leaf node.
                const stepResult = state.tr.maybeStep(step);
                if (stepResult.failed) return false;
                else tr = state.tr.step(step);
            }
            // find out if there's now another list following and join them
            // as in, [list, p, list] => [list with p, list], and we want [joined list]
            const $postCut = tr.doc.resolve(tr.mapping.map($cut.pos + $cut.nodeAfter.nodeSize));
            if ($postCut.nodeBefore && $postCut.nodeAfter && $postCut.nodeBefore.type === $postCut.nodeAfter.type && [
                bulletList,
                orderedList
            ].indexOf($postCut.nodeBefore.type) > -1) tr = tr.join($postCut.pos);
            if (fontSize) {
                const prevListFontSizeAttrs = (0, $k3wEw.getFirstParagraphBlockMarkAttrs)($cut.nodeBefore, fontSize);
                const containingList = (0, $gab48.findParentNodeOfTypeClosestToPos)(tr.doc.resolve(tr.mapping.map($cut.pos)), [
                    bulletList,
                    orderedList
                ]);
                if (containingList) (0, $k3wEw.reconcileBlockMarkForContainerAtPos)(tr, containingList.pos, fontSize, prevListFontSizeAttrs);
            }
            if (dispatch) {
                var _tr$doc$resolve$nodeB;
                if (!((_tr$doc$resolve$nodeB = tr.doc.resolve($lastNode.pos).nodeBefore) !== null && _tr$doc$resolve$nodeB !== void 0 && _tr$doc$resolve$nodeB.isBlock) || tr.doc.resolve($lastNode.pos).nodeBefore === null) tr = tr.setSelection((0, $cw0wu.TextSelection).near(tr.doc.resolve(tr.mapping.map($cut.pos)), -1));
                dispatch(tr.scrollIntoView());
            }
            return true;
        }
    }
    return false;
};

});
parcelRegister("eWnvc", function(module, exports) {
$parcel$export(module.exports, "getCommonListAnalyticsAttributes", () => $52f2dc915c30c3e0$export$b4f9b2b8a958b87c);

var $iAUMu = parcelRequire("iAUMu");

var $S9Ran = parcelRequire("S9Ran");
const $52f2dc915c30c3e0$export$b4f9b2b8a958b87c = (tr)=>{
    const { selection: { $from: $from, $to: $to } } = tr;
    const fromAttrs = (0, $S9Ran.getListItemAttributes)($from);
    const toAttrs = (0, $S9Ran.getListItemAttributes)($to);
    return {
        itemIndexAtSelectionStart: fromAttrs.itemIndex,
        itemIndexAtSelectionEnd: toAttrs.itemIndex,
        indentLevelAtSelectionStart: fromAttrs.indentLevel,
        indentLevelAtSelectionEnd: toAttrs.indentLevel,
        itemsInSelection: (0, $iAUMu.countListItemsInSelection)(tr)
    };
};

});
parcelRegister("iAUMu", function(module, exports) {
$parcel$export(module.exports, "countListItemsInSelection", () => $d0962258621e3c68$export$c910df91212e45f2);

var $7nLBT = parcelRequire("7nLBT");
var $iE5F1 = parcelRequire("iE5F1");
const $d0962258621e3c68$export$c910df91212e45f2 = (tr)=>{
    const { from: from, to: to } = tr.selection;
    if (from === to) return 1;
    let count = 0;
    const listSlice = tr.doc.cut(from, to);
    listSlice.content.nodesBetween(0, listSlice.content.size, (node, pos, parent, index)=>{
        if (parent && (0, $7nLBT.isListItemNode)(parent) && !(0, $iE5F1.isListNode)(node) && index === 0) count++;
    });
    return count;
};

});

parcelRegister("S9Ran", function(module, exports) {
$parcel$export(module.exports, "getListItemAttributes", () => $3ce3cb3a3e6164e5$export$3f981ad265759e92);

var $gab48 = parcelRequire("gab48");

var $7nLBT = parcelRequire("7nLBT");

var $6uZQg = parcelRequire("6uZQg");
const $3ce3cb3a3e6164e5$export$3f981ad265759e92 = ($pos)=>{
    // Get level for the correct indent of nesting
    const indentLevel = (0, $6uZQg.numberNestedLists)($pos) - 1;
    const itemAtPos = (0, $gab48.findParentNodeClosestToPos)($pos, (0, $7nLBT.isListItemNode));
    // Get the index of the current item relative to parent (parent is at item depth - 1)
    const itemIndex = $pos.index(itemAtPos ? itemAtPos.depth - 1 : undefined);
    return {
        indentLevel: indentLevel,
        itemIndex: itemIndex
    };
};

});
parcelRegister("6uZQg", function(module, exports) {
$parcel$export(module.exports, "numberNestedLists", () => $f03a335285a808c2$export$5fe3c994010aac53);

var $iE5F1 = parcelRequire("iE5F1");
const $f03a335285a808c2$export$5fe3c994010aac53 = (resolvedPos)=>{
    let count = 0;
    for(let i = resolvedPos.depth - 1; i > 0; i--){
        const node = resolvedPos.node(i);
        if ((0, $iE5F1.isListNode)(node)) count += 1;
    }
    return count;
};

});



parcelRegister("k3wEw", function(module, exports) {
$parcel$export(module.exports, "getBlockMarkAttrs", () => $793f90f89dc42c2f$export$9e2e0ba9b4a3aaa9);
$parcel$export(module.exports, "getFirstParagraphBlockMarkAttrs", () => $793f90f89dc42c2f$export$1b9361dde62c5ad5);
$parcel$export(module.exports, "reconcileBlockMarkInRange", () => $793f90f89dc42c2f$export$d2e4d08c8ba1d788);
$parcel$export(module.exports, "reconcileBlockMarkForContainerAtPos", () => $793f90f89dc42c2f$export$6ea2388618f50d4a);
$parcel$export(module.exports, "reconcileBlockMarkForParagraphAtPos", () => $793f90f89dc42c2f$export$eb81f7a0535d3440);

var $bq0hv = parcelRequire("bq0hv");
const $793f90f89dc42c2f$var$getDefaultBlockNodeTypes = (tr)=>{
    const { paragraph: paragraph } = tr.doc.type.schema.nodes;
    return paragraph ? [
        paragraph
    ] : [];
};
const $793f90f89dc42c2f$export$9e2e0ba9b4a3aaa9 = (node, markType)=>{
    if (!node || !markType) return false;
    const blockMark = node.marks.find((mark)=>mark.type === markType);
    return blockMark ? blockMark.attrs : false;
};
const $793f90f89dc42c2f$export$1b9361dde62c5ad5 = (node, markType)=>{
    if (!node || !markType) return false;
    const { paragraph: paragraph } = node.type.schema.nodes;
    if (!paragraph) return false;
    const findFirstParagraphBlockMarkAttrs = (currentNode)=>{
        if (currentNode.type === paragraph) return $793f90f89dc42c2f$export$9e2e0ba9b4a3aaa9(currentNode, markType);
        for(let index = 0; index < currentNode.childCount; index++){
            const childResult = findFirstParagraphBlockMarkAttrs(currentNode.child(index));
            if (childResult !== false) return childResult;
        }
        return false;
    };
    return findFirstParagraphBlockMarkAttrs(node);
};
const $793f90f89dc42c2f$export$d2e4d08c8ba1d788 = (tr, from, to, markType, markAttrs, blockNodeTypes = $793f90f89dc42c2f$var$getDefaultBlockNodeTypes(tr))=>{
    if (!markType || blockNodeTypes.length === 0) return false;
    return (0, $bq0hv.createToggleBlockMarkOnRangeNext)(markType, ()=>markAttrs, blockNodeTypes)(from, to, tr);
};
const $793f90f89dc42c2f$export$6ea2388618f50d4a = (tr, containerPos, markType, markAttrs, blockNodeTypes = $793f90f89dc42c2f$var$getDefaultBlockNodeTypes(tr))=>{
    const containerNode = tr.doc.nodeAt(containerPos);
    if (!containerNode) return false;
    return $793f90f89dc42c2f$export$d2e4d08c8ba1d788(tr, containerPos, containerPos + containerNode.nodeSize, markType, markAttrs, blockNodeTypes);
};
const $793f90f89dc42c2f$export$eb81f7a0535d3440 = (tr, pos, markType, markAttrs)=>{
    const { paragraph: paragraph } = tr.doc.type.schema.nodes;
    if (!paragraph) return false;
    const resolvedPos = tr.doc.resolve(Math.max(0, Math.min(pos, tr.doc.content.size)));
    for(let depth = resolvedPos.depth; depth > 0; depth--){
        const node = resolvedPos.node(depth);
        if (node.type === paragraph) return $793f90f89dc42c2f$export$d2e4d08c8ba1d788(tr, resolvedPos.before(depth), resolvedPos.before(depth) + node.nodeSize, markType, markAttrs, [
            paragraph
        ]);
    }
    return false;
};

});

parcelRegister("84BHs", function(module, exports) {
$parcel$export(module.exports, "moveTargetIntoList", () => $7bf01b8e1c9f02f3$export$cbf2f67c120cb8dd);

var $3DNV7 = parcelRequire("3DNV7");
const $7bf01b8e1c9f02f3$export$cbf2f67c120cb8dd = ({ insertPosition: insertPosition, $target: $target })=>{
    var _$target$nodeAfter;
    // take the text content of the paragraph and insert after the paragraph up until before the the cut
    const from = insertPosition;
    const to = $target.pos + (((_$target$nodeAfter = $target.nodeAfter) === null || _$target$nodeAfter === void 0 ? void 0 : _$target$nodeAfter.nodeSize) || 0); //$cut.pos + $cut.nodeAfter.nodeSize;
    const gapFrom = $target.posAtIndex(0, $target.depth + 1); // start pos of the child
    const gapTo = $target.doc.resolve(gapFrom).end(); // end pos of the paragraph
    if (gapTo - gapFrom === 0) return new (0, $3DNV7.ReplaceStep)(from, to, $target.doc.slice(insertPosition, $target.pos));
    const step = new (0, $3DNV7.ReplaceAroundStep)(from, to, gapFrom, gapTo, $target.doc.slice(insertPosition, $target.pos), 0, true);
    return step;
};

});

parcelRegister("a0y81", function(module, exports) {
$parcel$export(module.exports, "convertListType", () => $94c5c5544615efab$export$193e29566e093d19);

var $am7wa = parcelRequire("am7wa");

var $j7pt0 = parcelRequire("j7pt0");
parcelRequire("56AB9");
var $24xJB = parcelRequire("24xJB");
var $iE5F1 = parcelRequire("iE5F1");

var $kW8qW = parcelRequire("kW8qW");

var $cw0wu = parcelRequire("cw0wu");

var $3DNV7 = parcelRequire("3DNV7");

var $gab48 = parcelRequire("gab48");

var $7uTIW = parcelRequire("7uTIW");
function $94c5c5544615efab$export$193e29566e093d19({ tr: tr, nextListNodeType: nextListNodeType }) {
    const { doc: doc, selection: { $from: $from, $to: $to } } = tr;
    let listRange;
    if (tr.selection instanceof (0, $j7pt0.GapCursorSelection)) {
        var _$from$nodeAfter;
        const nodeSize = ((_$from$nodeAfter = $from.nodeAfter) === null || _$from$nodeAfter === void 0 ? void 0 : _$from$nodeAfter.nodeSize) || 1;
        listRange = $from.blockRange($from.doc.resolve($from.pos + nodeSize));
    } else listRange = $from.blockRange($to, (0, $iE5F1.isListNode));
    if (listRange) return $94c5c5544615efab$var$convertSelectedList({
        tr: tr,
        nextListNodeType: nextListNodeType
    });
    const nodeRangeAroundList = $from.blockRange($to);
    if (!nodeRangeAroundList) return;
    const parentNode = nodeRangeAroundList.parent;
    const { startIndex: startIndex, endIndex: endIndex, depth: depth } = nodeRangeAroundList;
    // Checking for invalid nodes to prevent conversion
    // eg. a panel cannot be wrapped in a list so return
    // It will skip this check if the selection begins within a list
    // This is to match the behaviour of the toolbar buttons being disabled
    if (!(0, $7uTIW.findFirstParentListNode)($from)) for(let i = startIndex; i < endIndex; i++){
        const position = nodeRangeAroundList.$from.posAtIndex(i, depth);
        const resolvedPosition = doc.resolve(position);
        const currentChild = parentNode.child(i);
        const currentNodeRange = resolvedPosition.blockRange(tr.doc.resolve(position + currentChild.nodeSize));
        if (currentNodeRange && !(0, $iE5F1.isListNode)(currentChild) && !(0, $3DNV7.findWrapping)(currentNodeRange, nextListNodeType)) return;
    }
    // Checking for any non list nodes and wrapping them in a list
    // so they can be converted
    tr.doc.nodesBetween(nodeRangeAroundList.start, nodeRangeAroundList.end, (node, pos)=>{
        // Skip over any nodes that are part of a list
        if ((0, $7uTIW.findFirstParentListNode)(tr.doc.resolve(tr.mapping.map(pos)))) return false;
        // The following applies to suitable nodes that are not within a list
        const currentNodeNotWrappedInList = node;
        const isNotAnEmptyParagraphAndIsParagraphOrLeafNode = !(0, $24xJB.isEmptyParagraph)(currentNodeNotWrappedInList) && (!node.type.isBlock || node.type.name === 'paragraph');
        if (isNotAnEmptyParagraphAndIsParagraphOrLeafNode && nodeRangeAroundList) {
            const remainingNodeRange = new (0, $kW8qW.NodeRange)(tr.doc.resolve(tr.mapping.map(pos)), tr.doc.resolve(tr.mapping.map(pos) + currentNodeNotWrappedInList.nodeSize), nodeRangeAroundList.depth);
            $94c5c5544615efab$var$convertAroundList({
                tr: tr,
                nextListNodeType: nextListNodeType,
                nodeRange: remainingNodeRange
            });
            return false;
        }
    });
    $94c5c5544615efab$var$convertSelectedList({
        tr: tr,
        nextListNodeType: nextListNodeType
    });
    if (tr.docChanged) (0, $am7wa.joinSiblingLists)({
        tr: tr,
        forceListType: nextListNodeType
    });
}
const $94c5c5544615efab$var$convertSelectedList = ({ tr: tr, nextListNodeType: nextListNodeType })=>{
    const { selection: selection, selection: { from: from, to: to } } = tr;
    const { codeBlock: codeBlock } = tr.doc.type.schema.nodes;
    // get the positions of all the leaf nodes within the selection
    const nodePositions = [];
    if (selection instanceof (0, $cw0wu.TextSelection) && selection.$cursor || selection instanceof (0, $j7pt0.GapCursorSelection)) nodePositions.push(from);
    else // nodesBetween doesn't return leaf nodes that are outside of from and to
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        // isLeaf is false for empty codeBlock so adding additional check for childCount
        if (!node.isLeaf && !(node.type === codeBlock && node.childCount === 0)) return true;
        nodePositions.push(pos);
    });
    // use those positions to get the closest parent list nodes
    nodePositions.reduce((acc, pos)=>{
        const closestParentListNode = (0, $gab48.findParentNodeClosestToPos)(tr.doc.resolve(pos), (0, $iE5F1.isListNode));
        if (!closestParentListNode) return acc;
        // don't add duplicates if the parent has already been added into the array
        const existingParent = acc.find((node)=>{
            return node.pos === closestParentListNode.pos && node.start === closestParentListNode.start && node.depth === closestParentListNode.depth;
        });
        if (!existingParent) acc.push(closestParentListNode);
        return acc;
    }, []).forEach((item)=>{
        tr.setNodeMarkup(item.pos, nextListNodeType);
    });
};
const $94c5c5544615efab$var$convertAroundList = ({ tr: tr, nextListNodeType: nextListNodeType, nodeRange: nodeRange })=>{
    for(let i = nodeRange.endIndex - 1; i >= nodeRange.startIndex; i--){
        const position = nodeRange.$from.posAtIndex(i, nodeRange.depth);
        const resolvedPos = tr.doc.resolve(position + 1);
        const range = resolvedPos.blockRange(resolvedPos);
        if (!range) return;
        const wrappings = (0, $3DNV7.findWrapping)(range, nextListNodeType);
        if (!range || !wrappings) return;
        tr.wrap(range, wrappings);
    }
};

});
parcelRegister("am7wa", function(module, exports) {
$parcel$export(module.exports, "joinSiblingLists", () => $80e626f7b88dc05a$export$e400d0e3efb40bf0);

var $7nLBT = parcelRequire("7nLBT");
var $iE5F1 = parcelRequire("iE5F1");

var $bwZZE = parcelRequire("bwZZE");

var $l6xJW = parcelRequire("l6xJW");
const $80e626f7b88dc05a$export$e400d0e3efb40bf0 = ({ tr: tr, direction: direction, forceListType: forceListType })=>{
    const result = {
        orderedList: 0,
        bulletList: 0
    };
    const { doc: doc, selection: { $from: $from, $to: $to }, selection: selection } = tr;
    const range = $from.blockRange($to, (0, $bwZZE.isListNodeValidContent));
    if (!range) return result;
    const rootListNode = doc.nodeAt(range.start);
    const from = (0, $iE5F1.isListNode)(rootListNode) ? range.start : 0;
    const to = (0, $iE5F1.isListNode)(rootListNode) ? range.end : tr.doc.content.size;
    const joins = [];
    doc.nodesBetween(from, to, (node, pos, parent)=>{
        const resolvedPos = doc.resolve(pos);
        const { nodeBefore: nodeBefore, nodeAfter: nodeAfter } = resolvedPos;
        if (!nodeBefore || !nodeAfter || !(0, $iE5F1.isListNode)(nodeBefore) || !(0, $iE5F1.isListNode)(nodeAfter)) return;
        const isNestedList = (0, $7nLBT.isListItemNode)(parent);
        if (!isNestedList && nodeBefore.type !== nodeAfter.type && !forceListType) return;
        const index = resolvedPos.index();
        const positionPreviousNode = resolvedPos.posAtIndex(index - 1);
        const positionCurrentNode = resolvedPos.posAtIndex(index);
        // If the previous node is part of the selection, OR
        // If the previous node is not part of the selection and the previous node has the same list type that we’re converting to
        const joinBefore = positionPreviousNode >= from || nodeBefore.type === forceListType;
        if (forceListType) {
            if (joinBefore) tr.setNodeMarkup(positionPreviousNode, forceListType);
            tr.setNodeMarkup(positionCurrentNode, forceListType);
        }
        if (isNestedList && nodeBefore.type !== nodeAfter.type) {
            const nodeType = direction === (0, $l6xJW.JoinDirection).RIGHT ? nodeAfter.type : nodeBefore.type;
            tr.setNodeMarkup(positionPreviousNode, nodeType);
        }
        if (joinBefore) joins.push(pos);
    });
    if (selection.empty && rootListNode && (0, $iE5F1.isListNode)(rootListNode)) {
        const resolvedPos = doc.resolve(range.start + rootListNode.nodeSize);
        const { nodeBefore: nodeBefore, nodeAfter: nodeAfter } = resolvedPos;
        if (nodeBefore && nodeAfter && (0, $iE5F1.isListNode)(nodeBefore) && (0, $iE5F1.isListNode)(nodeAfter) && nodeAfter.type === nodeBefore.type) joins.push(resolvedPos.pos);
    }
    for(let i = joins.length - 1; i >= 0; i--){
        const listNode = tr.doc.nodeAt(joins[i]);
        const listName = listNode === null || listNode === void 0 ? void 0 : listNode.type.name;
        if (listName && (listName === 'orderedList' || listName === 'bulletList')) {
            const amount = result[listName] || 0;
            result[listName] = amount + 1;
        }
        tr.join(joins[i]);
    }
    return result;
};

});
parcelRegister("bwZZE", function(module, exports) {
$parcel$export(module.exports, "isListNodeValidContent", () => $aad775cc965b5170$export$b1e4478495976768);

var $kW8qW = parcelRequire("kW8qW");

var $7nLBT = parcelRequire("7nLBT");
function $aad775cc965b5170$export$b1e4478495976768(node) {
    const { bulletList: bulletList } = node.type.schema.nodes;
    if (!bulletList) return false;
    const listFragment = (0, $kW8qW.Fragment).from(bulletList.createAndFill());
    return !(0, $7nLBT.isListItemNode)(node) && node.type.validContent(listFragment);
}

});

parcelRegister("l6xJW", function(module, exports) {
$parcel$export(module.exports, "JoinDirection", () => $dcb419d93ca0c70c$export$5e0de40a18047fef);
var $dcb419d93ca0c70c$export$5e0de40a18047fef = /*#__PURE__*/ function(JoinDirection) {
    JoinDirection[JoinDirection["LEFT"] = 1] = "LEFT";
    JoinDirection[JoinDirection["RIGHT"] = -1] = "RIGHT";
    return JoinDirection;
}({});

});


parcelRegister("7uTIW", function(module, exports) {
$parcel$export(module.exports, "findFirstParentListNode", () => $70cdafe9875f2d2e$export$cd0bf0d386a8d5a7);
$parcel$export(module.exports, "findRootParentListNode", () => $70cdafe9875f2d2e$export$cd55a6653375f672);

var $7nLBT = parcelRequire("7nLBT");
var $iE5F1 = parcelRequire("iE5F1");

var $gab48 = parcelRequire("gab48");
function $70cdafe9875f2d2e$export$cd0bf0d386a8d5a7($pos) {
    const currentNode = $pos.doc.nodeAt($pos.pos);
    let listNodePosition = null;
    if ((0, $iE5F1.isListNode)(currentNode)) listNodePosition = $pos.pos;
    else {
        const result = (0, $gab48.findParentNodeClosestToPos)($pos, (0, $iE5F1.isListNode));
        listNodePosition = result && result.pos;
    }
    if (listNodePosition == null) return null;
    const node = $pos.doc.nodeAt(listNodePosition);
    if (!node) return null;
    return {
        node: node,
        pos: listNodePosition
    };
}
const $70cdafe9875f2d2e$export$cd55a6653375f672 = ($pos)=>{
    const { doc: doc } = $pos;
    if ($pos.pos + 1 > doc.content.size) return null;
    if ($pos.depth === 0) return doc.resolve($pos.pos + 1);
    const currentNode = doc.nodeAt($pos.pos);
    const beforePosition = $pos.before();
    const nodeBefore = doc.nodeAt(beforePosition);
    if ((0, $iE5F1.isListNode)(currentNode) && !(0, $7nLBT.isListItemNode)(nodeBefore)) return doc.resolve($pos.pos + 1);
    const parentList = (0, $gab48.findParentNodeClosestToPos)($pos, (0, $iE5F1.isListNode));
    if (!parentList) return null;
    const listNodePosition = doc.resolve(parentList.pos);
    return $70cdafe9875f2d2e$export$cd55a6653375f672(listNodePosition);
};

});


parcelRegister("8SO3W", function(module, exports) {
$parcel$export(module.exports, "wrapInListAndJoin", () => $f69c7dec7a136255$export$dc4f1f9730c3e037);

var $j7pt0 = parcelRequire("j7pt0");

var $9v2LJ = parcelRequire("9v2LJ");

var $kW8qW = parcelRequire("kW8qW");

var $3DNV7 = parcelRequire("3DNV7");

var $9fsJn = parcelRequire("9fsJn");
function $f69c7dec7a136255$export$dc4f1f9730c3e037(nodeType, tr) {
    $f69c7dec7a136255$export$a8aef45c6262afee(nodeType)(tr);
    (0, $9v2LJ.autoJoinTr)(tr, (before, after)=>before.type === after.type && before.type === nodeType);
}
function $f69c7dec7a136255$export$a8aef45c6262afee(listType, attrs) {
    return function(tr) {
        const { $from: $from, $to: $to } = tr.selection;
        let range;
        if (tr.selection instanceof (0, $j7pt0.GapCursorSelection) && $from.nodeAfter && (0, $9fsJn.isWrappingPossible)(listType, tr.selection)) {
            const nodeSize = $from.nodeAfter.nodeSize || 1;
            range = $from.blockRange($from.doc.resolve($from.pos + nodeSize));
        } else range = $from.blockRange($to);
        let doJoin = false;
        let outerRange = range;
        if (!range) return false;
        // This is at the top of an existing list item
        if (range.depth >= 2 && $from.node(range.depth - 1).type.compatibleContent(listType) && range.startIndex === 0) {
            // Don't do anything if this is the top of the list
            if ($from.index(range.depth - 1) === 0) return false;
            const $insert = tr.doc.resolve(range.start - 2);
            outerRange = new (0, $kW8qW.NodeRange)($insert, $insert, range.depth);
            if (range.endIndex < range.parent.childCount) range = new (0, $kW8qW.NodeRange)($from, tr.doc.resolve($to.end(range.depth)), range.depth);
            doJoin = true;
        }
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const wrap = (0, $3DNV7.findWrapping)(outerRange, listType, attrs, range);
        if (!wrap) return false;
        tr = $f69c7dec7a136255$var$doWrapInList(tr, range, wrap, doJoin, listType);
        return true;
    };
}
/**
 * Internal function used by wrapInList
 *
 * Adapted from https://github.com/ProseMirror/prosemirror-schema-list/blob/master/src/schema-list.js#L91-L112
 */ function $f69c7dec7a136255$var$doWrapInList(tr, range, wrappers, joinBefore, listType) {
    let content = (0, $kW8qW.Fragment).empty;
    for(let i = wrappers.length - 1; i >= 0; i--)content = (0, $kW8qW.Fragment).from(wrappers[i].type.create(wrappers[i].attrs, content));
    tr.step(new (0, $3DNV7.ReplaceAroundStep)(range.start - (joinBefore ? 2 : 0), range.end, range.start, range.end, new (0, $kW8qW.Slice)(content, 0, 0), wrappers.length, true));
    let found = 0;
    for(let i = 0; i < wrappers.length; i++)if (wrappers[i].type === listType) found = i + 1;
    const splitDepth = wrappers.length - found;
    let splitPos = range.start + wrappers.length - (joinBefore ? 2 : 0);
    const parent = range.parent;
    for(let i = range.startIndex, e = range.endIndex, first = true; i < e; i++, first = false){
        if (!first && (0, $3DNV7.canSplit)(tr.doc, splitPos, splitDepth)) {
            // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
            tr.split(splitPos, splitDepth);
            splitPos += 2 * splitDepth;
        }
        splitPos += parent.child(i).nodeSize;
    }
    return tr;
}

});
parcelRegister("9fsJn", function(module, exports) {
$parcel$export(module.exports, "isPosInsideParagraph", () => $3f7355e4ea5a8e1b$export$27bb641e25fad24d);
$parcel$export(module.exports, "isPosInsideList", () => $3f7355e4ea5a8e1b$export$4639440f68939b8a);
$parcel$export(module.exports, "isWrappingPossible", () => $3f7355e4ea5a8e1b$export$af251811cd857645);
$parcel$export(module.exports, "isInsideListItem", () => $3f7355e4ea5a8e1b$export$fd64e4ef922c42f3);
$parcel$export(module.exports, "isInsideTableCell", () => $3f7355e4ea5a8e1b$export$cb2b92f281f91c40);
$parcel$export(module.exports, "canJoinToPreviousListItem", () => $3f7355e4ea5a8e1b$export$6ec51e240036c4ab);
$parcel$export(module.exports, "selectionContainsList", () => $3f7355e4ea5a8e1b$export$f0dda2b070101c76);

var $j7pt0 = parcelRequire("j7pt0");

var $7nLBT = parcelRequire("7nLBT");
var $iE5F1 = parcelRequire("iE5F1");
var $4Dhpb = parcelRequire("4Dhpb");

var $3DNV7 = parcelRequire("3DNV7");

var $gab48 = parcelRequire("gab48");
const $3f7355e4ea5a8e1b$export$27bb641e25fad24d = ($pos)=>{
    return $pos.parent.type.name === 'paragraph';
};
const $3f7355e4ea5a8e1b$export$4639440f68939b8a = ($pos)=>{
    const posGrandParent = $pos.node(-1);
    return (0, $7nLBT.isListItemNode)($pos.parent) || (0, $iE5F1.isListNode)($pos.parent) || (0, $7nLBT.isListItemNode)(posGrandParent);
};
const $3f7355e4ea5a8e1b$export$af251811cd857645 = (nodeType, selection)=>{
    const { $from: $from, $to: $to } = selection;
    let range;
    if (selection instanceof (0, $j7pt0.GapCursorSelection) && $from.nodeAfter) {
        const nodeSize = $from.nodeAfter.nodeSize || 1;
        range = $from.blockRange($from.doc.resolve($from.pos + nodeSize));
    } else range = $from.blockRange($to);
    if (!range) return false;
    const wrap = (0, $3DNV7.findWrapping)(range, nodeType);
    if (!wrap) return false;
    return true;
};
const $3f7355e4ea5a8e1b$export$fd64e4ef922c42f3 = (tr)=>{
    const { parent: parent } = tr.selection.$from;
    const { listItem: listItem } = tr.doc.type.schema.nodes;
    if (tr.selection instanceof (0, $j7pt0.GapCursorSelection)) return (0, $7nLBT.isListItemNode)(parent);
    return (0, $gab48.hasParentNodeOfType)(listItem)(tr.selection) && (0, $4Dhpb.isParagraphNode)(parent);
};
const $3f7355e4ea5a8e1b$export$cb2b92f281f91c40 = (tr)=>{
    const { tableCell: tableCell, tableHeader: tableHeader } = tr.doc.type.schema.nodes;
    return !!(0, $gab48.findParentNodeOfType)([
        tableCell,
        tableHeader
    ])(tr.selection);
};
const $3f7355e4ea5a8e1b$export$6ec51e240036c4ab = (tr)=>{
    const { $from: $from } = tr.selection;
    const $before = tr.doc.resolve($from.pos - 1);
    let nodeBefore = $before ? $before.nodeBefore : null;
    if (tr.selection instanceof (0, $j7pt0.GapCursorSelection)) nodeBefore = $from.nodeBefore;
    return (0, $iE5F1.isListNode)(nodeBefore);
};
const $3f7355e4ea5a8e1b$export$f0dda2b070101c76 = (tr)=>{
    const { selection: { from: from, to: to } } = tr;
    let foundListNode = null;
    tr.doc.nodesBetween(from, to, (node)=>{
        if ((0, $iE5F1.isListNode)(node)) foundListNode = node;
        if (foundListNode) return false;
        return true;
    });
    return foundListNode;
};

});


parcelRegister("kWmG3", function(module, exports) {
$parcel$export(module.exports, "liftFollowingList", () => $ec587c52d530749d$export$4ed538bc5a7d756f);
$parcel$export(module.exports, "liftNodeSelectionList", () => $ec587c52d530749d$export$2b630c4fa336fee7);
$parcel$export(module.exports, "liftTextSelectionList", () => $ec587c52d530749d$export$a88bd9b6e3aac8d6);
$parcel$export(module.exports, "applyListNormalisationFixes", () => $ec587c52d530749d$export$da6cb9e5038a61a);

var $iE5F1 = parcelRequire("iE5F1");

var $kW8qW = parcelRequire("kW8qW");

var $cw0wu = parcelRequire("cw0wu");

var $3DNV7 = parcelRequire("3DNV7");

var $eYGgE = parcelRequire("eYGgE");
function $ec587c52d530749d$var$liftListItem(selection, tr) {
    const { $from: $from, $to: $to } = selection;
    const nodeType = tr.doc.type.schema.nodes.listItem;
    let range = $from.blockRange($to, (node)=>!!node.childCount && !!node.firstChild && node.firstChild.type === nodeType);
    if (!range || range.depth < 2 || $from.node(range.depth - 1).type !== nodeType) return tr;
    const end = range.end;
    const endOfList = $to.end(range.depth);
    if (end < endOfList) {
        tr.step(new (0, $3DNV7.ReplaceAroundStep)(end - 1, endOfList, end, endOfList, new (0, $kW8qW.Slice)((0, $kW8qW.Fragment).from(nodeType.create(undefined, range.parent.copy())), 1, 0), 1, true));
        range = new (0, $kW8qW.NodeRange)(tr.doc.resolve($from.pos), tr.doc.resolve(endOfList), range.depth);
    }
    return tr.lift(range, (0, $3DNV7.liftTarget)(range)).scrollIntoView();
}
function $ec587c52d530749d$export$4ed538bc5a7d756f(from, to, rootListDepth, tr) {
    const { listItem: listItem } = tr.doc.type.schema.nodes;
    let lifted = false;
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        if (!lifted && node.type === listItem && pos > from) {
            lifted = true;
            let listDepth = rootListDepth + 3;
            while(listDepth > rootListDepth + 2){
                const start = tr.doc.resolve(tr.mapping.map(pos));
                listDepth = start.depth;
                const end = tr.doc.resolve(tr.mapping.map(pos + node.textContent.length));
                const sel = new (0, $cw0wu.TextSelection)(start, end);
                tr = $ec587c52d530749d$var$liftListItem(sel, tr);
            }
        }
    });
    return tr;
}
function $ec587c52d530749d$export$2b630c4fa336fee7(selection, tr) {
    const { from: from } = selection;
    const { listItem: listItem } = tr.doc.type.schema.nodes;
    const mappedPosition = tr.mapping.map(from);
    const nodeAtPos = tr.doc.nodeAt(mappedPosition);
    const start = tr.doc.resolve(mappedPosition);
    if ((start === null || start === void 0 ? void 0 : start.parent.type) !== listItem) return tr;
    const end = tr.doc.resolve(mappedPosition + ((nodeAtPos === null || nodeAtPos === void 0 ? void 0 : nodeAtPos.nodeSize) || 1));
    const range = start.blockRange(end);
    if (range) {
        const liftTarget = (0, $eYGgE.getListLiftTarget)(start);
        tr.lift(range, liftTarget);
    }
    return tr;
}
function $ec587c52d530749d$export$a88bd9b6e3aac8d6(selection, tr) {
    const { from: from, to: to } = selection;
    const { paragraph: paragraph } = tr.doc.type.schema.nodes;
    const listCol = [];
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        if (node.type === paragraph) listCol.push({
            node: node,
            pos: pos
        });
    });
    for(let i = listCol.length - 1; i >= 0; i--){
        const paragraph = listCol[i];
        const start = tr.doc.resolve(tr.mapping.map(paragraph.pos));
        if (start.depth > 0) {
            let end;
            if (paragraph.node.textContent && paragraph.node.textContent.length > 0) end = tr.doc.resolve(tr.mapping.map(paragraph.pos + paragraph.node.textContent.length));
            else end = tr.doc.resolve(tr.mapping.map(paragraph.pos + 1));
            const range = start.blockRange(end);
            if (range) tr.lift(range, (0, $eYGgE.getListLiftTarget)(start));
        }
    }
    return tr;
}
/**
 * Finds the top-level list nodes (bulletList/orderedList) that contain the positions
 * affected by the given transactions. Returns a map of list node position → list node,
 * so callers can scan only the affected subtrees rather than the entire document.
 */ function $ec587c52d530749d$var$getAffectedListsFromTransactions(transactions, doc, schema) {
    const { bulletList: bulletList, orderedList: orderedList } = schema.nodes;
    const listTypes = [
        bulletList,
        orderedList
    ].filter(Boolean);
    if (listTypes.length === 0) return new Map();
    const result = new Map();
    for (const tr of transactions)for (const step of tr.steps){
        // ReplaceStep and ReplaceAroundStep both have from/to — other step types are skipped.
        if (!(step instanceof (0, $3DNV7.ReplaceStep)) && !(step instanceof (0, $3DNV7.ReplaceAroundStep))) continue;
        // Check both the start and end of each changed range, mapped to post-transaction positions.
        for (const rawPos of [
            step.from,
            step.to
        ]){
            const mappedPos = Math.min(tr.mapping.map(rawPos), doc.content.size - 1);
            const $pos = doc.resolve(mappedPos);
            // Walk ancestors from inner to outer, recording the outermost list node.
            // Once we find a list and then exit list structure (hit a non-list ancestor),
            // break early — prevents container nodes (e.g. panel) from causing us to
            // return an outer list that is in a different structural context.
            // $pos.node(depth) is O(1) array access.
            let rootListPos = null;
            let rootListNode = null;
            for(let depth = $pos.depth; depth >= 0; depth--){
                const node = $pos.node(depth);
                if (listTypes.includes(node.type)) {
                    rootListPos = $pos.before(depth);
                    rootListNode = node;
                } else if (rootListNode !== null && node.type !== schema.nodes.listItem) break;
            }
            if (rootListPos !== null && rootListNode !== null) result.set(rootListPos, rootListNode);
        }
    }
    return result;
}
function $ec587c52d530749d$export$da6cb9e5038a61a({ tr: tr, transactions: transactions, doc: doc, schema: schema }) {
    const affectedLists = $ec587c52d530749d$var$getAffectedListsFromTransactions(transactions, doc, schema);
    if (affectedLists.size === 0) return tr;
    const { listItem: listItem } = schema.nodes;
    if (!listItem) return tr;
    // Process lists in reverse position order so fixes at higher positions
    // don't shift the positions of fixes at lower positions.
    const sortedEntries = [
        ...affectedLists.entries()
    ].sort(([posA], [posB])=>posB - posA);
    for (const [listPos] of sortedEntries){
        // Re-resolve the list node from the current transaction doc (post-paste state),
        // as the original listNode snapshot may be stale after the paste transaction.
        const mappedListPos = tr.mapping.map(listPos);
        const currentListNode = tr.doc.nodeAt(mappedListPos);
        if (!currentListNode) continue;
        // Collect all listItem positions at all depths in document order, then process in
        // reverse so that fixes at higher positions don't shift positions of lower ones.
        const listItemPositions = [];
        currentListNode.descendants((node, offsetPos)=>{
            if (node.type === listItem) listItemPositions.push(mappedListPos + 1 + offsetPos);
            return true;
        });
        for(let i = listItemPositions.length - 1; i >= 0; i--){
            const mappedPos = tr.mapping.map(listItemPositions[i]);
            const node = tr.doc.nodeAt(mappedPos);
            if (!node || node.type !== listItem) continue;
            // Merge adjacent same-type list nodes (highest boundary first within the listItem).
            for(let j = node.childCount - 1; j > 0; j--){
                const child = node.child(j);
                const prevChild = node.child(j - 1);
                if ((0, $iE5F1.isListNode)(child) && child.type === prevChild.type) {
                    let offset = 1; // +1 for listItem opening token
                    for(let k = 0; k < j; k++)offset += node.child(k).nodeSize;
                    try {
                        tr.join(mappedPos + offset);
                    } catch (e) {
                        // join may fail if position is invalid after earlier transforms — skip
                        // eslint-disable-next-line no-console
                        console.warn('[editor-plugin-list] applyListNormalisationFixes: unexpected join failure', e);
                    }
                }
            }
        }
    }
    return tr;
}

});
parcelRegister("eYGgE", function(module, exports) {
$parcel$export(module.exports, "getListLiftTarget", () => $39e8ab0a9be64a57$export$624f45cf4fef090e);

var $7nLBT = parcelRequire("7nLBT");
var $iE5F1 = parcelRequire("iE5F1");
const $39e8ab0a9be64a57$export$624f45cf4fef090e = (resPos)=>{
    let target = resPos.depth;
    for(let i = resPos.depth; i > 0; i--){
        const node = resPos.node(i);
        if ((0, $iE5F1.isListNode)(node)) target = i;
        if (!(0, $7nLBT.isListItemNode)(node) && !(0, $iE5F1.isListNode)(node)) break;
    }
    return target - 1;
};

});


parcelRegister("9Fhn4", function(module, exports) {
$parcel$export(module.exports, "sanitiseMarksInSelection", () => $060b94800e0f03df$export$bec007f49d03125c);
const $060b94800e0f03df$var$listContainerTypes = new Set([
    'bulletList',
    'orderedList'
]);
/**
 * When wrapping in a list, the paragraph's direct parent will be listItem,
 * not the list container itself. For fontSize marks, resolve to listItem
 * so mark compatibility is checked against the actual parent.
 */ const $060b94800e0f03df$var$resolveEffectiveParentType = (newParentType)=>{
    if (newParentType && $060b94800e0f03df$var$listContainerTypes.has(newParentType.name)) return newParentType.schema.nodes.listItem;
    return newParentType;
};
const $060b94800e0f03df$var$isMarkDisallowed = (mark, parent, effectiveParentType)=>!(parent !== null && parent !== void 0 && parent.type.allowsMarkType(mark.type)) || effectiveParentType && !effectiveParentType.allowsMarkType(mark.type);
const $060b94800e0f03df$export$bec007f49d03125c = (tr, newParentType)=>{
    const { from: from, to: to } = tr.selection;
    const nodesSanitized = [];
    tr.doc.nodesBetween(from, to, (node, pos, parent)=>{
        if (node.isText) return false;
        // Skip expands and layouts if they are outside selection
        // but continue to iterate over their children.
        if ([
            'expand',
            'layoutSection'
        ].includes(node.type.name) && (pos < from || pos > to)) return true;
        node.marks.forEach((mark)=>{
            const effectiveParentType = $060b94800e0f03df$var$resolveEffectiveParentType(newParentType);
            if ($060b94800e0f03df$var$isMarkDisallowed(mark, parent, effectiveParentType)) {
                const filteredMarks = node.marks.filter((m)=>m.type !== mark.type);
                const position = pos > 0 ? pos : 0;
                const marksRemoved = node.marks.filter((m)=>m.type === mark.type);
                nodesSanitized.push({
                    node: node,
                    marksRemoved: marksRemoved
                });
                tr.setNodeMarkup(position, undefined, node.attrs, filteredMarks);
            }
        });
    });
    return nodesSanitized;
};

});

parcelRegister("daVVV", function(module, exports) {
$parcel$export(module.exports, "isFirstChildOfParent", () => $c8632d53d4534e3e$export$1d357fa6aecde5b8);

var $j7pt0 = parcelRequire("j7pt0");
const $c8632d53d4534e3e$export$1d357fa6aecde5b8 = (state)=>{
    const { $from: $from } = state.selection;
    return $from.depth > 1 ? state.selection instanceof (0, $j7pt0.GapCursorSelection) && $from.parentOffset === 0 || $from.index($from.depth - 1) === 0 : true;
};

});

parcelRegister("7qb9c", function(module, exports) {
$parcel$export(module.exports, "joinListItemForward", () => $14d8a2b054629f48$export$6851baf5987dd2cb);

var $g6Qq4 = parcelRequire("g6Qq4");

var $gpVit = parcelRequire("gpVit");

var $h7zC7 = parcelRequire("h7zC7");

var $cw0wu = parcelRequire("cw0wu");

var $gab48 = parcelRequire("gab48");

var $cfxlP = parcelRequire("cfxlP");
const $14d8a2b054629f48$export$6851baf5987dd2cb = (editorAnalyticsAPI)=>(state, dispatch)=>{
        const { tr: tr, selection: { $head: $head } } = state;
        const walkNode = (0, $h7zC7.walkNextNode)($head);
        if (!(0, $h7zC7.isEmptySelectionAtEnd)(state)) return false;
        let interveningSyncBlockPos;
        // walkNextNode can skip leaf nodes because they have no resolvable content position.
        state.doc.nodesBetween($head.pos, walkNode.$pos.pos, (node, pos)=>{
            if (interveningSyncBlockPos === undefined && node.type.name === 'syncBlock') interveningSyncBlockPos = pos;
            return interveningSyncBlockPos === undefined;
        });
        if (interveningSyncBlockPos !== undefined) {
            if (dispatch) {
                const selection = (0, $cw0wu.NodeSelection).create(state.doc, interveningSyncBlockPos);
                dispatch(tr.setSelection(selection).scrollIntoView());
            }
            return true;
        }
        const scenarios = (0, $cfxlP.calcJoinListScenario)(walkNode, $head);
        if (!scenarios) return false;
        const [scenario, action] = scenarios;
        const result = action({
            tr: tr,
            $next: walkNode.$pos,
            $head: $head
        });
        if (!result) return false;
        const { bulletList: bulletList, orderedList: orderedList } = state.schema.nodes;
        const listParent = (0, $gab48.findParentNodeOfType)([
            bulletList,
            orderedList
        ])(tr.selection);
        let actionSubjectId = (0, $g6Qq4.ACTION_SUBJECT_ID).FORMAT_LIST_BULLET;
        if (listParent && listParent.node.type === orderedList) actionSubjectId = (0, $g6Qq4.ACTION_SUBJECT_ID).FORMAT_LIST_NUMBER;
        editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent({
            action: (0, $g6Qq4.ACTION).LIST_ITEM_JOINED,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).LIST,
            actionSubjectId: actionSubjectId,
            eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
            attributes: {
                inputMethod: (0, $g6Qq4.INPUT_METHOD).KEYBOARD,
                direction: (0, $gpVit.DELETE_DIRECTION).FORWARD,
                scenario: scenario
            }
        })(tr);
        if (dispatch) dispatch(tr);
        return true;
    };

});
parcelRegister("cfxlP", function(module, exports) {
$parcel$export(module.exports, "calcJoinListScenario", () => $aff2421e11506360$export$c60ae92c9826748a);

var $gpVit = parcelRequire("gpVit");

var $7nLBT = parcelRequire("7nLBT");
var $iE5F1 = parcelRequire("iE5F1");
var $4Dhpb = parcelRequire("4Dhpb");

var $9fsJn = parcelRequire("9fsJn");

var $cVttC = parcelRequire("cVttC");

var $iA1wr = parcelRequire("iA1wr");

var $emXRC = parcelRequire("emXRC");

var $dmK5e = parcelRequire("dmK5e");

var $jExSc = parcelRequire("jExSc");
const $aff2421e11506360$export$c60ae92c9826748a = (walkNode, $head)=>{
    const { $pos: $next, foundNode: nextFoundNode } = walkNode;
    const headParent = $head.parent;
    const headGrandParent = $head.node(-1);
    const headInList = (0, $9fsJn.isPosInsideList)($head);
    const headInParagraph = (0, $9fsJn.isPosInsideParagraph)($head);
    const headInLastNonListChild = headGrandParent && headGrandParent.lastChild && (headGrandParent.lastChild === headParent || headGrandParent.childCount > 1 && headGrandParent.child(headGrandParent.childCount - 2) === headParent && //find the second last child if a list item may be the last child
    (0, $iE5F1.isListNode)(headGrandParent.lastChild));
    const nextInList = (0, $9fsJn.isPosInsideList)($next);
    const nextInParagraph = (0, $9fsJn.isPosInsideParagraph)($next);
    if (!headInList && headInParagraph && nextInList) return [
        (0, $gpVit.LIST_TEXT_SCENARIOS).JOIN_LIST_ITEM_WITH_PARAGRAPH,
        (0, $cVttC.joinListItemWithParagraph)
    ];
    if (!nextFoundNode || !headInList || !headInParagraph || !headInLastNonListChild) return false;
    if (!nextInList && nextInParagraph) return [
        (0, $gpVit.LIST_TEXT_SCENARIOS).JOIN_PARAGRAPH_WITH_LIST,
        (0, $dmK5e.joinParagrapWithList)
    ];
    if (!nextInList) return false;
    const nextNodeAfter = $next.nodeAfter;
    const nextGrandParent = $next.node(-1);
    const headGreatGrandParent = $head.node(-2);
    const nextInListItem = (0, $7nLBT.isListItemNode)($next.parent);
    const nextNodeAfterListItem = (0, $7nLBT.isListItemNode)(nextNodeAfter);
    const nextListItemHasFirstChildParagraph = nextNodeAfter && //Redundant check but the linter complains otherwise
    nextNodeAfterListItem && (0, $4Dhpb.isParagraphNode)(nextNodeAfter.firstChild);
    if (!nextInListItem && nextListItemHasFirstChildParagraph) return [
        (0, $gpVit.LIST_TEXT_SCENARIOS).JOIN_DESCENDANT_TO_PARENT,
        (0, $emXRC.joinNestedListWithParentListItem)
    ];
    if (!nextInListItem) return false;
    const nextParentSiblingOfHeadParent = nextGrandParent && nextGrandParent === headGreatGrandParent;
    const nextNodeAfterIsParagraph = (0, $4Dhpb.isParagraphNode)(nextNodeAfter);
    if (!nextNodeAfterIsParagraph) return false;
    if (nextParentSiblingOfHeadParent) return [
        (0, $gpVit.LIST_TEXT_SCENARIOS).JOIN_SIBLINGS,
        (0, $jExSc.joinSiblingListItems)
    ];
    return [
        (0, $gpVit.LIST_TEXT_SCENARIOS).JOIN_PARENT_SIBLING_TO_PARENT_CHILD,
        (0, $iA1wr.joinListItemWithParentNestedList)
    ];
};

});
parcelRegister("cVttC", function(module, exports) {
$parcel$export(module.exports, "joinListItemWithParagraph", () => $1dc9840ebc93b66b$export$fc9859705a1e8274);

var $9dUiE = parcelRequire("9dUiE");
var $iE5F1 = parcelRequire("iE5F1");

var $kW8qW = parcelRequire("kW8qW");
const $1dc9840ebc93b66b$export$fc9859705a1e8274 = ({ tr: tr, $next: $next, $head: $head })=>{
    // For empty paragraphs before a list
    if ($head.parent.content.size < 1) {
        (0, $9dUiE.insertContentDeleteRange)(tr, (tr)=>tr.doc.resolve($head.pos), [], [
            [
                $head.pos - 1,
                $head.pos
            ]
        ]);
        return true;
    }
    const paragraphPosition = $head.pos;
    const list = tr.doc.nodeAt($next.pos - 1);
    const firstListItem = tr.doc.nodeAt($next.pos);
    if (!list || !firstListItem) return false;
    const firstChildNodeOfFirstListItem = firstListItem.firstChild;
    if (!firstChildNodeOfFirstListItem) return false;
    const lastChildOfFirstListItem = firstListItem.lastChild;
    const firstGrandchildOfFirstListItem = firstChildNodeOfFirstListItem.firstChild;
    const firstListItemHasOneChildWithNoNestedLists = $1dc9840ebc93b66b$var$hasSingleChild(firstListItem) && firstChildNodeOfFirstListItem.childCount < 2 && $next.nodeAfter;
    const firstListItemContainsParagraphAndNestedList = !$1dc9840ebc93b66b$var$hasSingleChild(firstListItem) && lastChildOfFirstListItem && (0, $iE5F1.isListNode)(lastChildOfFirstListItem);
    const insertions = [];
    const deletions = [];
    // For lists that only have one list item with no children - need to remove remaining list
    if ($1dc9840ebc93b66b$var$hasSingleChild(list) && $1dc9840ebc93b66b$var$hasSingleChild(firstListItem) && $next.nodeAfter) deletions.push([
        tr.mapping.map($next.pos - 1),
        tr.mapping.map($next.pos + $next.nodeAfter.nodeSize + 1)
    ]);
    // For first list items that have a paragraph and a list
    if (firstListItemContainsParagraphAndNestedList) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const firstListItemNestedList = (0, $kW8qW.Fragment).from(lastChildOfFirstListItem.content);
        insertions.push([
            firstListItemNestedList,
            tr.mapping.map($next.pos)
        ]);
    }
    // For first list item has one child & no nested lists OR first list items that have a paragraph and a list
    if (firstListItemHasOneChildWithNoNestedLists || firstListItemContainsParagraphAndNestedList) {
        deletions.push([
            tr.mapping.map($next.pos),
            tr.mapping.map($next.pos + firstListItem.nodeSize - 1)
        ]);
        const firstListItemText = (0, $kW8qW.Fragment).from(firstChildNodeOfFirstListItem.content);
        insertions.push([
            firstListItemText,
            paragraphPosition
        ]);
        (0, $9dUiE.insertContentDeleteRange)(tr, (tr)=>tr.doc.resolve($head.pos), insertions, deletions);
        return true;
    }
    // For any first list items that have multiple children (eg. multiple paragraphs)
    if (firstListItem.childCount > 1) {
        insertions.push([
            (0, $kW8qW.Fragment).from(firstChildNodeOfFirstListItem.content),
            paragraphPosition
        ]);
        deletions.push([
            tr.mapping.map($next.pos + 1),
            tr.mapping.map($next.pos + firstChildNodeOfFirstListItem.nodeSize + 1)
        ]);
        (0, $9dUiE.insertContentDeleteRange)(tr, (tr)=>tr.doc.resolve($head.pos), insertions, deletions);
        return true;
    }
    // For any remaining first list items that have a single child (eg. single paragraph, multiple lines of text)
    if (firstGrandchildOfFirstListItem && firstGrandchildOfFirstListItem.type.name === 'hardBreak') {
        const nodeSizeOfGrandchild = firstGrandchildOfFirstListItem ? firstGrandchildOfFirstListItem.nodeSize : 0;
        deletions.push([
            tr.mapping.map($next.pos + 2),
            tr.mapping.map($next.pos + 2 + nodeSizeOfGrandchild)
        ]);
    } else {
        insertions.push([
            (0, $kW8qW.Fragment).from(firstChildNodeOfFirstListItem.content),
            paragraphPosition
        ]);
        const nodeSizeOfFirstChild = firstChildNodeOfFirstListItem.nodeSize;
        deletions.push([
            tr.mapping.map($next.pos),
            tr.mapping.map($next.pos + 2 + nodeSizeOfFirstChild)
        ]);
    }
    (0, $9dUiE.insertContentDeleteRange)(tr, (tr)=>tr.doc.resolve($head.pos), insertions, deletions);
    return true;
};
const $1dc9840ebc93b66b$var$hasSingleChild = (node)=>{
    return node.childCount === 1;
};

});

parcelRegister("iA1wr", function(module, exports) {
$parcel$export(module.exports, "joinListItemWithParentNestedList", () => $b82463ed748aafd7$export$2d042119f7337416);

var $9dUiE = parcelRequire("9dUiE");
var $iE5F1 = parcelRequire("iE5F1");
const $b82463ed748aafd7$export$2d042119f7337416 = ({ tr: tr, $next: $next, $head: $head })=>{
    /* CASE 4
   * Initial Structure:
   *
   * List A {
   *   ListItem B {
   *     Paragraph C { text1 }
   *     ...Children D
   *     List E {
   *       ...
   *         List F {       //May be multiple levels of lists
   *           ...Children G
   *           ListItem H {        //Last node of the block
   *             ...Children I
   *             Paragraph J { text2 |$head||textInsertPos| } |childrenMInsertPos|        //Cant have children since this ListItem is the last of the block
   *           }
   *         }
   *       ...
   *     |childrenOInsertPos| }
   *   }
   *   ListItem K { |$next|
   *      Paragraph L { text3 }
   *      ...Children M
   *      List? N {
   *       ...Children O
   *      }
   *   }
   * }
   *
   * Converts to:
   *
   * List A {
   *   ListItem B {
   *     Paragraph C { text1 }
   *     ...Children D
   *     List E {
   *       ...
   *         List F {
   *           ...Children G
   *           ListItem H {
   *             ...Children I
   *             Paragraph J { text2text3 }
   *             ...Children M
   *           }
   *         }
   *       ...
   *       ...Children O
   *     }
   *   }
   * }
   *
   */ const listItemK = $next.parent; //List must have at least one child
    if (!listItemK.firstChild || !listItemK.lastChild) return false;
    const beforeListItemK = $next.before();
    const afterListItemB = $next.before();
    const afterListItemK = $next.after();
    const containsChildrenO = (0, $iE5F1.isListNode)(listItemK.lastChild);
    const textInsertPos = $head.pos;
    const childrenMInsertPos = $head.pos + 1;
    const childrenOInsertPos = afterListItemB - 2;
    const textContent = listItemK.firstChild.content;
    const childrenMContent = containsChildrenO ? listItemK.content.cut(listItemK.firstChild.nodeSize, listItemK.nodeSize - listItemK.lastChild.nodeSize - 2 //Get the position before
    ) : listItemK.content.cut(listItemK.firstChild.nodeSize);
    const childrenOContent = listItemK.lastChild.content;
    (0, $9dUiE.insertContentDeleteRange)(tr, (tr)=>tr.doc.resolve(textInsertPos), containsChildrenO ? [
        [
            textContent,
            textInsertPos
        ],
        [
            childrenMContent,
            childrenMInsertPos
        ],
        [
            childrenOContent,
            childrenOInsertPos
        ]
    ] : [
        [
            textContent,
            textInsertPos
        ],
        [
            childrenMContent,
            childrenMInsertPos
        ]
    ], [
        [
            beforeListItemK,
            afterListItemK
        ]
    ]);
    return true;
};

});

parcelRegister("emXRC", function(module, exports) {
$parcel$export(module.exports, "joinNestedListWithParentListItem", () => $6406643c8857cf2d$export$a4a1ba570b242c2c);

var $9dUiE = parcelRequire("9dUiE");
var $iE5F1 = parcelRequire("iE5F1");
const $6406643c8857cf2d$export$a4a1ba570b242c2c = ({ tr: tr, $next: $next, $head: $head })=>{
    /* CASE 3
   * Initial Structure:
   *
   * List A {
   *   ListItem B {
   *     ...Children C
   *     Paragraph D { text1 |$head||textInsertPos| } |childrenHInsertPos|
   *     List E { |$next||childrenJInsertPos|
   *       ListItem F {
   *         Paragraph G { text2 }
   *         ...Children H
   *         List? I {
   *           ...Children J
   *         }
   *       }
   *       ...Children K
   *     }
   *   }
   * }
   *
   * Converts to:
   *
   * List A {
   *   ListItem B {
   *     ...Children C
   *     Paragraph D { text1text2 }
   *     ...Children H
   *     List E {
   *       ...Children J
   *       ...Children K
   *     }
   *   }
   * }
   *
   */ const listE = $next.parent;
    const listItemF = $next.nodeAfter; //We know next is before a ListItem. ListItem must have at least one child
    if (!listItemF || !listItemF.lastChild) return false;
    const paragraphG = listItemF.firstChild; //ListItem must have at least one child
    if (!paragraphG) return false;
    const beforeListE = $next.before();
    const beforeListItemF = $next.pos;
    const afterParagraphD = $head.after();
    const afterListE = $next.after();
    const afterListItemF = tr.doc.resolve($next.pos + 1).after(); //List must always have at least one listItem
    const containsChildrenJ = (0, $iE5F1.isListNode)(listItemF.lastChild);
    const shouldRemoveListE = listE.childCount === 1 && !containsChildrenJ; //Assures no Children J and K
    const textInsertPos = $head.pos;
    const childrenHInsertPos = afterParagraphD;
    const childrenJInsertPos = $next.pos;
    const textContent = paragraphG.content;
    const childrenHContent = containsChildrenJ ? listItemF.content.cut(paragraphG.nodeSize, listItemF.nodeSize - listItemF.lastChild.nodeSize - 2) : listItemF.content.cut(paragraphG.nodeSize); //If Children J doesn't exist then Children H will include the last node
    const childrenJContent = listItemF.lastChild.content; //Will be invalid if there are no Children J but it will be unused
    (0, $9dUiE.insertContentDeleteRange)(tr, (tr)=>tr.doc.resolve(textInsertPos), containsChildrenJ ? [
        [
            textContent,
            textInsertPos
        ],
        [
            childrenHContent,
            childrenHInsertPos
        ],
        [
            childrenJContent,
            childrenJInsertPos
        ]
    ] : [
        [
            textContent,
            textInsertPos
        ],
        [
            childrenHContent,
            childrenHInsertPos
        ]
    ], [
        shouldRemoveListE ? [
            beforeListE,
            afterListE
        ] : [
            beforeListItemF,
            afterListItemF
        ]
    ]);
    return true;
};

});

parcelRegister("dmK5e", function(module, exports) {
$parcel$export(module.exports, "joinParagrapWithList", () => $2df78e49aec24fe1$export$676f199e6d2601c5);

var $9dUiE = parcelRequire("9dUiE");
const $2df78e49aec24fe1$export$676f199e6d2601c5 = ({ tr: tr, $next: $next, $head: $head })=>{
    /* CASE 1
   * Initial Structure:
   *
   * List A {
   *   ListItem B {
   *     ...Children C
   *     Paragraph D { text1 |$head||textInsertPos| }
   *   }
   * }
   * Paragraph E { |$next| text 2 }
   *
   * Converts to:
   *
   * List A {
   *   ListItem B {
   *     ...Children C
   *     Paragraph D { text1text2 }
   *   }
   * }
   *
   */ const paragraphE = $next.parent;
    const beforeParagraphE = $next.before();
    const afterParagraphE = $next.after();
    const textInsertPos = $head.pos;
    const textContent = paragraphE.content;
    (0, $9dUiE.insertContentDeleteRange)(tr, (tr)=>tr.doc.resolve(textInsertPos), [
        [
            textContent,
            textInsertPos
        ]
    ], [
        [
            beforeParagraphE,
            afterParagraphE
        ]
    ]);
    return true;
};

});

parcelRegister("jExSc", function(module, exports) {
$parcel$export(module.exports, "joinSiblingListItems", () => $2ae45432c4cb13df$export$1a90e697acce0e2d);

var $9dUiE = parcelRequire("9dUiE");
const $2ae45432c4cb13df$export$1a90e697acce0e2d = ({ tr: tr, $next: $next, $head: $head })=>{
    /* CASE 2
   * Initial Structure:
   *
   * List A {
   *   ListItem B {
   *     ...Children C
   *     Paragraph D { text1 |$head||textInsertPos| }       //Cant have children since that would be Case 4
   *   |childrenGInsertPos| }
   *   ListItem E { |$next|
   *     Paragraph F { text2 }
   *     ...Children G
   *   }
   * }
   *
   * Converts to:
   *
   * List A {
   *   ListItem B {
   *     ...Children C
   *     Paragraph C { text1text2 }
   *     ...Children G
   *   }
   * }
   *
   */ const listItemE = $next.parent;
    const paragraphF = $next.nodeAfter; //ListItem must have at least one child
    if (!paragraphF) return false;
    const beforeListItemE = $next.before();
    const afterListItemE = $next.after();
    const endListItemB = $head.end(-1);
    const textInsertPos = $head.pos;
    const childrenGInsertPos = endListItemB;
    const textContent = paragraphF.content;
    const childrenGContent = listItemE.content.cut(paragraphF.nodeSize);
    (0, $9dUiE.insertContentDeleteRange)(tr, (tr)=>tr.doc.resolve(textInsertPos), [
        [
            textContent,
            textInsertPos
        ],
        [
            childrenGContent,
            childrenGInsertPos
        ]
    ], [
        [
            beforeListItemE,
            afterListItemE
        ]
    ]);
    return true;
};

});



parcelRegister("dN4vy", function(module, exports) {
$parcel$export(module.exports, "listBackspace", () => $72bf3bfd328a0d5d$export$7d25b69a3ad4526e);

var $g6Qq4 = parcelRequire("g6Qq4");

var $gpVit = parcelRequire("gpVit");

var $k3wEw = parcelRequire("k3wEw");

var $9dUiE = parcelRequire("9dUiE");
var $iE5F1 = parcelRequire("iE5F1");
var $4Dhpb = parcelRequire("4Dhpb");

var $h7zC7 = parcelRequire("h7zC7");

var $gab48 = parcelRequire("gab48");

var $9fsJn = parcelRequire("9fsJn");
//Cases below refer to the cases found in this document: https://product-fabric.atlassian.net/wiki/spaces/E/pages/1146954996/List+Backspace+and+Delete+Behaviour
//Case for two adjacent list items of the same indentation
const $72bf3bfd328a0d5d$var$listBackspaceCase2 = (tr, dispatch, $prev, $head)=>{
    /* CASE 2
   * Initial Structure:
   *
   * List A {
   *   ListItem B {
   *     ...Children C
   *     Paragraph D { text1 |textInsertPos| }       //Cant have children since that would be Case 4
   *   |$prev||childrenGInsertPos| }
   *   ListItem E {
   *     Paragraph F { |$head| text2 }
   *     ...Children G
   *   }
   * }
   *
   * Converts to:
   *
   * List A {
   *   ListItem B {
   *     ...Children C
   *     Paragraph C { text1text2 }
   *     ...Children G
   *   }
   * }
   *
   */ const listItemE = $head.node(-1); //Head is inside listItem E so it must have a first and last child
    const { fontSize: fontSize } = tr.doc.type.schema.marks;
    if (!listItemE.firstChild) return false;
    const beforeListItemE = $head.before(-1);
    const afterListItemE = $head.after(-1);
    const textInsertPos = $prev.pos - 1; //Paragraph D must be directly behind $prev otherwise it would be case 4
    const childrenGInsertPos = $prev.pos;
    const textContent = $head.parent.content;
    const childrenGContent = listItemE.content.cut(listItemE.firstChild.nodeSize);
    (0, $9dUiE.insertContentDeleteRange)(tr, (tr)=>tr.doc.resolve(textInsertPos), [
        [
            textContent,
            textInsertPos
        ],
        [
            childrenGContent,
            childrenGInsertPos
        ]
    ], [
        [
            beforeListItemE,
            afterListItemE
        ]
    ]);
    if (fontSize) {
        const targetParagraphFontSizeAttrs = (0, $k3wEw.getBlockMarkAttrs)($prev.parent.lastChild, fontSize);
        (0, $k3wEw.reconcileBlockMarkForParagraphAtPos)(tr, tr.mapping.map(textInsertPos), fontSize, targetParagraphFontSizeAttrs);
    }
    if (dispatch) dispatch(tr);
    return true;
};
//Case for two adjacent list items with the first being of lower indentation
const $72bf3bfd328a0d5d$var$listBackspaceCase3 = (tr, dispatch, $prev, $head)=>{
    /* CASE 3
   * Initial Structure:
   *
   * List A {
   *   ListItem B {
   *     ...Children C
   *     Paragraph D { text1 |$prev||textInsertPos| } |childrenHInsertPos|
   *     List E { |childrenJInsertPos|
   *       ListItem F {
   *         Paragraph G { |$head| text2 }
   *         ...Children H
   *         List? I {
   *           ...Children J
   *         }
   *       }
   *       ...Children K
   *     }
   *   }
   * }
   *
   * Converts to:
   *
   * List A {
   *   ListItem B {
   *     ...Children C
   *     Paragraph D { text1text2 }
   *     ...Children H
   *     List E {
   *       ...Children J
   *       ...Children K
   *     }
   *   }
   * }
   *
   */ const listE = $head.node(-2);
    const listItemF = $head.node(-1); //Head is inside listItem F so it must have a first and last child
    const { fontSize: fontSize } = tr.doc.type.schema.marks;
    if (!listItemF.firstChild || !listItemF.lastChild) return false;
    const beforeListE = $head.before(-2);
    const beforeListItemF = $head.before(-1);
    const afterParagraphD = $prev.after();
    const afterListE = $head.after(-2);
    const afterListItemF = $head.after(-1);
    const startListE = $head.start(-2);
    const containsChildrenJ = (0, $iE5F1.isListNode)(listItemF.lastChild);
    const shouldRemoveListE = listE.childCount === 1 && !containsChildrenJ; //Assures no Children J and K
    const textInsertPos = $prev.pos;
    const childrenHInsertPos = afterParagraphD;
    const childrenJInsertPos = startListE;
    const textContent = $head.parent.content;
    const childrenHContent = containsChildrenJ ? listItemF.content.cut(listItemF.firstChild.nodeSize, listItemF.nodeSize - listItemF.lastChild.nodeSize - 2) : listItemF.content.cut(listItemF.firstChild.nodeSize); //If Children J doesn't exist then Children H will include the last node
    const childrenJContent = listItemF.lastChild.content; //Will be invalid if there are no Children J but it will be unused
    (0, $9dUiE.insertContentDeleteRange)(tr, (tr)=>tr.doc.resolve(textInsertPos), containsChildrenJ ? [
        [
            textContent,
            textInsertPos
        ],
        [
            childrenHContent,
            childrenHInsertPos
        ],
        [
            childrenJContent,
            childrenJInsertPos
        ]
    ] : [
        [
            textContent,
            textInsertPos
        ],
        [
            childrenHContent,
            childrenHInsertPos
        ]
    ], [
        shouldRemoveListE ? [
            beforeListE,
            afterListE
        ] : [
            beforeListItemF,
            afterListItemF
        ]
    ]);
    if (fontSize) {
        const targetParagraphFontSizeAttrs = (0, $k3wEw.getBlockMarkAttrs)($prev.parent, fontSize);
        (0, $k3wEw.reconcileBlockMarkForParagraphAtPos)(tr, tr.mapping.map(textInsertPos), fontSize, targetParagraphFontSizeAttrs);
    }
    if (dispatch) dispatch(tr);
    return true;
};
//Case for two adjacent list items with the first being of greater indentation
const $72bf3bfd328a0d5d$var$listBackspaceCase4 = (tr, dispatch, $prev, $head, $last)=>{
    /* CASE 4
   * Initial Structure:
   *
   * List A {
   *   ListItem B {
   *     Paragraph C { text1 }
   *     ...Children D
   *     List E {
   *       ...
   *         List F {       //May be multiple levels of lists
   *           ...Children G
   *           ListItem H {        //Last node of the block
   *             ...Children I
   *             Paragraph J { text2 |$last||textInsertPos| } |childrenMInsertPos|        //Cant have children since this ListItem is the last of the block
   *           }
   *         }
   *       ...
   *     |childrenOInsertPosition| }
   *   |$prev| }
   *   ListItem K {
   *      Paragraph L { |$head| text3 }
   *      ...Children M
   *      List? N {
   *       ...Children O
   *      }
   *   }
   * }
   *
   * Converts to:
   *
   * List A {
   *   ListItem B {
   *     Paragraph C { text1 }
   *     ...Children D
   *     List E {
   *       ...
   *         List F {
   *           ...Children G
   *           ListItem H {
   *             ...Children I
   *             Paragraph J { text2text3 }
   *             ...Children M
   *           }
   *         }
   *       ...
   *       ...Children O
   *     }
   *   }
   * }
   *
   */ if (!$last) //Exit if an invalid last was given as a parameter
    return false;
    const listItemK = $head.node(-1); //Head is inside listItem K so it must have a first and last child
    const { fontSize: fontSize } = tr.doc.type.schema.marks;
    if (!listItemK.firstChild || !listItemK.lastChild) return false;
    const paragraphL = $head.parent;
    const beforeListItemK = $head.before(-1);
    const afterParagraphJ = $last.after();
    const afterListItemK = $head.after(-1);
    const containsChildrenO = (0, $iE5F1.isListNode)(listItemK.lastChild);
    const textInsertPos = $last.pos;
    const childrenMInsertPos = afterParagraphJ;
    const childrenOInsertPos = $prev.pos - 1; //Last item of listItem B must be a list therefore we can simply decrement $prev to get there
    const textContent = paragraphL.content;
    const childrenMContent = containsChildrenO ? listItemK.content.cut(listItemK.firstChild.nodeSize, listItemK.nodeSize - listItemK.lastChild.nodeSize - 2) : listItemK.content.cut(listItemK.firstChild.nodeSize);
    const childrenOContent = listItemK.lastChild.content;
    (0, $9dUiE.insertContentDeleteRange)(tr, (tr)=>tr.doc.resolve(textInsertPos), containsChildrenO ? [
        [
            textContent,
            textInsertPos
        ],
        [
            childrenMContent,
            childrenMInsertPos
        ],
        [
            childrenOContent,
            childrenOInsertPos
        ]
    ] : [
        [
            textContent,
            textInsertPos
        ],
        [
            childrenMContent,
            childrenMInsertPos
        ]
    ], [
        [
            beforeListItemK,
            afterListItemK
        ]
    ]);
    if (fontSize) {
        const targetParagraphFontSizeAttrs = (0, $k3wEw.getBlockMarkAttrs)($last.parent, fontSize);
        (0, $k3wEw.reconcileBlockMarkForParagraphAtPos)(tr, tr.mapping.map(textInsertPos), fontSize, targetParagraphFontSizeAttrs);
    }
    if (dispatch) dispatch(tr);
    return true;
};
const $72bf3bfd328a0d5d$var$BACKSPACE_COMMANDS = {
    [(0, $gpVit.LIST_TEXT_SCENARIOS).JOIN_SIBLINGS]: $72bf3bfd328a0d5d$var$listBackspaceCase2,
    [(0, $gpVit.LIST_TEXT_SCENARIOS).JOIN_DESCENDANT_TO_PARENT]: $72bf3bfd328a0d5d$var$listBackspaceCase3,
    [(0, $gpVit.LIST_TEXT_SCENARIOS).JOIN_TO_SIBLING_DESCENDANT]: $72bf3bfd328a0d5d$var$listBackspaceCase4
};
const $72bf3bfd328a0d5d$export$c60ae92c9826748a = (walkNode, $head, tr)=>{
    const { $pos: $prev, foundNode: prevFoundNode } = walkNode;
    const prevInList = (0, $9fsJn.isPosInsideList)($prev);
    const headInParagraph = (0, $9fsJn.isPosInsideParagraph)($head);
    const headInFirstChild = $head.index(-1) === 0;
    const headInList = (0, $9fsJn.isPosInsideList)($head);
    //Must be at the start of the selection of the first child in the listItem
    if (!prevFoundNode || !prevInList || !headInParagraph || !headInFirstChild || !headInList) return false;
    const prevInParagraph = (0, $9fsJn.isPosInsideParagraph)($prev);
    if (prevInParagraph) return [
        (0, $gpVit.LIST_TEXT_SCENARIOS).JOIN_DESCENDANT_TO_PARENT,
        null
    ];
    const prevParentLastChildIsList = $prev.parent.lastChild && (0, $iE5F1.isListNode)($prev.parent.lastChild);
    const prevParentLastChildIsParagraph = (0, $4Dhpb.isParagraphNode)($prev.parent.lastChild);
    // Will search for the possible last node for case 4 (where the list could be indented multiple times)
    // $last is required to determine whether we are in case 2 or 4
    let $last = tr.doc.resolve($prev.pos);
    let lastFoundNode;
    do {
        const walkNode = (0, $h7zC7.walkPrevNode)($last);
        $last = walkNode.$pos;
        lastFoundNode = walkNode.foundNode;
    }while (lastFoundNode && !$last.parent.isTextblock);
    const lastInParagraph = (0, $9fsJn.isPosInsideParagraph)($last);
    if (lastFoundNode && prevParentLastChildIsList && lastInParagraph) return [
        (0, $gpVit.LIST_TEXT_SCENARIOS).JOIN_TO_SIBLING_DESCENDANT,
        $last
    ];
    else if (prevParentLastChildIsParagraph) return [
        (0, $gpVit.LIST_TEXT_SCENARIOS).JOIN_SIBLINGS,
        null
    ];
    return false;
};
const $72bf3bfd328a0d5d$export$7d25b69a3ad4526e = (editorAnalyticsAPI)=>(state, dispatch)=>{
        const { tr: tr, selection: { $head: $head } } = state;
        const walkNode = (0, $h7zC7.walkPrevNode)($head);
        if (!(0, $h7zC7.isEmptySelectionAtStart)(state)) return false;
        const scenario = $72bf3bfd328a0d5d$export$c60ae92c9826748a(walkNode, $head, tr);
        if (!scenario) return false;
        const { bulletList: bulletList, orderedList: orderedList } = state.schema.nodes;
        const listParent = (0, $gab48.findParentNodeOfType)([
            bulletList,
            orderedList
        ])(tr.selection);
        let actionSubjectId = (0, $g6Qq4.ACTION_SUBJECT_ID).FORMAT_LIST_BULLET;
        if (listParent && listParent.node.type === orderedList) actionSubjectId = (0, $g6Qq4.ACTION_SUBJECT_ID).FORMAT_LIST_NUMBER;
        editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent({
            action: (0, $g6Qq4.ACTION).LIST_ITEM_JOINED,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).LIST,
            actionSubjectId: actionSubjectId,
            eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
            attributes: {
                inputMethod: (0, $g6Qq4.INPUT_METHOD).KEYBOARD,
                direction: (0, $gpVit.DELETE_DIRECTION).BACKWARD,
                scenario: scenario[0]
            }
        })(tr);
        return $72bf3bfd328a0d5d$var$BACKSPACE_COMMANDS[scenario[0]](tr, dispatch, walkNode.$pos, $head, scenario[1]);
    };

});

parcelRegister("1y0UK", function(module, exports) {
$parcel$export(module.exports, "outdentList", () => $c9fe3e3785086757$export$959569198ddbbe17);

var $g6Qq4 = parcelRequire("g6Qq4");

var $eWnvc = parcelRequire("eWnvc");

var $8O4hA = parcelRequire("8O4hA");

var $3IDI7 = parcelRequire("3IDI7");

var $kQkyj = parcelRequire("kQkyj");

var $lNQjY = parcelRequire("lNQjY");

var $7uTIW = parcelRequire("7uTIW");

var $9fsJn = parcelRequire("9fsJn");
/**
 * Handler for flexible list outdentation.
 * Lifts items independently and cleans up wrapper structures.
 */ const $c9fe3e3785086757$var$handleOutdentListItems = (tr, editorAnalyticsAPI, inputMethod)=>{
    var _findFirstParentListN;
    (0, $lNQjY.moveSelectedListItems)(tr, -1);
    // If no changes were made, handle based on context
    if (!tr.docChanged) // If inside table cell and can't outdent list, then let it handle by table keymap
    return !(0, $9fsJn.isInsideTableCell)(tr) ? new (0, $8O4hA.PassiveTransaction)() : null;
    // Determine the action subject ID from the parent list type
    const { selection: { $from: $from } } = tr;
    const currentListNode = (_findFirstParentListN = (0, $7uTIW.findFirstParentListNode)($from)) === null || _findFirstParentListN === void 0 ? void 0 : _findFirstParentListN.node;
    const actionSubjectId = currentListNode && (0, $3IDI7.isBulletList)(currentListNode) ? (0, $g6Qq4.ACTION_SUBJECT_ID).FORMAT_LIST_BULLET : (0, $g6Qq4.ACTION_SUBJECT_ID).FORMAT_LIST_NUMBER;
    // Attach analytics event with flexibleIndentation attribute
    editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent({
        action: (0, $g6Qq4.ACTION).OUTDENTED,
        actionSubject: (0, $g6Qq4.ACTION_SUBJECT).LIST,
        actionSubjectId: actionSubjectId,
        eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
        attributes: {
            ...(0, $eWnvc.getCommonListAnalyticsAttributes)(tr),
            inputMethod: inputMethod
        }
    })(tr);
    return tr;
};
const $c9fe3e3785086757$export$959569198ddbbe17 = (editorAnalyticsAPI)=>(inputMethod = (0, $g6Qq4.INPUT_METHOD).KEYBOARD)=>{
        return function({ tr: tr }) {
            if (!(0, $9fsJn.isInsideListItem)(tr)) return null;
            const { $from: $from } = tr.selection;
            const parentListNode = (0, $7uTIW.findFirstParentListNode)($from);
            if (!parentListNode) // Keep focus in the editor when there is no parent list to outdent.
            return new (0, $8O4hA.PassiveTransaction)();
            (0, $kQkyj.closeHistory)(tr);
            return $c9fe3e3785086757$var$handleOutdentListItems(tr, editorAnalyticsAPI, inputMethod);
        };
    };

});
parcelRegister("lNQjY", function(module, exports) {
$parcel$export(module.exports, "moveSelectedListItems", () => $2b7f1809750709bf$export$d06b49236c055472);

var $lc7rP = parcelRequire("lc7rP");

var $ietce = parcelRequire("ietce");

var $6MLz1 = parcelRequire("6MLz1");

var $7uTIW = parcelRequire("7uTIW");

var $3t4W2 = parcelRequire("3t4W2");
function $2b7f1809750709bf$export$d06b49236c055472(tr, indentDelta) {
    const originalSelection = tr.selection;
    const rootListResolved = (0, $7uTIW.findRootParentListNode)(originalSelection.$from);
    if (!rootListResolved) return;
    const rootList = (0, $7uTIW.findFirstParentListNode)(rootListResolved);
    if (!rootList) return;
    const rootListStart = rootList.pos;
    const rootListEnd = rootListStart + rootList.node.nodeSize;
    const result = (0, $3t4W2.flattenList)({
        doc: tr.doc,
        rootListStart: rootListStart,
        rootListEnd: rootListEnd,
        selectionFrom: originalSelection.from,
        selectionTo: originalSelection.to,
        indentDelta: indentDelta,
        maxDepth: (0, $6MLz1.MAX_NESTED_LIST_INDENTATION)
    });
    if (!result) return;
    const { items: items, startIndex: startIndex, endIndex: endIndex } = result;
    const { fragment: fragment, contentStartOffsets: contentStartOffsets } = (0, $3t4W2.buildReplacementFragment)(items, tr.doc.type.schema);
    if (fragment.size === 0) return;
    // Narrow the replacement to the minimal changed range for collab-friendly
    // cursor preservation on unaffected list items.
    const narrowed = (0, $lc7rP.narrowReplacementRange)(tr.doc, rootListStart, rootListEnd, fragment, contentStartOffsets);
    tr.replaceWith(narrowed.start, narrowed.end, narrowed.fragment);
    const { from: from, to: to } = (0, $ietce.computeSelectionOffsets)({
        items: items,
        startIndex: startIndex,
        endIndex: endIndex,
        originalFrom: originalSelection.from,
        originalTo: originalSelection.to,
        contentStartOffsets: narrowed.adjustedContentStartOffsets,
        rootListStart: narrowed.start,
        docSize: tr.doc.content.size
    });
    (0, $ietce.restoreSelection)({
        tr: tr,
        originalSelection: originalSelection,
        from: from,
        to: to
    });
}

});
parcelRegister("lc7rP", function(module, exports) {
$parcel$export(module.exports, "narrowReplacementRange", () => $e576819bd7dc3c0d$export$1d19d37d675fc1b8);

var $kW8qW = parcelRequire("kW8qW");
function $e576819bd7dc3c0d$export$1d19d37d675fc1b8(doc, rootListStart, rootListEnd, fragment, contentStartOffsets) {
    const oldNode = doc.nodeAt(rootListStart);
    const newNode = fragment.childCount === 1 ? fragment.firstChild : null;
    if (!oldNode || !newNode || newNode.type !== oldNode.type) return {
        start: rootListStart,
        end: rootListEnd,
        fragment: fragment,
        adjustedContentStartOffsets: contentStartOffsets
    };
    const minChildCount = Math.min(oldNode.childCount, newNode.childCount);
    let commonPrefixChildren = 0;
    let prefixSize = 0;
    for(let i = 0; i < minChildCount; i++){
        const oldChild = oldNode.child(i);
        const newChild = newNode.child(i);
        if (oldChild.eq(newChild)) {
            commonPrefixChildren++;
            prefixSize += oldChild.nodeSize;
        } else break;
    }
    let commonSuffixChildren = 0;
    let suffixSize = 0;
    for(let i = 0; i < minChildCount - commonPrefixChildren; i++){
        const oldChild = oldNode.child(oldNode.childCount - 1 - i);
        const newChild = newNode.child(newNode.childCount - 1 - i);
        if (oldChild.eq(newChild)) {
            commonSuffixChildren++;
            suffixSize += oldChild.nodeSize;
        } else break;
    }
    const totalCommon = commonPrefixChildren + commonSuffixChildren;
    if (totalCommon >= oldNode.childCount && totalCommon >= newNode.childCount) return {
        start: rootListStart,
        end: rootListStart,
        fragment: (0, $kW8qW.Fragment).empty,
        adjustedContentStartOffsets: contentStartOffsets
    };
    const narrowedStart = rootListStart + 1 + prefixSize;
    const narrowedEnd = rootListEnd - 1 - suffixSize;
    const changedChildStart = commonPrefixChildren;
    const changedChildEnd = newNode.childCount - commonSuffixChildren;
    const changedNodes = [];
    for(let i = changedChildStart; i < changedChildEnd; i++)changedNodes.push(newNode.child(i));
    const narrowedFragment = (0, $kW8qW.Fragment).from(changedNodes);
    const prefixOffset = 1 + prefixSize;
    const adjustedContentStartOffsets = contentStartOffsets.map((offset)=>offset - prefixOffset);
    return {
        start: narrowedStart,
        end: narrowedEnd,
        fragment: narrowedFragment,
        adjustedContentStartOffsets: adjustedContentStartOffsets
    };
}

});

parcelRegister("ietce", function(module, exports) {
$parcel$export(module.exports, "computeSelectionOffsets", () => $f685079b5aebb89a$export$76f89e56a88b45c7);
$parcel$export(module.exports, "restoreSelection", () => $f685079b5aebb89a$export$df4382c94ffa9da5);

var $cw0wu = parcelRequire("cw0wu");

var $j7pt0 = parcelRequire("j7pt0");
function $f685079b5aebb89a$export$76f89e56a88b45c7({ items: items, startIndex: startIndex, endIndex: endIndex, originalFrom: originalFrom, originalTo: originalTo, contentStartOffsets: contentStartOffsets, rootListStart: rootListStart, docSize: docSize }) {
    // +1 shifts from the outer edge of the list item node to the start of the content within
    const fromContentStart = items[startIndex].pos + 1;
    const toContentStart = items[endIndex].pos + 1;
    const fromOffset = originalFrom - fromContentStart;
    const toOffset = originalTo - toContentStart;
    const clamp = (pos)=>Math.min(Math.max(0, pos), docSize);
    return {
        from: clamp(rootListStart + contentStartOffsets[startIndex] + fromOffset),
        to: clamp(rootListStart + contentStartOffsets[endIndex] + toOffset)
    };
}
function $f685079b5aebb89a$export$df4382c94ffa9da5({ tr: tr, originalSelection: originalSelection, from: from, to: to }) {
    const maxPos = tr.doc.content.size;
    if (originalSelection instanceof (0, $cw0wu.NodeSelection)) try {
        tr.setSelection((0, $cw0wu.NodeSelection).create(tr.doc, Math.min(from, maxPos - 1)));
    } catch  {
        tr.setSelection((0, $cw0wu.Selection).near(tr.doc.resolve(from)));
    }
    else if (originalSelection instanceof (0, $j7pt0.GapCursorSelection)) tr.setSelection(new (0, $j7pt0.GapCursorSelection)(tr.doc.resolve(from), originalSelection.side));
    else tr.setSelection((0, $cw0wu.TextSelection).create(tr.doc, from, to));
}

});

parcelRegister("6MLz1", function(module, exports) {
$parcel$export(module.exports, "MAX_NESTED_LIST_INDENTATION", () => $9fe46ded497fa582$export$eb55a67f55930af1);
const $9fe46ded497fa582$export$eb55a67f55930af1 = 6;

});

parcelRegister("3t4W2", function(module, exports) {
$parcel$export(module.exports, "flattenList", () => $2fd16c8b2a7e0827$export$8824054d4a42eac8);
$parcel$export(module.exports, "buildReplacementFragment", () => $2fd16c8b2a7e0827$export$861e2120f3e445e9);

var $2NNpO = parcelRequire("2NNpO");

var $7nLBT = parcelRequire("7nLBT");
var $iE5F1 = parcelRequire("iE5F1");
/**
 * Returns true if a listItem has at least one non-list child (paragraph, etc.).
 */ function $2fd16c8b2a7e0827$var$hasContentChildren(listItem) {
    return listItem.children.some((child)=>!(0, $iE5F1.isListNode)(child));
}
function $2fd16c8b2a7e0827$export$8824054d4a42eac8(options) {
    const { doc: doc, rootListStart: rootListStart, selectionFrom: selectionFrom, selectionTo: selectionTo, indentDelta: indentDelta, maxDepth: maxDepth } = options;
    const rootList = doc.nodeAt(rootListStart);
    if (!rootList) return null;
    const schema = rootList.type.schema;
    const items = [];
    let startIndex = -1;
    let endIndex = -1;
    let exceedsMaxDepth = false;
    const isPointSelection = selectionFrom === selectionTo;
    const pushSegment = (segmentNode, contentStart, contentEnd, depth, parentList)=>{
        const isSelected = isPointSelection ? selectionFrom >= contentStart && selectionFrom <= contentEnd : contentStart < selectionTo && contentEnd > selectionFrom;
        const effectiveDepth = depth + (isSelected ? indentDelta : 0);
        items.push({
            node: segmentNode,
            pos: contentStart - 1,
            depth: effectiveDepth,
            isSelected: isSelected,
            listType: parentList.type.name,
            parentListAttrs: parentList.attrs
        });
        if (isSelected) {
            const index = items.length - 1;
            if (startIndex === -1) startIndex = index;
            endIndex = index;
            if (maxDepth != null && effectiveDepth >= maxDepth) exceedsMaxDepth = true;
        }
    };
    const walkList = (listNode, listPos, depth)=>{
        let childPos = listPos + 1;
        listNode.forEach((listItemNode)=>{
            if (!(0, $7nLBT.isListItemNode)(listItemNode)) {
                childPos += listItemNode.nodeSize;
                return;
            }
            const itemStart = childPos;
            let innerPos = itemStart + 1;
            // Content collected since the last sub-list. Each run becomes its own item.
            let segmentContent = [];
            let segmentContentStart = innerPos;
            let segmentContentSize = 0;
            const emitSegment = (parentList)=>{
                if (segmentContent.length === 0) return;
                const segmentItem = schema.nodes.listItem.create(listItemNode.attrs, segmentContent);
                pushSegment(segmentItem, segmentContentStart, segmentContentStart + segmentContentSize, depth, parentList);
            };
            listItemNode.forEach((child)=>{
                if ((0, $iE5F1.isListNode)(child)) {
                    // A sub-list ends the current run: emit it, then walk the sub-list deeper.
                    emitSegment(listNode);
                    segmentContent = [];
                    segmentContentSize = 0;
                    walkList(child, innerPos, depth + 1);
                    innerPos += child.nodeSize;
                    segmentContentStart = innerPos;
                } else {
                    if (segmentContent.length === 0) segmentContentStart = innerPos;
                    segmentContent.push(child);
                    segmentContentSize += child.nodeSize;
                    innerPos += child.nodeSize;
                }
            });
            // Emit any remaining content after the last sub-list.
            emitSegment(listNode);
            childPos += listItemNode.nodeSize;
        });
    };
    walkList(rootList, rootListStart, 0);
    if (items.length === 0 || startIndex === -1 || exceedsMaxDepth) return null;
    return {
        items: items,
        startIndex: startIndex,
        endIndex: endIndex
    };
}
/**
 * Extract non-list (content) children from a listItem node.
 */ function $2fd16c8b2a7e0827$var$extractContentChildren(listItem) {
    const children = [];
    for(let i = 0; i < listItem.childCount; i++){
        const child = listItem.child(i);
        if (!(0, $iE5F1.isListNode)(child)) children.push(child);
    }
    return children;
}
/**
 * Rebuild a ProseMirror list tree from a flat array of `FlattenedItem` objects
 * using a bottom-up stack approach.
 *
 * The algorithm tracks open list/listItem wrappers on a stack. As depth
 * transitions occur between consecutive elements, wrapper nodes are opened
 * (depth increase) or closed (depth decrease).
 */ function $2fd16c8b2a7e0827$var$rebuildPMList(elements, schema) {
    if (elements.length === 0) return null;
    const stack = [];
    function openList(listType, listAttrs) {
        stack.push({
            listType: listType,
            listAttrs: listAttrs,
            items: []
        });
    }
    /**
   * Close lists on the stack down to `targetDepth`, wrapping each closed
   * list into the last listItem of its parent.
   */ function closeToDepth(targetDepth) {
        while(stack.length > targetDepth + 1){
            const closed = stack.pop();
            if (!closed) break;
            const listNode = schema.nodes[closed.listType].create(closed.listAttrs, closed.items);
            // Attach the closed list to the last listItem on the parent frame
            const parentFrame = stack[stack.length - 1];
            const lastItem = parentFrame.items[parentFrame.items.length - 1];
            if (lastItem) {
                // Append the nested list to this listItem's children
                const newContent = [];
                lastItem.forEach((child)=>newContent.push(child));
                newContent.push(listNode);
                parentFrame.items[parentFrame.items.length - 1] = schema.nodes.listItem.create(lastItem.attrs, newContent);
            } else {
                // Edge case: no listItem to attach to. Create a wrapper.
                const wrapperItem = schema.nodes.listItem.create(null, [
                    listNode
                ]);
                parentFrame.items.push(wrapperItem);
            }
        }
    }
    // Seed the root list with the first element's parent list attributes
    openList(elements[0].listType, elements[0].parentListAttrs);
    for (const el of elements){
        const targetDepth = el.depth;
        // Close lists if we're going shallower
        if (stack.length > targetDepth + 1) closeToDepth(targetDepth);
        // Open lists if we need to go deeper.
        // We do NOT create wrapper listItems here — closeToDepth handles
        // creating wrappers that contain only the nested list (no empty paragraph).
        // For unselected elements, the list structure already existed so we
        // preserve the parent list's attributes. For selected (moved) elements,
        // this is a new nesting level so we use null (the localId plugin will
        // backfill a fresh UUID).
        while(stack.length < targetDepth + 1)openList(el.listType, el.isSelected ? null : el.parentListAttrs);
        // Build the listItem for this element using its content children
        const contentChildren = $2fd16c8b2a7e0827$var$extractContentChildren(el.node);
        const listItem = schema.nodes.listItem.create(el.node.attrs, contentChildren);
        stack[stack.length - 1].items.push(listItem);
    }
    // Close all remaining open lists
    closeToDepth(0);
    const root = stack[0];
    const rebuilt = schema.nodes[root.listType].create(root.listAttrs, root.items);
    // Compute content start offsets by walking the rebuilt tree.
    const contentStartOffsets = new Array(elements.length);
    let segIdx = 0;
    rebuilt.descendants((node, pos)=>{
        if ((0, $7nLBT.isListItemNode)(node) && $2fd16c8b2a7e0827$var$hasContentChildren(node)) {
            // +1 for rebuilt's opening tag, +1 for listItem's opening tag
            contentStartOffsets[segIdx] = 1 + pos + 1;
            segIdx++;
        }
        return true;
    });
    return {
        node: rebuilt,
        contentStartOffsets: contentStartOffsets
    };
}
function $2fd16c8b2a7e0827$export$861e2120f3e445e9(elements, schema) {
    return (0, $2NNpO.buildReplacementFragment)({
        items: elements,
        schema: schema,
        rebuildFn: $2fd16c8b2a7e0827$var$rebuildPMList,
        extractContentFn: (item)=>$2fd16c8b2a7e0827$var$extractContentChildren(item.node)
    });
}

});
parcelRegister("2NNpO", function(module, exports) {
$parcel$export(module.exports, "buildReplacementFragment", () => $42f9aa334457b2c9$export$861e2120f3e445e9);

var $kW8qW = parcelRequire("kW8qW");
function $42f9aa334457b2c9$export$861e2120f3e445e9({ items: items, schema: schema, rebuildFn: rebuildFn, extractContentFn: extractContentFn }) {
    let fragment = (0, $kW8qW.Fragment).empty;
    let pendingListSegment = [];
    let pendingStartIdx = 0;
    const contentStartOffsets = new Array(items.length);
    const flushListSegment = ()=>{
        if (pendingListSegment.length > 0) {
            const fragmentOffset = fragment.size;
            const result = rebuildFn(pendingListSegment, schema);
            if (result) {
                // Map the rebuild's content start offsets into the overall fragment.
                for(let i = 0; i < pendingListSegment.length; i++)contentStartOffsets[pendingStartIdx + i] = fragmentOffset + result.contentStartOffsets[i];
                fragment = fragment.addToEnd(result.node);
            }
            pendingListSegment = [];
        }
    };
    let elIdx = 0;
    for (const item of items){
        if (item.depth < 0) {
            flushListSegment();
            // Extracted element — content children become top-level nodes.
            // Record offset of first content child.
            contentStartOffsets[elIdx] = fragment.size;
            for (const node of extractContentFn(item, schema))fragment = fragment.addToEnd(node);
        } else {
            if (pendingListSegment.length === 0) pendingStartIdx = elIdx;
            pendingListSegment.push(item);
        }
        elIdx++;
    }
    flushListSegment();
    return {
        fragment: fragment,
        contentStartOffsets: contentStartOffsets
    };
}

});





parcelRegister("hEPiO", function(module, exports) {
$parcel$export(module.exports, "indentList", () => $852b3828e315908e$export$8066a906978eedb2);

var $g6Qq4 = parcelRequire("g6Qq4");

var $eWnvc = parcelRequire("eWnvc");

var $8O4hA = parcelRequire("8O4hA");

var $3IDI7 = parcelRequire("3IDI7");

var $kQkyj = parcelRequire("kQkyj");

var $lNQjY = parcelRequire("lNQjY");

var $7uTIW = parcelRequire("7uTIW");

var $9fsJn = parcelRequire("9fsJn");
/**
 * Handler for flexible list indentation.
 * Allows indenting the first item by creating wrapper structures.
 */ const $852b3828e315908e$var$handleIndentListItems = (tr, editorAnalyticsAPI, inputMethod)=>{
    var _findFirstParentListN;
    (0, $lNQjY.moveSelectedListItems)(tr, 1);
    // If no changes were made, return PassiveTransaction to prevent browser from handling this as a tab key event (e.g. moving focus)
    if (!tr.docChanged) return new (0, $8O4hA.PassiveTransaction)();
    const { selection: { $from: $from } } = tr;
    const currentListNode = (_findFirstParentListN = (0, $7uTIW.findFirstParentListNode)($from)) === null || _findFirstParentListN === void 0 ? void 0 : _findFirstParentListN.node;
    const actionSubjectId = currentListNode && (0, $3IDI7.isBulletList)(currentListNode) ? (0, $g6Qq4.ACTION_SUBJECT_ID).FORMAT_LIST_BULLET : (0, $g6Qq4.ACTION_SUBJECT_ID).FORMAT_LIST_NUMBER;
    editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent({
        action: (0, $g6Qq4.ACTION).INDENTED,
        actionSubject: (0, $g6Qq4.ACTION_SUBJECT).LIST,
        actionSubjectId: actionSubjectId,
        eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
        attributes: {
            ...(0, $eWnvc.getCommonListAnalyticsAttributes)(tr),
            inputMethod: inputMethod
        }
    })(tr);
    return tr;
};
const $852b3828e315908e$export$8066a906978eedb2 = (editorAnalyticsAPI)=>(inputMethod = (0, $g6Qq4.INPUT_METHOD).KEYBOARD)=>{
        return function({ tr: tr }) {
            // don't indent if selection is not inside a list
            if (!(0, $9fsJn.isInsideListItem)(tr)) return null;
            // Save the history, so it could undo/revert to the same state before the indent, see https://product-fabric.atlassian.net/browse/ED-14753
            (0, $kQkyj.closeHistory)(tr);
            return $852b3828e315908e$var$handleIndentListItems(tr, editorAnalyticsAPI, inputMethod);
        };
    };

});

parcelRegister("4KAVU", function(module, exports) {
$parcel$export(module.exports, "default", () => $73aa3865750c5b15$export$2e2bcd8739ae039);

var $f7Kk4 = parcelRequire("f7Kk4");

var $8t09p = parcelRequire("8t09p");

var $hKUAq = parcelRequire("hKUAq");
// Using UTF instead of • character
// because of issue where product converted the
// character into an escaped version.
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $73aa3865750c5b15$var$BULLET_LIST_EXPRESSION = /^\s*([\*\-\u2022]) $/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $73aa3865750c5b15$var$ORDERED_LIST_EXPRESSION = /((^[1-9]{1}[0-9]{0,2})|^(0))[\.\)] $/;
function $73aa3865750c5b15$export$2e2bcd8739ae039(schema, editorAnalyticsApi) {
    const { nodes: { bulletList: bulletList, orderedList: orderedList } } = schema;
    const rules = [];
    if (bulletList) rules.push((0, $hKUAq.createRuleForListType)({
        expression: $73aa3865750c5b15$var$BULLET_LIST_EXPRESSION,
        listType: bulletList,
        editorAnalyticsApi: editorAnalyticsApi
    }));
    if (orderedList) rules.push((0, $hKUAq.createRuleForListType)({
        expression: $73aa3865750c5b15$var$ORDERED_LIST_EXPRESSION,
        listType: orderedList,
        editorAnalyticsApi: editorAnalyticsApi
    }));
    if (rules.length !== 0) return new (0, $f7Kk4.SafePlugin)((0, $8t09p.createPlugin)('lists', rules));
    return;
}

});
parcelRegister("hKUAq", function(module, exports) {
$parcel$export(module.exports, "createRuleForListType", () => $19c386b54be414f4$export$7c19b3e2f55f7141);

var $g6Qq4 = parcelRequire("g6Qq4");

var $gpVit = parcelRequire("gpVit");

var $hfNS8 = parcelRequire("hfNS8");

var $c1Pi0 = parcelRequire("c1Pi0");
const $19c386b54be414f4$var$getOrder = (matchResult)=>Number(matchResult[1]);
function $19c386b54be414f4$export$7c19b3e2f55f7141({ listType: listType, expression: expression, editorAnalyticsApi: editorAnalyticsApi }) {
    let joinScenario = (0, $gpVit.JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST).NO_JOIN;
    const isBulletList = listType.name === 'bulletList';
    const actionSubjectId = isBulletList ? (0, $g6Qq4.ACTION_SUBJECT_ID).FORMAT_LIST_BULLET : (0, $g6Qq4.ACTION_SUBJECT_ID).FORMAT_LIST_NUMBER;
    const getAnalyticsPayload = (state, matchResult)=>{
        const analyticsPayload = {
            action: (0, $g6Qq4.ACTION).INSERTED,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).LIST,
            actionSubjectId: actionSubjectId,
            eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
            attributes: {
                inputMethod: (0, $g6Qq4.INPUT_METHOD).FORMATTING
            }
        };
        if (listType === state.schema.nodes.orderedList && analyticsPayload.attributes) {
            analyticsPayload.attributes.listStartNumber = $19c386b54be414f4$var$getOrder(matchResult);
            analyticsPayload.attributes.joinScenario = joinScenario;
            // we reset the tracked joinScenario after storing it in the event payload
            joinScenario = (0, $gpVit.JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST).NO_JOIN;
        }
        return analyticsPayload;
    };
    const joinToNeighbourIfSameListType = (_, node, scenario)=>{
        const shouldJoin = node.type === listType;
        if (shouldJoin) joinScenario = scenario;
        return shouldJoin;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const getAttrs = (matchResult)=>{
        return {
            order: $19c386b54be414f4$var$getOrder(matchResult)
        };
    };
    const inputRule = (0, $c1Pi0.createWrappingJoinRule)({
        match: expression,
        nodeType: listType,
        getAttrs: getAttrs,
        joinPredicate: joinToNeighbourIfSameListType
    });
    return (0, $hfNS8.inputRuleWithAnalytics)(getAnalyticsPayload, editorAnalyticsApi)(inputRule);
}

});
parcelRegister("c1Pi0", function(module, exports) {
$parcel$export(module.exports, "createWrappingJoinRule", () => $f401279e778db4da$export$6341edfa2d147bc);

var $gpVit = parcelRequire("gpVit");

var $33v8M = parcelRequire("33v8M");

var $3DNV7 = parcelRequire("3DNV7");

var $gab48 = parcelRequire("gab48");
const $f401279e778db4da$export$6341edfa2d147bc = ({ match: match, nodeType: nodeType, getAttrs: getAttrs, joinPredicate: joinPredicate })=>{
    const handler = (state, match, start, end)=>{
        const attrs = (getAttrs instanceof Function ? getAttrs(match) : getAttrs) || {};
        const tr = state.tr;
        const fixedStart = Math.max(start, 1);
        tr.delete(fixedStart, end);
        const $start = tr.doc.resolve(fixedStart);
        const range = $start.blockRange();
        const wrapping = range && (0, $3DNV7.findWrapping)(range, nodeType, attrs);
        if (!wrapping || !range) return null;
        const parentNodePosMapped = tr.mapping.map(range.start);
        const parentNode = tr.doc.nodeAt(parentNodePosMapped);
        const lastWrap = wrapping[wrapping.length - 1];
        if (parentNode && lastWrap) {
            const allowedMarks = lastWrap.type.allowedMarks(parentNode.marks) || [];
            tr.setNodeMarkup(parentNodePosMapped, parentNode.type, parentNode.attrs, allowedMarks);
        }
        tr.wrap(range, wrapping);
        // if an orderedList node would be inserted by the input rule match, and
        // that orderedList node is being added directly after another orderedList
        const $end = tr.doc.resolve(tr.mapping.map(end));
        const nodeWithPos = (0, $gab48.findParentNodeOfTypeClosestToPos)($end, nodeType);
        if (nodeType === state.schema.nodes.orderedList) // otherwise join the lists
        {
            if (nodeWithPos) {
                const nodeEnd = nodeWithPos.pos + nodeWithPos.node.nodeSize;
                const after = tr.doc.resolve(nodeEnd).nodeAfter;
                if (after && after.type === nodeType && (0, $3DNV7.canJoin)(tr.doc, nodeEnd) && (!joinPredicate || joinPredicate(match, after, (0, $gpVit.JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST).JOINED_TO_LIST_BELOW))) tr.join(nodeEnd);
            }
        }
        const before = tr.doc.resolve(fixedStart - 1).nodeBefore;
        if (before && before.type === nodeType && (0, $3DNV7.canJoin)(tr.doc, fixedStart - 1) && (!joinPredicate || joinPredicate(match, before, (0, $gpVit.JOIN_SCENARIOS_WHEN_TYPING_TO_INSERT_LIST).JOINED_TO_LIST_ABOVE))) tr.join(fixedStart - 1);
        return tr;
    };
    return (0, $33v8M.createRule)(match, handler);
};

});



parcelRegister("iQvt4", function(module, exports) {
$parcel$export(module.exports, "default", () => $d3d45de1f1441ae3$export$2e2bcd8739ae039);

var $g6Qq4 = parcelRequire("g6Qq4");

var $cv8id = parcelRequire("cv8id");

var $ejrfk = parcelRequire("ejrfk");

var $jMNEp = parcelRequire("jMNEp");

var $hEPiO = parcelRequire("hEPiO");

var $1y0UK = parcelRequire("1y0UK");
function $d3d45de1f1441ae3$export$e832373cff8dec22(featureFlags, editorAnalyticsAPI) {
    const list = {};
    (0, $cv8id.bindKeymapWithEditorCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $cv8id.findShortcutByKeymap)((0, $cv8id.toggleOrderedList)), (0, $jMNEp.toggleList)(editorAnalyticsAPI)((0, $g6Qq4.INPUT_METHOD).KEYBOARD, 'orderedList'), list);
    (0, $cv8id.bindKeymapWithEditorCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $cv8id.findShortcutByKeymap)((0, $cv8id.toggleBulletList)), (0, $jMNEp.toggleList)(editorAnalyticsAPI)((0, $g6Qq4.INPUT_METHOD).KEYBOARD, 'bulletList'), list);
    (0, $cv8id.bindKeymapWithEditorCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $cv8id.indentList).common, (0, $hEPiO.indentList)(editorAnalyticsAPI)((0, $g6Qq4.INPUT_METHOD).KEYBOARD), list);
    (0, $cv8id.bindKeymapWithEditorCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $cv8id.outdentList).common, (0, $1y0UK.outdentList)(editorAnalyticsAPI)((0, $g6Qq4.INPUT_METHOD).KEYBOARD), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $cv8id.bindKeymapWithCommand)((0, $cv8id.enter).common, (0, $jMNEp.enterKeyCommand)(editorAnalyticsAPI)(), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $cv8id.bindKeymapWithCommand)((0, $cv8id.backspace).common, (0, $jMNEp.backspaceKeyCommand)(editorAnalyticsAPI)(), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $cv8id.bindKeymapWithCommand)((0, $cv8id.deleteKey).common, (0, $jMNEp.deleteKeyCommand)(editorAnalyticsAPI), list);
    // This shortcut is Mac only
    (0, $cv8id.bindKeymapWithCommand)((0, $cv8id.findKeyMapForBrowser)((0, $cv8id.forwardDelete)), (0, $jMNEp.deleteKeyCommand)(editorAnalyticsAPI), list);
    return (0, $ejrfk.keymap)(list);
}
var $d3d45de1f1441ae3$export$2e2bcd8739ae039 = $d3d45de1f1441ae3$export$e832373cff8dec22;

});

parcelRegister("hqaCP", function(module, exports) {
$parcel$export(module.exports, "pluginKey", () => $bc4a387287845f9d$export$18d4026d1ea86bb1);
$parcel$export(module.exports, "createPlugin", () => $bc4a387287845f9d$export$ae829ec7b2625219);

var $f7Kk4 = parcelRequire("f7Kk4");

var $8t2a4 = parcelRequire("8t2a4");

var $8HYXC = parcelRequire("8HYXC");

var $1J9lh = parcelRequire("1J9lh");

var $fMCeS = parcelRequire("fMCeS");

var $4EVbq = parcelRequire("4EVbq");

var $3TnFr = parcelRequire("3TnFr");

var $cw0wu = parcelRequire("cw0wu");

var $gab48 = parcelRequire("gab48");

var $a3b9P = parcelRequire("a3b9P");

var $kWmG3 = parcelRequire("kWmG3");

var $9fsJn = parcelRequire("9fsJn");
const $bc4a387287845f9d$var$listPluginKey = new (0, $cw0wu.PluginKey)('listPlugin');
const $bc4a387287845f9d$export$18d4026d1ea86bb1 = $bc4a387287845f9d$var$listPluginKey;
const $bc4a387287845f9d$var$initialState = {
    bulletListActive: false,
    bulletListDisabled: false,
    orderedListActive: false,
    orderedListDisabled: false,
    decorationSet: (0, $a3b9P.DecorationSet).empty,
    listStructureToken: 0
};
/**
 * Numbered lists whose item counters reach 2+ digits need extra gutter spacing so the counter
 * does not collide with the item content.
 */ const $bc4a387287845f9d$var$getItemCounterPaddingStyle = (node)=>{
    var _node$attrs;
    if (node.type.name !== 'orderedList') return undefined;
    const digitsSize = (0, $4EVbq.getItemCounterDigitsSize)({
        itemsCount: node === null || node === void 0 ? void 0 : node.childCount,
        order: node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.order
    });
    return digitsSize && digitsSize > 1 ? (0, $fMCeS.getOrderedListInlineStyles)(digitsSize, 'string') : undefined;
};
/**
 * Builds the decorations for a range aligned to top-level block boundaries — or for the whole
 * document, which is the same thing.
 *
 * Indentation level is no longer decorated: the `:is(ul, ol)` rules in
 * `editor-core/src/ui/EditorContentContainer/styles/list.ts` derive the marker from the list's
 * ancestors in CSS instead. All that remains is the ordered-list counter gutter, which depends on
 * the item count and start number and so cannot be expressed as a selector.
 *
 * Textblocks only hold inline content, so they can never contain a list. Skipping their subtrees
 * avoids visiting every text node in the range.
 */ const $bc4a387287845f9d$var$getDecorationsForRange = (doc, from, to)=>{
    const decorations = [];
    doc.nodesBetween(from, to, (node, currentNodeStartPos)=>{
        if (node.isTextblock) return false;
        const style = $bc4a387287845f9d$var$getItemCounterPaddingStyle(node);
        if (style) decorations.push((0, $a3b9P.Decoration).node(currentNodeStartPos, currentNodeStartPos + node.nodeSize, {
            style: style
        }));
        return true;
    });
    return decorations;
};
const $bc4a387287845f9d$export$784ca90d67c37251 = (doc)=>(0, $a3b9P.DecorationSet).empty.add(doc, $bc4a387287845f9d$var$getDecorationsForRange(doc, 0, doc.content.size));
/**
 * Expands the ranges touched by a transaction out to whole top-level blocks. A list decoration
 * depends only on the subtree of the top-level block containing it, so recomputing whole blocks is
 * enough — and it keeps the depth calculation free of any ancestor accounting.
 */ const $bc4a387287845f9d$var$getDirtyTopLevelRanges = (tr, doc)=>{
    const docSize = doc.content.size;
    const wholeDoc = [
        {
            from: 0,
            to: docSize
        }
    ];
    const boundsAt = (pos)=>{
        // resolving a position strictly inside a block gives us its boundaries in O(depth)
        const inside = Math.max(1, Math.min(pos, Math.max(1, docSize - 1)));
        const $inside = doc.resolve(inside);
        if ($inside.depth > 0) return {
            from: $inside.before(1),
            to: $inside.after(1)
        };
        // exactly between two top-level blocks — cover both neighbours
        const $before = doc.resolve(Math.max(1, inside - 1));
        const $after = doc.resolve(Math.min(Math.max(1, docSize - 1), inside + 1));
        return {
            from: $before.depth > 0 ? $before.before(1) : 0,
            to: $after.depth > 0 ? $after.after(1) : docSize
        };
    };
    const ranges = [];
    for(let index = 0; index < tr.steps.length; index++){
        const step = tr.steps[index];
        // Duck-typed rather than matched on step class so that unknown step types fall back to a
        // full recompute instead of being silently skipped.
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const { from: from, to: to, pos: pos } = step;
        const positions = typeof from === 'number' && typeof to === 'number' ? [
            from,
            to
        ] : typeof pos === 'number' ? [
            pos
        ] : [];
        if (positions.length === 0) return wholeDoc;
        // Step positions are in the document before this step, so map through the later steps. The
        // range start is biased left and the end biased right, so that neither slides across a
        // block boundary and leaves a dirty block out of the recompute.
        const remainder = tr.mapping.slice(index);
        const start = boundsAt(remainder.map(Math.min(...positions), -1));
        const end = boundsAt(remainder.map(Math.max(...positions), 1));
        ranges.push({
            from: Math.min(start.from, end.from),
            to: Math.max(start.to, end.to)
        });
    }
    ranges.sort((a, b)=>a.from - b.from);
    const merged = [];
    for (const range of ranges){
        const last = merged[merged.length - 1];
        if (last && range.from <= last.to) last.to = Math.max(last.to, range.to);
        else merged.push({
            ...range
        });
    }
    return merged;
};
const $bc4a387287845f9d$export$77a59c867f92cbc7 = (previousDecorationSet, tr, doc)=>{
    let decorationSet = previousDecorationSet.map(tr.mapping, doc);
    for (const { from: from, to: to } of $bc4a387287845f9d$var$getDirtyTopLevelRanges(tr, doc)){
        // find() also returns decorations that merely touch the range, so removal is restricted to
        // the ones fully inside it — those are exactly the decorations recomputed below. Removing a
        // decoration that only touches the boundary would drop it permanently.
        const stale = decorationSet.find(from, to).filter((decoration)=>decoration.from >= from && decoration.to <= to);
        if (stale.length > 0) decorationSet = decorationSet.remove(stale);
        const fresh = $bc4a387287845f9d$var$getDecorationsForRange(doc, from, to);
        if (fresh.length > 0) decorationSet = decorationSet.add(doc, fresh);
    }
    return decorationSet;
};
/**
 * The selection-derived part of the plugin state. `decorationSet` and `listStructureToken` are
 * excluded because they depend on the previous state rather than on the current selection.
 */ const $bc4a387287845f9d$var$getListState = (doc, selection)=>{
    const { bulletList: bulletList, orderedList: orderedList, taskList: taskList } = doc.type.schema.nodes;
    const listParent = (0, $gab48.findParentNodeOfType)([
        bulletList,
        orderedList,
        taskList
    ])(selection);
    const bulletListActive = !!listParent && listParent.node.type === bulletList;
    const orderedListActive = !!listParent && listParent.node.type === orderedList;
    const bulletListDisabled = !(bulletListActive || orderedListActive || (0, $9fsJn.isWrappingPossible)(bulletList, selection));
    const orderedListDisabled = !(bulletListActive || orderedListActive || (0, $9fsJn.isWrappingPossible)(orderedList, selection));
    return {
        bulletListActive: bulletListActive,
        bulletListDisabled: bulletListDisabled,
        orderedListActive: orderedListActive,
        orderedListDisabled: orderedListDisabled
    };
};
/**
 * Bumps `listStructureToken` only when the selection sits inside a list, so that editing a
 * document with no list involvement does not churn toolbar renders.
 */ const $bc4a387287845f9d$var$withListStructureToken = (nextPluginState, pluginState)=>{
    const isInList = nextPluginState.bulletListActive || nextPluginState.orderedListActive || pluginState.bulletListActive || pluginState.orderedListActive;
    return isInList ? pluginState.listStructureToken + 1 : pluginState.listStructureToken;
};
const $bc4a387287845f9d$var$handleDocChanged = (tr, pluginState)=>{
    const nextPluginState = $bc4a387287845f9d$var$handleSelectionChanged(tr, pluginState);
    return {
        ...nextPluginState,
        decorationSet: $bc4a387287845f9d$export$77a59c867f92cbc7(pluginState.decorationSet, tr, tr.doc),
        listStructureToken: $bc4a387287845f9d$var$withListStructureToken(nextPluginState, pluginState)
    };
};
const $bc4a387287845f9d$var$handleSelectionChanged = (tr, pluginState)=>{
    const { bulletListActive: bulletListActive, orderedListActive: orderedListActive, bulletListDisabled: bulletListDisabled, orderedListDisabled: orderedListDisabled } = $bc4a387287845f9d$var$getListState(tr.doc, tr.selection);
    if (bulletListActive !== pluginState.bulletListActive || orderedListActive !== pluginState.orderedListActive || bulletListDisabled !== pluginState.bulletListDisabled || orderedListDisabled !== pluginState.orderedListDisabled) {
        const nextPluginState = {
            ...pluginState,
            bulletListActive: bulletListActive,
            orderedListActive: orderedListActive,
            bulletListDisabled: bulletListDisabled,
            orderedListDisabled: orderedListDisabled
        };
        return nextPluginState;
    }
    return pluginState;
};
const $bc4a387287845f9d$var$reducer = ()=>(state)=>{
        return state;
    };
const $bc4a387287845f9d$var$createInitialState = (api)=>(state)=>{
        const isToolbarAIFCEnabled = Boolean(api === null || api === void 0 ? void 0 : api.toolbar);
        return {
            // When plugin is initialised, editor state is defined with selection
            // hence returning the list state based on the selection to avoid list button in primary toolbar flickering during initial load
            ...isToolbarAIFCEnabled ? $bc4a387287845f9d$var$getListState(state.doc, state.selection) : $bc4a387287845f9d$var$initialState,
            decorationSet: $bc4a387287845f9d$export$784ca90d67c37251(state.doc),
            listStructureToken: 0
        };
    };
const $bc4a387287845f9d$export$ae829ec7b2625219 = (eventDispatch, _featureFlags, api)=>{
    const { getPluginState: getPluginState, createPluginState: createPluginState } = (0, $3TnFr.pluginFactory)($bc4a387287845f9d$var$listPluginKey, $bc4a387287845f9d$var$reducer(), {
        onDocChanged: $bc4a387287845f9d$var$handleDocChanged,
        onSelectionChanged: $bc4a387287845f9d$var$handleSelectionChanged
    });
    return new (0, $f7Kk4.SafePlugin)({
        state: createPluginState(eventDispatch, $bc4a387287845f9d$var$createInitialState(api)),
        key: $bc4a387287845f9d$var$listPluginKey,
        appendTransaction (transactions, _oldState, newState) {
            if (!transactions.some((t)=>t.docChanged)) return null;
            // Efficiently scans only affected list nodes — exits early if none are found.
            const tr = (0, $kWmG3.applyListNormalisationFixes)({
                tr: newState.tr,
                transactions: transactions,
                doc: newState.doc,
                schema: newState.schema
            });
            if (tr.docChanged) return tr;
            return null;
        },
        props: {
            decorations (state) {
                const { decorationSet: decorationSet } = getPluginState(state);
                return decorationSet;
            },
            handleClick: (view, pos, event)=>{
                const { state: state } = view;
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                if ([
                    'LI',
                    'UL'
                ].includes((event === null || event === void 0 ? void 0 : event.target).tagName)) {
                    var _nodeAtPos$firstChild;
                    const nodeAtPos = state.tr.doc.nodeAt(pos);
                    const { listItem: listItem, codeBlock: codeBlock } = view.state.schema.nodes;
                    if ((nodeAtPos === null || nodeAtPos === void 0 ? void 0 : nodeAtPos.type) === listItem && (nodeAtPos === null || nodeAtPos === void 0 || (_nodeAtPos$firstChild = nodeAtPos.firstChild) === null || _nodeAtPos$firstChild === void 0 ? void 0 : _nodeAtPos$firstChild.type) === codeBlock) {
                        var _document;
                        const bufferPx = 50;
                        const isCodeBlockNextToListMarker = Boolean((_document = document) === null || _document === void 0 || (_document = _document.elementFromPoint(event.clientX + ((0, $fMCeS.listItemCounterPadding) + bufferPx), event.clientY)) === null || _document === void 0 ? void 0 : _document.closest(`.${(0, $1J9lh.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER}`));
                        if (isCodeBlockNextToListMarker) {
                            // +1 needed to put cursor inside li
                            // otherwise gap cursor markup will be injected as immediate child of ul resulting in invalid html
                            (0, $8HYXC.setGapCursorSelection)(view, pos + 1, (0, $8t2a4.Side).LEFT);
                            return true;
                        }
                    }
                }
                return false;
            }
        }
    });
};

});
parcelRegister("8HYXC", function(module, exports) {
$parcel$export(module.exports, "setGapCursorSelection", () => $5b3603cc1564bb79$export$a8946811e8b82dd);

var $j7pt0 = parcelRequire("j7pt0");
function $5b3603cc1564bb79$export$a8946811e8b82dd(view, pos, side) {
    const { state: state } = view;
    view.dispatch(state.tr.setSelection(new (0, $j7pt0.GapCursorSelection)(state.doc.resolve(pos), side)));
}

});


parcelRegister("7fMgH", function(module, exports) {
$parcel$export(module.exports, "getListComponents", () => $adf0beeb5c1bd516$export$eb84e5278d4ad5e0);

var $30Yan = parcelRequire("30Yan");

var $fY4jW = parcelRequire("fY4jW");

var $3y2s4 = parcelRequire("3y2s4");

var $49N9T = parcelRequire("49N9T");

var $am4At = parcelRequire("am4At");
const $adf0beeb5c1bd516$var$BULLET_LIST_NODE_NAME = 'bulletList';
const $adf0beeb5c1bd516$var$ORDERED_LIST_NODE_NAME = 'orderedList';
const $adf0beeb5c1bd516$export$eb84e5278d4ad5e0 = (api)=>{
    const isSmallTextExperimentEnabled = (0, $3y2s4.isExperimentEnabled)('platform_editor_block_menu_small_text');
    const parentKey = isSmallTextExperimentEnabled ? (0, $30Yan.TRANSFORM_TEXTFORMATTING_MENU_SECTION).key : (0, $30Yan.TRANSFORM_STRUCTURE_MENU_SECTION).key;
    const rank = isSmallTextExperimentEnabled ? (0, $fY4jW.TRANSFORM_TEXT_FORMATTING_MENU_SECTION_RANK) : (0, $fY4jW.TRANSFORM_STRUCTURE_MENU_SECTION_RANK);
    return [
        {
            type: 'block-menu-item',
            key: (0, $30Yan.TRANSFORM_STRUCTURE_BULLETED_LIST_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: parentKey,
                rank: rank[(0, $30Yan.TRANSFORM_STRUCTURE_BULLETED_LIST_MENU_ITEM).key]
            },
            component: (0, $49N9T.createBulletedListBlockMenuItem)({
                api: api
            }),
            isHidden: ()=>{
                var _api$blockMenu;
                return Boolean(api === null || api === void 0 || (_api$blockMenu = api.blockMenu) === null || _api$blockMenu === void 0 ? void 0 : _api$blockMenu.actions.isTransformOptionDisabled($adf0beeb5c1bd516$var$BULLET_LIST_NODE_NAME));
            }
        },
        {
            type: 'block-menu-item',
            key: (0, $30Yan.TRANSFORM_STRUCTURE_NUMBERED_LIST_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: parentKey,
                rank: rank[(0, $30Yan.TRANSFORM_STRUCTURE_NUMBERED_LIST_MENU_ITEM).key]
            },
            component: (0, $am4At.createNumberedListBlockMenuItem)({
                api: api
            }),
            isHidden: ()=>{
                var _api$blockMenu2;
                return Boolean(api === null || api === void 0 || (_api$blockMenu2 = api.blockMenu) === null || _api$blockMenu2 === void 0 ? void 0 : _api$blockMenu2.actions.isTransformOptionDisabled($adf0beeb5c1bd516$var$ORDERED_LIST_NODE_NAME));
            }
        }
    ];
};

});
parcelRegister("49N9T", function(module, exports) {
$parcel$export(module.exports, "createBulletedListBlockMenuItem", () => $b2b4306fea6be888$export$a10d73d60d04133e);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $g6Qq4 = parcelRequire("g6Qq4");

var $anv2i = parcelRequire("anv2i");

var $dbuPt = parcelRequire("dbuPt");

var $kUZ0E = parcelRequire("kUZ0E");
const $b2b4306fea6be888$var$NODE_NAME = 'bulletList';
const $b2b4306fea6be888$var$BulletedListBlockMenuItem = ({ api: api, isSuggested: isSuggested })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const handleClick = (event)=>{
        const triggeredFrom = event.nativeEvent instanceof KeyboardEvent || event.nativeEvent.detail === 0 ? (0, $g6Qq4.INPUT_METHOD).KEYBOARD : (0, $g6Qq4.INPUT_METHOD).MOUSE;
        const inputMethod = (0, $g6Qq4.INPUT_METHOD).BLOCK_MENU;
        api === null || api === void 0 || api.core.actions.execute(({ tr: tr })=>{
            var _api$blockMenu;
            const command = api === null || api === void 0 || (_api$blockMenu = api.blockMenu) === null || _api$blockMenu === void 0 ? void 0 : _api$blockMenu.commands.transformNode(tr.doc.type.schema.nodes.bulletList, {
                inputMethod: inputMethod,
                isSuggested: isSuggested,
                triggeredFrom: triggeredFrom,
                targetTypeName: $b2b4306fea6be888$var$NODE_NAME
            });
            return command ? command({
                tr: tr
            }) : null;
        });
    };
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dbuPt.ToolbarDropdownItem), {
        onClick: handleClick,
        elemBefore: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kUZ0E))), {
            label: "",
            size: "small"
        }),
        children: formatMessage((0, $anv2i.messages).bulletedList)
    });
};
const $b2b4306fea6be888$export$a10d73d60d04133e = ({ api: api })=>{
    return ({ isSuggested: isSuggested } = {})=>/*#__PURE__*/ (0, $dc70d.jsx)($b2b4306fea6be888$var$BulletedListBlockMenuItem, {
            api: api,
            isSuggested: isSuggested
        });
};

});

parcelRegister("am4At", function(module, exports) {
$parcel$export(module.exports, "createNumberedListBlockMenuItem", () => $04542e03372900fb$export$43d7befaff491a1f);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $g6Qq4 = parcelRequire("g6Qq4");

var $anv2i = parcelRequire("anv2i");

var $dbuPt = parcelRequire("dbuPt");

var $3aSEM = parcelRequire("3aSEM");
const $04542e03372900fb$var$NODE_NAME = 'orderedList';
const $04542e03372900fb$var$NumberedListBlockMenuItem = ({ api: api, isSuggested: isSuggested })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const handleClick = (event)=>{
        const triggeredFrom = event.nativeEvent instanceof KeyboardEvent || event.nativeEvent.detail === 0 ? (0, $g6Qq4.INPUT_METHOD).KEYBOARD : (0, $g6Qq4.INPUT_METHOD).MOUSE;
        const inputMethod = (0, $g6Qq4.INPUT_METHOD).BLOCK_MENU;
        api === null || api === void 0 || api.core.actions.execute(({ tr: tr })=>{
            var _api$blockMenu;
            const command = api === null || api === void 0 || (_api$blockMenu = api.blockMenu) === null || _api$blockMenu === void 0 ? void 0 : _api$blockMenu.commands.transformNode(tr.doc.type.schema.nodes.orderedList, {
                inputMethod: inputMethod,
                isSuggested: isSuggested,
                triggeredFrom: triggeredFrom,
                targetTypeName: $04542e03372900fb$var$NODE_NAME
            });
            return command ? command({
                tr: tr
            }) : null;
        });
    };
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dbuPt.ToolbarDropdownItem), {
        onClick: handleClick,
        elemBefore: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3aSEM))), {
            label: "",
            size: "small"
        }),
        children: formatMessage((0, $anv2i.messages).orderedList)
    });
};
const $04542e03372900fb$export$43d7befaff491a1f = ({ api: api })=>{
    return ({ isSuggested: isSuggested } = {})=>/*#__PURE__*/ (0, $dc70d.jsx)($04542e03372900fb$var$NumberedListBlockMenuItem, {
            api: api,
            isSuggested: isSuggested
        });
};

});


parcelRegister("Jdyi6", function(module, exports) {
$parcel$export(module.exports, "getListQuickInsertComponents", () => $6e55d1c6e8784654$export$863f69203d9d228a);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $cv8id = parcelRequire("cv8id");

var $anv2i = parcelRequire("anv2i");

var $b8Hvx = parcelRequire("b8Hvx");

var $9woaI = parcelRequire("9woaI");

var $am2Qg = parcelRequire("am2Qg");

var $d8083 = parcelRequire("d8083");
const $6e55d1c6e8784654$export$863f69203d9d228a = ({ api: api })=>[
        {
            item: (0, $9woaI.UNORDERED_LIST_MENU_ITEM),
            type: 'unordered'
        },
        {
            item: (0, $9woaI.ORDERED_LIST_MENU_ITEM),
            type: 'ordered'
        }
    ].map(({ item: item, type: type })=>{
        const isOrdered = type === 'ordered';
        return {
            key: item.key,
            type: item.type,
            parents: [
                {
                    key: (0, $9woaI.TEXT_FORMATTING_SECTION).key,
                    type: (0, $9woaI.TEXT_FORMATTING_SECTION).type,
                    rank: (0, $am2Qg.TEXT_FORMATTING_SECTION_RANK)[item.key]
                }
            ],
            match: (0, $b8Hvx.createQuickInsertMatcher)(({ formatMessage: formatMessage })=>({
                    description: formatMessage(isOrdered ? (0, $anv2i.messages).orderedListDescription : (0, $anv2i.messages).unorderedListDescription),
                    keywords: isOrdered ? [
                        'ol',
                        'ordered'
                    ] : [
                        'ul',
                        'unordered'
                    ],
                    shortcut: (0, $cv8id.tooltip)(isOrdered ? (0, $cv8id.toggleOrderedList) : (0, $cv8id.toggleBulletList)),
                    title: formatMessage(isOrdered ? (0, $anv2i.messages).orderedList : (0, $anv2i.messages).unorderedList)
                })),
            component: ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $d8083.ListQuickInsertMenuItem), {
                    api: api,
                    type: type
                })
        };
    });

});
parcelRegister("d8083", function(module, exports) {
$parcel$export(module.exports, "ListQuickInsertMenuItem", () => $994dd565874cf042$export$b59ff37788c63e2);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $g6Qq4 = parcelRequire("g6Qq4");

var $cv8id = parcelRequire("cv8id");

var $anv2i = parcelRequire("anv2i");

var $fT9mF = parcelRequire("fT9mF");

var $64eKJ = parcelRequire("64eKJ");

var $kUZ0E = parcelRequire("kUZ0E");

var $3aSEM = parcelRequire("3aSEM");
const $994dd565874cf042$var$previewImageUrls = {
    ordered: {
        dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVHU.png',
        light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVLU.png'
    },
    unordered: {
        dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVHR.png',
        light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVMP.png'
    }
};
const $994dd565874cf042$export$b59ff37788c63e2 = ({ api: api, type: type })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const isOrdered = type === 'ordered';
    const preview = (0, $bSJIT.useMemo)(()=>({
            image: $994dd565874cf042$var$previewImageUrls[type],
            attribution: {
                name: formatMessage((0, $64eKJ.messages).previewAttributionAtlassian)
            }
        }), [
        formatMessage,
        type
    ]);
    const onSelect = (0, $bSJIT.useCallback)(({ editorView: editorView, insert: insert, source: source })=>{
        var _api$analytics;
        const { schema: schema } = editorView.state;
        const listNode = isOrdered ? schema.nodes.orderedList : schema.nodes.bulletList;
        const actionSubjectId = isOrdered ? (0, $g6Qq4.ACTION_SUBJECT_ID).FORMAT_LIST_NUMBER : (0, $g6Qq4.ACTION_SUBJECT_ID).FORMAT_LIST_BULLET;
        const tr = insert(listNode.createChecked({}, schema.nodes.listItem.createChecked({}, schema.nodes.paragraph.createChecked())));
        api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 || _api$analytics.actions.attachAnalyticsEvent({
            action: (0, $g6Qq4.ACTION).INSERTED,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).LIST,
            actionSubjectId: actionSubjectId,
            attributes: {
                inputMethod: source
            },
            eventType: (0, $g6Qq4.EVENT_TYPE).TRACK
        })(tr);
        return tr;
    }, [
        api,
        isOrdered
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $fT9mF.QuickInsertMenuItem), {
        description: formatMessage(isOrdered ? (0, $anv2i.messages).orderedListDescription : (0, $anv2i.messages).unorderedListDescription),
        iconBefore: isOrdered ? /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3aSEM))), {
            label: ""
        }) : /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kUZ0E))), {
            label: ""
        }),
        onSelect: onSelect,
        preview: preview,
        shortcut: (0, $cv8id.tooltip)(isOrdered ? (0, $cv8id.toggleOrderedList) : (0, $cv8id.toggleBulletList)),
        title: formatMessage(isOrdered ? (0, $anv2i.messages).orderedList : (0, $anv2i.messages).unorderedList)
    });
};

});



parcelRegister("jYlNA", function(module, exports) {
$parcel$export(module.exports, "mediaPlugin", () => $418f8591f112714b$export$a4dd0667e1feabbd);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $g6Qq4 = parcelRequire("g6Qq4");

var $5BUNL = parcelRequire("5BUNL");

var $cW1gB = parcelRequire("cW1gB");

var $f7Kk4 = parcelRequire("f7Kk4");

var $8qHhy = parcelRequire("8qHhy");

var $5beht = parcelRequire("5beht");

var $cw0wu = parcelRequire("cw0wu");

var $97BF5 = parcelRequire("97BF5");

var $3y2s4 = parcelRequire("3y2s4");

var $3vZrB = parcelRequire("3vZrB");

var $8Maqs = parcelRequire("8Maqs");

var $2r6Qo = parcelRequire("2r6Qo");

var $lOIBf = parcelRequire("lOIBf");

var $e8F5x = parcelRequire("e8F5x");

var $1CuAQ = parcelRequire("1CuAQ");

var $bMuqp = parcelRequire("bMuqp");

var $7kOM6 = parcelRequire("7kOM6");

var $kZf5n = parcelRequire("kZf5n");

var $dnBXh = parcelRequire("dnBXh");

var $8QWMu = parcelRequire("8QWMu");

var $klddC = parcelRequire("klddC");

var $3R6b9 = parcelRequire("3R6b9");

var $8vv0U = parcelRequire("8vv0U");

var $ki6Uz = parcelRequire("ki6Uz");

var $9y8VT = parcelRequire("9y8VT");

var $2jJHo = parcelRequire("2jJHo");

var $9iI02 = parcelRequire("9iI02");

var $7ICJC = parcelRequire("7ICJC");

var $4sVoN = parcelRequire("4sVoN");

var $jmBd6 = parcelRequire("jmBd6");

var $ieBDn = parcelRequire("ieBDn");

var $7zSFj = parcelRequire("7zSFj");

var $2L3c8 = parcelRequire("2L3c8");

var $cG8zd = parcelRequire("cG8zd");
const $418f8591f112714b$var$selector = (states)=>{
    var _states$mediaState, _states$mediaState2;
    return {
        onPopupToggle: (_states$mediaState = states.mediaState) === null || _states$mediaState === void 0 ? void 0 : _states$mediaState.onPopupToggle,
        setBrowseFn: (_states$mediaState2 = states.mediaState) === null || _states$mediaState2 === void 0 ? void 0 : _states$mediaState2.setBrowseFn
    };
};
const $418f8591f112714b$var$MediaPickerFunctionalComponent = ({ api: api, editorDomElement: editorDomElement, appearance: appearance })=>{
    const { onPopupToggle: onPopupToggle, setBrowseFn: setBrowseFn } = (0, $5beht.useSharedPluginStateWithSelector)(api, [
        'media'
    ], $418f8591f112714b$var$selector);
    if (!onPopupToggle || !setBrowseFn) return null;
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $ieBDn.MediaPickerComponents), {
        onPopupToggle: onPopupToggle,
        setBrowseFn: setBrowseFn,
        editorDomElement: editorDomElement,
        appearance: appearance,
        api: api
    });
};
const $418f8591f112714b$var$mediaViewerStateSelector = (states)=>{
    var _states$mediaState3, _states$mediaState4, _states$mediaState5;
    return {
        isMediaViewerVisible: (_states$mediaState3 = states.mediaState) === null || _states$mediaState3 === void 0 ? void 0 : _states$mediaState3.isMediaViewerVisible,
        mediaViewerSelectedMedia: (_states$mediaState4 = states.mediaState) === null || _states$mediaState4 === void 0 ? void 0 : _states$mediaState4.mediaViewerSelectedMedia,
        mediaClientConfig: (_states$mediaState5 = states.mediaState) === null || _states$mediaState5 === void 0 ? void 0 : _states$mediaState5.mediaClientConfig
    };
};
const $418f8591f112714b$var$MediaViewerFunctionalComponent = ({ api: api, editorView: editorView, mediaViewerExtensions: mediaViewerExtensions, fallbackMediaNameFetcher: fallbackMediaNameFetcher })=>{
    // Only traverse document once when media viewer is visible, media viewer items will not update
    // when document changes are made while media viewer is open
    const { isMediaViewerVisible: isMediaViewerVisible, mediaViewerSelectedMedia: mediaViewerSelectedMedia, mediaClientConfig: mediaClientConfig } = (0, $5beht.useSharedPluginStateWithSelector)(api, [
        'media'
    ], $418f8591f112714b$var$mediaViewerStateSelector);
    const mediaItems = (0, $bSJIT.useMemo)(()=>{
        if (isMediaViewerVisible) {
            const mediaNodes = (0, $4sVoN.extractMediaNodes)(editorView.state.doc);
            return (0, $4sVoN.createMediaIdentifierArray)(mediaNodes);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- only update mediaItems once when media viewer is visible
    }, [
        isMediaViewerVisible
    ]);
    // Viewer does not have required attributes to render the media viewer
    if (!isMediaViewerVisible || !mediaViewerSelectedMedia || !mediaClientConfig) return null;
    const handleOnClose = ()=>{
        // Run Command to hide the media viewer
        api === null || api === void 0 || api.core.actions.execute(api === null || api === void 0 ? void 0 : api.media.commands.hideMediaViewer);
    };
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $7zSFj.RenderMediaViewer), {
        mediaClientConfig: mediaClientConfig,
        onClose: handleOnClose,
        selectedNodeAttrs: mediaViewerSelectedMedia,
        items: mediaItems,
        extensions: mediaViewerExtensions,
        fallbackMediaNameFetcher: fallbackMediaNameFetcher
    });
};
const $418f8591f112714b$export$a4dd0667e1feabbd = ({ config: options = {}, api: api })=>{
    var _api$analytics3;
    let previousMediaProvider;
    const mediaErrorLocalIds = new Set();
    return {
        name: 'media',
        getSharedState (editorState) {
            if (!editorState) return null;
            return (0, $7ICJC.stateKey).getState(editorState) || null;
        },
        actions: {
            handleMediaNodeRenderError: (node, reason, nestedUnder)=>{
                var _api$analytics;
                let isDuplicateError = false;
                if ((0, $3y2s4.isExperimentEnabled)('platform_editor_media_reliability_observability')) {
                    if (mediaErrorLocalIds.has(node.attrs.localId)) // we mark duplicate errors in the case of nested media nodes
                    // renderering to avoid firing multiple errored events for the same underlying issue,
                    // which can happen more often with nested media nodes
                    isDuplicateError = true;
                    else mediaErrorLocalIds.add(node.attrs.localId);
                }
                api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 || _api$analytics.actions.fireAnalyticsEvent({
                    action: (0, $g6Qq4.ACTION).ERRORED,
                    actionSubject: (0, $g6Qq4.ACTION_SUBJECT).EDITOR,
                    actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).MEDIA,
                    eventType: (0, $g6Qq4.EVENT_TYPE).UI,
                    attributes: {
                        reason: reason,
                        external: node.attrs.__external,
                        ...nestedUnder ? {
                            nestedUnder: nestedUnder
                        } : {},
                        isDuplicateError: isDuplicateError
                    }
                });
            },
            insertMediaAsMediaSingle: (view, node, inputMethod, insertMediaVia)=>{
                var _api$analytics2;
                return (0, $jmBd6.insertMediaAsMediaSingle)(view, node, inputMethod, api === null || api === void 0 || (_api$analytics2 = api.analytics) === null || _api$analytics2 === void 0 ? void 0 : _api$analytics2.actions, insertMediaVia, options === null || options === void 0 ? void 0 : options.allowPixelResizing);
            },
            setProvider: (provider)=>{
                // Prevent someone trying to set the exact same provider twice for performance reasons
                if (previousMediaProvider === provider) return false;
                previousMediaProvider = provider;
                return (api === null || api === void 0 ? void 0 : api.core.actions.execute(({ tr: tr })=>tr.setMeta((0, $7ICJC.stateKey), {
                        mediaProvider: provider
                    }))) ?? false;
            }
        },
        commands: {
            showMediaViewer: $klddC.showMediaViewer,
            hideMediaViewer: $klddC.hideMediaViewer,
            trackMediaPaste: $klddC.trackMediaPaste,
            setAIGenerating: $klddC.setAIGenerating,
            clearAIGenerating: $klddC.clearAIGenerating,
            insertMediaSingle: (0, $klddC.insertMediaAsMediaSingleCommand)(api === null || api === void 0 || (_api$analytics3 = api.analytics) === null || _api$analytics3 === void 0 ? void 0 : _api$analytics3.actions, options.allowPixelResizing)
        },
        nodes () {
            const { allowMediaGroup: allowMediaGroup = true, allowMediaSingle: allowMediaSingle = false, allowPixelResizing: allowPixelResizing = false, allowCaptions: allowCaptions, featureFlags: mediaFeatureFlags } = options || {};
            const allowMediaInline = (0, $97BF5.getMediaFeatureFlag)('mediaInline', mediaFeatureFlags);
            const mediaSingleOption = {
                withCaption: allowCaptions,
                withExtendedWidthTypes: allowPixelResizing
            };
            return [
                {
                    name: 'mediaGroup',
                    node: (0, $1CuAQ.mediaGroupSpecWithFixedToDOM)()
                },
                {
                    name: 'mediaSingle',
                    node: (0, $7kOM6.mediaSingleSpecWithFixedToDOM)(mediaSingleOption)
                },
                {
                    name: 'media',
                    node: (0, $e8F5x.mediaSpecWithFixedToDOM)()
                },
                {
                    name: 'mediaInline',
                    node: (0, $bMuqp.mediaInlineSpecWithFixedToDOM)()
                }
            ].filter((node)=>{
                if (node.name === 'mediaGroup') return allowMediaGroup;
                if (node.name === 'mediaSingle') return allowMediaSingle;
                if (node.name === 'mediaInline') return allowMediaInline;
                return true;
            });
        },
        pmPlugins () {
            const pmPlugins = [
                {
                    name: 'media',
                    plugin: ({ schema: schema, dispatch: dispatch, getIntl: getIntl, eventDispatcher: eventDispatcher, providerFactory: providerFactory, errorReporter: errorReporter, portalProviderAPI: portalProviderAPI, dispatchAnalyticsEvent: dispatchAnalyticsEvent, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>{
                        return (0, $2jJHo.createPlugin)(schema, {
                            providerFactory: providerFactory,
                            nodeViews: {
                                mediaGroup: (0, $3vZrB.lazyMediaGroupView)(portalProviderAPI, eventDispatcher, providerFactory, options, api, getIntl()),
                                mediaSingle: (0, $lOIBf.ReactMediaSingleNode)(portalProviderAPI, eventDispatcher, providerFactory, api, dispatchAnalyticsEvent, options, getIntl()),
                                media: (0, $2r6Qo.ReactMediaNode)(portalProviderAPI, eventDispatcher, providerFactory, options, api, getIntl()),
                                mediaInline: (0, $8Maqs.lazyMediaInlineView)(portalProviderAPI, eventDispatcher, providerFactory, api, undefined, options === null || options === void 0 ? void 0 : options.fallbackMediaNameFetcher, getIntl())
                            },
                            errorReporter: errorReporter,
                            uploadErrorHandler: options && options.uploadErrorHandler,
                            waitForMediaUpload: options && options.waitForMediaUpload,
                            customDropzoneContainer: options && options.customDropzoneContainer,
                            customMediaPicker: options && options.customMediaPicker,
                            allowResizing: !!(options && options.allowResizing),
                            fallbackMediaNameFetcher: options && options.fallbackMediaNameFetcher
                        }, getIntl, api, nodeViewPortalProviderAPI, dispatch, options);
                    }
                },
                {
                    name: 'mediaKeymap',
                    plugin: ({ getIntl: getIntl })=>{
                        var _api$analytics4, _api$selection;
                        return (0, $3R6b9.default)(options, api === null || api === void 0 || (_api$analytics4 = api.analytics) === null || _api$analytics4 === void 0 ? void 0 : _api$analytics4.actions, api === null || api === void 0 || (_api$selection = api.selection) === null || _api$selection === void 0 ? void 0 : _api$selection.actions, api === null || api === void 0 ? void 0 : api.width, getIntl);
                    }
                }
            ];
            if (options && options.allowMediaSingle) pmPlugins.push({
                name: 'mediaSingleKeymap',
                plugin: ({ schema: schema })=>(0, $8vv0U.default)(schema)
            });
            if (options && options.allowAltTextOnImages) {
                pmPlugins.push({
                    name: 'mediaAltText',
                    plugin: (0, $dnBXh.createPlugin)
                });
                pmPlugins.push({
                    name: 'mediaAltTextKeymap',
                    plugin: ({ schema: schema })=>{
                        var _api$analytics5;
                        return (0, $8QWMu.default)(schema, api === null || api === void 0 || (_api$analytics5 = api.analytics) === null || _api$analytics5 === void 0 ? void 0 : _api$analytics5.actions);
                    }
                });
            }
            if (options && options.allowLinking) {
                pmPlugins.push({
                    name: 'mediaLinking',
                    plugin: ({ dispatch: dispatch })=>(0, $ki6Uz.default)(dispatch)
                });
                pmPlugins.push({
                    name: 'mediaLinkingKeymap',
                    plugin: ({ schema: schema })=>(0, $9y8VT.default)(schema)
                });
            }
            if (options && options.allowAdvancedToolBarOptions && options.allowResizing && (0, $8qHhy.areToolbarFlagsEnabled)(Boolean(api === null || api === void 0 ? void 0 : api.toolbar)) && options.allowPixelResizing) pmPlugins.push({
                name: 'mediaPixelResizing',
                plugin: (0, $9iI02.createPlugin)
            });
            pmPlugins.push({
                name: 'mediaAIGeneratingDecoration',
                plugin: ()=>(0, $kZf5n.createAIGeneratingDecorationPlugin)()
            });
            pmPlugins.push({
                name: 'mediaSelectionHandler',
                plugin: ()=>{
                    const mediaSelectionHandlerPlugin = new (0, $f7Kk4.SafePlugin)({
                        key: new (0, $cw0wu.PluginKey)('mediaSelectionHandlerPlugin'),
                        props: {
                            handleScrollToSelection: (view)=>{
                                const { state: { selection: selection } } = view;
                                if (!(selection instanceof (0, $cw0wu.NodeSelection)) || selection.node.type.name !== 'media') return false;
                                const { node: node, offset: offset } = view.domAtPos(selection.from);
                                if (// Is the media element mounted already?
                                offset === node.childNodes.length) // Media is not ready, so stop the scroll request
                                return true;
                                // Media is ready, keep the scrolling request
                                return false;
                            }
                        }
                    });
                    return mediaSelectionHandlerPlugin;
                }
            });
            return pmPlugins;
        },
        contentComponent ({ editorView: editorView, appearance: appearance }) {
            if (!editorView) return null;
            return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $dc70d.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $dc70d.jsx)($418f8591f112714b$var$MediaViewerFunctionalComponent, {
                        api: api,
                        editorView: editorView,
                        mediaViewerExtensions: options === null || options === void 0 ? void 0 : options.mediaViewerExtensions,
                        fallbackMediaNameFetcher: options === null || options === void 0 ? void 0 : options.fallbackMediaNameFetcher
                    }),
                    /*#__PURE__*/ (0, $dc70d.jsx)($418f8591f112714b$var$MediaPickerFunctionalComponent, {
                        editorDomElement: editorView.dom,
                        appearance: appearance,
                        api: api
                    })
                ]
            });
        },
        secondaryToolbarComponent ({ disabled: disabled }) {
            return /*#__PURE__*/ (0, $dc70d.jsx)((0, $cG8zd.default), {
                isDisabled: disabled,
                isReducedSpacing: true,
                api: api
            });
        },
        pluginsOptions: {
            quickInsert: ({ formatMessage: formatMessage })=>!(api !== null && api !== void 0 && api.mediaInsert) ? [
                    {
                        id: 'media',
                        title: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).mediaFiles),
                        description: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).mediaFilesDescription),
                        priority: 400,
                        keywords: [
                            'attachment',
                            'gif',
                            'media',
                            'picture',
                            'image',
                            'video',
                            'file'
                        ],
                        icon: ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $5BUNL.IconImages), {}),
                        isDisabledOffline: true,
                        action (insert, state) {
                            var _api$analytics6;
                            const pluginState = (0, $7ICJC.stateKey).getState(state);
                            pluginState === null || pluginState === void 0 || pluginState.showMediaPicker();
                            const tr = insert('');
                            api === null || api === void 0 || (_api$analytics6 = api.analytics) === null || _api$analytics6 === void 0 || _api$analytics6.actions.attachAnalyticsEvent({
                                action: (0, $g6Qq4.ACTION).OPENED,
                                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).PICKER,
                                actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).PICKER_CLOUD,
                                attributes: {
                                    inputMethod: (0, $g6Qq4.INPUT_METHOD).QUICK_INSERT
                                },
                                eventType: (0, $g6Qq4.EVENT_TYPE).UI
                            })(tr);
                            return tr;
                        }
                    }
                ] : [],
            floatingToolbar: (state, intl, providerFactory)=>{
                var _api$editorViewMode;
                return (0, $2L3c8.floatingToolbar)(state, intl, {
                    providerFactory: providerFactory,
                    allowMediaInline: options && (0, $97BF5.getMediaFeatureFlag)('mediaInline', options.featureFlags),
                    allowResizing: options && options.allowResizing,
                    allowResizingInTables: options && options.allowResizingInTables,
                    allowCommentsOnMedia: options && options.allowCommentsOnMedia,
                    allowLinking: options && options.allowLinking,
                    allowAdvancedToolBarOptions: options && options.allowAdvancedToolBarOptions,
                    allowAltTextOnImages: options && options.allowAltTextOnImages,
                    allowImageEditing: !!(api !== null && api !== void 0 && api.mediaEditing) && options && options.allowImageEditing,
                    allowImagePreview: options && options.allowImagePreview,
                    altTextValidator: options && options.altTextValidator,
                    fullWidthEnabled: options && options.fullWidthEnabled,
                    allowMediaInlineImages: options && options.allowMediaInlineImages,
                    isViewOnly: (api === null || api === void 0 || (_api$editorViewMode = api.editorViewMode) === null || _api$editorViewMode === void 0 || (_api$editorViewMode = _api$editorViewMode.sharedState.currentState()) === null || _api$editorViewMode === void 0 ? void 0 : _api$editorViewMode.mode) === 'view',
                    allowPixelResizing: options === null || options === void 0 ? void 0 : options.allowPixelResizing,
                    onCommentButtonMount: options === null || options === void 0 ? void 0 : options.onCommentButtonMount,
                    createCommentExperience: options === null || options === void 0 ? void 0 : options.createCommentExperience
                }, api);
            }
        }
    };
};

});
parcelRegister("3vZrB", function(module, exports) {
$parcel$export(module.exports, "lazyMediaGroupView", () => $7487ba0ce8129135$export$a1a01149851636f0);

var $e1vJC = parcelRequire("e1vJC");
const $7487ba0ce8129135$export$a1a01149851636f0 = (portalProviderAPI, eventDispatcher, providerFactory, options = {}, api, intl)=>{
    return (0, $e1vJC.ReactMediaGroupNode)(portalProviderAPI, eventDispatcher, providerFactory, options, api, intl);
};

});
parcelRegister("e1vJC", function(module, exports) {
$parcel$export(module.exports, "ReactMediaGroupNode", () => $e7a1e731617d7cf7$export$dc2dedbaab4b1587);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $fRXfs = parcelRequire("fRXfs");

var $0Xboy = parcelRequire("0Xboy");

var $5beht = parcelRequire("5beht");

var $CrH9u = parcelRequire("CrH9u");

var $jTv7r = parcelRequire("jTv7r");

var $ess9d = parcelRequire("ess9d");
const $e7a1e731617d7cf7$var$selector = (states)=>{
    var _states$editorDisable, _states$editorViewMod;
    return {
        editorDisabled: (_states$editorDisable = states.editorDisabledState) === null || _states$editorDisable === void 0 ? void 0 : _states$editorDisable.editorDisabled,
        editorViewMode: (_states$editorViewMod = states.editorViewModeState) === null || _states$editorViewMod === void 0 ? void 0 : _states$editorViewMod.mode
    };
};
function $e7a1e731617d7cf7$var$MediaGroupNodeViewInternal({ renderFn: renderFn, pluginInjectionApi: pluginInjectionApi }) {
    const { editorDisabled: editorDisabled, editorViewMode: editorViewMode } = (0, $5beht.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'editorDisabled',
        'editorViewMode'
    ], $e7a1e731617d7cf7$var$selector);
    const mediaProvider = (0, $CrH9u.useMediaProvider)(pluginInjectionApi);
    return renderFn({
        editorDisabled: editorDisabled,
        editorViewMode: editorViewMode,
        mediaProvider: mediaProvider
    });
}
class $e7a1e731617d7cf7$var$MediaGroupNodeView extends (0, $0Xboy.default) {
    render(props, forwardRef) {
        const { providerFactory: providerFactory, mediaOptions: mediaOptions, pluginInjectionApi: pluginInjectionApi, intl: intl } = props;
        const getPos = this.getPos;
        return /*#__PURE__*/ (0, $dc70d.jsx)((0, $jTv7r.MediaSSRReactContextsProvider), {
            intl: intl,
            children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $fRXfs.WithProviders), {
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                providers: [
                    'contextIdentifierProvider'
                ],
                providerFactory: providerFactory,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                renderNode: ({ contextIdentifierProvider: contextIdentifierProvider })=>{
                    const renderFn = ({ mediaProvider: mediaProviderFromState, editorDisabled: editorDisabled, editorViewMode: editorViewMode })=>{
                        const mediaProvider = mediaProviderFromState ? Promise.resolve(mediaProviderFromState) : undefined;
                        return /*#__PURE__*/ (0, $dc70d.jsx)((0, $ess9d.MediaGroupNext), {
                            node: this.node,
                            getPos: getPos,
                            view: this.view,
                            forwardRef: forwardRef,
                            disabled: editorDisabled,
                            allowLazyLoading: mediaOptions.allowLazyLoading,
                            mediaProvider: mediaProvider,
                            contextIdentifierProvider: contextIdentifierProvider,
                            isCopyPasteEnabled: mediaOptions.isCopyPasteEnabled,
                            anchorPos: this.view.state.selection.$anchor.pos,
                            headPos: this.view.state.selection.$head.pos,
                            mediaOptions: mediaOptions,
                            editorViewMode: editorViewMode === 'view'
                        });
                    };
                    return /*#__PURE__*/ (0, $dc70d.jsx)($e7a1e731617d7cf7$var$MediaGroupNodeViewInternal, {
                        renderFn: renderFn,
                        pluginInjectionApi: pluginInjectionApi
                    });
                }
            })
        });
    }
}
const $e7a1e731617d7cf7$export$dc2dedbaab4b1587 = (portalProviderAPI, eventDispatcher, providerFactory, mediaOptions = {}, pluginInjectionApi, intl)=>(node, view, getPos)=>{
        return new $e7a1e731617d7cf7$var$MediaGroupNodeView(node, view, getPos, portalProviderAPI, eventDispatcher, {
            providerFactory: providerFactory,
            mediaOptions: mediaOptions,
            pluginInjectionApi: pluginInjectionApi,
            intl: intl
        }).init();
    };

});
parcelRegister("CrH9u", function(module, exports) {
$parcel$export(module.exports, "useMediaProvider", () => $b4f9e7e0bdc124e0$export$669acb2735f045dd);

var $bSJIT = parcelRequire("bSJIT");

var $5beht = parcelRequire("5beht");
const $b4f9e7e0bdc124e0$var$selector = (states)=>{
    var _states$mediaState;
    return {
        mediaProvider: (_states$mediaState = states.mediaState) === null || _states$mediaState === void 0 ? void 0 : _states$mediaState.mediaProvider
    };
};
const $b4f9e7e0bdc124e0$export$669acb2735f045dd = (pluginInjectionApi)=>{
    const { mediaProvider: mediaProvider } = (0, $5beht.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'media'
    ], $b4f9e7e0bdc124e0$var$selector);
    const provider = (0, $bSJIT.useMemo)(()=>{
        return mediaProvider;
    }, [
        mediaProvider
    ]);
    return provider;
};

});

parcelRegister("jTv7r", function(module, exports) {
$parcel$export(module.exports, "MediaSSRReactContextsProvider", () => $f80e59d807e41cf7$export$6542fd0697d9003d);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $fK3tS = parcelRequire("fK3tS");

var $7lseo = parcelRequire("7lseo");
function $f80e59d807e41cf7$export$6542fd0697d9003d({ children: children, intl: intl }) {
    if (!(0, $7lseo.isSSR)()) return children;
    if (!intl) return children;
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $fK3tS.Provider), {
        value: intl,
        children: children
    });
}

});

parcelRegister("ess9d", function(module, exports) {
$parcel$export(module.exports, "MediaGroupNext", () => $c059cbcff3176a5a$export$7fbb084971a34492);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $fK3tS = parcelRequire("fK3tS");

var $j8W9G = parcelRequire("j8W9G");

var $b2855 = parcelRequire("b2855");

var $cUlhg = parcelRequire("cUlhg");
var $j2OLx = parcelRequire("j2OLx");

var $5vR15 = parcelRequire("5vR15");

var $9dYEz = parcelRequire("9dYEz");

var $97BF5 = parcelRequire("97BF5");

var $5VgS2 = parcelRequire("5VgS2");

var $797yE = parcelRequire("797yE");

var $7ICJC = parcelRequire("7ICJC");

var $eUcZO = parcelRequire("eUcZO");
const $c059cbcff3176a5a$var$getIdentifier = (item)=>{
    if (item.attrs.type === 'external') return {
        mediaItemType: 'external-image',
        dataURI: item.attrs.url
    };
    return {
        id: item.attrs.id,
        mediaItemType: 'file',
        collectionName: item.attrs.collection
    };
};
const $c059cbcff3176a5a$var$isNodeSelected = (props)=>(mediaItemPos, mediaGroupPos)=>{
        const selected = (0, $5vR15.isNodeSelectedOrInRange)(props.anchorPos, props.headPos, mediaGroupPos, props.nodeSize);
        if (selected === (0, $cUlhg.SelectedState).selectedInRange) return true;
        if (selected === (0, $cUlhg.SelectedState).selectedInside && props.anchorPos === mediaItemPos) return true;
        return false;
    };
const $c059cbcff3176a5a$var$prepareFilmstripItem = ({ allowLazyLoading: allowLazyLoading, enableDownloadButton: enableDownloadButton, handleMediaNodeRemoval: handleMediaNodeRemoval, getPos: getPos, intl: intl, isMediaItemSelected: isMediaItemSelected, setMediaGroupNodeSelection: setMediaGroupNodeSelection, featureFlags: featureFlags })=>(item, idx)=>{
        // We declared this to get a fresh position every time
        const getNodePos = ()=>{
            const pos = getPos();
            if (typeof pos !== 'number') // That may seems weird, but the previous type wasn't match with the real ProseMirror code. And a lot of Media API was built expecting a number
            // Because the original code would return NaN on runtime
            // We are just make it explict now.
            // We may run a deep investagation on Media code to figure out a better fix. But, for now, we want to keep the current behavior.
            // TODO: ED-13910 - prosemirror-bump leftovers
            return NaN;
            return pos + idx + 1;
        };
        // Media Inline creates a floating toolbar with the same options, excludes these options if enabled
        const mediaInlineOptions = (allowMediaInline = false)=>{
            if (!allowMediaInline) return {
                shouldEnableDownloadButton: enableDownloadButton,
                actions: [
                    {
                        handler: handleMediaNodeRemoval.bind(null, undefined, getNodePos),
                        icon: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9dYEz))), {
                            label: intl.formatMessage((0, $j8W9G.nodeViewsMessages).mediaGroupDeleteLabel)
                        })
                    }
                ]
            };
        };
        const mediaGroupPos = getPos();
        return {
            identifier: $c059cbcff3176a5a$var$getIdentifier(item),
            isLazy: allowLazyLoading,
            selected: isMediaItemSelected(getNodePos(), typeof mediaGroupPos === 'number' ? mediaGroupPos : NaN),
            onClick: ()=>{
                setMediaGroupNodeSelection(getNodePos());
            },
            ...mediaInlineOptions((0, $97BF5.getMediaFeatureFlag)('mediaInline', featureFlags))
        };
    };
/**
 * Keep returning the same ProseMirror Node, unless the node content changed.
 *
 * React uses shallow comparation with `Object.is`,
 * but that can cause multiple re-renders when the same node is given in a different instance.
 *
 * To avoid unnecessary re-renders, this hook uses the `Node.eq` from ProseMirror API to compare
 * previous and new values.
 */ const $c059cbcff3176a5a$var$useLatestMediaGroupNode = (nextMediaNode)=>{
    const previousMediaNode = (0, $b2855.default)(nextMediaNode);
    const [mediaNode, setMediaNode] = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useState(nextMediaNode);
    (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useEffect(()=>{
        if (!previousMediaNode) return;
        if (!previousMediaNode.eq(nextMediaNode)) setMediaNode(nextMediaNode);
    }, [
        previousMediaNode,
        nextMediaNode
    ]);
    return mediaNode;
};
const $c059cbcff3176a5a$var$runMediaNodeUpdate = async ({ mediaNodeUpdater: mediaNodeUpdater, getPos: getPos, node: node, updateAttrs: updateAttrs })=>{
    if (updateAttrs) await mediaNodeUpdater.updateNodeAttrs(getPos);
    const contextId = mediaNodeUpdater.getNodeContextId();
    if (!contextId) await mediaNodeUpdater.updateNodeContextId(getPos);
    const shouldNodeBeDeepCopied = await mediaNodeUpdater.shouldNodeBeDeepCopied();
    if (shouldNodeBeDeepCopied) await mediaNodeUpdater.copyNodeFromPos(getPos, {
        traceId: node.attrs.__mediaTraceId
    });
};
const $c059cbcff3176a5a$var$noop = ()=>{};
const $c059cbcff3176a5a$export$7fbb084971a34492 = (0, $fK3tS.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).memo((props)=>{
    const { mediaOptions: { allowLazyLoading: allowLazyLoading, enableDownloadButton: enableDownloadButton, featureFlags: featureFlags, fallbackMediaNameFetcher: fallbackMediaNameFetcher }, intl: intl, getPos: getPos, anchorPos: anchorPos, headPos: headPos, view: view, disabled: disabled, editorViewMode: editorViewMode, mediaProvider: mediaProvider, contextIdentifierProvider: contextIdentifierProvider, isCopyPasteEnabled: isCopyPasteEnabled } = props;
    const mediaGroupNode = $c059cbcff3176a5a$var$useLatestMediaGroupNode(props.node);
    const mediaPluginState = (0, $bSJIT.useMemo)(()=>{
        return (0, $7ICJC.stateKey).getState(view.state);
    }, [
        view.state
    ]);
    const mediaClientConfig = mediaPluginState === null || mediaPluginState === void 0 ? void 0 : mediaPluginState.mediaClientConfig;
    const handleMediaGroupUpdate = mediaPluginState === null || mediaPluginState === void 0 ? void 0 : mediaPluginState.handleMediaGroupUpdate;
    const [viewMediaClientConfig, setViewMediaClientConfig] = (0, $bSJIT.useState)(undefined);
    const nodeSize = mediaGroupNode.nodeSize;
    const mediaNodesWithOffsets = (0, $bSJIT.useMemo)(()=>{
        const result = [];
        mediaGroupNode.forEach((item, childOffset)=>{
            result.push({
                node: item,
                offset: childOffset
            });
        });
        return result;
    }, [
        mediaGroupNode
    ]);
    const previousMediaNodesWithOffsets = (0, $b2855.default)(mediaNodesWithOffsets);
    const handleMediaNodeRemoval = (0, $bSJIT.useMemo)(()=>{
        return disabled || !mediaPluginState ? $c059cbcff3176a5a$var$noop : mediaPluginState.handleMediaNodeRemoval;
    }, [
        disabled,
        mediaPluginState
    ]);
    const setMediaGroupNodeSelection = (0, $bSJIT.useCallback)((pos)=>{
        (0, $j2OLx.setNodeSelection)(view, pos);
    }, [
        view
    ]);
    const isMediaItemSelected = (0, $bSJIT.useMemo)(()=>{
        return $c059cbcff3176a5a$var$isNodeSelected({
            anchorPos: anchorPos,
            headPos: headPos,
            nodeSize: nodeSize
        });
    }, [
        anchorPos,
        headPos,
        nodeSize
    ]);
    const filmstripItem = (0, $bSJIT.useMemo)(()=>{
        return $c059cbcff3176a5a$var$prepareFilmstripItem({
            allowLazyLoading: allowLazyLoading,
            enableDownloadButton: enableDownloadButton,
            handleMediaNodeRemoval: handleMediaNodeRemoval,
            getPos: getPos,
            intl: intl,
            isMediaItemSelected: isMediaItemSelected,
            setMediaGroupNodeSelection: setMediaGroupNodeSelection,
            featureFlags: featureFlags
        });
    }, [
        allowLazyLoading,
        enableDownloadButton,
        handleMediaNodeRemoval,
        getPos,
        intl,
        isMediaItemSelected,
        setMediaGroupNodeSelection,
        featureFlags
    ]);
    const items = (0, $bSJIT.useMemo)(()=>{
        return mediaNodesWithOffsets.map(({ node: node, offset: offset })=>{
            return filmstripItem(node, offset);
        });
    }, [
        mediaNodesWithOffsets,
        filmstripItem
    ]);
    (0, $bSJIT.useEffect)(()=>{
        setViewMediaClientConfig(mediaClientConfig);
    }, [
        mediaClientConfig
    ]);
    (0, $bSJIT.useEffect)(()=>{
        // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- Ignored via go/ees017 (to be fixed)
        mediaNodesWithOffsets.forEach(({ node: node, offset: offset })=>{
            const mediaNodeUpdater = (0, $eUcZO.createMediaNodeUpdater)({
                view: view,
                mediaProvider: mediaProvider,
                contextIdentifierProvider: contextIdentifierProvider,
                node: node,
                isMediaSingle: false
            });
            const updateAttrs = isCopyPasteEnabled || isCopyPasteEnabled === undefined;
            $c059cbcff3176a5a$var$runMediaNodeUpdate({
                mediaNodeUpdater: mediaNodeUpdater,
                node: node,
                updateAttrs: updateAttrs,
                getPos: ()=>{
                    const pos = getPos();
                    if (typeof pos !== 'number') return undefined;
                    return pos + offset + 1;
                }
            });
        });
    }, [
        view,
        contextIdentifierProvider,
        getPos,
        mediaProvider,
        mediaNodesWithOffsets,
        isCopyPasteEnabled
    ]);
    (0, $bSJIT.useEffect)(()=>{
        if (!handleMediaGroupUpdate || !previousMediaNodesWithOffsets) return;
        const old = previousMediaNodesWithOffsets.map(({ node: node })=>node);
        const next = mediaNodesWithOffsets.map(({ node: node })=>node);
        handleMediaGroupUpdate(old, next);
        return ()=>{
            handleMediaGroupUpdate(next, []);
        };
    }, [
        handleMediaGroupUpdate,
        mediaNodesWithOffsets,
        previousMediaNodesWithOffsets
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $5VgS2.Filmstrip), {
        items: items,
        mediaClientConfig: viewMediaClientConfig,
        featureFlags: featureFlags,
        shouldOpenMediaViewer: editorViewMode && (0, $797yE.editorExperiment)('platform_editor_controls', 'control'),
        fallbackMediaNameFetcher: fallbackMediaNameFetcher
    });
}));
$c059cbcff3176a5a$export$7fbb084971a34492.displayName = 'MediaGroup';

});
parcelRegister("j8W9G", function(module, exports) {
$parcel$export(module.exports, "nodeViewsMessages", () => $5ba7f49f0a454b60$export$788459419c7c9712);

var $f0Pt4 = parcelRequire("f0Pt4");
const $5ba7f49f0a454b60$export$788459419c7c9712 = (0, $f0Pt4.defineMessages)({
    mediaGroupDeleteLabel: {
        id: 'fabric.editor.mediaGroupDeleteLabel',
        defaultMessage: 'delete',
        description: 'Accessible label for the delete icon button shown on a media group item in the editor, used to remove the media file from the document.'
    }
});

});

parcelRegister("5VgS2", function(module, exports) {
$parcel$export(module.exports, "Filmstrip", () => $197c6240cb9062c9$export$8be30a51dc0802a7);

var $bSJIT = parcelRequire("bSJIT");

var $gc5WX = parcelRequire("gc5WX");

var $fyJNx = parcelRequire("fyJNx");

var $b2ees = parcelRequire("b2ees");

var $2nw6E = parcelRequire("2nw6E");

var $fzoUl = parcelRequire("fzoUl");

var $6bl9M = parcelRequire("6bl9M");
class $197c6240cb9062c9$export$8be30a51dc0802a7 extends (0, $bSJIT.Component) {
    renderCards() {
        const { items: items, mediaClientConfig: mediaClientConfig, shouldOpenMediaViewer: shouldOpenMediaViewer, featureFlags: featureFlags, viewerOptions: viewerOptions, isLazy: isLazy } = this.props;
        return items.map((item)=>{
            const key = (0, $6bl9M.generateIdentifierKey)(item.identifier);
            if (!mediaClientConfig) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $b2ees.CardLoading), {
                key: key,
                dimensions: (0, $gc5WX.defaultImageCardDimensions),
                interactionName: "media-filmstrip-card-loading"
            });
            const mediaViewerItems = shouldOpenMediaViewer ? items.map((item)=>item.identifier) : undefined;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fyJNx.default), {
                key: key,
                mediaClientConfig: mediaClientConfig,
                dimensions: (0, $gc5WX.defaultImageCardDimensions),
                useInlinePlayer: false,
                shouldOpenMediaViewer: shouldOpenMediaViewer,
                mediaViewerItems: mediaViewerItems,
                featureFlags: featureFlags,
                viewerOptions: viewerOptions,
                isLazy: isLazy,
                fallbackMediaNameFetcher: this.props.fallbackMediaNameFetcher,
                ...item
            });
        });
    }
    render() {
        const { testId: testId = 'media-filmstrip', includeHashForDuplicateFiles: includeHashForDuplicateFiles } = this.props;
        if (includeHashForDuplicateFiles) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2nw6E.DeduplicatedFilmStrip), this.props);
        const { animate: animate, offset: offset } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fzoUl.FilmstripView), {
            animate: animate,
            offset: offset,
            onSize: this.handleSize,
            onScroll: this.handleScroll,
            testId: testId
        }, this.renderCards());
    }
    constructor(...args){
        super(...args), this.state = {
            animate: false,
            offset: 0
        }, this.handleSize = ({ offset: offset })=>this.setState({
                offset: offset
            }), this.handleScroll = ({ animate: animate, offset: offset })=>this.setState({
                animate: animate,
                offset: offset
            });
    }
}

});
parcelRegister("2nw6E", function(module, exports) {
$parcel$export(module.exports, "DeduplicatedFilmStrip", () => $48f3aa80fd244e35$export$f2e48bfda187171f);

var $bSJIT = parcelRequire("bSJIT");

var $gc5WX = parcelRequire("gc5WX");

var $fyJNx = parcelRequire("fyJNx");

var $b2ees = parcelRequire("b2ees");

var $4PL54 = parcelRequire("4PL54");

var $35T7J = parcelRequire("35T7J");

var $3pMfu = parcelRequire("3pMfu");

var $fzoUl = parcelRequire("fzoUl");

var $6bl9M = parcelRequire("6bl9M");
function $48f3aa80fd244e35$export$5cae361ad82dce8b(value) {
    const ref = (0, $bSJIT.useRef)();
    (0, $bSJIT.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}
const $48f3aa80fd244e35$var$DeduplicatedFilmStripInternal = ({ items: items, mediaClientConfig: mediaClientConfig, shouldOpenMediaViewer: shouldOpenMediaViewer, featureFlags: featureFlags, viewerOptions: viewerOptions, testId: testId = 'media-filmstrip', isLazy: isLazy, fallbackMediaNameFetcher: fallbackMediaNameFetcher })=>{
    const [animate, setAnimate] = (0, $bSJIT.useState)(false);
    const [offset, setOffset] = (0, $bSJIT.useState)(0);
    const handleSize = ({ offset: offset })=>{
        setOffset(offset);
    };
    const handleScroll = ({ animate: animate, offset: offset })=>{
        setAnimate(animate);
        setOffset(offset);
    };
    const ids = (0, $bSJIT.useMemo)(()=>items.map(({ identifier: identifier })=>identifier).filter((0, $4PL54.isFileIdentifier)), [
        items
    ]);
    const fileHashes = (0, $3pMfu.useFileHashes)(ids);
    const cards = (0, $bSJIT.useMemo)(()=>{
        // filters only the first item when encountering duplicated hashes
        const uniqueItems = items.filter(({ identifier: identifier }, i)=>identifier.mediaItemType !== 'file' || !fileHashes[identifier.id] || !items.some((currentItem, currI)=>currentItem.identifier.mediaItemType === 'file' && currI < i && fileHashes[identifier.id] === fileHashes[currentItem.identifier.id]));
        return uniqueItems.map((item)=>{
            const key = (0, $6bl9M.generateIdentifierKey)(item.identifier);
            if (!mediaClientConfig) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $b2ees.CardLoading), {
                key: key,
                dimensions: (0, $gc5WX.defaultImageCardDimensions),
                interactionName: "media-filmstrip-card-loading"
            });
            const mediaViewerItems = shouldOpenMediaViewer ? uniqueItems.map((item)=>item.identifier) : undefined;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fyJNx.default), {
                key: key,
                mediaClientConfig: mediaClientConfig,
                dimensions: (0, $gc5WX.defaultImageCardDimensions),
                useInlinePlayer: false,
                shouldOpenMediaViewer: shouldOpenMediaViewer,
                mediaViewerItems: mediaViewerItems,
                featureFlags: featureFlags,
                viewerOptions: viewerOptions,
                includeHashForDuplicateFiles: true,
                isLazy: isLazy,
                fallbackMediaNameFetcher: fallbackMediaNameFetcher,
                ...item
            });
        });
    }, [
        items,
        fileHashes,
        mediaClientConfig,
        shouldOpenMediaViewer,
        featureFlags,
        viewerOptions,
        isLazy,
        fallbackMediaNameFetcher
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fzoUl.FilmstripView), {
        animate: animate,
        offset: offset,
        onSize: handleSize,
        onScroll: handleScroll,
        testId: testId
    }, cards);
};
const $48f3aa80fd244e35$var$EmptyFilmstripView = ({ items: items, testId: testId })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fzoUl.FilmstripView), {
        animate: false,
        offset: 0,
        onSize: ()=>{},
        onScroll: ()=>{},
        testId: testId
    }, items.map((item, _i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $b2ees.CardLoading), {
            key: (0, $6bl9M.generateIdentifierKey)(item.identifier),
            dimensions: (0, $gc5WX.defaultImageCardDimensions),
            interactionName: "media-filmstrip-card-loading"
        })));
};
const $48f3aa80fd244e35$export$f2e48bfda187171f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $35T7J.MediaClientContext).Consumer, null, (value)=>value ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($48f3aa80fd244e35$var$DeduplicatedFilmStripInternal, props) : !props.mediaClientConfig ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($48f3aa80fd244e35$var$EmptyFilmstripView, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $35T7J.MediaClientProvider), {
            clientConfig: props.mediaClientConfig
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement($48f3aa80fd244e35$var$DeduplicatedFilmStripInternal, props)));

});
parcelRegister("3pMfu", function(module, exports) {
$parcel$export(module.exports, "useFileHashes", () => $8e2211138ca31c42$export$f91c9e51e5ab027d);

var $bSJIT = parcelRequire("bSJIT");

var $gCPqs = parcelRequire("gCPqs");

var $46b54 = parcelRequire("46b54");

var $xNLmi = parcelRequire("xNLmi");

var $9PueT = parcelRequire("9PueT");
const $8e2211138ca31c42$var$areFilesPotentiallyDuplicated = (file1, file2)=>file1.status === file2.status && file1.name === file2.name && file1.size === file2.size && file1.mimeType === file2.mimeType && file1.id !== file2.id;
function $8e2211138ca31c42$export$f91c9e51e5ab027d(ids) {
    const nonErrorFiles = (0, $xNLmi.useMediaStore)((state)=>Object.values(state.files).filter((0, $gCPqs.isNonErrorFinalFileState)));
    const mediaClient = (0, $46b54.useMediaClient)();
    const collections = (0, $bSJIT.useMemo)(()=>Object.fromEntries(ids.map(({ id: id, collectionName: collectionName })=>[
                id,
                collectionName
            ])), [
        ids
    ]);
    const files = (0, $bSJIT.useMemo)(()=>nonErrorFiles.filter((file)=>ids.some(({ id: id })=>file.id === id)), [
        nonErrorFiles,
        ids
    ]);
    const prevFiles = (0, $9PueT.usePrevious)(files);
    (0, $bSJIT.useEffect)(()=>{
        const prev = prevFiles ?? [];
        // Get the files that have been added or whose status has changed since last time.
        const addedOrChangedFiles = files.filter((file)=>file && prev.every((prevFile)=>prevFile.id !== file.id || prevFile.status !== file.status));
        // Get the files from the list that are duplicates of the added / changed files
        const potentialDuplicates = files.filter((file)=>addedOrChangedFiles.some((addedFile)=>$8e2211138ca31c42$var$areFilesPotentiallyDuplicated(file, addedFile)));
        if (potentialDuplicates.length) // if any duplicates are found then fetch their hashes along with the added files
        [
            ...addedOrChangedFiles,
            ...potentialDuplicates
        ].forEach((file)=>{
            const collectionName = collections[file.id];
            mediaClient.file.getFileState(file.id, {
                collectionName: collectionName,
                includeHashForDuplicateFiles: true,
                forceRefresh: true
            });
        });
    }, [
        files,
        prevFiles,
        mediaClient,
        collections
    ]);
    const hashMap = (0, $bSJIT.useMemo)(()=>Object.fromEntries(files.map((file)=>[
                file.id,
                file.hash
            ])), [
        files
    ]);
    return hashMap;
}

});
parcelRegister("gCPqs", function(module, exports) {
$parcel$export(module.exports, "isNonErrorFinalFileState", () => $3543bfea0f77e135$export$8f33148a37b0c72f);
const $3543bfea0f77e135$export$8f33148a37b0c72f = (fileState)=>[
        'processed',
        'failed-processing'
    ].includes(fileState.status);

});

parcelRegister("9PueT", function(module, exports) {
$parcel$export(module.exports, "usePrevious", () => $a7ab6cf8a647e54d$export$5cae361ad82dce8b);

var $bSJIT = parcelRequire("bSJIT");
function $a7ab6cf8a647e54d$export$5cae361ad82dce8b(value) {
    const ref = (0, $bSJIT.useRef)();
    (0, $bSJIT.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}

});


parcelRegister("6bl9M", function(module, exports) {
$parcel$export(module.exports, "generateIdentifierKey", () => $80168e1fa6e48f3f$export$5d5de19b6d92a058);
let $80168e1fa6e48f3f$var$lastKey = 1;
const $80168e1fa6e48f3f$var$identifiersMap = new Map();
const $80168e1fa6e48f3f$export$5d5de19b6d92a058 = (identifier)=>{
    switch(identifier.mediaItemType){
        case 'external-image':
            return identifier.dataURI;
        case 'file':
            if (typeof identifier.id === 'string') return identifier.id;
            else {
                const currentKey = $80168e1fa6e48f3f$var$identifiersMap.get(identifier.id);
                if (currentKey) return currentKey;
                // We want to increment the key before using it
                $80168e1fa6e48f3f$var$lastKey++;
                const newKey = `${$80168e1fa6e48f3f$var$lastKey}`;
                $80168e1fa6e48f3f$var$identifiersMap.set(identifier.id, newKey);
                return newKey;
            }
    }
};

});



parcelRegister("7ICJC", function(module, exports) {
$parcel$export(module.exports, "stateKey", () => $bc8632acdc63aeb7$export$77b371d6becc8882);

var $cw0wu = parcelRequire("cw0wu");
const $bc8632acdc63aeb7$export$77b371d6becc8882 = new (0, $cw0wu.PluginKey)('mediaPlugin');

});

parcelRegister("eUcZO", function(module, exports) {
$parcel$export(module.exports, "MediaNodeUpdater", () => $f3808054f3d4dc95$export$e115d1293528d541);
$parcel$export(module.exports, "createMediaNodeUpdater", () => $f3808054f3d4dc95$export$5acae1477d0bf3d);
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $7RHfd = parcelRequire("7RHfd");

var $4eNaz = parcelRequire("4eNaz");

var $g6Qq4 = parcelRequire("g6Qq4");

var $29qUP = parcelRequire("29qUP");

var $cw0wu = parcelRequire("cw0wu");

var $18aF1 = parcelRequire("18aF1");
var $5k1f2 = parcelRequire("5k1f2");
var $2IaXl = parcelRequire("2IaXl");

var $83J3A = parcelRequire("83J3A");

var $2GUyw = parcelRequire("2GUyw");

var $gdUUy = parcelRequire("gdUUy");

var $lyZqb = parcelRequire("lyZqb");

var $7ICJC = parcelRequire("7ICJC");

var $h61b3 = parcelRequire("h61b3");

var $4sVoN = parcelRequire("4sVoN");

var $eTAAh = parcelRequire("eTAAh");
const $f3808054f3d4dc95$var$isMediaTypeSupported = (type)=>{
    if (type) return [
        'image',
        'file'
    ].includes(type);
    return false;
};
class $f3808054f3d4dc95$export$e115d1293528d541 {
    constructor(props){
        // Updates the node with contextId if it doesn't have one already
        this.updateContextId = async ()=>{
            const attrs = this.getAttrs();
            if (!attrs || attrs && !$f3808054f3d4dc95$var$isMediaTypeSupported(attrs.type)) return;
            const { id: id } = attrs;
            const objectId = await this.getObjectId();
            (0, $h61b3.batchMediaNodeAttrsUpdate)(this.props.view, {
                id: id,
                nextAttributes: {
                    __contextId: objectId
                }
            });
        };
        this.updateNodeContextId = async (getPos)=>{
            const attrs = this.getAttrs();
            if (!attrs || attrs && !$f3808054f3d4dc95$var$isMediaTypeSupported(attrs.type)) return;
            const objectId = await this.getObjectId();
            (0, $lyZqb.updateCurrentMediaNodeAttrs)({
                __contextId: objectId
            }, {
                node: this.props.node,
                getPos: getPos
            })(this.props.view.state, this.props.view.dispatch);
        };
        this.hasFileAttributesDefined = (attrs)=>{
            return attrs && attrs.type === 'file' && attrs.__fileName && attrs.__fileMimeType && attrs.__fileSize && attrs.__contextId;
        };
        this.getNewFileAttrsForNode = async ()=>{
            const attrs = this.getAttrs();
            const mediaProvider = await this.props.mediaProvider;
            if (!mediaProvider || !mediaProvider.uploadParams || !attrs || !$f3808054f3d4dc95$var$isMediaTypeSupported(attrs.type) || this.hasFileAttributesDefined(attrs)) return;
            const mediaClientConfig = mediaProvider.viewMediaClientConfig;
            const mediaClient = (0, $83J3A.getMediaClient)(mediaClientConfig);
            let fileState;
            const { id: id, collection: collectionName } = attrs;
            try {
                fileState = await mediaClient.file.getCurrentState(id, {
                    collectionName: collectionName
                });
                if (fileState.status === 'error') return;
            } catch  {
                return;
            }
            const contextId = this.getNodeContextId() || await this.getObjectId();
            const { name: name, mimeType: mimeType, size: size } = fileState;
            const newAttrs = {
                __fileName: name,
                __fileMimeType: mimeType,
                __fileSize: size,
                __contextId: contextId
            };
            if (!$f3808054f3d4dc95$var$hasPrivateAttrsChanged(attrs, newAttrs)) return;
            return newAttrs;
        };
        this.updateMediaSingleFileAttrs = async ()=>{
            const newAttrs = await this.getNewFileAttrsForNode();
            const { id: id } = this.getAttrs();
            if (id && newAttrs) (0, $h61b3.batchMediaNodeAttrsUpdate)(this.props.view, {
                id: id,
                nextAttributes: newAttrs
            });
        };
        this.updateNodeAttrs = async (getPos)=>{
            const newAttrs = await this.getNewFileAttrsForNode();
            if (newAttrs) (0, $lyZqb.updateCurrentMediaNodeAttrs)(newAttrs, {
                node: this.props.node,
                getPos: getPos
            })(this.props.view.state, this.props.view.dispatch);
        };
        this.getAttrs = ()=>{
            const { attrs: attrs } = this.props.node;
            if (attrs) return attrs;
            return undefined;
        };
        this.getObjectId = async ()=>{
            const contextIdentifierProvider = await this.props.contextIdentifierProvider;
            return (contextIdentifierProvider === null || contextIdentifierProvider === void 0 ? void 0 : contextIdentifierProvider.objectId) || null;
        };
        this.uploadExternalMedia = async (getPos)=>{
            const { node: node, mediaOptions: mediaOptions } = this.props;
            if (mediaOptions !== null && mediaOptions !== void 0 && mediaOptions.isExternalMediaUploadDisabled) return;
            const mediaProvider = await this.props.mediaProvider;
            if (node && mediaProvider) {
                const uploadMediaClientConfig = mediaProvider.uploadMediaClientConfig;
                if (!uploadMediaClientConfig || !node.attrs.url) return;
                const mediaClient = (0, $83J3A.getMediaClient)(uploadMediaClientConfig);
                const collection = mediaProvider.uploadParams && mediaProvider.uploadParams.collection;
                try {
                    const uploader = await mediaClient.file.uploadExternal(node.attrs.url, collection);
                    const { uploadableFileUpfrontIds: uploadableFileUpfrontIds, dimensions: dimensions } = uploader;
                    const pos = getPos();
                    if (typeof pos !== 'number') return;
                    (0, $lyZqb.replaceExternalMedia)(pos + 1, {
                        id: uploadableFileUpfrontIds.id,
                        collection: collection,
                        height: dimensions.height,
                        width: dimensions.width,
                        occurrenceKey: uploadableFileUpfrontIds.occurrenceKey
                    })(this.props.view.state, this.props.view.dispatch);
                } catch  {
                    //keep it as external media
                    if (this.props.dispatchAnalyticsEvent) this.props.dispatchAnalyticsEvent({
                        action: (0, $g6Qq4.ACTION).UPLOAD_EXTERNAL_FAIL,
                        actionSubject: (0, $g6Qq4.ACTION_SUBJECT).EDITOR,
                        eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL
                    });
                }
            }
        };
        this.getNodeContextId = ()=>{
            const attrs = this.getAttrs();
            if (!attrs || attrs && !$f3808054f3d4dc95$var$isMediaTypeSupported(attrs.type)) return null;
            return attrs.__contextId || null;
        };
        this.updateDimensions = (dimensions)=>{
            const { view: view } = this.props;
            const mediaPluginState = (0, $7ICJC.stateKey).getState(view.state);
            const targetDisplayHeight = mediaPluginState === null || mediaPluginState === void 0 ? void 0 : mediaPluginState.replaceMediaTargetDisplayHeight;
            if (targetDisplayHeight !== null && targetDisplayHeight !== undefined && dimensions.width > 0) {
                var _mediaSingleNode;
                // Replace mode: combine intrinsic dimension update on the media node AND
                // display width update on the mediaSingle into a single transaction so they
                // are never out of sync and don't cause two separate renders/layout shifts.
                // Clear the stored target height — this is a one-shot adjustment
                if (mediaPluginState) mediaPluginState.replaceMediaTargetDisplayHeight = null;
                // Clamp to the layout's maximum width so the image never overflows its container.
                const lineLength = this.props.lineLength ?? 760;
                const { state: state } = view;
                const { mediaSingle: mediaSingle } = state.schema.nodes;
                // Typed explicitly because TypeScript can't track mutations inside
                // the descendants callback closure and would narrow these to `never`.
                let mediaSinglePos = null;
                let mediaSingleNode = null;
                let mediaPos = null;
                state.doc.descendants((node, pos)=>{
                    if (mediaSinglePos !== null) return false;
                    if (node.type === mediaSingle) {
                        const mediaChild = node.firstChild;
                        if (mediaChild && mediaChild.attrs.id === dimensions.id) {
                            mediaSinglePos = pos;
                            mediaSingleNode = node;
                            mediaPos = pos + 1;
                        }
                    }
                    return true;
                });
                const layout = ((_mediaSingleNode = mediaSingleNode) === null || _mediaSingleNode === void 0 || (_mediaSingleNode = _mediaSingleNode.attrs) === null || _mediaSingleNode === void 0 ? void 0 : _mediaSingleNode.layout) ?? 'center';
                const newDisplayWidth = (0, $eTAAh.computeReplacementDisplayWidth)(targetDisplayHeight, dimensions.width, dimensions.height, layout, lineLength);
                if (mediaSinglePos !== null && mediaSingleNode !== null && mediaPos !== null) {
                    const tr = state.tr;
                    // Update intrinsic dimensions on the media child node
                    tr.step(new (0, $4eNaz.SetAttrsStep)(mediaPos, {
                        height: dimensions.height,
                        width: dimensions.width
                    }));
                    // Update display width on the mediaSingle parent
                    tr.setNodeMarkup(mediaSinglePos, undefined, {
                        ...mediaSingleNode.attrs,
                        width: Math.round(newDisplayWidth),
                        widthType: 'pixel'
                    });
                    // Re-create the NodeSelection so the floating toolbar picks up
                    // the updated node and renders the full set of controls.
                    if (state.selection instanceof (0, $cw0wu.NodeSelection)) tr.setSelection((0, $cw0wu.NodeSelection).create(tr.doc, mediaSinglePos));
                    tr.setMeta('scrollIntoView', false);
                    view.dispatch(tr);
                    return;
                }
            }
            // Normal (non-replace) path: use the existing batched update mechanism
            (0, $h61b3.batchMediaNodeAttrsUpdate)(view, {
                id: dimensions.id,
                nextAttributes: {
                    height: dimensions.height,
                    width: dimensions.width
                }
            });
        };
        this.shouldNodeBeDeepCopied = async ()=>{
            var _this$props$mediaOpti, _this$mediaPluginStat;
            const scope = ((_this$props$mediaOpti = this.props.mediaOptions) === null || _this$props$mediaOpti === void 0 ? void 0 : _this$props$mediaOpti.mediaShallowCopyScope) ?? ((_this$mediaPluginStat = this.mediaPluginState) === null || _this$mediaPluginStat === void 0 || (_this$mediaPluginStat = _this$mediaPluginStat.mediaOptions) === null || _this$mediaPluginStat === void 0 ? void 0 : _this$mediaPluginStat.mediaShallowCopyScope) ?? 'context';
            if (scope === 'context') return await this.hasDifferentContextId();
            else {
                const attrs = this.getAttrs();
                if (!attrs || !this.mediaPluginState) return false;
                const id = (0, $4sVoN.getIdentifier)(attrs);
                const isIdentifierOutsideEditorScope = !this.mediaPluginState.isIdentifierInEditorScope(id);
                return isIdentifierOutsideEditorScope;
            }
        };
        this.hasDifferentContextId = async ()=>{
            const nodeContextId = this.getNodeContextId();
            const currentContextId = await this.getObjectId();
            if (nodeContextId && currentContextId && nodeContextId !== currentContextId) return true;
            return false;
        };
        this.isNodeFromDifferentCollection = async ()=>{
            const mediaProvider = await this.props.mediaProvider;
            if (!mediaProvider || !mediaProvider.uploadParams) return false;
            const currentCollectionName = mediaProvider.uploadParams.collection;
            const attrs = this.getAttrs();
            if (!attrs || attrs && !$f3808054f3d4dc95$var$isMediaTypeSupported(attrs.type)) return false;
            const { collection: nodeCollection, __contextId: __contextId } = attrs;
            const contextId = __contextId || await this.getObjectId();
            if (contextId && currentCollectionName !== nodeCollection) return true;
            return false;
        };
        this.handleCopyFileSwitcher = async (attrs)=>{
            const { mediaClient: mediaClient, source: source, destination: destination, traceContext: traceContext } = attrs;
            try {
                // calling copyWithToken by passing the auth providers
                const { id: id } = await mediaClient.file.copyFile(source, destination, undefined, traceContext);
                return id;
            } catch (err) {
                if ((0, $gdUUy.fg)('platform_media_cross_client_copy')) {
                    // calling /v2/file/copy by removing the auth tokens to make cross product copy and pastes
                    const { authProvider: _sourceAP, ...copyV2Source } = source;
                    const { authProvider: _destAP, ...copyV2Destination } = destination;
                    const { id: id } = await mediaClient.file.copyFile(copyV2Source, copyV2Destination, undefined, traceContext);
                    return id;
                } else throw err;
            }
        };
        this.copyNodeFromBlobUrl = async (getPos)=>{
            const attrs = this.getAttrs();
            if (!attrs || attrs.type !== 'external') return;
            const { url: url } = attrs;
            const mediaAttrs = (0, $18aF1.getAttrsFromUrl)(url);
            if (!mediaAttrs) return;
            const mediaProvider = await this.props.mediaProvider;
            if (!mediaProvider || !mediaProvider.uploadParams) return;
            const currentCollectionName = mediaProvider.uploadParams.collection;
            const { contextId: contextId, clientId: clientId, id: id, collection: collection, height: height, width: width, mimeType: mimeType, name: name, size: size } = mediaAttrs;
            const uploadMediaClientConfig = mediaProvider.uploadMediaClientConfig;
            if (!uploadMediaClientConfig || !uploadMediaClientConfig.getAuthFromContext) return;
            const mediaClient = (0, $83J3A.getMediaClient)(uploadMediaClientConfig);
            const getAuthFromContext = uploadMediaClientConfig.getAuthFromContext;
            const mediaFileId = await this.handleCopyFileSwitcher({
                mediaClient: mediaClient,
                source: {
                    id: id,
                    collection: collection,
                    authProvider: ()=>getAuthFromContext(contextId),
                    clientId: (0, $gdUUy.fg)('platform_media_cross_client_copy_with_auth') ? clientId : undefined
                },
                destination: {
                    collection: currentCollectionName,
                    authProvider: uploadMediaClientConfig.authProvider,
                    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                    occurrenceKey: (0, $7RHfd.default)()
                }
            });
            const pos = getPos();
            if (typeof pos !== 'number') return;
            (0, $lyZqb.replaceExternalMedia)(pos + 1, {
                id: mediaFileId,
                collection: currentCollectionName,
                height: height,
                width: width,
                __fileName: name,
                __fileMimeType: mimeType,
                __fileSize: size
            })(this.props.view.state, this.props.view.dispatch);
        };
        // Copies the pasted node into the current collection using a getPos handler
        this.copyNodeFromPos = async (getPos, traceContext)=>{
            const attrs = this.getAttrs();
            if (!attrs || attrs && !$f3808054f3d4dc95$var$isMediaTypeSupported(attrs.type)) return;
            const copiedAttrs = await this.copyFile(attrs.id, attrs.collection, traceContext);
            if (!copiedAttrs) return;
            (0, $lyZqb.updateCurrentMediaNodeAttrs)(copiedAttrs, {
                node: this.props.node,
                getPos: getPos
            })(this.props.view.state, this.props.view.dispatch);
        };
        // Copies the pasted node into the current collection
        this.copyNode = async (traceContext)=>{
            const attrs = this.getAttrs();
            const { view: view } = this.props;
            if (!attrs || attrs && !$f3808054f3d4dc95$var$isMediaTypeSupported(attrs.type)) return;
            const copiedAttrs = await this.copyFile(attrs.id, attrs.collection, traceContext);
            if (!copiedAttrs) return;
            (0, $lyZqb.updateMediaNodeAttrs)(attrs.id, copiedAttrs)(view.state, view.dispatch);
        };
        this.copyFile = async (id, collection, traceContext)=>{
            const mediaProvider = await this.props.mediaProvider;
            if (!(mediaProvider !== null && mediaProvider !== void 0 && mediaProvider.uploadParams)) return;
            const nodeContextId = this.getNodeContextId();
            const uploadMediaClientConfig = mediaProvider.uploadMediaClientConfig;
            if (!(uploadMediaClientConfig !== null && uploadMediaClientConfig !== void 0 && uploadMediaClientConfig.getAuthFromContext) || !nodeContextId) return;
            const mediaClient = (0, $83J3A.getMediaClient)(uploadMediaClientConfig);
            const clientId = (0, $gdUUy.fg)('platform_media_cross_client_copy_with_auth') ? (0, $2GUyw.getClientIdForFile)(id) : undefined;
            const currentCollectionName = mediaProvider.uploadParams.collection;
            const objectId = await this.getObjectId();
            const getAuthFromContext = uploadMediaClientConfig.getAuthFromContext;
            const mediaFileId = await this.handleCopyFileSwitcher({
                mediaClient: mediaClient,
                source: {
                    id: id,
                    collection: collection,
                    authProvider: ()=>getAuthFromContext(nodeContextId),
                    clientId: clientId
                },
                destination: {
                    collection: currentCollectionName,
                    authProvider: uploadMediaClientConfig.authProvider,
                    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                    occurrenceKey: (0, $7RHfd.default)()
                },
                traceContext: traceContext
            });
            return {
                id: mediaFileId,
                collection: currentCollectionName,
                __contextId: objectId
            };
        };
        this.props = props;
        this.mediaPluginState = (0, $7ICJC.stateKey).getState(props.view.state);
    }
    setProps(newComponentProps) {
        this.props = {
            ...this.props,
            ...newComponentProps
        };
    }
    isMediaBlobUrl() {
        const attrs = this.getAttrs();
        return !!(attrs && attrs.type === 'external' && (0, $2IaXl.isMediaBlobUrl)(attrs.url));
    }
    async getRemoteDimensions() {
        const mediaProvider = await this.props.mediaProvider;
        const { mediaOptions: mediaOptions } = this.props;
        const attrs = this.getAttrs();
        if (!mediaProvider || !attrs) return false;
        const { height: height, width: width } = attrs;
        if (attrs.type === 'external' || !attrs.id) return false;
        const { id: id, collection: collection } = attrs;
        if (height && width) return false;
        // can't fetch remote dimensions on mobile, so we'll default them
        if (mediaOptions && !mediaOptions.allowRemoteDimensionsFetch) return {
            id: id,
            height: (0, $29qUP.DEFAULT_IMAGE_HEIGHT),
            width: (0, $29qUP.DEFAULT_IMAGE_WIDTH)
        };
        const viewMediaClientConfig = mediaProvider.viewMediaClientConfig;
        const mediaClient = (0, $83J3A.getMediaClient)(viewMediaClientConfig);
        const currentState = await mediaClient.file.getCurrentState(id, {
            collectionName: collection
        });
        if (!(0, $5k1f2.isImageRepresentationReady)(currentState)) return false;
        const imageMetadata = await mediaClient.getImageMetadata(id, {
            collection: collection
        });
        if (!imageMetadata || !imageMetadata.original) return false;
        return {
            id: id,
            height: imageMetadata.original.height || (0, $29qUP.DEFAULT_IMAGE_HEIGHT),
            width: imageMetadata.original.width || (0, $29qUP.DEFAULT_IMAGE_WIDTH)
        };
    }
    async handleExternalMedia(getPos) {
        if (this.isMediaBlobUrl()) try {
            await this.copyNodeFromBlobUrl(getPos);
        } catch  {
            await this.uploadExternalMedia(getPos);
        }
        else await this.uploadExternalMedia(getPos);
    }
}
const $f3808054f3d4dc95$var$hasPrivateAttrsChanged = (currentAttrs, newAttrs)=>{
    return currentAttrs.__fileName !== newAttrs.__fileName || currentAttrs.__fileMimeType !== newAttrs.__fileMimeType || currentAttrs.__fileSize !== newAttrs.__fileSize || currentAttrs.__contextId !== newAttrs.__contextId;
};
const $f3808054f3d4dc95$export$5acae1477d0bf3d = (props)=>{
    const updaterProps = {
        ...props
    };
    return new $f3808054f3d4dc95$export$e115d1293528d541(updaterProps);
};

});
parcelRegister("18aF1", function(module, exports) {
$parcel$export(module.exports, "getAttrsFromUrl", () => $ed14dccd32da6f7e$export$b91a9e94ff0cbb29);
const $ed14dccd32da6f7e$var$getNumberFromParams = (params, name)=>{
    const value = params.get(name);
    return typeof value === 'string' && !isNaN(parseInt(value)) ? parseInt(value) : undefined;
};
const $ed14dccd32da6f7e$var$getStringFromParams = (params, name)=>{
    const value = params.get(name);
    if (!value) return;
    return decodeURIComponent(value);
};
const $ed14dccd32da6f7e$export$b91a9e94ff0cbb29 = (blobUrl)=>{
    const url = new URL(blobUrl);
    const hash = url.hash.replace('#', '');
    const params = new URLSearchParams(hash);
    const id = params.get('id');
    const contextId = params.get('contextId');
    const clientId = params.get('clientId');
    // check if we have the required params (clientId is optional for backwards compatibility)
    if (!id || !contextId) return;
    return {
        id: id,
        contextId: contextId,
        clientId: clientId || undefined,
        collection: $ed14dccd32da6f7e$var$getStringFromParams(params, 'collection'),
        alt: $ed14dccd32da6f7e$var$getStringFromParams(params, 'alt'),
        height: $ed14dccd32da6f7e$var$getNumberFromParams(params, 'height'),
        width: $ed14dccd32da6f7e$var$getNumberFromParams(params, 'width'),
        size: $ed14dccd32da6f7e$var$getNumberFromParams(params, 'size'),
        name: $ed14dccd32da6f7e$var$getStringFromParams(params, 'name'),
        mimeType: $ed14dccd32da6f7e$var$getStringFromParams(params, 'mimeType')
    };
};

});

parcelRegister("2IaXl", function(module, exports) {
$parcel$export(module.exports, "isMediaBlobUrl", () => $d035e8afb44b4e7b$export$e1e8ad57ada2d90);

var $7FZfL = parcelRequire("7FZfL");
const $d035e8afb44b4e7b$export$e1e8ad57ada2d90 = (url)=>{
    return url.indexOf(`${(0, $7FZfL.mediaBlobUrlIdentifier)}=true`) > -1;
};

});

parcelRegister("2GUyw", function(module, exports) {
$parcel$export(module.exports, "getClientIdForFile", () => $0f4d33fca154b62f$export$3cac71a2bd99f367);
$parcel$export(module.exports, "extractClientIdsFromHtml", () => $0f4d33fca154b62f$export$a60ab7931e673c86);
/**
 * Cache for storing fileId to clientId mapping during paste operations.
 * This avoids the need to store clientId in ADF schema attributes.
 *
 * Used for cross-client copy/paste scenarios
 *
 * Entries persist across reads to support multiple pastes of the same content.
 * An LRU-style max size limit guards against unbounded growth — the oldest entry
 * is evicted whenever the cache exceeds CLIENT_ID_CACHE_MAX_SIZE.
 */ const $0f4d33fca154b62f$var$CLIENT_ID_CACHE_MAX_SIZE = 20;
const $0f4d33fca154b62f$var$clientIdCache = new Map();
const $0f4d33fca154b62f$export$e03a2c36a6c44657 = (fileId, clientId)=>{
    $0f4d33fca154b62f$var$clientIdCache.set(fileId, clientId);
    // Evict oldest entries if cache exceeds max size
    if ($0f4d33fca154b62f$var$clientIdCache.size > $0f4d33fca154b62f$var$CLIENT_ID_CACHE_MAX_SIZE) {
        const oldestKey = $0f4d33fca154b62f$var$clientIdCache.keys().next().value;
        if (oldestKey !== undefined) $0f4d33fca154b62f$var$clientIdCache.delete(oldestKey);
    }
};
const $0f4d33fca154b62f$export$3cac71a2bd99f367 = (fileId)=>{
    return $0f4d33fca154b62f$var$clientIdCache.get(fileId);
};
const $0f4d33fca154b62f$export$227522d8fd74bd7e = ()=>{
    $0f4d33fca154b62f$var$clientIdCache.clear();
};
/**
 * Used to store fileId to clientId mappings on paste of Editor PM Node
 *
 * Handles two sources of pasted HTML:
 *
 * 1. Editor-to-editor copy: the clientId is stored as a `data-client-id` attribute
 *    directly on the `<div data-node-type="media">` element, written by the editor's
 *    clipboard serialiser.
 *
 * 2. Renderer-to-editor copy (e.g. pasting from a published Confluence page): the
 *    renderer does not write `data-client-id` on the media div. Instead, the clientId
 *    is embedded inside the blob URL on the `<img>` child element, in the hash params:
 *    `src="blob:https://...#media-blob-url=true&id=FILE_ID&...&clientId=CLIENT_ID"`
 *
 * All media nodes in a single pasted HTML fragment always share the same clientId,
 * so we extract it once and apply it to all file IDs found in the HTML.
 */ /**
 * Extract the clientId from a blob URL hash fragment (renderer-to-editor path).
 * Returns undefined if not found.
 */ const $0f4d33fca154b62f$var$extractClientIdFromBlobUrl = (html)=>{
    // Matches both:
    //   - blob: URLs (client-rendered renderer)
    //   - HTTPS URLs with #media-blob-url=true in the hash (SSR-rendered renderer)
    const imgSrcRegex = /src="([^"]*#media-blob-url=true[^"]*)"/g;
    let match;
    while((match = imgSrcRegex.exec(html)) !== null){
        const src = match[1];
        // clientId is encoded in the hash fragment as a URL param
        // e.g. blob:https://hello.atlassian.net/uuid#media-blob-url=true&id=FILE_ID&clientId=CLIENT_ID
        const hash = src.includes('#') ? src.slice(src.indexOf('#') + 1) : '';
        // Unescape HTML-encoded ampersands that appear in raw clipboard HTML attribute values
        const decodedHash = hash.replace(/&amp;/g, '&');
        const clientId = new URLSearchParams(decodedHash).get('clientId');
        if (clientId) return clientId;
    }
    return undefined;
};
const $0f4d33fca154b62f$export$a60ab7931e673c86 = (html)=>{
    var _exec;
    if (!html) return;
    // All media nodes in a single paste share the same clientId.
    // Extract it once from either source:
    //   - Editor-to-editor: present as data-client-id="..." attribute
    //   - Renderer-to-editor: embedded in the blob URL hash as clientId=...
    const clientId = ((_exec = /data-client-id="([^"]*)"/.exec(html)) === null || _exec === void 0 ? void 0 : _exec[1]) ?? $0f4d33fca154b62f$var$extractClientIdFromBlobUrl(html);
    if (!clientId) return;
    // Map every file ID in the HTML to the single clientId
    const fileIdRegex = /data-id="([^"]*)"/g;
    let match;
    while((match = fileIdRegex.exec(html)) !== null)$0f4d33fca154b62f$export$e03a2c36a6c44657(match[1], clientId);
};

});

parcelRegister("lyZqb", function(module, exports) {
$parcel$export(module.exports, "findMediaNode", () => $4eae1f857ea0604e$export$f4585563863d37bf);
$parcel$export(module.exports, "updateCurrentMediaNodeAttrs", () => $4eae1f857ea0604e$export$fb68358a5cd1917e);
$parcel$export(module.exports, "updateMediaNodeAttrs", () => $4eae1f857ea0604e$export$b75bb49e34d97d07);
$parcel$export(module.exports, "replaceExternalMedia", () => $4eae1f857ea0604e$export$8c2989a33c6f5bd5);

var $4eNaz = parcelRequire("4eNaz");

var $gZj5p = parcelRequire("gZj5p");

var $7ICJC = parcelRequire("7ICJC");
const $4eae1f857ea0604e$export$f4585563863d37bf = (mediaPluginState, id)=>{
    const { mediaNodes: mediaNodes } = mediaPluginState;
    // Array#find... no IE support
    return mediaNodes.reduce((memo, nodeWithPos)=>{
        if (memo) return memo;
        const { node: node } = nodeWithPos;
        if (node.attrs.id === id) return nodeWithPos;
        return memo;
    }, null);
};
const $4eae1f857ea0604e$export$691b82c623e6f45f = (mediaPluginState, id)=>{
    const { mediaNodes: mediaNodes } = mediaPluginState;
    return mediaNodes.filter((nodeWithHandler)=>nodeWithHandler.node.attrs.id === id);
};
const $4eae1f857ea0604e$export$d6ca4605aefeca32 = (pos, state)=>{
    const node = state.doc.nodeAt(pos);
    return node && [
        'media',
        'mediaInline'
    ].includes(node.type.name);
};
const $4eae1f857ea0604e$export$9ab762e6df73c440 = (id, attrs)=>(state, dispatch)=>{
        const mediaPluginState = (0, $7ICJC.stateKey).getState(state);
        if (!mediaPluginState) return false;
        const mediaNodes = $4eae1f857ea0604e$export$691b82c623e6f45f(mediaPluginState, id);
        const validMediaNodePositions = mediaNodes.reduce((acc, { getPos: getPos })=>{
            const pos = getPos();
            if (typeof pos !== 'number' || isNaN(pos) || typeof pos === 'number' && !$4eae1f857ea0604e$export$d6ca4605aefeca32(pos, state)) return acc;
            acc.push(pos);
            return acc;
        }, []);
        if (validMediaNodePositions.length === 0) return false;
        const tr = state.tr;
        validMediaNodePositions.forEach((pos)=>tr.step(new (0, $4eNaz.SetAttrsStep)(pos, attrs)));
        tr.setMeta('addToHistory', false);
        (0, $gZj5p.tintDirtyTransaction)(tr);
        if (dispatch) dispatch(tr);
        return true;
    };
const $4eae1f857ea0604e$export$fb68358a5cd1917e = (attrs, mediaNode, tintDirtyTr)=>(state, dispatch)=>{
        const pos = mediaNode.getPos();
        if (typeof pos !== 'number' || isNaN(pos) || typeof pos === 'number' && !$4eae1f857ea0604e$export$d6ca4605aefeca32(pos, state)) return false;
        const tr = state.tr;
        tr.step(new (0, $4eNaz.SetAttrsStep)(pos, attrs));
        tr.setMeta('addToHistory', false);
        if (tintDirtyTr) (0, $gZj5p.tintDirtyTransaction)(tr);
        if (dispatch) dispatch(tr);
        return true;
    };
const $4eae1f857ea0604e$export$b75bb49e34d97d07 = (id, attrs)=>(state, dispatch)=>{
        const mediaPluginState = (0, $7ICJC.stateKey).getState(state);
        if (!mediaPluginState) return false;
        const mediaNodeWithPos = $4eae1f857ea0604e$export$f4585563863d37bf(mediaPluginState, id);
        if (!mediaNodeWithPos) return false;
        const tr = state.tr;
        const pos = mediaNodeWithPos.getPos();
        if (typeof pos !== 'number' || !$4eae1f857ea0604e$export$d6ca4605aefeca32(pos, state)) return false;
        tr.step(new (0, $4eNaz.SetAttrsStep)(pos, attrs)).setMeta('addToHistory', false);
        if (dispatch) dispatch(tr);
        return true;
    };
const $4eae1f857ea0604e$export$8c2989a33c6f5bd5 = (pos, attrs)=>(state, dispatch)=>{
        const tr = state.tr;
        const node = tr.doc.nodeAt(pos);
        if (!node || node.type.name !== 'media') return false;
        tr.step(new (0, $4eNaz.SetAttrsStep)(pos, {
            type: 'file',
            url: null,
            ...attrs
        })).setMeta('addToHistory', false);
        if (dispatch) dispatch(tr);
        return true;
    };

});

parcelRegister("h61b3", function(module, exports) {
$parcel$export(module.exports, "batchMediaNodeAttrsUpdate", () => $49a52202dd14f7d9$export$298f04086ed0efe2);

var $inh7J = parcelRequire("inh7J");

var $8XNPf = parcelRequire("8XNPf");

var $5pl5b = parcelRequire("5pl5b");
/**
 * 🧱 Internal: Editor FE Platform
 * Based on https://github.com/lodash/lodash/issues/2403#issuecomment-1706130395
 *
 * Creates a debounced function that delays invoking the provided function until after a specified
 * wait time has elapsed since the last time the debounced function was invoked. Additionally, the
 * debounced function is memoized so that the same function instance is used for each unique set
 * of arguments based on the resolver.
 *
 * This is particularly useful in scenarios where you want to debounce function calls while ensuring
 * that each unique input combination receives its own debounced function instance. It's a combination
 * of lodash's `debounce` and `memoize`.
 *
 * @template T
 * @param {T} func - The function to debounce.
 * @param {number} [wait=0] - The number of milliseconds to delay.
 * @param {object} [options] - The options object to pass to `debounce`.
 * @param {Function} [resolver] - The function to resolve the cache key for memoization.
 * @returns {Function} A new debounced and memoized function.
 *
 * @example
 * const debouncedFunction = memoizeDebounce(myFunction, 300, { leading: true }, myResolver);
 * debouncedFunction(arg1, arg2);
 */ function $49a52202dd14f7d9$var$memoizeDebounce(func, wait = 0, options, resolver) {
    const mem = (0, (/*@__PURE__*/$parcel$interopDefault($8XNPf)))(function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($inh7J)))(func, wait, options);
    }, resolver);
    return function(...args) {
        return mem(...args)(...args);
    };
}
const $49a52202dd14f7d9$var$mediaAttributesCache = new WeakMap();
const $49a52202dd14f7d9$var$debouncedTime = 500;
const $49a52202dd14f7d9$export$e13de86a39dc2884 = (a, b)=>{
    // a contains b, and want to check if attributes in b are same in a
    return Object.entries(b).every(([bkey, bValue])=>{
        if (bkey in a) {
            const aValue = a[bkey];
            // Check if types match before comparing values
            return typeof aValue === typeof bValue && aValue === bValue;
        }
        return false;
    });
};
const $49a52202dd14f7d9$export$36f3e00b05c9935d = (editorView, cache)=>{
    const toUpdateValues = cache.get(editorView) || {};
    // clear the media attributes cache per editor view
    cache.delete(editorView);
    const ids = Object.keys(toUpdateValues);
    const { state: state } = editorView;
    const mediaSteps = [];
    // search node positions by id
    state.doc.descendants((node, position)=>{
        if (![
            node.type.schema.nodes.media,
            node.type.schema.nodes.mediaInline
        ].includes(node.type)) return true;
        if (!ids.includes(node.attrs.id)) return false;
        const attrs = toUpdateValues[node.attrs.id];
        if ($49a52202dd14f7d9$export$e13de86a39dc2884(node.attrs, attrs)) return false;
        mediaSteps.push({
            position: position,
            nodeType: node.type.name,
            attrs: attrs
        });
    });
    if (mediaSteps.length > 0) (0, $5pl5b.batchStepsUpdate)(editorView, mediaSteps);
};
const $49a52202dd14f7d9$export$8ad1cb8a3a0ac36b = $49a52202dd14f7d9$var$memoizeDebounce($49a52202dd14f7d9$export$36f3e00b05c9935d, $49a52202dd14f7d9$var$debouncedTime, /**
 * Use the default debounce options:
 * {leading: false, trailing: true}
 */ undefined, (view)=>{
    /**
   * EditorView is a singleton.
   * There is only one instance per Editor.
   */ return view;
});
const $49a52202dd14f7d9$export$298f04086ed0efe2 = (editorView, props)=>{
    let cachePerView = $49a52202dd14f7d9$var$mediaAttributesCache.get(editorView);
    if (!cachePerView) cachePerView = {
        records: {}
    };
    cachePerView[props.id] = {
        ...cachePerView[props.id] || {},
        ...props.nextAttributes
    };
    $49a52202dd14f7d9$var$mediaAttributesCache.set(editorView, cachePerView);
    $49a52202dd14f7d9$export$8ad1cb8a3a0ac36b(editorView, $49a52202dd14f7d9$var$mediaAttributesCache);
};

});
parcelRegister("5pl5b", function(module, exports) {
$parcel$export(module.exports, "batchStepsUpdate", () => $a808766d22fa8c7a$export$4dd32806a37c505b);

var $48ZJc = parcelRequire("48ZJc");

var $gZj5p = parcelRequire("gZj5p");
const $a808766d22fa8c7a$export$4dd32806a37c505b = (editorView, steps)=>{
    const { state: state, dispatch: dispatch } = editorView;
    const tr = state.tr;
    if (steps.length === 0) return false;
    tr.step(new (0, $48ZJc.BatchAttrsStep)(steps));
    if (tr.steps.length > 0 && tr.doc.eq(state.doc)) return false;
    (0, $gZj5p.tintDirtyTransaction)(tr);
    dispatch(tr);
};

});


parcelRegister("4sVoN", function(module, exports) {
$parcel$export(module.exports, "isMediaBlobUrlFromAttrs", () => $40ad58b206d8cc69$export$2111a084b5e4465d);
$parcel$export(module.exports, "posOfMediaGroupNearby", () => $40ad58b206d8cc69$export$7abbbf8335ec653);
$parcel$export(module.exports, "posOfParentMediaGroup", () => $40ad58b206d8cc69$export$6f3a1f1a8fe30200);
$parcel$export(module.exports, "posOfPrecedingMediaGroup", () => $40ad58b206d8cc69$export$365a04aece6dfb6);
$parcel$export(module.exports, "isSelectionNonMediaBlockNode", () => $40ad58b206d8cc69$export$5921300994784ec4);
$parcel$export(module.exports, "isSelectionMediaSingleNode", () => $40ad58b206d8cc69$export$e5cc26eb78c044a3);
$parcel$export(module.exports, "isInsidePotentialEmptyParagraph", () => $40ad58b206d8cc69$export$c64712b0ea25772a);
$parcel$export(module.exports, "removeMediaNode", () => $40ad58b206d8cc69$export$ddc636b287a33575);
$parcel$export(module.exports, "splitMediaGroup", () => $40ad58b206d8cc69$export$60aa99908f1d280f);
$parcel$export(module.exports, "copyOptionalAttrsFromMediaState", () => $40ad58b206d8cc69$export$21d5b3d9cf01948c);
$parcel$export(module.exports, "isMediaSingleOrInlineNodeSelected", () => $40ad58b206d8cc69$export$5410c0ed8420fc75);
$parcel$export(module.exports, "getMediaSingleOrInlineNodeFromSelection", () => $40ad58b206d8cc69$export$e9f7b6e4ebb6d186);
$parcel$export(module.exports, "getMediaFromSupportedMediaNodesFromSelection", () => $40ad58b206d8cc69$export$a556482c8c054147);
$parcel$export(module.exports, "isNodeDoubleClickSupportedInLivePagesViewMode", () => $40ad58b206d8cc69$export$7940ab1d031fef29);
$parcel$export(module.exports, "getIdentifier", () => $40ad58b206d8cc69$export$adb27ddab077e944);
$parcel$export(module.exports, "extractMediaNodes", () => $40ad58b206d8cc69$export$a22092fc57f1d693);
$parcel$export(module.exports, "createMediaIdentifierArray", () => $40ad58b206d8cc69$export$be91ba10d8a4f435);

var $5iSwO = parcelRequire("5iSwO");
var $BqAL4 = parcelRequire("BqAL4");
var $7k00C = parcelRequire("7k00C");

var $j7pt0 = parcelRequire("j7pt0");

var $6Cbfp = parcelRequire("6Cbfp");

var $h7zC7 = parcelRequire("h7zC7");

var $5FzRL = parcelRequire("5FzRL");

var $cw0wu = parcelRequire("cw0wu");

var $gab48 = parcelRequire("gab48");

var $2IaXl = parcelRequire("2IaXl");

var $fRvvl = parcelRequire("fRvvl");

var $7omWA = parcelRequire("7omWA");

var $2jJHo = parcelRequire("2jJHo");

var $jmBd6 = parcelRequire("jmBd6");
const $40ad58b206d8cc69$var$isTemporary = (id)=>{
    return id.indexOf('temporary:') === 0;
};
const $40ad58b206d8cc69$export$2111a084b5e4465d = (attrs)=>{
    return !!(attrs && attrs.type === 'external' && (0, $2IaXl.isMediaBlobUrl)(attrs.url));
};
const $40ad58b206d8cc69$export$7abbbf8335ec653 = (state)=>{
    return $40ad58b206d8cc69$export$6f3a1f1a8fe30200(state) || $40ad58b206d8cc69$var$posOfFollowingMediaGroup(state) || $40ad58b206d8cc69$export$365a04aece6dfb6(state) || $40ad58b206d8cc69$var$posOfMediaGroupNextToGapCursor(state);
};
const $40ad58b206d8cc69$export$5921300994784ec4 = (state)=>{
    const { node: node } = state.selection;
    return node && node.type !== state.schema.nodes.media && node.isBlock;
};
const $40ad58b206d8cc69$export$e5cc26eb78c044a3 = (state)=>{
    const { node: node } = state.selection;
    return node && node.type === state.schema.nodes.mediaSingle;
};
const $40ad58b206d8cc69$var$isSelectionMediaInlineNode = (state)=>{
    const { node: node } = state.selection;
    return node && node.type === state.schema.nodes.mediaInline;
};
const $40ad58b206d8cc69$export$365a04aece6dfb6 = (state)=>{
    if (!(0, $6Cbfp.atTheBeginningOfBlock)(state)) return;
    return $40ad58b206d8cc69$var$posOfMediaGroupAbove(state, state.selection.$from);
};
const $40ad58b206d8cc69$var$posOfMediaGroupNextToGapCursor = (state)=>{
    const { selection: selection } = state;
    if (selection instanceof (0, $j7pt0.GapCursorSelection)) {
        const $pos = state.selection.$from;
        const mediaGroupType = state.schema.nodes.mediaGroup;
        return $40ad58b206d8cc69$var$posOfImmediatePrecedingMediaGroup($pos, mediaGroupType) || $40ad58b206d8cc69$var$posOfImmediateFollowingMediaGroup($pos, mediaGroupType);
    }
};
const $40ad58b206d8cc69$var$posOfImmediatePrecedingMediaGroup = ($pos, mediaGroupType)=>{
    if ($pos.nodeBefore && $pos.nodeBefore.type === mediaGroupType) return $pos.pos - $pos.nodeBefore.nodeSize + 1;
};
const $40ad58b206d8cc69$var$posOfImmediateFollowingMediaGroup = ($pos, mediaGroupType)=>{
    if ($pos.nodeAfter && $pos.nodeAfter.type === mediaGroupType) return $pos.pos + 1;
};
const $40ad58b206d8cc69$var$posOfFollowingMediaGroup = (state)=>{
    if (!(0, $6Cbfp.atTheEndOfBlock)(state)) return;
    return $40ad58b206d8cc69$var$posOfMediaGroupBelow(state, state.selection.$to);
};
const $40ad58b206d8cc69$var$posOfMediaGroupAbove = (state, $pos)=>{
    let adjacentPos;
    let adjacentNode;
    if ($40ad58b206d8cc69$export$5921300994784ec4(state)) {
        adjacentPos = $pos.pos;
        adjacentNode = $pos.nodeBefore;
    } else {
        adjacentPos = (0, $7k00C.startPositionOfParent)($pos) - 1;
        adjacentNode = state.doc.resolve(adjacentPos).nodeBefore;
    }
    if (adjacentNode && adjacentNode.type === state.schema.nodes.mediaGroup) return adjacentPos - adjacentNode.nodeSize + 1;
    return;
};
const $40ad58b206d8cc69$export$c64712b0ea25772a = (state)=>{
    const { $from: $from } = state.selection;
    return $from.parent.type === state.schema.nodes.paragraph && (0, $6Cbfp.atTheBeginningOfBlock)(state) && (0, $6Cbfp.atTheEndOfBlock)(state);
};
const $40ad58b206d8cc69$var$posOfMediaGroupBelow = (state, $pos, prepend = true)=>{
    let adjacentPos;
    let adjacentNode;
    if ($40ad58b206d8cc69$export$5921300994784ec4(state)) {
        adjacentPos = $pos.pos;
        adjacentNode = $pos.nodeAfter;
    } else {
        adjacentPos = (0, $BqAL4.endPositionOfParent)($pos);
        adjacentNode = state.doc.nodeAt(adjacentPos);
    }
    if (adjacentNode && adjacentNode.type === state.schema.nodes.mediaGroup) return prepend ? adjacentPos + 1 : adjacentPos + adjacentNode.nodeSize - 1;
    return;
};
const $40ad58b206d8cc69$export$6f3a1f1a8fe30200 = (state, $pos, prepend = false)=>{
    const { $from: $from } = state.selection;
    $pos = $pos || $from;
    if ($pos.parent.type === state.schema.nodes.mediaGroup) return prepend ? (0, $7k00C.startPositionOfParent)($pos) : (0, $BqAL4.endPositionOfParent)($pos) - 1;
    return;
};
const $40ad58b206d8cc69$export$ddc636b287a33575 = (view, node, getPos)=>{
    const { id: id } = node.attrs;
    const { state: state } = view;
    const { tr: tr, selection: selection, doc: doc } = state;
    const currentMediaNodePos = getPos();
    if (typeof currentMediaNodePos !== 'number') return;
    tr.deleteRange(currentMediaNodePos, currentMediaNodePos + node.nodeSize);
    if ($40ad58b206d8cc69$var$isTemporary(id)) tr.setMeta('addToHistory', false);
    const $currentMediaNodePos = doc.resolve(currentMediaNodePos);
    const { nodeBefore: nodeBefore, parent: parent } = $currentMediaNodePos;
    const isLastMediaNode = $currentMediaNodePos.index() === parent.childCount - 1;
    // If deleting a selected media node, we need to tell where the cursor to go next.
    // Prosemirror didn't gave us the behaviour of moving left if the media node is not the last one.
    // So we handle it ourselves.
    if (selection.from === currentMediaNodePos && !isLastMediaNode && !(0, $5iSwO.atTheBeginningOfDoc)(state) && nodeBefore && nodeBefore.type.name === 'media') {
        const nodeBefore = (0, $gab48.findPositionOfNodeBefore)(tr.selection);
        if (nodeBefore) tr.setSelection((0, $cw0wu.NodeSelection).create(tr.doc, nodeBefore));
    }
    view.dispatch(tr);
};
const $40ad58b206d8cc69$export$60aa99908f1d280f = (view)=>{
    const { selection: selection } = view.state;
    // if selection is not a media node, do nothing.
    if (!(selection instanceof (0, $cw0wu.NodeSelection)) || selection.node.type !== view.state.schema.nodes.media) return false;
    (0, $5FzRL.deleteSelection)(view.state, view.dispatch);
    if (selection.$to.nodeAfter) {
        (0, $5FzRL.splitBlock)(view.state, view.dispatch);
        (0, $h7zC7.createParagraphNear)(false)(view.state, view.dispatch);
    } else (0, $h7zC7.createNewParagraphBelow)(view.state, view.dispatch);
    return true;
};
const $40ad58b206d8cc69$var$isOptionalAttr = (attr)=>attr.length > 1 && attr[0] === '_' && attr[1] === '_';
const $40ad58b206d8cc69$export$21d5b3d9cf01948c = (mediaState, node)=>{
    Object.keys(node.attrs).filter($40ad58b206d8cc69$var$isOptionalAttr).forEach((key)=>{
        const mediaStateKey = key.substring(2);
        const attrValue = mediaState[mediaStateKey];
        if (attrValue !== undefined) // @ts-ignore - [unblock prosemirror bump] assigning to readonly prop
        node.attrs[key] = attrValue;
    });
};
const $40ad58b206d8cc69$export$9b24cf4bc5375bda = (state)=>{
    if (!$40ad58b206d8cc69$export$e5cc26eb78c044a3(state)) return null;
    const tr = state.tr;
    const pos = tr.selection.from + 1;
    const mediaNode = tr.doc.nodeAt(pos);
    if (mediaNode && mediaNode.type === state.schema.nodes.media) return mediaNode;
    return null;
};
const $40ad58b206d8cc69$var$getMediaInlineNodeFromSelection = (state)=>{
    if (!$40ad58b206d8cc69$var$isSelectionMediaInlineNode(state)) return null;
    const tr = state.tr;
    const pos = tr.selection.from;
    const mediaNode = tr.doc.nodeAt(pos);
    return mediaNode;
};
const $40ad58b206d8cc69$export$5410c0ed8420fc75 = (state)=>{
    const { allowInlineImages: allowInlineImages } = (0, $2jJHo.getMediaPluginState)(state);
    return $40ad58b206d8cc69$export$e5cc26eb78c044a3(state) || allowInlineImages && $40ad58b206d8cc69$var$isSelectionMediaInlineNode(state);
};
const $40ad58b206d8cc69$export$e9f7b6e4ebb6d186 = (state)=>{
    const { allowInlineImages: allowInlineImages } = (0, $2jJHo.getMediaPluginState)(state);
    const mediaNode = $40ad58b206d8cc69$export$9b24cf4bc5375bda(state) || allowInlineImages && $40ad58b206d8cc69$var$getMediaInlineNodeFromSelection(state);
    return mediaNode || null;
};
const $40ad58b206d8cc69$export$a556482c8c054147 = (state)=>{
    const { node: node } = state.selection;
    // Specifically for media supported nodes, double click could have been initiated on the media caption
    if (!node) return null;
    switch(node.type){
        case node.type.schema.nodes.media:
        case node.type.schema.nodes.mediaInline:
            return node;
        case node.type.schema.nodes.mediaSingle:
        case node.type.schema.nodes.mediaGroup:
            return node.firstChild;
        default:
            return null;
    }
};
const $40ad58b206d8cc69$export$7940ab1d031fef29 = (isViewMode, node)=>{
    if (!node) return false;
    // Double Click is not supported for video nodes on both views
    if ((0, $jmBd6.isVideo)(node.attrs.__fileMimeType)) return false;
    // Double click is supported for all editor media nodes
    if (!isViewMode) return true;
    // Double Click is not supported for mediaGroup and mediaInline nodes that are file
    if (node.type === node.type.schema.nodes.mediaGroup || node.type === node.type.schema.nodes.mediaInline && node.attrs.type === 'file') return false;
    // Double Click supported for all other media nodes
    return true;
};
const $40ad58b206d8cc69$export$adb27ddab077e944 = (attrs)=>{
    if ((0, $7omWA.isExternalMedia)(attrs)) return {
        mediaItemType: 'external-image',
        dataURI: attrs.url
    };
    else {
        const { id: id, collection: collection = '' } = attrs;
        return {
            id: id,
            mediaItemType: 'file',
            collectionName: collection
        };
    }
};
const $40ad58b206d8cc69$export$a22092fc57f1d693 = (doc)=>{
    const mediaNodes = [];
    doc.descendants((node)=>{
        if (node.type.name === 'media' || node.type.name === 'mediaInline') mediaNodes.push(node);
    });
    return mediaNodes;
};
const $40ad58b206d8cc69$export$be91ba10d8a4f435 = (mediaNodes)=>{
    const mediaIdentifierMap = new Map();
    mediaNodes.forEach((item)=>{
        const attrs = item.attrs;
        if (!attrs) return;
        if ((0, $jmBd6.isVideo)(attrs.__fileMimeType)) return;
        const identifier = $40ad58b206d8cc69$export$adb27ddab077e944(attrs);
        // Add only if not already processed
        const idKey = (0, $fRvvl.isExternalImageIdentifier)(identifier) ? identifier.dataURI : identifier.id;
        if (!mediaIdentifierMap.has(idKey)) mediaIdentifierMap.set(idKey, identifier);
    });
    return [
        ...mediaIdentifierMap.values()
    ];
};

});
parcelRegister("7omWA", function(module, exports) {
$parcel$export(module.exports, "isExternalMedia", () => $f269901af015a40f$export$c8d0f9dbb5a183eb);
$parcel$export(module.exports, "getSelectedNearestMediaContainerNodeAttrsFunction", () => $f269901af015a40f$export$a5d2856f3da2ba87);
$parcel$export(module.exports, "getSelectedNearestMediaContainerNodeAttrs", () => $f269901af015a40f$export$33674170711ec257);
$parcel$export(module.exports, "getIsDownloadDisabledByDataSecurityPolicy", () => $f269901af015a40f$export$de36002be6360c60);
$parcel$export(module.exports, "downloadMedia", () => $f269901af015a40f$export$e8f97a24a74eb5e0);
$parcel$export(module.exports, "removeMediaGroupNode", () => $f269901af015a40f$export$83833694bbefe84a);
$parcel$export(module.exports, "getSelectedMediaSingle", () => $f269901af015a40f$export$3b6a8a992fa2a6d6);
$parcel$export(module.exports, "getPixelWidthOfElement", () => $f269901af015a40f$export$5b609aa7c383235);
$parcel$export(module.exports, "calcNewLayout", () => $f269901af015a40f$export$62003b26b3b70d62);
$parcel$export(module.exports, "getMaxToolbarWidth", () => $f269901af015a40f$export$6bd6107b1c4a8338);
$parcel$export(module.exports, "getSelectedLayoutIcon", () => $f269901af015a40f$export$247dbed7311e99c7);
$parcel$export(module.exports, "canShowSwitchButtons", () => $f269901af015a40f$export$e9cd793e76f25514);
$parcel$export(module.exports, "updateToFullHeightSeparator", () => $f269901af015a40f$export$e13ccac5f0484027);
$parcel$export(module.exports, "getMediaSingleAndMediaInlineSwitcherDropdown", () => $f269901af015a40f$export$cf30b16cfb070b4a);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $57l7A = parcelRequire("57l7A");

var $29qUP = parcelRequire("29qUP");

var $ahEv1 = parcelRequire("ahEv1");

var $6B1yf = parcelRequire("6B1yf");

var $gab48 = parcelRequire("gab48");

var $5bbjm = parcelRequire("5bbjm");

var $g6z2B = parcelRequire("g6z2B");

var $eNuIV = parcelRequire("eNuIV");

var $83J3A = parcelRequire("83J3A");

var $2HqML = parcelRequire("2HqML");

var $jmBd6 = parcelRequire("jmBd6");

var $jAHUG = parcelRequire("jAHUG");
const $f269901af015a40f$export$c8d0f9dbb5a183eb = (attrs)=>{
    return attrs.type === 'external';
};
const $f269901af015a40f$var$getSelectedMediaContainerNodeAttrs = (mediaPluginState)=>{
    var _mediaPluginState$sel;
    const selectedNode = (_mediaPluginState$sel = mediaPluginState.selectedMediaContainerNode) === null || _mediaPluginState$sel === void 0 ? void 0 : _mediaPluginState$sel.call(mediaPluginState);
    if (selectedNode && selectedNode.attrs) return selectedNode.attrs;
    return null;
};
const $f269901af015a40f$export$a5d2856f3da2ba87 = (selectedMediaContainerNode)=>{
    const selectedNode = selectedMediaContainerNode === null || selectedMediaContainerNode === void 0 ? void 0 : selectedMediaContainerNode();
    if (selectedNode) switch(selectedNode.type.name){
        case 'mediaSingle':
            {
                const childNode = selectedNode.firstChild;
                return childNode === null || childNode === void 0 ? void 0 : childNode.attrs;
            }
        default:
            return selectedNode.attrs;
    }
    return null;
};
const $f269901af015a40f$export$33674170711ec257 = (mediaPluginState)=>{
    return $f269901af015a40f$export$a5d2856f3da2ba87(mediaPluginState.selectedMediaContainerNode);
};
const $f269901af015a40f$export$de36002be6360c60 = (mediaPluginState)=>{
    var _mediaPluginState$med;
    const enforceMediaDataSecurityPolicy = mediaPluginState === null || mediaPluginState === void 0 || (_mediaPluginState$med = mediaPluginState.mediaClientConfig) === null || _mediaPluginState$med === void 0 ? void 0 : _mediaPluginState$med.enforceDataSecurityPolicy;
    return typeof enforceMediaDataSecurityPolicy === 'boolean' ? enforceMediaDataSecurityPolicy : false;
};
const $f269901af015a40f$export$e8f97a24a74eb5e0 = async (mediaPluginState, isViewMode)=>{
    try {
        const selectedNodeAttrs = isViewMode ? $f269901af015a40f$export$33674170711ec257(mediaPluginState) : $f269901af015a40f$var$getSelectedMediaContainerNodeAttrs(mediaPluginState);
        if (selectedNodeAttrs && mediaPluginState.mediaClientConfig && !$f269901af015a40f$export$c8d0f9dbb5a183eb(selectedNodeAttrs)) {
            var _mediaPluginState$med2;
            const { id: id, collection: collection = '' } = selectedNodeAttrs;
            const mediaClient = (0, $83J3A.getMediaClient)(mediaPluginState.mediaClientConfig);
            const fileState = await mediaClient.file.getCurrentState(id, {
                collectionName: collection
            });
            let fileName = fileState.status === 'error' ? undefined : fileState.name;
            if (!fileName && (_mediaPluginState$med2 = mediaPluginState.mediaOptions) !== null && _mediaPluginState$med2 !== void 0 && _mediaPluginState$med2.fallbackMediaNameFetcher) {
                const fetched = await mediaPluginState.mediaOptions.fallbackMediaNameFetcher(id).catch(()=>undefined);
                fileName = fetched ?? undefined;
            }
            mediaClient.file.downloadBinary(id, fileName, collection);
        }
        return true;
    } catch (err) {
        return false;
    }
};
const $f269901af015a40f$export$83833694bbefe84a = (state)=>{
    const { mediaGroup: mediaGroup } = state.schema.nodes;
    const mediaGroupParent = (0, $gab48.findParentNodeOfType)(mediaGroup)(state.selection);
    let tr = state.tr;
    // If it is the last media group in filmstrip, remove the entire filmstrip
    if (mediaGroupParent && mediaGroupParent.node.childCount === 1) tr = (0, $gab48.removeParentNodeOfType)(mediaGroup)(tr);
    else tr = (0, $gab48.removeSelectedNode)(tr);
    return tr;
};
const $f269901af015a40f$export$3b6a8a992fa2a6d6 = (state)=>{
    const { mediaSingle: mediaSingle } = state.schema.nodes;
    return (0, $gab48.findSelectedNodeOfType)(mediaSingle)(state.selection) || (0, $gab48.findParentNodeOfType)(mediaSingle)(state.selection);
};
const $f269901af015a40f$export$5b609aa7c383235 = (0, $57l7A.default)((editorView, pos, mediaWidth)=>{
    const domNode = editorView.nodeDOM(pos);
    if (domNode instanceof HTMLElement) return domNode.offsetWidth;
    return mediaWidth;
});
const $f269901af015a40f$export$62003b26b3b70d62 = (width, layout, contentWidth, fullWidthMode = false, isNested = false)=>{
    const isWrappedLayout = (0, $29qUP.wrappedLayouts).indexOf(layout) > -1;
    //See flowchart for layout logic: https://hello.atlassian.net/wiki/spaces/TWPCP/whiteboard/2969594044
    if (width >= (0, $5bbjm.akEditorFullWidthLayoutWidth)) // If width is greater than or equal to full editor width
    return 'full-width';
    if (fullWidthMode) // If under editor full width mode
    return isWrappedLayout ? layout : 'center';
    if (width > contentWidth && !isNested) // If width is greater than content length and not nested
    return 'wide';
    return isNested || isWrappedLayout && width !== contentWidth ? layout : 'center';
};
let $f269901af015a40f$var$maxToolbarFitWidth = 0;
const $f269901af015a40f$export$6bd6107b1c4a8338 = ()=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const toolbar = document.querySelector(`div[aria-label="Media floating controls"]`);
    const toolbarWidth = toolbar === null || toolbar === void 0 ? void 0 : toolbar.getBoundingClientRect().width;
    if (!toolbar) $f269901af015a40f$var$maxToolbarFitWidth = 0;
    if (toolbarWidth && toolbarWidth > $f269901af015a40f$var$maxToolbarFitWidth) $f269901af015a40f$var$maxToolbarFitWidth = toolbarWidth;
    return $f269901af015a40f$var$maxToolbarFitWidth;
};
const $f269901af015a40f$export$247dbed7311e99c7 = (layoutIcons, selectedNode)=>{
    const selectedLayout = selectedNode.attrs.layout;
    return layoutIcons.find((icon)=>icon.value === ((0, $6B1yf.nonWrappedLayouts).includes(selectedLayout) ? 'center' : selectedLayout));
};
const $f269901af015a40f$export$e9cd793e76f25514 = (mediaSingleNode)=>{
    if (mediaSingleNode) {
        const mediaNode = mediaSingleNode.content.firstChild;
        return mediaNode && !(0, $jmBd6.isVideo)(mediaNode.attrs.__fileMimeType);
    }
    return false;
};
const $f269901af015a40f$export$e13ccac5f0484027 = (items)=>{
    const lastItem = items.at(-1);
    if ((lastItem === null || lastItem === void 0 ? void 0 : lastItem.type) === 'separator') lastItem.fullHeight = true;
    else if (items.length) items.push({
        type: 'separator',
        fullHeight: true
    });
};
const $f269901af015a40f$export$cf30b16cfb070b4a = (nodeType, intl, pluginInjectionApi, hasCaption = false)=>{
    var _pluginInjectionApi$a, _pluginInjectionApi$a2;
    const mediaInlineImageTitle = intl.formatMessage((0, $ahEv1.toolbarMessages).changeToMediaInlineImage);
    const mediaSingleTitle = intl.formatMessage((0, $ahEv1.toolbarMessages).changeToMediaSingle);
    const inlineSwitcherTitle = intl.formatMessage(hasCaption ? (0, $ahEv1.toolbarMessages).changeToMediaInlineImageCaptionWarning : (0, $ahEv1.toolbarMessages).changeToMediaInlineImage);
    const InlineIcon = ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g6z2B))), {
            color: "currentColor",
            spacing: "spacious",
            label: ""
        });
    const BlockIcon = ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eNuIV))), {
            color: "currentColor",
            spacing: "spacious",
            label: ""
        });
    const dropdownConfig = {
        inline: {
            handleInlineButtonClick: ()=>{
                return true;
            },
            handleBlockButtonClick: (0, $jAHUG.changeMediaInlineToMediaSingle)(pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$a = pluginInjectionApi.analytics) === null || _pluginInjectionApi$a === void 0 ? void 0 : _pluginInjectionApi$a.actions, pluginInjectionApi === null || pluginInjectionApi === void 0 ? void 0 : pluginInjectionApi.width.sharedState.currentState()),
            id: 'media-inline-to-block-toolbar-item',
            icon: InlineIcon
        },
        block: {
            handleInlineButtonClick: (0, $jAHUG.changeMediaSingleToMediaInline)(pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$a2 = pluginInjectionApi.analytics) === null || _pluginInjectionApi$a2 === void 0 ? void 0 : _pluginInjectionApi$a2.actions),
            handleBlockButtonClick: ()=>{
                return true;
            },
            id: 'media-block-to-inline-toolbar-item',
            icon: BlockIcon
        }
    };
    const options = [
        {
            id: 'editor.media.convert.mediainline',
            title: mediaInlineImageTitle,
            onClick: dropdownConfig[nodeType].handleInlineButtonClick,
            selected: nodeType === 'inline',
            icon: /*#__PURE__*/ (0, $dc70d.jsx)(InlineIcon, {}),
            tooltip: hasCaption ? inlineSwitcherTitle : undefined
        },
        {
            id: 'editor.media.convert.mediasingle',
            title: mediaSingleTitle,
            onClick: dropdownConfig[nodeType].handleBlockButtonClick,
            selected: nodeType === 'block',
            icon: /*#__PURE__*/ (0, $dc70d.jsx)(BlockIcon, {})
        }
    ];
    return {
        id: dropdownConfig[nodeType].id,
        testId: 'media-inline-to-block-dropdown',
        title: intl.formatMessage((0, $2HqML.messages).sizeOptions),
        type: 'dropdown',
        options: options,
        icon: dropdownConfig[nodeType].icon
    };
};

});
parcelRegister("jmBd6", function(module, exports) {
$parcel$export(module.exports, "isMediaSingle", () => $6b5a646c214f033b$export$e5065363a261ea68);
$parcel$export(module.exports, "insertMediaAsMediaSingle", () => $6b5a646c214f033b$export$62e6f072fbcbc210);
$parcel$export(module.exports, "createInsertMediaAsMediaSingleCommand", () => $6b5a646c214f033b$export$ad66fa9805ac027a);
$parcel$export(module.exports, "insertMediaSingleNode", () => $6b5a646c214f033b$export$653e52366db7c5b6);
$parcel$export(module.exports, "isVideo", () => $6b5a646c214f033b$export$ac5608bbe92d6fdc);
$parcel$export(module.exports, "changeFromMediaInlineToMediaSingleNode", () => $6b5a646c214f033b$export$276040c239babb42);

var $57l7A = parcelRequire("57l7A");

var $g6Qq4 = parcelRequire("g6Qq4");

var $dw0oh = parcelRequire("dw0oh");

var $7Pkpg = parcelRequire("7Pkpg");

var $29qUP = parcelRequire("29qUP");

var $33OA0 = parcelRequire("33OA0");

var $7k00C = parcelRequire("7k00C");

var $6Cbfp = parcelRequire("6Cbfp");

var $56AB9 = parcelRequire("56AB9");
var $24xJB = parcelRequire("24xJB");

var $kW8qW = parcelRequire("kW8qW");

var $gab48 = parcelRequire("gab48");

var $5bbjm = parcelRequire("5bbjm");

var $jCYj3 = parcelRequire("jCYj3");

var $gdUUy = parcelRequire("gdUUy");

var $4sVoN = parcelRequire("4sVoN");

var $cbWfC = parcelRequire("cbWfC");

var $icDBi = parcelRequire("icDBi");
const $6b5a646c214f033b$var$TABLE_CELL_HORIZONTAL_PADDING = 16;
const $6b5a646c214f033b$var$getPositiveWidth = (width)=>typeof width === 'number' && width > 0 ? width : undefined;
const $6b5a646c214f033b$var$getClosestNodeDepth = ($pos, nodeNames)=>{
    for(let depth = $pos.depth; depth > 0; depth--){
        if (nodeNames.includes($pos.node(depth).type.name)) return depth;
    }
};
const $6b5a646c214f033b$var$getTableCellWidthFromPosition = (doc, pos)=>{
    if (typeof pos !== 'number') return undefined;
    try {
        const $pos = doc.resolve(pos);
        const cellDepth = $6b5a646c214f033b$var$getClosestNodeDepth($pos, [
            'tableCell',
            'tableHeader'
        ]);
        const tableDepth = $6b5a646c214f033b$var$getClosestNodeDepth($pos, [
            'table'
        ]);
        if (cellDepth === undefined || tableDepth === undefined || tableDepth >= cellDepth) return undefined;
        const tableNode = $pos.node(tableDepth);
        const cellNode = $pos.node(cellDepth);
        const tableMap = (0, $jCYj3.TableMap).get(tableNode);
        const tableStart = $pos.before(tableDepth) + 1;
        const cellPositionInTable = $pos.before(cellDepth) - tableStart;
        const cellRect = tableMap.findCell(cellPositionInTable);
        const columnSpan = cellRect.right - cellRect.left;
        const colwidth = cellNode.attrs.colwidth;
        const explicitCellWidth = colwidth === null || colwidth === void 0 ? void 0 : colwidth.slice(0, columnSpan).reduce((total, width)=>total + width, 0);
        const tableWidth = $6b5a646c214f033b$var$getPositiveWidth(tableNode.attrs.width) ?? (0, $5bbjm.akEditorDefaultLayoutWidth);
        const inferredCellWidth = tableWidth / tableMap.width * columnSpan;
        const cellWidth = $6b5a646c214f033b$var$getPositiveWidth(explicitCellWidth) ?? $6b5a646c214f033b$var$getPositiveWidth(inferredCellWidth);
        return cellWidth ? cellWidth - $6b5a646c214f033b$var$TABLE_CELL_HORIZONTAL_PADDING : undefined;
    } catch  {
        return undefined;
    }
};
const $6b5a646c214f033b$var$getMediaSingleMaxWidthForInsertion = (view, pos, widthPluginState)=>$6b5a646c214f033b$var$getPositiveWidth((0, $33OA0.getMaxWidthForNestedNodeNext)(view, pos, true)) ?? $6b5a646c214f033b$var$getPositiveWidth($6b5a646c214f033b$var$getTableCellWidthFromPosition(view.state.doc, pos)) ?? $6b5a646c214f033b$var$getPositiveWidth(widthPluginState === null || widthPluginState === void 0 ? void 0 : widthPluginState.lineLength) ?? $6b5a646c214f033b$var$getPositiveWidth(widthPluginState === null || widthPluginState === void 0 ? void 0 : widthPluginState.width);
const $6b5a646c214f033b$var$getInsertMediaAnalytics = (inputMethod, fileExtension, insertMediaVia)=>({
        action: (0, $g6Qq4.ACTION).INSERTED,
        actionSubject: (0, $g6Qq4.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).MEDIA,
        attributes: {
            inputMethod: inputMethod,
            insertMediaVia: insertMediaVia,
            fileExtension: fileExtension,
            type: (0, $g6Qq4.ACTION_SUBJECT_ID).MEDIA_SINGLE
        },
        eventType: (0, $g6Qq4.EVENT_TYPE).TRACK
    });
function $6b5a646c214f033b$var$shouldAddParagraph(state) {
    return (0, $6Cbfp.atTheBeginningOfBlock)(state) && !(0, $56AB9.checkNodeDown)(state.selection, state.doc, (0, $24xJB.isEmptyParagraph));
}
function $6b5a646c214f033b$var$insertNodesWithOptionalParagraph({ nodes: nodes, analyticsAttributes: analyticsAttributes = {}, editorAnalyticsAPI: editorAnalyticsAPI, insertMediaVia: insertMediaVia }) {
    return function(state, dispatch) {
        const { tr: tr } = state;
        if ((0, $gdUUy.fg)('platform_editor_introduce_insert_media_command')) {
            const updatedTr = $6b5a646c214f033b$var$insertNodesWithOptionalParagraphCommand({
                nodes: nodes,
                analyticsAttributes: analyticsAttributes,
                editorAnalyticsAPI: editorAnalyticsAPI,
                insertMediaVia: insertMediaVia
            })({
                tr: tr
            });
            if (updatedTr && dispatch) {
                dispatch === null || dispatch === void 0 || dispatch(updatedTr);
                return true;
            }
            return false;
        }
        const { inputMethod: inputMethod, fileExtension: fileExtension, newType: newType, previousType: previousType } = analyticsAttributes;
        let updatedTr = tr;
        const openEnd = 0;
        if (state.selection.empty) {
            const insertFrom = (0, $6Cbfp.atTheBeginningOfBlock)(state) ? state.selection.$from.before() : state.selection.from;
            // the use of pmSafeInsert causes the node selection to media single node.
            // It leads to discrepancy between the full-page and comment editor - not sure why :shrug:
            // When multiple images are uploaded, the node selection is set to the previous node
            // and got overridden by the next node inserted.
            // It also causes the images position shifted when the images are uploaded.
            // E.g the images are uploaded after a table, the images will be inserted inside the table.
            // so we revert to use tr.insert instead. No extra paragraph is added.
            updatedTr = updatedTr.insert(insertFrom, nodes);
        } else updatedTr.replaceSelection(new (0, $kW8qW.Slice)((0, $kW8qW.Fragment).from(nodes), 0, openEnd));
        if (inputMethod) editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent($6b5a646c214f033b$var$getInsertMediaAnalytics(inputMethod, fileExtension, insertMediaVia))(updatedTr);
        if (newType && previousType) editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent((0, $cbWfC.getChangeMediaAnalytics)(previousType, newType, (0, $cbWfC.findChangeFromLocation)(state.selection)))(updatedTr);
        if (dispatch) dispatch(updatedTr);
        return true;
    };
}
function $6b5a646c214f033b$var$insertNodesWithOptionalParagraphCommand({ nodes: nodes, positions: positions, analyticsAttributes: analyticsAttributes = {}, editorAnalyticsAPI: editorAnalyticsAPI, insertMediaVia: insertMediaVia }) {
    return ({ tr: tr })=>{
        const { inputMethod: inputMethod, fileExtension: fileExtension, newType: newType, previousType: previousType } = analyticsAttributes;
        let updatedTr = tr;
        const openEnd = 0;
        const { selection: selection } = tr;
        const from = positions ? positions[0] : selection.from;
        const to = positions ? positions[1] : selection.to;
        const $from = positions ? tr.doc.resolve(from) : selection.$from;
        const isEmpty = positions ? from === to : selection.empty;
        if (isEmpty) {
            const isAtTheBeginningOfBlock = positions ? (0, $7k00C.startPositionOfParent)($from) === $from.pos : (0, $6Cbfp.selectionIsAtTheBeginningOfBlock)(selection);
            const insertFrom = isAtTheBeginningOfBlock ? $from.before() : from;
            // the use of pmSafeInsert causes the node selection to media single node.
            // It leads to discrepancy between the full-page and comment editor - not sure why :shrug:
            // When multiple images are uploaded, the node selection is set to the previous node
            // and got overridden by the next node inserted.
            // It also causes the images position shifted when the images are uploaded.
            // E.g the images are uploaded after a table, the images will be inserted inside the table.
            // so we revert to use tr.insert instead. No extra paragraph is added.
            updatedTr = updatedTr.insert(insertFrom, nodes);
        } else {
            const slice = new (0, $kW8qW.Slice)((0, $kW8qW.Fragment).from(nodes), 0, openEnd);
            updatedTr = positions ? updatedTr.replaceRange(from, to, slice) : updatedTr.replaceSelection(slice);
        }
        if (inputMethod) editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent($6b5a646c214f033b$var$getInsertMediaAnalytics(inputMethod, fileExtension, insertMediaVia))(updatedTr);
        if (newType && previousType) editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent((0, $cbWfC.getChangeMediaAnalytics)(previousType, newType, (0, $cbWfC.findChangeFromLocation)(tr.selection)))(updatedTr);
        return updatedTr;
    };
}
const $6b5a646c214f033b$export$e5065363a261ea68 = (schema, fileMimeType)=>!!schema.nodes.mediaSingle && (0, $icDBi.isImage)(fileMimeType);
const $6b5a646c214f033b$export$62e6f072fbcbc210 = (view, node, inputMethod, editorAnalyticsAPI, insertMediaVia, allowPixelResizing)=>{
    const { state: state, dispatch: dispatch } = view;
    const { mediaSingle: mediaSingle, media: media } = state.schema.nodes;
    if (!mediaSingle) return false;
    // if not an image type media node
    if (node.type !== media || !(0, $icDBi.isImage)(node.attrs.__fileMimeType) && node.attrs.type !== 'external') return false;
    const mediaSingleMaxWidth = $6b5a646c214f033b$var$getMediaSingleMaxWidthForInsertion(view, state.selection.$from.pos);
    if ((0, $gdUUy.fg)('platform_editor_introduce_insert_media_command')) {
        const updatedTr = $6b5a646c214f033b$export$ad66fa9805ac027a(node.attrs, inputMethod, editorAnalyticsAPI, insertMediaVia, allowPixelResizing, undefined, undefined, mediaSingleMaxWidth)({
            tr: state.tr
        });
        if (updatedTr && dispatch) {
            dispatch === null || dispatch === void 0 || dispatch(updatedTr);
            return true;
        }
        return false;
    }
    const mediaSingleAttrs = allowPixelResizing ? {
        widthType: 'pixel',
        width: (0, $7Pkpg.getMediaSingleInitialWidth)(node.attrs.width ?? (0, $29qUP.DEFAULT_IMAGE_WIDTH), mediaSingleMaxWidth),
        layout: 'center'
    } : {};
    const mediaSingleNode = mediaSingle.create(mediaSingleAttrs, node);
    const nodes = [
        mediaSingleNode
    ];
    const analyticsAttributes = {
        inputMethod: inputMethod,
        fileExtension: node.attrs.__fileMimeType
    };
    return $6b5a646c214f033b$var$insertNodesWithOptionalParagraph({
        nodes: nodes,
        analyticsAttributes: analyticsAttributes,
        editorAnalyticsAPI: editorAnalyticsAPI,
        insertMediaVia: insertMediaVia
    })(state, dispatch);
};
const $6b5a646c214f033b$export$ad66fa9805ac027a = (mediaAttrs, inputMethod, editorAnalyticsAPI, insertMediaVia, allowPixelResizing, positions, dataConsumerSource, mediaSingleMaxWidth)=>{
    return ({ tr: tr })=>{
        const { mediaSingle: mediaSingle, media: media } = tr.doc.type.schema.nodes;
        if (!mediaSingle || !media) return null;
        if (mediaAttrs.type !== 'external' && !(0, $icDBi.isImage)(mediaAttrs.__fileMimeType ?? undefined)) return null;
        const resolvedMediaSingleMaxWidth = $6b5a646c214f033b$var$getPositiveWidth(mediaSingleMaxWidth) ?? $6b5a646c214f033b$var$getPositiveWidth($6b5a646c214f033b$var$getTableCellWidthFromPosition(tr.doc, positions ? positions[0] : tr.selection.from));
        const mediaSingleAttrs = allowPixelResizing ? {
            widthType: 'pixel',
            width: (0, $7Pkpg.getMediaSingleInitialWidth)(mediaAttrs.width ?? (0, $29qUP.DEFAULT_IMAGE_WIDTH), resolvedMediaSingleMaxWidth),
            layout: 'center'
        } : {};
        const dataConsumerMarkType = dataConsumerSource ? tr.doc.type.schema.marks.dataConsumer : undefined;
        const mediaNode = dataConsumerSource && dataConsumerMarkType ? media.create(mediaAttrs, undefined, [
            dataConsumerMarkType.create({
                sources: [
                    dataConsumerSource
                ]
            })
        ]) : media.create(mediaAttrs);
        const mediaSingleNode = mediaSingle.create(mediaSingleAttrs, mediaNode);
        const nodes = [
            mediaSingleNode
        ];
        const analyticsAttributes = {
            inputMethod: inputMethod,
            // External images have no file extension
            fileExtension: mediaAttrs.type !== 'external' && mediaAttrs.__fileMimeType ? mediaAttrs.__fileMimeType ?? undefined : undefined
        };
        return $6b5a646c214f033b$var$insertNodesWithOptionalParagraphCommand({
            nodes: nodes,
            positions: positions,
            analyticsAttributes: analyticsAttributes,
            editorAnalyticsAPI: editorAnalyticsAPI,
            insertMediaVia: insertMediaVia
        })({
            tr: tr
        });
    };
};
const $6b5a646c214f033b$var$getFileExtension = (fileName)=>{
    if (fileName) {
        const extensionIdx = fileName.lastIndexOf('.');
        return extensionIdx >= 0 ? fileName.substring(extensionIdx + 1) : undefined;
    }
    return undefined;
};
const $6b5a646c214f033b$export$653e52366db7c5b6 = (view, mediaState, inputMethod, collection, alignLeftOnInsert, widthPluginState, editorAnalyticsAPI, onNodeInserted, insertMediaVia, allowPixelResizing)=>{
    var _state$selection$$fro;
    if (collection === undefined) return false;
    const { state: state, dispatch: dispatch } = view;
    const grandParentNodeType = (_state$selection$$fro = state.selection.$from.node(-1)) === null || _state$selection$$fro === void 0 ? void 0 : _state$selection$$fro.type;
    const parentNodeType = state.selection.$from.parent.type;
    // add undefined as fallback as we don't want media single width to have upper limit as 0
    // if widthPluginState.width is 0, default 760 will be used
    const contentWidth = $6b5a646c214f033b$var$getMediaSingleMaxWidthForInsertion(view, state.selection.$from.pos, widthPluginState) ?? undefined;
    const node = $6b5a646c214f033b$var$createMediaSingleNode(state.schema, collection, contentWidth, mediaState.status !== 'error' && $6b5a646c214f033b$export$ac5608bbe92d6fdc(mediaState.fileMimeType) ? (0, $29qUP.MEDIA_SINGLE_VIDEO_MIN_PIXEL_WIDTH) : (0, $29qUP.MEDIA_SINGLE_DEFAULT_MIN_PIXEL_WIDTH), alignLeftOnInsert, allowPixelResizing)(mediaState);
    let fileExtension;
    if (mediaState.fileName) {
        const extensionIdx = mediaState.fileName.lastIndexOf('.');
        fileExtension = extensionIdx >= 0 ? mediaState.fileName.substring(extensionIdx + 1) : undefined;
    }
    // should split if media is valid content for the grandparent of the selected node
    // and the parent node is a paragraph
    if ((0, $dw0oh.shouldSplitSelectedNodeOnNodeInsertion)({
        parentNodeType: parentNodeType,
        grandParentNodeType: grandParentNodeType,
        content: node
    })) $6b5a646c214f033b$var$insertNodesWithOptionalParagraph({
        nodes: [
            node
        ],
        analyticsAttributes: {
            fileExtension: fileExtension,
            inputMethod: inputMethod
        },
        editorAnalyticsAPI: editorAnalyticsAPI,
        insertMediaVia: insertMediaVia
    })(state, dispatch);
    else {
        let tr = null;
        tr = (0, $dw0oh.safeInsert)(node, state.selection.from)(state.tr);
        if (!tr) {
            const content = $6b5a646c214f033b$var$shouldAddParagraph(view.state) ? (0, $kW8qW.Fragment).fromArray([
                node,
                state.schema.nodes.paragraph.create()
            ]) : node;
            tr = (0, $gab48.safeInsert)(content, undefined, true)(state.tr);
        }
        if (inputMethod) editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent($6b5a646c214f033b$var$getInsertMediaAnalytics(inputMethod, fileExtension, insertMediaVia))(tr);
        dispatch(tr);
    }
    if (onNodeInserted) onNodeInserted(mediaState.id, view.state.selection.to);
    return true;
};
const $6b5a646c214f033b$export$276040c239babb42 = (view, fromNode, widthPluginState, editorAnalyticsAPI, allowPixelResizing)=>{
    var _state$selection$$fro2;
    const { state: state, dispatch: dispatch } = view;
    const { mediaInline: mediaInline } = state.schema.nodes;
    if (fromNode.type !== mediaInline) return false;
    const grandParentNodeType = (_state$selection$$fro2 = state.selection.$from.node(-1)) === null || _state$selection$$fro2 === void 0 ? void 0 : _state$selection$$fro2.type;
    const parentNodeType = state.selection.$from.parent.type;
    // add undefined as fallback as we don't want media single width to have upper limit as 0
    // if widthPluginState.width is 0, default 760 will be used
    const contentWidth = $6b5a646c214f033b$var$getMediaSingleMaxWidthForInsertion(view, state.selection.$from.pos, widthPluginState) ?? undefined;
    const node = $6b5a646c214f033b$var$replaceWithMediaSingleNode(state.schema, contentWidth, (0, $29qUP.MEDIA_SINGLE_DEFAULT_MIN_PIXEL_WIDTH), allowPixelResizing)(fromNode);
    const fileExtension = $6b5a646c214f033b$var$getFileExtension(fromNode.attrs.__fileName);
    // should split if media is valid content for the grandparent of the selected node
    // and the parent node is a paragraph
    if ((0, $dw0oh.shouldSplitSelectedNodeOnNodeInsertion)({
        parentNodeType: parentNodeType,
        grandParentNodeType: grandParentNodeType,
        content: node
    })) return $6b5a646c214f033b$var$insertNodesWithOptionalParagraph({
        nodes: [
            node
        ],
        analyticsAttributes: {
            fileExtension: fileExtension,
            newType: (0, $g6Qq4.ACTION_SUBJECT_ID).MEDIA_SINGLE,
            previousType: (0, $g6Qq4.ACTION_SUBJECT_ID).MEDIA_INLINE
        },
        editorAnalyticsAPI: editorAnalyticsAPI
    })(state, dispatch);
    else {
        const nodePos = state.tr.doc.resolve(state.selection.from).end();
        let tr = null;
        tr = (0, $gab48.removeSelectedNode)(state.tr);
        tr = (0, $dw0oh.safeInsert)(node, nodePos)(tr);
        if (!tr) {
            const content = $6b5a646c214f033b$var$shouldAddParagraph(view.state) ? (0, $kW8qW.Fragment).fromArray([
                node,
                state.schema.nodes.paragraph.create()
            ]) : node;
            tr = (0, $gab48.safeInsert)(content, undefined, true)(state.tr);
        }
        editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent((0, $cbWfC.getChangeMediaAnalytics)((0, $g6Qq4.ACTION_SUBJECT_ID).MEDIA_INLINE, (0, $g6Qq4.ACTION_SUBJECT_ID).MEDIA_SINGLE, (0, $cbWfC.findChangeFromLocation)(state.selection)))(tr);
        dispatch(tr);
    }
    return true;
};
const $6b5a646c214f033b$var$createMediaSingleNode = (schema, collection, maxWidth, minWidth, alignLeftOnInsert, allowPixelResizing)=>(mediaState)=>{
        const { id: id, dimensions: dimensions, contextId: contextId, scaleFactor: scaleFactor = 1, fileName: fileName } = mediaState;
        const { width: width, height: height } = dimensions || {
            height: undefined,
            width: undefined
        };
        const { media: media, mediaSingle: mediaSingle } = schema.nodes;
        const scaledWidth = width && Math.round(width / scaleFactor);
        const mediaNode = media.create({
            id: id,
            type: 'file',
            collection: collection,
            contextId: contextId,
            width: scaledWidth,
            height: height && Math.round(height / scaleFactor),
            ...fileName && {
                alt: fileName
            }
        });
        const mediaSingleAttrs = alignLeftOnInsert ? {
            layout: 'align-start'
        } : {};
        const extendedMediaSingleAttrs = allowPixelResizing ? {
            ...mediaSingleAttrs,
            width: (0, $7Pkpg.getMediaSingleInitialWidth)(scaledWidth, maxWidth, minWidth),
            // TODO: ED-26962 - change to use enum
            widthType: 'pixel'
        } : mediaSingleAttrs;
        (0, $4sVoN.copyOptionalAttrsFromMediaState)(mediaState, mediaNode);
        return mediaSingle.createChecked(extendedMediaSingleAttrs, mediaNode);
    };
const $6b5a646c214f033b$var$replaceWithMediaSingleNode = (schema, maxWidth, minWidth, allowPixelResizing)=>(mediaNode)=>{
        const { width: width } = mediaNode.attrs;
        const { media: media, mediaSingle: mediaSingle } = schema.nodes;
        const copiedMediaNode = media.create({
            ...mediaNode.attrs,
            type: 'file'
        }, mediaNode.content, mediaNode.marks);
        const extendedMediaSingleAttrs = allowPixelResizing ? {
            width: (0, $7Pkpg.getMediaSingleInitialWidth)(width, maxWidth, minWidth),
            widthType: 'pixel'
        } : {};
        return mediaSingle.createChecked(extendedMediaSingleAttrs, copiedMediaNode);
    };
const $6b5a646c214f033b$export$ac5608bbe92d6fdc = (0, $57l7A.default)((fileType)=>{
    return !!fileType && fileType.includes('video');
});

});
parcelRegister("cbWfC", function(module, exports) {
$parcel$export(module.exports, "getMediaResizeAnalyticsEvent", () => $00221bdd89372f63$export$d3bec2d7dfd57a94);
$parcel$export(module.exports, "getMediaInputResizeAnalyticsEvent", () => $00221bdd89372f63$export$e861d73ef59c0864);
$parcel$export(module.exports, "getChangeMediaAnalytics", () => $00221bdd89372f63$export$3a6429e633acb640);
$parcel$export(module.exports, "findChangeFromLocation", () => $00221bdd89372f63$export$cc94f10add475df5);

var $g6Qq4 = parcelRequire("g6Qq4");

var $gab48 = parcelRequire("gab48");
const $00221bdd89372f63$export$d3bec2d7dfd57a94 = (type, attributes)=>{
    if (!attributes) return;
    const { width: width, widthType: widthType, layout: layout, snapType: snapType, parentNode: parentNode, inputMethod: inputMethod } = attributes;
    const actionSubject = type === 'embed' ? (0, $g6Qq4.ACTION_SUBJECT).EMBEDS : (0, $g6Qq4.ACTION_SUBJECT).MEDIA_SINGLE;
    return {
        action: (0, $g6Qq4.ACTION).EDITED,
        actionSubject: actionSubject,
        actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).RESIZED,
        attributes: {
            width: width,
            layout: layout,
            widthType: widthType,
            snapType: snapType,
            parentNode: parentNode,
            inputMethod: inputMethod
        },
        eventType: (0, $g6Qq4.EVENT_TYPE).UI
    };
};
const $00221bdd89372f63$export$e861d73ef59c0864 = (type, attributes)=>{
    if (!attributes) return;
    const { width: width, layout: layout, validation: validation, parentNode: parentNode, inputMethod: inputMethod } = attributes;
    const actionSubject = type === 'embed' ? (0, $g6Qq4.ACTION_SUBJECT).EMBEDS : (0, $g6Qq4.ACTION_SUBJECT).MEDIA_SINGLE;
    return {
        action: (0, $g6Qq4.ACTION).EDITED,
        actionSubject: actionSubject,
        actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).RESIZED,
        attributes: {
            width: width,
            layout: layout,
            validation: validation,
            parentNode: parentNode,
            inputMethod: inputMethod
        },
        eventType: (0, $g6Qq4.EVENT_TYPE).UI
    };
};
const $00221bdd89372f63$export$3a6429e633acb640 = (previousType, newType, changeFromLocation)=>({
        action: (0, $g6Qq4.ACTION).CHANGED_TYPE,
        actionSubject: (0, $g6Qq4.ACTION_SUBJECT).MEDIA,
        eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
        attributes: {
            newType: newType,
            previousType: previousType,
            changeFromLocation: changeFromLocation
        }
    });
function $00221bdd89372f63$export$cc94f10add475df5(selection) {
    const { schema: schema, name: name } = selection.$from.doc.type;
    const parentNodeInfo = (0, $gab48.findParentNode)((node)=>node.type !== schema.nodes.paragraph)(selection);
    return parentNodeInfo ? parentNodeInfo.node.type.name : name;
}

});

parcelRegister("icDBi", function(module, exports) {
$parcel$export(module.exports, "isImage", () => $5bed09f8fadfdbc6$export$fb85bc5d6d9ef19b);
$parcel$export(module.exports, "isVideo", () => $5bed09f8fadfdbc6$export$ac5608bbe92d6fdc);
const $5bed09f8fadfdbc6$export$fb85bc5d6d9ef19b = (type)=>{
    return !!type && (type.indexOf('image/') > -1 || type.indexOf('video/') > -1 || type === 'image');
};
const $5bed09f8fadfdbc6$export$ac5608bbe92d6fdc = (fileType)=>{
    return !!fileType && fileType.includes('video/');
};

});


parcelRegister("jAHUG", function(module, exports) {
$parcel$export(module.exports, "getNodeType", () => $c4653107c8c3f157$export$d168cba70360dd3d);
$parcel$export(module.exports, "changeInlineToMediaCard", () => $c4653107c8c3f157$export$8cf8c3c101907002);
$parcel$export(module.exports, "changeMediaCardToInline", () => $c4653107c8c3f157$export$f1c1c33109f7b728);
$parcel$export(module.exports, "changeMediaInlineToMediaSingle", () => $c4653107c8c3f157$export$697a66ccfb9355d9);
$parcel$export(module.exports, "removeInlineCardWithAnalytics", () => $c4653107c8c3f157$export$736937947f2887f2);
$parcel$export(module.exports, "toggleBorderMark", () => $c4653107c8c3f157$export$422bbbda8886cfb6);
$parcel$export(module.exports, "setBorderMark", () => $c4653107c8c3f157$export$40f3bc13e4908fe6);
$parcel$export(module.exports, "updateMediaSingleWidthTr", () => $c4653107c8c3f157$export$2cb0367d661a3966);
$parcel$export(module.exports, "updateMediaSingleWidth", () => $c4653107c8c3f157$export$c71ac81378eeb0c2);
$parcel$export(module.exports, "changeMediaSingleToMediaInline", () => $c4653107c8c3f157$export$f68bb2b466cc4cc6);

var $g6Qq4 = parcelRequire("g6Qq4");

var $hpVfr = parcelRequire("hpVfr");

var $5NaaJ = parcelRequire("5NaaJ");

var $kW8qW = parcelRequire("kW8qW");

var $cw0wu = parcelRequire("cw0wu");

var $gab48 = parcelRequire("gab48");

var $cbWfC = parcelRequire("cbWfC");

var $i1rYO = parcelRequire("i1rYO");

var $4sVoN = parcelRequire("4sVoN");

var $jmBd6 = parcelRequire("jmBd6");

var $7omWA = parcelRequire("7omWA");
const $c4653107c8c3f157$export$f54f5cacf382b9f2 = '#091e4224';
const $c4653107c8c3f157$export$5346947b21be4717 = 2;
const $c4653107c8c3f157$export$d168cba70360dd3d = (state)=>{
    const { mediaSingle: mediaSingle, mediaInline: mediaInline } = state.schema.nodes;
    return (0, $4sVoN.isSelectionMediaSingleNode)(state) ? mediaSingle.name : mediaInline.name;
};
const $c4653107c8c3f157$export$8cf8c3c101907002 = (editorAnalyticsAPI, forceFocusSelector)=>(state, dispatch)=>{
        var _findParentNodeCloses, _parent$content$first, _parent$content$lastC, _parent$content$lastC2;
        const { media: media, mediaInline: mediaInline, mediaGroup: mediaGroup, paragraph: paragraph, heading: heading } = state.schema.nodes;
        const selectedNode = state.selection instanceof (0, $cw0wu.NodeSelection) && state.selection.node.type === mediaInline && state.selection.node;
        if (!selectedNode) return false;
        const { id: id, type: type, collection: collection } = selectedNode.attrs;
        const mediaNode = media.createChecked({
            id: id,
            type: type,
            collection: collection
        });
        const group = mediaGroup.createChecked({}, mediaNode);
        const parent = (_findParentNodeCloses = (0, $gab48.findParentNodeClosestToPos)(state.selection.$from, (node)=>{
            return node.type === paragraph || node.type === heading;
        })) === null || _findParentNodeCloses === void 0 ? void 0 : _findParentNodeCloses.node;
        let tr = state.tr;
        let insertPos;
        if (!!parent && parent.content.size === 2 && ((_parent$content$first = parent.content.firstChild) === null || _parent$content$first === void 0 ? void 0 : _parent$content$first.type.name) === 'mediaInline' && ((_parent$content$lastC = parent.content.lastChild) === null || _parent$content$lastC === void 0 ? void 0 : _parent$content$lastC.type.name) === 'text' && ((_parent$content$lastC2 = parent.content.lastChild) === null || _parent$content$lastC2 === void 0 || (_parent$content$lastC2 = _parent$content$lastC2.text) === null || _parent$content$lastC2 === void 0 ? void 0 : _parent$content$lastC2.trim()) === '') {
            /// Empty paragraph or empty heading
            /// Drop the corresponding card on the current line
            insertPos = state.tr.doc.resolve(state.selection.from).start() - 1;
            if (insertPos < 0) return false;
            tr = tr.delete(insertPos, insertPos + parent.nodeSize);
            tr = (0, $gab48.safeInsert)(group, insertPos, false)(tr);
        } else {
            /// Non-empty paragraph, non-empty heading, or other nodes (e.g., action, list)
            /// Drop the corresponding card underneath the current line
            insertPos = state.tr.doc.resolve(state.selection.from).end();
            tr = (0, $gab48.removeSelectedNode)(tr);
            tr = (0, $gab48.safeInsert)(group, insertPos, false)(tr);
        }
        if (dispatch) {
            editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent({
                action: (0, $g6Qq4.ACTION).CHANGED_TYPE,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).MEDIA,
                eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
                attributes: {
                    newType: (0, $g6Qq4.ACTION_SUBJECT_ID).MEDIA_GROUP,
                    previousType: (0, $g6Qq4.ACTION_SUBJECT_ID).MEDIA_INLINE
                }
            })(tr);
            const $endOfNode = tr.doc.resolve(insertPos + 1);
            const newSelection = new (0, $cw0wu.NodeSelection)($endOfNode);
            tr.setSelection(newSelection);
            forceFocusSelector === null || forceFocusSelector === void 0 || forceFocusSelector(`.thumbnail-appearance`)(tr);
            dispatch(tr);
        }
        return true;
    };
const $c4653107c8c3f157$export$f1c1c33109f7b728 = (editorAnalyticsAPI, forceFocusSelector)=>(state, dispatch)=>{
        const { media: media, mediaInline: mediaInline, paragraph: paragraph } = state.schema.nodes;
        const selectedNode = state.selection instanceof (0, $cw0wu.NodeSelection) && state.selection.node;
        // @ts-ignore - [unblock prosemirror bump] redundant check comparing boolean to media
        if (!selectedNode || !selectedNode.type === media) return false;
        const mediaInlineNode = mediaInline.create({
            id: selectedNode.attrs.id,
            collection: selectedNode.attrs.collection
        });
        const space = state.schema.text(' ');
        const content = (0, $kW8qW.Fragment).from([
            mediaInlineNode,
            space
        ]);
        const node = paragraph.createChecked({}, content);
        const nodePos = state.tr.doc.resolve(state.selection.from).start();
        let tr = (0, $7omWA.removeMediaGroupNode)(state);
        // Minus 1 to insert the node before the media group
        tr = (0, $gab48.safeInsert)(node, nodePos - 1, false)(tr);
        if (dispatch) {
            editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent({
                action: (0, $g6Qq4.ACTION).CHANGED_TYPE,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).MEDIA,
                eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
                attributes: {
                    newType: (0, $g6Qq4.ACTION_SUBJECT_ID).MEDIA_INLINE,
                    previousType: (0, $g6Qq4.ACTION_SUBJECT_ID).MEDIA_GROUP
                }
            })(tr);
            const newSelection = (0, $cw0wu.NodeSelection).create(tr.doc, nodePos);
            tr.setSelection(newSelection);
            forceFocusSelector === null || forceFocusSelector === void 0 || forceFocusSelector(`.inline-appearance`)(tr);
            dispatch(tr);
        }
        return true;
    };
const $c4653107c8c3f157$export$697a66ccfb9355d9 = (editorAnalyticsAPI, widthPluginState, allowPixelResizing)=>(state, dispatch, view)=>{
        const { mediaInline: mediaInline } = state.schema.nodes;
        const selectedNode = state.selection instanceof (0, $cw0wu.NodeSelection) && state.selection.node.type === mediaInline && state.selection.node;
        if (!selectedNode) return false;
        if (view) return (0, $jmBd6.changeFromMediaInlineToMediaSingleNode)(view, selectedNode, widthPluginState, editorAnalyticsAPI, allowPixelResizing);
        return true;
    };
const $c4653107c8c3f157$export$736937947f2887f2 = (editorAnalyticsAPI)=>{
    return (0, $5NaaJ.withAnalytics)(editorAnalyticsAPI, {
        action: (0, $g6Qq4.ACTION).DELETED,
        actionSubject: (0, $g6Qq4.ACTION_SUBJECT).MEDIA_INLINE,
        attributes: {
            inputMethod: (0, $g6Qq4.INPUT_METHOD).FLOATING_TB
        },
        eventType: (0, $g6Qq4.EVENT_TYPE).TRACK
    })($c4653107c8c3f157$export$c8abec9f794b33a4);
};
const $c4653107c8c3f157$export$c8abec9f794b33a4 = (state, dispatch)=>{
    if ((0, $gab48.isNodeSelection)(state.selection)) {
        if (dispatch) dispatch((0, $gab48.removeSelectedNode)(state.tr));
        return true;
    }
    return false;
};
const $c4653107c8c3f157$export$422bbbda8886cfb6 = (editorAnalyticsAPI)=>(state, dispatch)=>{
        const nodeWithPos = (0, $hpVfr.currentMediaNodeWithPos)(state) || (0, $i1rYO.currentMediaInlineNodeWithPos)(state);
        if (!nodeWithPos) return false;
        const { node: node, pos: pos } = nodeWithPos;
        const borderMark = node.marks.find((m)=>m.type.name === 'border');
        const marks = node.marks.filter((m)=>m.type.name !== 'border').concat(borderMark ? [] : state.schema.marks.border.create({
            color: $c4653107c8c3f157$export$f54f5cacf382b9f2,
            size: $c4653107c8c3f157$export$5346947b21be4717
        }));
        const tr = state.tr.setNodeMarkup(pos, node.type, node.attrs, marks);
        tr.setMeta('scrollIntoView', false);
        if (state.selection instanceof (0, $cw0wu.NodeSelection)) {
            if (state.selection.$anchor.pos === state.selection.from) tr.setSelection((0, $cw0wu.NodeSelection).create(tr.doc, state.selection.from));
        }
        if (dispatch) {
            const type = $c4653107c8c3f157$export$d168cba70360dd3d(state);
            if (borderMark !== null && borderMark !== void 0 && borderMark.attrs) editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent({
                action: (0, $g6Qq4.ACTION).DELETED,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).MEDIA,
                actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).BORDER,
                eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
                attributes: {
                    type: type,
                    previousColor: borderMark.attrs.color,
                    previousSize: borderMark.attrs.size,
                    mediaType: node.attrs.type
                }
            })(tr);
            else editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent({
                action: (0, $g6Qq4.ACTION).ADDED,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).MEDIA,
                actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).BORDER,
                eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
                attributes: {
                    type: type,
                    color: $c4653107c8c3f157$export$f54f5cacf382b9f2,
                    size: $c4653107c8c3f157$export$5346947b21be4717,
                    mediaType: node.attrs.type
                }
            })(tr);
            dispatch(tr);
        }
        return true;
    };
const $c4653107c8c3f157$export$40f3bc13e4908fe6 = (editorAnalyticsAPI)=>(attrs)=>(state, dispatch)=>{
            var _node$marks$find;
            const nodeWithPos = (0, $hpVfr.currentMediaNodeWithPos)(state) || (0, $i1rYO.currentMediaInlineNodeWithPos)(state);
            if (!nodeWithPos) return false;
            const { node: node, pos: pos } = nodeWithPos;
            const borderMark = (_node$marks$find = node.marks.find((m)=>m.type.name === 'border')) === null || _node$marks$find === void 0 ? void 0 : _node$marks$find.attrs;
            const color = attrs.color ?? (borderMark === null || borderMark === void 0 ? void 0 : borderMark.color) ?? $c4653107c8c3f157$export$f54f5cacf382b9f2;
            const size = attrs.size ?? (borderMark === null || borderMark === void 0 ? void 0 : borderMark.size) ?? $c4653107c8c3f157$export$5346947b21be4717;
            const marks = node.marks.filter((m)=>m.type.name !== 'border').concat(state.schema.marks.border.create({
                color: color,
                size: size
            }));
            const tr = state.tr.setNodeMarkup(pos, node.type, node.attrs, marks);
            tr.setMeta('scrollIntoView', false);
            if (state.selection instanceof (0, $cw0wu.NodeSelection)) {
                if (state.selection.$anchor.pos === state.selection.from) tr.setSelection((0, $cw0wu.NodeSelection).create(tr.doc, state.selection.from));
            }
            if (dispatch) {
                editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent({
                    action: (0, $g6Qq4.ACTION).UPDATED,
                    actionSubject: (0, $g6Qq4.ACTION_SUBJECT).MEDIA,
                    actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).BORDER,
                    eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
                    attributes: {
                        type: $c4653107c8c3f157$export$d168cba70360dd3d(state),
                        mediaType: node.attrs.type,
                        previousColor: borderMark === null || borderMark === void 0 ? void 0 : borderMark.color,
                        previousSize: borderMark === null || borderMark === void 0 ? void 0 : borderMark.size,
                        newColor: color,
                        newSize: size
                    }
                })(tr);
                dispatch(tr);
            }
            return true;
        };
const $c4653107c8c3f157$export$2cb0367d661a3966 = (editorAnalyticsAPI, state, width, validation, inputMethod, layout)=>{
    const selectedMediaSingleNode = (0, $7omWA.getSelectedMediaSingle)(state);
    if (!selectedMediaSingleNode) return null;
    const tr = state.tr.setNodeMarkup(selectedMediaSingleNode.pos, undefined, {
        ...selectedMediaSingleNode.node.attrs,
        width: width,
        widthType: 'pixel',
        layout: layout
    });
    tr.setMeta('scrollIntoView', false);
    tr.setSelection((0, $cw0wu.NodeSelection).create(tr.doc, selectedMediaSingleNode.pos));
    const $pos = state.doc.resolve(selectedMediaSingleNode.pos);
    const parentNodeType = $pos ? $pos.parent.type.name : undefined;
    const payload = (0, $cbWfC.getMediaInputResizeAnalyticsEvent)('mediaSingle', {
        width: width,
        layout: layout,
        validation: validation,
        inputMethod: inputMethod,
        parentNode: parentNodeType
    });
    if (payload) editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent(payload)(tr);
    return tr;
};
const $c4653107c8c3f157$export$c71ac81378eeb0c2 = (editorAnalyticsAPI)=>(width, validation, inputMethod, layout)=>(state, dispatch)=>{
            const tr = $c4653107c8c3f157$export$2cb0367d661a3966(editorAnalyticsAPI, state, width, validation, inputMethod, layout);
            if (!tr) return false;
            if (dispatch) dispatch(tr);
            return true;
        };
const $c4653107c8c3f157$export$f68bb2b466cc4cc6 = (editorAnalyticsAPI)=>(state, dispatch)=>{
        const selectedNodeWithPos = (0, $7omWA.getSelectedMediaSingle)(state);
        const { mediaInline: mediaInline, paragraph: paragraph } = state.schema.nodes;
        if (!selectedNodeWithPos) return false;
        const mediaSingleNode = selectedNodeWithPos.node;
        const mediaNode = mediaSingleNode.firstChild;
        if (!mediaNode) return false;
        const mediaInlineNode = mediaInline.create({
            ...mediaNode.attrs,
            type: 'image'
        }, null, mediaNode.marks);
        const space = state.schema.text(' ');
        const content = (0, $kW8qW.Fragment).from([
            mediaInlineNode,
            space
        ]);
        const node = paragraph.createChecked({}, content);
        const { from: from } = state.selection;
        let tr = state.tr;
        tr = (0, $gab48.removeSelectedNode)(tr);
        tr = (0, $gab48.safeInsert)(node, from, false)(tr);
        // 3 accounts for  paragraph 1 + mediaInline size 1 + space 1
        tr.setSelection((0, $cw0wu.TextSelection).create(tr.doc, from + 3));
        if (dispatch) {
            editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent((0, $cbWfC.getChangeMediaAnalytics)((0, $g6Qq4.ACTION_SUBJECT_ID).MEDIA_SINGLE, (0, $g6Qq4.ACTION_SUBJECT_ID).MEDIA_INLINE, (0, $cbWfC.findChangeFromLocation)(state.selection)))(tr);
            dispatch(tr);
        }
        return true;
    };

});
parcelRegister("i1rYO", function(module, exports) {
$parcel$export(module.exports, "currentMediaInlineNodeWithPos", () => $930b61a4c8b40548$export$de57f5901ccaf81a);
$parcel$export(module.exports, "currentMediaNode", () => $930b61a4c8b40548$export$61c1b21ac50e0a02);
$parcel$export(module.exports, "currentMediaInlineNode", () => $930b61a4c8b40548$export$948c2f536cfeec35);
$parcel$export(module.exports, "currentMediaOrInlineNodeBorderMark", () => $930b61a4c8b40548$export$ab2a65138449fdc1);

var $hpVfr = parcelRequire("hpVfr");

var $cw0wu = parcelRequire("cw0wu");
const $930b61a4c8b40548$export$de57f5901ccaf81a = (editorState)=>{
    const { doc: doc, selection: selection, schema: schema } = editorState;
    if (!doc || !selection || !(selection instanceof (0, $cw0wu.NodeSelection)) || selection.node.type !== schema.nodes.mediaInline) return;
    const pos = selection.$anchor.pos;
    const node = doc.nodeAt(pos);
    if (!node || node.type !== schema.nodes.mediaInline) return;
    return {
        node: node,
        pos: pos
    };
};
const $930b61a4c8b40548$export$61c1b21ac50e0a02 = (editorState)=>{
    var _currentMediaNodeWith;
    return (_currentMediaNodeWith = (0, $hpVfr.currentMediaNodeWithPos)(editorState)) === null || _currentMediaNodeWith === void 0 ? void 0 : _currentMediaNodeWith.node;
};
const $930b61a4c8b40548$export$948c2f536cfeec35 = (editorState)=>{
    var _currentMediaInlineNo;
    return (_currentMediaInlineNo = $930b61a4c8b40548$export$de57f5901ccaf81a(editorState)) === null || _currentMediaInlineNo === void 0 ? void 0 : _currentMediaInlineNo.node;
};
const $930b61a4c8b40548$export$ab2a65138449fdc1 = (editorState)=>{
    const node = $930b61a4c8b40548$export$61c1b21ac50e0a02(editorState) || $930b61a4c8b40548$export$948c2f536cfeec35(editorState);
    if (!node) return;
    const borderMark = node.marks.find((m)=>m.type.name === 'border');
    if (!borderMark) return;
    return borderMark.attrs;
};

});



parcelRegister("2jJHo", function(module, exports) {
$parcel$export(module.exports, "MEDIA_CONTENT_WRAP_CLASS_NAME", () => $3a36aed222e51a6a$export$fcef64fdeaf6f18a);
$parcel$export(module.exports, "MEDIA_PLUGIN_IS_RESIZING_KEY", () => $3a36aed222e51a6a$export$2955196e6685aaf4);
$parcel$export(module.exports, "MEDIA_PLUGIN_RESIZING_WIDTH_KEY", () => $3a36aed222e51a6a$export$ea728aeacba173d1);
$parcel$export(module.exports, "getMediaPluginState", () => $3a36aed222e51a6a$export$c2bb38320d6be1f2);
$parcel$export(module.exports, "createPlugin", () => $3a36aed222e51a6a$export$ae829ec7b2625219);

var $kqszs = parcelRequire("kqszs");

var $bSJIT = parcelRequire("bSJIT");

var $fK3tS = parcelRequire("fK3tS");

var $7RHfd = parcelRequire("7RHfd");

var $4eNaz = parcelRequire("4eNaz");

var $g6Qq4 = parcelRequire("g6Qq4");

var $jxkn6 = parcelRequire("jxkn6");

var $ehhh6 = parcelRequire("ehhh6");

var $jEFfF = parcelRequire("jEFfF");

var $29qUP = parcelRequire("29qUP");

var $33OA0 = parcelRequire("33OA0");

var $f7Kk4 = parcelRequire("f7Kk4");

var $cw0wu = parcelRequire("cw0wu");

var $3DNV7 = parcelRequire("3DNV7");

var $gab48 = parcelRequire("gab48");

var $a3b9P = parcelRequire("a3b9P");

var $2E7OD = parcelRequire("2E7OD");

var $4PL54 = parcelRequire("4PL54");

var $97BF5 = parcelRequire("97BF5");

var $3y2s4 = parcelRequire("3y2s4");

var $eUcZO = parcelRequire("eUcZO");

var $lyZqb = parcelRequire("lyZqb");

var $4sVoN = parcelRequire("4sVoN");

var $fLyBt = parcelRequire("fLyBt");

var $kWqd8 = parcelRequire("kWqd8");

var $jmBd6 = parcelRequire("jmBd6");

var $7dHnk = parcelRequire("7dHnk");

var $7bQCz = parcelRequire("7bQCz");

var $aLFwY = parcelRequire("aLFwY");

var $7xuRi = parcelRequire("7xuRi");

var $8w5gF = parcelRequire("8w5gF");

var $1cWyg = parcelRequire("1cWyg");

var $fxLWg = parcelRequire("fxLWg");

var $7ICJC = parcelRequire("7ICJC");
const $3a36aed222e51a6a$export$fcef64fdeaf6f18a = 'media-content-wrap';
const $3a36aed222e51a6a$export$2955196e6685aaf4 = 'mediaSinglePlugin.isResizing';
const $3a36aed222e51a6a$export$ea728aeacba173d1 = 'mediaSinglePlugin.resizing-width';
const $3a36aed222e51a6a$var$createDropPlaceholder = (intl, nodeViewPortalProviderAPI, dropPlaceholderKey, allowDropLine, inline)=>{
    const usePointerIndicator = (0, $7xuRi.isMediaDropPositionEnabled)();
    // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
    const dropPlaceholder = document.createElement(usePointerIndicator ? 'span' : 'div');
    const createElement = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement;
    if (usePointerIndicator) {
        dropPlaceholder.dataset.mediaDropPlaceholder = 'true';
        dropPlaceholder.style.display = 'contents';
        nodeViewPortalProviderAPI.render(()=>createElement((0, $7bQCz.MediaDropIndicator), {
                inline: inline ?? false
            }), dropPlaceholder, dropPlaceholderKey);
        return dropPlaceholder;
    }
    if (allowDropLine) nodeViewPortalProviderAPI.render(()=>createElement((0, $fK3tS.Provider), {
            value: intl
        }, createElement((0, $7dHnk.default), {
            type: 'single'
        })), dropPlaceholder, dropPlaceholderKey);
    else nodeViewPortalProviderAPI.render(()=>createElement((0, $fK3tS.Provider), {
            value: intl
        }, createElement((0, $7dHnk.default))), dropPlaceholder, dropPlaceholderKey);
    return dropPlaceholder;
};
const $3a36aed222e51a6a$var$MEDIA_RESOLVED_STATES = [
    'ready',
    'error',
    'cancelled'
];
class $3a36aed222e51a6a$export$a013ab53254c388d {
    /**
   * Pending and hovered drop targets, allocated on first use and only for the test cohort, so
   * the control cohort runs none of this code and retains none of its state.
   */ get dropTargets() {
        if (!(0, $7xuRi.isMediaDropPositionEnabled)()) return undefined;
        this.mediaDropTargets ?? (this.mediaDropTargets = new (0, $8w5gF.MediaDropTargets)());
        return this.mediaDropTargets;
    }
    constructor(state, options, mediaOptions, dispatch, pluginInjectionApi){
        this.allowsUploads = false;
        this.uploadStatus = 'pending';
        this.ignoreLinks = false;
        this.waitForMediaUpload = true;
        this.allUploadsFinished = true;
        this.showDropzone = false;
        this.isFullscreen = false;
        this.layout = 'center';
        this.mediaNodes = [];
        this.isResizing = false;
        this.resizingWidth = 0;
        this.allowInlineImages = false;
        this.uploadInProgressSubscriptions = [];
        this.uploadInProgressSubscriptionsNotified = false;
        // this is only a temporary variable, which gets cleared after the last inserted node has been selected
        this.lastAddedMediaSingleFileIds = [];
        this.destroyed = false;
        this.removeOnCloseListener = ()=>{};
        this.onPopupToggleCallback = ()=>{};
        // When non-null, holds the file ID of the media node being replaced. Used both as a
        // flag (non-null = replace mode) and as a cross-check to ensure the correct node is
        // updated if the selection moves between the picker opening and the file being picked.
        this.replaceMediaFileId = null;
        // The display height (in pixels) of the mediaSingle being replaced, computed at replace time
        // from its display width and the old media node's intrinsic aspect ratio.
        // Used by the nodeview to recompute display width from the new file's aspect ratio after
        // dimensions are fetched, preserving visual height rather than visual width.
        this.replaceMediaTargetDisplayHeight = null;
        this.identifierCount = new Map();
        // This is to enable mediaShallowCopySope to enable only shallow copying media referenced within the edtior
        // see: trackOutOfScopeIdentifier
        this.outOfEditorScopeIdentifierMap = new Map();
        this.taskManager = new (0, $1cWyg.MediaTaskManager)();
        this.pickers = [];
        this.pickerPromises = [];
        this.getMediaOptions = ()=>this.options;
        this.isMediaSchemaNode = ({ type: type })=>{
            var _this$mediaOptions3;
            const { mediaInline: mediaInline, mediaSingle: mediaSingle, media: media } = this.view.state.schema.nodes;
            if ((0, $97BF5.getMediaFeatureFlag)('mediaInline', (_this$mediaOptions3 = this.mediaOptions) === null || _this$mediaOptions3 === void 0 ? void 0 : _this$mediaOptions3.featureFlags)) return type === mediaSingle || type === media || type === mediaInline;
            return type === mediaSingle;
        };
        // callback to flag that a node has been inserted
        this.onNodeInserted = (id, selectionPosition)=>{
            this.lastAddedMediaSingleFileIds.unshift({
                id: id,
                selectionPosition: selectionPosition
            });
        };
        /**
   * we insert a new file by inserting a initial state for that file.
   *
   * called when we insert a new file via the picker (connected via pickerfacade)
   */ this.insertFile = (mediaState, onMediaStateChanged, pickerType, insertMediaVia)=>{
            var _mediaState$fileMimeT, _this$pluginInjection2, _this$pluginInjection4, _this$dropTargets3;
            const dropTargets = this.dropTargets;
            if (dropTargets && this.destroyed) return;
            const dropPos = dropTargets === null || dropTargets === void 0 ? void 0 : dropTargets.positionFor(mediaState.id);
            const replacement = dropPos !== undefined && (_mediaState$fileMimeT = mediaState.fileMimeType) !== null && _mediaState$fileMimeT !== void 0 && _mediaState$fileMimeT.startsWith('image/') ? dropTargets === null || dropTargets === void 0 ? void 0 : dropTargets.replacementFor(mediaState.id, this.view.state.doc) : undefined;
            if (dropPos !== undefined) {
                this.replaceMediaFileId = null;
                this.replaceMediaTargetDisplayHeight = null;
                const selection = replacement ? (0, $cw0wu.NodeSelection).create(this.view.state.doc, replacement.pos) : (0, $8w5gF.mediaDropSelection)(this.view.state.doc, dropPos);
                this.view.dispatch(this.view.state.tr.setSelection(selection));
            }
            const { state: state } = this.view;
            const editorAnalyticsAPI = (_this$pluginInjection2 = this.pluginInjectionApi) === null || _this$pluginInjection2 === void 0 || (_this$pluginInjection2 = _this$pluginInjection2.analytics) === null || _this$pluginInjection2 === void 0 ? void 0 : _this$pluginInjection2.actions;
            const mediaStateWithContext = {
                ...mediaState,
                contextId: this.contextIdentifierProvider ? this.contextIdentifierProvider.objectId : undefined
            };
            const collection = mediaState.collection ?? this.collectionFromProvider();
            if (collection === undefined) {
                var _this$dropTargets;
                (_this$dropTargets = this.dropTargets) === null || _this$dropTargets === void 0 || _this$dropTargets.inserted(mediaState.id);
                return;
            }
            // If replace mode was set but the selection has moved away from a mediaSingle
            // (e.g. the user cancelled the replace picker and then inserted media elsewhere),
            // clear replace state so this insertion proceeds as a normal insert.
            if (this.replaceMediaFileId !== null) {
                var _state$selection$node;
                const { mediaSingle: mediaSingle } = state.schema.nodes;
                const isStillOnTargetMedia = state.selection instanceof (0, $cw0wu.NodeSelection) && state.selection.node.type === mediaSingle && ((_state$selection$node = state.selection.node.firstChild) === null || _state$selection$node === void 0 ? void 0 : _state$selection$node.attrs.id) === this.replaceMediaFileId;
                if (!isStillOnTargetMedia) {
                    this.replaceMediaFileId = null;
                    this.replaceMediaTargetDisplayHeight = null;
                }
            }
            // We need to dispatch the change to event dispatcher only for successful files
            if (mediaState.status !== 'error') this.updateAndDispatch({
                allUploadsFinished: false
            });
            if (this.uploadInProgressSubscriptions.length > 0 && !this.uploadInProgressSubscriptionsNotified) {
                this.uploadInProgressSubscriptions.forEach((fn)=>fn(true));
                this.uploadInProgressSubscriptionsNotified = true;
            }
            // Replace mode: if a media node is being replaced, update its attrs in-place
            // rather than inserting a new node. This preserves layout, width, and caption.
            if (this.replaceMediaFileId !== null || replacement !== undefined) {
                // Clear replace mode immediately so subsequent insertions behave normally
                this.replaceMediaFileId = null;
                const { state: currentState } = this.view;
                const mediaSinglePos = currentState.selection.from;
                const mediaPos = mediaSinglePos + 1;
                const mediaNode = currentState.doc.nodeAt(mediaPos);
                if (!mediaNode || mediaNode.type.name !== 'media') return;
                // Build a single transaction that:
                // 1. Updates the media child node attrs (new file identity + cleared dimensions)
                // 2. Re-creates the NodeSelection so the toolbar picks up the fresh node
                const tr = currentState.tr;
                tr.step(new (0, $4eNaz.SetAttrsStep)(mediaPos, {
                    id: mediaState.id,
                    collection: collection,
                    type: 'file',
                    __fileMimeType: mediaState.fileMimeType ?? null,
                    __fileName: mediaState.fileName ?? null,
                    __fileSize: mediaState.fileSize ?? null,
                    __mediaTraceId: null,
                    // Clear intrinsic dimensions — they'll be fetched once the file
                    // is processed and applied via updateDimensions in a single tx
                    // with the height-preserving mediaSingle width adjustment.
                    width: null,
                    height: null
                }));
                // Re-create the selection so the floating toolbar picks up
                // the updated node and renders the full set of controls.
                tr.setSelection((0, $cw0wu.NodeSelection).create(tr.doc, mediaSinglePos));
                tr.setMeta('scrollIntoView', false);
                this.view.dispatch(tr);
                // Still register the state-change listener so upload completion is tracked
                onMediaStateChanged(this.handleMediaState);
                const isEndState = (state)=>state.status && $3a36aed222e51a6a$var$MEDIA_RESOLVED_STATES.includes(state.status);
                // After the file finishes uploading/processing, trigger a dimension fetch.
                // getRemoteDimensions may fail if called too early (isImageRepresentationReady
                // returns false while processing), so we wait for the ready state first.
                const triggerDimensionFetch = ()=>{
                    // Find the media node in the doc by id and create a temporary
                    // MediaNodeUpdater to fetch and apply dimensions
                    const { state: editorState } = this.view;
                    const { mediaSingle: mediaSingleType } = editorState.schema.nodes;
                    let mediaChildNode = null;
                    editorState.doc.descendants((node)=>{
                        if (mediaChildNode) return false;
                        if (node.type === mediaSingleType) {
                            const child = node.firstChild;
                            if (child && child.attrs.id === mediaState.id) mediaChildNode = child;
                        }
                        return true;
                    });
                    if (mediaChildNode) {
                        var _this$pluginInjection3;
                        const updater = (0, $eUcZO.createMediaNodeUpdater)({
                            view: this.view,
                            mediaProvider: this.mediaProvider ? Promise.resolve(this.mediaProvider) : undefined,
                            contextIdentifierProvider: this.contextIdentifierProvider ? Promise.resolve(this.contextIdentifierProvider) : undefined,
                            node: mediaChildNode,
                            isMediaSingle: true,
                            lineLength: (_this$pluginInjection3 = this.pluginInjectionApi) === null || _this$pluginInjection3 === void 0 || (_this$pluginInjection3 = _this$pluginInjection3.width) === null || _this$pluginInjection3 === void 0 || (_this$pluginInjection3 = _this$pluginInjection3.sharedState.currentState()) === null || _this$pluginInjection3 === void 0 ? void 0 : _this$pluginInjection3.lineLength
                        });
                        updater.getRemoteDimensions().then((dims)=>{
                            if (dims) updater.updateDimensions(dims);
                        }).catch(()=>{
                        // Silently ignore — if dimensions can't be fetched (e.g. network error),
                        // the image will render at its current size without the height-preserving
                        // width adjustment. This is an acceptable degraded experience.
                        });
                    }
                };
                if (!isEndState(mediaStateWithContext)) {
                    const uploadingPromise = new Promise((resolve)=>{
                        onMediaStateChanged((newState)=>{
                            if (isEndState(newState)) resolve(newState);
                        });
                    });
                    this.taskManager.addPendingTask(uploadingPromise, mediaStateWithContext.id).then(()=>{
                        this.updateAndDispatch({
                            allUploadsFinished: true
                        });
                        triggerDimensionFetch();
                    });
                } else // File is already in a resolved state — fetch dimensions immediately
                triggerDimensionFetch();
                if (dropPos !== undefined) {
                    var _this$dropTargets2;
                    (_this$dropTargets2 = this.dropTargets) === null || _this$dropTargets2 === void 0 || _this$dropTargets2.inserted(mediaState.id);
                }
                const { view: view } = this;
                if (!view.hasFocus()) view.focus();
                return;
            }
            switch((0, $kWqd8.getMediaNodeInsertionType)(state, this.mediaOptions, mediaStateWithContext.fileMimeType)){
                case 'inline':
                    (0, $fLyBt.insertMediaInlineNode)(editorAnalyticsAPI)(this.view, mediaStateWithContext, collection, this.allowInlineImages, this.getInputMethod(pickerType), insertMediaVia);
                    break;
                case 'block':
                    // read width state right before inserting to get up-to-date and define values
                    const widthPluginState = (_this$pluginInjection4 = this.pluginInjectionApi) === null || _this$pluginInjection4 === void 0 || (_this$pluginInjection4 = _this$pluginInjection4.width) === null || _this$pluginInjection4 === void 0 ? void 0 : _this$pluginInjection4.sharedState.currentState();
                    (0, $jmBd6.insertMediaSingleNode)(this.view, mediaStateWithContext, this.getInputMethod(pickerType), collection, this.mediaOptions && this.mediaOptions.alignLeftOnInsert, widthPluginState, editorAnalyticsAPI, this.onNodeInserted, insertMediaVia, this.mediaOptions && this.mediaOptions.allowPixelResizing);
                    break;
                case 'group':
                    (0, $fLyBt.insertMediaGroupNode)(editorAnalyticsAPI)(this.view, [
                        mediaStateWithContext
                    ], collection, this.getInputMethod(pickerType), insertMediaVia, dropPos);
                    break;
            }
            (_this$dropTargets3 = this.dropTargets) === null || _this$dropTargets3 === void 0 || _this$dropTargets3.inserted(mediaState.id);
            // do events when media state changes
            onMediaStateChanged(this.handleMediaState);
            // handle waiting for upload complete
            const isEndState = (state)=>state.status && $3a36aed222e51a6a$var$MEDIA_RESOLVED_STATES.indexOf(state.status) !== -1;
            if (!isEndState(mediaStateWithContext)) {
                const uploadingPromise = new Promise((resolve)=>{
                    onMediaStateChanged((newState)=>{
                        // When media item reaches its final state, remove listener and resolve
                        if (isEndState(newState)) resolve(newState);
                    });
                });
                this.taskManager.addPendingTask(uploadingPromise, mediaStateWithContext.id).then(()=>{
                    this.updateAndDispatch({
                        allUploadsFinished: true
                    });
                });
            }
            // refocus the view
            const { view: view } = this;
            if (!view.hasFocus()) view.focus();
            this.waitForPendingTasks().then(()=>{
                if (this.uploadInProgressSubscriptions.length > 0 && this.uploadInProgressSubscriptionsNotified) {
                    this.uploadInProgressSubscriptions.forEach((fn)=>fn(false));
                    this.uploadInProgressSubscriptionsNotified = false;
                }
            });
            this.selectLastAddedMediaNode();
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.addPendingTask = (task)=>{
            this.taskManager.addPendingTask(task);
        };
        this.splitMediaGroup = ()=>(0, $4sVoN.splitMediaGroup)(this.view);
        this.onPopupPickerClose = ()=>{
            this.onPopupToggleCallback(false);
        };
        this.showMediaPicker = ()=>{
            if (this.openMediaPickerBrowser) return this.openMediaPickerBrowser();
            this.onPopupToggleCallback(true);
        };
        /**
   * Opens the media picker in "replace" mode. The next file selected/uploaded
   * will replace the currently selected mediaSingle node's media child in-place,
   * preserving layout, width, and caption.
   *
   * The display height is computed and stored so that after the new file's intrinsic
   * dimensions are fetched, the mediaSingle display width can be adjusted to maintain
   * visual height stability rather than width stability.
   */ this.showMediaPickerForReplace = ()=>{
            var _this$pluginInjection5;
            const { state: state } = this.view;
            const { mediaSingle: mediaSingle } = state.schema.nodes;
            const { selection: selection } = state;
            // Only activate replace mode when a mediaSingle is selected
            if (!(selection instanceof (0, $cw0wu.NodeSelection)) || selection.node.type !== mediaSingle) return;
            const mediaSingleNode = selection.node;
            const mediaNode = mediaSingleNode.firstChild;
            if (!mediaNode) return;
            // Store the current media node's id so insertFile can identify and replace it
            this.replaceMediaFileId = mediaNode.attrs.id;
            // Compute and store the current display height so we can preserve it after
            // the new file's intrinsic dimensions are known.
            // displayHeight = displayWidth * (intrinsicHeight / intrinsicWidth)
            const widthAttr = mediaSingleNode.attrs.width;
            const widthType = mediaSingleNode.attrs.widthType;
            const intrinsicWidth = mediaNode.attrs.width;
            const intrinsicHeight = mediaNode.attrs.height;
            // Resolve actual pixel display width from mediaSingle attrs.
            const lineLength = ((_this$pluginInjection5 = this.pluginInjectionApi) === null || _this$pluginInjection5 === void 0 || (_this$pluginInjection5 = _this$pluginInjection5.width) === null || _this$pluginInjection5 === void 0 || (_this$pluginInjection5 = _this$pluginInjection5.sharedState.currentState()) === null || _this$pluginInjection5 === void 0 ? void 0 : _this$pluginInjection5.lineLength) ?? 760;
            let displayWidth = null;
            if (widthAttr && widthType === 'pixel') displayWidth = widthAttr;
            else if (widthAttr) // Default widthType is 'percentage' — convert to pixels
            displayWidth = widthAttr / 100 * lineLength;
            else if (intrinsicWidth) // No width set at all (never resized) — fall back to intrinsic width
            displayWidth = intrinsicWidth;
            if (displayWidth && intrinsicWidth && intrinsicHeight && intrinsicWidth > 0) this.replaceMediaTargetDisplayHeight = displayWidth * (intrinsicHeight / intrinsicWidth);
            else // Can't compute display height — fall back to preserving width
            this.replaceMediaTargetDisplayHeight = null;
            // Finally, show the media picker
            this.showMediaPicker();
        };
        this.setBrowseFn = (browseFn)=>{
            this.openMediaPickerBrowser = browseFn;
        };
        this.onPopupToggle = (onPopupToggleCallback)=>{
            this.onPopupToggleCallback = onPopupToggleCallback;
        };
        /**
   * Returns a promise that is resolved after all pending operations have been finished.
   * An optional timeout will cause the promise to reject if the operation takes too long
   *
   * NOTE: The promise will resolve even if some of the media have failed to process.
   */ this.waitForPendingTasks = this.taskManager.waitForPendingTasks;
        /**
   * Called from React UI Component when user clicks on "Delete" icon
   * inside of it
   */ this.handleMediaNodeRemoval = (node, getPos)=>{
            let getNode = node;
            if (!getNode) {
                const pos = getPos();
                if (typeof pos !== 'number') return;
                getNode = this.view.state.doc.nodeAt(pos);
            }
            (0, $4sVoN.removeMediaNode)(this.view, getNode, getPos);
        };
        this.getIdentifierKey = (identifier)=>{
            if (identifier.mediaItemType === 'file') return identifier.id;
            else return identifier.dataURI;
        };
        this.trackMediaNodeAddition = (node)=>{
            const identifier = (0, $4sVoN.getIdentifier)(node.attrs);
            const key = this.getIdentifierKey(identifier);
            const { count: count } = this.identifierCount.get(key) ?? {
                count: 0
            };
            if (count === 0) this.taskManager.resumePendingTask(key);
            this.identifierCount.set(key, {
                identifier: identifier,
                count: count + 1
            });
        };
        this.trackMediaNodeRemoval = (node)=>{
            const identifier = (0, $4sVoN.getIdentifier)(node.attrs);
            const key = this.getIdentifierKey(identifier);
            const { count: count } = this.identifierCount.get(key) ?? {
                count: 0
            };
            if (count === 1) this.taskManager.cancelPendingTask(key);
            this.identifierCount.set(key, {
                identifier: identifier,
                count: count - 1
            });
        };
        this.isIdentifierInEditorScope = (identifier)=>{
            const key = this.getIdentifierKey(identifier);
            // rely on has instead of count > 0 because if the user cuts and pastes the same media
            // the count will temporarily be 0 but the media is still in the scope of editor.
            return !this.outOfEditorScopeIdentifierMap.has(key) && this.identifierCount.has(key);
        };
        /**
   * This is used in on Paste of media, this tracks which if the pasted media originated from a outside the editor
   * i.e. the pasted media was not uplaoded to the current editor.
   * This is to enable mediaShallowCopySope to enable only shallow copying media referenced within the edtior
   */ this.trackOutOfScopeIdentifier = (identifier)=>{
            const key = this.getIdentifierKey(identifier);
            this.outOfEditorScopeIdentifierMap.set(key, {
                identifier: identifier
            });
        };
        /**
   * Called from React UI Component on componentDidMount
   */ this.handleMediaNodeMount = (node, getPos)=>{
            this.trackMediaNodeAddition(node);
            this.mediaNodes.unshift({
                node: node,
                getPos: getPos
            });
        };
        /**
   * Called from React UI Component on componentWillUnmount and UNSAFE_componentWillReceiveProps
   * when React component's underlying node property is replaced with a new node
   */ this.handleMediaNodeUnmount = (oldNode)=>{
            this.trackMediaNodeRemoval(oldNode);
            this.mediaNodes = this.mediaNodes.filter(({ node: node })=>oldNode !== node);
        };
        this.handleMediaGroupUpdate = (oldNodes, newNodes)=>{
            const addedNodes = newNodes.filter((node)=>oldNodes.every((oldNode)=>oldNode.attrs.id !== node.attrs.id));
            const removedNodes = oldNodes.filter((node)=>newNodes.every((newNode)=>newNode.attrs.id !== node.attrs.id));
            addedNodes.forEach((node)=>{
                this.trackMediaNodeAddition(node);
            });
            removedNodes.forEach((oldNode)=>{
                this.trackMediaNodeRemoval(oldNode);
            });
        };
        this.findMediaNode = (id)=>{
            return $lyZqb.findMediaNode(this, id);
        };
        this.destroyAllPickers = (pickers)=>{
            pickers.forEach((picker)=>picker.destroy());
            this.pickers.splice(0, this.pickers.length);
        };
        this.destroyPickers = ()=>{
            const { pickers: pickers, pickerPromises: pickerPromises } = this;
            // If pickerPromises and pickers are the same length
            // All pickers have resolved and we safely destroy them
            // Otherwise wait for them to resolve then destroy.
            if (pickerPromises.length === pickers.length) this.destroyAllPickers(this.pickers);
            else Promise.all(pickerPromises).then((resolvedPickers)=>this.destroyAllPickers(resolvedPickers));
            this.customPicker = undefined;
        };
        this.getInputMethod = (pickerType)=>{
            switch(pickerType){
                case (0, $g6Qq4.INPUT_METHOD).PICKER_CLOUD:
                    return (0, $g6Qq4.INPUT_METHOD).PICKER_CLOUD;
                case (0, $g6Qq4.INPUT_METHOD).MEDIA_PICKER:
                    return (0, $g6Qq4.INPUT_METHOD).MEDIA_PICKER;
                case 'clipboard':
                    return (0, $g6Qq4.INPUT_METHOD).CLIPBOARD;
                case 'dropzone':
                    return (0, $g6Qq4.INPUT_METHOD).DRAG_AND_DROP;
                case 'browser':
                    return (0, $g6Qq4.INPUT_METHOD).BROWSER;
            }
            return;
        };
        this.updateMediaSingleNodeAttrs = (id, attrs)=>{
            const { view: view } = this;
            if (!view) return;
            return (0, $lyZqb.updateMediaNodeAttrs)(id, attrs)(view.state, view.dispatch);
        };
        this.handleMediaState = (state)=>{
            switch(state.status){
                case 'error':
                    const { uploadErrorHandler: uploadErrorHandler } = this.options;
                    if (uploadErrorHandler) uploadErrorHandler(state);
                    break;
            }
        };
        this.removeSelectedMediaContainer = ()=>{
            const { view: view } = this;
            const selectedNode = this.selectedMediaContainerNode();
            if (!selectedNode) return false;
            const { from: from } = view.state.selection;
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            (0, $4sVoN.removeMediaNode)(view, selectedNode.firstChild, ()=>from + 1);
            return true;
        };
        this.selectedMediaContainerNode = ()=>{
            var _this$view;
            const selection = (_this$view = this.view) === null || _this$view === void 0 || (_this$view = _this$view.state) === null || _this$view === void 0 ? void 0 : _this$view.selection;
            if (selection instanceof (0, $cw0wu.NodeSelection) && this.isMediaSchemaNode(selection.node)) return selection.node;
            return;
        };
        this.getDropTarget = (event)=>{
            var _this$dropTargets4;
            if (!event.dataTransfer || !this.allowsUploads || this.destroyed) return;
            const hover = (_this$dropTargets4 = this.dropTargets) === null || _this$dropTargets4 === void 0 ? void 0 : _this$dropTargets4.hover;
            if (event.target instanceof Element && event.target.closest('[data-media-drop-placeholder]') && hover !== undefined) return {
                pos: hover
            };
            const files = Array.from(event.dataTransfer.files);
            const fileTypes = files.length ? files.map((file)=>file.type) : Array.from(event.dataTransfer.items || []).filter((item)=>item.kind === 'file').map((item)=>item.type);
            const replacement = (0, $8w5gF.findMediaDropReplacement)(this.view, event, fileTypes);
            if (replacement) {
                const node = this.view.state.doc.nodeAt(replacement.pos);
                return {
                    pos: replacement.pos + ((node === null || node === void 0 ? void 0 : node.nodeSize) ?? 0),
                    replacement: replacement
                };
            }
            const pos = (0, $8w5gF.findMediaDropPosition)(this.view, {
                left: event.clientX,
                top: event.clientY
            }, fileTypes.length ? fileTypes : [
                ''
            ], this.mediaOptions);
            return pos === undefined ? undefined : {
                pos: pos
            };
        };
        this.handleDragOver = (event)=>{
            var _dropTargets$hoverRep, _target$replacement, _dropTargets$hoverRep2, _target$replacement2;
            const dropTargets = this.dropTargets;
            if (!dropTargets) return;
            const target = this.getDropTarget(event);
            const isActive = target !== undefined;
            if (dropTargets.hover === (target === null || target === void 0 ? void 0 : target.pos) && this.showDropzone === isActive && ((_dropTargets$hoverRep = dropTargets.hoverReplacement) === null || _dropTargets$hoverRep === void 0 ? void 0 : _dropTargets$hoverRep.pos) === (target === null || target === void 0 || (_target$replacement = target.replacement) === null || _target$replacement === void 0 ? void 0 : _target$replacement.pos) && ((_dropTargets$hoverRep2 = dropTargets.hoverReplacement) === null || _dropTargets$hoverRep2 === void 0 ? void 0 : _dropTargets$hoverRep2.media) === (target === null || target === void 0 || (_target$replacement2 = target.replacement) === null || _target$replacement2 === void 0 ? void 0 : _target$replacement2.media)) return;
            dropTargets.hover = target === null || target === void 0 ? void 0 : target.pos;
            dropTargets.hoverReplacement = target === null || target === void 0 ? void 0 : target.replacement;
            this.showDropzone = isActive;
            this.view.dispatch(this.view.state.tr);
        };
        this.handleDrop = (event, traceContext)=>{
            const dropTargets = this.dropTargets;
            if (!dropTargets) return false;
            const target = this.getDropTarget(event);
            this.handleDrag('leave');
            if (!target) return false;
            return dropTargets.start(traceContext.traceId, target.pos, target.replacement);
        };
        this.handleDrag = (dragState)=>{
            const dropTargets = this.dropTargets;
            if (dropTargets) {
                if (dragState === 'enter' || this.destroyed) return;
                if (!this.showDropzone && dropTargets.hover === undefined) return;
                this.showDropzone = false;
                dropTargets.clearHover();
                this.view.dispatch(this.view.state.tr);
                return;
            }
            const isActive = dragState === 'enter';
            if (this.showDropzone === isActive) return;
            this.showDropzone = isActive;
            const { dispatch: dispatch, state: state } = this.view;
            const { tr: tr, selection: selection, doc: doc } = state;
            const { media: media, mediaGroup: mediaGroup } = state.schema.nodes;
            const pos = Math.max(0, selection.$from.pos - 1);
            const sel = (0, $cw0wu.Selection).findFrom(doc.resolve(pos), -1);
            if (sel && (0, $gab48.findSelectedNodeOfType)(media)(sel)) {
                const parent = (0, $gab48.findParentNodeOfType)(mediaGroup)(sel);
                if (parent) tr.setSelection((0, $cw0wu.NodeSelection).create(tr.doc, parent.start));
            }
            dispatch(tr);
        };
        var _this$mediaOptions, _this$mediaOptions2;
        this.options = options;
        this.mediaOptions = mediaOptions;
        this.dispatch = dispatch;
        this.pluginInjectionApi = pluginInjectionApi;
        this.waitForMediaUpload = options.waitForMediaUpload === undefined ? true : options.waitForMediaUpload;
        const { nodes: nodes } = state.schema;
        (0, (/*@__PURE__*/$parcel$interopDefault($kqszs)))(nodes.media && (nodes.mediaGroup || nodes.mediaSingle), 'Editor: unable to init media plugin - media or mediaGroup/mediaSingle node absent in schema');
        if (mediaOptions !== null && mediaOptions !== void 0 && mediaOptions.syncProvider) {
            this.setMediaProvider(mediaOptions.syncProvider);
            if (mediaOptions.provider && (0, $3y2s4.isExperimentEnabled)('platform_editor_ssr_toolbar_optimistic')) {
                // The synchronous SSR provider may only support viewing. Keep its view
                // config, but wait for the full provider before deciding upload availability.
                if (!this.allowsUploads) this.uploadStatus = 'pending';
                this.setMediaProvider(mediaOptions.provider);
            }
        } else if (mediaOptions !== null && mediaOptions !== void 0 && mediaOptions.provider) this.setMediaProvider(mediaOptions === null || mediaOptions === void 0 ? void 0 : mediaOptions.provider);
        if ((0, $jEFfF.mediaInlineImagesEnabled)((0, $97BF5.getMediaFeatureFlag)('mediaInline', (_this$mediaOptions = this.mediaOptions) === null || _this$mediaOptions === void 0 ? void 0 : _this$mediaOptions.featureFlags), (_this$mediaOptions2 = this.mediaOptions) === null || _this$mediaOptions2 === void 0 ? void 0 : _this$mediaOptions2.allowMediaInlineImages)) this.allowInlineImages = true;
        this.errorReporter = options.errorReporter || new (0, $ehhh6.ErrorReporter)();
        this.singletonCreatedAt = (performance || Date).now();
    }
    clone() {
        const clonedAt = (performance || Date).now();
        // Prevent double wrapping
        // If clone is repeatedly called, we want to proxy the underlying MediaPluginStateImplementation target, rather than the proxy itself
        // If we proxy the proxy, then calling get in future will need to recursively unwrap proxies to find the original target, which causes performance issues
        // Instead, we check if there is an original target stored on "this", and if so, we use that as the proxy target instead
        return new Proxy(this.originalTarget ?? this, {
            get (target, prop, receiver) {
                if (prop === 'singletonCreatedAt') return clonedAt;
                if (prop === 'originalTarget') return target;
                return Reflect.get(target, prop, receiver);
            }
        });
    }
    subscribeToUploadInProgressState(fn) {
        this.uploadInProgressSubscriptions.push(fn);
    }
    unsubscribeFromUploadInProgressState(fn) {
        this.uploadInProgressSubscriptions = this.uploadInProgressSubscriptions.filter((subscribedFn)=>subscribedFn !== fn);
    }
    async setMediaProvider(mediaProvider) {
        // Prevent someone trying to set the exact same provider twice for performance reasons
        if (this.previousMediaProvider === mediaProvider && !((0, $3y2s4.isExperimentEnabled)('platform_editor_ssr_toolbar_optimistic') && this.uploadStatus === 'pending' && !mediaProvider)) return;
        this.previousMediaProvider = mediaProvider;
        if (!mediaProvider) {
            this.destroyPickers();
            this.allowsUploads = false;
            this.uploadStatus = 'unavailable';
            if (!this.destroyed && (this.view || !(0, $3y2s4.isExperimentEnabled)('platform_editor_ssr_toolbar_optimistic'))) this.view.dispatch(this.view.state.tr.setMeta((0, $7ICJC.stateKey), {
                allowsUploads: this.allowsUploads
            }));
            return;
        }
        // Ignored via go/ees007
        // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
        // TODO disable (not destroy!) pickers until mediaProvider is resolved
        try {
            const resolvedProvider = mediaProvider instanceof Promise ? await mediaProvider : mediaProvider;
            if ((0, $3y2s4.isExperimentEnabled)('platform_editor_ssr_toolbar_optimistic') && (this.destroyed || this.previousMediaProvider !== mediaProvider)) return;
            this.mediaProvider = resolvedProvider;
            // Ignored via go/ees007
            // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
            // TODO [MS-2038]: remove once context api is removed
            // We want to re assign the view and upload configs if they are missing for backwards compatibility
            // as currently integrators can pass context || mediaClientConfig
            if (!this.mediaProvider.viewMediaClientConfig) {
                const viewMediaClientConfig = this.mediaProvider.viewMediaClientConfig;
                if (viewMediaClientConfig) this.mediaProvider.viewMediaClientConfig = viewMediaClientConfig;
            }
            (0, (/*@__PURE__*/$parcel$interopDefault($kqszs)))(this.mediaProvider.viewMediaClientConfig, `MediaProvider promise did not resolve to a valid instance of MediaProvider - ${this.mediaProvider}`);
        } catch (err) {
            if ((0, $3y2s4.isExperimentEnabled)('platform_editor_ssr_toolbar_optimistic') && (this.destroyed || this.previousMediaProvider !== mediaProvider)) return;
            const wrappedError = new Error(`Media functionality disabled due to rejected provider: ${err instanceof Error ? err.message : String(err)}`);
            this.errorReporter.captureException(wrappedError);
            this.destroyPickers();
            this.allowsUploads = false;
            this.uploadStatus = 'unavailable';
            if (!this.destroyed && (this.view || !(0, $3y2s4.isExperimentEnabled)('platform_editor_ssr_toolbar_optimistic'))) this.view.dispatch(this.view.state.tr.setMeta((0, $7ICJC.stateKey), {
                allowsUploads: this.allowsUploads
            }));
            return;
        }
        this.mediaClientConfig = this.mediaProvider.viewMediaClientConfig;
        this.allowsUploads = !!this.mediaProvider.uploadMediaClientConfig;
        this.uploadStatus = this.allowsUploads ? 'available' : 'unavailable';
        const { view: view, allowsUploads: allowsUploads } = this;
        // make sure editable DOM node is mounted
        if (!this.destroyed && view && view.dom.parentNode) // make PM plugin aware of the state change to update UI during 'apply' hook
        view.dispatch(view.state.tr.setMeta((0, $7ICJC.stateKey), {
            allowsUploads: allowsUploads
        }));
        if (this.allowsUploads) {
            this.uploadMediaClientConfig = this.mediaProvider.uploadMediaClientConfig;
            if (this.mediaProvider.uploadParams && this.uploadMediaClientConfig) await this.initPickers(this.mediaProvider.uploadParams, (0, $fxLWg.default));
            else this.destroyPickers();
        } else this.destroyPickers();
    }
    setIsResizing(isResizing) {
        this.isResizing = isResizing;
    }
    setResizingWidth(width) {
        this.resizingWidth = width;
    }
    updateElement() {
        let newElement;
        const selectedContainer = this.selectedMediaContainerNode();
        if (selectedContainer && this.isMediaSchemaNode(selectedContainer)) {
            newElement = this.getDomElement(this.view.domAtPos.bind(this.view));
            if (selectedContainer.type === this.view.state.schema.nodes.mediaSingle) this.currentMaxWidth = (0, $33OA0.getMaxWidthForNestedNodeNext)(this.view, this.view.state.selection.$anchor.pos) || undefined;
            else this.currentMaxWidth = undefined;
        }
        if (this.element !== newElement) this.element = newElement;
    }
    getDomElement(domAtPos) {
        const { selection: selection } = this.view.state;
        if (!(selection instanceof (0, $cw0wu.NodeSelection))) return;
        if (!this.isMediaSchemaNode(selection.node)) return;
        const node = (0, $gab48.findDomRefAtPos)(selection.from, domAtPos);
        if (node) {
            if (!node.childNodes.length) return node.parentNode;
            return node;
        }
        return;
    }
    get contextIdentifierProvider() {
        var _this$pluginInjection;
        return (_this$pluginInjection = this.pluginInjectionApi) === null || _this$pluginInjection === void 0 || (_this$pluginInjection = _this$pluginInjection.contextIdentifier) === null || _this$pluginInjection === void 0 || (_this$pluginInjection = _this$pluginInjection.sharedState.currentState()) === null || _this$pluginInjection === void 0 ? void 0 : _this$pluginInjection.contextIdentifierProvider;
    }
    selectLastAddedMediaNode() {
        var _this$mediaOptions4;
        // if preventAutoFocusOnUpload is enabled, skip auto-selection and just clear the tracking array
        if ((_this$mediaOptions4 = this.mediaOptions) !== null && _this$mediaOptions4 !== void 0 && _this$mediaOptions4.preventAutoFocusOnUpload) {
            this.lastAddedMediaSingleFileIds = [];
            return;
        }
        // if lastAddedMediaSingleFileIds is empty exit because there are no added media single nodes to be selected
        if (this.lastAddedMediaSingleFileIds.length !== 0) this.waitForPendingTasks().then(()=>{
            const lastTrackedAddedNode = this.lastAddedMediaSingleFileIds[0];
            // execute selection only if selection did not change after the node has been inserted
            if ((lastTrackedAddedNode === null || lastTrackedAddedNode === void 0 ? void 0 : lastTrackedAddedNode.selectionPosition) === this.view.state.selection.from) {
                const lastAddedNode = this.mediaNodes.find((node)=>{
                    return node.node.attrs.id === lastTrackedAddedNode.id;
                });
                const lastAddedNodePos = lastAddedNode === null || lastAddedNode === void 0 ? void 0 : lastAddedNode.getPos();
                if (lastAddedNodePos) {
                    const { dispatch: dispatch, state: state } = this.view;
                    const tr = state.tr;
                    tr.setSelection((0, $cw0wu.NodeSelection).create(tr.doc, lastAddedNodePos));
                    if (dispatch) dispatch(tr);
                }
            }
            // reset temp constant after uploads finished
            this.lastAddedMediaSingleFileIds = [];
        });
    }
    setView(view) {
        this.view = view;
        if ((0, $3y2s4.isExperimentEnabled)('platform_editor_ssr_toolbar_optimistic') && this.uploadStatus === 'pending' && !this.previousMediaProvider) // No provider was configured for this client editor. SSR has no view and stays pending.
        this.uploadStatus = 'unavailable';
    }
    destroy() {
        var _this$mediaDropTarget;
        if (this.destroyed) return;
        this.destroyed = true;
        (_this$mediaDropTarget = this.mediaDropTargets) === null || _this$mediaDropTarget === void 0 || _this$mediaDropTarget.clear();
        const { mediaNodes: mediaNodes } = this;
        mediaNodes.splice(0, mediaNodes.length);
        this.removeOnCloseListener();
        this.destroyPickers();
    }
    async initPickers(uploadParams, Picker) {
        if (this.destroyed || !this.uploadMediaClientConfig) return;
        const { errorReporter: errorReporter, pickers: pickers, pickerPromises: pickerPromises } = this;
        // create pickers if they don't exist, re-use otherwise
        if (!pickers.length) {
            const pickerFacadeConfig = {
                mediaClientConfig: this.uploadMediaClientConfig,
                errorReporter: errorReporter
            };
            if (this.options.customMediaPicker) {
                const customPicker = new Picker('customMediaPicker', pickerFacadeConfig, this.options.customMediaPicker).init();
                pickerPromises.push(customPicker);
                pickers.push(this.customPicker = await customPicker);
            }
            pickers.forEach((picker)=>{
                picker.onNewMedia(this.insertFile);
            });
        }
        // set new upload params for the pickers
        pickers.forEach((picker)=>picker.setUploadParams(uploadParams));
    }
    collectionFromProvider() {
        return this.mediaProvider && this.mediaProvider.uploadParams && this.mediaProvider.uploadParams.collection;
    }
    updateAndDispatch(props) {
        // update plugin state
        Object.keys(props).forEach((_key)=>{
            const key = _key;
            const value = props[key];
            if (value !== undefined) this[key] = value;
        });
        if (this.dispatch) this.dispatch((0, $7ICJC.stateKey), {
            ...this
        });
    }
}
const $3a36aed222e51a6a$export$c2bb38320d6be1f2 = (state)=>(0, $7ICJC.stateKey).getState(state);
const $3a36aed222e51a6a$export$ae829ec7b2625219 = (_schema, options, getIntl, pluginInjectionApi, nodeViewPortalProviderAPI, dispatch, mediaOptions)=>{
    const intl = getIntl();
    return new (0, $f7Kk4.SafePlugin)({
        state: {
            init (_config, state) {
                return new $3a36aed222e51a6a$export$a013ab53254c388d(state, options, mediaOptions, dispatch, pluginInjectionApi);
            },
            apply (tr, pluginState) {
                var _pluginState$dropTarg, _tr$getMeta;
                (_pluginState$dropTarg = pluginState.dropTargets) === null || _pluginState$dropTarg === void 0 || _pluginState$dropTarg.map(tr.mapping);
                const isResizing = tr.getMeta($3a36aed222e51a6a$export$2955196e6685aaf4);
                const resizingWidth = tr.getMeta($3a36aed222e51a6a$export$ea728aeacba173d1);
                const mediaProvider = (_tr$getMeta = tr.getMeta((0, $7ICJC.stateKey))) === null || _tr$getMeta === void 0 ? void 0 : _tr$getMeta.mediaProvider;
                // Yes, I agree with you; this approach, using the clone() fuction, below is horrifying.
                // However, we needed to implement this workaround to solve the singleton Media PluginState.
                // The entire PluginInjectionAPI relies on the following axiom: "A PluginState that reflects a new EditorState.". We can not have the mutable singleton instance for all EditorState.
                // Unfortunately, we can't implement a proper fix for this media state situation. So, we are faking a new object using a Proxy instance.
                let nextPluginState = pluginState;
                if (isResizing !== undefined) {
                    pluginState.setIsResizing(isResizing);
                    nextPluginState = nextPluginState.clone();
                }
                if (mediaProvider) pluginState.setMediaProvider(mediaProvider);
                if (resizingWidth) {
                    pluginState.setResizingWidth(resizingWidth);
                    nextPluginState = nextPluginState.clone();
                }
                // remap editing media single position if we're in collab
                if (typeof pluginState.editingMediaSinglePos === 'number') {
                    pluginState.editingMediaSinglePos = tr.mapping.map(pluginState.editingMediaSinglePos);
                    nextPluginState = nextPluginState.clone();
                }
                const meta = tr.getMeta((0, $7ICJC.stateKey));
                if (meta) {
                    const { allowsUploads: allowsUploads } = meta;
                    pluginState.updateAndDispatch({
                        allowsUploads: typeof allowsUploads === 'undefined' ? pluginState.allowsUploads : allowsUploads
                    });
                    nextPluginState = nextPluginState.clone();
                }
                // ACTIONS
                switch(meta === null || meta === void 0 ? void 0 : meta.type){
                    case (0, $aLFwY.ACTIONS).SHOW_MEDIA_VIEWER:
                        pluginState.mediaViewerSelectedMedia = meta.mediaViewerSelectedMedia;
                        pluginState.isMediaViewerVisible = meta.isMediaViewerVisible;
                        nextPluginState = nextPluginState.clone();
                        break;
                    case (0, $aLFwY.ACTIONS).HIDE_MEDIA_VIEWER:
                        pluginState.mediaViewerSelectedMedia = undefined;
                        pluginState.isMediaViewerVisible = meta.isMediaViewerVisible;
                        nextPluginState = nextPluginState.clone();
                        break;
                    case (0, $aLFwY.ACTIONS).TRACK_MEDIA_PASTE:
                        const { identifier: identifier } = meta;
                        const isIdentifierInEditorScope = pluginState.isIdentifierInEditorScope(identifier);
                        if (!isIdentifierInEditorScope && (0, $4PL54.isFileIdentifier)(identifier)) {
                            pluginState.trackOutOfScopeIdentifier(identifier);
                            nextPluginState = pluginState.clone();
                        }
                        break;
                }
                // NOTE: We're not calling passing new state to the Editor, because we depend on the view.state reference
                //       throughout the lifetime of view. We injected the view into the plugin state, because we dispatch()
                //       transformations from within the plugin state (i.e. when adding a new file).
                return nextPluginState;
            }
        },
        appendTransaction (transactions, _oldState, newState) {
            for (const transaction of transactions){
                const isSelectionOnMediaInsideMediaSingle = transaction.selectionSet && (0, $gab48.isNodeSelection)(transaction.selection) && transaction.selection.node.type === newState.schema.nodes.media && transaction.selection.$anchor.parent.type === newState.schema.nodes.mediaSingle;
                // Note: this causes an additional transaction when selecting a media node
                // through clicking  on it with the cursor.
                if (isSelectionOnMediaInsideMediaSingle) // If a selection has been placed on a media inside a media single,
                // we shift it to the media single parent as other code is opinionated about
                // the selection landing there. In particular the caption insertion and selection
                // action.
                return newState.tr.setSelection((0, $cw0wu.NodeSelection).create(newState.doc, transaction.selection.$from.pos - 1));
            }
            return;
        },
        key: (0, $7ICJC.stateKey),
        view: (view)=>{
            const pluginState = $3a36aed222e51a6a$export$c2bb38320d6be1f2(view.state);
            pluginState.setView(view);
            pluginState.updateElement();
            return {
                update: ()=>{
                    pluginState.updateElement();
                }
            };
        },
        props: {
            decorations: (state)=>{
                // Use this to indicate that the media node is selected
                const mediaNodes = [];
                const { schema: schema, doc: doc } = state;
                // Find any media nodes in the current selection
                if (state.selection instanceof (0, $cw0wu.TextSelection) || state.selection instanceof (0, $cw0wu.AllSelection) || state.selection instanceof (0, $2E7OD.CellSelection)) doc.nodesBetween(state.selection.from, state.selection.to, (node, pos)=>{
                    if (node.type === schema.nodes.media) {
                        mediaNodes.push((0, $a3b9P.Decoration).node(pos, pos + node.nodeSize, {}, {
                            type: 'media',
                            selected: true
                        }));
                        return false;
                    }
                    return true;
                });
                else if (state.selection instanceof (0, $cw0wu.NodeSelection)) {
                    const { node: node, $from: $from } = state.selection;
                    if (node.type === schema.nodes.mediaSingle || node.type === schema.nodes.mediaGroup) doc.nodesBetween($from.pos, $from.pos + node.nodeSize, (mediaNode, mediaPos)=>{
                        if (mediaNode.type === schema.nodes.media) {
                            mediaNodes.push((0, $a3b9P.Decoration).node(mediaPos, mediaPos + mediaNode.nodeSize, {}, {
                                type: 'media',
                                selected: true
                            }));
                            return false;
                        }
                        return true;
                    });
                }
                const pluginState = $3a36aed222e51a6a$export$c2bb38320d6be1f2(state);
                if (!pluginState.showDropzone) return (0, $a3b9P.DecorationSet).create(state.doc, mediaNodes);
                const dropTargets = pluginState.dropTargets;
                let pos;
                if (dropTargets) {
                    const replacement = dropTargets.hoverReplacementFor(state.doc);
                    if (replacement) {
                        const node = state.doc.nodeAt(replacement.pos);
                        if (node) return (0, $a3b9P.DecorationSet).create(state.doc, [
                            (0, $a3b9P.Decoration).node(replacement.pos, replacement.pos + node.nodeSize, {
                                class: 'richMedia-selected'
                            }),
                            ...mediaNodes
                        ]);
                    }
                    pos = dropTargets.hover;
                } else {
                    if (state.selection instanceof (0, $cw0wu.NodeSelection)) {
                        const node = state.selection.node;
                        if (node.type === schema.nodes.mediaSingle) {
                            const deco = (0, $a3b9P.Decoration).node(state.selection.from, state.selection.to, {
                                class: 'richMedia-selected'
                            });
                            return (0, $a3b9P.DecorationSet).create(state.doc, [
                                deco,
                                ...mediaNodes
                            ]);
                        }
                        return (0, $a3b9P.DecorationSet).create(state.doc, mediaNodes);
                    }
                    const { $anchor: $anchor } = state.selection;
                    pos = $anchor.pos;
                    if ($anchor.parent.type !== schema.nodes.paragraph && $anchor.parent.type !== schema.nodes.codeBlock) pos = (0, $3DNV7.insertPoint)(state.doc, pos, schema.nodes.mediaGroup);
                }
                if (pos === null || pos === undefined) return (0, $a3b9P.DecorationSet).create(state.doc, mediaNodes);
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                const dropPlaceholderKey = (0, $7RHfd.default)();
                const dropPlaceholders = [
                    (0, $a3b9P.Decoration).widget(pos, ()=>{
                        return $3a36aed222e51a6a$var$createDropPlaceholder(intl, nodeViewPortalProviderAPI, dropPlaceholderKey, mediaOptions && mediaOptions.allowDropzoneDropLine, dropTargets !== undefined && state.doc.resolve(pos).parent.inlineContent);
                    }, {
                        key: 'drop-placeholder',
                        destroy: (elem)=>{
                            if (elem instanceof HTMLElement) nodeViewPortalProviderAPI.remove(dropPlaceholderKey);
                        }
                    }),
                    ...mediaNodes
                ];
                return (0, $a3b9P.DecorationSet).create(state.doc, dropPlaceholders);
            },
            nodeViews: options.nodeViews,
            handleTextInput (view, from, to, text) {
                const { selection: selection } = view.state;
                if (text === ' ' && selection instanceof (0, $cw0wu.NodeSelection) && selection.node.type.name === 'mediaSingle') {
                    var _stateKey$getState;
                    const videoControlsWrapperRef = (_stateKey$getState = (0, $7ICJC.stateKey).getState(view.state)) === null || _stateKey$getState === void 0 ? void 0 : _stateKey$getState.element;
                    const videoControls = videoControlsWrapperRef === null || videoControlsWrapperRef === void 0 ? void 0 : videoControlsWrapperRef.querySelectorAll('button, [tabindex]:not([tabindex="-1"])');
                    if (videoControls) {
                        const isVideoControl = Array.from(videoControls).some((videoControl)=>{
                            // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
                            return document.activeElement === videoControl;
                        });
                        if (isVideoControl) return true;
                    }
                }
                $3a36aed222e51a6a$export$c2bb38320d6be1f2(view.state).splitMediaGroup();
                return false;
            },
            handleClick: (_editorView, _pos, event)=>{
                var _event$target;
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const clickedInsideCaptionPlaceholder = (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.closest(`[data-id="${(0, $29qUP.CAPTION_PLACEHOLDER_ID)}"]`);
                const browser = (0, $jxkn6.getBrowserInfo)();
                // Workaround for Chrome given a regression introduced in prosemirror-view@1.18.6
                // Returning true prevents that updateSelection() is getting called in the commit below:
                // @see https://github.com/ProseMirror/prosemirror-view/compare/1.18.5...1.18.6
                if ((browser.chrome || browser.safari) && clickedInsideCaptionPlaceholder) return true;
                // Workaound for iOS 16 Caption selection issue
                // @see https://product-fabric.atlassian.net/browse/MEX-2012
                if (browser.ios) {
                    var _event$target2;
                    // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    return !!((_event$target2 = event.target) !== null && _event$target2 !== void 0 && _event$target2.closest(`[class="${$3a36aed222e51a6a$export$fcef64fdeaf6f18a}"]`));
                }
                return false;
            },
            handleDoubleClickOn: (view)=>{
                var _pluginState$mediaOpt, _pluginInjectionApi$e;
                // Check if media viewer is enabled
                const pluginState = $3a36aed222e51a6a$export$c2bb38320d6be1f2(view.state);
                if (!((_pluginState$mediaOpt = pluginState.mediaOptions) !== null && _pluginState$mediaOpt !== void 0 && _pluginState$mediaOpt.allowImagePreview)) return false;
                const isLivePagesViewMode = (pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$e = pluginInjectionApi.editorViewMode) === null || _pluginInjectionApi$e === void 0 || (_pluginInjectionApi$e = _pluginInjectionApi$e.sharedState.currentState()) === null || _pluginInjectionApi$e === void 0 ? void 0 : _pluginInjectionApi$e.mode) === 'view';
                // Double Click support for Media Viewer Nodes
                const maybeMediaNode = (0, $4sVoN.getMediaFromSupportedMediaNodesFromSelection)(view.state);
                if (maybeMediaNode) {
                    var _pluginInjectionApi$a;
                    // If media type is video, do not open media viewer
                    if (!(0, $4sVoN.isNodeDoubleClickSupportedInLivePagesViewMode)(isLivePagesViewMode, maybeMediaNode)) return false;
                    // Show media viewer
                    pluginInjectionApi === null || pluginInjectionApi === void 0 || pluginInjectionApi.core.actions.execute(pluginInjectionApi === null || pluginInjectionApi === void 0 ? void 0 : pluginInjectionApi.media.commands.showMediaViewer(maybeMediaNode.attrs));
                    // Call analytics event
                    pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$a = pluginInjectionApi.analytics) === null || _pluginInjectionApi$a === void 0 || _pluginInjectionApi$a.actions.fireAnalyticsEvent({
                        action: (0, $g6Qq4.ACTION).OPENED,
                        actionSubject: (0, $g6Qq4.ACTION_SUBJECT).MEDIA_VIEWER,
                        actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).MEDIA,
                        eventType: (0, $g6Qq4.EVENT_TYPE).UI,
                        attributes: {
                            nodeType: maybeMediaNode.type.name,
                            inputMethod: (0, $g6Qq4.INPUT_METHOD).DOUBLE_CLICK
                        }
                    });
                    return true;
                }
                return false;
            },
            handleDOMEvents: {
                keydown: (view, event)=>{
                    const { selection: selection } = view.state;
                    if (selection instanceof (0, $cw0wu.NodeSelection) && selection.node.type.name === 'mediaSingle') // handle keydown events for video controls panel to prevent fire of rest prosemirror listeners;
                    {
                        if ((event === null || event === void 0 ? void 0 : event.target) instanceof HTMLElement) {
                            const a11yDefaultKeys = [
                                'Tab',
                                'Space',
                                'Enter',
                                'Shift',
                                'Esc'
                            ];
                            const targetsAndButtons = {
                                button: a11yDefaultKeys,
                                range: [
                                    ...a11yDefaultKeys,
                                    'ArrowDown',
                                    'ArrowUp',
                                    'ArrowLeft',
                                    'ArrowRight'
                                ],
                                combobox: [
                                    ...a11yDefaultKeys,
                                    'ArrowDown',
                                    'ArrowUp',
                                    'Esc'
                                ],
                                slider: [
                                    'Tab',
                                    'Shift',
                                    'ArrowLeft',
                                    'ArrowRight'
                                ]
                            };
                            const targetRole = event.target.role;
                            const targetType = event.target.type;
                            const allowedTargets = targetRole || targetType;
                            // only if targeting interactive elements fe. button, slider, range, dropdown
                            if (allowedTargets && allowedTargets in targetsAndButtons) {
                                const targetRelatedA11YKeys = targetsAndButtons[allowedTargets];
                                const allowedKeys = new Set(targetRelatedA11YKeys);
                                if (allowedKeys.has(event.key) || allowedKeys.has(event.code)) // allow event to bubble to be handled by react handlers
                                return true;
                                else // otherwise focus editor to allow setting gapCursor. (e.g.: arrowRightFromMediaSingle)
                                view.focus();
                            }
                        }
                    }
                    // fire regular prosemirror listeners;
                    return false;
                }
            }
        }
    });
};

});
parcelRegister("jEFfF", function(module, exports) {
$parcel$export(module.exports, "mediaInlineImagesEnabled", () => $07a91e1d4a2464ec$export$a82bf3f59adcc8aa);
/**
 * Enable media inline images feature based on
 * mediaOptions.featureFlags.mediaInline, mediaOptions.allowMediaInlineImages
 *
 * The reason not using mediaOption as param is because MediaOption is from editor-plugin-media
 * we want to avoid circular deps
 * @param allowMediaInline MediaOptions.featureFlags.mediaInline
 * @param allowMediaInlineImages MediaOptions.allowMediaInlineImages
 * @returns boolean
 */ const $07a91e1d4a2464ec$export$a82bf3f59adcc8aa = (allowMediaInline, allowMediaInlineImages)=>{
    return allowMediaInline && allowMediaInlineImages;
};

});

parcelRegister("fLyBt", function(module, exports) {
$parcel$export(module.exports, "canInsertMediaInline", () => $3baec9fb5c0b25b6$export$bbcb7fa97854e414);
$parcel$export(module.exports, "insertMediaInlineNode", () => $3baec9fb5c0b25b6$export$9996196b21d597d4);
$parcel$export(module.exports, "insertMediaGroupNode", () => $3baec9fb5c0b25b6$export$9cc886ab7b992a97);

var $g6Qq4 = parcelRequire("g6Qq4");

var $hA4kh = parcelRequire("hA4kh");

var $5m3y9 = parcelRequire("5m3y9");
var $BqAL4 = parcelRequire("BqAL4");
var $7k00C = parcelRequire("7k00C");

var $6Cbfp = parcelRequire("6Cbfp");

var $56AB9 = parcelRequire("56AB9");
var $5BDGB = parcelRequire("5BDGB");
var $kRFDj = parcelRequire("kRFDj");
var $j2OLx = parcelRequire("j2OLx");
var $dEhT6 = parcelRequire("dEhT6");

var $kW8qW = parcelRequire("kW8qW");

var $3DNV7 = parcelRequire("3DNV7");

var $gab48 = parcelRequire("gab48");

var $7xuRi = parcelRequire("7xuRi");

var $icDBi = parcelRequire("icDBi");

var $4sVoN = parcelRequire("4sVoN");

var $kWqd8 = parcelRequire("kWqd8");
const $3baec9fb5c0b25b6$export$bbcb7fa97854e414 = (state)=>{
    const node = state.schema.nodes.mediaInline.create({});
    return (0, $gab48.canInsert)(state.selection.$to, (0, $kW8qW.Fragment).from(node));
};
const $3baec9fb5c0b25b6$var$getInsertMediaGroupAnalytics = (mediaState, inputMethod, insertMediaVia)=>{
    let media = '';
    if (mediaState.length === 1) media = mediaState[0].fileMimeType || 'unknown';
    else if (mediaState.length > 1) media = 'multiple';
    return {
        action: (0, $g6Qq4.ACTION).INSERTED,
        actionSubject: (0, $g6Qq4.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).MEDIA,
        attributes: {
            type: (0, $g6Qq4.ACTION_SUBJECT_ID).MEDIA_GROUP,
            inputMethod: inputMethod,
            fileExtension: media,
            insertMediaVia: insertMediaVia
        },
        eventType: (0, $g6Qq4.EVENT_TYPE).TRACK
    };
};
const $3baec9fb5c0b25b6$var$getInsertMediaInlineAnalytics = (mediaState, inputMethod, insertMediaVia)=>{
    const media = mediaState.fileMimeType || 'unknown';
    return {
        action: (0, $g6Qq4.ACTION).INSERTED,
        actionSubject: (0, $g6Qq4.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).MEDIA,
        attributes: {
            type: (0, $g6Qq4.ACTION_SUBJECT_ID).MEDIA_INLINE,
            inputMethod: inputMethod,
            fileExtension: media,
            insertMediaVia: insertMediaVia
        },
        eventType: (0, $g6Qq4.EVENT_TYPE).TRACK
    };
};
const $3baec9fb5c0b25b6$export$226108e53ed56d7b = (mediaState, actionSubjectId, inputMethod, insertMediaVia, reason)=>{
    const media = mediaState.fileMimeType || 'unknown';
    return {
        action: (0, $g6Qq4.ACTION).FAILED_TO_INSERT,
        actionSubject: (0, $g6Qq4.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: actionSubjectId,
        attributes: {
            inputMethod: inputMethod,
            fileExtension: media,
            insertMediaVia: insertMediaVia,
            reason: reason
        },
        eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL
    };
};
/**
 * Check if current editor selections is a media group or not.
 * @param state Editor state
 */ function $3baec9fb5c0b25b6$var$isSelectionMediaGroup(state) {
    const { schema: schema } = state;
    const selectionParent = state.selection.$anchor.node();
    return selectionParent && selectionParent.type === schema.nodes.mediaGroup;
}
/**
 * Insert a paragraph after if reach the end of doc
 * and there is no media group in the front or selection is a non media block node
 * @param node Node at insertion point
 * @param state Editor state
 */ function $3baec9fb5c0b25b6$var$shouldAppendParagraph(state, node) {
    const { schema: { nodes: { media: media } } } = state;
    const wasMediaNode = node && node.type === media;
    return ((0, $56AB9.insideTableCell)(state) || (0, $56AB9.isInListItem)(state) || (0, $5BDGB.isInLayoutColumn)(state) || (0, $5m3y9.atTheEndOfDoc)(state) && (!(0, $4sVoN.posOfPrecedingMediaGroup)(state) || (0, $4sVoN.isSelectionNonMediaBlockNode)(state))) && !wasMediaNode;
}
/**
 * Check if node of type has been inserted successfully
 */ const $3baec9fb5c0b25b6$var$hasInsertedNodeOfType = (tr, nodeType)=>{
    var _tr$doc$nodeAt;
    let insertPos = -1;
    tr.steps.forEach((step)=>{
        if (step instanceof (0, $3DNV7.ReplaceStep)) step.slice.content.forEach((node)=>{
            if (node.type.name === nodeType) insertPos = step.from;
        });
    });
    if (insertPos === -1 || ((_tr$doc$nodeAt = tr.doc.nodeAt(insertPos)) === null || _tr$doc$nodeAt === void 0 ? void 0 : _tr$doc$nodeAt.type.name) !== nodeType) return false;
    return true;
};
const $3baec9fb5c0b25b6$export$9996196b21d597d4 = (editorAnalyticsAPI)=>(view, mediaState, collection, allowInlineImages, inputMethod, insertMediaVia)=>{
        const { state: state, dispatch: dispatch } = view;
        const { schema: schema, tr: tr } = state;
        const { mediaInline: mediaInline } = schema.nodes;
        // Do nothing if no media found
        if (!mediaInline || !mediaState || collection === undefined) return false;
        const { id: id, dimensions: dimensions, scaleFactor: scaleFactor = 1, fileName: fileName } = mediaState;
        const mediaInlineAttrs = {
            id: id,
            collection: collection
        };
        if (allowInlineImages && (0, $icDBi.isImage)(mediaState.fileMimeType)) {
            const { width: width, height: height } = dimensions || {
                width: undefined,
                height: undefined
            };
            const scaledWidth = width ? Math.round(width / scaleFactor) : (0, $hA4kh.DEFAULT_IMAGE_WIDTH);
            const scaledHeight = height ? Math.round(height / scaleFactor) : (0, $hA4kh.DEFAULT_IMAGE_HEIGHT);
            mediaInlineAttrs.width = scaledWidth;
            mediaInlineAttrs.height = scaledHeight;
            mediaInlineAttrs.type = 'image';
            mediaInlineAttrs.alt = fileName;
        }
        const mediaInlineNode = mediaInline.create(mediaInlineAttrs);
        const space = state.schema.text(' ');
        let pos = state.selection.$to.pos;
        // If the selection is inside an empty list item or panel set pos inside paragraph
        if ((0, $kWqd8.isInSupportedInlineImageParent)(state) && (0, $4sVoN.isInsidePotentialEmptyParagraph)(state)) pos = pos + 1;
        const content = (0, $kW8qW.Fragment).from([
            mediaInlineNode,
            space
        ]);
        // Delete the selection if a selection is made
        const deleteRange = $3baec9fb5c0b25b6$var$findDeleteRange(state);
        let payload;
        try {
            if (!deleteRange) tr.insert(pos, content);
            else tr.insert(pos, content).deleteRange(deleteRange.start, deleteRange.end);
            if ($3baec9fb5c0b25b6$var$hasInsertedNodeOfType(tr, 'mediaInline')) payload = $3baec9fb5c0b25b6$var$getInsertMediaInlineAnalytics(mediaState, inputMethod, insertMediaVia);
            else payload = $3baec9fb5c0b25b6$export$226108e53ed56d7b(mediaState, (0, $g6Qq4.ACTION_SUBJECT_ID).MEDIA_INLINE, inputMethod, insertMediaVia);
        } catch (error) {
            payload = $3baec9fb5c0b25b6$export$226108e53ed56d7b(mediaState, (0, $g6Qq4.ACTION_SUBJECT_ID).MEDIA_INLINE, inputMethod, insertMediaVia, // eslint-disable-next-line @typescript-eslint/no-explicit-any
            error.toString());
        }
        editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent(payload)(tr);
        dispatch(tr);
        return true;
    };
const $3baec9fb5c0b25b6$export$9cc886ab7b992a97 = (editorAnalyticsAPI)=>(view, mediaStates, collection, inputMethod, insertMediaVia, dropPosition)=>{
        const { state: state, dispatch: dispatch } = view;
        const { tr: tr, schema: schema } = state;
        const { media: media, paragraph: paragraph } = schema.nodes;
        // Do nothing if no media found
        if (!media || !mediaStates.length) return;
        const mediaNodes = $3baec9fb5c0b25b6$var$createMediaFileNodes(mediaStates, collection, media);
        const mediaInsertPos = (0, $7xuRi.isMediaDropPositionEnabled)() ? dropPosition ?? $3baec9fb5c0b25b6$var$findMediaInsertPos(state) : $3baec9fb5c0b25b6$var$findMediaInsertPos(state);
        const resolvedInsertPos = tr.doc.resolve(mediaInsertPos);
        const parent = resolvedInsertPos.parent;
        const nodeAtInsertionPoint = tr.doc.nodeAt(mediaInsertPos);
        const shouldSplit = !$3baec9fb5c0b25b6$var$isSelectionMediaGroup(state) && (0, $kRFDj.isSupportedInParent)(state, (0, $kW8qW.Fragment).from(state.schema.nodes.mediaGroup.createChecked({}, mediaNodes)));
        const withParagraph = $3baec9fb5c0b25b6$var$shouldAppendParagraph(state, nodeAtInsertionPoint);
        let content = parent.type === schema.nodes.mediaGroup ? mediaNodes // If parent is a mediaGroup do not wrap items again.
         : [
            schema.nodes.mediaGroup.createChecked({}, mediaNodes)
        ];
        if (shouldSplit) {
            content = withParagraph ? content.concat(paragraph.create()) : content;
            // delete the selection or empty paragraph
            const deleteRange = $3baec9fb5c0b25b6$var$findDeleteRange(state);
            if (!deleteRange) tr.insert(mediaInsertPos, content);
            else if (mediaInsertPos <= deleteRange.start) tr.deleteRange(deleteRange.start, deleteRange.end).insert(mediaInsertPos, content);
            else tr.insert(mediaInsertPos, content).deleteRange(deleteRange.start, deleteRange.end);
            editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent($3baec9fb5c0b25b6$var$getInsertMediaGroupAnalytics(mediaStates, inputMethod, insertMediaVia))(tr);
            dispatch(tr);
            $3baec9fb5c0b25b6$var$setSelectionAfterMediaInsertion(view);
            return;
        }
        // Don't append new paragraph when adding media to a existing mediaGroup
        if (withParagraph && parent.type !== schema.nodes.mediaGroup) content.push(paragraph.create());
        editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent($3baec9fb5c0b25b6$var$getInsertMediaGroupAnalytics(mediaStates, inputMethod, insertMediaVia))(tr);
        dispatch((0, $gab48.safeInsert)((0, $kW8qW.Fragment).fromArray(content), mediaInsertPos)(tr));
    };
const $3baec9fb5c0b25b6$var$createMediaFileNodes = (mediaStates, collection, media)=>{
    const nodes = mediaStates.map((mediaState)=>{
        const { id: id } = mediaState;
        const node = media.create({
            id: id,
            type: 'file',
            collection: collection
        });
        (0, $4sVoN.copyOptionalAttrsFromMediaState)(mediaState, node);
        return node;
    });
    return nodes;
};
/**
 * Find root list node if exist from current selection
 * @param state Editor state
 */ const $3baec9fb5c0b25b6$var$findRootListNode = (state)=>{
    const { schema: { nodes: { bulletList: bulletList, orderedList: orderedList } } } = state;
    return (0, $56AB9.findFarthestParentNode)((node)=>node.type === bulletList || node.type === orderedList)(state.selection.$from);
};
const $3baec9fb5c0b25b6$export$cbffff148fb3b8a6 = (state)=>{
    const { schema: { nodes: { mediaGroup: mediaGroup, listItem: listItem } } } = state;
    // 1. Check if I am inside a list.
    if ((0, $gab48.hasParentNode)((node)=>node.type === listItem)(state.selection)) {
        // 2. Get end position of root list
        const rootListNode = $3baec9fb5c0b25b6$var$findRootListNode(state);
        if (rootListNode) {
            const pos = rootListNode.pos + rootListNode.node.nodeSize;
            // 3. Fint the first location inside the media group
            const nextNode = state.doc.nodeAt(pos);
            if (nextNode && nextNode.type === mediaGroup) return pos + 1;
            return pos;
        }
    }
    return;
};
/**
 * Find insertion point,
 * If it is in a List it will return position to the next block,
 * If there are any media group close it will return this position
 * Otherwise, It will return the respective block given selection.
 * @param content Content to be inserted
 * @param state Editor state
 */ const $3baec9fb5c0b25b6$var$findMediaInsertPos = (state)=>{
    const { $from: $from, $to: $to } = state.selection;
    // Check if selection is inside a list.
    const posInList = $3baec9fb5c0b25b6$export$cbffff148fb3b8a6(state);
    if (posInList) // If I have a position in lists, I should return, otherwise I am not inside a list
    return posInList;
    const nearbyMediaGroupPos = (0, $4sVoN.posOfMediaGroupNearby)(state);
    if (nearbyMediaGroupPos && (!(0, $4sVoN.isSelectionNonMediaBlockNode)(state) || $from.pos < nearbyMediaGroupPos && $to.pos < nearbyMediaGroupPos)) return nearbyMediaGroupPos;
    if ((0, $4sVoN.isSelectionNonMediaBlockNode)(state)) return $to.pos;
    if ((0, $6Cbfp.atTheEndOfBlock)(state)) return $to.pos + 1;
    if ((0, $6Cbfp.atTheBeginningOfBlock)(state)) return $from.pos - 1;
    return $to.pos;
};
const $3baec9fb5c0b25b6$var$findDeleteRange = (state)=>{
    const { $from: $from, $to: $to } = state.selection;
    if ((0, $4sVoN.posOfParentMediaGroup)(state)) return;
    if (!(0, $4sVoN.isInsidePotentialEmptyParagraph)(state) || (0, $4sVoN.posOfMediaGroupNearby)(state)) return $3baec9fb5c0b25b6$var$range($from.pos, $to.pos);
    return $3baec9fb5c0b25b6$var$range((0, $7k00C.startPositionOfParent)($from) - 1, (0, $BqAL4.endPositionOfParent)($to));
};
const $3baec9fb5c0b25b6$var$range = (start, end = start)=>{
    return {
        start: start,
        end: end
    };
};
const $3baec9fb5c0b25b6$var$setSelectionAfterMediaInsertion = (view)=>{
    const { state: state } = view;
    const { doc: doc } = state;
    const mediaPos = (0, $4sVoN.posOfMediaGroupNearby)(state);
    if (!mediaPos) return;
    const $mediaPos = doc.resolve(mediaPos);
    const endOfMediaGroup = (0, $BqAL4.endPositionOfParent)($mediaPos);
    if (endOfMediaGroup + 1 >= doc.nodeSize - 1) // if nothing after the media group, fallback to select the newest uploaded media item
    (0, $j2OLx.setNodeSelection)(view, mediaPos);
    else (0, $dEhT6.setTextSelection)(view, endOfMediaGroup + 1);
};

});
parcelRegister("7xuRi", function(module, exports) {
$parcel$export(module.exports, "exposeMediaDropPosition", () => $26c1247fc12614d0$export$7747a201e676b77e);
$parcel$export(module.exports, "isMediaDropPositionEnabled", () => $26c1247fc12614d0$export$6551a54d7b8e7e79);

var $3y2s4 = parcelRequire("3y2s4");

var $3zzvD = parcelRequire("3zzvD");
const $26c1247fc12614d0$var$MEDIA_DROP_POSITION_EXPERIMENT = 'platform_editor_media_drop_position';
const $26c1247fc12614d0$export$7747a201e676b77e = ()=>(0, $3y2s4.isExperimentEnabled)($26c1247fc12614d0$var$MEDIA_DROP_POSITION_EXPERIMENT);
const $26c1247fc12614d0$export$6551a54d7b8e7e79 = ()=>(0, $3zzvD.UNSAFE_expValNoExposure)($26c1247fc12614d0$var$MEDIA_DROP_POSITION_EXPERIMENT, 'isEnabled', false) === true;

});

parcelRegister("kWqd8", function(module, exports) {
$parcel$export(module.exports, "isInSupportedInlineImageParent", () => $372753c2306d2fdd$export$31a926ac827892a0);
$parcel$export(module.exports, "getMediaNodeInsertionType", () => $372753c2306d2fdd$export$600118b0ad66a68c);

var $jEFfF = parcelRequire("jEFfF");

var $56AB9 = parcelRequire("56AB9");

var $gab48 = parcelRequire("gab48");

var $97BF5 = parcelRequire("97BF5");

var $gdUUy = parcelRequire("gdUUy");

var $fLyBt = parcelRequire("fLyBt");

var $jmBd6 = parcelRequire("jmBd6");

var $icDBi = parcelRequire("icDBi");

var $4sVoN = parcelRequire("4sVoN");
const $372753c2306d2fdd$export$31a926ac827892a0 = (state)=>{
    return (0, $gab48.hasParentNodeOfType)([
        state.schema.nodes.listItem
    ])(state.selection);
};
const $372753c2306d2fdd$export$600118b0ad66a68c = (state, mediaOptions, fileMimeType)=>{
    if ((0, $icDBi.isImage)(fileMimeType) && (0, $gdUUy.fg)('platform_editor_media_block_default')) {
        if ((0, $jmBd6.isMediaSingle)(state.schema, fileMimeType)) return 'block';
        return 'group';
    }
    const canInsertInlineNode = (0, $97BF5.getMediaFeatureFlag)('mediaInline', mediaOptions === null || mediaOptions === void 0 ? void 0 : mediaOptions.featureFlags) && !(0, $56AB9.isInEmptyLine)(state) && (!(0, $4sVoN.isInsidePotentialEmptyParagraph)(state) || $372753c2306d2fdd$export$31a926ac827892a0(state)) && (0, $fLyBt.canInsertMediaInline)(state);
    if ((0, $jEFfF.mediaInlineImagesEnabled)((0, $97BF5.getMediaFeatureFlag)('mediaInline', mediaOptions === null || mediaOptions === void 0 ? void 0 : mediaOptions.featureFlags), mediaOptions === null || mediaOptions === void 0 ? void 0 : mediaOptions.allowMediaInlineImages)) {
        if (canInsertInlineNode && !(0, $icDBi.isVideo)(fileMimeType)) return 'inline';
    }
    if ((0, $jmBd6.isMediaSingle)(state.schema, fileMimeType)) return 'block';
    else if (canInsertInlineNode) return 'inline';
    return 'group';
};

});


parcelRegister("7dHnk", function(module, exports) {
$parcel$export(module.exports, "default", () => $068224567c990570$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled, @typescript-eslint/consistent-type-imports

var $9dQre = parcelRequire("9dQre");

var $fK3tS = parcelRequire("fK3tS");

var $99x6E = parcelRequire("99x6E");

var $lwuFt = parcelRequire("lwuFt");

var $f0ceB = parcelRequire("f0ceB");
const $068224567c990570$var$iconWrapperStyles = /*#__PURE__*/ (0, $9dQre.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: "var(--ds-icon-accent-blue, #357DE8)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    background: "var(--ds-background-accent-blue-subtle, #669DF1)",
    borderRadius: "var(--ds-radius-small, 3px)",
    margin: `${"var(--ds-space-075, 6px)"} ${"var(--ds-space-050, 4px)"} ${"var(--ds-space-300, 24px)"}`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $f0ceB.FILE_WIDTH)}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minHeight: `${(0, $f0ceB.MEDIA_HEIGHT)}px`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
});
const $068224567c990570$var$dropLineStyles = /*#__PURE__*/ (0, $9dQre.css)({
    background: "var(--ds-border-focused, #4688EC)",
    borderRadius: "var(--ds-radius-small, 3px)",
    margin: `${"var(--ds-space-025, 2px)"} 0`,
    width: '100%',
    height: '2px'
});
const $068224567c990570$var$IconWrapperComponent = (props)=>{
    const { intl: intl } = props;
    const { dropPlaceholderLabel: dropPlaceholderLabel } = (0, $99x6E.dropPlaceholderMessages);
    return /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        css: $068224567c990570$var$iconWrapperStyles
    }, /*#__PURE__*/ (0, $9dQre.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lwuFt))), {
        label: intl.formatMessage(dropPlaceholderLabel)
    }));
};
const $068224567c990570$var$IntlIconWrapper = (0, $fK3tS.default)($068224567c990570$var$IconWrapperComponent);
var $068224567c990570$export$2e2bcd8739ae039 = ({ type: type = 'group' })=>type === 'single' ? /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        css: $068224567c990570$var$dropLineStyles
    }) : /*#__PURE__*/ (0, $9dQre.jsx)($068224567c990570$var$IntlIconWrapper, null);

});
parcelRegister("99x6E", function(module, exports) {
$parcel$export(module.exports, "dropPlaceholderMessages", () => $afe51f731be27433$export$5ac810f4a4d76ba2);

var $f0Pt4 = parcelRequire("f0Pt4");
const $afe51f731be27433$export$5ac810f4a4d76ba2 = (0, $f0Pt4.defineMessages)({
    dropPlaceholderLabel: {
        id: 'fabric.editor.dropPlaceholderLabel',
        defaultMessage: 'Document',
        description: 'The text is shown as the label for the document icon in the media drop placeholder, displayed when a file is being dragged over the editor and the target is a document-type media item.'
    }
});

});

parcelRegister("f0ceB", function(module, exports) {
$parcel$export(module.exports, "MEDIA_HEIGHT", () => $e109e51a6ccd73f3$export$c9940009a015ae53);
$parcel$export(module.exports, "FILE_WIDTH", () => $e109e51a6ccd73f3$export$e9329f8fc8b15625);
$parcel$export(module.exports, "default", () => $e109e51a6ccd73f3$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $bAB3U = parcelRequire("bAB3U");

var $57l7A = parcelRequire("57l7A");

var $96Oa5 = parcelRequire("96Oa5");

var $dwOcU = parcelRequire("dwOcU");

var $g6Qq4 = parcelRequire("g6Qq4");

var $8qHhy = parcelRequire("8qHhy");

var $j2OLx = parcelRequire("j2OLx");
var $dEhT6 = parcelRequire("dEhT6");

var $7mZGn = parcelRequire("7mZGn");

var $gab48 = parcelRequire("gab48");

var $2E7OD = parcelRequire("2E7OD");

var $fyJNx = parcelRequire("fyJNx");

var $b2ees = parcelRequire("b2ees");

var $gdUUy = parcelRequire("gdUUy");

var $797yE = parcelRequire("797yE");

var $7ICJC = parcelRequire("7ICJC");

var $7Sg1S = parcelRequire("7Sg1S");

var $eUcZO = parcelRequire("eUcZO");

var $e35II = parcelRequire("e35II");
const $e109e51a6ccd73f3$export$c9940009a015ae53 = 125;
const $e109e51a6ccd73f3$export$e9329f8fc8b15625 = 156;
class $e109e51a6ccd73f3$export$56a8c4089468c01e extends (0, $bSJIT.Component) {
    constructor(props){
        super(props), this.mediaInstance = {}, this.state = {}, this.videoControlsWrapperRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createRef(), this.unbindKeyDown = null, this.getDataConsumerMark = ()=>this.props.node.marks.find((m)=>m.type.name === 'dataConsumer'), this.getDataConsumerSource = (props = this.props)=>{
            var _props$node$marks$fin;
            return (_props$node$marks$fin = props.node.marks.find((mark)=>mark.type.name === 'dataConsumer')) === null || _props$node$marks$fin === void 0 || (_props$node$marks$fin = _props$node$marks$fin.attrs.sources) === null || _props$node$marks$fin === void 0 ? void 0 : _props$node$marks$fin[0];
        }, this.emitMediaRenderEvent = (event, props = this.props)=>{
            var _props$mediaOptions, _props$mediaOptions$o;
            (_props$mediaOptions = props.mediaOptions) === null || _props$mediaOptions === void 0 || (_props$mediaOptions$o = _props$mediaOptions.onMediaRenderEvent) === null || _props$mediaOptions$o === void 0 || _props$mediaOptions$o.call(_props$mediaOptions, {
                ...event,
                dataConsumerSource: this.getDataConsumerSource(props),
                mediaId: props.node.attrs.id,
                mediaInstance: this.mediaInstance
            });
        }, this.setViewMediaClientConfig = async ()=>{
            // mediaProvider is Promise<MediaProvider>, so await it first to get the actual provider
            const mediaProvider = await this.props.mediaProvider;
            if (mediaProvider) {
                const viewMediaClientConfig = mediaProvider.viewMediaClientConfig;
                const viewAndUploadMediaClientConfig = mediaProvider.viewAndUploadMediaClientConfig;
                // Only update state if new configs are available and different from current state
                if (viewMediaClientConfig && this.state.viewMediaClientConfig !== viewMediaClientConfig || viewAndUploadMediaClientConfig && this.state.viewAndUploadMediaClientConfig !== viewAndUploadMediaClientConfig) this.setState({
                    viewMediaClientConfig: viewMediaClientConfig,
                    viewAndUploadMediaClientConfig: viewAndUploadMediaClientConfig
                });
            }
        }, this.selectMediaSingleFromCard = ({ event: event })=>{
            var _this$props$pluginInj;
            this.selectMediaSingle(event);
            // In edit mode (node content wrapper has contenteditable set to true), link redirection is disabled by default
            // We need to call "stopPropagation" here in order to prevent in editor view mode, the browser from navigating to
            // another URL if the media node is wrapped in a link mark.
            if (this.props.isViewOnly && (0, $8qHhy.areToolbarFlagsEnabled)(Boolean((_this$props$pluginInj = this.props.pluginInjectionApi) === null || _this$props$pluginInj === void 0 ? void 0 : _this$props$pluginInj.toolbar))) event.preventDefault();
        }, this.selectMediaSingle = (event)=>{
            const propPos = this.props.getPos();
            if (typeof propPos !== 'number') return;
            // NOTE: This does not prevent the link navigation in the editor view mode, .preventDefault is needed (see selectMediaSingleFromCard)
            // Hence it should be removed
            // We need to call "stopPropagation" here in order to prevent the browser from navigating to
            // another URL if the media node is wrapped in a link mark.
            if ((0, $797yE.editorExperiment)('platform_editor_controls', 'control')) event.stopPropagation();
            const { state: state } = this.props.view;
            if (event.shiftKey) {
                // don't select text if there is current selection in a table (as this would override selected cells)
                if (state.selection instanceof (0, $2E7OD.CellSelection)) return;
                (0, $dEhT6.setTextSelection)(this.props.view, state.selection.from < propPos ? state.selection.from : propPos - 1, // + 3 needed for offset of the media inside mediaSingle and cursor to make whole mediaSingle selected
                state.selection.to > propPos ? state.selection.to : propPos + 2);
            } else (0, $j2OLx.setNodeSelection)(this.props.view, propPos - 1);
        }, this.getMediaSettings = (0, $57l7A.default)((viewAndUploadMediaClientConfig, isViewOnly)=>{
            return {
                canUpdateVideoCaptions: (0, $gdUUy.fg)('platform_media_video_captions') ? !!viewAndUploadMediaClientConfig && !isViewOnly : false
            };
        }), /**
   * Media written straight into the document arrives without intrinsic dimensions, and the
   * fetch that would supply them resolves `false` while the file is still processing. Only
   * editor-driven uploads get a second attempt, from the plugin's media-state listener, so
   * otherwise the card would keep its placeholder ratio forever. The preview rendering is the
   * one moment the file is guaranteed ready, so the fetch is retried there.
   */ this.fetchMissingDimensions = async ()=>{
            var _pluginInjectionApi$w;
            const { node: node, view: view, mediaProvider: mediaProvider, contextIdentifierProvider: contextIdentifierProvider, mediaOptions: mediaOptions, pluginInjectionApi: pluginInjectionApi } = this.props;
            if (node.attrs.type === 'external' || !node.attrs.id || node.attrs.width && node.attrs.height) return;
            const updater = (0, $eUcZO.createMediaNodeUpdater)({
                view: view,
                mediaProvider: mediaProvider,
                contextIdentifierProvider: contextIdentifierProvider,
                node: node,
                mediaOptions: // Carries `allowRemoteDimensionsFetch`, so surfaces that cannot reach the media
                // APIs get the default dimensions back instead of a request.
                mediaOptions,
                isMediaSingle: true,
                lineLength: pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$w = pluginInjectionApi.width) === null || _pluginInjectionApi$w === void 0 || (_pluginInjectionApi$w = _pluginInjectionApi$w.sharedState.currentState()) === null || _pluginInjectionApi$w === void 0 ? void 0 : _pluginInjectionApi$w.lineLength
            });
            try {
                const dimensions = await updater.getRemoteDimensions();
                if (dimensions) updater.updateDimensions(dimensions);
            } catch  {
            // Leaves the card at its placeholder ratio, which the reveal's own timeout covers.
            }
        }, this.onPreviewRender = (fileId)=>{
            this.emitMediaRenderEvent({
                renderedMediaId: fileId,
                type: 'preview-rendered'
            });
            // Only tracked where the reveal uses it. Every media card in every editor calls this,
            // and the extra render it would otherwise trigger is not free.
            if (this.hasGeneratedMediaMotion && this.state.previewRenderedFileId !== fileId) {
                this.setState({
                    previewRenderedFileId: fileId
                });
                this.fetchMissingDimensions();
            }
        }, this.onError = (reason)=>{
            var _this$props$api;
            // The card is already showing its error treatment, so let the reveal open onto
            // that instead of waiting out its timeout.
            this.setState({
                failedFileId: this.props.node.attrs.id
            });
            this.emitMediaRenderEvent({
                reason: reason,
                type: 'error'
            });
            const nestedUnder = this.getNestedUnder();
            (_this$props$api = this.props.api) === null || _this$props$api === void 0 || _this$props$api.media.actions.handleMediaNodeRenderError(this.props.node, reason, nestedUnder);
        }, /**
   * This function checks if the media node is nested under a certain nodes, and if so,
   * returns the name of the parent node type. This is used for providing more context in media render errors.
   * @returns
   */ this.getNestedUnder = ()=>{
            const pos = this.props.getPos();
            if (typeof pos !== 'number') return undefined;
            const { doc: doc, schema: schema } = this.props.view.state;
            const { bodiedSyncBlock: bodiedSyncBlock } = schema.nodes;
            if (!bodiedSyncBlock) return undefined;
            const resolvedPos = doc.resolve(pos);
            const bodiedSyncBlockNode = (0, $gab48.findParentNodeClosestToPos)(resolvedPos, (currentNode)=>currentNode.type === bodiedSyncBlock);
            return bodiedSyncBlockNode === null || bodiedSyncBlockNode === void 0 ? void 0 : bodiedSyncBlockNode.node.type.name;
        }, this.onFullscreenChange = (fullscreen)=>{
            var _this$mediaPluginStat6;
            (_this$mediaPluginStat6 = this.mediaPluginState) === null || _this$mediaPluginStat6 === void 0 || _this$mediaPluginStat6.updateAndDispatch({
                isFullscreen: fullscreen
            });
        }, this.handleNewNode = (props)=>{
            var _this$mediaPluginStat7;
            const { node: node } = props;
            (_this$mediaPluginStat7 = this.mediaPluginState) === null || _this$mediaPluginStat7 === void 0 || _this$mediaPluginStat7.handleMediaNodeMount(node, ()=>this.props.getPos());
        };
        const { view: view, syncProvider: syncProvider } = this.props;
        this.mediaPluginState = (0, $7ICJC.stateKey).getState(view.state);
        // Initialize state from syncProvider (available on both server and client for SSR)
        if (syncProvider) this.state = {
            viewMediaClientConfig: syncProvider.viewMediaClientConfig,
            viewAndUploadMediaClientConfig: syncProvider.viewAndUploadMediaClientConfig
        };
    }
    shouldComponentUpdate(nextProps, nextState) {
        var _this$props$mediaOpti, _nextProps$mediaOptio;
        const hasNewViewMediaClientConfig = !this.state.viewMediaClientConfig && nextState.viewMediaClientConfig;
        const hasNewViewAndUploadMediaClientConfig = !this.state.viewAndUploadMediaClientConfig && nextState.viewAndUploadMediaClientConfig;
        if (this.props.selected !== nextProps.selected || this.props.node.attrs.id !== nextProps.node.attrs.id || this.props.node.attrs.collection !== nextProps.node.attrs.collection || // Patched in asynchronously once media services report the real size.
        this.props.node.attrs.width !== nextProps.node.attrs.width || this.props.node.attrs.height !== nextProps.node.attrs.height || this.props.isAIGenerating !== nextProps.isAIGenerating || this.props.maxDimensions.height !== nextProps.maxDimensions.height || this.props.maxDimensions.width !== nextProps.maxDimensions.width || this.props.contextIdentifierProvider !== nextProps.contextIdentifierProvider || this.props.isLoading !== nextProps.isLoading || this.props.isViewOnly !== nextProps.isViewOnly || this.props.mediaProvider !== nextProps.mediaProvider || this.props.syncProvider !== nextProps.syncProvider || this.getDataConsumerSource() !== this.getDataConsumerSource(nextProps) || ((_this$props$mediaOpti = this.props.mediaOptions) === null || _this$props$mediaOpti === void 0 ? void 0 : _this$props$mediaOpti.onMediaRenderEvent) !== ((_nextProps$mediaOptio = nextProps.mediaOptions) === null || _nextProps$mediaOptio === void 0 ? void 0 : _nextProps$mediaOptio.onMediaRenderEvent) || this.state.previewRenderedFileId !== nextState.previewRenderedFileId || this.state.failedFileId !== nextState.failedFileId || hasNewViewMediaClientConfig || hasNewViewAndUploadMediaClientConfig) return true;
        return false;
    }
    async componentDidMount() {
        var _dataConsumerMark$att;
        this.handleNewNode(this.props);
        this.emitMediaRenderEvent({
            type: 'mounted'
        });
        const { node: node, pluginInjectionApi: pluginInjectionApi } = this.props;
        const dataConsumerMark = this.getDataConsumerMark();
        const infographicType = dataConsumerMark === null || dataConsumerMark === void 0 || (_dataConsumerMark$att = dataConsumerMark.attrs.sources) === null || _dataConsumerMark$att === void 0 ? void 0 : _dataConsumerMark$att[0];
        if (infographicType) {
            var _pluginInjectionApi$a;
            pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$a = pluginInjectionApi.analytics) === null || _pluginInjectionApi$a === void 0 || _pluginInjectionApi$a.actions.fireAnalyticsEvent({
                action: (0, $g6Qq4.ACTION).RENDERED,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).MEDIA,
                actionSubjectId: node.attrs.id,
                eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
                attributes: {
                    infographicType: infographicType,
                    pageMode: 'edit',
                    mediaId: node.attrs.id
                }
            });
        }
        const { contextIdentifierProvider: contextIdentifierProvider } = this.props;
        this.setState({
            contextIdentifierProvider: await contextIdentifierProvider
        });
        await this.setViewMediaClientConfig();
    }
    componentWillUnmount() {
        var _this$mediaPluginStat;
        const { node: node } = this.props;
        this.emitMediaRenderEvent({
            type: 'unmounted'
        });
        (_this$mediaPluginStat = this.mediaPluginState) === null || _this$mediaPluginStat === void 0 || _this$mediaPluginStat.handleMediaNodeUnmount(node);
        if (this.unbindKeyDown && typeof this.unbindKeyDown === 'function') this.unbindKeyDown();
    }
    componentDidUpdate(prevProps) {
        var _prevProps$mediaOptio, _this$props$mediaOpti2, _this$mediaPluginStat3;
        if (prevProps.node.attrs.id !== this.props.node.attrs.id || this.getDataConsumerSource(prevProps) !== this.getDataConsumerSource() || ((_prevProps$mediaOptio = prevProps.mediaOptions) === null || _prevProps$mediaOptio === void 0 ? void 0 : _prevProps$mediaOptio.onMediaRenderEvent) !== ((_this$props$mediaOpti2 = this.props.mediaOptions) === null || _this$props$mediaOpti2 === void 0 ? void 0 : _this$props$mediaOpti2.onMediaRenderEvent)) {
            this.emitMediaRenderEvent({
                type: 'unmounted'
            }, prevProps);
            this.emitMediaRenderEvent({
                type: 'mounted'
            });
        }
        if (prevProps.node.attrs.id !== this.props.node.attrs.id) {
            var _this$mediaPluginStat2;
            (_this$mediaPluginStat2 = this.mediaPluginState) === null || _this$mediaPluginStat2 === void 0 || _this$mediaPluginStat2.handleMediaNodeUnmount(prevProps.node);
            this.handleNewNode(this.props);
        }
        (_this$mediaPluginStat3 = this.mediaPluginState) === null || _this$mediaPluginStat3 === void 0 || _this$mediaPluginStat3.updateElement();
        this.setViewMediaClientConfig();
        // this.videoControlsWrapperRef is null on componentDidMount. We need to wait until it has value
        if (this.videoControlsWrapperRef && this.videoControlsWrapperRef.current) {
            var _this$mediaPluginStat4;
            if (!((_this$mediaPluginStat4 = this.mediaPluginState) !== null && _this$mediaPluginStat4 !== void 0 && _this$mediaPluginStat4.videoControlsWrapperRef)) {
                var _this$mediaPluginStat5;
                this.bindKeydown();
                (_this$mediaPluginStat5 = this.mediaPluginState) === null || _this$mediaPluginStat5 === void 0 || _this$mediaPluginStat5.updateAndDispatch({
                    videoControlsWrapperRef: this.videoControlsWrapperRef.current
                });
            }
        }
    }
    bindKeydown() {
        var _this$videoControlsWr2;
        const onKeydown = (event)=>{
            if (event.key === 'Tab') {
                var _this$videoControlsWr;
                // Add focus trap for controls panel
                let firstElement;
                let lastElement;
                const focusableElements = (_this$videoControlsWr = this.videoControlsWrapperRef) === null || _this$videoControlsWr === void 0 || (_this$videoControlsWr = _this$videoControlsWr.current) === null || _this$videoControlsWr === void 0 ? void 0 : _this$videoControlsWr.querySelectorAll('button, input, [tabindex]:not([tabindex="-1"])');
                if (focusableElements && focusableElements.length) {
                    // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    firstElement = focusableElements[0];
                    // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    lastElement = focusableElements[focusableElements.length - 1];
                    if (event.shiftKey && document.activeElement === firstElement) {
                        event.preventDefault();
                        lastElement.focus();
                    } else if (!event.shiftKey && document.activeElement === lastElement) {
                        var _firstElement;
                        event.preventDefault();
                        (_firstElement = firstElement) === null || _firstElement === void 0 || _firstElement.focus();
                    }
                }
            }
        };
        if ((_this$videoControlsWr2 = this.videoControlsWrapperRef) !== null && _this$videoControlsWr2 !== void 0 && _this$videoControlsWr2.current) this.unbindKeyDown = (0, $bAB3U.bind)(this.videoControlsWrapperRef.current, {
            type: 'keydown',
            listener: onKeydown,
            options: {
                capture: true,
                passive: false
            }
        });
    }
    /**
   * Surface opt-in first, so surfaces that never ask for the motion are not exposed to the
   * gate. The node type is checked after it, so every node on an opted-in surface counts
   * towards the same exposure population.
   */ get hasGeneratedMediaMotion() {
        var _this$props$mediaOpti3;
        return !!((_this$props$mediaOpti3 = this.props.mediaOptions) !== null && _this$props$mediaOpti3 !== void 0 && _this$props$mediaOpti3.allowAIGeneratedMediaMotion) && (0, $gdUUy.fg)('aifc_page_create_defer_generated_visuals') && // File-backed only: `ExternalImageCard` reports neither its rendered preview nor its
        // dimensions, so an external node could only ever open on the reveal's timeout.
        this.props.node.attrs.type !== 'external';
    }
    render() {
        var _dataConsumerMark$att2;
        const { node: node, selected: selected, originalDimensions: originalDimensions, isLoading: isLoading, maxDimensions: maxDimensions, mediaOptions: mediaOptions } = this.props;
        const borderMark = node.marks.find((m)=>m.type.name === 'border');
        const dataConsumerMark = this.getDataConsumerMark();
        const { viewMediaClientConfig: viewMediaClientConfig, viewAndUploadMediaClientConfig: viewAndUploadMediaClientConfig, contextIdentifierProvider: contextIdentifierProvider } = this.state;
        const { id: id, type: type, collection: collection, url: url, alt: alt } = node.attrs;
        // Check if we have any media client config available (syncProvider, state, or upload config)
        const hasNoMediaClientConfig = !viewMediaClientConfig && ((0, $gdUUy.fg)('platform_media_video_captions') ? !viewAndUploadMediaClientConfig : true);
        const hasGeneratedMediaMotion = this.hasGeneratedMediaMotion;
        // Opening before the real dimensions land would animate to the wrong height and snap
        // when they correct. Nodes that never get them fall through to the reveal's timeout.
        //
        // A terminal error is readiness too: the card is already showing its error treatment,
        // so the space opens onto that rather than hiding it until the timeout.
        const isRevealReady = this.state.failedFileId === id || this.state.previewRenderedFileId === id && !!node.attrs.width && !!node.attrs.height;
        if (isLoading || type !== 'external' && hasNoMediaClientConfig) return /*#__PURE__*/ (0, $dc70d.jsx)((0, $7Sg1S.GeneratedMediaReveal), {
            isEnabled: hasGeneratedMediaMotion,
            isReady: isRevealReady,
            mediaKey: id,
            children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $e35II.MediaCardWrapper), {
                dimensions: originalDimensions,
                borderWidth: borderMark === null || borderMark === void 0 ? void 0 : borderMark.attrs.size,
                selected: selected,
                children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $b2ees.CardLoading), {
                    interactionName: "editor-media-card-loading"
                })
            })
        });
        const contextId = contextIdentifierProvider && contextIdentifierProvider.objectId;
        const identifier = type === 'external' ? {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            dataURI: url,
            name: url,
            mediaItemType: 'external-image'
        } : {
            id: id,
            mediaItemType: 'file',
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            collectionName: collection
        };
        const resolvedViewAndUploadMediaClientConfig = (0, $gdUUy.fg)('platform_media_video_captions') ? viewAndUploadMediaClientConfig : undefined;
        // mediaClientConfig is not needed for "external" case. So we have to cheat here.
        // there is a possibility mediaClientConfig will be part of a identifier,
        // so this might be not an issue
        const mediaClientConfig = resolvedViewAndUploadMediaClientConfig || viewMediaClientConfig || {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            authProvider: ()=>({})
        };
        const ssr = 'client';
        return /*#__PURE__*/ (0, $dc70d.jsx)((0, $7Sg1S.GeneratedMediaReveal), {
            isEnabled: hasGeneratedMediaMotion,
            isReady: isRevealReady,
            mediaKey: id,
            children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $e35II.MediaCardWrapper), {
                dimensions: originalDimensions,
                onContextMenu: this.selectMediaSingle,
                borderWidth: borderMark === null || borderMark === void 0 ? void 0 : borderMark.attrs.size,
                selected: selected,
                children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $dwOcU.default), {
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    data: {
                        [(0, $96Oa5.MEDIA_CONTEXT)]: {
                            border: !!borderMark,
                            // Only defined for remix-generated media (i.e. media nodes with a dataConsumer mark).
                            // Format: "remix:{type}:{subtype}" e.g. "remix:infographic:corporate-doodle"
                            remixSource: dataConsumerMark === null || dataConsumerMark === void 0 || (_dataConsumerMark$att2 = dataConsumerMark.attrs.sources) === null || _dataConsumerMark$att2 === void 0 ? void 0 : _dataConsumerMark$att2[0]
                        }
                    },
                    children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $fyJNx.default), {
                        mediaClientConfig: mediaClientConfig,
                        resizeMode: "stretchy-fit",
                        dimensions: maxDimensions,
                        originalDimensions: originalDimensions,
                        identifier: identifier,
                        selectable: true,
                        selected: selected,
                        disableOverlay: true,
                        onFullscreenChange: this.onFullscreenChange,
                        onClick: this.selectMediaSingleFromCard,
                        useInlinePlayer: mediaOptions && mediaOptions.allowLazyLoading,
                        isLazy: mediaOptions && mediaOptions.allowLazyLoading,
                        featureFlags: mediaOptions && mediaOptions.featureFlags,
                        contextId: contextId,
                        alt: alt,
                        videoControlsWrapperRef: this.videoControlsWrapperRef,
                        ssr: ssr,
                        mediaSettings: this.getMediaSettings(viewAndUploadMediaClientConfig, this.props.isViewOnly),
                        isAIGenerating: !!this.props.isAIGenerating,
                        hasLoadingMotion: hasGeneratedMediaMotion,
                        onPreviewRender: this.onPreviewRender,
                        fallbackMediaNameFetcher: mediaOptions === null || mediaOptions === void 0 ? void 0 : mediaOptions.fallbackMediaNameFetcher,
                        onError: this.onError
                    })
                })
            })
        });
    }
}
const $e109e51a6ccd73f3$var$_default_1 = (0, $7mZGn.withImageLoader)($e109e51a6ccd73f3$export$56a8c4089468c01e);
var $e109e51a6ccd73f3$export$2e2bcd8739ae039 = $e109e51a6ccd73f3$var$_default_1;

});
parcelRegister("7Sg1S", function(module, exports) {
$parcel$export(module.exports, "GeneratedMediaReveal", () => $f1ebbf7da20a2c83$export$c2c3b7612efdd2a3);
/* GeneratedMediaReveal.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");
// A `0fr -> 1fr` grid row opens out to the content's natural height without anyone having to
// measure it, which matters because the card's height comes from an aspect-ratio padding
// further down the tree.
const $f1ebbf7da20a2c83$var$openRow = null;
const $f1ebbf7da20a2c83$var$collapsedStyles = null;
const $f1ebbf7da20a2c83$var$revealStyles = null;
const $f1ebbf7da20a2c83$var$clippedStyles = null;
/**
 * Fail-safe, not a normal path: opens the node even if the preview never reports itself
 * rendered, so a failed or hanging image still ends up visible rather than staying collapsed.
 * Also covers lazy loading, where a card collapsed to zero height may never satisfy the
 * IntersectionObserver that triggers its fetch.
 *
 * Deliberately generous, because opening early is worse than opening late — the space then
 * reveals the card's own loading treatment instead of the image, and an AI-generated image has
 * to be generated, uploaded, processed and fetched first. `data-media-reveal-trigger` shows
 * which path fired; `timeout` in normal use means the readiness signal is broken.
 */ const $f1ebbf7da20a2c83$var$READY_TIMEOUT_MS = 30000;
// Backstop for reduced motion and browsers that don't interpolate grid-template-rows, where no
// animationend fires. Must stay comfortably longer than the reveal, or it cuts it off part way.
const $f1ebbf7da20a2c83$var$REVEAL_TIMEOUT_MS = 1000;
const $f1ebbf7da20a2c83$export$c2c3b7612efdd2a3 = ({ children: children, isEnabled: isEnabled, isReady: isReady, mediaKey: mediaKey })=>{
    const [state, setState] = (0, $bSJIT.useState)('collapsed');
    const [trigger, setTrigger] = (0, $bSJIT.useState)();
    // Reset during render rather than remounting on a `key`, which would also remount the card
    // below and restart its fetch. The reveal's effect only runs while `collapsed`, so without
    // this a replacement would appear at once, having inherited the previous file's `open`.
    const [renderedMediaKey, setRenderedMediaKey] = (0, $bSJIT.useState)(mediaKey);
    if (mediaKey !== renderedMediaKey) {
        setRenderedMediaKey(mediaKey);
        setState('collapsed');
        setTrigger(undefined);
    }
    (0, $bSJIT.useEffect)(()=>{
        if (!isEnabled || state !== 'collapsed') return;
        if (isReady) {
            setTrigger('ready');
            setState('revealing');
            return;
        }
        const timer = setTimeout(()=>{
            setTrigger('timeout');
            setState('revealing');
        }, $f1ebbf7da20a2c83$var$READY_TIMEOUT_MS);
        return ()=>clearTimeout(timer);
    }, [
        isEnabled,
        isReady,
        state
    ]);
    (0, $bSJIT.useEffect)(()=>{
        if (state !== 'revealing') return;
        const timer = setTimeout(()=>setState('open'), $f1ebbf7da20a2c83$var$REVEAL_TIMEOUT_MS);
        return ()=>clearTimeout(timer);
    }, [
        state
    ]);
    if (!isEnabled) return /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, {
        children: children
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        "data-media-reveal": state,
        "data-media-reveal-trigger": trigger,
        onAnimationEnd: (event)=>{
            // The media card runs animations of its own, which bubble through here.
            if (event.target === event.currentTarget) setState('open');
        },
        className: (0, $9fU1q.default)([
            state === 'collapsed' && "_1e0c11p5 _2z0563bf",
            state === 'revealing' && "",
            state === 'revealing' && "_1e0c11p5 _2z05hkll _j7hq8gkt _5sag15uc _1pglindk _1o51eoah _1bumglyw"
        ]),
        children: /*#__PURE__*/ (0, $dc70d.jsx)("div", {
            className: (0, $9fU1q.default)([
                state !== 'open' && "_1reo15vq _18m915vq _1tkeidpf"
            ]),
            children: children
        })
    });
};

});

parcelRegister("e35II", function(module, exports) {
$parcel$export(module.exports, "MediaSingleNodeSelector", () => $f53d142a4e5e305a$export$91aa6761f022a358);
$parcel$export(module.exports, "MediaCardWrapper", () => $f53d142a4e5e305a$export$d307b3919391b84f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $4v4Uu = parcelRequire("4v4Uu");
function $f53d142a4e5e305a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f53d142a4e5e305a$export$91aa6761f022a358 = 'media-single-node';
const $f53d142a4e5e305a$var$absoluteDivStyles = {
    name: "19s8nj4",
    styles: "position:absolute;width:100%;height:100%"
};
const $f53d142a4e5e305a$var$forcedDimensionsStyles = {
    name: "n48rgu",
    styles: "width:100%;position:relative"
};
const $f53d142a4e5e305a$var$pointerCursorStyle = {
    name: "e0dnmk",
    styles: "cursor:pointer"
};
const $f53d142a4e5e305a$export$d307b3919391b84f = ({ dimensions: dimensions, children: children, selected: selected, borderWidth: borderWidth = 0, onContextMenu: onContextMenu })=>{
    const calculatedBorderWidth = selected && borderWidth > 0 ? borderWidth + 1 : borderWidth;
    const borderRadius = `${calculatedBorderWidth + 8}px`;
    return /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        "data-testid": "media-card-wrapper",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "media-card-wrapper",
        css: $f53d142a4e5e305a$var$pointerCursorStyle,
        style: {
            borderColor: `var(--custom-palette-color)`,
            borderWidth: `${calculatedBorderWidth}px`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            borderStyle: 'solid',
            borderRadius: // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            borderRadius
        }
    }, /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        css: $f53d142a4e5e305a$var$forcedDimensionsStyles,
        style: {
            paddingBottom: `${dimensions.height / dimensions.width * 100}%`
        },
        onContextMenuCapture: onContextMenu
    }, borderWidth > 0 && /*#__PURE__*/ (0, $9dQre.jsx)((0, $4v4Uu.MediaBorderGapFiller), {
        borderColor: `var(--custom-palette-color)`
    }), /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        css: $f53d142a4e5e305a$var$absoluteDivStyles
    }, children)));
};

});



parcelRegister("7bQCz", function(module, exports) {
$parcel$export(module.exports, "MediaDropIndicator", () => $dd7f9159dbc0baa7$export$89d17d99130e30ef);
/* MediaDropIndicator.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $lthDJ = parcelRequire("lthDJ");
const $dd7f9159dbc0baa7$var$styles = {
    block: "_1e0c1ule _kqswh2mm _4t3iidpf _lcxvglyw",
    inline: "_1e0c1o8l _kqswstnw _1bsbidpf _4t3i1j6v _lcxvglyw"
};
const $dd7f9159dbc0baa7$export$89d17d99130e30ef = ({ inline: inline })=>/*#__PURE__*/ (0, $dc70d.jsx)("span", {
        "aria-hidden": "true",
        "data-testid": "media-drop-indicator",
        className: (0, $9fU1q.default)([
            !inline && $dd7f9159dbc0baa7$var$styles.block,
            inline && $dd7f9159dbc0baa7$var$styles.inline
        ]),
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $lthDJ.DropIndicator), {
            edge: inline ? 'left' : 'top'
        })
    });

});

parcelRegister("aLFwY", function(module, exports) {
$parcel$export(module.exports, "ACTIONS", () => $e3bc397572928943$export$92a1a3b7554e9387);
const $e3bc397572928943$export$92a1a3b7554e9387 = {
    SHOW_MEDIA_VIEWER: 'SHOW_MEDIA_VIEWER',
    HIDE_MEDIA_VIEWER: 'HIDE_MEDIA_VIEWER',
    TRACK_MEDIA_PASTE: 'TRACK_MEDIA_PASTE',
    SHOW_IMAGE_EDITOR: 'SHOW_IMAGE_EDITOR',
    HIDE_IMAGE_EDITOR: 'HIDE_IMAGE_EDITOR'
};

});

parcelRegister("8w5gF", function(module, exports) {
$parcel$export(module.exports, "mediaDropSelection", () => $34049484c7c80a65$export$2927f371755e90c5);
$parcel$export(module.exports, "findMediaDropPosition", () => $34049484c7c80a65$export$80c7df9d49a81913);
$parcel$export(module.exports, "findMediaDropReplacement", () => $34049484c7c80a65$export$b7a0ab2dd3467639);
$parcel$export(module.exports, "MediaDropTargets", () => $34049484c7c80a65$export$edba94eb7d982832);

var $j7pt0 = parcelRequire("j7pt0");

var $kW8qW = parcelRequire("kW8qW");

var $cw0wu = parcelRequire("cw0wu");

var $3DNV7 = parcelRequire("3DNV7");

var $kWqd8 = parcelRequire("kWqd8");
const $34049484c7c80a65$export$2927f371755e90c5 = (doc, pos)=>{
    const $pos = doc.resolve(pos);
    return $pos.parent.inlineContent ? (0, $cw0wu.TextSelection).create(doc, pos) : new (0, $j7pt0.GapCursorSelection)($pos);
};
const $34049484c7c80a65$export$80c7df9d49a81913 = (view, coords, fileTypes, mediaOptions)=>{
    if (!view.editable || view.dragging || fileTypes.length === 0) return;
    const rect = view.dom.getBoundingClientRect();
    const hit = view.posAtCoords({
        left: Math.max(rect.left + 1, Math.min(coords.left, rect.right - 1)),
        top: Math.max(rect.top + 1, Math.min(coords.top, rect.bottom - 1))
    });
    if (!hit) return;
    const { doc: doc, schema: schema } = view.state;
    const targetState = (0, $cw0wu.EditorState).create({
        doc: doc,
        schema: schema,
        selection: $34049484c7c80a65$export$2927f371755e90c5(doc, hit.pos)
    });
    const supportedOptions = schema.nodes.mediaInline ? mediaOptions : {
        ...mediaOptions,
        featureFlags: {
            ...mediaOptions === null || mediaOptions === void 0 ? void 0 : mediaOptions.featureFlags,
            mediaInline: false
        }
    };
    const insertionTypes = new Set(Array.from(new Set(fileTypes), (fileType)=>(0, $kWqd8.getMediaNodeInsertionType)(targetState, supportedOptions, fileType)));
    const slices = Array.from(insertionTypes).flatMap((insertionType)=>{
        let node;
        if (insertionType === 'inline') node = schema.nodes.mediaInline.create();
        else {
            const container = insertionType === 'block' ? schema.nodes.mediaSingle : schema.nodes.mediaGroup;
            if (!container || !schema.nodes.media) return [];
            node = container.create(null, schema.nodes.media.create({
                type: 'file'
            }));
        }
        return new (0, $kW8qW.Slice)((0, $kW8qW.Fragment).from(node), 0, 0);
    });
    if (slices.length !== insertionTypes.size) return;
    for (const slice of slices){
        const pos = (0, $3DNV7.dropPoint)(doc, hit.pos, slice);
        if (pos !== null && slices.every((content)=>{
            const alreadyValidated = content === slice && pos === hit.pos;
            return alreadyValidated || (0, $3DNV7.dropPoint)(doc, pos, content) === pos;
        })) return pos;
    }
    return;
};
const $34049484c7c80a65$export$b7a0ab2dd3467639 = (view, event, fileTypes)=>{
    if (!view.editable || view.dragging || fileTypes.length !== 1 || !fileTypes[0].startsWith('image/')) return;
    if (!(event.target instanceof Element)) return;
    const mediaDom = event.target.closest('[data-prosemirror-node-name="media"], [data-node-type="media"]');
    if (!mediaDom || !view.dom.contains(mediaDom)) return;
    const card = mediaDom.querySelector('.media-card-wrapper') ?? mediaDom;
    const rect = card.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX >= rect.right || event.clientY < rect.top || event.clientY >= rect.bottom) return;
    const $pos = view.state.doc.resolve(view.posAtDOM(mediaDom, 0));
    if ($pos.parent.type !== view.state.schema.nodes.mediaSingle) return;
    const media = $pos.parent.firstChild;
    if (!media || media.type !== view.state.schema.nodes.media) return;
    const mimeType = media.attrs.__fileMimeType;
    const hasImagePreview = !!card.querySelector('img[data-fileid], img[data-testid="media-image"], img[data-testid="media-card-svg"]') && !card.querySelector('video, [data-testid="media-card-play-button-wrapper"]');
    const isImage = mimeType ? mimeType.startsWith('image/') : media.attrs.type === 'external' || hasImagePreview;
    return isImage ? {
        pos: $pos.before(),
        media: media
    } : undefined;
};
const $34049484c7c80a65$var$mapReplacement = (replacement, mapping)=>{
    if (!replacement) return;
    const mapped = mapping.mapResult(replacement.pos, 1);
    return mapped.deleted ? undefined : {
        ...replacement,
        pos: mapped.pos
    };
};
const $34049484c7c80a65$var$currentReplacement = (replacement, doc)=>{
    if (!replacement) return;
    const node = doc.nodeAt(replacement.pos);
    const media = node === null || node === void 0 ? void 0 : node.firstChild;
    const original = replacement.media;
    if ((node === null || node === void 0 ? void 0 : node.type.name) === 'mediaSingle' && (media === null || media === void 0 ? void 0 : media.type) === original.type && media.attrs.id === original.attrs.id && media.attrs.collection === original.attrs.collection && media.attrs.type === original.attrs.type && media.attrs.url === original.attrs.url) return replacement;
    return;
};
class $34049484c7c80a65$export$edba94eb7d982832 {
    start(traceId, pos, replacement) {
        const batch = {
            pos: pos,
            replacement: replacement,
            files: new Set(),
            prepared: false
        };
        this.batches.set(traceId, batch);
        return ()=>{
            batch.prepared = true;
            this.prune();
        };
    }
    register(traceId, fileIds) {
        const batch = this.batches.get(traceId);
        if (!batch) return;
        for (const id of fileIds){
            batch.files.add(id);
            this.files.set(id, batch);
        }
    }
    positionFor(fileId) {
        var _this$files$get;
        return (_this$files$get = this.files.get(fileId)) === null || _this$files$get === void 0 ? void 0 : _this$files$get.pos;
    }
    replacementFor(fileId, doc) {
        var _this$files$get2;
        return $34049484c7c80a65$var$currentReplacement((_this$files$get2 = this.files.get(fileId)) === null || _this$files$get2 === void 0 ? void 0 : _this$files$get2.replacement, doc);
    }
    hoverReplacementFor(doc) {
        return $34049484c7c80a65$var$currentReplacement(this.hoverReplacement, doc);
    }
    clearHover() {
        this.hover = undefined;
        this.hoverReplacement = undefined;
    }
    inserted(fileId) {
        var _this$files$get3;
        (_this$files$get3 = this.files.get(fileId)) === null || _this$files$get3 === void 0 || _this$files$get3.files.delete(fileId);
        this.files.delete(fileId);
        this.prune();
    }
    map(mapping) {
        if (mapping.maps.length === 0) return;
        if (this.hover !== undefined) this.hover = mapping.map(this.hover, 1);
        this.hoverReplacement = $34049484c7c80a65$var$mapReplacement(this.hoverReplacement, mapping);
        for (const batch of this.batches.values()){
            batch.pos = mapping.map(batch.pos, 1);
            batch.replacement = $34049484c7c80a65$var$mapReplacement(batch.replacement, mapping);
        }
    }
    clear() {
        this.clearHover();
        this.batches.clear();
        this.files.clear();
    }
    prune() {
        for (const [id, batch] of this.batches)if (batch.prepared && batch.files.size === 0) this.batches.delete(id);
    }
    constructor(){
        this.batches = new Map();
        this.files = new Map();
    }
}

});

parcelRegister("1cWyg", function(module, exports) {
$parcel$export(module.exports, "MediaTaskManager", () => $b602c661f94e7485$export$8e609ae1a23dff23);
class $b602c661f94e7485$export$8e609ae1a23dff23 {
    constructor(){
        this.pendingTask = Promise.resolve(null);
        this.taskMap = new Map();
        this.cancelPendingTask = (id)=>{
            const task = this.taskMap.get(id);
            if (task && !task.cancelController.signal.aborted) task.cancelController.abort();
        };
        // Ignored via go/ees005
        // eslint-disable-next-line require-await
        this.waitForPendingTasks = async (timeout, lastTask)=>{
            if (lastTask && this.pendingTask === lastTask) return lastTask;
            const chainedPromise = this.pendingTask.then(()=>// Call ourselves to make sure that no new pending tasks have been
                // added before the current promise has resolved.
                this.waitForPendingTasks(undefined, this.pendingTask));
            if (!timeout) return chainedPromise;
            let rejectTimeout;
            const timeoutPromise = new Promise((_resolve, reject)=>{
                rejectTimeout = window.setTimeout(()=>reject(new Error(`Media operations did not finish in ${timeout} ms`)), timeout);
            });
            return Promise.race([
                timeoutPromise,
                chainedPromise.then((value)=>{
                    clearTimeout(rejectTimeout);
                    return value;
                })
            ]);
        };
        this.resumePendingTask = (id)=>{
            const mediaTask = this.taskMap.get(id);
            if (mediaTask && mediaTask.cancelController.signal.aborted) this.addPendingTask(mediaTask.task, id);
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.addPendingTask = (task, id)=>{
            let currentTask = task;
            if (id) {
                const cancelController = new AbortController();
                const signal = cancelController.signal;
                this.taskMap.set(id, {
                    task: task,
                    cancelController: cancelController
                });
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                currentTask = new Promise((resolve)=>{
                    task.then(resolve, resolve).finally(()=>{
                        this.taskMap.delete(id);
                    });
                    signal.onabort = ()=>{
                        resolve(null);
                    };
                });
            }
            // Chain the previous promise with a new one for this media item
            const currentPendingTask = this.pendingTask;
            const pendingPromise = ()=>currentPendingTask;
            this.pendingTask = currentTask.then(pendingPromise, pendingPromise);
            return this.pendingTask;
        };
    }
}

});

parcelRegister("fxLWg", function(module, exports) {
$parcel$export(module.exports, "default", () => $58f54a11cce16f6c$export$2e2bcd8739ae039);

var $3q3fP = parcelRequire("3q3fP");
class $58f54a11cce16f6c$export$2e2bcd8739ae039 {
    constructor(pickerType, config, pickerConfig, analyticsName){
        this.config = config;
        this.pickerConfig = pickerConfig;
        this.onDragListeners = [];
        this.onStartListeners = [];
        this.eventListeners = {};
        this.handleUploadPreviewUpdate = (event)=>{
            const { file: file, preview: preview } = event;
            //check if upload-error was called before upload-preview-update
            const isErroredFile = this.erroredFiles.has(file.id);
            const { dimensions: dimensions, scaleFactor: scaleFactor } = (0, $3q3fP.isImagePreview)(preview) ? preview : {
                dimensions: undefined,
                scaleFactor: undefined
            };
            const state = {
                id: file.id,
                fileName: file.name,
                fileSize: file.size,
                fileMimeType: file.type,
                collection: file.collectionName,
                dimensions: dimensions,
                scaleFactor: scaleFactor,
                status: isErroredFile ? 'error' : undefined
            };
            this.eventListeners[file.id] = [];
            this.onStartListeners.forEach((cb)=>cb(state, (evt)=>this.subscribeStateChanged(file, evt), this.analyticsName || this.pickerType));
        };
        this.subscribeStateChanged = (file, onStateChanged)=>{
            const subscribers = this.eventListeners[file.id];
            if (!subscribers) return;
            subscribers.push(onStateChanged);
        };
        this.handleUploadError = ({ error: error, fileId: fileId })=>{
            const listeners = this.eventListeners[fileId];
            this.erroredFiles.add(fileId);
            if (!listeners) return;
            listeners.forEach((cb)=>cb({
                    id: fileId,
                    status: 'error',
                    error: error && {
                        description: error.description,
                        name: error.name
                    }
                }));
            // remove listeners
            delete this.eventListeners[fileId];
        };
        this.handleMobileUploadEnd = (event)=>{
            const { file: file } = event;
            const listeners = this.eventListeners[file.id];
            if (!listeners) return;
            listeners.forEach((cb)=>cb({
                    id: file.id,
                    status: 'mobile-upload-end',
                    fileMimeType: file.type,
                    collection: file.collectionName,
                    publicId: file.publicId
                }));
        };
        this.handleReady = (event)=>{
            const { file: file } = event;
            const listeners = this.eventListeners[file.id];
            if (!listeners) return;
            listeners.forEach((cb)=>cb({
                    id: file.id,
                    status: 'ready'
                }));
            // remove listeners
            delete this.eventListeners[file.id];
        };
        this.pickerType = pickerType;
        this.analyticsName = analyticsName;
        this.erroredFiles = new Set();
    }
    // Ignored via go/ees005
    // eslint-disable-next-line require-await
    async init() {
        let picker;
        if (this.pickerType === 'customMediaPicker') picker = this.picker = this.pickerConfig;
        if (!picker) return this;
        picker.on('upload-preview-update', this.handleUploadPreviewUpdate);
        picker.on('upload-end', this.handleReady);
        picker.on('upload-error', this.handleUploadError);
        picker.on('mobile-upload-end', this.handleMobileUploadEnd);
        return this;
    }
    get type() {
        return this.pickerType;
    }
    get mediaPicker() {
        return this.picker;
    }
    destroy() {
        const { picker: picker } = this;
        if (!picker) return;
        picker.removeAllListeners('upload-preview-update');
        picker.removeAllListeners('upload-end');
        picker.removeAllListeners('upload-error');
        this.onStartListeners = [];
        this.onDragListeners = [];
    }
    setUploadParams(params) {
        if (this.picker) this.picker.setUploadParams(params);
    }
    onNewMedia(cb) {
        this.onStartListeners.push(cb);
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onDrag(cb) {
        this.onDragListeners.push(cb);
    }
}

});



parcelRegister("eTAAh", function(module, exports) {
$parcel$export(module.exports, "computeReplacementDisplayWidth", () => $e2bf728d860c3b44$export$e41d0c834cb917d8);

var $5bbjm = parcelRequire("5bbjm");
const $e2bf728d860c3b44$var$MIN_MEDIA_DISPLAY_WIDTH = 24;
const $e2bf728d860c3b44$export$e41d0c834cb917d8 = (targetDisplayHeight, newIntrinsicWidth, newIntrinsicHeight, layout, lineLength)=>{
    if (newIntrinsicHeight <= 0) return $e2bf728d860c3b44$var$MIN_MEDIA_DISPLAY_WIDTH;
    const unclamped = targetDisplayHeight * (newIntrinsicWidth / newIntrinsicHeight);
    const maxWidth = layout === 'full-width' ? (0, $5bbjm.akEditorFullWidthLayoutWidth) : layout === 'wide' ? (0, $5bbjm.akEditorWideLayoutWidth) : lineLength;
    return Math.max($e2bf728d860c3b44$var$MIN_MEDIA_DISPLAY_WIDTH, Math.min(unclamped, maxWidth));
};

});





parcelRegister("8Maqs", function(module, exports) {
$parcel$export(module.exports, "lazyMediaInlineView", () => $036f9e9f625fe86a$export$c4ddfa4daf804695);

var $1qOmx = parcelRequire("1qOmx");

const $036f9e9f625fe86a$export$c4ddfa4daf804695 = (portalProviderAPI, eventDispatcher, providerFactory, api, dispatchAnalyticsEvent, fallbackMediaNameFetcher, intl)=>{
    return (0, $1qOmx.withLazyLoading)({
        nodeName: 'mediaInline',
        getNodeViewOptions: ()=>{},
        loader: ()=>{
            const result = (parcelRequire("1inI1")).then(({ ReactMediaInlineNode: ReactMediaInlineNode })=>{
                return (node, view, getPos)=>{
                    return ReactMediaInlineNode(portalProviderAPI, eventDispatcher, providerFactory, api, dispatchAnalyticsEvent, fallbackMediaNameFetcher, intl)(node, view, getPos);
                };
            });
            return result;
        }
    });
};

});
parcelRegister("1qOmx", function(module, exports) {
$parcel$export(module.exports, "lazyNodeViewDecorationPluginKey", () => $c795f2f38c0e2643$export$325659f41b2239a7);
$parcel$export(module.exports, "withLazyLoading", () => $c795f2f38c0e2643$export$6b97b121e15a69b7);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $cw0wu = parcelRequire("cw0wu");

var $8RKfG = parcelRequire("8RKfG");

var $2v2C3 = parcelRequire("2v2C3");

var $6xfTE = parcelRequire("6xfTE");

const $c795f2f38c0e2643$export$325659f41b2239a7 = new (0, $cw0wu.PluginKey)('lazyNodeViewDecoration');
/**
 * 🧱 Internal: Editor FE Platform
 *
 * Controls which node was scheduled to load the original node view code
 */ const $c795f2f38c0e2643$var$requestedNodesPerEditorView = new WeakMap();
/**
 * 🧱 Internal: Editor FE Platform
 *
 * Caches loaded node view factory functions for each editor view
 */ const $c795f2f38c0e2643$var$resolvedNodesPerEditorView = new WeakMap();
/**
 * 🧱 Internal: Editor FE Platform
 *
 * Stores editorView -> raf to debounce NodeView updates.
 */ const $c795f2f38c0e2643$var$debounceToEditorViewMap = new WeakMap();
const $c795f2f38c0e2643$var$testOnlyIgnoreLazyNodeViewSet = new WeakSet();
function $c795f2f38c0e2643$export$6c7e823c919edf69(view) {
    $c795f2f38c0e2643$var$testOnlyIgnoreLazyNodeViewSet.add(view);
}
const $c795f2f38c0e2643$export$6b97b121e15a69b7 = ({ nodeName: nodeName, loader: loader, getNodeViewOptions: getNodeViewOptions })=>{
    return (node, view, getPos, decorations, innerDecorations)=>{
        var _node$type;
        let requestedNodes = $c795f2f38c0e2643$var$requestedNodesPerEditorView.get(view);
        if (!requestedNodes) {
            requestedNodes = new Map();
            $c795f2f38c0e2643$var$requestedNodesPerEditorView.set(view, requestedNodes);
        }
        const resolvedNodeViews = $c795f2f38c0e2643$var$resolvedNodesPerEditorView.get(view);
        if (!resolvedNodeViews) $c795f2f38c0e2643$var$resolvedNodesPerEditorView.set(view, new Map());
        const wasAlreadyRequested = requestedNodes.has(nodeName);
        if (wasAlreadyRequested) {
            const resolvedNodeView = resolvedNodeViews === null || resolvedNodeViews === void 0 ? void 0 : resolvedNodeViews.get(nodeName);
            if (resolvedNodeView && !$c795f2f38c0e2643$var$testOnlyIgnoreLazyNodeViewSet.has(view)) return resolvedNodeView(node, view, getPos, decorations, innerDecorations);
            return new (0, $6xfTE.LazyNodeView)(node, view, getPos, decorations);
        }
        const loaderPromise = loader().then((nodeViewFuncModule)=>{
            var _resolvedNodesPerEdit;
            const nodeViewFunc = (node, view, getPos, decorations, innerDecorations)=>{
                const nodeView = nodeViewFuncModule(node, view, getPos, decorations, getNodeViewOptions, innerDecorations);
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = nodeView.dom;
                dom.setAttribute('data-vc', `editor-lnv-loaded--${node.type.name}`);
                const pos = getPos();
                if (pos !== undefined) dom.setAttribute('data-editor-lnv-placeholder-replace', (0, $2v2C3.makeNodePlaceholderId)(node.type.name, pos));
                return nodeView;
            };
            (_resolvedNodesPerEdit = $c795f2f38c0e2643$var$resolvedNodesPerEditorView.get(view)) === null || _resolvedNodesPerEdit === void 0 || _resolvedNodesPerEdit.set(nodeName, nodeViewFunc);
            /**
       * Triggering lazyNodeViewDecoration plugin to apply decorations
       * to nodes with newly loaded NodeViews.
       */ const [callbackId, nodeTypes] = $c795f2f38c0e2643$var$debounceToEditorViewMap.get(view) || [
                null,
                new Set()
            ];
            if (callbackId) (0, $8RKfG.cancelCallback)(callbackId);
            nodeTypes.add(node.type.name);
            const nextCallbackId = (0, $8RKfG.scheduleCallback)(()=>{
                $c795f2f38c0e2643$var$debounceToEditorViewMap.set(view, [
                    null,
                    new Set()
                ]);
                const tr = view.state.tr;
                tr.setMeta($c795f2f38c0e2643$export$325659f41b2239a7, {
                    type: 'add',
                    nodeTypes: nodeTypes
                });
                view.dispatch(tr);
            });
            $c795f2f38c0e2643$var$debounceToEditorViewMap.set(view, [
                nextCallbackId,
                nodeTypes
            ]);
            /**
       * END triggering LazyNodeViewDecoration plugin
       */ return nodeViewFunc;
        });
        requestedNodes.set(nodeName, loaderPromise);
        typeof ((_node$type = node.type) === null || _node$type === void 0 || (_node$type = _node$type.spec) === null || _node$type === void 0 ? void 0 : _node$type.toDOM);
        return new (0, $6xfTE.LazyNodeView)(node, view, getPos, decorations);
    };
};

});
parcelRegister("8RKfG", function(module, exports) {
$parcel$export(module.exports, "scheduleCallback", () => $4ca489785478e369$export$4db3c991f22dbc2d);
$parcel$export(module.exports, "cancelCallback", () => $4ca489785478e369$export$b888d8f981c07a46);
const $4ca489785478e369$var$hasIdleCallback = 'requestIdleCallback' in window;
const $4ca489785478e369$export$4db3c991f22dbc2d = (cb, options)=>{
    return $4ca489785478e369$var$hasIdleCallback ? requestIdleCallback(cb, {
        timeout: 5000,
        ...options
    }) : requestAnimationFrame(cb);
};
const $4ca489785478e369$export$b888d8f981c07a46 = (id)=>{
    return $4ca489785478e369$var$hasIdleCallback ? cancelIdleCallback(id) : cancelAnimationFrame(id);
};

});

parcelRegister("2v2C3", function(module, exports) {
$parcel$export(module.exports, "makeNodePlaceholderId", () => $ec57f5ef57310aab$export$f306d9dd555af398);
function $ec57f5ef57310aab$export$f306d9dd555af398(nodeType, pos) {
    return `${nodeType}:${pos}`;
}

});

parcelRegister("6xfTE", function(module, exports) {
$parcel$export(module.exports, "LazyNodeView", () => $5c849204e89c8f15$export$dccb00b9da782c66);

var $8XNPf = parcelRequire("8XNPf");

var $kW8qW = parcelRequire("kW8qW");

var $2v2C3 = parcelRequire("2v2C3");
const $5c849204e89c8f15$var$getEditorLineWidth = (0, (/*@__PURE__*/$parcel$interopDefault($8XNPf)))((view)=>{
    var _view$dom;
    return (_view$dom = view.dom) === null || _view$dom === void 0 ? void 0 : _view$dom.clientWidth;
});
// Copied from ProseMirror NodeView
// https://github.com/ProseMirror/prosemirror-view/blob/cfa73eb969777f63bcb39972594fd4a9110f5a93/src/viewdesc.ts#L1095-L1099
function $5c849204e89c8f15$var$sameOuterDeco(a, b) {
    if (a.length !== b.length) return false;
    for(let i = 0; i < a.length; i++){
        // @ts-expect-error type actually exist on decoration at runtime
        if (!a[i].type) return false;
        // @ts-expect-error type actually exist on decoration at runtime
        if (!a[i].type.eq(b[i].type)) return false;
    }
    return true;
}
class $5c849204e89c8f15$export$dccb00b9da782c66 {
    constructor(node, view, _getPos, outerDeco){
        this.update = (node, outerDeco)=>{
            const prevNode = this.node;
            this.node = node;
            if (!$5c849204e89c8f15$var$sameOuterDeco(outerDeco, this.outerDeco)) return false;
            // Copying some of the default NodeView update behaviour
            // https://github.com/ProseMirror/prosemirror-view/blob/cfa73eb969777f63bcb39972594fd4a9110f5a93/src/viewdesc.ts#L803
            return !this.node.sameMarkup(prevNode);
        };
        var _node$type;
        this.node = node;
        this.outerDeco = outerDeco;
        if (typeof ((_node$type = node.type) === null || _node$type === void 0 || (_node$type = _node$type.spec) === null || _node$type === void 0 ? void 0 : _node$type.toDOM) !== 'function') {
            this.dom = document.createElement('div');
            return;
        }
        const toDOMConfiguration = {
            editorLineWidth: $5c849204e89c8f15$var$getEditorLineWidth(view)
        };
        const fallback = (0, $kW8qW.DOMSerializer).renderSpec(document, node.type.spec.toDOM(node, // We are injecting a second parameter to be used by the toDOM lazy node view implementations
        // @ts-expect-error
        toDOMConfiguration));
        this.dom = fallback.dom;
        this.contentDOM = fallback.contentDOM;
        if (this.dom instanceof HTMLElement) {
            // This attribute is mostly used for debugging purposed
            // It will help us to found out when the node was replaced
            this.dom.setAttribute('data-lazy-node-view', node.type.name);
            // This is used on Libra tests
            // We are using this to make sure all lazy noded were replaced
            // before the test started
            this.dom.setAttribute('data-lazy-node-view-fallback', 'true');
            // This is used by the UFO to identify the node
            this.dom.setAttribute('data-vc', `editor-lnv-fallback--${node.type.name}`);
            const pos = _getPos();
            if (pos !== undefined) // Used for UFO to identify this as a placeholder
            this.dom.setAttribute('data-editor-lnv-placeholder', (0, $2v2C3.makeNodePlaceholderId)(node.type.name, pos));
        }
    }
    ignoreMutation() {
        if (this.node.type.isTextblock) return false;
        return true;
    }
}

});


parcelRegister("1inI1", function(module, exports) {

var $kOunM = parcelRequire("kOunM");
module.exports = Promise.all([
    $kOunM("5dbAT"),
    $kOunM("jpx43")
]).then(()=>parcelRequire('6TSTC'));

});


parcelRegister("2r6Qo", function(module, exports) {
$parcel$export(module.exports, "ReactMediaNode", () => $85a379ba9380feb9$export$a8df8d02db5c2be0);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $bAB3U = parcelRequire("bAB3U");

var $29qUP = parcelRequire("29qUP");

var $fRXfs = parcelRequire("fRXfs");

var $btLjd = parcelRequire("btLjd");

var $2pWL6 = parcelRequire("2pWL6");

var $5beht = parcelRequire("5beht");

var $5bbjm = parcelRequire("5bbjm");

var $18aF1 = parcelRequire("18aF1");

var $kZf5n = parcelRequire("kZf5n");

var $lyZqb = parcelRequire("lyZqb");

var $4sVoN = parcelRequire("4sVoN");

var $jTv7r = parcelRequire("jTv7r");

var $f0ceB = parcelRequire("f0ceB");
const $85a379ba9380feb9$var$selector = (states)=>{
    var _states$mediaState;
    return {
        mediaProvider: (_states$mediaState = states.mediaState) === null || _states$mediaState === void 0 ? void 0 : _states$mediaState.mediaProvider
    };
};
const $85a379ba9380feb9$var$MediaNodeWithProviders = ({ pluginInjectionApi: pluginInjectionApi, innerComponent: innerComponent })=>{
    const { mediaProvider: mediaProvider } = (0, $5beht.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'media'
    ], $85a379ba9380feb9$var$selector);
    const interactionState = (0, $2pWL6.useSharedPluginStateSelector)(pluginInjectionApi, 'interaction.interactionState');
    return innerComponent({
        mediaProvider: mediaProvider ? Promise.resolve(mediaProvider) : undefined,
        interactionState: interactionState
    });
};
function $85a379ba9380feb9$var$isMediaDecorationSpec(decoration) {
    return decoration.spec.type !== undefined && decoration.spec.selected !== undefined;
}
class $85a379ba9380feb9$var$MediaNodeView extends (0, $btLjd.SelectionBasedNodeView) {
    getMediaSingleNode(getPos) {
        const pos = getPos();
        if (typeof pos !== 'number') return null;
        const $pos = this.view.state.doc.resolve(pos);
        // The parent of the media node should be mediaSingle
        if ($pos.parent && $pos.parent.type.name === 'mediaSingle') return $pos.parent;
        return null;
    }
    getMaxWidthFromMediaSingleNode(mediaSingleNode) {
        const { width: widthAttr, widthType: widthTypeAttr, layout: layoutAttr } = mediaSingleNode.attrs;
        // for extended mediaSingle nodes with width and widthType attributes ( default behaviour )
        if (widthAttr && widthTypeAttr === 'pixel') return widthAttr;
        // for legacy mediaSingle nodes without widthType attribute
        switch(layoutAttr){
            case 'full-width':
                return 0, $5bbjm.akEditorFullWidthLayoutWidth;
            case 'wide':
                return 0, $5bbjm.akEditorCalculatedWideLayoutWidth;
            default:
                return 0, $5bbjm.akEditorDefaultLayoutWidth;
        }
    }
    hasPxWidthType(mediaSingleNode) {
        const { width: widthAttr, widthType: widthTypeAttr } = mediaSingleNode.attrs;
        // for extended mediaSingle nodes with width and widthType attributes ( default behaviour )
        if (widthAttr && widthTypeAttr === 'pixel') return true;
        return false;
    }
    createDomRef() {
        const domRef = document.createElement('div');
        if (this.reactComponentProps.mediaOptions && this.reactComponentProps.mediaOptions.allowMediaSingleEditable) // workaround Chrome bug in https://product-fabric.atlassian.net/browse/ED-5379
        // see also: https://github.com/ProseMirror/prosemirror/issues/884
        domRef.contentEditable = 'true';
        this.resizeListenerBinding = (0, $bAB3U.bind)(domRef, {
            type: 'resized',
            listener: this.hasResizedListener
        });
        return domRef;
    }
    viewShouldUpdate(nextNode, decorations) {
        const hasMediaNodeSelectedDecoration = decorations.some((decoration)=>$85a379ba9380feb9$var$isMediaDecorationSpec(decoration) && decoration.spec.type === 'media' && decoration.spec.selected);
        if (this.isSelected !== hasMediaNodeSelectedDecoration) {
            this.isSelected = hasMediaNodeSelectedDecoration;
            return true;
        }
        const aiGenerating = (0, $kZf5n.hasAIGeneratingDecoration)(decorations);
        if (this.isAIGenerating !== aiGenerating) {
            this.isAIGenerating = aiGenerating;
            return true;
        }
        if (this.node.attrs !== nextNode.attrs) return true;
        return super.viewShouldUpdate(nextNode, decorations);
    }
    stopEvent(event) {
        // Don't trap right click events on media node
        if ([
            'mousedown',
            'contextmenu'
        ].indexOf(event.type) !== -1) {
            const mouseEvent = event;
            if (mouseEvent.button === 2) return true;
        }
        return false;
    }
    getAttrs() {
        const { attrs: attrs } = this.node;
        return attrs;
    }
    isMediaBlobUrl() {
        const attrs = this.getAttrs();
        return (0, $4sVoN.isMediaBlobUrlFromAttrs)(attrs);
    }
    render() {
        const { providerFactory: providerFactory, intl: intl } = this.reactComponentProps;
        return /*#__PURE__*/ (0, $dc70d.jsx)((0, $jTv7r.MediaSSRReactContextsProvider), {
            intl: intl,
            children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $fRXfs.WithProviders), {
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                providers: [
                    'contextIdentifierProvider'
                ],
                providerFactory: providerFactory,
                renderNode: this.renderMediaNodeWithProviders
            })
        });
    }
    destroy() {
        if (this.resizeListenerBinding) this.resizeListenerBinding();
        super.destroy();
    }
    constructor(...args){
        super(...args), this.isSelected = false, this.isAIGenerating = false, this.hasBeenResized = false, this.hasResizedListener = ()=>{
            if (!this.hasBeenResized) {
                this.hasBeenResized = true;
                this.update(this.node, this.decorations);
            }
        }, this.onExternalImageLoaded = (dimensions)=>{
            const getPos = this.getPos;
            const { width: width, height: height, ...rest } = this.getAttrs();
            if (!width || !height) (0, $lyZqb.updateCurrentMediaNodeAttrs)({
                ...rest,
                width: width || dimensions.width,
                height: height || dimensions.height
            }, {
                node: this.node,
                getPos: getPos
            }, true)(this.view.state, this.view.dispatch);
        }, this.getMaxCardDimensions = ()=>{
            const flexibleDimensions = {
                width: '100%',
                height: '100%'
            };
            const pos = this.getPos();
            if (typeof pos !== 'number') return flexibleDimensions;
            if (this.hasBeenResized) return flexibleDimensions;
            const mediaSingleNodeParent = this.getMediaSingleNode(this.getPos);
            // If media parent not found, return default
            if (!mediaSingleNodeParent) return flexibleDimensions;
            if (this.hasPxWidthType(mediaSingleNodeParent)) return {
                width: `${mediaSingleNodeParent.attrs.width}px`,
                height: '100%'
            };
            return flexibleDimensions;
        }, this.getMediaProviderToUse = (mediaOptions, mediaProvider)=>{
            if (mediaProvider) return mediaProvider;
            return mediaOptions.provider;
        }, this.renderMediaNodeWithState = (contextIdentifierProvider)=>{
            return ({ mediaProvider: mediaProvider, interactionState: interactionState })=>{
                var _this$reactComponentP;
                const getPos = this.getPos;
                const { mediaOptions: mediaOptions } = this.reactComponentProps;
                const attrs = this.getAttrs();
                const url = attrs.type === 'external' ? attrs.url : '';
                let { width: width, height: height } = attrs;
                if (this.isMediaBlobUrl()) {
                    const urlAttrs = (0, $18aF1.getAttrsFromUrl)(url);
                    if (urlAttrs) {
                        const { width: urlWidth, height: urlHeight } = urlAttrs;
                        width = width || urlWidth;
                        height = height || urlHeight;
                    }
                }
                width = width || (0, $29qUP.DEFAULT_IMAGE_WIDTH);
                height = height || (0, $29qUP.DEFAULT_IMAGE_HEIGHT);
                const { pluginInjectionApi: pluginInjectionApi } = this.reactComponentProps;
                // mediaSingle defines the max dimensions, so we don't need to constrain twice.
                const maxDimensions = this.getMaxCardDimensions();
                const originalDimensions = {
                    width: width,
                    height: height
                };
                const isSelectedAndInteracted = this.nodeInsideSelection() && interactionState !== 'hasNotHadInteraction';
                return /*#__PURE__*/ (0, $dc70d.jsx)((0, $f0ceB.default), {
                    api: pluginInjectionApi,
                    view: this.view,
                    node: this.node,
                    getPos: getPos,
                    selected: isSelectedAndInteracted,
                    originalDimensions: originalDimensions,
                    maxDimensions: maxDimensions,
                    url: url,
                    mediaProvider: this.getMediaProviderToUse(mediaOptions, mediaProvider),
                    syncProvider: mediaOptions.syncProvider,
                    contextIdentifierProvider: contextIdentifierProvider,
                    mediaOptions: mediaOptions,
                    onExternalImageLoaded: this.onExternalImageLoaded,
                    isViewOnly: ((_this$reactComponentP = this.reactComponentProps.pluginInjectionApi) === null || _this$reactComponentP === void 0 || (_this$reactComponentP = _this$reactComponentP.editorViewMode) === null || _this$reactComponentP === void 0 || (_this$reactComponentP = _this$reactComponentP.sharedState.currentState()) === null || _this$reactComponentP === void 0 ? void 0 : _this$reactComponentP.mode) === 'view',
                    pluginInjectionApi: this.reactComponentProps.pluginInjectionApi,
                    isAIGenerating: this.isAIGenerating
                });
            };
        }, this.renderMediaNodeWithProviders = ({ contextIdentifierProvider: contextIdentifierProvider })=>{
            const { pluginInjectionApi: pluginInjectionApi } = this.reactComponentProps;
            return /*#__PURE__*/ (0, $dc70d.jsx)($85a379ba9380feb9$var$MediaNodeWithProviders, {
                pluginInjectionApi: pluginInjectionApi,
                innerComponent: this.renderMediaNodeWithState(contextIdentifierProvider)
            });
        };
    }
}
const $85a379ba9380feb9$export$a8df8d02db5c2be0 = (portalProviderAPI, eventDispatcher, providerFactory, mediaOptions = {}, pluginInjectionApi, intl)=>(node, view, getPos)=>{
        return new $85a379ba9380feb9$var$MediaNodeView(node, view, getPos, portalProviderAPI, eventDispatcher, {
            eventDispatcher: eventDispatcher,
            providerFactory: providerFactory,
            mediaOptions: mediaOptions,
            pluginInjectionApi: pluginInjectionApi,
            intl: intl
        }).init();
    };

});
parcelRegister("kZf5n", function(module, exports) {
$parcel$export(module.exports, "hasAIGeneratingDecoration", () => $b0a58dd49e14fec6$export$9bb374347eefe943);
$parcel$export(module.exports, "setAIGeneratingMeta", () => $b0a58dd49e14fec6$export$dacdbc7b94b414ee);
$parcel$export(module.exports, "clearAIGeneratingMeta", () => $b0a58dd49e14fec6$export$d9968a0fb720c8d8);
$parcel$export(module.exports, "createAIGeneratingDecorationPlugin", () => $b0a58dd49e14fec6$export$4872b17b77321d10);

var $f7Kk4 = parcelRequire("f7Kk4");

var $cw0wu = parcelRequire("cw0wu");

var $a3b9P = parcelRequire("a3b9P");

var $gdUUy = parcelRequire("gdUUy");

var $5N1Y4 = parcelRequire("5N1Y4");
const $b0a58dd49e14fec6$export$aef4e943472be416 = new (0, $cw0wu.PluginKey)('aiGeneratingDecoration');
const $b0a58dd49e14fec6$var$AI_GENERATING_DECORATION_TYPE = 'ai-generating';
// ── Helpers ─────────────────────────────────────────────────────────────────
/**
 * Build a DecorationSet containing a Decoration.node for every media node
 * targeted by the given set.
 *
 * Targets are matched by `localId` first (the mediaSingle wrapper's or the media
 * node's own) so that duplicate copies of the same image — which share a media
 * file `id` — don't all get decorated; only the node the user acted on lights
 * up. Falls back to the media file `id` for nodes that have no localId yet.
 */ function $b0a58dd49e14fec6$var$buildDecorationSet(doc, targetIds) {
    if (targetIds.size === 0) return (0, $a3b9P.DecorationSet).empty;
    const decorations = [];
    doc.descendants((node, pos, parent)=>{
        var _parent$attrs;
        if (node.type.name !== 'media') return;
        const wrapperLocalId = parent === null || parent === void 0 || (_parent$attrs = parent.attrs) === null || _parent$attrs === void 0 ? void 0 : _parent$attrs.localId;
        const isTarget = wrapperLocalId && targetIds.has(wrapperLocalId) || node.attrs.localId && targetIds.has(node.attrs.localId) || targetIds.has(node.attrs.id);
        if (isTarget) decorations.push((0, $a3b9P.Decoration).node(pos, pos + node.nodeSize, {}, // no DOM attrs needed — the NodeView reads the decoration spec
        {
            type: $b0a58dd49e14fec6$var$AI_GENERATING_DECORATION_TYPE,
            mediaId: node.attrs.id
        }));
    });
    return (0, $a3b9P.DecorationSet).create(doc, decorations);
}
function $b0a58dd49e14fec6$export$9bb374347eefe943(decorations) {
    return decorations.some((d)=>d.spec.type === $b0a58dd49e14fec6$var$AI_GENERATING_DECORATION_TYPE);
}
function $b0a58dd49e14fec6$export$dacdbc7b94b414ee(tr, mediaId) {
    return tr.setMeta($b0a58dd49e14fec6$export$aef4e943472be416, {
        type: 'SET_GENERATING',
        mediaId: mediaId
    }).setMeta('addToHistory', false);
}
function $b0a58dd49e14fec6$export$d9968a0fb720c8d8(tr, mediaId) {
    return tr.setMeta($b0a58dd49e14fec6$export$aef4e943472be416, {
        type: 'CLEAR_GENERATING',
        mediaId: mediaId
    }).setMeta('addToHistory', false);
}
function $b0a58dd49e14fec6$export$4872b17b77321d10() {
    return new (0, $f7Kk4.SafePlugin)({
        key: $b0a58dd49e14fec6$export$aef4e943472be416,
        state: {
            init () {
                return {
                    generatingMediaIds: new Set(),
                    decorationSet: (0, $a3b9P.DecorationSet).empty
                };
            },
            apply (tr, pluginState, _oldState, newState) {
                // Disabled when gate/experiment off — drop decorations.
                if (!(0, $gdUUy.fg)('cc-maui-phase-2') || !(0, $5N1Y4.expValEquals)('cc-maui-experiment', 'isEnabled', true)) {
                    if (pluginState.generatingMediaIds.size > 0) return {
                        generatingMediaIds: new Set(),
                        decorationSet: (0, $a3b9P.DecorationSet).empty
                    };
                    return pluginState;
                }
                const meta = tr.getMeta($b0a58dd49e14fec6$export$aef4e943472be416);
                if (meta) switch(meta.type){
                    case 'SET_GENERATING':
                        {
                            const ids = new Set(pluginState.generatingMediaIds);
                            ids.add(meta.mediaId);
                            return {
                                generatingMediaIds: ids,
                                decorationSet: $b0a58dd49e14fec6$var$buildDecorationSet(newState.doc, ids)
                            };
                        }
                    case 'CLEAR_GENERATING':
                        {
                            const ids = new Set(pluginState.generatingMediaIds);
                            ids.delete(meta.mediaId);
                            return {
                                generatingMediaIds: ids,
                                decorationSet: $b0a58dd49e14fec6$var$buildDecorationSet(newState.doc, ids)
                            };
                        }
                    case 'CLEAR_ALL':
                        return {
                            generatingMediaIds: new Set(),
                            decorationSet: (0, $a3b9P.DecorationSet).empty
                        };
                }
                // Map decorations through document changes so positions stay in sync
                if (tr.docChanged && pluginState.decorationSet !== (0, $a3b9P.DecorationSet).empty) try {
                    return {
                        ...pluginState,
                        decorationSet: pluginState.decorationSet.map(tr.mapping, newState.doc)
                    };
                } catch  {
                    return {
                        generatingMediaIds: new Set(),
                        decorationSet: (0, $a3b9P.DecorationSet).empty
                    };
                }
                return pluginState;
            }
        },
        props: {
            decorations (state) {
                var _aiGeneratingDecorati;
                return ((_aiGeneratingDecorati = $b0a58dd49e14fec6$export$aef4e943472be416.getState(state)) === null || _aiGeneratingDecorati === void 0 ? void 0 : _aiGeneratingDecorati.decorationSet) ?? (0, $a3b9P.DecorationSet).empty;
            }
        }
    });
}

});


parcelRegister("lOIBf", function(module, exports) {
$parcel$export(module.exports, "ReactMediaSingleNode", () => $3dd05e8615d829df$export$fd09b1a92f5ce9f7);
/**
 * @jsxRuntime classic
 * @jsx jsx
 * @jsxFrag
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $fRXfs = parcelRequire("fRXfs");

var $0Xboy = parcelRequire("0Xboy");

var $2pWL6 = parcelRequire("2pWL6");

var $5beht = parcelRequire("5beht");

var $r0VQo = parcelRequire("r0VQo");

var $5vR15 = parcelRequire("5vR15");

var $3y2s4 = parcelRequire("3y2s4");

var $2jJHo = parcelRequire("2jJHo");

var $jTv7r = parcelRequire("jTv7r");

var $eOttS = parcelRequire("eOttS");
const $3dd05e8615d829df$var$selector = (states)=>{
    var _states$mediaState, _states$mediaState2, _states$annotationSta, _states$annotationSta2, _states$widthState, _states$widthState2, _states$editorDisable, _states$editorViewMod;
    return {
        mediaProviderPromise: (_states$mediaState = states.mediaState) === null || _states$mediaState === void 0 ? void 0 : _states$mediaState.mediaProvider,
        addPendingTask: (_states$mediaState2 = states.mediaState) === null || _states$mediaState2 === void 0 ? void 0 : _states$mediaState2.addPendingTask,
        isDrafting: (_states$annotationSta = states.annotationState) === null || _states$annotationSta === void 0 ? void 0 : _states$annotationSta.isDrafting,
        targetNodeId: (_states$annotationSta2 = states.annotationState) === null || _states$annotationSta2 === void 0 ? void 0 : _states$annotationSta2.targetNodeId,
        width: (_states$widthState = states.widthState) === null || _states$widthState === void 0 ? void 0 : _states$widthState.width,
        lineLength: (_states$widthState2 = states.widthState) === null || _states$widthState2 === void 0 ? void 0 : _states$widthState2.lineLength,
        editorDisabled: (_states$editorDisable = states.editorDisabledState) === null || _states$editorDisable === void 0 ? void 0 : _states$editorDisable.editorDisabled,
        viewMode: (_states$editorViewMod = states.editorViewModeState) === null || _states$editorViewMod === void 0 ? void 0 : _states$editorViewMod.mode
    };
};
const $3dd05e8615d829df$var$MediaSingleNodeWrapper = ({ pluginInjectionApi: pluginInjectionApi, contextIdentifierProvider: contextIdentifierProvider, node: node, getPos: getPos, mediaOptions: mediaOptions, view: view, fullWidthMode: fullWidthMode, selected: selected, eventDispatcher: eventDispatcher, dispatchAnalyticsEvent: dispatchAnalyticsEvent, forwardRef: forwardRef, editorAppearance: editorAppearance })=>{
    const { mediaProviderPromise: mediaProviderPromise, addPendingTask: addPendingTask, isDrafting: isDrafting, targetNodeId: targetNodeId, width: width, lineLength: lineLength, editorDisabled: editorDisabled, viewMode: viewMode } = (0, $5beht.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'width',
        'media',
        'annotation',
        'editorDisabled',
        'editorViewMode'
    ], $3dd05e8615d829df$var$selector);
    const interactionState = (0, $2pWL6.useSharedPluginStateSelector)(pluginInjectionApi, 'interaction.interactionState');
    const mediaProvider = (0, $bSJIT.useMemo)(()=>mediaProviderPromise ? Promise.resolve(mediaProviderPromise) : undefined, [
        mediaProviderPromise
    ]);
    const isSelectedAndInteracted = (0, $bSJIT.useCallback)(()=>Boolean(selected() && interactionState !== 'hasNotHadInteraction'), [
        interactionState,
        selected
    ]);
    return /*#__PURE__*/ (0, $9dQre.jsx)((0, $eOttS.MediaSingleNodeNext), {
        width: width || 0,
        lineLength: lineLength || 0,
        node: node,
        getPos: getPos,
        mediaProvider: mediaProvider,
        contextIdentifierProvider: contextIdentifierProvider,
        mediaOptions: mediaOptions,
        view: view,
        fullWidthMode: fullWidthMode,
        selected: isSelectedAndInteracted,
        eventDispatcher: eventDispatcher,
        addPendingTask: addPendingTask,
        isDrafting: isDrafting,
        targetNodeId: targetNodeId,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        forwardRef: forwardRef,
        pluginInjectionApi: pluginInjectionApi,
        editorDisabled: editorDisabled,
        editorViewMode: viewMode === 'view',
        editorAppearance: editorAppearance
    });
};
/**
 * Only the percentage-based `ResizableMediaSingle` reads `offsetLeft`, to offset the resize grid
 * for an image indented in a list. Pixel resizing and no-resizer configurations never consume it,
 * so `ignoreMutation` can skip the forced layout read for them.
 *
 * We can remove this and always return true from ignoreMutation once the legacy media resizer is removed.
 */ const $3dd05e8615d829df$var$shouldSkipOffsetLeftRead = (mediaOptions)=>{
    const allowPixelResizing = Boolean(mediaOptions && mediaOptions.allowPixelResizing);
    const allowResizing = Boolean(mediaOptions && mediaOptions.allowResizing);
    return (allowPixelResizing || !allowResizing) && (0, $3y2s4.isExperimentEnabled)('platform_editor_reduce_forced_layout');
};
class $3dd05e8615d829df$var$MediaSingleNodeView extends (0, $0Xboy.default) {
    createDomRef() {
        var _this$reactComponentP, _this$reactComponentP2;
        const domRef = document.createElement('div');
        // control the domRef contentEditable attribute based on the editor view mode
        this.unsubscribeToViewModeChange = this.subscribeToViewModeChange(domRef);
        const initialViewMode = (_this$reactComponentP = this.reactComponentProps.pluginInjectionApi) === null || _this$reactComponentP === void 0 || (_this$reactComponentP = _this$reactComponentP.editorViewMode) === null || _this$reactComponentP === void 0 || (_this$reactComponentP = _this$reactComponentP.sharedState.currentState()) === null || _this$reactComponentP === void 0 ? void 0 : _this$reactComponentP.mode;
        this.updateDomRefContentEditable(domRef, initialViewMode);
        if ((_this$reactComponentP2 = this.reactComponentProps.mediaOptions) !== null && _this$reactComponentP2 !== void 0 && _this$reactComponentP2.allowPixelResizing) domRef.classList.add('media-extended-resize-experience');
        domRef.setAttribute('data-media-vc-wrapper', 'true');
        this.updateContentVisibility(domRef);
        return domRef;
    }
    getContentDOM() {
        const dom = document.createElement('div');
        dom.classList.add((0, $2jJHo.MEDIA_CONTENT_WRAP_CLASS_NAME));
        return {
            dom: dom
        };
    }
    /**
   * Skip rendering off-screen media in large (limited-mode) documents; the estimate is derived from
   * the media's own dimensions and the renderer's width calculation. Called from both `createDomRef`
   * and `update()` because limited mode can flip from disabled→enabled after the document loads.
   * Takes the target element explicitly because `createDomRef` runs before `this.dom` is assigned.
   */ updateContentVisibility(dom) {
        var _api$limitedMode;
        const api = this.reactComponentProps.pluginInjectionApi;
        // Read limited mode from `this.view.state` via the exposed plugin key, NOT `currentState().enabled`
        // (which reads a stale false during initial EditorView construction — see the table nodeView).
        //
        // Reads the plugin's derived `enabled`, so this covers every reason limited mode can be on.
        const enabled = Boolean(api === null || api === void 0 || (_api$limitedMode = api.limitedMode) === null || _api$limitedMode === void 0 || (_api$limitedMode = _api$limitedMode.sharedState.currentState()) === null || _api$limitedMode === void 0 || (_api$limitedMode = _api$limitedMode.limitedModePluginKey) === null || _api$limitedMode === void 0 || (_api$limitedMode = _api$limitedMode.getState(this.view.state)) === null || _api$limitedMode === void 0 ? void 0 : _api$limitedMode.enabled);
        (0, $r0VQo.applyContentVisibility)(dom, enabled, ()=>{
            var _api$width;
            const widthState = api === null || api === void 0 || (_api$width = api.width) === null || _api$width === void 0 ? void 0 : _api$width.sharedState.currentState();
            return (0, $r0VQo.estimateMediaSingleIntrinsicSize)(this.node, (widthState === null || widthState === void 0 ? void 0 : widthState.lineLength) ?? 0, (widthState === null || widthState === void 0 ? void 0 : widthState.width) ?? 0);
        });
    }
    viewShouldUpdate(nextNode) {
        if (this.forceViewUpdate) {
            this.forceViewUpdate = false;
            return true;
        }
        if (this.node.attrs !== nextNode.attrs) return true;
        if (this.selectionType !== this.checkAndUpdateSelectionType()) return true;
        if (this.node.childCount !== nextNode.childCount) return true;
        return super.viewShouldUpdate(nextNode);
    }
    subscribeToViewModeChange(domRef) {
        var _this$reactComponentP3;
        return (_this$reactComponentP3 = this.reactComponentProps.pluginInjectionApi) === null || _this$reactComponentP3 === void 0 || (_this$reactComponentP3 = _this$reactComponentP3.editorViewMode) === null || _this$reactComponentP3 === void 0 ? void 0 : _this$reactComponentP3.sharedState.onChange((viewModeState)=>{
            var _viewModeState$nextSh;
            this.updateDomRefContentEditable(domRef, (_viewModeState$nextSh = viewModeState.nextSharedState) === null || _viewModeState$nextSh === void 0 ? void 0 : _viewModeState$nextSh.mode);
        });
    }
    updateDomRefContentEditable(domRef, editorViewMode) {
        var _this$reactComponentP4;
        // if the editor is in view mode, we should not allow editing
        if (editorViewMode === 'view') {
            domRef.contentEditable = 'false';
            return;
        }
        // if the editor is in edit mode, we should allow editing if the media options allow it
        if ((_this$reactComponentP4 = this.reactComponentProps.mediaOptions) !== null && _this$reactComponentP4 !== void 0 && _this$reactComponentP4.allowMediaSingleEditable) // workaround Chrome bug in https://product-fabric.atlassian.net/browse/ED-5379
        // see also: https://github.com/ProseMirror/prosemirror/issues/884
        domRef.contentEditable = 'true';
    }
    getNodeMediaId(node) {
        if (node.firstChild) return node.firstChild.attrs.id;
        return undefined;
    }
    stopEvent(event) {
        if (this.isNodeSelected() && event instanceof KeyboardEvent && (event === null || event === void 0 ? void 0 : event.target) instanceof HTMLElement) {
            const targetType = event.target.type;
            if (event.key === 'Enter' && targetType === 'button') return true;
        }
        return false;
    }
    update(node, decorations, _innerDecorations, isValidUpdate) {
        if (!isValidUpdate) isValidUpdate = (currentNode, newNode)=>this.getNodeMediaId(currentNode) === this.getNodeMediaId(newNode);
        // Detect mediaSingle width attribute changes and signal child media node to update
        if (!this.hasResized && this.node.attrs.width !== node.attrs.width) {
            const target = this.dom.querySelector('div[data-prosemirror-node-name="media"]');
            target === null || target === void 0 || target.dispatchEvent(new CustomEvent('resized'));
        }
        const didUpdate = super.update(node, decorations, _innerDecorations, isValidUpdate);
        if (this.dom) this.updateContentVisibility(this.dom);
        return didUpdate;
    }
    render(props, forwardRef) {
        const { eventDispatcher: eventDispatcher, fullWidthMode: fullWidthMode, providerFactory: providerFactory, mediaOptions: mediaOptions, dispatchAnalyticsEvent: dispatchAnalyticsEvent, pluginInjectionApi: pluginInjectionApi, editorAppearance: editorAppearance, intl: intl } = this.reactComponentProps;
        // getPos is a boolean for marks, since this is a node we know it must be a function
        const getPos = this.getPos;
        return /*#__PURE__*/ (0, $9dQre.jsx)((0, $jTv7r.MediaSSRReactContextsProvider), {
            intl: intl
        }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $fRXfs.WithProviders), {
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            providers: [
                'contextIdentifierProvider'
            ],
            providerFactory: providerFactory,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            renderNode: ({ contextIdentifierProvider: contextIdentifierProvider })=>{
                return /*#__PURE__*/ (0, $9dQre.jsx)($3dd05e8615d829df$var$MediaSingleNodeWrapper, {
                    pluginInjectionApi: pluginInjectionApi,
                    contextIdentifierProvider: contextIdentifierProvider,
                    node: this.node,
                    getPos: getPos,
                    mediaOptions: mediaOptions,
                    view: this.view,
                    fullWidthMode: fullWidthMode,
                    selected: this.isNodeSelected,
                    eventDispatcher: eventDispatcher,
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    forwardRef: forwardRef,
                    editorAppearance: editorAppearance
                });
            }
        }));
    }
    ignoreMutation() {
        if (this.skipsOffsetLeftRead === null) this.skipsOffsetLeftRead = $3dd05e8615d829df$var$shouldSkipOffsetLeftRead(this.reactComponentProps.mediaOptions);
        if (this.skipsOffsetLeftRead) return true;
        // DOM has changed; recalculate if we need to re-render
        if (this.dom) {
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            const offsetLeft = this.dom.offsetLeft;
            if (offsetLeft !== this.lastOffsetLeft) {
                this.lastOffsetLeft = offsetLeft;
                this.forceViewUpdate = true;
                this.update(this.node, [], undefined, ()=>true);
            }
        }
        return true;
    }
    destroy() {
        var _this$unsubscribeToVi;
        if ((0, $3y2s4.isExperimentEnabled)('platform_editor_reduce_memory_leaks')) super.destroy();
        (_this$unsubscribeToVi = this.unsubscribeToViewModeChange) === null || _this$unsubscribeToVi === void 0 || _this$unsubscribeToVi.call(this);
    }
    constructor(...args){
        super(...args), this.lastOffsetLeft = 0, this.forceViewUpdate = false, this.selectionType = null, this.hasResized = false, this.skipsOffsetLeftRead = null, this.checkAndUpdateSelectionType = ()=>{
            const getPos = this.getPos;
            const { selection: selection } = this.view.state;
            /**
     *  ED-19831
     *  There is a getPos issue coming from this code. We need to apply this workaround for now and apply a patch
     *  directly to confluence since this bug is now in production.
     */ let pos;
            try {
                pos = getPos ? getPos() : undefined;
            } catch  {
                pos = undefined;
            }
            const isNodeSelected = (0, $5vR15.isNodeSelectedOrInRange)(selection.$anchor.pos, selection.$head.pos, pos, this.node.nodeSize);
            this.selectionType = isNodeSelected;
            return isNodeSelected;
        }, this.isNodeSelected = ()=>{
            this.checkAndUpdateSelectionType();
            return this.selectionType !== null;
        };
    }
}
const $3dd05e8615d829df$export$fd09b1a92f5ce9f7 = (portalProviderAPI, eventDispatcher, providerFactory, pluginInjectionApi, dispatchAnalyticsEvent, mediaOptions = {}, intl)=>(node, view, getPos)=>{
        return new $3dd05e8615d829df$var$MediaSingleNodeView(node, view, getPos, portalProviderAPI, eventDispatcher, {
            eventDispatcher: eventDispatcher,
            fullWidthMode: mediaOptions.fullWidthEnabled,
            providerFactory: providerFactory,
            mediaOptions: mediaOptions,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            isCopyPasteEnabled: mediaOptions.isCopyPasteEnabled,
            pluginInjectionApi: pluginInjectionApi,
            editorAppearance: mediaOptions.editorAppearance,
            intl: intl
        }).init();
    };

});
parcelRegister("eOttS", function(module, exports) {
$parcel$export(module.exports, "MediaSingleNodeNext", () => $70f396cdad4c0642$export$4a00cdcfd685a172);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $jxkn6 = parcelRequire("jxkn6");

var $lqqbp = parcelRequire("lqqbp");

var $29qUP = parcelRequire("29qUP");

var $ds6EJ = parcelRequire("ds6EJ");

var $61dYH = parcelRequire("61dYH");

var $33OA0 = parcelRequire("33OA0");

var $dGul0 = parcelRequire("dGul0");

var $1mebE = parcelRequire("1mebE");

var $5N9nM = parcelRequire("5N9nM");

var $b2855 = parcelRequire("b2855");

var $cw0wu = parcelRequire("cw0wu");

var $gab48 = parcelRequire("gab48");

var $18aF1 = parcelRequire("18aF1");

var $9xRfX = parcelRequire("9xRfX");

var $4sVoN = parcelRequire("4sVoN");

var $fEdwW = parcelRequire("fEdwW");

var $a7lAS = parcelRequire("a7lAS");

var $bhAS0 = parcelRequire("bhAS0");

var $24yx2 = parcelRequire("24yx2");

var $gi3hj = parcelRequire("gi3hj");

var $eUcZO = parcelRequire("eUcZO");

var $e35II = parcelRequire("e35II");
function $70f396cdad4c0642$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $70f396cdad4c0642$var$figureWrapperStyles = {
    name: "ti75j2",
    styles: "margin:0"
};
const $70f396cdad4c0642$var$useMediaNodeUpdater = ({ mediaProvider: mediaProvider, mediaNode: mediaNode, dispatchAnalyticsEvent: dispatchAnalyticsEvent, mediaSingleNodeProps: mediaSingleNodeProps })=>{
    const previousMediaProvider = (0, $b2855.default)(mediaProvider);
    const previousMediaNode = (0, $b2855.default)(mediaNode);
    const mediaNodeUpdaterRef = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useRef(null);
    const createOrUpdateMediaNodeUpdater = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useCallback((props)=>{
        const mediaChildNode = mediaNode.firstChild;
        const updaterProps = {
            ...props,
            isMediaSingle: true,
            node: mediaChildNode ? mediaChildNode : mediaNode,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent
        };
        if (!mediaNodeUpdaterRef.current) mediaNodeUpdaterRef.current = (0, $eUcZO.createMediaNodeUpdater)(updaterProps);
        else mediaNodeUpdaterRef.current.setProps(updaterProps);
    }, [
        mediaNode,
        dispatchAnalyticsEvent
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useEffect(()=>{
        // Forced updates not required on mobile
        if (mediaSingleNodeProps.isCopyPasteEnabled === false) return;
        if (!mediaNodeUpdaterRef.current || previousMediaProvider !== mediaProvider) {
            var _mediaNodeUpdaterRef$;
            createOrUpdateMediaNodeUpdater(mediaSingleNodeProps);
            (_mediaNodeUpdaterRef$ = mediaNodeUpdaterRef.current) === null || _mediaNodeUpdaterRef$ === void 0 || _mediaNodeUpdaterRef$.updateMediaSingleFileAttrs();
        } else if (mediaNode.firstChild && previousMediaNode !== null && previousMediaNode !== void 0 && previousMediaNode.firstChild && mediaNode.firstChild !== (previousMediaNode === null || previousMediaNode === void 0 ? void 0 : previousMediaNode.firstChild)) {
            const attrsChanged = (0, $gi3hj.hasPrivateAttrsChanged)(previousMediaNode.firstChild.attrs, mediaNode.firstChild.attrs);
            if (attrsChanged) {
                var _mediaNodeUpdaterRef$2;
                createOrUpdateMediaNodeUpdater(mediaSingleNodeProps);
                // We need to call this method on any prop change since attrs can get removed with collab editing
                (_mediaNodeUpdaterRef$2 = mediaNodeUpdaterRef.current) === null || _mediaNodeUpdaterRef$2 === void 0 || _mediaNodeUpdaterRef$2.updateMediaSingleFileAttrs();
            }
        }
    }, [
        createOrUpdateMediaNodeUpdater,
        mediaNode,
        mediaProvider,
        mediaSingleNodeProps,
        previousMediaNode,
        previousMediaProvider
    ]);
    return mediaNodeUpdaterRef.current;
};
const $70f396cdad4c0642$var$mediaAsyncOperations = async (props)=>{
    const updatedDimensions = await props.updater.getRemoteDimensions();
    const currentAttrs = props.mediaChildNode.attrs;
    if (updatedDimensions && ((currentAttrs === null || currentAttrs === void 0 ? void 0 : currentAttrs.width) !== updatedDimensions.width || (currentAttrs === null || currentAttrs === void 0 ? void 0 : currentAttrs.height) !== updatedDimensions.height)) props.updater.updateDimensions(updatedDimensions);
    if (props.mediaChildNode.attrs.type === 'external' && props.mediaChildNode.attrs.__external) {
        const updatingNode = props.updater.handleExternalMedia(props.getPos);
        props.addPendingTask(updatingNode);
        await updatingNode;
        return;
    }
    const contextId = props.updater.getNodeContextId();
    if (!contextId) await props.updater.updateContextId();
    const shouldNodeBeDeepCopied = await props.updater.shouldNodeBeDeepCopied();
    if (shouldNodeBeDeepCopied) try {
        const copyNode = props.updater.copyNode({
            traceId: props.mediaNode.attrs.__mediaTraceId
        });
        props.addPendingTask(copyNode);
        await copyNode;
    } catch  {}
};
const $70f396cdad4c0642$var$useMediaAsyncOperations = ({ mediaNode: mediaNode, mediaNodeUpdater: mediaNodeUpdater, addPendingTask: addPendingTask, getPos: getPos, mediaChildNodeId: mediaChildNodeId })=>{
    (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useEffect(()=>{
        if (!mediaNodeUpdater) return;
        // we want the first child of MediaSingle (type "media")
        const childNode = mediaNode.firstChild;
        if (!childNode) return;
        $70f396cdad4c0642$var$mediaAsyncOperations({
            mediaChildNode: childNode,
            updater: mediaNodeUpdater,
            getPos: getPos,
            mediaNode: mediaNode,
            addPendingTask: addPendingTask
        });
    // mediaChildNodeId is included so this effect re-runs when the media source
    // is replaced (id changes), ensuring getRemoteDimensions fires for the new file
    // with up-to-date updater props after setProps has been called.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        mediaNode,
        addPendingTask,
        mediaNodeUpdater,
        getPos,
        mediaChildNodeId
    ]);
};
const $70f396cdad4c0642$var$noop = ()=>{};
/**
 * Keep returning the same ProseMirror Node, unless the node content changed.
 *
 * React uses shallow comparation with `Object.is`,
 * but that can cause multiple re-renders when the same node is given in a different instance.
 *
 * To avoid unnecessary re-renders, this hook uses the `Node.eq` from ProseMirror API to compare
 * previous and new values.
 */ const $70f396cdad4c0642$var$useLatestMediaNode = (nextMediaNode)=>{
    const previousMediaNode = (0, $b2855.default)(nextMediaNode);
    const [mediaNode, setMediaNode] = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useState(nextMediaNode);
    (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useEffect(()=>{
        if (!previousMediaNode || typeof previousMediaNode.eq !== 'function') return;
        if (!previousMediaNode.eq(nextMediaNode)) setMediaNode(nextMediaNode);
    }, [
        previousMediaNode,
        nextMediaNode
    ]);
    return mediaNode;
};
const $70f396cdad4c0642$var$useMediaDimensionsLogic = ({ childMediaNodeAttrs: childMediaNodeAttrs })=>{
    const { width: originalWidth, height: originalHeight } = childMediaNodeAttrs;
    const isExternalMedia = childMediaNodeAttrs.type === 'external';
    const hasMediaUrlBlob = isExternalMedia && typeof childMediaNodeAttrs.url === 'string' && (0, $4sVoN.isMediaBlobUrlFromAttrs)(childMediaNodeAttrs);
    const urlBlobAttrs = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useMemo(()=>{
        if (!hasMediaUrlBlob) return null;
        return (0, $18aF1.getAttrsFromUrl)(childMediaNodeAttrs.url);
    }, [
        hasMediaUrlBlob,
        childMediaNodeAttrs
    ]);
    const { width: width, height: height } = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useMemo(()=>{
        // original width and height of child media node (scaled)
        let width = originalWidth;
        let height = originalHeight;
        if (isExternalMedia) {
            if (urlBlobAttrs) {
                if (urlBlobAttrs) {
                    const { width: urlWidth, height: urlHeight } = urlBlobAttrs;
                    width = width || urlWidth;
                    height = height || urlHeight;
                }
            }
            if (width === null) width = (0, $29qUP.DEFAULT_IMAGE_WIDTH);
            if (height === null) height = (0, $29qUP.DEFAULT_IMAGE_HEIGHT);
        }
        if (!width || !height) {
            width = (0, $29qUP.DEFAULT_IMAGE_WIDTH);
            height = (0, $29qUP.DEFAULT_IMAGE_HEIGHT);
        }
        return {
            width: width,
            height: height
        };
    }, [
        originalWidth,
        originalHeight,
        isExternalMedia,
        urlBlobAttrs
    ]);
    return {
        width: width,
        height: height
    };
};
const $70f396cdad4c0642$var$useUpdateSizeCallback = ({ mediaNode: mediaNode, view: view, getPos: getPos })=>{
    const updateSize = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useCallback((width, layout)=>{
        const { state: state, dispatch: dispatch } = view;
        const pos = getPos();
        if (typeof pos === 'undefined') return;
        const tr = state.tr.setNodeMarkup(pos, undefined, {
            ...mediaNode.attrs,
            layout: layout,
            width: width,
            widthType: 'pixel'
        });
        tr.setMeta('scrollIntoView', false);
        /**
     * Any changes to attributes of a node count the node as "recreated" in Prosemirror[1]
     * This makes it so Prosemirror resets the selection to the child i.e. "media" instead of "media-single"
     * The recommended fix is to reset the selection.[2]
     *
     * [1] https://discuss.prosemirror.net/t/setnodemarkup-loses-current-nodeselection/976
     * [2] https://discuss.prosemirror.net/t/setnodemarkup-and-deselect/3673
     */ tr.setSelection((0, $cw0wu.NodeSelection).create(tr.doc, pos));
        return dispatch(tr);
    }, [
        view,
        getPos,
        mediaNode
    ]);
    return updateSize;
};
/**
 * This value is used to fallback when widthState is undefined.
 *
 * Previously, the old MediaSingle was ignoring the undefined situation:
 *
 * <MediaSingleNode
 *	  width={widthState!.width}
 *	  lineLength={widthState!.lineLength}
 */ const $70f396cdad4c0642$var$FALLBACK_MOST_COMMON_WIDTH = 760;
const $70f396cdad4c0642$export$4a00cdcfd685a172 = (mediaSingleNodeNextProps)=>{
    var _mediaNode$firstChild, _pluginInjectionApi$m, _mediaNode$firstChild2;
    const { selected: selected, getPos: getPos, node: nextMediaNode, mediaOptions: mediaOptions, fullWidthMode: fullWidthMode, view: view, pluginInjectionApi: pluginInjectionApi, width: containerWidth, lineLength: lineLength, dispatchAnalyticsEvent: dispatchAnalyticsEvent, editorViewMode: editorViewMode, editorDisabled: editorDisabled, isDrafting: isDrafting, targetNodeId: targetNodeId, editorAppearance: editorAppearance, mediaProvider: mediaProviderPromise, forwardRef: forwardRef, contextIdentifierProvider: contextIdentifierProviderPromise, addPendingTask: addPendingTask } = mediaSingleNodeNextProps;
    const [mediaProvider, setMediaProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useState(null);
    const [_contextIdentifierProvider, setContextIdentifierProvider] = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useState(null);
    const [viewMediaClientConfig, setViewMediaClientConfig] = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useState();
    const mountedRef = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useRef(true);
    const pos = getPos();
    const isSelected = selected();
    const contentWidthForLegacyExperience = (0, $lqqbp.getMaxWidthForNestedNode)(view, getPos()) || lineLength;
    const mediaNode = $70f396cdad4c0642$var$useLatestMediaNode(nextMediaNode);
    const mediaNodeUpdater = $70f396cdad4c0642$var$useMediaNodeUpdater({
        mediaNode: mediaNode,
        mediaSingleNodeProps: mediaSingleNodeNextProps,
        mediaProvider: mediaProvider,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent
    });
    $70f396cdad4c0642$var$useMediaAsyncOperations({
        mediaNodeUpdater: mediaNodeUpdater,
        getPos: getPos,
        mediaNode: mediaNode,
        addPendingTask: addPendingTask || $70f396cdad4c0642$var$noop,
        mediaChildNodeId: (_mediaNode$firstChild = mediaNode.firstChild) === null || _mediaNode$firstChild === void 0 ? void 0 : _mediaNode$firstChild.attrs.id
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useLayoutEffect(()=>{
        mountedRef.current = true;
        return ()=>{
            mountedRef.current = false;
        };
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useLayoutEffect(()=>{
        if (!mediaProviderPromise) return;
        mediaProviderPromise.then((resolvedProvider)=>{
            const { viewMediaClientConfig: viewMediaClientConfig } = resolvedProvider;
            if (mountedRef.current) {
                setViewMediaClientConfig(viewMediaClientConfig);
                setMediaProvider(resolvedProvider);
            }
        });
    }, [
        mediaProviderPromise
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useEffect(()=>{
        if (!contextIdentifierProviderPromise) return;
        contextIdentifierProviderPromise.then((provider)=>{
            if (mountedRef.current) setContextIdentifierProvider(provider);
        });
    }, [
        contextIdentifierProviderPromise
    ]);
    const { layout: layout, widthType: widthType, width: mediaSingleWidthAttribute } = mediaNode.attrs;
    const childNode = mediaNode.firstChild;
    const childMediaNodeAttrs = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useMemo(()=>{
        return (childNode === null || childNode === void 0 ? void 0 : childNode.attrs) || {};
    }, [
        childNode
    ]);
    const { width: width, height: height } = $70f396cdad4c0642$var$useMediaDimensionsLogic({
        childMediaNodeAttrs: childMediaNodeAttrs
    });
    const updateSize = $70f396cdad4c0642$var$useUpdateSizeCallback({
        view: view,
        getPos: getPos,
        mediaNode: mediaNode
    });
    const canResize = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useMemo(()=>{
        if (typeof pos !== 'number') return false;
        const result = Boolean(!!mediaOptions.allowResizing && !editorDisabled && !editorViewMode);
        if (mediaOptions.allowResizingInTables) return result;
        // If resizing not allowed in tables, check parents for tables
        const $pos = view.state.doc.resolve(pos);
        const { table: table } = view.state.schema.nodes;
        const disabledNode = !!(0, $gab48.findParentNodeOfTypeClosestToPos)($pos, [
            table
        ]);
        return Boolean(result && !disabledNode);
    }, [
        mediaOptions,
        pos,
        view,
        editorDisabled,
        editorViewMode
    ]);
    const shouldShowPlaceholder = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useMemo(()=>{
        const result = mediaOptions.allowCaptions && mediaNode.childCount !== 2 && isSelected && view.state.selection instanceof (0, $cw0wu.NodeSelection);
        return !editorDisabled && result;
    }, [
        editorDisabled,
        mediaOptions.allowCaptions,
        mediaNode,
        view,
        isSelected
    ]);
    const isInsideTable = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useMemo(()=>{
        if (typeof pos !== 'number') return false;
        return (0, $gab48.findParentNodeOfTypeClosestToPos)(view.state.doc.resolve(pos), [
            view.state.schema.nodes.table
        ]);
    }, [
        pos,
        view
    ]);
    const currentMediaElement = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useCallback(()=>{
        if (typeof pos !== 'number') return null;
        const mediaNode = view.domAtPos(pos + 1).node;
        return mediaNode instanceof HTMLElement ? mediaNode : null;
    }, [
        view,
        pos
    ]);
    const mediaSingleWidth = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useMemo(()=>{
        return (0, $33OA0.calcMediaSinglePixelWidth)({
            width: mediaSingleWidthAttribute,
            widthType: widthType,
            origWidth: width,
            layout: layout,
            // This will only be used when calculating legacy media single width
            // thus we use the legacy value (exclude table as container node)
            contentWidth: contentWidthForLegacyExperience,
            containerWidth: containerWidth,
            gutterOffset: (0, $29qUP.MEDIA_SINGLE_GUTTER_SIZE)
        });
    }, [
        mediaSingleWidthAttribute,
        widthType,
        width,
        layout,
        contentWidthForLegacyExperience,
        containerWidth
    ]);
    const currentMaxWidth = isSelected ? pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$m = pluginInjectionApi.media) === null || _pluginInjectionApi$m === void 0 || (_pluginInjectionApi$m = _pluginInjectionApi$m.sharedState.currentState()) === null || _pluginInjectionApi$m === void 0 ? void 0 : _pluginInjectionApi$m.currentMaxWidth : undefined;
    const contentWidth = currentMaxWidth || lineLength;
    const isCurrentNodeDrafting = Boolean(isDrafting && targetNodeId === (mediaNode === null || mediaNode === void 0 || (_mediaNode$firstChild2 = mediaNode.firstChild) === null || _mediaNode$firstChild2 === void 0 ? void 0 : _mediaNode$firstChild2.attrs.id));
    const mediaSingleWrapperRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createRef();
    const captionPlaceHolderRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createRef();
    const browser = (0, $jxkn6.getBrowserInfo)();
    const notIos = !browser.ios;
    const onMediaSingleClicked = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useCallback((event)=>{
        var _captionPlaceHolderRe;
        const browser = (0, $jxkn6.getBrowserInfo)();
        // Workaround for iOS 16 Caption selection issue
        // @see https://product-fabric.atlassian.net/browse/MEX-2012
        if (!browser.ios) return;
        if (mediaSingleWrapperRef.current !== event.target) return;
        (_captionPlaceHolderRe = captionPlaceHolderRef.current) === null || _captionPlaceHolderRe === void 0 || _captionPlaceHolderRe.click();
    }, [
        mediaSingleWrapperRef,
        captionPlaceHolderRef
    ]);
    const onMediaSingleKeyDown = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useCallback((event)=>{
        if (mediaSingleWrapperRef.current !== event.target) return;
        if (event.key === 'Enter' || event.key === ' ') {
            var _captionPlaceHolderRe2;
            event.preventDefault();
            (_captionPlaceHolderRe2 = captionPlaceHolderRef.current) === null || _captionPlaceHolderRe2 === void 0 || _captionPlaceHolderRe2.click();
        }
    }, [
        mediaSingleWrapperRef,
        captionPlaceHolderRef
    ]);
    const clickPlaceholder = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useCallback(()=>{
        var _pluginInjectionApi$a;
        if (typeof getPos === 'boolean') return;
        (0, $9xRfX.insertAndSelectCaptionFromMediaSinglePos)(pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$a = pluginInjectionApi.analytics) === null || _pluginInjectionApi$a === void 0 ? void 0 : _pluginInjectionApi$a.actions)(getPos(), mediaNode)(view.state, view.dispatch);
    }, [
        view,
        getPos,
        mediaNode,
        pluginInjectionApi
    ]);
    const legacySize = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useMemo(()=>{
        return {
            width: mediaSingleWidthAttribute,
            widthType: widthType
        };
    }, [
        widthType,
        mediaSingleWidthAttribute
    ]);
    const MediaChildren = /*#__PURE__*/ (0, $9dQre.jsx)("figure", {
        ref: mediaSingleWrapperRef,
        css: $70f396cdad4c0642$var$figureWrapperStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $e35II.MediaSingleNodeSelector),
        onClick: notIos ? undefined : onMediaSingleClicked,
        onKeyDown: notIos ? undefined : onMediaSingleKeyDown
    }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $61dYH.MediaBadges), {
        mediaElement: currentMediaElement(),
        mediaHeight: height,
        mediaWidth: width,
        extendedResizeOffset: mediaOptions.allowPixelResizing && !isInsideTable
    }, ({ visible: visible })=>/*#__PURE__*/ (0, $9dQre.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, visible && /*#__PURE__*/ (0, $9dQre.jsx)((0, $ds6EJ.ExternalImageBadge), {
            type: childMediaNodeAttrs.type,
            url: childMediaNodeAttrs.type === 'external' ? childMediaNodeAttrs.url : undefined
        }), mediaOptions.allowCommentsOnMedia && /*#__PURE__*/ (0, $9dQre.jsx)((0, $a7lAS.CommentBadgeWrapper), {
            view: view,
            api: pluginInjectionApi,
            mediaNode: mediaNode === null || mediaNode === void 0 ? void 0 : mediaNode.firstChild,
            getPos: getPos,
            isDrafting: isCurrentNodeDrafting
        }))), /*#__PURE__*/ (0, $9dQre.jsx)((0, $5N9nM.NodeViewContentHole), {
        ref: forwardRef
    }), shouldShowPlaceholder && /*#__PURE__*/ (0, $9dQre.jsx)((0, $fEdwW.CaptionPlaceholderButton), {
        ref: captionPlaceHolderRef,
        onClick: clickPlaceholder,
        placeholderMessage: mediaOptions.allowImagePreview ? (0, $dGul0.captionMessages).placeholderWithDoubleClickPrompt : (0, $dGul0.captionMessages).placeholder
    }));
    if (widthType !== 'pixel') return /*#__PURE__*/ (0, $9dQre.jsx)((0, $bSJIT.Fragment), null, canResize ? mediaOptions.allowPixelResizing ? /*#__PURE__*/ (0, $9dQre.jsx)((0, $24yx2.default), {
        view: view,
        getPos: getPos,
        updateSize: updateSize,
        gridSize: 12,
        viewMediaClientConfig: viewMediaClientConfig,
        allowBreakoutSnapPoints: mediaOptions && mediaOptions.allowBreakoutSnapPoints,
        selected: isSelected,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        pluginInjectionApi: pluginInjectionApi,
        layout: layout,
        width: width,
        height: height,
        containerWidth: containerWidth,
        lineLength: contentWidth || $70f396cdad4c0642$var$FALLBACK_MOST_COMMON_WIDTH,
        fullWidthMode: fullWidthMode,
        hasFallbackContainer: false,
        mediaSingleWidth: mediaSingleWidth,
        editorAppearance: editorAppearance,
        showLegacyNotification: true,
        forceHandlePositioning: mediaOptions === null || mediaOptions === void 0 ? void 0 : mediaOptions.forceHandlePositioning
    }, MediaChildren) : /*#__PURE__*/ (0, $9dQre.jsx)((0, $bhAS0.default), {
        view: view,
        getPos: getPos,
        updateSize: updateSize,
        gridSize: 12,
        viewMediaClientConfig: viewMediaClientConfig,
        allowBreakoutSnapPoints: mediaOptions && mediaOptions.allowBreakoutSnapPoints,
        selected: isSelected,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        pluginInjectionApi: pluginInjectionApi,
        layout: layout,
        width: width,
        height: height,
        containerWidth: containerWidth,
        fullWidthMode: fullWidthMode,
        hasFallbackContainer: false,
        mediaSingleWidth: mediaSingleWidth,
        editorAppearance: editorAppearance,
        lineLength: contentWidthForLegacyExperience || $70f396cdad4c0642$var$FALLBACK_MOST_COMMON_WIDTH,
        pctWidth: mediaSingleWidthAttribute
    }, MediaChildren) : /*#__PURE__*/ (0, $9dQre.jsx)((0, $1mebE.default), {
        layout: layout,
        width: width,
        height: height,
        containerWidth: containerWidth,
        fullWidthMode: fullWidthMode,
        hasFallbackContainer: false,
        editorAppearance: editorAppearance,
        pctWidth: mediaSingleWidthAttribute,
        lineLength: lineLength || $70f396cdad4c0642$var$FALLBACK_MOST_COMMON_WIDTH,
        size: legacySize
    }, MediaChildren));
    return mediaOptions.allowPixelResizing ? /*#__PURE__*/ (0, $9dQre.jsx)((0, $24yx2.default), {
        view: view,
        getPos: getPos,
        updateSize: updateSize,
        gridSize: 12,
        viewMediaClientConfig: viewMediaClientConfig,
        allowBreakoutSnapPoints: mediaOptions && mediaOptions.allowBreakoutSnapPoints,
        selected: isSelected,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        pluginInjectionApi: pluginInjectionApi,
        layout: layout,
        width: width,
        height: height,
        containerWidth: containerWidth,
        lineLength: contentWidth || $70f396cdad4c0642$var$FALLBACK_MOST_COMMON_WIDTH,
        fullWidthMode: fullWidthMode,
        hasFallbackContainer: false,
        mediaSingleWidth: mediaSingleWidth,
        editorAppearance: editorAppearance,
        showLegacyNotification: widthType !== 'pixel',
        forceHandlePositioning: mediaOptions === null || mediaOptions === void 0 ? void 0 : mediaOptions.forceHandlePositioning,
        disableHandles: !canResize
    }, MediaChildren) : /*#__PURE__*/ (0, $9dQre.jsx)((0, $bhAS0.default), {
        view: view,
        getPos: getPos,
        updateSize: updateSize,
        gridSize: 12,
        viewMediaClientConfig: viewMediaClientConfig,
        allowBreakoutSnapPoints: mediaOptions && mediaOptions.allowBreakoutSnapPoints,
        selected: isSelected,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        pluginInjectionApi: pluginInjectionApi,
        layout: layout,
        width: width,
        height: height,
        containerWidth: containerWidth,
        fullWidthMode: fullWidthMode,
        hasFallbackContainer: false,
        mediaSingleWidth: mediaSingleWidth,
        editorAppearance: editorAppearance,
        lineLength: contentWidthForLegacyExperience || $70f396cdad4c0642$var$FALLBACK_MOST_COMMON_WIDTH,
        pctWidth: mediaSingleWidthAttribute,
        disableHandles: !canResize
    }, MediaChildren);
};

});
parcelRegister("lqqbp", function(module, exports) {
$parcel$export(module.exports, "getMaxWidthForNestedNode", () => $dc85891fb1ac036d$export$4147ff5cc31ec064);

var $acax3 = parcelRequire("acax3");

var $9PK5v = parcelRequire("9PK5v");
const $dc85891fb1ac036d$export$4147ff5cc31ec064 = (view, pos)=>{
    if (typeof pos !== 'number') return null;
    if ((0, $9PK5v.isRichMediaInsideOfBlockNode)(view, pos)) {
        const $pos = view.state.doc.resolve(pos);
        const domNode = view.nodeDOM($pos.pos);
        if ($pos.nodeAfter && (0, $acax3.floatingLayouts).indexOf($pos.nodeAfter.attrs.layout) > -1 && domNode && domNode.parentElement) return domNode.parentElement.offsetWidth;
        if (domNode instanceof HTMLElement) return domNode.offsetWidth;
    }
    return null;
};

});

parcelRegister("dGul0", function(module, exports) {
$parcel$export(module.exports, "captionMessages", () => $0a37ee835bd8f918$export$6a0665148042092b);

var $f0Pt4 = parcelRequire("f0Pt4");
const $0a37ee835bd8f918$export$6a0665148042092b = (0, $f0Pt4.defineMessages)({
    placeholder: {
        id: 'fabric.editor.captionPlaceholder',
        defaultMessage: 'Add a caption',
        description: 'Placeholder description for an empty (new) caption in the editor'
    },
    placeholderWithDoubleClickPrompt: {
        id: 'fabric.editor.captionPlaceholderWithDoubleClickPrompt',
        defaultMessage: 'Add a caption - double-click to preview',
        description: 'Placeholder description to prompt users to add a caption and double click media to preview'
    }
});

});

parcelRegister("9xRfX", function(module, exports) {
$parcel$export(module.exports, "selectCaptionFromMediaSinglePos", () => $9b51c5f87795223a$export$994ea9c3fa8e0b0c);
$parcel$export(module.exports, "insertAndSelectCaptionFromMediaSinglePos", () => $9b51c5f87795223a$export$a34e35a63d969ea1);

var $g6Qq4 = parcelRequire("g6Qq4");

var $gab48 = parcelRequire("gab48");
const $9b51c5f87795223a$export$994ea9c3fa8e0b0c = (mediaSingleNodePos, mediaSingleNode)=>(state, dispatch)=>{
        // node should have two children, media and caption
        if (mediaSingleNode.childCount !== 2) return false;
        if (dispatch) {
            const media = mediaSingleNode.child(0);
            const caption = mediaSingleNode.child(1);
            let tr = state.tr;
            tr = $9b51c5f87795223a$var$setSelectionAtEndOfCaption(tr, mediaSingleNodePos, media.nodeSize, caption.nodeSize);
            tr.setMeta('scrollIntoView', false);
            dispatch(tr);
        }
        return true;
    };
const $9b51c5f87795223a$export$a34e35a63d969ea1 = (editorAnalyticsAPI)=>(mediaSingleNodePos, mediaSingleNode)=>(state, dispatch)=>{
            if (typeof mediaSingleNodePos !== 'number') return false;
            let tr = state.tr;
            // node should have one child, media
            if (mediaSingleNode.childCount !== 1) return false;
            if (dispatch) {
                const schema = state.schema;
                const media = mediaSingleNode.child(0);
                const caption = schema.nodes.caption.create();
                tr = state.tr.insert(mediaSingleNodePos + media.nodeSize + 1, caption);
                tr = $9b51c5f87795223a$var$setSelectionAtEndOfCaption(tr, mediaSingleNodePos, media.nodeSize, caption.nodeSize);
                tr.setMeta('scrollIntoView', false);
                editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent({
                    action: (0, $g6Qq4.ACTION).ADDED,
                    eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
                    actionSubject: (0, $g6Qq4.ACTION_SUBJECT).MEDIA_SINGLE,
                    actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).CAPTION
                })(tr);
                dispatch(tr);
            }
            return true;
        };
const $9b51c5f87795223a$var$setSelectionAtEndOfCaption = (tr, mediaSingleNodePos, mediaNodeSize, captionNodeSize)=>{
    return (0, $gab48.setTextSelection)(mediaSingleNodePos + mediaNodeSize + captionNodeSize)(tr);
};

});

parcelRegister("fEdwW", function(module, exports) {
$parcel$export(module.exports, "CaptionPlaceholderButton", () => $d50ec662440cc33b$export$dfb3d25b53c36a0a);
/* eslint-disable @atlaskit/design-system/use-primitives-text */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $5cKiX = parcelRequire("5cKiX");

var $29qUP = parcelRequire("29qUP");

var $dGul0 = parcelRequire("dGul0");

var $aHbh3 = parcelRequire("aHbh3");

var $9BVpB = parcelRequire("9BVpB");
function $d50ec662440cc33b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d50ec662440cc33b$var$placeholderText = {
    name: "o2x9s",
    styles: "color:var(--ds-text-subtlest, #6B6E76)"
};
const $d50ec662440cc33b$var$placeholderButton = (0, $9BVpB.xcss)({
    width: '100%',
    marginTop: 'space.100'
});
const $d50ec662440cc33b$export$dfb3d25b53c36a0a = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).forwardRef(({ onClick: onClick, placeholderMessage: placeholderMessage }, ref)=>{
    const handleMouseDown = (0, $bSJIT.useCallback)((e)=>{
        // In firefox, button is focused when mouse down, which make editor lose focus
        // Hence we want to disabled it so that user can type in caption directly after click
        e.preventDefault();
    }, []);
    const computedPlaceholderMessage = placeholderMessage ? placeholderMessage : (0, $dGul0.captionMessages).placeholder;
    return /*#__PURE__*/ (0, $9dQre.jsx)((0, $aHbh3.Pressable), {
        ref: ref,
        backgroundColor: "color.background.neutral.subtle",
        onClick: onClick,
        onMouseDown: handleMouseDown,
        "data-id": (0, $29qUP.CAPTION_PLACEHOLDER_ID),
        testId: "caption-placeholder",
        padding: "space.0",
        xcss: $d50ec662440cc33b$var$placeholderButton
    }, /*#__PURE__*/ (0, $9dQre.jsx)("span", {
        css: $d50ec662440cc33b$var$placeholderText,
        id: (0, $29qUP.CAPTION_PLACEHOLDER_ID)
    }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $5cKiX.default), computedPlaceholderMessage)));
});

});

parcelRegister("a7lAS", function(module, exports) {
$parcel$export(module.exports, "CommentBadgeWrapper", () => $b03f5ba910a59718$export$28b46719ed075ab4);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $459x8 = parcelRequire("459x8");

var $6Ilty = parcelRequire("6Ilty");

var $5beht = parcelRequire("5beht");
const $b03f5ba910a59718$var$selector = (states)=>{
    var _states$annotationSta, _states$annotationSta2, _states$annotationSta3;
    return {
        selectedAnnotations: (_states$annotationSta = states.annotationState) === null || _states$annotationSta === void 0 ? void 0 : _states$annotationSta.selectedAnnotations,
        isInlineCommentViewClosed: (_states$annotationSta2 = states.annotationState) === null || _states$annotationSta2 === void 0 ? void 0 : _states$annotationSta2.isInlineCommentViewClosed,
        annotations: (_states$annotationSta3 = states.annotationState) === null || _states$annotationSta3 === void 0 ? void 0 : _states$annotationSta3.annotations
    };
};
const $b03f5ba910a59718$export$28b46719ed075ab4 = ({ api: api, mediaNode: mediaNode, view: view, getPos: getPos, isDrafting: isDrafting })=>{
    const [entered, setEntered] = (0, $bSJIT.useState)(false);
    const { selectedAnnotations: selectedAnnotations, isInlineCommentViewClosed: isInlineCommentViewClosed, annotations: annotations } = (0, $5beht.useSharedPluginStateWithSelector)(api, [
        'annotation'
    ], $b03f5ba910a59718$var$selector);
    const { state: { schema: { nodes: { media: media }, marks: { annotation: annotation } } }, state: state, dispatch: dispatch } = view;
    const status = (0, $bSJIT.useMemo)(()=>{
        if (!selectedAnnotations || !mediaNode) return 'default';
        return selectedAnnotations.some((annotation)=>!!mediaNode.marks.find((mark)=>mark.attrs.id === annotation.id)) && !isInlineCommentViewClosed ? 'active' : 'default';
    }, [
        selectedAnnotations,
        isInlineCommentViewClosed,
        mediaNode
    ]);
    const onClick = (0, $bSJIT.useCallback)(()=>{
        if (api !== null && api !== void 0 && api.annotation && mediaNode) {
            const { showCommentForBlockNode: showCommentForBlockNode } = api.annotation.actions;
            showCommentForBlockNode(mediaNode, (0, $459x8.VIEW_METHOD).BADGE)(state, dispatch);
        }
    }, [
        api === null || api === void 0 ? void 0 : api.annotation,
        dispatch,
        mediaNode,
        state
    ]);
    const pos = getPos();
    const hasNoComments = !Number.isFinite(pos) || !annotations || !mediaNode || mediaNode.type !== media || mediaNode.marks.every((maybeAnnotation)=>maybeAnnotation.type !== annotation || !(maybeAnnotation.attrs.id in annotations) || annotations[maybeAnnotation.attrs.id]);
    if (!isDrafting && hasNoComments || !mediaNode) return null;
    const maybeMediaSingleElement = view.domAtPos(pos + 1).node;
    const mediaSingleElement = maybeMediaSingleElement instanceof HTMLElement ? maybeMediaSingleElement : null;
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $6Ilty.CommentBadgeNext), {
        onClick: onClick,
        mediaSingleElement: mediaSingleElement,
        status: entered ? 'entered' : status,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onMouseEnter: ()=>setEntered(true),
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onMouseLeave: ()=>setEntered(false)
    });
};

});

parcelRegister("bhAS0", function(module, exports) {
$parcel$export(module.exports, "default", () => $0310501278993e50$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $6KmuY = parcelRequire("6KmuY");

var $e6onJ = parcelRequire("e6onJ");

var $73T1A = parcelRequire("73T1A");

var $gm0BY = parcelRequire("gm0BY");
var $20rxI = parcelRequire("20rxI");
var $hzHr6 = parcelRequire("hzHr6");
var $1nvog = parcelRequire("1nvog");
var $13E3v = parcelRequire("13E3v");
var $76GIX = parcelRequire("76GIX");

var $l9Hpy = parcelRequire("l9Hpy");

var $gab48 = parcelRequire("gab48");

var $5bbjm = parcelRequire("5bbjm");

var $3y2s4 = parcelRequire("3y2s4");

var $5N1Y4 = parcelRequire("5N1Y4");

var $tHQ9T = parcelRequire("tHQ9T");

var $1OqQl = parcelRequire("1OqQl");

var $2oPWA = parcelRequire("2oPWA");
class $0310501278993e50$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Component {
    componentDidUpdate(prevProps) {
        const offsetLeft = (0, $6KmuY.calculateOffsetLeft)(this.insideInlineLike, this.insideLayout, this.props.view.dom, this.wrapper);
        if (offsetLeft !== this.state.offsetLeft && offsetLeft >= 0) this.setState({
            offsetLeft: offsetLeft
        });
        // Handle undo, when the actual pctWidth changed,
        // we sync up with the internal state.
        if (prevProps.pctWidth !== this.props.pctWidth) this.setState({
            resizedPctWidth: this.props.pctWidth
        });
        return true;
    }
    get wrappedLayout() {
        return (0, $76GIX.wrappedLayouts).indexOf(this.props.layout) > -1;
    }
    // check if is inside of a table
    isNestedInTable() {
        const { table: table } = this.props.view.state.schema.nodes;
        if (!this.$pos) return false;
        return !!(0, $gab48.findParentNodeOfTypeClosestToPos)(this.$pos, table);
    }
    async componentDidMount() {
        const { viewMediaClientConfig: viewMediaClientConfig } = this.props;
        if (viewMediaClientConfig) await this.checkVideoFile(viewMediaClientConfig);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.viewMediaClientConfig !== nextProps.viewMediaClientConfig) this.checkVideoFile(nextProps.viewMediaClientConfig);
        if (this.props.layout !== nextProps.layout) this.checkLayout(this.props.layout, nextProps.layout);
    }
    async checkVideoFile(viewMediaClientConfig) {
        const $pos = this.$pos;
        if (!$pos || !viewMediaClientConfig) return;
        const mediaNode = this.props.view.state.doc.nodeAt($pos.pos + 1);
        const mediaType = mediaNode ? await (0, $tHQ9T.checkMediaType)(mediaNode, viewMediaClientConfig) : undefined;
        const isVideoFile = mediaType !== 'external' && mediaType !== 'image';
        if (this.state.isVideoFile !== isVideoFile) this.setState({
            isVideoFile: isVideoFile
        });
    }
    /**
   * When returning to center layout from a wrapped/aligned layout, it might actually
   * be wide or full-width
   */ checkLayout(oldLayout, newLayout) {
        const { resizedPctWidth: resizedPctWidth } = this.state;
        if ((0, $76GIX.wrappedLayouts).indexOf(oldLayout) > -1 && newLayout === 'center' && resizedPctWidth) {
            const layout = this.calcUnwrappedLayout(resizedPctWidth, this.calcPxWidth(newLayout));
            this.props.updateSize(resizedPctWidth, layout);
        }
    }
    get $pos() {
        if (typeof this.props.getPos !== 'function') return null;
        const pos = this.props.getPos();
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (Number.isNaN(pos) || typeof pos !== 'number') return null;
        // need to pass view because we may not get updated props in time
        return this.props.view.state.doc.resolve(pos);
    }
    /**
   * The maxmimum number of grid columns this node can resize to.
   */ get gridWidth() {
        const { gridSize: gridSize } = this.props;
        return !(this.wrappedLayout || this.insideInlineLike) ? gridSize / 2 : gridSize;
    }
    get insideInlineLike() {
        const $pos = this.$pos;
        if (!$pos) return false;
        const { listItem: listItem } = this.props.view.state.schema.nodes;
        return !!(0, $gab48.findParentNodeOfTypeClosestToPos)($pos, [
            listItem
        ]);
    }
    get insideLayout() {
        const $pos = this.$pos;
        if (!$pos) return false;
        const { layoutColumn: layoutColumn } = this.props.view.state.schema.nodes;
        return !!(0, $gab48.findParentNodeOfTypeClosestToPos)($pos, [
            layoutColumn
        ]);
    }
    render() {
        const { width: origWidth, height: origHeight, layout: layout, pctWidth: pctWidth, containerWidth: containerWidth, fullWidthMode: fullWidthMode, selected: selected, children: children } = this.props;
        const initialWidth = this.calcPxWidth(); // width with padding
        let ratio;
        if (origWidth) ratio = (origHeight / origWidth * 100).toFixed(3);
        const isLeftResizeHandleDisabled = (0, $5N1Y4.expValEquals)('platform_editor_lovability_resize_dividers_panels', 'isEnabled', true) || (0, $3y2s4.isExperimentEnabled)('platform_editor_remove_left_resize_handle');
        const enable = {};
        (0, $hzHr6.handleSides).forEach((side)=>{
            const oppositeSide = side === 'left' ? 'right' : 'left';
            if (this.props.disableHandles) {
                enable[side] = false;
                return;
            }
            // Disable the left handle up-front (except for layouts where it is the
            // only handle) before computing whether it would otherwise be enabled.
            if (side === 'left' && isLeftResizeHandleDisabled && (0, $1OqQl.leftHandleOnlyLayouts).indexOf(layout) === -1) {
                enable[side] = false;
                return;
            }
            enable[side] = [
                'full-width',
                'wide',
                'center'
            ].concat(`wrap-${oppositeSide}`).concat(`align-${(0, $1nvog.imageAlignmentMap)[oppositeSide]}`).indexOf(layout) > -1;
            if (side === 'left' && this.insideInlineLike) enable[side] = false;
        });
        const snapPointsProps = {
            $pos: this.$pos,
            akEditorWideLayoutWidth: (0, $5bbjm.akEditorWideLayoutWidth),
            allowBreakoutSnapPoints: this.props.allowBreakoutSnapPoints,
            containerWidth: this.props.containerWidth,
            gridSize: this.props.gridSize,
            gridWidth: this.gridWidth,
            insideInlineLike: this.insideInlineLike,
            insideLayout: this.insideLayout,
            isVideoFile: this.state.isVideoFile,
            lineLength: this.props.lineLength,
            offsetLeft: this.state.offsetLeft,
            wrappedLayout: this.wrappedLayout
        };
        const nestedInTableHandleStyles = (isNestedInTable)=>{
            if (!isNestedInTable) return;
            return {
                left: {
                    left: `calc(${"var(--ds-space-025, 2px)"} * -0.5)`,
                    paddingLeft: '0px'
                },
                right: {
                    right: `calc(${"var(--ds-space-025, 2px)"} * -0.5)`,
                    paddingRight: '0px'
                }
            };
        };
        return /*#__PURE__*/ (0, $9dQre.jsx)("div", {
            ref: this.saveWrapper,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            css: (0, $2oPWA.wrapperStyle)({
                layout: layout,
                isResized: !!pctWidth,
                containerWidth: containerWidth || origWidth,
                fullWidthMode: fullWidthMode,
                width: origWidth
            })
        }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $73T1A.default), {
            ...this.props,
            displayGrid: this.displayGrid,
            ratio: ratio,
            width: initialWidth,
            selected: selected,
            enable: enable,
            calcNewSize: this.calcNewSize,
            snapPoints: (0, $l9Hpy.calculateSnapPoints)(snapPointsProps),
            scaleFactor: !this.wrappedLayout && !this.insideInlineLike ? 2 : 1,
            highlights: this.highlights,
            nodeType: "media",
            dispatchAnalyticsEvent: this.props.dispatchAnalyticsEvent,
            // when cursor is located below a media with caption,
            // press “Up“ key will result cursor focus on an invalid position, (on the resize handler)
            // This workaround adds an empty div inside the resize handler to prevent the issue.
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            handleComponentFunc: ()=>/*#__PURE__*/ (0, $9dQre.jsx)("div", {
                    contentEditable: false
                }),
            handleStyles: nestedInTableHandleStyles(this.isNestedInTable())
        }, children));
    }
    constructor(...args){
        super(...args), this.hasResized = false, this.state = {
            offsetLeft: (0, $6KmuY.calculateOffsetLeft)(this.insideInlineLike, this.insideLayout, this.props.view.dom, undefined),
            isVideoFile: false
        }, this.displayGrid = (visible, gridType, highlight)=>{
            var _pluginInjectionApi$g;
            const { pluginInjectionApi: pluginInjectionApi, view: view } = this.props;
            pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$g = pluginInjectionApi.grid) === null || _pluginInjectionApi$g === void 0 || (_pluginInjectionApi$g = _pluginInjectionApi$g.actions) === null || _pluginInjectionApi$g === void 0 || _pluginInjectionApi$g.displayGrid(view)({
                visible: visible,
                gridType: gridType,
                highlight: highlight
            });
        }, this.calcNewSize = (newWidth, stop)=>{
            const { layout: layout, view: { state: state } } = this.props;
            if (!this.hasResized) {
                var _this$wrapper;
                const mediaDomEl = (_this$wrapper = this.wrapper) === null || _this$wrapper === void 0 ? void 0 : _this$wrapper.querySelector('div[data-prosemirror-node-name="media"]');
                if (mediaDomEl) {
                    const event = new CustomEvent('resized');
                    mediaDomEl === null || mediaDomEl === void 0 || mediaDomEl.dispatchEvent(event);
                }
                this.hasResized = true;
            }
            const newPct = (0, $20rxI.calcPctFromPx)(newWidth, this.props.lineLength) * 100;
            this.setState({
                resizedPctWidth: newPct
            });
            let newLayout = (0, $gab48.hasParentNodeOfType)(state.schema.nodes.table)(state.selection) ? layout : this.calcUnwrappedLayout(newPct, newWidth);
            if (newPct <= 100) {
                if (this.wrappedLayout && (stop ? newPct !== 100 : true)) newLayout = layout;
                return {
                    width: newPct,
                    layout: newLayout
                };
            } else return {
                width: this.props.pctWidth || null,
                layout: newLayout
            };
        }, this.calcUnwrappedLayout = (pct, width)=>{
            if (pct <= 100) return 'center';
            if (width <= (0, $5bbjm.akEditorWideLayoutWidth)) return 'wide';
            return 'full-width';
        }, this.calcColumnLeftOffset = ()=>{
            const { offsetLeft: offsetLeft } = this.state;
            return this.insideInlineLike ? (0, $gm0BY.calcColumnsFromPx)(offsetLeft, this.props.lineLength, this.props.gridSize) : 0;
        }, this.calcPxWidth = (useLayout)=>{
            const { width: origWidth = 0, height: origHeight, layout: layout, pctWidth: pctWidth, lineLength: lineLength, containerWidth: containerWidth, fullWidthMode: fullWidthMode, getPos: getPos, view: { state: state } } = this.props;
            const { resizedPctWidth: resizedPctWidth } = this.state;
            const pos = typeof getPos === 'function' ? getPos() : undefined;
            return (0, $e6onJ.calcMediaPxWidth)({
                origWidth: origWidth,
                origHeight: origHeight,
                pctWidth: pctWidth,
                state: state,
                containerWidth: {
                    width: containerWidth,
                    lineLength: lineLength
                },
                isFullWidthModeEnabled: fullWidthMode,
                layout: useLayout || layout,
                pos: pos,
                resizedPctWidth: resizedPctWidth
            });
        }, this.highlights = (newWidth, snapPoints)=>{
            const snapWidth = (0, $13E3v.snapTo)(newWidth, snapPoints);
            const { layoutColumn: layoutColumn, table: table, expand: expand, nestedExpand: nestedExpand, panel: panel, panel_c1: panel_c1 } = this.props.view.state.schema.nodes;
            const parentsToHideGridLines = (0, $5N1Y4.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? [
                layoutColumn,
                table,
                expand,
                nestedExpand,
                panel,
                panel_c1
            ].filter(Boolean) : [
                layoutColumn,
                table,
                expand,
                nestedExpand,
                panel
            ].filter(Boolean);
            if (this.$pos && !!(0, $gab48.findParentNodeOfTypeClosestToPos)(this.$pos, parentsToHideGridLines)) return [];
            if (snapWidth > (0, $5bbjm.akEditorWideLayoutWidth)) return [
                'full-width'
            ];
            const { layout: layout, lineLength: lineLength, gridSize: gridSize } = this.props;
            const columns = (0, $gm0BY.calcColumnsFromPx)(snapWidth, lineLength, gridSize);
            const columnWidth = Math.round(columns);
            const highlight = [];
            if (layout === 'wrap-left' || layout === 'align-start') highlight.push(0, columnWidth);
            else if (layout === 'wrap-right' || layout === 'align-end') highlight.push(gridSize, gridSize - columnWidth);
            else if (this.insideInlineLike) highlight.push(Math.round(columns + this.calcColumnLeftOffset()));
            else highlight.push(Math.floor((gridSize - columnWidth) / 2), Math.ceil((gridSize + columnWidth) / 2));
            return highlight;
        }, this.saveWrapper = (wrapper)=>this.wrapper = wrapper;
    }
}

});
parcelRegister("6KmuY", function(module, exports) {
$parcel$export(module.exports, "calculateOffsetLeft", () => $1557afe67af5e998$export$ab1f1890e4428242);
function $1557afe67af5e998$export$ab1f1890e4428242(insideInlineLike, insideLayout, pmViewDom, wrapper) {
    let offsetLeft = 0;
    if (wrapper && insideInlineLike && !insideLayout) {
        const currentNode = wrapper;
        const boundingRect = currentNode.getBoundingClientRect();
        offsetLeft = boundingRect.left - pmViewDom.getBoundingClientRect().left;
    }
    return offsetLeft;
}

});

parcelRegister("tHQ9T", function(module, exports) {
$parcel$export(module.exports, "checkMediaType", () => $c2da32fab5e26ce2$export$9573295345282b3b);

var $83J3A = parcelRequire("83J3A");
const $c2da32fab5e26ce2$export$9573295345282b3b = async (mediaNode, mediaClientConfig)=>{
    if (mediaNode.attrs.type === 'external') return 'external';
    if (!mediaNode.attrs.id) return;
    try {
        const fileState = await (0, $83J3A.getMediaClient)(mediaClientConfig).file.getCurrentState(mediaNode.attrs.id, {
            collectionName: mediaNode.attrs.collection
        });
        if (fileState && fileState.status !== 'error') return fileState.mediaType;
    } catch (err) {
    // return undefined in case of media client error
    }
};

});

parcelRegister("1OqQl", function(module, exports) {
$parcel$export(module.exports, "leftHandleOnlyLayouts", () => $8e5247d49c78a484$export$edbc9d69329c7c7a);
const $8e5247d49c78a484$export$edbc9d69329c7c7a = [
    'wrap-right',
    'align-end'
];

});

parcelRegister("2oPWA", function(module, exports) {
$parcel$export(module.exports, "wrapperStyle", () => $3057c06419ba62b6$export$c4d4f06a25de97f);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9dQre = parcelRequire("9dQre");

var $4v4Uu = parcelRequire("4v4Uu");
const $3057c06419ba62b6$export$c4d4f06a25de97f = (props)=>/*#__PURE__*/ (0, $9dQre.css)("&>div{", (0, $4v4Uu.MediaSingleDimensionHelper)(props), ";position:relative;clear:both;}");

});


parcelRegister("24yx2", function(module, exports) {
$parcel$export(module.exports, "default", () => $f3dfcd3b5caf398b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $2YfQG = parcelRequire("2YfQG");

var $cNIkg = parcelRequire("cNIkg");

var $hvKP4 = parcelRequire("hvKP4");
var $60wae = parcelRequire("60wae");
var $bXYDi = parcelRequire("bXYDi");
var $e57gg = parcelRequire("e57gg");

var $8oe6c = parcelRequire("8oe6c");

var $ktQmh = parcelRequire("ktQmh");

var $5AVwN = parcelRequire("5AVwN");

var $3N6yZ = parcelRequire("3N6yZ");

var $1HfwI = parcelRequire("1HfwI");

var $29qUP = parcelRequire("29qUP");

var $ab8ay = parcelRequire("ab8ay");

var $5LDnu = parcelRequire("5LDnu");

var $2j1Ci = parcelRequire("2j1Ci");

var $20rxI = parcelRequire("20rxI");
var $hzHr6 = parcelRequire("hzHr6");
var $1nvog = parcelRequire("1nvog");
var $76GIX = parcelRequire("76GIX");

var $6B1yf = parcelRequire("6B1yf");

var $cw0wu = parcelRequire("cw0wu");

var $gab48 = parcelRequire("gab48");

var $5bbjm = parcelRequire("5bbjm");

var $3y2s4 = parcelRequire("3y2s4");

var $797yE = parcelRequire("797yE");

var $5N1Y4 = parcelRequire("5N1Y4");

var $2jJHo = parcelRequire("2jJHo");

var $cbWfC = parcelRequire("cbWfC");

var $tHQ9T = parcelRequire("tHQ9T");

var $1OqQl = parcelRequire("1OqQl");

var $fT1dY = parcelRequire("fT1dY");

var $2oPWA = parcelRequire("2oPWA");
const $f3dfcd3b5caf398b$export$fe623d3106c02058 = 'mediaSingle.resizerNext.testid';
const $f3dfcd3b5caf398b$var$getNodePosition = (getPos)=>{
    if (typeof getPos !== 'function') return null;
    const pos = getPos();
    if (Number.isNaN(pos) || typeof pos !== 'number') return null;
    return pos;
};
const $f3dfcd3b5caf398b$var$calcPxHeight = (props)=>{
    const { newWidth: newWidth, previousWidth: previousWidth, previousHeight: previousHeight } = props;
    return Math.round(previousHeight / previousWidth * newWidth);
};
const $f3dfcd3b5caf398b$var$calcMinWidth = ({ isVideoFile: isVideoFile, contentWidth: contentWidth })=>{
    return Math.min(contentWidth || (0, $5bbjm.akEditorDefaultLayoutWidth), isVideoFile ? (0, $29qUP.MEDIA_SINGLE_VIDEO_MIN_PIXEL_WIDTH) : (0, $29qUP.MEDIA_SINGLE_DEFAULT_MIN_PIXEL_WIDTH));
};
const $f3dfcd3b5caf398b$var$calcMaxWidth = ({ containerWidth: containerWidth, editorAppearance: editorAppearance })=>{
    return (0, $1HfwI.calcMediaSingleMaxWidth)(containerWidth, editorAppearance);
};
const $f3dfcd3b5caf398b$var$setIsResizingPluginState = ({ isResizing: isResizing, nodePosition: nodePosition, initialWidth: initialWidth })=>(state, dispatch)=>{
        const tr = state.tr;
        tr.setMeta((0, $2jJHo.MEDIA_PLUGIN_IS_RESIZING_KEY), isResizing);
        tr.setMeta('is-resizer-resizing', isResizing);
        if (isResizing && typeof nodePosition === 'number') tr.setSelection((0, $cw0wu.NodeSelection).create(state.doc, nodePosition));
        if (isResizing && typeof initialWidth === 'number') tr.setMeta((0, $2jJHo.MEDIA_PLUGIN_RESIZING_WIDTH_KEY), initialWidth);
        if (dispatch) dispatch(tr);
        return true;
    };
const $f3dfcd3b5caf398b$var$calcUnwrappedLayout = (width, containerWidth, contentWidth, fullWidthMode, isNestedNode)=>{
    if (isNestedNode) return 'center';
    if (fullWidthMode) {
        if (width < contentWidth) return 'center';
        return 'full-width';
    }
    // handle top-level node in fixed-width editor
    if (width <= contentWidth) return 'center';
    const padding = containerWidth <= (0, $5bbjm.akEditorFullPageNarrowBreakout) && (0, $797yE.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    }) ? (0, $5bbjm.akEditorGutterPaddingReduced) : (0, $5bbjm.akEditorGutterPaddingDynamic)();
    if (width < Math.min(containerWidth - padding * 2, (0, $5bbjm.akEditorFullWidthLayoutWidth))) return 'wide';
    // set full width to be containerWidth - padding * 2
    // instead of containerWidth - akEditorBreakoutPadding,
    // so that we have image aligned with text
    return 'full-width';
};
const $f3dfcd3b5caf398b$var$calcNewLayout = ({ layout: layout, containerWidth: containerWidth, lineLength: lineLength, fullWidthMode: fullWidthMode, isNestedNode: isNestedNode })=>(newWidth, stop)=>{
        const newPct = (0, $20rxI.calcPctFromPx)(newWidth, lineLength) * 100;
        const wrappedLayout = (0, $76GIX.wrappedLayouts).indexOf(layout) > -1;
        if (newPct <= 100 && wrappedLayout) {
            if (!stop || newPct !== 100) return layout;
        }
        return $f3dfcd3b5caf398b$var$calcUnwrappedLayout(newWidth, containerWidth, lineLength, fullWidthMode, isNestedNode);
    };
const $f3dfcd3b5caf398b$var$calculateSizeState = (props)=>(size, delta, onResizeStop = false, aspectRatio)=>{
        const calculatedWidth = Math.round(size.width + delta.width);
        const calculatedWidthWithLayout = $f3dfcd3b5caf398b$var$calcNewLayout(props)(calculatedWidth, onResizeStop);
        return {
            width: calculatedWidth,
            height: calculatedWidth / aspectRatio,
            layout: calculatedWidthWithLayout
        };
    };
const $f3dfcd3b5caf398b$var$getAspectRatio = ({ width: width, height: height })=>{
    if (width && height > 0) return width / height;
    // TODO: ED-26962 - handle this case
    return 1;
};
const $f3dfcd3b5caf398b$var$updateSizeInPluginState = (0, (/*@__PURE__*/$parcel$interopDefault($cNIkg)))(({ width: width, view: view })=>{
    const { state: state, dispatch: dispatch } = view;
    const tr = state.tr;
    tr.setMeta((0, $2jJHo.MEDIA_PLUGIN_RESIZING_WIDTH_KEY), width);
    return dispatch(tr);
}, (0, $29qUP.MEDIA_SINGLE_RESIZE_THROTTLE_TIME));
const $f3dfcd3b5caf398b$export$4198575e34ea4b65 = (props)=>{
    const { width: origWidth, children: children, containerWidth: containerWidth, fullWidthMode: fullWidthMode, layout: layout, selected: selected, showLegacyNotification: showLegacyNotification, className: className, dispatchAnalyticsEvent: dispatchAnalyticsEvent, editorAppearance: editorAppearance, getPos: getPos, lineLength: lineLength, mediaSingleWidth: mediaSingleWidth, height: height, nodeType: nodeType, pluginInjectionApi: pluginInjectionApi, updateSize: updateSize, view: view, viewMediaClientConfig: viewMediaClientConfig, forceHandlePositioning: forceHandlePositioning, disableHandles: disableHandles } = props;
    const initialWidth = (0, $bSJIT.useMemo)(()=>{
        return mediaSingleWidth || (0, $29qUP.DEFAULT_IMAGE_WIDTH);
    }, [
        mediaSingleWidth
    ]);
    const [dimensions, setDimensions] = (0, $bSJIT.useState)({
        width: initialWidth,
        height: $f3dfcd3b5caf398b$var$calcPxHeight({
            newWidth: initialWidth,
            previousWidth: initialWidth,
            previousHeight: height
        })
    });
    const dimensionsRef = (0, $bSJIT.useRef)(dimensions);
    const lastSnappedGuidelineKeysRef = (0, $bSJIT.useRef)([]);
    const [snaps, setSnaps] = (0, $bSJIT.useState)({});
    const [isResizing, setIsResizing] = (0, $bSJIT.useState)(false);
    const [isVideoFile, setIsVideoFile] = (0, $bSJIT.useState)(false);
    const [hasResized, setHasResized] = (0, $bSJIT.useState)(false);
    const nodePosition = $f3dfcd3b5caf398b$var$getNodePosition(getPos);
    const isNestedNode = (0, $bSJIT.useMemo)(()=>{
        if (nodePosition === null) return false;
        const $pos = view.state.doc.resolve(nodePosition);
        return !!($pos && $pos.depth !== 0);
    }, [
        nodePosition,
        view
    ]);
    const isAdjacentMode = (0, $bSJIT.useMemo)(()=>{
        if (forceHandlePositioning === 'adjacent') return true;
        return isNestedNode;
    }, [
        isNestedNode,
        forceHandlePositioning
    ]);
    const maybeContainerWidth = containerWidth || origWidth;
    const memoizedCss = (0, $bSJIT.useMemo)(()=>{
        return (0, $2oPWA.wrapperStyle)({
            layout: layout,
            containerWidth: maybeContainerWidth,
            fullWidthMode: fullWidthMode,
            mediaSingleWidth: dimensions.width,
            isNestedNode: isAdjacentMode,
            isExtendedResizeExperienceOn: true
        });
    }, [
        layout,
        maybeContainerWidth,
        fullWidthMode,
        dimensions.width,
        isAdjacentMode
    ]);
    const maxWidth = (0, $bSJIT.useMemo)(()=>{
        if (editorAppearance === 'chromeless' && forceHandlePositioning === 'adjacent') return containerWidth - (0, $29qUP.MEDIA_SINGLE_ADJACENT_HANDLE_MARGIN) * 2;
        if (!isResizing && isAdjacentMode) return undefined;
        if (isAdjacentMode || fullWidthMode) return lineLength;
        if (!isResizing) return `var(--ak-editor-max-container-width)`;
        return $f3dfcd3b5caf398b$var$calcMaxWidth({
            containerWidth: containerWidth,
            editorAppearance: editorAppearance
        });
    }, [
        isAdjacentMode,
        fullWidthMode,
        lineLength,
        editorAppearance,
        containerWidth,
        isResizing,
        forceHandlePositioning
    ]);
    const minWidth = $f3dfcd3b5caf398b$var$calcMinWidth({
        isVideoFile: isVideoFile,
        contentWidth: lineLength
    });
    // while is not resizing, we take 100% as min-width if the container width is less than the min-width
    const minViewWidth = isResizing ? minWidth : `min(${minWidth}px, 100%)`;
    const resizerNextClassName = (0, $bSJIT.useMemo)(()=>{
        const classNameNext = (0, (/*@__PURE__*/$parcel$interopDefault($2YfQG)))((0, $5LDnu.richMediaClassName), `image-${layout}`, isResizing ? 'is-resizing' : 'not-resizing', className, (0, $2j1Ci.resizerItemClassName), {
            'display-handle': selected && !disableHandles,
            'richMedia-selected': selected,
            'rich-media-wrapped': layout === 'wrap-left' || layout === 'wrap-right'
        });
        return classNameNext;
    }, [
        className,
        disableHandles,
        isResizing,
        layout,
        selected
    ]);
    const isInsideInlineLike = (0, $bSJIT.useMemo)(()=>{
        if (nodePosition === null) return false;
        const $pos = view.state.doc.resolve(nodePosition);
        const { listItem: listItem } = view.state.schema.nodes;
        return !!(0, $gab48.findParentNodeOfTypeClosestToPos)($pos, [
            listItem
        ]);
    }, [
        nodePosition,
        view
    ]);
    const enable = (0, $bSJIT.useMemo)(()=>{
        if (disableHandles) return {
            left: false,
            right: false
        };
        const isLeftResizeHandleDisabled = (0, $5N1Y4.expValEquals)('platform_editor_lovability_resize_dividers_panels', 'isEnabled', true) || (0, $3y2s4.isExperimentEnabled)('platform_editor_remove_left_resize_handle');
        return (0, $hzHr6.handleSides).reduce((acc, side)=>{
            const oppositeSide = side === 'left' ? 'right' : 'left';
            // Disable the left handle up-front (except for layouts where it is the
            // only handle) before computing whether it would otherwise be enabled.
            if (side === 'left' && isLeftResizeHandleDisabled && (0, $1OqQl.leftHandleOnlyLayouts).indexOf(layout) === -1) {
                acc[side] = false;
                return acc;
            }
            acc[side] = (0, $6B1yf.nonWrappedLayouts).concat(`wrap-${oppositeSide}`).concat(`align-${(0, $1nvog.imageAlignmentMap)[oppositeSide]}`).indexOf(layout) > -1;
            if (side === 'left' && isInsideInlineLike) acc[side] = false;
            return acc;
        }, {});
    }, [
        disableHandles,
        layout,
        isInsideInlineLike
    ]);
    const defaultGuidelines = (0, $bSJIT.useMemo)(()=>{
        if (isAdjacentMode) return [];
        return (0, $8oe6c.generateDefaultGuidelines)(lineLength, containerWidth, fullWidthMode);
    }, [
        isAdjacentMode,
        lineLength,
        containerWidth,
        fullWidthMode
    ]);
    const relativeGuidesRef = (0, $bSJIT.useRef)({});
    const guidelinesRef = (0, $bSJIT.useRef)([]);
    const updateGuidelines = (0, $bSJIT.useCallback)(()=>{
        const { relativeGuides: relativeGuides, dynamicGuides: dynamicGuides } = (0, $ktQmh.generateDynamicGuidelines)(view.state, lineLength, {
            styles: {
                lineStyle: 'dashed'
            },
            show: false
        });
        // disable guidelines for nested media single node
        const dynamicGuidelines = isAdjacentMode ? [] : dynamicGuides;
        relativeGuidesRef.current = relativeGuides;
        guidelinesRef.current = [
            ...defaultGuidelines,
            ...dynamicGuidelines
        ];
    }, [
        view,
        lineLength,
        defaultGuidelines,
        isAdjacentMode
    ]);
    const isGuidelineEnabled = (0, $bSJIT.useMemo)(()=>{
        return !!(pluginInjectionApi !== null && pluginInjectionApi !== void 0 && pluginInjectionApi.guideline);
    }, [
        pluginInjectionApi
    ]);
    const handleResizeStart = (0, $bSJIT.useCallback)(()=>{
        setIsResizing(true);
        $f3dfcd3b5caf398b$var$setIsResizingPluginState({
            isResizing: true,
            nodePosition: nodePosition,
            initialWidth: dimensionsRef.current.width
        })(view.state, view.dispatch);
        if (isGuidelineEnabled) updateGuidelines();
    }, [
        view,
        nodePosition,
        updateGuidelines,
        isGuidelineEnabled
    ]);
    const getRelativeGuides = (0, $bSJIT.useCallback)(()=>{
        var _pluginInjectionApi$g;
        if (typeof nodePosition !== 'number') return [];
        const guidelinePluginState = pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$g = pluginInjectionApi.guideline) === null || _pluginInjectionApi$g === void 0 || (_pluginInjectionApi$g = _pluginInjectionApi$g.sharedState) === null || _pluginInjectionApi$g === void 0 ? void 0 : _pluginInjectionApi$g.currentState();
        const { top: topOffset } = (guidelinePluginState === null || guidelinePluginState === void 0 ? void 0 : guidelinePluginState.rect) || {
            top: 0,
            left: 0
        };
        const $pos = view.state.doc.resolve(nodePosition);
        const relativeGuides = $pos && $pos.nodeAfter && dimensionsRef.current.width ? (0, $5AVwN.getRelativeGuidelines)(relativeGuidesRef.current, {
            node: $pos.nodeAfter,
            pos: $pos.pos
        }, view, lineLength, topOffset, dimensionsRef.current) : [];
        return relativeGuides;
    }, [
        pluginInjectionApi,
        nodePosition,
        view,
        lineLength
    ]);
    const updateActiveGuidelines = (0, $bSJIT.useCallback)((width = 0, guidelines, guidelineSnapsReference)=>{
        var _pluginInjectionApi$g2;
        if (!guidelineSnapsReference.snaps.x) return;
        const { gap: gap, keys: activeGuidelineKeys } = (0, $hvKP4.findClosestSnap)(width, guidelineSnapsReference.snaps.x, guidelineSnapsReference.guidelineReference, (0, $29qUP.MEDIA_SINGLE_SNAP_GAP));
        const relativeGuidelines = activeGuidelineKeys.length ? [] : getRelativeGuides();
        lastSnappedGuidelineKeysRef.current = activeGuidelineKeys.length ? activeGuidelineKeys : relativeGuidelines.map((rg)=>rg.key);
        const nextGuideLines = [
            ...(0, $3N6yZ.getGuidelinesWithHighlights)(gap, (0, $29qUP.MEDIA_SINGLE_SNAP_GAP), activeGuidelineKeys, guidelines),
            ...relativeGuidelines
        ];
        pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$g2 = pluginInjectionApi.guideline) === null || _pluginInjectionApi$g2 === void 0 || (_pluginInjectionApi$g2 = _pluginInjectionApi$g2.actions) === null || _pluginInjectionApi$g2 === void 0 || _pluginInjectionApi$g2.displayGuideline(view)({
            guidelines: nextGuideLines
        });
    }, [
        getRelativeGuides,
        pluginInjectionApi,
        view
    ]);
    const aspectRatioRef = (0, $bSJIT.useRef)($f3dfcd3b5caf398b$var$getAspectRatio({
        width: props.width,
        height: props.height
    }));
    const resizerContainerRef = (0, $bSJIT.useRef)(null);
    const handleResize = (0, $bSJIT.useCallback)((size, delta)=>{
        const { width: width, height: height, layout: newLayout } = $f3dfcd3b5caf398b$var$calculateSizeState({
            layout: layout,
            containerWidth: containerWidth,
            lineLength: lineLength,
            fullWidthMode: fullWidthMode,
            isNestedNode: isAdjacentMode
        })(size, delta, false, aspectRatioRef.current);
        const resizerDomEl = resizerContainerRef.current;
        if (resizerDomEl && !hasResized) {
            // dispatch resize event to media node DOM element inside resizerDom
            const mediaDomEl = resizerDomEl.querySelector('div[data-prosemirror-node-name="media"]');
            const event = new CustomEvent('resized');
            mediaDomEl === null || mediaDomEl === void 0 || mediaDomEl.dispatchEvent(event);
            setHasResized(true);
        }
        if (isGuidelineEnabled) {
            const guidelineSnaps = (0, $60wae.getGuidelineSnaps)(guidelinesRef.current, lineLength, layout);
            updateActiveGuidelines(width, guidelinesRef.current, guidelineSnaps);
            const relativeSnaps = (0, $e57gg.getRelativeGuideSnaps)(relativeGuidesRef.current, aspectRatioRef.current);
            setSnaps({
                x: [
                    ...guidelineSnaps.snaps.x || [],
                    ...relativeSnaps
                ]
            });
        }
        setDimensions({
            width: width,
            height: height
        });
        $f3dfcd3b5caf398b$var$updateSizeInPluginState({
            width: width,
            view: view
        });
        if (newLayout !== layout) updateSize(width, newLayout);
    }, [
        layout,
        containerWidth,
        lineLength,
        fullWidthMode,
        isAdjacentMode,
        hasResized,
        isGuidelineEnabled,
        view,
        updateActiveGuidelines,
        updateSize
    ]);
    const handleResizeStop = (0, $bSJIT.useCallback)((size, delta)=>{
        var _pluginInjectionApi$g3;
        if (typeof nodePosition !== 'number') return;
        const { width: width, height: height, layout: newLayout } = $f3dfcd3b5caf398b$var$calculateSizeState({
            layout: layout,
            containerWidth: containerWidth,
            lineLength: lineLength,
            fullWidthMode: fullWidthMode,
            isNestedNode: isAdjacentMode
        })(size, delta, false, aspectRatioRef.current);
        if (dispatchAnalyticsEvent) {
            const $pos = view.state.doc.resolve(nodePosition);
            const event = (0, $cbWfC.getMediaResizeAnalyticsEvent)(nodeType || 'mediaSingle', {
                width: width,
                layout: newLayout,
                widthType: 'pixel',
                snapType: (0, $bXYDi.getGuidelineTypeFromKey)(lastSnappedGuidelineKeysRef.current, guidelinesRef.current),
                parentNode: $pos ? $pos.parent.type.name : undefined,
                inputMethod: 'mouse'
            });
            if (event) dispatchAnalyticsEvent(event);
        }
        setIsResizing(false);
        $f3dfcd3b5caf398b$var$setIsResizingPluginState({
            isResizing: false
        })(view.state, view.dispatch);
        pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$g3 = pluginInjectionApi.guideline) === null || _pluginInjectionApi$g3 === void 0 || (_pluginInjectionApi$g3 = _pluginInjectionApi$g3.actions) === null || _pluginInjectionApi$g3 === void 0 || _pluginInjectionApi$g3.displayGuideline(view)({
            guidelines: []
        });
        let newWidth = width;
        if (newLayout === 'full-width') // When a node reaches full width in current viewport,
        // update its width with 1800 to align with pixel entry
        newWidth = (0, $5bbjm.akEditorFullWidthLayoutWidth);
        setDimensions({
            width: newWidth,
            height: height
        });
        updateSize(newWidth, newLayout);
    }, [
        nodeType,
        dispatchAnalyticsEvent,
        containerWidth,
        fullWidthMode,
        isAdjacentMode,
        layout,
        lineLength,
        view,
        nodePosition,
        pluginInjectionApi,
        updateSize
    ]);
    const mountedRef = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useRef(true);
    (0, $bSJIT.useLayoutEffect)(()=>{
        mountedRef.current = true;
        return ()=>{
            mountedRef.current = false;
        };
    }, []);
    (0, $bSJIT.useLayoutEffect)(()=>{
        setDimensions({
            width: initialWidth,
            height: $f3dfcd3b5caf398b$var$calcPxHeight({
                newWidth: initialWidth,
                previousWidth: initialWidth,
                previousHeight: height
            })
        });
    }, [
        initialWidth,
        height
    ]);
    (0, $bSJIT.useEffect)(()=>{
        dimensionsRef.current = dimensions;
    }, [
        dimensions
    ]);
    (0, $bSJIT.useEffect)(()=>{
        if (!viewMediaClientConfig || typeof nodePosition !== 'number') return;
        const mediaNode = view.state.doc.nodeAt(nodePosition + 1);
        if (!mediaNode) return;
        (0, $tHQ9T.checkMediaType)(mediaNode, viewMediaClientConfig).then((mediaType)=>{
            if (mountedRef.current) {
                const isVideoFile = mediaType !== 'external' && mediaType !== 'image';
                setIsVideoFile(isVideoFile);
            }
        });
    }, [
        view,
        viewMediaClientConfig,
        nodePosition
    ]);
    const handlePositioning = (0, $bSJIT.useMemo)(()=>{
        if (forceHandlePositioning) return forceHandlePositioning;
        return isAdjacentMode ? 'adjacent' : undefined;
    }, [
        forceHandlePositioning,
        isAdjacentMode
    ]);
    return /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: memoizedCss,
        ref: resizerContainerRef
    }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $ab8ay.default), {
        minWidth: minViewWidth,
        maxWidth: maxWidth,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resizerNextClassName,
        snapGap: (0, $29qUP.MEDIA_SINGLE_SNAP_GAP),
        enable: enable,
        width: dimensions.width,
        handleResizeStart: handleResizeStart,
        handleResize: handleResize,
        handleResizeStop: handleResizeStop,
        snap: snaps,
        resizeRatio: (0, $6B1yf.nonWrappedLayouts).includes(layout) ? 2 : 1,
        "data-testid": $f3dfcd3b5caf398b$export$fe623d3106c02058,
        isHandleVisible: selected && !disableHandles,
        handlePositioning: handlePositioning,
        handleHighlight: "full-height"
    }, children, showLegacyNotification && /*#__PURE__*/ (0, $9dQre.jsx)((0, $fT1dY.ResizableMediaMigrationNotification), null)));
};
const $f3dfcd3b5caf398b$var$ResizableMediaSingleToggle = ({ allowBreakoutSnapPoints: allowBreakoutSnapPoints, children: children, className: className, containerWidth: containerWidth, dataAttributes: dataAttributes, disableHandles: disableHandles, dispatchAnalyticsEvent: dispatchAnalyticsEvent, editorAppearance: editorAppearance, fullWidthMode: fullWidthMode, getPos: getPos, gridSize: gridSize, handleMediaSingleRef: handleMediaSingleRef, hasFallbackContainer: hasFallbackContainer, height: height, isInsideOfInlineExtension: isInsideOfInlineExtension, isLoading: isLoading, layout: layout, lineLength: lineLength, mediaSingleWidth: mediaSingleWidth, nodeType: nodeType, pctWidth: pctWidth, pluginInjectionApi: pluginInjectionApi, selected: selected, showLegacyNotification: showLegacyNotification, size: size, updateSize: updateSize, view: view, viewMediaClientConfig: viewMediaClientConfig, width: width, forceHandlePositioning: forceHandlePositioning })=>{
    return /*#__PURE__*/ (0, $9dQre.jsx)($f3dfcd3b5caf398b$export$4198575e34ea4b65, {
        allowBreakoutSnapPoints: allowBreakoutSnapPoints,
        // eslint-disable-next-line react/no-children-prop
        children: children,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        containerWidth: containerWidth,
        dataAttributes: dataAttributes,
        disableHandles: disableHandles,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        editorAppearance: editorAppearance,
        fullWidthMode: fullWidthMode,
        getPos: getPos,
        gridSize: gridSize,
        handleMediaSingleRef: handleMediaSingleRef,
        hasFallbackContainer: hasFallbackContainer,
        height: height,
        isInsideOfInlineExtension: isInsideOfInlineExtension,
        isLoading: isLoading,
        layout: layout,
        lineLength: lineLength,
        mediaSingleWidth: mediaSingleWidth,
        nodeType: nodeType,
        pctWidth: pctWidth,
        pluginInjectionApi: pluginInjectionApi,
        selected: selected,
        showLegacyNotification: showLegacyNotification,
        size: size,
        updateSize: updateSize,
        view: view,
        viewMediaClientConfig: viewMediaClientConfig,
        width: width,
        forceHandlePositioning: forceHandlePositioning
    });
};
var $f3dfcd3b5caf398b$export$2e2bcd8739ae039 = $f3dfcd3b5caf398b$var$ResizableMediaSingleToggle;

});
parcelRegister("hvKP4", function(module, exports) {
$parcel$export(module.exports, "findClosestSnap", () => $02e82a9847f27d9e$export$5ea7b9558ea477a);

var $96olQ = parcelRequire("96olQ");
const $02e82a9847f27d9e$export$5ea7b9558ea477a = (mediaSingleWidth, snapArray, guidelineSnaps, snapGap = 0)=>{
    const closestGapIndex = snapArray.reduce((prev, curr, index)=>Math.abs(curr - mediaSingleWidth) < Math.abs(snapArray[prev] - mediaSingleWidth) ? index : prev, 0);
    const gap = Math.abs(snapArray[closestGapIndex] - mediaSingleWidth);
    if (gap < snapGap) {
        const snappingWidth = snapArray[closestGapIndex];
        const guidelineKeys = [];
        // find wich guideline have the matching snap width
        guidelineSnaps.forEach((gs)=>{
            if (gs.width === snappingWidth) guidelineKeys.push(gs.guidelineKey);
        });
        const defaultGuidelineKeys = guidelineKeys.filter((guidelineKey)=>!guidelineKey.startsWith((0, $96olQ.MEDIA_DYNAMIC_GUIDELINE_PREFIX)));
        return {
            gap: gap,
            // only highlight default guidelines
            // when there are both default and dynamic guidelines to be highlighted
            keys: defaultGuidelineKeys.length && defaultGuidelineKeys.length < guidelineKeys.length ? defaultGuidelineKeys : guidelineKeys
        };
    }
    return {
        gap: gap,
        keys: []
    };
};

});
parcelRegister("96olQ", function(module, exports) {
$parcel$export(module.exports, "MEDIA_DYNAMIC_GUIDELINE_PREFIX", () => $a930d7685df2431a$export$4ff81dc131aec9c3);
const $a930d7685df2431a$export$4ff81dc131aec9c3 = 'media_';
const $a930d7685df2431a$export$74e673d6ab2f5668 = 'grid_';

});


parcelRegister("60wae", function(module, exports) {
$parcel$export(module.exports, "getGuidelineSnaps", () => $1c6da9961e64419a$export$da9fa72115c158e6);

var $57l7A = parcelRequire("57l7A");

var $6RJYH = parcelRequire("6RJYH");
const $1c6da9961e64419a$export$da9fa72115c158e6 = (0, $57l7A.default)((guidelines, editorWidth, layout = 'center')=>{
    const offset = editorWidth / 2;
    const getPositionX = (position)=>{
        return (0, $6RJYH.isVerticalPosition)(position) ? position.x : 0;
    };
    const calcXSnaps = (guidelineReference)=>{
        const snapsWidth = guidelineReference.filter((g)=>g.width > 0).map((g)=>g.width);
        const uniqueSnapWidth = [
            ...new Set(snapsWidth)
        ];
        return snapsWidth.length ? uniqueSnapWidth : undefined;
    };
    const guidelinesSnapsReference = guidelines.map((guideline)=>{
        const positionX = getPositionX(guideline.position);
        if ([
            'align-end',
            'wrap-right'
        ].includes(layout)) return {
            guidelineKey: guideline.key,
            width: offset - positionX
        };
        else if ([
            'align-start',
            'wrap-left'
        ].includes(layout)) return {
            guidelineKey: guideline.key,
            width: positionX + offset
        };
        return {
            guidelineKey: guideline.key,
            width: Math.abs(positionX) * 2
        };
    });
    return {
        guidelineReference: guidelinesSnapsReference,
        snaps: {
            x: calcXSnaps(guidelinesSnapsReference)
        }
    };
});

});

parcelRegister("bXYDi", function(module, exports) {
$parcel$export(module.exports, "getGuidelineTypeFromKey", () => $e569125f2fe12efc$export$3fa50479f031580);
const $e569125f2fe12efc$export$3fa50479f031580 = (keys, guidelines)=>{
    if (guidelines.length === 0) return 'none';
    // Check for default guidelines on key
    if (keys.some((key)=>[
            'grid_',
            'wide_',
            'full_width'
        ].some((defaultGuideline)=>key.indexOf(defaultGuideline) >= 0))) return 'default';
    // Check for temporary guidelines
    if (keys.some((key)=>[
            'media_'
        ].some((temoporaryGuideline)=>key.indexOf(temoporaryGuideline) >= 0))) return 'temporary';
    // Check for relative guidelines
    if (keys.some((key)=>[
            'relative_'
        ].some((relativeGuideline)=>key.indexOf(relativeGuideline) >= 0))) return 'relative';
    return 'none';
};

});

parcelRegister("e57gg", function(module, exports) {
$parcel$export(module.exports, "getRelativeGuideSnaps", () => $bd14706c4f7f4e17$export$ec77024f2efeedc5);

var $jXvSl = parcelRequire("jXvSl");
const $bd14706c4f7f4e17$export$ec77024f2efeedc5 = (relativeGuides, aspectRatio)=>{
    const snapsWidthFromMatchingHeight = Object.keys(relativeGuides.height || {}).map((heightKey)=>{
        const height = Number.parseInt(heightKey);
        return (0, $jXvSl.roundToNearest)(height * aspectRatio);
    });
    const snapsWidthFromMatchingWidth = Object.keys(relativeGuides.width || {}).map((widthKey)=>{
        return Number.parseInt(widthKey);
    });
    return [
        ...snapsWidthFromMatchingWidth,
        ...snapsWidthFromMatchingHeight
    ];
};

});
parcelRegister("jXvSl", function(module, exports) {
$parcel$export(module.exports, "roundToNearest", () => $62637a0a48b69d9c$export$f72673597dacfcfa);

var $29qUP = parcelRequire("29qUP");
const $62637a0a48b69d9c$export$f72673597dacfcfa = (value, interval = (0, $29qUP.DEFAULT_ROUNDING_INTERVAL))=>Math.round(value / interval) * interval;

});


parcelRegister("8oe6c", function(module, exports) {
$parcel$export(module.exports, "generateDefaultGuidelines", () => $8626f3971635ea24$export$9e51f24cdc2ab89d);

var $57l7A = parcelRequire("57l7A");

var $5bbjm = parcelRequire("5bbjm");

var $jXvSl = parcelRequire("jXvSl");

var $2iwyg = parcelRequire("2iwyg");
const $8626f3971635ea24$var$getDefaultGuidelines = (0, $57l7A.default)((editorWidth)=>{
    return [
        -6,
        -5,
        -4,
        -3,
        -2,
        -1,
        0,
        1,
        2,
        3,
        4,
        5,
        6
    ].map((val, index)=>({
            key: `grid_${index}`,
            position: {
                x: (0, $jXvSl.roundToNearest)(val / 12 * editorWidth)
            }
        }));
});
const $8626f3971635ea24$var$getWideGuidelines = (0, $57l7A.default)((editorWidth)=>{
    const wideSpacing = (0, $jXvSl.roundToNearest)(editorWidth * (0, $5bbjm.breakoutWideScaleRatio) / 2);
    return [
        {
            key: `wide_left`,
            position: {
                x: -wideSpacing
            }
        },
        {
            key: `wide_right`,
            position: {
                x: wideSpacing
            }
        }
    ];
});
const $8626f3971635ea24$var$getFullWidthGuidelines = (0, $57l7A.default)((containerWidth)=>{
    const fullWidth = (0, $jXvSl.roundToNearest)((0, $2iwyg.getContainerWidthOrFullEditorWidth)(containerWidth));
    return [
        {
            key: `full_width_left`,
            position: {
                x: -fullWidth
            }
        },
        {
            key: `full_width_right`,
            position: {
                x: fullWidth
            }
        }
    ];
});
const $8626f3971635ea24$export$9e51f24cdc2ab89d = (editorWidth, containerWidth, isFullWidthMode = false)=>{
    const innerGrids = $8626f3971635ea24$var$getDefaultGuidelines(editorWidth);
    const wideGuidelines = !isFullWidthMode ? $8626f3971635ea24$var$getWideGuidelines(editorWidth) : [];
    const fullWidthGuidelines = !isFullWidthMode ? $8626f3971635ea24$var$getFullWidthGuidelines(containerWidth) : [];
    return [
        ...innerGrids,
        ...wideGuidelines,
        ...fullWidthGuidelines
    ];
};

});
parcelRegister("2iwyg", function(module, exports) {
$parcel$export(module.exports, "getContainerWidthOrFullEditorWidth", () => $c01459c18d4d2abb$export$d52a13210f6817c5);

var $5bbjm = parcelRequire("5bbjm");

var $797yE = parcelRequire("797yE");
const $c01459c18d4d2abb$export$d52a13210f6817c5 = (containerWidth)=>{
    const padding = containerWidth <= (0, $5bbjm.akEditorFullPageNarrowBreakout) && (0, $797yE.editorExperiment)('platform_editor_preview_panel_responsiveness', true, {
        exposure: true
    }) ? (0, $5bbjm.akEditorGutterPaddingReduced) : (0, $5bbjm.akEditorGutterPaddingDynamic)();
    return Math.min(containerWidth - padding * 2, (0, $5bbjm.akEditorFullWidthLayoutWidth)) / 2;
};

});


parcelRegister("ktQmh", function(module, exports) {
$parcel$export(module.exports, "generateDynamicGuidelines", () => $dfa948a52753fcf0$export$54d414ee882d8753);

var $cw0wu = parcelRequire("cw0wu");

var $gab48 = parcelRequire("gab48");

var $jXvSl = parcelRequire("jXvSl");

var $96olQ = parcelRequire("96olQ");

var $bgi9e = parcelRequire("bgi9e");
const $dfa948a52753fcf0$export$54d414ee882d8753 = (state, editorWidth, styles = {})=>{
    const selectedNode = state.selection instanceof (0, $cw0wu.NodeSelection) && state.selection.node;
    const offset = editorWidth / 2;
    return (0, $gab48.findChildren)(state.tr.doc, (node)=>node.type === state.schema.nodes.mediaSingle).reduce((acc, nodeWithPos, index)=>{
        var _acc$relativeGuides, _acc$relativeGuides2;
        const { node: node, pos: pos } = nodeWithPos;
        // if the current node the selected node
        // or the node is not using pixel width,
        // We will skip the node.
        if (selectedNode === node || node.attrs.widthType !== 'pixel') return acc;
        const $pos = state.tr.doc.resolve(pos);
        if ($pos.parent.type !== state.schema.nodes.doc) return acc;
        const dimensions = (0, $bgi9e.getMediaSingleDimensions)(node, editorWidth);
        if (!dimensions) return acc;
        const { width: width, height: height } = dimensions;
        const dynamicGuides = [
            ...acc.dynamicGuides,
            ...$dfa948a52753fcf0$var$getDynamicGuides(node.attrs.layout, width, offset, `${(0, $96olQ.MEDIA_DYNAMIC_GUIDELINE_PREFIX)}${index}`, styles)
        ];
        const accRelativeGuidesWidth = ((_acc$relativeGuides = acc.relativeGuides) === null || _acc$relativeGuides === void 0 ? void 0 : _acc$relativeGuides.width) || {};
        const accRelativeGuidesHeight = ((_acc$relativeGuides2 = acc.relativeGuides) === null || _acc$relativeGuides2 === void 0 ? void 0 : _acc$relativeGuides2.height) || {};
        const relativeGuidesWidth = {
            ...accRelativeGuidesWidth,
            [width]: [
                ...accRelativeGuidesWidth[width] || [],
                nodeWithPos
            ]
        };
        const relativeGuidesWidthHeight = {
            ...accRelativeGuidesHeight,
            [Math.round(height)]: [
                ...accRelativeGuidesHeight[height] || [],
                nodeWithPos
            ]
        };
        return {
            dynamicGuides: dynamicGuides,
            relativeGuides: {
                width: relativeGuidesWidth,
                height: relativeGuidesWidthHeight
            }
        };
    }, {
        relativeGuides: {
            width: {},
            height: {}
        },
        dynamicGuides: []
    });
};
const $dfa948a52753fcf0$var$getDynamicGuides = (layout, width, offset, key, styles)=>{
    switch(layout){
        case 'align-start':
        case 'wrap-left':
            return [
                {
                    position: {
                        x: (0, $jXvSl.roundToNearest)(width - offset)
                    },
                    key: key,
                    ...styles
                }
            ];
        case 'align-end':
        case 'wrap-right':
            return [
                {
                    position: {
                        x: (0, $jXvSl.roundToNearest)(offset - width)
                    },
                    key: key,
                    ...styles
                }
            ];
        case 'center':
            return [
                {
                    position: {
                        x: (0, $jXvSl.roundToNearest)(width / 2)
                    },
                    key: `${key}_right`,
                    ...styles
                },
                {
                    position: {
                        x: -(0, $jXvSl.roundToNearest)(width / 2)
                    },
                    key: `${key}_left`,
                    ...styles
                }
            ];
        default:
            return [];
    }
};

});
parcelRegister("bgi9e", function(module, exports) {
$parcel$export(module.exports, "getMediaSingleDimensions", () => $cc828b48ff730ad6$export$c7bf42817f6e4244);

var $5bbjm = parcelRequire("5bbjm");

var $b4Rwt = parcelRequire("b4Rwt");
var $jXvSl = parcelRequire("jXvSl");
const $cc828b48ff730ad6$export$c7bf42817f6e4244 = (mediaSingle, editorWidth = (0, $5bbjm.akEditorDefaultLayoutWidth))=>{
    if (mediaSingle.type !== mediaSingle.type.schema.nodes.mediaSingle) return null;
    const mediaNode = mediaSingle.firstChild;
    const { width: width, height: height } = (mediaNode === null || mediaNode === void 0 ? void 0 : mediaNode.attrs) || {};
    // e.g. external image
    if (!width || !height) return null;
    const ratio = parseFloat((height / width).toFixed(2));
    if (!mediaSingle.attrs.width) return {
        width: width,
        height: height,
        originalWidth: width,
        originalHeight: height,
        ratio: ratio
    };
    const pixelWidth = (0, $b4Rwt.getMediaSinglePixelWidth)(mediaSingle.attrs.width, editorWidth, mediaSingle.attrs.widthType);
    return {
        width: (0, $jXvSl.roundToNearest)(pixelWidth),
        height: (0, $jXvSl.roundToNearest)(pixelWidth * ratio),
        originalWidth: width,
        originalHeight: height,
        ratio: ratio
    };
};

});


parcelRegister("5AVwN", function(module, exports) {
$parcel$export(module.exports, "getRelativeGuidelines", () => $9f714e569e5501e0$export$73b4064129fc756b);

var $bgi9e = parcelRequire("bgi9e");

const $9f714e569e5501e0$var$RELATIVE_GUIDES_GAP = 6;
const $9f714e569e5501e0$var$getWidthRelativeGuideline = (key, view, nodeWithPos, editorWidth, topOffset, size)=>{
    const { node: node, pos: pos } = nodeWithPos;
    const { height: viewHeight } = view.dom.getBoundingClientRect();
    const { top: top } = view.coordsAtPos(pos + 1); // media node
    const { width: width, height: height } = size || (0, $bgi9e.getMediaSingleDimensions)(node, editorWidth) || {};
    const y = top - topOffset - $9f714e569e5501e0$var$RELATIVE_GUIDES_GAP;
    if (!width || !height || y < 0 || y > viewHeight) return null;
    let start = 0;
    let end = 0;
    switch(node.attrs.layout){
        case 'align-start':
        case 'wrap-left':
            start = -editorWidth / 2;
            end = start + width;
            break;
        case 'align-end':
        case 'wrap-right':
            end = editorWidth / 2;
            start = end - width;
            break;
        case 'center':
        case 'wide':
        case 'full-width':
            end = width / 2;
            start = -end;
            break;
        default:
    }
    return {
        key: key,
        position: {
            y: y,
            x: {
                start: start,
                end: end
            }
        },
        active: true,
        styles: {
            lineStyle: 'dashed',
            capStyle: 'line'
        }
    };
};
const $9f714e569e5501e0$var$getHeightRelativeGuideline = (key, view, nodeWithPos, editorWidth, topOffset, size)=>{
    const { node: node, pos: pos } = nodeWithPos;
    const { height: viewHeight } = view.dom.getBoundingClientRect();
    const { top: top } = view.coordsAtPos(pos + 1); // media node
    const { width: width, height: height } = size || (0, $bgi9e.getMediaSingleDimensions)(node, editorWidth) || {};
    if (!width || !height) return null;
    const start = top - topOffset;
    const end = start + height;
    if (end < 0 || start > viewHeight) return null;
    let x = 0;
    const halfWidth = editorWidth / 2;
    switch(node.attrs.layout){
        case 'align-start':
        case 'wrap-left':
            x = width - halfWidth;
            break;
        case 'align-end':
        case 'wrap-right':
            x = halfWidth;
            break;
        case 'center':
        case 'wide':
        case 'full-width':
            x = width / 2;
            break;
        default:
            x = 0;
    }
    return {
        key: key,
        position: {
            x: x + $9f714e569e5501e0$var$RELATIVE_GUIDES_GAP,
            y: {
                start: start,
                end: end
            }
        },
        active: true,
        styles: {
            lineStyle: 'dashed',
            capStyle: 'line'
        }
    };
};
const $9f714e569e5501e0$export$73b4064129fc756b = (relativeGuides, nodeWithPos, view, editorWidth, topOffset, size)=>{
    const matchWidth = relativeGuides.width ? relativeGuides.width[Math.round(size.width)] : [];
    const matchHeight = relativeGuides.height ? relativeGuides.height[Math.round(size.height)] : [];
    const matches = matchWidth || matchHeight;
    const getRelativeGuideline = matchWidth && $9f714e569e5501e0$var$getWidthRelativeGuideline || matchHeight && $9f714e569e5501e0$var$getHeightRelativeGuideline || null;
    if (matches && getRelativeGuideline) return [
        getRelativeGuideline('relative_guide_current', view, nodeWithPos, editorWidth, topOffset, size),
        ...matches.map((nodeWithPos, index)=>{
            return getRelativeGuideline(`relative_guide_${index}`, view, nodeWithPos, editorWidth, topOffset);
        })
    ].filter((config)=>!!config);
    return [];
};

});

parcelRegister("3N6yZ", function(module, exports) {
$parcel$export(module.exports, "getGuidelinesWithHighlights", () => $835fc8d50369249d$export$529f80a31b4cd2ac);
const $835fc8d50369249d$var$activeGuidelineStyle = (guideline)=>({
        ...guideline,
        active: true,
        show: true
    });
const $835fc8d50369249d$export$529f80a31b4cd2ac = (gap, maxGap, activeGuidelineKeys, guidelines)=>{
    if (activeGuidelineKeys.length) return guidelines.map((guideline)=>{
        if (activeGuidelineKeys.includes(guideline.key) && gap < maxGap) return $835fc8d50369249d$var$activeGuidelineStyle(guideline);
        return guideline;
    });
    else return guidelines;
};

});

parcelRegister("fT1dY", function(module, exports) {
$parcel$export(module.exports, "ResizableMediaMigrationNotification", () => $0537083b06644e47$export$239acce4d7b54ab1);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled, @typescript-eslint/consistent-type-imports

var $9dQre = parcelRequire("9dQre");

var $3hnUE = parcelRequire("3hnUE");
const $0537083b06644e47$export$239acce4d7b54ab1 = ()=>{
    return /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        "data-testid": "resizable-media-migration-notification",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: [
            (0, $3hnUE.resizableMediaMigrationNotificationStyle)
        ]
    });
};

});
parcelRegister("3hnUE", function(module, exports) {
$parcel$export(module.exports, "resizableMediaMigrationNotificationStyle", () => $aed7542474ad75ce$export$210d1a6e59f1b30e);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9dQre = parcelRequire("9dQre");
const $aed7542474ad75ce$var$NOTIFICATION_SIZE = 8;
const $aed7542474ad75ce$var$SPACE_FROM_EDGE = "var(--ds-space-100, 8px)";
const $aed7542474ad75ce$export$210d1a6e59f1b30e = /*#__PURE__*/ (0, $9dQre.css)({
    position: 'absolute',
    top: $aed7542474ad75ce$var$SPACE_FROM_EDGE,
    right: `calc(${"var(--ds-space-150, 12px)"} + ${$aed7542474ad75ce$var$SPACE_FROM_EDGE})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    backgroundColor: "var(--ds-background-warning-bold, #FBC828)",
    borderRadius: "var(--ds-radius-full, 50%)",
    width: `${$aed7542474ad75ce$var$NOTIFICATION_SIZE}px`,
    height: `${$aed7542474ad75ce$var$NOTIFICATION_SIZE}px`,
    pointerEvents: 'none'
});

});



parcelRegister("gi3hj", function(module, exports) {
$parcel$export(module.exports, "hasPrivateAttrsChanged", () => $c800c378f276bf26$export$56340c4ef3ba9375);
const $c800c378f276bf26$export$56340c4ef3ba9375 = (currentAttrs, newAttrs)=>{
    return currentAttrs.__fileName !== newAttrs.__fileName || currentAttrs.__fileMimeType !== newAttrs.__fileMimeType || currentAttrs.__fileSize !== newAttrs.__fileSize || currentAttrs.__contextId !== newAttrs.__contextId || // A changed id means the media source was replaced — always re-initialise
    // the updater so getRemoteDimensions fetches dimensions for the new file.
    // Only check when id is explicitly present on the new attrs (it's Partial).
    'id' in newAttrs && currentAttrs.id !== newAttrs.id;
};

});



parcelRegister("e8F5x", function(module, exports) {
$parcel$export(module.exports, "mediaSpecWithFixedToDOM", () => $2aab896c31ba1651$export$9f8a4f04eb482f68);

var $35RYb = parcelRequire("35RYb");

var $PFzWP = parcelRequire("PFzWP");

var $gdUUy = parcelRequire("gdUUy");

var $3fVSP = parcelRequire("3fVSP");
const $2aab896c31ba1651$export$d87a47989c00f322 = {
    width: 156,
    height: 125
};
const $2aab896c31ba1651$export$9f8a4f04eb482f68 = ()=>{
    return {
        ...(0, $35RYb.media),
        toDOM: (node)=>{
            const attrs = (0, $3fVSP.getMediaAttrs)('media', node);
            if (node.attrs.type === 'external') return [
                'img',
                {
                    ...attrs,
                    src: node.attrs.url,
                    style: (0, $PFzWP.convertToInlineCss)({
                        backgroundColor: `${"var(--ds-background-neutral, #0515240F)"}`,
                        outline: 'none',
                        width: `var(--ak-editor-media-card-width, 100%)`,
                        height: `var(--ak-editor-media-card-height, 100%)`
                    })
                }
            ];
            if (node.attrs.type === 'file') {
                const dataUrl = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';
                const width = $2aab896c31ba1651$export$d87a47989c00f322.width;
                const height = $2aab896c31ba1651$export$d87a47989c00f322.height;
                const sharedAttrs = {
                    width: width,
                    height: height,
                    ...attrs,
                    // Manually kept in sync with the style of media cards. The goal is to render a plain gray
                    // rectangle that provides an affordance for media.
                    style: (0, $PFzWP.convertToInlineCss)({
                        display: 'var(--ak-editor-media-card-display, inline-block)',
                        backgroundImage: `url("${dataUrl}")`,
                        marginLeft: '0',
                        marginRight: 'var(--ak-editor-media-margin-right, 4px)',
                        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage
                        borderRadius: "var(--ds-radius-small, 3px)",
                        outline: 'none',
                        flexBasis: `${$2aab896c31ba1651$export$d87a47989c00f322.width}px`,
                        backgroundColor: 'var(--ak-editor-media-card-background-color)',
                        width: `var(--ak-editor-media-card-width, 100%)`,
                        height: `var(--ak-editor-media-card-height, 0)`,
                        paddingBottom: `var(--ak-editor-media-padding-bottom, 0)`
                    })
                };
                // Safari is stripping the dom if a child does not exist for the media nodes on safari.
                // Creating an empty child allows safari to pick up the media node within the clipboard.
                // https://product-fabric.atlassian.net/browse/ED-25841
                return (0, $gdUUy.fg)('platform_editor_safari_media_clipboard_fix') ? [
                    'div',
                    sharedAttrs,
                    [
                        'div',
                        {}
                    ]
                ] : [
                    'div',
                    sharedAttrs
                ];
            }
            return [
                'div',
                {
                    ...attrs,
                    styles: (0, $PFzWP.convertToInlineCss)({
                        backgroundColor: `var(--ak-editor-media-card-background-color, ${"var(--ds-background-neutral, #0515240F)"})`,
                        outline: 'none'
                    })
                }
            ];
        }
    };
};

});
parcelRegister("3fVSP", function(module, exports) {
$parcel$export(module.exports, "getMediaAttrs", () => $5f3d492045c23803$export$daf6081925f8454b);
$parcel$export(module.exports, "getAttrsFromNodeMediaSingle", () => $5f3d492045c23803$export$6efdb466dbe90a4b);
const $5f3d492045c23803$export$daf6081925f8454b = (nodeName, node)=>{
    const copyPrivateAttributes = (from, to, map)=>{
        if (node.attrs) Object.keys(node.attrs).forEach((key)=>{
            if (key[0] === '_' && key[1] === '_' && from[key]) to[map ? map(key) : key] = from[key];
        });
    };
    const attrs = {
        'data-id': node.attrs.id,
        'data-node-type': `${nodeName}`,
        'data-type': node.attrs.type,
        'data-collection': node.attrs.collection,
        'data-occurrence-key': node.attrs.occurrenceKey,
        'data-width': node.attrs.width,
        'data-height': node.attrs.height,
        'data-url': node.attrs.url,
        'data-alt': node.attrs.alt,
        // toDOM is used for static rendering as well as editor rendering. This comes into play for
        // emails, copy/paste, etc, so the title and styling here *is* useful (despite a React-based
        // node view being used for editing).
        title: 'Attachment',
        // Manually kept in sync with the style of media cards. The goal is to render a plain gray
        // rectangle that provides an affordance for media.
        style: `display: inline-block; border-radius: 3px; background: #EBECF0; box-shadow: 0 1px 1px rgba(9, 30, 66, 0.2), 0 0 1px 0 rgba(9, 30, 66, 0.24);`
    };
    copyPrivateAttributes(node.attrs, attrs, (key)=>`data-${$5f3d492045c23803$export$f84fdfb973c05bd8(key.slice(2))}`);
    return attrs;
};
const $5f3d492045c23803$export$f84fdfb973c05bd8 = (str)=>// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    str.replace(/([^A-Z]+)([A-Z])/g, (_, x, y)=>`${x}-${y.toLowerCase()}`);
const $5f3d492045c23803$export$6efdb466dbe90a4b = (withExtendedWidthTypes, node)=>{
    const { layout: layout, width: width } = node.attrs;
    const attrs = {
        'data-node-type': 'mediaSingle',
        'data-layout': layout
    };
    if (width) attrs['data-width'] = isFinite(width) && Math.floor(width) === width ? width : width.toFixed(2);
    const { widthType: widthType } = node.attrs;
    return {
        ...attrs,
        'data-width-type': widthType || 'percentage',
        'data-media-vc-wrapper': 'true'
    };
};

});


parcelRegister("1CuAQ", function(module, exports) {
$parcel$export(module.exports, "mediaGroupSpecWithFixedToDOM", () => $e093916a43aaed58$export$927453cb1fcf720e);

var $jiA7W = parcelRequire("jiA7W");
const $e093916a43aaed58$export$d87a47989c00f322 = {
    width: 156,
    height: 125
};
const $e093916a43aaed58$export$aeb48196afcd236a = {
    width: 435,
    height: 125
};
const $e093916a43aaed58$export$1ad38773a5cc4cb0 = {
    width: 300,
    height: 300
};
const $e093916a43aaed58$export$ed7b8a4728e9c63 = (appearance = 'auto')=>{
    if (appearance === 'image') return $e093916a43aaed58$export$d87a47989c00f322;
    if (appearance === 'square') return $e093916a43aaed58$export$1ad38773a5cc4cb0;
    if (appearance === 'horizontal') return $e093916a43aaed58$export$aeb48196afcd236a;
    return $e093916a43aaed58$export$d87a47989c00f322;
};
const $e093916a43aaed58$export$927453cb1fcf720e = ()=>{
    return {
        ...(0, $jiA7W.mediaGroup),
        toDOM: ()=>{
            // Margin margin that consolidates the margin in the
            return [
                'div',
                {
                    style: `
						margin: 3px 5px;
						display: flex;
						gap: 8px;
						--ak-editor-media-card-background-color: #EBECF0;
						--ak-editor-media-card-width: ${$e093916a43aaed58$export$d87a47989c00f322.width}px;
						--ak-editor-media-card-height: ${$e093916a43aaed58$export$d87a47989c00f322.height}px;
					`,
                    'data-node-type': 'mediaGroup'
                },
                0
            ];
        }
    };
};

});

parcelRegister("bMuqp", function(module, exports) {
$parcel$export(module.exports, "mediaInlineSpecWithFixedToDOM", () => $7d144aa054dba25f$export$e71594f26ef09ec1);

var $hHCeP = parcelRequire("hHCeP");

var $3fVSP = parcelRequire("3fVSP");
const $7d144aa054dba25f$var$skeletonStyling = `background: ${"var(--ds-background-neutral, #0515240F)"};`;
// Matches media
const $7d144aa054dba25f$var$fallbackAspectRatio = 1.25;
const $7d144aa054dba25f$export$e71594f26ef09ec1 = ()=>{
    return {
        ...(0, $hHCeP.mediaInline),
        toDOM: (node)=>{
            const dataAttrs = (0, $3fVSP.getMediaAttrs)('mediaInline', node);
            if (node.attrs.type === 'image') {
                const aspectRatio = node.attrs.width && node.attrs.height ? node.attrs.width / node.attrs.height : $7d144aa054dba25f$var$fallbackAspectRatio;
                return [
                    'span',
                    {
                        ...dataAttrs,
                        style: 'display: inline-block; transform: translateY(6px)',
                        class: 'media-inline-image-wrapper'
                    },
                    [
                        'span',
                        {
                            height: '100%',
                            width: '100%',
                            // Transparent image workaround to control styling
                            src: 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7',
                            style: `display: inline-block; aspect-ratio: ${aspectRatio}; height: 100%; width: 100%; border-radius: ${"var(--ds-radius-small, 3px)"}; ${$7d144aa054dba25f$var$skeletonStyling}`
                        }
                    ]
                ];
            } else return [
                'span',
                {
                    ...dataAttrs,
                    style: `display: inline-block; transform: translateY(6px); ${$7d144aa054dba25f$var$skeletonStyling}`,
                    class: 'media-inline-image-wrapper'
                },
                [
                    'span',
                    {
                        style: `display: inline-block; height: 100%; width: 100%; aspect-ratio: ${$7d144aa054dba25f$var$fallbackAspectRatio};`
                    }
                ]
            ];
        }
    };
};

});

parcelRegister("7kOM6", function(module, exports) {
$parcel$export(module.exports, "mediaSingleSpecWithFixedToDOM", () => $a70c8fff09f18b0d$export$7540e2ccc4187dcf);

var $19APL = parcelRequire("19APL");

var $PFzWP = parcelRequire("PFzWP");

var $3fVSP = parcelRequire("3fVSP");
const $a70c8fff09f18b0d$var$WRAPPED_LAYOUTS = [
    'wrap-left',
    'wrap-right'
];
const $a70c8fff09f18b0d$var$ALIGNED_LAYOUTS = [
    'align-end',
    'align-start'
];
const $a70c8fff09f18b0d$var$LEGACY_LAYOUTS = [
    'full-width',
    'wide'
];
const $a70c8fff09f18b0d$var$DEFAULT_IMAGE_WIDTH = 250;
const $a70c8fff09f18b0d$var$DEFAULT_IMAGE_HEIGHT = 200;
const $a70c8fff09f18b0d$var$GUTTER_SIZE = '24px';
const $a70c8fff09f18b0d$var$HALF_GUTTER_SIZE = '12px';
const $a70c8fff09f18b0d$export$7d83792003901332 = ({ mediaSingleDimensionWidth: mediaSingleDimensionWidth, layout: layout, baseWidth: baseWidth, isPixelWidth: isPixelWidth, isExtendedResizeExperience: isExtendedResizeExperience })=>{
    const hasMediaDimensionWidth = typeof mediaSingleDimensionWidth === 'number';
    const isMediaWrapped = $a70c8fff09f18b0d$var$WRAPPED_LAYOUTS.includes(layout);
    const isMediaAligned = $a70c8fff09f18b0d$var$ALIGNED_LAYOUTS.includes(layout);
    const isMediaLegacyLayout = $a70c8fff09f18b0d$var$LEGACY_LAYOUTS.includes(layout);
    const shouldUseAlignedLayoutCalc = isMediaAligned && !hasMediaDimensionWidth;
    const shouldUseWrappedLayoutCalc = isMediaWrapped && !hasMediaDimensionWidth;
    const shouldUseBreakoutWideLogic = layout === 'wide';
    const shouldUseBreakoutFullWidthLogic = layout === 'full-width';
    const shouldUseProportionalCalc = !isExtendedResizeExperience && !isPixelWidth && hasMediaDimensionWidth && !isMediaLegacyLayout && !isMediaWrapped;
    const shouldUseHalfContainerCalc = shouldUseProportionalCalc && isMediaAligned && mediaSingleDimensionWidth >= 100;
    const shouldHardCodePixelWidth = isExtendedResizeExperience && isPixelWidth && hasMediaDimensionWidth;
    const containerWidthPlusGutter = `(min(100cqw, 100%) + ${$a70c8fff09f18b0d$var$GUTTER_SIZE})`;
    const fullContainerWidth = 'var(--ak-editor-max-container-width, 100cqw)';
    const applyContainerWidthBoundaries = (calc)=>{
        // Safe measure to avoid bleeding
        return `min(${calc}, ${fullContainerWidth})`;
    };
    let cssCalc = '';
    if (shouldUseAlignedLayoutCalc) cssCalc = `min(calc(${containerWidthPlusGutter} * 0.5 - ${$a70c8fff09f18b0d$var$GUTTER_SIZE}), ${baseWidth}px)`;
    else if (shouldUseWrappedLayoutCalc) cssCalc = `100%`;
    else if (shouldUseHalfContainerCalc) cssCalc = `min(min(${baseWidth}px, calc(50cqw - ${$a70c8fff09f18b0d$var$HALF_GUTTER_SIZE})), 100%)`;
    else if (shouldUseProportionalCalc) cssCalc = `calc(${containerWidthPlusGutter} * var(--ak-editor-media-single--proportion, 1px) - ${$a70c8fff09f18b0d$var$GUTTER_SIZE})`;
    else if (shouldHardCodePixelWidth) cssCalc = `min(${mediaSingleDimensionWidth}px, ${fullContainerWidth})`;
    else if (shouldUseBreakoutWideLogic) cssCalc = `max(var(--ak-editor--line-length), min(var(--ak-editor--breakout-wide-layout-width), var(--ak-editor-max-container-width)))`;
    else if (shouldUseBreakoutFullWidthLogic) cssCalc = `max(var(--ak-editor--line-length), min(var(--ak-editor--full-width-layout-width), var(--ak-editor-max-container-width)))`;
    else cssCalc = `max(min(${baseWidth}px, min(100cqw, 100%)), ${$a70c8fff09f18b0d$var$GUTTER_SIZE})`;
    return applyContainerWidthBoundaries(cssCalc);
};
const $a70c8fff09f18b0d$export$f236e46eb0ba66bc = ({ isMediaWrapped: isMediaWrapped, isExternalMedia: isExternalMedia, isPixelWidth: isPixelWidth, childMediaWidth: childMediaWidth, mediaSingleDimensionWidth: mediaSingleDimensionWidth })=>{
    if (isExternalMedia || !isMediaWrapped) return 'unset';
    const hasMediaDimensionWidth = typeof mediaSingleDimensionWidth === 'number';
    if (!hasMediaDimensionWidth) return `calc((100% / 2) - ${$a70c8fff09f18b0d$var$HALF_GUTTER_SIZE})`;
    if (isPixelWidth) return `min(calc((var(--ak-editor-max-container-width, 100%) / 2) - ${$a70c8fff09f18b0d$var$HALF_GUTTER_SIZE}), ${mediaSingleDimensionWidth}px)`;
    const hasChildMediaWidth = typeof childMediaWidth === 'number';
    if (hasChildMediaWidth) return `min(calc(100% * (${mediaSingleDimensionWidth} / 100) - ${$a70c8fff09f18b0d$var$HALF_GUTTER_SIZE}), ${childMediaWidth}px)`;
    return `calc(100% * (${mediaSingleDimensionWidth} / 100) - ${$a70c8fff09f18b0d$var$HALF_GUTTER_SIZE})`;
};
const $a70c8fff09f18b0d$export$e6a8bed31e6b00e2 = ({ isPixelWidth: isPixelWidth, isExtendedResizeExperience: isExtendedResizeExperience, mediaSingleDimensionWidth: mediaSingleDimensionWidth, isMediaWrapped: isMediaWrapped })=>{
    const hasMediaWidth = typeof mediaSingleDimensionWidth === 'number';
    if (isPixelWidth || isExtendedResizeExperience || !hasMediaWidth) return 'unset';
    if (isMediaWrapped) return mediaSingleDimensionWidth >= 50 ? '1' : `${1 - mediaSingleDimensionWidth / 100}`;
    return `${mediaSingleDimensionWidth / 100}`;
};
const $a70c8fff09f18b0d$export$899bc2e8a274123a = ({ layout: layout })=>{
    switch(layout){
        case 'align-end':
        case 'wrap-right':
            return 'end';
        case 'align-start':
        case 'wrap-left':
            return 'start';
        default:
            return 'center';
    }
};
const $a70c8fff09f18b0d$export$e03be381a0c66cf5 = ({ layout: layout, dataAttrs: dataAttrs, childMediaWidth: childMediaWidth, childMediaHeight: childMediaHeight, mediaSingleDimensionWidth: mediaSingleDimensionWidth, isPixelWidth: isPixelWidth, isExtendedResizeExperience: isExtendedResizeExperience })=>{
    const layoutStyleJustifyContent = $a70c8fff09f18b0d$export$899bc2e8a274123a({
        layout: layout
    });
    const mediaWidthCalc = $a70c8fff09f18b0d$export$7d83792003901332({
        layout: layout,
        mediaSingleDimensionWidth: mediaSingleDimensionWidth,
        baseWidth: childMediaWidth,
        isPixelWidth: isPixelWidth,
        isExtendedResizeExperience: isExtendedResizeExperience
    });
    const paddingBottom = `calc((${childMediaHeight} / ${childMediaWidth}) * 100%)`;
    return [
        'div',
        {
            class: `rich-media-item mediaSingleView-content-wrap image-${layout}`,
            style: (0, $PFzWP.convertToInlineCss)({
                display: 'flex',
                justifyContent: layoutStyleJustifyContent,
                transform: 'unset',
                marginLeft: '0'
            }),
            ...dataAttrs
        },
        [
            'div',
            {
                style: (0, $PFzWP.convertToInlineCss)({
                    borderRadius: "var(--ds-radius-small, 3px)",
                    width: mediaWidthCalc,
                    minWidth: mediaWidthCalc,
                    color: "var(--ds-icon, #292A2E)"
                })
            },
            [
                'figure',
                {
                    class: 'media-single-node',
                    style: (0, $PFzWP.convertToInlineCss)({
                        '--ak-editor-media-padding-bottom': paddingBottom,
                        margin: '0px'
                    })
                },
                [
                    'div',
                    {},
                    [
                        'div',
                        {
                            class: 'media-content-wrap'
                        },
                        0
                    ]
                ]
            ]
        ]
    ];
};
const $a70c8fff09f18b0d$export$e23517a19eb0e861 = (allowPixelResizing)=>(node)=>{
        const mediaSingleAttrs = node.attrs;
        const isPixelWidth = (mediaSingleAttrs === null || mediaSingleAttrs === void 0 ? void 0 : mediaSingleAttrs.widthType) === 'pixel';
        const layout = (mediaSingleAttrs === null || mediaSingleAttrs === void 0 ? void 0 : mediaSingleAttrs.layout) ?? 'center';
        const childNode = node.firstChild;
        const isExternalMedia = (childNode === null || childNode === void 0 ? void 0 : childNode.attrs.type) === 'external';
        const childMediaWidth = (childNode === null || childNode === void 0 ? void 0 : childNode.attrs.width) || $a70c8fff09f18b0d$var$DEFAULT_IMAGE_WIDTH;
        const childMediaHeight = (childNode === null || childNode === void 0 ? void 0 : childNode.attrs.height) || $a70c8fff09f18b0d$var$DEFAULT_IMAGE_HEIGHT;
        const dataAttrs = (0, $3fVSP.getAttrsFromNodeMediaSingle)(true, node);
        const content = $a70c8fff09f18b0d$export$e03be381a0c66cf5({
            layout: layout,
            dataAttrs: dataAttrs,
            childMediaWidth: childMediaWidth,
            childMediaHeight: childMediaHeight,
            mediaSingleDimensionWidth: mediaSingleAttrs.width,
            isPixelWidth: isPixelWidth,
            isExtendedResizeExperience: allowPixelResizing
        });
        const isMediaWrapped = $a70c8fff09f18b0d$var$WRAPPED_LAYOUTS.includes(layout);
        const proportionCalc = $a70c8fff09f18b0d$export$e6a8bed31e6b00e2({
            isPixelWidth: isPixelWidth,
            isMediaWrapped: isMediaWrapped,
            mediaSingleDimensionWidth: mediaSingleAttrs === null || mediaSingleAttrs === void 0 ? void 0 : mediaSingleAttrs.width,
            isExtendedResizeExperience: allowPixelResizing
        });
        const contentWrapperWidth = $a70c8fff09f18b0d$export$f236e46eb0ba66bc({
            isMediaWrapped: isMediaWrapped,
            isExternalMedia: isExternalMedia,
            isPixelWidth: isPixelWidth,
            childMediaWidth: childMediaWidth,
            mediaSingleDimensionWidth: mediaSingleAttrs === null || mediaSingleAttrs === void 0 ? void 0 : mediaSingleAttrs.width
        });
        return [
            'div',
            {
                class: 'mediaSingleView-content-wrap',
                layout: layout,
                'data-media-vc-wrapper': 'true',
                style: (0, $PFzWP.convertToInlineCss)({
                    '--ak-editor-media-single--proportion': proportionCalc,
                    '--ak-editor-media-card-display': 'block',
                    '--ak-editor-media-single--gutter-size': $a70c8fff09f18b0d$var$GUTTER_SIZE,
                    '--ak-editor-media-margin-right': '0',
                    '--ak-editor-media-card-background-color': "var(--ds-background-neutral, #0515240F)",
                    marginTop: isMediaWrapped ? $a70c8fff09f18b0d$var$HALF_GUTTER_SIZE : "var(--ds-space-300, 24px)",
                    marginBottom: isMediaWrapped ? $a70c8fff09f18b0d$var$HALF_GUTTER_SIZE : "var(--ds-space-300, 24px)",
                    marginRight: isMediaWrapped ? layout === 'wrap-right' ? 'auto' : $a70c8fff09f18b0d$var$HALF_GUTTER_SIZE : 0,
                    marginLeft: isMediaWrapped ? layout === 'wrap-left' ? 'auto' : $a70c8fff09f18b0d$var$HALF_GUTTER_SIZE : 0,
                    width: contentWrapperWidth
                })
            },
            content
        ];
    };
const $a70c8fff09f18b0d$export$7540e2ccc4187dcf = (mediaSingleOption)=>{
    const mediaSingleNode = (0, $19APL.mediaSingleSpec)(mediaSingleOption);
    const toDOM = $a70c8fff09f18b0d$export$e23517a19eb0e861(mediaSingleOption.withExtendedWidthTypes);
    return {
        ...mediaSingleNode,
        toDOM: toDOM
    };
};

});

parcelRegister("dnBXh", function(module, exports) {
$parcel$export(module.exports, "createCommand", () => $077b5f0a0f668330$export$8d4021544bdece00);
$parcel$export(module.exports, "getPluginState", () => $077b5f0a0f668330$export$f05434c51e3762e);
$parcel$export(module.exports, "createPlugin", () => $077b5f0a0f668330$export$ae829ec7b2625219);

var $f7Kk4 = parcelRequire("f7Kk4");

var $56AB9 = parcelRequire("56AB9");

var $3TnFr = parcelRequire("3TnFr");

var $cw0wu = parcelRequire("cw0wu");

var $2NUoc = parcelRequire("2NUoc");
const $077b5f0a0f668330$var$pluginKey = new (0, $cw0wu.PluginKey)('mediaAltTextPlugin');
const $077b5f0a0f668330$var$dest = (0, $3TnFr.pluginFactory)($077b5f0a0f668330$var$pluginKey, (0, $2NUoc.default), {
    onSelectionChanged: (tr, newState)=>{
        // dont close alt text for undo/redo transactions (if it comes from prosemirror-history)
        if (tr.getMeta((0, $56AB9.pmHistoryPluginKey))) return newState;
        return {
            isAltTextEditorOpen: false
        };
    }
});
const $077b5f0a0f668330$var$createPluginState = $077b5f0a0f668330$var$dest.createPluginState;
const $077b5f0a0f668330$export$8d4021544bdece00 = $077b5f0a0f668330$var$dest.createCommand;
const $077b5f0a0f668330$export$f05434c51e3762e = $077b5f0a0f668330$var$dest.getPluginState;
const $077b5f0a0f668330$export$ae829ec7b2625219 = ({ dispatch: dispatch, providerFactory: providerFactory })=>{
    return new (0, $f7Kk4.SafePlugin)({
        state: $077b5f0a0f668330$var$createPluginState(dispatch, {
            isAltTextEditorOpen: false
        }),
        key: $077b5f0a0f668330$var$pluginKey
    });
};

});
parcelRegister("2NUoc", function(module, exports) {
$parcel$export(module.exports, "default", () => $a5f201c9c6bd538a$export$2e2bcd8739ae039);
var $a5f201c9c6bd538a$export$2e2bcd8739ae039 = (state, action)=>{
    switch(action.type){
        case 'updateAltText':
            return {
                ...state
            };
        case 'openMediaAltTextMenu':
            return {
                ...state,
                isAltTextEditorOpen: true
            };
        case 'closeMediaAltTextMenu':
            return {
                ...state,
                isAltTextEditorOpen: false
            };
        default:
            return state;
    }
};

});


parcelRegister("8QWMu", function(module, exports) {
$parcel$export(module.exports, "default", () => $e51a18a5c9964c2a$export$2e2bcd8739ae039);

var $cv8id = parcelRequire("cv8id");

var $ejrfk = parcelRequire("ejrfk");

var $gH0fc = parcelRequire("gH0fc");
function $e51a18a5c9964c2a$export$2e2bcd8739ae039(schema, editorAnalyticsAPI) {
    const list = {};
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $cv8id.bindKeymapWithCommand)((0, $cv8id.addAltText).common, (0, $gH0fc.openMediaAltTextMenu)(editorAnalyticsAPI), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $cv8id.bindKeymapWithCommand)((0, $cv8id.escape).common, (0, $gH0fc.closeMediaAltTextMenu), list);
    return (0, $ejrfk.keymap)(list);
}

});
parcelRegister("gH0fc", function(module, exports) {
$parcel$export(module.exports, "closeMediaAltTextMenuAndSave", () => $1f3d53c0463f603d$export$e494ea08c5b8d2cd);
$parcel$export(module.exports, "closeMediaAltTextMenu", () => $1f3d53c0463f603d$export$56a9d6e428ac89c9);
$parcel$export(module.exports, "openMediaAltTextMenu", () => $1f3d53c0463f603d$export$e5f8c6baa484e73d);

var $g6Qq4 = parcelRequire("g6Qq4");

var $5NaaJ = parcelRequire("5NaaJ");

var $cw0wu = parcelRequire("cw0wu");

var $4sVoN = parcelRequire("4sVoN");

var $jAHUG = parcelRequire("jAHUG");

var $dnBXh = parcelRequire("dnBXh");
const $1f3d53c0463f603d$var$createCommandWithAnalytics = (actionType, action, transform)=>{
    return (editorAnalyticsAPI)=>{
        return (0, $5NaaJ.withAnalytics)(editorAnalyticsAPI, (state)=>{
            const mediaNode = (0, $4sVoN.getMediaSingleOrInlineNodeFromSelection)(state);
            const type = (0, $jAHUG.getNodeType)(state);
            return {
                action: actionType,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).MEDIA,
                actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).ALT_TEXT,
                eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
                attributes: {
                    type: type,
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    mediaType: mediaNode.attrs.type
                }
            };
        })((0, $dnBXh.createCommand)(action, transform));
    };
};
const $1f3d53c0463f603d$export$e494ea08c5b8d2cd = (altText)=>{
    const commandTransform = typeof altText === 'string' ? $1f3d53c0463f603d$var$updateAltTextTransform(altText) : undefined;
    return (0, $dnBXh.createCommand)((state)=>{
        if ((0, $4sVoN.isMediaSingleOrInlineNodeSelected)(state)) return {
            type: 'closeMediaAltTextMenu'
        };
        return false;
    }, commandTransform);
};
const $1f3d53c0463f603d$export$56a9d6e428ac89c9 = $1f3d53c0463f603d$export$e494ea08c5b8d2cd();
const $1f3d53c0463f603d$export$e5f8c6baa484e73d = $1f3d53c0463f603d$var$createCommandWithAnalytics((0, $g6Qq4.ACTION).OPENED, (state)=>{
    if ((0, $4sVoN.isMediaSingleOrInlineNodeSelected)(state)) return {
        type: 'openMediaAltTextMenu'
    };
    return false;
}, (tr)=>tr.setMeta('scrollIntoView', false));
const $1f3d53c0463f603d$var$updateAltTextTransform = (newAltText)=>(tr, state)=>{
        const mediaNode = (0, $4sVoN.getMediaSingleOrInlineNodeFromSelection)(state);
        if (mediaNode) {
            // mediaSingle or mediaInline
            const originalSelectionPos = tr.selection.from;
            const mediaPos = mediaNode.type === state.schema.nodes.media ? originalSelectionPos + 1 // media inside mediaSingle
             : originalSelectionPos; // mediaInline
            /**
     * Any changes to attributes of a node count the node as "recreated" in Prosemirror[1]
     * This makes it so Prosemirror resets the selection to the child i.e. "media" instead of "media-single"
     * The recommended fix is to reset the selection.[2]
     *
     * [1] https://discuss.prosemirror.net/t/setnodemarkup-loses-current-nodeselection/976
     * [2] https://discuss.prosemirror.net/t/setnodemarkup-and-deselect/3673
     */ tr.setMeta('scrollIntoView', false).setNodeMarkup(mediaPos, undefined, {
                ...mediaNode.attrs,
                alt: newAltText
            }).setSelection((0, $cw0wu.NodeSelection).create(tr.doc, originalSelectionPos));
        }
        return tr;
    };
const $1f3d53c0463f603d$export$d4d994ee16c78b4b = (newAltText)=>(0, $dnBXh.createCommand)((state)=>{
        if ((0, $4sVoN.isMediaSingleOrInlineNodeSelected)(state)) return {
            type: 'updateAltText'
        };
        return false;
    }, $1f3d53c0463f603d$var$updateAltTextTransform(newAltText));

});


parcelRegister("klddC", function(module, exports) {
$parcel$export(module.exports, "showMediaViewer", () => $0aa2e423a3b9bb00$export$9f7495958f6fc412);
$parcel$export(module.exports, "hideMediaViewer", () => $0aa2e423a3b9bb00$export$4e934779424102f3);
$parcel$export(module.exports, "trackMediaPaste", () => $0aa2e423a3b9bb00$export$3d560bf5e623346d);
$parcel$export(module.exports, "setAIGenerating", () => $0aa2e423a3b9bb00$export$b4a04e6655f9ee09);
$parcel$export(module.exports, "clearAIGenerating", () => $0aa2e423a3b9bb00$export$573182394cb8259c);
$parcel$export(module.exports, "insertMediaAsMediaSingleCommand", () => $0aa2e423a3b9bb00$export$483fbd616c5570ae);

var $aLFwY = parcelRequire("aLFwY");

var $kZf5n = parcelRequire("kZf5n");

var $7ICJC = parcelRequire("7ICJC");

var $4sVoN = parcelRequire("4sVoN");

var $jmBd6 = parcelRequire("jmBd6");
const $0aa2e423a3b9bb00$export$9f7495958f6fc412 = (media)=>({ tr: tr })=>{
        tr.setMeta((0, $7ICJC.stateKey), {
            type: (0, $aLFwY.ACTIONS).SHOW_MEDIA_VIEWER,
            mediaViewerSelectedMedia: media,
            isMediaViewerVisible: true
        });
        return tr;
    };
const $0aa2e423a3b9bb00$export$4e934779424102f3 = ({ tr: tr })=>{
    tr.setMeta((0, $7ICJC.stateKey), {
        type: (0, $aLFwY.ACTIONS).HIDE_MEDIA_VIEWER,
        mediaViewerSelectedMedia: null,
        isMediaViewerVisible: false
    });
    return tr;
};
const $0aa2e423a3b9bb00$export$3d560bf5e623346d = (attrs)=>({ tr: tr })=>{
        const identifier = (0, $4sVoN.getIdentifier)(attrs);
        tr.setMeta((0, $7ICJC.stateKey), {
            type: (0, $aLFwY.ACTIONS).TRACK_MEDIA_PASTE,
            identifier: identifier
        });
        return tr;
    };
const $0aa2e423a3b9bb00$export$b4a04e6655f9ee09 = (mediaId)=>({ tr: tr })=>(0, $kZf5n.setAIGeneratingMeta)(tr, mediaId);
const $0aa2e423a3b9bb00$export$573182394cb8259c = (mediaId)=>({ tr: tr })=>(0, $kZf5n.clearAIGeneratingMeta)(tr, mediaId);
const $0aa2e423a3b9bb00$export$483fbd616c5570ae = (editorAnalyticsAPI, allowPixelResizing)=>(mediaAttrs, inputMethod, insertMediaVia, positions, dataConsumerSource)=>(0, $jmBd6.createInsertMediaAsMediaSingleCommand)(mediaAttrs, inputMethod, editorAnalyticsAPI, insertMediaVia, allowPixelResizing, positions, dataConsumerSource);

});

parcelRegister("3R6b9", function(module, exports) {
$parcel$export(module.exports, "default", () => $b92c3fd74c7c8c82$export$2e2bcd8739ae039);

var $cv8id = parcelRequire("cv8id");

var $1HfwI = parcelRequire("1HfwI");

var $29qUP = parcelRequire("29qUP");

var $48nbt = parcelRequire("48nbt");

var $8t2a4 = parcelRequire("8t2a4");

var $j7pt0 = parcelRequire("j7pt0");

var $ejrfk = parcelRequire("ejrfk");

var $cw0wu = parcelRequire("cw0wu");

var $5bbjm = parcelRequire("5bbjm");

var $9xRfX = parcelRequire("9xRfX");

var $7ICJC = parcelRequire("7ICJC");

var $jAHUG = parcelRequire("jAHUG");

var $7omWA = parcelRequire("7omWA");
function $b92c3fd74c7c8c82$var$keymapPlugin(options, editorAnalyticsAPI, editorSelectionAPI, widthPlugin, getIntl) {
    const list = {};
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $cv8id.bindKeymapWithCommand)((0, $cv8id.undo).common, $b92c3fd74c7c8c82$var$ignoreLinksInSteps, list);
    if (options !== null && options !== void 0 && options.allowCaptions) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $cv8id.bindKeymapWithCommand)((0, $cv8id.moveDown).common, $b92c3fd74c7c8c82$var$insertAndSelectCaption(editorAnalyticsAPI), list);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $cv8id.bindKeymapWithCommand)((0, $cv8id.tab).common, $b92c3fd74c7c8c82$var$insertAndSelectCaption(editorAnalyticsAPI), list);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $cv8id.bindKeymapWithCommand)((0, $cv8id.moveLeft).common, $b92c3fd74c7c8c82$var$arrowLeftFromMediaSingle(editorSelectionAPI), list);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $cv8id.bindKeymapWithCommand)((0, $cv8id.moveRight).common, $b92c3fd74c7c8c82$var$arrowRightFromMediaSingle(editorSelectionAPI), list);
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $cv8id.bindKeymapWithCommand)((0, $cv8id.insertNewLine).common, $b92c3fd74c7c8c82$var$splitMediaGroup, list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $cv8id.bindKeymapWithCommand)((0, $cv8id.enter).common, $b92c3fd74c7c8c82$var$splitMediaGroup, list);
    if (options !== null && options !== void 0 && options.allowPixelResizing) {
        (0, $cv8id.bindKeymapWithCommand)(// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $cv8id.increaseMediaSize).common, $b92c3fd74c7c8c82$var$handleMediaIncrease(editorAnalyticsAPI, widthPlugin, options, getIntl), list);
        (0, $cv8id.bindKeymapWithCommand)(// Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $cv8id.decreaseMediaSize).common, $b92c3fd74c7c8c82$var$handleMediaDecrease(editorAnalyticsAPI, widthPlugin, options, getIntl), list);
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $cv8id.bindKeymapWithCommand)((0, $cv8id.activateVideoControls).common, $b92c3fd74c7c8c82$var$focusPlayButton, list);
    return (0, $ejrfk.keymap)(list);
}
const $b92c3fd74c7c8c82$var$ignoreLinksInSteps = (state)=>{
    const mediaPluginState = (0, $7ICJC.stateKey).getState(state);
    mediaPluginState.ignoreLinks = true;
    return false;
};
const $b92c3fd74c7c8c82$var$splitMediaGroup = (state)=>{
    const mediaPluginState = (0, $7ICJC.stateKey).getState(state);
    return mediaPluginState.splitMediaGroup();
};
const $b92c3fd74c7c8c82$var$focusPlayButton = (state)=>{
    var _stateKey$getState;
    const videoControlsWrapperRef = (_stateKey$getState = (0, $7ICJC.stateKey).getState(state)) === null || _stateKey$getState === void 0 ? void 0 : _stateKey$getState.element;
    if (videoControlsWrapperRef) {
        const firstButton = videoControlsWrapperRef === null || videoControlsWrapperRef === void 0 ? void 0 : videoControlsWrapperRef.querySelector('button, [tabindex]:not([tabindex="-1"])');
        firstButton === null || firstButton === void 0 || firstButton.focus();
    }
    return true;
};
const $b92c3fd74c7c8c82$var$validationMaxMin = (newWidth, maxWidth, minWidth, validation)=>{
    let newWidthValidated;
    if (newWidth > maxWidth) {
        newWidthValidated = maxWidth;
        validation = 'greater-than-max';
    } else if (newWidth < minWidth) {
        newWidthValidated = minWidth;
        validation = 'less-than-min';
    } else {
        newWidthValidated = newWidth;
        validation = 'valid';
    }
    return {
        newWidthValidated: newWidthValidated,
        validation: validation
    };
};
const $b92c3fd74c7c8c82$var$createAnnouncer = (action, mediaWidth, changeAmount, validation, getIntl)=>{
    const announcerContainer = document.getElementById('media-announcer') || document.createElement('div');
    const intl = getIntl();
    if (!announcerContainer.id) {
        announcerContainer.id = 'media-announcer';
        announcerContainer.setAttribute('role', 'status');
        announcerContainer.setAttribute('aria-live', 'polite');
        announcerContainer.setAttribute('aria-atomic', 'true');
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const style = announcerContainer.style;
        style.position = 'absolute';
        style.width = '1px';
        style.height = '1px';
        style.marginTop = '-1px';
        style.opacity = '0';
        style.overflow = 'hidden';
        document.body.appendChild(announcerContainer);
    } else {
        const newMediaWidth = mediaWidth + changeAmount;
        if (validation === 'greater-than-max') announcerContainer.textContent = intl.formatMessage((0, $48nbt.mediaResizeAnnouncerMessMessages).MediaWidthIsMax);
        else if (validation === 'less-than-min') announcerContainer.textContent = intl.formatMessage((0, $48nbt.mediaResizeAnnouncerMessMessages).MediaWidthIsMin);
        else announcerContainer.textContent = intl.formatMessage(action === 'increased' ? (0, $48nbt.mediaResizeAnnouncerMessMessages).DefaultMediaWidthIncreased : (0, $48nbt.mediaResizeAnnouncerMessMessages).DefaultMediaWidthDecreased, {
            newMediaWidth: newMediaWidth
        });
    }
};
const $b92c3fd74c7c8c82$var$handleMediaSizeChange = (editorAnalyticsAPI, widthPlugin, options, changeAmount, action, getIntl)=>(state, dispatch)=>{
        var _getSelectedMediaSing, _widthPlugin$sharedSt, _widthPlugin$sharedSt2, _getSelectedMediaSing2;
        const { selection: selection } = state;
        if (!(selection instanceof (0, $cw0wu.NodeSelection) && selection.node.type.name === 'mediaSingle')) return false;
        const mediaWidth = (_getSelectedMediaSing = (0, $7omWA.getSelectedMediaSingle)(state)) === null || _getSelectedMediaSing === void 0 || (_getSelectedMediaSing = _getSelectedMediaSing.node) === null || _getSelectedMediaSing === void 0 || (_getSelectedMediaSing = _getSelectedMediaSing.attrs) === null || _getSelectedMediaSing === void 0 ? void 0 : _getSelectedMediaSing.width;
        const contentWidth = (widthPlugin === null || widthPlugin === void 0 || (_widthPlugin$sharedSt = widthPlugin.sharedState.currentState()) === null || _widthPlugin$sharedSt === void 0 ? void 0 : _widthPlugin$sharedSt.lineLength) || (0, $5bbjm.akEditorDefaultLayoutWidth);
        const mediaPluginState = (0, $7ICJC.stateKey).getState(state);
        const maxWidthForNestedNode = mediaPluginState.currentMaxWidth;
        const minWidth = (0, $29qUP.MEDIA_SINGLE_DEFAULT_MIN_PIXEL_WIDTH);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let maxWidth = maxWidthForNestedNode;
        const currentMaxWidth = (widthPlugin === null || widthPlugin === void 0 || (_widthPlugin$sharedSt2 = widthPlugin.sharedState.currentState()) === null || _widthPlugin$sharedSt2 === void 0 ? void 0 : _widthPlugin$sharedSt2.width) || maxWidth;
        if (maxWidth === undefined && maxWidthForNestedNode === undefined) {
            var _widthPlugin$sharedSt3;
            maxWidth = options !== null && options !== void 0 && options.fullWidthEnabled ? widthPlugin === null || widthPlugin === void 0 || (_widthPlugin$sharedSt3 = widthPlugin.sharedState.currentState()) === null || _widthPlugin$sharedSt3 === void 0 ? void 0 : _widthPlugin$sharedSt3.lineLength : (0, $1HfwI.calcMediaSingleMaxWidth)(currentMaxWidth, options === null || options === void 0 ? void 0 : options.editorAppearance);
        }
        const validation = 'valid';
        const newWidth = mediaWidth + changeAmount;
        if (options !== null && options !== void 0 && options.fullWidthEnabled) {
            var _widthPlugin$sharedSt4;
            maxWidth = widthPlugin === null || widthPlugin === void 0 || (_widthPlugin$sharedSt4 = widthPlugin.sharedState.currentState()) === null || _widthPlugin$sharedSt4 === void 0 ? void 0 : _widthPlugin$sharedSt4.lineLength;
        } else if (maxWidthForNestedNode === undefined) maxWidth = (0, $1HfwI.calcMediaSingleMaxWidth)(currentMaxWidth, options === null || options === void 0 ? void 0 : options.editorAppearance);
        const { newWidthValidated: newWidthValidated, validation: validationResult } = $b92c3fd74c7c8c82$var$validationMaxMin(newWidth, maxWidth, minWidth, validation);
        const newLayout = (0, $7omWA.calcNewLayout)(newWidthValidated, (_getSelectedMediaSing2 = (0, $7omWA.getSelectedMediaSingle)(state)) === null || _getSelectedMediaSing2 === void 0 || (_getSelectedMediaSing2 = _getSelectedMediaSing2.node) === null || _getSelectedMediaSing2 === void 0 || (_getSelectedMediaSing2 = _getSelectedMediaSing2.attrs) === null || _getSelectedMediaSing2 === void 0 ? void 0 : _getSelectedMediaSing2.layout, contentWidth, options === null || options === void 0 ? void 0 : options.fullWidthEnabled);
        (0, $jAHUG.updateMediaSingleWidth)(editorAnalyticsAPI)(newWidthValidated, validationResult, 'keyboard', newLayout)(state, dispatch);
        $b92c3fd74c7c8c82$var$createAnnouncer(action, mediaWidth, changeAmount, validationResult, getIntl);
        return true;
    };
const $b92c3fd74c7c8c82$var$handleMediaIncrease = (editorAnalyticsAPI, widthPlugin, options, getIntl)=>$b92c3fd74c7c8c82$var$handleMediaSizeChange(editorAnalyticsAPI, widthPlugin, options, 1, 'increased', getIntl);
const $b92c3fd74c7c8c82$var$handleMediaDecrease = (editorAnalyticsAPI, widthPlugin, options, getIntl)=>$b92c3fd74c7c8c82$var$handleMediaSizeChange(editorAnalyticsAPI, widthPlugin, options, -1, 'decreased', getIntl);
const $b92c3fd74c7c8c82$var$insertAndSelectCaption = (editorAnalyticsAPI)=>(state, dispatch)=>{
        const { selection: selection, schema: schema } = state;
        if (selection instanceof (0, $cw0wu.NodeSelection) && selection.node.type === schema.nodes.mediaSingle && schema.nodes.caption) {
            if (dispatch) {
                const { from: from, node: node } = selection;
                if (!(0, $9xRfX.insertAndSelectCaptionFromMediaSinglePos)(editorAnalyticsAPI)(from, node)(state, dispatch)) (0, $9xRfX.selectCaptionFromMediaSinglePos)(from, node)(state, dispatch);
            }
            return true;
        }
        return false;
    };
const $b92c3fd74c7c8c82$var$arrowLeftFromMediaSingle = (editorSelectionAPI)=>(state, dispatch)=>{
        const { selection: selection } = state;
        if (editorSelectionAPI && selection instanceof (0, $cw0wu.NodeSelection) && selection.node.type.name === 'mediaSingle') {
            const tr = editorSelectionAPI.selectNearNode({
                selectionRelativeToNode: undefined,
                selection: new (0, $j7pt0.GapCursorSelection)(state.doc.resolve(selection.from), (0, $8t2a4.Side).LEFT)
            })(state);
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };
const $b92c3fd74c7c8c82$var$arrowRightFromMediaSingle = (editorSelectionAPI)=>(state, dispatch)=>{
        const { selection: selection } = state;
        if (editorSelectionAPI && selection instanceof (0, $cw0wu.NodeSelection) && selection.node.type.name === 'mediaSingle') {
            const tr = editorSelectionAPI.selectNearNode({
                selectionRelativeToNode: undefined,
                selection: new (0, $j7pt0.GapCursorSelection)(state.doc.resolve(selection.to), (0, $8t2a4.Side).RIGHT)
            })(state);
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };
var $b92c3fd74c7c8c82$export$2e2bcd8739ae039 = $b92c3fd74c7c8c82$var$keymapPlugin;

});
parcelRegister("48nbt", function(module, exports) {
$parcel$export(module.exports, "mediaResizeAnnouncerMessMessages", () => $e298ae3d96592fc3$export$1a764a38ffc131af);

var $f0Pt4 = parcelRequire("f0Pt4");
const $e298ae3d96592fc3$export$1a764a38ffc131af = (0, $f0Pt4.defineMessages)({
    MediaWidthIsMax: {
        id: 'fabric.editor.media.pixelEntry.MediaWidthIsMax',
        defaultMessage: 'Media increased to the maximum size',
        description: 'Assistive announcement text read by screen readers when the user resizes a media item and it reaches the maximum allowed size.'
    },
    MediaWidthIsMin: {
        id: 'fabric.editor.media.MediaWidthIsMin',
        defaultMessage: 'Media decreased to the minimum size',
        description: 'Assistive announcement text read by screen readers when the user resizes a media item and it reaches the minimum allowed size.'
    },
    DefaultMediaWidthIncreased: {
        id: 'fabric.editor.media.DefaultMediaWidthIncreased',
        defaultMessage: '{newMediaWidth, plural, one {Media width increased to # pixel.} other {Media width increased to # pixels.}}',
        description: 'Media width increased to {newMediaWidth} pixels.'
    },
    DefaultMediaWidthDecreased: {
        id: 'fabric.editor.media.DefaultMediaWidthDecreased',
        defaultMessage: '{newMediaWidth, plural, one {Media width decreased to # pixel.} other {Media width decreased to # pixels.}}',
        description: 'Media width decreased to {newMediaWidth} pixels.'
    }
});

});


parcelRegister("8vv0U", function(module, exports) {
$parcel$export(module.exports, "default", () => $6f37bbe3140a0e02$export$2e2bcd8739ae039);

var $cv8id = parcelRequire("cv8id");

var $5m3y9 = parcelRequire("5m3y9");

var $56AB9 = parcelRequire("56AB9");

var $5FzRL = parcelRequire("5FzRL");

var $ejrfk = parcelRequire("ejrfk");

var $cw0wu = parcelRequire("cw0wu");

var $gab48 = parcelRequire("gab48");
/**
 * Check if is an empty selection at the start of the node
 */ function $6f37bbe3140a0e02$var$isEmptySelectionAtStart(selection) {
    if (!selection.empty) return false;
    const { $from: $from } = selection;
    return $from.parentOffset <= 0;
}
/**
 * Check if the current selection is inside a node type
 */ function $6f37bbe3140a0e02$var$isSelectionInsideOf(selection, nodeType) {
    const { $from: $from } = selection;
    const parent = $from.parent;
    return parent.type === nodeType;
}
/**
 * Return the sibling of the current selection
 */ function $6f37bbe3140a0e02$var$getSibling(selection, sibling) {
    const { $from: $from } = selection;
    const index = $from.index($from.depth - 1);
    const grandParent = $from.node($from.depth - 1); // Get GrandParent
    return grandParent ? grandParent.maybeChild(index + sibling) : null;
}
/**
 * Check if respective sibling (negative number previous, positive number next)
 * is from the specified node
 */ function $6f37bbe3140a0e02$var$isSiblingOfType(selection, node, sibling) {
    const maybeSiblingNode = $6f37bbe3140a0e02$var$getSibling(selection, sibling);
    return !!maybeSiblingNode && maybeSiblingNode.type === node;
}
/**
 * When there's any empty block before another paragraph with wrap-right
 * mediaSingle. Pressing backspace at the start of the paragraph will select
 * the media but visually it makes more sense to remove the empty paragraph.
 *
 * Structure of the document: doc(block(), mediaSingle(media()), paragraph('{<>}hello!'))
 * But, visually it looks like the following:
 *
 *    [empty block] <- Remove this block
 * or [paragraph block] <- Move text inside this paragraph
 * or [any other block] <- Move paragraph node after this node
 * [Cursor] x x x x x x x x  +---------------+
 * x x x x x x x x x x       |  mediaSingle  |
 * x x x x x.                +---------------+
 */ function $6f37bbe3140a0e02$var$handleSelectionAfterWrapRight(isEmptyNode) {
    function isEmptyWithoutThrow(node) {
        let isEmpty = false;
        try {
            // We dont have isEmptyNode definition for table for example.
            // In this case it will throw we need to catch it
            isEmpty = isEmptyNode(node);
        } catch (e) {}
        return isEmpty;
    }
    return (state, dispatch)=>{
        const { $from: $from } = state.selection;
        const { paragraph: paragraph } = state.schema.nodes;
        const previousMediaSingleSibling = -2;
        const maybeSibling = $6f37bbe3140a0e02$var$getSibling(state.selection, previousMediaSingleSibling);
        if (!maybeSibling) // the last is the image so should let the default behaviour delete the image
        return false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const mediaSingle = $6f37bbe3140a0e02$var$getSibling(state.selection, -1); // Sibling is a media single already checked in main code
        const mediaSinglePos = $from.pos - mediaSingle.nodeSize;
        // Should find the position
        // Should move the current paragraph to the last line
        const maybeAnyBlockPos = mediaSinglePos - maybeSibling.nodeSize;
        let tr = state.tr;
        if (isEmptyWithoutThrow(maybeSibling)) // Should remove the empty sibling
        tr = tr.replace(maybeAnyBlockPos - 1, maybeAnyBlockPos + maybeSibling.nodeSize);
        else {
            // We move the current node, to the new position
            // 1. Remove current node, only if I am not removing the last node.
            if (!(0, $56AB9.isSelectionInsideLastNodeInDocument)(state.selection)) tr.replace($from.pos - 1, $from.pos + $from.parent.nodeSize - 1); // Remove node
            else // Remove node content, if is the last node, let a empty paragraph
            tr.replace($from.pos, $from.pos + $from.parent.nodeSize - 1);
            // 2. Add it in the new position
            // If the sibling is a paragraph lets copy the text inside the paragraph
            // Like a normal backspace from paragraph to paragraph
            if (maybeSibling.type === paragraph) {
                const insideParagraphPos = maybeAnyBlockPos + maybeSibling.nodeSize - 2;
                (0, $gab48.safeInsert)($from.parent.content, insideParagraphPos)(tr);
            } else {
                // If is any other kind of block just add the paragraph after it
                const endOfBlockPos = maybeAnyBlockPos + maybeSibling.nodeSize - 1;
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                (0, $gab48.safeInsert)($from.parent.copy($from.parent.content), endOfBlockPos)(tr);
            }
        }
        if (dispatch) dispatch(tr);
        return true;
    };
}
const $6f37bbe3140a0e02$var$backspaceAfterMediaNode = (schema)=>{
    const isEmptyNodeInSchema = (0, $56AB9.isEmptyNode)(schema);
    return (state, dispatch)=>{
        const { selection: selection, schema: schema, tr: tr } = state;
        const { $from: $from } = selection;
        if (!$6f37bbe3140a0e02$var$isEmptySelectionAtStart(state.selection)) return false;
        if (!$6f37bbe3140a0e02$var$isSelectionInsideOf(state.selection, schema.nodes.paragraph)) return false;
        const previousSibling = -1;
        // no media single or media group
        if (!$6f37bbe3140a0e02$var$isSiblingOfType(state.selection, schema.nodes.mediaSingle, previousSibling) && !$6f37bbe3140a0e02$var$isSiblingOfType(state.selection, schema.nodes.mediaGroup, previousSibling)) return false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const media = $6f37bbe3140a0e02$var$getSibling(state.selection, previousSibling);
        // if media single
        if (media.type === schema.nodes.mediaSingle) {
            if (media.attrs.layout === 'wrap-right') return $6f37bbe3140a0e02$var$handleSelectionAfterWrapRight(isEmptyNodeInSchema)(state, dispatch);
            if (dispatch) // Select media single, and remove paragraph if it's empty.
            (0, $5FzRL.selectNodeBackward)(state, (tr)=>{
                if (isEmptyNodeInSchema($from.parent) && !(0, $5m3y9.atTheEndOfDoc)(state)) tr.replace($from.pos - 1, $from.pos + $from.parent.nodeSize - 1); // Remove node
                dispatch(tr);
            });
            return true;
        }
        // if media group
        if (dispatch) {
            // select media group, and remove paragraph if it's empty.
            if (isEmptyNodeInSchema($from.parent)) {
                tr.replace($from.pos - 1, $from.pos + $from.parent.nodeSize - 1); // remove node
                tr.setSelection(new (0, $cw0wu.NodeSelection)(tr.doc.resolve($from.pos - media.nodeSize))).scrollIntoView(); // select media
            }
            dispatch(tr);
        }
        return true;
    };
};
function $6f37bbe3140a0e02$export$2e2bcd8739ae039(schema) {
    const list = {};
    const backspaceAfterMediaCommand = $6f37bbe3140a0e02$var$backspaceAfterMediaNode(schema);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $cv8id.bindKeymapWithCommand)((0, $cv8id.backspace).common, backspaceAfterMediaCommand, list);
    return (0, $ejrfk.keymap)(list);
}

});

parcelRegister("ki6Uz", function(module, exports) {
$parcel$export(module.exports, "mediaLinkingPluginKey", () => $9bd1732456e562de$export$e8ef6001d0045a33);
$parcel$export(module.exports, "createMediaLinkingCommand", () => $9bd1732456e562de$export$2c81aa6d281594cd);
$parcel$export(module.exports, "getMediaLinkingState", () => $9bd1732456e562de$export$a27ff1704d423d4e);
$parcel$export(module.exports, "default", () => $9bd1732456e562de$export$2e2bcd8739ae039);

var $f7Kk4 = parcelRequire("f7Kk4");

var $3TnFr = parcelRequire("3TnFr");

var $cw0wu = parcelRequire("cw0wu");

var $f1HYN = parcelRequire("f1HYN");
const $9bd1732456e562de$export$e8ef6001d0045a33 = new (0, $cw0wu.PluginKey)('mediaLinking');
const $9bd1732456e562de$var$initialState = {
    visible: false,
    editable: false,
    mediaPos: null,
    link: ''
};
function $9bd1732456e562de$var$mapping(tr, pluginState) {
    if (pluginState && pluginState.mediaPos !== null) return {
        ...pluginState,
        mediaPos: tr.mapping.map(pluginState.mediaPos)
    };
    return pluginState;
}
function $9bd1732456e562de$var$onSelectionChanged(tr) {
    const isNodeSelection = tr.selection instanceof (0, $cw0wu.NodeSelection);
    if (!isNodeSelection) return $9bd1732456e562de$var$initialState;
    const pos = tr.selection.$from.pos;
    const mediaPos = tr.selection.node.type.name === 'mediaInline' ? pos : pos + 1;
    const node = tr.doc.nodeAt(mediaPos);
    if (!node || ![
        'media',
        'mediaInline'
    ].includes(node.type.name)) return $9bd1732456e562de$var$initialState;
    const mark = node.marks.find((mark)=>mark.type.name === 'link');
    if (mark) return {
        ...$9bd1732456e562de$var$initialState,
        mediaPos: mediaPos,
        editable: true,
        link: mark.attrs.href
    };
    return {
        ...$9bd1732456e562de$var$initialState,
        mediaPos: mediaPos
    };
}
const $9bd1732456e562de$var$mediaLinkingPluginFactory = (0, $3TnFr.pluginFactory)($9bd1732456e562de$export$e8ef6001d0045a33, (0, $f1HYN.default), {
    mapping: $9bd1732456e562de$var$mapping,
    onSelectionChanged: $9bd1732456e562de$var$onSelectionChanged
});
const $9bd1732456e562de$export$2c81aa6d281594cd = $9bd1732456e562de$var$mediaLinkingPluginFactory.createCommand;
const $9bd1732456e562de$export$a27ff1704d423d4e = $9bd1732456e562de$var$mediaLinkingPluginFactory.getPluginState;
var $9bd1732456e562de$export$2e2bcd8739ae039 = (dispatch)=>new (0, $f7Kk4.SafePlugin)({
        key: $9bd1732456e562de$export$e8ef6001d0045a33,
        state: $9bd1732456e562de$var$mediaLinkingPluginFactory.createPluginState(dispatch, $9bd1732456e562de$var$initialState)
    });

});
parcelRegister("f1HYN", function(module, exports) {
$parcel$export(module.exports, "default", () => $02804a17aa6dd044$export$2e2bcd8739ae039);

var $14MDp = parcelRequire("14MDp");
var $02804a17aa6dd044$export$2e2bcd8739ae039 = (state, action)=>{
    switch(action.type){
        case (0, $14MDp.MediaLinkingActionsTypes).showToolbar:
            return {
                ...state,
                visible: true
            };
        case (0, $14MDp.MediaLinkingActionsTypes).setUrl:
            return {
                ...state,
                editable: true,
                link: action.payload
            };
        case (0, $14MDp.MediaLinkingActionsTypes).hideToolbar:
            return {
                ...state,
                visible: false
            };
        case (0, $14MDp.MediaLinkingActionsTypes).unlink:
            return {
                ...state,
                link: '',
                visible: false,
                editable: false
            };
    }
    return state;
};

});
parcelRegister("14MDp", function(module, exports) {
$parcel$export(module.exports, "MediaLinkingActionsTypes", () => $d229307828b4c4bc$export$6eb9cfa224a48678);
var $d229307828b4c4bc$export$6eb9cfa224a48678 = /*#__PURE__*/ function(MediaLinkingActionsTypes) {
    MediaLinkingActionsTypes["showToolbar"] = "MEDIA_SHOW_TOOLBAR";
    MediaLinkingActionsTypes["hideToolbar"] = "MEDIA_HIDE_TOOLBAR";
    MediaLinkingActionsTypes["setUrl"] = "MEDIA_SET_LINK_TO";
    MediaLinkingActionsTypes["unlink"] = "MEDIA_LINKING_UNLINK";
    return MediaLinkingActionsTypes;
}({});

});



parcelRegister("9y8VT", function(module, exports) {
$parcel$export(module.exports, "default", () => $2fcb688dabc902d3$export$2e2bcd8739ae039);

var $cv8id = parcelRequire("cv8id");

var $ejrfk = parcelRequire("ejrfk");

var $5cifv = parcelRequire("5cifv");
function $2fcb688dabc902d3$export$2e2bcd8739ae039(schema) {
    const list = {};
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $cv8id.bindKeymapWithCommand)((0, $cv8id.addLink).common, (0, $5cifv.showLinkingToolbarWithMediaTypeCheck), list);
    return (0, $ejrfk.keymap)(list);
}

});
parcelRegister("5cifv", function(module, exports) {
$parcel$export(module.exports, "showLinkingToolbar", () => $7967f33c7048cd4b$export$e0eb18fceec368c4);
$parcel$export(module.exports, "showLinkingToolbarWithMediaTypeCheck", () => $7967f33c7048cd4b$export$f0b12e75a8c0baf5);
$parcel$export(module.exports, "hideLinkingToolbar", () => $7967f33c7048cd4b$export$3b74d2c3073f13a9);
$parcel$export(module.exports, "unlink", () => $7967f33c7048cd4b$export$5e0808041271ce04);
$parcel$export(module.exports, "setUrlToMedia", () => $7967f33c7048cd4b$export$b195a1839eae3673);

var $g6Qq4 = parcelRequire("g6Qq4");

var $bq0hv = parcelRequire("bq0hv");

var $98KMe = parcelRequire("98KMe");

var $ki6Uz = parcelRequire("ki6Uz");

var $14MDp = parcelRequire("14MDp");

var $2jJHo = parcelRequire("2jJHo");

var $tHQ9T = parcelRequire("tHQ9T");

var $i1rYO = parcelRequire("i1rYO");
const $7967f33c7048cd4b$export$e0eb18fceec368c4 = (0, $ki6Uz.createMediaLinkingCommand)((state)=>{
    const mediaLinkingState = (0, $ki6Uz.getMediaLinkingState)(state);
    if (mediaLinkingState && mediaLinkingState.mediaPos !== null) {
        const node = state.doc.nodeAt(mediaLinkingState.mediaPos);
        if (node) return {
            type: (0, $14MDp.MediaLinkingActionsTypes).showToolbar
        };
    }
    return false;
});
const $7967f33c7048cd4b$export$f0b12e75a8c0baf5 = (editorState, dispatch, editorView)=>{
    if (dispatch && editorView) {
        const mediaNode = (0, $i1rYO.currentMediaNode)(editorState);
        const mediaInlineNode = (0, $i1rYO.currentMediaInlineNode)(editorState);
        const nodeSelection = editorState.selection;
        const currentSelectedNode = nodeSelection.node;
        if (!mediaNode && !mediaInlineNode) return false;
        const { mediaClientConfig: mediaClientConfig } = (0, $2jJHo.getMediaPluginState)(editorState);
        if (!mediaClientConfig) return false;
        if (mediaNode && currentSelectedNode !== mediaInlineNode) (0, $tHQ9T.checkMediaType)(mediaNode, mediaClientConfig).then((mediaType)=>{
            if ((mediaType === 'external' || mediaType === 'image') && // We make sure the selection and the node hasn't changed.
            (0, $i1rYO.currentMediaNode)(editorView.state) === mediaNode) dispatch(editorView.state.tr.setMeta((0, $ki6Uz.mediaLinkingPluginKey), {
                type: (0, $14MDp.MediaLinkingActionsTypes).showToolbar
            }));
        });
        if (mediaInlineNode) (0, $tHQ9T.checkMediaType)(mediaInlineNode, mediaClientConfig).then((mediaType)=>{
            if ((mediaType === 'external' || mediaType === 'image') && // We make sure the selection and the node hasn't changed.
            (0, $i1rYO.currentMediaInlineNode)(editorView.state) === mediaInlineNode) dispatch(editorView.state.tr.setMeta((0, $ki6Uz.mediaLinkingPluginKey), {
                type: (0, $14MDp.MediaLinkingActionsTypes).showToolbar
            }));
        });
    }
    return true;
};
const $7967f33c7048cd4b$var$hideLinkingToolbarCommand = (0, $ki6Uz.createMediaLinkingCommand)({
    type: (0, $14MDp.MediaLinkingActionsTypes).hideToolbar
});
const $7967f33c7048cd4b$export$3b74d2c3073f13a9 = (state, dispatch, view, focusFloatingToolbar)=>{
    $7967f33c7048cd4b$var$hideLinkingToolbarCommand(state, dispatch, view);
    // restore focus on the editor so keyboard shortcuts aren't lost to the browser
    if (view && !focusFloatingToolbar) view.focus();
};
function $7967f33c7048cd4b$var$getCurrentUrl(state) {
    const { link: linkType } = state.schema.marks;
    const mediaLinkingState = (0, $ki6Uz.getMediaLinkingState)(state);
    if (!mediaLinkingState || mediaLinkingState.mediaPos === null) return;
    const $pos = state.doc.resolve(mediaLinkingState.mediaPos);
    const node = state.doc.nodeAt($pos.pos);
    if (!node) return;
    const hasLink = linkType.isInSet(node.marks);
    if (!hasLink) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const link = node.marks.find((mark)=>mark.type === linkType); // Already check exist
    const url = link.attrs.href;
    return url;
}
function $7967f33c7048cd4b$var$toggleLinkMark(tr, state, { forceRemove: forceRemove = false, url: url }) {
    const mediaLinkingState = (0, $ki6Uz.getMediaLinkingState)(state);
    if (!mediaLinkingState || mediaLinkingState.mediaPos === null) return tr;
    const $pos = state.doc.resolve(mediaLinkingState.mediaPos);
    const node = state.doc.nodeAt($pos.pos);
    if (!node) return tr;
    const linkMark = state.schema.marks.link;
    const { media: media, mediaInline: mediaInline } = state.schema.nodes;
    if (node.type !== mediaInline) {
        const toggleBlockLinkMark = (0, $bq0hv.createToggleBlockMarkOnRange)(linkMark, (prevAttrs, node)=>{
            // Only add mark to media
            if (!node || node.type !== media) return; //No op
            if (forceRemove) return false;
            const href = (0, $98KMe.normalizeUrl)(url);
            if (prevAttrs && prevAttrs.href === href) return; //No op
            if (href.trim() === '') return false; // remove
            return {
                ...prevAttrs,
                href: href
            };
        }, [
            media
        ]);
        toggleBlockLinkMark($pos.pos, $pos.pos + node.nodeSize, tr, state);
    }
    const toggleInlineLinkMark = (0, $bq0hv.createToggleInlineMarkOnRange)(linkMark, (prevAttrs, node)=>{
        // Only add mark to mediaInline
        if (!node || node.type !== mediaInline) return; //No op
        if (forceRemove) return false;
        const href = (0, $98KMe.normalizeUrl)(url);
        if (prevAttrs && prevAttrs.href === href) return; //No op
        if (href.trim() === '') return false; // remove
        return {
            ...prevAttrs,
            href: href
        };
    });
    toggleInlineLinkMark($pos.pos, $pos.pos + node.nodeSize, tr, state);
    return tr;
}
const $7967f33c7048cd4b$var$fireAnalyticForMediaLink = (tr, action, attributes, editorAnalyticsAPI)=>{
    editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent({
        action: action,
        eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
        actionSubject: (0, $g6Qq4.ACTION_SUBJECT).MEDIA,
        actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).LINK,
        attributes: attributes
    })(tr);
    return tr;
};
const $7967f33c7048cd4b$export$5e0808041271ce04 = (editorAnalyticsAPI)=>(0, $ki6Uz.createMediaLinkingCommand)({
        type: (0, $14MDp.MediaLinkingActionsTypes).unlink
    }, (tr, state)=>{
        const transaction = $7967f33c7048cd4b$var$toggleLinkMark(tr, state, {
            forceRemove: true
        });
        return $7967f33c7048cd4b$var$fireAnalyticForMediaLink(transaction, (0, $g6Qq4.ACTION).DELETED, {
            ...$7967f33c7048cd4b$var$getNodeTypeAndMediaTypeAttributes(state)
        }, editorAnalyticsAPI);
    });
const $7967f33c7048cd4b$var$getAction = (newUrl, state)=>{
    const currentUrl = $7967f33c7048cd4b$var$getCurrentUrl(state);
    if (!currentUrl) return (0, $g6Qq4.ACTION).ADDED;
    else if (newUrl !== currentUrl) return (0, $g6Qq4.ACTION).EDITED;
    return undefined;
};
const $7967f33c7048cd4b$var$getNodeTypeAndMediaTypeAttributes = (state)=>{
    const mediaLinkingState = (0, $ki6Uz.getMediaLinkingState)(state);
    const { allowInlineImages: allowInlineImages } = (0, $2jJHo.getMediaPluginState)(state);
    const { mediaInline: mediaInline, mediaSingle: mediaSingle } = state.schema.nodes;
    if (!mediaLinkingState || mediaLinkingState.mediaPos === null) return;
    const $pos = state.doc.resolve(mediaLinkingState.mediaPos);
    const node = state.doc.nodeAt($pos.pos);
    if (!node) return {};
    if (allowInlineImages && node.type === mediaInline) return {
        type: mediaInline.name,
        mediaType: node.attrs.type
    };
    return {
        type: mediaSingle.name,
        mediaType: node.attrs.type
    };
};
const $7967f33c7048cd4b$export$b195a1839eae3673 = (url, inputMethod, editorAnalyticsAPI)=>(0, $ki6Uz.createMediaLinkingCommand)({
        type: (0, $14MDp.MediaLinkingActionsTypes).setUrl,
        payload: (0, $98KMe.normalizeUrl)(url)
    }, (tr, state)=>{
        const action = $7967f33c7048cd4b$var$getAction(url, state);
        if (!action) return tr;
        const nodeTypeAndMediaTypeAttrs = $7967f33c7048cd4b$var$getNodeTypeAndMediaTypeAttributes(state);
        try {
            const toggleLinkMarkResult = $7967f33c7048cd4b$var$toggleLinkMark(tr, state, {
                url: url
            });
            $7967f33c7048cd4b$var$fireAnalyticForMediaLink(tr, action, action === (0, $g6Qq4.ACTION).ADDED ? {
                inputMethod: inputMethod,
                ...nodeTypeAndMediaTypeAttrs
            } : nodeTypeAndMediaTypeAttrs, editorAnalyticsAPI);
            return toggleLinkMarkResult;
        } catch (e) {
            $7967f33c7048cd4b$var$fireAnalyticForMediaLink(tr, (0, $g6Qq4.ACTION).ERRORED, {
                action: action,
                ...nodeTypeAndMediaTypeAttrs
            }, editorAnalyticsAPI);
            throw e;
        }
    });

});


parcelRegister("9iI02", function(module, exports) {
$parcel$export(module.exports, "createCommand", () => $609af0ccb08a9906$export$8d4021544bdece00);
$parcel$export(module.exports, "getPluginState", () => $609af0ccb08a9906$export$f05434c51e3762e);
$parcel$export(module.exports, "createPlugin", () => $609af0ccb08a9906$export$ae829ec7b2625219);

var $f7Kk4 = parcelRequire("f7Kk4");

var $3TnFr = parcelRequire("3TnFr");

var $cw0wu = parcelRequire("cw0wu");

var $dlMbz = parcelRequire("dlMbz");
const $609af0ccb08a9906$var$pluginKey = new (0, $cw0wu.PluginKey)('mediaPixelResizingPlugin');
const $609af0ccb08a9906$var$dest = (0, $3TnFr.pluginFactory)($609af0ccb08a9906$var$pluginKey, (0, $dlMbz.default), {
    onSelectionChanged () {
        return {
            isPixelEditorOpen: false
        };
    }
});
const $609af0ccb08a9906$var$createPluginState = $609af0ccb08a9906$var$dest.createPluginState;
const $609af0ccb08a9906$export$8d4021544bdece00 = $609af0ccb08a9906$var$dest.createCommand;
const $609af0ccb08a9906$export$f05434c51e3762e = $609af0ccb08a9906$var$dest.getPluginState;
const $609af0ccb08a9906$export$ae829ec7b2625219 = ({ dispatch: dispatch })=>{
    return new (0, $f7Kk4.SafePlugin)({
        state: $609af0ccb08a9906$var$createPluginState(dispatch, {
            isPixelEditorOpen: false
        }),
        key: $609af0ccb08a9906$var$pluginKey
    });
};

});
parcelRegister("dlMbz", function(module, exports) {
$parcel$export(module.exports, "default", () => $4ad9236c5a2d5ece$export$2e2bcd8739ae039);
var $4ad9236c5a2d5ece$export$2e2bcd8739ae039 = (state, action)=>{
    switch(action.type){
        case 'openPixelEditor':
            return {
                ...state,
                isPixelEditorOpen: true
            };
        case 'closePixelEditor':
            return {
                ...state,
                isPixelEditorOpen: false
            };
        default:
            return state;
    }
};

});


parcelRegister("ieBDn", function(module, exports) {
$parcel$export(module.exports, "MediaPickerComponents", () => $f8fd6ecf9ac6ac0a$export$b8a89db960d45391);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $5beht = parcelRequire("5beht");

var $8DueG = parcelRequire("8DueG");

var $fdq38 = parcelRequire("fdq38");

var $dVYrS = parcelRequire("dVYrS");
const $f8fd6ecf9ac6ac0a$var$selector = (states)=>{
    var _states$focusState, _states$connectivityS, _states$mediaState;
    return {
        hasFocus: (_states$focusState = states.focusState) === null || _states$focusState === void 0 ? void 0 : _states$focusState.hasFocus,
        connectivityMode: (_states$connectivityS = states.connectivityState) === null || _states$connectivityS === void 0 ? void 0 : _states$connectivityS.mode,
        mediaOptions: (_states$mediaState = states.mediaState) === null || _states$mediaState === void 0 ? void 0 : _states$mediaState.mediaOptions
    };
};
const $f8fd6ecf9ac6ac0a$var$MediaPicker = ({ api: api, isPopupOpened: isPopupOpened, appearance: appearance, onBrowseFn: onBrowseFn, editorDomElement: editorDomElement })=>{
    const { hasFocus: hasFocus, connectivityMode: connectivityMode, mediaOptions: mediaOptions } = (0, $5beht.useSharedPluginStateWithSelector)(api, [
        'focus',
        'connectivity',
        'media'
    ], $f8fd6ecf9ac6ac0a$var$selector);
    const featureFlags = mediaOptions && mediaOptions.featureFlags;
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const editorDom = editorDomElement;
    const editorParent = editorDom.parentElement ?? undefined;
    /**
   * https://product-fabric.atlassian.net/browse/ED-21993
   * Avoid attach paste event to same dom element,
   * so editor-paste-plugin can use stopPropagation,
   * as stopImmediatePropagation could cause race condition issues
   */ const container = editorParent;
    const clipboard = hasFocus ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $fdq38.ClipboardWrapper), {
        api: api,
        featureFlags: featureFlags,
        container: container
    }) : null;
    return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $dc70d.Fragment), {
        children: [
            clipboard,
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $dVYrS.DropzoneWrapper), {
                api: api,
                isActive: !isPopupOpened && // If we're offline don't show the dropzone
                connectivityMode !== 'offline',
                featureFlags: featureFlags,
                editorDomElement: editorDomElement,
                appearance: appearance
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $8DueG.BrowserWrapper), {
                api: api,
                onBrowseFn: onBrowseFn,
                featureFlags: featureFlags
            })
        ]
    });
};
class $f8fd6ecf9ac6ac0a$export$b8a89db960d45391 extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Component {
    static #_ = this.displayName = 'MediaPickerComponents';
    componentDidMount() {
        const { onPopupToggle: onPopupToggle } = this.props;
        onPopupToggle((isPopupOpened)=>{
            this.setState({
                isPopupOpened: isPopupOpened
            });
        });
    }
    render() {
        const { api: api, editorDomElement: editorDomElement, appearance: appearance } = this.props;
        const { isPopupOpened: isPopupOpened } = this.state;
        return /*#__PURE__*/ (0, $dc70d.jsx)($f8fd6ecf9ac6ac0a$var$MediaPicker, {
            editorDomElement: editorDomElement,
            appearance: appearance,
            isPopupOpened: isPopupOpened,
            onBrowseFn: this.onBrowseFn,
            api: api
        });
    }
    constructor(...args){
        super(...args), this.state = {
            isPopupOpened: false
        }, this.onBrowseFn = (nativeBrowseFn)=>{
            const { setBrowseFn: setBrowseFn } = this.props;
            setBrowseFn(nativeBrowseFn);
        };
    }
}

});
parcelRegister("8DueG", function(module, exports) {
$parcel$export(module.exports, "BrowserWrapper", () => $ddfb260ddb911dff$export$78e63feb3bcb89b0);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $8AI2A = parcelRequire("8AI2A");

var $7I1Lf = parcelRequire("7I1Lf");
const $ddfb260ddb911dff$export$78e63feb3bcb89b0 = ({ api: api, isOpen: isOpen, onBrowseFn: onBrowseFn, featureFlags: featureFlags })=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $7I1Lf.default), {
        api: api,
        analyticsName: "browser",
        children: ({ mediaClientConfig: mediaClientConfig, config: config, pickerFacadeInstance: pickerFacadeInstance })=>{
            const browserConfig = {
                ...config,
                multiple: true
            };
            return /*#__PURE__*/ (0, $dc70d.jsx)((0, $8AI2A.BrowserLoader), {
                onBrowseFn: onBrowseFn,
                isOpen: isOpen,
                config: browserConfig,
                mediaClientConfig: mediaClientConfig,
                onEnd: pickerFacadeInstance.handleReady,
                onError: pickerFacadeInstance.handleUploadError,
                onPreviewUpdate: pickerFacadeInstance.handleUploadPreviewUpdate,
                featureFlags: featureFlags
            });
        }
    });

});
parcelRegister("7I1Lf", function(module, exports) {
$parcel$export(module.exports, "default", () => $46a551258609c2d9$export$2e2bcd8739ae039);

var $bSJIT = parcelRequire("bSJIT");

var $4Sf72 = parcelRequire("4Sf72");

var $ehhh6 = parcelRequire("ehhh6");

var $5beht = parcelRequire("5beht");

var $fxLWg = parcelRequire("fxLWg");
const $46a551258609c2d9$var$dummyMediaPickerObject = {
    on: ()=>{},
    removeAllListeners: ()=>{},
    emit: ()=>{},
    destroy: ()=>{},
    setUploadParams: ()=>{}
};
const $46a551258609c2d9$var$selector = (states)=>{
    var _states$mediaState, _states$mediaState2, _states$mediaState3, _states$mediaState4;
    return {
        mediaProvider: (_states$mediaState = states.mediaState) === null || _states$mediaState === void 0 ? void 0 : _states$mediaState.mediaProvider,
        mediaOptions: (_states$mediaState2 = states.mediaState) === null || _states$mediaState2 === void 0 ? void 0 : _states$mediaState2.mediaOptions,
        insertFile: (_states$mediaState3 = states.mediaState) === null || _states$mediaState3 === void 0 ? void 0 : _states$mediaState3.insertFile,
        options: (_states$mediaState4 = states.mediaState) === null || _states$mediaState4 === void 0 ? void 0 : _states$mediaState4.options
    };
};
function $46a551258609c2d9$export$2e2bcd8739ae039({ api: api, analyticsName: analyticsName, children: children }) {
    const [state, setState] = (0, $bSJIT.useState)({
        pickerFacadeInstance: undefined,
        config: undefined,
        mediaClientConfig: undefined
    });
    const { mediaProvider: mediaProvider, mediaOptions: mediaOptions, insertFile: insertFile, options: options } = (0, $5beht.useSharedPluginStateWithSelector)(api, [
        'media'
    ], $46a551258609c2d9$var$selector);
    const handleMediaProvider = (0, $bSJIT.useCallback)(async (_name, provider)=>{
        const mediaProvider = await provider;
        if (!mediaProvider || !mediaProvider.uploadParams || !insertFile) return;
        const resolvedMediaClientConfig = await mediaProvider.uploadMediaClientConfig || await mediaProvider.viewMediaClientConfig;
        if (!resolvedMediaClientConfig) return;
        const pickerFacadeConfig = {
            mediaClientConfig: resolvedMediaClientConfig,
            errorReporter: (options === null || options === void 0 ? void 0 : options.errorReporter) || new (0, $ehhh6.ErrorReporter)(),
            featureFlags: mediaOptions && mediaOptions.featureFlags
        };
        const pickerFacadeInstance = await new (0, $fxLWg.default)('customMediaPicker', pickerFacadeConfig, $46a551258609c2d9$var$dummyMediaPickerObject, analyticsName).init();
        pickerFacadeInstance.onNewMedia(insertFile);
        pickerFacadeInstance.setUploadParams(mediaProvider.uploadParams);
        const config = {
            uploadParams: mediaProvider.uploadParams
        };
        (0, $4Sf72.flushSync)(()=>{
            setState({
                pickerFacadeInstance: pickerFacadeInstance,
                config: config,
                mediaClientConfig: resolvedMediaClientConfig
            });
        });
    }, [
        analyticsName,
        insertFile,
        mediaOptions,
        options === null || options === void 0 ? void 0 : options.errorReporter
    ]);
    (0, $bSJIT.useEffect)(()=>{
        if (mediaProvider) // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- Ignored via go/ees017 (to be fixed)
        handleMediaProvider('mediaProvider', Promise.resolve(mediaProvider));
    }, [
        mediaProvider,
        handleMediaProvider
    ]);
    const { mediaClientConfig: mediaClientConfig, config: config, pickerFacadeInstance: pickerFacadeInstance } = state;
    if (!mediaClientConfig || !config || !pickerFacadeInstance) return null;
    return children({
        mediaClientConfig: mediaClientConfig,
        config: config,
        pickerFacadeInstance: pickerFacadeInstance
    });
}

});


parcelRegister("fdq38", function(module, exports) {
$parcel$export(module.exports, "ClipboardWrapper", () => $fc0243bdc994d897$export$b7fcd7f87db4d1ee);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $ewM8s = parcelRequire("ewM8s");

var $7I1Lf = parcelRequire("7I1Lf");
const $fc0243bdc994d897$export$b7fcd7f87db4d1ee = ({ api: api, container: container, featureFlags: featureFlags })=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $7I1Lf.default), {
        api: api,
        analyticsName: "clipboard",
        children: ({ mediaClientConfig: mediaClientConfig, config: config, pickerFacadeInstance: pickerFacadeInstance })=>{
            const clipboardConfig = Object.assign({}, config);
            clipboardConfig.container = container;
            clipboardConfig.onPaste = (event)=>{
                event.stopPropagation();
                return false;
            };
            return /*#__PURE__*/ (0, $dc70d.jsx)((0, $ewM8s.ClipboardLoader), {
                mediaClientConfig: mediaClientConfig,
                config: clipboardConfig,
                onError: pickerFacadeInstance.handleUploadError,
                onPreviewUpdate: pickerFacadeInstance.handleUploadPreviewUpdate,
                onEnd: pickerFacadeInstance.handleReady,
                featureFlags: featureFlags
            });
        }
    });

});

parcelRegister("dVYrS", function(module, exports) {
$parcel$export(module.exports, "DropzoneWrapper", () => $0cec30b49eacf459$export$1364cc2f4ae811f4);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9xvBa = parcelRequire("9xvBa");

var $5beht = parcelRequire("5beht");

var $7tc9a = parcelRequire("7tc9a");

var $7xuRi = parcelRequire("7xuRi");

var $7I1Lf = parcelRequire("7I1Lf");
const $0cec30b49eacf459$var$selector = (states)=>{
    var _states$mediaState, _states$mediaState2, _states$mediaState3, _states$mediaState4, _states$mediaState5;
    return {
        options: (_states$mediaState = states.mediaState) === null || _states$mediaState === void 0 ? void 0 : _states$mediaState.options,
        handleDrag: (_states$mediaState2 = states.mediaState) === null || _states$mediaState2 === void 0 ? void 0 : _states$mediaState2.handleDrag,
        handleDragOver: (_states$mediaState3 = states.mediaState) === null || _states$mediaState3 === void 0 ? void 0 : _states$mediaState3.handleDragOver,
        handleDrop: (_states$mediaState4 = states.mediaState) === null || _states$mediaState4 === void 0 ? void 0 : _states$mediaState4.handleDrop,
        dropTargets: (_states$mediaState5 = states.mediaState) === null || _states$mediaState5 === void 0 ? void 0 : _states$mediaState5.dropTargets
    };
};
const $0cec30b49eacf459$var$DropzoneWrapperInternal = ({ api: api, isActive: isActive, featureFlags: featureFlags, editorDomElement: editorDomElement, appearance: appearance, mediaClientConfig: mediaClientConfig, config: config, pickerFacadeInstance: pickerFacadeInstance })=>{
    const { options: options, handleDrag: handleDrag, handleDragOver: handleDragOver, handleDrop: handleDrop, dropTargets: dropTargets } = (0, $5beht.useSharedPluginStateWithSelector)(api, [
        'media'
    ], $0cec30b49eacf459$var$selector);
    const usePointerPosition = (0, $7xuRi.isMediaDropPositionEnabled)();
    /** The mounted dropzone invokes this only for accepted external file drags and drops. */ const enrolInMediaDropExperiment = (0, $bSJIT.useCallback)(()=>{
        (0, $7xuRi.exposeMediaDropPosition)();
    }, []);
    const handleDragEnter = (0, $bSJIT.useCallback)(()=>{
        enrolInMediaDropExperiment();
        handleDrag === null || handleDrag === void 0 || handleDrag('enter');
    }, [
        enrolInMediaDropExperiment,
        handleDrag
    ]);
    const handleError = (0, $bSJIT.useCallback)((payload)=>{
        dropTargets === null || dropTargets === void 0 || dropTargets.inserted(payload.fileId);
        pickerFacadeInstance.handleUploadError(payload);
    }, [
        dropTargets,
        pickerFacadeInstance
    ]);
    const handleUploadsStart = (0, $bSJIT.useCallback)(({ files: files, traceContext: traceContext })=>{
        if (traceContext) dropTargets === null || dropTargets === void 0 || dropTargets.register(traceContext.traceId, files.map((file)=>file.id));
    }, [
        dropTargets
    ]);
    const { customDropzoneContainer: customDropzoneContainer } = options || {};
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const editorHtmlElement = editorDomElement;
    const scrollParent = appearance === 'full-page' && (0, $9xvBa.findOverflowScrollParent)(editorHtmlElement);
    const container = customDropzoneContainer || (scrollParent ? scrollParent : editorHtmlElement);
    /** Clears a stale hover indicator when the dropzone is removed or replaced mid-drag. */ (0, $bSJIT.useEffect)(()=>{
        if (!usePointerPosition || !isActive) return;
        return ()=>handleDrag === null || handleDrag === void 0 ? void 0 : handleDrag('leave');
    }, [
        container,
        handleDrag,
        isActive,
        usePointerPosition
    ]);
    const dropzoneConfig = {
        ...config,
        container: container
    };
    return isActive ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $7tc9a.DropzoneLoader), {
        mediaClientConfig: mediaClientConfig,
        config: dropzoneConfig,
        onDragOver: usePointerPosition ? handleDragOver : undefined,
        onDrop: enrolInMediaDropExperiment,
        onDropWithContext: usePointerPosition ? handleDrop : undefined,
        onUploadsStart: usePointerPosition ? handleUploadsStart : undefined,
        onError: usePointerPosition ? handleError : pickerFacadeInstance.handleUploadError,
        onPreviewUpdate: pickerFacadeInstance.handleUploadPreviewUpdate,
        onEnd: pickerFacadeInstance.handleReady,
        onDragEnter: handleDragEnter,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onDragLeave: ()=>handleDrag === null || handleDrag === void 0 ? void 0 : handleDrag('leave'),
        featureFlags: featureFlags
    }) : null;
};
const $0cec30b49eacf459$export$1364cc2f4ae811f4 = ({ api: api, isActive: isActive, featureFlags: featureFlags, editorDomElement: editorDomElement, appearance: appearance })=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $7I1Lf.default), {
        api: api,
        analyticsName: "dropzone",
        children: ({ mediaClientConfig: mediaClientConfig, config: config, pickerFacadeInstance: pickerFacadeInstance })=>/*#__PURE__*/ (0, $dc70d.jsx)($0cec30b49eacf459$var$DropzoneWrapperInternal, {
                api: api,
                isActive: isActive,
                featureFlags: featureFlags,
                editorDomElement: editorDomElement,
                appearance: appearance,
                mediaClientConfig: mediaClientConfig,
                config: config,
                pickerFacadeInstance: pickerFacadeInstance
            })
    });

});


parcelRegister("7zSFj", function(module, exports) {
$parcel$export(module.exports, "RenderMediaViewer", () => $51b136df52efd1c9$export$d852d5f849a8df8d);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $4Sf72 = parcelRequire("4Sf72");

var $h1iH7 = parcelRequire("h1iH7");

var $7omWA = parcelRequire("7omWA");
const $51b136df52efd1c9$var$getIdentifier = (attrs)=>{
    if ((0, $7omWA.isExternalMedia)(attrs)) return {
        mediaItemType: 'external-image',
        dataURI: attrs.url
    };
    else {
        const { id: id, collection: collection = '' } = attrs;
        return {
            id: id,
            mediaItemType: 'file',
            collectionName: collection
        };
    }
};
const $51b136df52efd1c9$export$d852d5f849a8df8d = ({ mediaClientConfig: mediaClientConfig, onClose: onClose, selectedNodeAttrs: selectedNodeAttrs, items: items = [], extensions: extensions, fallbackMediaNameFetcher: fallbackMediaNameFetcher })=>{
    const identifier = $51b136df52efd1c9$var$getIdentifier(selectedNodeAttrs);
    const collectionName = (0, $7omWA.isExternalMedia)(selectedNodeAttrs) ? '' : selectedNodeAttrs.collection;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4Sf72))).createPortal(/*#__PURE__*/ (0, $dc70d.jsx)((0, $h1iH7.default), {
        collectionName: collectionName,
        items: items,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        mediaClientConfig: mediaClientConfig,
        selectedItem: identifier,
        onClose: onClose,
        extensions: extensions,
        fallbackMediaNameFetcher: fallbackMediaNameFetcher
    }), document.body);
};

});

parcelRegister("2L3c8", function(module, exports) {
$parcel$export(module.exports, "handleShowMediaViewer", () => $0824fa77277ac6f0$export$19271a18f1ddc766);
$parcel$export(module.exports, "floatingToolbar", () => $0824fa77277ac6f0$export$4850df084251d287);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $g6Qq4 = parcelRequire("g6Qq4");

var $gHATu = parcelRequire("gHATu");

var $hVGJk = parcelRequire("hVGJk");

var $jEFfF = parcelRequire("jEFfF");

var $fNLdd = parcelRequire("fNLdd");

var $278lv = parcelRequire("278lv");

var $ahEv1 = parcelRequire("ahEv1");

var $8qHhy = parcelRequire("8qHhy");

var $5NaaJ = parcelRequire("5NaaJ");

var $cw0wu = parcelRequire("cw0wu");

var $gab48 = parcelRequire("gab48");

var $5bbjm = parcelRequire("5bbjm");

var $e856D = parcelRequire("e856D");

var $c81bI = parcelRequire("c81bI");

var $gV64P = parcelRequire("gV64P");

var $3iMZX = parcelRequire("3iMZX");

var $j7FKK = parcelRequire("j7FKK");

var $kGogQ = parcelRequire("kGogQ");

var $g6z2B = parcelRequire("g6z2B");

var $eNuIV = parcelRequire("eNuIV");

var $lWuWs = parcelRequire("lWuWs");

var $4rvUe = parcelRequire("4rvUe");

var $kwptA = parcelRequire("kwptA");

var $2HqML = parcelRequire("2HqML");

var $3y2s4 = parcelRequire("3y2s4");

var $gdUUy = parcelRequire("gdUUy");

var $e35II = parcelRequire("e35II");

var $dnBXh = parcelRequire("dnBXh");

var $5cifv = parcelRequire("5cifv");

var $ki6Uz = parcelRequire("ki6Uz");

var $9iI02 = parcelRequire("9iI02");

var $b1AVF = parcelRequire("b1AVF");

var $7ICJC = parcelRequire("7ICJC");

var $i1rYO = parcelRequire("i1rYO");

var $jmBd6 = parcelRequire("jmBd6");

var $emGE2 = parcelRequire("emGE2");

var $gHqj4 = parcelRequire("gHqj4");

var $jAHUG = parcelRequire("jAHUG");

var $3iiJ3 = parcelRequire("3iiJ3");

var $54s68 = parcelRequire("54s68");

var $j5PoU = parcelRequire("j5PoU");

var $ipOKx = parcelRequire("ipOKx");

var $fV1C5 = parcelRequire("fV1C5");

var $5tgEy = parcelRequire("5tgEy");

var $hX4GT = parcelRequire("hX4GT");

var $7omWA = parcelRequire("7omWA");
const $0824fa77277ac6f0$var$mediaTypeMessages = {
    image: (0, $2HqML.messages).file_image_is_selected,
    video: (0, $2HqML.messages).file_video_is_selected,
    audio: (0, $2HqML.messages).file_audio_is_selected,
    doc: (0, $2HqML.messages).file_doc_is_selected,
    archive: (0, $2HqML.messages).file_archive_is_selected,
    unknown: (0, $2HqML.messages).file_unknown_is_selected
};
const $0824fa77277ac6f0$var$getMediaActionSubject = (nodeType)=>{
    switch(nodeType.name){
        case 'mediaSingle':
            return (0, $g6Qq4.ACTION_SUBJECT).MEDIA_SINGLE;
        case 'mediaInline':
            return (0, $g6Qq4.ACTION_SUBJECT).MEDIA_INLINE;
        case 'mediaGroup':
            return (0, $g6Qq4.ACTION_SUBJECT).MEDIA_GROUP;
        default:
            return (0, $g6Qq4.ACTION_SUBJECT).MEDIA;
    }
};
const $0824fa77277ac6f0$var$removeWithAnalytics = (editorAnalyticsApi, nodeType)=>{
    if (!nodeType) return $0824fa77277ac6f0$var$remove;
    const mediaType = $0824fa77277ac6f0$var$getMediaActionSubject(nodeType);
    return (0, $5NaaJ.withAnalytics)(editorAnalyticsApi, {
        action: (0, $g6Qq4.ACTION).DELETED,
        actionSubject: mediaType,
        attributes: {
            inputMethod: (0, $g6Qq4.INPUT_METHOD).FLOATING_TB
        },
        eventType: (0, $g6Qq4.EVENT_TYPE).TRACK
    })($0824fa77277ac6f0$var$remove);
};
const $0824fa77277ac6f0$var$remove = (state, dispatch)=>{
    if (dispatch) dispatch((0, $gab48.removeSelectedNode)(state.tr));
    return true;
};
const $0824fa77277ac6f0$var$handleRemoveMediaGroupWithAnalytics = (editorAnalyticsApi)=>{
    return (0, $5NaaJ.withAnalytics)(editorAnalyticsApi, {
        action: (0, $g6Qq4.ACTION).DELETED,
        actionSubject: (0, $g6Qq4.ACTION_SUBJECT).MEDIA_GROUP,
        attributes: {
            inputMethod: (0, $g6Qq4.INPUT_METHOD).FLOATING_TB
        },
        eventType: (0, $g6Qq4.EVENT_TYPE).TRACK
    })($0824fa77277ac6f0$var$handleRemoveMediaGroup);
};
const $0824fa77277ac6f0$var$handleRemoveMediaGroup = (state, dispatch)=>{
    const tr = (0, $7omWA.removeMediaGroupNode)(state);
    if (dispatch) dispatch(tr);
    return true;
};
const $0824fa77277ac6f0$export$19271a18f1ddc766 = ({ api: api, mediaPluginState: mediaPluginState })=>{
    const selectedNodeAttrs = (0, $7omWA.getSelectedNearestMediaContainerNodeAttrs)(mediaPluginState);
    if (!selectedNodeAttrs) return false;
    api === null || api === void 0 || api.core.actions.execute(api === null || api === void 0 ? void 0 : api.media.commands.showMediaViewer(selectedNodeAttrs));
};
const $0824fa77277ac6f0$export$909b58dbf0af33b8 = ({ api: api, mediaPluginState: mediaPluginState })=>{
    var _api$mediaEditing;
    const selectedNodeAttrs = (0, $7omWA.getSelectedNearestMediaContainerNodeAttrs)(mediaPluginState);
    if (!selectedNodeAttrs) return false;
    api === null || api === void 0 || api.core.actions.execute(api === null || api === void 0 || (_api$mediaEditing = api.mediaEditing) === null || _api$mediaEditing === void 0 ? void 0 : _api$mediaEditing.commands.showImageEditor(selectedNodeAttrs));
};
const $0824fa77277ac6f0$var$generateMediaCardFloatingToolbar = (state, intl, mediaPluginState, hoverDecoration, pluginInjectionApi, editorAnalyticsAPI, forceFocusSelector, isViewOnly)=>{
    var _pluginInjectionApi$c;
    const disableDownloadButton = (0, $7omWA.getIsDownloadDisabledByDataSecurityPolicy)(mediaPluginState);
    const areAnyNewToolbarFlagsEnabled = (0, $8qHhy.areToolbarFlagsEnabled)(Boolean(pluginInjectionApi === null || pluginInjectionApi === void 0 ? void 0 : pluginInjectionApi.toolbar));
    const preview = {
        id: 'editor.media.viewer',
        testId: 'file-preview-toolbar-button',
        type: 'button',
        icon: areAnyNewToolbarFlagsEnabled ? (0, (/*@__PURE__*/$parcel$interopDefault($j7FKK))) : (0, (/*@__PURE__*/$parcel$interopDefault($eNuIV))),
        title: intl.formatMessage((0, $2HqML.messages).expand),
        onClick: ()=>{
            return $0824fa77277ac6f0$export$19271a18f1ddc766({
                mediaPluginState: mediaPluginState,
                api: pluginInjectionApi
            }) ?? false;
        },
        disabled: (0, $hVGJk.isOfflineMode)(pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$c = pluginInjectionApi.connectivity) === null || _pluginInjectionApi$c === void 0 || (_pluginInjectionApi$c = _pluginInjectionApi$c.sharedState) === null || _pluginInjectionApi$c === void 0 || (_pluginInjectionApi$c = _pluginInjectionApi$c.currentState()) === null || _pluginInjectionApi$c === void 0 ? void 0 : _pluginInjectionApi$c.mode),
        supportsViewMode: true
    };
    const download = {
        id: 'editor.media.card.download',
        type: 'button',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3iMZX))),
        onClick: ()=>{
            (0, $7omWA.downloadMedia)(mediaPluginState);
            return true;
        },
        title: intl.formatMessage((0, $2HqML.messages).download),
        disabled: disableDownloadButton,
        ...areAnyNewToolbarFlagsEnabled && {
            supportsViewMode: true
        }
    };
    if (isViewOnly && !areAnyNewToolbarFlagsEnabled) return [];
    const { mediaGroup: mediaGroup } = state.schema.nodes;
    const items = [];
    if (!areAnyNewToolbarFlagsEnabled) items.push({
        id: 'editor.media.view.switcher.inline',
        type: 'button',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($g6z2B))),
        selected: false,
        focusEditoronEnter: true,
        disabled: false,
        onClick: (0, $jAHUG.changeMediaCardToInline)(editorAnalyticsAPI, forceFocusSelector),
        title: intl.formatMessage((0, $278lv.messages).inlineTitle),
        testId: 'inline-appearance',
        className: 'inline-appearance' // a11y. uses to force focus on item
    }, {
        id: 'editor.media.view.switcher.thumbnail',
        type: 'button',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lWuWs))),
        selected: true,
        disabled: false,
        focusEditoronEnter: true,
        onClick: ()=>true,
        title: intl.formatMessage((0, $278lv.messages).blockTitle),
        testId: 'thumbnail-appearance',
        className: 'thumbnail-appearance' // a11y. uses to force focus on item
    }, {
        type: 'separator'
    }, preview, {
        type: 'separator'
    }, download, {
        type: 'separator'
    }, {
        type: 'copy-button',
        supportsViewMode: true,
        items: [
            {
                state: state,
                formatMessage: intl.formatMessage,
                nodeType: mediaGroup
            }
        ]
    }, {
        type: 'separator'
    }, {
        id: 'editor.media.delete',
        type: 'button',
        appearance: 'danger',
        focusEditoronEnter: true,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gV64P))),
        onMouseEnter: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(mediaGroup, true),
        onMouseLeave: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(mediaGroup, false),
        onFocus: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(mediaGroup, true),
        onBlur: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(mediaGroup, false),
        title: intl.formatMessage((0, $fNLdd.default).remove),
        onClick: $0824fa77277ac6f0$var$handleRemoveMediaGroupWithAnalytics(editorAnalyticsAPI),
        testId: 'media-toolbar-remove-button'
    });
    else {
        const options = [
            {
                id: 'editor.media.view.switcher.inline',
                title: intl.formatMessage((0, $278lv.messages).inlineTitle),
                onClick: (0, $jAHUG.changeMediaCardToInline)(editorAnalyticsAPI, forceFocusSelector),
                icon: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g6z2B))), {
                    label: "",
                    spacing: "spacious"
                })
            },
            {
                id: 'editor.media.view.switcher.thumbnail',
                title: intl.formatMessage((0, $278lv.messages).blockTitle),
                selected: true,
                onClick: ()=>true,
                icon: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lWuWs))), {
                    label: "",
                    spacing: "spacious"
                })
            }
        ];
        const switcherDropdown = {
            title: intl.formatMessage((0, $2HqML.messages).fileDisplayOptions),
            id: 'media-group-inline-switcher-toolbar-item',
            testId: 'media-group-inline-switcher-dropdown',
            type: 'dropdown',
            options: options,
            icon: ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lWuWs))), {
                    label: "",
                    spacing: "spacious"
                })
        };
        items.push(switcherDropdown, {
            type: 'separator',
            fullHeight: true
        }, download, {
            type: 'separator',
            supportsViewMode: true
        }, preview, {
            type: 'separator',
            fullHeight: true
        });
    }
    return items;
};
const $0824fa77277ac6f0$var$generateMediaSingleFloatingToolbar = (state, intl, options, pluginState, mediaLinkingState, pluginInjectionApi)=>{
    var _pluginInjectionApi$d;
    const { mediaSingle: mediaSingle } = state.schema.nodes;
    const { allowResizing: allowResizing, allowLinking: allowLinking, allowAdvancedToolBarOptions: allowAdvancedToolBarOptions, allowCommentsOnMedia: allowCommentsOnMedia, allowResizingInTables: allowResizingInTables, allowAltTextOnImages: allowAltTextOnImages, allowMediaInline: allowMediaInline, allowMediaInlineImages: allowMediaInlineImages, allowImageEditing: allowImageEditing, allowImagePreview: allowImagePreview, isViewOnly: isViewOnly, allowPixelResizing: allowPixelResizing, onCommentButtonMount: onCommentButtonMount, createCommentExperience: createCommentExperience } = options;
    let toolbarButtons = [];
    const { hoverDecoration: hoverDecoration } = (pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$d = pluginInjectionApi.decorations) === null || _pluginInjectionApi$d === void 0 ? void 0 : _pluginInjectionApi$d.actions) ?? {};
    const areAnyNewToolbarFlagsEnabled = (0, $8qHhy.areToolbarFlagsEnabled)(Boolean(pluginInjectionApi === null || pluginInjectionApi === void 0 ? void 0 : pluginInjectionApi.toolbar));
    const disableDownloadButton = (0, $7omWA.getIsDownloadDisabledByDataSecurityPolicy)(pluginState);
    const mauiToolbarSeparatorsUpdateEnabled = (0, $gdUUy.fg)('cc-maui-toolbar-separators-update-jira') && areAnyNewToolbarFlagsEnabled;
    if ((0, $54s68.shouldShowImageBorder)(state)) {
        toolbarButtons.push({
            type: 'custom',
            fallback: [],
            render: (editorView)=>{
                if (!editorView) return null;
                const { dispatch: dispatch, state: state } = editorView;
                const borderMark = (0, $i1rYO.currentMediaOrInlineNodeBorderMark)(state);
                return /*#__PURE__*/ (0, $dc70d.jsx)((0, $emGE2.default), {
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    toggleBorder: ()=>{
                        var _pluginInjectionApi$a;
                        (0, $jAHUG.toggleBorderMark)(pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$a = pluginInjectionApi.analytics) === null || _pluginInjectionApi$a === void 0 ? void 0 : _pluginInjectionApi$a.actions)(state, dispatch);
                    },
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    setBorder: (attrs)=>{
                        var _pluginInjectionApi$a2;
                        (0, $jAHUG.setBorderMark)(pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$a2 = pluginInjectionApi.analytics) === null || _pluginInjectionApi$a2 === void 0 ? void 0 : _pluginInjectionApi$a2.actions)(attrs)(state, dispatch);
                    },
                    borderMark: borderMark,
                    intl: intl
                });
            }
        });
        if (!areAnyNewToolbarFlagsEnabled) toolbarButtons.push({
            type: 'separator'
        });
    }
    if (allowAdvancedToolBarOptions) {
        var _pluginInjectionApi$a3;
        const widthPlugin = pluginInjectionApi === null || pluginInjectionApi === void 0 ? void 0 : pluginInjectionApi.width;
        let isChangingLayoutDisabled = false;
        const selectedNode = (0, $7omWA.getSelectedMediaSingle)(state);
        if (allowPixelResizing) {
            var _widthPlugin$sharedSt;
            const contentWidth = widthPlugin === null || widthPlugin === void 0 || (_widthPlugin$sharedSt = widthPlugin.sharedState.currentState()) === null || _widthPlugin$sharedSt === void 0 ? void 0 : _widthPlugin$sharedSt.lineLength;
            const selectedNodeMaxWidth = pluginState.currentMaxWidth || contentWidth;
            if (selectedNode && selectedNodeMaxWidth && selectedNode.node.attrs.width >= selectedNodeMaxWidth) isChangingLayoutDisabled = true;
        }
        const layoutButtons = (0, $gHATu.default)(state, intl, state.schema.nodes.mediaSingle, widthPlugin, pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$a3 = pluginInjectionApi.analytics) === null || _pluginInjectionApi$a3 === void 0 ? void 0 : _pluginInjectionApi$a3.actions, allowResizing, allowResizingInTables, true, true, isChangingLayoutDisabled, allowPixelResizing);
        const addLayoutDropdownToToolbar = ()=>{
            if (areAnyNewToolbarFlagsEnabled) {
                var _pluginInjectionApi$a4;
                const layoutDropdown = (0, $gHATu.buildLayoutDropdown)(state, intl, state.schema.nodes.mediaSingle, widthPlugin, pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$a4 = pluginInjectionApi.analytics) === null || _pluginInjectionApi$a4 === void 0 ? void 0 : _pluginInjectionApi$a4.actions, allowResizing, allowResizingInTables, true, true, isChangingLayoutDisabled, allowPixelResizing);
                toolbarButtons = [
                    ...toolbarButtons,
                    ...layoutDropdown
                ];
            } else {
                const selectedLayoutIcon = (0, $7omWA.getSelectedLayoutIcon)([
                    ...(0, $gHATu.alignmentIcons),
                    ...(0, $gHATu.wrappingIcons)
                ], // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                selectedNode.node);
                if (selectedLayoutIcon && layoutButtons.length) {
                    const options = {
                        render: (props)=>{
                            return /*#__PURE__*/ (0, $dc70d.jsx)((0, $j5PoU.LayoutGroup), {
                                layoutButtons: layoutButtons,
                                ...props,
                                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
                            });
                        },
                        width: 188,
                        height: 32
                    };
                    const trigger = {
                        id: 'media-single-layout',
                        testId: 'media-single-layout-dropdown-trigger',
                        type: 'dropdown',
                        options: options,
                        title: intl.formatMessage((0, $gHATu.layoutToMessages)[selectedLayoutIcon.value]),
                        icon: selectedLayoutIcon.icon
                    };
                    toolbarButtons = [
                        ...toolbarButtons,
                        trigger,
                        ...areAnyNewToolbarFlagsEnabled ? [] : [
                            {
                                type: 'separator'
                            }
                        ]
                    ];
                }
            }
        };
        if ((0, $jEFfF.mediaInlineImagesEnabled)(allowMediaInline, allowMediaInlineImages) && selectedNode) addLayoutDropdownToToolbar();
        else {
            toolbarButtons = [
                ...toolbarButtons,
                ...layoutButtons
            ];
            if (layoutButtons.length && !areAnyNewToolbarFlagsEnabled) toolbarButtons.push({
                type: 'separator'
            });
        }
        // floating and inline switcher
        if (pluginState.allowInlineImages && selectedNode && (0, $7omWA.canShowSwitchButtons)(selectedNode.node)) {
            var _selectedNode$node$fi;
            // mediaInlne doesn't suppprt external images, so hiding buttons to prevent conversion from mediaSingle to mediaInline
            if (((_selectedNode$node$fi = selectedNode.node.firstChild) === null || _selectedNode$node$fi === void 0 ? void 0 : _selectedNode$node$fi.attrs.type) !== 'external') {
                const hasCaption = (0, $gab48.contains)(selectedNode.node, state.schema.nodes.caption);
                const inlineSwitcherTitle = intl.formatMessage(hasCaption ? (0, $ahEv1.toolbarMessages).changeToMediaInlineImageCaptionWarning : (0, $ahEv1.toolbarMessages).changeToMediaInlineImage);
                const floatingSwitcherTitle = intl.formatMessage((0, $ahEv1.toolbarMessages).changeToMediaSingle);
                if (!areAnyNewToolbarFlagsEnabled) {
                    var _pluginInjectionApi$a5;
                    toolbarButtons.push({
                        type: 'button',
                        id: 'editor.media.image.view.switcher.inline',
                        title: inlineSwitcherTitle,
                        icon: ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g6z2B))), {
                                color: "currentColor",
                                spacing: "spacious",
                                label: inlineSwitcherTitle
                            }),
                        onClick: (0, $jAHUG.changeMediaSingleToMediaInline)(pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$a5 = pluginInjectionApi.analytics) === null || _pluginInjectionApi$a5 === void 0 ? void 0 : _pluginInjectionApi$a5.actions),
                        testId: 'image-inline-appearance',
                        selected: false
                    }, {
                        type: 'button',
                        id: 'editor.media.image.view.switcher.floating',
                        title: floatingSwitcherTitle,
                        icon: ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kGogQ))), {
                                color: "currentColor",
                                spacing: "spacious",
                                label: floatingSwitcherTitle
                            }),
                        onClick: ()=>{
                            return true;
                        },
                        testId: 'image-floating-appearance',
                        selected: true
                    }, {
                        type: 'separator'
                    });
                } else {
                    const switchFromBlockToInline = (0, $7omWA.getMediaSingleAndMediaInlineSwitcherDropdown)('block', intl, pluginInjectionApi, hasCaption);
                    toolbarButtons.push(switchFromBlockToInline, ...mauiToolbarSeparatorsUpdateEnabled ? [] : [
                        {
                            type: 'separator',
                            fullHeight: true
                        }
                    ]);
                }
            }
        }
        // A separator is needed regardless switcher is enabled or not
        if (Boolean(pluginInjectionApi === null || pluginInjectionApi === void 0 ? void 0 : pluginInjectionApi.toolbar) && !mauiToolbarSeparatorsUpdateEnabled) toolbarButtons.push({
            type: 'separator',
            fullHeight: true
        });
        // Pixel Entry Toolbar Support
        const { selection: selection } = state;
        const isWithinTable = (0, $gab48.hasParentNodeOfType)([
            state.schema.nodes.table
        ])(selection);
        if (allowResizing && (!isWithinTable || allowResizingInTables === true) && allowPixelResizing) {
            const selectedMediaSingleNode = (0, $7omWA.getSelectedMediaSingle)(state);
            const sizeInput = {
                type: 'custom',
                fallback: [],
                render: (editorView)=>{
                    if (!editorView || !selectedMediaSingleNode) return null;
                    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $b1AVF.PixelEntry), {
                        editorView: editorView,
                        intl: intl,
                        selectedMediaSingleNode: selectedMediaSingleNode,
                        pluginInjectionApi: pluginInjectionApi,
                        pluginState: pluginState,
                        hoverDecoration: hoverDecoration,
                        isEditorFullWidthEnabled: options.fullWidthEnabled
                    });
                }
            };
            if (pluginState.isResizing) {
                // If the image is resizing
                // then return pixel entry component or full width label as the only toolbar item
                if (!selectedMediaSingleNode) return [];
                const { layout: layout } = selectedMediaSingleNode.node.attrs;
                if (layout === 'full-width') {
                    const fullWidthLabel = {
                        type: 'custom',
                        fallback: [],
                        render: ()=>{
                            return /*#__PURE__*/ (0, $dc70d.jsx)((0, $b1AVF.FullWidthDisplay), {
                                intl: intl
                            });
                        }
                    };
                    return [
                        fullWidthLabel
                    ];
                }
                return [
                    sizeInput
                ];
            }
            if (!areAnyNewToolbarFlagsEnabled) {
                toolbarButtons.push(sizeInput);
                toolbarButtons.push({
                    type: 'separator'
                });
            }
        }
        if (!areAnyNewToolbarFlagsEnabled) {
            if (allowCommentsOnMedia) toolbarButtons.push((0, $3iiJ3.commentButton)(intl, state, pluginInjectionApi, onCommentButtonMount, createCommentExperience), {
                type: 'separator',
                supportsViewMode: true
            });
            if (allowLinking && (0, $ipOKx.shouldShowMediaLinkToolbar)(state)) toolbarButtons.push({
                type: 'custom',
                fallback: [],
                render: (editorView, idx)=>{
                    if (editorView !== null && editorView !== void 0 && editorView.state) {
                        const editLink = ()=>{
                            if (editorView) {
                                const { state: state, dispatch: dispatch } = editorView;
                                (0, $5cifv.showLinkingToolbar)(state, dispatch);
                            }
                        };
                        const openLink = ()=>{
                            if (editorView) {
                                var _pluginInjectionApi$a6;
                                const { state: { tr: tr }, dispatch: dispatch } = editorView;
                                pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$a6 = pluginInjectionApi.analytics) === null || _pluginInjectionApi$a6 === void 0 || _pluginInjectionApi$a6.actions.attachAnalyticsEvent({
                                    eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
                                    action: (0, $g6Qq4.ACTION).VISITED,
                                    actionSubject: (0, $g6Qq4.ACTION_SUBJECT).MEDIA,
                                    actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).LINK
                                })(tr);
                                dispatch(tr);
                                return true;
                            }
                        };
                        return /*#__PURE__*/ (0, $dc70d.jsx)((0, $fV1C5.LinkToolbarAppearance), {
                            editorState: editorView.state,
                            intl: intl,
                            mediaLinkingState: mediaLinkingState,
                            onAddLink: editLink,
                            onEditLink: editLink,
                            onOpenLink: openLink,
                            isViewOnly: isViewOnly,
                            areAnyNewToolbarFlagsEnabled: false
                        }, idx);
                    }
                    return null;
                },
                supportsViewMode: true
            });
            // Image Editing Support
            if (!!(pluginInjectionApi !== null && pluginInjectionApi !== void 0 && pluginInjectionApi.mediaEditing) && allowImageEditing && (0, $3y2s4.isExperimentEnabled)('platform_editor_add_image_editing')) {
                var _mediaNode$attrs, _mediaNode$attrs2, _mediaNode$attrs3;
                const selectedMediaSingleNode = (0, $7omWA.getSelectedMediaSingle)(state);
                const mediaNode = selectedMediaSingleNode === null || selectedMediaSingleNode === void 0 ? void 0 : selectedMediaSingleNode.node.content.firstChild;
                // Disable image editing for external media, as we cannot save changes to external images per CORS policy
                const isExternal = (mediaNode === null || mediaNode === void 0 || (_mediaNode$attrs = mediaNode.attrs) === null || _mediaNode$attrs === void 0 ? void 0 : _mediaNode$attrs.type) === 'external';
                // Disable image editing for gifs as CropperJS does not support gif editing
                const isGif = (mediaNode === null || mediaNode === void 0 || (_mediaNode$attrs2 = mediaNode.attrs) === null || _mediaNode$attrs2 === void 0 ? void 0 : _mediaNode$attrs2.__fileMimeType) === 'image/gif';
                if (!(0, $jmBd6.isVideo)(mediaNode === null || mediaNode === void 0 || (_mediaNode$attrs3 = mediaNode.attrs) === null || _mediaNode$attrs3 === void 0 ? void 0 : _mediaNode$attrs3.__fileMimeType) && !isExternal && !isGif) toolbarButtons.push({
                    id: 'editor.media.edit',
                    testId: 'image-edit-toolbar-button',
                    type: 'button',
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($e856D))),
                    title: intl.formatMessage((0, $fNLdd.default).imageEdit),
                    onClick: ()=>{
                        return $0824fa77277ac6f0$export$909b58dbf0af33b8({
                            api: pluginInjectionApi,
                            mediaPluginState: pluginState
                        }) ?? false;
                    },
                    // Making the button more accessible
                    supportsViewMode: false,
                    isRadioButton: true,
                    selected: false
                });
            }
            // Preview Support
            if (allowImagePreview) {
                var _mediaNode$attrs4;
                const selectedMediaSingleNode = (0, $7omWA.getSelectedMediaSingle)(state);
                const mediaNode = selectedMediaSingleNode === null || selectedMediaSingleNode === void 0 ? void 0 : selectedMediaSingleNode.node.content.firstChild;
                if (!(0, $jmBd6.isVideo)(mediaNode === null || mediaNode === void 0 || (_mediaNode$attrs4 = mediaNode.attrs) === null || _mediaNode$attrs4 === void 0 ? void 0 : _mediaNode$attrs4.__fileMimeType)) {
                    var _pluginInjectionApi$c2;
                    toolbarButtons.push({
                        id: 'editor.media.viewer',
                        testId: 'file-preview-toolbar-button',
                        type: 'button',
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($eNuIV))),
                        title: intl.formatMessage((0, $2HqML.messages).expand),
                        onClick: ()=>{
                            return $0824fa77277ac6f0$export$19271a18f1ddc766({
                                api: pluginInjectionApi,
                                mediaPluginState: pluginState
                            }) ?? false;
                        },
                        disabled: (0, $hVGJk.isOfflineMode)(pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$c2 = pluginInjectionApi.connectivity) === null || _pluginInjectionApi$c2 === void 0 || (_pluginInjectionApi$c2 = _pluginInjectionApi$c2.sharedState) === null || _pluginInjectionApi$c2 === void 0 || (_pluginInjectionApi$c2 = _pluginInjectionApi$c2.currentState()) === null || _pluginInjectionApi$c2 === void 0 ? void 0 : _pluginInjectionApi$c2.mode),
                        supportsViewMode: true
                    }, {
                        type: 'separator',
                        supportsViewMode: true
                    });
                }
            }
        }
    }
    if (isViewOnly) toolbarButtons.push({
        id: 'editor.media.image.download',
        type: 'button',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3iMZX))),
        onClick: ()=>{
            (0, $7omWA.downloadMedia)(pluginState, isViewOnly);
            return true;
        },
        disabled: disableDownloadButton,
        title: intl.formatMessage((0, $2HqML.messages).download),
        supportsViewMode: true
    }, ...mauiToolbarSeparatorsUpdateEnabled ? [] : [
        {
            type: 'separator',
            supportsViewMode: true
        }
    ]);
    if (!areAnyNewToolbarFlagsEnabled) {
        var _pluginInjectionApi$a8;
        if (allowAltTextOnImages) {
            var _pluginInjectionApi$a7;
            toolbarButtons.push((0, $gHqj4.altTextButton)(intl, state, pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$a7 = pluginInjectionApi.analytics) === null || _pluginInjectionApi$a7 === void 0 ? void 0 : _pluginInjectionApi$a7.actions), {
                type: 'separator'
            });
        }
        const removeButton = {
            id: 'editor.media.delete',
            type: 'button',
            appearance: 'danger',
            focusEditoronEnter: true,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($gV64P))),
            onMouseEnter: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(mediaSingle, true),
            onMouseLeave: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(mediaSingle, false),
            onFocus: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(mediaSingle, true),
            onBlur: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(mediaSingle, false),
            title: intl.formatMessage((0, $fNLdd.default).remove),
            onClick: $0824fa77277ac6f0$var$removeWithAnalytics(pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$a8 = pluginInjectionApi.analytics) === null || _pluginInjectionApi$a8 === void 0 ? void 0 : _pluginInjectionApi$a8.actions),
            testId: 'media-toolbar-remove-button',
            supportsViewMode: false
        };
        const items = [
            ...toolbarButtons,
            {
                type: 'copy-button',
                items: [
                    {
                        state: state,
                        formatMessage: intl.formatMessage,
                        nodeType: mediaSingle
                    }
                ],
                supportsViewMode: true
            }
        ];
        items.push({
            type: 'separator',
            supportsViewMode: false
        });
        items.push(removeButton);
        return items;
    } else {
        // Preview Support
        if (allowAdvancedToolBarOptions && allowImagePreview) {
            var _mediaNode$attrs5;
            const selectedMediaSingleNode = (0, $7omWA.getSelectedMediaSingle)(state);
            const mediaNode = selectedMediaSingleNode === null || selectedMediaSingleNode === void 0 ? void 0 : selectedMediaSingleNode.node.content.firstChild;
            if (!(0, $jmBd6.isVideo)(mediaNode === null || mediaNode === void 0 || (_mediaNode$attrs5 = mediaNode.attrs) === null || _mediaNode$attrs5 === void 0 ? void 0 : _mediaNode$attrs5.__fileMimeType)) {
                var _pluginInjectionApi$c3;
                toolbarButtons.push({
                    id: 'editor.media.viewer',
                    testId: 'file-preview-toolbar-button',
                    type: 'button',
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($j7FKK))),
                    title: intl.formatMessage((0, $2HqML.messages).expand),
                    onClick: ()=>{
                        return $0824fa77277ac6f0$export$19271a18f1ddc766({
                            api: pluginInjectionApi,
                            mediaPluginState: pluginState
                        }) ?? false;
                    },
                    disabled: (0, $hVGJk.isOfflineMode)(pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$c3 = pluginInjectionApi.connectivity) === null || _pluginInjectionApi$c3 === void 0 || (_pluginInjectionApi$c3 = _pluginInjectionApi$c3.sharedState) === null || _pluginInjectionApi$c3 === void 0 || (_pluginInjectionApi$c3 = _pluginInjectionApi$c3.currentState()) === null || _pluginInjectionApi$c3 === void 0 ? void 0 : _pluginInjectionApi$c3.mode),
                    supportsViewMode: true
                }, ...mauiToolbarSeparatorsUpdateEnabled ? [] : [
                    {
                        type: 'separator',
                        supportsViewMode: true
                    }
                ]);
            }
        }
        if (allowAdvancedToolBarOptions && allowImageEditing && (0, $3y2s4.isExperimentEnabled)('platform_editor_add_image_editing')) {
            var _mediaNode$attrs6, _mediaNode$attrs7, _mediaNode$attrs8;
            const selectedMediaSingleNode = (0, $7omWA.getSelectedMediaSingle)(state);
            const mediaNode = selectedMediaSingleNode === null || selectedMediaSingleNode === void 0 ? void 0 : selectedMediaSingleNode.node.content.firstChild;
            // Disable image editing for external media, as we cannot save changes to external images per CORS policy
            const isExternal = (mediaNode === null || mediaNode === void 0 || (_mediaNode$attrs6 = mediaNode.attrs) === null || _mediaNode$attrs6 === void 0 ? void 0 : _mediaNode$attrs6.type) === 'external';
            // Disable image editing for gifs as CropperJS does not support gif editing
            const isGif = (mediaNode === null || mediaNode === void 0 || (_mediaNode$attrs7 = mediaNode.attrs) === null || _mediaNode$attrs7 === void 0 ? void 0 : _mediaNode$attrs7.__fileMimeType) === 'image/gif';
            if (!(0, $jmBd6.isVideo)(mediaNode === null || mediaNode === void 0 || (_mediaNode$attrs8 = mediaNode.attrs) === null || _mediaNode$attrs8 === void 0 ? void 0 : _mediaNode$attrs8.__fileMimeType) && !isExternal && !isGif) toolbarButtons.push({
                id: 'editor.media.edit',
                testId: 'image-edit-toolbar-button',
                type: 'button',
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($e856D))),
                title: intl.formatMessage((0, $fNLdd.default).imageEdit),
                onClick: ()=>{
                    return $0824fa77277ac6f0$export$909b58dbf0af33b8({
                        api: pluginInjectionApi,
                        mediaPluginState: pluginState
                    }) ?? false;
                },
                supportsViewMode: false
            }, ...mauiToolbarSeparatorsUpdateEnabled ? [] : [
                {
                    type: 'separator',
                    supportsViewMode: false
                }
            ]);
        }
        // open link
        if (allowLinking && (0, $ipOKx.shouldShowMediaLinkToolbar)(state) && mediaLinkingState && mediaLinkingState.editable) toolbarButtons.push((0, $ipOKx.getOpenLinkToolbarButtonOption)(intl, mediaLinkingState, pluginInjectionApi), ...mauiToolbarSeparatorsUpdateEnabled ? [] : [
            {
                type: 'separator',
                supportsViewMode: true
            }
        ]);
        isViewOnly && toolbarButtons.push({
            type: 'copy-button',
            items: [
                {
                    state: state,
                    formatMessage: intl.formatMessage,
                    nodeType: mediaSingle
                }
            ],
            supportsViewMode: true
        }, ...mauiToolbarSeparatorsUpdateEnabled ? [] : [
            {
                type: 'separator',
                supportsViewMode: true
            }
        ]);
        if (allowAdvancedToolBarOptions && allowCommentsOnMedia) {
            if (!mauiToolbarSeparatorsUpdateEnabled) (0, $7omWA.updateToFullHeightSeparator)(toolbarButtons);
            toolbarButtons.push((0, $3iiJ3.commentButton)(intl, state, pluginInjectionApi, onCommentButtonMount, createCommentExperience));
        }
        return toolbarButtons;
    }
};
const $0824fa77277ac6f0$var$getMediaTypeMessage = (selectedNodeTypeSingle)=>{
    const mediaType = Object.keys($0824fa77277ac6f0$var$mediaTypeMessages).find((key)=>selectedNodeTypeSingle === null || selectedNodeTypeSingle === void 0 ? void 0 : selectedNodeTypeSingle.includes(key));
    return mediaType ? $0824fa77277ac6f0$var$mediaTypeMessages[mediaType] : (0, $2HqML.messages).file_unknown_is_selected;
};
const $0824fa77277ac6f0$export$893b800ba7bfda6d = 'media-overflow-dropdown-trigger';
const $0824fa77277ac6f0$var$isMediaSelection = (selection, nodeType)=>{
    if (selection instanceof (0, $cw0wu.NodeSelection)) return nodeType.includes(selection.node.type);
    return false;
};
const $0824fa77277ac6f0$export$4850df084251d287 = (state, intl, options = {}, pluginInjectionApi)=>{
    var _pluginInjectionApi$d2;
    const { media: media, mediaInline: mediaInline, mediaSingle: mediaSingle, mediaGroup: mediaGroup } = state.schema.nodes;
    const { altTextValidator: altTextValidator, allowLinking: allowLinking, allowAltTextOnImages: allowAltTextOnImages, providerFactory: providerFactory, allowResizing: allowResizing, isViewOnly: isViewOnly, allowResizingInTables: allowResizingInTables, allowAdvancedToolBarOptions: allowAdvancedToolBarOptions, allowPixelResizing: allowPixelResizing } = options;
    const { allowMediaInline: allowMediaInline } = options;
    const mediaPluginState = (0, $7ICJC.stateKey).getState(state);
    const mediaLinkingState = (0, $ki6Uz.getMediaLinkingState)(state);
    const { hoverDecoration: hoverDecoration } = (pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$d2 = pluginInjectionApi.decorations) === null || _pluginInjectionApi$d2 === void 0 ? void 0 : _pluginInjectionApi$d2.actions) ?? {};
    if (!mediaPluginState) return;
    const nodeType = allowMediaInline ? [
        mediaInline,
        mediaSingle,
        media
    ] : [
        mediaSingle
    ];
    const isSelectedNodeMediaSingle = state.selection instanceof (0, $cw0wu.NodeSelection) && state.selection.node.type === mediaSingle;
    if (!$0824fa77277ac6f0$var$isMediaSelection(state.selection, nodeType)) return;
    const baseToolbar = {
        title: 'Media floating controls',
        nodeType: nodeType,
        getDomRef: ()=>{
            var _mediaPluginState$ele;
            const element = isSelectedNodeMediaSingle ? ((_mediaPluginState$ele = mediaPluginState.element) === null || _mediaPluginState$ele === void 0 ? void 0 : _mediaPluginState$ele.querySelector(`.${(0, $e35II.MediaSingleNodeSelector)}`)) || mediaPluginState.element : mediaPluginState.element;
            return element;
        }
    };
    if (allowLinking && mediaLinkingState && mediaLinkingState.visible && (0, $ipOKx.shouldShowMediaLinkToolbar)(state)) {
        const linkingToolbar = (0, $ipOKx.getLinkingToolbar)(baseToolbar, mediaLinkingState, state, intl, pluginInjectionApi, providerFactory);
        if (linkingToolbar) return linkingToolbar;
    }
    // testId is required to show focus on trigger button on ESC key press
    // see hideOnEsc in platform/packages/editor/editor-plugin-floating-toolbar/src/ui/Dropdown.tsx
    const overflowButtonSelector = (0, $8qHhy.areToolbarFlagsEnabled)(Boolean(pluginInjectionApi === null || pluginInjectionApi === void 0 ? void 0 : pluginInjectionApi.toolbar)) ? `[data-testid="${$0824fa77277ac6f0$export$893b800ba7bfda6d}"]` : undefined;
    if (allowAltTextOnImages) {
        const mediaAltTextPluginState = (0, $dnBXh.getPluginState)(state);
        if (mediaAltTextPluginState.isAltTextEditorOpen) {
            var _pluginInjectionApi$f;
            return (0, $gHqj4.getAltTextToolbar)(baseToolbar, {
                altTextValidator: altTextValidator,
                forceFocusSelector: pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$f = pluginInjectionApi.floatingToolbar) === null || _pluginInjectionApi$f === void 0 || (_pluginInjectionApi$f = _pluginInjectionApi$f.actions) === null || _pluginInjectionApi$f === void 0 ? void 0 : _pluginInjectionApi$f.forceFocusSelector,
                triggerButtonSelector: overflowButtonSelector,
                areAnyNewToolbarFlagsEnabled: (0, $8qHhy.areToolbarFlagsEnabled)(Boolean(pluginInjectionApi === null || pluginInjectionApi === void 0 ? void 0 : pluginInjectionApi.toolbar))
            });
        }
    }
    const { selection: selection } = state;
    const isWithinTable = (0, $gab48.hasParentNodeOfType)([
        state.schema.nodes.table
    ])(selection);
    if (allowAdvancedToolBarOptions && allowResizing && (!isWithinTable || allowResizingInTables === true) && allowPixelResizing && (0, $8qHhy.areToolbarFlagsEnabled)(Boolean(pluginInjectionApi === null || pluginInjectionApi === void 0 ? void 0 : pluginInjectionApi.toolbar))) {
        const mediaPixelResizingPluginState = (0, $9iI02.getPluginState)(state);
        if (mediaPixelResizingPluginState !== null && mediaPixelResizingPluginState !== void 0 && mediaPixelResizingPluginState.isPixelEditorOpen) return (0, $hX4GT.getPixelResizingToolbar)(baseToolbar, {
            intl: intl,
            pluginInjectionApi: pluginInjectionApi,
            pluginState: mediaPluginState,
            hoverDecoration: hoverDecoration,
            isEditorFullWidthEnabled: options.fullWidthEnabled,
            triggerButtonSelector: overflowButtonSelector
        });
    }
    let items = [];
    const parentMediaGroupNode = (0, $gab48.findParentNodeOfType)(mediaGroup)(state.selection);
    let selectedNodeType;
    if (state.selection instanceof (0, $cw0wu.NodeSelection)) selectedNodeType = state.selection.node.type;
    if (allowMediaInline && (parentMediaGroupNode === null || parentMediaGroupNode === void 0 ? void 0 : parentMediaGroupNode.node.type) === mediaGroup) {
        var _pluginInjectionApi$a9, _pluginInjectionApi$f2;
        const mediaOffset = state.selection.$from.parentOffset + 1;
        baseToolbar.getDomRef = ()=>{
            var _mediaPluginState$ele2;
            const selector = (0, $kwptA.mediaFilmstripItemDOMSelector)(mediaOffset);
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            return (_mediaPluginState$ele2 = mediaPluginState.element) === null || _mediaPluginState$ele2 === void 0 ? void 0 : _mediaPluginState$ele2.querySelector(selector);
        };
        items = $0824fa77277ac6f0$var$generateMediaCardFloatingToolbar(state, intl, mediaPluginState, hoverDecoration, pluginInjectionApi, pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$a9 = pluginInjectionApi.analytics) === null || _pluginInjectionApi$a9 === void 0 ? void 0 : _pluginInjectionApi$a9.actions, pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$f2 = pluginInjectionApi.floatingToolbar) === null || _pluginInjectionApi$f2 === void 0 || (_pluginInjectionApi$f2 = _pluginInjectionApi$f2.actions) === null || _pluginInjectionApi$f2 === void 0 ? void 0 : _pluginInjectionApi$f2.forceFocusSelector, isViewOnly);
    } else if (allowMediaInline && selectedNodeType && selectedNodeType === mediaInline) items = (0, $5tgEy.generateMediaInlineFloatingToolbar)(state, intl, mediaPluginState, hoverDecoration, pluginInjectionApi, options);
    else {
        baseToolbar.getDomRef = ()=>{
            var _mediaPluginState$ele3;
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            const element = (_mediaPluginState$ele3 = mediaPluginState.element) === null || _mediaPluginState$ele3 === void 0 ? void 0 : _mediaPluginState$ele3.querySelector(`.${(0, $e35II.MediaSingleNodeSelector)}`);
            return element || mediaPluginState.element;
        };
        items = $0824fa77277ac6f0$var$generateMediaSingleFloatingToolbar(state, intl, options, mediaPluginState, mediaLinkingState, pluginInjectionApi);
    }
    if (!mediaPluginState.isResizing && (0, $8qHhy.areToolbarFlagsEnabled)(Boolean(pluginInjectionApi === null || pluginInjectionApi === void 0 ? void 0 : pluginInjectionApi.toolbar))) {
        var _pluginInjectionApi$a0, _pluginInjectionApi$a1, _pluginInjectionApi$a10;
        if (!(0, $gdUUy.fg)('cc-maui-toolbar-separators-update-jira')) (0, $7omWA.updateToFullHeightSeparator)(items);
        const showReplaceOption = !isViewOnly && mediaPluginState.allowsUploads && (0, $3y2s4.isExperimentEnabled)('platform_editor_inline_media_replacement') && selectedNodeType === mediaSingle;
        const customOptions = [
            ...(0, $ipOKx.getLinkingDropdownOptions)(state, intl, mediaLinkingState, allowMediaInline && selectedNodeType && selectedNodeType === mediaInline, allowLinking, isViewOnly),
            ...(0, $gHqj4.getAltTextDropdownOption)(state, intl.formatMessage, allowAltTextOnImages, selectedNodeType, pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$a0 = pluginInjectionApi.analytics) === null || _pluginInjectionApi$a0 === void 0 ? void 0 : _pluginInjectionApi$a0.actions),
            ...(0, $hX4GT.getResizeDropdownOption)(options, state, intl.formatMessage, selectedNodeType)
        ];
        if (customOptions.length) customOptions.push({
            type: 'separator'
        });
        const hoverDecorationProps = (nodeType, className)=>({
                onMouseEnter: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(nodeType, true, className),
                onMouseLeave: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(nodeType, false, className),
                onFocus: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(nodeType, true, className),
                onBlur: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(nodeType, false, className)
            });
        items.push({
            type: 'overflow-dropdown',
            id: 'media',
            testId: $0824fa77277ac6f0$export$893b800ba7bfda6d,
            options: [
                ...customOptions,
                ...showReplaceOption ? [
                    {
                        title: intl.formatMessage((0, $ahEv1.toolbarMessages).replaceMedia),
                        onClick: ()=>{
                            mediaPluginState.showMediaPickerForReplace();
                            return true;
                        },
                        icon: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4rvUe))), {
                            label: ""
                        }),
                        testId: 'media-replace-toolbar-button'
                    }
                ] : [],
                {
                    title: intl === null || intl === void 0 ? void 0 : intl.formatMessage((0, $fNLdd.default).copyToClipboard),
                    onClick: ()=>{
                        var _pluginInjectionApi$c4, _pluginInjectionApi$f3;
                        pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$c4 = pluginInjectionApi.core) === null || _pluginInjectionApi$c4 === void 0 || _pluginInjectionApi$c4.actions.execute(pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$f3 = pluginInjectionApi.floatingToolbar) === null || _pluginInjectionApi$f3 === void 0 ? void 0 : _pluginInjectionApi$f3.commands.copyNode(nodeType, (0, $g6Qq4.INPUT_METHOD).FLOATING_TB));
                        return true;
                    },
                    icon: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c81bI))), {
                        label: ""
                    }),
                    ...hoverDecorationProps(nodeType, (0, $5bbjm.akEditorSelectedNodeClassName))
                },
                {
                    title: intl === null || intl === void 0 ? void 0 : intl.formatMessage((0, $fNLdd.default).delete),
                    onClick: (parentMediaGroupNode === null || parentMediaGroupNode === void 0 ? void 0 : parentMediaGroupNode.node.type) === mediaGroup ? $0824fa77277ac6f0$var$handleRemoveMediaGroupWithAnalytics(pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$a1 = pluginInjectionApi.analytics) === null || _pluginInjectionApi$a1 === void 0 ? void 0 : _pluginInjectionApi$a1.actions) : $0824fa77277ac6f0$var$removeWithAnalytics(pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$a10 = pluginInjectionApi.analytics) === null || _pluginInjectionApi$a10 === void 0 ? void 0 : _pluginInjectionApi$a10.actions, selectedNodeType),
                    icon: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gV64P))), {
                        label: ""
                    }),
                    ...hoverDecorationProps(nodeType)
                }
            ]
        });
    }
    // Ignored via go/ees005
    // eslint-disable-next-line no-var
    var assistiveMessage = '';
    const selectedMediaSingleNode = (0, $7omWA.getSelectedMediaSingle)(state);
    if (selectedMediaSingleNode) {
        const selectedMediaNodeView = selectedMediaSingleNode === null || selectedMediaSingleNode === void 0 ? void 0 : selectedMediaSingleNode.node.content;
        if (selectedMediaNodeView) {
            const selectedMediaNode = selectedMediaNodeView.firstChild;
            const selectedNodeTypeSingle = selectedMediaNode === null || selectedMediaNode === void 0 ? void 0 : selectedMediaNode.attrs.__fileMimeType;
            const selectedMediaAlt = selectedMediaNode === null || selectedMediaNode === void 0 ? void 0 : selectedMediaNode.attrs.alt;
            assistiveMessage = intl === null || intl === void 0 ? void 0 : intl.formatMessage($0824fa77277ac6f0$var$getMediaTypeMessage(selectedNodeTypeSingle), {
                name: selectedMediaAlt
            });
        }
    }
    const toolbarConfig = {
        ...baseToolbar,
        items: items,
        scrollable: true,
        mediaAssistiveMessage: assistiveMessage
    };
    if (allowResizing && allowPixelResizing) return {
        ...toolbarConfig,
        width: mediaPluginState.isResizing ? undefined : (0, $7omWA.getMaxToolbarWidth)()
    };
    return toolbarConfig;
};

});
parcelRegister("e856D", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5286fafd8f6a87b10cb903a063c98eb2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a495c603b037e286$var$_react = $a495c603b037e286$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $a495c603b037e286$var$_iconNew = $a495c603b037e286$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $a495c603b037e286$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ImageCrop".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/image-crop
 * Usage guidance:
 * Reserved for cropping images
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a495c603b037e286$var$ImageCropIcon = (props)=>/*#__PURE__*/ $a495c603b037e286$var$_react.default.createElement($a495c603b037e286$var$_iconNew.default, Object.assign({
        name: "ImageCropIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 3V0h1.5v3H11a2 2 0 0 1 2 2v6.5h3V13h-3v3h-1.5V5a.5.5 0 0 0-.5-.5H0V3zm0 8V6h1.5v5a.5.5 0 0 0 .5.5h5V13H5a2 2 0 0 1-2-2" clip-rule="evenodd"/>`
    }, props));
$a495c603b037e286$var$ImageCropIcon.displayName = 'ImageCropIcon';
var $a495c603b037e286$var$_default = module.exports.default = $a495c603b037e286$var$ImageCropIcon;

});

parcelRegister("kwptA", function(module, exports) {
$parcel$export(module.exports, "mediaFilmstripItemDOMSelector", () => $078fcfc1d347a12d$export$ddc30058b32b7b60);

var $fzoUl = parcelRequire("fzoUl");
const $078fcfc1d347a12d$export$ddc30058b32b7b60 = (offset)=>{
    return `.${0, $fzoUl.MediaFilmStripListItemSelector}:nth-child(${offset})`;
};

});

parcelRegister("b1AVF", function(module, exports) {
$parcel$export(module.exports, "PixelEntry", () => $5b557c4161dd2c75$export$4c9bbfa83ba6e1fa);
$parcel$export(module.exports, "FullWidthDisplay", () => $5b557c4161dd2c75$export$8bde7db5b2aba7d);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $2WuR4 = parcelRequire("2WuR4");

var $29qUP = parcelRequire("29qUP");

var $82LN8 = parcelRequire("82LN8");

var $8qHhy = parcelRequire("8qHhy");

var $cw0wu = parcelRequire("cw0wu");

var $gab48 = parcelRequire("gab48");

var $5bbjm = parcelRequire("5bbjm");

var $8aT4G = parcelRequire("8aT4G");

var $jAHUG = parcelRequire("jAHUG");

var $7omWA = parcelRequire("7omWA");

var $jmBd6 = parcelRequire("jmBd6");

var $lzc7g = parcelRequire("lzc7g");

var $jAfaL = parcelRequire("jAfaL");

var $iaMRR = parcelRequire("iaMRR");
const $5b557c4161dd2c75$export$4c9bbfa83ba6e1fa = ({ editorView: editorView, selectedMediaSingleNode: selectedMediaSingleNode, pluginInjectionApi: pluginInjectionApi, intl: intl, pluginState: pluginState, hoverDecoration: hoverDecoration, isEditorFullWidthEnabled: isEditorFullWidthEnabled, triggerButtonSelector: triggerButtonSelector })=>{
    var _pluginInjectionApi$w, _pluginInjectionApi$m, _pluginInjectionApi$f;
    const { state: state, dispatch: dispatch } = editorView;
    const { mediaSingle: mediaSingle } = state.schema.nodes;
    const contentWidth = (pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$w = pluginInjectionApi.width.sharedState.currentState()) === null || _pluginInjectionApi$w === void 0 ? void 0 : _pluginInjectionApi$w.lineLength) || (0, $5bbjm.akEditorDefaultLayoutWidth);
    const { width: mediaSingleWidth, widthType: widthType, layout: layout } = selectedMediaSingleNode.node.attrs;
    // hasParentNode will return falsey value if selection depth === 0
    const isNested = (0, $gab48.hasParentNode)((n)=>n.type !== state.schema.nodes.doc)(state.selection);
    const updateNodeWithTr = (0, $bSJIT.useCallback)((width, validation)=>{
        var _pluginInjectionApi$a;
        const newLayout = (0, $7omWA.calcNewLayout)(width, layout, contentWidth, isEditorFullWidthEnabled, isNested);
        return (0, $jAHUG.updateMediaSingleWidthTr)(pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$a = pluginInjectionApi.analytics) === null || _pluginInjectionApi$a === void 0 ? void 0 : _pluginInjectionApi$a.actions, state, width, validation, 'floatingToolBar', newLayout);
    }, [
        layout,
        contentWidth,
        isEditorFullWidthEnabled,
        isNested,
        state,
        pluginInjectionApi
    ]);
    const selectedMediaNode = selectedMediaSingleNode.node.content.firstChild;
    if (!selectedMediaNode) return null;
    const { width: mediaWidth, height: mediaHeight } = selectedMediaNode.attrs;
    const maxWidthForNestedNode = pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$m = pluginInjectionApi.media) === null || _pluginInjectionApi$m === void 0 || (_pluginInjectionApi$m = _pluginInjectionApi$m.sharedState.currentState()) === null || _pluginInjectionApi$m === void 0 ? void 0 : _pluginInjectionApi$m.currentMaxWidth;
    const maxWidth = maxWidthForNestedNode || (0, $5bbjm.akEditorFullWidthLayoutWidth);
    const isVideoFile = (0, $jmBd6.isVideo)(selectedMediaNode.attrs.__fileMimeType);
    const minWidth = (0, $2WuR4.calcMinWidth)(isVideoFile, maxWidthForNestedNode || contentWidth);
    const hasPixelType = widthType === 'pixel';
    const pixelWidthFromElement = (0, $7omWA.getPixelWidthOfElement)(editorView, selectedMediaSingleNode.pos + 1, // get pos of media node
    mediaWidth || (0, $29qUP.DEFAULT_IMAGE_WIDTH));
    const pixelWidth = hasPixelType ? mediaSingleWidth : pixelWidthFromElement;
    const forceFocusSelector = pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$f = pluginInjectionApi.floatingToolbar) === null || _pluginInjectionApi$f === void 0 || (_pluginInjectionApi$f = _pluginInjectionApi$f.actions) === null || _pluginInjectionApi$f === void 0 ? void 0 : _pluginInjectionApi$f.forceFocusSelector;
    const areAnyNewToolbarFlagsEnabled = (0, $8qHhy.areToolbarFlagsEnabled)(Boolean(pluginInjectionApi === null || pluginInjectionApi === void 0 ? void 0 : pluginInjectionApi.toolbar));
    return /*#__PURE__*/ (0, $9dQre.jsx)((0, $jAfaL.PixelEntryComponent), {
        intl: intl,
        width: pluginState.isResizing ? pluginState.resizingWidth : pixelWidth,
        showMigration: !pluginState.isResizing && !hasPixelType,
        mediaWidth: mediaWidth || (0, $29qUP.DEFAULT_IMAGE_WIDTH),
        mediaHeight: mediaHeight || (0, $29qUP.DEFAULT_IMAGE_HEIGHT),
        minWidth: minWidth,
        maxWidth: maxWidth,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onChange: (valid)=>{
            if (valid) hoverDecoration === null || hoverDecoration === void 0 || hoverDecoration(mediaSingle, true, 'warning')(editorView.state, dispatch, editorView);
            else hoverDecoration === null || hoverDecoration === void 0 || hoverDecoration(mediaSingle, false)(editorView.state, dispatch, editorView);
        },
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onSubmit: ({ width: width, validation: validation })=>{
            const tr = updateNodeWithTr(width, validation);
            if (tr) dispatch(tr);
        },
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onMigrate: ()=>{
            let tr = state.tr.setNodeMarkup(selectedMediaSingleNode.pos, undefined, {
                ...selectedMediaSingleNode.node.attrs,
                width: pixelWidthFromElement,
                widthType: 'pixel'
            });
            tr.setMeta('scrollIntoView', false);
            tr.setSelection((0, $cw0wu.NodeSelection).create(tr.doc, selectedMediaSingleNode.pos));
            if (triggerButtonSelector) {
                const newTr = forceFocusSelector && forceFocusSelector(triggerButtonSelector)(tr);
                tr = newTr !== undefined ? newTr : tr;
            }
            dispatch(tr);
        },
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onCloseAndSave: ({ width: width, validation: validation }, setFocus)=>{
            let tr = updateNodeWithTr(width, validation);
            if (setFocus && triggerButtonSelector) {
                const newTr = forceFocusSelector && tr && forceFocusSelector(triggerButtonSelector)(tr);
                tr = newTr !== undefined ? newTr : tr;
            }
            if (tr) return (0, $lzc7g.closePixelEditorAndSave)(()=>tr)(state, dispatch);
        },
        isViewMode: pluginState.isResizing,
        triggerButtonSelector: triggerButtonSelector,
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    });
};
const $5b557c4161dd2c75$export$8bde7db5b2aba7d = ({ intl: { formatMessage: formatMessage } })=>{
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        css: (0, $iaMRR.pixelSizingFullWidthLabelStyles)
    }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $8aT4G.Text), null, formatMessage((0, $82LN8.pixelEntryMessages).fullWidthLabel))));
};

});
parcelRegister("2WuR4", function(module, exports) {
$parcel$export(module.exports, "calcMinWidth", () => $fe41ab2dc16254dc$export$c7eaa4d46a45395);

var $29qUP = parcelRequire("29qUP");
const $fe41ab2dc16254dc$export$c7eaa4d46a45395 = (isVideoFile, contentWidth)=>{
    return Math.min(contentWidth, isVideoFile ? (0, $29qUP.MEDIA_SINGLE_VIDEO_MIN_PIXEL_WIDTH) : (0, $29qUP.MEDIA_SINGLE_DEFAULT_MIN_PIXEL_WIDTH));
};

});

parcelRegister("82LN8", function(module, exports) {
$parcel$export(module.exports, "pixelEntryMessages", () => $e651e15dda68f058$export$41750bfa58c03af2);

var $f0Pt4 = parcelRequire("f0Pt4");
const $e651e15dda68f058$export$41750bfa58c03af2 = (0, $f0Pt4.defineMessages)({
    validationFailedMessage: {
        id: 'fabric.editor.media.pixelEntry.validationFailedMessage',
        defaultMessage: 'Validation for width failed',
        description: 'The passed in validator function returned false'
    },
    inputWidthTooltip: {
        id: 'fabric.editor.media.pixelEntry.inputWidthTooltip',
        defaultMessage: 'Max width {maxWidth}px',
        description: 'The tooltip displayed ontop of the width input'
    },
    inputWidthAriaLabel: {
        id: 'fabric.editor.media.pixelEntry.inputWidthAriaLabel',
        defaultMessage: 'Max width {maxWidth}px',
        description: 'Aria label for the width input field used for media pixel entry. The placeholder {maxWidth} will be substituted with the maximum allowed width value in pixels.'
    },
    inputWidthLabel: {
        id: 'fabric.editor.media.pixelEntry.inputWidthLabel',
        defaultMessage: 'Width',
        description: 'Label for the width input field in the media resize panel. Users enter a numeric value representing the desired width in pixels for the image.'
    },
    inputHeightTooltip: {
        id: 'fabric.editor.media.pixelEntry.inputHeightTooltip',
        defaultMessage: 'Height',
        description: 'The tooltip displayed ontop of the height input'
    },
    inputHeightAriaLabel: {
        id: 'fabric.editor.media.pixelEntry.inputHeightAriaLabel',
        defaultMessage: 'height input',
        description: 'Aria label for the height input field used for media pixel entry to inform screen readers about the purpose of the input.'
    },
    submitButtonText: {
        id: 'fabric.editor.media.pixelEntry.submitButtonText',
        defaultMessage: 'Submit',
        description: 'The text give to the hidden submit button'
    },
    fullWidthLabel: {
        id: 'fabric.editor.image.fullWidthLabel',
        defaultMessage: 'Full-width',
        description: 'Label shown in the media pixel entry toolbar when the image is at its maximum width, indicating the image is in full-width display mode.'
    },
    migrationButtonText: {
        id: 'fabric.editor.media.pixelEntry.migrationButtonText',
        defaultMessage: 'Convert to pixels',
        description: 'The text give to the button used to covert to pixels for legacy experience'
    },
    migrationButtonTooltip: {
        id: 'fabric.editor.media.pixelEntry.migrationButtonTooltip',
        defaultMessage: 'Migrate from percentage to fixed pixel sizing',
        description: 'The tooltip displayed on the migration button'
    },
    closePixelEntry: {
        id: 'fabric.editor.media.pixelEntry.closePixelEntry',
        defaultMessage: 'Close',
        description: 'The text give to the close button used to close the pixel inputs and go back to main toolbar'
    },
    resizeOption: {
        id: 'fabric.editor.media.pixelEntry.ResizeOption',
        defaultMessage: 'Resize',
        description: 'The text give to the resize option in the overflow dropdown for images'
    }
});

});

parcelRegister("lzc7g", function(module, exports) {
$parcel$export(module.exports, "openPixelEditor", () => $149ceb687a7db957$export$3f611b75d530f269);
$parcel$export(module.exports, "closePixelEditorAndSave", () => $149ceb687a7db957$export$b46ccfbc4dc863e);

var $9iI02 = parcelRequire("9iI02");
const $149ceb687a7db957$export$3f611b75d530f269 = ()=>{
    return (0, $9iI02.createCommand)({
        type: 'openPixelEditor'
    });
};
const $149ceb687a7db957$export$6113a2660dc189b8 = ()=>{
    return (0, $9iI02.createCommand)({
        type: 'closePixelEditor'
    });
};
const $149ceb687a7db957$export$b46ccfbc4dc863e = (saveTransform)=>{
    return (0, $9iI02.createCommand)({
        type: 'closePixelEditor'
    }, saveTransform);
};

});

parcelRegister("jAfaL", function(module, exports) {
$parcel$export(module.exports, "PixelEntryComponent", () => $05d09c8191b84049$export$87ba3d82a3f32422);
/* eslint-disable jsdoc/check-tag-names */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $hzFIQ = parcelRequire("hzFIQ");

var $4TRbS = parcelRequire("4TRbS");

var $82LN8 = parcelRequire("82LN8");

var $cvNPo = parcelRequire("cvNPo");

var $fbRS9 = parcelRequire("fbRS9");

var $9dYEz = parcelRequire("9dYEz");

var $gUpf2 = parcelRequire("gUpf2");

var $2IITT = parcelRequire("2IITT");

var $aRsbV = parcelRequire("aRsbV");

var $9BVpB = parcelRequire("9BVpB");

var $jgsO4 = parcelRequire("jgsO4");

var $lavtv = parcelRequire("lavtv");

var $cz0Kt = parcelRequire("cz0Kt");

var $iaMRR = parcelRequire("iaMRR");
function $05d09c8191b84049$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $05d09c8191b84049$var$pixelSizingLabel = (0, $9BVpB.xcss)({
    gridArea: 'label',
    lineHeight: "var(--ds-space-300, 24px)"
});
const $05d09c8191b84049$export$87ba3d82a3f32422 = ({ width: width, mediaWidth: mediaWidth, mediaHeight: mediaHeight, onSubmit: onSubmit, minWidth: minWidth, maxWidth: maxWidth, onChange: onChange, intl: { formatMessage: formatMessage }, showMigration: showMigration, onMigrate: onMigrate, onCloseAndSave: onCloseAndSave, isViewMode: isViewMode, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled })=>{
    const ratioWidth = (0, $bSJIT.useMemo)(()=>{
        return mediaHeight / mediaWidth;
    }, [
        mediaHeight,
        mediaWidth
    ]);
    const ratioHeight = (0, $bSJIT.useMemo)(()=>{
        return mediaWidth / mediaHeight;
    }, [
        mediaHeight,
        mediaWidth
    ]);
    const [computedWidth, setComputedWidth] = (0, $bSJIT.useState)(width);
    const [computedHeight, setComputedHeight] = (0, $bSJIT.useState)(Math.round(ratioWidth * width));
    // Handle update to width from outside component
    (0, $bSJIT.useEffect)(()=>{
        setComputedWidth(width);
        setComputedHeight(Math.round(ratioWidth * width));
    }, [
        width,
        ratioWidth
    ]);
    // Handle submit when user presses enter in form
    const handleOnSubmit = (data)=>{
        if (data.inputWidth === '' || data.inputHeight === '') return;
        if (onSubmit) {
            let widthToBeSumitted = data.inputWidth;
            let validation = 'valid';
            if (data.inputWidth < minWidth) {
                widthToBeSumitted = minWidth;
                validation = 'less-than-min';
            }
            if (data.inputWidth > maxWidth) {
                widthToBeSumitted = maxWidth;
                validation = 'greater-than-max';
            }
            // If user keeps submitting an invalid input, node width attribute will be updated with the same value
            // and won't upadte the state in useEffect (since width is the same)
            // Thus, we set the state here to always display the correct dimension
            if (validation !== 'valid') {
                setComputedWidth(widthToBeSumitted);
                setComputedHeight(Math.round(ratioWidth * widthToBeSumitted));
            }
            onSubmit({
                width: widthToBeSumitted,
                validation: validation
            });
        }
    };
    // Handle submit when user presses enter or click close button in PixelEntryComponentNext
    const handleCloseAndSave = (0, $bSJIT.useCallback)((data, setFocus)=>{
        if (data.inputWidth === '' || data.inputHeight === '') return;
        if (onCloseAndSave) {
            let widthToBeSubmitted = data.inputWidth;
            let validation = 'valid';
            if (data.inputWidth < minWidth) {
                widthToBeSubmitted = minWidth;
                validation = 'less-than-min';
            }
            if (data.inputWidth > maxWidth) {
                widthToBeSubmitted = maxWidth;
                validation = 'greater-than-max';
            }
            // If user keeps submitting an invalid input, node width attribute will be updated with the same value
            // and won't upadte the state in useEffect (since width is the same)
            // Thus, we set the state here to always display the correct dimension
            if (validation !== 'valid') {
                setComputedWidth(widthToBeSubmitted);
                setComputedHeight(Math.round(ratioWidth * widthToBeSubmitted));
            }
            onCloseAndSave({
                width: widthToBeSubmitted,
                validation: validation
            }, setFocus);
        }
    }, [
        maxWidth,
        minWidth,
        onCloseAndSave,
        ratioWidth
    ]);
    // Handle updating computed fields based on
    const handleOnChange = (0, $bSJIT.useCallback)((type)=>(event)=>{
            const value = parseInt(event.currentTarget.value);
            const newInputValue = isNaN(value) ? '' : value;
            let newWidth = '';
            switch(type){
                case 'inputWidth':
                    {
                        newWidth = newInputValue;
                        setComputedWidth(newInputValue);
                        const newHeight = newInputValue !== '' ? Math.round(ratioWidth * newInputValue) : '';
                        setComputedHeight(newHeight);
                        break;
                    }
                case 'inputHeight':
                    setComputedHeight(newInputValue);
                    newWidth = newInputValue !== '' ? Math.round(ratioHeight * newInputValue) : '';
                    setComputedWidth(newWidth);
                    break;
            }
            const isInvalidInputValid = newWidth !== '' && (newWidth < minWidth || newWidth > maxWidth);
            onChange && onChange(isInvalidInputValid);
        }, [
        minWidth,
        maxWidth,
        onChange,
        ratioWidth,
        ratioHeight
    ]);
    if (showMigration) return /*#__PURE__*/ (0, $9dQre.jsx)((0, $lavtv.default), {
        content: formatMessage((0, $82LN8.pixelEntryMessages).migrationButtonTooltip)
    }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $hzFIQ.default), {
        appearance: "warning",
        spacing: "compact",
        onClick: onMigrate,
        testId: (0, $cz0Kt.PIXELENTRY_MIGRATION_BUTTON_TESTID)
    }, formatMessage((0, $82LN8.pixelEntryMessages).migrationButtonText)));
    if (areAnyNewToolbarFlagsEnabled) return /*#__PURE__*/ (0, $9dQre.jsx)($05d09c8191b84049$export$94fe217aa650da08, {
        maxWidth: maxWidth,
        formatMessage: formatMessage,
        handleFieldChange: handleOnChange,
        computedWidth: computedWidth,
        computedHeight: computedHeight,
        handleCloseAndSave: handleCloseAndSave,
        isViewMode: isViewMode
    });
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        css: (0, $iaMRR.pixelEntryForm)
    }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $fbRS9.default), {
        onSubmit: handleOnSubmit
    }, ({ formProps: formProps })=>{
        return(// Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        /*#__PURE__*/ (0, $9dQre.jsx)("form", formProps, /*#__PURE__*/ (0, $9dQre.jsx)("div", {
            css: (0, $iaMRR.pixelSizingWrapper)
        }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $cvNPo.default), {
            key: "inputWidth",
            name: "inputWidth",
            defaultValue: computedWidth
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $9dQre.jsx)((0, $lavtv.default), {
                hideTooltipOnMouseDown: true,
                content: formatMessage((0, $82LN8.pixelEntryMessages).inputWidthTooltip, {
                    maxWidth: maxWidth
                }),
                position: "top"
            }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $jgsO4.default), {
                ...fieldProps,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/no-unsafe-style-overrides, @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                css: [
                    (0, $iaMRR.pixelSizingWidthInput),
                    (0, $iaMRR.pixelSizingInput)
                ],
                appearance: "none",
                isCompact: true,
                onChange: handleOnChange('inputWidth'),
                pattern: "\\d*",
                "aria-label": formatMessage((0, $82LN8.pixelEntryMessages).inputWidthAriaLabel, {
                    maxWidth: maxWidth
                })
            }))), /*#__PURE__*/ (0, $9dQre.jsx)((0, $gUpf2.Box), {
            as: "span",
            xcss: $05d09c8191b84049$var$pixelSizingLabel
        }, "\xd7"), /*#__PURE__*/ (0, $9dQre.jsx)((0, $cvNPo.default), {
            key: "inputHeight",
            name: "inputHeight",
            defaultValue: computedHeight
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $9dQre.jsx)((0, $lavtv.default), {
                hideTooltipOnMouseDown: true,
                content: formatMessage((0, $82LN8.pixelEntryMessages).inputHeightTooltip),
                position: "top"
            }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $jgsO4.default), {
                ...fieldProps,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/no-unsafe-style-overrides, @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                css: [
                    (0, $iaMRR.pixelSizingHeightInput),
                    (0, $iaMRR.pixelSizingInput)
                ],
                appearance: "none",
                isCompact: true,
                onChange: handleOnChange('inputHeight'),
                pattern: "\\d*",
                "aria-label": formatMessage((0, $82LN8.pixelEntryMessages).inputHeightAriaLabel)
            }))), /*#__PURE__*/ (0, $9dQre.jsx)((0, $hzFIQ.default), {
            css: (0, $iaMRR.pixelEntryHiddenSubmit),
            type: "submit"
        }, formatMessage((0, $82LN8.pixelEntryMessages).submitButtonText)))));
    })));
};
const $05d09c8191b84049$var$pixelEntryWrapperStyles = (0, $9BVpB.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    width: `${(0, $cz0Kt.PIXEL_RESIZING_TOOLBAR_WIDTH)}px`
});
const $05d09c8191b84049$var$pixelEntryWrapperViewModeStyles = (0, $9BVpB.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    width: `${(0, $cz0Kt.PIXEL_VIEW_MODE_TOOLBAR_WIDTH)}px`
});
const $05d09c8191b84049$var$fieldStyles = {
    name: "1we2h56",
    styles: "[data-ds--text-field--input]{padding-block:var(--ds-space-0, 0px);padding-inline:var(--ds-space-100, 8px);}flex:1"
};
const $05d09c8191b84049$var$dividerStyles = (0, $9BVpB.xcss)({
    width: '1px',
    height: "var(--ds-space-500, 40px)",
    background: "var(--ds-border, #0B120E24)",
    marginInlineEnd: 'space.050'
});
const $05d09c8191b84049$export$94fe217aa650da08 = ({ maxWidth: maxWidth, formatMessage: formatMessage, handleFieldChange: handleFieldChange, computedWidth: computedWidth, computedHeight: computedHeight, handleCloseAndSave: handleCloseAndSave, isViewMode: isViewMode })=>{
    const widthInputRef = (0, $bSJIT.useRef)(null);
    (0, $bSJIT.useEffect)(()=>{
        if (widthInputRef.current) {
            if (isViewMode) widthInputRef.current.blur();
            else widthInputRef.current.focus();
        }
    }, [
        isViewMode,
        widthInputRef
    ]);
    const handleKeyDown = (0, $bSJIT.useCallback)((event)=>{
        if (event.key === 'Enter') {
            const shouldSetFocus = true;
            handleCloseAndSave({
                inputWidth: computedWidth,
                inputHeight: computedHeight
            }, shouldSetFocus);
        }
    }, [
        computedWidth,
        computedHeight,
        handleCloseAndSave
    ]);
    const handleCloseButtonKeyDown = (0, $bSJIT.useCallback)((event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            const shouldSetFocus = true;
            handleCloseAndSave({
                inputWidth: computedWidth,
                inputHeight: computedHeight
            }, shouldSetFocus);
        }
    }, [
        computedWidth,
        computedHeight,
        handleCloseAndSave
    ]);
    return(// eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
    /*#__PURE__*/ (0, $9dQre.jsx)((0, $gUpf2.Box), {
        xcss: [
            $05d09c8191b84049$var$pixelEntryWrapperStyles,
            isViewMode && $05d09c8191b84049$var$pixelEntryWrapperViewModeStyles
        ]
    }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $2IITT.Inline), {
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $gUpf2.Box), {
        paddingInlineStart: "space.100"
    }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $aRsbV.Text), {
        color: "color.text.subtlest"
    }, formatMessage((0, $82LN8.pixelEntryMessages).inputWidthLabel))), /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        css: $05d09c8191b84049$var$fieldStyles
    }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $lavtv.default), {
        hideTooltipOnMouseDown: true,
        hideTooltipOnClick: true,
        position: "top",
        content: formatMessage((0, $82LN8.pixelEntryMessages).inputWidthTooltip, {
            maxWidth: maxWidth
        })
    }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $jgsO4.default), {
        name: "inputWidth",
        value: computedWidth,
        ref: widthInputRef,
        height: "var(--ds-space-250, 20px)",
        appearance: "none",
        pattern: "\\d*",
        "aria-label": formatMessage((0, $82LN8.pixelEntryMessages).inputWidthAriaLabel, {
            maxWidth: maxWidth
        }),
        onChange: handleFieldChange('inputWidth'),
        onKeyDown: handleKeyDown
    }))), /*#__PURE__*/ (0, $9dQre.jsx)((0, $gUpf2.Box), {
        paddingInlineStart: "space.100"
    }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $aRsbV.Text), {
        color: "color.text.subtlest"
    }, formatMessage((0, $82LN8.pixelEntryMessages).inputHeightTooltip))), /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        css: $05d09c8191b84049$var$fieldStyles
    }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $lavtv.default), {
        hideTooltipOnMouseDown: true,
        hideTooltipOnClick: true,
        content: formatMessage((0, $82LN8.pixelEntryMessages).inputHeightTooltip),
        position: "top"
    }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $jgsO4.default), {
        name: "inputHeight",
        value: computedHeight,
        height: "var(--ds-space-250, 20px)",
        appearance: "none",
        pattern: "\\d*",
        "aria-label": formatMessage((0, $82LN8.pixelEntryMessages).inputHeightAriaLabel),
        onChange: handleFieldChange('inputHeight'),
        onKeyDown: handleKeyDown
    }))), !isViewMode && /*#__PURE__*/ (0, $9dQre.jsx)((0, $bSJIT.Fragment), null, /*#__PURE__*/ (0, $9dQre.jsx)((0, $gUpf2.Box), {
        xcss: $05d09c8191b84049$var$dividerStyles
    }), /*#__PURE__*/ (0, $9dQre.jsx)((0, $4TRbS.default), {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        icon: ()=>/*#__PURE__*/ (0, $9dQre.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9dYEz))), {
                label: "",
                color: "var(--ds-icon-subtlest, #6B6E76)"
            }),
        label: formatMessage((0, $82LN8.pixelEntryMessages).closePixelEntry),
        appearance: "subtle",
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onClick: ()=>{
            handleCloseAndSave({
                inputWidth: computedWidth,
                inputHeight: computedHeight
            });
        },
        onKeyDown: handleCloseButtonKeyDown
    })))));
};

});
parcelRegister("cz0Kt", function(module, exports) {
$parcel$export(module.exports, "PIXELENTRY_MIGRATION_BUTTON_TESTID", () => $3edd7794f772be83$export$92acff719f79f188);
$parcel$export(module.exports, "PIXEL_RESIZING_TOOLBAR_WIDTH", () => $3edd7794f772be83$export$e879bf3f9286d0ca);
$parcel$export(module.exports, "PIXEL_VIEW_MODE_TOOLBAR_WIDTH", () => $3edd7794f772be83$export$82086c41f042e8aa);
const $3edd7794f772be83$export$92acff719f79f188 = 'pixel-entry-convert-pixels-btn';
const $3edd7794f772be83$export$e879bf3f9286d0ca = 240;
const $3edd7794f772be83$export$82086c41f042e8aa = 204;

});

parcelRegister("iaMRR", function(module, exports) {
$parcel$export(module.exports, "pixelSizingWrapper", () => $9d920e9e7824d599$export$7adff2da6cbda45a);
$parcel$export(module.exports, "pixelEntryForm", () => $9d920e9e7824d599$export$a087928e226af252);
$parcel$export(module.exports, "pixelSizingInput", () => $9d920e9e7824d599$export$8eb4fadc3d78e5b8);
$parcel$export(module.exports, "pixelSizingWidthInput", () => $9d920e9e7824d599$export$24de6e5e0b062da4);
$parcel$export(module.exports, "pixelSizingHeightInput", () => $9d920e9e7824d599$export$239e009fce8340c);
$parcel$export(module.exports, "pixelEntryHiddenSubmit", () => $9d920e9e7824d599$export$2eb599df69546ffe);
$parcel$export(module.exports, "pixelSizingFullWidthLabelStyles", () => $9d920e9e7824d599$export$e7603c3ecd81d479);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9dQre = parcelRequire("9dQre");
function $9d920e9e7824d599$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9d920e9e7824d599$var$PIXEL_SIZING_WRAPPER_MINIMUM_WIDTH = 120;
const $9d920e9e7824d599$export$7adff2da6cbda45a = /*#__PURE__*/ (0, $9dQre.css)("display:grid;grid-template-columns:1fr 1em 1fr 0;grid-template-rows:auto;grid-template-areas:'widthinput label heightinput submit';width:", $9d920e9e7824d599$var$PIXEL_SIZING_WRAPPER_MINIMUM_WIDTH, "px;text-align:center;height:var(--ds-space-300, 24px);&>*{margin-top:0!important;}");
const $9d920e9e7824d599$export$a087928e226af252 = {
    name: "jf7je1",
    styles: "form{width:100%;}"
};
const $9d920e9e7824d599$export$8eb4fadc3d78e5b8 = {
    name: "kleeuo",
    styles: "width:100%;height:var(--ds-space-300, 24px);& input{text-align:center;}"
};
const $9d920e9e7824d599$export$24de6e5e0b062da4 = {
    name: "6o3mvm",
    styles: "grid-area:widthinput"
};
const $9d920e9e7824d599$export$239e009fce8340c = {
    name: "10wktdx",
    styles: "grid-area:heightinput"
};
const $9d920e9e7824d599$export$2eb599df69546ffe = {
    name: "1555zxw",
    styles: "grid-area:submit;visibility:hidden;width:0;height:0;padding:0"
};
const $9d920e9e7824d599$export$e7603c3ecd81d479 = /*#__PURE__*/ (0, $9dQre.css)({
    minWidth: `${$9d920e9e7824d599$var$PIXEL_SIZING_WRAPPER_MINIMUM_WIDTH}px`,
    height: "var(--ds-space-300, 24px)",
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
});

});



parcelRegister("emGE2", function(module, exports) {
$parcel$export(module.exports, "default", () => $cf9077b733ea9853$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $bs8QL = parcelRequire("bs8QL");

var $5zk80 = parcelRequire("5zk80");

var $iw14B = parcelRequire("iw14B");

var $5CXZA = parcelRequire("5CXZA");

var $6efeV = parcelRequire("6efeV");

var $epqkL = parcelRequire("epqkL");

var $5chfg = parcelRequire("5chfg");

var $imBU3 = parcelRequire("imBU3");

var $fWCaV = parcelRequire("fWCaV");

var $8zO6u = parcelRequire("8zO6u");

var $1eX8N = parcelRequire("1eX8N");

var $4jS0J = parcelRequire("4jS0J");

var $4GWyU = parcelRequire("4GWyU");

var $8Mmfj = parcelRequire("8Mmfj");

var $cUD3Z = parcelRequire("cUD3Z");

var $5Mni1 = parcelRequire("5Mni1");

var $gdUUy = parcelRequire("gdUUy");

var $8aT4G = parcelRequire("8aT4G");

var $5N1Y4 = parcelRequire("5N1Y4");

var $lavtv = parcelRequire("lavtv");

var $7N6Do = parcelRequire("7N6Do");
function $cf9077b733ea9853$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// New padding for border options drop down
const $cf9077b733ea9853$var$dropdownOptionButtonNew = {
    name: "9wwuwq",
    styles: "background:transparent;border-width:var(--ds-border-width-selected, 2px);border-style:solid;border-color:transparent;display:flex;width:100%;align-items:center;justify-content:space-between;padding:0;&:focus{background-color:var(--ds-background-neutral-subtle-hovered, #0515240F);border-color:var(--ds-border-focused, #4688EC);}"
};
const $cf9077b733ea9853$var$ImageBorder = ({ intl: { formatMessage: formatMessage }, toggleBorder: toggleBorder, borderMark: borderMark, setBorder: setBorder })=>{
    const popupTarget = (0, $bSJIT.useRef)(null);
    const dropDownColorOptionButton = (0, $bSJIT.useRef)(null);
    const dropDownSizeOptionButton = (0, $bSJIT.useRef)(null);
    const colorSubmenuRef = (0, $bSJIT.useRef)(null);
    const sizeSubmenuRef = (0, $bSJIT.useRef)(null);
    const openDropdownButtonRef = (0, $bSJIT.useRef)(null);
    const enabled = !!borderMark;
    const color = borderMark === null || borderMark === void 0 ? void 0 : borderMark.color;
    const size = borderMark === null || borderMark === void 0 ? void 0 : borderMark.size;
    const [isOpen, setIsOpen] = (0, $bSJIT.useState)(false);
    const [isOpenByKeyboard, setIsOpenedByKeyboard] = (0, $bSJIT.useState)(false);
    const [isColorSubmenuOpen, setIsColorSubmenuOpen] = (0, $bSJIT.useState)(false);
    const [isSizeSubmenuOpen, setIsSizeSubmenuOpen] = (0, $bSJIT.useState)(false);
    const handleColorSubmenuEsc = (0, $bSJIT.useCallback)(()=>{
        var _dropDownColorOptionB;
        setIsOpenedByKeyboard(false);
        setIsColorSubmenuOpen(false);
        dropDownColorOptionButton === null || dropDownColorOptionButton === void 0 || (_dropDownColorOptionB = dropDownColorOptionButton.current) === null || _dropDownColorOptionB === void 0 || _dropDownColorOptionB.focus();
    }, []);
    const handleSizeSubmenuEsc = (0, $bSJIT.useCallback)(()=>{
        var _dropDownSizeOptionBu;
        setIsOpenedByKeyboard(false);
        setIsSizeSubmenuOpen(false);
        dropDownSizeOptionButton === null || dropDownSizeOptionButton === void 0 || (_dropDownSizeOptionBu = dropDownSizeOptionButton.current) === null || _dropDownSizeOptionBu === void 0 || _dropDownSizeOptionBu.focus();
    }, []);
    const handleSubMenuRef = (ref)=>{
        if (!ref) return;
        const rect = ref.getBoundingClientRect();
        if (rect.left + rect.width > window.innerWidth) ref.style.left = `-${rect.width}px`;
    };
    const handleTriggerByKeyboard = (event, allowedKeys, callback)=>{
        if (!allowedKeys.includes(event.key)) return;
        event.preventDefault();
        callback();
        setIsOpenedByKeyboard(true);
    };
    const handleTriggerToolbarByKeyboard = (event, callback)=>{
        handleTriggerByKeyboard(event, [
            'Enter',
            ' '
        ], callback);
    };
    const handleTriggerSubmenuByKeyboard = (event, callback)=>{
        const keys = (0, $5N1Y4.expValEquals)('platform_editor_toolbar_submenu_open_click', 'isEnabled', true) ? [
            'Enter',
            'ArrowRight'
        ] : [
            'Enter',
            ' '
        ];
        handleTriggerByKeyboard(event, keys, callback);
    };
    (0, $bSJIT.useEffect)(()=>{
        const focusFirstOption = (submenuRef, isOpen)=>{
            if (!isOpenByKeyboard) return;
            if (isOpen && submenuRef.current) {
                const firstOption = submenuRef.current.querySelector('button');
                if (!firstOption) return;
                firstOption.focus();
                const keyboardEvent = new KeyboardEvent('keydown', {
                    key: 'ArrowDown',
                    bubbles: true
                });
                firstOption.dispatchEvent(keyboardEvent);
            }
        };
        focusFirstOption(colorSubmenuRef, isColorSubmenuOpen);
        focusFirstOption(sizeSubmenuRef, isSizeSubmenuOpen);
    }, [
        isColorSubmenuOpen,
        isSizeSubmenuOpen,
        isOpenByKeyboard
    ]);
    const borderSizeOptions = [
        {
            name: formatMessage((0, $bs8QL.imageBorderMessages).borderSizeSubtle),
            value: 1,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($5Mni1)))
        },
        {
            name: formatMessage((0, $bs8QL.imageBorderMessages).borderSizeMedium),
            value: 2,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($cUD3Z)))
        },
        {
            name: formatMessage((0, $bs8QL.imageBorderMessages).borderSizeBold),
            value: 3,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($8Mmfj)))
        }
    ];
    const items = [
        {
            content: /*#__PURE__*/ (0, $9dQre.jsx)("div", null, /*#__PURE__*/ (0, $9dQre.jsx)("button", {
                ref: dropDownColorOptionButton,
                type: "button",
                "aria-label": formatMessage((0, $bs8QL.imageBorderMessages).borderColorDropdownAriaLabel),
                "data-testid": "image-border-dropdown-button-color",
                css: (0, $5N1Y4.expValEquals)('platform_editor_fix_media_toolbar_border_dropdown', 'isEnabled', true, false) ? $cf9077b733ea9853$var$dropdownOptionButtonNew : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                (0, $7N6Do.dropdownOptionButton),
                "aria-expanded": isColorSubmenuOpen,
                onKeyDown: (e)=>handleTriggerSubmenuByKeyboard(e, ()=>{
                        if ((0, $5N1Y4.expValEquals)('platform_editor_toolbar_submenu_open_click', 'isEnabled', true)) setIsColorSubmenuOpen((prev)=>{
                            const next = !prev;
                            if (next) setIsSizeSubmenuOpen(false);
                            return next;
                        });
                        else setIsColorSubmenuOpen(!isColorSubmenuOpen);
                    })
            }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $8aT4G.Text), null, formatMessage((0, $bs8QL.imageBorderMessages).borderColor)), /*#__PURE__*/ (0, $9dQre.jsx)("div", {
                css: (0, $7N6Do.contextualMenuArrow)
            })), /*#__PURE__*/ (0, $9dQre.jsx)("div", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: (0, $iw14B.DropdownMenuSharedCssClassName).SUBMENU,
                ref: colorSubmenuRef
            }, isColorSubmenuOpen && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, $9dQre.jsx)("div", {
                css: (0, $7N6Do.contextualSubMenu)(0),
                ref: handleSubMenuRef
            }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $5chfg.ArrowKeyNavigationProvider), {
                type: (0, $imBU3.ArrowKeyNavigationType).MENU,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                handleClose: (e)=>{
                    e.preventDefault();
                    e.stopPropagation();
                    handleColorSubmenuEsc();
                },
                disableCloseOnArrowClick: true
            }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $5CXZA.default), {
                ariaLabel: (0, $gdUUy.fg)('platform_editor_a11y_border_radiogroup_label') ? formatMessage((0, $bs8QL.imageBorderMessages).borderColorRadioGroupAriaLabel) : undefined,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                onClick: (color)=>{
                    setBorder({
                        color: color
                    });
                    setIsOpen(!isOpen);
                },
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                onKeyDown: (color, _, event)=>{
                    if (event.key === 'Enter' || event.key === ' ') {
                        var _openDropdownButtonRe;
                        setBorder({
                            color: color
                        });
                        setIsOpen(!isOpen);
                        setIsColorSubmenuOpen(false);
                        setIsSizeSubmenuOpen(false);
                        (_openDropdownButtonRe = openDropdownButtonRef.current) === null || _openDropdownButtonRe === void 0 || _openDropdownButtonRe.focus();
                    }
                },
                selectedColor: color ?? null,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                paletteOptions: {
                    palette: (0, $6efeV.default),
                    paletteColorTooltipMessages: (0, $epqkL.borderPaletteTooltipMessages),
                    hexToPaletteColor: (0, $1eX8N.hexToEditorBorderPaletteColor)
                }
            }))))),
            'data-testid': 'dropdown-item__Color',
            key: 'dropdown-menu-image-border-color-button',
            value: {
                name: 'color'
            },
            'aria-label': '',
            wrapperTabIndex: null
        },
        {
            content: /*#__PURE__*/ (0, $9dQre.jsx)("div", null, /*#__PURE__*/ (0, $9dQre.jsx)("button", {
                type: "button",
                "aria-label": formatMessage((0, $bs8QL.imageBorderMessages).borderSizeDropdownAriaLabel),
                "data-testid": "image-border-dropdown-button-size",
                css: (0, $5N1Y4.expValEquals)('platform_editor_fix_media_toolbar_border_dropdown', 'isEnabled', true, false) ? $cf9077b733ea9853$var$dropdownOptionButtonNew : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                (0, $7N6Do.dropdownOptionButton),
                "aria-expanded": isSizeSubmenuOpen,
                ref: dropDownSizeOptionButton,
                onKeyDown: (e)=>handleTriggerSubmenuByKeyboard(e, ()=>{
                        if ((0, $5N1Y4.expValEquals)('platform_editor_toolbar_submenu_open_click', 'isEnabled', true)) setIsSizeSubmenuOpen((prev)=>{
                            const next = !prev;
                            if (next) setIsColorSubmenuOpen(false);
                            return next;
                        });
                        else setIsSizeSubmenuOpen(!isSizeSubmenuOpen);
                    })
            }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $8aT4G.Text), null, formatMessage((0, $bs8QL.imageBorderMessages).borderSize)), /*#__PURE__*/ (0, $9dQre.jsx)("div", {
                css: (0, $7N6Do.contextualMenuArrow)
            })), /*#__PURE__*/ (0, $9dQre.jsx)("div", {
                //eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                className: (0, $iw14B.DropdownMenuSharedCssClassName).SUBMENU,
                ref: sizeSubmenuRef
            }, isSizeSubmenuOpen && /*#__PURE__*/ (0, $9dQre.jsx)((0, $5chfg.ArrowKeyNavigationProvider), {
                type: (0, $imBU3.ArrowKeyNavigationType).MENU,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                handleClose: (e)=>{
                    e.preventDefault();
                    handleSizeSubmenuEsc();
                },
                disableCloseOnArrowClick: true
            }, /*#__PURE__*/ (0, $9dQre.jsx)("div", {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                css: (0, $7N6Do.contextualSubMenu)(1),
                ref: handleSubMenuRef,
                role: (0, $gdUUy.fg)('platform_editor_a11y_border_radiogroup_label') ? 'radiogroup' : undefined,
                "aria-label": (0, $gdUUy.fg)('platform_editor_a11y_border_radiogroup_label') ? formatMessage((0, $bs8QL.imageBorderMessages).borderSizeRadioGroupAriaLabel) : undefined
            }, borderSizeOptions.map(({ name: name, value: value, icon: icon }, idx)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const ButtonIcon = icon;
                return(// Ignored via go/ees005
                // eslint-disable-next-line react/no-array-index-key
                /*#__PURE__*/ (0, $9dQre.jsx)((0, $lavtv.default), {
                    key: idx,
                    content: name
                }, /*#__PURE__*/ (0, $9dQre.jsx)("span", {
                    css: (0, $7N6Do.buttonWrapperStyle)
                }, /*#__PURE__*/ (0, $9dQre.jsx)("button", {
                    type: "button",
                    /* eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766 */ css: (0, $7N6Do.buttonStyle)(value === size),
                    "aria-label": name,
                    role: "radio",
                    "aria-checked": value === size,
                    onClick: ()=>{
                        setBorder({
                            size: value
                        });
                        setIsOpen(false);
                    },
                    onKeyDown: (event)=>{
                        if (event.key === 'Enter' || event.key === ' ') {
                            var _openDropdownButtonRe2;
                            setBorder({
                                size: value
                            });
                            setIsOpen(false);
                            setIsColorSubmenuOpen(false);
                            setIsSizeSubmenuOpen(false);
                            (_openDropdownButtonRe2 = openDropdownButtonRef.current) === null || _openDropdownButtonRe2 === void 0 || _openDropdownButtonRe2.focus();
                        }
                    },
                    onMouseDown: (e)=>{
                        e.preventDefault();
                    }
                }, /*#__PURE__*/ (0, $9dQre.jsx)(ButtonIcon, {
                    color: value === size ? "var(--ds-icon-inverse, #FFFFFF)" : 'currentColor',
                    spacing: "spacious",
                    label: ""
                })))));
            }))))),
            'data-testid': 'dropdown-item__Size',
            key: 'dropdown-menu-image-border-size-button',
            value: {
                name: 'size'
            },
            'aria-label': '',
            wrapperTabIndex: null
        }
    ];
    /**
   * We want to change direction of our dropdowns a bit early,
   * not exactly when it hits the boundary.
   */ const fitTolerance = 10;
    const fitWidth = (0, $7N6Do.menuItemDimensions).width;
    const fitHeight = items.length * ((0, $7N6Do.menuItemDimensions).height + (0, $7N6Do.itemSpacing));
    const isAnySubMenuOpen = isSizeSubmenuOpen || isColorSubmenuOpen;
    return /*#__PURE__*/ (0, $9dQre.jsx)("div", null, /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: (0, $7N6Do.toolbarButtonWrapper)({
            enabled: enabled,
            isOpen: isOpen
        })
    }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $8zO6u.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "image-border-toolbar-btn",
        selected: enabled,
        onClick: toggleBorder,
        spacing: "compact",
        "aria-label": enabled ? formatMessage((0, $bs8QL.imageBorderMessages).removeBorder) : formatMessage((0, $bs8QL.imageBorderMessages).addBorder),
        iconBefore: /*#__PURE__*/ (0, $9dQre.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4jS0J))), {
            color: "currentColor",
            label: "",
            spacing: "spacious"
        }),
        title: enabled ? formatMessage((0, $bs8QL.imageBorderMessages).removeBorder) : formatMessage((0, $bs8QL.imageBorderMessages).addBorder)
    }), /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        ref: popupTarget
    }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $8zO6u.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "image-border-toolbar-dropdown",
        ref: openDropdownButtonRef,
        selected: enabled || isOpen,
        "aria-expanded": isOpen,
        "aria-label": formatMessage((0, $bs8QL.imageBorderMessages).borderOptions),
        title: formatMessage((0, $bs8QL.imageBorderMessages).borderOptions),
        spacing: "compact",
        iconBefore: /*#__PURE__*/ (0, $9dQre.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4GWyU))), {
            color: "currentColor",
            spacing: "spacious",
            label: "",
            size: "small"
        }),
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onClick: ()=>{
            setIsOpen(!isOpen);
            setIsOpenedByKeyboard(false);
        },
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onKeyDown: (e)=>handleTriggerToolbarByKeyboard(e, ()=>setIsOpen(!isOpen))
    }))), /*#__PURE__*/ (0, $9dQre.jsx)((0, $5zk80.default), {
        target: popupTarget.current ? popupTarget.current : undefined,
        fitWidth: fitWidth + fitTolerance,
        fitHeight: fitHeight + fitTolerance,
        forcePlacement: true,
        stick: true
    }, /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        onMouseLeave: (0, $5N1Y4.expValEquals)('platform_editor_toolbar_submenu_open_click', 'isEnabled', true) ? undefined : ()=>{
            setIsColorSubmenuOpen(false);
            setIsSizeSubmenuOpen(false);
        },
        /* eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766 */ css: (0, $7N6Do.dropdownWrapper)
    }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $fWCaV.default), {
        //This needs be removed when the a11y is completely handled
        //Disabling key navigation now as it works only partially
        //Same with packages/editor/editor-plugin-table/src/plugins/table/ui/FloatingContextualMenu/ContextualMenu.tsx
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        arrowKeyNavigationProviderOptions: {
            type: (0, $imBU3.ArrowKeyNavigationType).MENU,
            disableArrowKeyNavigation: isAnySubMenuOpen
        },
        allowEnterDefaultBehavior: isAnySubMenuOpen,
        handleEscapeKeydown: isAnySubMenuOpen ? ()=>{
            return;
        } : ()=>{
            var _openDropdownButtonRe3;
            (_openDropdownButtonRe3 = openDropdownButtonRef.current) === null || _openDropdownButtonRe3 === void 0 || _openDropdownButtonRe3.focus();
        },
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        items: [
            {
                items: items
            }
        ],
        isOpen: isOpen,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        shouldFocusFirstItem: ()=>isOpenByKeyboard,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onOpenChange: ()=>{
            setIsOpen(false);
            setIsColorSubmenuOpen(false);
            setIsSizeSubmenuOpen(false);
            setIsOpenedByKeyboard(false);
        },
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onItemActivated: ({ item: item })=>{
            if (item.value.name === 'color') {
                if ((0, $5N1Y4.expValEquals)('platform_editor_toolbar_submenu_open_click', 'isEnabled', true)) setIsColorSubmenuOpen((prev)=>{
                    const next = !prev;
                    if (next) setIsSizeSubmenuOpen(false);
                    return next;
                });
                else setIsColorSubmenuOpen(!isColorSubmenuOpen);
            }
            if (item.value.name === 'size') {
                if ((0, $5N1Y4.expValEquals)('platform_editor_toolbar_submenu_open_click', 'isEnabled', true)) setIsSizeSubmenuOpen((prev)=>{
                    const next = !prev;
                    if (next) setIsColorSubmenuOpen(false);
                    return next;
                });
                else setIsSizeSubmenuOpen(!isSizeSubmenuOpen);
            }
        },
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onMouseEnter: ({ item: item })=>{
            if (!(0, $5N1Y4.expValEquals)('platform_editor_toolbar_submenu_open_click', 'isEnabled', true)) {
                if (item.value.name === 'color') {
                    setIsColorSubmenuOpen(true);
                    setIsOpenedByKeyboard(false);
                }
                if (item.value.name === 'size') {
                    setIsSizeSubmenuOpen(true);
                    setIsOpenedByKeyboard(false);
                }
            }
        },
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onMouseLeave: ({ item: item })=>{
            if (!(0, $5N1Y4.expValEquals)('platform_editor_toolbar_submenu_open_click', 'isEnabled', true)) {
                if (item.value.name === 'color') setIsColorSubmenuOpen(false);
                if (item.value.name === 'size') setIsSizeSubmenuOpen(false);
            }
        },
        fitWidth: fitWidth + fitTolerance,
        fitHeight: fitHeight + fitTolerance
    }))));
};
var $cf9077b733ea9853$export$2e2bcd8739ae039 = $cf9077b733ea9853$var$ImageBorder;

});
parcelRegister("bs8QL", function(module, exports) {
$parcel$export(module.exports, "imageBorderMessages", () => $2c0fe241fc837fe7$export$cb37ac89e145f1d);

var $f0Pt4 = parcelRequire("f0Pt4");
const $2c0fe241fc837fe7$export$cb37ac89e145f1d = (0, $f0Pt4.defineMessages)({
    borderColor: {
        id: 'fabric.editor.imageBorderColor',
        defaultMessage: 'Color',
        description: 'Label shown as a toolbar section heading in the image border options panel for selecting the border color of the selected image.'
    },
    borderColorDropdownAriaLabel: {
        id: 'fabric.editor.imageBorderColor.dropdownAriaLabel',
        defaultMessage: 'Image border options Color dropdown',
        description: 'ARIA label for the dropdown to change the border color of an image.'
    },
    borderColorRadioGroupAriaLabel: {
        id: 'fabric.editor.imageBorderColor.radioGroupAriaLabel',
        defaultMessage: 'Color options',
        description: 'ARIA label for the group of selectable border colors in the image border options panel.'
    },
    borderSize: {
        id: 'fabric.editor.imageBorderSize',
        defaultMessage: 'Size',
        description: 'Label shown as a toolbar section heading in the image border options panel for selecting the border thickness of the selected image.'
    },
    borderSizeDropdownAriaLabel: {
        id: 'fabric.editor.imageBorderSize.dropdownAriaLabel',
        defaultMessage: 'Image border options Size dropdown',
        description: 'ARIA label for the dropdown to change the border size of an image.'
    },
    borderSizeRadioGroupAriaLabel: {
        id: 'fabric.editor.imageBorderSize.radioGroupAriaLabel',
        defaultMessage: 'Size options',
        description: 'ARIA label for the group of selectable border sizes in the image border options panel.'
    },
    addBorder: {
        id: 'fabric.editor.addImageBorder',
        defaultMessage: 'Add border',
        description: 'Label shown on a button in the image border options toolbar to add a border around the selected image.'
    },
    removeBorder: {
        id: 'fabric.editor.removeImageBorder',
        defaultMessage: 'Remove border',
        description: 'The text is shown as a button label in the image toolbar. Removes any border that was previously applied to the selected image.'
    },
    borderOptions: {
        id: 'fabric.editor.imageBorderOptions',
        defaultMessage: 'Border options',
        description: 'The text is shown as a panel or menu header. Provides users access to customize image borders including size and color options.'
    },
    borderSizeSubtle: {
        id: 'fabric.editor.imageBorderSubtle',
        defaultMessage: 'Subtle',
        description: 'Label shown as a drop-down item in the image border size selector to apply a thin, subtle border around the image.'
    },
    borderSizeMedium: {
        id: 'fabric.editor.imageBorderMedium',
        defaultMessage: 'Medium',
        description: 'Label shown as a drop-down item in the image border size selector to apply a medium-weight border around the image.'
    },
    borderSizeBold: {
        id: 'fabric.editor.imageBorderBold',
        defaultMessage: 'Bold',
        description: 'Label shown as a drop-down item in the image border size selector to apply a thick, bold border around the image.'
    }
});

});

parcelRegister("6efeV", function(module, exports) {
$parcel$export(module.exports, "default", () => $d5374d34443d1ca1$export$2e2bcd8739ae039);

var $chTBj = parcelRequire("chTBj");

var $eUTDo = parcelRequire("eUTDo");

var $c7jdP = parcelRequire("c7jdP");

var $2nt4W = parcelRequire("2nt4W");
const $d5374d34443d1ca1$var$borderColorPalette = [];
(0, $chTBj.borderColorPalette).forEach((label, color)=>{
    // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
    const key = label.toLowerCase().replace(' ', '-');
    const message = (0, $c7jdP.default)((0, $2nt4W.default), key);
    $d5374d34443d1ca1$var$borderColorPalette.push({
        value: color,
        label: label,
        border: (0, $eUTDo.DEFAULT_BORDER_COLOR),
        message: message
    });
});
var $d5374d34443d1ca1$export$2e2bcd8739ae039 = $d5374d34443d1ca1$var$borderColorPalette;

});

parcelRegister("7N6Do", function(module, exports) {
$parcel$export(module.exports, "menuItemDimensions", () => $b7872326f769be03$export$1a7f12094b137d20);
$parcel$export(module.exports, "itemSpacing", () => $b7872326f769be03$export$e14354b446b68c1f);
$parcel$export(module.exports, "contextualMenuArrow", () => $b7872326f769be03$export$b102432b1d401cd6);
$parcel$export(module.exports, "contextualSubMenu", () => $b7872326f769be03$export$22186258d84a0d25);
$parcel$export(module.exports, "buttonStyle", () => $b7872326f769be03$export$fd4d27a26b4854f3);
$parcel$export(module.exports, "buttonWrapperStyle", () => $b7872326f769be03$export$7afe8f4b3442c19d);
$parcel$export(module.exports, "toolbarButtonWrapper", () => $b7872326f769be03$export$6d722733f5366928);
$parcel$export(module.exports, "dropdownOptionButton", () => $b7872326f769be03$export$8918fcb9aa07f104);
$parcel$export(module.exports, "dropdownWrapper", () => $b7872326f769be03$export$89634948c2be5ede);
/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression -- Needs manual remediation*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9dQre = parcelRequire("9dQre");

var $eUTDo = parcelRequire("eUTDo");
function $b7872326f769be03$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b7872326f769be03$export$1a7f12094b137d20 = {
    width: 175,
    height: 32
};
const $b7872326f769be03$export$e14354b446b68c1f = 4;
const $b7872326f769be03$export$b102432b1d401cd6 = {
    name: "bkadrv",
    styles: "display:flex;&::after{content:'\u203A';margin-left:var(--ds-space-050, 4px);line-height:20px;color:var(--ds-icon, #292A2E);}"
};
const $b7872326f769be03$export$3c6c744e4fb4ffeb = (color)=>/*#__PURE__*/ (0, $9dQre.css)($b7872326f769be03$export$b102432b1d401cd6, " &::before{content:'';display:block;border:var(--ds-border-width, 1px) solid ", (0, $eUTDo.DEFAULT_BORDER_COLOR), ";border-radius:var(--ds-radius-small, 3px);width:20px;height:20px;", color && `background: ${color}`, ";}");
const $b7872326f769be03$export$22186258d84a0d25 = (index)=>/*#__PURE__*/ (0, $9dQre.css)("border-radius:var(--ds-radius-small, 3px);background:var(--ds-surface-overlay, #FFFFFF);box-shadow:var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f);display:flex;position:absolute;top:", index * ($b7872326f769be03$export$1a7f12094b137d20.height + $b7872326f769be03$export$e14354b446b68c1f * 2), "px;left:", $b7872326f769be03$export$1a7f12094b137d20.width, "px;padding:var(--ds-space-100, 8px);>div{padding:0;}");
const $b7872326f769be03$export$fd4d27a26b4854f3 = (selected)=>/*#__PURE__*/ (0, $9dQre.css)("height:26px;width:26px;padding:0;border-radius:var(--ds-radius-small, 4px);background-color:", selected ? "var(--ds-text, #292A2E)" : "var(--ds-background-neutral, #0515240F)", ";border:1px solid ", (0, $eUTDo.DEFAULT_BORDER_COLOR), ";cursor:pointer;display:block;");
const $b7872326f769be03$export$7afe8f4b3442c19d = {
    name: "1bac8cc",
    styles: "border:1px solid transparent;margin:var(--ds-space-025, 2px);font-size:0;display:flex;align-items:center;padding:var(--ds-space-025, 2px);border-radius:var(--ds-radius-medium, 6px);&:focus-within,&:focus,&:hover{border-color:var(--ds-border, #0B120E24)!important;}"
};
const $b7872326f769be03$export$53f1d5ea8de3d7c = (size, selected)=>/*#__PURE__*/ (0, $9dQre.css)("position:relative;&:before{content:'';display:block;position:absolute;top:50%;left:50%;width:12px;height:", size, "px;background-color:", selected ? "var(--ds-icon-inverse, #FFFFFF)" : "var(--ds-icon, #292A2E)", ";border-radius:90px;transform:translate(-50%, -50%) rotate(135deg);}");
const $b7872326f769be03$var$getHoverStyles = (selector)=>`&:hover ${selector} {
    background: ${"var(--ds-background-neutral-subtle-hovered, #0515240F)"};

    &:hover {
      background: ${"var(--ds-background-neutral-hovered, #0B120E24)"};
    }
  }`;
const $b7872326f769be03$export$6d722733f5366928 = ({ enabled: enabled, isOpen: isOpen })=>/*#__PURE__*/ (0, $9dQre.css)("display:flex;.image-border-toolbar-btn{border-top-right-radius:0;border-bottom-right-radius:0;padding:0;&>span{margin:0;}&:not([disabled])::after{border:none;}}.image-border-toolbar-dropdown{padding:0;width:16px!important;border-top-left-radius:0!important;border-bottom-left-radius:0!important;margin-left:var(--ds-space-025, 2px);&>span{margin:0;}&:not([disabled])::after{border:none;}}", !enabled && $b7872326f769be03$var$getHoverStyles('.image-border-toolbar-btn'), " ", !isOpen && !enabled && $b7872326f769be03$var$getHoverStyles('.image-border-toolbar-dropdown'), ";");
const $b7872326f769be03$export$8918fcb9aa07f104 = {
    name: "1eim0z6",
    styles: "background:transparent;border:var(--ds-border-width-focused, 2px) solid transparent;display:flex;width:100%;align-items:center;justify-content:space-between;padding:8px 16px;&:focus{background-color:var(--ds-background-neutral-subtle-hovered, #0515240F);border:var(--ds-border-width-focused, 2px) solid var(--ds-border-focused, #4688EC);}"
};
const $b7872326f769be03$export$89634948c2be5ede = {
    name: "3linml",
    styles: "span[role='menuitem']{padding:0;}"
};

});


parcelRegister("gHqj4", function(module, exports) {
$parcel$export(module.exports, "altTextButton", () => $7575d5e957de3a07$export$ee5eb653e9c77c53);
$parcel$export(module.exports, "getAltTextToolbar", () => $7575d5e957de3a07$export$626712166441e24f);
$parcel$export(module.exports, "getAltTextDropdownOption", () => $7575d5e957de3a07$export$cf32f28463a52655);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $cv8id = parcelRequire("cv8id");

var $7Zwry = parcelRequire("7Zwry");

var $bN7vg = parcelRequire("bN7vg");

var $4fvxf = parcelRequire("4fvxf");

var $cw0wu = parcelRequire("cw0wu");

var $68PXu = parcelRequire("68PXu");

var $gH0fc = parcelRequire("gH0fc");

var $6Qx3E = parcelRequire("6Qx3E");

var $icDBi = parcelRequire("icDBi");

var $4sVoN = parcelRequire("4sVoN");

var $jAHUG = parcelRequire("jAHUG");
const $7575d5e957de3a07$var$testId = 'alt-text-edit-button';
const $7575d5e957de3a07$export$ee5eb653e9c77c53 = (intl, state, editorAnalyticsAPI)=>{
    const mediaNode = (0, $4sVoN.getMediaSingleOrInlineNodeFromSelection)(state);
    const message = mediaNode && mediaNode.attrs.alt ? (0, $bN7vg.altTextMessages).editAltText : (0, $bN7vg.altTextMessages).altText;
    const title = intl.formatMessage(message);
    return {
        title: title,
        id: 'editor.media.altText',
        type: 'button',
        onClick: (0, $gH0fc.openMediaAltTextMenu)(editorAnalyticsAPI),
        showTitle: true,
        testId: $7575d5e957de3a07$var$testId,
        tooltipContent: /*#__PURE__*/ (0, $dc70d.jsx)((0, $cv8id.ToolTipContent), {
            description: title,
            keymap: (0, $cv8id.addAltText)
        })
    };
};
const $7575d5e957de3a07$var$altTextEditComponent = (options)=>{
    return {
        type: 'custom',
        fallback: [],
        disableArrowNavigation: true,
        render: (view, idx)=>{
            if (!view) return null;
            const state = view.state;
            const mediaNode = (0, $4sVoN.getMediaSingleOrInlineNodeFromSelection)(state);
            if (!mediaNode) return null;
            /** Focus should move to the 'Alt text' button when the toolbar closes
       * and not close the floating toolbar.
       */ const setFocus = ()=>{
                var _options$forceFocusSe;
                const { state: { tr: tr }, dispatch: dispatch } = view;
                const elementSelector = options !== null && options !== void 0 && options.triggerButtonSelector && options !== null && options !== void 0 && options.areAnyNewToolbarFlagsEnabled ? options.triggerButtonSelector : `[data-testid="${$7575d5e957de3a07$var$testId}"]`;
                const newTr = options === null || options === void 0 || (_options$forceFocusSe = options.forceFocusSelector) === null || _options$forceFocusSe === void 0 ? void 0 : _options$forceFocusSe.call(options, elementSelector)(tr);
                if (newTr) dispatch(newTr);
            };
            const type = (0, $jAHUG.getNodeType)(state);
            return /*#__PURE__*/ (0, $dc70d.jsx)((0, $6Qx3E.default), {
                view: view,
                nodeType: type,
                mediaType: mediaNode.attrs.type,
                value: mediaNode.attrs.alt,
                altTextValidator: options && options.altTextValidator,
                onEscape: setFocus,
                onEnter: setFocus,
                areAnyNewToolbarFlagsEnabled: options === null || options === void 0 ? void 0 : options.areAnyNewToolbarFlagsEnabled
            }, idx);
        }
    };
};
const $7575d5e957de3a07$export$626712166441e24f = (toolbarBaseConfig, options)=>{
    return {
        ...toolbarBaseConfig,
        width: (0, $7Zwry.RECENT_SEARCH_WIDTH_IN_PX),
        className: (0, $4fvxf.ClassNames).FLOATING_TOOLBAR_COMPONENT,
        items: [
            $7575d5e957de3a07$var$altTextEditComponent(options)
        ]
    };
};
const $7575d5e957de3a07$export$cf32f28463a52655 = (state, formatMessage, allowAltTextOnImages, selectedNodeType, editorAnalyticsAPI)=>{
    const { mediaSingle: mediaSingle, mediaInline: mediaInline } = state.schema.nodes;
    const mediaType = state.selection instanceof (0, $cw0wu.NodeSelection) && state.selection.node.attrs.type;
    if (allowAltTextOnImages && (selectedNodeType === mediaSingle || selectedNodeType === mediaInline && (0, $icDBi.isImage)(mediaType))) return [
        {
            title: formatMessage((0, $bN7vg.altTextMessages).addAltText),
            onClick: (0, $gH0fc.openMediaAltTextMenu)(editorAnalyticsAPI),
            icon: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($68PXu))), {
                label: ""
            }),
            testId: 'media-alt-text-dropdown-option'
        }
    ];
    return [];
};

});
parcelRegister("bN7vg", function(module, exports) {
$parcel$export(module.exports, "altTextMessages", () => $34f0df5afe7f2674$export$63563c8e4d4e5bae);

var $f0Pt4 = parcelRequire("f0Pt4");
const $34f0df5afe7f2674$export$63563c8e4d4e5bae = (0, $f0Pt4.defineMessages)({
    altText: {
        id: 'fabric.editor.addAltText',
        defaultMessage: 'Alt text',
        description: 'The text is shown as the label for the alt text button in the image floating toolbar, allowing the user to open the alt text editor for the selected image.'
    },
    addAltText: {
        id: 'fabric.editor.addUpdatedAltText',
        defaultMessage: 'Add alt text',
        description: 'The text is shown on a button in the image floating toolbar that opens the alt text editor for adding descriptive text to the selected image.'
    },
    editAltText: {
        id: 'fabric.editor.editAltText',
        defaultMessage: 'Edit alt text',
        description: 'The text is shown on a button in the image floating toolbar that opens the alt text editor for updating the existing descriptive text of the selected image.'
    },
    back: {
        id: 'fabric.editor.closeAltTextEdit',
        defaultMessage: 'Back',
        description: 'The text is shown on a button in the alt text editing toolbar for an image. When clicked, it closes the alt text editor and navigates the user back to the main media toolbar.'
    },
    clear: {
        id: 'fabric.editor.clearAltTextEdit',
        defaultMessage: 'Clear alt text',
        description: 'The text is shown on a button in the alt text editing toolbar for an image. When clicked, it clears the current alt text value from the input field.'
    },
    placeholder: {
        id: 'fabric.editor.placeholderAltText',
        defaultMessage: 'Describe this image with alt text',
        description: 'The text is shown as placeholder text inside the alt text input field for an image. It prompts the user to enter a description of the image for accessibility purposes.'
    },
    supportText: {
        id: 'fabric.editor.supportAltText',
        defaultMessage: 'Alt text is useful for people using screen readers because of visual limitations.',
        description: 'The text is shown as a help message below the alt text input field for an image. It informs users why providing alt text is important for accessibility and screen reader support.'
    },
    validationMessage: {
        id: 'fabric.editor.alttext.validation',
        defaultMessage: 'Please remove any special characters in alt text.',
        description: 'Please remove any special characters in alt text. '
    }
});

});

parcelRegister("4fvxf", function(module, exports) {
$parcel$export(module.exports, "ClassNames", () => $f615f851b93a0743$export$9b9c0f9d9f3552b8);
const $f615f851b93a0743$var$prefix = 'pm-alt-text';
const $f615f851b93a0743$export$9b9c0f9d9f3552b8 = {
    FLOATING_TOOLBAR_COMPONENT: `${$f615f851b93a0743$var$prefix}-alt-text-floating-toolbar`,
    MEDIA_CONTAINER: 'mediaView-content-wrap'
};

});

parcelRegister("68PXu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2fc89d6cbf5bd1bfdf11995ed395f378>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $478bcb4a9e155534$var$_react = $478bcb4a9e155534$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $478bcb4a9e155534$var$_iconNew = $478bcb4a9e155534$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $478bcb4a9e155534$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ImageAltText".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/image-alt-text
 * Usage guidance:
 * Reserved for creating alt text for an image
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $478bcb4a9e155534$var$ImageAltTextIcon = (props)=>/*#__PURE__*/ $478bcb4a9e155534$var$_react.default.createElement($478bcb4a9e155534$var$_iconNew.default, Object.assign({
        name: "ImageAltTextIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M16 8h-3.5V6.5H16zm0 3.5h-3.5V10H16zm0 3.5H5v-1.5h11zM0 3a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M7.206 5.001a.75.75 0 0 1 .55.196l3 2.75-1.013 1.106-2.43-2.228-4.245 4.915-1.136-.98 4.75-5.5A.75.75 0 0 1 7.206 5" clip-rule="evenodd"/><path fill="currentcolor" d="M5 4.875a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0"/>`
    }, props));
$478bcb4a9e155534$var$ImageAltTextIcon.displayName = 'ImageAltTextIcon';
var $478bcb4a9e155534$var$_default = module.exports.default = $478bcb4a9e155534$var$ImageAltTextIcon;

});

parcelRegister("6Qx3E", function(module, exports) {
$parcel$export(module.exports, "default", () => $f8f3afda5d681f25$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $fK3tS = parcelRequire("fK3tS");

var $kIbto = parcelRequire("kIbto");

var $bTWXs = parcelRequire("bTWXs");

var $g6Qq4 = parcelRequire("g6Qq4");

var $7HjEm = parcelRequire("7HjEm");

var $cv8id = parcelRequire("cv8id");

var $7Zwry = parcelRequire("7Zwry");

var $bN7vg = parcelRequire("bN7vg");

var $kGWDu = parcelRequire("kGWDu");

var $8qHhy = parcelRequire("8qHhy");

var $jskR2 = parcelRequire("jskR2");

var $5bbjm = parcelRequire("5bbjm");

var $dpxPQ = parcelRequire("dpxPQ");

var $cBVmT = parcelRequire("cBVmT");

var $gH0fc = parcelRequire("gH0fc");
function $f8f3afda5d681f25$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f8f3afda5d681f25$export$17c2363f220b4958 = 510; // double tweet length
const $f8f3afda5d681f25$var$supportTextStyles = /*#__PURE__*/ (0, $9dQre.css)({
    color: "var(--ds-text-subtlest, #6B6E76)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: (0, $5bbjm.relativeFontSizeToBase16)(12),
    padding: `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-500, 40px)"}`,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '20px',
    borderTop: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    margin: 0
});
const $f8f3afda5d681f25$var$containerStyles = /*#__PURE__*/ (0, $9dQre.css)({
    // eslint-disable-next-line  @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $7Zwry.RECENT_SEARCH_WIDTH_IN_PX)}px`,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 2
});
const $f8f3afda5d681f25$var$inputWrapperStyles = /*#__PURE__*/ (0, $9dQre.css)({
    display: 'flex',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 0,
    padding: `${"var(--ds-space-075, 6px)"} 0`,
    alignItems: 'center'
});
const $f8f3afda5d681f25$var$validationWrapperStyles = /*#__PURE__*/ (0, $9dQre.css)({
    display: 'flex',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 0,
    padding: `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-300, 24px)"} ${"var(--ds-space-150, 12px)"} 0`,
    margin: `0 ${"var(--ds-space-150, 12px)"} 0 ${"var(--ds-space-500, 40px)"}`,
    borderTop: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border-danger, #E2483D)"}`,
    alignItems: 'start',
    flexDirection: 'column'
});
const $f8f3afda5d681f25$var$buttonWrapperStyles = /*#__PURE__*/ (0, $9dQre.css)({
    display: 'flex',
    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-100, 8px)"}`
});
const $f8f3afda5d681f25$var$clearTextStyles = {
    name: "101f0nf",
    styles: "color:var(--ds-icon-subtle, #505258)"
};
class $f8f3afda5d681f25$export$c3eac9b61d42d8a9 extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Component {
    constructor(props){
        super(props), this.state = {
            showClearTextButton: Boolean(this.props.value),
            validationErrors: this.props.value ? this.getValidationErrors(this.props.value) : [],
            lastValue: this.props.value
        }, this.closeMediaAltTextMenu = ()=>{
            const { view: view } = this.props;
            if (this.state.validationErrors.length === 0) (0, $gH0fc.closeMediaAltTextMenuAndSave)(this.state.lastValue || '')(view.state, view.dispatch);
            else (0, $gH0fc.closeMediaAltTextMenu)(view.state, view.dispatch);
        }, this.closeMediaAltTextMenuAndSetFocus = ()=>{
            var _this$props$onEnter, _this$props;
            this.closeMediaAltTextMenu();
            (_this$props$onEnter = (_this$props = this.props).onEnter) === null || _this$props$onEnter === void 0 || _this$props$onEnter.call(_this$props);
        }, this.dispatchCancelEvent = (event)=>{
            const { view: view, onEscape: onEscape } = this.props;
            // We need to pass down the ESCAPE keymap
            // because when we focus on the Toolbar, Prosemirror blur,
            // making all keyboard shortcuts not working
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            view.someProp('handleKeyDown', (fn)=>fn(view, event));
            onEscape === null || onEscape === void 0 || onEscape();
        }, this.handleOnChange = (newAltText)=>{
            var _this$state;
            const validationErrors = this.getValidationErrors(newAltText);
            if (((_this$state = this.state) === null || _this$state === void 0 || (_this$state = _this$state.validationErrors) === null || _this$state === void 0 ? void 0 : _this$state.length) !== (validationErrors === null || validationErrors === void 0 ? void 0 : validationErrors.length)) // If number of errors was changed we need to reset attribute to get new SR announcement
            {
                if (this.errorsListRef) {
                    var _this$errorsListRef;
                    const errorsArea = (_this$errorsListRef = this.errorsListRef) === null || _this$errorsListRef === void 0 ? void 0 : _this$errorsListRef.current;
                    errorsArea === null || errorsArea === void 0 || errorsArea.removeAttribute('aria-live');
                    errorsArea === null || errorsArea === void 0 || errorsArea.setAttribute('aria-live', 'assertive');
                }
            }
            this.setState({
                showClearTextButton: Boolean(newAltText),
                validationErrors: validationErrors,
                lastValue: newAltText
            });
        }, this.handleOnBlur = (e)=>{
            // prevent other selection transaction gets triggered
            e.stopPropagation();
            if (this.props.areAnyNewToolbarFlagsEnabled ?? (0, $8qHhy.areToolbarFlagsEnabled)()) this.closeMediaAltTextMenuAndSetFocus();
            else this.closeMediaAltTextMenu();
        }, this.handleClearText = ()=>{
            this.handleOnChange('');
        };
        const { createAnalyticsEvent: createAnalyticsEvent } = props;
        this.fireCustomAnalytics = (0, $bTWXs.fireAnalyticsEvent)(createAnalyticsEvent);
        this.errorsListRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createRef();
    }
    componentDidMount() {
        this.prevValue = this.props.value;
    }
    componentWillUnmount() {
        this.fireAnalytics((0, $g6Qq4.ACTION).CLOSED);
        if (!this.prevValue && this.state.lastValue) this.fireAnalytics((0, $g6Qq4.ACTION).ADDED);
        if (this.prevValue && !this.state.lastValue) this.fireAnalytics((0, $g6Qq4.ACTION).CLEARED);
        if (this.prevValue && this.prevValue !== this.state.lastValue) this.fireAnalytics((0, $g6Qq4.ACTION).EDITED);
    }
    getValidationErrors(value) {
        const { altTextValidator: altTextValidator } = this.props;
        if (value && typeof altTextValidator === 'function') return altTextValidator(value) || [];
        return [];
    }
    render() {
        const { intl: { formatMessage: formatMessage } } = this.props;
        const { showClearTextButton: showClearTextButton } = this.state;
        const backButtonMessage = formatMessage((0, $bN7vg.altTextMessages).back);
        const backButtonMessageComponent = /*#__PURE__*/ (0, $9dQre.jsx)((0, $cv8id.ToolTipContent), {
            description: backButtonMessage,
            keymap: (0, $cv8id.escape),
            shortcutOverride: "Esc"
        });
        const errorsList = (this.state.validationErrors || []).map(function(error, index) {
            // Ignored via go/ees005
            // eslint-disable-next-line react/no-array-index-key
            return /*#__PURE__*/ (0, $9dQre.jsx)((0, $jskR2.ErrorMessage), {
                key: index
            }, error);
        });
        const hasErrors = !!errorsList.length;
        const onSubmit = this.props.areAnyNewToolbarFlagsEnabled ?? (0, $8qHhy.areToolbarFlagsEnabled)() ? this.closeMediaAltTextMenuAndSetFocus : this.closeMediaAltTextMenu;
        return /*#__PURE__*/ (0, $9dQre.jsx)("div", {
            css: $f8f3afda5d681f25$var$containerStyles
        }, /*#__PURE__*/ (0, $9dQre.jsx)("section", {
            css: $f8f3afda5d681f25$var$inputWrapperStyles
        }, /*#__PURE__*/ (0, $9dQre.jsx)("div", {
            css: $f8f3afda5d681f25$var$buttonWrapperStyles
        }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $7HjEm.default), {
            title: formatMessage((0, $bN7vg.altTextMessages).back),
            icon: /*#__PURE__*/ (0, $9dQre.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dpxPQ))), {
                label: formatMessage((0, $bN7vg.altTextMessages).back),
                size: "small"
            }),
            tooltipContent: backButtonMessageComponent,
            onClick: this.closeMediaAltTextMenu,
            areAnyNewToolbarFlagsEnabled: this.props.areAnyNewToolbarFlagsEnabled ?? (0, $8qHhy.areToolbarFlagsEnabled)()
        })), /*#__PURE__*/ (0, $9dQre.jsx)((0, $kGWDu.default), {
            testId: "alt-text-input",
            ariaLabel: formatMessage((0, $bN7vg.altTextMessages).placeholder),
            describedById: `${hasErrors ? 'errors-list' : ''} support-text`,
            placeholder: formatMessage((0, $bN7vg.altTextMessages).placeholder),
            defaultValue: this.state.lastValue,
            onCancel: this.dispatchCancelEvent,
            onChange: this.handleOnChange,
            onBlur: this.handleOnBlur,
            onSubmit: onSubmit,
            maxLength: $f8f3afda5d681f25$export$17c2363f220b4958,
            ariaRequired: true,
            ariaInvalid: hasErrors,
            autoFocus: true
        }), showClearTextButton && /*#__PURE__*/ (0, $9dQre.jsx)("div", {
            css: $f8f3afda5d681f25$var$buttonWrapperStyles
        }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $7HjEm.default), {
            testId: "alt-text-clear-button",
            title: formatMessage((0, $bN7vg.altTextMessages).clear),
            icon: /*#__PURE__*/ (0, $9dQre.jsx)("span", {
                css: $f8f3afda5d681f25$var$clearTextStyles
            }, /*#__PURE__*/ (0, $9dQre.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cBVmT))), {
                label: formatMessage((0, $bN7vg.altTextMessages).clear)
            })),
            tooltipContent: formatMessage((0, $bN7vg.altTextMessages).clear),
            onClick: this.handleClearText,
            areAnyNewToolbarFlagsEnabled: this.props.areAnyNewToolbarFlagsEnabled ?? (0, $8qHhy.areToolbarFlagsEnabled)()
        }))), hasErrors && /*#__PURE__*/ (0, $9dQre.jsx)("section", {
            id: "errors-list",
            ref: this.errorsListRef,
            "aria-live": "assertive",
            css: $f8f3afda5d681f25$var$validationWrapperStyles
        }, errorsList), /*#__PURE__*/ (0, $9dQre.jsx)("p", {
            css: $f8f3afda5d681f25$var$supportTextStyles,
            id: "support-text"
        }, formatMessage((0, $bN7vg.altTextMessages).supportText)));
    }
    fireAnalytics(actionType) {
        const { createAnalyticsEvent: createAnalyticsEvent, nodeType: nodeType, mediaType: mediaType } = this.props;
        if (createAnalyticsEvent && this.fireCustomAnalytics) this.fireCustomAnalytics({
            payload: {
                action: actionType,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).MEDIA,
                actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).ALT_TEXT,
                eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
                attributes: {
                    type: nodeType,
                    mediaType: mediaType
                }
            }
        });
    }
}
const $f8f3afda5d681f25$var$_default_1 = (0, $kIbto.default)()((0, $fK3tS.default)($f8f3afda5d681f25$export$c3eac9b61d42d8a9));
var $f8f3afda5d681f25$export$2e2bcd8739ae039 = $f8f3afda5d681f25$var$_default_1;

});
parcelRegister("jskR2", function(module, exports) {
$parcel$export(module.exports, "ErrorMessage", () => $486c335e38796bf7$export$915e9e7bd4f0f96d);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $9dQre = parcelRequire("9dQre");

var $4vLTk = parcelRequire("4vLTk");

var $hkLEY = parcelRequire("hkLEY");

var $lP6sB = parcelRequire("lP6sB");

var $fNLdd = parcelRequire("fNLdd");
function $486c335e38796bf7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $486c335e38796bf7$var$errorColor = {
    name: "hwd2ye",
    styles: "color:var(--ds-text-danger, #AE2E24)"
};
const $486c335e38796bf7$var$validColor = {
    name: "88plqi",
    styles: "color:var(--ds-text-success, #4C6B1F)"
};
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $486c335e38796bf7$var$messageStyle = ()=>/*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $9dQre.css)({
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: `${12 / 14}em`,
        fontStyle: 'inherit',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 16 / 12,
        fontWeight: "var(--ds-font-weight-regular, 400)",
        color: "var(--ds-text-subtlest, #6B6E76)",
        marginTop: "var(--ds-space-050, 4px)",
        display: 'flex',
        justifyContent: 'baseline'
    });
const $486c335e38796bf7$var$iconWrapperStyle = {
    name: "15quk7w",
    styles: "display:flex;margin-right:var(--ds-space-050, 4px)"
};
const $486c335e38796bf7$export$8fbe3c7d0ed2c683 = ({ children: children })=>/*#__PURE__*/ (0, $9dQre.jsx)("div", {
        css: $486c335e38796bf7$var$messageStyle
    }, children);
const $486c335e38796bf7$export$915e9e7bd4f0f96d = ({ children: children })=>{
    const intl = (0, $4vLTk.default)();
    return /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        css: ()=>{
            return [
                $486c335e38796bf7$var$messageStyle(),
                $486c335e38796bf7$var$errorColor
            ];
        }
    }, /*#__PURE__*/ (0, $9dQre.jsx)("span", {
        css: $486c335e38796bf7$var$iconWrapperStyle
    }, /*#__PURE__*/ (0, $9dQre.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hkLEY))), {
        label: intl.formatMessage((0, $fNLdd.default).error)
    })), children);
};
const $486c335e38796bf7$export$5505afb209a532c8 = ({ children: children })=>{
    const intl = (0, $4vLTk.default)();
    return /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        css: ()=>{
            return [
                $486c335e38796bf7$var$messageStyle(),
                $486c335e38796bf7$var$validColor
            ];
        }
    }, /*#__PURE__*/ (0, $9dQre.jsx)("span", {
        css: $486c335e38796bf7$var$iconWrapperStyle
    }, /*#__PURE__*/ (0, $9dQre.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lP6sB))), {
        label: intl.formatMessage((0, $fNLdd.default).success)
    })), children);
};

});



parcelRegister("3iiJ3", function(module, exports) {
$parcel$export(module.exports, "commentButton", () => $08c656efb6294338$export$c936f67f30fa5fde);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $g6Qq4 = parcelRequire("g6Qq4");

var $459x8 = parcelRequire("459x8");

var $hVGJk = parcelRequire("hVGJk");

var $cv8id = parcelRequire("cv8id");

var $1oKa3 = parcelRequire("1oKa3");

var $fuAsP = parcelRequire("fuAsP");

var $eYvps = parcelRequire("eYvps");

var $gdUUy = parcelRequire("gdUUy");

var $797yE = parcelRequire("797yE");

var $7omWA = parcelRequire("7omWA");
const $08c656efb6294338$export$c936f67f30fa5fde = (intl, state, api, onCommentButtonMount, createCommentExperience)=>{
    var _getSelectedMediaSing, _api$annotation, _api$connectivity;
    const selectMediaNode = (_getSelectedMediaSing = (0, $7omWA.getSelectedMediaSingle)(state)) === null || _getSelectedMediaSing === void 0 ? void 0 : _getSelectedMediaSing.node.firstChild;
    let hasActiveComments = false;
    const annotations = api === null || api === void 0 || (_api$annotation = api.annotation) === null || _api$annotation === void 0 || (_api$annotation = _api$annotation.sharedState.currentState()) === null || _api$annotation === void 0 ? void 0 : _api$annotation.annotations;
    if (selectMediaNode && annotations) hasActiveComments = selectMediaNode.marks.some((mark)=>mark.type.name === 'annotation' && !annotations[mark.attrs.id]);
    const title = intl.formatMessage(hasActiveComments ? (0, $1oKa3.commentMessages).viewCommentsOnMedia : (0, $1oKa3.commentMessages).addCommentOnMedia);
    const buttonLabel = intl.formatMessage((0, $fuAsP.annotationMessages).createComment);
    const onClickHandler = (state, dispatch)=>{
        if (api !== null && api !== void 0 && api.annotation && selectMediaNode) {
            const { showCommentForBlockNode: showCommentForBlockNode, setInlineCommentDraftState: setInlineCommentDraftState } = api.annotation.actions;
            const isOpeningMediaCommentFromToolbar = (0, $gdUUy.fg)('confluence_frontend_media_scroll_fix') ? true : false;
            if (!showCommentForBlockNode(selectMediaNode, (0, $459x8.VIEW_METHOD).COMMENT_BUTTON, isOpeningMediaCommentFromToolbar)(state, dispatch)) {
                var _selectMediaNode$attr;
                createCommentExperience === null || createCommentExperience === void 0 || createCommentExperience.start({
                    attributes: {
                        pageClass: 'editor',
                        commentType: 'block',
                        blockType: 'media',
                        entryPoint: 'highlightActionsSimple'
                    }
                });
                createCommentExperience === null || createCommentExperience === void 0 || createCommentExperience.initExperience.start();
                setInlineCommentDraftState(true, // TODO: ED-26962 - might need to update to reflect it's from media floating toolbar
                (0, $g6Qq4.INPUT_METHOD).FLOATING_TB, 'block', (_selectMediaNode$attr = selectMediaNode.attrs) === null || _selectMediaNode$attr === void 0 ? void 0 : _selectMediaNode$attr.id, isOpeningMediaCommentFromToolbar)(state, dispatch);
            }
        }
        return true;
    };
    return {
        type: 'button',
        testId: 'add-comment-media-button',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($eYvps))),
        title: (0, $797yE.editorExperiment)('platform_editor_controls', 'control') ? title : buttonLabel,
        showTitle: (0, $797yE.editorExperiment)('platform_editor_controls', 'control') ? undefined : true,
        onClick: onClickHandler,
        tooltipContent: /*#__PURE__*/ (0, $dc70d.jsx)((0, $cv8id.ToolTipContent), {
            description: title
        }),
        supportsViewMode: true,
        disabled: (0, $hVGJk.isOfflineMode)(api === null || api === void 0 || (_api$connectivity = api.connectivity) === null || _api$connectivity === void 0 || (_api$connectivity = _api$connectivity.sharedState) === null || _api$connectivity === void 0 || (_api$connectivity = _api$connectivity.currentState()) === null || _api$connectivity === void 0 ? void 0 : _api$connectivity.mode),
        onMount: ()=>{
            onCommentButtonMount && onCommentButtonMount();
        }
    };
};

});

parcelRegister("54s68", function(module, exports) {
$parcel$export(module.exports, "shouldShowImageBorder", () => $8d14096222ca0678$export$5c7a39f9b065f644);

var $hpVfr = parcelRequire("hpVfr");

var $i1rYO = parcelRequire("i1rYO");
function $8d14096222ca0678$export$5c7a39f9b065f644(editorState) {
    const border = editorState.schema.marks.border;
    if (!border) return false;
    const nodeWithPos = (0, $hpVfr.currentMediaNodeWithPos)(editorState) || (0, $i1rYO.currentMediaInlineNodeWithPos)(editorState);
    if (!nodeWithPos) return false;
    const { parent: parent } = editorState.doc.resolve(nodeWithPos.pos);
    return parent && parent.type.allowsMarkType(border);
}

});

parcelRegister("j5PoU", function(module, exports) {
$parcel$export(module.exports, "LayoutGroup", () => $d7766997da1064d5$export$7fe0cbe305f29bb4);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled, @typescript-eslint/consistent-type-imports

var $9dQre = parcelRequire("9dQre");

var $f1bHg = parcelRequire("f1bHg");

var $7HjEm = parcelRequire("7HjEm");

var $2Bpgx = parcelRequire("2Bpgx");

var $gUpf2 = parcelRequire("gUpf2");

var $9BVpB = parcelRequire("9BVpB");
const $d7766997da1064d5$var$containerStyles = (0, $9BVpB.xcss)({
    marginLeft: 'space.100'
});
const $d7766997da1064d5$export$7fe0cbe305f29bb4 = ({ layoutButtons: layoutButtons, dispatchCommand: dispatchCommand, hide: hide, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled })=>{
    return /*#__PURE__*/ (0, $9dQre.jsx)((0, $gUpf2.Box), {
        xcss: $d7766997da1064d5$var$containerStyles
    }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $f1bHg.default), null, layoutButtons.map((item, idx)=>{
        switch(item.type){
            case 'separator':
                return /*#__PURE__*/ (0, $9dQre.jsx)((0, $2Bpgx.default), {
                    // Ignored via go/ees005
                    // eslint-disable-next-line react/no-array-index-key
                    key: idx,
                    areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
                });
            case 'button':
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const ButtonIcon = item.icon;
                return /*#__PURE__*/ (0, $9dQre.jsx)((0, $7HjEm.default), {
                    // Ignored via go/ees005
                    // eslint-disable-next-line react/no-array-index-key
                    key: idx,
                    icon: item.icon ? /*#__PURE__*/ (0, $9dQre.jsx)(ButtonIcon, {
                        label: item.title
                    }) : undefined,
                    title: item.title,
                    selected: item.selected,
                    disabled: item.disabled,
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    onClick: ()=>{
                        dispatchCommand(item.onClick);
                        hide();
                    },
                    areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
                });
        }
    })));
};

});

parcelRegister("ipOKx", function(module, exports) {
$parcel$export(module.exports, "shouldShowMediaLinkToolbar", () => $8a4c1a78331671f2$export$383c20208186148e);
$parcel$export(module.exports, "getLinkingToolbar", () => $8a4c1a78331671f2$export$894ccf55bf35e0cb);
$parcel$export(module.exports, "getLinkingDropdownOptions", () => $8a4c1a78331671f2$export$ed96f06ad293a0a8);
$parcel$export(module.exports, "getOpenLinkToolbarButtonOption", () => $8a4c1a78331671f2$export$23a4fa4e099d05b4);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $7nI18 = parcelRequire("7nI18");

var $g6Qq4 = parcelRequire("g6Qq4");

var $7Zwry = parcelRequire("7Zwry");

var $8FY43 = parcelRequire("8FY43");

var $ejFiy = parcelRequire("ejFiy");

var $8qHhy = parcelRequire("8qHhy");

var $gRfjb = parcelRequire("gRfjb");

var $92LrB = parcelRequire("92LrB");

var $5cifv = parcelRequire("5cifv");

var $ki6Uz = parcelRequire("ki6Uz");

var $i1rYO = parcelRequire("i1rYO");

var $bwHSq = parcelRequire("bwHSq");
const $8a4c1a78331671f2$var$FORCE_FOCUS_SELECTOR = '[data-testid="add-link-button"],[data-testid="edit-link-button"]';
const $8a4c1a78331671f2$var$FORCE_FOCUS_SELECTOR_EDITOR_CONTROLS = '[data-testid="media-overflow-dropdown-trigger"]';
function $8a4c1a78331671f2$export$383c20208186148e(editorState) {
    const mediaLinkingState = (0, $ki6Uz.getMediaLinkingState)(editorState);
    if (!mediaLinkingState || mediaLinkingState.mediaPos === null) return false;
    const { nodes: { media: media, mediaInline: mediaInline }, marks: { link: link } } = editorState.schema;
    const node = editorState.doc.nodeAt(mediaLinkingState.mediaPos);
    if (!node || ![
        media,
        mediaInline
    ].includes(node.type)) return false;
    const { parent: parent } = editorState.doc.resolve(mediaLinkingState.mediaPos);
    return parent && parent.type.allowsMarkType(link);
}
const $8a4c1a78331671f2$export$894ccf55bf35e0cb = (toolbarBaseConfig, mediaLinkingState, state, intl, pluginInjectionApi, providerFactory)=>{
    const { link: link, visible: visible, editable: editing, mediaPos: mediaPos } = mediaLinkingState;
    if (visible && mediaPos !== null) {
        const node = state.doc.nodeAt(mediaPos);
        if (node) return {
            ...toolbarBaseConfig,
            height: (0, $7Zwry.RECENT_SEARCH_HEIGHT_IN_PX),
            width: (0, $7Zwry.RECENT_SEARCH_WIDTH_IN_PX),
            forcePlacement: true,
            items: [
                {
                    type: 'custom',
                    fallback: [],
                    disableArrowNavigation: true,
                    render: (view, idx)=>{
                        if (!view || !providerFactory) return null;
                        const setFocusOnFloatingToolbar = (setFocus)=>{
                            if (setFocus && (0, $8qHhy.areToolbarFlagsEnabled)(Boolean(pluginInjectionApi === null || pluginInjectionApi === void 0 ? void 0 : pluginInjectionApi.toolbar))) {
                                var _pluginInjectionApi$f;
                                const { state: { tr: tr }, dispatch: dispatch } = view;
                                pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$f = pluginInjectionApi.floatingToolbar) === null || _pluginInjectionApi$f === void 0 || (_pluginInjectionApi$f = _pluginInjectionApi$f.actions) === null || _pluginInjectionApi$f === void 0 || _pluginInjectionApi$f.forceFocusSelector($8a4c1a78331671f2$var$FORCE_FOCUS_SELECTOR_EDITOR_CONTROLS)(tr);
                                dispatch(tr);
                            }
                        };
                        return /*#__PURE__*/ (0, $dc70d.jsx)((0, $bwHSq.default), {
                            displayUrl: link,
                            providerFactory: providerFactory,
                            intl: intl,
                            editing: editing,
                            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                            onUnlink: (setFocus)=>{
                                var _pluginInjectionApi$a;
                                (0, $5cifv.unlink)(pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$a = pluginInjectionApi.analytics) === null || _pluginInjectionApi$a === void 0 ? void 0 : _pluginInjectionApi$a.actions)(view.state, view.dispatch, view);
                                setFocusOnFloatingToolbar(setFocus);
                            },
                            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                            onBack: (href, meta, setFocus)=>{
                                if (href.trim() && meta.inputMethod) {
                                    var _pluginInjectionApi$a2;
                                    (0, $5cifv.setUrlToMedia)(href, meta.inputMethod, pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$a2 = pluginInjectionApi.analytics) === null || _pluginInjectionApi$a2 === void 0 ? void 0 : _pluginInjectionApi$a2.actions)(view.state, view.dispatch, view);
                                }
                                (0, $5cifv.hideLinkingToolbar)(view.state, view.dispatch, view);
                                setFocusOnFloatingToolbar(setFocus);
                            },
                            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                            onCancel: ()=>{
                                var _pluginInjectionApi$f2;
                                (0, $5cifv.hideLinkingToolbar)(view.state, view.dispatch, view, true);
                                /** Focus should move to the 'Add link' button when the toolbar closes
               * and not close the floating toolbar.
               */ const { state: { tr: tr }, dispatch: dispatch } = view;
                                const selector = (0, $8qHhy.areToolbarFlagsEnabled)(Boolean(pluginInjectionApi === null || pluginInjectionApi === void 0 ? void 0 : pluginInjectionApi.toolbar)) ? $8a4c1a78331671f2$var$FORCE_FOCUS_SELECTOR_EDITOR_CONTROLS : $8a4c1a78331671f2$var$FORCE_FOCUS_SELECTOR;
                                pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$f2 = pluginInjectionApi.floatingToolbar) === null || _pluginInjectionApi$f2 === void 0 || (_pluginInjectionApi$f2 = _pluginInjectionApi$f2.actions) === null || _pluginInjectionApi$f2 === void 0 || _pluginInjectionApi$f2.forceFocusSelector(selector)(tr);
                                dispatch(tr);
                            },
                            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                            onSubmit: (href, meta)=>{
                                var _pluginInjectionApi$a3;
                                (0, $5cifv.setUrlToMedia)(href, meta.inputMethod, pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$a3 = pluginInjectionApi.analytics) === null || _pluginInjectionApi$a3 === void 0 ? void 0 : _pluginInjectionApi$a3.actions)(view.state, view.dispatch, view);
                                (0, $5cifv.hideLinkingToolbar)(view.state, view.dispatch, view);
                                setFocusOnFloatingToolbar(true);
                            },
                            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                            onBlur: ()=>{
                                (0, $5cifv.hideLinkingToolbar)(view.state, view.dispatch, view);
                            },
                            areAnyNewToolbarFlagsEnabled: (0, $8qHhy.areToolbarFlagsEnabled)(Boolean(pluginInjectionApi === null || pluginInjectionApi === void 0 ? void 0 : pluginInjectionApi.toolbar))
                        }, idx);
                    }
                }
            ]
        };
    }
};
const $8a4c1a78331671f2$var$mediaTypes = [
    'image',
    'video',
    'audio',
    'doc',
    'archive',
    'unknown'
];
const $8a4c1a78331671f2$var$getMediaType = (selectedNodeTypeSingle)=>{
    return $8a4c1a78331671f2$var$mediaTypes.find((type)=>selectedNodeTypeSingle === null || selectedNodeTypeSingle === void 0 ? void 0 : selectedNodeTypeSingle.includes(type));
};
const $8a4c1a78331671f2$export$ed96f06ad293a0a8 = (editorState, intl, mediaLinkingState, isInlineNode, allowLinking, isViewOnly)=>{
    if (isViewOnly || !allowLinking || !$8a4c1a78331671f2$export$383c20208186148e(editorState)) return [];
    let mediaType;
    const mediaNode = isInlineNode ? (0, $i1rYO.currentMediaInlineNode)(editorState) : (0, $i1rYO.currentMediaNode)(editorState);
    if (mediaNode) {
        const selectedNodeTypeSingle = mediaNode === null || mediaNode === void 0 ? void 0 : mediaNode.attrs.__fileMimeType;
        mediaType = $8a4c1a78331671f2$var$getMediaType(selectedNodeTypeSingle);
    }
    // Only show link dropdown option for images and external media (shown as images)
    if (mediaType !== 'image' && (mediaNode === null || mediaNode === void 0 ? void 0 : mediaNode.attrs.type) !== 'external') return [];
    if (mediaLinkingState && mediaLinkingState.editable) {
        const title = intl.formatMessage((0, $ejFiy.linkToolbarMessages).editLink);
        return [
            {
                title: title,
                onClick: (editorState, dispatch, editorView)=>{
                    if (editorView) {
                        const { state: state, dispatch: dispatch } = editorView;
                        (0, $5cifv.showLinkingToolbar)(state, dispatch);
                    }
                    return true;
                },
                icon: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gRfjb))), {
                    label: ""
                })
            }
        ];
    } else {
        const title = intl.formatMessage((0, $ejFiy.linkToolbarMessages).addLink);
        return [
            {
                title: title,
                onClick: (editorState, dispatch, editorView)=>{
                    if (editorView) {
                        const { state: state, dispatch: dispatch } = editorView;
                        (0, $5cifv.showLinkingToolbar)(state, dispatch);
                    }
                    return true;
                },
                icon: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gRfjb))), {
                    label: ""
                })
            }
        ];
    }
};
const $8a4c1a78331671f2$export$23a4fa4e099d05b4 = (intl, mediaLinkingState, pluginInjectionApi)=>{
    const isValidUrl = (0, $7nI18.isSafeUrl)(mediaLinkingState.link);
    const linkTitle = intl.formatMessage(isValidUrl ? (0, $8FY43.linkMessages).openLink : (0, $ejFiy.linkToolbarMessages).unableToOpenLink);
    return {
        id: 'editor.media.open-link',
        testId: 'open-link-toolbar-button',
        type: 'button',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($92LrB))),
        title: linkTitle,
        target: '_blank',
        href: isValidUrl ? mediaLinkingState.link : undefined,
        disabled: !isValidUrl,
        onClick: (state, dispatch, editorView)=>{
            if (editorView) {
                var _pluginInjectionApi$a4;
                const { state: { tr: tr }, dispatch: dispatch } = editorView;
                pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$a4 = pluginInjectionApi.analytics) === null || _pluginInjectionApi$a4 === void 0 || _pluginInjectionApi$a4.actions.attachAnalyticsEvent({
                    eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
                    action: (0, $g6Qq4.ACTION).VISITED,
                    actionSubject: (0, $g6Qq4.ACTION_SUBJECT).MEDIA,
                    actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).LINK
                })(tr);
                dispatch(tr);
            }
            return true;
        },
        supportsViewMode: true
    };
};

});
parcelRegister("bwHSq", function(module, exports) {
$parcel$export(module.exports, "default", () => $fb4d7a0595d082fa$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $g6Qq4 = parcelRequire("g6Qq4");

var $7HjEm = parcelRequire("7HjEm");

var $2Bpgx = parcelRequire("2Bpgx");

var $g5EwL = parcelRequire("g5EwL");

var $fIEl2 = parcelRequire("fIEl2");

var $78iKh = parcelRequire("78iKh");

var $ejFiy = parcelRequire("ejFiy");

var $kGWDu = parcelRequire("kGWDu");

var $jskR2 = parcelRequire("jskR2");

var $98KMe = parcelRequire("98KMe");

var $dpxPQ = parcelRequire("dpxPQ");

var $1c4Ad = parcelRequire("1c4Ad");
const $fb4d7a0595d082fa$var$validationWrapper = /*#__PURE__*/ (0, $9dQre.css)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 0,
    padding: `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-300, 24px)"} ${"var(--ds-space-150, 12px)"} 0`,
    margin: `0 ${"var(--ds-space-050, 4px)"} 0 ${"var(--ds-space-400, 32px)"}`,
    borderTop: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border-danger, #E2483D)"}`,
    alignItems: 'start',
    display: 'flex',
    flexDirection: 'column'
});
const $fb4d7a0595d082fa$var$buttonWrapper = /*#__PURE__*/ (0, $9dQre.css)({
    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-050, 4px)"} 0px`
});
// eslint-disable-next-line @repo/internal/react/no-class-components
class $fb4d7a0595d082fa$var$LinkAddToolbar extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).PureComponent {
    getValidationErrors(value, inputMethod) {
        const { intl: { formatMessage: formatMessage } } = this.props;
        // dont show validation errors if input method is typeahed, which means user selects from search list
        if (inputMethod === (0, $g6Qq4.INPUT_METHOD).TYPEAHEAD) return [];
        if (!value) return [
            formatMessage((0, $ejFiy.linkToolbarMessages).emptyLink)
        ];
        // if url can be normalized - we consider it is a valid url
        // also don't show validaition errors for empty values
        if ((0, $98KMe.normalizeUrl)(value)) return [];
        else return [
            formatMessage((0, $ejFiy.linkToolbarMessages).invalidLink)
        ];
    }
    render() {
        const { providerFactory: providerFactory, displayUrl: displayUrl } = this.props;
        return /*#__PURE__*/ (0, $9dQre.jsx)((0, $g5EwL.default), {
            defaultUrl: (0, $98KMe.normalizeUrl)(displayUrl),
            providerFactory: providerFactory,
            onSubmit: this.handleSubmit,
            onBlur: this.handleOnBlur,
            render: this.renderContainer
        });
    }
    constructor(...args){
        super(...args), this.state = {
            validationErrors: []
        }, this.handleSubmit = ({ url: url, inputMethod: inputMethod })=>{
            this.props.onSubmit(url, {
                inputMethod: inputMethod
            });
        }, this.handleOnBack = ({ url: url, inputMethod: inputMethod }, setFocus)=>{
            const { onBack: onBack } = this.props;
            if (onBack) onBack(url, {
                inputMethod: inputMethod
            }, setFocus);
        }, this.handleCancel = ()=>{
            const { onCancel: onCancel } = this.props;
            if (onCancel) onCancel();
        }, this.handleUnlink = (setFocus)=>{
            const { onUnlink: onUnlink } = this.props;
            if (onUnlink) onUnlink(setFocus);
        }, this.handleOnBlur = (options)=>{
            this.props.onBlur(options.url);
        }, this.renderContainer = ({ activityProvider: activityProvider, inputProps: { onChange: onChange, onKeyDown: onKeyDown, onSubmit: onSubmit, value: value }, currentInputMethod: currentInputMethod, renderRecentList: renderRecentList })=>{
            const { intl: { formatMessage: formatMessage }, displayUrl: displayUrl } = this.props;
            const getPlaceholder = (hasActivityProvider)=>formatMessage(hasActivityProvider ? (0, $ejFiy.linkToolbarMessages).placeholder : (0, $ejFiy.linkToolbarMessages).linkPlaceholder);
            const formatLinkAddressText = formatMessage((0, $78iKh.mediaLinkToolbarMessages).backLink);
            const formatUnlinkText = formatMessage((0, $ejFiy.linkToolbarMessages).unlink);
            const errorsList = this.state.validationErrors.map(function(error, index) {
                // Ignored via go/ees005
                // eslint-disable-next-line react/no-array-index-key
                return /*#__PURE__*/ (0, $9dQre.jsx)((0, $jskR2.ErrorMessage), {
                    key: index
                }, error);
            });
            return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, $9dQre.jsx)("div", {
                className: "recent-list"
            }, /*#__PURE__*/ (0, $9dQre.jsx)("div", {
                css: [
                    (0, $fIEl2.container),
                    !!activityProvider && (0, $fIEl2.containerWithProvider)
                ]
            }, /*#__PURE__*/ (0, $9dQre.jsx)("div", {
                css: (0, $fIEl2.inputWrapper)
            }, /*#__PURE__*/ (0, $9dQre.jsx)("span", {
                css: $fb4d7a0595d082fa$var$buttonWrapper
            }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $7HjEm.default), {
                title: formatLinkAddressText,
                icon: /*#__PURE__*/ (0, $9dQre.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dpxPQ))), {
                    label: formatLinkAddressText,
                    size: "small"
                }),
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                onClick: ()=>this.handleOnBack({
                        url: value,
                        inputMethod: currentInputMethod
                    }),
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                onKeyDown: (event)=>{
                    if (event.key === 'Enter' || event.key === ' ') {
                        event.preventDefault();
                        this.handleOnBack({
                            url: value,
                            inputMethod: currentInputMethod
                        }, true);
                    }
                },
                areAnyNewToolbarFlagsEnabled: this.props.areAnyNewToolbarFlagsEnabled
            })), /*#__PURE__*/ (0, $9dQre.jsx)((0, $kGWDu.default), {
                inputId: "media-link-search-input",
                testId: "media-link-input",
                placeholder: getPlaceholder(!!activityProvider),
                autoFocus: true,
                onCancel: this.handleCancel,
                defaultValue: value,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                onSubmit: (inputValue)=>{
                    const validationErrors = this.getValidationErrors(inputValue, currentInputMethod);
                    this.setState({
                        validationErrors: validationErrors
                    });
                    if (!validationErrors.length) onSubmit();
                },
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                onChange: (value)=>{
                    this.setState({
                        validationErrors: []
                    });
                    onChange(value);
                },
                onKeyDown: onKeyDown
            }), /*#__PURE__*/ (0, $9dQre.jsx)("label", {
                className: "assistive",
                htmlFor: "media-link-search-input"
            }, formatMessage((0, $ejFiy.linkToolbarMessages).searchInput)), (0, $98KMe.normalizeUrl)(displayUrl) && /*#__PURE__*/ (0, $9dQre.jsx)((0, $bSJIT.Fragment), null, /*#__PURE__*/ (0, $9dQre.jsx)((0, $2Bpgx.default), {
                areAnyNewToolbarFlagsEnabled: this.props.areAnyNewToolbarFlagsEnabled
            }), /*#__PURE__*/ (0, $9dQre.jsx)((0, $7HjEm.default), {
                title: formatUnlinkText,
                icon: /*#__PURE__*/ (0, $9dQre.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1c4Ad))), {
                    label: formatUnlinkText
                }),
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                onClick: ()=>this.handleUnlink(),
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                onKeyDown: (event)=>{
                    if (event.key === 'Enter' || event.key === ' ') {
                        event.preventDefault();
                        this.handleUnlink(true);
                    }
                },
                areAnyNewToolbarFlagsEnabled: this.props.areAnyNewToolbarFlagsEnabled
            }))), !!errorsList.length && /*#__PURE__*/ (0, $9dQre.jsx)("section", {
                css: $fb4d7a0595d082fa$var$validationWrapper
            }, errorsList), renderRecentList())));
        };
    }
}
var $fb4d7a0595d082fa$export$2e2bcd8739ae039 = $fb4d7a0595d082fa$var$LinkAddToolbar;

});
parcelRegister("g5EwL", function(module, exports) {
$parcel$export(module.exports, "default", () => $225ababb8cf19f2a$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $fK3tS = parcelRequire("fK3tS");

var $g6Qq4 = parcelRequire("g6Qq4");

var $cjXwI = parcelRequire("cjXwI");

var $dG3XA = parcelRequire("dG3XA");
const $225ababb8cf19f2a$var$DEFAULT_ITEMS_LIMIT = 5;
const $225ababb8cf19f2a$var$limit = (items, max)=>{
    return items.slice(0, max);
};
// Ignored via go/ees005
// eslint-disable-next-line @repo/internal/react/no-class-components
class $225ababb8cf19f2a$var$RecentLink extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Component {
    constructor(props){
        super(props), this.activityProvider = null, this.handleSubmit = ()=>{
            const { items: items, url: url, selectedIndex: selectedIndex } = this.state;
            const inputMethod = this.getCurrentInputMethod();
            if (!inputMethod) return; // No call submit, if there is nothing to submit
            switch(inputMethod){
                case (0, $g6Qq4.INPUT_METHOD).MANUAL:
                    this.props.onSubmit({
                        url: url,
                        text: url,
                        inputMethod: (0, $g6Qq4.INPUT_METHOD).MANUAL
                    });
                    break;
                case (0, $g6Qq4.INPUT_METHOD).TYPEAHEAD:
                    {
                        const item = items[selectedIndex];
                        this.setState(()=>({
                                url: item.url
                            }));
                        if (this.props.onSubmit) this.props.onSubmit({
                            url: item.url,
                            text: item.name,
                            inputMethod: (0, $g6Qq4.INPUT_METHOD).TYPEAHEAD
                        });
                        break;
                    }
            }
        }, this.handleSelected = (href, text)=>{
            if (this.props.onSubmit) {
                this.setState(()=>({
                        url: href
                    }));
                this.props.onSubmit({
                    text: text,
                    url: href,
                    inputMethod: (0, $g6Qq4.INPUT_METHOD).TYPEAHEAD
                });
            }
        }, this.handleChange = async (input)=>{
            this.setState({
                url: input
            });
            if (this.activityProvider) {
                if (input.length === 0) this.setState({
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    items: $225ababb8cf19f2a$var$limit(await this.activityProvider.getRecentItems(), this.props.limit),
                    selectedIndex: -1
                });
                else this.setState({
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    items: $225ababb8cf19f2a$var$limit(await this.activityProvider.searchRecent(input), this.props.limit),
                    selectedIndex: 0
                });
            }
        }, // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.handleKeyDown = (e)=>{
            const { items: items, selectedIndex: selectedIndex } = this.state;
            if (!items || !items.length) return;
            if (e.key === 'ArrowDown') {
                // down
                e.preventDefault();
                this.setState({
                    selectedIndex: (selectedIndex + 1) % items.length
                });
            } else if (e.key === 'ArrowUp') {
                // up
                e.preventDefault();
                this.setState({
                    selectedIndex: selectedIndex > 0 ? selectedIndex - 1 : items.length - 1
                });
            }
        }, this.handleMouseMove = (objectId)=>{
            const { items: items } = this.state;
            if (items) {
                const index = items.findIndex((item)=>item.objectId === objectId);
                this.setState({
                    selectedIndex: index
                });
            }
        }, this.renderRecentList = ()=>{
            const { items: items, isLoading: isLoading, selectedIndex: selectedIndex } = this.state;
            return /*#__PURE__*/ (0, $dc70d.jsx)((0, $cjXwI.default), {
                items: items,
                isLoading: isLoading,
                selectedIndex: selectedIndex,
                onSelect: this.handleSelected,
                onMouseMove: this.handleMouseMove
            });
        }, this.clearValue = ()=>{
            this.setState({
                url: ''
            });
        };
        this.state = {
            selectedIndex: -1,
            isLoading: false,
            items: [],
            url: props.defaultUrl || ''
        };
    }
    static #_ = this.defaultProps = {
        limit: $225ababb8cf19f2a$var$DEFAULT_ITEMS_LIMIT
    };
    componentDidUpdate(prevProps) {
        if (prevProps.defaultUrl !== this.props.defaultUrl) this.setState((state)=>{
            if (state.url !== this.props.defaultUrl) return {
                items: [],
                selectedIndex: -1,
                url: this.props.defaultUrl || ''
            };
            return null;
        });
    }
    async componentDidMount() {
        if (this.props.activityProvider) {
            this.activityProvider = await this.props.activityProvider;
            await this.loadRecentItems(this.activityProvider);
        }
    }
    async loadRecentItems(activityProvider) {
        try {
            if (!this.state.url) this.setState({
                isLoading: true,
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                items: $225ababb8cf19f2a$var$limit(await activityProvider.getRecentItems(), this.props.limit) // defaultProps assure that limit always contains a value
            });
        } finally{
            this.setState({
                isLoading: false
            });
        }
    }
    getCurrentInputMethod() {
        const { items: items, url: url, selectedIndex: selectedIndex } = this.state;
        if (items && items.length > 0 && selectedIndex > -1) return (0, $g6Qq4.INPUT_METHOD).TYPEAHEAD;
        else if (url && url.length > 0) return (0, $g6Qq4.INPUT_METHOD).MANUAL;
        return;
    }
    render() {
        const { render: render } = this.props;
        const { url: url } = this.state;
        return render({
            activityProvider: this.activityProvider,
            inputProps: {
                onChange: this.handleChange,
                onKeyDown: this.handleKeyDown,
                onSubmit: this.handleSubmit,
                value: url
            },
            clearValue: this.clearValue,
            currentInputMethod: this.getCurrentInputMethod(),
            renderRecentList: this.renderRecentList
        });
    }
}
const $225ababb8cf19f2a$var$_default_1 = (0, $dG3XA.default)((0, $fK3tS.default)($225ababb8cf19f2a$var$RecentLink));
var $225ababb8cf19f2a$export$2e2bcd8739ae039 = $225ababb8cf19f2a$var$_default_1;

});
parcelRegister("dG3XA", function(module, exports) {
$parcel$export(module.exports, "default", () => $35e1d59421f87149$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $fRXfs = parcelRequire("fRXfs");
function $35e1d59421f87149$export$2e2bcd8739ae039(WrappedComponent) {
    return class WithActivityProvider extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Component {
        render() {
            const { providerFactory: providerFactory } = this.props;
            return /*#__PURE__*/ (0, $dc70d.jsx)((0, $fRXfs.WithProviders), {
                // Memoising this array causes the component fail tests in platform/packages/editor/editor-plugin-media-tests/src/__tests__/playwright/media-link.spec.ts because the WithProviders component doesn't update when the parent rerenders - this is a bug with the underlying WithProviders component
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                providers: [
                    'activityProvider'
                ],
                providerFactory: providerFactory,
                renderNode: this.renderNode
            });
        }
        constructor(...args){
            super(...args), this.renderNode = (providers)=>{
                const { providerFactory: _providerFactory, ...props } = this.props;
                const { activityProvider: activityProvider } = providers;
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any, react/jsx-props-no-spreading
                return /*#__PURE__*/ (0, $dc70d.jsx)(WrappedComponent, {
                    activityProvider: activityProvider,
                    ...props
                });
            };
        }
    };
}

});


parcelRegister("78iKh", function(module, exports) {
$parcel$export(module.exports, "mediaLinkToolbarMessages", () => $550e7bdfbc840a9e$export$8fc7ee45d6c4fad2);

var $f0Pt4 = parcelRequire("f0Pt4");
const $550e7bdfbc840a9e$export$8fc7ee45d6c4fad2 = (0, $f0Pt4.defineMessages)({
    backLink: {
        id: 'fabric.editor.backLink',
        defaultMessage: 'Go back',
        description: 'Go back from media linking toolbar to main toolbar'
    }
});

});



parcelRegister("fV1C5", function(module, exports) {
$parcel$export(module.exports, "LinkToolbarAppearance", () => $60c091e2e6c148f3$export$2a8c6fb42753b13e);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $7nI18 = parcelRequire("7nI18");

var $7HjEm = parcelRequire("7HjEm");

var $2Bpgx = parcelRequire("2Bpgx");

var $cv8id = parcelRequire("cv8id");

var $8FY43 = parcelRequire("8FY43");

var $ejFiy = parcelRequire("ejFiy");

var $gRfjb = parcelRequire("gRfjb");

var $92LrB = parcelRequire("92LrB");

var $i1rYO = parcelRequire("i1rYO");

var $7ICJC = parcelRequire("7ICJC");

var $tHQ9T = parcelRequire("tHQ9T");
function $60c091e2e6c148f3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $60c091e2e6c148f3$var$wrapperStyles = {
    name: "s5xdrg",
    styles: "display:flex;align-items:center"
};
const $60c091e2e6c148f3$export$2a8c6fb42753b13e = ({ editorState: editorState, mediaLinkingState: mediaLinkingState, intl: intl, onAddLink: onAddLink, onEditLink: onEditLink, onOpenLink: onOpenLink, isInlineNode: isInlineNode, isViewOnly: isViewOnly, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled })=>{
    const [showLinkingControls, setShowLinkingControls] = (0, $bSJIT.useState)(true);
    (0, $bSJIT.useEffect)(()=>{
        var _stateKey$getState;
        const mediaNode = isInlineNode ? (0, $i1rYO.currentMediaInlineNode)(editorState) : (0, $i1rYO.currentMediaNode)(editorState);
        if (!mediaNode) {
            setShowLinkingControls(false);
            return;
        }
        const mediaClientConfig = (_stateKey$getState = (0, $7ICJC.stateKey).getState(editorState)) === null || _stateKey$getState === void 0 ? void 0 : _stateKey$getState.mediaClientConfig;
        if (!mediaClientConfig) {
            setShowLinkingControls(false);
            return;
        }
        (0, $tHQ9T.checkMediaType)(mediaNode, mediaClientConfig).then((mediaType)=>{
            setShowLinkingControls(mediaType === 'external' || mediaType === 'image');
        });
    }, [
        editorState,
        isInlineNode
    ]);
    if (!showLinkingControls) return null;
    if (mediaLinkingState && mediaLinkingState.editable) {
        const isValidUrl = (0, $7nI18.isSafeUrl)(mediaLinkingState.link);
        const title = intl.formatMessage((0, $ejFiy.linkToolbarMessages).editLink);
        const linkTitle = intl.formatMessage(isValidUrl ? (0, $8FY43.linkMessages).openLink : (0, $ejFiy.linkToolbarMessages).unableToOpenLink);
        return /*#__PURE__*/ (0, $9dQre.jsx)((0, $bSJIT.Fragment), null, !isViewOnly && /*#__PURE__*/ (0, $9dQre.jsx)("div", {
            css: $60c091e2e6c148f3$var$wrapperStyles
        }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $7HjEm.default), {
            onClick: onEditLink,
            title: title,
            tooltipContent: /*#__PURE__*/ (0, $9dQre.jsx)((0, $cv8id.ToolTipContent), {
                description: title,
                keymap: (0, $cv8id.addLink)
            }),
            testId: "edit-link-button",
            areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
        }, title)), /*#__PURE__*/ (0, $9dQre.jsx)((0, $7HjEm.default), {
            target: "_blank",
            href: isValidUrl ? mediaLinkingState.link : undefined,
            disabled: !isValidUrl,
            onClick: onOpenLink,
            title: linkTitle,
            icon: /*#__PURE__*/ (0, $9dQre.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($92LrB))), {
                color: "currentColor",
                spacing: "spacious",
                label: linkTitle
            }),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: "hyperlink-open-link",
            areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
        }), /*#__PURE__*/ (0, $9dQre.jsx)((0, $2Bpgx.default), {
            areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
        }));
    } else {
        const title = intl.formatMessage((0, $ejFiy.linkToolbarMessages).addLink);
        return !isViewOnly ? /*#__PURE__*/ (0, $9dQre.jsx)((0, $bSJIT.Fragment), null, /*#__PURE__*/ (0, $9dQre.jsx)((0, $7HjEm.default), {
            testId: "add-link-button",
            onClick: onAddLink,
            title: title,
            tooltipContent: /*#__PURE__*/ (0, $9dQre.jsx)((0, $cv8id.ToolTipContent), {
                description: title,
                keymap: (0, $cv8id.addLink)
            }),
            icon: /*#__PURE__*/ (0, $9dQre.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gRfjb))), {
                color: "currentColor",
                label: title,
                spacing: "spacious"
            }),
            areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
        }), /*#__PURE__*/ (0, $9dQre.jsx)((0, $2Bpgx.default), {
            areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
        })) : null;
    }
};

});

parcelRegister("5tgEy", function(module, exports) {
$parcel$export(module.exports, "generateMediaInlineFloatingToolbar", () => $358730d536b1f96a$export$55564240c0c61582);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $g6Qq4 = parcelRequire("g6Qq4");

var $fNLdd = parcelRequire("fNLdd");

var $278lv = parcelRequire("278lv");

var $ahEv1 = parcelRequire("ahEv1");

var $8qHhy = parcelRequire("8qHhy");

var $cw0wu = parcelRequire("cw0wu");

var $gV64P = parcelRequire("gV64P");

var $3iMZX = parcelRequire("3iMZX");

var $j7FKK = parcelRequire("j7FKK");

var $kGogQ = parcelRequire("kGogQ");

var $g6z2B = parcelRequire("g6z2B");

var $eNuIV = parcelRequire("eNuIV");

var $lWuWs = parcelRequire("lWuWs");

var $2HqML = parcelRequire("2HqML");

var $gdUUy = parcelRequire("gdUUy");

var $5cifv = parcelRequire("5cifv");

var $ki6Uz = parcelRequire("ki6Uz");

var $i1rYO = parcelRequire("i1rYO");

var $icDBi = parcelRequire("icDBi");

var $emGE2 = parcelRequire("emGE2");

var $gHqj4 = parcelRequire("gHqj4");

var $jAHUG = parcelRequire("jAHUG");

var $54s68 = parcelRequire("54s68");

var $2L3c8 = parcelRequire("2L3c8");

var $ipOKx = parcelRequire("ipOKx");

var $fV1C5 = parcelRequire("fV1C5");

var $7omWA = parcelRequire("7omWA");
const $358730d536b1f96a$export$55564240c0c61582 = (state, intl, mediaPluginState, hoverDecoration, pluginInjectionApi, options = {})=>{
    var _pluginInjectionApi$a, _pluginInjectionApi$f;
    const editorAnalyticsAPI = pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$a = pluginInjectionApi.analytics) === null || _pluginInjectionApi$a === void 0 ? void 0 : _pluginInjectionApi$a.actions;
    const forceFocusSelector = pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$f = pluginInjectionApi.floatingToolbar) === null || _pluginInjectionApi$f === void 0 || (_pluginInjectionApi$f = _pluginInjectionApi$f.actions) === null || _pluginInjectionApi$f === void 0 ? void 0 : _pluginInjectionApi$f.forceFocusSelector;
    const { mediaInline: mediaInline } = state.schema.nodes;
    const mediaType = state.selection instanceof (0, $cw0wu.NodeSelection) && state.selection.node.attrs.type;
    const mediaLinkingState = (0, $ki6Uz.getMediaLinkingState)(state);
    if (mediaPluginState.allowInlineImages && (0, $icDBi.isImage)(mediaType)) return $358730d536b1f96a$var$getMediaInlineImageToolbar(state, intl, mediaPluginState, hoverDecoration, editorAnalyticsAPI, pluginInjectionApi, mediaLinkingState, options);
    const items = [];
    const areAnyNewToolbarFlagsEnabled = (0, $8qHhy.areToolbarFlagsEnabled)(Boolean(pluginInjectionApi === null || pluginInjectionApi === void 0 ? void 0 : pluginInjectionApi.toolbar));
    const mauiToolbarSeparatorsUpdateEnabled = (0, $gdUUy.fg)('cc-maui-toolbar-separators-update-jira') && areAnyNewToolbarFlagsEnabled;
    const preview = {
        id: 'editor.media.viewer',
        testId: 'file-preview-toolbar-button',
        type: 'button',
        icon: areAnyNewToolbarFlagsEnabled ? (0, (/*@__PURE__*/$parcel$interopDefault($j7FKK))) : (0, (/*@__PURE__*/$parcel$interopDefault($eNuIV))),
        title: intl.formatMessage((0, $2HqML.messages).expand),
        onClick: ()=>{
            return (0, $2L3c8.handleShowMediaViewer)({
                mediaPluginState: mediaPluginState,
                api: pluginInjectionApi
            }) ?? false;
        },
        ...areAnyNewToolbarFlagsEnabled && {
            supportsViewMode: true
        }
    };
    const disableDownloadButton = (0, $7omWA.getIsDownloadDisabledByDataSecurityPolicy)(mediaPluginState);
    const download = {
        id: 'editor.media.card.download',
        type: 'button',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3iMZX))),
        onClick: ()=>{
            (0, $7omWA.downloadMedia)(mediaPluginState);
            return true;
        },
        disabled: disableDownloadButton,
        title: intl.formatMessage((0, $2HqML.messages).download),
        ...areAnyNewToolbarFlagsEnabled && {
            supportsViewMode: true
        }
    };
    if (!areAnyNewToolbarFlagsEnabled) items.push({
        id: 'editor.media.view.switcher.inline',
        type: 'button',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($g6z2B))),
        selected: true,
        disabled: false,
        focusEditoronEnter: true,
        onClick: ()=>true,
        title: intl.formatMessage((0, $278lv.messages).inlineTitle),
        testId: 'inline-appearance',
        className: 'inline-appearance' // a11y. uses to force focus on item
    }, {
        id: 'editor.media.view.switcher.thumbnail',
        type: 'button',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lWuWs))),
        selected: false,
        disabled: false,
        focusEditoronEnter: true,
        onClick: (0, $jAHUG.changeInlineToMediaCard)(editorAnalyticsAPI, forceFocusSelector),
        title: intl.formatMessage((0, $278lv.messages).blockTitle),
        testId: 'thumbnail-appearance',
        className: 'thumbnail-appearance' // a11y. uses to force focus on item
    }, {
        type: 'separator'
    }, preview, {
        type: 'separator'
    }, download, {
        type: 'separator'
    }, {
        type: 'copy-button',
        supportsViewMode: true,
        items: [
            {
                state: state,
                formatMessage: intl.formatMessage,
                nodeType: mediaInline
            }
        ]
    }, {
        type: 'separator'
    }, {
        id: 'editor.media.delete',
        type: 'button',
        appearance: 'danger',
        focusEditoronEnter: true,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gV64P))),
        onMouseEnter: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(mediaInline, true),
        onMouseLeave: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(mediaInline, false),
        onFocus: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(mediaInline, true),
        onBlur: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(mediaInline, false),
        title: intl.formatMessage((0, $fNLdd.default).remove),
        onClick: (0, $jAHUG.removeInlineCardWithAnalytics)(editorAnalyticsAPI),
        testId: 'media-toolbar-remove-button'
    });
    else {
        const options = [
            {
                id: 'editor.media.view.switcher.inline',
                title: intl.formatMessage((0, $278lv.messages).inlineTitle),
                onClick: ()=>true,
                selected: true,
                icon: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g6z2B))), {
                    label: "",
                    spacing: "spacious"
                })
            },
            {
                id: 'editor.media.view.switcher.thumbnail',
                title: intl.formatMessage((0, $278lv.messages).blockTitle),
                onClick: (0, $jAHUG.changeInlineToMediaCard)(editorAnalyticsAPI, forceFocusSelector),
                icon: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lWuWs))), {
                    label: "",
                    spacing: "spacious"
                })
            }
        ];
        const switcherDropdown = {
            title: intl.formatMessage((0, $2HqML.messages).fileDisplayOptions),
            id: 'media-group-inline-switcher-toolbar-item',
            testId: 'media-group-inline-switcher-dropdown',
            type: 'dropdown',
            options: options,
            icon: ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g6z2B))), {
                    label: "",
                    spacing: "spacious"
                })
        };
        items.push(switcherDropdown, ...mauiToolbarSeparatorsUpdateEnabled ? [] : [
            {
                type: 'separator',
                fullHeight: true
            }
        ], download, ...mauiToolbarSeparatorsUpdateEnabled ? [] : [
            {
                type: 'separator',
                supportsViewMode: true
            }
        ], preview, ...mauiToolbarSeparatorsUpdateEnabled ? [] : [
            {
                type: 'separator',
                fullHeight: true
            }
        ]);
    }
    return items;
};
const $358730d536b1f96a$var$getMediaInlineImageToolbar = (state, intl, mediaPluginState, hoverDecoration, editorAnalyticsAPI, pluginInjectionApi, mediaLinkingState, options = {})=>{
    var _pluginInjectionApi$w;
    const { mediaInline: mediaInline } = state.schema.nodes;
    const mediaInlineImageTitle = intl.formatMessage((0, $ahEv1.toolbarMessages).changeToMediaInlineImage);
    const mediaSingleTitle = intl.formatMessage((0, $ahEv1.toolbarMessages).changeToMediaSingle);
    const widthPluginState = pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$w = pluginInjectionApi.width) === null || _pluginInjectionApi$w === void 0 ? void 0 : _pluginInjectionApi$w.sharedState.currentState();
    const inlineImageItems = [];
    const isEditorControlsEnabled = (0, $8qHhy.areToolbarFlagsEnabled)(Boolean(pluginInjectionApi === null || pluginInjectionApi === void 0 ? void 0 : pluginInjectionApi.toolbar));
    const { isViewOnly: isViewOnly, allowAltTextOnImages: allowAltTextOnImages, allowLinking: allowLinking, allowImagePreview: allowImagePreview } = options;
    const mauiToolbarSeparatorsUpdateEnabled = (0, $gdUUy.fg)('cc-maui-toolbar-separators-update-jira') && isEditorControlsEnabled;
    if ((0, $54s68.shouldShowImageBorder)(state)) {
        inlineImageItems.push({
            type: 'custom',
            fallback: [],
            render: (editorView)=>{
                if (!editorView) return null;
                const { dispatch: dispatch, state: state } = editorView;
                const borderMark = (0, $i1rYO.currentMediaOrInlineNodeBorderMark)(state);
                return /*#__PURE__*/ (0, $dc70d.jsx)((0, $emGE2.default), {
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    toggleBorder: ()=>{
                        var _pluginInjectionApi$a2;
                        (0, $jAHUG.toggleBorderMark)(pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$a2 = pluginInjectionApi.analytics) === null || _pluginInjectionApi$a2 === void 0 ? void 0 : _pluginInjectionApi$a2.actions)(state, dispatch);
                    },
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    setBorder: (attrs)=>{
                        var _pluginInjectionApi$a3;
                        (0, $jAHUG.setBorderMark)(pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$a3 = pluginInjectionApi.analytics) === null || _pluginInjectionApi$a3 === void 0 ? void 0 : _pluginInjectionApi$a3.actions)(attrs)(state, dispatch);
                    },
                    borderMark: borderMark,
                    intl: intl
                });
            }
        });
        if (!isEditorControlsEnabled) inlineImageItems.push({
            type: 'separator'
        });
    }
    const download = {
        id: 'editor.media.image.download',
        type: 'button',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3iMZX))),
        onClick: ()=>{
            (0, $7omWA.downloadMedia)(mediaPluginState, options.isViewOnly);
            return true;
        },
        title: intl.formatMessage((0, $2HqML.messages).download),
        supportsViewMode: true
    };
    // For Editor Controls: show options to convert from 'Inline' to 'Original size' via dropdown
    if (!isEditorControlsEnabled) inlineImageItems.push({
        id: 'editor.media.convert.mediainline',
        type: 'button',
        title: mediaInlineImageTitle,
        icon: ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g6z2B))), {
                color: "currentColor",
                spacing: "spacious",
                label: mediaInlineImageTitle
            }),
        onClick: ()=>{
            return true;
        },
        selected: true
    }, {
        id: 'editor.media.convert.mediasingle',
        type: 'button',
        title: mediaSingleTitle,
        icon: ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kGogQ))), {
                color: "currentColor",
                spacing: "spacious",
                label: mediaSingleTitle
            }),
        onClick: (0, $jAHUG.changeMediaInlineToMediaSingle)(editorAnalyticsAPI, widthPluginState, options === null || options === void 0 ? void 0 : options.allowPixelResizing)
    }, {
        type: 'separator'
    }, {
        type: 'custom',
        fallback: [],
        render: (editorView, idx)=>{
            if (editorView !== null && editorView !== void 0 && editorView.state) {
                const editLink = ()=>{
                    if (editorView) {
                        const { state: state, dispatch: dispatch } = editorView;
                        (0, $5cifv.showLinkingToolbar)(state, dispatch);
                    }
                };
                const openLink = ()=>{
                    if (editorView) {
                        var _pluginInjectionApi$a4;
                        const { state: { tr: tr }, dispatch: dispatch } = editorView;
                        pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$a4 = pluginInjectionApi.analytics) === null || _pluginInjectionApi$a4 === void 0 || _pluginInjectionApi$a4.actions.attachAnalyticsEvent({
                            eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
                            action: (0, $g6Qq4.ACTION).VISITED,
                            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).MEDIA,
                            actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).LINK
                        })(tr);
                        dispatch(tr);
                        return true;
                    }
                };
                return /*#__PURE__*/ (0, $dc70d.jsx)((0, $fV1C5.LinkToolbarAppearance), {
                    editorState: editorView.state,
                    intl: intl,
                    mediaLinkingState: mediaLinkingState,
                    onAddLink: editLink,
                    onEditLink: editLink,
                    onOpenLink: openLink,
                    isInlineNode: true,
                    isViewOnly: options.isViewOnly,
                    areAnyNewToolbarFlagsEnabled: (0, $8qHhy.areToolbarFlagsEnabled)(Boolean(pluginInjectionApi === null || pluginInjectionApi === void 0 ? void 0 : pluginInjectionApi.toolbar))
                }, idx);
            }
            return null;
        },
        supportsViewMode: true
    });
    else {
        const switchFromInlineToBlock = (0, $7omWA.getMediaSingleAndMediaInlineSwitcherDropdown)('inline', intl, pluginInjectionApi);
        inlineImageItems.push(switchFromInlineToBlock, ...mauiToolbarSeparatorsUpdateEnabled ? [] : [
            {
                type: 'separator',
                fullHeight: true
            }
        ]);
        if (isViewOnly) inlineImageItems.push(download, ...mauiToolbarSeparatorsUpdateEnabled ? [] : [
            {
                type: 'separator',
                supportsViewMode: true
            }
        ]);
    }
    //Image Preview
    if (allowImagePreview) inlineImageItems.push({
        id: 'editor.media.viewer',
        testId: 'file-preview-toolbar-button',
        type: 'button',
        icon: isEditorControlsEnabled ? (0, (/*@__PURE__*/$parcel$interopDefault($j7FKK))) : (0, (/*@__PURE__*/$parcel$interopDefault($eNuIV))),
        title: intl.formatMessage((0, $2HqML.messages).expand),
        onClick: ()=>{
            return (0, $2L3c8.handleShowMediaViewer)({
                mediaPluginState: mediaPluginState,
                api: pluginInjectionApi
            }) ?? false;
        },
        supportsViewMode: true
    }, ...mauiToolbarSeparatorsUpdateEnabled ? [] : [
        {
            type: 'separator',
            supportsViewMode: true
        }
    ]);
    // open link
    if (allowLinking && (0, $ipOKx.shouldShowMediaLinkToolbar)(state) && mediaLinkingState && mediaLinkingState.editable && isEditorControlsEnabled) inlineImageItems.push((0, $ipOKx.getOpenLinkToolbarButtonOption)(intl, mediaLinkingState, pluginInjectionApi), ...mauiToolbarSeparatorsUpdateEnabled ? [] : [
        {
            type: 'separator',
            supportsViewMode: true
        }
    ]);
    if (isViewOnly && !isEditorControlsEnabled) inlineImageItems.push(download, {
        type: 'separator',
        supportsViewMode: true
    });
    if (allowAltTextOnImages && !isEditorControlsEnabled) {
        var _pluginInjectionApi$a5;
        inlineImageItems.push((0, $gHqj4.altTextButton)(intl, state, pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$a5 = pluginInjectionApi.analytics) === null || _pluginInjectionApi$a5 === void 0 ? void 0 : _pluginInjectionApi$a5.actions), {
            type: 'separator'
        });
    }
    if (isViewOnly || !isEditorControlsEnabled) inlineImageItems.push({
        type: 'copy-button',
        supportsViewMode: true,
        items: [
            {
                state: state,
                formatMessage: intl.formatMessage,
                nodeType: mediaInline
            }
        ]
    });
    if (!isEditorControlsEnabled) {
        inlineImageItems.push({
            type: 'separator'
        });
        inlineImageItems.push({
            id: 'editor.media.delete',
            type: 'button',
            appearance: 'danger',
            focusEditoronEnter: true,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($gV64P))),
            onMouseEnter: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(mediaInline, true),
            onMouseLeave: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(mediaInline, false),
            onFocus: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(mediaInline, true),
            onBlur: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(mediaInline, false),
            title: intl.formatMessage((0, $fNLdd.default).remove),
            onClick: (0, $jAHUG.removeInlineCardWithAnalytics)(editorAnalyticsAPI),
            testId: 'media-toolbar-remove-button'
        });
    }
    return inlineImageItems;
};

});

parcelRegister("hX4GT", function(module, exports) {
$parcel$export(module.exports, "getPixelResizingToolbar", () => $4be5cd2a4088d8e7$export$bee6402990837b71);
$parcel$export(module.exports, "getResizeDropdownOption", () => $4be5cd2a4088d8e7$export$162f6210a4cda095);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $82LN8 = parcelRequire("82LN8");

var $gab48 = parcelRequire("gab48");

var $kGogQ = parcelRequire("kGogQ");

var $lzc7g = parcelRequire("lzc7g");

var $b1AVF = parcelRequire("b1AVF");

var $cz0Kt = parcelRequire("cz0Kt");

var $7omWA = parcelRequire("7omWA");
const $4be5cd2a4088d8e7$export$bee6402990837b71 = (toolbarBaseConfig, { pluginInjectionApi: pluginInjectionApi, intl: intl, pluginState: pluginState, hoverDecoration: hoverDecoration, isEditorFullWidthEnabled: isEditorFullWidthEnabled, triggerButtonSelector: triggerButtonSelector })=>({
        ...toolbarBaseConfig,
        width: (0, $cz0Kt.PIXEL_RESIZING_TOOLBAR_WIDTH),
        scrollable: true,
        items: [
            {
                type: 'custom',
                fallback: [],
                render: (editorView)=>{
                    if (!editorView) return null;
                    const selectedMediaSingleNode = (0, $7omWA.getSelectedMediaSingle)(editorView.state);
                    if (!editorView || !selectedMediaSingleNode) return null;
                    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $b1AVF.PixelEntry), {
                        editorView: editorView,
                        intl: intl,
                        selectedMediaSingleNode: selectedMediaSingleNode,
                        pluginInjectionApi: pluginInjectionApi,
                        pluginState: pluginState,
                        hoverDecoration: hoverDecoration,
                        isEditorFullWidthEnabled: isEditorFullWidthEnabled,
                        triggerButtonSelector: triggerButtonSelector
                    });
                }
            }
        ]
    });
const $4be5cd2a4088d8e7$export$162f6210a4cda095 = (mediaOptions, state, formatMessage, selectedNodeType)=>{
    if ((selectedNodeType === null || selectedNodeType === void 0 ? void 0 : selectedNodeType.name) !== 'mediaSingle') return [];
    const { allowResizing: allowResizing, allowResizingInTables: allowResizingInTables, allowAdvancedToolBarOptions: allowAdvancedToolBarOptions, allowPixelResizing: allowPixelResizing } = mediaOptions;
    const isWithinTable = (0, $gab48.hasParentNodeOfType)(state.schema.nodes.table)(state.selection);
    if (allowAdvancedToolBarOptions && allowResizing && (!isWithinTable || allowResizingInTables === true) && allowPixelResizing) return [
        {
            title: formatMessage((0, $82LN8.pixelEntryMessages).resizeOption),
            onClick: (0, $lzc7g.openPixelEditor)(),
            icon: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kGogQ))), {
                label: ""
            }),
            testId: 'media-pixel-resizing-dropdown-option'
        }
    ];
    return [];
};

});


parcelRegister("cG8zd", function(module, exports) {
$parcel$export(module.exports, "default", () => $4338bddf1ded9e33$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $fK3tS = parcelRequire("fK3tS");

var $bnf0l = parcelRequire("bnf0l");

var $jNAGw = parcelRequire("jNAGw");

var $8zO6u = parcelRequire("8zO6u");

var $5beht = parcelRequire("5beht");

var $5PeKn = parcelRequire("5PeKn");
const $4338bddf1ded9e33$var$onClickMediaButton = (showMediaPicker)=>()=>{
        showMediaPicker();
        return true;
    };
const $4338bddf1ded9e33$var$selector = (states)=>{
    var _states$mediaState, _states$mediaState2;
    return {
        allowsUploads: (_states$mediaState = states.mediaState) === null || _states$mediaState === void 0 ? void 0 : _states$mediaState.allowsUploads,
        showMediaPicker: (_states$mediaState2 = states.mediaState) === null || _states$mediaState2 === void 0 ? void 0 : _states$mediaState2.showMediaPicker
    };
};
const $4338bddf1ded9e33$var$ToolbarMedia = ({ isDisabled: isDisabled, isReducedSpacing: isReducedSpacing, intl: intl, api: api })=>{
    const { allowsUploads: allowsUploads, showMediaPicker: showMediaPicker } = (0, $5beht.useSharedPluginStateWithSelector)(api, [
        'media'
    ], $4338bddf1ded9e33$var$selector);
    if (!allowsUploads || !showMediaPicker) return null;
    const { toolbarMediaTitle: toolbarMediaTitle } = (0, $jNAGw.toolbarMediaMessages);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $8zO6u.default), {
        buttonId: (0, $bnf0l.TOOLBAR_ACTION_SUBJECT_ID).MEDIA,
        onClick: $4338bddf1ded9e33$var$onClickMediaButton(showMediaPicker),
        disabled: isDisabled,
        title: intl.formatMessage(toolbarMediaTitle),
        spacing: isReducedSpacing ? 'none' : 'default',
        iconBefore: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5PeKn))), {
            label: intl.formatMessage(toolbarMediaTitle)
        })
    });
};
// eslint-disable-next-line @typescript-eslint/no-restricted-types
const $4338bddf1ded9e33$var$_default_1 = (0, $fK3tS.default)($4338bddf1ded9e33$var$ToolbarMedia);
var $4338bddf1ded9e33$export$2e2bcd8739ae039 = $4338bddf1ded9e33$var$_default_1;

});
parcelRegister("jNAGw", function(module, exports) {
$parcel$export(module.exports, "toolbarMediaMessages", () => $4bbc3d97f04cfa1d$export$1e0626fa34762ce3);

var $f0Pt4 = parcelRequire("f0Pt4");
const $4bbc3d97f04cfa1d$export$1e0626fa34762ce3 = (0, $f0Pt4.defineMessages)({
    toolbarMediaTitle: {
        id: 'fabric.editor.toolbarMediaTitle',
        defaultMessage: 'Add image, video, or file',
        description: 'a label for an icon that describes files, videos and images'
    }
});

});



parcelRegister("ixSRH", function(module, exports) {
$parcel$export(module.exports, "insm", () => $ba5be2d840a803d0$export$2945ea0ab201da79);

var $hjVnd = parcelRequire("hjVnd");
let $ba5be2d840a803d0$var$initialisedInsm;
function $ba5be2d840a803d0$export$2cd8252107eb640b(options) {
    $ba5be2d840a803d0$var$initialisedInsm = new (0, $hjVnd.INSM)(options);
}
function $ba5be2d840a803d0$var$insmInitialised() {
    if (!$ba5be2d840a803d0$var$initialisedInsm) return false;
    return true;
}
const $ba5be2d840a803d0$export$2945ea0ab201da79 = {
    startHeavyTask (heavyTaskName) {
        if ($ba5be2d840a803d0$var$insmInitialised()) $ba5be2d840a803d0$var$initialisedInsm.startHeavyTask(heavyTaskName);
    },
    endHeavyTask (heavyTaskName) {
        if ($ba5be2d840a803d0$var$insmInitialised()) $ba5be2d840a803d0$var$initialisedInsm.endHeavyTask(heavyTaskName);
    },
    start (experienceKey, experienceProperties) {
        if ($ba5be2d840a803d0$var$insmInitialised()) $ba5be2d840a803d0$var$initialisedInsm.start(experienceKey, experienceProperties);
    },
    overrideExperienceKey (experienceKey) {
        if ($ba5be2d840a803d0$var$insmInitialised()) $ba5be2d840a803d0$var$initialisedInsm.overrideExperienceKey(experienceKey);
    },
    stopEarly (reasonKey, description) {
        if ($ba5be2d840a803d0$var$insmInitialised()) $ba5be2d840a803d0$var$initialisedInsm.stopEarly(reasonKey, description);
    },
    // We only expose details and feature start/stop to consumers
    // as the other properties are internals for the insm and InsmPeriod
    // to interact with the running session.
    get session () {
        if ($ba5be2d840a803d0$var$insmInitialised()) return $ba5be2d840a803d0$var$initialisedInsm.runningSession;
    },
    // @ts-expect-error Private method for testing purposes
    __setAnalyticsWebClient (analyticsWebClient) {
        if ($ba5be2d840a803d0$var$initialisedInsm) $ba5be2d840a803d0$var$initialisedInsm.analyticsWebClient = analyticsWebClient;
    }
};

});
parcelRegister("hjVnd", function(module, exports) {
$parcel$export(module.exports, "INSM", () => $60db75b11dd5ee6d$export$4b79d93e0c782a13);

var $5N1Y4 = parcelRequire("5N1Y4");

var $qv756 = parcelRequire("qv756");

var $hIKlg = parcelRequire("hIKlg");
class $60db75b11dd5ee6d$export$4b79d93e0c782a13 {
    constructor(options){
        /**
   * Heavy tasks are tracked at the insm layer as heavy tasks
   * are expected at times to be unrelated to the current
   * page session.
   */ this.runningHeavyTasks = new Set();
        this.periodMeasurers = [
            new (0, $qv756.INPTracker)()
        ];
        this.options = options;
        // If this does throw -- we do want an unhandledRejection rejection to be passed to the window
        // this is to ease debugging.
        options.getAnalyticsWebClient.then((analyticsWebClient)=>this.analyticsWebClient = analyticsWebClient);
        // No cleanup needs to be performed -- as this tooling is intended to run until the tab is closed
        // The use of beforeunload here is because using pagehide does not reliably result in the analytics
        // being fired by the analytics web client.
        // The use of this means we will miss events from mobile safari which does not reliably call this api
        // however mobile browsers do not call when a browser closes - so we expect limited mobile data from
        // this tooling in its current form.
        // window will not be defined in server envs - in these envs -- there can never be a session end
        if (typeof window !== 'undefined') // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.addEventListener('beforeunload', ()=>{
            var _this$runningSession;
            (_this$runningSession = this.runningSession) === null || _this$runningSession === void 0 || _this$runningSession.end({
                stoppedBy: 'beforeunload'
            });
        });
    }
    /**
   * Starts a heavy task in the currently running session.
   *
   * This also pauses measurement.
   *
   * For PageLoads using the key 'PageLoad' will mean the heavy task duration
   * is added to the insm session event as pageLoadTime.
   */ startHeavyTask(heavyTaskName) {
        var _this$runningSession2, _this$runningSession3, _this$runningSession4;
        this.runningHeavyTasks.add(heavyTaskName);
        (_this$runningSession2 = this.runningSession) === null || _this$runningSession2 === void 0 || (_this$runningSession2 = _this$runningSession2.periodTracking) === null || _this$runningSession2 === void 0 || _this$runningSession2.startHeavyTask(heavyTaskName);
        (_this$runningSession3 = this.runningSession) === null || _this$runningSession3 === void 0 || _this$runningSession3.periodTracking.pause(heavyTaskName);
        (_this$runningSession4 = this.runningSession) === null || _this$runningSession4 === void 0 || _this$runningSession4.longAnimationFrameMeasurer.pause();
    }
    /**
   * Ends a heavy task in the currently running session
   */ endHeavyTask(heavyTaskName) {
        var _this$runningSession5;
        this.runningHeavyTasks.delete(heavyTaskName);
        (_this$runningSession5 = this.runningSession) === null || _this$runningSession5 === void 0 || _this$runningSession5.periodTracking.resume(heavyTaskName);
        if (this.runningHeavyTasks.size === 0) {
            var _this$runningSession6;
            (_this$runningSession6 = this.runningSession) === null || _this$runningSession6 === void 0 || _this$runningSession6.longAnimationFrameMeasurer.resume();
        }
        if ((0, $5N1Y4.expValEquals)('cc_editor_insm_outlier_events', 'cohort', 'test')) {
            if (heavyTaskName === 'PageLoad') {
                var _this$runningSession7;
                (_this$runningSession7 = this.runningSession) === null || _this$runningSession7 === void 0 || _this$runningSession7.completePageLoad();
            }
        }
    }
    /**
   * Call this when starting a new experience.  This is expected to be wired to the product
   * routing solution.
   *
   * It's expected this call will be paired with a `insm.session.startHeavyTask('PageLoad')` and
   * subsequent `insm.session.endHeavyTask('PageLoad')` so that performance degradations linked
   * to the page initialisation are excluded from the active interactivity monitoring.
   *
   * Using the key 'PageLoad' is special and will result in the heavy task duration being added to the
   * insm session event as pageLoadTime.
   *
   *
   * ```ts
   * insm.start('edit-page', { initial: true, contentId: '9001' })
   * insm.session.startHeavyTask('PageLoad')
   * // ... heavy initialisation work
   * insm.session.endHeavyTask('PageLoad')
   * ```
   */ start(experienceKey, experienceProperties) {
        var _this$options$experie;
        if (this.runningSession !== undefined) this.runningSession.end({
            stoppedBy: 'new-experience',
            experienceKey: experienceKey,
            contentId: experienceProperties.contentId
        });
        this.lastStartedExperienceProperties = experienceProperties;
        if ((_this$options$experie = this.options.experiences[experienceKey]) !== null && _this$options$experie !== void 0 && _this$options$experie.enabled) this.runningSession = new (0, $hIKlg.INSMSession)(experienceKey, experienceProperties, this);
    }
    /**
   * Call this to update the name of the running session after it's started
   * In the case it's been started with an unregistered name, and there is not running
   * session. This will also trigger the session being started.
   */ overrideExperienceKey(experienceKey) {
        if (this.runningSession !== undefined) // If there is a running session - we update its name
        this.runningSession.updateExperienceKey(experienceKey);
        else {
            var _this$options$experie2;
            // otherwise - we assume the last session was not registered, and start it with the new name
            if ((_this$options$experie2 = this.options.experiences[experienceKey]) !== null && _this$options$experie2 !== void 0 && _this$options$experie2.enabled && this.lastStartedExperienceProperties) this.runningSession = new (0, $hIKlg.INSMSession)(experienceKey, this.lastStartedExperienceProperties, this);
        }
    }
    /**
   * This prematurely halts any running experience measurement. It's expected to be used in
   * scenarios such as when error boundaries are hit.
   */ stopEarly(reasonKey, description) {
        var _this$runningSession8;
        (_this$runningSession8 = this.runningSession) === null || _this$runningSession8 === void 0 || _this$runningSession8.earlyStop(reasonKey, description);
    }
    /**
   * Gets the current running session details
   */ get session() {
        return this.runningSession;
    }
}

});
parcelRegister("qv756", function(module, exports) {
$parcel$export(module.exports, "INPTracker", () => $a44edd263d7096a6$export$4551d640419205b3);
class $a44edd263d7096a6$export$4551d640419205b3 {
    constructor(options){
        /**
   * INP stands for Interaction to Next Paint
   */ this.name = 'inp';
        this.includedInteractions = (options === null || options === void 0 ? void 0 : options.includedInteractions) || [
            'pointerdown',
            'pointerup',
            'click',
            'keydown',
            'keyup'
        ];
        this.monitor = new $a44edd263d7096a6$var$InteractionTracker(this.includedInteractions);
    }
    start(paused) {
        const result = this.monitor.start(paused);
        return result;
    }
    end() {
        const result = this.monitor.end();
        return result;
    }
    pause() {
        this.monitor.pause();
    }
    resume() {
        this.monitor.resume();
    }
}
class $a44edd263d7096a6$var$InteractionResult {
    constructor(){
        this.min = Infinity;
        this.max = 0;
        this.average = 0;
        this.numerator = 0;
        this.count = 0;
    }
    update(duration) {
        if (duration > this.max) this.max = duration;
        if (duration < this.min) this.min = duration;
        this.numerator += duration;
        this.count += 1;
        this.average = this.numerator / this.count;
    }
    toMeasure() {
        return {
            min: this.count === 0 ? 0 : this.min,
            max: this.max,
            average: this.average,
            numerator: this.numerator,
            denominator: this.count
        };
    }
}
class $a44edd263d7096a6$var$InteractionTracker {
    constructor(includedInteractions){
        this.paused = false;
        this.performanceObserver = null;
        this.interactionResult = new $a44edd263d7096a6$var$InteractionResult();
        this.includedInteractions = includedInteractions;
    }
    stopTracking() {
        var _this$performanceObse;
        (_this$performanceObse = this.performanceObserver) === null || _this$performanceObse === void 0 || _this$performanceObse.disconnect();
        this.performanceObserver = null;
    }
    startTracking() {
        this.performanceObserver = new PerformanceObserver((list)=>{
            // Note: find link to actual safari issue .. good to get rid of this if Safari has fixed this
            // Delay by a microtask to workaround a bug in Safari where the
            // callback is invoked immediately, rather than in a separate task.
            // See: https://github.com/GoogleChrome/web-vitals/issues/277
            Promise.resolve().then(()=>{
                const entries = list.getEntries();
                entries.forEach((entry)=>{
                    // Skip further processing for entries that cannot be INP candidates.
                    //
                    // When a user interacts with a web page, a user interaction (for example a click) usually triggers a sequence of events.
                    // To measure the latency of this series of events, the events share the same interactionId.
                    // An interactionId is only computed for the following event types belonging to a user interaction. It is 0 otherwise.
                    // * click / tap / drag events: 'pointerdown', 'pointerup', 'click'
                    // * keypress events: 'keydown', 'keyup'
                    //
                    if (!entry.interactionId) return;
                    if (this.includedInteractions.includes(entry.name)) this.interactionResult.update(entry.duration);
                });
            });
        });
        // Event Timing entries have their durations rounded to the nearest 8ms,
        // so a duration of 40ms would be any event that spans 2.5 or more frames
        // at 60Hz. This threshold is chosen to strike a balance between usefulness
        // and performance. Running this callback for any interaction that spans
        // just one or two frames is likely not worth the insight that could be
        // gained.
        if (PerformanceObserver.supportedEntryTypes.includes('event')) this.performanceObserver.observe({
            type: 'event',
            buffered: false,
            durationThreshold: 40
        });
    }
    reset() {
        this.stopTracking();
        this.interactionResult = new $a44edd263d7096a6$var$InteractionResult();
    }
    start(paused) {
        const lastResult = this.interactionResult.toMeasure();
        this.reset();
        this.paused = paused;
        if (!paused) this.startTracking();
        return lastResult;
    }
    end() {
        try {
            return this.interactionResult.toMeasure();
        } finally{
            this.reset();
        }
    }
    pause() {
        if (this.paused) return;
        this.paused = true;
        this.stopTracking();
    }
    resume() {
        if (!this.paused) return;
        this.paused = false;
        this.startTracking();
    }
}

});

parcelRegister("hIKlg", function(module, exports) {
$parcel$export(module.exports, "INSMSession", () => $519ecd7eb2727969$export$15db790bb6e6f6d1);

var $iMLER = parcelRequire("iMLER");

var $5N1Y4 = parcelRequire("5N1Y4");

var $hf0Z9 = parcelRequire("hf0Z9");

var $9OOOa = parcelRequire("9OOOa");
class $519ecd7eb2727969$export$15db790bb6e6f6d1 {
    constructor(experienceKey, experienceProperties, insm){
        this.startedAt = performance.now();
        this.pageLoadTime = null;
        this.running = true;
        this.addedProperties = [];
        this.staticProperties = {};
        this.runningFeatures = new Set();
        this.experienceKey = experienceKey;
        this.experienceProperties = experienceProperties;
        this.insm = insm;
        this.periodTracking = new (0, $hf0Z9.PeriodTracking)(this);
        this.longAnimationFrameMeasurer = new (0, $9OOOa.LongAnimationFrameMeasurer)({
            initial: this.experienceProperties.initial,
            limit: 3,
            insmSession: this,
            reportingThreshold: 500
        });
    }
    /**
   * Completes the page load timing. This is called automatically when ending a heavy task
   * with the key 'PageLoad'.
   */ completePageLoad() {
        this.pageLoadTime = performance.now() - this.startedAt;
    }
    updateExperienceKey(experienceKey) {
        this.experienceKey = experienceKey;
    }
    /**
   * Adds a feature to the currently running session
   */ startFeature(featureName) {
        var _this$periodTracking;
        this.runningFeatures.add(featureName);
        (_this$periodTracking = this.periodTracking) === null || _this$periodTracking === void 0 || _this$periodTracking.startFeature(featureName);
    }
    /**
   * Ends a features usage in the currently running session
   */ endFeature(featureName) {
        this.runningFeatures.delete(featureName);
    }
    /**
   * Returns details on the current session.
   */ get details() {
        return {
            experienceKey: this.experienceKey,
            experienceProperties: this.experienceProperties,
            paused: this.periodTracking.pauses.size > 0,
            periodState: this.periodTracking.state,
            /**
       * The only scenario where this value should return false is when
       * the experience has been stopped early.
       */ running: this.running
        };
    }
    /**
   * This api is an alternative to addProperties for scenarios
   * such as where you have a hot path that will repeatedly fire
   * throughout a session.
   * The last value for a given key will be used, and if there is a
   * matching key from addProperties, the addProperties value will be used.
   *
   * ```ts
   * insm.session.addProperties('custom:lcm', true)
   * ```
   */ setProperty(key, value) {
        this.staticProperties[key] = value;
    }
    /**
   * This api takes either a static single-level key-value object, or callbacks which return the same and
   * will be evaluated on session end.
   *
   * When ending a session, all properties received via this api are merged, in order, into the resulting
   * insm event’s properties; last write wins.
   *
   * Callback values are evaluated at session end.
   *
   * For example, for the following
   *
   * ```ts
   * insm.experience.addProperties({ one: 1, two: 2 });
   * insm.experience.addProperties(() => ({ one: 'one' }));
   * insm.experience.addProperties({ three: 3 });
   * ```
   *
   * The resulting added properties will be
   *
   * ```ts
   * { one: 'one', two: 2, three: 3 }
   * ```
   */ addProperties(propertiesToAdd) {
        this.addedProperties.push(propertiesToAdd);
    }
    /**
   * In some scenarios (ie. when a page error boundary is hit), you will want to exit early.
   * This is api supports these scenarios
   *
   * ```ts
   * insm.stopEarly(reasonKey: string, description: string);
   * ```
   *
   * Sessions closed early are identifiable by their end details
   * `"endDetails": { stoppedBy: "early-stop", reasonKey, description }`.
   *
   * **Note**: The session is ended as soon as this is called, and any `addProperties` handlers will
   * called immediately.
   */ earlyStop(reason, description) {
        this.end({
            stoppedBy: 'early-stop',
            reason: reason,
            description: description
        });
    }
    end(endDetails) {
        var _periodResults$active, _periodResults$active2, _periodResults$active3, _periodResults$active4, _this$insm$analyticsW;
        if (this.running === false) // If an experience has already been ended -- don't repeat the ending
        return;
        this.running = false;
        const endedAt = performance.now();
        const duration = endedAt - this.startedAt;
        const evaluatedAddedProperties = {};
        for (const addedProperty of this.addedProperties)if (typeof addedProperty === 'function') Object.assign(evaluatedAddedProperties, addedProperty());
        else Object.assign(evaluatedAddedProperties, addedProperty);
        const periodResults = this.periodTracking.endResults;
        /**
     * This event ends up as "insm measured"
     */ const operationalEvent = {
            actionSubject: 'insm',
            action: 'measured',
            attributes: {
                // Added first to ensure these don't overwrite any insm properties
                ...this.staticProperties,
                ...evaluatedAddedProperties,
                'event:population': this.insm.options.population,
                experienceKey: this.experienceKey,
                initial: this.experienceProperties.initial,
                contentId: this.experienceProperties.contentId,
                timing: {
                    startedAt: this.startedAt,
                    duration: // Note: this will not match up with the periods sum of durations, as it includes
                    // time paused when heavy tasks were running, and/or the page is in the background.
                    duration
                },
                periods: periodResults,
                endDetails: endDetails,
                ...(0, $5N1Y4.expValEquals)('cc_editor_insm_outlier_events', 'cohort', 'test') ? {
                    longScripts: this.longAnimationFrameMeasurer.current,
                    pageLoadTime: this.pageLoadTime,
                    deviceDetails: $519ecd7eb2727969$var$getDeviceDetails()
                } : {},
                // these health attributes drive our SLOs
                healthAFPS: (_periodResults$active = periodResults.active.measurements.afps) !== null && _periodResults$active !== void 0 && _periodResults$active.average ? ((_periodResults$active2 = periodResults.active.measurements.afps) === null || _periodResults$active2 === void 0 ? void 0 : _periodResults$active2.average) >= 50 : undefined,
                healthINP: (_periodResults$active3 = periodResults.active.measurements.inp) !== null && _periodResults$active3 !== void 0 && _periodResults$active3.average ? ((_periodResults$active4 = periodResults.active.measurements.inp) === null || _periodResults$active4 === void 0 ? void 0 : _periodResults$active4.average) >= 200 : undefined
            },
            highPriority: true,
            tags: [
                'editor'
            ],
            source: 'unknown'
        };
        (_this$insm$analyticsW = this.insm.analyticsWebClient) === null || _this$insm$analyticsW === void 0 || _this$insm$analyticsW.sendOperationalEvent(operationalEvent);
        this.longAnimationFrameMeasurer.cleanup();
    }
}
// Functionality vendored from UFO
function $519ecd7eb2727969$var$getDeviceDetails() {
    var _navigator$connection, _navigator$connection2, _navigator$connection3;
    const telemetry = {};
    // /platform/packages/data/ufo-internal/src/core/publisher/plugins/browser.ts
    if ((0, (/*@__PURE__*/$parcel$interopDefault($iMLER))).getParser) {
        var _ref;
        const browser = (0, (/*@__PURE__*/$parcel$interopDefault($iMLER))).getParser(((_ref = typeof window !== 'undefined' && !!window ? window : undefined) === null || _ref === void 0 || (_ref = _ref.navigator) === null || _ref === void 0 ? void 0 : _ref.userAgent) || '');
        Object.assign(telemetry, {
            'event:browser:name': browser.getBrowserName(),
            'event:browser:version': browser.getBrowserVersion()
        });
    }
    // /platform/packages/data/ufo-internal/src/core/publisher/plugins/cpus.ts
    Object.assign(telemetry, {
        'event:cpus': navigator.hardwareConcurrency
    });
    // /platform/packages/data/ufo-internal/src/core/publisher/plugins/memory.ts
    // @ts-ignore: deviceMemory is exposed in some browsers
    Object.assign(telemetry, {
        'event:memory': navigator.deviceMemory
    });
    // /platform/packages/data/ufo-internal/src/core/publisher/plugins/network.ts
    Object.assign(telemetry, {
        // Network
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'event:network:effectiveType': (_navigator$connection = navigator.connection) === null || _navigator$connection === void 0 ? void 0 : _navigator$connection.effectiveType,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'event:network:rtt': (_navigator$connection2 = navigator.connection) === null || _navigator$connection2 === void 0 ? void 0 : _navigator$connection2.rtt,
        // @ts-ignore: connection is available in some browsers
        // eslint-disable-next-line compat/compat
        'event:network:downlink': (_navigator$connection3 = navigator.connection) === null || _navigator$connection3 === void 0 ? void 0 : _navigator$connection3.downlink
    });
    return telemetry;
}

});
parcelRegister("hf0Z9", function(module, exports) {
$parcel$export(module.exports, "PeriodTracking", () => $f7b111e7e79ebb02$export$715a4ea2578407b6);
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ class $f7b111e7e79ebb02$export$715a4ea2578407b6 {
    constructor(session){
        this.periodMeasurements = {
            active: {
                features: new Set(),
                heavyTasks: new Set(),
                measurements: {},
                duration: 0,
                count: 0
            },
            inactive: {
                features: new Set(),
                heavyTasks: new Set(),
                measurements: {},
                duration: 0,
                count: 0
            }
        };
        this.state = 'inactive';
        this.pauses = new Set();
        /**
   * Warning: this can be reset mid period when pausing/resuming.
   * It's intended use is to build the `periodMeasurements` duration.
   */ this.currentPeriodStart = performance.now();
        this.activeStartListeners = [];
        this.activeEndListeners = [];
        /**
   * This works by;
   * On setup
   * - starts activity listeners
   *   - on activity received
   *     - possible end active count down started.
   *       3 animation frames or 3 seconds of inactivity - whichever comes first
   *     - any existing end count down ended
   */ this.activeEndCountDownAbortController = new AbortController();
        this.session = session;
        this.latestPeriodFeatures = new Set(session.runningFeatures);
        this.latestHeavyTasks = new Set(session.insm.runningHeavyTasks);
        this.pauses = new Set(session.insm.runningHeavyTasks);
        const startInteractivityMeasuresPaused = this.latestHeavyTasks.size !== 0;
        for (const periodMeasurer of session.insm.periodMeasurers){
            if (!periodMeasurer) continue;
            periodMeasurer.start(startInteractivityMeasuresPaused);
            this.periodMeasurements.active.measurements[periodMeasurer.name] = {
                numerator: 0,
                denominator: 0,
                max: 0,
                min: 0,
                average: 0
            };
            this.periodMeasurements.inactive.measurements[periodMeasurer.name] = {
                numerator: 0,
                denominator: 0,
                max: 0,
                min: 0,
                average: 0
            };
        }
        this.setupActiveStartInteractionListeners();
    }
    startFeature(featureName) {
        this.latestPeriodFeatures.add(featureName);
        this.periodMeasurements[this.state].features.add(featureName);
    }
    startHeavyTask(heavyTaskName) {
        this.latestHeavyTasks.add(heavyTaskName);
        this.periodMeasurements[this.state].heavyTasks.add(heavyTaskName);
        this.pause(heavyTaskName);
    }
    endHeavyTask(heavyTaskName) {
        this.resume(heavyTaskName);
    }
    /**
   * Sets a pause based on a key.  If this is the first pause, then it will also halt
   * running interactivity measures, and update the current measurements duration.
   */ pause(pauseName) {
        if (this.pauses.size === 0) {
            this.periodMeasurements[this.state].duration = this.periodMeasurements[this.state].duration + (performance.now() - this.currentPeriodStart);
            for (const periodMeasurer of this.session.insm.periodMeasurers)periodMeasurer === null || periodMeasurer === void 0 || periodMeasurer.pause();
        }
        this.pauses.add(pauseName);
    }
    /**
   * Releases a pause for a key.
   *
   * **NOTE**: The session will only resume if this was the only
   * currently tracked pause key.
   */ resume(pauseName) {
        this.pauses.delete(pauseName);
        if (this.pauses.size === 0) {
            this.currentPeriodStart = performance.now();
            for (const periodMeasurer of this.session.insm.periodMeasurers)periodMeasurer === null || periodMeasurer === void 0 || periodMeasurer.resume();
        }
    }
    get endResults() {
        this.changePeriodAndTrackLast(this.state);
        return {
            active: {
                features: Array.from(this.periodMeasurements.active.features),
                heavyTasks: Array.from(this.periodMeasurements.active.heavyTasks),
                measurements: this.periodMeasurements.active.measurements,
                duration: this.periodMeasurements.active.duration,
                count: this.periodMeasurements.active.count
            },
            inactive: {
                features: Array.from(this.periodMeasurements.inactive.features),
                heavyTasks: Array.from(this.periodMeasurements.inactive.heavyTasks),
                measurements: this.periodMeasurements.inactive.measurements,
                duration: this.periodMeasurements.inactive.duration,
                count: this.periodMeasurements.inactive.count
            }
        };
    }
    setupActiveStartInteractionListeners() {
        const events = [
            'mousemove',
            'pointerdown',
            'pointerup',
            'click',
            'keydown',
            'keyup',
            'scroll'
        ];
        for (const event of events){
            const eventListener = ()=>{
                // start event
                this.changePeriodAndTrackLast('inactive', 'active');
            };
            window.addEventListener(event, eventListener, {
                once: true
            });
            this.activeStartListeners.push([
                event,
                eventListener
            ]);
        }
    }
    setupEndActiveInteractionListeners() {
        this.activeEndCountDownVisibilityListener = ()=>{
            if (document.visibilityState === 'hidden') endSession();
        };
        window.addEventListener('visibilitychange', this.activeEndCountDownVisibilityListener);
        const events = [
            'mousemove',
            'pointerdown',
            'pointerup',
            'click',
            'keydown',
            'keyup',
            'scroll'
        ];
        for (const event of events){
            const eventListener = ()=>{
                this.activeEndCountDownAbortController.abort();
                this.activeEndCountDownAbortController = new AbortController();
                $f7b111e7e79ebb02$var$startPeriodEndCountDown(this.activeEndCountDownAbortController.signal, ()=>{
                    endSession();
                });
            };
            window.addEventListener(event, eventListener);
            this.activeEndListeners.push([
                event,
                eventListener
            ]);
        }
        const endSession = ()=>{
            this.activeEndCountDownAbortController.abort();
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            window.removeEventListener('visibilitychange', this.activeEndCountDownVisibilityListener);
            for (const activeEndListener of this.activeEndListeners)window.removeEventListener(activeEndListener[0], activeEndListener[1]);
            this.changePeriodAndTrackLast('active', 'inactive');
        };
        // When first setting up -- there has just been an interaction -- so we start a countdown
        this.activeEndCountDownAbortController.abort();
        this.activeEndCountDownAbortController = new AbortController();
        $f7b111e7e79ebb02$var$startPeriodEndCountDown(this.activeEndCountDownAbortController.signal, ()=>{
            endSession();
        });
    }
    changePeriodAndTrackLast(lastPeriod, newPeriod) {
        var _this$activeEndCountD;
        this.periodMeasurements[lastPeriod].duration = this.periodMeasurements[lastPeriod].duration + (performance.now() - this.currentPeriodStart);
        this.periodMeasurements[lastPeriod].count++;
        const interactivityMeasuresPaused = this.latestHeavyTasks.size !== 0;
        for (const interactivityMeasure of this.session.insm.periodMeasurers){
            if (!interactivityMeasure) continue;
            const finalResult = newPeriod ? interactivityMeasure.start(interactivityMeasuresPaused) : interactivityMeasure.end();
            const tracked = this.periodMeasurements[lastPeriod].measurements[interactivityMeasure.name];
            if (finalResult.average === 0) ;
            else if (tracked.average === 0) // In this case -- we haven't had any entries come through yet - so we replace any existing entries
            this.periodMeasurements[lastPeriod].measurements[interactivityMeasure.name] = finalResult;
            else {
                // In this case there is a new measurement which we merge with the previous measurement
                const merged = {
                    numerator: finalResult.numerator + tracked.numerator,
                    denominator: finalResult.denominator + tracked.denominator,
                    average: (finalResult.numerator + tracked.numerator) / (finalResult.denominator + tracked.denominator),
                    max: tracked.max === 0 || finalResult.max > tracked.max ? finalResult.max : tracked.max,
                    min: tracked.min === 0 || finalResult.min < tracked.min ? finalResult.min : tracked.min
                };
                this.periodMeasurements[lastPeriod].measurements[interactivityMeasure.name] = merged;
            }
        }
        for (const listener of this.activeStartListeners)window.removeEventListener(listener[0], listener[1]);
        for (const listener of this.activeEndListeners)window.removeEventListener(listener[0], listener[1]);
        (_this$activeEndCountD = this.activeEndCountDownAbortController) === null || _this$activeEndCountD === void 0 || _this$activeEndCountD.abort();
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        window.removeEventListener('visibilitychange', this.activeEndCountDownVisibilityListener);
        if (newPeriod) {
            this.latestPeriodFeatures = new Set(this.session.runningFeatures);
            this.session.runningFeatures.forEach((featureName)=>{
                this.periodMeasurements[newPeriod].features.add(featureName);
            });
            this.latestHeavyTasks = new Set(this.session.insm.runningHeavyTasks);
            this.currentPeriodStart = performance.now();
            switch(newPeriod){
                case 'active':
                    this.setupEndActiveInteractionListeners();
                    this.state = 'active';
                    break;
                case 'inactive':
                    this.setupActiveStartInteractionListeners();
                    this.state = 'inactive';
                    break;
            }
        }
    }
}
function $f7b111e7e79ebb02$var$startPeriodEndCountDown(signal, handleEnd) {
    let animationFramesSinceLastInteraction = 0;
    let inactiveTimeReached = false;
    let timer;
    let animationFrameHandler;
    const monitorAnimationFrames = ()=>{
        animationFrameHandler = requestAnimationFrame(()=>{
            animationFramesSinceLastInteraction++;
            if (animationFramesSinceLastInteraction < 3) monitorAnimationFrames();
            else if (inactiveTimeReached) handleEnd();
        });
    };
    const monitorTime = ()=>{
        timer = setTimeout(()=>{
            inactiveTimeReached = true;
            if (animationFramesSinceLastInteraction === 3) handleEnd();
        }, 3000);
    };
    monitorTime();
    monitorAnimationFrames();
    signal.addEventListener('abort', ()=>{
        clearTimeout(timer);
        cancelAnimationFrame(animationFrameHandler);
    });
}

});

parcelRegister("9OOOa", function(module, exports) {
$parcel$export(module.exports, "LongAnimationFrameMeasurer", () => $b6bc21bcf5e23599$export$c53843efd6e2e499);
class $b6bc21bcf5e23599$export$c53843efd6e2e499 {
    constructor(options){
        this.longestScriptTimings = [];
        this.minimumIndex = -1;
        this.minimumDuration = Infinity;
        this.options = options;
        this.paused = options.insmSession.insm.runningHeavyTasks.size !== 0;
        if (PerformanceObserver.supportedEntryTypes.includes('long-animation-frame')) {
            this.observer = new PerformanceObserver((list)=>{
                if (!this.paused) // only handle batches when tracking is not paused
                this.handleBatch(list.getEntries());
            });
            this.observer.observe({
                type: 'long-animation-frame',
                buffered: options.initial
            });
        }
    }
    handleBatch(batch) {
        for(let batchIndex = 0; batchIndex < batch.length; batchIndex++){
            const animationFrame = batch[batchIndex];
            // Only process frames that exceed the reporting threshold
            if (animationFrame.duration < this.options.reportingThreshold) continue;
            // Process all scripts in this long animation frame
            if (animationFrame.scripts && animationFrame.scripts.length > 0) for (const script of animationFrame.scripts)this.processScript(script, animationFrame);
        }
    }
    createScriptTiming(script, animationFrame) {
        return {
            duration: script.duration,
            forcedStyleAndLayoutDuration: script.forcedStyleAndLayoutDuration,
            invoker: script.invoker,
            invokerType: script.invokerType,
            sourceCharPosition: script.sourceCharPosition,
            sourceFunctionName: script.sourceFunctionName,
            sourceURL: script.sourceURL,
            features: Array.from(this.options.insmSession.runningFeatures),
            afDuration: animationFrame.duration
        };
    }
    processScript(script, animationFrame) {
        const scriptDuration = script.duration;
        const len = this.longestScriptTimings.length;
        // Not yet at capacity: append and update min tracking incrementally
        if (len < this.options.limit) {
            const scriptTiming = this.createScriptTiming(script, animationFrame);
            this.longestScriptTimings[len] = scriptTiming;
            if (len === 0 || scriptDuration < this.minimumDuration) {
                this.minimumDuration = scriptDuration;
                this.minimumIndex = len;
            }
            return;
        }
        // At capacity: only do work if we beat the current min
        if (scriptDuration <= this.minimumDuration) return;
        const scriptTiming = this.createScriptTiming(script, animationFrame);
        // Replace the current min
        this.longestScriptTimings[this.minimumIndex] = scriptTiming;
        // Find new minimum
        let newMinimumIndex = 0;
        let newMinimumDuration = this.longestScriptTimings[0].duration;
        for(let i = 1; i < this.options.limit; i++)if (this.longestScriptTimings[i].duration < newMinimumDuration) {
            newMinimumIndex = i;
            newMinimumDuration = this.longestScriptTimings[i].duration;
        }
        // Update the min tracking
        this.minimumIndex = newMinimumIndex;
        this.minimumDuration = newMinimumDuration;
    }
    /**
   * Pauses tracking
   */ pause() {
        this.paused = true;
    }
    /**
   * Resumes tracking
   */ resume() {
        this.paused = false;
    }
    /**
   * Returns the current tracked longest script timings sorted by duration
   */ get current() {
        const copy = this.longestScriptTimings.slice();
        copy.sort((a, b)=>b.duration - a.duration);
        return copy;
    }
    /**
   * Cleans up the performance tracking (tracking cannot be resumed following this).
   */ cleanup() {
        var _this$observer;
        (_this$observer = this.observer) === null || _this$observer === void 0 || _this$observer.disconnect();
    }
}

});




parcelRegister("48IYX", function(module, exports) {
$parcel$export(module.exports, "default", () => $8b88e8dbf7b62f8c$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $7JT5k = parcelRequire("7JT5k");

var $2hMtT = parcelRequire("2hMtT");

var $2VV1e = parcelRequire("2VV1e");

var $pScEb = parcelRequire("pScEb");

var $gAe8g = parcelRequire("gAe8g");

var $5BUNL = parcelRequire("5BUNL");

var $30Yan = parcelRequire("30Yan");

var $fY4jW = parcelRequire("fY4jW");

var $1guOi = parcelRequire("1guOi");

var $8iYGb = parcelRequire("8iYGb");

var $3y2s4 = parcelRequire("3y2s4");

var $gdUUy = parcelRequire("gdUUy");

var $5N1Y4 = parcelRequire("5N1Y4");

var $60Fyu = parcelRequire("60Fyu");

var $1ybhj = parcelRequire("1ybhj");

var $ffvbI = parcelRequire("ffvbI");

var $apTjI = parcelRequire("apTjI");

var $dfD9b = parcelRequire("dfD9b");

var $b9FtP = parcelRequire("b9FtP");
const $8b88e8dbf7b62f8c$var$PANEL_NODE_NAME = 'panel';
const $8b88e8dbf7b62f8c$var$panelPlugin = ({ config: { allowCustomPanel: allowCustomPanel = false, allowCustomPanelEdit: allowCustomPanelEdit = false } = {}, api: api })=>{
    var _api$blockMenu;
    api === null || api === void 0 || (_api$blockMenu = api.blockMenu) === null || _api$blockMenu === void 0 || _api$blockMenu.actions.registerBlockMenuComponents([
        {
            type: 'block-menu-item',
            key: (0, $30Yan.TRANSFORM_STRUCTURE_PANEL_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $30Yan.TRANSFORM_STRUCTURE_MENU_SECTION).key,
                rank: (0, $fY4jW.TRANSFORM_STRUCTURE_MENU_SECTION_RANK)[(0, $30Yan.TRANSFORM_STRUCTURE_PANEL_MENU_ITEM).key]
            },
            component: (0, $apTjI.createPanelBlockMenuItem)(api),
            isHidden: ()=>{
                var _api$blockMenu2;
                return Boolean(api === null || api === void 0 || (_api$blockMenu2 = api.blockMenu) === null || _api$blockMenu2 === void 0 ? void 0 : _api$blockMenu2.actions.isTransformOptionDisabled($8b88e8dbf7b62f8c$var$PANEL_NODE_NAME));
            }
        }
    ]);
    const isRegisteredSlashCommandEnabled = (0, $3y2s4.isExperimentEnabled)('platform_editor_slash_command');
    if (isRegisteredSlashCommandEnabled) {
        var _api$uiControlRegistr;
        api === null || api === void 0 || (_api$uiControlRegistr = api.uiControlRegistry) === null || _api$uiControlRegistr === void 0 || _api$uiControlRegistr.actions.register((0, $dfD9b.getPanelQuickInsertComponents)({
            allowCustomPanel: allowCustomPanel,
            allowCustomPanelEdit: allowCustomPanelEdit,
            api: api
        }));
    }
    return {
        name: 'panel',
        nodes () {
            if ((0, $gdUUy.fg)('platform_editor_adf_with_localid')) return [
                {
                    name: 'panel',
                    node: {
                        ...(0, $pScEb.extendedPanelWithLocalId)(!!allowCustomPanel),
                        definingAsContext: true
                    }
                },
                ...(0, $5N1Y4.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? [
                    {
                        name: 'panel_c1',
                        node: {
                            ...(0, $2VV1e.extendedPanelC1WithLocalId)(!!allowCustomPanel),
                            definingAsContext: true
                        }
                    }
                ] : []
            ];
            return [
                {
                    name: 'panel',
                    node: (0, $7JT5k.extendedPanel)(!!allowCustomPanel)
                },
                ...(0, $5N1Y4.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? [
                    {
                        name: 'panel_c1',
                        node: (0, $2hMtT.extendedPanelC1)(!!allowCustomPanel)
                    }
                ] : []
            ];
        },
        pmPlugins () {
            return [
                {
                    name: 'panel',
                    plugin: ({ providerFactory: providerFactory, dispatch: dispatch, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>(0, $ffvbI.createPlugin)(dispatch, providerFactory, {
                            allowCustomPanel: allowCustomPanel,
                            allowCustomPanelEdit: allowCustomPanelEdit
                        }, api, nodeViewPortalProviderAPI)
                },
                {
                    name: 'panelKeyMap',
                    plugin: ()=>(0, $1ybhj.default)()
                }
            ];
        },
        actions: {
            insertPanel (inputMethod) {
                return function(state, dispatch) {
                    const tr = (0, $60Fyu.createPanelAction)({
                        state: state,
                        attributes: {
                            panelType: (0, $gAe8g.PanelType).INFO
                        },
                        api: api,
                        inputMethod: inputMethod
                    });
                    if (!tr) return false;
                    if (dispatch) dispatch(tr);
                    return true;
                };
            }
        },
        pluginsOptions: {
            ...isRegisteredSlashCommandEnabled ? {} : {
                quickInsert: ({ formatMessage: formatMessage })=>{
                    const quickInsertOptions = [
                        {
                            id: 'infopanel',
                            title: formatMessage((0, $8iYGb.messages).infoPanel),
                            keywords: [
                                'panel'
                            ],
                            description: formatMessage((0, $8iYGb.messages).infoPanelDescription),
                            priority: 800,
                            icon: ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $5BUNL.IconPanel), {}),
                            action (typeAheadInsert, state) {
                                return (0, $60Fyu.createPanelAction)({
                                    state: state,
                                    attributes: {
                                        panelType: (0, $gAe8g.PanelType).INFO
                                    },
                                    api: api,
                                    typeAheadInsert: typeAheadInsert
                                });
                            }
                        },
                        {
                            id: 'notepanel',
                            title: formatMessage((0, $8iYGb.messages).notePanel),
                            description: formatMessage((0, $8iYGb.messages).notePanelDescription),
                            priority: 1000,
                            icon: ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $5BUNL.IconPanelNote), {}),
                            action (typeAheadInsert, state) {
                                return (0, $60Fyu.createPanelAction)({
                                    state: state,
                                    attributes: {
                                        panelType: (0, $gAe8g.PanelType).NOTE
                                    },
                                    api: api,
                                    typeAheadInsert: typeAheadInsert
                                });
                            }
                        },
                        {
                            id: 'successpanel',
                            title: formatMessage((0, $8iYGb.messages).successPanel),
                            description: formatMessage((0, $8iYGb.messages).successPanelDescription),
                            keywords: [
                                'tip'
                            ],
                            priority: 1000,
                            icon: ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $5BUNL.IconPanelSuccess), {}),
                            action (typeAheadInsert, state) {
                                return (0, $60Fyu.createPanelAction)({
                                    state: state,
                                    attributes: {
                                        panelType: (0, $gAe8g.PanelType).SUCCESS
                                    },
                                    api: api,
                                    typeAheadInsert: typeAheadInsert
                                });
                            }
                        },
                        {
                            id: 'warningpanel',
                            title: formatMessage((0, $8iYGb.messages).warningPanel),
                            description: formatMessage((0, $8iYGb.messages).warningPanelDescription),
                            priority: 1000,
                            icon: ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $5BUNL.IconPanelWarning), {}),
                            action (typeAheadInsert, state) {
                                return (0, $60Fyu.createPanelAction)({
                                    state: state,
                                    attributes: {
                                        panelType: (0, $gAe8g.PanelType).WARNING
                                    },
                                    api: api,
                                    typeAheadInsert: typeAheadInsert
                                });
                            }
                        },
                        {
                            id: 'errorpanel',
                            title: formatMessage((0, $8iYGb.messages).errorPanel),
                            description: formatMessage((0, $8iYGb.messages).errorPanelDescription),
                            priority: 1000,
                            icon: ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $5BUNL.IconPanelError), {}),
                            action (typeAheadInsert, state) {
                                return (0, $60Fyu.createPanelAction)({
                                    state: state,
                                    attributes: {
                                        panelType: (0, $gAe8g.PanelType).ERROR
                                    },
                                    api: api,
                                    typeAheadInsert: typeAheadInsert
                                });
                            }
                        }
                    ];
                    if (allowCustomPanel && allowCustomPanelEdit) quickInsertOptions.push({
                        id: 'custompanel',
                        title: formatMessage((0, $8iYGb.messages).customPanel),
                        description: formatMessage((0, $8iYGb.messages).customPanelDescription),
                        priority: 1000,
                        icon: ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $1guOi.default), {}),
                        action (typeAheadInsert, state) {
                            return (0, $60Fyu.createPanelAction)({
                                state: state,
                                attributes: {
                                    panelType: (0, $gAe8g.PanelType).CUSTOM,
                                    panelIcon: ':rainbow:',
                                    panelIconId: '1f308',
                                    panelIconText: "\uD83C\uDF08",
                                    // Ignored via go/ees007
                                    // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
                                    // TODO: https://product-fabric.atlassian.net/browse/DSP-7268
                                    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
                                    panelColor: '#E6FCFF'
                                },
                                api: api,
                                typeAheadInsert: typeAheadInsert
                            });
                        }
                    });
                    return quickInsertOptions;
                }
            },
            floatingToolbar: (state, intl, providerFactory)=>(0, $b9FtP.getToolbarConfig)(state, intl, {
                    allowCustomPanel: allowCustomPanel,
                    allowCustomPanelEdit: allowCustomPanelEdit
                }, providerFactory, api)
        }
    };
};
var $8b88e8dbf7b62f8c$export$2e2bcd8739ae039 = $8b88e8dbf7b62f8c$var$panelPlugin;

});
parcelRegister("1guOi", function(module, exports) {
$parcel$export(module.exports, "default", () => $02358bc00966d569$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $8K5q6 = parcelRequire("8K5q6");
function $02358bc00966d569$export$2e2bcd8739ae039() {
    const { iconThemed: iconThemed } = (0, $8K5q6.useIconThemed)();
    return /*#__PURE__*/ (0, $dc70d.jsxs)("svg", {
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        focusable: "false",
        "aria-hidden": true,
        children: [
            /*#__PURE__*/ (0, $dc70d.jsx)("rect", {
                width: "40",
                height: "40",
                fill: iconThemed({
                    light: '#fff',
                    dark: '#161A1D'
                })
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)("path", {
                d: "M8 13C8 12.4477 8.44772 12 9 12H40V28H9C8.44772 28 8 27.5523 8 27V13Z",
                fill: iconThemed({
                    light: "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
                    dark: "var(--ds-background-accent-teal-subtlest, #E7F9FF)"
                })
            }),
            /*#__PURE__*/ (0, $dc70d.jsxs)("g", {
                clipPath: "url(#clip0)",
                children: [
                    /*#__PURE__*/ (0, $dc70d.jsx)("path", {
                        d: "M19.9999 16.2222C15.5817 16.2222 12.2222 19.5818 12.2222 24H16.0093C16.0093 21.7962 17.7964 20.0093 19.9999 20.0093V16.2222Z",
                        fill: iconThemed({
                            light: '#6E5DC6',
                            dark: '#9F8FEF'
                        })
                    }),
                    /*#__PURE__*/ (0, $dc70d.jsx)("path", {
                        d: "M12 23.9998H12.676C12.676 19.9578 15.9502 16.6809 19.9909 16.676V16C15.5767 16.0051 12 19.5847 12 23.9998Z",
                        fill: iconThemed({
                            light: '#E34935',
                            dark: '#EF5C48'
                        })
                    }),
                    /*#__PURE__*/ (0, $dc70d.jsx)("path", {
                        d: "M12.6851 24H13.3517C13.3517 20.3262 16.3273 17.3478 19.9999 17.3429V16.6762C15.9593 16.6811 12.6851 19.958 12.6851 24Z",
                        fill: iconThemed({
                            light: '#D97008',
                            dark: '#F18D13'
                        })
                    }),
                    /*#__PURE__*/ (0, $dc70d.jsx)("path", {
                        d: "M13.3518 24H14.0185C14.0185 20.6945 16.6956 18.0145 20 18.0096V17.3429C16.3274 17.3478 13.3518 20.3262 13.3518 24Z",
                        fill: iconThemed({
                            light: '#E2B203',
                            dark: '#E2B203'
                        })
                    }),
                    /*#__PURE__*/ (0, $dc70d.jsx)("path", {
                        d: "M14.0184 24H14.6851C14.6851 21.0629 17.064 18.6811 20 18.6762V18.0096C16.6955 18.0144 14.0184 20.6944 14.0184 24Z",
                        fill: iconThemed({
                            light: '#6A9A23',
                            dark: '#82B536'
                        })
                    }),
                    /*#__PURE__*/ (0, $dc70d.jsx)("path", {
                        d: "M14.6851 24H15.3517C15.3517 21.4311 17.4322 19.348 19.9999 19.3431V18.6762C17.0639 18.6811 14.6851 21.0629 14.6851 24Z",
                        fill: iconThemed({
                            light: '#0055CC',
                            dark: '#579DFF'
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)("defs", {
                children: /*#__PURE__*/ (0, $dc70d.jsx)("clipPath", {
                    id: "clip0",
                    children: /*#__PURE__*/ (0, $dc70d.jsx)("rect", {
                        width: "8",
                        height: "8",
                        fill: iconThemed({
                            light: '#fff',
                            dark: '#fff'
                        }),
                        transform: "translate(12 16)"
                    })
                })
            })
        ]
    });
}

});

parcelRegister("60Fyu", function(module, exports) {
$parcel$export(module.exports, "createPanelAction", () => $d9aed191a5b764e0$export$80e77a5be96b2b61);

var $g6Qq4 = parcelRequire("g6Qq4");

var $dw0oh = parcelRequire("dw0oh");

var $1SmGf = parcelRequire("1SmGf");

var $01Z6w = parcelRequire("01Z6w");

var $5N1Y4 = parcelRequire("5N1Y4");
const $d9aed191a5b764e0$export$80e77a5be96b2b61 = ({ state: state, attributes: attributes, api: api, typeAheadInsert: typeAheadInsert, inputMethod: inputMethod = (0, $g6Qq4.INPUT_METHOD).QUICK_INSERT })=>{
    const panelNodeType = (0, $5N1Y4.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? (0, $01Z6w.pickPanelTypeForInsertion)(state.selection.$from) : state.schema.nodes.panel;
    let tr;
    if (state.selection.empty) {
        var _insertSelectedItem;
        const node = panelNodeType.createAndFill({
            ...attributes
        });
        if (!node) return false;
        tr = typeAheadInsert ? typeAheadInsert(node) : (_insertSelectedItem = (0, $dw0oh.insertSelectedItem)(node)(state, state.tr, state.selection.head)) === null || _insertSelectedItem === void 0 ? void 0 : _insertSelectedItem.scrollIntoView();
    } else tr = (0, $1SmGf.createWrapSelectionTransaction)({
        state: state,
        type: panelNodeType,
        nodeAttributes: {
            ...attributes
        }
    });
    if (tr) {
        var _api$analytics;
        api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 || _api$analytics.actions.attachAnalyticsEvent({
            action: (0, $g6Qq4.ACTION).INSERTED,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).DOCUMENT,
            actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).PANEL,
            attributes: {
                inputMethod: inputMethod,
                panelType: attributes.panelType
            },
            eventType: (0, $g6Qq4.EVENT_TYPE).TRACK
        })(tr);
    }
    return tr ?? false;
};

});

parcelRegister("1ybhj", function(module, exports) {
$parcel$export(module.exports, "default", () => $072e79aee09b087e$export$2e2bcd8739ae039);

var $56AB9 = parcelRequire("56AB9");

var $ejrfk = parcelRequire("ejrfk");

var $gab48 = parcelRequire("gab48");

var $367pK = parcelRequire("367pK");
function $072e79aee09b087e$var$findParentNode(selection, nodeType) {
    const parentPosition = (0, $gab48.findParentNodeOfType)(nodeType)(selection);
    if (parentPosition) return parentPosition.node;
    return null;
}
function $072e79aee09b087e$var$isInsideAnEmptyNode(selection, nodeType, schema) {
    const parentNode = $072e79aee09b087e$var$findParentNode(selection, nodeType);
    return parentNode && (0, $56AB9.isEmptyNode)(schema)(parentNode);
}
function $072e79aee09b087e$export$e832373cff8dec22() {
    const deleteCurrentItem = ($from, tr)=>{
        return tr.delete($from.before($from.depth) - 1, $from.end($from.depth) + 1);
    };
    const keymaps = {
        Backspace: (state, dispatch)=>{
            var _$previousPos$nodeAft, _nodeBeforePanel$type;
            const { selection: selection, schema: { nodes: nodes }, tr: tr } = state;
            const { blockquote: blockquote, orderedList: orderedList, bulletList: bulletList, mediaSingle: mediaSingle, mediaGroup: mediaGroup, extension: extension } = nodes;
            const panelNodeTypes = (0, $367pK.panelTypes)(nodes);
            const { $from: $from, $to: $to } = selection;
            // Don't do anything if selection is a range
            if ($from.pos !== $to.pos) return false;
            // If not at the start of a panel, no joining will happen so allow default behaviour (backspacing characters etc..)
            if ($from.parentOffset !== 0) return false;
            const $previousPos = tr.doc.resolve(Math.max(0, $from.before($from.depth) - 1));
            const previousNodeType = $previousPos.pos > 0 && $previousPos.parent && $previousPos.parent.type;
            const parentNodeType = $from.parent.type;
            const isPreviousNodeAPanel = previousNodeType && (0, $367pK.isPanel)(previousNodeType.name);
            const isParentNodeAPanel = (0, $367pK.isPanel)(parentNodeType.name);
            const nodeBeforePanel = $previousPos === null || $previousPos === void 0 ? void 0 : $previousPos.nodeBefore;
            const isPreviousNodeMedia = previousNodeType === mediaSingle || previousNodeType === mediaGroup;
            const isPreviousNodeAList = previousNodeType === bulletList || previousNodeType === orderedList;
            // identifies if new position after backspace is at the start of a non-bodied extension node
            const isPreviousPosAtExtension = ((_$previousPos$nodeAft = $previousPos.nodeAfter) === null || _$previousPos$nodeAft === void 0 ? void 0 : _$previousPos$nodeAft.type) === extension;
            // Stops merging panels when deleting empty paragraph in between
            // Stops merging blockquotes with panels when deleting from start of blockquote
            if (isPreviousNodeAPanel && !isParentNodeAPanel && !isPreviousPosAtExtension || panelNodeTypes.some((type)=>$072e79aee09b087e$var$isInsideAnEmptyNode(selection, type, state.schema)) || (0, $gab48.hasParentNodeOfType)(blockquote)(selection) && !isPreviousNodeAList && !isPreviousNodeMedia && !isPreviousPosAtExtension || // Lift line of panel content up and out of the panel, when backspacing
            // at the start of a panel, if the node before the panel is an 'isolating' node
            // (for e.g. a table, or an expand), otherwise the default prosemirror backspace
            // behaviour will fallback to 'select node backward' logic because the node
            // before is an isolating node.
            nodeBeforePanel !== null && nodeBeforePanel !== void 0 && (_nodeBeforePanel$type = nodeBeforePanel.type) !== null && _nodeBeforePanel$type !== void 0 && (_nodeBeforePanel$type = _nodeBeforePanel$type.spec) !== null && _nodeBeforePanel$type !== void 0 && _nodeBeforePanel$type.isolating && (0, $gab48.hasParentNodeOfType)(panelNodeTypes)(selection)) {
                const content = $from.node($from.depth).content;
                const insertPos = $previousPos.pos;
                deleteCurrentItem($from, tr).insert(insertPos, content);
                if (dispatch) dispatch((0, $gab48.setTextSelection)(insertPos)(tr).scrollIntoView());
                return true;
            }
            const nodeType = $from.node().type;
            if (!(0, $367pK.isPanel)(nodeType.name)) return false;
            return true;
        }
    };
    return (0, $ejrfk.keymap)(keymaps);
}
var $072e79aee09b087e$export$2e2bcd8739ae039 = $072e79aee09b087e$export$e832373cff8dec22;

});
parcelRegister("367pK", function(module, exports) {
$parcel$export(module.exports, "isPanel", () => $7c331f6a3d5ff22b$export$e58edb186cf54d62);
$parcel$export(module.exports, "panelTypes", () => $7c331f6a3d5ff22b$export$24b1da61c87aac35);
$parcel$export(module.exports, "findPanel", () => $7c331f6a3d5ff22b$export$ddbd7c123a514b96);
$parcel$export(module.exports, "panelAttrsToDom", () => $7c331f6a3d5ff22b$export$4dbd81d91bb3604b);
$parcel$export(module.exports, "handleCut", () => $7c331f6a3d5ff22b$export$1c3f791fb2a5168);

var $gAe8g = parcelRequire("gAe8g");

var $9uOZB = parcelRequire("9uOZB");

var $e4OZJ = parcelRequire("e4OZJ");

var $cw0wu = parcelRequire("cw0wu");

var $gab48 = parcelRequire("gab48");

var $5bbjm = parcelRequire("5bbjm");

var $gdUUy = parcelRequire("gdUUy");

var $5N1Y4 = parcelRequire("5N1Y4");
const $7c331f6a3d5ff22b$export$e58edb186cf54d62 = (nodeName)=>{
    return (0, $5N1Y4.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? [
        'panel',
        'panel_c1'
    ].includes(nodeName) : nodeName === 'panel';
};
const $7c331f6a3d5ff22b$export$24b1da61c87aac35 = (nodes)=>{
    const { panel: panel, panel_c1: panel_c1 } = nodes;
    return (0, $5N1Y4.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? [
        panel,
        panel_c1
    ] : [
        panel
    ];
};
const $7c331f6a3d5ff22b$export$ddbd7c123a514b96 = (state, selection)=>{
    return (0, $gab48.findSelectedNodeOfType)($7c331f6a3d5ff22b$export$24b1da61c87aac35(state.schema.nodes))(selection || state.selection) || (0, $gab48.findParentNodeOfType)($7c331f6a3d5ff22b$export$24b1da61c87aac35(state.schema.nodes))(selection || state.selection);
};
const $7c331f6a3d5ff22b$export$4dbd81d91bb3604b = (attrs, allowCustomPanel)=>{
    const { panelColor: panelColor, panelType: panelType, panelIcon: panelIcon, panelIconId: panelIconId, panelIconText: panelIconText } = attrs;
    const isCustomPanel = panelType === (0, $gAe8g.PanelType).CUSTOM && allowCustomPanel;
    const hasIcon = !isCustomPanel || !!panelIcon || !!panelIconId;
    const tokenColor = typeof panelColor === 'string' && (0, $e4OZJ.hexToEditorBackgroundPaletteColor)(panelColor);
    const panelBackgroundColor = tokenColor || panelColor;
    const isCustomPanelWithColor = typeof panelColor === 'string' && isCustomPanel;
    const style = [
        `${isCustomPanelWithColor ? `background-color: ${panelBackgroundColor};` : ''}`,
        // When table-in-panel is enabled, set --table-container-bg so that table
        // masking elements (sticky-header mask, column-controls wrapper) blend with
        // the custom panel background instead of showing opaque white.
        `${isCustomPanelWithColor && (0, $5N1Y4.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? `${0, $5bbjm.akEditorTableContainerBg}: ${panelBackgroundColor};` : ''}`
    ].join('');
    let panelAttrs = {
        class: `${(0, $9uOZB.PanelSharedCssClassName).prefix}${!hasIcon ? ` ${(0, $9uOZB.PanelSharedCssClassName).noIcon}` : ''}`,
        'data-panel-type': panelType || (0, $gAe8g.PanelType).INFO,
        'data-testid': 'panel-node-view',
        style: style
    };
    if (panelColor && isCustomPanel) panelAttrs = {
        ...panelAttrs,
        'data-panel-color': panelColor,
        'data-panel-icon-id': panelIconId,
        'data-panel-icon-text': panelIconText
    };
    // Required for parseDOM to correctly parse custom panel when NodeView DOM is copied directly
    // Schema's parseDOM expects data-panel-icon on all custom panels, not just ones with color
    if (isCustomPanel) panelAttrs = {
        ...panelAttrs,
        'data-panel-icon': panelIcon
    };
    if ((0, $gdUUy.fg)('platform_editor_adf_with_localid')) panelAttrs = {
        ...panelAttrs,
        'data-local-id': attrs.localId
    };
    const iconDiv = [
        'div',
        // EDITOR-266 This fixes an issue in LCM where if you have nested panels
        // The icon colour will be overridden by the parent panel style, this is used to create a more specific css selector
        {
            class: (0, $9uOZB.PanelSharedCssClassName).icon,
            'data-panel-type': panelType || (0, $gAe8g.PanelType).INFO
        }
    ];
    const contentDiv = [
        'div',
        {
            class: (0, $9uOZB.PanelSharedCssClassName).content
        },
        0
    ];
    if (hasIcon) return [
        'div',
        panelAttrs,
        iconDiv,
        contentDiv
    ];
    else return [
        'div',
        panelAttrs,
        contentDiv
    ];
};
const $7c331f6a3d5ff22b$export$1c3f791fb2a5168 = (newState, oldState)=>{
    const newTr = newState.tr;
    const { schema: schema } = newState.doc.type;
    if ($7c331f6a3d5ff22b$export$2098521608ce5fc1(newState, oldState)) {
        // Create a panel using oldState with an empty paragraph node
        // and insert it in the same location when panel previously existed
        const emptyParagraph = schema.nodes.paragraph.create();
        const oldPanelNode = (0, $gab48.findParentNode)((node)=>$7c331f6a3d5ff22b$export$e58edb186cf54d62(node.type.name))(oldState.tr.selection);
        const clonedPanelNode = oldPanelNode === null || oldPanelNode === void 0 ? void 0 : oldPanelNode.node.copy();
        const panelNodeType = (0, $5N1Y4.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? (oldPanelNode === null || oldPanelNode === void 0 ? void 0 : oldPanelNode.node.type) ?? schema.nodes.panel : schema.nodes.panel;
        const newPanelNode = panelNodeType.create({
            ...clonedPanelNode === null || clonedPanelNode === void 0 ? void 0 : clonedPanelNode.attrs
        }, emptyParagraph);
        const endPos = oldState.tr.selection.$from.pos;
        if (oldPanelNode) {
            newTr.insert(oldPanelNode.pos, newPanelNode).setSelection(new (0, $cw0wu.TextSelection)(newTr.doc.resolve(endPos)));
            return newTr;
        }
    }
};
const $7c331f6a3d5ff22b$export$2098521608ce5fc1 = (newState, oldState)=>{
    // The following fuctions checks if *
    //  a. old selection is a NodeSelection.
    //  b. parent element a panel and does it have only one child
    //  c. parent node has a decision list and that decision list only has one decision item
    //     OR old selection is a codeblock OR old selection is a rule
    const isNodeSelection = oldState.tr.selection instanceof (0, $cw0wu.NodeSelection);
    const isNodeTypeRuleOrCodeBlock = isNodeSelection && [
        'codeBlock',
        'rule'
    ].includes(oldState.tr.selection.node.type.name);
    const isParentTypePanel = (0, $gab48.findParentNodeOfType)($7c331f6a3d5ff22b$export$24b1da61c87aac35(newState.schema.nodes))(oldState.tr.selection);
    const isparentTypeDecision = (0, $gab48.findParentNodeOfType)(newState.schema.nodes.decisionList)(oldState.tr.selection);
    return Boolean(isNodeSelection && (isParentTypePanel === null || isParentTypePanel === void 0 ? void 0 : isParentTypePanel.node.childCount) === 1 && ((isparentTypeDecision === null || isparentTypeDecision === void 0 ? void 0 : isparentTypeDecision.node.childCount) === 1 || isNodeTypeRuleOrCodeBlock));
};

});


parcelRegister("ffvbI", function(module, exports) {
$parcel$export(module.exports, "createPlugin", () => $132cc15d7a01d92c$export$ae829ec7b2625219);

var $f7Kk4 = parcelRequire("f7Kk4");

var $8KAjj = parcelRequire("8KAjj");

var $9uOZB = parcelRequire("9uOZB");

var $5N1Y4 = parcelRequire("5N1Y4");

var $f8Pip = parcelRequire("f8Pip");

var $kawBK = parcelRequire("kawBK");

var $367pK = parcelRequire("367pK");
const $132cc15d7a01d92c$export$ae829ec7b2625219 = (dispatch, providerFactory, pluginOptions, api, nodeViewPortalProviderAPI)=>{
    const { useLongPressSelection: useLongPressSelection = false } = pluginOptions;
    return new (0, $f7Kk4.SafePlugin)({
        key: (0, $kawBK.pluginKey),
        appendTransaction: (transactions, oldState, newState)=>{
            const tr = transactions.find((tr)=>tr.getMeta('uiEvent') === 'cut');
            if (tr) return (0, $367pK.handleCut)(newState, oldState);
        },
        props: {
            nodeViews: {
                panel: (0, $f8Pip.getPanelNodeView)(pluginOptions, api, nodeViewPortalProviderAPI, providerFactory),
                ...(0, $5N1Y4.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? {
                    panel_c1: (0, $f8Pip.getPanelNodeView)(pluginOptions, api, nodeViewPortalProviderAPI, providerFactory)
                } : {}
            },
            handleClickOn: (0, $8KAjj.createSelectionClickHandler)((0, $5N1Y4.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? [
                'panel',
                'panel_c1'
            ] : [
                'panel'
            ], (target)=>!!target.closest(`.${(0, $9uOZB.PanelSharedCssClassName).prefix}`), {
                useLongPressSelection: useLongPressSelection
            })
        }
    });
};

});
parcelRegister("f8Pip", function(module, exports) {
$parcel$export(module.exports, "getPanelNodeView", () => $c6ac874fecb1b8e0$export$544c25cc15cdca2);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $7RHfd = parcelRequire("7RHfd");

var $gAe8g = parcelRequire("gAe8g");

var $6AKcC = parcelRequire("6AKcC");

var $5tPrE = parcelRequire("5tPrE");

var $8yPGx = parcelRequire("8yPGx");

var $jmsFJ = parcelRequire("jmsFJ");

var $3zmLN = parcelRequire("3zmLN");

var $9uOZB = parcelRequire("9uOZB");

var $jO1kN = parcelRequire("jO1kN");

var $5beht = parcelRequire("5beht");

var $kW8qW = parcelRequire("kW8qW");

var $5bbjm = parcelRequire("5bbjm");

var $6YN8G = parcelRequire("6YN8G");

var $367pK = parcelRequire("367pK");

var $dbfTy = parcelRequire("dbfTy");
const $c6ac874fecb1b8e0$export$4641b622f6c36f58 = {
    info: (0, $5tPrE.PanelInfoIcon),
    success: (0, $jmsFJ.PanelSuccessIcon),
    note: (0, $8yPGx.PanelNoteIcon),
    tip: (0, (/*@__PURE__*/$parcel$interopDefault($6YN8G))),
    warning: (0, $3zmLN.PanelWarningIcon),
    error: (0, $6AKcC.PanelErrorIcon),
    custom: (0, $5tPrE.PanelInfoIcon)
};
const $c6ac874fecb1b8e0$var$selector = (states)=>{
    return {
        emojiState: states.emojiState
    };
};
const $c6ac874fecb1b8e0$export$2ba98455e5e9d756 = (props)=>{
    const { allowCustomPanel: allowCustomPanel, providerFactory: providerFactory, pluginInjectionApi: pluginInjectionApi, panelAttributes: { panelType: panelType, panelIcon: panelIcon, panelIconId: panelIconId, panelIconText: panelIconText } } = props;
    const { emojiState: emojiState } = (0, $5beht.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'emoji'
    ], $c6ac874fecb1b8e0$var$selector);
    const emojiProvider = emojiState === null || emojiState === void 0 ? void 0 : emojiState.emojiProvider;
    if (allowCustomPanel && panelIcon && panelType === (0, $gAe8g.PanelType).CUSTOM) return /*#__PURE__*/ (0, $dc70d.jsx)((0, $jO1kN.default), {
        emojiProvider: emojiProvider,
        providers: providerFactory,
        shortName: panelIcon,
        id: panelIconId,
        fallback: panelIconText,
        showTooltip: false,
        allowTextFallback: false,
        fitToHeight: (0, $5bbjm.akEditorCustomIconSize)
    });
    const Icon = $c6ac874fecb1b8e0$export$4641b622f6c36f58[panelType];
    return Icon ? /*#__PURE__*/ (0, $dc70d.jsx)(Icon, {
        label: `${panelType} panel`
    }) : null;
};
class $c6ac874fecb1b8e0$var$PanelNodeView {
    constructor(node, view, getPos, pluginOptions, api, nodeViewPortalProviderAPI, providerFactory){
        this.nodeViewPortalProviderAPI = nodeViewPortalProviderAPI;
        this.providerFactory = providerFactory;
        this.pluginOptions = pluginOptions;
        this.view = view;
        this.node = node;
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        this.key = (0, $7RHfd.default)();
        const { dom: dom, contentDOM: contentDOM } = (0, $kW8qW.DOMSerializer).renderSpec(document, (0, $367pK.panelAttrsToDom)(node.attrs, pluginOptions.allowCustomPanel || false));
        this.getPos = getPos;
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.dom = dom;
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.contentDOM = contentDOM;
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.icon = this.dom.querySelector(`.${(0, $9uOZB.PanelSharedCssClassName).icon}`);
        if (!this.icon) return;
        // set contentEditable as false to be able to select the custom panels with keyboard
        this.icon.contentEditable = 'false';
        const panelAttrs = node.attrs;
        // Determine if this is a standard panel type (info, note, success, warning, error)
        const isStandardPanel = panelAttrs.panelType && [
            (0, $gAe8g.PanelType).INFO,
            (0, $gAe8g.PanelType).NOTE,
            (0, $gAe8g.PanelType).SUCCESS,
            (0, $gAe8g.PanelType).WARNING,
            (0, $gAe8g.PanelType).ERROR
        ].includes(panelAttrs.panelType);
        // For standard panels (info, note, success, warning, error), render icon directly as native DOM
        // This avoids Portal rendering delays that cause flickering on SSR and page transitions
        if (isStandardPanel) (0, $dbfTy.renderPanelIcon)(panelAttrs.panelType, this.icon);
        else this.nodeViewPortalProviderAPI.render(()=>/*#__PURE__*/ (0, $dc70d.jsx)($c6ac874fecb1b8e0$export$2ba98455e5e9d756, {
                pluginInjectionApi: api,
                allowCustomPanel: pluginOptions.allowCustomPanel,
                panelAttributes: panelAttrs,
                providerFactory: this.providerFactory
            }), this.icon, this.key);
    }
    ignoreMutation(mutation) {
        // ignore mutation if it caused by the icon.
        if (!this.icon) return false;
        const isIcon = mutation.target === this.icon || mutation.target.parentNode === this.icon;
        // ignore mutation if it caused by the lazy load emoji inside icon.
        const isInsideIcon = this.icon.contains(mutation.target);
        return isIcon || isInsideIcon;
    }
    destroy() {
        const panelAttrs = this.node.attrs;
        // Determine if this is a standard panel type (info, note, success, warning, error)
        const isStandardPanel = panelAttrs.panelType && [
            (0, $gAe8g.PanelType).INFO,
            (0, $gAe8g.PanelType).NOTE,
            (0, $gAe8g.PanelType).SUCCESS,
            (0, $gAe8g.PanelType).WARNING,
            (0, $gAe8g.PanelType).ERROR
        ].includes(panelAttrs.panelType);
        // Only remove Portal if it was used (for custom emoji panels)
        if (!isStandardPanel) this.nodeViewPortalProviderAPI.remove(this.key);
    }
}
const $c6ac874fecb1b8e0$export$544c25cc15cdca2 = (pluginOptions, api, nodeViewPortalProviderAPI, providerFactory)=>(node, view, getPos)=>{
        return new $c6ac874fecb1b8e0$var$PanelNodeView(node, view, getPos, pluginOptions, api, nodeViewPortalProviderAPI, providerFactory);
    };

});
parcelRegister("jO1kN", function(module, exports) {
$parcel$export(module.exports, "default", () => $b9c9baefe5bd0646$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $hBXeM = parcelRequire("hBXeM");

var $rL8kb = parcelRequire("rL8kb");
const $b9c9baefe5bd0646$var$EmojiNodeFunctional = (props)=>{
    var _resourceConfig$optim;
    const { allowTextFallback: allowTextFallback, shortName: shortName, id: id, fallback: fallback, fitToHeight: fitToHeight, showTooltip: showTooltip, resourceConfig: resourceConfig, emojiProvider: emojiProvider } = props;
    const emojiId = (0, $bSJIT.useMemo)(()=>({
            shortName: shortName,
            id: id,
            fallback: fallback
        }), [
        shortName,
        id,
        fallback
    ]);
    const emojiProviderResolver = (0, $bSJIT.useMemo)(()=>Promise.resolve(emojiProvider), [
        emojiProvider
    ]);
    const customFallback = (0, $rL8kb.getEmojiCustomFallback)(fallback || shortName);
    if (allowTextFallback && !emojiProvider) return /*#__PURE__*/ (0, $dc70d.jsx)("span", {
        "data-emoji-id": id,
        "data-emoji-short-name": shortName,
        "data-emoji-text": fallback || shortName,
        children: customFallback || fallback || shortName
    });
    if (!emojiProvider) return null;
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $hBXeM.default), {
        emojiId: emojiId,
        emojiProvider: emojiProviderResolver,
        showTooltip: showTooltip,
        fitToHeight: fitToHeight,
        optimistic: true,
        customFallback: customFallback,
        optimisticImageURL: resourceConfig === null || resourceConfig === void 0 || (_resourceConfig$optim = resourceConfig.optimisticImageApi) === null || _resourceConfig$optim === void 0 ? void 0 : _resourceConfig$optim.getUrl({
            id: id,
            fallback: fallback,
            shortName: shortName
        }),
        editorEmoji: true
    });
};
const $b9c9baefe5bd0646$var$EmojiNode = ({ allowTextFallback: allowTextFallback, shortName: shortName, id: id, fallback: fallback, fitToHeight: fitToHeight, showTooltip: showTooltip, resourceConfig: resourceConfig, emojiProvider: emojiProvider, providers: providers })=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)($b9c9baefe5bd0646$var$EmojiNodeFunctional, {
        allowTextFallback: allowTextFallback,
        shortName: shortName,
        id: id,
        fallback: fallback,
        fitToHeight: fitToHeight,
        showTooltip: showTooltip,
        resourceConfig: resourceConfig,
        emojiProvider: emojiProvider,
        providers: providers
    });
};
const $b9c9baefe5bd0646$var$_default_1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).memo($b9c9baefe5bd0646$var$EmojiNode);
var $b9c9baefe5bd0646$export$2e2bcd8739ae039 = $b9c9baefe5bd0646$var$_default_1;

});

parcelRegister("dbfTy", function(module, exports) {
$parcel$export(module.exports, "renderPanelIcon", () => $53d57f0b889b5439$export$b4e58f62136fde82);

var $gAe8g = parcelRequire("gAe8g");
// SVG path data extracted from panel icon components
const $53d57f0b889b5439$var$PANEL_ICON_PATHS = {
    [(0, $gAe8g.PanelType).INFO]: 'M12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22V22ZM12 11.375C11.6685 11.375 11.3505 11.5067 11.1161 11.7411C10.8817 11.9755 10.75 12.2935 10.75 12.625V15.75C10.75 16.0815 10.8817 16.3995 11.1161 16.6339C11.3505 16.8683 11.6685 17 12 17C12.3315 17 12.6495 16.8683 12.8839 16.6339C13.1183 16.3995 13.25 16.0815 13.25 15.75V12.625C13.25 12.2935 13.1183 11.9755 12.8839 11.7411C12.6495 11.5067 12.3315 11.375 12 11.375ZM12 9.96875C12.4558 9.96875 12.893 9.78767 13.2153 9.46534C13.5377 9.14301 13.7188 8.70584 13.7188 8.25C13.7188 7.79416 13.5377 7.35699 13.2153 7.03466C12.893 6.71233 12.4558 6.53125 12 6.53125C11.5442 6.53125 11.107 6.71233 10.7847 7.03466C10.4623 7.35699 10.2812 7.79416 10.2812 8.25C10.2812 8.70584 10.4623 9.14301 10.7847 9.46534C11.107 9.78767 11.5442 9.96875 12 9.96875Z',
    [(0, $gAe8g.PanelType).NOTE]: 'M7 2H17C17.663 2 18.2989 2.26339 18.7678 2.73223C19.2366 3.20107 19.5 3.83696 19.5 4.5V19.5C19.5 20.163 19.2366 20.7989 18.7678 21.2678C18.2989 21.7366 17.663 22 17 22H7C6.33696 22 5.70107 21.7366 5.23223 21.2678C4.76339 20.7989 4.5 20.163 4.5 19.5V4.5C4.5 3.83696 4.76339 3.20107 5.23223 2.73223C5.70107 2.26339 6.33696 2 7 2ZM8.875 7C8.70924 7 8.55027 7.06585 8.43306 7.18306C8.31585 7.30027 8.25 7.45924 8.25 7.625V8.875C8.25 9.04076 8.31585 9.19973 8.43306 9.31694C8.55027 9.43415 8.70924 9.5 8.875 9.5H15.125C15.2908 9.5 15.4497 9.43415 15.5669 9.31694C15.6842 9.19973 15.75 9.04076 15.75 8.875V7.625C15.75 7.45924 15.6842 7.30027 15.5669 7.18306C15.4497 7.06585 15.2908 7 15.125 7H8.875ZM8.875 12C8.70924 12 8.55027 12.0658 8.43306 12.1831C8.31585 12.3003 8.25 12.4592 8.25 12.625V13.875C8.25 14.0408 8.31585 14.1997 8.43306 14.3169C8.55027 14.4342 8.70924 14.5 8.875 14.5H12.625C12.7908 14.5 12.9497 14.4342 13.0669 14.3169C13.1842 14.1997 13.25 14.0408 13.25 13.875V12.625C13.25 12.4592 13.1842 12.3003 13.0669 12.1831C12.9497 12.0658 12.7908 12 12.625 12H8.875Z',
    [(0, $gAe8g.PanelType).SUCCESS]: 'M12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22V22ZM13.705 8.295L11.015 13.4325L9.08625 11.695C8.9642 11.5852 8.82172 11.5005 8.66694 11.4457C8.51216 11.391 8.3481 11.3672 8.18415 11.3759C8.0202 11.3845 7.85955 11.4254 7.71139 11.4961C7.56322 11.5669 7.43044 11.6661 7.32063 11.7881C7.21081 11.9102 7.1261 12.0527 7.07135 12.2074C7.0166 12.3622 6.99287 12.5263 7.00152 12.6902C7.01016 12.8542 7.05102 13.0148 7.12175 13.163C7.19248 13.3112 7.2917 13.4439 7.41375 13.5538L10.5388 16.3663C10.6803 16.4938 10.8492 16.5872 11.0325 16.6395C11.2157 16.6917 11.4085 16.7014 11.596 16.6678C11.7836 16.6341 11.9609 16.558 12.1146 16.4453C12.2682 16.3326 12.3941 16.1863 12.4825 16.0175L15.92 9.455C16.0738 9.16127 16.1047 8.81847 16.0057 8.502C15.9068 8.18553 15.6862 7.92133 15.3925 7.7675C15.0988 7.61367 14.756 7.58283 14.4395 7.68176C14.123 7.78068 13.8588 8.00127 13.705 8.295V8.295Z',
    [(0, $gAe8g.PanelType).WARNING]: 'M13.4897 4.34592L21.8561 18.8611C21.9525 19.0288 22.0021 19.2181 21.9999 19.4101C21.9977 19.6021 21.9438 19.7903 21.8435 19.9559C21.7432 20.1215 21.6001 20.2588 21.4282 20.3542C21.2563 20.4497 21.0616 20.4999 20.8636 20.5H3.13707C2.93882 20.5 2.74401 20.4498 2.57196 20.3543C2.39992 20.2588 2.25663 20.1213 2.15631 19.9556C2.05598 19.7898 2.00212 19.6015 2.00006 19.4093C1.998 19.2171 2.04782 19.0278 2.14456 18.86L10.5121 4.34592C10.6602 4.08939 10.8762 3.87577 11.1377 3.72708C11.3993 3.57838 11.6971 3.5 12.0003 3.5C12.3036 3.5 12.6013 3.57838 12.8629 3.72708C13.1245 3.87577 13.3404 4.08939 13.4885 4.34592H13.4897ZM12.0003 7.82538C11.8232 7.82537 11.6482 7.86212 11.4869 7.93317C11.3257 8.00423 11.182 8.10793 11.0656 8.2373C10.9492 8.36668 10.8627 8.51872 10.8119 8.68321C10.7611 8.8477 10.7473 9.02083 10.7713 9.19093L11.3546 13.3416C11.3754 13.4933 11.4523 13.6326 11.5711 13.7334C11.6899 13.8343 11.8424 13.8899 12.0003 13.8899C12.1582 13.8899 12.3107 13.8343 12.4295 13.7334C12.5483 13.6326 12.6253 13.4933 12.6461 13.3416L13.2293 9.19093C13.2533 9.02083 13.2395 8.8477 13.1887 8.68321C13.138 8.51872 13.0515 8.36668 12.935 8.2373C12.8186 8.10793 12.6749 8.00423 12.5137 7.93317C12.3525 7.86212 12.1774 7.82537 12.0003 7.82538V7.82538ZM12.0003 17.3369C12.3395 17.3369 12.6649 17.2062 12.9047 16.9737C13.1446 16.7412 13.2793 16.4258 13.2793 16.0969C13.2793 15.7681 13.1446 15.4527 12.9047 15.2202C12.6649 14.9877 12.3395 14.857 12.0003 14.857C11.6611 14.857 11.3358 14.9877 11.0959 15.2202C10.8561 15.4527 10.7213 15.7681 10.7213 16.0969C10.7213 16.4258 10.8561 16.7412 11.0959 16.9737C11.3358 17.2062 11.6611 17.3369 12.0003 17.3369V17.3369Z',
    [(0, $gAe8g.PanelType).ERROR]: 'M13.8562 11.9112L16.5088 9.26C16.7433 9.02545 16.8751 8.70733 16.8751 8.37563C16.8751 8.04392 16.7433 7.7258 16.5088 7.49125C16.2742 7.2567 15.9561 7.12493 15.6244 7.12493C15.2927 7.12493 14.9746 7.2567 14.74 7.49125L12.09 10.1438L9.4375 7.49125C9.20295 7.25686 8.8849 7.12526 8.55331 7.12537C8.22172 7.12549 7.90376 7.25732 7.66937 7.49188C7.43499 7.72643 7.30338 8.04448 7.3035 8.37607C7.30361 8.70766 7.43545 9.02561 7.67 9.26L10.32 11.91L7.67 14.5625C7.4423 14.7983 7.31631 15.114 7.31916 15.4418C7.32201 15.7695 7.45347 16.083 7.68523 16.3148C7.91699 16.5465 8.2305 16.678 8.55825 16.6808C8.88599 16.6837 9.20175 16.5577 9.4375 16.33L12.0888 13.68L14.74 16.33C14.8561 16.4461 14.9939 16.5383 15.1455 16.6012C15.2972 16.664 15.4597 16.6964 15.6239 16.6965C15.7881 16.6966 15.9507 16.6643 16.1024 16.6015C16.2541 16.5387 16.392 16.4467 16.5081 16.3306C16.6243 16.2146 16.7164 16.0768 16.7793 15.9251C16.8422 15.7734 16.8746 15.6109 16.8746 15.4467C16.8747 15.2825 16.8424 15.1199 16.7796 14.9682C16.7168 14.8165 16.6248 14.6786 16.5088 14.5625L13.8562 11.9112V11.9112ZM12 22C9.34784 22 6.8043 20.9464 4.92893 19.0711C3.05357 17.1957 2 14.6522 2 12C2 9.34784 3.05357 6.8043 4.92893 4.92893C6.8043 3.05357 9.34784 2 12 2C14.6522 2 17.1957 3.05357 19.0711 4.92893C20.9464 6.8043 22 9.34784 22 12C22 14.6522 20.9464 17.1957 19.0711 19.0711C17.1957 20.9464 14.6522 22 12 22V22Z'
};
function $53d57f0b889b5439$export$b4e58f62136fde82(panelType, container) {
    if (!panelType || !$53d57f0b889b5439$var$PANEL_ICON_PATHS[panelType]) return null;
    const doc = container.ownerDocument;
    const svgNS = 'http://www.w3.org/2000/svg';
    // Create wrapper span (mimics PanelInfoIcon structure see editor-common/src/icons/shared/PanelInfoIcon.tsx)
    const span = doc.createElement('span');
    span.setAttribute('role', 'img');
    span.setAttribute('aria-label', `${panelType} panel`);
    // Create SVG element
    const svg = doc.createElementNS(svgNS, 'svg');
    svg.setAttribute('width', '24');
    svg.setAttribute('height', '24');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('xmlns', svgNS);
    svg.setAttribute('role', 'presentation');
    svg.style.pointerEvents = 'none';
    // Create path element
    const path = doc.createElementNS(svgNS, 'path');
    path.setAttribute('fill-rule', 'evenodd');
    path.setAttribute('clip-rule', 'evenodd');
    path.setAttribute('d', $53d57f0b889b5439$var$PANEL_ICON_PATHS[panelType]);
    path.setAttribute('fill', 'currentColor');
    svg.appendChild(path);
    span.appendChild(svg);
    container.appendChild(span);
    return svg;
}

});


parcelRegister("kawBK", function(module, exports) {
$parcel$export(module.exports, "pluginKey", () => $bfc837812154e7ba$export$18d4026d1ea86bb1);

var $cw0wu = parcelRequire("cw0wu");
const $bfc837812154e7ba$export$18d4026d1ea86bb1 = new (0, $cw0wu.PluginKey)('panelPlugin');

});


parcelRegister("apTjI", function(module, exports) {
$parcel$export(module.exports, "createPanelBlockMenuItem", () => $0fbbd82d1f882e52$export$33a19cd537147781);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $g6Qq4 = parcelRequire("g6Qq4");

var $8iYGb = parcelRequire("8iYGb");

var $01Z6w = parcelRequire("01Z6w");

var $dbuPt = parcelRequire("dbuPt");

var $iosNh = parcelRequire("iosNh");

var $5N1Y4 = parcelRequire("5N1Y4");
const $0fbbd82d1f882e52$var$NODE_NAME = 'panel';
const $0fbbd82d1f882e52$var$PanelBlockMenuItem = ({ api: api, isSuggested: isSuggested })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const handleClick = (event)=>{
        const triggeredFrom = event.nativeEvent instanceof KeyboardEvent || event.nativeEvent.detail === 0 ? (0, $g6Qq4.INPUT_METHOD).KEYBOARD : (0, $g6Qq4.INPUT_METHOD).MOUSE;
        const inputMethod = (0, $g6Qq4.INPUT_METHOD).BLOCK_MENU;
        api === null || api === void 0 || api.core.actions.execute(({ tr: tr })=>{
            var _api$blockMenu;
            const panelNodeType = (0, $5N1Y4.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? (0, $01Z6w.pickPanelTypeForInsertion)(tr.selection.$from) : tr.doc.type.schema.nodes.panel;
            const command = api === null || api === void 0 || (_api$blockMenu = api.blockMenu) === null || _api$blockMenu === void 0 ? void 0 : _api$blockMenu.commands.transformNode(panelNodeType, {
                inputMethod: inputMethod,
                isSuggested: isSuggested,
                triggeredFrom: triggeredFrom,
                targetTypeName: $0fbbd82d1f882e52$var$NODE_NAME
            });
            return command ? command({
                tr: tr
            }) : null;
        });
    };
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dbuPt.ToolbarDropdownItem), {
        onClick: handleClick,
        elemBefore: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iosNh))), {
            label: "",
            size: "small"
        }),
        children: formatMessage((0, $8iYGb.messages).panel)
    });
};
const $0fbbd82d1f882e52$export$33a19cd537147781 = (api)=>{
    return ({ isSuggested: isSuggested } = {})=>/*#__PURE__*/ (0, $dc70d.jsx)($0fbbd82d1f882e52$var$PanelBlockMenuItem, {
            api: api,
            isSuggested: isSuggested
        });
};

});

parcelRegister("dfD9b", function(module, exports) {
$parcel$export(module.exports, "getPanelQuickInsertComponents", () => $60b24ebd93ca930e$export$805344db6eac4db2);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $gAe8g = parcelRequire("gAe8g");

var $8iYGb = parcelRequire("8iYGb");

var $b8Hvx = parcelRequire("b8Hvx");

var $9woaI = parcelRequire("9woaI");

var $am2Qg = parcelRequire("am2Qg");

var $jjdrd = parcelRequire("jjdrd");

var $iutYp = parcelRequire("iutYp");

var $kbO7u = parcelRequire("kbO7u");

var $e8iqP = parcelRequire("e8iqP");

var $iosNh = parcelRequire("iosNh");

var $kVyVP = parcelRequire("kVyVP");

var $fzVII = parcelRequire("fzVII");
const $60b24ebd93ca930e$var$standardPanelItems = [
    {
        description: (0, $8iYGb.messages).infoPanelDescription,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iosNh))),
        keywords: [
            'panel'
        ],
        menuItem: (0, $9woaI.INFO_PANEL_MENU_ITEM),
        panelType: (0, $gAe8g.PanelType).INFO,
        previewImageUrls: {
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVKL.png',
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVHA.png'
        },
        title: (0, $8iYGb.messages).infoPanel
    },
    {
        description: (0, $8iYGb.messages).notePanelDescription,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kVyVP))),
        menuItem: (0, $9woaI.NOTE_PANEL_MENU_ITEM),
        panelType: (0, $gAe8g.PanelType).NOTE,
        previewImageUrls: {
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVKJ.png',
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVHB.png'
        },
        title: (0, $8iYGb.messages).notePanel
    },
    {
        description: (0, $8iYGb.messages).successPanelDescription,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($e8iqP))),
        keywords: [
            'tip'
        ],
        menuItem: (0, $9woaI.SUCCESS_PANEL_MENU_ITEM),
        panelType: (0, $gAe8g.PanelType).SUCCESS,
        previewImageUrls: {
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVKP.png',
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVH6.png'
        },
        title: (0, $8iYGb.messages).successPanel
    },
    {
        description: (0, $8iYGb.messages).warningPanelDescription,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kbO7u))),
        menuItem: (0, $9woaI.WARNING_PANEL_MENU_ITEM),
        panelType: (0, $gAe8g.PanelType).WARNING,
        previewImageUrls: {
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVKO.png',
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVHC.png'
        },
        title: (0, $8iYGb.messages).warningPanel
    },
    {
        description: (0, $8iYGb.messages).errorPanelDescription,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iutYp))),
        menuItem: (0, $9woaI.ERROR_PANEL_MENU_ITEM),
        panelType: (0, $gAe8g.PanelType).ERROR,
        previewImageUrls: {
            light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVKQ.png',
            dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVH1.png'
        },
        title: (0, $8iYGb.messages).errorPanel
    }
];
const $60b24ebd93ca930e$var$customPanelItem = {
    description: (0, $8iYGb.messages).customPanelDescription,
    icon: (0, (/*@__PURE__*/$parcel$interopDefault($jjdrd))),
    menuItem: (0, $9woaI.CUSTOM_PANEL_MENU_ITEM),
    panelType: (0, $gAe8g.PanelType).CUSTOM,
    previewImageUrls: {
        light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVKN.png',
        dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVHD.png'
    },
    title: (0, $8iYGb.messages).customPanel
};
const $60b24ebd93ca930e$export$805344db6eac4db2 = ({ api: api, allowCustomPanel: allowCustomPanel, allowCustomPanelEdit: allowCustomPanelEdit })=>{
    const allPanelItems = [
        ...$60b24ebd93ca930e$var$standardPanelItems,
        ...allowCustomPanel && allowCustomPanelEdit ? [
            $60b24ebd93ca930e$var$customPanelItem
        ] : []
    ];
    return allPanelItems.map(({ description: description, icon: icon, keywords: keywords, menuItem: menuItem, panelType: panelType, previewImageUrls: previewImageUrls, title: title })=>({
            key: menuItem.key,
            type: menuItem.type,
            parents: [
                {
                    key: (0, $9woaI.STRUCTURE_SECTION).key,
                    type: (0, $9woaI.STRUCTURE_SECTION).type,
                    rank: (0, $am2Qg.STRUCTURE_SECTION_RANK)[menuItem.key]
                }
            ],
            match: (0, $b8Hvx.createQuickInsertMatcher)(({ formatMessage: formatMessage })=>({
                    description: formatMessage(description),
                    keywords: keywords,
                    title: formatMessage(title)
                })),
            component: ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $fzVII.PanelQuickInsertMenuItem), {
                    api: api,
                    description: description,
                    icon: icon,
                    panelType: panelType,
                    previewImageUrls: previewImageUrls,
                    title: title
                })
        }));
};

});
parcelRegister("jjdrd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c5429223205b4172af0cbd0d2ddcaa04>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $03a0ae4f31ceab33$var$_react = $03a0ae4f31ceab33$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $03a0ae4f31ceab33$var$_iconNew = $03a0ae4f31ceab33$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $03a0ae4f31ceab33$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Pencil".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/pencil
 * Usage guidance:
 * Known uses: compose video title in Loom
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $03a0ae4f31ceab33$var$PencilIcon = (props)=>/*#__PURE__*/ $03a0ae4f31ceab33$var$_react.default.createElement($03a0ae4f31ceab33$var$_iconNew.default, Object.assign({
        name: "PencilIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.336 1.604a2 2 0 0 1 2.828 0l1.233 1.232a2 2 0 0 1 0 2.828l-8.099 8.099a2 2 0 0 1-1.022.547l-3.379.675a.75.75 0 0 1-.882-.882l.675-3.379a2 2 0 0 1 .547-1.022zm1.768 1.06a.5.5 0 0 0-.707 0l-.961.961 1.939 1.94.96-.961a.5.5 0 0 0 0-.707zm-.79 3.961-1.939-1.94-6.077 6.078a.5.5 0 0 0-.137.255l-.455 2.276 2.276-.455a.5.5 0 0 0 .255-.137zM16 15H8v-1.5h8z" clip-rule="evenodd"/>`
    }, props));
$03a0ae4f31ceab33$var$PencilIcon.displayName = 'PencilIcon';
var $03a0ae4f31ceab33$var$_default = module.exports.default = $03a0ae4f31ceab33$var$PencilIcon;

});

parcelRegister("iutYp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9c275ac7980a0446f7df03013c12225e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $037953bba03eac8e$var$_react = $037953bba03eac8e$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $037953bba03eac8e$var$_iconNew = $037953bba03eac8e$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $037953bba03eac8e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StatusWorkflowCancelled".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/status-workflow-cancelled
 * Usage guidance:
 * Reserved for representing statuses that indicated work or a process has been cancelled
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $037953bba03eac8e$var$StatusWorkflowCancelledIcon = (props)=>/*#__PURE__*/ $037953bba03eac8e$var$_react.default.createElement($037953bba03eac8e$var$_iconNew.default, Object.assign({
        name: "StatusWorkflowCancelledIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="M2.343 2.343A8 8 0 1 1 13.658 13.66 8 8 0 0 1 2.343 2.343m10.254 1.06A6.501 6.501 0 1 0 3.404 12.6a6.501 6.501 0 0 0 9.193-9.195m-.885 1.946L9.061 8l2.651 2.652-1.06 1.06L8 9.061l-2.65 2.651-1.06-1.06L6.938 8 4.29 5.35l1.06-1.06L8 6.938l2.652-2.65z"/>`
    }, props));
$037953bba03eac8e$var$StatusWorkflowCancelledIcon.displayName = 'StatusWorkflowCancelledIcon';
var $037953bba03eac8e$var$_default = module.exports.default = $037953bba03eac8e$var$StatusWorkflowCancelledIcon;

});

parcelRegister("fzVII", function(module, exports) {
$parcel$export(module.exports, "PanelQuickInsertMenuItem", () => $e3ea1cdf4d491844$export$2c24fd862570d204);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $gAe8g = parcelRequire("gAe8g");

var $fT9mF = parcelRequire("fT9mF");

var $64eKJ = parcelRequire("64eKJ");

var $60Fyu = parcelRequire("60Fyu");
const $e3ea1cdf4d491844$var$getPanelAttributes = (panelType)=>panelType === (0, $gAe8g.PanelType).CUSTOM ? {
        panelType: panelType,
        panelIcon: ':rainbow:',
        panelIconId: '1f308',
        panelIconText: "\uD83C\uDF08",
        // Custom panel color is stored in ADF, not applied as UI styling.
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        panelColor: '#E6FCFF'
    } : {
        panelType: panelType
    };
const $e3ea1cdf4d491844$export$2c24fd862570d204 = ({ api: api, description: description, icon: Icon, panelType: panelType, previewImageUrls: previewImageUrls, title: title })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const preview = (0, $bSJIT.useMemo)(()=>previewImageUrls ? {
            image: previewImageUrls,
            attribution: {
                name: formatMessage((0, $64eKJ.messages).previewAttributionAtlassian)
            }
        } : undefined, [
        formatMessage,
        previewImageUrls
    ]);
    const onSelect = (0, $bSJIT.useCallback)(({ editorView: editorView, insert: insert, source: source })=>(0, $60Fyu.createPanelAction)({
            api: api,
            attributes: $e3ea1cdf4d491844$var$getPanelAttributes(panelType),
            inputMethod: source,
            state: editorView.state,
            typeAheadInsert: insert
        }), [
        api,
        panelType
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $fT9mF.QuickInsertMenuItem), {
        description: formatMessage(description),
        iconBefore: /*#__PURE__*/ (0, $dc70d.jsx)(Icon, {
            label: ""
        }),
        onSelect: onSelect,
        preview: preview,
        title: formatMessage(title)
    });
};

});


parcelRegister("b9FtP", function(module, exports) {
$parcel$export(module.exports, "getToolbarConfig", () => $ac929943a17a0bac$export$86ce8f8241c20a3);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $gAe8g = parcelRequire("gAe8g");

var $g6Qq4 = parcelRequire("g6Qq4");

var $fNLdd = parcelRequire("fNLdd");

var $3WNZ9 = parcelRequire("3WNZ9");

var $9uOZB = parcelRequire("9uOZB");

var $8qHhy = parcelRequire("8qHhy");

var $eUTDo = parcelRequire("eUTDo");

var $bbDkH = parcelRequire("bbDkH");

var $04ASR = parcelRequire("04ASR");

var $5NaaJ = parcelRequire("5NaaJ");

var $gab48 = parcelRequire("gab48");

var $5bbjm = parcelRequire("5bbjm");

var $c81bI = parcelRequire("c81bI");

var $cBVmT = parcelRequire("cBVmT");

var $gV64P = parcelRequire("gV64P");

var $7lqLi = parcelRequire("7lqLi");

var $27TPw = parcelRequire("27TPw");

var $68E0O = parcelRequire("68E0O");

var $lP6sB = parcelRequire("lP6sB");

var $dsw4B = parcelRequire("dsw4B");

var $5N1Y4 = parcelRequire("5N1Y4");

var $it8Et = parcelRequire("it8Et");

var $367pK = parcelRequire("367pK");

var $2TIch = parcelRequire("2TIch");
const $ac929943a17a0bac$export$f17692e562e3afad = {
    [(0, $gAe8g.PanelType).INFO]: {
        shortName: ':info:',
        id: 'atlassian-info'
    },
    [(0, $gAe8g.PanelType).NOTE]: {
        shortName: ':note:',
        id: 'atlassian-note'
    },
    [(0, $gAe8g.PanelType).WARNING]: {
        shortName: ':warning:',
        id: 'atlassian-warning'
    },
    [(0, $gAe8g.PanelType).ERROR]: {
        shortName: ':cross_mark:',
        id: 'atlassian-cross_mark'
    },
    [(0, $gAe8g.PanelType).SUCCESS]: {
        shortName: ':check_mark:',
        id: 'atlassian-check_mark'
    },
    [(0, $gAe8g.PanelType).TIP]: {
        shortName: ':tip:',
        id: 'atlassian-tip'
    }
};
const $ac929943a17a0bac$export$b40dbe3b5f798829 = (formatMessage, panelNodeType, isCustomPanelEnabled, isCustomPanelEditable, providerFactory, hoverDecoration, editorAnalyticsAPI, activePanelType, activePanelColor, activePanelIcon, state, api)=>{
    const areAllNewToolbarFlagsDisabled = !(0, $8qHhy.areToolbarFlagsEnabled)(Boolean(api === null || api === void 0 ? void 0 : api.toolbar));
    // TODO: ED-14403 - investigate why these titles are not getting translated for the tooltips
    const items = areAllNewToolbarFlagsDisabled ? [
        {
            id: 'editor.panel.info',
            type: 'button',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($68E0O))),
            onClick: (0, $it8Et.changePanelType)(editorAnalyticsAPI)((0, $gAe8g.PanelType).INFO),
            selected: activePanelType === (0, $gAe8g.PanelType).INFO,
            title: formatMessage((0, $3WNZ9.panelMessages).info),
            tabIndex: null
        },
        {
            id: 'editor.panel.note',
            type: 'button',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($27TPw))),
            onClick: (0, $it8Et.changePanelType)(editorAnalyticsAPI)((0, $gAe8g.PanelType).NOTE),
            selected: activePanelType === (0, $gAe8g.PanelType).NOTE,
            title: formatMessage((0, $3WNZ9.panelMessages).note),
            tabIndex: null
        },
        {
            id: 'editor.panel.success',
            type: 'button',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lP6sB))),
            onClick: (0, $it8Et.changePanelType)(editorAnalyticsAPI)((0, $gAe8g.PanelType).SUCCESS),
            selected: activePanelType === (0, $gAe8g.PanelType).SUCCESS,
            title: formatMessage((0, $3WNZ9.panelMessages).success),
            tabIndex: null
        },
        {
            id: 'editor.panel.warning',
            type: 'button',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($dsw4B))),
            onClick: (0, $it8Et.changePanelType)(editorAnalyticsAPI)((0, $gAe8g.PanelType).WARNING),
            selected: activePanelType === (0, $gAe8g.PanelType).WARNING,
            title: formatMessage((0, $3WNZ9.panelMessages).warning),
            tabIndex: null
        },
        {
            id: 'editor.panel.error',
            type: 'button',
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($cBVmT))),
            onClick: (0, $it8Et.changePanelType)(editorAnalyticsAPI)((0, $gAe8g.PanelType).ERROR),
            selected: activePanelType === (0, $gAe8g.PanelType).ERROR,
            title: formatMessage((0, $3WNZ9.panelMessages).error),
            tabIndex: null
        }
    ] : [
        (0, $2TIch.panelTypeDropdown)({
            activePanelType: activePanelType,
            editorAnalyticsAPI: editorAnalyticsAPI,
            formatMessage: formatMessage
        }),
        ...Boolean(api === null || api === void 0 ? void 0 : api.toolbar) ? [] : [
            {
                type: 'separator'
            }
        ]
    ];
    if (isCustomPanelEnabled) {
        const changeColor = (color)=>(state, dispatch)=>{
                const panelNode = (0, $367pK.findPanel)(state);
                if (panelNode === undefined) return false;
                const previousColor = panelNode.node.attrs.panelType === 'custom' ? panelNode.node.attrs.panelColor || 'none' : (0, $9uOZB.getPanelTypeBackgroundNoTokens)(panelNode.node.attrs.panelType);
                const emojiInfo = panelNode.node.attrs.panelType;
                const panelEmoji = $ac929943a17a0bac$export$f17692e562e3afad[emojiInfo];
                const previousEmoji = panelEmoji ? {
                    emoji: panelEmoji.shortName,
                    emojiId: panelEmoji.id
                } : {};
                if (previousColor === color) {
                    (0, $it8Et.changePanelType)(editorAnalyticsAPI)((0, $gAe8g.PanelType).CUSTOM, {
                        color: color,
                        ...previousEmoji
                    }, isCustomPanelEnabled)(state, dispatch);
                    return false;
                }
                const payload = {
                    action: (0, $g6Qq4.ACTION).CHANGED_BACKGROUND_COLOR,
                    actionSubject: (0, $g6Qq4.ACTION_SUBJECT).PANEL,
                    actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).PANEL,
                    attributes: {
                        newColor: color,
                        previousColor: previousColor
                    },
                    eventType: (0, $g6Qq4.EVENT_TYPE).TRACK
                };
                (0, $5NaaJ.withAnalytics)(editorAnalyticsAPI, payload)((0, $it8Et.changePanelType)(editorAnalyticsAPI)((0, $gAe8g.PanelType).CUSTOM, {
                    color: color,
                    ...previousEmoji
                }, isCustomPanelEnabled))(state, dispatch);
                return false;
            };
        const changeEmoji = (emoji)=>(state, dispatch)=>{
                const panelNode = (0, $367pK.findPanel)(state);
                if (panelNode === undefined) return false;
                const previousIcon = panelNode.node.attrs.panelIcon || '';
                if (previousIcon === emoji.shortName) {
                    (0, $it8Et.changePanelType)(editorAnalyticsAPI)((0, $gAe8g.PanelType).CUSTOM, {
                        emoji: emoji.shortName,
                        emojiId: emoji.id,
                        emojiText: emoji.fallback
                    }, true)(state, dispatch);
                    return false;
                }
                const payload = {
                    action: (0, $g6Qq4.ACTION).CHANGED_ICON,
                    actionSubject: (0, $g6Qq4.ACTION_SUBJECT).PANEL,
                    actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).PANEL,
                    attributes: {
                        newIcon: emoji.shortName,
                        previousIcon: previousIcon
                    },
                    eventType: (0, $g6Qq4.EVENT_TYPE).TRACK
                };
                (0, $5NaaJ.withAnalytics)(editorAnalyticsAPI, payload)((0, $it8Et.changePanelType)(editorAnalyticsAPI)((0, $gAe8g.PanelType).CUSTOM, {
                    emoji: emoji.shortName,
                    emojiId: emoji.id,
                    emojiText: emoji.fallback
                }, true))(state, dispatch);
                return false;
            };
        const removeEmoji = ()=>(state, dispatch)=>{
                const panelNode = (0, $367pK.findPanel)(state);
                if (activePanelType === (0, $gAe8g.PanelType).CUSTOM && !activePanelIcon) return false;
                if (panelNode === undefined) return false;
                const payload = {
                    action: (0, $g6Qq4.ACTION).REMOVE_ICON,
                    actionSubject: (0, $g6Qq4.ACTION_SUBJECT).PANEL,
                    actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).PANEL,
                    attributes: {
                        icon: panelNode.node.attrs.panelIcon
                    },
                    eventType: (0, $g6Qq4.EVENT_TYPE).TRACK
                };
                (0, $5NaaJ.withAnalytics)(editorAnalyticsAPI, payload)((0, $it8Et.changePanelType)(editorAnalyticsAPI)((0, $gAe8g.PanelType).CUSTOM, {
                    emoji: undefined,
                    emojiId: undefined,
                    emojiText: undefined
                }, isCustomPanelEnabled))(state, dispatch);
                return false;
            };
        const panelColor = activePanelType === (0, $gAe8g.PanelType).CUSTOM ? activePanelColor || (0, $9uOZB.getPanelTypeBackgroundNoTokens)((0, $gAe8g.PanelType).INFO) : (0, $9uOZB.getPanelTypeBackgroundNoTokens)(activePanelType);
        const isNewPanelPaletteEnabled = (0, $5N1Y4.expValEquals)('platform_editor_lovability_text_bg_color', 'isEnabled', true);
        const colorPalette = isNewPanelPaletteEnabled ? (0, $04ASR.panelBackgroundPaletteNew) : (0, $bbDkH.panelBackgroundPalette);
        const defaultPalette = colorPalette.find((item)=>item.value === panelColor) || {
            // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
            label: 'Custom',
            value: panelColor,
            border: (0, $eUTDo.DEFAULT_BORDER_COLOR)
        };
        if (isCustomPanelEditable) {
            const colorPicker = {
                id: 'editor.panel.colorPicker',
                title: formatMessage((0, $3WNZ9.panelMessages).backgroundColor),
                isAriaExpanded: true,
                type: 'select',
                selectType: 'color',
                defaultValue: defaultPalette,
                options: colorPalette,
                cols: isNewPanelPaletteEnabled ? 10 : undefined,
                onChange: (option)=>changeColor(option.value)
            };
            const emojiPicker = {
                id: 'editor.panel.emojiPicker',
                title: formatMessage((0, $3WNZ9.panelMessages).emoji),
                type: 'select',
                selectType: 'emoji',
                options: [],
                selected: activePanelType === (0, $gAe8g.PanelType).CUSTOM && !!activePanelIcon,
                onChange: (emoji)=>changeEmoji(emoji)
            };
            const removeEmojiButton = {
                id: 'editor.panel.removeEmoji',
                type: 'button',
                icon: ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7lqLi))), {
                        spacing: 'spacious',
                        label: ''
                    }),
                onClick: removeEmoji(),
                title: formatMessage((0, $fNLdd.default).removeEmoji),
                disabled: activePanelIcon ? false : true
            };
            items.push(emojiPicker, removeEmojiButton, {
                type: 'separator'
            }, colorPicker);
        }
    }
    if (areAllNewToolbarFlagsDisabled) {
        if (state) {
            items.push({
                type: 'separator'
            });
            items.push({
                type: 'copy-button',
                items: [
                    {
                        state: state,
                        formatMessage: formatMessage,
                        nodeType: panelNodeType
                    }
                ]
            });
        }
        items.push({
            type: 'separator'
        }, {
            id: 'editor.panel.delete',
            type: 'button',
            appearance: 'danger',
            focusEditoronEnter: true,
            icon: ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gV64P))), {
                    spacing: 'spacious',
                    label: ''
                }),
            onClick: (0, $it8Et.removePanel)(editorAnalyticsAPI),
            onMouseEnter: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(panelNodeType, true),
            onMouseLeave: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(panelNodeType, false),
            onFocus: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(panelNodeType, true),
            onBlur: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(panelNodeType, false),
            title: formatMessage((0, $fNLdd.default).remove),
            tabIndex: null
        });
    } else {
        const hoverDecorationProps = (nodeType, className)=>({
                onMouseEnter: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(nodeType, true, className),
                onMouseLeave: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(nodeType, false, className),
                onFocus: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(nodeType, true, className),
                onBlur: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(nodeType, false, className)
            });
        // testId is required to show focus on trigger button on ESC key press
        // see hideOnEsc in platform/packages/editor/editor-plugin-floating-toolbar/src/ui/Dropdown.tsx
        const testId = 'panel-overflow-dropdown-trigger';
        const overflowMenuConfig = [
            {
                type: 'separator',
                fullHeight: true
            },
            {
                type: 'overflow-dropdown',
                testId: testId,
                options: [
                    {
                        title: formatMessage((0, $fNLdd.default).copyToClipboard),
                        onClick: ()=>{
                            var _api$core, _api$floatingToolbar;
                            api === null || api === void 0 || (_api$core = api.core) === null || _api$core === void 0 || _api$core.actions.execute(api === null || api === void 0 || (_api$floatingToolbar = api.floatingToolbar) === null || _api$floatingToolbar === void 0 ? void 0 : _api$floatingToolbar.commands.copyNode(panelNodeType, (0, $g6Qq4.INPUT_METHOD).FLOATING_TB));
                            return true;
                        },
                        icon: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c81bI))), {
                            label: ""
                        }),
                        ...hoverDecorationProps(panelNodeType, (0, $5bbjm.akEditorSelectedNodeClassName))
                    },
                    {
                        title: formatMessage((0, $fNLdd.default).delete),
                        onClick: (0, $it8Et.removePanel)(editorAnalyticsAPI),
                        icon: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gV64P))), {
                            label: ""
                        }),
                        ...hoverDecorationProps(panelNodeType)
                    }
                ]
            }
        ];
        items.push(...overflowMenuConfig);
    }
    return items;
};
const $ac929943a17a0bac$export$86ce8f8241c20a3 = (state, intl, options = {}, providerFactory, api)=>{
    const { formatMessage: formatMessage } = intl;
    const panelObject = (0, $367pK.findPanel)(state);
    if (panelObject) {
        var _api$decorations, _api$analytics;
        const nodeType = (0, $5N1Y4.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? panelObject.node.type : state.schema.nodes.panel;
        const { panelType: panelType, panelColor: panelColor, panelIcon: panelIcon } = panelObject.node.attrs;
        const isStandardPanel = (panelType)=>{
            return panelType !== (0, $gAe8g.PanelType).CUSTOM ? panelType : undefined;
        };
        // force toolbar to be turned on
        const items = $ac929943a17a0bac$export$b40dbe3b5f798829(formatMessage, nodeType, options.allowCustomPanel || false, options.allowCustomPanel && options.allowCustomPanelEdit || false, providerFactory, api === null || api === void 0 || (_api$decorations = api.decorations) === null || _api$decorations === void 0 ? void 0 : _api$decorations.actions.hoverDecoration, api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions, panelType, options.allowCustomPanel ? panelColor : undefined, options.allowCustomPanel ? panelIcon || isStandardPanel(panelType) : undefined, state, (0, $8qHhy.areToolbarFlagsEnabled)(Boolean(api === null || api === void 0 ? void 0 : api.toolbar)) ? api : undefined);
        const getDomRef = (editorView)=>{
            const domAtPos = editorView.domAtPos.bind(editorView);
            const element = (0, $gab48.findDomRefAtPos)(panelObject.pos, domAtPos);
            return element;
        };
        return {
            title: 'Panel floating controls',
            getDomRef: getDomRef,
            nodeType: nodeType,
            items: items,
            scrollable: true,
            groupLabel: formatMessage((0, $3WNZ9.panelMessages).panelsGroup)
        };
    }
    return;
};

});
parcelRegister("3WNZ9", function(module, exports) {
$parcel$export(module.exports, "panelMessages", () => $7f81e6666029c4a7$export$7bb18eb6f9170174);

var $f0Pt4 = parcelRequire("f0Pt4");
const $7f81e6666029c4a7$export$7bb18eb6f9170174 = (0, $f0Pt4.defineMessages)({
    info: {
        id: 'fabric.editor.info',
        defaultMessage: 'Info',
        description: 'Panels provide a way to highlight text. The info panel has a blue background.'
    },
    note: {
        id: 'fabric.editor.note',
        defaultMessage: 'Note',
        description: 'Panels provide a way to highlight text. The note panel has a purple background.'
    },
    success: {
        id: 'fabric.editor.success',
        defaultMessage: 'Success',
        description: 'Panels provide a way to highlight text. The success panel has a green background.'
    },
    warning: {
        id: 'fabric.editor.warning',
        defaultMessage: 'Warning',
        description: 'Panels provide a way to highlight text. The warning panel has a yellow background.'
    },
    error: {
        id: 'fabric.editor.error',
        defaultMessage: 'Error',
        description: 'Panels provide a way to highlight text. The error panel has a red background.'
    },
    emoji: {
        id: 'fabric.editor.panel.emoji',
        defaultMessage: 'Add emoji',
        description: 'The text is shown as a button label on a panel in the editor when the user can add or change the emoji icon displayed on the panel.'
    },
    custom: {
        id: 'fabric.editor.panel.custom',
        defaultMessage: 'Custom',
        description: 'Custom panels where user has selected custom emoji and background color'
    },
    backgroundColor: {
        id: 'fabric.editor.panel.backgroundColor',
        defaultMessage: 'Background color',
        description: 'The text is shown as a button or menu label in the panel toolbar. Opens a color picker to select the background color for the panel.'
    },
    panelsGroup: {
        id: 'fabric.editor.panel.panelsGroup',
        defaultMessage: 'Panel Types',
        description: 'aria-label for group of panels the floating toolbar'
    }
});

});

parcelRegister("bbDkH", function(module, exports) {
$parcel$export(module.exports, "panelBackgroundPalette", () => $014cc3970565ce9b$export$4c05e6c3475702fb);
const $014cc3970565ce9b$export$4c05e6c3475702fb = [
    {
        label: 'White',
        value: '#FFFFFF'
    },
    {
        label: 'Light blue',
        value: '#DEEBFF'
    },
    {
        label: 'Light teal',
        value: '#E6FCFF'
    },
    {
        label: 'Light green',
        value: '#E3FCEF'
    },
    {
        label: 'Light yellow',
        value: '#FFFAE6'
    },
    {
        label: 'Light red',
        value: '#FFEBE6'
    },
    {
        label: 'Light purple',
        value: '#EAE6FF'
    },
    {
        label: 'Light gray',
        value: '#F4F5F7'
    },
    {
        label: 'Blue',
        value: '#B3D4FF'
    },
    {
        label: 'Teal',
        value: '#B3F5FF'
    },
    {
        label: 'Green',
        value: '#ABF5D1'
    },
    {
        label: 'Yellow',
        value: '#FFF0B3'
    },
    {
        label: 'Red',
        value: '#FFBDAD'
    },
    {
        label: 'Purple',
        value: '#C0B6F2'
    },
    {
        label: 'Gray',
        value: '#B3BAC5'
    },
    {
        label: 'Dark blue',
        value: '#4C9AFF'
    },
    {
        label: 'Dark teal',
        value: '#79E2F2'
    },
    {
        label: 'Dark green',
        value: '#57D9A3'
    },
    {
        label: 'Dark yellow',
        value: '#FFC400'
    },
    {
        label: 'Dark red',
        value: '#FF8F73'
    },
    {
        label: 'Dark purple',
        value: '#998DD9'
    }
].map((color)=>({
        ...color,
        border: "var(--ds-border, #0B120E24)"
    }));

});

parcelRegister("04ASR", function(module, exports) {
$parcel$export(module.exports, "panelBackgroundPaletteNew", () => $6dd983b7480ae785$export$5e21fcae2a26e059);
const $6dd983b7480ae785$export$5e21fcae2a26e059 = [
    {
        label: 'White',
        value: '#FFFFFF'
    },
    {
        label: 'Subtle blue',
        value: '#DEEBFF'
    },
    {
        label: 'Subtle teal',
        value: '#E6FCFF'
    },
    {
        label: 'Subtle green',
        value: '#E3FCEF'
    },
    {
        label: 'Subtle lime',
        value: '#EFFFD6'
    },
    {
        label: 'Subtle yellow',
        value: '#FFFAE6'
    },
    {
        label: 'Subtle orange',
        value: '#FFF5DB'
    },
    {
        label: 'Subtle red',
        value: '#FFEBE6'
    },
    {
        label: 'Subtle magenta',
        value: '#FFECF8'
    },
    {
        label: 'Subtle purple',
        value: '#EAE6FF'
    },
    {
        label: 'Gray',
        value: '#F4F5F7'
    },
    {
        label: 'Blue',
        value: '#B3D4FF'
    },
    {
        label: 'Teal',
        value: '#B3F5FF'
    },
    {
        label: 'Green',
        value: '#ABF5D1'
    },
    {
        label: 'Lime',
        value: '#D3F1A7'
    },
    {
        label: 'Yellow',
        value: '#FFF0B3'
    },
    {
        label: 'Orange',
        value: '#FCE4A6'
    },
    {
        label: 'Red',
        value: '#FFBDAD'
    },
    {
        label: 'Magenta',
        value: '#FDD0EC'
    },
    {
        label: 'Purple',
        value: '#C0B6F2'
    },
    {
        label: 'Bold gray',
        value: '#B7B9BE'
    },
    {
        label: 'Bold blue',
        value: '#ADCBFB'
    },
    {
        label: 'Bold teal',
        value: '#B1E4F7'
    },
    {
        label: 'Bold green',
        value: '#97EDC9'
    },
    {
        label: 'Bold lime',
        value: '#BDE97C'
    },
    {
        label: 'Bold yellow',
        value: '#EFDD4E'
    },
    {
        label: 'Bold orange',
        value: '#FBD779'
    },
    {
        label: 'Bold red',
        value: '#FFB8B2'
    },
    {
        label: 'Bold magenta',
        value: '#FCB6E1'
    },
    {
        label: 'Bold purple',
        value: '#E3BDFA'
    }
].map((color)=>({
        ...color,
        border: "var(--ds-border, #0B120E24)"
    }));

});

parcelRegister("it8Et", function(module, exports) {
$parcel$export(module.exports, "removePanel", () => $0cb3045d3682f668$export$8784bcc8bfa6de8d);
$parcel$export(module.exports, "changePanelType", () => $0cb3045d3682f668$export$1e9f13c739b39e00);

var $g6Qq4 = parcelRequire("g6Qq4");

var $9uOZB = parcelRequire("9uOZB");

var $cw0wu = parcelRequire("cw0wu");

var $gab48 = parcelRequire("gab48");

var $5N1Y4 = parcelRequire("5N1Y4");

var $367pK = parcelRequire("367pK");
const $0cb3045d3682f668$export$8784bcc8bfa6de8d = (editorAnalyticsAPI)=>(state, dispatch)=>{
        const { schema: { nodes: nodes }, tr: tr } = state;
        const payload = {
            action: (0, $g6Qq4.ACTION).DELETED,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).PANEL,
            attributes: {
                inputMethod: (0, $g6Qq4.INPUT_METHOD).FLOATING_TB
            },
            eventType: (0, $g6Qq4.EVENT_TYPE).TRACK
        };
        const panelNodeTypes = (0, $367pK.panelTypes)(nodes);
        let deleteTr = tr;
        if ((0, $gab48.findSelectedNodeOfType)(panelNodeTypes)(tr.selection)) deleteTr = (0, $gab48.removeSelectedNode)(tr);
        else if ((0, $gab48.findParentNodeOfType)(panelNodeTypes)(tr.selection)) deleteTr = (0, $gab48.removeParentNodeOfType)(panelNodeTypes)(tr);
        if (!deleteTr) return false;
        if (dispatch) {
            editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent(payload)(deleteTr);
            dispatch(deleteTr);
        }
        return true;
    };
const $0cb3045d3682f668$export$1e9f13c739b39e00 = (editorAnalyticsAPI)=>(panelType, panelOptions = {}, allowCustomPanel = false)=>(state, dispatch)=>{
            const { schema: { nodes: nodes }, tr: tr } = state;
            const panelNode = (0, $367pK.findPanel)(state);
            if (panelNode === undefined) return false;
            const newType = panelType;
            const previousType = panelNode.node.attrs.panelType;
            let newTr;
            const panelNodeType = (0, $5N1Y4.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? panelNode.node.type : nodes.panel;
            if (allowCustomPanel) {
                const previousColor = panelNode.node.attrs.panelType === 'custom' ? panelNode.node.attrs.panelColor || 'none' : (0, $9uOZB.getPanelTypeBackgroundNoTokens)(previousType);
                const previousIcon = panelNode.node.attrs.panelIcon;
                const previousIconId = panelNode.node.attrs.panelIconId;
                const previousIconText = panelNode.node.attrs.panelIconText;
                const newPanelOptions = {
                    color: previousColor,
                    emoji: previousIcon,
                    emojiId: previousIconId,
                    emojiText: previousIconText,
                    ...panelOptions
                };
                newTr = tr.setNodeMarkup(panelNode.pos, panelNodeType, {
                    panelIcon: newPanelOptions.emoji,
                    panelIconId: newPanelOptions.emojiId,
                    panelIconText: newPanelOptions.emojiText,
                    panelColor: newPanelOptions.color,
                    panelType: panelType
                });
            } else newTr = tr.setNodeMarkup(panelNode.pos, panelNodeType, {
                panelType: panelType
            });
            const payload = {
                action: (0, $g6Qq4.ACTION).CHANGED_TYPE,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).PANEL,
                attributes: {
                    newType: newType,
                    previousType: previousType
                },
                eventType: (0, $g6Qq4.EVENT_TYPE).TRACK
            };
            // Select the panel if it was previously selected
            const newTrWithSelection = state.selection instanceof (0, $cw0wu.NodeSelection) && (0, $367pK.isPanel)(state.selection.node.type.name) ? newTr.setSelection(new (0, $cw0wu.NodeSelection)(tr.doc.resolve(panelNode.pos))) : newTr;
            editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent(payload)(newTrWithSelection);
            newTrWithSelection.setMeta('scrollIntoView', false);
            if (dispatch) dispatch(newTrWithSelection);
            return true;
        };

});

parcelRegister("2TIch", function(module, exports) {
$parcel$export(module.exports, "panelTypeDropdown", () => $51215b439f5d7213$export$b79ba0272604ac1c);

var $gAe8g = parcelRequire("gAe8g");

var $3WNZ9 = parcelRequire("3WNZ9");

var $cBVmT = parcelRequire("cBVmT");

var $2hM1a = parcelRequire("2hM1a");

var $27TPw = parcelRequire("27TPw");

var $68E0O = parcelRequire("68E0O");

var $lP6sB = parcelRequire("lP6sB");

var $dsw4B = parcelRequire("dsw4B");

var $it8Et = parcelRequire("it8Et");
const $51215b439f5d7213$var$panelTitleAndIcon = {
    [(0, $gAe8g.PanelType).INFO]: {
        title: (0, $3WNZ9.panelMessages).info,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($68E0O)))({
            label: 'info-icon',
            color: "var(--ds-icon-information, #357DE8)"
        })
    },
    [(0, $gAe8g.PanelType).NOTE]: {
        title: (0, $3WNZ9.panelMessages).note,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($27TPw)))({
            label: 'note-icon',
            color: "var(--ds-icon-discovery, #AF59E1)"
        })
    },
    [(0, $gAe8g.PanelType).SUCCESS]: {
        title: (0, $3WNZ9.panelMessages).success,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($lP6sB)))({
            label: 'success-icon',
            color: "var(--ds-icon-success, #6A9A23)"
        })
    },
    [(0, $gAe8g.PanelType).WARNING]: {
        title: (0, $3WNZ9.panelMessages).warning,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dsw4B)))({
            label: 'warning-icon',
            color: "var(--ds-icon-warning, #E06C00)"
        })
    },
    [(0, $gAe8g.PanelType).ERROR]: {
        title: (0, $3WNZ9.panelMessages).error,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cBVmT)))({
            label: 'error-icon',
            color: "var(--ds-icon-danger, #C9372C)"
        })
    },
    [(0, $gAe8g.PanelType).CUSTOM]: {
        title: (0, $3WNZ9.panelMessages).custom,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2hM1a)))({
            label: 'custom-icon'
        })
    }
};
const $51215b439f5d7213$export$b79ba0272604ac1c = ({ activePanelType: activePanelType, editorAnalyticsAPI: editorAnalyticsAPI, formatMessage: formatMessage })=>{
    const dropdownOptions = [
        {
            id: 'editor.panel.info',
            icon: $51215b439f5d7213$var$panelTitleAndIcon[(0, $gAe8g.PanelType).INFO].icon,
            onClick: (0, $it8Et.changePanelType)(editorAnalyticsAPI)((0, $gAe8g.PanelType).INFO),
            selected: activePanelType === (0, $gAe8g.PanelType).INFO,
            title: formatMessage($51215b439f5d7213$var$panelTitleAndIcon[(0, $gAe8g.PanelType).INFO].title)
        },
        {
            id: 'editor.panel.note',
            icon: $51215b439f5d7213$var$panelTitleAndIcon[(0, $gAe8g.PanelType).NOTE].icon,
            onClick: (0, $it8Et.changePanelType)(editorAnalyticsAPI)((0, $gAe8g.PanelType).NOTE),
            selected: activePanelType === (0, $gAe8g.PanelType).NOTE,
            title: formatMessage($51215b439f5d7213$var$panelTitleAndIcon[(0, $gAe8g.PanelType).NOTE].title)
        },
        {
            id: 'editor.panel.success',
            icon: $51215b439f5d7213$var$panelTitleAndIcon[(0, $gAe8g.PanelType).SUCCESS].icon,
            onClick: (0, $it8Et.changePanelType)(editorAnalyticsAPI)((0, $gAe8g.PanelType).SUCCESS),
            selected: activePanelType === (0, $gAe8g.PanelType).SUCCESS,
            title: formatMessage($51215b439f5d7213$var$panelTitleAndIcon[(0, $gAe8g.PanelType).SUCCESS].title)
        },
        {
            id: 'editor.panel.warning',
            icon: $51215b439f5d7213$var$panelTitleAndIcon[(0, $gAe8g.PanelType).WARNING].icon,
            onClick: (0, $it8Et.changePanelType)(editorAnalyticsAPI)((0, $gAe8g.PanelType).WARNING),
            selected: activePanelType === (0, $gAe8g.PanelType).WARNING,
            title: formatMessage($51215b439f5d7213$var$panelTitleAndIcon[(0, $gAe8g.PanelType).WARNING].title)
        },
        {
            id: 'editor.panel.error',
            icon: $51215b439f5d7213$var$panelTitleAndIcon[(0, $gAe8g.PanelType).ERROR].icon,
            onClick: (0, $it8Et.changePanelType)(editorAnalyticsAPI)((0, $gAe8g.PanelType).ERROR),
            selected: activePanelType === (0, $gAe8g.PanelType).ERROR,
            title: formatMessage($51215b439f5d7213$var$panelTitleAndIcon[(0, $gAe8g.PanelType).ERROR].title)
        }
    ];
    const selectedPanelType = activePanelType || (0, $gAe8g.PanelType).INFO;
    const selectedTitleAndIcon = $51215b439f5d7213$var$panelTitleAndIcon[selectedPanelType] || $51215b439f5d7213$var$panelTitleAndIcon[(0, $gAe8g.PanelType).CUSTOM];
    return {
        id: 'panel-type-dropdown',
        testId: 'panel-type-dropdown-trigger',
        type: 'dropdown',
        options: dropdownOptions,
        showSelected: true,
        iconBefore: ()=>selectedTitleAndIcon.icon,
        title: formatMessage(selectedTitleAndIcon.title)
    };
};

});



parcelRegister("cgJ2k", function(module, exports) {
$parcel$export(module.exports, "pasteOptionsToolbarPlugin", () => $95bd2af35eca9d4f$export$2eabbda136e01363);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $5beht = parcelRequire("5beht");

var $gdUUy = parcelRequire("gdUUy");

var $4zjoa = parcelRequire("4zjoa");
parcelRequire("ixBwV");
var $kZ1UZ = parcelRequire("kZ1UZ");

var $lKZTQ = parcelRequire("lKZTQ");

var $hTPtZ = parcelRequire("hTPtZ");

var $ltyiA = parcelRequire("ltyiA");

var $lLiyp = parcelRequire("lLiyp");

var $gvK5W = parcelRequire("gvK5W");

var $gejID = parcelRequire("gejID");

var $3rUq9 = parcelRequire("3rUq9");

var $eebPB = parcelRequire("eebPB");

var $dIL6F = parcelRequire("dIL6F");

var $1v9g6 = parcelRequire("1v9g6");

var $5bwFd = parcelRequire("5bwFd");
const $95bd2af35eca9d4f$export$2eabbda136e01363 = ({ config: config, api: api })=>{
    var _api$analytics;
    const editorAnalyticsAPI = api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions;
    const getPasteMenuContext = ()=>({
            getCurrentPasteRange: ()=>{
                var _api$pasteOptionsTool;
                const state = api === null || api === void 0 || (_api$pasteOptionsTool = api.pasteOptionsToolbarPlugin) === null || _api$pasteOptionsTool === void 0 ? void 0 : _api$pasteOptionsTool.sharedState.currentState();
                if (!state) return undefined;
                return {
                    pasteEndPos: state.pasteEndPos,
                    pasteStartPos: state.pasteStartPos
                };
            },
            getCurrentPastedUrl: ()=>{
                var _api$paste;
                return (0, $1v9g6.getSingleSmartLinkUrlFromSlice)(api === null || api === void 0 || (_api$paste = api.paste) === null || _api$paste === void 0 || (_api$paste = _api$paste.sharedState.currentState()) === null || _api$paste === void 0 || (_api$paste = _api$paste.lastContentPasted) === null || _api$paste === void 0 ? void 0 : _api$paste.pastedSlice);
            }
        });
    if (config !== null && config !== void 0 && config.usePopupBasedPasteActionsMenu && (0, $4zjoa.expValEqualsNoExposure)('platform_editor_paste_actions_menu', 'isEnabled', true)) {
        var _api$uiControlRegistr;
        api === null || api === void 0 || (_api$uiControlRegistr = api.uiControlRegistry) === null || _api$uiControlRegistr === void 0 || _api$uiControlRegistr.actions.register((0, $eebPB.getPasteMenuComponents)({
            api: api,
            markdownToPmConverter: config === null || config === void 0 ? void 0 : config.markdownToPmConverter
        }));
    }
    if (config !== null && config !== void 0 && config.pasteMenuButtonsFactory && config !== null && config !== void 0 && config.usePopupBasedPasteActionsMenu) {
        var _api$uiControlRegistr2;
        const rules = (()=>{
            const getContext = ()=>{
                var _api$pasteOptionsTool2, _api$paste2;
                const pasteOptsState = api === null || api === void 0 || (_api$pasteOptionsTool2 = api.pasteOptionsToolbarPlugin) === null || _api$pasteOptionsTool2 === void 0 ? void 0 : _api$pasteOptionsTool2.sharedState.currentState();
                const pasteState = api === null || api === void 0 || (_api$paste2 = api.paste) === null || _api$paste2 === void 0 ? void 0 : _api$paste2.sharedState.currentState();
                return {
                    getPlaintextLength: ()=>(pasteOptsState === null || pasteOptsState === void 0 ? void 0 : pasteOptsState.plaintextLength) ?? 0,
                    getAncestorNodeNames: ()=>(pasteOptsState === null || pasteOptsState === void 0 ? void 0 : pasteOptsState.pasteAncestorNodeNames) ?? [],
                    getPastedText: ()=>{
                        var _pasteState$lastConte;
                        return (pasteState === null || pasteState === void 0 || (_pasteState$lastConte = pasteState.lastContentPasted) === null || _pasteState$lastConte === void 0 ? void 0 : _pasteState$lastConte.text) ?? '';
                    },
                    getPastedSlice: ()=>{
                        var _pasteState$lastConte2;
                        return pasteState === null || pasteState === void 0 || (_pasteState$lastConte2 = pasteState.lastContentPasted) === null || _pasteState$lastConte2 === void 0 ? void 0 : _pasteState$lastConte2.pastedSlice;
                    },
                    getNodeTypes: ()=>[],
                    getPasteSource: ()=>{
                        var _pasteState$lastConte3;
                        return pasteState === null || pasteState === void 0 || (_pasteState$lastConte3 = pasteState.lastContentPasted) === null || _pasteState$lastConte3 === void 0 ? void 0 : _pasteState$lastConte3.pasteSource;
                    }
                };
            };
            return (0, $5bwFd.createPasteMenuRuleFactories)(getContext);
        })();
        const productButtons = config.pasteMenuButtonsFactory(rules, getPasteMenuContext());
        api === null || api === void 0 || (_api$uiControlRegistr2 = api.uiControlRegistry) === null || _api$uiControlRegistr2 === void 0 || _api$uiControlRegistr2.actions.register(productButtons);
    }
    return {
        name: 'pasteOptionsToolbarPlugin',
        actions: {
            getPasteMenuRules: ()=>{
                const getContext = ()=>{
                    var _api$pasteOptionsTool3, _api$paste3;
                    const pasteOptsState = api === null || api === void 0 || (_api$pasteOptionsTool3 = api.pasteOptionsToolbarPlugin) === null || _api$pasteOptionsTool3 === void 0 ? void 0 : _api$pasteOptionsTool3.sharedState.currentState();
                    const pasteState = api === null || api === void 0 || (_api$paste3 = api.paste) === null || _api$paste3 === void 0 ? void 0 : _api$paste3.sharedState.currentState();
                    return {
                        getPlaintextLength: ()=>(pasteOptsState === null || pasteOptsState === void 0 ? void 0 : pasteOptsState.plaintextLength) ?? 0,
                        getAncestorNodeNames: ()=>(pasteOptsState === null || pasteOptsState === void 0 ? void 0 : pasteOptsState.pasteAncestorNodeNames) ?? [],
                        getPastedText: ()=>{
                            var _pasteState$lastConte4;
                            return (pasteState === null || pasteState === void 0 || (_pasteState$lastConte4 = pasteState.lastContentPasted) === null || _pasteState$lastConte4 === void 0 ? void 0 : _pasteState$lastConte4.text) ?? '';
                        },
                        getPastedSlice: ()=>{
                            var _pasteState$lastConte5;
                            return pasteState === null || pasteState === void 0 || (_pasteState$lastConte5 = pasteState.lastContentPasted) === null || _pasteState$lastConte5 === void 0 ? void 0 : _pasteState$lastConte5.pastedSlice;
                        },
                        getNodeTypes: ()=>[],
                        getPasteSource: ()=>{
                            var _pasteState$lastConte6;
                            return pasteState === null || pasteState === void 0 || (_pasteState$lastConte6 = pasteState.lastContentPasted) === null || _pasteState$lastConte6 === void 0 ? void 0 : _pasteState$lastConte6.pasteSource;
                        }
                    };
                };
                return (0, $5bwFd.createPasteMenuRuleFactories)(getContext);
            }
        },
        pmPlugins () {
            return [
                {
                    name: 'pasteOptionsToolbarPlugin',
                    plugin: ({ dispatch: dispatch })=>(0, $hTPtZ.createPlugin)(dispatch, {
                            useNewPasteMenu: (config === null || config === void 0 ? void 0 : config.usePopupBasedPasteActionsMenu) && (0, $4zjoa.expValEqualsNoExposure)('platform_editor_paste_actions_menu', 'isEnabled', true)
                        })
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return {
                isPlainText: false,
                pasteAncestorNodeNames: [],
                pasteEndPos: 0,
                pasteStartPos: 0,
                plaintextLength: 0,
                selectedOption: (0, $ltyiA.ToolbarDropdownOption).None,
                showLegacyOptions: false,
                showToolbar: false
            };
            const pluginState = (0, $ltyiA.pasteOptionsPluginKey).getState(editorState);
            return {
                isPlainText: (pluginState === null || pluginState === void 0 ? void 0 : pluginState.isPlainText) ?? false,
                pasteAncestorNodeNames: (pluginState === null || pluginState === void 0 ? void 0 : pluginState.pasteAncestorNodeNames) ?? [],
                pasteEndPos: (pluginState === null || pluginState === void 0 ? void 0 : pluginState.pasteEndPos) ?? 0,
                pasteStartPos: (pluginState === null || pluginState === void 0 ? void 0 : pluginState.pasteStartPos) ?? 0,
                plaintextLength: (pluginState === null || pluginState === void 0 ? void 0 : pluginState.plaintext.length) ?? 0,
                selectedOption: (pluginState === null || pluginState === void 0 ? void 0 : pluginState.selectedOption) ?? (0, $ltyiA.ToolbarDropdownOption).None,
                showLegacyOptions: (pluginState === null || pluginState === void 0 ? void 0 : pluginState.showLegacyOptions) ?? false,
                showToolbar: (pluginState === null || pluginState === void 0 ? void 0 : pluginState.showToolbar) ?? false
            };
        },
        pluginsOptions: {
            floatingToolbar (state, intl) {
                if (config !== null && config !== void 0 && config.usePopupBasedPasteActionsMenu && (0, $4zjoa.expValEqualsNoExposure)('platform_editor_paste_actions_menu', 'isEnabled', true)) return;
                const pastePluginState = (0, $ltyiA.pasteOptionsPluginKey).getState(state);
                if (pastePluginState.showToolbar) return (0, $dIL6F.buildToolbar)(state, intl, editorAnalyticsAPI, config === null || config === void 0 ? void 0 : config.markdownToPmConverter);
                return;
            }
        },
        contentComponent ({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement }) {
            if (!(config !== null && config !== void 0 && config.usePopupBasedPasteActionsMenu && ((0, $4zjoa.expValEqualsNoExposure)('platform_editor_paste_actions_menu', 'isEnabled', true) || [
                'hasSpellingAndGrammar',
                'hasAltAiActions'
            ].includes((0, $kZ1UZ.expValNoExposure)('platform_editor_paste_actions_menu_v2', 'variant', 'control')))) || !editorView) return null;
            return /*#__PURE__*/ (0, $dc70d.jsx)((0, $3rUq9.PasteActionsMenu), {
                api: api,
                editorView: editorView,
                mountTo: popupsMountPoint,
                boundariesElement: popupsBoundariesElement,
                scrollableElement: popupsScrollableElement
            });
        },
        usePluginHook ({ editorView: editorView }) {
            const { lastContentPasted: lastContentPasted } = (0, $5beht.useSharedPluginStateWithSelector)(api, [
                'paste'
            ], (states)=>{
                var _states$pasteState;
                return {
                    lastContentPasted: (_states$pasteState = states.pasteState) === null || _states$pasteState === void 0 ? void 0 : _states$pasteState.lastContentPasted
                };
            });
            (0, $bSJIT.useEffect)(()=>{
                if (config !== null && config !== void 0 && config.usePopupBasedPasteActionsMenu && (0, $gdUUy.fg)('platform_editor_paste_actions_menu_exposure')) {
                    var _lastContentPasted$te;
                    (0, $lLiyp.firePasteActionsMenuExperimentExposure)((lastContentPasted === null || lastContentPasted === void 0 || (_lastContentPasted$te = lastContentPasted.text) === null || _lastContentPasted$te === void 0 ? void 0 : _lastContentPasted$te.length) ?? 0, editorView.state, lastContentPasted === null || lastContentPasted === void 0 ? void 0 : lastContentPasted.pasteStartPos, lastContentPasted === null || lastContentPasted === void 0 ? void 0 : lastContentPasted.pasteEndPos, lastContentPasted === null || lastContentPasted === void 0 ? void 0 : lastContentPasted.text, lastContentPasted === null || lastContentPasted === void 0 ? void 0 : lastContentPasted.pastedSlice);
                }
                // These two need to be seperate to prevent them being dependant on each other
                if (config !== null && config !== void 0 && config.usePopupBasedPasteActionsMenu && (0, $gdUUy.fg)('platform_editor_paste_actions_menu_v2_exposure')) {
                    var _lastContentPasted$te2;
                    (0, $gejID.firePasteActionsMenuV2ExperimentExposure)((lastContentPasted === null || lastContentPasted === void 0 || (_lastContentPasted$te2 = lastContentPasted.text) === null || _lastContentPasted$te2 === void 0 ? void 0 : _lastContentPasted$te2.length) ?? 0, editorView.state, lastContentPasted === null || lastContentPasted === void 0 ? void 0 : lastContentPasted.pasteStartPos, lastContentPasted === null || lastContentPasted === void 0 ? void 0 : lastContentPasted.pasteEndPos, lastContentPasted === null || lastContentPasted === void 0 ? void 0 : lastContentPasted.text, lastContentPasted === null || lastContentPasted === void 0 ? void 0 : lastContentPasted.pastedSlice);
                }
                // Fires only for single-link pastes, matching when the 3p link menu shows.
                if (config !== null && config !== void 0 && config.usePopupBasedPasteActionsMenu) (0, $gvK5W.firePaste3pLinkActionsMenuExperimentExposure)(lastContentPasted === null || lastContentPasted === void 0 ? void 0 : lastContentPasted.pastedSlice);
                if (config !== null && config !== void 0 && config.usePopupBasedPasteActionsMenu && (0, $4zjoa.expValEqualsNoExposure)('platform_editor_paste_actions_menu', 'isEnabled', true)) return;
                if (!lastContentPasted) {
                    (0, $lKZTQ.hideToolbar)()(editorView.state, editorView.dispatch);
                    return;
                }
                let selectedOption = (0, $ltyiA.ToolbarDropdownOption).None;
                if (!lastContentPasted.isPlainText) selectedOption = (0, $ltyiA.ToolbarDropdownOption).RichText;
                else if (lastContentPasted.isShiftPressed) selectedOption = (0, $ltyiA.ToolbarDropdownOption).PlainText;
                else selectedOption = (0, $ltyiA.ToolbarDropdownOption).Markdown;
                if (!(0, $dIL6F.isToolbarVisible)(editorView.state, lastContentPasted)) return;
                (0, $lKZTQ.showToolbar)(lastContentPasted, selectedOption)(editorView.state, editorView.dispatch);
            }, [
                lastContentPasted,
                editorView
            ]);
        }
    };
};

});
parcelRegister("lKZTQ", function(module, exports) {
$parcel$export(module.exports, "showToolbar", () => $13596aff47ca4d2f$export$1ad95a504fba561e);
$parcel$export(module.exports, "changeToPlainTextWithAnalytics", () => $13596aff47ca4d2f$export$c833704cd36ac295);
$parcel$export(module.exports, "dropdownClickHandler", () => $13596aff47ca4d2f$export$405f0689dadde83d);
$parcel$export(module.exports, "highlightContent", () => $13596aff47ca4d2f$export$3367fb592cb1ac64);
$parcel$export(module.exports, "changeToRichTextWithAnalytics", () => $13596aff47ca4d2f$export$849d50d444ed50f8);
$parcel$export(module.exports, "changeToMarkdownWithAnalytics", () => $13596aff47ca4d2f$export$a1a13c805bf0cea1);
$parcel$export(module.exports, "hideToolbar", () => $13596aff47ca4d2f$export$70777665aad0464c);
$parcel$export(module.exports, "checkAndHideToolbar", () => $13596aff47ca4d2f$export$8b65e7aad6163588);

var $g6Qq4 = parcelRequire("g6Qq4");

var $j0Og8 = parcelRequire("j0Og8");

var $5NaaJ = parcelRequire("5NaaJ");

var $h1M3d = parcelRequire("h1M3d");

var $iKn9y = parcelRequire("iKn9y");

var $31lhd = parcelRequire("31lhd");

var $ltyiA = parcelRequire("ltyiA");
const $13596aff47ca4d2f$export$1ad95a504fba561e = (lastContentPasted, selectedOption, showLegacyOptions = true, pasteAncestorNodeNames = [])=>{
    const commandAction = (_editorState)=>{
        return {
            type: (0, $h1M3d.PastePluginActionTypes).SHOW_PASTE_OPTIONS,
            data: {
                selectedOption: selectedOption,
                plaintext: lastContentPasted.text ?? '',
                isPlainText: lastContentPasted.isPlainText,
                richTextSlice: lastContentPasted.pastedSlice,
                pasteStartPos: lastContentPasted.pasteStartPos,
                pasteEndPos: lastContentPasted.pasteEndPos,
                showLegacyOptions: showLegacyOptions,
                pasteAncestorNodeNames: pasteAncestorNodeNames
            }
        };
    };
    return (0, $iKn9y.createCommand)(commandAction);
};
const $13596aff47ca4d2f$export$ff80cd8c68a7a6ad = ()=>{
    const plaintextTransformer = (tr, state)=>{
        const pluginState = (0, $ltyiA.pasteOptionsPluginKey).getState(state);
        if (pluginState.selectedOption === (0, $ltyiA.ToolbarDropdownOption).PlainText) return tr;
        return (0, $31lhd.formatPlainText)(tr, pluginState);
    };
    const commandAction = (_editorState)=>{
        return {
            type: (0, $h1M3d.PastePluginActionTypes).CHANGE_FORMAT,
            data: {
                selectedOption: (0, $ltyiA.ToolbarDropdownOption).PlainText
            }
        };
    };
    return (0, $iKn9y.createCommand)(commandAction, plaintextTransformer);
};
const $13596aff47ca4d2f$export$c833704cd36ac295 = (editorAnalyticsAPI, sliceSize, invokedFrom)=>()=>{
        return (0, $5NaaJ.withAnalytics)(editorAnalyticsAPI, {
            action: (0, $g6Qq4.ACTION).PASTED,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).DOCUMENT,
            eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
            attributes: {
                inputMethod: (0, $g6Qq4.INPUT_METHOD).TOOLBAR,
                type: (0, $j0Og8.PasteTypes).plain,
                content: (0, $j0Og8.PasteContents).text,
                pasteSize: sliceSize,
                invokedFrom: invokedFrom
            }
        })($13596aff47ca4d2f$export$ff80cd8c68a7a6ad());
    };
const $13596aff47ca4d2f$export$405f0689dadde83d = ()=>{
    return $13596aff47ca4d2f$export$3367fb592cb1ac64();
};
const $13596aff47ca4d2f$export$50a682c7628ffa4e = ()=>{
    const transformer = (tr, state)=>{
        const pluginState = (0, $ltyiA.pasteOptionsPluginKey).getState(state);
        if (pluginState.selectedOption === (0, $ltyiA.ToolbarDropdownOption).RichText) return tr;
        return (0, $31lhd.formatRichText)(tr, pluginState);
    };
    const commandAction = (_editorState)=>{
        return {
            type: (0, $h1M3d.PastePluginActionTypes).CHANGE_FORMAT,
            data: {
                selectedOption: (0, $ltyiA.ToolbarDropdownOption).RichText
            }
        };
    };
    return (0, $iKn9y.createCommand)(commandAction, transformer);
};
const $13596aff47ca4d2f$export$849d50d444ed50f8 = (editorAnalyticsAPI, invokedFrom)=>()=>{
        const payloadCallback = (state)=>{
            var _pastePluginState$ric;
            const pastePluginState = (0, $ltyiA.pasteOptionsPluginKey).getState(state);
            return {
                action: (0, $g6Qq4.ACTION).PASTED,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).DOCUMENT,
                eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
                attributes: {
                    inputMethod: (0, $g6Qq4.INPUT_METHOD).TOOLBAR,
                    type: (0, $j0Og8.PasteTypes).richText,
                    content: (0, $j0Og8.PasteContents).text,
                    pasteSize: ((_pastePluginState$ric = pastePluginState.richTextSlice) === null || _pastePluginState$ric === void 0 ? void 0 : _pastePluginState$ric.size) || 0,
                    invokedFrom: invokedFrom
                }
            };
        };
        return (0, $5NaaJ.withAnalytics)(editorAnalyticsAPI, payloadCallback)($13596aff47ca4d2f$export$50a682c7628ffa4e());
    };
const $13596aff47ca4d2f$export$f22e171f994ad9d1 = (markdownToPmConverter)=>{
    const markdownTransformer = (tr, state)=>{
        const pluginState = (0, $ltyiA.pasteOptionsPluginKey).getState(state);
        if (pluginState.selectedOption === (0, $ltyiA.ToolbarDropdownOption).Markdown) return tr;
        return (0, $31lhd.formatMarkdown)(tr, pluginState, markdownToPmConverter);
    };
    const commandAction = (_editorState)=>{
        return {
            type: (0, $h1M3d.PastePluginActionTypes).CHANGE_FORMAT,
            data: {
                selectedOption: (0, $ltyiA.ToolbarDropdownOption).Markdown
            }
        };
    };
    return (0, $iKn9y.createCommand)(commandAction, markdownTransformer);
};
const $13596aff47ca4d2f$export$a1a13c805bf0cea1 = (editorAnalyticsAPI, sliceSize, invokedFrom, markdownToPmConverter)=>()=>{
        return (0, $5NaaJ.withAnalytics)(editorAnalyticsAPI, {
            action: (0, $g6Qq4.ACTION).PASTED,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).DOCUMENT,
            eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
            attributes: {
                inputMethod: (0, $g6Qq4.INPUT_METHOD).TOOLBAR,
                type: (0, $j0Og8.PasteTypes).markdown,
                content: (0, $j0Og8.PasteContents).text,
                pasteSize: sliceSize,
                invokedFrom: invokedFrom
            }
        })($13596aff47ca4d2f$export$f22e171f994ad9d1(markdownToPmConverter));
    };
const $13596aff47ca4d2f$export$3367fb592cb1ac64 = ()=>{
    const commandAction = (_editorState)=>{
        return {
            type: (0, $h1M3d.PastePluginActionTypes).HIGHLIGHT_CONTENT
        };
    };
    return (0, $iKn9y.createCommand)(commandAction);
};
const $13596aff47ca4d2f$export$70777665aad0464c = ()=>{
    const commandAction = (_editorState)=>{
        return {
            type: (0, $h1M3d.PastePluginActionTypes).HIDE_PASTE_OPTIONS
        };
    };
    return (0, $iKn9y.createCommand)(commandAction);
};
const $13596aff47ca4d2f$export$8b65e7aad6163588 = (view)=>{
    const pluginState = (0, $ltyiA.pasteOptionsPluginKey).getState(view.state);
    if (pluginState.showToolbar) $13596aff47ca4d2f$export$70777665aad0464c()(view.state, view.dispatch);
};

});
parcelRegister("j0Og8", function(module, exports) {
$parcel$export(module.exports, "PasteTypes", () => $97e79cc502d14079$export$2ba12a8680458b1e);
$parcel$export(module.exports, "PasteContents", () => $97e79cc502d14079$export$a82556f999b47168);
const $97e79cc502d14079$export$2ba12a8680458b1e = {
    richText: 'richText',
    plain: 'plain',
    markdown: 'markdown',
    binary: 'binary'
};
const $97e79cc502d14079$export$602c33ed77663fbf = {
    fabricEditor: 'fabric-editor',
    applePages: 'apple-pages',
    googleSpreadsheets: 'google-spreadsheets',
    googleDocs: 'google-docs',
    microsoftExcel: 'microsoft-excel',
    microsoftWord: 'microsoft-word',
    dropboxPaper: 'dropbox-paper',
    uncategorized: 'uncategorized'
};
const $97e79cc502d14079$export$a82556f999b47168 = {
    text: 'text',
    url: 'url',
    code: 'code',
    mediaSingle: 'mediaSingle',
    mediaCard: 'mediaCard',
    mediaGroup: 'mediaGroup',
    tableCells: 'tableCells',
    table: 'table',
    expand: 'expand',
    nestedExpand: 'nestedExpand',
    mixed: 'mixed',
    blockquote: 'blockquote',
    blockCard: 'blockCard',
    bodiedExtension: 'bodiedExtension',
    multiBodiedExtension: 'multiBodiedExtension',
    bulletList: 'bulletList',
    codeBlock: 'codeBlock',
    decisionList: 'decisionList',
    decisionItem: 'decisionItem',
    extension: 'extension',
    heading: 'heading',
    layoutSection: 'layoutSection',
    orderedList: 'orderedList',
    panel: 'panel',
    rule: 'rule',
    tableHeader: 'tableHeader',
    tableRow: 'tableRow',
    taskItem: 'taskItem',
    uncategorized: 'uncategorized'
};

});

parcelRegister("h1M3d", function(module, exports) {
$parcel$export(module.exports, "PastePluginActionTypes", () => $052a7944c6d6d940$export$ad3c0356f902fd97);
var $052a7944c6d6d940$export$ad3c0356f902fd97 = /*#__PURE__*/ function(PastePluginActionTypes) {
    PastePluginActionTypes["START_TRACKING_PASTED_MACRO_POSITIONS"] = "START_TRACKING_PASTED_MACRO_POSITIONS";
    PastePluginActionTypes["STOP_TRACKING_PASTED_MACRO_POSITIONS"] = "STOP_TRACKING_PASTED_MACRO_POSITIONS";
    PastePluginActionTypes["SHOW_PASTE_OPTIONS"] = "SHOW_PASTE_OPTIONS";
    PastePluginActionTypes["HIDE_PASTE_OPTIONS"] = "HIDE_PASTE_OPTIONS";
    PastePluginActionTypes["HIGHLIGHT_CONTENT"] = "HIGHLIGHT_CONTENT";
    PastePluginActionTypes["CHANGE_FORMAT"] = "CHANGE_FORMAT";
    return PastePluginActionTypes;
}({});

});

parcelRegister("iKn9y", function(module, exports) {
$parcel$export(module.exports, "createPluginState", () => $b9bdc9a4ee310342$export$656c7661095efe2e);
$parcel$export(module.exports, "createCommand", () => $b9bdc9a4ee310342$export$8d4021544bdece00);

var $3TnFr = parcelRequire("3TnFr");

var $h1M3d = parcelRequire("h1M3d");

var $ltyiA = parcelRequire("ltyiA");

var $gwTAf = parcelRequire("gwTAf");

var $kMZUQ = parcelRequire("kMZUQ");
const $b9bdc9a4ee310342$var$dest = (0, $3TnFr.pluginFactory)((0, $ltyiA.pasteOptionsPluginKey), (0, $kMZUQ.reducer), {
    mapping: (tr, pluginState)=>{
        if (!tr.docChanged || !pluginState.showToolbar) return pluginState;
        const oldPasteStartPos = pluginState.pasteStartPos;
        const oldPasteEndPos = pluginState.pasteEndPos;
        const newPasteStartPos = tr.mapping.map(oldPasteStartPos);
        const newPasteEndPos = tr.mapping.map(oldPasteEndPos);
        //this is true when user changes format from the toolbar.
        //only change pasteEndPos in this case
        if ($b9bdc9a4ee310342$var$changedFormatFromToolbar(tr)) return {
            ...pluginState,
            pasteEndPos: newPasteEndPos
        };
        if (oldPasteStartPos === newPasteStartPos && oldPasteEndPos === newPasteEndPos) return pluginState;
        return {
            ...pluginState,
            pasteStartPos: newPasteStartPos,
            pasteEndPos: newPasteEndPos
        };
    },
    onSelectionChanged: (tr, pluginState)=>{
        // Detect click outside the editor
        if (tr.getMeta('outsideProsemirrorEditorClicked')) return {
            ...pluginState,
            showToolbar: false,
            highlightContent: false
        };
        return pluginState;
    }
});
const $b9bdc9a4ee310342$export$656c7661095efe2e = $b9bdc9a4ee310342$var$dest.createPluginState;
const $b9bdc9a4ee310342$export$8d4021544bdece00 = $b9bdc9a4ee310342$var$dest.createCommand;
const $b9bdc9a4ee310342$export$f05434c51e3762e = $b9bdc9a4ee310342$var$dest.getPluginState;
const $b9bdc9a4ee310342$var$changedFormatFromToolbar = (tr)=>{
    const meta = tr.getMeta((0, $gwTAf.PASTE_OPTIONS_META_ID));
    if (meta && meta.type === (0, $h1M3d.PastePluginActionTypes).CHANGE_FORMAT) return true;
    return false;
};

});
parcelRegister("ltyiA", function(module, exports) {
$parcel$export(module.exports, "pasteOptionsPluginKey", () => $7942036bdb9316fd$export$2b71482310d8c520);
$parcel$export(module.exports, "ToolbarDropdownOption", () => $7942036bdb9316fd$export$ec4e67a10e59fca);

var $cw0wu = parcelRequire("cw0wu");
const $7942036bdb9316fd$export$2b71482310d8c520 = new (0, $cw0wu.PluginKey)('paste-options');
var $7942036bdb9316fd$export$ec4e67a10e59fca = /*#__PURE__*/ function(ToolbarDropdownOption) {
    ToolbarDropdownOption[ToolbarDropdownOption["Markdown"] = 0] = "Markdown";
    ToolbarDropdownOption[ToolbarDropdownOption["RichText"] = 1] = "RichText";
    ToolbarDropdownOption[ToolbarDropdownOption["PlainText"] = 2] = "PlainText";
    ToolbarDropdownOption[ToolbarDropdownOption["None"] = 3] = "None";
    return ToolbarDropdownOption;
}({});

});

parcelRegister("gwTAf", function(module, exports) {
$parcel$export(module.exports, "PASTE_TOOLBAR_CLASS", () => $96295aa6af613fbc$export$164821e1c3d789fd);
$parcel$export(module.exports, "TEXT_HIGHLIGHT_CLASS", () => $96295aa6af613fbc$export$78dda1ebb9a1ea84);
$parcel$export(module.exports, "PASTE_HIGHLIGHT_DECORATION_KEY", () => $96295aa6af613fbc$export$d829547aa567b0f1);
$parcel$export(module.exports, "PASTE_TOOLBAR_ITEM_CLASS", () => $96295aa6af613fbc$export$af443436fa5992cb);
$parcel$export(module.exports, "PASTE_OPTIONS_TEST_ID", () => $96295aa6af613fbc$export$299d35c5583816ad);
$parcel$export(module.exports, "PASTE_OPTIONS_META_ID", () => $96295aa6af613fbc$export$d1234a98f427930);
$parcel$export(module.exports, "PASTE_MENU_GAP_HORIZONTAL", () => $96295aa6af613fbc$export$b7100f42dfe6c945);
$parcel$export(module.exports, "PASTE_MENU_GAP_TOP", () => $96295aa6af613fbc$export$6b0e62d36c2a26b4);
const $96295aa6af613fbc$export$164821e1c3d789fd = 'ak-editor-paste-toolbar';
const $96295aa6af613fbc$export$81e541fc7755f475 = 'ak-editor-paste-toolbar-item-dropdownList';
const $96295aa6af613fbc$export$78dda1ebb9a1ea84 = 'text-highlight';
const $96295aa6af613fbc$export$d829547aa567b0f1 = 'paste-highlight-decoration-key';
const $96295aa6af613fbc$export$af443436fa5992cb = 'ak-editor-paste-toolbar-item';
const $96295aa6af613fbc$export$220f0307408bc0c = 'akEditor';
const $96295aa6af613fbc$export$299d35c5583816ad = 'paste-options-testid';
const $96295aa6af613fbc$export$d1234a98f427930 = 'paste-options$';
const $96295aa6af613fbc$export$b7100f42dfe6c945 = 8;
const $96295aa6af613fbc$export$6b0e62d36c2a26b4 = 24;

});

parcelRegister("kMZUQ", function(module, exports) {
$parcel$export(module.exports, "reducer", () => $09cb2d0315846788$export$1650419e431d3ba3);

var $h1M3d = parcelRequire("h1M3d");
const $09cb2d0315846788$export$1650419e431d3ba3 = (state, action)=>{
    switch(action.type){
        case (0, $h1M3d.PastePluginActionTypes).SHOW_PASTE_OPTIONS:
            return {
                ...state,
                showToolbar: true,
                showLegacyOptions: action.data.showLegacyOptions,
                pasteAncestorNodeNames: action.data.pasteAncestorNodeNames,
                highlightContent: false,
                isPlainText: action.data.isPlainText,
                plaintext: action.data.plaintext,
                selectedOption: action.data.selectedOption,
                richTextSlice: action.data.richTextSlice,
                pasteStartPos: action.data.pasteStartPos,
                pasteEndPos: action.data.pasteEndPos
            };
        case (0, $h1M3d.PastePluginActionTypes).HIDE_PASTE_OPTIONS:
            return {
                ...state,
                highlightContent: false,
                showToolbar: false
            };
        case (0, $h1M3d.PastePluginActionTypes).HIGHLIGHT_CONTENT:
            return {
                ...state,
                highlightContent: true
            };
        case (0, $h1M3d.PastePluginActionTypes).CHANGE_FORMAT:
            return {
                ...state,
                highlightContent: true,
                selectedOption: action.data.selectedOption
            };
        default:
            return state;
    }
};

});


parcelRegister("31lhd", function(module, exports) {
$parcel$export(module.exports, "formatMarkdown", () => $44e9f0a245996944$export$f9baf8679201c53f);
$parcel$export(module.exports, "formatRichText", () => $44e9f0a245996944$export$da9c2ff7c79a9eab);
$parcel$export(module.exports, "formatPlainText", () => $44e9f0a245996944$export$60ca0c8603a51ef1);

var $3J3tU = parcelRequire("3J3tU");

var $j2Y9J = parcelRequire("j2Y9J");

var $68s4D = parcelRequire("68s4D");

var $8BLsc = parcelRequire("8BLsc");

var $kW8qW = parcelRequire("kW8qW");

var $cw0wu = parcelRequire("cw0wu");

var $3DNV7 = parcelRequire("3DNV7");

var $3y2s4 = parcelRequire("3y2s4");

var $k5oTI = parcelRequire("k5oTI");
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $44e9f0a245996944$var$CODE_BLOCK_FENCE_REGEX = /```/;
const $44e9f0a245996944$export$f9baf8679201c53f = (tr, pluginState, markdownToPmConverter)=>{
    let pasteStartPos = pluginState.pasteStartPos;
    const pasteEndPos = pluginState.pasteEndPos;
    const plaintext = pluginState.plaintext;
    if (pasteStartPos < 0) return tr;
    const resolvedPasteStartPos = tr.doc.resolve(pasteStartPos);
    const parentOffset = resolvedPasteStartPos.parentOffset;
    if (parentOffset === 0 && resolvedPasteStartPos.depth > 0) pasteStartPos = resolvedPasteStartPos.before();
    const markdownSlice = $44e9f0a245996944$export$3f1f93abf0f3a57(plaintext, tr.doc.type.schema, tr.selection, markdownToPmConverter);
    if (!markdownSlice) return tr;
    $44e9f0a245996944$var$pasteSliceIntoTransactionWithSelectionAdjust({
        tr: tr,
        pasteStartPos: pasteStartPos,
        pasteEndPos: pasteEndPos,
        slice: markdownSlice
    });
    return tr;
};
const $44e9f0a245996944$export$da9c2ff7c79a9eab = (tr, pluginState)=>{
    let pasteStartPos = pluginState.pasteStartPos;
    const pasteEndPos = pluginState.pasteEndPos;
    const richTextSlice = pluginState.richTextSlice;
    if (pasteStartPos < 0) return tr;
    if (richTextSlice.content.size === 0) return tr;
    const resolvedPasteStartPos = tr.doc.resolve(pasteStartPos);
    const parentOffset = resolvedPasteStartPos.parentOffset;
    if (parentOffset === 0 && resolvedPasteStartPos.depth > 0) pasteStartPos = resolvedPasteStartPos.before();
    $44e9f0a245996944$var$richTextSliceTransactionWithSelectionAdjust({
        tr: tr,
        pasteStartPos: pasteStartPos,
        pasteEndPos: pasteEndPos,
        slice: richTextSlice
    });
    return tr;
};
const $44e9f0a245996944$export$60ca0c8603a51ef1 = (tr, pluginState)=>{
    let pasteStartPos = pluginState.pasteStartPos;
    const pasteEndPos = pluginState.pasteEndPos;
    const plaintext = pluginState.plaintext;
    //not possible to create plain text slice with empty string
    if (pasteStartPos < 0 || plaintext === '') return tr;
    const resolvedPasteStartPos = tr.doc.resolve(pasteStartPos);
    const parentOffset = resolvedPasteStartPos.parentOffset;
    if (parentOffset === 0 && resolvedPasteStartPos.depth > 0) pasteStartPos = resolvedPasteStartPos.before();
    const schema = tr.doc.type.schema;
    const plainTextNode = schema.text(plaintext);
    const plainTextFragment = (0, $kW8qW.Fragment).from(schema.nodes.paragraph.createAndFill(null, plainTextNode));
    const plainTextSlice = new (0, $kW8qW.Slice)(plainTextFragment, resolvedPasteStartPos.depth, resolvedPasteStartPos.depth);
    $44e9f0a245996944$var$pasteSliceIntoTransactionWithSelectionAdjust({
        tr: tr,
        pasteStartPos: pasteStartPos,
        pasteEndPos: pasteEndPos,
        slice: plainTextSlice
    });
    return tr;
};
function $44e9f0a245996944$var$pasteSliceIntoTransactionWithSelectionAdjust({ tr: tr, pasteStartPos: pasteStartPos, pasteEndPos: pasteEndPos, slice: slice }) {
    tr.replaceRange(pasteStartPos, pasteEndPos, slice);
    // ProseMirror doesn't give a proper way to tell us where something was inserted.
    // However, we can know "how" it inserted something.
    //
    // So, instead of weird depth calculations, we can use the step produced by the transform.
    // For instance:
    //    The `replaceStep.to and replaceStep.from`, tell us the real position
    //    where the content will be insert.
    //    Then, we can use the `tr.mapping.map` to the updated position after the replace operation
    const replaceStep = tr.steps[0];
    if (!(replaceStep instanceof (0, $3DNV7.ReplaceStep))) return tr;
    const lastInsertNode = replaceStep.slice.content.lastChild;
    const emptyNodeReference = lastInsertNode === null || lastInsertNode === void 0 ? void 0 : lastInsertNode.type.createAndFill();
    const isLastNodeEmpty = (emptyNodeReference === null || emptyNodeReference === void 0 ? void 0 : emptyNodeReference.nodeSize) === (lastInsertNode === null || lastInsertNode === void 0 ? void 0 : lastInsertNode.nodeSize);
    const isStepSplitingTarget = !(lastInsertNode !== null && lastInsertNode !== void 0 && lastInsertNode.isLeaf) && isLastNodeEmpty;
    const $nextHead = tr.doc.resolve(tr.mapping.map(replaceStep.to));
    const $nextPosition = isStepSplitingTarget && $nextHead.depth > 0 ? tr.doc.resolve($nextHead.before()) : $nextHead;
    // The findFrom will make search for both: TextSelection and NodeSelections.
    const nextSelection = (0, $cw0wu.Selection).findFrom($nextPosition, -1);
    if (nextSelection) tr.setSelection(nextSelection);
}
function $44e9f0a245996944$var$richTextSliceTransactionWithSelectionAdjust({ tr: tr, pasteStartPos: pasteStartPos, pasteEndPos: pasteEndPos, slice: slice }) {
    tr.replaceRange(pasteStartPos, pasteEndPos, slice);
    // ProseMirror doesn't give a proper way to tell us where something was inserted.
    // However, we can know "how" it inserted something.
    //
    // So, instead of weird depth calculations, we can use the step produced by the transform.
    // For instance:
    //    The `replaceStep.to and replaceStep.from`, tell us the real position
    //    where the content will be insert.
    //    Then, we can use the `tr.mapping.map` to the updated position after the replace operation
    const replaceStep = tr.steps[0];
    if (!(replaceStep instanceof (0, $3DNV7.ReplaceStep))) return tr;
    const nextPosition = tr.mapping.map(replaceStep.to);
    // The findFrom will make search for both: TextSelection and NodeSelections.
    const nextSelection = (0, $cw0wu.Selection).findFrom(tr.doc.resolve(Math.min(nextPosition, tr.doc.content.size)), -1);
    if (nextSelection) tr.setSelection(nextSelection);
}
function $44e9f0a245996944$export$3f1f93abf0f3a57(text, schema, selection, markdownToPmConverter) {
    const targetOpenStartNode = selection.$from.parent;
    const targetOpenEndNode = selection.$to.parent;
    try {
        var _doc$content$firstChi, _doc$content$lastChil;
        let textInput = text;
        const textSplitByCodeBlock = textInput.split($44e9f0a245996944$var$CODE_BLOCK_FENCE_REGEX);
        for(let i = 0; i < textSplitByCodeBlock.length; i++)if (i % 2 === 0) // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp, @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
        textSplitByCodeBlock[i] = textSplitByCodeBlock[i].replace(/\\/g, '\\\\');
        textInput = textSplitByCodeBlock.join('```');
        const doc = markdownToPmConverter && (0, $3y2s4.isExperimentEnabled)('platform_editor_paste_as_md_use_gfm') ? schema.nodes.doc.createAndFill({}, markdownToPmConverter({
            markdown: textInput,
            schema: schema
        })) : new (0, $8BLsc.MarkdownTransformer)(schema, (0, $68s4D.md)).parse((0, $k5oTI.escapeLinks)(textInput));
        if (!doc || !doc.content) return;
        const canMergeOpenStart = targetOpenStartNode.type === ((_doc$content$firstChi = doc.content.firstChild) === null || _doc$content$firstChi === void 0 ? void 0 : _doc$content$firstChi.type);
        const canMergeOpenEnd = targetOpenEndNode.type === ((_doc$content$lastChil = doc.content.lastChild) === null || _doc$content$lastChil === void 0 ? void 0 : _doc$content$lastChil.type);
        const $start = (0, $cw0wu.Selection).atStart(doc).$from;
        const $end = (0, $cw0wu.Selection).atEnd(doc).$from;
        const openStart = canMergeOpenStart ? $start.depth : 0;
        const openEnd = canMergeOpenEnd ? $end.depth : 0;
        return (0, $3J3tU.normalizeMarkdownCodeBlockAttrsInSlice)(new (0, $kW8qW.Slice)(doc.content, openStart, openEnd), schema);
    } catch (error) {
        (0, $j2Y9J.logException)(error, {
            location: 'editor-plugin-paste-options-toolbar/util'
        });
        return;
    }
}

});
parcelRegister("k5oTI", function(module, exports) {
$parcel$export(module.exports, "isPastedFromFabricEditor", () => $937701ece824cca8$export$6c3620a9f018c4e);
$parcel$export(module.exports, "escapeLinks", () => $937701ece824cca8$export$8acd10161c5f8b07);
$parcel$export(module.exports, "hasMediaNode", () => $937701ece824cca8$export$e7b0e22080760bf0);
$parcel$export(module.exports, "hasRuleNode", () => $937701ece824cca8$export$ec154944314bb7c);
$parcel$export(module.exports, "hasLinkMark", () => $937701ece824cca8$export$2d7feffd198c797d);
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $937701ece824cca8$var$ESCAPE_LINKS_URL_REGEX = /^(https?|ftp|jamfselfservice):\/\/[^\s"'>]+$/;
function $937701ece824cca8$export$6c3620a9f018c4e(pastedFrom) {
    return pastedFrom === 'fabric-editor';
}
function $937701ece824cca8$export$8acd10161c5f8b07(text) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return text.replace(/(\[([^\]]+)\]\()?((https?|ftp|jamfselfservice):\/\/[^\s"'>]+)/g, (str)=>{
        return str.match($937701ece824cca8$var$ESCAPE_LINKS_URL_REGEX) ? `<${str}>` : str;
    });
}
const $937701ece824cca8$export$e7b0e22080760bf0 = (slice)=>{
    if (!slice) return false;
    let hasMedia = false;
    slice.content.descendants((node)=>{
        if ([
            'media',
            'mediaInline',
            'mediaGroup',
            'mediaSingle'
        ].includes(node.type.name)) {
            hasMedia = true;
            return false;
        }
        return true;
    });
    return hasMedia;
};
const $937701ece824cca8$export$ec154944314bb7c = (slice, schema)=>{
    let hasRuleNode = false;
    slice.content.nodesBetween(0, slice.content.size, (node, start)=>{
        if (node.type === schema.nodes.rule) hasRuleNode = true;
    });
    return hasRuleNode;
};
const $937701ece824cca8$export$2d7feffd198c797d = (slice)=>{
    let hasLinkMark = false;
    slice.content.descendants((node)=>{
        var _node$marks;
        const marks = (_node$marks = node.marks) === null || _node$marks === void 0 ? void 0 : _node$marks.map((mark)=>mark.type.name);
        hasLinkMark = marks === null || marks === void 0 ? void 0 : marks.includes('link');
        if (hasLinkMark) //break out of loop
        return false;
    });
    return hasLinkMark;
};

});



parcelRegister("hTPtZ", function(module, exports) {
$parcel$export(module.exports, "createPlugin", () => $01091b41d759c935$export$ae829ec7b2625219);

var $f7Kk4 = parcelRequire("f7Kk4");

var $kW8qW = parcelRequire("kW8qW");

var $a3b9P = parcelRequire("a3b9P");

var $lKZTQ = parcelRequire("lKZTQ");

var $ltyiA = parcelRequire("ltyiA");

var $gwTAf = parcelRequire("gwTAf");

var $iKn9y = parcelRequire("iKn9y");
const $01091b41d759c935$var$MODIFIER_KEYS = new Set([
    'Shift',
    'Control',
    'Alt',
    'Meta',
    // Cmd on Mac, Win on Windows
    'CapsLock',
    'NumLock',
    'ScrollLock',
    'Fn',
    'FnLock'
]);
function $01091b41d759c935$var$isModifierKey(event) {
    return $01091b41d759c935$var$MODIFIER_KEYS.has(event.key);
}
function $01091b41d759c935$export$ae829ec7b2625219(dispatch, options) {
    return new (0, $f7Kk4.SafePlugin)({
        key: (0, $ltyiA.pasteOptionsPluginKey),
        state: (0, $iKn9y.createPluginState)(dispatch, {
            showToolbar: false,
            showLegacyOptions: false,
            pasteAncestorNodeNames: [],
            pasteStartPos: 0,
            pasteEndPos: 0,
            plaintext: '',
            isPlainText: false,
            highlightContent: false,
            highlightDecorationSet: (0, $a3b9P.DecorationSet).empty,
            richTextSlice: (0, $kW8qW.Slice).empty,
            selectedOption: (0, $ltyiA.ToolbarDropdownOption).None
        }),
        view (_editorView) {
            return {
                update (_view, prevState) {
                    return prevState;
                }
            };
        },
        props: {
            handleDOMEvents: {
                blur: (view)=>{
                    if (options !== null && options !== void 0 && options.useNewPasteMenu) return false;
                    (0, $lKZTQ.checkAndHideToolbar)(view);
                    return false;
                },
                // Hide toolbar when clicked anywhere within the editor, tr.getMeta('pointer') does not work if clicked on the same line after pasting so relying on mousedown event
                mousedown: (0, $lKZTQ.checkAndHideToolbar)
            },
            handleKeyDown: (view, event)=>{
                // Don't hide toolbar when pressing modifier keys alone (Ctrl, Shift, Alt, Meta/Cmd)
                if ($01091b41d759c935$var$isModifierKey(event)) return false;
                (0, $lKZTQ.checkAndHideToolbar)(view);
                return false;
            },
            decorations: (state)=>{
                var _pasteOptionsPluginKe;
                const { highlightContent: highlightContent, pasteStartPos: pasteStartPos } = (0, $ltyiA.pasteOptionsPluginKey).getState(state) || {};
                const decorationSet = ((_pasteOptionsPluginKe = (0, $ltyiA.pasteOptionsPluginKey).getState(state)) === null || _pasteOptionsPluginKe === void 0 ? void 0 : _pasteOptionsPluginKe.highlightDecorationSet) ?? (0, $a3b9P.DecorationSet).empty;
                if (!highlightContent) return decorationSet;
                const { selection: selection } = state.tr;
                const pasteEndPos = selection.$anchor.pos;
                const highlightDecoration = (0, $a3b9P.Decoration).inline(pasteStartPos, pasteEndPos, {
                    class: (0, $gwTAf.TEXT_HIGHLIGHT_CLASS)
                }, {
                    key: (0, $gwTAf.PASTE_HIGHLIGHT_DECORATION_KEY)
                });
                return decorationSet.add(state.doc, [
                    highlightDecoration
                ]);
            }
        }
    });
}

});

parcelRegister("lLiyp", function(module, exports) {
$parcel$export(module.exports, "firePasteActionsMenuExperimentExposure", () => $c6a84628c77983a9$export$899f54ccaa7b18cb);
parcelRequire("ixBwV");
var $eW8cK = parcelRequire("eW8cK");
const $c6a84628c77983a9$var$hasTableNode = (slice)=>{
    if (!slice) return false;
    let found = false;
    slice.content.descendants((node)=>{
        if (node.type.name === 'table') {
            found = true;
            return false;
        }
        return true;
    });
    return found;
};
const $c6a84628c77983a9$var$isNotProse = (text)=>{
    const trimmed = text.trim();
    if (!trimmed) return false;
    // Check each character: if we find whitespace it's prose-like,
    // if we find a non-ASCII character it's likely CJK/Thai/etc.
    for(let i = 0; i < trimmed.length; i++){
        const code = trimmed.charCodeAt(i);
        // Whitespace (space, tab, newline, etc.) → prose-like
        if (code === 0x20 || code === 0x09 || code === 0x0a || code === 0x0d) return false;
        // Non-ASCII character → likely a non-Latin script (CJK, Thai, etc.)
        if (code > 0x7f) return false;
    }
    // No whitespace and all ASCII → URL, token, path, etc.
    return true;
};
const $c6a84628c77983a9$export$899f54ccaa7b18cb = (contentLength, state, pasteStartPos, pasteEndPos, pastedText, pastedSlice)=>{
    if (contentLength < 100 || !pasteStartPos || !pasteEndPos || !pastedText) return;
    if ($c6a84628c77983a9$var$isNotProse(pastedText)) return;
    if ($c6a84628c77983a9$var$hasTableNode(pastedSlice)) return;
    try {
        const $pos = state.doc.resolve(pasteStartPos);
        const pasteAncestorNodeNames = [];
        for(let depth = $pos.depth; depth > 0; depth--)// Only include an ancestor if the entire pasted range is contained within it.
        // This prevents nodes like 'heading' from being flagged as ancestors when the
        // pasted content starts in a heading but extends beyond it (e.g. heading + paragraph).
        if (pasteEndPos <= $pos.end(depth)) pasteAncestorNodeNames.push($pos.node(depth).type.name);
        const isInExcludedNode = pasteAncestorNodeNames.some((name)=>[
                'codeBlock',
                'heading'
            ].includes(name));
        if (!isInExcludedNode) (0, $eW8cK.expVal)('platform_editor_paste_actions_menu', 'isEnabled', false);
    } catch  {
        // pasteStartPos may be out of bounds if the document changed between
        // when the paste was recorded and when this effect fires.
        return;
    }
};

});

parcelRegister("gvK5W", function(module, exports) {
$parcel$export(module.exports, "firePaste3pLinkActionsMenuExperimentExposure", () => $0ab4ca63ff5bc4fa$export$53261c09932390d5);
// Remove this file when experiment `confluence_editor_paste_3p_link_actions_menu` is cleaned up.
parcelRequire("ixBwV");
var $eW8cK = parcelRequire("eW8cK");

var $l5IID = parcelRequire("l5IID");
const $0ab4ca63ff5bc4fa$export$53261c09932390d5 = (pastedSlice)=>{
    if ((0, $l5IID.isNotSingleLink)(pastedSlice)) return;
    (0, $eW8cK.expVal)('confluence_editor_paste_3p_link_actions_menu', 'isEnabled', false);
};

});
parcelRegister("l5IID", function(module, exports) {
$parcel$export(module.exports, "isNotSingleLink", () => $d2b1b37fd60f2ea6$export$b9183df0a8583e6b);
/**
 * Returns true if the given text node's sole mark is a `link` mark whose href
 * matches the node's text content exactly (i.e. the link label IS the URL).
 * Or if the text content is a parseable URL.
 */ const $d2b1b37fd60f2ea6$var$isUrlOnlyLinkTextNode = (node)=>{
    var _node$marks$0$attrs;
    if (!node.isText) return false;
    if (node.marks.length !== 1 || node.marks[0].type.name !== 'link') return false;
    const href = ((_node$marks$0$attrs = node.marks[0].attrs) === null || _node$marks$0$attrs === void 0 ? void 0 : _node$marks$0$attrs.href) ?? '';
    // Check if the text content is a URL
    const textOfNode = node.text ?? '';
    const parseableUrl = $d2b1b37fd60f2ea6$var$isParseableUrl(textOfNode);
    return node.text === href || parseableUrl;
};
/**
 * Checks if a given string is parseable as a URL.
 */ const $d2b1b37fd60f2ea6$var$isParseableUrl = (text)=>{
    var _URL;
    if (typeof ((_URL = URL) === null || _URL === void 0 ? void 0 : _URL.canParse) === 'function') return URL.canParse(text);
    // Fallback for older environments
    try {
        new URL(text);
        return true;
    } catch (e) {
        return false;
    }
};
const $d2b1b37fd60f2ea6$var$isSupportedCard = (node)=>node.type.name === 'inlineCard' || node.type.name === 'blockCard' || node.type.name === 'embedCard';
const $d2b1b37fd60f2ea6$var$transparentSingleChildContainerNodeTypes = new Set([
    'paragraph',
    'listItem',
    'bulletList',
    'orderedList'
]);
/**
 * Returns the children of a Fragment, filtering out whitespace-only text nodes.
 * This handles trailing/leading spaces that browsers sometimes include when
 * copying a link (e.g. `<a href="...">URL</a> `).
 */ const $d2b1b37fd60f2ea6$var$significantChildren = (fragment)=>{
    const children = [];
    fragment.forEach((child)=>{
        var _child$text;
        if (child.isText && ((_child$text = child.text) === null || _child$text === void 0 ? void 0 : _child$text.trim()) === '') return;
        children.push(child);
    });
    return children;
};
/**
 * Returns true when the fragment contains exactly one meaningful leaf that
 * satisfies `isSupportedLeaf`.
 *
 * Transparent single-child containers (paragraph, listItem, bulletList, and
 * orderedList) are traversed recursively. Whitespace-only sibling text nodes
 * are ignored at each level.
 */ const $d2b1b37fd60f2ea6$var$containsExactlyOneMeaningfulLeaf = (fragment, isSupportedLeaf)=>{
    const children = $d2b1b37fd60f2ea6$var$significantChildren(fragment);
    if (children.length !== 1) return false;
    const [child] = children;
    if (isSupportedLeaf(child)) return true;
    if (!$d2b1b37fd60f2ea6$var$transparentSingleChildContainerNodeTypes.has(child.type.name)) return false;
    return $d2b1b37fd60f2ea6$var$containsExactlyOneMeaningfulLeaf(child.content, isSupportedLeaf);
};
const $d2b1b37fd60f2ea6$var$isSingleSmartLinkCard = (slice)=>$d2b1b37fd60f2ea6$var$containsExactlyOneMeaningfulLeaf(slice.content, $d2b1b37fd60f2ea6$var$isSupportedCard);
const $d2b1b37fd60f2ea6$var$isSingleBareLink = (slice)=>$d2b1b37fd60f2ea6$var$containsExactlyOneMeaningfulLeaf(slice.content, $d2b1b37fd60f2ea6$var$isUrlOnlyLinkTextNode);
const $d2b1b37fd60f2ea6$export$b9183df0a8583e6b = (slice)=>{
    if (!slice || !slice.content.size) // No rich-text slice → plain text paste, not a single link in the relevant sense
    return true;
    return !$d2b1b37fd60f2ea6$var$isSingleBareLink(slice) && !$d2b1b37fd60f2ea6$var$isSingleSmartLinkCard(slice);
};

});


parcelRegister("gejID", function(module, exports) {
$parcel$export(module.exports, "firePasteActionsMenuV2ExperimentExposure", () => $709770a74c876c36$export$3bc247e6ff3a4c32);
// Remove this file when experiment 'platform_editor_paste_actions_menu_v2' is cleaned up.
parcelRequire("ixBwV");
var $eW8cK = parcelRequire("eW8cK");

var $6vxF4 = parcelRequire("6vxF4");

var $22Mzi = parcelRequire("22Mzi");
const $709770a74c876c36$export$3bc247e6ff3a4c32 = (contentLength, state, pasteStartPos, pasteEndPos, pastedText, pastedSlice)=>{
    if (contentLength < 100 || !pasteStartPos || !pasteEndPos || !pastedText) return;
    if ((0, $22Mzi.isNotProse)(pastedText)) return;
    if ((0, $6vxF4.hasTableNode)(pastedSlice)) return;
    try {
        const $pos = state.doc.resolve(pasteStartPos);
        const pasteAncestorNodeNames = [];
        for(let depth = $pos.depth; depth > 0; depth--)if (pasteEndPos <= $pos.end(depth)) pasteAncestorNodeNames.push($pos.node(depth).type.name);
        const isInExcludedNode = pasteAncestorNodeNames.some((name)=>[
                'codeBlock',
                'heading'
            ].includes(name));
        if (!isInExcludedNode) (0, $eW8cK.expVal)('platform_editor_paste_actions_menu_v2', 'variant', 'control');
    } catch  {
        return;
    }
};

});
parcelRegister("6vxF4", function(module, exports) {
$parcel$export(module.exports, "hasTableNode", () => $017ab29b12b9eccf$export$44b7f57aaef7c0af);
const $017ab29b12b9eccf$export$44b7f57aaef7c0af = (slice)=>{
    if (!slice) return false;
    let found = false;
    slice.content.descendants((node)=>{
        if (node.type.name === 'table') {
            found = true;
            return false;
        }
        return true;
    });
    return found;
};

});

parcelRegister("22Mzi", function(module, exports) {
$parcel$export(module.exports, "isNotProse", () => $160676a462beed30$export$71535a792a9ee562);
const $160676a462beed30$export$71535a792a9ee562 = (text)=>{
    const trimmed = text.trim();
    if (!trimmed) return false;
    // Check each character: if we find whitespace it's prose-like,
    // if we find a non-ASCII character it's likely CJK/Thai/etc.
    for(let i = 0; i < trimmed.length; i++){
        const code = trimmed.charCodeAt(i);
        // Whitespace (space, tab, newline, etc.) → prose-like
        if (code === 0x20 || code === 0x09 || code === 0x0a || code === 0x0d) return false;
        // Non-ASCII character → likely a non-Latin script (CJK, Thai, etc.)
        if (code > 0x7f) return false;
    }
    // No whitespace and all ASCII → URL, token, path, etc.
    return true;
};

});


parcelRegister("3rUq9", function(module, exports) {
$parcel$export(module.exports, "PasteActionsMenu", () => $23476be08c2f8b45$export$8c1ff721ebf4b048);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $g6Qq4 = parcelRequire("g6Qq4");

var $5zk80 = parcelRequire("5zk80");

var $9xvBa = parcelRequire("9xvBa");

var $28qc1 = parcelRequire("28qc1");

var $4rzOL = parcelRequire("4rzOL");

var $cf2n1 = parcelRequire("cf2n1");

var $5beht = parcelRequire("5beht");

var $gab48 = parcelRequire("gab48");

var $5bbjm = parcelRequire("5bbjm");

var $7bYyx = parcelRequire("7bYyx");
parcelRequire("ixBwV");
var $eW8cK = parcelRequire("eW8cK");

var $lKZTQ = parcelRequire("lKZTQ");

var $gwTAf = parcelRequire("gwTAf");

var $ltyiA = parcelRequire("ltyiA");

var $dIL6F = parcelRequire("dIL6F");

var $l5IID = parcelRequire("l5IID");

var $di5Gz = parcelRequire("di5Gz");

var $cYR5e = parcelRequire("cYR5e");
const $23476be08c2f8b45$var$PopupWithListeners = (0, $cf2n1.default)((0, $5zk80.default));
const $23476be08c2f8b45$var$isAgentMentionUserType = (userType)=>userType === 'APP' || userType === 'AGENT';
const $23476be08c2f8b45$export$3d56f604f007aa63 = (slice)=>{
    if (!slice) return false;
    let hasAgentMention = false;
    slice.content.descendants((node)=>{
        if (node.type.name === 'mention' && $23476be08c2f8b45$var$isAgentMentionUserType(node.attrs.userType)) hasAgentMention = true;
    });
    return hasAgentMention;
};
const $23476be08c2f8b45$export$fa38ccb7191f761d = (slice)=>(0, $eW8cK.expVal)('platform_editor_agent_mentions', 'isEnabled', false) && $23476be08c2f8b45$export$3d56f604f007aa63(slice);
const $23476be08c2f8b45$export$6b1ad80f8062f971 = (slice)=>(0, $eW8cK.expVal)('platform_editor_fix_link_paste_menu', 'isEnabled', false) && !(0, $l5IID.isNotSingleLink)(slice ?? undefined);
function $23476be08c2f8b45$export$2562999169740ceb(editorView, pos) {
    try {
        const domRef = (0, $gab48.findDomRefAtPos)(pos, editorView.domAtPos.bind(editorView));
        if (domRef instanceof HTMLElement) {
            // Empty blocks render a <br> placeholder whose bounding rect has no
            // meaningful dimensions (height ≈ 0). Using it as the Popup anchor
            // causes the menu to appear at an unexpected position. Walk up to the
            // parent block element so the Popup anchors correctly.
            if (domRef.nodeName === 'BR' && domRef.parentElement) return domRef.parentElement;
            return domRef;
        }
        return null;
    } catch  {
        return null;
    }
}
function $23476be08c2f8b45$export$203646a3dfbc94aa(editorView, pos) {
    const $pos = editorView.state.doc.resolve(pos);
    for(let depth = $pos.depth; depth > 0; depth--){
        if ($pos.node(depth).type.name === 'table') return $pos.after(depth);
    }
    return undefined;
}
function $23476be08c2f8b45$export$8c670dfcca72be48(editorView, pasteEndPos, tableAfterPos) {
    const endCoords = editorView.coordsAtPos(pasteEndPos);
    let bottom = endCoords.bottom;
    if (tableAfterPos !== undefined) {
        const afterCoords = editorView.coordsAtPos(tableAfterPos);
        bottom = Math.max(bottom, afterCoords.bottom);
    }
    return bottom;
}
function $23476be08c2f8b45$export$69f2182d2b29f39f(editorView, pos) {
    try {
        const $pos = editorView.state.doc.resolve(pos);
        // Walk up the document tree from the resolved position's innermost
        // node towards the root. $pos.node(depth) gives the ancestor at each
        // depth; $pos.start(depth) gives the position just inside that ancestor,
        // so `$pos.start(depth) - 1` is the position of the ancestor node itself
        // (which is what nodeDOM expects).
        for(let depth = $pos.depth; depth >= 0; depth--){
            const node = $pos.node(depth);
            if (node.isBlock) {
                const domNode = editorView.nodeDOM($pos.start(depth) - 1);
                if (domNode instanceof HTMLElement) return domNode;
                // depth 0 is the doc node — nodeDOM(–1) won't work, so try
                // the editor's own DOM element as a fallback.
                if (depth === 0 && editorView.dom instanceof HTMLElement) return editorView.dom;
            }
        }
    } catch  {
    // Position may be out of range after a concurrent edit — fall through.
    }
    return null;
}
function $23476be08c2f8b45$export$725e0e72f273d89c(editorView, pasteEndPos, targetElement, popupContentRef) {
    return (position)=>{
        var _popupContentRef$curr;
        const endCoords = editorView.coordsAtPos(pasteEndPos);
        const targetRect = targetElement.getBoundingClientRect();
        // Vertical: center the menu with the line at the paste end position.
        const lineHeight = endCoords.bottom - endCoords.top;
        const lineMidpoint = endCoords.top + lineHeight / 2;
        const menuHeight = ((_popupContentRef$curr = popupContentRef.current) === null || _popupContentRef$curr === void 0 ? void 0 : _popupContentRef$curr.getBoundingClientRect().height) ?? lineHeight;
        const menuTop = lineMidpoint - menuHeight / 2;
        const topDelta = menuTop - (targetRect.top + targetRect.height);
        const adjustedTop = (position.top ?? 0) + topDelta;
        // Horizontal: position to the right of the cursor
        const leftDelta = endCoords.right - targetRect.right;
        const adjustedLeft = (position.left ?? 0) + leftDelta;
        return {
            ...position,
            top: adjustedTop,
            left: adjustedLeft
        };
    };
}
function $23476be08c2f8b45$export$d9eec7b6624484d8(editorView, pasteStartPos, pasteEndPos, targetElement, scrollableElement) {
    // Pre-compute once per render to avoid doc.resolve() on every scroll frame.
    const tableAfterPos = $23476be08c2f8b45$export$203646a3dfbc94aa(editorView, pasteEndPos);
    const blockAncestorDOM = $23476be08c2f8b45$export$69f2182d2b29f39f(editorView, pasteStartPos);
    return (position)=>{
        const startCoords = editorView.coordsAtPos(pasteStartPos);
        const endBottom = $23476be08c2f8b45$export$8c670dfcca72be48(editorView, pasteEndPos, tableAfterPos);
        const targetRect = targetElement.getBoundingClientRect();
        // ── Vertical adjustment ──────────────────────────────────────────
        // The Popup places the menu at the target's bottom edge by default.
        // We shift it up so it aligns with the paste start position.
        // Both coordinates are in viewport space, so the delta is offset-parent agnostic.
        const topDelta = startCoords.top - (targetRect.top + targetRect.height);
        let adjustedTop = (position.top ?? 0) + topDelta;
        // Sticky-top: clamp to the scroll container's top edge when the paste
        // start has scrolled above the visible area, but only while some pasted
        // content is still visible.
        if (scrollableElement) {
            const scrollContainerTop = scrollableElement.getBoundingClientRect().top;
            if (startCoords.top < scrollContainerTop && endBottom > scrollContainerTop) adjustedTop += scrollContainerTop - startCoords.top + (0, $gwTAf.PASTE_MENU_GAP_TOP);
        }
        // ── Horizontal adjustment ────────────────────────────────────────
        // When pasted content starts with a mark (bold, italic, link …) or
        // an inline node (emoji, smart link, inline image …),
        // findDomRefAtPos returns the narrow inline wrapper element. The
        // Popup's alignX="end" then places the menu at that element's right
        // edge instead of the content area's right edge. We correct this by
        // resolving the nearest block-level ProseMirror ancestor and
        // re-anchoring to its right edge.
        let adjustedLeft = position.left;
        if (blockAncestorDOM && blockAncestorDOM !== targetElement) {
            const blockRect = blockAncestorDOM.getBoundingClientRect();
            // Shift left by the difference between the block's right edge and
            // the inline target's right edge. This mirrors what alignX="end"
            // would have computed if the target were the block element.
            const leftDelta = blockRect.right - targetRect.right;
            adjustedLeft = (position.left ?? 0) + leftDelta;
        }
        return {
            ...position,
            top: adjustedTop,
            left: adjustedLeft
        };
    };
}
const $23476be08c2f8b45$export$8c1ff721ebf4b048 = ({ api: api, editorView: editorView, mountTo: mountTo, boundariesElement: boundariesElement, scrollableElement: scrollableElement })=>{
    var _api$analytics, _api$uiControlRegistr;
    const editorAnalyticsAPI = api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions;
    const { lastContentPasted: lastContentPasted } = (0, $5beht.useSharedPluginStateWithSelector)(api, [
        'paste'
    ], (states)=>{
        var _states$pasteState;
        return {
            lastContentPasted: (_states$pasteState = states.pasteState) === null || _states$pasteState === void 0 ? void 0 : _states$pasteState.lastContentPasted
        };
    });
    const sliceForAgentMentionSuppression = lastContentPasted === null || lastContentPasted === void 0 ? void 0 : lastContentPasted.sourcePastedSlice;
    const pasteMenuComponents = (api === null || api === void 0 || (_api$uiControlRegistr = api.uiControlRegistry) === null || _api$uiControlRegistr === void 0 ? void 0 : _api$uiControlRegistr.actions.getComponents((0, $4rzOL.PASTE_MENU).key)) ?? [];
    // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- pasteMenuComponents changes by reference each render; filter is small (< 10 items)
    const aiMenuItems = pasteMenuComponents.filter((c)=>{
        var _c$parents;
        return c.type === 'menu-item' && ((_c$parents = c.parents) === null || _c$parents === void 0 ? void 0 : _c$parents.some((p)=>p.key === (0, $4rzOL.AI_PASTE_MENU_SECTION).key));
    });
    const visibleAiActionKeys = (0, $di5Gz.getVisibleKeys)(aiMenuItems, [
        'menu-item'
    ]);
    const hasVisibleAiActions = visibleAiActionKeys.length > 0;
    const shouldSuppressPasteActions = (0, $bSJIT.useMemo)(()=>{
        const suppressForAgentMention = $23476be08c2f8b45$export$fa38ccb7191f761d(sliceForAgentMentionSuppression);
        const suppressForSingleLink = $23476be08c2f8b45$export$6b1ad80f8062f971(sliceForAgentMentionSuppression) && !hasVisibleAiActions;
        return suppressForAgentMention || suppressForSingleLink;
    }, [
        sliceForAgentMentionSuppression,
        hasVisibleAiActions
    ]);
    const prevShowToolbarRef = (0, $bSJIT.useRef)(false);
    const popupContentRef = (0, $bSJIT.useRef)(null);
    (0, $bSJIT.useEffect)(()=>{
        if (!lastContentPasted) {
            (0, $lKZTQ.hideToolbar)()(editorView.state, editorView.dispatch);
            return;
        }
        if (shouldSuppressPasteActions) {
            (0, $lKZTQ.hideToolbar)()(editorView.state, editorView.dispatch);
            return;
        }
        let selectedOption = (0, $ltyiA.ToolbarDropdownOption).None;
        if (!lastContentPasted.isPlainText) selectedOption = (0, $ltyiA.ToolbarDropdownOption).RichText;
        else if (lastContentPasted.isShiftPressed) selectedOption = (0, $ltyiA.ToolbarDropdownOption).PlainText;
        else selectedOption = (0, $ltyiA.ToolbarDropdownOption).Markdown;
        const $pos = editorView.state.doc.resolve(lastContentPasted.pasteStartPos);
        const pasteAncestorNodeNames = [];
        for(let depth = $pos.depth; depth > 0; depth--)// Only include an ancestor if the entire pasted range is contained within it.
        // This prevents nodes like 'heading' from being flagged as ancestors when the
        // pasted content starts in a heading but extends beyond it (e.g. heading + paragraph).
        if (lastContentPasted.pasteEndPos <= $pos.end(depth)) pasteAncestorNodeNames.push($pos.node(depth).type.name);
        const legacyVisible = (0, $dIL6F.isToolbarVisible)(editorView.state, lastContentPasted);
        (0, $lKZTQ.showToolbar)(lastContentPasted, selectedOption, legacyVisible, pasteAncestorNodeNames)(editorView.state, editorView.dispatch);
    }, [
        lastContentPasted,
        shouldSuppressPasteActions,
        editorView
    ]);
    const { showToolbar: isToolbarShown, pasteStartPos: pasteStartPos, pasteEndPos: pasteEndPos } = (0, $5beht.useSharedPluginStateWithSelector)(api, [
        'pasteOptionsToolbarPlugin'
    ], (states)=>{
        const pluginState = states.pasteOptionsToolbarPluginState;
        return {
            showToolbar: (pluginState === null || pluginState === void 0 ? void 0 : pluginState.showToolbar) ?? false,
            pasteStartPos: (pluginState === null || pluginState === void 0 ? void 0 : pluginState.pasteStartPos) ?? 0,
            pasteEndPos: (pluginState === null || pluginState === void 0 ? void 0 : pluginState.pasteEndPos) ?? 0
        };
    });
    const preventEditorFocusLoss = (0, $bSJIT.useCallback)((e)=>{
        e.preventDefault();
    }, []);
    const handleDismiss = (0, $bSJIT.useCallback)(()=>{
        (0, $lKZTQ.hideToolbar)()(editorView.state, editorView.dispatch);
    }, [
        editorView
    ]);
    const handleMouseEnter = (0, $bSJIT.useCallback)(()=>{
        (0, $lKZTQ.highlightContent)()(editorView.state, editorView.dispatch);
    }, [
        editorView
    ]);
    const handleClickOutside = (0, $bSJIT.useCallback)((evt)=>{
        if (evt.target instanceof Element) {
            const isInsideNestedDropdown = evt.target.closest('[data-toolbar-nested-dropdown-menu]');
            if (isInsideNestedDropdown) return;
        }
        handleDismiss();
    }, [
        handleDismiss
    ]);
    const handleSetIsOpen = (0, $bSJIT.useCallback)((isOpen)=>{
        if (!isOpen) handleDismiss();
    }, [
        handleDismiss
    ]);
    const shouldRenderToolbar = isToolbarShown && !shouldSuppressPasteActions;
    // Find the actual scroll container using the same utility the Popup's
    // stick prop uses internally. We pass this as the scrollableElement prop
    // so the Popup attaches its built-in scroll listener, which calls
    // scheduledUpdatePosition (RAF-throttled) on each scroll event — triggering
    // onPositionCalculated with fresh viewport coordinates.
    const overflowScrollParent = shouldRenderToolbar ? (0, $9xvBa.findOverflowScrollParent)(editorView.dom) : false;
    const effectiveScrollableElement = overflowScrollParent || scrollableElement;
    const anyComponentVisible = (0, $di5Gz.hasVisibleButton)(pasteMenuComponents);
    // Whether the card plugin's "Display as" section is visible when the menu opens.
    const displayAsVisible = (0, $di5Gz.getVisibleKeys)(pasteMenuComponents, [
        'menu-section'
    ]).includes((0, $4rzOL.SMART_LINK_DISPLAY_AS_PASTE_MENU_SECTION).key);
    // Two positioning modes:
    // 1. Inline: no AI actions visible — menu appears to the right of the cursor,
    //    vertically centered with the text line.
    // 2. Block-anchored: AI actions are visible — menu appears at the right edge
    //    of the content block, aligned with paste start.
    (0, $bSJIT.useEffect)(()=>{
        if (!prevShowToolbarRef.current && shouldRenderToolbar) editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.fireAnalyticsEvent({
            action: (0, $g6Qq4.ACTION).OPENED,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).PASTE_ACTIONS_MENU,
            eventType: (0, $g6Qq4.EVENT_TYPE).UI,
            attributes: {
                visibleAiActions: visibleAiActionKeys,
                displayAsVisible: displayAsVisible
            }
        });
        prevShowToolbarRef.current = shouldRenderToolbar;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        shouldRenderToolbar,
        editorAnalyticsAPI
    ]);
    const useInlinePosition = !hasVisibleAiActions;
    if (!shouldRenderToolbar) return null;
    if (!anyComponentVisible) return null;
    const target = $23476be08c2f8b45$export$2562999169740ceb(editorView, useInlinePosition ? pasteEndPos : pasteStartPos);
    if (!target) return null;
    // Choose positioning strategy based on whether the menu appears inline
    // (right of cursor for short pastes) or anchored to the block ancestor
    // (right side of content area for longer pastes / AI actions).
    let positionCalculator;
    try {
        positionCalculator = useInlinePosition ? $23476be08c2f8b45$export$725e0e72f273d89c(editorView, pasteEndPos, target, popupContentRef) : $23476be08c2f8b45$export$d9eec7b6624484d8(editorView, pasteStartPos, pasteEndPos, target, effectiveScrollableElement);
    } catch (error) {
        positionCalculator = (position)=>({
                ...position,
                top: position.top ?? 0
            });
    }
    return /*#__PURE__*/ (0, $dc70d.jsx)($23476be08c2f8b45$var$PopupWithListeners, {
        target: target,
        mountTo: mountTo,
        boundariesElement: boundariesElement,
        scrollableElement: effectiveScrollableElement,
        minPopupMargin: (0, $gwTAf.PASTE_MENU_GAP_HORIZONTAL),
        zIndex: (0, $5bbjm.akEditorFloatingPanelZIndex),
        alignX: "end",
        alignY: useInlinePosition ? 'top' : 'bottom',
        /* eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed) */ offset: [
            (0, $gwTAf.PASTE_MENU_GAP_HORIZONTAL),
            0
        ],
        onPositionCalculated: positionCalculator,
        handleClickOutside: handleClickOutside,
        handleEscapeKeydown: handleDismiss,
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $28qc1.EditorToolbarProvider), {
            editorView: editorView,
            children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $7bYyx.ToolbarDropdownMenuProvider), {
                isOpen: isToolbarShown,
                setIsOpen: handleSetIsOpen,
                children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $cYR5e.PasteActionsMenuContent), {
                    onMouseDown: preventEditorFocusLoss,
                    onMouseEnter: handleMouseEnter,
                    components: pasteMenuComponents,
                    contentRef: popupContentRef,
                    pastedSlice: lastContentPasted === null || lastContentPasted === void 0 ? void 0 : lastContentPasted.pastedSlice
                })
            })
        })
    });
};

});
parcelRegister("dIL6F", function(module, exports) {
$parcel$export(module.exports, "isToolbarVisible", () => $9d4517c0bfc1af92$export$208ad7410c805534);
$parcel$export(module.exports, "buildToolbar", () => $9d4517c0bfc1af92$export$6dd6ab35df8f7f86);

var $c1WE7 = parcelRequire("c1WE7");

var $5bbjm = parcelRequire("5bbjm");

var $kg4VT = parcelRequire("kg4VT");

var $3y2s4 = parcelRequire("3y2s4");

var $lKZTQ = parcelRequire("lKZTQ");

var $gwTAf = parcelRequire("gwTAf");

var $k5oTI = parcelRequire("k5oTI");

var $ltyiA = parcelRequire("ltyiA");
const $9d4517c0bfc1af92$var$TOP_LEVEL_LIST_NODE_NAMES = [
    'bulletList',
    'orderedList',
    'taskList'
];
/**
 * Pasting markdown lists leaves the cursor at doc > list > listItem > paragraph, so the
 * immediate grandparent is a listItem rather than the doc and the paste options are never
 * offered. Treat a list that is itself a direct child of the doc as top level, while still
 * excluding lists nested in other containers such as tables and panels.
 */ const $9d4517c0bfc1af92$var$isInsideTopLevelList = ($from)=>{
    if (!(0, $3y2s4.isExperimentEnabled)('platform_editor_markdown_conversion_improvements')) return false;
    if ($from.depth < 1) return false;
    return $9d4517c0bfc1af92$var$TOP_LEVEL_LIST_NODE_NAMES.includes($from.node(1).type.name);
};
const $9d4517c0bfc1af92$export$208ad7410c805534 = (state, lastContentPasted)=>{
    var _$from$parent, _$from$node, _state$schema$nodes$c;
    /**
   * Conditions for not showing the toolbar:
   * 1. Pasting link, media or text containing media(note: markdown link and images are allowed)
   * 2. Content is pasted in a nested node(i.e. inside a table, panel etc.).
   *    (grandParent node should be root doc for showing up the toolbar)
   * 3. Cursor is inside the codeblock.
   */ const $from = state.selection.$from;
    if ((0, $k5oTI.hasRuleNode)(lastContentPasted.pastedSlice, state.schema)) return false;
    const parentNodeType = (_$from$parent = $from.parent) === null || _$from$parent === void 0 ? void 0 : _$from$parent.type;
    const grandParentNodeType = (_$from$node = $from.node($from.depth - 1)) === null || _$from$node === void 0 ? void 0 : _$from$node.type;
    if (((grandParentNodeType === null || grandParentNodeType === void 0 ? void 0 : grandParentNodeType.name) === state.schema.nodes.doc.name || $9d4517c0bfc1af92$var$isInsideTopLevelList($from)) && parentNodeType.name !== ((_state$schema$nodes$c = state.schema.nodes.codeBlock) === null || _state$schema$nodes$c === void 0 ? void 0 : _state$schema$nodes$c.name) && !(0, $k5oTI.isPastedFromFabricEditor)(lastContentPasted.pasteSource) && !(0, $k5oTI.hasLinkMark)(lastContentPasted.pastedSlice) && !(0, $k5oTI.hasMediaNode)(lastContentPasted.pastedSlice)) return true;
    return false;
};
const $9d4517c0bfc1af92$export$aea1bbb5471be38f = (pluginState, intl, editorAnalyticsAPI, markdownToPmConverter)=>{
    const options = [
        {
            id: 'editor.paste.richText',
            title: intl.formatMessage((0, $c1WE7.pasteOptionsToolbarMessages).richText),
            selected: pluginState.selectedOption === (0, $ltyiA.ToolbarDropdownOption).RichText,
            hidden: pluginState.isPlainText,
            onClick: (0, $lKZTQ.changeToRichTextWithAnalytics)(editorAnalyticsAPI)()
        },
        {
            id: 'editor.paste.markdown',
            title: intl.formatMessage((0, $c1WE7.pasteOptionsToolbarMessages).markdown),
            selected: pluginState.selectedOption === (0, $ltyiA.ToolbarDropdownOption).Markdown,
            onClick: (0, $lKZTQ.changeToMarkdownWithAnalytics)(editorAnalyticsAPI, pluginState.plaintext.length, undefined, markdownToPmConverter)()
        },
        {
            id: 'editor.paste.plainText',
            title: intl.formatMessage((0, $c1WE7.pasteOptionsToolbarMessages).plainText),
            selected: pluginState.selectedOption === (0, $ltyiA.ToolbarDropdownOption).PlainText,
            onClick: (0, $lKZTQ.changeToPlainTextWithAnalytics)(editorAnalyticsAPI, pluginState.plaintext.length)()
        }
    ];
    return {
        id: (0, $gwTAf.PASTE_TOOLBAR_ITEM_CLASS),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($kg4VT))),
        type: 'dropdown',
        testId: (0, $gwTAf.PASTE_OPTIONS_TEST_ID),
        title: intl.formatMessage((0, $c1WE7.pasteOptionsToolbarMessages).pasteOptions),
        options: options,
        onToggle: $9d4517c0bfc1af92$var$onToggleHandler
    };
};
const $9d4517c0bfc1af92$var$onToggleHandler = (state, dispatch)=>{
    return (0, $lKZTQ.dropdownClickHandler)()(state, dispatch);
};
const $9d4517c0bfc1af92$export$6dd6ab35df8f7f86 = (state, intl, editorAnalyticsAPI, markdownToPmConverter)=>{
    const { schema: schema } = state;
    const validNodes = Object.values(schema.nodes);
    const pluginState = (0, $ltyiA.pasteOptionsPluginKey).getState(state);
    const menu = $9d4517c0bfc1af92$export$aea1bbb5471be38f(pluginState, intl, editorAnalyticsAPI, markdownToPmConverter);
    return {
        title: intl.formatMessage((0, $c1WE7.pasteOptionsToolbarMessages).pasteOptions),
        nodeType: validNodes,
        zIndex: (0, $5bbjm.akEditorFloatingPanelZIndex),
        className: (0, $gwTAf.PASTE_TOOLBAR_CLASS),
        items: [
            menu
        ],
        align: 'right',
        onPositionCalculated: $9d4517c0bfc1af92$var$onPositionCalculated
    };
};
const $9d4517c0bfc1af92$var$onPositionCalculated = (editorView, _nextPos)=>{
    const { from: from } = editorView.state.selection;
    const fromCoords = editorView.coordsAtPos(from);
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const toolbar = document.querySelector(`div[aria-label="${(0, $c1WE7.pasteOptionsToolbarMessages).pasteOptions.defaultMessage}"]`);
    const offsetParent = (toolbar === null || toolbar === void 0 ? void 0 : toolbar.offsetParent) || editorView.dom;
    const offsetParentRect = offsetParent === null || offsetParent === void 0 ? void 0 : offsetParent.getBoundingClientRect();
    const offsetTop = (offsetParentRect === null || offsetParentRect === void 0 ? void 0 : offsetParentRect.top) || 0;
    const offsetLeft = (offsetParentRect === null || offsetParentRect === void 0 ? void 0 : offsetParentRect.left) || 0;
    const offsetScrollTop = (offsetParent === null || offsetParent === void 0 ? void 0 : offsetParent.scrollTop) || 0;
    const cursorHeight = $9d4517c0bfc1af92$var$getCursorHeight(editorView, from);
    return {
        top: fromCoords.top - offsetTop + offsetScrollTop + cursorHeight,
        left: fromCoords.left - offsetLeft
    };
};
const $9d4517c0bfc1af92$var$getCursorHeight = (editorView, from)=>{
    const nodeAtFrom = editorView.domAtPos(from).node;
    const nearestNonTextNode = (nodeAtFrom === null || nodeAtFrom === void 0 ? void 0 : nodeAtFrom.nodeType) === Node.TEXT_NODE ? // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    nodeAtFrom.parentNode : // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    nodeAtFrom;
    return parseFloat(window.getComputedStyle(nearestNonTextNode, undefined).lineHeight || '');
};

});
parcelRegister("c1WE7", function(module, exports) {
$parcel$export(module.exports, "pasteOptionsToolbarMessages", () => $dd423ef824a161a3$export$703e803e9cb0cea4);

var $f0Pt4 = parcelRequire("f0Pt4");
const $dd423ef824a161a3$export$703e803e9cb0cea4 = (0, $f0Pt4.defineMessages)({
    pasteOptions: {
        id: 'fabric.editor.pasteOptions',
        defaultMessage: 'Paste options',
        description: 'Opens a menu with additional paste options'
    },
    plainText: {
        id: 'fabric.editor.plainText',
        defaultMessage: 'Use plain text',
        description: 'Label for the paste option button that strips all formatting and pastes content as plain text.'
    },
    markdown: {
        id: 'fabric.editor.useMarkdown',
        defaultMessage: 'Use Markdown',
        description: 'Label for the paste option button that pastes content with Markdown formatting preserved.'
    },
    richText: {
        id: 'fabric.editor.richText',
        defaultMessage: 'Use rich text',
        description: 'Label for the paste option button that pastes content preserving rich text formatting (e.g. bold, links, headings).'
    },
    plainTextAction: {
        id: 'fabric.editor.plainTextAction',
        defaultMessage: 'Plain text',
        description: 'Drop-down menu item label for the action that pastes the clipboard content as plain text, stripping all formatting.'
    },
    markdownAction: {
        id: 'fabric.editor.useMarkdownAction',
        defaultMessage: 'Markdown',
        description: 'Drop-down menu item label for the action that pastes the clipboard content with Markdown formatting applied.'
    },
    richTextAction: {
        id: 'fabric.editor.richTextAction',
        defaultMessage: 'Rich text',
        description: 'Drop-down menu item label for the action that pastes the clipboard content preserving rich text formatting.'
    },
    pasteMenuActionsTitle: {
        id: 'fabric.editor.pasteMenuActionsTitle',
        defaultMessage: 'Paste actions',
        description: 'Section title for actions in the paste options menu'
    },
    pasteMenuActionsPasteAs: {
        id: 'fabric.editor.pasteMenuActionsPasteAs',
        defaultMessage: 'Paste as',
        description: 'Submenu title to surface pasting options to paste content as Markdown, Rich text or Plain text'
    }
});

});


parcelRegister("di5Gz", function(module, exports) {
$parcel$export(module.exports, "getVisibleKeys", () => $6103345ceb479092$export$99cddee748d62c45);
$parcel$export(module.exports, "hasVisibleButton", () => $6103345ceb479092$export$159affd63ddd230e);
const $6103345ceb479092$var$isComponentOrAncestorHidden = (component, componentsByKey)=>{
    var _component$isHidden;
    if ((_component$isHidden = component.isHidden) !== null && _component$isHidden !== void 0 && _component$isHidden.call(component)) return true;
    return (component.parents ?? []).some((parent)=>{
        const parentComponent = componentsByKey.get(parent.key);
        return parentComponent ? $6103345ceb479092$var$isComponentOrAncestorHidden(parentComponent, componentsByKey) : false;
    });
};
const $6103345ceb479092$export$99cddee748d62c45 = (components, types = [
    'menu-item'
])=>{
    const componentsByKey = new Map(components.map((c)=>[
            c.key,
            c
        ]));
    return components.filter((c)=>types.includes(c.type)).filter((c)=>!$6103345ceb479092$var$isComponentOrAncestorHidden(c, componentsByKey)).map((c)=>c.key);
};
const $6103345ceb479092$export$159affd63ddd230e = (components)=>{
    return $6103345ceb479092$export$99cddee748d62c45(components).length > 0;
};

});

parcelRegister("cYR5e", function(module, exports) {
$parcel$export(module.exports, "PasteActionsMenuContent", () => $dff6812f07a5a79c$export$41585964872b7c);
/* PasteActionsMenuContent.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $4rzOL = parcelRequire("4rzOL");

var $3Aq92 = parcelRequire("3Aq92");

var $h6aQr = parcelRequire("h6aQr");

var $7fEzQ = parcelRequire("7fEzQ");

var $3y2s4 = parcelRequire("3y2s4");

var $9PwDt = parcelRequire("9PwDt");

var $1v9g6 = parcelRequire("1v9g6");

var $4mLXL = parcelRequire("4mLXL");
const $dff6812f07a5a79c$var$styles = {
    container: "_2rko12b0 _bfhk1bhr _16qs130s"
};
const $dff6812f07a5a79c$var$pasteMenuSurface = {
    type: (0, $4rzOL.PASTE_MENU).type,
    key: (0, $4rzOL.PASTE_MENU).key
};
const $dff6812f07a5a79c$export$41585964872b7c = ({ onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, components: components, contentRef: contentRef, pastedSlice: pastedSlice })=>{
    const setOutsideClickTargetRef = (0, $bSJIT.useContext)((0, $3Aq92.OutsideClickTargetRefContext));
    // Extract the pasted URL (if the pasted content was a single smart link).
    // Uses the reactive pasted slice from the paste plugin state so pastedUrl
    // updates when paste state changes.
    const pastedUrl = (0, $1v9g6.getSingleSmartLinkUrlFromSlice)(pastedSlice);
    // Components with isAsyncHidden are hidden until the async check resolves.
    // This prevents flash-of-visible content for items that
    // should ultimately be hidden. A generation counter discards stale results.
    const [asyncHiddenResults, setAsyncHiddenResults] = (0, $bSJIT.useState)(()=>{
        return Object.fromEntries(components.map((component)=>[
                component.key,
                true
            ]));
    });
    const generationRef = (0, $bSJIT.useRef)(0);
    (0, $bSJIT.useEffect)(()=>{
        const asyncComponents = [];
        for (const component of components)if (typeof component.isAsyncHidden === 'function') asyncComponents.push(component);
        if (asyncComponents.length === 0) {
            setAsyncHiddenResults({});
            return;
        }
        // Reset: mark all async components as hidden until this round resolves.
        const pending = {};
        for (const c of asyncComponents)pending[c.key] = true;
        setAsyncHiddenResults(pending);
        const generation = ++generationRef.current;
        const context = {
            pastedUrl: pastedUrl
        };
        (0, $4mLXL.evaluateAsyncHidden)(asyncComponents, context).then((results)=>{
            // Discard if a newer effect has already started.
            if (generation === generationRef.current) setAsyncHiddenResults(results);
        });
    }, [
        components,
        pastedUrl
    ]);
    // SurfaceRenderer evaluates isHidden() itself on each component. Override
    // isHidden on async components so SurfaceRenderer sees the resolved value.
    const visibleComponents = components.map((component)=>{
        if (typeof component.isAsyncHidden !== 'function') // No async check — pass through unchanged.
        return component;
        const asyncResult = asyncHiddenResults[component.key];
        return {
            ...component,
            isHidden: ()=>{
                var _component$isHidden;
                return asyncResult === true || Boolean((_component$isHidden = component.isHidden) === null || _component$isHidden === void 0 ? void 0 : _component$isHidden.call(component));
            }
        };
    });
    const mergedRef = (0, $bSJIT.useCallback)((node)=>{
        setOutsideClickTargetRef === null || setOutsideClickTargetRef === void 0 || setOutsideClickTargetRef(node);
        if (contentRef) contentRef.current = node;
    }, [
        setOutsideClickTargetRef,
        contentRef
    ]);
    if ((0, $3y2s4.isExperimentEnabled)('platform_editor_menu_radius_update')) return /*#__PURE__*/ (0, $dc70d.jsx)((0, $h6aQr.ToolbarMenuContainer), {
        ref: mergedRef,
        onMouseDown: onMouseDown,
        onMouseEnter: onMouseEnter,
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $7fEzQ.SurfaceRenderer), {
            surface: $dff6812f07a5a79c$var$pasteMenuSurface,
            components: visibleComponents
        })
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
        ref: mergedRef,
        xcss: $dff6812f07a5a79c$var$styles.container,
        onMouseDown: onMouseDown,
        onMouseEnter: onMouseEnter,
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $7fEzQ.SurfaceRenderer), {
            surface: $dff6812f07a5a79c$var$pasteMenuSurface,
            components: visibleComponents
        })
    });
};

});
parcelRegister("1v9g6", function(module, exports) {
$parcel$export(module.exports, "getSingleSmartLinkUrlFromSlice", () => $209683690531d103$export$6f4c320e305ef7dc);

var $l5IID = parcelRequire("l5IID");
const $209683690531d103$var$getUrlFromTextLinkNode = (node)=>{
    var _node$marks$0$attrs;
    if (!node.isText || node.marks.length !== 1 || node.marks[0].type.name !== 'link') return undefined;
    const href = (_node$marks$0$attrs = node.marks[0].attrs) === null || _node$marks$0$attrs === void 0 ? void 0 : _node$marks$0$attrs.href;
    return typeof href === 'string' && node.text === href ? href : undefined;
};
const $209683690531d103$var$getUrlFromCardNode = (node)=>{
    var _node$attrs, _node$attrs2;
    if (node.type.name !== 'inlineCard' && node.type.name !== 'blockCard' && node.type.name !== 'embedCard') return undefined;
    const url = ((_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.url) ?? ((_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 || (_node$attrs2 = _node$attrs2.data) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.url);
    return typeof url === 'string' ? url : undefined;
};
const $209683690531d103$var$significantChildren = (node)=>{
    const children = [];
    node.content.forEach((child)=>{
        var _child$text;
        if (child.isText && ((_child$text = child.text) === null || _child$text === void 0 ? void 0 : _child$text.trim()) === '') return;
        children.push(child);
    });
    return children;
};
const $209683690531d103$export$6f4c320e305ef7dc = (slice)=>{
    if (!slice || (0, $l5IID.isNotSingleLink)(slice)) return undefined;
    if (slice.content.childCount !== 1) return undefined;
    const topNode = slice.content.child(0);
    const topNodeUrl = $209683690531d103$var$getUrlFromTextLinkNode(topNode) ?? $209683690531d103$var$getUrlFromCardNode(topNode);
    if (topNodeUrl) return topNodeUrl;
    if (topNode.type.name !== 'paragraph') return undefined;
    const children = $209683690531d103$var$significantChildren(topNode);
    if (children.length !== 1) return undefined;
    return $209683690531d103$var$getUrlFromTextLinkNode(children[0]) ?? $209683690531d103$var$getUrlFromCardNode(children[0]);
};

});

parcelRegister("4mLXL", function(module, exports) {
$parcel$export(module.exports, "evaluateAsyncHidden", () => $cebe9af9bc9f0962$export$1e23d15f3989d9b2);
const $cebe9af9bc9f0962$export$d62a1f704dc41529 = 3000;
const $cebe9af9bc9f0962$var$hasAsyncHidden = (component)=>typeof component.isAsyncHidden === 'function';
const $cebe9af9bc9f0962$var$rejectOnTimeout = (promise, timeoutMs)=>{
    let timeoutId;
    const timeoutPromise = new Promise((_, reject)=>{
        timeoutId = setTimeout(()=>reject(new Error('isAsyncHidden timeout')), timeoutMs);
    });
    return Promise.race([
        promise.finally(()=>{
            if (timeoutId !== undefined) clearTimeout(timeoutId);
        }),
        timeoutPromise
    ]);
};
const $cebe9af9bc9f0962$var$evaluateComponentAsyncHidden = async (component, context)=>{
    try {
        const hidden = await $cebe9af9bc9f0962$var$rejectOnTimeout(component.isAsyncHidden(context), $cebe9af9bc9f0962$export$d62a1f704dc41529);
        return {
            key: component.key,
            hidden: hidden
        };
    } catch  {
        return {
            key: component.key,
            hidden: true
        };
    }
};
async function $cebe9af9bc9f0962$export$1e23d15f3989d9b2(components, context) {
    const results = await Promise.all(components.filter($cebe9af9bc9f0962$var$hasAsyncHidden).map((component)=>$cebe9af9bc9f0962$var$evaluateComponentAsyncHidden(component, context)));
    return Object.fromEntries(results.map(({ key: key, hidden: hidden })=>[
            key,
            hidden
        ]));
}

});



parcelRegister("eebPB", function(module, exports) {
$parcel$export(module.exports, "getPasteMenuComponents", () => $4eaec7e02e4582ac$export$fc33052900084a9d);
/* PasteMenuComponents.tsx generated by @compiled/babel-plugin v3.0.2 */ /* PasteMenuComponents.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $14TCm = parcelRequire("14TCm");

var $4vLTk = parcelRequire("4vLTk");

var $c1WE7 = parcelRequire("c1WE7");

var $28qc1 = parcelRequire("28qc1");

var $4rzOL = parcelRequire("4rzOL");

var $fiku8 = parcelRequire("fiku8");

var $5beht = parcelRequire("5beht");

var $dbuPt = parcelRequire("dbuPt");

var $dlk6h = parcelRequire("dlk6h");

var $1gwdz = parcelRequire("1gwdz");

var $4GWyU = parcelRequire("4GWyU");

var $l9Ysx = parcelRequire("l9Ysx");

var $kg4VT = parcelRequire("kg4VT");

var $9PwDt = parcelRequire("9PwDt");

var $lKZTQ = parcelRequire("lKZTQ");

var $ltyiA = parcelRequire("ltyiA");

var $di5Gz = parcelRequire("di5Gz");

var $iOXty = parcelRequire("iOXty");
const $4eaec7e02e4582ac$var$nestedMenuStyles = {
    narrowSection: "_10gv1lit"
};
const $4eaec7e02e4582ac$export$ca4999b34e9ed55a = (pasteType, selectedOption)=>{
    switch(pasteType){
        case 'rich-text':
            return selectedOption === (0, $ltyiA.ToolbarDropdownOption).RichText;
        case 'markdown':
            return selectedOption === (0, $ltyiA.ToolbarDropdownOption).Markdown;
        case 'plain-text':
            return selectedOption === (0, $ltyiA.ToolbarDropdownOption).PlainText;
        default:
            return false;
    }
};
const $4eaec7e02e4582ac$var$PasteMenuItem = ({ api: api, pasteType: pasteType, markdownToPmConverter: markdownToPmConverter })=>{
    var _api$analytics;
    const intl = (0, $4vLTk.default)();
    const { editorView: editorView } = (0, $28qc1.useEditorToolbar)();
    const editorAnalyticsAPI = api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions;
    const { selectedOption: selectedOption, plaintextLength: plaintextLength, isPlainText: isPlainText } = (0, $5beht.useSharedPluginStateWithSelector)(api, [
        'pasteOptionsToolbarPlugin'
    ], (states)=>{
        const pluginState = states.pasteOptionsToolbarPluginState;
        return {
            selectedOption: (pluginState === null || pluginState === void 0 ? void 0 : pluginState.selectedOption) ?? (0, $ltyiA.ToolbarDropdownOption).None,
            plaintextLength: (pluginState === null || pluginState === void 0 ? void 0 : pluginState.plaintextLength) ?? 0,
            isPlainText: (pluginState === null || pluginState === void 0 ? void 0 : pluginState.isPlainText) ?? false
        };
    });
    const getDefaultLabel = (0, $bSJIT.useCallback)((type)=>{
        switch(type){
            case 'rich-text':
                return intl.formatMessage((0, $c1WE7.pasteOptionsToolbarMessages).richTextAction);
            case 'markdown':
                return intl.formatMessage((0, $c1WE7.pasteOptionsToolbarMessages).markdownAction);
            case 'plain-text':
                return intl.formatMessage((0, $c1WE7.pasteOptionsToolbarMessages).plainTextAction);
            default:
                return type;
        }
    }, [
        intl
    ]);
    const handleClick = (0, $bSJIT.useCallback)((e)=>{
        e.preventDefault();
        if (!editorView) return;
        switch(pasteType){
            case 'rich-text':
                (0, $lKZTQ.changeToRichTextWithAnalytics)(editorAnalyticsAPI, 'pasteMenu')()(editorView.state, editorView.dispatch);
                break;
            case 'markdown':
                (0, $lKZTQ.changeToMarkdownWithAnalytics)(editorAnalyticsAPI, plaintextLength, 'pasteMenu', markdownToPmConverter)()(editorView.state, editorView.dispatch);
                break;
            case 'plain-text':
                (0, $lKZTQ.changeToPlainTextWithAnalytics)(editorAnalyticsAPI, plaintextLength, 'pasteMenu')()(editorView.state, editorView.dispatch);
                break;
        }
    }, [
        editorView,
        editorAnalyticsAPI,
        markdownToPmConverter,
        plaintextLength,
        pasteType
    ]);
    if (pasteType === 'rich-text' && isPlainText) return null;
    const displayLabel = getDefaultLabel(pasteType);
    const isSelected = $4eaec7e02e4582ac$export$ca4999b34e9ed55a(pasteType, selectedOption);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dbuPt.ToolbarDropdownItem), {
        onClick: handleClick,
        isSelected: isSelected,
        testId: `paste-${pasteType}-menu-item`,
        hasNestedDropdownMenu: true,
        children: displayLabel
    });
};
const $4eaec7e02e4582ac$var$PasteOptionsNestedMenu = ({ children: children, hasVisibleAiActions: hasVisibleAiActions })=>{
    const intl = (0, $4vLTk.default)();
    const label = intl.formatMessage((0, $c1WE7.pasteOptionsToolbarMessages).pasteMenuActionsPasteAs);
    if (!hasVisibleAiActions) return /*#__PURE__*/ (0, $dc70d.jsx)((0, $iOXty.PasteOptionsDropdownButton), {
        elemBefore: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kg4VT))), {
            size: "small",
            label: ""
        }),
        elemAfter: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4GWyU))), {
            size: "small",
            label: ""
        }),
        label: label,
        testId: "paste-options-nested-menu",
        tooltipContent: label,
        children: children
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $1gwdz.ToolbarNestedDropdownMenu), {
        elemBefore: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kg4VT))), {
            size: "small",
            label: label
        }),
        elemAfter: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($l9Ysx))), {
            size: "small",
            label: ""
        }),
        testId: "paste-options-nested-menu",
        text: label,
        children: children
    });
};
const $4eaec7e02e4582ac$var$getHasVisibleAiActions = (api)=>{
    var _api$uiControlRegistr;
    const allComponents = (api === null || api === void 0 || (_api$uiControlRegistr = api.uiControlRegistry) === null || _api$uiControlRegistr === void 0 ? void 0 : _api$uiControlRegistr.actions.getComponents((0, $4rzOL.PASTE_MENU).key)) ?? [];
    const aiMenuItems = allComponents.filter((c)=>{
        var _c$parents;
        return c.type === 'menu-item' && ((_c$parents = c.parents) === null || _c$parents === void 0 ? void 0 : _c$parents.some((p)=>p.key === (0, $4rzOL.AI_PASTE_MENU_SECTION).key));
    });
    return (0, $di5Gz.getVisibleKeys)(aiMenuItems, [
        'menu-item'
    ]).length > 0;
};
const $4eaec7e02e4582ac$export$fc33052900084a9d = ({ api: api, markdownToPmConverter: markdownToPmConverter })=>[
        {
            type: (0, $4rzOL.PASTE_MENU).type,
            key: (0, $4rzOL.PASTE_MENU).key
        },
        {
            type: (0, $4rzOL.PASTE_MENU_SECTION).type,
            key: (0, $4rzOL.PASTE_MENU_SECTION).key,
            parents: [
                {
                    type: (0, $4rzOL.PASTE_MENU).type,
                    key: (0, $4rzOL.PASTE_MENU).key,
                    rank: (0, $fiku8.PASTE_MENU_RANK)[(0, $4rzOL.PASTE_MENU_SECTION).key]
                }
            ],
            isHidden: ()=>{
                var _api$pasteOptionsTool;
                const pluginState = api === null || api === void 0 || (_api$pasteOptionsTool = api.pasteOptionsToolbarPlugin) === null || _api$pasteOptionsTool === void 0 ? void 0 : _api$pasteOptionsTool.sharedState.currentState();
                return !((pluginState === null || pluginState === void 0 ? void 0 : pluginState.showLegacyOptions) ?? false);
            },
            component: (props)=>{
                const hasVisibleAiActions = $4eaec7e02e4582ac$var$getHasVisibleAiActions(api);
                if (!hasVisibleAiActions) return /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
                    padding: "space.100",
                    children: props.children
                });
                return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dlk6h.ToolbarDropdownItemSection), {
                    hasSeparator: true,
                    children: props.children
                });
            }
        },
        {
            type: (0, $4rzOL.PASTE_NESTED_MENU).type,
            key: (0, $4rzOL.PASTE_NESTED_MENU).key,
            parents: [
                {
                    type: (0, $4rzOL.PASTE_MENU_SECTION).type,
                    key: (0, $4rzOL.PASTE_MENU_SECTION).key,
                    rank: (0, $fiku8.PASTE_MENU_SECTION_RANK)[(0, $4rzOL.PASTE_NESTED_MENU).key]
                }
            ],
            component: (props)=>{
                const hasVisibleAiActions = $4eaec7e02e4582ac$var$getHasVisibleAiActions(api);
                return /*#__PURE__*/ (0, $dc70d.jsx)($4eaec7e02e4582ac$var$PasteOptionsNestedMenu, {
                    hasVisibleAiActions: hasVisibleAiActions,
                    children: props.children
                });
            }
        },
        {
            type: (0, $4rzOL.PASTE_MENU_NESTED_SECTION).type,
            key: (0, $4rzOL.PASTE_MENU_NESTED_SECTION).key,
            parents: [
                {
                    type: (0, $4rzOL.PASTE_NESTED_MENU).type,
                    key: (0, $4rzOL.PASTE_NESTED_MENU).key,
                    rank: (0, $fiku8.PASTE_NESTED_MENU_RANK)[(0, $4rzOL.PASTE_MENU_NESTED_SECTION).key]
                }
            ],
            component: (props)=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
                    xcss: (0, $14TCm.cx)($4eaec7e02e4582ac$var$nestedMenuStyles.narrowSection),
                    children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $dlk6h.ToolbarDropdownItemSection), {
                        children: props.children
                    })
                })
        },
        {
            key: (0, $4rzOL.PASTE_RICH_TEXT_MENU_ITEM).key,
            type: (0, $4rzOL.PASTE_RICH_TEXT_MENU_ITEM).type,
            component: ()=>/*#__PURE__*/ (0, $dc70d.jsx)($4eaec7e02e4582ac$var$PasteMenuItem, {
                    api: api,
                    pasteType: "rich-text"
                }),
            parents: [
                {
                    key: (0, $4rzOL.PASTE_MENU_NESTED_SECTION).key,
                    type: (0, $4rzOL.PASTE_MENU_NESTED_SECTION).type,
                    rank: (0, $fiku8.PASTE_MENU_NESTED_SECTION_RANK)[(0, $4rzOL.PASTE_RICH_TEXT_MENU_ITEM).key]
                }
            ]
        },
        {
            key: (0, $4rzOL.PASTE_MARKDOWN_MENU_ITEM).key,
            type: (0, $4rzOL.PASTE_MARKDOWN_MENU_ITEM).type,
            component: ()=>/*#__PURE__*/ (0, $dc70d.jsx)($4eaec7e02e4582ac$var$PasteMenuItem, {
                    api: api,
                    markdownToPmConverter: markdownToPmConverter,
                    pasteType: "markdown"
                }),
            parents: [
                {
                    key: (0, $4rzOL.PASTE_MENU_NESTED_SECTION).key,
                    type: (0, $4rzOL.PASTE_MENU_NESTED_SECTION).type,
                    rank: (0, $fiku8.PASTE_MENU_NESTED_SECTION_RANK)[(0, $4rzOL.PASTE_MARKDOWN_MENU_ITEM).key]
                }
            ]
        },
        {
            key: (0, $4rzOL.PASTE_PLAIN_TEXT_MENU_ITEM).key,
            type: (0, $4rzOL.PASTE_PLAIN_TEXT_MENU_ITEM).type,
            component: ()=>/*#__PURE__*/ (0, $dc70d.jsx)($4eaec7e02e4582ac$var$PasteMenuItem, {
                    api: api,
                    pasteType: "plain-text"
                }),
            parents: [
                {
                    key: (0, $4rzOL.PASTE_MENU_NESTED_SECTION).key,
                    type: (0, $4rzOL.PASTE_MENU_NESTED_SECTION).type,
                    rank: (0, $fiku8.PASTE_MENU_NESTED_SECTION_RANK)[(0, $4rzOL.PASTE_PLAIN_TEXT_MENU_ITEM).key]
                }
            ]
        }
    ];

});
parcelRegister("iOXty", function(module, exports) {
$parcel$export(module.exports, "PasteOptionsDropdownButton", () => $f54f828fb5fafd3f$export$fb556e4963c45caa);
/* PasteOptionsDropdownButton.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $lkSXl = parcelRequire("lkSXl");

var $7cgYb = parcelRequire("7cgYb");

var $eHnl8 = parcelRequire("eHnl8");
const $f54f828fb5fafd3f$export$fb556e4963c45caa = ({ children: children, elemBefore: elemBefore, elemAfter: elemAfter, label: label, testId: testId, tooltipContent: tooltipContent })=>{
    const trigger = (0, $bSJIT.useCallback)((triggerProps)=>{
        const button = /*#__PURE__*/ (0, $dc70d.jsx)((0, $7cgYb.ToolbarButton), {
            ref: triggerProps.triggerRef,
            isSelected: triggerProps.isSelected,
            "aria-expanded": triggerProps['aria-expanded'],
            "aria-haspopup": triggerProps['aria-haspopup'],
            onClick: triggerProps.onClick,
            testId: testId,
            iconBefore: elemBefore,
            label: label,
            children: elemAfter
        });
        if (tooltipContent) return /*#__PURE__*/ (0, $dc70d.jsx)((0, $eHnl8.ToolbarTooltip), {
            content: tooltipContent,
            position: "top",
            children: button
        });
        return button;
    }, [
        testId,
        elemBefore,
        elemAfter,
        label,
        tooltipContent
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $lkSXl.default), {
        placement: "bottom-start",
        trigger: trigger,
        children: children
    });
};

});


parcelRegister("5bwFd", function(module, exports) {
$parcel$export(module.exports, "createPasteMenuRuleFactories", () => $3b123a35a8d18aca$export$aa0980ac1f3ab236);

var $dFtkv = parcelRequire("dFtkv");

var $6vxF4 = parcelRequire("6vxF4");

var $22Mzi = parcelRequire("22Mzi");

var $l5IID = parcelRequire("l5IID");
/**
 * Returns a rule that hides the paste-menu button when the pasted plain-text
 * is shorter than `minChars` characters.
 */ const $3b123a35a8d18aca$var$minCharsRule = (minChars)=>(context)=>context.getPlaintextLength() < minChars;
/**
 * Returns a rule that hides the paste-menu button when the pasted plain-text
 * is longer than `maxChars` characters.
 */ const $3b123a35a8d18aca$var$maxCharsRule = (maxChars)=>(context)=>context.getPlaintextLength() > maxChars;
/**
 * A rule that hides the paste-menu button when the pasted content is plain
 * text (i.e. not rich-text / prose).
 */ const $3b123a35a8d18aca$var$notProseRule = (context)=>{
    // The pasted slice being empty or missing indicates plain-text paste.
    const slice = context.getPastedSlice();
    const pastedText = context.getPastedText();
    return slice === undefined && (0, $22Mzi.isNotProse)(pastedText);
};
/**
 * A rule that hides the paste-menu button when the pasted content contains a
 * table node as an ancestor at the insertion point.
 */ const $3b123a35a8d18aca$var$containsTableRule = (context)=>(0, $6vxF4.hasTableNode)(context.getPastedSlice());
/**
 * Returns a rule that hides the paste-menu button when any of the provided
 * node names appear in the ancestor list at the insertion point.
 */ const $3b123a35a8d18aca$var$excludedAncestorRule = (excludedNames)=>(context)=>context.getAncestorNodeNames().some((name)=>excludedNames.includes(name));
/**
 * Returns a rule that hides the paste-menu button when the pasted content contains
 * more than one node type (e.g. a mix of paragraphs and headings, or a table
 * with multiple cell types).
 */ const $3b123a35a8d18aca$var$hideIfMixedNodesRule = (context)=>{
    const slice = context.getPastedSlice();
    if (!slice) return false;
    return (0, $dFtkv.hasMixedNodes)(slice);
};
/**
 * Returns a rule that hides the paste-menu button when the pasted content contains
 * only a single node type (e.g. a single paragraph, or a table with only one cell type).
 * This is the inverse of `hideIfMixedNodesRule` and can be used in combination with it
 * to target pastes that contain either exactly one node type or more than one node type.
 */ const $3b123a35a8d18aca$var$hideIfSingleNodeRule = (context)=>{
    const slice = context.getPastedSlice();
    if (!slice) return false;
    return !(0, $dFtkv.hasMixedNodes)(slice);
};
/**
 * A rule that hides the paste-menu button when the paste source is NOT an
 * external application (i.e. the content was pasted from within the Fabric
 * editor or renderer rather than from a third-party source).
 */ const $3b123a35a8d18aca$var$notExternalPasteRule = (context)=>{
    const source = context.getPasteSource();
    return source === 'fabric-editor' || source === 'fabric-renderer';
};
/**
 * A rule that hides the paste-menu button when the pasted content is a single
 * standalone link — i.e. a bare URL link (text equals href) alone in a
 * paragraph, or a single inline card (smartlink) alone in a paragraph.
 *
 * Returns `true` (hidden) when the paste is NOT a single link — e.g. a link
 * with a custom label, a link accompanied by other text or sibling nodes, or
 * multiple paragraphs.
 */ const $3b123a35a8d18aca$var$notSingleLinkRule = (context)=>(0, $l5IID.isNotSingleLink)(context.getPastedSlice());
/**
 * A rule that hides the paste-menu button when the pasted content IS a single
 * standalone link (the inverse of `notSingleLinkRule`).
 *
 * Use this to suppress buttons (e.g. Improve Writing, Fix Spelling) that
 * should not appear for single-link pastes.
 */ const $3b123a35a8d18aca$var$isSingleLinkRule = (context)=>!(0, $l5IID.isNotSingleLink)(context.getPastedSlice());
/**
 * Combines multiple context-aware rules with short-circuit evaluation.
 * Returns `true` (hidden) as soon as the first rule returns `true`; returns
 * `false` only when all rules return `false`.
 * Context is injected by `createPasteMenuRuleFactories` — callers never
 * construct or pass a context object.
 */ const $3b123a35a8d18aca$var$allRules = (...rules)=>(context)=>{
        for (const rule of rules){
            if (rule(context)) return true;
        }
        return false;
    };
/**
 * Binds a `PasteMenuRuleWithContext` to a context supplier, returning a
 * no-argument `PasteMenuRule` that re-reads the context on every invocation.
 */ const $3b123a35a8d18aca$var$bind = (getContext, rule)=>()=>rule(getContext());
const $3b123a35a8d18aca$export$aa0980ac1f3ab236 = (getContext)=>({
        allRules: (...rules)=>$3b123a35a8d18aca$var$bind(getContext, $3b123a35a8d18aca$var$allRules(...rules)),
        containsTableRule: $3b123a35a8d18aca$var$bind(getContext, $3b123a35a8d18aca$var$containsTableRule),
        excludedAncestorRule: (excludedNames)=>$3b123a35a8d18aca$var$bind(getContext, $3b123a35a8d18aca$var$excludedAncestorRule(excludedNames)),
        hideIfMixedNodesRule: $3b123a35a8d18aca$var$bind(getContext, $3b123a35a8d18aca$var$hideIfMixedNodesRule),
        hideIfSingleNodeRule: $3b123a35a8d18aca$var$bind(getContext, $3b123a35a8d18aca$var$hideIfSingleNodeRule),
        isSingleLinkRule: $3b123a35a8d18aca$var$bind(getContext, $3b123a35a8d18aca$var$isSingleLinkRule),
        maxCharsRule: (maxChars)=>$3b123a35a8d18aca$var$bind(getContext, $3b123a35a8d18aca$var$maxCharsRule(maxChars)),
        minCharsRule: (minChars)=>$3b123a35a8d18aca$var$bind(getContext, $3b123a35a8d18aca$var$minCharsRule(minChars)),
        notExternalPasteRule: $3b123a35a8d18aca$var$bind(getContext, $3b123a35a8d18aca$var$notExternalPasteRule),
        notProseRule: $3b123a35a8d18aca$var$bind(getContext, $3b123a35a8d18aca$var$notProseRule),
        notSingleLinkRule: $3b123a35a8d18aca$var$bind(getContext, $3b123a35a8d18aca$var$notSingleLinkRule)
    });

});
parcelRegister("dFtkv", function(module, exports) {
$parcel$export(module.exports, "hasMixedNodes", () => $9f90b5e77f47aa04$export$a88d571ef2c6a298);
/**
 * Structural container nodes are nodes whose children are determined by
 * document structure (e.g. list items inside a list, rows inside a table)
 * rather than by content choice. Having different child types inside these
 * nodes does NOT indicate mixed content.
 *
 * All other container nodes (blockTaskItem, blockquote, panel,
 * expand, layoutColumn, tableCell, tableHeader, bodiedExtension, etc.) hold
 * rich block content, so mixed block children inside them IS mixing.
 */ const $9f90b5e77f47aa04$var$STRUCTURAL_CONTAINERS = new Set([
    'bulletList',
    'orderedList',
    'listItem',
    'taskList',
    'decisionList',
    'table',
    'tableRow'
]);
/**
 * Returns true if a node's direct block-level children include more than one
 * distinct node type — i.e. the children are "mixed".
 */ const $9f90b5e77f47aa04$var$hasBlockSiblings = (node)=>{
    const types = new Set();
    node.forEach((child)=>{
        if (child.isBlock) types.add(child.type.name);
    });
    return types.size > 1;
};
const $9f90b5e77f47aa04$export$a88d571ef2c6a298 = (slice)=>{
    var _slice$content;
    if (!(slice !== null && slice !== void 0 && (_slice$content = slice.content) !== null && _slice$content !== void 0 && _slice$content.size)) return false;
    // Check the top-level children of the slice (Fragment has no parent Node,
    // so we construct a synthetic check by iterating slice.content directly).
    const topLevelTypes = new Set();
    slice.content.forEach((node)=>{
        if (node.isBlock) topLevelTypes.add(node.type.name);
    });
    if (topLevelTypes.size > 1) return true;
    // Walk every descendant node and check its direct block children for mixing,
    // skipping structural containers (their children are structural, not content).
    let mixed = false;
    slice.content.descendants((node)=>{
        if (mixed) return false; // short-circuit once found
        if ($9f90b5e77f47aa04$var$STRUCTURAL_CONTAINERS.has(node.type.name)) return true; // recurse into but don't check children for mixing
        if ($9f90b5e77f47aa04$var$hasBlockSiblings(node)) {
            mixed = true;
            return false;
        }
        return true;
    });
    return mixed;
};

});



parcelRegister("eN2ur", function(module, exports) {
$parcel$export(module.exports, "rulePlugin", () => $30016e183d4075e9$export$7cc71f8da095a98d);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $et9pQ = parcelRequire("et9pQ");

var $g6Qq4 = parcelRequire("g6Qq4");

var $5BUNL = parcelRequire("5BUNL");

var $cW1gB = parcelRequire("cW1gB");

var $3y2s4 = parcelRequire("3y2s4");

var $gdUUy = parcelRequire("gdUUy");

var $a0Uv8 = parcelRequire("a0Uv8");

var $lA8Bu = parcelRequire("lA8Bu");

var $2m3sl = parcelRequire("2m3sl");

var $hpbmj = parcelRequire("hpbmj");

var $jQGN7 = parcelRequire("jQGN7");
const $30016e183d4075e9$export$7cc71f8da095a98d = ({ api: api })=>{
    var _api$analytics;
    const isRegisteredSlashCommandEnabled = (0, $3y2s4.isExperimentEnabled)('platform_editor_slash_command');
    if (isRegisteredSlashCommandEnabled) {
        var _api$uiControlRegistr;
        api === null || api === void 0 || (_api$uiControlRegistr = api.uiControlRegistry) === null || _api$uiControlRegistr === void 0 || _api$uiControlRegistr.actions.register((0, $hpbmj.getRuleQuickInsertComponents)({
            api: api
        }));
    }
    return {
        name: 'rule',
        nodes () {
            return [
                {
                    name: 'rule',
                    node: (0, $3y2s4.isExperimentEnabled)('platform_editor_lovability_dividers_attributes') ? (0, $et9pQ.ruleWithAttrs) : (0, $gdUUy.fg)('platform_editor_adf_with_localid') ? (0, $et9pQ.ruleWithLocalId) : (0, $et9pQ.rule)
                }
            ];
        },
        actions: {
            insertHorizontalRule: (0, $a0Uv8.insertHorizontalRule)(api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions)
        },
        pmPlugins () {
            return [
                {
                    name: 'ruleInputRule',
                    plugin: ({ schema: schema })=>{
                        var _api$analytics2;
                        return (0, $lA8Bu.default)(schema, api === null || api === void 0 || (_api$analytics2 = api.analytics) === null || _api$analytics2 === void 0 ? void 0 : _api$analytics2.actions);
                    }
                },
                {
                    name: 'ruleKeymap',
                    plugin: ()=>{
                        var _api$analytics3;
                        return (0, $2m3sl.default)(api === null || api === void 0 || (_api$analytics3 = api.analytics) === null || _api$analytics3 === void 0 ? void 0 : _api$analytics3.actions);
                    }
                }
            ];
        },
        pluginsOptions: {
            ...(0, $3y2s4.isExperimentEnabled)('platform_editor_lovability_dividers') ? {
                floatingToolbar: (state, intl)=>(0, $jQGN7.getToolbarConfig)(state, intl, api)
            } : {},
            quickInsert: isRegisteredSlashCommandEnabled ? undefined : ({ formatMessage: formatMessage })=>[
                    {
                        id: 'rule',
                        title: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).horizontalRule),
                        description: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).horizontalRuleDescription),
                        keywords: [
                            'horizontal',
                            'rule',
                            'line',
                            'hr'
                        ],
                        priority: 1200,
                        keyshortcut: '---',
                        icon: ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $5BUNL.IconDivider), {}),
                        action (insert, state, source) {
                            var _api$analytics4;
                            const tr = insert(state.schema.nodes.rule.createChecked());
                            api === null || api === void 0 || (_api$analytics4 = api.analytics) === null || _api$analytics4 === void 0 || _api$analytics4.actions.attachAnalyticsEvent({
                                action: (0, $g6Qq4.ACTION).INSERTED,
                                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).DOCUMENT,
                                actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).DIVIDER,
                                attributes: {
                                    inputMethod: source ?? (0, $g6Qq4.INPUT_METHOD).QUICK_INSERT
                                },
                                eventType: (0, $g6Qq4.EVENT_TYPE).TRACK
                            })(tr);
                            return tr;
                        }
                    }
                ]
        }
    };
};

});
parcelRegister("a0Uv8", function(module, exports) {
$parcel$export(module.exports, "insertHorizontalRule", () => $fdebf8bab6fa72bb$export$439dcefd29ca03b3);
$parcel$export(module.exports, "removeHorizontalRule", () => $fdebf8bab6fa72bb$export$93942a466902d058);
$parcel$export(module.exports, "updateHorizontalRuleWeight", () => $fdebf8bab6fa72bb$export$e55d67c4985f2966);
$parcel$export(module.exports, "updateHorizontalRuleStyle", () => $fdebf8bab6fa72bb$export$f1274b300007451f);
$parcel$export(module.exports, "updateHorizontalRuleColor", () => $fdebf8bab6fa72bb$export$69bf1c5ef9e8c26b);

var $g6Qq4 = parcelRequire("g6Qq4");

var $gab48 = parcelRequire("gab48");

var $5WjjR = parcelRequire("5WjjR");

var $lA8Bu = parcelRequire("lA8Bu");
const $fdebf8bab6fa72bb$export$439dcefd29ca03b3 = (editorAnalyticsAPI)=>(inputMethod)=>(state, dispatch)=>{
            const tr = (0, $lA8Bu.createHorizontalRule)(state, state.selection.from, state.selection.to, inputMethod, editorAnalyticsAPI);
            if (tr) {
                if (dispatch) dispatch(tr);
                return true;
            }
            return false;
        };
const $fdebf8bab6fa72bb$export$93942a466902d058 = (editorAnalyticsAPI)=>(state, dispatch)=>{
        const { rule: rule } = state.schema.nodes;
        if (!(0, $gab48.findSelectedNodeOfType)(rule)(state.selection)) return false;
        if (dispatch) {
            const deleteTr = (0, $gab48.removeSelectedNode)(state.tr);
            const payload = {
                action: (0, $g6Qq4.ACTION).DELETED,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).DIVIDER,
                attributes: {
                    inputMethod: (0, $g6Qq4.INPUT_METHOD).FLOATING_TB
                },
                eventType: (0, $g6Qq4.EVENT_TYPE).TRACK
            };
            editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent(payload)(deleteTr);
            dispatch(deleteTr);
        }
        return true;
    };
const $fdebf8bab6fa72bb$export$e55d67c4985f2966 = (weight, editorAnalyticsAPI)=>(state, dispatch)=>{
        const { rule: rule } = state.schema.nodes;
        const selectedRule = (0, $gab48.findSelectedNodeOfType)(rule)(state.selection);
        if (!selectedRule) return false;
        const previousWeight = selectedRule.node.attrs.weight ?? (0, $5WjjR.DEFAULT_DIVIDER_WEIGHT);
        if (previousWeight === weight) return true;
        if (dispatch) {
            const updateTr = state.tr.setNodeMarkup(selectedRule.pos, undefined, {
                ...selectedRule.node.attrs,
                weight: weight
            });
            editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent({
                action: (0, $g6Qq4.ACTION).UPDATED,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).DIVIDER,
                attributes: {
                    inputMethod: (0, $g6Qq4.INPUT_METHOD).FLOATING_TB,
                    previousWeight: previousWeight,
                    weight: weight
                },
                eventType: (0, $g6Qq4.EVENT_TYPE).TRACK
            })(updateTr);
            dispatch(updateTr);
        }
        return true;
    };
const $fdebf8bab6fa72bb$export$f1274b300007451f = (style, editorAnalyticsAPI)=>(state, dispatch)=>{
        const { rule: rule } = state.schema.nodes;
        const selectedRule = (0, $gab48.findSelectedNodeOfType)(rule)(state.selection);
        if (!selectedRule) return false;
        const previousStyle = selectedRule.node.attrs.style ?? (0, $5WjjR.DEFAULT_DIVIDER_STYLE);
        if (previousStyle === style) return true;
        if (dispatch) {
            const updateTr = state.tr.setNodeMarkup(selectedRule.pos, undefined, {
                ...selectedRule.node.attrs,
                style: style
            });
            editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent({
                action: (0, $g6Qq4.ACTION).UPDATED,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).DIVIDER,
                attributes: {
                    inputMethod: (0, $g6Qq4.INPUT_METHOD).FLOATING_TB,
                    previousStyle: previousStyle,
                    style: style
                },
                eventType: (0, $g6Qq4.EVENT_TYPE).TRACK
            })(updateTr);
            dispatch(updateTr);
        }
        return true;
    };
const $fdebf8bab6fa72bb$export$69bf1c5ef9e8c26b = (color, editorAnalyticsAPI)=>(state, dispatch)=>{
        const { rule: rule } = state.schema.nodes;
        const selectedRule = (0, $gab48.findSelectedNodeOfType)(rule)(state.selection);
        if (!selectedRule) return false;
        const defaultColor = "var(--ds-border, #0B120E24)";
        const previousColor = typeof selectedRule.node.attrs.color === 'string' ? selectedRule.node.attrs.color : null;
        const updatedColor = color === defaultColor ? null : color;
        if (previousColor === updatedColor) return true;
        if (dispatch) {
            const updateTr = state.tr.setNodeMarkup(selectedRule.pos, undefined, {
                ...selectedRule.node.attrs,
                color: updatedColor
            });
            editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent({
                action: (0, $g6Qq4.ACTION).UPDATED,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).DIVIDER,
                attributes: {
                    inputMethod: (0, $g6Qq4.INPUT_METHOD).FLOATING_TB,
                    previousColor: previousColor,
                    color: updatedColor
                },
                eventType: (0, $g6Qq4.EVENT_TYPE).TRACK
            })(updateTr);
            dispatch(updateTr);
        }
        return true;
    };

});
parcelRegister("5WjjR", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_DIVIDER_STYLE", () => $14727768c3a14d69$export$18afedb55d187f64);
$parcel$export(module.exports, "DEFAULT_DIVIDER_WEIGHT", () => $14727768c3a14d69$export$c51e6b91f3cc81af);
const $14727768c3a14d69$export$18afedb55d187f64 = 'solid';
const $14727768c3a14d69$export$c51e6b91f3cc81af = 2;

});

parcelRegister("lA8Bu", function(module, exports) {
$parcel$export(module.exports, "createHorizontalRule", () => $10ef345c0377908e$export$718ed5cb714e84ae);
$parcel$export(module.exports, "default", () => $10ef345c0377908e$export$2e2bcd8739ae039);

var $g6Qq4 = parcelRequire("g6Qq4");

var $dw0oh = parcelRequire("dw0oh");

var $f7Kk4 = parcelRequire("f7Kk4");

var $33v8M = parcelRequire("33v8M");

var $kW8qW = parcelRequire("kW8qW");

var $gab48 = parcelRequire("gab48");

var $b9BdF = parcelRequire("b9BdF");

var $8t09p = parcelRequire("8t09p");
const $10ef345c0377908e$export$718ed5cb714e84ae = (state, start, end, inputMethod, editorAnalyticsAPI)=>{
    if (!state.selection.empty) return null;
    let tr = null;
    const { rule: rule } = state.schema.nodes;
    /**
   * This is a workaround to get rid of the typeahead text when using quick insert
   * Once we insert *nothing*, we get a new transaction, so we can use the new selection
   * without considering the extra text after the `/` command.
   **/ tr = state.tr.replaceWith(start, end, (0, $kW8qW.Fragment).empty);
    tr = (0, $dw0oh.safeInsert)(rule.createChecked(), tr.selection.from)(tr);
    if (!tr) tr = state.tr.replaceRange(start, end, new (0, $kW8qW.Slice)((0, $kW8qW.Fragment).from(state.schema.nodes.rule.createChecked()), 0, 0));
    editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent({
        action: (0, $g6Qq4.ACTION).INSERTED,
        actionSubject: (0, $g6Qq4.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).DIVIDER,
        attributes: {
            inputMethod: inputMethod
        },
        eventType: (0, $g6Qq4.EVENT_TYPE).TRACK
    })(tr);
    return tr;
};
const $10ef345c0377908e$var$createHorizontalRuleAutoformat = (state, start, end, editorAnalyticsAPI)=>{
    const { listItem: listItem } = state.schema.nodes;
    if ((0, $gab48.hasParentNodeOfType)(listItem)(state.selection)) return null;
    return $10ef345c0377908e$export$718ed5cb714e84ae(state, start, end, (0, $g6Qq4.INPUT_METHOD).FORMATTING, editorAnalyticsAPI);
};
// eslint-disable-next-line require-unicode-regexp
const $10ef345c0377908e$var$HORIZONTAL_RULE_AUTOFORMAT_REGEX = /^(---|\*\*\*)$/;
function $10ef345c0377908e$export$568a7ed6897c4817(schema, editorAnalyticsAPI) {
    const rules = [];
    if (schema.nodes.rule) {
        // '---' and '***' for hr
        rules.push((0, $33v8M.createRule)($10ef345c0377908e$var$HORIZONTAL_RULE_AUTOFORMAT_REGEX, (state, _match, start, end)=>$10ef345c0377908e$var$createHorizontalRuleAutoformat(state, start, end, editorAnalyticsAPI)));
        // '---' and '***' after shift+enter for hr
        rules.push((0, $33v8M.createRule)(// Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        new RegExp(`${(0, $b9BdF.leafNodeReplacementCharacter)}(\\-\\-\\-|\\*\\*\\*)`), (state, _match, start, end)=>{
            const { hardBreak: hardBreak } = state.schema.nodes;
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            if (state.doc.resolve(start).nodeAfter.type !== hardBreak) return null;
            return $10ef345c0377908e$var$createHorizontalRuleAutoformat(state, start, end, editorAnalyticsAPI);
        }));
    }
    if (rules.length !== 0) return new (0, $f7Kk4.SafePlugin)((0, $8t09p.createPlugin)('rule', rules, {
        isBlockNodeRule: true
    }));
    return;
}
var $10ef345c0377908e$export$2e2bcd8739ae039 = $10ef345c0377908e$export$568a7ed6897c4817;

});


parcelRegister("2m3sl", function(module, exports) {
$parcel$export(module.exports, "default", () => $256dfd807c03e158$export$2e2bcd8739ae039);

var $g6Qq4 = parcelRequire("g6Qq4");

var $cv8id = parcelRequire("cv8id");

var $ejrfk = parcelRequire("ejrfk");

var $a0Uv8 = parcelRequire("a0Uv8");
function $256dfd807c03e158$export$e832373cff8dec22(editorAnalyticsAPI) {
    const list = {};
    (0, $cv8id.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $cv8id.insertRule).common, (0, $a0Uv8.insertHorizontalRule)(editorAnalyticsAPI)((0, $g6Qq4.INPUT_METHOD).SHORTCUT), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $cv8id.bindKeymapWithCommand)((0, $cv8id.escape).common, ()=>true, list);
    return (0, $ejrfk.keymap)(list);
}
var $256dfd807c03e158$export$2e2bcd8739ae039 = $256dfd807c03e158$export$e832373cff8dec22;

});

parcelRegister("hpbmj", function(module, exports) {
$parcel$export(module.exports, "getRuleQuickInsertComponents", () => $bec4b4c3026203f3$export$5dfa902850534ff5);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $cW1gB = parcelRequire("cW1gB");

var $b8Hvx = parcelRequire("b8Hvx");

var $9woaI = parcelRequire("9woaI");

var $am2Qg = parcelRequire("am2Qg");

var $2EsG7 = parcelRequire("2EsG7");
const $bec4b4c3026203f3$var$previewImageUrls = {
    light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVL8.png',
    dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVK1.png'
};
const $bec4b4c3026203f3$export$5dfa902850534ff5 = ({ api: api })=>[
        {
            key: (0, $9woaI.RULE_MENU_ITEM).key,
            type: (0, $9woaI.RULE_MENU_ITEM).type,
            parents: [
                {
                    key: (0, $9woaI.STRUCTURE_SECTION).key,
                    type: (0, $9woaI.STRUCTURE_SECTION).type,
                    rank: (0, $am2Qg.STRUCTURE_SECTION_RANK)[(0, $9woaI.RULE_MENU_ITEM).key]
                }
            ],
            match: (0, $b8Hvx.createQuickInsertMatcher)(({ formatMessage: formatMessage })=>({
                    description: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).horizontalRuleDescription),
                    keywords: [
                        'horizontal',
                        'rule',
                        'line',
                        'hr'
                    ],
                    shortcut: '---',
                    title: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).horizontalRule)
                })),
            component: ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $2EsG7.RuleQuickInsertMenuItem), {
                    api: api,
                    previewImageUrls: $bec4b4c3026203f3$var$previewImageUrls
                })
        }
    ];

});
parcelRegister("2EsG7", function(module, exports) {
$parcel$export(module.exports, "RuleQuickInsertMenuItem", () => $5f8fc80daf2c58f9$export$63f498da6b5e3124);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $g6Qq4 = parcelRequire("g6Qq4");

var $cW1gB = parcelRequire("cW1gB");

var $fT9mF = parcelRequire("fT9mF");

var $64eKJ = parcelRequire("64eKJ");

var $g3Ytr = parcelRequire("g3Ytr");
const $5f8fc80daf2c58f9$export$63f498da6b5e3124 = ({ api: api, previewImageUrls: previewImageUrls })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const preview = (0, $bSJIT.useMemo)(()=>previewImageUrls ? {
            image: previewImageUrls,
            attribution: {
                name: formatMessage((0, $64eKJ.messages).previewAttributionAtlassian)
            }
        } : undefined, [
        formatMessage,
        previewImageUrls
    ]);
    const onSelect = (0, $bSJIT.useCallback)(({ editorView: editorView, insert: insert, source: source })=>{
        var _api$analytics;
        const tr = insert(editorView.state.schema.nodes.rule.createChecked());
        api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 || _api$analytics.actions.attachAnalyticsEvent({
            action: (0, $g6Qq4.ACTION).INSERTED,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).DOCUMENT,
            actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).DIVIDER,
            attributes: {
                inputMethod: source ?? (0, $g6Qq4.INPUT_METHOD).QUICK_INSERT
            },
            eventType: (0, $g6Qq4.EVENT_TYPE).TRACK
        })(tr);
        return tr;
    }, [
        api
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $fT9mF.QuickInsertMenuItem), {
        description: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).horizontalRuleDescription),
        iconBefore: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g3Ytr))), {
            label: ""
        }),
        onSelect: onSelect,
        preview: preview,
        shortcut: "---",
        title: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).horizontalRule)
    });
};

});


parcelRegister("jQGN7", function(module, exports) {
$parcel$export(module.exports, "getToolbarConfig", () => $f7fe586251ba2b47$export$86ce8f8241c20a3);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $g6Qq4 = parcelRequire("g6Qq4");

var $fNLdd = parcelRequire("fNLdd");

var $dEh4R = parcelRequire("dEh4R");

var $8FtCL = parcelRequire("8FtCL");

var $gab48 = parcelRequire("gab48");

var $5bbjm = parcelRequire("5bbjm");

var $c81bI = parcelRequire("c81bI");

var $2hM1a = parcelRequire("2hM1a");

var $gV64P = parcelRequire("gV64P");

var $a0Uv8 = parcelRequire("a0Uv8");

var $auHTV = parcelRequire("auHTV");

var $kqvob = parcelRequire("kqvob");

var $iYnfD = parcelRequire("iYnfD");
const $f7fe586251ba2b47$var$getToolbarItems = (formatMessage, ruleNodeType, ruleAttrs, api)=>{
    var _api$decorations, _api$analytics4;
    const hoverDecoration = api === null || api === void 0 || (_api$decorations = api.decorations) === null || _api$decorations === void 0 ? void 0 : _api$decorations.actions.hoverDecoration;
    const hoverDecorationProps = (className)=>({
            onMouseEnter: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(ruleNodeType, true, className),
            onMouseLeave: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(ruleNodeType, false, className),
            onFocus: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(ruleNodeType, true, className),
            onBlur: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(ruleNodeType, false, className)
        });
    const currentColor = ruleAttrs.color || "var(--ds-border, #0B120E24)";
    const items = [
        {
            id: 'divider-options',
            type: 'dropdown',
            testId: 'divider-options',
            title: formatMessage((0, $dEh4R.ruleMessages).dividerOptions),
            iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($2hM1a))),
            options: {
                width: 272,
                height: 184,
                render: ({ dispatchCommand: dispatchCommand })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $iYnfD.DividerOptions), {
                        style: ruleAttrs.style,
                        weight: ruleAttrs.weight,
                        onStyleChange: (style)=>{
                            var _api$analytics;
                            return dispatchCommand((0, $a0Uv8.updateHorizontalRuleStyle)(style, api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions));
                        },
                        onWeightChange: (weight)=>{
                            var _api$analytics2;
                            return dispatchCommand((0, $a0Uv8.updateHorizontalRuleWeight)(weight, api === null || api === void 0 || (_api$analytics2 = api.analytics) === null || _api$analytics2 === void 0 ? void 0 : _api$analytics2.actions));
                        }
                    })
            }
        },
        {
            id: 'divider-color-picker',
            type: 'select',
            selectType: 'color',
            title: formatMessage((0, $dEh4R.ruleMessages).dividerColors),
            isAriaExpanded: true,
            hideExpandIcon: true,
            defaultValue: (0, $auHTV.dividerColorPalette).find((color)=>color.value === currentColor) || {
                label: formatMessage((0, $dEh4R.ruleMessages).customDividerColor),
                value: currentColor,
                border: (0, $auHTV.dividerColorPalette)[0].border
            },
            options: (0, $auHTV.dividerColorPalette),
            cols: 10,
            hexToPaletteColor: (color)=>color === "var(--ds-border, #0B120E24)" ? color : (0, $8FtCL.hexToEditorTextPaletteColor)(color),
            paletteColorTooltipMessages: (0, $kqvob.dividerPaletteTooltipMessages),
            onChange: (option)=>{
                var _api$analytics3;
                return (0, $a0Uv8.updateHorizontalRuleColor)(option.value, api === null || api === void 0 || (_api$analytics3 = api.analytics) === null || _api$analytics3 === void 0 ? void 0 : _api$analytics3.actions);
            }
        },
        {
            type: 'separator',
            fullHeight: true
        }
    ];
    const overflowMenuItems = [
        {
            type: 'overflow-dropdown',
            options: [
                {
                    title: formatMessage((0, $fNLdd.default).copyToClipboard),
                    icon: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c81bI))), {
                        label: ""
                    }),
                    onClick: ()=>{
                        var _api$core, _api$floatingToolbar;
                        api === null || api === void 0 || (_api$core = api.core) === null || _api$core === void 0 || _api$core.actions.execute(api === null || api === void 0 || (_api$floatingToolbar = api.floatingToolbar) === null || _api$floatingToolbar === void 0 ? void 0 : _api$floatingToolbar.commands.copyNode(ruleNodeType, (0, $g6Qq4.INPUT_METHOD).FLOATING_TB));
                        return true;
                    },
                    ...hoverDecorationProps((0, $5bbjm.akEditorSelectedNodeClassName))
                },
                {
                    title: formatMessage((0, $fNLdd.default).delete),
                    icon: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gV64P))), {
                        label: ""
                    }),
                    onClick: (0, $a0Uv8.removeHorizontalRule)(api === null || api === void 0 || (_api$analytics4 = api.analytics) === null || _api$analytics4 === void 0 ? void 0 : _api$analytics4.actions),
                    ...hoverDecorationProps()
                }
            ]
        }
    ];
    items.push(...overflowMenuItems);
    return items;
};
const $f7fe586251ba2b47$export$86ce8f8241c20a3 = (state, intl, api)=>{
    const { formatMessage: formatMessage } = intl;
    const { selection: selection } = state;
    const { rule: rule } = state.schema.nodes;
    const ruleNode = (0, $gab48.findSelectedNodeOfType)(state.schema.nodes.rule)(state.selection);
    if (!ruleNode) return undefined;
    const getDomRef = (editorView)=>{
        const domAtPos = editorView.domAtPos.bind(editorView);
        const element = (0, $gab48.findDomRefAtPos)(selection.from, domAtPos);
        return element;
    };
    return {
        title: formatMessage((0, $dEh4R.ruleMessages).dividerFloatingControls),
        getDomRef: getDomRef,
        nodeType: [
            rule
        ],
        items: $f7fe586251ba2b47$var$getToolbarItems(formatMessage, rule, ruleNode.node.attrs, api),
        scrollable: true
    };
};

});
parcelRegister("dEh4R", function(module, exports) {
$parcel$export(module.exports, "ruleMessages", () => $74ff769351e65a57$export$a0557135812acc8e);

var $f0Pt4 = parcelRequire("f0Pt4");
const $74ff769351e65a57$export$a0557135812acc8e = (0, $f0Pt4.defineMessages)({
    customDividerColor: {
        id: 'editor-common.messages.rule.customDividerColor',
        defaultMessage: 'Custom',
        description: 'Label for a selected divider color that is not in the predefined color palette.'
    },
    boldGrayDividerColor: {
        id: 'editor-common.messages.rule.boldGrayDividerColor',
        defaultMessage: 'Bold gray',
        description: 'Tooltip label for the bold gray divider color swatch.'
    },
    dividerColors: {
        id: 'fabric.editor.rule.dividerColors',
        defaultMessage: 'Divider colors',
        description: 'Label for the color picker in the floating toolbar of a selected divider.'
    },
    defaultDividerColor: {
        id: 'editor-common.messages.rule.defaultDividerColor',
        defaultMessage: 'Default',
        description: 'Tooltip label for the default divider color swatch.'
    },
    dividerOptions: {
        id: 'fabric.editor.rule.dividerOptions',
        defaultMessage: 'Divider options',
        description: 'Label for the floating toolbar button that opens options for a selected divider.'
    },
    dividerFloatingControls: {
        id: 'fabric.editor.rule.dividerFloatingControls',
        defaultMessage: 'Divider floating controls',
        description: 'Accessible title for the floating toolbar shown when a divider is selected.'
    },
    weight: {
        id: 'fabric.editor.rule.weight',
        defaultMessage: 'Weight',
        description: 'Heading for the divider weight options in the divider options menu.'
    },
    style: {
        id: 'fabric.editor.rule.style',
        defaultMessage: 'Style',
        description: 'Heading for the divider style options in the divider options menu.'
    },
    smallDivider: {
        id: 'fabric.editor.rule.smallDivider',
        defaultMessage: 'Small divider',
        description: 'Accessible label for the button that selects a small divider weight.'
    },
    mediumDivider: {
        id: 'fabric.editor.rule.mediumDivider',
        defaultMessage: 'Medium divider',
        description: 'Accessible label for the button that selects a medium divider weight.'
    },
    largeDivider: {
        id: 'fabric.editor.rule.largeDivider',
        defaultMessage: 'Large divider',
        description: 'Accessible label for the button that selects a large divider weight.'
    },
    solidDivider: {
        id: 'fabric.editor.rule.solidDivider',
        defaultMessage: 'Solid divider',
        description: 'Accessible label for the button that selects a solid divider style.'
    },
    dashedDivider: {
        id: 'fabric.editor.rule.dashedDivider',
        defaultMessage: 'Dashed divider',
        description: 'Accessible label for the button that selects a dashed divider style.'
    },
    dottedDivider: {
        id: 'fabric.editor.rule.dottedDivider',
        defaultMessage: 'Dotted divider',
        description: 'Accessible label for the button that selects a dotted divider style.'
    },
    sketchDivider: {
        id: 'fabric.editor.rule.sketchDivider',
        defaultMessage: 'Sketch divider',
        description: 'Accessible label for the button that selects a sketch divider style.'
    },
    fadeDivider: {
        id: 'fabric.editor.rule.fadeDivider',
        defaultMessage: 'Fade divider',
        description: 'Accessible label for the button that selects a fading divider style.'
    }
});

});

parcelRegister("auHTV", function(module, exports) {
$parcel$export(module.exports, "dividerColorPalette", () => $11890399ac23e34f$export$b943e9971a5bac74);

var $dEh4R = parcelRequire("dEh4R");

var $dFqiE = parcelRequire("dFqiE");
const $11890399ac23e34f$export$b943e9971a5bac74 = [
    // 1. the textColorPalette does not have the "bold gray" color. it is added separately
    // in `platform/packages/editor/editor-plugin-text-color/src/pm-plugins/utils/constants.ts`
    // by editor-plugin-text-color so we need to do the same for the dividerColorPalette
    {
        border: "var(--ds-border, #0B120E24)",
        label: (0, $dEh4R.ruleMessages).boldGrayDividerColor.defaultMessage,
        message: (0, $dEh4R.ruleMessages).boldGrayDividerColor,
        value: '#172B4D'
    },
    // 2. the dividerColorPalette replaces textColorPalette's white with the divider's default color.
    ...(0, $dFqiE.textColorPaletteNew).map((swatch)=>swatch.value.toUpperCase() === '#FFFFFF' ? {
            ...swatch,
            label: (0, $dEh4R.ruleMessages).defaultDividerColor.defaultMessage,
            message: undefined,
            value: "var(--ds-border, #0B120E24)"
        } : swatch)
];

});
parcelRegister("dFqiE", function(module, exports) {
$parcel$export(module.exports, "textColorPaletteNew", () => $3171e762d85e6d38$export$5c94a41a055ef872);

var $3e3xK = parcelRequire("3e3xK");

var $6nCvv = parcelRequire("6nCvv");
const $3171e762d85e6d38$export$5c94a41a055ef872 = [];
(0, $3e3xK.colorPaletteNew).forEach((label, color)=>{
    $3171e762d85e6d38$export$5c94a41a055ef872.push((0, $6nCvv.mapPaletteColor)(label, color));
});

});


parcelRegister("kqvob", function(module, exports) {
$parcel$export(module.exports, "dividerPaletteTooltipMessages", () => $7ee10705a11a7ead$export$80089910eb58ed9f);

var $dEh4R = parcelRequire("dEh4R");

var $epqkL = parcelRequire("epqkL");
// from platform/packages/editor/editor-plugin-text-color/src/pm-plugins/utils/constants.t
const $7ee10705a11a7ead$var$defaultTextColor = '#172B4D';
const $7ee10705a11a7ead$export$80089910eb58ed9f = {
    light: {
        ...(0, $epqkL.textPaletteTooltipMessages).light,
        [$7ee10705a11a7ead$var$defaultTextColor]: (0, $dEh4R.ruleMessages).boldGrayDividerColor,
        ["var(--ds-border, #0B120E24)".toUpperCase()]: (0, $dEh4R.ruleMessages).defaultDividerColor
    },
    dark: {
        ...(0, $epqkL.textPaletteTooltipMessages).dark,
        [$7ee10705a11a7ead$var$defaultTextColor]: (0, $dEh4R.ruleMessages).boldGrayDividerColor,
        ["var(--ds-border, #0B120E24)".toUpperCase()]: (0, $dEh4R.ruleMessages).defaultDividerColor
    }
};

});

parcelRegister("iYnfD", function(module, exports) {
$parcel$export(module.exports, "DividerOptions", () => $091ee3877250a2bf$export$ff01baa6f7ec1e6f);
/* DividerOptions.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $4TRbS = parcelRequire("4TRbS");

var $dEh4R = parcelRequire("dEh4R");

var $8Mmfj = parcelRequire("8Mmfj");

var $cUD3Z = parcelRequire("cUD3Z");

var $5Mni1 = parcelRequire("5Mni1");

var $9PwDt = parcelRequire("9PwDt");

var $8aT4G = parcelRequire("8aT4G");

var $5WjjR = parcelRequire("5WjjR");

var $9Y0MZ = parcelRequire("9Y0MZ");

var $4NQr8 = parcelRequire("4NQr8");

var $3Loql = parcelRequire("3Loql");

var $3OOZy = parcelRequire("3OOZy");

var $4rX0u = parcelRequire("4rX0u");
const $091ee3877250a2bf$var$styles = {
    container: "_18zrutpp _4t3i5jys",
    section: "_1rjc1b66",
    dividerOptionsContainer: "_zulpu2gc _1e0c1txw _1bsb1osq",
    dividerOptionsButtonContainer: "_1rjc1b66"
};
const $091ee3877250a2bf$var$dividerOptionsButtonStyles = null;
const $091ee3877250a2bf$var$SmallWeightIcon = (iconProps)=>/*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5Mni1))), {
        color: "var(--ds-icon-subtle, #505258)",
        label: iconProps.label
    });
const $091ee3877250a2bf$var$MediumWeightIcon = (iconProps)=>/*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cUD3Z))), {
        color: "var(--ds-icon-subtle, #505258)",
        label: iconProps.label
    });
const $091ee3877250a2bf$var$LargeWeightIcon = (iconProps)=>/*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8Mmfj))), {
        color: "var(--ds-icon-subtle, #505258)",
        label: iconProps.label
    });
const $091ee3877250a2bf$var$weightOptions = [
    {
        icon: $091ee3877250a2bf$var$SmallWeightIcon,
        label: (0, $dEh4R.ruleMessages).smallDivider,
        value: 1
    },
    {
        icon: $091ee3877250a2bf$var$MediumWeightIcon,
        label: (0, $dEh4R.ruleMessages).mediumDivider,
        value: 2
    },
    {
        icon: $091ee3877250a2bf$var$LargeWeightIcon,
        label: (0, $dEh4R.ruleMessages).largeDivider,
        value: 3
    }
];
const $091ee3877250a2bf$var$styleOptionRows = [
    // row 1
    [
        {
            icon: (0, $4rX0u.SolidStrokeIcon),
            label: (0, $dEh4R.ruleMessages).solidDivider,
            value: 'solid'
        },
        {
            icon: (0, $9Y0MZ.DashedStrokeIcon),
            label: (0, $dEh4R.ruleMessages).dashedDivider,
            value: 'dashed'
        },
        {
            icon: (0, $4NQr8.DottedStrokeIcon),
            label: (0, $dEh4R.ruleMessages).dottedDivider,
            value: 'dotted'
        }
    ],
    // row 2
    [
        {
            icon: (0, $3OOZy.SketchStrokeIcon),
            label: (0, $dEh4R.ruleMessages).sketchDivider,
            value: 'sketch'
        },
        {
            icon: (0, $3Loql.FadeStrokeIcon),
            label: (0, $dEh4R.ruleMessages).fadeDivider,
            value: 'fade'
        }
    ]
];
const $091ee3877250a2bf$var$DividerOptionButton = ({ icon: icon, isSelected: isSelected, label: label, onSelect: onSelect, value: value })=>{
    const handleClick = (0, $bSJIT.useCallback)(()=>onSelect === null || onSelect === void 0 ? void 0 : onSelect(value), [
        onSelect,
        value
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        className: (0, $9fU1q.default)([
            "_2rko1mok _1reo15vq _18m915vq _16jlkb7n _1vy41mok _ug5l1h6o _r55q1osq"
        ]),
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $4TRbS.default), {
            icon: icon,
            isSelected: isSelected,
            label: label,
            onClick: handleClick
        })
    });
};
const $091ee3877250a2bf$export$ff01baa6f7ec1e6f = ({ onStyleChange: onStyleChange, onWeightChange: onWeightChange, style: style, weight: weight })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const selectedStyle = style ?? (0, $5WjjR.DEFAULT_DIVIDER_STYLE);
    const selectedWeight = weight ?? (0, $5WjjR.DEFAULT_DIVIDER_WEIGHT);
    return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $9PwDt.Box), {
        xcss: $091ee3877250a2bf$var$styles.container,
        children: [
            /*#__PURE__*/ (0, $dc70d.jsxs)((0, $9PwDt.Box), {
                xcss: $091ee3877250a2bf$var$styles.section,
                children: [
                    /*#__PURE__*/ (0, $dc70d.jsx)((0, $8aT4G.Text), {
                        weight: "bold",
                        color: "color.text.subtle",
                        children: formatMessage((0, $dEh4R.ruleMessages).weight)
                    }),
                    /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
                        xcss: $091ee3877250a2bf$var$styles.dividerOptionsButtonContainer,
                        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
                            xcss: $091ee3877250a2bf$var$styles.dividerOptionsContainer,
                            children: $091ee3877250a2bf$var$weightOptions.map(({ icon: icon, label: label, value: value })=>/*#__PURE__*/ (0, $dc70d.jsx)($091ee3877250a2bf$var$DividerOptionButton, {
                                    icon: icon,
                                    isSelected: selectedWeight === value,
                                    label: formatMessage(label),
                                    onSelect: onWeightChange,
                                    value: value
                                }, value))
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dc70d.jsxs)((0, $9PwDt.Box), {
                xcss: $091ee3877250a2bf$var$styles.section,
                children: [
                    /*#__PURE__*/ (0, $dc70d.jsx)((0, $8aT4G.Text), {
                        weight: "bold",
                        color: "color.text.subtle",
                        children: formatMessage((0, $dEh4R.ruleMessages).style)
                    }),
                    $091ee3877250a2bf$var$styleOptionRows.map((options)=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
                            xcss: $091ee3877250a2bf$var$styles.dividerOptionsButtonContainer,
                            children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
                                xcss: $091ee3877250a2bf$var$styles.dividerOptionsContainer,
                                children: options.map(({ icon: icon, label: label, value: value })=>/*#__PURE__*/ (0, $dc70d.jsx)($091ee3877250a2bf$var$DividerOptionButton, {
                                        icon: icon,
                                        isSelected: selectedStyle === value,
                                        label: formatMessage(label),
                                        onSelect: onStyleChange,
                                        value: value
                                    }, value))
                            })
                        }, options[0].value))
                ]
            })
        ]
    });
};

});
parcelRegister("9Y0MZ", function(module, exports) {
$parcel$export(module.exports, "DashedStrokeIcon", () => $e0890e421de45864$export$f8ebe9de64d90be2);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");
const $e0890e421de45864$var$CustomGlyph = ()=>/*#__PURE__*/ (0, $dc70d.jsxs)("svg", {
        width: "44",
        height: "8",
        viewBox: "0 0 44 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $dc70d.jsx)("g", {
                clipPath: "url(#clip0_238_17349)",
                children: /*#__PURE__*/ (0, $dc70d.jsx)("path", {
                    d: "M-78 4H122",
                    stroke: "var(--ds-icon-subtle, #505258)",
                    strokeWidth: "2",
                    strokeDasharray: "4 6"
                })
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)("defs", {
                children: /*#__PURE__*/ (0, $dc70d.jsx)("clipPath", {
                    id: "clip0_238_17349",
                    children: /*#__PURE__*/ (0, $dc70d.jsx)("rect", {
                        width: "44",
                        height: "8",
                        fill: "white"
                    })
                })
            })
        ]
    });
const $e0890e421de45864$export$f8ebe9de64d90be2 = ()=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)($e0890e421de45864$var$CustomGlyph, {});
};

});

parcelRegister("4NQr8", function(module, exports) {
$parcel$export(module.exports, "DottedStrokeIcon", () => $1582d21c924e1979$export$5f5f24456a5d0432);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");
const $1582d21c924e1979$var$CustomGlyph = ()=>/*#__PURE__*/ (0, $dc70d.jsxs)("svg", {
        width: "44",
        height: "8",
        viewBox: "0 0 44 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $dc70d.jsx)("g", {
                clipPath: "url(#clip0_238_2909)",
                children: /*#__PURE__*/ (0, $dc70d.jsx)("path", {
                    d: "M-78 4H122",
                    stroke: "var(--ds-icon, #292A2E)",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeDasharray: "0.01 6"
                })
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)("defs", {
                children: /*#__PURE__*/ (0, $dc70d.jsx)("clipPath", {
                    id: "clip0_238_2909",
                    children: /*#__PURE__*/ (0, $dc70d.jsx)("rect", {
                        width: "44",
                        height: "8",
                        fill: "white"
                    })
                })
            })
        ]
    });
const $1582d21c924e1979$export$5f5f24456a5d0432 = ()=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)($1582d21c924e1979$var$CustomGlyph, {});
};

});

parcelRegister("3Loql", function(module, exports) {
$parcel$export(module.exports, "FadeStrokeIcon", () => $e0a50d4182e7e7ab$export$1b1d09d3b21445d7);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");
const $e0a50d4182e7e7ab$var$CustomGlyph = ()=>/*#__PURE__*/ (0, $dc70d.jsxs)("svg", {
        width: "79",
        height: "2",
        viewBox: "0 0 79 2",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $dc70d.jsx)("path", {
                d: "M0 1C1.31667 1.06667 2.63333 1.13 3.95 1.19C15.8 1.73 27.65 2 39.5 2C51.35 2 63.2 1.73 75.05 1.19C76.3667 1.13 77.6833 1.06667 79 1C77.6833 0.933333 76.3667 0.87 75.05 0.81C63.2 0.27 51.35 0 39.5 0C27.65 0 15.8 0.27 3.95 0.81C2.63333 0.87 1.31667 0.933333 0 1Z",
                fill: "url(#paint0_linear_238_2941)"
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)("defs", {
                children: /*#__PURE__*/ (0, $dc70d.jsxs)("linearGradient", {
                    id: "paint0_linear_238_2941",
                    x1: "0",
                    y1: "1.5",
                    x2: "79",
                    y2: "1.5",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $dc70d.jsx)("stop", {
                            stopColor: "var(--ds-icon, #292A2E)",
                            stopOpacity: 0
                        }),
                        /*#__PURE__*/ (0, $dc70d.jsx)("stop", {
                            offset: "0.274038",
                            stopColor: "var(--ds-icon, #292A2E)"
                        }),
                        /*#__PURE__*/ (0, $dc70d.jsx)("stop", {
                            offset: "0.740385",
                            stopColor: "var(--ds-icon, #292A2E)"
                        }),
                        /*#__PURE__*/ (0, $dc70d.jsx)("stop", {
                            offset: "1",
                            stopColor: "var(--ds-icon, #292A2E)",
                            stopOpacity: 0
                        })
                    ]
                })
            })
        ]
    });
const $e0a50d4182e7e7ab$export$1b1d09d3b21445d7 = ()=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)($e0a50d4182e7e7ab$var$CustomGlyph, {});
};

});

parcelRegister("3OOZy", function(module, exports) {
$parcel$export(module.exports, "SketchStrokeIcon", () => $700aa5181d409186$export$b7de24e477dce174);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");
const $700aa5181d409186$var$CustomGlyph = ()=>/*#__PURE__*/ (0, $dc70d.jsx)("svg", {
        width: "83",
        height: "6",
        viewBox: "0 0 83 6",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $dc70d.jsx)("path", {
            d: "M0.428223 4.0112C0.428223 4.0112 6.35543 1.20063 10.4282 1.0112C15.2535 0.786762 17.5977 4.0112 22.4282 4.0112C27.2587 4.0112 29.5977 1.01007 34.4282 1.0112C38.8335 1.01222 41.0265 3.33342 45.4282 3.5112C50.7856 3.72757 53.5691 0.845277 58.9282 1.0112C63.5219 1.15342 65.8325 3.47137 70.4282 3.5112C75.215 3.55267 77.6415 1.04949 82.4282 1.0112",
            stroke: "var(--ds-icon, #292A2E)",
            strokeWidth: "2"
        })
    });
const $700aa5181d409186$export$b7de24e477dce174 = ()=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)($700aa5181d409186$var$CustomGlyph, {});
};

});

parcelRegister("4rX0u", function(module, exports) {
$parcel$export(module.exports, "SolidStrokeIcon", () => $1cf1935c9d288404$export$e163998943e805e9);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");
const $1cf1935c9d288404$var$CustomGlyph = ()=>/*#__PURE__*/ (0, $dc70d.jsxs)("svg", {
        width: "44",
        height: "8",
        viewBox: "0 0 44 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $dc70d.jsx)("g", {
                clipPath: "url(#clip0_238_17340)",
                children: /*#__PURE__*/ (0, $dc70d.jsx)("path", {
                    d: "M-78 4H122",
                    stroke: "var(--ds-icon, #292A2E)",
                    strokeWidth: "2"
                })
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)("defs", {
                children: /*#__PURE__*/ (0, $dc70d.jsx)("clipPath", {
                    id: "clip0_238_17340",
                    children: /*#__PURE__*/ (0, $dc70d.jsx)("rect", {
                        width: "44",
                        height: "8",
                        fill: "white"
                    })
                })
            })
        ]
    });
const $1cf1935c9d288404$export$e163998943e805e9 = ()=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)($1cf1935c9d288404$var$CustomGlyph, {});
};

});




parcelRegister("bvogh", function(module, exports) {
$parcel$export(module.exports, "scrollIntoViewPlugin", () => $7af231559b31a66f$export$750392944713b1a5);

var $f7Kk4 = parcelRequire("f7Kk4");

var $cw0wu = parcelRequire("cw0wu");

var $3DNV7 = parcelRequire("3DNV7");

var $b9BdF = parcelRequire("b9BdF");
const $7af231559b31a66f$export$a86035451b36e0f9 = new (0, $cw0wu.PluginKey)('scrollIntoViewPlugin');
/**
 * Determines if a transaction contains changes that should trigger scrolling into view.
 * This includes:
 * - Specific step types (Replace, ReplaceAround)
 */ const $7af231559b31a66f$var$hasRelevantChanges = (tr)=>{
    // Check if there are any steps that modified the document
    if (!tr.docChanged) return false;
    // Look for specific types of steps that should trigger scrolling
    const hasRelevantStep = tr.steps.some((step)=>step instanceof (0, $3DNV7.ReplaceStep) || step instanceof (0, $3DNV7.ReplaceAroundStep));
    return hasRelevantStep;
};
const $7af231559b31a66f$var$createPlugin = ()=>new (0, $f7Kk4.SafePlugin)({
        key: $7af231559b31a66f$export$a86035451b36e0f9,
        appendTransaction: (transactions, _oldState, newState)=>{
            if (!transactions.length) return;
            const tr = transactions[0];
            if (($7af231559b31a66f$var$hasRelevantChanges(tr) || tr.storedMarksSet) && !tr.scrolledIntoView && tr.getMeta('scrollIntoView') !== false && // ignore anything we would not want to undo
            // this covers things like autofixing layouts, hovering table rows/cols
            tr.getMeta('addToHistory') !== false && // ignore collab changes from another user
            !tr.getMeta('isRemote') && // ignore any transaction coming from the input text rule plugin
            !tr.getMeta((0, $b9BdF.TEXT_INPUT_RULE_TRANSACTION_KEY)) && // ignore appended transactions as they should be treated as side effects
            tr.getMeta('appendedTransaction') === undefined) return newState.tr.scrollIntoView();
        }
    });
const $7af231559b31a66f$export$750392944713b1a5 = ()=>({
        name: 'scrollIntoView',
        pmPlugins () {
            return [
                {
                    name: 'scrollIntoView',
                    plugin: ()=>$7af231559b31a66f$var$createPlugin()
                }
            ];
        }
    });

});

parcelRegister("dlEm0", function(module, exports) {
$parcel$export(module.exports, "statusPlugin", () => $b77f7523c4cae5ce$export$4c24fc5ab73049c9);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $4d8Oe = parcelRequire("4d8Oe");

var $g6Qq4 = parcelRequire("g6Qq4");

var $5BUNL = parcelRequire("5BUNL");

var $30Yan = parcelRequire("30Yan");

var $fY4jW = parcelRequire("fY4jW");

var $cv8id = parcelRequire("cv8id");

var $fuAsP = parcelRequire("fuAsP");

var $cW1gB = parcelRequire("cW1gB");

var $inSrS = parcelRequire("inSrS");

var $eYvps = parcelRequire("eYvps");

var $3y2s4 = parcelRequire("3y2s4");

var $bPDay = parcelRequire("bPDay");

var $5TrGu = parcelRequire("5TrGu");

var $YU2I8 = parcelRequire("YU2I8");

var $6LpyK = parcelRequire("6LpyK");

var $7L7MN = parcelRequire("7L7MN");

var $lVAFz = parcelRequire("lVAFz");

var $4JfiJ = parcelRequire("4JfiJ");

var $dEam1 = parcelRequire("dEam1");
const $b77f7523c4cae5ce$export$4c24fc5ab73049c9 = ({ config: options, api: api })=>{
    var _api$analytics, _api$analytics2;
    if ((0, $3y2s4.isExperimentEnabled)('platform_editor_turn_into_status')) {
        var _api$blockMenu;
        api === null || api === void 0 || (_api$blockMenu = api.blockMenu) === null || _api$blockMenu === void 0 || _api$blockMenu.actions.registerBlockMenuComponents([
            {
                type: 'block-menu-item',
                key: (0, $30Yan.TRANSFORM_STRUCTURE_STATUS_MENU_ITEM).key,
                parent: {
                    type: 'block-menu-section',
                    key: (0, $30Yan.TRANSFORM_STRUCTURE_MENU_SECTION).key,
                    rank: (0, $fY4jW.TRANSFORM_STRUCTURE_MENU_SECTION_RANK)[(0, $30Yan.TRANSFORM_STRUCTURE_STATUS_MENU_ITEM).key]
                },
                component: (0, $4JfiJ.createStatusBlockMenuItem)(api),
                isHidden: ()=>{
                    var _api$blockControls;
                    return (0, $dEam1.isStatusTurnIntoHidden)(api === null || api === void 0 || (_api$blockControls = api.blockControls) === null || _api$blockControls === void 0 || (_api$blockControls = _api$blockControls.sharedState.currentState()) === null || _api$blockControls === void 0 ? void 0 : _api$blockControls.preservedSelection);
                }
            }
        ]);
    }
    const isRegisteredSlashCommandEnabled = (0, $3y2s4.isExperimentEnabled)('platform_editor_slash_command');
    if ((options === null || options === void 0 ? void 0 : options.menuDisabled) !== true && isRegisteredSlashCommandEnabled) {
        var _api$uiControlRegistr;
        api === null || api === void 0 || (_api$uiControlRegistr = api.uiControlRegistry) === null || _api$uiControlRegistr === void 0 || _api$uiControlRegistr.actions.register((0, $lVAFz.getStatusQuickInsertComponents)({
            api: api
        }));
    }
    return {
        name: 'status',
        nodes () {
            return [
                {
                    name: 'status',
                    node: (0, $4d8Oe.status)
                }
            ];
        },
        pmPlugins () {
            return [
                {
                    name: 'status',
                    plugin: (pmPluginFactoryParams)=>(0, $YU2I8.default)(pmPluginFactoryParams, options)
                },
                {
                    name: 'statusKeymap',
                    plugin: (0, $5TrGu.keymapPlugin)
                }
            ];
        },
        actions: {
            commitStatusPicker: $bPDay.commitStatusPicker,
            updateStatus: (0, $bPDay.updateStatusWithAnalytics)(api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions)
        },
        commands: {
            removeStatus: $bPDay.removeStatus,
            insertStatus: (0, $bPDay.insertStatus)(api === null || api === void 0 || (_api$analytics2 = api.analytics) === null || _api$analytics2 === void 0 ? void 0 : _api$analytics2.actions)
        },
        getSharedState (state) {
            if (!state) return undefined;
            const pluginState = (0, $6LpyK.pluginKey).getState(state);
            return pluginState ? {
                isNew: pluginState.isNew,
                showStatusPickerAt: pluginState.showStatusPickerAt,
                focusStatusInput: pluginState.focusStatusInput
            } : undefined;
        },
        pluginsOptions: {
            ...isRegisteredSlashCommandEnabled ? {} : {
                quickInsert: ({ formatMessage: formatMessage })=>{
                    if ((options === null || options === void 0 ? void 0 : options.menuDisabled) === true) return [];
                    return [
                        {
                            id: 'status',
                            title: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).status),
                            description: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).statusDescription),
                            priority: 700,
                            keywords: [
                                'lozenge'
                            ],
                            icon: ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $5BUNL.IconStatus), {}),
                            action (_insert, state) {
                                var _api$analytics3;
                                return (0, $bPDay.insertStatus)(api === null || api === void 0 || (_api$analytics3 = api.analytics) === null || _api$analytics3 === void 0 ? void 0 : _api$analytics3.actions)((0, $g6Qq4.INPUT_METHOD).QUICK_INSERT)({
                                    tr: state.tr
                                }) ?? state.tr;
                            }
                        }
                    ];
                }
            },
            floatingToolbar (state, intl) {
                const isViewMode = ()=>{
                    var _api$editorViewMode;
                    return (api === null || api === void 0 || (_api$editorViewMode = api.editorViewMode) === null || _api$editorViewMode === void 0 || (_api$editorViewMode = _api$editorViewMode.sharedState.currentState()) === null || _api$editorViewMode === void 0 ? void 0 : _api$editorViewMode.mode) === 'view';
                };
                if (!isViewMode()) return undefined;
                return {
                    title: 'Status floating toolbar',
                    nodeType: state.schema.nodes.status,
                    onPositionCalculated: (0, $inSrS.calculateToolbarPositionAboveSelection)('Status floating toolbar'),
                    items: (node)=>{
                        var _api$annotation;
                        const annotationState = api === null || api === void 0 || (_api$annotation = api.annotation) === null || _api$annotation === void 0 ? void 0 : _api$annotation.sharedState.currentState();
                        const hasActiveMark = node.marks.some((mark)=>mark.type.name === 'annotation' && (annotationState === null || annotationState === void 0 ? void 0 : annotationState.annotations[mark.attrs.id]) === false);
                        const showAnnotation = annotationState && isViewMode() && annotationState.isVisible && !annotationState.bookmark && !annotationState.mouseData.isSelecting && !hasActiveMark;
                        const onCommentClick = (stateFromClickEvent, dispatch)=>{
                            var _api$analytics4;
                            if (!(api !== null && api !== void 0 && api.annotation)) return true;
                            const command = api.annotation.actions.setInlineCommentDraftState(true, (0, $g6Qq4.INPUT_METHOD).TOOLBAR);
                            api === null || api === void 0 || (_api$analytics4 = api.analytics) === null || _api$analytics4 === void 0 || (_api$analytics4 = _api$analytics4.actions) === null || _api$analytics4 === void 0 || _api$analytics4.fireAnalyticsEvent({
                                action: (0, $g6Qq4.ACTION).CLICKED,
                                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).BUTTON,
                                actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).CREATE_INLINE_COMMENT_FROM_HIGHLIGHT_ACTIONS_MENU,
                                eventType: (0, $g6Qq4.EVENT_TYPE).UI,
                                attributes: {
                                    source: 'highlightActionsMenu',
                                    pageMode: 'edit',
                                    sourceNode: 'status'
                                }
                            });
                            return command(stateFromClickEvent, dispatch);
                        };
                        const createCommentMessage = intl.formatMessage((0, $fuAsP.annotationMessages).createComment);
                        const commentItems = showAnnotation ? [
                            {
                                type: 'button',
                                title: createCommentMessage,
                                onClick: onCommentClick,
                                showTitle: true,
                                tooltipContent: /*#__PURE__*/ (0, $dc70d.jsx)((0, $cv8id.ToolTipContent), {
                                    description: createCommentMessage,
                                    keymap: (0, $cv8id.addInlineComment)
                                }),
                                icon: (0, (/*@__PURE__*/$parcel$interopDefault($eYvps))),
                                supportsViewMode: true
                            }
                        ] : [];
                        return [
                            ...commentItems
                        ];
                    }
                };
            }
        },
        contentComponent ({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement }) {
            if (!editorView) return null;
            const domAtPos = editorView.domAtPos.bind(editorView);
            return /*#__PURE__*/ (0, $dc70d.jsx)((0, $7L7MN.ContentComponent), {
                domAtPos: domAtPos,
                api: api,
                editorView: editorView,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement
            });
        }
    };
};

});
parcelRegister("bPDay", function(module, exports) {
$parcel$export(module.exports, "insertStatus", () => $856a2230f218a028$export$84e57993298e69f2);
$parcel$export(module.exports, "updateStatus", () => $856a2230f218a028$export$dd127eb7207846ef);
$parcel$export(module.exports, "updateStatusWithAnalytics", () => $856a2230f218a028$export$2d82855a8f0dcacb);
$parcel$export(module.exports, "removeStatus", () => $856a2230f218a028$export$38345b9b03bc4599);
$parcel$export(module.exports, "setFocusOnStatusInput", () => $856a2230f218a028$export$89aebd528a1fddb6);
$parcel$export(module.exports, "commitStatusPicker", () => $856a2230f218a028$export$cdfbbd5b38df803);

var $9RSBE = parcelRequire("9RSBE");

var $g6Qq4 = parcelRequire("g6Qq4");

var $cWyqT = parcelRequire("cWyqT");

var $5NaaJ = parcelRequire("5NaaJ");

var $kW8qW = parcelRequire("kW8qW");

var $cw0wu = parcelRequire("cw0wu");

var $gab48 = parcelRequire("gab48");

var $iRCoz = parcelRequire("iRCoz");

var $6LpyK = parcelRequire("6LpyK");
const $856a2230f218a028$export$83bafcce64b36a62 = (statusNode, tr, annotationMarks)=>{
    const fragment = (0, $kW8qW.Fragment).fromArray([
        statusNode,
        tr.doc.type.schema.text(' ', annotationMarks)
    ]);
    const insertable = (0, $gab48.canInsert)(tr.selection.$from, fragment);
    if (!insertable) {
        const parentSelection = (0, $cw0wu.NodeSelection).create(tr.doc, tr.selection.from - tr.selection.$anchor.parentOffset - 1);
        tr.insert(parentSelection.to, fragment).setSelection((0, $cw0wu.NodeSelection).create(tr.doc, parentSelection.to + 1));
    } else tr.insert(tr.selection.from, fragment).setSelection((0, $cw0wu.NodeSelection).create(tr.doc, tr.selection.from - fragment.size));
    return tr.setMeta((0, $6LpyK.pluginKey), {
        showStatusPickerAt: tr.selection.from,
        isNew: true
    }).scrollIntoView();
};
const $856a2230f218a028$export$1cefe804e0e75f6d = (tr)=>{
    const annotationMarksForPos = (0, $cWyqT.getAnnotationMarksForPos)(tr.selection.$head);
    const statusNode = (0, $iRCoz.createStatusNode)(tr.doc.type.schema, {}, annotationMarksForPos);
    return $856a2230f218a028$export$83bafcce64b36a62(statusNode, tr, annotationMarksForPos);
};
const $856a2230f218a028$export$84e57993298e69f2 = (editorAnalyticsAPI)=>(inputMethod = (0, $g6Qq4.INPUT_METHOD).TOOLBAR)=>({ tr: tr })=>{
            const statusTr = $856a2230f218a028$export$1cefe804e0e75f6d(tr);
            editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent({
                action: (0, $g6Qq4.ACTION).INSERTED,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).DOCUMENT,
                actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).STATUS,
                attributes: {
                    inputMethod: inputMethod
                },
                eventType: (0, $g6Qq4.EVENT_TYPE).TRACK
            })(statusTr);
            return statusTr;
        };
const $856a2230f218a028$export$dd127eb7207846ef = (status)=>(state, dispatch)=>{
        const { schema: schema } = state;
        const selectedStatus = status ? Object.assign(status, {
            text: status.text.trim(),
            localId: status.localId || (0, $9RSBE.uuid).generate()
        }) : status;
        const statusProps = {
            ...(0, $iRCoz.getDefaultStatusAttrs)(),
            ...selectedStatus
        };
        let tr = state.tr;
        const { showStatusPickerAt: showStatusPickerAt } = (0, $6LpyK.pluginKey).getState(state) || {};
        if (!showStatusPickerAt) {
            // Same behaviour as quick insert (used in createStatus)
            const statusNode = schema.nodes.status.createChecked(statusProps);
            tr = $856a2230f218a028$export$83bafcce64b36a62(statusNode, state.tr);
            if (dispatch) dispatch(tr);
            return true;
        }
        if (state.doc.nodeAt(showStatusPickerAt)) {
            tr.setNodeMarkup(showStatusPickerAt, schema.nodes.status, statusProps).setSelection((0, $cw0wu.NodeSelection).create(tr.doc, showStatusPickerAt)).setMeta((0, $6LpyK.pluginKey), {
                showStatusPickerAt: showStatusPickerAt
            }).scrollIntoView();
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };
const $856a2230f218a028$export$2d82855a8f0dcacb = (editorAnalyticsAPI)=>(inputMethod, status)=>(0, $5NaaJ.withAnalytics)(editorAnalyticsAPI, {
            action: (0, $g6Qq4.ACTION).INSERTED,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).DOCUMENT,
            actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).STATUS,
            attributes: {
                inputMethod: inputMethod
            },
            eventType: (0, $g6Qq4.EVENT_TYPE).TRACK
        })($856a2230f218a028$export$dd127eb7207846ef(status));
const $856a2230f218a028$export$9bef27b5339b1a7a = (showStatusPickerAt)=>(state, dispatch)=>{
        dispatch(state.tr.setMeta((0, $6LpyK.pluginKey), {
            showStatusPickerAt: showStatusPickerAt,
            isNew: false
        }));
        return true;
    };
const $856a2230f218a028$export$38345b9b03bc4599 = (showStatusPickerAt)=>({ tr: tr })=>{
        tr.replace(showStatusPickerAt, showStatusPickerAt + 1);
        return tr;
    };
const $856a2230f218a028$export$89aebd528a1fddb6 = ()=>(state, dispatch)=>{
        if (!dispatch) return false;
        const tr = state.tr.setMeta((0, $6LpyK.pluginKey), {
            focusStatusInput: true
        });
        dispatch(tr);
        return true;
    };
const $856a2230f218a028$var$handleClosingByArrows = (closingMethod, state, showStatusPickerAt, tr)=>{
    if (closingMethod === 'arrowLeft') // put cursor right before status Lozenge
    tr = tr.setSelection((0, $cw0wu.Selection).near(state.tr.doc.resolve(showStatusPickerAt), -1));
    else if (closingMethod === 'arrowRight') // put cursor right after status Lozenge
    tr = tr.setSelection((0, $cw0wu.Selection).near(state.tr.doc.resolve(showStatusPickerAt + 1)));
};
const $856a2230f218a028$export$cdfbbd5b38df803 = (closingPayload)=>(editorView)=>{
        const { state: state, dispatch: dispatch } = editorView;
        const { showStatusPickerAt: showStatusPickerAt } = (0, $6LpyK.pluginKey).getState(state) || {};
        const { closingMethod: closingMethod } = closingPayload || {};
        if (!showStatusPickerAt) return;
        const statusNode = state.tr.doc.nodeAt(showStatusPickerAt);
        if (!statusNode) return;
        let tr = state.tr;
        tr = tr.setMeta((0, $6LpyK.pluginKey), {
            showStatusPickerAt: null,
            focusStatusInput: false,
            isNew: false
        });
        if (closingMethod) $856a2230f218a028$var$handleClosingByArrows(closingMethod, state, showStatusPickerAt, tr);
        else if (statusNode.attrs.text) // still has content - keep content
        // move selection after status if selection did not change
        {
            if (tr.selection.from === showStatusPickerAt) tr = tr.setSelection((0, $cw0wu.Selection).near(state.tr.doc.resolve(showStatusPickerAt + 2)));
        } else // no content - remove node
        tr = tr.delete(showStatusPickerAt, showStatusPickerAt + 1);
        dispatch(tr);
        editorView.focus();
    };

});
parcelRegister("iRCoz", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_STATUS", () => $fab1aa52b27080ef$export$ac80046fa87f5a7a);
$parcel$export(module.exports, "getDefaultStatusAttrs", () => $fab1aa52b27080ef$export$f6d65cccf81e7a40);
$parcel$export(module.exports, "createStatusNode", () => $fab1aa52b27080ef$export$bc38267ef98d9f2);

var $9RSBE = parcelRequire("9RSBE");

var $gdUUy = parcelRequire("gdUUy");
const $fab1aa52b27080ef$export$ac80046fa87f5a7a = {
    text: '',
    color: 'neutral'
};
const $fab1aa52b27080ef$export$42634a38572cebab = {
    text: '',
    color: 'neutral',
    style: 'mixedCase'
};
const $fab1aa52b27080ef$export$f6d65cccf81e7a40 = ()=>(0, $gdUUy.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? $fab1aa52b27080ef$export$42634a38572cebab : $fab1aa52b27080ef$export$ac80046fa87f5a7a;
const $fab1aa52b27080ef$export$bc38267ef98d9f2 = (schema, attrs = {}, marks)=>schema.nodes.status.createChecked({
        ...$fab1aa52b27080ef$export$f6d65cccf81e7a40(),
        localId: (0, $9RSBE.uuid).generate(),
        ...attrs
    }, null, marks);

});

parcelRegister("6LpyK", function(module, exports) {
$parcel$export(module.exports, "pluginKey", () => $dc298038a964aaca$export$18d4026d1ea86bb1);

var $cw0wu = parcelRequire("cw0wu");
const $dc298038a964aaca$export$18d4026d1ea86bb1 = new (0, $cw0wu.PluginKey)('statusPlugin');

});


parcelRegister("5TrGu", function(module, exports) {
$parcel$export(module.exports, "keymapPlugin", () => $8669544ff952013a$export$e832373cff8dec22);

var $cv8id = parcelRequire("cv8id");

var $ejrfk = parcelRequire("ejrfk");

var $cw0wu = parcelRequire("cw0wu");

var $bPDay = parcelRequire("bPDay");

var $6LpyK = parcelRequire("6LpyK");

var $8jHYW = parcelRequire("8jHYW");
function $8669544ff952013a$export$e832373cff8dec22() {
    const list = {};
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $cv8id.bindKeymapWithCommand)((0, $cv8id.enter).common, $8669544ff952013a$var$consumeKeyEvent, list);
    (0, $cv8id.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $cv8id.tab).common, (state, dispatch)=>{
        const statusPluginState = (0, $6LpyK.pluginKey).getState(state);
        const isStatusNode = state.selection instanceof (0, $cw0wu.NodeSelection) ? state.selection.node.type === state.schema.nodes.status : false;
        if (!isStatusNode) return false;
        if (statusPluginState !== null && statusPluginState !== void 0 && statusPluginState.showStatusPickerAt) {
            (0, $bPDay.setFocusOnStatusInput)()(state, dispatch);
            return true;
        }
        return false;
    }, list);
    return (0, $ejrfk.keymap)(list);
}
// consume event to prevent status node problems with positioning and selection
const $8669544ff952013a$var$consumeKeyEvent = (state, _dispatch)=>!!(0, $8jHYW.mayGetStatusAtSelection)(state.tr.selection);
var $8669544ff952013a$export$2e2bcd8739ae039 = $8669544ff952013a$export$e832373cff8dec22;

});
parcelRegister("8jHYW", function(module, exports) {
$parcel$export(module.exports, "mayGetStatusAtSelection", () => $824348afdeaaef8e$export$ae039c0c89d3061);
$parcel$export(module.exports, "isEmptyStatus", () => $824348afdeaaef8e$export$4e209830f320e9a);

var $cw0wu = parcelRequire("cw0wu");
const $824348afdeaaef8e$export$ae039c0c89d3061 = (selection)=>{
    if (selection && selection instanceof (0, $cw0wu.NodeSelection)) {
        const nodeSelection = selection;
        if (nodeSelection.node.type.name === 'status') return selection.node.attrs || null;
    }
    return null;
};
const $824348afdeaaef8e$export$4e209830f320e9a = (node)=>node && (node.text && node.text.trim().length === 0 || node.text === '');
const $824348afdeaaef8e$export$9a35f63e5088c6ab = (tr, pos)=>tr.setSelection((0, $cw0wu.NodeSelection).create(tr.doc, tr.mapping.map(pos)));

});


parcelRegister("YU2I8", function(module, exports) {
$parcel$export(module.exports, "default", () => $311167052d2d4161$export$2e2bcd8739ae039);

var $f7Kk4 = parcelRequire("f7Kk4");

var $56AB9 = parcelRequire("56AB9");

var $cw0wu = parcelRequire("cw0wu");

var $5HVEl = parcelRequire("5HVEl");

var $6LpyK = parcelRequire("6LpyK");

var $8jHYW = parcelRequire("8jHYW");
const $311167052d2d4161$var$createPlugin = (pmPluginFactoryParams, options)=>new (0, $f7Kk4.SafePlugin)({
        state: {
            init: ()=>({
                    isNew: false,
                    showStatusPickerAt: null,
                    focusStatusInput: false
                }),
            apply (tr, state, oldEditorState) {
                const meta = tr.getMeta((0, $6LpyK.pluginKey));
                if (meta) {
                    const newState = {
                        ...state,
                        ...meta
                    };
                    pmPluginFactoryParams.dispatch((0, $6LpyK.pluginKey), newState);
                    return newState;
                }
                if (tr.docChanged && state.showStatusPickerAt) {
                    const { pos: pos, deleted: deleted } = tr.mapping.mapResult(state.showStatusPickerAt);
                    const showStatusPickerAt = deleted ? null : pos;
                    const newState = {
                        ...state,
                        showStatusPickerAt: showStatusPickerAt
                    };
                    if (newState.showStatusPickerAt !== state.showStatusPickerAt) {
                        pmPluginFactoryParams.dispatch((0, $6LpyK.pluginKey), newState);
                        return newState;
                    }
                }
                if (tr.selectionSet) {
                    // Change in selection, while status picker was open, update state, if required.
                    const selectionFrom = tr.selection.from;
                    const nodeAtSelection = tr.doc.nodeAt(selectionFrom);
                    let showStatusPickerAt = null;
                    if (nodeAtSelection && nodeAtSelection.type === oldEditorState.schema.nodes.status && tr.selection instanceof (0, $cw0wu.NodeSelection)) showStatusPickerAt = selectionFrom;
                    if (showStatusPickerAt !== state.showStatusPickerAt) {
                        const newState = {
                            ...state,
                            isNew: false,
                            showStatusPickerAt: showStatusPickerAt,
                            focusStatusInput: false
                        };
                        pmPluginFactoryParams.dispatch((0, $6LpyK.pluginKey), newState);
                        return newState;
                    }
                }
                return state;
            }
        },
        filterTransaction: (tr, state)=>{
            // if it is a selection change transaction, and selection changes from node to text
            if (tr.selectionSet && !tr.steps.length && tr.isGeneric && tr.selection instanceof (0, $cw0wu.TextSelection) && state.selection instanceof (0, $cw0wu.NodeSelection)) {
                const { isNew: isNew, showStatusPickerAt: showStatusPickerAt } = (0, $6LpyK.pluginKey).getState(state) || {};
                const nodeAtSelection = tr.doc.nodeAt(tr.selection.from);
                // prevent changing node selection to text selection on dom change right after inserting status
                // if newly selected status is selected with status picker opened
                if (isNew && showStatusPickerAt && nodeAtSelection && nodeAtSelection.type === state.schema.nodes.status) return false;
            }
            return true;
        },
        appendTransaction: (transactions, oldEditorState, newEditorState)=>{
            let changed = false;
            const tr = newEditorState.tr;
            /**
     * When user start creating status, and, when users navigates away
     *  while empty, then we want to remove empty ("set a status") status.
     * But when transaction to add empty status happens from undo/redo
     *  we don't want to remove it.
     */ if (transactions.find((tr)=>tr.selectionSet && !tr.getMeta((0, $56AB9.pmHistoryPluginKey)))) {
                const oldStatus = (0, $8jHYW.mayGetStatusAtSelection)(oldEditorState.selection);
                const newStatus = (0, $8jHYW.mayGetStatusAtSelection)(newEditorState.selection);
                if (oldStatus && (newStatus && oldStatus.localId !== newStatus.localId || !newStatus)) {
                    if ((0, $8jHYW.isEmptyStatus)(oldStatus)) {
                        const pos = oldEditorState.selection.from;
                        tr.delete(tr.mapping.map(pos), tr.mapping.map(pos + 1));
                        changed = true;
                    }
                }
            }
            return changed ? tr : undefined;
        },
        key: (0, $6LpyK.pluginKey),
        props: {
            nodeViews: {
                status: (node)=>{
                    return new (0, $5HVEl.StatusNodeView)(node, pmPluginFactoryParams.getIntl());
                }
            }
        }
    });
var $311167052d2d4161$export$2e2bcd8739ae039 = $311167052d2d4161$var$createPlugin;

});
parcelRegister("5HVEl", function(module, exports) {
$parcel$export(module.exports, "StatusNodeView", () => $61d11ca869bd03f5$export$54e825089e34a876);

var $6kjeV = parcelRequire("6kjeV");

var $kW8qW = parcelRequire("kW8qW");

var $gdUUy = parcelRequire("gdUUy");

var $f7dYO = parcelRequire("f7dYO");

var $bhBLS = parcelRequire("bhBLS");
class $61d11ca869bd03f5$export$54e825089e34a876 {
    /**
   *
   * @param node
   * @param intl
   * @example
   */ constructor(node, intl){
        this.box = null;
        this.textContainer = null;
        this.node = node;
        this.intl = intl;
        const spec = (0, $bhBLS.statusToDOM)(node);
        const { dom: dom } = (0, $kW8qW.DOMSerializer).renderSpec(document, spec);
        this.dom = dom;
        this.domElement = dom instanceof HTMLElement ? dom : undefined;
        if (this.domElement) {
            this.box = this.domElement.querySelector('.status-lozenge-span');
            this.textContainer = this.domElement.querySelector('.lozenge-text');
        }
        if (!node.attrs.text) this.setPlaceholder();
    }
    setPlaceholder() {
        if (this.textContainer && this.domElement) {
            this.textContainer.textContent = this.intl.formatMessage((0, $6kjeV.messages).placeholder);
            this.domElement.style.setProperty('opacity', '0.83');
        }
    }
    /**
   *
   * @param node
   * @example
   */ update(node) {
        if (node.type !== this.node.type) return false;
        if (this.textContainer && node.attrs.text !== this.node.attrs.text) {
            var _this$domElement;
            this.textContainer.textContent = node.attrs.text;
            // Also update data-text on outer wrapper for parseDOM extraction when copying
            (_this$domElement = this.domElement) === null || _this$domElement === void 0 || _this$domElement.setAttribute('data-text', node.attrs.text);
        }
        if (this.textContainer && node.attrs.style !== this.node.attrs.style && (0, $gdUUy.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) this.textContainer.style.textTransform = node.attrs.style !== 'mixedCase' ? 'uppercase' : '';
        if (node.attrs.color !== this.node.attrs.color) {
            var _this$box, _this$domElement2;
            const dataColor = (0, $f7dYO.normalizeStatusColorAttr)(node.attrs.color);
            (_this$box = this.box) === null || _this$box === void 0 || _this$box.setAttribute('data-color', dataColor);
            // Also update data-color on outer wrapper for parseDOM extraction when copying
            (_this$domElement2 = this.domElement) === null || _this$domElement2 === void 0 || _this$domElement2.setAttribute('data-color', dataColor);
        }
        if (!node.attrs.text) this.setPlaceholder();
        if (node.attrs.text && this.domElement) this.domElement.style.setProperty('opacity', '1');
        this.node = node;
        return true;
    }
}

});
parcelRegister("6kjeV", function(module, exports) {
$parcel$export(module.exports, "messages", () => $f3e65485071ae20b$export$defe85febe8b728c);

var $f0Pt4 = parcelRequire("f0Pt4");
const $f3e65485071ae20b$export$defe85febe8b728c = (0, $f0Pt4.defineMessages)({
    statusEditorLabel: {
        id: 'fabric.editor.statusEditorLabel',
        defaultMessage: 'Status editor',
        description: 'Accessible label for the status element editor panel that appears when a user clicks on a status badge in the editor to modify it.'
    },
    placeholder: {
        id: 'fabric.editor.statusPlaceholder',
        defaultMessage: 'Set a status',
        description: 'Placeholder description for an empty (new) status item in the editor'
    },
    editText: {
        id: 'fabric.editor.editStatusText',
        defaultMessage: 'Edit Status',
        description: 'Title for the input that changes the status text'
    },
    editColor: {
        id: 'fabric.editor.editStatusColor',
        defaultMessage: 'Edit Status Color',
        description: 'Title for the color picker that changes the status color'
    },
    statusPickerOpenedAlert: {
        id: 'fabric.editor.statusPickerOpenedAlert',
        defaultMessage: 'Status editor popup opened, press Tab to access popup',
        description: 'Screen reader alert when the status picker is opened, letting the user know they can press the Tab button to access the status picker'
    }
});

});

parcelRegister("f7dYO", function(module, exports) {
$parcel$export(module.exports, "normalizeStatusColorAttr", () => $ed56e13784c4aed2$export$8a37d2efeae0a4ed);
const $ed56e13784c4aed2$export$8a37d2efeae0a4ed = (color)=>color.startsWith('#') ? color.toUpperCase() : color;

});

parcelRegister("bhBLS", function(module, exports) {
$parcel$export(module.exports, "statusToDOM", () => $e92e74b55cb75bfa$export$5318aa2f7ab92c01);

var $jxkn6 = parcelRequire("jxkn6");

var $PFzWP = parcelRequire("PFzWP");

var $kuD5k = parcelRequire("kuD5k");

var $gdUUy = parcelRequire("gdUUy");

var $f7dYO = parcelRequire("f7dYO");
// eg. Version/4.0 Chrome/95.0.4638.50
const $e92e74b55cb75bfa$var$isAndroidChromium = typeof window !== 'undefined' && /Version\/.* Chrome\/.*/u.test(window.navigator.userAgent);
const $e92e74b55cb75bfa$export$5318aa2f7ab92c01 = (node)=>{
    const browser = (0, $jxkn6.getBrowserInfo)();
    const { text: text, color: color, style: style, localId: localId } = node.attrs;
    const dataColor = (0, $f7dYO.normalizeStatusColorAttr)(color);
    const editorNodeWrapperAttrs = {
        class: 'statusView-content-wrap inlineNodeView',
        'data-testid': 'statusContainerView',
        'data-prosemirror-node-name': 'status',
        localid: localId,
        // Required for parseDOM to correctly parse status when NodeView DOM is copied directly
        'data-node-type': 'status',
        'data-color': dataColor,
        'data-text': text // Text stored as attribute for parseDOM extraction
    };
    const statusElementAttrs = {
        style: (0, $PFzWP.convertToInlineCss)($e92e74b55cb75bfa$var$isAndroidChromium ? {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles -- Ignored via go/DSP-18766
            display: 'inline-block !important',
            verticalAlign: 'middle'
        } : {}),
        class: 'status-lozenge-span',
        'data-node-type': 'status',
        'data-color': dataColor,
        'data-style': style
    };
    const lozengeWrapperAttrs = {
        class: 'lozenge-wrapper'
    };
    const lozengeTextAttrs = {
        class: 'lozenge-text',
        style: (0, $PFzWP.convertToInlineCss)({
            // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
            letterSpacing: '0.165px',
            ...style !== 'mixedCase' && (0, $gdUUy.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? {
                // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
                textTransform: 'uppercase'
            } : {}
        })
    };
    return [
        'span',
        editorNodeWrapperAttrs,
        [
            'span',
            {
                class: 'zeroWidthSpaceContainer'
            },
            [
                'span',
                {
                    class: 'inlineNodeViewAddZeroWidthSpace'
                },
                (0, $kuD5k.ZERO_WIDTH_SPACE)
            ]
        ],
        [
            'span',
            statusElementAttrs,
            [
                'span',
                lozengeWrapperAttrs,
                [
                    'span',
                    lozengeTextAttrs,
                    text
                ]
            ]
        ],
        browser.android ? [
            'span',
            {
                class: 'zeroWidthSpaceContainer',
                contentEditable: 'false'
            },
            [
                'span',
                {
                    class: 'inlineNodeViewAddZeroWidthSpace'
                },
                (0, $kuD5k.ZERO_WIDTH_SPACE)
            ]
        ] : [
            'span',
            {
                class: 'inlineNodeViewAddZeroWidthSpace'
            },
            ''
        ]
    ];
};

});



parcelRegister("7L7MN", function(module, exports) {
$parcel$export(module.exports, "ContentComponent", () => $df3285124df1f966$export$2dda1e4a1d1f6a81);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $9x1C7 = parcelRequire("9x1C7");

var $gab48 = parcelRequire("gab48");

var $3y2s4 = parcelRequire("3y2s4");

var $gdUUy = parcelRequire("gdUUy");

var $bPDay = parcelRequire("bPDay");

var $8KjYB = parcelRequire("8KjYB");

var $jTNmi = parcelRequire("jTNmi");
function $df3285124df1f966$export$2dda1e4a1d1f6a81({ api: api, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, editorView: editorView, domAtPos: domAtPos }) {
    const { statusState: statusState } = (0, $9x1C7.useSharedPluginState)(api, [
        'status'
    ]);
    const { showStatusPickerAt: showStatusPickerAt } = statusState ?? {};
    const target = (0, $bSJIT.useMemo)(()=>// Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        showStatusPickerAt ? (0, $gab48.findDomRefAtPos)(showStatusPickerAt, domAtPos) : null, [
        showStatusPickerAt,
        domAtPos
    ]);
    const statusNode = (0, $bSJIT.useMemo)(()=>showStatusPickerAt ? editorView.state.doc.nodeAt(showStatusPickerAt) : undefined, // eslint-disable-next-line react-hooks/exhaustive-deps -- preserve original recompute cadence for the ungated path
    [
        showStatusPickerAt,
        editorView
    ]);
    const onSelect = (0, $bSJIT.useCallback)((status)=>{
        (0, $bPDay.updateStatus)(status)(editorView.state, editorView.dispatch);
    }, [
        editorView
    ]);
    const onTextChanged = (0, $bSJIT.useCallback)((status)=>{
        (0, $bPDay.updateStatus)(status)(editorView.state, editorView.dispatch);
    }, [
        editorView
    ]);
    const closeStatusPicker = (0, $bSJIT.useCallback)((closingPayload)=>{
        (0, $bPDay.commitStatusPicker)(closingPayload)(editorView);
    }, [
        editorView
    ]);
    const onEnter = (0, $bSJIT.useCallback)(()=>{
        (0, $bPDay.commitStatusPicker)()(editorView);
    }, [
        editorView
    ]);
    const onSuggestedStatusClick = (0, $bSJIT.useCallback)((status)=>{
        var _editorView$state$doc;
        const currentLocalId = typeof showStatusPickerAt === 'number' ? (_editorView$state$doc = editorView.state.doc.nodeAt(showStatusPickerAt)) === null || _editorView$state$doc === void 0 ? void 0 : _editorView$state$doc.attrs.localId : undefined;
        const suggestedStatus = {
            color: status.color,
            ...currentLocalId ? {
                localId: currentLocalId
            } : {},
            ...status.style ? {
                style: status.style
            } : {},
            text: status.text
        };
        const didUpdateStatus = (0, $bPDay.updateStatus)(suggestedStatus)(editorView.state, editorView.dispatch);
        if (didUpdateStatus) (0, $bPDay.commitStatusPicker)()(editorView);
    }, [
        editorView,
        showStatusPickerAt
    ]);
    const suggestedStatuses = (0, $bSJIT.useMemo)(()=>{
        if (typeof showStatusPickerAt !== 'number' || !(0, $3y2s4.isExperimentEnabled)('platform_editor_status_popup_suggestions')) return [];
        // Read the node directly from the current doc so suggestions reflect the latest
        // document state (the memoized `statusNode` intentionally preserves the original
        // recompute cadence for the ungated path).
        const currentNode = editorView.state.doc.nodeAt(showStatusPickerAt);
        if (!currentNode || currentNode.type.name !== 'status') return [];
        const { color: color, localId: localId, text: text } = currentNode.attrs;
        return (0, $8KjYB.getSuggestedStatuses)({
            currentPos: showStatusPickerAt,
            currentStatus: {
                color: color,
                localId: localId,
                text: text
            },
            doc: editorView.state.doc,
            shouldUppercaseText: (0, $gdUUy.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')
        });
    }, [
        showStatusPickerAt,
        editorView.state.doc
    ]);
    if (typeof showStatusPickerAt !== 'number') return null;
    if (!statusNode || statusNode.type.name !== 'status') return null;
    const { text: text, color: color, localId: localId, style: style } = statusNode.attrs;
    const displayText = style !== 'mixedCase' && (0, $gdUUy.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? text.toUpperCase() : text;
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $jTNmi.default), {
        isNew: statusState === null || statusState === void 0 ? void 0 : statusState.isNew,
        focusStatusInput: statusState === null || statusState === void 0 ? void 0 : statusState.focusStatusInput,
        target: target,
        defaultText: displayText,
        defaultColor: color,
        defaultLocalId: localId,
        mountTo: popupsMountPoint,
        boundariesElement: popupsBoundariesElement,
        scrollableElement: popupsScrollableElement,
        onSelect: onSelect,
        onTextChanged: onTextChanged,
        closeStatusPicker: closeStatusPicker,
        onEnter: onEnter,
        onSuggestedStatusClick: onSuggestedStatusClick,
        editorView: editorView,
        api: api,
        suggestedStatuses: suggestedStatuses
    });
}

});
parcelRegister("8KjYB", function(module, exports) {
$parcel$export(module.exports, "getSuggestedStatuses", () => $56a429b94e5c7c08$export$8db4724ea852799d);

var $lKGUH = parcelRequire("lKGUH");
const $56a429b94e5c7c08$export$9e316df46dca86d0 = 20;
// `color` may be a legacy name or a hex value that render the same hue (e.g. `green` and
// `#D3F1A7` both resolve to `accent-lime`), so the key is built from the resolved appearance
// rather than the raw attribute value — otherwise both variants would surface as suggestions.
const $56a429b94e5c7c08$var$getStatusKey = ({ color: color, text: text })=>`${(0, $lKGUH.getLozengeAppearance)(color)}:${text.trim().toLowerCase()}`;
const $56a429b94e5c7c08$var$getDisplayText = (status, shouldUppercaseText)=>shouldUppercaseText && status.style !== 'mixedCase' ? status.text.toUpperCase() : status.text;
const $56a429b94e5c7c08$export$8db4724ea852799d = ({ currentPos: currentPos, currentStatus: currentStatus, doc: doc, limit: limit = $56a429b94e5c7c08$export$9e316df46dca86d0, shouldUppercaseText: shouldUppercaseText = false })=>{
    const closestStatusesByKey = new Map();
    const currentStatusKey = $56a429b94e5c7c08$var$getStatusKey(currentStatus);
    doc.descendants((node, pos)=>{
        if (node.type.name !== 'status' || pos === currentPos) return;
        const text = typeof node.attrs.text === 'string' ? node.attrs.text.trim() : '';
        if (!text) return;
        const status = {
            color: node.attrs.color,
            localId: node.attrs.localId,
            style: node.attrs.style,
            text: text
        };
        const statusKey = $56a429b94e5c7c08$var$getStatusKey(status);
        if (status.localId === currentStatus.localId || statusKey === currentStatusKey) return;
        const existingStatus = closestStatusesByKey.get(statusKey);
        const nextStatus = {
            ...status,
            distance: Math.abs(pos - currentPos),
            displayText: $56a429b94e5c7c08$var$getDisplayText(status, shouldUppercaseText)
        };
        if (!existingStatus || nextStatus.distance < existingStatus.distance) closestStatusesByKey.set(statusKey, nextStatus);
    });
    return Array.from(closestStatusesByKey.values()).sort((statusA, statusB)=>{
        if (statusA.distance !== statusB.distance) return statusA.distance - statusB.distance;
        if (statusA.displayText !== statusB.displayText) return statusA.displayText.localeCompare(statusB.displayText);
        return statusA.color.localeCompare(statusB.color);
    }).slice(0, limit).map(({ distance: _distance, ...status })=>status);
};

});

parcelRegister("jTNmi", function(module, exports) {
$parcel$export(module.exports, "default", () => $2b204993af1ebf52$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $fK3tS = parcelRequire("fK3tS");

var $kIbto = parcelRequire("kIbto");

var $c9wRy = parcelRequire("c9wRy");

var $6kjeV = parcelRequire("6kjeV");

var $5zk80 = parcelRequire("5zk80");

var $3Aq92 = parcelRequire("3Aq92");

var $cf2n1 = parcelRequire("cf2n1");

var $cp06f = parcelRequire("cp06f");

var $5bbjm = parcelRequire("5bbjm");

var $3y2s4 = parcelRequire("3y2s4");

var $3zzvD = parcelRequire("3zzvD");

var $gdUUy = parcelRequire("gdUUy");

var $asIyf = parcelRequire("asIyf");

var $574Jv = parcelRequire("574Jv");

var $9Abbn = parcelRequire("9Abbn");

var $iRCoz = parcelRequire("iRCoz");

var $aWayE = parcelRequire("aWayE");
function $2b204993af1ebf52$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2b204993af1ebf52$var$PopupWithListeners = (0, $cf2n1.default)((0, $5zk80.default));
var $2b204993af1ebf52$export$4182489224ea9c47 = /*#__PURE__*/ function(InputMethod) {
    InputMethod["blur"] = "blur";
    InputMethod["escKey"] = "escKey";
    InputMethod["enterKey"] = "enterKey";
    return InputMethod;
}({});
var $2b204993af1ebf52$export$cc742728d048210b = /*#__PURE__*/ function(closingMethods) {
    closingMethods["ArrowLeft"] = "arrowLeft";
    closingMethods["ArrowRight"] = "arrowRight";
    return closingMethods;
}({});
const $2b204993af1ebf52$var$pickerContainerStyles = /*#__PURE__*/ (0, $9dQre.css)({
    background: "var(--ds-surface-overlay, #FFFFFF)",
    padding: `${"var(--ds-space-100, 8px)"} 0`,
    borderRadius: "var(--ds-radius-small, 3px)",
    boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    ':focus': {
        outline: 'none'
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    input: {
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        textTransform: 'uppercase'
    }
});
const $2b204993af1ebf52$var$pickerContainerStylesTeam26 = /*#__PURE__*/ (0, $9dQre.css)({
    background: "var(--ds-surface-overlay, #FFFFFF)",
    padding: `${"var(--ds-space-100, 8px)"} 0`,
    borderRadius: "var(--ds-radius-small, 3px)",
    boxShadow: "var(--ds-shadow-overlay, 0 0 1px rgba(9, 30, 66, 0.31), 0 4px 8px -2px rgba(9, 30, 66, 0.25))",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    ':focus': {
        outline: 'none'
    }
});
// The scrollable suggestions area already supplies its own trailing padding once actually
// scrolled to the end, so the outer wrapper's own bottom padding is only ever extra
// whitespace below the (fixed-height) scroll box, most visible right under the half-cut
// row when unscrolled.
const $2b204993af1ebf52$var$pickerContainerNoBottomPaddingStyles = {
    name: "18g08sj",
    styles: "padding-bottom:0"
};
const $2b204993af1ebf52$var$suggestedStatusesContainerStyles = /*#__PURE__*/ (0, $9dQre.css)({
    display: 'flex',
    flexDirection: 'column',
    gap: "var(--ds-space-050, 4px)",
    margin: 0,
    // Bottom padding matches the list's own top padding (`space.100`) so the gap above the first
    // suggestion and the gap below the last (once scrolled to the true end) are the same size.
    padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-150, 12px)"} ${"var(--ds-space-100, 8px)"}`,
    paddingLeft: "var(--ds-space-100, 8px)"
});
// Fixed input plus capped scrolling color controls and suggestions. The ten-color picker is
// taller because it carries a second swatch row.
const $2b204993af1ebf52$var$STATUS_PICKER_FIT_HEIGHT = 236;
const $2b204993af1ebf52$var$STATUS_PICKER_TEN_COLOR_FIT_HEIGHT = 268;
// ColorPalette: swatches per row * 32px slot + 16px inline margin.
const $2b204993af1ebf52$var$STATUS_PICKER_CONTENT_WIDTH = 208; // 6 * 32 + 16
const $2b204993af1ebf52$var$STATUS_PICKER_TEN_COLOR_CONTENT_WIDTH = 176; // 5 * 32 + 16
const $2b204993af1ebf52$var$statusPickerWidthStylesOld = /*#__PURE__*/ (0, $9dQre.css)({
    width: `${$2b204993af1ebf52$var$STATUS_PICKER_CONTENT_WIDTH}px`
});
const $2b204993af1ebf52$var$statusPickerWidthStyles = /*#__PURE__*/ (0, $9dQre.css)({
    width: `${$2b204993af1ebf52$var$STATUS_PICKER_TEN_COLOR_CONTENT_WIDTH}px`
});
const $2b204993af1ebf52$var$suggestedStatusButtonStyles = /*#__PURE__*/ (0, $9dQre.css)({
    background: 'transparent',
    border: 0,
    borderRadius: "var(--ds-radius-small, 3px)",
    cursor: 'pointer',
    justifyContent: 'flex-start',
    // Allow this flex item to shrink so long statuses can truncate.
    minWidth: 0,
    padding: 0,
    '&:focus-visible': {
        outline: `2px solid ${"var(--ds-border-focused, #0C66E4)"}`,
        outlineOffset: "var(--ds-space-025, 2px)"
    }
});
const $2b204993af1ebf52$var$suggestedStatusButtonWrapperStyles = {
    name: "zd7plg",
    styles: "align-self:flex-start;border-width:var(--ds-border-width, 1px);border-style:solid;border-color:transparent;border-radius:var(--ds-space-075, 6px);box-sizing:border-box;display:flex;margin-left:var(--ds-space-025, 2px);max-width:100%;padding-block:var(--ds-border-width, 1px);padding-inline:var(--ds-border-width, 1px);&:hover{border-color:var(--ds-border, #091E4224);}"
};
// eslint-disable-next-line @repo/internal/react/no-class-components
class $2b204993af1ebf52$var$StatusPickerWithIntl extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Component {
    constructor(props){
        super(props), this.handleClickOutside = (event)=>{
            event.preventDefault();
            this.inputMethod = "blur";
            const selectedText = window.getSelection();
            if (!selectedText) this.props.closeStatusPicker();
        }, this.handleEscapeKeydown = (event)=>{
            event.preventDefault();
            this.inputMethod = "escKey";
            this.props.onEnter(this.state);
        }, this.handleTabPress = (event)=>{
            var _getDocument2;
            if (!(0, $3zzvD.UNSAFE_expValNoExposure)('platform_editor_status_popup_suggestions', 'isEnabled', false)) {
                var _getDocument;
                /* original tab-navigation behaviour: cycle between color buttons and the input field */ const colorButtons = event.currentTarget.querySelectorAll('button');
                const inputField = event.currentTarget.querySelector('input');
                const activeElement = (_getDocument = (0, $c9wRy.getDocument)()) === null || _getDocument === void 0 ? void 0 : _getDocument.activeElement;
                const isInputFocussed = activeElement === inputField;
                const isButtonFocussed = Array.from(colorButtons).some((buttonElement)=>{
                    return activeElement === buttonElement;
                });
                if (event !== null && event !== void 0 && event.shiftKey) {
                    /* shift + tab */ if (isInputFocussed) {
                        colorButtons[0].focus();
                        event.preventDefault();
                    }
                    /* After the user presses shift + tab the color-palette component updates tab index for the first color to be 0.
                To correctly set focus to the input field instead of the first color button we need to set focus manually
                */ if (isButtonFocussed) {
                        inputField === null || inputField === void 0 || inputField.focus();
                        event.preventDefault();
                    }
                } else /* tab */ if (isButtonFocussed) {
                    inputField === null || inputField === void 0 || inputField.focus();
                    event.preventDefault();
                }
                return;
            }
            const colorButtons = event.currentTarget.querySelectorAll('button:not([data-suggested-status-button])');
            const suggestedStatusButtons = event.currentTarget.querySelectorAll('button[data-suggested-status-button]');
            const inputField = event.currentTarget.querySelector('input');
            const activeElement = (_getDocument2 = (0, $c9wRy.getDocument)()) === null || _getDocument2 === void 0 ? void 0 : _getDocument2.activeElement;
            const isInputFocussed = activeElement === inputField;
            const isButtonFocussed = Array.from(colorButtons).some((buttonElement)=>{
                return activeElement === buttonElement;
            });
            const isSuggestedStatusButtonFocussed = Array.from(suggestedStatusButtons).some((buttonElement)=>{
                return activeElement === buttonElement;
            });
            if (event !== null && event !== void 0 && event.shiftKey) {
                /* shift + tab */ if (isInputFocussed) {
                    if (suggestedStatusButtons.length > 0) suggestedStatusButtons[suggestedStatusButtons.length - 1].focus();
                    else {
                        var _colorButtons$;
                        (_colorButtons$ = colorButtons[0]) === null || _colorButtons$ === void 0 || _colorButtons$.focus();
                    }
                    event.preventDefault();
                }
                /* After the user presses shift + tab the color-palette component updates tab index for the first color to be 0.
             To correctly set focus to the input field instead of the first color button we need to set focus manually
             */ if (isButtonFocussed) {
                    inputField === null || inputField === void 0 || inputField.focus();
                    event.preventDefault();
                }
                if (isSuggestedStatusButtonFocussed) {
                    var _colorButtons;
                    (_colorButtons = colorButtons[colorButtons.length - 1]) === null || _colorButtons === void 0 || _colorButtons.focus();
                    event.preventDefault();
                }
            } else {
                /* tab */ if (isButtonFocussed) {
                    if (suggestedStatusButtons.length > 0) suggestedStatusButtons[0].focus();
                    else inputField === null || inputField === void 0 || inputField.focus();
                    event.preventDefault();
                }
                if (isSuggestedStatusButtonFocussed) {
                    inputField === null || inputField === void 0 || inputField.focus();
                    event.preventDefault();
                }
            }
        }, this.handleArrow = (event, closingMethod)=>{
            var _getDocument3;
            const activeElement = (_getDocument3 = (0, $c9wRy.getDocument)()) === null || _getDocument3 === void 0 ? void 0 : _getDocument3.activeElement;
            if (activeElement === this.popupBodyWrapper.current) {
                var _this$popupBodyWrappe;
                event.preventDefault();
                (_this$popupBodyWrappe = this.popupBodyWrapper) === null || _this$popupBodyWrappe === void 0 || (_this$popupBodyWrappe = _this$popupBodyWrappe.current) === null || _this$popupBodyWrappe === void 0 || _this$popupBodyWrappe.blur();
                this.props.closeStatusPicker({
                    closingMethod: closingMethod
                });
            }
        }, this.onKeyDown = (event)=>{
            const isTabPressed = event.key === 'Tab';
            if (isTabPressed) return this.handleTabPress(event);
            if (event.key in $2b204993af1ebf52$export$cc742728d048210b) return this.handleArrow(event, $2b204993af1ebf52$export$cc742728d048210b[event.key]);
        }, this.onColorHover = (color)=>{
            this.createStatusAnalyticsAndFireFunc({
                action: 'hovered',
                actionSubject: 'statusColorPicker',
                attributes: {
                    color: color,
                    localId: this.state.localId,
                    state: (0, $aWayE.analyticsState)(this.props.isNew)
                }
            });
        }, this.onColorClick = (color)=>{
            const { text: text, localId: localId } = this.state;
            if (color === this.state.color) {
                this.createStatusAnalyticsAndFireFunc({
                    action: 'clicked',
                    actionSubject: 'statusColorPicker',
                    attributes: {
                        color: color,
                        localId: localId,
                        state: (0, $aWayE.analyticsState)(this.props.isNew)
                    }
                });
                // closes status box and commits colour
                this.onEnter();
            } else {
                this.setState({
                    color: color
                });
                this.props.onSelect({
                    text: text,
                    color: color,
                    localId: localId
                });
            }
        }, this.onTextChanged = (text)=>{
            const { color: color, localId: localId } = this.state;
            this.setState({
                text: text
            });
            this.props.onTextChanged({
                text: text,
                color: color,
                localId: localId
            }, !!this.props.isNew);
        }, this.onEnter = ()=>{
            this.inputMethod = "enterKey";
            this.props.onEnter(this.state);
        }, this.onSuggestedStatusClick = (status, position)=>{
            this.fireSuggestedStatusClickedAnalytics(status, position);
            this.props.onSuggestedStatusClick(status);
        }, this.handleSuggestedStatusKeyDown = (event)=>{
            // Selection (Enter/Space) is handled natively via the button's onClick.
            // Keydown only drives ArrowUp/ArrowDown navigation between suggestions.
            if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
                event.preventDefault();
                event.stopPropagation();
                this.focusAdjacentSuggestedStatus(event.currentTarget, event.key === 'ArrowDown' ? 1 : -1);
            }
        }, // cancel bubbling to fix clickOutside logic:
        // popup re-renders its content before the click event bubbles up to the document
        // therefore click target element would be different from the popup content
        this.handlePopupClick = (event)=>event.nativeEvent.stopImmediatePropagation();
        this.state = this.extractStateFromProps(props);
        this.createStatusAnalyticsAndFireFunc = (0, $aWayE.createStatusAnalyticsAndFire)(props.createAnalyticsEvent);
        this.popupBodyWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createRef();
    }
    fireStatusPopupOpenedAnalytics(state) {
        const { color: color, text: text, localId: localId, isNew: isNew } = state;
        this.startTime = Date.now();
        this.createStatusAnalyticsAndFireFunc({
            action: 'opened',
            actionSubject: 'statusPopup',
            attributes: {
                textLength: text ? text.length : 0,
                selectedColor: color,
                localId: localId,
                state: (0, $aWayE.analyticsState)(isNew)
            }
        });
    }
    fireStatusPopupClosedAnalytics(state) {
        const { color: color, text: text, localId: localId, isNew: isNew } = state;
        this.createStatusAnalyticsAndFireFunc({
            action: 'closed',
            actionSubject: 'statusPopup',
            attributes: {
                inputMethod: this.inputMethod,
                duration: Date.now() - this.startTime,
                textLength: text ? text.length : 0,
                selectedColor: color,
                localId: localId,
                state: (0, $aWayE.analyticsState)(isNew)
            }
        });
    }
    reset() {
        this.startTime = Date.now();
        this.inputMethod = "blur";
    }
    componentDidMount() {
        this.reset();
        this.fireStatusPopupOpenedAnalytics(this.state);
    }
    componentWillUnmount() {
        this.focusTimeout && cancelAnimationFrame(this.focusTimeout);
        this.fireStatusPopupClosedAnalytics(this.state);
        this.startTime = 0;
    }
    componentDidUpdate(prevProps, prevState) {
        const element = this.props.target;
        if (prevProps.target !== element) {
            const newState = this.extractStateFromProps(this.props);
            this.setState(newState);
            this.fireStatusPopupClosedAnalytics(prevState);
            this.reset();
            this.fireStatusPopupOpenedAnalytics(newState);
        }
    }
    extractStateFromProps(props) {
        const { defaultColor: defaultColor, defaultText: defaultText, defaultLocalId: defaultLocalId, isNew: isNew } = props;
        return {
            color: defaultColor || (0, $iRCoz.DEFAULT_STATUS).color,
            text: defaultText || (0, $iRCoz.DEFAULT_STATUS).text,
            localId: defaultLocalId,
            isNew: isNew
        };
    }
    setRef(setOutsideClickTargetRef) {
        return (ref)=>{
            setOutsideClickTargetRef(ref);
            this.popupBodyWrapper.current = ref;
        };
    }
    renderWithSetOutsideClickTargetRef(setOutsideClickTargetRef) {
        const { isNew: isNew, focusStatusInput: focusStatusInput, api: api, suggestedStatuses: suggestedStatuses } = this.props;
        const { color: color, text: text } = this.state;
        const isSuggestionsEnabled = (0, $3y2s4.isExperimentEnabled)('platform_editor_status_popup_suggestions');
        const isUpdateStatusColorsEnabled = (0, $3y2s4.isExperimentEnabled)('platform_editor_update_status_colors') || (0, $3y2s4.isExperimentEnabled)('platform_editor_update_status_colors_jira');
        const suggestedStatusList = suggestedStatuses !== null && suggestedStatuses !== void 0 && suggestedStatuses.length && isSuggestionsEnabled ? /*#__PURE__*/ (0, $9dQre.jsx)("div", {
            css: $2b204993af1ebf52$var$suggestedStatusesContainerStyles,
            "data-suggested-status-list": true
        }, suggestedStatuses.map((suggestedStatus, index)=>/*#__PURE__*/ (0, $9dQre.jsx)("div", {
                css: $2b204993af1ebf52$var$suggestedStatusButtonWrapperStyles,
                key: `${suggestedStatus.color}:${suggestedStatus.text}`
            }, /*#__PURE__*/ (0, $9dQre.jsx)("button", {
                type: "button",
                css: $2b204993af1ebf52$var$suggestedStatusButtonStyles,
                onClick: ()=>this.onSuggestedStatusClick(suggestedStatus, index + 1),
                onKeyDown: this.handleSuggestedStatusKeyDown,
                "aria-label": suggestedStatus.displayText,
                "data-suggested-status-button": true
            }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $asIyf.Status), {
                color: suggestedStatus.color,
                isConstrainedToParent: true,
                text: suggestedStatus.displayText
            }))))) : null;
        const pickerContent = /*#__PURE__*/ (0, $9dQre.jsx)((0, $574Jv.StatusPicker), {
            autoFocus: isNew || focusStatusInput,
            selectedColor: color,
            text: text,
            onColorClick: this.onColorClick,
            onColorHover: this.onColorHover,
            onTextChanged: this.onTextChanged,
            onEnter: this.onEnter,
            palette: isUpdateStatusColorsEnabled ? 'extended' : 'default',
            scrollableContent: suggestedStatusList
        });
        return /*#__PURE__*/ (0, $9dQre.jsx)((0, $cp06f.UserIntentPopupWrapper), {
            api: api,
            userIntent: "statusPickerOpen"
        }, /*#__PURE__*/ (0, $9dQre.jsx)("div", {
            css: [
                (0, $gdUUy.fg)('platform-dst-lozenge-tag-badge-visual-uplifts') ? $2b204993af1ebf52$var$pickerContainerStylesTeam26 : $2b204993af1ebf52$var$pickerContainerStyles,
                isSuggestionsEnabled && isUpdateStatusColorsEnabled ? $2b204993af1ebf52$var$statusPickerWidthStyles : undefined,
                isSuggestionsEnabled && !isUpdateStatusColorsEnabled ? $2b204993af1ebf52$var$statusPickerWidthStylesOld : undefined,
                isSuggestionsEnabled && !!suggestedStatusList ? $2b204993af1ebf52$var$pickerContainerNoBottomPaddingStyles : undefined
            ],
            role: "none",
            ref: this.setRef(setOutsideClickTargetRef),
            onClick: this.handlePopupClick,
            onKeyDown: this.onKeyDown
        }, pickerContent));
    }
    render() {
        const { target: target, mountTo: mountTo, boundariesElement: boundariesElement, scrollableElement: scrollableElement, editorView: editorView, intl: intl } = this.props;
        if (!(editorView !== null && editorView !== void 0 && editorView.editable)) return null;
        const fitHeight = (0, $3y2s4.isExperimentEnabled)('platform_editor_update_status_colors') || (0, $3y2s4.isExperimentEnabled)('platform_editor_update_status_colors_jira') ? $2b204993af1ebf52$var$STATUS_PICKER_TEN_COLOR_FIT_HEIGHT : $2b204993af1ebf52$var$STATUS_PICKER_FIT_HEIGHT;
        return target && /*#__PURE__*/ (0, $9dQre.jsx)($2b204993af1ebf52$var$PopupWithListeners, {
            ariaLabel: intl.formatMessage((0, $6kjeV.messages).statusEditorLabel),
            target: target,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            offset: [
                0,
                8
            ],
            handleClickOutside: this.handleClickOutside,
            handleEscapeKeydown: this.handleEscapeKeydown,
            zIndex: (0, $5bbjm.akEditorFloatingDialogZIndex),
            fitHeight: (0, $3y2s4.isExperimentEnabled)('platform_editor_status_popup_suggestions') ? fitHeight : 40,
            mountTo: mountTo,
            boundariesElement: boundariesElement,
            scrollableElement: scrollableElement,
            closeOnTab: false
        }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $9Abbn.default), {
            "aria-atomic": true,
            role: "alert"
        }, intl.formatMessage((0, $6kjeV.messages).statusPickerOpenedAlert)), /*#__PURE__*/ (0, $9dQre.jsx)((0, $3Aq92.OutsideClickTargetRefContext).Consumer, null, this.renderWithSetOutsideClickTargetRef.bind(this)));
    }
    fireSuggestedStatusClickedAnalytics(status, position) {
        var _this$props$suggested;
        this.createStatusAnalyticsAndFireFunc({
            action: 'clicked',
            actionSubject: 'statusSuggestion',
            attributes: {
                color: status.color,
                localId: this.state.localId,
                position: position,
                state: (0, $aWayE.analyticsState)(this.props.isNew),
                textLength: status.text ? status.text.length : 0,
                totalSuggestions: ((_this$props$suggested = this.props.suggestedStatuses) === null || _this$props$suggested === void 0 ? void 0 : _this$props$suggested.length) ?? 0
            }
        });
    }
    focusAdjacentSuggestedStatus(currentButton, direction) {
        var _this$popupBodyWrappe2, _suggestedStatusButto;
        const suggestedStatusButtons = (_this$popupBodyWrappe2 = this.popupBodyWrapper.current) === null || _this$popupBodyWrappe2 === void 0 ? void 0 : _this$popupBodyWrappe2.querySelectorAll('button[data-suggested-status-button]');
        if (!(suggestedStatusButtons !== null && suggestedStatusButtons !== void 0 && suggestedStatusButtons.length)) return;
        const currentIndex = Array.from(suggestedStatusButtons).indexOf(currentButton);
        if (currentIndex < 0) return;
        const nextIndex = (currentIndex + direction + suggestedStatusButtons.length) % suggestedStatusButtons.length;
        (_suggestedStatusButto = suggestedStatusButtons[nextIndex]) === null || _suggestedStatusButto === void 0 || _suggestedStatusButto.focus();
    }
}
const $2b204993af1ebf52$export$bcfa9a4744e42b68 = (0, $fK3tS.default)($2b204993af1ebf52$var$StatusPickerWithIntl);
const $2b204993af1ebf52$var$_default_1 = (0, $kIbto.default)()($2b204993af1ebf52$export$bcfa9a4744e42b68);
var $2b204993af1ebf52$export$2e2bcd8739ae039 = $2b204993af1ebf52$var$_default_1;

});
parcelRegister("574Jv", function(module, exports) {
$parcel$export(module.exports, "StatusPicker", () => $119c9dd1d5f565e8$export$39975ce689bf0105);
/* StatusPicker.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $fK3tS = parcelRequire("fK3tS");

var $jgsO4 = parcelRequire("jgsO4");

var $9mOMT = parcelRequire("9mOMT");

var $2aHQc = parcelRequire("2aHQc");
const $119c9dd1d5f565e8$var$fieldTextWrapperStyles = null;
const $119c9dd1d5f565e8$var$scrollContainerStyles = null;
const $119c9dd1d5f565e8$var$paletteWrapperStyles = null;
const $119c9dd1d5f565e8$var$scrollHeightStyles = null;
class $119c9dd1d5f565e8$var$Picker extends (0, $bSJIT.PureComponent) {
    static #_ = this.defaultProps = {
        autoFocus: true
    };
    render() {
        const { text: text, selectedColor: selectedColor, onColorClick: onColorClick, onColorHover: onColorHover, intl: intl, scrollableContent: scrollableContent, palette: palette } = this.props;
        const colorPalette = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $2aHQc.default), {
            key: this.colorPaletteKey,
            onClick: onColorClick,
            onHover: onColorHover,
            selectedColor: selectedColor,
            palette: palette
        });
        // Using <React.Fragment> instead of [] to workaround Enzyme
        // (https://github.com/airbnb/enzyme/issues/1149)
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
            key: this.fieldTextWrapperKey,
            className: (0, $9fU1q.default)([
                "_19pkidpf _otyridpf _2hwxu2gc _18u0u2gc _n6341ihb"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $jgsO4.default), {
            value: text,
            isCompact: true,
            ref: this.handleInputRef,
            onChange: this.onChange,
            onKeyPress: this.onKeyPress,
            spellCheck: false,
            autoComplete: "off",
            "aria-label": intl.formatMessage((0, $9mOMT.messages).statusInputLabel)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
            className: (0, $9fU1q.default)([
                "_19pku2gc"
            ])
        }, colorPalette), scrollableContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("div", {
            "data-status-picker-scroll-container": true,
            className: (0, $9fU1q.default)([
                "_18m91wug _15mtglyw _1bsb1osq",
                "_c71l1lit"
            ])
        }, scrollableContent) : null);
    }
    componentDidUpdate() {
        if (this.inputRef && this.props.autoFocus) this.focusInput();
    }
    componentWillUnmount() {
        if (this.autofocusTimeout !== undefined) clearTimeout(this.autofocusTimeout);
    }
    constructor(...args){
        super(...args), this.fieldTextWrapperKey = Math.random().toString(), this.colorPaletteKey = Math.random().toString(), this.onChange = (evt)=>{
            // @ts-ignore
            this.props.onTextChanged(evt.target.value);
        }, this.onKeyPress = (event)=>{
            if (event.key === 'Enter') this.props.onEnter();
        }, this.handleInputRef = (ref)=>{
            this.inputRef = ref;
            if (ref && this.props.autoFocus) this.focusInput();
        }, this.focusInput = ()=>{
            if (!this.inputRef) return;
            // Defer to prevent editor scrolling to top
            this.autofocusTimeout = setTimeout(()=>{
                var _this$inputRef;
                (_this$inputRef = this.inputRef) === null || _this$inputRef === void 0 || _this$inputRef.focus();
            });
        };
    }
}
const $119c9dd1d5f565e8$export$39975ce689bf0105 = (0, $fK3tS.default)($119c9dd1d5f565e8$var$Picker);

});
parcelRegister("9mOMT", function(module, exports) {
$parcel$export(module.exports, "messages", () => $53f0f218b0fa91ce$export$defe85febe8b728c);

var $f0Pt4 = parcelRequire("f0Pt4");
const $53f0f218b0fa91ce$export$defe85febe8b728c = (0, $f0Pt4.defineMessages)({
    neutralColor: {
        id: 'fabric.status.color.grey',
        defaultMessage: 'Gray',
        description: 'Tooltip for the gray color in color palette'
    },
    purpleColor: {
        id: 'fabric.status.color.purple',
        defaultMessage: 'Purple',
        description: 'Tooltip for the purple color in color palette'
    },
    blueColor: {
        id: 'fabric.status.color.blue',
        defaultMessage: 'Blue',
        description: 'Tooltip for the blue color in color palette'
    },
    redColor: {
        id: 'fabric.status.color.red',
        defaultMessage: 'Red',
        description: 'Tooltip for the red color in color palette'
    },
    yellowColor: {
        id: 'fabric.status.color.yellow',
        defaultMessage: 'Yellow',
        description: 'Tooltip for the yellow color in color palette'
    },
    greenColor: {
        id: 'fabric.status.color.green',
        defaultMessage: 'Green',
        description: 'Tooltip for the green color in color palette'
    },
    tealColor: {
        id: 'fabric.status.color.teal',
        defaultMessage: 'Teal',
        description: 'Tooltip for the teal color in color palette'
    },
    limeColor: {
        id: 'fabric.status.color.lime',
        defaultMessage: 'Lime',
        description: 'Tooltip for the lime color in color palette'
    },
    orangeColor: {
        id: 'fabric.status.color.orange',
        defaultMessage: 'Orange',
        description: 'Tooltip for the orange color in color palette'
    },
    magentaColor: {
        id: 'fabric.status.color.magenta',
        defaultMessage: 'Magenta',
        description: 'Tooltip for the magenta color in color palette'
    },
    statusInputLabel: {
        id: 'fabric.status.input.label',
        defaultMessage: 'Set a status',
        description: 'Aria label text for the status input field'
    }
});

});

parcelRegister("2aHQc", function(module, exports) {
$parcel$export(module.exports, "default", () => $53418a4bd852c712$export$2e2bcd8739ae039);
/* color-palette.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $gdUUy = parcelRequire("gdUUy");

var $ceb9s = parcelRequire("ceb9s");

var $lKGUH = parcelRequire("lKGUH");

var $gp53S = parcelRequire("gp53S");
const $53418a4bd852c712$var$paletteLegacy = [
    [
        'neutral',
        "var(--ds-background-neutral, #0515240F)",
        "var(--ds-border-bold, #7D818A)",
        "var(--ds-icon, #292A2E)"
    ],
    [
        'purple',
        "var(--ds-background-discovery, #F8EEFE)",
        "var(--ds-border-discovery, #AF59E1)",
        "var(--ds-icon-discovery, #AF59E1)"
    ],
    [
        'blue',
        "var(--ds-background-information, #E9F2FE)",
        "var(--ds-border-information, #357DE8)",
        "var(--ds-icon-information, #357DE8)"
    ],
    [
        'red',
        "var(--ds-background-danger, #FFECEB)",
        "var(--ds-border-danger, #E2483D)",
        "var(--ds-icon-danger, #C9372C)"
    ],
    [
        'yellow',
        "var(--ds-background-warning, #FFF5DB)",
        "var(--ds-border-warning, #E06C00)",
        "var(--ds-icon-warning, #E06C00)"
    ],
    [
        'green',
        "var(--ds-background-success, #EFFFD6)",
        "var(--ds-border-success, #6A9A23)",
        "var(--ds-icon-success, #6A9A23)"
    ]
];
const $53418a4bd852c712$var$paletteRefreshed = [
    [
        'neutral',
        "var(--ds-background-accent-gray-subtler, #DDDEE1)",
        "var(--ds-border-bold, #7D818A)",
        "var(--ds-icon, #292A2E)"
    ],
    [
        'blue',
        "var(--ds-background-information-pressed, #ADCBFB)",
        "var(--ds-border-information, #357DE8)",
        "var(--ds-icon, #292A2E)"
    ],
    [
        'green',
        "var(--ds-background-success-pressed, #BDE97C)",
        "var(--ds-border-success, #6A9A23)",
        "var(--ds-icon, #292A2E)"
    ],
    [
        'yellow',
        "var(--ds-background-warning-pressed, #FBD779)",
        "var(--ds-border-warning, #E06C00)",
        "var(--ds-icon, #292A2E)"
    ],
    [
        'red',
        "var(--ds-background-danger-pressed, #FFB8B2)",
        "var(--ds-border-danger, #E2483D)",
        "var(--ds-icon, #292A2E)"
    ],
    [
        'purple',
        "var(--ds-background-discovery-pressed, #E3BDFA)",
        "var(--ds-border-discovery, #AF59E1)",
        "var(--ds-icon, #292A2E)"
    ]
];
const $53418a4bd852c712$var$paletteTeam26 = [
    [
        'neutral',
        "var(--ds-background-neutral, #0515240F)",
        '#CACBCF',
        '#63666B',
        "var(--ds-icon, #292A2E)"
    ],
    [
        'blue',
        "var(--ds-background-information-subtler, #CFE1FD)",
        '#8FB8F6',
        '#1558BC',
        "var(--ds-icon, #292A2E)"
    ],
    [
        'green',
        "var(--ds-background-success-subtler, #D3F1A7)",
        '#B3DF72',
        '#4C6B1F',
        "var(--ds-icon, #292A2E)"
    ],
    [
        'yellow',
        "var(--ds-background-warning-subtler, #FCE4A6)",
        '#FBC828',
        '#9E4C00',
        "var(--ds-icon, #292A2E)"
    ],
    [
        'red',
        "var(--ds-background-danger-subtler, #FFD5D2)",
        '#FD9891',
        '#AE2E24',
        "var(--ds-icon, #292A2E)"
    ],
    [
        'purple',
        "var(--ds-background-discovery-subtler, #EED7FC)",
        '#D8A0F7',
        '#803FA5',
        "var(--ds-icon, #292A2E)"
    ]
];
// Derived from the status colour registry so the swatch list, the Lozenge appearances
// and the i18n keys cannot drift apart. See COLORS.
const $53418a4bd852c712$var$paletteHex = (0, $lKGUH.PICKER_SWATCHES).flatMap((value)=>{
    const swatch = (0, $lKGUH.COLORS)[value].swatch;
    return swatch ? [
        [
            value,
            swatch.backgroundColor,
            swatch.borderColor,
            (0, $lKGUH.SWATCH_ICON_COLOR)
        ]
    ] : [];
});
/** Columns each variant is laid out in; `extended` wraps its ten swatches onto two rows. */ const $53418a4bd852c712$var$variantToCols = {
    default: 7,
    extended: 5
};
const $53418a4bd852c712$var$getPalette = (colorMode, variant = 'default')=>{
    if (variant === 'extended') return $53418a4bd852c712$var$paletteHex;
    if ((0, $gdUUy.fg)('platform-dst-lozenge-tag-badge-visual-uplifts')) {
        const isDark = colorMode === 'dark';
        return $53418a4bd852c712$var$paletteTeam26.map(([colorValue, backgroundColor, lightBorderColor, darkBorderColor, iconColor])=>[
                colorValue,
                backgroundColor,
                isDark ? darkBorderColor : lightBorderColor,
                iconColor
            ]);
    }
    return (0, $gdUUy.fg)('platform-component-visual-refresh') ? $53418a4bd852c712$var$paletteRefreshed : $53418a4bd852c712$var$paletteLegacy;
};
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/design-system/no-css-tagged-template-expression -- Ignored via go/DSP-18766
const $53418a4bd852c712$var$colorPaletteWrapperStyles = null;
const $53418a4bd852c712$var$colorPaletteRowGapStyles = null;
var $53418a4bd852c712$export$2e2bcd8739ae039 = ({ cols: cols, onClick: onClick, selectedColor: selectedColor, className: className, onHover: onHover, palette: variant = 'default' })=>{
    const { colorMode: colorMode } = (0, $ceb9s.useThemeObserver)();
    const palette = $53418a4bd852c712$var$getPalette(colorMode, variant);
    const resolvedCols = cols ?? $53418a4bd852c712$var$variantToCols[variant];
    const colorRefs = (0, $bSJIT.useRef)([]);
    (0, $bSJIT.useEffect)(()=>{
        colorRefs.current = colorRefs.current.slice(0, palette.length);
    }, [
        palette.length
    ]);
    const createKeyDownHandler = (0, $bSJIT.useCallback)((index)=>(e)=>{
            var _colorRefs$current$ne;
            let newColorIndex = null;
            const nextColor = ()=>index + 1 > palette.length - 1 ? 0 : index + 1;
            const previousColor = ()=>index - 1 < 0 ? palette.length - 1 : index - 1;
            switch(e.key){
                case 'ArrowRight':
                case 'ArrowDown':
                    e.preventDefault();
                    newColorIndex = nextColor();
                    break;
                case 'ArrowLeft':
                case 'ArrowUp':
                    e.preventDefault();
                    newColorIndex = previousColor();
                    break;
            }
            if (newColorIndex === null) return;
            (_colorRefs$current$ne = colorRefs.current[newColorIndex]) === null || _colorRefs$current$ne === void 0 || _colorRefs$current$ne.focus();
        }, [
        colorRefs,
        palette.length
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement("ul", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $9fU1q.default)([
            "_19bvidpf _19pku2gc _2hwxu2gc _otyridpf _18u0u2gc _1e0c1txw _1n261g80",
            variant === 'extended' && "_1p571b66",
            className
        ]),
        style: {
            maxWidth: resolvedCols * 32
        }
    }, palette.map(([colorValue, backgroundColor, borderColor, iconColor], i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $gp53S.default), {
            key: colorValue,
            value: colorValue,
            backgroundColor: backgroundColor,
            borderColor: borderColor,
            iconColor: iconColor,
            onClick: onClick,
            onHover: onHover,
            isSelected: (0, $lKGUH.isSwatchSelected)(colorValue, selectedColor),
            tabIndex: i === 0 ? 0 : -1,
            setRef: (el)=>colorRefs.current[i] = el,
            onKeyDown: createKeyDownHandler(i)
        })));
};

});
parcelRegister("gp53S", function(module, exports) {
$parcel$export(module.exports, "default", () => $2004cd4ca15ee583$export$2e2bcd8739ae039);
/* color.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $5cKiX = parcelRequire("5cKiX");

var $k9Jtq = parcelRequire("k9Jtq");

var $gXqq0 = parcelRequire("gXqq0");

var $bbdYx = parcelRequire("bbdYx");

var $9mOMT = parcelRequire("9mOMT");

var $lKGUH = parcelRequire("lKGUH");
const $2004cd4ca15ee583$var$styles = {
    button: "_2rko12b0 _19itia51 _1reo15vq _18m915vq _4t3i1tcg _1bsb1tcg _bfhki8nm _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _1e0c1ule"
};
const $2004cd4ca15ee583$var$buttonWrapperStyles = null;
class $2004cd4ca15ee583$export$2e2bcd8739ae039 extends (0, $bSJIT.PureComponent) {
    render() {
        const { tabIndex: tabIndex, backgroundColor: backgroundColor, isSelected: isSelected, borderColor: borderColor, iconColor: iconColor, value: value, setRef: setRef, onKeyDown: onKeyDown } = this.props;
        return /*#__PURE__*/ $bSJIT.createElement("li", {
            className: (0, $9fU1q.default)([
                "_2rko12x7 _189ee4h9 _1dqonqa1 _1h6d1j28 _19pkze3t _2hwxv77o _otyrze3t _18u0v77o _1e0c1txw _4cvr1h6o _ca0qe4h9 _u5f3e4h9 _n3tde4h9 _19bve4h9 _bfw7ia51"
            ])
        }, /*#__PURE__*/ $bSJIT.createElement((0, $5cKiX.default), (0, $9mOMT.messages)[(0, $lKGUH.getColorLabelKey)(value)], (labels)=>/*#__PURE__*/ $bSJIT.createElement((0, $gXqq0.Pressable), {
                xcss: $2004cd4ca15ee583$var$styles.button,
                onClick: this.onClick,
                onMouseEnter: this.onMouseEnter,
                onMouseLeave: this.onMouseLeave,
                onMouseDown: this.onMouseDown,
                onKeyDown: onKeyDown,
                tabIndex: tabIndex,
                title: labels[0],
                // button element does not support aria-selected.
                // For button selected (to be precise pressed) or not
                //  use aria-pressed as per
                // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/button_role#associated_aria_roles_states_and_properties
                "aria-pressed": isSelected,
                style: {
                    backgroundColor: backgroundColor || 'transparent',
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                    color: iconColor,
                    borderColor: // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                    borderColor
                },
                ref: setRef
            }, isSelected && /*#__PURE__*/ $bSJIT.createElement((0, (/*@__PURE__*/$parcel$interopDefault($k9Jtq))), {
                color: "currentColor",
                label: labels[0]
            }))));
    }
    componentWillUnmount() {
        this.hoverStartTime = 0;
    }
    constructor(...args){
        super(...args), this.hoverStartTime = 0, this.onMouseEnter = ()=>{
            this.hoverStartTime = Date.now();
        }, this.onMouseLeave = ()=>{
            const { onHover: onHover } = this.props;
            const delay = Date.now() - this.hoverStartTime;
            if (delay >= (0, $bbdYx.ANALYTICS_HOVER_DELAY) && onHover) onHover(this.props.value);
            this.hoverStartTime = 0;
        }, this.onMouseDown = (e)=>{
            e.preventDefault();
        }, this.onClick = (e)=>{
            const { onClick: onClick, value: value } = this.props;
            e.preventDefault();
            onClick(value);
        };
    }
}

});



parcelRegister("aWayE", function(module, exports) {
$parcel$export(module.exports, "createStatusAnalyticsAndFire", () => $379b57155e5ace1d$export$aa98853957f9f5aa);
$parcel$export(module.exports, "analyticsState", () => $379b57155e5ace1d$export$69e00be7c24e6455);
const $379b57155e5ace1d$export$7787c7adba71b8c3 = 'fabric-elements';
const $379b57155e5ace1d$export$aa98853957f9f5aa = (createAnalyticsEvent)=>(payload)=>{
        if (createAnalyticsEvent && payload) {
            const statusPayload = {
                ...payload,
                eventType: 'ui'
            };
            if (!statusPayload.attributes) statusPayload.attributes = {};
            statusPayload.attributes.componentName = 'status';
            createAnalyticsEvent(statusPayload).fire($379b57155e5ace1d$export$7787c7adba71b8c3);
        }
    };
const $379b57155e5ace1d$export$69e00be7c24e6455 = (isNew)=>isNew ? 'new' : 'update';

});



parcelRegister("lVAFz", function(module, exports) {
$parcel$export(module.exports, "getStatusQuickInsertComponents", () => $851ce2f0663885a4$export$40f4dbe3660e5878);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $cW1gB = parcelRequire("cW1gB");

var $b8Hvx = parcelRequire("b8Hvx");

var $9woaI = parcelRequire("9woaI");

var $am2Qg = parcelRequire("am2Qg");

var $goZLw = parcelRequire("goZLw");
const $851ce2f0663885a4$var$previewImageUrls = {
    light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVKM.png',
    dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVH8.png'
};
const $851ce2f0663885a4$export$40f4dbe3660e5878 = ({ api: api })=>[
        {
            key: (0, $9woaI.STATUS_MENU_ITEM).key,
            type: (0, $9woaI.STATUS_MENU_ITEM).type,
            parents: [
                {
                    key: (0, $9woaI.STRUCTURE_SECTION).key,
                    type: (0, $9woaI.STRUCTURE_SECTION).type,
                    rank: (0, $am2Qg.STRUCTURE_SECTION_RANK)[(0, $9woaI.STATUS_MENU_ITEM).key]
                }
            ],
            match: (0, $b8Hvx.createQuickInsertMatcher)(({ formatMessage: formatMessage })=>({
                    description: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).statusDescription),
                    keywords: [
                        'lozenge'
                    ],
                    title: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).status)
                })),
            component: ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $goZLw.StatusQuickInsertMenuItem), {
                    api: api,
                    previewImageUrls: $851ce2f0663885a4$var$previewImageUrls
                })
        }
    ];

});
parcelRegister("goZLw", function(module, exports) {
$parcel$export(module.exports, "StatusQuickInsertMenuItem", () => $0efcad1399040e54$export$95fca5d556748032);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $g6Qq4 = parcelRequire("g6Qq4");

var $cW1gB = parcelRequire("cW1gB");

var $fT9mF = parcelRequire("fT9mF");

var $64eKJ = parcelRequire("64eKJ");

var $kXH8r = parcelRequire("kXH8r");

var $bPDay = parcelRequire("bPDay");
const $0efcad1399040e54$export$95fca5d556748032 = ({ api: api, previewImageUrls: previewImageUrls })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const preview = (0, $bSJIT.useMemo)(()=>previewImageUrls ? {
            image: previewImageUrls,
            attribution: {
                name: formatMessage((0, $64eKJ.messages).previewAttributionAtlassian)
            }
        } : undefined, [
        formatMessage,
        previewImageUrls
    ]);
    const onSelect = (0, $bSJIT.useCallback)(({ insert: insert })=>{
        var _api$analytics;
        const tr = insert(undefined);
        return (0, $bPDay.insertStatus)(api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions)((0, $g6Qq4.INPUT_METHOD).QUICK_INSERT)({
            tr: tr
        }) ?? tr;
    }, [
        api
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $fT9mF.QuickInsertMenuItem), {
        description: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).statusDescription),
        iconBefore: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kXH8r))), {
            label: ""
        }),
        onSelect: onSelect,
        preview: preview,
        title: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).status)
    });
};

});


parcelRegister("4JfiJ", function(module, exports) {
$parcel$export(module.exports, "createStatusBlockMenuItem", () => $02fd9aff32fefa87$export$1bc5e7c5f3514477);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $g6Qq4 = parcelRequire("g6Qq4");

var $cW1gB = parcelRequire("cW1gB");

var $dbuPt = parcelRequire("dbuPt");

var $kXH8r = parcelRequire("kXH8r");

var $6LpyK = parcelRequire("6LpyK");

var $iRCoz = parcelRequire("iRCoz");
const $02fd9aff32fefa87$var$StatusBlockMenuItem = ({ api: api, isSuggested: isSuggested })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const handleClick = ()=>{
        api === null || api === void 0 || api.core.actions.execute(({ tr: tr })=>{
            var _api$blockMenu, _api$analytics;
            const command = api === null || api === void 0 || (_api$blockMenu = api.blockMenu) === null || _api$blockMenu === void 0 ? void 0 : _api$blockMenu.commands.transformInlineNode({
                buildInlineNode: (source)=>(0, $iRCoz.createStatusNode)(tr.doc.type.schema, {
                        text: source.textContent.trim()
                    }),
                isSuggested: isSuggested,
                targetTypeName: 'status'
            });
            const nextTr = command === null || command === void 0 ? void 0 : command({
                tr: tr
            });
            if (!(nextTr !== null && nextTr !== void 0 && nextTr.docChanged)) return null;
            api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 || (_api$analytics = _api$analytics.actions) === null || _api$analytics === void 0 || _api$analytics.attachAnalyticsEvent({
                action: (0, $g6Qq4.ACTION).INSERTED,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).DOCUMENT,
                actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).STATUS,
                attributes: {
                    inputMethod: (0, $g6Qq4.INPUT_METHOD).BLOCK_MENU
                },
                eventType: (0, $g6Qq4.EVENT_TYPE).TRACK
            })(nextTr);
            return nextTr.setMeta((0, $6LpyK.pluginKey), {
                focusStatusInput: true,
                isNew: true,
                showStatusPickerAt: nextTr.selection.from
            });
        });
    };
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dbuPt.ToolbarDropdownItem), {
        onClick: handleClick,
        elemBefore: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kXH8r))), {
            label: "",
            size: "small"
        }),
        children: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).status)
    });
};
const $02fd9aff32fefa87$export$1bc5e7c5f3514477 = (api)=>{
    return ({ isSuggested: isSuggested } = {})=>/*#__PURE__*/ (0, $dc70d.jsx)($02fd9aff32fefa87$var$StatusBlockMenuItem, {
            api: api,
            isSuggested: isSuggested
        });
};

});

parcelRegister("dEam1", function(module, exports) {
$parcel$export(module.exports, "isStatusTurnIntoHidden", () => $b668b124dc934a88$export$92eec996e401854b);

var $cw0wu = parcelRequire("cw0wu");
const $b668b124dc934a88$var$MAX_STATUS_TURN_INTO_CHARS = 30;
const $b668b124dc934a88$var$SUPPORTED_SOURCE_TYPES = new Set([
    'paragraph',
    'heading'
]);
const $b668b124dc934a88$var$getTurnIntoStatusSourceNode = (selection)=>{
    if (!selection || !(selection instanceof (0, $cw0wu.NodeSelection))) return null;
    return selection.node;
};
const $b668b124dc934a88$export$62a566bf1e63f1ee = (node)=>{
    if (!node || !$b668b124dc934a88$var$SUPPORTED_SOURCE_TYPES.has(node.type.name)) return false;
    for(let i = 0; i < node.childCount; i++){
        if (!node.child(i).isText) return false;
    }
    return node.textContent.trim().length <= $b668b124dc934a88$var$MAX_STATUS_TURN_INTO_CHARS;
};
const $b668b124dc934a88$export$92eec996e401854b = (selection)=>!$b668b124dc934a88$export$62a566bf1e63f1ee($b668b124dc934a88$var$getTurnIntoStatusSourceNode(selection));

});


parcelRegister("j0iaN", function(module, exports) {
$parcel$export(module.exports, "getSelectedNodeOrNodeParentByNodeType", () => $02e0870cbf9fb4cf$export$64477bc469482fd0);
$parcel$export(module.exports, "toDOM", () => $02e0870cbf9fb4cf$export$289411c5a7970646);
$parcel$export(module.exports, "copyDomNode", () => $02e0870cbf9fb4cf$export$ccb445b3e5426309);
$parcel$export(module.exports, "copyDomNodeWithResult", () => $02e0870cbf9fb4cf$export$33db169877394f69);

var $kW8qW = parcelRequire("kW8qW");

var $cw0wu = parcelRequire("cw0wu");

var $gab48 = parcelRequire("gab48");

var $kAhws = parcelRequire("kAhws");

var $jxkn6 = parcelRequire("jxkn6");
function $02e0870cbf9fb4cf$export$64477bc469482fd0({ nodeType: nodeType, selection: selection }) {
    let node = (0, $gab48.findSelectedNodeOfType)(nodeType)(selection);
    if (!node) node = (0, $gab48.findParentNodeOfType)(nodeType)(selection);
    return node;
}
const $02e0870cbf9fb4cf$export$289411c5a7970646 = (node, schema)=>{
    return (0, $kW8qW.DOMSerializer).fromSchema(schema).serializeNode(node);
};
const $02e0870cbf9fb4cf$export$ccb445b3e5426309 = (domNode, nodeType, selection)=>{
    $02e0870cbf9fb4cf$export$33db169877394f69(domNode, nodeType, selection);
};
const $02e0870cbf9fb4cf$export$33db169877394f69 = (domNode, nodeType, selection)=>{
    if (!domNode) return;
    const div = document.createElement('div');
    div.appendChild(domNode);
    const schema = selection.$from.doc.type.schema;
    const browser = (0, $jxkn6.getBrowserInfo)();
    // if copying inline content
    if (nodeType.inlineContent) // The "1 1" refers to the start and end depth of the slice
    // since we're copying the text inside a paragraph, it will always be 1 1
    // https://github.com/ProseMirror/prosemirror-view/blob/master/src/clipboard.ts#L32
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    div.firstChild.setAttribute('data-pm-slice', '1 1 []');
    else // The "0 0" refers to the start and end depth of the slice
    // since we're copying the block node only, it will always be 0 0
    // https://github.com/ProseMirror/prosemirror-view/blob/master/src/clipboard.ts#L32
    // Ignored via go/ees005
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    div.firstChild.setAttribute('data-pm-slice', '0 0 []');
    const isSyncedBlock = nodeType.name === 'syncBlock' || nodeType.name === 'bodiedSyncBlock';
    if (browser.safari && isSyncedBlock) // clipboard-polyfill/native-first clipboard.write only reaches DOM fallback after rejection; Safari can
    // resolve native writes without retaining synced-block HTML, so we force copy-event/execCommand while click activation is live.
    return (0, $kAhws.copyHTMLToClipboardSynchronously)(div);
    // Safari's ClipboardItem API may not preserve HTML for extension nodes or mediaSingle nodes.
    if (browser.safari && selection instanceof (0, $cw0wu.NodeSelection) && (selection.node.type === schema.nodes.extension || selection.node.type === schema.nodes.mediaSingle)) (0, $kAhws.copyHTMLToClipboardPolyfill)(div);
    else (0, $kAhws.copyHTMLToClipboard)(div);
};

});

parcelRegister("2KDOT", function(module, exports) {
$parcel$export(module.exports, "getPopupContainerFromEditorView", () => $6362fbd922a2bb10$export$f562a1e3da45e3ca);
/**
 * Searches for the popup container element relative to the provided editor view element.
 *
 * @param editorViewEl - The editor view HTMLElement.
 * @returns The popup container HTMLElement if found, otherwise undefined.
 */ const $6362fbd922a2bb10$export$f562a1e3da45e3ca = (editorViewEl)=>{
    const editorContentArea = editorViewEl === null || editorViewEl === void 0 ? void 0 : editorViewEl.closest('.ak-editor-content-area');
    const pluginsComponentsWrapper = editorContentArea === null || editorContentArea === void 0 ? void 0 : editorContentArea.querySelector(':scope > [data-testid="plugins-components-wrapper"]');
    return pluginsComponentsWrapper || undefined;
};

});

parcelRegister("i6ggr", function(module, exports) {
$parcel$export(module.exports, "getPositionAfterTopParentNodeOfType", () => $2099c3b93c7b0dda$export$ae584b8f0be37f04);
const $2099c3b93c7b0dda$export$ae584b8f0be37f04 = (nodeType)=>($pos)=>{
        // Loop through parent nodes from top to bottom
        for(let depth = 1; depth <= $pos.depth; depth++){
            const node = $pos.node(depth);
            // Count the table nodes
            if (node.type === nodeType) return $pos.after(depth);
        }
    };

});

parcelRegister("jh23c", function(module, exports) {
$parcel$export(module.exports, "handlePaste", () => $abe6fde6c3ffa46a$export$5dbcc300324fed87);

var $kW8qW = parcelRequire("kW8qW");

var $gab48 = parcelRequire("gab48");

var $gdUUy = parcelRequire("gdUUy");

var $2E7OD = parcelRequire("2E7OD");

var $jCYj3 = parcelRequire("jCYj3");

var $gs1fw = parcelRequire("gs1fw");

var $1oK0T = parcelRequire("1oK0T");

var $d5q7D = parcelRequire("d5q7D");

var $atLfX = parcelRequire("atLfX");

var $jb6W5 = parcelRequire("jb6W5");

var $hfHX9 = parcelRequire("hfHX9");

var $jKKQx = parcelRequire("jKKQx");
const $abe6fde6c3ffa46a$var$SKIP_NESTED_TABLE_PASTE_SOURCES = [
    'microsoft-excel',
    'google-spreadsheets'
];
function $abe6fde6c3ffa46a$export$5dbcc300324fed87(view, _event, slice, options) {
    var _slice$content$firstC;
    if (!(0, $hfHX9.isInTable)(view.state)) return false;
    const { schema: schema } = view.state;
    const isPasteFullTableInsideEmptyCellEnabled = (0, $gdUUy.fg)('platform_editor_paste_full_table_inside_empty_cell');
    const isPartialTablePaste = slice.content.childCount === 1 && ((_slice$content$firstC = slice.content.firstChild) === null || _slice$content$firstC === void 0 ? void 0 : _slice$content$firstC.type) === schema.nodes.table && slice.openStart !== 0 && slice.openEnd !== 0;
    const sel = view.state.selection;
    const isCellSelection = sel instanceof (0, $2E7OD.CellSelection);
    if (isPasteFullTableInsideEmptyCellEnabled && !isPartialTablePaste && // If the selection is not a cell selection, and the selection is empty then we can insert a nested table
    !isCellSelection && sel.empty && !(options && $abe6fde6c3ffa46a$var$SKIP_NESTED_TABLE_PASTE_SOURCES.includes(options.pasteSource))) {
        const cellRes = (0, $gab48.findParentNode)((node)=>node.type === schema.nodes.tableCell || node.type === schema.nodes.tableHeader)(sel);
        if (cellRes) {
            var _cellRes$node$content;
            const canInsertNestedTable = (_cellRes$node$content = cellRes.node.contentMatchAt(0).matchType(schema.nodes.table)) === null || _cellRes$node$content === void 0 ? void 0 : _cellRes$node$content.validEnd;
            if (canInsertNestedTable) return false;
        }
    }
    let cells = (0, $jKKQx.pastedCells)(slice);
    if (isCellSelection) {
        if (!cells) cells = {
            width: 1,
            height: 1,
            rows: [
                (0, $kW8qW.Fragment).from((0, $atLfX.fitSlice)((0, $1oK0T.tableNodeTypes)(view.state.schema).cell, slice))
            ]
        };
        const table = sel.$anchorCell.node(-1);
        const start = sel.$anchorCell.start(-1);
        const tableMap = (0, $jCYj3.TableMap).get(table);
        const rect = tableMap.rectBetween(sel.$anchorCell.pos - start, sel.$headCell.pos - start);
        cells = (0, $d5q7D.clipCells)(cells, rect.right - rect.left, rect.bottom - rect.top);
        (0, $jb6W5.insertCells)(view.state, view.dispatch, start, rect, $abe6fde6c3ffa46a$var$clearColumnWidthOfCells(cells, rect, tableMap));
        return true;
    }
    if (cells) {
        const $cell = (0, $gs1fw.selectionCell)(sel);
        if (!$cell) throw new Error(`handlePaste: no cell found`);
        const start = $cell.start(-1);
        const rect = (0, $jCYj3.TableMap).get($cell.node(-1)).findCell($cell.pos - start);
        const tableMap = (0, $jCYj3.TableMap).get($cell.node(-1));
        (0, $jb6W5.insertCells)(view.state, view.dispatch, start, rect, $abe6fde6c3ffa46a$var$clearColumnWidthOfCells(cells, rect, tableMap));
        return true;
    }
    return false;
}
// Clear the pasted cells column widths so that it maintains
// the column widths of the destination table only if the pasted
// cells overlap with existing cells in the destination table.
// If the table grows on paste, keep the column widhts of the
// original table.
const $abe6fde6c3ffa46a$var$clearColumnWidthOfCells = (cells, rect, table)=>{
    const overlappingCells = [];
    for (const row of cells.rows){
        let colNum = rect.left;
        for(let index = 0; index < row.childCount; index++){
            const cell = row.child(index);
            if (colNum + cell.attrs.colspan <= table.width) {
                overlappingCells.push(cell);
                colNum += cell.attrs.colspan;
            } else break;
        }
    }
    for (const cell of overlappingCells)// TODO: ED-13910 - unblock Prosemirror bump
    // @ts-ignore
    cell.attrs.colwidth = null;
    return cells;
};

});
parcelRegister("d5q7D", function(module, exports) {
$parcel$export(module.exports, "clipCells", () => $609f2ba0677cef4b$export$cdcebd68073bc3f);
// Utilities used for copy/paste handling.
//
// This module handles pasting cell content into tables, or pasting
// anything into a cell selection, as replacing a block of cells with
// the content of the selection. When pasting cells into a cell, that
// involves placing the block of pasted content so that its top left
// aligns with the selection cell, optionally extending the table to
// the right or bottom to make sure it is large enough. Pasting into a
// cell selection is different, here the cells in the selection are
// clipped to the selection's rectangle, optionally repeating the
// pasted cells when they are smaller than the selection.

var $kW8qW = parcelRequire("kW8qW");

var $7zE9O = parcelRequire("7zE9O");
function $609f2ba0677cef4b$export$cdcebd68073bc3f({ width: currentWidth, height: currentHeight, rows: currentRows }, newWidth, newHeight) {
    let rows = currentRows;
    let width = currentWidth;
    let height = currentHeight;
    if (width !== newWidth) {
        const added = [];
        const newRows = [];
        for(let row = 0; row < rows.length; row++){
            const frag = rows[row];
            const cells = [];
            for(let col = added[row] || 0, i = 0; col < newWidth; i++){
                let cell = frag.child(i % frag.childCount);
                if (col + cell.attrs.colspan > newWidth) cell = cell.type.create((0, $7zE9O.removeColSpan)(cell.attrs, cell.attrs.colspan, col + cell.attrs.colspan - newWidth), cell.content);
                cells.push(cell);
                col += cell.attrs.colspan;
                for(let j = 1; j < cell.attrs.rowspan; j++)added[row + j] = (added[row + j] || 0) + cell.attrs.colspan;
            }
            newRows.push((0, $kW8qW.Fragment).from(cells));
        }
        rows = newRows;
        width = newWidth;
    }
    if (height !== newHeight) {
        const newRows = [];
        for(let row = 0, i = 0; row < newHeight; row++, i++){
            const cells = [];
            const source = rows[i % height];
            for(let j = 0; j < source.childCount; j++){
                let cell = source.child(j);
                if (row + cell.attrs.rowspan > newHeight) cell = cell.type.create({
                    ...cell.attrs,
                    rowspan: Math.max(1, newHeight - cell.attrs.rowspan)
                }, cell.content);
                cells.push(cell);
            }
            newRows.push((0, $kW8qW.Fragment).from(cells));
        }
        rows = newRows;
        height = newHeight;
    }
    return {
        width: width,
        height: height,
        rows: rows
    };
}

});

parcelRegister("atLfX", function(module, exports) {
$parcel$export(module.exports, "fitSlice", () => $cc5196f452d4ed26$export$f09c6b3b06d884fb);
// Utilities used for copy/paste handling.
//
// This module handles pasting cell content into tables, or pasting
// anything into a cell selection, as replacing a block of cells with
// the content of the selection. When pasting cells into a cell, that
// involves placing the block of pasted content so that its top left
// aligns with the selection cell, optionally extending the table to
// the right or bottom to make sure it is large enough. Pasting into a
// cell selection is different, here the cells in the selection are
// clipped to the selection's rectangle, optionally repeating the
// pasted cells when they are smaller than the selection.

var $3DNV7 = parcelRequire("3DNV7");
function $cc5196f452d4ed26$export$f09c6b3b06d884fb(nodeType, slice) {
    const node = nodeType.createAndFill();
    if (!node) throw new Error(`fitSlice: unable to create node`);
    const tr = new (0, $3DNV7.Transform)(node).replace(0, node.content.size, slice);
    return tr.doc;
}

});

parcelRegister("jb6W5", function(module, exports) {
$parcel$export(module.exports, "insertCells", () => $1d47cc524a19db8d$export$e0b94385c1fdc132);
// Utilities used for copy/paste handling.
//
// This module handles pasting cell content into tables, or pasting
// anything into a cell selection, as replacing a block of cells with
// the content of the selection. When pasting cells into a cell, that
// involves placing the block of pasted content so that its top left
// aligns with the selection cell, optionally extending the table to
// the right or bottom to make sure it is large enough. Pasting into a
// cell selection is different, here the cells in the selection are
// clipped to the selection's rectangle, optionally repeating the
// pasted cells when they are smaller than the selection.

var $kW8qW = parcelRequire("kW8qW");

var $2E7OD = parcelRequire("2E7OD");

var $jCYj3 = parcelRequire("jCYj3");

var $fl5nf = parcelRequire("fl5nf");

var $7zE9O = parcelRequire("7zE9O");

var $dh2Lm = parcelRequire("dh2Lm");

var $1oK0T = parcelRequire("1oK0T");
// Make sure a table has at least the given width and height. Return
// true if something was changed.
function $1d47cc524a19db8d$var$growTable(tr, map, table, start, width, height, mapFrom) {
    const { schema: schema } = tr.doc.type;
    const types = (0, $1oK0T.tableNodeTypes)(schema);
    let empty;
    let emptyHead;
    if (width > map.width) for(let row = 0, rowEnd = 0; row < map.height; row++){
        const rowNode = table.child(row);
        rowEnd += rowNode.nodeSize;
        const cells = [];
        let add;
        if (rowNode.lastChild == null || rowNode.lastChild.type === types.cell) // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        add = empty || (empty = types.cell.createAndFill());
        else // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        add = emptyHead || (emptyHead = types.header_cell.createAndFill());
        for(let i = map.width; i < width; i++)cells.push(add);
        tr.insert(tr.mapping.slice(mapFrom).map(rowEnd - 1 + start), cells);
    }
    if (height > map.height) {
        const cells = [];
        for(let i = 0, k = (map.height - 1) * map.width; i < Math.max(map.width, width); i++){
            let header;
            if (i >= map.width) header = false;
            else {
                const mappedPos = map.map[k + i];
                const node = table.nodeAt(mappedPos);
                if (!node) throw new Error(`growTable: no node found at pos ${mappedPos}`);
                header = node.type === types.header_cell;
            }
            cells.push(header ? // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            emptyHead || (emptyHead = types.header_cell.createAndFill()) : // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            empty || (empty = types.cell.createAndFill()));
        }
        const emptyRow = types.row.create(null, (0, $kW8qW.Fragment).from(cells));
        const rows = [];
        for(let i = map.height; i < height; i++)rows.push(emptyRow);
        tr.insert(tr.mapping.slice(mapFrom).map(start + table.nodeSize - 2), rows);
    }
    return !!(empty || emptyHead);
}
// Make sure the given line (left, top) to (right, top) doesn't cross
// any rowspan cells by splitting cells that cross it. Return true if
// something changed.
function $1d47cc524a19db8d$var$isolateHorizontal(tr, map, table, start, left, right, top, mapFrom) {
    if (top === 0 || top === map.height) return false;
    let found = false;
    for(let col = left; col < right; col++){
        const index = top * map.width + col;
        const pos = map.map[index];
        if (map.map[index - map.width] === pos) {
            found = true;
            const cell = table.nodeAt(pos);
            if (!cell) throw new Error(`isolateHorizontal: no cell found at pos ${pos}`);
            const { top: cellTop, left: cellLeft } = map.findCell(pos);
            tr.setNodeMarkup(tr.mapping.slice(mapFrom).map(pos + start), undefined, {
                ...cell.attrs,
                rowspan: top - cellTop
            });
            const newCell = cell.type.createAndFill({
                ...cell.attrs,
                rowspan: cellTop + cell.attrs.rowspan - top
            });
            if (!newCell) throw new Error('isolateHorizontal: failed to create cell');
            tr.insert(tr.mapping.slice(mapFrom).map(map.positionAt(top, cellLeft, table)), newCell);
            col += cell.attrs.colspan - 1;
        }
    }
    return found;
}
// Make sure the given line (left, top) to (left, bottom) doesn't
// cross any colspan cells by splitting cells that cross it. Return
// true if something changed.
function $1d47cc524a19db8d$var$isolateVertical(tr, map, table, start, top, bottom, left, mapFrom) {
    if (left === 0 || left === map.width) return false;
    let found = false;
    for(let row = top; row < bottom; row++){
        const index = row * map.width + left;
        const pos = map.map[index];
        if (map.map[index - 1] === pos) {
            found = true;
            const cell = table.nodeAt(pos);
            if (!cell) throw new Error(`isolateVertical: could not find cell at pos ${pos}`);
            const cellLeft = map.colCount(pos);
            const updatePos = tr.mapping.slice(mapFrom).map(pos + start);
            tr.setNodeMarkup(updatePos, undefined, (0, $7zE9O.removeColSpan)(cell.attrs, left - cellLeft, cell.attrs.colspan - (left - cellLeft)));
            const newCell = cell.type.createAndFill((0, $7zE9O.removeColSpan)(cell.attrs, 0, left - cellLeft));
            if (!newCell) throw new Error('isolateVertical: failed to create cell');
            tr.insert(updatePos + cell.nodeSize, newCell);
            row += cell.attrs.rowspan - 1;
        }
    }
    return found;
}
function $1d47cc524a19db8d$var$applyHeaderCells(tr, tableMap, state, tableStart, table, headerRowEnabled, headerColumnEnabled) {
    const { schema: schema } = state;
    const setMarkup = (tr, row, col, headerEnabled)=>{
        const cellPos = tableStart + tableMap.positionAt(row, col, table);
        const cell = tr.doc.nodeAt(cellPos);
        const newType = headerEnabled ? schema.nodes.tableHeader : schema.nodes.tableCell;
        const isCellTypeChanged = newType !== (cell === null || cell === void 0 ? void 0 : cell.type);
        const isCellTypeValid = !!cell && [
            schema.nodes.tableCell,
            schema.nodes.tableHeader
        ].includes(cell.type);
        if (isCellTypeChanged && isCellTypeValid) tr.setNodeMarkup(cellPos, newType, cell === null || cell === void 0 ? void 0 : cell.attrs, cell === null || cell === void 0 ? void 0 : cell.marks);
    };
    // For row === 0 && col === 0 it is enabled if either are enabled
    setMarkup(tr, 0, 0, headerColumnEnabled || headerRowEnabled);
    // Header Column
    for(let col = 1; col < tableMap.width; col++)setMarkup(tr, 0, col, headerRowEnabled);
    // Header Row
    for(let row = 1; row < tableMap.height; row++)setMarkup(tr, row, 0, headerColumnEnabled);
}
function $1d47cc524a19db8d$export$e0b94385c1fdc132(state, dispatch, tableStart, rect, cells) {
    let table = state.doc;
    const newRect = (0, $dh2Lm.selectedRect)(state);
    const types = (0, $1oK0T.tableNodeTypes)(state.schema);
    // Get if the header row and column are enabled on the original table
    const headerRowEnabled = (0, $fl5nf.isHeaderEnabledByType)('row', newRect, types);
    const headerColumnEnabled = (0, $fl5nf.isHeaderEnabledByType)('column', newRect, types);
    if (tableStart) {
        table = state.doc.nodeAt(tableStart - 1);
        if (!table) throw new Error(`insertCells: could not find table at pos ${tableStart - 1}`);
    }
    let map = (0, $jCYj3.TableMap).get(table);
    const { top: top, left: left } = rect;
    const right = left + cells.width;
    const bottom = top + cells.height;
    const { tr: tr } = state;
    let mapFrom = 0;
    function recomp() {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        table = tableStart ? tr.doc.nodeAt(tableStart - 1) : tr.doc;
        map = (0, $jCYj3.TableMap).get(table);
        mapFrom = tr.mapping.maps.length;
    }
    // Prepare the table to be large enough and not have any cells
    // crossing the boundaries of the rectangle that we want to
    // insert into. If anything about it changes, recompute the table
    // map so that subsequent operations can see the current shape.
    if ($1d47cc524a19db8d$var$growTable(tr, map, table, tableStart, right, bottom, mapFrom)) recomp();
    if ($1d47cc524a19db8d$var$isolateHorizontal(tr, map, table, tableStart, left, right, top, mapFrom)) recomp();
    if ($1d47cc524a19db8d$var$isolateHorizontal(tr, map, table, tableStart, left, right, bottom, mapFrom)) recomp();
    if ($1d47cc524a19db8d$var$isolateVertical(tr, map, table, tableStart, top, bottom, left, mapFrom)) recomp();
    if ($1d47cc524a19db8d$var$isolateVertical(tr, map, table, tableStart, top, bottom, right, mapFrom)) recomp();
    for(let row = top; row < bottom; row++){
        const from = map.positionAt(row, left, table);
        const to = map.positionAt(row, right, table);
        // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
        tr.replace(tr.mapping.slice(mapFrom).map(from + tableStart), tr.mapping.slice(mapFrom).map(to + tableStart), new (0, $kW8qW.Slice)(cells.rows[row - top], 0, 0));
    }
    recomp();
    $1d47cc524a19db8d$var$applyHeaderCells(tr, map, state, tableStart, table, headerRowEnabled, headerColumnEnabled);
    tr.setSelection(new (0, $2E7OD.CellSelection)(tr.doc.resolve(tableStart + map.map[top * map.width + left]), tr.doc.resolve(tableStart + map.map[(bottom - 1) * map.width + right - 1])));
    dispatch(tr);
}

});
parcelRegister("fl5nf", function(module, exports) {
$parcel$export(module.exports, "isHeaderEnabledByType", () => $8f24979e702e4993$export$96946e3333d0ccc6);
function $8f24979e702e4993$export$96946e3333d0ccc6(type, rect, types) {
    // Get cell positions for first row or first column
    const cellPositions = rect.map.cellsInRect({
        left: 0,
        top: 0,
        right: type === 'row' ? rect.map.width : 1,
        bottom: type === 'column' ? rect.map.height : 1
    });
    for(let i = 0; i < cellPositions.length; i++){
        const cell = rect.table.nodeAt(cellPositions[i]);
        if (cell && cell.type !== types.header_cell) return false;
    }
    return true;
}

});


parcelRegister("jKKQx", function(module, exports) {
$parcel$export(module.exports, "pastedCells", () => $7c9ca4e22f06157a$export$f6d8f52489457fc4);
// Utilities used for copy/paste handling.
//
// This module handles pasting cell content into tables, or pasting
// anything into a cell selection, as replacing a block of cells with
// the content of the selection. When pasting cells into a cell, that
// involves placing the block of pasted content so that its top left
// aligns with the selection cell, optionally extending the table to
// the right or bottom to make sure it is large enough. Pasting into a
// cell selection is different, here the cells in the selection are
// clipped to the selection's rectangle, optionally repeating the
// pasted cells when they are smaller than the selection.

var $kW8qW = parcelRequire("kW8qW");

var $atLfX = parcelRequire("atLfX");

var $1oK0T = parcelRequire("1oK0T");
// Utilities to help with copying and pasting table cells
/**
 * Replace any header cells with table cells.
 *
 * @param schema
 * @param cells
 * @returns Fragment with header cells converted to table cells
 */ function $7c9ca4e22f06157a$var$stripHeaderType(schema, cells) {
    const newCells = [];
    cells.forEach((cell)=>{
        // Convert to cell type if not already
        const cellNodeType = (0, $1oK0T.tableNodeTypes)(schema).cell;
        const tableCell = cell.type === cellNodeType ? cell : cellNodeType.createAndFill(cell.attrs, cell.content, cell.marks) ?? cell;
        newCells.push(tableCell);
    });
    return (0, $kW8qW.Fragment).from(newCells);
}
// : (Schema, [Fragment]) → {width: number, height: number, rows: [Fragment]}
// Compute the width and height of a set of cells, and make sure each
// row has the same number of cells.
function $7c9ca4e22f06157a$var$ensureRectangular(schema, rowsFragment) {
    const rows = rowsFragment;
    const widths = [];
    for(let i = 0; i < rows.length; i++){
        const row = rows[i];
        for(let j = row.childCount - 1; j >= 0; j--){
            const { rowspan: rowspan, colspan: colspan } = row.child(j).attrs;
            for(let r = i; r < i + rowspan; r++)widths[r] = (widths[r] || 0) + colspan;
        }
    }
    let width = 0;
    for(let r = 0; r < widths.length; r++)width = Math.max(width, widths[r]);
    for(let r = 0; r < widths.length; r++){
        if (r >= rows.length) rows.push((0, $kW8qW.Fragment).empty);
        if (widths[r] < width) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const empty = (0, $1oK0T.tableNodeTypes)(schema).cell.createAndFill();
            const cells = [];
            for(let i = widths[r]; i < width; i++)cells.push(empty);
            rows[r] = rows[r].append((0, $kW8qW.Fragment).from(cells));
        }
    }
    return {
        height: rows.length,
        width: width,
        rows: rows
    };
}
function $7c9ca4e22f06157a$export$f6d8f52489457fc4(slice) {
    if (!slice.size) return null;
    let { content: content, openStart: openStart, openEnd: openEnd } = slice;
    if (!content.firstChild) throw new Error('pastedCells: no firstChild defined for content');
    while(content.childCount === 1 && (openStart > 0 && openEnd > 0 || content.firstChild.type.spec.tableRole === 'table')){
        openStart--;
        openEnd--;
        content = content.firstChild.content;
        if (!content.firstChild) throw new Error('pastedCells: no firstChild defined for content');
    }
    const first = content.firstChild;
    const role = first.type.spec.tableRole;
    const { schema: schema } = first.type;
    const rows = [];
    if (role === 'row') for(let i = 0; i < content.childCount; i++){
        let cells = content.child(i).content;
        const left = i ? 0 : Math.max(0, openStart - 1);
        const right = i < content.childCount - 1 ? 0 : Math.max(0, openEnd - 1);
        if (left || right) cells = (0, $atLfX.fitSlice)((0, $1oK0T.tableNodeTypes)(schema).row, new (0, $kW8qW.Slice)(cells, left, right)).content;
        rows.push(cells);
    }
    else if (role === 'cell' || role === 'header_cell') rows.push(openStart || openEnd ? (0, $atLfX.fitSlice)((0, $1oK0T.tableNodeTypes)(schema).row, new (0, $kW8qW.Slice)(content, openStart, openEnd)).content : content);
    else return null;
    const rowsWithoutHeaders = rows.map((row)=>$7c9ca4e22f06157a$var$stripHeaderType(schema, row));
    return $7c9ca4e22f06157a$var$ensureRectangular(schema, rowsWithoutHeaders);
}

});


parcelRegister("3XdGy", function(module, exports) {
$parcel$export(module.exports, "getSelectedTableInfo", () => $29033511dccc2bd6$export$d2cf64960b17e12e);

var $jCYj3 = parcelRequire("jCYj3");

var $5BCfR = parcelRequire("5BCfR");
function $29033511dccc2bd6$export$d2cf64960b17e12e(selection) {
    let map;
    let totalRowCount = 0;
    let totalColumnCount = 0;
    const table = (0, $5BCfR.findTable)(selection);
    if (table) {
        map = (0, $jCYj3.TableMap).get(table.node);
        totalRowCount = map.height;
        totalColumnCount = map.width;
    }
    return {
        table: table,
        map: map,
        totalRowCount: totalRowCount,
        totalColumnCount: totalColumnCount
    };
}

});

parcelRegister("jSR7I", function(module, exports) {
$parcel$export(module.exports, "DropdownMenuItem", () => $5c4b6abbb895d19d$export$ed97964d1871885d);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $k9Jtq = parcelRequire("k9Jtq");

var $kpgiw = parcelRequire("kpgiw");

var $lavtv = parcelRequire("lavtv");

var $74yRN = parcelRequire("74yRN");

function $5c4b6abbb895d19d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $5c4b6abbb895d19d$var$labelStyles = {
    name: "18nns55",
    styles: "display:inline-block;width:100%"
};
const $5c4b6abbb895d19d$var$spacerStyles = {
    name: "nce1h9",
    styles: "display:flex;flex:1;padding:var(--ds-space-100, 8px)"
};
const $5c4b6abbb895d19d$var$DropdownButtonItem = (0, $kpgiw.default);
const $5c4b6abbb895d19d$var$SelectedIconBefore = ({ itemSelected: itemSelected, intl: intl, showSelected: showSelected })=>{
    if (showSelected && itemSelected) return /*#__PURE__*/ (0, $9dQre.jsx)("span", {
        "aria-hidden": "true"
    }, /*#__PURE__*/ (0, $9dQre.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($k9Jtq))), {
        label: intl.formatMessage((0, $74yRN.default).confirmModalOK),
        spacing: "none"
    }));
    return /*#__PURE__*/ (0, $9dQre.jsx)("span", {
        css: $5c4b6abbb895d19d$var$spacerStyles
    });
};
const $5c4b6abbb895d19d$export$ed97964d1871885d = (props)=>{
    const { item: item, hide: hide, dispatchCommand: dispatchCommand, editorView: editorView, showSelected: showSelected, intl: intl } = props;
    const itemSelected = item.selected;
    const iconBefore = (0, $bSJIT.useMemo)(()=>{
        if (item.icon) return item.icon;
        else return /*#__PURE__*/ (0, $9dQre.jsx)($5c4b6abbb895d19d$var$SelectedIconBefore, {
            itemSelected: itemSelected,
            showSelected: showSelected,
            intl: intl
        });
    }, [
        itemSelected,
        showSelected,
        intl,
        item.icon
    ]);
    const [tooltipContent, setTooltipContent] = (0, $bSJIT.useState)(item.tooltip || '');
    const handleItemMouseOut = (0, $bSJIT.useCallback)(()=>{
        setTooltipContent('');
        if (item.onMouseOut) dispatchCommand(item.onMouseOut);
    }, [
        item.onMouseOut,
        dispatchCommand
    ]);
    const handleItemMouseDown = (0, $bSJIT.useCallback)((e)=>{
        e.preventDefault(); // ED-16204 - This is needed for safari to get handleItemClick() to work
        if (item.onMouseDown) dispatchCommand(item.onMouseDown);
    }, [
        item.onMouseDown,
        dispatchCommand
    ]);
    const handleItemMouseOver = (0, $bSJIT.useCallback)(()=>{
        setTooltipContent(item.tooltip || '');
        if (item.onMouseOver) dispatchCommand(item.onMouseOver);
    }, [
        item.tooltip,
        item.onMouseOver,
        dispatchCommand
    ]);
    const handleItemMouseEnter = (0, $bSJIT.useCallback)((e)=>{
        if (item.onMouseEnter) {
            e.preventDefault();
            dispatchCommand(item.onMouseEnter);
        }
    }, [
        item.onMouseEnter,
        dispatchCommand
    ]);
    const handleItemMouseLeave = (0, $bSJIT.useCallback)((e)=>{
        if (item.onMouseLeave) {
            e.preventDefault();
            dispatchCommand(item.onMouseLeave);
        }
    }, [
        item.onMouseLeave,
        dispatchCommand
    ]);
    const handleItemOnFocus = (0, $bSJIT.useCallback)((e)=>{
        if (item.onFocus) {
            e.preventDefault();
            dispatchCommand(item.onFocus);
        }
    }, [
        item.onFocus,
        dispatchCommand
    ]);
    const handleItemOnBlur = (0, $bSJIT.useCallback)((e)=>{
        if (item.onBlur) {
            e.preventDefault();
            dispatchCommand(item.onBlur);
        }
    }, [
        item.onBlur,
        dispatchCommand
    ]);
    const handleItemClick = (0, $bSJIT.useCallback)(()=>{
        /**
     * The order of dispatching the event and hide() is important, because
     * the ClickAreaBlock will be relying on the element to calculate the
     * click coordinate.
     * For more details, please visit the comment in this PR https://bitbucket.org/atlassian/atlassian-frontend/pull-requests/5328/edm-1321-set-selection-near-smart-link?link_source=email#chg-packages/editor/editor-core/src/plugins/floating-toolbar/ui/DropdownMenu.tsx
     */ dispatchCommand(item.onClick);
        hide();
        if (!(editorView !== null && editorView !== void 0 && editorView.hasFocus())) editorView === null || editorView === void 0 || editorView.focus();
    }, [
        dispatchCommand,
        item.onClick,
        hide,
        editorView
    ]);
    /* ED-16704 - Native mouse event handler to overcome firefox issue on disabled <button> - https://github.com/whatwg/html/issues/5886 */ const labelRef = (0, $bSJIT.useRef)(null);
    const handleTitleWrapperMouseEvent = (0, $bSJIT.useCallback)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (e)=>{
        if (item.disabled) {
            e.stopPropagation();
            e.preventDefault();
        }
    }, [
        item.disabled
    ]);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const isAriaChecked = (item)=>{
        const { selected: selected, domItemOptions: domItemOptions } = item;
        return (domItemOptions === null || domItemOptions === void 0 ? void 0 : domItemOptions.type) === 'item-checkbox' ? selected : undefined;
    };
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const hasRole = (item)=>{
        var _item$domItemOptions;
        // Always return proper menu roles to fix aria-required-children violations
        return ((_item$domItemOptions = item.domItemOptions) === null || _item$domItemOptions === void 0 ? void 0 : _item$domItemOptions.type) === 'item-checkbox' ? 'menuitemcheckbox' : 'menuitem';
    };
    (0, $bSJIT.useEffect)(()=>{
        const labelRefCurrent = labelRef.current;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        labelRefCurrent === null || labelRefCurrent === void 0 || labelRefCurrent.addEventListener('click', handleTitleWrapperMouseEvent);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        labelRefCurrent === null || labelRefCurrent === void 0 || labelRefCurrent.addEventListener('mousedown', handleTitleWrapperMouseEvent);
        return ()=>{
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            labelRefCurrent === null || labelRefCurrent === void 0 || labelRefCurrent.removeEventListener('click', handleTitleWrapperMouseEvent);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            labelRefCurrent === null || labelRefCurrent === void 0 || labelRefCurrent.removeEventListener('mousedown', handleTitleWrapperMouseEvent);
        };
    });
    const itemContent = /*#__PURE__*/ (0, $9dQre.jsx)($5c4b6abbb895d19d$var$DropdownButtonItem, {
        isSelected: itemSelected,
        iconBefore: iconBefore,
        iconAfter: item.elemAfter,
        onClick: handleItemClick,
        "data-testid": item.testId,
        isDisabled: item.disabled,
        onMouseDown: handleItemMouseDown,
        onMouseOver: handleItemMouseOver,
        onMouseEnter: handleItemMouseEnter,
        onMouseLeave: handleItemMouseLeave,
        onMouseOut: handleItemMouseOut,
        onFocus: handleItemOnFocus,
        onBlur: handleItemOnBlur,
        role: hasRole(item),
        "aria-checked": isAriaChecked(item)
    }, /*#__PURE__*/ (0, $9dQre.jsx)("span", {
        ref: labelRef,
        css: $5c4b6abbb895d19d$var$labelStyles
    }, item.title));
    if (tooltipContent) return /*#__PURE__*/ (0, $9dQre.jsx)((0, $lavtv.default), {
        content: tooltipContent
    }, itemContent);
    return itemContent;
};

});
parcelRegister("74yRN", function(module, exports) {
$parcel$export(module.exports, "default", () => $a9a117afd5b89e33$export$2e2bcd8739ae039);

var $f0Pt4 = parcelRequire("f0Pt4");
const $a9a117afd5b89e33$var$message = (0, $f0Pt4.defineMessages)({
    confirmModalDefaultHeading: {
        id: 'fabric.editor.floatingToolbar.confirmModalHeading',
        defaultMessage: 'Are you sure?',
        description: 'Default heading of floating toolbar confirmation modal.'
    },
    confirmModalOK: {
        id: 'fabric.editor.floatingToolbar.confirmModalOK',
        defaultMessage: 'OK',
        description: 'OK button for floating toolbar confirmation modal.'
    },
    confirmModalCancel: {
        id: 'fabric.editor.floatingToolbar.confirmModalCancel',
        defaultMessage: 'Cancel',
        description: 'Cancel button for floating toolbar confirmation modal.'
    },
    confirmModalListUnit: {
        id: 'fabric.editor.floatingToolbar.confirmModalConnectedUnit',
        defaultMessage: '{name}{amount, plural, =0 {} one { (+1 connected element)} other { (+# connected elements)}}',
        description: 'Text displayed in confirmation modal which highlights the nodes and the amount of connected nodes that will be deleted'
    },
    confirmDeleteLinkedModalMessage: {
        id: 'fabric.editor.extension.confirmDeleteLinkedModalMessage',
        defaultMessage: 'Deleting {nodeName} will break anything connected to it.',
        description: 'Message for confirm modal when deleting a extension linked to an data consumer.'
    },
    floatingToolbarAriaLabel: {
        id: 'fabric.editor.floatingToolbar.floatingToolbarAriaLabel',
        defaultMessage: 'Floating Toolbar',
        description: "The text is used as the ARIA label for the floating toolbar element that appears above selected content in the editor, helping screen reader users identify the toolbar's purpose."
    },
    floatingToolbarAnnouncer: {
        id: 'fabric.editor.floatingToolbar.floatingToolbarAnnouncer',
        defaultMessage: 'Floating toolbar controls have been opened',
        description: 'message that will be announced to screenreaders that the floating toolbar is opened'
    },
    floatingToolbarScrollLeft: {
        id: 'fabric.editor.floatingToolbar.scrollLeft',
        defaultMessage: 'Scroll left',
        description: 'Button to scroll left when the toolbar is in the overflow state'
    },
    floatingToolbarScrollRight: {
        id: 'fabric.editor.floatingToolbar.scrollRight',
        defaultMessage: 'Scroll right',
        description: 'Button to scroll right when the toolbar is in the overflow state'
    }
});
var $a9a117afd5b89e33$export$2e2bcd8739ae039 = $a9a117afd5b89e33$var$message;

});


parcelRegister("kD5qu", function(module, exports) {
$parcel$export(module.exports, "DropdownSeparator", () => $a9084973a538abe1$export$c0340fdc1581055e);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled, @typescript-eslint/consistent-type-imports -- Ignored via go/DSP-18766; jsx required at runtime for @jsxRuntime classic

var $9dQre = parcelRequire("9dQre");
function $a9084973a538abe1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a9084973a538abe1$var$separatorStyles = {
    name: "1qptm7f",
    styles: "background:var(--ds-border, #0B120E24);height:1px"
};
const $a9084973a538abe1$export$c0340fdc1581055e = ()=>{
    return /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        css: $a9084973a538abe1$var$separatorStyles
    });
};

});

parcelRegister("aec79", function(module, exports) {
$parcel$export(module.exports, "isSelectionTableNestedInTable", () => $0d8c3e434b99e994$export$3dd46fa6c35aa514);

var $5BCfR = parcelRequire("5BCfR");
const $0d8c3e434b99e994$export$3dd46fa6c35aa514 = (state)=>{
    const table = (0, $5BCfR.findTable)(state.selection);
    if (!table) return false;
    const parent = state.doc.resolve(table.pos).parent;
    const nodeTypes = state.schema.nodes;
    return [
        nodeTypes.tableHeader,
        nodeTypes.tableCell
    ].includes(parent.type);
};

});

parcelRegister("4DF8z", function(module, exports) {
$parcel$export(module.exports, "transformSliceToRemoveOpenBodiedExtension", () => $2d17d7d320253e6a$export$c50f82e6f2cff97d);
$parcel$export(module.exports, "transformSliceToRemoveOpenMultiBodiedExtension", () => $2d17d7d320253e6a$export$d2a1206296dcfa47);
$parcel$export(module.exports, "transformSliceToRemoveLegacyContentMacro", () => $2d17d7d320253e6a$export$23ce34395aea8526);

var $9RSBE = parcelRequire("9RSBE");

var $kW8qW = parcelRequire("kW8qW");

var $4ClnP = parcelRequire("4ClnP");

const $2d17d7d320253e6a$export$c50f82e6f2cff97d = (slice, schema)=>{
    const { bodiedExtension: bodiedExtension } = schema.nodes;
    const fragment = (0, $4ClnP.mapFragment)(slice.content, (node, parent, index)=>{
        if (node.type === bodiedExtension && !parent) {
            const currentNodeIsAtStartAndIsOpen = slice.openStart && index === 0;
            const currentNodeIsAtEndAndIsOpen = slice.openEnd && index + 1 === slice.content.childCount;
            if (currentNodeIsAtStartAndIsOpen || currentNodeIsAtEndAndIsOpen) return node.content;
        }
        return node;
    });
    // If the first/last child has changed - then we know we've removed a bodied extension & to decrement the open depth
    return new (0, $kW8qW.Slice)(fragment, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    fragment.firstChild && fragment.firstChild.type !== slice.content.firstChild.type ? slice.openStart - 1 : slice.openStart, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    fragment.lastChild && fragment.lastChild.type !== slice.content.lastChild.type ? slice.openEnd - 1 : slice.openEnd);
};
const $2d17d7d320253e6a$export$d2a1206296dcfa47 = (slice, schema)=>{
    var _slice$content$firstC, _slice$content$firstC2;
    const { multiBodiedExtension: multiBodiedExtension, extensionFrame: extensionFrame } = schema.nodes;
    let depthToReduce = 2; // Removing MBE and extensionFrame
    // Edge case where the slice does not contain extensionFrames under MBE, happens when multiple block nodes get copied from a frame
    if (((_slice$content$firstC = slice.content.firstChild) === null || _slice$content$firstC === void 0 ? void 0 : _slice$content$firstC.type) === multiBodiedExtension && ((_slice$content$firstC2 = slice.content.firstChild) === null || _slice$content$firstC2 === void 0 || (_slice$content$firstC2 = _slice$content$firstC2.firstChild) === null || _slice$content$firstC2 === void 0 ? void 0 : _slice$content$firstC2.type) !== extensionFrame) depthToReduce = 1;
    const fragment = (0, $4ClnP.mapFragment)(slice.content, (node, parent, index)=>{
        if (node.type === multiBodiedExtension && !parent || node.type === extensionFrame) {
            const currentNodeIsAtStartAndIsOpen = slice.openStart >= depthToReduce && index === 0;
            const currentNodeIsAtEndAndIsOpen = slice.openEnd >= depthToReduce && index + 1 === slice.content.childCount;
            if (currentNodeIsAtStartAndIsOpen || currentNodeIsAtEndAndIsOpen) return node.content;
        }
        if (node.type === multiBodiedExtension) {
            var _node$attrs$parameter;
            /* While pasting on the same page, macroId does not change until the page is published and causes collision with the existing macroId
       *  where switching tabs of one node changes the tabs for the other node, so we put a random macroId at paste to avoid collision
       */ if ((_node$attrs$parameter = node.attrs.parameters) !== null && _node$attrs$parameter !== void 0 && (_node$attrs$parameter = _node$attrs$parameter.macroMetadata) !== null && _node$attrs$parameter !== void 0 && (_node$attrs$parameter = _node$attrs$parameter.macroId) !== null && _node$attrs$parameter !== void 0 && _node$attrs$parameter.value) node.attrs.parameters.macroMetadata.macroId.value = (0, $9RSBE.uuid).generate();
        }
        return node;
    });
    // If the first/last child has changed - then we know we've removed MBE and extensionFrame and need to decrement the open depth
    return new (0, $kW8qW.Slice)(fragment, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    fragment.firstChild && fragment.firstChild.type !== slice.content.firstChild.type ? slice.openStart - depthToReduce : slice.openStart, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    fragment.lastChild && fragment.lastChild.type !== slice.content.lastChild.type ? slice.openEnd - depthToReduce : slice.openEnd);
};
const $2d17d7d320253e6a$var$LEGACY_CONTENT_MACRO_EXTENSION_TYPE = 'com.atlassian.confluence.migration', $2d17d7d320253e6a$var$LEGACY_CONTENT_MACRO_EXTENSION_KEY = 'legacy-content';
const $2d17d7d320253e6a$var$isLegacyContentMacroExtension = (extensionNode)=>{
    var _extensionNode$attrs, _extensionNode$attrs2;
    return ((_extensionNode$attrs = extensionNode.attrs) === null || _extensionNode$attrs === void 0 ? void 0 : _extensionNode$attrs.extensionType) === $2d17d7d320253e6a$var$LEGACY_CONTENT_MACRO_EXTENSION_TYPE && ((_extensionNode$attrs2 = extensionNode.attrs) === null || _extensionNode$attrs2 === void 0 ? void 0 : _extensionNode$attrs2.extensionKey) === $2d17d7d320253e6a$var$LEGACY_CONTENT_MACRO_EXTENSION_KEY;
};
const $2d17d7d320253e6a$export$23ce34395aea8526 = (slice, schema)=>{
    const { extension: extension } = schema.nodes;
    return (0, $4ClnP.mapSlice)(slice, (node)=>{
        if (node.type === extension && $2d17d7d320253e6a$var$isLegacyContentMacroExtension(node)) // Strip the node
        return null;
        return node;
    });
};

});

parcelRegister("eOIiR", function(module, exports) {
$parcel$export(module.exports, "ToolbarKeyboardNavigationProvider", () => $982639223a05cbd2$export$881345eb2554ea9e);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $c9wRy = parcelRequire("c9wRy");
const $982639223a05cbd2$export$881345eb2554ea9e = ({ children: children, childComponentSelector: childComponentSelector, dom: dom, isShortcutToFocusToolbar: isShortcutToFocusToolbar, handleFocus: handleFocus, handleEscape: handleEscape, ariaLabel: ariaLabel, ariaControls: ariaControls })=>{
    const wrapperRef = (0, $bSJIT.useRef)(null);
    (0, $bSJIT.useLayoutEffect)(()=>{
        if (!wrapperRef.current) return;
        const { current: element } = wrapperRef;
        const getFocusableElements = ()=>{
            if (!element) return [];
            // Find all focusable elements within the toolbar that match the child component selector
            const focusableSelectors = [
                'button:not([disabled])',
                '[role="button"]:not([disabled])',
                '[tabindex]:not([tabindex="-1"])'
            ].join(',');
            const allFocusable = Array.from(element.querySelectorAll(focusableSelectors));
            // Filter to only include elements that are:
            // 1. Within the child component selector
            // 2. Visible (not hidden by display:none on itself or any parent)
            return allFocusable.filter((el)=>{
                // Independent containers own their key handling and tab stops.
                if (el.closest('[data-keyboard-navigation-independent]')) return false;
                if (!el.closest(`${childComponentSelector}`)) return false;
                // Check if the element or any of its parents have display: none
                let currentEl = el;
                while(currentEl && currentEl !== element){
                    const computedStyle = window.getComputedStyle(currentEl);
                    if (computedStyle.display === 'none' || computedStyle.visibility === 'hidden') return false;
                    currentEl = currentEl.parentElement;
                }
                return true;
            });
        };
        const moveFocus = (direction)=>{
            var _focusableElements$ne;
            const focusableElements = getFocusableElements();
            if (focusableElements.length === 0) return;
            const doc = (0, $c9wRy.getDocument)();
            const currentIndex = focusableElements.findIndex((el)=>el === (doc === null || doc === void 0 ? void 0 : doc.activeElement));
            let nextIndex;
            if (currentIndex === -1) // No element currently focused, focus the first one
            nextIndex = 0;
            else if (direction === 'right') // Move right, wrap to beginning if at end
            nextIndex = (currentIndex + 1) % focusableElements.length;
            else // Move left, wrap to end if at beginning
            nextIndex = currentIndex === 0 ? focusableElements.length - 1 : currentIndex - 1;
            (_focusableElements$ne = focusableElements[nextIndex]) === null || _focusableElements$ne === void 0 || _focusableElements$ne.focus();
        };
        const handleTab = ()=>{
            const focusableElements = getFocusableElements();
            if (focusableElements.length === 0) return;
            const doc = (0, $c9wRy.getDocument)();
            let index = doc !== null && doc !== void 0 && doc.activeElement ? focusableElements.findIndex((el)=>el === (doc === null || doc === void 0 ? void 0 : doc.activeElement)) : 0;
            if (index < 0) index = 0;
            focusableElements.forEach((el)=>el.setAttribute('tabindex', '-1'));
            focusableElements[index].setAttribute('tabindex', '0');
        };
        const handleKeyDown = (event)=>{
            const targetElement = event.target;
            if (targetElement instanceof HTMLElement && !targetElement.closest(`${childComponentSelector}`)) return;
            if (targetElement instanceof HTMLElement && targetElement.closest('[data-keyboard-navigation-independent]')) return;
            switch(event.key){
                case 'Escape':
                    handleEscape(event);
                    break;
                case 'ArrowLeft':
                    event.preventDefault();
                    moveFocus('left');
                    break;
                case 'ArrowRight':
                    event.preventDefault();
                    moveFocus('right');
                    break;
                case 'Tab':
                    handleTab();
                    break;
                default:
            }
        };
        const globalKeyDownHandler = (event)=>{
            if (isShortcutToFocusToolbar && isShortcutToFocusToolbar(event)) handleFocus(event);
        };
        // ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element === null || element === void 0 || element.addEventListener('keydown', handleKeyDown);
        // ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        dom === null || dom === void 0 || dom.addEventListener('keydown', globalKeyDownHandler);
        return ()=>{
            // ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element === null || element === void 0 || element.removeEventListener('keydown', handleKeyDown);
            // ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            dom === null || dom === void 0 || dom.removeEventListener('keydown', globalKeyDownHandler);
        };
    }, [
        wrapperRef,
        childComponentSelector,
        dom,
        isShortcutToFocusToolbar,
        handleFocus,
        handleEscape
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- ignored via go/DSP-18766
        className: "custom-key-handler-wrapper",
        ref: wrapperRef,
        role: "toolbar",
        "aria-label": ariaLabel,
        "aria-controls": ariaControls,
        children: children
    });
};

});

parcelRegister("kYtKJ", function(module, exports) {
$parcel$export(module.exports, "createBlockTaskItem", () => $6afe559683060359$export$d295c32f32566012);
const $6afe559683060359$export$d295c32f32566012 = ({ attrs: attrs, content: content, marks: marks, schema: schema })=>{
    const { blockTaskItem: blockTaskItem, paragraph: paragraph } = schema.nodes;
    const newParagraph = paragraph.createChecked(null, content, marks === null || marks === void 0 ? void 0 : marks.filter((mark)=>blockTaskItem.allowsMarkType(mark.type)));
    return blockTaskItem.create(attrs ?? null, newParagraph);
};

});

parcelRegister("aRfwQ", function(module, exports) {
$parcel$export(module.exports, "textColorPlugin", () => $f9f058abaf1d74c0$export$7658bf1f1b6f477d);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $3e3xK = parcelRequire("3e3xK");

var $797yE = parcelRequire("797yE");

var $j1Cfq = parcelRequire("j1Cfq");

var $3gKTm = parcelRequire("3gKTm");

var $45Vwj = parcelRequire("45Vwj");

var $8nR2b = parcelRequire("8nR2b");

var $jjryD = parcelRequire("jjryD");

var $5RTMs = parcelRequire("5RTMs");

var $cwZBO = parcelRequire("cwZBO");

var $8EdF9 = parcelRequire("8EdF9");
const $f9f058abaf1d74c0$var$pluginConfig = (textColorConfig)=>{
    if (!textColorConfig || typeof textColorConfig === 'boolean') return undefined;
    return textColorConfig;
};
const $f9f058abaf1d74c0$var$isToolbarComponentEnabled = (textColorConfig)=>{
    return textColorConfig === undefined || textColorConfig.toolbarConfig === undefined || textColorConfig.toolbarConfig.enabled !== false;
};
const $f9f058abaf1d74c0$export$7658bf1f1b6f477d = ({ config: textColorConfig, api: api })=>{
    const isToolbarAIFCEnabled = Boolean(api === null || api === void 0 ? void 0 : api.toolbar);
    const primaryToolbarComponent = ({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isToolbarReducedSpacing: isToolbarReducedSpacing, dispatchAnalyticsEvent: dispatchAnalyticsEvent, disabled: disabled })=>{
        if (!editorView) return null;
        return /*#__PURE__*/ (0, $dc70d.jsx)((0, $cwZBO.PrimaryToolbarComponent), {
            isReducedSpacing: isToolbarReducedSpacing,
            editorView: editorView,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
            disabled: disabled,
            api: api
        });
    };
    if (isToolbarAIFCEnabled) {
        var _api$toolbar;
        if (api !== null && api !== void 0 && (_api$toolbar = api.toolbar) !== null && _api$toolbar !== void 0 && _api$toolbar.actions.registerComponents && $f9f058abaf1d74c0$var$isToolbarComponentEnabled($f9f058abaf1d74c0$var$pluginConfig(textColorConfig))) api.toolbar.actions.registerComponents((0, $8EdF9.getToolbarComponents)(api));
    } else {
        var _api$primaryToolbar;
        api === null || api === void 0 || (_api$primaryToolbar = api.primaryToolbar) === null || _api$primaryToolbar === void 0 || _api$primaryToolbar.actions.registerComponent({
            name: 'textColor',
            component: primaryToolbarComponent
        });
    }
    return {
        name: 'textColor',
        marks () {
            return [
                {
                    name: 'textColor',
                    mark: (0, $3e3xK.textColor)
                }
            ];
        },
        pmPlugins () {
            return isToolbarAIFCEnabled ? [
                {
                    name: 'textColor',
                    plugin: ({ dispatch: dispatch })=>(0, $jjryD.createPlugin)(dispatch, $f9f058abaf1d74c0$var$pluginConfig(textColorConfig))
                },
                {
                    name: 'textColorKeymap',
                    plugin: ()=>(0, $8nR2b.keymapPlugin)({
                            api: api
                        })
                }
            ] : [
                {
                    name: 'textColor',
                    plugin: ({ dispatch: dispatch })=>(0, $jjryD.createPlugin)(dispatch, $f9f058abaf1d74c0$var$pluginConfig(textColorConfig))
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            return (0, $jjryD.pluginKey).getState(editorState);
        },
        actions: {
            changeColor: (color, inputMethod)=>{
                var _api$analytics;
                return (0, $45Vwj.changeColor)(color, api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions, inputMethod);
            }
        },
        commands: {
            changeColor: (color, inputMethod)=>{
                return (0, $j1Cfq.changeColor)(color, api, inputMethod);
            },
            setPalette: (isPaletteOpen)=>{
                return (0, $3gKTm.setPalette)(isPaletteOpen);
            }
        },
        pluginsOptions: !isToolbarAIFCEnabled ? {
            selectionToolbar: ()=>{
                var _api$userPreferences;
                const toolbarDocking = api === null || api === void 0 || (_api$userPreferences = api.userPreferences) === null || _api$userPreferences === void 0 || (_api$userPreferences = _api$userPreferences.sharedState) === null || _api$userPreferences === void 0 || (_api$userPreferences = _api$userPreferences.currentState()) === null || _api$userPreferences === void 0 ? void 0 : _api$userPreferences.preferences.toolbarDockingPosition;
                if (toolbarDocking === 'none' && (0, $797yE.editorExperiment)('platform_editor_controls', 'variant1', {
                    exposure: true
                })) {
                    const toolbarCustom = {
                        type: 'custom',
                        render: (view, _idx, dispatchAnalyticsEvent)=>{
                            if (!view) return;
                            return /*#__PURE__*/ (0, $dc70d.jsx)((0, $5RTMs.FloatingToolbarComponent), {
                                editorView: view,
                                dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                                api: api
                            });
                        },
                        fallback: []
                    };
                    return {
                        isToolbarAbove: true,
                        items: [
                            toolbarCustom
                        ],
                        rank: 6,
                        pluginName: 'textColor'
                    };
                } else return undefined;
            }
        } : {},
        primaryToolbarComponent: !(api !== null && api !== void 0 && api.primaryToolbar) ? primaryToolbarComponent : undefined
    };
};

});
parcelRegister("j1Cfq", function(module, exports) {
$parcel$export(module.exports, "changeColor", () => $23bdc07fa6ba8101$export$917538e4f4eb20f9);

var $g6Qq4 = parcelRequire("g6Qq4");

var $gnlVA = parcelRequire("gnlVA");

var $guQFl = parcelRequire("guQFl");

var $fJlve = parcelRequire("fJlve");

var $hFmwg = parcelRequire("hFmwg");

var $jDumH = parcelRequire("jDumH");
const $23bdc07fa6ba8101$var$maybeSyncSelectionAfterFormat = (tr)=>{
    if (tr.docChanged) tr.setMeta((0, $guQFl.FORMAT_SELECTION_SYNC_META), true);
};
/**
 * Helper to create an analytics payload
 * @param newColor  - Color to be change in hex code
 * @param previousColor - Active color in hex code
 * @param palette - Current palette of colors
 * @returns Higher order command with analytics logic inside.
 */ function $23bdc07fa6ba8101$var$createColorAnalyticsPayload(newColor, previousColor, palette, inputMethod, hadMarkAttributes = {}) {
    const newColorFromPalette = palette.find(({ value: value })=>value === newColor);
    const previousColorFromPalette = palette.find(({ value: value })=>value === previousColor);
    const newColorLabel = newColorFromPalette ? newColorFromPalette.label : newColor;
    const previousColorLabel = previousColorFromPalette ? previousColorFromPalette.label : previousColor || '';
    return {
        action: (0, $g6Qq4.ACTION).FORMATTED,
        actionSubject: (0, $g6Qq4.ACTION_SUBJECT).TEXT,
        actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).FORMAT_COLOR,
        eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
        attributes: {
            newColor: newColorLabel.toLowerCase(),
            previousColor: previousColorLabel.toLowerCase(),
            inputMethod: inputMethod,
            ...hadMarkAttributes
        }
    };
}
const $23bdc07fa6ba8101$export$917538e4f4eb20f9 = (color, api, inputMethod)=>({ tr: tr })=>{
        var _api$analytics2;
        const { textColor: textColor, backgroundColor: backgroundColor } = tr.doc.type.schema.marks;
        const pluginState = api === null || api === void 0 ? void 0 : api.textColor.sharedState.currentState();
        if (!textColor || !pluginState) return tr;
        const activeColor = (0, $fJlve.getActiveColorNew)(tr);
        const isRemovingColor = color === pluginState.defaultColor;
        const hadMarkAttributes = isRemovingColor ? {} : (0, $gnlVA.getHadMarkAttributes)(tr, [
            backgroundColor
        ]);
        const colorAnalyticsPayload = $23bdc07fa6ba8101$var$createColorAnalyticsPayload(color, activeColor, pluginState.palette, inputMethod, hadMarkAttributes);
        if (pluginState.disabled) return tr;
        if (isRemovingColor) {
            var _api$analytics;
            api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 || _api$analytics.actions.attachAnalyticsEvent(colorAnalyticsPayload)(tr);
            (0, $hFmwg.removeColor)({
                tr: tr
            });
            $23bdc07fa6ba8101$var$maybeSyncSelectionAfterFormat(tr);
            return tr;
        }
        api === null || api === void 0 || (_api$analytics2 = api.analytics) === null || _api$analytics2 === void 0 || _api$analytics2.actions.attachAnalyticsEvent(colorAnalyticsPayload)(tr);
        (0, $jDumH.toggleColor)(color)({
            tr: tr
        });
        $23bdc07fa6ba8101$var$maybeSyncSelectionAfterFormat(tr);
        return tr;
    };

});
parcelRegister("fJlve", function(module, exports) {
$parcel$export(module.exports, "getActiveColor", () => $922bd5115d9330b6$export$1c6fa8f53a5fb47f);
$parcel$export(module.exports, "getActiveColorNew", () => $922bd5115d9330b6$export$9ed72cbbcfbf2a15);

var $bOo38 = parcelRequire("bOo38");
const $922bd5115d9330b6$export$1c6fa8f53a5fb47f = (state)=>{
    const { $from: $from, $to: $to, $cursor: $cursor } = state.selection;
    const { textColor: textColor } = state.schema.marks;
    // Filter out other marks
    let marks = [];
    if ($cursor) marks.push(textColor.isInSet(state.storedMarks || $cursor.marks()) || undefined);
    else state.doc.nodesBetween($from.pos, $to.pos, (currentNode)=>{
        if (currentNode.isLeaf) {
            const mark = textColor.isInSet(currentNode.marks) || undefined;
            marks.push(mark);
            return !mark;
        }
        return true;
    });
    // Merge consecutive same color marks
    let prevMark;
    marks = marks.filter((mark)=>{
        if (mark && prevMark && mark.attrs.color === prevMark.attrs.color) return false;
        prevMark = mark;
        return true;
    });
    const marksWithColor = marks.filter((mark)=>!!mark);
    // When multiple colors are selected revert back to default color
    if (marksWithColor.length > 1 || marksWithColor.length === 1 && marks.length > 1) return null;
    return marksWithColor.length ? marksWithColor[0].attrs.color : (0, $bOo38.DEFAULT_COLOR).color;
};
const $922bd5115d9330b6$export$9ed72cbbcfbf2a15 = (tr)=>{
    const { $from: $from, $to: $to, $cursor: $cursor } = tr.selection;
    const { textColor: textColor } = tr.doc.type.schema.marks;
    // Filter out other marks
    let marks = [];
    if ($cursor) marks.push(textColor.isInSet(tr.storedMarks || $cursor.marks()) || undefined);
    else tr.doc.nodesBetween($from.pos, $to.pos, (currentNode)=>{
        if (currentNode.isLeaf) {
            const mark = textColor.isInSet(currentNode.marks) || undefined;
            marks.push(mark);
            return !mark;
        }
        return true;
    });
    // Merge consecutive same color marks
    let prevMark;
    marks = marks.filter((mark)=>{
        if (mark && prevMark && mark.attrs.color === prevMark.attrs.color) return false;
        prevMark = mark;
        return true;
    });
    const marksWithColor = marks.filter((mark)=>!!mark);
    // When multiple colors are selected revert back to default color
    if (marksWithColor.length > 1 || marksWithColor.length === 1 && marks.length > 1) return null;
    return marksWithColor.length ? marksWithColor[0].attrs.color : (0, $bOo38.DEFAULT_COLOR).color;
};

});
parcelRegister("bOo38", function(module, exports) {
$parcel$export(module.exports, "overrideMarks", () => $a878a93ef512bdab$export$ccbc17c7832f26ef);
$parcel$export(module.exports, "ACCESSIBLE_CONTRAST_RATIO", () => $a878a93ef512bdab$export$fc59e1ed5414eef9);
$parcel$export(module.exports, "DIFFICULT_CONTRAST_RATIO", () => $a878a93ef512bdab$export$423a5169d8af406a);
$parcel$export(module.exports, "DEFAULT_BACKGROUND_COLOR", () => $a878a93ef512bdab$export$617cdcc6afaae4f7);
$parcel$export(module.exports, "DEFAULT_COLOR", () => $a878a93ef512bdab$export$37394b0fa44b998c);
const $a878a93ef512bdab$export$ccbc17c7832f26ef = [
    'backgroundColor'
];
const $a878a93ef512bdab$export$fc59e1ed5414eef9 = 4.5;
const $a878a93ef512bdab$export$423a5169d8af406a = 3;
const $a878a93ef512bdab$export$617cdcc6afaae4f7 = '#FFFFFF';
const $a878a93ef512bdab$export$3bfbdac4444b01ff = '#00000000';
const $a878a93ef512bdab$export$37394b0fa44b998c = {
    // TODO: DSP-4137 - Remove usage of hardcoded color
    /* eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage */ color: '#172b4d',
    label: 'Dark gray'
};

});


parcelRegister("hFmwg", function(module, exports) {
$parcel$export(module.exports, "removeColor", () => $d64c9d47489ee15c$export$4a26621adcb675d6);

var $auga3 = parcelRequire("auga3");

var $jjryD = parcelRequire("jjryD");
const $d64c9d47489ee15c$export$4a26621adcb675d6 = ({ tr: tr })=>{
    const { textColor: textColor } = tr.doc.type.schema.marks;
    (0, $auga3.removeMark)(textColor)({
        tr: tr
    });
    tr.setMeta((0, $jjryD.pluginKey), {
        action: (0, $jjryD.ACTIONS).RESET_COLOR
    });
    return tr;
};

});
parcelRegister("jjryD", function(module, exports) {
$parcel$export(module.exports, "ACTIONS", () => $8d4df5ad3bd12db1$export$92a1a3b7554e9387);
$parcel$export(module.exports, "pluginKey", () => $8d4df5ad3bd12db1$export$18d4026d1ea86bb1);
$parcel$export(module.exports, "createPlugin", () => $8d4df5ad3bd12db1$export$ae829ec7b2625219);

var $f7Kk4 = parcelRequire("f7Kk4");

var $dFqiE = parcelRequire("dFqiE");

var $evw0j = parcelRequire("evw0j");

var $cw0wu = parcelRequire("cw0wu");

var $4zjoa = parcelRequire("4zjoa");

var $fJlve = parcelRequire("fJlve");

var $bOo38 = parcelRequire("bOo38");

var $2skiO = parcelRequire("2skiO");
function $8d4df5ad3bd12db1$var$createInitialPluginState(editorState, pluginConfig) {
    const defaultColor = (pluginConfig === null || pluginConfig === void 0 ? void 0 : pluginConfig.defaultColor) || (0, $bOo38.DEFAULT_COLOR);
    const paletteColors = (0, $4zjoa.expValEqualsNoExposure)('platform_editor_lovability_text_bg_color', 'isEnabled', true) ? (0, $dFqiE.textColorPaletteNew) : (0, $evw0j.textColorPalette);
    const palette = [
        {
            value: defaultColor.color,
            label: defaultColor.label,
            border: "var(--ds-border, #0B120E24)"
        },
        ...paletteColors
    ];
    const color = (0, $fJlve.getActiveColor)(editorState);
    const state = {
        color: color,
        disabled: (0, $2skiO.getDisabledState)(editorState),
        palette: palette,
        defaultColor: defaultColor.color,
        isPaletteOpen: false
    };
    return state;
}
var $8d4df5ad3bd12db1$export$92a1a3b7554e9387 = /*#__PURE__*/ function(ACTIONS) {
    ACTIONS[ACTIONS["RESET_COLOR"] = 0] = "RESET_COLOR";
    ACTIONS[ACTIONS["SET_COLOR"] = 1] = "SET_COLOR";
    ACTIONS[ACTIONS["DISABLE"] = 2] = "DISABLE";
    ACTIONS[ACTIONS["SET_PALETTE"] = 3] = "SET_PALETTE";
    return ACTIONS;
}({});
const $8d4df5ad3bd12db1$export$18d4026d1ea86bb1 = new (0, $cw0wu.PluginKey)('textColorPlugin');
function $8d4df5ad3bd12db1$export$ae829ec7b2625219(dispatch, pluginConfig) {
    return new (0, $f7Kk4.SafePlugin)({
        key: $8d4df5ad3bd12db1$export$18d4026d1ea86bb1,
        state: {
            init (_config, editorState) {
                return $8d4df5ad3bd12db1$var$createInitialPluginState(editorState, pluginConfig);
            },
            apply (tr, pluginState, _, newState) {
                const meta = tr.getMeta($8d4df5ad3bd12db1$export$18d4026d1ea86bb1) || {};
                let nextState;
                switch(meta.action){
                    case 0:
                        nextState = {
                            ...pluginState,
                            color: pluginState.defaultColor
                        };
                        break;
                    case 1:
                        nextState = {
                            ...pluginState,
                            color: meta.color,
                            disabled: false,
                            isPaletteOpen: false
                        };
                        break;
                    case 2:
                        nextState = {
                            ...pluginState,
                            disabled: true
                        };
                        break;
                    case 3:
                        nextState = {
                            ...pluginState,
                            isPaletteOpen: meta.isPaletteOpen
                        };
                        break;
                    default:
                        const color = (0, $fJlve.getActiveColor)(newState);
                        nextState = {
                            ...pluginState,
                            color: color,
                            disabled: (0, $2skiO.getDisabledState)(newState)
                        };
                }
                if (pluginState && pluginState.color !== nextState.color || pluginState && pluginState.disabled !== nextState.disabled || pluginState && pluginState.isPaletteOpen !== nextState.isPaletteOpen) {
                    dispatch($8d4df5ad3bd12db1$export$18d4026d1ea86bb1, nextState);
                    return nextState;
                }
                return pluginState;
            }
        }
    });
}

});
parcelRegister("2skiO", function(module, exports) {
$parcel$export(module.exports, "getDisabledState", () => $2c34cff2c9643643$export$4af1020a67b5ec91);
$parcel$export(module.exports, "getDisabledStateNew", () => $2c34cff2c9643643$export$bc7d0019d5b59541);

var $foNZE = parcelRequire("foNZE");
var $5SRcn = parcelRequire("5SRcn");

var $bOo38 = parcelRequire("bOo38");
const $2c34cff2c9643643$var$hasLinkMark = ($pos)=>{
    const { doc: { type: { schema: { marks: { link: linkMarkType } } } }, pos: pos } = $pos;
    if (!linkMarkType) return false;
    return $pos.doc.rangeHasMark(pos, Math.min(pos + 1, $pos.doc.content.size), linkMarkType);
};
const $2c34cff2c9643643$export$4af1020a67b5ec91 = (state)=>{
    const { textColor: textColor } = state.schema.marks;
    if (textColor) {
        var _state$storedMarks;
        const { empty: empty, ranges: ranges, $cursor: $cursor } = state.selection;
        if (empty && !$cursor || $cursor && $2c34cff2c9643643$var$hasLinkMark($cursor) || (0, $foNZE.isMarkAllowedInRange)(state.doc, ranges, textColor) === false) return true;
        // Allow "excluded" marks that can be overridden
        // These marks are explicitly removed before applying the new mark (see toggleColor command)
        const omitOverrides = (mark)=>{
            return !(0, $bOo38.overrideMarks).includes(mark.type.name);
        };
        if ((0, $5SRcn.isMarkExcluded)(textColor, ((_state$storedMarks = state.storedMarks) === null || _state$storedMarks === void 0 ? void 0 : _state$storedMarks.filter(omitOverrides)) || $cursor && $cursor.marks().filter(omitOverrides))) return true;
        return false;
    }
    return true;
};
const $2c34cff2c9643643$export$bc7d0019d5b59541 = (tr)=>{
    const { textColor: textColor } = tr.doc.type.schema.marks;
    if (textColor) {
        var _tr$storedMarks;
        const { empty: empty, ranges: ranges, $cursor: $cursor } = tr.selection;
        if (empty && !$cursor || $cursor && $2c34cff2c9643643$var$hasLinkMark($cursor) || (0, $foNZE.isMarkAllowedInRange)(tr.doc, ranges, textColor) === false) return true;
        // Allow "excluded" marks that can be overridden
        // These marks are explicitly removed before applying the new mark (see toggleColor command)
        const omitOverrides = (mark)=>{
            return !(0, $bOo38.overrideMarks).includes(mark.type.name);
        };
        if ((0, $5SRcn.isMarkExcluded)(textColor, ((_tr$storedMarks = tr.storedMarks) === null || _tr$storedMarks === void 0 ? void 0 : _tr$storedMarks.filter(omitOverrides)) || $cursor && $cursor.marks().filter(omitOverrides))) return true;
        return false;
    }
    return true;
};

});
parcelRegister("foNZE", function(module, exports) {
$parcel$export(module.exports, "isMarkAllowedInRange", () => $1f1811aee07213f9$export$22a8bb98a26ef60);
const $1f1811aee07213f9$export$22a8bb98a26ef60 = (doc, ranges, type)=>{
    for(let i = 0; i < ranges.length; i++){
        const { $from: $from, $to: $to } = ranges[i];
        let can = $from.depth === 0 ? doc.type.allowsMarkType(type) : false;
        doc.nodesBetween($from.pos, $to.pos, (node)=>{
            if (can) return false;
            can = node.inlineContent && node.type.allowsMarkType(type);
            return;
        });
        if (can) return can;
    }
    return false;
};

});

parcelRegister("5SRcn", function(module, exports) {
$parcel$export(module.exports, "isMarkExcluded", () => $fd2284b4ceff7082$export$87b559fec4a10a1a);
const $fd2284b4ceff7082$export$87b559fec4a10a1a = (type, marks)=>{
    if (marks) return marks.some((mark)=>mark.type !== type && mark.type.excludes(type));
    return false;
};

});




parcelRegister("jDumH", function(module, exports) {
$parcel$export(module.exports, "toggleColor", () => $11d88734dd86ab15$export$afb561a73dff6672);

var $auga3 = parcelRequire("auga3");

var $fGjxM = parcelRequire("fGjxM");

var $5N1Y4 = parcelRequire("5N1Y4");

var $jjryD = parcelRequire("jjryD");

var $bOo38 = parcelRequire("bOo38");

var $2skiO = parcelRequire("2skiO");
const $11d88734dd86ab15$export$afb561a73dff6672 = (color)=>({ tr: tr })=>{
        const { textColor: textColor } = tr.doc.type.schema.marks;
        const disabledState = (0, $2skiO.getDisabledStateNew)(tr);
        if (disabledState) {
            tr.setMeta((0, $jjryD.pluginKey), {
                action: (0, $jjryD.ACTIONS).DISABLE
            });
            return tr;
        }
        if (!(0, $5N1Y4.expValEquals)('platform_editor_lovability_text_bg_color', 'isEnabled', true)) (0, $bOo38.overrideMarks).forEach((mark)=>{
            const { marks: marks } = tr.doc.type.schema;
            if (marks[mark]) (0, $auga3.removeMark)(marks[mark])({
                tr: tr
            });
        });
        (0, $fGjxM.toggleMark)(textColor, {
            color: color
        })({
            tr: tr
        });
        return tr;
    };

});


parcelRegister("3gKTm", function(module, exports) {
$parcel$export(module.exports, "togglePalette", () => $49ad8dd049609f6f$export$7c9cf3bdfeac3246);
$parcel$export(module.exports, "setPalette", () => $49ad8dd049609f6f$export$9567774ece486a9);

var $jjryD = parcelRequire("jjryD");
const $49ad8dd049609f6f$export$7c9cf3bdfeac3246 = (api)=>({ tr: tr })=>{
        const pluginState = api === null || api === void 0 ? void 0 : api.textColor.sharedState.currentState();
        const isPaletteOpen = pluginState === null || pluginState === void 0 ? void 0 : pluginState.isPaletteOpen;
        tr.setMeta((0, $jjryD.pluginKey), {
            action: (0, $jjryD.ACTIONS).SET_PALETTE,
            isPaletteOpen: !isPaletteOpen
        });
        return tr;
    };
const $49ad8dd049609f6f$export$9567774ece486a9 = (isPaletteOpen)=>({ tr: tr })=>{
        tr.setMeta((0, $jjryD.pluginKey), {
            action: (0, $jjryD.ACTIONS).SET_PALETTE,
            isPaletteOpen: isPaletteOpen
        });
        return tr;
    };

});

parcelRegister("45Vwj", function(module, exports) {
$parcel$export(module.exports, "changeColor", () => $0fb60c1655287650$export$917538e4f4eb20f9);

var $g6Qq4 = parcelRequire("g6Qq4");

var $gnlVA = parcelRequire("gnlVA");

var $5NaaJ = parcelRequire("5NaaJ");

var $jjryD = parcelRequire("jjryD");

var $fJlve = parcelRequire("fJlve");

var $93XAC = parcelRequire("93XAC");

var $686T7 = parcelRequire("686T7");
/**
 * Helper to create a higher order analytics command
 * @param newColor  - Color to be change in hex code
 * @param previousColor - Active color in hex code
 * @param palette - Current palette of colors
 * @return Higher order command with analytics logic inside.
 */ function $0fb60c1655287650$var$createWithColorAnalytics(newColor, previousColor, palette, editorAnalyticsApi, inputMethod, hadMarkAttributes = {}) {
    const newColorFromPalette = palette.find(({ value: value })=>value === newColor);
    const previousColorFromPalette = palette.find(({ value: value })=>value === previousColor);
    const newColorLabel = newColorFromPalette ? newColorFromPalette.label : newColor;
    const previousColorLabel = previousColorFromPalette ? previousColorFromPalette.label : previousColor || '';
    return (0, $5NaaJ.withAnalytics)(editorAnalyticsApi, {
        action: (0, $g6Qq4.ACTION).FORMATTED,
        actionSubject: (0, $g6Qq4.ACTION_SUBJECT).TEXT,
        actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).FORMAT_COLOR,
        eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
        attributes: {
            newColor: newColorLabel.toLowerCase(),
            previousColor: previousColorLabel.toLowerCase(),
            inputMethod: inputMethod,
            ...hadMarkAttributes
        }
    });
}
const $0fb60c1655287650$export$917538e4f4eb20f9 = (color, editorAnalyticsApi, inputMethod)=>(state, dispatch)=>{
        const { textColor: textColor, backgroundColor: backgroundColor } = state.schema.marks;
        if (textColor) {
            const pluginState = (0, $jjryD.pluginKey).getState(state);
            const activeColor = (0, $fJlve.getActiveColor)(state);
            const isRemovingColor = color === (pluginState === null || pluginState === void 0 ? void 0 : pluginState.defaultColor);
            const hadMarkAttributes = isRemovingColor ? {} : (0, $gnlVA.getHadMarkAttributes)(state.tr, [
                backgroundColor
            ]);
            const withColorAnalytics = $0fb60c1655287650$var$createWithColorAnalytics(color, activeColor, (pluginState === null || pluginState === void 0 ? void 0 : pluginState.palette) || [], editorAnalyticsApi, inputMethod, hadMarkAttributes);
            if (pluginState !== null && pluginState !== void 0 && pluginState.disabled) return false;
            if (isRemovingColor) {
                withColorAnalytics((0, $93XAC.removeColor)())(state, dispatch);
                return true;
            }
            withColorAnalytics((0, $686T7.toggleColor)(color))(state, dispatch);
            return true;
        }
        return false;
    };

});
parcelRegister("93XAC", function(module, exports) {
$parcel$export(module.exports, "removeColor", () => $e6c01c8dd9667cce$export$4a26621adcb675d6);

var $auga3 = parcelRequire("auga3");

var $guQFl = parcelRequire("guQFl");

var $jjryD = parcelRequire("jjryD");
const $e6c01c8dd9667cce$export$4a26621adcb675d6 = ()=>(state, dispatch)=>{
        const { schema: schema } = state;
        const { textColor: textColor } = schema.marks;
        const tr = state.tr;
        (0, $auga3.removeMark)(textColor)({
            tr: tr
        });
        if (dispatch) {
            if (tr.docChanged) tr.setMeta((0, $guQFl.FORMAT_SELECTION_SYNC_META), true);
            dispatch(tr.setMeta((0, $jjryD.pluginKey), {
                action: (0, $jjryD.ACTIONS).RESET_COLOR
            }));
        }
        return true;
    };

});

parcelRegister("686T7", function(module, exports) {
$parcel$export(module.exports, "toggleColor", () => $97b85a0b66ce2ff9$export$afb561a73dff6672);

var $auga3 = parcelRequire("auga3");

var $fGjxM = parcelRequire("fGjxM");

var $guQFl = parcelRequire("guQFl");

var $5N1Y4 = parcelRequire("5N1Y4");

var $jjryD = parcelRequire("jjryD");

var $bOo38 = parcelRequire("bOo38");

var $2skiO = parcelRequire("2skiO");
const $97b85a0b66ce2ff9$export$afb561a73dff6672 = (color)=>(state, dispatch)=>{
        const { textColor: textColor } = state.schema.marks;
        const tr = state.tr;
        const disabledState = (0, $2skiO.getDisabledState)(state);
        if (disabledState) {
            if (dispatch) dispatch(tr.setMeta((0, $jjryD.pluginKey), {
                action: (0, $jjryD.ACTIONS).DISABLE
            }));
            return false;
        }
        if (dispatch) {
            if (!(0, $5N1Y4.expValEquals)('platform_editor_lovability_text_bg_color', 'isEnabled', true)) (0, $bOo38.overrideMarks).forEach((mark)=>{
                const { marks: marks } = tr.doc.type.schema;
                if (marks[mark]) (0, $auga3.removeMark)(marks[mark])({
                    tr: tr
                });
            });
            (0, $fGjxM.toggleMark)(textColor, {
                color: color
            })({
                tr: tr
            });
            if (tr.docChanged) tr.setMeta((0, $guQFl.FORMAT_SELECTION_SYNC_META), true);
            dispatch(tr);
        }
        return true;
    };

});


parcelRegister("8nR2b", function(module, exports) {
$parcel$export(module.exports, "keymapPlugin", () => $ed9e6af43eeb28aa$export$e832373cff8dec22);

var $bdXbU = parcelRequire("bdXbU");

var $cv8id = parcelRequire("cv8id");

var $3gKTm = parcelRequire("3gKTm");
function $ed9e6af43eeb28aa$export$e832373cff8dec22({ api: api }) {
    const list = {};
    if ((0, $cv8id.toggleHighlightPalette).common) (0, $cv8id.bindKeymapWithEditorCommand)((0, $cv8id.toggleHighlightPalette).common, (0, $3gKTm.togglePalette)(api), list);
    return (0, $bdXbU.keymap)(list);
}

});

parcelRegister("5RTMs", function(module, exports) {
$parcel$export(module.exports, "FloatingToolbarComponent", () => $5f988bfe9d1d0518$export$b15abb95157a91c7);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $5beht = parcelRequire("5beht");

var $dYYXR = parcelRequire("dYYXR");

var $eVmQb = parcelRequire("eVmQb");
const $5f988bfe9d1d0518$var$FloatingToolbarSettings = {
    disabled: false,
    isReducedSpacing: true
};
const $5f988bfe9d1d0518$var$selector = (states)=>{
    var _states$textColorStat, _states$textColorStat2, _states$textColorStat3, _states$textColorStat4;
    return {
        color: (_states$textColorStat = states.textColorState) === null || _states$textColorStat === void 0 ? void 0 : _states$textColorStat.color,
        defaultColor: (_states$textColorStat2 = states.textColorState) === null || _states$textColorStat2 === void 0 ? void 0 : _states$textColorStat2.defaultColor,
        palette: (_states$textColorStat3 = states.textColorState) === null || _states$textColorStat3 === void 0 ? void 0 : _states$textColorStat3.palette,
        disabled: (_states$textColorStat4 = states.textColorState) === null || _states$textColorStat4 === void 0 ? void 0 : _states$textColorStat4.disabled
    };
};
const $5f988bfe9d1d0518$export$b15abb95157a91c7 = ({ api: api, editorView: editorView, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
    const { color: color, defaultColor: defaultColor, palette: palette, disabled: disabled } = (0, $5beht.useSharedPluginStateWithSelector)(api, [
        'textColor'
    ], $5f988bfe9d1d0518$var$selector);
    if (color === undefined || defaultColor === undefined || palette === undefined) return null;
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $eVmQb.default), {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        pluginState: {
            color: color,
            defaultColor: defaultColor,
            palette: palette,
            disabled: disabled
        },
        isReducedSpacing: $5f988bfe9d1d0518$var$FloatingToolbarSettings.isReducedSpacing,
        editorView: editorView,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        disabled: $5f988bfe9d1d0518$var$FloatingToolbarSettings.disabled,
        pluginInjectionApi: api,
        toolbarType: (0, $dYYXR.ToolbarType).FLOATING
    });
};

});
parcelRegister("dYYXR", function(module, exports) {
$parcel$export(module.exports, "ToolbarType", () => $aaedb2d1c9e1e731$export$a5d11b3163e4b1a5);
var $aaedb2d1c9e1e731$export$a5d11b3163e4b1a5 = /*#__PURE__*/ function(ToolbarType) {
    ToolbarType["PRIMARY"] = "primaryToolbar";
    ToolbarType["FLOATING"] = "floatingToolbar";
    return ToolbarType;
}({});

});

parcelRegister("eVmQb", function(module, exports) {
$parcel$export(module.exports, "default", () => $d3bd4f2d593dfef3$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $fK3tS = parcelRequire("fK3tS");

var $g6Qq4 = parcelRequire("g6Qq4");

var $bnf0l = parcelRequire("bnf0l");

var $ilMHn = parcelRequire("ilMHn");

var $lOB48 = parcelRequire("lOB48");

var $kLBYz = parcelRequire("kLBYz");

var $g42cj = parcelRequire("g42cj");

var $5CXZA = parcelRequire("5CXZA");

var $epqkL = parcelRequire("epqkL");

var $czomm = parcelRequire("czomm");

var $imBU3 = parcelRequire("imBU3");

var $6bWVw = parcelRequire("6bWVw");

var $8zO6u = parcelRequire("8zO6u");

var $8FtCL = parcelRequire("8FtCL");

var $5bbjm = parcelRequire("5bbjm");

var $4GWyU = parcelRequire("4GWyU");

var $aBl4O = parcelRequire("aBl4O");

var $797yE = parcelRequire("797yE");

var $5N1Y4 = parcelRequire("5N1Y4");

var $45Vwj = parcelRequire("45Vwj");

var $1e48P = parcelRequire("1e48P");

var $dYYXR = parcelRequire("dYYXR");
function $d3bd4f2d593dfef3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d3bd4f2d593dfef3$var$addMarginToWrapper = {
    name: "we4ryv",
    styles: "margin-right:var(--ds-space-050, 4px)"
};
class $d3bd4f2d593dfef3$export$2985b35a9cfdee76 extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Component {
    render() {
        var _palette$find;
        const { isOpen: isOpen, isOpenedByKeyboard: isOpenedByKeyboard } = this.state;
        const { popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isReducedSpacing: isReducedSpacing, pluginState: pluginState, intl: { formatMessage: formatMessage }, disabled: disabled, pluginInjectionApi: pluginInjectionApi } = this.props;
        const palette = pluginState.palette;
        const isNewColorPaletteEnabled = (0, $5N1Y4.expValEquals)('platform_editor_lovability_text_bg_color', 'isEnabled', true);
        const colorPickerColumns = isNewColorPaletteEnabled ? 10 : undefined;
        let fitWidth;
        if (document.body.clientWidth <= 740) // This was originally hard-coded, but moved here to a const
        // My guess is it's based off (width of button * columns) + left/right padding
        // 7 cols: 240 = (32 * 7) + (8 + 8)
        // 10 cols: 338 = (32 * 10) + (8 + 8)
        // Not sure where the extra 2px comes from
        fitWidth = isNewColorPaletteEnabled ? 338 : 242;
        const selectedColor = this.getSelectedColor(pluginState);
        // TODO: ED-26959 - This doesn't work, the label isn't translated
        const selectedColorPaletteItemLabel = (_palette$find = palette.find((paletteItem)=>paletteItem.value === pluginState.color)) === null || _palette$find === void 0 ? void 0 : _palette$find.label;
        const selectedColorPaletteItemLabelText = selectedColorPaletteItemLabel || '';
        const labelTextColor = formatMessage((0, $lOB48.textColorMessages).textColor, {
            selectedColorName: selectedColorPaletteItemLabelText
        });
        const tooltipTextColor = formatMessage((0, $lOB48.textColorMessages).textColorTooltip);
        const { selectedRowIndex: selectedRowIndex, selectedColumnIndex: selectedColumnIndex } = (0, $czomm.getSelectedRowAndColumnFromPalette)(palette, pluginState.color, colorPickerColumns);
        const reducedSpacing = this.props.toolbarType === (0, $dYYXR.ToolbarType).FLOATING ? 'compact' : 'none';
        return /*#__PURE__*/ (0, $9dQre.jsx)("span", {
            css: [
                (0, $g42cj.wrapperStyle),
                $d3bd4f2d593dfef3$var$addMarginToWrapper
            ]
        }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $6bWVw.DropdownContainer), {
            mountTo: popupsMountPoint,
            boundariesElement: popupsBoundariesElement,
            scrollableElement: popupsScrollableElement,
            isOpen: isOpen && !pluginState.disabled,
            handleClickOutside: this.hide,
            handleEscapeKeydown: this.hideonEsc,
            zIndex: (0, $5bbjm.akEditorMenuZIndex),
            fitWidth: fitWidth,
            closeOnTab: true,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            arrowKeyNavigationProviderOptions: {
                type: (0, $imBU3.ArrowKeyNavigationType).COLOR,
                selectedRowIndex: selectedRowIndex,
                selectedColumnIndex: selectedColumnIndex,
                isOpenedByKeyboard: isOpenedByKeyboard,
                isPopupPositioned: true
            },
            trigger: /*#__PURE__*/ (0, $9dQre.jsx)((0, $8zO6u.default), {
                buttonId: (0, $bnf0l.TOOLBAR_ACTION_SUBJECT_ID).TEXT_COLOR,
                spacing: !isReducedSpacing || (0, $797yE.editorExperiment)('platform_editor_controls', 'variant1') ? 'default' : reducedSpacing,
                disabled: disabled || pluginState.disabled,
                selected: isOpen,
                "aria-label": labelTextColor,
                "aria-expanded": isOpen,
                "aria-haspopup": true,
                title: tooltipTextColor,
                onClick: this.toggleOpen,
                onKeyDown: this.onKeyDown,
                ref: this.toolbarItemRef,
                iconBefore: /*#__PURE__*/ (0, $9dQre.jsx)("div", {
                    css: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
                    (0, $g42cj.triggerWrapperStylesWithPadding)
                }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $ilMHn.DynamicStrokeIconDecoration), {
                    selectedColor: selectedColor,
                    disabled: pluginState.disabled,
                    icon: /*#__PURE__*/ (0, $9dQre.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aBl4O))), {
                        label: "",
                        color: "currentColor",
                        spacing: "spacious"
                    })
                }), //eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
                /*#__PURE__*/ (0, $9dQre.jsx)("span", {
                    css: (0, $kLBYz.expandIconContainerStyle)
                }, /*#__PURE__*/ (0, $9dQre.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4GWyU))), {
                    label: "",
                    color: "currentColor",
                    size: "small"
                })))
            })
        }, /*#__PURE__*/ (0, $9dQre.jsx)("div", {
            "data-testid": "text-color-palette"
        }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $5CXZA.default), {
            cols: colorPickerColumns,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onClick: (color)=>{
                var _pluginInjectionApi$a;
                return this.changeTextColor(color, pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$a = pluginInjectionApi.analytics) === null || _pluginInjectionApi$a === void 0 ? void 0 : _pluginInjectionApi$a.actions, pluginState.disabled);
            },
            selectedColor: pluginState.color,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            paletteOptions: {
                palette: palette,
                hexToPaletteColor: (0, $8FtCL.hexToEditorTextPaletteColor),
                paletteColorTooltipMessages: (0, $epqkL.textPaletteTooltipMessages)
            }
        }))), !(pluginInjectionApi !== null && pluginInjectionApi !== void 0 && pluginInjectionApi.primaryToolbar) && /* eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $9dQre.jsx)("span", {
            css: (0, $g42cj.separatorStyles)
        }));
    }
    getSelectedColor(pluginState) {
        const selectedColor = pluginState.color !== pluginState.defaultColor ? pluginState.color ? // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $8FtCL.hexToEditorTextPaletteColor)(pluginState.color) : pluginState.color : null;
        return selectedColor;
    }
    buildAnalyticsPalette(action, data) {
        return {
            action: action,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).TOOLBAR,
            actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).FORMAT_COLOR,
            eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
            attributes: {
                ...data
            }
        };
    }
    dispatchAnalyticsEvent(payload) {
        const { dispatchAnalyticsEvent: dispatchAnalyticsEvent } = this.props;
        if (dispatchAnalyticsEvent) dispatchAnalyticsEvent(payload);
    }
    constructor(...args){
        super(...args), this.state = {
            isOpen: false,
            isOpenedByKeyboard: false
        }, this.toolbarItemRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createRef(), this.changeColor = (color, editorAnalyticsApi)=>(0, $45Vwj.changeColor)(color, editorAnalyticsApi, (0, $1e48P.getInputMethod)(this.props.toolbarType))(this.props.editorView.state, this.props.editorView.dispatch), this.changeTextColor = (color, editorAnalyticsApi, disabled)=>{
            if (!disabled) {
                var _this$props$editorVie;
                this.handleOpenChange({
                    isOpen: false,
                    logCloseEvent: false
                });
                this.changeColor(color, editorAnalyticsApi);
                //To set the focus on the textcolor button when the menu is closed by 'Esc' only to meet aria guidelines
                (_this$props$editorVie = this.props.editorView) === null || _this$props$editorVie === void 0 || _this$props$editorVie.focus();
            }
            return false;
        }, this.toggleOpen = ()=>{
            this.handleOpenChange({
                isOpen: !this.state.isOpen,
                logCloseEvent: true
            });
        }, this.onKeyDown = (event)=>{
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                this.setState({
                    isOpenedByKeyboard: true
                });
                this.toggleOpen();
            }
        }, this.handleOpenChange = ({ isOpen: isOpen, logCloseEvent: logCloseEvent })=>{
            this.setState({
                isOpen: isOpen
            });
            if (!isOpen) this.setState({
                isOpenedByKeyboard: false
            });
            if (logCloseEvent) this.dispatchAnalyticsEvent(this.buildAnalyticsPalette(isOpen ? (0, $g6Qq4.ACTION).OPENED : (0, $g6Qq4.ACTION).CLOSED, {
                noSelect: isOpen === false
            }));
        }, this.hide = (e)=>{
            const { isOpen: isOpen } = this.state;
            if (isOpen === true) {
                this.dispatchAnalyticsEvent(this.buildAnalyticsPalette((0, $g6Qq4.ACTION).CLOSED, {
                    noSelect: true
                }));
                this.setState({
                    isOpen: false
                });
                if (e instanceof KeyboardEvent && e.key === 'Escape') {
                    var _this$toolbarItemRef;
                    (_this$toolbarItemRef = this.toolbarItemRef) === null || _this$toolbarItemRef === void 0 || (_this$toolbarItemRef = _this$toolbarItemRef.current) === null || _this$toolbarItemRef === void 0 || _this$toolbarItemRef.focus();
                }
            }
        }, this.hideonEsc = (e)=>{
            var _this$toolbarItemRef2;
            this.hide(e);
            (_this$toolbarItemRef2 = this.toolbarItemRef) === null || _this$toolbarItemRef2 === void 0 || (_this$toolbarItemRef2 = _this$toolbarItemRef2.current) === null || _this$toolbarItemRef2 === void 0 || _this$toolbarItemRef2.focus();
        };
    }
}
// eslint-disable-next-line @typescript-eslint/no-restricted-types
const $d3bd4f2d593dfef3$var$_default_1 = (0, $fK3tS.default)($d3bd4f2d593dfef3$export$2985b35a9cfdee76);
var $d3bd4f2d593dfef3$export$2e2bcd8739ae039 = $d3bd4f2d593dfef3$var$_default_1;

});
parcelRegister("ilMHn", function(module, exports) {
$parcel$export(module.exports, "DynamicStrokeIconDecoration", () => $ce62c2d8346a6ebd$export$76b0278e018f8601);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled, @typescript-eslint/consistent-type-imports -- Ignored via go/DSP-18766; jsx required at runtime for @jsxRuntime classic

var $9dQre = parcelRequire("9dQre");

var $gUpf2 = parcelRequire("gUpf2");

var $9BVpB = parcelRequire("9BVpB");
function $ce62c2d8346a6ebd$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ce62c2d8346a6ebd$var$barStyles = {
    name: "k9tay8",
    styles: "position:absolute;left:0;right:0;top:18px;margin:auto;width:var(--ds-space-200, 16px);height:3px"
};
const $ce62c2d8346a6ebd$var$textColorIconWrapper = (0, $9BVpB.xcss)({
    position: 'relative'
});
const $ce62c2d8346a6ebd$var$getBackground = (selectedColor, disabled)=>{
    if (selectedColor) return selectedColor;
    return disabled ? "var(--ds-icon-disabled, #080F214A)" : "var(--ds-icon, #292A2E)";
};
const $ce62c2d8346a6ebd$export$76b0278e018f8601 = ({ selectedColor: selectedColor, disabled: disabled, icon: icon })=>{
    return /*#__PURE__*/ (0, $9dQre.jsx)((0, $gUpf2.Box), {
        xcss: $ce62c2d8346a6ebd$var$textColorIconWrapper
    }, icon, /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        "data-testid": "toolbar-icon-dynamic-stroke",
        style: {
            background: $ce62c2d8346a6ebd$var$getBackground(selectedColor, disabled)
        },
        css: $ce62c2d8346a6ebd$var$barStyles
    }));
};

});

parcelRegister("lOB48", function(module, exports) {
$parcel$export(module.exports, "textColorMessages", () => $806101f6cb8b1592$export$effb4ee8b6f74abe);

var $f0Pt4 = parcelRequire("f0Pt4");
const $806101f6cb8b1592$export$effb4ee8b6f74abe = (0, $f0Pt4.defineMessages)({
    textColor: {
        id: 'fabric.editor.textColor',
        defaultMessage: '{selectedColorName} Text color',
        description: 'Label of menu that provides access to various colors of text. For example: green Text color, dark blue Text color'
    },
    textColorTooltip: {
        id: 'fabric.editor.textColorTooltip',
        defaultMessage: 'Text color',
        description: 'Toolip of menu that provides access to various colors of text.'
    },
    textColorHighlightTooltip: {
        id: 'fabric.editor.textColorHighlightTooltip',
        defaultMessage: 'Text and highlight color',
        description: 'Tooltip of menu that provides access to various colors of highlight.'
    }
});

});

parcelRegister("1e48P", function(module, exports) {
$parcel$export(module.exports, "getInputMethod", () => $aa036601826aa999$export$8213a6fbfa466e73);

var $g6Qq4 = parcelRequire("g6Qq4");

var $dYYXR = parcelRequire("dYYXR");
const $aa036601826aa999$var$toolbarTypeToInputMethod = {
    [(0, $dYYXR.ToolbarType).PRIMARY]: (0, $g6Qq4.INPUT_METHOD).TOOLBAR,
    [(0, $dYYXR.ToolbarType).FLOATING]: (0, $g6Qq4.INPUT_METHOD).FLOATING_TB
};
const $aa036601826aa999$export$8213a6fbfa466e73 = (toolbarType)=>$aa036601826aa999$var$toolbarTypeToInputMethod[toolbarType];

});



parcelRegister("cwZBO", function(module, exports) {
$parcel$export(module.exports, "PrimaryToolbarComponent", () => $5465a5c014681f7a$export$94516d5cccf573e3);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $5beht = parcelRequire("5beht");

var $dYYXR = parcelRequire("dYYXR");

var $eVmQb = parcelRequire("eVmQb");
const $5465a5c014681f7a$var$selector = (states)=>{
    var _states$textColorStat, _states$textColorStat2, _states$textColorStat3, _states$textColorStat4;
    return {
        color: (_states$textColorStat = states.textColorState) === null || _states$textColorStat === void 0 ? void 0 : _states$textColorStat.color,
        defaultColor: (_states$textColorStat2 = states.textColorState) === null || _states$textColorStat2 === void 0 ? void 0 : _states$textColorStat2.defaultColor,
        palette: (_states$textColorStat3 = states.textColorState) === null || _states$textColorStat3 === void 0 ? void 0 : _states$textColorStat3.palette,
        disabled: (_states$textColorStat4 = states.textColorState) === null || _states$textColorStat4 === void 0 ? void 0 : _states$textColorStat4.disabled
    };
};
const $5465a5c014681f7a$export$94516d5cccf573e3 = ({ api: api, isReducedSpacing: isReducedSpacing, editorView: editorView, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement, popupsBoundariesElement: popupsBoundariesElement, dispatchAnalyticsEvent: dispatchAnalyticsEvent, disabled: disabled })=>{
    const { color: color, defaultColor: defaultColor, palette: palette, disabled: textColorDisabled } = (0, $5beht.useSharedPluginStateWithSelector)(api, [
        'textColor'
    ], $5465a5c014681f7a$var$selector);
    if (color === undefined || defaultColor === undefined || palette === undefined) return null;
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $eVmQb.default), {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        pluginState: {
            color: color,
            defaultColor: defaultColor,
            palette: palette,
            disabled: textColorDisabled
        },
        isReducedSpacing: isReducedSpacing,
        editorView: editorView,
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        disabled: disabled,
        pluginInjectionApi: api,
        toolbarType: (0, $dYYXR.ToolbarType).PRIMARY
    });
};

});

parcelRegister("8EdF9", function(module, exports) {
$parcel$export(module.exports, "getToolbarComponents", () => $01ee983e1d6831c0$export$a758406ca53b86a5);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $4rzOL = parcelRequire("4rzOL");

var $fiku8 = parcelRequire("fiku8");

var $5N1Y4 = parcelRequire("5N1Y4");

var $hWHnc = parcelRequire("hWHnc");

var $eNBTs = parcelRequire("eNBTs");

var $8Uxnw = parcelRequire("8Uxnw");

var $7Sygw = parcelRequire("7Sygw");

var $jrQZX = parcelRequire("jrQZX");
const $01ee983e1d6831c0$export$a758406ca53b86a5 = (api)=>{
    return [
        {
            ...(0, $4rzOL.TEXT_COLOR_HIGHLIGHT_GROUP),
            parents: [
                {
                    ...(0, $4rzOL.TEXT_SECTION),
                    rank: (0, $fiku8.TEXT_SECTION_RANK)[(0, $4rzOL.TEXT_COLOR_HIGHLIGHT_GROUP).key]
                },
                {
                    type: (0, $4rzOL.TEXT_SECTION_PRIMARY_TOOLBAR).type,
                    key: (0, $4rzOL.TEXT_SECTION_PRIMARY_TOOLBAR).key,
                    rank: (0, $fiku8.TEXT_SECTION_PRIMARY_TOOLBAR_RANK)[(0, $4rzOL.TEXT_COLOR_HIGHLIGHT_GROUP).key]
                }
            ]
        },
        {
            ...(0, $4rzOL.TEXT_COLOR_HIGHLIGHT_MENU),
            parents: [
                {
                    ...(0, $4rzOL.TEXT_COLOR_HIGHLIGHT_GROUP),
                    rank: (0, $fiku8.TEXT_COLOR_HIGHLIGHT_GROUP_RANK)[(0, $4rzOL.TEXT_COLOR_HIGHLIGHT_MENU).key]
                }
            ],
            component: ({ children: children })=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $8Uxnw.TextColorHighlightMenu), {
                    api: api,
                    children: children
                })
        },
        {
            ...(0, $4rzOL.TEXT_COLOR_HIGHLIGHT_MENU_SECTION),
            parents: [
                {
                    ...(0, $4rzOL.TEXT_COLOR_HIGHLIGHT_MENU),
                    rank: (0, $fiku8.TEXT_COLOR_HIGHLIGHT_MENU_RANK)[(0, $4rzOL.TEXT_COLOR_HIGHLIGHT_MENU_SECTION).key]
                },
                {
                    type: (0, $4rzOL.TEXT_COLLAPSED_MENU).type,
                    key: (0, $4rzOL.TEXT_COLLAPSED_MENU).key,
                    rank: (0, $fiku8.TEXT_COLLAPSED_MENU_RANK)[(0, $4rzOL.TEXT_COLOR_HIGHLIGHT_MENU_SECTION).key]
                }
            ],
            component: (0, $jrQZX.TextMenuSection)
        },
        {
            ...(0, $4rzOL.TEXT_COLOR_MENU_ITEM),
            parents: [
                {
                    ...(0, $4rzOL.TEXT_COLOR_HIGHLIGHT_MENU_SECTION),
                    rank: (0, $fiku8.TEXT_COLOR_HIGHLIGHT_MENU_SECTION_RANK)[(0, $4rzOL.TEXT_COLOR_MENU_ITEM).key]
                }
            ],
            component: ({ parents: parents })=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $7Sygw.TextColorMenuItem), {
                    api: api,
                    parents: parents
                })
        },
        {
            ...(0, $4rzOL.CLEAR_COLOR_MENU_ITEM),
            parents: [
                {
                    ...(0, $4rzOL.TEXT_COLOR_HIGHLIGHT_MENU_SECTION),
                    rank: (0, $fiku8.TEXT_COLOR_HIGHLIGHT_MENU_SECTION_RANK)[(0, $4rzOL.CLEAR_COLOR_MENU_ITEM).key]
                }
            ],
            component: ({ parents: parents })=>{
                return /*#__PURE__*/ (0, $dc70d.jsx)((0, $eNBTs.RemoveColorMenuItem), {
                    api: api,
                    parents: parents
                });
            }
        },
        ...(0, $5N1Y4.expValEquals)('platform_editor_lovability_text_bg_color', 'isEnabled', true) ? [
            {
                ...(0, $4rzOL.COLOR_ACCESSIBILITY_MENU_ITEM),
                parents: [
                    {
                        ...(0, $4rzOL.TEXT_COLOR_HIGHLIGHT_MENU_SECTION),
                        rank: (0, $fiku8.TEXT_COLOR_HIGHLIGHT_MENU_SECTION_RANK)[(0, $4rzOL.COLOR_ACCESSIBILITY_MENU_ITEM).key]
                    }
                ],
                component: ()=>{
                    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $hWHnc.ColorAccessibilityMenuItem), {
                        api: api
                    });
                }
            }
        ] : []
    ];
};

});
parcelRegister("hWHnc", function(module, exports) {
$parcel$export(module.exports, "ColorAccessibilityMenuItem", () => $e5d8f9244f279d05$export$8e34e17dd957d56);
/* ColorAccessibilityMenuItem.tsx generated by @compiled/babel-plugin v3.0.2 */ /* ColorAccessibilityMenuItem.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $gAe8g = parcelRequire("gAe8g");

var $4TRbS = parcelRequire("4TRbS");

var $jDsoo = parcelRequire("jDsoo");

var $2gBYe = parcelRequire("2gBYe");

var $9uOZB = parcelRequire("9uOZB");

var $28qc1 = parcelRequire("28qc1");

var $e2JYe = parcelRequire("e2JYe");

var $czomm = parcelRequire("czomm");

var $5beht = parcelRequire("5beht");

var $e4OZJ = parcelRequire("e4OZJ");

var $8FtCL = parcelRequire("8FtCL");

var $jYZXg = parcelRequire("jYZXg");

var $cw0wu = parcelRequire("cw0wu");

var $a2cYt = parcelRequire("a2cYt");

var $1hEmZ = parcelRequire("1hEmZ");

var $9PwDt = parcelRequire("9PwDt");

var $fZ0ZI = parcelRequire("fZ0ZI");

var $8aT4G = parcelRequire("8aT4G");

var $g86TM = parcelRequire("g86TM");

var $iK2HI = parcelRequire("iK2HI");

var $bOo38 = parcelRequire("bOo38");
const $e5d8f9244f279d05$var$resolveColorValue = (color, fallback)=>{
    return (0, $czomm.getTokenCSSVariableValue)(color) || (color.startsWith('var(') ? fallback : color);
};
const $e5d8f9244f279d05$var$getForegroundColor = (textColor, defaultColor)=>{
    if (!textColor || defaultColor && textColor === defaultColor) return (0, $g86TM.getTokenValue)('color.text', defaultColor || (0, $bOo38.DEFAULT_COLOR).color);
    const colorValue = (0, $8FtCL.hexToEditorTextPaletteColor)(textColor) || textColor;
    return $e5d8f9244f279d05$var$resolveColorValue(colorValue, textColor);
};
const $e5d8f9244f279d05$var$getBackgroundColor = (backgroundColor, palette = 'text')=>{
    if (!backgroundColor || backgroundColor === 'none') return (0, $g86TM.getTokenValue)('elevation.surface', (0, $bOo38.DEFAULT_BACKGROUND_COLOR));
    const colorValue = palette === 'element' ? (0, $e4OZJ.hexToEditorBackgroundPaletteColor)(backgroundColor) || backgroundColor : (0, $jYZXg.hexToEditorTextBackgroundPaletteColor)(backgroundColor) || backgroundColor;
    return $e5d8f9244f279d05$var$resolveColorValue(colorValue, backgroundColor);
};
const $e5d8f9244f279d05$var$getBackgroundColorInNonActiveTheme = (backgroundColor, palette = 'text')=>{
    if (!backgroundColor || backgroundColor === 'none') return (0, $czomm.getTokenCSSVariableValueForNonActiveTheme)("var(--ds-surface, #FFFFFF)", (0, $bOo38.DEFAULT_BACKGROUND_COLOR));
    const colorValue = palette === 'element' ? (0, $e4OZJ.hexToEditorBackgroundPaletteColor)(backgroundColor) || backgroundColor : (0, $jYZXg.hexToEditorTextBackgroundPaletteColor)(backgroundColor) || backgroundColor;
    return (0, $czomm.getTokenCSSVariableValueForNonActiveTheme)(colorValue, backgroundColor);
};
const $e5d8f9244f279d05$var$STANDARD_PANEL_BACKGROUND_COLORS = new Map([
    [
        (0, $gAe8g.PanelType).INFO,
        (0, $9uOZB.getPanelTypeBackgroundNoTokens)((0, $gAe8g.PanelType).INFO)
    ],
    [
        (0, $gAe8g.PanelType).NOTE,
        (0, $9uOZB.getPanelTypeBackgroundNoTokens)((0, $gAe8g.PanelType).NOTE)
    ],
    [
        (0, $gAe8g.PanelType).SUCCESS,
        (0, $9uOZB.getPanelTypeBackgroundNoTokens)((0, $gAe8g.PanelType).SUCCESS)
    ],
    [
        (0, $gAe8g.PanelType).WARNING,
        (0, $9uOZB.getPanelTypeBackgroundNoTokens)((0, $gAe8g.PanelType).WARNING)
    ],
    [
        (0, $gAe8g.PanelType).ERROR,
        (0, $9uOZB.getPanelTypeBackgroundNoTokens)((0, $gAe8g.PanelType).ERROR)
    ]
]);
const $e5d8f9244f279d05$var$getResolvedBackgroundFromHighlight = (highlightColor)=>{
    if (!highlightColor) return {
        color: null,
        source: 'text'
    };
    return {
        color: highlightColor,
        source: 'text'
    };
};
/**
 * Resolves a background color from a container node that paints behind text.
 * Callers walk ancestors so the nearest painted container wins.
 */ const $e5d8f9244f279d05$var$getSupportedAncestorBackgroundColor = (node)=>{
    let backgroundColor;
    if (node.type.name === 'tableCell' || node.type.name === 'tableHeader') backgroundColor = node.attrs.background;
    else if (node.type.name === 'panel' || node.type.name === 'panel_c1') {
        if (node.attrs.panelType === (0, $gAe8g.PanelType).CUSTOM) backgroundColor = node.attrs.panelColor;
        else backgroundColor = $e5d8f9244f279d05$var$STANDARD_PANEL_BACKGROUND_COLORS.get(node.attrs.panelType);
    }
    return backgroundColor ? {
        color: backgroundColor,
        source: 'element'
    } : null;
};
const $e5d8f9244f279d05$export$b51989a8ef7747fa = ($pos, node)=>{
    for (const mark of node.marks){
        if (mark.type.name === 'backgroundColor' && mark.attrs.color) return {
            color: mark.attrs.color,
            source: 'text'
        };
    }
    for(let depth = $pos.depth; depth > 0; depth--){
        const resolvedBackgroundColor = $e5d8f9244f279d05$var$getSupportedAncestorBackgroundColor($pos.node(depth));
        if (resolvedBackgroundColor) return resolvedBackgroundColor;
    }
    return {
        color: null,
        source: 'text'
    };
};
const $e5d8f9244f279d05$var$getResolvedBackgroundColorForPosition = ($pos, highlightColor)=>{
    const highlightBackground = $e5d8f9244f279d05$var$getResolvedBackgroundFromHighlight(highlightColor);
    if (highlightColor) return highlightBackground;
    for(let depth = $pos.depth; depth > 0; depth--){
        const resolvedBackgroundColor = $e5d8f9244f279d05$var$getSupportedAncestorBackgroundColor($pos.node(depth));
        if (resolvedBackgroundColor) return resolvedBackgroundColor;
    }
    return highlightBackground;
};
const $e5d8f9244f279d05$var$getResolvedBackgroundColorValue = (backgroundColor)=>{
    if (backgroundColor.source === 'element') return $e5d8f9244f279d05$var$getBackgroundColor(backgroundColor.color, 'element');
    return $e5d8f9244f279d05$var$getBackgroundColor(backgroundColor.color);
};
const $e5d8f9244f279d05$var$getResolvedBackgroundColorValueInNonActiveTheme = (backgroundColor)=>{
    if (backgroundColor.source === 'element') return $e5d8f9244f279d05$var$getBackgroundColorInNonActiveTheme(backgroundColor.color, 'element');
    return $e5d8f9244f279d05$var$getBackgroundColorInNonActiveTheme(backgroundColor.color);
};
const $e5d8f9244f279d05$var$useColorAccessibilityState = (api)=>{
    return (0, $5beht.useSharedPluginStateWithSelector)(api, [
        'textColor',
        'highlight'
    ], (states)=>{
        var _states$textColorStat, _states$highlightStat, _states$textColorStat2;
        return {
            defaultColor: (_states$textColorStat = states.textColorState) === null || _states$textColorStat === void 0 ? void 0 : _states$textColorStat.defaultColor,
            highlightColor: (_states$highlightStat = states.highlightState) === null || _states$highlightStat === void 0 ? void 0 : _states$highlightStat.activeColor,
            textColor: (_states$textColorStat2 = states.textColorState) === null || _states$textColorStat2 === void 0 ? void 0 : _states$textColorStat2.color
        };
    });
};
const $e5d8f9244f279d05$var$getContrastRatio = (defaultColor, backgroundColor, textColor)=>{
    try {
        const contrastRatio = (0, $iK2HI.getContrastRatio)($e5d8f9244f279d05$var$getForegroundColor(textColor, defaultColor), $e5d8f9244f279d05$var$getResolvedBackgroundColorValue(backgroundColor));
        return contrastRatio;
    } catch  {
        // if we failed to calculate the contrast ratio, return null
        return null;
    }
};
// Computes the contrast ratio as it would appear in the non-active theme.
const $e5d8f9244f279d05$var$getNonActiveThemeContrastRatio = (defaultColor, backgroundColor, textColor)=>{
    try {
        return (0, $iK2HI.getContrastRatio)((0, $e2JYe.getTextColorInNonActiveTheme)(textColor ?? null, defaultColor || (0, $bOo38.DEFAULT_COLOR).color), $e5d8f9244f279d05$var$getResolvedBackgroundColorValueInNonActiveTheme(backgroundColor));
    } catch  {
        // if we failed to calculate the contrast ratio, return null
        return null;
    }
};
const $e5d8f9244f279d05$var$getAccessibilityStatus = (contrastRatio)=>{
    if (contrastRatio >= (0, $bOo38.ACCESSIBLE_CONTRAST_RATIO)) return 'accessible';
    else if (contrastRatio >= (0, $bOo38.DIFFICULT_CONTRAST_RATIO)) return 'difficultToRead';
    else return 'inaccessible';
};
/**
 * Computes status from active foreground/background colors only.
 * Used by the gate-off path so legacy behavior stays isolated.
 */ const $e5d8f9244f279d05$var$getAccessibilityStatusFromColorPair = (defaultColor, backgroundColor, textColor)=>{
    const contrastRatio = $e5d8f9244f279d05$var$getContrastRatio(defaultColor, backgroundColor, textColor);
    return contrastRatio === null ? null : $e5d8f9244f279d05$var$getAccessibilityStatus(contrastRatio);
};
/**
 * Returns the lowest contrast ratio across active and non-active themes.
 */ const $e5d8f9244f279d05$var$getMostCriticalContrastRatioAcrossThemes = (defaultColor, backgroundColor, textColor)=>{
    const contrastRatio = $e5d8f9244f279d05$var$getContrastRatio(defaultColor, backgroundColor, textColor);
    const nonActiveThemeContrastRatio = $e5d8f9244f279d05$var$getNonActiveThemeContrastRatio(defaultColor, backgroundColor, textColor);
    if (contrastRatio !== null && nonActiveThemeContrastRatio !== null) return Math.min(contrastRatio, nonActiveThemeContrastRatio);
    return contrastRatio;
};
const $e5d8f9244f279d05$var$getAccessibilityStatusFromColorPairAcrossThemes = (defaultColor, backgroundColor, textColor)=>{
    const mostCriticalContrastRatio = $e5d8f9244f279d05$var$getMostCriticalContrastRatioAcrossThemes(defaultColor, backgroundColor, textColor);
    return mostCriticalContrastRatio === null ? null : $e5d8f9244f279d05$var$getAccessibilityStatus(mostCriticalContrastRatio);
};
/**
 * Collects the worst accessibility status across all unique foreground/background
 * combinations in the current selection.
 *
 * When the selection spans multiple text colors and/or resolved backgrounds,
 * this checks each unique pair across both the active and non-active theme and
 * returns the worst status found.
 */ const $e5d8f9244f279d05$var$getWorstAccessibilityStatusFromEditorState = (state, defaultColor)=>{
    let worstContrastRatio = null;
    // Text/highlight colors only apply to a text range. If the selection is
    // not a text selection (e.g. a node, cell or all selection) there is no
    // meaningful range of colored text to evaluate.
    if (!(state.selection instanceof (0, $cw0wu.TextSelection)) || state.selection.empty) return null;
    const { from: from, to: to } = state.selection;
    const seen = new Set();
    state.doc.nodesBetween(from, to, (node, pos)=>{
        if (!node.isText) return !node.isLeaf;
        let textColor = null;
        for (const mark of node.marks)if (mark.type.name === 'textColor') textColor = mark.attrs.color ?? null;
        const backgroundColor = $e5d8f9244f279d05$export$b51989a8ef7747fa(state.doc.resolve(pos), node);
        const pairKey = `${textColor ?? 'default'}|${backgroundColor.source}|${backgroundColor.color ?? 'default'}`;
        // Skip foreground/background pairs already evaluated. The source is
        // part of the key because text highlights and element backgrounds use
        // different editor palettes.
        if (seen.has(pairKey)) return;
        seen.add(pairKey);
        const mostCriticalContrastRatio = $e5d8f9244f279d05$var$getMostCriticalContrastRatioAcrossThemes(defaultColor, backgroundColor, textColor);
        if (mostCriticalContrastRatio === null) return;
        if (worstContrastRatio === null || mostCriticalContrastRatio < worstContrastRatio) worstContrastRatio = mostCriticalContrastRatio;
    });
    return worstContrastRatio === null ? null : $e5d8f9244f279d05$var$getAccessibilityStatus(worstContrastRatio);
};
const $e5d8f9244f279d05$export$347a4f417fdc66ea = (state, defaultColor, highlightColor, textColor)=>{
    if (state.selection instanceof (0, $cw0wu.TextSelection)) {
        if (!state.selection.empty) return $e5d8f9244f279d05$var$getWorstAccessibilityStatusFromEditorState(state, defaultColor);
        return $e5d8f9244f279d05$var$getAccessibilityStatusFromColorPairAcrossThemes(defaultColor, $e5d8f9244f279d05$var$getResolvedBackgroundColorForPosition(state.selection.$from, highlightColor), textColor);
    }
    return null;
};
const $e5d8f9244f279d05$var$AccessibilityStatus = ({ accessibilityStatus: accessibilityStatus, formatMessage: formatMessage })=>{
    if (accessibilityStatus === 'accessible') return /*#__PURE__*/ (0, $dc70d.jsx)((0, $8aT4G.Text), {
        as: "span",
        size: "small",
        color: "color.text.success",
        children: formatMessage((0, $2gBYe.colorAccessibilityMessages).accessibleLabel)
    });
    else if (accessibilityStatus === 'difficultToRead') return /*#__PURE__*/ (0, $dc70d.jsx)((0, $8aT4G.Text), {
        as: "span",
        size: "small",
        color: "color.text.warning",
        children: formatMessage((0, $2gBYe.colorAccessibilityMessages).difficultToReadLabel)
    });
    else return /*#__PURE__*/ (0, $dc70d.jsx)((0, $8aT4G.Text), {
        as: "span",
        size: "small",
        color: "color.text.danger",
        children: formatMessage((0, $2gBYe.colorAccessibilityMessages).inaccessibleLabel)
    });
};
const $e5d8f9244f279d05$var$styles = {
    container: "_19itglyw _19pkze3t _ca0qze3t _n3tdze3t _19bvze3t _u5f3ze3t _1e0c1txw _4cvr1h6o _1bah1yb4"
};
const $e5d8f9244f279d05$export$8e34e17dd957d56 = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const { defaultColor: defaultColor, highlightColor: highlightColor, textColor: textColor } = $e5d8f9244f279d05$var$useColorAccessibilityState(api);
    const { editorView: editorView } = (0, $28qc1.useEditorToolbar)();
    const editorState = editorView === null || editorView === void 0 ? void 0 : editorView.state;
    const accessibilityStatus = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useMemo(()=>editorState ? $e5d8f9244f279d05$export$347a4f417fdc66ea(editorState, defaultColor, highlightColor, textColor) : $e5d8f9244f279d05$var$getAccessibilityStatusFromColorPair(defaultColor, $e5d8f9244f279d05$var$getResolvedBackgroundFromHighlight(highlightColor), textColor), [
        defaultColor,
        editorState,
        highlightColor,
        textColor
    ]);
    if (accessibilityStatus === null) return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dc70d.Fragment), {});
    const tooltipContent = (accessibilityStatus)=>{
        if (accessibilityStatus === 'accessible') return formatMessage((0, $2gBYe.colorAccessibilityMessages).accessibleTooltip);
        else if (accessibilityStatus === 'difficultToRead') return formatMessage((0, $2gBYe.colorAccessibilityMessages).difficultToReadTooltip);
        else return formatMessage((0, $2gBYe.colorAccessibilityMessages).inaccessibleTooltip);
    };
    return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $9PwDt.Box), {
        xcss: (0, $jDsoo.cx)($e5d8f9244f279d05$var$styles.container),
        children: [
            /*#__PURE__*/ (0, $dc70d.jsxs)((0, $fZ0ZI.Inline), {
                alignBlock: "center",
                space: "space.050",
                children: [
                    /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a2cYt))), {
                        label: "",
                        size: "medium",
                        color: "var(--ds-icon-subtle, #505258)"
                    }),
                    /*#__PURE__*/ (0, $dc70d.jsx)((0, $8aT4G.Text), {
                        as: "span",
                        size: "small",
                        color: "color.text.subtle",
                        children: formatMessage((0, $2gBYe.colorAccessibilityMessages).accessibility)
                    }),
                    /*#__PURE__*/ (0, $dc70d.jsx)((0, $8aT4G.Text), {
                        as: "span",
                        size: "small",
                        color: "color.text.subtle",
                        "aria-hidden": "true",
                        children: "\u2022"
                    }),
                    /*#__PURE__*/ (0, $dc70d.jsx)($e5d8f9244f279d05$var$AccessibilityStatus, {
                        accessibilityStatus: accessibilityStatus,
                        formatMessage: formatMessage
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $4TRbS.default), {
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($1hEmZ))),
                shape: "circle",
                label: tooltipContent(accessibilityStatus),
                isTooltipDisabled: false,
                spacing: "compact",
                appearance: "subtle"
            })
        ]
    });
};

});
parcelRegister("2gBYe", function(module, exports) {
$parcel$export(module.exports, "colorAccessibilityMessages", () => $b8c68d4b2b5e2688$export$df1842193ff5ba1e);

var $f0Pt4 = parcelRequire("f0Pt4");
const $b8c68d4b2b5e2688$export$df1842193ff5ba1e = (0, $f0Pt4.defineMessages)({
    accessibility: {
        id: 'fabric.editor.color.accessibility.accessibility',
        defaultMessage: 'Accessibility',
        description: 'Label for the accessibility status in the combined text highlight and color menu.'
    },
    accessibleLabel: {
        id: 'fabric.editor.color.accessibility.accessibleLabel',
        defaultMessage: 'Accessible',
        description: 'Label for the accessibility status when the color combination is accessible.'
    },
    accessibleTooltip: {
        id: 'fabric.editor.color.accessibility.accessibleTooltip',
        defaultMessage: 'Accessible color combination',
        description: 'Tooltip content for the accessibility status when the color combination is accessible.'
    },
    difficultToReadLabel: {
        id: 'fabric.editor.color.accessibility.difficultToReadLabel',
        defaultMessage: 'Difficult to read',
        description: 'Label for the accessibility status when the color combination is difficult to read.'
    },
    difficultToReadTooltip: {
        id: 'fabric.editor.color.accessibility.difficultToReadTooltip',
        defaultMessage: 'This color combination has low contrast. Select a different color to improve legibility.',
        description: 'Tooltip content for the accessibility status when the color combination is difficult to read.'
    },
    inaccessibleLabel: {
        id: 'fabric.editor.color.accessibility.inaccessibleLabel',
        defaultMessage: 'Inaccessible',
        description: 'Label for the accessibility status when the color combination is inaccessible.'
    },
    inaccessibleTooltip: {
        id: 'fabric.editor.color.accessibility.inaccessibleTooltip',
        defaultMessage: 'This color combination is hard to read. Select a different color to improve legibility.',
        description: 'Tooltip content for the accessibility status when the color combination is inaccessible.'
    }
});

});

parcelRegister("e2JYe", function(module, exports) {
$parcel$export(module.exports, "getTextColorInNonActiveTheme", () => $f5b3f4c0037198fe$export$fde37617ba913701);

var $8FtCL = parcelRequire("8FtCL");

var $czomm = parcelRequire("czomm");
const $f5b3f4c0037198fe$export$fde37617ba913701 = (color, defaultColor)=>{
    if (!color || color === defaultColor) return (0, $czomm.getTokenCSSVariableValueForNonActiveTheme)("var(--ds-text, #292A2E)", defaultColor);
    const colorValue = (0, $8FtCL.hexToEditorTextPaletteColor)(color) || color;
    return (0, $czomm.getTokenCSSVariableValueForNonActiveTheme)(colorValue, color);
};

});

parcelRegister("iK2HI", function(module, exports) {
$parcel$export(module.exports, "getContrastRatio", () => $3f85896fec3e60df$export$d061e26956a60b0a);
// from platform/packages/design-system/tokens/src/utils/get-contrast-ratio.tsx

var $iWjRz = parcelRequire("iWjRz");
function $3f85896fec3e60df$var$hexToRgb(hex) {
    if (!(0, $iWjRz.isHex)(hex)) throw new Error('Invalid HEX');
    const colorParts = hex.substring(1).split('');
    const color = colorParts.length === 3 || colorParts.length === 4 ? `${colorParts[0]}${colorParts[0]}${colorParts[1]}${colorParts[1]}${colorParts[2]}${colorParts[2]}` : colorParts.slice(0, 6).join('');
    const colorValue = Number(`0x${color}`);
    return [
        colorValue >> 16 & 255,
        colorValue >> 8 & 255,
        colorValue & 255
    ];
}
function $3f85896fec3e60df$var$relativeLuminanceW3C(r, g, b) {
    const RsRGB = r / 255;
    const GsRGB = g / 255;
    const BsRGB = b / 255;
    const R = RsRGB <= 0.03928 ? RsRGB / 12.92 : Math.pow((RsRGB + 0.055) / 1.055, 2.4);
    const G = GsRGB <= 0.03928 ? GsRGB / 12.92 : Math.pow((GsRGB + 0.055) / 1.055, 2.4);
    const B = BsRGB <= 0.03928 ? BsRGB / 12.92 : Math.pow((BsRGB + 0.055) / 1.055, 2.4);
    return 0.2126 * R + 0.7152 * G + 0.0722 * B;
}
function $3f85896fec3e60df$export$d061e26956a60b0a(foreground, background) {
    if (!(0, $iWjRz.isHex)(foreground) || !(0, $iWjRz.isHex)(background)) throw new Error('Invalid HEX');
    const foregroundRgb = $3f85896fec3e60df$var$hexToRgb(foreground);
    const backgroundRgb = $3f85896fec3e60df$var$hexToRgb(background);
    const foregroundLuminance = $3f85896fec3e60df$var$relativeLuminanceW3C(foregroundRgb[0], foregroundRgb[1], foregroundRgb[2]);
    const backgroundLuminance = $3f85896fec3e60df$var$relativeLuminanceW3C(backgroundRgb[0], backgroundRgb[1], backgroundRgb[2]);
    // calculate the color contrast ratio
    const brightest = Math.max(foregroundLuminance, backgroundLuminance);
    const darkest = Math.min(foregroundLuminance, backgroundLuminance);
    return (brightest + 0.05) / (darkest + 0.05);
}

});


parcelRegister("eNBTs", function(module, exports) {
$parcel$export(module.exports, "RemoveColorMenuItem", () => $903bcf53acd0b841$export$cb635404e02af50a);
/* RemoveColorMenuItem.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $4vLTk = parcelRequire("4vLTk");

var $jNJGJ = parcelRequire("jNJGJ");

var $gG6Zw = parcelRequire("gG6Zw");

var $96hEQ = parcelRequire("96hEQ");

var $cY6Ia = parcelRequire("cY6Ia");

var $7bYyx = parcelRequire("7bYyx");

var $1cckB = parcelRequire("1cckB");

var $8aT4G = parcelRequire("8aT4G");

var $5N1Y4 = parcelRequire("5N1Y4");
const $903bcf53acd0b841$var$styles = {
    removeColorButton: "_2rko12b0 _195gv77o _189ee4h9 _1dqonqa1 _1h6d1l7x _19pk12x7",
    removeColorButtonPatch: "_195gze3t _19pkze3t",
    iconContainer: "_zulp12x7 _1e0c1txw _4cvr1h6o _1bah1h6o"
};
const $903bcf53acd0b841$export$cb635404e02af50a = ({ api: api, parents: parents })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const context = (0, $7bYyx.useToolbarDropdownMenu)();
    const closeMenu = context === null || context === void 0 ? void 0 : context.closeMenu;
    const onClick = (event)=>{
        var _api$textColor$shared;
        if (!api) return;
        const defaultColor = (_api$textColor$shared = api.textColor.sharedState.currentState()) === null || _api$textColor$shared === void 0 ? void 0 : _api$textColor$shared.defaultColor;
        if (!defaultColor) return;
        api.core.actions.execute(({ tr: tr })=>{
            var _api$highlight;
            if (!(0, $5N1Y4.expValEquals)('platform_editor_lovability_text_bg_color', 'isEnabled', true)) api.textColor.commands.changeColor(defaultColor, (0, $96hEQ.getInputMethodFromParentKeys)(parents))({
                tr: tr
            });
            (_api$highlight = api.highlight) === null || _api$highlight === void 0 || _api$highlight.commands.changeColor({
                color: (0, $cY6Ia.REMOVE_HIGHLIGHT_COLOR),
                inputMethod: (0, $96hEQ.getInputMethodFromParentKeys)(parents)
            })({
                tr: tr
            });
            return tr;
        });
        if (!(0, $5N1Y4.expValEquals)('platform_editor_lovability_text_bg_color', 'isEnabled', true)) closeMenu === null || closeMenu === void 0 || closeMenu(event);
    };
    if ((0, $5N1Y4.expValEquals)('platform_editor_lovability_text_bg_color', 'isEnabled', true)) return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        className: (0, $9fU1q.default)([
            $903bcf53acd0b841$var$styles.removeColorButton,
            $903bcf53acd0b841$var$styles.removeColorButtonPatch
        ]),
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $jNJGJ.default), {
            shouldFitContainer: true,
            appearance: "subtle",
            onClick: onClick,
            children: /*#__PURE__*/ (0, $dc70d.jsxs)("span", {
                className: (0, $9fU1q.default)([
                    $903bcf53acd0b841$var$styles.iconContainer
                ]),
                children: [
                    /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1cckB))), {
                        size: "medium",
                        label: ""
                    }),
                    /*#__PURE__*/ (0, $dc70d.jsx)((0, $8aT4G.Text), {
                        color: "color.text.subtle",
                        children: formatMessage((0, $gG6Zw.highlightMessages).removeHighlight)
                    })
                ]
            })
        })
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        className: (0, $9fU1q.default)([
            $903bcf53acd0b841$var$styles.removeColorButton
        ]),
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $jNJGJ.default), {
            shouldFitContainer: true,
            appearance: "subtle",
            onClick: onClick,
            children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $8aT4G.Text), {
                weight: "medium",
                children: formatMessage((0, $gG6Zw.highlightMessages).removeColor)
            })
        })
    });
};

});
parcelRegister("cY6Ia", function(module, exports) {
$parcel$export(module.exports, "REMOVE_HIGHLIGHT_COLOR", () => $495423fbb874c532$export$7af0d402d86db2f8);
$parcel$export(module.exports, "highlightColorPalette", () => $495423fbb874c532$export$d0f14653c33da02f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $9dQre = parcelRequire("9dQre");

var $dVvP0 = parcelRequire("dVvP0");

var $ceb9s = parcelRequire("ceb9s");

var $c7jdP = parcelRequire("c7jdP");

var $6nCvv = parcelRequire("6nCvv");

var $2nt4W = parcelRequire("2nt4W");
const $495423fbb874c532$export$7af0d402d86db2f8 = '#00000000';
// Custom icon ejection - these icons have been migrated away from the deprecated Custom / SVG components to native SVG. Please review whether this icon should be contributed to @atlaskit/icon-lab or whether it can be replaced by an existing icon from either @atlaskit/icon or @atlaskit/icon-lab
const $495423fbb874c532$var$DiagonalLineGlyph = (props)=>/*#__PURE__*/ (0, $9dQre.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: props.style
    }, /*#__PURE__*/ (0, $9dQre.jsx)("rect", {
        width: "24",
        height: "24",
        fill: "white",
        fillOpacity: "0.01"
    }), /*#__PURE__*/ (0, $9dQre.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.2038 7.70388C17.5955 8.09565 17.5941 8.73128 17.2005 9.12127L9.1213 17.1277C8.73027 17.5152 8.09958 17.5138 7.71031 17.1245C7.31854 16.7328 7.31997 16.0971 7.71351 15.7071L15.7928 7.70069C16.1838 7.31318 16.8145 7.31461 17.2038 7.70388Z",
        fill: "currentColor",
        fillOpacity: "0.5"
    }));
const $495423fbb874c532$export$b875e193f77236ba = ()=>{
    const { colorMode: colorMode } = (0, $ceb9s.useThemeObserver)();
    const primaryColor = colorMode === 'dark' ? "var(--ds-background-accent-gray-bolder, #6B6E76)" : "var(--ds-background-accent-gray-subtle, #8C8F97)";
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
    /*#__PURE__*/ (0, $9dQre.jsx)($495423fbb874c532$var$DiagonalLineGlyph, {
        style: {
            color: primaryColor
        }
    }));
};
const $495423fbb874c532$export$d0f14653c33da02f = [
    {
        value: $495423fbb874c532$export$7af0d402d86db2f8,
        label: 'No color',
        // Mostly informative, only used for analytics
        border: "var(--ds-border, #0B120E24)",
        message: (0, $c7jdP.default)((0, $2nt4W.default), 'no-color'),
        decorator: /*#__PURE__*/ (0, $9dQre.jsx)($495423fbb874c532$export$b875e193f77236ba, null)
    }
];
(0, $dVvP0.backgroundColorPalette).forEach((label, color)=>{
    $495423fbb874c532$export$d0f14653c33da02f.push((0, $6nCvv.mapPaletteColor)(label, color));
});

});

parcelRegister("1cckB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3517887d062ef93ff03d31199bce5df1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0df07a2fc55aeb46$var$_react = $0df07a2fc55aeb46$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $0df07a2fc55aeb46$var$_iconNew = $0df07a2fc55aeb46$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $0df07a2fc55aeb46$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ColourNone".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/colour-none
 * Usage guidance:
 * Remove colours from Whiteboard's colour picker
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0df07a2fc55aeb46$var$ColourNoneIcon = (props)=>/*#__PURE__*/ $0df07a2fc55aeb46$var$_react.default.createElement($0df07a2fc55aeb46$var$_iconNew.default, Object.assign({
        name: "ColourNoneIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m.47 1.53 14 14 1.06-1.06-14-14zM9.32 12.5l1.5 1.5H4a2 2 0 0 1-2-2V5.18l1.5 1.5V12a.5.5 0 0 0 .5.5zM12 2H5.18l1.5 1.5H12a.5.5 0 0 1 .5.5v5.32l1.5 1.5V4a2 2 0 0 0-2-2"/>`
    }, props));
$0df07a2fc55aeb46$var$ColourNoneIcon.displayName = 'ColourNoneIcon';
var $0df07a2fc55aeb46$var$_default = module.exports.default = $0df07a2fc55aeb46$var$ColourNoneIcon;

});


parcelRegister("8Uxnw", function(module, exports) {
$parcel$export(module.exports, "TextColorHighlightMenu", () => $e0e140f8d0189fe4$export$c448885240fc43ad);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $cv8id = parcelRequire("cv8id");

var $lOB48 = parcelRequire("lOB48");

var $6UJcu = parcelRequire("6UJcu");

var $2pWL6 = parcelRequire("2pWL6");

var $8FtCL = parcelRequire("8FtCL");

var $jYZXg = parcelRequire("jYZXg");

var $8KiWh = parcelRequire("8KiWh");

var $gahAL = parcelRequire("gahAL");

var $6PDfA = parcelRequire("6PDfA");

var $7bYyx = parcelRequire("7bYyx");

var $eHnl8 = parcelRequire("eHnl8");

var $aBdvW = parcelRequire("aBdvW");

var $5N1Y4 = parcelRequire("5N1Y4");
const $e0e140f8d0189fe4$var$getIconColor = (textColor, defaultColor, highlightColor)=>{
    if ((0, $5N1Y4.expValEquals)('platform_editor_lovability_text_bg_color', 'isEnabled', true)) {
        if (!textColor || textColor === defaultColor && defaultColor) return "var(--ds-text, #292A2E)";
        return (0, $8FtCL.hexToEditorTextPaletteColor)(textColor) || "var(--ds-text, #292A2E)";
    }
    if (highlightColor || !textColor || textColor === defaultColor && defaultColor) return "var(--ds-text, #292A2E)";
    return (0, $8FtCL.hexToEditorTextPaletteColor)(textColor) || "var(--ds-text, #292A2E)";
};
const $e0e140f8d0189fe4$var$getHighlightColorIcon = (highlightColor)=>{
    if (highlightColor) return (0, $jYZXg.hexToEditorTextBackgroundPaletteColor)(highlightColor);
    return undefined;
};
const $e0e140f8d0189fe4$var$useTextColorHighlightMenuState = (api)=>{
    const isTextColorDisabled = (0, $2pWL6.useSharedPluginStateSelector)(api, 'textColor.disabled');
    const textColor = (0, $2pWL6.useSharedPluginStateSelector)(api, 'textColor.color');
    const defaultColor = (0, $2pWL6.useSharedPluginStateSelector)(api, 'textColor.defaultColor');
    const isPaletteOpen = (0, $2pWL6.useSharedPluginStateSelector)(api, 'textColor.isPaletteOpen');
    const highlightColor = (0, $2pWL6.useSharedPluginStateSelector)(api, 'highlight.activeColor');
    return {
        isTextColorDisabled: isTextColorDisabled,
        textColor: textColor,
        defaultColor: defaultColor,
        isPaletteOpen: isPaletteOpen,
        highlightColor: highlightColor
    };
};
const $e0e140f8d0189fe4$export$c448885240fc43ad = ({ children: children, api: api })=>{
    var _api$textColor2;
    const isHighlightPluginExisted = !!(api !== null && api !== void 0 && api.highlight);
    const { isDisabled: isToolbarDisabled } = (0, $aBdvW.useToolbarUI)();
    const { isTextColorDisabled: isTextColorDisabled, textColor: textColor, defaultColor: defaultColor, isPaletteOpen: isPaletteOpen, highlightColor: highlightColor } = $e0e140f8d0189fe4$var$useTextColorHighlightMenuState(api);
    const isDisabled = Boolean(isToolbarDisabled || isTextColorDisabled);
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const setIsPaletteOpen = (0, $bSJIT.useCallback)((isOpen)=>{
        var _api$textColor;
        if (api !== null && api !== void 0 && (_api$textColor = api.textColor) !== null && _api$textColor !== void 0 && (_api$textColor = _api$textColor.commands) !== null && _api$textColor !== void 0 && _api$textColor.setPalette) api.core.actions.execute(({ tr: tr })=>{
            api.textColor.commands.setPalette(isOpen)({
                tr: tr
            });
            return tr;
        });
    }, [
        api === null || api === void 0 || (_api$textColor2 = api.textColor) === null || _api$textColor2 === void 0 ? void 0 : _api$textColor2.commands,
        api === null || api === void 0 ? void 0 : api.core.actions
    ]);
    // use isPaletteOpenRef to "close" the palette on unmount, and not on state changes
    const isPaletteOpenRef = (0, $bSJIT.useRef)(isPaletteOpen);
    isPaletteOpenRef.current = isPaletteOpen;
    (0, $bSJIT.useEffect)(()=>{
        return ()=>{
            if ((0, $5N1Y4.expValEquals)('platform_editor_lovability_text_bg_color', 'isEnabled', true)) {
                if (isPaletteOpenRef.current) setIsPaletteOpen(false);
            }
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $bSJIT.useEffect)(()=>{
        return ()=>{
            if ((0, $5N1Y4.expValEquals)('platform_editor_lovability_text_bg_color', 'isEnabled', true)) return;
            if (isPaletteOpen) setIsPaletteOpen(false);
        };
    }, [
        setIsPaletteOpen,
        isPaletteOpen
    ]);
    const iconColor = $e0e140f8d0189fe4$var$getIconColor(textColor, defaultColor, highlightColor);
    if ((0, $5N1Y4.expValEquals)('platform_editor_lovability_text_bg_color', 'isEnabled', true)) return /*#__PURE__*/ (0, $dc70d.jsx)((0, $7bYyx.ToolbarDropdownMenuProvider), {
        isOpen: isPaletteOpen,
        setIsOpen: setIsPaletteOpen,
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $6PDfA.ToolbarDropdownMenu), {
            iconBefore: /*#__PURE__*/ (0, $dc70d.jsx)((0, $gahAL.ToolbarColorSwatch), {
                highlightColor: $e0e140f8d0189fe4$var$getHighlightColorIcon(highlightColor),
                children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $8KiWh.TextColorIcon), {
                    label: formatMessage((0, $lOB48.textColorMessages).textColorTooltip),
                    iconColor: iconColor,
                    shouldRecommendSmallIcon: true,
                    size: 'small',
                    isDisabled: isDisabled,
                    spacing: 'compact'
                })
            }),
            isDisabled: isDisabled,
            testId: "text-color-highlight-menu",
            hasSectionMargin: false,
            tooltipComponent: /*#__PURE__*/ (0, $dc70d.jsx)((0, $eHnl8.ToolbarTooltip), {
                content: /*#__PURE__*/ (0, $dc70d.jsx)((0, $cv8id.ToolTipContent), {
                    description: formatMessage(isHighlightPluginExisted ? (0, $lOB48.textColorMessages).textColorHighlightTooltip : (0, $lOB48.textColorMessages).textColorTooltip),
                    keymap: (0, $cv8id.toggleHighlightPalette)
                })
            }),
            children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $6UJcu.SelectedTextColorProvider), {
                textColor: textColor,
                defaultColor: defaultColor,
                children: children
            })
        })
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $7bYyx.ToolbarDropdownMenuProvider), {
        isOpen: isPaletteOpen,
        setIsOpen: setIsPaletteOpen,
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $6PDfA.ToolbarDropdownMenu), {
            iconBefore: /*#__PURE__*/ (0, $dc70d.jsx)((0, $gahAL.ToolbarColorSwatch), {
                highlightColor: $e0e140f8d0189fe4$var$getHighlightColorIcon(highlightColor),
                children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $8KiWh.TextColorIcon), {
                    label: formatMessage((0, $lOB48.textColorMessages).textColorTooltip),
                    iconColor: iconColor,
                    shouldRecommendSmallIcon: true,
                    size: 'small',
                    isDisabled: isDisabled,
                    spacing: 'compact'
                })
            }),
            isDisabled: isDisabled,
            testId: "text-color-highlight-menu",
            hasSectionMargin: false,
            tooltipComponent: /*#__PURE__*/ (0, $dc70d.jsx)((0, $eHnl8.ToolbarTooltip), {
                content: /*#__PURE__*/ (0, $dc70d.jsx)((0, $cv8id.ToolTipContent), {
                    description: formatMessage(isHighlightPluginExisted ? (0, $lOB48.textColorMessages).textColorHighlightTooltip : (0, $lOB48.textColorMessages).textColorTooltip),
                    keymap: (0, $cv8id.toggleHighlightPalette)
                })
            }),
            children: children
        })
    });
};

});
parcelRegister("6UJcu", function(module, exports) {
$parcel$export(module.exports, "SelectedTextColorProvider", () => $9c7f3d3454459302$export$1c83d9b6bb9a01e);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $c28JW = parcelRequire("c28JW");
const $9c7f3d3454459302$export$1c83d9b6bb9a01e = ({ children: children, defaultColor: defaultColor, textColor: textColor })=>{
    const value = (0, $bSJIT.useMemo)(()=>({
            defaultColor: defaultColor,
            textColor: textColor
        }), [
        defaultColor,
        textColor
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $c28JW.SelectedTextColorContext).Provider, {
        value: value,
        children: children
    });
};

});
parcelRegister("c28JW", function(module, exports) {
$parcel$export(module.exports, "SelectedTextColorContext", () => $368353d675800399$export$72b8ac8e2a7bb722);

var $bSJIT = parcelRequire("bSJIT");
const $368353d675800399$export$72b8ac8e2a7bb722 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createContext({});

});


parcelRegister("8KiWh", function(module, exports) {
$parcel$export(module.exports, "TextColorIcon", () => $3849e49b519834dc$export$36ed63fbff8ebdac);
/* TextColorIcon.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $aBl4O = parcelRequire("aBl4O");

var $9PwDt = parcelRequire("9PwDt");
const $3849e49b519834dc$var$styles = {
    icon: "_19pk12x7"
};
const $3849e49b519834dc$export$36ed63fbff8ebdac = ({ label: label, shouldRecommendSmallIcon: shouldRecommendSmallIcon, size: size, spacing: spacing, testId: testId, iconColor: iconColor, isDisabled: isDisabled })=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
        as: "span",
        xcss: $3849e49b519834dc$var$styles.icon,
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aBl4O))), {
            label: label,
            testId: testId,
            color: isDisabled ? "var(--ds-icon-disabled, #080F214A)" : iconColor,
            shouldRecommendSmallIcon: shouldRecommendSmallIcon,
            spacing: spacing,
            size: size
        })
    });
};

});

parcelRegister("gahAL", function(module, exports) {
$parcel$export(module.exports, "ToolbarColorSwatch", () => $beb591d8a9b2ebfa$export$772f650f1e0be5db);
/* ToolbarColorSwatch.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9PwDt = parcelRequire("9PwDt");
const $beb591d8a9b2ebfa$var$styles = {
    colorSwatch: "_19itia51 _2rko12b0 _1e0c1txw _1bah1h6o _4cvr1h6o _1bsbgktf _4t3igktf _18u0r5cr _2hwxr5cr"
};
const $beb591d8a9b2ebfa$export$772f650f1e0be5db = ({ children: children, highlightColor: highlightColor })=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
        xcss: $beb591d8a9b2ebfa$var$styles.colorSwatch,
        testId: "toolbar-color-swatch",
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        style: {
            backgroundColor: highlightColor
        },
        children: children
    });
};

});


parcelRegister("7Sygw", function(module, exports) {
$parcel$export(module.exports, "TextColorMenuItem", () => $75441833bbf0f75b$export$12b1414e9754f110);
/* TextColorMenuItem.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $lOB48 = parcelRequire("lOB48");

var $96hEQ = parcelRequire("96hEQ");

var $28qc1 = parcelRequire("28qc1");

var $epqkL = parcelRequire("epqkL");

var $5beht = parcelRequire("5beht");

var $8FtCL = parcelRequire("8FtCL");

var $6J5tJ = parcelRequire("6J5tJ");

var $7bYyx = parcelRequire("7bYyx");

var $7WQx2 = parcelRequire("7WQx2");

var $gdUUy = parcelRequire("gdUUy");

var $1egeT = parcelRequire("1egeT");

var $dDEhr = parcelRequire("dDEhr");

var $5N1Y4 = parcelRequire("5N1Y4");
const $75441833bbf0f75b$var$TEXT_COLOR_PICKER_COLUMNS = 10;
const $75441833bbf0f75b$var$styles = {
    container: "_zulp12x7"
};
function $75441833bbf0f75b$export$12b1414e9754f110({ api: api, parents: parents }) {
    const { color: color, defaultColor: defaultColor, palette: palette } = (0, $5beht.useSharedPluginStateWithSelector)(api, [
        'textColor'
    ], (states)=>{
        var _states$textColorStat, _states$textColorStat2, _states$textColorStat3;
        return {
            color: (_states$textColorStat = states.textColorState) === null || _states$textColorStat === void 0 ? void 0 : _states$textColorStat.color,
            defaultColor: ((_states$textColorStat2 = states.textColorState) === null || _states$textColorStat2 === void 0 ? void 0 : _states$textColorStat2.defaultColor) || null,
            palette: ((_states$textColorStat3 = states.textColorState) === null || _states$textColorStat3 === void 0 ? void 0 : _states$textColorStat3.palette) || []
        };
    });
    const { editorView: editorView } = (0, $28qc1.useEditorToolbar)();
    const context = (0, $7bYyx.useToolbarDropdownMenu)();
    const closeMenu = context === null || context === void 0 ? void 0 : context.closeMenu;
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const labelId = (0, $bSJIT.useId)();
    const isNewColorPaletteEnabled = (0, $5N1Y4.expValEquals)('platform_editor_lovability_text_bg_color', 'isEnabled', true);
    const handleTextColorChange = (0, $bSJIT.useCallback)((color, event)=>{
        var _api$textColor;
        if (!(editorView !== null && editorView !== void 0 && editorView.state) || !(editorView !== null && editorView !== void 0 && editorView.dispatch)) return;
        if (api !== null && api !== void 0 && (_api$textColor = api.textColor) !== null && _api$textColor !== void 0 && (_api$textColor = _api$textColor.actions) !== null && _api$textColor !== void 0 && _api$textColor.changeColor) {
            api.textColor.actions.changeColor(color, (0, $96hEQ.getInputMethodFromParentKeys)(parents))(editorView.state, editorView.dispatch);
            if (!isNewColorPaletteEnabled) closeMenu === null || closeMenu === void 0 || closeMenu(event);
        }
    }, [
        editorView === null || editorView === void 0 ? void 0 : editorView.state,
        editorView === null || editorView === void 0 ? void 0 : editorView.dispatch,
        api === null || api === void 0 ? void 0 : api.textColor.actions,
        parents,
        closeMenu,
        isNewColorPaletteEnabled
    ]);
    const colorPalette = /*#__PURE__*/ (0, $dc70d.jsx)((0, $6J5tJ.default), {
        ariaLabelledBy: labelId,
        cols: isNewColorPaletteEnabled ? $75441833bbf0f75b$var$TEXT_COLOR_PICKER_COLUMNS : undefined,
        gap: isNewColorPaletteEnabled ? 'space.0' : undefined,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onClick: (color, _, event)=>{
            handleTextColorChange(color, event);
        },
        selectedColor: color || defaultColor,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        paletteOptions: {
            palette: palette,
            hexToPaletteColor: (0, $8FtCL.hexToEditorTextPaletteColor),
            paletteColorTooltipMessages: (0, $epqkL.textPaletteTooltipMessages)
        }
    });
    return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $dDEhr.Stack), {
        xcss: $75441833bbf0f75b$var$styles.container,
        testId: "text-color-menu-item",
        children: [
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $7WQx2.default), {
                id: labelId,
                size: "xxsmall",
                // The label names the palette's radio group; a heading inside a menu is skipped and has no stable level here
                as: (0, $gdUUy.fg)('platform_editor_a11y_color_palette_radiogroup') ? 'div' : undefined,
                children: formatMessage((0, $lOB48.textColorMessages).textColorTooltip)
            }),
            isNewColorPaletteEnabled ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $1egeT.Bleed), {
                inline: "space.025",
                children: colorPalette
            }) : colorPalette
        ]
    });
}

});
parcelRegister("6J5tJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $3461b478a45885fe$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $7qLn8 = parcelRequire("7qLn8");

var $4vLTk = parcelRequire("4vLTk");

var $gdUUy = parcelRequire("gdUUy");

var $jdcqW = parcelRequire("jdcqW");

var $fZ0ZI = parcelRequire("fZ0ZI");

var $5N1Y4 = parcelRequire("5N1Y4");

var $ceb9s = parcelRequire("ceb9s");

var $hJYvT = parcelRequire("hJYvT");

var $jX1Tw = parcelRequire("jX1Tw");

var $2X9pp = parcelRequire("2X9pp");
/**
 * For a given color pick the color from a list of colors with
 * the highest contrast
 *
 * @param color color string, supports HEX, RGB, RGBA etc.
 * @param useIconToken boolean, describes if a token should be used for the icon color
 * @returns Highest contrast color in pool
 */ function $3461b478a45885fe$var$getCheckMarkColor(color, useIconToken) {
    const tokenVal = (0, $2X9pp.getTokenCSSVariableValue)(color);
    const colorValue = !!tokenVal ? tokenVal : color;
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    const contrastColor = [
        '#FFFFFF',
        '#42526E'
    ].sort((a, b)=>(0, $7qLn8.default).difference(b, colorValue) - (0, $7qLn8.default).difference(a, colorValue))[0];
    if (!useIconToken) return contrastColor;
    // Use of these token comes from guidance from designers in the Design System team
    // they are only intended for use with text colors (and there are different tokens
    // planned to be used when this extended to be used with other palettes).
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    return contrastColor === '#FFFFFF' ? "var(--ds-icon-inverse, #FFFFFF)" : "var(--ds-icon, #292A2E)";
}
/**
 * ColorPalette component for displaying a grid of selectable colors
 *
 * Features:
 * - Responsive grid layout
 * - Keyboard navigation support
 * - Accessibility compliance (ARIA attributes)
 * - Theme-aware tooltips
 * - Design token integration
 * - Customizable color mapping
 */ const $3461b478a45885fe$var$ColorPalette = ({ ariaLabelledBy: ariaLabelledBy, cols: cols = (0, $2X9pp.DEFAULT_COLOR_PICKER_COLUMNS), gap: gap = 'space.050', onClick: onClick, onKeyDown: onKeyDown, selectedColor: selectedColor, paletteOptions: paletteOptions })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const { palette: palette, hexToPaletteColor: hexToPaletteColor, paletteColorTooltipMessages: paletteColorTooltipMessages } = paletteOptions;
    const { colorMode: tokenTheme } = (0, $ceb9s.useThemeObserver)();
    const useIconToken = !!hexToPaletteColor;
    const shouldUseInlineColorGap = (0, $5N1Y4.expValEquals)('platform_editor_lovability_text_bg_color', 'isEnabled', true);
    // Refs for keyboard navigation
    const paletteRef = (0, $bSJIT.useRef)(null);
    const currentFocusRef = (0, $bSJIT.useRef)({
        row: 0,
        col: 0
    });
    const colorsPerRow = (0, $bSJIT.useMemo)(()=>{
        return (0, $2X9pp.getColorsPerRowFromPalette)(palette, cols);
    }, [
        palette,
        cols
    ]);
    // Get initial focus position based on selected color
    const { selectedRowIndex: selectedRowIndex, selectedColumnIndex: selectedColumnIndex } = (0, $bSJIT.useMemo)(()=>{
        return (0, $2X9pp.getSelectedRowAndColumnFromPalette)(palette, selectedColor, cols);
    }, [
        palette,
        selectedColor,
        cols
    ]);
    // Focus management utility
    const focusColorAt = (0, $bSJIT.useCallback)((row, col)=>{
        var _rowElement$children$, _rowElement$children$2;
        if (!paletteRef.current) return;
        const rowElement = paletteRef.current.children[row];
        if (!(rowElement instanceof HTMLElement)) return;
        const colorButtonCandidate = (_rowElement$children$ = rowElement.children[col]) === null || _rowElement$children$ === void 0 || (_rowElement$children$2 = _rowElement$children$.querySelector) === null || _rowElement$children$2 === void 0 ? void 0 : _rowElement$children$2.call(_rowElement$children$, 'button');
        const colorButton = colorButtonCandidate instanceof HTMLButtonElement ? colorButtonCandidate : null;
        if (colorButton) {
            colorButton.focus();
            currentFocusRef.current = {
                row: row,
                col: col
            };
        }
    }, []);
    // Initialize focus position and handle autofocus
    (0, $bSJIT.useEffect)(()=>{
        if (selectedRowIndex >= 0 && selectedColumnIndex >= 0) currentFocusRef.current = {
            row: selectedRowIndex,
            col: selectedColumnIndex
        };
        else currentFocusRef.current = {
            row: 0,
            col: 0
        };
    }, [
        selectedRowIndex,
        selectedColumnIndex
    ]);
    // Keyboard navigation handler
    const handleKeyDown = (0, $bSJIT.useCallback)((value, label, event)=>{
        var _colorsPerRow$row;
        const { row: row, col: col } = currentFocusRef.current;
        const maxRow = colorsPerRow.length - 1;
        const maxCol = ((_colorsPerRow$row = colorsPerRow[row]) === null || _colorsPerRow$row === void 0 ? void 0 : _colorsPerRow$row.length) - 1 || 0;
        switch(event.key){
            case 'ArrowRight':
                event.preventDefault();
                if (col < maxCol) focusColorAt(row, col + 1);
                else if (row < maxRow) // Move to first color of next row
                focusColorAt(row + 1, 0);
                else // Wrap to first color of first row
                focusColorAt(0, 0);
                break;
            case 'ArrowLeft':
                event.preventDefault();
                if (col > 0) focusColorAt(row, col - 1);
                else if (row > 0) {
                    var _colorsPerRow;
                    // Move to last color of previous row
                    const prevRowMaxCol = ((_colorsPerRow = colorsPerRow[row - 1]) === null || _colorsPerRow === void 0 ? void 0 : _colorsPerRow.length) - 1 || 0;
                    focusColorAt(row - 1, prevRowMaxCol);
                } else {
                    var _colorsPerRow$maxRow;
                    // Wrap to last color of last row
                    const lastRowMaxCol = ((_colorsPerRow$maxRow = colorsPerRow[maxRow]) === null || _colorsPerRow$maxRow === void 0 ? void 0 : _colorsPerRow$maxRow.length) - 1 || 0;
                    focusColorAt(maxRow, lastRowMaxCol);
                }
                break;
            case 'ArrowDown':
                event.preventDefault();
                if (row < maxRow) {
                    var _colorsPerRow2;
                    // Move to same column in next row, or last available column
                    const nextRowMaxCol = ((_colorsPerRow2 = colorsPerRow[row + 1]) === null || _colorsPerRow2 === void 0 ? void 0 : _colorsPerRow2.length) - 1 || 0;
                    const targetCol = Math.min(col, nextRowMaxCol);
                    focusColorAt(row + 1, targetCol);
                } else {
                    var _colorsPerRow$;
                    // Wrap to same column in first row
                    const firstRowMaxCol = ((_colorsPerRow$ = colorsPerRow[0]) === null || _colorsPerRow$ === void 0 ? void 0 : _colorsPerRow$.length) - 1 || 0;
                    const targetCol = Math.min(col, firstRowMaxCol);
                    focusColorAt(0, targetCol);
                }
                break;
            case 'ArrowUp':
                event.preventDefault();
                if (row > 0) {
                    var _colorsPerRow3;
                    // Move to same column in previous row, or last available column
                    const prevRowMaxCol = ((_colorsPerRow3 = colorsPerRow[row - 1]) === null || _colorsPerRow3 === void 0 ? void 0 : _colorsPerRow3.length) - 1 || 0;
                    const targetCol = Math.min(col, prevRowMaxCol);
                    focusColorAt(row - 1, targetCol);
                } else {
                    var _colorsPerRow$maxRow2;
                    // Wrap to same column in last row
                    const lastRowMaxCol = ((_colorsPerRow$maxRow2 = colorsPerRow[maxRow]) === null || _colorsPerRow$maxRow2 === void 0 ? void 0 : _colorsPerRow$maxRow2.length) - 1 || 0;
                    const targetCol = Math.min(col, lastRowMaxCol);
                    focusColorAt(maxRow, targetCol);
                }
                break;
            case 'Home':
                event.preventDefault();
                focusColorAt(row, 0);
                break;
            case 'End':
                event.preventDefault();
                focusColorAt(row, maxCol);
                break;
            case 'PageUp':
                event.preventDefault();
                focusColorAt(0, col);
                break;
            case 'PageDown':
                {
                    var _colorsPerRow$maxRow3;
                    event.preventDefault();
                    const lastRowMaxCol = ((_colorsPerRow$maxRow3 = colorsPerRow[maxRow]) === null || _colorsPerRow$maxRow3 === void 0 ? void 0 : _colorsPerRow$maxRow3.length) - 1 || 0;
                    const targetCol = Math.min(col, lastRowMaxCol);
                    focusColorAt(maxRow, targetCol);
                    break;
                }
            case 'Tab':
                // Allow Tab to move to next focusable element (don't prevent default)
                // This will allow Tab to move between color palettes
                if (onKeyDown) onKeyDown(value, label, event);
                break;
            case 'Enter':
            case ' ':
                event.preventDefault();
                onClick(value, label, event);
                break;
            default:
                // Pass through to custom onKeyDown handler if provided
                if (onKeyDown) onKeyDown(value, label, event);
                break;
        }
    }, [
        colorsPerRow,
        focusColorAt,
        onClick,
        onKeyDown
    ]);
    const paletteGrid = /*#__PURE__*/ (0, $dc70d.jsx)((0, $jdcqW.Grid), {
        gap: gap,
        ref: paletteRef,
        role: (0, $gdUUy.fg)('platform_editor_a11y_color_palette_radiogroup') ? 'presentation' : 'group',
        children: colorsPerRow.map((row, rowIndex)=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $fZ0ZI.Inline), {
                space: shouldUseInlineColorGap ? gap : undefined,
                rowSpace: shouldUseInlineColorGap ? undefined : gap,
                role: (0, $gdUUy.fg)('platform_editor_a11y_color_palette_radiogroup') ? 'presentation' : 'radiogroup',
                children: row.map(({ value: value, label: label, border: border, message: message, decorator: decorator }, colIndex)=>{
                    let tooltipMessage = message;
                    // Override with theme-specific tooltip messages if provided
                    if (paletteColorTooltipMessages) {
                        if (tokenTheme === 'dark') tooltipMessage = (0, $jX1Tw.default)(paletteColorTooltipMessages.dark, value.toUpperCase());
                        if (tokenTheme === 'light') tooltipMessage = (0, $jX1Tw.default)(paletteColorTooltipMessages.light, value.toUpperCase());
                    }
                    // Determine if this color should be focusable
                    const isSelectedColor = value === selectedColor;
                    const isFirstColor = rowIndex === 0 && colIndex === 0;
                    // Only the selected color or first color should be focusable via Tab
                    // This allows Tab to move between color palettes
                    const shouldBeFocusable = isSelectedColor || !selectedColor && isFirstColor;
                    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $hJYvT.Color), {
                        value: value,
                        borderColor: border,
                        label: tooltipMessage ? formatMessage(tooltipMessage) : label,
                        onClick: onClick,
                        onKeyDown: handleKeyDown,
                        isSelected: isSelectedColor,
                        checkMarkColor: $3461b478a45885fe$var$getCheckMarkColor(value, useIconToken),
                        hexToPaletteColor: hexToPaletteColor,
                        decorator: decorator,
                        tabIndex: shouldBeFocusable ? 0 : -1
                    }, value);
                })
            }, `row-first-color-${row[0].value}`))
    });
    if ((0, $gdUUy.fg)('platform_editor_a11y_color_palette_radiogroup')) // All swatches are one radio group; the grid and its rows only carry the layout
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        role: "radiogroup",
        "aria-labelledby": ariaLabelledBy,
        children: paletteGrid
    });
    return paletteGrid;
};
var $3461b478a45885fe$export$2e2bcd8739ae039 = $3461b478a45885fe$var$ColorPalette;

});
parcelRegister("hJYvT", function(module, exports) {
$parcel$export(module.exports, "Color", () => $b40a8388343b5c33$export$892596cec99bc70e);
/* Color.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $k9Jtq = parcelRequire("k9Jtq");

var $4zjoa = parcelRequire("4zjoa");

var $lavtv = parcelRequire("lavtv");
const $b40a8388343b5c33$var$buttonWrapperStyles = null;
const $b40a8388343b5c33$var$buttonWrapperStylesNew = null;
const $b40a8388343b5c33$var$buttonStyles = null;
const $b40a8388343b5c33$export$892596cec99bc70e = /*#__PURE__*/ (0, $bSJIT.memo)(({ autoFocus: autoFocus, tabIndex: tabIndex, value: value, label: label, isSelected: isSelected, borderColor: borderColor, checkMarkColor: checkMarkColor = "var(--ds-icon-inverse, #FFFFFF)", hexToPaletteColor: hexToPaletteColor, decorator: decorator, onClick: onClick, onKeyDown: onKeyDown })=>{
    const colorStyle = hexToPaletteColor ? hexToPaletteColor(value) : value;
    const handleMouseDown = (0, $bSJIT.useCallback)((e)=>{
        e.preventDefault();
    }, []);
    const handleClick = (0, $bSJIT.useCallback)((e)=>{
        e.preventDefault();
        onClick(value, label, e);
    }, [
        onClick,
        value,
        label
    ]);
    const handleKeyDown = (0, $bSJIT.useCallback)((e)=>{
        if (!onKeyDown) return;
        e.preventDefault();
        onKeyDown(value, label, e);
    }, [
        onKeyDown,
        value,
        label
    ]);
    if ((0, $4zjoa.expValEqualsNoExposure)('platform_editor_lovability_text_bg_color', 'isEnabled', true)) return /*#__PURE__*/ (0, $dc70d.jsx)((0, $lavtv.default), {
        content: label,
        children: /*#__PURE__*/ (0, $dc70d.jsx)("span", {
            className: (0, $9fU1q.default)([
                "_2rko1qi0 _1h6d1j28 _1dqonqa1 _189ee4h9 _1e0c1txw _4cvr1h6o _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o _858u1l7x _jyzf1l7x _4cvx1l7x"
            ]),
            children: /*#__PURE__*/ (0, $dc70d.jsxs)("button", {
                type: "button",
                "aria-label": label,
                role: "radio",
                "aria-checked": isSelected,
                onClick: handleClick,
                onKeyDown: handleKeyDown,
                onMouseDown: handleMouseDown,
                tabIndex: tabIndex,
                style: {
                    backgroundColor: colorStyle || "var(--ds-background-input, #FFFFFF)",
                    border: `${"var(--ds-border-width, 1px)"} solid ${borderColor}`
                },
                autoFocus: autoFocus,
                className: (0, $9fU1q.default)([
                    "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _2rko12b0 _19it1ps9 _4t3i1ejb _1bsb1ejb _bfhki8nm _80omtlke _1e0c1ule _kqswh2mm _y2mvdfik _1bg4v77o"
                ]),
                children: [
                    !decorator && isSelected && /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($k9Jtq))), {
                        color: checkMarkColor,
                        label: ""
                    }),
                    decorator
                ]
            })
        })
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $lavtv.default), {
        content: label,
        children: /*#__PURE__*/ (0, $dc70d.jsx)("span", {
            className: (0, $9fU1q.default)([
                "_2rko12b0 _1h6d1j28 _1dqonqa1 _189ee4h9 _1e0c1txw _4cvr1h6o _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o _858u1l7x _jyzf1l7x _4cvx1l7x"
            ]),
            children: /*#__PURE__*/ (0, $dc70d.jsxs)("button", {
                type: "button",
                "aria-label": label,
                role: "radio",
                "aria-checked": isSelected,
                onClick: handleClick,
                onKeyDown: handleKeyDown,
                onMouseDown: handleMouseDown,
                tabIndex: tabIndex,
                style: {
                    backgroundColor: colorStyle || "var(--ds-background-input, #FFFFFF)",
                    border: `${"var(--ds-border-width, 1px)"} solid ${borderColor}`
                },
                autoFocus: autoFocus,
                className: (0, $9fU1q.default)([
                    "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _2rko12b0 _19it1ps9 _4t3i1ejb _1bsb1ejb _bfhki8nm _80omtlke _1e0c1ule _kqswh2mm _y2mvdfik _1bg4v77o"
                ]),
                children: [
                    !decorator && isSelected && /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($k9Jtq))), {
                        color: checkMarkColor,
                        label: ""
                    }),
                    decorator
                ]
            })
        })
    });
});

});

parcelRegister("jX1Tw", function(module, exports) {
$parcel$export(module.exports, "default", () => $afe454b605fe7cad$export$2e2bcd8739ae039);
function $afe454b605fe7cad$export$2e2bcd8739ae039(messages, color) {
    const message = messages[color];
    if (!message) // eslint-disable-next-line no-console
    console.warn(`Color palette does not have an internationalization message for color ${color.toUpperCase()}.
You must add a message description to properly translate this color.
Using current label as default message.
This could have happened when someone changed the 'colorPalette' from 'adf-schema' without updating this file.
`);
    return message;
}

});

parcelRegister("2X9pp", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_COLOR_PICKER_COLUMNS", () => $9e1d4efc8000f845$export$dc37d14f75a32acb);
$parcel$export(module.exports, "getColorsPerRowFromPalette", () => $9e1d4efc8000f845$export$d97d52770ca27b6f);
$parcel$export(module.exports, "getSelectedRowAndColumnFromPalette", () => $9e1d4efc8000f845$export$c16ae5b27ec0c8f6);
$parcel$export(module.exports, "getTokenCSSVariableValue", () => $9e1d4efc8000f845$export$426cbff16166281c);
const $9e1d4efc8000f845$export$dc37d14f75a32acb = 7;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $9e1d4efc8000f845$var$CSS_VAR_REGEX = /var\(([^,\)]+)(,.*)?/;
function $9e1d4efc8000f845$export$d97d52770ca27b6f(palette, cols = $9e1d4efc8000f845$export$dc37d14f75a32acb) {
    return palette.reduce((resultArray, item, index)=>{
        const chunkIndex = Math.floor(index / cols);
        resultArray[chunkIndex] = resultArray[chunkIndex] || []; // start a new chunk
        resultArray[chunkIndex].push(item);
        return resultArray;
    }, []);
}
function $9e1d4efc8000f845$export$17092ffd56d3b3b2(colorsPerRow, selectedColor) {
    let selectedRowIndex = -1;
    let selectedColumnIndex = -1;
    colorsPerRow.forEach((row, rowIndex)=>{
        row.forEach(({ value: value }, columnIndex)=>{
            if (value === selectedColor) {
                selectedRowIndex = rowIndex;
                selectedColumnIndex = columnIndex;
            }
        });
    });
    return {
        selectedRowIndex: selectedRowIndex,
        selectedColumnIndex: selectedColumnIndex
    };
}
function $9e1d4efc8000f845$export$c16ae5b27ec0c8f6(palette, selectedColor, cols = $9e1d4efc8000f845$export$dc37d14f75a32acb) {
    const colorsPerRow = $9e1d4efc8000f845$export$d97d52770ca27b6f(palette, cols);
    return $9e1d4efc8000f845$export$17092ffd56d3b3b2(colorsPerRow, selectedColor);
}
const $9e1d4efc8000f845$export$426cbff16166281c = (variableExpression)=>{
    // Match CSS variable pattern: var(--variable-name, fallback)
    const matcher = variableExpression.match($9e1d4efc8000f845$var$CSS_VAR_REGEX);
    if (matcher) {
        const variable = matcher[1].trim();
        const fallback = matcher[2] ? matcher[2].replace(',', '').trim() : '';
        // Return fallback if we're in a server environment
        if (typeof document === 'undefined') return fallback;
        // Get the computed value from the document
        const value = window.getComputedStyle(document.documentElement).getPropertyValue(variable).trim();
        return value || fallback;
    }
    return '';
};

});



parcelRegister("jrQZX", function(module, exports) {
$parcel$export(module.exports, "TextMenuSection", () => $cf0047c587473313$export$95716c110be351d7);
/* TextMenuSection.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $4rzOL = parcelRequire("4rzOL");

var $dlk6h = parcelRequire("dlk6h");

var $9PwDt = parcelRequire("9PwDt");

var $5N1Y4 = parcelRequire("5N1Y4");
const $cf0047c587473313$var$styles = {
    menuOld: "_1rjcv77o _18zru2gc",
    menu: "_zulpu2gc _1rjc12x7 _18zrutpp _1e0c1txw _2lx21bp4"
};
const $cf0047c587473313$export$95716c110be351d7 = ({ children: children, parents: parents })=>{
    const hasSeparator = parents.some((parent)=>parent.key === (0, $4rzOL.TEXT_COLLAPSED_MENU).key);
    const onMouseDown = (event)=>{
        if ((0, $5N1Y4.expValEquals)('platform_editor_lovability_text_bg_color', 'isEnabled', true)) event.stopPropagation();
    };
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dlk6h.ToolbarDropdownItemSection), {
        hasSeparator: hasSeparator,
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
            xcss: (0, $5N1Y4.expValEquals)('platform_editor_lovability_text_bg_color', 'isEnabled', true) ? $cf0047c587473313$var$styles.menu : $cf0047c587473313$var$styles.menuOld,
            onMouseDown: onMouseDown,
            children: children
        })
    });
};

});



parcelRegister("jvVVo", function(module, exports) {
$parcel$export(module.exports, "toolbarListsIndentationPlugin", () => $bb5eabbd0d7f3d43$export$fdc8ab6a3979a865);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $d0HRE = parcelRequire("d0HRE");

var $73bnr = parcelRequire("73bnr");

var $5beht = parcelRequire("5beht");

var $797yE = parcelRequire("797yE");

var $8qTes = parcelRequire("8qTes");

var $hH6U9 = parcelRequire("hH6U9");

var $6oklh = parcelRequire("6oklh");

var $3I1Nh = parcelRequire("3I1Nh");

var $gfJge = parcelRequire("gfJge");
const $bb5eabbd0d7f3d43$export$fdc8ab6a3979a865 = ({ config: config, api: api })=>{
    var _api$featureFlags;
    const { showIndentationButtons: showIndentationButtons = false, allowHeadingAndParagraphIndentation: allowHeadingAndParagraphIndentation = false } = config ?? {};
    const featureFlags = (api === null || api === void 0 || (_api$featureFlags = api.featureFlags) === null || _api$featureFlags === void 0 ? void 0 : _api$featureFlags.sharedState.currentState()) || {};
    const isToolbarAIFCEnabled = Boolean(api === null || api === void 0 ? void 0 : api.toolbar);
    const primaryToolbarComponent = ({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, toolbarSize: toolbarSize, disabled: disabled, isToolbarReducedSpacing: isToolbarReducedSpacing })=>{
        if (!editorView) return null;
        return /*#__PURE__*/ (0, $dc70d.jsx)($bb5eabbd0d7f3d43$export$94516d5cccf573e3, {
            featureFlags: featureFlags,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            isSmall: toolbarSize < (0, $d0HRE.ToolbarSize).L,
            isToolbarReducedSpacing: isToolbarReducedSpacing,
            disabled: disabled,
            editorView: editorView,
            showIndentationButtons: showIndentationButtons,
            pluginInjectionApi: api,
            allowHeadingAndParagraphIndentation: allowHeadingAndParagraphIndentation
        });
    };
    if (isToolbarAIFCEnabled) {
        var _api$toolbar;
        api === null || api === void 0 || (_api$toolbar = api.toolbar) === null || _api$toolbar === void 0 || _api$toolbar.actions.registerComponents((0, $gfJge.getToolbarComponents)({
            api: api,
            showIndentationButtons: showIndentationButtons,
            allowHeadingAndParagraphIndentation: allowHeadingAndParagraphIndentation
        }));
    } else {
        var _api$primaryToolbar;
        api === null || api === void 0 || (_api$primaryToolbar = api.primaryToolbar) === null || _api$primaryToolbar === void 0 || _api$primaryToolbar.actions.registerComponent({
            name: 'toolbarListsIndentation',
            component: primaryToolbarComponent
        });
    }
    return {
        name: 'toolbarListsIndentation',
        pluginsOptions: {
            ...!isToolbarAIFCEnabled && {
                selectionToolbar () {
                    var _api$userPreferences;
                    const toolbarDocking = api === null || api === void 0 || (_api$userPreferences = api.userPreferences) === null || _api$userPreferences === void 0 || (_api$userPreferences = _api$userPreferences.sharedState.currentState()) === null || _api$userPreferences === void 0 ? void 0 : _api$userPreferences.preferences.toolbarDockingPosition;
                    if (toolbarDocking === 'none' && (0, $797yE.editorExperiment)('platform_editor_controls', 'variant1', {
                        exposure: true
                    })) {
                        const toolbarCustom = {
                            type: 'custom',
                            render: (view)=>{
                                if (!view) return;
                                return /*#__PURE__*/ (0, $dc70d.jsx)((0, $3I1Nh.FloatingToolbarComponent), {
                                    editorView: view,
                                    featureFlags: featureFlags,
                                    pluginInjectionApi: api,
                                    showIndentationButtons: showIndentationButtons,
                                    allowHeadingAndParagraphIndentation: allowHeadingAndParagraphIndentation
                                });
                            },
                            fallback: []
                        };
                        return {
                            rank: 3,
                            isToolbarAbove: true,
                            items: [
                                toolbarCustom
                            ],
                            pluginName: 'toolbarListsIndentation'
                        };
                    } else return undefined;
                }
            }
        },
        primaryToolbarComponent: !isToolbarAIFCEnabled && !(api !== null && api !== void 0 && api.primaryToolbar) ? primaryToolbarComponent : undefined
    };
};
function $bb5eabbd0d7f3d43$export$94516d5cccf573e3({ featureFlags: featureFlags, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isSmall: isSmall, isToolbarReducedSpacing: isToolbarReducedSpacing, disabled: disabled, editorView: editorView, showIndentationButtons: showIndentationButtons, pluginInjectionApi: pluginInjectionApi, allowHeadingAndParagraphIndentation: allowHeadingAndParagraphIndentation }) {
    var _pluginInjectionApi$l;
    const { bulletListActive: bulletListActive, bulletListDisabled: bulletListDisabled, orderedListActive: orderedListActive, orderedListDisabled: orderedListDisabled, isIndentationAllowed: isIndentationAllowed, indentDisabled: indentDisabled, outdentDisabled: outdentDisabled } = (0, $5beht.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'list',
        'indentation'
    ], (states)=>{
        var _states$listState, _states$listState2, _states$listState3, _states$listState4, _states$indentationSt, _states$indentationSt2, _states$indentationSt3, _states$listState5;
        return {
            bulletListActive: (_states$listState = states.listState) === null || _states$listState === void 0 ? void 0 : _states$listState.bulletListActive,
            bulletListDisabled: (_states$listState2 = states.listState) === null || _states$listState2 === void 0 ? void 0 : _states$listState2.bulletListDisabled,
            orderedListActive: (_states$listState3 = states.listState) === null || _states$listState3 === void 0 ? void 0 : _states$listState3.orderedListActive,
            orderedListDisabled: (_states$listState4 = states.listState) === null || _states$listState4 === void 0 ? void 0 : _states$listState4.orderedListDisabled,
            isIndentationAllowed: (_states$indentationSt = states.indentationState) === null || _states$indentationSt === void 0 ? void 0 : _states$indentationSt.isIndentationAllowed,
            indentDisabled: (_states$indentationSt2 = states.indentationState) === null || _states$indentationSt2 === void 0 ? void 0 : _states$indentationSt2.indentDisabled,
            outdentDisabled: (_states$indentationSt3 = states.indentationState) === null || _states$indentationSt3 === void 0 ? void 0 : _states$indentationSt3.outdentDisabled,
            // listStructureToken changes when a list edit could have altered indent/outdent
            // availability, which none of the flags above capture on their own
            listStructureToken: (_states$listState5 = states.listState) === null || _states$listState5 === void 0 ? void 0 : _states$listState5.listStructureToken
        };
    });
    const [taskDecisionState, setTaskDecisionState] = (0, $bSJIT.useState)();
    (0, $73bnr.usePluginStateEffect)(pluginInjectionApi, [
        'taskDecision'
    ], ({ taskDecisionState: newTaskDecisionState })=>{
        if ((newTaskDecisionState === null || newTaskDecisionState === void 0 ? void 0 : newTaskDecisionState.outdentDisabled) !== (taskDecisionState === null || taskDecisionState === void 0 ? void 0 : taskDecisionState.outdentDisabled) || (newTaskDecisionState === null || newTaskDecisionState === void 0 ? void 0 : newTaskDecisionState.indentDisabled) !== (taskDecisionState === null || taskDecisionState === void 0 ? void 0 : taskDecisionState.indentDisabled) || (newTaskDecisionState === null || newTaskDecisionState === void 0 ? void 0 : newTaskDecisionState.isInsideTask) !== (taskDecisionState === null || taskDecisionState === void 0 ? void 0 : taskDecisionState.isInsideTask)) setTaskDecisionState({
            isInsideTask: Boolean(newTaskDecisionState === null || newTaskDecisionState === void 0 ? void 0 : newTaskDecisionState.isInsideTask),
            indentDisabled: Boolean(newTaskDecisionState === null || newTaskDecisionState === void 0 ? void 0 : newTaskDecisionState.indentDisabled),
            outdentDisabled: Boolean(newTaskDecisionState === null || newTaskDecisionState === void 0 ? void 0 : newTaskDecisionState.outdentDisabled)
        });
    });
    const toolbarListsIndentationState = (0, $8qTes.getIndentationButtonsState)(editorView.state, allowHeadingAndParagraphIndentation, taskDecisionState, {
        isIndentationAllowed: isIndentationAllowed,
        indentDisabled: indentDisabled,
        outdentDisabled: outdentDisabled
    }, pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$l = pluginInjectionApi.list) === null || _pluginInjectionApi$l === void 0 ? void 0 : _pluginInjectionApi$l.actions.isInsideListItem);
    if (bulletListActive === undefined || bulletListDisabled === undefined || orderedListActive === undefined || orderedListDisabled === undefined) return null;
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $6oklh.default), {
        featureFlags: featureFlags,
        isSmall: isSmall,
        isReducedSpacing: isToolbarReducedSpacing,
        disabled: disabled,
        editorView: editorView,
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        bulletListActive: bulletListActive,
        bulletListDisabled: bulletListDisabled,
        orderedListActive: orderedListActive,
        orderedListDisabled: orderedListDisabled,
        showIndentationButtons: !!showIndentationButtons,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        indentDisabled: toolbarListsIndentationState.indentDisabled,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        outdentDisabled: toolbarListsIndentationState.outdentDisabled,
        indentationStateNode: toolbarListsIndentationState === null || toolbarListsIndentationState === void 0 ? void 0 : toolbarListsIndentationState.node,
        pluginInjectionApi: pluginInjectionApi,
        toolbarType: (0, $hH6U9.ToolbarType).PRIMARY
    });
}

});
parcelRegister("8qTes", function(module, exports) {
$parcel$export(module.exports, "getIndentationButtonsState", () => $939c9cb8d7cd8e3b$export$3d562ab2ad3402f3);

var $7aCjN = parcelRequire("7aCjN");

var $S9Ran = parcelRequire("S9Ran");

var $gab48 = parcelRequire("gab48");
function $939c9cb8d7cd8e3b$export$3d562ab2ad3402f3(editorState, allowHeadingAndParagraphIndentation, taskDecisionState, indentationState, isInsideListItem) {
    const state = {
        indentDisabled: true,
        outdentDisabled: true,
        node: null
    };
    const { selection: selection } = editorState;
    // Handle bullet and numbered lists seperately as they do
    // not use the indentation mark.
    // Check for lists before paragraphs and headings in case
    // the selection is in a list nested in a layout column.
    if (isInsideListItem !== null && isInsideListItem !== void 0 && isInsideListItem(editorState.tr)) {
        const { indentLevel: indentLevel } = (0, $S9Ran.getListItemAttributes)(selection.$head);
        return {
            // List indent levels are zero indexed so we need to subtract 1
            indentDisabled: indentLevel >= (0, $7aCjN.MAX_INDENTATION_LEVEL) - 1,
            outdentDisabled: false,
            node: 'list'
        };
    }
    // Handle tasks seperately as they do not use the indentation mark
    // and have different behaviour for outdent compared to lists
    if (taskDecisionState !== null && taskDecisionState !== void 0 && taskDecisionState.isInsideTask) return {
        indentDisabled: taskDecisionState.indentDisabled,
        outdentDisabled: taskDecisionState.outdentDisabled,
        node: 'taskList'
    };
    const isTopLevelParagraphOrHeading = selection.$from.depth === 1;
    const isInLayoutNode = (0, $gab48.hasParentNodeOfType)(editorState.schema.nodes.layoutColumn)(selection) && // depth of non-nested paragraphs and headings in layouts will always be 3
    selection.$from.depth === 3;
    if (allowHeadingAndParagraphIndentation && ((indentationState === null || indentationState === void 0 ? void 0 : indentationState.isIndentationAllowed) ?? false) && (isTopLevelParagraphOrHeading || isInLayoutNode) && (indentationState === null || indentationState === void 0 ? void 0 : indentationState.indentDisabled) !== undefined && (indentationState === null || indentationState === void 0 ? void 0 : indentationState.outdentDisabled) !== undefined) return {
        indentDisabled: indentationState.indentDisabled,
        outdentDisabled: indentationState.outdentDisabled,
        node: 'paragraph_heading'
    };
    return state;
}

});

parcelRegister("hH6U9", function(module, exports) {
$parcel$export(module.exports, "ToolbarType", () => $1399001a18ff01ba$export$a5d11b3163e4b1a5);
var $1399001a18ff01ba$export$a5d11b3163e4b1a5 = /*#__PURE__*/ function(ToolbarType) {
    ToolbarType["PRIMARY"] = "primaryToolbar";
    ToolbarType["FLOATING"] = "floatingToolbar";
    return ToolbarType;
}({});

});

parcelRegister("6oklh", function(module, exports) {
$parcel$export(module.exports, "default", () => $daa04309b3591919$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $g6Qq4 = parcelRequire("g6Qq4");

var $797yE = parcelRequire("797yE");

var $hH6U9 = parcelRequire("hH6U9");

var $4TZqt = parcelRequire("4TZqt");

var $aexpl = parcelRequire("aexpl");

var $8r8Bw = parcelRequire("8r8Bw");

var $3MVB1 = parcelRequire("3MVB1");
function $daa04309b3591919$export$2e2bcd8739ae039(props) {
    const { disabled: disabled, isSmall: isSmall, isReducedSpacing: isReducedSpacing, bulletListActive: bulletListActive, bulletListDisabled: bulletListDisabled, orderedListActive: orderedListActive, orderedListDisabled: orderedListDisabled, showIndentationButtons: showIndentationButtons, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, indentDisabled: indentDisabled, outdentDisabled: outdentDisabled, indentationStateNode: indentationStateNode, featureFlags: featureFlags, pluginInjectionApi: pluginInjectionApi, toolbarType: toolbarType } = props;
    const inputMethod = toolbarType ? (0, $3MVB1.getInputMethod)(toolbarType) : (0, $g6Qq4.INPUT_METHOD).TOOLBAR;
    if (isSmall || toolbarType === (0, $hH6U9.ToolbarType).FLOATING || (0, $797yE.editorExperiment)('platform_editor_controls', 'variant1')) {
        const areAllOptionsDisabled = [
            bulletListDisabled,
            orderedListDisabled,
            indentDisabled,
            outdentDisabled
        ].every((item)=>Boolean(item) === true);
        const isDisabled = disabled || areAllOptionsDisabled;
        return /*#__PURE__*/ (0, $dc70d.jsx)((0, $8r8Bw.ToolbarDropdown), {
            editorView: props.editorView,
            isReducedSpacing: isReducedSpacing,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            bulletListActive: bulletListActive,
            bulletListDisabled: bulletListDisabled,
            showIndentationButtons: showIndentationButtons,
            orderedListActive: orderedListActive,
            orderedListDisabled: orderedListDisabled,
            indentDisabled: indentDisabled,
            outdentDisabled: outdentDisabled,
            disabled: isDisabled,
            onItemActivated: (0, $4TZqt.onItemActivated)(pluginInjectionApi, indentationStateNode, inputMethod),
            featureFlags: featureFlags,
            pluginInjectionApi: pluginInjectionApi,
            toolbarType: toolbarType
        });
    }
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $aexpl.Toolbar), {
        editorView: props.editorView,
        isReducedSpacing: isReducedSpacing,
        bulletListActive: bulletListActive,
        bulletListDisabled: bulletListDisabled,
        showIndentationButtons: showIndentationButtons,
        orderedListActive: orderedListActive,
        orderedListDisabled: orderedListDisabled,
        indentDisabled: indentDisabled,
        outdentDisabled: outdentDisabled,
        disabled: disabled,
        onItemActivated: (0, $4TZqt.onItemActivated)(pluginInjectionApi, indentationStateNode, inputMethod),
        featureFlags: featureFlags,
        pluginInjectionApi: pluginInjectionApi
    });
}

});
parcelRegister("4TZqt", function(module, exports) {
$parcel$export(module.exports, "onItemActivated", () => $81102b82f99ef99c$export$602524aee99c280f);
const $81102b82f99ef99c$export$602524aee99c280f = (pluginInjectionApi, indentationStateNode, inputMethod)=>({ buttonName: buttonName, editorView: editorView })=>{
        var _pluginInjectionApi$c, _pluginInjectionApi$l, _pluginInjectionApi$c2, _pluginInjectionApi$l2;
        switch(buttonName){
            case 'bullet_list':
                pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$c = pluginInjectionApi.core) === null || _pluginInjectionApi$c === void 0 || _pluginInjectionApi$c.actions.execute(pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$l = pluginInjectionApi.list) === null || _pluginInjectionApi$l === void 0 ? void 0 : _pluginInjectionApi$l.commands.toggleBulletList(inputMethod));
                break;
            case 'ordered_list':
                pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$c2 = pluginInjectionApi.core) === null || _pluginInjectionApi$c2 === void 0 || _pluginInjectionApi$c2.actions.execute(pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$l2 = pluginInjectionApi.list) === null || _pluginInjectionApi$l2 === void 0 ? void 0 : _pluginInjectionApi$l2.commands.toggleOrderedList(inputMethod));
                break;
            case 'indent':
                {
                    const node = indentationStateNode;
                    if (node === 'paragraph_heading') {
                        var _pluginInjectionApi$i;
                        pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$i = pluginInjectionApi.indentation) === null || _pluginInjectionApi$i === void 0 || _pluginInjectionApi$i.actions.indentParagraphOrHeading(inputMethod)(editorView.state, editorView.dispatch);
                    }
                    if (node === 'list') {
                        var _pluginInjectionApi$c3, _pluginInjectionApi$l3;
                        pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$c3 = pluginInjectionApi.core) === null || _pluginInjectionApi$c3 === void 0 || _pluginInjectionApi$c3.actions.execute(pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$l3 = pluginInjectionApi.list) === null || _pluginInjectionApi$l3 === void 0 ? void 0 : _pluginInjectionApi$l3.commands.indentList(inputMethod));
                    }
                    if (node === 'taskList') {
                        var _pluginInjectionApi$t;
                        pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$t = pluginInjectionApi.taskDecision) === null || _pluginInjectionApi$t === void 0 || _pluginInjectionApi$t.actions.indentTaskList(inputMethod)(editorView.state, editorView.dispatch);
                    }
                    break;
                }
            case 'outdent':
                {
                    const node = indentationStateNode;
                    if (node === 'paragraph_heading') {
                        var _pluginInjectionApi$i2;
                        pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$i2 = pluginInjectionApi.indentation) === null || _pluginInjectionApi$i2 === void 0 || _pluginInjectionApi$i2.actions.outdentParagraphOrHeading(inputMethod)(editorView.state, editorView.dispatch);
                    }
                    if (node === 'list') {
                        var _pluginInjectionApi$c4, _pluginInjectionApi$l4;
                        pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$c4 = pluginInjectionApi.core) === null || _pluginInjectionApi$c4 === void 0 || _pluginInjectionApi$c4.actions.execute(pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$l4 = pluginInjectionApi.list) === null || _pluginInjectionApi$l4 === void 0 ? void 0 : _pluginInjectionApi$l4.commands.outdentList(inputMethod));
                    }
                    if (node === 'taskList') {
                        var _pluginInjectionApi$t2;
                        pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$t2 = pluginInjectionApi.taskDecision) === null || _pluginInjectionApi$t2 === void 0 || _pluginInjectionApi$t2.actions.outdentTaskList(inputMethod)(editorView.state, editorView.dispatch);
                    }
                    break;
                }
        }
    };

});

parcelRegister("aexpl", function(module, exports) {
$parcel$export(module.exports, "Toolbar", () => $1496e14448e39e61$export$4c260019440d418f);
/* Toolbar.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $bnf0l = parcelRequire("bnf0l");

var $cv8id = parcelRequire("cv8id");

var $3nSaH = parcelRequire("3nSaH");

var $anv2i = parcelRequire("anv2i");

var $8zO6u = parcelRequire("8zO6u");

var $bAyf8 = parcelRequire("bAyf8");

var $58mAd = parcelRequire("58mAd");

var $kUZ0E = parcelRequire("kUZ0E");

var $3aSEM = parcelRequire("3aSEM");

var $bPSDe = parcelRequire("bPSDe");

var $7jCvB = parcelRequire("7jCvB");
function $1496e14448e39e61$export$4c260019440d418f(props) {
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const indentButtonRef = (0, $bSJIT.useRef)(null);
    const outdentButtonRef = (0, $bSJIT.useRef)(null);
    const { disabled: disabled, isReducedSpacing: isReducedSpacing, bulletListActive: bulletListActive, bulletListDisabled: bulletListDisabled, orderedListActive: orderedListActive, orderedListDisabled: orderedListDisabled, showIndentationButtons: showIndentationButtons, indentDisabled: indentDisabled, outdentDisabled: outdentDisabled, onItemActivated: onItemActivated, pluginInjectionApi: pluginInjectionApi } = props;
    const labelUnorderedList = formatMessage((0, $anv2i.messages).unorderedList);
    const labelOrderedList = formatMessage((0, $anv2i.messages).orderedList);
    const labelListsFormat = formatMessage((0, $anv2i.messages).listsFormat);
    const indentMessage = formatMessage((0, $3nSaH.messages).indent);
    const outdentMessage = formatMessage((0, $3nSaH.messages).outdent);
    const isIndentButtonFocused = document.activeElement === indentButtonRef.current;
    const isOutdentButtonFocused = document.activeElement === outdentButtonRef.current;
    const handleOnItemActivated = (buttonName)=>(event)=>onItemActivated({
                editorView: props.editorView,
                buttonName: buttonName
            });
    (0, $bSJIT.useEffect)(()=>{
        if (isIndentButtonFocused && indentDisabled && outdentButtonRef.current) outdentButtonRef.current.focus();
    }, [
        indentButtonRef,
        indentDisabled,
        isIndentButtonFocused
    ]);
    (0, $bSJIT.useEffect)(()=>{
        if (isOutdentButtonFocused && outdentDisabled && indentButtonRef.current) indentButtonRef.current.focus();
    }, [
        outdentButtonRef,
        outdentDisabled,
        isOutdentButtonFocused
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $bAyf8.ToolbarButtonGroup), {
        children: [
            /*#__PURE__*/ (0, $dc70d.jsxs)("div", {
                role: "group",
                "aria-label": labelListsFormat,
                children: [
                    /*#__PURE__*/ (0, $dc70d.jsx)((0, $8zO6u.default), {
                        buttonId: (0, $bnf0l.TOOLBAR_ACTION_SUBJECT_ID).BULLET_LIST,
                        testId: labelUnorderedList,
                        spacing: isReducedSpacing ? 'none' : 'default',
                        onClick: handleOnItemActivated('bullet_list'),
                        selected: bulletListActive,
                        "aria-pressed": bulletListActive,
                        "aria-label": (0, $cv8id.tooltip)((0, $cv8id.toggleBulletList), labelUnorderedList),
                        "aria-keyshortcuts": (0, $cv8id.getAriaKeyshortcuts)((0, $cv8id.toggleBulletList)),
                        disabled: bulletListDisabled || disabled,
                        title: /*#__PURE__*/ (0, $dc70d.jsx)((0, $cv8id.ToolTipContent), {
                            description: labelUnorderedList,
                            keymap: (0, $cv8id.toggleBulletList)
                        }),
                        iconBefore: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kUZ0E))), {
                            label: "",
                            color: "currentColor",
                            spacing: "spacious"
                        })
                    }),
                    /*#__PURE__*/ (0, $dc70d.jsx)((0, $8zO6u.default), {
                        buttonId: (0, $bnf0l.TOOLBAR_ACTION_SUBJECT_ID).ORDERED_LIST,
                        testId: labelOrderedList,
                        spacing: isReducedSpacing ? 'none' : 'default',
                        onClick: handleOnItemActivated('ordered_list'),
                        selected: orderedListActive,
                        "aria-pressed": orderedListActive,
                        "aria-label": (0, $cv8id.tooltip)((0, $cv8id.toggleOrderedList), labelOrderedList),
                        "aria-keyshortcuts": (0, $cv8id.getAriaKeyshortcuts)((0, $cv8id.toggleOrderedList)),
                        disabled: orderedListDisabled || disabled,
                        title: /*#__PURE__*/ (0, $dc70d.jsx)((0, $cv8id.ToolTipContent), {
                            description: labelOrderedList,
                            keymap: (0, $cv8id.toggleOrderedList)
                        }),
                        iconBefore: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3aSEM))), {
                            color: "currentColor",
                            spacing: "spacious",
                            label: ""
                        })
                    }),
                    showIndentationButtons && /*#__PURE__*/ (0, $dc70d.jsx)((0, $8zO6u.default), {
                        buttonId: (0, $bnf0l.TOOLBAR_ACTION_SUBJECT_ID).OUTDENT,
                        testId: (0, $bnf0l.TOOLBAR_ACTION_SUBJECT_ID).OUTDENT,
                        ref: outdentButtonRef,
                        spacing: isReducedSpacing ? 'none' : 'default',
                        onClick: handleOnItemActivated('outdent'),
                        iconBefore: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bPSDe))), {
                            color: "currentColor",
                            spacing: "spacious",
                            label: ""
                        }),
                        disabled: outdentDisabled || disabled,
                        "aria-label": (0, $cv8id.tooltip)((0, $cv8id.outdent), outdentMessage),
                        "aria-keyshortcuts": (0, $cv8id.getAriaKeyshortcuts)((0, $cv8id.outdent)),
                        title: /*#__PURE__*/ (0, $dc70d.jsx)((0, $cv8id.ToolTipContent), {
                            description: outdentMessage,
                            keymap: (0, $cv8id.outdent)
                        })
                    }),
                    showIndentationButtons && /*#__PURE__*/ (0, $dc70d.jsx)((0, $8zO6u.default), {
                        buttonId: (0, $bnf0l.TOOLBAR_ACTION_SUBJECT_ID).INDENT,
                        testId: (0, $bnf0l.TOOLBAR_ACTION_SUBJECT_ID).INDENT,
                        ref: indentButtonRef,
                        spacing: isReducedSpacing ? 'none' : 'default',
                        onClick: handleOnItemActivated('indent'),
                        iconBefore: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7jCvB))), {
                            color: "currentColor",
                            spacing: "spacious",
                            label: ""
                        }),
                        disabled: indentDisabled || disabled,
                        "aria-label": (0, $cv8id.tooltip)((0, $cv8id.indent), indentMessage),
                        "aria-keyshortcuts": (0, $cv8id.getAriaKeyshortcuts)((0, $cv8id.indent)),
                        title: /*#__PURE__*/ (0, $dc70d.jsx)((0, $cv8id.ToolTipContent), {
                            description: indentMessage,
                            keymap: (0, $cv8id.indent)
                        })
                    })
                ]
            }),
            !(pluginInjectionApi !== null && pluginInjectionApi !== void 0 && pluginInjectionApi.primaryToolbar) && /*#__PURE__*/ (0, $dc70d.jsx)((0, $58mAd.ToolbarSeparator), {})
        ]
    });
}

});
parcelRegister("3nSaH", function(module, exports) {
$parcel$export(module.exports, "messages", () => $4e68998bc4a2ee88$export$defe85febe8b728c);

var $f0Pt4 = parcelRequire("f0Pt4");
const $4e68998bc4a2ee88$export$defe85febe8b728c = (0, $f0Pt4.defineMessages)({
    indent: {
        id: 'fabric.editor.indent',
        defaultMessage: 'Indent',
        description: 'Indent a list item, paragraph or heading'
    },
    outdent: {
        id: 'fabric.editor.outdent',
        defaultMessage: 'Outdent',
        description: 'Outdent a list item, paragraph or heading'
    }
});

});

parcelRegister("bAyf8", function(module, exports) {
$parcel$export(module.exports, "ToolbarButtonGroup", () => $27119d8d7a578fd1$export$89cfa2b8585c6d03);
/* ButtonGroup.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $9fU1q = parcelRequire("9fU1q");
parcelRequire("bSJIT");
const $27119d8d7a578fd1$var$buttonGroupStyle = null;
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- This rule thinks this isn't a `css()` call due to the name mapping
const $27119d8d7a578fd1$var$buttonGroupStyleUnbounded = null;
function $27119d8d7a578fd1$export$89cfa2b8585c6d03({ children: children }) {
    return /*#__PURE__*/ (0, $dc70d.jsx)("span", {
        className: (0, $9fU1q.default)([
            "_zulp1b66 _1e0c116y _4cvr1h6o",
            "_sox11txw _1p8dglyw _89rs1b66"
        ]),
        children: children
    });
}

});


parcelRegister("8r8Bw", function(module, exports) {
$parcel$export(module.exports, "ToolbarDropdown", () => $4c390f8e858d3b93$export$6dea40f2cdd197ea);
/* ToolbarDropdown.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $cv8id = parcelRequire("cv8id");

var $3nSaH = parcelRequire("3nSaH");

var $anv2i = parcelRequire("anv2i");

var $cut9B = parcelRequire("cut9B");

var $fWCaV = parcelRequire("fWCaV");

var $8zO6u = parcelRequire("8zO6u");

var $9xI4S = parcelRequire("9xI4S");

var $024dl = parcelRequire("024dl");

var $hdcuV = parcelRequire("hdcuV");

var $58mAd = parcelRequire("58mAd");

var $kUZ0E = parcelRequire("kUZ0E");

var $3aSEM = parcelRequire("3aSEM");

var $bPSDe = parcelRequire("bPSDe");

var $7jCvB = parcelRequire("7jCvB");

var $797yE = parcelRequire("797yE");

var $hH6U9 = parcelRequire("hH6U9");
function $4c390f8e858d3b93$export$6dea40f2cdd197ea(props) {
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const { disabled: disabled, isReducedSpacing: isReducedSpacing, bulletListActive: bulletListActive, orderedListActive: orderedListActive, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, onItemActivated: onItemActivated, pluginInjectionApi: pluginInjectionApi } = props;
    const [isDropdownOpen, setIsDropdownOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useState(false);
    const [isOpenedByKeyboard, setOpenedByKeyboard] = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useState(false);
    const labelLists = formatMessage((0, $anv2i.messages).lists);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onOpenChange = (attrs)=>{
        setIsDropdownOpen(attrs.isDropdownOpen);
    };
    const handleTriggerClick = ()=>{
        onOpenChange({
            isDropdownOpen: !isDropdownOpen
        });
    };
    const handleOnKeyDown = (event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            setIsDropdownOpen(!isDropdownOpen);
            setOpenedByKeyboard(true);
        }
    };
    const items = $4c390f8e858d3b93$var$useItems(props);
    const handleOnItemActivated = ({ item: item, shouldCloseMenu: shouldCloseMenu = true })=>{
        setIsDropdownOpen(!shouldCloseMenu);
        return onItemActivated({
            editorView: props.editorView,
            buttonName: item.value.name
        });
    };
    const reducedSpacing = props.toolbarType === (0, $hH6U9.ToolbarType).FLOATING ? 'compact' : 'none';
    let activeListIcon = null;
    let isSelected = isDropdownOpen;
    if ((0, $797yE.editorExperiment)('platform_editor_controls', 'variant1')) activeListIcon = orderedListActive ? /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3aSEM))), {
        spacing: "spacious",
        label: ""
    }) : /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kUZ0E))), {
        spacing: "spacious",
        label: ""
    });
    else {
        activeListIcon = /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kUZ0E))), {
            color: "currentColor",
            spacing: "spacious",
            label: labelLists
        });
        isSelected = bulletListActive || orderedListActive || isDropdownOpen;
    }
    return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $024dl.ToolbarDropdownWrapper), {
        children: [
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $fWCaV.DropdownMenuWithKeyboardNavigation), {
                items: items,
                onItemActivated: handleOnItemActivated,
                mountTo: popupsMountPoint,
                boundariesElement: popupsBoundariesElement,
                scrollableElement: popupsScrollableElement,
                isOpen: isDropdownOpen,
                onOpenChange: onOpenChange,
                fitHeight: 188,
                fitWidth: 175,
                shouldUseDefaultRole: true,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                shouldFocusFirstItem: ()=>{
                    if (isOpenedByKeyboard) setOpenedByKeyboard(false);
                    return isOpenedByKeyboard;
                },
                children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $8zO6u.default), {
                    spacing: isReducedSpacing ? reducedSpacing : 'default',
                    selected: isSelected,
                    "aria-expanded": isDropdownOpen,
                    "aria-haspopup": true,
                    "aria-label": labelLists,
                    disabled: disabled,
                    onClick: handleTriggerClick,
                    onKeyDown: handleOnKeyDown,
                    title: labelLists,
                    iconBefore: /*#__PURE__*/ (0, $dc70d.jsxs)((0, $9xI4S.ToolbarDropdownTriggerWrapper), {
                        children: [
                            activeListIcon,
                            /*#__PURE__*/ (0, $dc70d.jsx)((0, $hdcuV.ToolbarExpandIcon), {})
                        ]
                    })
                })
            }),
            !(pluginInjectionApi !== null && pluginInjectionApi !== void 0 && pluginInjectionApi.primaryToolbar) && /*#__PURE__*/ (0, $dc70d.jsx)((0, $58mAd.ToolbarSeparator), {})
        ]
    });
}
function $4c390f8e858d3b93$var$useItems(props) {
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const labelUnorderedList = formatMessage((0, $anv2i.messages).unorderedList);
    const labelOrderedList = formatMessage((0, $anv2i.messages).orderedList);
    const items = [
        {
            key: 'unorderedList',
            content: labelUnorderedList,
            value: {
                name: 'bullet_list'
            },
            isDisabled: props.bulletListDisabled,
            isActive: Boolean(props.bulletListActive),
            elemAfter: /*#__PURE__*/ (0, $dc70d.jsx)((0, $cut9B.Shortcut), {
                children: (0, $cv8id.tooltip)((0, $cv8id.toggleBulletList))
            }),
            elemBefore: (0, $797yE.editorExperiment)('platform_editor_controls', 'variant1') ? /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kUZ0E))), {
                label: ""
            }) : undefined
        },
        {
            key: 'orderedList',
            content: labelOrderedList,
            value: {
                name: 'ordered_list'
            },
            isDisabled: props.orderedListDisabled,
            isActive: Boolean(props.orderedListActive),
            elemAfter: /*#__PURE__*/ (0, $dc70d.jsx)((0, $cut9B.Shortcut), {
                children: (0, $cv8id.tooltip)((0, $cv8id.toggleOrderedList))
            }),
            elemBefore: (0, $797yE.editorExperiment)('platform_editor_controls', 'variant1') ? /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3aSEM))), {
                label: ""
            }) : undefined
        }
    ];
    if (props.showIndentationButtons) {
        const labelIndent = formatMessage((0, $3nSaH.messages).indent);
        const labelOutdent = formatMessage((0, $3nSaH.messages).outdent);
        items.push({
            key: 'outdent',
            content: labelOutdent,
            value: {
                name: 'outdent'
            },
            isDisabled: props.outdentDisabled,
            isActive: false,
            elemAfter: /*#__PURE__*/ (0, $dc70d.jsx)((0, $cut9B.Shortcut), {
                children: (0, $cv8id.tooltip)((0, $cv8id.outdent))
            }),
            elemBefore: (0, $797yE.editorExperiment)('platform_editor_controls', 'variant1') ? /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bPSDe))), {
                label: ""
            }) : undefined
        }, {
            key: 'indent',
            content: labelIndent,
            value: {
                name: 'indent'
            },
            isDisabled: props.indentDisabled,
            isActive: false,
            elemAfter: /*#__PURE__*/ (0, $dc70d.jsx)((0, $cut9B.Shortcut), {
                children: (0, $cv8id.tooltip)((0, $cv8id.indent))
            }),
            elemBefore: (0, $797yE.editorExperiment)('platform_editor_controls', 'variant1') ? /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7jCvB))), {
                label: ""
            }) : undefined
        });
    }
    return [
        {
            items: items
        }
    ];
}

});

parcelRegister("3MVB1", function(module, exports) {
$parcel$export(module.exports, "getInputMethod", () => $f6206234f3244a08$export$8213a6fbfa466e73);

var $g6Qq4 = parcelRequire("g6Qq4");

var $hH6U9 = parcelRequire("hH6U9");
const $f6206234f3244a08$var$toolbarTypeToInputMethod = {
    [(0, $hH6U9.ToolbarType).PRIMARY]: (0, $g6Qq4.INPUT_METHOD).TOOLBAR,
    [(0, $hH6U9.ToolbarType).FLOATING]: (0, $g6Qq4.INPUT_METHOD).FLOATING_TB
};
const $f6206234f3244a08$export$8213a6fbfa466e73 = (toolbarType)=>$f6206234f3244a08$var$toolbarTypeToInputMethod[toolbarType];

});


parcelRegister("3I1Nh", function(module, exports) {
$parcel$export(module.exports, "FloatingToolbarComponent", () => $5cfbb598341e32dc$export$b15abb95157a91c7);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $73bnr = parcelRequire("73bnr");

var $5beht = parcelRequire("5beht");

var $797yE = parcelRequire("797yE");

var $8qTes = parcelRequire("8qTes");

var $hH6U9 = parcelRequire("hH6U9");

var $6oklh = parcelRequire("6oklh");
const $5cfbb598341e32dc$var$FloatingToolbarSettings = {
    disabled: false,
    isToolbarReducedSpacing: true,
    isSmall: true
};
function $5cfbb598341e32dc$export$b15abb95157a91c7({ featureFlags: featureFlags, editorView: editorView, showIndentationButtons: showIndentationButtons, pluginInjectionApi: pluginInjectionApi, allowHeadingAndParagraphIndentation: allowHeadingAndParagraphIndentation }) {
    var _pluginInjectionApi$l;
    const { bulletListActive: bulletListActive, bulletListDisabled: bulletListDisabled, orderedListActive: orderedListActive, orderedListDisabled: orderedListDisabled, isIndentationAllowed: isIndentationAllowed, indentDisabled: indentDisabled, outdentDisabled: outdentDisabled } = (0, $5beht.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'list',
        'indentation'
    ], (states)=>{
        var _states$listState, _states$listState2, _states$listState3, _states$listState4, _states$indentationSt, _states$indentationSt2, _states$indentationSt3, _states$listState5;
        return {
            bulletListActive: (_states$listState = states.listState) === null || _states$listState === void 0 ? void 0 : _states$listState.bulletListActive,
            bulletListDisabled: (_states$listState2 = states.listState) === null || _states$listState2 === void 0 ? void 0 : _states$listState2.bulletListDisabled,
            orderedListActive: (_states$listState3 = states.listState) === null || _states$listState3 === void 0 ? void 0 : _states$listState3.orderedListActive,
            orderedListDisabled: (_states$listState4 = states.listState) === null || _states$listState4 === void 0 ? void 0 : _states$listState4.orderedListDisabled,
            isIndentationAllowed: (_states$indentationSt = states.indentationState) === null || _states$indentationSt === void 0 ? void 0 : _states$indentationSt.isIndentationAllowed,
            indentDisabled: (_states$indentationSt2 = states.indentationState) === null || _states$indentationSt2 === void 0 ? void 0 : _states$indentationSt2.indentDisabled,
            outdentDisabled: (_states$indentationSt3 = states.indentationState) === null || _states$indentationSt3 === void 0 ? void 0 : _states$indentationSt3.outdentDisabled,
            // listStructureToken changes when a list edit could have altered indent/outdent
            // availability, which none of the flags above capture on their own
            listStructureToken: (_states$listState5 = states.listState) === null || _states$listState5 === void 0 ? void 0 : _states$listState5.listStructureToken
        };
    });
    const [taskDecisionState, setTaskDecisionState] = (0, $bSJIT.useState)();
    (0, $73bnr.usePluginStateEffect)(pluginInjectionApi, [
        'taskDecision'
    ], ({ taskDecisionState: newTaskDecisionState })=>{
        if ((newTaskDecisionState === null || newTaskDecisionState === void 0 ? void 0 : newTaskDecisionState.outdentDisabled) !== (taskDecisionState === null || taskDecisionState === void 0 ? void 0 : taskDecisionState.outdentDisabled) || (newTaskDecisionState === null || newTaskDecisionState === void 0 ? void 0 : newTaskDecisionState.indentDisabled) !== (taskDecisionState === null || taskDecisionState === void 0 ? void 0 : taskDecisionState.indentDisabled) || (newTaskDecisionState === null || newTaskDecisionState === void 0 ? void 0 : newTaskDecisionState.isInsideTask) !== (taskDecisionState === null || taskDecisionState === void 0 ? void 0 : taskDecisionState.isInsideTask)) setTaskDecisionState({
            isInsideTask: Boolean(newTaskDecisionState === null || newTaskDecisionState === void 0 ? void 0 : newTaskDecisionState.isInsideTask),
            indentDisabled: Boolean(newTaskDecisionState === null || newTaskDecisionState === void 0 ? void 0 : newTaskDecisionState.indentDisabled),
            outdentDisabled: Boolean(newTaskDecisionState === null || newTaskDecisionState === void 0 ? void 0 : newTaskDecisionState.outdentDisabled)
        });
    });
    const toolbarListsIndentationState = (0, $8qTes.getIndentationButtonsState)(editorView.state, allowHeadingAndParagraphIndentation, taskDecisionState, {
        isIndentationAllowed: isIndentationAllowed,
        indentDisabled: indentDisabled,
        outdentDisabled: outdentDisabled
    }, pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$l = pluginInjectionApi.list) === null || _pluginInjectionApi$l === void 0 ? void 0 : _pluginInjectionApi$l.actions.isInsideListItem);
    if (bulletListActive === undefined || bulletListDisabled === undefined || orderedListActive === undefined || orderedListDisabled === undefined) return null;
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $6oklh.default), {
        featureFlags: featureFlags,
        isSmall: $5cfbb598341e32dc$var$FloatingToolbarSettings.isSmall,
        isReducedSpacing: (0, $797yE.editorExperiment)('platform_editor_controls', 'variant1') ? false : $5cfbb598341e32dc$var$FloatingToolbarSettings.isToolbarReducedSpacing,
        disabled: $5cfbb598341e32dc$var$FloatingToolbarSettings.disabled,
        editorView: editorView,
        bulletListActive: bulletListActive,
        bulletListDisabled: bulletListDisabled,
        orderedListActive: orderedListActive,
        orderedListDisabled: orderedListDisabled,
        showIndentationButtons: !!showIndentationButtons,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        indentDisabled: toolbarListsIndentationState.indentDisabled,
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        outdentDisabled: toolbarListsIndentationState.outdentDisabled,
        indentationStateNode: toolbarListsIndentationState === null || toolbarListsIndentationState === void 0 ? void 0 : toolbarListsIndentationState.node,
        pluginInjectionApi: pluginInjectionApi,
        toolbarType: (0, $hH6U9.ToolbarType).FLOATING
    });
}

});

parcelRegister("gfJge", function(module, exports) {
$parcel$export(module.exports, "getToolbarComponents", () => $1cde1b06ff4cf294$export$a758406ca53b86a5);

var $34Dgx = parcelRequire("34Dgx");

var $aSbVr = parcelRequire("aSbVr");

var $7TGHB = parcelRequire("7TGHB");

var $cDydm = parcelRequire("cDydm");

var $jR7zp = parcelRequire("jR7zp");
const $1cde1b06ff4cf294$export$a758406ca53b86a5 = ({ api: api, showIndentationButtons: showIndentationButtons, allowHeadingAndParagraphIndentation: allowHeadingAndParagraphIndentation })=>{
    return [
        ...(0, $7TGHB.getListsIndentationGroupForPrimaryToolbar)(),
        ...(0, $aSbVr.getListsIndentationGroupForInlineToolbar)(),
        ...(0, $cDydm.getListsIndentationHeroButton)(api),
        ...(0, $34Dgx.getBulletedListButtonGroup)(api),
        ...(0, $jR7zp.getListsIndentationMenu)(allowHeadingAndParagraphIndentation, showIndentationButtons, api)
    ];
};

});
parcelRegister("34Dgx", function(module, exports) {
$parcel$export(module.exports, "getBulletedListButtonGroup", () => $c17cbbf966dda8fd$export$eeaae60d77808105);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $28qc1 = parcelRequire("28qc1");

var $4rzOL = parcelRequire("4rzOL");

var $fiku8 = parcelRequire("fiku8");

var $f6IUb = parcelRequire("f6IUb");

var $5gDEv = parcelRequire("5gDEv");

var $jZVH4 = parcelRequire("jZVH4");
const $c17cbbf966dda8fd$var$BulletedListButtonGroup = ({ children: children })=>{
    const { editorAppearance: editorAppearance } = (0, $28qc1.useEditorToolbar)();
    if (editorAppearance === 'full-page') return /*#__PURE__*/ (0, $dc70d.jsx)((0, $f6IUb.Show), {
        above: "xl",
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $5gDEv.ToolbarButtonGroup), {
            children: children
        })
    });
};
const $c17cbbf966dda8fd$export$eeaae60d77808105 = (api)=>{
    return [
        {
            type: (0, $4rzOL.BULLETED_LIST_BUTTON_GROUP).type,
            key: (0, $4rzOL.BULLETED_LIST_BUTTON_GROUP).key,
            parents: [
                {
                    type: (0, $4rzOL.TEXT_SECTION_PRIMARY_TOOLBAR).type,
                    key: (0, $4rzOL.TEXT_SECTION_PRIMARY_TOOLBAR).key,
                    rank: (0, $fiku8.TEXT_SECTION_PRIMARY_TOOLBAR_RANK)[(0, $4rzOL.BULLETED_LIST_BUTTON_GROUP).key]
                }
            ],
            component: ({ children: children })=>{
                return /*#__PURE__*/ (0, $dc70d.jsx)($c17cbbf966dda8fd$var$BulletedListButtonGroup, {
                    children: children
                });
            }
        },
        {
            type: (0, $4rzOL.BULLETED_LIST_BUTTON).type,
            key: (0, $4rzOL.BULLETED_LIST_BUTTON).key,
            parents: [
                {
                    type: (0, $4rzOL.BULLETED_LIST_BUTTON_GROUP).type,
                    key: (0, $4rzOL.BULLETED_LIST_BUTTON_GROUP).key,
                    rank: 100
                }
            ],
            component: ({ parents: parents })=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $jZVH4.BulletedListButton), {
                    api: api,
                    parents: parents
                })
        }
    ];
};

});
parcelRegister("jZVH4", function(module, exports) {
$parcel$export(module.exports, "BulletedListButton", () => $f2486881d0099094$export$40c1053c0d024043);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $cv8id = parcelRequire("cv8id");

var $kUZ0E = parcelRequire("kUZ0E");

var $7cgYb = parcelRequire("7cgYb");

var $eHnl8 = parcelRequire("eHnl8");

var $7JVJx = parcelRequire("7JVJx");
const $f2486881d0099094$export$40c1053c0d024043 = ({ api: api, parents: parents })=>{
    const { bulletMessage: bulletMessage, onClick: onClick, isDisabled: isDisabled, isSelected: isSelected } = (0, $7JVJx.useBulletedListInfo)({
        api: api,
        parents: parents
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $eHnl8.ToolbarTooltip), {
        content: /*#__PURE__*/ (0, $dc70d.jsx)((0, $cv8id.ToolTipContent), {
            description: bulletMessage,
            keymap: (0, $cv8id.toggleBulletList)
        }),
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $7cgYb.ToolbarButton), {
            iconBefore: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kUZ0E))), {
                size: "small",
                label: ""
            }),
            onClick: onClick,
            isSelected: isSelected,
            isDisabled: isDisabled,
            ariaKeyshortcuts: (0, $cv8id.getAriaKeyshortcuts)((0, $cv8id.toggleBulletList)),
            label: bulletMessage
        })
    });
};

});
parcelRegister("7JVJx", function(module, exports) {
$parcel$export(module.exports, "useBulletedListInfo", () => $9183b6f6f21c3ca4$export$7d7b92fab7b2082a);
$parcel$export(module.exports, "BulletedListMenuItem", () => $9183b6f6f21c3ca4$export$13c3f4610578d225);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $cv8id = parcelRequire("cv8id");

var $anv2i = parcelRequire("anv2i");

var $96hEQ = parcelRequire("96hEQ");

var $5beht = parcelRequire("5beht");

var $kUZ0E = parcelRequire("kUZ0E");

var $dbuPt = parcelRequire("dbuPt");

var $jBWM2 = parcelRequire("jBWM2");
const $9183b6f6f21c3ca4$export$7d7b92fab7b2082a = ({ api: api, parents: parents })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const bulletMessage = formatMessage((0, $anv2i.messages).bulletedList);
    const { bulletListActive: bulletListActive, bulletListDisabled: bulletListDisabled, taskListActive: taskListActive } = (0, $5beht.useSharedPluginStateWithSelector)(api, [
        'list',
        'taskDecision'
    ], (states)=>{
        var _states$listState, _states$listState2, _states$taskDecisionS;
        return {
            bulletListActive: (_states$listState = states.listState) === null || _states$listState === void 0 ? void 0 : _states$listState.bulletListActive,
            bulletListDisabled: (_states$listState2 = states.listState) === null || _states$listState2 === void 0 ? void 0 : _states$listState2.bulletListDisabled,
            taskListActive: (_states$taskDecisionS = states.taskDecisionState) === null || _states$taskDecisionS === void 0 ? void 0 : _states$taskDecisionS.isInsideTask
        };
    });
    const isDisabled = bulletListDisabled && !taskListActive;
    const onClick = ()=>{
        var _api$taskDecision;
        api === null || api === void 0 || api.core.actions.execute(taskListActive ? api === null || api === void 0 || (_api$taskDecision = api.taskDecision) === null || _api$taskDecision === void 0 ? void 0 : _api$taskDecision.commands.toggleTaskList('bulletList') : api === null || api === void 0 ? void 0 : api.list.commands.toggleBulletList((0, $96hEQ.getInputMethodFromParentKeys)(parents)));
    };
    const shortcut = (0, $cv8id.formatShortcut)((0, $cv8id.toggleBulletList));
    return {
        bulletMessage: bulletMessage,
        onClick: onClick,
        isDisabled: isDisabled,
        isSelected: bulletListActive,
        shortcut: shortcut
    };
};
const $9183b6f6f21c3ca4$export$13c3f4610578d225 = ({ api: api, parents: parents })=>{
    const { bulletMessage: bulletMessage, onClick: onClick, isDisabled: isDisabled, isSelected: isSelected, shortcut: shortcut } = $9183b6f6f21c3ca4$export$7d7b92fab7b2082a({
        api: api,
        parents: parents
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dbuPt.ToolbarDropdownItem), {
        elemBefore: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kUZ0E))), {
            size: "small",
            label: ""
        }),
        elemAfter: shortcut ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $jBWM2.ToolbarKeyboardShortcutHint), {
            shortcut: shortcut
        }) : undefined,
        isSelected: isSelected,
        isDisabled: isDisabled,
        onClick: onClick,
        ariaKeyshortcuts: shortcut,
        children: bulletMessage
    });
};

});



parcelRegister("aSbVr", function(module, exports) {
$parcel$export(module.exports, "getListsIndentationGroupForInlineToolbar", () => $fa5c4d99fe5d88be$export$ba625abe9e2ccf66);

var $4rzOL = parcelRequire("4rzOL");

var $fiku8 = parcelRequire("fiku8");
const $fa5c4d99fe5d88be$export$ba625abe9e2ccf66 = ()=>{
    return [
        {
            type: (0, $4rzOL.LISTS_INDENTATION_GROUP_INLINE).type,
            key: (0, $4rzOL.LISTS_INDENTATION_GROUP_INLINE).key,
            parents: [
                {
                    type: (0, $4rzOL.TEXT_SECTION).type,
                    key: (0, $4rzOL.TEXT_SECTION).key,
                    rank: (0, $fiku8.TEXT_SECTION_RANK)[(0, $4rzOL.LISTS_INDENTATION_GROUP).key]
                }
            ]
        }
    ];
};

});

parcelRegister("7TGHB", function(module, exports) {
$parcel$export(module.exports, "getListsIndentationGroupForPrimaryToolbar", () => $d2a4acf624859060$export$559bcfe9bd160d2a);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $28qc1 = parcelRequire("28qc1");

var $4rzOL = parcelRequire("4rzOL");

var $fiku8 = parcelRequire("fiku8");

var $f6IUb = parcelRequire("f6IUb");

var $5gDEv = parcelRequire("5gDEv");
const $d2a4acf624859060$var$ListsIndentationGroup = ({ children: children })=>{
    const { editorAppearance: editorAppearance } = (0, $28qc1.useEditorToolbar)();
    if (editorAppearance === 'full-page') return /*#__PURE__*/ (0, $dc70d.jsx)((0, $f6IUb.Show), {
        above: "xl",
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $5gDEv.ToolbarButtonGroup), {
            children: children
        })
    });
};
const $d2a4acf624859060$var$ListsIndentationGroupCollapsed = ({ children: children })=>{
    const { editorAppearance: editorAppearance } = (0, $28qc1.useEditorToolbar)();
    if (editorAppearance === 'full-page') return /*#__PURE__*/ (0, $dc70d.jsx)((0, $f6IUb.Show), {
        below: "xl",
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $5gDEv.ToolbarButtonGroup), {
            children: children
        })
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $5gDEv.ToolbarButtonGroup), {
        children: children
    });
};
const $d2a4acf624859060$export$559bcfe9bd160d2a = ()=>{
    return [
        {
            type: (0, $4rzOL.LISTS_INDENTATION_GROUP).type,
            key: (0, $4rzOL.LISTS_INDENTATION_GROUP).key,
            parents: [
                {
                    type: (0, $4rzOL.TEXT_SECTION_PRIMARY_TOOLBAR).type,
                    key: (0, $4rzOL.TEXT_SECTION_PRIMARY_TOOLBAR).key,
                    rank: (0, $fiku8.TEXT_SECTION_PRIMARY_TOOLBAR_RANK)[(0, $4rzOL.LISTS_INDENTATION_GROUP).key]
                }
            ],
            component: ({ children: children })=>{
                return /*#__PURE__*/ (0, $dc70d.jsx)($d2a4acf624859060$var$ListsIndentationGroup, {
                    children: children
                });
            }
        },
        {
            type: (0, $4rzOL.LISTS_INDENTATION_GROUP_COLLAPSED).type,
            key: (0, $4rzOL.LISTS_INDENTATION_GROUP_COLLAPSED).key,
            parents: [
                {
                    type: (0, $4rzOL.TEXT_SECTION_PRIMARY_TOOLBAR).type,
                    key: (0, $4rzOL.TEXT_SECTION_PRIMARY_TOOLBAR).key,
                    rank: (0, $fiku8.TEXT_SECTION_PRIMARY_TOOLBAR_RANK)[(0, $4rzOL.LISTS_INDENTATION_GROUP).key]
                }
            ],
            component: ({ children: children })=>{
                return /*#__PURE__*/ (0, $dc70d.jsx)($d2a4acf624859060$var$ListsIndentationGroupCollapsed, {
                    children: children
                });
            }
        }
    ];
};

});

parcelRegister("cDydm", function(module, exports) {
$parcel$export(module.exports, "getListsIndentationHeroButton", () => $c3fa4f539d0c7507$export$b917037285a1e87b);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $4rzOL = parcelRequire("4rzOL");

var $fiku8 = parcelRequire("fiku8");

var $geMI9 = parcelRequire("geMI9");
const $c3fa4f539d0c7507$export$b917037285a1e87b = (api)=>{
    return [
        {
            type: (0, $4rzOL.LISTS_INDENTATION_HERO_BUTTON).type,
            key: (0, $4rzOL.LISTS_INDENTATION_HERO_BUTTON).key,
            parents: [
                {
                    type: (0, $4rzOL.LISTS_INDENTATION_GROUP).type,
                    key: (0, $4rzOL.LISTS_INDENTATION_GROUP).key,
                    rank: (0, $fiku8.LISTS_INDENTATION_GROUP_RANK)[(0, $4rzOL.LISTS_INDENTATION_HERO_BUTTON).key]
                }
            ],
            component: ({ parents: parents })=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $geMI9.ListsIndentationHeroButtonNew), {
                    api: api,
                    parents: parents
                })
        },
        {
            type: (0, $4rzOL.LISTS_INDENTATION_HERO_BUTTON_COLLAPSED).type,
            key: (0, $4rzOL.LISTS_INDENTATION_HERO_BUTTON_COLLAPSED).key,
            parents: [
                {
                    type: (0, $4rzOL.LISTS_INDENTATION_GROUP_COLLAPSED).type,
                    key: (0, $4rzOL.LISTS_INDENTATION_GROUP_COLLAPSED).key,
                    rank: (0, $fiku8.LISTS_INDENTATION_GROUP_COLLAPSED_RANK)[(0, $4rzOL.LISTS_INDENTATION_HERO_BUTTON_COLLAPSED).key]
                },
                {
                    type: (0, $4rzOL.LISTS_INDENTATION_GROUP_INLINE).type,
                    key: (0, $4rzOL.LISTS_INDENTATION_GROUP_INLINE).key,
                    rank: (0, $fiku8.LISTS_INDENTATION_GROUP_COLLAPSED_RANK)[(0, $4rzOL.LISTS_INDENTATION_HERO_BUTTON_COLLAPSED).key]
                }
            ],
            component: ({ parents: parents })=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $geMI9.ListsIndentationHeroButtonCollapsed), {
                    api: api,
                    parents: parents
                })
        }
    ];
};

});
parcelRegister("geMI9", function(module, exports) {
$parcel$export(module.exports, "ListsIndentationHeroButtonCollapsed", () => $841dd40eaa1f3f27$export$64aac13cbedfda18);
$parcel$export(module.exports, "ListsIndentationHeroButtonNew", () => $841dd40eaa1f3f27$export$ac280cc0a77a657a);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $cv8id = parcelRequire("cv8id");

var $anv2i = parcelRequire("anv2i");

var $gvmlr = parcelRequire("gvmlr");

var $96hEQ = parcelRequire("96hEQ");

var $5beht = parcelRequire("5beht");

var $kUZ0E = parcelRequire("kUZ0E");

var $3aSEM = parcelRequire("3aSEM");

var $7cgYb = parcelRequire("7cgYb");

var $eHnl8 = parcelRequire("eHnl8");

var $4ujxi = parcelRequire("4ujxi");
function $841dd40eaa1f3f27$var$useListsIndentationHeroButtonInfo({ api: api, parents: parents, defaultListType: defaultListType }) {
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const { bulletListActive: bulletListActive, bulletListDisabled: bulletListDisabled, orderedListActive: orderedListActive, taskListActive: taskListActive } = (0, $5beht.useSharedPluginStateWithSelector)(api, [
        'list',
        'taskDecision'
    ], (states)=>{
        var _states$listState, _states$listState2, _states$listState3, _states$taskDecisionS;
        return {
            bulletListActive: (_states$listState = states.listState) === null || _states$listState === void 0 ? void 0 : _states$listState.bulletListActive,
            bulletListDisabled: (_states$listState2 = states.listState) === null || _states$listState2 === void 0 ? void 0 : _states$listState2.bulletListDisabled,
            orderedListActive: (_states$listState3 = states.listState) === null || _states$listState3 === void 0 ? void 0 : _states$listState3.orderedListActive,
            taskListActive: (_states$taskDecisionS = states.taskDecisionState) === null || _states$taskDecisionS === void 0 ? void 0 : _states$taskDecisionS.isInsideTask
        };
    });
    const getListType = taskListActive ? 'taskList' : orderedListActive ? 'orderedList' : defaultListType;
    const taskListKeymap = (0, $cv8id.toggleTaskList);
    const getKeymap = getListType === 'taskList' ? taskListKeymap : getListType === 'orderedList' ? (0, $cv8id.toggleOrderedList) : (0, $cv8id.toggleBulletList);
    const shortcut = (0, $cv8id.formatShortcut)(getKeymap);
    const keymap = getKeymap;
    const message = getListType === 'taskList' ? formatMessage((0, $gvmlr.tasksAndDecisionsMessages).taskList) : getListType === 'orderedList' ? formatMessage((0, $anv2i.messages).orderedList) : formatMessage((0, $anv2i.messages).bulletedList);
    const onClick = ()=>{
        const inputMethod = (0, $96hEQ.getInputMethodFromParentKeys)(parents);
        if (getListType === 'taskList') {
            var _api$taskDecision;
            api === null || api === void 0 || api.core.actions.execute(api === null || api === void 0 || (_api$taskDecision = api.taskDecision) === null || _api$taskDecision === void 0 ? void 0 : _api$taskDecision.commands.toggleTaskList());
        } else if (getListType === 'orderedList') api === null || api === void 0 || api.core.actions.execute(api === null || api === void 0 ? void 0 : api.list.commands.toggleOrderedList(inputMethod));
        else api === null || api === void 0 || api.core.actions.execute(api === null || api === void 0 ? void 0 : api.list.commands.toggleBulletList(inputMethod));
    };
    const iconBefore = getListType === 'taskList' ? /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4ujxi))), {
        label: formatMessage((0, $gvmlr.tasksAndDecisionsMessages).taskList),
        size: "small"
    }) : getListType === 'orderedList' ? /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3aSEM))), {
        label: formatMessage((0, $anv2i.messages).orderedList),
        size: "small"
    }) : /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kUZ0E))), {
        label: formatMessage((0, $anv2i.messages).bulletedList),
        size: "small"
    });
    const isSelected = getListType === 'bulletList' ? bulletListActive : getListType === 'orderedList' ? orderedListActive : taskListActive;
    const isDisabled = !orderedListActive && !taskListActive && bulletListDisabled;
    return {
        shortcut: shortcut,
        keymap: keymap,
        message: message,
        onClick: onClick,
        iconBefore: iconBefore,
        isSelected: isSelected,
        isDisabled: isDisabled
    };
}
const $841dd40eaa1f3f27$export$64aac13cbedfda18 = ({ api: api, parents: parents })=>{
    const { shortcut: shortcut, keymap: keymap, message: message, onClick: onClick, iconBefore: iconBefore, isSelected: isSelected, isDisabled: isDisabled } = $841dd40eaa1f3f27$var$useListsIndentationHeroButtonInfo({
        api: api,
        parents: parents,
        defaultListType: 'bulletList'
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $eHnl8.ToolbarTooltip), {
        content: /*#__PURE__*/ (0, $dc70d.jsx)((0, $cv8id.ToolTipContent), {
            description: message,
            keymap: keymap
        }),
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $7cgYb.ToolbarButton), {
            iconBefore: iconBefore,
            isSelected: isSelected,
            isDisabled: isDisabled,
            ariaKeyshortcuts: shortcut,
            onClick: onClick
        })
    });
};
const $841dd40eaa1f3f27$export$ac280cc0a77a657a = ({ api: api, parents: parents })=>{
    const { shortcut: shortcut, keymap: keymap, message: message, onClick: onClick, iconBefore: iconBefore, isSelected: isSelected, isDisabled: isDisabled } = $841dd40eaa1f3f27$var$useListsIndentationHeroButtonInfo({
        api: api,
        parents: parents,
        defaultListType: 'orderedList'
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $eHnl8.ToolbarTooltip), {
        content: /*#__PURE__*/ (0, $dc70d.jsx)((0, $cv8id.ToolTipContent), {
            description: message,
            keymap: keymap
        }),
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $7cgYb.ToolbarButton), {
            iconBefore: iconBefore,
            isSelected: isSelected,
            isDisabled: isDisabled,
            ariaKeyshortcuts: shortcut,
            onClick: onClick
        })
    });
};
const $841dd40eaa1f3f27$export$a7640af50de0f233 = ({ api: api, parents: parents })=>{
    const { shortcut: shortcut, message: message, onClick: onClick, iconBefore: iconBefore, isSelected: isSelected, isDisabled: isDisabled } = $841dd40eaa1f3f27$var$useListsIndentationHeroButtonInfo({
        api: api,
        parents: parents,
        defaultListType: 'bulletList'
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $eHnl8.ToolbarTooltip), {
        content: message,
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $7cgYb.ToolbarButton), {
            iconBefore: iconBefore,
            isSelected: isSelected,
            isDisabled: isDisabled,
            ariaKeyshortcuts: shortcut,
            onClick: onClick
        })
    });
};

});


parcelRegister("jR7zp", function(module, exports) {
$parcel$export(module.exports, "getListsIndentationMenu", () => $765e5b35f471ccea$export$9c70fcf7cde6c956);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $4rzOL = parcelRequire("4rzOL");

var $fiku8 = parcelRequire("fiku8");

var $7JVJx = parcelRequire("7JVJx");

var $jAfHP = parcelRequire("jAfHP");

var $8PAY3 = parcelRequire("8PAY3");

var $kr3cx = parcelRequire("kr3cx");

var $7mnzH = parcelRequire("7mnzH");

var $1tIcR = parcelRequire("1tIcR");
const $765e5b35f471ccea$export$9c70fcf7cde6c956 = (allowHeadingAndParagraphIndentation, showIndentationButtons, api)=>{
    return [
        {
            type: (0, $4rzOL.LISTS_INDENTATION_MENU).type,
            key: (0, $4rzOL.LISTS_INDENTATION_MENU).key,
            parents: [
                {
                    type: (0, $4rzOL.LISTS_INDENTATION_GROUP).type,
                    key: (0, $4rzOL.LISTS_INDENTATION_GROUP).key,
                    rank: (0, $fiku8.LISTS_INDENTATION_GROUP_RANK)[(0, $4rzOL.LISTS_INDENTATION_MENU).key]
                },
                {
                    type: (0, $4rzOL.LISTS_INDENTATION_GROUP_COLLAPSED).type,
                    key: (0, $4rzOL.LISTS_INDENTATION_GROUP_COLLAPSED).key,
                    rank: (0, $fiku8.LISTS_INDENTATION_GROUP_COLLAPSED_RANK)[(0, $4rzOL.LISTS_INDENTATION_MENU).key]
                },
                {
                    type: (0, $4rzOL.LISTS_INDENTATION_GROUP_INLINE).type,
                    key: (0, $4rzOL.LISTS_INDENTATION_GROUP_INLINE).key,
                    rank: (0, $fiku8.LISTS_INDENTATION_GROUP_COLLAPSED_RANK)[(0, $4rzOL.LISTS_INDENTATION_MENU).key]
                }
            ],
            component: ({ children: children })=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $8PAY3.ListsIndentationMenu), {
                    api: api,
                    allowHeadingAndParagraphIndentation: allowHeadingAndParagraphIndentation,
                    children: children
                })
        },
        {
            type: (0, $4rzOL.LISTS_INDENTATION_MENU_SECTION).type,
            key: (0, $4rzOL.LISTS_INDENTATION_MENU_SECTION).key,
            parents: [
                {
                    type: (0, $4rzOL.LISTS_INDENTATION_MENU).type,
                    key: (0, $4rzOL.LISTS_INDENTATION_MENU).key,
                    rank: (0, $fiku8.LISTS_INDENTATION_MENU_RANK)[(0, $4rzOL.LISTS_INDENTATION_MENU_SECTION).key]
                },
                {
                    type: (0, $4rzOL.TEXT_COLLAPSED_MENU).type,
                    key: (0, $4rzOL.TEXT_COLLAPSED_MENU).key,
                    rank: (0, $fiku8.TEXT_COLLAPSED_MENU_RANK)[(0, $4rzOL.LISTS_INDENTATION_MENU_SECTION).key]
                }
            ],
            component: (0, $kr3cx.MenuSection)
        },
        {
            type: (0, $4rzOL.BULLETED_LIST_MENU_ITEM).type,
            key: (0, $4rzOL.BULLETED_LIST_MENU_ITEM).key,
            parents: [
                {
                    type: (0, $4rzOL.LISTS_INDENTATION_MENU_SECTION).type,
                    key: (0, $4rzOL.LISTS_INDENTATION_MENU_SECTION).key,
                    rank: (0, $fiku8.LISTS_INDENTATION_MENU_SECTION_RANK)[(0, $4rzOL.BULLETED_LIST_MENU_ITEM).key]
                }
            ],
            component: ({ parents: parents })=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $7JVJx.BulletedListMenuItem), {
                    api: api,
                    parents: parents
                })
        },
        {
            type: (0, $4rzOL.NUMBERED_LIST_MENU_ITEM).type,
            key: (0, $4rzOL.NUMBERED_LIST_MENU_ITEM).key,
            parents: [
                {
                    type: (0, $4rzOL.LISTS_INDENTATION_MENU_SECTION).type,
                    key: (0, $4rzOL.LISTS_INDENTATION_MENU_SECTION).key,
                    rank: (0, $fiku8.LISTS_INDENTATION_MENU_SECTION_RANK)[(0, $4rzOL.NUMBERED_LIST_MENU_ITEM).key]
                }
            ],
            component: ({ parents: parents })=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $7mnzH.NumberedListMenuItem), {
                    api: api,
                    parents: parents
                })
        },
        {
            type: (0, $4rzOL.OUTDENT_MENU_ITEM).type,
            key: (0, $4rzOL.OUTDENT_MENU_ITEM).key,
            parents: [
                {
                    type: (0, $4rzOL.LISTS_INDENTATION_MENU_SECTION).type,
                    key: (0, $4rzOL.LISTS_INDENTATION_MENU_SECTION).key,
                    rank: (0, $fiku8.LISTS_INDENTATION_MENU_SECTION_RANK)[(0, $4rzOL.OUTDENT_MENU_ITEM).key]
                }
            ],
            component: ({ parents: parents })=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $1tIcR.OutdentMenuItem), {
                    api: api,
                    allowHeadingAndParagraphIndentation: allowHeadingAndParagraphIndentation,
                    showIndentationButtons: showIndentationButtons,
                    parents: parents
                })
        },
        {
            type: (0, $4rzOL.INDENT_MENU_ITEM).type,
            key: (0, $4rzOL.INDENT_MENU_ITEM).key,
            parents: [
                {
                    type: (0, $4rzOL.LISTS_INDENTATION_MENU_SECTION).type,
                    key: (0, $4rzOL.LISTS_INDENTATION_MENU_SECTION).key,
                    rank: (0, $fiku8.LISTS_INDENTATION_MENU_SECTION_RANK)[(0, $4rzOL.INDENT_MENU_ITEM).key]
                }
            ],
            component: ({ parents: parents })=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $jAfHP.IndentMenuItem), {
                    api: api,
                    allowHeadingAndParagraphIndentation: allowHeadingAndParagraphIndentation,
                    showIndentationButtons: showIndentationButtons,
                    parents: parents
                })
        }
    ];
};

});
parcelRegister("jAfHP", function(module, exports) {
$parcel$export(module.exports, "IndentMenuItem", () => $815bbfe69198583d$export$fdc3a713c0f7f7e);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $cv8id = parcelRequire("cv8id");

var $3nSaH = parcelRequire("3nSaH");

var $96hEQ = parcelRequire("96hEQ");

var $28qc1 = parcelRequire("28qc1");

var $7jCvB = parcelRequire("7jCvB");

var $dbuPt = parcelRequire("dbuPt");

var $jBWM2 = parcelRequire("jBWM2");

var $aMQPG = parcelRequire("aMQPG");
const $815bbfe69198583d$export$fdc3a713c0f7f7e = ({ api: api, showIndentationButtons: showIndentationButtons, allowHeadingAndParagraphIndentation: allowHeadingAndParagraphIndentation, parents: parents })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const { editorView: editorView } = (0, $28qc1.useEditorToolbar)();
    const indentationState = (0, $aMQPG.useIndentationState)({
        api: api,
        allowHeadingAndParagraphIndentation: allowHeadingAndParagraphIndentation,
        state: editorView === null || editorView === void 0 ? void 0 : editorView.state
    });
    if (!showIndentationButtons) return null;
    const onClick = ()=>{
        const inputMethod = (0, $96hEQ.getInputMethodFromParentKeys)(parents);
        const node = indentationState === null || indentationState === void 0 ? void 0 : indentationState.node;
        if (node === 'paragraph_heading') {
            if (editorView !== null && editorView !== void 0 && editorView.state) {
                var _api$indentation;
                api === null || api === void 0 || (_api$indentation = api.indentation) === null || _api$indentation === void 0 || _api$indentation.actions.indentParagraphOrHeading(inputMethod)(editorView === null || editorView === void 0 ? void 0 : editorView.state, editorView === null || editorView === void 0 ? void 0 : editorView.dispatch);
            }
        }
        if (node === 'list') {
            var _api$core, _api$list;
            api === null || api === void 0 || (_api$core = api.core) === null || _api$core === void 0 || _api$core.actions.execute(api === null || api === void 0 || (_api$list = api.list) === null || _api$list === void 0 ? void 0 : _api$list.commands.indentList(inputMethod));
        }
        if (node === 'taskList') {
            if (editorView !== null && editorView !== void 0 && editorView.state) {
                var _api$taskDecision;
                api === null || api === void 0 || (_api$taskDecision = api.taskDecision) === null || _api$taskDecision === void 0 || _api$taskDecision.actions.indentTaskList(inputMethod)(editorView === null || editorView === void 0 ? void 0 : editorView.state, editorView === null || editorView === void 0 ? void 0 : editorView.dispatch);
            }
        }
    };
    const shortcut = (0, $cv8id.formatShortcut)((0, $cv8id.indent));
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dbuPt.ToolbarDropdownItem), {
        elemBefore: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7jCvB))), {
            size: "small",
            label: ""
        }),
        elemAfter: shortcut ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $jBWM2.ToolbarKeyboardShortcutHint), {
            shortcut: shortcut
        }) : undefined,
        isDisabled: indentationState === null || indentationState === void 0 ? void 0 : indentationState.indentDisabled,
        ariaKeyshortcuts: shortcut,
        onClick: onClick,
        children: formatMessage((0, $3nSaH.messages).indent)
    });
};

});
parcelRegister("aMQPG", function(module, exports) {
$parcel$export(module.exports, "useIndentationState", () => $85da00d2c8779c7b$export$738f7a376e7e29b3);

var $5beht = parcelRequire("5beht");

var $8qTes = parcelRequire("8qTes");
const $85da00d2c8779c7b$export$738f7a376e7e29b3 = ({ api: api, allowHeadingAndParagraphIndentation: allowHeadingAndParagraphIndentation, state: state })=>{
    const { isIndentationAllowed: isIndentationAllowed, indentDisabled: indentDisabled, outdentDisabled: outdentDisabled } = (0, $5beht.useSharedPluginStateWithSelector)(api, [
        'indentation'
    ], (states)=>{
        var _states$indentationSt, _states$indentationSt2, _states$indentationSt3;
        return {
            isIndentationAllowed: (_states$indentationSt = states.indentationState) === null || _states$indentationSt === void 0 ? void 0 : _states$indentationSt.isIndentationAllowed,
            outdentDisabled: (_states$indentationSt2 = states.indentationState) === null || _states$indentationSt2 === void 0 ? void 0 : _states$indentationSt2.outdentDisabled,
            indentDisabled: (_states$indentationSt3 = states.indentationState) === null || _states$indentationSt3 === void 0 ? void 0 : _states$indentationSt3.indentDisabled
        };
    });
    const { isInsideTask: isInsideTask, indentDisabled: taskIndentDisabled, outdentDisabled: taskOutdentDisabled } = (0, $5beht.useSharedPluginStateWithSelector)(api, [
        'taskDecision'
    ], (states)=>{
        var _states$taskDecisionS, _states$taskDecisionS2, _states$taskDecisionS3;
        return {
            isInsideTask: (_states$taskDecisionS = states.taskDecisionState) === null || _states$taskDecisionS === void 0 ? void 0 : _states$taskDecisionS.isInsideTask,
            outdentDisabled: (_states$taskDecisionS2 = states.taskDecisionState) === null || _states$taskDecisionS2 === void 0 ? void 0 : _states$taskDecisionS2.outdentDisabled,
            indentDisabled: (_states$taskDecisionS3 = states.taskDecisionState) === null || _states$taskDecisionS3 === void 0 ? void 0 : _states$taskDecisionS3.indentDisabled
        };
    });
    if (!state) return undefined;
    return (0, $8qTes.getIndentationButtonsState)(state, allowHeadingAndParagraphIndentation, {
        isInsideTask: isInsideTask ?? false,
        indentDisabled: taskIndentDisabled ?? false,
        outdentDisabled: taskOutdentDisabled ?? false
    }, {
        isIndentationAllowed: isIndentationAllowed,
        indentDisabled: indentDisabled,
        outdentDisabled: outdentDisabled
    }, api === null || api === void 0 ? void 0 : api.list.actions.isInsideListItem);
};

});


parcelRegister("8PAY3", function(module, exports) {
$parcel$export(module.exports, "ListsIndentationMenu", () => $29cdd9d43bd49f01$export$4f71a14292bb825f);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $6xNT1 = parcelRequire("6xNT1");

var $28qc1 = parcelRequire("28qc1");

var $5beht = parcelRequire("5beht");

var $11XBj = parcelRequire("11XBj");

var $6PDfA = parcelRequire("6PDfA");

var $eHnl8 = parcelRequire("eHnl8");

var $aMQPG = parcelRequire("aMQPG");
const $29cdd9d43bd49f01$export$4f71a14292bb825f = ({ children: children, api: api, allowHeadingAndParagraphIndentation: allowHeadingAndParagraphIndentation })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const { editorView: editorView } = (0, $28qc1.useEditorToolbar)();
    const indentationState = (0, $aMQPG.useIndentationState)({
        api: api,
        allowHeadingAndParagraphIndentation: allowHeadingAndParagraphIndentation,
        state: editorView === null || editorView === void 0 ? void 0 : editorView.state
    });
    const { bulletListDisabled: bulletListDisabled, orderedListDisabled: orderedListDisabled, taskListActive: taskListActive } = (0, $5beht.useSharedPluginStateWithSelector)(api, [
        'list',
        'taskDecision'
    ], (states)=>{
        var _states$listState, _states$listState2, _states$taskDecisionS;
        return {
            bulletListDisabled: (_states$listState = states.listState) === null || _states$listState === void 0 ? void 0 : _states$listState.bulletListDisabled,
            orderedListDisabled: (_states$listState2 = states.listState) === null || _states$listState2 === void 0 ? void 0 : _states$listState2.orderedListDisabled,
            taskListActive: (_states$taskDecisionS = states.taskDecisionState) === null || _states$taskDecisionS === void 0 ? void 0 : _states$taskDecisionS.isInsideTask
        };
    });
    const allItemsDisabled = bulletListDisabled && orderedListDisabled && (indentationState === null || indentationState === void 0 ? void 0 : indentationState.indentDisabled) && (indentationState === null || indentationState === void 0 ? void 0 : indentationState.outdentDisabled) && !taskListActive;
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $6PDfA.ToolbarDropdownMenu), {
        iconBefore: /*#__PURE__*/ (0, $dc70d.jsx)((0, $11XBj.MoreItemsIcon), {
            label: formatMessage((0, $6xNT1.messages).lists)
        }),
        isDisabled: allItemsDisabled,
        testId: "editor-toolbar__lists-and-indentation-menu",
        label: formatMessage((0, $6xNT1.messages).lists),
        tooltipComponent: /*#__PURE__*/ (0, $dc70d.jsx)((0, $eHnl8.ToolbarTooltip), {
            content: formatMessage((0, $6xNT1.messages).lists)
        }),
        children: children
    });
};

});
parcelRegister("6xNT1", function(module, exports) {
$parcel$export(module.exports, "messages", () => $e35895a1937affdc$export$defe85febe8b728c);
// Common Translations will live here

var $f0Pt4 = parcelRequire("f0Pt4");
const $e35895a1937affdc$export$defe85febe8b728c = (0, $f0Pt4.defineMessages)({
    unorderedList: {
        id: 'fabric.editor.unorderedList',
        defaultMessage: 'Bullet list',
        description: "A list with bullets. Also known as an \u201Cunordered\u201D list"
    },
    unorderedListDescription: {
        id: 'fabric.editor.unorderedList.description',
        defaultMessage: 'Create an unordered list',
        description: 'The text is shown as a description for the bullet list option in the quick insert menu when the user searches for list formatting options.'
    },
    orderedList: {
        id: 'fabric.editor.orderedList',
        defaultMessage: 'Numbered list',
        description: 'The text is shown as the label for the numbered list option in the editor toolbar or menu, allowing the user to insert a sequentially numbered list into their document.'
    },
    orderedListDescription: {
        id: 'fabric.editor.orderedList.description',
        defaultMessage: 'Create an ordered list',
        description: 'The text is shown as a description for the numbered list option in the quick insert menu when the user searches for list formatting options.'
    },
    lists: {
        id: 'fabric.editor.lists',
        defaultMessage: 'Lists',
        description: 'Menu shows ordered/bullet list and unordered/numbered lists'
    }
});

});


parcelRegister("kr3cx", function(module, exports) {
$parcel$export(module.exports, "MenuSection", () => $a36c452e436063a7$export$4b1545b4f2016d26);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $4rzOL = parcelRequire("4rzOL");

var $dlk6h = parcelRequire("dlk6h");
const $a36c452e436063a7$export$4b1545b4f2016d26 = ({ children: children, title: title, parents: parents })=>{
    const hasSeparator = parents.some((parent)=>parent.key === (0, $4rzOL.TEXT_COLLAPSED_MENU).key);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dlk6h.ToolbarDropdownItemSection), {
        hasSeparator: hasSeparator,
        title: title,
        children: children
    });
};

});

parcelRegister("7mnzH", function(module, exports) {
$parcel$export(module.exports, "NumberedListMenuItem", () => $2e36278f71d65849$export$248224347373862f);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $cv8id = parcelRequire("cv8id");

var $anv2i = parcelRequire("anv2i");

var $96hEQ = parcelRequire("96hEQ");

var $5beht = parcelRequire("5beht");

var $3aSEM = parcelRequire("3aSEM");

var $dbuPt = parcelRequire("dbuPt");

var $jBWM2 = parcelRequire("jBWM2");
const $2e36278f71d65849$export$248224347373862f = ({ api: api, parents: parents })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const { orderedListActive: orderedListActive, orderedListDisabled: orderedListDisabled, taskListActive: taskListActive } = (0, $5beht.useSharedPluginStateWithSelector)(api, [
        'list',
        'taskDecision'
    ], (states)=>{
        var _states$listState, _states$listState2, _states$taskDecisionS;
        return {
            orderedListActive: (_states$listState = states.listState) === null || _states$listState === void 0 ? void 0 : _states$listState.orderedListActive,
            orderedListDisabled: (_states$listState2 = states.listState) === null || _states$listState2 === void 0 ? void 0 : _states$listState2.orderedListDisabled,
            taskListActive: (_states$taskDecisionS = states.taskDecisionState) === null || _states$taskDecisionS === void 0 ? void 0 : _states$taskDecisionS.isInsideTask
        };
    });
    const onClick = ()=>{
        var _api$taskDecision;
        api === null || api === void 0 || api.core.actions.execute(taskListActive ? api === null || api === void 0 || (_api$taskDecision = api.taskDecision) === null || _api$taskDecision === void 0 ? void 0 : _api$taskDecision.commands.toggleTaskList('orderedList') : api === null || api === void 0 ? void 0 : api.list.commands.toggleOrderedList((0, $96hEQ.getInputMethodFromParentKeys)(parents)));
    };
    const shortcut = (0, $cv8id.formatShortcut)((0, $cv8id.toggleOrderedList));
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dbuPt.ToolbarDropdownItem), {
        elemBefore: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3aSEM))), {
            size: "small",
            label: ""
        }),
        elemAfter: shortcut ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $jBWM2.ToolbarKeyboardShortcutHint), {
            shortcut: shortcut
        }) : undefined,
        isSelected: orderedListActive,
        isDisabled: orderedListDisabled && !taskListActive,
        onClick: onClick,
        ariaKeyshortcuts: shortcut,
        children: formatMessage((0, $anv2i.messages).orderedList)
    });
};

});

parcelRegister("1tIcR", function(module, exports) {
$parcel$export(module.exports, "OutdentMenuItem", () => $a165dbca476ea117$export$549a24252ad8d94);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $cv8id = parcelRequire("cv8id");

var $3nSaH = parcelRequire("3nSaH");

var $96hEQ = parcelRequire("96hEQ");

var $28qc1 = parcelRequire("28qc1");

var $bPSDe = parcelRequire("bPSDe");

var $dbuPt = parcelRequire("dbuPt");

var $jBWM2 = parcelRequire("jBWM2");

var $aMQPG = parcelRequire("aMQPG");
const $a165dbca476ea117$export$549a24252ad8d94 = ({ api: api, allowHeadingAndParagraphIndentation: allowHeadingAndParagraphIndentation, showIndentationButtons: showIndentationButtons, parents: parents })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const { editorView: editorView } = (0, $28qc1.useEditorToolbar)();
    const indentationState = (0, $aMQPG.useIndentationState)({
        api: api,
        allowHeadingAndParagraphIndentation: allowHeadingAndParagraphIndentation,
        state: editorView === null || editorView === void 0 ? void 0 : editorView.state
    });
    if (!showIndentationButtons) return null;
    const onClick = ()=>{
        const inputMethod = (0, $96hEQ.getInputMethodFromParentKeys)(parents);
        const node = indentationState === null || indentationState === void 0 ? void 0 : indentationState.node;
        if (node === 'paragraph_heading') {
            if (editorView !== null && editorView !== void 0 && editorView.state) {
                var _api$indentation;
                api === null || api === void 0 || (_api$indentation = api.indentation) === null || _api$indentation === void 0 || _api$indentation.actions.outdentParagraphOrHeading(inputMethod)(editorView === null || editorView === void 0 ? void 0 : editorView.state, editorView === null || editorView === void 0 ? void 0 : editorView.dispatch);
            }
        }
        if (node === 'list') api === null || api === void 0 || api.core.actions.execute(api === null || api === void 0 ? void 0 : api.list.commands.outdentList(inputMethod));
        if (node === 'taskList') {
            if (editorView !== null && editorView !== void 0 && editorView.state) {
                var _api$taskDecision;
                api === null || api === void 0 || (_api$taskDecision = api.taskDecision) === null || _api$taskDecision === void 0 || _api$taskDecision.actions.outdentTaskList(inputMethod)(editorView === null || editorView === void 0 ? void 0 : editorView.state, editorView === null || editorView === void 0 ? void 0 : editorView.dispatch);
            }
        }
    };
    const shortcut = (0, $cv8id.formatShortcut)((0, $cv8id.outdent));
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dbuPt.ToolbarDropdownItem), {
        elemBefore: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bPSDe))), {
            size: "small",
            label: ""
        }),
        elemAfter: shortcut ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $jBWM2.ToolbarKeyboardShortcutHint), {
            shortcut: shortcut
        }) : undefined,
        isDisabled: indentationState === null || indentationState === void 0 ? void 0 : indentationState.outdentDisabled,
        ariaKeyshortcuts: shortcut,
        onClick: onClick,
        children: formatMessage((0, $3nSaH.messages).outdent)
    });
};

});




parcelRegister("hU8M0", function(module, exports) {
$parcel$export(module.exports, "EditorPresetBuilder", () => $5a78359739eb92b2$export$dab03ba05a79e5c7);

var $5N1Y4 = parcelRequire("5N1Y4");

var $eXGEf = parcelRequire("eXGEf");
class $5a78359739eb92b2$export$dab03ba05a79e5c7 {
    constructor(...more){
        this.apiEmitter = ()=>{};
        this.safeEntry = (plugin)=>Array.isArray(plugin) ? plugin : [
                plugin,
                undefined
            ];
        // @ts-ignore - TS2872 TypeScript 5.9.2 upgrade
        this.data = [
            ...more
        ];
        this.apiPromise = new Promise((r)=>this.resolver = r);
        this.apiResolver = new $5a78359739eb92b2$var$APIDispatcher((emitter)=>this.apiEmitter = emitter);
    }
    add(nextOrTuple) {
        return new $5a78359739eb92b2$export$dab03ba05a79e5c7(/**
     * re-cast this to NewPlugin as we've done all the type
     * safety, dependency checking, narrowing, during
     * `SafePresetCheck & VerifyPluginDependencies`
     */ nextOrTuple, ...this.data);
    }
    maybeAdd(pluginToAdd, shouldAdd) {
        const pluginOrBuilder = typeof shouldAdd === 'function' ? // @ts-expect-error Argument of type 'SafePresetCheck<ToAddPlugin, StackPlugins>' is not assignable to parameter of type 'ToAddPlugin'.
        shouldAdd(pluginToAdd, this) : shouldAdd;
        if (pluginOrBuilder instanceof $5a78359739eb92b2$export$dab03ba05a79e5c7) return pluginOrBuilder;
        const nextPluginStack = [
            /**
     * re-cast this to NewPlugin as we've done all the type
     * safety, dependency checking, narrowing, during
     * `SafePresetCheck & VerifyPluginDependencies`
     */ pluginOrBuilder ? pluginToAdd : undefined,
            ...this.data
        ];
        const nextEditorPresetBuilder = new $5a78359739eb92b2$export$dab03ba05a79e5c7(...nextPluginStack);
        return nextEditorPresetBuilder;
    }
    has(plugin) {
        return this.data.some((pluginPreset)=>{
            if (Array.isArray(pluginPreset)) return pluginPreset[0] === plugin;
            return pluginPreset === plugin;
        });
    }
    build({ pluginInjectionAPI: pluginInjectionAPI, excludePlugins: maybeExcludePlugins } = {}) {
        const excludePlugins = new Set(maybeExcludePlugins ? maybeExcludePlugins : []);
        const editorPlugins = this.processEditorPlugins({
            pluginInjectionAPI: pluginInjectionAPI,
            excludePlugins: excludePlugins
        });
        if (pluginInjectionAPI) {
            var _this$resolver;
            // The pluginInjectionAPI API doesn't have information enough to build a proper type for the API.
            // It is returning a generic type but on top of the Proxy system
            // So, we can safely recast it here
            this.apiEmitter(pluginInjectionAPI.api());
            // Deprecated approach
            (_this$resolver = this.resolver) === null || _this$resolver === void 0 || _this$resolver.call(this, pluginInjectionAPI.api());
        }
        return this.removeExcludedPlugins(editorPlugins, excludePlugins);
    }
    verifyDuplicatedPlugins() {
        const cache = new Set();
        this.data.filter(Boolean).forEach((pluginEntry)=>{
            const [pluginFn, _] = Array.isArray(pluginEntry) ? pluginEntry : [
                pluginEntry,
                undefined
            ];
            if (cache.has(pluginFn)) throw new Error(`${pluginFn} is already included!`);
            cache.add(pluginFn);
        });
        return true;
    }
    processEditorPlugins({ pluginInjectionAPI: pluginInjectionAPI, excludePlugins: excludePlugins }) {
        this.verifyDuplicatedPlugins();
        const seen = new Set();
        const pluginsDataCopy = this.data.slice();
        const plugins = pluginsDataCopy.reverse().filter(Boolean).map((entry)=>{
            const [fn, config] = this.safeEntry(entry);
            if (seen.has(fn)) return null;
            seen.add(fn);
            if (typeof fn !== 'function') return null;
            let plugin;
            if ((0, $5N1Y4.expValEquals)('platform_editor_improve_preset_builder_logging', 'isEnabled', true)) try {
                plugin = pluginInjectionAPI ? fn({
                    config: config,
                    api: pluginInjectionAPI.api()
                }) : fn({
                    config: config
                });
            } catch (error) {
                const pluginName = fn.name || 'unknown';
                const enhancedError = error instanceof Error ? new Error(`Failed to initialize plugin '${pluginName}': ${error.message}`) : new Error(`Failed to initialize plugin '${pluginName}'`);
                throw enhancedError;
            }
            else plugin = pluginInjectionAPI ? fn({
                config: config,
                api: pluginInjectionAPI.api()
            }) : fn({
                config: config
            });
            if (plugin && excludePlugins !== null && excludePlugins !== void 0 && excludePlugins.has(plugin.name)) return null;
            if (!pluginInjectionAPI) return plugin;
            pluginInjectionAPI.onEditorPluginInitialized(plugin);
            return plugin;
        }).filter(Boolean);
        return plugins;
    }
    removeExcludedPlugins(plugins, excludes) {
        if (excludes) return plugins.filter((plugin)=>!plugin || !excludes.has(plugin.name));
        return plugins;
    }
}
/**
 * WARNING: Internal object
 *
 * Dedicated wrapper around EventDispatcher for public API around the editor API.
 * This only has the public method `on` which is used to listen to updates to the editor API.
 *
 * This shouldn't really be used externally - the `editorAPI` should be accessed via `usePreset`.
 */ class $5a78359739eb92b2$var$APIDispatcher {
    constructor(emitter){
        this.emitter = emitter;
        this.eventDispatcher = new (0, $eXGEf.EventDispatcher)();
        this.key = 'api-resolved-event';
        // Need to store the last event created in case we subscribe after the fact
        this.initialEvent = undefined;
        this.emitter((v)=>{
            this.initialEvent = v;
            this.eventDispatcher.emit(this.key, v);
        });
    }
    /**
   * Used to observe Editor API events
   *
   * @param cb Callback to listen to the editor API.
   * This will also emit the last event if the stream has already started.
   * @returns Cleanup function to cleanup the listener
   */ on(cb) {
        if (this.initialEvent !== undefined) // Keeps timing consistent with old approach - certain products
        // ie. ai-mate relied on this.
        Promise.resolve().then(()=>cb(this.initialEvent));
        this.eventDispatcher.on(this.key, cb);
        return ()=>{
            this.eventDispatcher.off(this.key, cb);
        };
    }
    destroy() {
        this.eventDispatcher.destroy();
    }
}

});

parcelRegister("9PC0M", function(module, exports) {
$parcel$export(module.exports, "userPreferencesPlugin", () => $26077f8f4a0cb6f1$export$b2ef360f69e1145b);

var $4F1Uz = parcelRequire("4F1Uz");

var $5v9Nu = parcelRequire("5v9Nu");

var $3sFnk = parcelRequire("3sFnk");

var $3llAp = parcelRequire("3llAp");

var $7pZzJ = parcelRequire("7pZzJ");

var $b7DjZ = parcelRequire("b7DjZ");
const $26077f8f4a0cb6f1$export$b2ef360f69e1145b = ({ config: config, api: api })=>{
    const userPreferencesProvider = config.userPreferencesProvider;
    return {
        name: 'userPreferences',
        pmPlugins () {
            return [
                {
                    name: 'userPreferencesPlugin',
                    plugin: ()=>{
                        return (0, $3sFnk.createPlugin)(config, api);
                    }
                }
            ];
        },
        actions: {
            updateUserPreference: (key, value)=>{
                var _api$analytics;
                return (0, $5v9Nu.updateUserPreference)({
                    key: key,
                    value: value,
                    userPreferencesProvider: userPreferencesProvider,
                    editorAnalyticsApi: api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions
                });
            },
            getUserPreferences: ()=>{
                if (!userPreferencesProvider) return config.initialUserPreferences;
                return userPreferencesProvider.getPreferences();
            }
        },
        commands: {
            overrideUserPreference: (key, value)=>{
                return (0, $5v9Nu.overrideUserPreference)({
                    key: key,
                    value: value
                });
            },
            clearOverrideUserPreference: (key)=>{
                return (0, $5v9Nu.clearOverrideUserPreference)({
                    key: key
                });
            }
        },
        getSharedState (editorState) {
            if (!editorState) return null;
            const state = (0, $3sFnk.userPreferencesPluginKey).getState(editorState);
            // state can return undefined if the plugin hasn't been registered
            if (!state) return null;
            else if (!state.overrides || Object.keys(state.overrides).length === 0) return state;
            return {
                ...state,
                preferences: {
                    ...state.preferences,
                    ...state.overrides
                }
            };
        },
        usePluginHook ({ editorView: editorView }) {
            const { resolvedUserPreferences: resolvedUserPreferences } = (0, $4F1Uz.useResolvedUserPreferences)(userPreferencesProvider);
            (0, $b7DjZ.useUserPreferencesUpdateListener)(editorView, resolvedUserPreferences);
            (0, $3llAp.useDocumentVisibilityWatcher)(userPreferencesProvider);
            (0, $7pZzJ.useUserPreferencesInitListener)(Boolean(userPreferencesProvider === null || userPreferencesProvider === void 0 ? void 0 : userPreferencesProvider.isInitialized), resolvedUserPreferences, api);
        }
    };
};

});
parcelRegister("4F1Uz", function(module, exports) {
$parcel$export(module.exports, "useResolvedUserPreferences", () => $98634f67b5383a52$export$b5633b5b7afd4542);

var $bSJIT = parcelRequire("bSJIT");
function $98634f67b5383a52$export$b5633b5b7afd4542(userPreferencesProvider) {
    const [resolvedUserPreferences, setResolvedUserPreferences] = (0, $bSJIT.useState)((userPreferencesProvider === null || userPreferencesProvider === void 0 ? void 0 : userPreferencesProvider.getPreferences()) || null);
    (0, $bSJIT.useEffect)(()=>{
        return userPreferencesProvider === null || userPreferencesProvider === void 0 ? void 0 : userPreferencesProvider.onUpdate(()=>{
            setResolvedUserPreferences(userPreferencesProvider.getPreferences());
        });
    }, [
        userPreferencesProvider
    ]);
    return {
        resolvedUserPreferences: resolvedUserPreferences
    };
}

});

parcelRegister("5v9Nu", function(module, exports) {
$parcel$export(module.exports, "overrideUserPreference", () => $ea799a7e41cc4adf$export$f9431c71d648ada2);
$parcel$export(module.exports, "clearOverrideUserPreference", () => $ea799a7e41cc4adf$export$8243f41c2dd518ad);
$parcel$export(module.exports, "updateUserPreference", () => $ea799a7e41cc4adf$export$32e4436123e4fc74);

var $g6Qq4 = parcelRequire("g6Qq4");

var $j2Y9J = parcelRequire("j2Y9J");

var $3sFnk = parcelRequire("3sFnk");
const $ea799a7e41cc4adf$export$f9431c71d648ada2 = ({ key: key, value: value })=>({ tr: tr })=>{
        tr.setMeta((0, $3sFnk.userPreferencesPluginKey), {
            override: {
                key: key,
                value: value
            }
        });
        return tr;
    };
const $ea799a7e41cc4adf$export$8243f41c2dd518ad = ({ key: key })=>({ tr: tr })=>{
        tr.setMeta((0, $3sFnk.userPreferencesPluginKey), {
            override: {
                key: key,
                value: null
            }
        });
        return tr;
    };
const $ea799a7e41cc4adf$export$32e4436123e4fc74 = ({ key: key, value: value, userPreferencesProvider: userPreferencesProvider, editorAnalyticsApi: editorAnalyticsApi })=>({ tr: tr })=>{
        try {
            userPreferencesProvider === null || userPreferencesProvider === void 0 || userPreferencesProvider.updatePreference(key, value);
        } catch (error) {
            (0, $j2Y9J.logException)(error, {
                location: 'editor-plugin-user-preferences/userPreferencesPlugin'
            });
        }
        // If the userPreferencesProvider is not available,
        // the plugin's state will be updated to operate in 'in memory' mode.
        tr.setMeta((0, $3sFnk.userPreferencesPluginKey), {
            preferences: {
                [key]: value
            }
        });
        if (key === 'toolbarDockingPosition') editorAnalyticsApi === null || editorAnalyticsApi === void 0 || editorAnalyticsApi.attachAnalyticsEvent({
            action: (0, $g6Qq4.ACTION).UPDATED,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).USER_PREFERENCES,
            actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).SELECTION_TOOLBAR_PREFERENCES,
            attributes: {
                toolbarDocking: value
            },
            eventType: (0, $g6Qq4.EVENT_TYPE).TRACK
        })(tr);
        return tr;
    };

});
parcelRegister("3sFnk", function(module, exports) {
$parcel$export(module.exports, "userPreferencesPluginKey", () => $74bea763e31133e2$export$26bf7aeec579553f);
$parcel$export(module.exports, "createPlugin", () => $74bea763e31133e2$export$ae829ec7b2625219);

var $f7Kk4 = parcelRequire("f7Kk4");

var $cw0wu = parcelRequire("cw0wu");

var $797yE = parcelRequire("797yE");
const $74bea763e31133e2$export$17267f5809d60e00 = (currentOverrides, override)=>{
    const { key: key, value: value } = override;
    if (value === null || value === undefined) {
        const { [key]: _, ...rest } = currentOverrides;
        return rest;
    }
    return {
        ...currentOverrides,
        [key]: value
    };
};
const $74bea763e31133e2$export$26bf7aeec579553f = new (0, $cw0wu.PluginKey)('userPreferencesPlugin');
const $74bea763e31133e2$export$ae829ec7b2625219 = (pluginOptions, _api)=>{
    const { userPreferencesProvider: userPreferencesProvider, initialUserPreferences: initialUserPreferences } = pluginOptions;
    const getInitialUserPreferences = ()=>{
        if (initialUserPreferences && (0, $797yE.editorExperiment)('platform_editor_controls', 'variant1')) return initialUserPreferences;
        return {
            toolbarDockingPosition: 'top'
        };
    };
    return new (0, $f7Kk4.SafePlugin)({
        key: $74bea763e31133e2$export$26bf7aeec579553f,
        state: {
            init () {
                return {
                    preferences: (userPreferencesProvider === null || userPreferencesProvider === void 0 ? void 0 : userPreferencesProvider.getPreferences()) || getInitialUserPreferences(),
                    overrides: {}
                };
            },
            apply: (tr, currentPluginState)=>{
                const meta = tr.getMeta($74bea763e31133e2$export$26bf7aeec579553f);
                if (!meta || !meta.preferences && !meta.override) return currentPluginState;
                const nextState = {
                    ...currentPluginState
                };
                if (meta.preferences) nextState.preferences = {
                    ...currentPluginState.preferences,
                    ...meta.preferences
                };
                if (meta.override) nextState.overrides = $74bea763e31133e2$export$17267f5809d60e00(currentPluginState.overrides, meta.override);
                return nextState;
            }
        }
    });
};

});


parcelRegister("3llAp", function(module, exports) {
$parcel$export(module.exports, "useDocumentVisibilityWatcher", () => $76f43e6771b9a858$export$c3ff777471586be2);

var $bSJIT = parcelRequire("bSJIT");

var $bAB3U = parcelRequire("bAB3U");

var $j2Y9J = parcelRequire("j2Y9J");
const $76f43e6771b9a858$export$c3ff777471586be2 = (userPreferencesProvider)=>{
    (0, $bSJIT.useEffect)(()=>{
        if (userPreferencesProvider) {
            const refreshPreferences = async ()=>{
                if (document.visibilityState === 'visible') try {
                    await userPreferencesProvider.loadPreferences();
                } catch (error) {
                    (0, $j2Y9J.logException)(error, {
                        location: 'editor-plugin-user-preferences/userPreferencesPlugin'
                    });
                }
            };
            return (0, $bAB3U.bind)(document, {
                type: 'visibilitychange',
                listener: refreshPreferences
            });
        }
    }, [
        userPreferencesProvider
    ]);
};

});

parcelRegister("7pZzJ", function(module, exports) {
$parcel$export(module.exports, "useUserPreferencesInitListener", () => $62fda3b611f68945$export$2bd306fd54c8196e);

var $bSJIT = parcelRequire("bSJIT");

var $g6Qq4 = parcelRequire("g6Qq4");
const $62fda3b611f68945$export$2bd306fd54c8196e = (isInitialized, resolvedUserPreferences, api)=>{
    const isInitializedRef = (0, $bSJIT.useRef)(false);
    (0, $bSJIT.useEffect)(()=>{
        if (isInitialized && resolvedUserPreferences && !isInitializedRef.current) {
            var _api$analytics;
            isInitializedRef.current = true;
            api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 || _api$analytics.actions.fireAnalyticsEvent({
                action: (0, $g6Qq4.ACTION).INITIALISED,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).USER_PREFERENCES,
                actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).SELECTION_TOOLBAR_PREFERENCES,
                attributes: {
                    toolbarDocking: resolvedUserPreferences.toolbarDockingPosition
                },
                eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL
            });
        }
    }, [
        api,
        isInitialized,
        resolvedUserPreferences
    ]);
};

});

parcelRegister("b7DjZ", function(module, exports) {
$parcel$export(module.exports, "useUserPreferencesUpdateListener", () => $cdcb61c85983f7a0$export$c4b185fa097d4dc);

var $bSJIT = parcelRequire("bSJIT");

var $3sFnk = parcelRequire("3sFnk");
const $cdcb61c85983f7a0$export$c4b185fa097d4dc = (editorView, resolvedUserPreferences)=>{
    (0, $bSJIT.useEffect)(()=>{
        if (resolvedUserPreferences) editorView.dispatch(editorView.state.tr.setMeta((0, $3sFnk.userPreferencesPluginKey), {
            preferences: resolvedUserPreferences
        }));
    }, [
        resolvedUserPreferences,
        editorView
    ]);
};

});


parcelRegister("ePLdG", function(module, exports) {
$parcel$export(module.exports, "analyticsPlugin", () => $ba52eae59c7d8c92$export$f26023c5d4a5ab44);

var $bSJIT = parcelRequire("bSJIT");

var $7ozbX = parcelRequire("7ozbX");

var $6WltM = parcelRequire("6WltM");

var $bTWXs = parcelRequire("bTWXs");

var $g6Qq4 = parcelRequire("g6Qq4");

var $gK4Lk = parcelRequire("gK4Lk");

var $jRBYX = parcelRequire("jRBYX");

var $jqEKs = parcelRequire("jqEKs");

var $f7Kk4 = parcelRequire("f7Kk4");

var $2jmce = parcelRequire("2jmce");

var $auxfd = parcelRequire("auxfd");

var $1AhpS = parcelRequire("1AhpS");

var $iCzTa = parcelRequire("iCzTa");

var $2r96d = parcelRequire("2r96d");
function $ba52eae59c7d8c92$var$createPlugin(options, featureFlags) {
    if (!options) return;
    const hasRequiredPerformanceAPIs = (0, $jRBYX.isPerformanceAPIAvailable)();
    return new (0, $f7Kk4.SafePlugin)({
        key: (0, $iCzTa.analyticsPluginKey),
        state: {
            init: ()=>{
                return {
                    ...options,
                    fireAnalytics: (0, $bTWXs.fireAnalyticsEvent)(options.createAnalyticsEvent)
                };
            },
            apply: (tr, pluginState, _, state)=>{
                const { createAnalyticsEvent: createAnalyticsEvent } = tr.getMeta((0, $iCzTa.analyticsPluginKey)) ?? {};
                // When the createAnalyticsEvent is reconfigured
                if (options.createAnalyticsEvent && options.createAnalyticsEvent !== pluginState.createAnalyticsEvent || pluginState.createAnalyticsEvent !== createAnalyticsEvent && createAnalyticsEvent) return {
                    ...pluginState,
                    createAnalyticsEvent: options.createAnalyticsEvent ?? createAnalyticsEvent
                };
                if (featureFlags.catchAllTracking) {
                    const analyticsEventWithChannel = (0, $gK4Lk.getAnalyticsEventsFromTransaction)(tr);
                    if (analyticsEventWithChannel.length > 0) {
                        for (const { payload: payload, channel: channel } of analyticsEventWithChannel)// Measures how much time it takes to update the DOM after each ProseMirror document update
                        // that has an analytics event.
                        if (hasRequiredPerformanceAPIs && tr.docChanged && payload.action !== (0, $g6Qq4.ACTION).INSERTED && payload.action !== (0, $g6Qq4.ACTION).DELETED) {
                            const measureName = `${payload.actionSubject}:${payload.action}:${payload.actionSubjectId}`;
                            (0, $jqEKs.measureRender)(// NOTE this name could be resulting in misleading data -- where if multiple payloads are
                            // received before a render completes -- the measurement value will be inaccurate (this is
                            // due to measureRender requiring unique measureNames)
                            measureName, ({ duration: duration, distortedDuration: distortedDuration })=>{
                                (0, $bTWXs.fireAnalyticsEvent)(pluginState.createAnalyticsEvent)({
                                    payload: $ba52eae59c7d8c92$var$extendPayload({
                                        payload: payload,
                                        duration: duration,
                                        distortedDuration: distortedDuration
                                    }),
                                    channel: channel
                                });
                            });
                        }
                    }
                }
                return pluginState;
            }
        }
    });
}
/**
 * Analytics plugin to be added to an `EditorPresetBuilder` and used with `ComposableEditor`
 * from `@atlaskit/editor-core`.
 */ const $ba52eae59c7d8c92$export$f26023c5d4a5ab44 = ({ config: options = {}, api: api })=>{
    var _api$featureFlags;
    const featureFlags = (api === null || api === void 0 || (_api$featureFlags = api.featureFlags) === null || _api$featureFlags === void 0 ? void 0 : _api$featureFlags.sharedState.currentState()) || {};
    const analyticsEventPropQueue = new Set();
    return {
        name: 'analytics',
        getSharedState: (editorState)=>{
            if (!editorState) return {
                createAnalyticsEvent: null,
                attachAnalyticsEvent: null,
                performanceTracking: undefined
            };
            const { createAnalyticsEvent: createAnalyticsEvent, performanceTracking: performanceTracking } = (0, $iCzTa.analyticsPluginKey).getState(editorState) ?? {};
            return {
                createAnalyticsEvent: createAnalyticsEvent,
                attachAnalyticsEvent: (0, $2jmce.createAttachPayloadIntoTransaction)(editorState.selection),
                performanceTracking: performanceTracking
            };
        },
        actions: {
            attachAnalyticsEvent: (payload, channel = (0, $1AhpS.editorAnalyticsChannel))=>(tr)=>{
                    var _api$analytics;
                    const { createAnalyticsEvent: createAnalyticsEvent, attachAnalyticsEvent: attachAnalyticsEvent } = (api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.sharedState.currentState()) ?? {};
                    if (!tr || !createAnalyticsEvent || !attachAnalyticsEvent) {
                        analyticsEventPropQueue.add({
                            payload: payload,
                            channel: channel
                        });
                        return false;
                    }
                    attachAnalyticsEvent({
                        tr: tr,
                        payload: payload,
                        channel: channel
                    });
                    return true;
                },
            fireAnalyticsEvent (payload, channel = (0, $1AhpS.editorAnalyticsChannel), options) {
                var _api$analytics2;
                const { createAnalyticsEvent: createAnalyticsEvent } = (api === null || api === void 0 || (_api$analytics2 = api.analytics) === null || _api$analytics2 === void 0 ? void 0 : _api$analytics2.sharedState.currentState()) ?? {};
                if (options !== null && options !== void 0 && options.context) payload = (0, $auxfd.getStateContext)(options.context.selection, payload);
                if (!createAnalyticsEvent) {
                    analyticsEventPropQueue.add({
                        payload: payload,
                        channel: channel
                    });
                    return;
                }
                // This cast is needed to satisfy TS when using custom payloads which is only allowed by
                // the fireAnalyticsEvent function in EditorAnalyticsAPI for now.
                // createAnalyticsEvent actually fires our standard AnalyticsEventPayload type which is less strict
                // so this is safe.
                const firedPayload = payload;
                (0, $bTWXs.fireAnalyticsEvent)(createAnalyticsEvent, options)({
                    payload: firedPayload,
                    channel: channel
                });
            }
        },
        usePluginHook ({ editorView: editorView }) {
            const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6WltM.useAnalyticsEvents)();
            (0, $bSJIT.useLayoutEffect)(()=>{
                const { dispatch: dispatch, state: { tr: tr } } = editorView;
                tr.setMeta((0, $iCzTa.analyticsPluginKey), {
                    createAnalyticsEvent: createAnalyticsEvent
                });
                dispatch(tr);
                // Attach all analytics events to the transaction
                analyticsEventPropQueue.forEach(({ payload: payload, channel: channel })=>{
                    var _createAnalyticsEvent;
                    (_createAnalyticsEvent = createAnalyticsEvent(payload)) === null || _createAnalyticsEvent === void 0 || _createAnalyticsEvent.fire(channel ?? (0, $1AhpS.editorAnalyticsChannel));
                });
                // Clear the queue
                analyticsEventPropQueue.clear();
            }, [
                createAnalyticsEvent,
                editorView
            ]);
        },
        pmPlugins () {
            return [
                {
                    name: 'analyticsPlugin',
                    plugin: ()=>$ba52eae59c7d8c92$var$createPlugin(options, featureFlags)
                }
            ];
        },
        onEditorViewStateUpdated ({ originalTransaction: originalTransaction, transactions: transactions, newEditorState: newEditorState }) {
            const pluginState = (0, $iCzTa.analyticsPluginKey).getState(newEditorState);
            if (!pluginState || !pluginState.createAnalyticsEvent) return;
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const steps = transactions.reduce((acc, tr)=>{
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const payloads = tr.steps// Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                .filter((step)=>step instanceof (0, $7ozbX.AnalyticsStep)).map((x)=>x.analyticsEvents).reduce((acc, val)=>acc.concat(val), []);
                acc.push(...payloads);
                return acc;
            }, []);
            if (steps.length === 0) return;
            const { createAnalyticsEvent: createAnalyticsEvent } = pluginState;
            const undoAnaltyicsEventTransformer = (0, $2r96d.generateUndoRedoInputSoucePayload)(originalTransaction);
            steps.forEach(({ payload: payload, channel: channel })=>{
                const nextPayload = undoAnaltyicsEventTransformer(payload);
                (0, $bTWXs.fireAnalyticsEvent)(createAnalyticsEvent)({
                    payload: nextPayload,
                    channel: channel
                });
            });
        }
    };
};
function $ba52eae59c7d8c92$var$extendPayload({ payload: payload, duration: duration, distortedDuration: distortedDuration }) {
    return {
        ...payload,
        attributes: {
            ...payload.attributes,
            duration: duration,
            distortedDuration: distortedDuration
        },
        eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL
    };
}

});
parcelRegister("2jmce", function(module, exports) {
$parcel$export(module.exports, "createAttachPayloadIntoTransaction", () => $075a70afe485ccf4$export$539ce7f09649e93);

var $7ozbX = parcelRequire("7ozbX");

var $g6Qq4 = parcelRequire("g6Qq4");

var $auxfd = parcelRequire("auxfd");

var $2066c = parcelRequire("2066c");
const $075a70afe485ccf4$var$actionsToIgnore = [
    (0, $g6Qq4.ACTION).INVOKED,
    (0, $g6Qq4.ACTION).OPENED
];
const $075a70afe485ccf4$export$539ce7f09649e93 = (selection)=>({ payload: payload, tr: tr, channel: channel })=>$075a70afe485ccf4$var$attachPayloadIntoTransaction({
            payload: payload,
            selection: selection,
            tr: tr,
            channel: channel
        });
// This utils was taken as reference in packages/editor/editor-plugin-ai/src/analytics/utils.ts
//  to create new util attachPayloadIntoTransaction in above file.
// If you make a change here, please review attachPayloadIntoTransaction in above
//  file and update it as well if needed.
const $075a70afe485ccf4$var$attachPayloadIntoTransaction = ({ payload: payload, selection: selection, tr: tr, channel: channel })=>{
    payload = (0, $auxfd.getStateContext)(selection, payload, tr);
    payload = (0, $2066c.mapActionSubjectIdToAttributes)(payload);
    const { storedMarks: storedMarks } = tr;
    const pos = tr.mapping.map(selection.$from.pos, -1);
    tr.step(new (0, $7ozbX.AnalyticsStep)([
        {
            payload: payload,
            channel: channel
        }
    ], $075a70afe485ccf4$var$actionsToIgnore, pos // We need to create the step based on a position, this prevent split history for relative changes.
    ));
    // When you add a new step all the storedMarks are removed it
    if (storedMarks) tr.setStoredMarks(storedMarks);
};

});
parcelRegister("auxfd", function(module, exports) {
$parcel$export(module.exports, "getStateContext", () => $fdf776bdc8ddc2c3$export$b8d8bec4e31cbd66);

var $g6Qq4 = parcelRequire("g6Qq4");

var $2J0GM = parcelRequire("2J0GM");

var $6m8Z0 = parcelRequire("6m8Z0");

var $cw0wu = parcelRequire("cw0wu");

var $gab48 = parcelRequire("gab48");

var $2E7OD = parcelRequire("2E7OD");
function $fdf776bdc8ddc2c3$export$ab5b04535d7a5950(selection) {
    var _selection$constructo;
    let type;
    let position;
    if ((selection === null || selection === void 0 || (_selection$constructo = selection.constructor) === null || _selection$constructo === void 0 ? void 0 : _selection$constructo.name) === 'GapCursorSelection') {
        type = (0, $2J0GM.SELECTION_TYPE).GAP_CURSOR;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        position = selection.side;
    } else if (selection instanceof (0, $2E7OD.CellSelection)) type = (0, $2J0GM.SELECTION_TYPE).CELL;
    else if (selection instanceof (0, $cw0wu.NodeSelection)) type = (0, $2J0GM.SELECTION_TYPE).NODE;
    else if (selection.from !== selection.to) type = (0, $2J0GM.SELECTION_TYPE).RANGED;
    else {
        type = (0, $2J0GM.SELECTION_TYPE).CURSOR;
        const { from: from, $from: $from } = selection;
        if (from === $from.start()) position = (0, $2J0GM.SELECTION_POSITION).START;
        else if (from === $from.end()) position = (0, $2J0GM.SELECTION_POSITION).END;
        else position = (0, $2J0GM.SELECTION_POSITION).MIDDLE;
    }
    return {
        type: type,
        position: position
    };
}
function $fdf776bdc8ddc2c3$var$findInsertedLocation(oldSelection, newSelection, tr) {
    const { schema: schema } = newSelection.$from.doc.type;
    const { nodes: { paragraph: paragraph, table: table } } = schema;
    if (oldSelection instanceof (0, $2E7OD.CellSelection)) return table.name;
    const newDoc = newSelection.$from.doc;
    const insertLocationInfo = (0, $gab48.findParentNode)((node)=>node.type !== paragraph)(oldSelection);
    let pos = (insertLocationInfo === null || insertLocationInfo === void 0 ? void 0 : insertLocationInfo.start) || 0;
    // Map the old document position through the transaction's steps
    pos = tr.mapping.map(pos);
    let parentNodePos = newDoc.resolve(pos);
    // Keep going one level above the attempted insert position till we find a node that contains the current cursor position in it's range
    while(parentNodePos.end() < newSelection.$from.pos)parentNodePos = newDoc.resolve(parentNodePos.start(Math.max(parentNodePos.depth - 1, 0)));
    return parentNodePos.node().type.name;
}
function $fdf776bdc8ddc2c3$export$b8d8bec4e31cbd66(selection, payload, tr) {
    if (!payload.attributes) return payload;
    const { type: type, position: position } = $fdf776bdc8ddc2c3$export$ab5b04535d7a5950(selection);
    payload.attributes.selectionType = type;
    if (position) payload.attributes.selectionPosition = position;
    const insertLocation = (0, $6m8Z0.findInsertLocation)(selection);
    if (tr && payload.action === (0, $g6Qq4.ACTION).INSERTED && payload.actionSubject !== (0, $g6Qq4.ACTION_SUBJECT).ANNOTATION && payload.actionSubject !== (0, $g6Qq4.ACTION_SUBJECT).EDITOR_PLUGIN_AI) payload.attributes.insertedLocation = $fdf776bdc8ddc2c3$var$findInsertedLocation(selection, tr.selection, tr);
    if (payload.action === (0, $g6Qq4.ACTION).INSERTED && payload.actionSubject === (0, $g6Qq4.ACTION_SUBJECT).DOCUMENT && payload.attributes) {
        payload.attributes.insertLocation = insertLocation;
        const { bodiedSyncBlock: bodiedSyncBlock } = selection.$from.doc.type.schema.nodes;
        payload.attributes.isInsideSyncedBlock = Boolean((0, $gab48.findParentNodeOfType)(bodiedSyncBlock)(selection));
    } else payload.attributes.nodeLocation = insertLocation;
    return payload;
}

});
parcelRegister("2J0GM", function(module, exports) {
$parcel$export(module.exports, "SELECTION_TYPE", () => $757d32a2172dd2e1$export$96527b3d022fe7df);
$parcel$export(module.exports, "SELECTION_POSITION", () => $757d32a2172dd2e1$export$f64a96dc7664cbe5);
var $757d32a2172dd2e1$export$96527b3d022fe7df = /*#__PURE__*/ function(SELECTION_TYPE) {
    SELECTION_TYPE["CURSOR"] = "cursor";
    SELECTION_TYPE["RANGED"] = "ranged";
    SELECTION_TYPE["TEXT"] = "text";
    SELECTION_TYPE["NODE"] = "node";
    SELECTION_TYPE["CELL"] = "cell";
    SELECTION_TYPE["GAP_CURSOR"] = "gapCursor";
    return SELECTION_TYPE;
}({});
var $757d32a2172dd2e1$export$f64a96dc7664cbe5 = /*#__PURE__*/ function(SELECTION_POSITION) {
    SELECTION_POSITION["START"] = "start";
    SELECTION_POSITION["MIDDLE"] = "middle";
    SELECTION_POSITION["END"] = "end";
    SELECTION_POSITION["LEFT"] = "left";
    SELECTION_POSITION["RIGHT"] = "right";
    return SELECTION_POSITION;
}({});

});


parcelRegister("2066c", function(module, exports) {
$parcel$export(module.exports, "mapActionSubjectIdToAttributes", () => $7147a841442033a3$export$dd48e359ffe98e59);

var $g6Qq4 = parcelRequire("g6Qq4");
function $7147a841442033a3$export$dd48e359ffe98e59(payload) {
    const documentInserted = payload.action === (0, $g6Qq4.ACTION).INSERTED && payload.actionSubject === (0, $g6Qq4.ACTION_SUBJECT).DOCUMENT;
    const textFormatted = payload.action === (0, $g6Qq4.ACTION).FORMATTED && payload.actionSubject === (0, $g6Qq4.ACTION_SUBJECT).TEXT;
    const hasActionSubjectId = !!payload.actionSubjectId;
    if (hasActionSubjectId && (documentInserted || textFormatted)) payload.attributes = {
        ...payload.attributes,
        // @ts-expect-error
        actionSubjectId: payload.actionSubjectId
    };
    return payload;
}

});


parcelRegister("1AhpS", function(module, exports) {
$parcel$export(module.exports, "editorAnalyticsChannel", () => $c1d3b574778e8f6f$export$1467dbbb3bb418c6);

var $1l5zG = parcelRequire("1l5zG");
const $c1d3b574778e8f6f$export$1467dbbb3bb418c6 = (0, $1l5zG.FabricChannel).editor;

});

parcelRegister("iCzTa", function(module, exports) {
$parcel$export(module.exports, "analyticsPluginKey", () => $35f49ae5e2240a8d$export$c4a4504e8a9a0b2e);

var $cw0wu = parcelRequire("cw0wu");
const $35f49ae5e2240a8d$export$c4a4504e8a9a0b2e = new (0, $cw0wu.PluginKey)('analyticsPlugin');

});

parcelRegister("2r96d", function(module, exports) {
$parcel$export(module.exports, "generateUndoRedoInputSoucePayload", () => $765c2f7e56e4a3ba$export$67d130a769494b9b);
const $765c2f7e56e4a3ba$var$getUndoRedoInputSource = (tr)=>{
    // Please, do not copy or use this kind of code below
    return tr.getMeta('undoRedoPlugin$') ?? null;
};
const $765c2f7e56e4a3ba$export$67d130a769494b9b = (tr)=>{
    const undoRedoPluginInputSource = $765c2f7e56e4a3ba$var$getUndoRedoInputSource(tr);
    return (payload)=>{
        const shouldAddHistoryTriggerMethodAttribute = undoRedoPluginInputSource && [
            'undid',
            'redid'
        ].includes(payload.action);
        return !shouldAddHistoryTriggerMethodAttribute ? payload : {
            ...payload,
            attributes: {
                ...payload.attributes,
                historyTriggerMethod: undoRedoPluginInputSource
            }
        };
    };
};

});


parcelRegister("2CoFm", function(module, exports) {
$parcel$export(module.exports, "default", () => $fd6c55f4cf991b40$export$2e2bcd8739ae039);

var $bNELO = parcelRequire("bNELO");

var $fhSQQ = parcelRequire("fhSQQ");

var $eCc5B = parcelRequire("eCc5B");

var $bdXbU = parcelRequire("bdXbU");

var $5FzRL = parcelRequire("5FzRL");

var $3y2s4 = parcelRequire("3y2s4");

var $5Aczr = parcelRequire("5Aczr");

var $5QGQH = parcelRequire("5QGQH");

var $8DN0b = parcelRequire("8DN0b");

var $8M53e = parcelRequire("8M53e");

var $aKfyg = parcelRequire("aKfyg");

var $23Y04 = parcelRequire("23Y04");

var $2Oycl = parcelRequire("2Oycl");

var $4xnbo = parcelRequire("4xnbo");

var $7KO6o = parcelRequire("7KO6o");

var $02w6v = parcelRequire("02w6v");

var $8QqlY = parcelRequire("8QqlY");
function $fd6c55f4cf991b40$export$edcd20463038b9e1(from, to, tr, callbacks) {
    const { doc: doc } = tr;
    doc.nodesBetween(from, to, (node, pos)=>{
        callbacks.forEach((cb)=>cb({
                tr: tr,
                node: node,
                pos: pos,
                from: from,
                to: to
            }));
    });
}
const $fd6c55f4cf991b40$var$SMART_TO_ASCII = {
    "\u2026": '...',
    "\u2192": '->',
    "\u2190": '<-',
    "\u2013": '--',
    "\u201C": '"',
    "\u201D": '"',
    "\u2018": "'",
    "\u2019": "'"
};
// eslint-disable-next-line require-unicode-regexp
const $fd6c55f4cf991b40$var$FIND_SMART_CHAR = new RegExp(`[${Object.keys($fd6c55f4cf991b40$var$SMART_TO_ASCII).join('')}]`, 'g');
const $fd6c55f4cf991b40$var$basePlugin = ({ config: options, api: api })=>{
    var _api$featureFlags, _api$base;
    const featureFlags = (api === null || api === void 0 || (_api$featureFlags = api.featureFlags) === null || _api$featureFlags === void 0 ? void 0 : _api$featureFlags.sharedState.currentState()) || {};
    const callbacks = [];
    api === null || api === void 0 || (_api$base = api.base) === null || _api$base === void 0 || _api$base.actions.registerMarks(({ tr: tr, node: node, pos: pos, from: from, to: to })=>{
        const { doc: doc } = tr;
        const { schema: schema } = doc.type;
        const { text: textNodeType } = schema.nodes;
        if (node.type === textNodeType && node.text) {
            // Find a valid start and end position because the text may be partially selected.
            const startPositionInSelection = Math.max(pos, from);
            const endPositionInSelection = Math.min(pos + node.nodeSize, to);
            const textForReplacing = doc.textBetween(startPositionInSelection, endPositionInSelection);
            const newText = textForReplacing.replace($fd6c55f4cf991b40$var$FIND_SMART_CHAR, (match)=>$fd6c55f4cf991b40$var$SMART_TO_ASCII[match] ?? match);
            const currentStartPos = tr.mapping.map(startPositionInSelection);
            const currentEndPos = tr.mapping.map(endPositionInSelection);
            tr.replaceWith(currentStartPos, currentEndPos, schema.text(newText, node.marks));
        }
    });
    return {
        name: 'base',
        getSharedState (editorState) {
            return {
                allowScrollGutter: options === null || options === void 0 ? void 0 : options.allowScrollGutter,
                keyboardHeight: (0, $02w6v.getKeyboardHeight)(editorState)
            };
        },
        actions: {
            setKeyboardHeight: $5QGQH.setKeyboardHeight,
            resolveMarks: (from, to, tr)=>$fd6c55f4cf991b40$export$edcd20463038b9e1(from, to, tr, callbacks),
            registerMarks: (callback)=>{
                callbacks.push(callback);
            }
        },
        pmPlugins () {
            const plugins = [
                {
                    name: 'filterStepsPlugin',
                    plugin: ({ dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>(0, $8M53e.default)(dispatchAnalyticsEvent)
                }
            ];
            plugins.push({
                name: 'lazyNodeViewDecorationsPlugin',
                plugin: ()=>(0, $2Oycl.createLazyNodeViewDecorationPlugin)()
            });
            // In Chrome, when the selection is placed between adjacent nodes which are not contenteditatble
            // the cursor appears at the right most point of the parent container.
            //
            // In Firefox, when the selection is placed between adjacent nodes which are not contenteditatble
            // no cursor is presented to users.
            //
            // In Safari, when the selection is placed between adjacent nodes which are not contenteditatble
            // it is not possible to navigate with arrow keys.
            //
            // This plugin works around the issues by inserting decorations between
            // inline nodes which are set as contenteditable, and have a zero width space.
            plugins.push({
                name: 'inlineCursorTargetPlugin',
                plugin: ()=>options && options.allowInlineCursorTarget ? (0, $23Y04.default)() : undefined
            });
            plugins.push({
                name: 'newlinePreserveMarksPlugin',
                plugin: (0, $4xnbo.default)
            }, {
                name: 'frozenEditor',
                plugin: ({ dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
                    if ((0, $3y2s4.isExperimentEnabled)('platform_editor_remove_legacy_perf_events')) return undefined;
                    return (0, $aKfyg.default)(api === null || api === void 0 ? void 0 : api.contextIdentifier)(dispatchAnalyticsEvent, (0, $8QqlY.inputTracking), undefined);
                }
            }, {
                name: 'history',
                plugin: ()=>(0, $5Aczr.history)()
            }, // should be last :(
            {
                name: 'codeBlockIndent',
                plugin: ()=>(0, $bdXbU.keymap)({
                        ...(0, $5FzRL.baseKeymap),
                        'Mod-[': ()=>true,
                        'Mod-]': ()=>true
                    })
            });
            if (options && options.allowScrollGutter) plugins.push({
                name: 'scrollGutterPlugin',
                plugin: ()=>(0, $7KO6o.default)(options.allowScrollGutter)
            });
            plugins.push({
                name: 'disableSpellcheckingPlugin',
                plugin: ()=>(0, $8DN0b.default)(featureFlags)
            });
            return plugins;
        },
        nodes () {
            return [
                {
                    name: 'doc',
                    node: (0, $bNELO.doc)
                },
                {
                    name: 'paragraph',
                    node: (0, $fhSQQ.paragraph)
                },
                {
                    name: 'text',
                    node: (0, $eCc5B.text)
                }
            ];
        }
    };
};
var $fd6c55f4cf991b40$export$2e2bcd8739ae039 = $fd6c55f4cf991b40$var$basePlugin;

});
parcelRegister("5QGQH", function(module, exports) {
$parcel$export(module.exports, "setKeyboardHeight", () => $6bc2afc835de04b4$export$b8c3ea160300668d);

var $bWbzK = parcelRequire("bWbzK");
const $6bc2afc835de04b4$export$b8c3ea160300668d = (keyboardHeight)=>(state, dispatch)=>{
        const { tr: tr } = state;
        tr.setMeta((0, $bWbzK.scrollGutterPluginKey), {
            keyboardHeight: keyboardHeight
        });
        if (dispatch) dispatch(tr);
        return true;
    };

});
parcelRegister("bWbzK", function(module, exports) {
$parcel$export(module.exports, "scrollGutterPluginKey", () => $8b615cbe74f4779c$export$54fdd3c2782161ea);
$parcel$export(module.exports, "getScrollGutterPluginState", () => $8b615cbe74f4779c$export$a237783470abe542);

var $cw0wu = parcelRequire("cw0wu");
const $8b615cbe74f4779c$export$54fdd3c2782161ea = new (0, $cw0wu.PluginKey)('scrollGutter');
const $8b615cbe74f4779c$export$a237783470abe542 = (state)=>{
    if (state) return $8b615cbe74f4779c$export$54fdd3c2782161ea.getState(state);
};

});


parcelRegister("8DN0b", function(module, exports) {
$parcel$export(module.exports, "default", () => $3a9ac6e414981a5b$export$2e2bcd8739ae039);

var $jxkn6 = parcelRequire("jxkn6");

var $f7Kk4 = parcelRequire("f7Kk4");

var $cw0wu = parcelRequire("cw0wu");
function $3a9ac6e414981a5b$var$getCurrentBrowserAndVersion(browserEnv) {
    switch(true){
        case browserEnv.chrome === true:
            return {
                browser: 'chrome',
                version: browserEnv.chrome_version
            };
        case browserEnv.ie === true:
            return {
                browser: 'ie',
                version: browserEnv.ie_version
            };
        case browserEnv.gecko === true:
            return {
                browser: 'gecko',
                version: browserEnv.gecko_version
            };
        case browserEnv.safari === true:
            return {
                browser: 'safari',
                version: browserEnv.safari_version
            };
    }
    return undefined;
}
var $3a9ac6e414981a5b$export$2e2bcd8739ae039 = (featureFlags)=>new (0, $f7Kk4.SafePlugin)({
        key: new (0, $cw0wu.PluginKey)('disableSpellchecking'),
        props: {
            attributes: (editorState)=>{
                if (!featureFlags) return {};
                const browserConfigFeatureFlag = featureFlags.disableSpellcheckByBrowser;
                const browserEnv = (0, $jxkn6.getBrowserInfo)();
                const userCurrentBrowserAndVersion = $3a9ac6e414981a5b$var$getCurrentBrowserAndVersion(browserEnv);
                if (!userCurrentBrowserAndVersion || !browserConfigFeatureFlag) return {};
                const browserVersionDisableRange = // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                browserConfigFeatureFlag[userCurrentBrowserAndVersion.browser];
                if (!browserVersionDisableRange || !browserEnv[userCurrentBrowserAndVersion.browser]) return {};
                const shouldDisableSpellcheck = !!browserVersionDisableRange.maximum ? userCurrentBrowserAndVersion.version >= browserVersionDisableRange.minimum && userCurrentBrowserAndVersion.version <= browserVersionDisableRange.maximum : browserEnv[userCurrentBrowserAndVersion.browser] && userCurrentBrowserAndVersion.version >= browserVersionDisableRange.minimum;
                if (shouldDisableSpellcheck) return {
                    spellcheck: 'false'
                };
                return {};
            }
        }
    });

});

parcelRegister("8M53e", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca99c2e367f9a70c$export$2e2bcd8739ae039);

var $g6Qq4 = parcelRequire("g6Qq4");

var $gK4Lk = parcelRequire("gK4Lk");

var $f7Kk4 = parcelRequire("f7Kk4");
const $ca99c2e367f9a70c$var$hasInvalidSteps = (tr)=>(tr.steps || []).some((step)=>step.from > step.to);
var $ca99c2e367f9a70c$export$2e2bcd8739ae039 = (dispatchAnalyticsEvent)=>{
    return new (0, $f7Kk4.SafePlugin)({
        filterTransaction (transaction) {
            if ($ca99c2e367f9a70c$var$hasInvalidSteps(transaction)) {
                // eslint-disable-next-line no-console
                console.warn('The transaction was blocked because it contains invalid steps', transaction.steps);
                dispatchAnalyticsEvent({
                    action: (0, $g6Qq4.ACTION).DISCARDED_INVALID_STEPS_FROM_TRANSACTION,
                    actionSubject: (0, $g6Qq4.ACTION_SUBJECT).EDITOR,
                    attributes: {
                        analyticsEventPayloads: (0, $gK4Lk.getAnalyticsEventsFromTransaction)(transaction)
                    },
                    eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL
                });
                return false;
            }
            return true;
        }
    });
};

});

parcelRegister("aKfyg", function(module, exports) {
$parcel$export(module.exports, "default", () => $a0ea23dfade1be26$export$2e2bcd8739ae039);

var $g6Qq4 = parcelRequire("g6Qq4");

var $4S8NW = parcelRequire("4S8NW");

var $iUiR7 = parcelRequire("iUiR7");

var $jRBYX = parcelRequire("jRBYX");

var $f7Kk4 = parcelRequire("f7Kk4");

var $lrWkt = parcelRequire("lrWkt");

var $cw0wu = parcelRequire("cw0wu");

var $8deej = parcelRequire("8deej");

var $lxlLm = parcelRequire("lxlLm");
const $a0ea23dfade1be26$export$70246689264eff75 = new (0, $cw0wu.PluginKey)('frozenEditor');
const $a0ea23dfade1be26$var$DEFAULT_KEYSTROKE_SAMPLING_LIMIT = 100;
const $a0ea23dfade1be26$var$DEFAULT_SLOW_THRESHOLD = 300;
const $a0ea23dfade1be26$export$c8d5b833abcf8e80 = 600;
const $a0ea23dfade1be26$export$47b2879ca9bbf67a = 2000;
const $a0ea23dfade1be26$export$1b622068be977101 = 3000;
const $a0ea23dfade1be26$var$DEFAULT_TRACK_SEVERITY_ENABLED = false;
const $a0ea23dfade1be26$export$5705ac5f923a65e7 = 100;
const $a0ea23dfade1be26$export$1c6feb3429832c55 = 500;
const $a0ea23dfade1be26$var$dispatchLongTaskEvent = (contextIdentifierPlugin)=>(dispatchAnalyticsEvent, view, time, getNodeCount, interactionType, severity)=>{
        var _contextIdentifierPlu;
        const { state: state } = view;
        const nodesCount = getNodeCount(state);
        return dispatchAnalyticsEvent({
            action: (0, $g6Qq4.ACTION).BROWSER_FREEZE,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).EDITOR,
            attributes: {
                objectId: contextIdentifierPlugin === null || contextIdentifierPlugin === void 0 || (_contextIdentifierPlu = contextIdentifierPlugin.sharedState.currentState()) === null || _contextIdentifierPlu === void 0 || (_contextIdentifierPlu = _contextIdentifierPlu.contextIdentifierProvider) === null || _contextIdentifierPlu === void 0 ? void 0 : _contextIdentifierPlu.objectId,
                freezeTime: time,
                nodeSize: state.doc.nodeSize,
                ...nodesCount,
                interactionType: interactionType,
                severity: severity
            },
            eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL
        });
    };
var $a0ea23dfade1be26$export$2e2bcd8739ae039 = (contextIdentifierPlugin)=>(dispatchAnalyticsEvent, inputTracking, browserFreezeTracking)=>{
        let interactionType;
        let inputLatencyTracker = null;
        if (browserFreezeTracking !== null && browserFreezeTracking !== void 0 && browserFreezeTracking.trackInteractionType) interactionType = (0, $8deej.setInteractionType)((0, $4S8NW.BROWSER_FREEZE_INTERACTION_TYPE).LOADING);
        const samplingRate = inputTracking && typeof inputTracking.samplingRate === 'number' ? inputTracking.samplingRate : $a0ea23dfade1be26$var$DEFAULT_KEYSTROKE_SAMPLING_LIMIT;
        // TODO: ED-26959 - get right values here based on appearance
        const slowThreshold = $a0ea23dfade1be26$var$DEFAULT_SLOW_THRESHOLD;
        // TODO: ED-26959 - get right values here based on appearance
        const freezeThreshold = $a0ea23dfade1be26$export$c8d5b833abcf8e80;
        const allowCountNodes = inputTracking && inputTracking.countNodes;
        let prevNodeCountState = null;
        let prevNodeCount = {};
        // Cache the result as we were calling this multiple times
        // and has potential to be expensive
        const getNodeCount = (state)=>{
            if (state === prevNodeCountState) return prevNodeCount;
            prevNodeCount = allowCountNodes ? (0, $iUiR7.countNodes)(state) : {};
            prevNodeCountState = state;
            return prevNodeCount;
        };
        const shouldTrackSeverity = (inputTracking === null || inputTracking === void 0 ? void 0 : inputTracking.trackSeverity) || $a0ea23dfade1be26$var$DEFAULT_TRACK_SEVERITY_ENABLED;
        const severityThresholdNormal = (inputTracking === null || inputTracking === void 0 ? void 0 : inputTracking.severityNormalThreshold) || $a0ea23dfade1be26$export$5705ac5f923a65e7;
        const severityThresholdDegraded = (inputTracking === null || inputTracking === void 0 ? void 0 : inputTracking.severityDegradedThreshold) || $a0ea23dfade1be26$export$1c6feb3429832c55;
        const createDispatchSample = (action, view)=>(time, severity)=>{
                var _contextIdentifierPlu2;
                const { state: state } = view;
                const nodesCount = getNodeCount(state);
                const samplePayload = {
                    action: action,
                    actionSubject: (0, $g6Qq4.ACTION_SUBJECT).EDITOR,
                    attributes: {
                        time: time,
                        nodeSize: state.doc.nodeSize,
                        ...nodesCount,
                        objectId: contextIdentifierPlugin === null || contextIdentifierPlugin === void 0 || (_contextIdentifierPlu2 = contextIdentifierPlugin.sharedState.currentState()) === null || _contextIdentifierPlu2 === void 0 || (_contextIdentifierPlu2 = _contextIdentifierPlu2.contextIdentifierProvider) === null || _contextIdentifierPlu2 === void 0 ? void 0 : _contextIdentifierPlu2.objectId,
                        severity: shouldTrackSeverity ? severity : undefined
                    },
                    eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL
                };
                dispatchAnalyticsEvent(samplePayload);
            };
        const createDispatchAverage = (action, view)=>({ mean: mean, median: median, sampleSize: sampleSize }, severity)=>{
                var _contextIdentifierPlu3;
                const { state: state } = view;
                const nodeCount = getNodeCount(state);
                const averagePayload = {
                    action: action,
                    actionSubject: (0, $g6Qq4.ACTION_SUBJECT).EDITOR,
                    attributes: {
                        mean: mean,
                        median: median,
                        sampleSize: sampleSize,
                        ...nodeCount,
                        nodeSize: state.doc.nodeSize,
                        severity: shouldTrackSeverity ? severity : undefined,
                        objectId: contextIdentifierPlugin === null || contextIdentifierPlugin === void 0 || (_contextIdentifierPlu3 = contextIdentifierPlugin.sharedState.currentState()) === null || _contextIdentifierPlu3 === void 0 || (_contextIdentifierPlu3 = _contextIdentifierPlu3.contextIdentifierProvider) === null || _contextIdentifierPlu3 === void 0 ? void 0 : _contextIdentifierPlu3.objectId
                    },
                    eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL
                };
                dispatchAnalyticsEvent(averagePayload);
            };
        return new (0, $f7Kk4.SafePlugin)({
            key: $a0ea23dfade1be26$export$70246689264eff75,
            props: (0, $jRBYX.isPerformanceAPIAvailable)() ? {
                handleTextInput (view) {
                    if (browserFreezeTracking !== null && browserFreezeTracking !== void 0 && browserFreezeTracking.trackInteractionType) interactionType = (0, $4S8NW.BROWSER_FREEZE_INTERACTION_TYPE).TYPING;
                    if (inputLatencyTracker) {
                        const end = inputLatencyTracker.start();
                        // This is called after all handleTextInput events are executed which means first handleTextInput time incorporates following handleTextInput processing time
                        // Also this is called before browser rendering so it doesn't count it.
                        requestAnimationFrame(end);
                    }
                    return false;
                },
                handleDOMEvents: browserFreezeTracking !== null && browserFreezeTracking !== void 0 && browserFreezeTracking.trackInteractionType ? {
                    click: ()=>{
                        interactionType = (0, $8deej.setInteractionType)((0, $4S8NW.BROWSER_FREEZE_INTERACTION_TYPE).CLICKING);
                        return false;
                    },
                    paste: ()=>{
                        interactionType = (0, $8deej.setInteractionType)((0, $4S8NW.BROWSER_FREEZE_INTERACTION_TYPE).PASTING);
                        return false;
                    }
                } : undefined
            } : undefined,
            view (view) {
                if (!(0, $jRBYX.isPerformanceObserverAvailable)()) return {};
                inputLatencyTracker = new (0, $lxlLm.default)({
                    samplingRate: samplingRate,
                    slowThreshold: slowThreshold,
                    normalThreshold: severityThresholdNormal,
                    degradedThreshold: severityThresholdDegraded,
                    dispatchSample: createDispatchSample((0, $g6Qq4.ACTION).INPUT_PERF_SAMPLING, view),
                    dispatchAverage: createDispatchAverage((0, $g6Qq4.ACTION).INPUT_PERF_SAMPLING_AVG, view),
                    onSlowInput: (time)=>{
                        var _contextIdentifierPlu4;
                        const { state: state } = view;
                        const nodesCount = getNodeCount(state);
                        dispatchAnalyticsEvent({
                            action: (0, $g6Qq4.ACTION).SLOW_INPUT,
                            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).EDITOR,
                            attributes: {
                                time: time,
                                nodeSize: state.doc.nodeSize,
                                ...nodesCount,
                                objectId: contextIdentifierPlugin === null || contextIdentifierPlugin === void 0 || (_contextIdentifierPlu4 = contextIdentifierPlugin.sharedState.currentState()) === null || _contextIdentifierPlu4 === void 0 || (_contextIdentifierPlu4 = _contextIdentifierPlu4.contextIdentifierProvider) === null || _contextIdentifierPlu4 === void 0 ? void 0 : _contextIdentifierPlu4.objectId
                            },
                            eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL
                        });
                    }
                });
                let observer;
                try {
                    observer = new PerformanceObserver((list)=>{
                        const perfEntries = list.getEntries();
                        for(let i = 0; i < perfEntries.length; i++){
                            const { duration: duration } = perfEntries[i];
                            if (duration > freezeThreshold) $a0ea23dfade1be26$var$dispatchLongTaskEvent(contextIdentifierPlugin)(dispatchAnalyticsEvent, view, duration, getNodeCount, browserFreezeTracking !== null && browserFreezeTracking !== void 0 && browserFreezeTracking.trackInteractionType ? interactionType : undefined, (0, $lrWkt.getAnalyticsEventSeverity)(duration, // Ignored via go/ees007
                            // eslint-disable-next-line @atlaskit/editor/enforce-todo-comment-format
                            //TODO: get right values here
                            severityThresholdNormal, severityThresholdDegraded));
                        }
                    });
                    // register observer for long task notifications
                    observer.observe({
                        entryTypes: [
                            'longtask'
                        ]
                    });
                } catch (e) {}
                return {
                    destroy: ()=>{
                        var _inputLatencyTracker, _observer;
                        (_inputLatencyTracker = inputLatencyTracker) === null || _inputLatencyTracker === void 0 || _inputLatencyTracker.flush();
                        (_observer = observer) === null || _observer === void 0 || _observer.disconnect();
                    }
                };
            }
        });
    };

});
parcelRegister("8deej", function(module, exports) {
$parcel$export(module.exports, "setInteractionType", () => $edeb57040a6318eb$export$324d9bc8f4935d84);
/** Allows the possibility of overriding interaction type values in unit tests via jest.mock or spyOn. */ const $edeb57040a6318eb$export$324d9bc8f4935d84 = (value)=>value;

});

parcelRegister("lxlLm", function(module, exports) {
$parcel$export(module.exports, "default", () => $9bbfe9edb02e1958$export$2e2bcd8739ae039);

var $lrWkt = parcelRequire("lrWkt");

var $cpnxI = parcelRequire("cpnxI");
class $9bbfe9edb02e1958$export$2e2bcd8739ae039 {
    constructor({ samplingRate: samplingRate, slowThreshold: slowThreshold, normalThreshold: normalThreshold, degradedThreshold: degradedThreshold, dispatchAverage: dispatchAverage, dispatchSample: dispatchSample, onSampleStart: onSampleStart, onSampleEnd: onSampleEnd, onSlowInput: onSlowInput }){
        this.samples = [];
        this.total = 0;
        this.samplingRate = samplingRate;
        this.slowThreshold = slowThreshold;
        this.normalThreshold = normalThreshold;
        this.degradedThreshold = degradedThreshold;
        this.dispatchAverage = dispatchAverage;
        this.dispatchSample = dispatchSample;
        this.onSampleStart = onSampleStart;
        this.onSampleEnd = onSampleEnd;
        this.onSlowInput = onSlowInput;
    }
    start() {
        const currentStart = performance.now();
        if (this.samples.length + 1 === this.samplingRate) {
            var _this$onSampleStart;
            (_this$onSampleStart = this.onSampleStart) === null || _this$onSampleStart === void 0 || _this$onSampleStart.call(this);
        }
        const end = ()=>{
            if (currentStart === null) return;
            let isSlow = false;
            const time = (0, $cpnxI.getTimeSince)(currentStart);
            this.push(time);
            if (time > this.slowThreshold) {
                var _this$onSlowInput;
                (_this$onSlowInput = this.onSlowInput) === null || _this$onSlowInput === void 0 || _this$onSlowInput.call(this, time);
                isSlow = true;
            }
            if (this.samples.length === this.samplingRate) {
                var _this$onSampleEnd;
                this.flush();
                (_this$onSampleEnd = this.onSampleEnd) === null || _this$onSampleEnd === void 0 || _this$onSampleEnd.call(this, time, {
                    isSlow: isSlow,
                    severity: this.severity(time)
                });
            }
        };
        return end;
    }
    flush() {
        if (this.samples.length === 0) return;
        this.dispatch();
        this.samples = [];
        this.total = 0;
    }
    dispatch() {
        var _this$dispatchSample, _this$dispatchAverage;
        (_this$dispatchSample = this.dispatchSample) === null || _this$dispatchSample === void 0 || _this$dispatchSample.call(this, this.getLast(), this.severity(this.getLast()));
        // cache
        const median = this.getMedian();
        (_this$dispatchAverage = this.dispatchAverage) === null || _this$dispatchAverage === void 0 || _this$dispatchAverage.call(this, {
            mean: this.getMean(),
            median: median,
            sampleSize: this.samples.length
        }, this.severity(median));
    }
    push(latency) {
        this.samples.push(latency);
        this.total += latency;
    }
    severity(time) {
        return (0, $lrWkt.getAnalyticsEventSeverity)(time, this.normalThreshold, this.degradedThreshold);
    }
    getLast() {
        return this.samples[this.samples.length - 1];
    }
    getMean() {
        return this.total / this.samples.length;
    }
    getMedian() {
        if (this.samples.length === 1) return this.samples[0];
        this.samples.sort((a, b)=>a - b);
        const middle = (this.samples.length + 1) / 2;
        const floorMiddle = Math.floor(middle);
        const remainder = middle % floorMiddle;
        if (remainder === 0) return this.samples[middle - 1];
        const left = this.samples[floorMiddle - 1];
        const right = this.samples[floorMiddle];
        return (left + right) / 2;
    }
}

});
parcelRegister("cpnxI", function(module, exports) {
$parcel$export(module.exports, "getTimeSince", () => $73690802df1c1533$export$a26b90db2c8f1b97);
/**
 * Calculate the difference between performance.now() and the given startTime.
 * This allows for the timing to be overridable during tests.
 *
 * @param startTime DOMHighResTimeStamp
 * @returns DOMHighResTimeStamp
 */ const $73690802df1c1533$export$a26b90db2c8f1b97 = (startTime)=>performance.now() - startTime;

});



parcelRegister("23Y04", function(module, exports) {
$parcel$export(module.exports, "default", () => $1f21a31171a9a830$export$2e2bcd8739ae039);

var $jxkn6 = parcelRequire("jxkn6");

var $f7Kk4 = parcelRequire("f7Kk4");

var $aTdXU = parcelRequire("aTdXU");

var $kuD5k = parcelRequire("kuD5k");

var $cw0wu = parcelRequire("cw0wu");

var $a3b9P = parcelRequire("a3b9P");
const $1f21a31171a9a830$export$8836bfc6be4cb708 = new (0, $cw0wu.PluginKey)('inlineCursorTargetPlugin');
const $1f21a31171a9a830$var$isInlineNodeView = (node)=>{
    /**
   * If inlineNodeView is a hardbreak we don't want to add decorations
   * as it breaks soft line breaks for Japanese/Chinese keyboards.
   */ const isHardBreak = (node === null || node === void 0 ? void 0 : node.type) === (node === null || node === void 0 ? void 0 : node.type.schema.nodes.hardBreak);
    return node && node.type.isInline && !node.type.isText && !isHardBreak;
};
var $1f21a31171a9a830$export$2e2bcd8739ae039 = ()=>{
    return new (0, $f7Kk4.SafePlugin)({
        key: $1f21a31171a9a830$export$8836bfc6be4cb708,
        state: {
            init: ()=>({
                    cursorTarget: undefined
                }),
            apply (tr) {
                const { selection: selection, doc: doc } = tr;
                const { $from: $from, $to: $to } = selection;
                // In Safari, if the cursor target is to the right of the cursor it will block selections
                // made with shift + arrowRight and vice versa for shift + arrowLeft. This is due to a
                // contenteditable bug in safari, where editable elements block the selection but we need
                // the cursor target to be editable for the following:
                // - Ability to navigate with down/up arrows when between inline nodes
                // - Ability to navigate with down/up arrows when between the start of a paragraph & an inline node
                // - Ability to click and drag to select an inline node if it is the first node
                // To prevent blocking the selection, we check handleDOMEvents and add meta to
                // the transaction to prevent the plugin from making cursor target decorations.
                const safariShiftSelection = tr.getMeta($1f21a31171a9a830$export$8836bfc6be4cb708);
                if (selection && (0, $aTdXU.isTextSelection)(selection) && !safariShiftSelection) {
                    const hasInlineNodeViewAfter = $1f21a31171a9a830$var$isInlineNodeView($from.nodeAfter);
                    const hasInlineNodeViewBefore = $1f21a31171a9a830$var$isInlineNodeView($from.nodeBefore);
                    const isAtStartAndInlineNodeViewAfter = $from.parentOffset === 0 && $1f21a31171a9a830$var$isInlineNodeView($from.nodeAfter);
                    const isAtEndAndInlineNodeViewBefore = doc.resolve($from.pos).node().lastChild === $from.nodeBefore && $1f21a31171a9a830$var$isInlineNodeView($from.nodeBefore);
                    const createWidget = (side)=>{
                        const node = document.createElement('span');
                        node.contentEditable = 'true';
                        node.setAttribute('aria-hidden', 'true');
                        node.appendChild(document.createTextNode((0, $kuD5k.ZERO_WIDTH_SPACE)));
                        node.className = 'cursor-target';
                        const { $from: $from } = selection;
                        const rightPosition = $from.pos;
                        const leftPosition = $from.posAtIndex(Math.max($from.index() - 1, 0));
                        const widgetPos = side === 'left' ? leftPosition : rightPosition;
                        return (0, $a3b9P.Decoration).widget(widgetPos, node, {
                            raw: true,
                            key: 'inlineCursor'
                        });
                    };
                    // Create editable decoration widgets around the current inline node to allow proper cursor navigation.
                    if ((hasInlineNodeViewAfter || isAtEndAndInlineNodeViewBefore) && (hasInlineNodeViewBefore || isAtStartAndInlineNodeViewAfter)) return {
                        cursorTarget: {
                            decorations: [
                                createWidget('left'),
                                createWidget('right')
                            ],
                            positions: {
                                from: $from.pos,
                                to: $to.pos
                            }
                        }
                    };
                }
                return {
                    cursorTarget: undefined
                };
            }
        },
        props: {
            decorations (state) {
                const { doc: doc } = state;
                const { cursorTarget: cursorTarget } = $1f21a31171a9a830$export$8836bfc6be4cb708.getState(state);
                if ($1f21a31171a9a830$var$cursorTargetHasValidDecorations(cursorTarget)) return (0, $a3b9P.DecorationSet).create(doc, cursorTarget.decorations);
                return null;
            },
            handleDOMEvents: {
                // Workaround to prevent the decorations created by the plugin from
                // blocking shift + arrow left/right selections in safari. When
                // a shift + arrow left/right event is detected, send meta data to the
                // plugin to prevent it from creating decorations.
                // TODO: ED-26959 - We may be able to remove this when playing the following ticket:
                // https://product-fabric.atlassian.net/browse/ED-14938
                keydown: (view, event)=>{
                    const browser = (0, $jxkn6.getBrowserInfo)();
                    if (browser.safari && event instanceof KeyboardEvent && event.shiftKey && (event.key === 'ArrowLeft' || event.key === 'ArrowRight')) view.dispatch(view.state.tr.setMeta($1f21a31171a9a830$export$8836bfc6be4cb708, {
                        cursorTarget: undefined
                    }));
                    return false;
                },
                // Check the DOM to see if there are inline cursor targets
                // after a composition event ends. If so, manually insert the
                // event data in order to prevent contents ending up inside
                // of the cursor target decorations.
                compositionend: (view, incorrectlyTypedEvent)=>{
                    // This is typed by the prosemirror definitions as Event,
                    // this type is incorrect, and it is actually an InputEvent
                    const event = incorrectlyTypedEvent;
                    const { state: state } = view;
                    const { cursorTarget: cursorTarget } = $1f21a31171a9a830$export$8836bfc6be4cb708.getState(state);
                    if (cursorTarget !== undefined) {
                        $1f21a31171a9a830$var$handleTextInputInsideCursorTargetDecoration({
                            event: event,
                            cursorTarget: cursorTarget,
                            view: view
                        });
                        return true;
                    }
                    return false;
                },
                // Check the DOM to see if there are inline cursor targets
                // before any input event. If so, manually insert the
                // event data in order to prevent contents ending up inside
                // of the cursor target decorations.
                beforeinput: (view, incorrectlyTypedEvent)=>{
                    // This is typed by the prosemirror definitions as Event,
                    // this type is incorrect, and it is actually an InputEvent
                    const event = incorrectlyTypedEvent;
                    const { state: state } = view;
                    const { cursorTarget: cursorTarget } = $1f21a31171a9a830$export$8836bfc6be4cb708.getState(state);
                    if (!event.isComposing && cursorTarget !== undefined) {
                        $1f21a31171a9a830$var$handleTextInputInsideCursorTargetDecoration({
                            event: event,
                            cursorTarget: cursorTarget,
                            view: view
                        });
                        return true;
                    }
                    return false;
                }
            }
        }
    });
};
function $1f21a31171a9a830$var$cursorTargetHasValidDecorations(cursorTarget) {
    if (!cursorTarget || // Decorations can end up as null when the decorations prop is
    // called after the decorations have been removed from the dom.
    // https://github.com/ProseMirror/prosemirror-view/blob/8f0d313a6389b86a335274fba36534ba1cb21f12/src/decoration.js#L30
    cursorTarget.decorations.includes(null)) return false;
    return true;
}
function $1f21a31171a9a830$var$handleTextInputInsideCursorTargetDecoration({ event: event, view: view, cursorTarget: cursorTarget }) {
    event.stopPropagation();
    event.preventDefault();
    const content = event.data || '';
    // ensure any custom handleTextInput handlers are called for the input event
    // ie. type ahead, emoji shortcuts.
    const defaultTransaction = ()=>view.state.tr.insertText(content, cursorTarget.positions.from, cursorTarget.positions.to);
    const potentiallyHandleByHandleTextInput = view.someProp('handleTextInput', (f)=>f(view, cursorTarget.positions.from, cursorTarget.positions.to, content, defaultTransaction));
    if (potentiallyHandleByHandleTextInput) // if a handleTextInput handler has handled the event, we don't want to
    // manually update the document.
    return;
    view.dispatch(defaultTransaction());
}

});

parcelRegister("2Oycl", function(module, exports) {
$parcel$export(module.exports, "createLazyNodeViewDecorationPlugin", () => $ee69072fafe28261$export$650082547b31be68);

var $1qOmx = parcelRequire("1qOmx");

var $f7Kk4 = parcelRequire("f7Kk4");

var $a3b9P = parcelRequire("a3b9P");
const $ee69072fafe28261$var$LAZY_NODE_VIEW_DECORATION_CLASS = '__lazy-node-view-decoration__';
function $ee69072fafe28261$export$650082547b31be68() {
    return new (0, $f7Kk4.SafePlugin)({
        key: (0, $1qOmx.lazyNodeViewDecorationPluginKey),
        state: {
            init: ()=>{
                return {
                    decorations: (0, $a3b9P.DecorationSet).empty,
                    nodeTypes: []
                };
            },
            apply (tr, _oldState, newState) {
                const actionPayload = tr.getMeta((0, $1qOmx.lazyNodeViewDecorationPluginKey));
                const pluginState = (0, $1qOmx.lazyNodeViewDecorationPluginKey).getState(newState);
                if ((actionPayload === null || actionPayload === void 0 ? void 0 : actionPayload.type) === 'add' && actionPayload.nodeTypes.size) {
                    const decorations = [];
                    tr.doc.nodesBetween(0, tr.doc.nodeSize - 2, (node, pos)=>{
                        if (actionPayload.nodeTypes.has(node.type.name)) decorations.push((0, $a3b9P.Decoration).node(pos, pos + node.nodeSize, {
                            class: $ee69072fafe28261$var$LAZY_NODE_VIEW_DECORATION_CLASS
                        }));
                    });
                    return {
                        decorations: (0, $a3b9P.DecorationSet).create(tr.doc, decorations)
                    };
                }
                if ((actionPayload === null || actionPayload === void 0 ? void 0 : actionPayload.type) === 'clear') return {
                    decorations: (0, $a3b9P.DecorationSet).empty
                };
                if (tr.docChanged) return {
                    decorations: pluginState === null || pluginState === void 0 ? void 0 : pluginState.decorations.map(tr.mapping, tr.doc)
                };
                return pluginState;
            }
        },
        props: {
            decorations: (state)=>{
                var _lazyNodeViewDecorati;
                return (_lazyNodeViewDecorati = (0, $1qOmx.lazyNodeViewDecorationPluginKey).getState(state)) === null || _lazyNodeViewDecorati === void 0 ? void 0 : _lazyNodeViewDecorati.decorations;
            }
        },
        view (editorView) {
            return {
                update () {
                    /**
           * After view update can clean up decorations...
           */ const pluginState = (0, $1qOmx.lazyNodeViewDecorationPluginKey).getState(editorView.state);
                    if (pluginState.decorations !== (0, $a3b9P.DecorationSet).empty) {
                        const tr = editorView.state.tr;
                        tr.setMeta((0, $1qOmx.lazyNodeViewDecorationPluginKey), {
                            type: 'clear'
                        });
                        editorView.dispatch(tr);
                    }
                }
            };
        }
    });
}

});

parcelRegister("4xnbo", function(module, exports) {
$parcel$export(module.exports, "default", () => $f303db0f2a67e4e4$export$2e2bcd8739ae039);

var $f7Kk4 = parcelRequire("f7Kk4");

var $cSk7K = parcelRequire("cSk7K");
var $KawKV = parcelRequire("KawKV");

var $ejrfk = parcelRequire("ejrfk");

var $cw0wu = parcelRequire("cw0wu");
const $f303db0f2a67e4e4$export$2f489388b18569dd = new (0, $cw0wu.PluginKey)('newlinePreserveMarksPlugin');
const $f303db0f2a67e4e4$var$isSelectionAligned = (state)=>!!state.selection.$to.parent.marks.find((m)=>m.type === state.schema.marks.alignment);
const $f303db0f2a67e4e4$var$isSelectionFontSized = (state)=>{
    const { blockTaskItem: blockTaskItem, listItem: listItem } = state.schema.nodes;
    const { fontSize: fontSize } = state.schema.marks;
    const $to = state.selection.$to;
    const grandParent = $to.node($to.depth - 1);
    if (!fontSize || // don't intercept Enter inside blockTaskItem or listItem
    grandParent && (grandParent.type === blockTaskItem || grandParent.type === listItem)) return false;
    return !!$to.parent.marks.find((m)=>m.type === fontSize);
};
const $f303db0f2a67e4e4$var$hasBlockMarksToPreserve = (state)=>$f303db0f2a67e4e4$var$isSelectionAligned(state) || $f303db0f2a67e4e4$var$isSelectionFontSized(state);
const $f303db0f2a67e4e4$var$splitBlockPreservingMarks = (state, dispatch)=>{
    if (dispatch) dispatch(state.tr.split(state.tr.mapping.map(state.selection.$from.pos), 1));
    return true;
};
var $f303db0f2a67e4e4$export$2e2bcd8739ae039 = ()=>new (0, $f7Kk4.SafePlugin)({
        key: $f303db0f2a67e4e4$export$2f489388b18569dd,
        props: {
            handleKeyDown: (0, $ejrfk.keydownHandler)({
                Enter: (0, $cSk7K.filter)([
                    (0, $KawKV.isSelectionEndOfParagraph),
                    $f303db0f2a67e4e4$var$hasBlockMarksToPreserve
                ], $f303db0f2a67e4e4$var$splitBlockPreservingMarks)
            })
        }
    });

});

parcelRegister("7KO6o", function(module, exports) {
$parcel$export(module.exports, "default", () => $20af34226d11a0df$export$2e2bcd8739ae039);

var $f7Kk4 = parcelRequire("f7Kk4");

var $797yE = parcelRequire("797yE");

var $bWbzK = parcelRequire("bWbzK");
const $20af34226d11a0df$var$GUTTER_SIZE_IN_PX = 120;
const $20af34226d11a0df$var$GUTTER_SELECTOR_NAME = 'editor-scroll-gutter';
const $20af34226d11a0df$var$GUTTER_ATTR = 'data-editor-scroll-gutter';
/**
 * Create a gutter element that can be added or removed from the DOM.
 */ function $20af34226d11a0df$var$createGutter(gutterSize, parent) {
    if ((0, $797yE.editorExperiment)('platform_editor_blocks', true)) {
        if (!parent) return ()=>{};
        const existing = parent.querySelector(`[${$20af34226d11a0df$var$GUTTER_ATTR}]`);
        if (existing instanceof HTMLElement) return ()=>parent.removeChild(existing);
        const gutter = document.createElement('div');
        gutter.style.paddingBottom = `${gutterSize}px`;
        gutter.setAttribute('data-vc', 'scroll-gutter');
        gutter.setAttribute($20af34226d11a0df$var$GUTTER_ATTR, 'true');
        parent.appendChild(gutter);
        return ()=>parent.removeChild(gutter);
    }
    const gutterRef = document.getElementById($20af34226d11a0df$var$GUTTER_SELECTOR_NAME);
    if (gutterRef) return ()=>parent === null || parent === void 0 ? void 0 : parent.removeChild(gutterRef);
    const gutter = document.createElement('div');
    gutter.style.paddingBottom = `${gutterSize}px`;
    gutter.setAttribute('data-vc', 'scroll-gutter');
    gutter.id = $20af34226d11a0df$var$GUTTER_SELECTOR_NAME;
    if (parent) parent.appendChild(gutter);
    return ()=>parent === null || parent === void 0 ? void 0 : parent.removeChild(gutter);
}
var // eslint-disable-next-line @typescript-eslint/no-empty-object-type
$20af34226d11a0df$export$2e2bcd8739ae039 = (pluginOptions = {})=>{
    const { getScrollElement: getScrollElement, gutterSize: gutterSize = $20af34226d11a0df$var$GUTTER_SIZE_IN_PX } = pluginOptions;
    if (!getScrollElement) return undefined;
    return new (0, $f7Kk4.SafePlugin)({
        key: (0, $bWbzK.scrollGutterPluginKey),
        state: {
            init: ()=>({}),
            apply: (tr, pluginState)=>{
                if (tr.getMeta((0, $bWbzK.scrollGutterPluginKey))) return tr.getMeta((0, $bWbzK.scrollGutterPluginKey));
                return pluginState;
            }
        },
        props: {
            // Determines the distance (in pixels) between the cursor and the end of the visible viewport at which point,
            // when scrolling the cursor into view, scrolling takes place.
            // Defaults to 0: https://prosemirror.net/docs/ref/#view.EditorProps.scrollThreshold
            scrollThreshold: gutterSize,
            // Determines the extra space (in pixels) that is left above or below the cursor when it is scrolled into view.
            // Defaults to 5: https://prosemirror.net/docs/ref/#view.EditorProps.scrollMargin
            scrollMargin: gutterSize
        },
        view (view) {
            var _editorElement;
            // Store references to avoid lookups on successive checks.
            const scrollElement = getScrollElement(view);
            let editorElement = view.dom instanceof HTMLElement ? view.dom : null;
            let editorParentElement = (_editorElement = editorElement) === null || _editorElement === void 0 ? void 0 : _editorElement.parentElement;
            let cleanup = ()=>{};
            if (editorParentElement && scrollElement) cleanup = $20af34226d11a0df$var$createGutter(gutterSize, editorParentElement);
            return {
                destroy () {
                    cleanup();
                    editorParentElement = editorElement = null;
                }
            };
        }
    });
};

});

parcelRegister("02w6v", function(module, exports) {
$parcel$export(module.exports, "getKeyboardHeight", () => $db39de4a588b1720$export$af5702f0c69bf4d7);

var $bWbzK = parcelRequire("bWbzK");
const $db39de4a588b1720$export$af5702f0c69bf4d7 = (state)=>{
    if (state) {
        const scrollGutterPluginState = (0, $bWbzK.getScrollGutterPluginState)(state);
        return scrollGutterPluginState ? scrollGutterPluginState.keyboardHeight : undefined;
    }
};

});

parcelRegister("8QqlY", function(module, exports) {
$parcel$export(module.exports, "inputTracking", () => $6da161934e75f7df$export$30b652f8daa79df4);
const $6da161934e75f7df$export$30b652f8daa79df4 = {
    enabled: true,
    samplingRate: 100,
    countNodes: true,
    trackSeverity: true,
    trackRenderingTime: false,
    trackSingleKeypress: false,
    // TODO: ED-26959 - change this based on appearance due to SLOs - need to make ticket for both
    severityDegradedThreshold: 273,
    severityNormalThreshold: 143
};

});


parcelRegister("3ndaT", function(module, exports) {
$parcel$export(module.exports, "betterTypeHistoryPlugin", () => $2c0c3978db5b4ff9$export$5587393ddd97118a);

var $4F4eb = parcelRequire("4F4eb");

var $dRQI0 = parcelRequire("dRQI0");
/**
 * This plugin is aiming to improve undo behaviour for some of our more custom applications, very specific text
 * paste events, splitting blocks of text, new lines.
 */ const $2c0c3978db5b4ff9$export$5587393ddd97118a = ()=>{
    return {
        name: 'betterTypeHistory',
        actions: {
            flagPasteEvent (tr) {
                tr.setMeta((0, $dRQI0.pluginKey), true);
                return tr;
            }
        },
        pmPlugins () {
            return [
                {
                    name: 'betterTypeHistory',
                    plugin: ()=>(0, $4F4eb.default)()
                }
            ];
        }
    };
};

});
parcelRegister("4F4eb", function(module, exports) {
$parcel$export(module.exports, "default", () => $4d2c02bfc16737be$export$2e2bcd8739ae039);

var $f7Kk4 = parcelRequire("f7Kk4");

var $5eokt = parcelRequire("5eokt");

var $kW8qW = parcelRequire("kW8qW");

var $cw0wu = parcelRequire("cw0wu");

var $3DNV7 = parcelRequire("3DNV7");

var $kQkyj = parcelRequire("kQkyj");

var $dRQI0 = parcelRequire("dRQI0");
const $4d2c02bfc16737be$var$getEnterKeyboardActionStep = (trs)=>{
    const firstTr = trs.length === 1 && trs[0];
    if (!firstTr || !firstTr.docChanged || !firstTr.isGeneric || !(firstTr.selection instanceof (0, $cw0wu.TextSelection))) return null;
    const { selection: selection, steps: steps } = firstTr;
    const replaceSteps = steps.filter((step)=>step instanceof (0, $3DNV7.ReplaceStep) || step instanceof (0, $3DNV7.ReplaceAroundStep));
    if (!selection.$cursor || replaceSteps.length !== 1) return null;
    return replaceSteps[0];
};
const $4d2c02bfc16737be$var$isSliceSplittingBlockNode = (slice)=>{
    const hasOnlyTwoChildren = slice.size > 1 && slice.content.childCount === 2;
    if (!hasOnlyTwoChildren) return false;
    const firstNode = slice.content.child(0);
    const secondNode = slice.content.child(1);
    return firstNode && secondNode && firstNode.type === secondNode.type;
};
const $4d2c02bfc16737be$var$isSliceAddingNewlineChar = (slice, schema)=>{
    const newLine = (0, $kW8qW.Fragment).from(schema.text('\n'));
    return slice.content.eq(newLine);
};
var $4d2c02bfc16737be$export$2e2bcd8739ae039 = ()=>{
    return new (0, $f7Kk4.SafePlugin)({
        key: (0, $dRQI0.pluginKey),
        appendTransaction: (transactions, oldState, newState)=>{
            const hasHandlePasteMeta = transactions.find((tran)=>tran.getMeta((0, $dRQI0.pluginKey)));
            if (hasHandlePasteMeta) return (0, $kQkyj.closeHistory)(newState.tr);
            const enterStep = $4d2c02bfc16737be$var$getEnterKeyboardActionStep(transactions);
            if (!enterStep) return;
            const slice = (0, $5eokt.extractSliceFromStep)(enterStep);
            const { schema: schema } = newState;
            if (slice && ($4d2c02bfc16737be$var$isSliceSplittingBlockNode(slice) || $4d2c02bfc16737be$var$isSliceAddingNewlineChar(slice, schema))) return (0, $kQkyj.closeHistory)(newState.tr);
        }
    });
};

});
parcelRegister("dRQI0", function(module, exports) {
$parcel$export(module.exports, "pluginKey", () => $d755d617b6702a78$export$18d4026d1ea86bb1);

var $cw0wu = parcelRequire("cw0wu");
const $d755d617b6702a78$export$18d4026d1ea86bb1 = new (0, $cw0wu.PluginKey)('betterTypeHistoryPlugin');

});



parcelRegister("9QiVY", function(module, exports) {
$parcel$export(module.exports, "blockTypePlugin", () => $901f93c4434bca6b$export$896c3d927d705025);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $1dTNM = parcelRequire("1dTNM");

var $lCTYs = parcelRequire("lCTYs");

var $l4kwz = parcelRequire("l4kwz");

var $eqk7K = parcelRequire("eqk7K");

var $g6Qq4 = parcelRequire("g6Qq4");

var $5BUNL = parcelRequire("5BUNL");

var $bdXbU = parcelRequire("bdXbU");

var $cv8id = parcelRequire("cv8id");

var $8iYGb = parcelRequire("8iYGb");

var $d0HRE = parcelRequire("d0HRE");

var $3y2s4 = parcelRequire("3y2s4");

var $gdUUy = parcelRequire("gdUUy");

var $797yE = parcelRequire("797yE");

var $5j7nF = parcelRequire("5j7nF");

var $en3JK = parcelRequire("en3JK");

var $cMYAZ = parcelRequire("cMYAZ");

var $fnYyJ = parcelRequire("fnYyJ");

var $5Cj1s = parcelRequire("5Cj1s");

var $d5Qde = parcelRequire("d5Qde");

var $lD7vN = parcelRequire("lD7vN");

var $lzFsh = parcelRequire("lzFsh");

var $lQQ25 = parcelRequire("lQQ25");
const $901f93c4434bca6b$var$headingPluginOptions = ({ formatMessage: formatMessage }, isAllowed, editorAnalyticsApi)=>{
    if (!isAllowed) return [];
    return Array.from({
        length: 6
    }, (_v, idx)=>{
        const level = idx + 1;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const descriptionDescriptor = (0, $8iYGb.messages)[`heading${level}Description`];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const keyshortcut = (0, $cv8id.tooltip)((0, $bdXbU.keymap)[`toggleHeading${level}`]);
        const id = `heading${level}`;
        return {
            id: id,
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            title: formatMessage((0, $8iYGb.messages)[id]),
            description: formatMessage(descriptionDescriptor),
            priority: 1300,
            keywords: [
                `h${level}`
            ],
            keyshortcut: keyshortcut,
            icon: ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $5BUNL.IconHeading), {
                    level: level
                }),
            action (insert, state) {
                const tr = insert(state.schema.nodes.heading.createChecked({
                    level: level
                }));
                editorAnalyticsApi === null || editorAnalyticsApi === void 0 || editorAnalyticsApi.attachAnalyticsEvent({
                    action: (0, $g6Qq4.ACTION).FORMATTED,
                    actionSubject: (0, $g6Qq4.ACTION_SUBJECT).TEXT,
                    eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
                    actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).FORMAT_HEADING,
                    attributes: {
                        inputMethod: (0, $g6Qq4.INPUT_METHOD).QUICK_INSERT,
                        newHeadingLevel: level
                    }
                })(tr);
                return tr;
            }
        };
    });
};
const $901f93c4434bca6b$var$blockquotePluginOptions = ({ formatMessage: formatMessage }, isAllowed, editorAnalyticsApi)=>{
    if (!isAllowed) return [];
    return [
        {
            id: 'blockquote',
            title: formatMessage((0, $8iYGb.messages).blockquote),
            description: formatMessage((0, $8iYGb.messages).blockquoteDescription),
            priority: 1300,
            keyshortcut: '>',
            icon: ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $5BUNL.IconQuote), {}),
            action (insert, state) {
                const tr = insert(state.schema.nodes.blockquote.createChecked({}, state.schema.nodes.paragraph.createChecked()));
                editorAnalyticsApi === null || editorAnalyticsApi === void 0 || editorAnalyticsApi.attachAnalyticsEvent({
                    action: (0, $g6Qq4.ACTION).FORMATTED,
                    actionSubject: (0, $g6Qq4.ACTION_SUBJECT).TEXT,
                    eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
                    actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).FORMAT_BLOCK_QUOTE,
                    attributes: {
                        inputMethod: (0, $g6Qq4.INPUT_METHOD).QUICK_INSERT
                    }
                })(tr);
                return tr;
            }
        }
    ];
};
const $901f93c4434bca6b$export$896c3d927d705025 = ({ config: options, api: api })=>{
    var _api$blockMenu;
    const isToolbarAIFCEnabled = Boolean(api === null || api === void 0 ? void 0 : api.toolbar);
    const isRegisteredSlashCommandEnabled = (0, $3y2s4.isExperimentEnabled)('platform_editor_slash_command');
    const primaryToolbarComponent = ({ popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, toolbarSize: toolbarSize, disabled: disabled, isToolbarReducedSpacing: isToolbarReducedSpacing })=>{
        const isSmall = toolbarSize < (0, $d0HRE.ToolbarSize).XXL;
        return /*#__PURE__*/ (0, $dc70d.jsx)((0, $d5Qde.PrimaryToolbarComponent), {
            isSmall: isSmall,
            disabled: disabled,
            isToolbarReducedSpacing: isToolbarReducedSpacing,
            api: api,
            popupsMountPoint: popupsMountPoint,
            popupsBoundariesElement: popupsBoundariesElement,
            popupsScrollableElement: popupsScrollableElement,
            shouldUseDefaultRole: false
        });
    };
    if (isToolbarAIFCEnabled) {
        var _api$toolbar;
        api === null || api === void 0 || (_api$toolbar = api.toolbar) === null || _api$toolbar === void 0 || _api$toolbar.actions.registerComponents((0, $lD7vN.getToolbarComponents)(api, options === null || options === void 0 ? void 0 : options.allowFontSize));
    } else {
        var _api$primaryToolbar;
        api === null || api === void 0 || (_api$primaryToolbar = api.primaryToolbar) === null || _api$primaryToolbar === void 0 || _api$primaryToolbar.actions.registerComponent({
            name: 'blockType',
            component: primaryToolbarComponent
        });
    }
    api === null || api === void 0 || (_api$blockMenu = api.blockMenu) === null || _api$blockMenu === void 0 || _api$blockMenu.actions.registerBlockMenuComponents((0, $lzFsh.getBlockTypeComponents)(api, {
        allowFontSize: options === null || options === void 0 ? void 0 : options.allowFontSize
    }));
    if (isRegisteredSlashCommandEnabled) {
        var _api$uiControlRegistr, _options$allowBlockTy;
        api === null || api === void 0 || (_api$uiControlRegistr = api.uiControlRegistry) === null || _api$uiControlRegistr === void 0 || _api$uiControlRegistr.actions.register((0, $lQQ25.getBlockTypeQuickInsertComponents)({
            api: api,
            exclude: (options === null || options === void 0 || (_options$allowBlockTy = options.allowBlockType) === null || _options$allowBlockTy === void 0 ? void 0 : _options$allowBlockTy.exclude) ?? []
        }));
    }
    return {
        name: 'blockType',
        nodes () {
            const nodes = [
                {
                    name: 'heading',
                    node: (0, $eqk7K.heading)
                },
                {
                    name: 'blockquote',
                    node: (0, $gdUUy.fg)('platform_editor_adf_with_localid') ? (0, $1dTNM.extendedBlockquoteWithLocalId) : (0, $1dTNM.extendedBlockquote)
                },
                {
                    name: 'hardBreak',
                    node: (0, $l4kwz.hardBreak)
                }
            ];
            if (options && options.allowBlockType) {
                const exclude = options.allowBlockType.exclude ? options.allowBlockType.exclude : [];
                return nodes.filter((node)=>exclude.indexOf(node.name) === -1);
            }
            return nodes;
        },
        marks () {
            if (options !== null && options !== void 0 && options.allowFontSize) return [
                {
                    name: 'fontSize',
                    mark: (0, $lCTYs.fontSize)
                }
            ];
            return [];
        },
        pmPlugins () {
            return [
                {
                    name: 'blockType',
                    plugin: ({ dispatch: dispatch })=>{
                        return (0, $fnYyJ.createPlugin)(api, dispatch, options && options.lastNodeMustBeParagraph, options === null || options === void 0 ? void 0 : options.includeBlockQuoteAsTextstyleOption, options === null || options === void 0 ? void 0 : options.allowFontSize);
                    }
                },
                {
                    name: 'blockTypeInputRule',
                    plugin: ({ schema: schema, featureFlags: featureFlags })=>{
                        var _api$analytics;
                        return (0, $en3JK.default)(api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions, schema, featureFlags);
                    }
                },
                // Needs to be lower priority than editor-tables.tableEditing
                // plugin as it is currently swallowing right/down arrow events inside tables
                {
                    name: 'blockTypeKeyMap',
                    plugin: ({ schema: schema, featureFlags: featureFlags })=>{
                        var _api$analytics2;
                        return (0, $cMYAZ.default)(api === null || api === void 0 || (_api$analytics2 = api.analytics) === null || _api$analytics2 === void 0 ? void 0 : _api$analytics2.actions, schema, featureFlags);
                    }
                }
            ];
        },
        actions: {
            insertBlockQuote (inputMethod) {
                var _api$analytics3;
                return (0, $5j7nF.insertBlockQuoteWithAnalytics)(inputMethod, api === null || api === void 0 || (_api$analytics3 = api.analytics) === null || _api$analytics3 === void 0 ? void 0 : _api$analytics3.actions);
            }
        },
        commands: {
            setTextLevel (level, inputMethod, fromBlockQuote = false) {
                var _api$analytics4;
                return (0, $5j7nF.setBlockTypeWithAnalytics)(level, inputMethod, api === null || api === void 0 || (_api$analytics4 = api.analytics) === null || _api$analytics4 === void 0 ? void 0 : _api$analytics4.actions, fromBlockQuote);
            },
            insertBlockQuote (inputMethod) {
                var _api$analytics5;
                return (0, $5j7nF.insertBlockQuoteWithAnalyticsCommand)(inputMethod, api === null || api === void 0 || (_api$analytics5 = api.analytics) === null || _api$analytics5 === void 0 ? void 0 : _api$analytics5.actions);
            },
            clearFormatting (inputMethod) {
                var _api$analytics6;
                return (0, $5j7nF.clearFormatting)(inputMethod, api === null || api === void 0 || (_api$analytics6 = api.analytics) === null || _api$analytics6 === void 0 ? void 0 : _api$analytics6.actions);
            }
        },
        getSharedState (editorState) {
            if (!editorState) return;
            return (0, $fnYyJ.pluginKey).getState(editorState);
        },
        primaryToolbarComponent: !(api !== null && api !== void 0 && api.primaryToolbar) ? primaryToolbarComponent : undefined,
        pluginsOptions: {
            ...!isToolbarAIFCEnabled && {
                selectionToolbar: ()=>{
                    var _api$userPreferences;
                    const toolbarDocking = api === null || api === void 0 || (_api$userPreferences = api.userPreferences) === null || _api$userPreferences === void 0 || (_api$userPreferences = _api$userPreferences.sharedState.currentState()) === null || _api$userPreferences === void 0 || (_api$userPreferences = _api$userPreferences.preferences) === null || _api$userPreferences === void 0 ? void 0 : _api$userPreferences.toolbarDockingPosition;
                    if (toolbarDocking === 'none' && (0, $797yE.editorExperiment)('platform_editor_controls', 'variant1', {
                        exposure: true
                    })) {
                        const toolbarCustom = {
                            type: 'custom',
                            render: (view, _idx, _dispatchAnalyticsEvent)=>{
                                if (!view) return;
                                return /*#__PURE__*/ (0, $dc70d.jsx)((0, $5Cj1s.FloatingToolbarComponent), {
                                    api: api
                                });
                            },
                            fallback: []
                        };
                        return {
                            isToolbarAbove: true,
                            items: [
                                toolbarCustom
                            ],
                            rank: 8
                        };
                    } else return undefined;
                }
            },
            ...!isRegisteredSlashCommandEnabled && {
                quickInsert: (intl)=>{
                    var _api$analytics7, _api$analytics8;
                    const exclude = options && options.allowBlockType && options.allowBlockType.exclude ? options.allowBlockType.exclude : [];
                    return [
                        ...$901f93c4434bca6b$var$blockquotePluginOptions(intl, exclude.indexOf('blockquote') === -1, api === null || api === void 0 || (_api$analytics7 = api.analytics) === null || _api$analytics7 === void 0 ? void 0 : _api$analytics7.actions),
                        ...$901f93c4434bca6b$var$headingPluginOptions(intl, exclude.indexOf('heading') === -1, api === null || api === void 0 || (_api$analytics8 = api.analytics) === null || _api$analytics8 === void 0 ? void 0 : _api$analytics8.actions)
                    ];
                }
            }
        }
    };
};

});
parcelRegister("5j7nF", function(module, exports) {
$parcel$export(module.exports, "setBlockTypeWithAnalytics", () => $749a8c7aaae5e1e0$export$3f9af78ebb95cc20);
$parcel$export(module.exports, "setNormalTextWithAnalytics", () => $749a8c7aaae5e1e0$export$283e32d0388e302a);
$parcel$export(module.exports, "setSmallTextWithAnalytics", () => $749a8c7aaae5e1e0$export$2c10a6ea48e28b89);
$parcel$export(module.exports, "setHeadingWithAnalytics", () => $749a8c7aaae5e1e0$export$52d74b15bd103d7f);
$parcel$export(module.exports, "clearFormatting", () => $749a8c7aaae5e1e0$export$195de5d8e201efd7);
$parcel$export(module.exports, "insertBlockQuoteWithAnalytics", () => $749a8c7aaae5e1e0$export$50b4331f407b3ab6);
$parcel$export(module.exports, "insertBlockQuoteWithAnalyticsCommand", () => $749a8c7aaae5e1e0$export$f5e16b3b6b62d83);
$parcel$export(module.exports, "cleanUpAtTheStartOfDocument", () => $749a8c7aaae5e1e0$export$9c6026f8ac831f44);

var $g6Qq4 = parcelRequire("g6Qq4");

var $bq0hv = parcelRequire("bq0hv");

var $1ej2m = parcelRequire("1ej2m");

var $b9WCP = parcelRequire("b9WCP");

var $5NaaJ = parcelRequire("5NaaJ");

var $3DNV7 = parcelRequire("3DNV7");

var $2E7OD = parcelRequire("2E7OD");

var $97VXU = parcelRequire("97VXU");

var $55apt = parcelRequire("55apt");

var $2oKif = parcelRequire("2oKif");

var $ea8EW = parcelRequire("ea8EW");
function $749a8c7aaae5e1e0$export$36987f561c736aad(name) {
    return ({ tr: tr })=>{
        const { nodes: nodes } = tr.doc.type.schema;
        if (name === (0, $97VXU.NORMAL_TEXT).name && nodes.paragraph) return $749a8c7aaae5e1e0$export$63c4f0859cc75dc6()({
            tr: tr
        });
        if (name === 'smallText') return $749a8c7aaae5e1e0$export$7343796298b2524f()({
            tr: tr
        });
        const headingBlockType = (0, $97VXU.HEADINGS_BY_NAME)[name];
        if (headingBlockType && nodes.heading && headingBlockType.level) return $749a8c7aaae5e1e0$export$c6a04dca1ed03a3c(headingBlockType.level)({
            tr: tr
        });
        return null;
    };
}
function $749a8c7aaae5e1e0$export$c6a04dca1ed03a3c(level, fromBlockQuote) {
    return function({ tr: tr }) {
        const { selection: selection, doc: { type: { schema: schema } } } = tr;
        const ranges = selection instanceof (0, $2E7OD.CellSelection) ? selection.ranges : [
            selection
        ];
        ranges.forEach(({ $from: $from, $to: $to })=>{
            if (fromBlockQuote) {
                const range = $from.blockRange($to);
                if (!range) return;
                // First, lift the content out of the blockquote
                const targetLiftDepth = (0, $3DNV7.liftTarget)(range);
                if (targetLiftDepth || targetLiftDepth === 0) tr.lift(range, targetLiftDepth);
                // Then apply the heading block type to the lifted content
                // We need to recalculate positions after the lift operation
                const newFrom = tr.mapping.map($from.pos);
                const newTo = tr.mapping.map($to.pos);
                tr.setBlockType(newFrom, newTo, schema.nodes.heading, {
                    level: level
                });
            } else tr.setBlockType($from.pos, $to.pos, schema.nodes.heading, {
                level: level
            });
        });
        // Remove fontSize mark from transformed content in range
        // List content stays as paragraphs (headings aren't allowed in list items),
        // but non-list content has been converted to headings by setBlockType above.
        const { fontSize: fontSize } = schema.marks;
        if (fontSize) {
            const allowedBlocks = [
                schema.nodes.paragraph,
                schema.nodes.heading
            ];
            if (selection instanceof (0, $2E7OD.CellSelection)) selection.forEachCell((cell, pos)=>{
                (0, $bq0hv.createToggleBlockMarkOnRangeNext)(fontSize, ()=>false, allowedBlocks)(pos, pos + cell.nodeSize, tr);
            });
            else {
                const expandedRange = (0, $55apt.getSelectionRangeExpandedToLists)(tr);
                (0, $bq0hv.createToggleBlockMarkOnRangeNext)(fontSize, ()=>false, allowedBlocks)(expandedRange.from, expandedRange.to, tr);
            }
        }
        return tr;
    };
}
function $749a8c7aaae5e1e0$export$3f9af78ebb95cc20(name, inputMethod, editorAnalyticsApi, fromBlockQuote) {
    return ({ tr: tr })=>{
        const { nodes: nodes, marks: marks } = tr.doc.type.schema;
        if (name === 'normal' && nodes.paragraph) return $749a8c7aaae5e1e0$export$283e32d0388e302a(inputMethod, editorAnalyticsApi, fromBlockQuote)({
            tr: tr
        });
        if (name === 'smallText' && marks.fontSize) return $749a8c7aaae5e1e0$export$2c10a6ea48e28b89(inputMethod, editorAnalyticsApi, fromBlockQuote)({
            tr: tr
        });
        const headingBlockType = (0, $97VXU.HEADINGS_BY_NAME)[name];
        if (headingBlockType && nodes.heading && headingBlockType.level) return $749a8c7aaae5e1e0$export$52d74b15bd103d7f(headingBlockType.level, inputMethod, editorAnalyticsApi, fromBlockQuote)({
            tr: tr
        });
        return null;
    };
}
function $749a8c7aaae5e1e0$export$7343796298b2524f(fromBlockQuote) {
    return function({ tr: tr }) {
        const { marks: { fontSize: fontSize }, nodes: { paragraph: paragraph } } = tr.doc.type.schema;
        if (!fontSize) return null;
        const { selection: selection } = tr;
        const applySmallFontSize = (0, $bq0hv.createToggleBlockMarkOnRangeNext)(fontSize, ()=>({
                fontSize: 'small'
            }), [
            paragraph
        ]);
        if (fromBlockQuote) {
            const { $from: $from, $to: $to } = selection;
            const range = $from.blockRange($to);
            if (!range) return tr;
            const targetLiftDepth = (0, $3DNV7.liftTarget)(range);
            if (targetLiftDepth || targetLiftDepth === 0) tr.lift(range, targetLiftDepth);
            const from = tr.mapping.map($from.pos);
            const to = tr.mapping.map($to.pos);
            tr.setBlockType(from, to, paragraph);
            applySmallFontSize(from, to, tr);
        } else if (selection instanceof (0, $2E7OD.CellSelection)) {
            const mapFrom = tr.steps.length;
            selection.forEachCell((cell, pos)=>{
                const from = tr.mapping.slice(mapFrom).map(pos);
                const to = from + cell.nodeSize;
                tr.setBlockType(from, to, paragraph);
                (0, $55apt.convertTaskItemsToBlockTaskItems)(tr, from, to);
                applySmallFontSize(from, to, tr);
            });
        } else {
            tr.setBlockType(selection.from, selection.to, paragraph);
            const expandedRange = (0, $55apt.getSelectionRangeExpandedToLists)(tr);
            (0, $55apt.convertTaskItemsToBlockTaskItems)(tr, expandedRange.from, expandedRange.to);
            applySmallFontSize(tr.mapping.map(expandedRange.from, -1), tr.mapping.map(expandedRange.to, 1), tr);
        }
        return tr;
    };
}
function $749a8c7aaae5e1e0$export$2c10a6ea48e28b89(inputMethod, editorAnalyticsApi, fromBlockQuote) {
    return $749a8c7aaae5e1e0$var$withCurrentHeadingLevel((previousHeadingLevel)=>({ tr: tr })=>{
            editorAnalyticsApi === null || editorAnalyticsApi === void 0 || editorAnalyticsApi.attachAnalyticsEvent({
                action: (0, $g6Qq4.ACTION).FORMATTED,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).TEXT,
                eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).FORMAT_SMALL_TEXT,
                attributes: {
                    inputMethod: inputMethod,
                    previousBlockType: previousHeadingLevel !== undefined ? String(previousHeadingLevel) : undefined
                }
            })(tr);
            return $749a8c7aaae5e1e0$export$7343796298b2524f(fromBlockQuote)({
                tr: tr
            });
        });
}
function $749a8c7aaae5e1e0$export$63c4f0859cc75dc6(fromBlockQuote) {
    return function({ tr: tr }) {
        const { selection: selection, doc: { type: { schema: schema } } } = tr;
        // Apply normal text to the selection range (handles non-list content)
        const ranges = selection instanceof (0, $2E7OD.CellSelection) ? selection.ranges : [
            selection
        ];
        ranges.forEach(({ $from: $from, $to: $to })=>{
            if (fromBlockQuote) {
                const range = $from.blockRange($to);
                if (!range) return;
                // First, lift the content out of the blockquote
                const targetLiftDepth = (0, $3DNV7.liftTarget)(range);
                if (targetLiftDepth || targetLiftDepth === 0) tr.lift(range, targetLiftDepth);
                const newFrom = tr.mapping.map($from.pos);
                const newTo = tr.mapping.map($to.pos);
                tr.setBlockType(newFrom, newTo, schema.nodes.paragraph, {});
            } else tr.setBlockType($from.pos, $to.pos, schema.nodes.paragraph);
        });
        // Remove fontSize mark from any lists the selection touches
        const { fontSize: fontSize } = schema.marks;
        if (fontSize) {
            if (selection instanceof (0, $2E7OD.CellSelection)) selection.forEachCell((cell, pos)=>{
                (0, $bq0hv.createToggleBlockMarkOnRangeNext)(fontSize, ()=>false, [
                    schema.nodes.paragraph
                ])(pos, pos + cell.nodeSize, tr);
            });
            else {
                const expandedRange = (0, $55apt.getSelectionRangeExpandedToLists)(tr);
                (0, $bq0hv.createToggleBlockMarkOnRangeNext)(fontSize, ()=>false, [
                    schema.nodes.paragraph
                ])(expandedRange.from, expandedRange.to, tr);
            }
        }
        return tr;
    };
}
function $749a8c7aaae5e1e0$export$195de5d8e201efd7(inputMethod, editorAnalyticsApi) {
    return function({ tr: tr }) {
        const formattingCleared = [];
        const schema = tr.doc.type.schema;
        (0, $2oKif.FORMATTING_MARK_TYPES).forEach((mark)=>{
            const { from: from, to: to } = tr.selection;
            const markType = schema.marks[mark];
            if (!markType) return;
            if (tr.selection instanceof (0, $2E7OD.CellSelection)) (0, $2oKif.cellSelectionNodesBetween)(tr.selection, tr.doc, (node, pos)=>{
                const isTableCell = node.type === schema.nodes.tableCell || node.type === schema.nodes.tableHeader;
                if (!isTableCell) return true;
                if (tr.doc.rangeHasMark(pos, pos + node.nodeSize, markType)) {
                    formattingCleared.push((0, $2oKif.formatTypes)[mark]);
                    tr.removeMark(pos, pos + node.nodeSize, markType);
                }
                return false;
            });
            else if (tr.doc.rangeHasMark(from, to, markType)) {
                formattingCleared.push((0, $2oKif.formatTypes)[mark]);
                tr.removeMark(from, to, markType);
            }
        });
        (0, $2oKif.FORMATTING_NODE_TYPES).forEach((nodeName)=>{
            const formattedNodeType = schema.nodes[nodeName];
            const { $from: $from, $to: $to } = tr.selection;
            if (tr.selection instanceof (0, $2E7OD.CellSelection)) (0, $2oKif.cellSelectionNodesBetween)(tr.selection, tr.doc, (0, $2oKif.clearNodeFormattingOnSelection)(schema, tr, formattedNodeType, nodeName, formattingCleared));
            else tr.doc.nodesBetween($from.pos, $to.pos, (0, $2oKif.clearNodeFormattingOnSelection)(schema, tr, formattedNodeType, nodeName, formattingCleared));
        });
        tr.setStoredMarks([]);
        if (formattingCleared.length) editorAnalyticsApi === null || editorAnalyticsApi === void 0 || editorAnalyticsApi.attachAnalyticsEvent({
            action: (0, $g6Qq4.ACTION).FORMATTED,
            eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).TEXT,
            actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).FORMAT_CLEAR,
            attributes: {
                inputMethod: inputMethod,
                formattingCleared: formattingCleared,
                dropdownMenu: 'textStyle'
            }
        })(tr);
        return tr;
    };
}
function $749a8c7aaae5e1e0$var$withCurrentHeadingLevel(fn) {
    return ({ tr: tr })=>{
        // Find all headings and paragraphs of text
        const { heading: heading, paragraph: paragraph } = tr.doc.type.schema.nodes;
        const nodes = (0, $1ej2m.filterChildrenBetween)(tr.doc, tr.selection.from, tr.selection.to, (node)=>{
            return node.type === heading || node.type === paragraph;
        });
        // Check each paragraph and/or heading and check for consistent level
        let level;
        for (const node of nodes){
            const nodeLevel = node.node.type === heading ? node.node.attrs.level : 0;
            if (!level) level = nodeLevel;
            else if (nodeLevel !== level) {
                // Conflict in level, therefore inconsistent and undefined
                level = undefined;
                break;
            }
        }
        return fn(level)({
            tr: tr
        });
    };
}
function $749a8c7aaae5e1e0$export$283e32d0388e302a(inputMethod, editorAnalyticsApi, fromBlockQuote) {
    return $749a8c7aaae5e1e0$var$withCurrentHeadingLevel((previousHeadingLevel)=>({ tr: tr })=>{
            editorAnalyticsApi === null || editorAnalyticsApi === void 0 || editorAnalyticsApi.attachAnalyticsEvent({
                action: (0, $g6Qq4.ACTION).FORMATTED,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).TEXT,
                eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).FORMAT_HEADING,
                attributes: {
                    inputMethod: inputMethod,
                    newHeadingLevel: 0,
                    previousHeadingLevel: previousHeadingLevel
                }
            })(tr);
            return $749a8c7aaae5e1e0$export$63c4f0859cc75dc6(fromBlockQuote)({
                tr: tr
            });
        });
}
const $749a8c7aaae5e1e0$export$52d74b15bd103d7f = (newHeadingLevel, inputMethod, editorAnalyticsApi, fromBlockQuote)=>{
    return $749a8c7aaae5e1e0$var$withCurrentHeadingLevel((previousHeadingLevel)=>({ tr: tr })=>{
            editorAnalyticsApi === null || editorAnalyticsApi === void 0 || editorAnalyticsApi.attachAnalyticsEvent({
                action: (0, $g6Qq4.ACTION).FORMATTED,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).TEXT,
                eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).FORMAT_HEADING,
                attributes: {
                    inputMethod: inputMethod,
                    newHeadingLevel: newHeadingLevel,
                    previousHeadingLevel: previousHeadingLevel
                }
            })(tr);
            return $749a8c7aaae5e1e0$export$c6a04dca1ed03a3c(newHeadingLevel, fromBlockQuote)({
                tr: tr
            });
        });
};
function $749a8c7aaae5e1e0$var$insertBlockQuote() {
    return function(state, dispatch) {
        const { nodes: nodes } = state.schema;
        if (nodes.paragraph && nodes.blockquote) return (0, $b9WCP.wrapSelectionIn)(nodes.blockquote)(state, dispatch);
        return false;
    };
}
const $749a8c7aaae5e1e0$export$50b4331f407b3ab6 = (inputMethod, editorAnalyticsApi)=>{
    return (0, $5NaaJ.withAnalytics)(editorAnalyticsApi, {
        action: (0, $g6Qq4.ACTION).FORMATTED,
        actionSubject: (0, $g6Qq4.ACTION_SUBJECT).TEXT,
        eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
        actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).FORMAT_BLOCK_QUOTE,
        attributes: {
            inputMethod: inputMethod
        }
    })($749a8c7aaae5e1e0$var$insertBlockQuote());
};
function $749a8c7aaae5e1e0$export$f5e16b3b6b62d83(inputMethod, editorAnalyticsApi) {
    return $749a8c7aaae5e1e0$var$withCurrentHeadingLevel(()=>({ tr: tr })=>{
            const { nodes: nodes } = tr.doc.type.schema;
            editorAnalyticsApi === null || editorAnalyticsApi === void 0 || editorAnalyticsApi.attachAnalyticsEvent({
                action: (0, $g6Qq4.ACTION).FORMATTED,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).TEXT,
                eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).FORMAT_BLOCK_QUOTE,
                attributes: {
                    inputMethod: inputMethod
                }
            })(tr);
            return (0, $ea8EW.wrapSelectionInBlockType)(nodes.blockquote)({
                tr: tr
            });
        });
}
const $749a8c7aaae5e1e0$export$9c6026f8ac831f44 = (state, dispatch)=>{
    const { $cursor: $cursor } = state.selection;
    if ($cursor && !$cursor.nodeBefore && !$cursor.nodeAfter && $cursor.pos === 1) {
        const { tr: tr, schema: schema } = state;
        const { paragraph: paragraph } = schema.nodes;
        const { parent: parent } = $cursor;
        /**
     * Use cases:
     * 1. Change `heading` to `paragraph`
     * 2. Remove block marks
     *
     * NOTE: We already know it's an empty doc so it's safe to use 0
     */ tr.setNodeMarkup(0, paragraph, parent.attrs, []);
        if (dispatch) dispatch(tr);
        return true;
    }
    return false;
};

});
parcelRegister("55apt", function(module, exports) {
$parcel$export(module.exports, "isNodeAWrappingBlockNode", () => $f329dede607e46f7$export$3a2c03e35bc6c7a8);
$parcel$export(module.exports, "createJoinNodesRule", () => $f329dede607e46f7$export$1fe8b64ae159a0fa);
$parcel$export(module.exports, "createWrappingTextBlockRule", () => $f329dede607e46f7$export$644b98fd2fd87b8b);
$parcel$export(module.exports, "areBlockTypesDisabled", () => $f329dede607e46f7$export$52adb8d9a3386cb8);
$parcel$export(module.exports, "isSelectionInsideListNode", () => $f329dede607e46f7$export$fbe592d31a93b004);
$parcel$export(module.exports, "checkFormattingIsPresent", () => $f329dede607e46f7$export$4b48a1fc423972ea);
$parcel$export(module.exports, "hasBlockQuoteInOptions", () => $f329dede607e46f7$export$bce51f4ee2032263);
$parcel$export(module.exports, "getSelectionRangeExpandedToLists", () => $f329dede607e46f7$export$77bd22d0a1033d4);
$parcel$export(module.exports, "convertTaskItemsToBlockTaskItems", () => $f329dede607e46f7$export$9fb148c84c583d2a);

var $89hQd = parcelRequire("89hQd");

var $kYtKJ = parcelRequire("kYtKJ");

var $33v8M = parcelRequire("33v8M");

var $hfNS8 = parcelRequire("hfNS8");

var $gab48 = parcelRequire("gab48");

var $97VXU = parcelRequire("97VXU");
const $f329dede607e46f7$export$3a2c03e35bc6c7a8 = (node)=>{
    if (!node) return false;
    return (0, $97VXU.WRAPPER_BLOCK_TYPES).some((blockNode)=>blockNode.name === node.type.name);
};
const $f329dede607e46f7$export$1fe8b64ae159a0fa = (match, nodeType)=>{
    return (0, $hfNS8.createWrappingJoinRule)({
        nodeType: nodeType,
        match: match,
        getAttrs: {},
        joinPredicate: (_, node)=>node.type === nodeType
    });
};
const $f329dede607e46f7$export$644b98fd2fd87b8b = ({ match: match, nodeType: nodeType, getAttrs: getAttrs })=>{
    const handler = (state, match, start, end)=>{
        const fixedStart = Math.max(start, 1);
        const $start = state.doc.resolve(fixedStart);
        const attrs = getAttrs instanceof Function ? getAttrs(match) : getAttrs;
        const nodeBefore = $start.node(-1);
        if (nodeBefore && !nodeBefore.canReplaceWith($start.index(-1), $start.indexAfter(-1), nodeType)) return null;
        return state.tr.delete(fixedStart, end).setBlockType(fixedStart, fixedStart, nodeType, attrs);
    };
    return (0, $33v8M.createRule)(match, handler);
};
/**
 * Function will create a list of wrapper blocks present in a selection.
 */ function $f329dede607e46f7$var$getSelectedWrapperNodes(state) {
    const nodes = [];
    if (state.selection) {
        const { $from: $from, $to: $to, empty: empty } = state.selection;
        const { blockquote: blockquote, panel: panel, orderedList: orderedList, bulletList: bulletList, listItem: listItem, caption: caption, codeBlock: codeBlock, decisionItem: decisionItem, decisionList: decisionList, taskItem: taskItem, taskList: taskList } = state.schema.nodes;
        const wrapperNodes = [
            blockquote,
            panel,
            orderedList,
            bulletList,
            listItem,
            codeBlock,
            decisionItem,
            decisionList,
            taskItem,
            taskList
        ];
        wrapperNodes.push(caption);
        if (empty) {
            for(let depth = 0; depth <= $from.depth; depth++){
                const node = $from.node(depth);
                if (node.isBlock && wrapperNodes.indexOf(node.type) >= 0) nodes.push(node.type);
            }
            return nodes;
        }
        state.doc.nodesBetween($from.pos, $to.pos, (node)=>{
            if (node.isBlock && wrapperNodes.indexOf(node.type) >= 0) nodes.push(node.type);
        });
    }
    return nodes;
}
function $f329dede607e46f7$export$52adb8d9a3386cb8(state, allowFontSize = false) {
    const nodesTypes = $f329dede607e46f7$var$getSelectedWrapperNodes(state);
    const { panel: panel, blockquote: blockquote, bulletList: bulletList, orderedList: orderedList, listItem: listItem, taskList: taskList, taskItem: taskItem } = state.schema.nodes;
    const isSmallFontSizeEnabled = allowFontSize;
    const excludedTypes = isSmallFontSizeEnabled ? [
        panel,
        bulletList,
        orderedList,
        listItem,
        taskList,
        taskItem
    ] : [
        panel
    ];
    const disallowedWrapperTypes = nodesTypes.filter((type)=>!excludedTypes.includes(type));
    if (isSmallFontSizeEnabled) {
        const selectionInsideList = $f329dede607e46f7$export$fbe592d31a93b004(state);
        const selectionInsideQuote = $f329dede607e46f7$export$a7e992c753426072(state);
        // Inside a blockquote (but not a list nested within one): the blockquote itself isn't a
        // disallowing wrapper, but anything else is.
        if (selectionInsideQuote && !selectionInsideList) return disallowedWrapperTypes.some((type)=>type !== blockquote);
        return disallowedWrapperTypes.length > 0;
    }
    let hasQuote = false;
    let hasNestedListInQuote = false;
    const { $from: $from, $to: $to } = state.selection;
    state.doc.nodesBetween($from.pos, $to.pos, (node)=>{
        if (node.type === blockquote) {
            hasQuote = true;
            node.descendants((child)=>{
                if (child.type === bulletList || child.type === orderedList) {
                    hasNestedListInQuote = true;
                    return false;
                }
                return true;
            });
        }
        return !hasNestedListInQuote;
    });
    return disallowedWrapperTypes.length > 0 && (!hasQuote || hasNestedListInQuote);
}
function $f329dede607e46f7$export$fbe592d31a93b004(state) {
    if (!state.selection) return false;
    const { $from: $from, $to: $to } = state.selection;
    const { bulletList: bulletList, orderedList: orderedList, taskList: taskList } = state.schema.nodes;
    const listNodeTypes = [
        bulletList,
        orderedList,
        taskList
    ];
    let insideList = false;
    state.doc.nodesBetween($from.pos, $to.pos, (node)=>{
        if (node.isBlock && listNodeTypes.indexOf(node.type) >= 0) {
            insideList = true;
            return false;
        }
        return true;
    });
    return insideList || listNodeTypes.some((nodeType)=>(0, $gab48.hasParentNodeOfType)(nodeType)(state.selection));
}
function $f329dede607e46f7$export$a7e992c753426072(state) {
    if (!state.selection) return false;
    const { $from: $from, $to: $to } = state.selection;
    const { blockquote: blockquote } = state.schema.nodes;
    // For collapsed selections, check if the cursor is inside a blockquote
    if ($from.pos === $to.pos) return (0, $gab48.hasParentNodeOfType)(blockquote)(state.selection);
    // For range selections, check if any node in the range is a blockquote,
    // or if the selection starts/ends inside a blockquote
    let insideQuote = false;
    state.doc.nodesBetween($from.pos, $to.pos, (node)=>{
        if (node.type === blockquote) {
            insideQuote = true;
            return false;
        }
        return true;
    });
    return insideQuote || (0, $gab48.hasParentNodeOfType)(blockquote)(state.selection);
}
const $f329dede607e46f7$var$blockStylingIsPresent = (state)=>{
    const { from: from, to: to } = state.selection;
    let isBlockStyling = false;
    state.doc.nodesBetween(from, to, (node)=>{
        if ((0, $97VXU.FORMATTING_NODE_TYPES).indexOf(node.type.name) !== -1) {
            isBlockStyling = true;
            return false;
        }
        return true;
    });
    return isBlockStyling;
};
const $f329dede607e46f7$var$marksArePresent = (state)=>{
    const activeMarkTypes = (0, $97VXU.FORMATTING_MARK_TYPES).filter((mark)=>{
        if (!!state.schema.marks[mark]) {
            const { $from: $from, empty: empty } = state.selection;
            const { marks: marks } = state.schema;
            if (empty) return !!marks[mark].isInSet(state.storedMarks || $from.marks());
            return (0, $89hQd.anyMarkActive)(state, marks[mark]);
        }
        return false;
    });
    return activeMarkTypes.length > 0;
};
const $f329dede607e46f7$export$4b48a1fc423972ea = (state)=>{
    return $f329dede607e46f7$var$marksArePresent(state) || $f329dede607e46f7$var$blockStylingIsPresent(state);
};
const $f329dede607e46f7$export$bce51f4ee2032263 = (dropdownOptions)=>{
    return !!dropdownOptions.find((blockType)=>blockType.name === 'blockquote');
};
function $f329dede607e46f7$export$77bd22d0a1033d4(tr) {
    const { selection: selection } = tr;
    const { bulletList: bulletList, orderedList: orderedList, taskList: taskList } = tr.doc.type.schema.nodes;
    const listNodeTypes = [
        bulletList,
        orderedList,
        taskList
    ];
    let from = selection.from;
    let to = selection.to;
    // Walk up from the selection start to find the outermost list node.
    // We do NOT break at the first list found because task lists nest differently
    // from bullet/ordered lists:
    //   - bullet/ordered: bulletList > listItem > bulletList (nested inside listItem)
    //   - task: taskList > taskList (nested as direct children)
    // For task lists, breaking at the first list would only capture the innermost
    // taskList, missing sibling task items in parent lists. By continuing to walk
    // up, we find the outermost list and include all nested content.
    for(let depth = selection.$from.depth; depth > 0; depth--){
        const node = selection.$from.node(depth);
        if (listNodeTypes.indexOf(node.type) >= 0) from = selection.$from.before(depth);
    }
    for(let depth = selection.$to.depth; depth > 0; depth--){
        const node = selection.$to.node(depth);
        if (listNodeTypes.indexOf(node.type) >= 0) to = selection.$to.after(depth);
    }
    return {
        from: from,
        to: to
    };
}
function $f329dede607e46f7$export$9fb148c84c583d2a(tr, from, to) {
    const { nodes: { taskItem: taskItem, blockTaskItem: blockTaskItem } } = tr.doc.type.schema;
    if (!blockTaskItem || !taskItem) return;
    // Collect taskItem positions from the current (unmutated) document
    const taskItemsToConvert = [];
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        if (node.type === taskItem) taskItemsToConvert.push({
            pos: pos,
            node: node
        });
    });
    // Replace in reverse document order so earlier positions remain valid
    for(let i = taskItemsToConvert.length - 1; i >= 0; i--){
        const { pos: pos, node: node } = taskItemsToConvert[i];
        const blockTaskNode = (0, $kYtKJ.createBlockTaskItem)({
            attrs: node.attrs,
            content: node.content,
            schema: tr.doc.type.schema
        });
        tr.replaceWith(pos, pos + node.nodeSize, blockTaskNode);
    }
}

});
parcelRegister("89hQd", function(module, exports) {
$parcel$export(module.exports, "anyMarkActive", () => $6d60f7d9e12b12e5$export$3d7a3b3f27c57f56);

var $2E7OD = parcelRequire("2E7OD");
const $6d60f7d9e12b12e5$export$3d7a3b3f27c57f56 = (state, markType)=>{
    const { $from: $from, from: from, to: to, empty: empty } = state.selection;
    if (empty) return !!markType.isInSet(state.storedMarks || $from.marks());
    let rangeHasMark = false;
    if (state.selection instanceof (0, $2E7OD.CellSelection)) state.selection.forEachCell((cell, cellPos)=>{
        const from = cellPos;
        const to = cellPos + cell.nodeSize;
        if (!rangeHasMark) rangeHasMark = state.doc.rangeHasMark(from, to, markType);
    });
    else rangeHasMark = state.doc.rangeHasMark(from, to, markType);
    return rangeHasMark;
};

});


parcelRegister("2oKif", function(module, exports) {
$parcel$export(module.exports, "FORMATTING_NODE_TYPES", () => $4cb27a71d3561c50$export$a5cb0c20bd02ce0c);
$parcel$export(module.exports, "FORMATTING_MARK_TYPES", () => $4cb27a71d3561c50$export$73b50f8f13648c71);
$parcel$export(module.exports, "formatTypes", () => $4cb27a71d3561c50$export$ce157a3b6664c924);
$parcel$export(module.exports, "cellSelectionNodesBetween", () => $4cb27a71d3561c50$export$bd443c1dba3019b8);
$parcel$export(module.exports, "clearNodeFormattingOnSelection", () => $4cb27a71d3561c50$export$10ed2145ce1a03b1);

var $g6Qq4 = parcelRequire("g6Qq4");

var $3DNV7 = parcelRequire("3DNV7");
const $4cb27a71d3561c50$export$a5cb0c20bd02ce0c = [
    'heading',
    'blockquote'
];
const $4cb27a71d3561c50$export$73b50f8f13648c71 = [
    'em',
    'code',
    'strike',
    'strong',
    'underline',
    'textColor',
    'subsup',
    'backgroundColor'
];
const $4cb27a71d3561c50$export$ce157a3b6664c924 = {
    em: (0, $g6Qq4.ACTION_SUBJECT_ID).FORMAT_ITALIC,
    code: (0, $g6Qq4.ACTION_SUBJECT_ID).FORMAT_CODE,
    strike: (0, $g6Qq4.ACTION_SUBJECT_ID).FORMAT_STRIKE,
    strong: (0, $g6Qq4.ACTION_SUBJECT_ID).FORMAT_STRONG,
    underline: (0, $g6Qq4.ACTION_SUBJECT_ID).FORMAT_UNDERLINE,
    textColor: (0, $g6Qq4.ACTION_SUBJECT_ID).FORMAT_COLOR,
    subsup: 'subsup',
    backgroundColor: (0, $g6Qq4.ACTION_SUBJECT_ID).FORMAT_BACKGROUND_COLOR
};
const $4cb27a71d3561c50$export$bd443c1dba3019b8 = (selection, doc, f, startPos)=>{
    selection.forEachCell((cell, cellPos)=>{
        doc.nodesBetween(cellPos, cellPos + cell.nodeSize, f, startPos);
    });
};
function $4cb27a71d3561c50$export$10ed2145ce1a03b1(schema, tr, formattedNodeType, nodeName, formattingCleared) {
    return function(node, pos) {
        if (node.type === formattedNodeType) {
            if (formattedNodeType.isTextblock) {
                tr.setNodeMarkup(pos, schema.nodes.paragraph);
                formattingCleared.push(nodeName);
                return false;
            } else {
                // In case of panel or blockquote
                const fromPos = tr.doc.resolve(pos + 1);
                const toPos = tr.doc.resolve(pos + node.nodeSize - 1);
                const nodeRange = fromPos.blockRange(toPos);
                if (nodeRange) {
                    const targetLiftDepth = (0, $3DNV7.liftTarget)(nodeRange);
                    if (targetLiftDepth || targetLiftDepth === 0) {
                        formattingCleared.push(nodeName);
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        tr.lift(nodeRange, targetLiftDepth);
                    }
                }
            }
        }
        return true;
    };
}

});

parcelRegister("ea8EW", function(module, exports) {
$parcel$export(module.exports, "wrapSelectionInBlockType", () => $035cfb57e5c05367$export$bb05c9a6c853122f);

var $kW8qW = parcelRequire("kW8qW");

var $3DNV7 = parcelRequire("3DNV7");
function $035cfb57e5c05367$export$bb05c9a6c853122f(_nodeType) {
    return ({ tr: tr })=>{
        const { nodes: nodes } = tr.doc.type.schema;
        const { alignment: alignment, indentation: indentation, fontSize: fontSize } = tr.doc.type.schema.marks;
        if (nodes.paragraph && nodes.blockquote) {
            /** Remove alignment, indentation, and unsupported blockquote marks from the selection */ const marksToRemove = [
                alignment,
                indentation,
                fontSize
            ];
            const hasMark = (mark)=>marksToRemove.indexOf(mark.type) > -1;
            const not = (fn)=>(arg)=>!fn(arg);
            /**
       * When you need to toggle the selection
       * when another type which does not allow alignment is applied
       */ tr.doc.nodesBetween(tr.selection.from, tr.selection.to, (node, pos)=>{
                if (node.type === nodes.paragraph && node.marks.some(hasMark)) {
                    const resolvedPos = tr.doc.resolve(pos);
                    const withoutBlockMarks = node.marks.filter(not(hasMark));
                    tr = tr.setNodeMarkup(resolvedPos.pos, undefined, node.attrs, withoutBlockMarks);
                }
            });
            /** Get range and wrapping needed for the selection */ const { $from: $from, $to: $to } = tr.selection;
            const range = $from.blockRange($to);
            const wrapping = range && (0, $3DNV7.findWrapping)(range, nodes.blockquote);
            if (wrapping) /** Wrap the selection */ tr.wrap(range, wrapping).scrollIntoView();
            else {
                /** If wrapping is not possible, replace with a blockquote */ const start = $from.start();
                const end = $to.end();
                const content = $from.node().content;
                const blockquote = nodes.blockquote.create({}, nodes.paragraph.create({}, content));
                const slice = new (0, $kW8qW.Slice)((0, $kW8qW.Fragment).from(blockquote), 0, 0);
                tr.replaceRange(start, end, slice).scrollIntoView();
            }
        }
        return tr;
    };
}

});


parcelRegister("en3JK", function(module, exports) {
$parcel$export(module.exports, "default", () => $562ff4cf96bacae3$export$2e2bcd8739ae039);

var $g6Qq4 = parcelRequire("g6Qq4");

var $lMfrv = parcelRequire("lMfrv");

var $f7Kk4 = parcelRequire("f7Kk4");

var $33v8M = parcelRequire("33v8M");

var $hfNS8 = parcelRequire("hfNS8");

var $b9BdF = parcelRequire("b9BdF");

var $8t09p = parcelRequire("8t09p");

var $55apt = parcelRequire("55apt");
const $562ff4cf96bacae3$var$MAX_HEADING_LEVEL = 6;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $562ff4cf96bacae3$var$BLOCK_QUOTE_REGEX = /^\s*>\s$/;
function $562ff4cf96bacae3$var$getHeadingLevel(match) {
    return {
        level: match[1].length
    };
}
function $562ff4cf96bacae3$var$headingRule(nodeType, maxLevel) {
    return (0, $55apt.createWrappingTextBlockRule)({
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        match: new RegExp('^(#{1,' + maxLevel + '})\\s$'),
        nodeType: nodeType,
        getAttrs: $562ff4cf96bacae3$var$getHeadingLevel
    });
}
function $562ff4cf96bacae3$var$blockQuoteRule(nodeType) {
    return (0, $55apt.createJoinNodesRule)($562ff4cf96bacae3$var$BLOCK_QUOTE_REGEX, nodeType);
}
/**
 * Get heading rules
 *
 * @param {Schema} schema
 * @returns {InputRuleWithHandler[]}
 */ function $562ff4cf96bacae3$var$getHeadingRules(editorAnalyticsAPI, schema) {
    // '# ' for h1, '## ' for h2 and etc
    const hashRule = $562ff4cf96bacae3$var$headingRule(schema.nodes.heading, $562ff4cf96bacae3$var$MAX_HEADING_LEVEL);
    const leftNodeReplacementHashRule = (0, $33v8M.createRule)(// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    new RegExp(`${(0, $b9BdF.leafNodeReplacementCharacter)}(#{1,6})\\s$`), (state, match, start, end)=>{
        const level = match[1].length;
        return (0, $lMfrv.insertBlock)(state, schema.nodes.heading, start, end, {
            level: level
        });
    });
    // New analytics handler
    const ruleWithHeadingAnalytics = (0, $hfNS8.inputRuleWithAnalytics)((_state, matchResult)=>({
            action: (0, $g6Qq4.ACTION).FORMATTED,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).TEXT,
            eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
            actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).FORMAT_HEADING,
            attributes: {
                inputMethod: (0, $g6Qq4.INPUT_METHOD).FORMATTING,
                newHeadingLevel: $562ff4cf96bacae3$var$getHeadingLevel(matchResult).level
            }
        }), editorAnalyticsAPI);
    return [
        ruleWithHeadingAnalytics(hashRule),
        ruleWithHeadingAnalytics(leftNodeReplacementHashRule)
    ];
}
/**
 * Get all block quote input rules
 *
 * @param {Schema} schema
 * @returns {InputRuleWithHandler[]}
 */ function $562ff4cf96bacae3$var$getBlockQuoteRules(editorAnalyticsAPI, schema) {
    // '> ' for blockquote
    const greatherThanRule = $562ff4cf96bacae3$var$blockQuoteRule(schema.nodes.blockquote);
    const leftNodeReplacementGreatherRule = (0, $33v8M.createRule)(// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    new RegExp(`${(0, $b9BdF.leafNodeReplacementCharacter)}\\s*>\\s$`), (state, _match, start, end)=>{
        return (0, $lMfrv.insertBlock)(state, schema.nodes.blockquote, start, end);
    });
    // Analytics V3 handler
    const ruleWithBlockQuoteAnalytics = (0, $hfNS8.inputRuleWithAnalytics)({
        action: (0, $g6Qq4.ACTION).FORMATTED,
        actionSubject: (0, $g6Qq4.ACTION_SUBJECT).TEXT,
        eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
        actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).FORMAT_BLOCK_QUOTE,
        attributes: {
            inputMethod: (0, $g6Qq4.INPUT_METHOD).FORMATTING
        }
    }, editorAnalyticsAPI);
    return [
        ruleWithBlockQuoteAnalytics(greatherThanRule),
        ruleWithBlockQuoteAnalytics(leftNodeReplacementGreatherRule)
    ];
}
function $562ff4cf96bacae3$var$inputRulePlugin(editorAnalyticsAPI, schema, featureFlags) {
    const rules = [];
    if (schema.nodes.heading) rules.push(...$562ff4cf96bacae3$var$getHeadingRules(editorAnalyticsAPI, schema));
    if (schema.nodes.blockquote) rules.push(...$562ff4cf96bacae3$var$getBlockQuoteRules(editorAnalyticsAPI, schema));
    if (rules.length !== 0) return new (0, $f7Kk4.SafePlugin)((0, $8t09p.createPlugin)('block-type', rules, {
        isBlockNodeRule: true
    }));
    return;
}
var $562ff4cf96bacae3$export$2e2bcd8739ae039 = $562ff4cf96bacae3$var$inputRulePlugin;

});
parcelRegister("lMfrv", function(module, exports) {
$parcel$export(module.exports, "insertBlock", () => $3ef1aa1c216d5c03$export$f51280337625031);

var $cw0wu = parcelRequire("cw0wu");

var $gab48 = parcelRequire("gab48");
const $3ef1aa1c216d5c03$export$f51280337625031 = (state, nodeType, start, end, attrs)=>{
    // To ensure that match is done after HardBreak.
    const { hardBreak: hardBreak, codeBlock: codeBlock, listItem: listItem } = state.schema.nodes;
    const $pos = state.doc.resolve(start);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    if ($pos.nodeAfter.type !== hardBreak) return null;
    // To ensure no nesting is done. (unless we're inserting a codeBlock inside lists)
    if ($pos.depth > 1 && !(nodeType === codeBlock && (0, $gab48.hasParentNodeOfType)(listItem)(state.selection))) return null;
    // Split at the start of autoformatting and delete formatting characters.
    let tr = state.tr.delete(start, end).split(start);
    let currentNode = tr.doc.nodeAt(start + 1);
    // If node has more content split at the end of autoformatting.
    let nodeHasMoreContent = false;
    tr.doc.nodesBetween(start, start + currentNode.nodeSize, (node, pos)=>{
        if (!nodeHasMoreContent && node.type === hardBreak) {
            nodeHasMoreContent = true;
            tr = tr.split(pos + 1).delete(pos, pos + 1);
        }
    });
    if (nodeHasMoreContent) currentNode = tr.doc.nodeAt(start + 1);
    // Create new node and fill with content of current node.
    const { blockquote: blockquote, paragraph: paragraph } = state.schema.nodes;
    let content;
    let depth;
    if (nodeType === blockquote) {
        depth = 3;
        content = [
            paragraph.create({}, currentNode.content)
        ];
    } else {
        depth = 2;
        content = currentNode.content;
    }
    const newNode = nodeType.create(attrs, content);
    // Add new node.
    tr = tr.setSelection(new (0, $cw0wu.NodeSelection)(tr.doc.resolve(start + 1)))// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    .replaceSelectionWith(newNode).setSelection(new (0, $cw0wu.TextSelection)(tr.doc.resolve(start + depth)));
    return tr;
};

});


parcelRegister("cMYAZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $7bf051496727db40$export$2e2bcd8739ae039);

var $g6Qq4 = parcelRequire("g6Qq4");

var $bdXbU = parcelRequire("bdXbU");

var $cv8id = parcelRequire("cv8id");

var $h7zC7 = parcelRequire("h7zC7");

var $5FzRL = parcelRequire("5FzRL");

var $gNUrD = parcelRequire("gNUrD");

var $jVAei = parcelRequire("jVAei");

var $5N1Y4 = parcelRequire("5N1Y4");

var $97VXU = parcelRequire("97VXU");

var $5j7nF = parcelRequire("5j7nF");

var $87WRJ = parcelRequire("87WRJ");

var $aR7GN = parcelRequire("aR7GN");

var $9wdHD = parcelRequire("9wdHD");

var $55apt = parcelRequire("55apt");
const $7bf051496727db40$var$backspaceCommand = (0, $5FzRL.chainCommands)((0, $5j7nF.cleanUpAtTheStartOfDocument), (0, $aR7GN.deleteBlockContent)((0, $55apt.isNodeAWrappingBlockNode)), (0, $87WRJ.deleteAndMoveCursor));
const $7bf051496727db40$var$del = (0, $5FzRL.chainCommands)((0, $h7zC7.deleteEmptyParagraphAndMoveBlockUp)((0, $55apt.isNodeAWrappingBlockNode)), (0, $aR7GN.deleteBlockContent)((0, $55apt.isNodeAWrappingBlockNode)), (0, $87WRJ.deleteAndMoveCursor));
function $7bf051496727db40$export$2e2bcd8739ae039(editorAnalyticsApi, schema, _featureFlags) {
    const list = {};
    (0, $cv8id.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $cv8id.insertNewLine).common, (0, $h7zC7.insertNewLineWithAnalytics)(editorAnalyticsApi), list);
    // Fixes the "Enter after a heading with trailing whitespace creates another
    // heading instead of a paragraph" bug. The command is a no-op (returns false)
    // in every case except that exact scenario, so other Enter handlers are
    // unaffected.
    if ((0, $5N1Y4.expValEquals)('platform_editor_fix_new_line_after_heading', 'isEnabled', true)) (0, $cv8id.bindKeymapWithCommand)((0, $cv8id.enter).common ?? 'Enter', (0, $9wdHD.splitHeadingWithTrailingSpace), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $cv8id.bindKeymapWithCommand)((0, $cv8id.moveUp).common, (0, $h7zC7.createNewParagraphAbove), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $cv8id.bindKeymapWithCommand)((0, $cv8id.moveDown).common, (0, $h7zC7.createNewParagraphBelow), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $cv8id.bindKeymapWithCommand)((0, $cv8id.findKeyMapForBrowser)((0, $cv8id.redo)), (0, $gNUrD.redo), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $cv8id.bindKeymapWithCommand)((0, $cv8id.undo).common, (0, $jVAei.undo), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $cv8id.bindKeymapWithCommand)((0, $cv8id.backspace).common, $7bf051496727db40$var$backspaceCommand, list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $cv8id.bindKeymapWithCommand)((0, $cv8id.deleteKey).common, $7bf051496727db40$var$del, list);
    (0, $cv8id.bindKeymapWithCommand)((0, $cv8id.forwardDelete).mac, $7bf051496727db40$var$del, list);
    if (schema.nodes[$97VXU.BLOCK_QUOTE.nodeName]) (0, $cv8id.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $cv8id.findShortcutByKeymap)((0, $cv8id.toggleBlockQuote)), (0, $5j7nF.insertBlockQuoteWithAnalytics)((0, $g6Qq4.INPUT_METHOD).KEYBOARD, editorAnalyticsApi), list);
    return (0, $bdXbU.keymap)(list);
}

});
parcelRegister("87WRJ", function(module, exports) {
$parcel$export(module.exports, "deleteAndMoveCursor", () => $bc1679857c62b82f$export$6c408f720f6b44a7);

var $cw0wu = parcelRequire("cw0wu");
// We should override default behaviour when selection spans node depths or
// ends at a node junction
const $bc1679857c62b82f$var$shouldMoveCursorAfterDelete = (state)=>{
    const { selection: { $from: $from, $to: $to } } = state;
    const nodeRange = $from.blockRange($to);
    if (!nodeRange) return false;
    const hasSameAncestor = $from.depth === $to.depth && $from.depth - 1 === nodeRange.depth;
    const toPositionHasNodeAfter = !!$to.nodeAfter;
    if (hasSameAncestor || toPositionHasNodeAfter) return false;
    return true;
};
const $bc1679857c62b82f$export$6c408f720f6b44a7 = (state, dispatch)=>{
    if (state.selection.empty || !(state.selection instanceof (0, $cw0wu.TextSelection))) return false;
    if (!$bc1679857c62b82f$var$shouldMoveCursorAfterDelete(state)) return false;
    const { tr: tr } = state;
    tr.deleteSelection();
    // Make sure the next position is not out of boundaries
    const previousPosition = Math.min(Math.max(state.selection.$from.pos, 0), tr.doc.content.size);
    // Override default delete behaviour that moves the cursor to first suitable position after selection (postive bias).
    // See. selectionToInsertionEnd. We will override behavior with negative bias (search for suitable cursor position backwards).
    tr.setSelection((0, $cw0wu.Selection).near(tr.doc.resolve(previousPosition), -1));
    if (dispatch) dispatch(tr.scrollIntoView());
    return true;
};

});

parcelRegister("aR7GN", function(module, exports) {
$parcel$export(module.exports, "deleteBlockContent", () => $18ab5b0379770dfa$export$9c1a524875bfb8ec);

var $cw0wu = parcelRequire("cw0wu");

var $gab48 = parcelRequire("gab48");
// function to check whether the selected node is the sole decision item in the decision list
const $18ab5b0379770dfa$var$isSelectedNodeSoleDecisionItem = (state)=>{
    var _findParentNodeOfType;
    const isDecisionItemNodeSelected = state.selection instanceof (0, $cw0wu.NodeSelection) && state.selection.node.type.name === 'decisionItem';
    if (!isDecisionItemNodeSelected) return false;
    const decisionList = (_findParentNodeOfType = (0, $gab48.findParentNodeOfType)([
        state.schema.nodes.decisionList
    ])(state.selection)) === null || _findParentNodeOfType === void 0 ? void 0 : _findParentNodeOfType.node;
    return (decisionList === null || decisionList === void 0 ? void 0 : decisionList.childCount) === 1;
};
const $18ab5b0379770dfa$var$isSelectedNodeMediaGroup = (state)=>{
    return Boolean(state.selection instanceof (0, $cw0wu.NodeSelection) && state.selection.node.type.name === 'media' && state.selection.$head.parent.type.name === 'mediaGroup');
};
function $18ab5b0379770dfa$export$9c1a524875bfb8ec(isNodeAWrappingBlockNode) {
    return (state, dispatch)=>{
        const { tr: tr, selection: { $from: $from, $to: $to }, doc: doc } = state;
        if ($from.pos === $to.pos) return false;
        let selectionCrossesWrappingBlockNode = false;
        doc.nodesBetween($from.pos, $to.pos, (node, pos)=>{
            // Optimisation. If selection crosses wrapping block node
            // short circuit the loop by returning false
            if (isNodeAWrappingBlockNode(node)) {
                selectionCrossesWrappingBlockNode = true;
                return false;
            }
        });
        if (!selectionCrossesWrappingBlockNode) return false;
        const isParentNodeOfTypePanel = (0, $gab48.hasParentNodeOfType)([
            state.schema.nodes.panel
        ])(state.selection);
        const isParentNodeOfTypeBlockQuote = (0, $gab48.hasParentNodeOfType)([
            state.schema.nodes.blockquote
        ])(state.selection);
        if ((isParentNodeOfTypePanel || isParentNodeOfTypeBlockQuote) && $18ab5b0379770dfa$var$isSelectedNodeMediaGroup(state) || isParentNodeOfTypePanel && $18ab5b0379770dfa$var$isSelectedNodeSoleDecisionItem(state)) {
            tr.setSelection(new (0, $cw0wu.TextSelection)(tr.doc.resolve($from.before())));
            tr.delete($from.before(), $from.after());
        } else tr.delete($from.pos, $to.pos);
        if (dispatch) dispatch(tr);
        return true;
    };
}

});

parcelRegister("9wdHD", function(module, exports) {
$parcel$export(module.exports, "splitHeadingWithTrailingSpace", () => $b842c8eed681aaed$export$bbc98c32685b9fd);

var $5FzRL = parcelRequire("5FzRL");
// eslint-disable-next-line require-unicode-regexp
const $b842c8eed681aaed$var$WHITESPACE_ONLY = /^\s+$/;
/**
 * Determines whether the current selection is inside a heading, positioned after
 * all of the heading's visible (non-whitespace) content but *before* one or more
 * trailing whitespace characters.
 *
 * In this scenario ProseMirror's default `splitBlock` treats the cursor as *not*
 * being at the end of the node (`atEnd === false`), because there is still
 * (whitespace) content between the cursor and the node boundary. As a result the
 * newly split-off block inherits the heading type instead of becoming a
 * paragraph — even though, visually, the cursor looks like it is at the end of
 * the heading.
 *
 * We intentionally scope this to *only* that case:
 * - The parent must be a heading.
 * - The selection must be empty (a plain caret, not a range).
 * - There must be at least one character between the caret and the end of the
 *   heading, and every such character must be whitespace.
 *
 * All other cases (caret mid-word, caret at the true end, empty heading, etc.)
 * return `false` so the default behaviour is preserved.
 */ const $b842c8eed681aaed$var$isCursorAfterHeadingContentBeforeTrailingWhitespace = ($from)=>{
    const parent = $from.parent;
    const headingType = $from.doc.type.schema.nodes.heading;
    if (!headingType || parent.type !== headingType) return false;
    // Offset of the caret within the heading's content.
    const offsetInParent = $from.parentOffset;
    const contentSize = parent.content.size;
    // If the caret is already at (or past) the end of the heading content, this is
    // the normal "atEnd" case handled correctly by the default split — skip.
    if (offsetInParent >= contentSize) return false;
    // The remaining text between the caret and the end of the heading.
    const trailingText = parent.textBetween(offsetInParent, contentSize);
    // Must be non-empty and consist solely of whitespace.
    return trailingText.length > 0 && $b842c8eed681aaed$var$WHITESPACE_ONLY.test(trailingText);
};
const $b842c8eed681aaed$export$bbc98c32685b9fd = (state, dispatch, view)=>{
    const { $from: $from } = state.selection;
    // Only act on an empty caret selection inside a matching heading.
    if (!state.selection.empty || !$b842c8eed681aaed$var$isCursorAfterHeadingContentBeforeTrailingWhitespace($from)) return false;
    const paragraphType = state.schema.nodes.paragraph;
    if (!paragraphType) return false;
    return (0, $5FzRL.splitBlockAs)((_node, atEnd)=>{
        // Guard again inside the callback: only override the type for the exact
        // scenario. If ProseMirror already considers us at the end, defer to the
        // default (return null).
        if (atEnd) return null;
        return {
            type: paragraphType
        };
    })(state, dispatch, view);
};

});


parcelRegister("fnYyJ", function(module, exports) {
$parcel$export(module.exports, "pluginKey", () => $8358cdbd6d84c9ad$export$18d4026d1ea86bb1);
$parcel$export(module.exports, "createPlugin", () => $8358cdbd6d84c9ad$export$ae829ec7b2625219);

var $g6Qq4 = parcelRequire("g6Qq4");

var $6bBgj = parcelRequire("6bBgj");

var $jxkn6 = parcelRequire("jxkn6");

var $f7Kk4 = parcelRequire("f7Kk4");

var $cw0wu = parcelRequire("cw0wu");

var $97VXU = parcelRequire("97VXU");

var $5j7nF = parcelRequire("5j7nF");

var $bujnZ = parcelRequire("bujnZ");

var $55apt = parcelRequire("55apt");
const $8358cdbd6d84c9ad$var$blockTypeForNode = (node, schema)=>{
    if (node.type === schema.nodes.heading) {
        const maybeNode = (0, $97VXU.HEADINGS_BY_LEVEL)[node.attrs['level']];
        if (maybeNode) return maybeNode;
    } else if (node.marks.some((m)=>m.type.name === 'fontSize' && m.attrs.fontSize === 'small')) return 0, $97VXU.SMALL_TEXT;
    else if (node.type === schema.nodes.paragraph) return 0, $97VXU.NORMAL_TEXT;
    else if (node.type === schema.nodes.blockquote) return 0, $97VXU.BLOCK_QUOTE;
    return 0, $97VXU.OTHER;
};
const $8358cdbd6d84c9ad$var$isBlockTypeSchemaSupported = (blockType, state)=>{
    switch(blockType){
        case 0, $97VXU.NORMAL_TEXT:
            return !!state.schema.nodes.paragraph;
        case 0, $97VXU.HEADING_1:
        case 0, $97VXU.HEADING_2:
        case 0, $97VXU.HEADING_3:
        case 0, $97VXU.HEADING_4:
        case 0, $97VXU.HEADING_5:
        case 0, $97VXU.HEADING_6:
            return !!state.schema.nodes.heading;
        case 0, $97VXU.SMALL_TEXT:
            return !!state.schema.marks.fontSize;
        case 0, $97VXU.BLOCK_QUOTE:
            return !!state.schema.nodes.blockquote;
        case 0, $97VXU.CODE_BLOCK:
            return !!state.schema.nodes.codeBlock;
        case 0, $97VXU.PANEL:
            return !!state.schema.nodes.panel;
    }
    return;
};
const $8358cdbd6d84c9ad$var$detectBlockType = (availableBlockTypes, state)=>{
    // Before a document is loaded, there is no selection.
    if (!state.selection) return 0, $97VXU.NORMAL_TEXT;
    let blockType;
    const { $from: $from, $to: $to } = state.selection;
    state.doc.nodesBetween($from.pos, $to.pos, (node)=>{
        const nodeBlockType = availableBlockTypes.filter((blockType)=>blockType === $8358cdbd6d84c9ad$var$blockTypeForNode(node, state.schema));
        if (nodeBlockType.length > 0) {
            if (!blockType) blockType = nodeBlockType[0];
            else if (blockType !== (0, $97VXU.OTHER) && blockType !== nodeBlockType[0]) blockType = (0, $97VXU.OTHER);
            return false;
        }
    });
    return blockType || (0, $97VXU.OTHER);
};
const $8358cdbd6d84c9ad$var$autoformatHeading = (headingLevel, editorAnalyticsApi)=>{
    if (headingLevel === 0) return (0, $5j7nF.setNormalTextWithAnalytics)((0, $g6Qq4.INPUT_METHOD).FORMATTING, editorAnalyticsApi);
    return (0, $5j7nF.setHeadingWithAnalytics)(headingLevel, (0, $g6Qq4.INPUT_METHOD).FORMATTING, editorAnalyticsApi);
};
const $8358cdbd6d84c9ad$export$18d4026d1ea86bb1 = new (0, $cw0wu.PluginKey)('blockTypePlugin');
const $8358cdbd6d84c9ad$export$ae829ec7b2625219 = (editorAPI, dispatch, lastNodeMustBeParagraph, includeBlockQuoteAsTextstyleOption, allowFontSize)=>{
    var _editorAPI$analytics;
    const editorAnalyticsApi = editorAPI === null || editorAPI === void 0 || (_editorAPI$analytics = editorAPI.analytics) === null || _editorAPI$analytics === void 0 ? void 0 : _editorAPI$analytics.actions;
    let altKeyLocation = 0;
    return new (0, $f7Kk4.SafePlugin)({
        appendTransaction (_transactions, _oldState, newState) {
            if (lastNodeMustBeParagraph) {
                const pos = newState.doc.resolve(newState.doc.content.size - 1);
                const lastNode = pos.node(1);
                const { paragraph: paragraph } = newState.schema.nodes;
                if (lastNode && lastNode.isBlock && lastNode.type !== paragraph) {
                    const tr = newState.tr.insert(newState.doc.content.size, newState.schema.nodes.paragraph.create());
                    return tr.setMeta((0, $6bBgj.INSERTED_TRAILING_PARAGRAPH_TO_LAST_NODE_META), true);
                }
            }
        },
        state: {
            init (_config, state) {
                const availableBlockTypes = (0, $97VXU.TEXT_BLOCK_TYPES).filter((blockType)=>$8358cdbd6d84c9ad$var$isBlockTypeSchemaSupported(blockType, state));
                const availableWrapperBlockTypes = (0, $97VXU.WRAPPER_BLOCK_TYPES).filter((blockType)=>$8358cdbd6d84c9ad$var$isBlockTypeSchemaSupported(blockType, state));
                const BLOCK_TYPES_IN_DROPDOWN = (0, $97VXU.getBlockTypesInDropdown)(includeBlockQuoteAsTextstyleOption);
                const availableBlockTypesInDropdown = BLOCK_TYPES_IN_DROPDOWN.filter((blockType)=>$8358cdbd6d84c9ad$var$isBlockTypeSchemaSupported(blockType, state));
                const formattingIsPresent = (0, $55apt.hasBlockQuoteInOptions)(availableBlockTypesInDropdown) ? (0, $55apt.checkFormattingIsPresent)(state) : undefined;
                return {
                    currentBlockType: $8358cdbd6d84c9ad$var$detectBlockType(availableBlockTypesInDropdown, state),
                    blockTypesDisabled: (0, $55apt.areBlockTypesDisabled)(state, allowFontSize),
                    availableBlockTypes: availableBlockTypes,
                    availableWrapperBlockTypes: availableWrapperBlockTypes,
                    availableBlockTypesInDropdown: availableBlockTypesInDropdown,
                    formattingIsPresent: formattingIsPresent
                };
            },
            apply (_tr, oldPluginState, _oldState, newState) {
                const newPluginState = {
                    ...oldPluginState,
                    currentBlockType: $8358cdbd6d84c9ad$var$detectBlockType(oldPluginState.availableBlockTypesInDropdown, newState),
                    blockTypesDisabled: (0, $55apt.areBlockTypesDisabled)(newState, allowFontSize),
                    formattingIsPresent: (0, $55apt.hasBlockQuoteInOptions)(oldPluginState.availableBlockTypesInDropdown) ? (0, $55apt.checkFormattingIsPresent)(newState) : undefined
                };
                if (newPluginState.currentBlockType !== oldPluginState.currentBlockType || newPluginState.blockTypesDisabled !== oldPluginState.blockTypesDisabled || newPluginState.formattingIsPresent !== oldPluginState.formattingIsPresent) dispatch($8358cdbd6d84c9ad$export$18d4026d1ea86bb1, newPluginState);
                return newPluginState;
            }
        },
        key: $8358cdbd6d84c9ad$export$18d4026d1ea86bb1,
        props: {
            /**
       * As we only want the left alt key to work for headings shortcuts on Windows
       * we can't use prosemirror-keymap and need to handle these shortcuts specially
       * Shortcut on Mac: Cmd-Opt-{heading level}
       * Shortcut on Windows: Ctrl-LeftAlt-{heading level}
       */ handleKeyDown: (view, event)=>{
                let headingLevel = (0, $bujnZ.HEADING_KEYS).indexOf(event.keyCode);
                if (headingLevel === -1) // Check for numpad keys if not found in digits row
                headingLevel = (0, $bujnZ.HEADING_NUMPAD_KEYS).indexOf(event.keyCode);
                const browser = (0, $jxkn6.getBrowserInfo)();
                if (headingLevel > -1 && event.altKey) {
                    if (browser.mac && event.metaKey) {
                        var _editorAPI$core;
                        return (editorAPI === null || editorAPI === void 0 || (_editorAPI$core = editorAPI.core) === null || _editorAPI$core === void 0 ? void 0 : _editorAPI$core.actions.execute($8358cdbd6d84c9ad$var$autoformatHeading(headingLevel, editorAnalyticsApi))) ?? false;
                    } else if (!browser.mac && event.ctrlKey && altKeyLocation !== event.DOM_KEY_LOCATION_RIGHT) {
                        var _editorAPI$core2;
                        return (editorAPI === null || editorAPI === void 0 || (_editorAPI$core2 = editorAPI.core) === null || _editorAPI$core2 === void 0 ? void 0 : _editorAPI$core2.actions.execute($8358cdbd6d84c9ad$var$autoformatHeading(headingLevel, editorAnalyticsApi))) ?? false;
                    }
                } else if (event.keyCode === (0, $bujnZ.KEY_7) && event.altKey) {
                    if (browser.mac && event.metaKey) {
                        var _editorAPI$core3;
                        return (editorAPI === null || editorAPI === void 0 || (_editorAPI$core3 = editorAPI.core) === null || _editorAPI$core3 === void 0 ? void 0 : _editorAPI$core3.actions.execute((0, $5j7nF.setSmallTextWithAnalytics)((0, $g6Qq4.INPUT_METHOD).SHORTCUT, editorAnalyticsApi))) ?? false;
                    } else if (!browser.mac && event.ctrlKey && altKeyLocation !== event.DOM_KEY_LOCATION_RIGHT) {
                        var _editorAPI$core4;
                        return (editorAPI === null || editorAPI === void 0 || (_editorAPI$core4 = editorAPI.core) === null || _editorAPI$core4 === void 0 ? void 0 : _editorAPI$core4.actions.execute((0, $5j7nF.setSmallTextWithAnalytics)((0, $g6Qq4.INPUT_METHOD).SHORTCUT, editorAnalyticsApi))) ?? false;
                    }
                } else if (event.key === 'Alt') // event.location is for the current key only; when a user hits Ctrl-Alt-1 the
                // location refers to the location of the '1' key
                // We store the location of the Alt key when it is hit to check against later
                altKeyLocation = event.location;
                else if (!event.altKey) altKeyLocation = 0;
                return false;
            }
        }
    });
};

});
parcelRegister("bujnZ", function(module, exports) {
$parcel$export(module.exports, "KEY_7", () => $cd30db4a99ae209a$export$495808184472a100);
$parcel$export(module.exports, "HEADING_KEYS", () => $cd30db4a99ae209a$export$442e847723cf0569);
$parcel$export(module.exports, "HEADING_NUMPAD_KEYS", () => $cd30db4a99ae209a$export$fcc4b4cb2de35e6);
const $cd30db4a99ae209a$var$KEY_0 = 48;
const $cd30db4a99ae209a$var$KEY_1 = 49;
const $cd30db4a99ae209a$var$KEY_2 = 50;
const $cd30db4a99ae209a$var$KEY_3 = 51;
const $cd30db4a99ae209a$var$KEY_4 = 52;
const $cd30db4a99ae209a$var$KEY_5 = 53;
const $cd30db4a99ae209a$var$KEY_6 = 54;
const $cd30db4a99ae209a$export$495808184472a100 = 55;
const $cd30db4a99ae209a$export$442e847723cf0569 = [
    $cd30db4a99ae209a$var$KEY_0,
    $cd30db4a99ae209a$var$KEY_1,
    $cd30db4a99ae209a$var$KEY_2,
    $cd30db4a99ae209a$var$KEY_3,
    $cd30db4a99ae209a$var$KEY_4,
    $cd30db4a99ae209a$var$KEY_5,
    $cd30db4a99ae209a$var$KEY_6
];
const $cd30db4a99ae209a$var$NUMPAD_KEY_0 = 96;
const $cd30db4a99ae209a$var$NUMPAD_KEY_1 = 97;
const $cd30db4a99ae209a$var$NUMPAD_KEY_2 = 98;
const $cd30db4a99ae209a$var$NUMPAD_KEY_3 = 99;
const $cd30db4a99ae209a$var$NUMPAD_KEY_4 = 100;
const $cd30db4a99ae209a$var$NUMPAD_KEY_5 = 101;
const $cd30db4a99ae209a$var$NUMPAD_KEY_6 = 102;
const $cd30db4a99ae209a$export$fcc4b4cb2de35e6 = [
    $cd30db4a99ae209a$var$NUMPAD_KEY_0,
    $cd30db4a99ae209a$var$NUMPAD_KEY_1,
    $cd30db4a99ae209a$var$NUMPAD_KEY_2,
    $cd30db4a99ae209a$var$NUMPAD_KEY_3,
    $cd30db4a99ae209a$var$NUMPAD_KEY_4,
    $cd30db4a99ae209a$var$NUMPAD_KEY_5,
    $cd30db4a99ae209a$var$NUMPAD_KEY_6
];

});


parcelRegister("5Cj1s", function(module, exports) {
$parcel$export(module.exports, "FloatingToolbarComponent", () => $b434bba052b1185d$export$b15abb95157a91c7);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $g6Qq4 = parcelRequire("g6Qq4");

var $5beht = parcelRequire("5beht");

var $797yE = parcelRequire("797yE");

var $6NIin = parcelRequire("6NIin");
const $b434bba052b1185d$var$FloatingToolbarSettings = {
    isSmall: true,
    disabled: false,
    isToolbarReducedSpacing: true,
    shouldUseDefaultRole: false
};
function $b434bba052b1185d$export$b15abb95157a91c7({ api: api }) {
    const { currentBlockType: currentBlockType, blockTypesDisabled: blockTypesDisabled, availableBlockTypes: availableBlockTypes, availableBlockTypesInDropdown: availableBlockTypesInDropdown, formattingIsPresent: formattingIsPresent } = (0, $5beht.useSharedPluginStateWithSelector)(api, [
        'blockType'
    ], (states)=>{
        var _states$blockTypeStat, _states$blockTypeStat2, _states$blockTypeStat3, _states$blockTypeStat4, _states$blockTypeStat5;
        return {
            currentBlockType: (_states$blockTypeStat = states.blockTypeState) === null || _states$blockTypeStat === void 0 ? void 0 : _states$blockTypeStat.currentBlockType,
            blockTypesDisabled: (_states$blockTypeStat2 = states.blockTypeState) === null || _states$blockTypeStat2 === void 0 ? void 0 : _states$blockTypeStat2.blockTypesDisabled,
            availableBlockTypes: (_states$blockTypeStat3 = states.blockTypeState) === null || _states$blockTypeStat3 === void 0 ? void 0 : _states$blockTypeStat3.availableBlockTypes,
            availableBlockTypesInDropdown: (_states$blockTypeStat4 = states.blockTypeState) === null || _states$blockTypeStat4 === void 0 ? void 0 : _states$blockTypeStat4.availableBlockTypesInDropdown,
            formattingIsPresent: (_states$blockTypeStat5 = states.blockTypeState) === null || _states$blockTypeStat5 === void 0 ? void 0 : _states$blockTypeStat5.formattingIsPresent
        };
    });
    const boundSetBlockType = (0, $bSJIT.useCallback)((name, fromBlockQuote)=>{
        var _api$core, _api$blockType;
        return api === null || api === void 0 || (_api$core = api.core) === null || _api$core === void 0 ? void 0 : _api$core.actions.execute(api === null || api === void 0 || (_api$blockType = api.blockType) === null || _api$blockType === void 0 || (_api$blockType = _api$blockType.commands) === null || _api$blockType === void 0 ? void 0 : _api$blockType.setTextLevel(name, (0, $g6Qq4.INPUT_METHOD).FLOATING_TB, fromBlockQuote));
    }, [
        api
    ]);
    const wrapBlockQuote = (0, $bSJIT.useCallback)(()=>{
        var _api$core2, _api$blockType2;
        return api === null || api === void 0 || (_api$core2 = api.core) === null || _api$core2 === void 0 ? void 0 : _api$core2.actions.execute(api === null || api === void 0 || (_api$blockType2 = api.blockType) === null || _api$blockType2 === void 0 || (_api$blockType2 = _api$blockType2.commands) === null || _api$blockType2 === void 0 ? void 0 : _api$blockType2.insertBlockQuote((0, $g6Qq4.INPUT_METHOD).FLOATING_TB));
    }, [
        api
    ]);
    const clearFormatting = (0, $bSJIT.useCallback)(()=>{
        var _api$core3, _api$blockType3;
        return api === null || api === void 0 || (_api$core3 = api.core) === null || _api$core3 === void 0 ? void 0 : _api$core3.actions.execute(api === null || api === void 0 || (_api$blockType3 = api.blockType) === null || _api$blockType3 === void 0 || (_api$blockType3 = _api$blockType3.commands) === null || _api$blockType3 === void 0 ? void 0 : _api$blockType3.clearFormatting((0, $g6Qq4.INPUT_METHOD).FLOATING_TB));
    }, [
        api
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $6NIin.default), {
        isSmall: $b434bba052b1185d$var$FloatingToolbarSettings.isSmall,
        isDisabled: $b434bba052b1185d$var$FloatingToolbarSettings.disabled,
        isReducedSpacing: (0, $797yE.editorExperiment)('platform_editor_controls', 'variant1') ? false : $b434bba052b1185d$var$FloatingToolbarSettings.isToolbarReducedSpacing,
        setTextLevel: boundSetBlockType,
        currentBlockType: currentBlockType,
        blockTypesDisabled: blockTypesDisabled,
        availableBlockTypes: availableBlockTypes,
        availableBlockTypesInDropdown: availableBlockTypesInDropdown,
        formattingIsPresent: formattingIsPresent,
        wrapBlockQuote: wrapBlockQuote,
        clearFormatting: clearFormatting,
        shouldUseDefaultRole: $b434bba052b1185d$var$FloatingToolbarSettings.shouldUseDefaultRole,
        api: api
    });
}

});
parcelRegister("6NIin", function(module, exports) {
$parcel$export(module.exports, "default", () => $af69733ce60794b1$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $fK3tS = parcelRequire("fK3tS");

var $cv8id = parcelRequire("cv8id");

var $glyUo = parcelRequire("glyUo");

var $g42cj = parcelRequire("g42cj");

var $fWCaV = parcelRequire("fWCaV");

var $5bbjm = parcelRequire("5bbjm");

var $dca9w = parcelRequire("dca9w");

var $gUpf2 = parcelRequire("gUpf2");

var $9BVpB = parcelRequire("9BVpB");

var $797yE = parcelRequire("797yE");

var $bTehu = parcelRequire("bTehu");

var $97VXU = parcelRequire("97VXU");

var $bnwUP = parcelRequire("bnwUP");

var $aOroS = parcelRequire("aOroS");
const $af69733ce60794b1$var$buttonWrapperStyles = (0, $9BVpB.xcss)({
    flexShrink: 0
});
// eslint-disable-next-line @repo/internal/react/no-class-components
class $af69733ce60794b1$var$ToolbarBlockType extends (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).PureComponent {
    componentDidMount() {
        const observer = new (0, $bTehu.ThemeMutationObserver)(({ typography: typography })=>{
            if (typography !== this.state.typographyTheme) this.setState({
                typographyTheme: typography
            });
        });
        this.setState({
            observer: observer
        });
        observer.observe();
    }
    componentWillUnmount() {
        var _this$state$observer;
        (_this$state$observer = this.state.observer) === null || _this$state$observer === void 0 || _this$state$observer.disconnect();
    }
    render() {
        const { active: active, isOpenedByKeyboard: isOpenedByKeyboard } = this.state;
        const { popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, isSmall: isSmall, isReducedSpacing: isReducedSpacing, currentBlockType: currentBlockType, blockTypesDisabled: blockTypesDisabled, availableBlockTypes: availableBlockTypes = [], availableBlockTypesInDropdown: availableBlockTypesInDropdown = [], shouldUseDefaultRole: shouldUseDefaultRole, intl: { formatMessage: formatMessage }, api: api } = this.props;
        const isHeadingDisabled = !availableBlockTypes.some((blockType)=>blockType.nodeName === 'heading');
        if (isHeadingDisabled) return null;
        const blockTypeTitles = availableBlockTypesInDropdown.filter((blockType)=>blockType.name === (currentBlockType === null || currentBlockType === void 0 ? void 0 : currentBlockType.name)).map((blockType)=>blockType.title);
        const defaultIcon = /*#__PURE__*/ (0, $9dQre.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dca9w))), {
            label: ""
        });
        const currentIcon = currentBlockType === null || currentBlockType === void 0 ? void 0 : currentBlockType.icon;
        if (!this.props.isDisabled && !blockTypesDisabled) {
            const items = this.createItems();
            const button = /*#__PURE__*/ (0, $9dQre.jsx)((0, $bnwUP.BlockTypeButton), {
                isSmall: isSmall,
                isReducedSpacing: isReducedSpacing,
                selected: active,
                disabled: false,
                title: blockTypeTitles[0],
                onClick: this.handleTriggerClick,
                onKeyDown: this.handleTriggerByKeyboard,
                formatMessage: formatMessage,
                "aria-expanded": active,
                blockTypeName: currentBlockType === null || currentBlockType === void 0 ? void 0 : currentBlockType.name,
                blockTypeIcon: currentIcon || defaultIcon
            });
            return /*#__PURE__*/ (0, $9dQre.jsx)("span", {
                css: [
                    (0, $g42cj.wrapperStyle),
                    (0, $aOroS.floatingToolbarWrapperStyle)
                ]
            }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $fWCaV.DropdownMenuWithKeyboardNavigation), {
                items: items,
                onOpenChange: this.onOpenChange,
                onItemActivated: this.handleSelectBlockType,
                isOpen: active,
                mountTo: popupsMountPoint,
                boundariesElement: popupsBoundariesElement,
                scrollableElement: popupsScrollableElement,
                zIndex: (0, $5bbjm.akEditorMenuZIndex),
                fitHeight: 360,
                fitWidth: 106,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                section: {
                    hasSeparator: true
                },
                shouldUseDefaultRole: shouldUseDefaultRole,
                // hasSeparator={true}
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                shouldFocusFirstItem: ()=>{
                    if (isOpenedByKeyboard) // eslint-disable-next-line @repo/internal/react/no-set-state-inside-render
                    this.setState({
                        ...this.state,
                        isOpenedByKeyboard: false
                    });
                    return isOpenedByKeyboard;
                }
            }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $gUpf2.Box), {
                xcss: $af69733ce60794b1$var$buttonWrapperStyles
            }, button)), !(api !== null && api !== void 0 && api.primaryToolbar) && /*#__PURE__*/ (0, $9dQre.jsx)("span", {
                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                css: (0, $g42cj.separatorStyles)
            }));
        }
        return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $9dQre.jsx)("span", {
            css: (0, $g42cj.wrapperStyle)
        }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $bnwUP.BlockTypeButton), {
            isSmall: isSmall,
            isReducedSpacing: isReducedSpacing,
            selected: active,
            disabled: true,
            title: blockTypeTitles[0],
            onClick: this.handleTriggerClick,
            onKeyDown: this.handleTriggerByKeyboard,
            formatMessage: formatMessage,
            "aria-expanded": active,
            blockTypeName: currentBlockType === null || currentBlockType === void 0 ? void 0 : currentBlockType.name,
            blockTypeIcon: currentIcon || defaultIcon
        }), !(api !== null && api !== void 0 && api.primaryToolbar) && /*#__PURE__*/ (0, $9dQre.jsx)("span", {
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            css: (0, $g42cj.separatorStyles)
        })));
    }
    constructor(...args){
        super(...args), this.state = {
            active: false,
            isOpenedByKeyboard: false,
            typographyTheme: undefined,
            observer: null
        }, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onOpenChange = (attrs)=>{
            this.setState({
                ...this.state,
                active: attrs.isOpen,
                isOpenedByKeyboard: attrs.isOpenedByKeyboard
            });
        }, this.handleTriggerClick = ()=>{
            this.onOpenChange({
                isOpen: !this.state.active,
                isOpenedByKeyboard: false
            });
        }, this.handleTriggerByKeyboard = (event)=>{
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                this.onOpenChange({
                    isOpen: !this.state.active,
                    isOpenedByKeyboard: true
                });
            }
        }, this.createItems = ()=>{
            const { intl: { formatMessage: formatMessage }, currentBlockType: currentBlockType, availableBlockTypesInDropdown: availableBlockTypesInDropdown, formattingIsPresent: formattingIsPresent } = this.props;
            const items = (availableBlockTypesInDropdown ?? []).map((blockType, index)=>{
                const isActive = currentBlockType === blockType;
                const tagName = blockType.tagName || 'p';
                const Tag = tagName;
                const defaultMessage = Array.isArray(blockType.title.defaultMessage) ? blockType.title.defaultMessage.find((message)=>'value' in message) : blockType.title.defaultMessage;
                const description = typeof defaultMessage === 'string' ? defaultMessage : defaultMessage && 'value' in defaultMessage ? defaultMessage.value : '';
                const keyMap = (0, $cv8id.findKeymapByDescription)(description);
                const icon = blockType === null || blockType === void 0 ? void 0 : blockType.icon;
                const item = {
                    content: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    /*#__PURE__*/ (0, $9dQre.jsx)("div", {
                        css: (0, $aOroS.blockTypeMenuItemStyle)(tagName, isActive, this.state.typographyTheme)
                    }, /*#__PURE__*/ (0, $9dQre.jsx)(Tag, null, formatMessage(blockType.title))),
                    value: blockType,
                    'aria-label': (0, $cv8id.tooltip)(keyMap, formatMessage(blockType.title)),
                    key: `${blockType.name}-${index}`,
                    elemBefore: (0, $797yE.editorExperiment)('platform_editor_controls', 'variant1') ? icon : undefined,
                    elemAfter: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    /*#__PURE__*/ (0, $9dQre.jsx)("div", {
                        css: [
                            (0, $aOroS.keyboardShortcut),
                            isActive && (0, $aOroS.keyboardShortcutSelect)
                        ]
                    }, (0, $cv8id.tooltip)(keyMap)),
                    isActive: isActive
                };
                return item;
            });
            if ((availableBlockTypesInDropdown ?? []).map((blockType)=>blockType.name).includes('blockquote') && (0, $797yE.editorExperiment)('platform_editor_controls', 'control')) {
                const clearFormattingItem = {
                    content: /*#__PURE__*/ (0, $9dQre.jsx)("div", null, /*#__PURE__*/ (0, $9dQre.jsx)("p", null, (0, $glyUo.toolbarMessages).clearFormatting.defaultMessage)),
                    value: {
                        name: 'clearFormatting'
                    },
                    'aria-label': (0, $cv8id.tooltip)((0, $cv8id.clearFormatting), (0, $glyUo.toolbarMessages).clearFormatting.defaultMessage),
                    key: 'clear-formatting',
                    elemAfter: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    /*#__PURE__*/ (0, $9dQre.jsx)("div", {
                        css: [
                            (0, $aOroS.keyboardShortcut)
                        ]
                    }, (0, $cv8id.tooltip)((0, $cv8id.clearFormatting))),
                    isActive: false,
                    isDisabled: currentBlockType === (0, $97VXU.NORMAL_TEXT) && !formattingIsPresent
                };
                return [
                    {
                        items: items
                    },
                    {
                        items: [
                            clearFormattingItem
                        ]
                    }
                ];
            }
            return [
                {
                    items: items
                }
            ];
        }, this.handleSelectBlockType = ({ item: item, shouldCloseMenu: shouldCloseMenu = true })=>{
            const blockType = item.value;
            if (blockType.name === 'blockquote') this.props.wrapBlockQuote(blockType.name);
            else if (blockType.name === 'clearFormatting') this.props.clearFormatting();
            else {
                var _this$props$currentBl;
                const fromBlockQuote = ((_this$props$currentBl = this.props.currentBlockType) === null || _this$props$currentBl === void 0 ? void 0 : _this$props$currentBl.name) === 'blockquote';
                this.props.setTextLevel(blockType.name, fromBlockQuote);
            }
            if (shouldCloseMenu) this.setState({
                ...this.state,
                active: false
            });
        };
    }
}
// eslint-disable-next-line @typescript-eslint/no-restricted-types
const $af69733ce60794b1$var$_default_1 = (0, $fK3tS.default)($af69733ce60794b1$var$ToolbarBlockType);
var $af69733ce60794b1$export$2e2bcd8739ae039 = $af69733ce60794b1$var$_default_1;

});
parcelRegister("bnwUP", function(module, exports) {
$parcel$export(module.exports, "BlockTypeButton", () => $cbf68f1ed7424b20$export$60665cf15e769742);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $5cKiX = parcelRequire("5cKiX");

var $glyUo = parcelRequire("glyUo");

var $kLBYz = parcelRequire("kLBYz");

var $g42cj = parcelRequire("g42cj");

var $8zO6u = parcelRequire("8zO6u");

var $4GWyU = parcelRequire("4GWyU");

var $dca9w = parcelRequire("dca9w");

var $gUpf2 = parcelRequire("gUpf2");

var $9BVpB = parcelRequire("9BVpB");

var $797yE = parcelRequire("797yE");

var $97VXU = parcelRequire("97VXU");

var $aOroS = parcelRequire("aOroS");
const $cbf68f1ed7424b20$var$buttonContentStyle = (0, $9BVpB.xcss)({
    minWidth: `calc(80px + 2*${"var(--ds-space-075, 6px)"})`,
    overflow: 'hidden',
    padding: 'space.075'
});
const $cbf68f1ed7424b20$var$buttonContentReducedSpacingStyle = (0, $9BVpB.xcss)({
    padding: 'space.100',
    minWidth: `calc(80px + 2*${"var(--ds-space-100, 8px)"})`
});
const $cbf68f1ed7424b20$export$60665cf15e769742 = (props)=>{
    const blockTypeName = props.blockTypeName || '';
    const labelTextStyles = props.formatMessage((0, $glyUo.toolbarMessages).textStyles, {
        blockTypeName: blockTypeName
    });
    const toolipTextStyles = props.formatMessage((0, $glyUo.toolbarMessages).textStylesTooltip);
    const icon = (0, $797yE.editorExperiment)('platform_editor_controls', 'variant1') && props.blockTypeIcon ? props.blockTypeIcon : /*#__PURE__*/ (0, $9dQre.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dca9w))), {
        label: labelTextStyles,
        spacing: "spacious",
        color: "currentColor"
    });
    const chevronIconSpacing = (0, $797yE.editorExperiment)('platform_editor_controls', 'variant1') ? 'spacious' : 'none';
    const shouldUseIconAsButton = props.isSmall || (0, $797yE.editorExperiment)('platform_editor_controls', 'variant1');
    return /*#__PURE__*/ (0, $9dQre.jsx)((0, $8zO6u.default), {
        spacing: props.isReducedSpacing ? 'none' : 'default',
        selected: props.selected,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "block-type-btn",
        disabled: props.disabled,
        onClick: props.onClick,
        onKeyDown: props.onKeyDown,
        title: toolipTextStyles,
        "aria-label": labelTextStyles,
        "aria-haspopup": true,
        "aria-expanded": props['aria-expanded'],
        iconAfter: /*#__PURE__*/ (0, $9dQre.jsx)("span", {
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            css: [
                (0, $g42cj.wrapperStyle),
                props.isSmall && (0, $aOroS.wrapperSmallStyle)
            ],
            "data-testid": "toolbar-block-type-text-styles-icon"
        }, /*#__PURE__*/ (0, $9dQre.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, shouldUseIconAsButton && icon, /*#__PURE__*/ (0, $9dQre.jsx)("span", {
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            css: (0, $kLBYz.expandIconContainerStyle)
        }, /*#__PURE__*/ (0, $9dQre.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4GWyU))), {
            spacing: chevronIconSpacing,
            label: "",
            color: "currentColor",
            size: "small"
        }))))
    }, !shouldUseIconAsButton && /*#__PURE__*/ (0, $9dQre.jsx)((0, $gUpf2.Box), {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        xcss: [
            $cbf68f1ed7424b20$var$buttonContentStyle,
            props.isReducedSpacing && $cbf68f1ed7424b20$var$buttonContentReducedSpacingStyle
        ]
    }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $5cKiX.default), props.title || (0, $97VXU.NORMAL_TEXT).title)));
};

});
parcelRegister("aOroS", function(module, exports) {
$parcel$export(module.exports, "blockTypeMenuItemStyle", () => $3d02597963fef52d$export$2e548ca9c55ac73f);
$parcel$export(module.exports, "keyboardShortcut", () => $3d02597963fef52d$export$54ea58af6cf8bf3a);
$parcel$export(module.exports, "keyboardShortcutSelect", () => $3d02597963fef52d$export$b09cf4fbc27c2bae);
$parcel$export(module.exports, "wrapperSmallStyle", () => $3d02597963fef52d$export$4f9ef2b7bddb4c3a);
$parcel$export(module.exports, "floatingToolbarWrapperStyle", () => $3d02597963fef52d$export$a61e5f64ad28e14a);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9dQre = parcelRequire("9dQre");

var $kbjAk = parcelRequire("kbjAk");

var $gAI3f = parcelRequire("gAI3f");

var $hqEKl = parcelRequire("hqEKl");
function $3d02597963fef52d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $3d02597963fef52d$export$2e548ca9c55ac73f = (tagName, selected, typographyTheme)=>{
    // TEMP FIX: See https://product-fabric.atlassian.net/browse/ED-13878
    const selectedStyle = selected ? `${tagName} { color: ${"var(--ds-text, #292A2E)"} !important; }` : '';
    return ()=>/*#__PURE__*/ (0, $9dQre.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        tagName === 'blockquote' ? (0, $kbjAk.blockquoteSharedStyles) : (0, $gAI3f.headingsSharedStyles)(typographyTheme), ">{h1, h2, h3, h4, h5, h6{margin-top:0;}blockquote{padding-top:0;padding-bottom:0;margin-top:0;}}", // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        selectedStyle);
};
const $3d02597963fef52d$export$54ea58af6cf8bf3a = /*#__PURE__*/ (0, $9dQre.css)((0, $hqEKl.shortcutStyle), "margin-left:var(--ds-space-200, 16px);color:var(--ds-icon, #292A2E);");
const $3d02597963fef52d$export$b09cf4fbc27c2bae = {
    name: "1cmggog",
    styles: "color:var(--ds-icon, #292A2E)"
};
const $3d02597963fef52d$export$4f9ef2b7bddb4c3a = {
    name: "1eh91m4",
    styles: "margin-left:var(--ds-space-050, 4px);min-width:40px"
};
const $3d02597963fef52d$export$e1f541b6d8e35681 = {
    name: "1igsh0u",
    styles: "margin-left:var(--ds-space-negative-100, -8px)"
};
const $3d02597963fef52d$export$a61e5f64ad28e14a = {
    name: "1t1gmw4",
    styles: "[data-role='droplistContent']{max-height:90vh;}"
};

});
parcelRegister("kbjAk", function(module, exports) {
$parcel$export(module.exports, "blockquoteSharedStyles", () => $94d5252b9aa3f720$export$1b5f3b43e6c4a8ee);
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9dQre = parcelRequire("9dQre");

var $5bbjm = parcelRequire("5bbjm");
const $94d5252b9aa3f720$export$1b5f3b43e6c4a8ee = /*#__PURE__*/ (0, $9dQre.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& blockquote': {
        boxSizing: 'border-box',
        color: 'inherit',
        width: '100%',
        display: 'inline-block',
        paddingLeft: "var(--ds-space-200, 16px)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        borderLeft: `${"var(--ds-border-width-selected, 2px)"} solid ${"var(--ds-border, #0B120E24)"}`,
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: `${(0, $5bbjm.blockNodesVerticalMargin)} 0 0 0`,
        marginRight: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        "[dir='rtl'] &": {
            paddingLeft: 0,
            paddingRight: "var(--ds-space-200, 16px)"
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:first-child': {
            marginTop: 0
        },
        '&::before': {
            content: "''"
        },
        '&::after': {
            content: 'none'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& p': {
            display: 'block'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '& table, & table:last-child': {
            display: 'inline-table'
        },
        // Workaround for overriding the inline-block display on last child of a blockquote set in CSS reset.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
        '> .code-block:last-child, >.mediaSingleView-content-wrap:last-child, >.mediaGroupView-content-wrap:last-child': {
            display: 'block'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '> .extensionView-content-wrap:last-child': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            display: 'block'
        }
    }
});

});

parcelRegister("gAI3f", function(module, exports) {
$parcel$export(module.exports, "headingsSharedStyles", () => $44a74840b2dc74e8$export$9272613b68afed4b);
/* eslint-disable @atlaskit/ui-styling-standard/use-compiled -- Pre-existing lint debt surfaced by this mechanical type-import-only PR. */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ /* eslint-disable @atlaskit/design-system/use-tokens-space */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9dQre = parcelRequire("9dQre");

var $hyCzT = parcelRequire("hyCzT");
const $44a74840b2dc74e8$var$headingWithAlignmentStyles = ()=>// Override marginTop: 0 with default margin found in headingsSharedStyles for first heading in alignment block that is not the first child
    ({
        '.fabric-editor-block-mark.fabric-editor-alignment:not(:first-child)': {
            '> h1:first-child': {
                marginTop: '1.667em'
            },
            ' > h2:first-child': {
                marginTop: '1.8em'
            },
            '> h3:first-child': {
                marginTop: '2em'
            },
            '> h4:first-child': {
                marginTop: '1.357em'
            },
            '> h5:first-child': {
                marginTop: '1.667em'
            },
            '> h6:first-child': {
                marginTop: '1.455em'
            }
        },
        // Set marginTop: 0 if alignment block is next to a gap cursor or widget that is first child
        '.ProseMirror-gapcursor:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .fabric-editor-block-mark.fabric-editor-alignment, .ProseMirror-widget:first-child + .ProseMirror-widget:nth-child(2) + .fabric-editor-block-mark.fabric-editor-alignment': {
            '> :is(h1, h2, h3, h4, h5, h6):first-child': {
                marginTop: '0'
            }
        }
    });
const $44a74840b2dc74e8$export$9272613b68afed4b = (_typographyTheme)=>{
    return /*#__PURE__*/ (0, $9dQre.css)({
        '& h1': {
            font: (0, $hyCzT.default)('editor.font.heading.h1'),
            marginBottom: 0,
            marginTop: '1.45833em',
            '& strong': {
                fontWeight: (0, $hyCzT.default)('editor.font.weight.heading.h1.bold')
            },
            '&::before': {}
        },
        '& h2': {
            font: (0, $hyCzT.default)('editor.font.heading.h2'),
            marginTop: '1.4em',
            marginBottom: 0,
            '& strong': {
                fontWeight: (0, $hyCzT.default)('editor.font.weight.heading.h1.bold')
            }
        },
        '& h3': {
            font: (0, $hyCzT.default)('editor.font.heading.h3'),
            marginTop: '1.31249em',
            marginBottom: 0,
            '& strong': {
                fontWeight: (0, $hyCzT.default)('editor.font.weight.heading.h1.bold')
            }
        },
        '& h4': {
            font: (0, $hyCzT.default)('editor.font.heading.h4'),
            marginTop: '1.25em',
            '& strong': {
                fontWeight: (0, $hyCzT.default)('editor.font.weight.heading.h1.bold')
            }
        },
        '& h5': {
            font: (0, $hyCzT.default)('editor.font.heading.h5'),
            marginTop: '1.45833em',
            textTransform: 'none',
            '& strong': {
                fontWeight: (0, $hyCzT.default)('editor.font.weight.heading.h1.bold')
            }
        },
        '& h6': {
            font: (0, $hyCzT.default)('editor.font.heading.h6'),
            marginTop: '1.59091em',
            textTransform: 'none',
            '& strong': {
                fontWeight: (0, $hyCzT.default)('editor.font.weight.heading.h1.bold')
            }
        },
        ...$44a74840b2dc74e8$var$headingWithAlignmentStyles()
    });
};

});





parcelRegister("d5Qde", function(module, exports) {
$parcel$export(module.exports, "PrimaryToolbarComponent", () => $22d11d26d843f434$export$94516d5cccf573e3);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $g6Qq4 = parcelRequire("g6Qq4");

var $5beht = parcelRequire("5beht");

var $6NIin = parcelRequire("6NIin");
function $22d11d26d843f434$export$94516d5cccf573e3({ api: api, isSmall: isSmall, disabled: disabled, isToolbarReducedSpacing: isToolbarReducedSpacing, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, shouldUseDefaultRole: shouldUseDefaultRole }) {
    const { currentBlockType: currentBlockType, blockTypesDisabled: blockTypesDisabled, availableBlockTypes: availableBlockTypes, availableBlockTypesInDropdown: availableBlockTypesInDropdown, formattingIsPresent: formattingIsPresent } = (0, $5beht.useSharedPluginStateWithSelector)(api, [
        'blockType'
    ], (states)=>{
        var _states$blockTypeStat, _states$blockTypeStat2, _states$blockTypeStat3, _states$blockTypeStat4, _states$blockTypeStat5;
        return {
            currentBlockType: (_states$blockTypeStat = states.blockTypeState) === null || _states$blockTypeStat === void 0 ? void 0 : _states$blockTypeStat.currentBlockType,
            blockTypesDisabled: (_states$blockTypeStat2 = states.blockTypeState) === null || _states$blockTypeStat2 === void 0 ? void 0 : _states$blockTypeStat2.blockTypesDisabled,
            availableBlockTypes: (_states$blockTypeStat3 = states.blockTypeState) === null || _states$blockTypeStat3 === void 0 ? void 0 : _states$blockTypeStat3.availableBlockTypes,
            availableBlockTypesInDropdown: (_states$blockTypeStat4 = states.blockTypeState) === null || _states$blockTypeStat4 === void 0 ? void 0 : _states$blockTypeStat4.availableBlockTypesInDropdown,
            formattingIsPresent: (_states$blockTypeStat5 = states.blockTypeState) === null || _states$blockTypeStat5 === void 0 ? void 0 : _states$blockTypeStat5.formattingIsPresent
        };
    });
    const boundSetBlockType = (name, fromBlockQuote)=>{
        var _api$core, _api$blockType;
        return api === null || api === void 0 || (_api$core = api.core) === null || _api$core === void 0 ? void 0 : _api$core.actions.execute(api === null || api === void 0 || (_api$blockType = api.blockType) === null || _api$blockType === void 0 || (_api$blockType = _api$blockType.commands) === null || _api$blockType === void 0 ? void 0 : _api$blockType.setTextLevel(name, (0, $g6Qq4.INPUT_METHOD).TOOLBAR, fromBlockQuote));
    };
    const wrapBlockQuote = ()=>{
        var _api$core2, _api$blockType2;
        return api === null || api === void 0 || (_api$core2 = api.core) === null || _api$core2 === void 0 ? void 0 : _api$core2.actions.execute(api === null || api === void 0 || (_api$blockType2 = api.blockType) === null || _api$blockType2 === void 0 || (_api$blockType2 = _api$blockType2.commands) === null || _api$blockType2 === void 0 ? void 0 : _api$blockType2.insertBlockQuote((0, $g6Qq4.INPUT_METHOD).TOOLBAR));
    };
    const clearFormatting = ()=>{
        var _api$core3, _api$blockType3;
        return api === null || api === void 0 || (_api$core3 = api.core) === null || _api$core3 === void 0 ? void 0 : _api$core3.actions.execute(api === null || api === void 0 || (_api$blockType3 = api.blockType) === null || _api$blockType3 === void 0 || (_api$blockType3 = _api$blockType3.commands) === null || _api$blockType3 === void 0 ? void 0 : _api$blockType3.clearFormatting((0, $g6Qq4.INPUT_METHOD).TOOLBAR));
    };
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $6NIin.default), {
        isSmall: isSmall,
        isDisabled: disabled,
        isReducedSpacing: isToolbarReducedSpacing,
        setTextLevel: boundSetBlockType,
        wrapBlockQuote: wrapBlockQuote,
        clearFormatting: clearFormatting,
        currentBlockType: currentBlockType,
        blockTypesDisabled: blockTypesDisabled,
        availableBlockTypes: availableBlockTypes,
        availableBlockTypesInDropdown: availableBlockTypesInDropdown,
        formattingIsPresent: formattingIsPresent,
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        shouldUseDefaultRole: shouldUseDefaultRole,
        api: api
    });
}

});

parcelRegister("lD7vN", function(module, exports) {
$parcel$export(module.exports, "getToolbarComponents", () => $5cc57dbb16ab625c$export$a758406ca53b86a5);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $4rzOL = parcelRequire("4rzOL");

var $fiku8 = parcelRequire("fiku8");

var $97VXU = parcelRequire("97VXU");

var $5XdCn = parcelRequire("5XdCn");

var $kosNz = parcelRequire("kosNz");

var $d90Uh = parcelRequire("d90Uh");
const $5cc57dbb16ab625c$export$a758406ca53b86a5 = (api, allowFontSize)=>{
    const toolbarComponents = [
        {
            type: (0, $4rzOL.TEXT_STYLES_GROUP).type,
            key: (0, $4rzOL.TEXT_STYLES_GROUP).key,
            parents: [
                {
                    type: (0, $4rzOL.TEXT_SECTION).type,
                    key: (0, $4rzOL.TEXT_SECTION).key,
                    rank: (0, $fiku8.TEXT_SECTION_RANK)[(0, $4rzOL.TEXT_STYLES_GROUP).key]
                },
                {
                    type: (0, $4rzOL.TEXT_SECTION_PRIMARY_TOOLBAR).type,
                    key: (0, $4rzOL.TEXT_SECTION_PRIMARY_TOOLBAR).key,
                    rank: (0, $fiku8.TEXT_SECTION_PRIMARY_TOOLBAR_RANK)[(0, $4rzOL.TEXT_STYLES_GROUP).key]
                }
            ]
        },
        {
            type: (0, $4rzOL.TEXT_STYLES_MENU).type,
            key: (0, $4rzOL.TEXT_STYLES_MENU).key,
            parents: [
                {
                    type: (0, $4rzOL.TEXT_STYLES_GROUP).type,
                    key: (0, $4rzOL.TEXT_STYLES_GROUP).key,
                    rank: (0, $fiku8.TEXT_STYLES_GROUP_RANK)[(0, $4rzOL.TEXT_STYLES_MENU).key]
                }
            ],
            component: ({ children: children })=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $d90Uh.TextStylesMenuButton), {
                    api: api,
                    allowFontSize: allowFontSize,
                    children: children
                })
        },
        {
            type: (0, $4rzOL.TEXT_STYLES_MENU_SECTION).type,
            key: (0, $4rzOL.TEXT_STYLES_MENU_SECTION).key,
            parents: [
                {
                    type: (0, $4rzOL.TEXT_STYLES_MENU).type,
                    key: (0, $4rzOL.TEXT_STYLES_MENU).key,
                    rank: (0, $fiku8.TEXT_STYLES_MENU_RANK)[(0, $4rzOL.TEXT_STYLES_MENU_SECTION).key]
                },
                {
                    type: (0, $4rzOL.TEXT_COLLAPSED_MENU).type,
                    key: (0, $4rzOL.TEXT_COLLAPSED_MENU).key,
                    rank: (0, $fiku8.TEXT_COLLAPSED_MENU_RANK)[(0, $4rzOL.TEXT_STYLES_MENU_SECTION).key]
                }
            ]
        }
    ];
    Object.values((0, $97VXU.toolbarBlockTypesWithRank)({
        allowFontSize: allowFontSize
    })).forEach((blockType)=>{
        if (blockType.toolbarKey) {
            const menuItem = {
                type: 'menu-item',
                key: blockType.toolbarKey,
                parents: [
                    {
                        type: (0, $4rzOL.TEXT_STYLES_MENU_SECTION).type,
                        key: (0, $4rzOL.TEXT_STYLES_MENU_SECTION).key,
                        rank: blockType.toolbarRank
                    }
                ],
                component: blockType.name === 'blockquote' ? ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $kosNz.QuoteButton), {
                        blockType: blockType,
                        api: api
                    }) : ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $5XdCn.HeadingButton), {
                        blockType: blockType,
                        api: api
                    })
            };
            toolbarComponents.push(menuItem);
        }
    });
    return toolbarComponents;
};

});
parcelRegister("5XdCn", function(module, exports) {
$parcel$export(module.exports, "HeadingButton", () => $98936af81fb1a21f$export$a24781eb35f914a5);
/* HeadingButton.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ 
var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $g6Qq4 = parcelRequire("g6Qq4");

var $hyCzT = parcelRequire("hyCzT");

var $cv8id = parcelRequire("cv8id");

var $28qc1 = parcelRequire("28qc1");

var $2pWL6 = parcelRequire("2pWL6");

var $dbuPt = parcelRequire("dbuPt");

var $jBWM2 = parcelRequire("jBWM2");

var $55apt = parcelRequire("55apt");
const $98936af81fb1a21f$var$headingTextProps = {
    normal: {
        style: {
            font: (0, $hyCzT.default)('editor.font.body')
        }
    },
    smallText: {
        style: {
            font: (0, $hyCzT.default)('editor.font.body.small') ?? (0, $hyCzT.default)('editor.font.body')
        }
    },
    heading1: {
        style: {
            font: (0, $hyCzT.default)('editor.font.heading.h1')
        }
    },
    heading2: {
        style: {
            font: (0, $hyCzT.default)('editor.font.heading.h2')
        }
    },
    heading3: {
        style: {
            font: (0, $hyCzT.default)('editor.font.heading.h3')
        }
    },
    heading4: {
        style: {
            font: (0, $hyCzT.default)('editor.font.heading.h4')
        }
    },
    heading5: {
        style: {
            font: (0, $hyCzT.default)('editor.font.heading.h5')
        }
    },
    heading6: {
        style: {
            font: (0, $hyCzT.default)('editor.font.heading.h6')
        }
    }
};
const $98936af81fb1a21f$var$HeadingText = ({ children: children, headingType: headingType })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement('div', $98936af81fb1a21f$var$headingTextProps[headingType], children);
};
const $98936af81fb1a21f$var$shortcuts = {
    normal: (0, $cv8id.setNormalText),
    smallText: (0, $cv8id.toggleSmallText),
    heading1: (0, $cv8id.toggleHeading1),
    heading2: (0, $cv8id.toggleHeading2),
    heading3: (0, $cv8id.toggleHeading3),
    heading4: (0, $cv8id.toggleHeading4),
    heading5: (0, $cv8id.toggleHeading5),
    heading6: (0, $cv8id.toggleHeading6)
};
const $98936af81fb1a21f$var$shouldDisableHeadingButton = (state, blockType)=>{
    if (!state) return false;
    return (0, $55apt.isSelectionInsideListNode)(state) && blockType.name !== 'normal' && blockType.name !== 'smallText';
};
const $98936af81fb1a21f$export$a24781eb35f914a5 = ({ blockType: blockType, api: api })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const currentBlockType = (0, $2pWL6.useSharedPluginStateSelector)(api, 'blockType.currentBlockType');
    const availableBlockTypesInDropdown = (0, $2pWL6.useSharedPluginStateSelector)(api, 'blockType.availableBlockTypesInDropdown');
    const { editorView: editorView } = (0, $28qc1.useEditorToolbar)();
    if (!(availableBlockTypesInDropdown !== null && availableBlockTypesInDropdown !== void 0 && availableBlockTypesInDropdown.some((availableBlockType)=>availableBlockType.name === blockType.name))) return null;
    const isDisabled = $98936af81fb1a21f$var$shouldDisableHeadingButton(editorView === null || editorView === void 0 ? void 0 : editorView.state, blockType);
    const fromBlockQuote = (currentBlockType === null || currentBlockType === void 0 ? void 0 : currentBlockType.name) === 'blockquote';
    const onClick = ()=>{
        var _api$core, _api$blockType;
        if (isDisabled) return;
        api === null || api === void 0 || (_api$core = api.core) === null || _api$core === void 0 || _api$core.actions.execute(api === null || api === void 0 || (_api$blockType = api.blockType) === null || _api$blockType === void 0 || (_api$blockType = _api$blockType.commands) === null || _api$blockType === void 0 ? void 0 : _api$blockType.setTextLevel(blockType.name, (0, $g6Qq4.INPUT_METHOD).TOOLBAR, fromBlockQuote));
    };
    const shortcut = (0, $cv8id.formatShortcut)($98936af81fb1a21f$var$shortcuts[blockType.name]);
    const isSelected = (currentBlockType === null || currentBlockType === void 0 ? void 0 : currentBlockType.name) === blockType.name;
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dbuPt.ToolbarDropdownItem), {
        elemBefore: blockType.icon,
        elemAfter: shortcut ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $jBWM2.ToolbarKeyboardShortcutHint), {
            shortcut: shortcut
        }) : undefined,
        onClick: onClick,
        isSelected: isSelected,
        isDisabled: isDisabled,
        ariaKeyshortcuts: shortcut,
        children: /*#__PURE__*/ (0, $dc70d.jsx)($98936af81fb1a21f$var$HeadingText, {
            headingType: blockType.name,
            children: formatMessage(blockType.title)
        })
    });
};

});

parcelRegister("kosNz", function(module, exports) {
$parcel$export(module.exports, "QuoteButton", () => $7e64a986944d724c$export$94ec63f36c20dec6);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $g6Qq4 = parcelRequire("g6Qq4");

var $cv8id = parcelRequire("cv8id");

var $28qc1 = parcelRequire("28qc1");

var $2pWL6 = parcelRequire("2pWL6");

var $dbuPt = parcelRequire("dbuPt");

var $jBWM2 = parcelRequire("jBWM2");

var $55apt = parcelRequire("55apt");
const $7e64a986944d724c$var$shouldDisableQuoteButton = (state)=>{
    if (!state) return false;
    return (0, $55apt.isSelectionInsideListNode)(state);
};
const $7e64a986944d724c$export$94ec63f36c20dec6 = ({ blockType: blockType, api: api })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const availableBlockTypesInDropdown = (0, $2pWL6.useSharedPluginStateSelector)(api, 'blockType.availableBlockTypesInDropdown');
    const currentBlockType = (0, $2pWL6.useSharedPluginStateSelector)(api, 'blockType.currentBlockType');
    const { editorView: editorView } = (0, $28qc1.useEditorToolbar)();
    if (!(availableBlockTypesInDropdown !== null && availableBlockTypesInDropdown !== void 0 && availableBlockTypesInDropdown.some((availableBlockType)=>availableBlockType.name === blockType.name))) return null;
    const isDisabled = $7e64a986944d724c$var$shouldDisableQuoteButton(editorView === null || editorView === void 0 ? void 0 : editorView.state);
    const onClick = ()=>{
        var _api$core, _api$blockType;
        if (isDisabled) return;
        api === null || api === void 0 || (_api$core = api.core) === null || _api$core === void 0 || _api$core.actions.execute(api === null || api === void 0 || (_api$blockType = api.blockType) === null || _api$blockType === void 0 || (_api$blockType = _api$blockType.commands) === null || _api$blockType === void 0 ? void 0 : _api$blockType.insertBlockQuote((0, $g6Qq4.INPUT_METHOD).TOOLBAR));
    };
    const shortcut = (0, $cv8id.formatShortcut)((0, $cv8id.toggleBlockQuote));
    const isSelected = currentBlockType === blockType;
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dbuPt.ToolbarDropdownItem), {
        elemBefore: blockType.icon,
        elemAfter: shortcut ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $jBWM2.ToolbarKeyboardShortcutHint), {
            shortcut: shortcut
        }) : undefined,
        onClick: onClick,
        isSelected: isSelected,
        isDisabled: isDisabled,
        ariaKeyshortcuts: shortcut,
        children: formatMessage(blockType.title)
    });
};

});

parcelRegister("d90Uh", function(module, exports) {
$parcel$export(module.exports, "TextStylesMenuButton", () => $88263b9d4ca03eb7$export$e34ebed463fa4947);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $glyUo = parcelRequire("glyUo");

var $28qc1 = parcelRequire("28qc1");

var $5beht = parcelRequire("5beht");

var $dca9w = parcelRequire("dca9w");

var $6PDfA = parcelRequire("6PDfA");

var $eHnl8 = parcelRequire("eHnl8");

var $97VXU = parcelRequire("97VXU");
const $88263b9d4ca03eb7$var$selectPluginState = (state)=>{
    var _state$blockTypeState, _state$blockTypeState2;
    return {
        blockTypesDisabled: (_state$blockTypeState = state.blockTypeState) === null || _state$blockTypeState === void 0 ? void 0 : _state$blockTypeState.blockTypesDisabled,
        currentBlockType: (_state$blockTypeState2 = state.blockTypeState) === null || _state$blockTypeState2 === void 0 ? void 0 : _state$blockTypeState2.currentBlockType
    };
};
const $88263b9d4ca03eb7$var$usePluginState = (api)=>(0, $5beht.useSharedPluginStateWithSelector)(api, [
        'blockType'
    ], $88263b9d4ca03eb7$var$selectPluginState);
const $88263b9d4ca03eb7$export$e34ebed463fa4947 = ({ allowFontSize: allowFontSize, api: api, children: children })=>{
    var _Object$values$find;
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const { blockTypesDisabled: blockTypesDisabled, currentBlockType: currentBlockType } = $88263b9d4ca03eb7$var$usePluginState(api);
    const blockTypes = (0, $97VXU.toolbarBlockTypesWithRank)({
        allowFontSize: allowFontSize
    });
    const { editorAppearance: editorAppearance } = (0, $28qc1.useEditorToolbar)();
    const CurrentIcon = (_Object$values$find = Object.values(blockTypes).find((blockType)=>blockType.name === (currentBlockType === null || currentBlockType === void 0 ? void 0 : currentBlockType.name))) === null || _Object$values$find === void 0 || (_Object$values$find = _Object$values$find.icon) === null || _Object$values$find === void 0 ? void 0 : _Object$values$find.type;
    const normalText = blockTypes.normal;
    const TriggerIcon = (0, $bSJIT.useMemo)(()=>{
        if (editorAppearance === 'full-page') {
            const hasCurrentBlockType = currentBlockType && CurrentIcon;
            const Icon = hasCurrentBlockType ? CurrentIcon : (0, (/*@__PURE__*/$parcel$interopDefault($dca9w)));
            return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $dc70d.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $dc70d.jsx)(Icon, {
                        label: "",
                        size: "small"
                    }),
                    hasCurrentBlockType ? formatMessage(currentBlockType.title) : formatMessage(normalText.title)
                ]
            });
        }
        return CurrentIcon ? /*#__PURE__*/ (0, $dc70d.jsx)(CurrentIcon, {
            label: `${currentBlockType === null || currentBlockType === void 0 ? void 0 : currentBlockType.name} ${formatMessage((0, $glyUo.toolbarMessages).textStylesTooltip)}`,
            size: "small"
        }) : /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dca9w))), {
            label: formatMessage((0, $glyUo.toolbarMessages).textStylesTooltip),
            size: "small"
        });
    }, [
        editorAppearance,
        currentBlockType,
        CurrentIcon,
        normalText,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $6PDfA.ToolbarDropdownMenu), {
        isDisabled: blockTypesDisabled,
        iconBefore: TriggerIcon,
        tooltipComponent: /*#__PURE__*/ (0, $dc70d.jsx)((0, $eHnl8.ToolbarTooltip), {
            content: formatMessage((0, $glyUo.toolbarMessages).textStylesTooltip)
        }),
        label: formatMessage((0, $glyUo.toolbarMessages).textStyles, {
            blockTypeName: currentBlockType === null || currentBlockType === void 0 ? void 0 : currentBlockType.name
        }),
        shouldRenderToParent: true,
        children: children
    });
};

});


parcelRegister("lzFsh", function(module, exports) {
$parcel$export(module.exports, "getBlockTypeComponents", () => $054f17fd176a490a$export$325b6b890260a604);

var $30Yan = parcelRequire("30Yan");

var $fY4jW = parcelRequire("fY4jW");

var $3y2s4 = parcelRequire("3y2s4");

var $6KzNM = parcelRequire("6KzNM");

var $7kidj = parcelRequire("7kidj");

var $6wiyg = parcelRequire("6wiyg");

var $6xR5b = parcelRequire("6xR5b");
const $054f17fd176a490a$var$HEADING_NODE_NAME = 'heading';
const $054f17fd176a490a$var$QUOTE_NODE_NAME = 'blockquote';
const $054f17fd176a490a$var$PARAGRAPH_NODE_NAME = 'paragraph';
const $054f17fd176a490a$export$325b6b890260a604 = (api, { allowFontSize: allowFontSize } = {})=>{
    const isSmallTextExperimentEnabled = (0, $3y2s4.isExperimentEnabled)('platform_editor_block_menu_small_text');
    const isSmallTextEnabled = Boolean(allowFontSize && isSmallTextExperimentEnabled);
    const textFormattingRank = isSmallTextExperimentEnabled ? (0, $fY4jW.TRANSFORM_TEXT_FORMATTING_MENU_SECTION_RANK) : (0, $fY4jW.TRANSFORM_HEADINGS_MENU_SECTION_RANK);
    const isTransformHeadingDisabled = (level)=>{
        var _api$blockMenu;
        return Boolean(api === null || api === void 0 || (_api$blockMenu = api.blockMenu) === null || _api$blockMenu === void 0 ? void 0 : _api$blockMenu.actions.isTransformOptionDisabled($054f17fd176a490a$var$HEADING_NODE_NAME, {
            level: level
        }));
    };
    return [
        {
            type: 'block-menu-item',
            key: (0, $30Yan.TRANSFORM_HEADINGS_H1_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $30Yan.TRANSFORM_TEXTFORMATTING_MENU_SECTION).key,
                rank: textFormattingRank[(0, $30Yan.TRANSFORM_HEADINGS_H1_MENU_ITEM).key]
            },
            component: (0, $6KzNM.createHeadingBlockMenuItem)({
                level: 1,
                api: api
            }),
            isHidden: ()=>isTransformHeadingDisabled(1)
        },
        {
            type: 'block-menu-item',
            key: (0, $30Yan.TRANSFORM_HEADINGS_H2_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $30Yan.TRANSFORM_TEXTFORMATTING_MENU_SECTION).key,
                rank: textFormattingRank[(0, $30Yan.TRANSFORM_HEADINGS_H2_MENU_ITEM).key]
            },
            component: (0, $6KzNM.createHeadingBlockMenuItem)({
                level: 2,
                api: api
            }),
            isHidden: ()=>isTransformHeadingDisabled(2)
        },
        {
            type: 'block-menu-item',
            key: (0, $30Yan.TRANSFORM_HEADINGS_H3_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $30Yan.TRANSFORM_TEXTFORMATTING_MENU_SECTION).key,
                rank: textFormattingRank[(0, $30Yan.TRANSFORM_HEADINGS_H3_MENU_ITEM).key]
            },
            component: (0, $6KzNM.createHeadingBlockMenuItem)({
                level: 3,
                api: api
            }),
            isHidden: ()=>isTransformHeadingDisabled(3)
        },
        {
            type: 'block-menu-item',
            key: (0, $30Yan.TRANSFORM_HEADINGS_H4_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $30Yan.TRANSFORM_TEXTFORMATTING_MENU_SECTION).key,
                rank: textFormattingRank[(0, $30Yan.TRANSFORM_HEADINGS_H4_MENU_ITEM).key]
            },
            component: (0, $6KzNM.createHeadingBlockMenuItem)({
                level: 4,
                api: api
            }),
            isHidden: ()=>isTransformHeadingDisabled(4)
        },
        {
            type: 'block-menu-item',
            key: (0, $30Yan.TRANSFORM_HEADINGS_H5_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $30Yan.TRANSFORM_TEXTFORMATTING_MENU_SECTION).key,
                rank: textFormattingRank[(0, $30Yan.TRANSFORM_HEADINGS_H5_MENU_ITEM).key]
            },
            component: (0, $6KzNM.createHeadingBlockMenuItem)({
                level: 5,
                api: api
            }),
            isHidden: ()=>isTransformHeadingDisabled(5)
        },
        {
            type: 'block-menu-item',
            key: (0, $30Yan.TRANSFORM_HEADINGS_H6_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $30Yan.TRANSFORM_TEXTFORMATTING_MENU_SECTION).key,
                rank: textFormattingRank[(0, $30Yan.TRANSFORM_HEADINGS_H6_MENU_ITEM).key]
            },
            component: (0, $6KzNM.createHeadingBlockMenuItem)({
                level: 6,
                api: api
            }),
            isHidden: ()=>isTransformHeadingDisabled(6)
        },
        {
            type: 'block-menu-item',
            key: (0, $30Yan.TRANSFORM_STRUCTURE_QUOTE_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: isSmallTextExperimentEnabled ? (0, $30Yan.TRANSFORM_TEXTFORMATTING_MENU_SECTION).key : (0, $30Yan.TRANSFORM_STRUCTURE_MENU_SECTION).key,
                rank: isSmallTextExperimentEnabled ? (0, $fY4jW.TRANSFORM_TEXT_FORMATTING_MENU_SECTION_RANK)[(0, $30Yan.TRANSFORM_STRUCTURE_QUOTE_MENU_ITEM).key] : (0, $fY4jW.TRANSFORM_STRUCTURE_MENU_SECTION_RANK)[(0, $30Yan.TRANSFORM_STRUCTURE_QUOTE_MENU_ITEM).key]
            },
            component: (0, $6wiyg.createQuoteBlockMenuItem)({
                api: api
            }),
            isHidden: ()=>{
                var _api$blockMenu2;
                return Boolean(api === null || api === void 0 || (_api$blockMenu2 = api.blockMenu) === null || _api$blockMenu2 === void 0 ? void 0 : _api$blockMenu2.actions.isTransformOptionDisabled($054f17fd176a490a$var$QUOTE_NODE_NAME));
            }
        },
        {
            type: 'block-menu-item',
            key: (0, $30Yan.TRANSFORM_STRUCTURE_PARAGRAPH_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: isSmallTextExperimentEnabled ? (0, $30Yan.TRANSFORM_TEXTFORMATTING_MENU_SECTION).key : (0, $30Yan.TRANSFORM_STRUCTURE_MENU_SECTION).key,
                rank: isSmallTextExperimentEnabled ? (0, $fY4jW.TRANSFORM_TEXT_FORMATTING_MENU_SECTION_RANK)[(0, $30Yan.TRANSFORM_STRUCTURE_PARAGRAPH_MENU_ITEM).key] : (0, $fY4jW.TRANSFORM_STRUCTURE_MENU_SECTION_RANK)[(0, $30Yan.TRANSFORM_STRUCTURE_PARAGRAPH_MENU_ITEM).key]
            },
            component: (0, $7kidj.createParagraphBlockMenuItem)({
                api: api
            }),
            isHidden: ()=>{
                var _api$blockMenu3;
                return Boolean(api === null || api === void 0 || (_api$blockMenu3 = api.blockMenu) === null || _api$blockMenu3 === void 0 ? void 0 : _api$blockMenu3.actions.isTransformOptionDisabled($054f17fd176a490a$var$PARAGRAPH_NODE_NAME, undefined, isSmallTextExperimentEnabled ? {
                    marksToRemove: [
                        'fontSize'
                    ]
                } : undefined));
            }
        },
        ...isSmallTextEnabled ? [
            {
                type: 'block-menu-item',
                key: (0, $30Yan.TRANSFORM_TEXT_FORMATTING_SMALL_TEXT_MENU_ITEM).key,
                parent: {
                    type: 'block-menu-section',
                    key: (0, $30Yan.TRANSFORM_TEXTFORMATTING_MENU_SECTION).key,
                    rank: (0, $fY4jW.TRANSFORM_TEXT_FORMATTING_MENU_SECTION_RANK)[(0, $30Yan.TRANSFORM_TEXT_FORMATTING_SMALL_TEXT_MENU_ITEM).key]
                },
                component: (0, $6xR5b.createSmallTextBlockMenuItem)({
                    api: api
                }),
                isHidden: ()=>{
                    var _api$core$sharedState, _api$blockMenu4;
                    return !(api !== null && api !== void 0 && (_api$core$sharedState = api.core.sharedState.currentState()) !== null && _api$core$sharedState !== void 0 && (_api$core$sharedState = _api$core$sharedState.schema) !== null && _api$core$sharedState !== void 0 && _api$core$sharedState.marks.fontSize) || Boolean(api === null || api === void 0 || (_api$blockMenu4 = api.blockMenu) === null || _api$blockMenu4 === void 0 ? void 0 : _api$blockMenu4.actions.isTransformOptionDisabled($054f17fd176a490a$var$PARAGRAPH_NODE_NAME, undefined, {
                        marksToAdd: {
                            fontSize: {
                                fontSize: 'small'
                            }
                        }
                    }));
                }
            }
        ] : []
    ];
};

});
parcelRegister("6KzNM", function(module, exports) {
$parcel$export(module.exports, "createHeadingBlockMenuItem", () => $a9b4b9746acad547$export$93c991c81dd77070);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $g6Qq4 = parcelRequire("g6Qq4");

var $8iYGb = parcelRequire("8iYGb");

var $dbuPt = parcelRequire("dbuPt");

var $c6mZq = parcelRequire("c6mZq");

var $hxpn3 = parcelRequire("hxpn3");

var $dhuIq = parcelRequire("dhuIq");

var $bbism = parcelRequire("bbism");

var $5RnyC = parcelRequire("5RnyC");

var $hz5BZ = parcelRequire("hz5BZ");
const $a9b4b9746acad547$var$headingIcons = [
    (0, (/*@__PURE__*/$parcel$interopDefault($dhuIq))),
    (0, (/*@__PURE__*/$parcel$interopDefault($hz5BZ))),
    (0, (/*@__PURE__*/$parcel$interopDefault($5RnyC))),
    (0, (/*@__PURE__*/$parcel$interopDefault($hxpn3))),
    (0, (/*@__PURE__*/$parcel$interopDefault($c6mZq))),
    (0, (/*@__PURE__*/$parcel$interopDefault($bbism)))
];
const $a9b4b9746acad547$var$headingMessages = [
    (0, $8iYGb.messages).heading1,
    (0, $8iYGb.messages).heading2,
    (0, $8iYGb.messages).heading3,
    (0, $8iYGb.messages).heading4,
    (0, $8iYGb.messages).heading5,
    (0, $8iYGb.messages).heading6
];
const $a9b4b9746acad547$var$NODE_NAME = 'heading';
const $a9b4b9746acad547$var$HeadingBlockMenuItem = ({ level: level, api: api, isSuggested: isSuggested })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const Icon = $a9b4b9746acad547$var$headingIcons[level - 1];
    const message = $a9b4b9746acad547$var$headingMessages[level - 1];
    const handleClick = (event)=>{
        const triggeredFrom = event.nativeEvent instanceof KeyboardEvent || event.nativeEvent.detail === 0 ? (0, $g6Qq4.INPUT_METHOD).KEYBOARD : (0, $g6Qq4.INPUT_METHOD).MOUSE;
        const inputMethod = (0, $g6Qq4.INPUT_METHOD).BLOCK_MENU;
        api === null || api === void 0 || api.core.actions.execute(({ tr: tr })=>{
            var _api$blockMenu;
            const command = api === null || api === void 0 || (_api$blockMenu = api.blockMenu) === null || _api$blockMenu === void 0 ? void 0 : _api$blockMenu.commands.transformNode(tr.doc.type.schema.nodes.heading, {
                inputMethod: inputMethod,
                isSuggested: isSuggested,
                triggeredFrom: triggeredFrom,
                targetTypeName: `${$a9b4b9746acad547$var$NODE_NAME}${level}`,
                targetAttrs: {
                    level: level
                }
            });
            return command ? command({
                tr: tr
            }) : null;
        });
    };
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dbuPt.ToolbarDropdownItem), {
        onClick: handleClick,
        elemBefore: /*#__PURE__*/ (0, $dc70d.jsx)(Icon, {
            label: "",
            size: "small"
        }),
        children: formatMessage(message)
    });
};
const $a9b4b9746acad547$export$93c991c81dd77070 = ({ level: level, api: api })=>{
    return ({ isSuggested: isSuggested } = {})=>/*#__PURE__*/ (0, $dc70d.jsx)($a9b4b9746acad547$var$HeadingBlockMenuItem, {
            level: level,
            api: api,
            isSuggested: isSuggested
        });
};

});

parcelRegister("7kidj", function(module, exports) {
$parcel$export(module.exports, "createParagraphBlockMenuItem", () => $979a6034c9bad9b4$export$469651dcc0916a77);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $g6Qq4 = parcelRequire("g6Qq4");

var $hETL4 = parcelRequire("hETL4");

var $dbuPt = parcelRequire("dbuPt");

var $eo2bn = parcelRequire("eo2bn");

var $75i6e = parcelRequire("75i6e");

var $3y2s4 = parcelRequire("3y2s4");
const $979a6034c9bad9b4$var$NODE_NAME = 'paragraph';
const $979a6034c9bad9b4$var$ParagraphBlockMenuItem = ({ api: api, isSuggested: isSuggested })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const isNormalTextLabelEnabled = (0, $3y2s4.isExperimentEnabled)('platform_editor_block_menu_small_text');
    const handleClick = (event)=>{
        const triggeredFrom = event.nativeEvent instanceof KeyboardEvent || event.nativeEvent.detail === 0 ? (0, $g6Qq4.INPUT_METHOD).KEYBOARD : (0, $g6Qq4.INPUT_METHOD).MOUSE;
        const inputMethod = (0, $g6Qq4.INPUT_METHOD).BLOCK_MENU;
        api === null || api === void 0 || api.core.actions.execute(({ tr: tr })=>{
            var _api$blockMenu;
            const command = api === null || api === void 0 || (_api$blockMenu = api.blockMenu) === null || _api$blockMenu === void 0 ? void 0 : _api$blockMenu.commands.transformNode(tr.doc.type.schema.nodes.paragraph, {
                inputMethod: inputMethod,
                isSuggested: isSuggested,
                marksToRemove: isNormalTextLabelEnabled ? [
                    'fontSize'
                ] : undefined,
                triggeredFrom: triggeredFrom,
                targetTypeName: $979a6034c9bad9b4$var$NODE_NAME
            });
            return command ? command({
                tr: tr
            }) : null;
        });
    };
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dbuPt.ToolbarDropdownItem), {
        onClick: handleClick,
        elemBefore: isNormalTextLabelEnabled ? /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eo2bn))), {
            label: "",
            size: "small"
        }) : /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($75i6e))), {
            label: "",
            size: "small"
        }),
        children: formatMessage(isNormalTextLabelEnabled ? (0, $hETL4.messages).normalText : (0, $hETL4.messages).paragraph)
    });
};
const $979a6034c9bad9b4$export$469651dcc0916a77 = ({ api: api })=>{
    return ({ isSuggested: isSuggested } = {})=>/*#__PURE__*/ (0, $dc70d.jsx)($979a6034c9bad9b4$var$ParagraphBlockMenuItem, {
            api: api,
            isSuggested: isSuggested
        });
};

});
parcelRegister("75i6e", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f1eea3b4a97fb7b1dee572382e989aa9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $52870a3b2016e23f$var$_react = $52870a3b2016e23f$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $52870a3b2016e23f$var$_iconNew = $52870a3b2016e23f$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $52870a3b2016e23f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextParagraph".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/text-paragraph
 * Usage guidance:
 * Confluence Editor AI action for reformatting paragraphs into multiple shorter paragraphs
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $52870a3b2016e23f$var$TextParagraphIcon = (props)=>/*#__PURE__*/ $52870a3b2016e23f$var$_react.default.createElement($52870a3b2016e23f$var$_iconNew.default, Object.assign({
        name: "TextParagraphIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.25 2.5a2.75 2.75 0 0 0 0 5.5H8V2.5zm3.25 0V15H8V9.5H6.25a4.25 4.25 0 0 1 0-8.5h5.5a.75.75 0 0 1 .75.75V15H11V2.5z" clip-rule="evenodd"/>`
    }, props));
$52870a3b2016e23f$var$TextParagraphIcon.displayName = 'TextParagraphIcon';
var $52870a3b2016e23f$var$_default = module.exports.default = $52870a3b2016e23f$var$TextParagraphIcon;

});


parcelRegister("6wiyg", function(module, exports) {
$parcel$export(module.exports, "createQuoteBlockMenuItem", () => $d587fa84257a3ff3$export$e07c899cb2d719c9);
/* QuoteBlockMenuItem.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $9fU1q = parcelRequire("9fU1q");
parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $g6Qq4 = parcelRequire("g6Qq4");

var $8iYGb = parcelRequire("8iYGb");

var $dbuPt = parcelRequire("dbuPt");

var $jHVBL = parcelRequire("jHVBL");
const $d587fa84257a3ff3$var$styles = {
    svgOverflow: "_1wrmewfl _172sewfl"
};
const $d587fa84257a3ff3$var$NODE_NAME = 'blockquote';
const $d587fa84257a3ff3$var$QuoteBlockMenuItem = ({ api: api, isSuggested: isSuggested })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const handleClick = (event)=>{
        const triggeredFrom = event.nativeEvent instanceof KeyboardEvent || event.nativeEvent.detail === 0 ? (0, $g6Qq4.INPUT_METHOD).KEYBOARD : (0, $g6Qq4.INPUT_METHOD).MOUSE;
        const inputMethod = (0, $g6Qq4.INPUT_METHOD).BLOCK_MENU;
        api === null || api === void 0 || api.core.actions.execute(({ tr: tr })=>{
            var _api$blockMenu;
            const command = api === null || api === void 0 || (_api$blockMenu = api.blockMenu) === null || _api$blockMenu === void 0 ? void 0 : _api$blockMenu.commands.transformNode(tr.doc.type.schema.nodes.blockquote, {
                inputMethod: inputMethod,
                isSuggested: isSuggested,
                triggeredFrom: triggeredFrom,
                targetTypeName: $d587fa84257a3ff3$var$NODE_NAME
            });
            return command ? command({
                tr: tr
            }) : null;
        });
    };
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dbuPt.ToolbarDropdownItem), {
        onClick: handleClick,
        elemBefore: /*#__PURE__*/ (0, $dc70d.jsx)("span", {
            className: (0, $9fU1q.default)([
                $d587fa84257a3ff3$var$styles.svgOverflow
            ]),
            children: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jHVBL))), {
                label: "",
                size: "small"
            })
        }),
        children: formatMessage((0, $8iYGb.messages).blockquote)
    });
};
const $d587fa84257a3ff3$export$e07c899cb2d719c9 = ({ api: api })=>{
    return ({ isSuggested: isSuggested } = {})=>/*#__PURE__*/ (0, $dc70d.jsx)($d587fa84257a3ff3$var$QuoteBlockMenuItem, {
            api: api,
            isSuggested: isSuggested
        });
};

});

parcelRegister("6xR5b", function(module, exports) {
$parcel$export(module.exports, "createSmallTextBlockMenuItem", () => $5eb00d38ac56b8de$export$b0be8c952819c98d);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $g6Qq4 = parcelRequire("g6Qq4");

var $8iYGb = parcelRequire("8iYGb");

var $1SDp1 = parcelRequire("1SDp1");

var $dbuPt = parcelRequire("dbuPt");
const $5eb00d38ac56b8de$var$NODE_NAME = 'smallText';
const $5eb00d38ac56b8de$var$SmallTextBlockMenuItem = ({ api: api, isSuggested: isSuggested })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const handleClick = (event)=>{
        const triggeredFrom = event.nativeEvent instanceof KeyboardEvent || event.nativeEvent.detail === 0 ? (0, $g6Qq4.INPUT_METHOD).KEYBOARD : (0, $g6Qq4.INPUT_METHOD).MOUSE;
        const inputMethod = (0, $g6Qq4.INPUT_METHOD).BLOCK_MENU;
        api === null || api === void 0 || api.core.actions.execute(({ tr: tr })=>{
            var _api$blockMenu;
            const command = api === null || api === void 0 || (_api$blockMenu = api.blockMenu) === null || _api$blockMenu === void 0 ? void 0 : _api$blockMenu.commands.transformNode(tr.doc.type.schema.nodes.paragraph, {
                inputMethod: inputMethod,
                isSuggested: isSuggested,
                marksToAdd: {
                    fontSize: {
                        fontSize: 'small'
                    }
                },
                triggeredFrom: triggeredFrom,
                targetTypeName: $5eb00d38ac56b8de$var$NODE_NAME
            });
            return command ? command({
                tr: tr
            }) : null;
        });
    };
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dbuPt.ToolbarDropdownItem), {
        onClick: handleClick,
        elemBefore: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1SDp1))), {
            label: "",
            size: "small"
        }),
        children: formatMessage((0, $8iYGb.messages).smallText)
    });
};
const $5eb00d38ac56b8de$export$b0be8c952819c98d = ({ api: api })=>{
    return ({ isSuggested: isSuggested } = {})=>/*#__PURE__*/ (0, $dc70d.jsx)($5eb00d38ac56b8de$var$SmallTextBlockMenuItem, {
            api: api,
            isSuggested: isSuggested
        });
};

});


parcelRegister("lQQ25", function(module, exports) {
$parcel$export(module.exports, "getBlockTypeQuickInsertComponents", () => $702b29f9ead35058$export$49ff46ca659b7c4a);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $8iYGb = parcelRequire("8iYGb");

var $b8Hvx = parcelRequire("b8Hvx");

var $9woaI = parcelRequire("9woaI");

var $am2Qg = parcelRequire("am2Qg");

var $30bjj = parcelRequire("30bjj");
const $702b29f9ead35058$var$headingItems = [
    {
        item: (0, $9woaI.HEADING_1_MENU_ITEM),
        level: 1
    },
    {
        item: (0, $9woaI.HEADING_2_MENU_ITEM),
        level: 2
    },
    {
        item: (0, $9woaI.HEADING_3_MENU_ITEM),
        level: 3
    },
    {
        item: (0, $9woaI.HEADING_4_MENU_ITEM),
        level: 4
    },
    {
        item: (0, $9woaI.HEADING_5_MENU_ITEM),
        level: 5
    },
    {
        item: (0, $9woaI.HEADING_6_MENU_ITEM),
        level: 6
    }
];
const $702b29f9ead35058$var$getParent = (key)=>[
        {
            key: (0, $9woaI.TEXT_FORMATTING_SECTION).key,
            type: (0, $9woaI.TEXT_FORMATTING_SECTION).type,
            rank: (0, $am2Qg.TEXT_FORMATTING_SECTION_RANK)[key]
        }
    ];
const $702b29f9ead35058$export$49ff46ca659b7c4a = ({ api: api, exclude: exclude })=>[
        ...$702b29f9ead35058$var$headingItems.filter(()=>!exclude.includes('heading')).map(({ item: item, level: headingLevel })=>{
            const headingMessages = (0, $30bjj.getHeadingQuickInsertMessages)(headingLevel);
            return {
                key: item.key,
                type: item.type,
                parents: $702b29f9ead35058$var$getParent(item.key),
                match: (0, $b8Hvx.createQuickInsertMatcher)(({ formatMessage: formatMessage })=>({
                        description: formatMessage(headingMessages.description),
                        keywords: [
                            `h${headingLevel}`
                        ],
                        shortcut: (0, $30bjj.getHeadingQuickInsertShortcut)(headingLevel),
                        title: formatMessage(headingMessages.title)
                    })),
                component: ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $30bjj.BlockTypeQuickInsertMenuItem), {
                        api: api,
                        item: headingLevel
                    })
            };
        }),
        ...!exclude.includes('blockquote') ? [
            {
                key: (0, $9woaI.BLOCKQUOTE_MENU_ITEM).key,
                type: (0, $9woaI.BLOCKQUOTE_MENU_ITEM).type,
                parents: $702b29f9ead35058$var$getParent((0, $9woaI.BLOCKQUOTE_MENU_ITEM).key),
                match: (0, $b8Hvx.createQuickInsertMatcher)(({ formatMessage: formatMessage })=>({
                        description: formatMessage((0, $8iYGb.messages).blockquoteDescription),
                        shortcut: '>',
                        title: formatMessage((0, $8iYGb.messages).blockquote)
                    })),
                component: ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $30bjj.BlockTypeQuickInsertMenuItem), {
                        api: api,
                        item: "blockquote"
                    })
            }
        ] : []
    ];

});
parcelRegister("30bjj", function(module, exports) {
$parcel$export(module.exports, "getHeadingQuickInsertMessages", () => $095d7674ba28b947$export$7913e5ec6aa6212c);
$parcel$export(module.exports, "getHeadingQuickInsertShortcut", () => $095d7674ba28b947$export$c99ec4513008fe69);
$parcel$export(module.exports, "BlockTypeQuickInsertMenuItem", () => $095d7674ba28b947$export$e0f203c8396bac7c);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $g6Qq4 = parcelRequire("g6Qq4");

var $cv8id = parcelRequire("cv8id");

var $8iYGb = parcelRequire("8iYGb");

var $fT9mF = parcelRequire("fT9mF");

var $64eKJ = parcelRequire("64eKJ");

var $c6mZq = parcelRequire("c6mZq");

var $hxpn3 = parcelRequire("hxpn3");

var $dhuIq = parcelRequire("dhuIq");

var $bbism = parcelRequire("bbism");

var $5RnyC = parcelRequire("5RnyC");

var $hz5BZ = parcelRequire("hz5BZ");

var $jHVBL = parcelRequire("jHVBL");
const $095d7674ba28b947$var$headingQuickInsertMessages = {
    1: {
        description: (0, $8iYGb.messages).heading1Description,
        title: (0, $8iYGb.messages).heading1
    },
    2: {
        description: (0, $8iYGb.messages).heading2Description,
        title: (0, $8iYGb.messages).heading2
    },
    3: {
        description: (0, $8iYGb.messages).heading3Description,
        title: (0, $8iYGb.messages).heading3
    },
    4: {
        description: (0, $8iYGb.messages).heading4Description,
        title: (0, $8iYGb.messages).heading4
    },
    5: {
        description: (0, $8iYGb.messages).heading5Description,
        title: (0, $8iYGb.messages).heading5
    },
    6: {
        description: (0, $8iYGb.messages).heading6Description,
        title: (0, $8iYGb.messages).heading6
    }
};
const $095d7674ba28b947$var$headingQuickInsertShortcuts = {
    1: (0, $cv8id.tooltip)((0, $cv8id.toggleHeading1)) ?? '',
    2: (0, $cv8id.tooltip)((0, $cv8id.toggleHeading2)) ?? '',
    3: (0, $cv8id.tooltip)((0, $cv8id.toggleHeading3)) ?? '',
    4: (0, $cv8id.tooltip)((0, $cv8id.toggleHeading4)) ?? '',
    5: (0, $cv8id.tooltip)((0, $cv8id.toggleHeading5)) ?? '',
    6: (0, $cv8id.tooltip)((0, $cv8id.toggleHeading6)) ?? ''
};
const $095d7674ba28b947$var$previewImageUrls = {
    blockquote: {
        dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVIC.png',
        light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVL6.png'
    },
    1: {
        dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVJH.png',
        light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVLN.png'
    },
    2: {
        dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVI2.png',
        light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVMW.png'
    },
    3: {
        dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVID.png',
        light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVLC.png'
    },
    4: {
        dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVIT.png',
        light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVM2.png'
    },
    5: {
        dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVHK.png',
        light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVLZ.png'
    },
    6: {
        dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVIB.png',
        light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVN0.png'
    }
};
const $095d7674ba28b947$export$7913e5ec6aa6212c = (level)=>$095d7674ba28b947$var$headingQuickInsertMessages[level];
const $095d7674ba28b947$export$c99ec4513008fe69 = (level)=>$095d7674ba28b947$var$headingQuickInsertShortcuts[level];
const $095d7674ba28b947$var$getBlockTypeQuickInsertIcon = (item)=>{
    switch(item){
        case 'blockquote':
            return /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jHVBL))), {
                label: ""
            });
        case 1:
            return /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dhuIq))), {
                label: ""
            });
        case 2:
            return /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hz5BZ))), {
                label: ""
            });
        case 3:
            return /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5RnyC))), {
                label: ""
            });
        case 4:
            return /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hxpn3))), {
                label: ""
            });
        case 5:
            return /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($c6mZq))), {
                label: ""
            });
        case 6:
            return /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bbism))), {
                label: ""
            });
    }
};
const $095d7674ba28b947$export$e0f203c8396bac7c = ({ api: api, item: item })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const isBlockquote = item === 'blockquote';
    const shortcut = (0, $bSJIT.useMemo)(()=>isBlockquote ? '>' : $095d7674ba28b947$export$c99ec4513008fe69(item), [
        isBlockquote,
        item
    ]);
    const title = formatMessage(item === 'blockquote' ? (0, $8iYGb.messages).blockquote : $095d7674ba28b947$export$7913e5ec6aa6212c(item).title);
    const description = formatMessage(item === 'blockquote' ? (0, $8iYGb.messages).blockquoteDescription : $095d7674ba28b947$export$7913e5ec6aa6212c(item).description);
    const preview = (0, $bSJIT.useMemo)(()=>({
            image: $095d7674ba28b947$var$previewImageUrls[item],
            attribution: {
                name: formatMessage((0, $64eKJ.messages).previewAttributionAtlassian)
            }
        }), [
        formatMessage,
        item
    ]);
    const onSelect = (0, $bSJIT.useCallback)(({ editorView: editorView, insert: insert })=>{
        const { schema: schema } = editorView.state;
        const tr = isBlockquote ? insert(schema.nodes.blockquote.createChecked({}, schema.nodes.paragraph.createChecked())) : insert(schema.nodes.heading.createChecked({
            level: item
        }));
        if (item === 'blockquote') {
            var _api$analytics;
            api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 || _api$analytics.actions.attachAnalyticsEvent({
                action: (0, $g6Qq4.ACTION).FORMATTED,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).TEXT,
                actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).FORMAT_BLOCK_QUOTE,
                attributes: {
                    inputMethod: (0, $g6Qq4.INPUT_METHOD).QUICK_INSERT
                },
                eventType: (0, $g6Qq4.EVENT_TYPE).TRACK
            })(tr);
        } else {
            var _api$analytics2;
            api === null || api === void 0 || (_api$analytics2 = api.analytics) === null || _api$analytics2 === void 0 || _api$analytics2.actions.attachAnalyticsEvent({
                action: (0, $g6Qq4.ACTION).FORMATTED,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).TEXT,
                actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).FORMAT_HEADING,
                attributes: {
                    inputMethod: (0, $g6Qq4.INPUT_METHOD).QUICK_INSERT,
                    newHeadingLevel: item
                },
                eventType: (0, $g6Qq4.EVENT_TYPE).TRACK
            })(tr);
        }
        return tr;
    }, [
        api,
        isBlockquote,
        item
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $fT9mF.QuickInsertMenuItem), {
        description: description,
        iconBefore: $095d7674ba28b947$var$getBlockTypeQuickInsertIcon(item),
        onSelect: onSelect,
        preview: preview,
        shortcut: shortcut,
        title: title
    });
};

});



parcelRegister("3dfNp", function(module, exports) {
$parcel$export(module.exports, "clearMarksOnEmptyDocPlugin", () => $aa7eca1ea37a8a25$export$30b76f1055cbb7e9);

var $f7Kk4 = parcelRequire("f7Kk4");

var $55o0j = parcelRequire("55o0j");

var $cw0wu = parcelRequire("cw0wu");
const $aa7eca1ea37a8a25$var$pluginKey = new (0, $cw0wu.PluginKey)('clearMarksOnChangeToEmptyDocumentPlugin');
function $aa7eca1ea37a8a25$var$createPlugin() {
    return new (0, $f7Kk4.SafePlugin)({
        key: $aa7eca1ea37a8a25$var$pluginKey,
        appendTransaction: (_transactions, oldState, newState)=>{
            // ED-2973: When a user clears the editor's content, remove the current active marks
            if (!(0, $55o0j.isEmptyDocument)(oldState.doc) && (0, $55o0j.isEmptyDocument)(newState.doc)) return newState.tr.setStoredMarks([]);
            return;
        }
    });
}
const $aa7eca1ea37a8a25$export$30b76f1055cbb7e9 = ()=>({
        name: 'clearMarksOnEmptyDoc',
        pmPlugins () {
            return [
                {
                    name: 'clearMarksOnChange',
                    plugin: $aa7eca1ea37a8a25$var$createPlugin
                }
            ];
        }
    });

});

parcelRegister("fRUcc", function(module, exports) {
$parcel$export(module.exports, "default", () => $924845e6791f1db3$export$2e2bcd8739ae039);

var $a5CKW = parcelRequire("a5CKW");
const $924845e6791f1db3$var$clipboard = ()=>({
        name: 'clipboard',
        pmPlugins () {
            return [
                {
                    name: 'clipboard',
                    plugin: (options)=>(0, $a5CKW.createPlugin)(options)
                }
            ];
        }
    });
var $924845e6791f1db3$export$2e2bcd8739ae039 = $924845e6791f1db3$var$clipboard;

});
parcelRegister("a5CKW", function(module, exports) {
$parcel$export(module.exports, "createPlugin", () => $50b86ff6829b1ed7$export$ae829ec7b2625219);

var $g6Qq4 = parcelRequire("g6Qq4");

var $kAhws = parcelRequire("kAhws");

var $f7Kk4 = parcelRequire("f7Kk4");

var $kW8qW = parcelRequire("kW8qW");

var $gab48 = parcelRequire("gab48");

var $gdUUy = parcelRequire("gdUUy");

var $inOgW = parcelRequire("inOgW");
var $50b86ff6829b1ed7$export$304e24f67740de29 = /*#__PURE__*/ function(ClipboardEventType) {
    ClipboardEventType["CUT"] = "CUT";
    ClipboardEventType["COPY"] = "COPY";
    return ClipboardEventType;
}({});
let $50b86ff6829b1ed7$var$lastEventType = null;
const $50b86ff6829b1ed7$export$ae829ec7b2625219 = ({ dispatchAnalyticsEvent: dispatchAnalyticsEvent, schema: schema })=>{
    let editorView;
    const getEditorView = ()=>editorView;
    return new (0, $f7Kk4.SafePlugin)({
        key: (0, $inOgW.clipboardPluginKey),
        view: (view)=>{
            editorView = view;
            return {
                update: (view)=>{
                    editorView = view;
                }
            };
        },
        props: {
            handleDOMEvents: {
                cut: (view)=>{
                    $50b86ff6829b1ed7$export$47cf4f31f028e0c9("CUT");
                    return $50b86ff6829b1ed7$export$e8eabed2709e2a33(view, dispatchAnalyticsEvent, (0, $g6Qq4.ACTION).CUT);
                },
                copy: (view)=>{
                    $50b86ff6829b1ed7$export$47cf4f31f028e0c9("COPY");
                    return $50b86ff6829b1ed7$export$e8eabed2709e2a33(view, dispatchAnalyticsEvent, (0, $g6Qq4.ACTION).COPIED);
                }
            },
            clipboardSerializer: $50b86ff6829b1ed7$export$33f65796de3575a9(schema, getEditorView)
        }
    });
};
const $50b86ff6829b1ed7$export$33f65796de3575a9 = (schema, getEditorView)=>{
    const oldSerializer = (0, $kW8qW.DOMSerializer).fromSchema(schema);
    const newSerializer = new (0, $kW8qW.DOMSerializer)(oldSerializer.nodes, oldSerializer.marks);
    const originalSerializeFragment = newSerializer.serializeFragment.bind(newSerializer);
    newSerializer.serializeFragment = (content, // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    options = {}, target)=>{
        var _content$firstChild, _content$firstChild2;
        const editorView = getEditorView();
        const selection = editorView.state.selection;
        // We do not need to handle when a user copies a tableRow + other content.
        // In that scenario it already wraps the Row with correct Table and attributes.
        if (!options.tableWrapperExists) {
            let i = 0;
            while(i < content.childCount){
                var _content$maybeChild;
                if (((_content$maybeChild = content.maybeChild(i)) === null || _content$maybeChild === void 0 ? void 0 : _content$maybeChild.type.name) === 'table') {
                    options.tableWrapperExists = true;
                    break;
                }
                i++;
            }
        }
        // When the content being copied includes a tableRow that is not already wrapped with a table,
        // We will wrap it with one ourselves, while preserving the parent table's attributes.
        if (((_content$firstChild = content.firstChild) === null || _content$firstChild === void 0 ? void 0 : _content$firstChild.type.name) === 'tableRow' && !options.tableWrapperExists) {
            // We only want 1 table wrapping the rows.
            // tableWrapperExist is a custom prop added solely for the purposes of this recursive algorithm.
            // The function is recursively called for each node in the tree captured in the fragment.
            // For recursive logic see the bind call above and the prosemirror-model (https://github.com/ProseMirror/prosemirror-model/blob/master/src/to_dom.js#L44
            // and https://github.com/ProseMirror/prosemirror-model/blob/master/src/to_dom.js#L87)
            options.tableWrapperExists = true;
            const parentTable = (0, $gab48.findParentNodeOfType)(schema.nodes.table)(selection);
            const attributes = parentTable === null || parentTable === void 0 ? void 0 : parentTable.node.attrs;
            const newTable = schema.nodes.table;
            // Explicitly remove local id since we are creating a new table and it should have a unique local id which will be generated.
            const newTableNode = newTable.createChecked({
                ...attributes,
                localId: undefined
            }, content);
            const newContent = (0, $kW8qW.Fragment).from(newTableNode);
            // Pass updated content into original ProseMirror serializeFragment function.
            // Currently incorrectly typed in @Types. See this GitHub thread: https://github.com/DefinitelyTyped/DefinitelyTyped/pull/57668
            //@ts-ignore
            return originalSerializeFragment(newContent, options, target);
        }
        // Remove annotations from extension nodes (e.g. MAUI charts) when copying to clipboard, matching media below.
        // The annotation mark lives on the extension node itself, so strip it from the fragment's children.
        if ($50b86ff6829b1ed7$var$lastEventType === "COPY" && (0, $gdUUy.fg)('cc_maui_annotations_on_extensions') && $50b86ff6829b1ed7$var$hasAnnotatedExtension(content)) {
            const contentArray = [];
            content.forEach((node)=>{
                contentArray.push(node.type.name === 'extension' ? node.mark(node.marks.filter((mark)=>mark.type.name !== 'annotation')) : node);
            });
            const newContent = (0, $kW8qW.Fragment).fromArray(contentArray);
            // Currently incorrectly typed, see comment above
            // @ts-ignore
            return originalSerializeFragment(newContent, options, target);
        }
        // Remove annotations from media nodes when copying to clipboard, only do this for copy operations
        // and keep existing content nodes from the parent.
        if ($50b86ff6829b1ed7$var$lastEventType === "COPY" && ((_content$firstChild2 = content.firstChild) === null || _content$firstChild2 === void 0 ? void 0 : _content$firstChild2.type.name) === 'media') {
            var _mediaNode$marks;
            const mediaNode = content.firstChild;
            const strippedMediaNode = schema.nodes.media.createChecked(mediaNode.attrs, mediaNode.content, (_mediaNode$marks = mediaNode.marks) === null || _mediaNode$marks === void 0 ? void 0 : _mediaNode$marks.filter((mark)=>mark.type.name !== 'annotation'));
            // Content for media parents can include multiple content nodes (media and captions). We now take that
            // into consideration when we are stripping annotations.
            let contentArray = [
                strippedMediaNode
            ];
            content.forEach((node)=>{
                if (node.type.name !== 'media') contentArray = [
                    ...contentArray,
                    node
                ];
            });
            const newContent = (0, $kW8qW.Fragment).fromArray(contentArray);
            // Currently incorrectly typed, see comment above
            // @ts-ignore
            return originalSerializeFragment(newContent, options, target);
        }
        // If we're not copying any rows or media nodes, just run default serializeFragment function.
        // Currently incorrectly typed in @Types. See this GitHub thread: https://github.com/DefinitelyTyped/DefinitelyTyped/pull/57668
        //@ts-ignore
        return originalSerializeFragment(content, options, target);
    };
    return newSerializer;
};
const $50b86ff6829b1ed7$var$hasAnnotatedExtension = (content)=>{
    let found = false;
    content.forEach((node)=>{
        if (node.type.name === 'extension' && node.marks.some((mark)=>mark.type.name === 'annotation')) found = true;
    });
    return found;
};
const $50b86ff6829b1ed7$export$e8eabed2709e2a33 = (view, dispatchAnalyticsEvent, action)=>{
    const clipboardAnalyticsPayload = (0, $kAhws.getAnalyticsPayload)(view.state, action);
    if (clipboardAnalyticsPayload) dispatchAnalyticsEvent(clipboardAnalyticsPayload);
    // return false so we don't block any other plugins' cut or copy handlers
    // from running just because we are sending an analytics event
    return false;
};
const $50b86ff6829b1ed7$export$47cf4f31f028e0c9 = (eventType)=>$50b86ff6829b1ed7$var$lastEventType = eventType;

});
parcelRegister("inOgW", function(module, exports) {
$parcel$export(module.exports, "clipboardPluginKey", () => $f6dd885fb4933613$export$7ff3d0e65871bad3);

var $cw0wu = parcelRequire("cw0wu");
const $f6dd885fb4933613$export$7ff3d0e65871bad3 = new (0, $cw0wu.PluginKey)('clipboardPlugin');

});



parcelRegister("kliKN", function(module, exports) {
$parcel$export(module.exports, "default", () => $ed1474753efc3285$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9nikD = parcelRequire("9nikD");

var $g6Qq4 = parcelRequire("g6Qq4");

var $5BUNL = parcelRequire("5BUNL");

var $30Yan = parcelRequire("30Yan");

var $fY4jW = parcelRequire("fY4jW");

var $8iYGb = parcelRequire("8iYGb");

var $3y2s4 = parcelRequire("3y2s4");

var $gdUUy = parcelRequire("gdUUy");

var $4zjoa = parcelRequire("4zjoa");

var $kdxmD = parcelRequire("kdxmD");

var $aERFo = parcelRequire("aERFo");

var $5vOos = parcelRequire("5vOos");

var $9csIT = parcelRequire("9csIT");

var $2SVXT = parcelRequire("2SVXT");

var $hCeAe = parcelRequire("hCeAe");

var $kZXn7 = parcelRequire("kZXn7");

var $jtzZt = parcelRequire("jtzZt");

var $1LuwP = parcelRequire("1LuwP");

var $kjP5G = parcelRequire("kjP5G");

var $cABjx = parcelRequire("cABjx");

var $1FrRP = parcelRequire("1FrRP");

var $4LYH1 = parcelRequire("4LYH1");

var $71NmD = parcelRequire("71NmD");
const $ed1474753efc3285$var$CODE_BLOCK_NODE_NAME = 'codeBlock';
const $ed1474753efc3285$var$codeBlockPlugin = ({ config: options, api: api })=>{
    var _api$blockMenu;
    const isRegisteredSlashCommandEnabled = (0, $3y2s4.isExperimentEnabled)('platform_editor_slash_command');
    api === null || api === void 0 || (_api$blockMenu = api.blockMenu) === null || _api$blockMenu === void 0 || _api$blockMenu.actions.registerBlockMenuComponents([
        {
            type: 'block-menu-item',
            key: (0, $30Yan.TRANSFORM_STRUCTURE_CODE_BLOCK_MENU_ITEM).key,
            parent: {
                type: 'block-menu-section',
                key: (0, $30Yan.TRANSFORM_STRUCTURE_MENU_SECTION).key,
                rank: (0, $fY4jW.TRANSFORM_STRUCTURE_MENU_SECTION_RANK)[(0, $30Yan.TRANSFORM_STRUCTURE_CODE_BLOCK_MENU_ITEM).key]
            },
            component: (0, $1FrRP.createCodeBlockMenuItem)(api),
            isHidden: ()=>{
                var _api$blockMenu2;
                return Boolean(api === null || api === void 0 || (_api$blockMenu2 = api.blockMenu) === null || _api$blockMenu2 === void 0 ? void 0 : _api$blockMenu2.actions.isTransformOptionDisabled($ed1474753efc3285$var$CODE_BLOCK_NODE_NAME));
            }
        }
    ]);
    if (isRegisteredSlashCommandEnabled) {
        var _api$uiControlRegistr;
        api === null || api === void 0 || (_api$uiControlRegistr = api.uiControlRegistry) === null || _api$uiControlRegistr === void 0 || _api$uiControlRegistr.actions.register((0, $71NmD.getCodeBlockQuickInsertComponents)({
            api: api
        }));
    }
    const plugin = {
        name: 'codeBlock',
        nodes () {
            return [
                {
                    name: 'codeBlock',
                    node: (0, $4zjoa.expValEqualsNoExposure)('platform_editor_code_block_q4_lovability', 'isEnabled', true) ? (0, $9nikD.codeBlock) : (0, $gdUUy.fg)('platform_editor_adf_with_localid') ? (0, $9nikD.codeBlockWithLocalId) : (0, $9nikD.codeBlock)
                }
            ];
        },
        getSharedState (state) {
            if (!state) return undefined;
            const codeBlockState = (0, $1LuwP.pluginKey).getState(state);
            return {
                copyButtonHoverNode: (0, $9csIT.copySelectionPluginKey).getState(state).codeBlockNode,
                formatCodeErrors: (codeBlockState === null || codeBlockState === void 0 ? void 0 : codeBlockState.formatCodeErrors) ?? {},
                pendingFormats: (codeBlockState === null || codeBlockState === void 0 ? void 0 : codeBlockState.pendingFormats) ?? {}
            };
        },
        pmPlugins () {
            return [
                {
                    name: 'codeBlock',
                    plugin: ({ getIntl: getIntl })=>(0, $jtzZt.createPlugin)({
                            ...options,
                            getIntl: getIntl,
                            api: api
                        })
                },
                {
                    name: 'codeBlockInputRule',
                    plugin: ({ schema: schema })=>{
                        var _api$analytics;
                        return (0, $hCeAe.createCodeBlockInputRule)(schema, api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions);
                    }
                },
                ...(0, $4zjoa.expValEqualsNoExposure)('platform_editor_code_block_q4_lovability', 'isEnabled', true) ? [
                    {
                        name: 'codeBlockAutoDetect',
                        plugin: ()=>(0, $aERFo.createAutoDetectPlugin)(api)
                    }
                ] : [],
                {
                    name: 'codeBlockIDEKeyBindings',
                    plugin: ()=>(0, $2SVXT.default)(api)
                },
                {
                    name: 'codeBlockKeyMap',
                    plugin: ({ schema: schema })=>(0, $kZXn7.default)(schema)
                },
                {
                    name: 'codeBlockCopySelection',
                    plugin: ()=>(0, $9csIT.codeBlockCopySelectionPlugin)()
                },
                {
                    name: 'codeBlockAutoFullStopTransform',
                    plugin: ()=>(0, $5vOos.codeBlockAutoFullStopTransformPlugin)()
                }
            ];
        },
        // Workaround for a firefox issue where dom selection is off sync
        // https://product-fabric.atlassian.net/browse/ED-12442
        onEditorViewStateUpdated (props) {
            (0, $kjP5G.default)(props.originalTransaction, props.newEditorState);
        },
        actions: {
            /*
       * Function will insert code block at current selection if block is empty or below current selection and set focus on it.
       */ insertCodeBlock: (inputMethod)=>{
                var _api$analytics2;
                return (0, $kdxmD.insertCodeBlockWithAnalytics)(inputMethod, api === null || api === void 0 || (_api$analytics2 = api.analytics) === null || _api$analytics2 === void 0 ? void 0 : _api$analytics2.actions);
            }
        },
        pluginsOptions: {
            ...!isRegisteredSlashCommandEnabled && {
                quickInsert: ({ formatMessage: formatMessage })=>[
                        {
                            id: 'codeblock',
                            title: formatMessage((0, $8iYGb.messages).codeblock),
                            description: formatMessage((0, $8iYGb.messages).codeblockDescription),
                            keywords: [
                                'code block'
                            ],
                            priority: 700,
                            keyshortcut: '```',
                            icon: ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $5BUNL.IconCode), {}),
                            action (_insert, state, source) {
                                var _api$analytics3;
                                const tr = (0, $kdxmD.createInsertCodeBlockTransaction)({
                                    state: state
                                });
                                api === null || api === void 0 || (_api$analytics3 = api.analytics) === null || _api$analytics3 === void 0 || _api$analytics3.actions.attachAnalyticsEvent({
                                    action: (0, $g6Qq4.ACTION).INSERTED,
                                    actionSubject: (0, $g6Qq4.ACTION_SUBJECT).DOCUMENT,
                                    actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).CODE_BLOCK,
                                    attributes: {
                                        inputMethod: source || (0, $g6Qq4.INPUT_METHOD).QUICK_INSERT
                                    },
                                    eventType: (0, $g6Qq4.EVENT_TYPE).TRACK
                                })(tr);
                                return tr;
                            }
                        }
                    ]
            },
            floatingToolbar: (0, $cABjx.getToolbarConfig)(options === null || options === void 0 ? void 0 : options.allowCopyToClipboard, api, options === null || options === void 0 ? void 0 : options.overrideLanguageName, options === null || options === void 0 ? void 0 : options.formatCodeProvider)
        },
        contentComponent: ()=>(0, $4zjoa.expValEqualsNoExposure)('platform_editor_code_block_q4_lovability', 'isEnabled', true) ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $4LYH1.FormatCodeErrorFlag), {
                api: api
            }) : null
    };
    return plugin;
};
var $ed1474753efc3285$export$2e2bcd8739ae039 = $ed1474753efc3285$var$codeBlockPlugin;

});
parcelRegister("kdxmD", function(module, exports) {
$parcel$export(module.exports, "removeCodeBlockWithAnalytics", () => $8d6d7b96a4e3e064$export$44b4779780b25933);
$parcel$export(module.exports, "changeLanguage", () => $8d6d7b96a4e3e064$export$61465194746e7fd2);
$parcel$export(module.exports, "detectLanguage", () => $8d6d7b96a4e3e064$export$ae9ea24a1b29b07c);
$parcel$export(module.exports, "createFormatCodeOnClick", () => $8d6d7b96a4e3e064$export$7f5d8563b7e51b88);
$parcel$export(module.exports, "copyContentToClipboardWithAnalytics", () => $8d6d7b96a4e3e064$export$50ffc017f5e54c0);
$parcel$export(module.exports, "resetCopiedState", () => $8d6d7b96a4e3e064$export$3e0b07341e7576a);
$parcel$export(module.exports, "ignoreFollowingMutations", () => $8d6d7b96a4e3e064$export$e6e93d61d1873d0c);
$parcel$export(module.exports, "resetShouldIgnoreFollowingMutations", () => $8d6d7b96a4e3e064$export$60364cd5f5fed191);
$parcel$export(module.exports, "createInsertCodeBlockTransaction", () => $8d6d7b96a4e3e064$export$c875ffe428b4a5f);
$parcel$export(module.exports, "createInsertCodeBlockTransactionWithAnalytics", () => $8d6d7b96a4e3e064$export$c0fb2037bfcf75f4);
$parcel$export(module.exports, "insertCodeBlockWithAnalytics", () => $8d6d7b96a4e3e064$export$a8d9c0f039b6fb43);
$parcel$export(module.exports, "toggleWordWrapStateForCodeBlockNode", () => $8d6d7b96a4e3e064$export$160d674382436f98);
$parcel$export(module.exports, "toggleLineNumbersForCodeBlockNode", () => $8d6d7b96a4e3e064$export$5d4256781e1f4071);

var $g6Qq4 = parcelRequire("g6Qq4");

var $4S8NW = parcelRequire("4S8NW");

var $kAhws = parcelRequire("kAhws");

var $3J3tU = parcelRequire("3J3tU");

var $dw0oh = parcelRequire("dw0oh");

var $iPR6g = parcelRequire("iPR6g");

var $e1fCY = parcelRequire("e1fCY");

var $5NaaJ = parcelRequire("5NaaJ");

var $cw0wu = parcelRequire("cw0wu");

var $gab48 = parcelRequire("gab48");

var $5N1Y4 = parcelRequire("5N1Y4");

var $cbzce = parcelRequire("cbzce");

var $552Jd = parcelRequire("552Jd");

var $9csIT = parcelRequire("9csIT");

var $1LuwP = parcelRequire("1LuwP");

var $b94mh = parcelRequire("b94mh");

var $b0rAs = parcelRequire("b0rAs");
const $8d6d7b96a4e3e064$export$44b4779780b25933 = (editorAnalyticsAPI)=>{
    return (0, $5NaaJ.withAnalytics)(editorAnalyticsAPI, {
        action: (0, $g6Qq4.ACTION).DELETED,
        actionSubject: (0, $g6Qq4.ACTION_SUBJECT).CODE_BLOCK,
        attributes: {
            inputMethod: (0, $g6Qq4.INPUT_METHOD).FLOATING_TB
        },
        eventType: (0, $g6Qq4.EVENT_TYPE).TRACK
    })($8d6d7b96a4e3e064$export$e635d7f974817375);
};
const $8d6d7b96a4e3e064$export$e635d7f974817375 = (state, dispatch)=>{
    const { schema: { nodes: nodes }, tr: tr } = state;
    if (dispatch) {
        let removeTr = tr;
        if ((0, $gab48.findSelectedNodeOfType)(nodes.codeBlock)(tr.selection)) removeTr = (0, $gab48.removeSelectedNode)(tr);
        else removeTr = (0, $gab48.removeParentNodeOfType)(nodes.codeBlock)(tr);
        dispatch(removeTr);
    }
    return true;
};
const $8d6d7b96a4e3e064$export$61465194746e7fd2 = (editorAnalyticsAPI)=>(language, selectionSource)=>(state, dispatch)=>{
            var _pluginKey$getState, _autoDetectPluginKey$;
            const { codeBlock: codeBlock } = state.schema.nodes;
            const pos = (_pluginKey$getState = (0, $1LuwP.pluginKey).getState(state)) === null || _pluginKey$getState === void 0 ? void 0 : _pluginKey$getState.pos;
            if (typeof pos !== 'number') return false;
            const node = state.doc.nodeAt(pos);
            const localId = node === null || node === void 0 ? void 0 : node.attrs.localId;
            const shouldIncludeAutoDetectionContext = (0, $5N1Y4.expValEquals)('platform_editor_code_block_q4_lovability', 'isEnabled', true);
            const previousAutoDetectEntry = shouldIncludeAutoDetectionContext ? (_autoDetectPluginKey$ = (0, $552Jd.autoDetectPluginKey).getState(state)) === null || _autoDetectPluginKey$ === void 0 ? void 0 : _autoDetectPluginKey$.languageDetectionMap[localId] : undefined;
            const tr = state.tr.setNodeMarkup(pos, codeBlock, {
                ...node === null || node === void 0 ? void 0 : node.attrs,
                language: language
            }).setMeta('scrollIntoView', false);
            if (shouldIncludeAutoDetectionContext) tr.setMeta((0, $552Jd.autoDetectPluginKey), {
                type: (0, $cbzce.ACTIONS).REMOVE_AUTO_DETECT_ENTRY,
                data: {
                    localId: localId
                }
            });
            const selection = (0, $gab48.isNodeSelection)(state.selection) ? (0, $cw0wu.NodeSelection).create(tr.doc, pos) : tr.selection;
            const result = tr.setSelection(selection);
            if (dispatch) {
                editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent({
                    action: (0, $g6Qq4.ACTION).LANGUAGE_SELECTED,
                    actionSubject: (0, $g6Qq4.ACTION_SUBJECT).CODE_BLOCK,
                    attributes: {
                        language: language ?? 'none',
                        ...selectionSource ? {
                            selectionSource: selectionSource
                        } : {},
                        ...shouldIncludeAutoDetectionContext ? {
                            autoDetectionResult: previousAutoDetectEntry === null || previousAutoDetectEntry === void 0 ? void 0 : previousAutoDetectEntry.detectionResult,
                            autoDetectedLanguage: previousAutoDetectEntry === null || previousAutoDetectEntry === void 0 ? void 0 : previousAutoDetectEntry.autoDetectedLanguage
                        } : {}
                    },
                    eventType: (0, $g6Qq4.EVENT_TYPE).TRACK
                })(result);
                dispatch(result);
            }
            return true;
        };
const $8d6d7b96a4e3e064$export$ae9ea24a1b29b07c = ()=>(state, dispatch)=>{
        var _pluginKey$getState2;
        const pos = (_pluginKey$getState2 = (0, $1LuwP.pluginKey).getState(state)) === null || _pluginKey$getState2 === void 0 ? void 0 : _pluginKey$getState2.pos;
        if (typeof pos !== 'number') return false;
        const node = state.doc.nodeAt(pos);
        if (!node) return false;
        const localId = (0, $b0rAs.getLocalId)(node);
        if (!localId) return false;
        const autoDetectState = (0, $552Jd.autoDetectPluginKey).getState(state);
        const previousEntry = autoDetectState === null || autoDetectState === void 0 ? void 0 : autoDetectState.languageDetectionMap[localId];
        const entry = (0, $b0rAs.createAutoDetectEntry)(node, pos, (0, $b0rAs.hasEnoughTextForAutoDetection)(node.textContent), previousEntry, {
            preserveDetectionResult: false
        });
        const tr = state.tr.setNodeMarkup(pos, state.schema.nodes.codeBlock, {
            ...node.attrs,
            language: null
        }).setMeta((0, $552Jd.autoDetectPluginKey), {
            type: (0, $cbzce.ACTIONS).SET_AUTO_DETECT_ENTRY,
            data: {
                localId: localId,
                entry: entry
            }
        }).setMeta('scrollIntoView', false);
        const selection = (0, $gab48.isNodeSelection)(state.selection) ? (0, $cw0wu.NodeSelection).create(tr.doc, pos) : tr.selection;
        const result = tr.setSelection(selection);
        if (dispatch) dispatch(result);
        return true;
    };
const $8d6d7b96a4e3e064$var$setResolveFormatCodeMeta = (tr, { languageSource: languageSource, localId: localId, outcome: outcome, requestId: requestId, errorType: errorType })=>tr.setMeta((0, $1LuwP.pluginKey), {
        type: (0, $cbzce.ACTIONS).RESOLVE_FORMAT_CODE,
        data: {
            languageSource: languageSource,
            localId: localId,
            outcome: outcome,
            requestId: requestId,
            ...errorType ? {
                errorType: errorType
            } : {}
        }
    });
const $8d6d7b96a4e3e064$var$replaceCodeBlockText = ({ codeBlockNode: codeBlockNode, content: content, pos: pos, tr: tr })=>{
    const from = pos + 1;
    const to = pos + codeBlockNode.nodeSize - 1;
    tr.delete(from, to);
    if (content) tr.insertText(content, from);
    // The editor scroll plugin scrolls doc-changing transactions by default.
    return tr.setMeta('scrollIntoView', false);
};
const $8d6d7b96a4e3e064$var$attachFormatCodeAnalytics = ({ editorAnalyticsAPI: editorAnalyticsAPI, languageSource: languageSource, result: result, tr: tr })=>{
    if (result.status === 'failed') {
        editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent({
            action: (0, $g6Qq4.ACTION).ERRORED,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).CODE_BLOCK,
            attributes: {
                errorType: result.errorType,
                language: result.language,
                languageSource: languageSource
            },
            eventType: (0, $g6Qq4.EVENT_TYPE).TRACK
        })(tr);
        return;
    }
    editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent({
        action: (0, $g6Qq4.ACTION).FORMATTED,
        actionSubject: (0, $g6Qq4.ACTION_SUBJECT).CODE_BLOCK,
        attributes: {
            language: result.language,
            languageSource: languageSource,
            outcome: result.status
        },
        eventType: (0, $g6Qq4.EVENT_TYPE).TRACK
    })(tr);
};
const $8d6d7b96a4e3e064$var$createResolveFormatCodeTransaction = ({ editorAnalyticsAPI: editorAnalyticsAPI, localId: localId, pendingFormat: pendingFormat, result: result, tr: tr })=>{
    const { languageSource: languageSource, requestId: requestId } = pendingFormat;
    const codeBlockNode = tr.doc.nodeAt(pendingFormat.pos);
    const hasMatchingCodeBlock = (codeBlockNode === null || codeBlockNode === void 0 ? void 0 : codeBlockNode.type) === tr.doc.type.schema.nodes.codeBlock && (codeBlockNode === null || codeBlockNode === void 0 ? void 0 : codeBlockNode.attrs.localId) === localId;
    if (!hasMatchingCodeBlock) {
        // Keep failure telemetry even when the target block is no longer available.
        if (result.status === 'failed') $8d6d7b96a4e3e064$var$attachFormatCodeAnalytics({
            editorAnalyticsAPI: editorAnalyticsAPI,
            languageSource: languageSource,
            result: result,
            tr: tr
        });
        return $8d6d7b96a4e3e064$var$setResolveFormatCodeMeta(tr, {
            languageSource: languageSource,
            localId: localId,
            outcome: 'unchanged',
            requestId: requestId
        });
    }
    let resultTransaction = tr;
    if (result.status === 'formatted') resultTransaction = $8d6d7b96a4e3e064$var$replaceCodeBlockText({
        codeBlockNode: codeBlockNode,
        content: result.content,
        pos: pendingFormat.pos,
        tr: tr
    });
    $8d6d7b96a4e3e064$var$attachFormatCodeAnalytics({
        editorAnalyticsAPI: editorAnalyticsAPI,
        languageSource: languageSource,
        result: result,
        tr: resultTransaction
    });
    return $8d6d7b96a4e3e064$var$setResolveFormatCodeMeta(resultTransaction, {
        errorType: result.status === 'failed' ? result.errorType : undefined,
        languageSource: languageSource,
        localId: localId,
        outcome: result.status,
        requestId: requestId
    });
};
const $8d6d7b96a4e3e064$export$7f5d8563b7e51b88 = ({ api: api, editorAnalyticsAPI: editorAnalyticsAPI, formatCodeProvider: formatCodeProvider })=>(state, dispatch)=>{
        var _autoDetectPluginKey$2, _api$core;
        if (!formatCodeProvider) return false;
        const currentCodeBlockState = (0, $1LuwP.pluginKey).getState(state);
        const currentPos = currentCodeBlockState === null || currentCodeBlockState === void 0 ? void 0 : currentCodeBlockState.pos;
        if (!currentCodeBlockState || typeof currentPos !== 'number') return false;
        const currentNode = state.doc.nodeAt(currentPos);
        if (!currentNode || currentNode.type !== state.schema.nodes.codeBlock) return false;
        const currentLanguage = currentNode.attrs.language ?? '';
        const currentLocalId = currentNode.attrs.localId;
        if (currentCodeBlockState.pendingFormats[currentLocalId]) return true;
        const autoDetectEntry = (_autoDetectPluginKey$2 = (0, $552Jd.autoDetectPluginKey).getState(state)) === null || _autoDetectPluginKey$2 === void 0 ? void 0 : _autoDetectPluginKey$2.languageDetectionMap[currentLocalId];
        const languageSource = (autoDetectEntry === null || autoDetectEntry === void 0 ? void 0 : autoDetectEntry.autoDetectedLanguage) === currentLanguage ? 'auto-detected' : 'selected';
        const content = currentNode.textContent;
        const requestId = crypto.randomUUID();
        api === null || api === void 0 || (_api$core = api.core) === null || _api$core === void 0 || _api$core.actions.execute(({ tr: tr })=>tr.setMeta((0, $1LuwP.pluginKey), {
                type: (0, $cbzce.ACTIONS).START_FORMAT_CODE,
                data: {
                    languageSource: languageSource,
                    localId: currentLocalId,
                    pos: currentPos,
                    requestId: requestId
                }
            }));
        formatCodeProvider.formatCode({
            content: content,
            language: currentLanguage
        }).catch(()=>({
                errorType: 'formatter-execution-failed',
                language: currentLanguage,
                status: 'failed'
            })).then((result)=>{
            var _api$codeBlock, _api$core2;
            const pendingFormat = api === null || api === void 0 || (_api$codeBlock = api.codeBlock) === null || _api$codeBlock === void 0 || (_api$codeBlock = _api$codeBlock.sharedState.currentState()) === null || _api$codeBlock === void 0 ? void 0 : _api$codeBlock.pendingFormats[currentLocalId];
            if (!pendingFormat || pendingFormat.requestId !== requestId) return;
            api === null || api === void 0 || (_api$core2 = api.core) === null || _api$core2 === void 0 || _api$core2.actions.execute(({ tr: tr })=>$8d6d7b96a4e3e064$var$createResolveFormatCodeTransaction({
                    editorAnalyticsAPI: editorAnalyticsAPI,
                    localId: currentLocalId,
                    pendingFormat: pendingFormat,
                    result: result,
                    tr: tr
                }));
        });
        return true;
    };
const $8d6d7b96a4e3e064$export$50ffc017f5e54c0 = (editorAnalyticsAPI)=>(state, dispatch)=>{
        const { schema: { nodes: nodes }, tr: tr } = state;
        const codeBlock = (0, $gab48.findParentNodeOfType)(nodes.codeBlock)(tr.selection);
        const textContent = codeBlock && codeBlock.node.textContent;
        if (textContent) {
            (0, $kAhws.copyToClipboard)(textContent);
            const copyToClipboardTr = tr;
            copyToClipboardTr.setMeta((0, $1LuwP.pluginKey), {
                type: (0, $cbzce.ACTIONS).SET_COPIED_TO_CLIPBOARD,
                data: true
            });
            copyToClipboardTr.setMeta((0, $9csIT.copySelectionPluginKey), 'remove-selection');
            if (editorAnalyticsAPI) {
                const analyticsPayload = (0, $kAhws.getAnalyticsPayload)(state, (0, $g6Qq4.ACTION).COPIED);
                if (analyticsPayload) {
                    analyticsPayload.attributes.inputMethod = (0, $g6Qq4.INPUT_METHOD).FLOATING_TB;
                    analyticsPayload.attributes.nodeType = codeBlock === null || codeBlock === void 0 ? void 0 : codeBlock.node.type.name;
                    editorAnalyticsAPI.attachAnalyticsEvent(analyticsPayload)(copyToClipboardTr);
                }
            }
            if (dispatch) dispatch(copyToClipboardTr);
        }
        return true;
    };
const $8d6d7b96a4e3e064$export$859674cc23da4522 = (state, dispatch)=>{
    const { schema: { nodes: nodes }, tr: tr } = state;
    const codeBlock = (0, $gab48.findParentNodeOfType)(nodes.codeBlock)(tr.selection);
    const textContent = codeBlock && codeBlock.node.textContent;
    if (textContent) {
        (0, $kAhws.copyToClipboard)(textContent);
        const copyToClipboardTr = tr;
        copyToClipboardTr.setMeta((0, $1LuwP.pluginKey), {
            type: (0, $cbzce.ACTIONS).SET_COPIED_TO_CLIPBOARD,
            data: true
        });
        copyToClipboardTr.setMeta((0, $9csIT.copySelectionPluginKey), 'remove-selection');
        if (dispatch) dispatch(copyToClipboardTr);
    }
    return true;
};
const $8d6d7b96a4e3e064$export$3e0b07341e7576a = (state, dispatch)=>{
    const { tr: tr } = state;
    const codeBlockState = (0, $1LuwP.pluginKey).getState(state);
    const resetCopiedStateTr = tr;
    if (codeBlockState && codeBlockState.contentCopied) {
        resetCopiedStateTr.setMeta((0, $1LuwP.pluginKey), {
            type: (0, $cbzce.ACTIONS).SET_COPIED_TO_CLIPBOARD,
            data: false
        });
        resetCopiedStateTr.setMeta((0, $9csIT.copySelectionPluginKey), 'remove-selection');
        if (dispatch) dispatch(resetCopiedStateTr);
    } else {
        const clearSelectionStateTransaction = state.tr;
        clearSelectionStateTransaction.setMeta((0, $9csIT.copySelectionPluginKey), 'remove-selection');
        // note: dispatch should always be defined when called from the
        // floating toolbar. Howver the Command type which floating toolbar uses
        // (and resetCopiedState) uses suggests it's optional.
        if (dispatch) dispatch(clearSelectionStateTransaction);
    }
    return true;
};
const $8d6d7b96a4e3e064$export$e6e93d61d1873d0c = (state, dispatch)=>{
    const { tr: tr } = state;
    const ignoreFollowingMutationsTr = tr;
    ignoreFollowingMutationsTr.setMeta((0, $1LuwP.pluginKey), {
        type: (0, $cbzce.ACTIONS).SET_SHOULD_IGNORE_FOLLOWING_MUTATIONS,
        data: true
    });
    if (dispatch) dispatch(ignoreFollowingMutationsTr);
    return true;
};
const $8d6d7b96a4e3e064$export$60364cd5f5fed191 = (state, dispatch)=>{
    const { tr: tr } = state;
    const ignoreFollowingMutationsTr = tr;
    ignoreFollowingMutationsTr.setMeta((0, $1LuwP.pluginKey), {
        type: (0, $cbzce.ACTIONS).SET_SHOULD_IGNORE_FOLLOWING_MUTATIONS,
        data: false
    });
    if (dispatch) dispatch(ignoreFollowingMutationsTr);
    return true;
};
function $8d6d7b96a4e3e064$export$c875ffe428b4a5f({ state: state }) {
    let { tr: tr } = state;
    const { from: from } = state.selection;
    const { codeBlock: codeBlock } = state.schema.nodes;
    const codeBlockAttrs = (0, $3J3tU.getDefaultCodeBlockAttrs)();
    const grandParentNode = state.selection.$from.node(-1);
    const grandParentNodeType = grandParentNode === null || grandParentNode === void 0 ? void 0 : grandParentNode.type;
    const parentNodeType = state.selection.$from.parent.type;
    /** We always want to append a codeBlock unless we're inserting into a paragraph
   * AND it's a valid child of the grandparent node.
   * Insert the current selection as codeBlock content unless it contains nodes other
   * than paragraphs and inline.
   */ const canInsertCodeBlock = (0, $dw0oh.shouldSplitSelectedNodeOnNodeInsertion)({
        parentNodeType: parentNodeType,
        grandParentNodeType: grandParentNodeType,
        content: codeBlock.createAndFill()
    }) && (0, $dw0oh.contentAllowedInCodeBlock)(state);
    if (canInsertCodeBlock) tr = (0, $b94mh.transformToCodeBlockAction)(state, from, codeBlockAttrs);
    else (0, $gab48.safeInsert)(codeBlock.createAndFill(codeBlockAttrs))(tr).scrollIntoView();
    return tr;
}
function $8d6d7b96a4e3e064$export$c0fb2037bfcf75f4({ analyticsAPI: analyticsAPI, inputMethod: inputMethod, state: state }) {
    const tr = $8d6d7b96a4e3e064$export$c875ffe428b4a5f({
        state: state
    });
    analyticsAPI === null || analyticsAPI === void 0 || analyticsAPI.attachAnalyticsEvent({
        action: (0, $g6Qq4.ACTION).INSERTED,
        actionSubject: (0, $g6Qq4.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).CODE_BLOCK,
        attributes: {
            inputMethod: inputMethod
        },
        eventType: (0, $g6Qq4.EVENT_TYPE).TRACK
    })(tr);
    return tr;
}
function $8d6d7b96a4e3e064$export$a8d9c0f039b6fb43(inputMethod, analyticsAPI) {
    return (0, $5NaaJ.withAnalytics)(analyticsAPI, {
        action: (0, $g6Qq4.ACTION).INSERTED,
        actionSubject: (0, $g6Qq4.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).CODE_BLOCK,
        attributes: {
            inputMethod: inputMethod
        },
        eventType: (0, $g6Qq4.EVENT_TYPE).TRACK
    })(function(state, dispatch) {
        const tr = $8d6d7b96a4e3e064$export$c875ffe428b4a5f({
            state: state
        });
        if (dispatch) dispatch(tr);
        return true;
    });
}
const $8d6d7b96a4e3e064$export$160d674382436f98 = (editorAnalyticsAPI)=>(state, dispatch)=>{
        const codeBlock = (0, $e1fCY.findCodeBlock)(state);
        const codeBlockNode = codeBlock === null || codeBlock === void 0 ? void 0 : codeBlock.node;
        const { tr: tr } = state;
        if (!(0, $3J3tU.codeBlockWrappedStates) || !codeBlockNode) return false;
        const updatedToggleState = !(0, $3J3tU.isCodeBlockWordWrapEnabled)(codeBlockNode);
        if ((0, $5N1Y4.expValEquals)('platform_editor_code_block_q4_lovability', 'isEnabled', true)) tr.setNodeMarkup(codeBlock.pos, undefined, {
            ...codeBlockNode.attrs,
            wrap: updatedToggleState
        }).setMeta('scrollIntoView', false);
        else (0, $3J3tU.codeBlockWrappedStates).set(codeBlockNode, updatedToggleState);
        tr.setMeta((0, $1LuwP.pluginKey), {
            type: (0, $cbzce.ACTIONS).SET_IS_WRAPPED,
            data: updatedToggleState
        });
        if (dispatch) {
            editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent({
                action: (0, $g6Qq4.ACTION).TOGGLE_CODE_BLOCK_WRAP,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).CODE_BLOCK,
                attributes: {
                    platform: (0, $4S8NW.PLATFORMS).WEB,
                    mode: (0, $4S8NW.MODE).EDITOR,
                    wordWrapEnabled: updatedToggleState,
                    codeBlockNodeSize: codeBlockNode.nodeSize
                },
                eventType: (0, $g6Qq4.EVENT_TYPE).TRACK
            })(tr);
            dispatch(tr);
        }
        return true;
    };
const $8d6d7b96a4e3e064$export$86e84eec7e5dd9ff = (editorAnalyticsAPI)=>({ tr: tr })=>{
        const { codeBlock: codeBlockType } = tr.doc.type.schema.nodes;
        const codeBlock = (0, $gab48.findSelectedNodeOfType)(codeBlockType)(tr.selection) || (0, $gab48.findParentNodeOfType)(codeBlockType)(tr.selection);
        if (!codeBlock) return null;
        const codeBlockNode = codeBlock.node;
        const lineNumbersHidden = !Boolean(codeBlockNode.attrs.hideLineNumbers);
        tr.setNodeMarkup(codeBlock.pos, undefined, {
            ...codeBlockNode.attrs,
            hideLineNumbers: lineNumbersHidden
        });
        editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent({
            action: (0, $g6Qq4.ACTION).TOGGLE_CODE_BLOCK_LINE_NUMBERS,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).CODE_BLOCK,
            attributes: {
                platform: (0, $4S8NW.PLATFORMS).WEB,
                lineNumbersHidden: lineNumbersHidden,
                codeBlockNodeSize: codeBlockNode.nodeSize
            },
            eventType: (0, $g6Qq4.EVENT_TYPE).TRACK
        })(tr);
        return tr;
    };
const $8d6d7b96a4e3e064$export$5d4256781e1f4071 = (editorAnalyticsAPI)=>(0, $iPR6g.editorCommandToPMCommand)($8d6d7b96a4e3e064$export$86e84eec7e5dd9ff(editorAnalyticsAPI));

});
parcelRegister("e1fCY", function(module, exports) {
$parcel$export(module.exports, "findCodeBlock", () => $deae65973768ead0$export$8435d1ef36841a34);

var $gab48 = parcelRequire("gab48");
const $deae65973768ead0$export$8435d1ef36841a34 = (state, selection)=>{
    const { codeBlock: codeBlock } = state.schema.nodes;
    return (0, $gab48.findSelectedNodeOfType)(codeBlock)(selection || state.selection) || (0, $gab48.findParentNodeOfType)(codeBlock)(selection || state.selection);
};

});

parcelRegister("cbzce", function(module, exports) {
$parcel$export(module.exports, "ACTIONS", () => $683f191ac4e1c7bc$export$92a1a3b7554e9387);
const $683f191ac4e1c7bc$export$92a1a3b7554e9387 = {
    CLEAR_FORMAT_CODE_ERROR: 'CLEAR_FORMAT_CODE_ERROR',
    REMOVE_AUTO_DETECT_ENTRY: 'REMOVE_AUTO_DETECT_ENTRY',
    RESOLVE_FORMAT_CODE: 'RESOLVE_FORMAT_CODE',
    SET_AUTO_DETECT_ENTRY: 'SET_AUTO_DETECT_ENTRY',
    SET_COPIED_TO_CLIPBOARD: 'SET_COPIED_TO_CLIPBOARD',
    SET_IS_WRAPPED: 'SET_IS_WRAPPED',
    SET_SHOULD_IGNORE_FOLLOWING_MUTATIONS: 'SET_SHOULD_IGNORE_FOLLOWING_MUTATIONS',
    START_FORMAT_CODE: 'START_FORMAT_CODE'
};

});

parcelRegister("552Jd", function(module, exports) {
$parcel$export(module.exports, "autoDetectPluginKey", () => $330c602e52576793$export$264979d19e499e37);

var $cw0wu = parcelRequire("cw0wu");
const $330c602e52576793$export$264979d19e499e37 = new (0, $cw0wu.PluginKey)('codeBlockAutoDetectPlugin');
const $330c602e52576793$export$62e9b65dae1e4e8f = (state)=>$330c602e52576793$export$264979d19e499e37.getState(state);

});

parcelRegister("9csIT", function(module, exports) {
$parcel$export(module.exports, "copySelectionPluginKey", () => $63c3cfe966774f1c$export$97324d26e7dfa2c5);
$parcel$export(module.exports, "codeBlockCopySelectionPlugin", () => $63c3cfe966774f1c$export$bf11b3ffc9027f6b);
$parcel$export(module.exports, "provideVisualFeedbackForCopyButton", () => $63c3cfe966774f1c$export$73dae478fefb96e);
$parcel$export(module.exports, "removeVisualFeedbackForCopyButton", () => $63c3cfe966774f1c$export$1ec425a919cc0ea);

var $j0iaN = parcelRequire("j0iaN");

var $f7Kk4 = parcelRequire("f7Kk4");

var $cw0wu = parcelRequire("cw0wu");

var $a3b9P = parcelRequire("a3b9P");
const $63c3cfe966774f1c$export$97324d26e7dfa2c5 = new (0, $cw0wu.PluginKey)('codeBlockCopySelectionPlugin');
function $63c3cfe966774f1c$var$getSelectionDecorationStartAndEnd({ state: state, transaction: transaction }) {
    const codeBlockNode = (0, $j0iaN.getSelectedNodeOrNodeParentByNodeType)({
        nodeType: state.schema.nodes.codeBlock,
        selection: transaction.selection
    });
    if (!codeBlockNode) return {
        decorationStartAndEnd: undefined,
        codeBlockNode: undefined
    };
    const decorationStartAndEnd = [
        codeBlockNode.start,
        codeBlockNode.start + codeBlockNode.node.nodeSize
    ];
    return {
        decorationStartAndEnd: decorationStartAndEnd,
        codeBlockNode: codeBlockNode.node
    };
}
function $63c3cfe966774f1c$export$bf11b3ffc9027f6b() {
    return new (0, $f7Kk4.SafePlugin)({
        key: $63c3cfe966774f1c$export$97324d26e7dfa2c5,
        state: {
            init () {
                return {
                    decorationStartAndEnd: undefined
                };
            },
            apply (transaction, currentCodeBlockCopySelectionPluginState, _oldState, newState) {
                switch(transaction.getMeta($63c3cfe966774f1c$export$97324d26e7dfa2c5)){
                    case 'show-selection':
                        return $63c3cfe966774f1c$var$getSelectionDecorationStartAndEnd({
                            state: newState,
                            transaction: transaction
                        });
                    case 'remove-selection':
                        return {
                            decorationStartAndEnd: undefined
                        };
                    default:
                        // The contents of the code block can change while the selection is being shown
                        // (either from collab edits -- or from the user continuing to type while hovering
                        // the mouse over the copy button).
                        // This ensures the selection is updated in these cases.
                        if (currentCodeBlockCopySelectionPluginState.decorationStartAndEnd !== undefined) return $63c3cfe966774f1c$var$getSelectionDecorationStartAndEnd({
                            state: newState,
                            transaction: transaction
                        });
                        return currentCodeBlockCopySelectionPluginState;
                }
            }
        },
        props: {
            decorations (state) {
                if ($63c3cfe966774f1c$export$97324d26e7dfa2c5.getState(state).decorationStartAndEnd) {
                    const [start, end] = $63c3cfe966774f1c$export$97324d26e7dfa2c5.getState(state).decorationStartAndEnd;
                    return (0, $a3b9P.DecorationSet).create(state.doc, [
                        (0, $a3b9P.Decoration).inline(start, end, {
                            class: 'ProseMirror-fake-text-selection'
                        })
                    ]);
                }
                return (0, $a3b9P.DecorationSet).empty;
            }
        }
    });
}
function $63c3cfe966774f1c$export$73dae478fefb96e(state, dispatch) {
    const tr = state.tr;
    tr.setMeta($63c3cfe966774f1c$export$97324d26e7dfa2c5, 'show-selection');
    // note: dispatch should always be defined when called from the
    // floating toolbar. Howver the Command type which the floating toolbar
    // uses suggests it's optional.
    // Using the type here to protect against future refactors of the
    // floating toolbar
    if (dispatch) dispatch(tr);
    return true;
}
function $63c3cfe966774f1c$export$1ec425a919cc0ea(state, dispatch) {
    const tr = state.tr;
    tr.setMeta($63c3cfe966774f1c$export$97324d26e7dfa2c5, 'remove-selection');
    // note: dispatch should always be defined when called from the
    // floating toolbar. Howver the Command type which the floating toolbar
    // uses suggests it's optional.
    // Using the type here to protect against future refactors of the
    // floating toolbar
    if (dispatch) dispatch(tr);
    return true;
}

});

parcelRegister("1LuwP", function(module, exports) {
$parcel$export(module.exports, "pluginKey", () => $9c890bf06ba06da0$export$18d4026d1ea86bb1);

var $cw0wu = parcelRequire("cw0wu");
const $9c890bf06ba06da0$export$18d4026d1ea86bb1 = new (0, $cw0wu.PluginKey)('codeBlockPlugin');

});

parcelRegister("b94mh", function(module, exports) {
$parcel$export(module.exports, "transformToCodeBlockAction", () => $67b67a0f67577f65$export$92adcb8baa0906a6);
$parcel$export(module.exports, "isConvertableToCodeBlock", () => $67b67a0f67577f65$export$4b5d5858845bfcf6);

var $j7pt0 = parcelRequire("j7pt0");

var $cOmYT = parcelRequire("cOmYT");

var $4ClnP = parcelRequire("4ClnP");

var $kW8qW = parcelRequire("kW8qW");

var $cw0wu = parcelRequire("cw0wu");
function $67b67a0f67577f65$export$92adcb8baa0906a6(state, start, // Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
attrs) {
    const startOfCodeBlockText = state.selection.$from;
    const endPosition = state.selection.empty && !(state.selection instanceof (0, $j7pt0.GapCursorSelection)) ? startOfCodeBlockText.end() : state.selection.$to.pos;
    const startLinePosition = startOfCodeBlockText.start();
    //when cmd+A is used to select the content. start position should be 0.
    const parentStartPosition = startOfCodeBlockText.depth === 0 ? 0 : startOfCodeBlockText.before();
    const contentSlice = state.doc.slice(startOfCodeBlockText.pos, endPosition);
    const codeBlockSlice = (0, $4ClnP.mapSlice)(contentSlice, (node, parent, index)=>{
        if (node.type === state.schema.nodes.hardBreak) return state.schema.text('\n');
        if (node.isText) return node.mark([]);
        if (node.isInline) {
            // Convert dates
            if (node.attrs.timestamp) return state.schema.text((0, $cOmYT.timestampToString)(node.attrs.timestamp, null));
            // Convert links
            if (node.attrs.url) return state.schema.text(node.attrs.url);
            return node.attrs.text ? state.schema.text(node.attrs.text) : null;
        }
        // if the current node is the last child of the Slice exit early to prevent
        // adding additional line breaks
        if (contentSlice.content.childCount - 1 === index) return node.content;
        //useful to decide whether to append line breaks when the content has list items.
        const isParentLastChild = parent && contentSlice.content.childCount - 1 === index;
        // add line breaks at the end of each paragraph to mimic layout of selected content
        // do not add line breaks when the 'paragraph' parent is last child.
        if (node.content.childCount && node.type === state.schema.nodes.paragraph && !isParentLastChild) return node.content.append((0, $kW8qW.Fragment).from(state.schema.text('\n\n')));
        return node.content.childCount ? node.content : null;
    });
    const tr = state.tr;
    // Replace current block node
    const startMapped = startLinePosition === start ? parentStartPosition : start;
    const codeBlock = state.schema.nodes.codeBlock;
    const codeBlockNode = codeBlock.createChecked(attrs, codeBlockSlice.content);
    tr.replaceWith(startMapped, Math.min(endPosition, tr.doc.content.size), codeBlockNode);
    // Reposition cursor when inserting into layouts or table headers
    const mapped = tr.doc.resolve(tr.mapping.map(startMapped) + 1);
    const selection = (0, $cw0wu.TextSelection).findFrom(mapped, state.selection instanceof (0, $j7pt0.GapCursorSelection) ? -1 : 1, true);
    if (selection) return tr.setSelection(selection);
    return tr.setSelection((0, $cw0wu.TextSelection).create(tr.doc, Math.min(start + startOfCodeBlockText.node().nodeSize - 1, tr.doc.content.size)));
}
function $67b67a0f67577f65$export$4b5d5858845bfcf6(state) {
    // Before a document is loaded, there is no selection.
    if (!state.selection) return false;
    const { $from: $from } = state.selection;
    const node = $from.parent;
    if (!node.isTextblock || node.type === state.schema.nodes.codeBlock) return false;
    const parentDepth = $from.depth - 1;
    const parentNode = $from.node(parentDepth);
    const index = $from.index(parentDepth);
    return parentNode.canReplaceWith(index, index + 1, state.schema.nodes.codeBlock);
}

});

parcelRegister("b0rAs", function(module, exports) {
$parcel$export(module.exports, "hasEnoughTextForAutoDetection", () => $9be4256c2995bbf9$export$a5224da7b01ec0b7);
$parcel$export(module.exports, "getLocalId", () => $9be4256c2995bbf9$export$957229695d10ea4a);
$parcel$export(module.exports, "createAutoDetectEntry", () => $9be4256c2995bbf9$export$ebf3c95b2e36b335);
$parcel$export(module.exports, "removeAutoDetection", () => $9be4256c2995bbf9$export$8e484f7dcf239a78);
$parcel$export(module.exports, "updateAutoDetectState", () => $9be4256c2995bbf9$export$e9e91d763bd6702f);

var $3J3tU = parcelRequire("3J3tU");

var $56AB9 = parcelRequire("56AB9");

var $2RMFZ = parcelRequire("2RMFZ");
const $9be4256c2995bbf9$var$MIN_AUTO_DETECT_TEXT_LENGTH = 20;
const $9be4256c2995bbf9$export$75fa5ee64c376b5c = (lastObservedText, text)=>{
    if (!lastObservedText) return text.length > 0;
    return Math.abs(text.length - lastObservedText.length) > lastObservedText.length / 2;
};
const $9be4256c2995bbf9$export$1c51de8940db13e0 = (text)=>text.split('\n')[0] ?? '';
const $9be4256c2995bbf9$export$a5224da7b01ec0b7 = (text)=>text.trim().length >= $9be4256c2995bbf9$var$MIN_AUTO_DETECT_TEXT_LENGTH;
const $9be4256c2995bbf9$export$957229695d10ea4a = (node)=>typeof node.attrs.localId === 'string' ? node.attrs.localId : null;
const $9be4256c2995bbf9$export$ebf3c95b2e36b335 = (node, pos, isPending, previous, options = {})=>({
        lastObservedText: node.textContent,
        lastObservedFirstLine: $9be4256c2995bbf9$export$1c51de8940db13e0(node.textContent),
        isPending: isPending,
        detectionResult: options.preserveDetectionResult === false ? undefined : previous === null || previous === void 0 ? void 0 : previous.detectionResult,
        autoDetectedLanguage: previous === null || previous === void 0 ? void 0 : previous.autoDetectedLanguage,
        pos: pos
    });
const $9be4256c2995bbf9$export$82bdb85239e6f0b5 = (languageDetectionMap, node, pos, isPending)=>{
    const localId = $9be4256c2995bbf9$export$957229695d10ea4a(node);
    if (!localId) return languageDetectionMap;
    return {
        ...languageDetectionMap,
        [localId]: $9be4256c2995bbf9$export$ebf3c95b2e36b335(node, pos, isPending, languageDetectionMap[localId])
    };
};
const $9be4256c2995bbf9$export$8e484f7dcf239a78 = (languageDetectionMap, localId)=>{
    if (!languageDetectionMap[localId]) return languageDetectionMap;
    const nextLanguageDetectionMap = {
        ...languageDetectionMap
    };
    delete nextLanguageDetectionMap[localId];
    return nextLanguageDetectionMap;
};
const $9be4256c2995bbf9$var$getCodeBlockLocalIdsRemovedFromChangedRanges = (tr, codeBlockType)=>{
    const localIds = new Set();
    tr.steps.forEach((step, stepIndex)=>{
        const docAtStep = tr.docs[stepIndex];
        step.getMap().forEach((oldStart, oldEnd)=>{
            if (oldStart === oldEnd) return;
            const clampedOldEnd = Math.min(oldEnd, docAtStep.content.size);
            docAtStep.nodesBetween(oldStart, clampedOldEnd, (node, pos)=>{
                if (node.type !== codeBlockType) return true;
                const isWholeCodeBlockRemoved = pos >= oldStart && pos + node.nodeSize <= clampedOldEnd;
                if (!isWholeCodeBlockRemoved) return false;
                const localId = $9be4256c2995bbf9$export$957229695d10ea4a(node);
                if (localId) localIds.add(localId);
                return false;
            });
        });
    });
    return localIds;
};
const $9be4256c2995bbf9$var$isHistoryMeta = (meta)=>typeof meta === 'object' && meta !== null && 'redo' in meta;
const $9be4256c2995bbf9$var$getCodeBlockTransactionChanges = (tr, codeBlockType)=>{
    const insertedNodesWithPos = (0, $3J3tU.getInsertedCodeBlocksInTransaction)(tr, codeBlockType);
    const removedFromChangedRangesLocalIds = $9be4256c2995bbf9$var$getCodeBlockLocalIdsRemovedFromChangedRanges(tr, codeBlockType);
    const insertedLocalIds = new Set();
    const insertedCodeBlocks = [];
    insertedNodesWithPos.forEach(({ node: node, pos: pos })=>{
        const localId = $9be4256c2995bbf9$export$957229695d10ea4a(node);
        if (!localId) return;
        insertedLocalIds.add(localId);
        if (!removedFromChangedRangesLocalIds.has(localId)) insertedCodeBlocks.push({
            localId: localId,
            node: node,
            pos: pos
        });
    });
    const deletedLocalIds = new Set();
    removedFromChangedRangesLocalIds.forEach((localId)=>{
        if (!insertedLocalIds.has(localId)) deletedLocalIds.add(localId);
    });
    return {
        deletedLocalIds: deletedLocalIds,
        insertedCodeBlocks: insertedCodeBlocks
    };
};
const $9be4256c2995bbf9$export$e9e91d763bd6702f = (tr, pluginState)=>{
    const { codeBlock: codeBlock } = tr.doc.type.schema.nodes;
    const isPaste = tr.getMeta('paste') === true || tr.getMeta('uiEvent') === 'paste';
    const isExternalContentChange = tr.getMeta('replaceDocument') === true || tr.getMeta('isRemote') === true;
    const historyMeta = tr.getMeta((0, $56AB9.pmHistoryPluginKey));
    const isUndo = $9be4256c2995bbf9$var$isHistoryMeta(historyMeta) && historyMeta.redo === false;
    const hasTrackedEntries = Object.keys(pluginState.languageDetectionMap).length > 0;
    // Page loads and remote edits should not start auto-detection for code blocks.
    if (!hasTrackedEntries && isExternalContentChange) return pluginState.languageDetectionMap;
    // Existing entries still need mapping/deletion cleanup, but external edits should not refresh text.
    const changedCodeBlockNodes = isExternalContentChange ? [] : (0, $2RMFZ.getAllChangedCodeBlocksInTransaction)(tr);
    if (!hasTrackedEntries && !changedCodeBlockNodes.length) return pluginState.languageDetectionMap;
    const { deletedLocalIds: deletedLocalIds, insertedCodeBlocks: insertedCodeBlocks } = $9be4256c2995bbf9$var$getCodeBlockTransactionChanges(tr, codeBlock);
    let languageDetectionMap = hasTrackedEntries ? Object.fromEntries(Object.entries(pluginState.languageDetectionMap).map(([localId, entry])=>[
            localId,
            {
                ...entry,
                pos: tr.mapping.map(entry.pos)
            }
        ])) : pluginState.languageDetectionMap;
    if (!isExternalContentChange) {
        insertedCodeBlocks.forEach(({ localId: localId, node: node, pos: pos })=>{
            if (node.attrs.language) {
                languageDetectionMap = $9be4256c2995bbf9$export$8e484f7dcf239a78(languageDetectionMap, localId);
                return;
            }
            languageDetectionMap = $9be4256c2995bbf9$export$82bdb85239e6f0b5(languageDetectionMap, node, pos, $9be4256c2995bbf9$export$a5224da7b01ec0b7(node.textContent));
        });
        changedCodeBlockNodes.forEach(({ node: node, pos: pos })=>{
            var _tr$before$nodeAt;
            const localId = $9be4256c2995bbf9$export$957229695d10ea4a(node);
            if (!localId || !languageDetectionMap[localId]) return;
            const currentLanguage = node.attrs.language;
            const previousEntry = languageDetectionMap[localId];
            // Undo metadata does not identify the changed node; compare the pre/post language
            // so text undo inside auto-detection mode keeps the entry.
            const previousLanguage = isUndo ? (_tr$before$nodeAt = tr.before.nodeAt(tr.mapping.invert().map(pos))) === null || _tr$before$nodeAt === void 0 ? void 0 : _tr$before$nodeAt.attrs.language : undefined;
            if (isUndo && previousLanguage && !currentLanguage || currentLanguage && currentLanguage !== previousEntry.autoDetectedLanguage) {
                languageDetectionMap = $9be4256c2995bbf9$export$8e484f7dcf239a78(languageDetectionMap, localId);
                return;
            }
            const text = node.textContent;
            const firstLine = $9be4256c2995bbf9$export$1c51de8940db13e0(text);
            const shouldTriggerDetection = previousEntry.isPending || isPaste || firstLine !== previousEntry.lastObservedFirstLine || $9be4256c2995bbf9$export$75fa5ee64c376b5c(previousEntry.lastObservedText, text);
            const isPending = $9be4256c2995bbf9$export$a5224da7b01ec0b7(text) && shouldTriggerDetection;
            // Only pending detection refreshes the text snapshot; otherwise gradual typing
            // should continue comparing against the last attempted detection.
            languageDetectionMap = isPending ? $9be4256c2995bbf9$export$82bdb85239e6f0b5(languageDetectionMap, node, pos, true) : {
                ...languageDetectionMap,
                [localId]: {
                    ...previousEntry,
                    isPending: false,
                    pos: pos
                }
            };
        });
    }
    deletedLocalIds.forEach((localId)=>{
        if (languageDetectionMap[localId]) languageDetectionMap = $9be4256c2995bbf9$export$8e484f7dcf239a78(languageDetectionMap, localId);
    });
    return languageDetectionMap;
};

});
parcelRegister("2RMFZ", function(module, exports) {
$parcel$export(module.exports, "getCursor", () => $20417ff73abc6376$export$da3f040fb23d21f);
$parcel$export(module.exports, "getAllCodeBlockNodesInDoc", () => $20417ff73abc6376$export$f43d710a87ced169);
$parcel$export(module.exports, "getAllChangedCodeBlocksInTransaction", () => $20417ff73abc6376$export$3fa3c149b89781e7);
function $20417ff73abc6376$export$da3f040fb23d21f(selection) {
    return selection.$cursor || undefined;
}
function $20417ff73abc6376$export$f43d710a87ced169(state) {
    const codeBlockNodes = [];
    state.doc.descendants((node, pos)=>{
        if (node.type === state.schema.nodes.codeBlock) {
            codeBlockNodes.push({
                node: node,
                pos: pos
            });
            return false;
        }
        return true;
    });
    return codeBlockNodes;
}
function $20417ff73abc6376$export$3fa3c149b89781e7(tr) {
    const changedCodeBlocks = [];
    const nodePositions = new Set();
    tr.steps.forEach((step)=>{
        const mapResult = step.getMap();
        mapResult.forEach((oldStart, oldEnd, newStart, newEnd)=>{
            tr.doc.nodesBetween(newStart, Math.min(newEnd, tr.doc.content.size), (node, pos)=>{
                if (node.type.name === 'codeBlock') {
                    if (!nodePositions.has(pos)) {
                        nodePositions.add(pos);
                        changedCodeBlocks.push({
                            node: node,
                            pos: pos
                        });
                    }
                }
            });
        });
    });
    return changedCodeBlocks;
}

});



parcelRegister("aERFo", function(module, exports) {
$parcel$export(module.exports, "createAutoDetectPlugin", () => $6666db4c99f66f76$export$d5142f5b34a5c85b);

var $f7Kk4 = parcelRequire("f7Kk4");

var $b0rAs = parcelRequire("b0rAs");

var $kZ5YL = parcelRequire("kZ5YL");

var $cbzce = parcelRequire("cbzce");

var $552Jd = parcelRequire("552Jd");
const $6666db4c99f66f76$export$d5142f5b34a5c85b = (api)=>new (0, $f7Kk4.SafePlugin)({
        key: (0, $552Jd.autoDetectPluginKey),
        state: {
            init () {
                return {
                    languageDetectionMap: {}
                };
            },
            apply (tr, pluginState) {
                const meta = tr.getMeta((0, $552Jd.autoDetectPluginKey));
                let languageDetectionMap = tr.docChanged ? (0, $b0rAs.updateAutoDetectState)(tr, pluginState) : pluginState.languageDetectionMap;
                if ((meta === null || meta === void 0 ? void 0 : meta.type) === (0, $cbzce.ACTIONS).SET_AUTO_DETECT_ENTRY) languageDetectionMap = {
                    ...languageDetectionMap,
                    [meta.data.localId]: meta.data.entry
                };
                else if ((meta === null || meta === void 0 ? void 0 : meta.type) === (0, $cbzce.ACTIONS).REMOVE_AUTO_DETECT_ENTRY) languageDetectionMap = (0, $b0rAs.removeAutoDetection)(languageDetectionMap, meta.data.localId);
                if (languageDetectionMap === pluginState.languageDetectionMap) return pluginState;
                return {
                    languageDetectionMap: languageDetectionMap
                };
            }
        },
        view (view) {
            const timers = new Map();
            return {
                update () {
                    (0, $kZ5YL.syncPendingDetectionTimers)(view, timers, api);
                },
                destroy () {
                    timers.forEach(({ timer: timer })=>clearTimeout(timer));
                    timers.clear();
                }
            };
        }
    });

});
parcelRegister("kZ5YL", function(module, exports) {
$parcel$export(module.exports, "syncPendingDetectionTimers", () => $6228d1d54d0a3424$export$294a2b069616ba23);

var $g6Qq4 = parcelRequire("g6Qq4");

var $cbzce = parcelRequire("cbzce");

var $552Jd = parcelRequire("552Jd");

var $b0rAs = parcelRequire("b0rAs");

var $6FsW6 = parcelRequire("6FsW6");
const $6228d1d54d0a3424$var$AUTO_DETECT_DEBOUNCE_MS = 500;
// Stored positions are mapped through transactions; verify the localId before using them.
const $6228d1d54d0a3424$var$getCodeBlockFromEntry = (view, localId, entry)=>{
    const node = view.state.doc.nodeAt(entry.pos);
    const codeBlockType = view.state.schema.nodes.codeBlock;
    if ((node === null || node === void 0 ? void 0 : node.type) === codeBlockType && node.attrs.localId === localId) return {
        node: node,
        pos: entry.pos
    };
    return null;
};
// Runs after debounce, so it must re-read current editor state before applying language changes.
const $6228d1d54d0a3424$var$runPendingDetection = (view, localId, api)=>{
    var _api$core;
    const pluginState = (0, $552Jd.autoDetectPluginKey).getState(view.state);
    const entry = pluginState === null || pluginState === void 0 ? void 0 : pluginState.languageDetectionMap[localId];
    if (!(entry !== null && entry !== void 0 && entry.isPending)) return;
    const found = $6228d1d54d0a3424$var$getCodeBlockFromEntry(view, localId, entry);
    if (!found) return;
    const detectedLanguage = (0, $6FsW6.detectLanguage)(found.node.textContent);
    const detectionResult = detectedLanguage ? 'detected' : 'noneDetected';
    const detectionPhase = entry.detectionResult ? 'redetection' : 'initial';
    // Keep a previous auto-detected language when the latest snippet is too weak to classify.
    const shouldPreserveAutoDetectedLanguage = !detectedLanguage && Boolean(entry.autoDetectedLanguage) && found.node.attrs.language === entry.autoDetectedLanguage;
    const nextEntry = {
        ...(0, $b0rAs.createAutoDetectEntry)(found.node, found.pos, false, entry),
        detectionResult: detectionResult,
        autoDetectedLanguage: detectedLanguage ?? entry.autoDetectedLanguage
    };
    const hasDetectedLanguageChange = Boolean(detectedLanguage) && found.node.attrs.language !== detectedLanguage;
    const shouldClearStaleLanguage = !detectedLanguage && Boolean(found.node.attrs.language) && !shouldPreserveAutoDetectedLanguage;
    const shouldUpdateNodeLanguage = hasDetectedLanguageChange || shouldClearStaleLanguage;
    api === null || api === void 0 || (_api$core = api.core) === null || _api$core === void 0 || _api$core.actions.execute(({ tr: tr })=>{
        if (shouldUpdateNodeLanguage) {
            var _api$analytics;
            tr.setNodeMarkup(found.pos, undefined, {
                ...found.node.attrs,
                language: detectedLanguage
            }, found.node.marks);
            api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 || _api$analytics.actions.attachAnalyticsEvent({
                action: (0, $g6Qq4.ACTION).LANGUAGE_AUTO_DETECTED,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).CODE_BLOCK,
                attributes: {
                    language: detectedLanguage ?? 'none',
                    detectionResult: detectionResult,
                    detectionPhase: detectionPhase
                },
                eventType: (0, $g6Qq4.EVENT_TYPE).TRACK
            })(tr);
        }
        tr.setMeta((0, $552Jd.autoDetectPluginKey), {
            type: (0, $cbzce.ACTIONS).SET_AUTO_DETECT_ENTRY,
            data: {
                localId: localId,
                entry: nextEntry
            }
        });
        // Language detection runs in the background and should not move the viewport.
        return tr.setMeta('scrollIntoView', false);
    });
};
const $6228d1d54d0a3424$var$clearTimer = (timers, localId)=>{
    const scheduledDetection = timers.get(localId);
    if (scheduledDetection) {
        clearTimeout(scheduledDetection.timer);
        timers.delete(localId);
    }
};
const $6228d1d54d0a3424$export$294a2b069616ba23 = (view, timers, api)=>{
    const pluginState = (0, $552Jd.autoDetectPluginKey).getState(view.state);
    const pendingEntries = Object.entries((pluginState === null || pluginState === void 0 ? void 0 : pluginState.languageDetectionMap) ?? {}).filter(([, entry])=>entry.isPending);
    const pendingLocalIds = new Set(pendingEntries.map(([localId])=>localId));
    pendingEntries.forEach(([localId, entry])=>{
        const scheduledDetection = timers.get(localId);
        if ((scheduledDetection === null || scheduledDetection === void 0 ? void 0 : scheduledDetection.lastObservedText) === entry.lastObservedText) return;
        $6228d1d54d0a3424$var$clearTimer(timers, localId);
        const timer = setTimeout(()=>{
            timers.delete(localId);
            $6228d1d54d0a3424$var$runPendingDetection(view, localId, api);
        }, $6228d1d54d0a3424$var$AUTO_DETECT_DEBOUNCE_MS);
        timers.set(localId, {
            lastObservedText: entry.lastObservedText,
            timer: timer
        });
    });
    timers.forEach((_, localId)=>{
        if (!pendingLocalIds.has(localId)) $6228d1d54d0a3424$var$clearTimer(timers, localId);
    });
};

});
parcelRegister("6FsW6", function(module, exports) {
$parcel$export(module.exports, "detectLanguage", () => $4018f80f5dcc51a0$export$ae9ea24a1b29b07c);
/* eslint-disable require-unicode-regexp */ // Conservative weighted-regex heuristic for common high-confidence snippets, not a full classifier.
// Ambiguous snippets intentionally return null so users can select the language manually.
const $4018f80f5dcc51a0$var$MAX_DETECTION_CHARS = 10000;
const $4018f80f5dcc51a0$var$MIN_DETECTION_SCORE = 3; // Require at least one medium-confidence signal before auto-selecting.
const $4018f80f5dcc51a0$var$MIN_SCORE_GAP = 2; // Avoid auto-selecting when top two languages are too close to distinguish.
// looksLikeJson regexes
const $4018f80f5dcc51a0$var$JSON_START_REGEX = /^[{[]/;
const $4018f80f5dcc51a0$var$JSON_END_REGEX = /[}\]]$/;
// html regexes
const $4018f80f5dcc51a0$var$HTML_DOCTYPE_REGEX = /<!doctype\s+html/i;
const $4018f80f5dcc51a0$var$HTML_TAG_REGEX = /<\/?(?:html|head|body|div|span|script|style|section|template)\b/i;
// css regexes
const $4018f80f5dcc51a0$var$CSS_AT_RULE_REGEX = /@[\w-]+\s+[^{]+\{/;
const $4018f80f5dcc51a0$var$CSS_SELECTOR_PROPERTY_REGEX = /[.#]?[-_a-zA-Z][-_a-zA-Z0-9\s,.:#>+~*\[\]='"]+\{[^}]*\b(?:color|display|margin|padding|font|background|border|width|height|grid|flex)\s*:/;
const $4018f80f5dcc51a0$var$CSS_PROPERTY_REGEX = /\b(?:color|display|margin|padding|font-size|background|border|width|height)\s*:\s*[^;{}]+;/;
// sql regexes
const $4018f80f5dcc51a0$var$SQL_SELECT_FROM_REGEX = /\bSELECT\b[\s\S]+\bFROM\b/i;
const $4018f80f5dcc51a0$var$SQL_DML_REGEX = /\b(?:INSERT\s+INTO|UPDATE\b[\s\S]+\bSET\b|DELETE\s+FROM|CREATE\s+TABLE|ALTER\s+TABLE)\b/i;
const $4018f80f5dcc51a0$var$SQL_CLAUSE_REGEX = /\b(?:JOIN|WHERE|GROUP\s+BY|ORDER\s+BY|LIMIT)\b/i;
// typescript regexes
const $4018f80f5dcc51a0$var$TS_INTERFACE_TYPE_REGEX = /\b(?:interface|type)\s+[A-Z_$][\w$]*(?:\s*[=<{])/;
const $4018f80f5dcc51a0$var$TS_IMPORT_EXPORT_TYPE_REGEX = /\bimport\s+type\b|\bexport\s+type\b/;
const $4018f80f5dcc51a0$var$TS_TYPED_VAR_REGEX = /\b(?:const|let|var)\s+[\w$]+\s*:\s*[A-Za-z_$][\w$<>|\[\],\s]*/;
const $4018f80f5dcc51a0$var$TS_RETURN_TYPE_REGEX = /\)\s*:\s*(?:Promise<)?[A-Za-z_$][\w$<>|\[\],\s]*(?:>|\s)?\s*=>?\s*[{;]/;
const $4018f80f5dcc51a0$var$TS_ADVANCED_REGEX = /\b(?:as\s+const|implements\s+[A-Z_$]|enum\s+[A-Z_$])/;
const $4018f80f5dcc51a0$var$TS_ACCESS_MODIFIER_REGEX = /\b(?:private|protected|public|readonly)\s+[\w$]+\s*=/;
const $4018f80f5dcc51a0$var$TS_TYPED_ARROW_PARAM_REGEX = /\([^)]{0,500}\b[\w$]+\??:\s*[A-Za-z_$][\w$<>{}\[\]|&,\s.?]{0,200}[^)]{0,500}\)\s*(?::\s*[A-Za-z_$][\w$<>{}\[\]|&,\s.?]{0,200})?\s*=>/;
// javascript regexes
const $4018f80f5dcc51a0$var$JS_VAR_REGEX = /\b(?:const|let|var)\s+[\w$]+\s*=/;
const $4018f80f5dcc51a0$var$JS_FUNCTION_REGEX = /\bfunction\s*[\w$]*\s*\([^)]*\)\s*\{/;
const $4018f80f5dcc51a0$var$JS_ARROW_REGEX = /=>\s*(?:\{|[\w$'"`(])/;
const $4018f80f5dcc51a0$var$JS_IMPORT_EXPORT_REGEX = /\b(?:import|export)\s+(?:[\w${}*,\s]+\s+from\s+)?['"][^'"]+['"]/;
const $4018f80f5dcc51a0$var$JS_COMMON_API_REGEX = /\b(?:console\.log|document\.|window\.|require\()|\bmodule\.exports\b/;
// python regexes
const $4018f80f5dcc51a0$var$PY_DEF_REGEX = /^\s*def\s+[a-zA-Z_]\w*\([^)]*\)\s*:/m;
const $4018f80f5dcc51a0$var$PY_CLASS_REGEX = /^\s*class\s+[A-Z_]\w*(?:\([^)]*\))?\s*:/m;
const $4018f80f5dcc51a0$var$PY_IMPORT_REGEX = /^\s*(?:from\s+[\w.]+\s+import\s+\w+|import\s+[\w.]+)/m;
const $4018f80f5dcc51a0$var$PY_CONTROL_REGEX = /^\s*(?:if|elif|else|for|while|try|except)\b[^\n]*:\s*$/m;
const $4018f80f5dcc51a0$var$PY_PRINT_REGEX = /\bprint\([^)]*\)/;
// java regexes
const $4018f80f5dcc51a0$var$JAVA_CLASS_REGEX = /\bpublic\s+(?:final\s+)?class\s+[A-Z]\w*/;
const $4018f80f5dcc51a0$var$JAVA_MAIN_REGEX = /\bpublic\s+static\s+void\s+main\s*\(\s*String\[\]/;
const $4018f80f5dcc51a0$var$JAVA_PRINTLN_REGEX = /\bSystem\.out\.println\s*\(/;
const $4018f80f5dcc51a0$var$JAVA_MEMBER_REGEX = /\b(?:private|protected|public)\s+(?:static\s+)?(?:final\s+)?[A-Z]\w*(?:<[^>]+>)?\s+\w+\s*[;(=]/;
// go regexes
const $4018f80f5dcc51a0$var$GO_PACKAGE_REGEX = /^\s*package\s+\w+/m;
const $4018f80f5dcc51a0$var$GO_FUNC_REGEX = /\bfunc\s+(?:\([^)]*\)\s*)?[A-Za-z_]\w*\s*\([^)]*\)\s*(?:[A-Za-z_*\[\]]+\s*)?\{/;
const $4018f80f5dcc51a0$var$GO_PRINTLN_REGEX = /\bfmt\.(?:Println|Printf)\s*\(/;
const $4018f80f5dcc51a0$var$GO_IMPORT_REGEX = /\bimport\s+\(\s*[\s\S]*?\)/;
// ruby regexes
const $4018f80f5dcc51a0$var$RUBY_DEF_REGEX = /^\s*def\s+[a-z_]\w*[!?=]?/m;
const $4018f80f5dcc51a0$var$RUBY_CLASS_REGEX = /^\s*class\s+[A-Z]\w*(?:\s*<\s*[A-Z]\w*)?/m;
const $4018f80f5dcc51a0$var$RUBY_END_REGEX = /^\s*end\s*$/m;
const $4018f80f5dcc51a0$var$RUBY_COMMON_API_REGEX = /\b(?:puts|require|attr_reader|attr_accessor)\b/;
const $4018f80f5dcc51a0$var$RUBY_BLOCK_REGEX = /\bdo\s*\|[^|]+\|/;
// rust regexes
const $4018f80f5dcc51a0$var$RUST_FN_REGEX = /\bfn\s+[a-z_]\w*\s*\([^)]*\)\s*(?:->\s*[A-Za-z_:<>]+\s*)?\{/;
const $4018f80f5dcc51a0$var$RUST_LET_MUT_REGEX = /\blet\s+mut\s+\w+/;
const $4018f80f5dcc51a0$var$RUST_PRINTLN_REGEX = /\bprintln!\s*\(/;
const $4018f80f5dcc51a0$var$RUST_USE_REGEX = /\buse\s+(?:std|crate|super)::/;
const $4018f80f5dcc51a0$var$RUST_STRUCT_REGEX = /\b(?:impl|pub\s+struct|enum)\s+[A-Z]\w*/;
// shell regexes
const $4018f80f5dcc51a0$var$SHELL_SHEBANG_REGEX = /^#!\/usr\/bin\/(?:env\s+)?(?:ba|z|k)?sh\b/m;
const $4018f80f5dcc51a0$var$SHELL_CONTROL_REGEX = /^\s*(?:if|for|while)\b[\s\S]+\b(?:then|do)\b/m;
const $4018f80f5dcc51a0$var$SHELL_FI_DONE_REGEX = /^\s*(?:fi|done)\s*$/m;
const $4018f80f5dcc51a0$var$SHELL_COMMAND_REGEX = /\b(?:echo|export|cd|grep|sed|awk|curl)\b[\s\S]*(?:\$\w+|&&|\|)/;
const $4018f80f5dcc51a0$var$SHELL_VAR_REGEX = /\$\{?[A-Z_][A-Z0-9_]*\}?/;
const $4018f80f5dcc51a0$var$hasPattern = (code, pattern)=>{
    // Reset stateful regexes so repeated tests always start at the beginning.
    pattern.lastIndex = 0;
    return pattern.test(code);
};
const $4018f80f5dcc51a0$var$scorePatterns = (code, patterns)=>patterns.reduce((score, [pattern, value])=>score + ($4018f80f5dcc51a0$var$hasPattern(code, pattern) ? value : 0), 0);
const $4018f80f5dcc51a0$var$looksLikeHtmlTagPair = (code)=>{
    const openTags = new Set();
    // Ignored via go/ees019
    // eslint-disable-next-line e18e/prefer-static-regex
    const tagPattern = /<\/?([a-z][a-z0-9-]*)\b[^<>]{0,500}>/gi;
    let match;
    while((match = tagPattern.exec(code)) !== null){
        const [tag, tagName] = match;
        if (tag.endsWith('/>')) continue;
        if (tag.startsWith('</')) {
            if (openTags.has(tagName.toLowerCase())) return true;
        } else openTags.add(tagName.toLowerCase());
    }
    return false;
};
const $4018f80f5dcc51a0$var$looksLikeJson = (code)=>{
    const trimmed = code.trim();
    if (!$4018f80f5dcc51a0$var$JSON_START_REGEX.test(trimmed) || !$4018f80f5dcc51a0$var$JSON_END_REGEX.test(trimmed)) return false;
    try {
        const parsed = JSON.parse(trimmed);
        return parsed !== null && typeof parsed === 'object';
    } catch  {
        return false;
    }
};
const $4018f80f5dcc51a0$var$getLanguageScores = (code)=>[
        {
            language: 'json',
            score: $4018f80f5dcc51a0$var$looksLikeJson(code) ? 8 : 0
        },
        {
            language: 'html',
            score: $4018f80f5dcc51a0$var$scorePatterns(code, [
                [
                    $4018f80f5dcc51a0$var$HTML_DOCTYPE_REGEX,
                    5
                ],
                [
                    $4018f80f5dcc51a0$var$HTML_TAG_REGEX,
                    2
                ]
            ]) + ($4018f80f5dcc51a0$var$looksLikeHtmlTagPair(code) ? 3 : 0)
        },
        {
            language: 'css',
            score: $4018f80f5dcc51a0$var$scorePatterns(code, [
                [
                    $4018f80f5dcc51a0$var$CSS_AT_RULE_REGEX,
                    3
                ],
                [
                    $4018f80f5dcc51a0$var$CSS_SELECTOR_PROPERTY_REGEX,
                    5
                ],
                [
                    $4018f80f5dcc51a0$var$CSS_PROPERTY_REGEX,
                    3
                ]
            ])
        },
        {
            language: 'sql',
            score: $4018f80f5dcc51a0$var$scorePatterns(code, [
                [
                    $4018f80f5dcc51a0$var$SQL_SELECT_FROM_REGEX,
                    5
                ],
                [
                    $4018f80f5dcc51a0$var$SQL_DML_REGEX,
                    5
                ],
                [
                    $4018f80f5dcc51a0$var$SQL_CLAUSE_REGEX,
                    2
                ]
            ])
        },
        {
            language: 'typescript',
            score: $4018f80f5dcc51a0$var$scorePatterns(code, [
                [
                    $4018f80f5dcc51a0$var$TS_INTERFACE_TYPE_REGEX,
                    5
                ],
                [
                    $4018f80f5dcc51a0$var$TS_IMPORT_EXPORT_TYPE_REGEX,
                    4
                ],
                [
                    $4018f80f5dcc51a0$var$TS_TYPED_VAR_REGEX,
                    4
                ],
                [
                    $4018f80f5dcc51a0$var$TS_RETURN_TYPE_REGEX,
                    3
                ],
                [
                    $4018f80f5dcc51a0$var$TS_ADVANCED_REGEX,
                    3
                ],
                [
                    $4018f80f5dcc51a0$var$TS_ACCESS_MODIFIER_REGEX,
                    5
                ],
                [
                    $4018f80f5dcc51a0$var$TS_TYPED_ARROW_PARAM_REGEX,
                    5
                ]
            ])
        },
        {
            language: 'javascript',
            score: $4018f80f5dcc51a0$var$scorePatterns(code, [
                [
                    $4018f80f5dcc51a0$var$JS_VAR_REGEX,
                    3
                ],
                [
                    $4018f80f5dcc51a0$var$JS_FUNCTION_REGEX,
                    3
                ],
                [
                    $4018f80f5dcc51a0$var$JS_ARROW_REGEX,
                    3
                ],
                [
                    $4018f80f5dcc51a0$var$JS_IMPORT_EXPORT_REGEX,
                    3
                ],
                [
                    $4018f80f5dcc51a0$var$JS_COMMON_API_REGEX,
                    3
                ]
            ])
        },
        {
            language: 'python',
            score: $4018f80f5dcc51a0$var$scorePatterns(code, [
                [
                    $4018f80f5dcc51a0$var$PY_DEF_REGEX,
                    5
                ],
                [
                    $4018f80f5dcc51a0$var$PY_CLASS_REGEX,
                    4
                ],
                [
                    $4018f80f5dcc51a0$var$PY_IMPORT_REGEX,
                    3
                ],
                [
                    $4018f80f5dcc51a0$var$PY_CONTROL_REGEX,
                    2
                ],
                [
                    $4018f80f5dcc51a0$var$PY_PRINT_REGEX,
                    2
                ]
            ])
        },
        {
            language: 'java',
            score: $4018f80f5dcc51a0$var$scorePatterns(code, [
                [
                    $4018f80f5dcc51a0$var$JAVA_CLASS_REGEX,
                    5
                ],
                [
                    $4018f80f5dcc51a0$var$JAVA_MAIN_REGEX,
                    5
                ],
                [
                    $4018f80f5dcc51a0$var$JAVA_PRINTLN_REGEX,
                    4
                ],
                [
                    $4018f80f5dcc51a0$var$JAVA_MEMBER_REGEX,
                    3
                ]
            ])
        },
        {
            language: 'go',
            score: $4018f80f5dcc51a0$var$scorePatterns(code, [
                [
                    $4018f80f5dcc51a0$var$GO_PACKAGE_REGEX,
                    5
                ],
                [
                    $4018f80f5dcc51a0$var$GO_FUNC_REGEX,
                    5
                ],
                [
                    $4018f80f5dcc51a0$var$GO_PRINTLN_REGEX,
                    3
                ],
                [
                    $4018f80f5dcc51a0$var$GO_IMPORT_REGEX,
                    2
                ]
            ])
        },
        {
            language: 'ruby',
            score: $4018f80f5dcc51a0$var$scorePatterns(code, [
                [
                    $4018f80f5dcc51a0$var$RUBY_DEF_REGEX,
                    4
                ],
                [
                    $4018f80f5dcc51a0$var$RUBY_CLASS_REGEX,
                    3
                ],
                [
                    $4018f80f5dcc51a0$var$RUBY_END_REGEX,
                    3
                ],
                [
                    $4018f80f5dcc51a0$var$RUBY_COMMON_API_REGEX,
                    3
                ],
                [
                    $4018f80f5dcc51a0$var$RUBY_BLOCK_REGEX,
                    2
                ]
            ])
        },
        {
            language: 'rust',
            score: $4018f80f5dcc51a0$var$scorePatterns(code, [
                [
                    $4018f80f5dcc51a0$var$RUST_FN_REGEX,
                    5
                ],
                [
                    $4018f80f5dcc51a0$var$RUST_LET_MUT_REGEX,
                    3
                ],
                [
                    $4018f80f5dcc51a0$var$RUST_PRINTLN_REGEX,
                    4
                ],
                [
                    $4018f80f5dcc51a0$var$RUST_USE_REGEX,
                    3
                ],
                [
                    $4018f80f5dcc51a0$var$RUST_STRUCT_REGEX,
                    3
                ]
            ])
        },
        {
            language: 'shell',
            score: $4018f80f5dcc51a0$var$scorePatterns(code, [
                [
                    $4018f80f5dcc51a0$var$SHELL_SHEBANG_REGEX,
                    6
                ],
                [
                    $4018f80f5dcc51a0$var$SHELL_CONTROL_REGEX,
                    4
                ],
                [
                    $4018f80f5dcc51a0$var$SHELL_FI_DONE_REGEX,
                    3
                ],
                [
                    $4018f80f5dcc51a0$var$SHELL_COMMAND_REGEX,
                    3
                ],
                [
                    $4018f80f5dcc51a0$var$SHELL_VAR_REGEX,
                    2
                ]
            ])
        }
    ];
const $4018f80f5dcc51a0$export$ae9ea24a1b29b07c = (code)=>{
    const trimmedCode = code.trim();
    if (trimmedCode.length < 8) return null;
    const codeForDetection = trimmedCode.slice(0, $4018f80f5dcc51a0$var$MAX_DETECTION_CHARS);
    const [best, secondBest] = $4018f80f5dcc51a0$var$getLanguageScores(codeForDetection).filter(({ score: score })=>score > 0).sort((a, b)=>b.score - a.score);
    if (!best || best.score < $4018f80f5dcc51a0$var$MIN_DETECTION_SCORE) return null;
    if (secondBest && best.score - secondBest.score < $4018f80f5dcc51a0$var$MIN_SCORE_GAP) return null;
    return best.language;
};

});



parcelRegister("5vOos", function(module, exports) {
$parcel$export(module.exports, "codeBlockAutoFullStopTransformPlugin", () => $d23d15b46c805868$export$67e82b3aa944d041);

var $jxkn6 = parcelRequire("jxkn6");

var $f7Kk4 = parcelRequire("f7Kk4");

var $e1fCY = parcelRequire("e1fCY");

var $cw0wu = parcelRequire("cw0wu");

var $gdUUy = parcelRequire("gdUUy");
const $d23d15b46c805868$export$6114c8149cd0d98e = new (0, $cw0wu.PluginKey)('codeBlockAutoFullStopTransformPluginKey');
function $d23d15b46c805868$export$67e82b3aa944d041() {
    return new (0, $f7Kk4.SafePlugin)({
        key: $d23d15b46c805868$export$6114c8149cd0d98e,
        appendTransaction (_transactions, oldState, newState) {
            if (!(0, $gdUUy.fg)('code_block_auto_insertion_bug_fix')) return undefined;
            // We need to compare the old and new state to isloate auto insertion of fullstop on mac
            const { tr: trNew } = newState;
            const { tr: trOld } = oldState;
            const { from: fromOld } = trOld.selection;
            const { from: fromNew, to: toNew } = trNew.selection;
            const isCodeBlock = !!(0, $e1fCY.findCodeBlock)(oldState, trOld.selection) && !!(0, $e1fCY.findCodeBlock)(newState, trNew.selection);
            const browser = (0, $jxkn6.getBrowserInfo)();
            /**
       * Mac will auto insert a fullstop when the user double taps the space key after some content.
       * Line number decorators are assumed content so on new lines the fullstop is inserted.
       *
       * - When a fulltop is auto inserted the new states selection is the same, the old state selection is one position less
       * - The text returned for the old state returns as a space with the selection from - 1
       * - The text returned for the new state returns as a fullstop with the selection from - 2 to from -1
       *
       * This is enough conditional logic to isoloate the auto insertion of the fullstop on mac
       *
       * There are some solutions to this problem in codemirror which can be read further here
       * https://discuss.codemirror.net/t/dot-being-added-when-pressing-space-repeatedly/3899
       */ // both selections must be of code block early exit
            if (browser.mac && fromNew === toNew && fromNew === fromOld + 1 && isCodeBlock) // detect when '.' is inserted when the previous state was a space ' '
            try {
                const textBetweenBefore = trOld.doc.textBetween(fromOld - 1, fromOld); // ' '
                const textBetweenAfter = trNew.doc.textBetween(fromNew - 2, fromNew - 1); // '.'
                if (textBetweenBefore === ' ' && textBetweenAfter === '.') {
                    trNew.delete(fromNew - 2, fromNew); // remove the fullstop
                    trNew.insertText('  ', fromNew - 2); // insert double space
                    return trNew;
                }
            } catch (error) {
                // if for some reason textBetween fails, just return the new transaction as is by defaut.
                return undefined;
            }
            return undefined;
        }
    });
}

});

parcelRegister("2SVXT", function(module, exports) {
$parcel$export(module.exports, "default", () => $6f977316db83c501$export$2e2bcd8739ae039);

var $f7Kk4 = parcelRequire("f7Kk4");

var $cSk7K = parcelRequire("cSk7K");

var $ejrfk = parcelRequire("ejrfk");

var $cw0wu = parcelRequire("cw0wu");

var $gab48 = parcelRequire("gab48");

var $6ojGI = parcelRequire("6ojGI");

var $3cbjY = parcelRequire("3cbjY");

var $lfv8W = parcelRequire("lfv8W");

var $eU2U7 = parcelRequire("eU2U7");

var $dtuRz = parcelRequire("dtuRz");

var $2RMFZ = parcelRequire("2RMFZ");
const $6f977316db83c501$var$ideUX = (pluginInjectionApi)=>{
    var _pluginInjectionApi$a;
    const editorAnalyticsAPI = pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$a = pluginInjectionApi.analytics) === null || _pluginInjectionApi$a === void 0 ? void 0 : _pluginInjectionApi$a.actions;
    return new (0, $f7Kk4.SafePlugin)({
        props: {
            handleTextInput (view, from, to, text) {
                var _pluginInjectionApi$c;
                const { state: state, dispatch: dispatch } = view;
                const compositionPluginState = pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$c = pluginInjectionApi.composition) === null || _pluginInjectionApi$c === void 0 ? void 0 : _pluginInjectionApi$c.sharedState.currentState();
                if ((0, $lfv8W.isCursorInsideCodeBlock)(state) && !(compositionPluginState !== null && compositionPluginState !== void 0 && compositionPluginState.isComposing)) {
                    const beforeText = (0, $lfv8W.getStartOfCurrentLine)(state).text;
                    const afterText = (0, $lfv8W.getEndOfCurrentLine)(state).text;
                    // If text is a closing bracket/quote and we've already inserted it, move the selection after
                    if ((0, $eU2U7.isCursorBeforeClosingCharacter)(afterText) && (0, $eU2U7.isClosingCharacter)(text) && afterText.startsWith(text)) {
                        dispatch((0, $gab48.setTextSelection)(to + text.length)(state.tr));
                        return true;
                    }
                    // Automatically add right-hand side bracket when user types the left bracket
                    if ((0, $6ojGI.shouldAutoCloseBracket)(beforeText, afterText)) {
                        const { left: left, right: right } = (0, $6ojGI.getAutoClosingBracketInfo)(beforeText + text, afterText);
                        if (left && right) {
                            const bracketPair = state.schema.text(text + right);
                            const tr = state.tr.replaceWith(from, to, bracketPair);
                            dispatch((0, $gab48.setTextSelection)(from + text.length)(tr));
                            return true;
                        }
                    }
                    // Automatically add closing quote when user types a starting quote
                    if ((0, $dtuRz.shouldAutoCloseQuote)(beforeText, afterText)) {
                        const { left: leftQuote, right: rightQuote } = (0, $dtuRz.getAutoClosingQuoteInfo)(beforeText + text, afterText);
                        if (leftQuote && rightQuote) {
                            const quotePair = state.schema.text(text + rightQuote);
                            const tr = state.tr.replaceWith(from, to, quotePair);
                            dispatch((0, $gab48.setTextSelection)(from + text.length)(tr));
                            return true;
                        }
                    }
                }
                return false;
            },
            handleKeyDown: (0, $ejrfk.keydownHandler)({
                Backspace: (state, dispatch)=>{
                    if ((0, $lfv8W.isCursorInsideCodeBlock)(state)) {
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        const $cursor = (0, $2RMFZ.getCursor)(state.selection);
                        const beforeText = (0, $lfv8W.getStartOfCurrentLine)(state).text;
                        const afterText = (0, $lfv8W.getEndOfCurrentLine)(state).text;
                        const { left: leftBracket, right: rightBracket, hasTrailingMatchingBracket: hasTrailingMatchingBracket } = (0, $6ojGI.getAutoClosingBracketInfo)(beforeText, afterText);
                        if (leftBracket && rightBracket && hasTrailingMatchingBracket && dispatch) {
                            dispatch(state.tr.delete($cursor.pos - leftBracket.length, $cursor.pos + rightBracket.length));
                            return true;
                        }
                        const { left: leftQuote, right: rightQuote, hasTrailingMatchingQuote: hasTrailingMatchingQuote } = (0, $dtuRz.getAutoClosingQuoteInfo)(beforeText, afterText);
                        if (leftQuote && rightQuote && hasTrailingMatchingQuote && dispatch) {
                            dispatch(state.tr.delete($cursor.pos - leftQuote.length, $cursor.pos + rightQuote.length));
                            return true;
                        }
                        const { indentToken: { size: size, token: token }, indentText: indentText } = (0, $lfv8W.getLineInfo)(beforeText);
                        if (beforeText === indentText) {
                            if (indentText.endsWith(token.repeat(size)) && dispatch) {
                                dispatch(state.tr.delete($cursor.pos - (size - indentText.length % size || size), $cursor.pos));
                                return true;
                            }
                        }
                    }
                    return false;
                },
                Enter: (0, $cSk7K.filter)((0, $lfv8W.isSelectionEntirelyInsideCodeBlock), (0, $3cbjY.insertNewlineWithIndent)),
                'Mod-]': (0, $cSk7K.filter)((0, $lfv8W.isSelectionEntirelyInsideCodeBlock), (0, $3cbjY.indent)(editorAnalyticsAPI)),
                'Mod-[': (0, $cSk7K.filter)((0, $lfv8W.isSelectionEntirelyInsideCodeBlock), (0, $3cbjY.outdent)(editorAnalyticsAPI)),
                Tab: (0, $cSk7K.filter)((0, $lfv8W.isSelectionEntirelyInsideCodeBlock), (state, dispatch)=>{
                    if (!dispatch) return false;
                    if ((0, $lfv8W.isCursorInsideCodeBlock)(state)) return (0, $3cbjY.insertIndent)(state, dispatch);
                    return (0, $3cbjY.indent)(editorAnalyticsAPI)(state, dispatch);
                }),
                'Shift-Tab': (0, $cSk7K.filter)((0, $lfv8W.isSelectionEntirelyInsideCodeBlock), (0, $3cbjY.outdent)(editorAnalyticsAPI)),
                'Mod-a': (state, dispatch)=>{
                    if ((0, $lfv8W.isSelectionEntirelyInsideCodeBlock)(state)) {
                        const { $from: $from, $to: $to } = state.selection;
                        const isFullCodeBlockSelection = $from.parentOffset === 0 && $to.parentOffset === $to.parent.nodeSize - 2;
                        if (!isFullCodeBlockSelection && dispatch) {
                            dispatch(state.tr.setSelection((0, $cw0wu.TextSelection).create(state.doc, $from.start(), $to.end())));
                            return true;
                        }
                    }
                    return false;
                }
            })
        }
    });
};
var $6f977316db83c501$export$2e2bcd8739ae039 = $6f977316db83c501$var$ideUX;

});
parcelRegister("6ojGI", function(module, exports) {
$parcel$export(module.exports, "BRACKET_MAP", () => $2acf341f79955cd3$export$94d363c96bda1dd9);
$parcel$export(module.exports, "shouldAutoCloseBracket", () => $2acf341f79955cd3$export$29c04e6b1b08e223);
$parcel$export(module.exports, "getAutoClosingBracketInfo", () => $2acf341f79955cd3$export$a40becce5a71614c);
const $2acf341f79955cd3$export$94d363c96bda1dd9 = {
    '{': '}',
    '[': ']',
    '(': ')'
};
// when directly before a closing bracket
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $2acf341f79955cd3$var$CLOSING_BRACKET_REGEX = /^[}\])]/;
// exclusion: when directly before a non-whitespace character
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $2acf341f79955cd3$var$NON_WHITESPACE_AFTER_REGEX = /^[^\s]/;
const $2acf341f79955cd3$export$29c04e6b1b08e223 = (before, after)=>{
    // when directly before a closing bracket
    if ($2acf341f79955cd3$var$CLOSING_BRACKET_REGEX.test(after)) return true;
    // exclusion: when directly before a non-whitespace character
    if ($2acf341f79955cd3$var$NON_WHITESPACE_AFTER_REGEX.test(after)) return false;
    return true;
};
const $2acf341f79955cd3$export$a40becce5a71614c = (before, after)=>{
    const left = Object.keys($2acf341f79955cd3$export$94d363c96bda1dd9).find((item)=>before.endsWith(item));
    const right = left ? $2acf341f79955cd3$export$94d363c96bda1dd9[left] : undefined;
    const hasTrailingMatchingBracket = right ? after.startsWith(right) : false;
    return {
        left: left,
        right: right,
        hasTrailingMatchingBracket: hasTrailingMatchingBracket
    };
};

});

parcelRegister("3cbjY", function(module, exports) {
$parcel$export(module.exports, "indent", () => $31240f103a2e31f9$export$79ebfa808dffa5c6);
$parcel$export(module.exports, "outdent", () => $31240f103a2e31f9$export$25755c0352544598);
$parcel$export(module.exports, "insertIndent", () => $31240f103a2e31f9$export$ba3935b326bda6a5);
$parcel$export(module.exports, "insertNewlineWithIndent", () => $31240f103a2e31f9$export$1b9cc0cafa2b529c);

var $g6Qq4 = parcelRequire("g6Qq4");

var $31L32 = parcelRequire("31L32");

var $cw0wu = parcelRequire("cw0wu");

var $lfv8W = parcelRequire("lfv8W");
/**
 * Return the current indentation level
 * @param indentText - Text in the code block that represent an indentation
 * @param indentSize - Size of the indentation token in a string
 */ function $31240f103a2e31f9$var$getIndentLevel(indentText, indentSize) {
    if (indentSize === 0 || indentText.length === 0) return 0;
    return indentText.length / indentSize;
}
const $31240f103a2e31f9$export$79ebfa808dffa5c6 = (editorAnalyticsAPI)=>(state, dispatch)=>{
        const { text: text, start: start } = (0, $lfv8W.getLinesFromSelection)(state);
        const { tr: tr, selection: selection } = state;
        (0, $lfv8W.forEachLine)(text, (line, offset)=>{
            const { indentText: indentText, indentToken: indentToken } = (0, $lfv8W.getLineInfo)(line);
            const indentLevel = $31240f103a2e31f9$var$getIndentLevel(indentText, indentToken.size);
            const indentToAdd = indentToken.token.repeat(indentToken.size - indentText.length % indentToken.size || indentToken.size);
            tr.insertText(indentToAdd, tr.mapping.map(start + offset, -1));
            editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent({
                action: (0, $g6Qq4.ACTION).FORMATTED,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).TEXT,
                actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).FORMAT_INDENT,
                eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
                attributes: {
                    inputMethod: (0, $g6Qq4.INPUT_METHOD).KEYBOARD,
                    previousIndentationLevel: indentLevel,
                    newIndentLevel: indentLevel + 1,
                    direction: (0, $31L32.INDENT_DIRECTION).INDENT,
                    indentType: (0, $31L32.INDENT_TYPE).CODE_BLOCK
                }
            })(tr);
            if (!selection.empty) tr.setSelection((0, $cw0wu.TextSelection).create(tr.doc, tr.mapping.map(selection.from, -1), tr.selection.to));
        });
        if (dispatch) dispatch(tr);
        return true;
    };
const $31240f103a2e31f9$export$25755c0352544598 = (editorAnalyticsAPI)=>(state, dispatch)=>{
        const { text: text, start: start } = (0, $lfv8W.getLinesFromSelection)(state);
        const { tr: tr } = state;
        (0, $lfv8W.forEachLine)(text, (line, offset)=>{
            const { indentText: indentText, indentToken: indentToken } = (0, $lfv8W.getLineInfo)(line);
            if (indentText) {
                const indentLevel = $31240f103a2e31f9$var$getIndentLevel(indentText, indentToken.size);
                const unindentLength = indentText.length % indentToken.size || indentToken.size;
                tr.delete(tr.mapping.map(start + offset), tr.mapping.map(start + offset + unindentLength));
                editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent({
                    action: (0, $g6Qq4.ACTION).FORMATTED,
                    actionSubject: (0, $g6Qq4.ACTION_SUBJECT).TEXT,
                    actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).FORMAT_INDENT,
                    eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
                    attributes: {
                        inputMethod: (0, $g6Qq4.INPUT_METHOD).KEYBOARD,
                        previousIndentationLevel: indentLevel,
                        newIndentLevel: indentLevel - 1,
                        direction: (0, $31L32.INDENT_DIRECTION).OUTDENT,
                        indentType: (0, $31L32.INDENT_TYPE).CODE_BLOCK
                    }
                })(tr);
            }
        });
        if (dispatch) dispatch(tr);
        return true;
    };
function $31240f103a2e31f9$export$ba3935b326bda6a5(state, dispatch) {
    const { text: textAtStartOfLine } = (0, $lfv8W.getStartOfCurrentLine)(state);
    const { indentToken: indentToken } = (0, $lfv8W.getLineInfo)(textAtStartOfLine);
    const indentToAdd = indentToken.token.repeat(indentToken.size - textAtStartOfLine.length % indentToken.size || indentToken.size);
    dispatch(state.tr.insertText(indentToAdd));
    return true;
}
function $31240f103a2e31f9$export$1b9cc0cafa2b529c(state, dispatch) {
    const { text: textAtStartOfLine } = (0, $lfv8W.getStartOfCurrentLine)(state);
    const { indentText: indentText } = (0, $lfv8W.getLineInfo)(textAtStartOfLine);
    if (indentText && dispatch) {
        dispatch(state.tr.insertText('\n' + indentText));
        return true;
    }
    return false;
}

});
parcelRegister("lfv8W", function(module, exports) {
$parcel$export(module.exports, "isSelectionEntirelyInsideCodeBlock", () => $abac2081a98e0725$export$b54b55a89e362241);
$parcel$export(module.exports, "isCursorInsideCodeBlock", () => $abac2081a98e0725$export$cecd33f3def3e129);
$parcel$export(module.exports, "getStartOfCurrentLine", () => $abac2081a98e0725$export$13a3ef35664ba7de);
$parcel$export(module.exports, "getEndOfCurrentLine", () => $abac2081a98e0725$export$8291149050336443);
$parcel$export(module.exports, "getLinesFromSelection", () => $abac2081a98e0725$export$64ccdebd7526708f);
$parcel$export(module.exports, "forEachLine", () => $abac2081a98e0725$export$7f5b487b51da88d0);
$parcel$export(module.exports, "getLineInfo", () => $abac2081a98e0725$export$7af82191547c5ff7);

var $2RMFZ = parcelRequire("2RMFZ");
const $abac2081a98e0725$export$b54b55a89e362241 = (state)=>state.selection.$from.sameParent(state.selection.$to) && state.selection.$from.parent.type === state.schema.nodes.codeBlock;
const $abac2081a98e0725$export$cecd33f3def3e129 = (state)=>!!(0, $2RMFZ.getCursor)(state.selection) && $abac2081a98e0725$export$b54b55a89e362241(state);
const $abac2081a98e0725$export$13a3ef35664ba7de = (state)=>{
    const { $from: $from } = state.selection;
    if ($from.nodeBefore && $from.nodeBefore.isText) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const prevNewLineIndex = $from.nodeBefore.text.lastIndexOf('\n');
        return {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            text: $from.nodeBefore.text.substring(prevNewLineIndex + 1),
            pos: $from.start() + prevNewLineIndex + 1
        };
    }
    return {
        text: '',
        pos: $from.pos
    };
};
const $abac2081a98e0725$export$8291149050336443 = (state)=>{
    const { $to: $to } = state.selection;
    if ($to.nodeAfter && $to.nodeAfter.isText) {
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const nextNewLineIndex = $to.nodeAfter.text.indexOf('\n');
        return {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            text: $to.nodeAfter.text.substring(0, nextNewLineIndex >= 0 ? nextNewLineIndex : undefined),
            pos: nextNewLineIndex >= 0 ? $to.pos + nextNewLineIndex : $to.end()
        };
    }
    return {
        text: '',
        pos: $to.pos
    };
};
function $abac2081a98e0725$export$64ccdebd7526708f(state) {
    const { pos: start } = $abac2081a98e0725$export$13a3ef35664ba7de(state);
    const { pos: end } = $abac2081a98e0725$export$8291149050336443(state);
    const text = state.doc.textBetween(start, end);
    return {
        text: text,
        start: start,
        end: end
    };
}
const $abac2081a98e0725$export$7f5b487b51da88d0 = (text, callback)=>{
    let offset = 0;
    text.split('\n').forEach((line)=>{
        callback(line, offset);
        offset += line.length + 1;
    });
};
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $abac2081a98e0725$var$SPACE = {
    token: ' ',
    size: 2,
    regex: /[^ ]/
};
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $abac2081a98e0725$var$TAB = {
    token: '\t',
    size: 1,
    regex: /[^\t]/
};
const $abac2081a98e0725$export$7af82191547c5ff7 = (line)=>{
    const indentToken = line.startsWith('\t') ? $abac2081a98e0725$var$TAB : $abac2081a98e0725$var$SPACE;
    const indentLength = line.search(indentToken.regex);
    const indentText = line.substring(0, indentLength >= 0 ? indentLength : line.length);
    return {
        indentToken: indentToken,
        indentText: indentText
    };
};

});


parcelRegister("eU2U7", function(module, exports) {
$parcel$export(module.exports, "isCursorBeforeClosingCharacter", () => $ae671d05a42bc0c2$export$1d6d73d16dcadbdd);
$parcel$export(module.exports, "isClosingCharacter", () => $ae671d05a42bc0c2$export$ea0560eb552fb0a7);

var $6ojGI = parcelRequire("6ojGI");

var $dtuRz = parcelRequire("dtuRz");
const $ae671d05a42bc0c2$var$PAIRED_CHARACTER_MAP = {
    ...(0, $6ojGI.BRACKET_MAP),
    ...(0, $dtuRz.QUOTE_MAP)
};
const $ae671d05a42bc0c2$export$1d6d73d16dcadbdd = (after)=>{
    return Object.keys($ae671d05a42bc0c2$var$PAIRED_CHARACTER_MAP).some((leftCharacter)=>after.startsWith($ae671d05a42bc0c2$var$PAIRED_CHARACTER_MAP[leftCharacter]));
};
const $ae671d05a42bc0c2$export$ea0560eb552fb0a7 = (text)=>{
    return Object.keys($ae671d05a42bc0c2$var$PAIRED_CHARACTER_MAP).some((leftCharacter)=>text === $ae671d05a42bc0c2$var$PAIRED_CHARACTER_MAP[leftCharacter]);
};

});
parcelRegister("dtuRz", function(module, exports) {
$parcel$export(module.exports, "QUOTE_MAP", () => $2dcbe5cdda7b4106$export$bb64b01afeb72d0a);
$parcel$export(module.exports, "shouldAutoCloseQuote", () => $2dcbe5cdda7b4106$export$42f0a0996a9a464d);
$parcel$export(module.exports, "getAutoClosingQuoteInfo", () => $2dcbe5cdda7b4106$export$6af564d7e42f37e8);
const $2dcbe5cdda7b4106$export$bb64b01afeb72d0a = {
    "'": "'",
    '"': '"',
    '`': '`'
};
// when directly before a closing bracket
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $2dcbe5cdda7b4106$var$CLOSING_BRACKET_REGEX = /^[}\])]/;
// exclusion: when directly before a non-whitespace character
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $2dcbe5cdda7b4106$var$NON_WHITESPACE_AFTER_REGEX = /^[^\s]/;
// exclusion: when directly after a letter or quote
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $2dcbe5cdda7b4106$var$ALPHANUMERIC_END_REGEX = /[A-Za-z0-9]$/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $2dcbe5cdda7b4106$var$QUOTE_END_REGEX = /[\'\"\'`]$/;
const $2dcbe5cdda7b4106$export$42f0a0996a9a464d = (before, after)=>{
    // when directly before a closing bracket
    if ($2dcbe5cdda7b4106$var$CLOSING_BRACKET_REGEX.test(after)) return true;
    // exclusion: when directly before a non-whitespace character
    if ($2dcbe5cdda7b4106$var$NON_WHITESPACE_AFTER_REGEX.test(after)) return false;
    // exclusion: when directly after a letter or quote
    if ($2dcbe5cdda7b4106$var$ALPHANUMERIC_END_REGEX.test(before) || $2dcbe5cdda7b4106$var$QUOTE_END_REGEX.test(before)) return false;
    return true;
};
const $2dcbe5cdda7b4106$export$6af564d7e42f37e8 = (before, after)=>{
    const left = Object.keys($2dcbe5cdda7b4106$export$bb64b01afeb72d0a).find((item)=>before.endsWith(item));
    const right = left ? $2dcbe5cdda7b4106$export$bb64b01afeb72d0a[left] : undefined;
    const hasTrailingMatchingQuote = right ? after.startsWith(right) : false;
    return {
        left: left,
        right: right,
        hasTrailingMatchingQuote: hasTrailingMatchingQuote
    };
};

});



parcelRegister("hCeAe", function(module, exports) {
$parcel$export(module.exports, "createCodeBlockInputRule", () => $e8c6a844bbe38b2c$export$bdcd7d8080bcac7f);

var $g6Qq4 = parcelRequire("g6Qq4");

var $3J3tU = parcelRequire("3J3tU");

var $lMfrv = parcelRequire("lMfrv");

var $f7Kk4 = parcelRequire("f7Kk4");

var $33v8M = parcelRequire("33v8M");

var $hfNS8 = parcelRequire("hfNS8");

var $gab48 = parcelRequire("gab48");

var $b9BdF = parcelRequire("b9BdF");

var $8t09p = parcelRequire("8t09p");

var $b94mh = parcelRequire("b94mh");
// eslint-disable-next-line require-unicode-regexp
const $e8c6a844bbe38b2c$var$THREE_TILDE_RULE_REGEX = /(?!\s)(`{3,})$/;
function $e8c6a844bbe38b2c$export$bdcd7d8080bcac7f(schema, editorAnalyticsAPI) {
    const rules = $e8c6a844bbe38b2c$var$getCodeBlockRules(editorAnalyticsAPI, schema);
    return new (0, $f7Kk4.SafePlugin)((0, $8t09p.createPlugin)('code-block-input-rule', rules, {
        isBlockNodeRule: true
    }));
}
/**
 * Get all code block input rules
 *
 * @param {Schema} schema
 * @returns {InputRuleWithHandler[]}
 */ function $e8c6a844bbe38b2c$var$getCodeBlockRules(editorAnalyticsAPI, schema) {
    const ruleAnalytics = (0, $hfNS8.inputRuleWithAnalytics)({
        action: (0, $g6Qq4.ACTION).INSERTED,
        actionSubject: (0, $g6Qq4.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).CODE_BLOCK,
        attributes: {
            inputMethod: (0, $g6Qq4.INPUT_METHOD).FORMATTING
        },
        eventType: (0, $g6Qq4.EVENT_TYPE).TRACK
    }, editorAnalyticsAPI);
    const validMatchLength = (match)=>match.length > 0 && match[0].length === 3;
    const threeTildeRule = (0, $33v8M.createRule)($e8c6a844bbe38b2c$var$THREE_TILDE_RULE_REGEX, (state, match, start, end)=>{
        if (!validMatchLength(match)) return null;
        const attributes = (0, $3J3tU.getDefaultCodeBlockAttrs)(match[4] ? {
            language: match[4]
        } : {});
        if ((0, $b94mh.isConvertableToCodeBlock)(state)) return (0, $b94mh.transformToCodeBlockAction)(state, start, attributes);
        const tr = state.tr;
        tr.delete(start, end);
        const codeBlock = tr.doc.type.schema.nodes.codeBlock.createChecked(attributes);
        (0, $gab48.safeInsert)(codeBlock)(tr);
        return tr;
    });
    const leftNodeReplacementThreeTildeRule = (0, $33v8M.createRule)(// Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    new RegExp(`((${(0, $b9BdF.leafNodeReplacementCharacter)}\`{3,})|^\\s(\`{3,}))(\\S*)$`), (state, match, start, end)=>{
        if (!validMatchLength(match)) return null;
        const attributes = (0, $3J3tU.getDefaultCodeBlockAttrs)(match[4] ? {
            language: match[4]
        } : {});
        const inlineStart = Math.max(match.index + state.selection.$from.start(), 1);
        return (0, $lMfrv.insertBlock)(state, schema.nodes.codeBlock, inlineStart, end, attributes);
    });
    return [
        ruleAnalytics(threeTildeRule),
        ruleAnalytics(leftNodeReplacementThreeTildeRule)
    ];
}

});

parcelRegister("kZXn7", function(module, exports) {
$parcel$export(module.exports, "default", () => $99fcbb9e3c2da0be$export$2e2bcd8739ae039);

var $56AB9 = parcelRequire("56AB9");

var $ejrfk = parcelRequire("ejrfk");

var $cw0wu = parcelRequire("cw0wu");

var $gab48 = parcelRequire("gab48");

var $2RMFZ = parcelRequire("2RMFZ");
const $99fcbb9e3c2da0be$var$deleteCurrentItem = ($from)=>(tr)=>{
        return tr.delete($from.before($from.depth), $from.after($from.depth));
    };
const $99fcbb9e3c2da0be$var$setTextSelection = (pos)=>(tr)=>{
        const newSelection = (0, $cw0wu.Selection).findFrom(tr.doc.resolve(pos), -1, true);
        if (newSelection) tr.setSelection(newSelection);
        return tr;
    };
function $99fcbb9e3c2da0be$export$e832373cff8dec22(schema) {
    return (0, $ejrfk.keymap)({
        Backspace: (state, dispatch)=>{
            const $cursor = (0, $2RMFZ.getCursor)(state.selection);
            const { codeBlock: codeBlock, listItem: listItem, table: table, layoutColumn: layoutColumn, paragraph: paragraph } = state.schema.nodes;
            if (!$cursor || $cursor.parent.type !== codeBlock || !dispatch) return false;
            if ($cursor.pos === 1 || (0, $gab48.hasParentNodeOfType)(listItem)(state.selection) && $cursor.parentOffset === 0) {
                const node = (0, $gab48.findParentNodeOfTypeClosestToPos)($cursor, codeBlock);
                if (!node) return false;
                dispatch(state.tr.setNodeMarkup(node.pos, node.node.type, node.node.attrs, []).setBlockType($cursor.pos, $cursor.pos, paragraph));
                return true;
            }
            if ($cursor.node && (0, $56AB9.isEmptyNode)(schema)($cursor.node()) && ((0, $gab48.hasParentNodeOfType)(layoutColumn)(state.selection) || (0, $gab48.hasParentNodeOfType)(table)(state.selection))) {
                const { tr: tr } = state;
                const insertPos = $cursor.pos;
                $99fcbb9e3c2da0be$var$deleteCurrentItem($cursor)(tr);
                $99fcbb9e3c2da0be$var$setTextSelection(insertPos)(tr);
                dispatch(tr.scrollIntoView());
                return true;
            }
            // Handle not nested empty code block
            if ((0, $56AB9.isEmptyNode)(schema)($cursor.node())) {
                dispatch($99fcbb9e3c2da0be$var$deleteCurrentItem($cursor)(state === null || state === void 0 ? void 0 : state.tr));
                return true;
            }
            return false;
        }
    });
}
var $99fcbb9e3c2da0be$export$2e2bcd8739ae039 = $99fcbb9e3c2da0be$export$e832373cff8dec22;

});

parcelRegister("jtzZt", function(module, exports) {
$parcel$export(module.exports, "createPlugin", () => $c5b2c357ccf74c14$export$ae829ec7b2625219);

var $jxkn6 = parcelRequire("jxkn6");

var $3J3tU = parcelRequire("3J3tU");

var $8iYGb = parcelRequire("8iYGb");

var $f7Kk4 = parcelRequire("f7Kk4");

var $8KAjj = parcelRequire("8KAjj");

var $e1fCY = parcelRequire("e1fCY");

var $cw0wu = parcelRequire("cw0wu");

var $a3b9P = parcelRequire("a3b9P");

var $4zjoa = parcelRequire("4zjoa");

var $kdxmD = parcelRequire("kdxmD");

var $ddtHI = parcelRequire("ddtHI");

var $5OHXV = parcelRequire("5OHXV");

var $eoCdc = parcelRequire("eoCdc");

var $cbzce = parcelRequire("cbzce");

var $3Iips = parcelRequire("3Iips");

var $1LuwP = parcelRequire("1LuwP");

var $2RMFZ = parcelRequire("2RMFZ");
const $c5b2c357ccf74c14$export$ae829ec7b2625219 = ({ useLongPressSelection: useLongPressSelection = false, getIntl: getIntl, allowCompositionInputOverride: allowCompositionInputOverride = false, api: api })=>{
    const handleDOMEvents = {
        click: ()=>{
            var _api$core, _api$interaction;
            // Set hasHadInteraction to true on any click of code blocks, as clicks
            // on code blocks to not propagate to editor-level click handlers
            api === null || api === void 0 || (_api$core = api.core) === null || _api$core === void 0 || _api$core.actions.execute(api === null || api === void 0 || (_api$interaction = api.interaction) === null || _api$interaction === void 0 ? void 0 : _api$interaction.commands.handleInteraction);
        }
    };
    // ME-1599: Composition on mobile was causing the DOM observer to mutate the code block
    // incorrecly and lose content when pressing enter in the middle of a code block line.
    if (allowCompositionInputOverride) handleDOMEvents.beforeinput = (view, event)=>{
        const keyEvent = event;
        const eventInputType = keyEvent.inputType;
        const eventText = keyEvent.data;
        const browser = (0, $jxkn6.getBrowserInfo)();
        if (browser.ios && event.composed && // insertParagraph will be the input type when the enter key is pressed.
        eventInputType === 'insertParagraph' && (0, $e1fCY.findCodeBlock)(view.state, view.state.selection)) {
            event.preventDefault();
            return true;
        } else if (browser.android && event.composed && eventInputType === 'insertCompositionText' && eventText[(eventText === null || eventText === void 0 ? void 0 : eventText.length) - 1] === '\n' && (0, $e1fCY.findCodeBlock)(view.state, view.state.selection)) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const resultingText = event.target.outerText + '\n';
            if (resultingText.endsWith(eventText)) // End of paragraph
            setTimeout(()=>{
                view.someProp('handleKeyDown', (f)=>f(view, new KeyboardEvent('keydown', {
                        bubbles: true,
                        cancelable: true,
                        key: 'Enter',
                        code: 'Enter'
                    })));
            }, 0);
            else // Middle of paragraph, end of line
            (0, $kdxmD.ignoreFollowingMutations)(view.state, view.dispatch);
            return true;
        }
        if (browser.android) (0, $kdxmD.resetShouldIgnoreFollowingMutations)(view.state, view.dispatch);
        return false;
    };
    return new (0, $f7Kk4.SafePlugin)({
        state: {
            init (_, state) {
                const node = (0, $e1fCY.findCodeBlock)(state, state.selection);
                const initialDecorations = // Disabled when using advanced code block advanced since it interfers with styling
                // Long term we will deprecate the code block plugin and move all the related logic to
                // the advanced plugin
                // @ts-expect-error Code block advanced cannot depend on code block
                (api === null || api === void 0 ? void 0 : api.codeBlockAdvanced) !== undefined ? [] : (0, $3Iips.generateInitialDecorations)(state);
                return {
                    pos: node ? node.pos : null,
                    contentCopied: false,
                    formatCodeErrors: {},
                    isNodeSelected: false,
                    pendingFormats: {},
                    shouldIgnoreFollowingMutations: false,
                    decorations: (0, $a3b9P.DecorationSet).create(state.doc, initialDecorations)
                };
            },
            apply (tr, pluginState, _oldState, newState) {
                const meta = tr.getMeta((0, $1LuwP.pluginKey));
                if ((meta === null || meta === void 0 ? void 0 : meta.type) === (0, $cbzce.ACTIONS).SET_IS_WRAPPED) {
                    const node = (0, $e1fCY.findCodeBlock)(newState, tr.selection);
                    return {
                        ...pluginState,
                        decorations: (0, $3Iips.updateDecorationSetWithWordWrappedDecorator)(pluginState.decorations, tr, node)
                    };
                }
                if (tr.docChanged) {
                    const node = (0, $e1fCY.findCodeBlock)(newState, tr.selection);
                    const codeBlockNodes = (0, $2RMFZ.getAllChangedCodeBlocksInTransaction)(tr);
                    // Updates mapping position of all existing decorations to new positions
                    // specifically used for updating word wrap node decorators (does not cover drag & drop, validateWordWrappedDecorators does).
                    let updatedDecorationSet = pluginState.decorations.map(tr.mapping, tr.doc);
                    if (codeBlockNodes.length) {
                        (0, $3J3tU.updateCodeBlockWrappedStateNodeKeys)(codeBlockNodes, _oldState);
                        // Disabled when using advanced code block for performance reasons
                        // @ts-expect-error Code block advanced cannot depend on code block
                        if ((api === null || api === void 0 ? void 0 : api.codeBlockAdvanced) === undefined) updatedDecorationSet = (0, $3Iips.updateCodeBlockDecorations)(tr, codeBlockNodes, updatedDecorationSet);
                    }
                    const newPluginState = {
                        ...pluginState,
                        pos: node ? node.pos : null,
                        isNodeSelected: tr.selection instanceof (0, $cw0wu.NodeSelection),
                        decorations: updatedDecorationSet
                    };
                    if (!(0, $4zjoa.expValEqualsNoExposure)('platform_editor_code_block_q4_lovability', 'isEnabled', true)) return newPluginState;
                    // Successful format results change the doc and carry format meta.
                    const formatCodePluginState = (0, $eoCdc.applyFormatCodeMeta)(newPluginState, meta);
                    return {
                        ...formatCodePluginState,
                        // Pending format requests can outlive unrelated document edits.
                        pendingFormats: (0, $eoCdc.mapPendingFormats)(formatCodePluginState.pendingFormats, tr, newState)
                    };
                }
                if (tr.selectionSet) {
                    const node = (0, $e1fCY.findCodeBlock)(newState, tr.selection);
                    const newPluginState = {
                        ...pluginState,
                        pos: node ? node.pos : null,
                        isNodeSelected: tr.selection instanceof (0, $cw0wu.NodeSelection)
                    };
                    return newPluginState;
                }
                if ((meta === null || meta === void 0 ? void 0 : meta.type) === (0, $cbzce.ACTIONS).SET_COPIED_TO_CLIPBOARD) return {
                    ...pluginState,
                    contentCopied: meta.data
                };
                else if ((meta === null || meta === void 0 ? void 0 : meta.type) === (0, $cbzce.ACTIONS).SET_SHOULD_IGNORE_FOLLOWING_MUTATIONS) return {
                    ...pluginState,
                    shouldIgnoreFollowingMutations: meta.data
                };
                if ((0, $4zjoa.expValEqualsNoExposure)('platform_editor_code_block_q4_lovability', 'isEnabled', true)) // Failed/unchanged format results and dismissals are meta-only.
                return (0, $eoCdc.applyFormatCodeMeta)(pluginState, meta);
                return pluginState;
            }
        },
        key: (0, $1LuwP.pluginKey),
        props: {
            decorations (state) {
                return (0, $1LuwP.pluginKey).getState(state).decorations || (0, $a3b9P.DecorationSet).empty;
            },
            nodeViews: {
                codeBlock: (node, view, getPos)=>{
                    const { formatMessage: formatMessage } = getIntl();
                    const formattedAriaLabel = formatMessage((0, $8iYGb.messages).codeblock);
                    return (0, $ddtHI.codeBlockNodeView)(node, view, getPos, formattedAriaLabel, api);
                }
            },
            handleClickOn: (0, $8KAjj.createSelectionClickHandler)([
                'codeBlock'
            ], (target)=>!!(target.classList.contains((0, $5OHXV.codeBlockClassNames).lineNumberWidget) || target.classList.contains((0, $5OHXV.codeBlockClassNames).gutter)), {
                useLongPressSelection: useLongPressSelection
            }),
            handleDOMEvents: handleDOMEvents
        }
    });
};

});
parcelRegister("ddtHI", function(module, exports) {
$parcel$export(module.exports, "codeBlockNodeView", () => $0c6a4133036f034f$export$9ea0022afafc61b7);

var $jxkn6 = parcelRequire("jxkn6");

var $3J3tU = parcelRequire("3J3tU");

var $kW8qW = parcelRequire("kW8qW");

var $gdUUy = parcelRequire("gdUUy");

var $kdxmD = parcelRequire("kdxmD");

var $c0w0t = parcelRequire("c0w0t");

var $5OHXV = parcelRequire("5OHXV");
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $0c6a4133036f034f$var$MATCH_NEWLINES = new RegExp('\n', 'g');
const $0c6a4133036f034f$var$toDOM = (node, contentEditable, formattedAriaLabel)=>[
        'div',
        {
            class: (0, $5OHXV.codeBlockClassNames).container
        },
        [
            'div',
            {
                class: (0, $5OHXV.codeBlockClassNames).start,
                contenteditable: 'false'
            }
        ],
        [
            'div',
            {
                class: (0, $5OHXV.codeBlockClassNames).contentWrapper
            },
            [
                'div',
                {
                    class: (0, $5OHXV.codeBlockClassNames).gutter,
                    contenteditable: 'false'
                }
            ],
            [
                'div',
                {
                    class: (0, $5OHXV.codeBlockClassNames).content
                },
                [
                    'code',
                    {
                        'data-language': node.attrs.language || '',
                        spellcheck: 'false',
                        contenteditable: contentEditable ? 'true' : 'false',
                        'data-testid': 'code-block--code',
                        'aria-label': formattedAriaLabel,
                        ...(0, $gdUUy.fg)('platform_editor_adf_with_localid') && {
                            'data-local-id': node.attrs.localId
                        }
                    },
                    0
                ]
            ]
        ],
        [
            'div',
            {
                class: (0, $5OHXV.codeBlockClassNames).end,
                contenteditable: 'false'
            }
        ]
    ];
class $0c6a4133036f034f$export$84ecc4258da6ad44 {
    constructor(node, view, getPos, formattedAriaLabel, api, cleanupEditorDisabledListener){
        this.cleanupEditorDisabledListener = cleanupEditorDisabledListener;
        this.formattedAriaLabel = '';
        /**
   * As the code block updates we get the maximum amount of digits in a line number and expand the number gutter to reflect this.
   */ this.maintainDynamicGutterSize = ()=>{
            let totalLineCount = 1;
            this.node.forEach((node)=>{
                const text = node.text;
                if (text) // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                totalLineCount += (node.text.match($0c6a4133036f034f$var$MATCH_NEWLINES) || []).length;
            });
            const maxDigits = totalLineCount.toString().length;
            this.dom.style.setProperty('--lineNumberGutterWidth', `${maxDigits}ch`);
        };
        var _api$editorDisabled;
        const { dom: dom, contentDOM: contentDOM } = (0, $kW8qW.DOMSerializer).renderSpec(document, $0c6a4133036f034f$var$toDOM(node, !(api !== null && api !== void 0 && (_api$editorDisabled = api.editorDisabled) !== null && _api$editorDisabled !== void 0 && (_api$editorDisabled = _api$editorDisabled.sharedState.currentState()) !== null && _api$editorDisabled !== void 0 && _api$editorDisabled.editorDisabled), formattedAriaLabel));
        this.getPos = getPos;
        this.view = view;
        this.node = node;
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.dom = dom;
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.contentDOM = contentDOM;
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        this.lineNumberGutter = this.dom.querySelector(`.${(0, $5OHXV.codeBlockClassNames).gutter}`);
        this.api = api;
        this.maintainDynamicGutterSize();
        // Ensure the code block node has a wrapped state.
        // Wrapped state may already exist from breakout's recreating the node.
        if (!(0, $3J3tU.codeBlockWrappedStates).has(node)) (0, $3J3tU.codeBlockWrappedStates).set(node, (0, $3J3tU.defaultWordWrapState));
        this.handleEditorDisabledChanged();
    }
    handleEditorDisabledChanged() {
        var _this$api;
        if ((_this$api = this.api) !== null && _this$api !== void 0 && _this$api.editorDisabled) this.cleanupEditorDisabledListener = this.api.editorDisabled.sharedState.onChange((sharedState)=>{
            if (this.contentDOM) this.contentDOM.setAttribute('contenteditable', sharedState.nextSharedState.editorDisabled ? 'false' : 'true');
        });
    }
    updateDOMAndSelection(savedInnerHTML, newCursorPosition) {
        var _this$dom;
        if ((_this$dom = this.dom) !== null && _this$dom !== void 0 && _this$dom.childNodes && this.dom.childNodes.length > 1) {
            var _contentView$childNod;
            const contentWrapper = this.dom.childNodes[1];
            const contentView = contentWrapper === null || contentWrapper === void 0 ? void 0 : contentWrapper.childNodes[1];
            if ((contentView === null || contentView === void 0 || (_contentView$childNod = contentView.childNodes) === null || _contentView$childNod === void 0 ? void 0 : _contentView$childNod.length) > 0) {
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const codeElement = contentView.firstChild;
                codeElement.innerHTML = savedInnerHTML;
                // We need to set cursor for the DOM update
                const textElement = Array.from(codeElement.childNodes).find((child)=>child.nodeName === '#text');
                const sel = window.getSelection();
                const range = document.createRange();
                range.setStart(textElement, newCursorPosition);
                range.collapse(true);
                sel === null || sel === void 0 || sel.removeAllRanges();
                sel === null || sel === void 0 || sel.addRange(range);
            }
        }
    }
    coalesceDOMElements() {
        var _this$dom2;
        if ((_this$dom2 = this.dom) !== null && _this$dom2 !== void 0 && _this$dom2.childNodes && this.dom.childNodes.length > 1) {
            const contentWrapper = this.dom.childNodes[1];
            const contentView = contentWrapper === null || contentWrapper === void 0 ? void 0 : contentWrapper.childNodes[1];
            if (contentView !== null && contentView !== void 0 && contentView.childNodes && contentView.childNodes.length > 1) {
                let savedInnerHTML = '';
                while(contentView.childNodes.length > 1){
                    // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    const lastChild = contentView.lastChild;
                    savedInnerHTML = lastChild.innerHTML + savedInnerHTML;
                    contentView.removeChild(lastChild);
                }
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const firstChild = contentView.firstChild;
                savedInnerHTML = firstChild.innerHTML + '\n' + savedInnerHTML;
                const newCursorPosition = firstChild.innerHTML.length + 1;
                setTimeout(this.updateDOMAndSelection.bind(this, savedInnerHTML, newCursorPosition), 20);
            }
        }
    }
    update(node) {
        if (node.type !== this.node.type) return false;
        if (node !== this.node) {
            if (node.attrs.language !== this.node.attrs.language) this.contentDOM.setAttribute('data-language', node.attrs.language || '');
            this.node = node;
            this.maintainDynamicGutterSize();
            const browser = (0, $jxkn6.getBrowserInfo)();
            if (browser.android) {
                this.coalesceDOMElements();
                (0, $kdxmD.resetShouldIgnoreFollowingMutations)(this.view.state, this.view.dispatch);
            }
        }
        return true;
    }
    ignoreMutation(record) {
        const pluginState = (0, $c0w0t.getPluginState)(this.view.state);
        if (pluginState !== null && pluginState !== void 0 && pluginState.shouldIgnoreFollowingMutations) return true;
        // Ensure updating the line-number gutter doesn't trigger reparsing the codeblock
        return record.target === this.lineNumberGutter || record.target.parentNode === this.lineNumberGutter;
    }
    destroy() {
        if (this.cleanupEditorDisabledListener) this.cleanupEditorDisabledListener();
        this.cleanupEditorDisabledListener = undefined;
    }
}
const $0c6a4133036f034f$export$9ea0022afafc61b7 = (node, view, getPos, formattedAriaLabel, api)=>new $0c6a4133036f034f$export$84ecc4258da6ad44(node, view, getPos, formattedAriaLabel, api);

});
parcelRegister("c0w0t", function(module, exports) {
$parcel$export(module.exports, "getPluginState", () => $6e96788743cd8e1c$export$f05434c51e3762e);

var $1LuwP = parcelRequire("1LuwP");
const $6e96788743cd8e1c$export$f05434c51e3762e = (state)=>(0, $1LuwP.pluginKey).getState(state);

});

parcelRegister("5OHXV", function(module, exports) {
$parcel$export(module.exports, "codeBlockClassNames", () => $03620f72d035bcd8$export$4ffea7f3ae91d083);

var $1J9lh = parcelRequire("1J9lh");
const $03620f72d035bcd8$export$4ffea7f3ae91d083 = {
    container: (0, $1J9lh.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER,
    start: (0, $1J9lh.CodeBlockSharedCssClassName).CODEBLOCK_START,
    end: (0, $1J9lh.CodeBlockSharedCssClassName).CODEBLOCK_END,
    contentWrapper: (0, $1J9lh.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPER,
    contentWrapped: (0, $1J9lh.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT_WRAPPED,
    gutter: (0, $1J9lh.CodeBlockSharedCssClassName).CODEBLOCK_LINE_NUMBER_GUTTER,
    content: (0, $1J9lh.CodeBlockSharedCssClassName).CODEBLOCK_CONTENT,
    lineNumberWidget: (0, $1J9lh.CodeBlockSharedCssClassName).CODEBLOCK_CONTAINER_LINE_NUMBER_WIDGET
};

});


parcelRegister("eoCdc", function(module, exports) {
$parcel$export(module.exports, "mapPendingFormats", () => $e6180404dc1a02e0$export$bd3710c0a5fb6dad);
$parcel$export(module.exports, "applyFormatCodeMeta", () => $e6180404dc1a02e0$export$6d52e1741d2cdede);

var $cbzce = parcelRequire("cbzce");
const $e6180404dc1a02e0$export$bd3710c0a5fb6dad = (pendingFormats, tr, newState)=>{
    const entries = Object.entries(pendingFormats);
    if (entries.length === 0) return pendingFormats;
    let nextPendingFormats = pendingFormats;
    entries.forEach(([localId, pendingFormat])=>{
        const { deleted: deleted, pos: pos } = tr.mapping.mapResult(pendingFormat.pos, 1);
        const codeBlockNode = newState.doc.nodeAt(pos);
        const shouldRemovePendingFormat = deleted || (codeBlockNode === null || codeBlockNode === void 0 ? void 0 : codeBlockNode.type) !== newState.schema.nodes.codeBlock || (codeBlockNode === null || codeBlockNode === void 0 ? void 0 : codeBlockNode.attrs.localId) !== localId;
        const shouldUpdatePendingFormat = pos !== pendingFormat.pos;
        if (shouldRemovePendingFormat || shouldUpdatePendingFormat) {
            if (nextPendingFormats === pendingFormats) nextPendingFormats = {
                ...pendingFormats
            };
        }
        if (shouldRemovePendingFormat) {
            delete nextPendingFormats[localId];
            return;
        }
        if (shouldUpdatePendingFormat) nextPendingFormats[localId] = {
            ...pendingFormat,
            pos: pos
        };
    });
    return nextPendingFormats;
};
function $e6180404dc1a02e0$var$removeRecordEntry(record, key) {
    const nextRecord = {
        ...record
    };
    delete nextRecord[key];
    return nextRecord;
}
const $e6180404dc1a02e0$export$6d52e1741d2cdede = (pluginState, meta)=>{
    switch(meta === null || meta === void 0 ? void 0 : meta.type){
        case (0, $cbzce.ACTIONS).START_FORMAT_CODE:
            return {
                ...pluginState,
                pendingFormats: {
                    ...pluginState.pendingFormats,
                    [meta.data.localId]: {
                        languageSource: meta.data.languageSource,
                        pos: meta.data.pos,
                        requestId: meta.data.requestId
                    }
                }
            };
        case (0, $cbzce.ACTIONS).RESOLVE_FORMAT_CODE:
            {
                const pendingFormats = $e6180404dc1a02e0$var$removeRecordEntry(pluginState.pendingFormats, meta.data.localId);
                const formatCodeErrors = $e6180404dc1a02e0$var$removeRecordEntry(pluginState.formatCodeErrors, meta.data.localId);
                return {
                    ...pluginState,
                    formatCodeErrors: meta.data.outcome === 'failed' ? {
                        ...formatCodeErrors,
                        [meta.data.localId]: {
                            errorType: meta.data.errorType,
                            localId: meta.data.localId,
                            languageSource: meta.data.languageSource
                        }
                    } : formatCodeErrors,
                    pendingFormats: pendingFormats
                };
            }
        case (0, $cbzce.ACTIONS).CLEAR_FORMAT_CODE_ERROR:
            return {
                ...pluginState,
                formatCodeErrors: $e6180404dc1a02e0$var$removeRecordEntry(pluginState.formatCodeErrors, meta.data.localId)
            };
        default:
            return pluginState;
    }
};

});

parcelRegister("3Iips", function(module, exports) {
$parcel$export(module.exports, "generateInitialDecorations", () => $a41d63eb2feb8661$export$e39f4b987bac6a89);
$parcel$export(module.exports, "updateCodeBlockDecorations", () => $a41d63eb2feb8661$export$af0ed0ae85f93cba);
$parcel$export(module.exports, "updateDecorationSetWithWordWrappedDecorator", () => $a41d63eb2feb8661$export$655c2c2993b251d2);

var $3J3tU = parcelRequire("3J3tU");

var $a3b9P = parcelRequire("a3b9P");

var $5OHXV = parcelRequire("5OHXV");

var $2RMFZ = parcelRequire("2RMFZ");
const $a41d63eb2feb8661$export$feb1744c3f7a1a44 = 'decorationWidgetType';
const $a41d63eb2feb8661$export$7d62a9abd4358350 = 'decorationNodeType';
const $a41d63eb2feb8661$export$e39f4b987bac6a89 = (state)=>{
    const codeBlockNodes = (0, $2RMFZ.getAllCodeBlockNodesInDoc)(state);
    return codeBlockNodes.flatMap((node)=>$a41d63eb2feb8661$export$9955827033f49bf6($a41d63eb2feb8661$export$e2f66570e25f0fa7(node)));
};
const $a41d63eb2feb8661$export$af0ed0ae85f93cba = (tr, codeBlockNodes, decorationSet)=>{
    let updatedDecorationSet = decorationSet;
    // Update line number decorators for changed code block nodes if new line added or line removed.
    updatedDecorationSet = $a41d63eb2feb8661$export$b7832269a6c1c9aa(tr, codeBlockNodes, updatedDecorationSet);
    // Check to make sure the word wrap decorators are still valid.
    updatedDecorationSet = $a41d63eb2feb8661$export$7384f52a5ea552e1(tr, codeBlockNodes, updatedDecorationSet);
    return updatedDecorationSet;
};
const $a41d63eb2feb8661$export$b7832269a6c1c9aa = (tr, codeBlockNodes, decorationSet)=>{
    let updatedDecorationSet = decorationSet;
    const lineNumberDecorators = [];
    codeBlockNodes.forEach((node)=>{
        const existingWidgetsOnNode = updatedDecorationSet.find(node.pos, node.pos + node.node.nodeSize, (spec)=>spec.type === $a41d63eb2feb8661$export$feb1744c3f7a1a44);
        const newLineAttributes = $a41d63eb2feb8661$export$e2f66570e25f0fa7(node);
        // There will be no widgets on initialisation. If the number of existing widgets does not equal the amount of lines, regenerate the widgets.
        // There may be a case where the number of existing widgets and the number of lines are the same, that's why we track totalLineCount. This allows
        // us to know how many lines there were when the widget was created. It avoids a break in line numbers, e.g. "1, 2, 3, 5, 6". Happens on line removal.
        if (existingWidgetsOnNode.length === 0 || existingWidgetsOnNode.length !== newLineAttributes.length || existingWidgetsOnNode[0].spec.totalLineCount !== newLineAttributes.length) {
            updatedDecorationSet = updatedDecorationSet.remove(existingWidgetsOnNode);
            lineNumberDecorators.push(...$a41d63eb2feb8661$export$9955827033f49bf6(newLineAttributes));
        }
    });
    return updatedDecorationSet.add(tr.doc, [
        ...lineNumberDecorators
    ]);
};
const $a41d63eb2feb8661$export$e2f66570e25f0fa7 = (node)=>{
    const { node: innerNode, pos: pos } = node;
    // Get content node
    const contentNode = innerNode.content;
    // Get node text content
    let lineAttributes = [];
    // Early exit if content size is 0
    if (contentNode.size === 0) return [
        {
            lineStart: pos + 1,
            lineNumber: 1
        }
    ];
    contentNode.forEach((child)=>{
        const nodeTextContent = child.textContent;
        const nodeStartPos = pos;
        let lineStartIndex = nodeStartPos;
        // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
        const newLineAttributes = nodeTextContent.split('\n').map((line, index)=>{
            const lineLength = line.length;
            const lineStart = lineStartIndex + 1;
            const lineNumber = index + 1;
            // Include the newline character and increment to keep tabs on line position
            lineStartIndex += lineLength + 1;
            return {
                lineStart: lineStart,
                lineNumber: lineNumber
            };
        });
        lineAttributes = [
            ...lineAttributes,
            ...newLineAttributes
        ];
    });
    return lineAttributes;
};
const $a41d63eb2feb8661$export$9955827033f49bf6 = (lineAttributes)=>{
    const widgetDecorations = lineAttributes.map((lineAttribute)=>{
        const { lineStart: lineStart, lineNumber: lineNumber } = lineAttribute;
        // Passing a function to create the widget rather than directly passing a widget, as per ProseMirror docs.
        const createLineNumberWidget = ()=>{
            const widget = document.createElement('span');
            widget.textContent = `${lineNumber}`;
            widget.classList.add((0, $5OHXV.codeBlockClassNames).lineNumberWidget);
            return widget;
        };
        // side -1 is used so the line numbers are the first thing to the left of the lines of code.
        // totalLineCount is used to know whether or not to update the line numbers when a new line is added or removed.
        return (0, $a3b9P.Decoration).widget(lineStart, createLineNumberWidget, {
            type: $a41d63eb2feb8661$export$feb1744c3f7a1a44,
            side: -1,
            totalLineCount: lineAttributes.length
        });
    });
    return widgetDecorations;
};
const $a41d63eb2feb8661$export$7384f52a5ea552e1 = (tr, codeBlockNodes, decorationSet)=>{
    let updatedDecorationSet = decorationSet;
    codeBlockNodes.forEach((node)=>{
        const isCodeBlockWrappedInState = (0, $3J3tU.isCodeBlockWordWrapEnabled)(node.node);
        const isCodeBlockWrappedByDecorator = $a41d63eb2feb8661$export$343dbf55d0e24df2(node.pos, decorationSet).length !== 0;
        if (isCodeBlockWrappedInState !== isCodeBlockWrappedByDecorator) updatedDecorationSet = $a41d63eb2feb8661$export$655c2c2993b251d2(decorationSet, tr, node);
    });
    return updatedDecorationSet;
};
const $a41d63eb2feb8661$export$655c2c2993b251d2 = (decorationSet, tr, node)=>{
    if (!node || node.pos === undefined) return decorationSet;
    let updatedDecorationSet = decorationSet;
    const { pos: pos, node: innerNode } = node;
    const isNodeWrapped = (0, $3J3tU.isCodeBlockWordWrapEnabled)(innerNode);
    if (!isNodeWrapped) {
        const currentWrappedBlockDecorationSet = $a41d63eb2feb8661$export$343dbf55d0e24df2(pos, updatedDecorationSet);
        updatedDecorationSet = updatedDecorationSet.remove(currentWrappedBlockDecorationSet);
        // In code block advanced we don't use the node decoration - however a change in decorations
        // is how we detect updates to the word wrap. If we have no decorations attached we've
        // likely changed the breakout width with the toggle ON - we add an empty decoration to force
        // prosemirror to recognise the change so we can update in our node view. This gets filtered
        // out on the next toggle.
        if (currentWrappedBlockDecorationSet.length === 0 && pos + innerNode.nodeSize <= tr.doc.content.size) {
            const wrappedBlock = (0, $a3b9P.Decoration).node(pos, pos + innerNode.nodeSize, {}, {
                type: $a41d63eb2feb8661$export$7d62a9abd4358350
            } // Allows for quick filtering of decorations while using `find`
            );
            updatedDecorationSet = updatedDecorationSet.add(tr.doc, [
                wrappedBlock
            ]);
        }
    } else {
        const wrappedBlock = (0, $a3b9P.Decoration).node(pos, pos + innerNode.nodeSize, {
            class: (0, $5OHXV.codeBlockClassNames).contentWrapped
        }, {
            type: $a41d63eb2feb8661$export$7d62a9abd4358350
        } // Allows for quick filtering of decorations while using `find`
        );
        updatedDecorationSet = updatedDecorationSet.add(tr.doc, [
            wrappedBlock
        ]);
    }
    return updatedDecorationSet;
};
const $a41d63eb2feb8661$export$343dbf55d0e24df2 = (pos, decorationSet)=>{
    const codeBlockNodePosition = pos + 1; // We need to add 1 to the position to get the start of the node.
    const currentWrappedBlockDecorationSet = decorationSet.find(codeBlockNodePosition, codeBlockNodePosition, (spec)=>spec.type === $a41d63eb2feb8661$export$7d62a9abd4358350);
    return currentWrappedBlockDecorationSet;
};

});


parcelRegister("kjP5G", function(module, exports) {
$parcel$export(module.exports, "default", () => $a24ea2ce10f6229f$export$2e2bcd8739ae039);

var $jxkn6 = parcelRequire("jxkn6");

var $1LuwP = parcelRequire("1LuwP");
// Workaround for a firefox issue where dom selection is off sync
// https://product-fabric.atlassian.net/browse/ED-12442
const $a24ea2ce10f6229f$export$b3bd6df96c05d596 = ()=>{
    const domSelection = window.getSelection();
    if (domSelection) {
        const domRange = domSelection && domSelection.rangeCount === 1 && domSelection.getRangeAt(0).cloneRange();
        if (domRange) {
            domSelection.removeAllRanges();
            domSelection.addRange(domRange);
        }
    }
};
const $a24ea2ce10f6229f$var$refreshBrowserSelectionOnChange = (transaction, editorState)=>{
    var _pluginKey$getState;
    const browser = (0, $jxkn6.getBrowserInfo)();
    if (browser.gecko && transaction.docChanged && // codeblockState.pos should be set if current selection is in a codeblock.
    typeof ((_pluginKey$getState = (0, $1LuwP.pluginKey).getState(editorState)) === null || _pluginKey$getState === void 0 ? void 0 : _pluginKey$getState.pos) === 'number') $a24ea2ce10f6229f$export$b3bd6df96c05d596();
};
var $a24ea2ce10f6229f$export$2e2bcd8739ae039 = $a24ea2ce10f6229f$var$refreshBrowserSelectionOnChange;

});

parcelRegister("cABjx", function(module, exports) {
$parcel$export(module.exports, "getToolbarConfig", () => $ef385972faaeaec2$export$86ce8f8241c20a3);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $3J3tU = parcelRequire("3J3tU");

var $fNLdd = parcelRequire("fNLdd");

var $583Mc = parcelRequire("583Mc");

var $8qHhy = parcelRequire("8qHhy");

var $gab48 = parcelRequire("gab48");

var $imwtU = parcelRequire("imwtU");

var $c81bI = parcelRequire("c81bI");

var $gV64P = parcelRequire("gV64P");

var $3aSEM = parcelRequire("3aSEM");

var $5fP6U = parcelRequire("5fP6U");

var $3y2s4 = parcelRequire("3y2s4");

var $gdUUy = parcelRequire("gdUUy");

var $5N1Y4 = parcelRequire("5N1Y4");

var $4zjoa = parcelRequire("4zjoa");

var $kdxmD = parcelRequire("kdxmD");

var $gUI3Q = parcelRequire("gUI3Q");

var $fRoB5 = parcelRequire("fRoB5");

var $5gb0X = parcelRequire("5gb0X");

var $krJQX = parcelRequire("krJQX");

var $552Jd = parcelRequire("552Jd");

var $9csIT = parcelRequire("9csIT");

var $it6Ss = parcelRequire("it6Ss");

var $1LuwP = parcelRequire("1LuwP");
const $ef385972faaeaec2$var$getDetectLanguageOption = (formatMessage)=>({
        alias: [],
        label: formatMessage((0, $583Mc.codeBlockButtonMessages).detectLanguage),
        value: (0, $5gb0X.DETECT_LANGUAGE_VALUE)
    });
const $ef385972faaeaec2$var$getNoneDetectedOption = (formatMessage)=>({
        alias: [],
        label: formatMessage((0, $583Mc.codeBlockButtonMessages).noneDetected),
        value: (0, $5gb0X.NONE_LANGUAGE_VALUE)
    });
const $ef385972faaeaec2$var$getDefaultLanguagePickerValue = (language, languagePickerOptions)=>language ? languagePickerOptions.find((option)=>language === (0, $5gb0X.NONE_LANGUAGE_VALUE) ? option.value === (0, $5gb0X.PLAIN_TEXT_LANGUAGE_VALUE) : option.value === language || option.alias.includes(language)) : undefined;
const $ef385972faaeaec2$var$getAutoDetectPickerValue = ({ autoDetectEntry: autoDetectEntry, formatMessage: formatMessage, language: language, languagePickerOptions: languagePickerOptions })=>{
    const defaultPickerValue = $ef385972faaeaec2$var$getDefaultLanguagePickerValue(language, languagePickerOptions);
    // A weak re-detection records noneDetected but can leave a previously auto-detected
    // language on the node. Keep showing "(detected)" only while that preserved language
    // still matches the node language, so manual language changes do not inherit the label.
    const shouldShowDetectedLabel = Boolean(defaultPickerValue) && (autoDetectEntry === null || autoDetectEntry === void 0 ? void 0 : autoDetectEntry.autoDetectedLanguage) === language && Boolean(autoDetectEntry === null || autoDetectEntry === void 0 ? void 0 : autoDetectEntry.detectionResult);
    if (shouldShowDetectedLabel && defaultPickerValue) return {
        ...defaultPickerValue,
        label: formatMessage((0, $583Mc.codeBlockButtonMessages).detectedLanguage, {
            language: defaultPickerValue.label
        })
    };
    if (language || !autoDetectEntry) return defaultPickerValue;
    if (autoDetectEntry.detectionResult === 'noneDetected') return $ef385972faaeaec2$var$getNoneDetectedOption(formatMessage);
    if (!autoDetectEntry.detectionResult) return $ef385972faaeaec2$var$getDetectLanguageOption(formatMessage);
    return undefined;
};
const $ef385972faaeaec2$export$86ce8f8241c20a3 = (allowCopyToClipboard = false, api, overrideLanguageName, formatCodeProvider)=>{
    // Append gated languages (e.g. Mermaid) at runtime. Build a fresh array since
    // createLanguageList sorts in place and would otherwise mutate DEFAULT_LANGUAGES.
    const supportedLanguages = (0, $gdUUy.fg)('platform_editor_code_block_mermaid_language') ? [
        ...(0, $it6Ss.DEFAULT_LANGUAGES),
        (0, $it6Ss.MERMAID_LANGUAGE)
    ] : (0, $it6Ss.DEFAULT_LANGUAGES);
    const languageList = (0, $it6Ss.createLanguageList)(overrideLanguageName ? supportedLanguages.map((languageOption)=>({
            ...languageOption,
            name: overrideLanguageName(languageOption.name)
        })) : supportedLanguages);
    const languagePickerOptions = languageList.map((lang)=>({
            label: lang.name,
            value: (0, $it6Ss.getLanguageIdentifier)(lang),
            alias: lang.alias
        }));
    return (state, { formatMessage: formatMessage })=>{
        var _api$editorViewMode, _api$decorations, _api$analytics, _node$attrs, _node$attrs2;
        const isViewMode = (api === null || api === void 0 || (_api$editorViewMode = api.editorViewMode) === null || _api$editorViewMode === void 0 || (_api$editorViewMode = _api$editorViewMode.sharedState.currentState()) === null || _api$editorViewMode === void 0 ? void 0 : _api$editorViewMode.mode) === 'view';
        const { hoverDecoration: hoverDecoration } = (api === null || api === void 0 || (_api$decorations = api.decorations) === null || _api$decorations === void 0 ? void 0 : _api$decorations.actions) ?? {};
        const editorAnalyticsAPI = api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions;
        const codeBlockState = (0, $1LuwP.pluginKey).getState(state);
        const pos = (codeBlockState === null || codeBlockState === void 0 ? void 0 : codeBlockState.pos) ?? null;
        if (!codeBlockState || pos === null) return;
        const node = state.doc.nodeAt(pos);
        const nodeType = state.schema.nodes.codeBlock;
        if ((node === null || node === void 0 ? void 0 : node.type) !== nodeType) return;
        const isWrapped = (0, $3J3tU.isCodeBlockWordWrapEnabled)(node);
        const areLineNumbersVisible = (0, $3J3tU.areCodeBlockLineNumbersVisible)(node);
        const language = node === null || node === void 0 || (_node$attrs = node.attrs) === null || _node$attrs === void 0 ? void 0 : _node$attrs.language;
        const localId = node === null || node === void 0 || (_node$attrs2 = node.attrs) === null || _node$attrs2 === void 0 ? void 0 : _node$attrs2.localId;
        const autoDetectState = (0, $552Jd.autoDetectPluginKey).getState(state);
        const isFormatCodePending = typeof localId === 'string' && Boolean(codeBlockState.pendingFormats[localId]);
        // Keep fresh option objects for the legacy toolbar select so reopening it
        // continues to start from the top rather than preserving the previously
        // focused option by reference.
        const languageSelectOptions = languagePickerOptions.map((option)=>({
                ...option
            }));
        const defaultValue = language ? languageSelectOptions.find((option)=>option.value === language) || languageSelectOptions.find((option)=>option.alias.includes(language)) : null;
        const languageSelect = {
            id: 'editor.codeBlock.languageOptions',
            type: 'select',
            selectType: 'list',
            onChange: (option)=>(0, $kdxmD.changeLanguage)(editorAnalyticsAPI)(option.value),
            defaultValue: defaultValue,
            placeholder: formatMessage((0, $583Mc.codeBlockButtonMessages).selectLanguage),
            options: languageSelectOptions,
            filterOption: $ef385972faaeaec2$export$fffed505cd33273c
        };
        const areAnyNewToolbarFlagsEnabled = (0, $8qHhy.areToolbarFlagsEnabled)(Boolean(api === null || api === void 0 ? void 0 : api.toolbar));
        const isQ4LovabilityEnabled = (0, $5N1Y4.expValEquals)('platform_editor_code_block_q4_lovability', 'isEnabled', true);
        let languagePicker;
        if (isQ4LovabilityEnabled) {
            const autoDetectEntry = typeof localId === 'string' ? autoDetectState === null || autoDetectState === void 0 ? void 0 : autoDetectState.languageDetectionMap[localId] : undefined;
            const autoDetectPickerValue = $ef385972faaeaec2$var$getAutoDetectPickerValue({
                autoDetectEntry: autoDetectEntry,
                formatMessage: formatMessage,
                language: language,
                languagePickerOptions: languagePickerOptions
            });
            languagePicker = {
                type: 'custom',
                fallback: [],
                render: (view)=>{
                    if (!view) return null;
                    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $gUI3Q.CodeBlockLanguagePicker), {
                        api: api,
                        defaultValue: autoDetectPickerValue,
                        editorView: view,
                        filterOption: $ef385972faaeaec2$export$fffed505cd33273c,
                        formatMessage: formatMessage,
                        languagePickerOptions: languagePickerOptions,
                        triggerSpacing: !areAnyNewToolbarFlagsEnabled ? 'compact' : 'default'
                    });
                }
            };
        }
        const separator = {
            type: 'separator'
        };
        const copyToClipboardItems = !allowCopyToClipboard ? [] : [
            {
                id: 'editor.codeBlock.copy',
                type: 'button',
                supportsViewMode: true,
                appearance: 'subtle',
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($c81bI))),
                // note: copyContentToClipboardWithAnalytics contains logic that also removes the
                // visual feedback for the copy button
                onClick: (0, $kdxmD.copyContentToClipboardWithAnalytics)(editorAnalyticsAPI),
                title: formatMessage(codeBlockState.contentCopied ? (0, $583Mc.codeBlockButtonMessages).copiedCodeToClipboard : (0, $3y2s4.isExperimentEnabled)('platform_editor_a11y_codeblock_copy_name') ? (0, $583Mc.codeBlockButtonMessages).copyCodeSnippetToClipboard : (0, $583Mc.codeBlockButtonMessages).copyCodeToClipboard),
                onMouseEnter: (0, $9csIT.provideVisualFeedbackForCopyButton),
                // note: resetCopiedState contains logic that also removes the
                // visual feedback for the copy button
                onMouseLeave: (0, $kdxmD.resetCopiedState),
                onFocus: (0, $9csIT.provideVisualFeedbackForCopyButton),
                onBlur: (0, $9csIT.removeVisualFeedbackForCopyButton),
                hideTooltipOnClick: false,
                hasNewContentOnTriggerClick: true,
                disabled: codeBlockState.isNodeSelected,
                tabIndex: null
            },
            separator
        ];
        let copyAndDeleteButtonMenuItems = [];
        if (areAnyNewToolbarFlagsEnabled) {
            const overflowMenuOptions = [
                {
                    title: formatMessage((0, $fNLdd.default).delete),
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($gV64P)))({
                        label: ''
                    }),
                    onMouseEnter: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(nodeType, true),
                    onMouseLeave: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(nodeType, false),
                    onFocus: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(nodeType, true),
                    onBlur: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(nodeType, false),
                    onClick: (0, $kdxmD.removeCodeBlockWithAnalytics)(editorAnalyticsAPI)
                }
            ];
            if (allowCopyToClipboard) overflowMenuOptions.unshift({
                title: formatMessage((0, $3y2s4.isExperimentEnabled)('platform_editor_a11y_codeblock_copy_name') ? (0, $583Mc.codeBlockButtonMessages).copyCodeSnippetToClipboard : (0, $fNLdd.default).copyToClipboard),
                onClick: (0, $kdxmD.copyContentToClipboardWithAnalytics)(editorAnalyticsAPI),
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($c81bI)))({
                    label: ''
                }),
                onMouseEnter: (0, $9csIT.provideVisualFeedbackForCopyButton),
                onMouseLeave: (0, $kdxmD.resetCopiedState),
                onFocus: (0, $9csIT.provideVisualFeedbackForCopyButton),
                onBlur: (0, $9csIT.removeVisualFeedbackForCopyButton),
                disabled: codeBlockState.isNodeSelected
            });
            copyAndDeleteButtonMenuItems = isViewMode ? [
                ...copyToClipboardItems
            ] : [
                {
                    type: 'separator',
                    fullHeight: true
                },
                {
                    type: 'overflow-dropdown',
                    testId: 'code-block-overflow-dropdown-trigger',
                    options: overflowMenuOptions
                }
            ];
        } else {
            const deleteButton = {
                id: 'editor.codeBlock.delete',
                type: 'button',
                appearance: 'danger',
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($gV64P))),
                iconFallback: (0, (/*@__PURE__*/$parcel$interopDefault($gV64P))),
                onMouseEnter: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(nodeType, true),
                onMouseLeave: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(nodeType, false),
                onFocus: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(nodeType, true),
                onBlur: hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(nodeType, false),
                onClick: (0, $kdxmD.removeCodeBlockWithAnalytics)(editorAnalyticsAPI),
                title: formatMessage((0, $fNLdd.default).remove),
                tabIndex: null
            };
            copyAndDeleteButtonMenuItems = [
                separator,
                ...copyToClipboardItems,
                deleteButton
            ];
        }
        const codeBlockWrapButtonTitle = (0, $4zjoa.expValEqualsNoExposure)('platform_editor_code_block_q4_lovability', 'isEnabled', true) ? formatMessage(isWrapped ? (0, $583Mc.codeBlockButtonMessages).unwrapCodeLabel : (0, $583Mc.codeBlockButtonMessages).wrapCodeLabel) : formatMessage((0, $583Mc.codeBlockButtonMessages).wrapCode);
        const codeBlockWrapButton = {
            id: 'editor.codeBlock.wrap',
            type: 'button',
            // Toggling button now writes to ADF, hence it should be available in view mode
            supportsViewMode: !(0, $4zjoa.expValEqualsNoExposure)('platform_editor_code_block_q4_lovability', 'isEnabled', true),
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($5fP6U))),
            iconFallback: (0, $fRoB5.WrapIcon),
            onClick: (0, $kdxmD.toggleWordWrapStateForCodeBlockNode)(editorAnalyticsAPI),
            title: codeBlockWrapButtonTitle,
            tabIndex: null,
            selected: isWrapped
        };
        const codeBlockLineNumbersButton = {
            id: 'editor.codeBlock.lineNumbers',
            type: 'button',
            supportsViewMode: false,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($3aSEM))),
            onClick: (0, $kdxmD.toggleLineNumbersForCodeBlockNode)(editorAnalyticsAPI),
            title: formatMessage(areLineNumbersVisible ? (0, $583Mc.codeBlockButtonMessages).hideLineNumbersLabel : (0, $583Mc.codeBlockButtonMessages).showLineNumbersLabel),
            tabIndex: null,
            selected: areLineNumbersVisible
        };
        const formatLanguage = formatCodeProvider !== null && formatCodeProvider !== void 0 && formatCodeProvider.isSupportedLanguage(language) ? language : undefined;
        const canFormatCode = node.textContent.length > 0 && Boolean(formatLanguage);
        const formatCodeButton = {
            id: 'editor.codeBlock.formatCode',
            type: 'button',
            supportsViewMode: false,
            disabled: !canFormatCode || isFormatCodePending,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($imwtU))),
            onClick: (0, $kdxmD.createFormatCodeOnClick)({
                api: api,
                editorAnalyticsAPI: editorAnalyticsAPI,
                formatCodeProvider: formatCodeProvider
            }),
            onFocus: (0, $krJQX.preloadFormatterOnIntent)(formatCodeProvider, formatLanguage),
            onMouseEnter: (0, $krJQX.preloadFormatterOnIntent)(formatCodeProvider, formatLanguage),
            title: formatMessage(canFormatCode ? (0, $583Mc.codeBlockButtonMessages).formatCode : (0, $583Mc.codeBlockButtonMessages).formatCodeUnavailable)
        };
        return {
            title: 'CodeBlock floating controls',
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            getDomRef: (view)=>(0, $gab48.findDomRefAtPos)(pos, view.domAtPos.bind(view)),
            nodeType: nodeType,
            items: [
                languagePicker ?? languageSelect,
                ...areAnyNewToolbarFlagsEnabled ? [] : [
                    separator
                ],
                codeBlockWrapButton,
                ...isQ4LovabilityEnabled ? [
                    codeBlockLineNumbersButton,
                    ...formatCodeProvider ? [
                        formatCodeButton
                    ] : []
                ] : [],
                ...copyAndDeleteButtonMenuItems
            ],
            scrollable: true
        };
    };
};
const $ef385972faaeaec2$export$fffed505cd33273c = (option, rawInput)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const { data: data } = option;
    const searchString = rawInput.toLowerCase();
    return data.label.toLowerCase().includes(searchString) || data.alias.some((alias)=>alias.toLowerCase() === searchString);
};

});
parcelRegister("gUI3Q", function(module, exports) {
$parcel$export(module.exports, "CodeBlockLanguagePicker", () => $ad5d4d3cd5bf93c5$export$5393582178e4c2a);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $kdxmD = parcelRequire("kdxmD");

var $5gb0X = parcelRequire("5gb0X");

var $1jVul = parcelRequire("1jVul");

var $5mQRY = parcelRequire("5mQRY");
const $ad5d4d3cd5bf93c5$export$5393582178e4c2a = ({ api: api, defaultValue: defaultValue, editorView: editorView, filterOption: filterOption, formatMessage: formatMessage, languagePickerOptions: languagePickerOptions, triggerSpacing: triggerSpacing })=>{
    var _api$analytics2;
    const [recentLanguageValues, setRecentLanguageValues] = (0, $bSJIT.useState)(()=>(0, $5mQRY.getRecentLanguages)());
    const refreshRecentLanguages = (0, $bSJIT.useCallback)(()=>{
        setRecentLanguageValues((0, $5mQRY.getRecentLanguages)());
    }, []);
    const handleSelection = (0, $bSJIT.useCallback)((option, selectionSource, interactionMethod)=>{
        var _api$analytics;
        const isDetectLanguageSelected = option.value === (0, $5gb0X.DETECT_LANGUAGE_VALUE);
        const command = isDetectLanguageSelected ? (0, $kdxmD.detectLanguage)() : (0, $kdxmD.changeLanguage)(api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions)(option.value, selectionSource);
        const commandSucceeded = command(editorView.state, editorView.dispatch);
        if (interactionMethod === 'mouse') requestAnimationFrame(()=>{
            // Mouse-opened picker should return editing focus to the code block. Keyboard-opened
            // picker keeps focus on the trigger to avoid CodeMirror DOM focus without cm.hasFocus.
            api === null || api === void 0 || api.core.actions.focus({
                scrollIntoView: false
            });
        });
        if (commandSucceeded) {
            (0, $5mQRY.saveRecentLanguage)(option.value);
            setRecentLanguageValues((0, $5mQRY.getRecentLanguages)());
        }
    }, [
        api === null || api === void 0 || (_api$analytics2 = api.analytics) === null || _api$analytics2 === void 0 ? void 0 : _api$analytics2.actions,
        api === null || api === void 0 ? void 0 : api.core.actions,
        editorView
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $1jVul.LanguagePicker), {
        defaultValue: defaultValue,
        filterOption: filterOption,
        formatMessage: formatMessage,
        languagePickerOptions: languagePickerOptions,
        recentLanguageValues: recentLanguageValues,
        onMenuOpen: refreshRecentLanguages,
        onSelection: handleSelection,
        triggerSpacing: triggerSpacing
    });
};

});
parcelRegister("5gb0X", function(module, exports) {
$parcel$export(module.exports, "NONE_LANGUAGE_VALUE", () => $dfbd8c8c72409cc3$export$1ce1cbcc4f60583f);
$parcel$export(module.exports, "DETECT_LANGUAGE_VALUE", () => $dfbd8c8c72409cc3$export$81fe902fcf56eb7c);
$parcel$export(module.exports, "PLAIN_TEXT_LANGUAGE_VALUE", () => $dfbd8c8c72409cc3$export$5ebaabde4fc8cb67);
$parcel$export(module.exports, "createGroupedLanguageOptions", () => $dfbd8c8c72409cc3$export$1bc7cbac729eb361);

var $583Mc = parcelRequire("583Mc");
const $dfbd8c8c72409cc3$export$1ce1cbcc4f60583f = 'none';
const $dfbd8c8c72409cc3$export$81fe902fcf56eb7c = 'autodetect';
const $dfbd8c8c72409cc3$export$5ebaabde4fc8cb67 = 'text';
const $dfbd8c8c72409cc3$export$997b95251f1f16f7 = (formatMessage)=>({
        alias: [
            $dfbd8c8c72409cc3$export$81fe902fcf56eb7c
        ],
        label: formatMessage((0, $583Mc.codeBlockButtonMessages).detectLanguage),
        selectionSource: 'pinned',
        value: $dfbd8c8c72409cc3$export$81fe902fcf56eb7c
    });
const $dfbd8c8c72409cc3$export$1bc7cbac729eb361 = ({ formatMessage: formatMessage, languages: languages, recentlyUsedLanguages: recentlyUsedLanguages = [] })=>{
    const recentlyUsedLanguageValues = new Set(recentlyUsedLanguages.map((language)=>language.value));
    const allLanguages = languages.filter((language)=>language.value !== $dfbd8c8c72409cc3$export$1ce1cbcc4f60583f && language.value !== $dfbd8c8c72409cc3$export$5ebaabde4fc8cb67 && !recentlyUsedLanguageValues.has(language.value));
    const plainTextOption = languages.find((language)=>language.value === $dfbd8c8c72409cc3$export$5ebaabde4fc8cb67);
    const pinnedOptions = [
        $dfbd8c8c72409cc3$export$997b95251f1f16f7(formatMessage)
    ];
    if (plainTextOption) pinnedOptions.push({
        ...plainTextOption,
        selectionSource: 'pinned'
    });
    return [
        {
            label: '',
            options: pinnedOptions
        },
        ...recentlyUsedLanguages.length > 0 ? [
            {
                label: formatMessage((0, $583Mc.codeBlockButtonMessages).recentlyUsed),
                options: recentlyUsedLanguages.map((language)=>({
                        ...language,
                        selectionSource: 'recentlyUsed'
                    }))
            }
        ] : [],
        {
            label: formatMessage((0, $583Mc.codeBlockButtonMessages).all),
            options: allLanguages.map((language)=>({
                    ...language,
                    selectionSource: 'all'
                }))
        }
    ];
};

});

parcelRegister("1jVul", function(module, exports) {
$parcel$export(module.exports, "LanguagePicker", () => $fc6516e24047d998$export$409dffa5e19bc01a);
/* LanguagePicker.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $jNJGJ = parcelRequire("jNJGJ");

var $583Mc = parcelRequire("583Mc");

var $4GWyU = parcelRequire("4GWyU");

var $9PwDt = parcelRequire("9PwDt");

var $kbBdI = parcelRequire("kbBdI");

var $d6VL5 = parcelRequire("d6VL5");

var $5gb0X = parcelRequire("5gb0X");
const $fc6516e24047d998$var$pickerOptionStyles = null;
const $fc6516e24047d998$var$styles = {
    divider: "_h7alglyw _179rglyw _mqm2ia51 _1bsb1osq",
    trigger: "_p12fuuw1 _ficf1e5h _1xw9glyw"
};
const $fc6516e24047d998$var$CustomGroup = (props)=>{
    const allGroups = props.selectProps.options;
    const isFirstGroup = allGroups.length > 0 && allGroups[0] === props.data;
    return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $bSJIT.Fragment), {
        children: [
            !isFirstGroup && /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
                as: "hr",
                xcss: $fc6516e24047d998$var$styles.divider,
                role: "presentation"
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $kbBdI.components).Group, {
                ...props
            })
        ]
    });
};
const $fc6516e24047d998$var$CustomOption = (props)=>{
    return(// eslint-disable-next-line react/jsx-props-no-spreading -- react-select custom components must forward all props to the default Option.
    /*#__PURE__*/ (0, $dc70d.jsx)((0, $kbBdI.components).Option, {
        ...props,
        children: /*#__PURE__*/ (0, $dc70d.jsx)("span", {
            className: (0, $9fU1q.default)([
                "_vwz478tn"
            ]),
            children: props.children
        })
    }));
};
const $fc6516e24047d998$var$popupSelectComponents = {
    Group: $fc6516e24047d998$var$CustomGroup,
    Option: $fc6516e24047d998$var$CustomOption
};
const $fc6516e24047d998$var$focusWithoutScrolling = (element)=>{
    element.focus({
        preventScroll: true
    });
};
const $fc6516e24047d998$var$getRecentlyUsedLanguages = (recentLanguageValues, optionsByValue)=>{
    const recentlyUsedLanguages = [];
    for (const recentLanguageValue of recentLanguageValues){
        const option = optionsByValue.get(recentLanguageValue);
        if (option) recentlyUsedLanguages.push(option);
    }
    return recentlyUsedLanguages;
};
const $fc6516e24047d998$export$409dffa5e19bc01a = ({ defaultValue: defaultValue, filterOption: filterOption, formatMessage: formatMessage, languagePickerOptions: languagePickerOptions, recentLanguageValues: recentLanguageValues = [], onMenuOpen: onMenuOpen, onSelection: onSelection, triggerSpacing: triggerSpacing = 'default' })=>{
    const label = (defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.label) ?? formatMessage((0, $583Mc.codeBlockButtonMessages).selectLanguage);
    const selectLanguageLabel = formatMessage((0, $583Mc.codeBlockButtonMessages).selectLanguage);
    const [hasSearchQuery, setHasSearchQuery] = (0, $bSJIT.useState)(false);
    const [lockedPopperPlacement, setLockedPopperPlacement] = (0, $bSJIT.useState)();
    const inputValueRef = (0, $bSJIT.useRef)('');
    // PopupSelect restores focus based on the trigger/open interaction, not the option
    // interaction. Keep this tied to the trigger so keyboard-open + mouse-select still follows
    // the keyboard focus path.
    const interactionMethodRef = (0, $bSJIT.useRef)('keyboard');
    const optionsByValue = (0, $bSJIT.useMemo)(()=>new Map(languagePickerOptions.map((option)=>[
                option.value,
                option
            ])), [
        languagePickerOptions
    ]);
    const recentlyUsedLanguages = (0, $bSJIT.useMemo)(()=>$fc6516e24047d998$var$getRecentlyUsedLanguages(recentLanguageValues, optionsByValue), [
        recentLanguageValues,
        optionsByValue
    ]);
    const options = (0, $bSJIT.useMemo)(()=>(0, $5gb0X.createGroupedLanguageOptions)({
            formatMessage: formatMessage,
            languages: languagePickerOptions,
            recentlyUsedLanguages: recentlyUsedLanguages
        }), [
        formatMessage,
        languagePickerOptions,
        recentlyUsedLanguages
    ]);
    const searchOptions = (0, $bSJIT.useMemo)(()=>options.flatMap((group)=>group.options), [
        options
    ]);
    const stableMenuPopperProps = (0, $bSJIT.useMemo)(()=>({
            // Allow Popper to choose top on the first open when bottom has no room, then lock the
            // chosen placement so later hover/search renders do not move the open picker.
            placement: lockedPopperPlacement ?? 'bottom-start',
            modifiers: [
                {
                    name: 'offset',
                    options: {
                        offset: [
                            0,
                            8
                        ]
                    }
                },
                {
                    name: 'preventOverflow',
                    enabled: false
                },
                ...lockedPopperPlacement ? [
                    {
                        name: 'flip',
                        enabled: false
                    }
                ] : []
            ],
            onFirstUpdate: ({ placement: placement })=>{
                setLockedPopperPlacement(placement);
            }
        }), [
        lockedPopperPlacement
    ]);
    const handleChange = (0, $bSJIT.useCallback)((option)=>{
        if (!option) return;
        const isSearchSelection = inputValueRef.current.trim().length > 0;
        const selectionSource = isSearchSelection ? 'search' : option.selectionSource ?? 'all';
        onSelection(option, selectionSource, interactionMethodRef.current);
    }, [
        onSelection
    ]);
    const handleInputChange = (0, $bSJIT.useCallback)((newInputValue, actionMeta)=>{
        // React-select clears the input as part of selecting a value before onChange fires.
        // Keep the last user-typed query so handleChange can report search selections correctly.
        const isInputChange = !actionMeta || actionMeta.action === 'input-change';
        if (isInputChange) {
            inputValueRef.current = newInputValue;
            setHasSearchQuery(newInputValue.trim().length > 0);
            return newInputValue;
        }
        return inputValueRef.current;
    }, []);
    const handleMenuOpen = (0, $bSJIT.useCallback)(()=>{
        inputValueRef.current = '';
        setHasSearchQuery(false);
        setLockedPopperPlacement(undefined);
        onMenuOpen === null || onMenuOpen === void 0 || onMenuOpen();
    }, [
        onMenuOpen
    ]);
    const handleTriggerMouseUp = (0, $bSJIT.useCallback)((event)=>{
        interactionMethodRef.current = 'mouse';
        // Focus the trigger before PopupSelect opens so FocusLock restores focus to the
        // trigger after a mouse selection. Relying on the button's default mouse focus is too
        // late here; FocusLock can still remember the code block as the previous focus target.
        $fc6516e24047d998$var$focusWithoutScrolling(event.currentTarget);
    }, []);
    const handleTriggerKeyDownCapture = (0, $bSJIT.useCallback)(()=>{
        interactionMethodRef.current = 'keyboard';
    }, []);
    const renderTarget = (0, $bSJIT.useCallback)(({ isOpen: isOpen, ref: ref, onKeyDown: onKeyDown, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup })=>/*#__PURE__*/ (0, $dc70d.jsx)("div", {
            className: (0, $9fU1q.default)([
                $fc6516e24047d998$var$styles.trigger
            ]),
            children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $jNJGJ.default), {
                spacing: triggerSpacing,
                shouldFitContainer: true,
                onMouseUp: handleTriggerMouseUp,
                onKeyDownCapture: handleTriggerKeyDownCapture,
                onKeyDown: onKeyDown,
                ref: ref,
                iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($4GWyU))),
                appearance: "subtle",
                isSelected: isOpen,
                "aria-controls": ariaControls,
                "aria-expanded": ariaExpanded,
                "aria-haspopup": ariaHasPopup,
                testId: "code-block-language-picker-trigger",
                children: label
            })
        }), [
        label,
        triggerSpacing,
        handleTriggerMouseUp,
        handleTriggerKeyDownCapture
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $d6VL5.PopupSelect), {
        components: $fc6516e24047d998$var$popupSelectComponents,
        filterOption: filterOption,
        label: selectLanguageLabel,
        maxMenuHeight: 300,
        minMenuWidth: 200,
        menuPlacement: "auto",
        onChange: handleChange,
        onInputChange: handleInputChange,
        onMenuOpen: handleMenuOpen,
        options: hasSearchQuery ? searchOptions : options,
        popperProps: stableMenuPopperProps,
        searchThreshold: -1,
        target: renderTarget,
        testId: "code-block-language-picker",
        defaultValue: defaultValue
    });
};

});

parcelRegister("5mQRY", function(module, exports) {
$parcel$export(module.exports, "getRecentLanguages", () => $c121367e42db23b2$export$f474067f7cfd10a);
$parcel$export(module.exports, "saveRecentLanguage", () => $c121367e42db23b2$export$40a7fab637911506);

var $hYVMR = parcelRequire("hYVMR");

var $it6Ss = parcelRequire("it6Ss");

var $5gb0X = parcelRequire("5gb0X");
const $c121367e42db23b2$export$377b756c63ac664b = 'recently-used-languages';
const $c121367e42db23b2$var$RECENT_LANGUAGES_STORAGE_CLIENT_KEY = '@atlaskit/editor-plugin-code-block';
const $c121367e42db23b2$var$MAX_RECENT_LANGUAGES = 3;
const $c121367e42db23b2$var$RECENT_LANGUAGE_BLOCKLIST = new Set([
    (0, $5gb0X.DETECT_LANGUAGE_VALUE),
    (0, $5gb0X.NONE_LANGUAGE_VALUE),
    (0, $5gb0X.PLAIN_TEXT_LANGUAGE_VALUE)
]);
const $c121367e42db23b2$var$KNOWN_LANGUAGE_VALUES = new Set((0, $it6Ss.DEFAULT_LANGUAGES).map((language)=>(0, $it6Ss.getLanguageIdentifier)(language)));
const $c121367e42db23b2$var$recentLanguagesStorageClient = new (0, $hYVMR.StorageClient)($c121367e42db23b2$var$RECENT_LANGUAGES_STORAGE_CLIENT_KEY);
const $c121367e42db23b2$var$isValidRecentLanguage = (language)=>$c121367e42db23b2$var$KNOWN_LANGUAGE_VALUES.has(language) && !$c121367e42db23b2$var$RECENT_LANGUAGE_BLOCKLIST.has(language);
const $c121367e42db23b2$var$readRecentLanguages = ()=>{
    const storedValue = $c121367e42db23b2$var$recentLanguagesStorageClient.getItem($c121367e42db23b2$export$377b756c63ac664b);
    return Array.isArray(storedValue) ? storedValue : [];
};
const $c121367e42db23b2$export$f474067f7cfd10a = ()=>{
    try {
        return $c121367e42db23b2$var$readRecentLanguages();
    } catch  {
        return [];
    }
};
const $c121367e42db23b2$export$40a7fab637911506 = (language)=>{
    if (!$c121367e42db23b2$var$isValidRecentLanguage(language)) return;
    try {
        const recentLanguages = $c121367e42db23b2$var$readRecentLanguages();
        const nextRecentLanguages = Array.from(new Set([
            language,
            ...recentLanguages
        ])).slice(0, $c121367e42db23b2$var$MAX_RECENT_LANGUAGES);
        // StorageClient only exposes setItemWithExpiry; omitting the duration stores without expiry.
        $c121367e42db23b2$var$recentLanguagesStorageClient.setItemWithExpiry($c121367e42db23b2$export$377b756c63ac664b, nextRecentLanguages);
    } catch  {
        return;
    }
};
const $c121367e42db23b2$export$36acc0e2c8b8397d = ()=>{
    $c121367e42db23b2$var$recentLanguagesStorageClient.removeItem($c121367e42db23b2$export$377b756c63ac664b);
};

});
parcelRegister("it6Ss", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_LANGUAGES", () => $f1200e96a03caec1$export$5a175c817b3d7154);
$parcel$export(module.exports, "MERMAID_LANGUAGE", () => $f1200e96a03caec1$export$2253b3fe462d024d);
$parcel$export(module.exports, "getLanguageIdentifier", () => $f1200e96a03caec1$export$8ef04e71795bc8a6);
$parcel$export(module.exports, "createLanguageList", () => $f1200e96a03caec1$export$e2dc9c8f242e4ee2);

var $jMMBQ = parcelRequire("jMMBQ");
const $f1200e96a03caec1$export$5a175c817b3d7154 = [
    {
        name: '(None)',
        alias: [
            'none'
        ],
        value: 'none'
    },
    ...(0, $jMMBQ.SUPPORTED_LANGUAGES)
];
const $f1200e96a03caec1$export$2253b3fe462d024d = {
    name: 'Mermaid',
    alias: [
        'mermaid'
    ],
    value: 'mermaid'
};
function $f1200e96a03caec1$export$c11db3aa0f1c6401(supportedLanguages, language) {
    if (!language) return undefined;
    const matches = supportedLanguages.filter((supportedLanguage)=>{
        return supportedLanguage.alias.indexOf(language.toLowerCase()) !== -1;
    });
    if (matches.length > 0) return matches[0];
    return undefined;
}
function $f1200e96a03caec1$export$b76ace6a02d76481(supportedLanguages) {
    if (!supportedLanguages || !supportedLanguages.length) return $f1200e96a03caec1$export$5a175c817b3d7154;
    return $f1200e96a03caec1$export$5a175c817b3d7154.filter((language)=>{
        let i = language.alias.length;
        while(i--){
            if (supportedLanguages.indexOf(language.alias[i]) > -1) return true;
        }
        return false;
    });
}
function $f1200e96a03caec1$export$8ef04e71795bc8a6(language) {
    return language.alias[0];
}
function $f1200e96a03caec1$export$e2dc9c8f242e4ee2(supportedLanguages) {
    return supportedLanguages.sort((left, right)=>{
        if (left.alias[0] === 'none') return -1;
        if (left.name.toLowerCase() > right.name.toLowerCase()) return 1;
        if (left.name.toLowerCase() < right.name.toLowerCase()) return -1;
        return 0;
    });
}

});



parcelRegister("fRoB5", function(module, exports) {
$parcel$export(module.exports, "WrapIcon", () => $7aec014cc2f3b291$export$93a804c703d50d67);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $hETL4 = parcelRequire("hETL4");
const $7aec014cc2f3b291$var$CustomGlyph = ()=>/*#__PURE__*/ (0, $dc70d.jsx)("svg", {
        width: "24",
        height: "24",
        fill: "none",
        viewBox: "0 0 24 24",
        children: /*#__PURE__*/ (0, $dc70d.jsx)("g", {
            fill: "currentColor",
            clipPath: "url(#clip0_654_431)",
            children: /*#__PURE__*/ (0, $dc70d.jsx)("path", {
                d: "M20 4h-1v16h1V4ZM3 8a1 1 0 0 1 1-1h9.5a4.5 4.5 0 1 1 0 9h-2.086l.293.293a1 1 0 0 1-1.414 1.414l-2-2a1 1 0 0 1 0-1.414l2-2a1 1 0 0 1 1.414 1.414l-.293.293H13.5a2.5 2.5 0 0 0 0-5H4a1 1 0 0 1-1-1Z",
                clipRule: "evenodd",
                fillRule: "evenodd"
            })
        })
    });
const $7aec014cc2f3b291$export$93a804c703d50d67 = ()=>{
    const intl = (0, $4vLTk.default)();
    return /*#__PURE__*/ (0, $dc70d.jsx)($7aec014cc2f3b291$var$CustomGlyph, {
        "aria-label": intl.formatMessage((0, $hETL4.messages).wrapIcon)
    });
};

});

parcelRegister("krJQX", function(module, exports) {
$parcel$export(module.exports, "preloadFormatterOnIntent", () => $17bbf90fafe5ae2f$export$bbd1d07b83fc9327);
const $17bbf90fafe5ae2f$export$bbd1d07b83fc9327 = (formatCodeProvider, language)=>(_state, dispatch)=>{
        var _formatCodeProvider$p;
        if (!dispatch || !formatCodeProvider || !language) // Hover/focus handlers are command-shaped; keep dry-runs side-effect free.
        return false;
        (_formatCodeProvider$p = formatCodeProvider.preload) === null || _formatCodeProvider$p === void 0 || (_formatCodeProvider$p = _formatCodeProvider$p.call(formatCodeProvider, language)) === null || _formatCodeProvider$p === void 0 || _formatCodeProvider$p.catch(()=>undefined);
        return false;
    };

});


parcelRegister("1FrRP", function(module, exports) {
$parcel$export(module.exports, "createCodeBlockMenuItem", () => $737634f240452b98$export$76cec325b897d60);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $g6Qq4 = parcelRequire("g6Qq4");

var $hETL4 = parcelRequire("hETL4");

var $dbuPt = parcelRequire("dbuPt");

var $imwtU = parcelRequire("imwtU");
const $737634f240452b98$var$NODE_NAME = 'codeBlock';
const $737634f240452b98$var$CodeBlockMenuItem = ({ api: api, isSuggested: isSuggested })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const handleClick = (event)=>{
        const triggeredFrom = event.nativeEvent instanceof KeyboardEvent || event.nativeEvent.detail === 0 ? (0, $g6Qq4.INPUT_METHOD).KEYBOARD : (0, $g6Qq4.INPUT_METHOD).MOUSE;
        const inputMethod = (0, $g6Qq4.INPUT_METHOD).BLOCK_MENU;
        api === null || api === void 0 || api.core.actions.execute(({ tr: tr })=>{
            var _api$blockMenu;
            const command = api === null || api === void 0 || (_api$blockMenu = api.blockMenu) === null || _api$blockMenu === void 0 ? void 0 : _api$blockMenu.commands.transformNode(tr.doc.type.schema.nodes.codeBlock, {
                inputMethod: inputMethod,
                isSuggested: isSuggested,
                triggeredFrom: triggeredFrom,
                targetTypeName: $737634f240452b98$var$NODE_NAME
            });
            return command ? command({
                tr: tr
            }) : null;
        });
    };
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dbuPt.ToolbarDropdownItem), {
        onClick: handleClick,
        elemBefore: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($imwtU))), {
            label: "",
            size: "small"
        }),
        children: formatMessage((0, $hETL4.messages).codeBlock)
    });
};
const $737634f240452b98$export$76cec325b897d60 = (api)=>{
    return ({ isSuggested: isSuggested } = {})=>/*#__PURE__*/ (0, $dc70d.jsx)($737634f240452b98$var$CodeBlockMenuItem, {
            api: api,
            isSuggested: isSuggested
        });
};

});

parcelRegister("4LYH1", function(module, exports) {
$parcel$export(module.exports, "FormatCodeErrorFlag", () => $846bd273edaa5a96$export$4481d6fe3f264c4b);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $583Mc = parcelRequire("583Mc");

var $5beht = parcelRequire("5beht");

var $2bmUD = parcelRequire("2bmUD");

var $lJzMO = parcelRequire("lJzMO");

var $hkLEY = parcelRequire("hkLEY");

var $cbzce = parcelRequire("cbzce");

var $1LuwP = parcelRequire("1LuwP");
const $846bd273edaa5a96$var$FormatCodeErrorFlagItem = ({ formatCodeError: formatCodeError })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $2bmUD.default), {
        description: formatMessage(formatCodeError.languageSource === 'auto-detected' ? (0, $583Mc.codeBlockButtonMessages).formatCodeFailedAutoDetectedDescription : (0, $583Mc.codeBlockButtonMessages).formatCodeFailedDescription),
        icon: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hkLEY))), {
            color: "var(--ds-icon-danger, #C9372C)",
            label: ""
        }),
        id: formatCodeError.localId,
        title: formatMessage((0, $583Mc.codeBlockButtonMessages).formatCodeFailed)
    });
};
const $846bd273edaa5a96$export$4481d6fe3f264c4b = ({ api: api })=>{
    const { formatCodeErrors: formatCodeErrors } = (0, $5beht.useSharedPluginStateWithSelector)(api, [
        'codeBlock'
    ], (states)=>{
        var _states$codeBlockStat;
        return {
            formatCodeErrors: ((_states$codeBlockStat = states.codeBlockState) === null || _states$codeBlockStat === void 0 ? void 0 : _states$codeBlockStat.formatCodeErrors) ?? {}
        };
    });
    const onDismissed = (0, $bSJIT.useCallback)((localId)=>{
        var _api$core, _api$core2;
        api === null || api === void 0 || (_api$core = api.core) === null || _api$core === void 0 || _api$core.actions.execute(({ tr: tr })=>{
            tr.setMeta((0, $1LuwP.pluginKey), {
                type: (0, $cbzce.ACTIONS).CLEAR_FORMAT_CODE_ERROR,
                data: {
                    localId: localId
                }
            });
            return tr;
        });
        api === null || api === void 0 || (_api$core2 = api.core) === null || _api$core2 === void 0 || _api$core2.actions.focus();
    }, [
        api
    ]);
    const onFlagGroupDismissed = (0, $bSJIT.useCallback)((localId)=>onDismissed(String(localId)), [
        onDismissed
    ]);
    const activeFormatCodeErrors = Object.values(formatCodeErrors);
    if (activeFormatCodeErrors.length === 0) return null;
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $lJzMO.FlagGroup), {
        onDismissed: onFlagGroupDismissed,
        children: activeFormatCodeErrors.map((formatCodeError)=>/*#__PURE__*/ (0, $dc70d.jsx)($846bd273edaa5a96$var$FormatCodeErrorFlagItem, {
                formatCodeError: formatCodeError
            }, formatCodeError.localId))
    });
};

});

parcelRegister("71NmD", function(module, exports) {
$parcel$export(module.exports, "getCodeBlockQuickInsertComponents", () => $2e1059ec60609b99$export$12608b607d657329);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $8iYGb = parcelRequire("8iYGb");

var $b8Hvx = parcelRequire("b8Hvx");

var $9woaI = parcelRequire("9woaI");

var $am2Qg = parcelRequire("am2Qg");

var $akiGw = parcelRequire("akiGw");
const $2e1059ec60609b99$var$previewImageUrls = {
    light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVKE.png',
    dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVH7.png'
};
const $2e1059ec60609b99$export$12608b607d657329 = ({ api: api })=>[
        {
            key: (0, $9woaI.CODE_BLOCK_MENU_ITEM).key,
            type: (0, $9woaI.CODE_BLOCK_MENU_ITEM).type,
            parents: [
                {
                    key: (0, $9woaI.STRUCTURE_SECTION).key,
                    type: (0, $9woaI.STRUCTURE_SECTION).type,
                    rank: (0, $am2Qg.STRUCTURE_SECTION_RANK)[(0, $9woaI.CODE_BLOCK_MENU_ITEM).key]
                }
            ],
            match: (0, $b8Hvx.createQuickInsertMatcher)(({ formatMessage: formatMessage })=>({
                    description: formatMessage((0, $8iYGb.messages).codeblockDescription),
                    keywords: [
                        'code block'
                    ],
                    shortcut: '```',
                    title: formatMessage((0, $8iYGb.messages).codeblock)
                })),
            component: ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $akiGw.CodeBlockQuickInsertMenuItem), {
                    api: api,
                    previewImageUrls: $2e1059ec60609b99$var$previewImageUrls
                })
        }
    ];

});
parcelRegister("akiGw", function(module, exports) {
$parcel$export(module.exports, "CodeBlockQuickInsertMenuItem", () => $f0be745a09c68738$export$959ecdf27b352a49);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $8iYGb = parcelRequire("8iYGb");

var $fT9mF = parcelRequire("fT9mF");

var $64eKJ = parcelRequire("64eKJ");

var $5beht = parcelRequire("5beht");

var $imwtU = parcelRequire("imwtU");

var $kdxmD = parcelRequire("kdxmD");
const $f0be745a09c68738$export$959ecdf27b352a49 = ({ api: api, previewImageUrls: previewImageUrls })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const preview = (0, $bSJIT.useMemo)(()=>previewImageUrls ? {
            image: previewImageUrls,
            attribution: {
                name: formatMessage((0, $64eKJ.messages).previewAttributionAtlassian)
            }
        } : undefined, [
        formatMessage,
        previewImageUrls
    ]);
    const { editorDisabled: editorDisabled } = (0, $5beht.useSharedPluginStateWithSelector)(api, [
        'editorDisabled'
    ], (states)=>{
        var _states$editorDisable;
        return {
            editorDisabled: (_states$editorDisable = states.editorDisabledState) === null || _states$editorDisable === void 0 ? void 0 : _states$editorDisable.editorDisabled
        };
    });
    const onSelect = (0, $bSJIT.useCallback)(({ editorView: editorView, source: source })=>{
        var _api$analytics;
        return (0, $kdxmD.createInsertCodeBlockTransactionWithAnalytics)({
            analyticsAPI: api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions,
            inputMethod: source,
            state: editorView.state
        });
    }, [
        api
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $fT9mF.QuickInsertMenuItem), {
        description: formatMessage((0, $8iYGb.messages).codeblockDescription),
        iconBefore: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($imwtU))), {
            label: ""
        }),
        isDisabled: editorDisabled,
        onSelect: onSelect,
        preview: preview,
        shortcut: "```",
        title: formatMessage((0, $8iYGb.messages).codeblock)
    });
};

});



parcelRegister("io4ZI", function(module, exports) {
$parcel$export(module.exports, "compositionPlugin", () => $8a4f365297edb541$export$afd1652ef5208b);

var $ScC9s = parcelRequire("ScC9s");

var $MPwAV = parcelRequire("MPwAV");
const $8a4f365297edb541$export$afd1652ef5208b = ()=>{
    return {
        name: 'composition',
        getSharedState (editorState) {
            var _pluginKey$getState;
            if (!editorState) return {
                isComposing: false
            };
            return {
                isComposing: !!((_pluginKey$getState = (0, $MPwAV.pluginKey).getState(editorState)) !== null && _pluginKey$getState !== void 0 && _pluginKey$getState.isComposing)
            };
        },
        pmPlugins () {
            return [
                {
                    name: 'composition',
                    plugin: ()=>(0, $ScC9s.default)()
                }
            ];
        }
    };
};

});
parcelRegister("ScC9s", function(module, exports) {
$parcel$export(module.exports, "default", () => $979d8b4d99c51347$export$2e2bcd8739ae039);

var $f7Kk4 = parcelRequire("f7Kk4");

var $kuD5k = parcelRequire("kuD5k");

var $MPwAV = parcelRequire("MPwAV");
const $979d8b4d99c51347$var$isLinux = ()=>navigator.userAgent.indexOf('Linux') >= 0;
var $979d8b4d99c51347$export$2e2bcd8739ae039 = ()=>new (0, $f7Kk4.SafePlugin)({
        key: (0, $MPwAV.pluginKey),
        state: {
            init: ()=>({
                    isComposing: false,
                    zeroWidthSpacePos: undefined
                }),
            apply: (tr, value)=>{
                const isComposing = tr.getMeta((0, $MPwAV.pluginKey));
                const zeroWidthSpacePos = tr.getMeta('zeroWidthSpacePos');
                if (typeof isComposing === 'undefined') return value;
                return {
                    isComposing: isComposing,
                    zeroWidthSpacePos: zeroWidthSpacePos
                };
            }
        },
        props: {
            handleDOMEvents: {
                compositionstart: (view, event)=>{
                    const { tr: tr } = view.state;
                    tr.setMeta((0, $MPwAV.pluginKey), true);
                    // only apply for linux and cursor is at start of line
                    if ($979d8b4d99c51347$var$isLinux() && view.state.selection.$from.parentOffset === 0) {
                        tr.insertText((0, $kuD5k.ZERO_WIDTH_SPACE));
                        // remember the position of inserted zero width space
                        tr.setMeta('zeroWidthSpacePos', view.state.selection.$from.pos);
                    }
                    view.dispatch(tr);
                    return false;
                },
                compositionend: (view, event)=>{
                    const { tr: tr } = view.state;
                    tr.setMeta((0, $MPwAV.pluginKey), false);
                    if ($979d8b4d99c51347$var$isLinux()) {
                        var _pluginKey$getState;
                        const zeroWidthSpacePos = (_pluginKey$getState = (0, $MPwAV.pluginKey).getState(view.state)) === null || _pluginKey$getState === void 0 ? void 0 : _pluginKey$getState.zeroWidthSpacePos;
                        if (typeof zeroWidthSpacePos !== 'undefined') tr.deleteRange(zeroWidthSpacePos, zeroWidthSpacePos + 1);
                        tr.setMeta('zeroWidthSpacePos', undefined);
                    }
                    view.dispatch(tr);
                    return false;
                }
            }
        }
    });

});
parcelRegister("MPwAV", function(module, exports) {
$parcel$export(module.exports, "pluginKey", () => $269d5ee8230385ad$export$18d4026d1ea86bb1);

var $cw0wu = parcelRequire("cw0wu");
const $269d5ee8230385ad$export$18d4026d1ea86bb1 = new (0, $cw0wu.PluginKey)('compositionPlugin');

});



parcelRegister("gUNXe", function(module, exports) {
$parcel$export(module.exports, "contextIdentifierPlugin", () => $cc04576f9e8fd80e$export$43b392516e89a467);

var $lpFBq = parcelRequire("lpFBq");
const $cc04576f9e8fd80e$export$43b392516e89a467 = ({ config: config, api: api })=>{
    return {
        name: 'contextIdentifier',
        commands: {
            setProvider: (config)=>({ tr: tr })=>{
                    var _api$contextIdentifie;
                    // If no change, don't dispatch
                    if ((config === null || config === void 0 ? void 0 : config.contextIdentifierProvider) === (api === null || api === void 0 || (_api$contextIdentifie = api.contextIdentifier) === null || _api$contextIdentifie === void 0 || (_api$contextIdentifie = _api$contextIdentifie.sharedState.currentState()) === null || _api$contextIdentifie === void 0 ? void 0 : _api$contextIdentifie.contextIdentifierProvider)) return null;
                    return tr.setMeta((0, $lpFBq.pluginKey), {
                        contextIdentifierProvider: config === null || config === void 0 ? void 0 : config.contextIdentifierProvider
                    });
                }
        },
        getSharedState (state) {
            var _pluginKey$getState;
            if (!state) return undefined;
            return {
                contextIdentifierProvider: (_pluginKey$getState = (0, $lpFBq.pluginKey).getState(state)) === null || _pluginKey$getState === void 0 ? void 0 : _pluginKey$getState.contextIdentifierProvider
            };
        },
        pmPlugins: ()=>{
            return [
                {
                    name: 'contextIdentifier',
                    plugin: (0, $lpFBq.createPlugin)(config, api)
                }
            ];
        }
    };
};

});
parcelRegister("lpFBq", function(module, exports) {
$parcel$export(module.exports, "pluginKey", () => $d70dc91bdf21ab87$export$18d4026d1ea86bb1);
$parcel$export(module.exports, "createPlugin", () => $d70dc91bdf21ab87$export$ae829ec7b2625219);

var $f7Kk4 = parcelRequire("f7Kk4");

var $cw0wu = parcelRequire("cw0wu");
const $d70dc91bdf21ab87$export$18d4026d1ea86bb1 = new (0, $cw0wu.PluginKey)('contextIdentiferPlugin');
async function $d70dc91bdf21ab87$var$updateContextIdentifier(config, api) {
    var _api$core, _api$contextIdentifie;
    const provider = await config.contextIdentifierProvider;
    api === null || api === void 0 || (_api$core = api.core) === null || _api$core === void 0 || _api$core.actions.execute(api === null || api === void 0 || (_api$contextIdentifie = api.contextIdentifier) === null || _api$contextIdentifie === void 0 ? void 0 : _api$contextIdentifie.commands.setProvider({
        contextIdentifierProvider: provider
    }));
}
const $d70dc91bdf21ab87$export$ae829ec7b2625219 = (initialConfig, api)=>()=>{
        if (initialConfig) $d70dc91bdf21ab87$var$updateContextIdentifier(initialConfig, api);
        return new (0, $f7Kk4.SafePlugin)({
            key: $d70dc91bdf21ab87$export$18d4026d1ea86bb1,
            state: {
                init: ()=>initialConfig,
                apply: (tr, pluginState)=>{
                    const meta = tr.getMeta($d70dc91bdf21ab87$export$18d4026d1ea86bb1);
                    return meta ? meta : pluginState;
                }
            }
        });
    };

});


parcelRegister("1XFnB", function(module, exports) {
$parcel$export(module.exports, "copyButtonPlugin", () => $ab9f7f24d6473ab1$export$ea22bdb37423f02c);

var $h4NUZ = parcelRequire("h4NUZ");

var $4wvUO = parcelRequire("4wvUO");
const $ab9f7f24d6473ab1$export$ea22bdb37423f02c = ({ api: api })=>{
    var _api$analytics;
    return {
        name: 'copyButton',
        pmPlugins () {
            return [
                {
                    name: 'copyButton',
                    plugin: ()=>(0, $h4NUZ.default)()
                }
            ];
        },
        actions: {
            processCopyButtonItems: (0, $4wvUO.processCopyButtonItems)(api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions, api),
            afterCopy: (message)=>(0, $4wvUO.afterCopy)(api)(message)
        }
    };
};

});
parcelRegister("h4NUZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $d81ecfa09a8bc13e$export$2e2bcd8739ae039);

var $f7Kk4 = parcelRequire("f7Kk4");

var $a3b9P = parcelRequire("a3b9P");

var $8S0bU = parcelRequire("8S0bU");
function $d81ecfa09a8bc13e$export$6867b9cd7a8c8a75({ $pos: $pos, markType: markType }) {
    const hasMark = $pos.doc.rangeHasMark($pos.pos, Math.min($pos.pos + 1, $pos.doc.nodeSize), markType);
    if (!hasMark) return false;
    if ($pos.parent.childCount === 1) {
        const nodePosition = $pos.pos;
        const maybeNode = $pos.doc.nodeAt(nodePosition);
        if (!maybeNode || !maybeNode.isText) return false;
        const start = $pos.pos - $pos.parentOffset;
        const end = start + maybeNode.nodeSize;
        return {
            start: start,
            end: end
        };
    }
    if ($pos.parent.childCount > 1) {
        const start = $pos.pos - $pos.textOffset;
        const maybeTextNode = $pos.doc.nodeAt(start);
        if (!maybeTextNode || !maybeTextNode.isText) return false;
        const end = start + maybeTextNode.nodeSize;
        return {
            start: start,
            end: end
        };
    }
    return false;
}
function $d81ecfa09a8bc13e$var$getMarkSelectionDecorationStartAndEnd({ markType: markType, transaction: transaction }) {
    const anchorPositions = $d81ecfa09a8bc13e$export$6867b9cd7a8c8a75({
        $pos: transaction.selection.$anchor,
        markType: markType
    });
    if (anchorPositions) return {
        ...anchorPositions,
        markType: markType
    };
    const headPositions = $d81ecfa09a8bc13e$export$6867b9cd7a8c8a75({
        $pos: transaction.selection.$head,
        markType: markType
    });
    if (headPositions) return {
        ...headPositions,
        markType: markType
    };
    return undefined;
}
function $d81ecfa09a8bc13e$export$ea22bdb37423f02c() {
    return new (0, $f7Kk4.SafePlugin)({
        key: (0, $8S0bU.copyButtonPluginKey),
        state: {
            init () {
                return {
                    copied: false,
                    markSelection: undefined
                };
            },
            apply (tr, currentPluginState) {
                const meta = tr.getMeta((0, $8S0bU.copyButtonPluginKey));
                if ((meta === null || meta === void 0 ? void 0 : meta.copied) !== undefined) return {
                    copied: meta.copied,
                    markSelection: undefined
                };
                if (meta !== null && meta !== void 0 && meta.showSelection) return {
                    copied: currentPluginState.copied,
                    markSelection: $d81ecfa09a8bc13e$var$getMarkSelectionDecorationStartAndEnd({
                        markType: meta.markType,
                        transaction: tr
                    })
                };
                if (meta !== null && meta !== void 0 && meta.removeSelection) return {
                    copied: currentPluginState.copied,
                    markSelection: undefined
                };
                if (currentPluginState.markSelection) return {
                    copied: currentPluginState.copied,
                    markSelection: $d81ecfa09a8bc13e$var$getMarkSelectionDecorationStartAndEnd({
                        markType: currentPluginState.markSelection.markType,
                        transaction: tr
                    })
                };
                return currentPluginState;
            }
        },
        props: {
            decorations (_state) {
                // Showing visual hints for the hyperlink copy button has been disabled
                // due to an issue where invalid hyperlink marks cause the floating toolbar
                // to jump around when the copy button is hovered.
                // See the following bug for details -- once that is resolved -- the visual
                // hints can be re enabled.
                // https://product-fabric.atlassian.net/browse/DTR-722
                // const copyButtonPluginState = copyButtonPluginKey.getState(
                //   state,
                // ) as CopyButtonPluginState;
                // if (copyButtonPluginState.markSelection) {
                //   const { start, end } = copyButtonPluginState.markSelection;
                //   return DecorationSet.create(state.doc, [
                //     Decoration.inline(start, end, {
                //       class: 'ProseMirror-fake-text-selection',
                //     }),
                //   ]);
                // }
                return (0, $a3b9P.DecorationSet).empty;
            }
        }
    });
}
var $d81ecfa09a8bc13e$export$2e2bcd8739ae039 = $d81ecfa09a8bc13e$export$ea22bdb37423f02c;

});
parcelRegister("8S0bU", function(module, exports) {
$parcel$export(module.exports, "copyButtonPluginKey", () => $c602bae737f7b6f1$export$e41a18c2cdafffa9);

var $cw0wu = parcelRequire("cw0wu");
const $c602bae737f7b6f1$export$e41a18c2cdafffa9 = new (0, $cw0wu.PluginKey)('copyButtonPlugin');

});


parcelRegister("4wvUO", function(module, exports) {
$parcel$export(module.exports, "afterCopy", () => $3f311cd4de27a565$export$b372d635c5d31afc);
$parcel$export(module.exports, "processCopyButtonItems", () => $3f311cd4de27a565$export$f61ed03c42ac876f);

var $fNLdd = parcelRequire("fNLdd");

var $c81bI = parcelRequire("c81bI");

var $cQU1U = parcelRequire("cQU1U");

var $8S0bU = parcelRequire("8S0bU");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $3f311cd4de27a565$var$isSeparator(item) {
    return (item === null || item === void 0 ? void 0 : item.type) === 'separator';
}
function $3f311cd4de27a565$var$isNodeOptions(options) {
    return 'nodeType' in options && options.nodeType !== undefined;
}
const $3f311cd4de27a565$export$b372d635c5d31afc = (api)=>(message)=>{
        var _api$accessibilityUti;
        api === null || api === void 0 || api.core.actions.execute(({ tr: tr })=>{
            return tr.setMeta((0, $8S0bU.copyButtonPluginKey), {
                copied: true
            }).setMeta('scrollIntoView', false);
        });
        api === null || api === void 0 || (_api$accessibilityUti = api.accessibilityUtils) === null || _api$accessibilityUti === void 0 || _api$accessibilityUti.actions.ariaNotify(message, {
            priority: 'important'
        });
    };
function $3f311cd4de27a565$export$518afae27d2d4b23(options, hoverDecoration, editorAnalyticsApi, api) {
    const { state: state, formatMessage: formatMessage, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onFocus: onFocus, onBlur: onBlur } = options;
    const copyButtonState = (0, $8S0bU.copyButtonPluginKey).getState(state);
    let buttonActionHandlers;
    if ($3f311cd4de27a565$var$isNodeOptions(options)) {
        const { onClick: onClick } = options;
        buttonActionHandlers = {
            onClick: (0, $cQU1U.createToolbarCopyCommandForNode)(options.nodeType, editorAnalyticsApi, api, formatMessage((0, $fNLdd.default).copiedToClipboard)),
            // Note for future changes: these two handlers should perform
            // the same action.
            onMouseEnter: onMouseEnter || (hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(options.nodeType, true, 'ak-editor-selected-node')),
            onFocus: onFocus || (hoverDecoration === null || hoverDecoration === void 0 ? void 0 : hoverDecoration(options.nodeType, true, 'ak-editor-selected-node')),
            // Note for future changes: these two handlers should perform
            // the same action.
            onMouseLeave: (0, $cQU1U.resetCopiedState)(options.nodeType, hoverDecoration, onMouseLeave),
            onBlur: (0, $cQU1U.resetCopiedState)(options.nodeType, hoverDecoration, onBlur)
        };
        if (onClick) buttonActionHandlers.onClick = (editorState, dispatch, editorView)=>{
            if (onClick(editorState, dispatch, editorView)) {
                $3f311cd4de27a565$export$b372d635c5d31afc(api)(formatMessage((0, $fNLdd.default).copiedToClipboard));
                return true;
            }
            return false;
        };
    } else buttonActionHandlers = {
        onClick: (0, $cQU1U.createToolbarCopyCommandForMark)(options.markType, editorAnalyticsApi),
        onMouseEnter: (0, $cQU1U.getProvideMarkVisualFeedbackForCopyButtonCommand)(options.markType),
        onFocus: (0, $cQU1U.getProvideMarkVisualFeedbackForCopyButtonCommand)(options.markType),
        onMouseLeave: (0, $cQU1U.removeMarkVisualFeedbackForCopyButtonCommand),
        onBlur: (0, $cQU1U.removeMarkVisualFeedbackForCopyButtonCommand)
    };
    return {
        id: 'editor.floatingToolbar.copy',
        type: 'button',
        appearance: 'subtle',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($c81bI))),
        title: formatMessage(copyButtonState !== null && copyButtonState !== void 0 && copyButtonState.copied ? (0, $fNLdd.default).copiedToClipboard : (0, $fNLdd.default).copyToClipboard),
        ...buttonActionHandlers,
        hideTooltipOnClick: false,
        hasNewContentOnTriggerClick: true,
        tabIndex: null
    };
}
const $3f311cd4de27a565$export$f61ed03c42ac876f = (editorAnalyticsApi, api)=>(_state)=>{
        return (items, hoverDecoration)=>items.flatMap((item)=>{
                switch(item.type){
                    case 'copy-button':
                        if (item !== null && item !== void 0 && item.hidden) return [];
                        return item === null || item === void 0 ? void 0 : item.items.map((copyButtonItem)=>$3f311cd4de27a565$var$isSeparator(copyButtonItem) ? copyButtonItem : $3f311cd4de27a565$export$518afae27d2d4b23(copyButtonItem, hoverDecoration, editorAnalyticsApi, api));
                    default:
                        return [
                            item
                        ];
                }
            });
    };

});
parcelRegister("cQU1U", function(module, exports) {
$parcel$export(module.exports, "createToolbarCopyCommandForMark", () => $2f8aedfc0265f458$export$61f33363e77ed28);
$parcel$export(module.exports, "getProvideMarkVisualFeedbackForCopyButtonCommand", () => $2f8aedfc0265f458$export$5887c7b152626490);
$parcel$export(module.exports, "removeMarkVisualFeedbackForCopyButtonCommand", () => $2f8aedfc0265f458$export$e52b1d5c60d367b8);
$parcel$export(module.exports, "createToolbarCopyCommandForNode", () => $2f8aedfc0265f458$export$be806b3b778a7682);
$parcel$export(module.exports, "resetCopiedState", () => $2f8aedfc0265f458$export$3e0b07341e7576a);

var $g6Qq4 = parcelRequire("g6Qq4");

var $kAhws = parcelRequire("kAhws");

var $j0iaN = parcelRequire("j0iaN");

var $8S0bU = parcelRequire("8S0bU");
function $2f8aedfc0265f458$export$61f33363e77ed28(markType, editorAnalyticsApi) {
    function command(state, dispatch) {
        const textNode = state.tr.selection.$head.parent.maybeChild(state.tr.selection.$head.index());
        if (!textNode) return false;
        if (dispatch) {
            // As calling copyHTMLToClipboard causes side effects -- we only run this when
            // dispatch is provided -- as otherwise the consumer is only testing to see if
            // the action is availble.
            const domNode = (0, $j0iaN.toDOM)(textNode, state.schema);
            if (domNode) {
                const div = document.createElement('div');
                const p = document.createElement('p');
                div.appendChild(p);
                p.appendChild(domNode);
                // The "1 1" refers to the start and end depth of the slice
                // since we're copying the text inside a paragraph, it will always be 1 1
                // https://github.com/ProseMirror/prosemirror-view/blob/master/src/clipboard.ts#L32
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                div.firstChild.setAttribute('data-pm-slice', '1 1 []');
                // If we're copying a hyperlink, we'd copy the url as the fallback plain text
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const linkUrl = domNode.getAttribute('href');
                (0, $kAhws.copyHTMLToClipboard)(div, markType.name === 'link' && linkUrl ? linkUrl : undefined);
            }
            const copyToClipboardTr = state.tr;
            copyToClipboardTr.setMeta((0, $8S0bU.copyButtonPluginKey), {
                copied: true
            });
            const analyticsPayload = (0, $kAhws.getAnalyticsPayload)(state, (0, $g6Qq4.ACTION).COPIED);
            if (analyticsPayload && editorAnalyticsApi) {
                var _editorAnalyticsApi$a;
                analyticsPayload.attributes.inputMethod = (0, $g6Qq4.INPUT_METHOD).FLOATING_TB;
                analyticsPayload.attributes.markType = markType.name;
                editorAnalyticsApi === null || editorAnalyticsApi === void 0 || (_editorAnalyticsApi$a = editorAnalyticsApi.attachAnalyticsEvent) === null || _editorAnalyticsApi$a === void 0 || _editorAnalyticsApi$a.call(editorAnalyticsApi, analyticsPayload)(copyToClipboardTr);
            }
            dispatch(copyToClipboardTr);
        }
        return true;
    }
    return command;
}
function $2f8aedfc0265f458$export$5887c7b152626490(markType) {
    function provideMarkVisualFeedbackForCopyButtonCommand(state, dispatch) {
        const tr = state.tr;
        tr.setMeta((0, $8S0bU.copyButtonPluginKey), {
            showSelection: true,
            markType: markType
        });
        if (dispatch) dispatch(tr);
        return true;
    }
    return provideMarkVisualFeedbackForCopyButtonCommand;
}
function $2f8aedfc0265f458$export$e52b1d5c60d367b8(state, dispatch) {
    const tr = state.tr;
    tr.setMeta((0, $8S0bU.copyButtonPluginKey), {
        removeSelection: true
    });
    const copyButtonState = (0, $8S0bU.copyButtonPluginKey).getState(state);
    if (copyButtonState !== null && copyButtonState !== void 0 && copyButtonState.copied) tr.setMeta((0, $8S0bU.copyButtonPluginKey), {
        copied: false
    });
    if (dispatch) dispatch(tr);
    return true;
}
const $2f8aedfc0265f458$export$be806b3b778a7682 = (nodeType, editorAnalyticsApi, api, onClickMessage)=>(state, dispatch)=>{
        const { tr: tr, schema: schema } = state;
        // This command should only be triggered by the Copy button in the floating toolbar
        // which is only visible when selection is inside the target node
        const contentNodeWithPos = (0, $j0iaN.getSelectedNodeOrNodeParentByNodeType)({
            nodeType: nodeType,
            selection: tr.selection
        });
        if (!contentNodeWithPos) return false;
        const copyToClipboardTr = tr;
        copyToClipboardTr.setMeta((0, $8S0bU.copyButtonPluginKey), {
            copied: true
        });
        const analyticsPayload = (0, $kAhws.getAnalyticsPayload)(state, (0, $g6Qq4.ACTION).COPIED);
        if (analyticsPayload && editorAnalyticsApi) {
            var _editorAnalyticsApi$a2;
            analyticsPayload.attributes.inputMethod = (0, $g6Qq4.INPUT_METHOD).FLOATING_TB;
            analyticsPayload.attributes.nodeType = contentNodeWithPos.node.type.name;
            editorAnalyticsApi === null || editorAnalyticsApi === void 0 || (_editorAnalyticsApi$a2 = editorAnalyticsApi.attachAnalyticsEvent) === null || _editorAnalyticsApi$a2 === void 0 || _editorAnalyticsApi$a2.call(editorAnalyticsApi, analyticsPayload)(copyToClipboardTr);
        }
        if (dispatch) {
            // As calling copyHTMLToClipboard causes side effects -- we only run this when
            // dispatch is provided -- as otherwise the consumer is only testing to see if
            // the action is availble.
            const domNode = (0, $j0iaN.toDOM)(contentNodeWithPos.node, schema);
            (0, $j0iaN.copyDomNode)(domNode, contentNodeWithPos.node.type, tr.selection);
            copyToClipboardTr.setMeta('scrollIntoView', false);
            dispatch(copyToClipboardTr);
        }
        /**
   * A11y-10275 This prop api drilled from the plugin all the way down to the usage
   * because it's the safest way to ensure accessibilityUtils is available and not
   * undefined.
   *
   * see thread https://atlassian.slack.com/archives/C02CDUS3SUS/p1744256326459569
   */ if (onClickMessage) {
            var _api$accessibilityUti;
            api === null || api === void 0 || (_api$accessibilityUti = api.accessibilityUtils) === null || _api$accessibilityUti === void 0 || _api$accessibilityUti.actions.ariaNotify(onClickMessage, {
                priority: 'important'
            });
        }
        return true;
    };
const $2f8aedfc0265f458$export$3e0b07341e7576a = (nodeType, hoverDecoration, onMouseLeave)=>(state, dispatch)=>{
        let customTr = state.tr;
        // Avoid multipe dispatch
        // https://product-fabric.atlassian.net/wiki/spaces/E/pages/2241659456/All+about+dispatch+and+why+there+shouldn+t+be+multiple#How-do-I-avoid-them%3F
        const customDispatch = (tr)=>{
            customTr = tr;
        };
        onMouseLeave ? onMouseLeave(state, customDispatch) : hoverDecoration === null || hoverDecoration === void 0 || hoverDecoration(nodeType, false)(state, customDispatch);
        const copyButtonState = (0, $8S0bU.copyButtonPluginKey).getState(state);
        if (copyButtonState !== null && copyButtonState !== void 0 && copyButtonState.copied) customTr.setMeta((0, $8S0bU.copyButtonPluginKey), {
            copied: false
        });
        if (dispatch) dispatch(customTr);
        return true;
    };

});



parcelRegister("bXida", function(module, exports) {
$parcel$export(module.exports, "decorationsPlugin", () => $c8e558618aca02e3$export$1c07ef1814918eb5);

var $bYwh2 = parcelRequire("bYwh2");

var $66XQ7 = parcelRequire("66XQ7");
const $c8e558618aca02e3$export$1c07ef1814918eb5 = ()=>({
        name: 'decorations',
        pmPlugins () {
            return [
                {
                    name: 'decorationPlugin',
                    plugin: ()=>(0, $66XQ7.default)()
                }
            ];
        },
        actions: {
            hoverDecoration: $66XQ7.hoverDecoration,
            removeDecoration: $66XQ7.removeDecoration
        },
        getSharedState (editorState) {
            if (!editorState) return {
                decoration: undefined
            };
            return (0, $66XQ7.decorationStateKey).getState(editorState);
        },
        commands: {
            hoverDecoration: ({ add: add, className: className })=>(0, $bYwh2.hoverDecorationCommand)({
                    add: add,
                    className: className
                }),
            removeDecoration: ()=>(0, $bYwh2.removeDecorationCommand)()
        }
    });

});
parcelRegister("bYwh2", function(module, exports) {
$parcel$export(module.exports, "hoverDecorationCommand", () => $f955f554915e95cc$export$84d8b6d3cf5f2fb4);
$parcel$export(module.exports, "removeDecorationCommand", () => $f955f554915e95cc$export$14b7848c5cb6944c);

var $6Cbfp = parcelRequire("6Cbfp");

var $cw0wu = parcelRequire("cw0wu");

var $a3b9P = parcelRequire("a3b9P");

var $2E7OD = parcelRequire("2E7OD");

var $jCYj3 = parcelRequire("jCYj3");

var $a7bfT = parcelRequire("a7bfT");

var $66XQ7 = parcelRequire("66XQ7");
const $f955f554915e95cc$export$84d8b6d3cf5f2fb4 = ({ add: add, className: className = 'danger selected', selection: providedSelection })=>({ tr: tr })=>{
        const selection = providedSelection || tr.selection;
        const decorations = [];
        const handleTableSelection = (pos = selection.$from)=>{
            const table = (0, $a7bfT.findTableClosestToPos)(pos);
            if (!table) return tr;
            const tableNode = table.node;
            const tablePos = table.pos;
            decorations.push((0, $a3b9P.Decoration).node(tablePos, tablePos + tableNode.nodeSize, {
                class: className
            }, {
                key: `decorationNode-table-${tablePos}`
            }));
            const map = (0, $jCYj3.TableMap).get(tableNode);
            const cellPositions = new Set(map.map);
            cellPositions.forEach((cellPos)=>{
                const docPos = tablePos + cellPos + 1;
                const cell = tableNode.nodeAt(cellPos);
                if (cell) decorations.push((0, $a3b9P.Decoration).node(docPos, docPos + cell.nodeSize, {
                    class: className
                }, {
                    key: `decorationNode-cell-${docPos}`
                }));
            });
        };
        const handleNodeSelection = (node, pos)=>{
            const from = pos;
            const to = from + node.nodeSize;
            decorations.push((0, $a3b9P.Decoration).node(from, to, {
                class: className
            }, {
                key: 'decorationNode'
            }));
            if (node.type.name === 'layoutSection' || node.type.name === 'layoutColumn') {
                const startOfInsideOfContainer = tr.doc.resolve(from + 1);
                const endOfInsideOfContainer = tr.doc.resolve(to - 1);
                handleNodesSelection(startOfInsideOfContainer, endOfInsideOfContainer);
            }
        };
        const handleNodesSelection = ($from, $to)=>{
            let currentPos = $from.pos;
            const sourceNodes = (0, $6Cbfp.getSourceNodesFromSelectionRange)(tr, (0, $cw0wu.TextSelection).create(tr.doc, currentPos, $to.pos));
            sourceNodes.forEach((sourceNode)=>{
                if (sourceNode.type.name === 'table') {
                    const startPosOfTable = tr.doc.resolve(currentPos + 3);
                    handleTableSelection(startPosOfTable);
                } else handleNodeSelection(sourceNode, currentPos);
                currentPos += sourceNode.nodeSize;
            });
        };
        // Selecting a table directly: CellSelection
        if (selection instanceof (0, $2E7OD.CellSelection)) handleTableSelection();
        // multiselect: TextSelection
        if (selection instanceof (0, $cw0wu.TextSelection)) handleNodesSelection(selection.$from, selection.$to);
        if (selection instanceof (0, $cw0wu.NodeSelection)) handleNodeSelection(selection.node, selection.from);
        // If no decorations were created, return early
        if (decorations.length === 0) return tr;
        const hasDangerDecorations = className.split(' ').includes('danger');
        tr.setMeta((0, $66XQ7.decorationStateKey), {
            action: add ? (0, $66XQ7.ACTIONS).DECORATION_ADD : (0, $66XQ7.ACTIONS).DECORATION_REMOVE,
            data: (0, $a3b9P.DecorationSet).create(tr.doc, decorations),
            hasDangerDecorations: hasDangerDecorations
        }).setMeta('addToHistory', false);
        return tr;
    };
const $f955f554915e95cc$export$14b7848c5cb6944c = ()=>({ tr: tr })=>{
        return tr.setMeta((0, $66XQ7.decorationStateKey), {
            action: (0, $66XQ7.ACTIONS).DECORATION_REMOVE
        });
    };

});
parcelRegister("66XQ7", function(module, exports) {
$parcel$export(module.exports, "decorationStateKey", () => $65be898971b65098$export$385f768f10dabdd5);
$parcel$export(module.exports, "ACTIONS", () => $65be898971b65098$export$92a1a3b7554e9387);
$parcel$export(module.exports, "removeDecoration", () => $65be898971b65098$export$ea377ae2b4b58797);
$parcel$export(module.exports, "hoverDecoration", () => $65be898971b65098$export$fbf24964a8aac61c);
$parcel$export(module.exports, "default", () => $65be898971b65098$export$2e2bcd8739ae039);

var $f7Kk4 = parcelRequire("f7Kk4");

var $cw0wu = parcelRequire("cw0wu");

var $gab48 = parcelRequire("gab48");

var $a3b9P = parcelRequire("a3b9P");
const $65be898971b65098$export$385f768f10dabdd5 = new (0, $cw0wu.PluginKey)('decorationPlugin');
var $65be898971b65098$export$92a1a3b7554e9387 = /*#__PURE__*/ function(ACTIONS) {
    ACTIONS[ACTIONS["DECORATION_ADD"] = 0] = "DECORATION_ADD";
    ACTIONS[ACTIONS["DECORATION_REMOVE"] = 1] = "DECORATION_REMOVE";
    return ACTIONS;
}({});
const $65be898971b65098$export$ea377ae2b4b58797 = (state, dispatch)=>{
    const { tr: tr } = state;
    const { decoration: decoration } = $65be898971b65098$export$385f768f10dabdd5.getState(state);
    if (decoration && dispatch) {
        dispatch(tr.setMeta($65be898971b65098$export$385f768f10dabdd5, {
            action: 1
        }));
        return true;
    }
    return false;
};
const $65be898971b65098$export$fbf24964a8aac61c = (nodeType, add, className = 'danger')=>(state, dispatch)=>{
        let from;
        let parentNode;
        if (state.selection instanceof (0, $cw0wu.NodeSelection)) {
            const selectedNode = state.selection.node;
            const nodeTypes = Array.isArray(nodeType) ? nodeType : [
                nodeType
            ];
            const isNodeTypeMatching = nodeTypes.indexOf(selectedNode.type) > -1;
            // This adds danger styling if the selected node is the one that requires
            // the decoration to be added, e.g. if a layout is selected and the user
            // hovers over the layout's delete button.
            if (isNodeTypeMatching) {
                from = state.selection.from;
                parentNode = selectedNode;
            }
        }
        // This adds danger styling if the selection is not a node selection, OR if
        // the selected node is a child of the one that requires the decoration to
        // be added, e.g. if a decision item is selected inside a layout and the
        // user hovers over the layout's delete button.
        const foundParentNode = (0, $gab48.findParentNodeOfType)(nodeType)(state.selection);
        if (from === undefined && foundParentNode) {
            from = foundParentNode.pos;
            parentNode = foundParentNode.node;
        }
        // Note: can't use !from as from could be 0, which is falsy but valid
        if (from === undefined || parentNode === undefined) return false;
        if (dispatch) dispatch(state.tr.setMeta($65be898971b65098$export$385f768f10dabdd5, {
            action: add ? 0 : 1,
            data: (0, $a3b9P.Decoration).node(from, from + parentNode.nodeSize, {
                class: className
            }, {
                key: 'decorationNode'
            })
        }).setMeta('addToHistory', false));
        return true;
    };
var $65be898971b65098$export$2e2bcd8739ae039 = ()=>{
    return new (0, $f7Kk4.SafePlugin)({
        key: $65be898971b65098$export$385f768f10dabdd5,
        state: {
            init: ()=>({
                    decoration: undefined
                }),
            apply (tr, pluginState) {
                if (pluginState.decoration && pluginState.decoration instanceof (0, $a3b9P.Decoration)) {
                    const mapResult = tr.mapping.mapResult(pluginState.decoration.from);
                    if (mapResult.deleted) pluginState = {
                        decoration: undefined
                    };
                }
                if (pluginState.decoration && pluginState.decoration instanceof (0, $a3b9P.DecorationSet)) pluginState.decoration = pluginState.decoration.map(tr.mapping, tr.doc);
                const meta = tr.getMeta($65be898971b65098$export$385f768f10dabdd5);
                if (!meta) return pluginState;
                switch(meta.action){
                    case 0:
                        return {
                            decoration: meta.data,
                            hasDangerDecorations: meta.hasDangerDecorations
                        };
                    case 1:
                        return {
                            decoration: undefined,
                            hasDangerDecorations: undefined
                        };
                    default:
                        return pluginState;
                }
            }
        },
        props: {
            decorations (state) {
                const { doc: doc } = state;
                const { decoration: decoration } = $65be898971b65098$export$385f768f10dabdd5.getState(state);
                if (decoration instanceof (0, $a3b9P.Decoration)) return (0, $a3b9P.DecorationSet).create(doc, [
                    decoration
                ]);
                if (decoration instanceof (0, $a3b9P.DecorationSet)) return decoration;
                return null;
            }
        }
    });
};

});



parcelRegister("c7D2T", function(module, exports) {
$parcel$export(module.exports, "editorDisabledPlugin", () => $041c7803242c24e3$export$db5fb3a4c4390f03);

var $9wZWu = parcelRequire("9wZWu");

var $f7Kk4 = parcelRequire("f7Kk4");

var $3TnFr = parcelRequire("3TnFr");

var $cw0wu = parcelRequire("cw0wu");

var $2Yjgh = parcelRequire("2Yjgh");
const $041c7803242c24e3$export$18d4026d1ea86bb1 = new (0, $cw0wu.PluginKey)('editorDisabledPlugin');
const { getPluginState: $041c7803242c24e3$var$getPluginState } = (0, $3TnFr.pluginFactory)($041c7803242c24e3$export$18d4026d1ea86bb1, (0, $2Yjgh.reducer));
/*
Stores the state of the editor enabled/disabled for panel and floating
toolbar to subscribe to through useSharedPluginState. Otherwise the NodeViews
won't re-render when it changes.
*/ function $041c7803242c24e3$var$createPlugin(dispatch, options) {
    const scheduleEditorDisabledUpdate = (0, $9wZWu.default)((view)=>{
        if ($041c7803242c24e3$var$getPluginState(view.state).editorDisabled !== !view.editable) {
            const disabledMeta = {
                editorDisabled: !view.editable,
                disabledByPlugin: $041c7803242c24e3$var$getPluginState(view.state).disabledByPlugin
            };
            const tr = view.state.tr.setMeta($041c7803242c24e3$export$18d4026d1ea86bb1, disabledMeta).setMeta('editorDisabledPlugin', disabledMeta);
            tr.setMeta('isLocal', true);
            view.dispatch(tr);
        }
    });
    return new (0, $f7Kk4.SafePlugin)({
        key: $041c7803242c24e3$export$18d4026d1ea86bb1,
        state: {
            init: ()=>{
                return {
                    editorDisabled: (options === null || options === void 0 ? void 0 : options.initialDisabledState) ?? false,
                    disabledByPlugin: false
                };
            },
            apply: (tr, pluginState)=>{
                const meta = tr.getMeta($041c7803242c24e3$export$18d4026d1ea86bb1);
                if (meta) {
                    if ('action' in meta) return (0, $2Yjgh.reducer)(pluginState, meta);
                    return pluginState.editorDisabled !== meta.editorDisabled ? {
                        ...pluginState,
                        ...meta
                    } : pluginState;
                }
                return pluginState;
            }
        },
        props: {
            // If we set to undefined it respects the previous value.
            // Prosemirror doesn't have this typed correctly for this type of behaviour
            // @ts-expect-error
            editable: (state)=>{
                const { disabledByPlugin: disabledByPlugin } = $041c7803242c24e3$export$18d4026d1ea86bb1.getState(state) ?? {
                    disabledByPlugin: false
                };
                return disabledByPlugin ? false : undefined;
            }
        },
        view: (view)=>{
            // schedule on mount
            scheduleEditorDisabledUpdate(view);
            return {
                update (view) {
                    scheduleEditorDisabledUpdate(view);
                },
                destroy () {
                    scheduleEditorDisabledUpdate.cancel();
                }
            };
        }
    });
}
const $041c7803242c24e3$export$db5fb3a4c4390f03 = ({ config: options = {} })=>({
        name: 'editorDisabled',
        getSharedState (editorState) {
            if (!editorState) return {
                editorDisabled: false
            };
            const pluginState = $041c7803242c24e3$export$18d4026d1ea86bb1.getState(editorState);
            if (!pluginState) return {
                editorDisabled: false
            };
            return {
                editorDisabled: pluginState.disabledByPlugin || pluginState.editorDisabled
            };
        },
        pmPlugins: ()=>[
                {
                    name: 'editorDisabled',
                    plugin: ({ dispatch: dispatch })=>$041c7803242c24e3$var$createPlugin(dispatch, options)
                }
            ],
        commands: {
            toggleDisabled: (disabled)=>({ tr: tr })=>{
                    return tr.setMeta($041c7803242c24e3$export$18d4026d1ea86bb1, {
                        action: (0, $2Yjgh.ACTION).TOGGLE_DISABLED,
                        disabled: disabled
                    });
                }
        }
    });

});
parcelRegister("2Yjgh", function(module, exports) {
$parcel$export(module.exports, "ACTION", () => $2f880999548bb65a$export$9523889e0a5da4ba);
$parcel$export(module.exports, "reducer", () => $2f880999548bb65a$export$1650419e431d3ba3);
var $2f880999548bb65a$export$9523889e0a5da4ba = /*#__PURE__*/ function(ACTION) {
    ACTION["TOGGLE_DISABLED"] = "TOGGLE_DISABLED";
    return ACTION;
}({});
function $2f880999548bb65a$export$1650419e431d3ba3(pluginState, meta) {
    if (meta && 'action' in meta) switch(meta.action){
        case "TOGGLE_DISABLED":
            if (meta.disabled === pluginState.disabledByPlugin) return pluginState;
            return {
                ...pluginState,
                disabledByPlugin: Boolean(meta.disabled)
            };
        default:
            return pluginState;
    }
    return pluginState;
}

});


parcelRegister("a1ESh", function(module, exports) {
$parcel$export(module.exports, "featureFlagsPlugin", () => $443efffa8e4eb41f$export$79626a094e303f80);

var $f7Kk4 = parcelRequire("f7Kk4");

var $cw0wu = parcelRequire("cw0wu");
const $443efffa8e4eb41f$var$pluginKey = new (0, $cw0wu.PluginKey)('featureFlags');
const $443efffa8e4eb41f$export$79626a094e303f80 = ({ config: featureFlags = {} })=>({
        name: 'featureFlags',
        getSharedState (editorState) {
            if (!editorState) return featureFlags || {};
            return $443efffa8e4eb41f$var$pluginKey.getState(editorState) || featureFlags || {};
        },
        pmPlugins () {
            return [
                {
                    name: 'featureFlags',
                    plugin: ()=>new (0, $f7Kk4.SafePlugin)({
                            key: $443efffa8e4eb41f$var$pluginKey,
                            state: {
                                init: ()=>({
                                        ...featureFlags
                                    }),
                                apply: (_, pluginState)=>pluginState
                            }
                        })
                }
            ];
        }
    });

});

parcelRegister("jTQuH", function(module, exports) {
$parcel$export(module.exports, "floatingToolbarPlugin", () => $fe6c382ba00418a3$export$baed971c987bc0e);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $3vF76 = parcelRequire("3vF76");

var $g6Qq4 = parcelRequire("g6Qq4");

var $iUiGU = parcelRequire("iUiGU");

var $7lseo = parcelRequire("7lseo");

var $5zk80 = parcelRequire("5zk80");

var $fRXfs = parcelRequire("fRXfs");

var $f7Kk4 = parcelRequire("f7Kk4");

var $8qHhy = parcelRequire("8qHhy");

var $9x1C7 = parcelRequire("9x1C7");

var $cw0wu = parcelRequire("cw0wu");

var $gab48 = parcelRequire("gab48");

var $gdUUy = parcelRequire("gdUUy");

var $3kEJw = parcelRequire("3kEJw");

var $7m0En = parcelRequire("7m0En");

var $6pBTo = parcelRequire("6pBTo");

var $iYkJR = parcelRequire("iYkJR");

var $19NVK = parcelRequire("19NVK");

var $4LHUo = parcelRequire("4LHUo");

var $lM50J = parcelRequire("lM50J");

var $dld2I = parcelRequire("dld2I");

var $9Fqvh = parcelRequire("9Fqvh");
const $fe6c382ba00418a3$var$SUPPRESS_TOOLBAR_USER_INTENTS = [
    'dragging',
    'tableContextualMenuPopupOpen',
    'tableDragMenuPopupOpen',
    'commenting',
    // Suppress while reviewing an AI Suggested Edits card so node floating toolbars don't overlap
    // or mis-position against the suggestion card / diff decorations. Set by the ai-suggestions plugin.
    'reviewing',
    'resizing',
    'blockMenuOpen',
    'statusPickerOpen',
    // Suppress when a modal/overlay is open over the editor (e.g. the Jira remix ephemeral preview),
    // so the floating toolbar does not bleed through on top of the overlay.
    'overlayOpen'
];
const $fe6c382ba00418a3$export$c5f0b4d19f5b8d4b = (selection, configs)=>{
    // node selections always take precedence, see if
    let configPair;
    configs.find((config)=>{
        const node = (0, $gab48.findSelectedNodeOfType)(config.nodeType)(selection);
        if (node) configPair = {
            node: node.node,
            pos: node.pos,
            config: config
        };
        return !!node;
    });
    if (configPair) return configPair;
    // create mapping of node type name to configs
    const configByNodeType = {};
    configs.forEach((config)=>{
        if (Array.isArray(config.nodeType)) config.nodeType.forEach((nodeType)=>{
            configByNodeType[nodeType.name] = config;
        });
        else configByNodeType[config.nodeType.name] = config;
    });
    // search up the tree from selection
    const { $from: $from } = selection;
    for(let i = $from.depth; i > 0; i--){
        const node = $from.node(i);
        const matchedConfig = configByNodeType[node.type.name];
        if (matchedConfig) return {
            config: matchedConfig,
            node: node,
            pos: $from.pos
        };
    }
    // if it is AllSelection (can be result of Cmd+A) - use first node
    if (selection instanceof (0, $cw0wu.AllSelection)) {
        const docNode = $from.node(0);
        let matchedConfig = null;
        const firstChild = (0, $4LHUo.findNode)(docNode, (node)=>{
            matchedConfig = configByNodeType[node.type.name];
            return !!matchedConfig;
        });
        if (firstChild && matchedConfig) return {
            config: matchedConfig,
            node: firstChild,
            pos: $from.pos
        };
    }
    return;
};
const $fe6c382ba00418a3$var$getDomRefFromSelection = (view, dispatchAnalyticsEvent)=>{
    try {
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        return (0, $gab48.findDomRefAtPos)(view.state.selection.from, view.domAtPos.bind(view));
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn(error);
        if (dispatchAnalyticsEvent) {
            const payload = {
                action: (0, $g6Qq4.ACTION).ERRORED,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).CONTENT_COMPONENT,
                eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    component: (0, $g6Qq4.CONTENT_COMPONENT).FLOATING_TOOLBAR,
                    selection: view.state.selection.toJSON(),
                    position: view.state.selection.from,
                    docSize: view.state.doc.nodeSize,
                    error: error.toString(),
                    // @ts-expect-error - Object literal may only specify known properties, 'errorStack' does not exist in type
                    // This error was introduced after upgrading to TypeScript 5
                    errorStack: error.stack || undefined
                }
            };
            dispatchAnalyticsEvent(payload);
        }
    }
};
function $fe6c382ba00418a3$var$filterUndefined(x) {
    return !!x;
}
const $fe6c382ba00418a3$export$baed971c987bc0e = ({ api: api })=>{
    return {
        name: 'floatingToolbar',
        pmPlugins (floatingToolbarHandlers = []) {
            const plugins = [
                {
                    // Should be after all toolbar plugins
                    name: 'floatingToolbar',
                    plugin: ({ providerFactory: providerFactory, getIntl: getIntl })=>$fe6c382ba00418a3$export$5c1ec0ef773ca0cc({
                            api: api,
                            floatingToolbarHandlers: floatingToolbarHandlers,
                            providerFactory: providerFactory,
                            getIntl: getIntl
                        })
                },
                {
                    name: 'floatingToolbarData',
                    plugin: ({ dispatch: dispatch })=>(0, $iYkJR.createPlugin)(dispatch)
                },
                {
                    name: 'forceFocus',
                    plugin: ()=>(0, $7m0En.default)()
                }
            ];
            return plugins;
        },
        actions: {
            forceFocusSelector: $7m0En.forceFocusSelector
        },
        commands: {
            copyNode: (nodeType, inputMethod)=>{
                var _api$analytics;
                return (0, $3kEJw.copyNode)(nodeType, api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions, inputMethod);
            }
        },
        getSharedState (editorState) {
            var _api$interaction, _pluginKey$getState, _pluginKey$getState$g;
            if (!editorState) return undefined;
            const interactionState = api === null || api === void 0 || (_api$interaction = api.interaction) === null || _api$interaction === void 0 || (_api$interaction = _api$interaction.sharedState.currentState()) === null || _api$interaction === void 0 ? void 0 : _api$interaction.interactionState;
            const configWithNodeInfo = interactionState !== 'hasNotHadInteraction' ? ((_pluginKey$getState = $fe6c382ba00418a3$export$18d4026d1ea86bb1.getState(editorState)) === null || _pluginKey$getState === void 0 || (_pluginKey$getState$g = _pluginKey$getState.getConfigWithNodeInfo) === null || _pluginKey$getState$g === void 0 ? void 0 : _pluginKey$getState$g.call(_pluginKey$getState, editorState)) ?? undefined : undefined;
            return {
                configWithNodeInfo: configWithNodeInfo,
                floatingToolbarData: (0, $19NVK.pluginKey).getState(editorState)
            };
        },
        contentComponent ({ popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, editorView: editorView, providerFactory: providerFactory, dispatchAnalyticsEvent: dispatchAnalyticsEvent }) {
            if (!editorView) return null;
            return /*#__PURE__*/ (0, $dc70d.jsx)($fe6c382ba00418a3$export$2dda1e4a1d1f6a81, {
                editorView: editorView,
                pluginInjectionApi: api,
                popupsMountPoint: popupsMountPoint,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement,
                providerFactory: providerFactory,
                dispatchAnalyticsEvent: dispatchAnalyticsEvent
            });
        }
    };
};
function $fe6c382ba00418a3$export$2dda1e4a1d1f6a81({ pluginInjectionApi: pluginInjectionApi, editorView: editorView, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, providerFactory: providerFactory, dispatchAnalyticsEvent: dispatchAnalyticsEvent }) {
    var _configWithNodeInfo$c, _configWithNodeInfo$c2, _items, _pluginInjectionApi$c, _pluginInjectionApi$d, _confirmButtonItem, _confirmButtonItem2, _confirmButtonItem3;
    const { floatingToolbarState: floatingToolbarState, editorDisabledState: editorDisabledState, editorViewModeState: editorViewModeState, userIntentState: userIntentState } = (0, $9x1C7.useSharedPluginState)(pluginInjectionApi, [
        'floatingToolbar',
        'editorDisabled',
        'editorViewMode',
        'userIntent'
    ]);
    const { configWithNodeInfo: configWithNodeInfoFromHook, floatingToolbarData: floatingToolbarData } = floatingToolbarState ?? {};
    let configWithNodeInfo = configWithNodeInfoFromHook;
    if ((0, $gdUUy.fg)('platform_editor_ai_remix_toolbar')) {
        var _pluginInjectionApi$f;
        // Read configWithNodeInfo live because the hook snapshot can lag behind the
        // current editor selection and keep the floating toolbar rendered stale.
        // for example, trigger remix on panel will not hide the floating toolbar
        configWithNodeInfo = pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$f = pluginInjectionApi.floatingToolbar) === null || _pluginInjectionApi$f === void 0 || (_pluginInjectionApi$f = _pluginInjectionApi$f.sharedState.currentState()) === null || _pluginInjectionApi$f === void 0 ? void 0 : _pluginInjectionApi$f.configWithNodeInfo;
    }
    if ((0, $7lseo.isSSR)()) return null;
    if (!configWithNodeInfo || !configWithNodeInfo.config || typeof ((_configWithNodeInfo$c = configWithNodeInfo.config) === null || _configWithNodeInfo$c === void 0 ? void 0 : _configWithNodeInfo$c.visible) !== 'undefined' && !((_configWithNodeInfo$c2 = configWithNodeInfo.config) !== null && _configWithNodeInfo$c2 !== void 0 && _configWithNodeInfo$c2.visible)) return null;
    if (userIntentState !== null && userIntentState !== void 0 && userIntentState.currentUserIntent && $fe6c382ba00418a3$var$SUPPRESS_TOOLBAR_USER_INTENTS.includes(userIntentState === null || userIntentState === void 0 ? void 0 : userIntentState.currentUserIntent)) return null;
    const { config: config, node: node } = configWithNodeInfo;
    // When the new inline editor-toolbar is enabled, suppress floating toolbar for text selections.
    if (Boolean(pluginInjectionApi === null || pluginInjectionApi === void 0 ? void 0 : pluginInjectionApi.toolbar)) {
        const selection = editorView.state.selection;
        const isCellSelection = '$anchorCell' in selection && !selection.empty;
        const isTextSelected = selection instanceof (0, $cw0wu.TextSelection) && !selection.empty;
        // don't dismiss table toolbar when a cell selection is caused by clicking the drag handle (which has it's own userIntent)
        if (isTextSelected && config.className !== 'hyperlink-floating-toolbar' || isCellSelection && (userIntentState === null || userIntentState === void 0 ? void 0 : userIntentState.currentUserIntent) === 'default') return null;
    }
    let { items: items } = config;
    const { groupLabel: groupLabel } = config;
    const { title: title, getDomRef: getDomRef = $fe6c382ba00418a3$var$getDomRefFromSelection, align: align = 'center', className: className = '', containerSurface: containerSurface, height: height, width: width, zIndex: zIndex, offset: offset = [
        0,
        12
    ], forcePlacement: forcePlacement, preventPopupOverflow: preventPopupOverflow, onPositionCalculated: onPositionCalculated, absoluteOffset: absoluteOffset = {
        top: 0,
        left: 0,
        right: 0,
        bottom: 0
    }, focusTrap: focusTrap, mediaAssistiveMessage: mediaAssistiveMessage = '', stick: stick = true } = config;
    const targetRef = getDomRef(editorView, dispatchAnalyticsEvent);
    const isEditorDisabled = editorDisabledState && editorDisabledState.editorDisabled;
    const isInViewMode = (editorViewModeState === null || editorViewModeState === void 0 ? void 0 : editorViewModeState.mode) === 'view';
    if (!targetRef || isEditorDisabled && !isInViewMode) return null;
    // TODO: MODES-3950 - Update this view mode specific logic once we refactor view mode.
    //       We should inverse the responsibility here: A blacklist for toolbar items in view mode, rather than this white list.
    //       Also consider moving this logic to the more specific toolbar plugins (media and selection).
    const iterableItems = Array.isArray(items) ? items : (_items = items) === null || _items === void 0 ? void 0 : _items(node);
    if (isInViewMode) {
        // Typescript note: Not all toolbar item types have the `supportsViewMode` prop.
        const toolbarItemViewModeProp = 'supportsViewMode';
        // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- Ignored via go/ees017 (to be fixed)
        items = iterableItems.filter((item)=>toolbarItemViewModeProp in item && !!item[toolbarItemViewModeProp]);
    }
    if ((0, $8qHhy.areToolbarFlagsEnabled)(Boolean(pluginInjectionApi === null || pluginInjectionApi === void 0 ? void 0 : pluginInjectionApi.toolbar))) {
        var _items2;
        // Consolidate floating toolbar items
        const toolbarItemsArray = Array.isArray(items) ? items : (_items2 = items) === null || _items2 === void 0 ? void 0 : _items2(node);
        // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- Ignored via go/ees017 (to be fixed)
        const overflowDropdownItems = toolbarItemsArray.filter((item)=>item.type === 'overflow-dropdown');
        if (overflowDropdownItems.length > 1) {
            const consolidatedOverflowDropdown = (0, $9Fqvh.consolidateOverflowDropdownItems)(overflowDropdownItems);
            // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- Ignored via go/ees017 (to be fixed)
            const otherItems = toolbarItemsArray.filter((item)=>item.type !== 'overflow-dropdown');
            if (otherItems.length > 0) // remove the last separators
            while(((_otherItems$at = otherItems.at(-1)) === null || _otherItems$at === void 0 ? void 0 : _otherItems$at.type) === 'separator'){
                var _otherItems$at;
                otherItems.pop();
            }
            items = [
                ...otherItems,
                {
                    type: 'separator',
                    fullHeight: true,
                    supportsViewMode: true
                },
                consolidatedOverflowDropdown
            ];
        }
        // Apply analytics to dropdown
        if (overflowDropdownItems.length > 0 && dispatchAnalyticsEvent) {
            var _items3;
            const currentItems = Array.isArray(items) ? items : (_items3 = items) === null || _items3 === void 0 ? void 0 : _items3(node);
            const updatedItems = currentItems.map((item)=>{
                if (item.type !== 'overflow-dropdown') return item;
                const originalOnClick = item.onClick;
                return {
                    ...item,
                    onClick: ()=>{
                        var _pluginInjectionApi$e;
                        const editorContentMode = pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$e = pluginInjectionApi.editorViewMode) === null || _pluginInjectionApi$e === void 0 || (_pluginInjectionApi$e = _pluginInjectionApi$e.sharedState.currentState()) === null || _pluginInjectionApi$e === void 0 ? void 0 : _pluginInjectionApi$e.mode;
                        dispatchAnalyticsEvent({
                            action: (0, $g6Qq4.ACTION).CLICKED,
                            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).BUTTON,
                            actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).FLOATING_TOOLBAR_OVERFLOW,
                            eventType: (0, $g6Qq4.EVENT_TYPE).UI,
                            attributes: {
                                editorContentMode: editorContentMode
                            }
                        });
                        // Call original onClick if it exists
                        originalOnClick === null || originalOnClick === void 0 || originalOnClick();
                    }
                };
            });
            items = updatedItems;
        }
    }
    let customPositionCalculation;
    const toolbarItems = pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$c = pluginInjectionApi.copyButton) === null || _pluginInjectionApi$c === void 0 ? void 0 : _pluginInjectionApi$c.actions.processCopyButtonItems(editorView.state)(Array.isArray(items) ? items : items(node), pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$d = pluginInjectionApi.decorations) === null || _pluginInjectionApi$d === void 0 ? void 0 : _pluginInjectionApi$d.actions.hoverDecoration);
    if (onPositionCalculated) customPositionCalculation = (nextPos)=>{
        return onPositionCalculated(editorView, nextPos);
    };
    const dispatchCommand = (fn)=>fn && fn(editorView.state, editorView.dispatch, editorView);
    // Confirm dialog
    let confirmButtonItem;
    const { confirmDialogForItem: confirmDialogForItem, confirmDialogForItemOption: confirmDialogForItemOption } = floatingToolbarData || {};
    const matchingItem = confirmDialogForItem ? toolbarItems === null || toolbarItems === void 0 ? void 0 : toolbarItems[confirmDialogForItem] : undefined;
    if ((matchingItem === null || matchingItem === void 0 ? void 0 : matchingItem.type) === 'button') confirmButtonItem = matchingItem;
    if ((matchingItem === null || matchingItem === void 0 ? void 0 : matchingItem.type) === 'overflow-dropdown' && confirmDialogForItemOption !== undefined) {
        const matchingItemOption = matchingItem.options[confirmDialogForItemOption];
        // OverflowDropdownOption is the only member of the union that does not have a 'type' property
        if (!('type' in matchingItemOption)) confirmButtonItem = matchingItemOption;
    }
    const scrollable = config.scrollable;
    const confirmDialogOptions = typeof ((_confirmButtonItem = confirmButtonItem) === null || _confirmButtonItem === void 0 ? void 0 : _confirmButtonItem.confirmDialog) === 'function' ? (_confirmButtonItem2 = confirmButtonItem) === null || _confirmButtonItem2 === void 0 ? void 0 : _confirmButtonItem2.confirmDialog() : (_confirmButtonItem3 = confirmButtonItem) === null || _confirmButtonItem3 === void 0 ? void 0 : _confirmButtonItem3.confirmDialog;
    return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $iUiGU.ErrorBoundary), {
        component: (0, $g6Qq4.ACTION_SUBJECT).FLOATING_TOOLBAR_PLUGIN,
        componentId: (0, (/*@__PURE__*/$parcel$interopDefault($3vF76)))(title),
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        fallbackComponent: null,
        children: [
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $5zk80.default), {
                ariaLabel: title,
                role: 'toolbar',
                offset: offset,
                target: targetRef,
                alignY: "bottom",
                forcePlacement: forcePlacement,
                fitHeight: height,
                fitWidth: width,
                absoluteOffset: absoluteOffset,
                alignX: align,
                stick: stick,
                zIndex: zIndex,
                mountTo: popupsMountPoint,
                boundariesElement: popupsBoundariesElement,
                scrollableElement: popupsScrollableElement,
                onPositionCalculated: customPositionCalculation,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                style: scrollable ? {
                    maxWidth: '100%'
                } : {},
                focusTrap: focusTrap,
                preventOverflow: preventPopupOverflow,
                children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $fRXfs.WithProviders), {
                    providerFactory: providerFactory,
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    providers: [
                        'extensionProvider'
                    ],
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    renderNode: (providers)=>{
                        return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dld2I.default), {
                            target: targetRef,
                            // Ignored via go/ees005
                            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                            items: toolbarItems,
                            groupLabel: groupLabel,
                            node: node,
                            dispatchCommand: dispatchCommand,
                            editorView: editorView,
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
                            className: className,
                            containerSurface: containerSurface,
                            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                            focusEditor: ()=>editorView.focus(),
                            providerFactory: providerFactory,
                            popupsMountPoint: popupsMountPoint,
                            popupsBoundariesElement: popupsBoundariesElement,
                            popupsScrollableElement: popupsScrollableElement,
                            dispatchAnalyticsEvent: dispatchAnalyticsEvent,
                            extensionsProvider: providers.extensionProvider,
                            scrollable: scrollable,
                            api: pluginInjectionApi,
                            mediaAssistiveMessage: mediaAssistiveMessage
                        });
                    }
                })
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $lM50J.ConfirmationModal), {
                testId: "ak-floating-toolbar-confirmation-modal",
                options: confirmDialogOptions,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                onConfirm: (isChecked = false)=>{
                    // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    if (!!confirmDialogOptions.onConfirm) // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    dispatchCommand(confirmDialogOptions.onConfirm(isChecked));
                    else // Ignored via go/ees005
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    dispatchCommand(confirmButtonItem.onClick);
                },
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                onClose: ()=>{
                    dispatchCommand((0, $6pBTo.hideConfirmDialog)());
                    // Need to set focus to Editor here,
                    // As when the Confirmation dialog pop up, and user interacts with the dialog, Editor loses focus.
                    // So when Confirmation dialog is closed, Editor does not have the focus, then cursor goes to the position 1 of the doc,
                    // instead of the cursor position before the dialog pop up.
                    if (!editorView.hasFocus()) editorView.focus();
                }
            })
        ]
    });
}
const $fe6c382ba00418a3$export$18d4026d1ea86bb1 = new (0, $cw0wu.PluginKey)('floatingToolbarPluginKey');
/**
 * Clean up floating toolbar configs from undesired properties.
 */ function $fe6c382ba00418a3$var$sanitizeFloatingToolbarConfig(config) {
    // Cleanup from non existing node types
    if (Array.isArray(config.nodeType)) return {
        ...config,
        nodeType: config.nodeType.filter($fe6c382ba00418a3$var$filterUndefined)
    };
    return config;
}
function $fe6c382ba00418a3$export$5c1ec0ef773ca0cc(options) {
    const { floatingToolbarHandlers: floatingToolbarHandlers, providerFactory: providerFactory, getIntl: getIntl, api: api } = options;
    const intl = getIntl();
    const getConfigWithNodeInfo = (editorState)=>{
        let activeConfigs = [];
        for(let index = 0; index < floatingToolbarHandlers.length; index++){
            const handler = floatingToolbarHandlers[index];
            const config = handler(editorState, intl, providerFactory, activeConfigs);
            if (config) {
                var _api$userIntent;
                if ($fe6c382ba00418a3$var$SUPPRESS_TOOLBAR_USER_INTENTS.includes((api === null || api === void 0 || (_api$userIntent = api.userIntent) === null || _api$userIntent === void 0 || (_api$userIntent = _api$userIntent.sharedState.currentState()) === null || _api$userIntent === void 0 ? void 0 : _api$userIntent.currentUserIntent) || '')) {
                    activeConfigs = undefined;
                    break;
                }
                activeConfigs.push($fe6c382ba00418a3$var$sanitizeFloatingToolbarConfig(config));
            }
        }
        const relevantConfig = activeConfigs && $fe6c382ba00418a3$export$c5f0b4d19f5b8d4b(editorState.selection, activeConfigs);
        return relevantConfig;
    };
    const getIsToolbarSuppressed = ()=>{
        return false;
    };
    return new (0, $f7Kk4.SafePlugin)({
        key: $fe6c382ba00418a3$export$18d4026d1ea86bb1,
        state: {
            init: ()=>{
                return {
                    getConfigWithNodeInfo: getConfigWithNodeInfo
                };
            },
            apply: (_tr, _pluginState, __oldEditorState)=>{
                const suppressedToolbar = getIsToolbarSuppressed();
                const newPluginState = {
                    getConfigWithNodeInfo: getConfigWithNodeInfo,
                    suppressedToolbar: suppressedToolbar
                };
                return newPluginState;
            }
        },
        view: ()=>{
            return {
                update: (view, prevState)=>{
                    const pluginState = $fe6c382ba00418a3$export$18d4026d1ea86bb1.getState(view.state);
                    const prevPluginState = $fe6c382ba00418a3$export$18d4026d1ea86bb1.getState(prevState);
                    if (pluginState !== null && pluginState !== void 0 && pluginState.suppressedToolbar && !(prevPluginState !== null && prevPluginState !== void 0 && prevPluginState.suppressedToolbar)) {
                        var _api$analytics2;
                        api === null || api === void 0 || (_api$analytics2 = api.analytics) === null || _api$analytics2 === void 0 || (_api$analytics2 = _api$analytics2.actions) === null || _api$analytics2 === void 0 || _api$analytics2.fireAnalyticsEvent({
                            action: (0, $g6Qq4.ACTION).SUPPRESSED,
                            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).FLOATING_TOOLBAR_PLUGIN,
                            actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).FLOATING_TOOLBAR,
                            eventType: (0, $g6Qq4.EVENT_TYPE).TRACK
                        });
                    }
                }
            };
        }
    });
}

});
parcelRegister("3kEJw", function(module, exports) {
$parcel$export(module.exports, "copyNode", () => $6abf93e5d8a6d9df$export$978ef9948557240e);

var $kAhws = parcelRequire("kAhws");

var $j0iaN = parcelRequire("j0iaN");
const $6abf93e5d8a6d9df$export$978ef9948557240e = (nodeType, editorAnalyticsApi, inputMethod)=>({ tr: tr })=>{
        // const { tr, schema } = state;
        // This command should only be triggered by the Copy button in the floating toolbar
        // which is only visible when selection is inside the target node
        const contentNodeWithPos = (0, $j0iaN.getSelectedNodeOrNodeParentByNodeType)({
            nodeType: nodeType,
            selection: tr.selection
        });
        if (!contentNodeWithPos) return tr;
        const schema = tr.doc.type.schema;
        const copyToClipboardTr = tr;
        const domNode = (0, $j0iaN.toDOM)(contentNodeWithPos.node, schema);
        (0, $j0iaN.copyDomNode)(domNode, contentNodeWithPos.node.type, tr.selection);
        if (editorAnalyticsApi) {
            const analyticsPayload = (0, $kAhws.getNodeCopiedAnalyticsPayload)(contentNodeWithPos.node, inputMethod);
            editorAnalyticsApi.attachAnalyticsEvent(analyticsPayload)(copyToClipboardTr);
        }
        copyToClipboardTr.setMeta('scrollIntoView', false);
        return copyToClipboardTr;
    };

});

parcelRegister("7m0En", function(module, exports) {
$parcel$export(module.exports, "default", () => $1fe69198e484c00d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "forceFocusSelector", () => $1fe69198e484c00d$export$1470545de94762f5);
$parcel$export(module.exports, "checkShouldForceFocusAndApply", () => $1fe69198e484c00d$export$a2ced8424a9be595);

var $f7Kk4 = parcelRequire("f7Kk4");

var $cw0wu = parcelRequire("cw0wu");
const $1fe69198e484c00d$export$ded15a80767f6af7 = new (0, $cw0wu.PluginKey)('forceFocusStatePlugin');
var /**
 * Used in cases where a floating toolbar button opens a submenu which destroys
 * the button, but the user has pressed ESC to close the submenu and focus needs
 * to move back to the button. */ $1fe69198e484c00d$export$2e2bcd8739ae039 = ()=>new (0, $f7Kk4.SafePlugin)({
        key: $1fe69198e484c00d$export$ded15a80767f6af7,
        state: {
            init: ()=>({
                    selector: null
                }),
            apply: (tr, prevState)=>{
                const meta = tr.getMeta($1fe69198e484c00d$export$ded15a80767f6af7);
                if (meta && 'selector' in meta) return {
                    selector: meta.selector
                };
                return prevState;
            }
        }
    });
const $1fe69198e484c00d$export$1470545de94762f5 = (selector)=>(tr)=>{
        return tr.setMeta($1fe69198e484c00d$export$ded15a80767f6af7, {
            selector: selector
        });
    };
function $1fe69198e484c00d$export$a2ced8424a9be595(view) {
    const state = view === null || view === void 0 ? void 0 : view.state;
    if (state) {
        const { selector: selector } = $1fe69198e484c00d$export$ded15a80767f6af7.getState(state);
        if (selector) {
            const focusableElement = document.querySelector(selector);
            if (focusableElement) {
                focusableElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                    inline: 'nearest'
                });
                // Ignored via go/ees005
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                focusableElement.focus();
                const { state: { tr: tr }, dispatch: dispatch } = view;
                dispatch($1fe69198e484c00d$export$1470545de94762f5(null)(tr));
            }
        }
    }
}

});

parcelRegister("6pBTo", function(module, exports) {
$parcel$export(module.exports, "showConfirmDialog", () => $bac2c308649c4b2f$export$c0076bd4afc29e7a);
$parcel$export(module.exports, "hideConfirmDialog", () => $bac2c308649c4b2f$export$5a3c1357cfd1045c);

var $4kuOn = parcelRequire("4kuOn");
const $bac2c308649c4b2f$export$c0076bd4afc29e7a = (buttonIndex, optionIndex)=>(0, $4kuOn.createCommand)({
        type: 'SHOW_CONFIRM_DIALOG',
        data: {
            buttonIndex: buttonIndex,
            optionIndex: optionIndex
        }
    }, (tr)=>tr.setMeta('addToHistory', false));
const $bac2c308649c4b2f$export$5a3c1357cfd1045c = ()=>(0, $4kuOn.createCommand)({
        type: 'HIDE_CONFIRM_DIALOG'
    }, (tr)=>tr.setMeta('addToHistory', false));

});
parcelRegister("4kuOn", function(module, exports) {
$parcel$export(module.exports, "createPluginState", () => $1dac091782c06482$export$656c7661095efe2e);
$parcel$export(module.exports, "createCommand", () => $1dac091782c06482$export$8d4021544bdece00);

var $3TnFr = parcelRequire("3TnFr");

var $19NVK = parcelRequire("19NVK");

var $5Ax30 = parcelRequire("5Ax30");
const $1dac091782c06482$var$dest = (0, $3TnFr.pluginFactory)((0, $19NVK.pluginKey), (0, $5Ax30.reducer));
const $1dac091782c06482$export$656c7661095efe2e = $1dac091782c06482$var$dest.createPluginState;
const $1dac091782c06482$export$8d4021544bdece00 = $1dac091782c06482$var$dest.createCommand;
const $1dac091782c06482$export$f05434c51e3762e = $1dac091782c06482$var$dest.getPluginState;

});
parcelRegister("19NVK", function(module, exports) {
$parcel$export(module.exports, "pluginKey", () => $1c07381222a27912$export$18d4026d1ea86bb1);

var $cw0wu = parcelRequire("cw0wu");
const $1c07381222a27912$export$18d4026d1ea86bb1 = new (0, $cw0wu.PluginKey)('floatingToolbarData');

});

parcelRegister("5Ax30", function(module, exports) {
$parcel$export(module.exports, "reducer", () => $74aa730041c1160c$export$1650419e431d3ba3);
const $74aa730041c1160c$export$1650419e431d3ba3 = (pluginState, action)=>{
    switch(action.type){
        case 'SHOW_CONFIRM_DIALOG':
            return {
                ...pluginState,
                confirmDialogForItem: action.data.buttonIndex,
                confirmDialogForItemOption: action.data.optionIndex
            };
        case 'HIDE_CONFIRM_DIALOG':
            return {
                ...pluginState,
                confirmDialogForItem: undefined
            };
        default:
            return pluginState;
    }
};

});



parcelRegister("iYkJR", function(module, exports) {
$parcel$export(module.exports, "createPlugin", () => $c3ee67fc42cc5f51$export$ae829ec7b2625219);

var $f7Kk4 = parcelRequire("f7Kk4");

var $4kuOn = parcelRequire("4kuOn");

var $19NVK = parcelRequire("19NVK");
const $c3ee67fc42cc5f51$export$ae829ec7b2625219 = (dispatch)=>{
    return new (0, $f7Kk4.SafePlugin)({
        state: (0, $4kuOn.createPluginState)(dispatch, {}),
        key: (0, $19NVK.pluginKey)
    });
};

});

parcelRegister("4LHUo", function(module, exports) {
$parcel$export(module.exports, "findNode", () => $a2f8b917d926577a$export$5b92d7a8b5d33ee2);
function $a2f8b917d926577a$export$5b92d7a8b5d33ee2(parent, predicate) {
    let matchedNode;
    parent.descendants((node)=>{
        // dont run predicate if node already found
        if (matchedNode) return false;
        if (predicate(node)) {
            matchedNode = node;
            return false;
        }
        return true;
    });
    return matchedNode;
}

});

parcelRegister("lM50J", function(module, exports) {
$parcel$export(module.exports, "ConfirmationModal", () => $c48bfd28dfcaa863$export$1f33f980da756c46);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $fK3tS = parcelRequire("fK3tS");

var $lFaAn = parcelRequire("lFaAn");

var $jRJNt = parcelRequire("jRJNt");

var $a3BrZ = parcelRequire("a3BrZ");
const $c48bfd28dfcaa863$var$ConfirmationModalImpl = (props)=>{
    const { options: options } = props;
    const renderModel = (isReferentialityDialog = false)=>// Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        // Ignored via go/ees005
        // eslint-disable-next-line react/jsx-props-no-spreading
        isReferentialityDialog ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $jRJNt.CheckboxModal), {
            ...props
        }) : /*#__PURE__*/ (0, $dc70d.jsx)((0, $a3BrZ.SimpleModal), {
            ...props
        });
    return options ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $lFaAn.default), {
        children: renderModel(options === null || options === void 0 ? void 0 : options.isReferentialityDialog)
    }) : null;
};
const $c48bfd28dfcaa863$export$1f33f980da756c46 = (0, $fK3tS.default)($c48bfd28dfcaa863$var$ConfirmationModalImpl);

});
parcelRegister("jRJNt", function(module, exports) {
$parcel$export(module.exports, "CheckboxModal", () => $91fe30686f268d1c$export$9c828de50258a892);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $jNJGJ = parcelRequire("jNJGJ");

var $8HhhR = parcelRequire("8HhhR");

var $74yRN = parcelRequire("74yRN");

var $2w1u7 = parcelRequire("2w1u7");

var $c9mVs = parcelRequire("c9mVs");

var $7HzAO = parcelRequire("7HzAO");

var $j4mCC = parcelRequire("j4mCC");

var $4TlNm = parcelRequire("4TlNm");

var $8aT4G = parcelRequire("8aT4G");
const $91fe30686f268d1c$export$9c828de50258a892 = (props)=>{
    var _options$getChildrenI;
    const [isChecked, setCheckbox] = (0, $bSJIT.useState)(false);
    const { onConfirm: onConfirm, onClose: onClose, options: options, intl: { formatMessage: formatMessage }, testId: testId } = props;
    const heading = (options === null || options === void 0 ? void 0 : options.title) || formatMessage((0, $74yRN.default).confirmModalDefaultHeading);
    const okButtonLabel = (options === null || options === void 0 ? void 0 : options.okButtonLabel) || formatMessage((0, $74yRN.default).confirmModalOK);
    const cancelButtonLabel = (options === null || options === void 0 ? void 0 : options.cancelButtonLabel) || formatMessage((0, $74yRN.default).confirmModalCancel);
    const checkboxlabel = options === null || options === void 0 ? void 0 : options.checkboxLabel;
    const childrenInfo = options === null || options === void 0 || (_options$getChildrenI = options.getChildrenInfo) === null || _options$getChildrenI === void 0 ? void 0 : _options$getChildrenI.call(options);
    const ListComponent = ({ nodes: nodes })=>{
        if (nodes.length === 0) return null;
        return /*#__PURE__*/ (0, $dc70d.jsx)("ul", {
            children: nodes.map((node)=>// Ignored via go/ees005
                // eslint-disable-next-line react/jsx-props-no-spreading
                /*#__PURE__*/ (0, $bSJIT.createElement)(ListItem, {
                    ...node,
                    key: node.id
                }))
        });
    };
    const ListItem = (props)=>{
        const { id: id, name: name, amount: amount } = props;
        return /*#__PURE__*/ (0, $dc70d.jsx)("li", {
            id: id,
            children: formatMessage((0, $74yRN.default).confirmModalListUnit, {
                name: name,
                amount: amount
            })
        });
    };
    return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $c9mVs.default), {
        onClose: onClose,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $j4mCC.default), {
                hasCloseButton: true,
                children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $4TlNm.default), {
                    appearance: "warning",
                    children: heading
                })
            }),
            /*#__PURE__*/ (0, $dc70d.jsxs)((0, $2w1u7.default), {
                children: [
                    /*#__PURE__*/ (0, $dc70d.jsx)((0, $8aT4G.Text), {
                        as: "p",
                        children: options === null || options === void 0 ? void 0 : options.message
                    }),
                    !!(childrenInfo !== null && childrenInfo !== void 0 && childrenInfo.length) && /*#__PURE__*/ (0, $dc70d.jsx)(ListComponent, {
                        nodes: childrenInfo
                    }),
                    /*#__PURE__*/ (0, $dc70d.jsx)((0, $8aT4G.Text), {
                        as: "p",
                        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $8HhhR.Checkbox), {
                            isChecked: isChecked,
                            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                            onChange: ()=>setCheckbox(!isChecked),
                            label: checkboxlabel,
                            testId: testId ? `${testId}-checkbox` : undefined
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dc70d.jsxs)((0, $7HzAO.default), {
                children: [
                    /*#__PURE__*/ (0, $dc70d.jsx)((0, $jNJGJ.default), {
                        appearance: "default",
                        onClick: onClose,
                        testId: testId ? `${testId}-cancel-button` : undefined,
                        children: cancelButtonLabel
                    }),
                    /*#__PURE__*/ (0, $dc70d.jsx)((0, $jNJGJ.default), {
                        appearance: "warning",
                        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                        onClick: ()=>{
                            onConfirm(isChecked);
                            onClose();
                        },
                        testId: testId ? `${testId}-confirm-button` : undefined,
                        children: okButtonLabel
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("a3BrZ", function(module, exports) {
$parcel$export(module.exports, "SimpleModal", () => $47ed19894c66a6ab$export$f96c193e316d2274);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $jNJGJ = parcelRequire("jNJGJ");

var $74yRN = parcelRequire("74yRN");

var $2w1u7 = parcelRequire("2w1u7");

var $c9mVs = parcelRequire("c9mVs");

var $7HzAO = parcelRequire("7HzAO");

var $j4mCC = parcelRequire("j4mCC");

var $4TlNm = parcelRequire("4TlNm");

var $8aT4G = parcelRequire("8aT4G");
const $47ed19894c66a6ab$export$f96c193e316d2274 = (props)=>{
    const { onConfirm: onConfirm, onClose: onClose, options: options, intl: { formatMessage: formatMessage }, testId: testId } = props;
    const heading = (options === null || options === void 0 ? void 0 : options.title) || formatMessage((0, $74yRN.default).confirmModalDefaultHeading);
    const okButtonLabel = (options === null || options === void 0 ? void 0 : options.okButtonLabel) || formatMessage((0, $74yRN.default).confirmModalOK);
    const cancelButtonLabel = (options === null || options === void 0 ? void 0 : options.cancelButtonLabel) || formatMessage((0, $74yRN.default).confirmModalCancel);
    return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $c9mVs.default), {
        onClose: onClose,
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $j4mCC.default), {
                hasCloseButton: true,
                children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $4TlNm.default), {
                    appearance: "warning",
                    children: heading
                })
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $2w1u7.default), {
                children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $8aT4G.Text), {
                    as: "p",
                    children: options === null || options === void 0 ? void 0 : options.message
                })
            }),
            /*#__PURE__*/ (0, $dc70d.jsxs)((0, $7HzAO.default), {
                children: [
                    /*#__PURE__*/ (0, $dc70d.jsx)((0, $jNJGJ.default), {
                        appearance: "default",
                        onClick: onClose,
                        testId: testId ? `${testId}-cancel-button` : undefined,
                        children: cancelButtonLabel
                    }),
                    /*#__PURE__*/ (0, $dc70d.jsx)((0, $jNJGJ.default), {
                        appearance: "warning",
                        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                        onClick: ()=>{
                            onConfirm();
                            onClose();
                        },
                        testId: testId ? `${testId}-confirm-button` : undefined,
                        children: okButtonLabel
                    })
                ]
            })
        ]
    });
};

});


parcelRegister("dld2I", function(module, exports) {
$parcel$export(module.exports, "default", () => $3040e4b891be5106$export$2e2bcd8739ae039);
/* eslint-disable @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $fK3tS = parcelRequire("fK3tS");

var $f1bHg = parcelRequire("f1bHg");

var $4ambm = parcelRequire("4ambm");

var $jU1gf = parcelRequire("jU1gf");

var $74yRN = parcelRequire("74yRN");

var $7HjEm = parcelRequire("7HjEm");

var $2Bpgx = parcelRequire("2Bpgx");

var $fNLdd = parcelRequire("fNLdd");

var $8qHhy = parcelRequire("8qHhy");

var $epqkL = parcelRequire("epqkL");

var $1NElZ = parcelRequire("1NElZ");

var $aHqLs = parcelRequire("aHqLs");

var $e4OZJ = parcelRequire("e4OZJ");

var $iabGk = parcelRequire("iabGk");

var $3y2s4 = parcelRequire("3y2s4");

var $7m0En = parcelRequire("7m0En");

var $6pBTo = parcelRequire("6pBTo");

var $iXxVC = parcelRequire("iXxVC");

var $2r1FT = parcelRequire("2r1FT");

var $fARSz = parcelRequire("fARSz");

var $gaSQI = parcelRequire("gaSQI");

var $1UG5w = parcelRequire("1UG5w");

var $d37J1 = parcelRequire("d37J1");

var $gM1Ws = parcelRequire("gM1Ws");
function $3040e4b891be5106$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
function $3040e4b891be5106$export$7abc8284d66f79b1(items, areAnyNewToolbarFlagsEnabled) {
    const groupItems = items.reduce((accumulator, item, i)=>{
        const { finalOutput: finalOutput, buttonGroup: buttonGroup } = accumulator;
        if (item.type === 'button') {
            const notLastItem = i < items.length - 1;
            const nextItemIsButton = items[i + 1] && items[i + 1].type === 'button';
            const wasPreviousButton = items[i - 1] && items[i - 1].type === 'button';
            const shouldBeRadioButton = notLastItem && nextItemIsButton || wasPreviousButton;
            // Only group as radio button if not explicitly set to false
            const isRadioButton = shouldBeRadioButton && item.isRadioButton !== false;
            if (isRadioButton) {
                item.isRadioButton = true;
                buttonGroup.push(item);
                if (!nextItemIsButton && wasPreviousButton) {
                    finalOutput.push(buttonGroup);
                    accumulator.buttonGroup = [];
                }
            } else finalOutput.push(item);
        } else if (item.type === 'separator' && areAnyNewToolbarFlagsEnabled) {
            var _items;
            const isLeadingSeparator = i === 0;
            const isTrailingSeparator = i === items.length - 1;
            const isDuplicateSeparator = ((_items = items[i - 1]) === null || _items === void 0 ? void 0 : _items.type) === 'separator';
            !isLeadingSeparator && !isTrailingSeparator && !isDuplicateSeparator && finalOutput.push(item);
        } else finalOutput.push(item);
        return accumulator;
    }, {
        buttonGroup: [],
        finalOutput: []
    });
    return groupItems.finalOutput;
}
const $3040e4b891be5106$var$ToolbarItems = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).memo(({ items: items, groupLabel: groupLabel, dispatchCommand: dispatchCommand, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, editorView: editorView, dispatchAnalyticsEvent: dispatchAnalyticsEvent, popupsScrollableElement: popupsScrollableElement, scrollable: scrollable, providerFactory: providerFactory, extensionsProvider: extensionsProvider, node: node, setDisableScroll: setDisableScroll, mountRef: mountRef, api: api, intl: intl })=>{
    const emojiAndColourPickerMountPoint = scrollable ? popupsMountPoint || (editorView === null || editorView === void 0 ? void 0 : editorView.dom.closest('.fabric-editor-popup-scroll-parent')) || (editorView === null || editorView === void 0 ? void 0 : editorView.dom.closest('.ak-editor-content-area')) || undefined : popupsMountPoint;
    const areAnyNewToolbarFlagsEnabled = (0, $8qHhy.areToolbarFlagsEnabled)(Boolean(api === null || api === void 0 ? void 0 : api.toolbar));
    const renderItem = (item, idx)=>{
        var _api$contextPanel, _api$extension;
        switch(item.type){
            case 'button':
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const ButtonIcon = item.icon;
                const onClickHandler = ()=>{
                    if (item.confirmDialog) dispatchCommand((0, $6pBTo.showConfirmDialog)(idx));
                    else {
                        dispatchCommand(item.onClick);
                        if (item.focusEditoronEnter && !(editorView !== null && editorView !== void 0 && editorView.hasFocus())) editorView === null || editorView === void 0 || editorView.focus();
                    }
                };
                const getIconColor = (disabled, selected)=>{
                    if (disabled) return "var(--ds-icon-disabled, #080F214A)";
                    if (selected) return "var(--ds-icon-selected, #1868DB)";
                    return 'currentColor';
                };
                return /*#__PURE__*/ (0, $9dQre.jsx)((0, $7HjEm.default), {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop, @atlaskit/design-system/no-unsafe-style-overrides -- Ignored via go/DSP-18766
                    className: item.className,
                    key: idx,
                    title: item.title,
                    href: item.href,
                    icon: item.icon ? /*#__PURE__*/ (0, $9dQre.jsx)(ButtonIcon, {
                        color: getIconColor(item.disabled, item.selected),
                        spacing: "spacious",
                        label: undefined,
                        "aria-hidden": true
                    }) : undefined,
                    iconAfter: item.iconAfter ? /*#__PURE__*/ (0, $9dQre.jsx)(item.iconAfter, {
                        label: ""
                    }) : undefined,
                    appearance: item.appearance,
                    target: item.target,
                    onClick: onClickHandler,
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    onMouseEnter: ()=>dispatchCommand(item.onMouseEnter),
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    onMouseLeave: ()=>dispatchCommand(item.onMouseLeave),
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    onFocus: ()=>dispatchCommand(item.onFocus),
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    onBlur: ()=>dispatchCommand(item.onBlur),
                    onMount: item.onMount,
                    onUnmount: item.onUnmount,
                    selected: item.selected,
                    disabled: item.disabled,
                    tooltipContent: item.tooltipContent,
                    testId: item.testId,
                    hideTooltipOnClick: item.hideTooltipOnClick,
                    hasNewContentOnTriggerClick: item.hasNewContentOnTriggerClick,
                    ariaHasPopup: item.ariaHasPopup,
                    tabIndex: item.tabIndex,
                    isRadioButton: item.isRadioButton,
                    ariaLabel: item === null || item === void 0 ? void 0 : item.ariaLabel,
                    pulse: item.pulse,
                    interactionName: item.interactionName,
                    areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
                }, item.showTitle && item.title);
            case 'input':
                return /*#__PURE__*/ (0, $9dQre.jsx)((0, $gaSQI.Input), {
                    key: idx,
                    mountPoint: popupsMountPoint,
                    boundariesElement: popupsBoundariesElement,
                    defaultValue: item.defaultValue,
                    placeholder: item.placeholder,
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    onSubmit: (value)=>dispatchCommand(item.onSubmit(value)),
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    onBlur: (value)=>dispatchCommand(item.onBlur(value))
                });
            case 'custom':
                return item.render(editorView, idx, dispatchAnalyticsEvent, {
                    popupsBoundariesElement: popupsBoundariesElement,
                    popupsMountPoint: popupsMountPoint,
                    popupsScrollableElement: popupsScrollableElement,
                    scrollable: scrollable,
                    setDisableParentScroll: scrollable ? setDisableScroll : undefined
                });
            case 'overflow-dropdown':
                // if an option has a confirmDialog, we need to replace its onClick handler
                // to set the state to show the confirm dialog
                // crudely done here to avoid greater coupling with DropdownMenuItem from `floating-toolbar`
                // which would need knowledge of indexes, showConfirmDialog etc.
                const options = item.options.map((option, optionIndex)=>{
                    if (!('type' in option) && option.confirmDialog) {
                        const onClick = option.confirmDialog ? (0, $6pBTo.showConfirmDialog)(idx, optionIndex) : option.onClick;
                        return {
                            ...option,
                            onClick: onClick
                        };
                    }
                    return option;
                });
                return /*#__PURE__*/ (0, $9dQre.jsx)((0, $iXxVC.default), {
                    alignX: areAnyNewToolbarFlagsEnabled ? 'right' : undefined,
                    key: idx,
                    title: intl.formatMessage((0, $fNLdd.default).viewMore),
                    icon: /*#__PURE__*/ (0, $9dQre.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iabGk))), {
                        label: "",
                        spacing: "spacious"
                    }),
                    dispatchCommand: dispatchCommand,
                    options: options,
                    disabled: item.disabled,
                    tooltip: item.tooltip,
                    hideExpandIcon: true,
                    mountPoint: popupsMountPoint,
                    boundariesElement: popupsBoundariesElement,
                    scrollableElement: popupsScrollableElement,
                    dropdownWidth: item.dropdownWidth,
                    showSelected: item.showSelected,
                    buttonTestId: item.testId,
                    editorView: editorView,
                    setDisableParentScroll: scrollable ? setDisableScroll : undefined,
                    dropdownListId: (item === null || item === void 0 ? void 0 : item.id) && `${item.id}-dropdownList`,
                    alignDropdownWithToolbar: items.length === 1,
                    onClick: item.onClick,
                    areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
                });
            case 'dropdown':
                const DropdownIcon = item.icon;
                const BeforeIcon = item.iconBefore;
                return /*#__PURE__*/ (0, $9dQre.jsx)((0, $iXxVC.default), {
                    key: idx,
                    title: item.title,
                    icon: DropdownIcon && /*#__PURE__*/ (0, $9dQre.jsx)(DropdownIcon, {
                        label: item.title
                    }),
                    iconBefore: BeforeIcon && /*#__PURE__*/ (0, $9dQre.jsx)(BeforeIcon, {
                        label: ""
                    }),
                    dispatchCommand: dispatchCommand,
                    options: item.options,
                    disabled: item.disabled,
                    tooltip: item.tooltip,
                    hideExpandIcon: item.hideExpandIcon,
                    mountPoint: popupsMountPoint,
                    boundariesElement: popupsBoundariesElement,
                    scrollableElement: popupsScrollableElement,
                    dropdownWidth: item.dropdownWidth,
                    showSelected: item.showSelected,
                    buttonTestId: item.testId,
                    editorView: editorView,
                    setDisableParentScroll: scrollable ? setDisableScroll : undefined,
                    dropdownListId: (item === null || item === void 0 ? void 0 : item.id) && `${item.id}-dropdownList`,
                    alignDropdownWithToolbar: items.length === 1,
                    onToggle: item.onToggle,
                    footer: item.footer,
                    onMount: item.onMount,
                    onClick: item.onClick,
                    pulse: item.pulse,
                    shouldFitContainer: item.shouldFitContainer,
                    areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
                });
            case 'select':
                if (item.selectType === 'list') {
                    const ariaLabel = item.title || item.placeholder;
                    return /*#__PURE__*/ (0, $9dQre.jsx)((0, $gM1Ws.default), {
                        key: idx,
                        dispatchCommand: dispatchCommand,
                        options: item.options,
                        hideExpandIcon: item.hideExpandIcon,
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        mountPoint: scrollable ? mountRef.current : undefined,
                        boundariesElement: popupsBoundariesElement,
                        scrollableElement: popupsScrollableElement,
                        defaultValue: item.defaultValue,
                        placeholder: item.placeholder,
                        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                        onChange: (selected)=>dispatchCommand(item.onChange(selected)),
                        ariaLabel: ariaLabel,
                        filterOption: item.filterOption,
                        setDisableParentScroll: scrollable ? setDisableScroll : undefined,
                        classNamePrefix: 'floating-toolbar-select'
                    });
                }
                if (item.selectType === 'color') return /*#__PURE__*/ (0, $9dQre.jsx)((0, $1NElZ.default), {
                    skipFocusButtonAfterPick: true,
                    key: idx,
                    isAriaExpanded: item.isAriaExpanded,
                    hideExpandIcon: item.hideExpandIcon,
                    title: item.title,
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    onChange: (selected)=>{
                        dispatchCommand(item.onChange(selected));
                    },
                    cols: item.cols,
                    colorPalette: item.options,
                    currentColor: item.defaultValue ? item.defaultValue.value : undefined,
                    placement: "Panels",
                    mountPoint: emojiAndColourPickerMountPoint,
                    setDisableParentScroll: scrollable ? setDisableScroll : undefined,
                    hexToPaletteColor: (0, $3y2s4.isExperimentEnabled)('platform_editor_lovability_dividers') ? item.hexToPaletteColor ?? (0, $e4OZJ.hexToEditorBackgroundPaletteColor) : (0, $e4OZJ.hexToEditorBackgroundPaletteColor),
                    paletteColorTooltipMessages: (0, $3y2s4.isExperimentEnabled)('platform_editor_lovability_dividers') ? item.paletteColorTooltipMessages ?? (0, $epqkL.backgroundPaletteTooltipMessages) : (0, $epqkL.backgroundPaletteTooltipMessages),
                    returnEscToButton: item.returnEscToButton
                });
                if (item.selectType === 'emoji') return /*#__PURE__*/ (0, $9dQre.jsx)((0, $2r1FT.EmojiPickerButton), {
                    key: idx,
                    editorView: editorView,
                    title: item.title,
                    providerFactory: providerFactory,
                    isSelected: item.selected,
                    // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                    onChange: (selected)=>dispatchCommand(item.onChange(selected)),
                    mountPoint: emojiAndColourPickerMountPoint,
                    popupsBoundariesElement: popupsBoundariesElement,
                    setDisableParentScroll: scrollable ? setDisableScroll : undefined,
                    pluginInjectionApi: api
                });
                return null;
            case 'extensions-placeholder':
                if (!editorView || !extensionsProvider) return null;
                return /*#__PURE__*/ (0, $9dQre.jsx)((0, $fARSz.ExtensionsPlaceholder), {
                    key: idx,
                    node: node,
                    editorView: editorView,
                    extensionProvider: extensionsProvider,
                    separator: item.separator,
                    applyChangeToContextPanel: api === null || api === void 0 || (_api$contextPanel = api.contextPanel) === null || _api$contextPanel === void 0 ? void 0 : _api$contextPanel.actions.applyChange,
                    extensionApi: api === null || api === void 0 || (_api$extension = api.extension) === null || _api$extension === void 0 ? void 0 : _api$extension.actions.api(),
                    dispatchCommand: dispatchCommand,
                    popupsMountPoint: popupsMountPoint,
                    popupsBoundariesElement: popupsBoundariesElement,
                    popupsScrollableElement: popupsScrollableElement,
                    alignDropdownWithToolbar: items.length === 1,
                    scrollable: scrollable,
                    areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
                });
            case 'separator':
                if (areAnyNewToolbarFlagsEnabled) return item.fullHeight ? /*#__PURE__*/ (0, $9dQre.jsx)((0, $2Bpgx.default), {
                    key: idx,
                    fullHeight: true,
                    areAnyNewToolbarFlagsEnabled: true
                }) : null;
                return /*#__PURE__*/ (0, $9dQre.jsx)((0, $2Bpgx.default), {
                    key: idx,
                    fullHeight: item.fullHeight,
                    areAnyNewToolbarFlagsEnabled: false
                });
        }
    };
    const groupedItems = $3040e4b891be5106$export$7abc8284d66f79b1(// eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- Ignored via go/ees017 (to be fixed)
    items.filter((item)=>!item.hidden), areAnyNewToolbarFlagsEnabled);
    return /*#__PURE__*/ (0, $9dQre.jsx)((0, $f1bHg.default), {
        testId: "editor-floating-toolbar-items"
    }, groupedItems.map((element, index)=>{
        const isGroup = Array.isArray(element);
        if (isGroup) return /*#__PURE__*/ (0, $9dQre.jsx)("div", {
            // Ignored via go/ees005
            // eslint-disable-next-line react/no-array-index-key
            key: index,
            css: areAnyNewToolbarFlagsEnabled ? $3040e4b891be5106$var$buttonGroupStylesNew : $3040e4b891be5106$var$buttonGroupStyles,
            role: "radiogroup",
            "aria-label": groupLabel ?? undefined,
            "data-testid": "editor-floating-toolbar-grouped-buttons"
        }, element.map((element)=>{
            const indexInAllItems = items.findIndex((item)=>item === element);
            return renderItem(element, indexInAllItems);
        }));
        else {
            const indexInAllItems = items.findIndex((item)=>item === element);
            return renderItem(element, indexInAllItems);
        }
    }));
}, (prevProps, nextProps)=>{
    if (!nextProps.node) return false;
    // only rerender toolbar items if the node is different
    // otherwise it causes an issue where multiple popups stays open
    return !(prevProps.node.type !== nextProps.node.type || prevProps.node.attrs.localId !== nextProps.node.attrs.localId || prevProps.popupsBoundariesElement !== nextProps.popupsBoundariesElement || prevProps.popupsMountPoint !== nextProps.popupsMountPoint || prevProps.popupsScrollableElement !== nextProps.popupsScrollableElement || prevProps.scrollable !== nextProps.scrollable || prevProps.setDisableScroll !== nextProps.setDisableScroll || !(0, $jU1gf.areSameItems)(prevProps.items, nextProps.items) || !prevProps.mounted !== !nextProps.mounted);
});
const $3040e4b891be5106$var$buttonGroupStyles = {
    name: "h1up05",
    styles: "display:flex;gap:var(--ds-space-050, 4px)"
};
const $3040e4b891be5106$var$buttonGroupStylesNew = {
    name: "gcdzb",
    styles: "display:flex;gap:var(--ds-space-075, 6px)"
};
const $3040e4b891be5106$var$toolbarContainerBase = {
    name: "17hit5l",
    styles: "display:flex;line-height:1;box-sizing:border-box;& > div > div{align-items:center;}"
};
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var $3040e4b891be5106$var$_ref6 = {
    name: "q568uz",
    styles: "min-height:var(--ds-space-500, 40px)"
};
var $3040e4b891be5106$var$_ref7 = {
    name: "oxur4o",
    styles: "padding-left:var(--ds-space-050, 4px)"
};
var $3040e4b891be5106$var$_ref8 = {
    name: "oxur4o",
    styles: "padding-left:var(--ds-space-050, 4px)"
};
var $3040e4b891be5106$var$_ref9 = {
    name: "s0vnfv",
    styles: "height:32px"
};
var $3040e4b891be5106$var$_ref0 = {
    name: "1k18kha",
    styles: "height:40px"
};
var $3040e4b891be5106$var$_ref1 = {
    name: "1fjjwhj",
    styles: "padding:var(--ds-space-0, 0px)"
};
const $3040e4b891be5106$var$toolbarContainer = (areAnyNewToolbarFlagsEnabled, scrollable, hasSelect, firstElementIsSelect, // See `FloatingToolbarConfig.containerSurface`: 'none' is for a single custom item that
// already renders its own complete surface, so this wrapper's own surface is omitted.
containerSurface = 'default')=>/*#__PURE__*/ (0, $9dQre.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    containerSurface === 'none' ? undefined : {
        backgroundColor: "var(--ds-surface-overlay, #FFFFFF)",
        borderRadius: "var(--ds-radius-small, 3px)",
        boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)"
    }, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    containerSurface === 'none' ? $3040e4b891be5106$var$_ref1 : scrollable ? /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    (0, $9dQre.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    hasSelect ? $3040e4b891be5106$var$_ref0 : $3040e4b891be5106$var$_ref9, "overflow:hidden;") : // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    areAnyNewToolbarFlagsEnabled ? /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
    (0, $9dQre.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        padding: `${"var(--ds-space-0, 0px)"} 4px ${"var(--ds-space-0, 0px)"} 4px`
    }, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    firstElementIsSelect && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    $3040e4b891be5106$var$_ref8) : /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    (0, $9dQre.css)({
        padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-100, 8px)"}`
    }, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    firstElementIsSelect && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    $3040e4b891be5106$var$_ref7), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    areAnyNewToolbarFlagsEnabled ? $3040e4b891be5106$var$_ref6 : undefined);
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var $3040e4b891be5106$var$_ref = {
    name: "zjik7",
    styles: "display:flex"
};
var $3040e4b891be5106$var$_ref2 = {
    name: "9kivhj",
    styles: "margin-left:var(--ds-space-100, 8px)"
};
var $3040e4b891be5106$var$_ref3 = {
    name: "8gsxsd",
    styles: "margin-left:var(--ds-space-050, 4px)"
};
var $3040e4b891be5106$var$_ref4 = {
    name: "upho8i",
    styles: "overflow-x:auto;overflow-y:hidden;scrollbar-width:none"
};
var $3040e4b891be5106$var$_ref5 = {
    name: "d3v9zr",
    styles: "overflow:hidden"
};
const $3040e4b891be5106$var$toolbarOverflow = ({ scrollable: scrollable, scrollDisabled: scrollDisabled, firstElementIsSelect: firstElementIsSelect, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled })=>/*#__PURE__*/ (0, $9dQre.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    scrollable ? /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    (0, $9dQre.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    scrollDisabled ? $3040e4b891be5106$var$_ref5 : $3040e4b891be5106$var$_ref4, {
        WebkitOverflowScrolling: 'touch',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        padding: `${"var(--ds-space-050, 4px)"} 0 ${"var(--ds-space-050, 4px)"}`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> div': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            '> div:first-child': firstElementIsSelect ? $3040e4b891be5106$var$_ref3 : $3040e4b891be5106$var$_ref2,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '> div:nth-last-child(1 of :not(:where([popover], dialog)))': {
                marginRight: "var(--ds-space-100, 8px)"
            }
        }
    }, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    areAnyNewToolbarFlagsEnabled ? /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
    (0, $9dQre.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        padding: `${"var(--ds-space-0, 0px)"} 4px ${"var(--ds-space-600, 48px)"} 4px`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
        '> div': {
            minHeight: "var(--ds-space-500, 40px)",
            gap: "var(--ds-space-075, 6px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '> div:first-child': {
                marginLeft: 0
            },
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
            '> div:nth-last-child(1 of :not(:where([popover], dialog)))': {
                marginRight: 0
            }
        }
    }) : undefined) : $3040e4b891be5106$var$_ref);
// eslint-disable-next-line @repo/internal/react/no-class-components
class $3040e4b891be5106$var$Toolbar extends (0, $bSJIT.Component) {
    constructor(props){
        super(props), this.setDisableScroll = (disabled)=>{
            // wait before setting disabled state incase users jumping from one popup to another
            if (disabled) requestAnimationFrame(()=>{
                this.setState({
                    scrollDisabled: disabled
                });
            });
            else this.setState({
                scrollDisabled: disabled
            });
        }, this.shouldHandleArrowKeys = ()=>{
            var _this$props$items;
            //To prevent the keydown handling of arrow keys for custom toolbar items with 'disableArrowNavigation' prop enabled,
            //Usually the button which has menus or popups
            return !((_this$props$items = this.props.items) !== null && _this$props$items !== void 0 && _this$props$items.find((item)=>item.type === 'custom' && item.disableArrowNavigation));
        }, this.handleEscape = (event)=>{
            var _this$props$editorVie;
            // If any menu is open inside the floating toolbar 'Esc' key should not
            // focus the editorview.
            // Event can't be stopped as they are not childnodes of floating toolbar
            // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
            const isDropdownOpen = !!document.querySelector('[data-role="droplistContent"]');
            // eslint-disable-next-line @atlaskit/platform/no-direct-document-usage
            const isSelectMenuOpen = !!document.querySelector('.floating-toolbar-select__menu');
            if (isDropdownOpen || isSelectMenuOpen) return;
            (_this$props$editorVie = this.props.editorView) === null || _this$props$editorVie === void 0 || _this$props$editorVie.focus();
            event.preventDefault();
            event.stopPropagation();
        }, this.captureMouseEvent = (event)=>{
            var _this$props$items2;
            // Don't capture mouse event for custom toolbars e.g. insert hyperlink
            if (((_this$props$items2 = this.props.items) === null || _this$props$items2 === void 0 ? void 0 : _this$props$items2.length) === 1 && this.props.items[0].type === 'custom') return;
            // Prevents toolbar from closing when clicking on the toolbar itself and not on the buttons
            event.stopPropagation();
            event.preventDefault();
        }, this.isShortcutToFocusToolbar = (event)=>{
            //Alt + F10 to reach first element in this floating toolbar
            return event.altKey && (event.key === 'F10' || event.keyCode === 121);
        };
        this.scrollContainerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createRef();
        this.mountRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createRef();
        this.toolbarContainerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createRef();
        this.state = {
            scrollDisabled: false,
            mounted: false
        };
    }
    // remove any decorations added by toolbar buttons i.e danger and selected styling
    // this prevents https://product-fabric.atlassian.net/browse/ED-10207
    resetStyling() {
        if (this.props.editorView) {
            var _this$props$api;
            const { state: state, dispatch: dispatch } = this.props.editorView;
            (_this$props$api = this.props.api) === null || _this$props$api === void 0 || (_this$props$api = _this$props$api.decorations) === null || _this$props$api === void 0 || _this$props$api.actions.removeDecoration(state, dispatch);
        }
    }
    componentDidMount() {
        this.setState({
            mounted: true
        });
    }
    componentDidUpdate(prevProps) {
        var _this$props;
        (0, $7m0En.checkShouldForceFocusAndApply)((_this$props = this.props) === null || _this$props === void 0 ? void 0 : _this$props.editorView);
        if (this.props.node !== prevProps.node) this.resetStyling();
    }
    componentWillUnmount() {
        const { editorView: editorView } = this.props;
        if (editorView) {
            const { state: { tr: tr }, dispatch: dispatch } = editorView;
            dispatch((0, $7m0En.forceFocusSelector)(null)(tr));
        }
        this.resetStyling();
    }
    render() {
        var _this$props$api2;
        const { items: items, className: className, node: node, intl: intl, scrollable: scrollable, mediaAssistiveMessage: mediaAssistiveMessage } = this.props;
        const areAnyNewToolbarFlagsEnabled = (0, $8qHhy.areToolbarFlagsEnabled)(Boolean((_this$props$api2 = this.props.api) === null || _this$props$api2 === void 0 ? void 0 : _this$props$api2.toolbar));
        if (!items || !items.length) return null;
        // Select has left padding of 4px to the border, everything else 8px
        const firstElementIsSelect = items[0].type === 'select';
        const hasSelect = items.find((item)=>item.type === 'select' && item.selectType === 'list');
        return /*#__PURE__*/ (0, $9dQre.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, /*#__PURE__*/ (0, $9dQre.jsx)((0, $aHqLs.ToolbarArrowKeyNavigationProvider), {
            editorView: this.props.editorView,
            handleEscape: this.handleEscape,
            disableArrowKeyNavigation: !this.shouldHandleArrowKeys(),
            childComponentSelector: "[data-testid='editor-floating-toolbar']",
            isShortcutToFocusToolbar: this.isShortcutToFocusToolbar,
            intl: intl
        }, /*#__PURE__*/ (0, $9dQre.jsx)("div", {
            ref: this.toolbarContainerRef,
            css: ()=>[
                    $3040e4b891be5106$var$toolbarContainerBase,
                    $3040e4b891be5106$var$toolbarContainer(areAnyNewToolbarFlagsEnabled, scrollable, hasSelect !== undefined, firstElementIsSelect, this.props.containerSurface)
                ],
            "aria-label": intl.formatMessage((0, $74yRN.default).floatingToolbarAriaLabel),
            role: "toolbar",
            "data-testid": "editor-floating-toolbar",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: className,
            onMouseDown: areAnyNewToolbarFlagsEnabled ? this.captureMouseEvent : undefined
        }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $4ambm.default), {
            text: mediaAssistiveMessage ? `${mediaAssistiveMessage}, ${intl.formatMessage((0, $74yRN.default).floatingToolbarAnnouncer)}` : intl.formatMessage((0, $74yRN.default).floatingToolbarAnnouncer),
            delay: 250
        }), scrollable && areAnyNewToolbarFlagsEnabled && /*#__PURE__*/ (0, $9dQre.jsx)((0, $1UG5w.ScrollButton), {
            intl: intl,
            scrollContainerRef: this.scrollContainerRef,
            node: node,
            disabled: this.state.scrollDisabled,
            side: "left"
        }), /*#__PURE__*/ (0, $9dQre.jsx)("div", {
            "data-testid": "floating-toolbar-items",
            ref: this.scrollContainerRef,
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            css: $3040e4b891be5106$var$toolbarOverflow({
                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled,
                scrollable: scrollable,
                scrollDisabled: this.state.scrollDisabled,
                firstElementIsSelect: firstElementIsSelect
            })
        }, /*#__PURE__*/ (0, $9dQre.jsx)($3040e4b891be5106$var$ToolbarItems, {
            ...this.props,
            setDisableScroll: this.setDisableScroll,
            mountRef: this.mountRef,
            mounted: this.state.mounted
        })), scrollable && (areAnyNewToolbarFlagsEnabled ? /*#__PURE__*/ (0, $9dQre.jsx)((0, $1UG5w.ScrollButton), {
            intl: intl,
            scrollContainerRef: this.scrollContainerRef,
            node: node,
            disabled: this.state.scrollDisabled,
            side: "right"
        }) : /*#__PURE__*/ (0, $9dQre.jsx)((0, $d37J1.ScrollButtons), {
            intl: intl,
            scrollContainerRef: this.scrollContainerRef,
            node: node,
            disabled: this.state.scrollDisabled,
            areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
        }))), /*#__PURE__*/ (0, $9dQre.jsx)("div", {
            ref: this.mountRef
        })));
    }
}
// eslint-disable-next-line @typescript-eslint/no-restricted-types
const $3040e4b891be5106$var$_default_1 = (0, $fK3tS.default)($3040e4b891be5106$var$Toolbar);
var $3040e4b891be5106$export$2e2bcd8739ae039 = $3040e4b891be5106$var$_default_1;

});
parcelRegister("jU1gf", function(module, exports) {
$parcel$export(module.exports, "areSameItems", () => $3a8f1d65c39b9bf5$export$1d04baad505b720e);



var $74yRN = parcelRequire("74yRN");

// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $3a8f1d65c39b9bf5$var$makeSameType(_a, _b) {
    return true;
}
const $3a8f1d65c39b9bf5$export$d36bdfa510afb180 = (objA, objB)=>{
    if (objA === objB) return true;
    if (objA == null || objB == null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    const bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    for(let idx = 0; idx < keysA.length; idx++){
        const key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (objA[key] !== objB[key]) return false;
    }
    return true;
};
const $3a8f1d65c39b9bf5$export$fc16749c794bf6ff = (left, right, compareFn = $3a8f1d65c39b9bf5$export$d36bdfa510afb180)=>{
    if (left.length !== right.length) return false;
    for(let idx = 0; idx < left.length; idx++){
        if (!compareFn(left[idx], right[idx])) return false;
    }
    return true;
};
const $3a8f1d65c39b9bf5$var$compareItemWithKeys = (leftItem, rightItem, excludedKeys = [])=>Object.keys(leftItem).filter((key)=>excludedKeys.indexOf(key) === -1).every((key)=>leftItem[key] instanceof Object ? // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        $3a8f1d65c39b9bf5$export$d36bdfa510afb180(leftItem[key], rightItem[key]) : leftItem[key] === rightItem[key]);
const $3a8f1d65c39b9bf5$export$b6007c51cfc2eaf0 = (leftItem, rightItem)=>{
    if (leftItem.type !== rightItem.type) return false;
    switch(leftItem.type){
        case 'button':
            // Need to typecast `rightItem as typeof leftItem` otherwise we will
            // have to put the `type !==` inside each case.
            return $3a8f1d65c39b9bf5$var$compareItemWithKeys(leftItem, rightItem, [
                'type',
                'onClick',
                'onMouseEnter',
                'onMouseLeave'
            ]);
        case 'copy-button':
            return $3a8f1d65c39b9bf5$var$compareItemWithKeys(leftItem, rightItem, [
                'type',
                'items'
            ]);
        case 'input':
            return $3a8f1d65c39b9bf5$var$compareItemWithKeys(leftItem, rightItem, [
                'type',
                'onSubmit',
                'onBlur'
            ]);
        case 'select':
            if ($3a8f1d65c39b9bf5$var$makeSameType(leftItem, rightItem) && Array.isArray(leftItem.options) && Array.isArray(rightItem.options) && // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            !$3a8f1d65c39b9bf5$export$fc16749c794bf6ff(leftItem.options, rightItem.options, (left, right)=>$3a8f1d65c39b9bf5$var$compareItemWithKeys(left, right))) return false;
            return $3a8f1d65c39b9bf5$var$compareItemWithKeys(leftItem, rightItem, [
                'type',
                'onChange',
                'options'
            ]);
        case 'overflow-dropdown':
        case 'dropdown':
            if ($3a8f1d65c39b9bf5$var$makeSameType(leftItem, rightItem) && Array.isArray(leftItem.options) && Array.isArray(rightItem.options) && // @ts-expect-error TS2345: Argument of type 'DropdownOptionT<Function>[]' is not assignable to parameter of type 'any[][]'
            !$3a8f1d65c39b9bf5$export$fc16749c794bf6ff(leftItem.options, rightItem.options, (left, right)=>// @ts-expect-error  TS2322: Type '"onClick"' is not assignable to type 'keyof any[]'
                $3a8f1d65c39b9bf5$var$compareItemWithKeys(left, right, [
                    'onClick'
                ]))) return false;
            return $3a8f1d65c39b9bf5$var$compareItemWithKeys(leftItem, rightItem, [
                'type',
                'options'
            ]);
        case 'custom':
            return false;
        case 'separator':
            return $3a8f1d65c39b9bf5$var$compareItemWithKeys(leftItem, rightItem);
        case 'extensions-placeholder':
            return $3a8f1d65c39b9bf5$var$compareItemWithKeys(leftItem, rightItem);
    }
};
const $3a8f1d65c39b9bf5$export$1d04baad505b720e = (leftArr, rightArr)=>{
    if (leftArr === undefined && rightArr === undefined) return true;
    if (leftArr === undefined || rightArr === undefined) return false;
    if (leftArr.length !== rightArr.length) return false;
    return leftArr.every((item, index)=>$3a8f1d65c39b9bf5$export$b6007c51cfc2eaf0(rightArr[index], item));
};

});

parcelRegister("iXxVC", function(module, exports) {
$parcel$export(module.exports, "default", () => $9f855b843cfb9bb7$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $7HjEm = parcelRequire("7HjEm");

var $imBU3 = parcelRequire("imBU3");

var $6bWVw = parcelRequire("6bWVw");

var $4GWyU = parcelRequire("4GWyU");

var $5VGMy = parcelRequire("5VGMy");

var $1F8Tv = parcelRequire("1F8Tv");
function $9f855b843cfb9bb7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $9f855b843cfb9bb7$var$dropdownExpandContainer = /*#__PURE__*/ (0, $9dQre.css)({
    margin: `0px ${"var(--ds-space-negative-050, -4px)"}`
});
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $9f855b843cfb9bb7$var$iconGroup = {
    name: "zjik7",
    styles: "display:flex"
};
const $9f855b843cfb9bb7$var$CompositeIcon = ({ icon: icon })=>/*#__PURE__*/ (0, $9dQre.jsx)("div", {
        css: $9f855b843cfb9bb7$var$iconGroup
    }, icon, /*#__PURE__*/ (0, $9dQre.jsx)("span", {
        css: $9f855b843cfb9bb7$var$dropdownExpandContainer
    }, /*#__PURE__*/ (0, $9dQre.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4GWyU))), {
        color: "currentColor",
        spacing: "spacious",
        label: "Expand dropdown menu",
        size: "small"
    })));
class $9f855b843cfb9bb7$export$2e2bcd8739ae039 extends (0, $bSJIT.Component) {
    render() {
        const { isOpen: isOpen } = this.state;
        const { title: title, icon: icon, iconBefore: iconBefore, options: options, dispatchCommand: dispatchCommand, mountPoint: mountPoint, boundariesElement: boundariesElement, scrollableElement: scrollableElement, hideExpandIcon: hideExpandIcon, disabled: disabled, tooltip: tooltip, buttonTestId: buttonTestId, dropdownWidth: dropdownWidth, dropdownListId: dropdownListId, alignDropdownWithToolbar: alignDropdownWithToolbar, footer: footer, onMount: onMount, pulse: pulse, shouldFitContainer: shouldFitContainer, alignX: alignX, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled } = this.props;
        let trigger;
        if (icon) {
            const TriggerIcon = hideExpandIcon ? icon : /*#__PURE__*/ (0, $9dQre.jsx)($9f855b843cfb9bb7$var$CompositeIcon, {
                icon: icon
            });
            trigger = /*#__PURE__*/ (0, $9dQre.jsx)((0, $7HjEm.default), {
                testId: buttonTestId,
                title: title,
                icon: TriggerIcon,
                onClick: this.toggleOpen,
                onKeyDown: this.toggleOpenByKeyboard,
                selected: isOpen,
                disabled: disabled,
                tooltipContent: tooltip,
                ariaHasPopup: areAnyNewToolbarFlagsEnabled ? true : undefined,
                onMount: onMount,
                pulse: pulse,
                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
            });
        } else trigger = /*#__PURE__*/ (0, $9dQre.jsx)((0, $7HjEm.default), {
            testId: buttonTestId,
            iconAfter: /*#__PURE__*/ (0, $9dQre.jsx)("span", {
                css: $9f855b843cfb9bb7$var$dropdownExpandContainer
            }, /*#__PURE__*/ (0, $9dQre.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4GWyU))), {
                color: "currentColor",
                spacing: "spacious",
                label: "Expand dropdown menu",
                size: "small"
            })),
            icon: iconBefore,
            onClick: this.toggleOpen,
            onKeyDown: this.toggleOpenByKeyboard,
            selected: isOpen,
            disabled: disabled,
            tooltipContent: tooltip,
            ariaHasPopup: true,
            areaControls: dropdownListId,
            onMount: onMount,
            pulse: pulse,
            areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
        }, title);
        /**
     * We want to change direction of our dropdowns a bit early,
     * not exactly when it hits the boundary.
     */ const fitTolerance = 10;
        const fitWidth = Array.isArray(options) || typeof options === 'function' ? dropdownWidth || (0, $1F8Tv.menuItemDimensions).width : options.width;
        const fitHeight = Array.isArray(options) ? options.length * (0, $1F8Tv.menuItemDimensions).height + (0, $1F8Tv.itemSpacing) * 2 : typeof options === 'function' ? this.makeArrayOptionsFromCallback(options).length : options.height;
        return(/**
       * At the moment footer diver is rendered along with footer, if it's provided
       * This is to provide some level of consistency
       * Refer to the PR for more details:
       * https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/137394/overview?commentId=8130003
       */ /*#__PURE__*/ (0, $9dQre.jsx)((0, $6bWVw.DropdownContainer), {
            alignX: alignX,
            mountTo: mountPoint,
            boundariesElement: boundariesElement,
            scrollableElement: scrollableElement,
            isOpen: isOpen,
            handleClickOutside: this.hide,
            handleEscapeKeydown: this.hideOnEsc,
            onOpenChange: this.onOpenChanged,
            fitWidth: fitWidth + fitTolerance,
            fitHeight: fitHeight + fitTolerance,
            trigger: trigger,
            dropdownListId: dropdownListId,
            alignDropdownWithParentElement: alignDropdownWithToolbar,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            arrowKeyNavigationProviderOptions: {
                type: (0, $imBU3.ArrowKeyNavigationType).MENU
            },
            shouldFitContainer: shouldFitContainer
        }, Array.isArray(options) ? this.renderArrayOptions(options) : typeof options === 'function' ? this.renderArrayOptions(this.makeArrayOptionsFromCallback(options)) : options.render({
            hide: this.hide,
            dispatchCommand: dispatchCommand
        }), footer && /*#__PURE__*/ (0, $9dQre.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, /*#__PURE__*/ (0, $9dQre.jsx)((0, $5VGMy.Divider), null), footer)));
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.isOpen !== this.state.isOpen) {
            if (this.props.setDisableParentScroll) this.props.setDisableParentScroll(this.state.isOpen);
            // ECA11Y-235: no sense in sending keyboard event since the menu popup mounted to the custom element,
            // we will ensure first element focused asap as 'MenuArrowKeyNavigationProvider' is mounted
            if (this.props.mountPoint) return;
            if (this.state.isOpen && this.state.isOpenedByKeyboard) {
                const dropList = document.querySelector('[data-role="droplistContent"]');
                if (dropList) // Add setTimeout so that if a dropdown item has tooltip,
                // the tooltip won't be rendered until next render cycle
                // when the droplist is correctly positioned.
                // This makes tooltip appears at the correct position for the first dropdown item.
                setTimeout(()=>{
                    const keyboardEvent = new KeyboardEvent('keydown', {
                        bubbles: true,
                        key: 'ArrowDown'
                    });
                    dropList.dispatchEvent(keyboardEvent);
                }, 0);
            }
        }
    }
    constructor(...args){
        super(...args), this.state = {
            isOpen: false,
            isOpenedByKeyboard: false
        }, this.triggerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createRef(), this.makeArrayOptionsFromCallback = (makeOptions)=>{
            const options = makeOptions();
            return options;
        }, this.renderArrayOptions = (options)=>{
            const { showSelected: showSelected, dispatchCommand: dispatchCommand, editorView: editorView, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled } = this.props;
            return /*#__PURE__*/ (0, $9dQre.jsx)((0, $1F8Tv.default), {
                hide: this.hide,
                dispatchCommand: dispatchCommand,
                items: options,
                showSelected: showSelected,
                editorView: editorView,
                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
            });
        }, this.toggleOpen = ()=>{
            const onClick = this.props.onClick;
            if (onClick) onClick();
            this.setState({
                isOpen: !this.state.isOpen,
                isOpenedByKeyboard: false
            });
            const onToggle = this.props.onToggle;
            if (!onToggle) return;
            requestAnimationFrame(()=>{
                this.props.dispatchCommand(onToggle);
            });
        }, this.toggleOpenByKeyboard = (event)=>{
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                this.setState({
                    isOpen: !this.state.isOpen,
                    isOpenedByKeyboard: true
                });
            }
        }, this.hide = ()=>{
            this.setState({
                ...this.state,
                isOpen: false
            });
        }, this.hideOnEsc = ()=>{
            var _document$querySelect;
            // Focus the trigger button only on Escape
            // Focus is done before hiding to ensure onBlur is called
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            (_document$querySelect = document.querySelector(`[data-testid=${this.props.buttonTestId}]`)) === null || _document$querySelect === void 0 || _document$querySelect.focus();
            this.hide();
        }, this.onOpenChanged = (openChangedEvent)=>{
            if (!openChangedEvent.isOpen && openChangedEvent.event instanceof KeyboardEvent) {
                var _openChangedEvent$eve;
                ((_openChangedEvent$eve = openChangedEvent.event) === null || _openChangedEvent$eve === void 0 ? void 0 : _openChangedEvent$eve.key) === 'Escape' ? this.hideOnEsc() : this.hide();
            }
        };
    }
}

});
parcelRegister("5VGMy", function(module, exports) {
$parcel$export(module.exports, "Divider", () => $0005dab1c192eeec$export$2e0a83ec2e27ecbb);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $gUpf2 = parcelRequire("gUpf2");

var $9BVpB = parcelRequire("9BVpB");
const $0005dab1c192eeec$var$styles = (0, $9BVpB.xcss)({
    width: '100%',
    borderBlockEnd: 'none',
    borderBlockStart: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    borderInline: 'none'
});
const $0005dab1c192eeec$export$2e0a83ec2e27ecbb = ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $gUpf2.Box), {
        as: "hr",
        xcss: $0005dab1c192eeec$var$styles,
        role: "presentation"
    });

});

parcelRegister("1F8Tv", function(module, exports) {
$parcel$export(module.exports, "menuItemDimensions", () => $1a1a5a9efc74ba27$export$1a7f12094b137d20);
$parcel$export(module.exports, "itemSpacing", () => $1a1a5a9efc74ba27$export$e14354b446b68c1f);
$parcel$export(module.exports, "default", () => $1a1a5a9efc74ba27$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $fK3tS = parcelRequire("fK3tS");

var $jSR7I = parcelRequire("jSR7I");

var $kD5qu = parcelRequire("kD5qu");

var $fsfgu = parcelRequire("fsfgu");
const $1a1a5a9efc74ba27$export$1a7f12094b137d20 = {
    width: 175,
    height: 32
};
const $1a1a5a9efc74ba27$var$headingStyles = /*#__PURE__*/ (0, $9dQre.css)({
    padding: `${"var(--ds-space-200, 16px)"} 0 ${"var(--ds-space-100, 8px)"}`
});
// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
const $1a1a5a9efc74ba27$var$menuContainerStyles = /*#__PURE__*/ (0, $9dQre.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    minWidth: `${$1a1a5a9efc74ba27$export$1a7f12094b137d20.width}px`,
    // temporary solution to retain spacing defined by @atlaskit/Item
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& button': {
        minHeight: "var(--ds-space-400, 32px)",
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"} 7px`,
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > [data-item-elem-before]': {
            marginRight: "var(--ds-space-050, 4px)"
        }
    }
});
const $1a1a5a9efc74ba27$export$e14354b446b68c1f = 4;
const $1a1a5a9efc74ba27$var$Dropdown = /*#__PURE__*/ (0, $bSJIT.memo)((props)=>{
    const { hide: hide, dispatchCommand: dispatchCommand, items: items, intl: intl, editorView: editorView, showSelected: showSelected = true, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled } = props;
    if (areAnyNewToolbarFlagsEnabled) return /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        css: $1a1a5a9efc74ba27$var$menuContainerStyles,
        role: "menu"
    }, items.filter((item)=>item && (!('hidden' in item) || !item.hidden)).map((item, idx)=>{
        if (!('type' in item)) return /*#__PURE__*/ (0, $9dQre.jsx)((0, $jSR7I.DropdownMenuItem), {
            // Ignored via go/ees005
            // eslint-disable-next-line react/no-array-index-key
            key: idx,
            item: item,
            hide: hide,
            dispatchCommand: dispatchCommand,
            editorView: editorView,
            showSelected: showSelected,
            intl: intl
        });
        if (item.type === 'separator') // eslint-disable-next-line react/no-array-index-key
        return /*#__PURE__*/ (0, $9dQre.jsx)((0, $kD5qu.DropdownSeparator), {
            key: idx
        });
        if (item.type === 'overflow-dropdown-heading') return /*#__PURE__*/ (0, $9dQre.jsx)("div", {
            key: item.title,
            css: $1a1a5a9efc74ba27$var$headingStyles
        }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $fsfgu.default), null, item.title));
        if (item.type === 'custom') {
            const dropdownMenuOptions = {
                hide: hide,
                dispatchCommand: dispatchCommand,
                editorView: editorView,
                showSelected: showSelected,
                intl: intl
            };
            return item.render(editorView, dropdownMenuOptions);
        }
    }));
    return /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        css: $1a1a5a9efc74ba27$var$menuContainerStyles,
        role: "menu"
    }, items.filter((item)=>!item.hidden).map((item, idx)=>/*#__PURE__*/ (0, $9dQre.jsx)((0, $jSR7I.DropdownMenuItem), {
            // Ignored via go/ees005
            // eslint-disable-next-line react/no-array-index-key
            key: idx,
            item: item,
            hide: hide,
            dispatchCommand: dispatchCommand,
            editorView: editorView,
            showSelected: showSelected,
            intl: intl
        })));
});
const $1a1a5a9efc74ba27$var$_default_1 = (0, $fK3tS.default)($1a1a5a9efc74ba27$var$Dropdown);
var $1a1a5a9efc74ba27$export$2e2bcd8739ae039 = $1a1a5a9efc74ba27$var$_default_1;

});


parcelRegister("2r1FT", function(module, exports) {
$parcel$export(module.exports, "EmojiPickerButton", () => $2d43ce252d475ddd$export$428fcc6fc228bd52);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $4TRbS = parcelRequire("4TRbS");

var $5zk80 = parcelRequire("5zk80");

var $3Aq92 = parcelRequire("3Aq92");

var $cf2n1 = parcelRequire("cf2n1");

var $5beht = parcelRequire("5beht");

var $asaws = parcelRequire("asaws");

var $7k37t = parcelRequire("7k37t");

var $lavtv = parcelRequire("lavtv");
function $2d43ce252d475ddd$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $2d43ce252d475ddd$var$emojiPickerButtonWrapperVisualRefresh = {
    name: "1spoyok",
    styles: "position:relative;button{&:not([disabled])::after{border:none;}}"
};
const $2d43ce252d475ddd$var$selector = (states)=>{
    var _states$emojiState;
    return (_states$emojiState = states.emojiState) === null || _states$emojiState === void 0 ? void 0 : _states$emojiState.emojiProvider;
};
const $2d43ce252d475ddd$var$EmojiPickerWithProvider = (props)=>{
    const emojiProvider = (0, $5beht.useSharedPluginStateWithSelector)(props.pluginInjectionApi, [
        'emoji'
    ], $2d43ce252d475ddd$var$selector);
    const setOutsideClickTargetRef = (0, $bSJIT.useContext)((0, $3Aq92.OutsideClickTargetRefContext));
    if (!emojiProvider) return null;
    return /*#__PURE__*/ (0, $9dQre.jsx)((0, $asaws.EmojiPicker), {
        emojiProvider: Promise.resolve(emojiProvider),
        onSelection: props.updateEmoji,
        onPickerRef: setOutsideClickTargetRef
    });
};
// Note: These are based on the height and width of the emoji picker at the time
// of writing (2025-05-05). It is 100% prone to change but at least it's vaguely
// written down.
const $2d43ce252d475ddd$var$EMOJI_PICKER_MAX_HEIGHT = 431;
const $2d43ce252d475ddd$var$EMOJI_PICKER_MAX_WIDTH = 352;
const $2d43ce252d475ddd$var$EmojiPickerWithListener = (0, $cf2n1.default)($2d43ce252d475ddd$var$EmojiPickerWithProvider);
const $2d43ce252d475ddd$export$428fcc6fc228bd52 = (props)=>{
    const buttonRef = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useRef(null);
    const [isPopupOpen, setIsPopupOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useState(false);
    (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useEffect(()=>{
        if (props.setDisableParentScroll) props.setDisableParentScroll(isPopupOpen);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isPopupOpen
    ]);
    const togglePopup = (0, $bSJIT.useCallback)(()=>{
        setIsPopupOpen(!isPopupOpen);
    }, [
        setIsPopupOpen,
        isPopupOpen
    ]);
    const updateEmoji = (emoji)=>{
        setIsPopupOpen(false);
        props.onChange && props.onChange(emoji);
        requestAnimationFrame(()=>{
            var _props$editorView;
            (_props$editorView = props.editorView) === null || _props$editorView === void 0 || _props$editorView.focus();
        });
    };
    const isDetachedElement = (0, $bSJIT.useCallback)((el)=>!document.body.contains(el), []);
    const handleEmojiClickOutside = (0, $bSJIT.useCallback)((e)=>{
        // Ignore click events for detached elements.
        // Workaround for CETI-240 - where two onClicks fire - one when the upload button is
        // still in the document, and one once it's detached. Does not always occur, and
        // may be a side effect of a react render optimisation
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        if (e && e.target && !isDetachedElement(e.target)) togglePopup();
    }, [
        isDetachedElement,
        togglePopup
    ]);
    const handleEmojiPressEscape = (0, $bSJIT.useCallback)(()=>{
        var _buttonRef$current;
        setIsPopupOpen(false);
        (_buttonRef$current = buttonRef.current) === null || _buttonRef$current === void 0 || _buttonRef$current.focus();
    }, [
        setIsPopupOpen,
        buttonRef
    ]);
    const renderPopup = ()=>{
        if (!buttonRef.current || !isPopupOpen) return;
        return /*#__PURE__*/ (0, $9dQre.jsx)((0, $5zk80.default), {
            target: buttonRef.current,
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            mountTo: props.setDisableParentScroll ? props.mountPoint : buttonRef.current.parentElement,
            fitHeight: $2d43ce252d475ddd$var$EMOJI_PICKER_MAX_HEIGHT,
            fitWidth: $2d43ce252d475ddd$var$EMOJI_PICKER_MAX_WIDTH,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            offset: [
                0,
                10
            ],
            // Confluence inline comment editor has z-index: 500
            // if the toolbar is scrollable, this will be mounted in the root editor
            // we need an index of > 500 to display over it
            zIndex: props.setDisableParentScroll ? 600 : undefined,
            focusTrap: true,
            preventOverflow: true,
            boundariesElement: props.popupsBoundariesElement
        }, /*#__PURE__*/ (0, $9dQre.jsx)($2d43ce252d475ddd$var$EmojiPickerWithListener, {
            handleEscapeKeydown: handleEmojiPressEscape,
            handleClickOutside: handleEmojiClickOutside,
            pluginInjectionApi: props.pluginInjectionApi,
            updateEmoji: updateEmoji
        }));
    };
    const title = props.title || '';
    return /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        css: $2d43ce252d475ddd$var$emojiPickerButtonWrapperVisualRefresh
    }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $lavtv.default), {
        content: title,
        position: "top"
    }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $4TRbS.default), {
        appearance: "subtle",
        key: props.idx,
        onClick: togglePopup,
        ref: buttonRef,
        isSelected: props.isSelected,
        label: title,
        spacing: "compact",
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        icon: ()=>/*#__PURE__*/ (0, $9dQre.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7k37t))), {
                color: "currentColor",
                label: "emoji-picker-button",
                spacing: "spacious"
            })
    })), renderPopup());
};

});

parcelRegister("fARSz", function(module, exports) {
$parcel$export(module.exports, "ExtensionsPlaceholder", () => $ee4901da190d9eb6$export$8bacfc8aacebb3c1);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $deAR2 = parcelRequire("deAR2");

var $cJJTb = parcelRequire("cJJTb");

var $f1bHg = parcelRequire("f1bHg");

var $kky6V = parcelRequire("kky6V");

var $7HjEm = parcelRequire("7HjEm");

var $2Bpgx = parcelRequire("2Bpgx");

var $bnbmo = parcelRequire("bnbmo");
var $aec79 = parcelRequire("aec79");

var $5vR15 = parcelRequire("5vR15");

var $3y2s4 = parcelRequire("3y2s4");

var $iXxVC = parcelRequire("iXxVC");
const $ee4901da190d9eb6$var$noop = ()=>null;
const $ee4901da190d9eb6$var$isDefaultExport = (mod)=>{
    return mod.hasOwnProperty('default');
};
const $ee4901da190d9eb6$var$resolveExtensionIcon = async (getIcon)=>{
    if (!getIcon) return $ee4901da190d9eb6$var$noop;
    const maybeIcon = await getIcon();
    return $ee4901da190d9eb6$var$isDefaultExport(maybeIcon) ? maybeIcon.default : maybeIcon;
};
const $ee4901da190d9eb6$var$ButtonIconLazy = ({ icon: icon, label: label })=>{
    const Icon = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useMemo(()=>(0, $cJJTb.lazy)(()=>$ee4901da190d9eb6$var$resolveExtensionIcon(icon), {}), [
        icon
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $cJJTb.LazySuspense), {
        fallback: null,
        children: /*#__PURE__*/ (0, $dc70d.jsx)(Icon, {
            label: label
        })
    });
};
const $ee4901da190d9eb6$var$ButtonIconLoadable = ({ icon: icon, label: label })=>{
    const Icon = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useMemo(()=>(0, (/*@__PURE__*/$parcel$interopDefault($deAR2)))({
            // Ignored via go/ees005
            // eslint-disable-next-line require-await
            loader: async ()=>$ee4901da190d9eb6$var$resolveExtensionIcon(icon),
            loading: $ee4901da190d9eb6$var$noop
        }), [
        icon
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)(Icon, {
        label: label
    });
};
const $ee4901da190d9eb6$var$ExtensionIcon = ({ icon: icon, label: label })=>{
    return (0, $3y2s4.isExperimentEnabled)('platform_editor_loosely_lazy_migration') ? /*#__PURE__*/ (0, $dc70d.jsx)($ee4901da190d9eb6$var$ButtonIconLazy, {
        icon: icon,
        label: label
    }) : /*#__PURE__*/ (0, $dc70d.jsx)($ee4901da190d9eb6$var$ButtonIconLoadable, {
        icon: icon,
        label: label
    });
};
const $ee4901da190d9eb6$var$ExtensionButton = (props)=>{
    const { item: item, node: node, extensionApi: extensionApi, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled } = props;
    const onClick = ()=>{
        if (typeof item.action !== 'function') throw new Error(`'action' of context toolbar item '${item.key}' is not a function`);
        const targetNodeAdf = (0, $5vR15.nodeToJSON)(node);
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        item.action(targetNodeAdf, extensionApi);
    };
    const getAriaLabel = ()=>{
        if (item.ariaLabel) return item.ariaLabel;
        if (typeof item.tooltip === 'string') return item.tooltip;
        if (item.label) return item.label;
        return '';
    };
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $7HjEm.default), {
        title: item.label,
        ariaLabel: getAriaLabel(),
        icon: item.icon ? /*#__PURE__*/ (0, $dc70d.jsx)($ee4901da190d9eb6$var$ExtensionIcon, {
            icon: item.icon,
            label: item.label || ''
        }) : undefined,
        onClick: onClick,
        tooltipContent: item.tooltip,
        tooltipStyle: item.tooltipStyle,
        disabled: item.disabled,
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled,
        children: item.label
    });
};
const $ee4901da190d9eb6$export$8bacfc8aacebb3c1 = (props)=>{
    const { node: node, editorView: editorView, extensionProvider: extensionProvider, separator: separator, applyChangeToContextPanel: applyChangeToContextPanel, extensionApi: extensionApi, scrollable: scrollable, setDisableScroll: setDisableScroll, dispatchCommand: dispatchCommand, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, alignDropdownWithToolbar: alignDropdownWithToolbar, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled } = props;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const [extensions, setExtensions] = (0, $bSJIT.useState)([]);
    (0, $bSJIT.useEffect)(()=>{
        getExtensions();
        async function getExtensions() {
            const provider = await extensionProvider;
            if (provider) setExtensions(await provider.getExtensions());
        }
    // leaving dependencies array empty so that this effect runs just once on component mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const nodeAdf = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useMemo(()=>(0, $5vR15.nodeToJSON)(node), [
        node
    ]);
    const extensionItems = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useMemo(()=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return (0, $kky6V.getContextualToolbarItemsFromModule)(extensions, nodeAdf, extensionApi);
    }, [
        extensions,
        nodeAdf,
        extensionApi
    ]);
    if (!extensionItems.length) return null;
    // ButtonGroup wraps each child with another layer
    // but count fragment as 1 child, so here we create the children manually.
    const children = [];
    if (separator && [
        'start',
        'both'
    ].includes(separator)) children.push(/*#__PURE__*/ (0, $dc70d.jsx)((0, $2Bpgx.default), {
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    }));
    const isNestedTable = (0, $bnbmo.isNestedTablesSupported)(editorView.state.schema) && (0, $aec79.isSelectionTableNestedInTable)(editorView.state);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    extensionItems.forEach((item, index)=>{
        // disable the referentiality and charts extensions for nested tables
        if (isNestedTable && [
            'referentiality:connections',
            'chart:insert-chart'
        ].includes(item.key)) item.disabled = true;
        if ('type' in item && item.type === 'dropdown') {
            const IconBefore = item.iconBefore;
            children.push(/*#__PURE__*/ (0, $dc70d.jsx)((0, $iXxVC.default), {
                title: item.title,
                icon: item.icon,
                iconBefore: IconBefore ? /*#__PURE__*/ (0, $dc70d.jsx)(IconBefore, {}) : undefined,
                dispatchCommand: dispatchCommand || (()=>{}),
                options: item.options,
                disabled: item.disabled,
                tooltip: item.tooltip,
                hideExpandIcon: item.hideExpandIcon,
                mountPoint: popupsMountPoint,
                boundariesElement: popupsBoundariesElement,
                scrollableElement: popupsScrollableElement,
                dropdownWidth: item.dropdownWidth,
                showSelected: item.showSelected,
                buttonTestId: item.testId,
                editorView: editorView,
                setDisableParentScroll: scrollable ? setDisableScroll : undefined,
                dropdownListId: (item === null || item === void 0 ? void 0 : item.id) && `${item.id}-dropdownList`,
                alignDropdownWithToolbar: alignDropdownWithToolbar,
                onToggle: item.onToggle,
                footer: item.footer,
                onMount: item.onMount,
                onClick: item.onClick,
                pulse: item.pulse,
                areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
            }, item.id));
        } else children.push(/*#__PURE__*/ (0, $dc70d.jsx)($ee4901da190d9eb6$var$ExtensionButton, {
            node: node,
            item: item,
            editorView: editorView,
            applyChangeToContextPanel: applyChangeToContextPanel,
            extensionApi: extensionApi,
            areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
        }));
        if (index < extensionItems.length - 1) children.push(/*#__PURE__*/ (0, $dc70d.jsx)((0, $2Bpgx.default), {
            areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
        }));
    });
    if (separator && [
        'end',
        'both'
    ].includes(separator)) children.push(/*#__PURE__*/ (0, $dc70d.jsx)((0, $2Bpgx.default), {
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    }));
    // eslint-disable-next-line react/no-children-prop
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $f1bHg.default), {
        children: children
    });
};

});

parcelRegister("gaSQI", function(module, exports) {
$parcel$export(module.exports, "Input", () => $a3ea5ed8b4da0287$export$f5b8910cec6cf069);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $anWec = parcelRequire("anWec");
const $a3ea5ed8b4da0287$export$f5b8910cec6cf069 = (props)=>{
    const { defaultValue: defaultValue, onBlur: onBlur, onSubmit: onSubmit, placeholder: placeholder } = props;
    const [text, setText] = (0, $bSJIT.useState)(defaultValue || '');
    const handleChange = (e)=>{
        setText(e.target.value);
    };
    const handleSubmit = (e)=>{
        e.preventDefault();
        onSubmit && onSubmit(text);
    };
    const handleBlur = (e)=>{
        e.preventDefault();
        onBlur && onBlur(text);
    };
    return /*#__PURE__*/ (0, $9dQre.jsx)("form", {
        onSubmit: handleSubmit
    }, /*#__PURE__*/ (0, $9dQre.jsx)("input", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        css: (0, $anWec.panelTextInput),
        value: text,
        onChange: handleChange,
        placeholder: placeholder,
        onBlur: handleBlur
    }));
};

});

parcelRegister("1UG5w", function(module, exports) {
$parcel$export(module.exports, "ScrollButton", () => $deab7ef080bb8a36$export$93d01adc5582c83e);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $bAB3U = parcelRequire("bAB3U");

var $9wZWu = parcelRequire("9wZWu");

var $4TRbS = parcelRequire("4TRbS");

var $74yRN = parcelRequire("74yRN");

var $dpxPQ = parcelRequire("dpxPQ");

var $l9Ysx = parcelRequire("l9Ysx");

var $gUpf2 = parcelRequire("gUpf2");

var $9BVpB = parcelRequire("9BVpB");
const $deab7ef080bb8a36$var$rightSideStyles = (0, $9BVpB.xcss)({
    borderLeft: `solid ${"var(--ds-border, #0B120E24)"} 1px`,
    right: 'space.0',
    borderTopRightRadius: 'radius.small',
    borderBottomRightRadius: 'radius.small'
});
const $deab7ef080bb8a36$var$leftSideStyles = (0, $9BVpB.xcss)({
    borderRight: `solid ${"var(--ds-border, #0B120E24)"} 1px`,
    left: 'space.0',
    borderTopLeftRadius: 'radius.small',
    borderBottomLeftRadius: 'radius.small'
});
const $deab7ef080bb8a36$var$buttonCommonStyles = (0, $9BVpB.xcss)({
    backgroundColor: 'elevation.surface.overlay',
    zIndex: '1',
    position: 'absolute'
});
const $deab7ef080bb8a36$export$93d01adc5582c83e = ({ intl: intl, scrollContainerRef: scrollContainerRef, node: node, disabled: disabled, side: side })=>{
    const [needScroll, setNeedScroll] = (0, $bSJIT.useState)(false);
    const [canScrollToSide, setCanScrollToSide] = (0, $bSJIT.useState)(true);
    const setCanScrollDebounced = (0, $9wZWu.default)(()=>{
        // Refs are null before mounting and after unmount
        if (!scrollContainerRef.current) return;
        const { scrollLeft: scrollLeft, scrollWidth: scrollWidth, offsetWidth: offsetWidth } = scrollContainerRef.current;
        setCanScrollToSide(// -1 to account for pixel rounding error
        side === 'left' ? scrollLeft > 0 : scrollLeft < scrollWidth - offsetWidth - 1);
    });
    const onScroll = ()=>{
        setCanScrollDebounced();
    };
    const onClick = ()=>{
        var _scrollContainerRef$c, _scrollContainerRef$c2, _scrollContainerRef$c3;
        const { width: scrollContainerWidth = 0 } = ((_scrollContainerRef$c = scrollContainerRef.current) === null || _scrollContainerRef$c === void 0 ? void 0 : _scrollContainerRef$c.getBoundingClientRect()) || {};
        const scrollLeft = ((_scrollContainerRef$c2 = scrollContainerRef.current) === null || _scrollContainerRef$c2 === void 0 ? void 0 : _scrollContainerRef$c2.scrollLeft) || 0;
        const scrollTo = side === 'left' ? scrollLeft - scrollContainerWidth : scrollLeft + scrollContainerWidth;
        (_scrollContainerRef$c3 = scrollContainerRef.current) === null || _scrollContainerRef$c3 === void 0 || _scrollContainerRef$c3.scrollTo({
            top: 0,
            left: scrollTo,
            behavior: 'smooth'
        });
    };
    const resizeObserver = new ResizeObserver((_t)=>{
        var _scrollContainerRef$c4, _scrollContainerRef$c5;
        const widthNeededToShowAllItems = ((_scrollContainerRef$c4 = scrollContainerRef.current) === null || _scrollContainerRef$c4 === void 0 ? void 0 : _scrollContainerRef$c4.scrollWidth) || 0;
        const parentNode = (_scrollContainerRef$c5 = scrollContainerRef.current) === null || _scrollContainerRef$c5 === void 0 ? void 0 : _scrollContainerRef$c5.parentNode;
        let availableSpace = -1;
        if (parentNode instanceof HTMLElement) availableSpace = parentNode.offsetWidth;
        if (availableSpace === -1) return;
        if (availableSpace >= widthNeededToShowAllItems) setNeedScroll(false);
        else {
            setNeedScroll(true);
            onScroll();
        }
    });
    (0, $bSJIT.useEffect)(()=>{
        onScroll();
        const scrollContainerRefCurrent = scrollContainerRef.current;
        let unbind;
        if (scrollContainerRefCurrent) {
            // Adding/removing scroll button depending on scroll position
            unbind = (0, $bAB3U.bind)(scrollContainerRefCurrent, {
                type: 'scroll',
                listener: onScroll
            });
            // watch for toolbar resize and show/hide scroll buttons if needed
            resizeObserver.observe(scrollContainerRefCurrent);
        }
        return ()=>{
            if (scrollContainerRefCurrent) {
                var _unbind;
                (_unbind = unbind) === null || _unbind === void 0 || _unbind();
                resizeObserver.unobserve(scrollContainerRefCurrent);
            }
            setCanScrollDebounced.cancel();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $bSJIT.useEffect)(()=>{
        const scrollContainerRefCurrent = scrollContainerRef.current;
        if (scrollContainerRefCurrent) {
            var _scrollContainerRefCu;
            // reset scroll position when switching from one node with toolbar to another
            // scroll to made optional as it may not be rendered in testing env
            (_scrollContainerRefCu = scrollContainerRefCurrent.scrollTo) === null || _scrollContainerRefCu === void 0 || _scrollContainerRefCu.call(scrollContainerRefCurrent, {
                left: 0
            });
        }
    }, [
        node.type,
        scrollContainerRef
    ]);
    const Icon = side === 'left' ? (0, (/*@__PURE__*/$parcel$interopDefault($dpxPQ))) : (0, (/*@__PURE__*/$parcel$interopDefault($l9Ysx)));
    return needScroll && (side === 'left' && canScrollToSide || side === 'right' && canScrollToSide) && /*#__PURE__*/ (0, $dc70d.jsx)((0, $gUpf2.Box), {
        padding: "space.050",
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        xcss: [
            side === 'left' ? $deab7ef080bb8a36$var$leftSideStyles : $deab7ef080bb8a36$var$rightSideStyles,
            $deab7ef080bb8a36$var$buttonCommonStyles
        ],
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $4TRbS.default), {
            appearance: "subtle",
            label: intl.formatMessage(side === 'left' ? (0, $74yRN.default).floatingToolbarScrollLeft : (0, $74yRN.default).floatingToolbarScrollRight),
            onClick: onClick,
            isDisabled: disabled,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            icon: (iconProps)=>/*#__PURE__*/ (0, $dc70d.jsx)(Icon, {
                    label: iconProps.label,
                    size: "small"
                }),
            isTooltipDisabled: false,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            tooltip: {
                position: 'top'
            }
        })
    });
};

});

parcelRegister("d37J1", function(module, exports) {
$parcel$export(module.exports, "ScrollButtons", () => $790523a3839306be$export$154bc6e95efc5a0d);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $9wZWu = parcelRequire("9wZWu");

var $74yRN = parcelRequire("74yRN");

var $7HjEm = parcelRequire("7HjEm");

var $dpxPQ = parcelRequire("dpxPQ");

var $l9Ysx = parcelRequire("l9Ysx");
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $790523a3839306be$var$toolbarScrollButtons = /*#__PURE__*/ (0, $9dQre.css)({
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridGap: "var(--ds-space-050, 4px)",
    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-100, 8px)"}`,
    borderLeft: `solid ${"var(--ds-border, #0B120E24)"} ${"var(--ds-border-width, 1px)"}`,
    flexShrink: 0,
    alignItems: 'center'
});
const $790523a3839306be$var$LeftIcon = (0, (/*@__PURE__*/$parcel$interopDefault($dpxPQ)));
const $790523a3839306be$var$RightIcon = (0, (/*@__PURE__*/$parcel$interopDefault($l9Ysx)));
const $790523a3839306be$export$154bc6e95efc5a0d = ({ intl: intl, scrollContainerRef: scrollContainerRef, node: node, disabled: disabled, areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled })=>{
    const buttonsContainerRef = (0, $bSJIT.useRef)(null);
    const [needScroll, setNeedScroll] = (0, $bSJIT.useState)(false);
    const [canScrollLeft, setCanScrollLeft] = (0, $bSJIT.useState)(true);
    const [canScrollRight, setCanScrollRight] = (0, $bSJIT.useState)(true);
    const setCanScrollDebounced = (0, $9wZWu.default)(()=>{
        // Refs are null before mounting and after unmount
        if (!scrollContainerRef.current) return;
        const { scrollLeft: scrollLeft, scrollWidth: scrollWidth, offsetWidth: offsetWidth } = scrollContainerRef.current;
        setCanScrollLeft(scrollLeft > 0);
        setCanScrollRight(scrollLeft + offsetWidth < scrollWidth - 1); // -1 to account for half pixel
    });
    const onScroll = ()=>setCanScrollDebounced();
    const scrollLeft = ()=>{
        var _scrollContainerRef$c, _scrollContainerRef$c2, _scrollContainerRef$c3;
        const { width: scrollContainerWidth = 0 } = ((_scrollContainerRef$c = scrollContainerRef.current) === null || _scrollContainerRef$c === void 0 ? void 0 : _scrollContainerRef$c.getBoundingClientRect()) || {};
        const scrollLeft = ((_scrollContainerRef$c2 = scrollContainerRef.current) === null || _scrollContainerRef$c2 === void 0 ? void 0 : _scrollContainerRef$c2.scrollLeft) || 0;
        // scroll to current position - scroll container width
        const scrollTo = scrollLeft - scrollContainerWidth;
        (_scrollContainerRef$c3 = scrollContainerRef.current) === null || _scrollContainerRef$c3 === void 0 || _scrollContainerRef$c3.scrollTo({
            top: 0,
            left: scrollTo,
            behavior: 'smooth'
        });
    };
    const scrollRight = ()=>{
        var _scrollContainerRef$c4, _scrollContainerRef$c5, _scrollContainerRef$c6;
        const { width: scrollContainerWidth = 0 } = ((_scrollContainerRef$c4 = scrollContainerRef.current) === null || _scrollContainerRef$c4 === void 0 ? void 0 : _scrollContainerRef$c4.getBoundingClientRect()) || {};
        const scrollLeft = ((_scrollContainerRef$c5 = scrollContainerRef.current) === null || _scrollContainerRef$c5 === void 0 ? void 0 : _scrollContainerRef$c5.scrollLeft) || 0;
        // scroll to current position + scroll container width
        const scrollTo = scrollLeft + scrollContainerWidth;
        (_scrollContainerRef$c6 = scrollContainerRef.current) === null || _scrollContainerRef$c6 === void 0 || _scrollContainerRef$c6.scrollTo({
            top: 0,
            left: scrollTo,
            behavior: 'smooth'
        });
    };
    const resizeObserver = new ResizeObserver((t)=>{
        var _scrollContainerRef$c7, _scrollContainerRef$c8;
        const widthNeededToShowAllItems = ((_scrollContainerRef$c7 = scrollContainerRef.current) === null || _scrollContainerRef$c7 === void 0 ? void 0 : _scrollContainerRef$c7.scrollWidth) || 0;
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        const availableSpace = (_scrollContainerRef$c8 = scrollContainerRef.current) === null || _scrollContainerRef$c8 === void 0 || (_scrollContainerRef$c8 = _scrollContainerRef$c8.parentNode) === null || _scrollContainerRef$c8 === void 0 ? void 0 : _scrollContainerRef$c8.offsetWidth;
        if (availableSpace >= widthNeededToShowAllItems) setNeedScroll(false);
        else {
            setNeedScroll(true);
            onScroll();
        }
    });
    (0, $bSJIT.useEffect)(()=>{
        onScroll();
        const scrollContainerRefCurrent = scrollContainerRef.current;
        if (scrollContainerRefCurrent) {
            // enable/disable scroll buttons depending on scroll position
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            scrollContainerRefCurrent.addEventListener('scroll', onScroll);
            // watch for toolbar resize and show/hide scroll buttons if needed
            resizeObserver.observe(scrollContainerRefCurrent);
        }
        return ()=>{
            if (scrollContainerRefCurrent) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                scrollContainerRefCurrent.removeEventListener('scroll', onScroll);
                resizeObserver.unobserve(scrollContainerRefCurrent);
            }
            setCanScrollDebounced.cancel();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $bSJIT.useEffect)(()=>{
        const scrollContainerRefCurrent = scrollContainerRef.current;
        if (scrollContainerRefCurrent) {
            var _scrollContainerRefCu;
            // reset scroll position when switching from one node with toolbar to another
            // scroll to made optional as it may not be rendered in testing env
            (_scrollContainerRefCu = scrollContainerRefCurrent.scrollTo) === null || _scrollContainerRefCu === void 0 || _scrollContainerRefCu.call(scrollContainerRefCurrent, {
                left: 0
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        node.type
    ]);
    return needScroll ? /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        ref: buttonsContainerRef,
        css: $790523a3839306be$var$toolbarScrollButtons,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: "scroll-buttons"
    }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $7HjEm.default), {
        title: intl.formatMessage((0, $74yRN.default).floatingToolbarScrollLeft),
        icon: /*#__PURE__*/ (0, $9dQre.jsx)($790523a3839306be$var$LeftIcon, {
            label: intl.formatMessage((0, $74yRN.default).floatingToolbarScrollLeft),
            size: "small"
        }),
        onClick: scrollLeft,
        disabled: !canScrollLeft || disabled,
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    }), /*#__PURE__*/ (0, $9dQre.jsx)((0, $7HjEm.default), {
        title: intl.formatMessage((0, $74yRN.default).floatingToolbarScrollRight),
        icon: /*#__PURE__*/ (0, $9dQre.jsx)($790523a3839306be$var$RightIcon, {
            label: intl.formatMessage((0, $74yRN.default).floatingToolbarScrollRight),
            size: "small"
        }),
        onClick: scrollRight,
        disabled: !canScrollRight || disabled,
        areAnyNewToolbarFlagsEnabled: areAnyNewToolbarFlagsEnabled
    })) : null;
};

});

parcelRegister("gM1Ws", function(module, exports) {
$parcel$export(module.exports, "default", () => $a42f42ba376f97ea$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $eOzrv = parcelRequire("eOzrv");
function $a42f42ba376f97ea$export$2e2bcd8739ae039(props) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const selectRef = (0, $bSJIT.useRef)(null);
    const { width: width = 200 } = props;
    const style = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useMemo(()=>({
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            container: (base)=>({
                    ...base,
                    width: width
                }),
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            menuPortal: (base)=>{
                var _selectRef$current, _selectRef$current2;
                // ED:16095: We add two possible getter paths for safely reaching into the underlying
                // react-select element. We first try a getter that conforms with react-select v5 APIs,
                // Failing that, we try a getter consistent with react-select v4 APIs. (We
                // handle both as consumers may control the time of the actual dependency version
                // cutover).
                const controlWrapper = (selectRef === null || selectRef === void 0 || (_selectRef$current = selectRef.current) === null || _selectRef$current === void 0 || (_selectRef$current = _selectRef$current.select) === null || _selectRef$current === void 0 || (_selectRef$current = _selectRef$current.controlRef) === null || _selectRef$current === void 0 ? void 0 : _selectRef$current.parentNode) || (selectRef === null || selectRef === void 0 || (_selectRef$current2 = selectRef.current) === null || _selectRef$current2 === void 0 || (_selectRef$current2 = _selectRef$current2.select) === null || _selectRef$current2 === void 0 || (_selectRef$current2 = _selectRef$current2.select) === null || _selectRef$current2 === void 0 || (_selectRef$current2 = _selectRef$current2.controlRef) === null || _selectRef$current2 === void 0 ? void 0 : _selectRef$current2.parentNode);
                const menuPortalStyles = controlWrapper && props.setDisableParentScroll ? {
                    // since the portal is now outside, we need to position it as before
                    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                    top: controlWrapper.offsetTop,
                    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage/preview
                    left: controlWrapper.offsetLeft,
                    height: controlWrapper.offsetHeight,
                    width: width
                } : {};
                return {
                    ...base,
                    ...menuPortalStyles
                };
            }
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        width
    ]);
    const onMenuOpen = ()=>{
        if (props.setDisableParentScroll) props.setDisableParentScroll(true);
    };
    const onMenuClose = ()=>{
        if (props.setDisableParentScroll) props.setDisableParentScroll(false);
    };
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $eOzrv.default), {
        ref: selectRef,
        options: props.options,
        value: props.defaultValue,
        onChange: props.onChange,
        placeholder: props.placeholder,
        spacing: "compact",
        menuPlacement: "auto",
        filterOption: props.filterOption,
        styles: style,
        menuPortalTarget: props.mountPoint,
        onMenuOpen: onMenuOpen,
        onMenuClose: onMenuClose,
        label: props.ariaLabel,
        classNamePrefix: props.classNamePrefix
    });
}

});


parcelRegister("9Fqvh", function(module, exports) {
$parcel$export(module.exports, "consolidateOverflowDropdownItems", () => $eb0d214fe105b610$export$2f5751d7b477f660);
const $eb0d214fe105b610$export$2f5751d7b477f660 = (overflowDropdowns)=>{
    if (overflowDropdowns.length <= 1) return overflowDropdowns[0];
    const combinedItems = overflowDropdowns.reduce((acc, item)=>{
        if (item.options) acc.push(...item.options);
        return acc;
    }, []);
    // To filter out items that have a rank property, sort them by rank in descending order (highest rank first)
    const rankedItems = combinedItems.filter((item)=>'rank' in item && typeof item.rank === 'number').sort((a, b)=>(b.rank || 0) - (a.rank || 0));
    const unrankedItems = combinedItems.filter((item)=>!('rank' in item && typeof item.rank === 'number'));
    const sortedItems = [
        ...rankedItems,
        ...unrankedItems
    ];
    const largestDropdownWidth = overflowDropdowns.reduce((acc, item)=>{
        if (item.dropdownWidth && item.dropdownWidth > acc) return item.dropdownWidth;
        return acc;
    }, 0);
    return {
        type: 'overflow-dropdown',
        dropdownWidth: largestDropdownWidth,
        options: sortedItems
    };
};

});


parcelRegister("lMapo", function(module, exports) {
$parcel$export(module.exports, "focusPlugin", () => $17ab5fe03c809248$export$78540d08bd386fba);

var $jwXho = parcelRequire("jwXho");
const $17ab5fe03c809248$export$78540d08bd386fba = ({ api: _api })=>{
    return {
        name: 'focus',
        getSharedState (editorState) {
            var _key$getState;
            if (!editorState) return {
                hasFocus: false
            };
            return {
                hasFocus: Boolean((_key$getState = (0, $jwXho.key).getState(editorState)) === null || _key$getState === void 0 ? void 0 : _key$getState.hasFocus)
            };
        },
        pmPlugins () {
            return [
                {
                    name: 'focusHandlerPlugin',
                    plugin: (0, $jwXho.createPlugin)
                }
            ];
        }
    };
};

});
parcelRegister("jwXho", function(module, exports) {
$parcel$export(module.exports, "key", () => $f5b080f79e8f9db9$export$df61b30b684217c0);
$parcel$export(module.exports, "createPlugin", () => $f5b080f79e8f9db9$export$ae829ec7b2625219);

var $f7Kk4 = parcelRequire("f7Kk4");

var $cw0wu = parcelRequire("cw0wu");
const $f5b080f79e8f9db9$export$df61b30b684217c0 = new (0, $cw0wu.PluginKey)('focusPluginHandler');
const $f5b080f79e8f9db9$export$ae829ec7b2625219 = ()=>new (0, $f7Kk4.SafePlugin)({
        key: $f5b080f79e8f9db9$export$df61b30b684217c0,
        state: {
            init () {
                return {
                    hasFocus: false
                };
            },
            apply (tr, oldPluginState) {
                const meta = tr.getMeta($f5b080f79e8f9db9$export$df61b30b684217c0);
                if (typeof meta === 'boolean') {
                    if (meta !== oldPluginState.hasFocus) return {
                        hasFocus: meta
                    };
                }
                return oldPluginState;
            }
        },
        props: {
            handleDOMEvents: {
                focus: (view)=>{
                    const focusState = $f5b080f79e8f9db9$export$df61b30b684217c0.getState(view.state);
                    if (!(focusState !== null && focusState !== void 0 && focusState.hasFocus)) view.dispatch(view.state.tr.setMeta($f5b080f79e8f9db9$export$df61b30b684217c0, true));
                    return false;
                },
                blur: (view)=>{
                    const focusState = $f5b080f79e8f9db9$export$df61b30b684217c0.getState(view.state);
                    if (focusState !== null && focusState !== void 0 && focusState.hasFocus) view.dispatch(view.state.tr.setMeta($f5b080f79e8f9db9$export$df61b30b684217c0, false));
                    return false;
                }
            }
        }
    });

});


parcelRegister("3OwOt", function(module, exports) {
$parcel$export(module.exports, "default", () => $18a4b4af1ea45a0d$export$2e2bcd8739ae039);

var $f7Kk4 = parcelRequire("f7Kk4");

var $56AB9 = parcelRequire("56AB9");

var $3TnFr = parcelRequire("3TnFr");

var $3zzvD = parcelRequire("3zzvD");

var $jVAei = parcelRequire("jVAei");

var $4CRxg = parcelRequire("4CRxg");

var $kK0Am = parcelRequire("kK0Am");

var $3FAjR = parcelRequire("3FAjR");

var $dGYwF = parcelRequire("dGYwF");
const $18a4b4af1ea45a0d$var$getInitialState = ()=>({
        canUndo: false,
        canRedo: false
    });
const { createPluginState: $18a4b4af1ea45a0d$var$createPluginState, getPluginState: $18a4b4af1ea45a0d$var$getPluginState } = (0, $3TnFr.pluginFactory)((0, $dGYwF.historyPluginKey), (0, $kK0Am.default));
/**
 * Expose prosemirror-history's `undo` as an `EditorCommand`. `undo(state, dispatch)`
 * builds its own transaction, so capture that transaction and return it in place of the
 * one passed in. Nothing is re-implemented: the returned transaction is exactly what
 * pressing Cmd+Z would dispatch, and callers may add metadata to it before it is
 * dispatched by `api.core.actions.execute`.
 */ const $18a4b4af1ea45a0d$var$undoCommand = (editorViewRef)=>({ tr: tr })=>{
        var _editorViewRef$curren;
        const state = (_editorViewRef$curren = editorViewRef.current) === null || _editorViewRef$curren === void 0 ? void 0 : _editorViewRef$curren.state;
        // The caller's `tr` is discarded, so refuse if it already carries changes or is stale.
        if (!state || tr.steps.length > 0 || tr.before !== state.doc) return null;
        let undoTr = null;
        (0, $jVAei.undo)(state, (built)=>{
            undoTr = built;
        });
        return undoTr;
    };
const $18a4b4af1ea45a0d$var$createPlugin = (dispatch, editorViewRef)=>new (0, $f7Kk4.SafePlugin)({
        state: $18a4b4af1ea45a0d$var$createPluginState(dispatch, $18a4b4af1ea45a0d$var$getInitialState),
        key: (0, $dGYwF.historyPluginKey),
        view: (editorView)=>{
            editorViewRef.current = editorView;
            return {
                destroy: ()=>{
                    if (editorViewRef.current === editorView) editorViewRef.current = undefined;
                }
            };
        },
        appendTransaction: (transactions, oldState, newState)=>{
            if (transactions.find((tr)=>tr.docChanged && tr.getMeta('addToHistory') !== false || tr.getMeta('endHistorySlice') || // Capture requires xstate in the AI plugin; this shared adapter only refreshes history.
                tr.getMeta((0, $56AB9.pmHistoryPluginKey)) && (0, $3zzvD.UNSAFE_expValNoExposure)('platform_editor_ai_review_moment', 'isEnabled', false))) {
                const pmHistoryPluginState = (0, $3FAjR.getPmHistoryPluginState)(newState);
                if (!pmHistoryPluginState) return;
                const canUndo = pmHistoryPluginState.done.eventCount > 0;
                const canRedo = pmHistoryPluginState.undone.eventCount > 0;
                const { canUndo: prevCanUndo, canRedo: prevCanRedo } = $18a4b4af1ea45a0d$var$getPluginState(newState);
                if (canUndo !== prevCanUndo || canRedo !== prevCanRedo) {
                    const action = {
                        type: (0, $4CRxg.HistoryActionTypes).UPDATE,
                        canUndo: canUndo,
                        canRedo: canRedo
                    };
                    return newState.tr.setMeta((0, $dGYwF.historyPluginKey), action);
                }
            }
        }
    });
const $18a4b4af1ea45a0d$var$historyPlugin = ({ api: api })=>{
    let currentId = null;
    const editorViewRef = {
        current: undefined
    };
    return {
        name: 'history',
        pmPlugins () {
            return [
                {
                    name: 'history',
                    plugin: ({ dispatch: dispatch })=>$18a4b4af1ea45a0d$var$createPlugin(dispatch, editorViewRef)
                }
            ];
        },
        getSharedState: (editorState)=>{
            if (!editorState) return undefined;
            const historyPluginState = (0, $dGYwF.historyPluginKey).getState(editorState);
            if (!historyPluginState) return undefined;
            const { done: done, undone: undone } = (0, $3FAjR.getPmHistoryPluginState)(editorState) ?? {};
            return {
                canUndo: historyPluginState.canUndo,
                canRedo: historyPluginState.canRedo,
                done: {
                    eventCount: (done === null || done === void 0 ? void 0 : done.eventCount) ?? 0
                },
                undone: {
                    eventCount: (undone === null || undone === void 0 ? void 0 : undone.eventCount) ?? 0
                }
            };
        },
        commands: {
            undo: $18a4b4af1ea45a0d$var$undoCommand(editorViewRef),
            updatePluginState: ({ tr: tr })=>{
                const { done: done, undone: undone } = (api === null || api === void 0 ? void 0 : api.history.sharedState.currentState()) ?? {};
                if (done === undefined || undone === undefined) return tr;
                const canUndo = done.eventCount > 0;
                const canRedo = undone.eventCount > 0;
                const action = {
                    type: (0, $4CRxg.HistoryActionTypes).UPDATE,
                    canUndo: canUndo,
                    canRedo: canRedo
                };
                return tr.setMeta((0, $dGYwF.historyPluginKey), action);
            },
            startHistorySlice: (id)=>({ tr: tr })=>{
                    if (currentId) return null;
                    currentId = id;
                    return tr.setMeta('startHistorySlice', true);
                },
            endHistorySlice: (id)=>({ tr: tr })=>{
                    if (currentId !== id) return null;
                    currentId = null;
                    return tr.setMeta('endHistorySlice', true);
                }
        }
    };
};
var $18a4b4af1ea45a0d$export$2e2bcd8739ae039 = $18a4b4af1ea45a0d$var$historyPlugin;

});
parcelRegister("4CRxg", function(module, exports) {
$parcel$export(module.exports, "HistoryActionTypes", () => $88d4472ccab999e6$export$324bf1d9598f1f30);
var $88d4472ccab999e6$export$324bf1d9598f1f30 = /*#__PURE__*/ function(HistoryActionTypes) {
    HistoryActionTypes["UPDATE"] = "UPDATE";
    return HistoryActionTypes;
}({});

});

parcelRegister("kK0Am", function(module, exports) {
$parcel$export(module.exports, "default", () => $467c4bb4d0479731$export$2e2bcd8739ae039);

var $4CRxg = parcelRequire("4CRxg");
const $467c4bb4d0479731$var$reducer = (state, action)=>{
    switch(action.type){
        case (0, $4CRxg.HistoryActionTypes).UPDATE:
            return {
                canUndo: action.canUndo,
                canRedo: action.canRedo
            };
    }
    return state;
};
var $467c4bb4d0479731$export$2e2bcd8739ae039 = $467c4bb4d0479731$var$reducer;

});

parcelRegister("3FAjR", function(module, exports) {
$parcel$export(module.exports, "getPmHistoryPluginState", () => $0ada43897802f88e$export$6bcebd7b5d7b9325);

var $56AB9 = parcelRequire("56AB9");
// Internal prosemirror history plugin does not export its plugin key.
// Previously we searched through all the plugins to find the history plugin
// but it's faster to look up the plugin directly via `getState`.
const $0ada43897802f88e$var$fakePluginKey = {
    key: (0, $56AB9.pmHistoryPluginKey),
    getState: (state)=>{
        // The plugin key is used to index state
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return state[0, $56AB9.pmHistoryPluginKey];
    },
    get (state) {
        return state.plugins.find(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (plugin)=>plugin.key === (0, $56AB9.pmHistoryPluginKey));
    }
};
const $0ada43897802f88e$export$6bcebd7b5d7b9325 = (state)=>{
    return $0ada43897802f88e$var$fakePluginKey.getState(state);
};

});

parcelRegister("dGYwF", function(module, exports) {
$parcel$export(module.exports, "historyPluginKey", () => $d77c261ea51ac6e7$export$8869884044241c3c);

var $cw0wu = parcelRequire("cw0wu");
const $d77c261ea51ac6e7$export$8869884044241c3c = new (0, $cw0wu.PluginKey)('historyPlugin');

});


parcelRegister("21bLu", function(module, exports) {
$parcel$export(module.exports, "hyperlinkPlugin", () => $3d0a8a2e7bf12276$export$8143923e8601d272);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $12hT9 = parcelRequire("12hT9");

var $g6Qq4 = parcelRequire("g6Qq4");

var $5BUNL = parcelRequire("5BUNL");

var $cv8id = parcelRequire("cv8id");

var $7Zehw = parcelRequire("7Zehw");

var $cW1gB = parcelRequire("cW1gB");

var $iPR6g = parcelRequire("iPR6g");

var $cgQ5m = parcelRequire("cgQ5m");

var $gRfjb = parcelRequire("gRfjb");

var $3y2s4 = parcelRequire("3y2s4");

var $797yE = parcelRequire("797yE");

var $5N1Y4 = parcelRequire("5N1Y4");

var $c8lUQ = parcelRequire("c8lUQ");

var $8hkNI = parcelRequire("8hkNI");

var $dqC4c = parcelRequire("dqC4c");

var $d5xI9 = parcelRequire("d5xI9");

var $a1fIR = parcelRequire("a1fIR");

var $jltJY = parcelRequire("jltJY");

var $5nCvs = parcelRequire("5nCvs");

var $6aoNe = parcelRequire("6aoNe");

var $aQtYb = parcelRequire("aQtYb");
const $3d0a8a2e7bf12276$var$getPosFromActiveLinkMark = (state)=>{
    if (state === undefined) return undefined;
    switch(state.type){
        case 'EDIT':
        case 'EDIT_INSERTED':
            return state.pos;
        case 'INSERT':
            return undefined;
    }
};
const $3d0a8a2e7bf12276$var$selectionToolbarLinkButtonTestId = 'ak-editor-selection-toolbar-link-button';
const $3d0a8a2e7bf12276$export$8143923e8601d272 = ({ config: options = {}, api: api })=>{
    let primaryToolbarComponent;
    const isToolbarAIFCEnabled = Boolean(api === null || api === void 0 ? void 0 : api.toolbar);
    const isRegisteredSlashCommandEnabled = (0, $3y2s4.isExperimentEnabled)('platform_editor_slash_command');
    if (isRegisteredSlashCommandEnabled) {
        var _api$uiControlRegistr;
        api === null || api === void 0 || (_api$uiControlRegistr = api.uiControlRegistry) === null || _api$uiControlRegistr === void 0 || _api$uiControlRegistr.actions.register((0, $5nCvs.getHyperlinkQuickInsertComponents)({
            api: api
        }));
    }
    if (isToolbarAIFCEnabled) {
        var _api$toolbar;
        api === null || api === void 0 || (_api$toolbar = api.toolbar) === null || _api$toolbar === void 0 || _api$toolbar.actions.registerComponents((0, $6aoNe.getToolbarComponents)(api));
    }
    return {
        name: 'hyperlink',
        marks () {
            return [
                {
                    name: 'link',
                    mark: (0, $12hT9.link)
                }
            ];
        },
        commands: {
            showLinkToolbar: (inputMethod = (0, $g6Qq4.INPUT_METHOD).TOOLBAR)=>{
                var _api$analytics;
                return (0, $c8lUQ.showLinkToolbar)(inputMethod, api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions);
            },
            updateLink: (href, text)=>{
                var _api$hyperlink;
                const linkMark = api === null || api === void 0 || (_api$hyperlink = api.hyperlink) === null || _api$hyperlink === void 0 || (_api$hyperlink = _api$hyperlink.sharedState.currentState()) === null || _api$hyperlink === void 0 ? void 0 : _api$hyperlink.activeLinkMark;
                const pos = $3d0a8a2e7bf12276$var$getPosFromActiveLinkMark(linkMark);
                if (pos === undefined) return ()=>null;
                return (0, $c8lUQ.updateLinkEditorCommand)(href, text, pos);
            },
            removeLink: ()=>{
                var _api$hyperlink2, _api$analytics2;
                const linkMark = api === null || api === void 0 || (_api$hyperlink2 = api.hyperlink) === null || _api$hyperlink2 === void 0 || (_api$hyperlink2 = _api$hyperlink2.sharedState.currentState()) === null || _api$hyperlink2 === void 0 ? void 0 : _api$hyperlink2.activeLinkMark;
                const pos = $3d0a8a2e7bf12276$var$getPosFromActiveLinkMark(linkMark);
                if (pos === undefined) return ()=>null;
                return (0, $c8lUQ.removeLinkEditorCommand)(pos, api === null || api === void 0 || (_api$analytics2 = api.analytics) === null || _api$analytics2 === void 0 ? void 0 : _api$analytics2.actions);
            }
        },
        actions: {
            hideLinkToolbar: (0, $c8lUQ.hideLinkToolbarSetMeta),
            insertLink: (inputMethod, from, to, href, title, displayText, cardsAvailable = false, sourceEvent, appearance)=>{
                var _api$card, _api$analytics3;
                return (0, $c8lUQ.insertLinkWithAnalytics)(inputMethod, from, to, href, api === null || api === void 0 || (_api$card = api.card) === null || _api$card === void 0 ? void 0 : _api$card.actions, api === null || api === void 0 || (_api$analytics3 = api.analytics) === null || _api$analytics3 === void 0 ? void 0 : _api$analytics3.actions, title, displayText, cardsAvailable, sourceEvent, appearance);
            },
            updateLink: (0, $c8lUQ.updateLink)
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            return (0, $a1fIR.stateKey).getState(editorState);
        },
        pmPlugins () {
            return [
                {
                    name: 'hyperlink',
                    plugin: ({ dispatch: dispatch, getIntl: getIntl })=>(0, $a1fIR.plugin)(dispatch, getIntl(), options === null || options === void 0 ? void 0 : options.editorAppearance, api, options === null || options === void 0 ? void 0 : options.onClickCallback, // @ts-ignore Temporary solution to check for Live Page editor.
                        options.__livePage)
                },
                {
                    name: 'fakeCursorToolbarPlugin',
                    plugin: ()=>(0, $8hkNI.default)
                },
                {
                    name: 'hyperlinkInputRule',
                    plugin: ({ schema: schema })=>{
                        var _api$analytics4;
                        return (0, $dqC4c.createInputRulePlugin)(schema, api === null || api === void 0 || (_api$analytics4 = api.analytics) === null || _api$analytics4 === void 0 ? void 0 : _api$analytics4.actions, options.autoLinkOnBlur);
                    }
                },
                {
                    name: 'hyperlinkKeymap',
                    plugin: ()=>{
                        var _api$analytics5;
                        return (0, $d5xI9.createKeymapPlugin)(api === null || api === void 0 || (_api$analytics5 = api.analytics) === null || _api$analytics5 === void 0 ? void 0 : _api$analytics5.actions);
                    }
                },
                {
                    name: 'hyperlinkToolbarButtons',
                    plugin: ()=>{
                        var _api$card2;
                        const hasCard = !!(api !== null && api !== void 0 && (_api$card2 = api.card) !== null && _api$card2 !== void 0 && _api$card2.actions);
                        return (0, $jltJY.toolbarButtonsPlugin)(hasCard ? {
                            skipAnalytics: true
                        } : undefined);
                    }
                }
            ];
        },
        pluginsOptions: {
            ...isRegisteredSlashCommandEnabled ? {} : {
                quickInsert: ({ formatMessage: formatMessage })=>[
                        {
                            id: 'hyperlink',
                            title: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).link),
                            description: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).linkDescription),
                            keywords: [
                                'hyperlink',
                                'url'
                            ],
                            priority: (0, $5N1Y4.expValEquals)('confluence_quick_insert_embeds', 'cohort', 'prioritizeLinkInQIM', 'control') ? -300 : 1200,
                            keyshortcut: (0, $cv8id.tooltip)((0, $cv8id.addLink)),
                            icon: ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $5BUNL.IconLink), {}),
                            action (insert, state) {
                                var _api$analytics6, _api$analytics6$attac;
                                const tr = insert(undefined);
                                tr.setMeta((0, $a1fIR.stateKey), {
                                    type: (0, $7Zehw.LinkAction).SHOW_INSERT_TOOLBAR,
                                    inputMethod: (0, $g6Qq4.INPUT_METHOD).QUICK_INSERT
                                });
                                const analyticsAttached = api === null || api === void 0 || (_api$analytics6 = api.analytics) === null || _api$analytics6 === void 0 || (_api$analytics6 = _api$analytics6.actions) === null || _api$analytics6 === void 0 || (_api$analytics6$attac = _api$analytics6.attachAnalyticsEvent) === null || _api$analytics6$attac === void 0 ? void 0 : _api$analytics6$attac.call(_api$analytics6, {
                                    action: (0, $g6Qq4.ACTION).INVOKED,
                                    actionSubject: (0, $g6Qq4.ACTION_SUBJECT).TYPEAHEAD,
                                    actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).TYPEAHEAD_LINK,
                                    attributes: {
                                        inputMethod: (0, $g6Qq4.INPUT_METHOD).QUICK_INSERT
                                    },
                                    eventType: (0, $g6Qq4.EVENT_TYPE).UI
                                })(tr);
                                return analyticsAttached !== false ? tr : false;
                            }
                        }
                    ]
            },
            floatingToolbar: (0, $aQtYb.getToolbarConfig)(options, api),
            ...!isToolbarAIFCEnabled && {
                selectionToolbar: (state, { formatMessage: formatMessage })=>{
                    var _api$userPreferences;
                    const toolbarDocking = api === null || api === void 0 || (_api$userPreferences = api.userPreferences) === null || _api$userPreferences === void 0 || (_api$userPreferences = _api$userPreferences.sharedState.currentState()) === null || _api$userPreferences === void 0 ? void 0 : _api$userPreferences.preferences.toolbarDockingPosition;
                    if (toolbarDocking === 'none' && (0, $797yE.editorExperiment)('platform_editor_controls', 'variant1', {
                        exposure: true
                    })) {
                        const toolbarButton = ()=>{
                            const { from: from, to: to } = state.selection;
                            const isEnabled = (0, $cgQ5m.canLinkBeCreatedInRange)(from, to)(state);
                            const title = formatMessage((0, $cW1gB.toolbarInsertBlockMessages).link);
                            return {
                                type: 'button',
                                disabled: !isEnabled,
                                testId: `${$3d0a8a2e7bf12276$var$selectionToolbarLinkButtonTestId}`,
                                icon: (0, (/*@__PURE__*/$parcel$interopDefault($gRfjb))),
                                title: title,
                                tooltipContent: (0, $cv8id.tooltip)((0, $cv8id.addLink), title),
                                showTitle: false,
                                onClick: (state, dispatch)=>{
                                    var _api$analytics7;
                                    return (0, $iPR6g.editorCommandToPMCommand)((0, $c8lUQ.showLinkToolbar)((0, $g6Qq4.INPUT_METHOD).FLOATING_TB, api === null || api === void 0 || (_api$analytics7 = api.analytics) === null || _api$analytics7 === void 0 ? void 0 : _api$analytics7.actions))(state, dispatch);
                                }
                            };
                        };
                        return {
                            isToolbarAbove: true,
                            items: [
                                toolbarButton()
                            ],
                            rank: 2
                        };
                    } else return undefined;
                }
            },
            ...!isToolbarAIFCEnabled && {
                primaryToolbarComponent: !(api !== null && api !== void 0 && api.primaryToolbar) && (0, $797yE.editorExperiment)('platform_editor_controls', 'variant1', {
                    exposure: true
                }) ? primaryToolbarComponent : undefined
            }
        }
    };
};

});
parcelRegister("7Zehw", function(module, exports) {
$parcel$export(module.exports, "LinkAction", () => $11c995c1017c876b$export$6dcc1033b74c9344);
var $11c995c1017c876b$export$6dcc1033b74c9344 = /*#__PURE__*/ function(LinkAction) {
    LinkAction["SHOW_INSERT_TOOLBAR"] = "SHOW_INSERT_TOOLBAR";
    LinkAction["HIDE_TOOLBAR"] = "HIDE_TOOLBAR";
    LinkAction["SELECTION_CHANGE"] = "SELECTION_CHANGE";
    LinkAction["INSERT_LINK_TOOLBAR"] = "INSERT";
    LinkAction["EDIT_INSERTED_TOOLBAR"] = "EDIT_INSERTED_TOOLBAR";
    LinkAction["SET_CONFIGURE_BUTTON_TARGET_POS"] = "SET_CONFIGURE_BUTTON_TARGET_POS";
    LinkAction["SET_CONFIGURE_DROPDOWN_OPEN"] = "SET_CONFIGURE_DROPDOWN_OPEN";
    return LinkAction;
}({});

});

parcelRegister("c8lUQ", function(module, exports) {
$parcel$export(module.exports, "updateLinkEditorCommand", () => $4ba901ede055e3ee$export$1f68f6e2d4509ef7);
$parcel$export(module.exports, "updateLink", () => $4ba901ede055e3ee$export$468bc07728835ac4);
$parcel$export(module.exports, "insertLinkWithAnalytics", () => $4ba901ede055e3ee$export$61f4de3ecc2b935b);
$parcel$export(module.exports, "removeLink", () => $4ba901ede055e3ee$export$91d8072017908bea);
$parcel$export(module.exports, "removeLinkEditorCommand", () => $4ba901ede055e3ee$export$32e967ed59808fd);
$parcel$export(module.exports, "editInsertedLink", () => $4ba901ede055e3ee$export$8eb8ea8f98f386b5);
$parcel$export(module.exports, "showLinkToolbar", () => $4ba901ede055e3ee$export$83c364d103479f90);
$parcel$export(module.exports, "hideLinkToolbar", () => $4ba901ede055e3ee$export$bd1cd60a9b31da5e);
$parcel$export(module.exports, "hideLinkToolbarSetMeta", () => $4ba901ede055e3ee$export$534add8453a7a184);
$parcel$export(module.exports, "onEscapeCallback", () => $4ba901ede055e3ee$export$34daa751a305794c);
$parcel$export(module.exports, "onClickAwayCallback", () => $4ba901ede055e3ee$export$e72685a867c8a4f2);

var $ci54V = parcelRequire("ci54V");

var $g6Qq4 = parcelRequire("g6Qq4");

var $dVt29 = parcelRequire("dVt29");

var $hGzMn = parcelRequire("hGzMn");

var $et48L = parcelRequire("et48L");
var $7Zehw = parcelRequire("7Zehw");

var $iPR6g = parcelRequire("iPR6g");

var $98KMe = parcelRequire("98KMe");

var $6Z6Le = parcelRequire("6Z6Le");

var $5NaaJ = parcelRequire("5NaaJ");

var $cw0wu = parcelRequire("cw0wu");

var $a1fIR = parcelRequire("a1fIR");
function $4ba901ede055e3ee$var$setLinkHrefEditorCommand(href, pos, editorAnalyticsApi, to, isTabPressed) {
    return ({ tr: tr })=>{
        if (!(0, $et48L.isTextAtPos)(pos)({
            tr: tr
        })) return null;
        const $pos = tr.doc.resolve(pos);
        const node = tr.doc.nodeAt(pos);
        const linkMark = tr.doc.type.schema.marks.link;
        const mark = linkMark.isInSet(node.marks);
        const url = (0, $98KMe.normalizeUrl)(href);
        if (mark && mark.attrs.href === url) return null;
        const rightBound = to && pos !== to ? to : pos - $pos.textOffset + node.nodeSize;
        tr.removeMark(pos, rightBound, linkMark);
        if (href.trim()) tr.addMark(pos, rightBound, linkMark.create({
            ...mark && mark.attrs || {},
            href: url
        }));
        else editorAnalyticsApi === null || editorAnalyticsApi === void 0 || editorAnalyticsApi.attachAnalyticsEvent((0, $ci54V.unlinkPayload)((0, $g6Qq4.ACTION_SUBJECT_ID).HYPERLINK))(tr);
        if (!isTabPressed) tr.setMeta((0, $a1fIR.stateKey), {
            type: (0, $7Zehw.LinkAction).HIDE_TOOLBAR
        });
        return tr;
    };
}
function $4ba901ede055e3ee$export$911a683cdd8a2ccf(href, pos, editorAnalyticsApi, to, isTabPressed) {
    return (0, $iPR6g.editorCommandToPMCommand)($4ba901ede055e3ee$var$setLinkHrefEditorCommand(href, pos, editorAnalyticsApi, to, isTabPressed));
}
function $4ba901ede055e3ee$export$1f68f6e2d4509ef7(href, text, pos, to) {
    return ({ tr: tr })=>{
        const $pos = tr.doc.resolve(pos);
        const node = tr.doc.nodeAt(pos);
        if (!node) return null;
        const url = (0, $98KMe.normalizeUrl)(href);
        const mark = tr.doc.type.schema.marks.link.isInSet(node.marks);
        const linkMark = tr.doc.type.schema.marks.link;
        const rightBound = to && pos !== to ? to : pos - $pos.textOffset + node.nodeSize;
        if (!url && text) {
            tr.removeMark(pos, rightBound, linkMark);
            tr.insertText(text, pos, rightBound);
        } else if (!url) return null;
        else {
            tr.insertText(text, pos, rightBound);
            // Casting to LinkAttributes to prevent wrong attributes been passed (Example ED-7951)
            const linkAttrs = {
                ...mark && mark.attrs || {},
                href: url
            };
            tr.addMark(pos, pos + text.length, linkMark.create(linkAttrs));
            tr.setMeta((0, $a1fIR.stateKey), {
                type: (0, $7Zehw.LinkAction).HIDE_TOOLBAR
            });
        }
        return tr;
    };
}
function $4ba901ede055e3ee$export$468bc07728835ac4(href, text, pos, to) {
    return (0, $iPR6g.editorCommandToPMCommand)($4ba901ede055e3ee$export$1f68f6e2d4509ef7(href, text, pos, to));
}
function $4ba901ede055e3ee$export$c13c4fbf8f656592(from, to, incomingHref, incomingTitle, displayText, source, sourceEvent, appearance = 'inline', cardApiActions) {
    return (state, dispatch)=>{
        const link = state.schema.marks.link;
        const { tr: tr } = state;
        if (incomingHref.trim()) {
            var _stateKey$getState;
            const normalizedUrl = (0, $98KMe.normalizeUrl)(incomingHref);
            // NB: in this context, `currentText` represents text which has been
            // highlighted in the Editor, upon which a link is is being added.
            const currentText = (_stateKey$getState = (0, $a1fIR.stateKey).getState(state)) === null || _stateKey$getState === void 0 ? void 0 : _stateKey$getState.activeText;
            let markEnd = to;
            const text = displayText || incomingTitle || incomingHref;
            if (!displayText || displayText !== currentText) {
                tr.insertText(text, from, to);
                // new block created to wrap the link
                if (tr.mapping.map(from) === from + text.length + 2) // +1 is for the block's opening tag
                markEnd = from + text.length + 1;
                else markEnd = from + text.length;
            }
            tr.addMark(from, markEnd, link.create({
                href: normalizedUrl
            }));
            tr.setSelection((0, $cw0wu.Selection).near(tr.doc.resolve(markEnd)));
            if (!displayText || displayText === incomingHref) {
                const queueCardsFromChangedTr = cardApiActions === null || cardApiActions === void 0 ? void 0 : cardApiActions.queueCardsFromChangedTr;
                if (queueCardsFromChangedTr) queueCardsFromChangedTr === null || queueCardsFromChangedTr === void 0 || queueCardsFromChangedTr(state, tr, // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                source, (0, $g6Qq4.ACTION).INSERTED, false, sourceEvent, appearance);
                else (0, $dVt29.addLinkMetadata)(state.selection, tr, {
                    action: (0, $g6Qq4.ACTION).INSERTED,
                    inputMethod: source,
                    sourceEvent: sourceEvent
                });
            } else /**
         * Add link metadata because queue cards would have otherwise handled this for us
         */ (0, $dVt29.addLinkMetadata)(state.selection, tr, {
                action: (0, $g6Qq4.ACTION).INSERTED,
                inputMethod: source,
                sourceEvent: sourceEvent
            });
            tr.setMeta((0, $a1fIR.stateKey), {
                type: (0, $7Zehw.LinkAction).HIDE_TOOLBAR
            });
            if (dispatch) dispatch(tr);
            return true;
        }
        tr.setMeta((0, $a1fIR.stateKey), {
            type: (0, $7Zehw.LinkAction).HIDE_TOOLBAR
        });
        if (dispatch) dispatch(tr);
        return false;
    };
}
const $4ba901ede055e3ee$export$61f4de3ecc2b935b = (inputMethod, from, to, href, cardActions, editorAnalyticsApi, title, displayText, cardsAvailable = false, sourceEvent, appearance)=>{
    // If smart cards are available, we send analytics for hyperlinks when a smart link is rejected.
    if (cardsAvailable && !title && !displayText) return $4ba901ede055e3ee$export$c13c4fbf8f656592(from, to, href, title, displayText, inputMethod, sourceEvent, appearance, cardActions);
    return (0, $5NaaJ.withAnalytics)(editorAnalyticsApi, (state)=>(0, $6Z6Le.getLinkCreationAnalyticsEvent)(inputMethod, href, from !== to ? state.tr : undefined))($4ba901ede055e3ee$export$c13c4fbf8f656592(from, to, href, title, displayText, inputMethod, sourceEvent, appearance, cardActions));
};
function $4ba901ede055e3ee$export$91d8072017908bea(pos, editorAnalyticsApi) {
    return (0, $hGzMn.commandWithMetadata)($4ba901ede055e3ee$export$911a683cdd8a2ccf('', pos, editorAnalyticsApi), {
        action: (0, $g6Qq4.ACTION).UNLINK
    });
}
function $4ba901ede055e3ee$export$32e967ed59808fd(pos, editorAnalyticsApi) {
    return ({ tr: tr })=>{
        $4ba901ede055e3ee$var$setLinkHrefEditorCommand('', pos, editorAnalyticsApi)({
            tr: tr
        });
        (0, $dVt29.addLinkMetadata)(tr.selection, tr, {
            action: (0, $g6Qq4.ACTION).UNLINK
        });
        return tr;
    };
}
function $4ba901ede055e3ee$export$8eb8ea8f98f386b5(editorAnalyticsApi) {
    return (state, dispatch)=>{
        if (dispatch) {
            const { tr: tr } = state;
            tr.setMeta((0, $a1fIR.stateKey), {
                type: (0, $7Zehw.LinkAction).EDIT_INSERTED_TOOLBAR,
                inputMethod: (0, $g6Qq4.INPUT_METHOD).FLOATING_TB
            });
            editorAnalyticsApi === null || editorAnalyticsApi === void 0 || editorAnalyticsApi.attachAnalyticsEvent((0, $ci54V.buildEditLinkPayload)((0, $g6Qq4.ACTION_SUBJECT_ID).HYPERLINK))(tr);
            dispatch(tr);
        }
        return true;
    };
}
function $4ba901ede055e3ee$export$83c364d103479f90(inputMethod, editorAnalyticsApi) {
    return ({ tr: tr })=>{
        const newTr = tr.setMeta((0, $a1fIR.stateKey), {
            type: (0, $7Zehw.LinkAction).SHOW_INSERT_TOOLBAR,
            inputMethod: inputMethod
        });
        editorAnalyticsApi === null || editorAnalyticsApi === void 0 || editorAnalyticsApi.attachAnalyticsEvent({
            action: (0, $g6Qq4.ACTION).INVOKED,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).TYPEAHEAD,
            actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).TYPEAHEAD_LINK,
            attributes: {
                inputMethod: inputMethod
            },
            eventType: (0, $g6Qq4.EVENT_TYPE).UI
        })(newTr);
        return newTr;
    };
}
function $4ba901ede055e3ee$export$bd1cd60a9b31da5e() {
    return function(state, dispatch) {
        if (dispatch) dispatch($4ba901ede055e3ee$export$534add8453a7a184(state.tr));
        return true;
    };
}
const $4ba901ede055e3ee$export$534add8453a7a184 = (tr)=>{
    return tr.setMeta((0, $a1fIR.stateKey), {
        type: (0, $7Zehw.LinkAction).HIDE_TOOLBAR
    });
};
const $4ba901ede055e3ee$export$34daa751a305794c = (cardActions)=>(state, dispatch)=>{
        var _cardActions$hideLink;
        const { tr: tr } = state;
        $4ba901ede055e3ee$export$534add8453a7a184(tr);
        cardActions === null || cardActions === void 0 || (_cardActions$hideLink = cardActions.hideLinkToolbar) === null || _cardActions$hideLink === void 0 || _cardActions$hideLink.call(cardActions, tr);
        if (dispatch) {
            dispatch(tr);
            return true;
        }
        return false;
    };
const $4ba901ede055e3ee$export$e72685a867c8a4f2 = (state, dispatch)=>{
    if (dispatch) {
        $4ba901ede055e3ee$export$bd1cd60a9b31da5e()(state, dispatch);
        return true;
    }
    return false;
};

});
parcelRegister("et48L", function(module, exports) {
$parcel$export(module.exports, "isTextAtPos", () => $fbbaf673aa077a46$export$8476280b1d47554d);
function $fbbaf673aa077a46$export$8476280b1d47554d(pos) {
    return ({ tr: tr })=>{
        const node = tr.doc.nodeAt(pos);
        return !!node && node.isText;
    };
}

});

parcelRegister("a1fIR", function(module, exports) {
$parcel$export(module.exports, "stateKey", () => $45ff79bd96215cb0$export$77b371d6becc8882);
$parcel$export(module.exports, "plugin", () => $45ff79bd96215cb0$export$ca524d3785e2543);

var $7RHfd = parcelRequire("7RHfd");

var $7nI18 = parcelRequire("7nI18");

var $98NlB = parcelRequire("98NlB");
var $7Zehw = parcelRequire("7Zehw");

var $bk3yN = parcelRequire("bk3yN");

var $f7Kk4 = parcelRequire("f7Kk4");

var $cgQ5m = parcelRequire("cgQ5m");
var $56AB9 = parcelRequire("56AB9");

var $cw0wu = parcelRequire("cw0wu");
const $45ff79bd96215cb0$var$mapTransactionToState = (state, tr)=>{
    if (!state) return undefined;
    else if (state.type === (0, $98NlB.InsertStatus).EDIT_LINK_TOOLBAR || state.type === (0, $98NlB.InsertStatus).EDIT_INSERTED_TOOLBAR) {
        const { pos: pos, deleted: deleted } = tr.mapping.mapResult(state.pos, 1);
        const node = tr.doc.nodeAt(pos);
        // If the position was not deleted & it is still a link
        if (!deleted && !!node.type.schema.marks.link.isInSet(node.marks)) {
            if (node === state.node && pos === state.pos) return state;
            return {
                ...state,
                pos: pos,
                node: node
            };
        }
        // If the position has been deleted, then require a navigation to show the toolbar again
        return;
    } else if (state.type === (0, $98NlB.InsertStatus).INSERT_LINK_TOOLBAR) return {
        ...state,
        from: tr.mapping.map(state.from),
        to: tr.mapping.map(state.to)
    };
    return;
};
const $45ff79bd96215cb0$var$toState = (state, action, editorState)=>{
    // Show insert or edit toolbar
    if (!state) switch(action){
        case (0, $7Zehw.LinkAction).SHOW_INSERT_TOOLBAR:
            {
                const { from: from, to: to } = editorState.selection;
                if ((0, $cgQ5m.canLinkBeCreatedInRange)(from, to)(editorState)) return {
                    type: (0, $98NlB.InsertStatus).INSERT_LINK_TOOLBAR,
                    from: from,
                    to: to
                };
                return undefined;
            }
        case (0, $7Zehw.LinkAction).SELECTION_CHANGE:
            // If the user has moved their cursor, see if they're in a link
            const link = (0, $bk3yN.getActiveLinkMark)(editorState);
            if (link) return {
                ...link,
                type: (0, $98NlB.InsertStatus).EDIT_LINK_TOOLBAR
            };
            return undefined;
        default:
            return undefined;
    }
    // Update toolbar state if selection changes, or if toolbar is hidden
    if (state.type === (0, $98NlB.InsertStatus).EDIT_LINK_TOOLBAR) switch(action){
        case (0, $7Zehw.LinkAction).EDIT_INSERTED_TOOLBAR:
            {
                const link = (0, $bk3yN.getActiveLinkMark)(editorState);
                if (link) {
                    if (link.pos === state.pos && link.node === state.node) return {
                        ...state,
                        type: (0, $98NlB.InsertStatus).EDIT_INSERTED_TOOLBAR
                    };
                    return {
                        ...link,
                        type: (0, $98NlB.InsertStatus).EDIT_INSERTED_TOOLBAR
                    };
                }
                return undefined;
            }
        case (0, $7Zehw.LinkAction).SELECTION_CHANGE:
            const link1 = (0, $bk3yN.getActiveLinkMark)(editorState);
            if (link1) {
                if (link1.pos === state.pos && link1.node === state.node) // Make sure we return the same object, if it's the same link
                return state;
                return {
                    ...link1,
                    type: (0, $98NlB.InsertStatus).EDIT_LINK_TOOLBAR
                };
            }
            return undefined;
        case (0, $7Zehw.LinkAction).HIDE_TOOLBAR:
            return undefined;
        default:
            return state;
    }
    // Remove toolbar if user changes selection or toolbar is hidden
    if (state.type === (0, $98NlB.InsertStatus).INSERT_LINK_TOOLBAR) switch(action){
        case (0, $7Zehw.LinkAction).SELECTION_CHANGE:
        case (0, $7Zehw.LinkAction).HIDE_TOOLBAR:
            return undefined;
        default:
            return state;
    }
    return;
};
const $45ff79bd96215cb0$var$getActiveText = (selection)=>{
    const currentSlice = selection.content();
    if (currentSlice.size === 0) return;
    if (currentSlice.content.childCount === 1 && currentSlice.content.firstChild && selection instanceof (0, $cw0wu.TextSelection)) return currentSlice.content.firstChild.textContent;
    return;
};
const $45ff79bd96215cb0$export$77b371d6becc8882 = new (0, $cw0wu.PluginKey)('hyperlinkPlugin');
const $45ff79bd96215cb0$export$ca524d3785e2543 = (dispatch, intl, editorAppearance, _pluginInjectionApi, _onClickCallback, __livePage)=>new (0, $f7Kk4.SafePlugin)({
        state: {
            init (_, state) {
                const canInsertLink = (0, $cgQ5m.canLinkBeCreatedInRange)(state.selection.from, state.selection.to)(state);
                return {
                    activeText: $45ff79bd96215cb0$var$getActiveText(state.selection),
                    canInsertLink: canInsertLink,
                    timesViewed: 0,
                    activeLinkMark: $45ff79bd96215cb0$var$toState(undefined, (0, $7Zehw.LinkAction).SELECTION_CHANGE, state),
                    editorAppearance: editorAppearance
                };
            },
            apply (tr, pluginState, oldState, newState) {
                let state = pluginState;
                const action = tr.getMeta($45ff79bd96215cb0$export$77b371d6becc8882) && tr.getMeta($45ff79bd96215cb0$export$77b371d6becc8882).type;
                const inputMethod = tr.getMeta($45ff79bd96215cb0$export$77b371d6becc8882) && tr.getMeta($45ff79bd96215cb0$export$77b371d6becc8882).inputMethod;
                if (tr.docChanged) state = {
                    activeText: state.activeText,
                    canInsertLink: (0, $cgQ5m.canLinkBeCreatedInRange)(newState.selection.from, newState.selection.to)(newState),
                    timesViewed: state.timesViewed,
                    inputMethod: inputMethod,
                    activeLinkMark: $45ff79bd96215cb0$var$mapTransactionToState(state.activeLinkMark, tr),
                    editorAppearance: editorAppearance
                };
                if (action) {
                    const stateForAnalytics = [
                        (0, $7Zehw.LinkAction).SHOW_INSERT_TOOLBAR,
                        (0, $7Zehw.LinkAction).EDIT_INSERTED_TOOLBAR
                    ].includes(action) ? {
                        timesViewed: ++state.timesViewed,
                        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                        searchSessionId: (0, $7RHfd.default)()
                    } : {
                        timesViewed: state.timesViewed,
                        searchSessionId: state.searchSessionId
                    };
                    state = {
                        activeText: state.activeText,
                        canInsertLink: state.canInsertLink,
                        inputMethod: inputMethod,
                        activeLinkMark: $45ff79bd96215cb0$var$toState(state.activeLinkMark, action, newState),
                        editorAppearance: editorAppearance,
                        ...stateForAnalytics
                    };
                }
                const hasPositionChanged = oldState.selection.from !== newState.selection.from || oldState.selection.to !== newState.selection.to;
                if (tr.selectionSet && hasPositionChanged) state = {
                    activeText: $45ff79bd96215cb0$var$getActiveText(newState.selection),
                    canInsertLink: (0, $cgQ5m.canLinkBeCreatedInRange)(newState.selection.from, newState.selection.to)(newState),
                    activeLinkMark: $45ff79bd96215cb0$var$toState(state.activeLinkMark, (0, $7Zehw.LinkAction).SELECTION_CHANGE, newState),
                    timesViewed: state.timesViewed,
                    searchSessionId: state.searchSessionId,
                    inputMethod: inputMethod,
                    editorAppearance: editorAppearance
                };
                if (!(0, $56AB9.shallowEqual)(state, pluginState)) dispatch($45ff79bd96215cb0$export$77b371d6becc8882, state);
                return state;
            }
        },
        key: $45ff79bd96215cb0$export$77b371d6becc8882,
        props: {
            handleDOMEvents: {
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                auxclick: (_, event)=>{
                    if (event.button !== 1) return false;
                    const anchor = $45ff79bd96215cb0$var$getLinkAnchor(event);
                    if (!anchor) return false;
                    // Browsers do not follow a link clicked inside contenteditable, so a link in
                    // editable text never opens on middle-click and has to be opened here. Cards
                    // render their anchor inside a contenteditable="false" node view, and a
                    // read-only editor is itself contenteditable="false" — in both cases the
                    // browser opens the tab, so doing it again here would open two.
                    if (anchor.closest('[contenteditable="false"]')) return false;
                    const href = anchor.getAttribute('href');
                    if (!href || !(0, $7nI18.isSafeUrl)(href)) return false;
                    window.open(href, '_blank', 'noopener,noreferrer');
                    return true;
                },
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                mouseup: (_, event)=>{
                    // this prevents redundant selection transaction when clicking on link
                    // link state will be update on slection change which happens on mousedown
                    if ($45ff79bd96215cb0$var$isLinkDirectTarget(event)) {
                        // Leave middle-click alone so the browser can still open the link in a new tab.
                        if (event.button === 1) return false;
                        event.preventDefault();
                        return true;
                    }
                    return false;
                },
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                mousedown: (view, event)=>{
                    // Middle-click on a link: skip ProseMirror's own handling so it does not move
                    // the selection into the link or select the card node, which is what opens
                    // the toolbar.
                    const middleClickAnchor = event.button === 1 ? $45ff79bd96215cb0$var$getLinkAnchor(event) : null;
                    if (middleClickAnchor) {
                        // Returning true only stops ProseMirror. The browser still places a caret
                        // at the click point inside contenteditable, and a caret inside the link is
                        // itself enough to open the toolbar, so the default has to be suppressed
                        // too. The auxclick handler above opens the tab for these links.
                        //
                        // Anchors inside a contenteditable="false" node view (cards, and read-only
                        // editors) are deliberately left alone: they get no caret, and it is the
                        // browser's default that opens their new tab.
                        if (!middleClickAnchor.closest('[contenteditable="false"]')) event.preventDefault();
                        return true;
                    }
                    // since link clicks are disallowed by browsers inside contenteditable
                    // so we need to handle shift+click selection ourselves in this case
                    if (!event.shiftKey || !$45ff79bd96215cb0$var$isLinkDirectTarget(event)) return false;
                    const { state: state } = view;
                    const { selection: { $anchor: $anchor } } = state;
                    const newPosition = view.posAtCoords({
                        left: event.clientX,
                        top: event.clientY
                    });
                    if ((newPosition === null || newPosition === void 0 ? void 0 : newPosition.pos) != null && newPosition.pos !== $anchor.pos) {
                        const tr = state.tr.setSelection((0, $cw0wu.TextSelection).create(state.doc, $anchor.pos, newPosition.pos));
                        view.dispatch(tr);
                        return true;
                    }
                    return false;
                }
            }
        }
    });
function $45ff79bd96215cb0$var$isLinkDirectTarget(event) {
    return (event === null || event === void 0 ? void 0 : event.target) instanceof HTMLElement && event.target.tagName === 'A';
}
/**
 * Whether the event happened anywhere inside a link, rather than on the anchor itself.
 *
 * Matching on the anchor alone is not enough. Every smart link variant renders its anchor
 * with nested content inside it — inline cards nest icon, title and lozenge spans, block
 * and embed cards render anchors via the flexible card `base-link-element` and
 * `ExpandedFrame` — so the direct target of a real click is almost never the anchor.
 *
 * Being DOM based rather than node based, this covers every variant that renders a real
 * anchor: link marks, inline cards, block cards, embed card headers and datasource cell
 * links. None of the card node views swallow `mousedown` (their `stopEvent` only returns
 * true for `dragstart`, or for form elements in the datasource case), so the event does
 * reach this handler in all of those cases. The exception is content inside an embed
 * card's iframe, which is a separate document we cannot observe.
 *
 * `isLinkDirectTarget` is deliberately left alone: widening it would also change
 * shift+click and mouseup handling for every nested element inside a link.
 */ function $45ff79bd96215cb0$var$getLinkAnchor(event) {
    return (event === null || event === void 0 ? void 0 : event.target) instanceof Element ? event.target.closest('a[href]') : null;
}

});
parcelRegister("98NlB", function(module, exports) {
$parcel$export(module.exports, "InsertStatus", () => $ad00aff68633084c$export$8dcc3cd59f9a0726);
var $ad00aff68633084c$export$8dcc3cd59f9a0726 = /*#__PURE__*/ function(InsertStatus) {
    InsertStatus["EDIT_LINK_TOOLBAR"] = "EDIT";
    InsertStatus["INSERT_LINK_TOOLBAR"] = "INSERT";
    InsertStatus["EDIT_INSERTED_TOOLBAR"] = "EDIT_INSERTED";
    return InsertStatus;
}({});

});



parcelRegister("8hkNI", function(module, exports) {
$parcel$export(module.exports, "default", () => $3275a91f92a63eb2$export$2e2bcd8739ae039);

var $98NlB = parcelRequire("98NlB");

var $f7Kk4 = parcelRequire("f7Kk4");

var $a3b9P = parcelRequire("a3b9P");

var $bkEhj = parcelRequire("bkEhj");

var $a1fIR = parcelRequire("a1fIR");
const $3275a91f92a63eb2$var$createTextCursor = (pos)=>{
    const node = document.createElement('div');
    node.className = 'ProseMirror-fake-text-cursor';
    return (0, $a3b9P.Decoration).widget(pos, node, {
        key: 'hyperlink-text-cursor'
    });
};
const $3275a91f92a63eb2$var$createTextSelection = (from, to)=>(0, $a3b9P.Decoration).inline(from, to, {
        class: 'ProseMirror-fake-text-selection'
    });
const $3275a91f92a63eb2$var$getInsertLinkToolbarState = (editorState)=>{
    const state = (0, $a1fIR.stateKey).getState(editorState);
    if (state && state.activeLinkMark) {
        if (state.activeLinkMark.type === (0, $98NlB.InsertStatus).INSERT_LINK_TOOLBAR) return state.activeLinkMark;
    }
    return undefined;
};
const $3275a91f92a63eb2$var$fakeCursorToolbarPlugin = new (0, $f7Kk4.SafePlugin)({
    key: (0, $bkEhj.fakeCursorForToolbarPluginKey),
    state: {
        init () {
            return (0, $a3b9P.DecorationSet).empty;
        },
        apply (tr, pluginState, oldState, newState) {
            const oldInsertToolbarState = $3275a91f92a63eb2$var$getInsertLinkToolbarState(oldState);
            const insertToolbarState = $3275a91f92a63eb2$var$getInsertLinkToolbarState(newState);
            // Map DecorationSet if it still refers to the same position in the document
            if (oldInsertToolbarState && insertToolbarState) {
                const { from: from, to: to } = insertToolbarState;
                const oldFrom = tr.mapping.map(oldInsertToolbarState.from);
                const oldTo = tr.mapping.map(oldInsertToolbarState.to);
                if (oldFrom === from && oldTo === to) return pluginState.map(tr.mapping, tr.doc);
            }
            // Update DecorationSet if new insert toolbar, or if we have moved to a different position in the doc
            if (insertToolbarState) {
                const { from: from, to: to } = insertToolbarState;
                return (0, $a3b9P.DecorationSet).create(tr.doc, [
                    from === to ? $3275a91f92a63eb2$var$createTextCursor(from) : $3275a91f92a63eb2$var$createTextSelection(from, to)
                ]);
            }
            return (0, $a3b9P.DecorationSet).empty;
        }
    },
    props: {
        decorations (state) {
            return (0, $bkEhj.fakeCursorForToolbarPluginKey).getState(state);
        }
    }
});
var $3275a91f92a63eb2$export$2e2bcd8739ae039 = $3275a91f92a63eb2$var$fakeCursorToolbarPlugin;

});
parcelRegister("bkEhj", function(module, exports) {
$parcel$export(module.exports, "fakeCursorForToolbarPluginKey", () => $91c812e1b5298fd4$export$38c00ed3b117ab26);

var $cw0wu = parcelRequire("cw0wu");
const $91c812e1b5298fd4$export$38c00ed3b117ab26 = new (0, $cw0wu.PluginKey)('fakeCursorToolbarPlugin');

});


parcelRegister("dqC4c", function(module, exports) {
$parcel$export(module.exports, "createInputRulePlugin", () => $2417094afedfe4c8$export$dc83f374e2af640d);

var $g6Qq4 = parcelRequire("g6Qq4");

var $dVt29 = parcelRequire("dVt29");

var $f7Kk4 = parcelRequire("f7Kk4");

var $33v8M = parcelRequire("33v8M");
var $amIzn = parcelRequire("amIzn");
var $98KMe = parcelRequire("98KMe");

var $6Z6Le = parcelRequire("6Z6Le");

var $hhAGP = parcelRequire("hhAGP");

var $8t09p = parcelRequire("8t09p");

var $jltJY = parcelRequire("jltJY");
// [something](link) should convert to a hyperlink
// eslint-disable-next-line require-unicode-regexp
const $2417094afedfe4c8$var$MARKDOWN_LINK_RULE_REGEX = /(^|[^!])\[(.*?)\]\((\S+)\)$/;
function $2417094afedfe4c8$export$8d0400fab1d2ed11(regexp, editorAnalyticsApi) {
    // Plain typed text (eg, typing 'www.google.com') should convert to a hyperlink
    return (0, $33v8M.createRule)(regexp, (state, match, start, end)=>{
        var _toolbarKey$getState;
        const { schema: schema } = state;
        if (state.doc.rangeHasMark(start, end, schema.marks.link)) return null;
        const link = match;
        // Property 'url' does not exist on type 'RegExpExecArray', the type of `match`.
        // This check is in case the match is not a Linkify match, which has a url property.
        if (link.url === undefined) return null;
        if (!(0, $hhAGP.shouldAutoLinkifyMatch)(link)) return null;
        const url = (0, $98KMe.normalizeUrl)(link.url);
        // Not previously handled; don't create a link if the URL is empty.
        // This will only happen if the `regexp` matches more links than the normalizeUrl validation;
        // if they both use the same linkify instance this shouldn't happen.
        if (url === '') return null;
        const markType = schema.mark('link', {
            href: url
        });
        // Need access to complete text to check if last URL is part of a filepath before linkifying
        const nodeBefore = state.selection.$from.nodeBefore;
        if (!nodeBefore || !nodeBefore.isText || !nodeBefore.text) return null;
        const filepaths = (0, $6Z6Le.findFilepaths)(nodeBefore.text, // The position referenced by 'start' is relative to the start of the document, findFilepaths deals with index in a node only.
        start - (nodeBefore.text.length - link.text.length // (start of link match) - (whole node text length - link length) gets start of text node, which is used as offset
        ));
        if ((0, $6Z6Le.isLinkInMatches)(start, filepaths)) {
            const tr = state.tr;
            return tr;
        }
        const from = start;
        const to = Math.min(start + link.text.length, state.doc.content.size);
        const tr = state.tr.addMark(from, to, markType);
        // Keep old behavior that will delete the space after the link
        if (to === end) tr.insertText(' ');
        (0, $dVt29.addLinkMetadata)(state.selection, tr, {
            inputMethod: (0, $g6Qq4.INPUT_METHOD).AUTO_DETECT
        });
        const skipAnalytics = ((_toolbarKey$getState = (0, $jltJY.toolbarKey).getState(state)) === null || _toolbarKey$getState === void 0 ? void 0 : _toolbarKey$getState.skipAnalytics) ?? false;
        if (skipAnalytics) return tr;
        editorAnalyticsApi === null || editorAnalyticsApi === void 0 || editorAnalyticsApi.attachAnalyticsEvent((0, $6Z6Le.getLinkCreationAnalyticsEvent)((0, $g6Qq4.INPUT_METHOD).AUTO_DETECT, url))(tr);
        return tr;
    });
}
function $2417094afedfe4c8$export$dc83f374e2af640d(schema, editorAnalyticsApi, autoLinkOnBlur = false) {
    if (!schema.marks.link) return;
    const urlWithASpaceRule = $2417094afedfe4c8$export$8d0400fab1d2ed11((0, $amIzn.LinkMatcher).create(), editorAnalyticsApi);
    const markdownLinkRule = (0, $33v8M.createRule)($2417094afedfe4c8$var$MARKDOWN_LINK_RULE_REGEX, (state, match, start, end)=>{
        var _toolbarKey$getState2;
        const { schema: schema } = state;
        const [, prefix, linkText, linkUrl] = match;
        // We don't filter this match here by shouldAutoLinkifyMatch
        // because the intent of creating a link is clear
        const url = (0, $98KMe.normalizeUrl)(linkUrl).trim();
        const markType = schema.mark('link', {
            href: url
        });
        const tr = state.tr.replaceWith(start + prefix.length, end, schema.text((linkText || '').trim(), [
            markType
        ]));
        (0, $dVt29.addLinkMetadata)(state.selection, tr, {
            inputMethod: (0, $g6Qq4.INPUT_METHOD).FORMATTING
        });
        const skipAnalytics = ((_toolbarKey$getState2 = (0, $jltJY.toolbarKey).getState(state)) === null || _toolbarKey$getState2 === void 0 ? void 0 : _toolbarKey$getState2.skipAnalytics) ?? false;
        if (skipAnalytics) return tr;
        editorAnalyticsApi === null || editorAnalyticsApi === void 0 || editorAnalyticsApi.attachAnalyticsEvent((0, $6Z6Le.getLinkCreationAnalyticsEvent)((0, $g6Qq4.INPUT_METHOD).FORMATTING, url))(tr);
        return tr;
    });
    return new (0, $f7Kk4.SafePlugin)((0, $8t09p.createPlugin)('hyperlink', [
        urlWithASpaceRule,
        markdownLinkRule
    ], autoLinkOnBlur ? {
        checkOnBlur: true,
        appendTextOnBlur: ' '
    } : undefined));
}
var $2417094afedfe4c8$export$2e2bcd8739ae039 = $2417094afedfe4c8$export$dc83f374e2af640d;

});
parcelRegister("jltJY", function(module, exports) {
$parcel$export(module.exports, "toolbarKey", () => $f84a6b5b1736947d$export$6cbac557ea601778);
$parcel$export(module.exports, "toolbarButtonsPlugin", () => $f84a6b5b1736947d$export$faf11097578346af);

var $f7Kk4 = parcelRequire("f7Kk4");

var $cw0wu = parcelRequire("cw0wu");
const $f84a6b5b1736947d$export$6cbac557ea601778 = new (0, $cw0wu.PluginKey)('hyperlinkToolbarItems');
const $f84a6b5b1736947d$export$faf11097578346af = (initialState)=>{
    return new (0, $f7Kk4.SafePlugin)({
        key: $f84a6b5b1736947d$export$6cbac557ea601778,
        state: {
            init: (_, __)=>{
                return initialState;
            },
            apply: (tr, pluginState)=>{
                const metaState = tr.getMeta($f84a6b5b1736947d$export$6cbac557ea601778);
                if (metaState) return metaState;
                return pluginState;
            }
        }
    });
};

});


parcelRegister("d5xI9", function(module, exports) {
$parcel$export(module.exports, "createKeymapPlugin", () => $be5381a82332ca5c$export$1d7b13ce0747fbd);

var $rd0To = parcelRequire("rd0To");

var $g6Qq4 = parcelRequire("g6Qq4");

var $dVt29 = parcelRequire("dVt29");

var $cv8id = parcelRequire("cv8id");

var $6Z6Le = parcelRequire("6Z6Le");

var $hhAGP = parcelRequire("hhAGP");

var $ejrfk = parcelRequire("ejrfk");

var $c8lUQ = parcelRequire("c8lUQ");

var $a1fIR = parcelRequire("a1fIR");

var $jltJY = parcelRequire("jltJY");
function $be5381a82332ca5c$export$1d7b13ce0747fbd(editorAnalyticsApi) {
    const list = {};
    (0, $cv8id.bindKeymapWithEditorCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $cv8id.addLink).common, (0, $c8lUQ.showLinkToolbar)((0, $g6Qq4.INPUT_METHOD).SHORTCUT, editorAnalyticsApi), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $cv8id.bindKeymapWithCommand)((0, $cv8id.enter).common, $be5381a82332ca5c$var$mayConvertLastWordToHyperlink(editorAnalyticsApi), list);
    (0, $cv8id.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $cv8id.insertNewLine).common, $be5381a82332ca5c$var$mayConvertLastWordToHyperlink(editorAnalyticsApi), list);
    (0, $cv8id.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $cv8id.escape).common, (state, dispatch, view)=>{
        const hyperlinkPlugin = (0, $a1fIR.stateKey).getState(state);
        if (hyperlinkPlugin.activeLinkMark) {
            (0, $c8lUQ.hideLinkToolbar)()(state, dispatch);
            if (view) view.focus();
            return false;
        }
        return false;
    }, list);
    return (0, $ejrfk.keymap)(list);
}
/**
 * Convert the last word before the selection to a hyperlink if it's a valid URL with a tld we want to linkify
 */ const $be5381a82332ca5c$var$mayConvertLastWordToHyperlink = (editorAnalyticsApi)=>{
    return function(state, dispatch) {
        var _toolbarKey$getState;
        const skipAnalytics = ((_toolbarKey$getState = (0, $jltJY.toolbarKey).getState(state)) === null || _toolbarKey$getState === void 0 ? void 0 : _toolbarKey$getState.skipAnalytics) ?? false;
        const nodeBefore = state.selection.$from.nodeBefore;
        if (!nodeBefore || !nodeBefore.isText || !nodeBefore.text) return false;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const words = nodeBefore.text.split(' ');
        const lastWord = words[words.length - 1];
        const match = (0, $rd0To.getLinkMatch)(lastWord);
        if (match) {
            if (!(0, $hhAGP.shouldAutoLinkifyMatch)(match)) return false;
            const hyperlinkedText = match.raw;
            const start = state.selection.$from.pos - hyperlinkedText.length;
            const end = state.selection.$from.pos;
            if (state.doc.rangeHasMark(start, end, state.schema.marks.link)) return false;
            const url = match.url;
            const markType = state.schema.mark('link', {
                href: url
            });
            const filepaths = (0, $6Z6Le.findFilepaths)(nodeBefore.text, start - (nodeBefore.text.length - hyperlinkedText.length // The position referenced by 'start' is relative to the start of the document, findFilepaths deals with index in a node only.
            ));
            if ((0, $6Z6Le.isLinkInMatches)(start, filepaths)) return false;
            const tr = state.tr.addMark(start, end, markType);
            if (dispatch) {
                (0, $dVt29.addLinkMetadata)(state.selection, tr, {
                    inputMethod: (0, $g6Qq4.INPUT_METHOD).AUTO_DETECT
                });
                if (skipAnalytics) dispatch(tr);
                else {
                    editorAnalyticsApi === null || editorAnalyticsApi === void 0 || editorAnalyticsApi.attachAnalyticsEvent((0, $6Z6Le.getLinkCreationAnalyticsEvent)((0, $g6Qq4.INPUT_METHOD).AUTO_DETECT, url))(tr);
                    dispatch(tr);
                }
            }
        }
        return false;
    };
};
var $be5381a82332ca5c$export$2e2bcd8739ae039 = $be5381a82332ca5c$export$1d7b13ce0747fbd;

});

parcelRegister("5nCvs", function(module, exports) {
$parcel$export(module.exports, "getHyperlinkQuickInsertComponents", () => $e5c577dd5ae7d240$export$91d5466719f8efb8);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $cv8id = parcelRequire("cv8id");

var $cW1gB = parcelRequire("cW1gB");

var $b8Hvx = parcelRequire("b8Hvx");

var $9woaI = parcelRequire("9woaI");

var $am2Qg = parcelRequire("am2Qg");

var $1wctV = parcelRequire("1wctV");
const $e5c577dd5ae7d240$export$91d5466719f8efb8 = ({ api: api })=>[
        {
            key: (0, $9woaI.HYPERLINK_MENU_ITEM).key,
            type: (0, $9woaI.HYPERLINK_MENU_ITEM).type,
            parents: [
                {
                    key: (0, $9woaI.MEDIA_SECTION).key,
                    type: (0, $9woaI.MEDIA_SECTION).type,
                    rank: (0, $am2Qg.MEDIA_SECTION_RANK)[(0, $9woaI.HYPERLINK_MENU_ITEM).key]
                }
            ],
            match: (0, $b8Hvx.createQuickInsertMatcher)(({ formatMessage: formatMessage })=>({
                    description: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).linkDescription),
                    keywords: [
                        'hyperlink',
                        'url'
                    ],
                    shortcut: (0, $cv8id.tooltip)((0, $cv8id.addLink)),
                    title: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).link)
                })),
            component: ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $1wctV.HyperlinkQuickInsertMenuItem), {
                    api: api
                })
        }
    ];

});
parcelRegister("1wctV", function(module, exports) {
$parcel$export(module.exports, "HyperlinkQuickInsertMenuItem", () => $ae86028707776b6c$export$b993de95dedc883b);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $g6Qq4 = parcelRequire("g6Qq4");

var $cv8id = parcelRequire("cv8id");

var $7Zehw = parcelRequire("7Zehw");

var $cW1gB = parcelRequire("cW1gB");

var $fT9mF = parcelRequire("fT9mF");

var $64eKJ = parcelRequire("64eKJ");

var $gRfjb = parcelRequire("gRfjb");

var $a1fIR = parcelRequire("a1fIR");
const $ae86028707776b6c$var$previewImageUrls = {
    dark: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVHO.png',
    light: 'https://dam-cdn.atl.orangelogic.com/CDNLink/AT12OVLL.png'
};
const $ae86028707776b6c$export$b993de95dedc883b = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const preview = (0, $bSJIT.useMemo)(()=>({
            image: $ae86028707776b6c$var$previewImageUrls,
            attribution: {
                name: formatMessage((0, $64eKJ.messages).previewAttributionAtlassian)
            }
        }), [
        formatMessage
    ]);
    const onSelect = (0, $bSJIT.useCallback)(({ insert: insert })=>{
        var _api$analytics, _api$analytics$attach;
        const tr = insert(undefined);
        tr.setMeta((0, $a1fIR.stateKey), {
            type: (0, $7Zehw.LinkAction).SHOW_INSERT_TOOLBAR,
            inputMethod: (0, $g6Qq4.INPUT_METHOD).QUICK_INSERT
        });
        const analyticsAttached = api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 || (_api$analytics = _api$analytics.actions) === null || _api$analytics === void 0 || (_api$analytics$attach = _api$analytics.attachAnalyticsEvent) === null || _api$analytics$attach === void 0 ? void 0 : _api$analytics$attach.call(_api$analytics, {
            action: (0, $g6Qq4.ACTION).INVOKED,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).TYPEAHEAD,
            actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).TYPEAHEAD_LINK,
            attributes: {
                inputMethod: (0, $g6Qq4.INPUT_METHOD).QUICK_INSERT
            },
            eventType: (0, $g6Qq4.EVENT_TYPE).UI
        })(tr);
        return analyticsAttached !== false ? tr : false;
    }, [
        api
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $fT9mF.QuickInsertMenuItem), {
        description: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).linkDescription),
        iconBefore: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gRfjb))), {
            label: ""
        }),
        onSelect: onSelect,
        preview: preview,
        shortcut: (0, $cv8id.tooltip)((0, $cv8id.addLink)),
        title: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).link)
    });
};

});


parcelRegister("6aoNe", function(module, exports) {
$parcel$export(module.exports, "getToolbarComponents", () => $af26c0e63c8ebaa8$export$a758406ca53b86a5);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $4rzOL = parcelRequire("4rzOL");

var $fiku8 = parcelRequire("fiku8");

var $jDG1f = parcelRequire("jDG1f");
const $af26c0e63c8ebaa8$export$a758406ca53b86a5 = (api)=>{
    const toolbarComponents = [
        {
            type: (0, $4rzOL.LINKING_GROUP).type,
            key: (0, $4rzOL.LINKING_GROUP).key,
            parents: [
                {
                    type: (0, $4rzOL.LINKING_SECTION).type,
                    key: (0, $4rzOL.LINKING_SECTION).key,
                    rank: (0, $fiku8.LINKING_SECTION_RANK)[(0, $4rzOL.LINKING_GROUP).key]
                }
            ]
        },
        {
            type: (0, $4rzOL.LINKING_BUTTON).type,
            key: (0, $4rzOL.LINKING_BUTTON).key,
            parents: [
                {
                    type: (0, $4rzOL.LINKING_GROUP).type,
                    key: (0, $4rzOL.LINKING_GROUP).key,
                    rank: (0, $fiku8.LINKING_GROUP_RANK)[(0, $4rzOL.LINKING_BUTTON).key]
                }
            ],
            component: ()=>{
                return /*#__PURE__*/ (0, $dc70d.jsx)((0, $jDG1f.LinkButton), {
                    api: api
                });
            }
        }
    ];
    return toolbarComponents;
};

});
parcelRegister("jDG1f", function(module, exports) {
$parcel$export(module.exports, "LinkButton", () => $1504872db369ca73$export$29d11c0fe2fc51d8);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $g6Qq4 = parcelRequire("g6Qq4");

var $cv8id = parcelRequire("cv8id");

var $cW1gB = parcelRequire("cW1gB");

var $5beht = parcelRequire("5beht");

var $gRfjb = parcelRequire("gRfjb");

var $7cgYb = parcelRequire("7cgYb");

var $eHnl8 = parcelRequire("eHnl8");
const $1504872db369ca73$export$29d11c0fe2fc51d8 = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const canInsertLink = (0, $5beht.useSharedPluginStateWithSelector)(api, [
        'hyperlink'
    ], (state)=>{
        var _state$hyperlinkState;
        return (state === null || state === void 0 || (_state$hyperlinkState = state.hyperlinkState) === null || _state$hyperlinkState === void 0 ? void 0 : _state$hyperlinkState.canInsertLink) ?? true;
    });
    const onClick = ()=>{
        api === null || api === void 0 || api.core.actions.execute(api === null || api === void 0 ? void 0 : api.hyperlink.commands.showLinkToolbar((0, $g6Qq4.INPUT_METHOD).FLOATING_TB));
    };
    const isEnabled = canInsertLink;
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $eHnl8.ToolbarTooltip), {
        content: /*#__PURE__*/ (0, $dc70d.jsx)((0, $cv8id.ToolTipContent), {
            description: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).link),
            keymap: (0, $cv8id.addLink)
        }),
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $7cgYb.ToolbarButton), {
            iconBefore: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gRfjb))), {
                label: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).link),
                size: "small"
            }),
            onClick: onClick,
            testId: 'editor-toolbar__link-button',
            isDisabled: !isEnabled
        })
    });
};

});


parcelRegister("aQtYb", function(module, exports) {
$parcel$export(module.exports, "getToolbarConfig", () => $7b6b701ed30d3cec$export$86ce8f8241c20a3);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $7nI18 = parcelRequire("7nI18");

var $ci54V = parcelRequire("ci54V");

var $g6Qq4 = parcelRequire("g6Qq4");

var $hGzMn = parcelRequire("hGzMn");

var $hVGJk = parcelRequire("hVGJk");

var $7Zwry = parcelRequire("7Zwry");

var $GdBew = parcelRequire("GdBew");

var $8FY43 = parcelRequire("8FY43");

var $ejFiy = parcelRequire("ejFiy");

var $8qHhy = parcelRequire("8qHhy");

var $cp06f = parcelRequire("cp06f");

var $5beht = parcelRequire("5beht");

var $98KMe = parcelRequire("98KMe");

var $cw0wu = parcelRequire("cw0wu");

var $gab48 = parcelRequire("gab48");

var $5Uddy = parcelRequire("5Uddy");

var $1c4Ad = parcelRequire("1c4Ad");

var $92LrB = parcelRequire("92LrB");

var $797yE = parcelRequire("797yE");

var $c8lUQ = parcelRequire("c8lUQ");

var $a1fIR = parcelRequire("a1fIR");

var $jltJY = parcelRequire("jltJY");
/* type guard for edit links */ function $7b6b701ed30d3cec$var$isEditLink(linkMark) {
    return linkMark.pos !== undefined;
}
const $7b6b701ed30d3cec$var$dispatchAnalytics = (dispatch, state, analyticsBuilder, editorAnalyticsApi)=>{
    if (dispatch) {
        const { tr: tr } = state;
        editorAnalyticsApi === null || editorAnalyticsApi === void 0 || editorAnalyticsApi.attachAnalyticsEvent(analyticsBuilder((0, $g6Qq4.ACTION_SUBJECT_ID).HYPERLINK))(tr);
        dispatch(tr);
    }
};
const $7b6b701ed30d3cec$var$visitHyperlink = (editorAnalyticsApi)=>(state, dispatch)=>{
        $7b6b701ed30d3cec$var$dispatchAnalytics(dispatch, state, (0, $ci54V.buildVisitedLinkPayload), editorAnalyticsApi);
        return true;
    };
function $7b6b701ed30d3cec$var$getLinkText(activeLinkMark, state) {
    if (!activeLinkMark.node) return undefined;
    const textToUrl = (0, $98KMe.normalizeUrl)(activeLinkMark.node.text);
    const linkMark = activeLinkMark.node.marks.find((mark)=>mark.type === state.schema.marks.link);
    const linkHref = linkMark && linkMark.attrs.href;
    if (textToUrl === linkHref) return undefined;
    return activeLinkMark.node.text;
}
const $7b6b701ed30d3cec$var$selector = (states)=>{
    var _states$hyperlinkStat, _states$hyperlinkStat2, _states$hyperlinkStat3;
    return {
        timesViewed: (_states$hyperlinkStat = states.hyperlinkState) === null || _states$hyperlinkStat === void 0 ? void 0 : _states$hyperlinkStat.timesViewed,
        inputMethod: (_states$hyperlinkStat2 = states.hyperlinkState) === null || _states$hyperlinkStat2 === void 0 ? void 0 : _states$hyperlinkStat2.inputMethod,
        searchSessionId: (_states$hyperlinkStat3 = states.hyperlinkState) === null || _states$hyperlinkStat3 === void 0 ? void 0 : _states$hyperlinkStat3.searchSessionId
    };
};
function $7b6b701ed30d3cec$export$a46cebff622c3cae({ linkPickerOptions: linkPickerOptions = {}, onSubmit: onSubmit, displayText: displayText, displayUrl: displayUrl, providerFactory: providerFactory, view: view, onCancel: onCancel, invokeMethod: invokeMethod, lpLinkPicker: lpLinkPicker, onClose: onClose, onEscapeCallback: onEscapeCallback, onClickAwayCallback: onClickAwayCallback, pluginInjectionApi: pluginInjectionApi }) {
    var _pluginInjectionApi$c;
    const { timesViewed: timesViewed, inputMethod: inputMethod, searchSessionId: searchSessionId } = (0, $5beht.useSharedPluginStateWithSelector)(pluginInjectionApi, [
        'hyperlink'
    ], $7b6b701ed30d3cec$var$selector);
    // This is constant rather than dynamic - because if someone's already got a hyperlink toolbar open,
    // we don't want to dynamically change it on them as this would cause data loss if they've already
    // started typing in the fields.
    const isOffline = (0, $bSJIT.useRef)((0, $hVGJk.isOfflineMode)(pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$c = pluginInjectionApi.connectivity) === null || _pluginInjectionApi$c === void 0 || (_pluginInjectionApi$c = _pluginInjectionApi$c.sharedState.currentState()) === null || _pluginInjectionApi$c === void 0 ? void 0 : _pluginInjectionApi$c.mode));
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $GdBew.HyperlinkAddToolbar), {
        linkPickerOptions: linkPickerOptions,
        onSubmit: onSubmit,
        displayText: displayText,
        displayUrl: displayUrl,
        providerFactory: providerFactory,
        view: view,
        onCancel: onCancel,
        invokeMethod: invokeMethod,
        lpLinkPicker: lpLinkPicker,
        onClose: onClose,
        onEscapeCallback: onEscapeCallback,
        onClickAwayCallback: onClickAwayCallback,
        timesViewed: timesViewed,
        inputMethod: inputMethod,
        searchSessionId: searchSessionId,
        isOffline: isOffline.current
    });
}
const $7b6b701ed30d3cec$export$86ce8f8241c20a3 = (options, pluginInjectionApi)=>(state, intl, providerFactory)=>{
        var _pluginInjectionApi$c2, _pluginInjectionApi$a;
        if (options.disableFloatingToolbar) return;
        const isToolbarAIFCEnabled = Boolean(pluginInjectionApi === null || pluginInjectionApi === void 0 ? void 0 : pluginInjectionApi.toolbar);
        const linkState = (0, $a1fIR.stateKey).getState(state);
        const activeLinkMark = linkState === null || linkState === void 0 ? void 0 : linkState.activeLinkMark;
        // If range selection, we don't show hyperlink floating toolbar.
        // Text Formattting toolbar is shown instaed.
        if (state.selection instanceof (0, $cw0wu.TextSelection) && state.selection.to !== state.selection.from && (activeLinkMark === null || activeLinkMark === void 0 ? void 0 : activeLinkMark.type) === 'EDIT' && (0, $797yE.editorExperiment)('platform_editor_controls', 'variant1')) return;
        const { formatMessage: formatMessage } = intl;
        const editorCardActions = pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$c2 = pluginInjectionApi.card) === null || _pluginInjectionApi$c2 === void 0 ? void 0 : _pluginInjectionApi$c2.actions;
        const editorAnalyticsApi = pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$a = pluginInjectionApi.analytics) === null || _pluginInjectionApi$a === void 0 ? void 0 : _pluginInjectionApi$a.actions;
        const lpLinkPicker = options.lpLinkPicker ?? true;
        if (activeLinkMark) {
            const hyperLinkToolbar = {
                title: 'Hyperlink floating controls',
                nodeType: [
                    state.schema.nodes.text,
                    state.schema.nodes.paragraph,
                    state.schema.nodes.heading,
                    state.schema.nodes.taskItem,
                    state.schema.nodes.decisionItem,
                    state.schema.nodes.caption
                ].filter((nodeType)=>!!nodeType),
                // Use only the node types existing in the schema ED-6745
                align: 'left',
                className: activeLinkMark.type.match('INSERT|EDIT_INSERTED') ? 'hyperlink-floating-toolbar' : '',
                // getDomRef by default uses view.state.selection.from to position the toolbar.
                // However, when the user clicks in right after the link the view.state.selection.from references to the dom after the selection.
                // So instead we want to use the activeLinkMark.pos which has been calculated as the position before the click so that would be the link node
                getDomRef: activeLinkMark && (activeLinkMark.type === 'EDIT_INSERTED' || activeLinkMark.type === 'EDIT') && (0, $797yE.editorExperiment)('platform_editor_controls', 'variant1') ? (view)=>{
                    const domRef = (0, $gab48.findDomRefAtPos)(activeLinkMark.pos, view.domAtPos.bind(view));
                    return domRef instanceof HTMLElement ? domRef : undefined;
                } : undefined
            };
            switch(activeLinkMark.type){
                case 'EDIT':
                    {
                        var _pluginInjectionApi$c3;
                        const { pos: pos, node: node } = activeLinkMark;
                        const linkMark = node.marks.filter((mark)=>mark.type === state.schema.marks.link);
                        const link = linkMark[0] && linkMark[0].attrs.href;
                        const isValidUrl = (0, $7nI18.isSafeUrl)(link);
                        const labelOpenLink = formatMessage(isValidUrl ? (0, $8FY43.linkMessages).openLink : (0, $ejFiy.linkToolbarMessages).unableToOpenLink);
                        // TODO: ED-14403 - investigate why these are not translating?
                        const labelUnlink = formatMessage((0, $ejFiy.linkToolbarMessages).unlink);
                        const editLink = formatMessage((0, $ejFiy.linkToolbarMessages).editLink);
                        const metadata = {
                            url: link,
                            title: ''
                        };
                        if (activeLinkMark.node.text) metadata.title = activeLinkMark.node.text;
                        const areAnyNewToolbarFlagsEnabled = (0, $8qHhy.areToolbarFlagsEnabled)(Boolean(pluginInjectionApi === null || pluginInjectionApi === void 0 ? void 0 : pluginInjectionApi.toolbar));
                        const cardActions = pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$c3 = pluginInjectionApi.card) === null || _pluginInjectionApi$c3 === void 0 ? void 0 : _pluginInjectionApi$c3.actions;
                        const startingToolbarItems = (cardActions === null || cardActions === void 0 ? void 0 : cardActions.getStartingToolbarItems(intl, link, (0, $c8lUQ.editInsertedLink)(editorAnalyticsApi), metadata, areAnyNewToolbarFlagsEnabled ? state : undefined)) ?? [
                            {
                                id: 'editor.link.edit',
                                testId: 'editor.link.edit',
                                type: 'button',
                                onClick: (0, $c8lUQ.editInsertedLink)(editorAnalyticsApi),
                                title: editLink,
                                showTitle: areAnyNewToolbarFlagsEnabled ? false : true,
                                metadata: metadata,
                                icon: areAnyNewToolbarFlagsEnabled ? (0, (/*@__PURE__*/$parcel$interopDefault($5Uddy))) : undefined
                            },
                            {
                                type: 'separator'
                            }
                        ];
                        const openLinkButton = {
                            id: 'editor.link.openLink',
                            testId: 'editor.link.openLink',
                            type: 'button',
                            disabled: !isValidUrl,
                            target: '_blank',
                            href: isValidUrl ? link : undefined,
                            onClick: $7b6b701ed30d3cec$var$visitHyperlink(editorAnalyticsApi),
                            title: labelOpenLink,
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($92LrB))),
                            className: 'hyperlink-open-link',
                            metadata: metadata,
                            tabIndex: null
                        };
                        const unlinkButton = {
                            id: 'editor.link.unlink',
                            testId: 'editor.link.unlink',
                            type: 'button',
                            onClick: (0, $hGzMn.commandWithMetadata)((0, $c8lUQ.removeLink)(pos, editorAnalyticsApi), {
                                inputMethod: (0, $g6Qq4.INPUT_METHOD).FLOATING_TB
                            }),
                            title: labelUnlink,
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($1c4Ad))),
                            tabIndex: null
                        };
                        const items = [
                            ...startingToolbarItems,
                            ...areAnyNewToolbarFlagsEnabled ? [
                                unlinkButton,
                                {
                                    type: 'separator',
                                    fullHeight: true
                                },
                                openLinkButton,
                                {
                                    type: 'separator',
                                    fullHeight: true
                                }
                            ] : [
                                openLinkButton,
                                {
                                    type: 'separator'
                                },
                                unlinkButton,
                                {
                                    type: 'separator'
                                }
                            ],
                            {
                                type: 'copy-button',
                                items: [
                                    {
                                        state: state,
                                        formatMessage: formatMessage,
                                        markType: state.schema.marks.link
                                    }
                                ]
                            },
                            ...(cardActions === null || cardActions === void 0 ? void 0 : cardActions.getEndingToolbarItems(intl, link)) ?? []
                        ];
                        return {
                            ...hyperLinkToolbar,
                            height: 32,
                            width: 250,
                            items: items,
                            scrollable: true
                        };
                    }
                case 'EDIT_INSERTED':
                case 'INSERT':
                    {
                        var _options$linkPicker, _options$linkPicker2, _options$linkPicker3;
                        let link;
                        if ($7b6b701ed30d3cec$var$isEditLink(activeLinkMark) && activeLinkMark.node) {
                            const linkMark = activeLinkMark.node.marks.filter((mark)=>mark.type === state.schema.marks.link);
                            link = linkMark[0] && linkMark[0].attrs.href;
                        }
                        const displayText = $7b6b701ed30d3cec$var$isEditLink(activeLinkMark) ? $7b6b701ed30d3cec$var$getLinkText(activeLinkMark, state) : linkState.activeText;
                        const popupHeight = (options === null || options === void 0 || (_options$linkPicker = options.linkPicker) === null || _options$linkPicker === void 0 ? void 0 : _options$linkPicker.popupHeight) ?? (lpLinkPicker ? (0, $7Zwry.LINKPICKER_HEIGHT_IN_PX) : (0, $7Zwry.RECENT_SEARCH_HEIGHT_IN_PX));
                        const popupWidth = (options === null || options === void 0 || (_options$linkPicker2 = options.linkPicker) === null || _options$linkPicker2 === void 0 ? void 0 : _options$linkPicker2.popupWidth) ?? (!lpLinkPicker ? undefined : (0, $7Zwry.RECENT_SEARCH_WIDTH_IN_PX));
                        return {
                            ...hyperLinkToolbar,
                            preventPopupOverflow: true,
                            height: popupHeight,
                            width: popupWidth,
                            containerSurface: options === null || options === void 0 || (_options$linkPicker3 = options.linkPicker) === null || _options$linkPicker3 === void 0 ? void 0 : _options$linkPicker3.popupContainerSurface,
                            items: [
                                {
                                    type: 'custom',
                                    fallback: [],
                                    disableArrowNavigation: true,
                                    render: (view, idx)=>{
                                        if (!view) return null;
                                        const Toolbar = /*#__PURE__*/ (0, $dc70d.jsx)($7b6b701ed30d3cec$export$a46cebff622c3cae, {
                                            pluginInjectionApi: pluginInjectionApi,
                                            view: view,
                                            linkPickerOptions: options === null || options === void 0 ? void 0 : options.linkPicker,
                                            lpLinkPicker: lpLinkPicker,
                                            displayUrl: link,
                                            displayText: displayText || '',
                                            providerFactory: providerFactory,
                                            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                                            onCancel: ()=>view.focus(),
                                            onEscapeCallback: (0, $c8lUQ.onEscapeCallback)(editorCardActions),
                                            onClickAwayCallback: (0, $c8lUQ.onClickAwayCallback),
                                            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                                            onSubmit: (href, title = '', displayText, inputMethod, analytic, appearance)=>{
                                                var _toolbarKey$getState;
                                                const isEdit = $7b6b701ed30d3cec$var$isEditLink(activeLinkMark);
                                                const action = isEdit ? (0, $g6Qq4.ACTION).UPDATED : (0, $g6Qq4.ACTION).INSERTED;
                                                const skipAnalytics = ((_toolbarKey$getState = (0, $jltJY.toolbarKey).getState(state)) === null || _toolbarKey$getState === void 0 ? void 0 : _toolbarKey$getState.skipAnalytics) ?? false;
                                                const command = isEdit ? (0, $hGzMn.commandWithMetadata)((0, $c8lUQ.updateLink)(href, displayText || title, activeLinkMark.pos), {
                                                    action: action,
                                                    inputMethod: inputMethod,
                                                    sourceEvent: analytic
                                                }) : (0, $c8lUQ.insertLinkWithAnalytics)(inputMethod, activeLinkMark.from, activeLinkMark.to, href, editorCardActions, editorAnalyticsApi, title, displayText, skipAnalytics, analytic, appearance);
                                                command(view.state, view.dispatch, view);
                                                view.focus();
                                            }
                                        }, idx);
                                        return isToolbarAIFCEnabled ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $cp06f.UserIntentPopupWrapper), {
                                            api: pluginInjectionApi,
                                            children: Toolbar
                                        }) : Toolbar;
                                    }
                                }
                            ]
                        };
                    }
            }
        }
        return;
    };

});


parcelRegister("ayDEm", function(module, exports) {
$parcel$export(module.exports, "interactionPlugin", () => $1f96ba4055046cdb$export$f92f816359ce0a38);

var $2SKZf = parcelRequire("2SKZf");
const $1f96ba4055046cdb$export$f92f816359ce0a38 = ()=>{
    return {
        name: 'interaction',
        getSharedState (editorState) {
            var _key$getState;
            if (!editorState) return {
                interactionState: 'hasNotHadInteraction'
            };
            return {
                /**
         * Interaction state can either be null or 'hasNotHadInteraction'. We
         * are specifically only returning an explicit value for 'hasNotHadInteraction'
         * because behaviour should only change when the user has _not_ ineteracted
         * with the editor. The behaviour of when `hasHadInteraction` is true and
         * when the plugin is undefined should be the same.
         */ interactionState: (_key$getState = (0, $2SKZf.key).getState(editorState)) !== null && _key$getState !== void 0 && _key$getState.hasHadInteraction ? null : 'hasNotHadInteraction'
            };
        },
        commands: {
            handleInteraction: ({ tr: tr })=>{
                return tr.setMeta((0, $2SKZf.key), {
                    hasHadInteraction: true
                });
            }
        },
        pmPlugins () {
            return [
                {
                    name: 'interactionHandlerPlugin',
                    plugin: (0, $2SKZf.createPlugin)
                }
            ];
        }
    };
};

});
parcelRegister("2SKZf", function(module, exports) {
$parcel$export(module.exports, "key", () => $4506cf60c8304a48$export$df61b30b684217c0);
$parcel$export(module.exports, "createPlugin", () => $4506cf60c8304a48$export$ae829ec7b2625219);

var $f7Kk4 = parcelRequire("f7Kk4");

var $cw0wu = parcelRequire("cw0wu");
const $4506cf60c8304a48$export$df61b30b684217c0 = new (0, $cw0wu.PluginKey)('interactionPluginHandler');
const $4506cf60c8304a48$var$handleInteraction = (view)=>{
    const interactionState = $4506cf60c8304a48$export$df61b30b684217c0.getState(view.state);
    if (!(interactionState !== null && interactionState !== void 0 && interactionState.hasHadInteraction)) view.dispatch(view.state.tr.setMeta($4506cf60c8304a48$export$df61b30b684217c0, {
        hasHadInteraction: true
    }));
    return false;
};
const $4506cf60c8304a48$export$ae829ec7b2625219 = ()=>new (0, $f7Kk4.SafePlugin)({
        key: $4506cf60c8304a48$export$df61b30b684217c0,
        state: {
            init () {
                return {
                    hasHadInteraction: false
                };
            },
            apply (tr, oldPluginState) {
                const meta = tr.getMeta($4506cf60c8304a48$export$df61b30b684217c0);
                if (typeof meta === 'object') {
                    if (meta.hasHadInteraction !== oldPluginState.hasHadInteraction) return {
                        hasHadInteraction: meta.hasHadInteraction
                    };
                }
                return oldPluginState;
            }
        },
        props: {
            handleDOMEvents: {
                // Handle all pointer click events (includes drag inside editor)
                mousedown: $4506cf60c8304a48$var$handleInteraction,
                // Handle keyboard events. Must be keyup to handle tabbing into editor (keyup occurs
                // on the "next focused" element)
                keyup: $4506cf60c8304a48$var$handleInteraction,
                // Handle drag and drop _into_ the editor from outside. Eg image DnD
                drop: $4506cf60c8304a48$var$handleInteraction,
                focus: $4506cf60c8304a48$var$handleInteraction
            }
        }
    });

});


parcelRegister("zjMkD", function(module, exports) {
$parcel$export(module.exports, "pastePlugin", () => $a7c32bc4a5a2505c$export$2d7f4bd9c1268cd7);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $g2At6 = parcelRequire("g2At6");

var $7ZBKT = parcelRequire("7ZBKT");

var $3pcnU = parcelRequire("3pcnU");

var $1d0wU = parcelRequire("1d0wU");
const $a7c32bc4a5a2505c$export$2d7f4bd9c1268cd7 = ({ config: config, api: api })=>{
    var _api$featureFlags, _api$analytics;
    const { cardOptions: cardOptions, sanitizePrivateContent: sanitizePrivateContent, isFullPage: isFullPage, pasteWarningOptions: pasteWarningOptions, markdownToPmConverter: markdownToPmConverter } = config ?? {};
    const featureFlags = (api === null || api === void 0 || (_api$featureFlags = api.featureFlags) === null || _api$featureFlags === void 0 ? void 0 : _api$featureFlags.sharedState.currentState()) || {};
    const editorAnalyticsAPI = api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions;
    return {
        name: 'paste',
        pmPlugins () {
            return [
                {
                    name: 'paste',
                    plugin: ({ schema: schema, providerFactory: providerFactory, dispatchAnalyticsEvent: dispatchAnalyticsEvent, dispatch: dispatch, getIntl: getIntl })=>(0, $g2At6.createPlugin)(schema, dispatchAnalyticsEvent, dispatch, featureFlags, api, getIntl, cardOptions, sanitizePrivateContent, providerFactory, pasteWarningOptions, markdownToPmConverter)
                },
                {
                    name: 'moveAnalyticsPlugin',
                    plugin: ({ dispatch: dispatch })=>{
                        return isFullPage ? (0, $7ZBKT.createPlugin)(dispatch, editorAnalyticsAPI) : undefined;
                    }
                }
            ];
        },
        contentComponent: ()=>{
            if (!pasteWarningOptions) return null;
            return /*#__PURE__*/ (0, $dc70d.jsx)((0, $1d0wU.Flag), {
                api: api
            });
        },
        getSharedState: (editorState)=>{
            if (!editorState) return {
                activeFlag: null,
                lastContentPasted: null
            };
            const pluginState = (0, $3pcnU.pluginKey).getState(editorState);
            return {
                activeFlag: pluginState.activeFlag,
                lastContentPasted: pluginState.lastContentPasted
            };
        }
    };
};

});
parcelRegister("g2At6", function(module, exports) {
$parcel$export(module.exports, "createPlugin", () => $812e778d29243f32$export$ae829ec7b2625219);

var $7RHfd = parcelRequire("7RHfd");

var $g6Qq4 = parcelRequire("g6Qq4");

var $j0Og8 = parcelRequire("j0Og8");

var $dVt29 = parcelRequire("dVt29");

var $kky6V = parcelRequire("kky6V");

var $afHZ2 = parcelRequire("afHZ2");

var $bnbmo = parcelRequire("bnbmo");

var $aMbh4 = parcelRequire("aMbh4");

var $68s4D = parcelRequire("68s4D");

var $jqEKs = parcelRequire("jqEKs");

var $f7Kk4 = parcelRequire("f7Kk4");

var $7VlAB = parcelRequire("7VlAB");

var $8xbWC = parcelRequire("8xbWC");
var $aMfdo = parcelRequire("aMfdo");
var $58V7h = parcelRequire("58V7h");
var $hHEUY = parcelRequire("hHEUY");

var $94H8F = parcelRequire("94H8F");

var $die0H = parcelRequire("die0H");

var $4DF8z = parcelRequire("4DF8z");

var $eFkc5 = parcelRequire("eFkc5");

var $5eokt = parcelRequire("5eokt");

var $cWyqT = parcelRequire("cWyqT");

var $6Z6Le = parcelRequire("6Z6Le");

var $4ClnP = parcelRequire("4ClnP");

var $8BLsc = parcelRequire("8BLsc");

var $kW8qW = parcelRequire("kW8qW");

var $gab48 = parcelRequire("gab48");

var $jh23c = parcelRequire("jh23c");

var $ixSRH = parcelRequire("ixSRH");

var $2GUyw = parcelRequire("2GUyw");

var $3y2s4 = parcelRequire("3y2s4");

var $gdUUy = parcelRequire("gdUUy");

var $797yE = parcelRequire("797yE");

var $5N1Y4 = parcelRequire("5N1Y4");

var $4zjoa = parcelRequire("4zjoa");

var $dpcHd = parcelRequire("dpcHd");

var $5BPEN = parcelRequire("5BPEN");

var $dag7I = parcelRequire("dag7I");

var $lxt9h = parcelRequire("lxt9h");

var $aJlUO = parcelRequire("aJlUO");

var $lkqkP = parcelRequire("lkqkP");

var $3pcnU = parcelRequire("3pcnU");

var $ceK8a = parcelRequire("ceK8a");

var $3yvGB = parcelRequire("3yvGB");

var $aQyop = parcelRequire("aQyop");

var $5Zjfk = parcelRequire("5Zjfk");

var $kHGZD = parcelRequire("kHGZD");

var $1lYCt = parcelRequire("1lYCt");

var $amZZk = parcelRequire("amZZk");
const $812e778d29243f32$export$eedfdbc6a6bc1442 = (state)=>{
    const { blockquote: blockquote } = state.schema.nodes;
    return (0, $gab48.hasParentNodeOfType)(blockquote)(state.selection);
};
const $812e778d29243f32$var$enableNewDomainCheckToImproveSmartLinkResolveRate = (hostname)=>{
    return(// OneDrive Shortlinks
    hostname.endsWith('1drv.ms') || // MS Teams links
    hostname.endsWith('teams.live.com') || hostname.endsWith('teams.cloud.microsoft') || hostname.endsWith('teams.microsoft.com') || // MS Power BI
    hostname.endsWith('powerbi.com') || // MS Azure devops
    hostname.endsWith('dev.azure.com') || hostname.endsWith('visualstudio.com'));
};
const $812e778d29243f32$var$PASTE = 'Editor Paste Plugin Paste Duration';
function $812e778d29243f32$export$c503e2315ac846a7(url) {
    if (!url) return false;
    try {
        const urlObj = new URL(url);
        const hostname = urlObj.hostname.toLowerCase();
        const protocol = urlObj.protocol.toLowerCase();
        // Only accept HTTPS URLs for security
        if (protocol !== 'https:') return false;
        // Check if hostname ends with the trusted domains (not just contains them)
        return hostname.endsWith('sharepoint.com') || hostname.endsWith('onedrive.com') || hostname.endsWith('onedrive.live.com') || $812e778d29243f32$var$enableNewDomainCheckToImproveSmartLinkResolveRate(hostname);
    } catch  {
        // If URL parsing fails, return false for safety
        return false;
    }
}
function $812e778d29243f32$export$ae829ec7b2625219(schema, dispatchAnalyticsEvent, dispatch, featureFlags, pluginInjectionApi, getIntl, cardOptions, sanitizePrivateContent, providerFactory, pasteWarningOptions, markdownToPmConverter) {
    var _pluginInjectionApi$a;
    const editorAnalyticsAPI = pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$a = pluginInjectionApi.analytics) === null || _pluginInjectionApi$a === void 0 ? void 0 : _pluginInjectionApi$a.actions;
    const atlassianMarkDownParser = new (0, $8BLsc.MarkdownTransformer)(schema, (0, $68s4D.md));
    function getMarkdownSlice(text, openStart, openEnd) {
        if (markdownToPmConverter && (0, $3y2s4.isExperimentEnabled)('platform_editor_paste_as_md_use_gfm')) return (0, $aQyop.getMarkdownSliceViaGfm)(text, schema, openStart, openEnd, markdownToPmConverter, (0, $3y2s4.isExperimentEnabled)('platform_editor_gfm_link_paste_fix'));
        const escapedTextInput = (0, $ceK8a.escapeBackslashAndLinksExceptCodeBlock)(text);
        const doc = atlassianMarkDownParser.parse(escapedTextInput);
        if (doc && doc.content) return new (0, $kW8qW.Slice)(doc.content, openStart, openEnd);
        return;
    }
    let extensionAutoConverter;
    async function setExtensionAutoConverter(name, extensionProviderPromise) {
        if (name !== 'extensionProvider' || !extensionProviderPromise) return;
        try {
            extensionAutoConverter = await (0, $kky6V.getExtensionAutoConvertersFromProvider)(extensionProviderPromise);
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    }
    if (providerFactory) providerFactory.subscribe('extensionProvider', setExtensionAutoConverter);
    let mostRecentPasteEvent;
    let pastedFromBitBucket = false;
    return new (0, $f7Kk4.SafePlugin)({
        key: (0, $3pcnU.pluginKey),
        state: (0, $3pcnU.createPluginState)(dispatch, {
            activeFlag: null,
            pastedMacroPositions: {},
            lastContentPasted: null
        }),
        props: {
            // For serialising to plain text
            clipboardTextSerializer: (0, $lkqkP.createClipboardTextSerializer)(getIntl()),
            clipboardParser: (0, $aJlUO.createClipboardParser)(schema),
            handleDOMEvents: {
                // note
                paste: (view, event)=>{
                    mostRecentPasteEvent = event;
                    if (event.clipboardData) (0, $ixSRH.insm).startHeavyTask('paste');
                    return false;
                }
            },
            // note
            handlePaste (view, rawEvent, slice) {
                var _text, _schema$nodes, _schema$nodes2, _schema$nodes3, _schema$nodes4, _schema$nodes5, _schema$nodes6, _schema$nodes7, _pluginInjectionApi$m, _schema$nodes$table;
                const event = rawEvent;
                if (!event.clipboardData) return false;
                let text = event.clipboardData.getData('text/plain');
                const html = event.clipboardData.getData('text/html');
                const uriList = event.clipboardData.getData('text/uri-list');
                // Extract clientId values from pasted HTML for media cross-product copy/paste
                // This must be done before ProseMirror parses the HTML, as clientId is not stored in ADF
                if ((0, $gdUUy.fg)('platform_media_cross_client_copy_with_auth')) (0, $2GUyw.extractClientIdsFromHtml)(html);
                // Links copied from iOS Safari share button only have the text/uri-list data type
                // ProseMirror don't do anything with this type so we want to make our own open slice
                // with url as text content so link is pasted inline
                if (uriList && !text && !html) {
                    text = uriList;
                    slice = new (0, $kW8qW.Slice)((0, $kW8qW.Fragment).from(schema.text(text)), 1, 1);
                }
                if ((_text = text) !== null && _text !== void 0 && _text.includes('\r')) // Ignored via go/ees005
                // eslint-disable-next-line require-unicode-regexp
                text = text.replace(/\r/g, '');
                // Strip Legacy Content Macro (LCM) extensions on paste
                if (!(0, $gdUUy.fg)('platform_editor_legacy_content_macro_insert')) slice = (0, $4DF8z.transformSliceToRemoveLegacyContentMacro)(slice, schema);
                const isPastedFile = (0, $aMbh4.isPastedFile)(event);
                const isPlainText = text && !html;
                const isRichText = !!html;
                // Bail if copied content has files
                if (isPastedFile) {
                    if (!html) {
                        (0, $ixSRH.insm).endHeavyTask('paste');
                        /**
             * Microsoft Office, Number, Pages, etc. adds an image to clipboard
             * with other mime-types so we don't let the event reach media.
             * The detection ration here is that if the payload has both `html` and
             * `files`, then it could be one of above or an image copied from web.
             * Here, we don't have html, so we return true to allow default event behaviour
             */ return true;
                    }
                    /**
           * We want to return false for external copied image to allow
           * it to be uploaded by the client.
           *
           * Scenario where we are pasting an external image inside a block quote
           * is skipped and handled in handleRichText
           */ if ((0, $ceK8a.htmlContainsSingleFile)(html) && !$812e778d29243f32$export$eedfdbc6a6bc1442(view.state)) {
                        (0, $ixSRH.insm).endHeavyTask('paste');
                        return true;
                    }
                    /**
           * https://product-fabric.atlassian.net/browse/ED-21993
           * stopImmediatePropagation will run the first event attached to the same element
           * Which chould have race condition issue
           */ event.stopPropagation();
                }
                const { state: state } = view;
                const content = (0, $lxt9h.getContentNodeTypes)(slice.content);
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                const pasteId = (0, $7RHfd.default)();
                const measureName = `${$812e778d29243f32$var$PASTE}_${pasteId}`;
                (0, $jqEKs.measureRender)(measureName, ({ duration: duration, distortedDuration: distortedDuration })=>{
                    const payload = (0, $lxt9h.createPasteMeasurePayload)({
                        view: view,
                        duration: duration,
                        content: content,
                        distortedDuration: distortedDuration
                    });
                    if (payload) dispatchAnalyticsEvent(payload);
                    (0, $ixSRH.insm).endHeavyTask('paste');
                });
                const getLastReplaceStepSlice = (tr)=>{
                    let slice;
                    for (const step of tr.steps){
                        const stepSlice = (0, $5eokt.extractSliceFromStep)(step);
                        if (stepSlice) slice = stepSlice;
                    }
                    return slice;
                };
                // creating a custom dispatch because we want to add a meta whenever we do a paste.
                const dispatch = (tr)=>{
                    var _state$doc$resolve$no;
                    // https://product-fabric.atlassian.net/browse/ED-12633
                    // don't add closeHistory call if we're pasting a text inside placeholder text as we want the whole action
                    // to be atomic
                    const { placeholder: placeholder } = state.schema.nodes;
                    const isPastingTextInsidePlaceholderText = ((_state$doc$resolve$no = state.doc.resolve(state.selection.$anchor.pos).nodeAfter) === null || _state$doc$resolve$no === void 0 ? void 0 : _state$doc$resolve$no.type) === placeholder;
                    // Don't add closeHistory if we're pasting over layout columns, as we will appendTransaction
                    // to cleanup the layout's structure and we want to keep the paste and re-structuring as
                    // one event.
                    const isPastingOverLayoutColumns = (0, $gab48.hasParentNodeOfType)(state.schema.nodes.layoutColumn)(state.selection);
                    // don't add closeHistory call if we're pasting a table, as some tables may involve additional
                    // appendedTransactions to repair them (if they're partial or incomplete) and we don't want
                    // to split those repairing transactions in prosemirror-history when they're being added to the
                    // "done" stack
                    const isPastingTable = tr.steps.some((step)=>{
                        var _slice$content;
                        const slice = (0, $5eokt.extractSliceFromStep)(step);
                        let tableExists = false;
                        slice === null || slice === void 0 || (_slice$content = slice.content) === null || _slice$content === void 0 || _slice$content.forEach((node)=>{
                            if (node.type === state.schema.nodes.table) tableExists = true;
                        });
                        return tableExists;
                    });
                    // Don't flag as a paste event (add closeHistory) when the paste affects a list and
                    // the list plugin's appendTransaction will normalise the structure, and we want the
                    // paste + normalisation to be a single undo step.
                    // Pasting into an existing list — selection is inside a list node.
                    let isPastingIntoList = false;
                    // Pasting list content from an external source — slice top-level contains a list node.
                    let isPastingListContent = false;
                    const listNodeTypes = [
                        state.schema.nodes.bulletList,
                        state.schema.nodes.orderedList,
                        state.schema.nodes.taskList
                    ].filter((n)=>Boolean(n));
                    isPastingIntoList = (0, $gab48.hasParentNodeOfType)(listNodeTypes)(state.selection);
                    for(let i = 0; i < slice.content.childCount; i++)if (listNodeTypes.includes(slice.content.child(i).type)) {
                        isPastingListContent = true;
                        break;
                    }
                    if (!isPastingTextInsidePlaceholderText && !isPastingTable && !isPastingOverLayoutColumns && !isPastingIntoList && !isPastingListContent && pluginInjectionApi !== null && pluginInjectionApi !== void 0 && pluginInjectionApi.betterTypeHistory) {
                        var _pluginInjectionApi$b;
                        tr = pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$b = pluginInjectionApi.betterTypeHistory) === null || _pluginInjectionApi$b === void 0 ? void 0 : _pluginInjectionApi$b.actions.flagPasteEvent(tr);
                    }
                    if ((0, $4zjoa.expValEqualsNoExposure)('platform_editor_code_block_q4_lovability', 'isEnabled', true)) tr = (0, $kHGZD.normalizePastedCodeBlockAttrs)(tr, schema.nodes.codeBlock);
                    const isDocChanged = tr.docChanged;
                    (0, $dVt29.addLinkMetadata)(view.state.selection, tr, {
                        action: isPlainText ? (0, $g6Qq4.ACTION).PASTED_AS_PLAIN : (0, $g6Qq4.ACTION).PASTED,
                        inputMethod: (0, $g6Qq4.INPUT_METHOD).CLIPBOARD
                    });
                    // handleMacroAutoConvert dispatches twice
                    // we make sure to call paste options toolbar
                    // only for a valid paste action
                    if (isDocChanged) {
                        const pastedSlice = getLastReplaceStepSlice(tr);
                        if (pastedSlice) {
                            var _input;
                            const pasteStartPos = state.selection.from;
                            const pasteEndPos = tr.selection.to;
                            const contentPasted = {
                                pasteStartPos: pasteStartPos,
                                pasteEndPos: pasteEndPos,
                                text: text,
                                isShiftPressed: Boolean(// eslint-disable-next-line @typescript-eslint/no-explicit-any
                                view.shiftKey || ((_input = view.input) === null || _input === void 0 ? void 0 : _input.shiftKey)),
                                isPlainText: Boolean(isPlainText),
                                pastedSlice: pastedSlice,
                                pastedAt: Date.now(),
                                pasteSource: (0, $ceK8a.getPasteSource)(event),
                                sourcePastedSlice: slice
                            };
                            tr.setMeta((0, $3pcnU.pluginKey), {
                                type: (0, $dpcHd.PastePluginActionTypes).ON_PASTE,
                                contentPasted: contentPasted
                            });
                        }
                    }
                    // the handlePaste definition overrides the generic prosemirror behaviour which would previously
                    // include a uiEvent meta of paste. To align with the docs (https://prosemirror.net/docs/ref/#state.Transaction)
                    // This will re-add the uiEvent meta.
                    view.dispatch(tr.setMeta('uiEvent', 'paste'));
                };
                slice = (0, $5Zjfk.handleParagraphBlockMarks)(state, slice);
                if ((0, $5N1Y4.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true)) {
                    var _view$state$selection;
                    const destinationParentType = ((_view$state$selection = view.state.selection.$from.node(-1)) === null || _view$state$selection === void 0 ? void 0 : _view$state$selection.type.name) ?? view.state.doc.type.name;
                    slice = (0, $5Zjfk.applyContainerNodeTransformToSlice)(slice, schema, destinationParentType);
                }
                slice = (0, $3yvGB.handleVSCodeBlock)({
                    state: state,
                    slice: slice,
                    event: event,
                    text: text
                });
                slice = (0, $1lYCt.handleSyncBlocksPaste)(slice, schema, (0, $ceK8a.getPasteSource)(event), html, pasteWarningOptions, pluginInjectionApi);
                const plainTextPasteSlice = (0, $6Z6Le.linkifyContent)(state.schema)(slice);
                if ((0, $lxt9h.handlePasteAsPlainTextWithAnalytics)(editorAnalyticsAPI)(view, event, plainTextPasteSlice)(state, dispatch, view)) return true;
                if ((0, $lxt9h.handlePasteIntoCaptionWithAnalytics)(editorAnalyticsAPI)(view, event, slice, (0, $j0Og8.PasteTypes).richText)(state, dispatch)) // Create a custom handler to avoid handling with handleRichText method
                // As SafeInsert is used inside handleRichText which caused some bad UX like this:
                // https://product-fabric.atlassian.net/browse/MEX-1520
                // Converting caption to plain text needs to be handled before transformSliceForMedia
                // as createChecked will fail when trying to create a mediaSingle node with a caption
                // that is not plain text.
                return true;
                // transform slices based on destination
                slice = (0, $dag7I.transformSliceForMedia)(slice, schema, pluginInjectionApi)(state.selection);
                let markdownSlice;
                if (isPlainText) {
                    var _markdownSlice;
                    markdownSlice = getMarkdownSlice(text, slice.openStart, slice.openEnd);
                    // https://product-fabric.atlassian.net/browse/ED-15134
                    // Lists are not allowed within Blockquotes at this time. Attempting to
                    // paste a markdown list ie. ">- foo" will yeild a markdownSlice of size 0.
                    // Rather then blocking the paste action with no UI feedback, this will instead
                    // force a "paste as plain text" action by clearing the markdownSlice.
                    markdownSlice = !((_markdownSlice = markdownSlice) !== null && _markdownSlice !== void 0 && _markdownSlice.size) ? undefined : markdownSlice;
                    if (markdownSlice) {
                        var _pluginInjectionApi$c, _pluginInjectionApi$e;
                        // linkify text prior to converting to macro
                        if ((0, $lxt9h.handlePasteLinkOnSelectedTextWithAnalytics)(editorAnalyticsAPI)(view, event, markdownSlice, (0, $j0Og8.PasteTypes).markdown)(state, dispatch)) return true;
                        // run macro autoconvert prior to other conversions
                        if ((0, $5Zjfk.handleMacroAutoConvert)(text, markdownSlice, pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$c = pluginInjectionApi.card) === null || _pluginInjectionApi$c === void 0 || (_pluginInjectionApi$c = _pluginInjectionApi$c.actions) === null || _pluginInjectionApi$c === void 0 ? void 0 : _pluginInjectionApi$c.queueCardsFromChangedTr, pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$e = pluginInjectionApi.extension) === null || _pluginInjectionApi$e === void 0 || (_pluginInjectionApi$e = _pluginInjectionApi$e.actions) === null || _pluginInjectionApi$e === void 0 ? void 0 : _pluginInjectionApi$e.runMacroAutoConvert, cardOptions, extensionAutoConverter, editorAnalyticsAPI)(state, dispatch, view)) {
                            // TODO: ED-26959 - handleMacroAutoConvert dispatch twice, so we can't use the helper
                            (0, $lxt9h.sendPasteAnalyticsEvent)(editorAnalyticsAPI)(view, event, markdownSlice, {
                                type: (0, $j0Og8.PasteTypes).markdown
                            });
                            return true;
                        }
                    }
                }
                slice = (0, $ceK8a.transformUnsupportedBlockCardToInline)(slice, state, cardOptions);
                // Handles edge case so that when copying text from the top level of the document
                // it can be pasted into nodes like panels/actions/decisions without removing them.
                // Overriding openStart to be 1 when only pasting a paragraph makes the preferred
                // depth favour the text, rather than the paragraph node.
                // https://github.com/ProseMirror/prosemirror-transform/blob/master/src/replace.js#:~:text=Transform.prototype.-,replaceRange,-%3D%20function(from%2C%20to
                const selectionDepth = state.selection.$head.depth;
                const selectionParentNode = state.selection.$head.node(selectionDepth - 1);
                const selectionParentType = selectionParentNode === null || selectionParentNode === void 0 ? void 0 : selectionParentNode.type;
                // panel_c1 is a schema variant of panel (table-in-panel); when the experiment is on,
                // handle it the same way as a panel.
                const edgeCaseNodeTypes = (0, $5N1Y4.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? [
                    (_schema$nodes = schema.nodes) === null || _schema$nodes === void 0 ? void 0 : _schema$nodes.panel,
                    (_schema$nodes2 = schema.nodes) === null || _schema$nodes2 === void 0 ? void 0 : _schema$nodes2.panel_c1,
                    (_schema$nodes3 = schema.nodes) === null || _schema$nodes3 === void 0 ? void 0 : _schema$nodes3.taskList,
                    (_schema$nodes4 = schema.nodes) === null || _schema$nodes4 === void 0 ? void 0 : _schema$nodes4.decisionList
                ] : [
                    (_schema$nodes5 = schema.nodes) === null || _schema$nodes5 === void 0 ? void 0 : _schema$nodes5.panel,
                    (_schema$nodes6 = schema.nodes) === null || _schema$nodes6 === void 0 ? void 0 : _schema$nodes6.taskList,
                    (_schema$nodes7 = schema.nodes) === null || _schema$nodes7 === void 0 ? void 0 : _schema$nodes7.decisionList
                ];
                if (slice.openStart === 0 && slice.openEnd !== 1 && selectionParentNode && edgeCaseNodeTypes.includes(selectionParentType)) // @ts-ignore - [unblock prosemirror bump] assigning to readonly prop
                slice.openStart = 1;
                // If we're in a code block, append the text contents of clipboard inside it
                if ((0, $lxt9h.handleCodeBlockWithAnalytics)(editorAnalyticsAPI)(view, event, slice, text)(state, dispatch)) return true;
                if ((0, $lxt9h.handleMediaSingleWithAnalytics)(editorAnalyticsAPI)(view, event, slice, isPastedFile ? (0, $j0Og8.PasteTypes).binary : (0, $j0Og8.PasteTypes).richText, pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$m = pluginInjectionApi.media) === null || _pluginInjectionApi$m === void 0 ? void 0 : _pluginInjectionApi$m.actions.insertMediaAsMediaSingle)(state, dispatch, view)) return true;
                if ((0, $lxt9h.handleSelectedTableWithAnalytics)(editorAnalyticsAPI)(view, event, slice)(state, dispatch)) return true;
                let isNestedMarkdownTable = false;
                // if paste a markdown table inside a table cell, we should treat it as a table slice
                const isParentNodeTdOrTh = selectionParentType === schema.nodes.tableCell || selectionParentType === schema.nodes.tableHeader;
                isNestedMarkdownTable = !!(markdownSlice && isPlainText && isParentNodeTdOrTh && (0, $lxt9h.getContentNodeTypes)(markdownSlice.content).includes((_schema$nodes$table = schema.nodes.table) === null || _schema$nodes$table === void 0 ? void 0 : _schema$nodes$table.name));
                slice = isNestedMarkdownTable ? markdownSlice : slice;
                // get editor-tables to handle pasting tables if it can
                // otherwise, just the replace the selection with the content
                if ((0, $jh23c.handlePaste)(view, event, slice, {
                    pasteSource: (0, $ceK8a.getPasteSource)(event)
                })) {
                    (0, $lxt9h.sendPasteAnalyticsEvent)(editorAnalyticsAPI)(view, event, slice, {
                        type: (0, $j0Og8.PasteTypes).richText
                    });
                    return true;
                }
                // handle paste of nested tables to ensure nesting limits are respected
                if ((0, $lxt9h.handleNestedTablePasteWithAnalytics)(editorAnalyticsAPI, (0, $bnbmo.isNestedTablesSupported)(state.schema))(view, event, slice)(state, dispatch)) return true;
                if ((0, $lxt9h.handlePasteIntoTaskAndDecisionWithAnalytics)(view, event, slice, isPlainText ? (0, $j0Og8.PasteTypes).plain : (0, $j0Og8.PasteTypes).richText, pluginInjectionApi)(state, dispatch)) return true;
                // If the clipboard only contains plain text, attempt to parse it as Markdown
                if (isPlainText && markdownSlice && !isNestedMarkdownTable) {
                    if ((0, $lxt9h.handlePastePreservingMarksWithAnalytics)(view, event, markdownSlice, (0, $j0Og8.PasteTypes).markdown, pluginInjectionApi)(state, dispatch)) return true;
                    return (0, $lxt9h.handleMarkdownWithAnalytics)(view, event, markdownSlice, pluginInjectionApi)(state, dispatch);
                }
                if (isRichText && $812e778d29243f32$export$eedfdbc6a6bc1442(state)) {
                    //If pasting inside blockquote
                    //Skip the blockquote node and keep remaining nodes as they are
                    //prevent doing this if there is list inside blockquote as the list is pasted incorrectly inside blockquote due to wrong openStart and openEnd
                    const { blockquote: blockquote } = schema.nodes;
                    const children = [];
                    (0, $4ClnP.mapChildren)(slice.content, (node)=>{
                        if (node.type === blockquote && !(0, $gab48.contains)(node, state.schema.nodes.listItem)) for(let i = 0; i < node.childCount; i++)children.push(node.child(i));
                        else children.push(node);
                    });
                    slice = new (0, $kW8qW.Slice)((0, $kW8qW.Fragment).fromArray(children), slice.openStart, slice.openEnd);
                }
                // finally, handle rich-text copy-paste
                if (isRichText || isNestedMarkdownTable) {
                    var _pluginInjectionApi$c2, _pluginInjectionApi$e2, _pluginInjectionApi$l;
                    // linkify the text where possible
                    slice = (0, $6Z6Le.linkifyContent)(state.schema)(slice);
                    if ((0, $lxt9h.handlePasteLinkOnSelectedTextWithAnalytics)(editorAnalyticsAPI)(view, event, slice, (0, $j0Og8.PasteTypes).richText)(state, dispatch)) return true;
                    // run macro autoconvert prior to other conversions
                    if ((0, $5Zjfk.handleMacroAutoConvert)(text, slice, pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$c2 = pluginInjectionApi.card) === null || _pluginInjectionApi$c2 === void 0 || (_pluginInjectionApi$c2 = _pluginInjectionApi$c2.actions) === null || _pluginInjectionApi$c2 === void 0 ? void 0 : _pluginInjectionApi$c2.queueCardsFromChangedTr, pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$e2 = pluginInjectionApi.extension) === null || _pluginInjectionApi$e2 === void 0 || (_pluginInjectionApi$e2 = _pluginInjectionApi$e2.actions) === null || _pluginInjectionApi$e2 === void 0 ? void 0 : _pluginInjectionApi$e2.runMacroAutoConvert, cardOptions, extensionAutoConverter, editorAnalyticsAPI)(state, dispatch, view)) {
                        // TODO: ED-26959 - handleMacroAutoConvert dispatch twice, so we can't use the helper
                        (0, $lxt9h.sendPasteAnalyticsEvent)(editorAnalyticsAPI)(view, event, slice, {
                            type: (0, $j0Og8.PasteTypes).richText
                        });
                        return true;
                    }
                    // Special handling for SharePoint URLs generated from Share button
                    // eslint-disable-next-line @atlaskit/platform/no-preconditioning
                    if ($812e778d29243f32$export$c503e2315ac846a7(text) && ((0, $gdUUy.fg)('platform_editor_sharepoint_url_smart_card_fallback') || (0, $gdUUy.fg)('platform_editor_sharepoint_url_smart_card_jira'))) {
                        // Create an inline card directly for SharePoint URLs to show the "Connect" button
                        const inlineCardNode = schema.nodes.inlineCard.create({
                            url: text
                        });
                        const cardSlice = new (0, $kW8qW.Slice)((0, $kW8qW.Fragment).from(inlineCardNode), 0, 0);
                        if (dispatch) dispatch(state.tr.replaceSelection(cardSlice));
                        return true;
                    }
                    // handle the case when copy content from a table cell inside bodied extension
                    if ((0, $5Zjfk.handleTableContentPasteInBodiedExtension)(slice)(state, dispatch)) return true;
                    // remove annotation marks from the pasted data if they are not present in the document
                    // for the cases when they are pasted from external pages
                    if (slice.content.size && (0, $cWyqT.containsAnyAnnotations)(slice, state)) {
                        var _pluginInjectionApi$a2;
                        pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$a2 = pluginInjectionApi.annotation) === null || _pluginInjectionApi$a2 === void 0 || _pluginInjectionApi$a2.actions.stripNonExistingAnnotations(slice, state);
                    }
                    if ((0, $lxt9h.handlePastePreservingMarksWithAnalytics)(view, event, slice, (0, $j0Og8.PasteTypes).richText, pluginInjectionApi)(state, dispatch)) return true;
                    // Check that we are pasting in a location that does not accept
                    // breakout marks, if so we strip the mark and paste. Note that
                    // breakout marks are only valid in the root document.
                    if (selectionParentType !== state.schema.nodes.doc && // When pasting at a root GapCursor, selection depth is 0 and there is no
                    // parent node to resolve. Treat it as doc-level so valid breakout marks stay.
                    selectionDepth !== 0) {
                        const sliceCopy = (0, $kW8qW.Slice).fromJSON(state.schema, slice.toJSON() || {});
                        sliceCopy.content.descendants((node)=>{
                            // @ts-ignore - [unblock prosemirror bump] assigning to readonly prop
                            node.marks = node.marks.filter((mark)=>mark.type.name !== 'breakout');
                            // as breakout marks should only be on top level nodes,
                            // we don't traverse the entire document
                            return false;
                        });
                        slice = sliceCopy;
                    }
                    if ((0, $lxt9h.handleExpandWithAnalytics)(editorAnalyticsAPI)(view, event, slice)(state, dispatch)) return true;
                    if (!(0, $afHZ2.insideTable)(state)) slice = (0, $58V7h.transformSliceNestedExpandToExpand)(slice, state.schema);
                    if ((0, $lxt9h.handlePastePanelOrDecisionIntoListWithAnalytics)(editorAnalyticsAPI)(view, event, slice, pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$l = pluginInjectionApi.list) === null || _pluginInjectionApi$l === void 0 ? void 0 : _pluginInjectionApi$l.actions.findRootParentListNode)(state, dispatch)) return true;
                    if ((0, $lxt9h.handlePasteNonNestableBlockNodesIntoListWithAnalytics)(editorAnalyticsAPI)(view, event, slice)(state, dispatch)) return true;
                    return (0, $lxt9h.handleRichTextWithAnalytics)(view, event, slice, pluginInjectionApi)(state, dispatch);
                }
                return false;
            },
            transformPasted (slice) {
                var _pluginInjectionApi$e3;
                if (sanitizePrivateContent) slice = (0, $5Zjfk.handleMention)(slice, schema);
                /* Bitbucket copies diffs as multiple adjacent code blocks
         * so we merge ALL adjacent code blocks to support paste here */ if (pastedFromBitBucket) slice = (0, $94H8F.transformSliceToJoinAdjacentCodeBlocks)(slice);
                // Filter out expand nodes if allowExpand is false
                if (!(pluginInjectionApi !== null && pluginInjectionApi !== void 0 && (_pluginInjectionApi$e3 = pluginInjectionApi.expand) !== null && _pluginInjectionApi$e3 !== void 0 && (_pluginInjectionApi$e3 = _pluginInjectionApi$e3.sharedState) !== null && _pluginInjectionApi$e3 !== void 0 && (_pluginInjectionApi$e3 = _pluginInjectionApi$e3.currentState()) !== null && _pluginInjectionApi$e3 !== void 0 && _pluginInjectionApi$e3.allowInsertion)) slice = (0, $5Zjfk.handlePasteExpand)(slice);
                slice = (0, $aMfdo.transformSingleLineCodeBlockToCodeMark)(slice, schema);
                slice = (0, $dag7I.transformSliceToCorrectMediaWrapper)(slice, schema);
                slice = (0, $dag7I.transformSliceToMediaSingleWithNewExperience)(slice, schema, pluginInjectionApi);
                slice = (0, $die0H.transformSliceToDecisionList)(slice, schema);
                // splitting linebreaks into paragraphs must happen before upgrading text to lists
                slice = (0, $5BPEN.splitParagraphs)(slice, schema);
                slice = (0, $5BPEN.upgradeTextToLists)(slice, schema);
                // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                if (slice.content.childCount && slice.content.lastChild.type === schema.nodes.codeBlock) slice = new (0, $kW8qW.Slice)(slice.content, 0, 0);
                if (!(0, $797yE.editorExperiment)('single_column_layouts', true)) slice = (0, $8xbWC.transformSingleColumnLayout)(slice, schema);
                slice = (0, $hHEUY.transformSliceToRemoveMacroId)(slice, schema);
                return slice;
            },
            transformPastedHTML (html) {
                // Fix for issue ED-4438
                // text from google docs should not be pasted as inline code
                if (html.indexOf('id="docs-internal-guid-') >= 0) {
                    // Ignored via go/ees005
                    // eslint-disable-next-line require-unicode-regexp
                    html = html.replace(/white-space:pre/g, '');
                    // Ignored via go/ees005
                    // eslint-disable-next-line require-unicode-regexp
                    html = html.replace(/white-space:pre-wrap/g, '');
                }
                // Partial fix for ED-7331: During a copy/paste from the legacy tinyMCE
                // confluence editor, if we encounter an incomplete table (e.g. table elements
                // not wrapped in <table>), we try to rebuild a complete, valid table if possible.
                if (mostRecentPasteEvent && (0, $amZZk.isPastedFromTinyMCEConfluence)(mostRecentPasteEvent, html) && (0, $amZZk.htmlHasIncompleteTable)(html)) {
                    const completeTableHtml = (0, $amZZk.tryRebuildCompleteTableHtml)(html);
                    if (completeTableHtml) html = completeTableHtml;
                }
                if (!(0, $ceK8a.isPastedFromWord)(html) && !(0, $ceK8a.isPastedFromExcel)(html) && html.indexOf('<img ') >= 0) html = (0, $dag7I.unwrapNestedMediaElements)(html);
                // https://product-fabric.atlassian.net/browse/ED-11714
                // Checking for edge case when copying a list item containing links from Notion
                // The html from this case is invalid with duplicate nested links
                if ((0, $ceK8a.htmlHasInvalidLinkTags)(html)) html = (0, $ceK8a.removeDuplicateInvalidLinks)(html);
                // Fix for ED-13568: Code blocks being copied/pasted when next to each other get merged
                pastedFromBitBucket = html.indexOf('data-qa="code-line"') >= 0;
                // Remove breakout marks HTML around sync block renderer nodes
                // so the breakout mark doesn't get applied to the wrong nodes
                if (html.indexOf((0, $7VlAB.SyncBlockRendererDataAttributeName)) >= 0) html = (0, $eFkc5.removeBreakoutFromRendererSyncBlockHTML)(html);
                // When platform_editor_nest_table_in_panel is OFF,
                // move tables out of panel divs in the HTML before ProseMirror
                // parses it — otherwise the panel schema drops the table content.
                if (!(0, $5N1Y4.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true)) html = (0, $5Zjfk.splitTablesOutOfPanelHtml)(html);
                mostRecentPasteEvent = null;
                return html;
            }
        }
    });
}

});
parcelRegister("8xbWC", function(module, exports) {
$parcel$export(module.exports, "transformSingleColumnLayout", () => $85b9dfcbc55cf590$export$ca45027befc3fad2);

var $kW8qW = parcelRequire("kW8qW");
const $85b9dfcbc55cf590$export$ca45027befc3fad2 = (slice, schema)=>{
    if (slice.content.childCount === 1 && slice.openStart === 0 && slice.openEnd === 0) {
        var _slice$content$firstC, _slice$content$firstC2, _slice$content$firstC3;
        if (((_slice$content$firstC = slice.content.firstChild) === null || _slice$content$firstC === void 0 ? void 0 : _slice$content$firstC.type) === schema.nodes.layoutColumn) {
            const newSlice = new (0, $kW8qW.Slice)(slice.content.firstChild.content, 0, 0);
            return newSlice;
        } else if (((_slice$content$firstC2 = slice.content.firstChild) === null || _slice$content$firstC2 === void 0 ? void 0 : _slice$content$firstC2.type) === schema.nodes.layoutSection && slice.content.firstChild.childCount === 1 && ((_slice$content$firstC3 = slice.content.firstChild.firstChild) === null || _slice$content$firstC3 === void 0 ? void 0 : _slice$content$firstC3.type) === schema.nodes.layoutColumn) {
            const newSlice = new (0, $kW8qW.Slice)(slice.content.firstChild.firstChild.content, 0, 0);
            return newSlice;
        }
    }
    return slice;
};

});

parcelRegister("aMfdo", function(module, exports) {
$parcel$export(module.exports, "transformSingleLineCodeBlockToCodeMark", () => $18151b8c99dab962$export$d1dc8019f50dded8);

var $kW8qW = parcelRequire("kW8qW");
const $18151b8c99dab962$export$d1dc8019f50dded8 = (slice, schema)=>{
    if (slice.content.childCount === 1 && (slice.openStart || slice.openEnd)) {
        const maybeCodeBlock = slice.content.firstChild;
        if (maybeCodeBlock && maybeCodeBlock.type === schema.nodes.codeBlock) {
            if (maybeCodeBlock.textContent && maybeCodeBlock.textContent.indexOf('\n') === -1) return new (0, $kW8qW.Slice)((0, $kW8qW.Fragment).from(schema.text(maybeCodeBlock.textContent, [
                schema.marks.code.create()
            ])), 0, 0);
        }
    }
    return slice;
};

});

parcelRegister("hHEUY", function(module, exports) {
$parcel$export(module.exports, "transformSliceToRemoveMacroId", () => $fcc3f28ff163f3f2$export$c20bd22f1bffad40);

var $4ClnP = parcelRequire("4ClnP");
const $fcc3f28ff163f3f2$export$c20bd22f1bffad40 = (slice, schema)=>{
    const { extension: extension, inlineExtension: inlineExtension } = schema.nodes;
    return (0, $4ClnP.mapSlice)(slice, (node)=>{
        var _node$attrs$parameter;
        if ([
            extension,
            inlineExtension
        ].includes(node.type) && typeof ((_node$attrs$parameter = node.attrs.parameters) === null || _node$attrs$parameter === void 0 || (_node$attrs$parameter = _node$attrs$parameter.macroMetadata) === null || _node$attrs$parameter === void 0 || (_node$attrs$parameter = _node$attrs$parameter.macroId) === null || _node$attrs$parameter === void 0 ? void 0 : _node$attrs$parameter.value) !== 'undefined') // Strip the macroId. While pasting on the same page, macroId does not change until the page
        // is published and causes collision with the existing macroId where switching tabs of one
        // node changes the tabs for the other node
        delete node.attrs.parameters.macroMetadata.macroId;
        return node;
    });
};

});

parcelRegister("94H8F", function(module, exports) {
$parcel$export(module.exports, "transformSliceToJoinAdjacentCodeBlocks", () => $427d4c621ba38724$export$5a682e48ed34e262);

var $kW8qW = parcelRequire("kW8qW");

var $4ClnP = parcelRequire("4ClnP");


function $427d4c621ba38724$var$joinCodeBlocks(left, right) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const textContext = `${left.textContent}\n${right.textContent}`;
    return left.type.create(left.attrs, left.type.schema.text(textContext));
}
function $427d4c621ba38724$var$mergeAdjacentCodeBlocks(fragment) {
    const children = [];
    fragment.forEach((maybeCodeBlock)=>{
        if (maybeCodeBlock.type === maybeCodeBlock.type.schema.nodes.codeBlock) {
            const peekAtPrevious = children[children.length - 1];
            if (peekAtPrevious && peekAtPrevious.type === maybeCodeBlock.type) // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            return children.push($427d4c621ba38724$var$joinCodeBlocks(children.pop(), maybeCodeBlock));
        }
        return children.push(maybeCodeBlock);
    });
    return (0, $kW8qW.Fragment).from(children);
}
function $427d4c621ba38724$export$5a682e48ed34e262(slice) {
    slice = (0, $4ClnP.mapSlice)(slice, (node)=>{
        return node.isBlock && !node.isTextblock ? node.copy($427d4c621ba38724$var$mergeAdjacentCodeBlocks(node.content)) : node;
    });
    // mapSlice won't be able to merge adjacent top-level code-blocks
    return new (0, $kW8qW.Slice)($427d4c621ba38724$var$mergeAdjacentCodeBlocks(slice.content), slice.openStart, slice.openEnd);
}

});

parcelRegister("die0H", function(module, exports) {
$parcel$export(module.exports, "transformSliceToDecisionList", () => $d3987cf1efd3cf1e$export$65d21b4bef5d424b);

var $kW8qW = parcelRequire("kW8qW");
const $d3987cf1efd3cf1e$export$65d21b4bef5d424b = (slice, schema)=>{
    const node = slice.content.firstChild;
    if (slice.content.childCount === 1 && node && node.type.name === 'decisionItem') {
        const decisionListWrapperNode = schema.nodes.decisionList.create({}, node);
        return new (0, $kW8qW.Slice)((0, $kW8qW.Fragment).from(decisionListWrapperNode), slice.openStart, slice.openEnd);
    }
    return slice;
};

});

parcelRegister("eFkc5", function(module, exports) {
$parcel$export(module.exports, "removeBreakoutFromRendererSyncBlockHTML", () => $3e41433fafcc6d3c$export$2dccb54a894dbcd3);

var $kBP5h = parcelRequire("kBP5h");

var $7VlAB = parcelRequire("7VlAB");
const $3e41433fafcc6d3c$export$2dccb54a894dbcd3 = (html)=>{
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    doc.querySelectorAll(`div.${(0, $kBP5h.BreakoutCssClassName).BREAKOUT_MARK}`).forEach((breakoutDiv)=>{
        // Check if this breakout div directly contains a renderer sync block
        const rendererDiv = breakoutDiv.querySelector(`:scope > div[${(0, $7VlAB.SyncBlockRendererDataAttributeName)}]`);
        if (rendererDiv) breakoutDiv.replaceWith(rendererDiv);
    });
    return doc.body.innerHTML;
};

});

parcelRegister("dpcHd", function(module, exports) {
$parcel$export(module.exports, "PastePluginActionTypes", () => $0b01960cc1f94c1e$export$ad3c0356f902fd97);
var $0b01960cc1f94c1e$export$ad3c0356f902fd97 = /*#__PURE__*/ function(PastePluginActionTypes) {
    PastePluginActionTypes["START_TRACKING_PASTED_MACRO_POSITIONS"] = "START_TRACKING_PASTED_MACRO_POSITIONS";
    PastePluginActionTypes["STOP_TRACKING_PASTED_MACRO_POSITIONS"] = "STOP_TRACKING_PASTED_MACRO_POSITIONS";
    PastePluginActionTypes["ON_PASTE"] = "ON_PASTE";
    PastePluginActionTypes["SET_ACTIVE_FLAG"] = "SET_ACTIVE_FLAG";
    return PastePluginActionTypes;
}({});

});

parcelRegister("5BPEN", function(module, exports) {
$parcel$export(module.exports, "startTrackingPastedMacroPositions", () => $75a3e2f5c04aa833$export$4a47d257a3fdbe1c);
$parcel$export(module.exports, "stopTrackingPastedMacroPositions", () => $75a3e2f5c04aa833$export$68f98dcea8e59d59);
$parcel$export(module.exports, "upgradeTextToLists", () => $75a3e2f5c04aa833$export$df231bdf1595dd19);
$parcel$export(module.exports, "splitParagraphs", () => $75a3e2f5c04aa833$export$f2dc3112f5c2bd10);

var $iE5F1 = parcelRequire("iE5F1");

var $4ClnP = parcelRequire("4ClnP");

var $5FzRL = parcelRequire("5FzRL");

var $kW8qW = parcelRequire("kW8qW");

var $cw0wu = parcelRequire("cw0wu");

var $dpcHd = parcelRequire("dpcHd");

var $3pcnU = parcelRequire("3pcnU");
const $75a3e2f5c04aa833$export$4a47d257a3fdbe1c = (pastedMacroPositions)=>(0, $3pcnU.createCommand)(()=>{
        return {
            type: (0, $dpcHd.PastePluginActionTypes).START_TRACKING_PASTED_MACRO_POSITIONS,
            pastedMacroPositions: pastedMacroPositions
        };
    });
const $75a3e2f5c04aa833$export$68f98dcea8e59d59 = (pastedMacroPositionKeys)=>(0, $3pcnU.createCommand)(()=>{
        return {
            type: (0, $dpcHd.PastePluginActionTypes).STOP_TRACKING_PASTED_MACRO_POSITIONS,
            pastedMacroPositionKeys: pastedMacroPositionKeys
        };
    });
// matchers for text lists
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $75a3e2f5c04aa833$var$bullets = /^\s*[\*\-\u2022](\s+|\s+$)/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $75a3e2f5c04aa833$var$numbers = /^\s*\d[\.\)](\s+|$)/;
const $75a3e2f5c04aa833$var$isListItem = (node, schema)=>{
    return Boolean(node && node.type === schema.nodes.listItem);
};
const $75a3e2f5c04aa833$var$getListType = (node, schema)=>{
    if (!node || !node.text) return null;
    const { bulletList: bulletList, orderedList: orderedList } = schema.nodes;
    return [
        {
            node: bulletList,
            matcher: $75a3e2f5c04aa833$var$bullets
        },
        {
            node: orderedList,
            matcher: $75a3e2f5c04aa833$var$numbers
        }
    ].reduce((lastMatch, listType)=>{
        if (lastMatch) return lastMatch;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const match = node.text.match(listType.matcher);
        return match ? [
            listType.node,
            match[0].length
        ] : lastMatch;
    }, null);
};
const $75a3e2f5c04aa833$export$252a79c29aea3669 = (content, schema)=>{
    const wrapperContent = [];
    let nextContent = [];
    content.forEach((node)=>{
        if (node.type === schema.nodes.hardBreak) {
            if (nextContent.length !== 0) wrapperContent.push(nextContent);
            nextContent = [
                node
            ];
        } else nextContent.push(node);
    });
    wrapperContent.push(nextContent);
    return wrapperContent;
};
const $75a3e2f5c04aa833$export$5bfe14e0df30e39c = (node, parent, schema)=>{
    const content = (0, $4ClnP.mapChildren)(node.content, (node)=>node);
    const linesSplitByHardbreaks = $75a3e2f5c04aa833$export$252a79c29aea3669(content, schema);
    const { paragraph: paragraph, hardBreak: hardBreak, listItem: listItem, orderedList: orderedList } = schema.nodes;
    const splitListsAndParagraphs = [];
    let paragraphParts = [];
    // Ignored via go/ees005
    // eslint-disable-next-line no-var
    for(var index = 0; index < linesSplitByHardbreaks.length; index = index + 1){
        var _firstNonHardBreakNod;
        const line = linesSplitByHardbreaks[index];
        let listMatch;
        if (index === 0) {
            var _line$;
            if (((_line$ = line[0]) === null || _line$ === void 0 ? void 0 : _line$.type) === hardBreak) {
                paragraphParts.push(line);
                continue;
            } else // the first line the potential list item is at postion 0
            listMatch = $75a3e2f5c04aa833$var$getListType(line[0], schema);
        } else {
            // lines after the first the potential list item is at postion 1
            if (line.length === 1) {
                // if the line only has a line break return as is
                paragraphParts.push(line);
                continue;
            }
            listMatch = $75a3e2f5c04aa833$var$getListType(line[1], schema);
        }
        if (!listMatch || // CONFCLOUD-79708: If we are inside a list - let's not try to upgrade list as it resolves
        // to invalid content
        $75a3e2f5c04aa833$var$isListItem(parent, schema)) {
            // if there is not list match return as is
            paragraphParts.push(line);
            continue;
        }
        const [nodeType, length] = listMatch;
        const firstNonHardBreakNode = line.find((node)=>node.type !== hardBreak);
        const chunksWithoutLeadingHardBreaks = line.slice(line.findIndex((node)=>node.type !== hardBreak));
        // retain text after bullet or number-dot e.g. 1. Hello
        const startingText = firstNonHardBreakNode === null || firstNonHardBreakNode === void 0 || (_firstNonHardBreakNod = firstNonHardBreakNode.text) === null || _firstNonHardBreakNod === void 0 ? void 0 : _firstNonHardBreakNod.substr(length);
        const restOfChunk = startingText ? // apply transformation to first entry
        [
            schema.text(startingText, firstNonHardBreakNode === null || firstNonHardBreakNode === void 0 ? void 0 : firstNonHardBreakNode.marks),
            ...chunksWithoutLeadingHardBreaks.slice(1)
        ] : chunksWithoutLeadingHardBreaks.slice(1);
        // convert to list
        const listItemNode = listItem === null || listItem === void 0 ? void 0 : listItem.createAndFill(undefined, paragraph.createChecked(undefined, restOfChunk));
        if (!listItemNode) {
            paragraphParts.push(line);
            continue;
        }
        const attrs = nodeType === orderedList ? {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
            order: parseInt(firstNonHardBreakNode.text.split('.')[0])
        } : undefined;
        const newList = nodeType.createChecked(attrs, [
            listItemNode
        ]);
        if (paragraphParts.length !== 0 && paragraph.validContent((0, $kW8qW.Fragment).from(paragraphParts.flat()))) {
            splitListsAndParagraphs.push(paragraph.createAndFill(node.attrs, paragraphParts.flat(), node.marks));
            paragraphParts = [];
        }
        splitListsAndParagraphs.push(newList);
    }
    if (paragraphParts.length !== 0 && paragraph.validContent((0, $kW8qW.Fragment).from(paragraphParts.flat()))) splitListsAndParagraphs.push(schema.nodes.paragraph.createAndFill(node.attrs, paragraphParts.flat(), node.marks));
    const result = splitListsAndParagraphs.flat();
    // try to join
    const mockState = (0, $cw0wu.EditorState).create({
        schema: schema
    });
    let joinedListsTr;
    const mockDispatch = (tr)=>{
        joinedListsTr = tr;
    };
    // Return false to prevent replaceWith from wrapping the text node in a paragraph
    // paragraph since that will be done later. If it's done here, it will fail
    // the paragraph.validContent check.
    // Dont return false if there are lists, as they arent validContent for paragraphs
    // and will result in hanging textNodes
    (0, $5FzRL.autoJoin)((state, dispatch)=>{
        if (!dispatch) return false;
        const containsList = result.some((node)=>node.type === schema.nodes.bulletList || node.type === schema.nodes.orderedList);
        if (result.some((node)=>node.isText) && !containsList) return false;
        dispatch(state.tr.replaceWith(0, 2, result));
        return true;
    }, (before, after)=>(0, $iE5F1.isListNode)(before) && (0, $iE5F1.isListNode)(after))(mockState, mockDispatch);
    const fragment = joinedListsTr ? joinedListsTr.doc.content : (0, $kW8qW.Fragment).from(result);
    return fragment;
};
const $75a3e2f5c04aa833$export$df231bdf1595dd19 = (slice, schema)=>{
    return (0, $4ClnP.mapSlice)(slice, (node, parent)=>{
        if (node.type === schema.nodes.paragraph) return $75a3e2f5c04aa833$export$5bfe14e0df30e39c(node, parent, schema);
        return node;
    });
};
const $75a3e2f5c04aa833$export$f2dc3112f5c2bd10 = (slice, schema)=>{
    // exclude Text nodes with a code mark, since we transform those later
    // into a codeblock
    let hasCodeMark = false;
    slice.content.forEach((child)=>{
        hasCodeMark = hasCodeMark || child.marks.some((mark)=>mark.type === schema.marks.code);
    });
    // slice might just be a raw text string
    if (schema.nodes.paragraph.validContent(slice.content) && !hasCodeMark) {
        const replSlice = $75a3e2f5c04aa833$export$b2e3d6bb71a327f1({
            fragment: slice.content,
            schema: schema
        });
        return new (0, $kW8qW.Slice)(replSlice, slice.openStart + 1, slice.openEnd + 1);
    }
    return (0, $4ClnP.mapSlice)(slice, (node)=>{
        if (node.type === schema.nodes.paragraph) return $75a3e2f5c04aa833$export$b2e3d6bb71a327f1({
            fragment: node.content,
            blockMarks: node.marks,
            schema: schema
        });
        return node;
    });
};
const $75a3e2f5c04aa833$export$b2e3d6bb71a327f1 = ({ fragment: fragment, blockMarks: blockMarks = [], schema: schema })=>{
    const paragraphs = [];
    let curChildren = [];
    let lastNode = null;
    const { hardBreak: hardBreak, paragraph: paragraph } = schema.nodes;
    fragment.forEach((node, i)=>{
        const isNodeValidContentForParagraph = schema.nodes.paragraph.validContent((0, $kW8qW.Fragment).from(node));
        if (!isNodeValidContentForParagraph) {
            paragraphs.push(node);
            return;
        }
        // ED-14725 Fixed the issue that it make duplicated line
        // when pasting <br /> from google docs.
        if (i === 0 && node.type === hardBreak) {
            paragraphs.push(paragraph.createChecked(undefined, curChildren, [
                ...blockMarks
            ]));
            lastNode = node;
            return;
        } else if (lastNode && lastNode.type === hardBreak && node.type === hardBreak) {
            // double hardbreak
            // backtrack a little; remove the trailing hardbreak we added last loop
            curChildren.pop();
            // create a new paragraph
            paragraphs.push(paragraph.createChecked(undefined, curChildren, [
                ...blockMarks
            ]));
            curChildren = [];
            return;
        }
        // add to this paragraph
        curChildren.push(node);
        lastNode = node;
    });
    if (curChildren.length) paragraphs.push(paragraph.createChecked(undefined, curChildren, [
        ...blockMarks
    ]));
    return (0, $kW8qW.Fragment).from(paragraphs.length ? paragraphs : // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    [
        paragraph.createAndFill(undefined, undefined, [
            ...blockMarks
        ])
    ]);
};

});
parcelRegister("3pcnU", function(module, exports) {
$parcel$export(module.exports, "pluginKey", () => $cf5d353cb3ce81dd$export$18d4026d1ea86bb1);
$parcel$export(module.exports, "createPluginState", () => $cf5d353cb3ce81dd$export$656c7661095efe2e);
$parcel$export(module.exports, "createCommand", () => $cf5d353cb3ce81dd$export$8d4021544bdece00);
$parcel$export(module.exports, "getPluginState", () => $cf5d353cb3ce81dd$export$f05434c51e3762e);

var $3TnFr = parcelRequire("3TnFr");

var $cw0wu = parcelRequire("cw0wu");

var $bbQV4 = parcelRequire("bbQV4");
const $cf5d353cb3ce81dd$export$18d4026d1ea86bb1 = new (0, $cw0wu.PluginKey)('pastePlugin');
const $cf5d353cb3ce81dd$var$dest = (0, $3TnFr.pluginFactory)($cf5d353cb3ce81dd$export$18d4026d1ea86bb1, (0, $bbQV4.reducer), {
    mapping: (tr, pluginState)=>{
        if (tr.docChanged) {
            let atLeastOnePositionChanged = false;
            const positionsMappedThroughChanges = Object.entries(pluginState.pastedMacroPositions).reduce((acc, [key, position])=>{
                const mappedPosition = tr.mapping.map(position);
                if (position !== mappedPosition) atLeastOnePositionChanged = true;
                acc[key] = tr.mapping.map(position);
                return acc;
            }, {});
            if (atLeastOnePositionChanged) return {
                ...pluginState,
                pastedMacroPositions: positionsMappedThroughChanges
            };
        }
        return pluginState;
    }
});
const $cf5d353cb3ce81dd$export$656c7661095efe2e = $cf5d353cb3ce81dd$var$dest.createPluginState;
const $cf5d353cb3ce81dd$export$8d4021544bdece00 = $cf5d353cb3ce81dd$var$dest.createCommand;
const $cf5d353cb3ce81dd$export$f05434c51e3762e = $cf5d353cb3ce81dd$var$dest.getPluginState;

});
parcelRegister("bbQV4", function(module, exports) {
$parcel$export(module.exports, "reducer", () => $94125581d3305f3c$export$1650419e431d3ba3);

var $dpcHd = parcelRequire("dpcHd");
const $94125581d3305f3c$export$1650419e431d3ba3 = (state, action)=>{
    switch(action.type){
        case (0, $dpcHd.PastePluginActionTypes).START_TRACKING_PASTED_MACRO_POSITIONS:
            return {
                ...state,
                pastedMacroPositions: {
                    ...state.pastedMacroPositions,
                    ...action.pastedMacroPositions
                }
            };
        case (0, $dpcHd.PastePluginActionTypes).STOP_TRACKING_PASTED_MACRO_POSITIONS:
            {
                const filteredMacroPositions = Object.fromEntries(Object.entries(state.pastedMacroPositions).filter(([key])=>!action.pastedMacroPositionKeys.includes(key)));
                return {
                    ...state,
                    pastedMacroPositions: filteredMacroPositions
                };
            }
        case (0, $dpcHd.PastePluginActionTypes).ON_PASTE:
            return {
                ...state,
                lastContentPasted: action.contentPasted
            };
        case (0, $dpcHd.PastePluginActionTypes).SET_ACTIVE_FLAG:
            return {
                ...state,
                activeFlag: action.activeFlag
            };
        default:
            return state;
    }
};

});



parcelRegister("dag7I", function(module, exports) {
$parcel$export(module.exports, "transformSliceForMedia", () => $4e4e15520fdc8929$export$5ed9534d355a0a0f);
$parcel$export(module.exports, "transformSliceToCorrectMediaWrapper", () => $4e4e15520fdc8929$export$bd95a8dd607682c8);
$parcel$export(module.exports, "transformSliceToMediaSingleWithNewExperience", () => $4e4e15520fdc8929$export$77944619eaa3fcd3);
$parcel$export(module.exports, "unwrapNestedMediaElements", () => $4e4e15520fdc8929$export$3b69af3aaae9ee54);

var $29qUP = parcelRequire("29qUP");

var $1T9YU = parcelRequire("1T9YU");
var $9OQBm = parcelRequire("9OQBm");
var $imwRr = parcelRequire("imwRr");

var $4ClnP = parcelRequire("4ClnP");

var $gab48 = parcelRequire("gab48");

var $hEbiH = parcelRequire("hEbiH");

var $3y2s4 = parcelRequire("3y2s4");
function $4e4e15520fdc8929$export$5ed9534d355a0a0f(slice, schema, api) {
    const { mediaSingle: mediaSingle, layoutSection: layoutSection, table: table, bulletList: bulletList, orderedList: orderedList, expand: expand, nestedExpand: nestedExpand } = schema.nodes;
    return (selection)=>{
        let newSlice = slice;
        if ((0, $gab48.hasParentNodeOfType)([
            layoutSection,
            table,
            bulletList,
            orderedList,
            expand,
            nestedExpand
        ])(selection)) newSlice = (0, $4ClnP.mapSlice)(newSlice, (node)=>{
            var _api$media, _mediaState$mediaOpti;
            const mediaState = api === null || api === void 0 || (_api$media = api.media) === null || _api$media === void 0 ? void 0 : _api$media.sharedState.currentState();
            const extendedOrLegacyAttrs = mediaState !== null && mediaState !== void 0 && (_mediaState$mediaOpti = mediaState.mediaOptions) !== null && _mediaState$mediaOpti !== void 0 && _mediaState$mediaOpti.allowPixelResizing ? {
                layout: node.attrs.layout,
                widthType: node.attrs.widthType,
                width: node.attrs.width
            } : {
                layout: node.attrs.layout
            };
            let attrs = {};
            if ((0, $gab48.hasParentNodeOfType)([
                layoutSection,
                table
            ])(selection)) // Supports layouts
            attrs = {
                ...extendedOrLegacyAttrs
            };
            else if ((0, $gab48.hasParentNodeOfType)([
                bulletList,
                orderedList,
                expand,
                nestedExpand
            ])(selection)) // does not support other layouts
            attrs = {
                ...extendedOrLegacyAttrs,
                layout: 'center'
            };
            return node.type.name === 'mediaSingle' ? mediaSingle.createChecked(attrs, node.content, node.marks) : node;
        });
        return newSlice;
    };
}
const $4e4e15520fdc8929$export$fb85bc5d6d9ef19b = (fileType)=>{
    return !!fileType && (fileType.indexOf('image/') > -1 || fileType.indexOf('video/') > -1);
};
const $4e4e15520fdc8929$export$bd95a8dd607682c8 = (slice, schema)=>{
    const { mediaGroup: mediaGroup, mediaSingle: mediaSingle, media: media } = schema.nodes;
    return (0, $4ClnP.mapSlice)(slice, (node, parent)=>{
        if (!parent && node.type === media) {
            if (mediaSingle && ($4e4e15520fdc8929$export$fb85bc5d6d9ef19b(node.attrs.__fileMimeType) || node.attrs.type === 'external')) return mediaSingle.createChecked({}, node);
            else return mediaGroup.createChecked({}, [
                node
            ]);
        }
        return node;
    });
};
const $4e4e15520fdc8929$export$77944619eaa3fcd3 = (slice, schema, api)=>{
    const { mediaInline: mediaInline, mediaSingle: mediaSingle, media: media } = schema.nodes;
    const newSlice = (0, $4ClnP.mapSlice)(slice, (node)=>{
        // This logic is duplicated in editor-plugin-ai where external images can be inserted
        // from external sources through the use of AI.  The editor-plugin-ai package is avoiding
        // sharing dependencies with editor-core to support products using it with various versions
        // of editor packages.
        // The duplication is in the following file:
        // packages/editor/editor-plugin-ai/src/prebuilt/content-transformers/markdown-to-pm/markdown-transformer.ts
        if (node.type === mediaSingle) {
            var _api$media2, _mediaState$mediaOpti2;
            const mediaState = api === null || api === void 0 || (_api$media2 = api.media) === null || _api$media2 === void 0 ? void 0 : _api$media2.sharedState.currentState();
            return mediaState !== null && mediaState !== void 0 && (_mediaState$mediaOpti2 = mediaState.mediaOptions) !== null && _mediaState$mediaOpti2 !== void 0 && _mediaState$mediaOpti2.allowPixelResizing ? mediaSingle.createChecked({
                width: node.attrs.width || (0, $29qUP.DEFAULT_IMAGE_WIDTH),
                widthType: node.attrs.widthType || 'pixel',
                layout: node.attrs.layout
            }, node.content, node.marks) : node;
        }
        return node;
    });
    return (0, $4ClnP.mapSlice)(newSlice, (node)=>{
        const __mediaTraceId = (0, $hEbiH.getRandomHex)(8);
        if (node.type === media) {
            var _api$media3;
            api === null || api === void 0 || api.core.actions.execute(api === null || api === void 0 || (_api$media3 = api.media) === null || _api$media3 === void 0 ? void 0 : _api$media3.commands.trackMediaPaste(node.attrs));
            return media.createChecked({
                ...node.attrs,
                __external: node.attrs.type === 'external',
                __mediaTraceId: node.attrs.type === 'external' ? null : __mediaTraceId
            }, node.content, node.marks);
        }
        if (node.type.name === 'mediaInline') {
            var _api$media4;
            api === null || api === void 0 || api.core.actions.execute(api === null || api === void 0 || (_api$media4 = api.media) === null || _api$media4 === void 0 ? void 0 : _api$media4.commands.trackMediaPaste(node.attrs));
            return mediaInline.createChecked({
                ...node.attrs,
                __mediaTraceId: __mediaTraceId
            }, node.content, node.marks);
        }
        return node;
    });
};
/**
 * Check base styles to see if an element will be invisible when rendered in a document.
 * @param element
 */ const $4e4e15520fdc8929$var$isElementInvisible = (element)=>{
    return element.style.opacity === '0' || element.style.display === 'none' || element.style.visibility === 'hidden';
};
const $4e4e15520fdc8929$var$VALID_TAGS_CONTAINER = [
    'DIV',
    'TD',
    'BLOCKQUOTE'
];
function $4e4e15520fdc8929$var$canContainImage(element) {
    if (!element) return false;
    return $4e4e15520fdc8929$var$VALID_TAGS_CONTAINER.indexOf(element.tagName) !== -1;
}
/**
 * Determines whether an `<img>` inside a mediaSingle wrapper should be hoisted
 * out of the wrapper and treated as a standalone external image.
 *
 * This should only happen when:
 * - The image source is external (data-source="external"), and
 * - The media wrapper has no valid file reference (no data-id), meaning
 *   ProseMirror cannot reconstruct a proper internal media node from the wrapper.
 *
 * When the wrapper has a valid file reference (e.g. internal media from Jira),
 * we leave the wrapper intact so ProseMirror can reconstruct a proper internal media node with the file reference and fetch fresh auth tokens.
 */ function $4e4e15520fdc8929$var$shouldHoistFromMediaSingle(imageTag) {
    const isExternalSource = imageTag.getAttribute('data-source') === 'external';
    if (!isExternalSource) return false;
    const mediaNode = imageTag.closest('[data-node-type="media"]');
    const hasFileReference = (mediaNode === null || mediaNode === void 0 ? void 0 : mediaNode.hasAttribute('data-id')) ?? false;
    return !hasFileReference;
}
const $4e4e15520fdc8929$export$3b69af3aaae9ee54 = (html)=>{
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const wrapper = doc.body;
    // Remove Google Doc's wrapper <b> el
    const docsWrapper = wrapper.querySelector('b[id^="docs-internal-guid-"]');
    if (docsWrapper) (0, $9OQBm.unwrap)(wrapper, docsWrapper);
    const imageTags = wrapper.querySelectorAll('img');
    if (!imageTags.length) return html;
    imageTags.forEach((imageTag)=>{
        // Capture the immediate parent, we may remove the media from here later.
        const mediaParent = imageTag.parentElement;
        if (!mediaParent) return;
        // Bypass emoji
        if (imageTag.className.includes('emoji-common-emoji-image')) return;
        // Bypass mention avatars - a mention's avatar <img> is nested only inside <span>s
        // (never a valid container), so it would otherwise get hoisted out of the mention's
        // DOM subtree and parsed as a standalone image instead of leaving the mention intact
        // for its own parseDOM rule to match.
        if ((0, $3y2s4.isExperimentEnabled)('platform_editor_preserve_mention_on_paste') && imageTag.closest('[data-mention-id]')) return;
        // Bypass mediaInline images - don't hoist images that are inside a mediaInline wrapper
        // as this would break parseDOM matching for mediaInline nodes
        // We remove the img from the DOM since mediaInline is a leaf node with no content
        if (imageTag.closest('[data-node-type="mediaInline"]')) {
            // Remove the img element so ProseMirror doesn't try to parse it
            // mediaInline nodes are leaf nodes and cannot have children
            imageTag.remove();
            return;
        }
        // when copying a jira comment that contains external image (data-source="external"),
        // the 'media' div is like this:
        // <div data-node-type="media"> has no data-id,
        // But when copying a jira comment that contains image that was uploaded to Jira, the div is like this:
        // <div data-node-type="media" data-type="file" data-id="dce9c14b-b857-41fd-9452-5f4ba3a4f679" data-collection="" data-file-name="Screenshot 2026-05-26 at 4.41.05 pm.png" data-file-size="1354355" data-file-mime-type="image/png">
        // ProseMirror fails to parse the media node because it has no data-id,
        // so we hoist the <img> to replace the entire mediaSingle wrapper
        // so the editor can treat it as a plain external image and render/re-upload it correctly.
        const mediaSingleWrapper = imageTag.closest('[data-node-type="mediaSingle"]');
        if (mediaSingleWrapper && $4e4e15520fdc8929$var$shouldHoistFromMediaSingle(imageTag)) // Hoist the <img> to replace the entire mediaSingle wrapper
        {
            if (mediaSingleWrapper.parentElement) {
                mediaSingleWrapper.parentElement.insertBefore(imageTag, mediaSingleWrapper);
                mediaSingleWrapper.remove();
                return;
            }
        }
        // If either the parent or the image itself contains styles that would make
        // them invisible on copy, dont paste them.
        if ($4e4e15520fdc8929$var$isElementInvisible(mediaParent) || $4e4e15520fdc8929$var$isElementInvisible(imageTag)) {
            mediaParent.removeChild(imageTag);
            return;
        }
        // If its wrapped by a valid container we assume its safe to bypass.
        // ProseMirror should handle these cases properly.
        if ($4e4e15520fdc8929$var$canContainImage(mediaParent) || mediaParent instanceof HTMLSpanElement && mediaParent.closest('[class*="emoji-common"]')) return;
        // Find the top most element that the parent has a valid container for the image.
        // Stop just before found the wrapper
        const insertBeforeElement = (0, $imwRr.walkUpTreeUntil)(mediaParent, (element)=>{
            // If is at the top just use this element as reference
            if (element.parentElement === wrapper) return true;
            return $4e4e15520fdc8929$var$canContainImage(element.parentElement);
        });
        // Here we try to insert the media right after its top most valid parent element
        // Unless its the last element in our structure then we will insert above it.
        if (insertBeforeElement && insertBeforeElement.parentElement) {
            // Insert as close as possible to the most closest valid element index in the tree.
            insertBeforeElement.parentElement.insertBefore(imageTag, insertBeforeElement.nextElementSibling || insertBeforeElement);
            // Attempt to clean up lines left behind by the image
            mediaParent.innerText = mediaParent.innerText.trim();
            // Walk up and delete empty elements left over after removing the image tag
            (0, $1T9YU.removeNestedEmptyEls)(mediaParent);
        }
    });
    // If last child is a hardbreak we don't want it
    if (wrapper.lastElementChild && wrapper.lastElementChild.tagName === 'BR') wrapper.removeChild(wrapper.lastElementChild);
    return wrapper.innerHTML;
};

});

parcelRegister("lxt9h", function(module, exports) {
$parcel$export(module.exports, "sendPasteAnalyticsEvent", () => $13674507b14fbb09$export$5ee87eef0a304a1b);
$parcel$export(module.exports, "handlePasteAsPlainTextWithAnalytics", () => $13674507b14fbb09$export$69d6e3902009956e);
$parcel$export(module.exports, "handlePasteIntoTaskAndDecisionWithAnalytics", () => $13674507b14fbb09$export$e3873690443e0966);
$parcel$export(module.exports, "handlePasteIntoCaptionWithAnalytics", () => $13674507b14fbb09$export$e1d2fb186881c383);
$parcel$export(module.exports, "handleCodeBlockWithAnalytics", () => $13674507b14fbb09$export$9fea421173ba6d7d);
$parcel$export(module.exports, "handleMediaSingleWithAnalytics", () => $13674507b14fbb09$export$b49fd82cf59cd44e);
$parcel$export(module.exports, "handlePastePreservingMarksWithAnalytics", () => $13674507b14fbb09$export$ef36b80b79d1d973);
$parcel$export(module.exports, "handleMarkdownWithAnalytics", () => $13674507b14fbb09$export$d7489d309972091e);
$parcel$export(module.exports, "handleRichTextWithAnalytics", () => $13674507b14fbb09$export$3ef868f9e7157717);
$parcel$export(module.exports, "handlePastePanelOrDecisionIntoListWithAnalytics", () => $13674507b14fbb09$export$2d195c5439ce2ebc);
$parcel$export(module.exports, "handlePasteNonNestableBlockNodesIntoListWithAnalytics", () => $13674507b14fbb09$export$bbc9709b7b4a2f6);
$parcel$export(module.exports, "handleExpandWithAnalytics", () => $13674507b14fbb09$export$6681e5bfb9c8b704);
$parcel$export(module.exports, "handleNestedTablePasteWithAnalytics", () => $13674507b14fbb09$export$7dc8d4c52517a2f7);
$parcel$export(module.exports, "handleSelectedTableWithAnalytics", () => $13674507b14fbb09$export$6dbadac5ea22dd7a);
$parcel$export(module.exports, "handlePasteLinkOnSelectedTextWithAnalytics", () => $13674507b14fbb09$export$b36a7c9ea20b7bbf);
$parcel$export(module.exports, "createPasteMeasurePayload", () => $13674507b14fbb09$export$5dd5834ba1e07721);
$parcel$export(module.exports, "getContentNodeTypes", () => $13674507b14fbb09$export$629ff5588e070c83);

var $g6Qq4 = parcelRequire("g6Qq4");

var $j0Og8 = parcelRequire("j0Og8");

var $gnlVA = parcelRequire("gnlVA");

var $2P442 = parcelRequire("2P442");

var $4ClnP = parcelRequire("4ClnP");

var $gab48 = parcelRequire("gab48");
parcelRequire("ixBwV");
var $eW8cK = parcelRequire("eW8cK");

var $ceK8a = parcelRequire("ceK8a");

var $5Zjfk = parcelRequire("5Zjfk");
const $13674507b14fbb09$var$isAgentUserType = (userType)=>userType === 'APP' || userType === 'AGENT';
const $13674507b14fbb09$var$shouldSuppressPastedMentionNotification = (node)=>(0, $eW8cK.expVal)('platform_editor_agent_mentions', 'isEnabled', false) && $13674507b14fbb09$var$isAgentUserType(node.attrs.userType);
const $13674507b14fbb09$var$contentToPasteContent = {
    url: (0, $j0Og8.PasteContents).url,
    paragraph: (0, $j0Og8.PasteContents).text,
    bulletList: (0, $j0Og8.PasteContents).bulletList,
    orderedList: (0, $j0Og8.PasteContents).orderedList,
    heading: (0, $j0Og8.PasteContents).heading,
    blockquote: (0, $j0Og8.PasteContents).blockquote,
    codeBlock: (0, $j0Og8.PasteContents).codeBlock,
    panel: (0, $j0Og8.PasteContents).panel,
    rule: (0, $j0Og8.PasteContents).rule,
    mediaSingle: (0, $j0Og8.PasteContents).mediaSingle,
    mediaCard: (0, $j0Og8.PasteContents).mediaCard,
    mediaGroup: (0, $j0Og8.PasteContents).mediaGroup,
    table: (0, $j0Og8.PasteContents).table,
    tableCells: (0, $j0Og8.PasteContents).tableCells,
    tableHeader: (0, $j0Og8.PasteContents).tableHeader,
    tableRow: (0, $j0Og8.PasteContents).tableRow,
    decisionList: (0, $j0Og8.PasteContents).decisionList,
    decisionItem: (0, $j0Og8.PasteContents).decisionItem,
    taskList: (0, $j0Og8.PasteContents).taskItem,
    extension: (0, $j0Og8.PasteContents).extension,
    bodiedExtension: (0, $j0Og8.PasteContents).bodiedExtension,
    blockCard: (0, $j0Og8.PasteContents).blockCard,
    layoutSection: (0, $j0Og8.PasteContents).layoutSection
};
const $13674507b14fbb09$var$nodeToActionSubjectId = {
    blockquote: (0, $g6Qq4.ACTION_SUBJECT_ID).PASTE_BLOCKQUOTE,
    blockCard: (0, $g6Qq4.ACTION_SUBJECT_ID).PASTE_BLOCK_CARD,
    bodiedExtension: (0, $g6Qq4.ACTION_SUBJECT_ID).PASTE_BODIED_EXTENSION,
    bulletList: (0, $g6Qq4.ACTION_SUBJECT_ID).PASTE_BULLET_LIST,
    codeBlock: (0, $g6Qq4.ACTION_SUBJECT_ID).PASTE_CODE_BLOCK,
    decisionList: (0, $g6Qq4.ACTION_SUBJECT_ID).PASTE_DECISION_LIST,
    extension: (0, $g6Qq4.ACTION_SUBJECT_ID).PASTE_EXTENSION,
    heading: (0, $g6Qq4.ACTION_SUBJECT_ID).PASTE_HEADING,
    mediaGroup: (0, $g6Qq4.ACTION_SUBJECT_ID).PASTE_MEDIA_GROUP,
    mediaSingle: (0, $g6Qq4.ACTION_SUBJECT_ID).PASTE_MEDIA_SINGLE,
    orderedList: (0, $g6Qq4.ACTION_SUBJECT_ID).PASTE_ORDERED_LIST,
    panel: (0, $g6Qq4.ACTION_SUBJECT_ID).PASTE_PANEL,
    rule: (0, $g6Qq4.ACTION_SUBJECT_ID).PASTE_RULE,
    table: (0, $g6Qq4.ACTION_SUBJECT_ID).PASTE_TABLE,
    tableCell: (0, $g6Qq4.ACTION_SUBJECT_ID).PASTE_TABLE_CELL,
    tableHeader: (0, $g6Qq4.ACTION_SUBJECT_ID).PASTE_TABLE_HEADER,
    tableRow: (0, $g6Qq4.ACTION_SUBJECT_ID).PASTE_TABLE_ROW,
    taskList: (0, $g6Qq4.ACTION_SUBJECT_ID).PASTE_TASK_LIST
};
function $13674507b14fbb09$export$234c310f1a4fffd6({ schema: schema, slice: slice }) {
    const { nodes: { paragraph: paragraph }, marks: { link: link } } = schema;
    const nodeOrMarkName = new Set();
    slice.content.forEach((node)=>{
        if (node.type === paragraph && node.content.size === 0) // Skip empty paragraph
        return;
        if (node.type.name === 'text' && link.isInSet(node.marks)) {
            nodeOrMarkName.add('url');
            return;
        }
        // Check node contain link
        if (node.type === paragraph && node.rangeHasMark(0, node.nodeSize - 2, link)) {
            nodeOrMarkName.add('url');
            return;
        }
        nodeOrMarkName.add(node.type.name);
    });
    if (nodeOrMarkName.size > 1) return (0, $j0Og8.PasteContents).mixed;
    if (nodeOrMarkName.size === 0) return (0, $j0Og8.PasteContents).uncategorized;
    const type = nodeOrMarkName.values().next().value;
    // @ts-ignore - TS2538 TypeScript 5.9.2 upgrade
    const pasteContent = $13674507b14fbb09$var$contentToPasteContent[type];
    return pasteContent ? pasteContent : (0, $j0Og8.PasteContents).uncategorized;
}
function $13674507b14fbb09$export$d26f991ad03d8827(slice) {
    let traceId;
    (0, $4ClnP.mapSlice)(slice, (node)=>{
        if (node.type.name === 'media' || node.type.name === 'mediaInline') traceId = node.attrs.__mediaTraceId;
        return node;
    });
    return traceId;
}
function $13674507b14fbb09$var$getActionSubjectId({ selection: selection, schema: schema }) {
    const { nodes: { paragraph: paragraph, listItem: listItem, taskItem: taskItem, decisionItem: decisionItem } } = schema;
    const parent = (0, $gab48.findParentNode)((node)=>{
        if (node.type !== paragraph && node.type !== listItem && node.type !== taskItem && node.type !== decisionItem) return true;
        return false;
    })(selection);
    if (!parent) return (0, $g6Qq4.ACTION_SUBJECT_ID).PASTE_PARAGRAPH;
    const parentType = parent.node.type;
    const actionSubjectId = $13674507b14fbb09$var$nodeToActionSubjectId[parentType.name];
    return actionSubjectId ? actionSubjectId : (0, $g6Qq4.ACTION_SUBJECT_ID).PASTE_PARAGRAPH;
}
function $13674507b14fbb09$var$createPasteAsPlainPayload(actionSubjectId, text, linksInPasteCount) {
    return {
        action: (0, $g6Qq4.ACTION).PASTED_AS_PLAIN,
        actionSubject: (0, $g6Qq4.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: actionSubjectId,
        eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
        attributes: {
            inputMethod: (0, $g6Qq4.INPUT_METHOD).KEYBOARD,
            pasteSize: text.length,
            linksInPasteCount: linksInPasteCount
        }
    };
}
function $13674507b14fbb09$var$createPastePayload(actionSubjectId, attributes, linkDomain) {
    return {
        action: (0, $g6Qq4.ACTION).PASTED,
        actionSubject: (0, $g6Qq4.ACTION_SUBJECT).DOCUMENT,
        actionSubjectId: actionSubjectId,
        eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
        attributes: {
            inputMethod: (0, $g6Qq4.INPUT_METHOD).KEYBOARD,
            ...attributes
        },
        ...linkDomain && linkDomain.length > 0 ? {
            nonPrivacySafeAttributes: {
                linkDomain: linkDomain
            }
        } : {}
    };
}
function $13674507b14fbb09$var$createPasteAnalyticsPayloadBySelection(event, slice, pasteContext, pluginInjectionApi) {
    return (selection, tr)=>{
        var _pluginInjectionApi$m;
        const text = event.clipboardData ? event.clipboardData.getData('text/plain') || event.clipboardData.getData('text/uri-list') : '';
        const actionSubjectId = $13674507b14fbb09$var$getActionSubjectId({
            selection: selection,
            schema: selection.$from.doc.type.schema
        });
        const pasteSize = slice.size;
        const content = $13674507b14fbb09$export$234c310f1a4fffd6({
            schema: selection.$from.doc.type.schema,
            slice: slice
        });
        const linkUrls = [];
        const mediaTraceId = $13674507b14fbb09$export$d26f991ad03d8827(slice);
        // If we have a link among the pasted content, grab the
        // domain and send it up with the analytics event
        if (content === (0, $j0Og8.PasteContents).url || content === (0, $j0Og8.PasteContents).mixed) (0, $4ClnP.mapSlice)(slice, (node)=>{
            const linkMark = node.marks.find((mark)=>mark.type.name === 'link');
            if (linkMark) linkUrls.push(linkMark.attrs.href);
            return node;
        });
        if (pasteContext.asPlain) return $13674507b14fbb09$var$createPasteAsPlainPayload(actionSubjectId, text, linkUrls.length);
        const source = (0, $ceK8a.getPasteSource)(event);
        const mentionIds = [];
        const mentionLocalIds = [];
        slice.content.descendants((node)=>{
            if (node.type.name === 'mention') {
                mentionIds.push(node.attrs.id);
                mentionLocalIds.push(node.attrs.localId);
            }
        });
        if (pluginInjectionApi !== null && pluginInjectionApi !== void 0 && (_pluginInjectionApi$m = pluginInjectionApi.mention) !== null && _pluginInjectionApi$m !== void 0 && (_pluginInjectionApi$m = _pluginInjectionApi$m.actions) !== null && _pluginInjectionApi$m !== void 0 && _pluginInjectionApi$m.announceMentionsInsertion) {
            var _pluginInjectionApi$m2;
            const mentionsInserted = [];
            slice.content.descendants((node)=>{
                if (node.type.name === 'mention') mentionsInserted.push({
                    type: 'added',
                    id: node.attrs.id,
                    localId: node.attrs.localId,
                    method: 'pasted',
                    ...$13674507b14fbb09$var$shouldSuppressPastedMentionNotification(node) ? {
                        shouldSuppressMentionNotification: true
                    } : {}
                });
                if (node.type.name === 'taskItem') {
                    node.content.forEach((nodeContent)=>{
                        if (nodeContent.type.name === 'mention') mentionsInserted.push({
                            type: 'added',
                            localId: nodeContent.attrs.localId,
                            id: nodeContent.attrs.id,
                            taskLocalId: node.attrs.localId,
                            method: 'pasted',
                            ...$13674507b14fbb09$var$shouldSuppressPastedMentionNotification(nodeContent) ? {
                                shouldSuppressMentionNotification: true
                            } : {}
                        });
                    });
                    return false;
                }
            });
            pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$m2 = pluginInjectionApi.mention) === null || _pluginInjectionApi$m2 === void 0 || (_pluginInjectionApi$m2 = _pluginInjectionApi$m2.actions) === null || _pluginInjectionApi$m2 === void 0 || _pluginInjectionApi$m2.announceMentionsInsertion(mentionsInserted);
        }
        if (pasteContext.type === (0, $j0Og8.PasteTypes).plain) return $13674507b14fbb09$var$createPastePayload(actionSubjectId, {
            pasteSize: text.length,
            type: pasteContext.type,
            content: (0, $j0Og8.PasteContents).text,
            source: source,
            hyperlinkPasteOnText: false,
            linksInPasteCount: linkUrls.length,
            mentionIds: mentionIds,
            mentionLocalIds: mentionLocalIds,
            pasteSplitList: pasteContext.pasteSplitList
        });
        const linkDomains = linkUrls.map((0, $2P442.getLinkDomain));
        const backgroundColor = selection.$from.doc.type.schema.marks.backgroundColor;
        const hadMarkAttributes = pasteContext.hyperlinkPasteOnText && tr ? (0, $gnlVA.getHadMarkAttributes)(tr, [
            backgroundColor
        ]) : {};
        return $13674507b14fbb09$var$createPastePayload(actionSubjectId, {
            type: pasteContext.type,
            pasteSize: pasteSize,
            content: content,
            source: source,
            hyperlinkPasteOnText: !!pasteContext.hyperlinkPasteOnText,
            linksInPasteCount: linkUrls.length,
            mediaTraceId: mediaTraceId,
            mentionIds: mentionIds,
            mentionLocalIds: mentionLocalIds,
            pasteSplitList: pasteContext.pasteSplitList,
            ...hadMarkAttributes
        }, linkDomains);
    };
}
function $13674507b14fbb09$export$a30e064bd28e927f(view, event, slice, pasteContext) {
    return $13674507b14fbb09$var$createPasteAnalyticsPayloadBySelection(event, slice, pasteContext)(view.state.selection);
}
const $13674507b14fbb09$export$5ee87eef0a304a1b = (editorAnalyticsAPI)=>(view, event, slice, pasteContext)=>{
        const tr = view.state.tr;
        const payload = $13674507b14fbb09$export$a30e064bd28e927f(view, event, slice, pasteContext);
        editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent(payload)(tr);
        view.dispatch(tr);
    };
const $13674507b14fbb09$export$69d6e3902009956e = (editorAnalyticsAPI)=>(view, event, slice)=>$13674507b14fbb09$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($13674507b14fbb09$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: (0, $j0Og8.PasteTypes).plain,
            asPlain: true
        }))((0, $5Zjfk.handlePasteAsPlainText)(slice, event, editorAnalyticsAPI));
const $13674507b14fbb09$export$e3873690443e0966 = (view, event, slice, type, pluginInjectionApi)=>{
    var _pluginInjectionApi$a, _pluginInjectionApi$c;
    return $13674507b14fbb09$var$injectAnalyticsPayloadBeforeCommand(pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$a = pluginInjectionApi.analytics) === null || _pluginInjectionApi$a === void 0 ? void 0 : _pluginInjectionApi$a.actions)($13674507b14fbb09$var$createPasteAnalyticsPayloadBySelection(event, slice, {
        type: type
    }))((0, $5Zjfk.handlePasteIntoTaskOrDecisionOrPanel)(slice, pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$c = pluginInjectionApi.card) === null || _pluginInjectionApi$c === void 0 || (_pluginInjectionApi$c = _pluginInjectionApi$c.actions) === null || _pluginInjectionApi$c === void 0 ? void 0 : _pluginInjectionApi$c.queueCardsFromChangedTr));
};
const $13674507b14fbb09$export$e1d2fb186881c383 = (editorAnalyticsAPI)=>(view, event, slice, type)=>$13674507b14fbb09$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($13674507b14fbb09$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: type
        }))((0, $5Zjfk.handlePasteIntoCaption)(slice));
const $13674507b14fbb09$export$9fea421173ba6d7d = (editorAnalyticsAPI)=>(view, event, slice, text)=>$13674507b14fbb09$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($13674507b14fbb09$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: (0, $j0Og8.PasteTypes).plain
        }))((0, $5Zjfk.handleCodeBlock)(text));
const $13674507b14fbb09$export$b49fd82cf59cd44e = (editorAnalyticsAPI)=>(view, event, slice, type, insertMediaAsMediaSingle)=>$13674507b14fbb09$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($13674507b14fbb09$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: type
        }))((0, $5Zjfk.handleMediaSingle)((0, $g6Qq4.INPUT_METHOD).CLIPBOARD, insertMediaAsMediaSingle)(slice));
const $13674507b14fbb09$export$ef36b80b79d1d973 = (view, event, slice, type, pluginInjectionApi)=>{
    var _pluginInjectionApi$a2, _pluginInjectionApi$c2;
    return $13674507b14fbb09$var$injectAnalyticsPayloadBeforeCommand(pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$a2 = pluginInjectionApi.analytics) === null || _pluginInjectionApi$a2 === void 0 ? void 0 : _pluginInjectionApi$a2.actions)($13674507b14fbb09$var$createPasteAnalyticsPayloadBySelection(event, slice, {
        type: type
    }))((0, $5Zjfk.handlePastePreservingMarks)(slice, pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$c2 = pluginInjectionApi.card) === null || _pluginInjectionApi$c2 === void 0 || (_pluginInjectionApi$c2 = _pluginInjectionApi$c2.actions) === null || _pluginInjectionApi$c2 === void 0 ? void 0 : _pluginInjectionApi$c2.queueCardsFromChangedTr));
};
const $13674507b14fbb09$export$d7489d309972091e = (view, event, slice, pluginInjectionApi)=>{
    var _pluginInjectionApi$a3, _pluginInjectionApi$c3;
    return $13674507b14fbb09$var$injectAnalyticsPayloadBeforeCommand(pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$a3 = pluginInjectionApi.analytics) === null || _pluginInjectionApi$a3 === void 0 ? void 0 : _pluginInjectionApi$a3.actions)($13674507b14fbb09$var$createPasteAnalyticsPayloadBySelection(event, slice, {
        type: (0, $j0Og8.PasteTypes).markdown
    }))((0, $5Zjfk.handleMarkdown)(slice, pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$c3 = pluginInjectionApi.card) === null || _pluginInjectionApi$c3 === void 0 || (_pluginInjectionApi$c3 = _pluginInjectionApi$c3.actions) === null || _pluginInjectionApi$c3 === void 0 ? void 0 : _pluginInjectionApi$c3.queueCardsFromChangedTr));
};
const $13674507b14fbb09$export$3ef868f9e7157717 = (view, event, slice, pluginInjectionApi)=>{
    var _pluginInjectionApi$a4, _pluginInjectionApi$c4;
    return $13674507b14fbb09$var$injectAnalyticsPayloadBeforeCommand(pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$a4 = pluginInjectionApi.analytics) === null || _pluginInjectionApi$a4 === void 0 ? void 0 : _pluginInjectionApi$a4.actions)($13674507b14fbb09$var$createPasteAnalyticsPayloadBySelection(event, slice, {
        type: (0, $j0Og8.PasteTypes).richText
    }, pluginInjectionApi))((0, $5Zjfk.handleRichText)(slice, pluginInjectionApi === null || pluginInjectionApi === void 0 || (_pluginInjectionApi$c4 = pluginInjectionApi.card) === null || _pluginInjectionApi$c4 === void 0 || (_pluginInjectionApi$c4 = _pluginInjectionApi$c4.actions) === null || _pluginInjectionApi$c4 === void 0 ? void 0 : _pluginInjectionApi$c4.queueCardsFromChangedTr));
};
const $13674507b14fbb09$var$injectAnalyticsPayloadBeforeCommand = (editorAnalyticsAPI)=>(createPayloadByTransaction)=>{
        return (mainCommand)=>{
            return (state, dispatch, view)=>{
                let originalTransaction = state.tr;
                const fakeDispatch = (tr)=>{
                    originalTransaction = tr;
                };
                const result = mainCommand(state, fakeDispatch, view);
                if (!result) return false;
                if (dispatch && originalTransaction.docChanged) {
                    // it needs to know the selection before the changes
                    const payload = createPayloadByTransaction(state.selection, state.tr);
                    editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent(payload)(originalTransaction);
                    dispatch(originalTransaction);
                }
                return true;
            };
        };
    };
const $13674507b14fbb09$export$2d195c5439ce2ebc = (editorAnalyticsAPI)=>(view, event, slice, findRootParentListNode)=>$13674507b14fbb09$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($13674507b14fbb09$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: (0, $j0Og8.PasteTypes).richText
        }))((0, $5Zjfk.handlePastePanelOrDecisionContentIntoList)(slice, findRootParentListNode));
const $13674507b14fbb09$export$bbc9709b7b4a2f6 = (editorAnalyticsAPI)=>(view, event, slice)=>$13674507b14fbb09$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($13674507b14fbb09$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: (0, $j0Og8.PasteTypes).richText,
            pasteSplitList: true
        }))((0, $5Zjfk.handlePasteNonNestableBlockNodesIntoList)(slice));
const $13674507b14fbb09$export$6681e5bfb9c8b704 = (editorAnalyticsAPI)=>(view, event, slice)=>$13674507b14fbb09$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($13674507b14fbb09$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: (0, $j0Og8.PasteTypes).richText,
            pasteSplitList: true
        }))((0, $5Zjfk.handleExpandPaste)(slice));
const $13674507b14fbb09$export$7dc8d4c52517a2f7 = (editorAnalyticsAPI, isNestingTablesSupported)=>(view, event, slice)=>$13674507b14fbb09$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($13674507b14fbb09$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: (0, $j0Og8.PasteTypes).richText,
            pasteSplitList: true
        }))((0, $5Zjfk.handleNestedTablePaste)(slice, isNestingTablesSupported));
const $13674507b14fbb09$export$6dbadac5ea22dd7a = (editorAnalyticsAPI)=>(view, event, slice)=>$13674507b14fbb09$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($13674507b14fbb09$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: (0, $j0Og8.PasteTypes).richText
        }))((0, $5Zjfk.handleSelectedTable)(editorAnalyticsAPI)(slice));
const $13674507b14fbb09$export$b36a7c9ea20b7bbf = (editorAnalyticsAPI)=>(view, event, slice, type)=>$13674507b14fbb09$var$injectAnalyticsPayloadBeforeCommand(editorAnalyticsAPI)($13674507b14fbb09$var$createPasteAnalyticsPayloadBySelection(event, slice, {
            type: type,
            hyperlinkPasteOnText: true
        }))((0, $5Zjfk.handlePasteLinkOnSelectedText)(slice));
const $13674507b14fbb09$export$5dd5834ba1e07721 = ({ view: view, duration: duration, content: content, distortedDuration: distortedDuration })=>{
    const pasteIntoNode = $13674507b14fbb09$var$getActionSubjectId({
        selection: view.state.selection,
        schema: view.state.schema
    });
    return {
        action: (0, $g6Qq4.ACTION).PASTED_TIMED,
        actionSubject: (0, $g6Qq4.ACTION_SUBJECT).EDITOR,
        eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL,
        attributes: {
            pasteIntoNode: pasteIntoNode,
            content: content,
            time: duration,
            distortedDuration: distortedDuration
        }
    };
};
const $13674507b14fbb09$export$629ff5588e070c83 = (content)=>{
    let nodeTypes = new Set();
    if (content.size) content.forEach((node)=>{
        if (node.content && node.content.size) nodeTypes = new Set([
            ...nodeTypes,
            ...$13674507b14fbb09$export$629ff5588e070c83(node.content)
        ]);
        nodeTypes.add(node.type.name);
    });
    return Array.from(nodeTypes);
};

});
parcelRegister("ceK8a", function(module, exports) {
$parcel$export(module.exports, "isPastedFromWord", () => $34c2555326764290$export$6ba9f527e53e4ac1);
$parcel$export(module.exports, "isPastedFromExcel", () => $34c2555326764290$export$8d0b7622c89b176c);
$parcel$export(module.exports, "htmlContainsSingleFile", () => $34c2555326764290$export$41d193509f55b76e);
$parcel$export(module.exports, "getPasteSource", () => $34c2555326764290$export$e45b5b7458bacd81);
$parcel$export(module.exports, "escapeBackslashAndLinksExceptCodeBlock", () => $34c2555326764290$export$3e81f5aaf68cd698);
$parcel$export(module.exports, "hasOnlyNodesOfType", () => $34c2555326764290$export$a4568554bf9b43cd);
$parcel$export(module.exports, "applyTextMarksToSlice", () => $34c2555326764290$export$3bf611fd421c1669);
$parcel$export(module.exports, "isEmptyNode", () => $34c2555326764290$export$641fdf56f693bfbc);
$parcel$export(module.exports, "isCursorSelectionAtTextStartOrEnd", () => $34c2555326764290$export$ee1d3ec5b3695690);
$parcel$export(module.exports, "isSelectionInsidePanel", () => $34c2555326764290$export$3befc640b7d49184);
$parcel$export(module.exports, "htmlHasInvalidLinkTags", () => $34c2555326764290$export$3c3a613abe5bb97d);
$parcel$export(module.exports, "removeDuplicateInvalidLinks", () => $34c2555326764290$export$35ca1bb0581efaf3);
$parcel$export(module.exports, "addReplaceSelectedTableAnalytics", () => $34c2555326764290$export$4f704994f6a89bd1);
$parcel$export(module.exports, "transformUnsupportedBlockCardToInline", () => $34c2555326764290$export$9ffea5586131a948);

var $g6Qq4 = parcelRequire("g6Qq4");

var $kFGkN = parcelRequire("kFGkN");

var $3BkBo = parcelRequire("3BkBo");

var $kRFDj = parcelRequire("kRFDj");

var $01Z6w = parcelRequire("01Z6w");

var $4ClnP = parcelRequire("4ClnP");

var $kW8qW = parcelRequire("kW8qW");

var $cw0wu = parcelRequire("cw0wu");

var $gab48 = parcelRequire("gab48");

var $3XdGy = parcelRequire("3XdGy");
var $czibn = parcelRequire("czibn");

var $2IaXl = parcelRequire("2IaXl");

var $5N1Y4 = parcelRequire("5N1Y4");
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $34c2555326764290$var$HTML_CONTAINS_SINGLE_FILE_REGEX = /<img .*>/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $34c2555326764290$var$ESCAPE_LINKS_INNER_REGEX = /^(https?|ftp|jamfselfservice):\/\/[^\s>"]+$/;
// Allows up to 3 leading spaces before ``` and optional trailing characters
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $34c2555326764290$var$OPENING_CODE_FENCE_REGEX = /^( {0,3})```.*$/;
// Allows up to 3 leading spaces before ``` and optional trailing spaces or tabs
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $34c2555326764290$var$CLOSING_CODE_FENCE_REGEX = /^( {0,3})```[ 	]*$/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $34c2555326764290$var$SPLIT_ON_ANCHOR_REGEX = /(?=<a)/;
function $34c2555326764290$export$6ba9f527e53e4ac1(html) {
    return !!html && html.indexOf('urn:schemas-microsoft-com:office:word') >= 0;
}
function $34c2555326764290$export$8d0b7622c89b176c(html) {
    return !!html && html.indexOf('urn:schemas-microsoft-com:office:excel') >= 0;
}
function $34c2555326764290$var$isPastedFromDropboxPaper(html) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return !!html && !!html.match(/class=\"\s?author-d-.+"/gim);
}
function $34c2555326764290$var$isPastedFromGoogleDocs(html) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return !!html && !!html.match(/id=\"docs-internal-guid-.+"/gim);
}
function $34c2555326764290$var$isPastedFromGoogleSpreadSheets(html) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return !!html && !!html.match(/data-sheets-.+=/gim);
}
function $34c2555326764290$var$isPastedFromPages(html) {
    return !!html && html.indexOf('content="Cocoa HTML Writer"') >= 0;
}
function $34c2555326764290$var$isPastedFromFabricEditor(html) {
    return !!html && html.indexOf('data-pm-slice="') >= 0;
}
const $34c2555326764290$export$6186a6a0af6a6a9d = (text)=>{
    return !!text && text.trim().split('\n').length === 1;
};
function $34c2555326764290$export$41d193509f55b76e(html) {
    return !!html.match($34c2555326764290$var$HTML_CONTAINS_SINGLE_FILE_REGEX) && !(0, $2IaXl.isMediaBlobUrl)(html);
}
function $34c2555326764290$export$e45b5b7458bacd81(event) {
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const html = event.clipboardData.getData('text/html');
    if ($34c2555326764290$var$isPastedFromDropboxPaper(html)) return 'dropbox-paper';
    else if ($34c2555326764290$export$6ba9f527e53e4ac1(html)) return 'microsoft-word';
    else if ($34c2555326764290$export$8d0b7622c89b176c(html)) return 'microsoft-excel';
    else if ($34c2555326764290$var$isPastedFromGoogleDocs(html)) return 'google-docs';
    else if ($34c2555326764290$var$isPastedFromGoogleSpreadSheets(html)) return 'google-spreadsheets';
    else if ($34c2555326764290$var$isPastedFromPages(html)) return 'apple-pages';
    else if ($34c2555326764290$var$isPastedFromFabricEditor(html)) return 'fabric-editor';
    return 'uncategorized';
}
function $34c2555326764290$export$8acd10161c5f8b07(text) {
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    return text.replace(/(\[([^\]]+)\]\()?((https?|ftp|jamfselfservice):\/\/[^\s>"]+)/g, (str)=>{
        return str.match($34c2555326764290$var$ESCAPE_LINKS_INNER_REGEX) ? `<${str}>` : str;
    });
}
function $34c2555326764290$export$3e81f5aaf68cd698(textInput, options) {
    const shouldEscapeLinks = !(options !== null && options !== void 0 && options.skipLinkEscaping);
    // ref: https://spec.commonmark.org/0.31.2/#fenced-code-blocks
    let isInsideCodeBlock = false;
    const lines = textInput.split('\n');
    // In the splitted array, we traverse through every line and check if it will be parsed as a codeblock.
    return lines.map((line)=>{
        if (!isInsideCodeBlock && $34c2555326764290$var$OPENING_CODE_FENCE_REGEX.test(line)) {
            isInsideCodeBlock = true;
            return line;
        }
        if (isInsideCodeBlock && $34c2555326764290$var$CLOSING_CODE_FENCE_REGEX.test(line)) {
            isInsideCodeBlock = false;
            return line;
        }
        // not code fence, don't escape anything inside code block
        if (isInsideCodeBlock) return line;
        else {
            // Ignored via go/ees005
            // eslint-disable-next-line require-unicode-regexp, @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
            let escaped = line.replace(/\\/g, '\\\\');
            if (shouldEscapeLinks) escaped = $34c2555326764290$export$8acd10161c5f8b07(escaped);
            return escaped;
        }
    }).join('\n');
}
function $34c2555326764290$export$a4568554bf9b43cd(...nodeTypes) {
    return (slice)=>{
        let hasOnlyNodesOfType = true;
        slice.content.descendants((node)=>{
            hasOnlyNodesOfType = hasOnlyNodesOfType && nodeTypes.indexOf(node.type) > -1;
            return hasOnlyNodesOfType;
        });
        return hasOnlyNodesOfType;
    };
}
function $34c2555326764290$export$3bf611fd421c1669(schema, marks) {
    return (slice)=>{
        const { marks: { code: codeMark, link: linkMark, annotation: annotationMark } } = schema;
        if (!Array.isArray(marks) || marks.length === 0) return slice;
        const sliceCopy = (0, $kW8qW.Slice).fromJSON(schema, slice.toJSON() || {});
        // allow links and annotations to be pasted
        const allowedMarksToPaste = [
            linkMark,
            annotationMark
        ];
        sliceCopy.content.descendants((node, _pos, parent)=>{
            if (node.isText && parent && parent.isBlock) {
                // @ts-ignore - [unblock prosemirror bump] assigning to readonly prop
                node.marks = [
                    // remove all marks from pasted slice when applying code mark
                    // and exclude all marks that are not allowed to be pasted
                    ...node.marks && !codeMark.isInSet(marks) && node.marks.filter((mark)=>allowedMarksToPaste.includes(mark.type)) || [],
                    // add marks to a slice if they're allowed in parent node
                    // and exclude link marks
                    ...parent.type.allowedMarks(marks).filter((mark)=>mark.type !== linkMark)
                ].sort((0, $3BkBo.sortByOrderWithTypeName)('marks'));
                return false;
            }
            if (node.isInline && [
                'inlineCard',
                'emoji',
                'status',
                'date',
                'mention'
            ].includes(node.type.name) && parent && parent.isBlock) // @ts-ignore - [unblock prosemirror bump] assigning to readonly prop
            node.marks = [
                ...node.marks,
                ...parent.type.allowedMarks(marks).filter((mark)=>mark.type === schema.marks.annotation)
            ];
            return true;
        });
        return sliceCopy;
    };
}
function $34c2555326764290$export$641fdf56f693bfbc(node) {
    if (!node) return false;
    const { type: nodeType } = node;
    const emptyNode = nodeType.createAndFill();
    return emptyNode && emptyNode.nodeSize === node.nodeSize && emptyNode.content.eq(node.content) && (0, $kW8qW.Mark).sameSet(emptyNode.marks, node.marks);
}
function $34c2555326764290$export$ee1d3ec5b3695690(selection) {
    return selection instanceof (0, $cw0wu.TextSelection) && selection.empty && selection.$cursor && (!selection.$cursor.nodeBefore || !selection.$cursor.nodeAfter);
}
function $34c2555326764290$export$c7c9ca5cba02ff5a(node) {
    // panel_c1 is a schema variant of panel (used when a table is nested inside a panel). When the
    // experiment is on, treat it as a panel too.
    if ((0, $5N1Y4.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true)) return Boolean(node && (0, $01Z6w.getBaseNodeTypeName)(node.type) === 'panel');
    return Boolean(node && node.type.name === 'panel');
}
function $34c2555326764290$export$3befc640b7d49184(selection) {
    if (selection instanceof (0, $cw0wu.NodeSelection) && $34c2555326764290$export$c7c9ca5cba02ff5a(selection.node)) return selection.node;
    const { doc: { type: { schema: { nodes: { panel: panel, panel_c1: panel_c1 } } } } } = selection.$from;
    // When the experiment is on, also match panel_c1 (table-in-panel variant).
    const panelPosition = (0, $5N1Y4.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? (0, $gab48.findParentNodeOfType)([
        panel,
        panel_c1
    ].filter(Boolean))(selection) : (0, $gab48.findParentNodeOfType)(panel)(selection);
    if (panelPosition) return panelPosition.node;
    return null;
}
const $34c2555326764290$export$3c3a613abe5bb97d = (html)=>{
    return !!html && (html.includes('</a></a>') || html.includes('"></a><a'));
};
const $34c2555326764290$export$35ca1bb0581efaf3 = (html)=>{
    if ($34c2555326764290$export$3c3a613abe5bb97d(html)) {
        const htmlArray = html.split($34c2555326764290$var$SPLIT_ON_ANCHOR_REGEX);
        const htmlArrayWithoutInvalidLinks = htmlArray.filter((item)=>{
            return !(item.includes('<a') && item.includes('"></a>')) && !(item.includes('<a') && !item.includes('</a>'));
        });
        const fixedHtml = htmlArrayWithoutInvalidLinks.join('')// Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        .replace(/<\/a><\/a>/gi, '</a>')// Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        .replace(/<a>/gi, '<a');
        return fixedHtml;
    }
    return html;
};
const $34c2555326764290$export$4f704994f6a89bd1 = (state, tr, editorAnalyticsAPI)=>{
    if ((0, $czibn.isTableSelected)(state.selection)) {
        const { totalRowCount: totalRowCount, totalColumnCount: totalColumnCount } = (0, $3XdGy.getSelectedTableInfo)(state.selection);
        editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent({
            action: (0, $kFGkN.TABLE_ACTION).REPLACED,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).TABLE,
            attributes: {
                totalColumnCount: totalColumnCount,
                totalRowCount: totalRowCount,
                inputMethod: (0, $g6Qq4.INPUT_METHOD).CLIPBOARD
            },
            eventType: (0, $g6Qq4.EVENT_TYPE).TRACK
        })(tr);
        return tr;
    }
    return state.tr;
};
const $34c2555326764290$export$9ffea5586131a948 = (slice, state, cardOptions)=>{
    const { blockCard: blockCard, inlineCard: inlineCard } = state.schema.nodes;
    const children = [];
    (0, $4ClnP.mapChildren)(slice.content, (node, i, frag)=>{
        if (node.type === blockCard && !$34c2555326764290$var$isBlockCardSupported(state, frag, (cardOptions === null || cardOptions === void 0 ? void 0 : cardOptions.allowBlockCards) ?? false)) children.push(inlineCard.createChecked(node.attrs, node.content, node.marks));
        else children.push(node);
    });
    return new (0, $kW8qW.Slice)((0, $kW8qW.Fragment).fromArray(children), slice.openStart, slice.openEnd);
};
/**
 * Function to determine if a block card is supported by the editor
 * @param state
 * @param frag
 * @param allowBlockCards
 * @returns
 */ const $34c2555326764290$var$isBlockCardSupported = (state, frag, allowBlockCards)=>{
    return allowBlockCards && (0, $kRFDj.isSupportedInParent)(state, frag);
};

});

parcelRegister("5Zjfk", function(module, exports) {
$parcel$export(module.exports, "handleMention", () => $56f60153870029a8$export$7097a0398467de9c);
$parcel$export(module.exports, "handlePasteIntoTaskOrDecisionOrPanel", () => $56f60153870029a8$export$af959912bf89ae42);
$parcel$export(module.exports, "handlePasteNonNestableBlockNodesIntoList", () => $56f60153870029a8$export$b8a52be876d0b84f);
$parcel$export(module.exports, "handlePastePanelOrDecisionContentIntoList", () => $56f60153870029a8$export$3fd7f6d89a9d2cac);
$parcel$export(module.exports, "handlePasteLinkOnSelectedText", () => $56f60153870029a8$export$5e27b285bdcc71bf);
$parcel$export(module.exports, "handlePasteAsPlainText", () => $56f60153870029a8$export$efe55f809fabb910);
$parcel$export(module.exports, "handlePastePreservingMarks", () => $56f60153870029a8$export$de618421675f910e);
$parcel$export(module.exports, "handleMacroAutoConvert", () => $56f60153870029a8$export$d23738992a74c3a9);
$parcel$export(module.exports, "handleMarkdown", () => $56f60153870029a8$export$4b83e18c607f848f);
$parcel$export(module.exports, "handleCodeBlock", () => $56f60153870029a8$export$98135102f7ccdef2);
$parcel$export(module.exports, "handleMediaSingle", () => $56f60153870029a8$export$5fb647c5a57bac64);
$parcel$export(module.exports, "handleTableContentPasteInBodiedExtension", () => $56f60153870029a8$export$36e0fe2cadced224);
$parcel$export(module.exports, "handleNestedTablePaste", () => $56f60153870029a8$export$113227139658cc8d);
$parcel$export(module.exports, "handleExpandPaste", () => $56f60153870029a8$export$a497757c6eac4530);
$parcel$export(module.exports, "handleParagraphBlockMarks", () => $56f60153870029a8$export$feb0d61bf65d9267);
$parcel$export(module.exports, "handleRichText", () => $56f60153870029a8$export$f9c7e15c780a77d0);
$parcel$export(module.exports, "handlePasteIntoCaption", () => $56f60153870029a8$export$d399a86cc775ad7e);
$parcel$export(module.exports, "handleSelectedTable", () => $56f60153870029a8$export$4ce587bb5876886d);
$parcel$export(module.exports, "handlePasteExpand", () => $56f60153870029a8$export$ce28e8ccb2f7a3dd);
$parcel$export(module.exports, "applyContainerNodeTransformToSlice", () => $56f60153870029a8$export$ce2b3491c532dd9d);
$parcel$export(module.exports, "splitTablesOutOfPanelHtml", () => $56f60153870029a8$export$f596ff5b0d9c556a);
// eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead

var $7RHfd = parcelRequire("7RHfd");

var $huQpY = parcelRequire("huQpY");

var $g6Qq4 = parcelRequire("g6Qq4");

var $dVt29 = parcelRequire("dVt29");

var $afHZ2 = parcelRequire("afHZ2");

var $k3wEw = parcelRequire("k3wEw");

var $89hQd = parcelRequire("89hQd");

var $fUWld = parcelRequire("fUWld");
var $i6ggr = parcelRequire("i6ggr");

var $8t2a4 = parcelRequire("8t2a4");

var $j7pt0 = parcelRequire("j7pt0");

var $cgQ5m = parcelRequire("cgQ5m");
var $56AB9 = parcelRequire("56AB9");
var $7nLBT = parcelRequire("7nLBT");
var $iE5F1 = parcelRequire("iE5F1");

var $6Z6Le = parcelRequire("6Z6Le");

var $01Z6w = parcelRequire("01Z6w");

var $5vR15 = parcelRequire("5vR15");

var $4ClnP = parcelRequire("4ClnP");

var $kW8qW = parcelRequire("kW8qW");

var $cw0wu = parcelRequire("cw0wu");

var $gab48 = parcelRequire("gab48");

var $3pDt7 = parcelRequire("3pDt7");

var $3y2s4 = parcelRequire("3y2s4");

var $gdUUy = parcelRequire("gdUUy");

var $kQkyj = parcelRequire("kQkyj");

var $5N1Y4 = parcelRequire("5N1Y4");

var $5BPEN = parcelRequire("5BPEN");

var $3pcnU = parcelRequire("3pcnU");

var $59pV5 = parcelRequire("59pV5");

var $eliEQ = parcelRequire("eliEQ");

var $ceK8a = parcelRequire("ceK8a");
const $56f60153870029a8$var$insideExpand = (state)=>{
    const { expand: expand, nestedExpand: nestedExpand } = state.schema.nodes;
    return (0, $gab48.hasParentNodeOfType)([
        expand,
        nestedExpand
    ])(state.selection);
};
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Compose 1 to n functions.
 * @param func first function
 * @param funcs additional functions
 */ function $56f60153870029a8$var$compose(func, ...funcs) {
    const allFuncs = [
        func,
        ...funcs
    ];
    return function composed(raw) {
        return allFuncs.reduceRight((memo, func)=>func(memo), raw);
    };
}
function $56f60153870029a8$export$7097a0398467de9c(slice, schema) {
    return (0, $4ClnP.mapSlice)(slice, (node)=>{
        var _schema$nodes$mention;
        // We should move this to the mention plugin when we refactor how paste works in the future
        // For now we can just null check mention exists in the schema to ensure we don't crash if it doesn't
        // exist.
        if (node.type.name === ((_schema$nodes$mention = schema.nodes.mention) === null || _schema$nodes$mention === void 0 ? void 0 : _schema$nodes$mention.name)) {
            const mention = node.attrs;
            const newMention = {
                ...mention,
                text: ''
            };
            return schema.nodes.mention.create(newMention, node.content, node.marks);
        }
        return node;
    });
}
function $56f60153870029a8$export$af959912bf89ae42(slice, queueCardsFromChangedTr) {
    return (state, dispatch)=>{
        var _slice$content$firstC, _slice$content$firstC2, _transformedSlice$con, _transformedSlice$con2;
        const { schema: schema, tr: { selection: selection } } = state;
        const { marks: { code: codeMark }, nodes: { decisionItem: decisionItem, emoji: emoji, hardBreak: hardBreak, mention: mention, paragraph: paragraph, taskItem: taskItem, text: text, panel: panel, panel_c1: panel_c1, bulletList: bulletList, orderedList: orderedList, taskList: taskList, listItem: listItem, expand: expand, heading: heading, codeBlock: codeBlock } } = schema;
        const selectionIsValidNode = state.selection instanceof (0, $cw0wu.NodeSelection) && [
            'decisionList',
            'decisionItem',
            'taskList',
            'taskItem'
        ].includes(state.selection.node.type.name);
        // panel_c1 is a schema variant of panel (used when a table is nested inside a panel). When the
        // experiment is on we must handle it anywhere we special-case a panel, otherwise partial
        // selections copied from inside a table-in-panel are treated as a foreign container and
        // re-wrapped on paste.
        const selectionHasValidParentNode = (0, $5N1Y4.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? (0, $gab48.hasParentNodeOfType)([
            decisionItem,
            taskItem,
            panel,
            panel_c1
        ].filter(Boolean))(state.selection) : (0, $gab48.hasParentNodeOfType)([
            decisionItem,
            taskItem,
            panel
        ])(state.selection);
        const selectionIsCodeBlock = (0, $gab48.hasParentNodeOfType)([
            codeBlock
        ])(state.selection);
        const selectionIsListItem = (0, $gab48.hasParentNodeOfType)([
            listItem
        ])(state.selection);
        const panelNode = (0, $ceK8a.isSelectionInsidePanel)(selection);
        const selectionIsPanel = Boolean(panelNode);
        const sliceFirstChildIsPanel = (0, $5N1Y4.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? !!slice.content.firstChild && (0, $01Z6w.getBaseNodeTypeName)(slice.content.firstChild.type) === 'panel' : ((_slice$content$firstC = slice.content.firstChild) === null || _slice$content$firstC === void 0 ? void 0 : _slice$content$firstC.type) === panel;
        const isSliceWholePanel = sliceFirstChildIsPanel && slice.openStart === 0 && slice.openEnd === 0;
        // we avoid handling codeBlock-in-panel use case in this function
        // returning false will allow code to flow into `handleCodeBlock` function
        // Partial content copied from panels will have panel in the slice
        // Return false to avoid handling this situation when pasted into list in panel and let `handlePastePanelOrDecisionContentIntoList` handle it
        if (selectionIsPanel && (selectionIsCodeBlock || selectionIsListItem && !isSliceWholePanel)) return false;
        // Some types of content should be handled by the default handler, not this function.
        // Check through slice content to see if it contains an invalid node.
        let sliceIsInvalid = false;
        let sliceHasTask = false;
        slice.content.nodesBetween(0, slice.content.size, (node)=>{
            if (node.type === bulletList || node.type === orderedList || node.type === expand || node.type === heading && !selectionIsPanel || node.type === listItem) sliceIsInvalid = true;
            if (selectionIsPanel && node.type === taskList) sliceHasTask = true;
        });
        // If the selection is a panel,
        // and the slice's first node is a paragraph
        // and it is not from a depth that would indicate it being from inside from another node (e.g. text from a decision)
        // then we can rely on the default behaviour.
        const selectionIsTaskOrDecision = (0, $gab48.hasParentNode)((node)=>node.type === taskItem || node.type === decisionItem)(selection);
        const sliceIsAPanelReceivingLowDepthText = selectionIsPanel && !selectionIsTaskOrDecision && ((_slice$content$firstC2 = slice.content.firstChild) === null || _slice$content$firstC2 === void 0 ? void 0 : _slice$content$firstC2.type) === paragraph && slice.openEnd < 2;
        if (sliceIsInvalid || sliceIsAPanelReceivingLowDepthText || !selectionIsValidNode && !selectionHasValidParentNode) return false;
        const filters = [
            (0, $6Z6Le.linkifyContent)(schema)
        ];
        const selectionMarks = selection.$head.marks();
        if (selection instanceof (0, $cw0wu.TextSelection) && Array.isArray(selectionMarks) && selectionMarks.length > 0 && (0, $ceK8a.hasOnlyNodesOfType)(paragraph, text, emoji, mention, hardBreak)(slice) && (!codeMark.isInSet(selectionMarks) || (0, $89hQd.anyMarkActive)(state, codeMark) // check if there is a code mark anywhere in the selection
        )) filters.push((0, $ceK8a.applyTextMarksToSlice)(schema, selection.$head.marks()));
        const transformedSlice = $56f60153870029a8$var$compose.apply(null, filters)(slice);
        const isFirstChildTaskNode = transformedSlice.content.firstChild.type === taskList || transformedSlice.content.firstChild.type === taskItem;
        const tr = (0, $kQkyj.closeHistory)(state.tr);
        if (panelNode && sliceHasTask && sliceFirstChildIsPanel && (0, $ceK8a.isEmptyNode)(panelNode) && selection.$from.node() === selection.$to.node()) return Boolean((0, $eliEQ.insertSliceInsideOfPanelNodeSelected)(panelNode)({
            tr: tr,
            slice: slice
        }));
        const transformedSliceIsValidNode = (0, $5N1Y4.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? (transformedSlice.content.firstChild.type.inlineContent || [
            'decisionList',
            'decisionItem',
            'taskItem',
            'taskList',
            'panel'
        ].includes((0, $01Z6w.getBaseNodeTypeName)(transformedSlice.content.firstChild.type))) && (!(0, $56AB9.isInListItem)(state) || (0, $56AB9.isInListItem)(state) && isFirstChildTaskNode) : (transformedSlice.content.firstChild.type.inlineContent || [
            'decisionList',
            'decisionItem',
            'taskItem',
            'taskList',
            'panel'
        ].includes(transformedSlice.content.firstChild.type.name)) && (!(0, $56AB9.isInListItem)(state) || (0, $56AB9.isInListItem)(state) && isFirstChildTaskNode);
        // If the slice or the selection are valid nodes to handle,
        // and the slice is not a whole node (i.e. openStart is 1 and openEnd is 0)
        // or the slice's first node is a paragraph,
        // then we can replace the selection with our slice.
        // When the experiment is on, validate against the actual destination panel variant (panel or
        // panel_c1) since their content expressions differ (panel_c1 additionally allows a nested
        // table).
        const pastingIntoExtendedPanel = (0, $5N1Y4.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? selectionIsPanel && ((panelNode === null || panelNode === void 0 ? void 0 : panelNode.type) ?? panel).validContent(transformedSlice.content) : selectionIsPanel && panel.validContent(transformedSlice.content);
        // A task slice carrying its own open taskList wrapper would, on a plain replaceSelection,
        // nest that wrapper inside the current item and add an extra taskList level. Unwrapping one
        // level keeps the pasted task(s) at the same level.
        const isOpenTaskListSlice = ((_transformedSlice$con = transformedSlice.content.firstChild) === null || _transformedSlice$con === void 0 ? void 0 : _transformedSlice$con.type) === taskList && transformedSlice.openStart >= 2 && transformedSlice.openEnd >= 1;
        // Restrict the unwrap to a taskItem destination: its task content is schema-invalid inside a
        // decisionItem (decisionList only accepts decisionItem), so decisionItem must fall through to
        // the normal replaceSelection path.
        const pastingIntoTaskItem = (0, $gab48.hasParentNodeOfType)([
            taskItem
        ])(selection);
        if (isOpenTaskListSlice && pastingIntoTaskItem && !selectionIsPanel) {
            const unwrappedSlice = new (0, $kW8qW.Slice)(transformedSlice.content.firstChild.content, transformedSlice.openStart - 1, transformedSlice.openEnd - 1);
            tr.replaceSelection(unwrappedSlice).scrollIntoView();
        } else if ((transformedSliceIsValidNode || selectionIsValidNode) && !pastingIntoExtendedPanel && !(transformedSlice.openStart === 1 && transformedSlice.openEnd === 0 || // Whole codeblock node has reverse slice depths.
        transformedSlice.openStart === 0 && transformedSlice.openEnd === 1) || ((_transformedSlice$con2 = transformedSlice.content.firstChild) === null || _transformedSlice$con2 === void 0 ? void 0 : _transformedSlice$con2.type) === paragraph) tr.replaceSelection(transformedSlice).scrollIntoView();
        else {
            const isWholeContentSelected = selection.$from.pos === selection.$from.start() && selection.$to.end() === selection.$to.pos;
            if (pastingIntoExtendedPanel && selection.$from.pos !== selection.$to.pos && !isWholeContentSelected) // Do a replaceSelection if the entire panel content isn't selected
            //tr.replaceSelection(transformedSlice).scrollIntoView();
            tr.replaceSelection(new (0, $kW8qW.Slice)(transformedSlice.content, 0, transformedSlice.openEnd)).scrollIntoView();
            else if ([
                'mediaSingle'
            ].includes(transformedSlice.content.firstChild.type.name) && selectionIsPanel) {
                const parentNode = (0, $5N1Y4.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? (0, $gab48.findParentNodeOfType)([
                    panel,
                    panel_c1
                ].filter(Boolean))(selection) : (0, $gab48.findParentNodeOfType)(panel)(selection);
                if (selectionIsPanel && parentNode && (0, $56AB9.isNodeEmpty)(parentNode.node)) {
                    tr.insert(selection.$from.pos, transformedSlice.content).scrollIntoView();
                    // Place the cursor at the the end of the insersertion
                    const endPos = tr.selection.from + transformedSlice.size;
                    tr.setSelection(new (0, $cw0wu.TextSelection)(tr.doc.resolve(endPos)));
                } else tr.replaceSelection(transformedSlice).scrollIntoView();
            } else {
                var _transformedSlice$con3;
                if (pastingIntoExtendedPanel && isWholeContentSelected) // if the entire panel content is selected, doing a replaceSelection removes the panel as well. Hence we do delete followed by safeInsert
                tr.delete(selection.$from.pos, selection.$to.pos);
                // This maintains both the selection (destination) and the slice (paste content).
                (0, $gab48.safeInsert)(transformedSlice.content)(tr).scrollIntoView();
                if (((_transformedSlice$con3 = transformedSlice.content.lastChild) === null || _transformedSlice$con3 === void 0 || (_transformedSlice$con3 = _transformedSlice$con3.type) === null || _transformedSlice$con3 === void 0 ? void 0 : _transformedSlice$con3.name) === 'rule') tr.setSelection((0, $cw0wu.TextSelection).near(tr.doc.resolve(tr.selection.$from.pos + transformedSlice.content.size)));
                else {
                    // safeInsert doesn't set correct cursor position
                    // it moves the cursor to beginning of the node
                    // we manually shift the cursor to end of the node
                    const nextPos = tr.doc.resolve(tr.selection.$from.end());
                    tr.setSelection(new (0, $cw0wu.TextSelection)(nextPos));
                }
            }
        }
        queueCardsFromChangedTr === null || queueCardsFromChangedTr === void 0 || queueCardsFromChangedTr(state, tr, (0, $g6Qq4.INPUT_METHOD).CLIPBOARD);
        if (dispatch) dispatch(tr);
        return true;
    };
}
function $56f60153870029a8$export$b8a52be876d0b84f(slice) {
    return (state, dispatch)=>{
        var _tr$doc$nodeAt, _slice$content$firstC3, _sliceContent$firstCh, _findParentNodeOfType;
        const { tr: tr } = state;
        const { selection: selection } = tr;
        const { $from: $from, $to: $to, from: from, to: to } = selection;
        const { orderedList: orderedList, bulletList: bulletList, listItem: listItem } = state.schema.nodes;
        // Selected nodes
        const selectionParentListItemNode = (0, $gab48.findParentNodeOfType)(listItem)(selection);
        const selectionParentListNodeWithPos = (0, $gab48.findParentNodeOfType)([
            bulletList,
            orderedList
        ])(selection);
        const selectionParentListNode = selectionParentListNodeWithPos === null || selectionParentListNodeWithPos === void 0 ? void 0 : selectionParentListNodeWithPos.node;
        // Slice info
        const sliceContent = slice.content;
        const sliceIsListItems = (0, $iE5F1.isListNode)(sliceContent.firstChild) && (0, $iE5F1.isListNode)(sliceContent.lastChild);
        // Find case of slices that can be inserted into a list item
        // (eg. paragraphs, list items, code blocks, media single)
        // These scenarios already get handled elsewhere and don't need to split the list
        let sliceContainsBlockNodesOtherThanThoseAllowedInListItem = false;
        slice.content.forEach((child)=>{
            var _listItem$spec$conten;
            if (!listItem || child.isBlock && !((_listItem$spec$conten = listItem.spec.content) !== null && _listItem$spec$conten !== void 0 && _listItem$spec$conten.includes(child.type.name))) sliceContainsBlockNodesOtherThanThoseAllowedInListItem = true;
        });
        if (!selectionParentListItemNode || !sliceContent || (0, $gab48.canInsert)($from, sliceContent) || // eg. inline nodes that can be inserted in a list item
        !sliceContainsBlockNodesOtherThanThoseAllowedInListItem || sliceIsListItems || !selectionParentListNodeWithPos) return false;
        // Offsets
        const listWrappingOffset = $to.depth - selectionParentListNodeWithPos.depth + 1; // difference in depth between to position and list node
        const listItemWrappingOffset = $to.depth - selectionParentListNodeWithPos.depth; // difference in depth between to position and list item node
        // Anything to do with nested lists should safeInsert and not be handled here
        if ($56f60153870029a8$export$67c0f4368bb304c3(state)) return false;
        // Node after the insert position
        const nodeAfterInsertPositionIsListItem = ((_tr$doc$nodeAt = tr.doc.nodeAt(to + listItemWrappingOffset)) === null || _tr$doc$nodeAt === void 0 ? void 0 : _tr$doc$nodeAt.type.name) === 'listItem';
        // Get the next list items position (used later to find the split out ordered list)
        const indexOfNextListItem = $to.indexAfter($to.depth - listItemWrappingOffset);
        const positionOfNextListItem = tr.doc.resolve(selectionParentListNodeWithPos.pos + 1).posAtIndex(indexOfNextListItem);
        // These nodes paste as plain text by default so need to be handled differently
        const sliceContainsNodeThatPastesAsPlainText = sliceContent.firstChild && [
            'taskItem',
            'taskList',
            'heading',
            'blockquote'
        ].includes(sliceContent.firstChild.type.name);
        // Work out position to replace up to
        let replaceTo;
        if (sliceContainsNodeThatPastesAsPlainText && nodeAfterInsertPositionIsListItem) replaceTo = to + listItemWrappingOffset;
        else if (sliceContainsNodeThatPastesAsPlainText || !nodeAfterInsertPositionIsListItem) replaceTo = to;
        else replaceTo = to + listWrappingOffset;
        // handle the insertion of the slice
        if (((_slice$content$firstC3 = slice.content.firstChild) === null || _slice$content$firstC3 === void 0 ? void 0 : _slice$content$firstC3.type.name) === 'blockquote' && (0, $gab48.contains)(slice.content.firstChild, state.schema.nodes.listItem)) (0, $59pV5.insertSliceInsideBlockquote)({
            tr: tr,
            slice: slice
        });
        else if (sliceContainsNodeThatPastesAsPlainText || nodeAfterInsertPositionIsListItem || sliceContent.childCount > 1 && ((_sliceContent$firstCh = sliceContent.firstChild) === null || _sliceContent$firstCh === void 0 ? void 0 : _sliceContent$firstCh.type.name) !== 'paragraph') tr.replaceWith(from, replaceTo, sliceContent).scrollIntoView();
        else // When the selection is not at the end of a list item
        // eg. middle of list item, start of list item
        tr.replaceSelection(slice).scrollIntoView();
        // Find the ordered list node after the pasted content so we can set it's order
        const mappedPositionOfNextListItem = tr.mapping.map(positionOfNextListItem);
        if (mappedPositionOfNextListItem > tr.doc.nodeSize) return false;
        const nodeAfterPastedContentResolvedPos = (0, $gab48.findParentNodeOfTypeClosestToPos)(tr.doc.resolve(mappedPositionOfNextListItem), [
            orderedList
        ]);
        // Work out the new split out lists 'order' (the number it starts from)
        const originalParentOrderedListNodeOrder = selectionParentListNode === null || selectionParentListNode === void 0 ? void 0 : selectionParentListNode.attrs.order;
        const numOfListItemsInOriginalList = (_findParentNodeOfType = (0, $gab48.findParentNodeOfTypeClosestToPos)(tr.doc.resolve(from - 1), [
            orderedList
        ])) === null || _findParentNodeOfType === void 0 ? void 0 : _findParentNodeOfType.node.childCount;
        // Set the new split out lists order attribute
        if (typeof originalParentOrderedListNodeOrder === 'number' && numOfListItemsInOriginalList && nodeAfterPastedContentResolvedPos) tr.setNodeMarkup(nodeAfterPastedContentResolvedPos.pos, orderedList, {
            ...nodeAfterPastedContentResolvedPos.node.attrs,
            order: originalParentOrderedListNodeOrder + numOfListItemsInOriginalList
        });
        // dispatch transaction
        if (tr.docChanged) {
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };
}
const $56f60153870029a8$export$c2473d50cf33051b = (selection, findRootParentListNode)=>{
    const { $from: $from, $to: $to, from: from, to: to } = selection;
    const selectionParentListItemNodeResolvedPos = findRootParentListNode ? findRootParentListNode($from) || findRootParentListNode($to) : null;
    const selectionParentListNode = selectionParentListItemNodeResolvedPos === null || selectionParentListItemNodeResolvedPos === void 0 ? void 0 : selectionParentListItemNodeResolvedPos.parent;
    if (!selectionParentListItemNodeResolvedPos || !selectionParentListNode) return false;
    const startOfEntireList = $from.pos < $to.pos ? selectionParentListItemNodeResolvedPos.pos + $from.depth - 1 : selectionParentListItemNodeResolvedPos.pos + $to.depth - 1;
    const endOfEntireList = $from.pos < $to.pos ? selectionParentListItemNodeResolvedPos.pos + selectionParentListNode.nodeSize - $to.depth - 1 : selectionParentListItemNodeResolvedPos.pos + selectionParentListNode.nodeSize - $from.depth - 1;
    if (!startOfEntireList || !endOfEntireList) return false;
    if (from < to) return startOfEntireList >= $from.pos && endOfEntireList <= $to.pos;
    else if (from > to) return startOfEntireList >= $to.pos && endOfEntireList <= $from.pos;
    else return false;
};
function $56f60153870029a8$export$3fd7f6d89a9d2cac(slice, findRootParentListNode) {
    return (state, dispatch)=>{
        const { schema: schema, tr: tr } = state;
        const { selection: selection } = tr;
        // Check this pasting action is related to copy content from panel node into a selected the list node
        const blockNode = slice.content.firstChild;
        const isSliceWholeNode = slice.openStart === 0 && slice.openEnd === 0;
        const selectionParentListItemNode = selection.$to.node(selection.$to.depth - 1);
        const sliceIsWholeNodeButShouldNotReplaceSelection = isSliceWholeNode && !$56f60153870029a8$export$c2473d50cf33051b(selection, findRootParentListNode);
        // When the experiment is on, treat panel_c1 (table-in-panel variant) like a panel.
        const blockNodeIsPanelOrDecision = (0, $5N1Y4.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? [
            'panel',
            'decisionList'
        ].includes(blockNode ? (0, $01Z6w.getBaseNodeTypeName)(blockNode.type) : '') : [
            'panel',
            'decisionList'
        ].includes((blockNode === null || blockNode === void 0 ? void 0 : blockNode.type.name) ?? '');
        if (!selectionParentListItemNode || (selectionParentListItemNode === null || selectionParentListItemNode === void 0 ? void 0 : selectionParentListItemNode.type) !== schema.nodes.listItem || !blockNode || !blockNodeIsPanelOrDecision || slice.content.childCount > 1 || (blockNode === null || blockNode === void 0 ? void 0 : blockNode.content.firstChild) === undefined || sliceIsWholeNodeButShouldNotReplaceSelection) return false;
        // Paste the panel node contents extracted instead of pasting the entire panel node
        tr.replaceSelection(slice).scrollIntoView();
        if (dispatch) dispatch(tr);
        return true;
    };
}
const $56f60153870029a8$var$innerTextRangeOfTextblock = (doc, posOfBlock)=>{
    const block = doc.nodeAt(posOfBlock);
    if (!block || !block.isTextblock) return null;
    // raw content bounds
    const contentStart = posOfBlock + 1; // +1 to move from node's start token to content start
    const contentEnd = contentStart + block.content.size;
    // clamp to doc coord space
    const start = Math.max(0, Math.min(contentStart, doc.content.size));
    const end = Math.max(0, Math.min(contentEnd, doc.content.size));
    if (end <= start) return null;
    // snap to nearest valid text positions
    const startSel = (0, $cw0wu.TextSelection).findFrom(doc.resolve(start), 1, true);
    const endSel = (0, $cw0wu.TextSelection).findFrom(doc.resolve(end), -1, true);
    if (!startSel || !endSel) return null;
    const from = startSel.$from.pos;
    const to = endSel.$to.pos;
    return to > from ? {
        from: from,
        to: to
    } : null;
};
function $56f60153870029a8$var$resolveSingleTextblockRangeIfAllSelected(state) {
    const sel = state.selection;
    if (!(sel instanceof (0, $cw0wu.AllSelection))) return null;
    let count = 0;
    let posOfBlock = -1;
    state.doc.nodesBetween(sel.from, sel.to, (node, pos)=>{
        if (!node.isTextblock) return true;
        count++;
        if (count > 1) return false;
        posOfBlock = pos;
        return true;
    });
    if (count !== 1) return null;
    return $56f60153870029a8$var$innerTextRangeOfTextblock(state.doc, posOfBlock);
}
function $56f60153870029a8$export$5e27b285bdcc71bf(slice) {
    return (state, dispatch)=>{
        const { schema: schema, selection: selection, selection: { from: from, to: to }, tr: tr } = state;
        let linkMark;
        // check if we have a link on the clipboard
        if (slice.content.childCount === 1 && (0, $5vR15.isParagraph)(slice.content.child(0), schema)) {
            const paragraph = slice.content.child(0);
            if (paragraph.content.childCount === 1 && (0, $5vR15.isText)(paragraph.content.child(0), schema)) {
                const text = paragraph.content.child(0);
                // If pasteType is plain text, then
                //  @atlaskit/editor-markdown-transformer in getMarkdownSlice decode
                //  url before setting text property of text node.
                //  However href of marks will be without decoding.
                //  So, if there is character (e.g space) in url eligible escaping then
                //  mark.attrs.href will not be equal to text.text.
                //  That's why decoding mark.attrs.href before comparing.
                // However, if pasteType is richText, that means url in text.text
                //  and href in marks, both won't be decoded.
                linkMark = text.marks.find((mark)=>(0, $5vR15.isLinkMark)(mark, schema) && (mark.attrs.href === text.text || decodeURI(mark.attrs.href) === text.text));
            }
        }
        // derive a linkable range if possible for Select‑All over a single textblock
        const selectAllRange = (0, $gdUUy.fg)('platform_editor_link_paste_select_all') ? $56f60153870029a8$var$resolveSingleTextblockRangeIfAllSelected(state) : null;
        const rangeFrom = (selectAllRange === null || selectAllRange === void 0 ? void 0 : selectAllRange.from) ?? from;
        const rangeTo = (selectAllRange === null || selectAllRange === void 0 ? void 0 : selectAllRange.to) ?? to;
        // if we have a link, apply it to the selected text if we have any and it's allowed
        if (linkMark && (selection instanceof (0, $cw0wu.TextSelection) || Boolean(selectAllRange)) && !selection.empty && (0, $cgQ5m.canLinkBeCreatedInRange)(rangeFrom, rangeTo)(state)) {
            tr.addMark(rangeFrom, rangeTo, linkMark);
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };
}
function $56f60153870029a8$export$efe55f809fabb910(slice, _event, editorAnalyticsAPI) {
    return (state, dispatch, view)=>{
        var _input;
        if (!view) return false;
        // prosemirror-bump-fix
        // Yes, this is wrong by default. But, we need to keep the private PAI usage to unblock the prosemirror bump
        // So, this code will make sure we are checking for both version (current and the newest prosemirror-view version
        const isShiftKeyPressed = // eslint-disable-next-line @typescript-eslint/no-explicit-any
        view.shiftKey || ((_input = view.input) === null || _input === void 0 ? void 0 : _input.shiftKey);
        // In case of SHIFT+CMD+V ("Paste and Match Style") we don't want to run the usual
        // fuzzy matching of content. ProseMirror already handles this scenario and will
        // provide us with slice containing paragraphs with plain text, which we decorate
        // with "stored marks".
        // @see prosemirror-view/src/clipboard.js:parseFromClipboard()).
        // @see prosemirror-view/src/input.js:doPaste().
        if (isShiftKeyPressed) {
            let tr = (0, $kQkyj.closeHistory)(state.tr);
            const { selection: selection } = tr;
            // <- using the same internal flag that prosemirror-view is using
            // if user has selected table we need custom logic to replace the table
            tr = (0, $3pDt7.replaceSelectedTable)(state, slice);
            // add analytics after replacing selected table
            tr = (0, $ceK8a.addReplaceSelectedTableAnalytics)(state, tr, editorAnalyticsAPI);
            // otherwise just replace the selection
            if (!tr.docChanged) tr.replaceSelection(slice);
            (state.storedMarks || []).forEach((mark)=>{
                tr.addMark(selection.from, selection.from + slice.size, mark);
            });
            tr.scrollIntoView();
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };
}
function $56f60153870029a8$export$de618421675f910e(slice, queueCardsFromChangedTr) {
    return (state, dispatch)=>{
        const { schema: schema, tr: { selection: selection } } = state;
        const { marks: { code: codeMark, annotation: annotationMark }, nodes: { bulletList: bulletList, emoji: emoji, hardBreak: hardBreak, heading: heading, listItem: listItem, mention: mention, orderedList: orderedList, text: text } } = schema;
        if (!(selection instanceof (0, $cw0wu.TextSelection))) return false;
        const selectionMarks = selection.$head.marks();
        if (selectionMarks.length === 0) return false;
        // special case for codeMark: will preserve mark only if codeMark is currently active
        // won't preserve mark if cursor is on the edge on the mark (namely inactive)
        const hasActiveCodeMark = codeMark && codeMark.isInSet(selectionMarks) && (0, $89hQd.anyMarkActive)(state, codeMark);
        const hasAnnotationMark = annotationMark && annotationMark.isInSet(selectionMarks);
        const selectionIsHeading = (0, $gab48.hasParentNodeOfType)([
            heading
        ])(state.selection);
        // if the pasted data is one of the node types below
        // we apply current selection marks to the pasted slice
        if ((0, $ceK8a.hasOnlyNodesOfType)(bulletList, hardBreak, heading, listItem, text, emoji, mention, orderedList)(slice) || selectionIsHeading || hasActiveCodeMark || hasAnnotationMark) {
            const transformedSlice = (0, $ceK8a.applyTextMarksToSlice)(schema, selectionMarks)(slice);
            const tr = (0, $kQkyj.closeHistory)(state.tr).replaceSelection(transformedSlice).setStoredMarks(selectionMarks).scrollIntoView();
            queueCardsFromChangedTr === null || queueCardsFromChangedTr === void 0 || queueCardsFromChangedTr(state, tr, (0, $g6Qq4.INPUT_METHOD).CLIPBOARD);
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };
}
async function $56f60153870029a8$var$getSmartLinkAdf(text, type, cardOptions) {
    if (!cardOptions.provider) throw Error('No card provider found');
    const provider = await cardOptions.provider;
    return await provider.resolve(text, type);
}
function $56f60153870029a8$var$insertAutoMacroOld(slice, macro, view, from, to) {
    if (view) {
        // insert the text or linkified/md-converted clipboard data
        const selection = view.state.tr.selection;
        let tr;
        let before;
        if (typeof from === 'number' && typeof to === 'number') {
            tr = view.state.tr.replaceRange(from, to, slice);
            before = tr.mapping.map(from, -1);
        } else {
            tr = view.state.tr.replaceSelection(slice);
            before = tr.mapping.map(selection.from, -1);
        }
        view.dispatch(tr);
        // replace the text with the macro as a separate transaction
        // so the autoconversion generates 2 undo steps
        const macroTr = (0, $kQkyj.closeHistory)(view.state.tr).replaceRangeWith(before, before + slice.size, macro).scrollIntoView();
        (0, $dVt29.addLinkMetadata)(view.state.selection, macroTr, {
            inputMethod: (0, $g6Qq4.INPUT_METHOD).CLIPBOARD,
            cardAction: 'AUTO_CONVERT'
        });
        view.dispatch(macroTr);
        return true;
    }
    return false;
}
/**
 * Replacement for `insertAutoMacroOld` behind
 * `platform_editor_paste_autoconvert_robustness`.
 *
 * Identical in shape, except that the range the macro replaces is derived from the steps
 * that were actually applied rather than from `slice.size`. `slice.size` is the slice's
 * own measure and does not account for ProseMirror's fitting behaviour in
 * `replaceRange`/`replaceSelection`, so the two can disagree — and when they do the macro
 * is inserted without removing the text it should replace, leaving both the pasted text
 * and the macro in the document.
 */ function $56f60153870029a8$var$insertAutoMacroNew(slice, macro, view, from, to) {
    if (!view) return false;
    const { selection: selection } = view.state;
    const hasExplicitRange = typeof from === 'number' && typeof to === 'number';
    const replaceFrom = hasExplicitRange ? from : selection.from;
    const replaceTo = hasExplicitRange ? to : selection.to;
    // insert the text or linkified/md-converted clipboard data
    const tr = hasExplicitRange ? view.state.tr.replaceRange(replaceFrom, replaceTo, slice) : view.state.tr.replaceSelection(slice);
    const insertedFrom = tr.mapping.map(replaceFrom, -1);
    const insertedTo = tr.mapping.map(replaceTo, 1);
    view.dispatch(tr);
    // Leave the document alone rather than replacing an implausible range.
    if (insertedFrom >= insertedTo || insertedTo > view.state.doc.content.size) return true;
    // replace the text with the macro as a separate transaction
    // so the autoconversion generates 2 undo steps
    const macroTr = (0, $kQkyj.closeHistory)(view.state.tr).replaceRangeWith(insertedFrom, insertedTo, macro).scrollIntoView();
    (0, $dVt29.addLinkMetadata)(view.state.selection, macroTr, {
        inputMethod: (0, $g6Qq4.INPUT_METHOD).CLIPBOARD,
        cardAction: 'AUTO_CONVERT'
    });
    view.dispatch(macroTr);
    return true;
}
function $56f60153870029a8$var$insertAutoMacro(slice, macro, view, from, to) {
    return (0, $3y2s4.isExperimentEnabled)('platform_editor_paste_autoconvert_robustness') ? $56f60153870029a8$var$insertAutoMacroNew(slice, macro, view, from, to) : $56f60153870029a8$var$insertAutoMacroOld(slice, macro, view, from, to);
}
/**
 * Locates the range currently occupied by a link that we pasted earlier.
 *
 * Positions recorded before an async gap can drift or be invalidated entirely by
 * concurrent edits, collaborative changes and `appendTransaction` hooks, so the
 * recorded range is verified against the document before it is used. If it no longer
 * holds the pasted link the link is re-located by href, preferring the occurrence
 * closest to where it was last seen.
 *
 * Returns `undefined` when the link cannot be found, so callers can leave the
 * document alone rather than replacing whatever happens to sit at a stale position.
 */ /**
 * Whether every text node spanning [from, to) carries a `link` mark pointing at `url`,
 * with no gaps or uncovered portions.
 */ function $56f60153870029a8$var$rangeIsExactLinkMark(doc, from, to, url, linkMarkType) {
    let matches = true;
    let coveredTo = from;
    doc.nodesBetween(from, to, (node, pos)=>{
        if (!matches || pos >= to) return false;
        if (!node.isLeaf) // A container node — e.g. the paragraph the link sits in. `nodesBetween` visits
        // these on the way down to the text node(s) we actually care about; keep
        // descending into it rather than treating it as a mismatch.
        return true;
        if (!node.isText) {
            // A non-text leaf (e.g. an inline card) cannot carry the link mark.
            matches = false;
            return false;
        }
        const linkMark = linkMarkType.isInSet(node.marks);
        if (!linkMark || linkMark.attrs.href !== url) {
            matches = false;
            return false;
        }
        coveredTo = Math.min(pos + node.nodeSize, to);
        return true;
    });
    return matches && coveredTo === to;
}
/**
 * `from`/`to` are not a one-off snapshot: they come from `pastedMacroPositions`, which the
 * paste plugin's `mapping` hook (`plugin-factory.ts`) maps through every transaction
 * applied while the smart link request is in flight, via `tr.mapping.map(position)`. So
 * this covers every edit ProseMirror can express as a position mapping — typing,
 * deleting, or moving content elsewhere in the same edit all keep `from`/`to` pointing at
 * the same logical span.
 *
 * It stops covering that span only when the span itself no longer represents our pasted
 * link — the link was unlinked, or its content was replaced outright. Deliberately no
 * fallback search for "the nearest link with the same href" is done: with multiple links
 * to the same URL in the document, a proximity search cannot tell which one we pasted, so
 * it risks silently replacing an occurrence we were never asked to touch, and it requires
 * an O(doc size) scan on every fallback to do it. Leaving the tracked link as a link is
 * the safe outcome here, and it's what happens when this function returns `undefined`.
 */ function $56f60153870029a8$var$findPastedLinkRange(state, url, from, to) {
    const { doc: doc, schema: schema } = state;
    const linkMarkType = schema.marks.link;
    const docSize = doc.content.size;
    if (!linkMarkType || typeof from !== 'number' || typeof to !== 'number' || from < 0 || from >= to || to > docSize) return undefined;
    // Text equality alone is not enough: if the link was unlinked (mark removed) while
    // the smart link request was in flight, the text can still read as the URL even
    // though it is no longer a link, and replacing it would destroy content that is no
    // longer ours to replace.
    if (doc.textBetween(from, to) === url && $56f60153870029a8$var$rangeIsExactLinkMark(doc, from, to, url, linkMarkType)) return {
        from: from,
        to: to
    };
    return undefined;
}
/**
 * Swaps a link that was already pasted into the document for its macro equivalent.
 *
 * Used when smart links could not resolve the URL, so the macro autoconversion is the
 * fallback. Does nothing if the link can no longer be found — for example because a
 * smart card has already replaced it — which is preferable to replacing unrelated
 * content at a stale position.
 */ function $56f60153870029a8$var$replacePastedLinkWithMacro(view, macro, url, from, to, editorAnalyticsAPI) {
    const range = $56f60153870029a8$var$findPastedLinkRange(view.state, url, from, to);
    if (!range) {
        // Metric for how often the tracked pasted link could no longer be found once the
        // smart link request settled, so the assumption that this is rare is measurable
        // rather than assumed.
        editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.fireAnalyticsEvent({
            action: (0, $g6Qq4.ACTION).ERRORED,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).SMART_LINK,
            eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL,
            attributes: {
                error: 'macro-auto-convert-pasted-link-not-found'
            }
        });
        return false;
    }
    const macroTr = (0, $kQkyj.closeHistory)(view.state.tr).replaceRangeWith(range.from, range.to, macro).scrollIntoView();
    (0, $dVt29.addLinkMetadata)(view.state.selection, macroTr, {
        inputMethod: (0, $g6Qq4.INPUT_METHOD).CLIPBOARD,
        cardAction: 'AUTO_CONVERT'
    });
    view.dispatch(macroTr);
    return true;
}
function $56f60153870029a8$export$d23738992a74c3a9(text, slice, queueCardsFromChangedTr, runMacroAutoConvert, cardsOptions, extensionAutoConverter, editorAnalyticsAPI) {
    return (state, dispatch, view)=>{
        let macro = null;
        // try to use auto convert from extension provider first
        if (extensionAutoConverter) {
            const extension = extensionAutoConverter(text);
            if (extension) macro = (0, $kW8qW.Node).fromJSON(state.schema, extension);
        }
        // then try from macro provider (which will be removed some time in the future)
        if (!macro) macro = (runMacroAutoConvert === null || runMacroAutoConvert === void 0 ? void 0 : runMacroAutoConvert(state, text)) ?? null;
        if (macro) {
            /**
       * if FF enabled, run through smart links and check for result
       */ if (cardsOptions && cardsOptions.resolveBeforeMacros && cardsOptions.resolveBeforeMacros.length) {
                if (cardsOptions.resolveBeforeMacros.indexOf(macro.attrs.extensionKey) < 0) return $56f60153870029a8$var$insertAutoMacro(slice, macro, view);
                if (!view) throw new Error('View is missing');
                const autoConvertMacro = macro;
                // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
                const trackingId = (0, $7RHfd.default)();
                const trackingFrom = `handleMacroAutoConvert-from-${trackingId}`;
                const trackingTo = `handleMacroAutoConvert-to-${trackingId}`;
                if ((0, $3y2s4.isExperimentEnabled)('platform_editor_paste_autoconvert_robustness')) {
                    // Insert the pasted content straight away. The smart link provider is only
                    // consulted to decide whether the inserted link should later be swapped for
                    // a macro, so it does not need to gate the insert — otherwise every
                    // autoconvertible paste appears to do nothing until a network round trip
                    // completes.
                    let insertedRange;
                    $56f60153870029a8$var$handleMarkdownWithInsertedRange(slice, queueCardsFromChangedTr, (range)=>{
                        insertedRange = range;
                    })(state, dispatch);
                    if (!insertedRange) return true;
                    (0, $5BPEN.startTrackingPastedMacroPositions)({
                        [trackingFrom]: insertedRange.from,
                        [trackingTo]: insertedRange.to
                    })(view.state, dispatch);
                    $56f60153870029a8$var$getSmartLinkAdf(text, 'inline', cardsOptions).catch(()=>{
                        // Smart links could not resolve the URL, so fall back to the macro.
                        // we use view.state rather than state because state becomes a stale
                        // state reference after getSmartLinkAdf's async work
                        const { pastedMacroPositions: pastedMacroPositions } = (0, $3pcnU.getPluginState)(view.state);
                        $56f60153870029a8$var$replacePastedLinkWithMacro(view, autoConvertMacro, text, pastedMacroPositions[trackingFrom], pastedMacroPositions[trackingTo], editorAnalyticsAPI);
                    }).finally(()=>{
                        (0, $5BPEN.stopTrackingPastedMacroPositions)([
                            trackingFrom,
                            trackingTo
                        ])(view.state, dispatch);
                    });
                    return true;
                }
                (0, $5BPEN.startTrackingPastedMacroPositions)({
                    [trackingFrom]: state.selection.from,
                    [trackingTo]: state.selection.to
                })(state, dispatch);
                $56f60153870029a8$var$getSmartLinkAdf(text, 'inline', cardsOptions).then(()=>{
                    // we use view.state rather than state because state becomes a stale
                    // state reference after getSmartLinkAdf's async work
                    const { pastedMacroPositions: pastedMacroPositions } = (0, $3pcnU.getPluginState)(view.state);
                    if (dispatch) $56f60153870029a8$export$4b83e18c607f848f(slice, queueCardsFromChangedTr, pastedMacroPositions[trackingFrom], pastedMacroPositions[trackingTo])(view.state, dispatch);
                }).catch(()=>{
                    const { pastedMacroPositions: pastedMacroPositions } = (0, $3pcnU.getPluginState)(view.state);
                    $56f60153870029a8$var$insertAutoMacro(slice, macro, view, pastedMacroPositions[trackingFrom], pastedMacroPositions[trackingTo]);
                }).finally(()=>{
                    (0, $5BPEN.stopTrackingPastedMacroPositions)([
                        trackingFrom,
                        trackingTo
                    ])(view.state, dispatch);
                });
                return true;
            }
            return $56f60153870029a8$var$insertAutoMacro(slice, macro, view);
        }
        return !!macro;
    };
}
function $56f60153870029a8$export$98135102f7ccdef2(text) {
    return (state, dispatch)=>{
        const { codeBlock: codeBlock } = state.schema.nodes;
        if (text && (0, $gab48.hasParentNodeOfType)(codeBlock)(state.selection)) {
            const tr = (0, $kQkyj.closeHistory)(state.tr);
            tr.scrollIntoView();
            if (dispatch) dispatch(tr.insertText(text));
            return true;
        }
        return false;
    };
}
function $56f60153870029a8$var$isOnlyMedia(state, slice) {
    const { media: media } = state.schema.nodes;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return slice.content.childCount === 1 && slice.content.firstChild.type === media;
}
function $56f60153870029a8$var$isOnlyMediaSingle(state, slice) {
    const { mediaSingle: mediaSingle } = state.schema.nodes;
    return(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    mediaSingle && slice.content.childCount === 1 && slice.content.firstChild.type === mediaSingle);
}
function $56f60153870029a8$export$5fb647c5a57bac64(inputMethod, insertMediaAsMediaSingle) {
    return function(slice) {
        return (state, dispatch, view)=>{
            if (view) {
                if ($56f60153870029a8$var$isOnlyMedia(state, slice)) // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                return (insertMediaAsMediaSingle === null || insertMediaAsMediaSingle === void 0 ? void 0 : insertMediaAsMediaSingle(view, slice.content.firstChild, inputMethod)) ?? false;
                if ((0, $afHZ2.insideTable)(state) && $56f60153870029a8$var$isOnlyMediaSingle(state, slice)) {
                    const tr = state.tr.replaceSelection(slice);
                    const nextPos = tr.doc.resolve(tr.mapping.map(state.selection.$from.pos));
                    if (dispatch) dispatch(tr.setSelection(new (0, $j7pt0.GapCursorSelection)(nextPos, (0, $8t2a4.Side).RIGHT)));
                    return true;
                }
            }
            return false;
        };
    };
}
const $56f60153870029a8$var$hasTopLevelExpand = (slice)=>{
    let hasExpand = false;
    slice.content.forEach((node)=>{
        if (node.type.name === 'expand' || node.type.name === 'nestedExpand') hasExpand = true;
    });
    return hasExpand;
};
function $56f60153870029a8$export$36e0fe2cadced224(slice) {
    return (state, dispatch)=>{
        const isInsideBodyExtension = (0, $gab48.hasParentNodeOfType)(state.schema.nodes.bodiedExtension)(state.selection);
        if (!(0, $afHZ2.insideTable)(state) || !isInsideBodyExtension) return false;
        const { bodiedExtension: bodiedExtension } = state.schema.nodes;
        const newSlice = (0, $4ClnP.mapSlice)(slice, (maybeNode)=>{
            if (maybeNode.type === bodiedExtension) return bodiedExtension.createChecked(maybeNode.attrs, maybeNode.content, maybeNode.marks);
            return maybeNode;
        });
        if (dispatch) {
            dispatch(state.tr.replaceSelection(newSlice));
            return true;
        }
        return false;
    };
}
function $56f60153870029a8$export$113227139658cc8d(slice, isNestingTablesSupported) {
    return (state, dispatch)=>{
        if (!isNestingTablesSupported || !(0, $afHZ2.insideTable)(state)) return false;
        const { schema: schema, selection: selection } = state;
        let sliceHasTable = false;
        slice.content.forEach((node)=>{
            if (node.type === state.schema.nodes.table) sliceHasTable = true;
        });
        if (sliceHasTable) // if slice has table - if pasting to deeply nested location place paste after top table
        {
            if ((0, $fUWld.getParentOfTypeCount)(schema.nodes.table)(selection.$from) > 1) {
                const positionAfterTopTable = (0, $i6ggr.getPositionAfterTopParentNodeOfType)(schema.nodes.table)(selection.$from);
                let { tr: tr } = state;
                tr = (0, $gab48.safeInsert)(slice.content, positionAfterTopTable)(tr);
                tr.scrollIntoView();
                if (dispatch) {
                    dispatch(tr);
                    return true;
                }
            }
        }
        return false;
    };
}
function $56f60153870029a8$export$a497757c6eac4530(slice) {
    return (state, dispatch)=>{
        const isInsideNestableExpand = !!$56f60153870029a8$var$insideExpand(state);
        // Do not handle expand if it's not being pasted into a table or expand
        // OR if it's nested within another node when being pasted into a table/expand
        if (!(0, $afHZ2.insideTable)(state) && !isInsideNestableExpand || !$56f60153870029a8$var$hasTopLevelExpand(slice)) return false;
        const { expand: expand, nestedExpand: nestedExpand } = state.schema.nodes;
        let { tr: tr } = state;
        let hasExpand = false;
        const newSlice = (0, $4ClnP.mapSlice)(slice, (maybeNode)=>{
            if (maybeNode.type === expand || maybeNode.type === nestedExpand) {
                hasExpand = true;
                try {
                    return nestedExpand.createChecked(maybeNode.attrs, maybeNode.content, maybeNode.marks);
                } catch  {
                    tr = (0, $gab48.safeInsert)(maybeNode, tr.selection.$to.pos)(tr);
                    return (0, $kW8qW.Fragment).empty;
                }
            }
            return maybeNode;
        });
        if (hasExpand && dispatch) {
            // If the slice is a subset, we can let PM replace the selection
            // it will insert as text where it can't place the node.
            // Otherwise we use safeInsert to insert below instead of
            // replacing/splitting the current node.
            if (slice.openStart > 1 && slice.openEnd > 1) dispatch(tr.replaceSelection(newSlice));
            else dispatch((0, $gab48.safeInsert)(newSlice.content)(tr));
            return true;
        }
        return false;
    };
}
function $56f60153870029a8$export$4b83e18c607f848f(markdownSlice, queueCardsFromChangedTr, from, to) {
    return (state, dispatch)=>{
        const tr = (0, $kQkyj.closeHistory)(state.tr);
        const pastesFrom = typeof from === 'number' ? from : tr.selection.from;
        if (typeof from === 'number' && typeof to === 'number') tr.replaceRange(from, to, markdownSlice);
        else tr.replaceSelection(markdownSlice);
        const textPosition = tr.doc.resolve(Math.min(pastesFrom + markdownSlice.size, tr.doc.content.size));
        tr.setSelection((0, $cw0wu.TextSelection).near(textPosition, -1));
        queueCardsFromChangedTr === null || queueCardsFromChangedTr === void 0 || queueCardsFromChangedTr(state, tr, (0, $g6Qq4.INPUT_METHOD).CLIPBOARD);
        if (dispatch) dispatch(tr.scrollIntoView());
        return true;
    };
}
function $56f60153870029a8$var$removePrecedingBackTick(tr) {
    const { $from: { nodeBefore: nodeBefore }, from: from } = tr.selection;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    if (nodeBefore && nodeBefore.isText && nodeBefore.text.endsWith('`')) tr.delete(from - 1, from);
}
function $56f60153870029a8$var$hasInlineCode(state, slice) {
    return slice.content.firstChild && slice.content.firstChild.marks.some((m)=>m.type === state.schema.marks.code);
}
function $56f60153870029a8$var$rollupLeafListItems(list, leafListItems) {
    list.content.forEach((child)=>{
        if ((0, $iE5F1.isListNode)(child) || (0, $7nLBT.isListItemNode)(child) && (0, $iE5F1.isListNode)(child.firstChild)) $56f60153870029a8$var$rollupLeafListItems(child, leafListItems);
        else leafListItems.push(child);
    });
}
function $56f60153870029a8$var$shouldFlattenList(state, slice) {
    const node = slice.content.firstChild;
    return node && (0, $afHZ2.insideTable)(state) && (0, $iE5F1.isListNode)(node) && slice.openStart > slice.openEnd;
}
function $56f60153870029a8$var$sliceHasTopLevelMarks(slice) {
    let hasTopLevelMarks = false;
    slice.content.descendants((node)=>{
        if (node.marks.length > 0) hasTopLevelMarks = true;
        return false;
    });
    return hasTopLevelMarks;
}
function $56f60153870029a8$var$getTopLevelMarkTypesInSlice(slice) {
    const markTypes = new Set();
    slice.content.descendants((node)=>{
        node.marks.map((mark)=>mark.type).forEach((markType)=>markTypes.add(markType));
        return false;
    });
    return markTypes;
}
/**
 * Peels container wrapper nodes (e.g. panel, expand) added by ProseMirror's addContext()
 * so that fontSize-marked paragraphs become top-level, preserving the mark on paste.
 */ function $56f60153870029a8$var$unwrapContainerNodesWithBlockMarks(slice, schema, fontSize) {
    let content = slice.content;
    let levelsUnwrapped = 0;
    while(content.childCount === 1 && content.firstChild && !content.firstChild.isTextblock && slice.openStart - levelsUnwrapped > 1){
        let hasBlockMarkedParagraph = false;
        for(let i = 0; i < content.firstChild.childCount; i++){
            const child = content.firstChild.child(i);
            if (child.type === schema.nodes.paragraph && child.marks.some((m)=>m.type === fontSize)) {
                hasBlockMarkedParagraph = true;
                break;
            }
        }
        if (!hasBlockMarkedParagraph) break;
        content = content.firstChild.content;
        levelsUnwrapped++;
    }
    if (levelsUnwrapped === 0) return slice;
    return new (0, $kW8qW.Slice)(content, slice.openStart - levelsUnwrapped, Math.max(0, slice.openEnd - levelsUnwrapped));
}
/**
 * Returns the fontSize attrs to apply at the paste destination, or false if none.
 * Checks list and task destinations in priority order.
 */ function $56f60153870029a8$var$getDestinationFontSizeAttrs(destinationListNode, isInSmallTaskContext, $from, currentNode, fontSize) {
    if (destinationListNode) return (0, $k3wEw.getFirstParagraphBlockMarkAttrs)(destinationListNode, fontSize);
    if (isInSmallTaskContext) return (0, $k3wEw.getBlockMarkAttrs)($from.parent, fontSize) || (0, $k3wEw.getFirstParagraphBlockMarkAttrs)(currentNode, fontSize);
    return false;
}
/**
 * Resolves which marks to apply to a paragraph node after filtering forbidden marks.
 * When a destination block mark is provided, replaces any existing fontSize mark with it.
 * When normalizing for the target context, removes the fontSize mark entirely.
 * Otherwise returns the filtered marks unchanged.
 */ function $56f60153870029a8$var$resolveParagraphMarks(marks, destinationBlockMarkAttrs, shouldNormalize, fontSize) {
    if (destinationBlockMarkAttrs) return marks.filter((m)=>m.type !== fontSize).concat(fontSize.create(destinationBlockMarkAttrs));
    if (shouldNormalize) return marks.filter((m)=>m.type !== fontSize);
    return marks;
}
/**
 * Variant of `handleMarkdown` used by macro auto-conversion behind
 * `platform_editor_paste_autoconvert_robustness`.
 *
 * Differs in two ways: the inserted range is derived from the steps that were applied
 * rather than from `markdownSlice.size`, which does not account for ProseMirror's fitting
 * behaviour; and that range is reported back through `onInsert` so the caller can track
 * the inserted link across the async gap before deciding whether to swap it for a macro.
 */ function $56f60153870029a8$var$handleMarkdownWithInsertedRange(markdownSlice, queueCardsFromChangedTr, onInsert) {
    return (state, dispatch)=>{
        const tr = (0, $kQkyj.closeHistory)(state.tr);
        const replaceFrom = tr.selection.from;
        const replaceTo = tr.selection.to;
        tr.replaceSelection(markdownSlice);
        const insertedFrom = tr.mapping.map(replaceFrom, -1);
        const insertedTo = tr.mapping.map(replaceTo, 1);
        tr.setSelection((0, $cw0wu.TextSelection).near(tr.doc.resolve(Math.min(insertedTo, tr.doc.content.size)), -1));
        queueCardsFromChangedTr === null || queueCardsFromChangedTr === void 0 || queueCardsFromChangedTr(state, tr, (0, $g6Qq4.INPUT_METHOD).CLIPBOARD);
        if (dispatch) {
            dispatch(tr.scrollIntoView());
            onInsert({
                from: insertedFrom,
                to: insertedTo
            });
        }
        return true;
    };
}
function $56f60153870029a8$export$feb0d61bf65d9267(state, slice) {
    var _findParentNodeOfType2;
    if (slice.content.size === 0) return slice;
    const { schema: schema, selection: selection, selection: { $from: $from } } = state;
    const { bulletList: bulletList, orderedList: orderedList, blockTaskItem: blockTaskItem, taskItem: taskItem, paragraph: paragraph, heading: heading } = schema.nodes;
    const { fontSize: fontSize } = schema.marks;
    const hasFontSize = !!fontSize;
    // When copying from inside a container (e.g. panel, expand), ProseMirror wraps the
    // content back in the container via addContext(), increasing openStart/openEnd. Unwrap
    // so the paragraph (with its fontSize mark) becomes top-level.
    if (hasFontSize) slice = $56f60153870029a8$var$unwrapContainerNodesWithBlockMarks(slice, schema, fontSize);
    const destinationListNode = (_findParentNodeOfType2 = (0, $gab48.findParentNodeOfType)([
        bulletList,
        orderedList
    ])(selection)) === null || _findParentNodeOfType2 === void 0 ? void 0 : _findParentNodeOfType2.node;
    const currentNode = typeof $from.node === 'function' ? $from.node() : undefined;
    const isInNormalTaskContext = (currentNode === null || currentNode === void 0 ? void 0 : currentNode.type) === taskItem || $from.parent.type === taskItem;
    const isInSmallTaskContext = !!blockTaskItem && ((currentNode === null || currentNode === void 0 ? void 0 : currentNode.type) === blockTaskItem || $from.parent.type === blockTaskItem || $from.parent.type === paragraph && $from.depth > 0 && $from.node($from.depth - 1).type === blockTaskItem);
    const destinationBlockMarkAttrs = hasFontSize ? $56f60153870029a8$var$getDestinationFontSizeAttrs(destinationListNode, isInSmallTaskContext, $from, currentNode, fontSize) : false;
    const isInHeadingContext = $from.parent.type === heading;
    // If no paragraph in the slice contains marks, there's no need for special handling
    // unless we're pasting into a small-text list and need to add the destination block mark.
    // Note: this doesn't check for marks applied to lower level nodes such as text
    if (!$56f60153870029a8$var$sliceHasTopLevelMarks(slice) && !destinationBlockMarkAttrs) return slice;
    const shouldNormalizeFontSizeForTarget = hasFontSize && (!!destinationListNode || isInNormalTaskContext || isInSmallTaskContext || isInHeadingContext);
    // If pasting a single paragraph into pre-existing content, match destination formatting.
    // For bullet/ordered lists under small-text, we still need to normalize the paragraph block mark
    // so pasted content adopts the destination list state.
    const destinationHasContent = $from.parent.textContent.length > 0;
    if (slice.content.childCount === 1 && destinationHasContent && !shouldNormalizeFontSizeForTarget) return slice;
    // Check the parent of (paragraph -> text) because block marks are assigned to a wrapper
    // element around the paragraph node
    const grandparent = $from.node(Math.max(0, $from.depth - 1));
    const markTypesInSlice = $56f60153870029a8$var$getTopLevelMarkTypesInSlice(slice);
    const forbiddenMarkTypes = [];
    for (const markType of markTypesInSlice)if (!grandparent.type.allowsMarkType(markType)) forbiddenMarkTypes.push(markType);
    const normalizedContent = (0, $4ClnP.mapSlice)(slice, (node)=>{
        if (node.type === paragraph) {
            const paragraphMarks = node.marks.filter((mark)=>!forbiddenMarkTypes.includes(mark.type));
            return paragraph.createChecked(undefined, node.content, $56f60153870029a8$var$resolveParagraphMarks(paragraphMarks, destinationBlockMarkAttrs, shouldNormalizeFontSizeForTarget, fontSize));
        } else if (node.type === heading) // Preserve heading attributes to keep formatting
        return heading.createChecked(node.attrs, node.content, node.marks.filter((mark)=>!forbiddenMarkTypes.includes(mark.type)));
        return node;
    });
    if (forbiddenMarkTypes.length === 0 && !shouldNormalizeFontSizeForTarget) {
        // In a slice containing one or more paragraphs at the document level (not wrapped in
        // another node), the first paragraph will only have its text content captured and pasted
        // since openStart is 1. We decrement the open depth of the slice so it retains any block
        // marks applied to it. We only care about the depth at the start of the selection so
        // there's no need to change openEnd - the rest of the slice gets pasted correctly.
        const openStart = Math.max(0, slice.openStart - 1);
        return new (0, $kW8qW.Slice)(slice.content, openStart, slice.openEnd);
    }
    if (forbiddenMarkTypes.length === 0 && shouldNormalizeFontSizeForTarget) {
        // When pasting into a heading, keep the original openStart so ProseMirror merges inline
        // content into the heading node rather than replacing it with a paragraph.
        const openStart = isInHeadingContext ? slice.openStart : Math.max(0, slice.openStart - 1);
        return new (0, $kW8qW.Slice)(normalizedContent.content, openStart, slice.openEnd);
    }
    // If the paragraph or heading contains marks forbidden by the parent node
    // (e.g. alignment/indentation), drop those marks from the slice. For lists under the small
    // text experiment, also normalize fontSize to the destination list state.
    return new (0, $kW8qW.Slice)(normalizedContent.content, slice.openStart, slice.openEnd);
}
function $56f60153870029a8$export$79d83373d2946ba6(slice) {
    if (!slice.content.firstChild) return slice;
    const listToFlatten = slice.content.firstChild;
    const leafListItems = [];
    $56f60153870029a8$var$rollupLeafListItems(listToFlatten, leafListItems);
    const contentWithFlattenedList = slice.content.replaceChild(0, listToFlatten.type.createChecked(listToFlatten.attrs, leafListItems));
    return new (0, $kW8qW.Slice)(contentWithFlattenedList, slice.openEnd, slice.openEnd);
}
const $56f60153870029a8$var$doesSliceContainBlockquoteListNodes = (slice, listContainerNodeTypes)=>{
    var _firstChildOfSlice$ty, _lastChildOfSlice$typ;
    const firstChildOfSlice = slice.content.firstChild;
    const lastChildOfSlice = slice.content.lastChild;
    const isFirstChildBlockquoteListNode = (firstChildOfSlice === null || firstChildOfSlice === void 0 || (_firstChildOfSlice$ty = firstChildOfSlice.type) === null || _firstChildOfSlice$ty === void 0 ? void 0 : _firstChildOfSlice$ty.name) === 'blockquote' && listContainerNodeTypes.some((nodeType)=>{
        var _firstChildOfSlice$co;
        return nodeType === (firstChildOfSlice === null || firstChildOfSlice === void 0 || (_firstChildOfSlice$co = firstChildOfSlice.content.firstChild) === null || _firstChildOfSlice$co === void 0 ? void 0 : _firstChildOfSlice$co.type);
    });
    const isLastChildBlockquoteListNode = (lastChildOfSlice === null || lastChildOfSlice === void 0 || (_lastChildOfSlice$typ = lastChildOfSlice.type) === null || _lastChildOfSlice$typ === void 0 ? void 0 : _lastChildOfSlice$typ.name) === 'blockquote' && listContainerNodeTypes.some((nodeType)=>{
        var _lastChildOfSlice$con;
        return nodeType === (lastChildOfSlice === null || lastChildOfSlice === void 0 || (_lastChildOfSlice$con = lastChildOfSlice.content.firstChild) === null || _lastChildOfSlice$con === void 0 ? void 0 : _lastChildOfSlice$con.type);
    });
    return isFirstChildBlockquoteListNode || isLastChildBlockquoteListNode;
};
function $56f60153870029a8$export$f9c7e15c780a77d0(slice, queueCardsFromChangedTr) {
    return (state, dispatch)=>{
        var _slice$content, _slice$content2, _findParentNodeOfType3, _firstChildOfSlice$ty2, _lastChildOfSlice$typ2, _panelParentOverCurre;
        const { codeBlock: codeBlock, heading: heading, paragraph: paragraph, panel: panel, panel_c1: panel_c1, bulletList: bulletList, orderedList: orderedList } = state.schema.nodes;
        const { fontSize: fontSize } = state.schema.marks;
        const { selection: selection, schema: schema } = state;
        const firstChildOfSlice = (_slice$content = slice.content) === null || _slice$content === void 0 ? void 0 : _slice$content.firstChild;
        const lastChildOfSlice = (_slice$content2 = slice.content) === null || _slice$content2 === void 0 ? void 0 : _slice$content2.lastChild;
        const listContainerNodeTypes = [
            bulletList,
            orderedList
        ];
        const hasFontSize = !!fontSize;
        const destinationListNode = hasFontSize ? (_findParentNodeOfType3 = (0, $gab48.findParentNodeOfType)(listContainerNodeTypes)(selection)) === null || _findParentNodeOfType3 === void 0 ? void 0 : _findParentNodeOfType3.node : undefined;
        const destinationListFontSizeAttrs = hasFontSize ? (0, $k3wEw.getFirstParagraphBlockMarkAttrs)(destinationListNode, fontSize) : false;
        // In case user is pasting inline code,
        // any backtick ` immediately preceding it should be removed.
        let tr = state.tr;
        if ($56f60153870029a8$var$hasInlineCode(state, slice)) $56f60153870029a8$var$removePrecedingBackTick(tr);
        if ($56f60153870029a8$var$shouldFlattenList(state, slice)) slice = $56f60153870029a8$export$79d83373d2946ba6(slice);
        (0, $kQkyj.closeHistory)(tr);
        const isFirstChildListNode = (0, $iE5F1.isListNode)(firstChildOfSlice);
        const isLastChildListNode = (0, $iE5F1.isListNode)(lastChildOfSlice);
        const isSliceContentListNodes = isFirstChildListNode || isLastChildListNode;
        const isFirstChildTaskListNode = (firstChildOfSlice === null || firstChildOfSlice === void 0 || (_firstChildOfSlice$ty2 = firstChildOfSlice.type) === null || _firstChildOfSlice$ty2 === void 0 ? void 0 : _firstChildOfSlice$ty2.name) === 'taskList';
        const isLastChildTaskListNode = (lastChildOfSlice === null || lastChildOfSlice === void 0 || (_lastChildOfSlice$typ2 = lastChildOfSlice.type) === null || _lastChildOfSlice$typ2 === void 0 ? void 0 : _lastChildOfSlice$typ2.name) === 'taskList';
        const isSliceContentTaskListNodes = isFirstChildTaskListNode || isLastChildTaskListNode;
        const sliceContentBlockquoteListNodes = $56f60153870029a8$var$doesSliceContainBlockquoteListNodes(slice, listContainerNodeTypes);
        // Compute once and reuse below to avoid traversing the slice twice.
        const sliceMarkTypes = hasFontSize ? $56f60153870029a8$var$getTopLevelMarkTypesInSlice(slice) : new Set();
        const destinationIsEmpty = hasFontSize && selection.$from.parent.type === paragraph && selection.$from.parent.textContent.length === 0;
        // Capture the destination paragraph's non-fontSize block marks (e.g. alignment, indentation)
        // before the paste so they can be restored if the paste replaces the paragraph entirely
        // (which happens when small text is pasted with openStart=0).
        const destinationNonFontSizeBlockMarks = hasFontSize && selection.$from.parent.type === paragraph && sliceMarkTypes.has(fontSize) ? selection.$from.parent.marks.filter((m)=>m.type !== fontSize) : [];
        // We want to use safeInsert to insert invalid content, as it inserts at the closest non schema violating position
        // rather than spliting the selection parent node in half (which is what replaceSelection does)
        // Exception is paragraph and heading nodes, these should be split, provided their parent supports the pasted content
        const textNodes = [
            heading,
            paragraph
        ];
        const selectionParent = selection.$to.node(selection.$to.depth - 1);
        const noNeedForSafeInsert = selection.$to.node().type.validContent(slice.content) || textNodes.includes(selection.$to.node().type) && selectionParent.type.validContent(slice.content);
        // panel_c1 is a schema variant of panel; when the experiment is on, treat both together.
        const panelParentOverCurrentSelection = (0, $5N1Y4.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? (0, $gab48.findParentNodeOfType)([
            panel,
            panel_c1
        ].filter(Boolean))(tr.selection) : (0, $gab48.findParentNodeOfType)(panel)(tr.selection);
        const isTargetPanelEmpty = panelParentOverCurrentSelection && ((_panelParentOverCurre = panelParentOverCurrentSelection.node) === null || _panelParentOverCurre === void 0 ? void 0 : _panelParentOverCurre.content.size) === 2;
        if (!isSliceContentTaskListNodes && (isSliceContentListNodes || isTargetPanelEmpty)) (0, $59pV5.insertSliceForLists)({
            tr: tr,
            slice: slice,
            schema: schema
        });
        else if (noNeedForSafeInsert && !$56f60153870029a8$export$f0f8559835c0f076(state, slice)) {
            var _firstChildOfSlice$ty3, _firstChildOfSlice$co2, _firstChildOfSlice$co3;
            if ((firstChildOfSlice === null || firstChildOfSlice === void 0 || (_firstChildOfSlice$ty3 = firstChildOfSlice.type) === null || _firstChildOfSlice$ty3 === void 0 ? void 0 : _firstChildOfSlice$ty3.name) === 'blockquote' && firstChildOfSlice !== null && firstChildOfSlice !== void 0 && (_firstChildOfSlice$co2 = firstChildOfSlice.content.firstChild) !== null && _firstChildOfSlice$co2 !== void 0 && _firstChildOfSlice$co2.type.name && [
                'bulletList',
                'orderedList',
                'mediaSingle'
            ].includes(firstChildOfSlice === null || firstChildOfSlice === void 0 || (_firstChildOfSlice$co3 = firstChildOfSlice.content.firstChild) === null || _firstChildOfSlice$co3 === void 0 ? void 0 : _firstChildOfSlice$co3.type.name)) // checks if parent node is a blockquote and child node is either a bulletlist or orderedlist or mediaSingle
            (0, $59pV5.insertSliceInsideBlockquote)({
                tr: tr,
                slice: slice
            });
            else {
                var _slice$content$lastCh;
                tr.replaceSelection(slice);
                // when cursor is inside a table cell, and slice.content.lastChild is a panel, expand, or decisionList
                // need to make sure the cursor position is is right after the panel, expand, or decisionList
                // still in the same table cell, see issue: https://product-fabric.atlassian.net/browse/ED-17862
                const shouldUpdateCursorPosAfterPaste = (0, $5N1Y4.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? [
                    'panel',
                    'nestedExpand',
                    'decisionList',
                    'codeBlock'
                ].includes(slice.content.lastChild ? (0, $01Z6w.getBaseNodeTypeName)(slice.content.lastChild.type) : '') : [
                    'panel',
                    'nestedExpand',
                    'decisionList',
                    'codeBlock'
                ].includes(((_slice$content$lastCh = slice.content.lastChild) === null || _slice$content$lastCh === void 0 || (_slice$content$lastCh = _slice$content$lastCh.type) === null || _slice$content$lastCh === void 0 ? void 0 : _slice$content$lastCh.name) || '');
                const lastChild = slice.content.lastChild;
                const $nextPos = tr.doc.resolve(tr.mapping.map(selection.from));
                const nextSelection = lastChild !== null && lastChild !== void 0 && lastChild.type.isTextblock ? (0, $cw0wu.TextSelection).findFrom($nextPos, -1, true) : new (0, $j7pt0.GapCursorSelection)($nextPos, (0, $8t2a4.Side).RIGHT);
                if (nextSelection) tr.setSelection(nextSelection);
                else if ((0, $56AB9.insideTableCell)(state) && shouldUpdateCursorPosAfterPaste) {
                    const nextPos = tr.doc.resolve(tr.mapping.map(selection.$from.pos));
                    tr.setSelection(new (0, $j7pt0.GapCursorSelection)(nextPos, (0, $8t2a4.Side).RIGHT));
                }
            }
        } else {
            // need to scan the slice if there's a block node or list items inside it
            let sliceHasList = false;
            slice.content.nodesBetween(0, slice.content.size, (node)=>{
                if (node.type === state.schema.nodes.listItem) {
                    sliceHasList = true;
                    return false;
                }
            });
            if ((0, $56AB9.insideTableCell)(state) && (0, $56AB9.isInListItem)(state) && (0, $gab48.canInsert)(selection.$from, slice.content) && (0, $gab48.canInsert)(selection.$to, slice.content) || sliceHasList) tr.replaceSelection(slice);
            else if ($56f60153870029a8$export$f0f8559835c0f076(state, slice) && !$56f60153870029a8$export$67c0f4368bb304c3(state)) tr = (0, $59pV5.insertSliceForTaskInsideList)({
                tr: tr,
                slice: slice
            });
            else {
                // need safeInsert rather than replaceSelection, so that nodes aren't split in half
                // e.g. when pasting a layout into a table, replaceSelection splits the table in half and adds the layout in the middle
                tr = (0, $gab48.safeInsert)(slice.content, tr.selection.$to.pos)(tr);
                if ($56f60153870029a8$export$f0f8559835c0f076(state, slice)) (0, $59pV5.updateSelectionAfterReplace)({
                    tr: tr
                });
            }
        }
        // font size handling for pasting into lists or blockquotes
        if (hasFontSize && (isSliceContentListNodes || sliceContentBlockquoteListNodes)) {
            const containingList = (0, $gab48.findParentNodeOfTypeClosestToPos)(tr.selection.$from, listContainerNodeTypes);
            if (containingList) (0, $k3wEw.reconcileBlockMarkForContainerAtPos)(tr, containingList.pos, fontSize, isSliceContentListNodes ? destinationListFontSizeAttrs : false);
        }
        // font size handling for pasting into paragraphs (normal text) - preserve source style
        if (hasFontSize && destinationIsEmpty && !sliceMarkTypes.has(fontSize) && !destinationListNode && selection.$from.parent.type === paragraph && (0, $k3wEw.getBlockMarkAttrs)(selection.$from.parent, fontSize)) (0, $k3wEw.reconcileBlockMarkForParagraphAtPos)(tr, tr.mapping.map(selection.$from.pos), fontSize, false);
        // Restore destination block marks (e.g. alignment) that were lost when pasting small text
        // replaced the paragraph entirely (openStart=0 from container unwrap).
        if (hasFontSize && destinationNonFontSizeBlockMarks.length > 0) {
            const pastedFrom = tr.mapping.map(selection.from, -1);
            const pastedTo = tr.mapping.map(selection.to, 1);
            for (const mark of destinationNonFontSizeBlockMarks)(0, $k3wEw.reconcileBlockMarkInRange)(tr, pastedFrom, pastedTo, mark.type, mark.attrs);
        }
        tr.setStoredMarks([]);
        if (tr.selection.empty && tr.selection.$from.parent.type === codeBlock) tr.setSelection((0, $cw0wu.TextSelection).near(tr.selection.$from, 1));
        tr.scrollIntoView();
        // queue link cards, ignoring any errors
        queueCardsFromChangedTr === null || queueCardsFromChangedTr === void 0 || queueCardsFromChangedTr(state, tr, (0, $g6Qq4.INPUT_METHOD).CLIPBOARD);
        if (dispatch) dispatch(tr);
        return true;
    };
}
function $56f60153870029a8$var$isUrlString(text) {
    try {
        new URL(text);
        return true;
    } catch  {
        return false;
    }
}
function $56f60153870029a8$var$isLinkOrUrlString(slice, schema) {
    if (slice.content.childCount !== 1 || !(0, $5vR15.isParagraph)(slice.content.child(0), schema)) return false;
    const paragraph = slice.content.child(0);
    if (paragraph.content.childCount !== 1 || !(0, $5vR15.isText)(paragraph.content.child(0), schema)) return false;
    const { marks: marks, text: text = '' } = paragraph.content.child(0);
    const hasLinkMark = marks.some((mark)=>(0, $5vR15.isLinkMark)(mark, schema));
    return hasLinkMark || $56f60153870029a8$var$isUrlString(text);
}
function $56f60153870029a8$export$d399a86cc775ad7e(slice) {
    return (state, dispatch)=>{
        if ($56f60153870029a8$var$isLinkOrUrlString(slice, state.schema)) return false;
        const { caption: caption } = state.schema.nodes;
        const tr = state.tr;
        if ((0, $gab48.hasParentNodeOfType)(caption)(state.selection)) {
            // We let PM replace the selection and it will insert as text where it can't place the node
            // This is totally fine as caption is just a simple block that only contains inline contents
            // And it is more in line with WYSIWYG expectations
            tr.replaceSelection(slice).scrollIntoView();
            if (dispatch) dispatch(tr);
            return true;
        }
        return false;
    };
}
const $56f60153870029a8$export$4ce587bb5876886d = (editorAnalyticsAPI)=>(slice)=>(state, dispatch)=>{
            let tr = (0, $3pDt7.replaceSelectedTable)(state, slice);
            // add analytics after replacing selected table
            tr = (0, $ceK8a.addReplaceSelectedTableAnalytics)(state, tr, editorAnalyticsAPI);
            if (tr.docChanged) {
                if (dispatch) dispatch(tr);
                return true;
            }
            return false;
        };
function $56f60153870029a8$export$f0f8559835c0f076(state, slice) {
    var _slice$content$firstC4;
    return Boolean((0, $56AB9.isInListItem)(state) && [
        'taskList',
        'taskItem'
    ].includes(((_slice$content$firstC4 = slice.content.firstChild) === null || _slice$content$firstC4 === void 0 || (_slice$content$firstC4 = _slice$content$firstC4.type) === null || _slice$content$firstC4 === void 0 ? void 0 : _slice$content$firstC4.name) || ''));
}
function $56f60153870029a8$export$67c0f4368bb304c3(state) {
    const { selection: selection, tr: tr } = state;
    const { orderedList: orderedList, bulletList: bulletList, listItem: listItem } = state.schema.nodes;
    const selectionParentListItemNode = (0, $gab48.findParentNodeOfType)(listItem)(selection);
    const selectionParentListNodeWithPos = (0, $gab48.findParentNodeOfType)([
        bulletList,
        orderedList
    ])(selection);
    if (!selectionParentListItemNode || !selectionParentListNodeWithPos) return false;
    const grandParentListNode = (0, $gab48.findParentNodeOfTypeClosestToPos)(tr.doc.resolve(selectionParentListNodeWithPos.pos), [
        bulletList,
        orderedList
    ]);
    const selectionIsInNestedList = !!grandParentListNode;
    let selectedListItemHasNestedList = false;
    selectionParentListItemNode.node.content.forEach((child)=>{
        if ((0, $iE5F1.isListNode)(child)) selectedListItemHasNestedList = true;
    });
    return selectedListItemHasNestedList || selectionIsInNestedList;
}
function $56f60153870029a8$export$ce28e8ccb2f7a3dd(slice) {
    return (0, $4ClnP.mapSlice)(slice, (node)=>{
        if (node.type.name === 'expand' || node.type.name === 'nestedExpand') {
            const children = [];
            if (node.attrs.title) children.push(node.type.schema.nodes.paragraph.createChecked(undefined, (0, $kW8qW.Fragment).from(node.type.schema.text(node.attrs.title))));
            node.content.forEach((inner)=>children.push(inner));
            return children;
        }
        return node;
    });
}
function $56f60153870029a8$export$ce2b3491c532dd9d(slice, schema, destinationParentType) {
    const sliceJson = slice.toJSON();
    if (!sliceJson) return slice;
    const wrappedAdf = {
        type: destinationParentType,
        content: sliceJson.content ?? []
    };
    try {
        const { transformedAdf: transformedAdf, isTransformed: isTransformed } = (0, $huQpY.transformContainerNodes)(wrappedAdf, schema);
        return isTransformed && transformedAdf && transformedAdf.content && transformedAdf.content.length > 0 ? (0, $kW8qW.Slice).fromJSON(schema, {
            ...sliceJson,
            content: transformedAdf.content
        }) : slice;
    } catch  {
        return slice;
    }
}
function $56f60153870029a8$export$f596ff5b0d9c556a(html) {
    if (!html.includes('data-panel-type')) return html;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const panelDivs = Array.from(doc.querySelectorAll('div[data-panel-type]'));
    let changed = false;
    for (const panelDiv of panelDivs){
        const editorTableWrappers = Array.from(panelDiv.querySelectorAll('[data-prosemirror-node-name="table"]'));
        const rendererTableWrappers = Array.from(panelDiv.querySelectorAll('.pm-table-container')).filter((wrapper)=>wrapper.querySelector('table') !== null);
        const tableWrappers = [
            ...editorTableWrappers,
            ...rendererTableWrappers
        ];
        if (tableWrappers.length === 0) continue;
        changed = true;
        let anchor = panelDiv;
        for (const tableWrapper of tableWrappers){
            var _tableWrapper$parentN, _anchor$parentNode;
            (_tableWrapper$parentN = tableWrapper.parentNode) === null || _tableWrapper$parentN === void 0 || _tableWrapper$parentN.removeChild(tableWrapper);
            (_anchor$parentNode = anchor.parentNode) === null || _anchor$parentNode === void 0 || _anchor$parentNode.insertBefore(tableWrapper, anchor.nextSibling);
            anchor = tableWrapper;
        }
    }
    return changed ? doc.body.innerHTML : html;
}

});
parcelRegister("3pDt7", function(module, exports) {
$parcel$export(module.exports, "replaceSelectedTable", () => $3cefe304596324c1$export$ea73b328547c6ad5);

var $kW8qW = parcelRequire("kW8qW");

var $cw0wu = parcelRequire("cw0wu");

var $5BCfR = parcelRequire("5BCfR");

var $czibn = parcelRequire("czibn");
const $3cefe304596324c1$export$ea73b328547c6ad5 = (state, content)=>{
    if ((0, $czibn.isTableSelected)(state.selection)) {
        const table = (0, $5BCfR.findTable)(state.selection);
        if (table) {
            const slice = typeof content === 'string' ? new (0, $kW8qW.Slice)((0, $kW8qW.Fragment).from(state.schema.text(content)), 0, 0) : content;
            const tr = state.tr.replace(table.pos, table.pos + table.node.nodeSize, slice);
            tr.setSelection((0, $cw0wu.TextSelection).create(tr.doc, table.pos + slice.size + 1));
            return tr;
        }
    }
    return state.tr;
};

});

parcelRegister("59pV5", function(module, exports) {
$parcel$export(module.exports, "insertSliceForLists", () => $ee5f48f9b4ddad5a$export$9beec16307c108ac);
$parcel$export(module.exports, "insertSliceInsideBlockquote", () => $ee5f48f9b4ddad5a$export$2dee216d0a70c94e);
$parcel$export(module.exports, "updateSelectionAfterReplace", () => $ee5f48f9b4ddad5a$export$e57c13697a8b8195);
$parcel$export(module.exports, "insertSliceForTaskInsideList", () => $ee5f48f9b4ddad5a$export$2982aac953f7c8b6);

var $bq0hv = parcelRequire("bq0hv");

var $iE5F1 = parcelRequire("iE5F1");

var $kW8qW = parcelRequire("kW8qW");

var $cw0wu = parcelRequire("cw0wu");

var $3DNV7 = parcelRequire("3DNV7");

var $gab48 = parcelRequire("gab48");

var $ceK8a = parcelRequire("ceK8a");

var $eliEQ = parcelRequire("eliEQ");
function $ee5f48f9b4ddad5a$export$9beec16307c108ac({ tr: tr, slice: slice, schema: schema }) {
    var _slice$content$firstC;
    const { selection: selection, selection: { $to: $to, $from: $from } } = tr;
    const { $cursor: $cursor } = selection;
    const panelNode = (0, $ceK8a.isSelectionInsidePanel)(selection);
    const selectionIsInsideList = $from.blockRange($to, (0, $iE5F1.isListNode));
    if (!$cursor && selectionIsInsideList) return (0, $eliEQ.insertSliceIntoRangeSelectionInsideList)({
        tr: tr,
        slice: slice
    });
    // if inside an empty panel, try and insert content inside it rather than replace it
    if (panelNode && (0, $ceK8a.isEmptyNode)(panelNode) && $from.node() === $to.node()) return (0, $eliEQ.insertSliceInsideOfPanelNodeSelected)(panelNode)({
        tr: tr,
        slice: slice,
        schema: schema
    });
    if (!$cursor || selectionIsInsideList) return tr.replaceSelection(slice);
    if ((0, $ceK8a.isEmptyNode)(tr.doc.resolve($cursor.pos).node())) return (0, $eliEQ.insertSliceIntoEmptyNode)({
        tr: tr,
        slice: slice
    });
    // When pasting a single list item into an action or decision, we skip the special "insert at node edge"
    // logic so that prosemirror pastes the list's content into the action/decision, rather than
    // pasting a whole list node directly after the action/decision item. (But we still preserve the
    // existing "insert at" node edge" behaviour if dealing with a list with more than one item, so that
    // it still inserts whole list node after the action/decision item).
    const pastingIntoActionOrDecision = Boolean((0, $gab48.findParentNodeOfType)([
        schema.nodes.taskList,
        schema.nodes.decisionList
    ])(selection));
    const oneListItem = slice.content.childCount === 1 && (0, $iE5F1.isListNode)(slice.content.firstChild) && ((_slice$content$firstC = slice.content.firstChild) === null || _slice$content$firstC === void 0 ? void 0 : _slice$content$firstC.childCount) === 1;
    if (!(pastingIntoActionOrDecision && oneListItem) && (0, $ceK8a.isCursorSelectionAtTextStartOrEnd)(selection)) return (0, $eliEQ.insertSliceAtNodeEdge)({
        tr: tr,
        slice: slice
    });
    tr.replaceSelection(slice);
}
const $ee5f48f9b4ddad5a$var$stripFontSizeInsideBlockquoteLists = (tr, blockquotePos)=>{
    const { marks: { fontSize: fontSize }, nodes: { paragraph: paragraph, listItem: listItem, taskItem: taskItem, blockTaskItem: blockTaskItem } } = tr.doc.type.schema;
    const listItemParentNodeTypes = [
        listItem,
        taskItem,
        blockTaskItem
    ];
    if (!fontSize) return;
    const containingBlockquote = tr.doc.nodeAt(blockquotePos);
    if (!containingBlockquote) return;
    const from = blockquotePos + 1;
    const to = blockquotePos + containingBlockquote.nodeSize - 1;
    (0, $bq0hv.createToggleBlockMarkOnRangeNext)(fontSize, ()=>false, (_schema, node, parent)=>node.type === paragraph && !!parent && listItemParentNodeTypes.some((nodeType)=>nodeType === parent.type))(from, to, tr);
};
function $ee5f48f9b4ddad5a$export$2dee216d0a70c94e({ tr: tr, slice: slice }) {
    //insert blockquote explicitly and set the selection in blockquote since replaceSelection will only insert the list
    const { schema: schema } = tr.doc.type;
    tr.replaceSelection(new (0, $kW8qW.Slice)((0, $kW8qW.Fragment).from(schema.nodes.blockquote.createAndFill()), 0, 0));
    $ee5f48f9b4ddad5a$export$e57c13697a8b8195({
        tr: tr
    });
    tr.replaceSelection(slice);
    const insertedBlockquotePos = (0, $gab48.findParentNodeOfType)(schema.nodes.blockquote)(tr.selection);
    if (!insertedBlockquotePos) return;
    $ee5f48f9b4ddad5a$var$stripFontSizeInsideBlockquoteLists(tr, insertedBlockquotePos.pos);
}
function $ee5f48f9b4ddad5a$export$e57c13697a8b8195({ tr: tr }) {
    // ProseMirror doesn't give a proper way to tell us where something was inserted.
    // However, we can know "how" it inserted something.
    //
    // So, instead of weird depth calculations, we can use the step produced by the transform.
    // For instance:
    //    The `replaceStep.to and replaceStep.from`, tell us the real position
    //    where the content will be insert.
    //    Then, we can use the `tr.mapping.map` to the updated position after the replace operation
    const replaceStep = tr.steps[0];
    if (!(replaceStep instanceof (0, $3DNV7.ReplaceStep))) return tr;
    const nextPosition = tr.mapping.map(replaceStep.to);
    // The findFrom will make search for both: TextSelection and NodeSelections.
    const nextSelection = (0, $cw0wu.Selection).findFrom(tr.doc.resolve(Math.min(nextPosition, tr.doc.content.size)), -1);
    if (nextSelection) tr.setSelection(nextSelection);
}
function $ee5f48f9b4ddad5a$export$2982aac953f7c8b6({ tr: tr, slice: slice }) {
    const { schema: schema } = tr.doc.type;
    // Collapse redundant nested taskList wrappers from the slice context, always keeping a single
    // outermost taskList so the content can be safely inserted as a sibling of the list item's
    // paragraph (a listItem cannot directly contain bare taskItems).
    const { taskList: taskList } = schema.nodes;
    let content = slice.content;
    while(content.childCount === 1 && ((_content$firstChild = content.firstChild) === null || _content$firstChild === void 0 ? void 0 : _content$firstChild.type) === taskList && ((_content$firstChild$f = content.firstChild.firstChild) === null || _content$firstChild$f === void 0 ? void 0 : _content$firstChild$f.type) === taskList){
        var _content$firstChild, _content$firstChild$f;
        content = content.firstChild.content;
    }
    // safeInsert keeps the task structure intact at the closest schema-valid position, instead of
    // replacing into an empty taskItem which would add an extra taskList level.
    tr = (0, $gab48.safeInsert)(content, tr.selection.$to.pos)(tr);
    $ee5f48f9b4ddad5a$export$e57c13697a8b8195({
        tr: tr
    });
    return tr;
}

});
parcelRegister("eliEQ", function(module, exports) {
$parcel$export(module.exports, "insertSliceIntoEmptyNode", () => $91802976410f7202$export$d69afd888d46c7c);
$parcel$export(module.exports, "insertSliceAtNodeEdge", () => $91802976410f7202$export$7b48cb097052829);
$parcel$export(module.exports, "insertSliceIntoRangeSelectionInsideList", () => $91802976410f7202$export$eee44e0848f600ea);
$parcel$export(module.exports, "insertSliceInsideOfPanelNodeSelected", () => $91802976410f7202$export$778b6ddd10a6aad3);
parcelRequire("56AB9");
var $24xJB = parcelRequire("24xJB");

var $kW8qW = parcelRequire("kW8qW");

var $cw0wu = parcelRequire("cw0wu");

var $3DNV7 = parcelRequire("3DNV7");

var $gab48 = parcelRequire("gab48");
function $91802976410f7202$export$d69afd888d46c7c({ tr: tr, slice: slice }) {
    tr.replaceSelection(slice);
}
function $91802976410f7202$export$7b48cb097052829({ tr: tr, slice: slice }) {
    const { selection: selection } = tr;
    const { $cursor: $cursor } = selection;
    if (!$cursor) return;
    const position = !$cursor.nodeBefore ? $cursor.before() : $cursor.after();
    tr.replaceRange(position, position, slice);
    const startSlicePosition = tr.doc.resolve(Math.min(position + slice.content.size - slice.openEnd, tr.doc.content.size));
    const direction = -1;
    tr.setSelection((0, $cw0wu.TextSelection).near(startSlicePosition, direction));
}
function $91802976410f7202$export$eee44e0848f600ea({ tr: tr, slice: slice }) {
    const { selection: { $to: $to, $from: $from, to: to, from: from } } = tr;
    // when the selection is inside of the same list item
    // we can use a normal replace
    if ($from.sameParent($to) || $from.depth === $to.depth) return tr.replaceSelection(slice);
    // if pasting a list inside another list, ensure no empty list items get added
    const newRange = $from.blockRange($to);
    if (!newRange) return;
    const startPos = from;
    const endPos = $to.nodeAfter ? to : to + 2;
    const newSlice = tr.doc.slice(endPos, newRange.end);
    tr.deleteRange(startPos, newRange.end);
    const mapped = tr.mapping.map(startPos);
    tr.replaceRange(mapped, mapped, slice);
    if (newSlice.size <= 0) return;
    const newSelection = (0, $cw0wu.TextSelection).near(tr.doc.resolve(tr.mapping.map(mapped)), -1);
    // @ts-ignore - [unblock prosemirror bump] assigning to readonly prop
    newSlice.openEnd = newSlice.openStart;
    tr.replaceRange(newSelection.from, newSelection.from, newSlice);
    tr.setSelection((0, $cw0wu.TextSelection).near(tr.doc.resolve(newSelection.from), -1));
}
function $91802976410f7202$export$778b6ddd10a6aad3(panelNode) {
    return ({ tr: tr, slice: slice, schema: schema })=>{
        const { selection: selection, selection: { $to: $to, $from: $from } } = tr;
        const { from: panelPosition } = selection;
        // if content of slice isn't valid for a panel node, insert the invalid node and following content after
        if (panelNode && !panelNode.type.validContent((0, $kW8qW.Fragment).from(slice.content))) {
            var _parentNode$firstChil;
            let insertPosition = $to.pos + 1;
            /* Adapting above logic to handle MBE, as it currently assumes that slice can be safely inserted after the panel node, which is not the case for MBE
            If insertPosition is in MBE and current slice contains invalid content for MBE, we need to insert the slice after the MBE node
         */ if (schema) {
                const mbeParentOfPanel = (0, $gab48.findParentNodeOfType)(schema.nodes.multiBodiedExtension)(selection);
                if (mbeParentOfPanel && !mbeParentOfPanel.node.type.validContent((0, $kW8qW.Fragment).from(slice.content))) insertPosition = mbeParentOfPanel.start + mbeParentOfPanel.node.nodeSize - 1;
            }
            tr.replaceRange(insertPosition, insertPosition, slice);
            // need to delete the empty paragraph at the top of the panel
            const parentNode = tr.doc.resolve($from.before()).node();
            if (parentNode && parentNode.childCount > 1 && ((_parentNode$firstChil = parentNode.firstChild) === null || _parentNode$firstChil === void 0 ? void 0 : _parentNode$firstChil.type.name) === 'paragraph' && (0, $24xJB.isEmptyParagraph)(parentNode.firstChild)) {
                const startPosDelete = tr.doc.resolve($from.before()).posAtIndex(0);
                const endPosDelete = tr.doc.resolve($from.before()).posAtIndex(1);
                const SIZE_OF_EMPTY_PARAGRAPH = 2; // {startPos}<p>{startPos + 1}</p>{endPos}
                if (endPosDelete - startPosDelete === SIZE_OF_EMPTY_PARAGRAPH) tr.delete(startPosDelete, endPosDelete);
            }
            tr.setSelection((0, $cw0wu.TextSelection).near(tr.doc.resolve(insertPosition + slice.content.size - slice.openStart - slice.openEnd + 1)));
            return;
        }
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const temporaryDoc = new (0, $3DNV7.Transform)(tr.doc.type.createAndFill());
        temporaryDoc.replaceRange(0, temporaryDoc.doc.content.size, slice);
        const sliceWithoutInvalidListSurrounding = temporaryDoc.doc.slice(0);
        const newPanel = panelNode.copy(sliceWithoutInvalidListSurrounding.content);
        const panelNodeSelected = selection instanceof (0, $cw0wu.NodeSelection) ? selection.node : null;
        const replaceFrom = panelNodeSelected ? panelPosition : tr.doc.resolve(panelPosition).start();
        const replaceTo = panelNodeSelected ? panelPosition + panelNodeSelected.nodeSize : replaceFrom;
        tr.replaceRangeWith(replaceFrom, replaceTo, newPanel);
        tr.setSelection((0, $cw0wu.TextSelection).near(tr.doc.resolve($from.pos + newPanel.content.size), -1));
    };
}

});




parcelRegister("aJlUO", function(module, exports) {
$parcel$export(module.exports, "createClipboardParser", () => $4e8797c4cbf3a521$export$973a4e50710cf49d);

var $kW8qW = parcelRequire("kW8qW");

var $5N1Y4 = parcelRequire("5N1Y4");
/**
 * Builds additional parseDOM rules to inject into the clipboard parser.
 *
 * Adding a rule with a higher priority than the default schema rules, allows
 * specific HTML patterns to be parsed as a different node type than the schema
 * would normally choose.
 */ function $4e8797c4cbf3a521$var$buildAdditionalClipboardParseRules(schema) {
    var _panel$spec$parseDOM;
    const rules = [];
    // This means that panels with tables inside always stay as panel_c1,
    // but panels without tables retain standard behaviour
    // of choosing between panel_c1 and panel depending on the context.
    // e.g. panel with table pasted in expand gets lifted out, panel with normal text gets pasted inside expand
    const { panel_c1: panel_c1, panel: panel } = schema.nodes;
    if (!panel_c1 || !panel) return rules;
    const panelGetAttrs = (_panel$spec$parseDOM = panel.spec.parseDOM) === null || _panel$spec$parseDOM === void 0 || (_panel$spec$parseDOM = _panel$spec$parseDOM[0]) === null || _panel$spec$parseDOM === void 0 ? void 0 : _panel$spec$parseDOM.getAttrs;
    rules.push({
        tag: 'div[data-panel-type]',
        priority: 60,
        node: panel_c1.name,
        getAttrs: (dom)=>{
            const hasEditorTable = dom.querySelector('[data-prosemirror-node-name="table"]') !== null;
            const hasRendererTable = dom.querySelector('.pm-table-container table') !== null;
            const hasTable = hasEditorTable || hasRendererTable;
            if (!hasTable) return false; // fall through to standard panel rule
            return panelGetAttrs ? panelGetAttrs(dom) : null;
        }
    });
    return rules;
}
function $4e8797c4cbf3a521$export$973a4e50710cf49d(schema) {
    if (!(0, $5N1Y4.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true)) return undefined;
    const additionalRules = $4e8797c4cbf3a521$var$buildAdditionalClipboardParseRules(schema);
    const baseParser = (0, $kW8qW.DOMParser).fromSchema(schema);
    const customParser = new (0, $kW8qW.DOMParser)(schema, [
        ...additionalRules,
        ...baseParser.rules
    ]);
    return customParser;
}

});

parcelRegister("lkqkP", function(module, exports) {
$parcel$export(module.exports, "createClipboardTextSerializer", () => $df736f0ce73b6457$export$98b67e7d9513bbaf);

var $cOmYT = parcelRequire("cOmYT");
function $df736f0ce73b6457$export$98b67e7d9513bbaf(intl) {
    return (slice)=>{
        const blockSeparator = '\n\n';
        return slice.content.textBetween(0, slice.content.size, blockSeparator, (leafNode)=>{
            switch(leafNode.type.name){
                case 'hardBreak':
                    return '\n';
                case 'text':
                    return leafNode.text;
                case 'inlineCard':
                    return leafNode.attrs.url;
                case 'blockCard':
                    return leafNode.attrs.url;
                // Note: Due to relying on an async fetch of the Mention name by the Node's React component,
                // pasting a mention does not actually work for the in-product Mention implementation.
                // However, this is also true of the previous implementation.
                // Bug ticket: https://product-fabric.atlassian.net/browse/ED-23076
                case 'mention':
                    return leafNode.attrs.text;
                case 'date':
                    return (0, $cOmYT.timestampToString)(leafNode.attrs.timestamp, intl);
                default:
                    // Unsupported node
                    return leafNode.text ?? '';
            }
        });
    };
}

});

parcelRegister("3yvGB", function(module, exports) {
$parcel$export(module.exports, "handleVSCodeBlock", () => $61c43b99c6523177$export$d920fedcc56c4475);

var $jMMBQ = parcelRequire("jMMBQ");

var $4ClnP = parcelRequire("4ClnP");
function $61c43b99c6523177$var$safelyGetVSCodeLanguage(editorData) {
    try {
        const vscodeData = editorData ? JSON.parse(editorData) : undefined;
        return vscodeData === null || vscodeData === void 0 ? void 0 : vscodeData.mode;
    } catch  {}
}
function $61c43b99c6523177$export$d920fedcc56c4475({ state: state, slice: slice, text: text, event: event }) {
    var _event$clipboardData;
    const vscodeData = event === null || event === void 0 || (_event$clipboardData = event.clipboardData) === null || _event$clipboardData === void 0 ? void 0 : _event$clipboardData.getData('vscode-editor-data');
    const language = $61c43b99c6523177$var$safelyGetVSCodeLanguage(vscodeData);
    if (text && language && (0, $jMMBQ.SUPPORTED_LANGUAGES).some((l)=>l.alias[0] === language)) {
        const { schema: schema } = state;
        slice = (0, $4ClnP.mapSlice)(slice, (node)=>{
            var _schema$nodes$codeBlo;
            if (node.type.name === ((_schema$nodes$codeBlo = schema.nodes.codeBlock) === null || _schema$nodes$codeBlo === void 0 ? void 0 : _schema$nodes$codeBlo.name)) return schema.nodes.codeBlock.createChecked({
                language: language
            }, schema.text(text));
            return node;
        });
    }
    return slice;
}

});

parcelRegister("aQyop", function(module, exports) {
$parcel$export(module.exports, "getMarkdownSliceViaGfm", () => $edeb5f5b7cad5a04$export$8457533209b7e8af);

var $j2Y9J = parcelRequire("j2Y9J");

var $kW8qW = parcelRequire("kW8qW");

var $ceK8a = parcelRequire("ceK8a");
function $edeb5f5b7cad5a04$export$8457533209b7e8af(text, schema, openStart, openEnd, markdownToPmConverter, wrapBareUrls) {
    // The injected GFM converter enables tables, task lists, and strikethrough
    // individually, but does not enable the GFM autolink-literal extension. In
    // the treatment, wrap bare URLs in CommonMark autolink syntax so the card
    // plugin receives a link mark to resolve. Preserve the current behavior in
    // control while the fix rolls out.
    const escapedTextInput = (0, $ceK8a.escapeBackslashAndLinksExceptCodeBlock)(text, {
        skipLinkEscaping: !wrapBareUrls
    });
    try {
        const doc = schema.nodes.doc.createAndFill({}, markdownToPmConverter({
            markdown: escapedTextInput,
            schema: schema
        }));
        if (doc && doc.content) return new (0, $kW8qW.Slice)(doc.content, openStart, openEnd);
    } catch (e) {
        (0, $j2Y9J.logException)(e instanceof Error ? e : new Error(String(e)), {
            location: 'editor-plugin-paste/getMarkdownSlice'
        });
    }
    return undefined;
}

});

parcelRegister("kHGZD", function(module, exports) {
$parcel$export(module.exports, "normalizePastedCodeBlockAttrs", () => $93b18b87f24c8dde$export$85bff74b6f63f849);

var $3J3tU = parcelRequire("3J3tU");
const $93b18b87f24c8dde$var$isCodeBlockWithUnsetWrap = (node)=>node.attrs.wrap === null;
const $93b18b87f24c8dde$var$patchInsertedCodeBlocks = (tr, insertedCodeBlocks)=>{
    insertedCodeBlocks.forEach(({ node: node, pos: pos })=>{
        tr.setNodeMarkup(pos, undefined, (0, $3J3tU.getDefaultCodeBlockAttrs)(node.attrs), node.marks);
    });
};
const $93b18b87f24c8dde$export$85bff74b6f63f849 = (tr, codeBlockType)=>{
    if (!codeBlockType) return tr;
    const insertedCodeBlocks = (0, $3J3tU.getInsertedCodeBlocksInTransaction)(tr, codeBlockType, {
        filter: $93b18b87f24c8dde$var$isCodeBlockWithUnsetWrap
    });
    if (insertedCodeBlocks.length) $93b18b87f24c8dde$var$patchInsertedCodeBlocks(tr, insertedCodeBlocks);
    return tr;
};

});

parcelRegister("1lYCt", function(module, exports) {
$parcel$export(module.exports, "handleSyncBlocksPaste", () => $5f69e62339713d66$export$27da60ebda8ac583);

var $9RSBE = parcelRequire("9RSBE");

var $g6Qq4 = parcelRequire("g6Qq4");

var $4ClnP = parcelRequire("4ClnP");

var $dpcHd = parcelRequire("dpcHd");

var $7I6p2 = parcelRequire("7I6p2");

var $3pcnU = parcelRequire("3pcnU");
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $5f69e62339713d66$var$RESOURCE_ID_REGEX = /data-resource-id="(confluence-page|jira-work-item)\//;
var $5f69e62339713d66$var$FLAG_ID = /*#__PURE__*/ function(FLAG_ID) {
    FLAG_ID["CANNOT_PASTE_CONTENT"] = "cannot-paste-content";
    return FLAG_ID;
}($5f69e62339713d66$var$FLAG_ID || {});
const $5f69e62339713d66$var$transformSyncBlockNode = (node, schema, isFromEditor)=>{
    // if copying from renderer, flatten out the content and remove the sync block
    if (!isFromEditor) return node.content;
    // sync blocks need a unique localId to function correctly
    const newAttrs = {
        ...node.attrs,
        localId: (0, $9RSBE.uuid).generate()
    };
    return schema.nodes.syncBlock.create(newAttrs, null, [
        ...node.marks
    ]);
};
const $5f69e62339713d66$var$transformBodiedSyncBlockNode = (node, isFromEditor)=>{
    // if copying from renderer, flatten out the content and remove the bodied sync block
    if (!isFromEditor) return node.content;
    // this is not possible as all bodiedSyncBlocks have already been converted into a syncBlock by now.
    return node;
};
const $5f69e62339713d66$var$showWarningFlag = ({ api: api, title: title, description: description, urlText: urlText, urlHref: urlHref })=>{
    // Use setTimeout to dispatch transaction in next tick and avoid re-entrant dispatch
    setTimeout(()=>{
        api === null || api === void 0 || api.core.actions.execute(({ tr: tr })=>{
            const flag = {
                id: "cannot-paste-content",
                description: description,
                title: title,
                urlText: urlText,
                urlHref: urlHref,
                type: (0, $7I6p2.FLAG_TYPE).WARNING
            };
            return tr.setMeta((0, $3pcnU.pluginKey), {
                type: (0, $dpcHd.PastePluginActionTypes).SET_ACTIVE_FLAG,
                activeFlag: flag
            });
        });
    }, 0);
};
// Check if rawHtml contains a synced block
// example: "<meta charset='utf-8'><html><head></head><body><div data-sync-block=\"\" data-local-id=\"\" data-resource-id=\"d64883c8-1270-431d-a1d3-51d36a1ed5f4\" data-prosemirror-content-type=\"node\" data-prosemirror-node-name=\"syncBlock\" data-prosemirror-node-block=\"true\" data-pm-slice=\"0 0 []\"></div></body></html>"
const $5f69e62339713d66$var$hasSyncedBlockInRawHtml = (rawHtml)=>{
    return Boolean(rawHtml === null || rawHtml === void 0 ? void 0 : rawHtml.includes('data-sync-block="'));
};
/**
 * Extracts the source product of a synced block reference from the pasted raw HTML.
 *
 * A reference block's `data-resource-id` is prefixed with the source product, e.g.
 * `confluence-page/5769323474/cdf6a1bc-...`. We only ever emit a controlled,
 * enumerated value (`confluence-page` | `jira-work-item`) so the resulting
 * analytics attribute can never carry user-generated content. Returns `undefined`
 * when the marker is missing or the prefix is unrecognised.
 *
 * Note: this intentionally mirrors `getSourceProductFromResourceIdSafe` from
 * `@atlaskit/editor-synced-block-provider/utils` but is duplicated locally to
 * avoid adding a cross-package dependency from the paste plugin onto the
 * synced-block provider.
 */ const $5f69e62339713d66$var$getSourceProductFromRawHtml = (rawHtml)=>{
    // The capture group already constrains the match to exactly these two literals,
    // so the assertion is safe. This mirrors `getContentIdAndProductFromResourceId`
    // in `@atlaskit/editor-synced-block-provider`.
    const match = rawHtml.match($5f69e62339713d66$var$RESOURCE_ID_REGEX);
    return match === null || match === void 0 ? void 0 : match[1];
};
const $5f69e62339713d66$export$27da60ebda8ac583 = (slice, schema, pasteSource, rawHtml, pasteWarningOptions, api)=>{
    const isFromEditor = pasteSource === 'fabric-editor';
    const isSyncedBlockInRawHtml = $5f69e62339713d66$var$hasSyncedBlockInRawHtml(rawHtml);
    let hasSyncedBlockInSlice = false;
    slice = (0, $4ClnP.mapSlice)(slice, (node)=>{
        if (node.type === schema.nodes.syncBlock) {
            hasSyncedBlockInSlice = true;
            return $5f69e62339713d66$var$transformSyncBlockNode(node, schema, isFromEditor);
        } else if (node.type === schema.nodes.bodiedSyncBlock) {
            hasSyncedBlockInSlice = true;
            return $5f69e62339713d66$var$transformBodiedSyncBlockNode(node, isFromEditor);
        }
        return node;
    });
    // A synced block reference was on the clipboard (`isSyncedBlockInRawHtml`) but the
    // destination schema dropped it (`!hasSyncedBlockInSlice`) — i.e. the user attempted
    // to insert a synced block into a surface that does not support synced blocks (e.g.
    // Bitbucket). Emit a track event so this can be measured directly instead of relying
    // on the "copied-but-never-landed" proxy. See EDITOR-7749.
    if (!hasSyncedBlockInSlice && isSyncedBlockInRawHtml) {
        var _api$analytics;
        api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 || (_api$analytics = _api$analytics.actions) === null || _api$analytics === void 0 || _api$analytics.fireAnalyticsEvent({
            eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
            action: (0, $g6Qq4.ACTION).INSERT_ATTEMPTED,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).SYNCED_BLOCK,
            actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).UNSUPPORTED_SURFACE,
            attributes: {
                sourceProduct: $5f69e62339713d66$var$getSourceProductFromRawHtml(rawHtml),
                pasteSource: pasteSource
            }
        });
        if (pasteWarningOptions !== null && pasteWarningOptions !== void 0 && pasteWarningOptions.cannotPasteSyncedBlock) {
            var _pasteWarningOptions$, _pasteWarningOptions$2, _pasteWarningOptions$3, _pasteWarningOptions$4;
            $5f69e62339713d66$var$showWarningFlag({
                api: api,
                title: pasteWarningOptions === null || pasteWarningOptions === void 0 || (_pasteWarningOptions$ = pasteWarningOptions.cannotPasteSyncedBlock) === null || _pasteWarningOptions$ === void 0 ? void 0 : _pasteWarningOptions$.title,
                description: pasteWarningOptions === null || pasteWarningOptions === void 0 || (_pasteWarningOptions$2 = pasteWarningOptions.cannotPasteSyncedBlock) === null || _pasteWarningOptions$2 === void 0 ? void 0 : _pasteWarningOptions$2.description,
                urlText: pasteWarningOptions === null || pasteWarningOptions === void 0 || (_pasteWarningOptions$3 = pasteWarningOptions.cannotPasteSyncedBlock) === null || _pasteWarningOptions$3 === void 0 ? void 0 : _pasteWarningOptions$3.urlText,
                urlHref: pasteWarningOptions === null || pasteWarningOptions === void 0 || (_pasteWarningOptions$4 = pasteWarningOptions.cannotPasteSyncedBlock) === null || _pasteWarningOptions$4 === void 0 ? void 0 : _pasteWarningOptions$4.urlHref
            });
        }
    }
    return slice;
};

});
parcelRegister("7I6p2", function(module, exports) {
$parcel$export(module.exports, "FLAG_TYPE", () => $17bd22b33713fee9$export$5e592dcf077082fd);
var $17bd22b33713fee9$export$5e592dcf077082fd = /*#__PURE__*/ function(FLAG_TYPE) {
    FLAG_TYPE["WARNING"] = "warning";
    FLAG_TYPE["ERROR"] = "error";
    FLAG_TYPE["INFO"] = "info";
    FLAG_TYPE["SUCCESS"] = "success";
    return FLAG_TYPE;
}({});

});


parcelRegister("amZZk", function(module, exports) {
$parcel$export(module.exports, "isPastedFromTinyMCEConfluence", () => $ca77d9659c3c21e5$export$4a3cccc9bf9da386);
$parcel$export(module.exports, "htmlHasIncompleteTable", () => $ca77d9659c3c21e5$export$120b137b77798e76);
$parcel$export(module.exports, "tryRebuildCompleteTableHtml", () => $ca77d9659c3c21e5$export$253f7bda9f1e0696);

var $gBGMF = parcelRequire("gBGMF");
const $ca77d9659c3c21e5$var$isPastedFromTinyMCE = (pasteEvent)=>{
    var _pasteEvent$clipboard;
    return (pasteEvent === null || pasteEvent === void 0 || (_pasteEvent$clipboard = pasteEvent.clipboardData) === null || _pasteEvent$clipboard === void 0 || (_pasteEvent$clipboard = _pasteEvent$clipboard.types) === null || _pasteEvent$clipboard === void 0 ? void 0 : _pasteEvent$clipboard.some((mimeType)=>mimeType === 'x-tinymce/html')) ?? false;
};
const $ca77d9659c3c21e5$export$4a3cccc9bf9da386 = (pasteEvent, html)=>{
    return $ca77d9659c3c21e5$var$isPastedFromTinyMCE(pasteEvent) && !!html && // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    !!html.match(/class=\"\s?(confluenceTd|confluenceTh|confluenceTable).+"/gim);
};
const $ca77d9659c3c21e5$export$4552e3fc797fc52a = (html)=>{
    const parser = new DOMParser();
    const nonTableWrappedDoc = parser.parseFromString(html, 'text/html');
    const tableWrappedDoc = parser.parseFromString(`<table>${html}</table>`, 'text/html');
    tableWrappedDoc.body.querySelectorAll('meta').forEach((meta)=>{
        tableWrappedDoc.head.prepend(meta);
    });
    return {
        tableWrappedDoc: tableWrappedDoc,
        nonTableWrappedDoc: nonTableWrappedDoc
    };
};
const $ca77d9659c3c21e5$var$exactlyDivisible = (larger, smaller)=>larger % smaller === 0;
const $ca77d9659c3c21e5$var$getTableElementsInfo = (doc)=>{
    const cellCount = doc.querySelectorAll('td').length;
    const thCount = doc.querySelectorAll('th').length;
    const mergedCellCount = doc.querySelectorAll('td[colspan]:not([colspan="1"])').length;
    let hasThAfterTd = false;
    const thsAndCells = doc.querySelectorAll('th,td');
    for(let i = 0, cellFound = false; i < thsAndCells.length; i++){
        if (cellFound && thsAndCells[i].nodeName === 'TH') {
            hasThAfterTd = true;
            break;
        }
        if (thsAndCells[i].nodeName === 'TD') cellFound = true;
    }
    const onlyTh = thCount > 0 && cellCount === 0;
    const onlyCells = cellCount > 0 && thCount === 0;
    const hasCompleteRow = // we take header-only and cell-only tables to be
    // row-complete
    onlyTh || onlyCells || // if headers and cells can "fit" against each other,
    // then we assume a complete row exists
    ($ca77d9659c3c21e5$var$exactlyDivisible(thCount, cellCount) || $ca77d9659c3c21e5$var$exactlyDivisible(cellCount, thCount)) && // all numbers are divisible by 1, so we carve out a specific
    // check for when there is only 1 table cell, and more than 1
    // table header.
    !(thCount > 1 && cellCount === 1);
    return {
        cellCount: cellCount,
        thCount: thCount,
        mergedCellCount: mergedCellCount,
        hasThAfterTd: hasThAfterTd,
        hasIncompleteRow: !hasCompleteRow
    };
};
const $ca77d9659c3c21e5$var$configureTableRows = (doc, colsInRow)=>{
    var _Array$from;
    const tableHeadersAndCells = Array.from(doc.body.querySelectorAll('th,td'));
    const evenlySplitChunks = (0, (/*@__PURE__*/$parcel$interopDefault($gBGMF)))(tableHeadersAndCells, colsInRow);
    const tableBody = doc.body.querySelector('tbody');
    evenlySplitChunks.forEach((chunk)=>{
        const tr = doc.createElement('tr');
        tableBody === null || tableBody === void 0 || tableBody.append(tr);
        tr.append(...chunk);
    });
    // We remove any leftover empty rows which may cause fabric editor
    // to no-op when parsing the table
    const emptyRows = (_Array$from = Array.from(tableBody.querySelectorAll('tr'))) === null || _Array$from === void 0 ? void 0 : _Array$from.filter((row)=>row.innerHTML.trim().length === 0);
    emptyRows.forEach((row)=>row.remove());
    return doc.body.innerHTML;
};
const $ca77d9659c3c21e5$var$fillIncompleteRowWithEmptyCells = (doc, thCount, cellCount)=>{
    var _lastCell$parentEleme;
    let extraCellsCount = 0;
    while(!$ca77d9659c3c21e5$var$exactlyDivisible(cellCount + extraCellsCount, thCount))extraCellsCount++;
    const extraEmptyCells = Array.from(Array(extraCellsCount)).map(()=>doc.createElement('td'));
    const lastCell = doc.body.querySelector('td:last-of-type');
    lastCell === null || lastCell === void 0 || (_lastCell$parentEleme = lastCell.parentElement) === null || _lastCell$parentEleme === void 0 || _lastCell$parentEleme.append(...extraEmptyCells);
    return {
        updatedCellCount: cellCount + extraCellsCount
    };
};
const $ca77d9659c3c21e5$export$d749bb0e238929f2 = (doc)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line prefer-const
    let { cellCount: cellCount, thCount: thCount, mergedCellCount: mergedCellCount, hasThAfterTd: hasThAfterTd, hasIncompleteRow: hasIncompleteRow } = $ca77d9659c3c21e5$var$getTableElementsInfo(doc);
    if (mergedCellCount || hasThAfterTd) // bail out to avoid handling more complex table structures
    return doc.body.innerHTML;
    if (!thCount) // if no table headers exist for reference, fallback to a single column table structure
    return $ca77d9659c3c21e5$var$configureTableRows(doc, 1);
    if (hasIncompleteRow) {
        // if shift-click selection copies a partial table row to the clipboard,
        // and we do have table headers for reference, then we add empty table cells
        // to fill out the partial row
        const { updatedCellCount: updatedCellCount } = $ca77d9659c3c21e5$var$fillIncompleteRowWithEmptyCells(doc, thCount, cellCount);
        cellCount = updatedCellCount;
    }
    for(let possibleColsInRow = thCount; possibleColsInRow > 0; possibleColsInRow--){
        if ($ca77d9659c3c21e5$var$exactlyDivisible(thCount, possibleColsInRow) && $ca77d9659c3c21e5$var$exactlyDivisible(cellCount, possibleColsInRow)) return $ca77d9659c3c21e5$var$configureTableRows(doc, possibleColsInRow);
    }
    return doc.body.innerHTML;
};
const $ca77d9659c3c21e5$export$120b137b77798e76 = (html)=>{
    return !html.includes('<table ') && (html.includes('<td ') || html.includes('<th '));
};
const $ca77d9659c3c21e5$export$253f7bda9f1e0696 = (incompleteTableHtml)=>{
    // first we try wrapping the table elements with <table> and let DOMParser try to rebuild
    // a valid DOM tree. we also keep the non-wrapped table for comparison purposes.
    const { nonTableWrappedDoc: nonTableWrappedDoc, tableWrappedDoc: tableWrappedDoc } = $ca77d9659c3c21e5$export$4552e3fc797fc52a(incompleteTableHtml);
    const didPreserveTableElements = Boolean(!nonTableWrappedDoc.body.querySelector('th, td') && tableWrappedDoc.body.querySelector('th, td'));
    const isExpectedStructure = tableWrappedDoc.querySelectorAll('body > table:only-child') && !tableWrappedDoc.querySelector(`body > table > tbody > tr > :not(th,td)`);
    // if DOMParser saves table elements that we would otherwise lose, and
    // if the table html is what we'd expect (a single table, with no extraneous
    // elements in table rows other than th, td), then we can now also try to
    // rebuild table rows/columns.
    if (didPreserveTableElements && isExpectedStructure) {
        const completeTableHtml = $ca77d9659c3c21e5$export$d749bb0e238929f2(tableWrappedDoc);
        return completeTableHtml;
    }
    return null;
};

});
parcelRegister("gBGMF", function(module, exports) {

var $5M0WW = parcelRequire("5M0WW");

var $jIpbb = parcelRequire("jIpbb");

var $mx0kf = parcelRequire("mx0kf");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $c1714a1007538c98$var$nativeCeil = Math.ceil, $c1714a1007538c98$var$nativeMax = Math.max;
/**
 * Creates an array of elements split into groups the length of `size`.
 * If `array` can't be split evenly, the final chunk will be the remaining
 * elements.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to process.
 * @param {number} [size=1] The length of each chunk
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the new array of chunks.
 * @example
 *
 * _.chunk(['a', 'b', 'c', 'd'], 2);
 * // => [['a', 'b'], ['c', 'd']]
 *
 * _.chunk(['a', 'b', 'c', 'd'], 3);
 * // => [['a', 'b', 'c'], ['d']]
 */ function $c1714a1007538c98$var$chunk(array, size, guard) {
    if (guard ? $jIpbb(array, size, guard) : size === undefined) size = 1;
    else size = $c1714a1007538c98$var$nativeMax($mx0kf(size), 0);
    var length = array == null ? 0 : array.length;
    if (!length || size < 1) return [];
    var index = 0, resIndex = 0, result = Array($c1714a1007538c98$var$nativeCeil(length / size));
    while(index < length)result[resIndex++] = $5M0WW(array, index, index += size);
    return result;
}
module.exports = $c1714a1007538c98$var$chunk;

});



parcelRegister("7ZBKT", function(module, exports) {
$parcel$export(module.exports, "createPlugin", () => $2a7d5607191c4829$export$ae829ec7b2625219);

var $g6Qq4 = parcelRequire("g6Qq4");

var $f7Kk4 = parcelRequire("f7Kk4");

var $34JcT = parcelRequire("34JcT");

var $e162G = parcelRequire("e162G");

var $aMoFs = parcelRequire("aMoFs");

var $j1IcO = parcelRequire("j1IcO");

var $fEteO = parcelRequire("fEteO");
const $2a7d5607191c4829$export$ae829ec7b2625219 = (dispatch, editorAnalyticsAPI)=>{
    // This variable is used to distinguish between copy and cut events in transformCopied.
    let isCutEvent = false;
    return new (0, $f7Kk4.SafePlugin)({
        key: (0, $aMoFs.pluginKey),
        state: (0, $e162G.createPluginState)(dispatch, (0, $j1IcO.defaultState)),
        props: {
            handleDOMEvents: {
                cut: ()=>{
                    isCutEvent = true;
                }
            },
            handlePaste: ({ state: state, dispatch: dispatch }, _event, slice)=>{
                var _content$firstChild;
                // The state was cleaned after previous paste. We don't need to update plugin state
                // with 'contentPasted' if currentActions array doesn't have 'copiedOrCut'.
                const { contentMoved: contentMoved } = (0, $e162G.getPluginState)(state);
                const hasCutAction = contentMoved.currentActions.includes('contentCut');
                if (!hasCutAction) return;
                const { content: content } = slice;
                const nodeName = (_content$firstChild = content.firstChild) === null || _content$firstChild === void 0 ? void 0 : _content$firstChild.type.name;
                if (!nodeName || !(contentMoved !== null && contentMoved !== void 0 && contentMoved.nodeTypes) || !(0, $fEteO.isCursorSelectionAtTopLevel)(state.selection)) return;
                const { tr: tr } = state;
                editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent({
                    action: (0, $g6Qq4.ACTION).MOVED,
                    actionSubject: (0, $g6Qq4.ACTION_SUBJECT).DOCUMENT,
                    actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).NODE,
                    eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
                    attributes: {
                        nodeDepth: contentMoved === null || contentMoved === void 0 ? void 0 : contentMoved.nodeDepth,
                        destinationNodeDepth: (0, $fEteO.getParentNodeDepth)(state.selection),
                        nodeTypes: contentMoved === null || contentMoved === void 0 ? void 0 : contentMoved.nodeTypes,
                        hasSelectedMultipleNodes: contentMoved === null || contentMoved === void 0 ? void 0 : contentMoved.hasSelectedMultipleNodes
                    }
                })(tr);
                // reset to default state
                const updatedTr = (0, $34JcT.resetContentMovedTransform)()(tr);
                dispatch(updatedTr);
            },
            transformCopied: (slice, { state: state, dispatch: dispatch })=>{
                var _content$firstChild2;
                // We want to listen only to 'cut' events
                if (!isCutEvent) return slice;
                let resetState = false;
                const { content: content, size: size } = slice;
                const { selection: selection } = state;
                const nodeName = ((_content$firstChild2 = content.firstChild) === null || _content$firstChild2 === void 0 ? void 0 : _content$firstChild2.type.name) || '';
                let nodeTypes, hasSelectedMultipleNodes = false;
                if (content.childCount > 1) {
                    if ((0, $fEteO.containsExcludedNode)(content)) resetState = true;
                    else {
                        const attributes = (0, $fEteO.getMultipleSelectionAttributes)(content);
                        nodeTypes = attributes.nodeTypes;
                        hasSelectedMultipleNodes = attributes.hasSelectedMultipleNodes;
                    }
                } else if (content.childCount === 1) {
                    // Some nodes are not relevant as they are parts of nodes, not whole nodes (like tableCell, tableHeader instead of table node)
                    // Some nodes like lists, taskList(item), decisionList(item) requires tricky checks that we want to avoid doing.
                    // These nodes were added to excludedNodes array.
                    if (!resetState && (0, $fEteO.isExcludedNode)(nodeName)) resetState = true;
                    if (!resetState && !(0, $fEteO.isEntireNestedParagraphOrHeadingSelected)(selection)) resetState = true;
                    if (!resetState && (0, $fEteO.isInlineNode)(nodeName) && (0, $fEteO.isNestedInlineNode)(selection)) resetState = true;
                    if (!resetState && (0, $fEteO.isNestedInTable)(state)) resetState = true;
                } else resetState = true;
                if (resetState) (0, $34JcT.resetContentMoved)()(state, dispatch);
                else {
                    const newState = {
                        size: size,
                        nodeTypes: nodeTypes ?? nodeName,
                        nodeDepth: (0, $fEteO.getParentNodeDepth)(selection),
                        hasSelectedMultipleNodes: hasSelectedMultipleNodes
                    };
                    (0, $34JcT.updateContentMoved)(newState, 'contentCut')(state, dispatch);
                }
                isCutEvent = false;
                return slice;
            }
        }
    });
};

});
parcelRegister("34JcT", function(module, exports) {
$parcel$export(module.exports, "updateContentMoved", () => $5a1d0874aa6f003b$export$7c2867f48317a29d);
$parcel$export(module.exports, "resetContentMoved", () => $5a1d0874aa6f003b$export$56834735aa39d3eb);
$parcel$export(module.exports, "resetContentMovedTransform", () => $5a1d0874aa6f003b$export$47c45651eb91dff0);

var $esSx1 = parcelRequire("esSx1");

var $e162G = parcelRequire("e162G");

var $aMoFs = parcelRequire("aMoFs");
const $5a1d0874aa6f003b$export$7c2867f48317a29d = (nextState, nextAction)=>(0, $e162G.createCommand)((state)=>{
        const { contentMoved: contentMoved } = (0, $e162G.getPluginState)(state);
        const data = {
            currentActions: [
                ...contentMoved.currentActions,
                nextAction
            ],
            size: (nextState === null || nextState === void 0 ? void 0 : nextState.size) || contentMoved.size,
            nodeDepth: nextState === null || nextState === void 0 ? void 0 : nextState.nodeDepth,
            nodeTypes: nextState === null || nextState === void 0 ? void 0 : nextState.nodeTypes,
            hasSelectedMultipleNodes: nextState === null || nextState === void 0 ? void 0 : nextState.hasSelectedMultipleNodes
        };
        return {
            type: (0, $esSx1.MoveAnalyticPluginTypes).UpdateMovedAction,
            data: data
        };
    }, (tr)=>tr.setMeta('addToHistory', false));
const $5a1d0874aa6f003b$export$56834735aa39d3eb = ()=>(0, $e162G.createCommand)(()=>{
        return {
            type: (0, $esSx1.MoveAnalyticPluginTypes).RemoveMovedAction
        };
    }, (tr)=>tr.setMeta('addToHistory', false));
const $5a1d0874aa6f003b$export$47c45651eb91dff0 = ()=>(tr)=>{
        const payload = {
            type: (0, $esSx1.MoveAnalyticPluginTypes).RemoveMovedAction
        };
        return tr.setMeta((0, $aMoFs.pluginKey), payload);
    };

});
parcelRegister("esSx1", function(module, exports) {
$parcel$export(module.exports, "MoveAnalyticPluginTypes", () => $a4bddd0e456c4252$export$a5fa3822909c7e0);
var $a4bddd0e456c4252$export$a5fa3822909c7e0 = /*#__PURE__*/ function(MoveAnalyticPluginTypes) {
    MoveAnalyticPluginTypes[MoveAnalyticPluginTypes["UpdateMovedAction"] = 0] = "UpdateMovedAction";
    MoveAnalyticPluginTypes[MoveAnalyticPluginTypes["RemoveMovedAction"] = 1] = "RemoveMovedAction";
    return MoveAnalyticPluginTypes;
}({});

});

parcelRegister("e162G", function(module, exports) {
$parcel$export(module.exports, "createPluginState", () => $3227e3e1933c9a31$export$656c7661095efe2e);
$parcel$export(module.exports, "createCommand", () => $3227e3e1933c9a31$export$8d4021544bdece00);
$parcel$export(module.exports, "getPluginState", () => $3227e3e1933c9a31$export$f05434c51e3762e);

var $3TnFr = parcelRequire("3TnFr");

var $aMoFs = parcelRequire("aMoFs");

var $36fq3 = parcelRequire("36fq3");
const $3227e3e1933c9a31$var$dest = (0, $3TnFr.pluginFactory)((0, $aMoFs.pluginKey), (0, $36fq3.reducer));
const $3227e3e1933c9a31$export$656c7661095efe2e = $3227e3e1933c9a31$var$dest.createPluginState;
const $3227e3e1933c9a31$export$8d4021544bdece00 = $3227e3e1933c9a31$var$dest.createCommand;
const $3227e3e1933c9a31$export$f05434c51e3762e = $3227e3e1933c9a31$var$dest.getPluginState;

});
parcelRegister("aMoFs", function(module, exports) {
$parcel$export(module.exports, "pluginKey", () => $0371815ac1163742$export$18d4026d1ea86bb1);

var $cw0wu = parcelRequire("cw0wu");
const $0371815ac1163742$export$18d4026d1ea86bb1 = new (0, $cw0wu.PluginKey)('moveAnalyticsPlugin');

});

parcelRegister("36fq3", function(module, exports) {
$parcel$export(module.exports, "reducer", () => $e92354d3b6d8a7d0$export$1650419e431d3ba3);

var $esSx1 = parcelRequire("esSx1");

var $j1IcO = parcelRequire("j1IcO");
const $e92354d3b6d8a7d0$export$1650419e431d3ba3 = (state, action)=>{
    switch(action.type){
        case (0, $esSx1.MoveAnalyticPluginTypes).UpdateMovedAction:
            return {
                ...state,
                contentMoved: {
                    ...state.contentMoved,
                    ...action.data
                }
            };
        case (0, $esSx1.MoveAnalyticPluginTypes).RemoveMovedAction:
            return {
                ...state,
                contentMoved: (0, $j1IcO.defaultState).contentMoved
            };
        default:
            return state;
    }
};

});
parcelRegister("j1IcO", function(module, exports) {
$parcel$export(module.exports, "defaultState", () => $62670c04caca4d18$export$49d5fc8cba920a0);
// For an event to be considered a move content event we want to ensure that
// cut had happened and was followed by paste. So our currentActions array should
// look like this ['contentCut', 'contentPasted'];
// After removing appendTransaction we don't update currentActions with 'contentPasted'
// but leaving it as array in case we decide to change it back or add 'contentCopied'.
const $62670c04caca4d18$export$49d5fc8cba920a0 = {
    contentMoved: {
        size: undefined,
        nodeDepth: undefined,
        currentActions: [],
        nodeTypes: undefined,
        hasSelectedMultipleNodes: undefined
    }
};

});




parcelRegister("fEteO", function(module, exports) {
$parcel$export(module.exports, "isExcludedNode", () => $a2323c62aacdc5bf$export$75248da1527ddfc1);
$parcel$export(module.exports, "isCursorSelectionAtTopLevel", () => $a2323c62aacdc5bf$export$14f96cade94e47c);
$parcel$export(module.exports, "isInlineNode", () => $a2323c62aacdc5bf$export$82ae59a0847ee78b);
$parcel$export(module.exports, "isNestedInlineNode", () => $a2323c62aacdc5bf$export$8cd6af93b47990b9);
$parcel$export(module.exports, "isNestedInTable", () => $a2323c62aacdc5bf$export$78b714f3f17d88b0);
$parcel$export(module.exports, "getParentNodeDepth", () => $a2323c62aacdc5bf$export$568289ef11d607ce);
$parcel$export(module.exports, "isEntireNestedParagraphOrHeadingSelected", () => $a2323c62aacdc5bf$export$b6cb43348b690a2d);
$parcel$export(module.exports, "containsExcludedNode", () => $a2323c62aacdc5bf$export$c4a09517c4982d7c);
$parcel$export(module.exports, "getMultipleSelectionAttributes", () => $a2323c62aacdc5bf$export$f3a535d61fe1eda3);

var $gab48 = parcelRequire("gab48");

var $2E7OD = parcelRequire("2E7OD");
const $a2323c62aacdc5bf$var$excludedNodes = [
    'caption',
    'layoutColumn',
    'listItem',
    'tableHeader',
    'tableCell',
    'tableRow',
    'text',
    'placeholder',
    'unsupportedBlock',
    'unsupportedInline',
    'hardBreak',
    'confluenceUnsupportedBlock',
    'confluenceUnsupportedInline',
    'taskItem',
    'decisionItem'
];
const $a2323c62aacdc5bf$export$75248da1527ddfc1 = (nodeName)=>$a2323c62aacdc5bf$var$excludedNodes.includes(nodeName);
const $a2323c62aacdc5bf$export$14f96cade94e47c = (selection)=>{
    const { from: from, to: to, $from: $from } = selection;
    if (from !== to) return false;
    return $from.parentOffset === 0;
};
const $a2323c62aacdc5bf$var$inlineNodes = [
    'emoji',
    'date',
    'status',
    'mention',
    'mediaInline',
    'inlineCard',
    'inlineExtension'
];
const $a2323c62aacdc5bf$export$82ae59a0847ee78b = (nodeName)=>{
    return $a2323c62aacdc5bf$var$inlineNodes.includes(nodeName);
};
const $a2323c62aacdc5bf$export$8cd6af93b47990b9 = (selection)=>{
    if (selection.$from.depth !== 1) return true;
    // check if the node is a part of a larger paragraph or heading
    const parentSize = selection.$from.parent.content.size;
    const contentSize = selection.content().size;
    const parentChildCount = selection.$from.parent.childCount;
    // when the node was copied and pasted, it won't have extra space the parent has only one child
    if (parentChildCount === 1) return false;
    // some inline nodes (like date and emoji) when inserted have extra space that is stores as a child
    if (parentChildCount === 2 && parentSize - contentSize === 1) return false;
    return true;
};
const $a2323c62aacdc5bf$export$78b714f3f17d88b0 = (state)=>{
    const { schema: schema, selection: selection } = state;
    if (selection instanceof (0, $2E7OD.CellSelection)) return false;
    const { table: table } = schema.nodes;
    const tableNode = (0, $gab48.findParentNodeOfTypeClosestToPos)(selection.$from, table);
    if (!tableNode) return false;
    return true;
};
const $a2323c62aacdc5bf$export$568289ef11d607ce = (selection)=>{
    const parentNode = (0, $gab48.findParentNodeClosestToPos)(selection.$from, ()=>true);
    if (!parentNode) return 0;
    return parentNode.node.type.name === 'heading' || parentNode.node.type.name === 'paragraph' ? parentNode.depth - 1 : parentNode.depth;
};
const $a2323c62aacdc5bf$export$b6cb43348b690a2d = (selection)=>{
    const { $from: $from, $to: $to } = selection;
    return $from.textOffset === 0 && $to.textOffset === 0;
};
const $a2323c62aacdc5bf$export$c4a09517c4982d7c = (content)=>{
    for(let i = 0; i < content.childCount; i++){
        var _content$maybeChild;
        const nodeName = ((_content$maybeChild = content.maybeChild(i)) === null || _content$maybeChild === void 0 ? void 0 : _content$maybeChild.type.name) || '';
        if ($a2323c62aacdc5bf$export$75248da1527ddfc1(nodeName)) return true;
    }
    return false;
};
const $a2323c62aacdc5bf$export$f3a535d61fe1eda3 = (content)=>{
    const nodeTypes = [];
    if (content.size) content.forEach((node)=>{
        nodeTypes.push(node.type.name);
    });
    return {
        nodeTypes: [
            ...new Set(nodeTypes)
        ].sort().join(','),
        hasSelectedMultipleNodes: nodeTypes.length > 1
    };
};

});


parcelRegister("1d0wU", function(module, exports) {
$parcel$export(module.exports, "Flag", () => $5d96ab9fb0e66aca$export$48ea269755562084);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $5beht = parcelRequire("5beht");

var $eJ0Uu = parcelRequire("eJ0Uu");

var $2bmUD = parcelRequire("2bmUD");

var $lJzMO = parcelRequire("lJzMO");

var $hkLEY = parcelRequire("hkLEY");

var $lP6sB = parcelRequire("lP6sB");

var $dsw4B = parcelRequire("dsw4B");

var $dpcHd = parcelRequire("dpcHd");

var $7I6p2 = parcelRequire("7I6p2");

var $3pcnU = parcelRequire("3pcnU");
const $5d96ab9fb0e66aca$export$48ea269755562084 = ({ api: api })=>{
    const { activeFlag: activeFlag } = (0, $5beht.useSharedPluginStateWithSelector)(api, [
        'paste'
    ], (states)=>{
        var _states$pasteState;
        return {
            activeFlag: (_states$pasteState = states.pasteState) === null || _states$pasteState === void 0 ? void 0 : _states$pasteState.activeFlag
        };
    });
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    if (!activeFlag) return;
    const { type: type, onDismissed: onDismissedCallback, description: flagDescription, title: flagTitle, urlText: flagUrlText, urlHref: flagUrlHref } = activeFlag;
    const description = flagDescription ? formatMessage(flagDescription) : undefined;
    const title = flagTitle ? formatMessage(flagTitle) : undefined;
    const urlText = flagUrlText ? formatMessage(flagUrlText) : undefined;
    const onDismissed = ()=>{
        api === null || api === void 0 || api.core.actions.execute(({ tr: tr })=>{
            onDismissedCallback === null || onDismissedCallback === void 0 || onDismissedCallback(tr);
            const oldMeta = tr.getMeta((0, $3pcnU.pluginKey));
            tr.setMeta((0, $3pcnU.pluginKey), {
                ...oldMeta,
                type: (0, $dpcHd.PastePluginActionTypes).SET_ACTIVE_FLAG,
                activeFlag: false
            });
            return tr;
        });
        api === null || api === void 0 || api.core.actions.focus();
    };
    const getActions = ()=>{
        const action = urlText && flagUrlHref ? {
            content: urlText,
            href: flagUrlHref
        } : undefined;
        if (action) return [
            {
                content: action.content,
                href: action.href,
                target: '_blank'
            }
        ];
        return undefined;
    };
    const getFlagComponent = ()=>{
        if (type === (0, $7I6p2.FLAG_TYPE).INFO || type === (0, $7I6p2.FLAG_TYPE).SUCCESS) return 0, $eJ0Uu.default;
        return 0, $2bmUD.default;
    };
    const FlagComponent = getFlagComponent();
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $lJzMO.FlagGroup), {
        children: /*#__PURE__*/ (0, $dc70d.jsx)(FlagComponent, {
            onDismissed: onDismissed,
            title: title,
            description: description,
            id: activeFlag.id,
            testId: activeFlag.id,
            icon: $5d96ab9fb0e66aca$var$typeToIcon(type),
            actions: getActions()
        })
    });
};
const $5d96ab9fb0e66aca$var$typeToIcon = (type)=>{
    if (type === 'error') return /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hkLEY))), {
        label: "",
        color: "var(--ds-icon-danger, #C9372C)"
    });
    if (type === 'warning') return /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dsw4B))), {
        label: "",
        color: "var(--ds-icon-warning, #E06C00)"
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lP6sB))), {
        label: "",
        color: "var(--ds-icon-success, #6A9A23)"
    });
};

});


parcelRegister("aCXWX", function(module, exports) {
$parcel$export(module.exports, "EMPTY_PARAGRAPH_TIMEOUT_DELAY", () => $883a800c06d52a09$export$d5dda3c025c51c47);
$parcel$export(module.exports, "pluginKey", () => $883a800c06d52a09$export$18d4026d1ea86bb1);
$parcel$export(module.exports, "placeholderPlugin", () => $883a800c06d52a09$export$ecbe4cfe6671ba88);
/* placeholderPlugin.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $7lseo = parcelRequire("7lseo");

var $55o0j = parcelRequire("55o0j");

var $cw0wu = parcelRequire("cw0wu");

var $gdUUy = parcelRequire("gdUUy");

var $9PwDt = parcelRequire("9PwDt");

var $hDkm2 = parcelRequire("hDkm2");

var $9Oqa2 = parcelRequire("9Oqa2");

var $5mO69 = parcelRequire("5mO69");
const $883a800c06d52a09$export$d5dda3c025c51c47 = 2000; // Delay before showing placeholder on empty paragraph
const $883a800c06d52a09$export$18d4026d1ea86bb1 = new (0, $cw0wu.PluginKey)('placeholderPlugin');
const $883a800c06d52a09$export$ecbe4cfe6671ba88 = ({ config: options, api: api })=>{
    let currentPlaceholder = options === null || options === void 0 ? void 0 : options.placeholder;
    return {
        name: 'placeholder',
        commands: {
            setPlaceholder: (placeholderText)=>({ tr: tr })=>{
                    if (currentPlaceholder !== placeholderText) {
                        currentPlaceholder = placeholderText;
                        return tr.setMeta($883a800c06d52a09$export$18d4026d1ea86bb1, {
                            placeholderText: placeholderText
                        });
                    }
                    return null;
                },
            setAnimatingPlaceholderPrompts: (placeholderPrompts)=>({ tr: tr })=>{
                    return tr.setMeta($883a800c06d52a09$export$18d4026d1ea86bb1, {
                        placeholderPrompts: placeholderPrompts
                    });
                },
            setPlaceholderHidden: (isPlaceholderHidden)=>({ tr: tr })=>{
                    return tr.setMeta($883a800c06d52a09$export$18d4026d1ea86bb1, {
                        isPlaceholderHidden: isPlaceholderHidden
                    });
                }
        },
        pmPlugins () {
            return [
                {
                    name: 'placeholder',
                    plugin: ({ getIntl: getIntl })=>(0, $5mO69.default)(getIntl(), options && options.placeholder, options && options.placeholderBracketHint, options && options.emptyLinePlaceholder, options && options.placeholderPrompts, options === null || options === void 0 ? void 0 : options.withEmptyParagraph, options === null || options === void 0 ? void 0 : options.isPlaceholderHidden, options && options.placeholderADF, options && options.placeholderPromptAnimationOptions, options === null || options === void 0 ? void 0 : options.isRovoLLMEnabled, api)
                }
            ];
        },
        contentComponent: (params)=>{
            var _params$editorView, _params$editorView2;
            if ((0, $7lseo.isSSR)()) return null;
            // If loading spinner is explicitly disabled (e.g., for DiffEditor/version history), skip
            if ((options === null || options === void 0 ? void 0 : options.enableLoadingSpinner) === false) return null;
            if ((0, $gdUUy.fg)('platform_editor_placeholder_collab_spinner')) return /*#__PURE__*/ (0, $dc70d.jsx)((0, $9Oqa2.PlaceholderLoadingSpinner), {
                api: api,
                editorView: params.editorView
            });
            const doc = (_params$editorView = params.editorView) === null || _params$editorView === void 0 ? void 0 : _params$editorView.state.doc;
            // @ts-ignore fix which needs follow up to use standard apis
            const collabEditPluginState = (_params$editorView2 = params.editorView) === null || _params$editorView2 === void 0 || (_params$editorView2 = _params$editorView2.state) === null || _params$editorView2 === void 0 ? void 0 : _params$editorView2.collabEditPlugin$;
            if (collabEditPluginState && collabEditPluginState.isReady !== true) {
                if (doc && !(0, $55o0j.isEmptyDocument)(doc)) return null;
                return /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
                    xcss: $883a800c06d52a09$var$spinnerContainerStyles.spinnerContainer,
                    children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $hDkm2.default), {
                        interactionName: "live-pages-loading-spinner",
                        size: "medium"
                    })
                });
            }
            return null;
        }
    };
};
const $883a800c06d52a09$var$spinnerContainerStyles = {
    spinnerContainer: "_1e0c1txw _2lx21bp4 _1bah1h6o _4cvr1h6o _1bsb1osq"
};

});
parcelRegister("9Oqa2", function(module, exports) {
$parcel$export(module.exports, "PlaceholderLoadingSpinner", () => $55612915514264fb$export$b93dd67102c6288a);
/* PlaceholderLoadingSpinner.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $5beht = parcelRequire("5beht");

var $55o0j = parcelRequire("55o0j");

var $9PwDt = parcelRequire("9PwDt");

var $hDkm2 = parcelRequire("hDkm2");
const $55612915514264fb$export$b93dd67102c6288a = ({ api: api, editorView: editorView })=>{
    const isCollabInitializing = (0, $5beht.useSharedPluginStateWithSelector)(api, [
        'collabEdit'
    ], ({ collabEditState: collabEditState })=>!!collabEditState && !collabEditState.initialised.collabInitialisedAt);
    const doc = editorView === null || editorView === void 0 ? void 0 : editorView.state.doc;
    if (!editorView || !isCollabInitializing || doc && !(0, $55o0j.isEmptyDocument)(doc)) return null;
    // In this scenario
    // - the collab plugin exists - but we don't have a "initial/placeholder" document
    // - and the collab plugin is not yet ready
    // So we show a placeholder spinner to indicate the content is still loading
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
        xcss: $55612915514264fb$var$spinnerContainerStyles.spinnerContainer,
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $hDkm2.default), {
            interactionName: "live-pages-loading-spinner",
            size: "medium"
        })
    });
};
const $55612915514264fb$var$spinnerContainerStyles = {
    spinnerContainer: "_1e0c1txw _2lx21bp4 _1bah1h6o _4cvr1h6o _1bsb1osq"
};

});

parcelRegister("5mO69", function(module, exports) {
$parcel$export(module.exports, "default", () => $08e559f1f483a5d8$export$2e2bcd8739ae039);

var $f7Kk4 = parcelRequire("f7Kk4");
parcelRequire("ixBwV");
var $eW8cK = parcelRequire("eW8cK");

var $aCXWX = parcelRequire("aCXWX");

var $deSDS = parcelRequire("deSDS");

var $bGr6r = parcelRequire("bGr6r");

var $6ZEvh = parcelRequire("6ZEvh");
function $08e559f1f483a5d8$export$2e2bcd8739ae039(intl, defaultPlaceholderText, bracketPlaceholderText, emptyLinePlaceholder, placeholderPrompts, withEmptyParagraph, initialIsPlaceholderHidden, placeholderADF, placeholderPromptAnimationOptions, isRovoLLMEnabled, api) {
    if (!defaultPlaceholderText && !placeholderPrompts && !bracketPlaceholderText && !placeholderADF) return;
    let isDestroyed = false;
    let activeTypewriterTimeouts = [];
    const clearAllTypewriterTimeouts = ()=>{
        activeTypewriterTimeouts.forEach((clearFn)=>clearFn());
        activeTypewriterTimeouts = [];
    };
    return new (0, $f7Kk4.SafePlugin)({
        key: (0, $aCXWX.pluginKey),
        state: {
            init: (_, state)=>{
                var _api$focus, _api$typeAhead;
                return (0, $6ZEvh.createPlaceHolderStateFrom)({
                    isInitial: true,
                    isEditorFocused: Boolean(api === null || api === void 0 || (_api$focus = api.focus) === null || _api$focus === void 0 || (_api$focus = _api$focus.sharedState.currentState()) === null || _api$focus === void 0 ? void 0 : _api$focus.hasFocus),
                    editorState: state,
                    isTypeAheadOpen: api === null || api === void 0 || (_api$typeAhead = api.typeAhead) === null || _api$typeAhead === void 0 ? void 0 : _api$typeAhead.actions.isOpen,
                    defaultPlaceholderText: defaultPlaceholderText,
                    bracketPlaceholderText: bracketPlaceholderText,
                    emptyLinePlaceholder: emptyLinePlaceholder,
                    placeholderADF: placeholderADF,
                    placeholderPrompts: placeholderPrompts,
                    typedAndDeleted: false,
                    userHadTyped: false,
                    intl: intl,
                    withEmptyParagraph: withEmptyParagraph,
                    isPlaceholderHidden: initialIsPlaceholderHidden
                });
            },
            apply: (tr, placeholderState, _oldEditorState, newEditorState)=>{
                var _api$focus2, _api$typeAhead2;
                const meta = tr.getMeta((0, $aCXWX.pluginKey));
                const isEditorFocused = Boolean(api === null || api === void 0 || (_api$focus2 = api.focus) === null || _api$focus2 === void 0 || (_api$focus2 = _api$focus2.sharedState.currentState()) === null || _api$focus2 === void 0 ? void 0 : _api$focus2.hasFocus);
                const { userHadTyped: userHadTyped, typedAndDeleted: typedAndDeleted } = (0, $6ZEvh.calculateUserInteractionState)({
                    placeholderState: placeholderState,
                    oldEditorState: _oldEditorState,
                    newEditorState: newEditorState
                });
                let isPlaceholderHidden = (placeholderState === null || placeholderState === void 0 ? void 0 : placeholderState.isPlaceholderHidden) ?? false;
                const shouldUpdatePlaceholderHidden = (meta === null || meta === void 0 ? void 0 : meta.isPlaceholderHidden) !== undefined;
                if (shouldUpdatePlaceholderHidden) isPlaceholderHidden = meta.isPlaceholderHidden;
                if ((meta === null || meta === void 0 ? void 0 : meta.placeholderText) !== undefined && withEmptyParagraph) {
                    const isCreateWithRovoOverride = !!meta.placeholderText && isRovoLLMEnabled && (0, $eW8cK.expVal)('cwr_blank_object_experiment', 'isEnabled', false);
                    // Only update defaultPlaceholderText from meta if we're not using ADF placeholder
                    // OR when the create-with-rovo experiment is active to allow intentional non-empty placeholder overrides
                    if (!placeholderADF || isCreateWithRovoOverride) defaultPlaceholderText = meta.placeholderText;
                }
                const newPlaceholderState = (0, $6ZEvh.createPlaceHolderStateFrom)({
                    isEditorFocused: isEditorFocused,
                    editorState: newEditorState,
                    isTypeAheadOpen: api === null || api === void 0 || (_api$typeAhead2 = api.typeAhead) === null || _api$typeAhead2 === void 0 ? void 0 : _api$typeAhead2.actions.isOpen,
                    defaultPlaceholderText: withEmptyParagraph ? defaultPlaceholderText : (meta === null || meta === void 0 ? void 0 : meta.placeholderText) ?? (placeholderState === null || placeholderState === void 0 ? void 0 : placeholderState.placeholderText) ?? defaultPlaceholderText,
                    bracketPlaceholderText: bracketPlaceholderText,
                    emptyLinePlaceholder: emptyLinePlaceholder,
                    placeholderADF: placeholderADF,
                    placeholderPrompts: (meta === null || meta === void 0 ? void 0 : meta.placeholderPrompts) ?? (placeholderState === null || placeholderState === void 0 ? void 0 : placeholderState.placeholderPrompts) ?? placeholderPrompts,
                    typedAndDeleted: typedAndDeleted,
                    userHadTyped: userHadTyped,
                    intl: intl,
                    isPlaceholderHidden: isPlaceholderHidden,
                    withEmptyParagraph: withEmptyParagraph,
                    showOnEmptyParagraph: (meta === null || meta === void 0 ? void 0 : meta.showOnEmptyParagraph) ?? (placeholderState === null || placeholderState === void 0 ? void 0 : placeholderState.showOnEmptyParagraph)
                });
                // Clear timeouts when hasPlaceholder becomes false
                if (!newPlaceholderState.hasPlaceholder) clearAllTypewriterTimeouts();
                return newPlaceholderState;
            }
        },
        props: {
            decorations (editorState) {
                var _api$composition, _api$showDiff;
                // @ts-ignore quick fix which needs follow up to use standard apis
                if (editorState.collabEditPlugin$ && editorState.collabEditPlugin$.isReady !== true) return;
                const { hasPlaceholder: hasPlaceholder, placeholderText: placeholderText, pos: pos, typedAndDeleted: typedAndDeleted, contextPlaceholderADF: contextPlaceholderADF, showOnEmptyParagraph: showOnEmptyParagraph } = (0, $6ZEvh.getPlaceholderState)(editorState);
                // Decorations is still called after plugin is destroyed
                // So we need to make sure decorations is not called if plugin has been destroyed to prevent the placeholder animations' setTimeouts called infinitely
                if (isDestroyed) return;
                const compositionPluginState = api === null || api === void 0 || (_api$composition = api.composition) === null || _api$composition === void 0 ? void 0 : _api$composition.sharedState.currentState();
                const isShowingDiff = Boolean(api === null || api === void 0 || (_api$showDiff = api.showDiff) === null || _api$showDiff === void 0 || (_api$showDiff = _api$showDiff.sharedState.currentState()) === null || _api$showDiff === void 0 ? void 0 : _api$showDiff.isDisplayingChanges);
                if (hasPlaceholder && ((placeholderText ?? '') || placeholderPrompts || placeholderADF || contextPlaceholderADF) && pos !== undefined && !(compositionPluginState !== null && compositionPluginState !== void 0 && compositionPluginState.isComposing) && !isShowingDiff) {
                    const initialDelayWhenUserTypedAndDeleted = typedAndDeleted ? (0, $deSDS.TYPEWRITER_TYPED_AND_DELETED_DELAY) : 0;
                    // contextPlaceholderADF takes precedence over the global placeholderADF
                    const placeholderAdfToUse = contextPlaceholderADF || placeholderADF;
                    return (0, $bGr6r.createPlaceholderDecoration)(editorState, placeholderText ?? '', placeholderPrompts, activeTypewriterTimeouts, pos, initialDelayWhenUserTypedAndDeleted, placeholderAdfToUse, showOnEmptyParagraph, placeholderPromptAnimationOptions);
                }
                return;
            }
        },
        view () {
            let timeoutId;
            function startEmptyParagraphTimeout(editorView) {
                if (timeoutId) return;
                timeoutId = setTimeout(()=>{
                    timeoutId = undefined;
                    editorView.dispatch(editorView.state.tr.setMeta((0, $aCXWX.pluginKey), {
                        showOnEmptyParagraph: true
                    }));
                }, (0, $aCXWX.EMPTY_PARAGRAPH_TIMEOUT_DELAY));
            }
            function destroyEmptyParagraphTimeout() {
                if (timeoutId) {
                    clearTimeout(timeoutId);
                    timeoutId = undefined;
                }
            }
            return {
                update (editorView, prevState) {
                    if (withEmptyParagraph) {
                        const prevPluginState = (0, $6ZEvh.getPlaceholderState)(prevState);
                        const newPluginState = (0, $6ZEvh.getPlaceholderState)(editorView.state);
                        // user start typing after move to an empty paragraph, clear timeout
                        if (!newPluginState.canShowOnEmptyParagraph && timeoutId) destroyEmptyParagraphTimeout();
                        else if (prevPluginState.canShowOnEmptyParagraph && newPluginState.canShowOnEmptyParagraph && newPluginState.pos !== prevPluginState.pos) {
                            editorView.dispatch(editorView.state.tr.setMeta((0, $aCXWX.pluginKey), {
                                showOnEmptyParagraph: false
                            }));
                            destroyEmptyParagraphTimeout();
                            startEmptyParagraphTimeout(editorView);
                        } else if (!prevPluginState.canShowOnEmptyParagraph && newPluginState.canShowOnEmptyParagraph && !newPluginState.showOnEmptyParagraph && !timeoutId) startEmptyParagraphTimeout(editorView);
                    }
                },
                destroy () {
                    clearAllTypewriterTimeouts();
                    destroyEmptyParagraphTimeout();
                    isDestroyed = true;
                }
            };
        }
    });
}

});
parcelRegister("deSDS", function(module, exports) {
$parcel$export(module.exports, "placeholderTestId", () => $17f9802225ef416b$export$53e9a5af7ff64f3e);
$parcel$export(module.exports, "TYPEWRITER_TYPE_DELAY", () => $17f9802225ef416b$export$2d1270bfa8929bb4);
$parcel$export(module.exports, "TYPEWRITER_PAUSE_BEFORE_ERASE", () => $17f9802225ef416b$export$ae685e1a0fa5d78);
$parcel$export(module.exports, "TYPEWRITER_ERASE_DELAY", () => $17f9802225ef416b$export$ff06808c8f6da73a);
$parcel$export(module.exports, "TYPEWRITER_CYCLE_DELAY", () => $17f9802225ef416b$export$d41926d20419077b);
$parcel$export(module.exports, "TYPEWRITER_TYPED_AND_DELETED_DELAY", () => $17f9802225ef416b$export$4b72a719051acd03);
$parcel$export(module.exports, "nodeTypesWithLongPlaceholderText", () => $17f9802225ef416b$export$a754230d588f273f);
$parcel$export(module.exports, "nodeTypesWithShortPlaceholderText", () => $17f9802225ef416b$export$70f0891e62fedaad);
const $17f9802225ef416b$export$53e9a5af7ff64f3e = 'placeholder-test-id';
const $17f9802225ef416b$export$2d1270bfa8929bb4 = 50; // Delay between typing each character
const $17f9802225ef416b$export$ae685e1a0fa5d78 = 2000; // Pause before starting to erase text
const $17f9802225ef416b$export$ff06808c8f6da73a = 40; // Delay between erasing each character
const $17f9802225ef416b$export$d41926d20419077b = 500; // Delay before starting next cycle
const $17f9802225ef416b$export$4b72a719051acd03 = 1500; // Delay before starting animation after user typed and deleted
const $17f9802225ef416b$export$a754230d588f273f = [
    'expand',
    'panel'
];
const $17f9802225ef416b$export$70f0891e62fedaad = [
    'tableCell',
    'tableHeader'
];

});

parcelRegister("bGr6r", function(module, exports) {
$parcel$export(module.exports, "createPlaceholderDecoration", () => $77cf9aab8848569f$export$980ea07f18fbfea9);

var $jxkn6 = parcelRequire("jxkn6");

var $fcrbf = parcelRequire("fcrbf");

var $kuD5k = parcelRequire("kuD5k");

var $kW8qW = parcelRequire("kW8qW");

var $a3b9P = parcelRequire("a3b9P");

var $797yE = parcelRequire("797yE");

var $d72wV = parcelRequire("d72wV");

var $deSDS = parcelRequire("deSDS");
function $77cf9aab8848569f$export$980ea07f18fbfea9(editorState, placeholderText, placeholderPrompts, activeTypewriterTimeouts, pos = 1, initialDelayWhenUserTypedAndDeleted = 0, placeholderADF, showOnEmptyParagraph, placeholderPromptAnimationOptions) {
    const browser = (0, $jxkn6.getBrowserInfo)();
    const placeholderDecoration = document.createElement('span');
    let placeholderNodeWithText = placeholderDecoration;
    placeholderDecoration.setAttribute('data-testid', (0, $deSDS.placeholderTestId));
    const shouldFadeIn = showOnEmptyParagraph;
    placeholderDecoration.className = shouldFadeIn ? 'placeholder-decoration placeholder-decoration-fade-in' : 'placeholder-decoration';
    placeholderDecoration.setAttribute('aria-hidden', 'true');
    // PM sets contenteditable to false on Decorations so Firefox doesn't display the flashing cursor
    // So adding an extra span which will contain the placeholder text
    if (browser.gecko) {
        const placeholderNode = document.createElement('span');
        placeholderNode.setAttribute('contenteditable', 'true'); // explicitly overriding the default Decoration behaviour
        placeholderDecoration.appendChild(placeholderNode);
        placeholderNodeWithText = placeholderNode;
    }
    if (placeholderText) placeholderNodeWithText.textContent = placeholderText || ' ';
    else if (placeholderADF) {
        const serializer = (0, $kW8qW.DOMSerializer).fromSchema(editorState.schema);
        // Get a PMNode from docnode
        const docNode = (0, $fcrbf.processRawValue)(editorState.schema, placeholderADF);
        if (docNode) {
            // Extract only the inline content from paragraphs, avoiding block-level elements
            // that can interfere with cursor rendering
            docNode.children.forEach((node)=>{
                // For paragraph nodes, serialize their content (inline elements) directly
                // without the wrapping <p> tag
                if (node.type.name === 'paragraph') node.content.forEach((inlineNode)=>{
                    const inlineDOM = serializer.serializeNode(inlineNode);
                    placeholderNodeWithText.append(inlineDOM);
                });
                else {
                    // For non-paragraph nodes, serialize normally
                    const nodeDOM = serializer.serializeNode(node);
                    placeholderNodeWithText.append(nodeDOM);
                }
            });
            const markElements = placeholderNodeWithText.querySelectorAll('[data-prosemirror-content-type="mark"]');
            markElements.forEach((markEl)=>{
                if (markEl instanceof HTMLElement) markEl.style.setProperty('color', "var(--ds-text-subtlest, #6B6E76)");
            });
            // Ensure all child elements don't block pointer events or cursor
            const allElements = placeholderNodeWithText.querySelectorAll('*');
            allElements.forEach((el)=>{
                if (el instanceof HTMLElement) {
                    el.style.pointerEvents = 'none';
                    el.style.userSelect = 'none';
                }
            });
        }
    } else if (placeholderPrompts) (0, $d72wV.cycleThroughPlaceholderPrompts)(placeholderPrompts, activeTypewriterTimeouts, placeholderNodeWithText, initialDelayWhenUserTypedAndDeleted, placeholderPromptAnimationOptions);
    // ME-2289 Tapping on backspace in empty editor hides and displays the keyboard
    // Add a editable buff node as the cursor moving forward is inevitable
    // when backspace in GBoard composition
    if (browser.android && browser.chrome) {
        const buffNode = document.createElement('span');
        buffNode.setAttribute('class', 'placeholder-android');
        buffNode.setAttribute('contenteditable', 'true');
        buffNode.textContent = ' ';
        placeholderDecoration.appendChild(buffNode);
    }
    const isTargetNested = editorState.doc.resolve(pos).depth > 1;
    // only truncate text for nested nodes, otherwise applying 'overflow: hidden;' to top level nodes
    // creates issues with quick insert button
    if (isTargetNested && (0, $797yE.editorExperiment)('platform_editor_controls', 'variant1')) placeholderDecoration.classList.add('placeholder-decoration-hide-overflow');
    if (placeholderADF && browser.chrome) {
        const fragment = document.createDocumentFragment();
        // An issue occurs with the caret where it gets bigger when it's next to a non-editable element like a decoration.
        // See: https://discuss.prosemirror.net/t/chrome-caret-cursor-larger-than-the-text-with-inlined-items/5946/2
        // Adding a zero-width space seems to fix this issue.
        fragment.appendChild(document.createTextNode((0, $kuD5k.ZERO_WIDTH_SPACE)));
        fragment.appendChild(placeholderDecoration);
        return (0, $a3b9P.DecorationSet).create(editorState.doc, [
            (0, $a3b9P.Decoration).widget(pos, fragment, {
                side: 0,
                key: `placeholder ${placeholderText}`
            })
        ]);
    }
    return (0, $a3b9P.DecorationSet).create(editorState.doc, [
        (0, $a3b9P.Decoration).widget(pos, placeholderDecoration, {
            side: 0,
            key: `placeholder ${placeholderText}`
        })
    ]);
}

});
parcelRegister("d72wV", function(module, exports) {
$parcel$export(module.exports, "cycleThroughPlaceholderPrompts", () => $d90038044f203a7e$export$e2d45b5ccf27f1ce);

var $deSDS = parcelRequire("deSDS");
const $d90038044f203a7e$export$e2d45b5ccf27f1ce = (placeholderPrompts, activeTypewriterTimeouts, placeholderNodeWithText, initialDelayWhenUserTypedAndDeleted = 0, options)=>{
    const prefersReducedMotion = typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) {
        placeholderNodeWithText.textContent = placeholderPrompts[0] ?? '';
        return;
    }
    let currentPromptIndex = 0;
    let displayedText = '';
    let animationTimeouts = [];
    const clearAllTimeouts = ()=>{
        animationTimeouts.forEach((timeoutId)=>clearTimeout(timeoutId));
        animationTimeouts = [];
    };
    const scheduleTimeout = (callback, delay)=>{
        const timeoutId = setTimeout(callback, delay);
        animationTimeouts.push(timeoutId);
        return timeoutId;
    };
    const startAnimationCycle = ()=>{
        const currentPrompt = placeholderPrompts[currentPromptIndex];
        const eraseDelay = (options === null || options === void 0 ? void 0 : options.eraseDelay) ?? (0, $deSDS.TYPEWRITER_ERASE_DELAY);
        const pauseBeforeErase = (options === null || options === void 0 ? void 0 : options.pauseBeforeErase) ?? (0, $deSDS.TYPEWRITER_PAUSE_BEFORE_ERASE);
        let characterIndex = 0;
        const typeNextCharacter = ()=>{
            if (characterIndex < currentPrompt.length) {
                displayedText = currentPrompt.substring(0, characterIndex + 1);
                placeholderNodeWithText.textContent = displayedText;
                characterIndex++;
                scheduleTimeout(typeNextCharacter, (0, $deSDS.TYPEWRITER_TYPE_DELAY));
            } else scheduleTimeout(eraseLastCharacter, pauseBeforeErase);
        };
        const eraseLastCharacter = ()=>{
            if (displayedText.length > 1) {
                displayedText = displayedText.substring(0, displayedText.length - 1);
                placeholderNodeWithText.textContent = displayedText;
                scheduleTimeout(eraseLastCharacter, eraseDelay);
            } else {
                displayedText = ' ';
                placeholderNodeWithText.textContent = displayedText;
                currentPromptIndex = (currentPromptIndex + 1) % placeholderPrompts.length;
                scheduleTimeout(startAnimationCycle, (0, $deSDS.TYPEWRITER_CYCLE_DELAY));
            }
        };
        typeNextCharacter();
    };
    activeTypewriterTimeouts === null || activeTypewriterTimeouts === void 0 || activeTypewriterTimeouts.push(clearAllTimeouts);
    if (initialDelayWhenUserTypedAndDeleted > 0) {
        placeholderNodeWithText.textContent = ' ';
        scheduleTimeout(startAnimationCycle, initialDelayWhenUserTypedAndDeleted);
    } else startAnimationCycle();
};

});


parcelRegister("6ZEvh", function(module, exports) {
$parcel$export(module.exports, "getPlaceholderState", () => $fe61c2238e371b3c$export$3defeb66989079cc);
$parcel$export(module.exports, "createPlaceHolderStateFrom", () => $fe61c2238e371b3c$export$e919c54ee5ce8f92);
$parcel$export(module.exports, "calculateUserInteractionState", () => $fe61c2238e371b3c$export$31fe4973d007ea9c);
parcelRequire("56AB9");
var $lwCmV = parcelRequire("lwCmV");
var $24xJB = parcelRequire("24xJB");
var $55o0j = parcelRequire("55o0j");

var $cPyt7 = parcelRequire("cPyt7");

var $01Z6w = parcelRequire("01Z6w");

var $gab48 = parcelRequire("gab48");

var $797yE = parcelRequire("797yE");

var $5N1Y4 = parcelRequire("5N1Y4");

var $aCXWX = parcelRequire("aCXWX");

var $k0zkR = parcelRequire("k0zkR");

var $deSDS = parcelRequire("deSDS");
function $fe61c2238e371b3c$export$3defeb66989079cc(editorState) {
    return (0, $aCXWX.pluginKey).getState(editorState);
}
function $fe61c2238e371b3c$export$5e4e0b200a219da7({ placeholderText: placeholderText, pos: pos, placeholderPrompts: placeholderPrompts, typedAndDeleted: typedAndDeleted, userHadTyped: userHadTyped, canShowOnEmptyParagraph: canShowOnEmptyParagraph, showOnEmptyParagraph: showOnEmptyParagraph, contextPlaceholderADF: contextPlaceholderADF }) {
    return {
        hasPlaceholder: true,
        placeholderText: placeholderText,
        placeholderPrompts: placeholderPrompts,
        contextPlaceholderADF: contextPlaceholderADF,
        pos: pos ? pos : 1,
        typedAndDeleted: typedAndDeleted,
        userHadTyped: userHadTyped,
        canShowOnEmptyParagraph: canShowOnEmptyParagraph,
        showOnEmptyParagraph: showOnEmptyParagraph
    };
}
const $fe61c2238e371b3c$export$a76584009ca8faeb = ({ placeholderText: placeholderText, placeholderPrompts: placeholderPrompts, userHadTyped: userHadTyped, pos: pos, canShowOnEmptyParagraph: canShowOnEmptyParagraph, showOnEmptyParagraph: showOnEmptyParagraph })=>({
        hasPlaceholder: false,
        placeholderText: placeholderText,
        placeholderPrompts: placeholderPrompts,
        userHadTyped: userHadTyped,
        typedAndDeleted: false,
        canShowOnEmptyParagraph: canShowOnEmptyParagraph,
        showOnEmptyParagraph: showOnEmptyParagraph,
        pos: pos
    });
function $fe61c2238e371b3c$export$e919c54ee5ce8f92({ isInitial: isInitial, isEditorFocused: isEditorFocused, editorState: editorState, isTypeAheadOpen: isTypeAheadOpen, defaultPlaceholderText: defaultPlaceholderText, intl: intl, bracketPlaceholderText: bracketPlaceholderText, emptyLinePlaceholder: emptyLinePlaceholder, placeholderADF: placeholderADF, placeholderPrompts: placeholderPrompts, typedAndDeleted: typedAndDeleted, userHadTyped: userHadTyped, isPlaceholderHidden: isPlaceholderHidden, withEmptyParagraph: withEmptyParagraph, showOnEmptyParagraph: showOnEmptyParagraph }) {
    const shouldHidePlaceholder = isPlaceholderHidden;
    if (shouldHidePlaceholder) return {
        ...$fe61c2238e371b3c$export$a76584009ca8faeb({
            placeholderText: defaultPlaceholderText,
            placeholderPrompts: placeholderPrompts,
            userHadTyped: userHadTyped
        }),
        isPlaceholderHidden: isPlaceholderHidden
    };
    if (isTypeAheadOpen !== null && isTypeAheadOpen !== void 0 && isTypeAheadOpen(editorState)) return $fe61c2238e371b3c$export$a76584009ca8faeb({
        placeholderText: defaultPlaceholderText,
        placeholderPrompts: placeholderPrompts,
        userHadTyped: userHadTyped
    });
    if ((defaultPlaceholderText || placeholderPrompts || placeholderADF) && (0, $55o0j.isEmptyDocument)(editorState.doc)) return $fe61c2238e371b3c$export$5e4e0b200a219da7({
        placeholderText: defaultPlaceholderText,
        pos: 1,
        placeholderPrompts: placeholderPrompts,
        typedAndDeleted: typedAndDeleted,
        userHadTyped: userHadTyped
    });
    if (withEmptyParagraph) {
        const { from: from, to: to, $to: $to } = editorState.selection;
        const isOnEmptyParagraphInNonEmptyDoc = (defaultPlaceholderText || placeholderADF) && withEmptyParagraph && !isInitial && !(0, $55o0j.isEmptyDocument)(editorState.doc) && from === to && (0, $24xJB.isEmptyParagraph)($to.parent) && (0, $lwCmV.hasDocAsParent)($to);
        if (isOnEmptyParagraphInNonEmptyDoc) {
            // If placeholder was already shown, keep it visible even without focus
            // This prevents the placeholder from disappearing when switching browser tabs
            if (showOnEmptyParagraph) return $fe61c2238e371b3c$export$5e4e0b200a219da7({
                placeholderText: defaultPlaceholderText,
                pos: to,
                placeholderPrompts: placeholderPrompts,
                typedAndDeleted: typedAndDeleted,
                userHadTyped: userHadTyped,
                canShowOnEmptyParagraph: true,
                showOnEmptyParagraph: true
            });
            // Focus is required to start the timeout for showing placeholder
            if (isEditorFocused) return $fe61c2238e371b3c$export$a76584009ca8faeb({
                placeholderText: defaultPlaceholderText,
                placeholderPrompts: placeholderPrompts,
                userHadTyped: userHadTyped,
                canShowOnEmptyParagraph: true,
                showOnEmptyParagraph: false,
                pos: to
            });
        }
    }
    if (isEditorFocused && (0, $797yE.editorExperiment)('platform_editor_controls', 'variant1')) {
        var _parentNode$type, _parentNode$firstChil, _parentNode$firstChil2;
        const { $from: $from, $to: $to } = editorState.selection;
        if ($from.pos !== $to.pos) return $fe61c2238e371b3c$export$a76584009ca8faeb({
            placeholderText: defaultPlaceholderText,
            placeholderPrompts: placeholderPrompts,
            userHadTyped: userHadTyped
        });
        const parentNode = $from.node($from.depth - 1);
        const parentType = parentNode !== null && parentNode !== void 0 && parentNode.type && (0, $5N1Y4.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? (0, $01Z6w.getBaseNodeTypeName)(parentNode.type) : parentNode === null || parentNode === void 0 || (_parentNode$type = parentNode.type) === null || _parentNode$type === void 0 ? void 0 : _parentNode$type.name;
        if (emptyLinePlaceholder && parentType === 'doc') {
            const isEmptyLine = (0, $24xJB.isEmptyParagraph)($from.parent);
            if (isEmptyLine) return $fe61c2238e371b3c$export$5e4e0b200a219da7({
                placeholderText: emptyLinePlaceholder,
                pos: $from.pos,
                placeholderPrompts: placeholderPrompts,
                typedAndDeleted: typedAndDeleted,
                userHadTyped: userHadTyped
            });
        }
        const isEmptyNode = (parentNode === null || parentNode === void 0 ? void 0 : parentNode.childCount) === 1 && ((_parentNode$firstChil = parentNode.firstChild) === null || _parentNode$firstChil === void 0 ? void 0 : _parentNode$firstChil.content.size) === 0 && ((_parentNode$firstChil2 = parentNode.firstChild) === null || _parentNode$firstChil2 === void 0 ? void 0 : _parentNode$firstChil2.type.name) === 'paragraph';
        if ((0, $deSDS.nodeTypesWithShortPlaceholderText).includes(parentType) && isEmptyNode) {
            var _table$node$firstChil;
            const table = (0, $gab48.findParentNode)((node)=>node.type === editorState.schema.nodes.table)(editorState.selection);
            if (!table) return $fe61c2238e371b3c$export$a76584009ca8faeb({
                placeholderText: defaultPlaceholderText,
                placeholderPrompts: placeholderPrompts,
                userHadTyped: userHadTyped
            });
            const isFirstCell = (table === null || table === void 0 || (_table$node$firstChil = table.node.firstChild) === null || _table$node$firstChil === void 0 ? void 0 : _table$node$firstChil.content.firstChild) === parentNode;
            if (isFirstCell) return $fe61c2238e371b3c$export$5e4e0b200a219da7({
                placeholderText: undefined,
                contextPlaceholderADF: (0, $k0zkR.createShortEmptyNodePlaceholderADF)(intl),
                pos: $from.pos,
                placeholderPrompts: placeholderPrompts,
                typedAndDeleted: typedAndDeleted,
                userHadTyped: userHadTyped
            });
        }
        if ((0, $deSDS.nodeTypesWithLongPlaceholderText).includes(parentType) && isEmptyNode) return $fe61c2238e371b3c$export$5e4e0b200a219da7({
            placeholderText: undefined,
            contextPlaceholderADF: (0, $k0zkR.createLongEmptyNodePlaceholderADF)(intl),
            pos: $from.pos,
            placeholderPrompts: placeholderPrompts,
            typedAndDeleted: typedAndDeleted,
            userHadTyped: userHadTyped
        });
        return $fe61c2238e371b3c$export$a76584009ca8faeb({
            placeholderText: defaultPlaceholderText,
            placeholderPrompts: placeholderPrompts,
            userHadTyped: userHadTyped
        });
    }
    if (bracketPlaceholderText && (0, $cPyt7.bracketTyped)(editorState) && isEditorFocused) {
        const { $from: $from } = editorState.selection;
        // Space is to account for positioning of the bracket
        const bracketHint = '  ' + bracketPlaceholderText;
        return $fe61c2238e371b3c$export$5e4e0b200a219da7({
            placeholderText: bracketHint,
            pos: $from.pos - 1,
            placeholderPrompts: placeholderPrompts,
            typedAndDeleted: typedAndDeleted,
            userHadTyped: userHadTyped
        });
    }
    return $fe61c2238e371b3c$export$a76584009ca8faeb({
        placeholderText: defaultPlaceholderText,
        placeholderPrompts: placeholderPrompts,
        userHadTyped: userHadTyped
    });
}
function $fe61c2238e371b3c$export$31fe4973d007ea9c({ placeholderState: placeholderState, oldEditorState: oldEditorState, newEditorState: newEditorState }) {
    const wasEmpty = oldEditorState ? (0, $55o0j.isEmptyDocument)(oldEditorState.doc) : true;
    const isEmpty = (0, $55o0j.isEmptyDocument)(newEditorState.doc);
    const hasEverTyped = Boolean(placeholderState === null || placeholderState === void 0 ? void 0 : placeholderState.userHadTyped) || // Previously typed
    !wasEmpty || // Had content before
    wasEmpty && !isEmpty; // Just added content
    const justDeletedAll = hasEverTyped && isEmpty && !wasEmpty;
    const isInTypedAndDeletedState = justDeletedAll || Boolean(placeholderState === null || placeholderState === void 0 ? void 0 : placeholderState.typedAndDeleted) && isEmpty;
    // Only reset user interaction tracking when editor is cleanly empty
    const shouldResetInteraction = isEmpty && !isInTypedAndDeletedState;
    return {
        userHadTyped: shouldResetInteraction ? false : hasEverTyped,
        typedAndDeleted: isInTypedAndDeletedState
    };
}

});
parcelRegister("k0zkR", function(module, exports) {
$parcel$export(module.exports, "createShortEmptyNodePlaceholderADF", () => $e343ab433fec65c2$export$1107bf49e86ec6cc);
$parcel$export(module.exports, "createLongEmptyNodePlaceholderADF", () => $e343ab433fec65c2$export$45e9ce38f04dd0ca);

var $eGCvp = parcelRequire("eGCvp");

var $daHgL = parcelRequire("daHgL");

var $4fPJw = parcelRequire("4fPJw");
const $e343ab433fec65c2$export$1107bf49e86ec6cc = ({ formatMessage: formatMessage })=>({
        version: 1,
        type: 'doc',
        content: [
            {
                type: 'paragraph',
                content: [
                    (0, $eGCvp.code)(formatMessage((0, $4fPJw.placeholderTextMessages).shortEmptyNodePlaceholderADFSlashShortcut)),
                    (0, $daHgL.text)(' '),
                    (0, $daHgL.text)(formatMessage((0, $4fPJw.placeholderTextMessages).shortEmptyNodePlaceholderADFSuffix))
                ]
            }
        ]
    });
const $e343ab433fec65c2$export$45e9ce38f04dd0ca = ({ formatMessage: formatMessage })=>({
        version: 1,
        type: 'doc',
        content: [
            {
                type: 'paragraph',
                content: [
                    (0, $daHgL.text)(formatMessage((0, $4fPJw.placeholderTextMessages).longEmptyNodePlaceholderADFPrefix)),
                    (0, $daHgL.text)(' '),
                    (0, $eGCvp.code)(formatMessage((0, $4fPJw.placeholderTextMessages).longEmptyNodePlaceholderADFSlashShortcut)),
                    (0, $daHgL.text)(' '),
                    (0, $daHgL.text)(formatMessage((0, $4fPJw.placeholderTextMessages).longEmptyNodePlaceholderADFSuffix))
                ]
            }
        ]
    });

});




parcelRegister("58QGE", function(module, exports) {
$parcel$export(module.exports, "primaryToolbarPlugin", () => $a2809582eb7a73dd$export$ad7799fd22a76abd);

var $aqIro = parcelRequire("aqIro");

var $kJUdo = parcelRequire("kJUdo");

var $briRX = parcelRequire("briRX");
const $a2809582eb7a73dd$export$ad7799fd22a76abd = ({ config: config })=>{
    // We use a plugin variable to store the component registry to avoid having to use
    // effects in each plugin, and to enable rendering the toolbar in SSR
    // TODO: ED-26962 - Replace this with something in plugin state once we have a way to initialise across plugins on plugin initialisation
    const componentRegistry = new Map();
    // Pre-fill registry with the separator component
    componentRegistry.set('separator', (0, $briRX.default));
    return {
        name: 'primaryToolbar',
        actions: {
            registerComponent: (0, $aqIro.registerComponent)(componentRegistry)
        },
        pmPlugins: ()=>[
                {
                    name: 'primaryToolbar',
                    plugin: ()=>(0, $kJUdo.createPlugin)({
                            componentRegistry: componentRegistry,
                            contextualFormattingEnabled: config === null || config === void 0 ? void 0 : config.contextualFormattingEnabled
                        })
                }
            ],
        getSharedState (editorState) {
            if (!editorState) return;
            return (0, $kJUdo.primaryToolbarPluginKey).getState(editorState);
        }
    };
};

});
parcelRegister("aqIro", function(module, exports) {
$parcel$export(module.exports, "registerComponent", () => $8df9a6966c140da7$export$d74092cddf07c0aa);
const $8df9a6966c140da7$export$d74092cddf07c0aa = (componentRegistry)=>({ name: name, component: component })=>{
        componentRegistry.set(name, component);
    };

});

parcelRegister("kJUdo", function(module, exports) {
$parcel$export(module.exports, "primaryToolbarPluginKey", () => $a1c1d9682369c948$export$36f60c8b3eb879ae);
$parcel$export(module.exports, "createPlugin", () => $a1c1d9682369c948$export$ae829ec7b2625219);

var $f7Kk4 = parcelRequire("f7Kk4");

var $cw0wu = parcelRequire("cw0wu");

var $5nhOh = parcelRequire("5nhOh");
const $a1c1d9682369c948$export$36f60c8b3eb879ae = new (0, $cw0wu.PluginKey)('primaryToolbar');
const $a1c1d9682369c948$export$ae829ec7b2625219 = ({ componentRegistry: componentRegistry, contextualFormattingEnabled: contextualFormattingEnabled })=>{
    return new (0, $f7Kk4.SafePlugin)({
        key: $a1c1d9682369c948$export$36f60c8b3eb879ae,
        state: {
            init: (_config, editorState)=>({
                    components: (0, $5nhOh.getToolbarComponents)({
                        componentRegistry: componentRegistry,
                        editorState: editorState,
                        contextualFormattingEnabled: contextualFormattingEnabled
                    })
                }),
            apply: (_tr, pluginState)=>pluginState
        }
    });
};

});
parcelRegister("5nhOh", function(module, exports) {
$parcel$export(module.exports, "getToolbarComponents", () => $430297e128f38fe6$export$a758406ca53b86a5);

var $797yE = parcelRequire("797yE");
const $430297e128f38fe6$export$a758406ca53b86a5 = ({ componentRegistry: componentRegistry, editorState: editorState, contextualFormattingEnabled: contextualFormattingEnabled })=>{
    let configuration;
    if (contextualFormattingEnabled && (0, $797yE.editorExperiment)('platform_editor_controls', 'variant1', {
        exposure: true
    })) configuration = $430297e128f38fe6$var$toolbarConfigurationV2(true);
    else {
        const shouldShowFindGroup = !!contextualFormattingEnabled;
        if (componentRegistry.has('trackChanges')) configuration = $430297e128f38fe6$var$toolbarConfigurationV3(shouldShowFindGroup);
        else configuration = $430297e128f38fe6$var$toolbarConfiguration(shouldShowFindGroup);
    }
    return configuration.filter((toolbarElement)=>typeof toolbarElement.enabled === 'undefined' || toolbarElement.enabled(componentRegistry, editorState)).reduce((acc, toolbarElement)=>{
        if (componentRegistry.has(toolbarElement.name)) {
            const component = componentRegistry.get(toolbarElement.name);
            if (!!component) acc.push(component);
        }
        return acc;
    }, []);
};
const $430297e128f38fe6$var$trackChangesGroup = [
    {
        name: 'separator',
        enabled: (componentRegistry)=>componentRegistry.has('undoRedo') || componentRegistry.has('trackChanges')
    },
    {
        name: 'undoRedoPlugin',
        enabled: (componentRegistry)=>componentRegistry.has('undoRedoPlugin')
    },
    {
        name: 'trackChanges',
        enabled: (componentRegistry)=>componentRegistry.has('trackChanges')
    }
];
const $430297e128f38fe6$var$undoRedoGroup = [
    {
        name: 'undoRedoPlugin'
    },
    {
        name: 'separator',
        enabled: (componentRegistry)=>componentRegistry.has('undoRedoPlugin')
    }
];
const $430297e128f38fe6$var$spellCheckGroup = [
    {
        name: 'spellCheck'
    },
    {
        name: 'separator',
        enabled: (componentRegistry)=>componentRegistry.has('spellCheck')
    }
];
const $430297e128f38fe6$var$blockTypeGroup = [
    {
        name: 'blockType'
    },
    {
        name: 'separator',
        enabled: (componentRegistry, editorState)=>componentRegistry.has('blockType') && // Use case where you want to have the block plugin but not render any toolbar items (when you exclude headings), we should be able to get rid of this when we split block type plugin up and check for the presence of the heading plugin directly
            !!editorState.schema.nodes.heading
    }
];
const $430297e128f38fe6$var$textFormattingGroup = [
    {
        name: 'textFormatting'
    },
    {
        name: 'separator',
        enabled: (componentRegistry)=>componentRegistry.has('textFormatting')
    }
];
const $430297e128f38fe6$var$alignmentGroup = [
    {
        name: 'alignment'
    },
    {
        name: 'separator',
        enabled: (componentRegistry)=>componentRegistry.has('alignment')
    }
];
const $430297e128f38fe6$var$textColorGroup = [
    {
        name: 'textColor'
    },
    {
        name: 'highlight'
    },
    {
        name: 'separator',
        enabled: (componentRegistry)=>componentRegistry.has('textColor') || componentRegistry.has('highlight')
    }
];
const $430297e128f38fe6$var$listFormattingGroup = [
    {
        name: 'toolbarListsIndentation'
    },
    {
        name: 'separator',
        enabled: (componentRegistry)=>componentRegistry.has('toolbarListsIndentation')
    }
];
const $430297e128f38fe6$var$hyperlinkGroup = [
    {
        name: 'hyperlink'
    },
    {
        name: 'separator',
        enabled: (componentRegistry)=>componentRegistry.has('hyperlink')
    }
];
const $430297e128f38fe6$var$insertBlockGroup = [
    {
        name: 'insertBlock'
    }
];
const $430297e128f38fe6$var$others = [
    {
        name: 'beforePrimaryToolbar'
    },
    {
        name: 'avatarGroup'
    },
    {
        name: 'findReplace'
    },
    {
        // TODO: ED-26962 - Should likely be split into three: spelling & grammar, separator, and AI trigger
        name: 'aiExperience'
    },
    {
        name: 'loom'
    }
];
const $430297e128f38fe6$var$othersGroupNoFind = [
    {
        name: 'beforePrimaryToolbar'
    },
    {
        name: 'avatarGroup'
    },
    {
        // TODO: ED-26962 - Should likely be split into three: spelling & grammar, separator, and AI trigger
        name: 'aiExperience'
    },
    {
        name: 'loom'
    }
];
const $430297e128f38fe6$var$findGroup = [
    {
        name: 'findReplace'
    }
];
const $430297e128f38fe6$var$toolbarConfigurationV3 = (shouldShowFindGroup)=>[
        ...$430297e128f38fe6$var$spellCheckGroup,
        ...$430297e128f38fe6$var$blockTypeGroup,
        ...$430297e128f38fe6$var$textFormattingGroup,
        ...$430297e128f38fe6$var$alignmentGroup,
        ...$430297e128f38fe6$var$textColorGroup,
        ...$430297e128f38fe6$var$listFormattingGroup,
        ...$430297e128f38fe6$var$insertBlockGroup,
        ...shouldShowFindGroup ? $430297e128f38fe6$var$others : $430297e128f38fe6$var$othersGroupNoFind,
        ...$430297e128f38fe6$var$trackChangesGroup
    ];
const $430297e128f38fe6$var$toolbarConfiguration = (shouldShowFindGroup)=>[
        ...$430297e128f38fe6$var$undoRedoGroup,
        ...$430297e128f38fe6$var$spellCheckGroup,
        ...$430297e128f38fe6$var$blockTypeGroup,
        ...$430297e128f38fe6$var$textFormattingGroup,
        ...$430297e128f38fe6$var$alignmentGroup,
        ...$430297e128f38fe6$var$textColorGroup,
        ...$430297e128f38fe6$var$listFormattingGroup,
        ...$430297e128f38fe6$var$insertBlockGroup,
        ...shouldShowFindGroup ? $430297e128f38fe6$var$others : $430297e128f38fe6$var$othersGroupNoFind
    ];
const $430297e128f38fe6$var$pinToolbar = [
    {
        name: 'pinToolbar'
    }
];
const $430297e128f38fe6$var$toolbarConfigurationV2 = (shouldShowInsertBlock, shouldShowFindGroup = false)=>[
        ...$430297e128f38fe6$var$blockTypeGroup,
        ...$430297e128f38fe6$var$textFormattingGroup,
        ...$430297e128f38fe6$var$textColorGroup,
        ...$430297e128f38fe6$var$alignmentGroup,
        ...$430297e128f38fe6$var$listFormattingGroup,
        ...$430297e128f38fe6$var$hyperlinkGroup,
        ...shouldShowInsertBlock ? $430297e128f38fe6$var$insertBlockGroup : [],
        {
            name: 'selectionExtension'
        },
        ...$430297e128f38fe6$var$pinToolbar,
        {
            name: 'beforePrimaryToolbar'
        },
        ...shouldShowFindGroup ? $430297e128f38fe6$var$findGroup : []
    ];

});


parcelRegister("briRX", function(module, exports) {
$parcel$export(module.exports, "default", () => $11fdd4953917b28b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled, @typescript-eslint/consistent-type-imports

var $9dQre = parcelRequire("9dQre");

var $g42cj = parcelRequire("g42cj");
var $11fdd4953917b28b$export$2e2bcd8739ae039 = ()=>// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $9dQre.jsx)("span", {
        css: (0, $g42cj.wrapperStyle)
    }, /*#__PURE__*/ (0, $9dQre.jsx)("span", {
        "data-vc": "primary-toolbar-separator",
        css: (0, $g42cj.separatorStyles)
    }));

});


parcelRegister("glxMc", function(module, exports) {
$parcel$export(module.exports, "quickInsertPlugin", () => $ee63fdf4568fbe2c$export$2ff93c7de46a9aaa);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $7lseo = parcelRequire("7lseo");

var $cW1gB = parcelRequire("cW1gB");

var $13g42 = parcelRequire("13g42");

var $gstGr = parcelRequire("gstGr");

var $f7Kk4 = parcelRequire("f7Kk4");

var $aaLLt = parcelRequire("aaLLt");

var $iabGk = parcelRequire("iabGk");

var $3y2s4 = parcelRequire("3y2s4");

var $gdUUy = parcelRequire("gdUUy");

var $93qUx = parcelRequire("93qUx");

var $5lWCd = parcelRequire("5lWCd");

var $iLb7V = parcelRequire("iLb7V");

var $7rhDT = parcelRequire("7rhDT");

var $7VQI9 = parcelRequire("7VQI9");

var $1orAR = parcelRequire("1orAR");

var $1pASS = parcelRequire("1pASS");

var $2zbrN = parcelRequire("2zbrN");

var $93g3K = parcelRequire("93g3K");

var $aFLsV = parcelRequire("aFLsV");
const $ee63fdf4568fbe2c$export$2ff93c7de46a9aaa = ({ config: options, api: api })=>{
    const refs = {};
    const onInsert = (item)=>{
        var _options$onInsert;
        options === null || options === void 0 || (_options$onInsert = options.onInsert) === null || _options$onInsert === void 0 || _options$onInsert.call(options, item);
    };
    const typeAheadPrioritySortingFn = (0, $aFLsV.withLayoutQuickInsertPrioritySorting)(options === null || options === void 0 ? void 0 : options.prioritySortingFn);
    const getItemRank = (0, $13g42.createQuickInsertRankResolver)(options === null || options === void 0 ? void 0 : options.getItemRank);
    const typeAhead = {
        id: (0, $aaLLt.TypeAheadAvailableNodes).QUICK_INSERT,
        getRegisteredItemRank: getItemRank,
        trigger: '/',
        // Support fullwidth slash (U+FF0F) used by Japanese/CJK keyboards (e.g. typing / on a Japanese keyboard layout)
        customRegex: "[/\uFF0F]",
        headless: options === null || options === void 0 ? void 0 : options.headless,
        getItems ({ query: query, editorState: editorState }) {
            const quickInsertState = (0, $7rhDT.pluginKey).getState(editorState);
            const items = (0, $aFLsV.getQuickInsertSuggestions)({
                query: query,
                disableDefaultItems: options === null || options === void 0 ? void 0 : options.disableDefaultItems,
                prioritySortingFn: typeAheadPrioritySortingFn,
                // EDITOR-6558: pass through consumer-supplied filter (e.g. Markdown Mode allowlist)
                itemFilter: options === null || options === void 0 ? void 0 : options.itemFilter
            }, quickInsertState === null || quickInsertState === void 0 ? void 0 : quickInsertState.lazyDefaultItems, quickInsertState === null || quickInsertState === void 0 ? void 0 : quickInsertState.providedItems);
            return Promise.resolve(items);
        },
        selectItem: (state, item, insert)=>{
            const quickInsertItem = item;
            const result = quickInsertItem.action(insert, state);
            if (result) onInsert(quickInsertItem);
            return result;
        },
        getMoreOptionsButtonConfig: options !== null && options !== void 0 && options.enableElementBrowser ? ({ formatMessage: formatMessage })=>{
            return {
                title: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).viewMore),
                ariaLabel: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).viewMoreAriaLabel),
                onClick: (props)=>openElementBrowser()(props),
                iconBefore: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iabGk))), {
                    label: ""
                })
            };
        } : undefined
    };
    if ((0, $3y2s4.isExperimentEnabled)('platform_editor_slash_command')) {
        var _api$uiControlRegistr;
        api === null || api === void 0 || (_api$uiControlRegistr = api.uiControlRegistry) === null || _api$uiControlRegistr === void 0 || _api$uiControlRegistr.actions.register((0, $1pASS.getQuickInsertComponents)({
            api: api,
            includeElementBrowserItems: (options === null || options === void 0 ? void 0 : options.enableElementBrowser) === true,
            isRecommendedItem: options === null || options === void 0 ? void 0 : options.isRecommendedItem,
            maxRecommendedItems: options === null || options === void 0 ? void 0 : options.maxRecommendedItems
        }));
    }
    if ((0, $3y2s4.isExperimentEnabled)('platform_editor_block_control_migration') && (options === null || options === void 0 ? void 0 : options.blockControlButtonEnabled) !== false) {
        var _api$uiControlRegistr2;
        api === null || api === void 0 || (_api$uiControlRegistr2 = api.uiControlRegistry) === null || _api$uiControlRegistr2 === void 0 || _api$uiControlRegistr2.actions.register((0, $7VQI9.getBlockControlQuickInsertComponents)({
            api: api,
            getEditorView: ()=>refs.editorView,
            openTypeAhead: ()=>{
                var _api$typeAhead;
                return api === null || api === void 0 || (_api$typeAhead = api.typeAhead) === null || _api$typeAhead === void 0 ? void 0 : _api$typeAhead.actions.open({
                    triggerHandler: typeAhead,
                    inputMethod: 'blockControl',
                    removePrefixTriggerOnCancel: true
                });
            }
        }));
    }
    const openElementBrowser = (options)=>({ tr: tr })=>{
            if ((0, $gdUUy.fg)('platform_editor_ease_of_use_metrics')) {
                var _api$metrics;
                api === null || api === void 0 || (_api$metrics = api.metrics) === null || _api$metrics === void 0 || _api$metrics.commands.handleIntentToStartEdit({
                    shouldStartTimer: false,
                    shouldPersistActiveSession: true
                })({
                    tr: tr
                });
            }
            return ((0, $3y2s4.isExperimentEnabled)('platform_editor_slash_command') ? (0, $5lWCd.openElementBrowser)(options) : (0, $5lWCd.openElementBrowserModal))({
                tr: tr
            });
        };
    let intl;
    return {
        name: 'quickInsert',
        pmPlugins (defaultItems) {
            return [
                {
                    name: 'quickInsert',
                    // It's important that this plugin is above TypeAheadPlugin
                    plugin: ({ providerFactory: providerFactory, getIntl: getIntl, dispatch: dispatch, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>$ee63fdf4568fbe2c$var$quickInsertPluginFactory((0, $3y2s4.isExperimentEnabled)('platform_editor_slash_command') ? (defaultItems || []).filter((item)=>item !== undefined) : defaultItems, providerFactory, getIntl, dispatch, dispatchAnalyticsEvent, refs, options === null || options === void 0 ? void 0 : options.emptyStateHandler, onInsert, options === null || options === void 0 ? void 0 : options.itemFilter, api)
                },
                {
                    name: 'quickInsertOpenExperience',
                    plugin: ()=>(0, $iLb7V.getQuickInsertOpenExperiencePlugin)({
                            refs: refs,
                            dispatchAnalyticsEvent: (payload)=>{
                                var _api$analytics;
                                return api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 || (_api$analytics = _api$analytics.actions) === null || _api$analytics === void 0 ? void 0 : _api$analytics.fireAnalyticsEvent(payload);
                            }
                        })
                }
            ];
        },
        pluginsOptions: {
            typeAhead: typeAhead
        },
        contentComponent ({ editorView: editorView, popupsMountPoint: popupsMountPoint, wrapperElement: wrapperElement }) {
            // using contentComponent to set editorView can cause it to become stale when editor is reconfigured
            // (e.g. page appearance change)
            if (!(0, $3y2s4.isExperimentEnabled)('platform_editor_block_control_migration')) refs.editorView = editorView || undefined;
            refs.popupsMountPoint = popupsMountPoint || undefined;
            refs.wrapperElement = wrapperElement || undefined;
            if (!editorView || (0, $7lseo.isSSR)()) return null;
            if (options !== null && options !== void 0 && options.enableElementBrowser) return (0, $3y2s4.isExperimentEnabled)('platform_editor_slash_command') && api !== null && api !== void 0 && api.uiControlRegistry ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $93g3K.RegistryElementBrowserContainer), {
                editorView: editorView,
                helpUrl: options === null || options === void 0 ? void 0 : options.elementBrowserHelpUrl,
                pluginInjectionAPI: api
            }) : /*#__PURE__*/ (0, $dc70d.jsx)((0, $2zbrN.default), {
                editorView: editorView,
                helpUrl: options === null || options === void 0 ? void 0 : options.elementBrowserHelpUrl,
                pluginInjectionAPI: api
            });
            return null;
        },
        getSharedState (editorState) {
            if (!editorState) return null;
            const quickInsertState = (0, $7rhDT.pluginKey).getState(editorState);
            if (!quickInsertState) return null;
            return {
                typeAheadHandler: typeAhead,
                getItemRank: getItemRank,
                lazyDefaultItems: quickInsertState.lazyDefaultItems,
                emptyStateHandler: quickInsertState.emptyStateHandler,
                providedItems: quickInsertState.providedItems,
                isElementBrowserModalOpen: quickInsertState.isElementBrowserModalOpen,
                isElementBrowserOpen: quickInsertState.isElementBrowserOpen
            };
        },
        actions: {
            insertItem: (0, $5lWCd.createInsertItem)(onInsert),
            openTypeAhead (inputMethod, removePrefixTriggerOnCancel) {
                var _api$typeAhead2;
                return Boolean(api === null || api === void 0 || (_api$typeAhead2 = api.typeAhead) === null || _api$typeAhead2 === void 0 ? void 0 : _api$typeAhead2.actions.open({
                    triggerHandler: typeAhead,
                    inputMethod: inputMethod,
                    removePrefixTriggerOnCancel: removePrefixTriggerOnCancel
                }));
            },
            getSuggestions: (searchOptions)=>{
                var _api$quickInsert;
                const { lazyDefaultItems: lazyDefaultItems, providedItems: providedItems } = (api === null || api === void 0 || (_api$quickInsert = api.quickInsert) === null || _api$quickInsert === void 0 ? void 0 : _api$quickInsert.sharedState.currentState()) ?? {};
                searchOptions = {
                    ...searchOptions,
                    prioritySortingFn: (0, $aFLsV.withLayoutQuickInsertPrioritySorting)((options === null || options === void 0 ? void 0 : options.prioritySortingFn) ?? searchOptions.prioritySortingFn)
                };
                // EDITOR-6558: layer the consumer-supplied filter (e.g. Markdown Mode allowlist)
                // over any caller-supplied filter so both apply.
                if (options !== null && options !== void 0 && options.itemFilter) {
                    const consumerFilter = options.itemFilter;
                    const callerFilter = searchOptions.itemFilter;
                    searchOptions = {
                        ...searchOptions,
                        itemFilter: callerFilter ? (item)=>consumerFilter(item) && callerFilter(item) : consumerFilter
                    };
                }
                return (0, $aFLsV.getQuickInsertSuggestions)(searchOptions, lazyDefaultItems, providedItems);
            }
        },
        commands: {
            openElementBrowser: openElementBrowser,
            openElementBrowserModal: ({ tr: tr })=>{
                if ((0, $gdUUy.fg)('platform_editor_ease_of_use_metrics')) {
                    var _api$metrics2;
                    api === null || api === void 0 || (_api$metrics2 = api.metrics) === null || _api$metrics2 === void 0 || _api$metrics2.commands.handleIntentToStartEdit({
                        shouldStartTimer: false,
                        shouldPersistActiveSession: true
                    })({
                        tr: tr
                    });
                }
                return (0, $5lWCd.openElementBrowserModal)({
                    tr: tr
                });
            },
            addQuickInsertItem: (item)=>({ tr: tr })=>{
                    var _api$quickInsert2;
                    const { lazyDefaultItems: lazyDefaultItems } = (api === null || api === void 0 || (_api$quickInsert2 = api.quickInsert) === null || _api$quickInsert2 === void 0 ? void 0 : _api$quickInsert2.sharedState.currentState()) ?? {};
                    const defaultItems = lazyDefaultItems ? lazyDefaultItems() : [];
                    const memoisedNewItems = (0, $gstGr.memoProcessQuickInsertItems)([
                        item
                    ], intl);
                    return tr.setMeta((0, $7rhDT.pluginKey), {
                        lazyDefaultItems: ()=>[
                                ...defaultItems,
                                ...memoisedNewItems
                            ]
                    });
                },
            updateQuickInsertItem: (key, item)=>({ tr: tr })=>{
                    var _api$quickInsert3;
                    const { providedItems: providedItems, lazyDefaultItems: lazyDefaultItems } = (api === null || api === void 0 || (_api$quickInsert3 = api.quickInsert) === null || _api$quickInsert3 === void 0 ? void 0 : _api$quickInsert3.sharedState.currentState()) ?? {};
                    const defaultItems = lazyDefaultItems ? lazyDefaultItems() : [];
                    const newItem = (0, $gstGr.memoProcessQuickInsertItems)([
                        item
                    ], intl);
                    const replaceByKey = (items)=>items.flatMap((i)=>i.key === key ? newItem : i);
                    const meta = {};
                    if (defaultItems.some((i)=>i.key === key)) meta.lazyDefaultItems = ()=>replaceByKey(defaultItems);
                    if (providedItems !== null && providedItems !== void 0 && providedItems.some((i)=>i.key === key)) meta.providedItems = replaceByKey(providedItems);
                    return Object.keys(meta).length > 0 ? tr.setMeta((0, $7rhDT.pluginKey), meta) : tr;
                },
            removeQuickInsertItem: (key)=>({ tr: tr })=>{
                    var _api$quickInsert4;
                    const { providedItems: providedItems, lazyDefaultItems: lazyDefaultItems } = (api === null || api === void 0 || (_api$quickInsert4 = api.quickInsert) === null || _api$quickInsert4 === void 0 ? void 0 : _api$quickInsert4.sharedState.currentState()) ?? {};
                    const defaultItems = lazyDefaultItems ? lazyDefaultItems() : [];
                    return tr.setMeta((0, $7rhDT.pluginKey), {
                        providedItems: (providedItems === null || providedItems === void 0 ? void 0 : providedItems.filter((item)=>item.key !== key)) ?? [],
                        lazyDefaultItems: ()=>defaultItems.filter((item)=>item.key !== key)
                    });
                }
        },
        usePluginHook: ()=>{
            intl = (0, $4vLTk.default)();
        }
    };
};
const $ee63fdf4568fbe2c$var$setProviderState = (providerState)=>(state, dispatch)=>{
        if (dispatch) dispatch(state.tr.setMeta((0, $7rhDT.pluginKey), providerState));
        return true;
    };
function $ee63fdf4568fbe2c$var$quickInsertPluginFactory(defaultItems, providerFactory, getIntl, dispatch, dispatchAnalyticsEvent, refs, emptyStateHandler, onInsert = ()=>{}, itemFilter, api) {
    return new (0, $f7Kk4.SafePlugin)({
        key: (0, $7rhDT.pluginKey),
        state: {
            init () {
                return {
                    isElementBrowserModalOpen: false,
                    isElementBrowserOpen: false,
                    emptyStateHandler: emptyStateHandler,
                    // lazy so it doesn't run on editor initialization
                    // memo here to avoid using a singleton cache, avoids editor
                    // getting confused when two editors exist within the same page.
                    lazyDefaultItems: ()=>(0, $gstGr.memoProcessQuickInsertItems)(defaultItems || [], getIntl())
                };
            },
            apply (tr, pluginState) {
                const meta = tr.getMeta((0, $7rhDT.pluginKey));
                if (meta) {
                    const keys = Object.keys(meta);
                    const changed = keys.some((key)=>{
                        return pluginState[key] !== meta[key];
                    });
                    if (changed) {
                        const newState = {
                            ...pluginState,
                            ...meta
                        };
                        dispatch((0, $7rhDT.pluginKey), newState);
                        return newState;
                    }
                }
                return pluginState;
            }
        },
        view (editorView) {
            if ((0, $3y2s4.isExperimentEnabled)('platform_editor_block_control_migration')) refs.editorView = editorView;
            let quickInsertItemsAnalyticsScheduler;
            let isDestroyed = false;
            const providerHandler = async (_name, providerPromise)=>{
                if (providerPromise) try {
                    const provider = await providerPromise;
                    const providedItems = await provider.getItems();
                    if ((0, $3y2s4.isExperimentEnabled)('platform_editor_slash_command')) {
                        var _api$uiControlRegistr3;
                        const directComponents = provider.getComponents ? await provider.getComponents() : [];
                        const components = (0, $1orAR.getLegacyCompatibleComponents)({
                            directComponents: directComponents,
                            itemFilter: itemFilter,
                            onInsert: onInsert,
                            providedItems: providedItems
                        });
                        api === null || api === void 0 || (_api$uiControlRegistr3 = api.uiControlRegistry) === null || _api$uiControlRegistr3 === void 0 || _api$uiControlRegistr3.actions.register(components);
                    }
                    $ee63fdf4568fbe2c$var$setProviderState({
                        provider: provider,
                        providedItems: providedItems
                    })(editorView.state, editorView.dispatch);
                    if (!isDestroyed && !quickInsertItemsAnalyticsScheduler) {
                        quickInsertItemsAnalyticsScheduler = (0, $93qUx.createQuickInsertItemsAnalyticsScheduler)(dispatchAnalyticsEvent);
                        quickInsertItemsAnalyticsScheduler.schedule({
                            providedItems: providedItems
                        });
                    }
                } catch (e) {
                    // eslint-disable-next-line no-console
                    console.error('Error getting items from quick insert provider', e);
                }
            };
            providerFactory.subscribe('quickInsertProvider', providerHandler);
            return {
                destroy () {
                    var _quickInsertItemsAnal;
                    if ((0, $3y2s4.isExperimentEnabled)('platform_editor_block_control_migration') && refs.editorView === editorView) refs.editorView = undefined;
                    isDestroyed = true;
                    (_quickInsertItemsAnal = quickInsertItemsAnalyticsScheduler) === null || _quickInsertItemsAnal === void 0 || _quickInsertItemsAnal.destroy();
                    providerFactory.unsubscribe('quickInsertProvider', providerHandler);
                }
            };
        }
    });
}

});
parcelRegister("13g42", function(module, exports) {
$parcel$export(module.exports, "createQuickInsertRankResolver", () => $2896bdef2821d0dd$export$a194005127f4fa88);

var $93UeO = parcelRequire("93UeO");

var $2WXs5 = parcelRequire("2WXs5");

var $9woaI = parcelRequire("9woaI");
const $2896bdef2821d0dd$export$a194005127f4fa88 = (getItemRank)=>{
    if (!getItemRank) return undefined;
    return ({ component: component, parent: parent })=>{
        if (component.type === 'menu-section' && parent.type === 'menu' && !(0, $93UeO.isMenuFooterSectionKey)(component.key)) return getItemRank({
            component: component,
            parent: parent
        });
        if (component.type === 'menu-item' && parent.type === 'menu-section' && !(0, $2WXs5.isSectionOverflowItemKey)(component.key) && !(0, $93UeO.isMenuFooterSectionKey)(parent.key) && parent.key !== (0, $9woaI.RECOMMENDED_SECTION).key) return getItemRank({
            component: component,
            parent: parent
        });
        return undefined;
    };
};

});

parcelRegister("gstGr", function(module, exports) {
$parcel$export(module.exports, "memoProcessQuickInsertItems", () => $edd79c44edbb6183$export$4fca091f4ee92b6d);
$parcel$export(module.exports, "find", () => $edd79c44edbb6183$export$71aa6c912b956294);

var $6NaLT = parcelRequire("6NaLT");

var $57l7A = parcelRequire("57l7A");
const $edd79c44edbb6183$var$processQuickInsertItems = (items, intl)=>{
    return items.reduce((acc, item)=>{
        if (typeof item === 'function' && // we preserve handler items with disableMemo so that we
        // can process them in a later step outside of memoizations
        !item.disableMemo) {
            const quickInsertItems = item(intl);
            return acc.concat(quickInsertItems);
        }
        return acc.concat(item);
    }, []);
};
const $edd79c44edbb6183$var$memoizedProcessQuickInsertItems = (0, $57l7A.default)($edd79c44edbb6183$var$processQuickInsertItems);
const $edd79c44edbb6183$export$4fca091f4ee92b6d = (items, intl)=>{
    const memoizedResults = $edd79c44edbb6183$var$memoizedProcessQuickInsertItems(items, intl);
    const hasDisabledMemos = items.some((item)=>typeof item === 'function' && item.disableMemo);
    if (!hasDisabledMemos) return memoizedResults;
    return memoizedResults.flatMap((item)=>typeof item === 'function' && item.disableMemo ? item(intl) : item);
};
const $edd79c44edbb6183$var$options = {
    threshold: 0.3,
    includeScore: true,
    keys: [
        {
            name: 'title',
            weight: 0.57
        },
        {
            name: 'keywords',
            weight: 0.08
        },
        {
            name: 'description',
            weight: 0.04
        },
        {
            name: 'keyshortcut',
            weight: 0.01
        }
    ]
};
function $edd79c44edbb6183$export$71aa6c912b956294(query, items, prioritySortingFn) {
    if (query === '') // Copy and sort list by priority
    return items.slice(0).sort((a, b)=>(a.priority || Number.POSITIVE_INFINITY) - (b.priority || Number.POSITIVE_INFINITY));
    const fuseOptions = {
        ...$edd79c44edbb6183$var$options
    };
    if (prioritySortingFn) {
        const sortFn = prioritySortingFn(items);
        // prioritySortingFn will trigger the experiment exposure, but sortFn
        // will be undefined for the control group.
        if (sortFn) fuseOptions.sortFn = sortFn;
    }
    const fuse = new (0, $6NaLT.default)(items, fuseOptions);
    const results = fuse.search(query);
    // searching for jira work items macro first
    const datasourceIndex = results.findIndex((r)=>{
        var _r$item$keywords;
        return r.item.id === 'datasource' && ((_r$item$keywords = r.item.keywords) === null || _r$item$keywords === void 0 ? void 0 : _r$item$keywords.includes('jira'));
    });
    //  then searching for the legacy jira macro
    const legacyIndex = results.findIndex((r)=>typeof r.item.key === 'string' && r.item.key.endsWith(':jira'));
    // the jira legcy macro is found before the jira work items macro then swap the two
    if (datasourceIndex > 0 && legacyIndex >= 0 && legacyIndex < datasourceIndex && Math.abs((results[datasourceIndex].score ?? 0) - (results[legacyIndex].score ?? 0)) < 0.2) {
        const [datasource] = results.splice(datasourceIndex, 1);
        results.splice(legacyIndex, 0, datasource);
    }
    return results.map((result)=>result.item);
}

});

parcelRegister("93qUx", function(module, exports) {
$parcel$export(module.exports, "createQuickInsertItemsAnalyticsScheduler", () => $9f4f7c826e96ff0d$export$1d3143213b9a5da7);

var $g6Qq4 = parcelRequire("g6Qq4");

var $4WpTU = parcelRequire("4WpTU");

var $9woaI = parcelRequire("9woaI");
const $9f4f7c826e96ff0d$export$6f0c8faa54b43db = 10000;
const $9f4f7c826e96ff0d$var$GUID_ONLY_APP_KEY_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/iu;
const $9f4f7c826e96ff0d$var$isGuidOnlyAppKey = (appKey)=>$9f4f7c826e96ff0d$var$GUID_ONLY_APP_KEY_REGEX.test(appKey);
const $9f4f7c826e96ff0d$var$sectionCategoryKeys = {
    [(0, $9woaI.BLOCK_TEMPLATES_SECTION).key]: 'blockTemplates',
    [(0, $9woaI.CREATE_SECTION).key]: 'create',
    [(0, $9woaI.DATA_AND_CHARTS_SECTION).key]: 'dataAndCharts',
    [(0, $9woaI.EMBED_SECTION).key]: 'embed',
    [(0, $9woaI.MEDIA_SECTION).key]: 'media',
    [(0, $9woaI.OTHER_SECTION).key]: 'other',
    [(0, $9woaI.ROVO_SECTION).key]: 'rovo',
    [(0, $9woaI.STRUCTURE_SECTION).key]: 'structure',
    [(0, $9woaI.TEXT_FORMATTING_SECTION).key]: 'textFormatting'
};
const $9f4f7c826e96ff0d$var$legacyCategoryKeys = new Set([
    'admin',
    'ai',
    'block-templates',
    'communication',
    'confluence-content',
    'data-and-charts',
    'development',
    'embed',
    'external-content',
    'formatting',
    'media',
    'navigation',
    'other',
    'reporting',
    'skills',
    'structure',
    'text-formatting',
    'visuals'
]);
const $9f4f7c826e96ff0d$var$isLegacyCategoryKey = (category)=>$9f4f7c826e96ff0d$var$legacyCategoryKeys.has(category);
const $9f4f7c826e96ff0d$export$dc378117e8b27887 = ({ providedItems: providedItems })=>{
    const emptyCategoryInformation = ()=>({
            internalMacroCount: 0,
            internalAppCount: 0,
            internalAppMacroMax: 0,
            ecosystemMacroCount: 0,
            ecosystemAppCount: 0,
            ecosystemAppMacroMax: 0,
            allMacroCount: 0,
            allAppCount: 0,
            allAppMacroMax: 0
        });
    const emptyCategoryCounts = {
        blockTemplates: emptyCategoryInformation(),
        create: emptyCategoryInformation(),
        dataAndCharts: emptyCategoryInformation(),
        embed: emptyCategoryInformation(),
        media: emptyCategoryInformation(),
        other: emptyCategoryInformation(),
        rovo: emptyCategoryInformation(),
        structure: emptyCategoryInformation(),
        textFormatting: emptyCategoryInformation()
    };
    const emptyLegacyCategoryCounts = {
        admin: emptyCategoryInformation(),
        ai: emptyCategoryInformation(),
        'block-templates': emptyCategoryInformation(),
        communication: emptyCategoryInformation(),
        'confluence-content': emptyCategoryInformation(),
        'data-and-charts': emptyCategoryInformation(),
        development: emptyCategoryInformation(),
        embed: emptyCategoryInformation(),
        'external-content': emptyCategoryInformation(),
        formatting: emptyCategoryInformation(),
        media: emptyCategoryInformation(),
        navigation: emptyCategoryInformation(),
        other: emptyCategoryInformation(),
        reporting: emptyCategoryInformation(),
        skills: emptyCategoryInformation(),
        structure: emptyCategoryInformation(),
        'text-formatting': emptyCategoryInformation(),
        uncategorized: emptyCategoryInformation(),
        visuals: emptyCategoryInformation()
    };
    const attributes = {
        category: emptyCategoryCounts,
        legacyCategory: emptyLegacyCategoryCounts,
        allCategories: emptyCategoryInformation()
    };
    const appMacroCounts = new WeakMap();
    const getAppMacroCounts = (category)=>{
        const existingCounts = appMacroCounts.get(category);
        if (existingCounts) return existingCounts;
        const counts = {
            all: new Map(),
            internal: new Map(),
            ecosystem: new Map()
        };
        appMacroCounts.set(category, counts);
        return counts;
    };
    const countAppMacro = (appKey, counts)=>{
        const appMacroCount = (counts.get(appKey) ?? 0) + 1;
        counts.set(appKey, appMacroCount);
        return appMacroCount;
    };
    const countCategoryItem = (category, item)=>{
        category.allMacroCount += 1;
        const { key: appKey = 'unknown', source: source } = item.app ?? {};
        const appMacroKey = $9f4f7c826e96ff0d$var$isGuidOnlyAppKey(appKey) ? 'unknown' : appKey;
        const counts = getAppMacroCounts(category);
        const allAppMacroCount = countAppMacro(appMacroKey, counts.all);
        category.allAppCount = counts.all.size;
        category.allAppMacroMax = Math.max(category.allAppMacroMax, allAppMacroCount);
        if (source === 'internal') {
            category.internalMacroCount += 1;
            const internalAppMacroCount = countAppMacro(appMacroKey, counts.internal);
            category.internalAppCount = counts.internal.size;
            category.internalAppMacroMax = Math.max(category.internalAppMacroMax, internalAppMacroCount);
        } else if (source === 'ecosystem') {
            category.ecosystemMacroCount += 1;
            const ecosystemAppMacroCount = countAppMacro(appMacroKey, counts.ecosystem);
            category.ecosystemAppCount = counts.ecosystem.size;
            category.ecosystemAppMacroMax = Math.max(category.ecosystemAppMacroMax, ecosystemAppMacroCount);
        }
    };
    const countItem = (item)=>{
        countCategoryItem(attributes.allCategories, item);
        const categories = item.categories ?? [];
        const normalizedCategories = new Set((categories === null || categories === void 0 ? void 0 : categories.map((category)=>category.trim().toLowerCase()).filter(Boolean)) ?? []);
        let hasUnknownCategory = normalizedCategories.size === 0;
        for (const category of normalizedCategories)if ($9f4f7c826e96ff0d$var$isLegacyCategoryKey(category)) countCategoryItem(attributes.legacyCategory[category], item);
        else hasUnknownCategory = true;
        if (hasUnknownCategory) countCategoryItem(attributes.legacyCategory.uncategorized, item);
        for (const { key: key } of (0, $4WpTU.getQuickInsertMenuItemParents)({
            category: item.category,
            legacyCategories: item.categories,
            rank: 0
        })){
            const categoryKey = $9f4f7c826e96ff0d$var$sectionCategoryKeys[key];
            if (!categoryKey) continue;
            countCategoryItem(attributes.category[categoryKey], item);
        }
    };
    for (const item of providedItems)countItem(item);
    return attributes;
};
const $9f4f7c826e96ff0d$export$1d3143213b9a5da7 = (dispatchAnalyticsEvent)=>{
    let timeoutId;
    let animationFrameId;
    let idleCallbackId;
    let destroyed = false;
    let scheduled = false;
    const emit = (options)=>{
        if (destroyed) return;
        dispatchAnalyticsEvent({
            action: (0, $g6Qq4.ACTION).QUICK_INSERT_INFORMATION,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).QUICK_INSERT,
            attributes: $9f4f7c826e96ff0d$export$dc378117e8b27887(options),
            eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL
        });
    };
    return {
        destroy: ()=>{
            destroyed = true;
            if (timeoutId !== undefined) clearTimeout(timeoutId);
            if (animationFrameId !== undefined && typeof window !== 'undefined') window.cancelAnimationFrame(animationFrameId);
            if (idleCallbackId !== undefined && typeof window !== 'undefined' && typeof window.cancelIdleCallback === 'function') window.cancelIdleCallback(idleCallbackId);
        },
        schedule: (options)=>{
            if (scheduled || destroyed) return;
            scheduled = true;
            timeoutId = setTimeout(()=>{
                if (destroyed || typeof window === 'undefined') return;
                if (typeof window.requestIdleCallback === 'function') idleCallbackId = window.requestIdleCallback(()=>emit(options));
                else if (typeof window.requestAnimationFrame === 'function') animationFrameId = window.requestAnimationFrame(()=>emit(options));
            }, $9f4f7c826e96ff0d$export$6f0c8faa54b43db);
        }
    };
};

});

parcelRegister("5lWCd", function(module, exports) {
$parcel$export(module.exports, "openElementBrowser", () => $ac3c736772092fed$export$efa5e2b745ac3301);
$parcel$export(module.exports, "closeElementBrowser", () => $ac3c736772092fed$export$c1aff7071ceb7d4a);
$parcel$export(module.exports, "openElementBrowserModal", () => $ac3c736772092fed$export$a37159c5d6f821f5);
$parcel$export(module.exports, "closeElementBrowserModal", () => $ac3c736772092fed$export$d7c09ddb7ec80ba9);
$parcel$export(module.exports, "createInsertItem", () => $ac3c736772092fed$export$40b105cb73ed6b94);

var $dw0oh = parcelRequire("dw0oh");

var $7rhDT = parcelRequire("7rhDT");
const $ac3c736772092fed$export$efa5e2b745ac3301 = ({ category: category } = {})=>({ tr: tr })=>tr.setMeta((0, $7rhDT.pluginKey), {
            elementBrowserInitialCategory: category,
            isElementBrowserOpen: true
        });
const $ac3c736772092fed$export$c1aff7071ceb7d4a = ()=>(state, dispatch)=>{
        if (dispatch) dispatch(state.tr.setMeta((0, $7rhDT.pluginKey), {
            elementBrowserInitialCategory: undefined,
            isElementBrowserOpen: false
        }));
        return true;
    };
const $ac3c736772092fed$export$a37159c5d6f821f5 = ({ tr: tr })=>tr.setMeta((0, $7rhDT.pluginKey), {
        isElementBrowserModalOpen: true
    });
const $ac3c736772092fed$export$d7c09ddb7ec80ba9 = ()=>(state, dispatch)=>{
        if (dispatch) dispatch(state.tr.setMeta((0, $7rhDT.pluginKey), {
            isElementBrowserModalOpen: false
        }));
        return true;
    };
const $ac3c736772092fed$export$40b105cb73ed6b94 = (onInsert)=>$ac3c736772092fed$var$insertItem(onInsert);
// this method was adapted from the typeahead plugin so we respect the API for quick insert items
const $ac3c736772092fed$var$insertItem = (onInsert)=>(item, source)=>(state, dispatch)=>{
            const insert = (maybeNode, opts = {})=>{
                return (0, $dw0oh.insertSelectedItem)(maybeNode, opts)(state, state.tr, state.selection.head);
            };
            const tr = item.action(insert, state, source);
            /** @note There is no transaction when called without a search currently (different insert) */ if (tr && dispatch) dispatch(tr);
            onInsert === null || onInsert === void 0 || onInsert(item);
            return true;
        };

});
parcelRegister("7rhDT", function(module, exports) {
$parcel$export(module.exports, "pluginKey", () => $2a7143ba3ed8162a$export$18d4026d1ea86bb1);

var $cw0wu = parcelRequire("cw0wu");
const $2a7143ba3ed8162a$export$18d4026d1ea86bb1 = new (0, $cw0wu.PluginKey)('quickInsertPluginKey');

});


parcelRegister("iLb7V", function(module, exports) {
$parcel$export(module.exports, "getQuickInsertOpenExperiencePlugin", () => $74105ad8961fe90b$export$399cc8247eb1f3b5);

var $g6Qq4 = parcelRequire("g6Qq4");

var $8JHqZ = parcelRequire("8JHqZ");
var $2KDOT = parcelRequire("2KDOT");

var $bApp6 = parcelRequire("bApp6");

var $b8RGE = parcelRequire("b8RGE");

var $73iZo = parcelRequire("73iZo");

var $9skTL = parcelRequire("9skTL");

var $f7Kk4 = parcelRequire("f7Kk4");

var $cw0wu = parcelRequire("cw0wu");
const $74105ad8961fe90b$var$pluginKey = new (0, $cw0wu.PluginKey)('quickInsertOpenExperience');
const $74105ad8961fe90b$var$TIMEOUT_DURATION = 1000;
const $74105ad8961fe90b$var$START_METHOD = {
    QUICK_INSERT_BUTTON: 'quickInsertButton',
    TYPEAHEAD: 'typeahead'
};
const $74105ad8961fe90b$var$ABORT_REASON = {
    USER_CANCELED: 'userCanceled',
    EDITOR_DESTROYED: 'editorDestroyed'
};
const $74105ad8961fe90b$export$399cc8247eb1f3b5 = ({ refs: refs, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>{
    let targetEl;
    let editorViewEl;
    let mouseDownPos;
    const getTarget = ()=>{
        if (!targetEl) targetEl = refs.popupsMountPoint || refs.wrapperElement || (0, $2KDOT.getPopupContainerFromEditorView)(editorViewEl);
        return targetEl;
    };
    const experience = new (0, $b8RGE.Experience)((0, $bApp6.EXPERIENCE_ID).MENU_OPEN, {
        actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).QUICK_INSERT,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        checks: [
            new (0, $9skTL.ExperienceCheckTimeout)({
                durationMs: $74105ad8961fe90b$var$TIMEOUT_DURATION
            }),
            new (0, $73iZo.ExperienceCheckDomMutation)({
                onDomMutation: ({ mutations: mutations })=>{
                    if (mutations.some($74105ad8961fe90b$var$isQuickInsertMenuAddedInMutation)) return {
                        status: 'success'
                    };
                },
                observeConfig: ()=>({
                        target: getTarget(),
                        options: {
                            childList: true
                        }
                    })
            })
        ]
    });
    return new (0, $f7Kk4.SafePlugin)({
        key: $74105ad8961fe90b$var$pluginKey,
        props: {
            handleDOMEvents: {
                mousedown: (_view, event)=>{
                    if ($74105ad8961fe90b$var$isTargetQuickInsertButton(event.target)) mouseDownPos = {
                        x: event.clientX,
                        y: event.clientY
                    };
                },
                mouseup: (_view, event)=>{
                    if (mouseDownPos && $74105ad8961fe90b$var$isTargetQuickInsertButton(event.target) && event.clientX === mouseDownPos.x && event.clientY === mouseDownPos.y) experience.start({
                        method: $74105ad8961fe90b$var$START_METHOD.QUICK_INSERT_BUTTON
                    });
                    mouseDownPos = undefined;
                },
                beforeinput: (view, event)=>{
                    if ($74105ad8961fe90b$var$isQuickInsertTrigger(event) && $74105ad8961fe90b$var$isSelectionWhichSupportsTypeahead(view) && !$74105ad8961fe90b$var$isQuickInsertMenuWithinNode(getTarget())) experience.start({
                        method: $74105ad8961fe90b$var$START_METHOD.TYPEAHEAD,
                        forceRestart: true
                    });
                },
                keydown: (_view, event)=>{
                    if ($74105ad8961fe90b$var$isCancelKey(event.key) && !$74105ad8961fe90b$var$isQuickInsertMenuWithinNode(getTarget())) experience.abort({
                        reason: $74105ad8961fe90b$var$ABORT_REASON.USER_CANCELED
                    });
                }
            }
        },
        view: (editorView)=>{
            editorViewEl = editorView.dom;
            return {
                destroy: ()=>{
                    experience.abort({
                        reason: $74105ad8961fe90b$var$ABORT_REASON.EDITOR_DESTROYED
                    });
                }
            };
        }
    });
};
const $74105ad8961fe90b$var$isQuickInsertTrigger = ({ inputType: inputType, data: data })=>{
    return inputType === 'insertText' && data === '/';
};
const $74105ad8961fe90b$var$isSelectionWhichSupportsTypeahead = ({ state: state })=>{
    var _nodeBefore$textConte;
    const { from: from, $from: $from } = state.selection;
    if ($from.parent.type.name === 'codeBlock') return false;
    if ($from.marks().some((mark)=>mark.type.name === 'code')) return false;
    if (from === 0) return true;
    const nodeBefore = state.doc.resolve(from).nodeBefore;
    if (!nodeBefore) return true;
    const charBefore = ((_nodeBefore$textConte = nodeBefore.textContent) === null || _nodeBefore$textConte === void 0 ? void 0 : _nodeBefore$textConte.slice(-1)) || '';
    return charBefore.trim().length === 0;
};
const $74105ad8961fe90b$var$isCancelKey = (key)=>{
    return key === 'Escape' || key === 'Backspace';
};
const $74105ad8961fe90b$var$isTargetQuickInsertButton = (target)=>{
    return target instanceof HTMLElement && (target.dataset.testid === 'editor-quick-insert-button' || !!target.closest('[data-testid="editor-quick-insert-button"]'));
};
const $74105ad8961fe90b$var$isQuickInsertMenuAddedInMutation = ({ type: type, addedNodes: addedNodes })=>{
    return type === 'childList' && [
        ...addedNodes
    ].some($74105ad8961fe90b$var$isQuickInsertMenuWithinNode);
};
const $74105ad8961fe90b$var$isQuickInsertMenuWithinNode = (node)=>{
    return (0, $8JHqZ.containsPopupWithNestedElement)(node, '.fabric-editor-typeahead');
};

});
parcelRegister("8JHqZ", function(module, exports) {
$parcel$export(module.exports, "containsPopupWithNestedElement", () => $7dd0a070b4fa3522$export$34b917212c8a3de1);
/**
 * Checks if a given node contains a popup with a nested element identified by a specific test ID.
 *
 * @param node - The node to check.
 * @param nestedElementQuery - The query to look for the nested element.
 * @returns True if the node contains the popup, false otherwise.
 */ const $7dd0a070b4fa3522$export$34b917212c8a3de1 = (node, nestedElementQuery)=>{
    if (!(node instanceof HTMLElement)) return false;
    // Check if node itself has the popup attribute and contains the element matching the nestedElementQuery
    if (node.matches('[data-editor-popup="true"]')) return !!node.querySelector(nestedElementQuery);
    // Check if any direct child with popup attribute contains the element matching the nestedElementQuery
    return !!node.querySelector(`:scope > [data-editor-popup="true"] ${nestedElementQuery}`);
};

});


parcelRegister("7VQI9", function(module, exports) {
$parcel$export(module.exports, "getBlockControlQuickInsertComponents", () => $b5f27155a0d804d7$export$14a5937ebd0404ab);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $aCqPV = parcelRequire("aCqPV");

var $dALum = parcelRequire("dALum");

var $cuBKz = parcelRequire("cuBKz");
const $b5f27155a0d804d7$export$14a5937ebd0404ab = ({ api: api, getEditorView: getEditorView, openTypeAhead: openTypeAhead })=>[
        {
            key: 'block-controls-quick-insert',
            type: 'button',
            parents: [
                {
                    ...(0, $dALum.BLOCK_CONTROLS_LEFT_GROUP),
                    rank: 100
                }
            ],
            isHidden: ({ surfaceContext: surfaceContext } = {})=>{
                var _api$editorViewMode;
                const context = surfaceContext === null || surfaceContext === void 0 ? void 0 : surfaceContext.get((0, $aCqPV.BLOCK_CONTROL_UI_CONTEXT));
                return (api === null || api === void 0 || (_api$editorViewMode = api.editorViewMode) === null || _api$editorViewMode === void 0 || (_api$editorViewMode = _api$editorViewMode.sharedState.currentState()) === null || _api$editorViewMode === void 0 ? void 0 : _api$editorViewMode.mode) === 'view' || !(context !== null && context !== void 0 && context.activeNode) || context.targetNode.pos !== context.rootNode.pos || context.targetNode.pos !== context.activeNode.rootPos;
            },
            component: ({ surfaceContext: surfaceContext })=>{
                var _context$activeNode;
                const context = surfaceContext === null || surfaceContext === void 0 ? void 0 : surfaceContext.get((0, $aCqPV.BLOCK_CONTROL_UI_CONTEXT));
                const view = getEditorView();
                if (!context || !view) return null;
                return /*#__PURE__*/ (0, $dc70d.jsx)((0, $cuBKz.BlockControlQuickInsertButton), {
                    api: api,
                    openTypeAhead: openTypeAhead,
                    reserveDragHandleSpace: ((_context$activeNode = context.activeNode) === null || _context$activeNode === void 0 ? void 0 : _context$activeNode.pos) !== context.rootNode.pos,
                    start: context.targetNode.pos,
                    view: view
                });
            }
        }
    ];

});
parcelRegister("cuBKz", function(module, exports) {
$parcel$export(module.exports, "BlockControlQuickInsertButton", () => $39601abd5f42937a$export$2f240217116ba1c2);
/* BlockControlQuickInsertButton.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $cv8id = parcelRequire("cv8id");

var $kictP = parcelRequire("kictP");

var $cw0wu = parcelRequire("cw0wu");

var $gab48 = parcelRequire("gab48");

var $2E7OD = parcelRequire("2E7OD");

var $kFWau = parcelRequire("kFWau");

var $gXqq0 = parcelRequire("gXqq0");

var $lavtv = parcelRequire("lavtv");
const $39601abd5f42937a$var$TEXT_PARENT_TYPES = [
    'paragraph',
    'heading',
    'blockquote',
    'taskItem',
    'decisionItem'
];
// @atlaskit/css intentionally restricts height and width values, so Compiled owns only the
// dimensions that scale at runtime with the editor's dense-mode font-size custom property.
const $39601abd5f42937a$var$quickInsertButtonContainerStyles = {
    root: "_1e0c1txw _4t3i9xsi _1bsb9xsi",
    reservedDragHandleSpace: "_12l21xcw"
};
const $39601abd5f42937a$var$quickInsertButtonStyles = {
    root: "_19itglyw _2rko1rr0 _v564k6bl _1rjcze3t _18zrze3t _4cvr1h6o _bfhksm61 _vchhusvi _syazazsu _80omtlke _1e0c1txw _4t3i1osq _1bah1h6o _1bsb1osq _mizu1v1w _1ah3v77o _ra3xnqa1 _128mdkaa _irr31dpa _1ggl5xtf _1di6fcek"
};
const $39601abd5f42937a$var$createNewLine = (start)=>({ tr: tr })=>{
        var _tr$doc$nodeAt;
        const nodeSize = (_tr$doc$nodeAt = tr.doc.nodeAt(start)) === null || _tr$doc$nodeAt === void 0 ? void 0 : _tr$doc$nodeAt.nodeSize;
        if (nodeSize === undefined) return tr;
        const position = start + nodeSize;
        tr.insert(position, tr.doc.type.schema.nodes.paragraph.create());
        return tr.setSelection((0, $cw0wu.TextSelection).near(tr.doc.resolve(position)));
    };
const $39601abd5f42937a$var$isSelectionInNode = (start, view)=>{
    const node = view.state.doc.nodeAt(start);
    if (!node) return false;
    const { $from: $from, $to: $to } = view.state.selection;
    return $from.pos >= start && $to.pos <= start + node.nodeSize;
};
const $39601abd5f42937a$var$isNonEditableBlock = (start, view)=>{
    const node = view.state.doc.nodeAt(start);
    if (!node) return false;
    if (node.type.name === 'mediaGroup' || node.type.name === 'mediaSingle') return true;
    return node.isBlock && (node.isAtom || node.isLeaf);
};
const $39601abd5f42937a$var$openQuickInsert = (api, view, start, openTypeAhead)=>{
    const isSelectionInsideNode = $39601abd5f42937a$var$isSelectionInNode(start, view);
    if (!isSelectionInsideNode || $39601abd5f42937a$var$isNonEditableBlock(start, view)) api.core.actions.execute($39601abd5f42937a$var$createNewLine(start));
    const { codeBlock: codeBlock } = view.state.schema.nodes;
    const { selection: selection } = view.state;
    const codeBlockParentNode = (0, $gab48.findParentNodeOfType)(codeBlock)(selection);
    if (codeBlockParentNode) api.core.actions.execute($39601abd5f42937a$var$createNewLine(codeBlockParentNode.pos));
    else if (isSelectionInsideNode) {
        const currentSelection = view.state.selection;
        if ((currentSelection instanceof (0, $cw0wu.TextSelection) || currentSelection instanceof (0, $cw0wu.NodeSelection) && currentSelection.node.isInline) && currentSelection.from !== currentSelection.to) {
            const currentParagraphNode = (0, $gab48.findParentNode)((node)=>$39601abd5f42937a$var$TEXT_PARENT_TYPES.includes(node.type.name))(currentSelection);
            if (currentParagraphNode) {
                const newPos = currentSelection.anchor === currentSelection.to ? currentParagraphNode.pos : currentParagraphNode.pos + currentParagraphNode.node.nodeSize - 1;
                api.core.actions.execute(({ tr: tr })=>{
                    tr.setSelection((0, $cw0wu.TextSelection).create(view.state.selection.$from.doc, newPos));
                    return tr;
                });
            }
        }
        if (currentSelection instanceof (0, $cw0wu.NodeSelection) && currentSelection.$from.depth > 0) {
            if ($39601abd5f42937a$var$isNonEditableBlock(view.state.selection.from, view)) api.core.actions.execute($39601abd5f42937a$var$createNewLine(view.state.selection.from));
            else api.core.actions.execute(({ tr: tr })=>{
                $39601abd5f42937a$var$createNewLine(view.state.selection.from)({
                    tr: tr
                });
                tr.setSelection((0, $cw0wu.TextSelection).create(tr.doc, view.state.selection.from));
                return tr;
            });
        }
        if (currentSelection instanceof (0, $2E7OD.CellSelection)) {
            const lastInlinePosition = (0, $cw0wu.TextSelection).near(view.state.selection.$to, -1);
            if (lastInlinePosition) api.core.actions.execute(({ tr: tr })=>{
                if (!(lastInlinePosition instanceof (0, $cw0wu.TextSelection))) {
                    $39601abd5f42937a$var$createNewLine(lastInlinePosition.from)({
                        tr: tr
                    });
                    tr.setSelection((0, $cw0wu.TextSelection).create(tr.doc, lastInlinePosition.to));
                } else tr.setSelection(lastInlinePosition);
                return tr;
            });
        }
    }
    openTypeAhead();
};
const $39601abd5f42937a$export$2f240217116ba1c2 = ({ api: api, openTypeAhead: openTypeAhead, reserveDragHandleSpace: reserveDragHandleSpace = false, start: start, view: view })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const label = formatMessage((0, $kictP.messages).insert);
    const handleMouseDown = (0, $bSJIT.useCallback)(()=>{
        var _api$typeAhead;
        if ((_api$typeAhead = api.typeAhead) !== null && _api$typeAhead !== void 0 && _api$typeAhead.actions.isOpen(view.state)) api.typeAhead.actions.close({
            insertCurrentQueryAsRawText: false
        });
    }, [
        api,
        view
    ]);
    const handleClick = (0, $bSJIT.useCallback)(()=>$39601abd5f42937a$var$openQuickInsert(api, view, start, openTypeAhead), [
        api,
        openTypeAhead,
        start,
        view
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $lavtv.default), {
        position: "top",
        content: /*#__PURE__*/ (0, $dc70d.jsx)((0, $cv8id.ToolTipContent), {
            description: label
        }),
        children: /*#__PURE__*/ (0, $dc70d.jsx)("span", {
            className: (0, $9fU1q.default)([
                $39601abd5f42937a$var$quickInsertButtonContainerStyles.root,
                reserveDragHandleSpace && $39601abd5f42937a$var$quickInsertButtonContainerStyles.reservedDragHandleSpace
            ]),
            children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $gXqq0.Pressable), {
                "aria-label": label,
                onClick: handleClick,
                onMouseDown: handleMouseDown,
                testId: "editor-quick-insert-button",
                type: "button",
                xcss: $39601abd5f42937a$var$quickInsertButtonStyles.root,
                children: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kFWau))), {
                    label: "",
                    color: "var(--ds-icon-subtle, #505258)",
                    size: "small"
                })
            })
        })
    });
};

});


parcelRegister("1orAR", function(module, exports) {
$parcel$export(module.exports, "getLegacyCompatibleComponents", () => $8e1df1c47b39e448$export$7ad4c7c38525438d);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $b8Hvx = parcelRequire("b8Hvx");

var $4WpTU = parcelRequire("4WpTU");

var $3eL0d = parcelRequire("3eL0d");

var $fT9mF = parcelRequire("fT9mF");

var $efcwg = parcelRequire("efcwg");

var $kNU38 = parcelRequire("kNU38");
const $8e1df1c47b39e448$var$LegacyQuickInsertProviderMenuItem = ({ item: item, onInsert: onInsert })=>{
    const { editorView: editorView, isOffline: isOffline } = (0, $efcwg.useQuickInsertContext)();
    const isDisabled = item.isDisabledOffline === true && isOffline;
    const onSelect = ({ insert: insert, source: source })=>{
        const result = item.action(insert, editorView.state, source);
        if (result) onInsert(item);
        return result;
    };
    const Icon = item.icon;
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $fT9mF.QuickInsertMenuItem), {
        description: item.description,
        iconBefore: Icon ? /*#__PURE__*/ (0, $dc70d.jsx)(Icon, {}) : /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kNU38))), {
            label: ""
        }),
        isDisabled: isDisabled,
        onSelect: onSelect,
        preview: item.preview,
        shortcut: item.keyshortcut,
        title: item.title
    });
};
const $8e1df1c47b39e448$var$getItemIdentity = (item, index)=>String(item.key ?? item.id ?? index);
const $8e1df1c47b39e448$var$getComponentsFromLegacyItems = (items, onInsert)=>items.map((item, index)=>{
        const identity = $8e1df1c47b39e448$var$getItemIdentity(item, index);
        return {
            type: 'menu-item',
            key: (0, $3eL0d.getQuickInsertProviderMenuItemKey)(identity, item.app),
            parents: (0, $4WpTU.getQuickInsertMenuItemParents)({
                category: item.category,
                legacyCategories: item.categories,
                rank: item.priority ?? index
            }),
            isHidden: item.isHidden,
            component: ()=>/*#__PURE__*/ (0, $dc70d.jsx)($8e1df1c47b39e448$var$LegacyQuickInsertProviderMenuItem, {
                    item: item,
                    onInsert: onInsert
                }),
            match: (0, $b8Hvx.createQuickInsertMatcher)(()=>({
                    description: item.description,
                    keywords: item.keywords,
                    shortcut: item.keyshortcut,
                    title: item.title
                }))
        };
    });
const $8e1df1c47b39e448$export$7ad4c7c38525438d = ({ directComponents: directComponents, itemFilter: itemFilter, onInsert: onInsert, providedItems: providedItems })=>{
    const filteredItems = itemFilter ? providedItems.filter(itemFilter) : providedItems;
    const allowedKeys = new Set(filteredItems.map((item, index)=>$8e1df1c47b39e448$var$getItemIdentity(item, index)));
    const directComponentsWithRenderer = directComponents.filter((component)=>typeof component.component === 'function');
    const namespacedDirectComponents = directComponentsWithRenderer.filter((component)=>!itemFilter || allowedKeys.has(component.key)).map((component)=>{
        const item = filteredItems.find((candidate, index)=>$8e1df1c47b39e448$var$getItemIdentity(candidate, index) === component.key);
        return {
            ...component,
            isHidden: item !== null && item !== void 0 && item.isHidden ? (options)=>{
                var _component$isHidden, _item$isHidden;
                return ((_component$isHidden = component.isHidden) === null || _component$isHidden === void 0 ? void 0 : _component$isHidden.call(component, options)) === true || ((_item$isHidden = item.isHidden) === null || _item$isHidden === void 0 ? void 0 : _item$isHidden.call(item)) === true;
            } : component.isHidden,
            key: (0, $3eL0d.getQuickInsertProviderMenuItemKey)(component.key, item === null || item === void 0 ? void 0 : item.app),
            component: item ? (props)=>component.component({
                    ...props,
                    onInsert: ()=>onInsert(item)
                }) : component.component,
            match: component.match ?? (item ? (0, $b8Hvx.createQuickInsertMatcher)(()=>({
                    description: item.description,
                    keywords: item.keywords,
                    shortcut: item.keyshortcut,
                    title: item.title
                })) : undefined)
        };
    });
    const directComponentKeys = new Set(directComponentsWithRenderer.map((component)=>component.key));
    const fallbackComponents = $8e1df1c47b39e448$var$getComponentsFromLegacyItems(filteredItems.filter((item, index)=>!directComponentKeys.has($8e1df1c47b39e448$var$getItemIdentity(item, index))), onInsert);
    return [
        ...fallbackComponents,
        ...namespacedDirectComponents
    ];
};

});

parcelRegister("1pASS", function(module, exports) {
$parcel$export(module.exports, "getQuickInsertComponents", () => $b68ef3e781cd1ae9$export$97fd3cfe99274aa2);

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $9woaI = parcelRequire("9woaI");

var $8kF6T = parcelRequire("8kF6T");

var $g2pPc = parcelRequire("g2pPc");

var $64eKJ = parcelRequire("64eKJ");

var $am2Qg = parcelRequire("am2Qg");

var $2Zjkk = parcelRequire("2Zjkk");

var $aFhQ3 = parcelRequire("aFhQ3");

var $kxg9D = parcelRequire("kxg9D");

var $lnlN2 = parcelRequire("lnlN2");

var $fZGnO = parcelRequire("fZGnO");

var $1M6RW = parcelRequire("1M6RW");
const $b68ef3e781cd1ae9$var$categories = [
    {
        message: (0, $64eKJ.messages).categoryRecommended,
        section: (0, $9woaI.RECOMMENDED_SECTION)
    },
    {
        message: (0, $64eKJ.messages).categoryStructure,
        section: (0, $9woaI.STRUCTURE_SECTION)
    },
    {
        message: (0, $64eKJ.messages).categoryMedia,
        section: (0, $9woaI.MEDIA_SECTION)
    },
    {
        message: (0, $64eKJ.messages).categoryCreate,
        section: (0, $9woaI.CREATE_SECTION)
    },
    {
        message: (0, $64eKJ.messages).categoryEmbed,
        section: (0, $9woaI.EMBED_SECTION)
    },
    {
        message: (0, $64eKJ.messages).categoryTextFormatting,
        section: (0, $9woaI.TEXT_FORMATTING_SECTION)
    },
    {
        message: (0, $64eKJ.messages).categoryRovo,
        section: (0, $9woaI.ROVO_SECTION)
    },
    {
        message: (0, $64eKJ.messages).categoryDataAndCharts,
        section: (0, $9woaI.DATA_AND_CHARTS_SECTION)
    },
    {
        message: (0, $64eKJ.messages).categoryBlockTemplates,
        section: (0, $9woaI.BLOCK_TEMPLATES_SECTION)
    },
    {
        message: (0, $64eKJ.messages).categoryOther,
        section: (0, $9woaI.OTHER_SECTION)
    }
];
const $b68ef3e781cd1ae9$var$createSectionComponent = (message)=>{
    const SectionComponent = ({ children: children })=>{
        const { formatMessage: formatMessage } = (0, $4vLTk.default)();
        return (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $g2pPc.QuickInsertMenuSection), {
            title: formatMessage(message)
        }, children);
    };
    return SectionComponent;
};
const $b68ef3e781cd1ae9$export$97fd3cfe99274aa2 = ({ api: api, includeElementBrowserItems: includeElementBrowserItems, isRecommendedItem: isRecommendedItem, maxRecommendedItems: maxRecommendedItems })=>{
    const recommendedSnapshot = (0, $kxg9D.createRecommendedSnapshotCache)({
        api: api,
        isRecommendedItem: isRecommendedItem,
        maxRecommendedItems: maxRecommendedItems
    });
    const recommendedSlots = Array.from({
        length: (0, $kxg9D.MAX_RECOMMENDED_ITEMS)
    }, (_, index)=>({
            key: `${0, $kxg9D.RECOMMENDED_SLOT_KEY_PREFIX}${index}`,
            type: 'menu-item',
            parents: [
                {
                    key: (0, $9woaI.RECOMMENDED_SECTION).key,
                    type: (0, $9woaI.RECOMMENDED_SECTION).type,
                    rank: index
                }
            ],
            match: ()=>null,
            isHidden: ({ surfaceContext: surfaceContext } = {})=>!recommendedSnapshot.getSnapshot(surfaceContext)[index],
            component: (props)=>(0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $fZGnO.QuickInsertRecommendedSlot), {
                    ...props,
                    index: index,
                    getSnapshot: recommendedSnapshot.getSnapshot
                })
        }));
    return [
        {
            key: (0, $9woaI.MENU).key,
            type: (0, $9woaI.MENU).type,
            component: (0, $8kF6T.QuickInsertMenuRoot)
        },
        ...recommendedSlots,
        ...$b68ef3e781cd1ae9$var$categories.flatMap(({ message: message, section: section })=>[
                {
                    key: section.key,
                    type: section.type,
                    parents: [
                        {
                            key: (0, $9woaI.MENU).key,
                            type: (0, $9woaI.MENU).type,
                            rank: (0, $am2Qg.QUICK_INSERT_MENU_RANK)[section.key]
                        }
                    ],
                    component: $b68ef3e781cd1ae9$var$createSectionComponent(message),
                    isHidden: section.key === (0, $9woaI.RECOMMENDED_SECTION).key ? ({ surfaceContext: surfaceContext } = {})=>recommendedSnapshot.getSnapshot(surfaceContext).length === 0 : undefined
                },
                ...includeElementBrowserItems && section.key !== (0, $9woaI.RECOMMENDED_SECTION).key ? [
                    {
                        key: (0, $aFhQ3.getSectionOverflowItemKey)(section.key),
                        type: 'menu-item',
                        parents: [
                            {
                                key: section.key,
                                type: section.type,
                                rank: (0, $am2Qg.CATEGORY_VIEW_MORE_RANK)
                            }
                        ],
                        component: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $1M6RW.QuickInsertSectionOverflowMenuItem), {
                                api: api,
                                category: section.key
                            })
                    }
                ] : []
            ]),
        ...includeElementBrowserItems ? [
            {
                key: (0, $2Zjkk.getMenuFooterSectionKey)((0, $9woaI.MENU).key),
                type: 'menu-section',
                parents: [
                    {
                        key: (0, $9woaI.MENU).key,
                        type: (0, $9woaI.MENU).type,
                        rank: Number.MAX_SAFE_INTEGER
                    }
                ]
            },
            {
                key: (0, $9woaI.VIEW_ALL_ELEMENTS_MENU_ITEM).key,
                type: (0, $9woaI.VIEW_ALL_ELEMENTS_MENU_ITEM).type,
                parents: [
                    {
                        key: (0, $2Zjkk.getMenuFooterSectionKey)((0, $9woaI.MENU).key),
                        type: 'menu-section',
                        rank: 100
                    }
                ],
                component: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement((0, $lnlN2.QuickInsertMenuFooterItem), {
                        api: api
                    })
            }
        ] : []
    ];
};

});
parcelRegister("8kF6T", function(module, exports) {
$parcel$export(module.exports, "QuickInsertMenuRoot", () => $73479d6f433946f1$export$e3bbcc8b2ad059b0);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $65Fe1 = parcelRequire("65Fe1");
const $73479d6f433946f1$export$e3bbcc8b2ad059b0 = ({ children: children })=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $65Fe1.default), {
        children: children
    });

});

parcelRegister("2Zjkk", function(module, exports) {
$parcel$export(module.exports, "getMenuFooterSectionKey", () => $3298abc70a3cbefa$export$671aedeb86e8b59a);

var $6vCxA = parcelRequire("6vCxA");
const $3298abc70a3cbefa$export$671aedeb86e8b59a = (menuKey)=>`${menuKey}${0, $6vCxA.MENU_FOOTER_SECTION_KEY_SUFFIX}`;

});

parcelRegister("aFhQ3", function(module, exports) {
$parcel$export(module.exports, "getSectionOverflowItemKey", () => $8af5349dbe673bc4$export$5436cd2a53179e15);

var $lf2zo = parcelRequire("lf2zo");
const $8af5349dbe673bc4$export$5436cd2a53179e15 = (sectionKey)=>`${sectionKey}${0, $lf2zo.SECTION_OVERFLOW_ITEM_KEY_SUFFIX}`;

});

parcelRegister("kxg9D", function(module, exports) {
$parcel$export(module.exports, "MAX_RECOMMENDED_ITEMS", () => $7e8347ee76497dd3$export$1f6c3ab5e2ffe7c9);
$parcel$export(module.exports, "RECOMMENDED_SLOT_KEY_PREFIX", () => $7e8347ee76497dd3$export$3d576a4afc6c4f84);
$parcel$export(module.exports, "createRecommendedSnapshotCache", () => $7e8347ee76497dd3$export$ede11567a50811ba);

var $j2Y9J = parcelRequire("j2Y9J");

var $3eL0d = parcelRequire("3eL0d");

var $7tv0d = parcelRequire("7tv0d");

var $9woaI = parcelRequire("9woaI");

var $93UeO = parcelRequire("93UeO");

var $2WXs5 = parcelRequire("2WXs5");

var $3xPFq = parcelRequire("3xPFq");
const $7e8347ee76497dd3$export$1f6c3ab5e2ffe7c9 = 5;
const $7e8347ee76497dd3$export$3d576a4afc6c4f84 = 'quick-insert-recommended-slot-';
const $7e8347ee76497dd3$export$d4242db6e41cd32 = (key)=>key.startsWith($7e8347ee76497dd3$export$3d576a4afc6c4f84);
const $7e8347ee76497dd3$var$isRecommendationCandidate = (component)=>component.type === 'menu-item' && !$7e8347ee76497dd3$export$d4242db6e41cd32(component.key) && !(0, $2WXs5.isSectionOverflowItemKey)(component.key) && !component.parents.some((parent)=>(0, $93UeO.isMenuFooterSectionKey)(parent.key));
const $7e8347ee76497dd3$export$6236b72fecfc8d60 = (maxRecommendedItems)=>{
    if (maxRecommendedItems === undefined || !Number.isFinite(maxRecommendedItems)) return $7e8347ee76497dd3$export$1f6c3ab5e2ffe7c9;
    if (maxRecommendedItems > $7e8347ee76497dd3$export$1f6c3ab5e2ffe7c9) (0, $j2Y9J.logException)(new Error('Quick Insert maxRecommendedItems exceeds the available slots'), {
        location: 'editor-plugin-quick-insert/getRecommendedComponents'
    });
    return Math.min(Math.max(Math.floor(maxRecommendedItems), 1), $7e8347ee76497dd3$export$1f6c3ab5e2ffe7c9);
};
const $7e8347ee76497dd3$export$91a55d980aef6b30 = ({ components: components, context: context, isRecommendedItem: isRecommendedItem = (0, $7tv0d.defaultIsRecommendedItem), maxRecommendedItems: maxRecommendedItems })=>{
    return components.filter($7e8347ee76497dd3$var$isRecommendationCandidate).flatMap((component, index)=>{
        var _component$isHidden;
        // Provider items are namespaced in the registry; consumers rank them by their source key.
        const result = isRecommendedItem({
            itemKey: (0, $3eL0d.quickInsertProviderMenuItemKey).getSourceKey(component.key)
        });
        if (result === null) return [];
        if (Number.isNaN(result.rank)) {
            (0, $j2Y9J.logException)(new Error('Invalid Quick Insert recommended item rank'), {
                location: 'editor-plugin-quick-insert/getRecommendedComponents'
            });
            return [];
        }
        if ((_component$isHidden = component.isHidden) !== null && _component$isHidden !== void 0 && _component$isHidden.call(component, {
            surfaceContext: context
        })) return [];
        return [
            {
                component: component,
                index: index,
                rank: result.rank
            }
        ];
    }).sort((first, second)=>first.rank === second.rank ? first.index - second.index : first.rank - second.rank).slice(0, $7e8347ee76497dd3$export$6236b72fecfc8d60(maxRecommendedItems)).map(({ component: component })=>component);
};
const $7e8347ee76497dd3$export$ede11567a50811ba = ({ api: api, isRecommendedItem: isRecommendedItem, maxRecommendedItems: maxRecommendedItems })=>{
    let snapshot;
    const getSnapshot = (surfaceContext)=>{
        var _surfaceContext$get, _snapshot;
        const menuOpenId = surfaceContext === null || surfaceContext === void 0 || (_surfaceContext$get = surfaceContext.get((0, $3xPFq.TYPE_AHEAD_SURFACE_CONTEXT))) === null || _surfaceContext$get === void 0 ? void 0 : _surfaceContext$get.menuOpenId;
        if (!surfaceContext || !menuOpenId) return [];
        if (((_snapshot = snapshot) === null || _snapshot === void 0 ? void 0 : _snapshot.id) !== menuOpenId) {
            var _api$uiControlRegistr;
            snapshot = {
                id: menuOpenId,
                items: $7e8347ee76497dd3$export$91a55d980aef6b30({
                    components: (api === null || api === void 0 || (_api$uiControlRegistr = api.uiControlRegistry) === null || _api$uiControlRegistr === void 0 ? void 0 : _api$uiControlRegistr.actions.getComponents((0, $9woaI.MENU).key)) ?? [],
                    context: surfaceContext,
                    isRecommendedItem: isRecommendedItem,
                    maxRecommendedItems: maxRecommendedItems
                })
            };
        }
        return snapshot.items;
    };
    return {
        getSnapshot: getSnapshot
    };
};

});
parcelRegister("7tv0d", function(module, exports) {
$parcel$export(module.exports, "defaultIsRecommendedItem", () => $0fae0dc30eafdc1e$export$55b7a034e29c70b0);

var $9woaI = parcelRequire("9woaI");
const $0fae0dc30eafdc1e$export$a7de2c77b9753ca0 = (orderedKeys)=>{
    const ranks = new Map(orderedKeys.map((key, index)=>[
            key,
            index
        ]));
    return ({ itemKey: itemKey })=>{
        const rank = ranks.get(itemKey);
        return rank === undefined ? null : {
            rank: rank
        };
    };
};
const $0fae0dc30eafdc1e$export$55b7a034e29c70b0 = $0fae0dc30eafdc1e$export$a7de2c77b9753ca0([
    (0, $9woaI.ASK_ROVO_MENU_ITEM).key,
    (0, $9woaI.HYPERLINK_MENU_ITEM).key,
    (0, $9woaI.MEDIA_INSERT_MENU_ITEM).key,
    (0, $9woaI.EMOJI_MENU_ITEM).key,
    (0, $9woaI.MENTION_MENU_ITEM).key
]);

});


parcelRegister("lnlN2", function(module, exports) {
$parcel$export(module.exports, "QuickInsertMenuFooterItem", () => $7476024896343f65$export$58c18b8bb85a91a);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $cW1gB = parcelRequire("cW1gB");

var $fT9mF = parcelRequire("fT9mF");

var $iabGk = parcelRequire("iabGk");
const $7476024896343f65$export$58c18b8bb85a91a = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const onSelect = (0, $bSJIT.useCallback)(({ insert: insert })=>{
        var _api$quickInsert;
        const tr = insert(undefined);
        return (api === null || api === void 0 || (_api$quickInsert = api.quickInsert) === null || _api$quickInsert === void 0 ? void 0 : _api$quickInsert.commands.openElementBrowser()({
            tr: tr
        })) ?? tr;
    }, [
        api
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $fT9mF.QuickInsertMenuItem), {
        ariaLabel: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).viewMoreAriaLabel),
        iconBefore: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iabGk))), {
            label: ""
        }),
        isDisabled: !(api !== null && api !== void 0 && api.quickInsert),
        onSelect: onSelect,
        shouldShowPreview: false,
        shouldWrapIcon: false,
        title: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).viewMore)
    });
};

});

parcelRegister("fZGnO", function(module, exports) {
$parcel$export(module.exports, "QuickInsertRecommendedSlot", () => $5f04c50dcdc1c60c$export$72d1305303853208);

var $bSJIT = parcelRequire("bSJIT");

var $efcwg = parcelRequire("efcwg");
const $5f04c50dcdc1c60c$export$72d1305303853208 = ({ index: index, getSnapshot: getSnapshot, ...props })=>{
    const { surfaceContext: surfaceContext } = (0, $efcwg.useQuickInsertContext)();
    const item = getSnapshot(surfaceContext)[index];
    return item !== null && item !== void 0 && item.component ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(item.component, props) : null;
};

});

parcelRegister("1M6RW", function(module, exports) {
$parcel$export(module.exports, "QuickInsertSectionOverflowMenuItem", () => $94d6683d9b769c00$export$51d41dc7948a4ae5);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $cW1gB = parcelRequire("cW1gB");

var $fT9mF = parcelRequire("fT9mF");

var $kFWau = parcelRequire("kFWau");
const $94d6683d9b769c00$export$51d41dc7948a4ae5 = ({ api: api, category: category })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const onSelect = (0, $bSJIT.useCallback)(({ insert: insert })=>{
        var _api$quickInsert;
        const tr = insert(undefined);
        return (api === null || api === void 0 || (_api$quickInsert = api.quickInsert) === null || _api$quickInsert === void 0 ? void 0 : _api$quickInsert.commands.openElementBrowser({
            category: category
        })({
            tr: tr
        })) ?? tr;
    }, [
        api,
        category
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $fT9mF.QuickInsertMenuItem), {
        iconBefore: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kFWau))), {
            label: ""
        }),
        isDisabled: !(api !== null && api !== void 0 && api.quickInsert),
        onSelect: onSelect,
        shouldShowPreview: false,
        title: formatMessage((0, $cW1gB.toolbarInsertBlockMessages).viewMore)
    });
};

});


parcelRegister("2zbrN", function(module, exports) {
$parcel$export(module.exports, "default", () => $ad390d7d00e2dd4a$export$2e2bcd8739ae039);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $g6Qq4 = parcelRequire("g6Qq4");

var $hVGJk = parcelRequire("hVGJk");

var $5beht = parcelRequire("5beht");

var $3y2s4 = parcelRequire("3y2s4");

var $gdUUy = parcelRequire("gdUUy");

var $5lWCd = parcelRequire("5lWCd");

var $7rhDT = parcelRequire("7rhDT");

var $hN9lF = parcelRequire("hN9lF");
const $ad390d7d00e2dd4a$var$Modal = ({ quickInsertState: quickInsertState, isOffline: isOffline, editorView: editorView, helpUrl: helpUrl, insertItem: insertItem, getSuggestions: getSuggestions, api: api, defaultCategory: defaultCategory })=>{
    const getItems = (0, $bSJIT.useCallback)((query, category)=>{
        var _getSuggestions;
        return (getSuggestions === null || getSuggestions === void 0 || (_getSuggestions = getSuggestions({
            query: query,
            category: category
        })) === null || _getSuggestions === void 0 ? void 0 : _getSuggestions.map((item)=>{
            return isOffline && item.isDisabledOffline ? {
                ...item,
                isDisabled: true
            } : item;
        })) ?? [];
    }, // See: https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/157796/overview?commentId=8559952
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        getSuggestions,
        quickInsertState.lazyDefaultItems,
        quickInsertState.providedItems,
        isOffline
    ]);
    const focusInEditor = (0, $bSJIT.useCallback)(()=>{
        if (!editorView.hasFocus()) editorView.focus();
    }, [
        editorView
    ]);
    // ED-19408 We not store the item ref in the state
    // Instead of adding the item immediately on insert item
    // We wait until modal close is complete, refocus the editor and then add the item
    const insertableItem = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useRef(null);
    const closeBrowser = (0, $bSJIT.useCallback)(()=>{
        const closeCommand = (0, $3y2s4.isExperimentEnabled)('platform_editor_slash_command') ? (0, $5lWCd.closeElementBrowser) : (0, $5lWCd.closeElementBrowserModal);
        closeCommand()(editorView.state, editorView.dispatch);
    }, [
        editorView
    ]);
    const onInsertItem = (0, $bSJIT.useCallback)((item)=>{
        closeBrowser();
        if ((0, $gdUUy.fg)('platform_editor_ease_of_use_metrics')) {
            var _api$metrics;
            api === null || api === void 0 || api.core.actions.execute(api === null || api === void 0 || (_api$metrics = api.metrics) === null || _api$metrics === void 0 ? void 0 : _api$metrics.commands.startActiveSessionTimer());
        }
        insertableItem.current = item;
    }, [
        closeBrowser,
        api
    ]);
    const onClose = (0, $bSJIT.useCallback)(()=>{
        closeBrowser();
        if ((0, $gdUUy.fg)('platform_editor_ease_of_use_metrics')) {
            var _api$metrics2;
            api === null || api === void 0 || api.core.actions.execute(api === null || api === void 0 || (_api$metrics2 = api.metrics) === null || _api$metrics2 === void 0 ? void 0 : _api$metrics2.commands.startActiveSessionTimer());
        }
        focusInEditor();
    }, [
        closeBrowser,
        focusInEditor,
        api
    ]);
    const onCloseComplete = (0, $bSJIT.useCallback)(()=>{
        if (!insertableItem.current) {
            focusInEditor();
            return;
        }
        const item = insertableItem.current;
        insertableItem.current = null;
        focusInEditor();
        insertItem === null || insertItem === void 0 || insertItem(item, (0, $g6Qq4.INPUT_METHOD).ELEMENT_BROWSER)(editorView.state, editorView.dispatch);
    }, [
        editorView,
        focusInEditor,
        insertItem
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $hN9lF.default), {
        defaultCategory: defaultCategory,
        getItems: getItems,
        onInsertItem: onInsertItem,
        helpUrl: helpUrl,
        isOpen: quickInsertState.isElementBrowserOpen || false,
        emptyStateHandler: quickInsertState.emptyStateHandler,
        onClose: onClose,
        onCloseComplete: onCloseComplete,
        shouldReturnFocus: false
    });
};
var $ad390d7d00e2dd4a$export$2e2bcd8739ae039 = ({ editorView: editorView, helpUrl: helpUrl, pluginInjectionAPI: pluginInjectionAPI })=>{
    var _pluginKey$getState, _pluginInjectionAPI$q, _pluginInjectionAPI$q2;
    const { lazyDefaultItems: lazyDefaultItems, providedItems: providedItems, isElementBrowserOpen: isElementBrowserOpen, emptyStateHandler: emptyStateHandler, mode: mode } = (0, $5beht.useSharedPluginStateWithSelector)(pluginInjectionAPI, [
        'quickInsert',
        'connectivity'
    ], (state)=>{
        var _state$quickInsertSta, _state$quickInsertSta2, _state$quickInsertSta3, _state$quickInsertSta4, _state$quickInsertSta5, _state$connectivitySt;
        return {
            lazyDefaultItems: (_state$quickInsertSta = state.quickInsertState) === null || _state$quickInsertSta === void 0 ? void 0 : _state$quickInsertSta.lazyDefaultItems,
            providedItems: (_state$quickInsertSta2 = state.quickInsertState) === null || _state$quickInsertSta2 === void 0 ? void 0 : _state$quickInsertSta2.providedItems,
            isElementBrowserOpen: (0, $3y2s4.isExperimentEnabled)('platform_editor_slash_command') ? (_state$quickInsertSta3 = state.quickInsertState) === null || _state$quickInsertSta3 === void 0 ? void 0 : _state$quickInsertSta3.isElementBrowserOpen : (_state$quickInsertSta4 = state.quickInsertState) === null || _state$quickInsertSta4 === void 0 ? void 0 : _state$quickInsertSta4.isElementBrowserModalOpen,
            emptyStateHandler: (_state$quickInsertSta5 = state.quickInsertState) === null || _state$quickInsertSta5 === void 0 ? void 0 : _state$quickInsertSta5.emptyStateHandler,
            mode: (_state$connectivitySt = state.connectivityState) === null || _state$connectivitySt === void 0 ? void 0 : _state$connectivitySt.mode
        };
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)($ad390d7d00e2dd4a$var$Modal, {
        defaultCategory: (_pluginKey$getState = (0, $7rhDT.pluginKey).getState(editorView.state)) === null || _pluginKey$getState === void 0 ? void 0 : _pluginKey$getState.elementBrowserInitialCategory,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        quickInsertState: {
            lazyDefaultItems: lazyDefaultItems,
            providedItems: providedItems,
            isElementBrowserOpen: isElementBrowserOpen,
            emptyStateHandler: emptyStateHandler
        },
        editorView: editorView,
        helpUrl: helpUrl,
        isOffline: (0, $hVGJk.isOfflineMode)(mode),
        insertItem: pluginInjectionAPI === null || pluginInjectionAPI === void 0 || (_pluginInjectionAPI$q = pluginInjectionAPI.quickInsert) === null || _pluginInjectionAPI$q === void 0 || (_pluginInjectionAPI$q = _pluginInjectionAPI$q.actions) === null || _pluginInjectionAPI$q === void 0 ? void 0 : _pluginInjectionAPI$q.insertItem,
        getSuggestions: pluginInjectionAPI === null || pluginInjectionAPI === void 0 || (_pluginInjectionAPI$q2 = pluginInjectionAPI.quickInsert) === null || _pluginInjectionAPI$q2 === void 0 || (_pluginInjectionAPI$q2 = _pluginInjectionAPI$q2.actions) === null || _pluginInjectionAPI$q2 === void 0 ? void 0 : _pluginInjectionAPI$q2.getSuggestions,
        api: pluginInjectionAPI
    });
};

});
parcelRegister("hN9lF", function(module, exports) {
$parcel$export(module.exports, "default", () => $ff740f28e95afa75$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $fK3tS = parcelRequire("fK3tS");
var $4vLTk = parcelRequire("4vLTk");

var $hzFIQ = parcelRequire("hzFIQ");

var $disn5 = parcelRequire("disn5");

var $64eKJ = parcelRequire("64eKJ");

var $1hEmZ = parcelRequire("1hEmZ");

var $803Gl = parcelRequire("803Gl");

var $hwgr4 = parcelRequire("hwgr4");

var $c9mVs = parcelRequire("c9mVs");

var $lFaAn = parcelRequire("lFaAn");

var $5ucts = parcelRequire("5ucts");
function $ff740f28e95afa75$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ff740f28e95afa75$export$77ff514ac660f8f8 = 16;
const $ff740f28e95afa75$var$actionsStyles = /*#__PURE__*/ (0, $9dQre.css)({
    display: 'inline-flex',
    margin: `0 ${"var(--ds-space-negative-050, -4px)"}`
});
const $ff740f28e95afa75$var$actionItemStyles = /*#__PURE__*/ (0, $9dQre.css)({
    flex: '1 0 auto',
    margin: `0 ${"var(--ds-space-050, 4px)"}`
});
const $ff740f28e95afa75$var$wrapperStyles = /*#__PURE__*/ (0, $9dQre.css)({
    display: 'flex',
    flex: '1 1 auto',
    boxSizing: 'border-box',
    padding: `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-200, 16px)"} 0 10px`,
    overflow: 'hidden',
    backgroundColor: "var(--ds-surface-overlay, #FFFFFF)",
    borderRadius: "var(--ds-radius-small, 3px)"
});
const $ff740f28e95afa75$var$modalFooterStyles = /*#__PURE__*/ (0, $9dQre.css)({
    display: 'flex',
    padding: `${"var(--ds-space-200, 16px)"}`,
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'space-between'
});
const $ff740f28e95afa75$var$modalCloseButtonStyles = {
    name: "1446vv2",
    styles: "display:flex;justify-content:flex-end;padding-block-start:var(--ds-space-200, 16px);padding-inline:var(--ds-space-200, 16px)"
};
const $ff740f28e95afa75$var$ModalElementBrowser = (props)=>{
    const [selectedItem, setSelectedItem] = (0, $bSJIT.useState)();
    const { helpUrl: helpUrl, intl: intl, onInsertItem: onInsertItemFn } = props;
    const onSelectItem = (0, $bSJIT.useCallback)((item)=>{
        setSelectedItem(item);
    }, [
        setSelectedItem
    ]);
    const onInsertItem = (0, $bSJIT.useCallback)((item)=>{
        onInsertItemFn(item);
    }, [
        onInsertItemFn
    ]);
    const RenderFooter = (0, $bSJIT.useCallback)(()=>/*#__PURE__*/ (0, $9dQre.jsx)($ff740f28e95afa75$var$Footer, {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onInsert: ()=>onInsertItem(selectedItem),
            beforeElement: helpUrl ? $ff740f28e95afa75$var$HelpLink(helpUrl, intl.formatMessage((0, $64eKJ.messages).help)) : undefined
        }), [
        onInsertItem,
        selectedItem,
        helpUrl,
        intl
    ]);
    const RenderBody = (0, $bSJIT.useCallback)(()=>/*#__PURE__*/ (0, $9dQre.jsx)("div", {
            css: $ff740f28e95afa75$var$wrapperStyles
        }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $disn5.default), {
            categories: (0, $5ucts.getCategories)(props.intl),
            defaultCategory: props.defaultCategory,
            getItems: props.getItems,
            showSearch: true,
            showCategories: true,
            mode: "full",
            onSelectItem: onSelectItem,
            onInsertItem: onInsertItem,
            emptyStateHandler: props.emptyStateHandler,
            autoFocusSearch: false
        })), [
        props.intl,
        props.defaultCategory,
        props.getItems,
        onSelectItem,
        onInsertItem,
        props.emptyStateHandler
    ]);
    const label = intl.formatMessage((0, $64eKJ.messages).browse);
    return /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        "data-editor-popup": true
    }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $lFaAn.default), null, props.isOpen && // eslint-disable-next-line @atlaskit/design-system/no-modal-label
    /*#__PURE__*/ (0, $9dQre.jsx)((0, $c9mVs.default), {
        label: label,
        testId: "element-browser-modal-dialog",
        stackIndex: 0,
        key: "element-browser-modal",
        onClose: props.onClose,
        onCloseComplete: props.onCloseComplete,
        height: "664px",
        width: "x-large",
        shouldReturnFocus: props.shouldReturnFocus
    }, /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        css: $ff740f28e95afa75$var$modalCloseButtonStyles
    }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $803Gl.CloseButton), {
        onClick: props.onClose
    })), /*#__PURE__*/ (0, $9dQre.jsx)(RenderBody, null), /*#__PURE__*/ (0, $9dQre.jsx)(RenderFooter, null))));
};
$ff740f28e95afa75$var$ModalElementBrowser.displayName = 'ModalElementBrowser';
const $ff740f28e95afa75$var$Footer = ({ onInsert: onInsert, beforeElement: beforeElement })=>{
    const intl = (0, $4vLTk.default)();
    const { onClose: onClose } = (0, $hwgr4.useModal)();
    return /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        css: $ff740f28e95afa75$var$modalFooterStyles
    }, beforeElement ? beforeElement : /*#__PURE__*/ (0, $9dQre.jsx)("span", null), /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        css: $ff740f28e95afa75$var$actionsStyles
    }, /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        css: $ff740f28e95afa75$var$actionItemStyles
    }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $hzFIQ.default), {
        appearance: "primary",
        onClick: onInsert,
        testId: "ModalElementBrowser__insert-button"
    }, intl.formatMessage((0, $64eKJ.messages).insert))), /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        css: $ff740f28e95afa75$var$actionItemStyles
    }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $hzFIQ.default), {
        appearance: "subtle",
        onClick: onClose,
        testId: "ModalElementBrowser__close-button"
    }, intl.formatMessage((0, $64eKJ.messages).close)))));
};
const $ff740f28e95afa75$var$HelpLink = (url, helpText)=>/*#__PURE__*/ (0, $9dQre.jsx)((0, $hzFIQ.default), {
        iconBefore: /*#__PURE__*/ (0, $9dQre.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1hEmZ))), {
            label: ""
        }),
        appearance: "subtle-link",
        href: url,
        target: "_blank",
        testId: "ModalElementBrowser__help-button"
    }, helpText);
const $ff740f28e95afa75$var$_default_1 = (0, $fK3tS.default)($ff740f28e95afa75$var$ModalElementBrowser);
var $ff740f28e95afa75$export$2e2bcd8739ae039 = $ff740f28e95afa75$var$_default_1;

});
parcelRegister("5ucts", function(module, exports) {
$parcel$export(module.exports, "getCategories", () => $7fcf1e8149c75800$export$7a0f33e8df10bd94);

var $64eKJ = parcelRequire("64eKJ");
function $7fcf1e8149c75800$export$7a0f33e8df10bd94(intl) {
    return [
        {
            title: intl.formatMessage((0, $64eKJ.messages).all),
            name: 'all'
        },
        {
            title: intl.formatMessage((0, $64eKJ.messages).AI),
            name: 'AI'
        },
        {
            title: intl.formatMessage((0, $64eKJ.messages).formatting),
            name: 'formatting'
        },
        {
            title: intl.formatMessage((0, $64eKJ.messages)['confluence-content']),
            name: 'confluence-content'
        },
        {
            title: intl.formatMessage((0, $64eKJ.messages).media),
            name: 'media'
        },
        {
            title: intl.formatMessage((0, $64eKJ.messages).visuals),
            name: 'visuals'
        },
        {
            title: intl.formatMessage((0, $64eKJ.messages).navigation),
            name: 'navigation'
        },
        {
            title: intl.formatMessage((0, $64eKJ.messages)['external-content']),
            name: 'external-content'
        },
        {
            title: intl.formatMessage((0, $64eKJ.messages).communication),
            name: 'communication'
        },
        {
            title: intl.formatMessage((0, $64eKJ.messages).reporting),
            name: 'reporting'
        },
        {
            title: intl.formatMessage((0, $64eKJ.messages).admin),
            name: 'admin'
        },
        {
            title: intl.formatMessage((0, $64eKJ.messages).development),
            name: 'development'
        }
    ];
}

});



parcelRegister("93g3K", function(module, exports) {
$parcel$export(module.exports, "RegistryElementBrowserContainer", () => $d6ee77b0a586277d$export$353e135d77a9825b);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $g6Qq4 = parcelRequire("g6Qq4");

var $hVGJk = parcelRequire("hVGJk");

var $dw0oh = parcelRequire("dw0oh");

var $9woaI = parcelRequire("9woaI");

var $5beht = parcelRequire("5beht");

var $5lWCd = parcelRequire("5lWCd");

var $7rhDT = parcelRequire("7rhDT");

var $cMIDL = parcelRequire("cMIDL");
const $d6ee77b0a586277d$var$EMPTY_COMPONENTS = [];
const $d6ee77b0a586277d$var$subscribeToNothing = ()=>()=>{};
const $d6ee77b0a586277d$export$353e135d77a9825b = ({ editorView: editorView, pluginInjectionAPI: pluginInjectionAPI, helpUrl: helpUrl })=>{
    var _pluginInjectionAPI$u2, _pluginInjectionAPI$a2, _pluginKey$getState;
    const { emptyStateHandler: currentEmptyStateHandler, isElementBrowserOpen: isElementBrowserOpen, mode: mode } = (0, $5beht.useSharedPluginStateWithSelector)(pluginInjectionAPI, [
        'quickInsert',
        'connectivity'
    ], (state)=>{
        var _state$quickInsertSta, _state$quickInsertSta2, _state$connectivitySt;
        return {
            isElementBrowserOpen: ((_state$quickInsertSta = state.quickInsertState) === null || _state$quickInsertSta === void 0 ? void 0 : _state$quickInsertSta.isElementBrowserOpen) ?? false,
            emptyStateHandler: (_state$quickInsertSta2 = state.quickInsertState) === null || _state$quickInsertSta2 === void 0 ? void 0 : _state$quickInsertSta2.emptyStateHandler,
            mode: (_state$connectivitySt = state.connectivityState) === null || _state$connectivitySt === void 0 ? void 0 : _state$connectivitySt.mode
        };
    });
    const getRegistrySnapshot = (0, $bSJIT.useCallback)(()=>{
        var _pluginInjectionAPI$u;
        if (!isElementBrowserOpen) return $d6ee77b0a586277d$var$EMPTY_COMPONENTS;
        const components = pluginInjectionAPI === null || pluginInjectionAPI === void 0 || (_pluginInjectionAPI$u = pluginInjectionAPI.uiControlRegistry) === null || _pluginInjectionAPI$u === void 0 ? void 0 : _pluginInjectionAPI$u.actions.getComponents((0, $9woaI.MENU).key);
        return components !== null && components !== void 0 && components.length ? components : $d6ee77b0a586277d$var$EMPTY_COMPONENTS;
    }, [
        isElementBrowserOpen,
        pluginInjectionAPI
    ]);
    const components = (0, $bSJIT.useSyncExternalStore)(isElementBrowserOpen ? (pluginInjectionAPI === null || pluginInjectionAPI === void 0 || (_pluginInjectionAPI$u2 = pluginInjectionAPI.uiControlRegistry) === null || _pluginInjectionAPI$u2 === void 0 ? void 0 : _pluginInjectionAPI$u2.actions.subscribe) ?? $d6ee77b0a586277d$var$subscribeToNothing : $d6ee77b0a586277d$var$subscribeToNothing, getRegistrySnapshot, getRegistrySnapshot);
    const [emptyStateHandler, setEmptyStateHandler] = (0, $bSJIT.useState)();
    const wasOpen = (0, $bSJIT.useRef)(false);
    const selectionHandler = (0, $bSJIT.useRef)(undefined);
    const isInsertConfirmed = (0, $bSJIT.useRef)(false);
    const lifecycleOpen = (0, $bSJIT.useRef)(false);
    const fireLifecycleEvent = (0, $bSJIT.useCallback)((action)=>{
        var _pluginInjectionAPI$a;
        pluginInjectionAPI === null || pluginInjectionAPI === void 0 || (_pluginInjectionAPI$a = pluginInjectionAPI.analytics) === null || _pluginInjectionAPI$a === void 0 || _pluginInjectionAPI$a.actions.fireAnalyticsEvent({
            action: action,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).ELEMENT_BROWSER,
            attributes: {
                mode: 'full'
            },
            eventType: (0, $g6Qq4.EVENT_TYPE).UI
        });
    }, [
        pluginInjectionAPI
    ]);
    (0, $bSJIT.useEffect)(()=>{
        if (isElementBrowserOpen && !wasOpen.current) {
            selectionHandler.current = undefined;
            setEmptyStateHandler(()=>currentEmptyStateHandler);
            isInsertConfirmed.current = false;
            lifecycleOpen.current = true;
            fireLifecycleEvent((0, $g6Qq4.ACTION).OPENED);
        } else if (!isElementBrowserOpen && wasOpen.current && lifecycleOpen.current) {
            lifecycleOpen.current = false;
            fireLifecycleEvent((0, $g6Qq4.ACTION).CLOSED);
        }
        wasOpen.current = isElementBrowserOpen;
    }, [
        currentEmptyStateHandler,
        fireLifecycleEvent,
        isElementBrowserOpen
    ]);
    (0, $bSJIT.useEffect)(()=>()=>{
            if (lifecycleOpen.current) {
                lifecycleOpen.current = false;
                fireLifecycleEvent((0, $g6Qq4.ACTION).CLOSED);
            }
        }, [
        fireLifecycleEvent
    ]);
    const focusInEditor = (0, $bSJIT.useCallback)(()=>{
        if (!editorView.hasFocus()) editorView.focus();
    }, [
        editorView
    ]);
    const onClose = (0, $bSJIT.useCallback)(()=>{
        if (!isInsertConfirmed.current) selectionHandler.current = undefined;
        (0, $5lWCd.closeElementBrowser)()(editorView.state, editorView.dispatch);
        focusInEditor();
    }, [
        editorView,
        focusInEditor
    ]);
    const onCloseComplete = (0, $bSJIT.useCallback)(()=>{
        const handler = isInsertConfirmed.current ? selectionHandler.current : undefined;
        selectionHandler.current = undefined;
        isInsertConfirmed.current = false;
        focusInEditor();
        if (!handler) return;
        const insert = (maybeNode, options = {})=>(0, $dw0oh.insertSelectedItem)(maybeNode, options)(editorView.state, editorView.state.tr, editorView.state.selection.head);
        const transaction = handler({
            insert: insert,
            source: (0, $g6Qq4.INPUT_METHOD).ELEMENT_BROWSER
        });
        if (transaction) editorView.dispatch(transaction);
    }, [
        editorView,
        focusInEditor
    ]);
    const onSelect = (0, $bSJIT.useCallback)((handler)=>{
        selectionHandler.current = handler;
    }, []);
    const onClearSelection = (0, $bSJIT.useCallback)(()=>{
        selectionHandler.current = undefined;
        isInsertConfirmed.current = false;
    }, []);
    const onConfirmInsert = (0, $bSJIT.useCallback)(()=>{
        if (!selectionHandler.current) return;
        isInsertConfirmed.current = true;
        onClose();
    }, [
        onClose
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $cMIDL.RegistryElementBrowser), {
        components: components,
        fireAnalyticsEvent: pluginInjectionAPI === null || pluginInjectionAPI === void 0 || (_pluginInjectionAPI$a2 = pluginInjectionAPI.analytics) === null || _pluginInjectionAPI$a2 === void 0 ? void 0 : _pluginInjectionAPI$a2.actions.fireAnalyticsEvent,
        emptyStateHandler: emptyStateHandler,
        helpUrl: helpUrl,
        defaultSection: (_pluginKey$getState = (0, $7rhDT.pluginKey).getState(editorView.state)) === null || _pluginKey$getState === void 0 ? void 0 : _pluginKey$getState.elementBrowserInitialCategory,
        editorView: editorView,
        isOffline: (0, $hVGJk.isOfflineMode)(mode),
        isOpen: isElementBrowserOpen,
        onClearSelection: onClearSelection,
        onClose: onClose,
        onCloseComplete: onCloseComplete,
        onConfirmInsert: onConfirmInsert,
        onSelect: onSelect
    });
};

});
parcelRegister("cMIDL", function(module, exports) {
$parcel$export(module.exports, "RegistryElementBrowser", () => $64a1058e3d46811d$export$94614d73cafbcc48);
/* RegistryElementBrowser.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $4TRbS = parcelRequire("4TRbS");

var $64eKJ = parcelRequire("64eKJ");

var $9woaI = parcelRequire("9woaI");

var $88sf5 = parcelRequire("88sf5");

var $2Zjkk = parcelRequire("2Zjkk");

var $aFhQ3 = parcelRequire("aFhQ3");

var $7WQx2 = parcelRequire("7WQx2");

var $9dYEz = parcelRequire("9dYEz");

var $2w1u7 = parcelRequire("2w1u7");

var $c9mVs = parcelRequire("c9mVs");

var $7HzAO = parcelRequire("7HzAO");

var $j4mCC = parcelRequire("j4mCC");

var $4TlNm = parcelRequire("4TlNm");

var $lFaAn = parcelRequire("lFaAn");

var $gdUUy = parcelRequire("gdUUy");

var $jgsO4 = parcelRequire("jgsO4");

var $7nWMa = parcelRequire("7nWMa");

var $bd9iR = parcelRequire("bd9iR");

var $b0tbe = parcelRequire("b0tbe");

var $2Owvc = parcelRequire("2Owvc");
const $64a1058e3d46811d$var$browserGridTemplateColumns = '182px minmax(0, 1fr)';
const $64a1058e3d46811d$var$categoryColumnGap = `calc(${"var(--ds-space-200, 16px)"} + ${"var(--ds-space-150, 12px)"})`;
const $64a1058e3d46811d$var$browserLayoutStyles = null;
const $64a1058e3d46811d$var$headerContentStyles = null;
const $64a1058e3d46811d$var$headerSearchStyles = null;
const $64a1058e3d46811d$var$EMPTY_ITEMS = [];
const $64a1058e3d46811d$var$resultsId = 'registry-element-browser-results';
const $64a1058e3d46811d$var$modalTestId = 'registry-element-browser-modal';
const $64a1058e3d46811d$var$getRenderedColumnCount = (options)=>{
    var _options$;
    const firstRowTop = (_options$ = options[0]) === null || _options$ === void 0 ? void 0 : _options$.getBoundingClientRect().top;
    const nextRowIndex = options.findIndex((option)=>firstRowTop !== undefined && option.getBoundingClientRect().top > firstRowTop + 1);
    return nextRowIndex > 0 ? nextRowIndex : options.length;
};
const $64a1058e3d46811d$export$94614d73cafbcc48 = ({ components: components, emptyStateHandler: emptyStateHandler, fireAnalyticsEvent: fireAnalyticsEvent, defaultSection: defaultSection, helpUrl: helpUrl, editorView: editorView, isLoading: isLoading = false, isOffline: isOffline, isOpen: isOpen, onClearSelection: onClearSelection, onClose: onClose, onCloseComplete: onCloseComplete, onConfirmInsert: onConfirmInsert, onSelect: onSelect })=>{
    var _model$fallbackItems;
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const [browserState, setBrowserState] = (0, $bSJIT.useState)({
        query: '',
        section: defaultSection
    });
    const { query: query, section: section, selectedRegistration: selectedRegistration } = browserState;
    const selectedRegistrationRef = (0, $bSJIT.useRef)(undefined);
    const browserModel = (0, $bSJIT.useMemo)(()=>{
        const model = (0, $7nWMa.createRegistryElementBrowserModel)(components, {
            footerKey: (0, $2Zjkk.getMenuFooterSectionKey)((0, $9woaI.MENU).key),
            overflowKeys: new Set(components.filter((component)=>component.type === 'menu-section').map((component)=>(0, $aFhQ3.getSectionOverflowItemKey)(component.key))),
            recommendedSectionKey: (0, $9woaI.RECOMMENDED_SECTION).key,
            rootKey: (0, $9woaI.MENU).key
        });
        const effectiveSection = section && model.sections.some(({ key: key })=>key === section) ? section : undefined;
        return {
            model: model,
            effectiveSection: effectiveSection,
            items: (0, $7nWMa.getRegistryElementBrowserItems)({
                formatMessage: formatMessage,
                model: model,
                query: query,
                section: effectiveSection
            })
        };
    }, [
        components,
        formatMessage,
        query,
        section
    ]);
    const { model: model, effectiveSection: effectiveSection, items: items } = browserModel;
    const visibleItems = items.length === 0 && !isLoading && query.trim().length > 0 ? model.fallbackItems ?? $64a1058e3d46811d$var$EMPTY_ITEMS : items;
    const isSelectedRegistrationCurrent = Boolean(selectedRegistration && browserState.selectionIsOffline === isOffline && visibleItems.some(({ registration: registration })=>registration === selectedRegistration));
    const selectedKey = isSelectedRegistrationCurrent ? selectedRegistration === null || selectedRegistration === void 0 ? void 0 : selectedRegistration.key : undefined;
    const invalidSection = Boolean(section && section !== effectiveSection);
    const invalidSelection = Boolean(selectedRegistration && !isSelectedRegistrationCurrent);
    if (isOpen && (invalidSection || invalidSelection)) setBrowserState({
        ...browserState,
        section: effectiveSection,
        selectedRegistration: undefined,
        selectionIsOffline: undefined,
        invalidation: {
            section: invalidSection ? section : undefined,
            selection: invalidSelection
        }
    });
    const searchInputRef = (0, $bSJIT.useRef)(null);
    const selectedCategoryRef = (0, $bSJIT.useRef)(null);
    const focusedCategoryRef = (0, $bSJIT.useRef)();
    const handledInvalidationRef = (0, $bSJIT.useRef)(browserState.invalidation);
    const wasOpen = (0, $bSJIT.useRef)(false);
    (0, $bSJIT.useEffect)(()=>{
        if (isOpen && !wasOpen.current) {
            selectedRegistrationRef.current = undefined;
            setBrowserState({
                query: '',
                section: (0, $7nWMa.getInitialRegistryElementBrowserSection)(model, defaultSection),
                selectedRegistration: undefined
            });
            onClearSelection();
        }
        wasOpen.current = isOpen;
    }, [
        defaultSection,
        isOpen,
        model,
        onClearSelection
    ]);
    (0, $bSJIT.useEffect)(()=>{
        var _searchInputRef$curre;
        const invalidation = browserState.invalidation;
        if (!isOpen || !invalidation || handledInvalidationRef.current === invalidation) return;
        handledInvalidationRef.current = invalidation;
        selectedRegistrationRef.current = undefined;
        onClearSelection();
        const ownerDocument = (_searchInputRef$curre = searchInputRef.current) === null || _searchInputRef$curre === void 0 ? void 0 : _searchInputRef$curre.ownerDocument;
        const activeElement = ownerDocument === null || ownerDocument === void 0 ? void 0 : ownerDocument.activeElement;
        if (invalidation.section && focusedCategoryRef.current === invalidation.section && activeElement === (ownerDocument === null || ownerDocument === void 0 ? void 0 : ownerDocument.body)) {
            var _selectedCategoryRef$;
            (_selectedCategoryRef$ = selectedCategoryRef.current) === null || _selectedCategoryRef$ === void 0 || _selectedCategoryRef$.focus();
        } else if (invalidation.selection && (activeElement === (ownerDocument === null || ownerDocument === void 0 ? void 0 : ownerDocument.body) || activeElement !== null && activeElement !== void 0 && activeElement.closest('[role="option"]'))) {
            var _searchInputRef$curre2;
            (_searchInputRef$curre2 = searchInputRef.current) === null || _searchInputRef$curre2 === void 0 || _searchInputRef$curre2.focus();
        }
    }, [
        browserState.invalidation,
        isOpen,
        onClearSelection
    ]);
    const resultCount = items.length || (!isLoading && query.trim() ? ((_model$fallbackItems = model.fallbackItems) === null || _model$fallbackItems === void 0 ? void 0 : _model$fallbackItems.length) ?? 0 : 0);
    const flushSearchAnalytics = (0, $88sf5.useQuickInsertSearchAnalytics)({
        query: query,
        resultCount: items.length,
        surface: 'element-browser',
        category: effectiveSection ?? 'all',
        isOpen: isOpen && !isLoading,
        fireAnalyticsEvent: fireAnalyticsEvent
    });
    const closeBrowser = (0, $bSJIT.useCallback)(()=>{
        flushSearchAnalytics();
        onClose();
    }, [
        flushSearchAnalytics,
        onClose
    ]);
    const onSearchFocus = (0, $bSJIT.useCallback)(()=>{
        focusedCategoryRef.current = undefined;
    }, []);
    const onBrowserFocusCapture = (0, $bSJIT.useCallback)((event)=>{
        const categories = event.currentTarget.querySelector('[data-testid="registry-element-browser-categories"]');
        const category = event.target instanceof HTMLElement && categories !== null && categories !== void 0 && categories.contains(event.target) ? event.target.closest('[data-section]') : null;
        focusedCategoryRef.current = category ? category.dataset.section ?? '' : undefined;
    }, []);
    const onSearchChange = (0, $bSJIT.useCallback)((event)=>{
        const nextQuery = event.currentTarget.value;
        selectedRegistrationRef.current = undefined;
        setBrowserState((current)=>({
                ...current,
                query: nextQuery,
                selectedRegistration: undefined
            }));
        onClearSelection();
    }, [
        onClearSelection
    ]);
    const onSectionClick = (0, $bSJIT.useCallback)((event)=>{
        const nextSection = event.currentTarget.dataset.section || undefined;
        selectedRegistrationRef.current = undefined;
        setBrowserState({
            query: '',
            section: nextSection,
            selectedRegistration: undefined
        });
        onClearSelection();
    }, [
        onClearSelection
    ]);
    const onRegistrySelect = (0, $bSJIT.useCallback)((key, handler)=>{
        var _model$items$find;
        const registration = (_model$items$find = model.items.find(({ registration: registration })=>registration.key === key)) === null || _model$items$find === void 0 ? void 0 : _model$items$find.registration;
        selectedRegistrationRef.current = registration;
        setBrowserState((current)=>({
                ...current,
                selectedRegistration: registration,
                selectionIsOffline: isOffline
            }));
        onSelect(handler);
    }, [
        isOffline,
        model.items,
        onSelect
    ]);
    const confirmInsert = (0, $bSJIT.useCallback)(()=>{
        const selectedRegistration = selectedRegistrationRef.current;
        if (!selectedRegistration || !visibleItems.some(({ registration: registration })=>registration === selectedRegistration)) return;
        onConfirmInsert();
    }, [
        onConfirmInsert,
        visibleItems
    ]);
    const onModalOpenComplete = (0, $bSJIT.useCallback)((node)=>{
        node.style.borderRadius = "var(--ds-radius-large, 8px)";
        const footer = node.querySelector(`[data-testid="${$64a1058e3d46811d$var$modalTestId}--footer"]`);
        footer === null || footer === void 0 || footer.style.setProperty('box-sizing', 'border-box');
        footer === null || footer === void 0 || footer.style.setProperty('height', '64px');
        footer === null || footer === void 0 || footer.style.setProperty('padding-block', "var(--ds-space-200, 16px)");
        const scrollableBody = node.querySelector(`[data-testid="${$64a1058e3d46811d$var$modalTestId}--scrollable"]`);
        scrollableBody === null || scrollableBody === void 0 || scrollableBody.style.setProperty('border-block-start', 'none');
        scrollableBody === null || scrollableBody === void 0 || scrollableBody.style.setProperty('border-block-end', 'none');
    }, []);
    const onKeyDown = (0, $bSJIT.useCallback)((event)=>{
        if (event.key === 'Tab' && event.shiftKey && event.target instanceof HTMLElement && event.target.getAttribute('role') === 'option') {
            var _selectedCategoryRef$2;
            event.preventDefault();
            (_selectedCategoryRef$2 = selectedCategoryRef.current) === null || _selectedCategoryRef$2 === void 0 || _selectedCategoryRef$2.focus();
            return;
        }
        if ([
            'ArrowDown',
            'ArrowUp',
            'ArrowLeft',
            'ArrowRight'
        ].includes(event.key)) {
            if (event.currentTarget === searchInputRef.current && (event.key === 'ArrowLeft' || event.key === 'ArrowRight')) return;
            const resultCollection = event.currentTarget.ownerDocument.getElementById($64a1058e3d46811d$var$resultsId);
            const options = Array.from((resultCollection === null || resultCollection === void 0 ? void 0 : resultCollection.querySelectorAll('[role="option"]')) ?? []);
            const currentIndex = options.findIndex((option)=>option === event.currentTarget.ownerDocument.activeElement);
            const columnCount = $64a1058e3d46811d$var$getRenderedColumnCount(options);
            const step = event.key === 'ArrowDown' ? columnCount : event.key === 'ArrowUp' ? -columnCount : event.key === 'ArrowRight' ? 1 : -1;
            let nextIndex = currentIndex < 0 ? 0 : currentIndex + step;
            if (event.key === 'ArrowDown' && columnCount < options.length) nextIndex = Math.min(nextIndex, options.length - 1);
            while(nextIndex >= 0 && nextIndex < options.length && (options[nextIndex].hasAttribute('disabled') || options[nextIndex].getAttribute('aria-disabled') === 'true'))nextIndex += step;
            const nextOption = options[nextIndex];
            if (nextOption) {
                event.preventDefault();
                nextOption.focus();
                nextOption.click();
            } else if (nextIndex < 0 && currentIndex >= 0) {
                var _searchInputRef$curre3;
                event.preventDefault();
                (_searchInputRef$curre3 = searchInputRef.current) === null || _searchInputRef$curre3 === void 0 || _searchInputRef$curre3.focus();
            }
            return;
        }
        if (event.key === 'Escape') {
            event.preventDefault();
            closeBrowser();
            return;
        }
        if (event.key === 'Enter') {
            var _event$currentTarget$;
            const focusedOption = event.target instanceof HTMLElement ? event.target.closest('[role="option"]') : null;
            const firstOption = (_event$currentTarget$ = event.currentTarget.ownerDocument.getElementById($64a1058e3d46811d$var$resultsId)) === null || _event$currentTarget$ === void 0 ? void 0 : _event$currentTarget$.querySelector('[role="option"]:not([aria-disabled="true"]):not([disabled])');
            const optionToActivate = focusedOption ?? firstOption;
            if (isSelectedRegistrationCurrent || optionToActivate) {
                event.preventDefault();
                if (!isSelectedRegistrationCurrent) optionToActivate === null || optionToActivate === void 0 || optionToActivate.click();
                confirmInsert();
            }
        }
    }, [
        closeBrowser,
        confirmInsert,
        isSelectedRegistrationCurrent
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $lFaAn.default), {
        children: isOpen && /*#__PURE__*/ (0, $dc70d.jsxs)((0, $c9mVs.default), {
            label: formatMessage({
                defaultMessage: 'Insert elements',
                id: 'editor.quick-insert.title'
            }),
            height: "664px",
            onClose: closeBrowser,
            onCloseComplete: onCloseComplete,
            onOpenComplete: onModalOpenComplete,
            testId: $64a1058e3d46811d$var$modalTestId,
            width: "min(968px, calc(100vw - 32px))",
            children: [
                /*#__PURE__*/ (0, $dc70d.jsx)((0, $j4mCC.default), {
                    children: /*#__PURE__*/ (0, $dc70d.jsxs)("div", {
                        className: (0, $9fU1q.default)([
                            "_zulp1fka _1e0c11p5 _yv0e1xuv _1bsb1osq _lk4ji47z"
                        ]),
                        children: [
                            (0, $gdUUy.fg)('platform_dst_modal-dialog-use-modal-title') ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $4TlNm.default), {
                                children: formatMessage({
                                    defaultMessage: 'Insert elements',
                                    id: 'editor.quick-insert.title'
                                })
                            }) : /*#__PURE__*/ (0, $dc70d.jsx)((0, $7WQx2.default), {
                                size: "medium",
                                children: formatMessage({
                                    defaultMessage: 'Insert elements',
                                    id: 'editor.quick-insert.title'
                                })
                            }),
                            /*#__PURE__*/ (0, $dc70d.jsxs)("div", {
                                className: (0, $9fU1q.default)([
                                    "_zulp1ejb _4cvr1h6o _1e0c11p5 _yv0ehpfy _1bsb1osq"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $dc70d.jsx)((0, $jgsO4.default), {
                                        autoFocus: true,
                                        "aria-controls": $64a1058e3d46811d$var$resultsId,
                                        "aria-label": formatMessage({
                                            defaultMessage: 'Search elements',
                                            id: 'editor.quick-insert.search'
                                        }),
                                        isCompact: true,
                                        name: "registry-element-browser-search",
                                        onFocus: onSearchFocus,
                                        onChange: onSearchChange,
                                        onKeyDown: onKeyDown,
                                        ref: searchInputRef,
                                        value: query
                                    }),
                                    /*#__PURE__*/ (0, $dc70d.jsx)((0, $4TRbS.default), {
                                        appearance: "subtle",
                                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($9dYEz))),
                                        label: formatMessage((0, $64eKJ.messages).close),
                                        onClick: closeBrowser,
                                        spacing: "compact"
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $dc70d.jsx)((0, $2w1u7.default), {
                    children: /*#__PURE__*/ (0, $dc70d.jsxs)("div", {
                        onFocusCapture: onBrowserFocusCapture,
                        className: (0, $9fU1q.default)([
                            "_zulp1fka _18zr1b66 _1e0c11p5 _yv0e1xuv _1q511b66 _lk4ji47z"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $dc70d.jsx)((0, $bd9iR.RegistryElementBrowserCategories), {
                                section: effectiveSection,
                                sections: model.sections,
                                onSectionClick: onSectionClick,
                                selectedButtonRef: selectedCategoryRef
                            }),
                            /*#__PURE__*/ (0, $dc70d.jsx)((0, $2Owvc.RegistryElementBrowserSearchResults), {
                                editorView: editorView,
                                emptyStateHandler: emptyStateHandler,
                                isLoading: isLoading,
                                isOffline: isOffline,
                                items: items,
                                fallbackItems: model.fallbackItems,
                                query: query,
                                resultsId: $64a1058e3d46811d$var$resultsId,
                                section: effectiveSection,
                                selectedKey: selectedKey,
                                onKeyDown: onKeyDown,
                                onSelect: onRegistrySelect
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $dc70d.jsx)((0, $7HzAO.default), {
                    children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $b0tbe.RegistryElementBrowserFooter), {
                        helpUrl: helpUrl,
                        isInsertEnabled: isSelectedRegistrationCurrent,
                        onClose: closeBrowser,
                        onConfirmInsert: confirmInsert,
                        resultCount: resultCount
                    })
                })
            ]
        })
    });
};

});
parcelRegister("7nWMa", function(module, exports) {
$parcel$export(module.exports, "createRegistryElementBrowserModel", () => $67278e5ffba52170$export$46f20bcf4e6b6485);
$parcel$export(module.exports, "getInitialRegistryElementBrowserSection", () => $67278e5ffba52170$export$99d4f28c9c96f5f0);
$parcel$export(module.exports, "getRegistryElementBrowserItems", () => $67278e5ffba52170$export$5c915404c4e9c307);

var $b8Hvx = parcelRequire("b8Hvx");

var $9woaI = parcelRequire("9woaI");
const $67278e5ffba52170$var$compareRanks = (left, right)=>{
    for(let index = 0; index < Math.max(left.length, right.length); index++){
        const difference = (left[index] ?? 0) - (right[index] ?? 0);
        if (difference !== 0) return difference;
    }
    return 0;
};
const $67278e5ffba52170$var$isVisible = (registration)=>{
    var _registration$isHidde;
    return ((_registration$isHidde = registration.isHidden) === null || _registration$isHidde === void 0 ? void 0 : _registration$isHidde.call(registration)) !== true;
};
const $67278e5ffba52170$var$getChildren = (components, parentKey)=>components.filter((component)=>{
        var _component$parents;
        return $67278e5ffba52170$var$isVisible(component) && ((_component$parents = component.parents) === null || _component$parents === void 0 ? void 0 : _component$parents.some((parent)=>parent.key === parentKey));
    });
const $67278e5ffba52170$var$getParentRank = (registration, parentKey)=>{
    var _registration$parents;
    return ((_registration$parents = registration.parents) === null || _registration$parents === void 0 || (_registration$parents = _registration$parents.find((parent)=>parent.key === parentKey)) === null || _registration$parents === void 0 ? void 0 : _registration$parents.rank) ?? Number.MAX_SAFE_INTEGER;
};
const $67278e5ffba52170$var$getDescendantItems = (components, parentKey, ancestorRanks, sectionKey)=>$67278e5ffba52170$var$getChildren(components, parentKey).flatMap((component)=>{
        const ranks = [
            ...ancestorRanks,
            $67278e5ffba52170$var$getParentRank(component, parentKey)
        ];
        if (component.type === 'menu-item') return component.component ? [
            {
                ranks: ranks,
                registration: component,
                sectionKeys: [
                    sectionKey
                ]
            }
        ] : [];
        return $67278e5ffba52170$var$getDescendantItems(components, component.key, ranks, sectionKey);
    });
const $67278e5ffba52170$export$46f20bcf4e6b6485 = (components, { footerKey: footerKey, overflowKeys: overflowKeys, recommendedSectionKey: recommendedSectionKey, rootKey: rootKey })=>{
    const excludedKeys = new Set([
        footerKey,
        recommendedSectionKey,
        ...overflowKeys
    ]);
    const visibleComponents = components.filter((component)=>$67278e5ffba52170$var$isVisible(component) && !excludedKeys.has(component.key));
    const sections = $67278e5ffba52170$var$getChildren(visibleComponents, rootKey).filter((component)=>component.type === 'menu-section').map((section)=>({
            key: section.key,
            rank: $67278e5ffba52170$var$getParentRank(section, rootKey)
        })).sort((left, right)=>left.rank - right.rank);
    const itemByKey = new Map();
    sections.forEach((section)=>{
        $67278e5ffba52170$var$getDescendantItems(visibleComponents, section.key, [
            section.rank
        ], section.key).forEach((item)=>{
            const existing = itemByKey.get(item.registration.key);
            if (!existing) {
                itemByKey.set(item.registration.key, item);
                return;
            }
            const sectionKeys = [
                ...new Set([
                    ...existing.sectionKeys,
                    ...item.sectionKeys
                ])
            ];
            itemByKey.set(item.registration.key, $67278e5ffba52170$var$compareRanks(item.ranks, existing.ranks) < 0 ? {
                ...item,
                sectionKeys: sectionKeys
            } : {
                ...existing,
                sectionKeys: sectionKeys
            });
        });
    });
    const items = [
        ...itemByKey.values()
    ].sort((left, right)=>$67278e5ffba52170$var$compareRanks(left.ranks, right.ranks));
    const fallbackItems = items.filter(({ registration: registration })=>registration.key === (0, $9woaI.ASK_ROVO_MENU_ITEM).key);
    return {
        fallbackItems: fallbackItems.length > 0 ? fallbackItems : undefined,
        items: items,
        sections: sections
    };
};
const $67278e5ffba52170$export$99d4f28c9c96f5f0 = (model, requestedSection)=>model.sections.some((section)=>section.key === requestedSection) ? requestedSection : undefined;
const $67278e5ffba52170$export$5c915404c4e9c307 = ({ formatMessage: formatMessage, model: model, query: query, section: section })=>{
    const normalizedQuery = query.trim();
    const items = section ? model.items.filter((item)=>item.sectionKeys.includes(section)) : model.items;
    const itemsWithDescriptions = items.map((item)=>{
        var _createQuickInsertMat;
        return {
            ...item,
            description: (_createQuickInsertMat = (0, $b8Hvx.createQuickInsertMatcher).getDescription) === null || _createQuickInsertMat === void 0 ? void 0 : _createQuickInsertMat.call((0, $b8Hvx.createQuickInsertMatcher), item.registration.match, formatMessage)
        };
    });
    if (!normalizedQuery) return itemsWithDescriptions;
    return itemsWithDescriptions.flatMap((item)=>{
        var _item$registration$ma, _item$registration;
        const result = (_item$registration$ma = (_item$registration = item.registration).match) === null || _item$registration$ma === void 0 ? void 0 : _item$registration$ma.call(_item$registration, {
            formatMessage: formatMessage,
            query: normalizedQuery
        });
        return result ? [
            {
                ...item,
                score: Math.min(1, Math.max(0, result.score))
            }
        ] : [];
    }).sort((left, right)=>(left.ranks[0] ?? 0) - (right.ranks[0] ?? 0) || left.score - right.score || $67278e5ffba52170$var$compareRanks(left.ranks, right.ranks) || left.registration.key.localeCompare(right.registration.key));
};

});

parcelRegister("bd9iR", function(module, exports) {
$parcel$export(module.exports, "RegistryElementBrowserCategories", () => $b451374ca232b9bc$export$bb615d63a03cb0f5);
/* RegistryElementBrowserCategories.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $jNJGJ = parcelRequire("jNJGJ");

var $9woaI = parcelRequire("9woaI");

var $64eKJ = parcelRequire("64eKJ");

var $8aT4G = parcelRequire("8aT4G");
const $b451374ca232b9bc$var$sectionMessages = {
    [(0, $9woaI.BLOCK_TEMPLATES_SECTION).key]: (0, $64eKJ.messages).categoryBlockTemplates,
    [(0, $9woaI.CREATE_SECTION).key]: (0, $64eKJ.messages).categoryCreate,
    [(0, $9woaI.DATA_AND_CHARTS_SECTION).key]: (0, $64eKJ.messages).categoryDataAndCharts,
    [(0, $9woaI.EMBED_SECTION).key]: (0, $64eKJ.messages).categoryEmbed,
    [(0, $9woaI.MEDIA_SECTION).key]: (0, $64eKJ.messages).categoryMedia,
    [(0, $9woaI.OTHER_SECTION).key]: (0, $64eKJ.messages).categoryOther,
    [(0, $9woaI.ROVO_SECTION).key]: (0, $64eKJ.messages).categoryRovo,
    [(0, $9woaI.STRUCTURE_SECTION).key]: (0, $64eKJ.messages).categoryStructure,
    [(0, $9woaI.TEXT_FORMATTING_SECTION).key]: (0, $64eKJ.messages).categoryTextFormatting
};
const $b451374ca232b9bc$var$categoryGridStyles = null;
const $b451374ca232b9bc$export$bb615d63a03cb0f5 = ({ section: section, sections: sections, onSectionClick: onSectionClick, selectedButtonRef: selectedButtonRef })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const isAllSelected = section === undefined;
    const onCategoryKeyDown = (0, $bSJIT.useCallback)((event)=>{
        var _event$currentTarget$, _event$currentTarget$2;
        if (![
            'ArrowDown',
            'ArrowUp',
            'ArrowLeft',
            'ArrowRight'
        ].includes(event.key)) return;
        const isForward = event.key === 'ArrowDown' || event.key === 'ArrowRight';
        const nextButton = isForward ? event.currentTarget.nextElementSibling ?? ((_event$currentTarget$ = event.currentTarget.parentElement) === null || _event$currentTarget$ === void 0 ? void 0 : _event$currentTarget$.firstElementChild) : event.currentTarget.previousElementSibling ?? ((_event$currentTarget$2 = event.currentTarget.parentElement) === null || _event$currentTarget$2 === void 0 ? void 0 : _event$currentTarget$2.lastElementChild);
        if (nextButton) {
            event.preventDefault();
            nextButton.focus();
            nextButton.click();
        }
    }, []);
    return /*#__PURE__*/ (0, $dc70d.jsxs)("div", {
        "aria-label": formatMessage({
            defaultMessage: 'Element categories',
            id: 'editor.quick-insert.categories-label'
        }),
        "data-testid": "registry-element-browser-categories",
        role: "group",
        className: (0, $9fU1q.default)([
            "_zulpu2gc _1rjc1b66 _18zr1b66 _ae4vv2br _1wpzv2br _1e0c11p5 _yv0ei47z _1ul9idpf _kqsw1if8 _154iidpf _qs0g1bhr _1w2e1ris _1ato1bp4 _lk4jglyw _1cgyi47z _1s8e1wug _pevy15vq _dl261osq _zvu9kb7n"
        ]),
        children: [
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $jNJGJ.default), {
                appearance: 'subtle',
                "aria-pressed": isAllSelected,
                "data-section": "",
                onClick: onSectionClick,
                onKeyDown: onCategoryKeyDown,
                ref: isAllSelected ? selectedButtonRef : undefined,
                isSelected: isAllSelected,
                shouldFitContainer: true,
                tabIndex: isAllSelected ? 0 : -1,
                children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $8aT4G.Text), {
                    align: "start",
                    color: "inherit",
                    maxLines: 1,
                    weight: "medium",
                    children: formatMessage({
                        defaultMessage: 'All',
                        id: 'editor.quick-insert.all'
                    })
                })
            }),
            sections.map((entry)=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $jNJGJ.default), {
                    appearance: 'subtle',
                    "aria-pressed": section === entry.key,
                    "data-section": entry.key,
                    onClick: onSectionClick,
                    onKeyDown: onCategoryKeyDown,
                    ref: section === entry.key ? selectedButtonRef : undefined,
                    isSelected: section === entry.key,
                    shouldFitContainer: true,
                    tabIndex: section === entry.key ? 0 : -1,
                    children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $8aT4G.Text), {
                        align: "start",
                        color: "inherit",
                        maxLines: 1,
                        weight: "medium",
                        children: formatMessage($b451374ca232b9bc$var$sectionMessages[entry.key] ?? (0, $64eKJ.messages).categoryOther)
                    })
                }, entry.key))
        ]
    });
};

});

parcelRegister("b0tbe", function(module, exports) {
$parcel$export(module.exports, "RegistryElementBrowserFooter", () => $4423b74201f1e239$export$ed2431500a2656c1);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $jNJGJ = parcelRequire("jNJGJ");

var $hPVlR = parcelRequire("hPVlR");

var $64eKJ = parcelRequire("64eKJ");

var $fZ0ZI = parcelRequire("fZ0ZI");

var $8aT4G = parcelRequire("8aT4G");
const $4423b74201f1e239$export$ed2431500a2656c1 = ({ helpUrl: helpUrl, isInsertEnabled: isInsertEnabled, onClose: onClose, onConfirmInsert: onConfirmInsert, resultCount: resultCount })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $fZ0ZI.Inline), {
        alignBlock: "center",
        grow: "fill",
        spread: "space-between",
        children: [
            /*#__PURE__*/ (0, $dc70d.jsxs)((0, $fZ0ZI.Inline), {
                alignBlock: "center",
                space: "space.100",
                children: [
                    /*#__PURE__*/ (0, $dc70d.jsx)((0, $8aT4G.Text), {
                        color: "color.text.subtlest",
                        children: formatMessage({
                            defaultMessage: '{count, plural, one {# result available} other {# results available}}',
                            id: 'editor.quick-insert.results-available'
                        }, {
                            count: resultCount
                        })
                    }),
                    helpUrl && /*#__PURE__*/ (0, $dc70d.jsx)((0, $hPVlR.default), {
                        appearance: "subtle",
                        href: helpUrl,
                        target: "_blank",
                        children: formatMessage({
                            defaultMessage: 'Help',
                            id: 'editor.quick-insert.help'
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $dc70d.jsxs)((0, $fZ0ZI.Inline), {
                space: "space.100",
                children: [
                    /*#__PURE__*/ (0, $dc70d.jsx)((0, $jNJGJ.default), {
                        appearance: "primary",
                        isDisabled: !isInsertEnabled,
                        onClick: onConfirmInsert,
                        children: formatMessage({
                            defaultMessage: 'Insert',
                            id: 'editor.quick-insert.insert'
                        })
                    }),
                    /*#__PURE__*/ (0, $dc70d.jsx)((0, $jNJGJ.default), {
                        appearance: "subtle",
                        onClick: onClose,
                        children: formatMessage((0, $64eKJ.messages).close)
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("2Owvc", function(module, exports) {
$parcel$export(module.exports, "RegistryElementBrowserSearchResults", () => $46c606fd73f057e1$export$48c38eae4a3403f4);
/* RegistryElementBrowserSearchResults.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $dkZQn = parcelRequire("dkZQn");

var $5PGJG = parcelRequire("5PGJG");
const $46c606fd73f057e1$var$resultsGridStyles = null;
const $46c606fd73f057e1$var$emptyStateGridItemStyles = null;
const $46c606fd73f057e1$var$styles = {
    fallbackMarketplace: "_1i531l7x _15a5nqa1 _uwhke4h9 _19pkpxbi _ca0qpxbi"
};
const $46c606fd73f057e1$var$RegistryElementBrowserItem = ({ editorView: editorView, isOffline: isOffline, isSelected: isSelected, item: item, onSelect: onSelect })=>{
    const { component: Component, key: key } = item.registration;
    const contextValue = (0, $bSJIT.useMemo)(()=>({
            editorView: editorView,
            isOffline: isOffline,
            item: {
                description: item.description,
                id: key,
                isSelected: isSelected
            },
            select: (handler)=>onSelect(key, handler),
            surface: 'element-browser'
        }), [
        editorView,
        isOffline,
        isSelected,
        item.description,
        key,
        onSelect
    ]);
    if (!Component) return null;
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $5PGJG.QuickInsertProvider), {
        value: contextValue,
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).createElement(Component, undefined, null)
    });
};
const $46c606fd73f057e1$export$48c38eae4a3403f4 = ({ editorView: editorView, emptyStateHandler: emptyStateHandler, fallbackItems: fallbackItems, isLoading: isLoading = false, isOffline: isOffline, items: items, query: query, resultsId: resultsId, section: section, selectedKey: selectedKey, onKeyDown: onKeyDown, onSelect: onSelect })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const hasFallbackItems = Boolean(!isLoading && items.length === 0 && query.trim().length > 0 && (fallbackItems === null || fallbackItems === void 0 ? void 0 : fallbackItems.length));
    const resultsLabel = formatMessage({
        defaultMessage: 'Element results',
        id: 'editor.quick-insert.results-label'
    });
    const displayedItems = hasFallbackItems && fallbackItems ? fallbackItems : items;
    const shouldRenderEmptyState = items.length === 0 && !isLoading;
    const emptyState = shouldRenderEmptyState ? emptyStateHandler === null || emptyStateHandler === void 0 ? void 0 : emptyStateHandler({
        mode: 'full',
        searchTerm: query,
        selectedCategory: section,
        showNoResultsMessage: false
    }) : null;
    return /*#__PURE__*/ (0, $dc70d.jsxs)("div", {
        "data-testid": "registry-element-browser-results",
        id: resultsId,
        tabIndex: -1,
        children: [
            displayedItems.length > 0 && /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                "aria-label": resultsLabel,
                onFocus: (event)=>{
                    if (event.target === event.currentTarget) {
                        var _event$currentTarget$;
                        (_event$currentTarget$ = event.currentTarget.querySelector('[role="option"]:not([aria-disabled="true"]):not([disabled])')) === null || _event$currentTarget$ === void 0 || _event$currentTarget$.focus();
                    }
                },
                onKeyDown: onKeyDown,
                role: "listbox",
                tabIndex: 0,
                className: (0, $9fU1q.default)([
                    "_zulpu2gc _ae4vv2br _4cvrv2br _1e0c11p5 _yv0ei47z _16409sye _g98o1koq"
                ]),
                children: displayedItems.map((item)=>/*#__PURE__*/ (0, $dc70d.jsx)($46c606fd73f057e1$var$RegistryElementBrowserItem, {
                        editorView: editorView,
                        isOffline: isOffline,
                        isSelected: selectedKey === item.registration.key,
                        item: item,
                        onSelect: onSelect
                    }, item.registration.key))
            }),
            shouldRenderEmptyState && !hasFallbackItems && query.trim().length > 0 && /*#__PURE__*/ (0, $dc70d.jsx)((0, $dkZQn.QuickInsertEmptyState), {
                mode: "full"
            }),
            emptyState && /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                className: (0, $9fU1q.default)([
                    "_yyhyjvu9 _1ul9idpf _1bsb1osq",
                    $46c606fd73f057e1$var$styles.fallbackMarketplace
                ]),
                children: emptyState
            })
        ]
    });
};

});



parcelRegister("aFLsV", function(module, exports) {
$parcel$export(module.exports, "withLayoutQuickInsertPrioritySorting", () => $0da6d80fb692b891$export$e8643d2543db7695);
$parcel$export(module.exports, "getQuickInsertSuggestions", () => $0da6d80fb692b891$export$f7a129a7d10810d3);

var $5AAvL = parcelRequire("5AAvL");

var $gstGr = parcelRequire("gstGr");

var $di3Bh = parcelRequire("di3Bh");
const $0da6d80fb692b891$var$isRegisteredLayoutQuickInsertItem = (item)=>{
    var _item$keywords, _item$keywords2;
    return Boolean(item.id && item.id !== 'layout' && ((_item$keywords = item.keywords) === null || _item$keywords === void 0 ? void 0 : _item$keywords.includes('layout')) && ((_item$keywords2 = item.keywords) === null || _item$keywords2 === void 0 ? void 0 : _item$keywords2.includes('column')));
};
const $0da6d80fb692b891$var$getLayoutQuickInsertItemIdRank = (items)=>new Map(items.filter($0da6d80fb692b891$var$isRegisteredLayoutQuickInsertItem).map((item, index)=>[
            item.id,
            index
        ]));
const $0da6d80fb692b891$var$getQuickInsertItemId = (items, result)=>{
    var _items$result$idx;
    return (_items$result$idx = items[result.idx]) === null || _items$result$idx === void 0 ? void 0 : _items$result$idx.id;
};
const $0da6d80fb692b891$export$e8643d2543db7695 = (prioritySortingFn)=>(items)=>{
        const consumerSortFn = prioritySortingFn === null || prioritySortingFn === void 0 ? void 0 : prioritySortingFn(items);
        const layoutItemIdRank = $0da6d80fb692b891$var$getLayoutQuickInsertItemIdRank(items);
        if (layoutItemIdRank.size < 2) return consumerSortFn;
        return (firstItem, secondItem)=>{
            const firstLayoutItemRank = layoutItemIdRank.get($0da6d80fb692b891$var$getQuickInsertItemId(items, firstItem));
            const secondLayoutItemRank = layoutItemIdRank.get($0da6d80fb692b891$var$getQuickInsertItemId(items, secondItem));
            if (firstLayoutItemRank !== undefined && secondLayoutItemRank !== undefined) return firstLayoutItemRank - secondLayoutItemRank;
            if (consumerSortFn) return consumerSortFn(firstItem, secondItem);
            return firstItem.score === secondItem.score ? firstItem.idx < secondItem.idx ? -1 : 1 : firstItem.score < secondItem.score ? -1 : 1;
        };
    };
const $0da6d80fb692b891$export$f7a129a7d10810d3 = (searchOptions, lazyDefaultItems = ()=>[], providedItems)=>{
    const { query: query, category: category, disableDefaultItems: disableDefaultItems, featuredItems: featuredItems, itemFilter: itemFilter, prioritySortingFn: prioritySortingFn } = searchOptions;
    const defaultItems = disableDefaultItems ? [] : lazyDefaultItems();
    const dedupeFn = (item)=>`${item.title}-${item.description ?? ''}`;
    let items = providedItems ? (0, $di3Bh.dedupe)([
        ...defaultItems,
        ...providedItems
    ], dedupeFn) : defaultItems;
    items = items.filter((item)=>{
        var _item$isHidden;
        return ((_item$isHidden = item.isHidden) === null || _item$isHidden === void 0 ? void 0 : _item$isHidden.call(item)) !== true;
    });
    // EDITOR-6558: apply consumer-supplied filter (e.g. Markdown Mode allowlist).
    if (itemFilter) items = items.filter(itemFilter);
    if (featuredItems) return items.filter((item)=>item.featured);
    return (0, $gstGr.find)((query === null || query === void 0 ? void 0 : query.trimEnd()) || '', category === 'all' || !category ? items : items.filter((item)=>(0, $5AAvL.getActiveQuickInsertCategories)(item.category, item.categories).includes(category)), prioritySortingFn);
};

});


parcelRegister("4dpcQ", function(module, exports) {
$parcel$export(module.exports, "selectionPlugin", () => $0ac0bf2e63b95f68$export$35a6a08064a865b4);

var $6gW9F = parcelRequire("6gW9F");

var $43QMS = parcelRequire("43QMS");

var $4njDB = parcelRequire("4njDB");

var $5aVbX = parcelRequire("5aVbX");

var $5MOTW = parcelRequire("5MOTW");

var $kxbB4 = parcelRequire("kxbB4");

var $fdTMG = parcelRequire("fdTMG");

var $h9Weu = parcelRequire("h9Weu");

var $5WfkH = parcelRequire("5WfkH");

var $hB6GW = parcelRequire("hB6GW");
const $0ac0bf2e63b95f68$var$displayGapCursor = (toggle)=>({ tr: tr })=>{
        return tr.setMeta((0, $kxbB4.gapCursorPluginKey), {
            displayGapCursor: toggle
        });
    };
const $0ac0bf2e63b95f68$var$clearManualSelection = ()=>({ tr: tr })=>{
        const currMeta = tr.getMeta((0, $hB6GW.selectionPluginKey));
        return tr.setMeta((0, $hB6GW.selectionPluginKey), {
            ...currMeta,
            manualSelection: {}
        });
    };
const $0ac0bf2e63b95f68$var$setManualSelection = (anchor, head)=>({ tr: tr })=>{
        const currMeta = tr.getMeta((0, $hB6GW.selectionPluginKey));
        return tr.setMeta((0, $hB6GW.selectionPluginKey), {
            ...currMeta,
            manualSelection: {
                anchor: anchor,
                head: head
            }
        });
    };
const $0ac0bf2e63b95f68$var$hideCursor = (hide)=>({ tr: tr })=>{
        const currMeta = tr.getMeta((0, $hB6GW.selectionPluginKey));
        return tr.setMeta((0, $hB6GW.selectionPluginKey), {
            ...currMeta,
            hideCursor: hide
        });
    };
const $0ac0bf2e63b95f68$var$setBlockSelection = (selection)=>({ tr: tr })=>{
        const currMeta = tr.getMeta((0, $hB6GW.selectionPluginKey));
        return tr.setMeta((0, $hB6GW.selectionPluginKey), {
            ...currMeta,
            setBlockSelection: selection
        });
    };
const $0ac0bf2e63b95f68$var$clearBlockSelection = ()=>({ tr: tr })=>{
        const currMeta = tr.getMeta((0, $hB6GW.selectionPluginKey));
        return tr.setMeta((0, $hB6GW.selectionPluginKey), {
            ...currMeta,
            clearBlockSelection: true
        });
    };
const $0ac0bf2e63b95f68$export$35a6a08064a865b4 = ({ api: api, config: options })=>({
        name: 'selection',
        commands: {
            displayGapCursor: $0ac0bf2e63b95f68$var$displayGapCursor,
            clearManualSelection: $0ac0bf2e63b95f68$var$clearManualSelection,
            hideCursor: $0ac0bf2e63b95f68$var$hideCursor,
            setManualSelection: $0ac0bf2e63b95f68$var$setManualSelection,
            setBlockSelection: $0ac0bf2e63b95f68$var$setBlockSelection,
            clearBlockSelection: $0ac0bf2e63b95f68$var$clearBlockSelection
        },
        actions: {
            selectNearNode: ({ selectionRelativeToNode: selectionRelativeToNode, selection: selection })=>(state)=>{
                    return (0, $4njDB.selectNearNode)(selectionRelativeToNode, selection)({
                        tr: state.tr
                    }) || state.tr;
                },
            getSelectionFragment: (0, $6gW9F.getSelectionFragment)(api),
            getSelectionLocalIds: (0, $6gW9F.getSelectionLocalIds)(api)
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            const pluginState = (0, $hB6GW.selectionPluginKey).getState(editorState);
            return {
                selectionRelativeToNode: pluginState === null || pluginState === void 0 ? void 0 : pluginState.selectionRelativeToNode,
                selection: pluginState === null || pluginState === void 0 ? void 0 : pluginState.selection
            };
        },
        pmPlugins () {
            return [
                {
                    name: 'selection',
                    plugin: ({ dispatch: dispatch, dispatchAnalyticsEvent: dispatchAnalyticsEvent })=>(0, $5WfkH.createPlugin)(api, dispatch, dispatchAnalyticsEvent, options)
                },
                {
                    name: 'selectionKeymap',
                    plugin: (0, $fdTMG.default)
                },
                {
                    name: 'gapCursorKeymap',
                    plugin: ()=>(0, $5aVbX.default)()
                },
                {
                    name: 'gapCursor',
                    plugin: ()=>(0, $5MOTW.default)
                },
                {
                    name: 'markBoundaryCursor',
                    plugin: ()=>(0, $h9Weu.createMarkBoundaryCursorPlugin)()
                },
                {
                    name: 'autoExpandSelectionRangeOnInlineNode',
                    plugin: ()=>(0, $43QMS.createAutoExpandSelectionRangeOnInlineNodePlugin)()
                }
            ];
        }
    });
var $0ac0bf2e63b95f68$export$2e2bcd8739ae039 = $0ac0bf2e63b95f68$export$35a6a08064a865b4;

});
parcelRegister("6gW9F", function(module, exports) {
$parcel$export(module.exports, "getSelectionFragment", () => $5b3d7a9900cf0d34$export$ebd99cdb6a61129e);
$parcel$export(module.exports, "getSelectionLocalIds", () => $5b3d7a9900cf0d34$export$27a1b30a70c1f80d);

var $8qh5l = parcelRequire("8qh5l");
var $lH2B7 = parcelRequire("lH2B7");
const $5b3d7a9900cf0d34$export$ebd99cdb6a61129e = (api)=>(props)=>{
        var _api$selection$shared;
        const selection = (props === null || props === void 0 ? void 0 : props.selection) ?? (api === null || api === void 0 || (_api$selection$shared = api.selection.sharedState) === null || _api$selection$shared === void 0 || (_api$selection$shared = _api$selection$shared.currentState()) === null || _api$selection$shared === void 0 ? void 0 : _api$selection$shared.selection);
        return (0, $8qh5l.getFragmentsFromSelection)(selection);
    };
const $5b3d7a9900cf0d34$export$27a1b30a70c1f80d = (api)=>(props)=>{
        var _api$selection$shared2, _selection;
        let selection = (props === null || props === void 0 ? void 0 : props.selection) ?? (api === null || api === void 0 || (_api$selection$shared2 = api.selection.sharedState) === null || _api$selection$shared2 === void 0 || (_api$selection$shared2 = _api$selection$shared2.currentState()) === null || _api$selection$shared2 === void 0 ? void 0 : _api$selection$shared2.selection);
        if ((_selection = selection) !== null && _selection !== void 0 && _selection.empty) // If we have an empty selection the current state might not be correct
        // We have a hack here to retrieve the current selection - but not dispatch a transaction
        api === null || api === void 0 || api.core.actions.execute(({ tr: tr })=>{
            selection = tr.selection;
            return null;
        });
        return (0, $lH2B7.getLocalIdsFromSelection)(selection);
    };

});

parcelRegister("43QMS", function(module, exports) {
$parcel$export(module.exports, "createAutoExpandSelectionRangeOnInlineNodePlugin", () => $089d077a432dfb25$export$b5faf98028194323);

var $f7Kk4 = parcelRequire("f7Kk4");

var $cw0wu = parcelRequire("cw0wu");

var $7OcOf = parcelRequire("7OcOf");
const $089d077a432dfb25$export$b5faf98028194323 = ()=>{
    let mouseDownElement = null;
    return new (0, $f7Kk4.SafePlugin)({
        key: (0, $7OcOf.autoExpandSelectionRangeOnInlineNodePluginKey),
        props: {
            handleDOMEvents: {
                mousedown: (_view, event)=>{
                    // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    mouseDownElement = event.target;
                },
                mouseup: (view, event)=>{
                    // Ignored via go/ees005
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    const mouseUpElement = event.target;
                    // terminate early if mouse down and mouse up elements are the same -> e.g a click event
                    // or mouse down doesn't trigger
                    if (!mouseDownElement || mouseDownElement === mouseUpElement) {
                        mouseDownElement = null;
                        return;
                    }
                    // reset mouse down element after mouse up event
                    // so that we can detect the next mouse down event is triggered right after mouse up event or not
                    mouseDownElement = null;
                    // terminate early if mouse up event is not fired on inline node
                    if (!$089d077a432dfb25$var$isMouseUpOnSupportedNode(mouseUpElement)) return;
                    const { dispatch: dispatch, state: state } = view;
                    const { selection: selection } = state;
                    // terminate early if current selection is not a text selection -> e.g. table cell selection
                    if (!(selection instanceof (0, $cw0wu.TextSelection))) return;
                    // find the document position of the mouse up element
                    const elementStartPosition = view.posAtDOM(mouseUpElement, 0);
                    // find out the direction of selection
                    const isAnchorBeforeElement = selection.$anchor.pos <= elementStartPosition;
                    const expandedSelectionHeadPosition = isAnchorBeforeElement ? elementStartPosition + 1 : elementStartPosition;
                    // expand the selection to include the mouse up element
                    const tr = state.tr.setSelection((0, $cw0wu.TextSelection).create(state.doc, selection.$anchor.pos, expandedSelectionHeadPosition));
                    dispatch(tr);
                }
            }
        }
    });
};
const $089d077a432dfb25$var$isMouseUpOnSupportedNode = (mouseUpElement)=>{
    const supportedNodes = [
        'emoji',
        'status',
        'date',
        'mention',
        'inlineCard'
    ];
    const supportedNodeViewContentClassNamesList = supportedNodes.map((nodeType)=>`.${nodeType}View-content-wrap`).join(', ');
    return !!mouseUpElement.closest(supportedNodeViewContentClassNamesList);
};

});
parcelRegister("7OcOf", function(module, exports) {
$parcel$export(module.exports, "autoExpandSelectionRangeOnInlineNodePluginKey", () => $fede92378ba12a71$export$e6805678cce429a4);

var $cw0wu = parcelRequire("cw0wu");
const $fede92378ba12a71$export$e6805678cce429a4 = new (0, $cw0wu.PluginKey)('autoExpandSelectionRangeOnInlineNodePlugin');

});


parcelRegister("4njDB", function(module, exports) {
$parcel$export(module.exports, "selectNearNode", () => $30d4b775b25182d5$export$c7d22caae2fd3756);
$parcel$export(module.exports, "arrowRight", () => $30d4b775b25182d5$export$680a8d7c28b0860);
$parcel$export(module.exports, "arrowLeft", () => $30d4b775b25182d5$export$3ff8c533d254ed7c);
/* eslint-disable import/no-extraneous-dependencies */ 
var $8t2a4 = parcelRequire("8t2a4");

var $j7pt0 = parcelRequire("j7pt0");

var $ispGV = parcelRequire("ispGV");

var $fUfre = parcelRequire("fUfre");
parcelRequire("56AB9");
var $24xJB = parcelRequire("24xJB");
var $56AB9 = parcelRequire("56AB9");

var $cw0wu = parcelRequire("cw0wu");

var $hB6GW = parcelRequire("hB6GW");

var $1wejO = parcelRequire("1wejO");

var $9leZe = parcelRequire("9leZe");

var $f6zxh = parcelRequire("f6zxh");
const $30d4b775b25182d5$export$c7d22caae2fd3756 = (selectionRelativeToNode, selection)=>({ tr: tr })=>{
        tr.setMeta((0, $hB6GW.selectionPluginKey), {
            type: (0, $1wejO.SelectionActionTypes).SET_RELATIVE_SELECTION,
            selectionRelativeToNode: selectionRelativeToNode
        });
        if (selection) return tr.setSelection(selection);
        return tr;
    };
const $30d4b775b25182d5$export$56a7f03ce3f93e52 = (selectionRelativeToNode, selection)=>(0, $9leZe.createCommand)({
        type: (0, $1wejO.SelectionActionTypes).SET_RELATIVE_SELECTION,
        selectionRelativeToNode: selectionRelativeToNode
    }, (tr)=>{
        return $30d4b775b25182d5$export$c7d22caae2fd3756(selectionRelativeToNode, selection)({
            tr: tr
        }) || tr;
    });
const $30d4b775b25182d5$export$680a8d7c28b0860 = (state, dispatch)=>{
    const { selection: selection } = state;
    if (selection instanceof (0, $j7pt0.GapCursorSelection)) return $30d4b775b25182d5$var$arrowRightFromGapCursor(selection)(state, dispatch);
    else if (selection instanceof (0, $cw0wu.NodeSelection)) return $30d4b775b25182d5$var$arrowRightFromNode(selection)(state, dispatch);
    else if (selection instanceof (0, $cw0wu.TextSelection)) return $30d4b775b25182d5$var$arrowRightFromText(selection)(state, dispatch);
    return false;
};
const $30d4b775b25182d5$export$3ff8c533d254ed7c = (state, dispatch)=>{
    const { selection: selection } = state;
    if (selection instanceof (0, $j7pt0.GapCursorSelection)) return $30d4b775b25182d5$var$arrowLeftFromGapCursor(selection)(state, dispatch);
    else if (selection instanceof (0, $cw0wu.NodeSelection)) return $30d4b775b25182d5$var$arrowLeftFromNode(selection)(state, dispatch);
    else if (selection instanceof (0, $cw0wu.TextSelection)) return $30d4b775b25182d5$var$arrowLeftFromText(selection)(state, dispatch);
    return false;
};
const $30d4b775b25182d5$var$arrowRightFromGapCursor = (selection)=>(state, dispatch)=>{
        const { $from: $from, $to: $to, side: side } = selection;
        if (side === (0, $8t2a4.Side).LEFT) {
            const selectableNode = (0, $f6zxh.findSelectableContainerAfter)($to, state.doc);
            if (selectableNode) return $30d4b775b25182d5$export$56a7f03ce3f93e52((0, $fUfre.RelativeSelectionPos).Start, (0, $cw0wu.NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
        } else if (side === (0, $8t2a4.Side).RIGHT && (0, $f6zxh.isSelectionAtEndOfParentNode)($from, selection)) {
            const selectableNode = (0, $f6zxh.findSelectableContainerParent)(selection);
            if (selectableNode) return $30d4b775b25182d5$export$56a7f03ce3f93e52((0, $fUfre.RelativeSelectionPos).End, (0, $cw0wu.NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
        }
        return false;
    };
const $30d4b775b25182d5$var$arrowLeftFromGapCursor = (selection)=>(state, dispatch)=>{
        const { $from: $from, side: side } = selection;
        const { selectionRelativeToNode: selectionRelativeToNode } = (0, $9leZe.getPluginState)(state);
        if (side === (0, $8t2a4.Side).RIGHT) {
            const selectableNode = (0, $f6zxh.findSelectableContainerBefore)($from, state.doc);
            if (selectableNode) return $30d4b775b25182d5$export$56a7f03ce3f93e52((0, $fUfre.RelativeSelectionPos).End, (0, $cw0wu.NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
        } else if (side === (0, $8t2a4.Side).LEFT && (0, $f6zxh.isSelectionAtStartOfParentNode)($from, selection)) {
            if (selectionRelativeToNode === (0, $fUfre.RelativeSelectionPos).Before) {
                const $parent = state.doc.resolve(selection.$from.before(selection.$from.depth));
                if ($parent) {
                    const selectableNode = (0, $f6zxh.findSelectableContainerBefore)($parent, state.doc);
                    if (selectableNode && (0, $ispGV.isIgnored)(selectableNode.node)) // selection is inside node without gap cursor preceeded by another node without gap cursor - set node selection for previous node
                    return $30d4b775b25182d5$export$56a7f03ce3f93e52((0, $fUfre.RelativeSelectionPos).End, (0, $cw0wu.NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
                }
                // we don't return this as we want to reset the relative pos, but not block other plugins
                // from responding to arrow left key
                $30d4b775b25182d5$export$56a7f03ce3f93e52()(state, dispatch);
            } else {
                const selectableNode = (0, $f6zxh.findSelectableContainerParent)(selection);
                if (selectableNode) return $30d4b775b25182d5$export$56a7f03ce3f93e52((0, $fUfre.RelativeSelectionPos).Start, (0, $cw0wu.NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
            }
        }
        return false;
    };
const $30d4b775b25182d5$var$arrowRightFromNode = (selection)=>(state, dispatch)=>{
        const { node: node, from: from, $to: $to } = selection;
        const { selectionRelativeToNode: selectionRelativeToNode } = (0, $9leZe.getPluginState)(state);
        if (node.isAtom) {
            if ((0, $f6zxh.isSelectionAtEndOfParentNode)($to, selection) && (node.isInline || (0, $ispGV.isIgnored)(node))) // selection is for inline node or atom node which is ignored by gap-cursor and that is the last child of its parent node - set text selection after it
            return $30d4b775b25182d5$var$findAndSetTextSelection((0, $fUfre.RelativeSelectionPos).End, state.doc.resolve(from + 1), (0, $hB6GW.SelectionDirection).After)(state, dispatch);
            return false;
        } else if (selectionRelativeToNode === (0, $fUfre.RelativeSelectionPos).Start) // selection is for container node - set selection inside it at the start
        return $30d4b775b25182d5$var$setSelectionInsideAtNodeStart((0, $fUfre.RelativeSelectionPos).Inside, node, from)(state, dispatch);
        else if ((0, $ispGV.isIgnored)(node) && (!selectionRelativeToNode || selectionRelativeToNode === (0, $fUfre.RelativeSelectionPos).End)) {
            const selectableNode = (0, $f6zxh.findSelectableContainerAfter)($to, state.doc);
            if (selectableNode && (0, $ispGV.isIgnored)(selectableNode.node)) // selection is for node without gap cursor followed by another node without gap cursor - set node selection for next node
            return $30d4b775b25182d5$export$56a7f03ce3f93e52((0, $fUfre.RelativeSelectionPos).Start, (0, $cw0wu.NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
        }
        return false;
    };
const $30d4b775b25182d5$var$arrowLeftFromNode = (selection)=>(state, dispatch)=>{
        const { node: node, from: from, to: to, $from: $from } = selection;
        const { selectionRelativeToNode: selectionRelativeToNode } = (0, $9leZe.getPluginState)(state);
        if (node.isAtom) {
            if ((0, $f6zxh.isSelectionAtStartOfParentNode)($from, selection) && (node.isInline || (0, $ispGV.isIgnored)(node))) // selection is for inline node or atom node which is ignored by gap-cursor and that is the first child of its parent node - set text selection before it
            return $30d4b775b25182d5$var$findAndSetTextSelection((0, $fUfre.RelativeSelectionPos).Start, state.doc.resolve(from), (0, $hB6GW.SelectionDirection).Before)(state, dispatch);
            return false;
        } else if (selectionRelativeToNode === (0, $fUfre.RelativeSelectionPos).End) // selection is for container node - set selection inside it at the end
        return $30d4b775b25182d5$export$7c9ae5d21795cde4((0, $fUfre.RelativeSelectionPos).Inside, node, from, to)(state, dispatch);
        else if (!selectionRelativeToNode || selectionRelativeToNode === (0, $fUfre.RelativeSelectionPos).Inside) // selection is for container node - set selection inside it at the start
        // (this is a special case when the user selects by clicking node)
        return $30d4b775b25182d5$var$setSelectionInsideAtNodeStart((0, $fUfre.RelativeSelectionPos).Before, node, from)(state, dispatch);
        else if ((0, $ispGV.isIgnored)(node) && selectionRelativeToNode === (0, $fUfre.RelativeSelectionPos).Start) {
            // selection is for node without gap cursor preceeded by another node without gap cursor - set node selection for previous node
            const selectableNode = (0, $f6zxh.findSelectableContainerBefore)($from, state.doc);
            if (selectableNode && (0, $ispGV.isIgnored)(selectableNode.node)) return $30d4b775b25182d5$export$56a7f03ce3f93e52((0, $fUfre.RelativeSelectionPos).End, (0, $cw0wu.NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
        }
        return false;
    };
const $30d4b775b25182d5$var$arrowRightFromText = (selection)=>(state, dispatch)=>{
        if ((0, $f6zxh.isSelectionAtEndOfParentNode)(selection.$to, selection)) {
            const selectableNode = (0, $f6zxh.findSelectableContainerParent)(selection);
            if (selectableNode) return $30d4b775b25182d5$export$56a7f03ce3f93e52((0, $fUfre.RelativeSelectionPos).End, (0, $cw0wu.NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
        }
        return false;
    };
const $30d4b775b25182d5$var$arrowLeftFromText = (selection)=>(state, dispatch)=>{
        const { selectionRelativeToNode: selectionRelativeToNode } = (0, $9leZe.getPluginState)(state);
        if (selectionRelativeToNode === (0, $fUfre.RelativeSelectionPos).Before) {
            const selectableNode = (0, $f6zxh.findSelectableContainerBefore)(selection.$from, state.doc);
            if (selectableNode && (0, $ispGV.isIgnored)(selectableNode.node)) // selection is inside node without gap cursor preceeded by another node without gap cursor - set node selection for previous node
            return $30d4b775b25182d5$export$56a7f03ce3f93e52((0, $fUfre.RelativeSelectionPos).End, (0, $cw0wu.NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
            // we don't return this as we want to reset the relative pos, but not block other plugins
            // from responding to arrow left key
            $30d4b775b25182d5$export$56a7f03ce3f93e52(undefined)(state, dispatch);
        } else if ((0, $f6zxh.isSelectionAtStartOfParentNode)(selection.$from, selection)) {
            const selectableNode = (0, $f6zxh.findSelectableContainerParent)(selection);
            if (selectableNode) return $30d4b775b25182d5$export$56a7f03ce3f93e52((0, $fUfre.RelativeSelectionPos).Start, (0, $cw0wu.NodeSelection).create(state.doc, selectableNode.pos))(state, dispatch);
        }
        return false;
    };
const $30d4b775b25182d5$var$findAndSetTextSelection = (selectionRelativeToNode, $pos, dir)=>(state, dispatch)=>{
        const sel = (0, $cw0wu.Selection).findFrom($pos, dir, true);
        if (sel) return $30d4b775b25182d5$export$56a7f03ce3f93e52(selectionRelativeToNode, sel)(state, dispatch);
        return false;
    };
const $30d4b775b25182d5$var$setSelectionInsideAtNodeStart = (selectionRelativeToNode, node, pos)=>(state, dispatch)=>{
        if ((0, $56AB9.isNodeEmpty)(node)) return $30d4b775b25182d5$var$findAndSetTextSelection(selectionRelativeToNode, state.doc.resolve(pos), (0, $hB6GW.SelectionDirection).After)(state, dispatch);
        const selectableNode = (0, $f6zxh.findFirstChildNodeToSelect)(node);
        if (selectableNode) {
            const { node: childNode, pos: childPos } = selectableNode;
            const selectionPos = pos + childPos + 1;
            if (childNode.isText || childNode.isAtom && (0, $ispGV.isIgnored)(childNode) || childNode.isInline) //selection is for text node, inline node or atom node which is ignored by gap-cursor. set selection before it.
            return $30d4b775b25182d5$var$findAndSetTextSelection(selectionRelativeToNode, state.doc.resolve(selectionPos), (0, $hB6GW.SelectionDirection).Before)(state, dispatch);
            else if ((0, $24xJB.isEmptyParagraph)(childNode)) return $30d4b775b25182d5$var$findAndSetTextSelection(selectionRelativeToNode, state.doc.resolve(selectionPos + 1), (0, $hB6GW.SelectionDirection).Before)(state, dispatch);
            else if (!(0, $ispGV.isIgnored)(node)) return $30d4b775b25182d5$export$56a7f03ce3f93e52(selectionRelativeToNode, new (0, $j7pt0.GapCursorSelection)(state.doc.resolve(selectionPos), (0, $8t2a4.Side).LEFT))(state, dispatch);
            else if ((0, $f6zxh.isSelectableContainerNode)(node)) return $30d4b775b25182d5$export$56a7f03ce3f93e52(selectionRelativeToNode, (0, $cw0wu.NodeSelection).create(state.doc, selectionPos))(state, dispatch);
        }
        return false;
    };
const $30d4b775b25182d5$export$7c9ae5d21795cde4 = (selectionRelativeToNode, node, from, to)=>(state, dispatch)=>{
        if ((0, $56AB9.isNodeEmpty)(node)) return $30d4b775b25182d5$var$findAndSetTextSelection(selectionRelativeToNode, state.doc.resolve(to), (0, $hB6GW.SelectionDirection).Before)(state, dispatch);
        const selectableNode = (0, $f6zxh.findLastChildNodeToSelect)(node);
        if (selectableNode) {
            const { node: childNode, pos: childPos } = selectableNode;
            const selectionPos = from + childPos + childNode.nodeSize;
            if (childNode.isText || childNode.isAtom && (0, $ispGV.isIgnored)(childNode) || childNode.isInline) //selection is for text node, inline node or atom node which is ignored by gap-cursor. set selection after it.
            return $30d4b775b25182d5$var$findAndSetTextSelection(selectionRelativeToNode, state.doc.resolve(selectionPos + 1), (0, $hB6GW.SelectionDirection).After)(state, dispatch);
            else if ((0, $24xJB.isEmptyParagraph)(childNode)) return $30d4b775b25182d5$var$findAndSetTextSelection(selectionRelativeToNode, state.doc.resolve(selectionPos), (0, $hB6GW.SelectionDirection).After)(state, dispatch);
            else if (!(0, $ispGV.isIgnored)(node)) return $30d4b775b25182d5$export$56a7f03ce3f93e52(selectionRelativeToNode, new (0, $j7pt0.GapCursorSelection)(state.doc.resolve(selectionPos + 1), (0, $8t2a4.Side).RIGHT))(state, dispatch);
            else if ((0, $f6zxh.isSelectableContainerNode)(node)) return $30d4b775b25182d5$export$56a7f03ce3f93e52(selectionRelativeToNode, (0, $cw0wu.NodeSelection).create(state.doc, selectionPos))(state, dispatch);
        }
        return false;
    };

});
parcelRegister("hB6GW", function(module, exports) {
$parcel$export(module.exports, "selectionPluginKey", () => $7862c68f4799732d$export$e530ba00b008a680);
$parcel$export(module.exports, "SelectionDirection", () => $7862c68f4799732d$export$5c80dd1df5708938);
/* eslint-disable @atlaskit/editor/no-re-export */ // Entry file in package.json


var $cw0wu = parcelRequire("cw0wu");
const $7862c68f4799732d$export$e530ba00b008a680 = new (0, $cw0wu.PluginKey)('selection');
var $7862c68f4799732d$export$5c80dd1df5708938 = /*#__PURE__*/ function(SelectionDirection) {
    SelectionDirection[SelectionDirection["Before"] = -1] = "Before";
    SelectionDirection[SelectionDirection["After"] = 1] = "After";
    return SelectionDirection;
}({});

});

parcelRegister("1wejO", function(module, exports) {
$parcel$export(module.exports, "SelectionActionTypes", () => $0743a9d4b2fa8f71$export$ab4e2275d2998c63);
var $0743a9d4b2fa8f71$export$ab4e2275d2998c63 = /*#__PURE__*/ function(SelectionActionTypes) {
    SelectionActionTypes["SET_DECORATIONS"] = "SET_DECORATIONS";
    SelectionActionTypes["SET_RELATIVE_SELECTION"] = "SET_RELATIVE_SELECTION";
    return SelectionActionTypes;
}({});

});

parcelRegister("9leZe", function(module, exports) {
$parcel$export(module.exports, "createCommand", () => $ba297002aef1e6d5$export$8d4021544bdece00);
$parcel$export(module.exports, "getPluginState", () => $ba297002aef1e6d5$export$f05434c51e3762e);
$parcel$export(module.exports, "createPluginState", () => $ba297002aef1e6d5$export$656c7661095efe2e);

var $3TnFr = parcelRequire("3TnFr");

var $cw0wu = parcelRequire("cw0wu");

var $a3b9P = parcelRequire("a3b9P");

var $2E7OD = parcelRequire("2E7OD");

var $hB6GW = parcelRequire("hB6GW");

var $gu4Uv = parcelRequire("gu4Uv");

var $f6zxh = parcelRequire("f6zxh");
const $ba297002aef1e6d5$var$handleDocChanged = (tr, pluginState)=>{
    // in some collab edge cases mapping decorations could throw an error
    try {
        if (pluginState.decorationSet.find().length === 0 && (!tr.selectionSet || (0, $f6zxh.getDecorations)(tr).find().length === 0)) return pluginState;
        const decorationSet = pluginState.decorationSet.map(tr.mapping, tr.doc);
        return {
            ...pluginState,
            decorationSet: decorationSet
        };
    } catch (error) {
        return {
            ...pluginState,
            decorationSet: (0, $a3b9P.DecorationSet).empty
        };
    }
};
const $ba297002aef1e6d5$var$handleSelectionChanged = (tr, pluginState)=>{
    // Reset relative selection pos when user clicks to select a node
    if ((tr.selection instanceof (0, $cw0wu.NodeSelection) && (0, $f6zxh.isSelectableContainerNode)(tr.selection.node) || tr.selection instanceof (0, $2E7OD.CellSelection)) && !tr.getMeta((0, $hB6GW.selectionPluginKey))) return {
        ...pluginState,
        selectionRelativeToNode: undefined
    };
    return pluginState;
};
const $ba297002aef1e6d5$var$dest = (0, $3TnFr.pluginFactory)((0, $hB6GW.selectionPluginKey), (0, $gu4Uv.reducer), {
    onDocChanged: $ba297002aef1e6d5$var$handleDocChanged,
    onSelectionChanged: $ba297002aef1e6d5$var$handleSelectionChanged
});
const $ba297002aef1e6d5$export$8d4021544bdece00 = $ba297002aef1e6d5$var$dest.createCommand;
const $ba297002aef1e6d5$export$f05434c51e3762e = $ba297002aef1e6d5$var$dest.getPluginState;
const $ba297002aef1e6d5$export$656c7661095efe2e = $ba297002aef1e6d5$var$dest.createPluginState;

});
parcelRegister("gu4Uv", function(module, exports) {
$parcel$export(module.exports, "reducer", () => $8c997bb747365d49$export$1650419e431d3ba3);

var $1wejO = parcelRequire("1wejO");
function $8c997bb747365d49$export$1650419e431d3ba3(pluginState, action) {
    switch(action.type){
        case (0, $1wejO.SelectionActionTypes).SET_DECORATIONS:
            return {
                ...pluginState,
                decorationSet: action.decorationSet,
                selection: action.selection
            };
        case (0, $1wejO.SelectionActionTypes).SET_RELATIVE_SELECTION:
            return {
                ...pluginState,
                selectionRelativeToNode: action.selectionRelativeToNode
            };
        default:
            return pluginState;
    }
}

});

parcelRegister("f6zxh", function(module, exports) {
$parcel$export(module.exports, "getDecorations", () => $797117ca6b1d49fe$export$968abecb43309c32);
$parcel$export(module.exports, "shouldRecalcDecorations", () => $797117ca6b1d49fe$export$8f1ae47b39045ce2);
$parcel$export(module.exports, "isSelectableContainerNode", () => $797117ca6b1d49fe$export$be9646888fa9d884);
$parcel$export(module.exports, "findSelectableContainerParent", () => $797117ca6b1d49fe$export$15e7624ccd1acbba);
$parcel$export(module.exports, "findSelectableContainerBefore", () => $797117ca6b1d49fe$export$5a13616ef7dc6dd);
$parcel$export(module.exports, "findSelectableContainerAfter", () => $797117ca6b1d49fe$export$f64170c1c72ca928);
$parcel$export(module.exports, "findFirstChildNodeToSelect", () => $797117ca6b1d49fe$export$12f3aca2cb5b5ae9);
$parcel$export(module.exports, "findLastChildNodeToSelect", () => $797117ca6b1d49fe$export$b5a7c30cdb2d437f);
$parcel$export(module.exports, "isSelectionAtStartOfParentNode", () => $797117ca6b1d49fe$export$f80a5aec143de6c6);
$parcel$export(module.exports, "isSelectionAtEndOfParentNode", () => $797117ca6b1d49fe$export$1ab0c837d3abb951);

var $1akDd = parcelRequire("1akDd");

var $ispGV = parcelRequire("ispGV");
parcelRequire("56AB9");
var $24xJB = parcelRequire("24xJB");
var $7nLBT = parcelRequire("7nLBT");

var $01Z6w = parcelRequire("01Z6w");

var $cw0wu = parcelRequire("cw0wu");

var $gab48 = parcelRequire("gab48");

var $a3b9P = parcelRequire("a3b9P");

var $5bbjm = parcelRequire("5bbjm");

var $5N1Y4 = parcelRequire("5N1Y4");

var $hB6GW = parcelRequire("hB6GW");

var $3tc9n = parcelRequire("3tc9n");
const $797117ca6b1d49fe$export$968abecb43309c32 = (tr, manualSelection, hideCursor, blockSelection)=>{
    let selection = tr.selection;
    const decorations = [];
    if (hideCursor) decorations.push((0, $3tc9n.createHideCursorDecoration)());
    if (selection instanceof (0, $cw0wu.NodeSelection)) {
        decorations.push((0, $a3b9P.Decoration).node(selection.from, selection.to, {
            class: (0, $5bbjm.akEditorSelectedNodeClassName)
        }));
        return (0, $a3b9P.DecorationSet).create(tr.doc, decorations);
    }
    if (selection instanceof (0, $cw0wu.TextSelection) || selection instanceof (0, $cw0wu.AllSelection)) {
        if (manualSelection && manualSelection.anchor >= 0 && manualSelection.head >= 0 && manualSelection.anchor <= tr.doc.nodeSize && manualSelection.head <= tr.doc.nodeSize) selection = (0, $cw0wu.TextSelection).create(tr.doc, manualSelection.anchor, manualSelection.head);
        // Only apply node decorations when there is an active block selection.
        // When there is no block selection, text selections should use native browser selection appearance.
        if (blockSelection) {
            const selectionDecorations = $797117ca6b1d49fe$export$299033b282ee8671(selection, tr.doc).map(({ node: node, pos: pos })=>{
                return (0, $a3b9P.Decoration).node(pos, pos + node.nodeSize, {
                    class: (0, $5bbjm.akEditorSelectedNodeClassName)
                });
            });
            decorations.push(...selectionDecorations);
        }
        return (0, $a3b9P.DecorationSet).create(tr.doc, decorations);
    }
    return decorations.length > 0 ? (0, $a3b9P.DecorationSet).create(tr.doc, decorations) : (0, $a3b9P.DecorationSet).empty;
};
const $797117ca6b1d49fe$var$topLevelBlockNodesThatHaveSelectionStyles = [
    'table',
    'panel',
    'expand',
    'layoutSection',
    'decisionList',
    'decisionItem',
    'codeBlock'
];
const $797117ca6b1d49fe$export$299033b282ee8671 = (selection, doc)=>{
    const nodes = [];
    if (selection.from !== selection.to) {
        const { from: from, to: to } = selection;
        doc.nodesBetween(from, to, (node, pos)=>{
            const withinSelection = from <= pos && pos + node.nodeSize <= to;
            // The reason we need to check for these nodes is to stop
            // traversing their children if they are within a selection -
            // this is to prevent selection styles from being added to
            // the children as well as the parent node.
            // Example scenario is if an entire table has been selected
            // we should not traverse its children so we can apply the
            // selection styles to the table. But if an entire tableRow
            // has been selected (but the parent table has not) we should
            // traverse it as it could contain other nodes that need
            // selection styles. I couldn’t see a clear way to differentiate
            // without explicitly stating which nodes should be traversed
            // and which shouldn’t.
            const nodeTypeName = (0, $5N1Y4.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? (0, $01Z6w.getBaseNodeTypeName)(node.type) : node.type.name;
            const isTopLevelNodeThatHasSelectionStyles = $797117ca6b1d49fe$var$topLevelBlockNodesThatHaveSelectionStyles.includes(nodeTypeName);
            // If the node is a top-level block node and completely sits within
            // the selection, we do not recurse it's children to prevent selection
            // styles being added to its child nodes. The expected behaviour
            // is that selection styles are only added to the parent.
            if (node && withinSelection && isTopLevelNodeThatHasSelectionStyles) {
                nodes.push({
                    node: node,
                    pos: pos
                });
                return false;
            // Otherwise we recurse the children and return them so we can apply
            // selection styles. Text is handled by the browser.
            } else if (node && withinSelection && !node.isText) nodes.push({
                node: node,
                pos: pos
            });
            return true;
        });
    }
    return nodes;
};
function $797117ca6b1d49fe$export$8f1ae47b39045ce2({ oldEditorState: oldEditorState, newEditorState: newEditorState }) {
    const oldSelection = oldEditorState.selection;
    const newSelection = newEditorState.selection;
    const oldPluginState = (0, $hB6GW.selectionPluginKey).getState(oldEditorState);
    const newPluginState = (0, $hB6GW.selectionPluginKey).getState(newEditorState);
    if (!oldPluginState || !newPluginState) return false;
    // If selection is unchanged, no need to recalculate
    if (oldSelection.eq(newSelection)) {
        // We need this special case for NodeSelection, as Prosemirror still thinks the
        // selections are equal when the node has changed
        if (oldSelection instanceof (0, $cw0wu.NodeSelection) && newSelection instanceof (0, $cw0wu.NodeSelection)) {
            const oldDecorations = oldPluginState.decorationSet.find();
            const newDecorations = newPluginState.decorationSet.find();
            // There might not be old or new decorations if the node selection is for a text node
            // This wouldn't have happened intentionally, but we need to handle this case regardless
            if (oldDecorations.length > 0 && newDecorations.length > 0) return !oldDecorations[0].eq(newDecorations[0]);
            return !(oldDecorations.length === 0 && newDecorations.length === 0);
        }
        return false;
    }
    // There's no point updating decorations if going from one standard TextSelection to another
    if (oldSelection instanceof (0, $cw0wu.TextSelection) && newSelection instanceof (0, $cw0wu.TextSelection) && oldSelection.from === oldSelection.to && newSelection.from === newSelection.to) return false;
    return true;
}
const $797117ca6b1d49fe$export$be9646888fa9d884 = (node)=>!!(node && !node.isAtom && (0, $cw0wu.NodeSelection).isSelectable(node));
const $797117ca6b1d49fe$export$e6eb31f83412b327 = (node)=>!!(node && (node.isText || (0, $24xJB.isEmptyParagraph)(node) || (0, $cw0wu.NodeSelection).isSelectable(node)));
const $797117ca6b1d49fe$export$15e7624ccd1acbba = (selection)=>{
    let foundNodeThatSupportsGapCursor = false;
    const selectableNode = (0, $gab48.findParentNode)((node)=>{
        const isSelectable = $797117ca6b1d49fe$export$be9646888fa9d884(node);
        if (!isSelectable && !(0, $ispGV.isIgnored)(node)) foundNodeThatSupportsGapCursor = true;
        return isSelectable;
    })(selection);
    if (!foundNodeThatSupportsGapCursor) return selectableNode;
};
const $797117ca6b1d49fe$export$5a13616ef7dc6dd = ($pos, doc)=>{
    // prosemirror just returns the same pos from Selection.findFrom when
    // parent.inlineContent is true, so we move position back one here
    // to counteract that
    if ($pos.parent.inlineContent && $797117ca6b1d49fe$export$be9646888fa9d884($pos.parent)) $pos = doc.resolve($pos.start() - 1);
    const selectionBefore = (0, $cw0wu.Selection).findFrom($pos, -1);
    if (selectionBefore) {
        const $selectionBefore = doc.resolve(selectionBefore.from);
        for(let i = $pos.depth + 1; i <= $selectionBefore.depth; i++){
            const node = $selectionBefore.node(i);
            if ($797117ca6b1d49fe$export$be9646888fa9d884(node)) return {
                node: node,
                pos: $selectionBefore.start(i) - 1
            };
            if (i > $pos.depth + 1 && !(0, $ispGV.isIgnored)(node)) return;
        }
        /**
     * Stick to the default left selection behaviour,
     * useful for mediaSingleWithCaption
     */ if (selectionBefore instanceof (0, $cw0wu.NodeSelection) && (0, $cw0wu.NodeSelection).isSelectable(selectionBefore.node)) return {
            node: selectionBefore.node,
            pos: selectionBefore.from
        };
    }
};
const $797117ca6b1d49fe$export$f64170c1c72ca928 = ($pos, doc)=>{
    const selectionAfter = (0, $cw0wu.Selection).findFrom($pos, 1);
    if (selectionAfter) {
        const $selectionAfter = doc.resolve(selectionAfter.from);
        for(let i = $pos.depth + 1; i <= $selectionAfter.depth; i++){
            const node = $selectionAfter.node(i);
            if ($797117ca6b1d49fe$export$be9646888fa9d884(node)) return {
                node: node,
                pos: $selectionAfter.start(i) - 1
            };
            if (i > $pos.depth + 1 && !(0, $ispGV.isIgnored)(node)) return;
        }
    }
};
const $797117ca6b1d49fe$export$12f3aca2cb5b5ae9 = (parent)=>(0, $gab48.flatten)(parent).find((child)=>$797117ca6b1d49fe$export$e6eb31f83412b327(child.node) || !(0, $ispGV.isIgnored)(child.node));
const $797117ca6b1d49fe$export$b5a7c30cdb2d437f = (parent)=>{
    let child;
    parent.descendants((node, pos)=>{
        if ($797117ca6b1d49fe$export$e6eb31f83412b327(node) || !(0, $ispGV.isIgnored)(node)) {
            child = {
                node: node,
                pos: pos
            };
            return false;
        }
    });
    if (child) return child;
};
const $797117ca6b1d49fe$export$f80a5aec143de6c6 = ($pos, selection)=>{
    var _findSelectableContai;
    return (0, $1akDd.isSelectionAtStartOfNode)($pos, (_findSelectableContai = $797117ca6b1d49fe$export$15e7624ccd1acbba(selection)) === null || _findSelectableContai === void 0 ? void 0 : _findSelectableContai.node);
};
const $797117ca6b1d49fe$export$1ab0c837d3abb951 = ($pos, selection)=>{
    // If the current position is at the end of its parent node's content.
    const isAtTheEndOfCurrentLevel = $pos.parent.content.size === $pos.parentOffset;
    if (!isAtTheEndOfCurrentLevel) return false;
    // If at the root or parent is selectable, we're at the end
    if ($pos.depth === 0 || (0, $cw0wu.NodeSelection).isSelectable($pos.parent)) return isAtTheEndOfCurrentLevel;
    // Handle lists: if in a list inside container and not at the end, return false
    if ((0, $gab48.hasParentNode)((0, $7nLBT.isListItemNode))(selection) && $797117ca6b1d49fe$export$7eb6f464328bf47e($pos, selection)) return false;
    // Handle layout columns: if another node follows, not at end
    if ($797117ca6b1d49fe$export$d2d208886cf1a82d($pos)) return false;
    // Default: if at end of parent's parent
    const $after = $pos.doc.resolve($pos.after());
    return $after.parent.content.size === $after.parentOffset;
};
const $797117ca6b1d49fe$export$7eb6f464328bf47e = ($pos, selection)=>{
    const isInContainerNode = (0, $gab48.hasParentNode)($797117ca6b1d49fe$export$5f94d2e4ba42a5c7)(selection);
    if (!isInContainerNode) return false;
    const parentList = (0, $gab48.findParentNodeClosestToPos)($pos, (0, $7nLBT.isListItemNode));
    if (!parentList) return false;
    const $parentListPos = $pos.doc.resolve(parentList.pos);
    const topLevelList = $797117ca6b1d49fe$export$b0ac99e4524eec5a($pos);
    if (!topLevelList) return false;
    const $afterTopLevelList = $pos.doc.resolve(topLevelList.pos + topLevelList.node.nodeSize);
    const nodeAfterTopLevelList = $afterTopLevelList.nodeAfter;
    const grandParentList = (0, $gab48.findParentNodeClosestToPos)($pos.doc.resolve($parentListPos.before()), (0, $7nLBT.isListItemNode));
    const grandParentListPos = grandParentList ? $pos.doc.resolve(grandParentList.pos) : undefined;
    const isLastListItemInParent = // Check if the current list item is the last child in its parent list
    $parentListPos.index() === $parentListPos.parent.childCount - 1 && // Check if there is no grandparent list, or if the grandparent list item is also the last child in its parent
    (!grandParentList || grandParentListPos && grandParentListPos.index() === grandParentListPos.parent.childCount - 1);
    if (!isLastListItemInParent || nodeAfterTopLevelList) return true;
    return false;
};
const $797117ca6b1d49fe$export$5f94d2e4ba42a5c7 = (node)=>{
    var _node$type;
    const { layoutColumn: layoutColumn, panel: panel, panel_c1: panel_c1, expand: expand } = (node === null || node === void 0 || (_node$type = node.type) === null || _node$type === void 0 || (_node$type = _node$type.schema) === null || _node$type === void 0 ? void 0 : _node$type.nodes) || {};
    const containerNodes = (0, $5N1Y4.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? [
        panel,
        panel_c1,
        expand,
        layoutColumn
    ] : [
        panel,
        expand,
        layoutColumn
    ];
    return Boolean(node && node.type && containerNodes.includes(node.type));
};
const $797117ca6b1d49fe$export$b0ac99e4524eec5a = (pos)=>{
    const { bulletList: bulletList, orderedList: orderedList } = pos.doc.type.schema.nodes;
    let currentDepth = pos.depth;
    let topLevelList;
    while(currentDepth > 0){
        const node = pos.node(currentDepth);
        if ([
            bulletList,
            orderedList
        ].includes(node.type)) topLevelList = {
            node: node,
            pos: pos.before(currentDepth)
        };
        currentDepth--;
    }
    return topLevelList;
};
const $797117ca6b1d49fe$export$d2d208886cf1a82d = ($pos)=>{
    const layoutColumnParent = (0, $gab48.findParentNodeClosestToPos)($pos, $797117ca6b1d49fe$export$c09dbe4edab814a2);
    if (!layoutColumnParent) return false;
    const panelOrExpandParent = (0, $gab48.findParentNodeClosestToPos)($pos, $797117ca6b1d49fe$export$3180f8c1df4f8d41);
    if (panelOrExpandParent && panelOrExpandParent.pos > layoutColumnParent.pos) return false;
    const afterPos = layoutColumnParent.pos + layoutColumnParent.node.nodeSize;
    const $after = $pos.doc.resolve(afterPos);
    return Boolean($after.nodeAfter);
};
const $797117ca6b1d49fe$export$c09dbe4edab814a2 = (node)=>{
    var _node$type2;
    const { layoutColumn: layoutColumn } = (node === null || node === void 0 || (_node$type2 = node.type) === null || _node$type2 === void 0 || (_node$type2 = _node$type2.schema) === null || _node$type2 === void 0 ? void 0 : _node$type2.nodes) || {};
    return Boolean(node && node.type && node.type === layoutColumn);
};
const $797117ca6b1d49fe$export$3180f8c1df4f8d41 = (node)=>{
    var _node$type3;
    const { panel: panel, panel_c1: panel_c1, expand: expand } = (node === null || node === void 0 || (_node$type3 = node.type) === null || _node$type3 === void 0 || (_node$type3 = _node$type3.schema) === null || _node$type3 === void 0 ? void 0 : _node$type3.nodes) || {};
    return Boolean(node && node.type && (node.type === panel || (0, $5N1Y4.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) && node.type === panel_c1 || node.type === expand));
};

});
parcelRegister("3tc9n", function(module, exports) {
$parcel$export(module.exports, "createHideCursorDecoration", () => $36b46443ed7805a3$export$22f5d232402cb4b);

var $a3b9P = parcelRequire("a3b9P");
const $36b46443ed7805a3$var$hideCursorWidgetStyles = `
	position: absolute;
	pointer-events: none;
	width: 0;
	height: 0;
`;
const $36b46443ed7805a3$var$createHideCursorWidget = ()=>{
    const span = document.createElement('span');
    span.className = 'ProseMirror-hide-cursor';
    span.setAttribute('style', $36b46443ed7805a3$var$hideCursorWidgetStyles);
    return span;
};
const $36b46443ed7805a3$export$22f5d232402cb4b = ()=>{
    return (0, $a3b9P.Decoration).widget(0, $36b46443ed7805a3$var$createHideCursorWidget, {
        key: 'hide-cursor-decoration',
        side: -1
    });
};

});




parcelRegister("5aVbX", function(module, exports) {
$parcel$export(module.exports, "default", () => $c5fff0fcd55d387d$export$2e2bcd8739ae039);

var $cv8id = parcelRequire("cv8id");

var $j7pt0 = parcelRequire("j7pt0");

var $5FzRL = parcelRequire("5FzRL");

var $ejrfk = parcelRequire("ejrfk");

var $eh0uh = parcelRequire("eh0uh");

var $6XRT4 = parcelRequire("6XRT4");
function $c5fff0fcd55d387d$export$2e2bcd8739ae039() {
    const map = {};
    (0, $cv8id.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $cv8id.insertNewLine).common, (state, dispatch, view)=>{
        const isInGapCursor = state.selection instanceof (0, $j7pt0.GapCursorSelection);
        // Only operate in gap cursor
        if (!isInGapCursor) return false;
        return (0, $5FzRL.createParagraphNear)(state, dispatch);
    }, map);
    (0, $cv8id.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $cv8id.moveLeft).common, (state, dispatch, view)=>{
        const endOfTextblock = view ? view.endOfTextblock.bind(view) : undefined;
        return (0, $eh0uh.arrow)((0, $6XRT4.Direction).LEFT, endOfTextblock)(state, dispatch, view);
    }, map);
    (0, $cv8id.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $cv8id.moveRight).common, (state, dispatch, view)=>{
        const endOfTextblock = view ? view.endOfTextblock.bind(view) : undefined;
        return (0, $eh0uh.arrow)((0, $6XRT4.Direction).RIGHT, endOfTextblock)(state, dispatch);
    }, map);
    (0, $cv8id.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $cv8id.moveUp).common, (state, dispatch, view)=>{
        const endOfTextblock = view ? view.endOfTextblock.bind(view) : undefined;
        return (0, $eh0uh.arrow)((0, $6XRT4.Direction).UP, endOfTextblock)(state, dispatch);
    }, map);
    (0, $cv8id.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $cv8id.moveDown).common, (state, dispatch, view)=>{
        const endOfTextblock = view ? view.endOfTextblock.bind(view) : undefined;
        return (0, $eh0uh.arrow)((0, $6XRT4.Direction).DOWN, endOfTextblock)(state, dispatch);
    }, map);
    // default PM's Backspace doesn't handle removing block nodes when cursor is after it
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $cv8id.bindKeymapWithCommand)((0, $cv8id.backspace).common, (0, $eh0uh.deleteNode)((0, $6XRT4.Direction).BACKWARD), map);
    // handle Delete key (remove node after the cursor)
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $cv8id.bindKeymapWithCommand)((0, $cv8id.deleteKey).common, (0, $eh0uh.deleteNode)((0, $6XRT4.Direction).FORWARD), map);
    return (0, $ejrfk.keymap)(map);
}

});
parcelRegister("eh0uh", function(module, exports) {
$parcel$export(module.exports, "arrow", () => $8028b77d6daf102e$export$f2120bbfa5450bd2);
$parcel$export(module.exports, "deleteNode", () => $8028b77d6daf102e$export$b05da9e94a08038f);

var $5iSwO = parcelRequire("5iSwO");
var $5m3y9 = parcelRequire("5m3y9");
var $8t2a4 = parcelRequire("8t2a4");

var $j7pt0 = parcelRequire("j7pt0");

var $7jXHH = parcelRequire("7jXHH");

var $81ojn = parcelRequire("81ojn");
var $5DWw8 = parcelRequire("5DWw8");
var $iiWgs = parcelRequire("iiWgs");

var $kuD5k = parcelRequire("kuD5k");

var $cw0wu = parcelRequire("cw0wu");

var $gab48 = parcelRequire("gab48");

var $kxbB4 = parcelRequire("kxbB4");

var $6XRT4 = parcelRequire("6XRT4");

var $7UxLc = parcelRequire("7UxLc");
const $8028b77d6daf102e$export$1c8a4d720fa6d473 = (direction, state, $pos)=>{
    var _$pos$nodeBefore;
    const { doc: doc, schema: schema } = state;
    switch(direction){
        case (0, $6XRT4.Direction).UP:
            if ((0, $5iSwO.atTheBeginningOfDoc)(state)) return false;
            return (0, $iiWgs.isPositionNearTableRow)($pos, schema, 'before') || (0, $7UxLc.isTextBlockNearPos)(doc, schema, $pos, -1) || (0, $5DWw8.isNodeBeforeMediaNode)($pos, state);
        case (0, $6XRT4.Direction).DOWN:
            return(// end of a paragraph
            (0, $5m3y9.atTheEndOfDoc)(state) || (0, $7UxLc.isTextBlockNearPos)(doc, schema, $pos, 1) || (0, $iiWgs.isPositionNearTableRow)($pos, schema, 'after') || ((_$pos$nodeBefore = $pos.nodeBefore) === null || _$pos$nodeBefore === void 0 ? void 0 : _$pos$nodeBefore.type.name) === 'text' && !$pos.nodeAfter);
        default:
            return false;
    }
};
// These cases should be handled using the handleMediaGapCursor function
function $8028b77d6daf102e$var$shouldHandleMediaGapCursor(dir, state) {
    var _selection$$from$node;
    const { selection: selection } = state;
    const upArrowFromGapCursorIntoMedia = selection instanceof (0, $j7pt0.GapCursorSelection) && dir === (0, $6XRT4.Direction).UP && selection.$from.nodeBefore && (0, $81ojn.isMediaNode)(selection.$from.nodeBefore);
    const downArrowFromGapCursorIntoMediaGroup = selection instanceof (0, $j7pt0.GapCursorSelection) && dir === (0, $6XRT4.Direction).DOWN && ((_selection$$from$node = selection.$from.nodeAfter) === null || _selection$$from$node === void 0 ? void 0 : _selection$$from$node.type.name) === 'mediaGroup';
    return upArrowFromGapCursorIntoMedia || downArrowFromGapCursorIntoMediaGroup;
}
// Handle media gap cursor for up/down arrow into media nodes
// Should check this case by using shouldHandleMediaGapCursor first
function $8028b77d6daf102e$var$handleMediaGapCursor(dir, state) {
    const { selection: selection, tr: tr } = state;
    const $pos = (0, $6XRT4.isBackward)(dir) ? selection.$from : selection.$to;
    if (dir === (0, $6XRT4.Direction).UP && selection.$from.nodeBefore && (0, $81ojn.isMediaNode)(selection.$from.nodeBefore)) {
        var _tr$doc$nodeAt;
        const nodeBeforePos = (0, $gab48.findPositionOfNodeBefore)(tr.selection);
        if (nodeBeforePos && selection.side === 'right' && ((_tr$doc$nodeAt = tr.doc.nodeAt(nodeBeforePos)) === null || _tr$doc$nodeAt === void 0 ? void 0 : _tr$doc$nodeAt.type.name) === 'mediaSingle') tr.setSelection(new (0, $cw0wu.NodeSelection)(tr.doc.resolve(nodeBeforePos))).scrollIntoView();
        else if (nodeBeforePos || nodeBeforePos === 0) tr.setSelection(new (0, $j7pt0.GapCursorSelection)(tr.doc.resolve(nodeBeforePos), (0, $8t2a4.Side).LEFT)).scrollIntoView();
    }
    if (dir === (0, $6XRT4.Direction).DOWN && selection.$from.nodeAfter) {
        const nodeAfterPos = selection.side === 'right' ? $pos.pos : $pos.pos + selection.$from.nodeAfter.nodeSize;
        if (nodeAfterPos) tr.setSelection(new (0, $j7pt0.GapCursorSelection)(tr.doc.resolve(nodeAfterPos), (0, $8t2a4.Side).LEFT)).scrollIntoView();
    }
    return tr;
}
const $8028b77d6daf102e$export$f2120bbfa5450bd2 = (dir, endOfTextblock)=>(state, dispatch, view)=>{
        const { doc: doc, selection: selection, tr: tr } = state;
        let $pos = (0, $6XRT4.isBackward)(dir) ? selection.$from : selection.$to;
        let mustMove = selection.empty;
        // start from text selection
        if (selection instanceof (0, $cw0wu.TextSelection)) {
            // if cursor is in the middle of a text node, do nothing
            if (!endOfTextblock || !endOfTextblock(dir.toString())) return false;
            // UP/DOWN jumps to the nearest texblock skipping gapcursor whenever possible
            if ($8028b77d6daf102e$export$1c8a4d720fa6d473(dir, state, $pos)) return false;
            // otherwise resolve previous/next position
            $pos = doc.resolve((0, $6XRT4.isBackward)(dir) ? $pos.before() : $pos.after());
            mustMove = false;
        }
        if (selection instanceof (0, $cw0wu.NodeSelection)) {
            if (selection.node.isInline) return false;
            if (dir === (0, $6XRT4.Direction).UP && !(0, $5iSwO.atTheBeginningOfDoc)(state) && !(0, $5DWw8.isNodeBeforeMediaNode)($pos, state) || dir === (0, $6XRT4.Direction).DOWN) // We dont add gap cursor on node selections going up and down
            // Except we do if we're going up for a block node which is the
            // first node in the document OR the node before is a media node
            return false;
        }
        // Handle media gap cursor for up/down arrow into media nodes
        if ($8028b77d6daf102e$var$shouldHandleMediaGapCursor(dir, state)) {
            const updatedTr = $8028b77d6daf102e$var$handleMediaGapCursor(dir, state);
            if (dispatch) dispatch(updatedTr);
            return true;
        }
        // when jumping between block nodes at the same depth, we need to reverse cursor without changing ProseMirror position
        if (selection instanceof (0, $j7pt0.GapCursorSelection) && // next node allow gap cursor position
        (0, $7jXHH.isValidTargetNode)((0, $6XRT4.isBackward)(dir) ? $pos.nodeBefore : $pos.nodeAfter) && // gap cursor changes block node
        ((0, $6XRT4.isBackward)(dir) && selection.side === (0, $8t2a4.Side).LEFT || (0, $6XRT4.isForward)(dir) && selection.side === (0, $8t2a4.Side).RIGHT)) {
            // reverse cursor position
            if (dispatch) dispatch(tr.setSelection(new (0, $j7pt0.GapCursorSelection)($pos, selection.side === (0, $8t2a4.Side).RIGHT ? (0, $8t2a4.Side).LEFT : (0, $8t2a4.Side).RIGHT)).scrollIntoView());
            return true;
        }
        if (view) {
            const domAtPos = view.domAtPos.bind(view);
            // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            const target = (0, $gab48.findDomRefAtPos)($pos.pos, domAtPos);
            if (target && target.textContent === (0, $kuD5k.ZERO_WIDTH_SPACE)) return false;
        }
        const nextSelection = (0, $j7pt0.GapCursorSelection).findFrom($pos, (0, $6XRT4.isBackward)(dir) ? -1 : 1, mustMove);
        if (!nextSelection) return false;
        if (!(0, $7jXHH.isValidTargetNode)((0, $6XRT4.isForward)(dir) ? nextSelection.$from.nodeBefore : nextSelection.$from.nodeAfter)) {
            // reverse cursor position
            if (dispatch) dispatch(tr.setSelection(new (0, $j7pt0.GapCursorSelection)(nextSelection.$from, (0, $6XRT4.isForward)(dir) ? (0, $8t2a4.Side).LEFT : (0, $8t2a4.Side).RIGHT)).scrollIntoView());
            return true;
        }
        if (dispatch) dispatch(tr.setSelection(nextSelection).scrollIntoView());
        return true;
    };
const $8028b77d6daf102e$export$b05da9e94a08038f = (dir)=>(state, dispatch)=>{
        if (state.selection instanceof (0, $j7pt0.GapCursorSelection)) {
            const { $from: $from, $anchor: $anchor } = state.selection;
            let { tr: tr } = state;
            if ((0, $6XRT4.isBackward)(dir)) {
                if (state.selection.side === 'left') {
                    tr.setSelection(new (0, $j7pt0.GapCursorSelection)($anchor, (0, $8t2a4.Side).RIGHT));
                    if (dispatch) dispatch(tr);
                    return true;
                }
                tr = (0, $gab48.removeNodeBefore)(state.tr);
            } else if ($from.nodeAfter) tr = tr.delete($from.pos, $from.pos + $from.nodeAfter.nodeSize);
            if (dispatch) dispatch(tr.setSelection((0, $cw0wu.Selection).near(tr.doc.resolve(tr.mapping.map(state.selection.$from.pos)))).scrollIntoView());
            return true;
        }
        return false;
    };
// This function captures clicks outside of the ProseMirror contentEditable area
// see also description of "handleClick" in gap-cursor pm-plugin
const $8028b77d6daf102e$var$captureCursorCoords = (event, editorRef, posAtCoords, tr)=>{
    const rect = editorRef.getBoundingClientRect();
    // capture clicks before the first block element
    if (event.clientY < rect.top) return {
        position: 0,
        side: (0, $8t2a4.Side).LEFT
    };
    if (rect.left > 0) {
        // calculate start position of a node that is vertically at the same level
        const coords = posAtCoords({
            left: rect.left,
            top: event.clientY
        });
        if (coords && coords.inside > -1) {
            const $from = tr.doc.resolve(coords.inside);
            const start = $from.before(1);
            const side = event.clientX < rect.left ? (0, $8t2a4.Side).LEFT : (0, $8t2a4.Side).RIGHT;
            let position;
            if (side === (0, $8t2a4.Side).LEFT) position = start;
            else {
                const node = tr.doc.nodeAt(start);
                if (node) position = start + node.nodeSize;
            }
            return {
                position: position,
                side: side
            };
        }
    }
    return null;
};
const $8028b77d6daf102e$export$1b305efb24649ca5 = (tr, event, editorRef, posAtCoords, editorFocused)=>{
    const cursorCoords = $8028b77d6daf102e$var$captureCursorCoords(event, editorRef, posAtCoords, tr);
    if (!cursorCoords) return;
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const $pos = cursorCoords.position !== undefined ? tr.doc.resolve(cursorCoords.position) : null;
    if ($pos === null) return;
    const isGapCursorAllowed = cursorCoords.side === (0, $8t2a4.Side).LEFT ? (0, $7jXHH.isValidTargetNode)($pos.nodeAfter) : (0, $7jXHH.isValidTargetNode)($pos.nodeBefore);
    if (isGapCursorAllowed && (0, $j7pt0.GapCursorSelection).valid($pos)) {
        // this forces PM to re-render the decoration node if we change the side of the gap cursor, it doesn't do it by default
        if (tr.selection instanceof (0, $j7pt0.GapCursorSelection)) tr.setSelection((0, $cw0wu.Selection).near($pos));
        else tr.setSelection(new (0, $j7pt0.GapCursorSelection)($pos, cursorCoords.side));
    } else if (editorFocused === false) {
        const selectionTemp = (0, $cw0wu.Selection).findFrom($pos, cursorCoords.side === (0, $8t2a4.Side).LEFT ? 1 : -1, true);
        if (selectionTemp) tr.setSelection(selectionTemp);
    }
};
const $8028b77d6daf102e$export$ddeed8e54d88a7b0 = (event, editorRef, posAtCoords, editorFocused)=>(state, dispatch)=>{
        const { tr: tr } = state;
        $8028b77d6daf102e$export$1b305efb24649ca5(tr, event, editorRef, posAtCoords, editorFocused);
        if (tr.selectionSet && dispatch) {
            dispatch(tr);
            return true;
        }
        return false;
    };
const $8028b77d6daf102e$export$a3664bef63da9388 = (state)=>{
    return Boolean((0, $kxbB4.gapCursorPluginKey).get(state));
};

});
parcelRegister("kxbB4", function(module, exports) {
$parcel$export(module.exports, "gapCursorPluginKey", () => $1bd1867431452f52$export$21af267ac39e2110);

var $cw0wu = parcelRequire("cw0wu");
const $1bd1867431452f52$export$21af267ac39e2110 = new (0, $cw0wu.PluginKey)('gapCursorPlugin');

});

parcelRegister("6XRT4", function(module, exports) {
$parcel$export(module.exports, "Direction", () => $1f1977629971af83$export$cacd6541cfeeb6c1);
$parcel$export(module.exports, "isBackward", () => $1f1977629971af83$export$4d894a9a195acd59);
$parcel$export(module.exports, "isForward", () => $1f1977629971af83$export$9439bc4ba99faca1);
var $1f1977629971af83$export$cacd6541cfeeb6c1 = /*#__PURE__*/ function(Direction) {
    Direction["UP"] = "up";
    Direction["RIGHT"] = "right";
    Direction["DOWN"] = "down";
    Direction["LEFT"] = "left";
    Direction["BACKWARD"] = "backward";
    Direction["FORWARD"] = "forward";
    return Direction;
}({});
function $1f1977629971af83$export$4d894a9a195acd59(dir) {
    return [
        "up",
        "left",
        "backward"
    ].indexOf(dir) !== -1;
}
function $1f1977629971af83$export$9439bc4ba99faca1(dir) {
    return [
        "right",
        "down",
        "forward"
    ].indexOf(dir) !== -1;
}

});

parcelRegister("7UxLc", function(module, exports) {
$parcel$export(module.exports, "isLeftCursor", () => $46ccda46bd4907ae$export$2b745dec73894c8a);
$parcel$export(module.exports, "isTextBlockNearPos", () => $46ccda46bd4907ae$export$84353379d6171bb9);
$parcel$export(module.exports, "getLayoutModeFromTargetNode", () => $46ccda46bd4907ae$export$698eab35981fecbc);
$parcel$export(module.exports, "isIgnoredClick", () => $46ccda46bd4907ae$export$e5da7366668fb130);
$parcel$export(module.exports, "getComputedStyleForLayoutMode", () => $46ccda46bd4907ae$export$b5b7287d8577df27);

var $29qUP = parcelRequire("29qUP");

var $8t2a4 = parcelRequire("8t2a4");

var $enwus = parcelRequire("enwus");

var $7YV6Z = parcelRequire("7YV6Z");

var $797yE = parcelRequire("797yE");
const $46ccda46bd4907ae$export$2b745dec73894c8a = (side)=>side === (0, $8t2a4.Side).LEFT;
function $46ccda46bd4907ae$export$ed28bfac31d0c2ef(doc, $pos, schema, dir = -1) {
    let $currentPos = $pos;
    let currentNode = null;
    const { mediaSingle: mediaSingle, media: media, mediaGroup: mediaGroup } = schema.nodes;
    do {
        $currentPos = doc.resolve(dir === -1 ? $currentPos.before() : $currentPos.after());
        if (!$currentPos) return null;
        currentNode = (dir === -1 ? $currentPos.nodeBefore : $currentPos.nodeAfter) || $currentPos.parent;
        if (!currentNode || currentNode.type === schema.nodes.doc) return null;
        if (currentNode.type === mediaSingle || currentNode.type === media || currentNode.type === mediaGroup) return currentNode;
    }while ($currentPos.depth > 0);
    return null;
}
const $46ccda46bd4907ae$export$84353379d6171bb9 = (doc, schema, $pos, dir)=>{
    let $currentPos = $pos;
    let currentNode = dir === -1 ? $currentPos.nodeBefore : $currentPos.nodeAfter;
    // If next node is a text or a text block bail out early.
    if (currentNode && (currentNode.isTextblock || currentNode.isText)) return true;
    while($currentPos.depth > 0){
        $currentPos = doc.resolve(dir === -1 ? $currentPos.before() : $currentPos.after());
        if (!$currentPos) return false;
        currentNode = (dir === -1 ? $currentPos.nodeBefore : $currentPos.nodeAfter) || $currentPos.parent;
        if (!currentNode || currentNode.type === schema.nodes.doc) return false;
        if (currentNode.isTextblock) return true;
    }
    let childNode = currentNode;
    while(childNode && childNode.firstChild){
        childNode = childNode.firstChild;
        if (childNode && (childNode.isTextblock || childNode.isText)) return true;
    }
    return false;
};
function $46ccda46bd4907ae$export$698eab35981fecbc(node) {
    let layout;
    if (node.attrs.layout) layout = node.attrs.layout;
    if (node.marks && node.marks.length) layout = (node.marks.find((mark)=>mark.type.name === 'breakout') || {
        attrs: {
            mode: ''
        }
    }).attrs.mode;
    if (node.type.name === 'table' && node.attrs.width) layout = 'fixed-width';
    if ([
        'wide',
        'full-width',
        'fixed-width'
    ].indexOf(layout) === -1) return '';
    return layout;
}
const $46ccda46bd4907ae$export$e5da7366668fb130 = (elem)=>{
    if ((elem === null || elem === void 0 ? void 0 : elem.nodeName) === 'BUTTON' || elem !== null && elem !== void 0 && elem.closest('button')) return true;
    // check if we're clicking an image caption placeholder
    if (elem !== null && elem !== void 0 && elem.closest(`[data-id="${(0, $29qUP.CAPTION_PLACEHOLDER_ID)}"]`)) return true;
    // check if target node has a parent table node
    let tableWrap;
    let node = elem;
    while(node){
        if (node.className && (node.getAttribute('class') || '').indexOf((0, $enwus.TableSharedCssClassName).TABLE_CONTAINER) > -1) {
            tableWrap = node;
            break;
        }
        // Ignored via go/ees005
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        node = node.parentNode;
    }
    if (tableWrap) {
        const rowControls = tableWrap.querySelector(`.${(0, $enwus.TableSharedCssClassName).TABLE_ROW_CONTROLS_WRAPPER}`);
        const isColumnControlsDecoration = elem && elem.classList && elem.classList.contains((0, $enwus.TableSharedCssClassName).TABLE_COLUMN_CONTROLS_DECORATIONS);
        return rowControls && rowControls.contains(elem) || isColumnControlsDecoration;
    }
    // Check if unsupported node selection
    // (without this, selection requires double clicking in FF due to posAtCoords differences)
    if (elem !== null && elem !== void 0 && elem.closest(`.${(0, $7YV6Z.UnsupportedSharedCssClassName).BLOCK_CONTAINER}`)) return true;
    return false;
};
const $46ccda46bd4907ae$export$b5b7287d8577df27 = (dom, node, style)=>{
    if (node && node.type.name === 'table') {
        const tableContainer = dom.querySelector('.pm-table-container');
        if (tableContainer) return window.getComputedStyle(tableContainer);
    }
    if ((0, $797yE.editorExperiment)('advanced_layouts', true) && node && node.type.name === 'layoutSection') {
        const layoutSectionContainer = dom.querySelector('.layout-section-container');
        if (layoutSectionContainer) return window.getComputedStyle(layoutSectionContainer);
    }
    return style;
};

});
parcelRegister("7YV6Z", function(module, exports) {
$parcel$export(module.exports, "UnsupportedSharedCssClassName", () => $214787ebfc0303e1$export$629043421dcc56e5);
const $214787ebfc0303e1$export$629043421dcc56e5 = {
    BLOCK_CONTAINER: 'unsupportedBlockView-content-wrap',
    INLINE_CONTAINER: 'unsupportedInlineView-content-wrap'
};

});




parcelRegister("5MOTW", function(module, exports) {
$parcel$export(module.exports, "default", () => $bcd1053deea328b3$export$2e2bcd8739ae039);

var $f7Kk4 = parcelRequire("f7Kk4");

var $8t2a4 = parcelRequire("8t2a4");

var $8JwHE = parcelRequire("8JwHE");

var $j7pt0 = parcelRequire("j7pt0");

var $cw0wu = parcelRequire("cw0wu");

var $gab48 = parcelRequire("gab48");

var $a3b9P = parcelRequire("a3b9P");

var $2E7OD = parcelRequire("2E7OD");

var $hB6GW = parcelRequire("hB6GW");

var $kxbB4 = parcelRequire("kxbB4");

var $eh0uh = parcelRequire("eh0uh");

var $6XRT4 = parcelRequire("6XRT4");

var $7UxLc = parcelRequire("7UxLc");

var $hk5C4 = parcelRequire("hk5C4");
const $bcd1053deea328b3$var$plugin = new (0, $f7Kk4.SafePlugin)({
    key: (0, $kxbB4.gapCursorPluginKey),
    state: {
        init: ()=>({
                selectionIsGapCursor: false,
                displayGapCursor: true,
                hideCursor: false
            }),
        apply: (tr, pluginState, _oldState, newState)=>{
            const meta = tr.getMeta((0, $kxbB4.gapCursorPluginKey));
            const selectionMeta = tr.getMeta((0, $hB6GW.selectionPluginKey));
            const selectionIsGapCursor = newState.selection instanceof (0, $j7pt0.GapCursorSelection);
            return {
                selectionIsGapCursor: selectionIsGapCursor,
                // only attempt to hide gap cursor if selection is gap cursor
                displayGapCursor: selectionIsGapCursor ? (meta === null || meta === void 0 ? void 0 : meta.displayGapCursor) ?? pluginState.displayGapCursor : true,
                // track hideCursor state from selection plugin
                hideCursor: (selectionMeta === null || selectionMeta === void 0 ? void 0 : selectionMeta.hideCursor) ?? pluginState.hideCursor
            };
        }
    },
    view: (view)=>{
        /**
     * If the selection is at the beginning of a document and is a NodeSelection,
     * convert to a GapCursor selection. This is to stop users accidentally replacing
     * the first node of a document by accident.
     */ if (view.state.selection.anchor === 0 && view.state.selection instanceof (0, $cw0wu.NodeSelection)) // This is required otherwise the dispatch doesn't trigger in the correct place
        window.requestAnimationFrame(()=>{
            view.dispatch(view.state.tr.setSelection(new (0, $j7pt0.GapCursorSelection)(view.state.doc.resolve(0), (0, $8t2a4.Side).LEFT)));
        });
        return {};
    },
    props: {
        decorations: (editorState)=>{
            const { doc: doc, selection: selection } = editorState;
            const { displayGapCursor: displayGapCursor, hideCursor: hideCursor } = (0, $kxbB4.gapCursorPluginKey).getState(editorState);
            if (selection instanceof (0, $j7pt0.GapCursorSelection) && displayGapCursor && !hideCursor) {
                const { $from: $from, side: side } = selection;
                // render decoration DOM node always to the left of the target node even if selection points to the right
                // otherwise positioning of the right gap cursor is a nightmare when the target node has a nodeView with vertical margins
                let position = selection.head;
                const isRightCursor = side === (0, $8t2a4.Side).RIGHT;
                if (isRightCursor && $from.nodeBefore) {
                    const nodeBeforeStart = (0, $gab48.findPositionOfNodeBefore)(selection);
                    if (typeof nodeBeforeStart === 'number') position = nodeBeforeStart;
                }
                const node = isRightCursor ? $from.nodeBefore : $from.nodeAfter;
                const layoutMode = node && (0, $7UxLc.getLayoutModeFromTargetNode)(node);
                return (0, $a3b9P.DecorationSet).create(doc, [
                    (0, $a3b9P.Decoration).widget(position, (0, $hk5C4.toDOM), {
                        key: `${(0, $j7pt0.JSON_ID)}-${side}-${layoutMode}`,
                        // position === 0: if gap cursor at start of document, render it on the left side of the selection to enable pasting (otherwise Chrome doesn't pick up the paste event)
                        side: layoutMode || position === 0 ? -1 : 0
                    })
                ]);
            }
            return null;
        },
        // render gap cursor only when its valid
        createSelectionBetween (view, $anchor, $head) {
            if (view && view.state && view.state.selection instanceof (0, $2E7OD.CellSelection)) // Do not show GapCursor when there is a CellSection happening
            return null;
            if ($anchor.pos === $head.pos && (0, $j7pt0.GapCursorSelection).valid($head)) return new (0, $j7pt0.GapCursorSelection)($head);
            return null;
        },
        handleClick (view, nodePos, event) {
            var _$pos$parent;
            const posAtCoords = view.posAtCoords({
                left: event.clientX,
                top: event.clientY
            });
            if (!posAtCoords || (0, $7UxLc.isIgnoredClick)(event.target instanceof HTMLElement ? event.target : null)) return false;
            const isInsideTheTarget = posAtCoords.pos === posAtCoords.inside;
            if (isInsideTheTarget) return false;
            const leftSideOffsetX = 20;
            const side = event.offsetX > leftSideOffsetX ? (0, $8t2a4.Side).RIGHT : (0, $8t2a4.Side).LEFT;
            const $pos = view.state.doc.resolve(nodePos);
            // In the new prosemirror-view posAtCoords  is not returning a precise value for our media nodes
            if (((_$pos$parent = $pos.parent) === null || _$pos$parent === void 0 ? void 0 : _$pos$parent.type.name) === 'mediaSingle') {
                const $insidePos = view.state.doc.resolve(Math.max(posAtCoords.inside, 0));
                // We don't have GapCursors problems when the node target is inside the root level
                if ($insidePos.depth <= 1) return false;
                const mediaGapCursor = !$pos.nodeBefore ? $pos.before() : $pos.after();
                return (0, $8JwHE.setGapCursorAtPos)(mediaGapCursor, side)(view.state, view.dispatch);
            }
            const docSize = view.state.doc.content.size;
            const nodeInside = posAtCoords.inside < 0 || posAtCoords.inside > docSize ? null : view.state.doc.nodeAt(posAtCoords.inside);
            if (nodeInside !== null && nodeInside !== void 0 && nodeInside.isAtom) return false;
            return (0, $8JwHE.setGapCursorAtPos)(nodePos, side)(view.state, view.dispatch);
        },
        handleDOMEvents: {
            /**
       * Android composition events aren't handled well by Prosemirror
       * We've added a couple of beforeinput hooks to help PM out when trying to delete
       * certain nodes. We can remove these when PM has better composition support.
       * @see https://github.com/ProseMirror/prosemirror/issues/543
       */ // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            beforeinput: (view, event)=>{
                if (event.inputType === 'deleteContentBackward' && view.state.selection instanceof (0, $j7pt0.GapCursorSelection)) {
                    event.preventDefault();
                    return (0, $eh0uh.deleteNode)((0, $6XRT4.Direction).BACKWARD)(view.state, view.dispatch);
                }
                return false;
            }
        }
    }
});
var $bcd1053deea328b3$export$2e2bcd8739ae039 = $bcd1053deea328b3$var$plugin;

});
parcelRegister("hk5C4", function(module, exports) {
$parcel$export(module.exports, "toDOM", () => $2e461449a090df65$export$289411c5a7970646);

var $8t2a4 = parcelRequire("8t2a4");

var $5N1Y4 = parcelRequire("5N1Y4");

var $7UxLc = parcelRequire("7UxLc");
/**
 * We have a couple of nodes that require us to compute style
 * on different elements, ideally all nodes should be able to
 * compute the appropriate styles based on their wrapper.
 */ const $2e461449a090df65$var$nestedCases = {
    'tableView-content-wrap': 'table',
    'mediaSingleView-content-wrap': '.rich-media-item',
    'bodiedExtensionView-content-wrap': '.extension-container',
    'multiBodiedExtensionView-content-wrap': '.multiBodiedExtension--container',
    'embedCardView-content-wrap': '.rich-media-item',
    'datasourceView-content-wrap': '.datasourceView-content-inner-wrap'
};
const $2e461449a090df65$var$getNestedSelector = (key)=>{
    if (key === 'multiBodiedExtensionView-content-wrap' && (0, $5N1Y4.expValEquals)('confluence_native_tabs_experiment', 'isEnabled', true)) return '.multiBodiedExtension--wrapper';
    return $2e461449a090df65$var$nestedCases[key];
};
const $2e461449a090df65$var$computeNestedStyle = (dom)=>{
    const foundKey = Object.keys($2e461449a090df65$var$nestedCases).find((className)=>dom.classList.contains(className));
    const nestedSelector = foundKey && $2e461449a090df65$var$getNestedSelector(foundKey);
    if (nestedSelector) {
        const nestedElement = dom.querySelector(nestedSelector);
        if (nestedElement) return window.getComputedStyle(nestedElement);
    }
};
const $2e461449a090df65$var$measureHeight = (style)=>{
    return $2e461449a090df65$var$measureValue(style, [
        'height',
        'padding-top',
        'padding-bottom',
        'border-top-width',
        'border-bottom-width'
    ]);
};
const $2e461449a090df65$var$measureWidth = (style)=>{
    return $2e461449a090df65$var$measureValue(style, [
        'width',
        'padding-left',
        'padding-right',
        'border-left-width',
        'border-right-width'
    ]);
};
const $2e461449a090df65$var$measureValue = (style, measureValues)=>{
    const [base, ...contentBoxValues] = measureValues;
    const measures = [
        style.getPropertyValue(base)
    ];
    const boxSizing = style.getPropertyValue('box-sizing');
    if (boxSizing === 'content-box') contentBoxValues.forEach((value)=>{
        measures.push(style.getPropertyValue(value));
    });
    let result = 0;
    for(let i = 0; i < measures.length; i++)result += parseFloat(measures[i]);
    return result;
};
const $2e461449a090df65$var$mutateElementStyle = (element, style, side)=>{
    element.style.transform = style.getPropertyValue('transform');
    if ((0, $7UxLc.isLeftCursor)(side)) {
        element.style.width = style.getPropertyValue('width');
        element.style.marginLeft = style.getPropertyValue('margin-left');
    } else {
        const marginRight = parseFloat(style.getPropertyValue('margin-right'));
        if (marginRight > 0) element.style.marginLeft = `-${Math.abs(marginRight)}px`;
        else element.style.paddingRight = `${Math.abs(marginRight)}px`;
    }
};
/**
 * For nested elements (e.g. .extension-container inside
 * .extensionView-content-wrap), use getBoundingClientRect to compute
 * the exact pixel offset between the gap cursor's position in the
 * flow and the inner element's visual position.
 */ const $2e461449a090df65$var$positionFromRect = (gapCursor, cursorParent, nestedElement)=>{
    const cursorRect = cursorParent.getBoundingClientRect();
    const innerRect = nestedElement.getBoundingClientRect();
    gapCursor.style.marginTop = `${innerRect.top - cursorRect.top}px`;
    gapCursor.style.left = `${innerRect.left - cursorRect.left}px`;
    gapCursor.style.width = `${innerRect.width}px`;
};
const $2e461449a090df65$export$289411c5a7970646 = (view, getPos)=>{
    const selection = view.state.selection;
    const { $from: $from, side: side } = selection;
    const isRightCursor = side === (0, $8t2a4.Side).RIGHT;
    const node = isRightCursor ? $from.nodeBefore : $from.nodeAfter;
    const element = document.createElement('span');
    element.className = `ProseMirror-gapcursor ${isRightCursor ? '-right' : '-left'}`;
    element.appendChild(document.createElement('span'));
    if (element.firstChild) {
        const gapCursor = element.firstChild;
        // The DOM from view.nodeDOM() might be stale after paste
        // Use requestAnimationFrame to wait for DOM to update, then fetch and measure
        requestAnimationFrame(()=>{
            const nodeStart = getPos();
            if (nodeStart === undefined) return;
            // if selection has changed, we no longer need to compute the styles for the gapcursor
            if (!view.state.selection.eq(selection)) return;
            const dom = view.nodeDOM(nodeStart);
            if (dom instanceof HTMLElement) {
                // For native embed extensions only, use getBoundingClientRect
                // to position the gap cursor precisely relative to the inner
                // .extension-container
                if (dom.classList.contains('extensionView-content-wrap')) {
                    const nativeEmbed = dom.querySelector('.extension-container:has([data-native-embed-alignment])');
                    if (nativeEmbed) {
                        const nativeEmbedStyle = window.getComputedStyle(nativeEmbed);
                        gapCursor.style.height = `${$2e461449a090df65$var$measureHeight(nativeEmbedStyle)}px`;
                        $2e461449a090df65$var$positionFromRect(gapCursor, element, nativeEmbed);
                        return;
                    }
                }
                const style = $2e461449a090df65$var$computeNestedStyle(dom) || window.getComputedStyle(dom);
                gapCursor.style.height = `${$2e461449a090df65$var$measureHeight(style)}px`;
                const layoutMode = node && (0, $7UxLc.getLayoutModeFromTargetNode)(node);
                if (nodeStart !== 0 || layoutMode || (node === null || node === void 0 ? void 0 : node.type.name) === 'table') gapCursor.style.marginTop = style.getPropertyValue('margin-top');
                const isNestedTable = (node === null || node === void 0 ? void 0 : node.type.name) === 'table' && selection.$to.depth > 0;
                if (layoutMode && !isNestedTable) {
                    gapCursor.setAttribute('layout', layoutMode);
                    const breakoutModeStyle = (0, $7UxLc.getComputedStyleForLayoutMode)(dom, node, style);
                    gapCursor.style.width = `${$2e461449a090df65$var$measureWidth(breakoutModeStyle)}px`;
                } else $2e461449a090df65$var$mutateElementStyle(gapCursor, style, selection.side);
            }
        });
    }
    return element;
};

});


parcelRegister("fdTMG", function(module, exports) {
$parcel$export(module.exports, "default", () => $6720a3faa0c382f7$export$2e2bcd8739ae039);

var $cv8id = parcelRequire("cv8id");

var $ejrfk = parcelRequire("ejrfk");

var $4njDB = parcelRequire("4njDB");
function $6720a3faa0c382f7$var$keymapPlugin() {
    const list = {};
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $cv8id.bindKeymapWithCommand)((0, $cv8id.moveRight).common, (0, $4njDB.arrowRight), list);
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $cv8id.bindKeymapWithCommand)((0, $cv8id.moveLeft).common, (0, $4njDB.arrowLeft), list);
    return (0, $ejrfk.keymap)(list);
}
var $6720a3faa0c382f7$export$2e2bcd8739ae039 = $6720a3faa0c382f7$var$keymapPlugin;

});

parcelRegister("h9Weu", function(module, exports) {
$parcel$export(module.exports, "createMarkBoundaryCursorPlugin", () => $b6489bbfc8d70983$export$d3a8cfe12ba42d22);

var $f7Kk4 = parcelRequire("f7Kk4");

var $a3b9P = parcelRequire("a3b9P");

var $4CVnu = parcelRequire("4CVnu");

var $i5HEI = parcelRequire("i5HEI");

var $bRW5T = parcelRequire("bRW5T");
const $b6489bbfc8d70983$export$d3a8cfe12ba42d22 = ()=>{
    return new (0, $f7Kk4.SafePlugin)({
        key: (0, $4CVnu.markBoundaryCursorPluginKey),
        state: {
            init: ()=>({
                    decorations: (0, $a3b9P.DecorationSet).empty
                }),
            apply (tr, currentState) {
                const { selection: selection, storedMarks: storedMarks, doc: doc, selectionSet: selectionSet, storedMarksSet: storedMarksSet, docChanged: docChanged } = tr;
                if (!selectionSet && !storedMarksSet && !docChanged) return currentState;
                const side = (0, $bRW5T.getActiveMarksSide)({
                    selection: selection,
                    storedMarks: storedMarks
                });
                if (!side) return {
                    decorations: (0, $a3b9P.DecorationSet).empty
                };
                return {
                    decorations: (0, $a3b9P.DecorationSet).create(doc, [
                        (0, $i5HEI.createMarkBoundaryCursorDecoration)(selection.head, side)
                    ])
                };
            }
        },
        props: {
            decorations: (state)=>{
                var _markBoundaryCursorPl;
                return (_markBoundaryCursorPl = (0, $4CVnu.markBoundaryCursorPluginKey).getState(state)) === null || _markBoundaryCursorPl === void 0 ? void 0 : _markBoundaryCursorPl.decorations;
            }
        }
    });
};

});
parcelRegister("4CVnu", function(module, exports) {
$parcel$export(module.exports, "markBoundaryCursorPluginKey", () => $7741466708973062$export$220fecd6a5c51ffb);

var $cw0wu = parcelRequire("cw0wu");
const $7741466708973062$export$220fecd6a5c51ffb = new (0, $cw0wu.PluginKey)('markBoundaryCursorPlugin');

});

parcelRegister("i5HEI", function(module, exports) {
$parcel$export(module.exports, "createMarkBoundaryCursorDecoration", () => $01365bd1d2d4b5f7$export$499e8e2917534a4d);

var $a3b9P = parcelRequire("a3b9P");
const $01365bd1d2d4b5f7$var$containerStyle = `
	position: relative;
`;
const $01365bd1d2d4b5f7$var$caretStyle = `
	position: absolute;
	height: 100%;
	width: 1px;
	left: -0.5px;
	bottom: 0;
	background-color: ${"var(--ds-text, #292A2E)"};
`;
const $01365bd1d2d4b5f7$var$toDOM = ()=>{
    var _caret$animate;
    const container = document.createElement('span');
    container.className = 'ProseMirror-mark-boundary-cursor';
    container.setAttribute('style', $01365bd1d2d4b5f7$var$containerStyle);
    const caret = document.createElement('div');
    caret.setAttribute('style', $01365bd1d2d4b5f7$var$caretStyle);
    (_caret$animate = caret.animate) === null || _caret$animate === void 0 || _caret$animate.call(caret, [
        {
            opacity: 1
        },
        {
            opacity: 1,
            offset: 0.5
        },
        {
            opacity: 0,
            offset: 0.5
        },
        {
            opacity: 0
        }
    ], {
        duration: 1000,
        iterations: Infinity
    });
    container.appendChild(caret);
    return container;
};
const $01365bd1d2d4b5f7$export$499e8e2917534a4d = (pos, side)=>{
    return (0, $a3b9P.Decoration).widget(pos, $01365bd1d2d4b5f7$var$toDOM, {
        key: 'mark-boundary-cursor',
        side: side
    });
};

});

parcelRegister("bRW5T", function(module, exports) {
$parcel$export(module.exports, "getActiveMarksSide", () => $f345c8cd61bc7854$export$8f6a177d567e1134);

var $aTdXU = parcelRequire("aTdXU");

var $kW8qW = parcelRequire("kW8qW");

var $1zJRo = parcelRequire("1zJRo");

var $gwRWQ = parcelRequire("gwRWQ");
function $f345c8cd61bc7854$export$8f6a177d567e1134({ selection: selection, storedMarks: storedMarks }) {
    if (!(0, $aTdXU.isTextSelection)(selection) || !selection.empty) return (0, $1zJRo.MarksSide).None;
    const { nodeBefore: nodeBefore, nodeAfter: nodeAfter } = selection.$head;
    const leftMarks = (nodeBefore === null || nodeBefore === void 0 ? void 0 : nodeBefore.marks) ?? [];
    const rightMarks = (nodeAfter === null || nodeAfter === void 0 ? void 0 : nodeAfter.marks) ?? [];
    if ((0, $kW8qW.Mark).sameSet(leftMarks, rightMarks)) return (0, $1zJRo.MarksSide).None;
    return (0, $gwRWQ.getInlineCodeCursorSide)({
        leftMarks: leftMarks,
        rightMarks: rightMarks,
        storedMarks: storedMarks
    });
}

});
parcelRegister("1zJRo", function(module, exports) {
$parcel$export(module.exports, "MarksSide", () => $fd599babfca88a28$export$6705e1762430d43f);
var $fd599babfca88a28$export$6705e1762430d43f = /*#__PURE__*/ function(MarksSide) {
    MarksSide[MarksSide["None"] = 0] = "None";
    MarksSide[MarksSide["Left"] = -1] = "Left";
    MarksSide[MarksSide["Right"] = 1] = "Right";
    return MarksSide;
}({});

});

parcelRegister("gwRWQ", function(module, exports) {
$parcel$export(module.exports, "getInlineCodeCursorSide", () => $4a81acf5c1c59a7e$export$325621c34246ee7d);

var $1zJRo = parcelRequire("1zJRo");
function $4a81acf5c1c59a7e$export$325621c34246ee7d({ leftMarks: leftMarks, rightMarks: rightMarks, storedMarks: storedMarks }) {
    const isInlineCodeToLeft = leftMarks.some((mark)=>mark.type.name === 'code');
    const isInlineCodeToRight = rightMarks.some((mark)=>mark.type.name === 'code');
    const isInlineCodeBeingStored = !!storedMarks && (storedMarks === null || storedMarks === void 0 ? void 0 : storedMarks.some((mark)=>mark.type.name === 'code'));
    const isStoredMarksBeingCleared = !!storedMarks && storedMarks.length === 0;
    // This condition covers two scenarios:
    // a) When the cursor is on the left side of the inline code, and is expected to be
    // positioned within the inline code after pressing arrow right
    // b) When the cursor is on the right side of the inline code, and is expected to be
    // positioned outside of the inline code after pressing arrow right
    // in both of these cases the cursor needs to be corrected to be positioned inline
    // with the node to the right
    // NOTE: In editor-plugin-text-formatting there is logic on left/right key press
    // which dispatches a transaction to update the stored marks
    if (isInlineCodeToRight && isInlineCodeBeingStored || isInlineCodeToLeft && isStoredMarksBeingCleared) return (0, $1zJRo.MarksSide).Right;
    return (0, $1zJRo.MarksSide).None;
}

});



parcelRegister("5WfkH", function(module, exports) {
$parcel$export(module.exports, "createPlugin", () => $91f97015d26b1939$export$ae829ec7b2625219);

var $f7Kk4 = parcelRequire("f7Kk4");

var $cw0wu = parcelRequire("cw0wu");

var $a3b9P = parcelRequire("a3b9P");

var $hB6GW = parcelRequire("hB6GW");

var $1wejO = parcelRequire("1wejO");

var $aNO5A = parcelRequire("aNO5A");

var $dK945 = parcelRequire("dK945");

var $9UESB = parcelRequire("9UESB");

var $9leZe = parcelRequire("9leZe");

var $f6zxh = parcelRequire("f6zxh");
const $91f97015d26b1939$export$53ac33307b5acee9 = (state)=>({
        decorationSet: (0, $f6zxh.getDecorations)(state.tr),
        selection: state.selection
    });
const $91f97015d26b1939$export$ae829ec7b2625219 = (api, dispatch, dispatchAnalyticsEvent, options = {})=>{
    let cursorHidden = false;
    let blockSelection;
    return new (0, $f7Kk4.SafePlugin)({
        key: (0, $hB6GW.selectionPluginKey),
        state: (0, $9leZe.createPluginState)(dispatch, $91f97015d26b1939$export$53ac33307b5acee9),
        appendTransaction (transactions, oldEditorState, newEditorState) {
            const { tr: tr } = newEditorState;
            let manualSelection;
            let hideCursorChanged = false;
            let blockSelectionChanged = false;
            for(let i = transactions.length - 1; i >= 0; i--){
                const meta = transactions[i].getMeta((0, $hB6GW.selectionPluginKey));
                if ((meta === null || meta === void 0 ? void 0 : meta.hideCursor) !== undefined) {
                    const newHideCursorValue = meta.hideCursor;
                    if (cursorHidden !== newHideCursorValue) {
                        cursorHidden = newHideCursorValue;
                        hideCursorChanged = true;
                    }
                }
                if (meta !== null && meta !== void 0 && meta.manualSelection && !manualSelection) manualSelection = meta.manualSelection;
                if (meta !== null && meta !== void 0 && meta.setBlockSelection) {
                    blockSelection = meta.setBlockSelection;
                    blockSelectionChanged = true;
                }
                if (meta !== null && meta !== void 0 && meta.clearBlockSelection) {
                    blockSelection = undefined;
                    blockSelectionChanged = true;
                }
            }
            if (!(0, $f6zxh.shouldRecalcDecorations)({
                oldEditorState: oldEditorState,
                newEditorState: newEditorState
            }) && !manualSelection && !hideCursorChanged && !blockSelectionChanged) return;
            tr.setMeta((0, $hB6GW.selectionPluginKey), {
                type: (0, $1wejO.SelectionActionTypes).SET_DECORATIONS,
                selection: tr.selection,
                decorationSet: (0, $f6zxh.getDecorations)(tr, manualSelection, cursorHidden, blockSelection)
            });
            return tr;
        },
        filterTransaction (tr, state) {
            // Prevent single click selecting atom nodes on mobile (we want to select with long press gesture instead)
            if (options.useLongPressSelection && tr.selectionSet && tr.selection instanceof (0, $cw0wu.NodeSelection) && !tr.getMeta((0, $hB6GW.selectionPluginKey))) return false;
            // Prevent prosemirror's mutation observer overriding a node selection with a text selection
            // for exact same range - this was cause of being unable to change dates in collab:
            // https://product-fabric.atlassian.net/browse/ED-10645
            if (state.selection instanceof (0, $cw0wu.NodeSelection) && tr.selection instanceof (0, $cw0wu.TextSelection) && state.selection.from === tr.selection.from && state.selection.to === tr.selection.to) return false;
            return true;
        },
        props: {
            createSelectionBetween: (0, $aNO5A.onCreateSelectionBetween),
            decorations (state) {
                var _api$interaction;
                const interactionState = api === null || api === void 0 || (_api$interaction = api.interaction) === null || _api$interaction === void 0 || (_api$interaction = _api$interaction.sharedState.currentState()) === null || _api$interaction === void 0 ? void 0 : _api$interaction.interactionState;
                // The interaction plugin is only present for editors that suppress the cursor
                // until first interaction, so we suppress selections for the same period.
                if (interactionState === 'hasNotHadInteraction') return (0, $a3b9P.DecorationSet).empty;
                return (0, $9leZe.getPluginState)(state).decorationSet;
            },
            handleDOMEvents: {
                keydown: (0, $dK945.createOnKeydown)({
                    __livePage: options.__livePage
                }),
                // Without this event, it is not possible to click and drag to select the first node in the
                // document if the node is a block with content (e.g. a panel with a paragraph inside).
                mouseout: (0, $9UESB.onMouseOut)
            }
        }
    });
};

});
parcelRegister("aNO5A", function(module, exports) {
$parcel$export(module.exports, "onCreateSelectionBetween", () => $2ef23f3422f57a07$export$ba3a236bf89a370d);

var $cw0wu = parcelRequire("cw0wu");
const $2ef23f3422f57a07$var$DOC_START_POS = 0;
function $2ef23f3422f57a07$var$isNodeContentEmpty(maybeNode) {
    return (maybeNode === null || maybeNode === void 0 ? void 0 : maybeNode.content.size) === 0 || (maybeNode === null || maybeNode === void 0 ? void 0 : maybeNode.textContent) === '';
}
function $2ef23f3422f57a07$var$findEmptySelectableParentNodePosition($pos) {
    const { doc: doc } = $pos;
    if ($pos.pos > doc.content.size) return null;
    if ($2ef23f3422f57a07$var$isCurrentNodeAtomOrEmptySelectable($pos)) return $pos;
    if ($pos.nodeBefore !== null) return null;
    if ($pos.depth === 0 && $pos.pos === 0) return $pos;
    const positionLevelUp = $pos.before();
    const resolvedPositionLevelUp = doc.resolve(positionLevelUp);
    return $2ef23f3422f57a07$var$findEmptySelectableParentNodePosition(resolvedPositionLevelUp);
}
const $2ef23f3422f57a07$var$isCurrentNodeAtomOrEmptySelectable = ($pos)=>{
    //ED-20209: Using $resolvedJustBeforeNodePos so that $resolvedJustBeforeNodePos.nodeAfter return the node at $pos.pos even if that is an atomic node
    if ($pos.pos === $2ef23f3422f57a07$var$DOC_START_POS) return false;
    const justBeforeNodePos = $pos.pos - 1;
    const $resolvedjustBeforePos = $pos.doc.resolve(justBeforeNodePos);
    const maybeNode = $resolvedjustBeforePos.nodeAfter;
    if (!maybeNode || !maybeNode.isBlock) return false;
    if (maybeNode.isAtom) return true;
    return $2ef23f3422f57a07$var$isNodeContentEmpty(maybeNode) && (0, $cw0wu.NodeSelection).isSelectable(maybeNode);
};
function $2ef23f3422f57a07$var$findNextSelectionPosition({ $targetHead: $targetHead, $anchor: $anchor, doc: doc }) {
    const direction = $anchor.pos < $targetHead.pos ? 'down' : 'up';
    //ED-20209: If the targetHead position is just before some node, Then return $targetHead and not select any node.
    let maybeNode = null;
    // prosemirror calls 'createSelectionBetween' for native 'drop' events, it passes $anchor
    // and $head which are based on a transformed document, but only provides the original
    // doc. Need to remap the $head pos to last element in doc to avoid RangeErrors.
    if ($targetHead.pos >= doc.nodeSize) maybeNode = doc.resolve(doc.nodeSize - 2).nodeBefore;
    else if ($targetHead.pos !== $2ef23f3422f57a07$var$DOC_START_POS) {
        const justBeforeHeadPos = $targetHead.pos - 1;
        const $resolvedJustBeforeHeadPos = doc.resolve(justBeforeHeadPos);
        maybeNode = $resolvedJustBeforeHeadPos.nodeAfter;
    }
    if (maybeNode === null) {
        maybeNode = $targetHead.nodeAfter;
        if (maybeNode !== null) $targetHead = doc.resolve($targetHead.pos + 1);
        else return null;
    }
    const maybeNextPosition = $2ef23f3422f57a07$var$findEmptySelectableParentNodePosition($targetHead);
    if (maybeNextPosition) {
        const justBeforeMaybeNextPos = maybeNextPosition.pos - 1;
        if (direction === 'up') return doc.resolve(Math.max(justBeforeMaybeNextPos, 0));
        else {
            const maybeNextNode = doc.resolve(justBeforeMaybeNextPos).nodeAfter;
            if (maybeNextNode) return doc.resolve(Math.min(justBeforeMaybeNextPos + maybeNextNode.nodeSize, doc.content.size));
        }
    }
    return null;
}
const $2ef23f3422f57a07$export$ba3a236bf89a370d = (view, $anchor, $head)=>{
    var _$head$parent, _$head$parent2;
    if ($anchor.pos === $head.pos) return null;
    if ($anchor.depth === $head.depth && $anchor.sameParent($head)) return null;
    // If the head is targeting a paragraph on root, then let ProseMirror handle the text selection
    if ($head.depth === 1 && ((_$head$parent = $head.parent) === null || _$head$parent === void 0 ? void 0 : _$head$parent.type.name) === 'paragraph') return null;
    // If head is at the beginning of a non-empty textblock, let ProseMirror handle the text selection
    if ((_$head$parent2 = $head.parent) !== null && _$head$parent2 !== void 0 && _$head$parent2.isTextblock && !$2ef23f3422f57a07$var$isNodeContentEmpty($head.parent) && $head.parentOffset === 0) return null;
    const $nextHeadPosition = $2ef23f3422f57a07$var$findNextSelectionPosition({
        $targetHead: $head,
        $anchor: $anchor,
        doc: view.state.doc
    });
    if (!$nextHeadPosition) return null;
    const forcedTextSelection = (0, $cw0wu.TextSelection).create(view.state.doc, $anchor.pos, $nextHeadPosition.pos);
    return forcedTextSelection;
};

});

parcelRegister("dK945", function(module, exports) {
$parcel$export(module.exports, "createOnKeydown", () => $fd6b9f6313f44035$export$1bff6ff05fed49a5);

var $eutMJ = parcelRequire("eutMJ");

var $cw0wu = parcelRequire("cw0wu");

var $5N1Y4 = parcelRequire("5N1Y4");

var $4zjoa = parcelRequire("4zjoa");
/*
 * The way expand was built, no browser recognize selection on it.
 * For instance, when a selection going to a "collapsed" expand
 * the browser will try to send the cursor to inside the expand content (wrong),
 * this behavior is caused because the expand content is never true hidden
 * we just set the height to 1px.
 *
 * So, we need to capture a possible selection event
 * when a collapsed expand is the next node in the common depth.
 * If that is true, we create a new TextSelection and stop the event bubble
 */ const $fd6b9f6313f44035$var$isCollapsedExpand = (node, { __livePage: __livePage })=>{
    let currentExpandedState;
    if (__livePage && (0, $5N1Y4.expValEquals)('platform_editor_single_player_expand', 'isEnabled', true)) currentExpandedState = node ? !(0, $eutMJ.expandedState).get(node) : undefined;
    else if (__livePage) currentExpandedState = node === null || node === void 0 ? void 0 : node.attrs.__expanded;
    else currentExpandedState = !(node !== null && node !== void 0 && node.attrs.__expanded);
    return Boolean(node && [
        'expand',
        'nestedExpand'
    ].includes(node.type.name) && currentExpandedState);
};
/**
 * ED-18072 - Cannot shift + arrow past bodied extension if it is not empty
 */ const $fd6b9f6313f44035$var$isBodiedExtension = (node)=>{
    return Boolean(node && [
        'bodiedExtension'
    ].includes(node.type.name));
};
/**
 * ED-19861 - [Regression] keyboard selections within action items are unpredicatable
 * Table was added to the list of problematic nodes because the desired behaviour when Shift+Up from outside the
 * table is to select the table node itself, rather than the table cell content. Previously this behaviour was handled
 * in `packages/editor/editor-core/src/plugins/selection/pm-plugins/events/create-selection-between.ts` but there was
 * a bug in `create-selection-between` which after fixing the bug that code was no longer handling table selection
 * correctly, so to fix that table was added here.
 */ const $fd6b9f6313f44035$var$isTable = (node)=>{
    return Boolean(node && [
        'table'
    ].includes(node.type.name));
};
const $fd6b9f6313f44035$var$isProblematicNode = (node, { __livePage: __livePage })=>{
    return $fd6b9f6313f44035$var$isCollapsedExpand(node, {
        __livePage: __livePage
    }) || $fd6b9f6313f44035$var$isBodiedExtension(node) || $fd6b9f6313f44035$var$isTable(node);
};
const $fd6b9f6313f44035$var$findFixedProblematicNodePosition = (doc, $head, direction, { __livePage: __livePage })=>{
    if ($head.pos === 0 || $head.depth === 0) return null;
    if (direction === 'up') {
        const pos = $head.before();
        const $posResolved = $head.doc.resolve(pos);
        const maybeProblematicNode = $posResolved.nodeBefore;
        if (maybeProblematicNode && $fd6b9f6313f44035$var$isProblematicNode(maybeProblematicNode, {
            __livePage: __livePage
        })) {
            const nodeSize = maybeProblematicNode.nodeSize;
            const nodeStartPosition = pos - nodeSize;
            // ($head.pos - 1) will correspond to (nodeStartPosition + nodeSize) when we are at the start of the text node
            const isAtEndOfProblematicNode = $head.pos - 1 === nodeStartPosition + nodeSize;
            if (isAtEndOfProblematicNode) {
                const startPosNode = Math.max(nodeStartPosition, 0);
                const $startPosNode = $head.doc.resolve(Math.min(startPosNode, $head.doc.content.size));
                return $startPosNode;
            }
        }
    }
    if (direction === 'down') {
        const pos = $head.after();
        const maybeProblematicNode = doc.nodeAt(pos);
        if (maybeProblematicNode && $fd6b9f6313f44035$var$isProblematicNode(maybeProblematicNode, {
            __livePage: __livePage
        }) && $head.pos + 1 === pos) {
            const nodeSize = maybeProblematicNode.nodeSize;
            const nodePosition = pos + nodeSize;
            const startPosNode = Math.max(nodePosition, 0);
            const $startPosNode = $head.doc.resolve(Math.min(startPosNode, $head.doc.content.size));
            return $startPosNode;
        }
    }
    return null;
};
const $fd6b9f6313f44035$var$isSelectionLineShortcutWhenCursorIsInsideInlineNode = (view, event)=>{
    var _selection$$cursor$no, _selection$$cursor$no2;
    if (!event.shiftKey || !event.metaKey) return false;
    const selection = view.state.selection;
    if (!(selection instanceof (0, $cw0wu.TextSelection))) return false;
    if (!selection.$cursor) return false;
    const isSelectingInlineNodeForward = event.key === 'ArrowRight' && Boolean((_selection$$cursor$no = selection.$cursor.nodeAfter) === null || _selection$$cursor$no === void 0 ? void 0 : _selection$$cursor$no.isInline);
    const isSelectingInlineNodeBackward = event.key === 'ArrowLeft' && Boolean((_selection$$cursor$no2 = selection.$cursor.nodeBefore) === null || _selection$$cursor$no2 === void 0 ? void 0 : _selection$$cursor$no2.isInline);
    return isSelectingInlineNodeForward || isSelectingInlineNodeBackward;
};
const $fd6b9f6313f44035$var$isNavigatingVerticallyWhenCursorIsInsideInlineNode = (view, event)=>{
    var _view$state, _selection$$cursor$no3, _selection$$cursor$no4;
    if (event.shiftKey || event.metaKey) return false;
    const selection = (_view$state = view.state) === null || _view$state === void 0 ? void 0 : _view$state.selection;
    if (!(selection instanceof (0, $cw0wu.TextSelection))) return false;
    if (!selection.$cursor) return false;
    const isNavigatingInlineNodeDownward = event.key === 'ArrowDown' && Boolean((_selection$$cursor$no3 = selection.$cursor.nodeBefore) === null || _selection$$cursor$no3 === void 0 ? void 0 : _selection$$cursor$no3.isInline) && Boolean((_selection$$cursor$no4 = selection.$cursor.nodeAfter) === null || _selection$$cursor$no4 === void 0 ? void 0 : _selection$$cursor$no4.isInline);
    if (isNavigatingInlineNodeDownward && (0, $eutMJ.getNextNodeExpandPos)(view, selection) !== undefined && (0, $4zjoa.expValEqualsNoExposure)('platform_editor_lovability_navigation_fixes', 'isEnabled', true)) return false;
    return isNavigatingInlineNodeDownward;
};
function $fd6b9f6313f44035$export$1bff6ff05fed49a5({ __livePage: __livePage = false }) {
    function onKeydown(view, event) {
        /*
     * This workaround is needed for some specific situations.
     * - expand collapse
     * - bodied extension
     */ if (!(event instanceof KeyboardEvent)) return false;
        // Override the default behaviour to make sure that the selection always extends to
        // the start of the document and not just the first inline position.
        if (event.shiftKey && event.metaKey && event.key === 'ArrowUp') {
            const selection = (0, $cw0wu.TextSelection).create(view.state.doc, view.state.selection.$anchor.pos, 0);
            view.dispatch(view.state.tr.setSelection(selection));
            event.preventDefault();
            return true;
        }
        if ($fd6b9f6313f44035$var$isSelectionLineShortcutWhenCursorIsInsideInlineNode(view, event)) return true;
        if ($fd6b9f6313f44035$var$isNavigatingVerticallyWhenCursorIsInsideInlineNode(view, event)) return true;
        if (!event.shiftKey || event.ctrlKey || event.metaKey) return false;
        if (![
            'ArrowUp',
            'ArrowDown',
            'ArrowRight',
            'ArrowLeft',
            'Home',
            'End'
        ].includes(event.key)) return false;
        const { doc: doc, selection: { $head: $head, $anchor: $anchor } } = view.state;
        if (event.key === 'ArrowRight' && $head.nodeAfter || event.key === 'ArrowLeft' && $head.nodeBefore) return false;
        const direction = [
            'ArrowLeft',
            'ArrowUp',
            'Home'
        ].includes(event.key) ? 'up' : 'down';
        const $fixedProblematicNodePosition = $fd6b9f6313f44035$var$findFixedProblematicNodePosition(doc, $head, direction, {
            __livePage: __livePage
        });
        if ($fixedProblematicNodePosition) {
            // an offset is used here so that left arrow selects the first character before the node (consistent with arrow right)
            const headOffset = event.key === 'ArrowLeft' ? -1 : 0;
            const head = $fixedProblematicNodePosition.pos + headOffset;
            const forcedTextSelection = (0, $cw0wu.TextSelection).create(view.state.doc, $anchor.pos, head);
            const tr = view.state.tr;
            tr.setSelection(forcedTextSelection);
            view.dispatch(tr);
            event.preventDefault();
            return true;
        }
        return false;
    }
    return onKeydown;
}

});

parcelRegister("9UESB", function(module, exports) {
$parcel$export(module.exports, "onMouseOut", () => $f8b35b1cef0b8c7a$export$65a11040da641544);

var $cw0wu = parcelRequire("cw0wu");
function $f8b35b1cef0b8c7a$export$53f3d8e656ab0334(selection) {
    if (selection.empty) return false;
    const { $anchor: $anchor, $head: $head } = selection;
    // Head must be at the start of its parent node's content
    if ($head.parentOffset !== 0) return false;
    // Head must be nested (e.g., in a panel > paragraph, not directly in doc)
    if ($head.depth <= 1) return false;
    // Head must be in the first top-level block (before depth 1 is 0)
    if ($head.before(1) !== 0) return false;
    // Selection must not span within a shared deeper structure
    if ($head.sharedDepth($anchor.pos) !== 0) return false;
    // Head must be in the first block at every level
    let isFirstBlockInTree = true;
    for(let i = $head.depth - 1; i >= 0; i--)if ($head.index(i) !== 0) {
        isFirstBlockInTree = false;
        break;
    }
    if (!isFirstBlockInTree) return false;
    return true;
}
function $f8b35b1cef0b8c7a$export$65a11040da641544(view, event) {
    // Only trigger during a mouse drag
    if (event.buttons === 0) return false;
    if (view.state.selection instanceof (0, $cw0wu.TextSelection) && $f8b35b1cef0b8c7a$export$53f3d8e656ab0334(view.state.selection)) {
        // Set selection with head at document start (position 0)
        const selection = new (0, $cw0wu.TextSelection)(view.state.doc.resolve(view.state.selection.$anchor.pos), view.state.doc.resolve(0));
        view.dispatch(view.state.tr.setSelection(selection));
        return true;
    }
    return false;
}

});



parcelRegister("iMKXn", function(module, exports) {
$parcel$export(module.exports, "selectionToolbarPlugin", () => $f2fe1036fdf3dfa9$export$b621d761b94834de);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $bAB3U = parcelRequire("bAB3U");

var $f7Kk4 = parcelRequire("f7Kk4");

var $inSrS = parcelRequire("inSrS");

var $cw0wu = parcelRequire("cw0wu");

var $797yE = parcelRequire("797yE");

var $hBjxW = parcelRequire("hBjxW");

var $lk55B = parcelRequire("lk55B");

var $83t7b = parcelRequire("83t7b");

var $721QH = parcelRequire("721QH");

var $lVZXD = parcelRequire("lVZXD");

var $bsU8E = parcelRequire("bsU8E");
const $f2fe1036fdf3dfa9$var$getToolbarDocking = (contextualFormattingEnabled, userPreferencesProvider)=>{
    if (contextualFormattingEnabled && (0, $797yE.editorExperiment)('platform_editor_controls', 'variant1')) return (userPreferencesProvider === null || userPreferencesProvider === void 0 ? void 0 : userPreferencesProvider.getPreference('toolbarDockingInitialPosition')) ?? 'none';
    return 'top';
};
const $f2fe1036fdf3dfa9$var$getToolbarDockingV2 = (contextualFormattingEnabled, dockingPreference)=>{
    if (contextualFormattingEnabled && (0, $797yE.editorExperiment)('platform_editor_controls', 'variant1')) return dockingPreference ?? 'none';
    return 'top';
};
const $f2fe1036fdf3dfa9$export$b621d761b94834de = ({ api: api, config: config })=>{
    const __selectionToolbarHandlers = [];
    let primaryToolbarComponent;
    const isToolbarAIFCEnabled = Boolean(api === null || api === void 0 ? void 0 : api.toolbar);
    const { userPreferencesProvider: userPreferencesProvider, contextualFormattingEnabled: contextualFormattingEnabled, disablePin: disablePin } = config;
    if (isToolbarAIFCEnabled) {
        var _api$toolbar;
        /**
     * If toolbar is set to always-pinned or always-inline, there is no control over toolbar placement
     */ if ((api === null || api === void 0 || (_api$toolbar = api.toolbar) === null || _api$toolbar === void 0 ? void 0 : _api$toolbar.actions.contextualFormattingMode()) === 'controlled') {
            var _api$toolbar2;
            api === null || api === void 0 || (_api$toolbar2 = api.toolbar) === null || _api$toolbar2 === void 0 || _api$toolbar2.actions.registerComponents((0, $bsU8E.getToolbarComponents)(api, true, disablePin));
        }
    } else if ((0, $797yE.editorExperiment)('platform_editor_controls', 'variant1', {
        exposure: true
    })) {
        var _api$primaryToolbar;
        primaryToolbarComponent = ({ disabled: disabled })=>{
            return /*#__PURE__*/ (0, $dc70d.jsx)((0, $lVZXD.PrimaryToolbarComponent), {
                api: api,
                disabled: disabled
            });
        };
        api === null || api === void 0 || (_api$primaryToolbar = api.primaryToolbar) === null || _api$primaryToolbar === void 0 || _api$primaryToolbar.actions.registerComponent({
            name: 'pinToolbar',
            component: primaryToolbarComponent
        });
    }
    let previousToolbarDocking = (userPreferencesProvider === null || userPreferencesProvider === void 0 ? void 0 : userPreferencesProvider.getPreference('toolbarDockingInitialPosition')) || null;
    return {
        name: 'selectionToolbar',
        actions: {
            /**
       * Overrides the user's toolbar docking position preference programmatically,
       * bypassing the normal user-driven preference update flow.
       */ overrideToolbarDocking: (toolbarDocking)=>{
                var _api$userPreferences;
                const command = api === null || api === void 0 || (_api$userPreferences = api.userPreferences) === null || _api$userPreferences === void 0 ? void 0 : _api$userPreferences.commands.overrideUserPreference('toolbarDockingPosition', toolbarDocking);
                if (!command) return false;
                return (api === null || api === void 0 ? void 0 : api.core.actions.execute(command)) ?? false;
            },
            /**
       * Clears the toolbar docking override and reverts to the current preference/state value.
       */ clearToolbarDockingOverride: ()=>{
                var _api$userPreferences2;
                const command = api === null || api === void 0 || (_api$userPreferences2 = api.userPreferences) === null || _api$userPreferences2 === void 0 ? void 0 : _api$userPreferences2.commands.clearOverrideUserPreference('toolbarDockingPosition');
                if (!command) return false;
                return (api === null || api === void 0 ? void 0 : api.core.actions.execute(command)) ?? false;
            },
            suppressToolbar: ()=>{
                return (api === null || api === void 0 ? void 0 : api.core.actions.execute((0, $hBjxW.toggleToolbar)({
                    hide: true
                }))) ?? false;
            },
            unsuppressToolbar: ()=>{
                return (api === null || api === void 0 ? void 0 : api.core.actions.execute((0, $hBjxW.toggleToolbar)({
                    hide: false
                }))) ?? false;
            },
            setToolbarDocking: (toolbarDocking)=>{
                var _api$userPreferences3;
                return (api === null || api === void 0 ? void 0 : api.core.actions.execute(api === null || api === void 0 || (_api$userPreferences3 = api.userPreferences) === null || _api$userPreferences3 === void 0 ? void 0 : _api$userPreferences3.actions.updateUserPreference('toolbarDockingPosition', toolbarDocking))) ?? false;
            },
            forceToolbarDockingWithoutAnalytics: (toolbarDocking)=>{
                var _api$userPreferences4;
                return (api === null || api === void 0 ? void 0 : api.core.actions.execute(api === null || api === void 0 || (_api$userPreferences4 = api.userPreferences) === null || _api$userPreferences4 === void 0 ? void 0 : _api$userPreferences4.actions.updateUserPreference('toolbarDockingPosition', toolbarDocking))) ?? false;
            },
            refreshToolbarDocking: ()=>{
                if (userPreferencesProvider) {
                    const userToolbarDockingPref = $f2fe1036fdf3dfa9$var$getToolbarDocking(contextualFormattingEnabled, userPreferencesProvider);
                    return (api === null || api === void 0 ? void 0 : api.core.actions.execute((0, $hBjxW.updateToolbarDocking)({
                        toolbarDocking: userToolbarDockingPref
                    }))) ?? false;
                }
                return false;
            }
        },
        getSharedState (editorState) {
            if (!editorState) return;
            return (0, $83t7b.selectionToolbarPluginKey).getState(editorState);
        },
        pmPlugins (selectionToolbarHandlers) {
            var _api$userPreferences5;
            if (selectionToolbarHandlers) __selectionToolbarHandlers.push(...selectionToolbarHandlers);
            const initialToolbarDocking = $f2fe1036fdf3dfa9$var$getToolbarDockingV2(contextualFormattingEnabled, api === null || api === void 0 || (_api$userPreferences5 = api.userPreferences) === null || _api$userPreferences5 === void 0 || (_api$userPreferences5 = _api$userPreferences5.sharedState.currentState()) === null || _api$userPreferences5 === void 0 || (_api$userPreferences5 = _api$userPreferences5.preferences) === null || _api$userPreferences5 === void 0 ? void 0 : _api$userPreferences5.toolbarDockingPosition);
            return [
                {
                    name: 'selection-tracker',
                    plugin: ()=>{
                        return new (0, $f7Kk4.SafePlugin)({
                            key: (0, $83t7b.selectionToolbarPluginKey),
                            state: {
                                init () {
                                    return {
                                        selectionStable: false,
                                        hide: false,
                                        toolbarDocking: initialToolbarDocking
                                    };
                                },
                                apply (tr, pluginState) {
                                    var _api$userIntent;
                                    const meta = tr.getMeta((0, $83t7b.selectionToolbarPluginKey));
                                    let newPluginState = pluginState;
                                    if (meta) return {
                                        ...newPluginState,
                                        ...meta
                                    };
                                    const isBlockMenuOpen = (api === null || api === void 0 || (_api$userIntent = api.userIntent) === null || _api$userIntent === void 0 || (_api$userIntent = _api$userIntent.sharedState.currentState()) === null || _api$userIntent === void 0 ? void 0 : _api$userIntent.currentUserIntent) === 'blockMenuOpen';
                                    newPluginState = {
                                        ...newPluginState,
                                        isBlockMenuOpen: isBlockMenuOpen
                                    };
                                    // if the toolbarDockingInitialPosition preference has changed
                                    // update the toolbarDocking state
                                    if (!previousToolbarDocking) {
                                        // we currently only check for the initial value
                                        const toolbarDockingPreference = userPreferencesProvider === null || userPreferencesProvider === void 0 ? void 0 : userPreferencesProvider.getPreference('toolbarDockingInitialPosition');
                                        if (toolbarDockingPreference && toolbarDockingPreference !== previousToolbarDocking) {
                                            previousToolbarDocking = toolbarDockingPreference;
                                            const userToolbarDockingPref = $f2fe1036fdf3dfa9$var$getToolbarDocking(contextualFormattingEnabled, userPreferencesProvider);
                                            if (pluginState.toolbarDocking !== userToolbarDockingPref) return {
                                                ...newPluginState,
                                                toolbarDocking: userToolbarDockingPref
                                            };
                                        }
                                    }
                                    return newPluginState;
                                }
                            },
                            view (view) {
                                const unbind = (0, $bAB3U.bind)(view.root, {
                                    type: 'mouseup',
                                    listener: (event)=>{
                                        var _api$editorViewMode;
                                        // We only want to set selectionStable to true if the editor has focus
                                        // to prevent the toolbar from showing when the editor is blurred
                                        // due to a click outside the editor.
                                        const editorViewModePlugin = api === null || api === void 0 || (_api$editorViewMode = api.editorViewMode) === null || _api$editorViewMode === void 0 ? void 0 : _api$editorViewMode.sharedState.currentState();
                                        const isViewModeEnabled = (editorViewModePlugin === null || editorViewModePlugin === void 0 ? void 0 : editorViewModePlugin.mode) === 'view';
                                        const target = event.target;
                                        if (target && target instanceof Element) {
                                            const isRovoChangeToneButton = target.tagName === 'BUTTON' && $f2fe1036fdf3dfa9$var$hasNestedSpanWithText(target, 'Change tone') || target.getAttribute('aria-label') === 'Change tone' || target.innerHTML === 'Change tone';
                                            const isRovoTranslateButton = target.tagName === 'BUTTON' && $f2fe1036fdf3dfa9$var$hasNestedSpanWithText(target, 'Translate options') || target.getAttribute('aria-label') === 'Translate options' || target.innerHTML === 'Translate options';
                                            if (isRovoChangeToneButton || isRovoTranslateButton) return null;
                                        }
                                        view.dispatch(view.state.tr.setMeta((0, $83t7b.selectionToolbarPluginKey), {
                                            selectionStable: !isViewModeEnabled ? view.hasFocus() : true
                                        }));
                                    }
                                });
                                const unbindEditorViewFocus = (0, $bAB3U.bind)(view.dom, {
                                    type: 'focus',
                                    listener: ()=>{
                                        view.dispatch(view.state.tr.setMeta((0, $83t7b.selectionToolbarPluginKey), {
                                            selectionStable: true
                                        }));
                                    }
                                });
                                return {
                                    destroy () {
                                        unbind();
                                        unbindEditorViewFocus();
                                    }
                                };
                            },
                            props: {
                                handleDOMEvents: {
                                    mousedown: (view)=>{
                                        view.dispatch(view.state.tr.setMeta((0, $83t7b.selectionToolbarPluginKey), {
                                            selectionStable: false
                                        }));
                                        return false;
                                    }
                                }
                            }
                        });
                    }
                }
            ];
        },
        pluginsOptions: isToolbarAIFCEnabled ? {} : {
            floatingToolbar (state, intl, providerFactory) {
                const { selectionStable: selectionStable, hide: hide, toolbarDocking: toolbarDocking, isBlockMenuOpen: isBlockMenuOpen } = (0, $83t7b.selectionToolbarPluginKey).getState(state);
                const isCellSelection = '$anchorCell' in state.selection;
                const isEditorControlsEnabled = (0, $797yE.editorExperiment)('platform_editor_controls', 'variant1');
                if (state.selection.empty || !selectionStable || hide || state.selection instanceof (0, $cw0wu.NodeSelection) || // $anchorCell is only available in CellSelection, this check is to
                // avoid importing CellSelection from @atlaskit/editor-tables
                isCellSelection && !isEditorControlsEnabled // for Editor Controls we want to show the toolbar on CellSelection
                ) // If there is no active selection, or the selection is not stable, or the selection is a node selection,
                // do not show the toolbar.
                return;
                if (isCellSelection && isEditorControlsEnabled) {
                    var _api$blockControls;
                    const isSelectedViaDragHandle = api === null || api === void 0 || (_api$blockControls = api.blockControls) === null || _api$blockControls === void 0 || (_api$blockControls = _api$blockControls.sharedState.currentState()) === null || _api$blockControls === void 0 ? void 0 : _api$blockControls.isSelectedViaDragHandle;
                    if (isSelectedViaDragHandle) return;
                }
                if (isBlockMenuOpen && isEditorControlsEnabled) // If the block menu is open, do not show the selection toolbar.
                return;
                // Resolve the selectionToolbarHandlers to a list of SelectionToolbarGroups
                // and filter out any handlers which returned undefined
                const resolved = __selectionToolbarHandlers.map((selectionToolbarHandler)=>selectionToolbarHandler(state, intl, providerFactory)).filter((resolved)=>resolved !== undefined);
                // Sort the groups by rank
                // This is intended to allow different plugins to control the order of the groups
                // they add to the selection toolbar.
                // ie. if you want to have your plugin's group appear first, set rank to -10 if there is currently another
                // plugin you expect to be run at the same time as with an rank of -9
                resolved.sort(({ rank: rankA = 0 }, { rank: rankB = 0 })=>{
                    if (rankA < rankB) return 1;
                    return -1;
                });
                const items = [];
                // This flattens the groups passed into the floating toolbar into a single list of items
                for(let i = 0; i < resolved.length; i++){
                    var _resolved$i;
                    // add a seperator icon after each group except the last
                    if (Array.isArray((_resolved$i = resolved[i]) === null || _resolved$i === void 0 ? void 0 : _resolved$i.items)) items.push(...resolved[i].items);
                    if ((0, $797yE.editorExperiment)('platform_editor_controls', 'variant1')) {
                        if (resolved[i] && resolved[i + 1]) {
                            var _resolved;
                            if (((_resolved = resolved[i + 1]) === null || _resolved === void 0 ? void 0 : _resolved.pluginName) === 'annotation') items.push({
                                type: 'separator',
                                fullHeight: true
                            });
                        }
                    } else if (i !== resolved.length - 1) items.push({
                        type: 'separator'
                    });
                }
                if (items.length > 0 && contextualFormattingEnabled && isEditorControlsEnabled) {
                    var _api$userPreferences6;
                    const toolbarDockingPref = api !== null && api !== void 0 && api.userPreferences ? api === null || api === void 0 || (_api$userPreferences6 = api.userPreferences) === null || _api$userPreferences6 === void 0 || (_api$userPreferences6 = _api$userPreferences6.sharedState.currentState()) === null || _api$userPreferences6 === void 0 || (_api$userPreferences6 = _api$userPreferences6.preferences) === null || _api$userPreferences6 === void 0 ? void 0 : _api$userPreferences6.toolbarDockingPosition : toolbarDocking;
                    items.push(...(0, $721QH.getPinOptionToolbarConfig)({
                        api: api,
                        toolbarDocking: toolbarDockingPref,
                        intl: intl
                    }));
                }
                let onPositionCalculated;
                const toolbarTitle = 'Selection toolbar';
                if (isCellSelection && isEditorControlsEnabled) onPositionCalculated = (0, $inSrS.calculateToolbarPositionOnCellSelection)(toolbarTitle);
                else {
                    const calcToolbarPosition = config.preferenceToolbarAboveSelection ? (0, $inSrS.calculateToolbarPositionAboveSelection) : (0, $inSrS.calculateToolbarPositionTrackHead);
                    onPositionCalculated = calcToolbarPosition(toolbarTitle);
                }
                const nodeType = (0, $lk55B.getSelectionNodeTypes)(state);
                return {
                    title: 'Selection toolbar',
                    nodeType: nodeType,
                    items: items,
                    ...isEditorControlsEnabled && {
                        scrollable: true
                    },
                    onPositionCalculated: onPositionCalculated
                };
            }
        },
        primaryToolbarComponent: !(api !== null && api !== void 0 && api.primaryToolbar) && (0, $797yE.editorExperiment)('platform_editor_controls', 'variant1', {
            exposure: true
        }) ? primaryToolbarComponent : undefined
    };
};
const $f2fe1036fdf3dfa9$var$hasNestedSpanWithText = (element, text)=>{
    if (element.tagName === 'SPAN' && element.innerHTML === text) return true;
    for (const child of Array.from(element.children)){
        if ($f2fe1036fdf3dfa9$var$hasNestedSpanWithText(child, text)) return true;
    }
    return false;
};

});
parcelRegister("hBjxW", function(module, exports) {
$parcel$export(module.exports, "toggleToolbar", () => $b11884b11a7b7fd6$export$9bf0179b815bb489);
$parcel$export(module.exports, "updateToolbarDocking", () => $b11884b11a7b7fd6$export$78c8c4f9cf91105f);

var $83t7b = parcelRequire("83t7b");
const $b11884b11a7b7fd6$export$9bf0179b815bb489 = ({ hide: hide })=>({ tr: tr })=>{
        tr.setMeta((0, $83t7b.selectionToolbarPluginKey), {
            hide: hide
        });
        return tr;
    };
const $b11884b11a7b7fd6$export$78c8c4f9cf91105f = ({ toolbarDocking: toolbarDocking })=>({ tr: tr })=>{
        tr.setMeta((0, $83t7b.selectionToolbarPluginKey), {
            toolbarDocking: toolbarDocking
        });
        return tr;
    };

});
parcelRegister("83t7b", function(module, exports) {
$parcel$export(module.exports, "selectionToolbarPluginKey", () => $89164dc56a0a3775$export$b382528b8197b4f1);

var $cw0wu = parcelRequire("cw0wu");
const $89164dc56a0a3775$export$b382528b8197b4f1 = new (0, $cw0wu.PluginKey)('selectionToolbarPluginKey');

});


parcelRegister("lk55B", function(module, exports) {
$parcel$export(module.exports, "getSelectionNodeTypes", () => $b227ba549e8b21c1$export$208ac2488b55bf9d);

var $3y2s4 = parcelRequire("3y2s4");
function $b227ba549e8b21c1$export$208ac2488b55bf9d(state) {
    const { from: from, to: to } = state.selection;
    if ((0, $3y2s4.isExperimentEnabled)('platform_editor_reduce_memory_leaks')) {
        const selectionNodeTypes = new Set();
        state.doc.nodesBetween(from, to, (node)=>{
            selectionNodeTypes.add(node.type);
        });
        return Array.from(selectionNodeTypes);
    }
    const selectionNodeTypes = [];
    state.doc.nodesBetween(from, to, (node)=>{
        if (selectionNodeTypes.indexOf(node.type) !== 0) selectionNodeTypes.push(node.type);
    });
    return selectionNodeTypes;
}

});

parcelRegister("721QH", function(module, exports) {
$parcel$export(module.exports, "getPinOptionToolbarConfig", () => $e0700da708af03d1$export$c9b144c567898dd8);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $hVGJk = parcelRequire("hVGJk");

var $c7Xo7 = parcelRequire("c7Xo7");

var $lPEMY = parcelRequire("lPEMY");

var $7XtiO = parcelRequire("7XtiO");
const $e0700da708af03d1$export$c9b144c567898dd8 = ({ api: api, toolbarDocking: toolbarDocking, intl: intl })=>{
    var _api$connectivity;
    const isOffline = (0, $hVGJk.isOfflineMode)(api === null || api === void 0 || (_api$connectivity = api.connectivity) === null || _api$connectivity === void 0 || (_api$connectivity = _api$connectivity.sharedState.currentState()) === null || _api$connectivity === void 0 ? void 0 : _api$connectivity.mode);
    let pinButton = {
        disabled: isOffline,
        id: 'editor.toolbar.unpined',
        icon: ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lPEMY))), {
                label: ""
            }),
        onClick: ()=>{
            var _api$userPreferences;
            return (api === null || api === void 0 ? void 0 : api.core.actions.execute(api === null || api === void 0 || (_api$userPreferences = api.userPreferences) === null || _api$userPreferences === void 0 ? void 0 : _api$userPreferences.actions.updateUserPreference('toolbarDockingPosition', 'top'))) ?? false;
        },
        title: intl.formatMessage((0, $c7Xo7.selectionToolbarMessages).toolbarPositionUnpined),
        type: 'button'
    };
    const isDockedToTop = toolbarDocking === 'top';
    if (isDockedToTop) pinButton = {
        disabled: isOffline,
        id: 'editor.toolbar.pinedToTop',
        icon: ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7XtiO))), {
                label: ""
            }),
        onClick: ()=>{
            var _api$userPreferences2;
            return (api === null || api === void 0 ? void 0 : api.core.actions.execute(api === null || api === void 0 || (_api$userPreferences2 = api.userPreferences) === null || _api$userPreferences2 === void 0 ? void 0 : _api$userPreferences2.actions.updateUserPreference('toolbarDockingPosition', 'none'))) ?? false;
        },
        type: 'button',
        title: intl.formatMessage((0, $c7Xo7.selectionToolbarMessages).toolbarPositionPinedAtTop)
    };
    return [
        {
            type: 'separator',
            fullHeight: true
        },
        pinButton
    ];
};

});
parcelRegister("c7Xo7", function(module, exports) {
$parcel$export(module.exports, "selectionToolbarMessages", () => $3630cdbf3780da4d$export$b0226831bf5c0d3e);

var $f0Pt4 = parcelRequire("f0Pt4");
const $3630cdbf3780da4d$export$b0226831bf5c0d3e = (0, $f0Pt4.defineMessages)({
    toolbarAppears: {
        id: 'fabric.editor.toolbarAppears',
        defaultMessage: 'Toolbar appears',
        description: 'Label for the group of radio options that control where the selection toolbar appears relative to selected text (e.g. inline or fixed at top).'
    },
    toolbarPositionInline: {
        id: 'fabric.editor.toolbarPositionInline',
        defaultMessage: 'In-line with text',
        description: 'Label for in-line toolbar position option'
    },
    toolbarPositionFixedAtTop: {
        id: 'fabric.editor.toolbarPositionFixedAtTop',
        defaultMessage: 'Fixed at top',
        description: 'Label for fixed at top toolbar position option'
    },
    toolbarPositionUnpined: {
        id: 'fabric.editor.toolbarPositionUnpined',
        defaultMessage: 'Pin the toolbar at the top',
        description: 'Label for in-line toolbar position option'
    },
    toolbarPositionPinedAtTop: {
        id: 'fabric.editor.toolbarPositionPinedAtTop',
        defaultMessage: 'Unpin the toolbar',
        description: 'Label for fixed at top toolbar position option'
    },
    toolbarPositionUnpinnedConcise: {
        id: 'fabric.editor.toolbarPositionUnpinnedConcise',
        defaultMessage: 'Pin toolbar to top',
        description: 'Label for menu item to pin the toolbar to the top of the page'
    }
});

});


parcelRegister("lVZXD", function(module, exports) {
$parcel$export(module.exports, "PrimaryToolbarComponent", () => $a7692f9495d1465e$export$94516d5cccf573e3);
/* PrimaryToolbarComponent.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9fU1q = parcelRequire("9fU1q");

var $4vLTk = parcelRequire("4vLTk");

var $hVGJk = parcelRequire("hVGJk");

var $c7Xo7 = parcelRequire("c7Xo7");

var $8zO6u = parcelRequire("8zO6u");

var $2pWL6 = parcelRequire("2pWL6");

var $lPEMY = parcelRequire("lPEMY");

var $7XtiO = parcelRequire("7XtiO");
const $a7692f9495d1465e$var$buttonStyles = null;
const $a7692f9495d1465e$export$94516d5cccf573e3 = ({ api: api, disabled: disabled })=>{
    var _api$userPreferences;
    const intl = (0, $4vLTk.default)();
    const mode = (0, $2pWL6.useSharedPluginStateSelector)(api, 'connectivity.mode');
    const isOffline = (0, $hVGJk.isOfflineMode)(mode);
    const isDockedToTop = (api === null || api === void 0 || (_api$userPreferences = api.userPreferences) === null || _api$userPreferences === void 0 || (_api$userPreferences = _api$userPreferences.sharedState.currentState()) === null || _api$userPreferences === void 0 || (_api$userPreferences = _api$userPreferences.preferences) === null || _api$userPreferences === void 0 ? void 0 : _api$userPreferences.toolbarDockingPosition) === 'top';
    if (isDockedToTop) return /*#__PURE__*/ (0, $dc70d.jsx)((0, $8zO6u.default), {
        "aria-label": intl.formatMessage((0, $c7Xo7.selectionToolbarMessages).toolbarPositionPinedAtTop),
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides -- Ignored via go/DSP-18766
        disabled: disabled || isOffline,
        iconBefore: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7XtiO))), {
            label: "",
            spacing: "spacious"
        }),
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onClick: ()=>{
            var _api$userPreferences2;
            return (api === null || api === void 0 ? void 0 : api.core.actions.execute(api === null || api === void 0 || (_api$userPreferences2 = api.userPreferences) === null || _api$userPreferences2 === void 0 ? void 0 : _api$userPreferences2.actions.updateUserPreference('toolbarDockingPosition', 'none'))) ?? false;
        },
        title: intl.formatMessage((0, $c7Xo7.selectionToolbarMessages).toolbarPositionPinedAtTop),
        className: (0, $9fU1q.default)([
            "_ca0q12x7 _n3td12x7 _19bv12x7 _u5f312x7"
        ])
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $8zO6u.default), {
        "aria-label": intl.formatMessage((0, $c7Xo7.selectionToolbarMessages).toolbarPositionUnpined),
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides -- Ignored via go/DSP-18766
        disabled: disabled || isOffline,
        iconBefore: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lPEMY))), {
            label: "",
            spacing: "spacious"
        }),
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onClick: ()=>{
            var _api$userPreferences3;
            return (api === null || api === void 0 ? void 0 : api.core.actions.execute(api === null || api === void 0 || (_api$userPreferences3 = api.userPreferences) === null || _api$userPreferences3 === void 0 ? void 0 : _api$userPreferences3.actions.updateUserPreference('toolbarDockingPosition', 'top'))) ?? false;
        },
        title: intl.formatMessage((0, $c7Xo7.selectionToolbarMessages).toolbarPositionUnpined),
        className: (0, $9fU1q.default)([
            "_ca0q12x7 _n3td12x7 _19bv12x7 _u5f312x7"
        ])
    });
};

});

parcelRegister("bsU8E", function(module, exports) {
$parcel$export(module.exports, "getToolbarComponents", () => $f93836694ccd8417$export$a758406ca53b86a5);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $4rzOL = parcelRequire("4rzOL");

var $fiku8 = parcelRequire("fiku8");

var $2XKfI = parcelRequire("2XKfI");

var $3BwvC = parcelRequire("3BwvC");

var $4ZjOM = parcelRequire("4ZjOM");
const $f93836694ccd8417$export$a758406ca53b86a5 = (api, contextualFormattingEnabled, disablePin)=>{
    const components = [
        {
            type: (0, $4rzOL.PIN_MENU_SECTION).type,
            key: (0, $4rzOL.PIN_MENU_SECTION).key,
            parents: [
                {
                    type: (0, $4rzOL.OVERFLOW_MENU).type,
                    key: (0, $4rzOL.OVERFLOW_MENU).key,
                    rank: (0, $fiku8.OVERFLOW_MENU_RANK)[(0, $4rzOL.PIN_MENU_SECTION).key]
                }
            ],
            component: ({ children: children })=>{
                return /*#__PURE__*/ (0, $dc70d.jsx)((0, $2XKfI.MenuSection), {
                    api: api,
                    children: children
                });
            }
        },
        {
            type: (0, $4rzOL.PIN_MENU_ITEM).type,
            key: (0, $4rzOL.PIN_MENU_ITEM).key,
            parents: [
                {
                    type: (0, $4rzOL.PIN_MENU_SECTION).type,
                    key: (0, $4rzOL.PIN_MENU_SECTION).key,
                    rank: (0, $fiku8.PIN_MENU_SECTION_RANK)[(0, $4rzOL.PIN_MENU_ITEM).key]
                }
            ],
            component: ()=>{
                return /*#__PURE__*/ (0, $dc70d.jsx)((0, $4ZjOM.PinMenuItem), {
                    api: api,
                    disablePin: disablePin
                });
            }
        }
    ];
    // Add pin button to primary toolbar when contextual formatting is enabled
    if (contextualFormattingEnabled) {
        const pinButtonComponents = [
            {
                type: (0, $4rzOL.PIN_GROUP).type,
                key: (0, $4rzOL.PIN_GROUP).key,
                parents: [
                    {
                        type: (0, $4rzOL.PIN_SECTION).type,
                        key: (0, $4rzOL.PIN_SECTION).key,
                        rank: (0, $fiku8.PIN_SECTION_RANK)[(0, $4rzOL.PIN_GROUP).key]
                    }
                ]
            },
            {
                type: (0, $4rzOL.PIN_BUTTON).type,
                key: (0, $4rzOL.PIN_BUTTON).key,
                parents: [
                    {
                        type: (0, $4rzOL.PIN_GROUP).type,
                        key: (0, $4rzOL.PIN_GROUP).key,
                        rank: (0, $fiku8.PIN_GROUP_RANK)[(0, $4rzOL.PIN_BUTTON).key]
                    }
                ],
                component: ()=>{
                    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $3BwvC.PinButton), {
                        api: api
                    });
                }
            }
        ];
        components.push(...pinButtonComponents);
    }
    return components;
};

});
parcelRegister("2XKfI", function(module, exports) {
$parcel$export(module.exports, "MenuSection", () => $86e414610783ba5b$export$4b1545b4f2016d26);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $28qc1 = parcelRequire("28qc1");

var $dlk6h = parcelRequire("dlk6h");
const $86e414610783ba5b$var$usePluginState = (_api)=>{
    const { editorViewMode: editorViewMode } = (0, $28qc1.useEditorToolbar)();
    return {
        editorViewMode: editorViewMode
    };
};
const $86e414610783ba5b$export$4b1545b4f2016d26 = ({ children: children, api: api })=>{
    const { editorViewMode: editorViewMode } = $86e414610783ba5b$var$usePluginState(api);
    const isEdit = editorViewMode === 'edit';
    if (!isEdit) return null;
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dlk6h.ToolbarDropdownItemSection), {
        hasSeparator: isEdit,
        children: children
    });
};

});

parcelRegister("3BwvC", function(module, exports) {
$parcel$export(module.exports, "PinButton", () => $8bee0ed4d1350b22$export$d2415675e97f35c2);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $c7Xo7 = parcelRequire("c7Xo7");

var $28qc1 = parcelRequire("28qc1");

var $5beht = parcelRequire("5beht");

var $7XtiO = parcelRequire("7XtiO");

var $7cgYb = parcelRequire("7cgYb");

var $eHnl8 = parcelRequire("eHnl8");
const $8bee0ed4d1350b22$export$d2415675e97f35c2 = ({ api: api })=>{
    const intl = (0, $4vLTk.default)();
    const message = intl.formatMessage((0, $c7Xo7.selectionToolbarMessages).toolbarPositionPinedAtTop);
    const { isOffline: isDisabled } = (0, $28qc1.useEditorToolbar)();
    // Pin/unpin is meaningless when a runtime override forces `'always-pinned'`
    // (e.g. Markdown Mode source / preview view). Subscribe so we re-render and
    // hide ourselves on flip.
    const runtimeOverride = (0, $5beht.useSharedPluginStateWithSelector)(api, [
        'toolbar'
    ], (states)=>{
        var _states$toolbarState;
        return (_states$toolbarState = states.toolbarState) === null || _states$toolbarState === void 0 ? void 0 : _states$toolbarState.contextualFormattingModeOverride;
    });
    if (runtimeOverride === 'always-pinned') return null;
    const onClick = ()=>{
        var _api$userPreferences;
        if (!api || isDisabled) return;
        api === null || api === void 0 || api.core.actions.execute(api === null || api === void 0 || (_api$userPreferences = api.userPreferences) === null || _api$userPreferences === void 0 ? void 0 : _api$userPreferences.actions.updateUserPreference('toolbarDockingPosition', 'none'));
    };
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $eHnl8.ToolbarTooltip), {
        content: message,
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $7cgYb.ToolbarButton), {
            iconBefore: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7XtiO))), {
                size: "small",
                label: ""
            }),
            label: message,
            onClick: onClick,
            isDisabled: isDisabled
        })
    });
};

});

parcelRegister("4ZjOM", function(module, exports) {
$parcel$export(module.exports, "PinMenuItem", () => $d8d7df9bbc380f9b$export$38c363c8d7e9c6f1);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $c7Xo7 = parcelRequire("c7Xo7");

var $28qc1 = parcelRequire("28qc1");

var $5beht = parcelRequire("5beht");

var $lPEMY = parcelRequire("lPEMY");

var $7XtiO = parcelRequire("7XtiO");

var $dbuPt = parcelRequire("dbuPt");
const $d8d7df9bbc380f9b$var$shouldShowPinMenuItem = (editMode)=>{
    return editMode !== 'view';
};
const $d8d7df9bbc380f9b$var$usePluginState = (_api)=>{
    const { editorViewMode: editorViewMode, editorToolbarDockingPreference: editorToolbarDockingPreference, isOffline: isOffline } = (0, $28qc1.useEditorToolbar)();
    return {
        editorViewMode: editorViewMode,
        editorToolbarDockingPreference: editorToolbarDockingPreference,
        isOffline: isOffline
    };
};
const $d8d7df9bbc380f9b$export$38c363c8d7e9c6f1 = ({ api: api, disablePin: disablePin })=>{
    const intl = (0, $4vLTk.default)();
    const runtimeOverride = (0, $5beht.useSharedPluginStateWithSelector)(api, [
        'toolbar'
    ], (states)=>{
        var _states$toolbarState;
        return (_states$toolbarState = states.toolbarState) === null || _states$toolbarState === void 0 ? void 0 : _states$toolbarState.contextualFormattingModeOverride;
    });
    const { editorViewMode: editorViewMode, editorToolbarDockingPreference: editorToolbarDockingPreference, isOffline: isDisabled } = $d8d7df9bbc380f9b$var$usePluginState(api);
    const isToolbarDocked = editorToolbarDockingPreference === 'top';
    if (disablePin || !$d8d7df9bbc380f9b$var$shouldShowPinMenuItem(editorViewMode) || runtimeOverride === 'always-pinned') return null;
    const onClick = ()=>{
        var _api$userPreferences;
        if (!api || isDisabled) return;
        api === null || api === void 0 || api.core.actions.execute(api === null || api === void 0 || (_api$userPreferences = api.userPreferences) === null || _api$userPreferences === void 0 ? void 0 : _api$userPreferences.actions.updateUserPreference('toolbarDockingPosition', isToolbarDocked ? 'none' : 'top'));
    };
    const message = intl.formatMessage(isToolbarDocked ? (0, $c7Xo7.selectionToolbarMessages).toolbarPositionPinedAtTop : (0, $c7Xo7.selectionToolbarMessages).toolbarPositionUnpinnedConcise);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dbuPt.ToolbarDropdownItem), {
        onClick: onClick,
        isDisabled: isDisabled,
        elemBefore: isToolbarDocked ? /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7XtiO))), {
            size: "small",
            label: ""
        }) : /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lPEMY))), {
            size: "small",
            label: ""
        }),
        children: message
    });
};

});



parcelRegister("2KvOl", function(module, exports) {
$parcel$export(module.exports, "submitEditorPlugin", () => $021c791cf69fc6d2$export$e488d499f3ae3f86);

var $4tcsi = parcelRequire("4tcsi");
const $021c791cf69fc6d2$export$e488d499f3ae3f86 = ({ config: onSave, api: api })=>({
        name: 'submitEditor',
        pmPlugins () {
            return [
                {
                    name: 'submitEditor',
                    plugin: ({ dispatch: dispatch })=>(0, $4tcsi.createPlugin)(dispatch, api, onSave)
                }
            ];
        }
    });

});
parcelRegister("4tcsi", function(module, exports) {
$parcel$export(module.exports, "createPlugin", () => $c2491a6c53e94f31$export$ae829ec7b2625219);

var $g6Qq4 = parcelRequire("g6Qq4");

var $cv8id = parcelRequire("cv8id");

var $lrWkt = parcelRequire("lrWkt");

var $ejrfk = parcelRequire("ejrfk");
function $c2491a6c53e94f31$export$ae829ec7b2625219(eventDispatch, api, onSave) {
    if (!onSave) return;
    return (0, $ejrfk.keymap)({
        [`${(0, $cv8id.submit).common}`]: (state, _dispatch, editorView)=>{
            var _api$media;
            const mediaState = api === null || api === void 0 || (_api$media = api.media) === null || _api$media === void 0 || (_api$media = _api$media.sharedState) === null || _api$media === void 0 ? void 0 : _api$media.currentState();
            if (mediaState && mediaState.waitForMediaUpload && !mediaState.allUploadsFinished) return true;
            if (!editorView) return false;
            eventDispatch((0, $lrWkt.analyticsEventKey), $c2491a6c53e94f31$var$analyticsPayload(state));
            onSave(editorView);
            return true;
        }
    });
}
const $c2491a6c53e94f31$var$analyticsPayload = (state)=>({
        payload: {
            action: (0, $g6Qq4.ACTION).STOPPED,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).EDITOR,
            actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).SAVE,
            attributes: {
                inputMethod: (0, $g6Qq4.INPUT_METHOD).SHORTCUT,
                documentSize: state.doc.nodeSize
            },
            eventType: (0, $g6Qq4.EVENT_TYPE).UI
        }
    });

});


parcelRegister("j3xyv", function(module, exports) {
$parcel$export(module.exports, "textFormattingPlugin", () => $094adc216c098413$export$2db686be056cb923);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $j2Bxs = parcelRequire("j2Bxs");

var $hUZiY = parcelRequire("hUZiY");

var $gkynH = parcelRequire("gkynH");

var $tNlcR = parcelRequire("tNlcR");

var $2ltAu = parcelRequire("2ltAu");

var $1JJe1 = parcelRequire("1JJe1");

var $797yE = parcelRequire("797yE");

var $5jSEp = parcelRequire("5jSEp");

var $exqT2 = parcelRequire("exqT2");

var $6eMA2 = parcelRequire("6eMA2");

var $9u9Eq = parcelRequire("9u9Eq");

var $6hkdO = parcelRequire("6hkdO");

var $eIuNw = parcelRequire("eIuNw");

var $fv1GT = parcelRequire("fv1GT");

var $0qvtE = parcelRequire("0qvtE");

var $86UXH = parcelRequire("86UXH");

var $77U33 = parcelRequire("77U33");

var $4Yo2H = parcelRequire("4Yo2H");

var $lkX9A = parcelRequire("lkX9A");
const $094adc216c098413$export$2db686be056cb923 = ({ config: options, api: api })=>{
    var _api$analytics7, _api$analytics8, _api$analytics9, _api$analytics0, _api$analytics1, _api$analytics10, _api$analytics11;
    const isToolbarAIFCEnabled = Boolean(api === null || api === void 0 ? void 0 : api.toolbar);
    const primaryToolbarComponent = ({ editorView: editorView, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement, isToolbarReducedSpacing: isToolbarReducedSpacing, toolbarSize: toolbarSize, disabled: disabled })=>{
        if (!editorView) return null;
        return /*#__PURE__*/ (0, $dc70d.jsx)((0, $4Yo2H.PrimaryToolbarComponent), {
            api: api,
            popupsMountPoint: popupsMountPoint,
            popupsScrollableElement: popupsScrollableElement,
            toolbarSize: toolbarSize,
            isReducedSpacing: isToolbarReducedSpacing,
            editorView: editorView,
            disabled: disabled,
            shouldUseResponsiveToolbar: Boolean(options === null || options === void 0 ? void 0 : options.responsiveToolbarMenu)
        });
    };
    if (isToolbarAIFCEnabled) {
        var _api$toolbar;
        api === null || api === void 0 || (_api$toolbar = api.toolbar) === null || _api$toolbar === void 0 || _api$toolbar.actions.registerComponents((0, $lkX9A.getToolbarComponents)(api, options));
    } else {
        var _api$primaryToolbar;
        api === null || api === void 0 || (_api$primaryToolbar = api.primaryToolbar) === null || _api$primaryToolbar === void 0 || _api$primaryToolbar.actions.registerComponent({
            name: 'textFormatting',
            component: primaryToolbarComponent
        });
    }
    return {
        name: 'textFormatting',
        marks () {
            return [
                {
                    name: 'em',
                    mark: (0, $hUZiY.em)
                },
                {
                    name: 'strong',
                    mark: (0, $tNlcR.strong)
                }
            ].concat(options !== null && options !== void 0 && options.disableStrikethrough ? [] : {
                name: 'strike',
                mark: (0, $gkynH.strike)
            }).concat(options !== null && options !== void 0 && options.disableCode ? [] : {
                name: 'code',
                mark: (0, $j2Bxs.code)
            }).concat(options !== null && options !== void 0 && options.disableSuperscriptAndSubscript ? [] : {
                name: 'subsup',
                mark: (0, $2ltAu.subsup)
            }).concat(options !== null && options !== void 0 && options.disableUnderline ? [] : {
                name: 'underline',
                mark: (0, $1JJe1.underline)
            });
        },
        pmPlugins () {
            return [
                {
                    name: 'textFormatting',
                    plugin: ({ dispatch: dispatch })=>{
                        var _api$analytics;
                        return (0, $fv1GT.plugin)(dispatch, api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions);
                    }
                },
                {
                    name: 'textFormattingCursor',
                    plugin: ()=>(0, $9u9Eq.default)
                },
                {
                    name: 'textFormattingInputRule',
                    plugin: ({ schema: schema })=>{
                        var _api$analytics2;
                        return (0, $6hkdO.default)(schema, api === null || api === void 0 || (_api$analytics2 = api.analytics) === null || _api$analytics2 === void 0 ? void 0 : _api$analytics2.actions, api);
                    }
                },
                {
                    name: 'textFormattingSmartRule',
                    plugin: ()=>{
                        var _api$analytics3;
                        return !(options !== null && options !== void 0 && options.disableSmartTextCompletion) ? (0, $86UXH.default)(api === null || api === void 0 || (_api$analytics3 = api.analytics) === null || _api$analytics3 === void 0 ? void 0 : _api$analytics3.actions) : undefined;
                    }
                },
                {
                    name: 'textFormattingClear',
                    plugin: ({ dispatch: dispatch })=>(0, $exqT2.plugin)(dispatch)
                },
                {
                    name: 'textFormattingClearKeymap',
                    plugin: ()=>{
                        var _api$analytics4;
                        return (0, $6eMA2.default)(api === null || api === void 0 || (_api$analytics4 = api.analytics) === null || _api$analytics4 === void 0 ? void 0 : _api$analytics4.actions);
                    }
                },
                {
                    name: 'textFormattingKeymap',
                    plugin: ({ schema: schema })=>{
                        var _api$analytics5;
                        return (0, $eIuNw.default)(schema, api === null || api === void 0 || (_api$analytics5 = api.analytics) === null || _api$analytics5 === void 0 ? void 0 : _api$analytics5.actions);
                    }
                }
            ];
        },
        getSharedState (editorState) {
            var _clearFormattingPlugi;
            if (!editorState) return undefined;
            const textFormattingState = (0, $0qvtE.pluginKey).getState(editorState);
            return {
                ...textFormattingState,
                formattingIsPresent: (_clearFormattingPlugi = (0, $exqT2.pluginKey).getState(editorState)) === null || _clearFormattingPlugi === void 0 ? void 0 : _clearFormattingPlugi.formattingIsPresent,
                isInitialised: !!(textFormattingState !== null && textFormattingState !== void 0 && textFormattingState.isInitialised)
            };
        },
        pluginsOptions: isToolbarAIFCEnabled ? {} : {
            selectionToolbar: ()=>{
                var _api$userPreferences;
                const toolbarDocking = api === null || api === void 0 || (_api$userPreferences = api.userPreferences) === null || _api$userPreferences === void 0 || (_api$userPreferences = _api$userPreferences.sharedState.currentState()) === null || _api$userPreferences === void 0 || (_api$userPreferences = _api$userPreferences.preferences) === null || _api$userPreferences === void 0 ? void 0 : _api$userPreferences.toolbarDockingPosition;
                if (toolbarDocking === 'none' && (0, $797yE.editorExperiment)('platform_editor_controls', 'variant1', {
                    exposure: true
                })) {
                    const toolbarCustom = {
                        type: 'custom',
                        render: (view)=>{
                            var _api$analytics6;
                            if (!view) return;
                            return /*#__PURE__*/ (0, $dc70d.jsx)((0, $77U33.FloatingToolbarTextFormalWithIntl), {
                                api: api,
                                editorView: view,
                                editorAnalyticsAPI: api === null || api === void 0 || (_api$analytics6 = api.analytics) === null || _api$analytics6 === void 0 ? void 0 : _api$analytics6.actions
                            });
                        },
                        fallback: []
                    };
                    return {
                        isToolbarAbove: true,
                        items: [
                            toolbarCustom
                        ],
                        rank: 7,
                        pluginName: 'textFormatting'
                    };
                } else return undefined;
            }
        },
        primaryToolbarComponent: !(api !== null && api !== void 0 && api.primaryToolbar) && !isToolbarAIFCEnabled ? primaryToolbarComponent : undefined,
        commands: {
            toggleSuperscript: (0, $5jSEp.toggleSuperscriptWithAnalytics)(api === null || api === void 0 || (_api$analytics7 = api.analytics) === null || _api$analytics7 === void 0 ? void 0 : _api$analytics7.actions),
            toggleSubscript: (0, $5jSEp.toggleSubscriptWithAnalytics)(api === null || api === void 0 || (_api$analytics8 = api.analytics) === null || _api$analytics8 === void 0 ? void 0 : _api$analytics8.actions),
            toggleStrike: (0, $5jSEp.toggleStrikeWithAnalytics)(api === null || api === void 0 || (_api$analytics9 = api.analytics) === null || _api$analytics9 === void 0 ? void 0 : _api$analytics9.actions),
            toggleCode: (0, $5jSEp.toggleCodeWithAnalytics)(api === null || api === void 0 || (_api$analytics0 = api.analytics) === null || _api$analytics0 === void 0 ? void 0 : _api$analytics0.actions),
            toggleUnderline: (0, $5jSEp.toggleUnderlineWithAnalytics)(api === null || api === void 0 || (_api$analytics1 = api.analytics) === null || _api$analytics1 === void 0 ? void 0 : _api$analytics1.actions),
            toggleEm: (0, $5jSEp.toggleEmWithAnalytics)(api === null || api === void 0 || (_api$analytics10 = api.analytics) === null || _api$analytics10 === void 0 ? void 0 : _api$analytics10.actions),
            toggleStrong: (0, $5jSEp.toggleStrongWithAnalytics)(api === null || api === void 0 || (_api$analytics11 = api.analytics) === null || _api$analytics11 === void 0 ? void 0 : _api$analytics11.actions)
        }
    };
};

});
parcelRegister("5jSEp", function(module, exports) {
$parcel$export(module.exports, "toggleEmWithAnalytics", () => $13f0b5f3784996ce$export$fe8278eb0d365433);
$parcel$export(module.exports, "toggleStrikeWithAnalytics", () => $13f0b5f3784996ce$export$f08ef336cb688397);
$parcel$export(module.exports, "toggleStrongWithAnalytics", () => $13f0b5f3784996ce$export$686bc7c29753e27);
$parcel$export(module.exports, "toggleUnderlineWithAnalytics", () => $13f0b5f3784996ce$export$bf3c86b5abdb857d);
$parcel$export(module.exports, "toggleSuperscriptWithAnalytics", () => $13f0b5f3784996ce$export$ca1c98793b67ba6b);
$parcel$export(module.exports, "toggleSubscriptWithAnalytics", () => $13f0b5f3784996ce$export$8d0c92ae27a193);
$parcel$export(module.exports, "toggleCodeWithAnalytics", () => $13f0b5f3784996ce$export$2d4f5a54f840ba91);

var $g6Qq4 = parcelRequire("g6Qq4");

var $fGjxM = parcelRequire("fGjxM");

var $fAdYi = parcelRequire("fAdYi");
const $13f0b5f3784996ce$export$3032060d929f850a = ({ tr: tr })=>{
    const { em: em } = tr.doc.type.schema.marks;
    if (!em) // No transaction to apply
    return null;
    return (0, $fGjxM.toggleMark)(em)({
        tr: tr
    });
};
const $13f0b5f3784996ce$export$fe8278eb0d365433 = (editorAnalyticsApi)=>(inputMethod)=>({ tr: tr })=>{
            const newTr = $13f0b5f3784996ce$export$3032060d929f850a({
                tr: tr
            });
            if (!newTr) // No transaction to apply
            return null;
            editorAnalyticsApi === null || editorAnalyticsApi === void 0 || editorAnalyticsApi.attachAnalyticsEvent({
                action: (0, $g6Qq4.ACTION).FORMATTED,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).TEXT,
                eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).FORMAT_ITALIC,
                attributes: {
                    inputMethod: inputMethod
                }
            })(newTr);
            return newTr;
        };
const $13f0b5f3784996ce$export$2670450dfa0f0caf = ({ tr: tr })=>{
    const { strike: strike } = tr.doc.type.schema.marks;
    if (!strike) // No transaction to apply
    return null;
    return (0, $fGjxM.toggleMark)(strike)({
        tr: tr
    });
};
const $13f0b5f3784996ce$export$f08ef336cb688397 = (editorAnalyticsApi)=>(inputMethod)=>({ tr: tr })=>{
            const newTr = $13f0b5f3784996ce$export$2670450dfa0f0caf({
                tr: tr
            });
            if (!newTr) // No transaction to apply
            return null;
            editorAnalyticsApi === null || editorAnalyticsApi === void 0 || editorAnalyticsApi.attachAnalyticsEvent({
                action: (0, $g6Qq4.ACTION).FORMATTED,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).TEXT,
                eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).FORMAT_STRIKE,
                attributes: {
                    inputMethod: inputMethod
                }
            })(newTr);
            return newTr;
        };
const $13f0b5f3784996ce$export$52f111485e4791e7 = ({ tr: tr })=>{
    const { strong: strong } = tr.doc.type.schema.marks;
    if (!strong) // No transaction to apply
    return null;
    return (0, $fGjxM.toggleMark)(strong)({
        tr: tr
    });
};
const $13f0b5f3784996ce$export$686bc7c29753e27 = (editorAnalyticsApi)=>(inputMethod)=>({ tr: tr })=>{
            const newTr = $13f0b5f3784996ce$export$52f111485e4791e7({
                tr: tr
            });
            if (!newTr) // No transaction to apply
            return null;
            editorAnalyticsApi === null || editorAnalyticsApi === void 0 || editorAnalyticsApi.attachAnalyticsEvent({
                action: (0, $g6Qq4.ACTION).FORMATTED,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).TEXT,
                eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).FORMAT_STRONG,
                attributes: {
                    inputMethod: inputMethod
                }
            })(newTr);
            return newTr;
        };
const $13f0b5f3784996ce$export$6bcc93697958b66d = ({ tr: tr })=>{
    const { underline: underline } = tr.doc.type.schema.marks;
    if (!underline) // No transaction to apply
    return null;
    return (0, $fGjxM.toggleMark)(underline)({
        tr: tr
    });
};
const $13f0b5f3784996ce$export$bf3c86b5abdb857d = (editorAnalyticsApi)=>(inputMethod)=>({ tr: tr })=>{
            const newTr = $13f0b5f3784996ce$export$6bcc93697958b66d({
                tr: tr
            });
            if (!newTr) // No transaction to apply
            return null;
            editorAnalyticsApi === null || editorAnalyticsApi === void 0 || editorAnalyticsApi.attachAnalyticsEvent({
                action: (0, $g6Qq4.ACTION).FORMATTED,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).TEXT,
                eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).FORMAT_UNDERLINE,
                attributes: {
                    inputMethod: inputMethod
                }
            })(newTr);
            return newTr;
        };
const $13f0b5f3784996ce$export$4af6b58e12324fd = ({ tr: tr })=>{
    const { subsup: subsup } = tr.doc.type.schema.marks;
    if (!subsup) // No transaction to apply
    return null;
    return (0, $fGjxM.toggleMark)(subsup, {
        type: 'sup'
    })({
        tr: tr
    });
};
const $13f0b5f3784996ce$export$ca1c98793b67ba6b = (editorAnalyticsApi)=>(inputMethod)=>({ tr: tr })=>{
            const newTr = $13f0b5f3784996ce$export$4af6b58e12324fd({
                tr: tr
            });
            if (!newTr) // No transaction to apply
            return null;
            editorAnalyticsApi === null || editorAnalyticsApi === void 0 || editorAnalyticsApi.attachAnalyticsEvent({
                action: (0, $g6Qq4.ACTION).FORMATTED,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).TEXT,
                eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).FORMAT_SUPER,
                attributes: {
                    inputMethod: inputMethod
                }
            })(newTr);
            return newTr;
        };
const $13f0b5f3784996ce$export$d26ab98fee0c804 = ({ tr: tr })=>{
    const { subsup: subsup } = tr.doc.type.schema.marks;
    if (!subsup) // No transaction to apply
    return null;
    return (0, $fGjxM.toggleMark)(subsup, {
        type: 'sub'
    })({
        tr: tr
    });
};
const $13f0b5f3784996ce$export$8d0c92ae27a193 = (editorAnalyticsApi)=>(inputMethod)=>({ tr: tr })=>{
            const newTr = $13f0b5f3784996ce$export$d26ab98fee0c804({
                tr: tr
            });
            if (!newTr) // No transaction to apply
            return null;
            editorAnalyticsApi === null || editorAnalyticsApi === void 0 || editorAnalyticsApi.attachAnalyticsEvent({
                action: (0, $g6Qq4.ACTION).FORMATTED,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).TEXT,
                eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).FORMAT_SUB,
                attributes: {
                    inputMethod: inputMethod
                }
            })(newTr);
            return newTr;
        };
const $13f0b5f3784996ce$export$70686c6e7e15ed46 = ({ api: api })=>({ tr: tr })=>{
        const { code: code } = tr.doc.type.schema.marks;
        if (!code) // No transaction to apply
        return null;
        return (0, $fAdYi.nextToggleMark)(code, api)({
            tr: tr
        });
    };
const $13f0b5f3784996ce$export$2d4f5a54f840ba91 = (editorAnalyticsApi, api)=>(inputMethod)=>({ tr: tr })=>{
            const newTr = $13f0b5f3784996ce$export$70686c6e7e15ed46({
                api: api
            })({
                tr: tr
            });
            if (!newTr) // No transaction to apply
            return null;
            editorAnalyticsApi === null || editorAnalyticsApi === void 0 || editorAnalyticsApi.attachAnalyticsEvent({
                action: (0, $g6Qq4.ACTION).FORMATTED,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).TEXT,
                eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
                actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).FORMAT_CODE,
                attributes: {
                    inputMethod: inputMethod
                }
            })(newTr);
            return newTr;
        };

});
parcelRegister("fAdYi", function(module, exports) {
$parcel$export(module.exports, "nextToggleMark", () => $0581c051d53f8c6e$export$21e1076136e25038);

var $aPnf6 = parcelRequire("aPnf6");

var $cw0wu = parcelRequire("cw0wu");

var $2E7OD = parcelRequire("2E7OD");

var $gdUUy = parcelRequire("gdUUy");
const $0581c051d53f8c6e$export$21e1076136e25038 = (markType, api, attrs)=>({ tr: tr })=>{
        const mark = markType.create(attrs);
        // For cursor selections we can use the default behaviour.
        if (tr.selection instanceof (0, $cw0wu.TextSelection) && tr.selection.$cursor) {
            if (mark.isInSet(tr.storedMarks || tr.selection.$cursor.marks())) tr.removeStoredMark(mark);
            else tr.addStoredMark(mark);
            return tr;
        }
        return $0581c051d53f8c6e$var$nextToggleMarkInRange(mark, api)({
            tr: tr
        });
    };
const $0581c051d53f8c6e$var$nextToggleMarkInRange = (mark, api)=>({ tr: tr })=>{
        if (tr.selection instanceof (0, $2E7OD.CellSelection)) {
            let removeMark = true;
            const cells = [];
            tr.selection.forEachCell((cell, cellPos)=>{
                cells.push({
                    node: cell,
                    pos: cellPos
                });
                const from = cellPos;
                const to = cellPos + cell.nodeSize;
                removeMark && (removeMark = (0, $aPnf6.entireSelectionContainsMark)(mark, tr.doc, from, to));
            });
            for(let i = cells.length - 1; i >= 0; i--){
                const cell = cells[i];
                const from = cell.pos;
                const to = from + cell.node.nodeSize;
                $0581c051d53f8c6e$export$2b94ea0e39917015(from, to, removeMark, mark, tr, api);
            }
        } else {
            const { $from: $from, $to: $to } = tr.selection;
            // We decide to remove the mark only if the entire selection contains the mark
            // Examples with *bold* text
            // Scenario 1: Selection contains both bold and non-bold text -> bold entire selection
            // Scenario 2: Selection contains only bold text -> un-bold entire selection
            // Scenario 3: Selection contains no bold text -> bold entire selection
            const removeMark = (0, $aPnf6.entireSelectionContainsMark)(mark, tr.doc, $from.pos, $to.pos);
            $0581c051d53f8c6e$export$2b94ea0e39917015($from.pos, $to.pos, removeMark, mark, tr, api);
        }
        if (tr.docChanged) return tr;
        return null;
    };
const $0581c051d53f8c6e$export$2b94ea0e39917015 = (from, to, removeMark, mark, tr, api)=>{
    const { schema: schema } = tr.doc.type;
    const { code: code } = schema.marks;
    if (mark.type === code) {
        var _api$base;
        api === null || api === void 0 || (_api$base = api.base) === null || _api$base === void 0 || (_api$base = _api$base.actions) === null || _api$base === void 0 || _api$base.resolveMarks(from, to, tr);
    }
    /**
   * We should refactor this so text formatting doesn't reference plugins it doesn't know about.
   */ tr.doc.nodesBetween(tr.mapping.map(from), tr.mapping.map(to), (node, pos)=>{
        if ((0, $gdUUy.fg)('editor_inline_comments_on_inline_nodes')) {
            if (!node.isText) {
                const isAllowedInlineNode = [
                    'emoji',
                    'status',
                    'date',
                    'mention',
                    'inlineCard'
                ].includes(node.type.name);
                if (!isAllowedInlineNode) return true;
            }
        } else {
            if (!node.isText) return true;
        }
        // This is an issue when the user selects some text.
        // We need to check if the current node position is less than the range selection from.
        // If it’s true, that means we should apply the mark using the range selection,
        // not the current node position.
        const nodeBetweenFrom = Math.max(pos, tr.mapping.map(from));
        const nodeBetweenTo = Math.min(pos + node.nodeSize, tr.mapping.map(to));
        if (removeMark) tr.removeMark(nodeBetweenFrom, nodeBetweenTo, mark);
        else tr.addMark(nodeBetweenFrom, nodeBetweenTo, mark);
        return true;
    });
    return tr;
};

});


parcelRegister("exqT2", function(module, exports) {
$parcel$export(module.exports, "pluginKey", () => $c710133ed05a1abc$export$18d4026d1ea86bb1);
$parcel$export(module.exports, "plugin", () => $c710133ed05a1abc$export$ca524d3785e2543);

var $f7Kk4 = parcelRequire("f7Kk4");

var $cw0wu = parcelRequire("cw0wu");

var $2poSi = parcelRequire("2poSi");
const $c710133ed05a1abc$export$18d4026d1ea86bb1 = new (0, $cw0wu.PluginKey)('clearFormattingPlugin');
const $c710133ed05a1abc$export$ca524d3785e2543 = (dispatch)=>new (0, $f7Kk4.SafePlugin)({
        state: {
            init (_config, state) {
                return {
                    formattingIsPresent: (0, $2poSi.checkFormattingIsPresent)(state)
                };
            },
            apply (_tr, pluginState, _oldState, newState) {
                const formattingIsPresent = (0, $2poSi.checkFormattingIsPresent)(newState);
                if (formattingIsPresent !== pluginState.formattingIsPresent) {
                    dispatch($c710133ed05a1abc$export$18d4026d1ea86bb1, {
                        formattingIsPresent: formattingIsPresent
                    });
                    return {
                        formattingIsPresent: formattingIsPresent
                    };
                }
                return pluginState;
            }
        },
        key: $c710133ed05a1abc$export$18d4026d1ea86bb1
    });

});
parcelRegister("2poSi", function(module, exports) {
$parcel$export(module.exports, "hasCode", () => $a315e0d2c223dd2d$export$435b7561880b778c);
$parcel$export(module.exports, "markActive", () => $a315e0d2c223dd2d$export$c91f8b3cbd625635);
$parcel$export(module.exports, "checkFormattingIsPresent", () => $a315e0d2c223dd2d$export$4b48a1fc423972ea);
$parcel$export(module.exports, "compareItemsArrays", () => $a315e0d2c223dd2d$export$53d327693050b221);
$parcel$export(module.exports, "isArrayContainsContent", () => $a315e0d2c223dd2d$export$f8f79f933a3fce55);

var $89hQd = parcelRequire("89hQd");

var $h2Fei = parcelRequire("h2Fei");
const $a315e0d2c223dd2d$export$435b7561880b778c = (state, pos)=>{
    const { code: code } = state.schema.marks;
    const node = pos >= 0 && state.doc.nodeAt(pos);
    if (node) return !!node.marks.filter((mark)=>mark.type === code).length;
    return false;
};
const $a315e0d2c223dd2d$export$c91f8b3cbd625635 = (state, mark)=>{
    const { from: from, to: to, empty: empty } = state.selection;
    // When the selection is empty, only the active marks apply.
    if (empty) return !!mark.isInSet(state.tr.storedMarks || state.selection.$from.marks());
    // For a non-collapsed selection, the marks on the nodes matter.
    let found = false;
    state.doc.nodesBetween(from, to, (node)=>{
        found = found || mark.isInSet(node.marks);
    });
    return found;
};
const $a315e0d2c223dd2d$var$blockStylingIsPresent = (state)=>{
    const { from: from, to: to } = state.selection;
    let isBlockStyling = false;
    state.doc.nodesBetween(from, to, (node)=>{
        if ((0, $h2Fei.FORMATTING_NODE_TYPES).indexOf(node.type.name) !== -1) {
            isBlockStyling = true;
            return false;
        }
        return true;
    });
    return isBlockStyling;
};
const $a315e0d2c223dd2d$var$marksArePresent = (state)=>{
    const activeMarkTypes = (0, $h2Fei.FORMATTING_MARK_TYPES).filter((mark)=>{
        if (!!state.schema.marks[mark]) {
            const { $from: $from, empty: empty } = state.selection;
            const { marks: marks } = state.schema;
            if (empty) return !!marks[mark].isInSet(state.storedMarks || $from.marks());
            return (0, $89hQd.anyMarkActive)(state, marks[mark]);
        }
        return false;
    });
    return activeMarkTypes.length > 0;
};
const $a315e0d2c223dd2d$export$4b48a1fc423972ea = (state)=>{
    return $a315e0d2c223dd2d$var$marksArePresent(state) || $a315e0d2c223dd2d$var$blockStylingIsPresent(state);
};
const $a315e0d2c223dd2d$export$53d327693050b221 = (items, prevItems)=>{
    return items && items.filter((item)=>!prevItems.includes(item));
};
const $a315e0d2c223dd2d$export$f8f79f933a3fce55 = (items, content)=>items.filter((item)=>item.content === content).length > 0;

});
parcelRegister("h2Fei", function(module, exports) {
$parcel$export(module.exports, "FORMATTING_NODE_TYPES", () => $8bb2699a79e6cd80$export$a5cb0c20bd02ce0c);
$parcel$export(module.exports, "FORMATTING_MARK_TYPES", () => $8bb2699a79e6cd80$export$73b50f8f13648c71);
$parcel$export(module.exports, "clearFormattingWithAnalytics", () => $8bb2699a79e6cd80$export$332a1f720fc2ba0);
$parcel$export(module.exports, "clearFormattingWithAnalyticsNext", () => $8bb2699a79e6cd80$export$38c6848f9e966bd5);

var $g6Qq4 = parcelRequire("g6Qq4");

var $3DNV7 = parcelRequire("3DNV7");

var $2E7OD = parcelRequire("2E7OD");

var $lTuEc = parcelRequire("lTuEc");
const $8bb2699a79e6cd80$export$a5cb0c20bd02ce0c = [
    'heading',
    'blockquote'
];
const $8bb2699a79e6cd80$export$73b50f8f13648c71 = [
    'em',
    'code',
    'strike',
    'strong',
    'underline',
    'textColor',
    'subsup',
    'backgroundColor'
];
const $8bb2699a79e6cd80$var$formatTypes = {
    em: (0, $g6Qq4.ACTION_SUBJECT_ID).FORMAT_ITALIC,
    code: (0, $g6Qq4.ACTION_SUBJECT_ID).FORMAT_CODE,
    strike: (0, $g6Qq4.ACTION_SUBJECT_ID).FORMAT_STRIKE,
    strong: (0, $g6Qq4.ACTION_SUBJECT_ID).FORMAT_STRONG,
    underline: (0, $g6Qq4.ACTION_SUBJECT_ID).FORMAT_UNDERLINE,
    textColor: (0, $g6Qq4.ACTION_SUBJECT_ID).FORMAT_COLOR,
    subsup: 'subsup',
    backgroundColor: (0, $g6Qq4.ACTION_SUBJECT_ID).FORMAT_BACKGROUND_COLOR
};
function $8bb2699a79e6cd80$export$332a1f720fc2ba0(inputMethod, editorAnalyticsAPI) {
    return $8bb2699a79e6cd80$export$195de5d8e201efd7(inputMethod, editorAnalyticsAPI);
}
const $8bb2699a79e6cd80$var$clearNodeFormattingOnSelectionNext = (schema, tr, formattedNodeType, nodeName, formattingCleared)=>{
    return function(node, pos) {
        if (node.type === formattedNodeType) {
            if (formattedNodeType.isTextblock) {
                tr.setNodeMarkup(pos, schema.nodes.paragraph);
                formattingCleared.push(nodeName);
                return false;
            } else {
                // In case of panel or blockquote
                const fromPos = tr.doc.resolve(pos + 1);
                const toPos = tr.doc.resolve(pos + node.nodeSize - 1);
                const nodeRange = fromPos.blockRange(toPos);
                if (nodeRange) {
                    const targetLiftDepth = (0, $3DNV7.liftTarget)(nodeRange);
                    if (targetLiftDepth || targetLiftDepth === 0) {
                        formattingCleared.push(nodeName);
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        tr.lift(nodeRange, targetLiftDepth);
                    }
                }
            }
        }
        return true;
    };
};
function $8bb2699a79e6cd80$var$clearNodeFormattingOnSelection(state, tr, formattedNodeType, nodeName, formattingCleared) {
    return function(node, pos) {
        if (node.type === formattedNodeType) {
            if (formattedNodeType.isTextblock) {
                tr.setNodeMarkup(pos, state.schema.nodes.paragraph);
                formattingCleared.push(nodeName);
                return false;
            } else {
                // In case of panel or blockquote
                const fromPos = tr.doc.resolve(pos + 1);
                const toPos = tr.doc.resolve(pos + node.nodeSize - 1);
                const nodeRange = fromPos.blockRange(toPos);
                if (nodeRange) {
                    const targetLiftDepth = (0, $3DNV7.liftTarget)(nodeRange);
                    if (targetLiftDepth || targetLiftDepth === 0) {
                        formattingCleared.push(nodeName);
                        // Ignored via go/ees005
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        tr.lift(nodeRange, targetLiftDepth);
                    }
                }
            }
        }
        return true;
    };
}
function $8bb2699a79e6cd80$export$195de5d8e201efd7(inputMethod, editorAnalyticsAPI) {
    return function(state, dispatch) {
        const { tr: tr } = state;
        const formattingCleared = [];
        $8bb2699a79e6cd80$export$73b50f8f13648c71.forEach((mark)=>{
            const { from: from, to: to } = tr.selection;
            const markType = state.schema.marks[mark];
            if (!markType) return;
            if (tr.selection instanceof (0, $2E7OD.CellSelection)) (0, $lTuEc.cellSelectionNodesBetween)(tr.selection, tr.doc, (node, pos)=>{
                const isTableCell = node.type === state.schema.nodes.tableCell || node.type === state.schema.nodes.tableHeader;
                if (!isTableCell) return true;
                if (tr.doc.rangeHasMark(pos, pos + node.nodeSize, markType)) {
                    formattingCleared.push($8bb2699a79e6cd80$var$formatTypes[mark]);
                    tr.removeMark(pos, pos + node.nodeSize, markType);
                }
                return false;
            });
            else if (tr.doc.rangeHasMark(from, to, markType)) {
                formattingCleared.push($8bb2699a79e6cd80$var$formatTypes[mark]);
                tr.removeMark(from, to, markType);
            }
        });
        $8bb2699a79e6cd80$export$a5cb0c20bd02ce0c.forEach((nodeName)=>{
            const formattedNodeType = state.schema.nodes[nodeName];
            const { $from: $from, $to: $to } = tr.selection;
            if (tr.selection instanceof (0, $2E7OD.CellSelection)) (0, $lTuEc.cellSelectionNodesBetween)(tr.selection, tr.doc, $8bb2699a79e6cd80$var$clearNodeFormattingOnSelection(state, tr, formattedNodeType, nodeName, formattingCleared));
            else tr.doc.nodesBetween($from.pos, $to.pos, $8bb2699a79e6cd80$var$clearNodeFormattingOnSelection(state, tr, formattedNodeType, nodeName, formattingCleared));
        });
        tr.setStoredMarks([]);
        if (formattingCleared.length && inputMethod) editorAnalyticsAPI === null || editorAnalyticsAPI === void 0 || editorAnalyticsAPI.attachAnalyticsEvent({
            action: (0, $g6Qq4.ACTION).FORMATTED,
            eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).TEXT,
            actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).FORMAT_CLEAR,
            attributes: {
                inputMethod: inputMethod,
                formattingCleared: formattingCleared,
                dropdownMenu: inputMethod === (0, $g6Qq4.INPUT_METHOD).TOOLBAR || inputMethod === (0, $g6Qq4.INPUT_METHOD).FLOATING_TB ? 'textFormatting' : undefined
            }
        })(tr);
        if (dispatch) dispatch(tr);
        return true;
    };
}
const $8bb2699a79e6cd80$export$38c6848f9e966bd5 = (editorAnalyticsApi)=>(inputMethod)=>({ tr: tr })=>{
            const formattingCleared = [];
            const { schema: schema } = tr.doc.type;
            $8bb2699a79e6cd80$export$73b50f8f13648c71.forEach((mark)=>{
                const { from: from, to: to } = tr.selection;
                const markType = schema.marks[mark];
                if (!markType) return;
                if (tr.selection instanceof (0, $2E7OD.CellSelection)) (0, $lTuEc.cellSelectionNodesBetween)(tr.selection, tr.doc, (node, pos)=>{
                    const isTableCell = node.type === tr.doc.type.schema.nodes.tableCell || node.type === schema.nodes.tableHeader;
                    if (!isTableCell) return true;
                    if (tr.doc.rangeHasMark(pos, pos + node.nodeSize, markType)) {
                        formattingCleared.push($8bb2699a79e6cd80$var$formatTypes[mark]);
                        tr.removeMark(pos, pos + node.nodeSize, markType);
                    }
                    return false;
                });
                else if (tr.doc.rangeHasMark(from, to, markType)) {
                    formattingCleared.push($8bb2699a79e6cd80$var$formatTypes[mark]);
                    tr.removeMark(from, to, markType);
                }
            });
            $8bb2699a79e6cd80$export$a5cb0c20bd02ce0c.forEach((nodeName)=>{
                const formattedNodeType = schema.nodes[nodeName];
                const { $from: $from, $to: $to } = tr.selection;
                if (tr.selection instanceof (0, $2E7OD.CellSelection)) (0, $lTuEc.cellSelectionNodesBetween)(tr.selection, tr.doc, $8bb2699a79e6cd80$var$clearNodeFormattingOnSelectionNext(schema, tr, formattedNodeType, nodeName, formattingCleared));
                else tr.doc.nodesBetween($from.pos, $to.pos, $8bb2699a79e6cd80$var$clearNodeFormattingOnSelectionNext(schema, tr, formattedNodeType, nodeName, formattingCleared));
            });
            tr.setStoredMarks([]);
            if (formattingCleared.length && inputMethod) editorAnalyticsApi === null || editorAnalyticsApi === void 0 || editorAnalyticsApi.attachAnalyticsEvent({
                action: (0, $g6Qq4.ACTION).FORMATTED,
                eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).TEXT,
                actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).FORMAT_CLEAR,
                attributes: {
                    inputMethod: inputMethod,
                    formattingCleared: formattingCleared,
                    dropdownMenu: inputMethod === (0, $g6Qq4.INPUT_METHOD).TOOLBAR || inputMethod === (0, $g6Qq4.INPUT_METHOD).FLOATING_TB ? 'textFormatting' : undefined
                }
            })(tr);
            return tr;
        };

});
parcelRegister("lTuEc", function(module, exports) {
$parcel$export(module.exports, "cellSelectionNodesBetween", () => $bf35db07ae79545b$export$bd443c1dba3019b8);
const $bf35db07ae79545b$export$bd443c1dba3019b8 = (selection, doc, f, startPos)=>{
    selection.forEachCell((cell, cellPos)=>{
        doc.nodesBetween(cellPos, cellPos + cell.nodeSize, f, startPos);
    });
};

});




parcelRegister("6eMA2", function(module, exports) {
$parcel$export(module.exports, "default", () => $3d71a6b1cb813ddc$export$2e2bcd8739ae039);

var $g6Qq4 = parcelRequire("g6Qq4");

var $cv8id = parcelRequire("cv8id");

var $ejrfk = parcelRequire("ejrfk");

var $h2Fei = parcelRequire("h2Fei");
function $3d71a6b1cb813ddc$export$e832373cff8dec22(editorAnalyticsAPI) {
    const list = {};
    (0, $cv8id.bindKeymapWithEditorCommand)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $cv8id.findShortcutByKeymap)((0, $cv8id.clearFormatting)), (0, $h2Fei.clearFormattingWithAnalyticsNext)(editorAnalyticsAPI)((0, $g6Qq4.INPUT_METHOD).SHORTCUT), list);
    return (0, $ejrfk.keymap)(list);
}
var $3d71a6b1cb813ddc$export$2e2bcd8739ae039 = $3d71a6b1cb813ddc$export$e832373cff8dec22;

});

parcelRegister("9u9Eq", function(module, exports) {
$parcel$export(module.exports, "default", () => $6ee046dd0c9ee76a$export$2e2bcd8739ae039);

var $f7Kk4 = parcelRequire("f7Kk4");

var $cw0wu = parcelRequire("cw0wu");
// Don't apply in Edge as per ED-4546
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $6ee046dd0c9ee76a$var$EDGE_USER_AGENT_REGEX = /Edge\/\d/;
// eslint-disable-next-line import/no-anonymous-default-export
const $6ee046dd0c9ee76a$var$_default_1 = new (0, $f7Kk4.SafePlugin)({
    props: {
        handleClick (view, clickPos, event) {
            // Don't apply in Edge as per ED-4546
            if (navigator && $6ee046dd0c9ee76a$var$EDGE_USER_AGENT_REGEX.test(navigator.userAgent)) return false;
            // @see ED-6231
            if (clickPos > view.state.doc.content.size) return false;
            const { code: code } = view.state.schema.marks;
            const { paragraph: paragraph } = view.state.schema.nodes;
            const $click = view.state.doc.resolve(clickPos);
            const clickWasAtEdgeOfATextNode = ($click.nodeBefore ? $click.nodeBefore.isInline : $click.nodeAfter) && ($click.nodeAfter ? $click.nodeAfter.isInline : $click.nodeBefore) && $click.textOffset === 0;
            const clickWasNearACodeMark = code && ($click.nodeBefore && code.isInSet($click.nodeBefore.marks) || $click.nodeAfter && code.isInSet($click.nodeAfter.marks));
            // Find the starting position of the clicked dom-element
            // TODO: ED-26962 - Remove calls to private API
            const clickedDOMElementPosition = event.target && event.target instanceof Node && view.posAtDOM(event.target);
            const clickNode = view.state.doc.nodeAt(clickPos);
            const clickWasAtTextNode = !!(clickNode && clickNode.isText);
            const clickWasAtEndOfAParagraphNode = $click.parent.type === paragraph && $click.textOffset === 0 && $click.nodeAfter === null;
            if (clickWasAtEdgeOfATextNode && clickWasNearACodeMark && clickedDOMElementPosition && // if click did not occur at a text node or end of paragraph, then
            // it was at a directly adjacent non-text node, so we skip this manual
            // text selection logic to preserve that non-text node's selection
            (clickWasAtTextNode || clickWasAtEndOfAParagraphNode)) {
                const clickWasInsideNodeDOM = event.target.parentNode === view.domAtPos(clickedDOMElementPosition).node && // Ignored via go/ees005
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                code.isInSet(view.state.doc.resolve(clickedDOMElementPosition).nodeAfter.marks);
                const nodeNextToClick = $click.nodeBefore && code.isInSet($click.nodeBefore.marks) ? $click.nodeAfter : $click.nodeBefore;
                // Need to set the selection here to allow clicking between [code('text'),{<>},emoji()]
                const tr = view.state.tr.setSelection((0, $cw0wu.TextSelection).near($click));
                if (clickWasInsideNodeDOM) tr.setStoredMarks([
                    code.create()
                ]);
                else tr.setStoredMarks(nodeNextToClick ? nodeNextToClick.marks : []);
                view.dispatch(tr);
                return true;
            }
            return false;
        }
    }
});
var $6ee046dd0c9ee76a$export$2e2bcd8739ae039 = $6ee046dd0c9ee76a$var$_default_1;

});

parcelRegister("6hkdO", function(module, exports) {
$parcel$export(module.exports, "default", () => $0470d876d6eac22c$export$2e2bcd8739ae039);

var $g6Qq4 = parcelRequire("g6Qq4");

var $f7Kk4 = parcelRequire("f7Kk4");

var $33v8M = parcelRequire("33v8M");

var $hfNS8 = parcelRequire("hfNS8");

var $b9BdF = parcelRequire("b9BdF");

var $8t09p = parcelRequire("8t09p");

var $5N1Y4 = parcelRequire("5N1Y4");
var $0470d876d6eac22c$var$ValidAutoformatChars = /*#__PURE__*/ function(ValidAutoformatChars) {
    ValidAutoformatChars["STRONG"] = "__";
    ValidAutoformatChars["STRIKE"] = "~~";
    ValidAutoformatChars["STRONG_MARKDOWN"] = "**";
    ValidAutoformatChars["ITALIC_MARKDOWN"] = "*";
    ValidAutoformatChars["ITALIC"] = "_";
    ValidAutoformatChars["CODE"] = "`";
    return ValidAutoformatChars;
}($0470d876d6eac22c$var$ValidAutoformatChars || {});
const $0470d876d6eac22c$export$ab511c819612d3bc = {
    ["~~"]: [
        "_",
        "__",
        "**",
        "*"
    ],
    ["__"]: [
        "~~",
        "*"
    ],
    ["**"]: [
        "_",
        "~~"
    ],
    ["*"]: [
        "~~",
        "__"
    ],
    ["_"]: [
        "~~",
        "**"
    ],
    ["`"]: [
        // e.g: loko (`some code`
        '( '
    ]
};
function $0470d876d6eac22c$var$addMark(markType, _schema, char, api) {
    return (state, _match, start, end)=>{
        var _schema$marks;
        const { doc: doc, schema: schema, tr: tr } = state;
        const textPrefix = state.doc.textBetween(start, start + char.length);
        // fixes the following case: my `*name` is *
        // expected result: should ignore special characters inside "code"
        if (textPrefix !== char || schema !== null && schema !== void 0 && (_schema$marks = schema.marks) !== null && _schema$marks !== void 0 && (_schema$marks = _schema$marks.code) !== null && _schema$marks !== void 0 && _schema$marks.isInSet(doc.resolve(start + 1).marks())) {
            if (!(0, $5N1Y4.expValEquals)('platform_editor_lovability_inline_code', 'isEnabled', true)) return null;
            // if the prefix is not a character but the suffix is, continue
            const suffix = state.doc.textBetween(end - char.length, end);
            if (suffix !== char) return null;
        }
        // Prevent autoformatting across hardbreaks
        let containsHardBreak;
        doc.nodesBetween(start, end, (node)=>{
            if (node.type === schema.nodes.hardBreak) {
                containsHardBreak = true;
                return false;
            }
            return !containsHardBreak;
        });
        if (containsHardBreak) return null;
        // fixes autoformatting in heading nodes: # Heading *bold*
        // expected result: should not autoformat *bold*; <h1>Heading *bold*</h1>
        const startPosResolved = doc.resolve(start);
        const endPosResolved = doc.resolve(end);
        if (startPosResolved.sameParent(endPosResolved) && !startPosResolved.parent.type.allowsMarkType(markType)) return null;
        if (markType.name === 'code') {
            var _api$base;
            api === null || api === void 0 || (_api$base = api.base) === null || _api$base === void 0 || (_api$base = _api$base.actions) === null || _api$base === void 0 || _api$base.resolveMarks(tr.mapping.map(start), tr.mapping.map(end), tr);
        }
        const mappedStart = tr.mapping.map(start);
        const mappedEnd = tr.mapping.map(end);
        tr.addMark(mappedStart, mappedEnd, markType.create());
        const textSuffix = tr.doc.textBetween(mappedEnd - char.length, mappedEnd);
        if (textSuffix === char) tr.delete(mappedEnd - char.length, mappedEnd);
        if (textPrefix === char) tr.delete(mappedStart, mappedStart + char.length);
        return tr.removeStoredMark(markType);
    };
}
class $0470d876d6eac22c$var$ReverseRegexExp extends RegExp {
    exec(str) {
        if (!str) return null;
        const reverseStr = [
            ...str
        ].reverse().join('');
        const result = super.exec(reverseStr);
        if (!result) return null;
        for(let i = 0; i < result.length; i++)if (result[i] && typeof result[i] === 'string') result[i] = [
            ...result[i]
        ].reverse().join('');
        if (result.input && typeof result.input === 'string') result.input = [
            ...result.input
        ].reverse().join('');
        if (result.input && result[0]) result.index = result.input.length - result[0].length;
        return result;
    }
}
const $0470d876d6eac22c$var$buildRegex = (char)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const escapedChar = char.replace(/(\W)/g, '\\$1');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp, @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
    const combinations = $0470d876d6eac22c$export$ab511c819612d3bc[char].map((c)=>c.replace(/(\W)/g, '\\$1')).join('|');
    // Single X - https://regex101.com/r/McT3yq/14/
    // Double X - https://regex101.com/r/pQUgjx/1/
    const baseRegex = '^X(?=[^X\\s]).*?[^\\sX]X(?=[\\sOBJECT_REPLACEMENT_CHARACTER]COMBINATIONS|$)'.replace('OBJECT_REPLACEMENT_CHARACTER', (0, $b9BdF.leafNodeReplacementCharacter)).replace('COMBINATIONS', combinations ? `|${combinations}` : '');
    const replacedRegex = String.prototype.hasOwnProperty('replaceAll') ? // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    baseRegex.replaceAll('X', escapedChar) : // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    baseRegex.replace(/X/g, escapedChar);
    return new $0470d876d6eac22c$var$ReverseRegexExp(replacedRegex);
};
const $0470d876d6eac22c$var$buildRegexNew = (char, allowsBackwardMatch = false)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    const escapedChar = char.replace(/(\W)/g, '\\$1');
    // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp, @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
    const combinations = $0470d876d6eac22c$export$ab511c819612d3bc[char].map((c)=>c.replace(/(\W)/g, '\\$1')).join('|');
    // Single X - https://regex101.com/r/McT3yq/14/
    // Double X - https://regex101.com/r/pQUgjx/1/
    // if backwards matches are allowed, do not prefix the regex with an anchor (^)
    const maybeAnchor = allowsBackwardMatch ? '' : '^';
    const orCombinations = combinations ? `|${combinations}` : '';
    const baseRegex = `${maybeAnchor}X(?=[^X\\s]).*?[^\\sX]X(?=[\\s${(0, $b9BdF.leafNodeReplacementCharacter)}]${orCombinations}|$)`;
    const replacedRegex = String.prototype.hasOwnProperty('replaceAll') ? // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    baseRegex.replaceAll('X', escapedChar) : // Ignored via go/ees005
    // eslint-disable-next-line require-unicode-regexp
    baseRegex.replace(/X/g, escapedChar);
    return new $0470d876d6eac22c$var$ReverseRegexExp(replacedRegex);
};
const $0470d876d6eac22c$export$3312a15c47701971 = $0470d876d6eac22c$var$buildRegex("__");
const $0470d876d6eac22c$export$b2c5e5dc4b85ebff = $0470d876d6eac22c$var$buildRegex("**");
const $0470d876d6eac22c$export$5293ac529581c0f9 = $0470d876d6eac22c$var$buildRegex("_");
const $0470d876d6eac22c$export$bef0fedfe2c8027e = $0470d876d6eac22c$var$buildRegex("*");
const $0470d876d6eac22c$export$6dd2d2a62884fadf = $0470d876d6eac22c$var$buildRegex("~~");
const $0470d876d6eac22c$export$b311ac3b6caef479 = $0470d876d6eac22c$var$buildRegex("`");
const $0470d876d6eac22c$export$6e92f28cddbb8b0c = $0470d876d6eac22c$var$buildRegexNew("`", true);
/**
 * Create input rules for strong mark
 *
 * @param {Schema} schema
 * @returns {InputRuleWrapper[]}
 */ function $0470d876d6eac22c$var$getStrongInputRules(schema, editorAnalyticsAPI) {
    const ruleWithStrongAnalytics = (0, $hfNS8.inputRuleWithAnalytics)({
        action: (0, $g6Qq4.ACTION).FORMATTED,
        actionSubject: (0, $g6Qq4.ACTION_SUBJECT).TEXT,
        actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).FORMAT_STRONG,
        eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
        attributes: {
            inputMethod: (0, $g6Qq4.INPUT_METHOD).FORMATTING
        }
    }, editorAnalyticsAPI);
    // **string** or __strong__ should bold the text
    const doubleUnderscoreRule = (0, $33v8M.createRule)($0470d876d6eac22c$export$3312a15c47701971, $0470d876d6eac22c$var$addMark(schema.marks.strong, schema, "__"));
    const doubleAsterixRule = (0, $33v8M.createRule)($0470d876d6eac22c$export$b2c5e5dc4b85ebff, $0470d876d6eac22c$var$addMark(schema.marks.strong, schema, "**"));
    return [
        ruleWithStrongAnalytics(doubleUnderscoreRule),
        ruleWithStrongAnalytics(doubleAsterixRule)
    ];
}
/**
 * Create input rules for em mark
 *
 * @param {Schema} schema
 * @returns {InputRuleWrapper[]}
 */ function $0470d876d6eac22c$var$getItalicInputRules(schema, editorAnalyticsAPI) {
    const ruleWithItalicAnalytics = (0, $hfNS8.inputRuleWithAnalytics)({
        action: (0, $g6Qq4.ACTION).FORMATTED,
        actionSubject: (0, $g6Qq4.ACTION_SUBJECT).TEXT,
        actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).FORMAT_ITALIC,
        eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
        attributes: {
            inputMethod: (0, $g6Qq4.INPUT_METHOD).FORMATTING
        }
    }, editorAnalyticsAPI);
    const underscoreRule = (0, $33v8M.createRule)($0470d876d6eac22c$export$5293ac529581c0f9, $0470d876d6eac22c$var$addMark(schema.marks.em, schema, "_"));
    const asterixRule = (0, $33v8M.createRule)($0470d876d6eac22c$export$bef0fedfe2c8027e, $0470d876d6eac22c$var$addMark(schema.marks.em, schema, "*"));
    return [
        ruleWithItalicAnalytics(underscoreRule),
        ruleWithItalicAnalytics(asterixRule)
    ];
}
/**
 * Create input rules for strike mark
 *
 * @param {Schema} schema
 * @returns {InputRuleWrapper[]}
 */ function $0470d876d6eac22c$var$getStrikeInputRules(schema, editorAnalyticsAPI) {
    const ruleWithStrikeAnalytics = (0, $hfNS8.inputRuleWithAnalytics)({
        action: (0, $g6Qq4.ACTION).FORMATTED,
        actionSubject: (0, $g6Qq4.ACTION_SUBJECT).TEXT,
        actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).FORMAT_STRIKE,
        eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
        attributes: {
            inputMethod: (0, $g6Qq4.INPUT_METHOD).FORMATTING
        }
    }, editorAnalyticsAPI);
    const doubleTildeRule = (0, $33v8M.createRule)($0470d876d6eac22c$export$6dd2d2a62884fadf, $0470d876d6eac22c$var$addMark(schema.marks.strike, schema, "~~"));
    return [
        ruleWithStrikeAnalytics(doubleTildeRule)
    ];
}
/**
 * Create input rules for code mark
 *
 * @param {Schema} schema
 * @returns {InputRuleWrapper[]}
 */ function $0470d876d6eac22c$var$getCodeInputRules(schema, editorAnalyticsAPI, api) {
    const ruleWithCodeAnalytics = (0, $hfNS8.inputRuleWithAnalytics)({
        action: (0, $g6Qq4.ACTION).FORMATTED,
        actionSubject: (0, $g6Qq4.ACTION_SUBJECT).TEXT,
        actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).FORMAT_CODE,
        eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
        attributes: {
            inputMethod: (0, $g6Qq4.INPUT_METHOD).FORMATTING
        }
    }, editorAnalyticsAPI);
    const allowsBackwardMatch = (0, $5N1Y4.expValEquals)('platform_editor_lovability_inline_code', 'isEnabled', true);
    const backTickRule = (0, $33v8M.createRule)(allowsBackwardMatch ? $0470d876d6eac22c$export$6e92f28cddbb8b0c : $0470d876d6eac22c$export$b311ac3b6caef479, $0470d876d6eac22c$var$addMark(schema.marks.code, schema, "`", api), allowsBackwardMatch);
    return [
        ruleWithCodeAnalytics(backTickRule)
    ];
}
function $0470d876d6eac22c$export$568a7ed6897c4817(schema, editorAnalyticsAPI, api) {
    const rules = [];
    if (schema.marks.strong) rules.push(...$0470d876d6eac22c$var$getStrongInputRules(schema, editorAnalyticsAPI));
    if (schema.marks.em) rules.push(...$0470d876d6eac22c$var$getItalicInputRules(schema, editorAnalyticsAPI));
    if (schema.marks.strike) rules.push(...$0470d876d6eac22c$var$getStrikeInputRules(schema, editorAnalyticsAPI));
    if (schema.marks.code) rules.push(...$0470d876d6eac22c$var$getCodeInputRules(schema, editorAnalyticsAPI, api));
    if (rules.length !== 0) return new (0, $f7Kk4.SafePlugin)((0, $8t09p.createPlugin)('text-formatting', rules));
    return;
}
var $0470d876d6eac22c$export$2e2bcd8739ae039 = $0470d876d6eac22c$export$568a7ed6897c4817;

});

parcelRegister("eIuNw", function(module, exports) {
$parcel$export(module.exports, "default", () => $1c7d6c38c6259aeb$export$2e2bcd8739ae039);

var $g6Qq4 = parcelRequire("g6Qq4");

var $cv8id = parcelRequire("cv8id");

var $f7Kk4 = parcelRequire("f7Kk4");

var $ejrfk = parcelRequire("ejrfk");

var $797yE = parcelRequire("797yE");

var $5jSEp = parcelRequire("5jSEp");

var $0qvtE = parcelRequire("0qvtE");
function $1c7d6c38c6259aeb$export$2e2bcd8739ae039(schema, editorAnalyticsAPI) {
    const list = {};
    if (schema.marks.strong) (0, $cv8id.bindKeymapWithEditorCommand)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $cv8id.findShortcutByKeymap)((0, $cv8id.toggleBold)), (0, $5jSEp.toggleStrongWithAnalytics)(editorAnalyticsAPI)((0, $g6Qq4.INPUT_METHOD).SHORTCUT), list);
    if (schema.marks.em) (0, $cv8id.bindKeymapWithEditorCommand)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $cv8id.findShortcutByKeymap)((0, $cv8id.toggleItalic)), (0, $5jSEp.toggleEmWithAnalytics)(editorAnalyticsAPI)((0, $g6Qq4.INPUT_METHOD).SHORTCUT), list);
    if (schema.marks.code) (0, $cv8id.bindKeymapWithEditorCommand)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $cv8id.findShortcutByKeymap)((0, $cv8id.toggleCode)), (0, $5jSEp.toggleCodeWithAnalytics)(editorAnalyticsAPI)((0, $g6Qq4.INPUT_METHOD).SHORTCUT), list);
    if (schema.marks.strike) (0, $cv8id.bindKeymapWithEditorCommand)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $cv8id.findShortcutByKeymap)((0, $cv8id.toggleStrikethrough)), (0, $5jSEp.toggleStrikeWithAnalytics)(editorAnalyticsAPI)((0, $g6Qq4.INPUT_METHOD).SHORTCUT), list);
    if (schema.marks.subsup) (0, $cv8id.bindKeymapWithEditorCommand)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $cv8id.findShortcutByKeymap)((0, $cv8id.toggleSubscript)), (0, $5jSEp.toggleSubscriptWithAnalytics)(editorAnalyticsAPI)((0, $g6Qq4.INPUT_METHOD).SHORTCUT), list);
    if (schema.marks.subsup) (0, $cv8id.bindKeymapWithEditorCommand)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $cv8id.findShortcutByKeymap)((0, $cv8id.toggleSuperscript)), (0, $5jSEp.toggleSuperscriptWithAnalytics)(editorAnalyticsAPI)((0, $g6Qq4.INPUT_METHOD).SHORTCUT), list);
    if (schema.marks.underline) (0, $cv8id.bindKeymapWithEditorCommand)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $cv8id.findShortcutByKeymap)((0, $cv8id.toggleUnderline)), (0, $5jSEp.toggleUnderlineWithAnalytics)(editorAnalyticsAPI)((0, $g6Qq4.INPUT_METHOD).SHORTCUT), list);
    const getEnabledKeylist = (view)=>{
        const textFormattingState = (0, $0qvtE.pluginKey).getState(view.state);
        const list = {};
        if (schema.marks.strong && !(textFormattingState !== null && textFormattingState !== void 0 && textFormattingState.strongDisabled)) (0, $cv8id.bindKeymapWithEditorCommand)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $cv8id.findShortcutByKeymap)((0, $cv8id.toggleBold)), (0, $5jSEp.toggleStrongWithAnalytics)(editorAnalyticsAPI)((0, $g6Qq4.INPUT_METHOD).SHORTCUT), list);
        if (schema.marks.em && !(textFormattingState !== null && textFormattingState !== void 0 && textFormattingState.emDisabled)) (0, $cv8id.bindKeymapWithEditorCommand)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $cv8id.findShortcutByKeymap)((0, $cv8id.toggleItalic)), (0, $5jSEp.toggleEmWithAnalytics)(editorAnalyticsAPI)((0, $g6Qq4.INPUT_METHOD).SHORTCUT), list);
        if (schema.marks.code && !(textFormattingState !== null && textFormattingState !== void 0 && textFormattingState.codeDisabled)) (0, $cv8id.bindKeymapWithEditorCommand)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $cv8id.findShortcutByKeymap)((0, $cv8id.toggleCode)), (0, $5jSEp.toggleCodeWithAnalytics)(editorAnalyticsAPI)((0, $g6Qq4.INPUT_METHOD).SHORTCUT), list);
        if (schema.marks.strike && !(textFormattingState !== null && textFormattingState !== void 0 && textFormattingState.strikeDisabled)) (0, $cv8id.bindKeymapWithEditorCommand)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $cv8id.findShortcutByKeymap)((0, $cv8id.toggleStrikethrough)), (0, $5jSEp.toggleStrikeWithAnalytics)(editorAnalyticsAPI)((0, $g6Qq4.INPUT_METHOD).SHORTCUT), list);
        if (schema.marks.subsup && !(textFormattingState !== null && textFormattingState !== void 0 && textFormattingState.subscriptDisabled)) (0, $cv8id.bindKeymapWithEditorCommand)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $cv8id.findShortcutByKeymap)((0, $cv8id.toggleSubscript)), (0, $5jSEp.toggleSubscriptWithAnalytics)(editorAnalyticsAPI)((0, $g6Qq4.INPUT_METHOD).SHORTCUT), list);
        if (schema.marks.subsup && !(textFormattingState !== null && textFormattingState !== void 0 && textFormattingState.superscriptDisabled)) (0, $cv8id.bindKeymapWithEditorCommand)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $cv8id.findShortcutByKeymap)((0, $cv8id.toggleSuperscript)), (0, $5jSEp.toggleSuperscriptWithAnalytics)(editorAnalyticsAPI)((0, $g6Qq4.INPUT_METHOD).SHORTCUT), list);
        if (schema.marks.underline && !(textFormattingState !== null && textFormattingState !== void 0 && textFormattingState.underlineDisabled)) (0, $cv8id.bindKeymapWithEditorCommand)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (0, $cv8id.findShortcutByKeymap)((0, $cv8id.toggleUnderline)), (0, $5jSEp.toggleUnderlineWithAnalytics)(editorAnalyticsAPI)((0, $g6Qq4.INPUT_METHOD).SHORTCUT), list);
        return list;
    };
    return new (0, $f7Kk4.SafePlugin)({
        props: {
            handleKeyDown (view, event) {
                const keyboardEvent = (0, $cv8id.isCapsLockOnAndModifyKeyboardEvent)(event);
                const keymapList = (0, $797yE.editorExperiment)('platform_editor_controls', 'variant1') ? getEnabledKeylist(view) : list;
                return (0, $ejrfk.keydownHandler)(keymapList)(view, keyboardEvent);
            }
        }
    });
}

});
parcelRegister("0qvtE", function(module, exports) {
$parcel$export(module.exports, "pluginKey", () => $97c272633685c4f0$export$18d4026d1ea86bb1);

var $cw0wu = parcelRequire("cw0wu");
const $97c272633685c4f0$export$18d4026d1ea86bb1 = new (0, $cw0wu.PluginKey)('textFormatting');

});


parcelRegister("fv1GT", function(module, exports) {
$parcel$export(module.exports, "plugin", () => $e5d76801e17201ab$export$ca524d3785e2543);
// TODO: ED-26962 - Ideally this should use the custom toggleMark function from @atlaskit/editor-common so we also disable the options when selecting inline nodes but it disables the marks when the selection is empty at this point in time which is undesirable
// import { toggleMark } from '@atlaskit/editor-common/mark';

var $cv8id = parcelRequire("cv8id");

var $89hQd = parcelRequire("89hQd");

var $jRjUc = parcelRequire("jRjUc");

var $f7Kk4 = parcelRequire("f7Kk4");

var $56AB9 = parcelRequire("56AB9");

var $5FzRL = parcelRequire("5FzRL");

var $kW8qW = parcelRequire("kW8qW");

var $cw0wu = parcelRequire("cw0wu");

var $797yE = parcelRequire("797yE");

var $cSBFu = parcelRequire("cSBFu");

var $0qvtE = parcelRequire("0qvtE");
const $e5d76801e17201ab$var$isSelectionInlineCursor = (selection)=>{
    if (selection instanceof (0, $cw0wu.NodeSelection)) return true;
    return false;
};
const $e5d76801e17201ab$var$checkNodeSelection = (mark, editorState, type)=>{
    const selection = editorState.selection;
    if ($e5d76801e17201ab$var$isSelectionInlineCursor(selection)) return false;
    return (0, $5FzRL.toggleMark)(mark, {
        type: type
    })(editorState);
};
const $e5d76801e17201ab$var$getTextFormattingState = (editorState, _editorAnalyticsAPI)=>{
    const { em: em, code: code, strike: strike, strong: strong, subsup: subsup, underline: underline } = editorState.schema.marks;
    const state = {
        isInitialised: true
    };
    const showOnlyCommonMarks = (0, $797yE.editorExperiment)('platform_editor_controls', 'variant1', {
        exposure: true
    });
    if (showOnlyCommonMarks) {
        // Code marks will disable all other formatting options when they are included in a
        // selection but (for now) we do not want to make it behave differently in regards to which
        // toolbar items are highlighted on selection. We need to track code in selection seperately
        // to ensure all other formatting options are disabled appropriately.
        if (code) state.codeInSelection = (0, $89hQd.anyMarkActive)(editorState, code.create());
        const marks = [
            [
                code,
                'code'
            ],
            [
                em,
                'em'
            ],
            [
                strike,
                'strike'
            ],
            [
                strong,
                'strong'
            ],
            [
                underline,
                'underline'
            ],
            [
                subsup === null || subsup === void 0 ? void 0 : subsup.create({
                    type: 'sub'
                }),
                'subscript'
            ],
            [
                subsup === null || subsup === void 0 ? void 0 : subsup.create({
                    type: 'sup'
                }),
                'superscript'
            ]
        ].filter(([mark])=>mark);
        const marksToName = new Map(marks);
        const activeMarks = (0, $jRjUc.wholeSelectionHasMarks)(editorState, Array.from(marksToName.keys()));
        for (const [mark, markName] of marks){
            const active = activeMarks.get(mark);
            if (active !== undefined) state[`${markName}Active`] = active;
            state[`${markName}Disabled`] = // Disable when code is active, except for code itself which should not be disabled
            // when code is in selection 😅
            state.codeInSelection && markName !== 'code' ? true : !$e5d76801e17201ab$var$checkNodeSelection(mark instanceof (0, $kW8qW.MarkType) ? mark : mark.type, editorState);
        }
        return state;
    }
    if (code) {
        state.codeActive = (0, $89hQd.anyMarkActive)(editorState, code.create());
        state.codeDisabled = !$e5d76801e17201ab$var$checkNodeSelection(code, editorState);
    }
    if (em) {
        state.emActive = (0, $89hQd.anyMarkActive)(editorState, em);
        state.emDisabled = state.codeActive ? true : !$e5d76801e17201ab$var$checkNodeSelection(em, editorState);
    }
    if (strike) {
        state.strikeActive = (0, $89hQd.anyMarkActive)(editorState, strike);
        state.strikeDisabled = state.codeActive ? true : !$e5d76801e17201ab$var$checkNodeSelection(strike, editorState);
    }
    if (strong) {
        state.strongActive = (0, $89hQd.anyMarkActive)(editorState, strong);
        state.strongDisabled = state.codeActive ? true : !$e5d76801e17201ab$var$checkNodeSelection(strong, editorState);
    }
    if (subsup) {
        const subMark = subsup.create({
            type: 'sub'
        });
        const supMark = subsup.create({
            type: 'sup'
        });
        state.subscriptActive = (0, $89hQd.anyMarkActive)(editorState, subMark);
        state.superscriptActive = (0, $89hQd.anyMarkActive)(editorState, supMark);
        state.subscriptDisabled = state.codeActive ? true : !$e5d76801e17201ab$var$checkNodeSelection(subsup, editorState, 'sub');
        state.superscriptDisabled = state.codeActive ? true : !$e5d76801e17201ab$var$checkNodeSelection(subsup, editorState, 'sup');
    }
    if (underline) {
        state.underlineActive = (0, $89hQd.anyMarkActive)(editorState, underline);
        state.underlineDisabled = state.codeActive ? true : !$e5d76801e17201ab$var$checkNodeSelection(underline, editorState);
    }
    return state;
};
const $e5d76801e17201ab$export$ca524d3785e2543 = (dispatch, editorAnalyticsAPI)=>new (0, $f7Kk4.SafePlugin)({
        state: {
            init (_config, state) {
                return $e5d76801e17201ab$var$getTextFormattingState(state, editorAnalyticsAPI);
            },
            apply (_tr, pluginState, _oldState, newState) {
                const state = $e5d76801e17201ab$var$getTextFormattingState(newState, editorAnalyticsAPI);
                if (!(0, $56AB9.shallowEqual)(pluginState, state)) {
                    dispatch((0, $0qvtE.pluginKey), state);
                    return state;
                }
                return pluginState;
            }
        },
        key: (0, $0qvtE.pluginKey),
        props: {
            handleKeyDown (view, event) {
                var _pluginKey$getState;
                const { state: state, dispatch: dispatch } = view;
                if (event.key === (0, $cv8id.moveRight).common && !event.metaKey) return $cSBFu.moveRight()(state, dispatch);
                else if (event.key === (0, $cv8id.moveLeft).common && !event.metaKey) return $cSBFu.moveLeft()(state, dispatch);
                else if (event.key === 'u' && event.metaKey && (_pluginKey$getState = (0, $0qvtE.pluginKey).getState(state)) !== null && _pluginKey$getState !== void 0 && _pluginKey$getState.underlineDisabled && (0, $797yE.editorExperiment)('platform_editor_controls', 'variant1')) // This is a workaround for browser behaviour with cmd+u (in Chrome only) where the underline mark being applied around the selection
                event.preventDefault();
                return false;
            },
            handleTextInput (view, from, to, text) {
                const { state: state, dispatch: dispatch } = view;
                const { schema: schema, selection: { $from: { parent: { type: parentNodeType } } } } = state;
                if (parentNodeType.allowsMarkType(schema.marks.code)) return (0, $cSBFu.createInlineCodeFromTextInputWithAnalytics)(editorAnalyticsAPI)(from, to, text)(state, dispatch);
                return false;
            }
        }
    });

});
parcelRegister("jRjUc", function(module, exports) {
$parcel$export(module.exports, "wholeSelectionHasMarks", () => $f737fdead9ef289c$export$a4048c78ac7b54c8);

var $kW8qW = parcelRequire("kW8qW");

var $2E7OD = parcelRequire("2E7OD");



const $f737fdead9ef289c$var$allMarksAreRuledOut = (marks)=>Array.from(marks.values()).every((mark)=>!mark);
const $f737fdead9ef289c$export$a4048c78ac7b54c8 = (state, markTypes)=>{
    const { $from: $from, from: from, to: to, empty: empty } = state.selection;
    if (empty) return new Map(markTypes.map((markType)=>[
            markType,
            !!markType.isInSet(state.storedMarks || $from.marks())
        ]));
    if (state.selection instanceof (0, $2E7OD.CellSelection)) return $f737fdead9ef289c$var$cellSelectionHasMarks(state.doc, state.selection, markTypes);
    return $f737fdead9ef289c$var$wholeRangeHasMarks(from, to, state.doc, markTypes);
};
const $f737fdead9ef289c$var$cellSelectionHasMarks = (doc, selection, markTypes)=>{
    // Warning: This is micro-optimized and is a total pain to actually read.
    // Will attempt to explain in comments.
    // Start with map of booleans for each mark
    let cellsHaveMarks = new Map(markTypes.map((markType)=>[
            markType,
            true
        ]));
    selection.forEachCell((cell, cellPos)=>{
        // Early exit if all marks are already ruled out
        if ($f737fdead9ef289c$var$allMarksAreRuledOut(cellsHaveMarks)) return;
        const from = cellPos;
        const to = cellPos + cell.nodeSize;
        // On first cell just do a regular check
        if (!cellsHaveMarks) cellsHaveMarks = $f737fdead9ef289c$var$wholeRangeHasMarks(from, to, doc, markTypes);
        else {
            // Find the marks that are still true ie the ones that haven't been ruled out in
            // previous cells. The idea here is to whittle down the list of marks so that we check
            // less and less as we go, giving `wholeRangeHasMarks` more opportunities to exit early
            const marksToCheck = [];
            for (const [markType, hasMark] of cellsHaveMarks)if (hasMark) marksToCheck.push(markType);
            // Look specifically for the marks that are not yet ruled out.
            const cellHasMarks = $f737fdead9ef289c$var$wholeRangeHasMarks(from, to, doc, marksToCheck);
            // Map these results back into the original array of results and repeat!
            for (const [markType, hasMark] of cellHasMarks)cellsHaveMarks.set(markType, hasMark);
        }
    });
    return cellsHaveMarks;
};
const $f737fdead9ef289c$var$wholeRangeHasMarks = (from, to, doc, markTypes)=>{
    const hasMarks = new Map(markTypes.map((markType)=>[
            markType,
            true
        ]));
    const hasNoMarks = new Map(markTypes.map((markType)=>[
            markType,
            false
        ]));
    let isTextContent = false;
    doc.nodesBetween(from, to, (node)=>{
        if ($f737fdead9ef289c$var$allMarksAreRuledOut(hasMarks)) // This won't be a true early exit, but will prevent diving into nodes and
        // any checks further down the function.
        return false;
        if (!node.type.isText) return true; // continue traversing
        isTextContent = true;
        for (const [markType, hasMark] of hasMarks){
            if (!hasMark) continue; // already ruled out the mark, skip further checks
            const value = markType instanceof (0, $kW8qW.Mark) ? markType.isInSet(node.marks) : node.marks.some((mark)=>mark.type === markType);
            hasMarks.set(markType, value);
        }
    });
    return isTextContent ? hasMarks : hasNoMarks;
};

});

parcelRegister("cSBFu", function(module, exports) {
$parcel$export(module.exports, "moveRight", () => $e40ec4879533b8f3$export$e2c874fbfec7201);
$parcel$export(module.exports, "moveLeft", () => $e40ec4879533b8f3$export$108f27160c89e515);
$parcel$export(module.exports, "createInlineCodeFromTextInputWithAnalytics", () => $e40ec4879533b8f3$export$7a99a2b030134bb0);

var $g6Qq4 = parcelRequire("g6Qq4");

var $fGjxM = parcelRequire("fGjxM");

var $5NaaJ = parcelRequire("5NaaJ");

var $cw0wu = parcelRequire("cw0wu");

var $2poSi = parcelRequire("2poSi");
const $e40ec4879533b8f3$export$e2c874fbfec7201 = ()=>{
    return (state, dispatch)=>{
        const { code: code } = state.schema.marks;
        const { empty: empty, $cursor: $cursor } = state.selection;
        if (!empty || !$cursor) return false;
        const { storedMarks: storedMarks } = state.tr;
        if (code) {
            const insideCode = (0, $2poSi.markActive)(state, code.create());
            const currentPosHasCode = state.doc.rangeHasMark($cursor.pos, $cursor.pos, code);
            const nextPosHasCode = state.doc.rangeHasMark($cursor.pos, $cursor.pos + 1, code);
            const exitingCode = !currentPosHasCode && !nextPosHasCode && (!storedMarks || !!storedMarks.length);
            const enteringCode = !currentPosHasCode && nextPosHasCode && (!storedMarks || !storedMarks.length);
            // entering code mark (from the left edge): don't move the cursor, just add the mark
            if (!insideCode && enteringCode) {
                if (dispatch) dispatch(state.tr.addStoredMark(code.create()));
                return true;
            }
            // exiting code mark: don't move the cursor, just remove the mark
            if (insideCode && exitingCode) {
                if (dispatch) dispatch(state.tr.removeStoredMark(code));
                return true;
            }
        }
        return false;
    };
};
const $e40ec4879533b8f3$export$108f27160c89e515 = ()=>{
    return (state, dispatch)=>{
        const { code: code } = state.schema.marks;
        const { empty: empty, $cursor: $cursor } = state.selection;
        if (!empty || !$cursor) return false;
        const { storedMarks: storedMarks } = state.tr;
        if (code) {
            const insideCode = code && (0, $2poSi.markActive)(state, code.create());
            const currentPosHasCode = (0, $2poSi.hasCode)(state, $cursor.pos);
            const nextPosHasCode = (0, $2poSi.hasCode)(state, $cursor.pos - 1);
            const nextNextPosHasCode = (0, $2poSi.hasCode)(state, $cursor.pos - 2);
            const exitingCode = currentPosHasCode && !nextPosHasCode && Array.isArray(storedMarks);
            const atLeftEdge = nextPosHasCode && !nextNextPosHasCode && (storedMarks === null || Array.isArray(storedMarks) && !!storedMarks.length);
            const atRightEdge = (exitingCode && Array.isArray(storedMarks) && !storedMarks.length || !exitingCode && storedMarks === null) && !nextPosHasCode && nextNextPosHasCode;
            const enteringCode = !currentPosHasCode && nextPosHasCode && Array.isArray(storedMarks) && !storedMarks.length;
            // at the right edge: remove code mark and move the cursor to the left
            if (!insideCode && atRightEdge) {
                const tr = state.tr.setSelection((0, $cw0wu.Selection).near(state.doc.resolve($cursor.pos - 1)));
                if (dispatch) dispatch(tr.removeStoredMark(code));
                return true;
            }
            // entering code mark (from right edge): don't move the cursor, just add the mark
            if (!insideCode && enteringCode) {
                if (dispatch) dispatch(state.tr.addStoredMark(code.create()));
                return true;
            }
            // at the left edge: add code mark and move the cursor to the left
            if (insideCode && atLeftEdge) {
                const tr = state.tr.setSelection((0, $cw0wu.Selection).near(state.doc.resolve($cursor.pos - 1)));
                if (dispatch) dispatch(tr.addStoredMark(code.create()));
                return true;
            }
            // exiting code mark (or at the beginning of the line): don't move the cursor, just remove the mark
            const isFirstChild = $cursor.index($cursor.depth - 1) === 0;
            if (insideCode && (exitingCode || !$cursor.nodeBefore && isFirstChild)) {
                if (dispatch) dispatch(state.tr.removeStoredMark(code));
                return true;
            }
        }
        return false;
    };
};
const $e40ec4879533b8f3$var$createInlineCodeFromTextInput = (from, to, text)=>{
    return (state, dispatch)=>{
        if (state.selection.empty) {
            const { nodeBefore: before } = state.doc.resolve(from);
            const { nodeAfter: after } = state.doc.resolve(to);
            const hasTickBefore = before && before.text && before.text.endsWith('`');
            const hasTickAfter = after && after.text && after.text.startsWith('`');
            if (hasTickBefore && hasTickAfter) {
                let tr = state.tr.replaceRangeWith(from - 1, to + 1, state.schema.text(text));
                if (dispatch) {
                    const codeMark = state.schema.marks.code.create();
                    tr = (0, $fGjxM.applyMarkOnRange)(tr.mapping.map(from - 1), tr.mapping.map(to + 1), false, codeMark, tr).setStoredMarks([
                        codeMark
                    ]);
                    dispatch(tr);
                }
                return true;
            }
        }
        return false;
    };
};
const $e40ec4879533b8f3$export$7a99a2b030134bb0 = (editorAnalyticsAPI)=>(from, to, text)=>{
        return (0, $5NaaJ.withAnalytics)(editorAnalyticsAPI, {
            action: (0, $g6Qq4.ACTION).FORMATTED,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).TEXT,
            eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
            actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).FORMAT_CODE,
            attributes: {
                inputMethod: (0, $g6Qq4.INPUT_METHOD).FORMATTING
            }
        })($e40ec4879533b8f3$var$createInlineCodeFromTextInput(from, to, text));
    };

});


parcelRegister("86UXH", function(module, exports) {
$parcel$export(module.exports, "default", () => $f01ebfe0cbe8024b$export$2e2bcd8739ae039);

var $g6Qq4 = parcelRequire("g6Qq4");

var $gQ0km = parcelRequire("gQ0km");

var $f7Kk4 = parcelRequire("f7Kk4");

var $33v8M = parcelRequire("33v8M");

var $hfNS8 = parcelRequire("hfNS8");

var $cw0wu = parcelRequire("cw0wu");

var $8t09p = parcelRequire("8t09p");
// We don't agressively upgrade single quotes to smart quotes because
// they may clash with an emoji. Only do that when we have a matching
// single quote, or a contraction.
// wrapped text
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $f01ebfe0cbe8024b$var$WRAPPED_SINGLE_QUOTE_REGEX = /(\s|^)'(\S+.*\S+)'$/;
// apostrophe
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $f01ebfe0cbe8024b$var$APOSTROPHE_REGEX = /(\w+)(')(\w+)$/;
// Product rules
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $f01ebfe0cbe8024b$var$ATLASSIAN_REGEX = /(\s+|^)(atlassian)(\s)$/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $f01ebfe0cbe8024b$var$JIRA_REGEX = /(\s+|^)(jira|JIRA)(\s)$/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $f01ebfe0cbe8024b$var$BITBUCKET_REGEX = /(\s+|^)(bitbucket|BitBucket)(\s)$/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $f01ebfe0cbe8024b$var$HIPCHAT_REGEX = /(\s+|^)(hipchat|HipChat)(\s)$/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $f01ebfe0cbe8024b$var$TRELLO_REGEX = /(\s+|^)(trello)(\s)$/;
// Symbol rules
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $f01ebfe0cbe8024b$var$ARROW_RIGHT_REGEX = /(\s+|^)(--?>)(\s)$/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $f01ebfe0cbe8024b$var$ARROW_LEFT_REGEX = /(\s+|^)(<--?)(\s)$/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $f01ebfe0cbe8024b$var$ARROW_DOUBLE_REGEX = /(\s+|^)(<->?)(\s)$/;
// Punctuation rules
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $f01ebfe0cbe8024b$var$DASH_REGEX = /(\s+|^)(--)(\s)$/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $f01ebfe0cbe8024b$var$ELLIPSIS_REGEX = /()(\.\.\.)$/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $f01ebfe0cbe8024b$var$OPEN_DOUBLE_QUOTE_REGEX = /((?:^|[\s\{\[\(\<'"\u2018\u201C]))(")$/;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $f01ebfe0cbe8024b$var$CLOSE_DOUBLE_QUOTE_REGEX = /"$/;
/**
 * Creates an InputRuleHandler that will match on a regular expression of the
 * form `(prefix, content, suffix?)`, and replace it with some given text,
 * maintaining prefix and suffix around the replacement.
 *
 * @param text text to replace with
 */ function $f01ebfe0cbe8024b$var$replaceTextUsingCaptureGroup(text) {
    return (state, match, start, end)=>{
        const [, prefix, , suffix] = match;
        const replacement = text + (suffix || '');
        const { tr: tr, selection: { $to: $to } } = state;
        const startPos = start + (prefix || '').length;
        const safePos = Math.min(// I know it is almost impossible to have a negative value at this point.
        // But, this is JS #trustnoone
        Math.max(startPos, 0), end);
        tr.replaceWith(safePos, end, state.schema.text(replacement, $to.marks()));
        tr.setSelection((0, $cw0wu.Selection).near(tr.doc.resolve(tr.selection.to)));
        return tr;
    };
}
function $f01ebfe0cbe8024b$var$createReplacementRule(to, from) {
    return (0, $33v8M.createRule)(from, $f01ebfe0cbe8024b$var$replaceTextUsingCaptureGroup(to));
}
/**
 * Create replacement rules fiven a replacement map
 * @param replMap - Replacement map
 * @param trackingEventName - Analytics V2 tracking event name
 * @param replacementRuleWithAnalytics - Analytics GAS V3 middleware for replacement and rules.
 */ function $f01ebfe0cbe8024b$var$createReplacementRules(replMap, replacementRuleWithAnalytics) {
    return Object.keys(replMap).map((replacement)=>{
        const regex = replMap[replacement];
        const rule = $f01ebfe0cbe8024b$var$createReplacementRule(replacement, regex);
        if (replacementRuleWithAnalytics) return replacementRuleWithAnalytics(replacement)(rule);
        return rule;
    });
}
// We don't agressively upgrade single quotes to smart quotes because
// they may clash with an emoji. Only do that when we have a matching
// single quote, or a contraction.
function $f01ebfe0cbe8024b$var$createSingleQuotesRules() {
    return [
        // wrapped text
        (0, $33v8M.createRule)($f01ebfe0cbe8024b$var$WRAPPED_SINGLE_QUOTE_REGEX, (state, match, start, end)=>{
            const OPEN_SMART_QUOTE_CHAR = "\u2018";
            const CLOSED_SMART_QUOTE_CHAR = "\u2019";
            const [, spacing, innerContent] = match;
            // Edge case where match begins with some spacing. We need to add
            // it back to the document
            const openQuoteReplacement = spacing + OPEN_SMART_QUOTE_CHAR;
            // End is not always where the closed quote is, edge case exists
            // when there is spacing after the closed quote. We need to
            // determine position of closed quote from the start position.
            const positionOfClosedQuote = start + openQuoteReplacement.length + innerContent.length;
            return state.tr.insertText(CLOSED_SMART_QUOTE_CHAR, positionOfClosedQuote, end).insertText(openQuoteReplacement, start, start + openQuoteReplacement.length);
        }),
        // apostrophe
        $f01ebfe0cbe8024b$var$createReplacementRule("\u2019", $f01ebfe0cbe8024b$var$APOSTROPHE_REGEX)
    ];
}
/**
 * Get replacement rules related to product
 */ function $f01ebfe0cbe8024b$var$getProductRules(editorAnalyticsAPI) {
    const productRuleWithAnalytics = (product)=>(0, $hfNS8.inputRuleWithAnalytics)((_, match)=>({
                action: (0, $g6Qq4.ACTION).SUBSTITUTED,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).TEXT,
                actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).PRODUCT_NAME,
                eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
                attributes: {
                    product: product,
                    originalSpelling: match[2]
                }
            }), editorAnalyticsAPI);
    return $f01ebfe0cbe8024b$var$createReplacementRules({
        Atlassian: $f01ebfe0cbe8024b$var$ATLASSIAN_REGEX,
        Jira: $f01ebfe0cbe8024b$var$JIRA_REGEX,
        Bitbucket: $f01ebfe0cbe8024b$var$BITBUCKET_REGEX,
        Hipchat: $f01ebfe0cbe8024b$var$HIPCHAT_REGEX,
        Trello: $f01ebfe0cbe8024b$var$TRELLO_REGEX
    }, productRuleWithAnalytics);
}
/**
 * Get replacement rules related to symbol
 */ function $f01ebfe0cbe8024b$var$getSymbolRules(editorAnalyticsAPI) {
    const symbolToString = {
        "\u2192": (0, $gQ0km.SYMBOL).ARROW_RIGHT,
        "\u2190": (0, $gQ0km.SYMBOL).ARROW_LEFT,
        "\u2194\uFE0E": (0, $gQ0km.SYMBOL).ARROW_DOUBLE
    };
    const symbolRuleWithAnalytics = (symbol)=>(0, $hfNS8.inputRuleWithAnalytics)({
            action: (0, $g6Qq4.ACTION).SUBSTITUTED,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).TEXT,
            actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).SYMBOL,
            eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
            attributes: {
                symbol: symbolToString[symbol]
            }
        }, editorAnalyticsAPI);
    return $f01ebfe0cbe8024b$var$createReplacementRules({
        "\u2192": $f01ebfe0cbe8024b$var$ARROW_RIGHT_REGEX,
        "\u2190": $f01ebfe0cbe8024b$var$ARROW_LEFT_REGEX,
        "\u2194\uFE0E": $f01ebfe0cbe8024b$var$ARROW_DOUBLE_REGEX
    }, symbolRuleWithAnalytics);
}
/**
 * Get replacement rules related to punctuation
 */ function $f01ebfe0cbe8024b$var$getPunctuationRules(editorAnalyticsAPI) {
    const punctuationToString = {
        "\u2013": (0, $gQ0km.PUNC).DASH,
        "\u2026": (0, $gQ0km.PUNC).ELLIPSIS,
        "\u201D": (0, $gQ0km.PUNC).QUOTE_DOUBLE,
        [(0, $gQ0km.PUNC).QUOTE_SINGLE]: (0, $gQ0km.PUNC).QUOTE_SINGLE
    };
    const punctuationRuleWithAnalytics = (punctuation)=>(0, $hfNS8.inputRuleWithAnalytics)({
            action: (0, $g6Qq4.ACTION).SUBSTITUTED,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).TEXT,
            actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).PUNC,
            eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
            attributes: {
                punctuation: punctuationToString[punctuation]
            }
        }, editorAnalyticsAPI);
    const dashEllipsisRules = $f01ebfe0cbe8024b$var$createReplacementRules({
        "\u2013": $f01ebfe0cbe8024b$var$DASH_REGEX,
        "\u2026": $f01ebfe0cbe8024b$var$ELLIPSIS_REGEX
    }, punctuationRuleWithAnalytics);
    const doubleQuoteRules = $f01ebfe0cbe8024b$var$createReplacementRules({
        "\u201C": $f01ebfe0cbe8024b$var$OPEN_DOUBLE_QUOTE_REGEX,
        "\u201D": $f01ebfe0cbe8024b$var$CLOSE_DOUBLE_QUOTE_REGEX
    }, punctuationRuleWithAnalytics);
    const singleQuoteRules = $f01ebfe0cbe8024b$var$createSingleQuotesRules();
    return [
        ...dashEllipsisRules,
        ...doubleQuoteRules,
        ...singleQuoteRules.map((rule)=>punctuationRuleWithAnalytics((0, $gQ0km.PUNC).QUOTE_SINGLE)(rule))
    ];
}
var $f01ebfe0cbe8024b$export$2e2bcd8739ae039 = (editorAnalyticsAPI)=>new (0, $f7Kk4.SafePlugin)((0, $8t09p.createPlugin)('text-formatting:smart-input', [
        ...$f01ebfe0cbe8024b$var$getProductRules(editorAnalyticsAPI),
        ...$f01ebfe0cbe8024b$var$getSymbolRules(editorAnalyticsAPI),
        ...$f01ebfe0cbe8024b$var$getPunctuationRules(editorAnalyticsAPI)
    ]));

});
parcelRegister("gQ0km", function(module, exports) {
$parcel$export(module.exports, "SYMBOL", () => $406df3f2aa7acae6$export$27c95a7104c1f7aa);
$parcel$export(module.exports, "PUNC", () => $406df3f2aa7acae6$export$3530f2dd0e78fdc2);
var $406df3f2aa7acae6$export$27c95a7104c1f7aa = /*#__PURE__*/ function(SYMBOL) {
    SYMBOL["ARROW_RIGHT"] = "rightArrow";
    SYMBOL["ARROW_LEFT"] = "leftArrow";
    SYMBOL["ARROW_DOUBLE"] = "doubleArrow";
    return SYMBOL;
}({});
var $406df3f2aa7acae6$export$3530f2dd0e78fdc2 = /*#__PURE__*/ function(PUNC) {
    PUNC["DASH"] = "emDash";
    PUNC["ELLIPSIS"] = "ellipsis";
    PUNC["QUOTE_SINGLE"] = "singleQuote";
    PUNC["QUOTE_DOUBLE"] = "doubleQuote";
    return PUNC;
}({});

});


parcelRegister("77U33", function(module, exports) {
$parcel$export(module.exports, "FloatingToolbarTextFormalWithIntl", () => $27ce0594b068fac7$export$d728f1bdde37938b);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $fK3tS = parcelRequire("fK3tS");

var $d0HRE = parcelRequire("d0HRE");

var $5beht = parcelRequire("5beht");

var $797yE = parcelRequire("797yE");

var $jhjTO = parcelRequire("jhjTO");

var $35tyQ = parcelRequire("35tyQ");

var $bvs15 = parcelRequire("bvs15");

var $aXeYj = parcelRequire("aXeYj");

var $89gD0 = parcelRequire("89gD0");

var $6Khbz = parcelRequire("6Khbz");

var $kzqI4 = parcelRequire("kzqI4");
const $27ce0594b068fac7$var$FloatingToolbarSettings = {
    disabled: false,
    isReducedSpacing: true,
    shouldUseResponsiveToolbar: false,
    toolbarSize: (0, $d0HRE.ToolbarSize).S,
    hasMoreButton: false,
    moreButtonLabel: '',
    toolbarType: (0, $kzqI4.ToolbarType).FLOATING
};
const $27ce0594b068fac7$var$selector = (states)=>{
    var _states$textFormattin, _states$textFormattin2, _states$textFormattin3, _states$textFormattin4, _states$textFormattin5, _states$textFormattin6, _states$textFormattin7, _states$textFormattin8, _states$textFormattin9, _states$textFormattin0, _states$textFormattin1, _states$textFormattin10, _states$textFormattin11, _states$textFormattin12, _states$textFormattin13, _states$textFormattin14, _states$textFormattin15, _states$textFormattin16, _states$textFormattin17, _states$textFormattin18, _states$textFormattin19, _states$textFormattin20, _states$textFormattin21;
    return {
        isInitialised: Boolean((_states$textFormattin = states.textFormattingState) === null || _states$textFormattin === void 0 ? void 0 : _states$textFormattin.isInitialised),
        formattingIsPresent: (_states$textFormattin2 = states.textFormattingState) === null || _states$textFormattin2 === void 0 ? void 0 : _states$textFormattin2.formattingIsPresent,
        emActive: (_states$textFormattin3 = states.textFormattingState) === null || _states$textFormattin3 === void 0 ? void 0 : _states$textFormattin3.emActive,
        emDisabled: (_states$textFormattin4 = states.textFormattingState) === null || _states$textFormattin4 === void 0 ? void 0 : _states$textFormattin4.emDisabled,
        emHidden: (_states$textFormattin5 = states.textFormattingState) === null || _states$textFormattin5 === void 0 ? void 0 : _states$textFormattin5.emHidden,
        codeActive: (_states$textFormattin6 = states.textFormattingState) === null || _states$textFormattin6 === void 0 ? void 0 : _states$textFormattin6.codeActive,
        codeDisabled: (_states$textFormattin7 = states.textFormattingState) === null || _states$textFormattin7 === void 0 ? void 0 : _states$textFormattin7.codeDisabled,
        codeHidden: (_states$textFormattin8 = states.textFormattingState) === null || _states$textFormattin8 === void 0 ? void 0 : _states$textFormattin8.codeHidden,
        underlineActive: (_states$textFormattin9 = states.textFormattingState) === null || _states$textFormattin9 === void 0 ? void 0 : _states$textFormattin9.underlineActive,
        underlineDisabled: (_states$textFormattin0 = states.textFormattingState) === null || _states$textFormattin0 === void 0 ? void 0 : _states$textFormattin0.underlineDisabled,
        underlineHidden: (_states$textFormattin1 = states.textFormattingState) === null || _states$textFormattin1 === void 0 ? void 0 : _states$textFormattin1.underlineHidden,
        strikeActive: (_states$textFormattin10 = states.textFormattingState) === null || _states$textFormattin10 === void 0 ? void 0 : _states$textFormattin10.strikeActive,
        strikeDisabled: (_states$textFormattin11 = states.textFormattingState) === null || _states$textFormattin11 === void 0 ? void 0 : _states$textFormattin11.strikeDisabled,
        strikeHidden: (_states$textFormattin12 = states.textFormattingState) === null || _states$textFormattin12 === void 0 ? void 0 : _states$textFormattin12.strikeHidden,
        strongActive: (_states$textFormattin13 = states.textFormattingState) === null || _states$textFormattin13 === void 0 ? void 0 : _states$textFormattin13.strongActive,
        strongDisabled: (_states$textFormattin14 = states.textFormattingState) === null || _states$textFormattin14 === void 0 ? void 0 : _states$textFormattin14.strongDisabled,
        strongHidden: (_states$textFormattin15 = states.textFormattingState) === null || _states$textFormattin15 === void 0 ? void 0 : _states$textFormattin15.strongHidden,
        superscriptActive: (_states$textFormattin16 = states.textFormattingState) === null || _states$textFormattin16 === void 0 ? void 0 : _states$textFormattin16.superscriptActive,
        superscriptDisabled: (_states$textFormattin17 = states.textFormattingState) === null || _states$textFormattin17 === void 0 ? void 0 : _states$textFormattin17.superscriptDisabled,
        superscriptHidden: (_states$textFormattin18 = states.textFormattingState) === null || _states$textFormattin18 === void 0 ? void 0 : _states$textFormattin18.superscriptHidden,
        subscriptActive: (_states$textFormattin19 = states.textFormattingState) === null || _states$textFormattin19 === void 0 ? void 0 : _states$textFormattin19.subscriptActive,
        subscriptDisabled: (_states$textFormattin20 = states.textFormattingState) === null || _states$textFormattin20 === void 0 ? void 0 : _states$textFormattin20.subscriptDisabled,
        subscriptHidden: (_states$textFormattin21 = states.textFormattingState) === null || _states$textFormattin21 === void 0 ? void 0 : _states$textFormattin21.subscriptHidden
    };
};
const $27ce0594b068fac7$var$FloatingToolbarTextFormat = ({ api: api, editorAnalyticsAPI: editorAnalyticsAPI, editorView: editorView, intl: intl })=>{
    const textFormattingState = (0, $5beht.useSharedPluginStateWithSelector)(api, [
        'textFormatting'
    ], $27ce0594b068fac7$var$selector);
    const { formattingIsPresent: formattingIsPresent, ...formattingIconState } = textFormattingState;
    const defaultIcons = (0, $aXeYj.useFormattingIcons)({
        schema: editorView.state.schema,
        intl: intl,
        isToolbarDisabled: $27ce0594b068fac7$var$FloatingToolbarSettings.disabled,
        editorAnalyticsAPI: editorAnalyticsAPI,
        textFormattingState: formattingIconState,
        toolbarType: $27ce0594b068fac7$var$FloatingToolbarSettings.toolbarType
    });
    const { dropdownItems: dropdownItems, singleItems: singleItems } = (0, $89gD0.useIconList)({
        icons: defaultIcons,
        iconTypeList: (0, $jhjTO.ToolbarButtonsStrong)
    });
    const clearIcon = (0, $bvs15.useClearIcon)({
        formattingPluginInitialised: textFormattingState.isInitialised,
        formattingIsPresent: formattingIsPresent,
        intl: intl,
        editorAnalyticsAPI: editorAnalyticsAPI,
        toolbarType: $27ce0594b068fac7$var$FloatingToolbarSettings.toolbarType
    });
    const items = (0, $bSJIT.useMemo)(()=>{
        if (!clearIcon) return [
            {
                items: dropdownItems
            }
        ];
        return [
            {
                items: dropdownItems
            },
            {
                items: [
                    clearIcon
                ]
            }
        ];
    }, [
        clearIcon,
        dropdownItems
    ]);
    return /*#__PURE__*/ (0, $9dQre.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, /*#__PURE__*/ (0, $9dQre.jsx)((0, $6Khbz.SingleToolbarButtons), {
        items: singleItems,
        editorView: editorView,
        isReducedSpacing: false
    }), /*#__PURE__*/ (0, $9dQre.jsx)((0, $35tyQ.FormattingTextDropdownMenu), {
        editorView: editorView,
        items: items,
        isReducedSpacing: (0, $797yE.editorExperiment)('platform_editor_controls', 'variant1') ? false : $27ce0594b068fac7$var$FloatingToolbarSettings.isReducedSpacing,
        moreButtonLabel: $27ce0594b068fac7$var$FloatingToolbarSettings.moreButtonLabel,
        hasFormattingActive: $27ce0594b068fac7$var$FloatingToolbarSettings.hasMoreButton,
        hasMoreButton: $27ce0594b068fac7$var$FloatingToolbarSettings.hasMoreButton,
        intl: intl,
        toolbarType: $27ce0594b068fac7$var$FloatingToolbarSettings.toolbarType
    }));
};
const $27ce0594b068fac7$export$d728f1bdde37938b = (0, $fK3tS.default)($27ce0594b068fac7$var$FloatingToolbarTextFormat);

});
parcelRegister("jhjTO", function(module, exports) {
$parcel$export(module.exports, "ToolbarButtonsStrongItalic", () => $16c974d2593b332b$export$37a675a4731536c);
$parcel$export(module.exports, "ToolbarButtonsStrong", () => $16c974d2593b332b$export$9930ae1c7f6b53f3);
$parcel$export(module.exports, "ButtonsMenuMinimal", () => $16c974d2593b332b$export$5789feaf6941ee12);
$parcel$export(module.exports, "ResponsiveCustomButtonToolbarMinimal", () => $16c974d2593b332b$export$13589e95a4a6fb40);
$parcel$export(module.exports, "ResponsiveCustomButtonToolbarCompact", () => $16c974d2593b332b$export$fdd1bbcb63018330);
$parcel$export(module.exports, "ResponsiveCustomMenuMinimal", () => $16c974d2593b332b$export$1b53a931a2dd9e07);
$parcel$export(module.exports, "ResponsiveCustomMenuCompact", () => $16c974d2593b332b$export$53d57ab9be604153);

var $d0HRE = parcelRequire("d0HRE");

var $kzqI4 = parcelRequire("kzqI4");
const $16c974d2593b332b$export$37a675a4731536c = [
    (0, $kzqI4.IconTypes).strong,
    (0, $kzqI4.IconTypes).em
];
const $16c974d2593b332b$export$9930ae1c7f6b53f3 = [
    (0, $kzqI4.IconTypes).strong
];
const $16c974d2593b332b$export$def34bf0ee813055 = [
    (0, $kzqI4.IconTypes).strong,
    (0, $kzqI4.IconTypes).em,
    (0, $kzqI4.IconTypes).underline
];
const $16c974d2593b332b$export$5789feaf6941ee12 = [
    (0, $kzqI4.IconTypes).em,
    (0, $kzqI4.IconTypes).underline,
    (0, $kzqI4.IconTypes).strike,
    (0, $kzqI4.IconTypes).code,
    (0, $kzqI4.IconTypes).subscript,
    (0, $kzqI4.IconTypes).superscript
];
const $16c974d2593b332b$export$f40ebaa61bfc4d53 = [
    (0, $kzqI4.IconTypes).underline,
    (0, $kzqI4.IconTypes).strike,
    (0, $kzqI4.IconTypes).code,
    (0, $kzqI4.IconTypes).subscript,
    (0, $kzqI4.IconTypes).superscript
];
const $16c974d2593b332b$export$b1ac64c82cac61ce = [
    (0, $kzqI4.IconTypes).strike,
    (0, $kzqI4.IconTypes).code,
    (0, $kzqI4.IconTypes).subscript,
    (0, $kzqI4.IconTypes).superscript
];
const $16c974d2593b332b$export$13589e95a4a6fb40 = {
    [(0, $d0HRE.ToolbarSize).XXL]: $16c974d2593b332b$export$9930ae1c7f6b53f3,
    [(0, $d0HRE.ToolbarSize).XL]: $16c974d2593b332b$export$9930ae1c7f6b53f3,
    [(0, $d0HRE.ToolbarSize).L]: $16c974d2593b332b$export$9930ae1c7f6b53f3,
    [(0, $d0HRE.ToolbarSize).M]: $16c974d2593b332b$export$9930ae1c7f6b53f3,
    [(0, $d0HRE.ToolbarSize).S]: $16c974d2593b332b$export$9930ae1c7f6b53f3,
    [(0, $d0HRE.ToolbarSize).XXXS]: []
};
const $16c974d2593b332b$export$fdd1bbcb63018330 = {
    [(0, $d0HRE.ToolbarSize).XXL]: $16c974d2593b332b$export$37a675a4731536c,
    [(0, $d0HRE.ToolbarSize).XL]: $16c974d2593b332b$export$37a675a4731536c,
    [(0, $d0HRE.ToolbarSize).L]: $16c974d2593b332b$export$37a675a4731536c,
    [(0, $d0HRE.ToolbarSize).M]: $16c974d2593b332b$export$37a675a4731536c,
    [(0, $d0HRE.ToolbarSize).S]: $16c974d2593b332b$export$37a675a4731536c,
    [(0, $d0HRE.ToolbarSize).XXXS]: []
};
const $16c974d2593b332b$export$861ad8d05e95bc1e = {
    [(0, $d0HRE.ToolbarSize).XXL]: $16c974d2593b332b$export$def34bf0ee813055,
    [(0, $d0HRE.ToolbarSize).XL]: $16c974d2593b332b$export$def34bf0ee813055,
    [(0, $d0HRE.ToolbarSize).L]: $16c974d2593b332b$export$def34bf0ee813055,
    [(0, $d0HRE.ToolbarSize).M]: $16c974d2593b332b$export$37a675a4731536c,
    [(0, $d0HRE.ToolbarSize).S]: $16c974d2593b332b$export$37a675a4731536c,
    [(0, $d0HRE.ToolbarSize).XXXS]: $16c974d2593b332b$export$9930ae1c7f6b53f3
};
const $16c974d2593b332b$export$1b53a931a2dd9e07 = {
    [(0, $d0HRE.ToolbarSize).XXL]: $16c974d2593b332b$export$5789feaf6941ee12,
    [(0, $d0HRE.ToolbarSize).XL]: $16c974d2593b332b$export$5789feaf6941ee12,
    [(0, $d0HRE.ToolbarSize).L]: $16c974d2593b332b$export$5789feaf6941ee12,
    [(0, $d0HRE.ToolbarSize).M]: $16c974d2593b332b$export$5789feaf6941ee12,
    [(0, $d0HRE.ToolbarSize).S]: $16c974d2593b332b$export$5789feaf6941ee12,
    [(0, $d0HRE.ToolbarSize).XXXS]: [
        (0, $kzqI4.IconTypes).strong,
        (0, $kzqI4.IconTypes).em,
        ...$16c974d2593b332b$export$5789feaf6941ee12
    ]
};
const $16c974d2593b332b$export$53d57ab9be604153 = {
    [(0, $d0HRE.ToolbarSize).XXL]: $16c974d2593b332b$export$f40ebaa61bfc4d53,
    [(0, $d0HRE.ToolbarSize).XL]: $16c974d2593b332b$export$f40ebaa61bfc4d53,
    [(0, $d0HRE.ToolbarSize).L]: $16c974d2593b332b$export$f40ebaa61bfc4d53,
    [(0, $d0HRE.ToolbarSize).M]: $16c974d2593b332b$export$f40ebaa61bfc4d53,
    [(0, $d0HRE.ToolbarSize).S]: $16c974d2593b332b$export$f40ebaa61bfc4d53,
    [(0, $d0HRE.ToolbarSize).XXXS]: [
        (0, $kzqI4.IconTypes).strong,
        (0, $kzqI4.IconTypes).em,
        ...$16c974d2593b332b$export$f40ebaa61bfc4d53
    ]
};
const $16c974d2593b332b$export$77ad87491c5fbf88 = {
    [(0, $d0HRE.ToolbarSize).XXL]: $16c974d2593b332b$export$b1ac64c82cac61ce,
    [(0, $d0HRE.ToolbarSize).XL]: $16c974d2593b332b$export$b1ac64c82cac61ce,
    [(0, $d0HRE.ToolbarSize).L]: $16c974d2593b332b$export$b1ac64c82cac61ce,
    [(0, $d0HRE.ToolbarSize).M]: [
        (0, $kzqI4.IconTypes).underline,
        ...$16c974d2593b332b$export$b1ac64c82cac61ce
    ],
    [(0, $d0HRE.ToolbarSize).S]: [
        (0, $kzqI4.IconTypes).underline,
        ...$16c974d2593b332b$export$b1ac64c82cac61ce
    ],
    [(0, $d0HRE.ToolbarSize).XXXS]: [
        (0, $kzqI4.IconTypes).em,
        (0, $kzqI4.IconTypes).underline,
        ...$16c974d2593b332b$export$b1ac64c82cac61ce
    ]
};

});
parcelRegister("kzqI4", function(module, exports) {
$parcel$export(module.exports, "IconTypes", () => $0907510095bd87aa$export$f84ca76848e3ed34);
$parcel$export(module.exports, "FormatOptions", () => $0907510095bd87aa$export$c1fb0eb1ea3f6fb6);
$parcel$export(module.exports, "ToolbarType", () => $0907510095bd87aa$export$a5d11b3163e4b1a5);
var $0907510095bd87aa$export$f84ca76848e3ed34 = /*#__PURE__*/ function(IconTypes) {
    IconTypes["strong"] = "strong";
    IconTypes["em"] = "em";
    IconTypes["underline"] = "underline";
    IconTypes["strike"] = "strike";
    IconTypes["code"] = "code";
    IconTypes["subscript"] = "subscript";
    IconTypes["superscript"] = "superscript";
    return IconTypes;
}({});
var $0907510095bd87aa$export$c1fb0eb1ea3f6fb6 = /*#__PURE__*/ function(FormatOptions) {
    FormatOptions["strong"] = "strong";
    FormatOptions["em"] = "em";
    FormatOptions["underline"] = "underline";
    FormatOptions["strike"] = "strike";
    FormatOptions["code"] = "code";
    FormatOptions["subscript"] = "subscript";
    FormatOptions["superscript"] = "superscript";
    return FormatOptions;
}({});
var $0907510095bd87aa$export$a5d11b3163e4b1a5 = /*#__PURE__*/ function(ToolbarType) {
    ToolbarType["PRIMARY"] = "primaryToolbar";
    ToolbarType["FLOATING"] = "floatingToolbar";
    return ToolbarType;
}({});

});


parcelRegister("35tyQ", function(module, exports) {
$parcel$export(module.exports, "FormattingTextDropdownMenu", () => $232beee0a4158a35$export$52e9a2bbe5d185e8);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $glyUo = parcelRequire("glyUo");

var $fWCaV = parcelRequire("fWCaV");

var $5bbjm = parcelRequire("5bbjm");

var $797yE = parcelRequire("797yE");

var $qn8KT = parcelRequire("qn8KT");

var $aNzJV = parcelRequire("aNzJV");

var $ljCNh = parcelRequire("ljCNh");
const $232beee0a4158a35$export$52e9a2bbe5d185e8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).memo(({ editorView: editorView, moreButtonLabel: moreButtonLabel, isReducedSpacing: isReducedSpacing, items: items, hasFormattingActive: hasFormattingActive, popupsBoundariesElement: popupsBoundariesElement, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement, hasMoreButton: hasMoreButton, intl: intl, toolbarType: toolbarType, isDisabled: isDisabled })=>{
    var _items$0$items$, _items$0$items$2;
    const [isMenuOpen, toggleMenu, closeMenu] = (0, $aNzJV.useMenuState)();
    const [isOpenedByKeyboard, setIsOpenedByKeyboard] = (0, $bSJIT.useState)(false);
    const onItemActivated = (0, $bSJIT.useCallback)(({ item: item, shouldCloseMenu: shouldCloseMenu = true })=>{
        if (item) {
            item.command(editorView.state, editorView.dispatch);
            if (shouldCloseMenu) closeMenu();
        }
    }, [
        editorView.state,
        editorView.dispatch,
        closeMenu
    ]);
    const activeItem = items[0].items.find((item)=>item.isActive);
    const defaultIcon = (0, $797yE.editorExperiment)('platform_editor_controls', 'variant1') ? (_items$0$items$ = items[0].items[0]) === null || _items$0$items$ === void 0 ? void 0 : _items$0$items$.elemBefore : undefined;
    const defaultIconName = (_items$0$items$2 = items[0].items[0]) === null || _items$0$items$2 === void 0 ? void 0 : _items$0$items$2.value.name;
    const iconBefore = activeItem ? activeItem === null || activeItem === void 0 ? void 0 : activeItem.elemBefore : defaultIcon;
    const activeIconName = (activeItem === null || activeItem === void 0 ? void 0 : activeItem.value.name) || defaultIconName;
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $fWCaV.DropdownMenuWithKeyboardNavigation), {
        mountTo: popupsMountPoint,
        onOpenChange: closeMenu,
        boundariesElement: popupsBoundariesElement,
        scrollableElement: popupsScrollableElement,
        onItemActivated: onItemActivated,
        isOpen: isMenuOpen,
        items: items,
        zIndex: (0, $5bbjm.akEditorMenuZIndex),
        fitHeight: 188,
        fitWidth: (0, $797yE.editorExperiment)('platform_editor_controls', 'control') ? 136 : 230,
        shouldUseDefaultRole: true,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        section: {
            hasSeparator: true
        },
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        shouldFocusFirstItem: ()=>{
            if (isOpenedByKeyboard) setIsOpenedByKeyboard(false);
            return isOpenedByKeyboard;
        },
        children: hasMoreButton ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $ljCNh.MoreButton), {
            isSelected: isMenuOpen || hasFormattingActive,
            label: moreButtonLabel,
            isReducedSpacing: isReducedSpacing,
            isDisabled: false,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onClick: ()=>{
                toggleMenu();
                setIsOpenedByKeyboard(false);
            },
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onKeyDown: (event)=>{
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    toggleMenu();
                    setIsOpenedByKeyboard(true);
                }
            },
            "aria-expanded": isMenuOpen
        }) : /*#__PURE__*/ (0, $dc70d.jsx)((0, $qn8KT.DropdownToolbarButton), {
            isReducedSpacing: isReducedSpacing,
            isDisabled: Boolean(isDisabled),
            isSelected: isMenuOpen,
            label: intl.formatMessage((0, $glyUo.toolbarMessages).textFormat),
            "aria-expanded": isMenuOpen,
            "aria-haspopup": true,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onClick: ()=>{
                toggleMenu();
                setIsOpenedByKeyboard(false);
            },
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            onKeyDown: (event)=>{
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    toggleMenu();
                    setIsOpenedByKeyboard(true);
                }
            },
            toolbarType: toolbarType,
            iconBefore: iconBefore,
            activeIconName: activeIconName
        })
    });
});

});
parcelRegister("qn8KT", function(module, exports) {
$parcel$export(module.exports, "DropdownToolbarButton", () => $dc3c2c67a2f37856$export$7c43b97d70f40057);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $kLBYz = parcelRequire("kLBYz");

var $g42cj = parcelRequire("g42cj");

var $8zO6u = parcelRequire("8zO6u");

var $4GWyU = parcelRequire("4GWyU");

var $ktWlR = parcelRequire("ktWlR");

var $kzqI4 = parcelRequire("kzqI4");
const $dc3c2c67a2f37856$export$7c43b97d70f40057 = ({ label: label, isReducedSpacing: isReducedSpacing, isDisabled: isDisabled, isSelected: isSelected, 'aria-expanded': ariaExpanded, onClick: onClick, onKeyDown: onKeyDown, toolbarType: toolbarType, iconBefore: iconBefore, activeIconName: activeIconName })=>{
    const reducedSpacing = toolbarType === (0, $kzqI4.ToolbarType).FLOATING ? 'compact' : 'none';
    return /*#__PURE__*/ (0, $9dQre.jsx)((0, $8zO6u.default), {
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-imported-style-values
        css: (0, $g42cj.disableBlueBorderStyles),
        testId: 'ak-editor-selection-toolbar-format-text-button',
        spacing: isReducedSpacing ? reducedSpacing : 'default',
        disabled: isDisabled,
        selected: isSelected,
        "aria-label": label,
        "aria-expanded": ariaExpanded,
        "aria-haspopup": true,
        title: label,
        onClick: onClick,
        onKeyDown: onKeyDown,
        iconBefore: /*#__PURE__*/ (0, $9dQre.jsx)("div", {
            css: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $g42cj.triggerWrapperStylesWithPadding),
            "data-testid": activeIconName ? `editor-toolbar__${activeIconName}` : undefined
        }, iconBefore ? iconBefore : /*#__PURE__*/ (0, $9dQre.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ktWlR))), {
            color: "currentColor",
            spacing: "spacious",
            label: ""
        }), /*#__PURE__*/ (0, $9dQre.jsx)("span", {
            css: (0, $kLBYz.expandIconContainerStyle)
        }, /*#__PURE__*/ (0, $9dQre.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4GWyU))), {
            label: "",
            color: "currentColor",
            size: "small"
        })))
    });
};

});

parcelRegister("aNzJV", function(module, exports) {
$parcel$export(module.exports, "useMenuState", () => $a0085193a1e54098$export$8091e3849c182a6);

var $bSJIT = parcelRequire("bSJIT");
const $a0085193a1e54098$export$8091e3849c182a6 = ()=>{
    const [isMenuOpen, setIsMenuOpened] = (0, $bSJIT.useState)(false);
    const toggleMenu = (0, $bSJIT.useCallback)(()=>{
        setIsMenuOpened(!isMenuOpen);
    }, [
        isMenuOpen
    ]);
    const closeMenu = (0, $bSJIT.useCallback)(()=>{
        setIsMenuOpened(false);
    }, []);
    return [
        isMenuOpen,
        toggleMenu,
        closeMenu
    ];
};

});

parcelRegister("ljCNh", function(module, exports) {
$parcel$export(module.exports, "MoreButton", () => $1e83bc03d2140859$export$7f94856880993f27);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $8zO6u = parcelRequire("8zO6u");

var $iabGk = parcelRequire("iabGk");
function $1e83bc03d2140859$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1e83bc03d2140859$var$MoreIconStyle = {
    name: "1m17jn9",
    styles: "display:flex;align-items:center;height:var(--ds-space-300, 24px)"
};
const $1e83bc03d2140859$export$7f94856880993f27 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).memo(({ label: label, 'aria-expanded': ariaExpanded, isReducedSpacing: isReducedSpacing, isSelected: isSelected, isDisabled: isDisabled, onClick: onClick, onKeyDown: onKeyDown })=>{
    return /*#__PURE__*/ (0, $9dQre.jsx)((0, $8zO6u.default), {
        disabled: isDisabled,
        selected: isSelected,
        onClick: onClick,
        onKeyDown: onKeyDown,
        spacing: isReducedSpacing ? 'none' : 'default',
        title: label,
        iconBefore: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $9dQre.jsx)("div", {
            css: $1e83bc03d2140859$var$MoreIconStyle
        }, /*#__PURE__*/ (0, $9dQre.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iabGk))), {
            label: "",
            color: "currentColor",
            spacing: "spacious",
            size: "small"
        })),
        "aria-expanded": ariaExpanded,
        "aria-label": label,
        "aria-haspopup": true
    });
});

});


parcelRegister("bvs15", function(module, exports) {
$parcel$export(module.exports, "useClearIcon", () => $2839d351672ac92e$export$4ff17fae4b9914b);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $cv8id = parcelRequire("cv8id");

var $glyUo = parcelRequire("glyUo");

var $hqEKl = parcelRequire("hqEKl");

var $dbIlo = parcelRequire("dbIlo");

var $797yE = parcelRequire("797yE");

var $h2Fei = parcelRequire("h2Fei");

var $3QdxC = parcelRequire("3QdxC");
const $2839d351672ac92e$export$4ff17fae4b9914b = ({ intl: intl, formattingPluginInitialised: formattingPluginInitialised, formattingIsPresent: formattingPresent, editorAnalyticsAPI: editorAnalyticsAPI, toolbarType: toolbarType })=>{
    const isPluginAvailable = Boolean(formattingPluginInitialised);
    const formattingIsPresent = Boolean(formattingPresent);
    const clearFormattingLabel = intl.formatMessage((0, $glyUo.toolbarMessages).clearFormatting);
    const clearFormattingToolbar = (0, $bSJIT.useCallback)((state, dispatch)=>(0, $h2Fei.clearFormattingWithAnalytics)((0, $3QdxC.getInputMethod)(toolbarType), editorAnalyticsAPI)(state, dispatch), [
        editorAnalyticsAPI,
        toolbarType
    ]);
    return (0, $bSJIT.useMemo)(()=>{
        if (!isPluginAvailable) return null;
        return {
            key: 'clearFormatting',
            command: clearFormattingToolbar,
            content: clearFormattingLabel,
            elemBefore: (0, $797yE.editorExperiment)('platform_editor_controls', 'variant1') ? /*#__PURE__*/ (0, $9dQre.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dbIlo))), {
                label: ""
            }) : undefined,
            elemAfter: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            /*#__PURE__*/ (0, $9dQre.jsx)("div", {
                css: (0, $hqEKl.shortcutStyle)
            }, (0, $cv8id.tooltip)((0, $cv8id.clearFormatting))),
            value: {
                name: 'clearFormatting'
            },
            isActive: false,
            isDisabled: !formattingIsPresent,
            'aria-label': (0, $cv8id.clearFormatting) ? (0, $cv8id.tooltip)((0, $cv8id.clearFormatting), String(clearFormattingLabel)) : String(clearFormattingLabel)
        };
    }, [
        isPluginAvailable,
        clearFormattingToolbar,
        clearFormattingLabel,
        formattingIsPresent
    ]);
};

});
parcelRegister("3QdxC", function(module, exports) {
$parcel$export(module.exports, "getInputMethod", () => $ede8a34fc0c39886$export$8213a6fbfa466e73);

var $g6Qq4 = parcelRequire("g6Qq4");

var $kzqI4 = parcelRequire("kzqI4");
const $ede8a34fc0c39886$export$ec2f5afcaf7ee094 = {
    [(0, $kzqI4.ToolbarType).PRIMARY]: (0, $g6Qq4.INPUT_METHOD).TOOLBAR,
    [(0, $kzqI4.ToolbarType).FLOATING]: (0, $g6Qq4.INPUT_METHOD).FLOATING_TB
};
const $ede8a34fc0c39886$export$8213a6fbfa466e73 = (toolbarType)=>$ede8a34fc0c39886$export$ec2f5afcaf7ee094[toolbarType];

});


parcelRegister("aXeYj", function(module, exports) {
$parcel$export(module.exports, "useFormattingIcons", () => $441071f62ee239d0$export$6f298ec13df828);
$parcel$export(module.exports, "useHasFormattingActived", () => $441071f62ee239d0$export$cb0a2ed6e982a08f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $bnf0l = parcelRequire("bnf0l");

var $cv8id = parcelRequire("cv8id");

var $glyUo = parcelRequire("glyUo");

var $iPR6g = parcelRequire("iPR6g");

var $hqEKl = parcelRequire("hqEKl");

var $imwtU = parcelRequire("imwtU");

var $dY4yK = parcelRequire("dY4yK");

var $ktWlR = parcelRequire("ktWlR");

var $74hnl = parcelRequire("74hnl");

var $dTdDF = parcelRequire("dTdDF");

var $797yE = parcelRequire("797yE");

var $5jSEp = parcelRequire("5jSEp");

var $1RFZ5 = parcelRequire("1RFZ5");

var $3QdxC = parcelRequire("3QdxC");

var $kzqI4 = parcelRequire("kzqI4");
const $441071f62ee239d0$var$withInputMethod = (toolbarType, func)=>(0, $iPR6g.editorCommandToPMCommand)(func((0, $3QdxC.getInputMethod)(toolbarType)));
const $441071f62ee239d0$var$IconButtons = (editorAnalyticsAPI, toolbarType)=>({
        strong: {
            buttonId: (0, $bnf0l.TOOLBAR_ACTION_SUBJECT_ID).TEXT_FORMATTING_STRONG,
            command: $441071f62ee239d0$var$withInputMethod(toolbarType, (0, $5jSEp.toggleStrongWithAnalytics)(editorAnalyticsAPI)),
            message: (0, $glyUo.toolbarMessages).bold,
            tooltipKeymap: (0, $cv8id.toggleBold),
            component: ()=>/*#__PURE__*/ (0, $9dQre.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dY4yK))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: ""
                })
        },
        em: {
            buttonId: (0, $bnf0l.TOOLBAR_ACTION_SUBJECT_ID).TEXT_FORMATTING_ITALIC,
            command: $441071f62ee239d0$var$withInputMethod(toolbarType, (0, $5jSEp.toggleEmWithAnalytics)(editorAnalyticsAPI)),
            message: (0, $glyUo.toolbarMessages).italic,
            tooltipKeymap: (0, $cv8id.toggleItalic),
            component: ()=>/*#__PURE__*/ (0, $9dQre.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ktWlR))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: ""
                })
        },
        underline: {
            buttonId: (0, $bnf0l.TOOLBAR_ACTION_SUBJECT_ID).TEXT_FORMATTING_UNDERLINE,
            command: $441071f62ee239d0$var$withInputMethod(toolbarType, (0, $5jSEp.toggleUnderlineWithAnalytics)(editorAnalyticsAPI)),
            message: (0, $glyUo.toolbarMessages).underline,
            tooltipKeymap: (0, $cv8id.toggleUnderline),
            component: ()=>/*#__PURE__*/ (0, $9dQre.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dTdDF))), {
                    color: "currentColor",
                    spacing: "spacious",
                    label: ""
                })
        },
        strike: {
            command: $441071f62ee239d0$var$withInputMethod(toolbarType, (0, $5jSEp.toggleStrikeWithAnalytics)(editorAnalyticsAPI)),
            message: (0, $glyUo.toolbarMessages).strike,
            tooltipKeymap: (0, $cv8id.toggleStrikethrough)
        },
        code: {
            command: $441071f62ee239d0$var$withInputMethod(toolbarType, (0, $5jSEp.toggleCodeWithAnalytics)(editorAnalyticsAPI)),
            message: (0, $glyUo.toolbarMessages).code,
            tooltipKeymap: (0, $cv8id.toggleCode)
        },
        subscript: {
            command: $441071f62ee239d0$var$withInputMethod(toolbarType, (0, $5jSEp.toggleSubscriptWithAnalytics)(editorAnalyticsAPI)),
            message: (0, $glyUo.toolbarMessages).subscript,
            tooltipKeymap: (0, $cv8id.toggleSubscript)
        },
        superscript: {
            command: $441071f62ee239d0$var$withInputMethod(toolbarType, (0, $5jSEp.toggleSuperscriptWithAnalytics)(editorAnalyticsAPI)),
            message: (0, $glyUo.toolbarMessages).superscript,
            tooltipKeymap: (0, $cv8id.toggleSuperscript)
        }
    });
const $441071f62ee239d0$var$IconBefore = {
    strong: {
        icon: /*#__PURE__*/ (0, $9dQre.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dY4yK))), {
            color: "currentColor",
            spacing: "spacious",
            label: ""
        })
    },
    em: {
        icon: /*#__PURE__*/ (0, $9dQre.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ktWlR))), {
            color: "currentColor",
            spacing: "spacious",
            label: ""
        })
    },
    underline: {
        icon: /*#__PURE__*/ (0, $9dQre.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dTdDF))), {
            color: "currentColor",
            spacing: "spacious",
            label: ""
        })
    },
    strike: {
        icon: /*#__PURE__*/ (0, $9dQre.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($74hnl))), {
            label: ""
        })
    },
    code: {
        icon: /*#__PURE__*/ (0, $9dQre.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($imwtU))), {
            color: "currentColor",
            spacing: "spacious",
            label: ""
        })
    },
    subscript: {
        icon: /*#__PURE__*/ (0, $9dQre.jsx)((0, $1RFZ5.Subscript), null)
    },
    superscript: {
        icon: /*#__PURE__*/ (0, $9dQre.jsx)((0, $1RFZ5.Superscript), null)
    }
};
const $441071f62ee239d0$var$getIcon = ({ iconType: iconType, isDisabled: isDisabled, isActive: isActive, intl: intl, editorAnalyticsAPI: editorAnalyticsAPI, toolbarType: toolbarType })=>{
    const icon = $441071f62ee239d0$var$IconButtons(editorAnalyticsAPI, toolbarType)[iconType];
    const iconBefore = $441071f62ee239d0$var$IconBefore[iconType].icon;
    const content = intl.formatMessage(icon.message);
    const { tooltipKeymap: tooltipKeymap } = icon;
    return {
        content: content,
        buttonId: icon.buttonId,
        iconMark: iconType,
        key: iconType,
        command: icon.command,
        iconElement: icon.component ? icon.component() : undefined,
        tooltipElement: tooltipKeymap ? /*#__PURE__*/ (0, $9dQre.jsx)((0, $cv8id.ToolTipContent), {
            description: content,
            keymap: tooltipKeymap
        }) : undefined,
        elemBefore: (0, $797yE.editorExperiment)('platform_editor_controls', 'variant1') ? iconBefore : undefined,
        elemAfter: tooltipKeymap ? // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        /*#__PURE__*/ (0, $9dQre.jsx)("div", {
            css: (0, $hqEKl.shortcutStyle)
        }, (0, $cv8id.tooltip)(tooltipKeymap)) : undefined,
        value: {
            name: iconType
        },
        isActive: isActive,
        isDisabled: isDisabled,
        'aria-label': tooltipKeymap ? (0, $cv8id.tooltip)(tooltipKeymap, String(content)) : String(content),
        'aria-keyshortcuts': (0, $cv8id.getAriaKeyshortcuts)(tooltipKeymap)
    };
};
const $441071f62ee239d0$var$IconsMarkSchema = {
    [(0, $kzqI4.IconTypes).strong]: 'strong',
    [(0, $kzqI4.IconTypes).em]: 'em',
    [(0, $kzqI4.IconTypes).strike]: 'strike',
    [(0, $kzqI4.IconTypes).code]: 'code',
    [(0, $kzqI4.IconTypes).underline]: 'underline',
    [(0, $kzqI4.IconTypes).superscript]: 'subsup',
    [(0, $kzqI4.IconTypes).subscript]: 'subsup'
};
const $441071f62ee239d0$var$buildMenuIconState = (iconMark)=>({ schema: schema, textFormattingState: textFormattingState })=>{
        const hasPluginState = Boolean(textFormattingState === null || textFormattingState === void 0 ? void 0 : textFormattingState.isInitialised);
        const markSchema = $441071f62ee239d0$var$IconsMarkSchema[iconMark];
        const hasSchemaMark = Boolean(schema.marks[markSchema]);
        if (!hasPluginState) return {
            isActive: false,
            isDisabled: true,
            isHidden: false,
            hasSchemaMark: hasSchemaMark
        };
        const isActive = textFormattingState === null || textFormattingState === void 0 ? void 0 : textFormattingState[`${iconMark}Active`];
        const isDisabled = textFormattingState === null || textFormattingState === void 0 ? void 0 : textFormattingState[`${iconMark}Disabled`];
        const isHidden = textFormattingState === null || textFormattingState === void 0 ? void 0 : textFormattingState[`${iconMark}Hidden`];
        return {
            isActive: Boolean(isActive),
            isDisabled: Boolean(isDisabled),
            isHidden: Boolean(isHidden),
            hasSchemaMark: hasSchemaMark
        };
    };
const $441071f62ee239d0$var$buildIcon = (iconMark, editorAnalyticsAPI, toolbarType)=>{
    const getState = $441071f62ee239d0$var$buildMenuIconState(iconMark);
    return ({ schema: schema, textFormattingState: textFormattingState, intl: intl, isToolbarDisabled: isToolbarDisabled })=>{
        const iconState = getState({
            schema: schema,
            textFormattingState: textFormattingState
        });
        const { isActive: isActive, isDisabled: isDisabled, isHidden: isHidden, hasSchemaMark: hasSchemaMark } = iconState;
        const iconComponent = (0, $bSJIT.useMemo)(()=>$441071f62ee239d0$var$getIcon({
                iconType: (0, $kzqI4.IconTypes)[iconMark],
                isDisabled: isToolbarDisabled || isDisabled,
                isActive: isActive,
                intl: intl,
                editorAnalyticsAPI: editorAnalyticsAPI,
                toolbarType: toolbarType
            }), [
            isToolbarDisabled,
            isDisabled,
            isActive,
            intl
        ]);
        const shouldRenderIcon = hasSchemaMark && !isHidden;
        return (0, $bSJIT.useMemo)(()=>shouldRenderIcon ? iconComponent : null, [
            shouldRenderIcon,
            iconComponent
        ]);
    };
};
const $441071f62ee239d0$export$6f298ec13df828 = ({ isToolbarDisabled: isToolbarDisabled, textFormattingState: textFormattingState, schema: schema, intl: intl, editorAnalyticsAPI: editorAnalyticsAPI, toolbarType: toolbarType })=>{
    const props = {
        schema: schema,
        textFormattingState: textFormattingState,
        intl: intl,
        isToolbarDisabled: Boolean(isToolbarDisabled),
        toolbarType: toolbarType
    };
    const buildStrongIcon = $441071f62ee239d0$var$buildIcon((0, $kzqI4.IconTypes).strong, editorAnalyticsAPI, toolbarType);
    const buildEmIcon = $441071f62ee239d0$var$buildIcon((0, $kzqI4.IconTypes).em, editorAnalyticsAPI, toolbarType);
    const buildUnderlineIcon = $441071f62ee239d0$var$buildIcon((0, $kzqI4.IconTypes).underline, editorAnalyticsAPI, toolbarType);
    const buildStrikeIcon = $441071f62ee239d0$var$buildIcon((0, $kzqI4.IconTypes).strike, editorAnalyticsAPI, toolbarType);
    const buildCodeIcon = $441071f62ee239d0$var$buildIcon((0, $kzqI4.IconTypes).code, editorAnalyticsAPI, toolbarType);
    const buildSubscriptIcon = $441071f62ee239d0$var$buildIcon((0, $kzqI4.IconTypes).subscript, editorAnalyticsAPI, toolbarType);
    const buildSuperscriptIcon = $441071f62ee239d0$var$buildIcon((0, $kzqI4.IconTypes).superscript, editorAnalyticsAPI, toolbarType);
    const strongIcon = buildStrongIcon(props);
    const emIcon = buildEmIcon(props);
    const underlineIcon = buildUnderlineIcon(props);
    const strikeIcon = buildStrikeIcon(props);
    const codeIcon = buildCodeIcon(props);
    const subscriptIcon = buildSubscriptIcon(props);
    const superscriptIcon = buildSuperscriptIcon(props);
    const result = (0, $bSJIT.useMemo)(()=>[
            strongIcon,
            emIcon,
            underlineIcon,
            strikeIcon,
            codeIcon,
            subscriptIcon,
            superscriptIcon
        ], [
        strongIcon,
        emIcon,
        underlineIcon,
        strikeIcon,
        codeIcon,
        subscriptIcon,
        superscriptIcon
    ]);
    return result;
};
const $441071f62ee239d0$export$cb0a2ed6e982a08f = ({ iconTypeList: iconTypeList, textFormattingState: textFormattingState })=>{
    const hasActiveFormatting = (0, $bSJIT.useMemo)(()=>{
        if (!(textFormattingState !== null && textFormattingState !== void 0 && textFormattingState.isInitialised)) return false;
        return iconTypeList.some((iconType)=>textFormattingState[`${iconType}Active`]);
    }, [
        textFormattingState,
        iconTypeList
    ]);
    return hasActiveFormatting;
};

});
parcelRegister("1RFZ5", function(module, exports) {
$parcel$export(module.exports, "Subscript", () => $ae4995adc031f68e$export$54eb3b8088f84d2b);
$parcel$export(module.exports, "Superscript", () => $ae4995adc031f68e$export$a4eac561e2e9d419);
/* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");
const $ae4995adc031f68e$var$SVGContainer = ({ children: children })=>/*#__PURE__*/ (0, $dc70d.jsx)("span", {
        style: {
            width: "var(--ds-space-300, 24px)",
            height: "var(--ds-space-300, 24px)",
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        },
        children: children
    });
const $ae4995adc031f68e$export$54eb3b8088f84d2b = ()=>/*#__PURE__*/ (0, $dc70d.jsx)($ae4995adc031f68e$var$SVGContainer, {
        children: /*#__PURE__*/ (0, $dc70d.jsx)("svg", {
            width: "16",
            height: "16",
            viewBox: "0 0 16 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $dc70d.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M5.10609 6.54799L7.88895 2.09448L9.16102 2.88936L5.99047 7.9633L9.21219 13.1191L7.94012 13.914L5.10609 9.37861L2.27207 13.914L1 13.1191L4.2217 7.9633L1.05117 2.88939L2.32324 2.09451L5.10609 6.54799ZM10.858 15.0001V13.696H12.3499V10.3153L10.8418 11.4343V9.86413L12.3138 8.83114H13.8161V13.696H14.9999V15.0001H10.858Z",
                fill: "currentColor"
            })
        })
    });
const $ae4995adc031f68e$export$a4eac561e2e9d419 = ()=>/*#__PURE__*/ (0, $dc70d.jsx)($ae4995adc031f68e$var$SVGContainer, {
        children: /*#__PURE__*/ (0, $dc70d.jsx)("svg", {
            width: "16",
            height: "16",
            viewBox: "0 0 16 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $dc70d.jsx)("path", {
                "fill-rule": "evenodd",
                "clip-rule": "evenodd",
                d: "M10.858 7.16892V5.86487H12.3499V2.4842L10.8418 3.60312V2.03298L12.3138 1H13.8161V5.86487H14.9999V7.16892H10.858ZM5.10609 6.5479L7.88895 2.09439L9.16102 2.88927L5.99047 7.96321L9.21219 13.119L7.94012 13.9139L5.10609 9.37852L2.27207 13.9139L1 13.119L4.2217 7.96321L1.05117 2.8893L2.32324 2.09442L5.10609 6.5479Z",
                fill: "currentColor"
            })
        })
    });

});


parcelRegister("89gD0", function(module, exports) {
$parcel$export(module.exports, "useIconList", () => $db9da3abf756a4f1$export$894adbec036a07c6);

var $bSJIT = parcelRequire("bSJIT");
const $db9da3abf756a4f1$export$894adbec036a07c6 = ({ icons: icons, iconTypeList: iconTypeList })=>{
    return (0, $bSJIT.useMemo)(()=>{
        return icons.reduce((acc, icon)=>{
            if (!icon || !icon.iconMark) return acc;
            const isIconSingleButton = iconTypeList.includes(icon.iconMark);
            if (isIconSingleButton) return {
                dropdownItems: acc.dropdownItems,
                singleItems: [
                    ...acc.singleItems,
                    icon
                ]
            };
            return {
                dropdownItems: [
                    ...acc.dropdownItems,
                    icon
                ],
                singleItems: acc.singleItems
            };
        }, {
            dropdownItems: [],
            singleItems: []
        });
    }, [
        icons,
        iconTypeList
    ]);
};

});

parcelRegister("6Khbz", function(module, exports) {
$parcel$export(module.exports, "SingleToolbarButtons", () => $e7f0453824ea087a$export$e3e9702c9c21585);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $g42cj = parcelRequire("g42cj");

var $8zO6u = parcelRequire("8zO6u");
const $e7f0453824ea087a$export$e3e9702c9c21585 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).memo(({ items: items, isReducedSpacing: isReducedSpacing, editorView: editorView })=>{
    const onClick = (0, $bSJIT.useCallback)((command)=>{
        return ()=>{
            command(editorView.state, editorView.dispatch);
            return false;
        };
    }, [
        editorView.state,
        editorView.dispatch
    ]);
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $9dQre.jsx)("span", {
        css: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
        (0, $g42cj.buttonGroupStyle)
    }, items.map((item)=>/*#__PURE__*/ (0, $9dQre.jsx)((0, $8zO6u.default), {
            key: item.key,
            testId: `editor-toolbar__${String(item.content)}`,
            buttonId: item.buttonId,
            spacing: isReducedSpacing ? 'none' : 'default',
            onClick: onClick(item.command),
            selected: item.isActive,
            disabled: item.isDisabled,
            title: item.tooltipElement,
            iconBefore: item.iconElement,
            "aria-pressed": item.isActive,
            "aria-label": item['aria-label'] ?? String(item.content),
            "aria-keyshortcuts": item['aria-keyshortcuts']
        }))));
});

});


parcelRegister("4Yo2H", function(module, exports) {
$parcel$export(module.exports, "PrimaryToolbarComponent", () => $0dbd37946cacb1fa$export$94516d5cccf573e3);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $5beht = parcelRequire("5beht");

var $72hRZ = parcelRequire("72hRZ");

var $kzqI4 = parcelRequire("kzqI4");
const $0dbd37946cacb1fa$var$selector = (states)=>{
    var _states$textFormattin, _states$textFormattin2, _states$textFormattin3, _states$textFormattin4, _states$textFormattin5, _states$textFormattin6, _states$textFormattin7, _states$textFormattin8, _states$textFormattin9, _states$textFormattin0, _states$textFormattin1, _states$textFormattin10, _states$textFormattin11, _states$textFormattin12, _states$textFormattin13, _states$textFormattin14, _states$textFormattin15, _states$textFormattin16, _states$textFormattin17, _states$textFormattin18, _states$textFormattin19, _states$textFormattin20, _states$textFormattin21;
    return {
        isInitialised: Boolean((_states$textFormattin = states.textFormattingState) === null || _states$textFormattin === void 0 ? void 0 : _states$textFormattin.isInitialised),
        formattingIsPresent: (_states$textFormattin2 = states.textFormattingState) === null || _states$textFormattin2 === void 0 ? void 0 : _states$textFormattin2.formattingIsPresent,
        emActive: (_states$textFormattin3 = states.textFormattingState) === null || _states$textFormattin3 === void 0 ? void 0 : _states$textFormattin3.emActive,
        emDisabled: (_states$textFormattin4 = states.textFormattingState) === null || _states$textFormattin4 === void 0 ? void 0 : _states$textFormattin4.emDisabled,
        emHidden: (_states$textFormattin5 = states.textFormattingState) === null || _states$textFormattin5 === void 0 ? void 0 : _states$textFormattin5.emHidden,
        codeActive: (_states$textFormattin6 = states.textFormattingState) === null || _states$textFormattin6 === void 0 ? void 0 : _states$textFormattin6.codeActive,
        codeDisabled: (_states$textFormattin7 = states.textFormattingState) === null || _states$textFormattin7 === void 0 ? void 0 : _states$textFormattin7.codeDisabled,
        codeHidden: (_states$textFormattin8 = states.textFormattingState) === null || _states$textFormattin8 === void 0 ? void 0 : _states$textFormattin8.codeHidden,
        underlineActive: (_states$textFormattin9 = states.textFormattingState) === null || _states$textFormattin9 === void 0 ? void 0 : _states$textFormattin9.underlineActive,
        underlineDisabled: (_states$textFormattin0 = states.textFormattingState) === null || _states$textFormattin0 === void 0 ? void 0 : _states$textFormattin0.underlineDisabled,
        underlineHidden: (_states$textFormattin1 = states.textFormattingState) === null || _states$textFormattin1 === void 0 ? void 0 : _states$textFormattin1.underlineHidden,
        strikeActive: (_states$textFormattin10 = states.textFormattingState) === null || _states$textFormattin10 === void 0 ? void 0 : _states$textFormattin10.strikeActive,
        strikeDisabled: (_states$textFormattin11 = states.textFormattingState) === null || _states$textFormattin11 === void 0 ? void 0 : _states$textFormattin11.strikeDisabled,
        strikeHidden: (_states$textFormattin12 = states.textFormattingState) === null || _states$textFormattin12 === void 0 ? void 0 : _states$textFormattin12.strikeHidden,
        strongActive: (_states$textFormattin13 = states.textFormattingState) === null || _states$textFormattin13 === void 0 ? void 0 : _states$textFormattin13.strongActive,
        strongDisabled: (_states$textFormattin14 = states.textFormattingState) === null || _states$textFormattin14 === void 0 ? void 0 : _states$textFormattin14.strongDisabled,
        strongHidden: (_states$textFormattin15 = states.textFormattingState) === null || _states$textFormattin15 === void 0 ? void 0 : _states$textFormattin15.strongHidden,
        superscriptActive: (_states$textFormattin16 = states.textFormattingState) === null || _states$textFormattin16 === void 0 ? void 0 : _states$textFormattin16.superscriptActive,
        superscriptDisabled: (_states$textFormattin17 = states.textFormattingState) === null || _states$textFormattin17 === void 0 ? void 0 : _states$textFormattin17.superscriptDisabled,
        superscriptHidden: (_states$textFormattin18 = states.textFormattingState) === null || _states$textFormattin18 === void 0 ? void 0 : _states$textFormattin18.superscriptHidden,
        subscriptActive: (_states$textFormattin19 = states.textFormattingState) === null || _states$textFormattin19 === void 0 ? void 0 : _states$textFormattin19.subscriptActive,
        subscriptDisabled: (_states$textFormattin20 = states.textFormattingState) === null || _states$textFormattin20 === void 0 ? void 0 : _states$textFormattin20.subscriptDisabled,
        subscriptHidden: (_states$textFormattin21 = states.textFormattingState) === null || _states$textFormattin21 === void 0 ? void 0 : _states$textFormattin21.subscriptHidden
    };
};
const $0dbd37946cacb1fa$export$94516d5cccf573e3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).memo(({ api: api, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement, toolbarSize: toolbarSize, editorView: editorView, disabled: disabled, isReducedSpacing: isReducedSpacing, shouldUseResponsiveToolbar: shouldUseResponsiveToolbar })=>{
    var _api$analytics;
    const textFormattingState = (0, $5beht.useSharedPluginStateWithSelector)(api, [
        'textFormatting'
    ], $0dbd37946cacb1fa$var$selector);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $72hRZ.default), {
        textFormattingState: textFormattingState,
        popupsMountPoint: popupsMountPoint,
        popupsScrollableElement: popupsScrollableElement,
        toolbarSize: toolbarSize,
        isReducedSpacing: isReducedSpacing,
        editorView: editorView,
        isToolbarDisabled: disabled,
        shouldUseResponsiveToolbar: shouldUseResponsiveToolbar,
        editorAnalyticsAPI: api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions,
        api: api,
        toolbarType: (0, $kzqI4.ToolbarType).PRIMARY
    });
});

});
parcelRegister("72hRZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $7e12c72293e40007$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $fK3tS = parcelRequire("fK3tS");

var $4ambm = parcelRequire("4ambm");

var $glyUo = parcelRequire("glyUo");

var $g42cj = parcelRequire("g42cj");

var $b2855 = parcelRequire("b2855");

var $797yE = parcelRequire("797yE");

var $2poSi = parcelRequire("2poSi");

var $35tyQ = parcelRequire("35tyQ");

var $bvs15 = parcelRequire("bvs15");

var $aXeYj = parcelRequire("aXeYj");

var $g19LL = parcelRequire("g19LL");

var $ljCNh = parcelRequire("ljCNh");

var $6Khbz = parcelRequire("6Khbz");
const $7e12c72293e40007$var$ToolbarFormatting = ({ shouldUseResponsiveToolbar: shouldUseResponsiveToolbar, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, editorView: editorView, toolbarSize: toolbarSize, isReducedSpacing: isReducedSpacing, isToolbarDisabled: isToolbarDisabled, intl: intl, editorAnalyticsAPI: editorAnalyticsAPI, textFormattingState: textFormattingState, api: api, toolbarType: toolbarType })=>{
    const [message, setMessage] = (0, $bSJIT.useState)('');
    const { formattingIsPresent: formattingIsPresent, ...formattingIconState } = textFormattingState;
    const defaultIcons = (0, $aXeYj.useFormattingIcons)({
        schema: editorView.state.schema,
        intl: intl,
        isToolbarDisabled: isToolbarDisabled,
        editorAnalyticsAPI: editorAnalyticsAPI,
        textFormattingState: formattingIconState,
        toolbarType: toolbarType
    });
    const clearIcon = (0, $bvs15.useClearIcon)({
        formattingPluginInitialised: textFormattingState.isInitialised,
        formattingIsPresent: formattingIsPresent,
        intl: intl,
        editorAnalyticsAPI: editorAnalyticsAPI,
        toolbarType: toolbarType
    });
    const menuIconTypeList = (0, $g19LL.useResponsiveIconTypeMenu)({
        toolbarSize: toolbarSize,
        responsivenessEnabled: shouldUseResponsiveToolbar
    });
    const hasFormattingActive = (0, $aXeYj.useHasFormattingActived)({
        iconTypeList: menuIconTypeList,
        textFormattingState: textFormattingState
    });
    const { dropdownItems: dropdownItems, singleItems: singleItems } = (0, $g19LL.useResponsiveToolbarButtons)({
        icons: defaultIcons,
        toolbarSize: toolbarSize,
        responsivenessEnabled: shouldUseResponsiveToolbar
    });
    const clearFormattingStatus = intl.formatMessage((0, $glyUo.toolbarMessages).textFormattingOff);
    const superscriptOffSubscriptOnStatus = intl.formatMessage((0, $glyUo.toolbarMessages).superscriptOffSubscriptOn);
    const subscriptOffSuperscriptOnStatus = intl.formatMessage((0, $glyUo.toolbarMessages).subscriptOffSuperscriptOn);
    // eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- Ignored via go/ees017 (to be fixed)
    const activeItems = [
        ...dropdownItems,
        ...singleItems
    ].filter((item)=>item.isActive);
    const prevActiveItems = (0, $b2855.default)(activeItems) ?? [];
    const fromSuperscriptToSubscript = (0, $2poSi.isArrayContainsContent)(activeItems, 'Subscript') && (0, $2poSi.isArrayContainsContent)(prevActiveItems, 'Superscript');
    const fromSubscriptToSuperscript = (0, $2poSi.isArrayContainsContent)(activeItems, 'Superscript') && (0, $2poSi.isArrayContainsContent)(prevActiveItems, 'Subscript');
    let comparedItems;
    let screenReaderMessage = '';
    if (prevActiveItems && activeItems.length > prevActiveItems.length) {
        comparedItems = (0, $2poSi.compareItemsArrays)(activeItems, prevActiveItems);
        screenReaderMessage = intl.formatMessage((0, $glyUo.toolbarMessages).on, {
            formattingType: comparedItems[0].content
        });
    } else {
        comparedItems = (0, $2poSi.compareItemsArrays)(prevActiveItems, activeItems);
        if (comparedItems && comparedItems.length) {
            var _activeItems$;
            screenReaderMessage = intl.formatMessage((0, $glyUo.toolbarMessages).off, {
                formattingType: comparedItems[0].content
            });
            if (((_activeItems$ = activeItems[0]) === null || _activeItems$ === void 0 ? void 0 : _activeItems$.content) === 'Code') screenReaderMessage = intl.formatMessage((0, $glyUo.toolbarMessages).codeOn, {
                textFormattingOff: (prevActiveItems === null || prevActiveItems === void 0 ? void 0 : prevActiveItems.length) > 1 ? clearFormattingStatus : screenReaderMessage
            });
            if (fromSuperscriptToSubscript) screenReaderMessage = superscriptOffSubscriptOnStatus;
            if (fromSubscriptToSuperscript) screenReaderMessage = subscriptOffSuperscriptOnStatus;
        }
    }
    // handle 'Clear formatting' status for screen readers
    if (!(activeItems !== null && activeItems !== void 0 && activeItems.length) && (prevActiveItems === null || prevActiveItems === void 0 ? void 0 : prevActiveItems.length) > 1) screenReaderMessage = clearFormattingStatus;
    const items = (0, $bSJIT.useMemo)(()=>{
        if (!clearIcon) return [
            {
                items: dropdownItems
            }
        ];
        return [
            {
                items: dropdownItems
            },
            {
                items: [
                    clearIcon
                ]
            }
        ];
    }, [
        clearIcon,
        dropdownItems
    ]);
    const moreFormattingButtonLabel = intl.formatMessage((0, $glyUo.toolbarMessages).moreFormatting);
    const labelTextFormat = intl.formatMessage((0, $glyUo.toolbarMessages).textFormatting);
    (0, $bSJIT.useEffect)(()=>{
        if (screenReaderMessage) setMessage(screenReaderMessage);
    }, [
        screenReaderMessage
    ]);
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $9dQre.jsx)("span", {
        css: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
        (0, $g42cj.buttonGroupStyle)
    }, /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        role: "group",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: 'js-text-format-wrap',
        "aria-label": labelTextFormat
    }, message && /*#__PURE__*/ (0, $9dQre.jsx)((0, $4ambm.default), {
        ariaLive: "assertive",
        text: message,
        ariaRelevant: "additions",
        delay: 250
    }), /*#__PURE__*/ (0, $9dQre.jsx)((0, $6Khbz.SingleToolbarButtons), {
        items: singleItems,
        editorView: editorView,
        isReducedSpacing: isReducedSpacing
    }), /*#__PURE__*/ (0, $9dQre.jsx)("span", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage
        css: (0, $g42cj.wrapperStyle)
    }, isToolbarDisabled && !(0, $797yE.editorExperiment)('platform_editor_controls', 'variant1') ? /*#__PURE__*/ (0, $9dQre.jsx)("div", null, /*#__PURE__*/ (0, $9dQre.jsx)((0, $ljCNh.MoreButton), {
        label: moreFormattingButtonLabel,
        isReducedSpacing: isReducedSpacing,
        isDisabled: true,
        isSelected: false,
        "aria-expanded": undefined,
        "aria-pressed": undefined
    })) : /*#__PURE__*/ (0, $9dQre.jsx)((0, $35tyQ.FormattingTextDropdownMenu), {
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        editorView: editorView,
        isReducedSpacing: isReducedSpacing,
        moreButtonLabel: moreFormattingButtonLabel,
        hasFormattingActive: hasFormattingActive,
        hasMoreButton: !(0, $797yE.editorExperiment)('platform_editor_controls', 'variant1'),
        items: items,
        intl: intl,
        toolbarType: toolbarType,
        isDisabled: (0, $797yE.editorExperiment)('platform_editor_controls', 'variant1') ? isToolbarDisabled : false
    }))), !(api !== null && api !== void 0 && api.primaryToolbar) && /* eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $9dQre.jsx)("span", {
        css: (0, $g42cj.separatorStyles)
    })));
};
const $7e12c72293e40007$var$Toolbar = ({ popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement, toolbarSize: toolbarSize, isReducedSpacing: isReducedSpacing, editorView: editorView, isToolbarDisabled: isToolbarDisabled, shouldUseResponsiveToolbar: shouldUseResponsiveToolbar, intl: intl, editorAnalyticsAPI: editorAnalyticsAPI, textFormattingState: textFormattingState, api: api, toolbarType: toolbarType })=>{
    return /*#__PURE__*/ (0, $9dQre.jsx)($7e12c72293e40007$var$ToolbarFormatting, {
        textFormattingState: textFormattingState,
        popupsMountPoint: popupsMountPoint,
        popupsScrollableElement: popupsScrollableElement,
        toolbarSize: toolbarSize,
        isReducedSpacing: isReducedSpacing,
        editorView: editorView,
        isToolbarDisabled: isToolbarDisabled,
        shouldUseResponsiveToolbar: shouldUseResponsiveToolbar,
        intl: intl,
        editorAnalyticsAPI: editorAnalyticsAPI,
        api: api,
        toolbarType: toolbarType
    });
};
const $7e12c72293e40007$var$_default_1 = (0, $fK3tS.default)($7e12c72293e40007$var$Toolbar);
var $7e12c72293e40007$export$2e2bcd8739ae039 = $7e12c72293e40007$var$_default_1;

});
parcelRegister("g19LL", function(module, exports) {
$parcel$export(module.exports, "useResponsiveIconTypeMenu", () => $727b6d1914aafa86$export$110e6c3d6580196f);
$parcel$export(module.exports, "useResponsiveToolbarButtons", () => $727b6d1914aafa86$export$efa5449fdb315092);

var $bSJIT = parcelRequire("bSJIT");

var $797yE = parcelRequire("797yE");

var $jhjTO = parcelRequire("jhjTO");

var $89gD0 = parcelRequire("89gD0");
const $727b6d1914aafa86$export$29ca18d8ace26dd8 = ({ toolbarSize: toolbarSize, responsivenessEnabled: responsivenessEnabled })=>{
    let ResponsiveCustomButtonToolbar = (0, $jhjTO.ResponsiveCustomButtonToolbarCompact);
    if ((0, $797yE.editorExperiment)('platform_editor_controls', 'variant1')) ResponsiveCustomButtonToolbar = (0, $jhjTO.ResponsiveCustomButtonToolbarMinimal);
    const iconTypeList = (0, $bSJIT.useMemo)(()=>ResponsiveCustomButtonToolbar[toolbarSize], [
        toolbarSize,
        ResponsiveCustomButtonToolbar
    ]);
    if (responsivenessEnabled) return iconTypeList;
    if ((0, $797yE.editorExperiment)('platform_editor_controls', 'variant1')) return 0, $jhjTO.ToolbarButtonsStrong;
    else return 0, $jhjTO.ToolbarButtonsStrongItalic;
};
const $727b6d1914aafa86$export$110e6c3d6580196f = ({ toolbarSize: toolbarSize, responsivenessEnabled: responsivenessEnabled })=>{
    let ResponsiveCustomMenu = (0, $jhjTO.ResponsiveCustomMenuCompact);
    if ((0, $797yE.editorExperiment)('platform_editor_controls', 'variant1')) ResponsiveCustomMenu = (0, $jhjTO.ResponsiveCustomMenuMinimal);
    const iconTypeList = (0, $bSJIT.useMemo)(()=>ResponsiveCustomMenu[toolbarSize], [
        toolbarSize,
        ResponsiveCustomMenu
    ]);
    if (responsivenessEnabled) return iconTypeList;
    if ((0, $797yE.editorExperiment)('platform_editor_controls', 'variant1')) return 0, $jhjTO.ButtonsMenuMinimal;
    else return 0, $jhjTO.ToolbarButtonsStrongItalic;
};
const $727b6d1914aafa86$export$efa5449fdb315092 = ({ icons: icons, toolbarSize: toolbarSize, responsivenessEnabled: responsivenessEnabled })=>{
    const iconTypeList = $727b6d1914aafa86$export$29ca18d8ace26dd8({
        toolbarSize: toolbarSize,
        responsivenessEnabled: responsivenessEnabled
    });
    const iconsPosition = (0, $89gD0.useIconList)({
        icons: icons,
        iconTypeList: iconTypeList
    });
    return iconsPosition;
};

});



parcelRegister("lkX9A", function(module, exports) {
$parcel$export(module.exports, "getToolbarComponents", () => $7f37272be3623ccc$export$a758406ca53b86a5);

var $bHNsv = parcelRequire("bHNsv");

var $6IuML = parcelRequire("6IuML");

var $agbex = parcelRequire("agbex");

var $hqZ8n = parcelRequire("hqZ8n");

var $2pTzV = parcelRequire("2pTzV");
const $7f37272be3623ccc$export$a758406ca53b86a5 = (api, options)=>{
    return [
        ...(0, $agbex.textFormattingGroupForPrimaryToolbar)(api),
        ...(0, $6IuML.textFormattingGroupForInlineToolbar)(api),
        ...(0, $bHNsv.boldButtonGroup)(api),
        ...options !== null && options !== void 0 && options.disableUnderline ? [] : (0, $2pTzV.underlineButtonGroup)(api),
        ...(0, $hqZ8n.textFormattingMenuGroup)(api)
    ];
};

});
parcelRegister("bHNsv", function(module, exports) {
$parcel$export(module.exports, "boldButtonGroup", () => $2b0db4036f216149$export$838bd3df7e6d113c);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $28qc1 = parcelRequire("28qc1");

var $4rzOL = parcelRequire("4rzOL");

var $fiku8 = parcelRequire("fiku8");

var $f6IUb = parcelRequire("f6IUb");

var $5gDEv = parcelRequire("5gDEv");

var $kzqI4 = parcelRequire("kzqI4");

var $3An2a = parcelRequire("3An2a");

var $3eGFf = parcelRequire("3eGFf");
const $2b0db4036f216149$var$BoldButtonGroup = ({ children: children })=>{
    const { editorAppearance: editorAppearance } = (0, $28qc1.useEditorToolbar)();
    if (editorAppearance === 'full-page') return /*#__PURE__*/ (0, $dc70d.jsx)((0, $f6IUb.Show), {
        above: "xl",
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $5gDEv.ToolbarButtonGroup), {
            children: children
        })
    });
};
const $2b0db4036f216149$export$838bd3df7e6d113c = (api)=>[
        {
            type: (0, $4rzOL.BOLD_BUTTON_GROUP).type,
            key: (0, $4rzOL.BOLD_BUTTON_GROUP).key,
            parents: [
                {
                    type: (0, $4rzOL.TEXT_SECTION_PRIMARY_TOOLBAR).type,
                    key: (0, $4rzOL.TEXT_SECTION_PRIMARY_TOOLBAR).key,
                    rank: (0, $fiku8.TEXT_SECTION_PRIMARY_TOOLBAR_RANK)[(0, $4rzOL.BOLD_BUTTON_GROUP).key]
                }
            ],
            component: ({ children: children })=>{
                return /*#__PURE__*/ (0, $dc70d.jsx)($2b0db4036f216149$var$BoldButtonGroup, {
                    children: children
                });
            }
        },
        {
            type: (0, $4rzOL.BOLD_BUTTON).type,
            key: (0, $4rzOL.BOLD_BUTTON).key,
            parents: [
                {
                    type: (0, $4rzOL.BOLD_BUTTON_GROUP).type,
                    key: (0, $4rzOL.BOLD_BUTTON_GROUP).key,
                    rank: 100
                }
            ],
            component: ({ parents: parents })=>{
                const { icon: icon, command: command, shortcut: shortcut, title: title } = (0, $3eGFf.formatOptions)().strong;
                return /*#__PURE__*/ (0, $dc70d.jsx)((0, $3An2a.FormatButton), {
                    api: api,
                    parents: parents,
                    icon: icon,
                    title: title,
                    shortcut: shortcut,
                    optionType: (0, $kzqI4.FormatOptions).strong,
                    toggleMarkWithAnalyticsCallback: command
                });
            }
        }
    ];

});
parcelRegister("3An2a", function(module, exports) {
$parcel$export(module.exports, "FormatMenuItem", () => $fffb48a0af66bb78$export$ddf8e5968f0fbf06);
$parcel$export(module.exports, "FormatButton", () => $fffb48a0af66bb78$export$4ce756b69a643bb2);
$parcel$export(module.exports, "ClearFormatMenuItem", () => $fffb48a0af66bb78$export$2d10ff258f7812b8);
$parcel$export(module.exports, "MoreFormattingMenu", () => $fffb48a0af66bb78$export$f2e08b351bba4df);
$parcel$export(module.exports, "MenuSection", () => $fffb48a0af66bb78$export$4b1545b4f2016d26);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $cv8id = parcelRequire("cv8id");

var $glyUo = parcelRequire("glyUo");

var $96hEQ = parcelRequire("96hEQ");

var $4rzOL = parcelRequire("4rzOL");

var $5beht = parcelRequire("5beht");

var $dbIlo = parcelRequire("dbIlo");

var $11XBj = parcelRequire("11XBj");

var $7cgYb = parcelRequire("7cgYb");

var $dbuPt = parcelRequire("dbuPt");

var $dlk6h = parcelRequire("dlk6h");

var $6PDfA = parcelRequire("6PDfA");

var $jBWM2 = parcelRequire("jBWM2");

var $eHnl8 = parcelRequire("eHnl8");

var $h2Fei = parcelRequire("h2Fei");

var $3eGFf = parcelRequire("3eGFf");
const $fffb48a0af66bb78$export$ddf8e5968f0fbf06 = ({ parents: parents, api: api, optionType: optionType, toggleMarkWithAnalyticsCallback: toggleMarkWithAnalyticsCallback, icon: icon, shortcut: shortcut, title: title })=>{
    const { isActive: isActive, isDisabled: isDisabled, isHidden: isHidden, shortcutContent: shortcutContent, onClick: onClick, ariaLabel: ariaLabel, formatTitle: formatTitle } = (0, $3eGFf.useComponentInfo)({
        api: api,
        optionType: optionType,
        title: title,
        shortcut: shortcut,
        toggleMarkWithAnalyticsCallback: toggleMarkWithAnalyticsCallback,
        parents: parents
    });
    const Icon = icon;
    if (isHidden) return null;
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dbuPt.ToolbarDropdownItem), {
        elemBefore: /*#__PURE__*/ (0, $dc70d.jsx)(Icon, {
            size: "small",
            label: ""
        }),
        elemAfter: shortcutContent && /*#__PURE__*/ (0, $dc70d.jsx)((0, $jBWM2.ToolbarKeyboardShortcutHint), {
            shortcut: shortcutContent
        }),
        isDisabled: isDisabled,
        isSelected: isActive,
        onClick: onClick,
        "aria-keyshortcuts": (0, $cv8id.getAriaKeyshortcuts)(shortcut),
        "aria-label": ariaLabel,
        children: formatTitle
    });
};
const $fffb48a0af66bb78$export$4ce756b69a643bb2 = ({ parents: parents, api: api, optionType: optionType, toggleMarkWithAnalyticsCallback: toggleMarkWithAnalyticsCallback, icon: icon, shortcut: shortcut, title: title })=>{
    const { isActive: isActive, isDisabled: isDisabled, onClick: onClick, ariaLabel: ariaLabel, formatTitle: formatTitle } = (0, $3eGFf.useComponentInfo)({
        api: api,
        optionType: optionType,
        title: title,
        shortcut: shortcut,
        toggleMarkWithAnalyticsCallback: toggleMarkWithAnalyticsCallback,
        parents: parents
    });
    const Icon = icon;
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $eHnl8.ToolbarTooltip), {
        content: /*#__PURE__*/ (0, $dc70d.jsx)((0, $cv8id.ToolTipContent), {
            description: formatTitle,
            keymap: shortcut
        }),
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $7cgYb.ToolbarButton), {
            iconBefore: /*#__PURE__*/ (0, $dc70d.jsx)(Icon, {
                label: ariaLabel,
                size: "small"
            }),
            onClick: onClick,
            isSelected: isActive,
            isDisabled: isDisabled,
            ariaKeyshortcuts: (0, $cv8id.getAriaKeyshortcuts)(shortcut),
            testId: `editor-toolbar__${formatTitle}`
        })
    });
};
const $fffb48a0af66bb78$export$2d10ff258f7812b8 = ({ api: api, parents: parents })=>{
    const { isInitialised: isInitialised, isFormattingPresent: isFormattingPresent } = (0, $5beht.useSharedPluginStateWithSelector)(api, [
        'textFormatting'
    ], (states)=>{
        var _states$textFormattin, _states$textFormattin2;
        return {
            isInitialised: (_states$textFormattin = states.textFormattingState) === null || _states$textFormattin === void 0 ? void 0 : _states$textFormattin.isInitialised,
            isFormattingPresent: (_states$textFormattin2 = states.textFormattingState) === null || _states$textFormattin2 === void 0 ? void 0 : _states$textFormattin2.formattingIsPresent
        };
    });
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    if (!isInitialised) return null;
    const formatTitle = formatMessage((0, $glyUo.toolbarMessages).clearFormatting);
    const shortcutContent = (0, $cv8id.tooltip)((0, $cv8id.clearFormatting));
    const onClick = ()=>{
        var _api$analytics;
        api === null || api === void 0 || api.core.actions.execute((0, $h2Fei.clearFormattingWithAnalyticsNext)(api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions)((0, $96hEQ.getInputMethodFromParentKeys)(parents)));
    };
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dbuPt.ToolbarDropdownItem), {
        elemBefore: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dbIlo))), {
            label: "",
            size: "small"
        }),
        elemAfter: shortcutContent && /*#__PURE__*/ (0, $dc70d.jsx)((0, $jBWM2.ToolbarKeyboardShortcutHint), {
            shortcut: shortcutContent
        }),
        isDisabled: !isFormattingPresent,
        onClick: onClick,
        ariaKeyshortcuts: (0, $cv8id.getAriaKeyshortcuts)((0, $cv8id.clearFormatting)),
        children: formatTitle
    });
};
const $fffb48a0af66bb78$export$f2e08b351bba4df = ({ children: children })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const content = formatMessage((0, $glyUo.toolbarMessages).moreFormatting);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $6PDfA.ToolbarDropdownMenu), {
        iconBefore: /*#__PURE__*/ (0, $dc70d.jsx)((0, $11XBj.MoreItemsIcon), {
            label: "",
            testId: "more-formatting"
        }),
        label: content,
        tooltipComponent: /*#__PURE__*/ (0, $dc70d.jsx)((0, $eHnl8.ToolbarTooltip), {
            content: formatMessage((0, $glyUo.toolbarMessages).textFormat)
        }),
        children: children
    });
};
const $fffb48a0af66bb78$export$4b1545b4f2016d26 = ({ children: children, title: title, parents: parents })=>{
    const hasSeparator = parents.some((parent)=>parent.key === (0, $4rzOL.TEXT_COLLAPSED_MENU).key);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dlk6h.ToolbarDropdownItemSection), {
        hasSeparator: hasSeparator,
        title: title,
        children: children
    });
};

});
parcelRegister("3eGFf", function(module, exports) {
$parcel$export(module.exports, "useComponentInfo", () => $e28feca8387dfecd$export$fd1f6c37ffd41092);
$parcel$export(module.exports, "formatOptions", () => $e28feca8387dfecd$export$fb6751f88f91d177);

var $4vLTk = parcelRequire("4vLTk");

var $cv8id = parcelRequire("cv8id");

var $glyUo = parcelRequire("glyUo");

var $96hEQ = parcelRequire("96hEQ");

var $4rzOL = parcelRequire("4rzOL");

var $fiku8 = parcelRequire("fiku8");

var $5beht = parcelRequire("5beht");

var $dY4yK = parcelRequire("dY4yK");

var $imwtU = parcelRequire("imwtU");

var $ktWlR = parcelRequire("ktWlR");

var $74hnl = parcelRequire("74hnl");

var $dROaw = parcelRequire("dROaw");

var $6v9rL = parcelRequire("6v9rL");

var $dTdDF = parcelRequire("dTdDF");

var $5jSEp = parcelRequire("5jSEp");
const $e28feca8387dfecd$var$FormatMarkSchema = {
    strong: 'strong',
    em: 'em',
    underline: 'underline',
    strike: 'strike',
    code: 'code',
    subscript: 'subsup',
    superscript: 'subsup'
};
const $e28feca8387dfecd$export$fd1f6c37ffd41092 = ({ api: api, optionType: optionType, title: title, shortcut: shortcut, toggleMarkWithAnalyticsCallback: toggleMarkWithAnalyticsCallback, parents: parents })=>{
    var _api$core;
    const { isActive: isActive, isDisabled: isDisabled, isHidden: isHidden, isPluginInitialised: isPluginInitialised } = (0, $5beht.useSharedPluginStateWithSelector)(api, [
        'textFormatting'
    ], (states)=>{
        var _states$textFormattin, _states$textFormattin2, _states$textFormattin3, _states$textFormattin4;
        return {
            isActive: (_states$textFormattin = states.textFormattingState) === null || _states$textFormattin === void 0 ? void 0 : _states$textFormattin[`${optionType}Active`],
            isDisabled: (_states$textFormattin2 = states.textFormattingState) === null || _states$textFormattin2 === void 0 ? void 0 : _states$textFormattin2[`${optionType}Disabled`],
            isHidden: (_states$textFormattin3 = states.textFormattingState) === null || _states$textFormattin3 === void 0 ? void 0 : _states$textFormattin3[`${optionType}Hidden`],
            isPluginInitialised: (_states$textFormattin4 = states.textFormattingState) === null || _states$textFormattin4 === void 0 ? void 0 : _states$textFormattin4.isInitialised
        };
    });
    const hasMarkSchema = api === null || api === void 0 || (_api$core = api.core) === null || _api$core === void 0 || (_api$core = _api$core.sharedState.currentState()) === null || _api$core === void 0 || (_api$core = _api$core.schema) === null || _api$core === void 0 ? void 0 : _api$core.marks[$e28feca8387dfecd$var$FormatMarkSchema[optionType]];
    let formatOptionState;
    if (!isPluginInitialised) formatOptionState = {
        isActive: false,
        isDisabled: true,
        isHidden: false
    };
    else formatOptionState = {
        isActive: Boolean(isActive),
        isDisabled: Boolean(isDisabled),
        isHidden: Boolean(!hasMarkSchema || isHidden)
    };
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const formatTitle = formatMessage(title);
    const shortcutContent = (0, $cv8id.tooltip)(shortcut);
    const ariaLabel = (0, $cv8id.tooltip)(shortcut, formatTitle);
    const onClick = ()=>{
        var _api$analytics;
        api === null || api === void 0 || api.core.actions.execute(toggleMarkWithAnalyticsCallback(api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions)((0, $96hEQ.getInputMethodFromParentKeys)(parents)));
    };
    return {
        ...formatOptionState,
        formatTitle: formatTitle,
        shortcutContent: shortcutContent,
        ariaLabel: ariaLabel || formatTitle,
        onClick: onClick
    };
};
const $e28feca8387dfecd$export$fb6751f88f91d177 = ()=>({
        strong: {
            rank: (0, $fiku8.TEXT_FORMATTING_MENU_SECTION_RANK)[(0, $4rzOL.BOLD_MENU_ITEM).key],
            key: (0, $4rzOL.BOLD_MENU_ITEM).key,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($dY4yK))),
            title: (0, $glyUo.toolbarMessages).bold,
            command: (0, $5jSEp.toggleStrongWithAnalytics),
            shortcut: (0, $cv8id.toggleBold)
        },
        em: {
            rank: (0, $fiku8.TEXT_FORMATTING_MENU_SECTION_RANK)[(0, $4rzOL.ITALIC_MENU_ITEM).key],
            key: (0, $4rzOL.ITALIC_MENU_ITEM).key,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($ktWlR))),
            title: (0, $glyUo.toolbarMessages).italic,
            command: (0, $5jSEp.toggleEmWithAnalytics),
            shortcut: (0, $cv8id.toggleItalic)
        },
        underline: {
            rank: (0, $fiku8.TEXT_FORMATTING_MENU_SECTION_RANK)[(0, $4rzOL.UNDERLINE_MENU_ITEM).key],
            key: (0, $4rzOL.UNDERLINE_MENU_ITEM).key,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($dTdDF))),
            title: (0, $glyUo.toolbarMessages).underline,
            command: (0, $5jSEp.toggleUnderlineWithAnalytics),
            shortcut: (0, $cv8id.toggleUnderline)
        },
        strike: {
            rank: (0, $fiku8.TEXT_FORMATTING_MENU_SECTION_RANK)[(0, $4rzOL.STRIKE_MENU_ITEM).key],
            key: (0, $4rzOL.STRIKE_MENU_ITEM).key,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($74hnl))),
            title: (0, $glyUo.toolbarMessages).strike,
            command: (0, $5jSEp.toggleStrikeWithAnalytics),
            shortcut: (0, $cv8id.toggleStrikethrough)
        },
        code: {
            rank: (0, $fiku8.TEXT_FORMATTING_MENU_SECTION_RANK)[(0, $4rzOL.CODE_MENU_ITEM).key],
            key: (0, $4rzOL.CODE_MENU_ITEM).key,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($imwtU))),
            title: (0, $glyUo.toolbarMessages).code,
            command: (0, $5jSEp.toggleCodeWithAnalytics),
            shortcut: (0, $cv8id.toggleCode)
        },
        subscript: {
            rank: (0, $fiku8.TEXT_FORMATTING_MENU_SECTION_RANK)[(0, $4rzOL.SUBSCRIPT_MENU_ITEM).key],
            key: (0, $4rzOL.SUBSCRIPT_MENU_ITEM).key,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($dROaw))),
            title: (0, $glyUo.toolbarMessages).subscript,
            command: (0, $5jSEp.toggleSubscriptWithAnalytics),
            shortcut: (0, $cv8id.toggleSubscript)
        },
        superscript: {
            rank: (0, $fiku8.TEXT_FORMATTING_MENU_SECTION_RANK)[(0, $4rzOL.SUPERSCRIPT_MENU_ITEM).key],
            key: (0, $4rzOL.SUPERSCRIPT_MENU_ITEM).key,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($6v9rL))),
            title: (0, $glyUo.toolbarMessages).superscript,
            command: (0, $5jSEp.toggleSuperscriptWithAnalytics),
            shortcut: (0, $cv8id.toggleSuperscript)
        }
    });

});
parcelRegister("dROaw", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5b05d76716678eee435c175df851e593>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a187240ec323ae67$var$_react = $a187240ec323ae67$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $a187240ec323ae67$var$_iconNew = $a187240ec323ae67$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $a187240ec323ae67$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextSubscript".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/text-subscript
 * Usage guidance:
 * Reserved for subscript text formatting.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a187240ec323ae67$var$TextSubscriptIcon = (props)=>/*#__PURE__*/ $a187240ec323ae67$var$_react.default.createElement($a187240ec323ae67$var$_iconNew.default, Object.assign({
        name: "TextSubscriptIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m6.26 8 3.69 6H8.19L5.4 9.47 2.78 14H1.05l3.46-6-3.46-6h1.73L5.4 6.53 8.19 2h1.76zm7.49.5h.08a.75.75 0 0 1 .67.75V16H13v-6h-1V8.5z"/>`
    }, props));
$a187240ec323ae67$var$TextSubscriptIcon.displayName = 'TextSubscriptIcon';
var $a187240ec323ae67$var$_default = module.exports.default = $a187240ec323ae67$var$TextSubscriptIcon;

});

parcelRegister("6v9rL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::930980b63f89790a6a77c30e1bb047c0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4bbcf73d94cf13e9$var$_react = $4bbcf73d94cf13e9$var$_interopRequireDefault((parcelRequire("bSJIT")));

var $4bbcf73d94cf13e9$var$_iconNew = $4bbcf73d94cf13e9$var$_interopRequireDefault((parcelRequire("gHJ0W")));
function $4bbcf73d94cf13e9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "TextSuperscript".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab/core/text-superscript
 * Usage guidance:
 * Reserved for superscript text formatting.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4bbcf73d94cf13e9$var$TextSuperscriptIcon = (props)=>/*#__PURE__*/ $4bbcf73d94cf13e9$var$_react.default.createElement($4bbcf73d94cf13e9$var$_iconNew.default, Object.assign({
        name: "TextSuperscriptIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m6.26 8 3.69 6H8.19L5.4 9.47 2.78 14H1.05l3.46-6-3.46-6h1.73L5.4 6.53 8.19 2h1.76zm7.49-8h.08a.75.75 0 0 1 .67.75V7.5H13v-6h-1V0z"/>`
    }, props));
$4bbcf73d94cf13e9$var$TextSuperscriptIcon.displayName = 'TextSuperscriptIcon';
var $4bbcf73d94cf13e9$var$_default = module.exports.default = $4bbcf73d94cf13e9$var$TextSuperscriptIcon;

});




parcelRegister("6IuML", function(module, exports) {
$parcel$export(module.exports, "textFormattingGroupForInlineToolbar", () => $cb2311c98f2132f5$export$653d8b3e035cd6f7);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $4rzOL = parcelRequire("4rzOL");

var $fiku8 = parcelRequire("fiku8");

var $5gDEv = parcelRequire("5gDEv");

var $kzqI4 = parcelRequire("kzqI4");

var $3An2a = parcelRequire("3An2a");

var $3eGFf = parcelRequire("3eGFf");
const $cb2311c98f2132f5$export$653d8b3e035cd6f7 = (api)=>[
        {
            type: (0, $4rzOL.TEXT_FORMATTING_GROUP_INLINE).type,
            key: (0, $4rzOL.TEXT_FORMATTING_GROUP_INLINE).key,
            parents: [
                {
                    type: (0, $4rzOL.TEXT_SECTION).type,
                    key: (0, $4rzOL.TEXT_SECTION).key,
                    rank: (0, $fiku8.TEXT_SECTION_RANK)[(0, $4rzOL.TEXT_FORMATTING_GROUP).key]
                }
            ],
            component: ({ children: children })=>{
                return /*#__PURE__*/ (0, $dc70d.jsx)((0, $5gDEv.ToolbarButtonGroup), {
                    children: children
                });
            }
        },
        {
            type: (0, $4rzOL.TEXT_FORMATTING_HERO_BUTTON).type,
            key: (0, $4rzOL.TEXT_FORMATTING_HERO_BUTTON).key,
            parents: [
                {
                    type: (0, $4rzOL.TEXT_FORMATTING_GROUP_INLINE).type,
                    key: (0, $4rzOL.TEXT_FORMATTING_GROUP_INLINE).key,
                    rank: (0, $fiku8.TEXT_FORMAT_GROUP_RANK)[(0, $4rzOL.TEXT_FORMATTING_HERO_BUTTON).key]
                }
            ],
            component: ({ parents: parents })=>{
                const { icon: icon, command: command, shortcut: shortcut, title: title } = (0, $3eGFf.formatOptions)().strong;
                return /*#__PURE__*/ (0, $dc70d.jsx)((0, $3An2a.FormatButton), {
                    api: api,
                    parents: parents,
                    icon: icon,
                    title: title,
                    shortcut: shortcut,
                    optionType: (0, $kzqI4.FormatOptions).strong,
                    toggleMarkWithAnalyticsCallback: command
                });
            }
        }
    ];

});

parcelRegister("agbex", function(module, exports) {
$parcel$export(module.exports, "textFormattingGroupForPrimaryToolbar", () => $d81420ab96b6932d$export$ed04d15827dc03ae);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $28qc1 = parcelRequire("28qc1");

var $4rzOL = parcelRequire("4rzOL");

var $fiku8 = parcelRequire("fiku8");

var $f6IUb = parcelRequire("f6IUb");

var $5gDEv = parcelRequire("5gDEv");

var $kzqI4 = parcelRequire("kzqI4");

var $3An2a = parcelRequire("3An2a");

var $3eGFf = parcelRequire("3eGFf");
const $d81420ab96b6932d$var$TextFormattingGroup = ({ children: children })=>{
    const { editorAppearance: editorAppearance } = (0, $28qc1.useEditorToolbar)();
    if (editorAppearance === 'full-page') return /*#__PURE__*/ (0, $dc70d.jsx)((0, $f6IUb.Show), {
        above: "xl",
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $5gDEv.ToolbarButtonGroup), {
            children: children
        })
    });
};
const $d81420ab96b6932d$var$TextFormattingGroupCollapsed = ({ children: children })=>{
    const { editorAppearance: editorAppearance } = (0, $28qc1.useEditorToolbar)();
    if (editorAppearance === 'full-page') return /*#__PURE__*/ (0, $dc70d.jsx)((0, $f6IUb.Show), {
        below: "xl",
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $5gDEv.ToolbarButtonGroup), {
            children: children
        })
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $5gDEv.ToolbarButtonGroup), {
        children: children
    });
};
const $d81420ab96b6932d$export$ed04d15827dc03ae = (api)=>[
        {
            type: (0, $4rzOL.TEXT_FORMATTING_GROUP).type,
            key: (0, $4rzOL.TEXT_FORMATTING_GROUP).key,
            parents: [
                {
                    type: (0, $4rzOL.TEXT_SECTION_PRIMARY_TOOLBAR).type,
                    key: (0, $4rzOL.TEXT_SECTION_PRIMARY_TOOLBAR).key,
                    rank: (0, $fiku8.TEXT_SECTION_PRIMARY_TOOLBAR_RANK)[(0, $4rzOL.TEXT_FORMATTING_GROUP).key]
                }
            ],
            component: ({ children: children })=>{
                return /*#__PURE__*/ (0, $dc70d.jsx)($d81420ab96b6932d$var$TextFormattingGroup, {
                    children: children
                });
            }
        },
        {
            type: (0, $4rzOL.TEXT_FORMATTING_GROUP_COLLAPSED).type,
            key: (0, $4rzOL.TEXT_FORMATTING_GROUP_COLLAPSED).key,
            parents: [
                {
                    type: (0, $4rzOL.TEXT_SECTION_PRIMARY_TOOLBAR).type,
                    key: (0, $4rzOL.TEXT_SECTION_PRIMARY_TOOLBAR).key,
                    rank: (0, $fiku8.TEXT_SECTION_PRIMARY_TOOLBAR_RANK)[(0, $4rzOL.TEXT_FORMATTING_GROUP).key]
                }
            ],
            component: ({ children: children })=>{
                return /*#__PURE__*/ (0, $dc70d.jsx)($d81420ab96b6932d$var$TextFormattingGroupCollapsed, {
                    children: children
                });
            }
        },
        {
            type: (0, $4rzOL.TEXT_FORMATTING_HERO_BUTTON).type,
            key: (0, $4rzOL.TEXT_FORMATTING_HERO_BUTTON).key,
            parents: [
                {
                    type: (0, $4rzOL.TEXT_FORMATTING_GROUP).type,
                    key: (0, $4rzOL.TEXT_FORMATTING_GROUP).key,
                    rank: (0, $fiku8.TEXT_FORMAT_GROUP_RANK)[(0, $4rzOL.TEXT_FORMATTING_HERO_BUTTON).key]
                }
            ],
            component: ({ parents: parents })=>{
                const { icon: icon, command: command, shortcut: shortcut, title: title } = (0, $3eGFf.formatOptions)().em;
                return /*#__PURE__*/ (0, $dc70d.jsx)((0, $3An2a.FormatButton), {
                    api: api,
                    parents: parents,
                    icon: icon,
                    title: title,
                    shortcut: shortcut,
                    optionType: (0, $kzqI4.FormatOptions).em,
                    toggleMarkWithAnalyticsCallback: command
                });
            }
        },
        {
            type: (0, $4rzOL.TEXT_FORMATTING_HERO_BUTTON_COLLAPSED).type,
            key: (0, $4rzOL.TEXT_FORMATTING_HERO_BUTTON_COLLAPSED).key,
            parents: [
                {
                    type: (0, $4rzOL.TEXT_FORMATTING_GROUP_COLLAPSED).type,
                    key: (0, $4rzOL.TEXT_FORMATTING_GROUP_COLLAPSED).key,
                    rank: (0, $fiku8.TEXT_FORMAT_GROUP_COLLAPSED_RANK)[(0, $4rzOL.TEXT_FORMATTING_HERO_BUTTON_COLLAPSED).key]
                }
            ],
            component: ({ parents: parents })=>{
                const { icon: icon, command: command, shortcut: shortcut, title: title } = (0, $3eGFf.formatOptions)().strong;
                return /*#__PURE__*/ (0, $dc70d.jsx)((0, $3An2a.FormatButton), {
                    api: api,
                    parents: parents,
                    icon: icon,
                    title: title,
                    shortcut: shortcut,
                    optionType: (0, $kzqI4.FormatOptions).strong,
                    toggleMarkWithAnalyticsCallback: command
                });
            }
        }
    ];

});

parcelRegister("hqZ8n", function(module, exports) {
$parcel$export(module.exports, "textFormattingMenuGroup", () => $21526de22600ba81$export$21e1245c68e20dce);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $4rzOL = parcelRequire("4rzOL");

var $fiku8 = parcelRequire("fiku8");

var $dlk6h = parcelRequire("dlk6h");

var $3An2a = parcelRequire("3An2a");

var $3eGFf = parcelRequire("3eGFf");
const $21526de22600ba81$export$922904c4345b3461 = (api)=>{
    return Object.entries((0, $3eGFf.formatOptions)()).map(([optionType, { icon: icon, shortcut: shortcut, title: title, command: command, rank: rank, key: key }])=>{
        return {
            type: 'menu-item',
            key: key,
            parents: [
                {
                    type: (0, $4rzOL.TEXT_FORMATTING_MENU_SECTION).type,
                    key: (0, $4rzOL.TEXT_FORMATTING_MENU_SECTION).key,
                    rank: rank
                }
            ],
            component: ({ parents: parents })=>{
                return /*#__PURE__*/ (0, $dc70d.jsx)((0, $3An2a.FormatMenuItem), {
                    api: api,
                    parents: parents,
                    icon: icon,
                    shortcut: shortcut,
                    title: title,
                    optionType: optionType,
                    toggleMarkWithAnalyticsCallback: command
                });
            }
        };
    });
};
const $21526de22600ba81$export$21e1245c68e20dce = (api)=>[
        {
            type: (0, $4rzOL.TEXT_FORMATTING_MENU).type,
            key: (0, $4rzOL.TEXT_FORMATTING_MENU).key,
            parents: [
                {
                    type: (0, $4rzOL.TEXT_FORMATTING_GROUP).type,
                    key: (0, $4rzOL.TEXT_FORMATTING_GROUP).key,
                    rank: (0, $fiku8.TEXT_FORMAT_GROUP_RANK)[(0, $4rzOL.TEXT_FORMATTING_MENU).key]
                },
                {
                    type: (0, $4rzOL.TEXT_FORMATTING_GROUP_COLLAPSED).type,
                    key: (0, $4rzOL.TEXT_FORMATTING_GROUP_COLLAPSED).key,
                    rank: (0, $fiku8.TEXT_FORMAT_GROUP_RANK)[(0, $4rzOL.TEXT_FORMATTING_MENU).key]
                },
                {
                    type: (0, $4rzOL.TEXT_FORMATTING_GROUP_INLINE).type,
                    key: (0, $4rzOL.TEXT_FORMATTING_GROUP_INLINE).key,
                    rank: (0, $fiku8.TEXT_FORMAT_GROUP_RANK)[(0, $4rzOL.TEXT_FORMATTING_HERO_BUTTON).key]
                }
            ],
            component: ({ children: children })=>{
                return /*#__PURE__*/ (0, $dc70d.jsx)((0, $3An2a.MoreFormattingMenu), {
                    children: children
                });
            }
        },
        {
            type: (0, $4rzOL.TEXT_FORMATTING_MENU_SECTION).type,
            key: (0, $4rzOL.TEXT_FORMATTING_MENU_SECTION).key,
            parents: [
                {
                    type: (0, $4rzOL.TEXT_FORMATTING_MENU).type,
                    key: (0, $4rzOL.TEXT_FORMATTING_MENU).key,
                    rank: (0, $fiku8.TEXT_FORMAT_MENU_RANK)[(0, $4rzOL.TEXT_FORMATTING_MENU_SECTION).key]
                },
                {
                    type: (0, $4rzOL.TEXT_COLLAPSED_MENU).type,
                    key: (0, $4rzOL.TEXT_COLLAPSED_MENU).key,
                    rank: (0, $fiku8.TEXT_COLLAPSED_MENU_RANK)[(0, $4rzOL.TEXT_FORMATTING_MENU_SECTION).key]
                }
            ],
            component: (0, $3An2a.MenuSection)
        },
        ...$21526de22600ba81$export$922904c4345b3461(api),
        {
            type: (0, $4rzOL.CLEAR_FORMARTTING_MENU_SECTION).type,
            key: (0, $4rzOL.CLEAR_FORMARTTING_MENU_SECTION).key,
            parents: [
                {
                    type: (0, $4rzOL.TEXT_FORMATTING_MENU).type,
                    key: (0, $4rzOL.TEXT_FORMATTING_MENU).key,
                    rank: (0, $fiku8.TEXT_FORMAT_MENU_RANK)[(0, $4rzOL.CLEAR_FORMARTTING_MENU_SECTION).key]
                },
                {
                    type: (0, $4rzOL.TEXT_COLLAPSED_MENU).type,
                    key: (0, $4rzOL.TEXT_COLLAPSED_MENU).key,
                    rank: (0, $fiku8.TEXT_COLLAPSED_MENU_RANK)[(0, $4rzOL.CLEAR_FORMARTTING_MENU_SECTION).key]
                }
            ],
            component: ({ children: children })=>{
                return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dlk6h.ToolbarDropdownItemSection), {
                    hasSeparator: true,
                    children: children
                });
            }
        },
        {
            type: (0, $4rzOL.CLEAR_FORMATTING_MENU_ITEM).type,
            key: (0, $4rzOL.CLEAR_FORMATTING_MENU_ITEM).key,
            parents: [
                {
                    type: (0, $4rzOL.CLEAR_FORMARTTING_MENU_SECTION).type,
                    key: (0, $4rzOL.CLEAR_FORMARTTING_MENU_SECTION).key,
                    rank: (0, $fiku8.CLEAR_FORMARTTING_MENU_SECTION_RANK)[(0, $4rzOL.CLEAR_FORMATTING_MENU_ITEM).key]
                }
            ],
            component: ({ parents: parents })=>{
                return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dc70d.Fragment), {
                    children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $3An2a.ClearFormatMenuItem), {
                        parents: parents,
                        api: api
                    })
                });
            }
        }
    ];

});

parcelRegister("2pTzV", function(module, exports) {
$parcel$export(module.exports, "underlineButtonGroup", () => $ef7d7881521a9d96$export$8988dc22a0ee54a7);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $28qc1 = parcelRequire("28qc1");

var $4rzOL = parcelRequire("4rzOL");

var $fiku8 = parcelRequire("fiku8");

var $f6IUb = parcelRequire("f6IUb");

var $5gDEv = parcelRequire("5gDEv");

var $kzqI4 = parcelRequire("kzqI4");

var $3An2a = parcelRequire("3An2a");

var $3eGFf = parcelRequire("3eGFf");
const $ef7d7881521a9d96$var$UnderlineButtonGroup = ({ children: children })=>{
    const { editorAppearance: editorAppearance } = (0, $28qc1.useEditorToolbar)();
    if (editorAppearance === 'full-page') return /*#__PURE__*/ (0, $dc70d.jsx)((0, $f6IUb.Show), {
        above: "xl",
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $5gDEv.ToolbarButtonGroup), {
            children: children
        })
    });
};
const $ef7d7881521a9d96$export$8988dc22a0ee54a7 = (api)=>[
        {
            type: (0, $4rzOL.UNDERLINE_BUTTON_GROUP).type,
            key: (0, $4rzOL.UNDERLINE_BUTTON_GROUP).key,
            parents: [
                {
                    type: (0, $4rzOL.TEXT_SECTION_PRIMARY_TOOLBAR).type,
                    key: (0, $4rzOL.TEXT_SECTION_PRIMARY_TOOLBAR).key,
                    rank: (0, $fiku8.TEXT_SECTION_PRIMARY_TOOLBAR_RANK)[(0, $4rzOL.UNDERLINE_BUTTON_GROUP).key]
                }
            ],
            component: ({ children: children })=>{
                return /*#__PURE__*/ (0, $dc70d.jsx)($ef7d7881521a9d96$var$UnderlineButtonGroup, {
                    children: children
                });
            }
        },
        {
            type: (0, $4rzOL.UNDERLINE_BUTTON).type,
            key: (0, $4rzOL.UNDERLINE_BUTTON).key,
            parents: [
                {
                    type: (0, $4rzOL.UNDERLINE_BUTTON_GROUP).type,
                    key: (0, $4rzOL.UNDERLINE_BUTTON_GROUP).key,
                    rank: 100
                }
            ],
            component: ({ parents: parents })=>{
                const { icon: icon, command: command, shortcut: shortcut, title: title } = (0, $3eGFf.formatOptions)().underline;
                return /*#__PURE__*/ (0, $dc70d.jsx)((0, $3An2a.FormatButton), {
                    api: api,
                    parents: parents,
                    icon: icon,
                    title: title,
                    shortcut: shortcut,
                    optionType: (0, $kzqI4.FormatOptions).underline,
                    toggleMarkWithAnalyticsCallback: command
                });
            }
        }
    ];

});



parcelRegister("4yyNU", function(module, exports) {
$parcel$export(module.exports, "toolbarPlugin", () => $bc3b8fc613310df7$export$2235d7d328f4404b);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $bAB3U = parcelRequire("bAB3U");

var $f7Kk4 = parcelRequire("f7Kk4");

var $cw0wu = parcelRequire("cw0wu");

var $gab48 = parcelRequire("gab48");

var $iPkIK = parcelRequire("iPkIK");

var $3y2s4 = parcelRequire("3y2s4");

var $gCV9B = parcelRequire("gCV9B");

var $aK9eO = parcelRequire("aK9eO");

var $11dYY = parcelRequire("11dYY");

var $1bE61 = parcelRequire("1bE61");

var $bGGL7 = parcelRequire("bGGL7");

var $1pEzJ = parcelRequire("1pEzJ");
function $bc3b8fc613310df7$var$getSelectedNode(editorState) {
    const { selection: selection } = editorState;
    if (selection instanceof (0, $cw0wu.NodeSelection)) return {
        node: selection.node,
        pos: selection.from,
        nodeType: selection.node.type.name,
        marks: selection.node.marks.map((mark)=>`${mark.type.name}:${JSON.stringify(mark.attrs)}`)
    };
    const { nodes: nodes } = editorState.schema;
    const selectedNode = (0, $gab48.findSelectedNodeOfType)([
        nodes.paragraph,
        nodes.heading,
        nodes.blockquote,
        nodes.panel,
        nodes.codeBlock
    ])(selection);
    if (selectedNode) return {
        node: selectedNode.node,
        pos: selectedNode.pos,
        nodeType: selectedNode.node.type.name,
        marks: selectedNode.node.marks.map((mark)=>`${mark.type.name}:${JSON.stringify(mark.attrs)}`)
    };
    const parentNode = (0, $gab48.findParentNodeOfType)([
        nodes.paragraph,
        nodes.heading,
        nodes.blockquote,
        nodes.panel,
        nodes.listItem,
        nodes.taskItem
    ])(selection);
    if (parentNode) return {
        node: parentNode.node,
        pos: parentNode.pos,
        nodeType: parentNode.node.type.name,
        marks: parentNode.node.marks.map((mark)=>`${mark.type.name}:${JSON.stringify(mark.attrs)}`)
    };
    const $pos = selection.$from;
    return {
        node: $pos.parent,
        pos: $pos.pos,
        nodeType: $pos.parent.type.name,
        marks: $pos.marks().map((mark)=>`${mark.type.name}:${JSON.stringify(mark.attrs)}`)
    };
}
const $bc3b8fc613310df7$export$2235d7d328f4404b = ({ api: api, config: config = {
    disableSelectionToolbar: false,
    disableSelectionToolbarWhenPinned: false
} })=>{
    const refs = {};
    const handleToolbarMouseUp = (event)=>{
        refs.toolbarMouseUpEvent = event.nativeEvent;
    };
    const { disableSelectionToolbar: disableSelectionToolbar, disableSelectionToolbarWhenPinned: disableSelectionToolbarWhenPinned, contextualFormattingEnabled: contextualFormattingEnabled = 'always-pinned', breakpointPreset: breakpointPreset } = config;
    const registry = (0, $iPkIK.createComponentRegistry)();
    registry.register((0, $bGGL7.getToolbarComponents)(contextualFormattingEnabled, api, breakpointPreset));
    return {
        name: 'toolbar',
        actions: {
            registerComponents: (toolbarComponents, replaceItems = false)=>{
                if (replaceItems) registry.safeRegister(toolbarComponents);
                else registry.register(toolbarComponents);
            },
            // EDITOR-6558: `componentFilter` is evaluated at read time (not at
            // `registerComponents` time) so it can react to runtime state
            // (e.g. the current markdown view mode) without forcing every
            // plugin to re-register its components. Returning a new array on
            // every call means React-tree consumers re-render whenever the
            // underlying filter would change.
            getComponents: ()=>{
                return config !== null && config !== void 0 && config.componentFilter ? registry.components.filter(config.componentFilter) : registry.components;
            },
            contextualFormattingMode: ()=>{
                var _config$contextualFor;
                // Returns the config-time mode only. The runtime override
                // (`EditorToolbarPluginState.contextualFormattingModeOverride`)
                // lives in PM state and must be merged in by the React render
                // site — see SelectionToolbar / Section / FullPageToolbarNext for
                // the `runtimeOverride ?? action() ?? 'always-pinned'` pattern.
                // Doing the merge here would require closure-capturing `editorView`,
                // which races with StrictMode double-mount.
                return (config === null || config === void 0 || (_config$contextualFor = config.contextualFormattingModeOverride) === null || _config$contextualFor === void 0 ? void 0 : _config$contextualFor.call(config)) ?? contextualFormattingEnabled ?? 'always-pinned';
            },
            getBreakpointPreset: ()=>{
                return breakpointPreset;
            }
        },
        commands: {
            setContextualFormattingModeOverride: (mode)=>{
                return ({ tr: tr })=>{
                    tr.setMeta((0, $aK9eO.editorToolbarPluginKey), {
                        contextualFormattingModeOverride: mode
                    });
                    return tr;
                };
            }
        },
        getSharedState (editorState) {
            if (!editorState) return undefined;
            return (0, $aK9eO.editorToolbarPluginKey).getState(editorState);
        },
        pmPlugins () {
            return [
                {
                    name: 'editor-toolbar-selection',
                    plugin: ()=>{
                        // Tracks mouse-down state to prevent the focus event (first page load)
                        // from prematurely showing the toolbar mid-drag
                        const mouseState = {
                            isMouseDown: false
                        };
                        return new (0, $f7Kk4.SafePlugin)({
                            key: (0, $aK9eO.editorToolbarPluginKey),
                            state: {
                                init (_, editorState) {
                                    return {
                                        shouldShowToolbar: false,
                                        selectedNode: $bc3b8fc613310df7$var$getSelectedNode(editorState),
                                        contextualFormattingModeOverride: undefined
                                    };
                                },
                                apply (tr, pluginState, _, newState) {
                                    const meta = tr.getMeta((0, $aK9eO.editorToolbarPluginKey));
                                    let newPluginState = {
                                        ...pluginState
                                    };
                                    const shouldUpdateNode = tr.docChanged || tr.selectionSet;
                                    if (shouldUpdateNode) {
                                        const newSelectedNode = $bc3b8fc613310df7$var$getSelectedNode(newState);
                                        const oldNode = pluginState.selectedNode;
                                        const hasNodeChanged = !oldNode || !newSelectedNode || oldNode.nodeType !== newSelectedNode.nodeType || oldNode.pos !== newSelectedNode.pos || JSON.stringify(oldNode.marks) !== JSON.stringify(newSelectedNode.marks);
                                        if (hasNodeChanged) newPluginState.selectedNode = newSelectedNode;
                                    }
                                    if (meta) {
                                        const { contextualFormattingModeOverride: contextualFormattingModeOverride, ...rest } = meta;
                                        // Only forward the override when the meta actually carries
                                        // the key — unrelated metas (mouseup / focus / mousedown
                                        // from the view() listeners) destructure it as `undefined`
                                        // and would otherwise wipe a previously-set override on
                                        // every interaction.
                                        newPluginState = {
                                            ...newPluginState,
                                            ...rest,
                                            ...'contextualFormattingModeOverride' in meta ? {
                                                contextualFormattingModeOverride: contextualFormattingModeOverride
                                            } : {}
                                        };
                                    }
                                    return newPluginState;
                                }
                            },
                            view (view) {
                                const unbind = (0, $bAB3U.bind)(view.root, {
                                    type: 'mouseup',
                                    listener: function(ev) {
                                        var _api$editorViewMode2;
                                        mouseState.isMouseDown = false;
                                        const event = ev;
                                        if ((0, $3y2s4.isExperimentEnabled)('platform_editor_toolbar_multi_editor_fix')) {
                                            var _api$editorViewMode, _api$toolbar;
                                            // Scope mouseups to this editor and its React-portaled toolbar.
                                            const isMouseUpInOwnedToolbar = refs.toolbarMouseUpEvent === event;
                                            const isMouseUpInEditor = event.composedPath().includes(view.dom);
                                            refs.toolbarMouseUpEvent = undefined;
                                            // Prevent outside clicks from reopening a blurred editor's toolbar.
                                            const editorViewModePlugin = api === null || api === void 0 || (_api$editorViewMode = api.editorViewMode) === null || _api$editorViewMode === void 0 ? void 0 : _api$editorViewMode.sharedState.currentState();
                                            const isViewModeEnabled = (editorViewModePlugin === null || editorViewModePlugin === void 0 ? void 0 : editorViewModePlugin.mode) === 'view';
                                            // Include focus in nested editable islands.
                                            const hasEditorFocus = view.hasFocus() || view.dom.contains(view.root.activeElement);
                                            const shouldShowToolbar = isViewModeEnabled ? isMouseUpInEditor || isMouseUpInOwnedToolbar : hasEditorFocus || isMouseUpInOwnedToolbar;
                                            const currentShouldShowToolbar = api === null || api === void 0 || (_api$toolbar = api.toolbar) === null || _api$toolbar === void 0 || (_api$toolbar = _api$toolbar.sharedState.currentState()) === null || _api$toolbar === void 0 ? void 0 : _api$toolbar.shouldShowToolbar;
                                            if (currentShouldShowToolbar !== shouldShowToolbar) view.dispatch(view.state.tr.setMeta((0, $aK9eO.editorToolbarPluginKey), {
                                                shouldShowToolbar: shouldShowToolbar
                                            }));
                                            return;
                                        }
                                        const isInToolbar = (0, $1pEzJ.isEventInContainer)(event, (0, $11dYY.DEFAULT_POPUP_SELECTORS).toolbarContainer);
                                        const isInPortal = (0, $1pEzJ.isEventInContainer)(event, (0, $11dYY.DEFAULT_POPUP_SELECTORS).portal);
                                        // We only want to set selectionStable to true if the editor has focus
                                        // to prevent the toolbar from showing when the editor is blurred
                                        // due to a click outside the editor.
                                        const editorViewModePlugin = api === null || api === void 0 || (_api$editorViewMode2 = api.editorViewMode) === null || _api$editorViewMode2 === void 0 ? void 0 : _api$editorViewMode2.sharedState.currentState();
                                        const isViewModeEnabled = (editorViewModePlugin === null || editorViewModePlugin === void 0 ? void 0 : editorViewModePlugin.mode) === 'view';
                                        // Focus can sit inside a nested editable region ProseMirror does not own -
                                        // such as a reference synced block's island - where `view.hasFocus()` is
                                        // false but the user is still interacting with the editor.
                                        const hasEditorFocus = view.hasFocus() || view.dom.contains(view.root.activeElement);
                                        view.dispatch(view.state.tr.setMeta((0, $aK9eO.editorToolbarPluginKey), {
                                            shouldShowToolbar: !isViewModeEnabled ? hasEditorFocus || isInToolbar || isInPortal : true
                                        }));
                                    }
                                });
                                const unbindEditorViewFocus = (0, $bAB3U.bind)(view.dom, {
                                    type: 'focus',
                                    listener: ()=>{
                                        // On first page load, focus fires after mousedown — skip to
                                        // avoid showing the toolbar mid-drag
                                        if (mouseState.isMouseDown) return;
                                        view.dispatch(view.state.tr.setMeta((0, $aK9eO.editorToolbarPluginKey), {
                                            shouldShowToolbar: true
                                        }));
                                    }
                                });
                                return {
                                    destroy () {
                                        unbind();
                                        unbindEditorViewFocus();
                                    }
                                };
                            },
                            props: {
                                handleDOMEvents: {
                                    mousedown: (view)=>{
                                        mouseState.isMouseDown = true;
                                        view.dispatch(view.state.tr.setMeta((0, $aK9eO.editorToolbarPluginKey), {
                                            shouldShowToolbar: false
                                        }));
                                        return false;
                                    }
                                }
                            }
                        });
                    }
                },
                ...!disableSelectionToolbar ? [
                    {
                        name: 'selectionToolbarOpenExperience',
                        plugin: ()=>(0, $gCV9B.getSelectionToolbarOpenExperiencePlugin)({
                                refs: refs,
                                dispatchAnalyticsEvent: (payload)=>{
                                    var _api$analytics;
                                    return api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 || (_api$analytics = _api$analytics.actions) === null || _api$analytics === void 0 ? void 0 : _api$analytics.fireAnalyticsEvent(payload);
                                },
                                getCurrentUserIntent: ()=>{
                                    var _api$userIntent;
                                    return api === null || api === void 0 || (_api$userIntent = api.userIntent) === null || _api$userIntent === void 0 || (_api$userIntent = _api$userIntent.sharedState.currentState()) === null || _api$userIntent === void 0 ? void 0 : _api$userIntent.currentUserIntent;
                                }
                            })
                    }
                ] : []
            ];
        },
        contentComponent: !disableSelectionToolbar ? ({ editorView: editorView, popupsMountPoint: popupsMountPoint })=>{
            refs.popupsMountPoint = popupsMountPoint || undefined;
            if (!editorView) return null;
            return /*#__PURE__*/ (0, $dc70d.jsx)((0, $1bE61.SelectionToolbarWithErrorBoundary), {
                api: api,
                editorView: editorView,
                mountPoint: popupsMountPoint,
                disableSelectionToolbarWhenPinned: disableSelectionToolbarWhenPinned ?? false,
                onToolbarMouseUp: handleToolbarMouseUp
            });
        } : undefined
    };
};

});
parcelRegister("iPkIK", function(module, exports) {
$parcel$export(module.exports, "createComponentRegistry", () => $f13a83be1d1677f1$export$34783ae4fef40269);
const $f13a83be1d1677f1$export$34783ae4fef40269 = ()=>{
    const components = [];
    const register = (newComponents)=>{
        components.push(...newComponents);
    };
    /**
   * Similer to `register` but first checks the registry against `newComponents` using its
   * key and type, if it already exists it replaces the item instead of simply appending it.
   *
   * Most likely you should avoid using this and just use the `register` method as it's preferred
   * to register components statically.
   */ const safeRegister = (newComponents)=>{
        newComponents.forEach((newComponent)=>{
            const existingIndex = components.findIndex((existingComponent)=>existingComponent.type === newComponent.type && existingComponent.key === newComponent.key);
            if (existingIndex !== -1) // Replace existing component
            components[existingIndex] = newComponent;
            else // Add new component
            components.push(newComponent);
        });
    };
    return {
        register: register,
        safeRegister: safeRegister,
        components: components
    };
};

});

parcelRegister("gCV9B", function(module, exports) {
$parcel$export(module.exports, "getSelectionToolbarOpenExperiencePlugin", () => $a3982b5a4b31b48e$export$cfe4aed4f8555228);

var $g6Qq4 = parcelRequire("g6Qq4");

var $8JHqZ = parcelRequire("8JHqZ");
var $2KDOT = parcelRequire("2KDOT");

var $bApp6 = parcelRequire("bApp6");

var $b8RGE = parcelRequire("b8RGE");

var $73iZo = parcelRequire("73iZo");

var $9skTL = parcelRequire("9skTL");

var $f7Kk4 = parcelRequire("f7Kk4");

var $cw0wu = parcelRequire("cw0wu");

var $6jZrP = parcelRequire("6jZrP");
const $a3982b5a4b31b48e$var$pluginKey = new (0, $cw0wu.PluginKey)('selectionToolbarOpenExperience');
const $a3982b5a4b31b48e$var$START_METHOD = {
    MOUSE_UP: 'mouseUp',
    KEY_DOWN: 'keyDown'
};
const $a3982b5a4b31b48e$var$ABORT_REASON = {
    SELECTION_CLEARED: 'selectionCleared',
    BLOCK_MENU_OPENED: 'blockMenuOpened',
    EDITOR_DESTROYED: 'editorDestroyed',
    USER_INTENT_SUPPRESSED: 'userIntentSuppressed'
};
const $a3982b5a4b31b48e$export$cfe4aed4f8555228 = ({ refs: refs, dispatchAnalyticsEvent: dispatchAnalyticsEvent, getCurrentUserIntent: getCurrentUserIntent })=>{
    let editorView;
    let targetEl;
    let shiftArrowKeyPressed = false;
    let mouseDownPos;
    let mouseDownSelection;
    const getTarget = ()=>{
        if (!targetEl) {
            var _editorView;
            targetEl = refs.popupsMountPoint || (0, $2KDOT.getPopupContainerFromEditorView)((_editorView = editorView) === null || _editorView === void 0 ? void 0 : _editorView.dom);
        }
        return targetEl;
    };
    const isCurrentUserIntentSuppressingToolbar = (selection)=>{
        if (!selection) return false;
        const isCellSelection = !selection.empty && '$anchorCell' in selection;
        return (0, $6jZrP.isSelectionToolbarSuppressedByUserIntent)(getCurrentUserIntent === null || getCurrentUserIntent === void 0 ? void 0 : getCurrentUserIntent(), isCellSelection);
    };
    const experience = new (0, $b8RGE.Experience)((0, $bApp6.EXPERIENCE_ID).TOOLBAR_OPEN, {
        actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).SELECTION_TOOLBAR,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        checks: [
            new (0, $9skTL.ExperienceCheckTimeout)({
                durationMs: 1000,
                onTimeout: ()=>{
                    var _editorView2, _editorView3;
                    if (isCurrentUserIntentSuppressingToolbar((_editorView2 = editorView) === null || _editorView2 === void 0 ? void 0 : _editorView2.state.selection)) return {
                        status: 'abort',
                        reason: $a3982b5a4b31b48e$var$ABORT_REASON.USER_INTENT_SUPPRESSED
                    };
                    else if ($a3982b5a4b31b48e$var$isBlockMenuWithinNode(getTarget())) return {
                        status: 'abort',
                        reason: $a3982b5a4b31b48e$var$ABORT_REASON.BLOCK_MENU_OPENED
                    };
                    else if ($a3982b5a4b31b48e$var$isSelectionWithoutTextContent((_editorView3 = editorView) === null || _editorView3 === void 0 ? void 0 : _editorView3.state.selection)) return {
                        status: 'abort',
                        reason: $a3982b5a4b31b48e$var$ABORT_REASON.SELECTION_CLEARED
                    };
                }
            }),
            new (0, $73iZo.ExperienceCheckDomMutation)({
                onDomMutation: ({ mutations: mutations })=>{
                    if (mutations.some($a3982b5a4b31b48e$var$isSelectionToolbarAddedInMutation)) return {
                        status: 'success'
                    };
                },
                observeConfig: ()=>({
                        target: getTarget(),
                        options: {
                            childList: true
                        }
                    })
            })
        ]
    });
    const shouldSkipExperienceStart = (selection)=>{
        if ($a3982b5a4b31b48e$var$isSelectionWithoutTextContent(selection) || $a3982b5a4b31b48e$var$isSelectionWithinCodeBlock(selection) || isCurrentUserIntentSuppressingToolbar(selection)) return true;
        const target = getTarget();
        if (!target) // when target is not found, skip the experience start
        return true;
        return $a3982b5a4b31b48e$var$isSelectionToolbarWithinNode(target) || $a3982b5a4b31b48e$var$isBlockMenuWithinNode(target);
    };
    return new (0, $f7Kk4.SafePlugin)({
        key: $a3982b5a4b31b48e$var$pluginKey,
        state: {
            init: ()=>({}),
            apply: (_tr, pluginState, oldState, newState)=>{
                if (!oldState.selection.empty && $a3982b5a4b31b48e$var$isSelectionWithoutTextContent(newState.selection)) experience.abort({
                    reason: $a3982b5a4b31b48e$var$ABORT_REASON.SELECTION_CLEARED
                });
                const shouldStartExperience = shiftArrowKeyPressed && !newState.selection.eq(oldState.selection) && !shouldSkipExperienceStart(newState.selection);
                if (shouldStartExperience) {
                    experience.start({
                        method: $a3982b5a4b31b48e$var$START_METHOD.KEY_DOWN
                    });
                    shiftArrowKeyPressed = false;
                }
                return pluginState;
            }
        },
        props: {
            handleDOMEvents: {
                mousedown: (view, e)=>{
                    mouseDownPos = {
                        x: e.clientX,
                        y: e.clientY
                    };
                    mouseDownSelection = view.state.selection;
                },
                mouseup: (view, e)=>{
                    const initialMouseDownPos = mouseDownPos;
                    const selectionChanged = (0, $6jZrP.hasSelectionChanged)(mouseDownSelection, view.state.selection);
                    mouseDownPos = undefined;
                    mouseDownSelection = undefined;
                    if (!initialMouseDownPos || shouldSkipExperienceStart(view.state.selection)) return;
                    const mouseCoordinatesChanged = e.clientX !== initialMouseDownPos.x || e.clientY !== initialMouseDownPos.y;
                    if (mouseCoordinatesChanged && selectionChanged) experience.start({
                        method: $a3982b5a4b31b48e$var$START_METHOD.MOUSE_UP
                    });
                },
                dblclick: (view)=>{
                    if (shouldSkipExperienceStart(view.state.selection)) return;
                    experience.start({
                        method: $a3982b5a4b31b48e$var$START_METHOD.MOUSE_UP
                    });
                },
                keydown: (_view, event)=>{
                    shiftArrowKeyPressed = (0, $6jZrP.isPlainShiftArrowKey)(event) && !$a3982b5a4b31b48e$var$isSelectionToolbarWithinNode(getTarget());
                },
                keyup: ()=>{
                    shiftArrowKeyPressed = false;
                }
            }
        },
        view: (view)=>{
            editorView = view;
            return {
                destroy: ()=>{
                    experience.abort({
                        reason: $a3982b5a4b31b48e$var$ABORT_REASON.EDITOR_DESTROYED
                    });
                }
            };
        }
    });
};
const $a3982b5a4b31b48e$var$isSelectionToolbarAddedInMutation = ({ type: type, addedNodes: addedNodes })=>{
    return type === 'childList' && [
        ...addedNodes
    ].some($a3982b5a4b31b48e$var$isSelectionToolbarWithinNode);
};
const $a3982b5a4b31b48e$var$isSelectionToolbarWithinNode = (node)=>{
    return (0, $8JHqZ.containsPopupWithNestedElement)(node, '[data-testid="editor-floating-toolbar"]');
};
const $a3982b5a4b31b48e$var$isBlockMenuWithinNode = (node)=>{
    return (0, $8JHqZ.containsPopupWithNestedElement)(node, '[data-testid="editor-block-menu"]');
};
const $a3982b5a4b31b48e$var$isSelectionWithoutTextContent = (selection)=>{
    if (!selection || selection.empty) return true;
    let hasText = false;
    selection.$from.doc.nodesBetween(selection.from, selection.to, (node)=>{
        if (hasText) return false;
        if (node.isText && node.text && node.text.length > 0) {
            hasText = true;
            return false;
        }
        return true;
    });
    return !hasText;
};
const $a3982b5a4b31b48e$var$isSelectionWithinCodeBlock = (selection)=>{
    const { $from: $from, $to: $to } = selection;
    return $from.sameParent($to) && $from.parent.type.name === 'codeBlock';
};

});
parcelRegister("6jZrP", function(module, exports) {
$parcel$export(module.exports, "isSelectionToolbarSuppressedByUserIntent", () => $ffa5656fdda527ff$export$e76971190b14d34a);
$parcel$export(module.exports, "isPlainShiftArrowKey", () => $ffa5656fdda527ff$export$1040bb4c78920b38);
$parcel$export(module.exports, "hasSelectionChanged", () => $ffa5656fdda527ff$export$29c1d2c9a57e77aa);
const $ffa5656fdda527ff$export$e76971190b14d34a = (currentUserIntent, isCellSelection)=>Boolean(currentUserIntent && currentUserIntent !== 'default' && !(currentUserIntent === 'dragHandleSelected' && !isCellSelection));
const $ffa5656fdda527ff$export$1040bb4c78920b38 = ({ shiftKey: shiftKey, key: key, metaKey: metaKey, ctrlKey: ctrlKey, altKey: altKey })=>shiftKey && !metaKey && !ctrlKey && !altKey && key.includes('Arrow');
const $ffa5656fdda527ff$export$29c1d2c9a57e77aa = (mouseDownSelection, currentSelection)=>Boolean(mouseDownSelection && !mouseDownSelection.eq(currentSelection));

});


parcelRegister("aK9eO", function(module, exports) {
$parcel$export(module.exports, "editorToolbarPluginKey", () => $cf3ed3748650c5c0$export$31b2b7ff910ba1f3);

var $cw0wu = parcelRequire("cw0wu");
const $cf3ed3748650c5c0$export$31b2b7ff910ba1f3 = new (0, $cw0wu.PluginKey)('editorToolbarPluginKey');

});

parcelRegister("11dYY", function(module, exports) {
$parcel$export(module.exports, "SELECTION_TOOLBAR_LABEL", () => $500ce68588629e20$export$e235a0bccaa8a700);
$parcel$export(module.exports, "DEFAULT_POPUP_SELECTORS", () => $500ce68588629e20$export$c0535c9204f67376);
const $500ce68588629e20$export$e235a0bccaa8a700 = 'Selection toolbar';
const $500ce68588629e20$export$c0535c9204f67376 = {
    toolbarContainer: '[role="toolbar"]',
    portal: '.atlaskit-portal'
};

});

parcelRegister("1bE61", function(module, exports) {
$parcel$export(module.exports, "SelectionToolbarWithErrorBoundary", () => $45575840139aacf3$export$316d94f683c144f1);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $g6Qq4 = parcelRequire("g6Qq4");

var $hVGJk = parcelRequire("hVGJk");

var $iUiGU = parcelRequire("iUiGU");

var $7lseo = parcelRequire("7lseo");

var $j2Y9J = parcelRequire("j2Y9J");

var $5zk80 = parcelRequire("5zk80");

var $2Sx33 = parcelRequire("2Sx33");

var $28qc1 = parcelRequire("28qc1");

var $43aKr = parcelRequire("43aKr");

var $5beht = parcelRequire("5beht");

var $inSrS = parcelRequire("inSrS");

var $cw0wu = parcelRequire("cw0wu");

var $5bbjm = parcelRequire("5bbjm");

var $cvshM = parcelRequire("cvshM");

var $5gDEv = parcelRequire("5gDEv");

var $dlk6h = parcelRequire("dlk6h");

var $ap3j9 = parcelRequire("ap3j9");

var $aBdvW = parcelRequire("aBdvW");

var $3y2s4 = parcelRequire("3y2s4");

var $797yE = parcelRequire("797yE");

var $11dYY = parcelRequire("11dYY");

var $8brDA = parcelRequire("8brDA");

var $5BdPH = parcelRequire("5BdPH");

var $6jZrP = parcelRequire("6jZrP");
const $45575840139aacf3$var$isToolbarComponent = (component)=>{
    return component.type === 'toolbar' && component.key === 'inline-text-toolbar';
};
const $45575840139aacf3$var$usePluginState = (api)=>{
    return (0, $5beht.useSharedPluginStateWithSelector)(api, [
        'connectivity',
        'userPreferences',
        'toolbar',
        'selection',
        'userIntent',
        'editorViewMode'
    ], (state)=>{
        var _state$connectivitySt, _state$userPreference, _state$toolbarState, _state$toolbarState2, _state$toolbarState3, _state$selectionState, _state$userIntentStat, _state$editorViewMode;
        return {
            connectivityStateMode: (_state$connectivitySt = state.connectivityState) === null || _state$connectivitySt === void 0 ? void 0 : _state$connectivitySt.mode,
            editorToolbarDockingPreference: (_state$userPreference = state.userPreferencesState) === null || _state$userPreference === void 0 || (_state$userPreference = _state$userPreference.preferences) === null || _state$userPreference === void 0 ? void 0 : _state$userPreference.toolbarDockingPosition,
            shouldShowToolbar: (_state$toolbarState = state.toolbarState) === null || _state$toolbarState === void 0 ? void 0 : _state$toolbarState.shouldShowToolbar,
            selectedNode: (_state$toolbarState2 = state.toolbarState) === null || _state$toolbarState2 === void 0 ? void 0 : _state$toolbarState2.selectedNode,
            contextualFormattingModeOverride: (_state$toolbarState3 = state.toolbarState) === null || _state$toolbarState3 === void 0 ? void 0 : _state$toolbarState3.contextualFormattingModeOverride,
            selection: (_state$selectionState = state.selectionState) === null || _state$selectionState === void 0 ? void 0 : _state$selectionState.selection,
            currentUserIntent: (_state$userIntentStat = state.userIntentState) === null || _state$userIntentStat === void 0 ? void 0 : _state$userIntentStat.currentUserIntent,
            editorViewMode: (_state$editorViewMode = state.editorViewModeState) === null || _state$editorViewMode === void 0 ? void 0 : _state$editorViewMode.mode
        };
    });
};
const $45575840139aacf3$var$useOnPositionCalculated = (editorView)=>{
    const onPositionCalculated = (0, $bSJIT.useCallback)((position)=>{
        try {
            // Show special position on cell selection only when editor controls experiment is enabled
            const isEditorControlsEnabled = (0, $797yE.editorExperiment)('platform_editor_controls', 'variant1', {
                exposure: true
            });
            const isCellSelection = '$anchorCell' in editorView.state.selection;
            if (isCellSelection && isEditorControlsEnabled) return (0, $inSrS.calculateToolbarPositionOnCellSelection)((0, $11dYY.SELECTION_TOOLBAR_LABEL))(editorView, position);
            return (0, $inSrS.calculateToolbarPositionTrackHead)((0, $11dYY.SELECTION_TOOLBAR_LABEL))(editorView, position);
        } catch (error) {
            (0, $j2Y9J.logException)(error, {
                location: 'editor-plugin-toolbar/selectionToolbar'
            });
            return position;
        }
    }, [
        editorView
    ]);
    return onPositionCalculated;
};
const $45575840139aacf3$export$5d706a9638468490 = ({ api: api, editorView: editorView, mountPoint: mountPoint, disableSelectionToolbarWhenPinned: disableSelectionToolbarWhenPinned, onToolbarMouseUp: onToolbarMouseUp })=>{
    var _api$toolbar, _api$toolbar2;
    const { connectivityStateMode: connectivityStateMode, editorToolbarDockingPreference: editorToolbarDockingPreference, currentUserIntent: currentUserIntent, shouldShowToolbar: shouldShowToolbar, editorViewMode: editorViewMode, contextualFormattingModeOverride: contextualFormattingModeOverride } = $45575840139aacf3$var$usePluginState(api);
    const contextualFormattingEnabled = contextualFormattingModeOverride ?? (api === null || api === void 0 || (_api$toolbar = api.toolbar) === null || _api$toolbar === void 0 ? void 0 : _api$toolbar.actions.contextualFormattingMode()) ?? 'always-pinned';
    const selectionToolbarConfigEnabled = (0, $2Sx33.shouldShowSelectionToolbar)(contextualFormattingEnabled, editorToolbarDockingPreference);
    const intl = (0, $4vLTk.default)();
    const components = api === null || api === void 0 || (_api$toolbar2 = api.toolbar) === null || _api$toolbar2 === void 0 ? void 0 : _api$toolbar2.actions.getComponents();
    const toolbar = components === null || components === void 0 ? void 0 : components.find((component)=>$45575840139aacf3$var$isToolbarComponent(component));
    const keyboardNavigation = (0, $bSJIT.useMemo)(()=>{
        return (0, $8brDA.getKeyboardNavigationConfig)(editorView, intl, api);
    }, [
        editorView,
        intl,
        api
    ]);
    const { isDisabled: isDisabled } = (0, $aBdvW.useToolbarUI)();
    const isOffline = (0, $hVGJk.isOfflineMode)(connectivityStateMode);
    const isTextSelection = !editorView.state.selection.empty && editorView.state.selection instanceof (0, $cw0wu.TextSelection);
    const isAllSelection = !editorView.state.selection.empty && editorView.state.selection instanceof (0, $cw0wu.AllSelection);
    const isCellSelection = !editorView.state.selection.empty && '$anchorCell' in editorView.state.selection;
    const onPositionCalculated = $45575840139aacf3$var$useOnPositionCalculated(editorView);
    if (selectionToolbarConfigEnabled && disableSelectionToolbarWhenPinned || !components || !toolbar) return null;
    if (!(isTextSelection || isCellSelection || isAllSelection) || currentUserIntent === 'dragging' || !shouldShowToolbar || currentUserIntent === 'blockMenuOpen' || // hide toolbar when user intent is not default, except when it's dragHandleSelected without cell selection
    (0, $6jZrP.isSelectionToolbarSuppressedByUserIntent)(currentUserIntent, isCellSelection) || (0, $7lseo.isSSR)()) return null;
    const toolbarContent = /*#__PURE__*/ (0, $dc70d.jsx)((0, $28qc1.EditorToolbarProvider), {
        editorView: editorView,
        editorToolbarDockingPreference: editorToolbarDockingPreference,
        editorViewMode: editorViewMode ?? 'edit',
        isOffline: isOffline,
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $43aKr.EditorToolbarUIProvider), {
            api: api,
            isDisabled: isDisabled,
            // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
            fireAnalyticsEvent: (payload)=>{
                var _api$analytics;
                api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 || _api$analytics.actions.fireAnalyticsEvent(payload);
            },
            keyboardNavigation: keyboardNavigation,
            children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $cvshM.ToolbarModelRenderer), {
                toolbar: toolbar,
                components: components,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                fallbacks: {
                    section: (0, $ap3j9.ToolbarSection),
                    menuSection: (0, $dlk6h.ToolbarDropdownItemSection),
                    group: (0, $5gDEv.ToolbarButtonGroup)
                }
            })
        })
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $5zk80.default), {
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        offset: [
            0,
            10
        ],
        target: (0, $5BdPH.getDomRefFromSelection)(editorView),
        onPositionCalculated: onPositionCalculated,
        mountTo: mountPoint,
        zIndex: (0, $5bbjm.akEditorFloatingDialogZIndex),
        children: (0, $3y2s4.isExperimentEnabled)('platform_editor_toolbar_multi_editor_fix') ? /*#__PURE__*/ (0, $dc70d.jsx)("div", {
            onMouseUpCapture: onToolbarMouseUp,
            children: toolbarContent
        }) : toolbarContent
    });
};
const $45575840139aacf3$export$316d94f683c144f1 = ({ api: api, editorView: editorView, mountPoint: mountPoint, disableSelectionToolbarWhenPinned: disableSelectionToolbarWhenPinned, onToolbarMouseUp: onToolbarMouseUp })=>{
    var _api$analytics2;
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $iUiGU.ErrorBoundary), {
        component: (0, $g6Qq4.ACTION_SUBJECT).TOOLBAR,
        componentId: (0, $g6Qq4.ACTION_SUBJECT_ID).SELECTION_TOOLBAR,
        dispatchAnalyticsEvent: api === null || api === void 0 || (_api$analytics2 = api.analytics) === null || _api$analytics2 === void 0 ? void 0 : _api$analytics2.actions.fireAnalyticsEvent,
        fallbackComponent: null,
        children: /*#__PURE__*/ (0, $dc70d.jsx)($45575840139aacf3$export$5d706a9638468490, {
            api: api,
            editorView: editorView,
            mountPoint: mountPoint,
            disableSelectionToolbarWhenPinned: disableSelectionToolbarWhenPinned,
            onToolbarMouseUp: onToolbarMouseUp
        })
    });
};

});
parcelRegister("2Sx33", function(module, exports) {
$parcel$export(module.exports, "shouldShowSelectionToolbar", () => $b40571529cc8b302$export$af4b2f219e301e70);
const $b40571529cc8b302$export$af4b2f219e301e70 = (contextualFormattingEnabled, toolbarDockingPosition)=>{
    if (contextualFormattingEnabled === 'controlled') return toolbarDockingPosition === 'top';
    if (contextualFormattingEnabled === 'always-inline') return true;
    return false;
};

});

parcelRegister("8brDA", function(module, exports) {
$parcel$export(module.exports, "getKeyboardNavigationConfig", () => $bb8e72a7fcf30216$export$48b8f4aa7f88bf3a);

var $c9wRy = parcelRequire("c9wRy");

var $1gu5b = parcelRequire("1gu5b");

var $j2Y9J = parcelRequire("j2Y9J");

var $k7NV2 = parcelRequire("k7NV2");

var $1pEzJ = parcelRequire("1pEzJ");
const $bb8e72a7fcf30216$export$48b8f4aa7f88bf3a = (editorView, intl, api)=>{
    if (!(editorView.dom instanceof HTMLElement)) return;
    const toolbarSelector = "[data-testid='editor-floating-toolbar']";
    return {
        childComponentSelector: toolbarSelector,
        dom: editorView.dom,
        isShortcutToFocusToolbar: (0, $1pEzJ.isShortcutToFocusToolbar),
        handleFocus: (event)=>{
            try {
                var _getDocument, _filteredFocusableEle, _filteredFocusableEle2, _filteredFocusableEle3;
                const toolbar = (_getDocument = (0, $c9wRy.getDocument)()) === null || _getDocument === void 0 ? void 0 : _getDocument.querySelector(toolbarSelector);
                if (!(toolbar instanceof HTMLElement)) return;
                const filteredFocusableElements = (0, $1pEzJ.getFocusableElements)(toolbar);
                (_filteredFocusableEle = filteredFocusableElements[0]) === null || _filteredFocusableEle === void 0 || _filteredFocusableEle.focus();
                // the button element removes the focus ring so this class adds it back
                if (((_filteredFocusableEle2 = filteredFocusableElements[0]) === null || _filteredFocusableEle2 === void 0 ? void 0 : _filteredFocusableEle2.tagName) === 'BUTTON') filteredFocusableElements[0].classList.add('first-floating-toolbar-button');
                (_filteredFocusableEle3 = filteredFocusableElements[0]) === null || _filteredFocusableEle3 === void 0 || _filteredFocusableEle3.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                    inline: 'nearest'
                });
                event.preventDefault();
                event.stopPropagation();
            } catch (error) {
                if (error instanceof Error) (0, $j2Y9J.logException)(error, {
                    location: 'editor-plugin-toolbar/selectionToolbar'
                });
            }
        },
        handleEscape: (event)=>{
            try {
                const isDropdownOpen = !!document.querySelector('[data-toolbar-component="menu-section"]');
                if (isDropdownOpen) return;
                api === null || api === void 0 || api.core.actions.focus();
                event.preventDefault();
                event.stopPropagation();
            } catch (error) {
                if (error instanceof Error) (0, $j2Y9J.logException)(error, {
                    location: 'editor-plugin-toolbar/selectionToolbar'
                });
            }
        },
        ariaControls: (0, $k7NV2.EDIT_AREA_ID),
        ariaLabel: intl.formatMessage((0, $1gu5b.messages).toolbarLabel)
    };
};

});
parcelRegister("1pEzJ", function(module, exports) {
$parcel$export(module.exports, "isEventInContainer", () => $74f79178f5eef876$export$3985dc3e1cbf9fe4);
$parcel$export(module.exports, "isShortcutToFocusToolbar", () => $74f79178f5eef876$export$d75f9c68101e0fa9);
$parcel$export(module.exports, "getFocusableElements", () => $74f79178f5eef876$export$433aaa1f216cf32d);
const $74f79178f5eef876$export$3985dc3e1cbf9fe4 = (event, containerSelector)=>{
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return false;
    return !!target.closest(containerSelector);
};
const $74f79178f5eef876$export$d75f9c68101e0fa9 = (event)=>{
    return event.altKey && event.key === 'F10';
};
const $74f79178f5eef876$export$433aaa1f216cf32d = (rootNode)=>{
    if (!rootNode) return [];
    const focusableElements = rootNode.querySelectorAll('a[href], button:not([disabled]), textarea, input, select, div[tabindex="-1"], div[tabindex="0"]') || [];
    const focusableElementsArray = Array.from(focusableElements);
    // filter out focusable elements from child components such as dropdown menus / popups
    return focusableElementsArray.filter((elm)=>{
        const style = window.getComputedStyle(elm);
        // filter out invisible elements
        return style.visibility !== 'hidden' && style.display !== 'none';
    });
};

});


parcelRegister("5BdPH", function(module, exports) {
$parcel$export(module.exports, "getDomRefFromSelection", () => $7904ca3d6e2ce895$export$49d74ed2464a12b9);

var $g6Qq4 = parcelRequire("g6Qq4");

var $j2Y9J = parcelRequire("j2Y9J");

var $gab48 = parcelRequire("gab48");
const $7904ca3d6e2ce895$export$49d74ed2464a12b9 = (view, dispatchAnalyticsEvent)=>{
    try {
        const domRef = (0, $gab48.findDomRefAtPos)(view.state.selection.from, view.domAtPos.bind(view));
        if (domRef instanceof HTMLElement) return domRef;
        throw new Error('Invalid DOM reference');
    } catch (error) {
        if (dispatchAnalyticsEvent) {
            const payload = {
                action: (0, $g6Qq4.ACTION).ERRORED,
                actionSubject: (0, $g6Qq4.ACTION_SUBJECT).CONTENT_COMPONENT,
                eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL,
                attributes: {
                    component: (0, $g6Qq4.CONTENT_COMPONENT).SELECTION_TOOLBAR,
                    selection: view.state.selection.toJSON(),
                    position: view.state.selection.from,
                    docSize: view.state.doc.nodeSize,
                    error: error instanceof Error ? error.toString() : String(error),
                    // @ts-expect-error - Object literal may only specify known properties, 'errorStack' does not exist in type
                    // This error was introduced after upgrading to TypeScript 5
                    errorStack: error instanceof Error ? error.stack : undefined
                }
            };
            dispatchAnalyticsEvent(payload);
        }
        if (error instanceof Error) (0, $j2Y9J.logException)(error, {
            location: 'editor-plugin-toolbar/selectionToolbar'
        });
    }
};

});


parcelRegister("bGGL7", function(module, exports) {
$parcel$export(module.exports, "getToolbarComponents", () => $6cd0d9fb9c1d9523$export$a758406ca53b86a5);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $g6Qq4 = parcelRequire("g6Qq4");

var $4rzOL = parcelRequire("4rzOL");

var $fiku8 = parcelRequire("fiku8");

var $f6IUb = parcelRequire("f6IUb");

var $aJU07 = parcelRequire("aJU07");

var $11dYY = parcelRequire("11dYY");

var $bcTVe = parcelRequire("bcTVe");

var $kEjs8 = parcelRequire("kEjs8");

var $3mxJ3 = parcelRequire("3mxJ3");

var $3F1qk = parcelRequire("3F1qk");

var $7cYRx = parcelRequire("7cYRx");

var $fKA14 = parcelRequire("fKA14");
const $6cd0d9fb9c1d9523$var$getInlineTextToolbarComponents = ()=>{
    return [
        {
            type: 'toolbar',
            key: (0, $4rzOL.TOOLBARS).INLINE_TEXT_TOOLBAR,
            component: ({ children: children })=>{
                return /*#__PURE__*/ (0, $dc70d.jsx)((0, $aJU07.Toolbar), {
                    label: (0, $11dYY.SELECTION_TOOLBAR_LABEL),
                    actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).SELECTION_TOOLBAR,
                    testId: 'editor-floating-toolbar',
                    children: children
                });
            }
        }
    ];
};
const $6cd0d9fb9c1d9523$var$getPrimaryToolbarComponents = (breakpointPreset)=>{
    return [
        {
            type: 'toolbar',
            key: (0, $4rzOL.TOOLBARS).PRIMARY_TOOLBAR,
            component: ({ children: children })=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $3F1qk.PrimaryToolbar), {
                    breakpointPreset: breakpointPreset,
                    children: children
                })
        }
    ];
};
const $6cd0d9fb9c1d9523$export$a758406ca53b86a5 = (contextualFormattingEnabled, api, breakpointPreset)=>{
    const components = [
        {
            type: (0, $4rzOL.TEXT_SECTION).type,
            key: (0, $4rzOL.TEXT_SECTION).key,
            parents: [
                {
                    type: 'toolbar',
                    key: (0, $4rzOL.TOOLBARS).INLINE_TEXT_TOOLBAR,
                    rank: (0, $fiku8.TOOLBAR_RANK)[(0, $4rzOL.TEXT_SECTION).key]
                }
            ],
            component: ({ children: children, parents: parents })=>{
                return /*#__PURE__*/ (0, $dc70d.jsx)((0, $f6IUb.Show), {
                    above: "md",
                    children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $7cYRx.Section), {
                        parents: parents,
                        api: api,
                        testId: "text-section",
                        children: children
                    })
                });
            }
        },
        {
            type: (0, $4rzOL.TEXT_SECTION_PRIMARY_TOOLBAR).type,
            key: (0, $4rzOL.TEXT_SECTION_PRIMARY_TOOLBAR).key,
            parents: [
                {
                    type: 'toolbar',
                    key: (0, $4rzOL.TOOLBARS).PRIMARY_TOOLBAR,
                    rank: (0, $fiku8.TOOLBAR_RANK)[(0, $4rzOL.TEXT_SECTION).key]
                }
            ],
            component: ({ children: children, parents: parents })=>{
                return /*#__PURE__*/ (0, $dc70d.jsx)((0, $f6IUb.Show), {
                    above: "md",
                    children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $7cYRx.Section), {
                        parents: parents,
                        api: api,
                        testId: "text-section",
                        children: children
                    })
                });
            }
        },
        {
            type: (0, $4rzOL.TEXT_SECTION_COLLAPSED).type,
            key: (0, $4rzOL.TEXT_SECTION_COLLAPSED).key,
            parents: [
                {
                    type: 'toolbar',
                    key: (0, $4rzOL.TOOLBARS).PRIMARY_TOOLBAR,
                    rank: (0, $fiku8.TOOLBAR_RANK)[(0, $4rzOL.TEXT_SECTION_COLLAPSED).key]
                },
                {
                    type: 'toolbar',
                    key: (0, $4rzOL.TOOLBARS).INLINE_TEXT_TOOLBAR,
                    rank: (0, $fiku8.TOOLBAR_RANK)[(0, $4rzOL.TEXT_SECTION_COLLAPSED).key]
                }
            ],
            component: ({ children: children, parents: parents })=>{
                return /*#__PURE__*/ (0, $dc70d.jsx)((0, $f6IUb.Show), {
                    below: "md",
                    children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $7cYRx.Section), {
                        parents: parents,
                        api: api,
                        testId: "text-section",
                        children: children
                    })
                });
            }
        },
        {
            type: (0, $4rzOL.TEXT_COLLAPSED_GROUP).type,
            key: (0, $4rzOL.TEXT_COLLAPSED_GROUP).key,
            parents: [
                {
                    type: (0, $4rzOL.TEXT_SECTION_COLLAPSED).type,
                    key: (0, $4rzOL.TEXT_SECTION_COLLAPSED).key,
                    rank: 100
                }
            ]
        },
        {
            type: (0, $4rzOL.TEXT_COLLAPSED_MENU).type,
            key: (0, $4rzOL.TEXT_COLLAPSED_MENU).key,
            parents: [
                {
                    type: (0, $4rzOL.TEXT_COLLAPSED_GROUP).type,
                    key: (0, $4rzOL.TEXT_COLLAPSED_GROUP).key,
                    rank: 100
                }
            ],
            component: (0, $fKA14.TextCollapsedMenu)
        },
        {
            type: (0, $4rzOL.INSERT_BLOCK_SECTION).type,
            key: (0, $4rzOL.INSERT_BLOCK_SECTION).key,
            parents: [
                {
                    type: 'toolbar',
                    key: (0, $4rzOL.TOOLBARS).PRIMARY_TOOLBAR,
                    rank: (0, $fiku8.TOOLBAR_RANK)[(0, $4rzOL.INSERT_BLOCK_SECTION).key]
                }
            ],
            component: ({ children: children, parents: parents })=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $7cYRx.Section), {
                    testId: "insert-block-section",
                    parents: parents,
                    api: api,
                    showSeparatorInFullPagePrimaryToolbar: true,
                    isSharedSection: false,
                    children: children
                })
        },
        {
            type: (0, $4rzOL.LINKING_SECTION).type,
            key: (0, $4rzOL.LINKING_SECTION).key,
            parents: [
                {
                    type: 'toolbar',
                    key: (0, $4rzOL.TOOLBARS).INLINE_TEXT_TOOLBAR,
                    rank: (0, $fiku8.TOOLBAR_RANK)[(0, $4rzOL.LINKING_SECTION).key]
                },
                {
                    type: 'toolbar',
                    key: (0, $4rzOL.TOOLBARS).PRIMARY_TOOLBAR,
                    rank: (0, $fiku8.TOOLBAR_RANK)[(0, $4rzOL.LINKING_SECTION).key]
                }
            ],
            component: ({ children: children, parents: parents })=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $7cYRx.Section), {
                    testId: "link-section",
                    parents: parents,
                    api: api,
                    showSeparatorInFullPagePrimaryToolbar: true,
                    children: children
                })
        },
        {
            type: (0, $4rzOL.OVERFLOW_SECTION).type,
            key: (0, $4rzOL.OVERFLOW_SECTION).key,
            parents: [
                {
                    type: 'toolbar',
                    key: (0, $4rzOL.TOOLBARS).INLINE_TEXT_TOOLBAR,
                    rank: (0, $fiku8.TOOLBAR_RANK)[(0, $4rzOL.OVERFLOW_SECTION).key]
                }
            ]
        },
        {
            type: (0, $4rzOL.OVERFLOW_GROUP).type,
            key: (0, $4rzOL.OVERFLOW_GROUP).key,
            parents: [
                {
                    type: (0, $4rzOL.OVERFLOW_SECTION).type,
                    key: (0, $4rzOL.OVERFLOW_SECTION).key,
                    rank: (0, $fiku8.OVERFLOW_SECTION_RANK)[(0, $4rzOL.OVERFLOW_GROUP).key]
                }
            ]
        },
        {
            type: (0, $4rzOL.OVERFLOW_MENU).type,
            key: (0, $4rzOL.OVERFLOW_MENU).key,
            parents: [
                {
                    type: (0, $4rzOL.OVERFLOW_GROUP).type,
                    key: (0, $4rzOL.OVERFLOW_GROUP).key,
                    rank: (0, $fiku8.OVERFLOW_GROUP_RANK)[(0, $4rzOL.OVERFLOW_MENU).key]
                }
            ],
            component: ({ children: children })=>{
                return /*#__PURE__*/ (0, $dc70d.jsx)((0, $bcTVe.OverflowMenu), {
                    children: children
                });
            }
        },
        {
            type: (0, $4rzOL.OVERFLOW_EXTENSIONS_MENU_SECTION).type,
            key: (0, $4rzOL.OVERFLOW_EXTENSIONS_MENU_SECTION).key,
            parents: [
                {
                    type: (0, $4rzOL.OVERFLOW_MENU).type,
                    key: (0, $4rzOL.OVERFLOW_MENU).key,
                    rank: (0, $fiku8.OVERFLOW_MENU_RANK)[(0, $4rzOL.OVERFLOW_EXTENSIONS_MENU_SECTION).key]
                }
            ],
            component: (0, $kEjs8.OverflowMenuSection)
        },
        {
            type: (0, $4rzOL.PIN_SECTION).type,
            key: (0, $4rzOL.PIN_SECTION).key,
            parents: [
                {
                    type: 'toolbar',
                    key: (0, $4rzOL.TOOLBARS).PRIMARY_TOOLBAR,
                    rank: (0, $fiku8.TOOLBAR_RANK)[(0, $4rzOL.PIN_SECTION).key]
                }
            ],
            component: ({ children: children, parents: parents })=>{
                return /*#__PURE__*/ (0, $dc70d.jsx)((0, $7cYRx.Section), {
                    testId: "pin-section",
                    parents: parents,
                    api: api,
                    showSeparatorInFullPagePrimaryToolbar: true,
                    children: children
                });
            }
        }
    ];
    components.push({
        type: (0, $4rzOL.OVERFLOW_SECTION_PRIMARY_TOOLBAR).type,
        key: (0, $4rzOL.OVERFLOW_SECTION_PRIMARY_TOOLBAR).key,
        parents: [
            {
                type: 'toolbar',
                key: (0, $4rzOL.TOOLBARS).PRIMARY_TOOLBAR,
                rank: (0, $fiku8.TOOLBAR_RANK)[(0, $4rzOL.OVERFLOW_SECTION_PRIMARY_TOOLBAR).key]
            }
        ],
        component: ({ children: children })=>{
            return /*#__PURE__*/ (0, $dc70d.jsx)((0, $3mxJ3.OverflowSection), {
                children: children
            });
        }
    }, {
        type: (0, $4rzOL.OVERFLOW_GROUP_PRIMARY_TOOLBAR).type,
        key: (0, $4rzOL.OVERFLOW_GROUP_PRIMARY_TOOLBAR).key,
        parents: [
            {
                type: (0, $4rzOL.OVERFLOW_SECTION_PRIMARY_TOOLBAR).type,
                key: (0, $4rzOL.OVERFLOW_SECTION_PRIMARY_TOOLBAR).key,
                rank: (0, $fiku8.OVERFLOW_SECTION_PRIMARY_TOOLBAR_RANK)[(0, $4rzOL.OVERFLOW_GROUP_PRIMARY_TOOLBAR).key]
            }
        ]
    }, {
        type: (0, $4rzOL.OVERFLOW_MENU_PRIMARY_TOOLBAR).type,
        key: (0, $4rzOL.OVERFLOW_MENU_PRIMARY_TOOLBAR).key,
        parents: [
            {
                type: (0, $4rzOL.OVERFLOW_GROUP_PRIMARY_TOOLBAR).type,
                key: (0, $4rzOL.OVERFLOW_GROUP_PRIMARY_TOOLBAR).key,
                rank: (0, $fiku8.OVERFLOW_GROUP_PRIMARY_TOOLBAR_RANK)[(0, $4rzOL.OVERFLOW_MENU_PRIMARY_TOOLBAR).key]
            }
        ],
        component: ({ children: children })=>{
            return /*#__PURE__*/ (0, $dc70d.jsx)((0, $bcTVe.OverflowMenu), {
                children: children
            });
        }
    });
    switch(contextualFormattingEnabled){
        case 'always-inline':
            components.unshift(...$6cd0d9fb9c1d9523$var$getInlineTextToolbarComponents());
            break;
        case 'always-pinned':
            components.unshift(...$6cd0d9fb9c1d9523$var$getPrimaryToolbarComponents(breakpointPreset));
            break;
        case 'controlled':
            components.unshift(...$6cd0d9fb9c1d9523$var$getInlineTextToolbarComponents());
            components.unshift(...$6cd0d9fb9c1d9523$var$getPrimaryToolbarComponents(breakpointPreset));
            break;
    }
    components.push({
        type: (0, $4rzOL.TRACK_CHANGES_SECTION).type,
        key: (0, $4rzOL.TRACK_CHANGES_SECTION).key,
        parents: [
            {
                type: 'toolbar',
                key: (0, $4rzOL.TOOLBARS).PRIMARY_TOOLBAR,
                rank: (0, $fiku8.TOOLBAR_RANK)[(0, $4rzOL.TRACK_CHANGES_SECTION).key]
            }
        ],
        component: ({ children: children, parents: parents })=>{
            return /*#__PURE__*/ (0, $dc70d.jsx)((0, $7cYRx.Section), {
                testId: "track-changes-section",
                parents: parents,
                api: api,
                showSeparatorInFullPagePrimaryToolbar: true,
                children: children
            });
        }
    });
    return components;
};

});
parcelRegister("aJU07", function(module, exports) {
$parcel$export(module.exports, "Toolbar", () => $180badfff0e07c75$export$4c260019440d418f);
$parcel$export(module.exports, "PrimaryToolbar", () => $180badfff0e07c75$export$7469f9986edfc2);
/* Toolbar.tsx generated by @compiled/babel-plugin v3.0.2 */ /* Toolbar.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-selectors */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $jDsoo = parcelRequire("jDsoo");

var $9PwDt = parcelRequire("9PwDt");

var $aBdvW = parcelRequire("aBdvW");

var $aPYHQ = parcelRequire("aPYHQ");

var $eOIiR = parcelRequire("eOIiR");

var $gi4gQ = parcelRequire("gi4gQ");
const $180badfff0e07c75$var$styles = {
    toolbarBase: "_2rko1qi0 _zulp1b66 _1e0c1txw _4cvr1h6o",
    toolbar: "_bfhk1bhr _4t3i14no _u5f31b66 _19bv1b66 _16qs130s",
    toolbarResponsive: "_195gpxbi",
    primaryToolbar: "_bfhkvuon _1tkezwfg",
    toolbarSeparator: "_1mj714no",
    hiddenSelectors: "_fy9oglyw _18shglyw _ze7rglyw",
    hiddenSelectorsPatch: "_z5m7glyw"
};
const $180badfff0e07c75$export$4c260019440d418f = ({ children: children, label: label, actionSubjectId: actionSubjectId, testId: testId })=>{
    const toolbar = /*#__PURE__*/ (0, $dc70d.jsxs)((0, $9PwDt.Box), {
        xcss: (0, $jDsoo.cx)($180badfff0e07c75$var$styles.toolbarBase, $180badfff0e07c75$var$styles.toolbar, $180badfff0e07c75$var$styles.toolbarResponsive, $180badfff0e07c75$var$styles.hiddenSelectors, $180badfff0e07c75$var$styles.toolbarSeparator, $180badfff0e07c75$var$styles.hiddenSelectorsPatch),
        "aria-label": label,
        testId: testId,
        "data-toolbar-type": "inline",
        children: [
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $gi4gQ.ViewEventEmitter), {
                actionSubject: (0, $gi4gQ.ACTION_SUBJECT).TOOLBAR,
                actionSubjectId: actionSubjectId
            }),
            children
        ]
    });
    let wrappedToolbar = toolbar;
    const { keyboardNavigation: keyboardNavigation } = (0, $aBdvW.useToolbarUI)();
    if (keyboardNavigation) {
        const { childComponentSelector: childComponentSelector, dom: dom, handleEscape: handleEscape, handleFocus: handleFocus, isShortcutToFocusToolbar: isShortcutToFocusToolbar, ariaControls: ariaControls, ariaLabel: ariaLabel } = keyboardNavigation;
        wrappedToolbar = /*#__PURE__*/ (0, $dc70d.jsx)((0, $eOIiR.ToolbarKeyboardNavigationProvider), {
            childComponentSelector: childComponentSelector,
            dom: dom,
            isShortcutToFocusToolbar: isShortcutToFocusToolbar,
            handleEscape: handleEscape,
            handleFocus: handleFocus,
            ariaControls: ariaControls,
            ariaLabel: ariaLabel,
            children: toolbar
        });
    }
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $aPYHQ.ResponsiveWrapper), {
        children: wrappedToolbar
    });
};
const $180badfff0e07c75$export$7469f9986edfc2 = ({ children: children, breakpointPreset: breakpointPreset, testId: testId })=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $aPYHQ.ResponsiveContainer), {
        breakpointPreset: breakpointPreset,
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
            xcss: (0, $jDsoo.cx)($180badfff0e07c75$var$styles.toolbarBase, $180badfff0e07c75$var$styles.primaryToolbar, $180badfff0e07c75$var$styles.hiddenSelectors),
            "data-toolbar-type": "primary",
            testId: testId,
            children: children
        })
    });
};

});
parcelRegister("aPYHQ", function(module, exports) {
$parcel$export(module.exports, "ResponsiveContainer", () => $d920e8a83e9b469b$export$e60a4704009a0009);
$parcel$export(module.exports, "ResponsiveWrapper", () => $d920e8a83e9b469b$export$fa6e408d6a7d6214);
/* ResponsiveContainer.tsx generated by @compiled/babel-plugin v3.0.2 */ /* ResponsiveContainer.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-selectors */ /* eslint-disable @atlaskit/ui-styling-standard/no-container-queries */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $jDsoo = parcelRequire("jDsoo");

var $3zzvD = parcelRequire("3zzvD");

var $9PwDt = parcelRequire("9PwDt");
const $d920e8a83e9b469b$var$styles = {
    responsiveContainer: "_1bsb1osq _7cca15wb _1f38ptqj _1bx91ule _1ehg1ule _1onx1ule _1xt01ule _zg9wglyw _1a2cglyw _sum2glyw _1vtcglyw _1ir3glyw _1vp2glyw _1eadglyw _a6zzglyw",
    responsiveContainerFullPage: "_1bsb1ns9 _1bx91ule _1ehg1ule _1onx1ule _1xt01ule _zg9wglyw _1a2cglyw _sum2glyw _1vtcglyw _1ir3glyw _1vp2glyw _1eadglyw _a6zzglyw",
    fullpage: "_luoiglyw _2ojp1ule _11uvglyw _fj2k1ule _1nqyglyw _jd611ule _syrzglyw _fr6v1ule _1je21ule _1btx1ule _biad1ule _1ana1ule",
    fullpageUpdated: "_1hjdglyw _h45w1ule _1ewsglyw _1vlh1ule _11uvglyw _fj2k1ule _1lepglyw _1c391ule _1ihv1ule _99in1ule _xbt51ule _1kmq1ule",
    reduced: "_kkyiglyw _1dj81ule _1cg81ule _j3qgglyw _xh1i1ule _oj3l1ule _13s9glyw _4nul1ule _wt211ule _tzm6glyw _ktne1ule _87bn1ule",
    jiraIssue: "_152xglyw _1cn41ule _1j4d1ule _1n52glyw _1nd71ule _lf431ule _103bglyw _1p0z1ule _g5yu1ule _tzm6glyw _ktne1ule _87bn1ule",
    jsmComment: "_s2iiglyw _o4331ule _1u301ule _u7j1glyw _c7al1ule _14ob1ule _1b07glyw _1meg1ule _1bqk1ule _tzm6glyw _ktne1ule _87bn1ule",
    confluenceComment: "_15nrglyw _cm5a1ule _7qjy1ule _13ioglyw _8urt1ule _cpaf1ule _18zmglyw _1uj01ule _1oqh1ule _tzm6glyw _ktne1ule _87bn1ule",
    responsiveRulesWrapper: "_1bx91ule _1ehg1ule _1onx1ule _1xt01ule _zg9wglyw _1a2cglyw _sum2glyw _1vtcglyw _33p2glyw _1dre1ule _u47mglyw _rut51ule _fj5dglyw _5wt61ule _hmx4glyw _1rrm1ule _ut18glyw _1nwo1ule _19fzglyw _1r831ule"
};
const $d920e8a83e9b469b$var$presetStyleMap = {
    fullpage: $d920e8a83e9b469b$var$styles.fullpage,
    reduced: $d920e8a83e9b469b$var$styles.reduced,
    'jira-issue': $d920e8a83e9b469b$var$styles.jiraIssue,
    'jsm-comment': $d920e8a83e9b469b$var$styles.jsmComment,
    'confluence-comment': $d920e8a83e9b469b$var$styles.confluenceComment
};
const $d920e8a83e9b469b$var$updatedPresetStyleMap = {
    fullpage: $d920e8a83e9b469b$var$styles.fullpageUpdated
};
const $d920e8a83e9b469b$export$e60a4704009a0009 = ({ children: children, breakpointPreset: breakpointPreset })=>{
    const isUpdatedConfig = breakpointPreset === 'fullpage' && (0, $3zzvD.UNSAFE_expValNoExposure)('platform_editor_ai_content_suggested_edits', 'isEnabled', false);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
        xcss: (0, $jDsoo.cx)(breakpointPreset === 'fullpage' ? $d920e8a83e9b469b$var$styles.responsiveContainerFullPage : $d920e8a83e9b469b$var$styles.responsiveContainer, isUpdatedConfig ? $d920e8a83e9b469b$var$updatedPresetStyleMap[breakpointPreset] : $d920e8a83e9b469b$var$presetStyleMap[breakpointPreset]),
        children: children
    });
};
const $d920e8a83e9b469b$export$fa6e408d6a7d6214 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
        xcss: $d920e8a83e9b469b$var$styles.responsiveRulesWrapper,
        children: children
    });
};

});

parcelRegister("gi4gQ", function(module, exports) {
$parcel$export(module.exports, "ACTION_SUBJECT", () => $6033cc0a61cdaf24$export$7525482b5931e326);
$parcel$export(module.exports, "ViewEventEmitter", () => $6033cc0a61cdaf24$export$58d0f383acf77599);

var $bSJIT = parcelRequire("bSJIT");

var $aBdvW = parcelRequire("aBdvW");
const $6033cc0a61cdaf24$export$7525482b5931e326 = {
    TOOLBAR: 'toolbar',
    TOOLBAR_DROPDOWN_MENU: 'toolbarDropdownMenu'
};
const $6033cc0a61cdaf24$export$58d0f383acf77599 = ({ actionSubjectId: actionSubjectId, actionSubject: actionSubject })=>{
    const isMountedRef = (0, $bSJIT.useRef)(false);
    const { fireAnalyticsEvent: fireAnalyticsEvent } = (0, $aBdvW.useToolbarUI)();
    (0, $bSJIT.useEffect)(()=>{
        if (isMountedRef.current) return;
        isMountedRef.current = true;
        const payload = {
            action: 'viewed',
            actionSubject: actionSubject,
            actionSubjectId: actionSubjectId,
            eventType: 'ui'
        };
        fireAnalyticsEvent && fireAnalyticsEvent(payload);
    }, [
        actionSubjectId,
        actionSubject,
        fireAnalyticsEvent
    ]);
    return null;
};

});


parcelRegister("bcTVe", function(module, exports) {
$parcel$export(module.exports, "OverflowMenu", () => $c888c424084dd406$export$f62801e1786d0b09);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $glyUo = parcelRequire("glyUo");

var $6ZIqd = parcelRequire("6ZIqd");

var $6PDfA = parcelRequire("6PDfA");

var $eHnl8 = parcelRequire("eHnl8");
const $c888c424084dd406$export$f62801e1786d0b09 = ({ children: children })=>{
    const intl = (0, $4vLTk.default)();
    const tooltipContent = intl.formatMessage((0, $glyUo.toolbarMessages).selectionToolbarOverflowMenuTooltip);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $6PDfA.ToolbarDropdownMenu), {
        label: tooltipContent,
        iconBefore: /*#__PURE__*/ (0, $dc70d.jsx)((0, $6ZIqd.ShowMoreHorizontalIcon), {
            label: ""
        }),
        tooltipComponent: /*#__PURE__*/ (0, $dc70d.jsx)((0, $eHnl8.ToolbarTooltip), {
            content: tooltipContent,
            position: "top"
        }),
        children: children
    });
};

});
parcelRegister("6ZIqd", function(module, exports) {
$parcel$export(module.exports, "ShowMoreHorizontalIcon", () => $f02bb9eb4001214a$export$c07cde1baa478056);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $iabGk = parcelRequire("iabGk");
const $f02bb9eb4001214a$export$c07cde1baa478056 = ({ label: label, testId: testId, color: color, shouldRecommendSmallIcon: shouldRecommendSmallIcon, spacing: spacing })=>/*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iabGk))), {
        label: label,
        testId: testId,
        color: color,
        shouldRecommendSmallIcon: shouldRecommendSmallIcon,
        spacing: spacing,
        size: "small"
    });

});


parcelRegister("kEjs8", function(module, exports) {
$parcel$export(module.exports, "OverflowMenuSection", () => $56639ba1a642b04b$export$e3cf1fcb813fa9a4);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $28qc1 = parcelRequire("28qc1");

var $dlk6h = parcelRequire("dlk6h");
const $56639ba1a642b04b$export$e3cf1fcb813fa9a4 = ({ children: children })=>{
    const { editorViewMode: editorViewMode } = (0, $28qc1.useEditorToolbar)();
    const isEdit = editorViewMode === 'edit';
    // only show separator in edit mode, when the pinned toolbar option is available
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dlk6h.ToolbarDropdownItemSection), {
        hasSeparator: isEdit,
        children: children
    });
};

});

parcelRegister("3mxJ3", function(module, exports) {
$parcel$export(module.exports, "OverflowSection", () => $bfb3b4e3e5a4577e$export$3590112bc75b92dc);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $28qc1 = parcelRequire("28qc1");

var $ap3j9 = parcelRequire("ap3j9");
const $bfb3b4e3e5a4577e$export$3590112bc75b92dc = ({ children: children, hasSeparator: hasSeparator, testId: testId })=>{
    const { editorAppearance: editorAppearance } = (0, $28qc1.useEditorToolbar)();
    if (editorAppearance === 'full-page') return null;
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $ap3j9.ToolbarSection), {
        hasSeparator: hasSeparator,
        testId: testId,
        children: children
    });
};

});

parcelRegister("3F1qk", function(module, exports) {
$parcel$export(module.exports, "PrimaryToolbar", () => $c3d2ba716243647d$export$7469f9986edfc2);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $28qc1 = parcelRequire("28qc1");

var $aJU07 = parcelRequire("aJU07");
const $c3d2ba716243647d$var$isFullPage = (editorAppearance)=>{
    return editorAppearance === 'full-page' || editorAppearance === 'full-width';
};
const $c3d2ba716243647d$var$getBreakpointPreset = (breakpointPreset, editorAppearance)=>{
    if (breakpointPreset) return breakpointPreset;
    return editorAppearance && $c3d2ba716243647d$var$isFullPage(editorAppearance) ? 'fullpage' : 'reduced';
};
const $c3d2ba716243647d$export$7469f9986edfc2 = ({ children: children, breakpointPreset: breakpointPreset })=>{
    const { editorAppearance: editorAppearance } = (0, $28qc1.useEditorToolbar)();
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $aJU07.PrimaryToolbar), {
        testId: "editor-primary-toolbar",
        breakpointPreset: $c3d2ba716243647d$var$getBreakpointPreset(breakpointPreset, editorAppearance),
        children: children
    });
};

});

parcelRegister("7cYRx", function(module, exports) {
$parcel$export(module.exports, "Section", () => $0a1b00ffa83075bf$export$6e2c8f0811a474ce);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $28qc1 = parcelRequire("28qc1");

var $4rzOL = parcelRequire("4rzOL");

var $5beht = parcelRequire("5beht");

var $ap3j9 = parcelRequire("ap3j9");
const $0a1b00ffa83075bf$var$shouldShowSection = (editMode, toolbar, toolbarDocking, contextualFormattingEnabled)=>{
    if (editMode === 'view') return false;
    if ((toolbar === null || toolbar === void 0 ? void 0 : toolbar.key) === (0, $4rzOL.TOOLBARS).INLINE_TEXT_TOOLBAR) return toolbarDocking !== 'top' || contextualFormattingEnabled === 'always-inline';
    if ((toolbar === null || toolbar === void 0 ? void 0 : toolbar.key) === (0, $4rzOL.TOOLBARS).PRIMARY_TOOLBAR) return toolbarDocking !== 'none' || contextualFormattingEnabled === 'always-pinned';
    return false;
};
const $0a1b00ffa83075bf$var$usePluginState = (_api)=>{
    const { editorViewMode: editorViewMode, editorToolbarDockingPreference: editorToolbarDockingPreference, editorAppearance: editorAppearance } = (0, $28qc1.useEditorToolbar)();
    return {
        editorViewMode: editorViewMode,
        editorToolbarDockingPreference: editorToolbarDockingPreference,
        editorAppearance: editorAppearance
    };
};
const $0a1b00ffa83075bf$export$6e2c8f0811a474ce = ({ children: children, parents: parents, api: api, testId: testId, showSeparatorInFullPagePrimaryToolbar: showSeparatorInFullPagePrimaryToolbar, isSharedSection: isSharedSection = true })=>{
    var _api$toolbar;
    const { editorViewMode: editorViewMode, editorToolbarDockingPreference: editorToolbarDockingPreference, editorAppearance: editorAppearance } = $0a1b00ffa83075bf$var$usePluginState(api);
    const runtimeOverride = (0, $5beht.useSharedPluginStateWithSelector)(api, [
        'toolbar'
    ], (states)=>{
        var _states$toolbarState;
        return (_states$toolbarState = states.toolbarState) === null || _states$toolbarState === void 0 ? void 0 : _states$toolbarState.contextualFormattingModeOverride;
    });
    const toolbar = parents.find((parent)=>parent.type === 'toolbar');
    const contextualFormattingEnabled = runtimeOverride ?? (api === null || api === void 0 || (_api$toolbar = api.toolbar) === null || _api$toolbar === void 0 ? void 0 : _api$toolbar.actions.contextualFormattingMode()) ?? 'always-pinned';
    if (isSharedSection && !$0a1b00ffa83075bf$var$shouldShowSection(editorViewMode, toolbar, editorToolbarDockingPreference, contextualFormattingEnabled)) return null;
    const isFullPage = editorAppearance === 'full-page';
    const hasSeparator = showSeparatorInFullPagePrimaryToolbar && isFullPage;
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $ap3j9.ToolbarSection), {
        testId: testId,
        hasSeparator: hasSeparator ? (0, $ap3j9.SeparatorPosition).START : hasSeparator,
        children: children
    });
};

});

parcelRegister("fKA14", function(module, exports) {
$parcel$export(module.exports, "TextCollapsedMenu", () => $1222bd40eeecb359$export$55607282fee51b86);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $glyUo = parcelRequire("glyUo");

var $dca9w = parcelRequire("dca9w");

var $6PDfA = parcelRequire("6PDfA");

var $eHnl8 = parcelRequire("eHnl8");
const $1222bd40eeecb359$export$55607282fee51b86 = ({ children: children })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $6PDfA.ToolbarDropdownMenu), {
        iconBefore: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dca9w))), {
            label: formatMessage((0, $glyUo.toolbarMessages).textStylesTooltip),
            size: "small"
        }),
        enableMaxHeight: true,
        tooltipComponent: /*#__PURE__*/ (0, $dc70d.jsx)((0, $eHnl8.ToolbarTooltip), {
            content: formatMessage((0, $glyUo.toolbarMessages).textStylesTooltip)
        }),
        children: children
    });
};

});



parcelRegister("143O4", function(module, exports) {
$parcel$export(module.exports, "typeAheadPlugin", () => $25719cba1a38ad64$export$a023c922ef32b883);
/**
 *
 * Revamped typeahead using decorations instead of the `typeAheadQuery` mark
 *
 * https://product-fabric.atlassian.net/wiki/spaces/E/pages/2992177582/Technical+TypeAhead+Data+Flow
 *
 *
 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $5pFl5 = parcelRequire("5pFl5");

var $g6Qq4 = parcelRequire("g6Qq4");

var $f7Kk4 = parcelRequire("f7Kk4");

var $aaLLt = parcelRequire("aaLLt");

var $a3b9P = parcelRequire("a3b9P");

var $gdUUy = parcelRequire("gdUUy");

var $8nLP3 = parcelRequire("8nLP3");

var $7EziY = parcelRequire("7EziY");

var $7GPfv = parcelRequire("7GPfv");

var $cQH44 = parcelRequire("cQH44");

var $2fG6X = parcelRequire("2fG6X");

var $g7mVf = parcelRequire("g7mVf");

var $1Fs6f = parcelRequire("1Fs6f");

var $fHRcq = parcelRequire("fHRcq");

var $kJH9k = parcelRequire("kJH9k");

var $479du = parcelRequire("479du");

var $1JKxC = parcelRequire("1JKxC");
const $25719cba1a38ad64$var$createOpenAtTransaction = (props)=>(tr)=>{
        return (0, $7GPfv.openTypeAheadAtCursor)(props)({
            tr: tr
        }) !== null;
    };
const $25719cba1a38ad64$var$createOpenTypeAhead = (editorViewRef)=>(props)=>{
        if (!editorViewRef.current) return false;
        const { current: view } = editorViewRef;
        const { tr: tr } = view.state;
        if (!$25719cba1a38ad64$var$createOpenAtTransaction(props)(tr)) return false;
        view.dispatch(tr);
        return true;
    };
const $25719cba1a38ad64$var$createInsertTypeAheadItem = (editorViewRef)=>(props)=>{
        if (!editorViewRef.current) return false;
        const { current: view } = editorViewRef;
        const { triggerHandler: triggerHandler, contentItem: contentItem, query: query, sourceListItem: sourceListItem, mode: mode } = props;
        (0, $7EziY.insertTypeAheadItem)(view)({
            handler: triggerHandler,
            item: contentItem,
            mode: mode || (0, $aaLLt.SelectItemMode).SELECTED,
            query: query,
            sourceListItem: sourceListItem
        });
        return true;
    };
const $25719cba1a38ad64$var$createFindHandlerByTrigger = (editorViewRef)=>(trigger)=>{
        if (!editorViewRef.current) return null;
        const { current: view } = editorViewRef;
        return (0, $479du.findHandler)(trigger, view.state);
    };
const $25719cba1a38ad64$var$createUpdateSectionTitle = (editorViewRef)=>(props)=>{
        if (!editorViewRef.current) return false;
        const { current: view } = editorViewRef;
        return (0, $cQH44.updateSectionTitle)(props)(view.state, view.dispatch);
    };
const $25719cba1a38ad64$var$createCloseTypeAhead = (editorViewRef)=>(options)=>{
        if (!editorViewRef.current) return false;
        const { current: view } = editorViewRef;
        const currentQuery = (0, $479du.getTypeAheadQuery)(view.state) || '';
        const { state: state } = view;
        let tr = state.tr;
        if (options.attachCommand) {
            const fakeDispatch = (customTr)=>{
                tr = customTr;
            };
            options.attachCommand(state, fakeDispatch);
        }
        (0, $8nLP3.closeTypeAhead)(tr);
        if (options.insertCurrentQueryAsRawText && currentQuery && currentQuery.length > 0) {
            const handler = (0, $479du.getTypeAheadHandler)(state);
            if (!handler) return false;
            const text = handler.trigger.concat(currentQuery);
            tr.replaceSelectionWith(state.schema.text(text));
        }
        view.dispatch(tr);
        if (!view.hasFocus()) view.focus();
        return true;
    };
const $25719cba1a38ad64$export$a023c922ef32b883 = ({ api: api })=>{
    const popupMountRef = {
        current: null
    };
    const editorViewRef = {
        current: null
    };
    return {
        name: 'typeAhead',
        marks () {
            // We need to keep this to make sure
            // All documents with typeahead marks will be loaded normally
            return [
                {
                    name: 'typeAheadQuery',
                    mark: (0, $5pFl5.typeAheadQuery)
                }
            ];
        },
        pmPlugins (typeAhead = []) {
            return [
                {
                    name: 'typeAhead',
                    plugin: ({ dispatch: dispatch, getIntl: getIntl, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI })=>(0, $fHRcq.createPlugin)({
                            getIntl: getIntl,
                            popupMountRef: popupMountRef,
                            reactDispatch: dispatch,
                            typeAheadHandlers: typeAhead,
                            nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
                            api: api
                        })
                },
                {
                    name: 'typeAheadEditorViewRef',
                    plugin: ()=>{
                        return new (0, $f7Kk4.SafePlugin)({
                            view (view) {
                                editorViewRef.current = view;
                                return {
                                    destroy () {
                                        editorViewRef.current = null;
                                    }
                                };
                            }
                        });
                    }
                },
                {
                    name: 'typeAheadInsertItem',
                    plugin: (0, $g7mVf.createPlugin)
                },
                {
                    name: 'typeAheadInputRule',
                    plugin: ({ schema: schema, featureFlags: featureFlags })=>(0, $2fG6X.inputRulePlugin)(schema, typeAhead, featureFlags)
                }
            ];
        },
        getSharedState (editorState) {
            if (!editorState) return {
                query: '',
                isOpen: false,
                isAllowed: false,
                currentHandler: undefined,
                decorationSet: (0, $a3b9P.DecorationSet).empty,
                decorationElement: null,
                triggerHandler: undefined,
                items: [],
                sections: [],
                errorInfo: null,
                selectedIndex: 0
            };
            const isOpen = (0, $479du.isTypeAheadOpen)(editorState);
            const state = (0, $479du.getPluginState)(editorState);
            return {
                query: (0, $479du.getTypeAheadQuery)(editorState) || '',
                currentHandler: (0, $479du.getTypeAheadHandler)(editorState),
                isOpen: isOpen,
                isAllowed: !isOpen,
                decorationSet: (state === null || state === void 0 ? void 0 : state.decorationSet) ?? (0, $a3b9P.DecorationSet).empty,
                decorationElement: (state === null || state === void 0 ? void 0 : state.decorationElement) ?? null,
                triggerHandler: state === null || state === void 0 ? void 0 : state.triggerHandler,
                items: (state === null || state === void 0 ? void 0 : state.items) ?? [],
                sections: (state === null || state === void 0 ? void 0 : state.sections) ?? [],
                errorInfo: (state === null || state === void 0 ? void 0 : state.errorInfo) ?? null,
                selectedIndex: (state === null || state === void 0 ? void 0 : state.selectedIndex) ?? 0
            };
        },
        actions: {
            isOpen: (0, $479du.isTypeAheadOpen),
            isAllowed: (0, $479du.isTypeAheadAllowed),
            open: $25719cba1a38ad64$var$createOpenTypeAhead(editorViewRef),
            openAtTransaction: $25719cba1a38ad64$var$createOpenAtTransaction,
            findHandlerByTrigger: $25719cba1a38ad64$var$createFindHandlerByTrigger(editorViewRef),
            insert: $25719cba1a38ad64$var$createInsertTypeAheadItem(editorViewRef),
            close: $25719cba1a38ad64$var$createCloseTypeAhead(editorViewRef),
            updateSectionTitle: $25719cba1a38ad64$var$createUpdateSectionTitle(editorViewRef)
        },
        contentComponent ({ editorView: editorView, containerElement: containerElement, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, wrapperElement: wrapperElement }) {
            popupMountRef.current = {
                popupsMountPoint: popupsMountPoint || wrapperElement || undefined,
                popupsBoundariesElement: popupsBoundariesElement,
                popupsScrollableElement: popupsScrollableElement || containerElement || undefined
            };
            if (!editorView) return null;
            return /*#__PURE__*/ (0, $dc70d.jsx)((0, $1JKxC.ContentComponent), {
                editorView: editorView,
                popupMountRef: popupMountRef,
                api: api
            });
        },
        onEditorViewStateUpdated ({ originalTransaction: originalTransaction, oldEditorState: oldEditorState, newEditorState: newEditorState }) {
            const oldPluginState = (0, $479du.getPluginState)(oldEditorState);
            const newPluginState = (0, $479du.getPluginState)(newEditorState);
            if (!oldPluginState || !newPluginState) return;
            const { triggerHandler: oldTriggerHandler } = oldPluginState;
            const { triggerHandler: newTriggerHandler } = newPluginState;
            const isANewHandler = oldTriggerHandler !== newTriggerHandler;
            if (oldTriggerHandler !== null && oldTriggerHandler !== void 0 && oldTriggerHandler.dismiss && isANewHandler) {
                const typeAheadMessage = originalTransaction.getMeta((0, $1Fs6f.pluginKey));
                const wasItemInserted = typeAheadMessage && typeAheadMessage.action === 'INSERT_RAW_QUERY';
                oldTriggerHandler.dismiss({
                    editorState: newEditorState,
                    query: oldPluginState.query,
                    stats: (oldPluginState.stats || new (0, $kJH9k.StatsModifier)()).serialize(),
                    wasItemInserted: wasItemInserted
                });
            }
            if (newTriggerHandler !== null && newTriggerHandler !== void 0 && newTriggerHandler.onOpen && isANewHandler) {
                if ((0, $gdUUy.fg)('platform_editor_ease_of_use_metrics')) {
                    var _api$metrics;
                    api === null || api === void 0 || (_api$metrics = api.metrics) === null || _api$metrics === void 0 || _api$metrics.commands.handleIntentToStartEdit({
                        shouldStartTimer: false,
                        shouldPersistActiveSession: true
                    });
                }
                newTriggerHandler.onOpen(newEditorState);
            }
            const oldIsOpen = (0, $479du.isTypeAheadOpen)(oldEditorState);
            const newIsOpen = (0, $479du.isTypeAheadOpen)(newEditorState);
            if (newTriggerHandler && isANewHandler) {
                // if the typeahead opens another typeahead via the quickInsert we do NOT want to fire this analytic event (mentions and emojis) as it is already being fired from editor-plugin-analytics
                const isDuplicateInvokedEvent = newPluginState.inputMethod === (0, $g6Qq4.INPUT_METHOD).QUICK_INSERT && Object.values((0, $aaLLt.TypeAheadAvailableNodes)).includes(newTriggerHandler.id);
                if (!isDuplicateInvokedEvent) {
                    var _api$analytics;
                    api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 || (_api$analytics = _api$analytics.actions) === null || _api$analytics === void 0 || _api$analytics.fireAnalyticsEvent({
                        action: (0, $g6Qq4.ACTION).INVOKED,
                        actionSubject: (0, $g6Qq4.ACTION_SUBJECT).TYPEAHEAD,
                        actionSubjectId: newTriggerHandler.id || 'not_set',
                        attributes: {
                            inputMethod: newPluginState.inputMethod || (0, $g6Qq4.INPUT_METHOD).KEYBOARD
                        },
                        eventType: (0, $g6Qq4.EVENT_TYPE).UI
                    }, undefined, {
                        context: {
                            selection: newEditorState.selection
                        }
                    });
                }
            } else if (oldIsOpen && !newIsOpen && (0, $gdUUy.fg)('platform_editor_ease_of_use_metrics')) {
                var _api$metrics2;
                api === null || api === void 0 || api.core.actions.execute(api === null || api === void 0 || (_api$metrics2 = api.metrics) === null || _api$metrics2 === void 0 ? void 0 : _api$metrics2.commands.startActiveSessionTimer());
            }
        }
    };
};

});
parcelRegister("8nLP3", function(module, exports) {
$parcel$export(module.exports, "closeTypeAhead", () => $3113062b2f0caf7d$export$daba40574d0568e3);

var $8IP1q = parcelRequire("8IP1q");

var $1Fs6f = parcelRequire("1Fs6f");
const $3113062b2f0caf7d$export$daba40574d0568e3 = (tr)=>{
    return tr.setMeta((0, $1Fs6f.pluginKey), {
        action: (0, $8IP1q.ACTIONS).CLOSE_TYPE_AHEAD
    });
};

});
parcelRegister("8IP1q", function(module, exports) {
$parcel$export(module.exports, "ACTIONS", () => $9df38fa142cede74$export$92a1a3b7554e9387);
var $9df38fa142cede74$export$92a1a3b7554e9387 = /*#__PURE__*/ function(ACTIONS) {
    ACTIONS["OPEN_TYPEAHEAD_AT_CURSOR"] = "OPEN_TYPEAHEAD_AT_CURSOR";
    ACTIONS["CLOSE_TYPE_AHEAD"] = "CLOSE_TYPE_AHEAD";
    ACTIONS["CHANGE_QUERY"] = "CHANGE_QUERY";
    ACTIONS["INSERT_ITEM"] = "INSERT_ITEM";
    ACTIONS["INSERT_RAW_QUERY"] = "INSERT_RAW_QUERY";
    ACTIONS["UPDATE_LIST_ITEMS"] = "UPDATE_LIST_ITEMS";
    ACTIONS["UPDATE_LIST_ERROR"] = "UPDATE_LIST_ERROR";
    ACTIONS["CLEAR_LIST_ERROR"] = "CLEAR_LIST_ERROR";
    ACTIONS["UPDATE_SELECTED_INDEX"] = "UPDATE_SELECTED_INDEX";
    ACTIONS["UPDATE_SECTION_TITLE"] = "UPDATE_SECTION_TITLE";
    return ACTIONS;
}({});

});

parcelRegister("1Fs6f", function(module, exports) {
$parcel$export(module.exports, "pluginKey", () => $95f3cf51d7c1c3c9$export$18d4026d1ea86bb1);

var $cw0wu = parcelRequire("cw0wu");
const $95f3cf51d7c1c3c9$export$18d4026d1ea86bb1 = new (0, $cw0wu.PluginKey)('typeAheadPlugin');

});


parcelRegister("7EziY", function(module, exports) {
$parcel$export(module.exports, "insertTypeAheadItem", () => $68499dd83b9dc119$export$173ade35125a6637);
$parcel$export(module.exports, "performTypeAheadSelection", () => $68499dd83b9dc119$export$cf9e900b30aef2ea);

var $5sUZ8 = parcelRequire("5sUZ8");

var $aaLLt = parcelRequire("aaLLt");

var $kW8qW = parcelRequire("kW8qW");

var $kQkyj = parcelRequire("kQkyj");

var $8IP1q = parcelRequire("8IP1q");

var $1Fs6f = parcelRequire("1Fs6f");

var $kJH9k = parcelRequire("kJH9k");

var $479du = parcelRequire("479du");

var $8nLP3 = parcelRequire("8nLP3");

var $8nXVe = parcelRequire("8nXVe");
const $68499dd83b9dc119$var$validateNode = ({ schema: schema, maybeNode: maybeNode })=>{
    if (!maybeNode) return null;
    if (maybeNode instanceof (0, $kW8qW.Node) || maybeNode instanceof (0, $kW8qW.Fragment)) return maybeNode;
    if (typeof maybeNode === 'string') return schema.text(maybeNode);
    try {
        return (0, $kW8qW.Node).fromJSON(schema, maybeNode);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        return null;
    }
};
const $68499dd83b9dc119$var$createInsertCallback = ({ editorState: state, handler: handler, query: query, wasInsertedBySpace: wasInsertedBySpace, selectedIndex: selectedIndex, textStartPosition: textStartPosition, textInserted: textInserted })=>(maybeNode, opts = {})=>{
        const { tr: tr } = state;
        const position = {
            start: textStartPosition,
            end: textStartPosition + (wasInsertedBySpace ? textInserted.length : 0)
        };
        const node = $68499dd83b9dc119$var$validateNode({
            schema: state.schema,
            maybeNode: maybeNode
        });
        if (!node) {
            (0, $8nLP3.closeTypeAhead)(tr);
            // In this kind of situation we need to
            // delete the raw text query
            tr.delete(position.start, position.end);
            return tr;
        }
        node instanceof (0, $kW8qW.Node) && node.isBlock ? (0, $8nXVe.insertBlockNode)({
            node: node,
            tr: tr,
            position: position
        }) : (0, $8nXVe.insertInlineNodeOrFragment)({
            maybeFragment: node,
            tr: tr,
            position: position,
            selectInlineNode: Boolean(opts.selectInlineNode)
        });
        (0, $kQkyj.closeHistory)(tr);
        if (wasInsertedBySpace) return tr;
        const config = {
            stage: (0, $5sUZ8.InsertTypeAheadStages).INSERTING_ITEM,
            query: query,
            selectedIndex: selectedIndex,
            trigger: handler.trigger
        };
        tr.step(new (0, $5sUZ8.InsertTypeAheadStep)(config));
        return tr;
    };
const $68499dd83b9dc119$var$createDeleteRawTextCallback = ({ trigger: trigger, selectedIndex: selectedIndex, position: position, query: query, wasInsertedBySpace: wasInsertedBySpace, insertItem: insertItem })=>{
    return (newState)=>{
        const tr = newState.tr;
        (0, $kQkyj.closeHistory)(tr);
        if (!wasInsertedBySpace) {
            tr.delete(position.start, position.end);
            const config = {
                stage: (0, $5sUZ8.InsertTypeAheadStages).DELETING_RAW_QUERY,
                selectedIndex: selectedIndex,
                query: query,
                trigger: trigger
            };
            tr.step(new (0, $5sUZ8.InsertTypeAheadStep)(config));
        }
        tr.setMeta((0, $1Fs6f.pluginKey), {
            action: (0, $8IP1q.ACTIONS).INSERT_ITEM,
            params: insertItem
        });
        return tr;
    };
};
const $68499dd83b9dc119$export$173ade35125a6637 = (view)=>({ item: item, handler: handler, mode: mode, query: query, sourceListItem: sourceListItem })=>{
        const pluginState = (0, $479du.getPluginState)(view.state);
        if (!pluginState) return;
        const stats = (pluginState.stats || new (0, $kJH9k.StatsModifier)()).serialize();
        const meta = {
            mode: mode,
            query: query,
            stats: stats,
            sourceListItem: sourceListItem
        };
        const { tr: tr } = view.state;
        const trigger = handler.trigger;
        let text = `${trigger}${query}`;
        if (mode === (0, $aaLLt.SelectItemMode).SPACE) text = text.trim().concat(' ');
        // We want to always persist selectedIndex as -1 upon selecting an item from typeahead
        // in order to retain exist focus behaviour when undoing
        const selectedIndex = -1;
        const wasInsertedBySpace = mode === (0, $aaLLt.SelectItemMode).SPACE;
        const { selection: { from: textStartPosition } } = tr;
        const insertItem = (newEditorSate)=>{
            const insertCallback = $68499dd83b9dc119$var$createInsertCallback({
                editorState: newEditorSate,
                query: query,
                mode: mode,
                handler: handler,
                wasInsertedBySpace: wasInsertedBySpace,
                selectedIndex: selectedIndex,
                textInserted: text,
                textStartPosition: textStartPosition
            });
            let wasInsertCallbackCalled = false;
            // Some wierd plugins doesn't call the insert item callback
            // For example, the link quick insert item
            // For those cases we need to make sure we are closing the typeahead
            const proxyHandler = {
                apply: function(target, _thisContext, argumentsList) {
                    wasInsertCallbackCalled = true;
                    return target(...argumentsList);
                }
            };
            const insertCallbackProxy = new Proxy(insertCallback, proxyHandler);
            const nextTr = handler.selectItem(newEditorSate, item, insertCallbackProxy, meta);
            if (!wasInsertCallbackCalled && nextTr) {
                (0, $kQkyj.closeHistory)(nextTr);
                // In some cases we need to re-open the typeahead
                // e.g.: addign mentions from the quick insert
                //
                // Today, the QuickInsert API doesn't have a tool
                // to help on this. So the code below will close the typeahead
                // only if there is no previous metadata about typeahead in the
                // next transaction
                if (!nextTr.getMeta((0, $1Fs6f.pluginKey))) (0, $8nLP3.closeTypeAhead)(nextTr);
            }
            return nextTr;
        };
        const position = {
            start: tr.selection.from,
            end: tr.selection.from + text.length
        };
        tr.setMeta((0, $1Fs6f.pluginKey), {
            action: (0, $8IP1q.ACTIONS).INSERT_RAW_QUERY,
            params: $68499dd83b9dc119$var$createDeleteRawTextCallback({
                wasInsertedBySpace: wasInsertedBySpace,
                selectedIndex: selectedIndex,
                insertItem: insertItem,
                position: position,
                query: query,
                trigger: trigger
            })
        });
        tr.insertText(text);
        (0, $kQkyj.closeHistory)(tr);
        view.dispatch(tr);
        view.focus();
    };
const $68499dd83b9dc119$var$executeTypeAheadSelection = (view)=>({ selectItem: selectItem, handler: handler, mode: mode, query: query, sourceListItem: sourceListItem })=>{
        const pluginState = (0, $479du.getPluginState)(view.state);
        if (!pluginState) return;
        const stats = (pluginState.stats || new (0, $kJH9k.StatsModifier)()).serialize();
        const meta = {
            mode: mode,
            query: query,
            stats: stats,
            sourceListItem: sourceListItem
        };
        const { tr: tr } = view.state;
        const trigger = handler.trigger;
        let text = `${trigger}${query}`;
        if (mode === (0, $aaLLt.SelectItemMode).SPACE) text = text.trim().concat(' ');
        const selectedIndex = -1;
        const wasInsertedBySpace = mode === (0, $aaLLt.SelectItemMode).SPACE;
        const { selection: { from: textStartPosition } } = tr;
        const insertItem = (newEditorState)=>{
            const insertCallback = $68499dd83b9dc119$var$createInsertCallback({
                editorState: newEditorState,
                query: query,
                mode: mode,
                handler: handler,
                wasInsertedBySpace: wasInsertedBySpace,
                selectedIndex: selectedIndex,
                textInserted: text,
                textStartPosition: textStartPosition
            });
            let wasInsertCallbackCalled = false;
            const insertCallbackProxy = new Proxy(insertCallback, {
                apply (target, _thisContext, argumentsList) {
                    wasInsertCallbackCalled = true;
                    return target(...argumentsList);
                }
            });
            const nextTr = selectItem(newEditorState, insertCallbackProxy, meta);
            if (!wasInsertCallbackCalled && nextTr) {
                (0, $kQkyj.closeHistory)(nextTr);
                if (!nextTr.getMeta((0, $1Fs6f.pluginKey))) (0, $8nLP3.closeTypeAhead)(nextTr);
            }
            return nextTr || false;
        };
        const position = {
            start: tr.selection.from,
            end: tr.selection.from + text.length
        };
        tr.setMeta((0, $1Fs6f.pluginKey), {
            action: (0, $8IP1q.ACTIONS).INSERT_RAW_QUERY,
            params: $68499dd83b9dc119$var$createDeleteRawTextCallback({
                wasInsertedBySpace: wasInsertedBySpace,
                selectedIndex: selectedIndex,
                insertItem: insertItem,
                position: position,
                query: query,
                trigger: trigger
            })
        });
        tr.insertText(text);
        (0, $kQkyj.closeHistory)(tr);
        view.dispatch(tr);
        view.focus();
    };
const $68499dd83b9dc119$export$cf9e900b30aef2ea = (view)=>({ inputMethod: inputMethod, selectionHandler: selectionHandler, handler: handler, query: query })=>{
        $68499dd83b9dc119$var$executeTypeAheadSelection(view)({
            handler: handler,
            mode: (0, $aaLLt.SelectItemMode).SELECTED,
            query: query,
            sourceListItem: [],
            selectItem: (_state, insert)=>selectionHandler({
                    insert: insert,
                    source: inputMethod
                })
        });
    };

});
parcelRegister("kJH9k", function(module, exports) {
$parcel$export(module.exports, "StatsModifier", () => $057d8425e3368fe2$export$630efe5940bb4d41);
class $057d8425e3368fe2$export$630efe5940bb4d41 {
    constructor(){
        this.startedAt = 0;
        this.endedAt = 0;
        this.keyCount = {
            arrowUp: 0,
            arrowDown: 0
        };
        this.increaseArrowUp = ()=>{
            this.keyCount.arrowUp += 1;
        };
        this.increaseArrowDown = ()=>{
            this.keyCount.arrowDown += 1;
        };
        this.serialize = ()=>{
            var _this$keyCount, _this$keyCount2;
            return {
                startedAt: this.startedAt,
                endedAt: performance.now(),
                keyCount: {
                    arrowUp: ((_this$keyCount = this.keyCount) === null || _this$keyCount === void 0 ? void 0 : _this$keyCount.arrowUp) || 0,
                    arrowDown: ((_this$keyCount2 = this.keyCount) === null || _this$keyCount2 === void 0 ? void 0 : _this$keyCount2.arrowDown) || 0
                }
            };
        };
        this.startedAt = performance.now();
        this.keyCount = {
            arrowUp: 0,
            arrowDown: 0
        };
    }
}

});

parcelRegister("479du", function(module, exports) {
$parcel$export(module.exports, "isTypeAheadHandler", () => $c5f7eb8bdcdcc7cc$export$be092076596418f1);
$parcel$export(module.exports, "isTypeAheadOpen", () => $c5f7eb8bdcdcc7cc$export$564dcc295d6ce147);
$parcel$export(module.exports, "getPluginState", () => $c5f7eb8bdcdcc7cc$export$f05434c51e3762e);
$parcel$export(module.exports, "getTypeAheadHandler", () => $c5f7eb8bdcdcc7cc$export$c1eba975d6442029);
$parcel$export(module.exports, "getTypeAheadQuery", () => $c5f7eb8bdcdcc7cc$export$7a55deb43cd1340e);
$parcel$export(module.exports, "isTypeAheadAllowed", () => $c5f7eb8bdcdcc7cc$export$74b0f581633f8412);
$parcel$export(module.exports, "findHandler", () => $c5f7eb8bdcdcc7cc$export$2bae95e359577df4);
$parcel$export(module.exports, "skipForwardToSafeItem", () => $c5f7eb8bdcdcc7cc$export$84a03e6192df0237);
$parcel$export(module.exports, "moveSelectedIndex", () => $c5f7eb8bdcdcc7cc$export$f985e98ceae7c8f6);
$parcel$export(module.exports, "getTypeAheadListAriaLabels", () => $c5f7eb8bdcdcc7cc$export$19cacaa810ba988a);

var $6ny6f = parcelRequire("6ny6f");

var $aaLLt = parcelRequire("aaLLt");

var $ex2cJ = parcelRequire("ex2cJ");

var $eBfRL = parcelRequire("eBfRL");

var $gdUUy = parcelRequire("gdUUy");

var $797yE = parcelRequire("797yE");

var $fq4QS = parcelRequire("fq4QS");

var $5aZT5 = parcelRequire("5aZT5");

var $1Fs6f = parcelRequire("1Fs6f");

var $kJH9k = parcelRequire("kJH9k");
const $c5f7eb8bdcdcc7cc$export$be092076596418f1 = (handler)=>{
    return handler && Object.values((0, $aaLLt.TypeAheadAvailableNodes)).includes(handler.id) && typeof handler.trigger === 'string' && typeof handler.selectItem === 'function' && typeof handler.getItems === 'function';
};
const $c5f7eb8bdcdcc7cc$export$564dcc295d6ce147 = (editorState)=>{
    var _typeAheadPluginKey$g;
    return !!((0, $1Fs6f.pluginKey) !== null && (0, $1Fs6f.pluginKey) !== void 0 && (_typeAheadPluginKey$g = (0, $1Fs6f.pluginKey).getState(editorState)) !== null && _typeAheadPluginKey$g !== void 0 && (_typeAheadPluginKey$g = _typeAheadPluginKey$g.decorationSet) !== null && _typeAheadPluginKey$g !== void 0 && _typeAheadPluginKey$g.find().length);
};
const $c5f7eb8bdcdcc7cc$export$f05434c51e3762e = (editorState)=>{
    return (0, $1Fs6f.pluginKey).getState(editorState);
};
const $c5f7eb8bdcdcc7cc$export$c1eba975d6442029 = (editorState)=>{
    var _typeAheadPluginKey$g2;
    return (_typeAheadPluginKey$g2 = (0, $1Fs6f.pluginKey).getState(editorState)) === null || _typeAheadPluginKey$g2 === void 0 ? void 0 : _typeAheadPluginKey$g2.triggerHandler;
};
const $c5f7eb8bdcdcc7cc$export$7a55deb43cd1340e = (editorState)=>{
    var _typeAheadPluginKey$g3;
    return (_typeAheadPluginKey$g3 = (0, $1Fs6f.pluginKey).getState(editorState)) === null || _typeAheadPluginKey$g3 === void 0 ? void 0 : _typeAheadPluginKey$g3.query;
};
const $c5f7eb8bdcdcc7cc$export$74b0f581633f8412 = (state)=>{
    const isOpen = $c5f7eb8bdcdcc7cc$export$564dcc295d6ce147(state);
    // if the TypeAhead is open
    // we should not allow it
    return !isOpen;
};
const $c5f7eb8bdcdcc7cc$export$2bae95e359577df4 = (id, state)=>{
    const pluginState = (0, $1Fs6f.pluginKey).getState(state);
    if (!pluginState || !pluginState.typeAheadHandlers || pluginState.typeAheadHandlers.length === 0) return null;
    const { typeAheadHandlers: typeAheadHandlers } = pluginState;
    return typeAheadHandlers.find((h)=>h.id === id) || null;
};
const $c5f7eb8bdcdcc7cc$export$84a03e6192df0237 = ({ currentIndex: currentIndex, nextIndex: nextIndex, listSize: listSize, itemIsDisabled: itemIsDisabled })=>{
    // Use a loop to find the next selectable item
    for(let idx = nextIndex; idx < listSize; idx++){
        if (!itemIsDisabled(idx)) return idx;
    }
    // We got to the end of the list ^, now try from the start
    for(let idx = 0; idx < nextIndex; idx++){
        if (!itemIsDisabled(idx)) return idx;
    }
    // If no selectable items are found, return currentIndex
    return currentIndex;
};
const $c5f7eb8bdcdcc7cc$export$723aff40bcdce278 = ({ currentIndex: currentIndex, nextIndex: nextIndex, listSize: listSize, itemIsDisabled: itemIsDisabled })=>{
    // Use a loop to find the next non-selectable item when going backwards
    for(let idx = nextIndex; idx >= 0; idx--){
        if (!itemIsDisabled(idx)) return idx;
    }
    // We got to the start of the list ^, now try from the end
    for(let idx = listSize; idx > nextIndex; idx--){
        if (!itemIsDisabled(idx)) return idx;
    }
    // If no non-selectable items are found, return currentIndex
    return currentIndex;
};
const $c5f7eb8bdcdcc7cc$export$89c7a133a9db5167 = ({ trigger: trigger, editorState: editorState })=>{
    const pluginState = (0, $1Fs6f.pluginKey).getState(editorState);
    if (!pluginState || !pluginState.typeAheadHandlers || pluginState.typeAheadHandlers.length === 0) return null;
    const { typeAheadHandlers: typeAheadHandlers } = pluginState;
    return typeAheadHandlers.find((h)=>h.trigger === trigger) || null;
};
const $c5f7eb8bdcdcc7cc$export$f985e98ceae7c8f6 = ({ editorView: editorView, direction: direction, api: api })=>()=>{
        const typeAheadState = $c5f7eb8bdcdcc7cc$export$f05434c51e3762e(editorView.state);
        if (!typeAheadState) return;
        const { selectedIndex: selectedIndex, items: items } = typeAheadState;
        const stats = typeAheadState.stats instanceof (0, $kJH9k.StatsModifier) ? typeAheadState.stats : new (0, $kJH9k.StatsModifier)();
        let nextIndex;
        const isDisabled = (idx)=>(0, $5aZT5.itemIsDisabled)(items[idx], api);
        if (direction === 'next') {
            stats.increaseArrowDown();
            /**
     * See: https://product-fabric.atlassian.net/browse/ED-17200
     * `selectedIndex` is forced to -1 now to not immediately focus the typeahead
     * and only do so when there is explicit logic to focus into the typeahead
     * options.
     *
     * This check for "set index to 1 when -1"
     * - is a temporary workaround to get back the previous behaviour without
     *    entirely reverting the a11y improvements
     *
     */ if (selectedIndex === -1 && items.length > 1) // If the first item is disabled we actually want to skip to the 3rd item
            // on the first arrow down
            nextIndex = isDisabled(0) && items.length > 2 ? 2 : 1;
            else nextIndex = selectedIndex >= items.length - 1 ? 0 : selectedIndex + 1;
            nextIndex = $c5f7eb8bdcdcc7cc$export$84a03e6192df0237({
                currentIndex: selectedIndex,
                nextIndex: nextIndex,
                listSize: items.length,
                itemIsDisabled: isDisabled
            });
        } else {
            stats.increaseArrowUp();
            nextIndex = selectedIndex <= 0 ? items.length - 1 : selectedIndex - 1;
            nextIndex = $c5f7eb8bdcdcc7cc$export$723aff40bcdce278({
                currentIndex: selectedIndex,
                nextIndex: nextIndex,
                listSize: items.length,
                itemIsDisabled: isDisabled
            });
        }
        (0, $fq4QS.updateSelectedIndex)(nextIndex, api)(editorView.state, editorView.dispatch);
    };
const $c5f7eb8bdcdcc7cc$var$isAgentMentionLoadError = (mention)=>(mention === null || mention === void 0 ? void 0 : mention.id) === (0, $eBfRL.AGENT_MENTION_LOAD_ERROR_ID) && mention.isPlaceholder === true && mention.placeholderType === 'error' && mention.appType === 'agent';
const $c5f7eb8bdcdcc7cc$export$19cacaa810ba988a = (trigger, intl, item)=>{
    var _item$emoji, _item$emoji2, _item$emoji3;
    switch(trigger){
        case '@':
            {
                var _item$mention, _item$mention2, _item$mention3;
                const description = (0, $797yE.editorExperiment)('platform_editor_agent_mentions', true) && (0, $gdUUy.fg)('platform_editor_mention_typeahead_profilecard') ? item === null || item === void 0 || (_item$mention = item.mention) === null || _item$mention === void 0 ? void 0 : _item$mention.description : undefined;
                const name = (item === null || item === void 0 || (_item$mention2 = item.mention) === null || _item$mention2 === void 0 ? void 0 : _item$mention2.name) || '';
                const shortName = (item === null || item === void 0 || (_item$mention3 = item.mention) === null || _item$mention3 === void 0 ? void 0 : _item$mention3.mentionName) || '';
                return {
                    popupAriaLabel: intl.formatMessage((0, $ex2cJ.typeAheadListMessages).mentionPopupLabel),
                    listItemAriaLabel: $c5f7eb8bdcdcc7cc$var$isAgentMentionLoadError(item === null || item === void 0 ? void 0 : item.mention) ? `${intl.formatMessage((0, $6ny6f.mentionMessages).typeAheadSectionAgentsLoadError)}. ${intl.formatMessage((0, $6ny6f.mentionMessages).typeAheadSectionAgentsRetry)}` : description ? intl.formatMessage((0, $ex2cJ.typeAheadListMessages).mentionListItemLabelWithDescription, {
                        name: name,
                        shortName: shortName,
                        description: description
                    }) : intl.formatMessage((0, $ex2cJ.typeAheadListMessages).metionListItemLabel, {
                        name: name,
                        shortName: shortName
                    })
                };
            }
        case '/':
            return {
                popupAriaLabel: intl.formatMessage((0, $ex2cJ.typeAheadListMessages).quickInsertPopupLabel),
                listItemAriaLabel: intl.formatMessage((0, $ex2cJ.typeAheadListMessages).emojiListItemLabel, {
                    name: (item === null || item === void 0 ? void 0 : item.title) || '',
                    shortcut: (item === null || item === void 0 || (_item$emoji = item.emoji) === null || _item$emoji === void 0 ? void 0 : _item$emoji.shortName) || ''
                })
            };
        case ':':
            return {
                popupAriaLabel: intl.formatMessage((0, $ex2cJ.typeAheadListMessages).emojiPopupLabel),
                listItemAriaLabel: intl.formatMessage((0, $ex2cJ.typeAheadListMessages).emojiListItemLabel, {
                    name: (item === null || item === void 0 || (_item$emoji2 = item.emoji) === null || _item$emoji2 === void 0 ? void 0 : _item$emoji2.name) || '',
                    shortcut: (item === null || item === void 0 || (_item$emoji3 = item.emoji) === null || _item$emoji3 === void 0 ? void 0 : _item$emoji3.shortName) || ''
                })
            };
        default:
            return {
                popupAriaLabel: intl.formatMessage((0, $ex2cJ.typeAheadListMessages).typeAheadPopupLabel)
            };
    }
};

});
parcelRegister("ex2cJ", function(module, exports) {
$parcel$export(module.exports, "typeAheadListMessages", () => $055f462adcffab37$export$940a17143b866527);

var $f0Pt4 = parcelRequire("f0Pt4");
const $055f462adcffab37$export$940a17143b866527 = (0, $f0Pt4.defineMessages)({
    typeAheadPopupLabel: {
        id: 'fabric.editor.typeAhead.popupLabel',
        defaultMessage: 'Typeahead results',
        description: 'ARIA label for the typeahead/autocomplete results popup. Announced to screen reader users when search or filter results appear.'
    },
    quickInsertPopupLabel: {
        id: 'fabric.editor.typeAhead.quickInsertPopupLabel',
        defaultMessage: 'Shortcuts for inserts and formatting',
        description: 'ARIA label for the quick insert typeahead popup showing available shortcuts. Announced to screen readers when the popup appears.'
    },
    quickInsertInputLabel: {
        id: 'fabric.editor.typeAhead.quickInsertInputLabel',
        defaultMessage: 'Begin typing to search or filter shortcut options',
        description: 'ARIA label for the quick insert typeahead input field, read by screen readers to inform users they can type to search or filter available editor shortcuts.'
    },
    quickInsertInputPlaceholderLabel: {
        id: 'fabric.editor.typeAhead.quickInsertInputPlaceholderLabel',
        defaultMessage: 'Search',
        description: 'Placeholder text displayed inside the quick insert typeahead input field when it is empty, prompting users to type a search term.'
    },
    emojiPopupLabel: {
        id: 'fabric.editor.typeahead.emojiPopupLabel',
        defaultMessage: 'Emoji shortcuts',
        description: 'the result of a emoji typeahead, similar to autocomplete results+'
    },
    emojiInputLabel: {
        id: 'fabric.editor.typeahead.emojiInputLabel',
        defaultMessage: 'Begin typing to search or filter emoji options',
        description: 'ARIA label for the emoji typeahead input field, read by screen readers to inform users they can type to search or filter available emoji options.'
    },
    mentionPopupLabel: {
        id: 'fabric.editor.typeahead.mentionPopupLabel',
        defaultMessage: 'Users you can tag',
        description: 'the aria label of a mention typeahead popup'
    },
    mentionInputLabel: {
        id: 'fabric.editor.typeahead.mentionInputLabel',
        defaultMessage: 'Begin typing to search for users to tag',
        description: 'ARIA label for the mention typeahead input field, read by screen readers to inform users they can type to search for people to tag in the document.'
    },
    metionListItemLabel: {
        id: 'fabric.editor.typeahead.metionListItemLabel',
        defaultMessage: 'User {name} @{shortName}',
        description: 'assistive text for user mention items username and nickname'
    },
    mentionListItemLabelWithDescription: {
        id: 'fabric.editor.typeahead.mentionListItemLabelWithDescription',
        defaultMessage: 'User {name} @{shortName}. {description}',
        description: 'assistive text for a mention item that also has a description (such as agent description)'
    },
    emojiListItemLabel: {
        id: 'fabric.editor.typeahead.emojiListItemLabel',
        defaultMessage: 'Emoji {name} Text Shortcut {shortcut}',
        description: 'assistive text for emoji name and shortcut'
    },
    inputQueryAssistiveLabel: {
        id: 'fabric.editor.inputQueryAssistiveTxt',
        defaultMessage: 'When autocomplete results are available use up and down arrows to review and enter to select. Touch device users, explore by touch or with swipe gestures.',
        description: 'Assistive text to the user when using typeahead shortcut'
    },
    searchResultsLabel: {
        id: 'fabric.editor.searchResults',
        defaultMessage: '{itemsLength, plural, one {# search result} other {# search results}} available. Use Up and Down arrow keys to navigate amongst the options. Press Enter to select an option.',
        description: 'Assistive text to the user when using typeahead shortcut and it preceeds with a number - Ex: 10 search results available'
    },
    noSearchResultsLabel: {
        id: 'fabric.editor.noSearchResults',
        defaultMessage: 'No search results',
        description: 'Assistive text to the user when using typeahead shortcut'
    },
    descriptionLabel: {
        id: 'fabric.editor.description',
        defaultMessage: 'Description',
        description: 'Label used as assistive text for the description of an item in the typeahead autocomplete dropdown list.'
    },
    shortcutLabel: {
        id: 'fabric.editor.shortcut',
        defaultMessage: 'Text shortcut',
        description: 'Label used as assistive text before a keyboard shortcut in the typeahead autocomplete dropdown list items.'
    },
    typeAheadErrorFallbackHeading: {
        id: 'fabric.editor.typeAheadErrorFallbackHeading',
        defaultMessage: 'Something went wrong',
        description: 'Error message heading shown when typeahead items fail to load'
    },
    typeAheadErrorFallbackDesc: {
        id: 'fabric.editor.typeAheadErrorFallbackDescription',
        defaultMessage: 'No results available. Try again.',
        description: 'Error message description shown when typeahead items fail to load'
    },
    viewAllInserts: {
        id: 'fablric.editor.viewAllInserts',
        defaultMessage: 'View all inserts',
        description: 'a text on a button that opens a side panel with a list of all insertable editor elements'
    },
    emptySearchResults: {
        id: 'fabric.editor.emptySearchResults',
        defaultMessage: "We couldn't find any results.",
        description: 'a message displayed when there are no search results'
    },
    emptySearchResultsSuggestion: {
        id: 'fabric.editor.emptySearchResultsSuggestion',
        defaultMessage: 'Select {buttonName} to browse inserts.',
        description: 'a prompt to suggest user to click a button to browse inserts when there are no search results'
    }
});

});

parcelRegister("fq4QS", function(module, exports) {
$parcel$export(module.exports, "updateSelectedIndex", () => $f19c10fc2bdd6a96$export$9993709486a96a6b);

var $8IP1q = parcelRequire("8IP1q");

var $5aZT5 = parcelRequire("5aZT5");

var $1Fs6f = parcelRequire("1Fs6f");
const $f19c10fc2bdd6a96$export$9993709486a96a6b = (selectedIndex, api)=>{
    return (state, dispatch)=>{
        const pluginState = (0, $1Fs6f.pluginKey).getState(state);
        if ((pluginState === null || pluginState === void 0 ? void 0 : pluginState.selectedIndex) === selectedIndex) return false;
        // If the new index is disabled ignore this call, we can use the previous index
        if ((0, $5aZT5.itemIsDisabled)(pluginState === null || pluginState === void 0 ? void 0 : pluginState.items[selectedIndex], api)) return false;
        const tr = state.tr;
        tr.setMeta((0, $1Fs6f.pluginKey), {
            action: (0, $8IP1q.ACTIONS).UPDATE_SELECTED_INDEX,
            params: {
                selectedIndex: selectedIndex
            }
        });
        if (dispatch) dispatch(tr);
        return true;
    };
};

});
parcelRegister("5aZT5", function(module, exports) {
$parcel$export(module.exports, "itemIsDisabled", () => $13751f3b1068b869$export$1ebf03cc1b973f80);

var $hVGJk = parcelRequire("hVGJk");
const $13751f3b1068b869$export$1ebf03cc1b973f80 = (item, api)=>{
    var _api$connectivity;
    const isOffline = (0, $hVGJk.isOfflineMode)(api === null || api === void 0 || (_api$connectivity = api.connectivity) === null || _api$connectivity === void 0 || (_api$connectivity = _api$connectivity.sharedState.currentState()) === null || _api$connectivity === void 0 ? void 0 : _api$connectivity.mode);
    return (item === null || item === void 0 ? void 0 : item.isNonInteractive) === true || isOffline && (item === null || item === void 0 ? void 0 : item.isDisabledOffline) === true;
};

});



parcelRegister("8nXVe", function(module, exports) {
$parcel$export(module.exports, "insertBlockNode", () => $c5ae7baa657eac58$export$faec73a52dd47a2c);
$parcel$export(module.exports, "insertInlineNodeOrFragment", () => $c5ae7baa657eac58$export$a6d430434014dc1c);

var $dw0oh = parcelRequire("dw0oh");

var $9MlgY = parcelRequire("9MlgY");

var $01Z6w = parcelRequire("01Z6w");

var $kW8qW = parcelRequire("kW8qW");

var $cw0wu = parcelRequire("cw0wu");

var $5N1Y4 = parcelRequire("5N1Y4");
function $c5ae7baa657eac58$var$findInsertPoint(doc, pos, nodeToInsert) {
    const $pos = doc.resolve(pos);
    const createInsertPosition = (from, to)=>({
            from: from,
            to: to || from
        });
    // Search for a valid position for nodeToInsert in progressively higher levels
    for(let level = $pos.depth; level >= 0; level--){
        const nodeAtLevel = $pos.node(level);
        // Try to replace the empty paragraph in the level above
        // Scenario:
        //   doc(
        //     table(
        //       row(
        //         cell(
        //           p('{<>}'),
        //         ),
        //       )
        //     )
        //   )
        const levelAbove = Math.max(level - 1, 0);
        const parentNode = $pos.node(levelAbove);
        // Special case: when this is true, the 'to' position should be the end
        // of the empty paragraph
        const isNodeAtLevelEmptyParagraph = nodeAtLevel.type.name === 'paragraph' && nodeAtLevel.content.size === 0;
        const indexAtLevelAbove = $pos.index(levelAbove);
        const canReplaceNodeAtLevelAbove = parentNode.canReplaceWith(indexAtLevelAbove, indexAtLevelAbove, nodeToInsert.type);
        if (isNodeAtLevelEmptyParagraph && canReplaceNodeAtLevelAbove) {
            const from = $pos.posAtIndex(indexAtLevelAbove, levelAbove);
            return createInsertPosition(from, from + nodeAtLevel.nodeSize);
        }
        // Try to insert this node right after the node in the level above
        // Scenario:
        //   doc(
        //     panel(
        //       p('{<>}'),
        //     )
        //   )
        const indexAfterAtLevelAbove = $pos.indexAfter(levelAbove);
        const canInsertNodeAtLevelAbove = parentNode.canReplaceWith(indexAfterAtLevelAbove, indexAfterAtLevelAbove, nodeToInsert.type);
        if (canInsertNodeAtLevelAbove) return createInsertPosition($pos.posAtIndex(indexAfterAtLevelAbove, levelAbove));
    }
    return createInsertPosition(0);
}
const $c5ae7baa657eac58$export$faec73a52dd47a2c = ({ node: node, tr: tr, position: position })=>{
    const { start: start, end: end } = position;
    if (node.isText) return tr.replaceWith(start, end, node);
    if (node.isBlock) {
        var _tr$selection$$from$n, _tr$selection$$from$n2;
        tr.delete(start, end);
        const mappedStart = tr.mapping.map(start);
        const nodeNormalized = (0, $dw0oh.normaliseNestedLayout)(tr, node);
        const { listItem: listItem } = tr.doc.type.schema.nodes;
        // Handle edge cases if it's in a list or that it's inserting a node in the same node type
        /* e.g.
     * panel (
     *   1. text (insertion)
     * )
     * at insertion, text is parent (0), listItem is grandParent (-1), list is greatGrandparent (-2), panel is ggreatGrandParent (-3)
     */ const grandParentNodeType = (_tr$selection$$from$n = tr.selection.$from.node(-1)) === null || _tr$selection$$from$n === void 0 ? void 0 : _tr$selection$$from$n.type;
        const ggreatGrandParentNodeType = (_tr$selection$$from$n2 = tr.selection.$from.node(-3)) === null || _tr$selection$$from$n2 === void 0 ? void 0 : _tr$selection$$from$n2.type;
        const isGGreatGrandParentOfSameType = (0, $5N1Y4.expValEquals)('platform_editor_nest_table_in_panel', 'isEnabled', true) ? ggreatGrandParentNodeType && (0, $01Z6w.isNodeOfSameBaseType)(ggreatGrandParentNodeType, node.type) : ggreatGrandParentNodeType === node.type;
        if (grandParentNodeType === listItem && !isGGreatGrandParentOfSameType) return (0, $9MlgY.transformNodeIntoListItem)(tr, nodeNormalized);
        // Handle edge cases for hr and mediaSingle
        const inserted = (0, $dw0oh.safeInsert)(nodeNormalized, mappedStart)(tr);
        if (inserted) return tr;
        const sliceInserted = (0, $kW8qW.Slice).maxOpen((0, $kW8qW.Fragment).from(nodeNormalized));
        const { from: from, to: to } = $c5ae7baa657eac58$var$findInsertPoint(tr.doc, mappedStart, nodeNormalized);
        tr.replaceWith(from, to, node);
        const openPosition = Math.min(from + (node.isAtom ? node.nodeSize : sliceInserted.openStart), tr.doc.content.size);
        const FORWARD_DIRECTION = 1;
        const nextSelection = (0, $cw0wu.TextSelection).findFrom(tr.doc.resolve(openPosition), FORWARD_DIRECTION, true);
        if (nextSelection) return tr.setSelection(nextSelection);
    }
    return tr;
};
const $c5ae7baa657eac58$export$a6d430434014dc1c = ({ maybeFragment: maybeFragment, tr: tr, position: position, selectInlineNode: selectInlineNode })=>{
    const { start: start, end: end } = position;
    const fragment = maybeFragment instanceof (0, $kW8qW.Node) ? (0, $kW8qW.Fragment).from(maybeFragment) : maybeFragment;
    tr.replaceWith(start, end, fragment);
    if (selectInlineNode) return tr.setSelection((0, $cw0wu.NodeSelection).create(tr.doc, start));
    return tr.setSelection((0, $cw0wu.TextSelection).near(tr.doc.resolve(start + fragment.size)));
};

});


parcelRegister("7GPfv", function(module, exports) {
$parcel$export(module.exports, "openTypeAheadAtCursor", () => $aa6693656a9f8f17$export$e7ce737179b76875);

var $j7pt0 = parcelRequire("j7pt0");

var $cw0wu = parcelRequire("cw0wu");

var $gdUUy = parcelRequire("gdUUy");

var $8IP1q = parcelRequire("8IP1q");

var $1Fs6f = parcelRequire("1Fs6f");
const $aa6693656a9f8f17$export$adbec20dbbf15a6b = (props)=>(tr)=>{
        const { triggerHandler: triggerHandler, inputMethod: inputMethod, query: query, removePrefixTriggerOnCancel: removePrefixTriggerOnCancel } = props;
        tr.setMeta((0, $1Fs6f.pluginKey), {
            action: (0, $8IP1q.ACTIONS).OPEN_TYPEAHEAD_AT_CURSOR,
            params: {
                triggerHandler: triggerHandler,
                inputMethod: inputMethod,
                query: query,
                removePrefixTriggerOnCancel: removePrefixTriggerOnCancel
            }
        });
    };
const $aa6693656a9f8f17$export$e7ce737179b76875 = ({ triggerHandler: triggerHandler, inputMethod: inputMethod, query: query, removePrefixTriggerOnCancel: removePrefixTriggerOnCancel })=>({ tr: tr })=>{
        var _triggerHandler$canOp;
        if (((_triggerHandler$canOp = triggerHandler.canOpen) === null || _triggerHandler$canOp === void 0 ? void 0 : _triggerHandler$canOp.call(triggerHandler)) === false && (0, $gdUUy.fg)('editor-disable-feature')) return null;
        $aa6693656a9f8f17$export$adbec20dbbf15a6b({
            triggerHandler: triggerHandler,
            inputMethod: inputMethod,
            query: query,
            removePrefixTriggerOnCancel: removePrefixTriggerOnCancel
        })(tr);
        const { selection: selection } = tr;
        const isInline = selection instanceof (0, $cw0wu.NodeSelection) && selection.node.type.isInline;
        if (!(selection instanceof (0, $cw0wu.TextSelection) || selection instanceof (0, $j7pt0.GapCursorSelection) || selection instanceof (0, $cw0wu.NodeSelection))) return tr;
        if (selection instanceof (0, $j7pt0.GapCursorSelection)) {
            // Create space for the typeahead menu in gap cursor
            tr.insertText(' ');
            // delete 1 pos before wherever selection is now - that will delete the empty space
            tr.delete(tr.selection.from - 1, tr.selection.from);
        } else {
            var _selection$$head$pare, _selection$$head$pare2, _selection$$head;
            if (selection instanceof (0, $cw0wu.NodeSelection)) {
                if (isInline) {
                    tr.deleteSelection();
                    return tr;
                }
                return tr;
            }
            if (!selection.$cursor) {
                tr.deleteSelection();
                return tr;
            }
            // Search & Destroy placeholder
            const cursorPos = selection.$cursor.pos;
            const nodeAtCursor = tr.doc.nodeAt(cursorPos);
            const isPlaceholderAtCursorPosition = nodeAtCursor && nodeAtCursor.type.name === 'placeholder';
            if (nodeAtCursor && isPlaceholderAtCursorPosition) tr.delete(cursorPos, cursorPos + nodeAtCursor.nodeSize);
            // ME-2375 remove the superfluous '@' inserted before decoration
            // by composition (https://github.com/ProseMirror/prosemirror/issues/903)
            //
            // Update:
            // Now also handles any use case with superfluous typeahead triggers (ie. '@', ':', '/')
            // being inserted due to composition by checking if we have the trigger
            // directly before the typeahead. This should not happen unless it has
            // been eroneously added because we require whitespace/newline for typeahead.
            // Check if the text ends with the trigger character (or any character matched
            // by customRegex, to support wide-char variants like fullwidth slash ／)
            const triggerPattern = triggerHandler.customRegex ? new RegExp(`(${triggerHandler.customRegex})$`, 'u') : null;
            const endsWithTrigger = ((_selection$$head$pare = (_selection$$head$pare2 = selection.$head.parent.textContent).endsWith) === null || _selection$$head$pare === void 0 ? void 0 : _selection$$head$pare.call(_selection$$head$pare2, triggerHandler.trigger)) || triggerPattern && triggerPattern.test(selection.$head.parent.textContent);
            if (cursorPos >= 2 && !!(selection !== null && selection !== void 0 && (_selection$$head = selection.$head) !== null && _selection$$head !== void 0 && (_selection$$head = _selection$$head.parent) !== null && _selection$$head !== void 0 && _selection$$head.textContent) && endsWithTrigger) tr.delete(cursorPos - 1, cursorPos);
        }
        return tr;
    };

});

parcelRegister("cQH44", function(module, exports) {
$parcel$export(module.exports, "updateSectionTitle", () => $1f3939785790b0e8$export$9edb4b0ea764e965);

var $8IP1q = parcelRequire("8IP1q");

var $1Fs6f = parcelRequire("1Fs6f");
const $1f3939785790b0e8$export$9edb4b0ea764e965 = ({ id: id, title: title, sectionTitleDisplay: sectionTitleDisplay })=>{
    return (state, dispatch)=>{
        if (!dispatch) return false;
        const tr = state.tr;
        const update = {
            title: title
        };
        if (sectionTitleDisplay !== undefined) update.sectionTitleDisplay = sectionTitleDisplay;
        tr.setMeta((0, $1Fs6f.pluginKey), {
            action: (0, $8IP1q.ACTIONS).UPDATE_SECTION_TITLE,
            params: {
                id: id,
                update: update
            }
        });
        dispatch(tr);
        return true;
    };
};

});

parcelRegister("2fG6X", function(module, exports) {
$parcel$export(module.exports, "inputRulePlugin", () => $72f70635c56d5f21$export$568a7ed6897c4817);

var $g6Qq4 = parcelRequire("g6Qq4");

var $f7Kk4 = parcelRequire("f7Kk4");

var $33v8M = parcelRequire("33v8M");

var $b9BdF = parcelRequire("b9BdF");

var $8t09p = parcelRequire("8t09p");

var $7GPfv = parcelRequire("7GPfv");
function $72f70635c56d5f21$export$568a7ed6897c4817(schema, typeAheads, featureFlags) {
    if (!typeAheads || typeAheads.length === 0) return;
    const rules = typeAheads.reduce((acc, typeAhead)=>{
        const trigger = typeAhead.customRegex || typeAhead.trigger;
        if (!trigger) return acc;
        // Ignored via go/ees005
        // eslint-disable-next-line require-unicode-regexp
        const regex = new RegExp(`(^|[.!?\\s${(0, $b9BdF.leafNodeReplacementCharacter)}])(${trigger})$`);
        acc.push((0, $33v8M.createRule)(regex, (state, match)=>{
            return (0, $7GPfv.openTypeAheadAtCursor)({
                triggerHandler: typeAhead,
                inputMethod: (0, $g6Qq4.INPUT_METHOD).KEYBOARD
            })({
                tr: state.tr
            });
        }));
        return acc;
    }, []);
    const plugin = new (0, $f7Kk4.SafePlugin)((0, $8t09p.createPlugin)('type-ahead', rules, {
        allowInsertTextOnDocument: false
    }));
    return plugin;
}
var $72f70635c56d5f21$export$2e2bcd8739ae039 = $72f70635c56d5f21$export$568a7ed6897c4817;

});

parcelRegister("g7mVf", function(module, exports) {
$parcel$export(module.exports, "createPlugin", () => $14455edb0a5ff32a$export$ae829ec7b2625219);

var $f7Kk4 = parcelRequire("f7Kk4");

var $8IP1q = parcelRequire("8IP1q");

var $3iWUu = parcelRequire("3iWUu");
function $14455edb0a5ff32a$export$ae829ec7b2625219() {
    return new (0, $f7Kk4.SafePlugin)({
        appendTransaction (transactions, _oldState, newState) {
            const insertItemCallback = (0, $3iWUu.isInsertionTransaction)(transactions, (0, $8IP1q.ACTIONS).INSERT_ITEM);
            if (insertItemCallback) {
                const tr = insertItemCallback(newState);
                if (tr) return tr;
            }
        }
    });
}

});
parcelRegister("3iWUu", function(module, exports) {
$parcel$export(module.exports, "isInsertionTransaction", () => $04aaafd45da1dd14$export$e715282b081c154e);

var $1Fs6f = parcelRequire("1Fs6f");
const $04aaafd45da1dd14$export$e715282b081c154e = (transactions, action)=>{
    var _tr$getMeta2;
    const tr = transactions.find((tr)=>{
        var _tr$getMeta;
        return ((_tr$getMeta = tr.getMeta((0, $1Fs6f.pluginKey))) === null || _tr$getMeta === void 0 ? void 0 : _tr$getMeta.action) === action;
    });
    if (!tr) return null;
    return (_tr$getMeta2 = tr.getMeta((0, $1Fs6f.pluginKey))) === null || _tr$getMeta2 === void 0 ? void 0 : _tr$getMeta2.params;
};

});


parcelRegister("fHRcq", function(module, exports) {
$parcel$export(module.exports, "createPlugin", () => $1667cbef19c43499$export$ae829ec7b2625219);

var $5sUZ8 = parcelRequire("5sUZ8");

var $g6Qq4 = parcelRequire("g6Qq4");

var $f7Kk4 = parcelRequire("f7Kk4");

var $enEa6 = parcelRequire("enEa6");

var $a3b9P = parcelRequire("a3b9P");

var $gdUUy = parcelRequire("gdUUy");

var $8IP1q = parcelRequire("8IP1q");

var $7GPfv = parcelRequire("7GPfv");

var $4vgtg = parcelRequire("4vgtg");

var $gSyjv = parcelRequire("gSyjv");

var $3iWUu = parcelRequire("3iWUu");

var $1Fs6f = parcelRequire("1Fs6f");

var $bf2JR = parcelRequire("bf2JR");
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $1667cbef19c43499$var$ASCII_CHAR_REGEX = /^[\x00-\x7F]$/;
const $1667cbef19c43499$var$hasValidTypeAheadStep = (tr)=>{
    const steps = tr.steps.filter((step)=>step instanceof (0, $5sUZ8.InsertTypeAheadStep));
    // There are some cases, like collab rebase, where the steps are re-applied
    // We should not re open the type-ahead for those cases
    if (steps.length === 1) return steps[0];
    return null;
};
function $1667cbef19c43499$export$ae829ec7b2625219({ reactDispatch: reactDispatch, popupMountRef: popupMountRef, typeAheadHandlers: typeAheadHandlers, getIntl: getIntl, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI, api: api }) {
    const intl = getIntl();
    const { createDecorations: createDecorations, removeDecorations: removeDecorations } = (0, $gSyjv.factoryDecorations)({
        intl: intl,
        nodeViewPortalProviderAPI: nodeViewPortalProviderAPI,
        popupMountRef: popupMountRef,
        api: api
    });
    const reducer = (0, $bf2JR.createReducer)({
        createDecorations: createDecorations,
        removeDecorations: removeDecorations,
        typeAheadHandlers: typeAheadHandlers,
        popupMountRef: popupMountRef
    });
    // Tracks a wide-char trigger handler detected during IME composition (e.g. ／).
    // Set by compositionupdate, cleared by compositionend. Used by handleKeyDown
    // to intercept Enter that confirms the composition.
    let pendingWideSlashHandler = null;
    return new (0, $f7Kk4.SafePlugin)({
        key: (0, $1Fs6f.pluginKey),
        state: {
            init () {
                return {
                    typeAheadHandlers: typeAheadHandlers,
                    query: '',
                    decorationSet: (0, $a3b9P.DecorationSet).empty,
                    decorationElement: null,
                    items: [],
                    sectionTitleUpdates: {},
                    sections: [],
                    errorInfo: null,
                    selectedIndex: -1,
                    stats: null,
                    inputMethod: null,
                    removePrefixTriggerOnCancel: undefined
                };
            },
            apply (tr, currentPluginState, oldEditorState, state) {
                const customStep = $1667cbef19c43499$var$hasValidTypeAheadStep(tr);
                const nextPluginState = reducer(tr, currentPluginState, customStep);
                if (currentPluginState !== nextPluginState) reactDispatch((0, $1Fs6f.pluginKey), nextPluginState);
                return nextPluginState;
            }
        },
        appendTransaction (transactions, _oldState, newState) {
            const insertItemCallback = (0, $3iWUu.isInsertionTransaction)(transactions, (0, $8IP1q.ACTIONS).INSERT_RAW_QUERY);
            if (insertItemCallback) {
                const tr = insertItemCallback(newState);
                if (tr) {
                    if ((0, $gdUUy.fg)('platform_editor_ease_of_use_metrics')) {
                        var _api$metrics;
                        api === null || api === void 0 || (_api$metrics = api.metrics) === null || _api$metrics === void 0 || _api$metrics.commands.startActiveSessionTimer()({
                            tr: tr
                        });
                    }
                    return tr;
                }
            }
        },
        view () {
            return {
                update (editorView) {}
            };
        },
        props: {
            decorations: (state)=>{
                var _pluginKey$getState;
                return (_pluginKey$getState = (0, $1Fs6f.pluginKey).getState(state)) === null || _pluginKey$getState === void 0 ? void 0 : _pluginKey$getState.decorationSet;
            },
            handleKeyDown: (view, event)=>{
                // When composing a wide-char trigger (e.g. ／), intercept the Enter key
                // that confirms the composition so we can open the typeahead instead.
                if (pendingWideSlashHandler && event.isComposing && (event.key === 'Enter' || event.keyCode === 13)) {
                    const handler = pendingWideSlashHandler;
                    pendingWideSlashHandler = null;
                    // Defer until ProseMirror has flushed the composed text into its state.
                    setTimeout(()=>{
                        const command = (0, $7GPfv.openTypeAheadAtCursor)({
                            triggerHandler: handler,
                            inputMethod: (0, $g6Qq4.INPUT_METHOD).KEYBOARD
                        });
                        const tr = command({
                            tr: view.state.tr
                        });
                        if (tr) view.dispatch(tr);
                    }, 0);
                    return true;
                }
                return false;
            },
            handleDOMEvents: {
                compositionupdate: (view, event)=>{
                    // Track whether the current composition exactly matches a wide-char
                    // trigger (e.g. ／ from Japanese keyboard).
                    // We can't open the typeahead yet because composition is still active,
                    // but we record the matching handler so the next keydown (Enter) can use it.
                    const pendingData = event.data ?? '';
                    pendingWideSlashHandler = typeAheadHandlers.find((handler)=>{
                        if (!handler.customRegex) return false;
                        // Only match if the composition is a NON-ASCII trigger character.
                        // ASCII triggers (e.g. '/') are handled by the normal input rule
                        // path and must NOT be intercepted here — otherwise typing '/' on
                        // a macOS Japanese IME (which briefly fires compositionupdate with
                        // data='/') would cause the Enter-confirm to open the typeahead.
                        // Matches any single ASCII character (U+0000–U+007F).
                        // No 'u' flag needed for ASCII-only ranges.
                        if ($1667cbef19c43499$var$ASCII_CHAR_REGEX.test(pendingData)) return false;
                        const pattern = new RegExp(`^(${handler.customRegex})$`, 'u');
                        return pattern.test(pendingData);
                    }) ?? null;
                    return false;
                },
                compositionend: (view, event)=>{
                    // Clear the pending handler when composition ends (cancelled or committed
                    // via a non-Enter key like Space, which we don't want to intercept).
                    pendingWideSlashHandler = null;
                    return false;
                },
                click: (view, event)=>{
                    const { target: target } = event;
                    // ProseMirror view listen to any click event inside of it
                    // When this event is coming from the typeahead
                    // we should tell to ProseMirror to sit down and relax
                    // cuz we know what we are doing (I hope)
                    if (target instanceof HTMLElement && (0, $enEa6.closest)(target, `[data-type-ahead=${(0, $4vgtg.TYPE_AHEAD_DECORATION_DATA_ATTRIBUTE)}]`)) return true;
                    return false;
                }
            }
        }
    });
}

});
parcelRegister("4vgtg", function(module, exports) {
$parcel$export(module.exports, "TYPE_AHEAD_DECORATION_KEY", () => $bb4d94050241c3dd$export$65dc1d975bd3407b);
$parcel$export(module.exports, "TYPE_AHEAD_DECORATION_DATA_ATTRIBUTE", () => $bb4d94050241c3dd$export$be8a8259777b339f);
$parcel$export(module.exports, "TYPE_AHEAD_POPUP_CONTENT_CLASS", () => $bb4d94050241c3dd$export$a5cdf6890cae94d6);
$parcel$export(module.exports, "TYPE_AHEAD_DECORATION_ELEMENT_ID", () => $bb4d94050241c3dd$export$a38374e9651d6165);
$parcel$export(module.exports, "CloseSelectionOptions", () => $bb4d94050241c3dd$export$fc2dc87cf13c1ab1);
const $bb4d94050241c3dd$export$65dc1d975bd3407b = 'typeahead_decoration_key';
const $bb4d94050241c3dd$export$be8a8259777b339f = 'typeaheadDecoration';
const $bb4d94050241c3dd$export$a5cdf6890cae94d6 = 'fabric-editor-typeahead';
const $bb4d94050241c3dd$export$a38374e9651d6165 = 'typeahaed_decoration_element_id';
var $bb4d94050241c3dd$export$fc2dc87cf13c1ab1 = /*#__PURE__*/ function(CloseSelectionOptions) {
    CloseSelectionOptions["BEFORE_TEXT_INSERTED"] = "BEFORE_TEXT_INSERTED";
    CloseSelectionOptions["AFTER_TEXT_INSERTED"] = "AFTER_TEXT_INSERTED";
    return CloseSelectionOptions;
}({});

});

parcelRegister("gSyjv", function(module, exports) {
$parcel$export(module.exports, "factoryDecorations", () => $33f0fe379be62713$export$116b677c5744e397);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $dTM5i = parcelRequire("dTM5i");

var $7RHfd = parcelRequire("7RHfd");

var $kitud = parcelRequire("kitud");

var $cw0wu = parcelRequire("cw0wu");

var $a3b9P = parcelRequire("a3b9P");

var $gdUUy = parcelRequire("gdUUy");

var $gNUrD = parcelRequire("gNUrD");

var $jVAei = parcelRequire("jVAei");

var $3ijIz = parcelRequire("3ijIz");

var $8nLP3 = parcelRequire("8nLP3");

var $4vgtg = parcelRequire("4vgtg");

var $kJH9k = parcelRequire("kJH9k");

var $479du = parcelRequire("479du");
const $33f0fe379be62713$export$116b677c5744e397 = ({ intl: intl, popupMountRef: popupMountRef, nodeViewPortalProviderAPI: nodeViewPortalProviderAPI, api: api })=>{
    const createDecorations = (tr, { triggerHandler: triggerHandler, inputMethod: inputMethod, reopenQuery: reopenQuery })=>{
        const { selection: selection } = tr;
        if (!(selection instanceof (0, $cw0wu.TextSelection)) || !selection.$cursor) return {
            decorationSet: (0, $a3b9P.DecorationSet).empty,
            stats: null,
            decorationElement: null
        };
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const decorationId = `decoration_id_${(0, $4vgtg.TYPE_AHEAD_DECORATION_KEY)}_${(0, $7RHfd.default)()}`;
        const { $cursor: $cursor } = selection;
        const typeaheadComponent = document.createElement('mark');
        const stats = new (0, $kJH9k.StatsModifier)();
        let shouldFocusCursorInsideQuery = true;
        const deco = (0, $a3b9P.Decoration).widget($cursor.pos, (editorView, getDecorationPositionUnsafe)=>{
            const getDecorationPosition = ()=>{
                try {
                    return getDecorationPositionUnsafe();
                } catch (e) {
                    return undefined;
                }
            };
            typeaheadComponent.setAttribute('id', decorationId);
            typeaheadComponent.setAttribute('role', 'search');
            typeaheadComponent.dataset.typeAheadQuery = 'true';
            typeaheadComponent.dataset.trigger = triggerHandler.trigger;
            // This line below seems weird,
            // we need that cuz the clickAreaHelper
            // will try to hijack any click event coming
            // from the inside of the Editor
            // packages/editor/editor-core/src/ui/Addon/click-area-helper.ts
            typeaheadComponent.dataset.editorPopup = 'true';
            typeaheadComponent.dataset.typeAhead = (0, $4vgtg.TYPE_AHEAD_DECORATION_DATA_ATTRIBUTE);
            typeaheadComponent.style.color = "var(--ds-text-accent-blue, #1558BC)";
            typeaheadComponent.style.backgroundColor = 'transparent';
            const onUndoRedo = (inputType)=>{
                if (![
                    'historyUndo',
                    'historyRedo'
                ].includes(inputType)) return false;
                const hasReopenQuery = typeof reopenQuery === 'string' && reopenQuery.trim().length > 0;
                const currentQuery = (0, $479du.getTypeAheadQuery)(editorView.state);
                if (hasReopenQuery || (currentQuery === null || currentQuery === void 0 ? void 0 : currentQuery.length) === 0) {
                    const command = inputType === 'historyUndo' ? (0, $jVAei.undo) : (0, $gNUrD.redo);
                    let tr = editorView.state.tr;
                    const fakeDispatch = (customTr)=>{
                        tr = customTr;
                    };
                    const result = command(editorView.state, fakeDispatch);
                    if (result) {
                        (0, $8nLP3.closeTypeAhead)(tr);
                        editorView.dispatch(tr);
                        editorView.focus();
                    }
                    return result;
                }
                return false;
            };
            nodeViewPortalProviderAPI.render(()=>{
                var _popupMountRef$curren, _popupMountRef$curren2, _popupMountRef$curren3;
                return /*#__PURE__*/ (0, $dc70d.jsx)((0, $dTM5i.default), {
                    defaultLocale: intl.defaultLocale || 'en-US',
                    locale: intl.locale || 'en-US',
                    messages: intl.messages,
                    formats: intl.formats,
                    children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $3ijIz.WrapperTypeAhead), {
                        triggerHandler: triggerHandler,
                        editorView: editorView,
                        anchorElement: typeaheadComponent,
                        inputMethod: inputMethod,
                        getDecorationPosition: getDecorationPosition,
                        shouldFocusCursorInsideQuery: shouldFocusCursorInsideQuery,
                        popupsMountPoint: (_popupMountRef$curren = popupMountRef.current) === null || _popupMountRef$curren === void 0 ? void 0 : _popupMountRef$curren.popupsMountPoint,
                        popupsBoundariesElement: (_popupMountRef$curren2 = popupMountRef.current) === null || _popupMountRef$curren2 === void 0 ? void 0 : _popupMountRef$curren2.popupsBoundariesElement,
                        popupsScrollableElement: (_popupMountRef$curren3 = popupMountRef.current) === null || _popupMountRef$curren3 === void 0 ? void 0 : _popupMountRef$curren3.popupsScrollableElement,
                        onUndoRedo: onUndoRedo,
                        reopenQuery: reopenQuery,
                        api: api
                    })
                });
            }, typeaheadComponent, decorationId, undefined, // @portal-render-immediately
            true);
            shouldFocusCursorInsideQuery = false;
            return typeaheadComponent;
        }, {
            isTypeAheadDecoration: true,
            key: decorationId,
            side: 0,
            stopEvent: (e)=>{
                const key = (0, $kitud.keyName)(e);
                const sel = document.getSelection();
                if ('ArrowLeft' === key && (sel === null || sel === void 0 ? void 0 : sel.anchorOffset) === 0) return false;
                return true;
            },
            ignoreSelection: false
        });
        return {
            decorationSet: (0, $a3b9P.DecorationSet).create(tr.doc, [
                deco
            ]),
            decorationElement: typeaheadComponent,
            stats: stats
        };
    };
    const removeDecorations = (decorationSet)=>{
        if (!decorationSet || decorationSet === (0, $a3b9P.DecorationSet).empty) return false;
        const typeAheadDecorations = decorationSet.find(undefined, undefined, (spec)=>{
            return spec.isTypeAheadDecoration;
        });
        if (!typeAheadDecorations || typeAheadDecorations.length === 0) return false;
        typeAheadDecorations.forEach(({ spec: spec })=>{
            if (!spec.key) return;
            const decoElement = document.querySelector(`#${spec.key}`);
            if (!decoElement) return;
            nodeViewPortalProviderAPI.remove(spec.key);
        });
        if ((0, $gdUUy.fg)('platform_editor_ease_of_use_metrics')) {
            var _api$metrics;
            api === null || api === void 0 || api.core.actions.execute(api === null || api === void 0 || (_api$metrics = api.metrics) === null || _api$metrics === void 0 ? void 0 : _api$metrics.commands.startActiveSessionTimer());
        }
        return true;
    };
    return {
        createDecorations: createDecorations,
        removeDecorations: removeDecorations
    };
};

});
parcelRegister("3ijIz", function(module, exports) {
$parcel$export(module.exports, "WrapperTypeAhead", () => $488214bc2a812691$export$970faf6afe0d9376);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $g6Qq4 = parcelRequire("g6Qq4");

var $aaLLt = parcelRequire("aaLLt");

var $gdUUy = parcelRequire("gdUUy");

var $797yE = parcelRequire("797yE");
parcelRequire("ixBwV");
var $eW8cK = parcelRequire("eW8cK");

var $eiHj2 = parcelRequire("eiHj2");

var $cCdEy = parcelRequire("cCdEy");

var $5aZT5 = parcelRequire("5aZT5");

var $479du = parcelRequire("479du");

var $kIfQl = parcelRequire("kIfQl");

var $jsipT = parcelRequire("jsipT");

var $7COe3 = parcelRequire("7COe3");

var $6A5XB = parcelRequire("6A5XB");

var $72Twt = parcelRequire("72Twt");

var $b3FBL = parcelRequire("b3FBL");
const $488214bc2a812691$export$970faf6afe0d9376 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).memo(({ triggerHandler: triggerHandler, editorView: editorView, anchorElement: anchorElement, shouldFocusCursorInsideQuery: shouldFocusCursorInsideQuery, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, inputMethod: inputMethod, getDecorationPosition: getDecorationPosition, reopenQuery: reopenQuery, onUndoRedo: onUndoRedo, api: api })=>{
    // @ts-ignore
    const openElementBrowserModal = triggerHandler === null || triggerHandler === void 0 ? void 0 : triggerHandler.openElementBrowserModal;
    let showMoreOptionsButton = false;
    if ((0, $797yE.editorExperiment)('platform_editor_controls', 'variant1')) showMoreOptionsButton = !!(triggerHandler !== null && triggerHandler !== void 0 && triggerHandler.getMoreOptionsButtonConfig);
    const intl = (0, $4vLTk.default)();
    const [closed, setClosed] = (0, $bSJIT.useState)(false);
    const [query, setQuery] = (0, $bSJIT.useState)(reopenQuery || '');
    const queryRef = (0, $bSJIT.useRef)(query);
    const editorViewRef = (0, $bSJIT.useRef)(editorView);
    const registeredSurface = (0, $b3FBL.getTypeAheadSurface)(triggerHandler.id);
    const items = (0, $jsipT.useLoadItems)(triggerHandler, editorView, query, showMoreOptionsButton, api, intl, !registeredSurface);
    (0, $bSJIT.useEffect)(()=>{
        if (!closed && (0, $gdUUy.fg)('platform_editor_ease_of_use_metrics')) {
            var _api$metrics;
            api === null || api === void 0 || api.core.actions.execute(api === null || api === void 0 || (_api$metrics = api.metrics) === null || _api$metrics === void 0 ? void 0 : _api$metrics.commands.handleIntentToStartEdit({
                shouldStartTimer: false,
                shouldPersistActiveSession: true
            }));
        }
    }, [
        closed,
        api
    ]);
    (0, $bSJIT.useLayoutEffect)(()=>{
        queryRef.current = query;
    }, [
        query
    ]);
    const [onItemInsert, onTextInsert] = (0, $kIfQl.useItemInsert)(triggerHandler, editorView, items, api);
    const selectNextItem = (0, $bSJIT.useMemo)(()=>(0, $479du.moveSelectedIndex)({
            editorView: editorView,
            direction: 'next',
            api: api
        }), [
        editorView,
        api
    ]);
    const selectPreviousItem = (0, $bSJIT.useMemo)(()=>(0, $479du.moveSelectedIndex)({
            editorView: editorView,
            direction: 'previous',
            api: api
        }), [
        editorView,
        api
    ]);
    const cancel = (0, $bSJIT.useCallback)(({ setSelectionAt: setSelectionAt, addPrefixTrigger: addPrefixTrigger, text: text, forceFocusOnEditor: forceFocusOnEditor })=>{
        if ((0, $797yE.editorExperiment)('platform_editor_controls', 'variant1')) {
            var _getPluginState;
            (0, $eiHj2.fireTypeAheadClosedAnalyticsEvent)(api, (0, $g6Qq4.ACTION).CANCELLED, !!queryRef.current, (0, $g6Qq4.INPUT_METHOD).KEYBOARD, (_getPluginState = (0, $479du.getPluginState)(editorView.state)) === null || _getPluginState === void 0 ? void 0 : _getPluginState.inputMethod);
        }
        setClosed(true);
        const fullquery = addPrefixTrigger ? `${triggerHandler.trigger}${text}` : text;
        onTextInsert({
            forceFocusOnEditor: forceFocusOnEditor,
            setSelectionAt: setSelectionAt,
            text: fullquery
        });
    }, [
        triggerHandler.trigger,
        onTextInsert,
        api,
        editorView.state
    ]);
    const insertSelectedItem = (0, $bSJIT.useCallback)((mode = (0, $aaLLt.SelectItemMode).SELECTED)=>{
        const { current: view } = editorViewRef;
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const { selectedIndex: selectedIndex } = (0, $479du.getPluginState)(view.state);
        const safeSelectedIndex = (0, $479du.skipForwardToSafeItem)({
            currentIndex: selectedIndex,
            nextIndex: 1,
            listSize: items.length,
            itemIsDisabled: (idx)=>(0, $5aZT5.itemIsDisabled)(items[idx], api)
        });
        // If the only safe index is -1 then none are safe - do not insert item
        if (safeSelectedIndex === -1) return;
        if ((0, $797yE.editorExperiment)('platform_editor_controls', 'variant1')) {
            var _getPluginState2;
            (0, $eiHj2.fireTypeAheadClosedAnalyticsEvent)(api, (0, $g6Qq4.ACTION).INSERTED, !!queryRef.current, (0, $g6Qq4.INPUT_METHOD).KEYBOARD, (_getPluginState2 = (0, $479du.getPluginState)(editorView.state)) === null || _getPluginState2 === void 0 ? void 0 : _getPluginState2.inputMethod);
        }
        setClosed(true);
        queueMicrotask(()=>{
            onItemInsert({
                mode: mode,
                index: selectedIndex,
                query: queryRef.current
            });
        });
    }, [
        items,
        api,
        editorView.state,
        onItemInsert
    ]);
    const showTypeAheadPopupList = (0, $bSJIT.useCallback)(()=>{}, []);
    const closePopup = (0, $bSJIT.useCallback)(()=>{
        setClosed(true);
    }, []);
    (0, $bSJIT.useEffect)(()=>{
        const { current: view } = editorViewRef;
        const pluginState = (0, $479du.getPluginState)(view.state);
        const shouldSkipEmptyQuery = !(0, $eW8cK.expVal)('platform_editor_agent_mentions', 'isEnabled', false) && query.length === 0;
        if (shouldSkipEmptyQuery || query === (pluginState === null || pluginState === void 0 ? void 0 : pluginState.query) || !(pluginState !== null && pluginState !== void 0 && pluginState.triggerHandler)) return;
        (0, $cCdEy.updateQuery)(query)(view.state, view.dispatch);
    }, [
        query,
        reopenQuery
    ]);
    (0, $7COe3.useOnForceSelect)({
        triggerHandler: triggerHandler,
        items: items,
        query: query,
        editorView: editorView,
        closePopup: closePopup
    });
    if (closed) return null;
    if (!triggerHandler) return null;
    if (registeredSurface) return /*#__PURE__*/ (0, $dc70d.jsx)((0, $72Twt.RegisteredTypeAheadMenu), {
        anchorElement: anchorElement,
        api: api,
        cancel: cancel,
        editorView: editorView,
        forceFocus: shouldFocusCursorInsideQuery,
        onClose: closePopup,
        onUndoRedo: onUndoRedo,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsMountPoint: popupsMountPoint,
        popupsScrollableElement: popupsScrollableElement,
        query: query,
        reopenQuery: reopenQuery,
        setQuery: setQuery,
        surface: registeredSurface,
        triggerHandler: triggerHandler
    });
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $6A5XB.InputQuery), {
        triggerQueryPrefix: triggerHandler === null || triggerHandler === void 0 ? void 0 : triggerHandler.trigger,
        onQueryChange: setQuery,
        onItemSelect: insertSelectedItem,
        selectNextItem: selectNextItem,
        selectPreviousItem: selectPreviousItem,
        onQueryFocus: showTypeAheadPopupList,
        cancel: cancel,
        forceFocus: shouldFocusCursorInsideQuery,
        onUndoRedo: onUndoRedo,
        reopenQuery: reopenQuery,
        editorView: editorView,
        items: items
    });
});
$488214bc2a812691$export$970faf6afe0d9376.displayName = 'WrapperTypeAhead';

});
parcelRegister("eiHj2", function(module, exports) {
$parcel$export(module.exports, "fireTypeAheadClosedAnalyticsEvent", () => $ffdbc86fd1956211$export$4a6068dadc2c7771);

var $g6Qq4 = parcelRequire("g6Qq4");
const $ffdbc86fd1956211$export$4a6068dadc2c7771 = (api, closeAction, hasQuery, inputMethod, invocationMethod = null)=>{
    var _api$analytics;
    api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 || _api$analytics.actions.fireAnalyticsEvent({
        action: (0, $g6Qq4.ACTION).CLOSED,
        actionSubject: (0, $g6Qq4.ACTION_SUBJECT).TYPEAHEAD,
        actionSubjectId: (0, $g6Qq4.ACTION_SUBJECT_ID).TYPEAHEAD_QUICK_INSERT,
        attributes: {
            inputMethod: inputMethod,
            closeAction: closeAction,
            hasQuery: hasQuery,
            invocationMethod: invocationMethod
        },
        eventType: (0, $g6Qq4.EVENT_TYPE).TRACK
    });
};

});

parcelRegister("cCdEy", function(module, exports) {
$parcel$export(module.exports, "updateQuery", () => $cb750aa43f36dd1b$export$4d1bf8b2f67bcb1);

var $8IP1q = parcelRequire("8IP1q");

var $1Fs6f = parcelRequire("1Fs6f");
const $cb750aa43f36dd1b$export$4d1bf8b2f67bcb1 = (query)=>{
    return (state, dispatch)=>{
        const pluginState = (0, $1Fs6f.pluginKey).getState(state);
        if ((pluginState === null || pluginState === void 0 ? void 0 : pluginState.query) === query) return false;
        const tr = state.tr;
        tr.setMeta((0, $1Fs6f.pluginKey), {
            action: (0, $8IP1q.ACTIONS).CHANGE_QUERY,
            params: {
                query: query
            }
        });
        if (dispatch) dispatch(tr);
        return true;
    };
};

});

parcelRegister("kIfQl", function(module, exports) {
$parcel$export(module.exports, "useItemInsert", () => $33c499f492da99fe$export$3a3385069392b26f);

var $bSJIT = parcelRequire("bSJIT");

var $aaLLt = parcelRequire("aaLLt");

var $8nLP3 = parcelRequire("8nLP3");

var $7EziY = parcelRequire("7EziY");

var $K6vpA = parcelRequire("K6vpA");

var $4vgtg = parcelRequire("4vgtg");

var $5aZT5 = parcelRequire("5aZT5");
const $33c499f492da99fe$var$onlyHasViewMoreItem = (items)=>{
    var _items$at;
    return ((_items$at = items.at(0)) === null || _items$at === void 0 ? void 0 : _items$at.title) === 'View more';
};
const $33c499f492da99fe$var$insertRawQuery = ({ view: view, setSelectionAt: setSelectionAt, text: text, forceFocusOnEditor: forceFocusOnEditor })=>{
    const { tr: tr, schema: schema } = view.state;
    (0, $8nLP3.closeTypeAhead)(tr);
    if (text.length > 0) {
        tr.replaceSelectionWith(schema.text(text));
        if (setSelectionAt === (0, $4vgtg.CloseSelectionOptions).BEFORE_TEXT_INSERTED) (0, $K6vpA.setSelectionBeforeQuery)(text)(tr);
    }
    view.dispatch(tr);
    if (forceFocusOnEditor) view.focus();
};
const $33c499f492da99fe$export$3a3385069392b26f = (triggerHandler, editorView, items, api)=>{
    const editorViewRef = (0, $bSJIT.useRef)(editorView);
    const itemsRef = (0, $bSJIT.useRef)(items);
    const onTextInsert = (0, $bSJIT.useCallback)(({ setSelectionAt: setSelectionAt, text: text, forceFocusOnEditor: forceFocusOnEditor })=>{
        if (!triggerHandler) return;
        const { current: view } = editorViewRef;
        $33c499f492da99fe$var$insertRawQuery({
            view: view,
            setSelectionAt: setSelectionAt,
            text: text,
            forceFocusOnEditor: forceFocusOnEditor
        });
    }, [
        triggerHandler
    ]);
    const onItemInsert = (0, $bSJIT.useCallback)(({ mode: mode, index: index, query: query })=>{
        const sourceListItem = itemsRef.current;
        if (sourceListItem.length === 0 || !triggerHandler || // View more item is only added for keyboard navigation and should not be considered as a valid item to be inserted
        $33c499f492da99fe$var$onlyHasViewMoreItem(sourceListItem)) {
            const text = `${triggerHandler.trigger}${query}`;
            onTextInsert({
                forceFocusOnEditor: true,
                setSelectionAt: (0, $4vgtg.CloseSelectionOptions).AFTER_TEXT_INSERTED,
                text: text
            });
            return;
        }
        const itemToInsert = sourceListItem[index];
        if (!itemToInsert) return;
        const isDisabled = (0, $5aZT5.itemIsDisabled)(itemToInsert, api);
        if (isDisabled) return;
        const { current: view } = editorViewRef;
        (0, $7EziY.insertTypeAheadItem)(view)({
            item: itemToInsert,
            handler: triggerHandler,
            mode: mode,
            query: query,
            sourceListItem: sourceListItem
        });
    }, [
        triggerHandler,
        onTextInsert,
        api
    ]);
    const onItemMatch = (0, $bSJIT.useCallback)(({ mode: mode, query: query })=>{
        const _items = itemsRef.current;
        if (_items && _items.length > 1) return false;
        if (_items.length === 1 && // View more item is only added for keyboard navigation and should not be considered as a valid item to be inserted
        !$33c499f492da99fe$var$onlyHasViewMoreItem(_items)) queueMicrotask(()=>{
            onItemInsert({
                mode: mode,
                query: query,
                index: 0
            });
        });
        else {
            const text = `${triggerHandler.trigger}${query}`;
            queueMicrotask(()=>{
                onTextInsert({
                    forceFocusOnEditor: true,
                    setSelectionAt: (0, $4vgtg.CloseSelectionOptions).AFTER_TEXT_INSERTED,
                    text: mode === (0, $aaLLt.SelectItemMode).SPACE ? text.concat(' ') : text
                });
            });
        }
        return true;
    }, [
        onItemInsert,
        triggerHandler,
        onTextInsert
    ]);
    (0, $bSJIT.useLayoutEffect)(()=>{
        itemsRef.current = items;
    }, [
        items
    ]);
    return [
        onItemInsert,
        onTextInsert,
        onItemMatch
    ];
};

});
parcelRegister("K6vpA", function(module, exports) {
$parcel$export(module.exports, "setSelectionBeforeQuery", () => $e41023a34db21fd7$export$5af11333ab9d7643);

var $cw0wu = parcelRequire("cw0wu");
const $e41023a34db21fd7$export$5af11333ab9d7643 = (rawText)=>(tr)=>{
        const currentPosition = tr.selection.$from.pos;
        const positionBeforeRawText = Math.max(currentPosition - rawText.length, 0);
        const resolvedPositionBeforeText = tr.doc.resolve(positionBeforeRawText);
        const nextSelection = (0, $cw0wu.TextSelection).findFrom(resolvedPositionBeforeText, -1, true);
        if (nextSelection) tr.setSelection(nextSelection);
    };

});


parcelRegister("jsipT", function(module, exports) {
$parcel$export(module.exports, "useLoadItems", () => $acdbf55a2d1ddfb5$export$36f5628e43bc3fcd);

var $bSJIT = parcelRequire("bSJIT");

var $lbJji = parcelRequire("lbJji");

var $7Tmqj = parcelRequire("7Tmqj");

var $9zPDJ = parcelRequire("9zPDJ");

var $eOoHy = parcelRequire("eOoHy");
const $acdbf55a2d1ddfb5$var$EMPTY_LIST_ITEM = [];
const $acdbf55a2d1ddfb5$export$36f5628e43bc3fcd = (triggerHandler, editorView, query, showViewMore, api, intl, enabled = true)=>{
    const [items, setItems] = (0, $bSJIT.useState)($acdbf55a2d1ddfb5$var$EMPTY_LIST_ITEM);
    const componentIsMounted = (0, $bSJIT.useRef)(true);
    const editorViewRef = (0, $bSJIT.useRef)(editorView);
    const latestQueryRef = (0, $bSJIT.useRef)(query);
    latestQueryRef.current = query;
    (0, $bSJIT.useEffect)(()=>{
        if (!enabled) {
            setItems($acdbf55a2d1ddfb5$var$EMPTY_LIST_ITEM);
            return;
        }
        const requestQuery = query;
        const isStaleRequest = ()=>latestQueryRef.current !== requestQuery;
        const options = {
            query: requestQuery || '',
            editorState: editorView.state
        };
        const { current: view } = editorViewRef;
        // Clear any existing error state before making a new request
        queueMicrotask(()=>{
            api === null || api === void 0 || api.core.actions.execute((0, $lbJji.clearListError)());
        });
        /**
     * Shared render pipeline used by both the single-shot `getItems`
     * Promise path and the opt-in multi-emit `subscribeToItemsUpdates`
     * path. Renders the dropdown with whatever items it is given.
     *
     * Both paths share the section-building and "View more"
     * placeholder logic — extracting this helper
     * avoids any chance the two paths drift in subtle rendering
     * behaviour.
     */ const renderResult = (result)=>{
            const { items: list, sections: sections } = (0, $eOoHy.buildSectionedResult)({
                items: result.length > 0 ? result : $acdbf55a2d1ddfb5$var$EMPTY_LIST_ITEM,
                triggerHandler: triggerHandler,
                intl: intl ?? null
            });
            if (componentIsMounted.current) setItems(list);
            const viewMoreItem = {
                title: 'View more'
            };
            queueMicrotask(()=>{
                (0, $9zPDJ.updateListItem)(showViewMore ? list.concat(viewMoreItem) : list, sections)(view.state, view.dispatch);
            });
        };
        // Matches the pre-refactor implicit-any contract for the original
        // `.catch((e) => updateListError(e)(...))` path.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const handleError = (e)=>{
            if (e) {
                if (componentIsMounted.current) setItems($acdbf55a2d1ddfb5$var$EMPTY_LIST_ITEM);
                queueMicrotask(()=>{
                    (0, $7Tmqj.updateListError)(e)(view.state, view.dispatch);
                });
            }
        };
        // Multi-emit path: handler opts in by implementing
        // `subscribeToItemsUpdates`. The handler controls when to push
        // updates; we re-render on every push for the lifetime of this
        // effect.
        const subscribeToItemsUpdates = triggerHandler === null || triggerHandler === void 0 ? void 0 : triggerHandler.subscribeToItemsUpdates;
        if (subscribeToItemsUpdates) {
            let stale = false;
            const { initial: initial, subscribe: subscribe } = subscribeToItemsUpdates(options);
            initial.then((result)=>{
                if (!stale && !isStaleRequest()) renderResult(result);
            }).catch(handleError);
            const unsubscribe = subscribe((items)=>{
                if (stale || isStaleRequest() || !componentIsMounted.current) return;
                renderResult(items);
            });
            return ()=>{
                stale = true;
                unsubscribe();
            };
        }
        // Existing single-shot path. Unchanged in behaviour.
        const getItems = triggerHandler === null || triggerHandler === void 0 ? void 0 : triggerHandler.getItems;
        if (!getItems) {
            setItems($acdbf55a2d1ddfb5$var$EMPTY_LIST_ITEM);
            return;
        }
        getItems(options).then(renderResult).catch(handleError);
    // ignore because EditorView is mutable but we don't want to
    // call loadItems when it changes, only when the query changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        triggerHandler,
        query,
        intl,
        enabled
    ]);
    (0, $bSJIT.useEffect)(()=>{
        return ()=>{
            componentIsMounted.current = false;
        };
    }, []);
    return items;
};

});
parcelRegister("lbJji", function(module, exports) {
$parcel$export(module.exports, "clearListError", () => $4e64f099ffa71ab5$export$265c9044700bb67);

var $8IP1q = parcelRequire("8IP1q");

var $1Fs6f = parcelRequire("1Fs6f");
const $4e64f099ffa71ab5$export$265c9044700bb67 = ()=>{
    return ({ tr: tr })=>{
        tr.setMeta((0, $1Fs6f.pluginKey), {
            action: (0, $8IP1q.ACTIONS).CLEAR_LIST_ERROR,
            params: {
                errorInfo: null
            }
        });
        return tr;
    };
};

});

parcelRegister("7Tmqj", function(module, exports) {
$parcel$export(module.exports, "updateListError", () => $567fc6d4cceda43e$export$4f4014ebb73e8d41);

var $8IP1q = parcelRequire("8IP1q");

var $1Fs6f = parcelRequire("1Fs6f");
const $567fc6d4cceda43e$export$4f4014ebb73e8d41 = (errorInfo)=>{
    return (state, dispatch)=>{
        const tr = state.tr;
        tr.setMeta((0, $1Fs6f.pluginKey), {
            action: (0, $8IP1q.ACTIONS).UPDATE_LIST_ERROR,
            params: {
                errorInfo: errorInfo,
                items: []
            }
        });
        if (dispatch) dispatch(tr);
        return true;
    };
};

});

parcelRegister("9zPDJ", function(module, exports) {
$parcel$export(module.exports, "updateListItem", () => $ec1c8bda743dcdf3$export$e482099e4c227d2);

var $8IP1q = parcelRequire("8IP1q");

var $1Fs6f = parcelRequire("1Fs6f");
const $ec1c8bda743dcdf3$export$e482099e4c227d2 = (items, sections = [])=>{
    return (state, dispatch)=>{
        const tr = state.tr;
        tr.setMeta((0, $1Fs6f.pluginKey), {
            action: (0, $8IP1q.ACTIONS).UPDATE_LIST_ITEMS,
            params: {
                items: items,
                sections: sections
            }
        });
        if (dispatch) dispatch(tr);
        return true;
    };
};

});

parcelRegister("eOoHy", function(module, exports) {
$parcel$export(module.exports, "buildSectionedResult", () => $2613edd794ffdfe4$export$ba9956bced492649);
const $2613edd794ffdfe4$export$ba9956bced492649 = ({ items: items, triggerHandler: triggerHandler, intl: intl })=>{
    var _triggerHandler$getSe;
    if (!intl) return {
        items: items,
        sections: []
    };
    const sectionDefinitions = (_triggerHandler$getSe = triggerHandler.getSections) === null || _triggerHandler$getSe === void 0 ? void 0 : _triggerHandler$getSe.call(triggerHandler, {
        intl: intl
    });
    if (!sectionDefinitions || sectionDefinitions.length === 0) return {
        items: items,
        sections: []
    };
    // Track which item indexes have been claimed by a section, or excluded (matched a section but
    // cut by that section's limit). Items excluded by limit should not appear anywhere in the output.
    const assignedToSection = new Set();
    const excludedByLimit = new Set();
    const groupedBySection = new Map();
    for (const section of sectionDefinitions){
        const matchingIndexes = [];
        for(let i = 0; i < items.length; i++){
            if (assignedToSection.has(i) || excludedByLimit.has(i)) continue;
            if (section.filter(items[i])) matchingIndexes.push(i);
        }
        const acceptedIndexes = section.limit !== undefined ? matchingIndexes.slice(0, section.limit) : matchingIndexes;
        const rejectedByLimit = matchingIndexes.slice(acceptedIndexes.length);
        for (const i of acceptedIndexes)assignedToSection.add(i);
        for (const i of rejectedByLimit)excludedByLimit.add(i);
        if (acceptedIndexes.length === 0) continue;
        groupedBySection.set(section.id, {
            indexes: acceptedIndexes,
            section: section
        });
    }
    const flattenedItems = [];
    const sections = [];
    for (const section of sectionDefinitions){
        const grouped = groupedBySection.get(section.id);
        if (!grouped) continue;
        const startIndex = flattenedItems.length;
        flattenedItems.push(...grouped.indexes.map((i)=>items[i]));
        const endIndex = flattenedItems.length - 1;
        const resolvedSection = {
            endIndex: endIndex,
            id: section.id,
            startIndex: startIndex,
            title: section.title
        };
        if (section.lozenge !== undefined) resolvedSection.lozenge = section.lozenge;
        if (section.sectionTitleDisplay) resolvedSection.sectionTitleDisplay = section.sectionTitleDisplay;
        sections.push(resolvedSection);
    }
    // Append items not claimed by any section and not excluded by a limit
    for(let i = 0; i < items.length; i++)if (!assignedToSection.has(i) && !excludedByLimit.has(i)) flattenedItems.push(items[i]);
    return {
        items: flattenedItems,
        sections: sections
    };
};

});


parcelRegister("7COe3", function(module, exports) {
$parcel$export(module.exports, "useOnForceSelect", () => $23350d0d0fe44b88$export$4715c10ec9ca9321);

var $bSJIT = parcelRequire("bSJIT");

var $aaLLt = parcelRequire("aaLLt");

var $7EziY = parcelRequire("7EziY");
const $23350d0d0fe44b88$export$4715c10ec9ca9321 = ({ triggerHandler: triggerHandler, items: items, query: query, editorView: editorView, closePopup: closePopup })=>{
    const editorViewRef = (0, $bSJIT.useRef)(editorView);
    (0, $bSJIT.useLayoutEffect)(()=>{
        if (!query || typeof triggerHandler.forceSelect !== 'function') return;
        const item = triggerHandler.forceSelect({
            items: items,
            query: query,
            editorState: editorViewRef.current.state
        });
        if (!item) return;
        const { current: view } = editorViewRef;
        closePopup();
        queueMicrotask(()=>{
            (0, $7EziY.insertTypeAheadItem)(view)({
                item: item,
                mode: (0, $aaLLt.SelectItemMode).SPACE,
                query: query,
                handler: triggerHandler,
                sourceListItem: items
            });
        });
    }, [
        triggerHandler,
        closePopup,
        query,
        items
    ]);
};

});

parcelRegister("6A5XB", function(module, exports) {
$parcel$export(module.exports, "InputQuery", () => $be0594cf7f1c6dac$export$efc9b80896822e63);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $4vLTk = parcelRequire("4vLTk");

var $kitud = parcelRequire("kitud");

var $9L0hy = parcelRequire("9L0hy");

var $jxkn6 = parcelRequire("jxkn6");

var $aaLLt = parcelRequire("aaLLt");

var $ex2cJ = parcelRequire("ex2cJ");

var $5bbjm = parcelRequire("5bbjm");

var $3y2s4 = parcelRequire("3y2s4");

var $797yE = parcelRequire("797yE");

var $4vgtg = parcelRequire("4vgtg");

var $479du = parcelRequire("479du");
const $be0594cf7f1c6dac$var$querySpanStyles = /*#__PURE__*/ (0, $9dQre.css)({
    outline: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& input': {
        width: '5px',
        border: 'none',
        background: 'transparent',
        padding: 0,
        margin: 0,
        // TODO: ED-17022 - Fixes firefox caret position
        // Do not migrate font when em is used as unit
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: '1em',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        height: (0, $5bbjm.blockNodesVerticalMargin),
        caretColor: "var(--ds-text-accent-blue, #1558BC)"
    }
});
const $be0594cf7f1c6dac$var$isNavigationKey = (event)=>{
    return [
        'Enter',
        'Tab',
        'ArrowDown',
        'ArrowUp'
    ].includes(event.key);
};
const $be0594cf7f1c6dac$var$isUndoRedoShortcut = (event)=>{
    const key = (0, $kitud.keyName)(event);
    if (event.ctrlKey && key === 'y') return 'historyRedo';
    if ((event.ctrlKey || event.metaKey) && event.shiftKey && key === 'Z') return 'historyRedo';
    if ((event.ctrlKey || event.metaKey) && key === 'z') return 'historyUndo';
    return false;
};
const $be0594cf7f1c6dac$var$getAriaLabel = (triggerPrefix, _intl)=>{
    switch(triggerPrefix){
        case '@':
            return (0, $ex2cJ.typeAheadListMessages).mentionInputLabel;
        case '/':
            return (0, $ex2cJ.typeAheadListMessages).quickInsertInputLabel;
        case ':':
            return (0, $ex2cJ.typeAheadListMessages).emojiInputLabel;
        default:
            return (0, $ex2cJ.typeAheadListMessages).quickInsertInputLabel;
    }
};
const $be0594cf7f1c6dac$export$714483c9a7c1d2b = (queryRef, focusQuery)=>{
    let animationFrameId;
    let cancelled = false;
    const focus = ()=>{
        if (!cancelled) focusQuery();
    };
    // React can render the decoration before ProseMirror attaches it. The microtask runs after that
    // synchronous attachment, while the animation frame remains a fallback for asynchronous mounts.
    window.queueMicrotask(()=>{
        var _queryRef$current;
        if (cancelled) return;
        if ((_queryRef$current = queryRef.current) !== null && _queryRef$current !== void 0 && _queryRef$current.isConnected) {
            focus();
            return;
        }
        animationFrameId = requestAnimationFrame(focus);
    });
    return ()=>{
        cancelled = true;
        if (animationFrameId !== undefined) cancelAnimationFrame(animationFrameId);
    };
};
const $be0594cf7f1c6dac$export$efc9b80896822e63 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).memo(({ activeDescendantId: activeDescendantId, triggerQueryPrefix: triggerQueryPrefix, cancel: cancel, onQueryChange: onQueryChange, onItemSelect: onItemSelect, selectNextItem: selectNextItem, selectPreviousItem: selectPreviousItem, forceFocus: forceFocus, reopenQuery: reopenQuery, onQueryFocus: onQueryFocus, onUndoRedo: onUndoRedo, editorView: editorView, items: items, listId: listId, optionCount: optionCount, shouldKeepOpenOnRegisteredMenu: shouldKeepOpenOnRegisteredMenu })=>{
    const resolvedOptionCount = optionCount ?? (items === null || items === void 0 ? void 0 : items.length) ?? 0;
    const ref = (0, $bSJIT.useRef)(document.createElement('span'));
    const inputRef = (0, $bSJIT.useRef)(null);
    const [query, setQuery] = (0, $bSJIT.useState)(null);
    const isEditorControlsEnabled = (0, $797yE.editorExperiment)('platform_editor_controls', 'variant1');
    const cleanedInputContent = (0, $bSJIT.useCallback)(()=>{
        var _ref$current;
        const raw = ((_ref$current = ref.current) === null || _ref$current === void 0 ? void 0 : _ref$current.textContent) || '';
        return raw;
    }, []);
    const onKeyUp = (0, $bSJIT.useCallback)((_event)=>{
        const text = cleanedInputContent();
        onQueryChange(text);
    }, [
        onQueryChange,
        cleanedInputContent
    ]);
    const [isInFocus, setInFocus] = (0, $bSJIT.useState)(false);
    const checkKeyEvent = (0, $bSJIT.useCallback)((event)=>{
        var _ref$current2;
        const key = (0, $kitud.keyName)(event);
        const sel = document.getSelection();
        const raw = ((_ref$current2 = ref.current) === null || _ref$current2 === void 0 ? void 0 : _ref$current2.textContent) || '';
        const text = cleanedInputContent();
        let stopDefault = false;
        const { selectedIndex: selectedIndex, removePrefixTriggerOnCancel: removePrefixTriggerOnCancel } = (0, $479du.getPluginState)(editorView.state) || {};
        setInFocus(true);
        switch(key){
            case ' ':
                // space key
                if (text.length === 0) {
                    cancel({
                        forceFocusOnEditor: true,
                        text: ' ',
                        addPrefixTrigger: isEditorControlsEnabled ? !removePrefixTriggerOnCancel : true,
                        setSelectionAt: (0, $4vgtg.CloseSelectionOptions).AFTER_TEXT_INSERTED
                    });
                    stopDefault = true;
                }
                break;
            case 'Escape':
            case 'PageUp':
            case 'PageDown':
            case 'Home':
                cancel({
                    text: text,
                    forceFocusOnEditor: true,
                    addPrefixTrigger: isEditorControlsEnabled ? !removePrefixTriggerOnCancel : true,
                    setSelectionAt: (0, $4vgtg.CloseSelectionOptions).AFTER_TEXT_INSERTED
                });
                stopDefault = true;
                break;
            case 'Backspace':
                if (raw.length === 0 || (sel === null || sel === void 0 ? void 0 : sel.anchorOffset) === 0) {
                    event.stopPropagation();
                    event.preventDefault();
                    cancel({
                        forceFocusOnEditor: true,
                        text: text,
                        addPrefixTrigger: false,
                        setSelectionAt: (0, $4vgtg.CloseSelectionOptions).BEFORE_TEXT_INSERTED
                    });
                }
                break;
            case 'Enter':
                // TODO: ED-14758 - Under the W3C specification, any keycode sent under IME would return a keycode 229
                // event.isComposing can't be used alone as this also included a virtual keyboard under a keyboardless device, therefore, it seems the best practice would be intercepting the event as below.
                // Some suggested the other workaround maybe listen on`keypress` instead of `keydown`
                if (!event.isComposing && event.which !== 229 && event.keyCode !== 229) {
                    if (selectedIndex === -1) {
                        /**
             * TODO DTR-1401: (also see ED-17200) There are two options
             * here, either
             * - set the index directly to 1 in WrapperTypeAhead.tsx's
             *   `insertSelectedItem` at the cost of breaking some of the a11y
             *   focus changes,
             * - or do this jank at the cost of some small analytics noise.
             *
             * The focus behaviour still needs cleanup
             */ selectPreviousItem();
                        selectNextItem();
                    }
                    onItemSelect(event.shiftKey ? (0, $aaLLt.SelectItemMode).SHIFT_ENTER : (0, $aaLLt.SelectItemMode).ENTER);
                }
                break;
            case 'Tab':
                event.shiftKey ? selectPreviousItem() : selectNextItem();
                break;
            case 'ArrowDown':
                selectNextItem();
                break;
            case 'ArrowUp':
                selectPreviousItem();
                break;
        }
        const undoRedoType = $be0594cf7f1c6dac$var$isUndoRedoShortcut(event);
        if (onUndoRedo && undoRedoType && onUndoRedo(undoRedoType)) stopDefault = true;
        if ($be0594cf7f1c6dac$var$isNavigationKey(event) || stopDefault) {
            event.stopPropagation();
            event.preventDefault();
            return false;
        }
    }, [
        onUndoRedo,
        onItemSelect,
        selectNextItem,
        selectPreviousItem,
        cancel,
        cleanedInputContent,
        editorView.state,
        isEditorControlsEnabled
    ]);
    (0, $bSJIT.useLayoutEffect)(()=>{
        if (!ref.current) return;
        const browser = (0, $jxkn6.getBrowserInfo)();
        const { current: element } = ref;
        const { removePrefixTriggerOnCancel: removePrefixTriggerOnCancel } = (0, $479du.getPluginState)(editorView.state) || {};
        const onFocusIn = (_event)=>{
            onQueryFocus();
        };
        const keyDown = (event)=>{
            const key = (0, $kitud.keyName)(event);
            if ([
                'ArrowLeft',
                'ArrowRight'
            ].includes(key) && document.getSelection && document.getSelection()) {
                var _ref$current3;
                const q = ((_ref$current3 = ref.current) === null || _ref$current3 === void 0 ? void 0 : _ref$current3.textContent) || '';
                const sel = document.getSelection();
                const isMovingRight = sel && 'ArrowRight' === key && sel.anchorOffset === q.length;
                const isMovingLeft = sel && 'ArrowLeft' === key && (sel.anchorOffset === 0 || event.metaKey);
                if (!isMovingRight && !isMovingLeft) return;
                cancel({
                    forceFocusOnEditor: true,
                    addPrefixTrigger: isEditorControlsEnabled ? !removePrefixTriggerOnCancel : true,
                    text: cleanedInputContent(),
                    setSelectionAt: isMovingRight ? (0, $4vgtg.CloseSelectionOptions).AFTER_TEXT_INSERTED : (0, $4vgtg.CloseSelectionOptions).BEFORE_TEXT_INSERTED
                });
                event.preventDefault();
                event.stopPropagation();
                return;
            }
            checkKeyEvent(event);
        };
        const onPaste = (event)=>{
            var _event$clipboardData, _event$clipboardData2;
            const html = (_event$clipboardData = event.clipboardData) === null || _event$clipboardData === void 0 ? void 0 : _event$clipboardData.getData('text/html');
            const plainText = (_event$clipboardData2 = event.clipboardData) === null || _event$clipboardData2 === void 0 ? void 0 : _event$clipboardData2.getData('text/plain');
            if (html && plainText) {
                event.preventDefault();
                // insert the plain text into the type-ahead input field
                const selection = window.getSelection();
                if (selection && ref.current) {
                    if (selection.rangeCount > 0) {
                        const range = selection.getRangeAt(0);
                        range.deleteContents();
                        range.insertNode(document.createTextNode(plainText));
                        range.collapse(false);
                    }
                }
            }
        };
        const onFocusOut = (event)=>{
            var _window$getSelection;
            const { relatedTarget: relatedTarget } = event;
            // Given the user is changing the focus
            // When the target is inside the TypeAhead Popup
            // Then the popup should stay open
            if (relatedTarget instanceof HTMLElement && relatedTarget.closest && (relatedTarget.closest(`.${(0, $4vgtg.TYPE_AHEAD_POPUP_CONTENT_CLASS)}`) || shouldKeepOpenOnRegisteredMenu && relatedTarget.closest('[data-registered-type-ahead-menu]'))) return;
            // Chrome and Edge may emit focusout events without direct input.
            // This path handles dismissals that don't involve item selection, so we ignore these events.
            // In Edge this also lead to duplication in the trigger character (@, /, :) as `cancel` would be called twice
            if ((browser.ie || browser.chrome) && !(((_window$getSelection = window.getSelection()) === null || _window$getSelection === void 0 ? void 0 : _window$getSelection.type) === 'Range') && // eslint-disable-next-line @typescript-eslint/no-explicit-any
            !event.sourceCapabilities) return;
            cancel({
                addPrefixTrigger: isEditorControlsEnabled ? !removePrefixTriggerOnCancel : true,
                text: cleanedInputContent(),
                setSelectionAt: (0, $4vgtg.CloseSelectionOptions).BEFORE_TEXT_INSERTED,
                forceFocusOnEditor: false
            });
        };
        const close = ()=>{
            cancel({
                addPrefixTrigger: false,
                text: '',
                forceFocusOnEditor: true,
                setSelectionAt: (0, $4vgtg.CloseSelectionOptions).BEFORE_TEXT_INSERTED
            });
        };
        const beforeinput = (e)=>{
            var _target$textContent;
            setInFocus(false);
            const { target: target } = e;
            if (e.isComposing || !(target instanceof HTMLElement)) return;
            if (e.inputType === 'historyUndo' && ((_target$textContent = target.textContent) === null || _target$textContent === void 0 ? void 0 : _target$textContent.length) === 0) {
                e.preventDefault();
                e.stopPropagation();
                close();
                return;
            }
            if (e.data != null && inputRef.current === null) {
                setQuery('');
                // We need to change the content on Safari
                // and set the cursor at the right place
                if (browser.safari) {
                    e.preventDefault();
                    const dataElement = document.createTextNode(e.data);
                    element.appendChild(dataElement);
                    const sel = window.getSelection();
                    const range = document.createRange();
                    range.setStart(dataElement, dataElement.length);
                    range.collapse(true);
                    sel === null || sel === void 0 || sel.removeAllRanges();
                    sel === null || sel === void 0 || sel.addRange(range);
                }
            }
        };
        const onInput = ()=>{};
        if (browser.safari) {
            // On Safari, for reasons beyond my understanding,
            // The undo behavior is totally different from other browsers
            // That why we need to have an specific branch only for Safari.
            const onInput = (e)=>{
                var _target$textContent2;
                const { target: target } = e;
                if (!(e instanceof InputEvent) || e.isComposing || !(target instanceof HTMLElement)) return;
                if (e.inputType === 'historyUndo' && ((_target$textContent2 = target.textContent) === null || _target$textContent2 === void 0 ? void 0 : _target$textContent2.length) === 1) {
                    e.preventDefault();
                    e.stopPropagation();
                    close();
                    return;
                }
            };
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element.addEventListener('input', onInput);
        }
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element.addEventListener('focusout', onFocusOut);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element.addEventListener('focusin', onFocusIn);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element.addEventListener('keydown', keyDown);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element.addEventListener('beforeinput', beforeinput);
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element.addEventListener('paste', onPaste);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element.removeEventListener('focusout', onFocusOut);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element.removeEventListener('focusin', onFocusIn);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element.removeEventListener('keydown', keyDown);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element.removeEventListener('beforeinput', beforeinput);
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element.removeEventListener('paste', onPaste);
            if (browser.safari) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element.removeEventListener('input', onInput);
        };
    }, [
        triggerQueryPrefix,
        cleanedInputContent,
        onQueryFocus,
        cancel,
        checkKeyEvent,
        editorView.state,
        isEditorControlsEnabled,
        shouldKeepOpenOnRegisteredMenu
    ]);
    (0, $bSJIT.useLayoutEffect)(()=>{
        const hasReopenQuery = typeof reopenQuery === 'string' && reopenQuery.trim().length > 0;
        if (ref.current && forceFocus) {
            // Ignored via go/ees005
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            setQuery(hasReopenQuery ? reopenQuery : null);
            const focusQuery = ()=>{
                if (!(ref !== null && ref !== void 0 && ref.current)) return;
                const sel = window.getSelection();
                if (sel && hasReopenQuery && ref.current.lastChild instanceof Text) {
                    const lastChild = ref.current.lastChild;
                    const range = document.createRange();
                    range.setStart(ref.current.lastChild, lastChild.length);
                    range.collapse(true);
                    sel.removeAllRanges();
                    sel.addRange(range);
                }
                ref.current.focus();
                setInFocus(true);
            };
            if ((0, $3y2s4.isExperimentEnabled)('platform_editor_typeahead_early_focus')) return $be0594cf7f1c6dac$export$714483c9a7c1d2b(ref, focusQuery);
            requestAnimationFrame(focusQuery);
        }
    }, [
        forceFocus,
        reopenQuery
    ]);
    const assistiveHintID = (0, $4vgtg.TYPE_AHEAD_DECORATION_ELEMENT_ID) + '__assistiveHint';
    const intl = (0, $4vLTk.default)();
    return /*#__PURE__*/ (0, $9dQre.jsx)((0, $bSJIT.Fragment), null, triggerQueryPrefix, /*#__PURE__*/ (0, $9dQre.jsx)("span", {
        css: [
            $be0594cf7f1c6dac$var$querySpanStyles
        ],
        contentEditable: true,
        ref: ref,
        onKeyUp: onKeyUp,
        tabIndex: -1,
        role: "combobox",
        "aria-activedescendant": activeDescendantId,
        "aria-controls": listId ?? (0, $4vgtg.TYPE_AHEAD_DECORATION_ELEMENT_ID),
        "aria-autocomplete": "list",
        "aria-expanded": resolvedOptionCount !== 0,
        "aria-labelledby": assistiveHintID,
        suppressContentEditableWarning: true,
        "data-query-prefix": triggerQueryPrefix,
        "data-place-holder": intl.formatMessage((0, $ex2cJ.typeAheadListMessages).quickInsertInputPlaceholderLabel)
    }, query === null ? /*#__PURE__*/ (0, $9dQre.jsx)("input", {
        ref: inputRef,
        type: "text",
        "aria-label": intl.formatMessage($be0594cf7f1c6dac$var$getAriaLabel(triggerQueryPrefix, intl))
    }) : query), /*#__PURE__*/ (0, $9dQre.jsx)("span", {
        id: assistiveHintID,
        style: {
            display: 'none'
        }
    }, intl.formatMessage((0, $ex2cJ.typeAheadListMessages).inputQueryAssistiveLabel)), /*#__PURE__*/ (0, $9dQre.jsx)((0, $9L0hy.AssistiveText), {
        assistiveText: resolvedOptionCount === 0 ? intl.formatMessage((0, $ex2cJ.typeAheadListMessages).noSearchResultsLabel, {
            itemsLength: resolvedOptionCount
        }) : '',
        isInFocus: resolvedOptionCount === 0 || isInFocus,
        id: (0, $4vgtg.TYPE_AHEAD_DECORATION_ELEMENT_ID)
    }));
});
$be0594cf7f1c6dac$export$efc9b80896822e63.displayName = 'InputQuery';

});
parcelRegister("9L0hy", function(module, exports) {
$parcel$export(module.exports, "AssistiveText", () => $6692c39a486112e0$export$568f929105953699);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $inh7J = parcelRequire("inh7J");
function $6692c39a486112e0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $6692c39a486112e0$var$assitiveTextStyles = {
    name: "v66mgv",
    styles: "border:0;clip:rect(0 0 0 0);height:1px;marginbottom:-1px;marginright:-1px;overflow:hidden;padding:0;position:absolute;whitespace:nowrap;width:1px"
};
const $6692c39a486112e0$export$568f929105953699 = ({ assistiveText: assistiveText = '', isInFocus: isInFocus = false, id: id = '', statusDebounceMillis: _statusDebounceMillis = 1400 })=>{
    const [bump, setBump] = (0, $bSJIT.useState)(false);
    const [debounced, setDebounced] = (0, $bSJIT.useState)(false);
    const [silenced, setSilenced] = (0, $bSJIT.useState)(false);
    const debounceStatusUpdate = (0, $bSJIT.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($inh7J)))(()=>{
            const shouldSilence = !isInFocus;
            setBump((prevBump)=>!prevBump);
            setDebounced(true);
            setSilenced(shouldSilence);
        }), [
        isInFocus
    ]);
    (0, $bSJIT.useEffect)(()=>{
        if (!debounced) {
            // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- Ignored via go/ees017 (to be fixed)
            debounceStatusUpdate();
            return ()=>{
                debounceStatusUpdate.cancel();
            };
        }
    }, [
        assistiveText,
        isInFocus,
        debounced,
        debounceStatusUpdate
    ]);
    (0, $bSJIT.useEffect)(()=>{
        if (debounced) {
            // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- Ignored via go/ees017 (to be fixed)
            setBump((prevBump)=>!prevBump);
            // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- Ignored via go/ees017 (to be fixed)
            setDebounced(true);
            // eslint-disable-next-line @atlassian/perf-linting/no-chain-state-updates -- Ignored via go/ees017 (to be fixed)
            setSilenced(!isInFocus);
        }
    }, [
        assistiveText,
        isInFocus,
        debounced
    ]);
    return /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        css: $6692c39a486112e0$var$assitiveTextStyles
    }, /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        "data-testid": id + '__status--A',
        id: id + '__status--A',
        role: "status",
        "aria-atomic": "true",
        "aria-live": "polite"
    }, !silenced && debounced && bump ? assistiveText : ''), /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        "data-testid": id + '__status--B',
        id: id + '__status--B',
        role: "status",
        "aria-atomic": "true",
        "aria-live": "polite"
    }, !silenced && debounced && !bump ? assistiveText : ''));
};

});


parcelRegister("72Twt", function(module, exports) {
$parcel$export(module.exports, "RegisteredTypeAheadMenu", () => $881015033a19d52b$export$45c92bf768c8130);
/* RegisteredTypeAheadMenu.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");

var $9fU1q = parcelRequire("9fU1q");

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $5zk80 = parcelRequire("5zk80");

var $A9iSs = parcelRequire("A9iSs");
var $b1eGy = parcelRequire("b1eGy");
var $i8Hch = parcelRequire("i8Hch");

var $e3nP3 = parcelRequire("e3nP3");

var $88sf5 = parcelRequire("88sf5");

var $2WXs5 = parcelRequire("2WXs5");

var $3xPFq = parcelRequire("3xPFq");

var $5bbjm = parcelRequire("5bbjm");

var $29Z7Q = parcelRequire("29Z7Q");

var $6A5XB = parcelRequire("6A5XB");

var $eMjaf = parcelRequire("eMjaf");

var $dmWk4 = parcelRequire("dmWk4");

var $koXel = parcelRequire("koXel");

var $7P2Ig = parcelRequire("7P2Ig");
const $881015033a19d52b$var$styles = {
    menu: "_19itglyw _2rko1mok _1reo15vq _18m915vq _bfhk1bhr _r06hglyw _vchhusvi _16qs130s _1q51idpf _85i5idpf _1bsbnklw"
};
const $881015033a19d52b$var$DEFAULT_MENU_MAX_HEIGHT = 480;
const $881015033a19d52b$var$MENU_WIDTH = 320;
const $881015033a19d52b$var$POPUP_OFFSET = [
    0,
    8
];
const $881015033a19d52b$var$EMPTY_COMPONENTS = [];
const $881015033a19d52b$var$subscribeToNothing = ()=>()=>{};
const $881015033a19d52b$export$45c92bf768c8130 = ({ anchorElement: anchorElement, api: api, cancel: cancel, editorView: editorView, forceFocus: forceFocus, maxHeight: maxHeight = $881015033a19d52b$var$DEFAULT_MENU_MAX_HEIGHT, onClose: onClose, onUndoRedo: onUndoRedo, popupsBoundariesElement: popupsBoundariesElement, popupsMountPoint: popupsMountPoint, popupsScrollableElement: popupsScrollableElement, query: query, reopenQuery: reopenQuery, setQuery: setQuery, surface: surface, triggerHandler: triggerHandler })=>{
    var _api$uiControlRegistr2, _api$analytics;
    const menuHeight = (0, $e3nP3.useMenuPopupSizing)({
        target: anchorElement,
        boundariesElement: popupsBoundariesElement,
        scrollableElement: popupsScrollableElement,
        maxHeight: maxHeight,
        offset: $881015033a19d52b$var$POPUP_OFFSET[1]
    });
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const generatedId = (0, $bSJIT.useId)();
    const listId = `${surface.listIdPrefix}-${generatedId}`;
    const menuRef = (0, $bSJIT.useRef)(null);
    const [typeAheadSurfaceContext] = (0, $bSJIT.useState)(()=>({
            menuOpenId: Symbol('type-ahead-menu-open')
        }));
    const surfaceContext = (0, $bSJIT.useMemo)(()=>(0, $29Z7Q.createSurfaceContext)((0, $3xPFq.TYPE_AHEAD_SURFACE_CONTEXT), typeAheadSurfaceContext), [
        typeAheadSurfaceContext
    ]);
    const [selectedItemIndex, setSelectedItemIndex] = (0, $bSJIT.useState)(0);
    const selectedItemIndexRef = (0, $bSJIT.useRef)(selectedItemIndex);
    const getComponents = (0, $bSJIT.useCallback)(()=>{
        var _api$uiControlRegistr;
        const components = api === null || api === void 0 || (_api$uiControlRegistr = api.uiControlRegistry) === null || _api$uiControlRegistr === void 0 ? void 0 : _api$uiControlRegistr.actions.getComponents(surface.root.key);
        return components !== null && components !== void 0 && components.length ? components : $881015033a19d52b$var$EMPTY_COMPONENTS;
    }, [
        api,
        surface.root.key
    ]);
    const components = (0, $bSJIT.useSyncExternalStore)((api === null || api === void 0 || (_api$uiControlRegistr2 = api.uiControlRegistry) === null || _api$uiControlRegistr2 === void 0 ? void 0 : _api$uiControlRegistr2.actions.subscribe) ?? $881015033a19d52b$var$subscribeToNothing, getComponents, getComponents);
    const hasSectionOverflowItems = (0, $bSJIT.useMemo)(()=>components.some(({ key: key })=>(0, $2WXs5.isSectionOverflowItemKey)(key)), [
        components
    ]);
    const menuModel = (0, $bSJIT.useMemo)(()=>(0, $A9iSs.getQuickInsertMenuModel)({
            components: components,
            formatMessage: formatMessage,
            getItemRank: triggerHandler.getRegisteredItemRank,
            query: query,
            rootComponent: surface.root,
            selectCategoryItems: hasSectionOverflowItems ? (0, $i8Hch.selectQuickInsertCategoryItems) : undefined,
            surfaceContext: surfaceContext
        }), [
        components,
        formatMessage,
        hasSectionOverflowItems,
        query,
        surfaceContext,
        surface.root,
        triggerHandler.getRegisteredItemRank
    ]);
    const rows = (0, $bSJIT.useMemo)(()=>(0, $b1eGy.getQuickInsertMenuRows)(menuModel), [
        menuModel
    ]);
    const searchResultCount = (0, $bSJIT.useMemo)(()=>menuModel.sections.reduce((count, section)=>count + section.filter(({ key: key, type: type })=>type === 'menu-item' && !(0, $2WXs5.isSectionOverflowItemKey)(key)).length, 0), [
        menuModel.sections
    ]);
    const flushSearchAnalytics = (0, $88sf5.useQuickInsertSearchAnalytics)({
        fireAnalyticsEvent: api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions.fireAnalyticsEvent,
        query: query,
        resultCount: searchResultCount,
        surface: 'typeahead'
    });
    const closeMenu = (0, $bSJIT.useCallback)(()=>{
        flushSearchAnalytics();
        onClose();
    }, [
        flushSearchAnalytics,
        onClose
    ]);
    const [previewActivation, setPreviewActivation] = (0, $bSJIT.useState)();
    const activePreviewItemKey = (previewActivation === null || previewActivation === void 0 ? void 0 : previewActivation.menuModel) === menuModel ? previewActivation.itemKey : undefined;
    const selectableRowIndexes = (0, $bSJIT.useMemo)(()=>rows.flatMap((registration, rowIndex)=>registration.type === 'menu-item' ? [
                rowIndex
            ] : []), [
        rows
    ]);
    const selectableRowKeys = selectableRowIndexes.map((index)=>{
        var _rows$index;
        return (_rows$index = rows[index]) === null || _rows$index === void 0 ? void 0 : _rows$index.key;
    }).join(',');
    const selectableItemCount = selectableRowIndexes.length + (menuModel.footer ? 1 : 0);
    (0, $bSJIT.useLayoutEffect)(()=>{
        const initialItemIndex = selectableItemCount > 0 ? 0 : -1;
        selectedItemIndexRef.current = initialItemIndex;
        setSelectedItemIndex(initialItemIndex);
    }, [
        query,
        selectableItemCount,
        selectableRowKeys
    ]);
    (0, $bSJIT.useLayoutEffect)(()=>{
        setPreviewActivation(undefined);
    }, [
        menuModel,
        query
    ]);
    const selectActiveItem = (0, $bSJIT.useCallback)((_mode)=>{
        const rowIndex = selectableRowIndexes[selectedItemIndex];
        const selectedId = rowIndex !== undefined ? (0, $dmWk4.getTypeAheadItemId)(listId, rowIndex) : menuModel.footer && selectedItemIndex === selectableRowIndexes.length ? (0, $eMjaf.getTypeAheadGlobalViewMoreId)(listId) : undefined;
        if (selectedId) {
            var _menuRef$current;
            (_menuRef$current = menuRef.current) === null || _menuRef$current === void 0 || (_menuRef$current = _menuRef$current.ownerDocument.getElementById(selectedId)) === null || _menuRef$current === void 0 || _menuRef$current.click();
        }
    }, [
        listId,
        menuModel.footer,
        selectableRowIndexes,
        selectedItemIndex
    ]);
    const setKeyboardPreview = (0, $bSJIT.useCallback)((itemIndex)=>{
        const rowIndex = selectableRowIndexes[itemIndex];
        const registration = rowIndex === undefined ? undefined : rows[rowIndex];
        setPreviewActivation((registration === null || registration === void 0 ? void 0 : registration.type) === 'menu-item' ? {
            itemKey: registration.key,
            menuModel: menuModel,
            source: 'keyboard'
        } : undefined);
    }, [
        menuModel,
        rows,
        selectableRowIndexes
    ]);
    const selectNextItem = (0, $bSJIT.useCallback)(()=>{
        const currentIndex = selectedItemIndexRef.current;
        const nextIndex = selectableItemCount === 0 ? -1 : currentIndex < 0 || currentIndex === selectableItemCount - 1 ? 0 : currentIndex + 1;
        selectedItemIndexRef.current = nextIndex;
        setSelectedItemIndex(nextIndex);
        setKeyboardPreview(nextIndex);
    }, [
        selectableItemCount,
        setKeyboardPreview
    ]);
    const selectPreviousItem = (0, $bSJIT.useCallback)(()=>{
        const currentIndex = selectedItemIndexRef.current;
        const previousIndex = selectableItemCount === 0 ? -1 : currentIndex <= 0 ? selectableItemCount - 1 : currentIndex - 1;
        selectedItemIndexRef.current = previousIndex;
        setSelectedItemIndex(previousIndex);
        setKeyboardPreview(previousIndex);
    }, [
        selectableItemCount,
        setKeyboardPreview
    ]);
    const onItemHover = (0, $bSJIT.useCallback)((itemIndex, itemKey)=>{
        selectedItemIndexRef.current = itemIndex;
        setSelectedItemIndex(itemIndex);
        setPreviewActivation((current)=>{
            if ((current === null || current === void 0 ? void 0 : current.itemKey) === itemKey && (current === null || current === void 0 ? void 0 : current.menuModel) === menuModel && (current === null || current === void 0 ? void 0 : current.source) === 'pointer') return current;
            return itemKey ? {
                itemKey: itemKey,
                menuModel: menuModel,
                source: 'pointer'
            } : undefined;
        });
    }, [
        menuModel
    ]);
    const onItemLeave = (0, $bSJIT.useCallback)((itemKey)=>{
        setPreviewActivation((current)=>(current === null || current === void 0 ? void 0 : current.source) === 'pointer' && current.itemKey === itemKey ? undefined : current);
    }, []);
    const onItemVisibilityChange = (0, $bSJIT.useCallback)((itemKey, isVisible)=>{
        if (!isVisible) setPreviewActivation((current)=>(current === null || current === void 0 ? void 0 : current.source) === 'pointer' && current.itemKey === itemKey ? undefined : current);
    }, []);
    const typeAheadContextValue = (0, $bSJIT.useMemo)(()=>({
            activePreviewItemKey: activePreviewItemKey,
            api: api,
            editorView: editorView,
            inputMethod: surface.inputMethod,
            menuOpenId: typeAheadSurfaceContext.menuOpenId,
            onClose: closeMenu,
            popupsMountPoint: popupsMountPoint,
            query: query,
            surfaceContext: surfaceContext,
            triggerHandler: triggerHandler
        }), [
        activePreviewItemKey,
        api,
        editorView,
        closeMenu,
        popupsMountPoint,
        query,
        surface.inputMethod,
        surfaceContext,
        triggerHandler,
        typeAheadSurfaceContext
    ]);
    const noOp = (0, $bSJIT.useCallback)(()=>{}, []);
    const SurfaceProvider = surface.Provider;
    return /*#__PURE__*/ (0, $dc70d.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $6A5XB.InputQuery), {
                activeDescendantId: selectableRowIndexes[selectedItemIndex] !== undefined ? (0, $dmWk4.getTypeAheadItemId)(listId, selectableRowIndexes[selectedItemIndex]) : menuModel.footer && selectedItemIndex === selectableRowIndexes.length ? (0, $eMjaf.getTypeAheadGlobalViewMoreId)(listId) : undefined,
                cancel: cancel,
                editorView: editorView,
                forceFocus: forceFocus,
                listId: listId,
                onItemSelect: selectActiveItem,
                onQueryChange: setQuery,
                onQueryFocus: noOp,
                onUndoRedo: onUndoRedo,
                optionCount: selectableItemCount,
                reopenQuery: reopenQuery,
                selectNextItem: selectNextItem,
                selectPreviousItem: selectPreviousItem,
                shouldKeepOpenOnRegisteredMenu: true,
                triggerQueryPrefix: triggerHandler.trigger
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $5zk80.default), {
                ariaLabel: null,
                boundariesElement: popupsBoundariesElement,
                fitHeight: menuHeight,
                fitWidth: $881015033a19d52b$var$MENU_WIDTH,
                mountTo: popupsMountPoint,
                offset: $881015033a19d52b$var$POPUP_OFFSET,
                preventOverflow: true,
                scrollableElement: popupsScrollableElement,
                target: anchorElement,
                zIndex: (0, $5bbjm.akEditorFloatingDialogZIndex),
                children: /*#__PURE__*/ (0, $dc70d.jsx)("div", {
                    ref: menuRef,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Parent overlays use this class to restore pointer interaction.
                    className: (0, $9fU1q.default)([
                        $881015033a19d52b$var$styles.menu,
                        "fabric-editor-typeahead"
                    ]),
                    "data-registered-type-ahead-menu": "",
                    "data-testid": "registered-type-ahead-menu",
                    children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $7P2Ig.TypeAheadProvider), {
                        value: typeAheadContextValue,
                        children: /*#__PURE__*/ (0, $dc70d.jsx)(SurfaceProvider, {
                            children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $koXel.TypeAheadMenuRenderer), {
                                Item: surface.Item,
                                listLabel: surface.listLabel,
                                listId: listId,
                                maxHeight: Math.max(0, menuHeight),
                                model: menuModel,
                                query: query,
                                hasScrollPadding: true,
                                onItemHover: onItemHover,
                                onItemLeave: onItemLeave,
                                onItemVisibilityChange: onItemVisibilityChange,
                                selectedItemIndex: selectedItemIndex
                            })
                        })
                    })
                })
            })
        ]
    });
};

});
parcelRegister("eMjaf", function(module, exports) {
$parcel$export(module.exports, "getTypeAheadGlobalViewMoreId", () => $4d1994c0f508623a$export$d5cc5bf265d75b59);
const $4d1994c0f508623a$export$d5cc5bf265d75b59 = (listId)=>`${listId}-view-all`;

});

parcelRegister("dmWk4", function(module, exports) {
$parcel$export(module.exports, "getTypeAheadItemId", () => $1b688be89a2e3ee7$export$320b63df33dc0c73);
const $1b688be89a2e3ee7$export$320b63df33dc0c73 = (listId, itemIndex)=>`${listId}--${itemIndex}`;

});

parcelRegister("koXel", function(module, exports) {
$parcel$export(module.exports, "TypeAheadMenuRenderer", () => $303806e1a9202c10$export$ee6db55bff9a708b);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $afyUO = parcelRequire("afyUO");

var $dASxq = parcelRequire("dASxq");

var $dkZQn = parcelRequire("dkZQn");

var $b1eGy = parcelRequire("b1eGy");

var $bLecl = parcelRequire("bLecl");

var $ex2cJ = parcelRequire("ex2cJ");

var $9PwDt = parcelRequire("9PwDt");

var $8aT4G = parcelRequire("8aT4G");

var $4PFpq = parcelRequire("4PFpq");

var $eMjaf = parcelRequire("eMjaf");

var $lPEbK = parcelRequire("lPEbK");

var $jXlar = parcelRequire("jXlar");
const $303806e1a9202c10$var$LIST_WIDTH = 320;
const $303806e1a9202c10$var$ESTIMATED_ROW_HEIGHT = 44;
// 44px item + 1px separator.
const $303806e1a9202c10$var$MENU_FOOTER_HEIGHT = 45;
const $303806e1a9202c10$var$MENU_FOOTER_HEIGHT_WITH_SCROLL_PADDING = 51;
const $303806e1a9202c10$export$ee6db55bff9a708b = ({ Item: Item, listLabel: listLabel, listId: listId, maxHeight: maxHeight, model: model, query: query = '', hasScrollPadding: hasScrollPadding = false, onItemHover: onItemHover, onItemLeave: onItemLeave, onItemVisibilityChange: onItemVisibilityChange, selectedItemIndex: selectedItemIndex })=>{
    var _model$fallbackItems;
    const intl = (0, $4vLTk.default)();
    const listRef = (0, $bSJIT.useRef)(null);
    const rows = (0, $bSJIT.useMemo)(()=>(0, $b1eGy.getQuickInsertMenuRows)(model), [
        model
    ]);
    const cache = (0, $bSJIT.useMemo)(()=>new (0, $afyUO.CellMeasurerCache)({
            defaultHeight: $303806e1a9202c10$var$ESTIMATED_ROW_HEIGHT,
            fixedWidth: true
        }), []);
    const itemIndexByRowIndex = (0, $bSJIT.useMemo)(()=>{
        const indexes = new Map();
        let itemIndex = 0;
        rows.forEach((registration, rowIndex)=>{
            if (registration.type === 'menu-item') indexes.set(rowIndex, itemIndex++);
        });
        return indexes;
    }, [
        rows
    ]);
    const selectedRowIndex = (0, $bSJIT.useMemo)(()=>{
        for (const [rowIndex, itemIndex] of itemIndexByRowIndex){
            if (itemIndex === selectedItemIndex) return rowIndex;
        }
        return -1;
    }, [
        itemIndexByRowIndex,
        selectedItemIndex
    ]);
    const rowKeySignature = (0, $bSJIT.useMemo)(()=>rows.map(({ key: key, type: type })=>`${type}:${key}`).join('\0'), [
        rows
    ]);
    const { height: measuredHeight, updateHeight: updateHeight } = (0, $bLecl.useMenuListHeight)(cache, rows.length, rowKeySignature);
    (0, $bSJIT.useLayoutEffect)(()=>{
        var _listRef$current, _listRef$current2;
        cache.clearAll();
        (_listRef$current = listRef.current) === null || _listRef$current === void 0 || _listRef$current.recomputeRowHeights();
        (_listRef$current2 = listRef.current) === null || _listRef$current2 === void 0 || _listRef$current2.scrollToPosition(0);
    }, [
        cache,
        rowKeySignature
    ]);
    (0, $bSJIT.useLayoutEffect)(()=>{
        if (selectedRowIndex >= 0) {
            var _listRef$current3;
            (_listRef$current3 = listRef.current) === null || _listRef$current3 === void 0 || _listRef$current3.scrollToRow(selectedRowIndex);
        }
    }, [
        selectedRowIndex
    ]);
    const renderRow = (0, $4PFpq.createTypeAheadRowRenderer)({
        cache: cache,
        onMeasured: updateHeight,
        itemIndexByRowIndex: itemIndexByRowIndex,
        Item: Item,
        listId: listId,
        onItemHover: onItemHover,
        onItemLeave: onItemLeave,
        onItemVisibilityChange: onItemVisibilityChange,
        rows: rows,
        hasScrollPadding: hasScrollPadding,
        selectedItemIndex: selectedItemIndex
    });
    const footerItemIndex = itemIndexByRowIndex.size;
    const onFooterItemHover = (0, $bSJIT.useCallback)(()=>onItemHover(footerItemIndex), [
        footerItemIndex,
        onItemHover
    ]);
    if (!model.root) return null;
    const RootComponent = model.root.component ?? (0, $lPEbK.PassThrough);
    const listMaxHeight = Math.max(0, maxHeight - (model.footer ? hasScrollPadding ? $303806e1a9202c10$var$MENU_FOOTER_HEIGHT_WITH_SCROLL_PADDING : $303806e1a9202c10$var$MENU_FOOTER_HEIGHT : 0));
    const hasListboxContent = rows.length > 0 || model.footer !== undefined;
    return /*#__PURE__*/ (0, $dc70d.jsx)(RootComponent, {
        children: /*#__PURE__*/ (0, $dc70d.jsxs)((0, $9PwDt.Box), {
            "aria-label": hasListboxContent ? intl.formatMessage(listLabel) : undefined,
            id: listId,
            role: hasListboxContent ? 'listbox' : undefined,
            children: [
                rows.length > 0 ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $dASxq.List), {
                    containerRole: "presentation",
                    height: Math.min(measuredHeight, listMaxHeight),
                    onRowsRendered: updateHeight,
                    overscanRowCount: 3,
                    ref: listRef,
                    role: "presentation",
                    rowCount: rows.length,
                    rowHeight: cache.rowHeight,
                    rowRenderer: renderRow,
                    scrollToAlignment: "auto",
                    width: $303806e1a9202c10$var$LIST_WIDTH
                }) : query !== '' && ((_model$fallbackItems = model.fallbackItems) === null || _model$fallbackItems === void 0 ? void 0 : _model$fallbackItems.length) === 0 ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $dkZQn.QuickInsertEmptyState), {
                    mode: "inline",
                    spacing: "spacious"
                }) : model.fallbackItems === undefined ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
                    paddingBlock: "space.150",
                    paddingInline: "space.250",
                    role: "group",
                    children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $8aT4G.Text), {
                        align: "center",
                        as: "p",
                        children: intl.formatMessage((0, $ex2cJ.typeAheadListMessages).emptySearchResults)
                    })
                }) : null,
                model.footer && /*#__PURE__*/ (0, $dc70d.jsx)((0, $jXlar.TypeAheadMenuFooter), {
                    id: (0, $eMjaf.getTypeAheadGlobalViewMoreId)(listId),
                    isSelected: selectedItemIndex === footerItemIndex,
                    Item: Item,
                    onMouseMove: onFooterItemHover,
                    registration: model.footer,
                    hasScrollPadding: hasScrollPadding
                })
            ]
        })
    });
};

});
parcelRegister("4PFpq", function(module, exports) {
$parcel$export(module.exports, "createTypeAheadRowRenderer", () => $087c701a7c851c41$export$3952e20305e1e33e);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $afyUO = parcelRequire("afyUO");

var $9PwDt = parcelRequire("9PwDt");

var $kMlEB = parcelRequire("kMlEB");

var $cWQFi = parcelRequire("cWQFi");

var $2evBA = parcelRequire("2evBA");
const $087c701a7c851c41$var$noOp = ()=>{};
const $087c701a7c851c41$export$3952e20305e1e33e = ({ cache: cache, hasScrollPadding: hasScrollPadding = false, onMeasured: onMeasured, itemIndexByRowIndex: itemIndexByRowIndex, Item: Item, listId: listId, onItemHover: onItemHover, onItemLeave: onItemLeave, onItemVisibilityChange: onItemVisibilityChange, rows: rows, selectedItemIndex: selectedItemIndex })=>({ index: index, key: key, parent: parent, style: style, isScrolling: isScrolling, isVisible: isVisible })=>{
        const registration = rows[index];
        if (!registration) return null;
        const itemIndex = itemIndexByRowIndex.get(index);
        const rowContent = registration.type === 'menu-section' ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $2evBA.TypeAheadSectionRow), {
            registration: registration
        }) : /*#__PURE__*/ (0, $dc70d.jsx)((0, $cWQFi.TypeAheadItemRow), {
            Item: Item,
            isSelected: itemIndex === selectedItemIndex,
            itemIndex: itemIndex ?? 0,
            listId: listId,
            onItemHover: onItemHover,
            onItemLeave: onItemLeave,
            onItemVisibilityChange: onItemVisibilityChange,
            isVisible: isVisible,
            registration: registration,
            rowIndex: index
        });
        return /*#__PURE__*/ (0, $dc70d.jsx)((0, $afyUO.CellMeasurer), {
            cache: cache,
            parent: parent,
            columnIndex: 0,
            rowIndex: index,
            children: ({ measure: measure })=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $kMlEB.ListRow), {
                    index: index,
                    isScrolling: isScrolling,
                    isVisible: isVisible,
                    measure: measure,
                    onMeasured: onMeasured,
                    onMouseMove: $087c701a7c851c41$var$noOp,
                    style: style,
                    children: hasScrollPadding ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
                        paddingBlockStart: index === 0 ? 'space.100' : undefined,
                        paddingBlockEnd: index === rows.length - 1 ? 'space.100' : undefined,
                        children: rowContent
                    }) : rowContent
                })
        }, key);
    };

});
parcelRegister("kMlEB", function(module, exports) {
$parcel$export(module.exports, "ListRow", () => $2c4467847f9bcc77$export$c36f87108246a02a);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");
const $2c4467847f9bcc77$export$c36f87108246a02a = /*#__PURE__*/ (0, $bSJIT.forwardRef)(({ children: children, measure: measure, onMeasured: onMeasured, index: index, style: style, isVisible: isVisible, isScrolling: isScrolling, onMouseMove: onMouseMove }, ref)=>{
    const childElementRef = (0, $bSJIT.useRef)(null);
    (0, $bSJIT.useEffect)(()=>{
        // Do not measure if the row is not visible or is scrolling for performance reasons.
        if (!childElementRef.current || !isVisible || isScrolling) return;
        const observer = new ResizeObserver(()=>{
            measure();
            onMeasured === null || onMeasured === void 0 || onMeasured();
        });
        observer.observe(childElementRef.current);
        return ()=>observer.disconnect();
    }, [
        isScrolling,
        isVisible,
        measure,
        onMeasured
    ]);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        ref: ref,
        style: style,
        "data-index": index,
        children: /*#__PURE__*/ (0, $dc70d.jsx)("div", {
            ref: childElementRef,
            "data-testid": `list-item-height-observed-${index}`,
            onMouseMove: onMouseMove,
            children: children
        })
    }));
});

});

parcelRegister("cWQFi", function(module, exports) {
$parcel$export(module.exports, "TypeAheadItemRow", () => $0a411c121fa8591c$export$8715aee5e047a437);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $dmWk4 = parcelRequire("dmWk4");
const $0a411c121fa8591c$export$8715aee5e047a437 = ({ isSelected: isSelected, itemIndex: itemIndex, Item: Item, listId: listId, onItemHover: onItemHover, onItemLeave: onItemLeave, onItemVisibilityChange: onItemVisibilityChange, registration: registration, rowIndex: rowIndex, isVisible: isVisible })=>{
    const onMouseMove = (0, $bSJIT.useCallback)(()=>onItemHover(itemIndex, registration.key), [
        itemIndex,
        onItemHover,
        registration.key
    ]);
    const onMouseLeave = (0, $bSJIT.useCallback)(()=>onItemLeave(registration.key), [
        onItemLeave,
        registration.key
    ]);
    const onBlur = (0, $bSJIT.useCallback)((event)=>{
        if (!event.currentTarget.contains(event.relatedTarget)) onItemLeave(registration.key);
    }, [
        onItemLeave,
        registration.key
    ]);
    (0, $bSJIT.useLayoutEffect)(()=>{
        onItemVisibilityChange(registration.key, isVisible);
        return ()=>onItemVisibilityChange(registration.key, false);
    }, [
        isVisible,
        onItemVisibilityChange,
        registration.key
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)("div", {
        onBlur: onBlur,
        onMouseLeave: onMouseLeave,
        onMouseMove: onMouseMove,
        children: /*#__PURE__*/ (0, $dc70d.jsx)(Item, {
            id: (0, $dmWk4.getTypeAheadItemId)(listId, rowIndex),
            isSelected: isSelected,
            registration: registration
        })
    });
};

});

parcelRegister("2evBA", function(module, exports) {
$parcel$export(module.exports, "TypeAheadSectionRow", () => $0486f03892f5c67d$export$87a2b9822a704853);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $lPEbK = parcelRequire("lPEbK");
const $0486f03892f5c67d$export$87a2b9822a704853 = ({ registration: registration })=>{
    const Component = registration.component ?? (0, $lPEbK.PassThrough);
    return /*#__PURE__*/ (0, $dc70d.jsx)(Component, {
        children: null
    });
};

});
parcelRegister("lPEbK", function(module, exports) {
$parcel$export(module.exports, "PassThrough", () => $dc7bdc6dafc1fe28$export$b5d6a35b0cce4297);
const $dc7bdc6dafc1fe28$export$b5d6a35b0cce4297 = ({ children: children })=>children;

});



parcelRegister("jXlar", function(module, exports) {
$parcel$export(module.exports, "TypeAheadMenuFooter", () => $f55eb656a7db33af$export$a1e87b60326ef5d2);
/* TypeAheadMenuFooter.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $9PwDt = parcelRequire("9PwDt");
const $f55eb656a7db33af$var$styles = {
    footer: "_1i531l7x _15a5nqa1 _uwhke4h9"
};
const $f55eb656a7db33af$export$a1e87b60326ef5d2 = ({ id: id, isSelected: isSelected, Item: Item, onMouseMove: onMouseMove, registration: registration, hasScrollPadding: hasScrollPadding = false })=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
        onMouseMove: onMouseMove,
        paddingBlockEnd: hasScrollPadding ? 'space.075' : undefined,
        xcss: $f55eb656a7db33af$var$styles.footer,
        children: /*#__PURE__*/ (0, $dc70d.jsx)(Item, {
            id: id,
            isSelected: isSelected,
            registration: registration
        })
    });

});


parcelRegister("7P2Ig", function(module, exports) {
$parcel$export(module.exports, "TypeAheadProvider", () => $377d0b2548a2c512$export$3e26cf75568c2e04);

var $kFjbv = parcelRequire("kFjbv");
const $377d0b2548a2c512$export$3e26cf75568c2e04 = (0, $kFjbv.TypeAheadContext).Provider;

});
parcelRegister("kFjbv", function(module, exports) {
$parcel$export(module.exports, "TypeAheadContext", () => $544b346538ce99f9$export$7488bf1bf6aaa4fb);

var $bSJIT = parcelRequire("bSJIT");
const $544b346538ce99f9$export$7488bf1bf6aaa4fb = (0, $bSJIT.createContext)(null);

});



parcelRegister("b3FBL", function(module, exports) {
$parcel$export(module.exports, "getTypeAheadSurface", () => $70ef1f487947b464$export$4ac2535e78a0590b);

var $g6Qq4 = parcelRequire("g6Qq4");

var $9woaI = parcelRequire("9woaI");

var $aaLLt = parcelRequire("aaLLt");

var $ex2cJ = parcelRequire("ex2cJ");

var $3y2s4 = parcelRequire("3y2s4");

var $UOOCB = parcelRequire("UOOCB");

var $5i4QA = parcelRequire("5i4QA");
const $70ef1f487947b464$var$quickInsertSurface = {
    inputMethod: (0, $g6Qq4.INPUT_METHOD).QUICK_INSERT,
    Item: (0, $UOOCB.TypeAheadQuickInsertItem),
    listIdPrefix: 'quick-insert-menu',
    listLabel: (0, $ex2cJ.typeAheadListMessages).quickInsertInputLabel,
    Provider: (0, $5i4QA.TypeAheadQuickInsertProvider),
    root: (0, $9woaI.MENU)
};
const $70ef1f487947b464$export$4ac2535e78a0590b = (id)=>{
    if (id === (0, $aaLLt.TypeAheadAvailableNodes).QUICK_INSERT && (0, $3y2s4.isExperimentEnabled)('platform_editor_slash_command')) return $70ef1f487947b464$var$quickInsertSurface;
    return undefined;
};

});
parcelRegister("UOOCB", function(module, exports) {
$parcel$export(module.exports, "TypeAheadQuickInsertItem", () => $89cf23bad58ec780$export$35133215e25e10c7);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $5PGJG = parcelRequire("5PGJG");

var $efcwg = parcelRequire("efcwg");

var $lPEbK = parcelRequire("lPEbK");
const $89cf23bad58ec780$export$35133215e25e10c7 = ({ id: id, isSelected: isSelected, registration: registration })=>{
    const quickInsertContext = (0, $efcwg.useQuickInsertContext)();
    const Component = registration.component ?? (0, $lPEbK.PassThrough);
    const contextValue = (0, $bSJIT.useMemo)(()=>({
            activePreviewItemKey: quickInsertContext.activePreviewItemKey,
            editorView: quickInsertContext.editorView,
            isOffline: quickInsertContext.isOffline,
            menuOpenId: quickInsertContext.menuOpenId,
            popupsMountPoint: quickInsertContext.popupsMountPoint,
            surfaceContext: quickInsertContext.surfaceContext,
            surface: 'typeahead',
            item: {
                id: id,
                isPreviewActive: quickInsertContext.activePreviewItemKey === registration.key,
                isSelected: isSelected
            },
            select: quickInsertContext.select
        }), [
        id,
        isSelected,
        quickInsertContext,
        registration.key
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $5PGJG.QuickInsertProvider), {
        value: contextValue,
        children: /*#__PURE__*/ (0, $dc70d.jsx)(Component, {
            children: null
        })
    });
};

});

parcelRegister("5i4QA", function(module, exports) {
$parcel$export(module.exports, "TypeAheadQuickInsertProvider", () => $c3c73e0a9c4062c2$export$212ead6007f88306);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $hVGJk = parcelRequire("hVGJk");

var $5PGJG = parcelRequire("5PGJG");

var $5beht = parcelRequire("5beht");

var $7EziY = parcelRequire("7EziY");

var $bgef1 = parcelRequire("bgef1");
const $c3c73e0a9c4062c2$export$212ead6007f88306 = ({ children: children })=>{
    const { activePreviewItemKey: activePreviewItemKey, api: api, editorView: editorView, inputMethod: inputMethod, menuOpenId: menuOpenId, onClose: onClose, popupsMountPoint: popupsMountPoint, query: query, surfaceContext: surfaceContext, triggerHandler: triggerHandler } = (0, $bgef1.useTypeAheadContext)();
    const { isOffline: isOffline } = (0, $5beht.useSharedPluginStateWithSelector)(api, [
        'connectivity'
    ], ({ connectivityState: connectivityState })=>({
            isOffline: (0, $hVGJk.isOfflineMode)(connectivityState === null || connectivityState === void 0 ? void 0 : connectivityState.mode)
        }));
    const select = (0, $bSJIT.useCallback)((selectionHandler)=>{
        onClose();
        queueMicrotask(()=>{
            (0, $7EziY.performTypeAheadSelection)(editorView)({
                handler: triggerHandler,
                inputMethod: inputMethod,
                query: query,
                selectionHandler: selectionHandler
            });
        });
    }, [
        editorView,
        inputMethod,
        onClose,
        query,
        triggerHandler
    ]);
    const contextValue = (0, $bSJIT.useMemo)(()=>({
            activePreviewItemKey: activePreviewItemKey,
            editorView: editorView,
            isOffline: isOffline,
            menuOpenId: menuOpenId,
            popupsMountPoint: popupsMountPoint,
            item: {
                id: 'typeahead-quick-insert',
                isPreviewActive: false,
                isSelected: false
            },
            surface: 'typeahead',
            select: select,
            surfaceContext: surfaceContext
        }), [
        activePreviewItemKey,
        editorView,
        isOffline,
        menuOpenId,
        popupsMountPoint,
        select,
        surfaceContext
    ]);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $5PGJG.QuickInsertProvider), {
        value: contextValue,
        children: children
    });
};

});
parcelRegister("bgef1", function(module, exports) {
$parcel$export(module.exports, "useTypeAheadContext", () => $239c5491d148c9bd$export$ca9af919503437c9);

var $bSJIT = parcelRequire("bSJIT");

var $kFjbv = parcelRequire("kFjbv");
const $239c5491d148c9bd$export$ca9af919503437c9 = ()=>{
    const value = (0, $bSJIT.useContext)((0, $kFjbv.TypeAheadContext));
    if (!value) throw new Error('useTypeAheadContext must be used within TypeAheadProvider');
    return value;
};

});





parcelRegister("bf2JR", function(module, exports) {
$parcel$export(module.exports, "createReducer", () => $51da251fb6d3cfe7$export$473eb76d322d0290);

var $5sUZ8 = parcelRequire("5sUZ8");

var $g6Qq4 = parcelRequire("g6Qq4");

var $a3b9P = parcelRequire("a3b9P");

var $ixSRH = parcelRequire("ixSRH");

var $8IP1q = parcelRequire("8IP1q");

var $1Fs6f = parcelRequire("1Fs6f");

var $479du = parcelRequire("479du");
const $51da251fb6d3cfe7$var$shouldForceOpen = (step)=>{
    if (!(step instanceof (0, $5sUZ8.InsertTypeAheadStep))) return false;
    const isDeletionRawQueryOperation = step.isInsertionStep() && step.stage === (0, $5sUZ8.InsertTypeAheadStages).DELETING_RAW_QUERY;
    const isUndoingInsertionItem = step.isUndoingStep() && step.stage === (0, $5sUZ8.InsertTypeAheadStages).INSERTING_ITEM;
    return isDeletionRawQueryOperation || isUndoingInsertionItem;
};
const $51da251fb6d3cfe7$var$shouldForceClose = (step)=>{
    if (!(step instanceof (0, $5sUZ8.InsertTypeAheadStep))) return false;
    const isInsertingItem = step.isInsertionStep() && step.stage === (0, $5sUZ8.InsertTypeAheadStages).INSERTING_ITEM;
    const isUndoingDeletionRawQuery = step.isUndoingStep() && step.stage === (0, $5sUZ8.InsertTypeAheadStages).DELETING_RAW_QUERY;
    return isInsertingItem || isUndoingDeletionRawQuery;
};
const $51da251fb6d3cfe7$var$applySectionTitleUpdates = ({ sections: sections, sectionTitleUpdates: sectionTitleUpdates })=>{
    const updatedSections = sections.map((section)=>{
        const update = sectionTitleUpdates[section.id];
        if (!update) return section;
        return {
            ...section,
            ...update
        };
    });
    return updatedSections;
};
const $51da251fb6d3cfe7$var$createFindHandler = (typeAheadHandlers)=>(step)=>{
        if (!(step instanceof (0, $5sUZ8.InsertTypeAheadStep))) return null;
        const handler = typeAheadHandlers.find((h)=>h.trigger === step.trigger);
        return handler || null;
    };
const $51da251fb6d3cfe7$export$473eb76d322d0290 = ({ typeAheadHandlers: typeAheadHandlers, removeDecorations: removeDecorations, createDecorations: createDecorations })=>{
    const findHandler = $51da251fb6d3cfe7$var$createFindHandler(typeAheadHandlers);
    const openMenu = (currentPluginState, { tr: tr, triggerHandler: triggerHandler, inputMethod: inputMethod, reopenQuery: reopenQuery, selectedIndex: selectedIndex, removePrefixTriggerOnCancel: removePrefixTriggerOnCancel })=>{
        var _insm$session;
        removeDecorations(currentPluginState.decorationSet);
        const { decorationSet: decorationSet, decorationElement: decorationElement, stats: stats } = createDecorations(tr, {
            triggerHandler: triggerHandler,
            inputMethod: inputMethod,
            reopenQuery: reopenQuery
        });
        (_insm$session = (0, $ixSRH.insm).session) === null || _insm$session === void 0 || _insm$session.startFeature('typeaheadOpen');
        return {
            ...currentPluginState,
            stats: stats,
            decorationSet: decorationSet,
            triggerHandler: triggerHandler,
            decorationElement: decorationElement,
            inputMethod: inputMethod,
            selectedIndex: typeof selectedIndex === 'number' ? selectedIndex : -1,
            items: [],
            sectionTitleUpdates: {},
            sections: [],
            query: reopenQuery || '',
            removePrefixTriggerOnCancel: removePrefixTriggerOnCancel
        };
    };
    const closeMenu = (currentPluginState)=>{
        var _insm$session2;
        removeDecorations(currentPluginState.decorationSet);
        (_insm$session2 = (0, $ixSRH.insm).session) === null || _insm$session2 === void 0 || _insm$session2.endFeature('typeaheadOpen');
        return {
            ...currentPluginState,
            inputMethod: null,
            query: '',
            decorationElement: null,
            decorationSet: (0, $a3b9P.DecorationSet).empty,
            stats: null,
            triggerHandler: undefined,
            items: [],
            sections: [],
            sectionTitleUpdates: {},
            removePrefixTriggerOnCancel: undefined
        };
    };
    return (tr, currentPluginState, typeAheadStepOverride)=>{
        const meta = tr.getMeta((0, $1Fs6f.pluginKey)) || {};
        // This code below controls when we should force
        // the menu to open or close during undo/redo operations
        const overrideHandler = findHandler(typeAheadStepOverride);
        if (typeAheadStepOverride && overrideHandler && $51da251fb6d3cfe7$var$shouldForceOpen(typeAheadStepOverride)) return openMenu(currentPluginState, {
            tr: tr,
            triggerHandler: overrideHandler,
            inputMethod: (0, $g6Qq4.INPUT_METHOD).KEYBOARD,
            reopenQuery: typeAheadStepOverride.query,
            selectedIndex: typeAheadStepOverride.selectedIndex
        });
        else if ($51da251fb6d3cfe7$var$shouldForceClose(typeAheadStepOverride)) return closeMenu(currentPluginState);
        const { action: action, params: params } = meta || {};
        const shouldOpenMenu = action === (0, $8IP1q.ACTIONS).OPEN_TYPEAHEAD_AT_CURSOR && (0, $479du.isTypeAheadHandler)(params === null || params === void 0 ? void 0 : params.triggerHandler);
        const selectionChanged = tr.selectionSet && (tr.isGeneric || Boolean(tr.getMeta('pointer')));
        const shouldCloseMenu = [
            (0, $8IP1q.ACTIONS).CLOSE_TYPE_AHEAD,
            (0, $8IP1q.ACTIONS).INSERT_ITEM
        ].includes(action) || selectionChanged;
        const shouldUpdateQuery = action === (0, $8IP1q.ACTIONS).CHANGE_QUERY;
        const shouldUpdateListItems = action === (0, $8IP1q.ACTIONS).UPDATE_LIST_ITEMS;
        const shouldUpdateListError = action === (0, $8IP1q.ACTIONS).UPDATE_LIST_ERROR;
        const shouldUpdateSelectedIndex = action === (0, $8IP1q.ACTIONS).UPDATE_SELECTED_INDEX;
        const shouldUpdateSectionTitleState = action === (0, $8IP1q.ACTIONS).UPDATE_SECTION_TITLE;
        const shouldClearListError = action === (0, $8IP1q.ACTIONS).CLEAR_LIST_ERROR;
        if (shouldOpenMenu) return openMenu(currentPluginState, {
            tr: tr,
            triggerHandler: params.triggerHandler,
            inputMethod: params.inputMethod,
            reopenQuery: params.query,
            removePrefixTriggerOnCancel: params.removePrefixTriggerOnCancel
        });
        else if (shouldCloseMenu) return closeMenu(currentPluginState);
        else if (shouldUpdateQuery) return {
            ...currentPluginState,
            query: params.query
        };
        else if (shouldUpdateListError) {
            const { errorInfo: errorInfo } = params;
            return {
                ...currentPluginState,
                errorInfo: errorInfo,
                items: [],
                sections: [],
                selectedIndex: -1
            };
        } else if (shouldUpdateListItems) {
            const { items: items, sections: sections = [] } = params;
            const { selectedIndex: selectedIndex } = currentPluginState;
            return {
                ...currentPluginState,
                items: items,
                sections: $51da251fb6d3cfe7$var$applySectionTitleUpdates({
                    sections: sections,
                    sectionTitleUpdates: currentPluginState.sectionTitleUpdates
                }),
                selectedIndex: Math.max(selectedIndex >= items.length ? items.length - 1 : selectedIndex, -1)
            };
        } else if (shouldUpdateSectionTitleState) {
            const { id: id, update: update } = params;
            const sectionTitleUpdates = {
                ...currentPluginState.sectionTitleUpdates,
                [id]: {
                    ...currentPluginState.sectionTitleUpdates[id],
                    ...update
                }
            };
            return {
                ...currentPluginState,
                sectionTitleUpdates: sectionTitleUpdates,
                sections: $51da251fb6d3cfe7$var$applySectionTitleUpdates({
                    sections: currentPluginState.sections,
                    sectionTitleUpdates: sectionTitleUpdates
                })
            };
        } else if (shouldUpdateSelectedIndex) return {
            ...currentPluginState,
            selectedIndex: params.selectedIndex
        };
        else if (shouldClearListError) return {
            ...currentPluginState,
            errorInfo: null
        };
        if (tr.docChanged) {
            const { decorationSet: decorationSet } = currentPluginState;
            const onRemove = ()=>{
                // Make sure we are unmounting the component
                // from the react tree when this decoration is removed
                removeDecorations(currentPluginState.decorationSet);
            };
            const mappedDecorationSet = decorationSet.map(tr.mapping, tr.doc, {
                onRemove: onRemove
            });
            // return same pluginState if decorationSet did not change
            if (mappedDecorationSet === currentPluginState.decorationSet) return currentPluginState;
            return {
                ...currentPluginState,
                decorationSet: mappedDecorationSet
            };
        }
        return currentPluginState;
    };
};

});


parcelRegister("1JKxC", function(module, exports) {
$parcel$export(module.exports, "ContentComponent", () => $10aee3c35113da2a$export$2dda1e4a1d1f6a81);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $5beht = parcelRequire("5beht");

var $b3FBL = parcelRequire("b3FBL");

var $jT9YZ = parcelRequire("jT9YZ");
function $10aee3c35113da2a$export$2dda1e4a1d1f6a81({ api: api, editorView: editorView, popupMountRef: popupMountRef }) {
    const { triggerHandler: triggerHandler, items: items, sections: sections, errorInfo: errorInfo, decorationElement: decorationElement, decorationSet: decorationSet, query: query, selectedIndex: selectedIndex } = (0, $5beht.useSharedPluginStateWithSelector)(api, [
        'typeAhead'
    ], (states)=>{
        var _states$typeAheadStat, _states$typeAheadStat2, _states$typeAheadStat3, _states$typeAheadStat4, _states$typeAheadStat5, _states$typeAheadStat6, _states$typeAheadStat7, _states$typeAheadStat8;
        return {
            triggerHandler: (_states$typeAheadStat = states.typeAheadState) === null || _states$typeAheadStat === void 0 ? void 0 : _states$typeAheadStat.triggerHandler,
            items: (_states$typeAheadStat2 = states.typeAheadState) === null || _states$typeAheadStat2 === void 0 ? void 0 : _states$typeAheadStat2.items,
            sections: (_states$typeAheadStat3 = states.typeAheadState) === null || _states$typeAheadStat3 === void 0 ? void 0 : _states$typeAheadStat3.sections,
            errorInfo: (_states$typeAheadStat4 = states.typeAheadState) === null || _states$typeAheadStat4 === void 0 ? void 0 : _states$typeAheadStat4.errorInfo,
            decorationElement: (_states$typeAheadStat5 = states.typeAheadState) === null || _states$typeAheadStat5 === void 0 ? void 0 : _states$typeAheadStat5.decorationElement,
            decorationSet: (_states$typeAheadStat6 = states.typeAheadState) === null || _states$typeAheadStat6 === void 0 ? void 0 : _states$typeAheadStat6.decorationSet,
            query: (_states$typeAheadStat7 = states.typeAheadState) === null || _states$typeAheadStat7 === void 0 ? void 0 : _states$typeAheadStat7.query,
            selectedIndex: (_states$typeAheadStat8 = states.typeAheadState) === null || _states$typeAheadStat8 === void 0 ? void 0 : _states$typeAheadStat8.selectedIndex
        };
    });
    if (items === undefined || sections === undefined || decorationSet === undefined || errorInfo === undefined || decorationElement === undefined || query === undefined || selectedIndex === undefined) return null;
    if ((0, $b3FBL.getTypeAheadSurface)(triggerHandler === null || triggerHandler === void 0 ? void 0 : triggerHandler.id)) return null;
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $jT9YZ.TypeAheadMenu), {
        editorView: editorView,
        popupMountRef: popupMountRef,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        typeAheadState: {
            triggerHandler: triggerHandler,
            items: items,
            sections: sections,
            errorInfo: errorInfo,
            decorationElement: decorationElement,
            decorationSet: decorationSet,
            query: query
        },
        selectedIndex: selectedIndex,
        api: api
    });
}

});
parcelRegister("jT9YZ", function(module, exports) {
$parcel$export(module.exports, "TypeAheadMenu", () => $a05d1359436c9b8b$export$b11addef9209139);

var $dc70d = parcelRequire("dc70d");

var $bSJIT = parcelRequire("bSJIT");

var $aaLLt = parcelRequire("aaLLt");

var $797yE = parcelRequire("797yE");

var $fq4QS = parcelRequire("fq4QS");

var $kIfQl = parcelRequire("kIfQl");

var $c4jTB = parcelRequire("c4jTB");
const $a05d1359436c9b8b$export$b11addef9209139 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).memo(({ editorView: editorView, popupMountRef: popupMountRef, typeAheadState: typeAheadState, selectedIndex: selectedIndex, api: api })=>{
    var _popupMountRef$curren, _popupMountRef$curren2, _popupMountRef$curren3;
    const isOpen = typeAheadState.decorationSet.find().length > 0;
    const { triggerHandler: triggerHandler, items: items, sections: sections = [], errorInfo: errorInfo, decorationElement: decorationElement, decorationSet: decorationSet, query: query } = typeAheadState;
    const [onItemInsert, onTextInsert, onItemMatch] = (0, $kIfQl.useItemInsert)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    triggerHandler, editorView, items, api);
    const setSelectedItem = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useCallback(({ index: nextIndex })=>{
        queueMicrotask(()=>{
            (0, $fq4QS.updateSelectedIndex)(nextIndex, api)(editorView.state, editorView.dispatch);
        });
    }, [
        editorView,
        api
    ]);
    const insertItem = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useCallback((mode = (0, $aaLLt.SelectItemMode).SELECTED, index)=>{
        queueMicrotask(()=>{
            onItemInsert({
                mode: mode,
                index: index,
                query: query
            });
        });
    }, [
        onItemInsert,
        query
    ]);
    const cancel = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useCallback(({ setSelectionAt: setSelectionAt, addPrefixTrigger: addPrefixTrigger, forceFocusOnEditor: forceFocusOnEditor })=>{
        const fullQuery = addPrefixTrigger ? `${triggerHandler === null || triggerHandler === void 0 ? void 0 : triggerHandler.trigger}${query}` : query;
        onTextInsert({
            forceFocusOnEditor: forceFocusOnEditor,
            setSelectionAt: setSelectionAt,
            text: fullQuery
        });
    }, [
        triggerHandler,
        onTextInsert,
        query
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useEffect(()=>{
        if (!isOpen || !query) return;
        const isLastCharSpace = query[query.length - 1] === ' ';
        if (!isLastCharSpace) return;
        const result = onItemMatch({
            mode: (0, $aaLLt.SelectItemMode).SPACE,
            query: query.trim()
        });
        if (!result) return;
    }, [
        isOpen,
        query,
        onItemMatch
    ]);
    // @ts-ignore
    const openElementBrowserModal = triggerHandler === null || triggerHandler === void 0 ? void 0 : triggerHandler.openElementBrowserModal;
    let showMoreOptionsButton = false;
    if ((0, $797yE.editorExperiment)('platform_editor_controls', 'variant1')) showMoreOptionsButton = !!(triggerHandler !== null && triggerHandler !== void 0 && triggerHandler.getMoreOptionsButtonConfig);
    if (!isOpen || !triggerHandler || !(decorationElement instanceof HTMLElement) || !openElementBrowserModal && items.length === 0 && !errorInfo) return null;
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $c4jTB.TypeAheadPopup), {
        editorView: editorView,
        popupsMountPoint: (_popupMountRef$curren = popupMountRef.current) === null || _popupMountRef$curren === void 0 ? void 0 : _popupMountRef$curren.popupsMountPoint,
        popupsBoundariesElement: (_popupMountRef$curren2 = popupMountRef.current) === null || _popupMountRef$curren2 === void 0 ? void 0 : _popupMountRef$curren2.popupsBoundariesElement,
        popupsScrollableElement: (_popupMountRef$curren3 = popupMountRef.current) === null || _popupMountRef$curren3 === void 0 ? void 0 : _popupMountRef$curren3.popupsScrollableElement,
        anchorElement: decorationElement,
        triggerHandler: triggerHandler,
        items: items,
        sections: sections,
        errorInfo: errorInfo,
        selectedIndex: selectedIndex,
        setSelectedItem: setSelectedItem,
        onItemInsert: insertItem,
        decorationSet: decorationSet,
        isEmptyQuery: !query,
        cancel: cancel,
        api: api,
        showMoreOptionsButton: showMoreOptionsButton
    });
});

});
parcelRegister("c4jTB", function(module, exports) {
$parcel$export(module.exports, "TypeAheadPopup", () => $d4079d3ba0020af2$export$fbc0702507873a7d);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $9wZWu = parcelRequire("9wZWu");

var $g6Qq4 = parcelRequire("g6Qq4");

var $5zk80 = parcelRequire("5zk80");

var $9xvBa = parcelRequire("9xvBa");

var $aaLLt = parcelRequire("aaLLt");

var $5beht = parcelRequire("5beht");

var $5bbjm = parcelRequire("5bbjm");

var $797yE = parcelRequire("797yE");

var $eiHj2 = parcelRequire("eiHj2");

var $4vgtg = parcelRequire("4vgtg");

var $479du = parcelRequire("479du");

var $327Q8 = parcelRequire("327Q8");

var $l1SNK = parcelRequire("l1SNK");
function $d4079d3ba0020af2$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d4079d3ba0020af2$var$DEFAULT_TYPEAHEAD_MENU_HEIGHT = 380;
const $d4079d3ba0020af2$var$VIEWMORE_BUTTON_HEIGHT = 53;
const $d4079d3ba0020af2$var$DEFAULT_TYPEAHEAD_MENU_HEIGHT_NEW = 480;
const $d4079d3ba0020af2$var$ITEM_PADDING = 12;
const $d4079d3ba0020af2$var$typeAheadContent = /*#__PURE__*/ (0, $9dQre.css)({
    background: "var(--ds-surface-overlay, #FFFFFF)",
    borderRadius: "var(--ds-radius-small, 3px)",
    boxShadow: "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)",
    padding: `${"var(--ds-space-050, 4px)"} 0`,
    width: '320px',
    maxHeight: '380px' /* ~5.5 visibile items */ ,
    overflowY: 'auto',
    MsOverflowStyle: '-ms-autohiding-scrollbar',
    position: 'relative'
});
const $d4079d3ba0020af2$var$typeAheadContentOverride = /*#__PURE__*/ (0, $9dQre.css)({
    maxHeight: `${$d4079d3ba0020af2$var$DEFAULT_TYPEAHEAD_MENU_HEIGHT_NEW}px`
});
const $d4079d3ba0020af2$var$typeAheadWrapperWithViewMoreOverride = {
    name: "1fttcpj",
    styles: "display:flex;flex-direction:column"
};
const $d4079d3ba0020af2$var$Highlight = ({ state: state, triggerHandler: triggerHandler })=>{
    if (!(triggerHandler !== null && triggerHandler !== void 0 && triggerHandler.getHighlight)) return null;
    return triggerHandler.getHighlight(state);
};
const $d4079d3ba0020af2$var$OFFSET = [
    0,
    8
];
const $d4079d3ba0020af2$export$fbc0702507873a7d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).memo((props)=>{
    var _getPluginState;
    const { editorView: editorView, triggerHandler: triggerHandler, anchorElement: anchorElement, popupsMountPoint: popupsMountPoint, popupsBoundariesElement: popupsBoundariesElement, popupsScrollableElement: popupsScrollableElement, items: items, sections: sections = [], errorInfo: errorInfo, selectedIndex: selectedIndex, onItemInsert: onItemInsert, isEmptyQuery: isEmptyQuery, cancel: cancel, api: api, showMoreOptionsButton: showMoreOptionsButton } = props;
    const ref = (0, $bSJIT.useRef)(null);
    const { moreElementsInQuickInsertView: moreElementsInQuickInsertView } = (0, $5beht.useSharedPluginStateWithSelector)(api, [
        'featureFlags'
    ], (states)=>{
        var _states$featureFlagsS;
        return {
            moreElementsInQuickInsertView: (_states$featureFlagsS = states.featureFlagsState) === null || _states$featureFlagsS === void 0 ? void 0 : _states$featureFlagsS.moreElementsInQuickInsertView
        };
    });
    const moreElementsInQuickInsertViewEnabled = moreElementsInQuickInsertView && triggerHandler.id === (0, $aaLLt.TypeAheadAvailableNodes).QUICK_INSERT;
    const isEditorControlsEnabled = (0, $797yE.editorExperiment)('platform_editor_controls', 'variant1');
    const defaultMenuHeight = (0, $bSJIT.useMemo)(()=>moreElementsInQuickInsertViewEnabled ? $d4079d3ba0020af2$var$DEFAULT_TYPEAHEAD_MENU_HEIGHT_NEW : $d4079d3ba0020af2$var$DEFAULT_TYPEAHEAD_MENU_HEIGHT, [
        moreElementsInQuickInsertViewEnabled
    ]);
    const activityStateRef = (0, $bSJIT.useRef)({
        inputMethod: null,
        closeAction: null,
        invocationMethod: (_getPluginState = (0, $479du.getPluginState)(editorView.state)) === null || _getPluginState === void 0 ? void 0 : _getPluginState.inputMethod
    });
    const startTime = (0, $bSJIT.useMemo)(()=>performance.now(), // In case those props changes
    // we need to recreate the startTime
    [
        items,
        isEmptyQuery,
        triggerHandler
    ] // eslint-disable-line react-hooks/exhaustive-deps
    );
    (0, $bSJIT.useEffect)(()=>{
        var _api$analytics, _api$analytics2;
        if (!(api !== null && api !== void 0 && (_api$analytics = api.analytics) !== null && _api$analytics !== void 0 && (_api$analytics = _api$analytics.actions) !== null && _api$analytics !== void 0 && _api$analytics.fireAnalyticsEvent)) return;
        const stopTime = performance.now();
        const time = stopTime - startTime;
        api === null || api === void 0 || (_api$analytics2 = api.analytics) === null || _api$analytics2 === void 0 || (_api$analytics2 = _api$analytics2.actions) === null || _api$analytics2 === void 0 || _api$analytics2.fireAnalyticsEvent({
            action: (0, $g6Qq4.ACTION).RENDERED,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).TYPEAHEAD,
            eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL,
            attributes: {
                time: time,
                items: items.length,
                initial: isEmptyQuery
            }
        });
    }, [
        startTime,
        items,
        isEmptyQuery,
        // In case the current triggerHandler changes
        // e.g: Inserting a mention using the quick insert
        // we need to send the event again
        // eslint-disable-next-line react-hooks/exhaustive-deps
        triggerHandler,
        api
    ]);
    (0, $bSJIT.useEffect)(()=>{
        var _api$analytics3, _api$analytics4;
        if (!(api !== null && api !== void 0 && (_api$analytics3 = api.analytics) !== null && _api$analytics3 !== void 0 && (_api$analytics3 = _api$analytics3.actions) !== null && _api$analytics3 !== void 0 && _api$analytics3.fireAnalyticsEvent)) return;
        api === null || api === void 0 || (_api$analytics4 = api.analytics) === null || _api$analytics4 === void 0 || (_api$analytics4 = _api$analytics4.actions) === null || _api$analytics4 === void 0 || _api$analytics4.fireAnalyticsEvent({
            action: (0, $g6Qq4.ACTION).VIEWED,
            actionSubject: (0, $g6Qq4.ACTION_SUBJECT).TYPEAHEAD_ITEM,
            eventType: (0, $g6Qq4.EVENT_TYPE).OPERATIONAL,
            attributes: {
                index: selectedIndex,
                items: items.length
            }
        });
    }, [
        items,
        api,
        selectedIndex,
        // In case the current triggerHandler changes
        // e.g: Inserting a mention using the quick insert
        // we need to send the event again
        // eslint-disable-next-line react-hooks/exhaustive-deps
        triggerHandler
    ]);
    const [fitHeight, setFitHeight] = (0, $bSJIT.useState)(defaultMenuHeight);
    const fitHeightWithViewMore = (0, $bSJIT.useMemo)(()=>{
        if (showMoreOptionsButton) return fitHeight - $d4079d3ba0020af2$var$VIEWMORE_BUTTON_HEIGHT;
        return fitHeight;
    }, [
        fitHeight,
        showMoreOptionsButton
    ]);
    const getFitHeight = (0, $bSJIT.useCallback)(()=>{
        if (!anchorElement || !popupsMountPoint) return;
        const target = anchorElement;
        const { top: targetTop, height: targetHeight } = target.getBoundingClientRect();
        const boundariesElement = popupsBoundariesElement || document.body;
        const { height: boundariesHeight, top: boundariesTop } = boundariesElement.getBoundingClientRect();
        // Calculating the space above and space below our decoration
        const spaceAbove = targetTop - (boundariesTop - boundariesElement.scrollTop);
        const spaceBelow = boundariesTop + boundariesHeight - (targetTop + targetHeight);
        // Keep default height if more than enough space
        if (spaceBelow >= defaultMenuHeight) return setFitHeight(defaultMenuHeight);
        // Determines whether typeahead will fit above or below decoration
        // and return the space available.
        const newFitHeight = spaceBelow >= spaceAbove ? spaceBelow : spaceAbove;
        // Each typeahead item has some padding
        // We want to leave some space at the top so first item
        // is not partially cropped
        const fitHeightWithSpace = newFitHeight - $d4079d3ba0020af2$var$ITEM_PADDING * 2;
        // Ensure typeahead height is max its default height
        const minFitHeight = Math.min(defaultMenuHeight, fitHeightWithSpace);
        return setFitHeight(minFitHeight);
    }, [
        anchorElement,
        defaultMenuHeight,
        popupsBoundariesElement,
        popupsMountPoint
    ]);
    const getFitHeightDebounced = (0, $9wZWu.default)(getFitHeight);
    (0, $bSJIT.useLayoutEffect)(()=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const scrollableElement = popupsScrollableElement || (0, $9xvBa.findOverflowScrollParent)(anchorElement);
        getFitHeight();
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        window.addEventListener('resize', getFitHeightDebounced);
        if (scrollableElement) // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        scrollableElement.addEventListener('scroll', getFitHeightDebounced);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            window.removeEventListener('resize', getFitHeightDebounced);
            if (scrollableElement) // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            scrollableElement.removeEventListener('scroll', getFitHeightDebounced);
        };
    }, [
        anchorElement,
        popupsScrollableElement,
        getFitHeightDebounced,
        getFitHeight
    ]);
    (0, $bSJIT.useLayoutEffect)(()=>{
        const { removePrefixTriggerOnCancel: removePrefixTriggerOnCancel } = (0, $479du.getPluginState)(editorView.state) || {};
        const focusOut = (event)=>{
            var _window$getSelection;
            const { relatedTarget: relatedTarget } = event;
            // Given the user is changing the focus
            // When the target is inside the TypeAhead Popup
            // Then the popup should stay open
            if (relatedTarget instanceof HTMLElement && relatedTarget.closest && (relatedTarget.closest(`.${(0, $4vgtg.TYPE_AHEAD_POPUP_CONTENT_CLASS)}`) || relatedTarget.closest(`[data-type-ahead="${(0, $4vgtg.TYPE_AHEAD_DECORATION_DATA_ATTRIBUTE)}"]`))) return;
            // Handles cases like emoji (:) and mention (@) typeaheads that open new typeaheads
            const isTextSelected = ((_window$getSelection = window.getSelection()) === null || _window$getSelection === void 0 ? void 0 : _window$getSelection.type) === 'Range';
            const innerEditor = anchorElement.closest('.extension-editable-area');
            if (innerEditor) {
                // When there is no related target, we default to not closing the popup
                let newFocusInsideCurrentEditor = !relatedTarget;
                if (relatedTarget instanceof HTMLElement) // check if the new focus is inside inner editor, keep popup opens
                newFocusInsideCurrentEditor = innerEditor.contains(relatedTarget);
                if (!isTextSelected && newFocusInsideCurrentEditor) return;
            } else {
                // if the current focus in outer editor, keep the existing behaviour, do not close the pop up if text is not selected
                if (!isTextSelected) return;
            }
            cancel({
                addPrefixTrigger: isEditorControlsEnabled ? !removePrefixTriggerOnCancel : true,
                setSelectionAt: (0, $4vgtg.CloseSelectionOptions).AFTER_TEXT_INSERTED,
                forceFocusOnEditor: false
            });
        };
        const { current: element } = ref;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element === null || element === void 0 || element.addEventListener('focusout', focusOut);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element === null || element === void 0 || element.removeEventListener('focusout', focusOut);
        };
    }, [
        ref,
        cancel,
        editorView.state,
        isEditorControlsEnabled,
        anchorElement
    ]);
    // TODO: ED-17443 - When you press escape on typeahead panel, it should remove focus and close the panel
    // This is the expected keyboard behaviour advised by the Accessibility team
    (0, $bSJIT.useLayoutEffect)(()=>{
        const { removePrefixTriggerOnCancel: removePrefixTriggerOnCancel } = (0, $479du.getPluginState)(editorView.state) || {};
        const escape = (event)=>{
            if (event.key === 'Escape') {
                activityStateRef.current.inputMethod = (0, $g6Qq4.INPUT_METHOD).KEYBOARD;
                cancel({
                    addPrefixTrigger: isEditorControlsEnabled ? !removePrefixTriggerOnCancel : true,
                    setSelectionAt: (0, $4vgtg.CloseSelectionOptions).AFTER_TEXT_INSERTED,
                    forceFocusOnEditor: true
                });
            }
        };
        const { current: element } = ref;
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element === null || element === void 0 || element.addEventListener('keydown', escape);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element === null || element === void 0 || element.removeEventListener('keydown', escape);
        };
    }, [
        ref,
        cancel,
        editorView.state,
        isEditorControlsEnabled
    ]);
    // @ts-ignore
    const openElementBrowserModal = triggerHandler === null || triggerHandler === void 0 ? void 0 : triggerHandler.openElementBrowserModal;
    const onMoreOptionsClicked = (0, $bSJIT.useCallback)(()=>{
        if (// eslint-disable-next-line @atlaskit/platform/no-preconditioning
        openElementBrowserModal && (0, $797yE.editorExperiment)('platform_editor_controls', 'variant1') && triggerHandler.id === (0, $aaLLt.TypeAheadAvailableNodes).QUICK_INSERT) activityStateRef.current = {
            inputMethod: (0, $g6Qq4.INPUT_METHOD).MOUSE,
            closeAction: (0, $g6Qq4.ACTION).VIEW_MORE,
            invocationMethod: activityStateRef.current.invocationMethod
        };
    }, [
        openElementBrowserModal,
        triggerHandler.id
    ]);
    return /*#__PURE__*/ (0, $9dQre.jsx)((0, $5zk80.default), {
        zIndex: (0, $5bbjm.akEditorFloatingDialogZIndex),
        target: anchorElement,
        mountTo: popupsMountPoint,
        boundariesElement: popupsBoundariesElement,
        scrollableElement: popupsScrollableElement,
        fitHeight: fitHeight,
        fitWidth: 340,
        offset: $d4079d3ba0020af2$var$OFFSET,
        ariaLabel: null,
        preventOverflow: true,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onUnmount: ()=>{
            if (selectedIndex > -1 && (0, $797yE.editorExperiment)('platform_editor_controls', 'variant1')) {
                // if selectedIndex is -1, it means that the user has not selected any item
                // will be handled by WrapperTypeAhead
                (0, $eiHj2.fireTypeAheadClosedAnalyticsEvent)(api, activityStateRef.current.closeAction || (0, $g6Qq4.ACTION).CANCELLED, !isEmptyQuery, activityStateRef.current.inputMethod || (0, $g6Qq4.INPUT_METHOD).MOUSE, activityStateRef.current.invocationMethod);
                // reset activity state
                activityStateRef.current = {
                    inputMethod: null,
                    closeAction: null,
                    invocationMethod: null
                };
            }
        }
    }, /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        css: [
            $d4079d3ba0020af2$var$typeAheadContent,
            moreElementsInQuickInsertViewEnabled && $d4079d3ba0020af2$var$typeAheadContentOverride,
            showMoreOptionsButton && $d4079d3ba0020af2$var$typeAheadWrapperWithViewMoreOverride
        ],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $4vgtg.TYPE_AHEAD_POPUP_CONTENT_CLASS),
        ref: ref
    }, errorInfo ? /*#__PURE__*/ (0, $9dQre.jsx)((0, $327Q8.TypeAheadErrorFallback), null) : /*#__PURE__*/ (0, $9dQre.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).Fragment, null, /*#__PURE__*/ (0, $9dQre.jsx)($d4079d3ba0020af2$var$Highlight, {
        state: editorView.state,
        triggerHandler: triggerHandler
    }), /*#__PURE__*/ (0, $9dQre.jsx)((0, $l1SNK.TypeAheadList), {
        items: items,
        isEmptyQuery: isEmptyQuery,
        sections: sections,
        selectedIndex: selectedIndex,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        onItemClick: (mode, index, inputMethod)=>{
            if ((0, $797yE.editorExperiment)('platform_editor_controls', 'variant1')) activityStateRef.current = {
                inputMethod: inputMethod || null,
                closeAction: (0, $g6Qq4.ACTION).INSERTED,
                invocationMethod: activityStateRef.current.invocationMethod
            };
            onItemInsert(mode, index);
        },
        fitHeight: fitHeightWithViewMore,
        editorView: editorView,
        decorationElement: anchorElement,
        triggerHandler: triggerHandler,
        moreElementsInQuickInsertViewEnabled: moreElementsInQuickInsertViewEnabled,
        api: api,
        showMoreOptionsButton: showMoreOptionsButton,
        onMoreOptionsClicked: onMoreOptionsClicked
    }))));
});
$d4079d3ba0020af2$export$fbc0702507873a7d.displayName = 'TypeAheadPopup';

});
parcelRegister("327Q8", function(module, exports) {
$parcel$export(module.exports, "TypeAheadErrorFallback", () => $1ad0b4e65cdc5532$export$71ea07f9d4f4ab38);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled, @typescript-eslint/consistent-type-imports

var $9dQre = parcelRequire("9dQre");

var $4vLTk = parcelRequire("4vLTk");

var $ex2cJ = parcelRequire("ex2cJ");

var $fiAV0 = parcelRequire("fiAV0");

var $71iG7 = parcelRequire("71iG7");
function $1ad0b4e65cdc5532$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1ad0b4e65cdc5532$var$minHeightComponentStyles = {
    name: "2omrkj",
    styles: "display:flex;align-items:stretch;justify-content:center;min-height:290px"
};
const $1ad0b4e65cdc5532$export$71ea07f9d4f4ab38 = ()=>{
    const intl = (0, $4vLTk.default)();
    const header = intl.formatMessage((0, $ex2cJ.typeAheadListMessages).typeAheadErrorFallbackHeading);
    const description = intl.formatMessage((0, $ex2cJ.typeAheadListMessages).typeAheadErrorFallbackDesc);
    return /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        "data-testid": "typeahead-error-boundary-ui",
        css: $1ad0b4e65cdc5532$var$minHeightComponentStyles
    }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $fiAV0.EmptyState), {
        header: header,
        // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        renderImage: ()=>/*#__PURE__*/ (0, $9dQre.jsx)((0, $71iG7.GenericErrorSVG), null),
        description: description
    }));
};

});
parcelRegister("fiAV0", function(module, exports) {
$parcel$export(module.exports, "EmptyState", () => $0c5284ca30976d58$export$fddf379e22a74b00);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $7WQx2 = parcelRequire("7WQx2");

var $cMYsY = parcelRequire("cMYsY");

var $aRsbV = parcelRequire("aRsbV");

var $9BVpB = parcelRequire("9BVpB");
const $0c5284ca30976d58$var$containerStyles = (0, $9BVpB.xcss)({
    marginBlockStart: 'space.600',
    marginBlockEnd: 'space.600',
    textAlign: 'center'
});
const $0c5284ca30976d58$export$fddf379e22a74b00 = ({ testId: testId, header: header, description: description, renderImage: renderImage })=>{
    return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $cMYsY.Flex), {
        xcss: $0c5284ca30976d58$var$containerStyles,
        testId: testId,
        direction: "column",
        alignItems: "center",
        gap: "space.300",
        children: [
            renderImage === null || renderImage === void 0 ? void 0 : renderImage(),
            /*#__PURE__*/ (0, $dc70d.jsxs)((0, $cMYsY.Flex), {
                direction: "column",
                alignItems: "center",
                gap: "space.200",
                children: [
                    /*#__PURE__*/ (0, $dc70d.jsx)((0, $7WQx2.default), {
                        size: "medium",
                        as: "h2",
                        children: header
                    }),
                    description && /*#__PURE__*/ (0, $dc70d.jsx)((0, $aRsbV.Text), {
                        as: "p",
                        color: "color.text",
                        children: description
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("71iG7", function(module, exports) {
$parcel$export(module.exports, "GenericErrorSVG", () => $f4f1c9a89549d015$export$e54420a1a27457a4);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled, @typescript-eslint/consistent-type-imports

var $9dQre = parcelRequire("9dQre");
const $f4f1c9a89549d015$var$HEIGHT = 90;
const $f4f1c9a89549d015$var$genericErrorStyles = /*#__PURE__*/ (0, $9dQre.css)({
    height: `${$f4f1c9a89549d015$var$HEIGHT}px`,
    display: 'block'
});
const $f4f1c9a89549d015$export$e54420a1a27457a4 = (props)=>{
    const id = 'link-picker-ui-generic-error-svg';
    return /*#__PURE__*/ (0, $9dQre.jsx)("svg", {
        height: "90",
        viewBox: "0 0 164 212",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        css: $f4f1c9a89549d015$var$genericErrorStyles,
        ...props
    }, /*#__PURE__*/ (0, $9dQre.jsx)("path", {
        d: "m95.43 74.16 66.44 115.08c5.84 10.12-1.46 22.76-13.14 22.76H15.85c-11.68 0-18.98-12.65-13.14-22.76L69.15 74.16c5.84-10.12 20.44-10.12 26.28 0Zm-7.56 83.55 2.88-44.35c.34-5.29-3.86-9.78-9.16-9.78-5.31 0-9.51 4.48-9.16 9.78l2.88 44.35a6.3 6.3 0 0 0 6.28 5.89c3.31 0 6.06-2.58 6.28-5.89Zm-15.84 23.54c0 5.66 4.76 10.1 10.39 9.58 4.85-.45 8.73-4.5 8.83-9.37.11-5.45-4.31-9.94-9.73-9.94-5.23-.01-9.49 4.37-9.49 9.73Z",
        fill: `url(#${id})`
    }), /*#__PURE__*/ (0, $9dQre.jsx)("path", {
        opacity: ".6",
        d: "M93.35 27.17 85.94.45c-.17-.62-1.07-.58-1.19.05l-4.66 25.1-5.8-1.08a.612.612 0 0 0-.7.76L81 52c.17.62 1.07.58 1.19-.05l4.66-25.1 5.8 1.08c.45.08.82-.33.7-.76ZM66.77 41.81 55.9 33.26c-.22-.18-.53.07-.41.33l5.53 11.43-2.66 1.29c-.18.09-.2.33-.05.45l10.87 8.55c.22.18.53-.07.41-.33l-5.53-11.43 2.66-1.29c.17-.08.2-.33.05-.45Z",
        fill: "#C1C7D0"
    }), /*#__PURE__*/ (0, $9dQre.jsx)("path", {
        opacity: ".6",
        d: "M102.78 56.75a.993.993 0 0 1-.92-1.38c-.24-.77-2.29-2.85-3.54-4.11-2.97-3.01-4.93-5-3.84-6.49 1.09-1.48 3.58-.22 7.35 1.7 1.32.67 3.35 1.7 4.45 2.03-.64-.95-2.24-2.58-3.28-3.63-2.97-3.01-4.93-5-3.84-6.49 1.08-1.48 3.58-.22 7.34 1.7 1.32.67 3.34 1.7 4.45 2.03-.64-.95-2.24-2.57-3.28-3.62-2.97-3.01-4.93-5-3.84-6.49 1.08-1.48 3.57-.22 7.34 1.7 1.58.8 4.18 2.13 4.98 2.13a1.005 1.005 0 0 1 1.46 1.36c-1.09 1.48-3.57.22-7.34-1.7-1.32-.67-3.34-1.7-4.44-2.03.64.95 2.24 2.57 3.28 3.62 2.97 3.01 4.93 5 3.84 6.49-1.08 1.48-3.57.22-7.34-1.7-1.32-.67-3.35-1.7-4.45-2.03.64.95 2.24 2.57 3.28 3.63 2.97 3.01 4.93 5 3.84 6.49-1.09 1.48-3.58.22-7.35-1.7-1.32-.67-3.35-1.71-4.45-2.03.64.95 2.24 2.58 3.28 3.63 2.97 3.01 4.93 5 3.84 6.49-.21.26-.51.4-.82.4Zm5.56 14.32c-.35 0-.69-.19-.88-.52-1.04-1.88-2.22-4.02-.91-5.21 1.31-1.2 3.34.18 5.49 1.63.87.59 2.26 1.53 2.93 1.71-.12-.68-.93-2.15-1.45-3.07-1.26-2.27-2.45-4.41-1.14-5.61 1.31-1.2 3.34.18 5.49 1.63.96.65 2.54 1.72 3.1 1.74a1 1 0 0 1 1.27 1.54c-1.31 1.2-3.34-.17-5.49-1.63-.87-.59-2.26-1.53-2.93-1.71.12.68.93 2.15 1.45 3.07 1.26 2.27 2.45 4.41 1.14 5.61-1.31 1.2-3.34-.18-5.49-1.63-.87-.59-2.26-1.53-2.93-1.71.12.68.93 2.14 1.22 2.67.27.48.09 1.09-.39 1.36-.15.09-.32.13-.48.13Zm-54.32-2.89c-.22 0-.44-.04-.67-.14-1.64-.69-1.24-3.11-.81-5.67.17-1.04.45-2.7.33-3.38-.57.39-1.56 1.75-2.18 2.6-1.53 2.09-2.99 4.07-4.62 3.38a.991.991 0 0 1-.53-1.31c.2-.48.73-.72 1.21-.57.52-.21 1.65-1.75 2.34-2.68 1.53-2.09 2.98-4.08 4.62-3.38 1.64.69 1.24 3.11.81 5.67-.17 1.04-.45 2.7-.33 3.38.57-.39 1.56-1.75 2.18-2.6 1.53-2.09 2.98-4.08 4.62-3.38 1.63.69 1.24 3.09.89 5.21-.09.54-.6.91-1.15.83-.54-.09-.92-.6-.83-1.15.1-.59.37-2.24.26-2.92-.57.39-1.56 1.75-2.18 2.6-1.33 1.79-2.59 3.51-3.96 3.51Z",
        fill: "#B3BAC5"
    }), /*#__PURE__*/ (0, $9dQre.jsx)("defs", null, /*#__PURE__*/ (0, $9dQre.jsx)("linearGradient", {
        id: id,
        x1: "26.169",
        y1: "228.621",
        x2: "138.408",
        y2: "116.382",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, $9dQre.jsx)("stop", {
        stopColor: "#C1C7D0"
    }), /*#__PURE__*/ (0, $9dQre.jsx)("stop", {
        offset: ".297",
        stopColor: "#C6CBD4",
        stopOpacity: ".881"
    }), /*#__PURE__*/ (0, $9dQre.jsx)("stop", {
        offset: ".63",
        stopColor: "#D3D7DE",
        stopOpacity: ".748"
    }), /*#__PURE__*/ (0, $9dQre.jsx)("stop", {
        offset: ".98",
        stopColor: "#E9EBEF",
        stopOpacity: ".608"
    }), /*#__PURE__*/ (0, $9dQre.jsx)("stop", {
        offset: "1",
        stopColor: "#EBECF0",
        stopOpacity: ".6"
    }))));
};

});


parcelRegister("l1SNK", function(module, exports) {
$parcel$export(module.exports, "TypeAheadList", () => $b3b7b36819a86857$export$81b66b5b19964713);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $fK3tS = parcelRequire("fK3tS");
var $4vLTk = parcelRequire("4vLTk");

var $afyUO = parcelRequire("afyUO");

var $dASxq = parcelRequire("dASxq");

var $g6Qq4 = parcelRequire("g6Qq4");

var $9L0hy = parcelRequire("9L0hy");

var $cW1gB = parcelRequire("cW1gB");

var $aaLLt = parcelRequire("aaLLt");

var $ex2cJ = parcelRequire("ex2cJ");

var $65Fe1 = parcelRequire("65Fe1");

var $gdUUy = parcelRequire("gdUUy");

var $9PwDt = parcelRequire("9PwDt");

var $fZ0ZI = parcelRequire("fZ0ZI");

var $8aT4G = parcelRequire("8aT4G");

var $5N1Y4 = parcelRequire("5N1Y4");

var $8nLP3 = parcelRequire("8nLP3");

var $fq4QS = parcelRequire("fq4QS");

var $4vgtg = parcelRequire("4vgtg");

var $479du = parcelRequire("479du");

var $kMlEB = parcelRequire("kMlEB");

var $a5c8w = parcelRequire("a5c8w");

var $2bokb = parcelRequire("2bokb");
const $b3b7b36819a86857$var$LIST_ITEM_ESTIMATED_HEIGHT = 64;
const $b3b7b36819a86857$var$LIST_WIDTH = 320;
const $b3b7b36819a86857$var$list = /*#__PURE__*/ (0, $9dQre.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    button: {
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-150, 12px)"}`
    }
});
/**
 * Resolves section title visibility before rows are built so hidden titles do not
 * occupy virtualized list rows. A single populated section keeps the existing
 * no-title behaviour unless it opts in with `showWhenOnlySection`; multiple
 * populated sections show titles by default. `showWhenQueryPresent: false`
 * takes precedence once the query is non-empty.
 */ const $b3b7b36819a86857$var$shouldRenderSectionTitle = ({ isEmptyQuery: isEmptyQuery, populatedSectionCount: populatedSectionCount, section: section })=>{
    var _section$sectionTitle;
    if (!isEmptyQuery && ((_section$sectionTitle = section.sectionTitleDisplay) === null || _section$sectionTitle === void 0 ? void 0 : _section$sectionTitle.showWhenQueryPresent) === false) return false;
    if (populatedSectionCount === 1) {
        var _section$sectionTitle2;
        return ((_section$sectionTitle2 = section.sectionTitleDisplay) === null || _section$sectionTitle2 === void 0 ? void 0 : _section$sectionTitle2.showWhenOnlySection) === true;
    }
    return true;
};
const $b3b7b36819a86857$export$8db52dab09acd16e = ({ isEmptyQuery: isEmptyQuery, itemsLength: itemsLength, sections: sections })=>{
    if (sections.length === 0) return Array.from({
        length: itemsLength
    }, (_, itemIndex)=>({
            type: 'item',
            itemIndex: itemIndex
        }));
    const sortedSections = [
        ...sections
    ].sort((left, right)=>left.startIndex - right.startIndex);
    const sectionsByStartIndex = new Map(sortedSections.map((section)=>[
            section.startIndex,
            section
        ]));
    const rows = [];
    const populatedSectionCount = sortedSections.length;
    for(let itemIndex = 0; itemIndex < itemsLength; itemIndex++){
        const section = sectionsByStartIndex.get(itemIndex);
        if (section) {
            const shouldRenderTitle = $b3b7b36819a86857$var$shouldRenderSectionTitle({
                isEmptyQuery: isEmptyQuery,
                populatedSectionCount: populatedSectionCount,
                section: section
            });
            if (shouldRenderTitle) rows.push({
                type: 'section',
                section: section
            });
        }
        rows.push({
            type: 'item',
            itemIndex: itemIndex
        });
    }
    return rows;
};
const $b3b7b36819a86857$var$TypeaheadAssistiveTextPureComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).memo(({ numberOfResults: numberOfResults })=>{
    const intl = (0, $4vLTk.default)();
    return /*#__PURE__*/ (0, $9dQre.jsx)((0, $9L0hy.AssistiveText), {
        assistiveText: intl.formatMessage((0, $ex2cJ.typeAheadListMessages).searchResultsLabel, {
            itemsLength: numberOfResults
        }),
        // when the popup is open its always in focus
        isInFocus: true,
        id: (0, $4vgtg.TYPE_AHEAD_DECORATION_ELEMENT_ID) + '__popup'
    });
});
const $b3b7b36819a86857$var$TypeAheadListComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).memo(({ items: items, sections: sections, selectedIndex: selectedIndex, isEmptyQuery: isEmptyQuery = true, editorView: editorView, onItemClick: onItemClick, intl: intl, fitHeight: fitHeight, decorationElement: decorationElement, triggerHandler: triggerHandler, moreElementsInQuickInsertViewEnabled: moreElementsInQuickInsertViewEnabled, api: api, showMoreOptionsButton: showMoreOptionsButton, onMoreOptionsClicked: onMoreOptionsClicked })=>{
    var _triggerHandler$getMo, _decorationElement$qu2;
    const listRef = (0, $bSJIT.useRef)();
    const listContainerRef = (0, $bSJIT.useRef)(null);
    const lastInputMethodRef = (0, $bSJIT.useRef)('keyboard');
    const mouseMovedRef = (0, $bSJIT.useRef)(false);
    const lastVisibleIndexes = (0, $bSJIT.useRef)({
        overscanStartIndex: 0,
        overscanStopIndex: 0,
        startIndex: 0,
        stopIndex: 0
    });
    // Exclude view more item from the count
    const itemsLength = showMoreOptionsButton ? Math.max(items.length - 1, 0) : items.length;
    const estimatedHeight = itemsLength * $b3b7b36819a86857$var$LIST_ITEM_ESTIMATED_HEIGHT;
    const [height, setHeight] = (0, $bSJIT.useState)(Math.min(estimatedHeight, fitHeight));
    const [cache, setCache] = (0, $bSJIT.useState)(new (0, $afyUO.CellMeasurerCache)({
        fixedWidth: true,
        defaultHeight: $b3b7b36819a86857$var$LIST_ITEM_ESTIMATED_HEIGHT
    }));
    const listRows = (0, $bSJIT.useMemo)(()=>$b3b7b36819a86857$export$8db52dab09acd16e({
            isEmptyQuery: isEmptyQuery,
            itemsLength: itemsLength,
            sections: sections || []
        }), [
        isEmptyQuery,
        itemsLength,
        sections
    ]);
    const itemRowIndexByItemIndex = (0, $bSJIT.useMemo)(()=>{
        const rowIndexByItemIndex = new Map();
        listRows.forEach((row, rowIndex)=>{
            if (row.type === 'item') rowIndexByItemIndex.set(row.itemIndex, rowIndex);
        });
        return rowIndexByItemIndex;
    }, [
        listRows
    ]);
    const selectedItemRowIndex = selectedIndex >= 0 ? itemRowIndexByItemIndex.get(selectedIndex) ?? -1 : -1;
    const onItemsRendered = (0, $bSJIT.useCallback)((props)=>{
        lastVisibleIndexes.current = props;
    }, []);
    const actions = (0, $bSJIT.useMemo)(()=>({
            onItemClick: onItemClick
        }), [
        onItemClick
    ]);
    const isNavigationKey = (event)=>{
        return [
            'ArrowDown',
            'ArrowUp',
            'Tab',
            'Enter',
            'Shift'
        ].includes(event.key);
    };
    const focusTargetElement = (0, $bSJIT.useCallback)(()=>{
        var _decorationElement$qu;
        //To reset the selected index
        (0, $fq4QS.updateSelectedIndex)(-1, api)(editorView.state, editorView.dispatch);
        listRef.current.scrollToRow(0);
        decorationElement === null || decorationElement === void 0 || (_decorationElement$qu = decorationElement.querySelector(`[role='combobox']`)) === null || _decorationElement$qu === void 0 || _decorationElement$qu.focus();
    }, [
        editorView,
        listRef,
        decorationElement,
        api
    ]);
    const selectNextItem = (0, $bSJIT.useMemo)(()=>(0, $479du.moveSelectedIndex)({
            editorView: editorView,
            direction: 'next',
            api: api
        }), [
        editorView,
        api
    ]);
    const selectPreviousItem = (0, $bSJIT.useMemo)(()=>(0, $479du.moveSelectedIndex)({
            editorView: editorView,
            direction: 'previous',
            api: api
        }), [
        editorView,
        api
    ]);
    const lastVisibleStartIndex = lastVisibleIndexes.current.startIndex;
    const lastVisibleStopIndex = lastVisibleIndexes.current.stopIndex;
    const onScroll = (0, $bSJIT.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ({ scrollUpdateWasRequested: scrollUpdateWasRequested })=>{
        if (!scrollUpdateWasRequested) return;
        // In case the user scroll to a non-visible item like press ArrowUp from the first index
        // We will force the scroll calling the scrollToItem in the useEffect hook
        // When the scroll happens and we render the elements,
        // we still need calculate the items height and re-draw the List.
        // It is possible the item selected became invisible again (because the items height changed)
        // So, we need to wait for height to be calculated. Then we need to check
        // if the selected item is visible or not. If it isn't visible we call the scrollToItem again.
        //
        // We can't do this check in the first frame because that frame is being used by the resetScreenThrottled
        // to calculate each height. THen, we can schedule a new frame when this one finishs.
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                const isViewMoreSelected = showMoreOptionsButton && selectedIndex === itemsLength;
                const isSelectedItemVisible = selectedItemRowIndex >= lastVisibleStartIndex && selectedItemRowIndex <= lastVisibleStopIndex || // view more is always visible, hence no scrolling
                isViewMoreSelected;
                //Should scroll to the list item only when the selectedIndex >= 0 and item is not visible
                if (!isSelectedItemVisible && selectedIndex !== -1) listRef.current.scrollToRow(selectedItemRowIndex);
                else if (selectedIndex === -1) listRef.current.scrollToRow(0);
            });
        });
    }, [
        selectedIndex,
        lastVisibleStartIndex,
        lastVisibleStopIndex,
        itemsLength,
        showMoreOptionsButton,
        selectedItemRowIndex
    ]);
    const onMouseMove = (event, row)=>{
        if (row.type !== 'item') return;
        const itemIndex = row.itemIndex;
        event.preventDefault();
        event.stopPropagation();
        if (selectedIndex === itemIndex) return;
        mouseMovedRef.current = true;
        lastInputMethodRef.current = 'mouse';
        (0, $fq4QS.updateSelectedIndex)(itemIndex, api)(editorView.state, editorView.dispatch);
    };
    (0, $bSJIT.useLayoutEffect)(()=>{
        if (mouseMovedRef.current) mouseMovedRef.current = false;
        else lastInputMethodRef.current = 'keyboard';
    }, [
        selectedIndex
    ]);
    (0, $bSJIT.useLayoutEffect)(()=>{
        if (!listRef.current) return;
        const isViewMoreSelected = showMoreOptionsButton && selectedIndex === itemsLength;
        const isSelectedItemVisible = selectedItemRowIndex >= lastVisibleStartIndex && selectedItemRowIndex <= lastVisibleStopIndex || // view more is always visible, hence no scrolling
        isViewMoreSelected;
        //Should scroll to the list item only when the selectedIndex >= 0 and item is not visible
        if (!isSelectedItemVisible && selectedIndex !== -1) listRef.current.scrollToRow(selectedItemRowIndex);
        else if (selectedIndex === -1) listRef.current.scrollToRow(0);
    }, [
        selectedIndex,
        lastVisibleStartIndex,
        lastVisibleStopIndex,
        itemsLength,
        showMoreOptionsButton,
        selectedItemRowIndex
    ]);
    (0, $bSJIT.useLayoutEffect)(()=>{
        setCache(new (0, $afyUO.CellMeasurerCache)({
            fixedWidth: true,
            defaultHeight: $b3b7b36819a86857$var$LIST_ITEM_ESTIMATED_HEIGHT
        }));
        // When query is updated, sometimes the scroll position of the menu is not at the top
        // Scrolling back to top for consistency
        requestAnimationFrame(()=>{
            var _listContainerRef$cur;
            if ((_listContainerRef$cur = listContainerRef.current) !== null && _listContainerRef$cur !== void 0 && _listContainerRef$cur.firstChild) // Ignored via go/ees005
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            listContainerRef.current.firstChild.scrollTo(0, 0);
        });
    }, [
        items,
        sections
    ]);
    const hasSections = sections && sections.length > 0;
    (0, $bSJIT.useLayoutEffect)(()=>{
        // Exclude view more item from the count
        const itemsToRender = hasSections ? listRows : showMoreOptionsButton ? items.slice(0, -1) : items;
        const height = Math.min(// eslint-disable-next-line @atlassian/perf-linting/no-expensive-computations-in-render -- Ignored via go/ees017 (to be fixed)
        itemsToRender.reduce((prevValue, currentValue, index)=>{
            return prevValue + cache.rowHeight({
                index: index
            });
        }, 0), fitHeight);
        setHeight(height);
    }, [
        listRows,
        items,
        cache,
        fitHeight,
        hasSections,
        showMoreOptionsButton
    ]);
    (0, $bSJIT.useLayoutEffect)(()=>{
        if (!listContainerRef.current) return;
        const { current: element } = listContainerRef;
        /**
     * To handle the key events on the list
     * @param event
     * @example
     */ const handleKeyDown = (event)=>{
            if (isNavigationKey(event)) {
                lastInputMethodRef.current = 'keyboard';
                switch(event.key){
                    case 'ArrowDown':
                        selectNextItem();
                        event.preventDefault();
                        event.stopPropagation();
                        break;
                    case 'ArrowUp':
                        selectPreviousItem();
                        event.preventDefault();
                        event.stopPropagation();
                        break;
                    case 'Tab':
                        event.shiftKey ? selectPreviousItem() : selectNextItem();
                        event.preventDefault();
                        break;
                    case 'Enter':
                        //Enter key quick inserts the selected item.
                        if (!event.isComposing || event.which !== 229 && event.keyCode !== 229) {
                            onItemClick(event.shiftKey ? (0, $aaLLt.SelectItemMode).SHIFT_ENTER : (0, $aaLLt.SelectItemMode).ENTER, selectedIndex, (0, $g6Qq4.INPUT_METHOD).KEYBOARD);
                            event.preventDefault();
                        }
                        break;
                    default:
                        event.preventDefault();
                }
            } else //All the remaining keys sets focus on the typeahead query(inputQuery.tsx))
            focusTargetElement();
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element === null || element === void 0 || element.addEventListener('keydown', handleKeyDown);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element === null || element === void 0 || element.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        editorView.state,
        focusTargetElement,
        selectNextItem,
        selectPreviousItem,
        selectedIndex,
        onItemClick,
        itemsLength
    ]);
    const firstOnlineSupportedRow = (0, $bSJIT.useMemo)(()=>{
        return items.findIndex((item)=>item.isDisabledOffline !== true);
    }, [
        items
    ]);
    const config = triggerHandler === null || triggerHandler === void 0 || (_triggerHandler$getMo = triggerHandler.getMoreOptionsButtonConfig) === null || _triggerHandler$getMo === void 0 ? void 0 : _triggerHandler$getMo.call(triggerHandler, intl);
    const handleClick = ()=>{
        if (onMoreOptionsClicked) onMoreOptionsClicked();
        api === null || api === void 0 || api.core.actions.execute(({ tr: tr })=>{
            (0, $8nLP3.closeTypeAhead)(tr);
            config === null || config === void 0 || config.onClick({
                tr: tr
            });
            return tr;
        });
    };
    const renderRow = ({ index: index, key: key, style: style, parent: parent, isScrolling: isScrolling, isVisible: isVisible })=>{
        const currentRow = listRows[index];
        if (!currentRow) return null;
        const sectionLozenge = currentRow.type === 'section' ? currentRow.section.lozenge : null;
        return /*#__PURE__*/ (0, $9dQre.jsx)((0, $afyUO.CellMeasurer), {
            key: key,
            cache: cache,
            parent: parent,
            columnIndex: 0,
            rowIndex: index
        }, ({ measure: measure })=>/*#__PURE__*/ (0, $9dQre.jsx)((0, $kMlEB.ListRow), {
                measure: measure,
                index: index,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                style: style,
                isVisible: isVisible,
                isScrolling: isScrolling,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                onMouseMove: (e)=>onMouseMove(e, currentRow)
            }, currentRow.type === 'section' ? (0, $5N1Y4.expValEquals)('platform_editor_agent_mentions', 'isEnabled', true) && (0, $gdUUy.fg)('platform_editor_agent_mentions_drop_one_fixes') ? sectionLozenge ? /*#__PURE__*/ (0, $9dQre.jsx)((0, $9PwDt.Box), {
                paddingInline: "space.150",
                paddingBlockStart: "space.150",
                paddingBlockEnd: "space.050"
            }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $fZ0ZI.Inline), {
                as: "span",
                space: "space.075",
                alignBlock: "center"
            }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $8aT4G.Text), {
                as: "span",
                size: "small",
                color: "color.text.subtle",
                weight: "medium"
            }, currentRow.section.title), sectionLozenge)) : /*#__PURE__*/ (0, $9dQre.jsx)((0, $9PwDt.Box), {
                paddingInline: "space.150",
                paddingBlockStart: "space.100",
                paddingBlockEnd: "space.050"
            }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $8aT4G.Text), {
                as: "span",
                size: "small",
                color: "color.text.subtle",
                weight: "medium"
            }, currentRow.section.title)) : /*#__PURE__*/ (0, $9dQre.jsx)((0, $9PwDt.Box), {
                paddingInline: "space.150",
                paddingBlock: "space.050"
            }, sectionLozenge ? /*#__PURE__*/ (0, $9dQre.jsx)((0, $fZ0ZI.Inline), {
                as: "span",
                space: "space.075",
                alignBlock: "center"
            }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $8aT4G.Text), {
                as: "span",
                size: "small",
                color: "color.text.subtle",
                weight: "medium"
            }, currentRow.section.title), sectionLozenge) : /*#__PURE__*/ (0, $9dQre.jsx)((0, $8aT4G.Text), {
                as: "span",
                size: "small",
                color: "color.text.subtle",
                weight: "medium"
            }, currentRow.section.title)) : /*#__PURE__*/ (0, $9dQre.jsx)((0, $2bokb.TypeAheadListItem), {
                key: items[currentRow.itemIndex].title,
                item: items[currentRow.itemIndex],
                firstOnlineSupportedIndex: firstOnlineSupportedRow,
                itemsLength: itemsLength,
                itemIndex: currentRow.itemIndex,
                selectedIndex: selectedIndex,
                // eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
                onItemClick: (mode, itemIndex)=>{
                    actions.onItemClick(mode, itemIndex, (0, $g6Qq4.INPUT_METHOD).MOUSE);
                },
                ariaLabel: (0, $479du.getTypeAheadListAriaLabels)(triggerHandler === null || triggerHandler === void 0 ? void 0 : triggerHandler.trigger, intl, items[currentRow.itemIndex]).listItemAriaLabel,
                moreElementsInQuickInsertViewEnabled: moreElementsInQuickInsertViewEnabled,
                api: api,
                lastInputMethodRef: lastInputMethodRef
            })));
    };
    const popupAriaLabel = (0, $479du.getTypeAheadListAriaLabels)(triggerHandler === null || triggerHandler === void 0 ? void 0 : triggerHandler.trigger, intl).popupAriaLabel;
    if (!Array.isArray(items)) return null;
    const menuGroupId = ((_decorationElement$qu2 = decorationElement.querySelector(`[role='combobox']`)) === null || _decorationElement$qu2 === void 0 ? void 0 : _decorationElement$qu2.getAttribute('aria-controls')) || (0, $4vgtg.TYPE_AHEAD_DECORATION_ELEMENT_ID);
    const EmptyResultView = /*#__PURE__*/ (0, $9dQre.jsx)((0, $9PwDt.Box), {
        paddingBlock: "space.150",
        paddingInline: "space.250"
    }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $8aT4G.Text), {
        align: "center",
        as: "p"
    }, intl.formatMessage((0, $ex2cJ.typeAheadListMessages).emptySearchResults)), /*#__PURE__*/ (0, $9dQre.jsx)((0, $8aT4G.Text), {
        align: "center",
        as: "p"
    }, intl.formatMessage((0, $ex2cJ.typeAheadListMessages).emptySearchResultsSuggestion, {
        buttonName: /*#__PURE__*/ (0, $9dQre.jsx)((0, $8aT4G.Text), {
            weight: "medium"
        }, intl.formatMessage((0, $cW1gB.toolbarInsertBlockMessages).viewMore))
    })));
    const ListContent = /*#__PURE__*/ (0, $9dQre.jsx)((0, $dASxq.List), {
        rowRenderer: renderRow,
        ref: listRef,
        // Skip rendering the view more button in the list
        rowCount: listRows.length,
        rowHeight: cache.rowHeight,
        onRowsRendered: onItemsRendered,
        width: $b3b7b36819a86857$var$LIST_WIDTH,
        onScroll: onScroll,
        height: height,
        overscanRowCount: 3,
        "aria-label": (0, $479du.getTypeAheadListAriaLabels)(undefined, intl).popupAriaLabel,
        containerRole: "presentation",
        role: "listbox",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed)
        css: [
            /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            (0, $9dQre.css)({
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
                button: {
                    padding: `${"var(--ds-space-150, 12px)"} ${"var(--ds-space-150, 12px)"} 11px`,
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
                    'span:last-child span:last-child': {
                        whiteSpace: 'normal'
                    }
                }
            }),
            moreElementsInQuickInsertViewEnabled && $b3b7b36819a86857$var$list
        ]
    });
    return /*#__PURE__*/ (0, $9dQre.jsx)((0, $65Fe1.default), {
        "aria-label": popupAriaLabel,
        "aria-relevant": "additions removals"
    }, /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        id: menuGroupId,
        ref: listContainerRef
    }, !showMoreOptionsButton || itemsLength ? ListContent : EmptyResultView, showMoreOptionsButton && config && /*#__PURE__*/ (0, $9dQre.jsx)((0, $a5c8w.MoreOptions), {
        title: config.title,
        ariaLabel: config.ariaLabel,
        onClick: handleClick,
        isFocused: selectedIndex === itemsLength,
        iconBefore: config.iconBefore,
        lastInputMethodRef: lastInputMethodRef
    }), /*#__PURE__*/ (0, $9dQre.jsx)($b3b7b36819a86857$var$TypeaheadAssistiveTextPureComponent, {
        numberOfResults: itemsLength.toString()
    })));
});
const $b3b7b36819a86857$export$81b66b5b19964713 = (0, $fK3tS.default)($b3b7b36819a86857$var$TypeAheadListComponent);
$b3b7b36819a86857$export$81b66b5b19964713.displayName = 'TypeAheadList';

});
parcelRegister("a5c8w", function(module, exports) {
$parcel$export(module.exports, "MoreOptions", () => $bc0e2bfd487bc2af$export$76421314069e32e1);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $jxkn6 = parcelRequire("jxkn6");

var $kpgiw = parcelRequire("kpgiw");

var $7LtMZ = parcelRequire("7LtMZ");
function $bc0e2bfd487bc2af$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $bc0e2bfd487bc2af$var$buttonStyles = {
    name: "t1j6cq",
    styles: "& > button:hover{background-color:var(--ds-background-neutral-subtle-hovered, #0515240F);}& > button:focus{background-color:var(--ds-background-neutral-subtle-hovered, #0515240F);}"
};
const $bc0e2bfd487bc2af$export$76421314069e32e1 = ({ onClick: onClick, isFocused: isFocused, title: title, ariaLabel: ariaLabel, iconBefore: iconBefore, lastInputMethodRef: lastInputMethodRef })=>{
    const ref = (0, $bSJIT.useRef)(null);
    const isSafari = (0, $jxkn6.getBrowserInfo)().safari;
    (0, $bSJIT.useEffect)(()=>{
        if (isFocused && ref.current) {
            const skipFocusOnSafariHover = isSafari && (lastInputMethodRef === null || lastInputMethodRef === void 0 ? void 0 : lastInputMethodRef.current) === 'mouse';
            if (!skipFocusOnSafariHover) ref.current.focus();
        }
    }, [
        isFocused,
        lastInputMethodRef,
        isSafari
    ]);
    (0, $bSJIT.useEffect)(()=>{
        if (!ref.current) return;
        const { current: element } = ref;
        const handleEnter = (e)=>{
            if (e.key === 'Enter') {
                onClick();
                // Prevent keydown listener in TypeaheadList from handling Enter pressed
                e.stopPropagation();
            }
        };
        // Ignored via go/ees005
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        element === null || element === void 0 || element.addEventListener('keydown', handleEnter);
        return ()=>{
            // Ignored via go/ees005
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            element === null || element === void 0 || element.removeEventListener('keydown', handleEnter);
        };
    });
    return /*#__PURE__*/ (0, $9dQre.jsx)((0, $7LtMZ.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, $9dQre.jsx)("span", {
        css: $bc0e2bfd487bc2af$var$buttonStyles
    }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $kpgiw.default), {
        ref: ref,
        /* eslint-disable-next-line @atlassian/perf-linting/no-unstable-inline-props -- Ignored via go/ees017 (to be fixed) */ onMouseDown: (e)=>{
            if (isSafari) e.preventDefault();
        },
        onClick: onClick,
        iconBefore: iconBefore,
        "aria-label": ariaLabel,
        testId: "type-ahead-more-options-button"
    }, title)));
};

});

parcelRegister("2bokb", function(module, exports) {
$parcel$export(module.exports, "TypeAheadListItem", () => $12004e741fabbb14$export$913373331e95c13e);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $4vLTk = parcelRequire("4vLTk");

var $jxkn6 = parcelRequire("jxkn6");

var $hVGJk = parcelRequire("hVGJk");

var $6iC1e = parcelRequire("6iC1e");

var $aaLLt = parcelRequire("aaLLt");

var $ex2cJ = parcelRequire("ex2cJ");

var $5beht = parcelRequire("5beht");

var $5bbjm = parcelRequire("5bbjm");

var $hqEKl = parcelRequire("hqEKl");

var $kpgiw = parcelRequire("kpgiw");

var $3y2s4 = parcelRequire("3y2s4");

var $gdUUy = parcelRequire("gdUUy");

var $9Abbn = parcelRequire("9Abbn");

var $pEA37 = parcelRequire("pEA37");
function $12004e741fabbb14$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $12004e741fabbb14$export$cfa784b45fc7b21d = /*#__PURE__*/ (0, $9dQre.css)({
    width: "var(--ds-space-500, 40px)",
    height: "var(--ds-space-500, 40px)",
    overflow: 'hidden',
    border: `${"var(--ds-border-width, 1px)"} solid ${"var(--ds-border, #0B120E24)"}`,
    borderRadius: "var(--ds-radius-small, 3px)",
    boxSizing: 'border-box',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    div: {
        width: "var(--ds-space-500, 40px)",
        height: "var(--ds-space-500, 40px)"
    }
});
const $12004e741fabbb14$var$itemIconSizeUpdated = {
    name: "1pc97kj",
    styles: "width:var(--ds-space-400, 32px);height:var(--ds-space-400, 32px);div{width:var(--ds-space-400, 32px);height:var(--ds-space-400, 32px);}"
};
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $12004e741fabbb14$var$itemBody = {
    name: "dblrt7",
    styles: "display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:space-between"
};
const $12004e741fabbb14$var$itemText = /*#__PURE__*/ (0, $9dQre.css)({
    whiteSpace: 'initial',
    color: `${"var(--ds-text, #292A2E)"}`
});
const $12004e741fabbb14$var$itemTitle = {
    name: "1v4psb4",
    styles: "line-height:1.4"
};
const $12004e741fabbb14$var$itemTitleOverride = {
    name: "1mdt16o",
    styles: "font:var(--ds-font-body, normal 400 14px/20px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
};
const $12004e741fabbb14$var$itemDescription = /*#__PURE__*/ (0, $9dQre.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/use-tokens-typography
    fontSize: `${(0, $5bbjm.relativeFontSizeToBase16)(12)};`,
    color: `${"var(--ds-text-subtle, #505258)"};`,
    marginTop: `${"var(--ds-space-050, 4px)"};`
});
const $12004e741fabbb14$var$itemDescriptionOverride = {
    name: "11i1ezp",
    styles: "font:var(--ds-font-body-small, normal 400 12px/16px \"Atlassian Sans\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif);margin-top:0"
};
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $12004e741fabbb14$var$itemAfter = {
    name: "ou8xsw",
    styles: "flex:0 0 auto"
};
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Ignored via go/DSP-18766
const $12004e741fabbb14$var$customRenderItemDivStyle = {
    name: "1679gcj",
    styles: "overflow:hidden;&:focus{box-shadow:inset 2px 0px 0px var(--ds-border-focused, #4688EC);background-color:var(--ds-background-neutral-subtle-hovered, #0515240F);outline:none;}"
};
/**
 * This CSS emulates the desired behaviour with :focus-visible for firefox.
 * Firefox unfortunately does not register keyboard focus if user mouseDown and drag a typeahead item
 * resulting in focus-visible style not drawn.
 */ const $12004e741fabbb14$var$selectionFrame = {
    '& > button:focus': {
        boxShadow: `inset 2px 0px 0px ${"var(--ds-border-focused, #4688EC)"};`,
        backgroundColor: `${"var(--ds-background-neutral-subtle-hovered, #0515240F)"}`,
        outline: 'none',
        '&:active': {
            boxShadow: 'none'
        }
    },
    '& > button:hover': {
        backgroundColor: 'inherit',
        outline: 'none'
    }
};
// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- Ignored via go/DSP-18766
const $12004e741fabbb14$var$selectedStyle = {
    name: "2atq5y",
    styles: "background-color:var(--ds-background-neutral-subtle-hovered, #0515240F);box-shadow:inset 2px 0px 0px var(--ds-border-focused, #4688EC)"
};
const $12004e741fabbb14$var$disabledStyle = {
    name: "v9x70u",
    styles: "color:var(--ds-text-disabled, #080F214A)"
};
const $12004e741fabbb14$var$titleWithLozengeStyle = /*#__PURE__*/ (0, $9dQre.css)({
    display: 'flex',
    alignItems: 'center',
    gap: `${"var(--ds-space-050, 4px)"}`
});
const $12004e741fabbb14$var$lozengeWrapperStyle = {
    name: "ozd7xs",
    styles: "flex-shrink:0"
};
const $12004e741fabbb14$var$FallbackIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).memo(()=>{
    return /*#__PURE__*/ (0, $9dQre.jsx)((0, $6iC1e.default), null);
});
const $12004e741fabbb14$var$noop = ()=>{};
const $12004e741fabbb14$var$CustomItemComponentWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).memo((props)=>{
    const { customRenderItem: customRenderItem, isSelected: isSelected, itemIsDisabled: itemIsDisabled, ariaLabel: ariaLabel, itemsLength: itemsLength, customItemRef: customItemRef, insertSelectedItem: insertSelectedItem, itemIndex: itemIndex } = props;
    const Comp = customRenderItem;
    const listItemClasses = (0, $bSJIT.useMemo)(()=>{
        return [
            $12004e741fabbb14$var$customRenderItemDivStyle,
            isSelected && !itemIsDisabled && $12004e741fabbb14$var$selectedStyle,
            itemIsDisabled && $12004e741fabbb14$var$disabledStyle
        ];
    }, [
        isSelected,
        itemIsDisabled
    ]);
    return /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        "aria-selected": isSelected,
        role: "option",
        "aria-label": ariaLabel,
        "aria-setsize": itemsLength,
        "aria-posinset": itemIndex + 1,
        tabIndex: 0,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
        css: listItemClasses,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `ak-typeahead-item ${isSelected ? 'typeahead-selected-item' : ''}`,
        //CSS classes added for test cases purpose
        ref: customItemRef
    }, /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        "aria-hidden": true
    }, /*#__PURE__*/ (0, $9dQre.jsx)(Comp, {
        onClick: insertSelectedItem,
        isSelected: false,
        onHover: $12004e741fabbb14$var$noop
    })));
});
const $12004e741fabbb14$export$913373331e95c13e = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).memo(({ item: item, itemsLength: itemsLength, selectedIndex: selectedIndex, onItemClick: onItemClick, itemIndex: itemIndex, ariaLabel: ariaLabel, moreElementsInQuickInsertViewEnabled: moreElementsInQuickInsertViewEnabled, api: api, firstOnlineSupportedIndex: firstOnlineSupportedIndex, lastInputMethodRef: lastInputMethodRef })=>{
    const isSafari = (0, $jxkn6.getBrowserInfo)().safari;
    const { connectivityMode: connectivityMode } = (0, $5beht.useSharedPluginStateWithSelector)(api, [
        'connectivity'
    ], (states)=>{
        var _states$connectivityS;
        return {
            connectivityMode: (_states$connectivityS = states.connectivityState) === null || _states$connectivityS === void 0 ? void 0 : _states$connectivityS.mode
        };
    });
    const isItemDisabled = (item)=>(0, $hVGJk.isOfflineMode)(connectivityMode) && ((item === null || item === void 0 ? void 0 : item.isDisabledOffline) ?? false);
    const itemIsDisabled = (item === null || item === void 0 ? void 0 : item.isNonInteractive) === true || isItemDisabled(item);
    const isFirstEnabledIndex = (0, $hVGJk.isOfflineMode)(connectivityMode) && itemIndex === firstOnlineSupportedIndex && selectedIndex === -1;
    /**
   * To select and highlight the first Item when no item is selected
   * However selectedIndex remains -1, So that user does not skip the first item when down arrow key is used from typeahead query(inputQuery.tsx)
   */ let isSelected = false;
    // Feature gated - connectivity is only available on desktop and behind a feature gate on full page mode
    if (connectivityMode === undefined) isSelected = itemIndex === selectedIndex || selectedIndex === -1 && itemIndex === 0;
    else isSelected = itemIndex === selectedIndex || selectedIndex === -1 && (itemIndex === 0 || isFirstEnabledIndex) && !itemIsDisabled;
    // Assistive text
    const intl = (0, $4vLTk.default)();
    const descriptionText = item.description ? `${item.description}.` : '';
    const shortcutText = item.keyshortcut ? ` ${intl.formatMessage((0, $ex2cJ.typeAheadListMessages).shortcutLabel)} ${item.keyshortcut}.` : '';
    const descriptionId = `typeahead-item-description-${itemIndex}`;
    const { icon: icon, title: title, render: customRenderItem } = item;
    const skillTag = (0, $bSJIT.useMemo)(()=>(0, $3y2s4.isExperimentEnabled)('display_skill_lozenge_in_editor') ? (0, $pEA37.parseSkillTagTitle)(title) : undefined, [
        title
    ]);
    const elementIcon = (0, $bSJIT.useMemo)(()=>{
        return /*#__PURE__*/ (0, $9dQre.jsx)("div", {
            css: [
                $12004e741fabbb14$export$cfa784b45fc7b21d,
                moreElementsInQuickInsertViewEnabled && $12004e741fabbb14$var$itemIconSizeUpdated
            ]
        }, icon ? icon() : /*#__PURE__*/ (0, $9dQre.jsx)($12004e741fabbb14$var$FallbackIcon, null));
    }, [
        icon,
        moreElementsInQuickInsertViewEnabled
    ]);
    const insertSelectedItem = (0, $bSJIT.useCallback)(()=>{
        if (itemIsDisabled) return;
        onItemClick((0, $aaLLt.SelectItemMode).SELECTED, itemIndex);
    }, [
        onItemClick,
        itemIndex,
        itemIsDisabled
    ]);
    const customItemRef = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useRef(null);
    const buttonItemRef = (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).useRef(null);
    const shouldUpdateFocus = selectedIndex === itemIndex && !isFirstEnabledIndex && (item === null || item === void 0 ? void 0 : item.isNonInteractive) !== true;
    const listItemClasses = (0, $bSJIT.useMemo)(()=>{
        return [
            $12004e741fabbb14$var$selectionFrame,
            isSelected && !itemIsDisabled && $12004e741fabbb14$var$selectedStyle
        ];
    }, [
        isSelected,
        itemIsDisabled
    ]);
    (0, $bSJIT.useLayoutEffect)(()=>{
        if (shouldUpdateFocus) {
            const skipFocusOnSafariHover = isSafari && (lastInputMethodRef === null || lastInputMethodRef === void 0 ? void 0 : lastInputMethodRef.current) === 'mouse';
            if (!skipFocusOnSafariHover) {
                var _customItemRef$curren;
                customItemRef === null || customItemRef === void 0 || (_customItemRef$curren = customItemRef.current) === null || _customItemRef$curren === void 0 || _customItemRef$curren.focus();
            }
        }
    }, [
        customItemRef,
        shouldUpdateFocus,
        lastInputMethodRef,
        isSafari
    ]);
    (0, $bSJIT.useLayoutEffect)(()=>{
        if (shouldUpdateFocus) {
            const skipFocusOnSafariHover = isSafari && (lastInputMethodRef === null || lastInputMethodRef === void 0 ? void 0 : lastInputMethodRef.current) === 'mouse';
            if (!skipFocusOnSafariHover) {
                var _buttonItemRef$curren;
                buttonItemRef === null || buttonItemRef === void 0 || (_buttonItemRef$curren = buttonItemRef.current) === null || _buttonItemRef$curren === void 0 || _buttonItemRef$curren.focus();
            }
        }
    }, [
        buttonItemRef,
        shouldUpdateFocus,
        lastInputMethodRef,
        isSafari
    ]);
    if (customRenderItem) return /*#__PURE__*/ (0, $9dQre.jsx)($12004e741fabbb14$var$CustomItemComponentWrapper, {
        itemIsDisabled: itemIsDisabled,
        customRenderItem: customRenderItem,
        isSelected: isSelected,
        ariaLabel: ariaLabel,
        itemsLength: itemsLength,
        customItemRef: customItemRef,
        insertSelectedItem: insertSelectedItem,
        itemIndex: itemIndex
    });
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $9dQre.jsx)("span", {
        css: listItemClasses
    }, (descriptionText || shortcutText) && /*#__PURE__*/ (0, $9dQre.jsx)((0, $9Abbn.default), {
        id: descriptionId
    }, descriptionText, " ", shortcutText), /*#__PURE__*/ (0, $9dQre.jsx)((0, $kpgiw.default), {
        onClick: insertSelectedItem,
        iconBefore: elementIcon,
        isSelected: isSelected,
        // `aria-selected` already conveys which option is selected, so `aria-current` is
        // inappropriate here (A11Y-32552). When the gate is off we fall back to the
        // `aria-current="true"` that ButtonItem applies for selected items.
        "aria-current": !(0, $gdUUy.fg)('platform_editor_a11y_quick_insert_aria_current') && isSelected ? 'true' : undefined,
        "aria-selected": isSelected,
        "aria-label": (skillTag === null || skillTag === void 0 ? void 0 : skillTag.name) ?? title,
        "aria-describedby": descriptionText || shortcutText ? descriptionId : undefined,
        "aria-setsize": itemsLength,
        "aria-posinset": itemIndex + 1,
        role: "option",
        ref: buttonItemRef,
        isDisabled: itemIsDisabled,
        testId: item.testId,
        // @ts-ignore
        css: listItemClasses
    }, /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        "aria-hidden": true
    }, /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        css: [
            $12004e741fabbb14$var$itemText
        ]
    }, /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        css: $12004e741fabbb14$var$itemBody
    }, /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        css: [
            $12004e741fabbb14$var$itemTitle,
            moreElementsInQuickInsertViewEnabled && $12004e741fabbb14$var$itemTitleOverride,
            itemIsDisabled && $12004e741fabbb14$var$disabledStyle,
            item.lozenge && $12004e741fabbb14$var$titleWithLozengeStyle
        ]
    }, skillTag ? /*#__PURE__*/ (0, $9dQre.jsx)((0, $pEA37.SkillTagLabel), {
        color: skillTag.color,
        slug: skillTag.slug
    }) : item.title, item.lozenge && /*#__PURE__*/ (0, $9dQre.jsx)("span", {
        css: $12004e741fabbb14$var$lozengeWrapperStyle
    }, item.lozenge)), /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        css: $12004e741fabbb14$var$itemAfter
    }, item.keyshortcut && /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        css: (0, $hqEKl.shortcutStyle)
    }, item.keyshortcut))), /*#__PURE__*/ (0, $9dQre.jsx)("div", {
        css: [
            $12004e741fabbb14$var$itemDescription,
            moreElementsInQuickInsertViewEnabled && $12004e741fabbb14$var$itemDescriptionOverride,
            itemIsDisabled && $12004e741fabbb14$var$disabledStyle
        ]
    }, item.description))))));
});

});
parcelRegister("pEA37", function(module, exports) {
$parcel$export(module.exports, "parseSkillTagTitle", () => $c4df27ecf518df67$export$2e64293b1c6450b1);
$parcel$export(module.exports, "SkillTagLabel", () => $c4df27ecf518df67$export$3e8bc5d80e9ade28);
/* SkillTagLabel.tsx generated by @compiled/babel-plugin v3.0.2 */ /* SkillTagLabel.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $jDsoo = parcelRequire("jDsoo");

var $gdUUy = parcelRequire("gdUUy");

var $9PwDt = parcelRequire("9PwDt");

var $8aT4G = parcelRequire("8aT4G");
const $c4df27ecf518df67$var$SKILL_TITLE_PREFIX = 'skill::';
const $c4df27ecf518df67$export$2e64293b1c6450b1 = (title)=>{
    if (!title.startsWith($c4df27ecf518df67$var$SKILL_TITLE_PREFIX)) return undefined;
    const [, color, slug, ...nameParts] = title.split('::');
    const name = nameParts.join('::');
    if (!slug || !name) return undefined;
    return {
        color: color || undefined,
        slug: slug,
        name: name
    };
};
const $c4df27ecf518df67$var$styles = {
    tag: "_1e0c1nu9",
    highlight: "_1e0c1nu9 _16d9qvcn _bfhki8nm",
    highlightStart: "_1e0c1nu9 _19bv1b66 _mkrz1f6o",
    highlightEnd: "_1e0c1nu9 _u5f31b66 _mkrz1gdk",
    slash: "_1e0c1nu9 _u5f31b66",
    legacyTag: "_2rkolb4i _1e0c1nu9 _16d9qvcn _vchhusvi _18u01b66 _19bv1b66 _u5f31b66 _bfhki8nm",
    legacySlash: "_1e0c1nu9 _2hwx1b66"
};
// Slash accent colors for a Rovo skill, mirroring the enum used by the inserted skill chip
// (@atlassian/rovo-platform-ui-components/skills/skill-colors). Duplicated here — rather than
// imported — so this shared, product-agnostic editor package doesn't take on a dependency on an
// ai-mate/Rovo UI package. Modelled as a finite cssMap (rather than a runtime style override) so
// each color resolves to a static, ratcheted style.
const $c4df27ecf518df67$var$accentColorStyles = {
    LIME: "_syaz1tco",
    RED: "_syaz9lu1",
    ORANGE: "_syazp1lv",
    YELLOW: "_syazfb2s",
    GREEN: "_syazh55r",
    TEAL: "_syaz17qg",
    BLUE: "_syaz16jw",
    PURPLE: "_syazqmo9",
    MAGENTA: "_syaz1s8m",
    GRAY: "_syaz1sqi",
    DEFAULT: "_syazazsu"
};
const $c4df27ecf518df67$var$isAccentColor = (color)=>Boolean(color && color in $c4df27ecf518df67$var$accentColorStyles);
const $c4df27ecf518df67$export$3e8bc5d80e9ade28 = ({ color: color, slug: slug })=>{
    const accentColor = $c4df27ecf518df67$var$isAccentColor(color) ? color : 'DEFAULT';
    if ((0, $gdUUy.fg)('rovo_skill_tag_slanted_background_killswitch')) return /*#__PURE__*/ (0, $dc70d.jsxs)((0, $9PwDt.Box), {
        as: "span",
        xcss: $c4df27ecf518df67$var$styles.legacyTag,
        testId: "skill-tag-label-container",
        children: [
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
                as: "span",
                xcss: (0, $jDsoo.cx)($c4df27ecf518df67$var$styles.legacySlash, $c4df27ecf518df67$var$accentColorStyles[accentColor]),
                children: "/"
            }),
            /*#__PURE__*/ (0, $dc70d.jsx)((0, $8aT4G.Text), {
                as: "span",
                children: slug
            })
        ]
    });
    const slugBeforeLastCharacter = slug.slice(0, -1);
    const lastSlugCharacter = slug.slice(-1);
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
        as: "span",
        xcss: $c4df27ecf518df67$var$styles.tag,
        testId: "skill-tag-label-container",
        children: /*#__PURE__*/ (0, $dc70d.jsxs)((0, $8aT4G.Text), {
            as: "span",
            children: [
                /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
                    as: "span",
                    xcss: (0, $jDsoo.cx)($c4df27ecf518df67$var$styles.highlight, $c4df27ecf518df67$var$styles.highlightStart, $c4df27ecf518df67$var$styles.slash, $c4df27ecf518df67$var$accentColorStyles[accentColor]),
                    children: "/"
                }),
                slugBeforeLastCharacter && /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
                    as: "span",
                    xcss: $c4df27ecf518df67$var$styles.highlight,
                    children: slugBeforeLastCharacter
                }),
                lastSlugCharacter && /*#__PURE__*/ (0, $dc70d.jsx)((0, $9PwDt.Box), {
                    as: "span",
                    xcss: (0, $jDsoo.cx)($c4df27ecf518df67$var$styles.highlight, $c4df27ecf518df67$var$styles.highlightEnd),
                    children: lastSlugCharacter
                })
            ]
        })
    });
};

});







parcelRegister("gayoi", function(module, exports) {
$parcel$export(module.exports, "undoRedoPlugin", () => $4c396da8be68a257$export$dcdc7fc7ecd3098);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $g6Qq4 = parcelRequire("g6Qq4");

var $f7Kk4 = parcelRequire("f7Kk4");

var $gNUrD = parcelRequire("gNUrD");

var $jVAei = parcelRequire("jVAei");

var $797yE = parcelRequire("797yE");

var $aXZOo = parcelRequire("aXZOo");

var $8bbYH = parcelRequire("8bbYH");

var $5tJEw = parcelRequire("5tJEw");

var $eo36j = parcelRequire("eo36j");

var $d0nCE = parcelRequire("d0nCE");

var $cvNye = parcelRequire("cvNye");

var $6VTbc = parcelRequire("6VTbc");
const $4c396da8be68a257$export$dcdc7fc7ecd3098 = ({ api: api, config: config })=>{
    const showToolbarButton = (config === null || config === void 0 ? void 0 : config.showToolbarButton) ?? true;
    const editorViewRef = {
        current: null
    };
    const isToolbarAIFCEnabled = Boolean(api === null || api === void 0 ? void 0 : api.toolbar);
    const primaryToolbarComponent = ({ editorView: editorView, disabled: disabled, isToolbarReducedSpacing: isToolbarReducedSpacing })=>{
        if (!editorView) return null;
        return /*#__PURE__*/ (0, $dc70d.jsx)((0, $cvNye.default), {
            isReducedSpacing: isToolbarReducedSpacing,
            disabled: disabled,
            editorView: editorView,
            api: api
        });
    };
    if (showToolbarButton) {
        if (isToolbarAIFCEnabled) {
            var _api$toolbar;
            api === null || api === void 0 || (_api$toolbar = api.toolbar) === null || _api$toolbar === void 0 || _api$toolbar.actions.registerComponents((0, $6VTbc.getToolbarComponents)(api));
        } else {
            var _api$primaryToolbar;
            api === null || api === void 0 || (_api$primaryToolbar = api.primaryToolbar) === null || _api$primaryToolbar === void 0 || _api$primaryToolbar.actions.registerComponent({
                name: 'undoRedoPlugin',
                component: primaryToolbarComponent
            });
        }
    }
    const handleUndo = (inputSource)=>{
        var _api$analytics;
        if (!editorViewRef.current) return false;
        return (0, $d0nCE.forceFocus)(editorViewRef.current, api)((0, $aXZOo.attachInputMetaWithAnalytics)(api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions)(inputSource || (0, $8bbYH.InputSource).EXTERNAL, (0, $g6Qq4.ACTION).UNDO_PERFORMED)((0, $jVAei.undo)));
    };
    const handleRedo = (inputSource)=>{
        var _api$analytics2;
        if (!editorViewRef.current) return false;
        return (0, $d0nCE.forceFocus)(editorViewRef.current, api)((0, $aXZOo.attachInputMetaWithAnalytics)(api === null || api === void 0 || (_api$analytics2 = api.analytics) === null || _api$analytics2 === void 0 ? void 0 : _api$analytics2.actions)(inputSource || (0, $8bbYH.InputSource).EXTERNAL, (0, $g6Qq4.ACTION).REDO_PERFORMED)((0, $gNUrD.redo)));
    };
    const showPrimaryToolbarComponent = !(api !== null && api !== void 0 && api.primaryToolbar) && !isToolbarAIFCEnabled && showToolbarButton;
    return {
        name: 'undoRedoPlugin',
        actions: {
            undo: handleUndo,
            redo: handleRedo
        },
        pmPlugins () {
            const plugins = [
                {
                    name: 'undoRedoKeyMap',
                    plugin: ()=>(0, $5tJEw.keymapPlugin)(api)
                },
                {
                    name: 'undoRedoPlugin',
                    plugin: (options)=>(0, $eo36j.createPlugin)(options)
                }
            ];
            if ((0, $797yE.editorExperiment)('platform_editor_controls', 'variant1', {
                exposure: false
            })) plugins.push({
                name: 'undoRedoGetEditorViewReferencePlugin',
                plugin: ()=>{
                    return new (0, $f7Kk4.SafePlugin)({
                        view: (editorView)=>{
                            editorViewRef.current = editorView;
                            return {
                                destroy: ()=>{
                                    editorViewRef.current = null;
                                }
                            };
                        }
                    });
                }
            });
            return plugins;
        },
        primaryToolbarComponent: showPrimaryToolbarComponent ? primaryToolbarComponent : undefined
    };
};

});
parcelRegister("aXZOo", function(module, exports) {
$parcel$export(module.exports, "attachInputMeta", () => $d890f97c548985ad$export$84d159245233a2bb);
$parcel$export(module.exports, "attachInputMetaWithAnalytics", () => $d890f97c548985ad$export$5b05f10224c3caf8);

var $g6Qq4 = parcelRequire("g6Qq4");

var $cPyt7 = parcelRequire("cPyt7");

var $5NaaJ = parcelRequire("5NaaJ");

var $8bbYH = parcelRequire("8bbYH");

var $2cbKj = parcelRequire("2cbKj");
const $d890f97c548985ad$export$84d159245233a2bb = (inputSource)=>(command)=>(state, dispatch)=>{
            let customTr = state.tr;
            const fakeDispatch = (tr)=>{
                customTr = tr;
            };
            command(state, fakeDispatch);
            if (!customTr || !customTr.docChanged) return false;
            customTr.setMeta((0, $2cbKj.pluginKey), inputSource);
            if (dispatch) dispatch(customTr);
            return true;
        };
const $d890f97c548985ad$var$inputSourceToInputMethod = (inputSource)=>{
    switch(inputSource){
        case (0, $8bbYH.InputSource).EXTERNAL:
            return (0, $g6Qq4.INPUT_METHOD).EXTERNAL;
        case (0, $8bbYH.InputSource).KEYBOARD:
            return (0, $g6Qq4.INPUT_METHOD).KEYBOARD;
        case (0, $8bbYH.InputSource).TOOLBAR:
            return (0, $g6Qq4.INPUT_METHOD).TOOLBAR;
        default:
            return (0, $g6Qq4.INPUT_METHOD).EXTERNAL;
    }
};
function $d890f97c548985ad$var$getNodesWithDifferingAttributes({ before: before, after: after }) {
    const allAttributeKeys = Object.keys({
        ...before.attrs,
        ...after.attrs
    });
    const differingAttributes = allAttributeKeys.filter((key)=>before.attrs[key] !== after.attrs[key]);
    const affectedNodes = differingAttributes.length ? [
        {
            type: before.type.name,
            attributes: differingAttributes
        }
    ] : [];
    return before.children.reduce((acc, beforeChild, index)=>[
            ...acc,
            ...$d890f97c548985ad$var$getNodesWithDifferingAttributes({
                before: beforeChild,
                after: after.child(index)
            })
        ], affectedNodes);
}
function $d890f97c548985ad$export$db14845dcbb6e6df({ before: before, after: after }) {
    const hasChanged = !(0, $cPyt7.areNodesEqualIgnoreAttrs)(after, before);
    const affectedNodes = hasChanged ? undefined : $d890f97c548985ad$var$getNodesWithDifferingAttributes({
        before: before,
        after: after
    })// Limit to 25 nodes to avoid oversize payloads
    .slice(0, 25);
    return {
        hasChanged: hasChanged,
        affectedNodes: affectedNodes
    };
}
const $d890f97c548985ad$export$5b05f10224c3caf8 = (editorAnalyticsAPI)=>(inputSource, action)=>(command)=>$d890f97c548985ad$export$84d159245233a2bb(inputSource)((0, $5NaaJ.withAnalytics)(editorAnalyticsAPI, ({ doc: before }, { currentDoc: after })=>({
                    eventType: (0, $g6Qq4.EVENT_TYPE).TRACK,
                    action: action,
                    actionSubject: (0, $g6Qq4.ACTION_SUBJECT).EDITOR,
                    attributes: {
                        inputMethod: $d890f97c548985ad$var$inputSourceToInputMethod(inputSource),
                        ...$d890f97c548985ad$export$db14845dcbb6e6df({
                            before: before,
                            after: after
                        })
                    }
                }))(command));

});
parcelRegister("8bbYH", function(module, exports) {
$parcel$export(module.exports, "InputSource", () => $96e6d3cabae85f96$export$c3de12c0810a343d);
// NOTE: The string values below intentionally duplicate the values of the
// matching `INPUT_METHOD` members in `@atlaskit/editor-common/analytics`
// (`TOOLBAR='toolbar'`, `KEYBOARD='keyboard'`, `EXTERNAL='external'`).
// Under TypeScript's `--isolatedDeclarations`, enum member initializers cannot
// reference external symbols (TS9020), so we cannot write
// `TOOLBAR = INPUT_METHOD.TOOLBAR`. If you change a value here, update the
// corresponding `INPUT_METHOD` member to match — these strings are written
// straight into transaction meta in `attach-input-meta.ts` and surface as
// the `historyTriggerMethod` analytics attribute (asserted in
// `editor-plugin-undo-redo-tests/.../analytics-input-method.ts`).
var $96e6d3cabae85f96$export$c3de12c0810a343d = /*#__PURE__*/ function(InputSource) {
    InputSource["TOOLBAR"] = "toolbar";
    InputSource["KEYBOARD"] = "keyboard";
    InputSource["EXTERNAL"] = "external";
    return InputSource;
}({});

});

parcelRegister("2cbKj", function(module, exports) {
$parcel$export(module.exports, "pluginKey", () => $f923130f228d3f96$export$18d4026d1ea86bb1);

var $cw0wu = parcelRequire("cw0wu");
const $f923130f228d3f96$export$18d4026d1ea86bb1 = new (0, $cw0wu.PluginKey)('undoRedoPlugin');

});


parcelRegister("5tJEw", function(module, exports) {
$parcel$export(module.exports, "keymapPlugin", () => $c2dc3d27c3ba2a60$export$e832373cff8dec22);

var $cv8id = parcelRequire("cv8id");

var $f7Kk4 = parcelRequire("f7Kk4");

var $ejrfk = parcelRequire("ejrfk");

var $5alt8 = parcelRequire("5alt8");
function $c2dc3d27c3ba2a60$export$e832373cff8dec22(api) {
    var _api$analytics, _api$analytics2, _api$analytics3;
    const list = {};
    (0, $cv8id.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $cv8id.findKeyMapForBrowser)((0, $cv8id.redo)), (0, $5alt8.redoFromKeyboardWithAnalytics)(api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions), list);
    (0, $cv8id.bindKeymapWithCommand)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $cv8id.findKeyMapForBrowser)((0, $cv8id.redoAlt)), (0, $5alt8.redoFromKeyboardWithAnalytics)(api === null || api === void 0 || (_api$analytics2 = api.analytics) === null || _api$analytics2 === void 0 ? void 0 : _api$analytics2.actions), list);
    (0, $cv8id.bindKeymapWithCommand)(// Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    (0, $cv8id.undo).common, (0, $5alt8.undoFromKeyboardWithAnalytics)(api === null || api === void 0 || (_api$analytics3 = api.analytics) === null || _api$analytics3 === void 0 ? void 0 : _api$analytics3.actions), list);
    return new (0, $f7Kk4.SafePlugin)({
        props: {
            handleKeyDown (view, event) {
                const keyboardEvent = (0, $cv8id.isCapsLockOnAndModifyKeyboardEvent)(event);
                return (0, $ejrfk.keydownHandler)(list)(view, keyboardEvent);
            }
        }
    });
}

});
parcelRegister("5alt8", function(module, exports) {
$parcel$export(module.exports, "undoFromKeyboardWithAnalytics", () => $40b0cf1b4d7162f6$export$4c45d895aa8430e8);
$parcel$export(module.exports, "redoFromKeyboardWithAnalytics", () => $40b0cf1b4d7162f6$export$1f3073e8f226f307);
$parcel$export(module.exports, "undoFromToolbarWithAnalytics", () => $40b0cf1b4d7162f6$export$a9ef7677c700995e);
$parcel$export(module.exports, "redoFromToolbarWithAnalytics", () => $40b0cf1b4d7162f6$export$1746c262152d0cc4);

var $g6Qq4 = parcelRequire("g6Qq4");

var $gNUrD = parcelRequire("gNUrD");

var $jVAei = parcelRequire("jVAei");

var $aXZOo = parcelRequire("aXZOo");

var $8bbYH = parcelRequire("8bbYH");
const $40b0cf1b4d7162f6$export$1d1a6834315b2876 = (0, $aXZOo.attachInputMeta)((0, $8bbYH.InputSource).KEYBOARD)((0, $jVAei.undo));
const $40b0cf1b4d7162f6$export$b51f9da6d7e523d2 = (0, $aXZOo.attachInputMeta)((0, $8bbYH.InputSource).KEYBOARD)((0, $gNUrD.redo));
const $40b0cf1b4d7162f6$export$841850d252e034f0 = (0, $aXZOo.attachInputMeta)((0, $8bbYH.InputSource).TOOLBAR)((0, $jVAei.undo));
const $40b0cf1b4d7162f6$export$11ad0a77a5cc0ccf = (0, $aXZOo.attachInputMeta)((0, $8bbYH.InputSource).TOOLBAR)((0, $gNUrD.redo));
const $40b0cf1b4d7162f6$export$4c45d895aa8430e8 = (editorAnalyticsAPI)=>(0, $aXZOo.attachInputMetaWithAnalytics)(editorAnalyticsAPI)((0, $8bbYH.InputSource).KEYBOARD, (0, $g6Qq4.ACTION).UNDO_PERFORMED)((0, $jVAei.undo));
const $40b0cf1b4d7162f6$export$1f3073e8f226f307 = (editorAnalyticsAPI)=>(0, $aXZOo.attachInputMetaWithAnalytics)(editorAnalyticsAPI)((0, $8bbYH.InputSource).KEYBOARD, (0, $g6Qq4.ACTION).REDO_PERFORMED)((0, $gNUrD.redo));
const $40b0cf1b4d7162f6$export$a9ef7677c700995e = (editorAnalyticsAPI)=>(0, $aXZOo.attachInputMetaWithAnalytics)(editorAnalyticsAPI)((0, $8bbYH.InputSource).TOOLBAR, (0, $g6Qq4.ACTION).UNDO_PERFORMED)((0, $jVAei.undo));
const $40b0cf1b4d7162f6$export$1746c262152d0cc4 = (editorAnalyticsAPI)=>(0, $aXZOo.attachInputMetaWithAnalytics)(editorAnalyticsAPI)((0, $8bbYH.InputSource).TOOLBAR, (0, $g6Qq4.ACTION).REDO_PERFORMED)((0, $gNUrD.redo));

});


parcelRegister("eo36j", function(module, exports) {
$parcel$export(module.exports, "createPlugin", () => $1cb202ecab2b3c12$export$ae829ec7b2625219);

var $f7Kk4 = parcelRequire("f7Kk4");

var $2cbKj = parcelRequire("2cbKj");
const $1cb202ecab2b3c12$export$ae829ec7b2625219 = ({ dispatch: dispatch })=>{
    return new (0, $f7Kk4.SafePlugin)({
        key: (0, $2cbKj.pluginKey)
    });
};

});

parcelRegister("d0nCE", function(module, exports) {
$parcel$export(module.exports, "forceFocus", () => $6675dbc715a3778e$export$4126ecb6f20789f0);
const $6675dbc715a3778e$export$2c9048c8abe91d0d = (editorView, api)=>(command)=>{
        var _api$typeAhead;
        if (!editorView) return false;
        if (api !== null && api !== void 0 && (_api$typeAhead = api.typeAhead) !== null && _api$typeAhead !== void 0 && (_api$typeAhead = _api$typeAhead.actions) !== null && _api$typeAhead !== void 0 && _api$typeAhead.isOpen(editorView.state)) {
            var _api$typeAhead2;
            api === null || api === void 0 || (_api$typeAhead2 = api.typeAhead) === null || _api$typeAhead2 === void 0 || (_api$typeAhead2 = _api$typeAhead2.actions) === null || _api$typeAhead2 === void 0 || _api$typeAhead2.close({
                attachCommand: command,
                insertCurrentQueryAsRawText: false
            });
        } else command(editorView.state, editorView.dispatch);
        return true;
    };
const $6675dbc715a3778e$export$4126ecb6f20789f0 = (editorView, api)=>(command)=>{
        const result = $6675dbc715a3778e$export$2c9048c8abe91d0d(editorView, api)(command);
        if (result && !editorView.hasFocus()) editorView.focus();
        return result;
    };

});

parcelRegister("cvNye", function(module, exports) {
$parcel$export(module.exports, "default", () => $547f7d0d76690049$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $9dQre = parcelRequire("9dQre");

var $fK3tS = parcelRequire("fK3tS");

var $bnf0l = parcelRequire("bnf0l");

var $cv8id = parcelRequire("cv8id");

var $7tsTi = parcelRequire("7tsTi");

var $g42cj = parcelRequire("g42cj");

var $8zO6u = parcelRequire("8zO6u");

var $5beht = parcelRequire("5beht");

var $b9Jhn = parcelRequire("b9Jhn");

var $uBKNk = parcelRequire("uBKNk");

var $5alt8 = parcelRequire("5alt8");

var $d0nCE = parcelRequire("d0nCE");
const $547f7d0d76690049$export$4a0f2fb817767d20 = ({ disabled: disabled, isReducedSpacing: isReducedSpacing, editorView: editorView, api: api, intl: { formatMessage: formatMessage } })=>{
    const { canRedo: canRedo, canUndo: canUndo } = (0, $5beht.useSharedPluginStateWithSelector)(api, [
        'history'
    ], (states)=>{
        var _states$historyState, _states$historyState2;
        return {
            canUndo: (_states$historyState = states.historyState) === null || _states$historyState === void 0 ? void 0 : _states$historyState.canUndo,
            canRedo: (_states$historyState2 = states.historyState) === null || _states$historyState2 === void 0 ? void 0 : _states$historyState2.canRedo
        };
    });
    const handleUndo = ()=>{
        var _api$analytics;
        (0, $d0nCE.forceFocus)(editorView, api)((0, $5alt8.undoFromToolbarWithAnalytics)(api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions));
    };
    const handleRedo = ()=>{
        var _api$analytics2;
        (0, $d0nCE.forceFocus)(editorView, api)((0, $5alt8.redoFromToolbarWithAnalytics)(api === null || api === void 0 || (_api$analytics2 = api.analytics) === null || _api$analytics2 === void 0 ? void 0 : _api$analytics2.actions));
    };
    const labelUndo = formatMessage((0, $7tsTi.messages).undo);
    const labelRedo = formatMessage((0, $7tsTi.messages).redo);
    return(// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $9dQre.jsx)("span", {
        css: // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-imported-style-values
        (0, $g42cj.buttonGroupStyle)
    }, /*#__PURE__*/ (0, $9dQre.jsx)((0, $8zO6u.default), {
        buttonId: (0, $bnf0l.TOOLBAR_ACTION_SUBJECT_ID).UNDO,
        spacing: isReducedSpacing ? 'none' : 'default',
        onClick: handleUndo,
        disabled: !canUndo || disabled,
        "aria-label": (0, $cv8id.tooltip)((0, $cv8id.undo), labelUndo),
        "aria-keyshortcuts": (0, $cv8id.getAriaKeyshortcuts)((0, $cv8id.undo)),
        title: /*#__PURE__*/ (0, $9dQre.jsx)((0, $cv8id.ToolTipContent), {
            description: labelUndo,
            keymap: (0, $cv8id.undo)
        }),
        iconBefore: /*#__PURE__*/ (0, $9dQre.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($uBKNk))), {
            label: "",
            color: "currentColor",
            spacing: "spacious"
        }),
        testId: "ak-editor-toolbar-button-undo"
    }), /*#__PURE__*/ (0, $9dQre.jsx)((0, $8zO6u.default), {
        spacing: isReducedSpacing ? 'none' : 'default',
        buttonId: (0, $bnf0l.TOOLBAR_ACTION_SUBJECT_ID).REDO,
        onClick: handleRedo,
        disabled: !canRedo || disabled,
        title: /*#__PURE__*/ (0, $9dQre.jsx)((0, $cv8id.ToolTipContent), {
            description: labelRedo,
            keymap: (0, $cv8id.redoAlt)
        }),
        iconBefore: /*#__PURE__*/ (0, $9dQre.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b9Jhn))), {
            label: "",
            color: "currentColor",
            spacing: "spacious"
        }),
        testId: "ak-editor-toolbar-button-redo",
        "aria-label": (0, $cv8id.tooltip)((0, $cv8id.redoAlt), labelRedo),
        "aria-keyshortcuts": (0, $cv8id.getAriaKeyshortcuts)((0, $cv8id.redoAlt))
    }), !(api !== null && api !== void 0 && api.primaryToolbar) && /* eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $9dQre.jsx)("span", {
        css: (0, $g42cj.separatorStyles)
    })));
};
// eslint-disable-next-line @typescript-eslint/no-restricted-types
const $547f7d0d76690049$var$_default_1 = (0, $fK3tS.default)($547f7d0d76690049$export$4a0f2fb817767d20);
var $547f7d0d76690049$export$2e2bcd8739ae039 = $547f7d0d76690049$var$_default_1;

});

parcelRegister("6VTbc", function(module, exports) {
$parcel$export(module.exports, "getToolbarComponents", () => $8279b7a66079b03b$export$a758406ca53b86a5);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $4rzOL = parcelRequire("4rzOL");

var $fiku8 = parcelRequire("fiku8");

var $f6IUb = parcelRequire("f6IUb");

var $5gDEv = parcelRequire("5gDEv");

var $inROv = parcelRequire("inROv");

var $3xHwQ = parcelRequire("3xHwQ");
const $8279b7a66079b03b$export$a758406ca53b86a5 = (api)=>{
    var _api$toolbar;
    const breakpointPreset = api === null || api === void 0 || (_api$toolbar = api.toolbar) === null || _api$toolbar === void 0 ? void 0 : _api$toolbar.actions.getBreakpointPreset();
    return [
        {
            type: (0, $4rzOL.UNDO_CHANGES_GROUP).type,
            key: (0, $4rzOL.UNDO_CHANGES_GROUP).key,
            parents: [
                {
                    type: (0, $4rzOL.TRACK_CHANGES_SECTION).type,
                    key: (0, $4rzOL.TRACK_CHANGES_SECTION).key,
                    rank: (0, $fiku8.TRACK_CHANGES_SECTION_RANK)[(0, $4rzOL.UNDO_CHANGES_GROUP).key]
                }
            ],
            component: ({ children: children })=>breakpointPreset === 'jsm-comment' ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $f6IUb.Show), {
                    above: "lg",
                    children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $5gDEv.ToolbarButtonGroup), {
                        children: children
                    })
                }) : /*#__PURE__*/ (0, $dc70d.jsx)((0, $5gDEv.ToolbarButtonGroup), {
                    children: children
                })
        },
        {
            type: (0, $4rzOL.UNDO_BUTTON).type,
            key: (0, $4rzOL.UNDO_BUTTON).key,
            parents: [
                {
                    type: (0, $4rzOL.UNDO_CHANGES_GROUP).type,
                    key: (0, $4rzOL.UNDO_CHANGES_GROUP).key,
                    rank: (0, $fiku8.UNDO_CHANGES_GROUP_RANK)[(0, $4rzOL.UNDO_BUTTON).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $3xHwQ.UndoButton), {
                    api: api
                })
        },
        {
            type: (0, $4rzOL.REDO_CHANGES_GROUP).type,
            key: (0, $4rzOL.REDO_CHANGES_GROUP).key,
            parents: [
                {
                    type: (0, $4rzOL.TRACK_CHANGES_SECTION).type,
                    key: (0, $4rzOL.TRACK_CHANGES_SECTION).key,
                    rank: (0, $fiku8.TRACK_CHANGES_SECTION_RANK)[(0, $4rzOL.REDO_CHANGES_GROUP).key]
                }
            ],
            component: ({ children: children })=>breakpointPreset === 'jsm-comment' ? /*#__PURE__*/ (0, $dc70d.jsx)((0, $f6IUb.Show), {
                    above: "lg",
                    children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $5gDEv.ToolbarButtonGroup), {
                        children: children
                    })
                }) : /*#__PURE__*/ (0, $dc70d.jsx)((0, $5gDEv.ToolbarButtonGroup), {
                    children: children
                })
        },
        {
            type: (0, $4rzOL.REDO_BUTTON).type,
            key: (0, $4rzOL.REDO_BUTTON).key,
            parents: [
                {
                    type: (0, $4rzOL.REDO_CHANGES_GROUP).type,
                    key: (0, $4rzOL.REDO_CHANGES_GROUP).key,
                    rank: (0, $fiku8.REDO_CHANGES_GROUP_RANK)[(0, $4rzOL.REDO_BUTTON).key]
                }
            ],
            component: ()=>/*#__PURE__*/ (0, $dc70d.jsx)((0, $inROv.RedoButton), {
                    api: api
                })
        }
    ];
};

});
parcelRegister("inROv", function(module, exports) {
$parcel$export(module.exports, "RedoButton", () => $966464469147b6a5$export$de10bfe090602e0a);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $cv8id = parcelRequire("cv8id");

var $7tsTi = parcelRequire("7tsTi");

var $28qc1 = parcelRequire("28qc1");

var $5beht = parcelRequire("5beht");

var $b9Jhn = parcelRequire("b9Jhn");

var $7cgYb = parcelRequire("7cgYb");

var $eHnl8 = parcelRequire("eHnl8");

var $5alt8 = parcelRequire("5alt8");

var $d0nCE = parcelRequire("d0nCE");
const $966464469147b6a5$export$de10bfe090602e0a = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const { editorView: editorView } = (0, $28qc1.useEditorToolbar)();
    const { canRedo: canRedo } = (0, $5beht.useSharedPluginStateWithSelector)(api, [
        'history'
    ], (states)=>{
        var _states$historyState;
        return {
            canRedo: (_states$historyState = states.historyState) === null || _states$historyState === void 0 ? void 0 : _states$historyState.canRedo
        };
    });
    const handleRedo = ()=>{
        if (editorView) {
            var _api$analytics;
            (0, $d0nCE.forceFocus)(editorView, api)((0, $5alt8.redoFromToolbarWithAnalytics)(api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions));
        }
    };
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $eHnl8.ToolbarTooltip), {
        content: /*#__PURE__*/ (0, $dc70d.jsx)((0, $cv8id.ToolTipContent), {
            description: formatMessage((0, $7tsTi.messages).redo),
            keymap: (0, $cv8id.redo)
        }),
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $7cgYb.ToolbarButton), {
            iconBefore: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($b9Jhn))), {
                label: formatMessage((0, $7tsTi.messages).redo),
                size: "small"
            }),
            onClick: handleRedo,
            isDisabled: !canRedo,
            ariaKeyshortcuts: (0, $cv8id.getAriaKeyshortcuts)((0, $cv8id.redo)),
            testId: "ak-editor-toolbar-button-redo"
        })
    });
};

});

parcelRegister("3xHwQ", function(module, exports) {
$parcel$export(module.exports, "UndoButton", () => $0428c4d327498f9c$export$f2500353cb92e6ec);

var $dc70d = parcelRequire("dc70d");
parcelRequire("bSJIT");

var $4vLTk = parcelRequire("4vLTk");

var $cv8id = parcelRequire("cv8id");

var $7tsTi = parcelRequire("7tsTi");

var $28qc1 = parcelRequire("28qc1");

var $5beht = parcelRequire("5beht");

var $7cgYb = parcelRequire("7cgYb");

var $eHnl8 = parcelRequire("eHnl8");

var $uBKNk = parcelRequire("uBKNk");

var $5alt8 = parcelRequire("5alt8");

var $d0nCE = parcelRequire("d0nCE");
const $0428c4d327498f9c$export$f2500353cb92e6ec = ({ api: api })=>{
    const { formatMessage: formatMessage } = (0, $4vLTk.default)();
    const { editorView: editorView } = (0, $28qc1.useEditorToolbar)();
    const { canUndo: canUndo } = (0, $5beht.useSharedPluginStateWithSelector)(api, [
        'history'
    ], (states)=>{
        var _states$historyState;
        return {
            canUndo: (_states$historyState = states.historyState) === null || _states$historyState === void 0 ? void 0 : _states$historyState.canUndo
        };
    });
    const handleUndo = ()=>{
        if (editorView) {
            var _api$analytics;
            (0, $d0nCE.forceFocus)(editorView, api)((0, $5alt8.undoFromToolbarWithAnalytics)(api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions));
        }
    };
    return /*#__PURE__*/ (0, $dc70d.jsx)((0, $eHnl8.ToolbarTooltip), {
        content: /*#__PURE__*/ (0, $dc70d.jsx)((0, $cv8id.ToolTipContent), {
            description: formatMessage((0, $7tsTi.messages).undo),
            keymap: (0, $cv8id.undo)
        }),
        children: /*#__PURE__*/ (0, $dc70d.jsx)((0, $7cgYb.ToolbarButton), {
            iconBefore: /*#__PURE__*/ (0, $dc70d.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($uBKNk))), {
                label: formatMessage((0, $7tsTi.messages).undo),
                size: "small"
            }),
            onClick: handleUndo,
            isDisabled: !canUndo,
            ariaKeyshortcuts: (0, $cv8id.getAriaKeyshortcuts)((0, $cv8id.undo)),
            testId: "ak-editor-toolbar-button-undo"
        })
    });
};

});



parcelRegister("ae5yU", function(module, exports) {
$parcel$export(module.exports, "unsupportedContentPlugin", () => $80c6cbda2f07f426$export$fae834324d89b92);

var $f7JVa = parcelRequire("f7JVa");

var $he3wV = parcelRequire("he3wV");

var $d5USw = parcelRequire("d5USw");

var $bkrsJ = parcelRequire("bkrsJ");

var $2hJSm = parcelRequire("2hJSm");

var $d1YmP = parcelRequire("d1YmP");

var $bkZOB = parcelRequire("bkZOB");

var $0Xboy = parcelRequire("0Xboy");

var $f7Kk4 = parcelRequire("f7Kk4");

var $d8JFj = parcelRequire("d8JFj");

var $cw0wu = parcelRequire("cw0wu");

var $3y2s4 = parcelRequire("3y2s4");

var $5JfDH = parcelRequire("5JfDH");

var $67JLG = parcelRequire("67JLG");

var $5W4K6 = parcelRequire("5W4K6");
const $80c6cbda2f07f426$var$pluginKey = new (0, $cw0wu.PluginKey)('unsupportedContentPlugin');
const $80c6cbda2f07f426$var$createPlugin = (pmPluginFactoryParams)=>{
    const { portalProviderAPI: portalProviderAPI, eventDispatcher: eventDispatcher, dispatchAnalyticsEvent: dispatchAnalyticsEvent, getIntl: getIntl } = pmPluginFactoryParams;
    const intl = getIntl();
    return new (0, $f7Kk4.SafePlugin)({
        key: $80c6cbda2f07f426$var$pluginKey,
        props: {
            nodeViews: {
                confluenceUnsupportedBlock: (0, $3y2s4.isExperimentEnabled)('platform_editor_vanilla_node_views_phase1') ? (node)=>new (0, $5JfDH.UnsupportedBlockNodeView)(node, intl, dispatchAnalyticsEvent) : (0, $0Xboy.default).fromComponent((0, $d8JFj.default), portalProviderAPI, eventDispatcher, {
                    dispatchAnalyticsEvent: dispatchAnalyticsEvent
                }, undefined),
                confluenceUnsupportedInline: (0, $3y2s4.isExperimentEnabled)('platform_editor_vanilla_node_views_phase1') ? (node)=>new (0, $5W4K6.UnsupportedInlineNodeViewVanilla)(node, intl, dispatchAnalyticsEvent) : (0, $bkZOB.getInlineNodeViewProducer)({
                    pmPluginFactoryParams: pmPluginFactoryParams,
                    Component: (0, $67JLG.UnsupportedInlineNodeView),
                    extraComponentProps: {
                        dispatchAnalyticsEvent: dispatchAnalyticsEvent
                    }
                }),
                unsupportedBlock: (0, $3y2s4.isExperimentEnabled)('platform_editor_vanilla_node_views_phase1') ? (node)=>new (0, $5JfDH.UnsupportedBlockNodeView)(node, intl, dispatchAnalyticsEvent) : (0, $0Xboy.default).fromComponent((0, $d8JFj.default), portalProviderAPI, eventDispatcher, {
                    dispatchAnalyticsEvent: dispatchAnalyticsEvent
                }, undefined),
                unsupportedInline: (0, $3y2s4.isExperimentEnabled)('platform_editor_vanilla_node_views_phase1') ? (node)=>new (0, $5W4K6.UnsupportedInlineNodeViewVanilla)(node, intl, dispatchAnalyticsEvent) : (0, $bkZOB.getInlineNodeViewProducer)({
                    pmPluginFactoryParams: pmPluginFactoryParams,
                    Component: (0, $67JLG.UnsupportedInlineNodeView),
                    extraComponentProps: {
                        dispatchAnalyticsEvent: dispatchAnalyticsEvent
                    }
                })
            }
        }
    });
};
const $80c6cbda2f07f426$export$fae834324d89b92 = ()=>({
        name: 'unsupportedContent',
        marks () {
            return [
                {
                    name: 'unsupportedMark',
                    mark: (0, $2hJSm.unsupportedMark)
                },
                {
                    name: 'unsupportedNodeAttribute',
                    mark: (0, $d1YmP.unsupportedNodeAttribute)
                }
            ];
        },
        nodes () {
            return [
                {
                    name: 'confluenceUnsupportedBlock',
                    node: (0, $f7JVa.confluenceUnsupportedBlock)
                },
                {
                    name: 'confluenceUnsupportedInline',
                    node: (0, $he3wV.confluenceUnsupportedInline)
                },
                {
                    name: 'unsupportedBlock',
                    node: (0, $d5USw.unsupportedBlock)
                },
                {
                    name: 'unsupportedInline',
                    node: (0, $bkrsJ.unsupportedInline)
                }
            ];
        },
        pmPlugins () {
            return [
                {
                    name: 'unsupportedContent',
                    plugin: $80c6cbda2f07f426$var$createPlugin
                }
            ];
        }
    });

});
parcelRegister("5JfDH", function(module, exports) {
$parcel$export(module.exports, "UnsupportedBlockNodeView", () => $ed22f1bf69bb258d$export$9d67847ab5f2260);

var $bAB3U = parcelRequire("bAB3U");

var $g6Qq4 = parcelRequire("g6Qq4");

var $36uNV = parcelRequire("36uNV");

var $7YV6Z = parcelRequire("7YV6Z");

var $eRA48 = parcelRequire("eRA48");

var $kjMQA = parcelRequire("kjMQA");

var $kW8qW = parcelRequire("kW8qW");

var $bVRlF = parcelRequire("bVRlF");

var $1YYYR = parcelRequire("1YYYR");
/**
 * CSS class names for the vanilla unsupported block node view elements.
 * Corresponding styles are defined in EditorContentContainer (gated behind
 * the platform_editor_vanilla_node_views_phase1 experiment).
 *
 * ⚠️ Renaming any of these requires the same change in BOTH copies of the styles:
 *  - `editor-core/src/ui/EditorContentContainer/styles/unsupportedStyles.ts` (emotion)
 *  - `editor-core/src/ui/EditorContentContainer/EditorContentContainer-compiled.tsx` (cssMap)
 *
 * These cannot be imported by either stylesheet: `cssMap` keys must be statically defined, so
 * the compiled copy hardcodes the strings — as it already does for `UnsupportedSharedCssClassName`.
 * A rename that misses a stylesheet fails loudly in the unsupported-content VR tests, which
 * assert the styled output rather than the class names.
 */ const $ed22f1bf69bb258d$var$VanillaUnsupportedCssClassName = {
    BLOCK_INNER: 'unsupported-block-vanilla-inner',
    ICON: 'unsupported-vanilla-icon'
};
const $ed22f1bf69bb258d$var$TOOLTIP_CLASS_NAME = 'unsupported-content-tooltip';
/** Distinct from the inline node view's prefix, so the counter fallback below cannot collide. */ const $ed22f1bf69bb258d$var$TOOLTIP_ID_PREFIX = 'unsupported-block-content-tooltip';
/** Classes applied to the tooltip element: the shared default look, plus our own hook. */ const $ed22f1bf69bb258d$var$TOOLTIP_CLASS_NAMES = `${(0, $kjMQA.VANILLA_TOOLTIP_DEFAULT_CLASS)} ${$ed22f1bf69bb258d$var$TOOLTIP_CLASS_NAME}`;
/**
 * `crypto.randomUUID()` is undefined outside a secure context. The counter is not the best
 * fallback, but given how widely available the crypto API is, it should be fine.
 *
 * Ideally `VanillaTooltip` would take an optional id and generate its own when one is not
 * supplied, rather than leaving this to every caller.
 */ const $ed22f1bf69bb258d$var$nextTooltipId = (()=>{
    let count = 0;
    return ()=>typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function' ? `${$ed22f1bf69bb258d$var$TOOLTIP_ID_PREFIX}-${crypto.randomUUID()}` : `${$ed22f1bf69bb258d$var$TOOLTIP_ID_PREFIX}-${count += 1}`;
})();
/**
 * Spec for an unsupported block node.
 *
 * The outer wrapper carries the shared CSS class so selection and cursor styles apply.
 * The inner element's `unsupported` class is retained for parity with the React
 * implementation, which products and tests may still select on.
 */ function $ed22f1bf69bb258d$var$getBlockSpec(label) {
    return [
        'div',
        {
            class: (0, $7YV6Z.UnsupportedSharedCssClassName).BLOCK_CONTAINER
        },
        [
            'div',
            {
                class: `unsupported ${$ed22f1bf69bb258d$var$VanillaUnsupportedCssClassName.BLOCK_INNER}`
            },
            [
                'span',
                {},
                label
            ],
            (0, $1YYYR.getUnsupportedContentIconSpec)($ed22f1bf69bb258d$var$VanillaUnsupportedCssClassName.ICON)
        ]
    ];
}
/**
 * Creates the DOM structure for an unsupported content node view.
 *
 * Matches the React version's two-level structure:
 *   outer wrapper (gets the shared CSS class — unsupportedBlockView-content-wrap)
 *     └── inner div (gets visual styles from EditorContentContainer CSS)
 *           ├── text label (span)
 *           └── icon (span, tooltip trigger)
 *
 * Visual styles (background, border, flex) are applied via EditorContentContainer CSS on
 * `.unsupportedBlockView-content-wrap > div`, matching how the existing selection/cursor
 * styles already work.
 */ function $ed22f1bf69bb258d$var$createUnsupportedDOM(node, intl) {
    const label = (0, $bVRlF.getUnsupportedContent)((0, $36uNV.unsupportedContentMessages).unsupportedBlockContent, `${(0, $36uNV.unsupportedContentMessages).unsupportedBlockContent.defaultMessage}:`, node, intl);
    const { dom: dom } = (0, $kW8qW.DOMSerializer).renderSpec(document, $ed22f1bf69bb258d$var$getBlockSpec(label));
    const domElement = dom instanceof HTMLElement ? dom : undefined;
    const icon = (domElement === null || domElement === void 0 ? void 0 : domElement.querySelector(`.${$ed22f1bf69bb258d$var$VanillaUnsupportedCssClassName.ICON}`)) ?? null;
    return {
        dom: dom,
        icon: icon
    };
}
class $ed22f1bf69bb258d$export$9d67847ab5f2260 {
    constructor(node, intl, dispatchAnalyticsEvent){
        this.tooltip = null;
        this.unbindMouseenter = null;
        this.node = node;
        const { dom: dom, icon: icon } = $ed22f1bf69bb258d$var$createUnsupportedDOM(node, intl);
        this.dom = dom;
        if (!icon) return;
        // Lazy-init: create the VanillaTooltip on first mouseenter.
        // Inline styles are required because the Popover API promotes the tooltip to the
        // browser's top layer, where ancestor CSS selectors cannot reach it.
        const initTooltip = (event)=>{
            var _this$unbindMouseente;
            // Unbind before re-dispatching below, so this listener is not re-entered by the
            // synthetic event. Matches `EmojiNodeView`.
            (_this$unbindMouseente = this.unbindMouseenter) === null || _this$unbindMouseente === void 0 || _this$unbindMouseente.call(this);
            this.unbindMouseenter = null;
            const tooltipText = intl.formatMessage((0, $36uNV.unsupportedContentMessages).unsupportedContentTooltip);
            this.tooltip = new (0, $kjMQA.VanillaTooltip)(icon, tooltipText, $ed22f1bf69bb258d$var$nextTooltipId(), $ed22f1bf69bb258d$var$TOOLTIP_CLASS_NAMES, 300, // Styling comes from the classes above, defined in the EditorContentContainer stylesheets.
            undefined, // Fired once the tooltip is actually visible, rather than on hover intent, so the
            // analytics match the React implementation's `<Tooltip onShow>`.
            dispatchAnalyticsEvent ? ()=>{
                var _this$node;
                return (0, $eRA48.trackUnsupportedContentTooltipDisplayedFor)(dispatchAnalyticsEvent, (0, $g6Qq4.ACTION_SUBJECT_ID).ON_UNSUPPORTED_BLOCK, (_this$node = this.node) === null || _this$node === void 0 || (_this$node = _this$node.attrs) === null || _this$node === void 0 || (_this$node = _this$node.originalValue) === null || _this$node === void 0 ? void 0 : _this$node.type);
            } : undefined);
            // VanillaTooltip binds its own `mouseenter` listener inside its constructor.
            // Listeners added while an event is being dispatched are not invoked for that
            // same event, so without re-dispatching, the tooltip would stay hidden until
            // the user hovered away and back. Matches `EmojiNodeView`, which lazy-inits
            // the same way.
            icon.dispatchEvent(new Event(event.type));
        };
        this.unbindMouseenter = (0, $bAB3U.bind)(icon, {
            type: 'mouseenter',
            listener: initTooltip,
            options: {
                once: true
            }
        });
    }
    update(node) {
        if (node.type !== this.node.type) return false;
        // originalValue attrs are immutable — label never changes.
        // Track node reference so analytics can read the latest attrs.
        this.node = node;
        return true;
    }
    destroy() {
        var _this$tooltip, _this$unbindMouseente2;
        (_this$tooltip = this.tooltip) === null || _this$tooltip === void 0 || _this$tooltip.destroy();
        this.tooltip = null;
        (_this$unbindMouseente2 = this.unbindMouseenter) === null || _this$unbindMouseente2 === void 0 || _this$unbindMouseente2.call(this);
        this.unbindMouseenter = null;
    }
}

});
parcelRegister("bVRlF", function(module, exports) {
$parcel$export(module.exports, "getUnsupportedContent", () => $095da5d66e8ac333$export$d4ded51d0f0bd2df);
function $095da5d66e8ac333$export$d4ded51d0f0bd2df(// Ignored via go/ees005
// eslint-disable-next-line @typescript-eslint/no-explicit-any
message, prefix, node, intl) {
    const defaultLocale = 'en';
    let canTranslateToLocale = true;
    const locale = intl ? intl.locale : defaultLocale;
    let finalMessage = message.defaultMessage;
    if (node && locale.startsWith(defaultLocale)) {
        // `confluenceUnsupportedBlock` and `confluenceUnsupportedInline` are declared with a
        // `cxhtml` attribute and no `originalValue`, so this must not assume it exists.
        //
        // NOTE: intentional deviation from the `@atlaskit/editor-common` original, which throws a
        // TypeError for those node types. In the React node views that throw is swallowed by
        // `ReactNodeView`'s ErrorBoundary; a vanilla node view has no such boundary, so it would
        // propagate out of the ProseMirror node view constructor. Keep this guard when the
        // duplication is resolved.
        //
        // @see https://hello.jira.atlassian.cloud/jira/browse/EDITOR-8637
        const { originalValue: originalValue } = node.attrs;
        if (originalValue) {
            if (originalValue.text || originalValue.attrs && originalValue.attrs.text) {
                finalMessage = originalValue.text ? originalValue.text : originalValue.attrs.text;
                canTranslateToLocale = false;
            } else if (originalValue.type) {
                finalMessage = `${prefix} ${originalValue.type}`;
                canTranslateToLocale = false;
            }
        }
    }
    if (intl && canTranslateToLocale) return intl.formatMessage(message);
    return finalMessage;
}

});

parcelRegister("1YYYR", function(module, exports) {
$parcel$export(module.exports, "getUnsupportedContentIconSpec", () => $b5e0f8811a86b9da$export$a9413459ee06c46a);
// Question circle icon SVG — source: @atlaskit/icon/core/question-circle.
const $b5e0f8811a86b9da$var$QUESTION_ICON_SVG = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" role="presentation" style="display:block">
  <path fill="currentColor" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-3c-.586 0-1 .414-1 1H5.5c0-1.414 1.086-2.5 2.5-2.5s2.5 1.086 2.5 2.5c0 1.133-.713 1.706-1.162 2.058-.511.402-.588.494-.588.692v.75h-1.5v-.75c0-.977.689-1.507 1.078-1.806l.084-.065C8.838 6.544 9 6.367 9 6c0-.586-.414-1-1-1"/>
  <path fill="currentColor" d="M9 11.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>
</svg>`;
/**
 * Parsing the SVG markup is the same work for every unsupported node, so the template is
 * built once and reused.
 *
 * Only the parse is cached: appending a `DocumentFragment` moves its children out of it, so
 * each caller needs its own clone — sharing one fragment would leave every icon after the
 * first empty.
 */ const $b5e0f8811a86b9da$var$getIconFragment = (()=>{
    let template;
    return ()=>{
        if (!template) {
            template = document.createElement('template');
            template.innerHTML = $b5e0f8811a86b9da$var$QUESTION_ICON_SVG;
        }
        return template.content.cloneNode(true);
    };
})();
function $b5e0f8811a86b9da$export$a9413459ee06c46a(iconClassName) {
    return [
        'span',
        {
            class: iconClassName,
            role: 'img',
            'aria-label': '?'
        },
        $b5e0f8811a86b9da$var$getIconFragment()
    ];
}

});


parcelRegister("67JLG", function(module, exports) {
$parcel$export(module.exports, "UnsupportedInlineNodeView", () => $fac62ac8a8286888$export$b963567668795b80);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $lmZMT = parcelRequire("lmZMT");
const $fac62ac8a8286888$export$b963567668795b80 = (props)=>{
    // Ignored via go/ees005
    // eslint-disable-next-line react/jsx-props-no-spreading
    return /*#__PURE__*/ (0, $9dQre.jsx)((0, $lmZMT.default), props);
};

});

parcelRegister("5W4K6", function(module, exports) {
$parcel$export(module.exports, "UnsupportedInlineNodeViewVanilla", () => $0aa5398ebb1e0dfa$export$81269ac65e4cceef);

var $bAB3U = parcelRequire("bAB3U");

var $g6Qq4 = parcelRequire("g6Qq4");

var $jxkn6 = parcelRequire("jxkn6");

var $36uNV = parcelRequire("36uNV");

var $eRA48 = parcelRequire("eRA48");

var $kjMQA = parcelRequire("kjMQA");

var $kuD5k = parcelRequire("kuD5k");

var $kW8qW = parcelRequire("kW8qW");

var $bVRlF = parcelRequire("bVRlF");

var $1YYYR = parcelRequire("1YYYR");
const $0aa5398ebb1e0dfa$var$VanillaUnsupportedInlineCssClassName = {
    INNER: 'unsupported-inline-vanilla-inner',
    ICON: 'unsupported-vanilla-icon'
};
/** Identifies this tooltip for tests and debugging. */ const $0aa5398ebb1e0dfa$var$TOOLTIP_CLASS_NAME = 'unsupported-content-tooltip';
/** Distinct from the block node view's prefix, so the counter fallback below cannot collide. */ const $0aa5398ebb1e0dfa$var$TOOLTIP_ID_PREFIX = 'unsupported-inline-content-tooltip';
/** Classes applied to the tooltip element: the shared default look, plus our own hook. */ const $0aa5398ebb1e0dfa$var$TOOLTIP_CLASS_NAMES = `${(0, $kjMQA.VANILLA_TOOLTIP_DEFAULT_CLASS)} ${$0aa5398ebb1e0dfa$var$TOOLTIP_CLASS_NAME}`;
const $0aa5398ebb1e0dfa$var$INLINE_NODE_VIEW_CLASS_NAME = 'inlineNodeView';
const $0aa5398ebb1e0dfa$var$ZERO_WIDTH_SPACE_CONTAINER_CLASS_NAME = 'zeroWidthSpaceContainer';
const $0aa5398ebb1e0dfa$var$ADD_ZERO_WIDTH_SPACE_CLASS_NAME = `${$0aa5398ebb1e0dfa$var$INLINE_NODE_VIEW_CLASS_NAME}AddZeroWidthSpace`;
const $0aa5398ebb1e0dfa$var$nextTooltipId = (()=>{
    let count = 0;
    return ()=>typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function' ? `${$0aa5398ebb1e0dfa$var$TOOLTIP_ID_PREFIX}-${crypto.randomUUID()}` : `${$0aa5398ebb1e0dfa$var$TOOLTIP_ID_PREFIX}-${count += 1}`;
})();
function $0aa5398ebb1e0dfa$var$getInlineSpec(node, label) {
    const browser = (0, $jxkn6.getBrowserInfo)();
    const trailingSpec = browser.android ? [
        'span',
        {
            class: $0aa5398ebb1e0dfa$var$ZERO_WIDTH_SPACE_CONTAINER_CLASS_NAME,
            contentEditable: 'false'
        },
        [
            'span',
            {
                class: $0aa5398ebb1e0dfa$var$ADD_ZERO_WIDTH_SPACE_CLASS_NAME
            }
        ],
        (0, $kuD5k.ZERO_WIDTH_SPACE)
    ] : [
        'span',
        {
            class: $0aa5398ebb1e0dfa$var$ADD_ZERO_WIDTH_SPACE_CLASS_NAME
        }
    ];
    return [
        'span',
        {
            class: `${node.type.name}View-content-wrap ${$0aa5398ebb1e0dfa$var$INLINE_NODE_VIEW_CLASS_NAME}`,
            contentEditable: 'false'
        },
        [
            'span',
            {
                class: $0aa5398ebb1e0dfa$var$ZERO_WIDTH_SPACE_CONTAINER_CLASS_NAME
            },
            [
                'span',
                {
                    class: $0aa5398ebb1e0dfa$var$ADD_ZERO_WIDTH_SPACE_CLASS_NAME
                }
            ],
            (0, $kuD5k.ZERO_WIDTH_SPACE)
        ],
        [
            'span',
            {
                class: $0aa5398ebb1e0dfa$var$VanillaUnsupportedInlineCssClassName.INNER
            },
            label,
            (0, $1YYYR.getUnsupportedContentIconSpec)($0aa5398ebb1e0dfa$var$VanillaUnsupportedInlineCssClassName.ICON)
        ],
        trailingSpec
    ];
}
function $0aa5398ebb1e0dfa$var$createUnsupportedInlineDOM(node, intl) {
    const label = (0, $bVRlF.getUnsupportedContent)((0, $36uNV.unsupportedContentMessages).unsupportedInlineContent, 'Unsupported', node, intl);
    const { dom: dom } = (0, $kW8qW.DOMSerializer).renderSpec(document, $0aa5398ebb1e0dfa$var$getInlineSpec(node, label));
    const domElement = dom instanceof HTMLElement ? dom : undefined;
    const icon = (domElement === null || domElement === void 0 ? void 0 : domElement.querySelector(`.${$0aa5398ebb1e0dfa$var$VanillaUnsupportedInlineCssClassName.ICON}`)) ?? null;
    return {
        dom: dom,
        icon: icon
    };
}
class $0aa5398ebb1e0dfa$export$81269ac65e4cceef {
    constructor(node, intl, dispatchAnalyticsEvent){
        this.tooltip = null;
        this.unbindMouseenter = null;
        this.node = node;
        const { dom: dom, icon: icon } = $0aa5398ebb1e0dfa$var$createUnsupportedInlineDOM(node, intl);
        this.dom = dom;
        if (!icon) return;
        this.unbindMouseenter = (0, $bAB3U.bind)(icon, {
            type: 'mouseenter',
            options: {
                once: true
            },
            listener: (event)=>{
                var _this$unbindMouseente;
                (_this$unbindMouseente = this.unbindMouseenter) === null || _this$unbindMouseente === void 0 || _this$unbindMouseente.call(this);
                this.unbindMouseenter = null;
                const tooltipText = intl.formatMessage((0, $36uNV.unsupportedContentMessages).unsupportedContentTooltip);
                this.tooltip = new (0, $kjMQA.VanillaTooltip)(icon, tooltipText, $0aa5398ebb1e0dfa$var$nextTooltipId(), $0aa5398ebb1e0dfa$var$TOOLTIP_CLASS_NAMES, 300, // Use default style by having the default tooltip class name.
                undefined, ()=>{
                    if (dispatchAnalyticsEvent) {
                        var _this$node;
                        (0, $eRA48.trackUnsupportedContentTooltipDisplayedFor)(dispatchAnalyticsEvent, (0, $g6Qq4.ACTION_SUBJECT_ID).ON_UNSUPPORTED_INLINE, (_this$node = this.node) === null || _this$node === void 0 || (_this$node = _this$node.attrs) === null || _this$node === void 0 || (_this$node = _this$node.originalValue) === null || _this$node === void 0 ? void 0 : _this$node.type);
                    }
                });
                icon.dispatchEvent(new Event(event.type));
            }
        });
    }
    update(node) {
        if (node.type !== this.node.type) return false;
        if (!this.node.sameMarkup(node)) return false;
        this.node = node;
        return true;
    }
    ignoreMutation(mutation) {
        return mutation.type !== 'selection';
    }
    destroy() {
        var _this$tooltip, _this$unbindMouseente2;
        (_this$tooltip = this.tooltip) === null || _this$tooltip === void 0 || _this$tooltip.destroy();
        this.tooltip = null;
        (_this$unbindMouseente2 = this.unbindMouseenter) === null || _this$unbindMouseente2 === void 0 || _this$unbindMouseente2.call(this);
        this.unbindMouseenter = null;
    }
}

});


parcelRegister("2pS9T", function(module, exports) {
$parcel$export(module.exports, "userIntentPlugin", () => $9d51da800e6acc45$export$234188bd1f793aed);

var $i6h2b = parcelRequire("i6h2b");

var $9yKbX = parcelRequire("9yKbX");
const $9d51da800e6acc45$export$234188bd1f793aed = ()=>({
        name: 'userIntent',
        pmPlugins () {
            return [
                {
                    name: 'userIntentPlugin',
                    plugin: (0, $9yKbX.createPlugin)
                }
            ];
        },
        getSharedState: (editorState)=>{
            if (!editorState) return;
            const pluginState = (0, $9yKbX.userIntentPluginKey).getState(editorState);
            if (!pluginState) return;
            return {
                currentUserIntent: pluginState.currentUserIntent
            };
        },
        commands: {
            setCurrentUserIntent: $i6h2b.setCurrentUserIntent
        }
    });

});
parcelRegister("i6h2b", function(module, exports) {
$parcel$export(module.exports, "setCurrentUserIntent", () => $963ff7469e873593$export$4de3f86a2063c3b3);

var $9yKbX = parcelRequire("9yKbX");
const $963ff7469e873593$export$4de3f86a2063c3b3 = (currentUserIntent)=>({ tr: tr })=>{
        tr.setMeta((0, $9yKbX.userIntentPluginKey), {
            type: 'setCurrentUserIntent',
            data: {
                currentUserIntent: currentUserIntent
            }
        });
        return tr;
    };

});
parcelRegister("9yKbX", function(module, exports) {
$parcel$export(module.exports, "userIntentPluginKey", () => $ca0c7883f9bdf2d0$export$f43d3f526d9434e);
$parcel$export(module.exports, "createPlugin", () => $ca0c7883f9bdf2d0$export$ae829ec7b2625219);

var $f7Kk4 = parcelRequire("f7Kk4");

var $cw0wu = parcelRequire("cw0wu");
const $ca0c7883f9bdf2d0$export$f43d3f526d9434e = new (0, $cw0wu.PluginKey)('userIntentPlugin');
const $ca0c7883f9bdf2d0$var$initialState = {
    currentUserIntent: 'default'
};
const $ca0c7883f9bdf2d0$export$ae829ec7b2625219 = ()=>{
    return new (0, $f7Kk4.SafePlugin)({
        key: $ca0c7883f9bdf2d0$export$f43d3f526d9434e,
        state: {
            init () {
                return $ca0c7883f9bdf2d0$var$initialState;
            },
            apply: (tr, currentPluginState)=>{
                const meta = tr.getMeta($ca0c7883f9bdf2d0$export$f43d3f526d9434e);
                if (meta) {
                    // If the incoming currentUserIntent is the same as the existing one, return the existing state
                    if (meta.data.currentUserIntent === currentPluginState.currentUserIntent) return currentPluginState;
                    return {
                        currentUserIntent: meta.data.currentUserIntent
                    };
                }
                return currentPluginState;
            }
        }
    });
};

});



parcelRegister("kNoxo", function(module, exports) {
$parcel$export(module.exports, "widthPlugin", () => $2298997f9b2401d2$export$8cdf857cb01de6dc);

var $7DyuC = parcelRequire("7DyuC");

var $9Stsb = parcelRequire("9Stsb");

var $dMgIr = parcelRequire("dMgIr");
const $2298997f9b2401d2$export$8cdf857cb01de6dc = ()=>{
    return {
        name: 'width',
        pmPlugins: ()=>[
                {
                    name: 'width',
                    plugin: ({ dispatch: dispatch })=>(0, $7DyuC.createPlugin)(dispatch)
                }
            ],
        getSharedState: (editorState)=>{
            if (!editorState) return undefined;
            return (0, $9Stsb.pluginKey).getState(editorState);
        },
        // Dispatches between the legacy hook and its replacement while
        // `platform_editor_reduce_forced_layout` runs. On cleanup, point this at the surviving
        // hook and delete `useWidthObserver`.
        usePluginHook: (0, $dMgIr.useWidthObserver)
    };
};

});
parcelRegister("7DyuC", function(module, exports) {
$parcel$export(module.exports, "createPlugin", () => $e5882954799db22f$export$ae829ec7b2625219);

var $f7Kk4 = parcelRequire("f7Kk4");

var $3y2s4 = parcelRequire("3y2s4");

var $9Stsb = parcelRequire("9Stsb");
function $e5882954799db22f$export$ae829ec7b2625219(dispatch) {
    return new (0, $f7Kk4.SafePlugin)({
        key: (0, $9Stsb.pluginKey),
        state: {
            init: ()=>{
                return {
                    // The init value of width is a placeholder, it cannot be 0,
                    // we use `window.outerWidth` window dimension,
                    // Which will not cause reflow at the start.
                    width: (0, $3y2s4.isExperimentEnabled)('platform_editor_reduce_forced_layout') ? window.outerWidth : document.body.offsetWidth
                };
            },
            apply (tr, pluginState) {
                const meta = tr.getMeta((0, $9Stsb.pluginKey));
                if (!meta) return pluginState;
                const newPluginState = {
                    ...pluginState,
                    ...meta
                };
                if (newPluginState && (pluginState.width !== newPluginState.width || pluginState.lineLength !== newPluginState.lineLength)) {
                    dispatch((0, $9Stsb.pluginKey), newPluginState);
                    return newPluginState;
                }
                return pluginState;
            }
        }
    });
}

});
parcelRegister("9Stsb", function(module, exports) {
$parcel$export(module.exports, "pluginKey", () => $037fad17a2810a64$export$18d4026d1ea86bb1);

var $cw0wu = parcelRequire("cw0wu");
const $037fad17a2810a64$export$18d4026d1ea86bb1 = new (0, $cw0wu.PluginKey)('widthPlugin');

});


parcelRegister("dMgIr", function(module, exports) {
$parcel$export(module.exports, "useWidthObserver", () => $74e503ed83c5c99a$export$b78842cb7cd02769);

var $3y2s4 = parcelRequire("3y2s4");

var $c9IsT = parcelRequire("c9IsT");

var $kakPQ = parcelRequire("kakPQ");

var $C0wTD = parcelRequire("C0wTD");
const $74e503ed83c5c99a$export$b78842cb7cd02769 = (0, $c9IsT.conditionalHooksFactory)(()=>(0, $3y2s4.isExperimentEnabled)('platform_editor_reduce_forced_layout'), (0, $C0wTD.useResizeWidthObserverNext), (0, $kakPQ.useResizeWidthObserver));

});
parcelRegister("kakPQ", function(module, exports) {
$parcel$export(module.exports, "useResizeWidthObserver", () => $bc618f08b3e6b937$export$b0f894529c6bfe0a);

var $bSJIT = parcelRequire("bSJIT");

var $9Stsb = parcelRequire("9Stsb");

var $hac3j = parcelRequire("hac3j");
const $bc618f08b3e6b937$export$33d12d97a81b0d33 = (props)=>(editorView)=>{
        const { dispatch: dispatch, state: { tr: tr } } = editorView;
        tr.setMeta((0, $9Stsb.pluginKey), props);
        dispatch(tr);
    };
const $bc618f08b3e6b937$export$b0f894529c6bfe0a = ({ editorView: editorView, containerElement: containerElement })=>{
    (0, $hac3j.useRefreshWidthOnTransition)(containerElement);
    (0, $bSJIT.useEffect)(()=>{
        const newState = {
            lineLength: editorView.dom.clientWidth,
            width: containerElement === null || containerElement === void 0 ? void 0 : containerElement.offsetWidth
        };
        $bc618f08b3e6b937$export$33d12d97a81b0d33(newState)(editorView);
    }, [
        editorView,
        editorView.dom.clientWidth,
        containerElement
    ]);
    (0, $bSJIT.useEffect)(()=>{
        const resizeWidth = (entries)=>{
            if (entries.length !== 1) return;
            const [fullAreaSize] = entries;
            if (!fullAreaSize || !Array.isArray(fullAreaSize.borderBoxSize)) return;
            const width = fullAreaSize.borderBoxSize[0].inlineSize;
            const lineLength = editorView.dom.clientWidth;
            $bc618f08b3e6b937$export$33d12d97a81b0d33({
                width: width,
                lineLength: lineLength
            })(editorView);
        };
        const resizeObserver = new ResizeObserver(resizeWidth);
        if (containerElement) resizeObserver.observe(containerElement);
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        containerElement,
        editorView
    ]);
};

});
parcelRegister("hac3j", function(module, exports) {
$parcel$export(module.exports, "useRefreshWidthOnTransition", () => $3c5eee7aa86e4b1f$export$b72edfd730e58e7c);

var $bSJIT = parcelRequire("bSJIT");

var $bAB3U = parcelRequire("bAB3U");
// List of names for transition end events across browsers
const $3c5eee7aa86e4b1f$var$transitionEventNames = [
    'transitionend',
    'oTransitionEnd',
    'webkitTransitionEnd'
];
const $3c5eee7aa86e4b1f$export$b72edfd730e58e7c = (containerElement)=>{
    const [_, setLastWidthEvent] = (0, $bSJIT.useState)();
    (0, $bSJIT.useEffect)(()=>{
        if (!containerElement) return;
        /**
     * Update the plugin components once the transition
     * to full width / default mode completes
     */ const forceComponentUpdate = (event)=>{
            // Only trigger an update if the transition is on a property containing `width`
            // This will cater for media and the content area itself currently.
            if (event.propertyName.includes('width')) setLastWidthEvent(event);
        };
        return (0, $bAB3U.bindAll)(containerElement, $3c5eee7aa86e4b1f$var$transitionEventNames.map((name)=>({
                type: name,
                listener: forceComponentUpdate
            })));
    }, [
        containerElement
    ]);
};

});


parcelRegister("C0wTD", function(module, exports) {
$parcel$export(module.exports, "useResizeWidthObserverNext", () => $71436720708763dc$export$43eaf58a37b10358);

var $bSJIT = parcelRequire("bSJIT");

var $lGeMX = parcelRequire("lGeMX");

var $kPDZi = parcelRequire("kPDZi");
const $71436720708763dc$export$43eaf58a37b10358 = ({ editorView: editorView, containerElement: containerElement })=>{
    const widthTransitionCount = (0, $kPDZi.useRefreshWidthOnTransitionNext)(containerElement);
    const lastMeasuredTransition = (0, $bSJIT.useRef)(widthTransitionCount);
    (0, $bSJIT.useEffect)(()=>{
        // `apply` spreads meta over state, so dispatching an explicit `undefined` would overwrite
        // the existing width.
        if (!containerElement) return;
        // only update editor width state after change editor layout
        if (lastMeasuredTransition.current === widthTransitionCount) return;
        lastMeasuredTransition.current = widthTransitionCount;
        const newState = {
            lineLength: editorView.dom.clientWidth,
            width: containerElement.offsetWidth
        };
        (0, $lGeMX.setEditorWidth)(newState)(editorView);
    }, [
        editorView,
        widthTransitionCount,
        containerElement
    ]);
    (0, $bSJIT.useEffect)(()=>{
        if (!containerElement) return;
        const resizeWidth = (entries)=>{
            var _fullAreaSize$borderB;
            // A delivery can batch several entries for the observed target; the last is current.
            const fullAreaSize = entries[entries.length - 1];
            if (!fullAreaSize || !Array.isArray(fullAreaSize.borderBoxSize)) return;
            // `Array.isArray` passes for `[]`, which some polyfills produce. Bail rather than
            // dispatch `undefined`, which would overwrite the width via the spread in `apply`.
            const width = (_fullAreaSize$borderB = fullAreaSize.borderBoxSize[0]) === null || _fullAreaSize$borderB === void 0 ? void 0 : _fullAreaSize$borderB.inlineSize;
            if (width === undefined) return;
            const lineLength = editorView.dom.clientWidth;
            (0, $lGeMX.setEditorWidth)({
                width: width,
                lineLength: lineLength
            })(editorView);
        };
        const resizeObserver = new ResizeObserver(resizeWidth);
        resizeObserver.observe(containerElement);
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        containerElement,
        editorView
    ]);
};

});
parcelRegister("lGeMX", function(module, exports) {
$parcel$export(module.exports, "setEditorWidth", () => $9782fbfe1d97a2dd$export$33d12d97a81b0d33);

var $9Stsb = parcelRequire("9Stsb");
const $9782fbfe1d97a2dd$export$33d12d97a81b0d33 = (props)=>(editorView)=>{
        const { dispatch: dispatch, state: { tr: tr } } = editorView;
        tr.setMeta((0, $9Stsb.pluginKey), props);
        dispatch(tr);
    };

});

parcelRegister("kPDZi", function(module, exports) {
$parcel$export(module.exports, "useRefreshWidthOnTransitionNext", () => $e00182394432c16d$export$b496c8f3006752c7);

var $bSJIT = parcelRequire("bSJIT");

var $bAB3U = parcelRequire("bAB3U");
// List of names for transition end events across browsers, plus `transitioncancel`: an
// interrupted transition never fires `transitionend`, so where the interruption settles the
// element at its final width that width would otherwise be missed.
const $e00182394432c16d$var$transitionEventNames = [
    'transitionend',
    'oTransitionEnd',
    'webkitTransitionEnd',
    'transitioncancel'
];
const $e00182394432c16d$export$b496c8f3006752c7 = (containerElement)=>{
    const [widthTransitionCount, setWidthTransitionCount] = (0, $bSJIT.useState)(0);
    (0, $bSJIT.useEffect)(()=>{
        if (!containerElement) return;
        /**
     * Update the plugin components once the transition
     * to full width / default mode completes
     */ const forceComponentUpdate = (event)=>{
            // Only trigger an update if the transition is on a property containing `width`
            // This will cater for media and the content area itself currently.
            if (event.propertyName.includes('width')) setWidthTransitionCount((count)=>count + 1);
        };
        return (0, $bAB3U.bindAll)(containerElement, $e00182394432c16d$var$transitionEventNames.map((name)=>({
                type: name,
                listener: forceComponentUpdate
            })));
    }, [
        containerElement
    ]);
    return widthTransitionCount;
};

});





//# sourceMappingURL=shared.c294406d.js.map
